(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire58e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire58e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2vAqh", function(module, exports) {

$parcel$export(module.exports, "PositionData", () => PositionData);
$parcel$export(module.exports, "Popup", () => Popup);
$parcel$export(module.exports, "getZindexPartial", () => getZindexPartial);
$parcel$export(module.exports, "getScrollableParent", () => getScrollableParent);
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");

var $cWXlQ = parcelRequire("cWXlQ");

var $49u5W = parcelRequire("49u5W");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Specifies the offset position values.
 */ var PositionData = /** @class */ function(_super) {
    __extends(PositionData, _super);
    function PositionData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, $5rsSz.Property)("left")
    ], PositionData.prototype, "X", void 0);
    __decorate([
        (0, $5rsSz.Property)("top")
    ], PositionData.prototype, "Y", void 0);
    return PositionData;
}((0, $3fcxu.ChildProperty));
// don't use space in classNames
var CLASSNAMES = {
    ROOT: "e-popup",
    RTL: "e-rtl",
    OPEN: "e-popup-open",
    CLOSE: "e-popup-close"
};
/**
 * Represents the Popup Component
 * ```html
 * <div id="popup" style="position:absolute;height:100px;width:100px;">
 * <div style="margin:35px 25px;">Popup Content</div></div>
 * ```
 * ```typescript
 * <script>
 *   var popupObj = new Popup();
 *   popupObj.appendTo("#popup");
 * </script>
 * ```
 */ var Popup = /** @class */ function(_super) {
    __extends(Popup, _super);
    function Popup(element, options) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Called internally if any of the property value changed.
     *
     * @param {PopupModel} newProp - specifies the new property
     * @param {PopupModel} oldProp - specifies the old property
     * @private
     * @returns {void}
     */ Popup.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "width":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "width": (0, $3EnZW.formatUnit)(newProp.width)
                    });
                    break;
                case "height":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "height": (0, $3EnZW.formatUnit)(newProp.height)
                    });
                    break;
                case "zIndex":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "zIndex": newProp.zIndex
                    });
                    break;
                case "enableRtl":
                    this.setEnableRtl();
                    break;
                case "position":
                case "relateTo":
                    this.refreshPosition();
                    break;
                case "offsetX":
                    var x = newProp.offsetX - oldProp.offsetX;
                    this.element.style.left = (parseInt(this.element.style.left, 10) + x).toString() + "px";
                    break;
                case "offsetY":
                    var y = newProp.offsetY - oldProp.offsetY;
                    this.element.style.top = (parseInt(this.element.style.top, 10) + y).toString() + "px";
                    break;
                case "content":
                    this.setContent();
                    break;
                case "actionOnScroll":
                    if (newProp.actionOnScroll !== "none") this.wireScrollEvents();
                    else this.unwireScrollEvents();
                    break;
            }
        }
    };
    /**
     * gets the Component module name.
     *
     * @returns {void}
     * @private
     */ Popup.prototype.getModuleName = function() {
        return "popup";
    };
    /**
     * To resolve if any collision occurs.
     *
     * @returns {void}
     */ Popup.prototype.resolveCollision = function() {
        this.checkCollision();
    };
    /**
     * gets the persisted state properties of the Component.
     *
     * @returns {void}
     */ Popup.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * To destroy the control.
     *
     * @returns {void}
     */ Popup.prototype.destroy = function() {
        if (this.element.classList.contains("e-popup-open")) this.unwireEvents();
        this.element.classList.remove(CLASSNAMES.ROOT, CLASSNAMES.RTL, CLASSNAMES.OPEN, CLASSNAMES.CLOSE);
        this.content = null;
        this.relateTo = null;
        (0, $49u5W.destroy)();
        _super.prototype.destroy.call(this);
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Popup.prototype.render = function() {
        this.element.classList.add(CLASSNAMES.ROOT);
        var styles = {};
        if (this.zIndex !== 1000) styles.zIndex = this.zIndex;
        if (this.width !== "auto") styles.width = (0, $3EnZW.formatUnit)(this.width);
        if (this.height !== "auto") styles.height = (0, $3EnZW.formatUnit)(this.height);
        (0, $4ZDHT.setStyleAttribute)(this.element, styles);
        this.fixedParent = false;
        this.setEnableRtl();
        this.setContent();
    };
    Popup.prototype.wireEvents = function() {
        if ((0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).add(window, "orientationchange", this.orientationOnChange, this);
        if (this.actionOnScroll !== "none") this.wireScrollEvents();
    };
    Popup.prototype.wireScrollEvents = function() {
        if (this.getRelateToElement()) for(var _i = 0, _a = this.getScrollableParent(this.getRelateToElement()); _i < _a.length; _i++){
            var parent_1 = _a[_i];
            (0, $aqzbR.EventHandler).add(parent_1, "scroll", this.scrollRefresh, this);
        }
    };
    Popup.prototype.unwireEvents = function() {
        if ((0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).remove(window, "orientationchange", this.orientationOnChange);
        if (this.actionOnScroll !== "none") this.unwireScrollEvents();
    };
    Popup.prototype.unwireScrollEvents = function() {
        if (this.getRelateToElement()) for(var _i = 0, _a = this.getScrollableParent(this.getRelateToElement()); _i < _a.length; _i++){
            var parent_2 = _a[_i];
            (0, $aqzbR.EventHandler).remove(parent_2, "scroll", this.scrollRefresh);
        }
    };
    Popup.prototype.getRelateToElement = function() {
        var relateToElement = this.relateTo === "" || (0, $3EnZW.isNullOrUndefined)(this.relateTo) ? document.body : this.relateTo;
        this.setProperties({
            relateTo: relateToElement
        }, true);
        return typeof this.relateTo === "string" ? document.querySelector(this.relateTo) : this.relateTo;
    };
    Popup.prototype.scrollRefresh = function(e) {
        if (this.actionOnScroll === "reposition") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.element) && !(this.element.offsetParent === e.target || this.element.offsetParent && this.element.offsetParent.tagName === "BODY" && e.target.parentElement == null)) this.refreshPosition();
        } else if (this.actionOnScroll === "hide") this.hide();
        if (this.actionOnScroll !== "none") {
            if (this.getRelateToElement()) {
                var targetVisible = this.isElementOnViewport(this.getRelateToElement(), e.target);
                if (!targetVisible && !this.targetInvisibleStatus) {
                    this.trigger("targetExitViewport");
                    this.targetInvisibleStatus = true;
                } else if (targetVisible) this.targetInvisibleStatus = false;
            }
        }
    };
    /**
     * This method is to get the element visibility on viewport when scroll
     * the page. This method will returns true even though 1 px of element
     * part is in visible.
     *
     * @param {HTMLElement} relateToElement - specifies the element
     * @param {HTMLElement} scrollElement - specifies the scroll element
     * @returns {boolean} - retruns the boolean
     */ // eslint-disable-next-line
    Popup.prototype.isElementOnViewport = function(relateToElement, scrollElement) {
        var scrollParents = this.getScrollableParent(relateToElement);
        for(var parent_3 = 0; parent_3 < scrollParents.length; parent_3++){
            if (this.isElementVisible(relateToElement, scrollParents[parent_3])) continue;
            else return false;
        }
        return true;
    };
    Popup.prototype.isElementVisible = function(relateToElement, scrollElement) {
        var rect = this.checkGetBoundingClientRect(relateToElement);
        if (!rect.height || !rect.width) return false;
        if (!(0, $3EnZW.isNullOrUndefined)(this.checkGetBoundingClientRect(scrollElement))) {
            var parent_4 = scrollElement.getBoundingClientRect();
            return !(rect.bottom < parent_4.top) && !(rect.bottom > parent_4.bottom) && !(rect.right > parent_4.right) && !(rect.left < parent_4.left);
        } else {
            var win = window;
            var windowView = {
                top: win.scrollY,
                left: win.scrollX,
                right: win.scrollX + win.outerWidth,
                bottom: win.scrollY + win.outerHeight
            };
            var off = (0, $cWXlQ.calculatePosition)(relateToElement);
            var ele = {
                top: off.top,
                left: off.left,
                right: off.left + rect.width,
                bottom: off.top + rect.height
            };
            var elementView = {
                top: windowView.bottom - ele.top,
                left: windowView.right - ele.left,
                bottom: ele.bottom - windowView.top,
                right: ele.right - windowView.left
            };
            return elementView.top > 0 && elementView.left > 0 && elementView.right > 0 && elementView.bottom > 0;
        }
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */ Popup.prototype.preRender = function() {
    //There is no event handler
    };
    Popup.prototype.setEnableRtl = function() {
        this.reposition();
        if (this.enableRtl) this.element.classList.add(CLASSNAMES.RTL);
        else this.element.classList.remove(CLASSNAMES.RTL);
    };
    Popup.prototype.setContent = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.content)) {
            this.element.innerHTML = "";
            if (typeof this.content === "string") this.element.textContent = this.content;
            else {
                var relateToElem = this.getRelateToElement();
                // eslint-disable-next-line
                var props = this.content.props;
                if (!relateToElem.classList.contains("e-dropdown-btn") || (0, $3EnZW.isNullOrUndefined)(props)) this.element.appendChild(this.content);
            }
        }
    };
    Popup.prototype.orientationOnChange = function() {
        var _this = this;
        setTimeout(function() {
            _this.refreshPosition();
        }, 200);
    };
    /**
     * Based on the `relative` element and `offset` values, `Popup` element position will refreshed.
     *
     * @param {HTMLElement} target - The target element.
     * @param {boolean} collision - Specifies whether to check for collision.
     * @returns {void}
     */ Popup.prototype.refreshPosition = function(target, collision) {
        if (!(0, $3EnZW.isNullOrUndefined)(target)) this.checkFixedParent(target);
        this.reposition();
        if (!collision) this.checkCollision();
    };
    Popup.prototype.reposition = function() {
        var pos;
        var position;
        var relateToElement = this.getRelateToElement();
        if (typeof this.position.X === "number" && typeof this.position.Y === "number") pos = {
            left: this.position.X,
            top: this.position.Y
        };
        else if (typeof this.position.X === "string" && typeof this.position.Y === "number" || typeof this.position.X === "number" && typeof this.position.Y === "string") {
            var parentDisplay = void 0;
            var display = this.element.style.display;
            this.element.style.display = "block";
            if (this.element.classList.contains("e-dlg-modal")) {
                parentDisplay = this.element.parentElement.style.display;
                this.element.parentElement.style.display = "block";
            }
            position = this.getAnchorPosition(relateToElement, this.element, this.position, this.offsetX, this.offsetY);
            if (typeof this.position.X === "string") pos = {
                left: position.left,
                top: this.position.Y
            };
            else pos = {
                left: this.position.X,
                top: position.top
            };
            this.element.style.display = display;
            if (this.element.classList.contains("e-dlg-modal")) this.element.parentElement.style.display = parentDisplay;
        } else if (relateToElement) {
            var height = this.element.clientHeight;
            var display = this.element.style.display;
            this.element.style.display = "block";
            pos = this.getAnchorPosition(relateToElement, this.element, this.position, this.offsetX, this.offsetY, height);
            this.element.style.display = display;
        } else pos = {
            left: 0,
            top: 0
        };
        if (!(0, $3EnZW.isNullOrUndefined)(pos)) {
            this.element.style.left = pos.left + "px";
            this.element.style.top = pos.top + "px";
        }
    };
    Popup.prototype.checkGetBoundingClientRect = function(ele) {
        var eleRect;
        try {
            eleRect = ele.getBoundingClientRect();
            return eleRect;
        } catch (error) {
            return null;
        }
    };
    Popup.prototype.getAnchorPosition = function(anchorEle, ele, position, offsetX, offsetY, height) {
        if (height === void 0) height = 0;
        var eleRect = this.checkGetBoundingClientRect(ele);
        var anchorRect = this.checkGetBoundingClientRect(anchorEle);
        if ((0, $3EnZW.isNullOrUndefined)(eleRect) || (0, $3EnZW.isNullOrUndefined)(anchorRect)) return null;
        var anchor = anchorEle;
        var anchorPos = {
            left: 0,
            top: 0
        };
        if (ele.offsetParent && ele.offsetParent.tagName === "BODY" && anchorEle.tagName === "BODY") anchorPos = (0, $cWXlQ.calculatePosition)(anchorEle);
        else {
            if (ele.classList.contains("e-dlg-modal") && anchor.tagName !== "BODY") ele = ele.parentElement;
            anchorPos = (0, $cWXlQ.calculateRelativeBasedPosition)(anchor, ele);
        }
        switch(position.X){
            default:
            case "left":
                break;
            case "center":
                if (ele.classList.contains("e-dlg-modal") && anchor.tagName === "BODY" && this.targetType === "container") anchorPos.left += window.innerWidth / 2 - eleRect.width / 2;
                else if (this.targetType === "container") anchorPos.left += anchorRect.width / 2 - eleRect.width / 2;
                else anchorPos.left += anchorRect.width / 2;
                break;
            case "right":
                if (ele.classList.contains("e-dlg-modal") && anchor.tagName === "BODY" && this.targetType === "container") anchorPos.left += window.innerWidth - eleRect.width;
                else if (this.targetType === "container") {
                    var scaleX = 1;
                    var tranformElement = (0, $49u5W.getTransformElement)(ele);
                    if (tranformElement) {
                        var transformStyle = getComputedStyle(tranformElement).transform;
                        if (transformStyle !== "none") {
                            var matrix = new DOMMatrix(transformStyle);
                            scaleX = matrix.a;
                        }
                    }
                    anchorPos.left += (anchorRect.width - eleRect.width) / scaleX;
                } else anchorPos.left += anchorRect.width;
                break;
        }
        switch(position.Y){
            default:
            case "top":
                break;
            case "center":
                if (ele.classList.contains("e-dlg-modal") && anchor.tagName === "BODY" && this.targetType === "container") anchorPos.top += window.innerHeight / 2 - eleRect.height / 2;
                else if (this.targetType === "container") anchorPos.top += anchorRect.height / 2 - eleRect.height / 2;
                else anchorPos.top += anchorRect.height / 2;
                break;
            case "bottom":
                if (ele.classList.contains("e-dlg-modal") && anchor.tagName === "BODY" && this.targetType === "container") anchorPos.top += window.innerHeight - eleRect.height;
                else if (this.targetType === "container" && !ele.classList.contains("e-dialog")) anchorPos.top += anchorRect.height - eleRect.height;
                else if (this.targetType === "container" && ele.classList.contains("e-dialog")) anchorPos.top += anchorRect.height - height;
                else anchorPos.top += anchorRect.height;
                break;
        }
        anchorPos.left += offsetX;
        anchorPos.top += offsetY;
        return anchorPos;
    };
    Popup.prototype.callFlip = function(param) {
        var relateToElement = this.getRelateToElement();
        (0, $49u5W.flip)(this.element, relateToElement, this.offsetX, this.offsetY, this.position.X, this.position.Y, this.viewPortElement, param, this.fixedParent);
    };
    Popup.prototype.callFit = function(param) {
        if ((0, $49u5W.isCollide)(this.element, this.viewPortElement).length !== 0) {
            if ((0, $3EnZW.isNullOrUndefined)(this.viewPortElement)) {
                var data = (0, $49u5W.fit)(this.element, this.viewPortElement, param);
                if (param.X) this.element.style.left = data.left + "px";
                if (param.Y) this.element.style.top = data.top + "px";
            } else {
                var elementRect = this.checkGetBoundingClientRect(this.element);
                var viewPortRect = this.checkGetBoundingClientRect(this.viewPortElement);
                if ((0, $3EnZW.isNullOrUndefined)(elementRect) || (0, $3EnZW.isNullOrUndefined)(viewPortRect)) return null;
                if (param && param.Y === true) {
                    if (viewPortRect.top > elementRect.top) this.element.style.top = "0px";
                    else if (viewPortRect.bottom < elementRect.bottom) this.element.style.top = parseInt(this.element.style.top, 10) - (elementRect.bottom - viewPortRect.bottom) + "px";
                }
                if (param && param.X === true) {
                    if (viewPortRect.right < elementRect.right) this.element.style.left = parseInt(this.element.style.left, 10) - (elementRect.right - viewPortRect.right) + "px";
                    else if (viewPortRect.left > elementRect.left) this.element.style.left = parseInt(this.element.style.left, 10) + (viewPortRect.left - elementRect.left) + "px";
                }
            }
        }
    };
    Popup.prototype.checkCollision = function() {
        var horz = this.collision.X;
        var vert = this.collision.Y;
        if (horz === "none" && vert === "none") return;
        if (horz === "flip" && vert === "flip") this.callFlip({
            X: true,
            Y: true
        });
        else if (horz === "fit" && vert === "fit") this.callFit({
            X: true,
            Y: true
        });
        else {
            if (horz === "flip") this.callFlip({
                X: true,
                Y: false
            });
            else if (vert === "flip") this.callFlip({
                Y: true,
                X: false
            });
            if (horz === "fit") this.callFit({
                X: true,
                Y: false
            });
            else if (vert === "fit") this.callFit({
                X: false,
                Y: true
            });
        }
    };
    /**
     * Shows the popup element from screen.
     *
     * @returns {void}
     * @param {AnimationModel} animationOptions - specifies the model
     * @param { HTMLElement } relativeElement - To calculate the zIndex value dynamically.
     */ Popup.prototype.show = function(animationOptions, relativeElement) {
        var _this = this;
        var relateToElement = this.getRelateToElement();
        if (relateToElement.classList.contains("e-filemanager")) this.fmDialogContainer = this.element.getElementsByClassName("e-file-select-wrap")[0];
        this.wireEvents();
        if (!(0, $3EnZW.isNullOrUndefined)(this.fmDialogContainer) && (0, $5q7BP.Browser).isIos) this.fmDialogContainer.style.display = "block";
        if (this.zIndex === 1000 || !(0, $3EnZW.isNullOrUndefined)(relativeElement)) {
            var zIndexElement = (0, $3EnZW.isNullOrUndefined)(relativeElement) ? this.element : relativeElement;
            this.zIndex = getZindexPartial(zIndexElement);
            (0, $4ZDHT.setStyleAttribute)(this.element, {
                "zIndex": this.zIndex
            });
        }
        animationOptions = !(0, $3EnZW.isNullOrUndefined)(animationOptions) && typeof animationOptions === "object" ? animationOptions : this.showAnimation;
        if (this.collision.X !== "none" || this.collision.Y !== "none") {
            (0, $4ZDHT.removeClass)([
                this.element
            ], CLASSNAMES.CLOSE);
            (0, $4ZDHT.addClass)([
                this.element
            ], CLASSNAMES.OPEN);
            this.checkCollision();
            (0, $4ZDHT.removeClass)([
                this.element
            ], CLASSNAMES.OPEN);
            (0, $4ZDHT.addClass)([
                this.element
            ], CLASSNAMES.CLOSE);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(animationOptions)) {
            animationOptions.begin = function() {
                if (!_this.isDestroyed) {
                    (0, $4ZDHT.removeClass)([
                        _this.element
                    ], CLASSNAMES.CLOSE);
                    (0, $4ZDHT.addClass)([
                        _this.element
                    ], CLASSNAMES.OPEN);
                }
            };
            animationOptions.end = function() {
                if (!_this.isDestroyed) _this.trigger("open");
            };
            new (0, $kj1BR.Animation)(animationOptions).animate(this.element);
        } else {
            (0, $4ZDHT.removeClass)([
                this.element
            ], CLASSNAMES.CLOSE);
            (0, $4ZDHT.addClass)([
                this.element
            ], CLASSNAMES.OPEN);
            this.trigger("open");
        }
    };
    /**
     * Hides the popup element from screen.
     *
     * @param {AnimationModel} animationOptions - To give the animation options.
     * @returns {void}
     */ Popup.prototype.hide = function(animationOptions) {
        var _this = this;
        animationOptions = !(0, $3EnZW.isNullOrUndefined)(animationOptions) && typeof animationOptions === "object" ? animationOptions : this.hideAnimation;
        if (!(0, $3EnZW.isNullOrUndefined)(animationOptions)) {
            animationOptions.end = function() {
                if (!_this.isDestroyed) {
                    (0, $4ZDHT.removeClass)([
                        _this.element
                    ], CLASSNAMES.OPEN);
                    (0, $4ZDHT.addClass)([
                        _this.element
                    ], CLASSNAMES.CLOSE);
                    _this.trigger("close");
                }
            };
            new (0, $kj1BR.Animation)(animationOptions).animate(this.element);
        } else {
            (0, $4ZDHT.removeClass)([
                this.element
            ], CLASSNAMES.OPEN);
            (0, $4ZDHT.addClass)([
                this.element
            ], CLASSNAMES.CLOSE);
            this.trigger("close");
        }
        this.unwireEvents();
    };
    /**
     * Gets scrollable parent elements for the given element.
     *
     * @returns {void}
     * @param { HTMLElement } element - Specify the element to get the scrollable parents of it.
     */ Popup.prototype.getScrollableParent = function(element) {
        this.checkFixedParent(element);
        return getScrollableParent(element, this.fixedParent);
    };
    Popup.prototype.checkFixedParent = function(element) {
        var parent = element.parentElement;
        while(parent && parent.tagName !== "HTML"){
            var parentStyle = getComputedStyle(parent);
            if ((parentStyle.position === "fixed" || parentStyle.position === "sticky") && !(0, $3EnZW.isNullOrUndefined)(this.element) && this.element.offsetParent && this.element.offsetParent.tagName === "BODY" && getComputedStyle(this.element.offsetParent).overflow !== "hidden") {
                this.element.style.top = window.scrollY > parseInt(this.element.style.top, 10) ? (0, $3EnZW.formatUnit)(window.scrollY - parseInt(this.element.style.top, 10)) : (0, $3EnZW.formatUnit)(parseInt(this.element.style.top, 10) - window.scrollY);
                this.element.style.position = "fixed";
                this.fixedParent = true;
            }
            parent = parent.parentElement;
            if (!(0, $3EnZW.isNullOrUndefined)(this.element) && (0, $3EnZW.isNullOrUndefined)(this.element.offsetParent) && parentStyle.position === "fixed" && this.element.style.position === "fixed") this.fixedParent = true;
        }
    };
    __decorate([
        (0, $5rsSz.Property)("auto")
    ], Popup.prototype, "height", void 0);
    __decorate([
        (0, $5rsSz.Property)("auto")
    ], Popup.prototype, "width", void 0);
    __decorate([
        (0, $5rsSz.Property)(null)
    ], Popup.prototype, "content", void 0);
    __decorate([
        (0, $5rsSz.Property)("container")
    ], Popup.prototype, "targetType", void 0);
    __decorate([
        (0, $5rsSz.Property)(null)
    ], Popup.prototype, "viewPortElement", void 0);
    __decorate([
        (0, $5rsSz.Property)({
            X: "none",
            Y: "none"
        })
    ], Popup.prototype, "collision", void 0);
    __decorate([
        (0, $5rsSz.Property)("")
    ], Popup.prototype, "relateTo", void 0);
    __decorate([
        (0, $5rsSz.Complex)({}, PositionData)
    ], Popup.prototype, "position", void 0);
    __decorate([
        (0, $5rsSz.Property)(0)
    ], Popup.prototype, "offsetX", void 0);
    __decorate([
        (0, $5rsSz.Property)(0)
    ], Popup.prototype, "offsetY", void 0);
    __decorate([
        (0, $5rsSz.Property)(1000)
    ], Popup.prototype, "zIndex", void 0);
    __decorate([
        (0, $5rsSz.Property)(false)
    ], Popup.prototype, "enableRtl", void 0);
    __decorate([
        (0, $5rsSz.Property)("reposition")
    ], Popup.prototype, "actionOnScroll", void 0);
    __decorate([
        (0, $5rsSz.Property)(null)
    ], Popup.prototype, "showAnimation", void 0);
    __decorate([
        (0, $5rsSz.Property)(null)
    ], Popup.prototype, "hideAnimation", void 0);
    __decorate([
        (0, $5rsSz.Event)()
    ], Popup.prototype, "open", void 0);
    __decorate([
        (0, $5rsSz.Event)()
    ], Popup.prototype, "close", void 0);
    __decorate([
        (0, $5rsSz.Event)()
    ], Popup.prototype, "targetExitViewport", void 0);
    Popup = __decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Popup);
    return Popup;
}((0, $hQxLN.Component));
function getScrollableParent(element, fixedParent) {
    var eleStyle = getComputedStyle(element);
    var scrollParents = [];
    var overflowRegex = /(auto|scroll)/;
    var parent = element.parentElement;
    while(parent && parent.tagName !== "HTML"){
        var parentStyle = getComputedStyle(parent);
        if (!(eleStyle.position === "absolute" && parentStyle.position === "static") && overflowRegex.test(parentStyle.overflow + parentStyle.overflowY + parentStyle.overflowX)) scrollParents.push(parent);
        parent = parent.parentElement;
    }
    if (!fixedParent) scrollParents.push(document);
    return scrollParents;
}
function getZindexPartial(element) {
    // upto body traversal
    var parent = element.parentElement;
    var parentZindex = [];
    while(parent){
        if (parent.tagName !== "BODY") {
            var index = document.defaultView.getComputedStyle(parent, null).getPropertyValue("z-index");
            var position = document.defaultView.getComputedStyle(parent, null).getPropertyValue("position");
            if (index !== "auto" && position !== "static") parentZindex.push(index);
            parent = parent.parentElement;
        } else break;
    }
    var childrenZindex = [];
    for(var i = 0; i < document.body.children.length; i++)if (!element.isEqualNode(document.body.children[i])) {
        var index = document.defaultView.getComputedStyle(document.body.children[i], null).getPropertyValue("z-index");
        var position = document.defaultView.getComputedStyle(document.body.children[i], null).getPropertyValue("position");
        if (index !== "auto" && position !== "static") childrenZindex.push(index);
    }
    childrenZindex.push("999");
    var siblingsZindex = [];
    if (!(0, $3EnZW.isNullOrUndefined)(element.parentElement) && element.parentElement.tagName !== "BODY") {
        var childNodes = [].slice.call(element.parentElement.children);
        for(var i = 0; i < childNodes.length; i++)if (!element.isEqualNode(childNodes[i])) {
            var index = document.defaultView.getComputedStyle(childNodes[i], null).getPropertyValue("z-index");
            var position = document.defaultView.getComputedStyle(childNodes[i], null).getPropertyValue("position");
            if (index !== "auto" && position !== "static") siblingsZindex.push(index);
        }
    }
    var finalValue = parentZindex.concat(childrenZindex, siblingsZindex);
    // eslint-disable-next-line
    var currentZindexValue = Math.max.apply(Math, finalValue) + 1;
    return currentZindexValue > 2147483647 ? 2147483647 : currentZindexValue;
}
function getMaxZindex(tagName) {
    if (tagName === void 0) tagName = [
        "*"
    ];
    var maxZindex = [];
    for(var i = 0; i < tagName.length; i++){
        var elements = document.getElementsByTagName(tagName[i]);
        for(var i_1 = 0; i_1 < elements.length; i_1++){
            var index = document.defaultView.getComputedStyle(elements[i_1], null).getPropertyValue("z-index");
            var position = document.defaultView.getComputedStyle(elements[i_1], null).getPropertyValue("position");
            if (index !== "auto" && position !== "static") maxZindex.push(index);
        }
    }
    // eslint-disable-next-line
    var currentZindexValue = Math.max.apply(Math, maxZindex) + 1;
    return currentZindexValue > 2147483647 ? 2147483647 : currentZindexValue;
}

});
parcelRegister("j7YE8", function(module, exports) {
$parcel$export(module.exports, "addClass", () => (parcelRequire("4ZDHT")).addClass);
$parcel$export(module.exports, "Ajax", () => (parcelRequire("cfGuF")).Ajax);
$parcel$export(module.exports, "Animation", () => (parcelRequire("kj1BR")).Animation);
$parcel$export(module.exports, "animationMode", () => (parcelRequire("kj1BR")).animationMode);
$parcel$export(module.exports, "append", () => (parcelRequire("4ZDHT")).append);
$parcel$export(module.exports, "attributes", () => (parcelRequire("4ZDHT")).attributes);
$parcel$export(module.exports, "Base", () => (parcelRequire("jmffE")).Base);
$parcel$export(module.exports, "blazorTemplates", () => (parcelRequire("c2qqN")).blazorTemplates);
$parcel$export(module.exports, "Browser", () => (parcelRequire("5q7BP")).Browser);
$parcel$export(module.exports, "ChildProperty", () => (parcelRequire("3fcxu")).ChildProperty);
$parcel$export(module.exports, "classList", () => (parcelRequire("4ZDHT")).classList);
$parcel$export(module.exports, "cldrData", () => (parcelRequire("bWDaN")).cldrData);
$parcel$export(module.exports, "closest", () => (parcelRequire("4ZDHT")).closest);
$parcel$export(module.exports, "Collection", () => (parcelRequire("5rsSz")).Collection);
$parcel$export(module.exports, "compile", () => (parcelRequire("c2qqN")).compile);
$parcel$export(module.exports, "Complex", () => (parcelRequire("5rsSz")).Complex);
$parcel$export(module.exports, "Component", () => (parcelRequire("hQxLN")).Component);
$parcel$export(module.exports, "createElement", () => (parcelRequire("4ZDHT")).createElement);
$parcel$export(module.exports, "debounce", () => (parcelRequire("3EnZW")).debounce);
$parcel$export(module.exports, "defaultCurrencyCode", () => (parcelRequire("bWDaN")).defaultCurrencyCode);
$parcel$export(module.exports, "deleteObject", () => (parcelRequire("3EnZW")).deleteObject);
$parcel$export(module.exports, "detach", () => (parcelRequire("4ZDHT")).detach);
$parcel$export(module.exports, "Draggable", () => (parcelRequire("eAUyT")).Draggable);
$parcel$export(module.exports, "Droppable", () => (parcelRequire("g9Ic7")).Droppable);
$parcel$export(module.exports, "Event", () => (parcelRequire("5rsSz")).Event);
$parcel$export(module.exports, "EventHandler", () => (parcelRequire("aqzbR")).EventHandler);
$parcel$export(module.exports, "extend", () => (parcelRequire("3EnZW")).extend);
$parcel$export(module.exports, "Fetch", () => (parcelRequire("1MTdI")).Fetch);
$parcel$export(module.exports, "formatUnit", () => (parcelRequire("3EnZW")).formatUnit);
$parcel$export(module.exports, "getComponent", () => (parcelRequire("jmffE")).getComponent);
$parcel$export(module.exports, "getDefaultDateObject", () => (parcelRequire("bWDaN")).getDefaultDateObject);
$parcel$export(module.exports, "getElement", () => (parcelRequire("3EnZW")).getElement);
$parcel$export(module.exports, "getEnumValue", () => (parcelRequire("3EnZW")).getEnumValue);
$parcel$export(module.exports, "getInstance", () => (parcelRequire("3EnZW")).getInstance);
$parcel$export(module.exports, "getNumericObject", () => (parcelRequire("bWDaN")).getNumericObject);
$parcel$export(module.exports, "getUniqueID", () => (parcelRequire("3EnZW")).getUniqueID);
$parcel$export(module.exports, "getValue", () => (parcelRequire("3EnZW")).getValue);
$parcel$export(module.exports, "initializeCSPTemplate", () => (parcelRequire("c2qqN")).initializeCSPTemplate);
$parcel$export(module.exports, "Internationalization", () => (parcelRequire("bWDaN")).Internationalization);
$parcel$export(module.exports, "isBlazor", () => (parcelRequire("3EnZW")).isBlazor);
$parcel$export(module.exports, "isNullOrUndefined", () => (parcelRequire("3EnZW")).isNullOrUndefined);
$parcel$export(module.exports, "isObject", () => (parcelRequire("3EnZW")).isObject);
$parcel$export(module.exports, "isRippleEnabled", () => (parcelRequire("kj1BR")).isRippleEnabled);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("3EnZW")).isUndefined);
$parcel$export(module.exports, "isVisible", () => (parcelRequire("4ZDHT")).isVisible);
$parcel$export(module.exports, "KeyboardEvents", () => (parcelRequire("dyv7X")).KeyboardEvents);
$parcel$export(module.exports, "L10n", () => (parcelRequire("e7i2H")).L10n);
$parcel$export(module.exports, "loadCldr", () => (parcelRequire("bWDaN")).loadCldr);
$parcel$export(module.exports, "matches", () => (parcelRequire("4ZDHT")).matches);
$parcel$export(module.exports, "merge", () => (parcelRequire("3EnZW")).merge);
$parcel$export(module.exports, "NotifyPropertyChanges", () => (parcelRequire("5rsSz")).NotifyPropertyChanges);
$parcel$export(module.exports, "Observer", () => (parcelRequire("13zI2")).Observer);
$parcel$export(module.exports, "onIntlChange", () => (parcelRequire("bWDaN")).onIntlChange);
$parcel$export(module.exports, "prepend", () => (parcelRequire("4ZDHT")).prepend);
$parcel$export(module.exports, "print", () => (parcelRequire("3EnZW")).print);
$parcel$export(module.exports, "Property", () => (parcelRequire("5rsSz")).Property);
$parcel$export(module.exports, "remove", () => (parcelRequire("4ZDHT")).remove);
$parcel$export(module.exports, "removeClass", () => (parcelRequire("4ZDHT")).removeClass);
$parcel$export(module.exports, "resetBlazorTemplate", () => (parcelRequire("c2qqN")).resetBlazorTemplate);
$parcel$export(module.exports, "rippleEffect", () => (parcelRequire("kj1BR")).rippleEffect);
$parcel$export(module.exports, "SanitizeHtmlHelper", () => (parcelRequire("3P3ke")).SanitizeHtmlHelper);
$parcel$export(module.exports, "select", () => (parcelRequire("4ZDHT")).select);
$parcel$export(module.exports, "selectAll", () => (parcelRequire("4ZDHT")).selectAll);
$parcel$export(module.exports, "setCulture", () => (parcelRequire("bWDaN")).setCulture);
$parcel$export(module.exports, "setStyleAttribute", () => (parcelRequire("4ZDHT")).setStyleAttribute);
$parcel$export(module.exports, "setValue", () => (parcelRequire("3EnZW")).setValue);
$parcel$export(module.exports, "throwError", () => (parcelRequire("3EnZW")).throwError);
$parcel$export(module.exports, "Touch", () => (parcelRequire("i528u")).Touch);
$parcel$export(module.exports, "updateBlazorTemplate", () => (parcelRequire("c2qqN")).updateBlazorTemplate);
/**
 * index
 */ parcelRequire("7qzC2");

});
parcelRegister("7qzC2", function(module, exports) {
$parcel$export(module.exports, "Ajax", () => (parcelRequire("cfGuF")).Ajax);
$parcel$export(module.exports, "Fetch", () => (parcelRequire("1MTdI")).Fetch);
$parcel$export(module.exports, "Animation", () => (parcelRequire("kj1BR")).Animation);
$parcel$export(module.exports, "animationMode", () => (parcelRequire("kj1BR")).animationMode);
$parcel$export(module.exports, "isRippleEnabled", () => (parcelRequire("kj1BR")).isRippleEnabled);
$parcel$export(module.exports, "rippleEffect", () => (parcelRequire("kj1BR")).rippleEffect);
$parcel$export(module.exports, "Base", () => (parcelRequire("jmffE")).Base);
$parcel$export(module.exports, "getComponent", () => (parcelRequire("jmffE")).getComponent);
$parcel$export(module.exports, "Browser", () => (parcelRequire("5q7BP")).Browser);
$parcel$export(module.exports, "Component", () => (parcelRequire("hQxLN")).Component);
$parcel$export(module.exports, "ChildProperty", () => (parcelRequire("3fcxu")).ChildProperty);
$parcel$export(module.exports, "Draggable", () => (parcelRequire("eAUyT")).Draggable);
$parcel$export(module.exports, "Droppable", () => (parcelRequire("g9Ic7")).Droppable);
$parcel$export(module.exports, "EventHandler", () => (parcelRequire("aqzbR")).EventHandler);
$parcel$export(module.exports, "cldrData", () => (parcelRequire("bWDaN")).cldrData);
$parcel$export(module.exports, "defaultCurrencyCode", () => (parcelRequire("bWDaN")).defaultCurrencyCode);
$parcel$export(module.exports, "getDefaultDateObject", () => (parcelRequire("bWDaN")).getDefaultDateObject);
$parcel$export(module.exports, "getNumericObject", () => (parcelRequire("bWDaN")).getNumericObject);
$parcel$export(module.exports, "Internationalization", () => (parcelRequire("bWDaN")).Internationalization);
$parcel$export(module.exports, "loadCldr", () => (parcelRequire("bWDaN")).loadCldr);
$parcel$export(module.exports, "onIntlChange", () => (parcelRequire("bWDaN")).onIntlChange);
$parcel$export(module.exports, "setCulture", () => (parcelRequire("bWDaN")).setCulture);
$parcel$export(module.exports, "KeyboardEvents", () => (parcelRequire("dyv7X")).KeyboardEvents);
$parcel$export(module.exports, "L10n", () => (parcelRequire("e7i2H")).L10n);
$parcel$export(module.exports, "Collection", () => (parcelRequire("5rsSz")).Collection);
$parcel$export(module.exports, "Complex", () => (parcelRequire("5rsSz")).Complex);
$parcel$export(module.exports, "Event", () => (parcelRequire("5rsSz")).Event);
$parcel$export(module.exports, "NotifyPropertyChanges", () => (parcelRequire("5rsSz")).NotifyPropertyChanges);
$parcel$export(module.exports, "Property", () => (parcelRequire("5rsSz")).Property);
$parcel$export(module.exports, "Touch", () => (parcelRequire("i528u")).Touch);
$parcel$export(module.exports, "blazorTemplates", () => (parcelRequire("c2qqN")).blazorTemplates);
$parcel$export(module.exports, "compile", () => (parcelRequire("c2qqN")).compile);
$parcel$export(module.exports, "initializeCSPTemplate", () => (parcelRequire("c2qqN")).initializeCSPTemplate);
$parcel$export(module.exports, "resetBlazorTemplate", () => (parcelRequire("c2qqN")).resetBlazorTemplate);
$parcel$export(module.exports, "updateBlazorTemplate", () => (parcelRequire("c2qqN")).updateBlazorTemplate);
$parcel$export(module.exports, "debounce", () => (parcelRequire("3EnZW")).debounce);
$parcel$export(module.exports, "deleteObject", () => (parcelRequire("3EnZW")).deleteObject);
$parcel$export(module.exports, "extend", () => (parcelRequire("3EnZW")).extend);
$parcel$export(module.exports, "formatUnit", () => (parcelRequire("3EnZW")).formatUnit);
$parcel$export(module.exports, "getElement", () => (parcelRequire("3EnZW")).getElement);
$parcel$export(module.exports, "getEnumValue", () => (parcelRequire("3EnZW")).getEnumValue);
$parcel$export(module.exports, "getInstance", () => (parcelRequire("3EnZW")).getInstance);
$parcel$export(module.exports, "getUniqueID", () => (parcelRequire("3EnZW")).getUniqueID);
$parcel$export(module.exports, "getValue", () => (parcelRequire("3EnZW")).getValue);
$parcel$export(module.exports, "isBlazor", () => (parcelRequire("3EnZW")).isBlazor);
$parcel$export(module.exports, "isNullOrUndefined", () => (parcelRequire("3EnZW")).isNullOrUndefined);
$parcel$export(module.exports, "isObject", () => (parcelRequire("3EnZW")).isObject);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("3EnZW")).isUndefined);
$parcel$export(module.exports, "merge", () => (parcelRequire("3EnZW")).merge);
$parcel$export(module.exports, "print", () => (parcelRequire("3EnZW")).print);
$parcel$export(module.exports, "setValue", () => (parcelRequire("3EnZW")).setValue);
$parcel$export(module.exports, "throwError", () => (parcelRequire("3EnZW")).throwError);
$parcel$export(module.exports, "addClass", () => (parcelRequire("4ZDHT")).addClass);
$parcel$export(module.exports, "append", () => (parcelRequire("4ZDHT")).append);
$parcel$export(module.exports, "attributes", () => (parcelRequire("4ZDHT")).attributes);
$parcel$export(module.exports, "classList", () => (parcelRequire("4ZDHT")).classList);
$parcel$export(module.exports, "closest", () => (parcelRequire("4ZDHT")).closest);
$parcel$export(module.exports, "createElement", () => (parcelRequire("4ZDHT")).createElement);
$parcel$export(module.exports, "detach", () => (parcelRequire("4ZDHT")).detach);
$parcel$export(module.exports, "isVisible", () => (parcelRequire("4ZDHT")).isVisible);
$parcel$export(module.exports, "matches", () => (parcelRequire("4ZDHT")).matches);
$parcel$export(module.exports, "prepend", () => (parcelRequire("4ZDHT")).prepend);
$parcel$export(module.exports, "remove", () => (parcelRequire("4ZDHT")).remove);
$parcel$export(module.exports, "removeClass", () => (parcelRequire("4ZDHT")).removeClass);
$parcel$export(module.exports, "select", () => (parcelRequire("4ZDHT")).select);
$parcel$export(module.exports, "selectAll", () => (parcelRequire("4ZDHT")).selectAll);
$parcel$export(module.exports, "setStyleAttribute", () => (parcelRequire("4ZDHT")).setStyleAttribute);
$parcel$export(module.exports, "Observer", () => (parcelRequire("13zI2")).Observer);
$parcel$export(module.exports, "SanitizeHtmlHelper", () => (parcelRequire("3P3ke")).SanitizeHtmlHelper);
/**
 * Base modules
 */ parcelRequire("fW217");
parcelRequire("cfGuF");
parcelRequire("1MTdI");
parcelRequire("kj1BR");
parcelRequire("jmffE");
parcelRequire("5q7BP");
parcelRequire("hQxLN");
parcelRequire("3fcxu");
parcelRequire("eAUyT");
parcelRequire("g9Ic7");
parcelRequire("aqzbR");
parcelRequire("bWDaN");
parcelRequire("dyv7X");
parcelRequire("e7i2H");
parcelRequire("6gool");
parcelRequire("5rsSz");
parcelRequire("i528u");
parcelRequire("33VE1");
parcelRequire("c2qqN");
parcelRequire("3EnZW");
parcelRequire("4ZDHT");
parcelRequire("13zI2");
parcelRequire("3P3ke");
parcelRequire("18li4");

});
parcelRegister("fW217", function(module, exports) {

$parcel$export(module.exports, "IntlBase", () => $b99dd653eda5c2fa$export$2e942c975b8046e9);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */ 
var $bWDaN = parcelRequire("bWDaN");

var $3EnZW = parcelRequire("3EnZW");

var $3amEA = parcelRequire("3amEA");

var $c2qRe = parcelRequire("c2qRe");

var $aJNO3 = parcelRequire("aJNO3");
var $b99dd653eda5c2fa$var$regExp = RegExp;
var $b99dd653eda5c2fa$export$b70e0d9183d08bef = {
    "en-US": {
        "d": "M/d/y",
        "D": "EEEE, MMMM d, y",
        "f": "EEEE, MMMM d, y h:mm a",
        "F": "EEEE, MMMM d, y h:mm:s a",
        "g": "M/d/y h:mm a",
        "G": "M/d/yyyy h:mm:ss tt",
        "m": "MMMM d",
        "M": "MMMM d",
        "r": "ddd, dd MMM yyyy HH':'mm':'ss 'GMT'",
        "R": "ddd, dd MMM yyyy HH':'mm':'ss 'GMT'",
        "s": "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        "t": "h:mm tt",
        "T": "h:m:s tt",
        "u": "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
        "U": "dddd, MMMM d, yyyy h:mm:ss tt",
        "y": "MMMM yyyy",
        "Y": "MMMM yyyy"
    }
};
var $b99dd653eda5c2fa$export$2e942c975b8046e9;
(function(IntlBase) {
    // eslint-disable-next-line security/detect-unsafe-regex
    IntlBase.negativeDataRegex = /^(('[^']+'|''|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/;
    // eslint-disable-next-line security/detect-unsafe-regex
    IntlBase.customRegex = /^(('[^']+'|''|[^*#@0,.])*)(\*.)?((([0#,]*[0,]*[0#]*[0# ]*)(\.[0#]*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/;
    IntlBase.latnParseRegex = /0|1|2|3|4|5|6|7|8|9/g;
    var fractionRegex = /[0-9]/g;
    IntlBase.defaultCurrency = "$";
    var mapper = [
        "infinity",
        "nan",
        "group",
        "decimal"
    ];
    var patternRegex = /G|M|L|H|c|'| a|yy|y|EEEE|E/g;
    var patternMatch = {
        "G": "",
        "M": "m",
        "L": "m",
        "H": "h",
        "c": "d",
        "'": '"',
        " a": " AM/PM",
        "yy": "yy",
        "y": "yyyy",
        "EEEE": "dddd",
        "E": "ddd"
    };
    IntlBase.dateConverterMapper = /dddd|ddd/ig;
    var defaultFirstDay = "sun";
    IntlBase.islamicRegex = /^islamic/;
    var firstDayMapper = {
        "sun": 0,
        "mon": 1,
        "tue": 2,
        "wed": 3,
        "thu": 4,
        "fri": 5,
        "sat": 6
    };
    IntlBase.formatRegex = new $b99dd653eda5c2fa$var$regExp("(^[ncpae]{1})([0-1]?[0-9]|20)?$", "i");
    IntlBase.currencyFormatRegex = new $b99dd653eda5c2fa$var$regExp("(^[ca]{1})([0-1]?[0-9]|20)?$", "i");
    IntlBase.curWithoutNumberRegex = /(c|a)$/ig;
    var typeMapper = {
        "$": "isCurrency",
        "%": "isPercent",
        "-": "isNegative",
        0: "nlead",
        1: "nend"
    };
    IntlBase.dateParseRegex = /([a-z])\1*|'([^']|'')+'|''|./gi;
    IntlBase.basicPatterns = [
        "short",
        "medium",
        "long",
        "full"
    ];
    IntlBase.defaultObject = {
        "dates": {
            "calendars": {
                "gregorian": {
                    "months": {
                        "stand-alone": {
                            "abbreviated": {
                                "1": "Jan",
                                "2": "Feb",
                                "3": "Mar",
                                "4": "Apr",
                                "5": "May",
                                "6": "Jun",
                                "7": "Jul",
                                "8": "Aug",
                                "9": "Sep",
                                "10": "Oct",
                                "11": "Nov",
                                "12": "Dec"
                            },
                            "narrow": {
                                "1": "J",
                                "2": "F",
                                "3": "M",
                                "4": "A",
                                "5": "M",
                                "6": "J",
                                "7": "J",
                                "8": "A",
                                "9": "S",
                                "10": "O",
                                "11": "N",
                                "12": "D"
                            },
                            "wide": {
                                "1": "January",
                                "2": "February",
                                "3": "March",
                                "4": "April",
                                "5": "May",
                                "6": "June",
                                "7": "July",
                                "8": "August",
                                "9": "September",
                                "10": "October",
                                "11": "November",
                                "12": "December"
                            }
                        }
                    },
                    "days": {
                        "stand-alone": {
                            "abbreviated": {
                                "sun": "Sun",
                                "mon": "Mon",
                                "tue": "Tue",
                                "wed": "Wed",
                                "thu": "Thu",
                                "fri": "Fri",
                                "sat": "Sat"
                            },
                            "narrow": {
                                "sun": "S",
                                "mon": "M",
                                "tue": "T",
                                "wed": "W",
                                "thu": "T",
                                "fri": "F",
                                "sat": "S"
                            },
                            "short": {
                                "sun": "Su",
                                "mon": "Mo",
                                "tue": "Tu",
                                "wed": "We",
                                "thu": "Th",
                                "fri": "Fr",
                                "sat": "Sa"
                            },
                            "wide": {
                                "sun": "Sunday",
                                "mon": "Monday",
                                "tue": "Tuesday",
                                "wed": "Wednesday",
                                "thu": "Thursday",
                                "fri": "Friday",
                                "sat": "Saturday"
                            }
                        }
                    },
                    "dayPeriods": {
                        "format": {
                            "wide": {
                                "am": "AM",
                                "pm": "PM"
                            }
                        }
                    },
                    "eras": {
                        "eraNames": {
                            "0": "Before Christ",
                            "0-alt-variant": "Before Common Era",
                            "1": "Anno Domini",
                            "1-alt-variant": "Common Era"
                        },
                        "eraAbbr": {
                            "0": "BC",
                            "0-alt-variant": "BCE",
                            "1": "AD",
                            "1-alt-variant": "CE"
                        },
                        "eraNarrow": {
                            "0": "B",
                            "0-alt-variant": "BCE",
                            "1": "A",
                            "1-alt-variant": "CE"
                        }
                    },
                    "dateFormats": {
                        "full": "EEEE, MMMM d, y",
                        "long": "MMMM d, y",
                        "medium": "MMM d, y",
                        "short": "M/d/yy"
                    },
                    "timeFormats": {
                        "full": "h:mm:ss a zzzz",
                        "long": "h:mm:ss a z",
                        "medium": "h:mm:ss a",
                        "short": "h:mm a"
                    },
                    "dateTimeFormats": {
                        "full": "{1} 'at' {0}",
                        "long": "{1} 'at' {0}",
                        "medium": "{1}, {0}",
                        "short": "{1}, {0}",
                        "availableFormats": {
                            "d": "d",
                            "E": "ccc",
                            "Ed": "d E",
                            "Ehm": "E h:mm a",
                            "EHm": "E HH:mm",
                            "Ehms": "E h:mm:ss a",
                            "EHms": "E HH:mm:ss",
                            "Gy": "y G",
                            "GyMMM": "MMM y G",
                            "GyMMMd": "MMM d, y G",
                            "GyMMMEd": "E, MMM d, y G",
                            "h": "h a",
                            "H": "HH",
                            "hm": "h:mm a",
                            "Hm": "HH:mm",
                            "hms": "h:mm:ss a",
                            "Hms": "HH:mm:ss",
                            "hmsv": "h:mm:ss a v",
                            "Hmsv": "HH:mm:ss v",
                            "hmv": "h:mm a v",
                            "Hmv": "HH:mm v",
                            "M": "L",
                            "Md": "M/d",
                            "MEd": "E, M/d",
                            "MMM": "LLL",
                            "MMMd": "MMM d",
                            "MMMEd": "E, MMM d",
                            "MMMMd": "MMMM d",
                            "ms": "mm:ss",
                            "y": "y",
                            "yM": "M/y",
                            "yMd": "M/d/y",
                            "yMEd": "E, M/d/y",
                            "yMMM": "MMM y",
                            "yMMMd": "MMM d, y",
                            "yMMMEd": "E, MMM d, y",
                            "yMMMM": "MMMM y"
                        }
                    }
                },
                "islamic": {
                    "months": {
                        "stand-alone": {
                            "abbreviated": {
                                "1": "Muh.",
                                "2": "Saf.",
                                "3": "Rab. I",
                                "4": "Rab. II",
                                "5": "Jum. I",
                                "6": "Jum. II",
                                "7": "Raj.",
                                "8": "Sha.",
                                "9": "Ram.",
                                "10": "Shaw.",
                                "11": "Dhu\u02BBl-Q.",
                                "12": "Dhu\u02BBl-H."
                            },
                            "narrow": {
                                "1": "1",
                                "2": "2",
                                "3": "3",
                                "4": "4",
                                "5": "5",
                                "6": "6",
                                "7": "7",
                                "8": "8",
                                "9": "9",
                                "10": "10",
                                "11": "11",
                                "12": "12"
                            },
                            "wide": {
                                "1": "Muharram",
                                "2": "Safar",
                                "3": "Rabi\u02BB I",
                                "4": "Rabi\u02BB II",
                                "5": "Jumada I",
                                "6": "Jumada II",
                                "7": "Rajab",
                                "8": "Sha\u02BBban",
                                "9": "Ramadan",
                                "10": "Shawwal",
                                "11": "Dhu\u02BBl-Qi\u02BBdah",
                                "12": "Dhu\u02BBl-Hijjah"
                            }
                        }
                    },
                    "days": {
                        "stand-alone": {
                            "abbreviated": {
                                "sun": "Sun",
                                "mon": "Mon",
                                "tue": "Tue",
                                "wed": "Wed",
                                "thu": "Thu",
                                "fri": "Fri",
                                "sat": "Sat"
                            },
                            "narrow": {
                                "sun": "S",
                                "mon": "M",
                                "tue": "T",
                                "wed": "W",
                                "thu": "T",
                                "fri": "F",
                                "sat": "S"
                            },
                            "short": {
                                "sun": "Su",
                                "mon": "Mo",
                                "tue": "Tu",
                                "wed": "We",
                                "thu": "Th",
                                "fri": "Fr",
                                "sat": "Sa"
                            },
                            "wide": {
                                "sun": "Sunday",
                                "mon": "Monday",
                                "tue": "Tuesday",
                                "wed": "Wednesday",
                                "thu": "Thursday",
                                "fri": "Friday",
                                "sat": "Saturday"
                            }
                        }
                    },
                    "dayPeriods": {
                        "format": {
                            "wide": {
                                "am": "AM",
                                "pm": "PM"
                            }
                        }
                    },
                    "eras": {
                        "eraNames": {
                            "0": "AH"
                        },
                        "eraAbbr": {
                            "0": "AH"
                        },
                        "eraNarrow": {
                            "0": "AH"
                        }
                    },
                    "dateFormats": {
                        "full": "EEEE, MMMM d, y G",
                        "long": "MMMM d, y G",
                        "medium": "MMM d, y G",
                        "short": "M/d/y GGGGG"
                    },
                    "timeFormats": {
                        "full": "h:mm:ss a zzzz",
                        "long": "h:mm:ss a z",
                        "medium": "h:mm:ss a",
                        "short": "h:mm a"
                    },
                    "dateTimeFormats": {
                        "full": "{1} 'at' {0}",
                        "long": "{1} 'at' {0}",
                        "medium": "{1}, {0}",
                        "short": "{1}, {0}",
                        "availableFormats": {
                            "d": "d",
                            "E": "ccc",
                            "Ed": "d E",
                            "Ehm": "E h:mm a",
                            "EHm": "E HH:mm",
                            "Ehms": "E h:mm:ss a",
                            "EHms": "E HH:mm:ss",
                            "Gy": "y G",
                            "GyMMM": "MMM y G",
                            "GyMMMd": "MMM d, y G",
                            "GyMMMEd": "E, MMM d, y G",
                            "h": "h a",
                            "H": "HH",
                            "hm": "h:mm a",
                            "Hm": "HH:mm",
                            "hms": "h:mm:ss a",
                            "Hms": "HH:mm:ss",
                            "M": "L",
                            "Md": "M/d",
                            "MEd": "E, M/d",
                            "MMM": "LLL",
                            "MMMd": "MMM d",
                            "MMMEd": "E, MMM d",
                            "MMMMd": "MMMM d",
                            "ms": "mm:ss",
                            "y": "y G",
                            "yyyy": "y G",
                            "yyyyM": "M/y GGGGG",
                            "yyyyMd": "M/d/y GGGGG",
                            "yyyyMEd": "E, M/d/y GGGGG",
                            "yyyyMMM": "MMM y G",
                            "yyyyMMMd": "MMM d, y G",
                            "yyyyMMMEd": "E, MMM d, y G",
                            "yyyyMMMM": "MMMM y G",
                            "yyyyQQQ": "QQQ y G",
                            "yyyyQQQQ": "QQQQ y G"
                        }
                    }
                }
            },
            "timeZoneNames": {
                "hourFormat": "+HH:mm;-HH:mm",
                "gmtFormat": "GMT{0}",
                "gmtZeroFormat": "GMT"
            }
        },
        "numbers": {
            "currencies": {
                "USD": {
                    "displayName": "US Dollar",
                    "symbol": "$",
                    "symbol-alt-narrow": "$"
                },
                "EUR": {
                    "displayName": "Euro",
                    "symbol": "\u20AC",
                    "symbol-alt-narrow": "\u20AC"
                },
                "GBP": {
                    "displayName": "British Pound",
                    "symbol-alt-narrow": "\xa3"
                }
            },
            "defaultNumberingSystem": "latn",
            "minimumGroupingDigits": "1",
            "symbols-numberSystem-latn": {
                "decimal": ".",
                "group": ",",
                "list": ";",
                "percentSign": "%",
                "plusSign": "+",
                "minusSign": "-",
                "exponential": "E",
                "superscriptingExponent": "\xd7",
                "perMille": "\u2030",
                "infinity": "\u221E",
                "nan": "NaN",
                "timeSeparator": ":"
            },
            "decimalFormats-numberSystem-latn": {
                "standard": "#,##0.###"
            },
            "percentFormats-numberSystem-latn": {
                "standard": "#,##0%"
            },
            "currencyFormats-numberSystem-latn": {
                "standard": "\xa4#,##0.00",
                "accounting": "\xa4#,##0.00;(\xa4#,##0.00)"
            },
            "scientificFormats-numberSystem-latn": {
                "standard": "#E0"
            }
        }
    };
    IntlBase.blazorDefaultObject = {
        "numbers": {
            "mapper": {
                "0": "0",
                "1": "1",
                "2": "2",
                "3": "3",
                "4": "4",
                "5": "5",
                "6": "6",
                "7": "7",
                "8": "8",
                "9": "9"
            },
            "mapperDigits": "0123456789",
            "numberSymbols": {
                "decimal": ".",
                "group": ",",
                "plusSign": "+",
                "minusSign": "-",
                "percentSign": "%",
                "nan": "NaN",
                "timeSeparator": ":",
                "infinity": "\u221E"
            },
            "timeSeparator": ":",
            "currencySymbol": "$",
            "currencypData": {
                "nlead": "$",
                "nend": "",
                "groupSeparator": ",",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            },
            "percentpData": {
                "nlead": "",
                "nend": "%",
                "groupSeparator": ",",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            },
            "percentnData": {
                "nlead": "-",
                "nend": "%",
                "groupSeparator": ",",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            },
            "currencynData": {
                "nlead": "($",
                "nend": ")",
                "groupSeparator": ",",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            },
            "decimalnData": {
                "nlead": "-",
                "nend": "",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            },
            "decimalpData": {
                "nlead": "",
                "nend": "",
                "groupData": {
                    "primary": 3
                },
                "maximumFraction": 2,
                "minimumFraction": 2
            }
        },
        "dates": {
            "dayPeriods": {
                "am": "AM",
                "pm": "PM"
            },
            "dateSeperator": "/",
            "days": {
                "abbreviated": {
                    "sun": "Sun",
                    "mon": "Mon",
                    "tue": "Tue",
                    "wed": "Wed",
                    "thu": "Thu",
                    "fri": "Fri",
                    "sat": "Sat"
                },
                "short": {
                    "sun": "Su",
                    "mon": "Mo",
                    "tue": "Tu",
                    "wed": "We",
                    "thu": "Th",
                    "fri": "Fr",
                    "sat": "Sa"
                },
                "wide": {
                    "sun": "Sunday",
                    "mon": "Monday",
                    "tue": "Tuesday",
                    "wed": "Wednesday",
                    "thu": "Thursday",
                    "fri": "Friday",
                    "sat": "Saturday"
                }
            },
            "months": {
                "abbreviated": {
                    "1": "Jan",
                    "2": "Feb",
                    "3": "Mar",
                    "4": "Apr",
                    "5": "May",
                    "6": "Jun",
                    "7": "Jul",
                    "8": "Aug",
                    "9": "Sep",
                    "10": "Oct",
                    "11": "Nov",
                    "12": "Dec"
                },
                "wide": {
                    "1": "January",
                    "2": "February",
                    "3": "March",
                    "4": "April",
                    "5": "May",
                    "6": "June",
                    "7": "July",
                    "8": "August",
                    "9": "September",
                    "10": "October",
                    "11": "November",
                    "12": "December"
                }
            },
            "eras": {
                "1": "AD"
            }
        }
    };
    IntlBase.monthIndex = {
        3: "abbreviated",
        4: "wide",
        5: "narrow",
        1: "abbreviated"
    };
    /**
     *
     */ IntlBase.month = "months";
    IntlBase.days = "days";
    /**
     * Default numerber Object
     */ IntlBase.patternMatcher = {
        C: "currency",
        P: "percent",
        N: "decimal",
        A: "currency",
        E: "scientific"
    };
    /**
     * Returns the resultant pattern based on the skeleton, dateObject and the type provided
     *
     * @private
     * @param {string} skeleton ?
     * @param {Object} dateObject ?
     * @param {string} type ?
     * @param {boolean} isIslamic ?
     * @param {string} blazorCulture ?
     * @returns {string} ?
     */ function getResultantPattern(skeleton, dateObject, type, isIslamic, blazorCulture) {
        var resPattern;
        var iType = type || "date";
        if (blazorCulture) resPattern = compareBlazorDateFormats({
            skeleton: skeleton
        }, blazorCulture).format || compareBlazorDateFormats({
            skeleton: "d"
        }, "en-US").format;
        else {
            if (IntlBase.basicPatterns.indexOf(skeleton) !== -1) {
                resPattern = (0, $3EnZW.getValue)(iType + "Formats." + skeleton, dateObject);
                if (iType === "dateTime") {
                    var dPattern = (0, $3EnZW.getValue)("dateFormats." + skeleton, dateObject);
                    var tPattern = (0, $3EnZW.getValue)("timeFormats." + skeleton, dateObject);
                    resPattern = resPattern.replace("{1}", dPattern).replace("{0}", tPattern);
                }
            } else resPattern = (0, $3EnZW.getValue)("dateTimeFormats.availableFormats." + skeleton, dateObject);
            if ((0, $3EnZW.isUndefined)(resPattern) && skeleton === "yMd") resPattern = "M/d/y";
        }
        return resPattern;
    }
    IntlBase.getResultantPattern = getResultantPattern;
    /**
     * Returns the dependable object for provided cldr data and culture
     *
     * @private
     * @param {Object} cldr ?
     * @param {string} culture ?
     * @param {string} mode ?
     * @param {boolean} isNumber ?
     * @returns {any} ?
     */ function getDependables(cldr, culture, mode, isNumber) {
        var ret = {};
        var calendartype = mode || "gregorian";
        ret.parserObject = (0, $3amEA.ParserBase).getMainObject(cldr, culture) || ((0, $3EnZW.isBlazor)() ? IntlBase.blazorDefaultObject : IntlBase.defaultObject);
        if (isNumber) ret.numericObject = (0, $3EnZW.getValue)("numbers", ret.parserObject);
        else {
            var dateString = (0, $3EnZW.isBlazor)() ? "dates" : "dates.calendars." + calendartype;
            ret.dateObject = (0, $3EnZW.getValue)(dateString, ret.parserObject);
        }
        return ret;
    }
    IntlBase.getDependables = getDependables;
    /**
     * Returns the symbol pattern for provided parameters
     *
     * @private
     * @param {string} type ?
     * @param {string} numSystem ?
     * @param {Object} obj ?
     * @param {boolean} isAccount ?
     * @returns {string} ?
     */ function getSymbolPattern(type, numSystem, obj, isAccount) {
        return (0, $3EnZW.getValue)(type + "Formats-numberSystem-" + numSystem + (isAccount ? ".accounting" : ".standard"), obj) || (isAccount ? (0, $3EnZW.getValue)(type + "Formats-numberSystem-" + numSystem + ".standard", obj) : "");
    }
    IntlBase.getSymbolPattern = getSymbolPattern;
    /**
     *
     * @param {string} format ?
     * @returns {string} ?
     */ function ConvertDateToWeekFormat(format) {
        var convertMapper = format.match(IntlBase.dateConverterMapper);
        if (convertMapper && (0, $3EnZW.isBlazor)()) {
            var tempString = convertMapper[0].length === 3 ? "EEE" : "EEEE";
            return format.replace(IntlBase.dateConverterMapper, tempString);
        }
        return format;
    }
    IntlBase.ConvertDateToWeekFormat = ConvertDateToWeekFormat;
    /**
     *
     * @param {DateFormatOptions} formatOptions ?
     * @param {string} culture ?
     * @returns {DateFormatOptions} ?
     */ function compareBlazorDateFormats(formatOptions, culture) {
        var format = formatOptions.format || formatOptions.skeleton;
        var curFormatMapper = (0, $3EnZW.getValue)((culture || "en-US") + "." + format, $b99dd653eda5c2fa$export$b70e0d9183d08bef);
        if (!curFormatMapper) curFormatMapper = (0, $3EnZW.getValue)("en-US." + format, $b99dd653eda5c2fa$export$b70e0d9183d08bef);
        if (curFormatMapper) {
            curFormatMapper = ConvertDateToWeekFormat(curFormatMapper);
            formatOptions.format = curFormatMapper.replace(/tt/, "a");
        }
        return formatOptions;
    }
    IntlBase.compareBlazorDateFormats = compareBlazorDateFormats;
    /**
     * Returns proper numeric skeleton
     *
     * @private
     * @param {string} skeleton ?
     * @returns {any} ?
     */ function getProperNumericSkeleton(skeleton) {
        var matches = skeleton.match(IntlBase.formatRegex);
        var ret = {};
        var pattern = matches[1].toUpperCase();
        ret.isAccount = pattern === "A";
        ret.type = IntlBase.patternMatcher["" + pattern];
        if (skeleton.length > 1) ret.fractionDigits = parseInt(matches[2], 10);
        return ret;
    }
    IntlBase.getProperNumericSkeleton = getProperNumericSkeleton;
    /**
     * Returns format data for number formatting like minimum fraction, maximum fraction, etc..,
     *
     * @private
     * @param {string} pattern ?
     * @param {boolean} needFraction ?
     * @param {string} cSymbol ?
     * @param {boolean} fractionOnly ?
     * @returns {any} ?
     */ function getFormatData(pattern, needFraction, cSymbol, fractionOnly) {
        var nData = fractionOnly ? {} : {
            nlead: "",
            nend: ""
        };
        var match = pattern.match(IntlBase.customRegex);
        if (match) {
            if (!fractionOnly) {
                nData.nlead = changeCurrencySymbol(match[1], cSymbol);
                nData.nend = changeCurrencySymbol(match[10], cSymbol);
                nData.groupPattern = match[4];
            }
            var fraction = match[7];
            if (fraction && needFraction) {
                var fmatch = fraction.match(fractionRegex);
                if (!(0, $3EnZW.isNullOrUndefined)(fmatch)) nData.minimumFraction = fmatch.length;
                else nData.minimumFraction = 0;
                nData.maximumFraction = fraction.length - 1;
            }
        }
        return nData;
    }
    IntlBase.getFormatData = getFormatData;
    /**
     * Changes currency symbol
     *
     * @private
     * @param {string} val ?
     * @param {string} sym ?
     * @returns {string} ?
     */ function changeCurrencySymbol(val, sym) {
        if (val) {
            val = val.replace(IntlBase.defaultCurrency, sym);
            return sym === "" ? val.trim() : val;
        }
        return "";
    }
    IntlBase.changeCurrencySymbol = changeCurrencySymbol;
    /**
     * Returns currency symbol based on currency code ?
     *
     * @private
     * @param {Object} numericObject ?
     * @param {string} currencyCode ?
     * @param {string} altSymbol ?
     * @param {string} ignoreCurrency ?
     * @returns {string} ?
     */ function getCurrencySymbol(numericObject, currencyCode, altSymbol, ignoreCurrency) {
        var symbol = altSymbol ? "." + altSymbol : ".symbol";
        var getCurrency = ignoreCurrency ? "$" : (0, $3EnZW.getValue)("currencies." + currencyCode + symbol, numericObject) || (0, $3EnZW.getValue)("currencies." + currencyCode + ".symbol-alt-narrow", numericObject) || "$";
        return getCurrency;
    }
    IntlBase.getCurrencySymbol = getCurrencySymbol;
    /**
     * Returns formatting options for custom number format
     *
     * @private
     * @param {string} format ?
     * @param {CommonOptions} dOptions ?
     * @param {any} obj ?
     * @returns {any} ?
     */ function customFormat(format, dOptions, obj) {
        var options = {};
        var formatSplit = format.split(";");
        var data = [
            "pData",
            "nData",
            "zeroData"
        ];
        for(var i = 0; i < formatSplit.length; i++)options["" + data[parseInt(i.toString(), 10)]] = customNumberFormat(formatSplit[parseInt(i.toString(), 10)], dOptions, obj);
        if ((0, $3EnZW.isNullOrUndefined)(options.nData)) {
            options.nData = (0, $3EnZW.extend)({}, options.pData);
            options.nData.nlead = (0, $3EnZW.isNullOrUndefined)(dOptions) ? "-" + options.nData.nlead : dOptions.minusSymbol + options.nData.nlead;
        }
        return options;
    }
    IntlBase.customFormat = customFormat;
    /**
     * Returns custom formatting options
     *
     * @private
     * @param {string} format ?
     * @param {CommonOptions} dOptions ?
     * @param {Object} numObject ?
     * @returns {any} ?
     */ function customNumberFormat(format, dOptions, numObject) {
        var cOptions = {
            type: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        };
        var pattern = format.match(IntlBase.customRegex);
        if ((0, $3EnZW.isNullOrUndefined)(pattern) || pattern[5] === "" && format !== "N/A") {
            cOptions.type = undefined;
            return cOptions;
        }
        cOptions.nlead = pattern[1];
        cOptions.nend = pattern[10];
        var integerPart = pattern[6];
        var spaceCapture = integerPart.match(/ $/g) ? true : false;
        var spaceGrouping = integerPart.replace(/ $/g, "").indexOf(" ") !== -1;
        cOptions.useGrouping = integerPart.indexOf(",") !== -1 || spaceGrouping;
        integerPart = integerPart.replace(/,/g, "");
        var fractionPart = pattern[7];
        if (integerPart.indexOf("0") !== -1) cOptions.minimumIntegerDigits = integerPart.length - integerPart.indexOf("0");
        if (!(0, $3EnZW.isNullOrUndefined)(fractionPart)) {
            cOptions.minimumFractionDigits = fractionPart.lastIndexOf("0");
            cOptions.maximumFractionDigits = fractionPart.lastIndexOf("#");
            if (cOptions.minimumFractionDigits === -1) cOptions.minimumFractionDigits = 0;
            if (cOptions.maximumFractionDigits === -1 || cOptions.maximumFractionDigits < cOptions.minimumFractionDigits) cOptions.maximumFractionDigits = cOptions.minimumFractionDigits;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(dOptions)) {
            dOptions.isCustomFormat = true;
            (0, $3EnZW.extend)(cOptions, isCurrencyPercent([
                cOptions.nlead,
                cOptions.nend
            ], "$", dOptions.currencySymbol));
            if (!cOptions.isCurrency) (0, $3EnZW.extend)(cOptions, isCurrencyPercent([
                cOptions.nlead,
                cOptions.nend
            ], "%", dOptions.percentSymbol));
        } else (0, $3EnZW.extend)(cOptions, isCurrencyPercent([
            cOptions.nlead,
            cOptions.nend
        ], "%", "%"));
        if (!(0, $3EnZW.isNullOrUndefined)(numObject)) {
            var symbolPattern = getSymbolPattern(cOptions.type, dOptions.numberMapper.numberSystem, numObject, false);
            if (cOptions.useGrouping) {
                cOptions.groupSeparator = spaceGrouping ? " " : dOptions.numberMapper.numberSymbols[mapper[2]];
                cOptions.groupData = (0, $aJNO3.NumberFormat).getGroupingDetails(symbolPattern.split(";")[0]);
            }
            cOptions.nlead = cOptions.nlead.replace(/'/g, "");
            cOptions.nend = spaceCapture ? " " + cOptions.nend.replace(/'/g, "") : cOptions.nend.replace(/'/g, "");
        }
        return cOptions;
    }
    IntlBase.customNumberFormat = customNumberFormat;
    /**
     * Returns formatting options for currency or percent type
     *
     * @private
     * @param {string[]} parts ?
     * @param {string} actual ?
     * @param {string} symbol ?
     * @returns {any} ?
     */ function isCurrencyPercent(parts, actual, symbol) {
        var options = {
            nlead: parts[0],
            nend: parts[1]
        };
        for(var i = 0; i < 2; i++){
            var part = parts[parseInt(i.toString(), 10)];
            var loc = part.indexOf(actual);
            if (loc !== -1 && (loc < part.indexOf("'") || loc > part.lastIndexOf("'"))) {
                options["" + typeMapper[parseInt(i.toString(), 10)]] = part.substr(0, loc) + symbol + part.substr(loc + 1);
                options["" + typeMapper["" + actual]] = true;
                options.type = options.isCurrency ? "currency" : "percent";
                break;
            }
        }
        return options;
    }
    IntlBase.isCurrencyPercent = isCurrencyPercent;
    /**
     * Returns culture based date separator
     *
     * @private
     * @param {Object} dateObj ?
     * @returns {string} ?
     */ function getDateSeparator(dateObj) {
        var value = ((0, $3EnZW.getValue)("dateFormats.short", dateObj) || "").match(/[dM]([^dM])[dM]/i);
        return value ? value[1] : "/";
    }
    IntlBase.getDateSeparator = getDateSeparator;
    /**
     * Returns Native Date Time pattern
     *
     * @private
     * @param {string} culture ?
     * @param {DateFormatOptions} options ?
     * @param {Object} cldr ?
     * @param {boolean} isExcelFormat ?
     * @returns {string} ?
     */ function getActualDateTimeFormat(culture, options, cldr, isExcelFormat) {
        var dependable = getDependables(cldr, culture, options.calendar);
        if ((0, $3EnZW.isBlazor)()) options = compareBlazorDateFormats(options, culture);
        var actualPattern = options.format || getResultantPattern(options.skeleton, dependable.dateObject, options.type);
        if (isExcelFormat) {
            actualPattern = actualPattern.replace(patternRegex, function(pattern) {
                return patternMatch["" + pattern];
            });
            if (actualPattern.indexOf("z") !== -1) {
                var tLength = actualPattern.match(/z/g).length;
                var timeZonePattern = void 0;
                var options_1 = {
                    "timeZone": {}
                };
                options_1.numMapper = (0, $3amEA.ParserBase).getNumberMapper(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr));
                options_1.timeZone = (0, $3EnZW.getValue)("dates.timeZoneNames", dependable.parserObject);
                var value = new Date();
                var timezone = value.getTimezoneOffset();
                var pattern = tLength < 4 ? "+H;-H" : options_1.timeZone.hourFormat;
                pattern = pattern.replace(/:/g, options_1.numMapper.timeSeparator);
                if (timezone === 0) timeZonePattern = options_1.timeZone.gmtZeroFormat;
                else {
                    timeZonePattern = (0, $c2qRe.DateFormat).getTimeZoneValue(timezone, pattern);
                    timeZonePattern = options_1.timeZone.gmtFormat.replace(/\{0\}/, timeZonePattern);
                }
                actualPattern = actualPattern.replace(/[z]+/, '"' + timeZonePattern + '"');
            }
            actualPattern = actualPattern.replace(/ $/, "");
        }
        return actualPattern;
    }
    IntlBase.getActualDateTimeFormat = getActualDateTimeFormat;
    /**
     *
     * @param {string} actual ?
     * @param {any} option ?
     * @returns {any} ?
     */ function processSymbol(actual, option) {
        if (actual.indexOf(",") !== -1) {
            var split = actual.split(",");
            actual = split[0] + (0, $3EnZW.getValue)("numberMapper.numberSymbols.group", option) + split[1].replace(".", (0, $3EnZW.getValue)("numberMapper.numberSymbols.decimal", option));
        } else actual = actual.replace(".", (0, $3EnZW.getValue)("numberMapper.numberSymbols.decimal", option));
        return actual;
    }
    IntlBase.processSymbol = processSymbol;
    /**
     * Returns Native Number pattern
     *
     * @private
     * @param {string} culture ?
     * @param {NumberFormatOptions} options ?
     * @param {Object} cldr ?
     * @param {boolean} isExcel ?
     * @returns {string} ?
     */ function getActualNumberFormat(culture, options, cldr, isExcel) {
        var dependable = getDependables(cldr, culture, "", true);
        var parseOptions = {
            custom: true
        };
        var numrericObject = dependable.numericObject;
        var minFrac;
        var curObj = {};
        var curMatch = (options.format || "").match(IntlBase.currencyFormatRegex);
        var type = IntlBase.formatRegex.test(options.format) ? getProperNumericSkeleton(options.format || "N") : {};
        var dOptions = {};
        if (curMatch) {
            dOptions.numberMapper = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.extend)({}, dependable.numericObject) : (0, $3amEA.ParserBase).getNumberMapper(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr), true);
            var curCode = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("currencySymbol", dependable.numericObject) : getCurrencySymbol(dependable.numericObject, options.currency || (0, $bWDaN.defaultCurrencyCode), options.altSymbol);
            var symbolPattern = getSymbolPattern("currency", dOptions.numberMapper.numberSystem, dependable.numericObject, /a/i.test(options.format));
            symbolPattern = symbolPattern.replace(/\u00A4/g, curCode);
            var split = symbolPattern.split(";");
            curObj.hasNegativePattern = (0, $3EnZW.isBlazor)() ? true : split.length > 1;
            curObj.nData = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)(type.type + "nData", numrericObject) : getFormatData(split[1] || "-" + split[0], true, curCode);
            curObj.pData = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)(type.type + "pData", numrericObject) : getFormatData(split[0], false, curCode);
            if (!curMatch[2] && !options.minimumFractionDigits && !options.maximumFractionDigits) minFrac = getFormatData(symbolPattern.split(";")[0], true, "", true).minimumFraction;
        }
        var actualPattern;
        if (IntlBase.formatRegex.test(options.format) || !options.format) {
            (0, $3EnZW.extend)(parseOptions, getProperNumericSkeleton(options.format || "N"));
            parseOptions.custom = false;
            actualPattern = "###0";
            if (parseOptions.fractionDigits || options.minimumFractionDigits || options.maximumFractionDigits || minFrac) {
                var defaultMinimum = 0;
                if (parseOptions.fractionDigits) options.minimumFractionDigits = options.maximumFractionDigits = parseOptions.fractionDigits;
                actualPattern = fractionDigitsPattern(actualPattern, minFrac || parseOptions.fractionDigits || options.minimumFractionDigits || defaultMinimum, options.maximumFractionDigits || defaultMinimum);
            }
            if (options.minimumIntegerDigits) actualPattern = minimumIntegerPattern(actualPattern, options.minimumIntegerDigits);
            if (options.useGrouping) actualPattern = groupingPattern(actualPattern);
            if (parseOptions.type === "currency" || parseOptions.type && (0, $3EnZW.isBlazor)()) {
                if ((0, $3EnZW.isBlazor)() && parseOptions.type !== "currency") {
                    curObj.pData = (0, $3EnZW.getValue)(parseOptions.type + "pData", numrericObject);
                    curObj.nData = (0, $3EnZW.getValue)(parseOptions.type + "nData", numrericObject);
                }
                var cPattern = actualPattern;
                actualPattern = curObj.pData.nlead + cPattern + curObj.pData.nend;
                if (curObj.hasNegativePattern || (0, $3EnZW.isBlazor)()) actualPattern += ";" + curObj.nData.nlead + cPattern + curObj.nData.nend;
            }
            if (parseOptions.type === "percent" && !(0, $3EnZW.isBlazor)()) actualPattern += " %";
        } else actualPattern = options.format.replace(/'/g, '"');
        if (Object.keys(dOptions).length > 0) actualPattern = !isExcel ? processSymbol(actualPattern, dOptions) : actualPattern;
        return actualPattern;
    }
    IntlBase.getActualNumberFormat = getActualNumberFormat;
    /**
     *
     * @param {string} pattern ?
     * @param {number} minDigits ?
     * @param {number} maxDigits ?
     * @returns {string} ?
     */ function fractionDigitsPattern(pattern, minDigits, maxDigits) {
        pattern += ".";
        for(var a = 0; a < minDigits; a++)pattern += "0";
        if (minDigits < maxDigits) {
            var diff = maxDigits - minDigits;
            for(var b = 0; b < diff; b++)pattern += "#";
        }
        return pattern;
    }
    IntlBase.fractionDigitsPattern = fractionDigitsPattern;
    /**
     *
     * @param {string} pattern ?
     * @param {number} digits ?
     * @returns {string} ?
     */ function minimumIntegerPattern(pattern, digits) {
        var temp = pattern.split(".");
        var integer = "";
        for(var x = 0; x < digits; x++)integer += "0";
        return temp[1] ? integer + "." + temp[1] : integer;
    }
    IntlBase.minimumIntegerPattern = minimumIntegerPattern;
    /**
     *
     * @param {string} pattern ?
     * @returns {string} ?
     */ function groupingPattern(pattern) {
        var temp = pattern.split(".");
        var integer = temp[0];
        var no = 3 - integer.length % 3;
        var hash = no && no === 1 ? "#" : no === 2 ? "##" : "";
        integer = hash + integer;
        pattern = "";
        for(var x = integer.length - 1; x > 0; x = x - 3)pattern = "," + integer[x - 2] + integer[x - 1] + integer[parseInt(x.toString(), 10)] + pattern;
        pattern = pattern.slice(1);
        return temp[1] ? pattern + "." + temp[1] : pattern;
    }
    IntlBase.groupingPattern = groupingPattern;
    /**
     *
     * @param {string} culture ?
     * @param {Object} cldr ?
     * @returns {number} ?
     */ function getWeekData(culture, cldr) {
        var firstDay = defaultFirstDay;
        var mapper = (0, $3EnZW.getValue)("supplemental.weekData.firstDay", cldr);
        var iCulture = culture;
        if (/en-/.test(iCulture)) iCulture = iCulture.slice(3);
        iCulture = iCulture.slice(0, 2).toUpperCase() + iCulture.substr(2);
        if (mapper) firstDay = mapper["" + iCulture] || mapper[iCulture.slice(0, 2)] || defaultFirstDay;
        return firstDayMapper["" + firstDay];
    }
    IntlBase.getWeekData = getWeekData;
    /**
     * @private
     * @param {any} pData ?
     * @param {string} aCurrency ?
     * @param {string} rCurrency ?
     * @returns {void} ?
     */ function replaceBlazorCurrency(pData, aCurrency, rCurrency) {
        var iCurrency = (0, $3amEA.getBlazorCurrencySymbol)(rCurrency);
        if (aCurrency !== iCurrency) for(var _i = 0, pData_1 = pData; _i < pData_1.length; _i++){
            var data = pData_1[_i];
            data.nend = data.nend.replace(aCurrency, iCurrency);
            data.nlead = data.nlead.replace(aCurrency, iCurrency);
        }
    }
    IntlBase.replaceBlazorCurrency = replaceBlazorCurrency;
    /**
     * @private
     * @param {Date} date ?
     * @returns {number} ?
     */ function getWeekOfYear(date) {
        var newYear = new Date(date.getFullYear(), 0, 1);
        var day = newYear.getDay();
        var weeknum;
        day = day >= 0 ? day : day + 7;
        var daynum = Math.floor((date.getTime() - newYear.getTime() - (date.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
        if (day < 4) {
            weeknum = Math.floor((daynum + day - 1) / 7) + 1;
            if (weeknum > 52) {
                var nYear = new Date(date.getFullYear() + 1, 0, 1);
                var nday = nYear.getDay();
                nday = nday >= 0 ? nday : nday + 7;
                weeknum = nday < 4 ? 1 : 53;
            }
        } else weeknum = Math.floor((daynum + day - 1) / 7);
        return weeknum;
    }
    IntlBase.getWeekOfYear = getWeekOfYear;
})($b99dd653eda5c2fa$export$2e942c975b8046e9 || ($b99dd653eda5c2fa$export$2e942c975b8046e9 = {}));

});
parcelRegister("bWDaN", function(module, exports) {

$parcel$export(module.exports, "onIntlChange", () => $8b237f71e4fde58a$export$6cb311ccccf7da2e);
$parcel$export(module.exports, "rightToLeft", () => $8b237f71e4fde58a$export$c743977d24bad607);
$parcel$export(module.exports, "cldrData", () => $8b237f71e4fde58a$export$8be2398a1573b5d4);
$parcel$export(module.exports, "defaultCulture", () => $8b237f71e4fde58a$export$36370df3ec99cb02);
$parcel$export(module.exports, "defaultCurrencyCode", () => $8b237f71e4fde58a$export$aa953ac971afd601);
$parcel$export(module.exports, "Internationalization", () => $8b237f71e4fde58a$export$aacf471dfb191f41);
$parcel$export(module.exports, "setCulture", () => $8b237f71e4fde58a$export$5f938ff33579cc37);
$parcel$export(module.exports, "loadCldr", () => $8b237f71e4fde58a$export$dd23409118f58879);
$parcel$export(module.exports, "getNumericObject", () => $8b237f71e4fde58a$export$52fad96a73de9753);
$parcel$export(module.exports, "getDefaultDateObject", () => $8b237f71e4fde58a$export$23f51f10e3a8a34a);

var $c2qRe = parcelRequire("c2qRe");

var $aJNO3 = parcelRequire("aJNO3");

var $ke2zM = parcelRequire("ke2zM");

var $clnws = parcelRequire("clnws");

var $fW217 = parcelRequire("fW217");

var $3EnZW = parcelRequire("3EnZW");

var $13zI2 = parcelRequire("13zI2");
var $8b237f71e4fde58a$export$6cb311ccccf7da2e = new (0, $13zI2.Observer)();
var $8b237f71e4fde58a$export$c743977d24bad607 = false;
var $8b237f71e4fde58a$export$8be2398a1573b5d4 = {};
var $8b237f71e4fde58a$export$36370df3ec99cb02 = "en-US";
var $8b237f71e4fde58a$export$aa953ac971afd601 = "USD";
var $8b237f71e4fde58a$var$mapper = [
    "numericObject",
    "dateObject"
];
/**
 * Internationalization class provides support to parse and format the number and date object to the desired format.
 * ```typescript
 * // To set the culture globally
 * setCulture('en-GB');
 *
 * // To set currency code globally
 * setCurrencyCode('EUR');
 *
 * //Load cldr data
 * loadCldr(gregorainData);
 * loadCldr(timeZoneData);
 * loadCldr(numbersData);
 * loadCldr(numberSystemData);
 *
 * // To use formatter in component side
 * let Intl:Internationalization = new Internationalization();
 *
 * // Date formatting
 * let dateFormatter: Function = Intl.getDateFormat({skeleton:'long',type:'dateTime'});
 * dateFormatter(new Date('11/2/2016'));
 * dateFormatter(new Date('25/2/2030'));
 * Intl.formatDate(new Date(),{skeleton:'E'});
 *
 * //Number formatting
 * let numberFormatter: Function = Intl.getNumberFormat({skeleton:'C5'})
 * numberFormatter(24563334);
 * Intl.formatNumber(123123,{skeleton:'p2'});
 *
 * // Date parser
 * let dateParser: Function = Intl.getDateParser({skeleton:'short',type:'time'});
 * dateParser('10:30 PM');
 * Intl.parseDate('10',{skeleton:'H'});
 * ```
 */ var $8b237f71e4fde58a$export$aacf471dfb191f41 = /** @class */ function() {
    function Internationalization(cultureName) {
        if (cultureName) this.culture = cultureName;
    }
    /**
     * Returns the format function for given options.
     *
     * @param {DateFormatOptions} options - Specifies the format options in which the format function will return.
     * @returns {Function} ?
     */ Internationalization.prototype.getDateFormat = function(options) {
        return (0, $c2qRe.DateFormat).dateFormat(this.getCulture(), options || {
            type: "date",
            skeleton: "short"
        }, $8b237f71e4fde58a$export$8be2398a1573b5d4);
    };
    /**
     * Returns the format function for given options.
     *
     * @param {NumberFormatOptions} options - Specifies the format options in which the format function will return.
     * @returns {Function} ?
     */ Internationalization.prototype.getNumberFormat = function(options) {
        if (options && !options.currency) options.currency = $8b237f71e4fde58a$export$aa953ac971afd601;
        if ((0, $3EnZW.isBlazor)() && options && !options.format) options.minimumFractionDigits = 0;
        return (0, $aJNO3.NumberFormat).numberFormatter(this.getCulture(), options || {}, $8b237f71e4fde58a$export$8be2398a1573b5d4);
    };
    /**
     * Returns the parser function for given options.
     *
     * @param {DateFormatOptions} options - Specifies the format options in which the parser function will return.
     * @returns {Function} ?
     */ Internationalization.prototype.getDateParser = function(options) {
        return (0, $ke2zM.DateParser).dateParser(this.getCulture(), options || {
            skeleton: "short",
            type: "date"
        }, $8b237f71e4fde58a$export$8be2398a1573b5d4);
    };
    /**
     * Returns the parser function for given options.
     *
     * @param {NumberFormatOptions} options - Specifies the format options in which the parser function will return.
     * @returns {Function} ?
     */ Internationalization.prototype.getNumberParser = function(options) {
        if ((0, $3EnZW.isBlazor)() && options && !options.format) options.minimumFractionDigits = 0;
        return (0, $clnws.NumberParser).numberParser(this.getCulture(), options || {
            format: "N"
        }, $8b237f71e4fde58a$export$8be2398a1573b5d4);
    };
    /**
     * Returns the formatted string based on format options.
     *
     * @param {number} value - Specifies the number to format.
     * @param {NumberFormatOptions} option - Specifies the format options in which the number will be formatted.
     * @returns {string} ?
     */ Internationalization.prototype.formatNumber = function(value, option) {
        return this.getNumberFormat(option)(value);
    };
    /**
     * Returns the formatted date string based on format options.
     *
     * @param {Date} value - Specifies the number to format.
     * @param {DateFormatOptions} option - Specifies the format options in which the number will be formatted.
     * @returns {string} ?
     */ Internationalization.prototype.formatDate = function(value, option) {
        return this.getDateFormat(option)(value);
    };
    /**
     * Returns the date object for given date string and options.
     *
     * @param {string} value - Specifies the string to parse.
     * @param {DateFormatOptions} option - Specifies the parse options in which the date string will be parsed.
     * @returns {Date} ?
     */ Internationalization.prototype.parseDate = function(value, option) {
        return this.getDateParser(option)(value);
    };
    /**
     * Returns the number object from the given string value and options.
     *
     * @param {string} value - Specifies the string to parse.
     * @param {NumberFormatOptions} option - Specifies the parse options in which the  string number  will be parsed.
     * @returns {number} ?
     */ Internationalization.prototype.parseNumber = function(value, option) {
        return this.getNumberParser(option)(value);
    };
    /**
     * Returns Native Date Time Pattern
     *
     * @param {DateFormatOptions} option - Specifies the parse options for resultant date time pattern.
     * @param {boolean} isExcelFormat - Specifies format value to be converted to excel pattern.
     * @returns {string} ?
     * @private
     */ Internationalization.prototype.getDatePattern = function(option, isExcelFormat) {
        return (0, $fW217.IntlBase).getActualDateTimeFormat(this.getCulture(), option, $8b237f71e4fde58a$export$8be2398a1573b5d4, isExcelFormat);
    };
    /**
     * Returns Native Number Pattern
     *
     * @param {NumberFormatOptions} option - Specifies the parse options for resultant number pattern.
     * @param {boolean} isExcel ?
     * @returns {string} ?
     * @private
     */ Internationalization.prototype.getNumberPattern = function(option, isExcel) {
        return (0, $fW217.IntlBase).getActualNumberFormat(this.getCulture(), option, $8b237f71e4fde58a$export$8be2398a1573b5d4, isExcel);
    };
    /**
     * Returns the First Day of the Week
     *
     * @returns {number} ?
     */ Internationalization.prototype.getFirstDayOfWeek = function() {
        return (0, $fW217.IntlBase).getWeekData(this.getCulture(), $8b237f71e4fde58a$export$8be2398a1573b5d4);
    };
    /**
     * Returns the culture
     *
     * @returns {string} ?
     */ Internationalization.prototype.getCulture = function() {
        return this.culture || $8b237f71e4fde58a$export$36370df3ec99cb02;
    };
    return Internationalization;
}();
function $8b237f71e4fde58a$export$5f938ff33579cc37(cultureName) {
    $8b237f71e4fde58a$export$36370df3ec99cb02 = cultureName;
    $8b237f71e4fde58a$export$6cb311ccccf7da2e.notify("notifyExternalChange", {
        "locale": $8b237f71e4fde58a$export$36370df3ec99cb02
    });
}
function $8b237f71e4fde58a$export$277db127882ac43f(currencyCode) {
    $8b237f71e4fde58a$export$aa953ac971afd601 = currencyCode;
    $8b237f71e4fde58a$export$6cb311ccccf7da2e.notify("notifyExternalChange", {
        "currencyCode": $8b237f71e4fde58a$export$aa953ac971afd601
    });
}
function $8b237f71e4fde58a$export$dd23409118f58879() {
    var data = [];
    for(var _i = 0; _i < arguments.length; _i++)data[_i] = arguments[_i];
    for(var _a = 0, data_1 = data; _a < data_1.length; _a++){
        var obj = data_1[_a];
        (0, $3EnZW.extend)($8b237f71e4fde58a$export$8be2398a1573b5d4, obj, {}, true);
    }
}
function $8b237f71e4fde58a$export$7dc0a9943bfc98f(status) {
    if (status === void 0) status = true;
    $8b237f71e4fde58a$export$c743977d24bad607 = status;
    $8b237f71e4fde58a$export$6cb311ccccf7da2e.notify("notifyExternalChange", {
        enableRtl: $8b237f71e4fde58a$export$c743977d24bad607
    });
}
function $8b237f71e4fde58a$export$52fad96a73de9753(locale, type) {
    var numObject = (0, $fW217.IntlBase).getDependables($8b237f71e4fde58a$export$8be2398a1573b5d4, locale, "", true)[$8b237f71e4fde58a$var$mapper[0]];
    var dateObject = (0, $fW217.IntlBase).getDependables($8b237f71e4fde58a$export$8be2398a1573b5d4, locale, "")[$8b237f71e4fde58a$var$mapper[1]];
    var numSystem = (0, $3EnZW.getValue)("defaultNumberingSystem", numObject);
    var symbPattern = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("numberSymbols", numObject) : (0, $3EnZW.getValue)("symbols-numberSystem-" + numSystem, numObject);
    var pattern = (0, $fW217.IntlBase).getSymbolPattern(type || "decimal", numSystem, numObject, false);
    return (0, $3EnZW.extend)(symbPattern, (0, $fW217.IntlBase).getFormatData(pattern, true, "", true), {
        "dateSeparator": (0, $fW217.IntlBase).getDateSeparator(dateObject)
    });
}
function $8b237f71e4fde58a$export$7ad9e6870c1cdfd(locale, currency) {
    var numObject = (0, $fW217.IntlBase).getDependables($8b237f71e4fde58a$export$8be2398a1573b5d4, locale, "", true);
    return (0, $fW217.IntlBase).getCurrencySymbol(numObject.numericObject, currency);
}
function $8b237f71e4fde58a$export$23f51f10e3a8a34a(mode) {
    return (0, $fW217.IntlBase).getDependables($8b237f71e4fde58a$export$8be2398a1573b5d4, "", mode, false)[$8b237f71e4fde58a$var$mapper[1]];
}

});
parcelRegister("c2qRe", function(module, exports) {

$parcel$export(module.exports, "datePartMatcher", () => $8c3a81495963eb22$export$50b9976ce17a3e0b);
$parcel$export(module.exports, "DateFormat", () => $8c3a81495963eb22$export$50a48c78a350e041);

var $3amEA = parcelRequire("3amEA");

var $fW217 = parcelRequire("fW217");

var $3EnZW = parcelRequire("3EnZW");

var $33VE1 = parcelRequire("33VE1");
var $8c3a81495963eb22$var$abbreviateRegexGlobal = /\/MMMMM|MMMM|MMM|a|LLLL|LLL|EEEEE|EEEE|E|K|cccc|ccc|WW|W|G+|z+/gi;
var $8c3a81495963eb22$var$standalone = "stand-alone";
var $8c3a81495963eb22$var$weekdayKey = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
var $8c3a81495963eb22$export$556aadbe6d1118bb = [
    "short",
    "medium",
    "long",
    "full"
];
var $8c3a81495963eb22$var$timeSetter = {
    m: "getMinutes",
    h: "getHours",
    H: "getHours",
    s: "getSeconds",
    d: "getDate",
    f: "getMilliseconds"
};
var $8c3a81495963eb22$export$50b9976ce17a3e0b = {
    "M": "month",
    "d": "day",
    "E": "weekday",
    "c": "weekday",
    "y": "year",
    "m": "minute",
    "h": "hour",
    "H": "hour",
    "s": "second",
    "L": "month",
    "a": "designator",
    "z": "timeZone",
    "Z": "timeZone",
    "G": "era",
    "f": "milliseconds"
};
var $8c3a81495963eb22$var$timeSeparator = "timeSeparator";
/**
 * Date Format is a framework provides support for date formatting.
 *
 * @private
 */ var $8c3a81495963eb22$export$50a48c78a350e041 = /** @class */ function() {
    function DateFormat() {}
    /**
     * Returns the formatter function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {DateFormatOptions} option - Specific the format in which date  will format.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */ DateFormat.dateFormat = function(culture, option, cldr) {
        var _this = this;
        var dependable = (0, $fW217.IntlBase).getDependables(cldr, culture, option.calendar);
        var numObject = (0, $3EnZW.getValue)("parserObject.numbers", dependable);
        var dateObject = dependable.dateObject;
        var formatOptions = {
            isIslamic: (0, $fW217.IntlBase).islamicRegex.test(option.calendar)
        };
        if ((0, $3EnZW.isBlazor)() && option.isServerRendered) option = (0, $fW217.IntlBase).compareBlazorDateFormats(option, culture);
        var resPattern = option.format || (0, $fW217.IntlBase).getResultantPattern(option.skeleton, dependable.dateObject, option.type, false, (0, $3EnZW.isBlazor)() ? culture : "");
        formatOptions.dateSeperator = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("dateSeperator", dateObject) : (0, $fW217.IntlBase).getDateSeparator(dependable.dateObject);
        if ((0, $3EnZW.isUndefined)(resPattern)) (0, $3EnZW.throwError)("Format options or type given must be invalid");
        else {
            resPattern = (0, $fW217.IntlBase).ConvertDateToWeekFormat(resPattern);
            if ((0, $3EnZW.isBlazor)()) resPattern = resPattern.replace(/tt/, "a");
            formatOptions.pattern = resPattern;
            formatOptions.numMapper = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.extend)({}, numObject) : (0, $3amEA.ParserBase).getNumberMapper(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr));
            var patternMatch = resPattern.match($8c3a81495963eb22$var$abbreviateRegexGlobal) || [];
            for(var _i = 0, patternMatch_1 = patternMatch; _i < patternMatch_1.length; _i++){
                var str = patternMatch_1[_i];
                var len = str.length;
                var char = str[0];
                if (char === "K") char = "h";
                switch(char){
                    case "E":
                    case "c":
                        if ((0, $3EnZW.isBlazor)()) formatOptions.weekday = (0, $3EnZW.getValue)("days." + (0, $fW217.IntlBase).monthIndex["" + len], dateObject);
                        else formatOptions.weekday = dependable.dateObject["" + (0, $fW217.IntlBase).days]["" + $8c3a81495963eb22$var$standalone][(0, $fW217.IntlBase).monthIndex["" + len]];
                        break;
                    case "M":
                    case "L":
                        if ((0, $3EnZW.isBlazor)()) formatOptions.month = (0, $3EnZW.getValue)("months." + (0, $fW217.IntlBase).monthIndex["" + len], dateObject);
                        else formatOptions.month = dependable.dateObject["" + (0, $fW217.IntlBase).month]["" + $8c3a81495963eb22$var$standalone][(0, $fW217.IntlBase).monthIndex["" + len]];
                        break;
                    case "a":
                        formatOptions.designator = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("dayPeriods", dateObject) : (0, $3EnZW.getValue)("dayPeriods.format.wide", dateObject);
                        break;
                    case "G":
                        var eText = len <= 3 ? "eraAbbr" : len === 4 ? "eraNames" : "eraNarrow";
                        formatOptions.era = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("eras", dateObject) : (0, $3EnZW.getValue)("eras." + eText, dependable.dateObject);
                        break;
                    case "z":
                        formatOptions.timeZone = (0, $3EnZW.getValue)("dates.timeZoneNames", dependable.parserObject);
                        break;
                }
            }
        }
        return function(value) {
            if (isNaN(value.getDate())) return null;
            return _this.intDateFormatter(value, formatOptions);
        };
    };
    /**
     * Returns formatted date string based on options passed.
     *
     * @param {Date} value ?
     * @param {FormatOptions} options ?
     * @returns {string} ?
     */ DateFormat.intDateFormatter = function(value, options) {
        var pattern = options.pattern;
        var ret = "";
        var matches = pattern.match((0, $fW217.IntlBase).dateParseRegex);
        var dObject = this.getCurrentDateValue(value, options.isIslamic);
        for(var _i = 0, matches_1 = matches; _i < matches_1.length; _i++){
            var match = matches_1[_i];
            var length_1 = match.length;
            var char = match[0];
            if (char === "K") char = "h";
            var curval = void 0;
            var curvalstr = "";
            var isNumber = void 0;
            var processNumber = void 0;
            var curstr = "";
            switch(char){
                case "M":
                case "L":
                    curval = dObject.month;
                    if (length_1 > 2) ret += options.month["" + curval];
                    else isNumber = true;
                    break;
                case "E":
                case "c":
                    ret += options.weekday["" + $8c3a81495963eb22$var$weekdayKey[value.getDay()]];
                    break;
                case "H":
                case "h":
                case "m":
                case "s":
                case "d":
                case "f":
                    isNumber = true;
                    if (char === "d") curval = dObject.date;
                    else if (char === "f") {
                        isNumber = false;
                        processNumber = true;
                        curvalstr = value["" + $8c3a81495963eb22$var$timeSetter["" + char]]().toString();
                        curvalstr = curvalstr.substring(0, length_1);
                        var curlength = curvalstr.length;
                        if (length_1 !== curlength) {
                            if (length_1 > 3) continue;
                            for(var i = 0; i < length_1 - curlength; i++)curvalstr = "0" + curvalstr.toString();
                        }
                        curstr += curvalstr;
                    } else curval = value["" + $8c3a81495963eb22$var$timeSetter["" + char]]();
                    if (char === "h") curval = curval % 12 || 12;
                    break;
                case "y":
                    processNumber = true;
                    curstr += dObject.year;
                    if (length_1 === 2) curstr = curstr.substr(curstr.length - 2);
                    break;
                case "a":
                    var desig = value.getHours() < 12 ? "am" : "pm";
                    ret += options.designator["" + desig];
                    break;
                case "G":
                    var dec = value.getFullYear() < 0 ? 0 : 1;
                    var retu = options.era["" + dec];
                    if ((0, $3EnZW.isNullOrUndefined)(retu)) retu = options.era[dec ? 0 : 1];
                    ret += retu || "";
                    break;
                case "'":
                    ret += match === "''" ? "'" : match.replace(/'/g, "");
                    break;
                case "z":
                    var timezone = value.getTimezoneOffset();
                    var pattern_1 = length_1 < 4 ? "+H;-H" : options.timeZone.hourFormat;
                    pattern_1 = pattern_1.replace(/:/g, options.numMapper.timeSeparator);
                    if (timezone === 0) ret += options.timeZone.gmtZeroFormat;
                    else {
                        processNumber = true;
                        curstr = this.getTimeZoneValue(timezone, pattern_1);
                    }
                    curstr = options.timeZone.gmtFormat.replace(/\{0\}/, curstr);
                    break;
                case ":":
                    ret += options.numMapper.numberSymbols["" + $8c3a81495963eb22$var$timeSeparator];
                    break;
                case "/":
                    ret += options.dateSeperator;
                    break;
                case "W":
                    isNumber = true;
                    curval = (0, $fW217.IntlBase).getWeekOfYear(value);
                    break;
                default:
                    ret += match;
            }
            if (isNumber) {
                processNumber = true;
                curstr = this.checkTwodigitNumber(curval, length_1);
            }
            if (processNumber) ret += (0, $3amEA.ParserBase).convertValueParts(curstr, (0, $fW217.IntlBase).latnParseRegex, options.numMapper.mapper);
        }
        return ret;
    };
    DateFormat.getCurrentDateValue = function(value, isIslamic) {
        if (isIslamic) return (0, $33VE1.HijriParser).getHijriDate(value);
        return {
            year: value.getFullYear(),
            month: value.getMonth() + 1,
            date: value.getDate()
        };
    };
    /**
     * Returns two digit numbers for given value and length
     *
     * @param {number} val ?
     * @param {number} len ?
     * @returns {string} ?
     */ DateFormat.checkTwodigitNumber = function(val, len) {
        var ret = val + "";
        if (len === 2 && ret.length !== 2) return "0" + ret;
        return ret;
    };
    /**
     * Returns the value of the Time Zone.
     *
     * @param {number} tVal ?
     * @param {string} pattern ?
     * @returns {string} ?
     * @private
     */ DateFormat.getTimeZoneValue = function(tVal, pattern) {
        var _this = this;
        var splt = pattern.split(";");
        var curPattern = splt[tVal > 0 ? 1 : 0];
        var no = Math.abs(tVal);
        return curPattern = curPattern.replace(/HH?|mm/g, function(str) {
            var len = str.length;
            var ishour = str.indexOf("H") !== -1;
            return _this.checkTwodigitNumber(Math.floor(ishour ? no / 60 : no % 60), len);
        });
    };
    return DateFormat;
}();

});
parcelRegister("3amEA", function(module, exports) {

$parcel$export(module.exports, "ParserBase", () => $24e3e0d1e5ec3825$export$bc74647fe4d8988a);
$parcel$export(module.exports, "getBlazorCurrencySymbol", () => $24e3e0d1e5ec3825$export$594748e4d9a897be);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Parser
 */ 
var $3EnZW = parcelRequire("3EnZW");
var $24e3e0d1e5ec3825$var$defaultNumberingSystem = {
    "latn": {
        "_digits": "0123456789",
        "_type": "numeric"
    }
};
var $24e3e0d1e5ec3825$var$defaultNumberSymbols = {
    "decimal": ".",
    "group": ",",
    "percentSign": "%",
    "plusSign": "+",
    "minusSign": "-",
    "infinity": "\u221E",
    "nan": "NaN",
    "exponential": "E"
};
var $24e3e0d1e5ec3825$var$latnNumberSystem = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9
];
/**
 * Interface for parser base
 *
 * @private
 */ var $24e3e0d1e5ec3825$export$bc74647fe4d8988a = /** @class */ function() {
    function ParserBase() {}
    /**
     * Returns the cldr object for the culture specifies
     *
     * @param {Object} obj - Specifies the object from which culture object to be acquired.
     * @param {string} cName - Specifies the culture name.
     * @returns {Object} ?
     */ ParserBase.getMainObject = function(obj, cName) {
        var value = (0, $3EnZW.isBlazor)() ? cName : "main." + cName;
        return (0, $3EnZW.getValue)(value, obj);
    };
    /**
     * Returns the numbering system object from given cldr data.
     *
     * @param {Object} obj - Specifies the object from which number system is acquired.
     * @returns {Object} ?
     */ ParserBase.getNumberingSystem = function(obj) {
        return (0, $3EnZW.getValue)("supplemental.numberingSystems", obj) || this.numberingSystems;
    };
    /**
     * Returns the reverse of given object keys or keys specified.
     *
     * @param {Object} prop - Specifies the object to be reversed.
     * @param {number[]} keys - Optional parameter specifies the custom keyList for reversal.
     * @returns {Object} ?
     */ ParserBase.reverseObject = function(prop, keys) {
        var propKeys = keys || Object.keys(prop);
        var res = {};
        for(var _i = 0, propKeys_1 = propKeys; _i < propKeys_1.length; _i++){
            var key = propKeys_1[_i];
            if (!Object.prototype.hasOwnProperty.call(res, prop["" + key])) res[prop["" + key]] = key;
        }
        return res;
    };
    /**
     * Returns the symbol regex by skipping the escape sequence.
     *
     * @param {string[]} props - Specifies the array values to be skipped.
     * @returns {RegExp} ?
     */ ParserBase.getSymbolRegex = function(props) {
        var regexStr = props.map(function(str) {
            return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
        }).join("|");
        var regExp = RegExp;
        return new regExp(regexStr, "g");
    };
    /**
     *
     * @param {Object} prop ?
     * @returns {Object} ?
     */ ParserBase.getSymbolMatch = function(prop) {
        var matchKeys = Object.keys($24e3e0d1e5ec3825$var$defaultNumberSymbols);
        var ret = {};
        for(var _i = 0, matchKeys_1 = matchKeys; _i < matchKeys_1.length; _i++){
            var key = matchKeys_1[_i];
            ret[prop["" + key]] = $24e3e0d1e5ec3825$var$defaultNumberSymbols["" + key];
        }
        return ret;
    };
    /**
     * Returns regex string for provided value
     *
     * @param {string} val ?
     * @returns {string} ?
     */ ParserBase.constructRegex = function(val) {
        var len = val.length;
        var ret = "";
        for(var i = 0; i < len; i++)if (i !== len - 1) ret += val[parseInt(i.toString(), 10)] + "|";
        else ret += val[parseInt(i.toString(), 10)];
        return ret;
    };
    /**
     * Returns the replaced value of matching regex and obj mapper.
     *
     * @param {string} value - Specifies the  values to be replaced.
     * @param {RegExp} regex - Specifies the  regex to search.
     * @param {Object} obj - Specifies the  object matcher to be replace value parts.
     * @returns {string} ?
     */ ParserBase.convertValueParts = function(value, regex, obj) {
        return value.replace(regex, function(str) {
            return obj["" + str];
        });
    };
    /**
     * Returns default numbering system object for formatting from cldr data
     *
     * @param {Object} obj ?
     * @returns {NumericObject} ?
     */ ParserBase.getDefaultNumberingSystem = function(obj) {
        var ret = {};
        ret.obj = (0, $3EnZW.getValue)("numbers", obj);
        ret.nSystem = (0, $3EnZW.getValue)("defaultNumberingSystem", ret.obj);
        return ret;
    };
    /**
     * Returns the replaced value of matching regex and obj mapper.
     *
     * @param {Object} curObj ?
     * @param {Object} numberSystem ?
     * @param {boolean} needSymbols ?
     * @param {boolean} blazorMode ?
     * @returns {Object} ?
     */ ParserBase.getCurrentNumericOptions = function(curObj, numberSystem, needSymbols, blazorMode) {
        var ret = {};
        var cur = this.getDefaultNumberingSystem(curObj);
        if (!(0, $3EnZW.isUndefined)(cur.nSystem) || blazorMode) {
            var digits = blazorMode ? (0, $3EnZW.getValue)("obj.mapperDigits", cur) : (0, $3EnZW.getValue)(cur.nSystem + "._digits", numberSystem);
            if (!(0, $3EnZW.isUndefined)(digits)) {
                ret.numericPair = this.reverseObject(digits, $24e3e0d1e5ec3825$var$latnNumberSystem);
                var regExp = RegExp;
                ret.numberParseRegex = new regExp(this.constructRegex(digits), "g");
                ret.numericRegex = "[" + digits[0] + "-" + digits[9] + "]";
                if (needSymbols) {
                    ret.numericRegex = digits[0] + "-" + digits[9];
                    ret.symbolNumberSystem = (0, $3EnZW.getValue)(blazorMode ? "numberSymbols" : "symbols-numberSystem-" + cur.nSystem, cur.obj);
                    ret.symbolMatch = this.getSymbolMatch(ret.symbolNumberSystem);
                    ret.numberSystem = cur.nSystem;
                }
            }
        }
        return ret;
    };
    /**
     * Returns number mapper object for the provided cldr data
     *
     * @param {Object} curObj ?
     * @param {Object} numberSystem ?
     * @param {boolean} isNumber ?
     * @returns {NumberMapper} ?
     */ ParserBase.getNumberMapper = function(curObj, numberSystem, isNumber) {
        var ret = {
            mapper: {}
        };
        var cur = this.getDefaultNumberingSystem(curObj);
        if (!(0, $3EnZW.isUndefined)(cur.nSystem)) {
            ret.numberSystem = cur.nSystem;
            ret.numberSymbols = (0, $3EnZW.getValue)("symbols-numberSystem-" + cur.nSystem, cur.obj);
            ret.timeSeparator = (0, $3EnZW.getValue)("timeSeparator", ret.numberSymbols);
            var digits = (0, $3EnZW.getValue)(cur.nSystem + "._digits", numberSystem);
            if (!(0, $3EnZW.isUndefined)(digits)) for(var _i = 0, latnNumberSystem_1 = $24e3e0d1e5ec3825$var$latnNumberSystem; _i < latnNumberSystem_1.length; _i++){
                var i = latnNumberSystem_1[_i];
                ret.mapper[parseInt(i.toString(), 10)] = digits[parseInt(i.toString(), 10)];
            }
        }
        return ret;
    };
    ParserBase.nPair = "numericPair";
    ParserBase.nRegex = "numericRegex";
    ParserBase.numberingSystems = $24e3e0d1e5ec3825$var$defaultNumberingSystem;
    return ParserBase;
}();
/**
 * @private
 */ var $24e3e0d1e5ec3825$var$blazorCurrencyData = {
    "DJF": "Fdj",
    "ERN": "Nfk",
    "ETB": "Br",
    "NAD": "$",
    "ZAR": "R",
    "XAF": "FCFA",
    "GHS": "GH\u20B5",
    "XDR": "XDR",
    "AED": "\u062F.\u0625.",
    "BHD": "\u062F.\u0628.",
    "DZD": "\u062F.\u062C.",
    "EGP": "\u062C.\u0645.",
    "ILS": "\u20AA",
    "IQD": "\u062F.\u0639.",
    "JOD": "\u062F.\u0627.",
    "KMF": "CF",
    "KWD": "\u062F.\u0643.",
    "LBP": "\u0644.\u0644.",
    "LYD": "\u062F.\u0644.",
    "MAD": "\u062F.\u0645.",
    "MRU": "\u0623.\u0645.",
    "OMR": "\u0631.\u0639.",
    "QAR": "\u0631.\u0642.",
    "SAR": "\u0631.\u0633.",
    "SDG": "\u062C.\u0633.",
    "SOS": "S",
    "SSP": "\xa3",
    "SYP": "\u0644.\u0633.",
    "TND": "\u062F.\u062A.",
    "YER": "\u0631.\u064A.",
    "CLP": "$",
    "INR": "\u20B9",
    "TZS": "TSh",
    "EUR": "\u20AC",
    "AZN": "\u20BC",
    "RUB": "\u20BD",
    "BYN": "Br",
    "ZMW": "K",
    "BGN": "\u043B\u0432.",
    "NGN": "\u20A6",
    "XOF": "CFA",
    "BDT": "\u09F3",
    "CNY": "\xa5",
    "BAM": "\u041A\u041C",
    "UGX": "USh",
    "USD": "$",
    "CZK": "K\u010D",
    "GBP": "\xa3",
    "DKK": "kr.",
    "KES": "Ksh",
    "CHF": "CHF",
    "MVR": "\u0783.",
    "BTN": "Nu.",
    "XCD": "EC$",
    "AUD": "$",
    "BBD": "$",
    "BIF": "FBu",
    "BMD": "$",
    "BSD": "$",
    "BWP": "P",
    "BZD": "$",
    "CAD": "$",
    "NZD": "$",
    "FJD": "$",
    "FKP": "\xa3",
    "GIP": "\xa3",
    "GMD": "D",
    "GYD": "$",
    "HKD": "$",
    "IDR": "Rp",
    "JMD": "$",
    "KYD": "$",
    "LRD": "$",
    "MGA": "Ar",
    "MOP": "MOP$",
    "MUR": "Rs",
    "MWK": "MK",
    "MYR": "RM",
    "PGK": "K",
    "PHP": "\u20B1",
    "PKR": "Rs",
    "RWF": "RF",
    "SBD": "$",
    "SCR": "SR",
    "SEK": "kr",
    "SGD": "$",
    "SHP": "\xa3",
    "SLL": "Le",
    "ANG": "NAf.",
    "SZL": "E",
    "TOP": "T$",
    "TTD": "$",
    "VUV": "VT",
    "WST": "WS$",
    "ARS": "$",
    "BOB": "Bs",
    "BRL": "R$",
    "COP": "$",
    "CRC": "\u20A1",
    "CUP": "$",
    "DOP": "$",
    "GTQ": "Q",
    "HNL": "L",
    "MXN": "$",
    "NIO": "C$",
    "PAB": "B/.",
    "PEN": "S/",
    "PYG": "\u20B2",
    "UYU": "$",
    "VES": "Bs.S",
    "IRR": "\u0631\u064A\u0627\u0644",
    "GNF": "FG",
    "CDF": "FC",
    "HTG": "G",
    "XPF": "FCFP",
    "HRK": "kn",
    "HUF": "Ft",
    "AMD": "\u058F",
    "ISK": "kr",
    "JPY": "\xa5",
    "GEL": "\u20BE",
    "CVE": "\u200B",
    "KZT": "\u20B8",
    "KHR": "\u17DB",
    "KPW": "\u20A9",
    "KRW": "\u20A9",
    "KGS": "\u0441\u043E\u043C",
    "AOA": "Kz",
    "LAK": "\u20AD",
    "MZN": "MTn",
    "MKD": "\u0434\u0435\u043D",
    "MNT": "\u20AE",
    "BND": "$",
    "MMK": "K",
    "NOK": "kr",
    "NPR": "\u0930\u0941",
    "AWG": "Afl.",
    "SRD": "$",
    "PLN": "z\u0142",
    "AFN": "\u060B",
    "STN": "Db",
    "MDL": "L",
    "RON": "lei",
    "UAH": "\u20B4",
    "LKR": "\u0DBB\u0DD4.",
    "ALL": "Lek\xeb",
    "RSD": "\u0434\u0438\u043D.",
    "TJS": "\u0441\u043C\u043D",
    "THB": "\u0E3F",
    "TMT": "m.",
    "TRY": "\u20BA",
    "UZS": "\u0441\u045E\u043C",
    "VND": "\u20AB",
    "TWD": "NT$"
};
function $24e3e0d1e5ec3825$export$594748e4d9a897be(currencyCode) {
    return (0, $3EnZW.getValue)(currencyCode || "", $24e3e0d1e5ec3825$var$blazorCurrencyData);
}

});
parcelRegister("3EnZW", function(module, exports) {

$parcel$export(module.exports, "createInstance", () => $2a87b90894913ed3$export$99152e8d49ca4e7d);
$parcel$export(module.exports, "setImmediate", () => $2a87b90894913ed3$export$c233f08fbfea0913);
$parcel$export(module.exports, "getValue", () => $2a87b90894913ed3$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "isUndefined", () => $2a87b90894913ed3$export$fce6876652108ab);
$parcel$export(module.exports, "setValue", () => $2a87b90894913ed3$export$80746c6bc6142fc8);
$parcel$export(module.exports, "isNullOrUndefined", () => $2a87b90894913ed3$export$bedb7023a7733221);
$parcel$export(module.exports, "deleteObject", () => $2a87b90894913ed3$export$39c5ed4ec960eade);
$parcel$export(module.exports, "containerObject", () => $2a87b90894913ed3$export$c52f423641a639e4);
$parcel$export(module.exports, "isObject", () => $2a87b90894913ed3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "getEnumValue", () => $2a87b90894913ed3$export$88629b022399495f);
$parcel$export(module.exports, "merge", () => $2a87b90894913ed3$export$4950aa0f605343fb);
$parcel$export(module.exports, "extend", () => $2a87b90894913ed3$export$8b58be045bf06082);
$parcel$export(module.exports, "isBlazor", () => $2a87b90894913ed3$export$2f7332c6737fa425);
$parcel$export(module.exports, "getUniqueID", () => $2a87b90894913ed3$export$b8ba5815f1bdad68);
$parcel$export(module.exports, "debounce", () => $2a87b90894913ed3$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "compareElementParent", () => $2a87b90894913ed3$export$1e556338240d8ca1);
$parcel$export(module.exports, "throwError", () => $2a87b90894913ed3$export$8bf7aba4a9e09055);
$parcel$export(module.exports, "print", () => $2a87b90894913ed3$export$c2d084dc44961371);
$parcel$export(module.exports, "formatUnit", () => $2a87b90894913ed3$export$fab59da06805c4ec);
$parcel$export(module.exports, "getElement", () => $2a87b90894913ed3$export$d16800b7e59a8051);
$parcel$export(module.exports, "getInstance", () => $2a87b90894913ed3$export$8bedcca5bbd73999);
$parcel$export(module.exports, "uniqueID", () => $2a87b90894913ed3$export$89912e019eef22aa);
var $2a87b90894913ed3$var$instances = "ej2_instances";
var $2a87b90894913ed3$var$uid = 0;
var $2a87b90894913ed3$var$isBlazorPlatform = false;
function $2a87b90894913ed3$export$11d7b4b3d0f490a2() {
    $2a87b90894913ed3$var$isBlazorPlatform = false;
}
function $2a87b90894913ed3$export$99152e8d49ca4e7d(classFunction, params) {
    var arrayParam = params;
    arrayParam.unshift(undefined);
    return new (Function.prototype.bind.apply(classFunction, arrayParam));
}
function $2a87b90894913ed3$export$c233f08fbfea0913(handler) {
    var unbind;
    var num = new Uint16Array(5);
    var intCrypto = window.msCrypto || window.crypto;
    intCrypto.getRandomValues(num);
    var secret = "ej2" + $2a87b90894913ed3$var$combineArray(num);
    var messageHandler = function(event) {
        if (event.source === window && typeof event.data === "string" && event.data.length <= 32 && event.data === secret) {
            handler();
            unbind();
        }
    };
    window.addEventListener("message", messageHandler, false);
    window.postMessage(secret, "*");
    return unbind = function() {
        window.removeEventListener("message", messageHandler);
        handler = messageHandler = secret = undefined;
    };
}
function $2a87b90894913ed3$export$bf7199a9ebcb84a9(nameSpace, obj) {
    var value = obj;
    var splits = nameSpace.replace(/\[/g, ".").replace(/\]/g, "").split(".");
    for(var i = 0; i < splits.length && !$2a87b90894913ed3$export$fce6876652108ab(value); i++)value = value[splits[parseInt(i.toString(), 10)]];
    return value;
}
function $2a87b90894913ed3$export$80746c6bc6142fc8(nameSpace, value, obj) {
    var keys = nameSpace.replace(/\[/g, ".").replace(/\]/g, "").split(".");
    var start = obj || {};
    var fromObj = start;
    var i;
    var length = keys.length;
    var key;
    for(i = 0; i < length; i++){
        key = keys[parseInt(i.toString(), 10)];
        if (i + 1 === length) fromObj["" + key] = value === undefined ? {} : value;
        else if ($2a87b90894913ed3$export$bedb7023a7733221(fromObj["" + key])) fromObj["" + key] = {};
        fromObj = fromObj["" + key];
    }
    return start;
}
function $2a87b90894913ed3$export$39c5ed4ec960eade(obj, key) {
    delete obj["" + key];
}
var $2a87b90894913ed3$export$c52f423641a639e4 = typeof window !== "undefined" ? window : {};
function $2a87b90894913ed3$export$a6cdc56e425d0d0a(obj) {
    var objCon = {};
    return !$2a87b90894913ed3$export$bedb7023a7733221(obj) && obj.constructor === objCon.constructor;
}
function $2a87b90894913ed3$export$88629b022399495f(enumObject, enumValue) {
    return enumObject["" + enumValue];
}
function $2a87b90894913ed3$export$4950aa0f605343fb(source, destination) {
    if (!$2a87b90894913ed3$export$bedb7023a7733221(destination)) {
        var temrObj = source;
        var tempProp = destination;
        var keys = Object.keys(destination);
        var deepmerge = "deepMerge";
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (!$2a87b90894913ed3$export$bedb7023a7733221(temrObj["" + deepmerge]) && temrObj["" + deepmerge].indexOf(key) !== -1 && ($2a87b90894913ed3$export$a6cdc56e425d0d0a(tempProp["" + key]) || Array.isArray(tempProp["" + key]))) $2a87b90894913ed3$export$8b58be045bf06082(temrObj["" + key], temrObj["" + key], tempProp["" + key], true);
            else temrObj["" + key] = tempProp["" + key];
        }
    }
}
function $2a87b90894913ed3$export$8b58be045bf06082(copied, first, second, deep) {
    var result = copied && typeof copied === "object" ? copied : {};
    var length = arguments.length;
    var args = [
        copied,
        first,
        second,
        deep
    ];
    if (deep) length = length - 1;
    var _loop_1 = function(i) {
        if (!args[parseInt(i.toString(), 10)]) return "continue";
        var obj1 = args[parseInt(i.toString(), 10)];
        Object.keys(obj1).forEach(function(key) {
            var src = result["" + key];
            var copy = obj1["" + key];
            var clone;
            var isArrayChanged = Array.isArray(copy) && Array.isArray(src) && copy.length !== src.length;
            var blazorEventExtend = $2a87b90894913ed3$export$2f7332c6737fa425() ? !(src instanceof Event) && !isArrayChanged : true;
            if (deep && blazorEventExtend && ($2a87b90894913ed3$export$a6cdc56e425d0d0a(copy) || Array.isArray(copy))) {
                if ($2a87b90894913ed3$export$a6cdc56e425d0d0a(copy)) {
                    clone = src ? src : {};
                    if (Array.isArray(clone) && Object.prototype.hasOwnProperty.call(clone, "isComplexArray")) $2a87b90894913ed3$export$8b58be045bf06082(clone, {}, copy, deep);
                    else result["" + key] = $2a87b90894913ed3$export$8b58be045bf06082(clone, {}, copy, deep);
                } else {
                    /* istanbul ignore next */ clone = $2a87b90894913ed3$export$2f7332c6737fa425() ? src && Object.keys(copy).length : src ? src : [];
                    result["" + key] = $2a87b90894913ed3$export$8b58be045bf06082([], clone, copy, clone && clone.length || copy && copy.length);
                }
            } else result["" + key] = copy;
        });
    };
    for(var i = 1; i < length; i++)_loop_1(i);
    return result;
}
function $2a87b90894913ed3$export$bedb7023a7733221(value) {
    return value === undefined || value === null;
}
function $2a87b90894913ed3$export$fce6876652108ab(value) {
    return "undefined" === typeof value;
}
function $2a87b90894913ed3$export$b8ba5815f1bdad68(definedName) {
    return definedName + "_" + $2a87b90894913ed3$var$uid++;
}
function $2a87b90894913ed3$export$61fc7d43ac8f84b0(eventFunction, delay) {
    var out;
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var later = function() {
            out = null;
            return eventFunction.apply(_this, args);
        };
        clearTimeout(out);
        out = setTimeout(later, delay);
    };
}
function $2a87b90894913ed3$export$927398b1a07dc446(data) {
    var array = [];
    var keys = Object.keys(data);
    for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
        var key = keys_2[_i];
        array.push(encodeURIComponent(key) + "=" + encodeURIComponent("" + data["" + key]));
    }
    return array.join("&");
}
function $2a87b90894913ed3$export$37b8d83213de0f5f(value) {
    var parser = Object.prototype.toString;
    if (parser.call(value) === "[object Array]") {
        if (parser.call(value[0]) === "[object Object]") return true;
    }
    return false;
}
function $2a87b90894913ed3$export$1e556338240d8ca1(child, parent) {
    var node = child;
    if (node === parent) return true;
    else if (node === document || !node) return false;
    else return $2a87b90894913ed3$export$1e556338240d8ca1(node.parentNode, parent);
}
function $2a87b90894913ed3$export$8bf7aba4a9e09055(message) {
    try {
        throw new Error(message);
    } catch (e) {
        throw new Error(e.message + "\n" + e.stack);
    }
}
function $2a87b90894913ed3$export$c2d084dc44961371(element, printWindow) {
    var div = document.createElement("div");
    var links = [].slice.call(document.getElementsByTagName("head")[0].querySelectorAll("base, link, style"));
    var blinks = [].slice.call(document.getElementsByTagName("body")[0].querySelectorAll("link, style"));
    if (blinks.length) for(var l = 0, len = blinks.length; l < len; l++)links.push(blinks[parseInt(l.toString(), 10)]);
    var reference = "";
    if ($2a87b90894913ed3$export$bedb7023a7733221(printWindow)) printWindow = window.open("", "print", "height=452,width=1024,tabbar=no");
    div.appendChild(element.cloneNode(true));
    for(var i = 0, len = links.length; i < len; i++)reference += links[parseInt(i.toString(), 10)].outerHTML;
    printWindow.document.write("<!DOCTYPE html> <html><head>" + reference + "</head><body>" + div.innerHTML + "<script> (function() { window.ready = true; })(); </script>" + "</body></html>");
    printWindow.document.close();
    printWindow.focus();
    var interval = setInterval(function() {
        if (printWindow.ready) {
            printWindow.print();
            printWindow.close();
            clearInterval(interval);
        }
    }, 500);
    return printWindow;
}
function $2a87b90894913ed3$export$fab59da06805c4ec(value) {
    var result = value + "";
    if (result.match(/auto|cm|mm|in|px|pt|pc|%|em|ex|ch|rem|vw|vh|vmin|vmax/)) return result;
    return result + "px";
}
function $2a87b90894913ed3$export$6a9bddec62ed7e3a() {
    $2a87b90894913ed3$var$isBlazorPlatform = true;
}
function $2a87b90894913ed3$export$2f7332c6737fa425() {
    return $2a87b90894913ed3$var$isBlazorPlatform;
}
function $2a87b90894913ed3$export$d16800b7e59a8051(element) {
    var xPath = "xPath";
    if (!(element instanceof Node) && $2a87b90894913ed3$export$2f7332c6737fa425() && !$2a87b90894913ed3$export$bedb7023a7733221(element["" + xPath])) return document.evaluate(element["" + xPath], document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    return element;
}
function $2a87b90894913ed3$export$8bedcca5bbd73999(element, component) {
    var elem = typeof element === "string" ? document.querySelector(element) : element;
    if (elem["" + $2a87b90894913ed3$var$instances]) for(var _i = 0, _a = elem["" + $2a87b90894913ed3$var$instances]; _i < _a.length; _i++){
        var inst = _a[_i];
        if (inst instanceof component) return inst;
    }
    return null;
}
function $2a87b90894913ed3$export$a78fd88194b4f36a(element, instance) {
    var elem = typeof element === "string" ? document.querySelector(element) : element;
    if (elem["" + $2a87b90894913ed3$var$instances]) elem["" + $2a87b90894913ed3$var$instances].push(instance);
    else elem["" + $2a87b90894913ed3$var$instances] = [
        instance
    ];
}
function $2a87b90894913ed3$export$89912e019eef22aa() {
    if (typeof window === "undefined") return;
    var num = new Uint16Array(5);
    var intCrypto = window.msCrypto || window.crypto;
    return intCrypto.getRandomValues(num);
}
/**
 *
 * @param {Int16Array} num ?
 * @returns {string} ?
 */ function $2a87b90894913ed3$var$combineArray(num) {
    var ret = "";
    for(var i = 0; i < 5; i++)ret += (i ? "," : "") + num[parseInt(i.toString(), 10)];
    return ret;
}

});


parcelRegister("33VE1", function(module, exports) {

$parcel$export(module.exports, "HijriParser", () => $23ae5de8bbf2215e$export$db339ee551ee4934);
/***
 * Hijri parser
 */ // eslint-disable-next-line @typescript-eslint/no-namespace
var $23ae5de8bbf2215e$export$db339ee551ee4934;
(function(HijriParser) {
    var dateCorrection = [
        28607,
        28636,
        28665,
        28695,
        28724,
        28754,
        28783,
        28813,
        28843,
        28872,
        28901,
        28931,
        28960,
        28990,
        29019,
        29049,
        29078,
        29108,
        29137,
        29167,
        29196,
        29226,
        29255,
        29285,
        29315,
        29345,
        29375,
        29404,
        29434,
        29463,
        29492,
        29522,
        29551,
        29580,
        29610,
        29640,
        29669,
        29699,
        29729,
        29759,
        29788,
        29818,
        29847,
        29876,
        29906,
        29935,
        29964,
        29994,
        30023,
        30053,
        30082,
        30112,
        30141,
        30171,
        30200,
        30230,
        30259,
        30289,
        30318,
        30348,
        30378,
        30408,
        30437,
        30467,
        30496,
        30526,
        30555,
        30585,
        30614,
        30644,
        30673,
        30703,
        30732,
        30762,
        30791,
        30821,
        30850,
        30880,
        30909,
        30939,
        30968,
        30998,
        31027,
        31057,
        31086,
        31116,
        31145,
        31175,
        31204,
        31234,
        31263,
        31293,
        31322,
        31352,
        31381,
        31411,
        31441,
        31471,
        31500,
        31530,
        31559,
        31589,
        31618,
        31648,
        31676,
        31706,
        31736,
        31766,
        31795,
        31825,
        31854,
        31884,
        31913,
        31943,
        31972,
        32002,
        32031,
        32061,
        32090,
        32120,
        32150,
        32180,
        32209,
        32239,
        32268,
        32298,
        32327,
        32357,
        32386,
        32416,
        32445,
        32475,
        32504,
        32534,
        32563,
        32593,
        32622,
        32652,
        32681,
        32711,
        32740,
        32770,
        32799,
        32829,
        32858,
        32888,
        32917,
        32947,
        32976,
        33006,
        33035,
        33065,
        33094,
        33124,
        33153,
        33183,
        33213,
        33243,
        33272,
        33302,
        33331,
        33361,
        33390,
        33420,
        33450,
        33479,
        33509,
        33539,
        33568,
        33598,
        33627,
        33657,
        33686,
        33716,
        33745,
        33775,
        33804,
        33834,
        33863,
        33893,
        33922,
        33952,
        33981,
        34011,
        34040,
        34069,
        34099,
        34128,
        34158,
        34187,
        34217,
        34247,
        34277,
        34306,
        34336,
        34365,
        34395,
        34424,
        34454,
        34483,
        34512,
        34542,
        34571,
        34601,
        34631,
        34660,
        34690,
        34719,
        34749,
        34778,
        34808,
        34837,
        34867,
        34896,
        34926,
        34955,
        34985,
        35015,
        35044,
        35074,
        35103,
        35133,
        35162,
        35192,
        35222,
        35251,
        35280,
        35310,
        35340,
        35370,
        35399,
        35429,
        35458,
        35488,
        35517,
        35547,
        35576,
        35605,
        35635,
        35665,
        35694,
        35723,
        35753,
        35782,
        35811,
        35841,
        35871,
        35901,
        35930,
        35960,
        35989,
        36019,
        36048,
        36078,
        36107,
        36136,
        36166,
        36195,
        36225,
        36254,
        36284,
        36314,
        36343,
        36373,
        36403,
        36433,
        36462,
        36492,
        36521,
        36551,
        36580,
        36610,
        36639,
        36669,
        36698,
        36728,
        36757,
        36786,
        36816,
        36845,
        36875,
        36904,
        36934,
        36963,
        36993,
        37022,
        37052,
        37081,
        37111,
        37141,
        37170,
        37200,
        37229,
        37259,
        37288,
        37318,
        37347,
        37377,
        37406,
        37436,
        37465,
        37495,
        37524,
        37554,
        37584,
        37613,
        37643,
        37672,
        37701,
        37731,
        37760,
        37790,
        37819,
        37849,
        37878,
        37908,
        37938,
        37967,
        37997,
        38027,
        38056,
        38085,
        38115,
        38144,
        38174,
        38203,
        38233,
        38262,
        38292,
        38322,
        38351,
        38381,
        38410,
        38440,
        38469,
        38499,
        38528,
        38558,
        38587,
        38617,
        38646,
        38676,
        38705,
        38735,
        38764,
        38794,
        38823,
        38853,
        38882,
        38912,
        38941,
        38971,
        39001,
        39030,
        39059,
        39089,
        39118,
        39148,
        39178,
        39208,
        39237,
        39267,
        39297,
        39326,
        39355,
        39385,
        39414,
        39444,
        39473,
        39503,
        39532,
        39562,
        39592,
        39621,
        39650,
        39680,
        39709,
        39739,
        39768,
        39798,
        39827,
        39857,
        39886,
        39916,
        39946,
        39975,
        40005,
        40035,
        40064,
        40094,
        40123,
        40153,
        40182,
        40212,
        40241,
        40271,
        40300,
        40330,
        40359,
        40389,
        40418,
        40448,
        40477,
        40507,
        40536,
        40566,
        40595,
        40625,
        40655,
        40685,
        40714,
        40744,
        40773,
        40803,
        40832,
        40862,
        40892,
        40921,
        40951,
        40980,
        41009,
        41039,
        41068,
        41098,
        41127,
        41157,
        41186,
        41216,
        41245,
        41275,
        41304,
        41334,
        41364,
        41393,
        41422,
        41452,
        41481,
        41511,
        41540,
        41570,
        41599,
        41629,
        41658,
        41688,
        41718,
        41748,
        41777,
        41807,
        41836,
        41865,
        41894,
        41924,
        41953,
        41983,
        42012,
        42042,
        42072,
        42102,
        42131,
        42161,
        42190,
        42220,
        42249,
        42279,
        42308,
        42337,
        42367,
        42397,
        42426,
        42456,
        42485,
        42515,
        42545,
        42574,
        42604,
        42633,
        42662,
        42692,
        42721,
        42751,
        42780,
        42810,
        42839,
        42869,
        42899,
        42929,
        42958,
        42988,
        43017,
        43046,
        43076,
        43105,
        43135,
        43164,
        43194,
        43223,
        43253,
        43283,
        43312,
        43342,
        43371,
        43401,
        43430,
        43460,
        43489,
        43519,
        43548,
        43578,
        43607,
        43637,
        43666,
        43696,
        43726,
        43755,
        43785,
        43814,
        43844,
        43873,
        43903,
        43932,
        43962,
        43991,
        44021,
        44050,
        44080,
        44109,
        44139,
        44169,
        44198,
        44228,
        44258,
        44287,
        44317,
        44346,
        44375,
        44405,
        44434,
        44464,
        44493,
        44523,
        44553,
        44582,
        44612,
        44641,
        44671,
        44700,
        44730,
        44759,
        44788,
        44818,
        44847,
        44877,
        44906,
        44936,
        44966,
        44996,
        45025,
        45055,
        45084,
        45114,
        45143,
        45172,
        45202,
        45231,
        45261,
        45290,
        45320,
        45350,
        45380,
        45409,
        45439,
        45468,
        45498,
        45527,
        45556,
        45586,
        45615,
        45644,
        45674,
        45704,
        45733,
        45763,
        45793,
        45823,
        45852,
        45882,
        45911,
        45940,
        45970,
        45999,
        46028,
        46058,
        46088,
        46117,
        46147,
        46177,
        46206,
        46236,
        46265,
        46295,
        46324,
        46354,
        46383,
        46413,
        46442,
        46472,
        46501,
        46531,
        46560,
        46590,
        46620,
        46649,
        46679,
        46708,
        46738,
        46767,
        46797,
        46826,
        46856,
        46885,
        46915,
        46944,
        46974,
        47003,
        47033,
        47063,
        47092,
        47122,
        47151,
        47181,
        47210,
        47240,
        47269,
        47298,
        47328,
        47357,
        47387,
        47417,
        47446,
        47476,
        47506,
        47535,
        47565,
        47594,
        47624,
        47653,
        47682,
        47712,
        47741,
        47771,
        47800,
        47830,
        47860,
        47890,
        47919,
        47949,
        47978,
        48008,
        48037,
        48066,
        48096,
        48125,
        48155,
        48184,
        48214,
        48244,
        48273,
        48303,
        48333,
        48362,
        48392,
        48421,
        48450,
        48480,
        48509,
        48538,
        48568,
        48598,
        48627,
        48657,
        48687,
        48717,
        48746,
        48776,
        48805,
        48834,
        48864,
        48893,
        48922,
        48952,
        48982,
        49011,
        49041,
        49071,
        49100,
        49130,
        49160,
        49189,
        49218,
        49248,
        49277,
        49306,
        49336,
        49365,
        49395,
        49425,
        49455,
        49484,
        49514,
        49543,
        49573,
        49602,
        49632,
        49661,
        49690,
        49720,
        49749,
        49779,
        49809,
        49838,
        49868,
        49898,
        49927,
        49957,
        49986,
        50016,
        50045,
        50075,
        50104,
        50133,
        50163,
        50192,
        50222,
        50252,
        50281,
        50311,
        50340,
        50370,
        50400,
        50429,
        50459,
        50488,
        50518,
        50547,
        50576,
        50606,
        50635,
        50665,
        50694,
        50724,
        50754,
        50784,
        50813,
        50843,
        50872,
        50902,
        50931,
        50960,
        50990,
        51019,
        51049,
        51078,
        51108,
        51138,
        51167,
        51197,
        51227,
        51256,
        51286,
        51315,
        51345,
        51374,
        51403,
        51433,
        51462,
        51492,
        51522,
        51552,
        51582,
        51611,
        51641,
        51670,
        51699,
        51729,
        51758,
        51787,
        51816,
        51846,
        51876,
        51906,
        51936,
        51965,
        51995,
        52025,
        52054,
        52083,
        52113,
        52142,
        52171,
        52200,
        52230,
        52260,
        52290,
        52319,
        52349,
        52379,
        52408,
        52438,
        52467,
        52497,
        52526,
        52555,
        52585,
        52614,
        52644,
        52673,
        52703,
        52733,
        52762,
        52792,
        52822,
        52851,
        52881,
        52910,
        52939,
        52969,
        52998,
        53028,
        53057,
        53087,
        53116,
        53146,
        53176,
        53205,
        53235,
        53264,
        53294,
        53324,
        53353,
        53383,
        53412,
        53441,
        53471,
        53500,
        53530,
        53559,
        53589,
        53619,
        53648,
        53678,
        53708,
        53737,
        53767,
        53796,
        53825,
        53855,
        53884,
        53913,
        53943,
        53973,
        54003,
        54032,
        54062,
        54092,
        54121,
        54151,
        54180,
        54209,
        54239,
        54268,
        54297,
        54327,
        54357,
        54387,
        54416,
        54446,
        54476,
        54505,
        54535,
        54564,
        54593,
        54623,
        54652,
        54681,
        54711,
        54741,
        54770,
        54800,
        54830,
        54859,
        54889,
        54919,
        54948,
        54977,
        55007,
        55036,
        55066,
        55095,
        55125,
        55154,
        55184,
        55213,
        55243,
        55273,
        55302,
        55332,
        55361,
        55391,
        55420,
        55450,
        55479,
        55508,
        55538,
        55567,
        55597,
        55627,
        55657,
        55686,
        55716,
        55745,
        55775,
        55804,
        55834,
        55863,
        55892,
        55922,
        55951,
        55981,
        56011,
        56040,
        56070,
        56100,
        56129,
        56159,
        56188,
        56218,
        56247,
        56276,
        56306,
        56335,
        56365,
        56394,
        56424,
        56454,
        56483,
        56513,
        56543,
        56572,
        56601,
        56631,
        56660,
        56690,
        56719,
        56749,
        56778,
        56808,
        56837,
        56867,
        56897,
        56926,
        56956,
        56985,
        57015,
        57044,
        57074,
        57103,
        57133,
        57162,
        57192,
        57221,
        57251,
        57280,
        57310,
        57340,
        57369,
        57399,
        57429,
        57458,
        57487,
        57517,
        57546,
        57576,
        57605,
        57634,
        57664,
        57694,
        57723,
        57753,
        57783,
        57813,
        57842,
        57871,
        57901,
        57930,
        57959,
        57989,
        58018,
        58048,
        58077,
        58107,
        58137,
        58167,
        58196,
        58226,
        58255,
        58285,
        58314,
        58343,
        58373,
        58402,
        58432,
        58461,
        58491,
        58521,
        58551,
        58580,
        58610,
        58639,
        58669,
        58698,
        58727,
        58757,
        58786,
        58816,
        58845,
        58875,
        58905,
        58934,
        58964,
        58994,
        59023,
        59053,
        59082,
        59111,
        59141,
        59170,
        59200,
        59229,
        59259,
        59288,
        59318,
        59348,
        59377,
        59407,
        59436,
        59466,
        59495,
        59525,
        59554,
        59584,
        59613,
        59643,
        59672,
        59702,
        59731,
        59761,
        59791,
        59820,
        59850,
        59879,
        59909,
        59939,
        59968,
        59997,
        60027,
        60056,
        60086,
        60115,
        60145,
        60174,
        60204,
        60234,
        60264,
        60293,
        60323,
        60352,
        60381,
        60411,
        60440,
        60469,
        60499,
        60528,
        60558,
        60588,
        60618,
        60648,
        60677,
        60707,
        60736,
        60765,
        60795,
        60824,
        60853,
        60883,
        60912,
        60942,
        60972,
        61002,
        61031,
        61061,
        61090,
        61120,
        61149,
        61179,
        61208,
        61237,
        61267,
        61296,
        61326,
        61356,
        61385,
        61415,
        61445,
        61474,
        61504,
        61533,
        61563,
        61592,
        61621,
        61651,
        61680,
        61710,
        61739,
        61769,
        61799,
        61828,
        61858,
        61888,
        61917,
        61947,
        61976,
        62006,
        62035,
        62064,
        62094,
        62123,
        62153,
        62182,
        62212,
        62242,
        62271,
        62301,
        62331,
        62360,
        62390,
        62419,
        62448,
        62478,
        62507,
        62537,
        62566,
        62596,
        62625,
        62655,
        62685,
        62715,
        62744,
        62774,
        62803,
        62832,
        62862,
        62891,
        62921,
        62950,
        62980,
        63009,
        63039,
        63069,
        63099,
        63128,
        63157,
        63187,
        63216,
        63246,
        63275,
        63305,
        63334,
        63363,
        63393,
        63423,
        63453,
        63482,
        63512,
        63541,
        63571,
        63600,
        63630,
        63659,
        63689,
        63718,
        63747,
        63777,
        63807,
        63836,
        63866,
        63895,
        63925,
        63955,
        63984,
        64014,
        64043,
        64073,
        64102,
        64131,
        64161,
        64190,
        64220,
        64249,
        64279,
        64309,
        64339,
        64368,
        64398,
        64427,
        64457,
        64486,
        64515,
        64545,
        64574,
        64603,
        64633,
        64663,
        64692,
        64722,
        64752,
        64782,
        64811,
        64841,
        64870,
        64899,
        64929,
        64958,
        64987,
        65017,
        65047,
        65076,
        65106,
        65136,
        65166,
        65195,
        65225,
        65254,
        65283,
        65313,
        65342,
        65371,
        65401,
        65431,
        65460,
        65490,
        65520,
        65549,
        65579,
        65608,
        65638,
        65667,
        65697,
        65726,
        65755,
        65785,
        65815,
        65844,
        65874,
        65903,
        65933,
        65963,
        65992,
        66022,
        66051,
        66081,
        66110,
        66140,
        66169,
        66199,
        66228,
        66258,
        66287,
        66317,
        66346,
        66376,
        66405,
        66435,
        66465,
        66494,
        66524,
        66553,
        66583,
        66612,
        66641,
        66671,
        66700,
        66730,
        66760,
        66789,
        66819,
        66849,
        66878,
        66908,
        66937,
        66967,
        66996,
        67025,
        67055,
        67084,
        67114,
        67143,
        67173,
        67203,
        67233,
        67262,
        67292,
        67321,
        67351,
        67380,
        67409,
        67439,
        67468,
        67497,
        67527,
        67557,
        67587,
        67617,
        67646,
        67676,
        67705,
        67735,
        67764,
        67793,
        67823,
        67852,
        67882,
        67911,
        67941,
        67971,
        68000,
        68030,
        68060,
        68089,
        68119,
        68148,
        68177,
        68207,
        68236,
        68266,
        68295,
        68325,
        68354,
        68384,
        68414,
        68443,
        68473,
        68502,
        68532,
        68561,
        68591,
        68620,
        68650,
        68679,
        68708,
        68738,
        68768,
        68797,
        68827,
        68857,
        68886,
        68916,
        68946,
        68975,
        69004,
        69034,
        69063,
        69092,
        69122,
        69152,
        69181,
        69211,
        69240,
        69270,
        69300,
        69330,
        69359,
        69388,
        69418,
        69447,
        69476,
        69506,
        69535,
        69565,
        69595,
        69624,
        69654,
        69684,
        69713,
        69743,
        69772,
        69802,
        69831,
        69861,
        69890,
        69919,
        69949,
        69978,
        70008,
        70038,
        70067,
        70097,
        70126,
        70156,
        70186,
        70215,
        70245,
        70274,
        70303,
        70333,
        70362,
        70392,
        70421,
        70451,
        70481,
        70510,
        70540,
        70570,
        70599,
        70629,
        70658,
        70687,
        70717,
        70746,
        70776,
        70805,
        70835,
        70864,
        70894,
        70924,
        70954,
        70983,
        71013,
        71042,
        71071,
        71101,
        71130,
        71159,
        71189,
        71218,
        71248,
        71278,
        71308,
        71337,
        71367,
        71397,
        71426,
        71455,
        71485,
        71514,
        71543,
        71573,
        71602,
        71632,
        71662,
        71691,
        71721,
        71751,
        71781,
        71810,
        71839,
        71869,
        71898,
        71927,
        71957,
        71986,
        72016,
        72046,
        72075,
        72105,
        72135,
        72164,
        72194,
        72223,
        72253,
        72282,
        72311,
        72341,
        72370,
        72400,
        72429,
        72459,
        72489,
        72518,
        72548,
        72577,
        72607,
        72637,
        72666,
        72695,
        72725,
        72754,
        72784,
        72813,
        72843,
        72872,
        72902,
        72931,
        72961,
        72991,
        73020,
        73050,
        73080,
        73109,
        73139,
        73168,
        73197,
        73227,
        73256,
        73286,
        73315,
        73345,
        73375,
        73404,
        73434,
        73464,
        73493,
        73523,
        73552,
        73581,
        73611,
        73640,
        73669,
        73699,
        73729,
        73758,
        73788,
        73818,
        73848,
        73877,
        73907,
        73936,
        73965,
        73995,
        74024,
        74053,
        74083,
        74113,
        74142,
        74172,
        74202,
        74231,
        74261,
        74291,
        74320,
        74349,
        74379,
        74408,
        74437,
        74467,
        74497,
        74526,
        74556,
        74586,
        74615,
        74645,
        74675,
        74704,
        74733,
        74763,
        74792,
        74822,
        74851,
        74881,
        74910,
        74940,
        74969,
        74999,
        75029,
        75058,
        75088,
        75117,
        75147,
        75176,
        75206,
        75235,
        75264,
        75294,
        75323,
        75353,
        75383,
        75412,
        75442,
        75472,
        75501,
        75531,
        75560,
        75590,
        75619,
        75648,
        75678,
        75707,
        75737,
        75766,
        75796,
        75826,
        75856,
        75885,
        75915,
        75944,
        75974,
        76003,
        76032,
        76062,
        76091,
        76121,
        76150,
        76180,
        76210,
        76239,
        76269,
        76299,
        76328,
        76358,
        76387,
        76416,
        76446,
        76475,
        76505,
        76534,
        76564,
        76593,
        76623,
        76653,
        76682,
        76712,
        76741,
        76771,
        76801,
        76830,
        76859,
        76889,
        76918,
        76948,
        76977,
        77007,
        77036,
        77066,
        77096,
        77125,
        77155,
        77185,
        77214,
        77243,
        77273,
        77302,
        77332,
        77361,
        77390,
        77420,
        77450,
        77479,
        77509,
        77539,
        77569,
        77598,
        77627,
        77657,
        77686,
        77715,
        77745,
        77774,
        77804,
        77833,
        77863,
        77893,
        77923,
        77952,
        77982,
        78011,
        78041,
        78070,
        78099,
        78129,
        78158,
        78188,
        78217,
        78247,
        78277,
        78307,
        78336,
        78366,
        78395,
        78425,
        78454,
        78483,
        78513,
        78542,
        78572,
        78601,
        78631,
        78661,
        78690,
        78720,
        78750,
        78779,
        78808,
        78838,
        78867,
        78897,
        78926,
        78956,
        78985,
        79015,
        79044,
        79074,
        79104,
        79133,
        79163,
        79192,
        79222,
        79251,
        79281,
        79310,
        79340,
        79369,
        79399,
        79428,
        79458,
        79487,
        79517,
        79546,
        79576,
        79606,
        79635,
        79665,
        79695,
        79724,
        79753,
        79783,
        79812,
        79841,
        79871,
        79900,
        79930,
        79960,
        79990
    ];
    /**
     *
     * @param {Date} gDate ?
     * @returns {Object} ?
     */ function getHijriDate(gDate) {
        var day = gDate.getDate();
        var month = gDate.getMonth();
        var year = gDate.getFullYear();
        var tMonth = month + 1;
        var tYear = year;
        if (tMonth < 3) {
            tYear -= 1;
            tMonth += 12;
        }
        var yPrefix = Math.floor(tYear / 100);
        var julilanOffset = yPrefix - Math.floor(yPrefix / 4.) - 2;
        var julianNumber = Math.floor(365.25 * (tYear + 4716)) + Math.floor(30.6001 * (tMonth + 1)) + day - julilanOffset - 1524;
        yPrefix = Math.floor((julianNumber - 1867216.25) / 36524.25);
        julilanOffset = yPrefix - Math.floor(yPrefix / 4.) + 1;
        var b = julianNumber + julilanOffset + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var tempMonth = Math.floor((b - d) / 30.6001);
        day = b - d - Math.floor(30.6001 * tempMonth);
        month = Math.floor((b - d) / 20.6001);
        if (month > 13) {
            c += 1;
            month -= 12;
        }
        month -= 1;
        year = c - 4716;
        var modifiedJulianDate = julianNumber - 2400000;
        // date calculation for year after 2077
        var iyear = 10631 / 30;
        var z = julianNumber - 1948084;
        var cyc = Math.floor(z / 10631.);
        z = z - 10631 * cyc;
        var j = Math.floor((z - 0.1335) / iyear);
        var iy = 30 * cyc + j;
        z = z - Math.floor(j * iyear + 0.1335);
        var im = Math.floor((z + 28.5001) / 29.5);
        /* istanbul ignore next */ if (im === 13) im = 12;
        var tempDay = z - Math.floor(29.5001 * im - 29);
        var i = 0;
        for(; i < dateCorrection.length; i++){
            if (dateCorrection[parseInt(i.toString(), 10)] > modifiedJulianDate) break;
        }
        var iln = i + 16260;
        var ii = Math.floor((iln - 1) / 12);
        var hYear = ii + 1;
        var hmonth = iln - 12 * ii;
        var hDate = modifiedJulianDate - dateCorrection[i - 1] + 1;
        if ((hDate + "").length > 2) {
            hDate = tempDay;
            hmonth = im;
            hYear = iy;
        }
        return {
            year: hYear,
            month: hmonth,
            date: hDate
        };
    }
    HijriParser.getHijriDate = getHijriDate;
    /**
     *
     * @param {number} year ?
     * @param {number} month ?
     * @param {number} day ?
     * @returns {Date} ?
     */ function toGregorian(year, month, day) {
        var iy = year;
        var im = month;
        var id = day;
        var ii = iy - 1;
        var iln = ii * 12 + 1 + (im - 1);
        var i = iln - 16260;
        var mcjdn = id + dateCorrection[i - 1] - 1;
        var julianDate = mcjdn + 2400000;
        var z = Math.floor(julianDate + 0.5);
        var a = Math.floor((z - 1867216.25) / 36524.25);
        a = z + 1 + a - Math.floor(a / 4);
        var b = a + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var e = Math.floor((b - d) / 30.6001);
        var gDay = b - d - Math.floor(e * 30.6001);
        var gMonth = e - (e > 13.5 ? 13 : 1);
        var gYear = c - (gMonth > 2.5 ? 4716 : 4715);
        /* istanbul ignore next */ if (gYear <= 0) gMonth--;
         // No year zero
        return new Date(gYear + "/" + gMonth + "/" + gDay);
    }
    HijriParser.toGregorian = toGregorian;
})($23ae5de8bbf2215e$export$db339ee551ee4934 || ($23ae5de8bbf2215e$export$db339ee551ee4934 = {}));

});


parcelRegister("aJNO3", function(module, exports) {

$parcel$export(module.exports, "NumberFormat", () => $7d14bdd6b7e7e7f6$export$27bce688931fdfcc);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");

var $bWDaN = parcelRequire("bWDaN");

var $fW217 = parcelRequire("fW217");

var $3amEA = parcelRequire("3amEA");
var $7d14bdd6b7e7e7f6$var$errorText = {
    "ms": "minimumSignificantDigits",
    "ls": "maximumSignificantDigits",
    "mf": "minimumFractionDigits",
    "lf": "maximumFractionDigits"
};
var $7d14bdd6b7e7e7f6$var$percentSign = "percentSign";
var $7d14bdd6b7e7e7f6$var$minusSign = "minusSign";
var $7d14bdd6b7e7e7f6$var$mapper = [
    "infinity",
    "nan",
    "group",
    "decimal",
    "exponential"
];
/**
 * Module for number formatting.
 *
 * @private
 */ var $7d14bdd6b7e7e7f6$export$27bce688931fdfcc = /** @class */ function() {
    function NumberFormat() {}
    /**
     * Returns the formatter function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {NumberFormatOptions} option - Specific the format in which number  will format.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */ NumberFormat.numberFormatter = function(culture, option, cldr) {
        var _this = this;
        var fOptions = (0, $3EnZW.extend)({}, option);
        var cOptions = {};
        var dOptions = {};
        var symbolPattern;
        var dependable = (0, $fW217.IntlBase).getDependables(cldr, culture, "", true);
        var numObject = dependable.numericObject;
        dOptions.numberMapper = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.extend)({}, numObject) : (0, $3amEA.ParserBase).getNumberMapper(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr), true);
        dOptions.currencySymbol = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("currencySymbol", numObject) : (0, $fW217.IntlBase).getCurrencySymbol(dependable.numericObject, fOptions.currency || (0, $bWDaN.defaultCurrencyCode), option.altSymbol, option.ignoreCurrency);
        dOptions.percentSymbol = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("numberSymbols.percentSign", numObject) : dOptions.numberMapper.numberSymbols["" + $7d14bdd6b7e7e7f6$var$percentSign];
        dOptions.minusSymbol = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("numberSymbols.minusSign", numObject) : dOptions.numberMapper.numberSymbols["" + $7d14bdd6b7e7e7f6$var$minusSign];
        var symbols = dOptions.numberMapper.numberSymbols;
        if (option.format && !(0, $fW217.IntlBase).formatRegex.test(option.format)) {
            cOptions = (0, $fW217.IntlBase).customFormat(option.format, dOptions, dependable.numericObject);
            if (!(0, $3EnZW.isUndefined)(fOptions.useGrouping) && fOptions.useGrouping) fOptions.useGrouping = cOptions.pData.useGrouping;
        } else {
            (0, $3EnZW.extend)(fOptions, (0, $fW217.IntlBase).getProperNumericSkeleton(option.format || "N"));
            fOptions.isCurrency = fOptions.type === "currency";
            fOptions.isPercent = fOptions.type === "percent";
            if (!(0, $3EnZW.isBlazor)()) symbolPattern = (0, $fW217.IntlBase).getSymbolPattern(fOptions.type, dOptions.numberMapper.numberSystem, dependable.numericObject, fOptions.isAccount);
            fOptions.groupOne = this.checkValueRange(fOptions.maximumSignificantDigits, fOptions.minimumSignificantDigits, true);
            this.checkValueRange(fOptions.maximumFractionDigits, fOptions.minimumFractionDigits, false, true);
            if (!(0, $3EnZW.isUndefined)(fOptions.fractionDigits)) fOptions.minimumFractionDigits = fOptions.maximumFractionDigits = fOptions.fractionDigits;
            if ((0, $3EnZW.isUndefined)(fOptions.useGrouping)) fOptions.useGrouping = true;
            if (fOptions.isCurrency && !(0, $3EnZW.isBlazor)()) symbolPattern = symbolPattern.replace(/\u00A4/g, (0, $fW217.IntlBase).defaultCurrency);
            if (!(0, $3EnZW.isBlazor)()) {
                var split = symbolPattern.split(";");
                cOptions.nData = (0, $fW217.IntlBase).getFormatData(split[1] || "-" + split[0], true, dOptions.currencySymbol);
                cOptions.pData = (0, $fW217.IntlBase).getFormatData(split[0], false, dOptions.currencySymbol);
                if (fOptions.useGrouping) {
                    fOptions.groupSeparator = symbols[$7d14bdd6b7e7e7f6$var$mapper[2]];
                    fOptions.groupData = this.getGroupingDetails(split[0]);
                }
            } else {
                cOptions.nData = (0, $3EnZW.extend)({}, {}, (0, $3EnZW.getValue)(fOptions.type + "nData", numObject));
                cOptions.pData = (0, $3EnZW.extend)({}, {}, (0, $3EnZW.getValue)(fOptions.type + "pData", numObject));
                if (fOptions.type === "currency" && option.currency) (0, $fW217.IntlBase).replaceBlazorCurrency([
                    cOptions.pData,
                    cOptions.nData
                ], dOptions.currencySymbol, option.currency);
            }
            var minFrac = (0, $3EnZW.isUndefined)(fOptions.minimumFractionDigits);
            if (minFrac) fOptions.minimumFractionDigits = cOptions.nData.minimumFraction;
            if ((0, $3EnZW.isUndefined)(fOptions.maximumFractionDigits)) {
                var mval = cOptions.nData.maximumFraction;
                fOptions.maximumFractionDigits = (0, $3EnZW.isUndefined)(mval) && fOptions.isPercent ? 0 : mval;
            }
            var mfrac = fOptions.minimumFractionDigits;
            var lfrac = fOptions.maximumFractionDigits;
            if (!(0, $3EnZW.isUndefined)(mfrac) && !(0, $3EnZW.isUndefined)(lfrac)) {
                if (mfrac > lfrac) fOptions.maximumFractionDigits = mfrac;
            }
        }
        (0, $3EnZW.extend)(cOptions.nData, fOptions);
        (0, $3EnZW.extend)(cOptions.pData, fOptions);
        return function(value) {
            if (isNaN(value)) return symbols[$7d14bdd6b7e7e7f6$var$mapper[1]];
            else if (!isFinite(value)) return symbols[$7d14bdd6b7e7e7f6$var$mapper[0]];
            return _this.intNumberFormatter(value, cOptions, dOptions, option);
        };
    };
    /**
     * Returns grouping details for the pattern provided
     *
     * @param {string} pattern ?
     * @returns {GroupDetails} ?
     */ NumberFormat.getGroupingDetails = function(pattern) {
        var ret = {};
        var match = pattern.match((0, $fW217.IntlBase).negativeDataRegex);
        if (match && match[4]) {
            var pattern_1 = match[4];
            var p = pattern_1.lastIndexOf(",");
            if (p !== -1) {
                var temp = pattern_1.split(".")[0];
                ret.primary = temp.length - p - 1;
                var s = pattern_1.lastIndexOf(",", p - 1);
                if (s !== -1) ret.secondary = p - 1 - s;
            }
        }
        return ret;
    };
    /**
     * Returns if the provided integer range is valid.
     *
     * @param {number} val1 ?
     * @param {number} val2 ?
     * @param {boolean} checkbothExist ?
     * @param {boolean} isFraction ?
     * @returns {boolean} ?
     */ NumberFormat.checkValueRange = function(val1, val2, checkbothExist, isFraction) {
        var decide = isFraction ? "f" : "s";
        var dint = 0;
        var str1 = $7d14bdd6b7e7e7f6$var$errorText["l" + decide];
        var str2 = $7d14bdd6b7e7e7f6$var$errorText["m" + decide];
        if (!(0, $3EnZW.isUndefined)(val1)) {
            this.checkRange(val1, str1, isFraction);
            dint++;
        }
        if (!(0, $3EnZW.isUndefined)(val2)) {
            this.checkRange(val2, str2, isFraction);
            dint++;
        }
        if (dint === 2) {
            if (val1 < val2) (0, $3EnZW.throwError)(str2 + "specified must be less than the" + str1);
            else return true;
        } else if (checkbothExist && dint === 1) (0, $3EnZW.throwError)("Both" + str2 + "and" + str2 + "must be present");
        return false;
    };
    /**
     * Check if the provided fraction range is valid
     *
     * @param {number} val ?
     * @param {string} text ?
     * @param {boolean} isFraction ?
     * @returns {void} ?
     */ NumberFormat.checkRange = function(val, text, isFraction) {
        var range = isFraction ? [
            0,
            20
        ] : [
            1,
            21
        ];
        if (val < range[0] || val > range[1]) (0, $3EnZW.throwError)(text + "value must be within the range" + range[0] + "to" + range[1]);
    };
    /**
     * Returns formatted numeric string for provided formatting options
     *
     * @param {number} value ?
     * @param {base.GenericFormatOptions} fOptions ?
     * @param {CommonOptions} dOptions ?
     * @param {NumberFormatOptions} [option] ?
     * @returns {string} ?
     */ NumberFormat.intNumberFormatter = function(value, fOptions, dOptions, option) {
        var curData;
        if ((0, $3EnZW.isUndefined)(fOptions.nData.type)) return undefined;
        else {
            if (value < 0) {
                value = value * -1;
                curData = fOptions.nData;
            } else if (value === 0) curData = fOptions.zeroData || fOptions.pData;
            else curData = fOptions.pData;
            var fValue = "";
            if (curData.isPercent) value = value * 100;
            if (curData.groupOne) fValue = this.processSignificantDigits(value, curData.minimumSignificantDigits, curData.maximumSignificantDigits);
            else {
                fValue = this.processFraction(value, curData.minimumFractionDigits, curData.maximumFractionDigits, option);
                if (curData.minimumIntegerDigits) fValue = this.processMinimumIntegers(fValue, curData.minimumIntegerDigits);
                if (dOptions.isCustomFormat && curData.minimumFractionDigits < curData.maximumFractionDigits && /\d+\.\d+/.test(fValue)) {
                    var temp = fValue.split(".");
                    var decimalPart = temp[1];
                    var len = decimalPart.length;
                    for(var i = len - 1; i >= 0; i--){
                        if (decimalPart[parseInt(i.toString(), 10)] === "0" && i >= curData.minimumFractionDigits) decimalPart = decimalPart.slice(0, i);
                        else break;
                    }
                    fValue = temp[0] + "." + decimalPart;
                }
            }
            if (curData.type === "scientific") {
                fValue = value.toExponential(curData.maximumFractionDigits);
                fValue = fValue.replace("e", dOptions.numberMapper.numberSymbols[$7d14bdd6b7e7e7f6$var$mapper[4]]);
            }
            fValue = fValue.replace(".", dOptions.numberMapper.numberSymbols[$7d14bdd6b7e7e7f6$var$mapper[3]]);
            fValue = curData.format === "#,###,,;(#,###,,)" ? this.customPivotFormat(parseInt(fValue, 10)) : fValue;
            if (curData.useGrouping) fValue = this.groupNumbers(fValue, curData.groupData.primary, curData.groupSeparator || ",", dOptions.numberMapper.numberSymbols[$7d14bdd6b7e7e7f6$var$mapper[3]] || ".", curData.groupData.secondary);
            fValue = (0, $3amEA.ParserBase).convertValueParts(fValue, (0, $fW217.IntlBase).latnParseRegex, dOptions.numberMapper.mapper);
            if (curData.nlead === "N/A") return curData.nlead;
            else {
                if (fValue === "0" && option && option.format === "0") return fValue + curData.nend;
                return curData.nlead + fValue + curData.nend;
            }
        }
    };
    /**
     * Returns significant digits processed numeric string
     *
     * @param {number} value ?
     * @param {number} min ?
     * @param {number} max ?
     * @returns {string} ?
     */ NumberFormat.processSignificantDigits = function(value, min, max) {
        var temp = value + "";
        var tn;
        var length = temp.length;
        if (length < min) return value.toPrecision(min);
        else {
            temp = value.toPrecision(max);
            tn = +temp;
            return tn + "";
        }
    };
    /**
     * Returns grouped numeric string
     *
     * @param {string} val ?
     * @param {number} level1 ?
     * @param {string} sep ?
     * @param {string} decimalSymbol ?
     * @param {number} level2 ?
     * @returns {string} ?
     */ NumberFormat.groupNumbers = function(val, level1, sep, decimalSymbol, level2) {
        var flag = !(0, $3EnZW.isNullOrUndefined)(level2) && level2 !== 0;
        var split = val.split(decimalSymbol);
        var prefix = split[0];
        var length = prefix.length;
        var str = "";
        while(length > level1){
            str = prefix.slice(length - level1, length) + (str.length ? sep + str : "");
            length -= level1;
            if (flag) {
                level1 = level2;
                flag = false;
            }
        }
        split[0] = prefix.slice(0, length) + (str.length ? sep : "") + str;
        return split.join(decimalSymbol);
    };
    /**
     * Returns fraction processed numeric string
     *
     * @param {number} value ?
     * @param {number} min ?
     * @param {number} max ?
     * @param {NumberFormatOptions} [option] ?
     * @returns {string} ?
     */ NumberFormat.processFraction = function(value, min, max, option) {
        var temp = (value + "").split(".")[1];
        var length = temp ? temp.length : 0;
        if (min && length < min) {
            var ret = "";
            if (length === 0) ret = value.toFixed(min);
            else {
                ret += value;
                for(var j = 0; j < min - length; j++)ret += "0";
                return ret;
            }
            return value.toFixed(min);
        } else if (!(0, $3EnZW.isNullOrUndefined)(max) && (length > max || max === 0)) return value.toFixed(max);
        var str = value + "";
        if (str[0] === "0" && option && option.format === "###.00") str = str.slice(1);
        return str;
    };
    /**
     * Returns integer processed numeric string
     *
     * @param {string} value ?
     * @param {number} min ?
     * @returns {string} ?
     */ NumberFormat.processMinimumIntegers = function(value, min) {
        var temp = value.split(".");
        var lead = temp[0];
        var len = lead.length;
        if (len < min) {
            for(var i = 0; i < min - len; i++)lead = "0" + lead;
            temp[0] = lead;
        }
        return temp.join(".");
    };
    /**
     * Returns custom format for pivot table
     *
     * @param {number} value ?
     * @returns {string} ?
     */ NumberFormat.customPivotFormat = function(value) {
        if (value >= 500000) {
            value /= 1000000;
            var _a = value.toString().split("."), integer = _a[0], decimal = _a[1];
            return decimal && +decimal.substring(0, 1) >= 5 ? Math.ceil(value).toString() : Math.floor(value).toString();
        }
        return "";
    };
    return NumberFormat;
}();

});

parcelRegister("ke2zM", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $eb971cfde3a9e5e1$export$e8d4b28a20981dd2);

var $fW217 = parcelRequire("fW217");

var $3amEA = parcelRequire("3amEA");

var $3EnZW = parcelRequire("3EnZW");

var $c2qRe = parcelRequire("c2qRe");

var $33VE1 = parcelRequire("33VE1");
var $eb971cfde3a9e5e1$var$standalone = "stand-alone";
var $eb971cfde3a9e5e1$var$latnRegex = /^[0-9]*$/;
var $eb971cfde3a9e5e1$var$timeSetter = {
    minute: "setMinutes",
    hour: "setHours",
    second: "setSeconds",
    day: "setDate",
    month: "setMonth",
    milliseconds: "setMilliseconds"
};
var $eb971cfde3a9e5e1$var$month = "months";
/**
 * Date Parser.
 *
 * @private
 */ var $eb971cfde3a9e5e1$export$e8d4b28a20981dd2 = /** @class */ function() {
    function DateParser() {}
    /**
     * Returns the parser function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {DateFormatOptions} option - Specific the format in which string date  will be parsed.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */ DateParser.dateParser = function(culture, option, cldr) {
        var _this = this;
        var dependable = (0, $fW217.IntlBase).getDependables(cldr, culture, option.calendar);
        var numOptions = (0, $3amEA.ParserBase).getCurrentNumericOptions(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr), false, (0, $3EnZW.isBlazor)());
        var parseOptions = {};
        if ((0, $3EnZW.isBlazor)() && option.isServerRendered) option = (0, $fW217.IntlBase).compareBlazorDateFormats(option, culture);
        var resPattern = option.format || (0, $fW217.IntlBase).getResultantPattern(option.skeleton, dependable.dateObject, option.type, false, (0, $3EnZW.isBlazor)() ? culture : "");
        var regexString = "";
        var hourOnly;
        if ((0, $3EnZW.isUndefined)(resPattern)) (0, $3EnZW.throwError)("Format options or type given must be invalid");
        else {
            resPattern = (0, $fW217.IntlBase).ConvertDateToWeekFormat(resPattern);
            parseOptions = {
                isIslamic: (0, $fW217.IntlBase).islamicRegex.test(option.calendar),
                pattern: resPattern,
                evalposition: {},
                culture: culture
            };
            var patternMatch = resPattern.match((0, $fW217.IntlBase).dateParseRegex) || [];
            var length_1 = patternMatch.length;
            var gmtCorrection = 0;
            var zCorrectTemp = 0;
            var isgmtTraversed = false;
            var nRegx = numOptions.numericRegex;
            var numMapper = (0, $3EnZW.isBlazor)() ? dependable.parserObject.numbers : (0, $3amEA.ParserBase).getNumberMapper(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr));
            for(var i = 0; i < length_1; i++){
                var str = patternMatch[parseInt(i.toString(), 10)];
                var len = str.length;
                var char = str[0] === "K" ? "h" : str[0];
                var isNumber = void 0;
                var canUpdate = void 0;
                var charKey = (0, $c2qRe.datePartMatcher)["" + char];
                var optional = len === 2 ? "" : "?";
                if (isgmtTraversed) {
                    gmtCorrection = zCorrectTemp;
                    isgmtTraversed = false;
                }
                switch(char){
                    case "E":
                    case "c":
                        var weekData = void 0;
                        if ((0, $3EnZW.isBlazor)()) weekData = (0, $3EnZW.getValue)("days." + (0, $fW217.IntlBase).monthIndex["" + len], dependable.dateObject);
                        else weekData = dependable.dateObject["" + (0, $fW217.IntlBase).days]["" + $eb971cfde3a9e5e1$var$standalone][(0, $fW217.IntlBase).monthIndex["" + len]];
                        var weekObject = (0, $3amEA.ParserBase).reverseObject(weekData);
                        regexString += "(" + Object.keys(weekObject).join("|") + ")";
                        break;
                    case "M":
                    case "L":
                    case "d":
                    case "m":
                    case "s":
                    case "h":
                    case "H":
                    case "f":
                        canUpdate = true;
                        if ((char === "M" || char === "L") && len > 2) {
                            var monthData = void 0;
                            if ((0, $3EnZW.isBlazor)()) monthData = (0, $3EnZW.getValue)("months." + (0, $fW217.IntlBase).monthIndex["" + len], dependable.dateObject);
                            else monthData = dependable.dateObject["" + $eb971cfde3a9e5e1$var$month]["" + $eb971cfde3a9e5e1$var$standalone][(0, $fW217.IntlBase).monthIndex["" + len]];
                            parseOptions["" + charKey] = (0, $3amEA.ParserBase).reverseObject(monthData);
                            regexString += "(" + Object.keys(parseOptions["" + charKey]).join("|") + ")";
                        } else if (char === "f") {
                            if (len > 3) continue;
                            isNumber = true;
                            regexString += "(" + nRegx + nRegx + "?" + nRegx + "?" + ")";
                        } else {
                            isNumber = true;
                            regexString += "(" + nRegx + nRegx + optional + ")";
                        }
                        if (char === "h") parseOptions.hour12 = true;
                        break;
                    case "W":
                        var opt = len === 1 ? "?" : "";
                        regexString += "(" + nRegx + opt + nRegx + ")";
                        break;
                    case "y":
                        canUpdate = isNumber = true;
                        if (len === 2) regexString += "(" + nRegx + nRegx + ")";
                        else regexString += "(" + nRegx + "{" + len + ",})";
                        break;
                    case "a":
                        canUpdate = true;
                        var periodValur = (0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("dayPeriods", dependable.dateObject) : (0, $3EnZW.getValue)("dayPeriods.format.wide", dependable.dateObject);
                        parseOptions["" + charKey] = (0, $3amEA.ParserBase).reverseObject(periodValur);
                        regexString += "(" + Object.keys(parseOptions["" + charKey]).join("|") + ")";
                        break;
                    case "G":
                        canUpdate = true;
                        var eText = len <= 3 ? "eraAbbr" : len === 4 ? "eraNames" : "eraNarrow";
                        parseOptions["" + charKey] = (0, $3amEA.ParserBase).reverseObject((0, $3EnZW.isBlazor)() ? (0, $3EnZW.getValue)("eras", dependable.dateObject) : (0, $3EnZW.getValue)("eras." + eText, dependable.dateObject));
                        regexString += "(" + Object.keys(parseOptions["" + charKey]).join("|") + "?)";
                        break;
                    case "z":
                        var tval = new Date().getTimezoneOffset();
                        canUpdate = tval !== 0;
                        parseOptions["" + charKey] = (0, $3EnZW.getValue)("dates.timeZoneNames", dependable.parserObject);
                        var tzone = parseOptions["" + charKey];
                        hourOnly = len < 4;
                        var hpattern = hourOnly ? "+H;-H" : tzone.hourFormat;
                        hpattern = hpattern.replace(/:/g, numMapper.timeSeparator);
                        regexString += "(" + this.parseTimeZoneRegx(hpattern, tzone, nRegx) + ")?";
                        isgmtTraversed = true;
                        zCorrectTemp = hourOnly ? 6 : 12;
                        break;
                    case "'":
                        var iString = str.replace(/'/g, "");
                        regexString += "(" + iString + ")?";
                        break;
                    default:
                        regexString += "([\\D])";
                        break;
                }
                if (canUpdate) parseOptions.evalposition["" + charKey] = {
                    isNumber: isNumber,
                    pos: i + 1 + gmtCorrection,
                    hourOnly: hourOnly
                };
                if (i === length_1 - 1 && !(0, $3EnZW.isNullOrUndefined)(regexString)) {
                    var regExp = RegExp;
                    parseOptions.parserRegex = new regExp("^" + regexString + "$", "i");
                }
            }
        }
        return function(value) {
            var parsedDateParts = _this.internalDateParse(value, parseOptions, numOptions);
            if ((0, $3EnZW.isNullOrUndefined)(parsedDateParts) || !Object.keys(parsedDateParts).length) return null;
            if (parseOptions.isIslamic) {
                var dobj = {};
                var tYear = parsedDateParts.year;
                var tDate = parsedDateParts.day;
                var tMonth = parsedDateParts.month;
                var ystrig = tYear ? tYear + "" : "";
                var is2DigitYear = ystrig.length === 2;
                if (!tYear || !tMonth || !tDate || is2DigitYear) dobj = (0, $33VE1.HijriParser).getHijriDate(new Date());
                if (is2DigitYear) tYear = parseInt((dobj.year + "").slice(0, 2) + ystrig, 10);
                var dateObject = (0, $33VE1.HijriParser).toGregorian(tYear || dobj.year, tMonth || dobj.month, tDate || dobj.date);
                parsedDateParts.year = dateObject.getFullYear();
                parsedDateParts.month = dateObject.getMonth() + 1;
                parsedDateParts.day = dateObject.getDate();
            }
            return _this.getDateObject(parsedDateParts);
        };
    };
    /**
     * Returns date object for provided date options
     *
     * @param {DateParts} options ?
     * @param {Date} value ?
     * @returns {Date} ?
     */ DateParser.getDateObject = function(options, value) {
        var res = value || new Date();
        res.setMilliseconds(0);
        var tKeys = [
            "hour",
            "minute",
            "second",
            "milliseconds",
            "month",
            "day"
        ];
        var y = options.year;
        var desig = options.designator;
        var tzone = options.timeZone;
        if (!(0, $3EnZW.isUndefined)(y)) {
            var len = (y + "").length;
            if (len <= 2) {
                var century = Math.floor(res.getFullYear() / 100) * 100;
                y += century;
            }
            res.setFullYear(y);
        }
        for(var _i = 0, tKeys_1 = tKeys; _i < tKeys_1.length; _i++){
            var key = tKeys_1[_i];
            var tValue = options["" + key];
            if ((0, $3EnZW.isUndefined)(tValue) && key === "day") res.setDate(1);
            if (!(0, $3EnZW.isUndefined)(tValue)) {
                if (key === "month") {
                    tValue -= 1;
                    if (tValue < 0 || tValue > 11) return new Date("invalid");
                    var pDate = res.getDate();
                    res.setDate(1);
                    res[$eb971cfde3a9e5e1$var$timeSetter["" + key]](tValue);
                    var lDate = new Date(res.getFullYear(), tValue + 1, 0).getDate();
                    res.setDate(pDate < lDate ? pDate : lDate);
                } else {
                    if (key === "day") {
                        var lastDay = new Date(res.getFullYear(), res.getMonth() + 1, 0).getDate();
                        if (tValue < 1 || tValue > lastDay) return null;
                    }
                    res["" + $eb971cfde3a9e5e1$var$timeSetter["" + key]](tValue);
                }
            }
        }
        if (!(0, $3EnZW.isUndefined)(desig)) {
            var hour = res.getHours();
            if (desig === "pm") res.setHours(hour + (hour === 12 ? 0 : 12));
            else if (hour === 12) res.setHours(0);
        }
        if (!(0, $3EnZW.isUndefined)(tzone)) {
            var tzValue = tzone - res.getTimezoneOffset();
            if (tzValue !== 0) res.setMinutes(res.getMinutes() + tzValue);
        }
        return res;
    };
    /**
     * Returns date parsing options for provided value along with parse and numeric options
     *
     * @param {string} value ?
     * @param {ParseOptions} parseOptions ?
     * @param {NumericOptions} num ?
     * @returns {DateParts} ?
     */ DateParser.internalDateParse = function(value, parseOptions, num) {
        var matches = value.match(parseOptions.parserRegex);
        var retOptions = {
            "hour": 0,
            "minute": 0,
            "second": 0
        };
        if ((0, $3EnZW.isNullOrUndefined)(matches)) return null;
        else {
            var props = Object.keys(parseOptions.evalposition);
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var prop = props_1[_i];
                var curObject = parseOptions.evalposition["" + prop];
                var matchString = matches[curObject.pos];
                if (curObject.isNumber) retOptions["" + prop] = this.internalNumberParser(matchString, num);
                else if (prop === "timeZone" && !(0, $3EnZW.isUndefined)(matchString)) {
                    var pos = curObject.pos;
                    var val = void 0;
                    var tmatch = matches[pos + 1];
                    var flag = !(0, $3EnZW.isUndefined)(tmatch);
                    if (curObject.hourOnly) val = this.getZoneValue(flag, tmatch, matches[pos + 4], num) * 60;
                    else {
                        val = this.getZoneValue(flag, tmatch, matches[pos + 7], num) * 60;
                        val += this.getZoneValue(flag, matches[pos + 4], matches[pos + 10], num);
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(val)) retOptions["" + prop] = val;
                } else {
                    var cultureOptions = [
                        "en-US",
                        "en-MH",
                        "en-MP"
                    ];
                    matchString = prop === "month" && !parseOptions.isIslamic && (parseOptions.culture === "en" || parseOptions.culture === "en-GB" || parseOptions.culture === "en-US") ? matchString[0].toUpperCase() + matchString.substring(1).toLowerCase() : matchString;
                    matchString = prop !== "month" && prop === "designator" && parseOptions.culture && parseOptions.culture.indexOf("en-") !== -1 && cultureOptions.indexOf(parseOptions.culture) === -1 ? matchString.toLowerCase() : matchString;
                    retOptions["" + prop] = parseOptions["" + prop]["" + matchString];
                }
            }
            if (parseOptions.hour12) retOptions.hour12 = true;
        }
        return retOptions;
    };
    /**
     * Returns parsed number for provided Numeric string and Numeric Options
     *
     * @param {string} value ?
     * @param {NumericOptions} option ?
     * @returns {number} ?
     */ DateParser.internalNumberParser = function(value, option) {
        value = (0, $3amEA.ParserBase).convertValueParts(value, option.numberParseRegex, option.numericPair);
        if ($eb971cfde3a9e5e1$var$latnRegex.test(value)) return +value;
        return null;
    };
    /**
     * Returns parsed time zone RegExp for provided hour format and time zone
     *
     * @param {string} hourFormat ?
     * @param {base.TimeZoneOptions} tZone ?
     * @param {string} nRegex ?
     * @returns {string} ?
     */ DateParser.parseTimeZoneRegx = function(hourFormat, tZone, nRegex) {
        var pattern = tZone.gmtFormat;
        var ret;
        var cRegex = "(" + nRegex + ")" + "(" + nRegex + ")";
        ret = hourFormat.replace("+", "\\+");
        if (hourFormat.indexOf("HH") !== -1) ret = ret.replace(/HH|mm/g, "(" + cRegex + ")");
        else ret = ret.replace(/H|m/g, "(" + cRegex + "?)");
        var splitStr = ret.split(";").map(function(str) {
            return pattern.replace("{0}", str);
        });
        ret = splitStr.join("|") + "|" + tZone.gmtZeroFormat;
        return ret;
    };
    /**
     * Returns zone based value.
     *
     * @param {boolean} flag ?
     * @param {string} val1 ?
     * @param {string} val2 ?
     * @param {NumericOptions} num ?
     * @returns {number} ?
     */ DateParser.getZoneValue = function(flag, val1, val2, num) {
        var ival = flag ? val1 : val2;
        if (!ival) return 0;
        var value = this.internalNumberParser(ival, num);
        if (flag) return -value;
        return value;
    };
    return DateParser;
}();

});

parcelRegister("clnws", function(module, exports) {

$parcel$export(module.exports, "NumberParser", () => $8fc9b1452ca07d20$export$cd11ab140839f11d);

var $3EnZW = parcelRequire("3EnZW");

var $3amEA = parcelRequire("3amEA");

var $fW217 = parcelRequire("fW217");
var $8fc9b1452ca07d20$var$regExp = RegExp;
var $8fc9b1452ca07d20$var$parseRegex = new $8fc9b1452ca07d20$var$regExp("^([^0-9]*)(([0-9,]*[0-9]+)(.[0-9]+)?)([Ee][+-]?[0-9]+)?([^0-9]*)$");
var $8fc9b1452ca07d20$var$groupRegex = /,/g;
var $8fc9b1452ca07d20$var$keys = [
    "minusSign",
    "infinity"
];
/**
 * Module for Number Parser.
 *
 * @private
 */ var $8fc9b1452ca07d20$export$cd11ab140839f11d = /** @class */ function() {
    function NumberParser() {}
    /**
     * Returns the parser function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {NumberFormatOptions} option - Specific the format in which number  will parsed.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */ NumberParser.numberParser = function(culture, option, cldr) {
        var _this = this;
        var dependable = (0, $fW217.IntlBase).getDependables(cldr, culture, "", true);
        var parseOptions = {
            custom: true
        };
        if ((0, $fW217.IntlBase).formatRegex.test(option.format) || !option.format) {
            (0, $3EnZW.extend)(parseOptions, (0, $fW217.IntlBase).getProperNumericSkeleton(option.format || "N"));
            parseOptions.custom = false;
            if (!parseOptions.fractionDigits) {
                if (option.maximumFractionDigits) parseOptions.maximumFractionDigits = option.maximumFractionDigits;
            }
        } else (0, $3EnZW.extend)(parseOptions, (0, $fW217.IntlBase).customFormat(option.format, null, null));
        var numbers = (0, $3EnZW.getValue)("numbers", dependable.parserObject);
        var numOptions = (0, $3amEA.ParserBase).getCurrentNumericOptions(dependable.parserObject, (0, $3amEA.ParserBase).getNumberingSystem(cldr), true, (0, $3EnZW.isBlazor)());
        parseOptions.symbolRegex = (0, $3amEA.ParserBase).getSymbolRegex(Object.keys(numOptions.symbolMatch));
        parseOptions.infinity = numOptions.symbolNumberSystem[$8fc9b1452ca07d20$var$keys[1]];
        var symbolpattern;
        if (!(0, $3EnZW.isBlazor)()) {
            symbolpattern = (0, $fW217.IntlBase).getSymbolPattern(parseOptions.type, numOptions.numberSystem, dependable.numericObject, parseOptions.isAccount);
            if (symbolpattern) {
                symbolpattern = symbolpattern.replace(/\u00A4/g, (0, $fW217.IntlBase).defaultCurrency);
                var split = symbolpattern.split(";");
                parseOptions.nData = (0, $fW217.IntlBase).getFormatData(split[1] || "-" + split[0], true, "");
                parseOptions.pData = (0, $fW217.IntlBase).getFormatData(split[0], true, "");
            }
        } else {
            parseOptions.nData = (0, $3EnZW.extend)({}, {}, (0, $3EnZW.getValue)(parseOptions.type + "nData", numbers));
            parseOptions.pData = (0, $3EnZW.extend)({}, {}, (0, $3EnZW.getValue)(parseOptions.type + "pData", numbers));
            if (parseOptions.type === "currency" && option.currency) (0, $fW217.IntlBase).replaceBlazorCurrency([
                parseOptions.pData,
                parseOptions.nData
            ], (0, $3EnZW.getValue)("currencySymbol", numbers), option.currency);
        }
        return function(value) {
            return _this.getParsedNumber(value, parseOptions, numOptions);
        };
    };
    /**
     * Returns parsed number for the provided formatting options
     *
     * @param {string} value ?
     * @param {NumericParts} options ?
     * @param {NumericOptions} numOptions ?
     * @returns {number} ?
     */ NumberParser.getParsedNumber = function(value, options, numOptions) {
        var isNegative;
        var isPercent;
        var tempValue;
        var lead;
        var end;
        var ret;
        if (value.indexOf(options.infinity) !== -1) return Infinity;
        else {
            value = (0, $3amEA.ParserBase).convertValueParts(value, options.symbolRegex, numOptions.symbolMatch);
            value = (0, $3amEA.ParserBase).convertValueParts(value, numOptions.numberParseRegex, numOptions.numericPair);
            value = value.indexOf("-") !== -1 ? value.replace("-.", "-0.") : value;
            if (value.indexOf(".") === 0) value = "0" + value;
            var matches = value.match($8fc9b1452ca07d20$var$parseRegex);
            if ((0, $3EnZW.isNullOrUndefined)(matches)) return NaN;
            lead = matches[1];
            tempValue = matches[2];
            var exponent = matches[5];
            end = matches[6];
            isNegative = options.custom ? lead === options.nData.nlead && end === options.nData.nend : lead.indexOf(options.nData.nlead) !== -1 && end.indexOf(options.nData.nend) !== -1;
            isPercent = isNegative ? options.nData.isPercent : options.pData.isPercent;
            tempValue = tempValue.replace($8fc9b1452ca07d20$var$groupRegex, "");
            if (exponent) tempValue += exponent;
            ret = +tempValue;
            if (options.type === "percent" || isPercent) ret = ret / 100;
            if (options.custom || options.fractionDigits) ret = parseFloat(ret.toFixed(options.custom ? isNegative ? options.nData.maximumFractionDigits : options.pData.maximumFractionDigits : options.fractionDigits));
            if (options.maximumFractionDigits) ret = this.convertMaxFracDigits(tempValue, options, ret, isNegative);
            if (isNegative) ret *= -1;
            return ret;
        }
    };
    NumberParser.convertMaxFracDigits = function(value, options, ret, isNegative) {
        var decimalSplitValue = value.split(".");
        if (decimalSplitValue[1] && decimalSplitValue[1].length > options.maximumFractionDigits) ret = +ret.toFixed(options.custom ? isNegative ? options.nData.maximumFractionDigits : options.pData.maximumFractionDigits : options.maximumFractionDigits);
        return ret;
    };
    return NumberParser;
}();

});

parcelRegister("13zI2", function(module, exports) {

$parcel$export(module.exports, "Observer", () => $0c51c56184c43006$export$c1cbdee04e18ea8b);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */ 
var $3EnZW = parcelRequire("3EnZW");
var $0c51c56184c43006$export$c1cbdee04e18ea8b = /** @class */ function() {
    function Observer(context) {
        this.ranArray = [];
        this.boundedEvents = {};
        if ((0, $3EnZW.isNullOrUndefined)(context)) return;
        this.context = context;
    }
    /**
     * To attach handler for given property in current context.
     *
     * @param {string} property - specifies the name of the event.
     * @param {Function} handler - Specifies the handler function to be called while event notified.
     * @param {Object} context - Specifies the context binded to the handler.
     * @param {string} id - specifies the random generated id.
     * @returns {void}
     */ Observer.prototype.on = function(property, handler, context, id) {
        if ((0, $3EnZW.isNullOrUndefined)(handler)) return;
        var cntxt = context || this.context;
        if (this.notExist(property)) {
            this.boundedEvents["" + property] = [
                {
                    handler: handler,
                    context: cntxt,
                    id: id
                }
            ];
            return;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(id)) {
            if (this.ranArray.indexOf(id) === -1) {
                this.ranArray.push(id);
                this.boundedEvents["" + property].push({
                    handler: handler,
                    context: cntxt,
                    id: id
                });
            }
        } else if (!this.isHandlerPresent(this.boundedEvents["" + property], handler)) this.boundedEvents["" + property].push({
            handler: handler,
            context: cntxt
        });
    };
    /**
     * To remove handlers from a event attached using on() function.
     *
     * @param {string} property - specifies the name of the event.
     * @param {Function} handler - Optional argument specifies the handler function to be called while event notified.
     * @param {string} id - specifies the random generated id.
     * @returns {void} ?
     */ Observer.prototype.off = function(property, handler, id) {
        if (this.notExist(property)) return;
        var curObject = (0, $3EnZW.getValue)(property, this.boundedEvents);
        if (handler) for(var i = 0; i < curObject.length; i++){
            if (id) {
                if (curObject[parseInt(i.toString(), 10)].id === id) {
                    curObject.splice(i, 1);
                    var indexLocation = this.ranArray.indexOf(id);
                    if (indexLocation !== -1) this.ranArray.splice(indexLocation, 1);
                    break;
                }
            } else if (handler === curObject[parseInt(i.toString(), 10)].handler) {
                curObject.splice(i, 1);
                break;
            }
        }
        else delete this.boundedEvents["" + property];
    };
    /**
     * To notify the handlers in the specified event.
     *
     * @param {string} property - Specifies the event to be notify.
     * @param {Object} argument - Additional parameters to pass while calling the handler.
     * @param {Function} successHandler - this function will invoke after event successfully triggered
     * @param {Function} errorHandler - this function will invoke after event if it was failure to call.
     * @returns {void} ?
     */ Observer.prototype.notify = function(property, argument, successHandler, errorHandler) {
        if (this.notExist(property)) {
            if (successHandler) successHandler.call(this, argument);
            return;
        }
        if (argument) argument.name = property;
        var blazor = "Blazor";
        var curObject = (0, $3EnZW.getValue)(property, this.boundedEvents).slice(0);
        if (window["" + blazor]) return this.blazorCallback(curObject, argument, successHandler, errorHandler, 0);
        else {
            for(var _i = 0, curObject_1 = curObject; _i < curObject_1.length; _i++){
                var cur = curObject_1[_i];
                cur.handler.call(cur.context, argument);
            }
            if (successHandler) successHandler.call(this, argument);
        }
    };
    Observer.prototype.blazorCallback = function(objs, argument, successHandler, errorHandler, index) {
        var _this = this;
        var isTrigger = index === objs.length - 1;
        if (index < objs.length) {
            var obj_1 = objs[parseInt(index.toString(), 10)];
            var promise = obj_1.handler.call(obj_1.context, argument);
            if (promise && typeof promise.then === "function") {
                if (!successHandler) return promise;
                promise.then(function(data) {
                    data = typeof data === "string" && _this.isJson(data) ? JSON.parse(data, _this.dateReviver) : data;
                    (0, $3EnZW.extend)(argument, argument, data, true);
                    if (successHandler && isTrigger) successHandler.call(obj_1.context, argument);
                    else return _this.blazorCallback(objs, argument, successHandler, errorHandler, index + 1);
                }).catch(function(data) {
                    if (errorHandler) errorHandler.call(obj_1.context, typeof data === "string" && _this.isJson(data) ? JSON.parse(data, _this.dateReviver) : data);
                });
            } else if (successHandler && isTrigger) successHandler.call(obj_1.context, argument);
            else return this.blazorCallback(objs, argument, successHandler, errorHandler, index + 1);
        }
    };
    Observer.prototype.dateReviver = function(key, value) {
        var dPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        if ((0, $3EnZW.isBlazor) && typeof value === "string" && value.match(dPattern) !== null) return new Date(value);
        return value;
    };
    Observer.prototype.isJson = function(value) {
        try {
            JSON.parse(value);
        } catch (e) {
            return false;
        }
        return true;
    };
    /**
     * To destroy handlers in the event
     *
     * @returns {void} ?
     */ Observer.prototype.destroy = function() {
        this.boundedEvents = this.context = undefined;
    };
    /**
     * To remove internationalization events
     *
     * @returns {void} ?
     */ Observer.prototype.offIntlEvents = function() {
        var eventsArr = this.boundedEvents["notifyExternalChange"];
        if (eventsArr) {
            for(var i = 0; i < eventsArr.length; i++){
                var curContext = eventsArr[parseInt(i.toString(), 10)].context;
                if (curContext && curContext.detectFunction && curContext.randomId && !curContext.isRendered) {
                    this.off("notifyExternalChange", curContext.detectFunction, curContext.randomId);
                    i--;
                }
            }
            if (!this.boundedEvents["notifyExternalChange"].length) delete this.boundedEvents["notifyExternalChange"];
        }
    };
    /**
     * Returns if the property exists.
     *
     * @param {string} prop ?
     * @returns {boolean} ?
     */ Observer.prototype.notExist = function(prop) {
        return Object.prototype.hasOwnProperty.call(this.boundedEvents, prop) === false || this.boundedEvents["" + prop].length <= 0;
    };
    /**
     * Returns if the handler is present.
     *
     * @param {BoundOptions[]} boundedEvents ?
     * @param {Function} handler ?
     * @returns {boolean} ?
     */ Observer.prototype.isHandlerPresent = function(boundedEvents, handler) {
        for(var _i = 0, boundedEvents_1 = boundedEvents; _i < boundedEvents_1.length; _i++){
            var cur = boundedEvents_1[_i];
            if (cur.handler === handler) return true;
        }
        return false;
    };
    return Observer;
}();

});



parcelRegister("cfGuF", function(module, exports) {

$parcel$export(module.exports, "Ajax", () => $8eb7d91fd805cef0$export$7a330199b2e76989);

var $3EnZW = parcelRequire("3EnZW");
var $8eb7d91fd805cef0$var$headerRegex = /^(.*?):[ \t]*([^\r\n]*)$/gm;
var $8eb7d91fd805cef0$var$defaultType = "GET";
/**
 * Ajax class provides ability to make asynchronous HTTP request to the server
 * ```typescript
 *   var ajax = new Ajax("index.html", "GET", true);
 *   ajax.send().then(
 *               function (value) {
 *                   console.log(value);
 *               },
 *               function (reason) {
 *                   console.log(reason);
 *               });
 * ```
 */ var $8eb7d91fd805cef0$export$7a330199b2e76989 = /** @class */ function() {
    /**
     * Constructor for Ajax class
     *
     * @param  {string|Object} options ?
     * @param  {string} type ?
     * @param  {boolean} async ?
     * @returns defaultType any
     */ function Ajax(options, type, async, contentType) {
        /**
         * A boolean value indicating whether the request should be sent asynchronous or not.
         *
         * @default true
         */ this.mode = true;
        /**
         * A boolean value indicating whether to ignore the promise reject.
         *
         * @private
         * @default true
         */ this.emitError = true;
        this.options = {};
        if (typeof options === "string") {
            this.url = options;
            this.type = type ? type.toUpperCase() : $8eb7d91fd805cef0$var$defaultType;
            this.mode = !(0, $3EnZW.isNullOrUndefined)(async) ? async : true;
        } else if (typeof options === "object") {
            this.options = options;
            (0, $3EnZW.merge)(this, this.options);
        }
        this.type = this.type ? this.type.toUpperCase() : $8eb7d91fd805cef0$var$defaultType;
        this.contentType = this.contentType !== undefined ? this.contentType : contentType;
    }
    /**
     *
     * Send the request to server.
     *
     * @param {any} data - To send the user data
     * @returns {Promise} ?
     */ Ajax.prototype.send = function(data) {
        var _this = this;
        this.data = (0, $3EnZW.isNullOrUndefined)(data) ? this.data : data;
        var eventArgs = {
            cancel: false,
            httpRequest: null
        };
        var promise = new Promise(function(resolve, reject) {
            _this.httpRequest = new XMLHttpRequest();
            _this.httpRequest.onreadystatechange = function() {
                _this.stateChange(resolve, reject);
            };
            if (!(0, $3EnZW.isNullOrUndefined)(_this.onLoad)) _this.httpRequest.onload = _this.onLoad;
            if (!(0, $3EnZW.isNullOrUndefined)(_this.onProgress)) _this.httpRequest.onprogress = _this.onProgress;
            /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(_this.onAbort)) _this.httpRequest.onabort = _this.onAbort;
            /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(_this.onError)) _this.httpRequest.onerror = _this.onError;
            //** Upload Events **/
            /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(_this.onUploadProgress)) _this.httpRequest.upload.onprogress = _this.onUploadProgress;
            _this.httpRequest.open(_this.type, _this.url, _this.mode);
            // Set default headers
            if (!(0, $3EnZW.isNullOrUndefined)(_this.data) && _this.contentType !== null) _this.httpRequest.setRequestHeader("Content-Type", _this.contentType || "application/json; charset=utf-8");
            if (_this.beforeSend) {
                eventArgs.httpRequest = _this.httpRequest;
                _this.beforeSend(eventArgs);
            }
            if (!eventArgs.cancel) _this.httpRequest.send(!(0, $3EnZW.isNullOrUndefined)(_this.data) ? _this.data : null);
        });
        return promise;
    };
    Ajax.prototype.successHandler = function(data) {
        if (this.onSuccess) this.onSuccess(data, this);
        return data;
    };
    Ajax.prototype.failureHandler = function(reason) {
        if (this.onFailure) this.onFailure(this.httpRequest);
        return reason;
    };
    Ajax.prototype.stateChange = function(resolve, reject) {
        var data = this.httpRequest.responseText;
        if (this.dataType && this.dataType.toLowerCase() === "json") {
            if (data === "") data = undefined;
            else try {
                data = JSON.parse(data);
            } catch (error) {
            // no exception handle
            }
        }
        if (this.httpRequest.readyState === 4) {
            //success range should be 200 to 299
            if (this.httpRequest.status >= 200 && this.httpRequest.status <= 299 || this.httpRequest.status === 304) resolve(this.successHandler(data));
            else if (this.emitError) reject(new Error(this.failureHandler(this.httpRequest.statusText)));
            else resolve();
        }
    };
    /**
     * To get the response header from XMLHttpRequest
     *
     * @param  {string} key Key to search in the response header
     * @returns {string} ?
     */ Ajax.prototype.getResponseHeader = function(key) {
        var responseHeaders = {};
        var headers = $8eb7d91fd805cef0$var$headerRegex.exec(this.httpRequest.getAllResponseHeaders());
        while(headers){
            responseHeaders[headers[1].toLowerCase()] = headers[2];
            headers = $8eb7d91fd805cef0$var$headerRegex.exec(this.httpRequest.getAllResponseHeaders());
        }
        var header = responseHeaders[key.toLowerCase()];
        return (0, $3EnZW.isNullOrUndefined)(header) ? null : header;
    };
    return Ajax;
}();

});

parcelRegister("1MTdI", function(module, exports) {

$parcel$export(module.exports, "Fetch", () => $14d51bb39f01acb2$export$1e7deca84b429035);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");
/**
 * The Fetch class provides a way to make asynchronous network requests, typically to retrieve resources from a server.
 * ```typescript
 *   var fetchApi = new Fetch('index.html', 'GET');
 *   fetchApi.send()
 *      .then((value) => {
 *          console.log(value);
 *      }).catch((error) => {
 *          console.log(error);
 *      });
 * ```
 */ var $14d51bb39f01acb2$export$1e7deca84b429035 = /** @class */ function() {
    /**
     * Constructor for Fetch class.
     *
     * @param {string|Object} options - Specifies the URL or Request object with URL to which the request is to be sent.
     * @param {string} type - Specifies which request method is to be used, such as GET, POST, etc.
     * @param {string} contentType - Specifies the content type of the request, which is used to indicate the original media type of the resource.
     */ function Fetch(options, type, contentType) {
        /**
         * Specifies which request method is to be used, such as GET, POST, etc.
         *
         * @default GET
         */ this.type = "GET";
        /**
         * A boolean value indicating whether to reject the promise or not.
         *
         * @private
         * @default true
         */ this.emitError = true;
        if (typeof options === "string") {
            this.url = options;
            this.type = !(0, $3EnZW.isNullOrUndefined)(type) ? type.toUpperCase() : this.type;
            this.contentType = contentType;
        } else if ((0, $3EnZW.isObject)(options) && Object.keys(options).length > 0) (0, $3EnZW.merge)(this, options);
        this.contentType = !(0, $3EnZW.isNullOrUndefined)(this.contentType) ? this.contentType : "application/json; charset=utf-8";
    }
    /**
     * Send the request to server.
     *
     * @param {string|Object} data - Specifies the data that needs to be added to the request.
     * @returns {Promise<Response>} - Returns the response to a request.
     */ Fetch.prototype.send = function(data) {
        var _this = this;
        var contentTypes = {
            "application/json": "json",
            "multipart/form-data": "formData",
            "application/octet-stream": "blob",
            "application/x-www-form-urlencoded": "formData"
        };
        try {
            if ((0, $3EnZW.isNullOrUndefined)(this.fetchRequest) && this.type === "GET") this.fetchRequest = new Request(this.url, {
                method: this.type
            });
            else if ((0, $3EnZW.isNullOrUndefined)(this.fetchRequest)) {
                this.data = !(0, $3EnZW.isNullOrUndefined)(data) ? data : this.data;
                this.fetchRequest = new Request(this.url, {
                    method: this.type,
                    headers: {
                        "Content-Type": this.contentType
                    },
                    body: this.data
                });
            }
            var eventArgs = {
                cancel: false,
                fetchRequest: this.fetchRequest
            };
            this.triggerEvent(this["beforeSend"], eventArgs);
            if (eventArgs.cancel) return null;
            this.fetchResponse = fetch(this.fetchRequest);
            return this.fetchResponse.then(function(response) {
                _this.triggerEvent(_this["onLoad"], response);
                if (!response.ok) throw response;
                var responseType = "text";
                for(var _i = 0, _a = Object.keys(contentTypes); _i < _a.length; _i++){
                    var key = _a[_i];
                    if (response.headers.get("Content-Type") && response.headers.get("Content-Type").indexOf(key) !== -1) responseType = contentTypes[key];
                }
                return response[responseType]();
            }).then(function(data) {
                _this.triggerEvent(_this["onSuccess"], data, _this);
                return data;
            }).catch(function(error) {
                var returnVal = {};
                if (_this.emitError) {
                    _this.triggerEvent(_this["onFailure"], error);
                    returnVal = Promise.reject(error);
                }
                return returnVal;
            });
        } catch (error) {
            return error;
        }
    };
    Fetch.prototype.triggerEvent = function(callback, data, instance) {
        if (!(0, $3EnZW.isNullOrUndefined)(callback) && typeof callback === "function") callback(data, instance);
    };
    return Fetch;
}();

});

parcelRegister("kj1BR", function(module, exports) {

$parcel$export(module.exports, "Animation", () => $ec86d4a6fdd839f3$export$c35d437ae5945fcd);
$parcel$export(module.exports, "animationMode", () => $ec86d4a6fdd839f3$export$50de33de7db4a164);
$parcel$export(module.exports, "rippleEffect", () => $ec86d4a6fdd839f3$export$83e151ccd3b302c1);
$parcel$export(module.exports, "isRippleEnabled", () => $ec86d4a6fdd839f3$export$fc3137faa58fa615);

var $4ZDHT = parcelRequire("4ZDHT");

var $jmffE = parcelRequire("jmffE");

var $5q7BP = parcelRequire("5q7BP");

var $aqzbR = parcelRequire("aqzbR");

var $5rsSz = parcelRequire("5rsSz");
var $ec86d4a6fdd839f3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ec86d4a6fdd839f3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * The Animation framework provide options to animate the html DOM elements
 * ```typescript
 *   let animeObject = new Animation({
 *      name: 'SlideLeftIn',
 *      duration: 1000
 *   });
 *   animeObject.animate('#anime1');
 *   animeObject.animate('#anime2', { duration: 500 });
 * ```
 */ var $ec86d4a6fdd839f3$export$c35d437ae5945fcd = /** @class */ function(_super) {
    $ec86d4a6fdd839f3$var$__extends(Animation, _super);
    function Animation(options) {
        var _this = _super.call(this, options, undefined) || this;
        /**
         * @private
         */ _this.easing = {
            ease: "cubic-bezier(0.250, 0.100, 0.250, 1.000)",
            linear: "cubic-bezier(0.250, 0.250, 0.750, 0.750)",
            easeIn: "cubic-bezier(0.420, 0.000, 1.000, 1.000)",
            easeOut: "cubic-bezier(0.000, 0.000, 0.580, 1.000)",
            easeInOut: "cubic-bezier(0.420, 0.000, 0.580, 1.000)",
            elasticInOut: "cubic-bezier(0.5,-0.58,0.38,1.81)",
            elasticIn: "cubic-bezier(0.17,0.67,0.59,1.81)",
            elasticOut: "cubic-bezier(0.7,-0.75,0.99,1.01)"
        };
        return _this;
    }
    Animation_1 = Animation;
    /**
     * Applies animation to the current element.
     *
     * @param {string | HTMLElement} element - Element which needs to be animated.
     * @param {AnimationModel} options - Overriding default animation settings.
     * @returns {void} ?
     */ Animation.prototype.animate = function(element, options) {
        options = !options ? {} : options;
        var model = this.getModel(options);
        if (typeof element === "string") {
            var elements = Array.prototype.slice.call((0, $4ZDHT.selectAll)(element, document));
            for(var _i = 0, elements_1 = elements; _i < elements_1.length; _i++){
                var element_1 = elements_1[_i];
                model.element = element_1;
                Animation_1.delayAnimation(model);
            }
        } else {
            model.element = element;
            Animation_1.delayAnimation(model);
        }
    };
    /**
     * Stop the animation effect on animated element.
     *
     * @param {HTMLElement} element - Element which needs to be stop the animation.
     * @param {AnimationOptions} model - Handling the animation model at stop function.
     * @returns {void}
     */ Animation.stop = function(element, model) {
        element.style.animation = "";
        element.removeAttribute("e-animate");
        var animationId = element.getAttribute("e-animation-id");
        if (animationId) {
            var frameId = parseInt(animationId, 10);
            cancelAnimationFrame(frameId);
            element.removeAttribute("e-animation-id");
        }
        if (model && model.end) model.end.call(this, model);
    };
    /**
     * Set delay to animation element
     *
     * @param {AnimationModel} model ?
     * @returns {void}
     */ Animation.delayAnimation = function(model) {
        if ($ec86d4a6fdd839f3$export$50de33de7db4a164 === "Disable" || $ec86d4a6fdd839f3$export$50de33de7db4a164 === $ec86d4a6fdd839f3$export$918231179b06f710.Disable) {
            if (model.begin) model.begin.call(this, model);
            if (model.end) model.end.call(this, model);
        } else if (model.delay) setTimeout(function() {
            Animation_1.applyAnimation(model);
        }, model.delay);
        else Animation_1.applyAnimation(model);
    };
    /**
     * Triggers animation
     *
     * @param {AnimationModel} model ?
     * @returns {void}
     */ Animation.applyAnimation = function(model) {
        var _this = this;
        model.timeStamp = 0;
        var step = 0;
        var timerId = 0;
        var prevTimeStamp = 0;
        var duration = model.duration;
        model.element.setAttribute("e-animate", "true");
        var startAnimation = function(timeStamp) {
            try {
                if (timeStamp) {
                    // let step: number = model.timeStamp = timeStamp - startTime;
                    /** phantomjs workaround for timestamp fix */ prevTimeStamp = prevTimeStamp === 0 ? timeStamp : prevTimeStamp;
                    model.timeStamp = timeStamp + model.timeStamp - prevTimeStamp;
                    prevTimeStamp = timeStamp;
                    /** phantomjs workaround end */ // trigger animation begin event
                    if (!step && model.begin) model.begin.call(_this, model);
                    step = step + 1;
                    var avg = model.timeStamp / step;
                    if (model.timeStamp < duration && model.timeStamp + avg < duration && model.element.getAttribute("e-animate")) {
                        // apply animation effect to the current element
                        model.element.style.animation = model.name + " " + model.duration + "ms " + model.timingFunction;
                        if (model.progress) model.progress.call(_this, model);
                        // repeat requestAnimationFrame
                        requestAnimationFrame(startAnimation);
                    } else {
                        // clear requestAnimationFrame
                        cancelAnimationFrame(timerId);
                        model.element.removeAttribute("e-animation-id");
                        model.element.removeAttribute("e-animate");
                        model.element.style.animation = "";
                        if (model.end) model.end.call(_this, model);
                    }
                } else {
                    //startTime = performance.now();
                    // set initial requestAnimationFrame
                    timerId = requestAnimationFrame(startAnimation);
                    model.element.setAttribute("e-animation-id", timerId.toString());
                }
            } catch (e) {
                cancelAnimationFrame(timerId);
                model.element.removeAttribute("e-animation-id");
                if (model.fail) model.fail.call(_this, e);
            }
        };
        startAnimation();
    };
    /**
     * Returns Animation Model
     *
     * @param {AnimationModel} options ?
     * @returns {AnimationModel} ?
     */ Animation.prototype.getModel = function(options) {
        return {
            name: options.name || this.name,
            delay: options.delay || this.delay,
            duration: options.duration !== undefined ? options.duration : this.duration,
            begin: options.begin || this.begin,
            end: options.end || this.end,
            fail: options.fail || this.fail,
            progress: options.progress || this.progress,
            timingFunction: this.easing[options.timingFunction] ? this.easing[options.timingFunction] : options.timingFunction || this.easing[this.timingFunction]
        };
    };
    /**
     * @private
     * @param {AnimationModel} newProp ?
     * @param {AnimationModel} oldProp ?
     * @returns {void} ?
     */ Animation.prototype.onPropertyChanged = function(newProp, oldProp) {
    // no code needed
    };
    /**
     * Returns module name as animation
     *
     * @private
     * @returns {void} ?
     */ Animation.prototype.getModuleName = function() {
        return "animation";
    };
    /**
     *
     * @private
     * @returns {void} ?
     */ Animation.prototype.destroy = function() {
    //Override base destroy;
    };
    var Animation_1;
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Property)("FadeIn")
    ], Animation.prototype, "name", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Property)(400)
    ], Animation.prototype, "duration", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Property)("ease")
    ], Animation.prototype, "timingFunction", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Animation.prototype, "delay", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Animation.prototype, "progress", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Animation.prototype, "begin", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Animation.prototype, "end", void 0);
    $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Animation.prototype, "fail", void 0);
    Animation = Animation_1 = $ec86d4a6fdd839f3$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Animation);
    return Animation;
}((0, $jmffE.Base));
function $ec86d4a6fdd839f3$export$83e151ccd3b302c1(element, rippleOptions, done) {
    var rippleModel = $ec86d4a6fdd839f3$var$getRippleModel(rippleOptions);
    if (rippleModel.rippleFlag === false || rippleModel.rippleFlag === undefined && !$ec86d4a6fdd839f3$export$fc3137faa58fa615) return function() {
    // do nothing.
    };
    element.setAttribute("data-ripple", "true");
    (0, $aqzbR.EventHandler).add(element, "mousedown", $ec86d4a6fdd839f3$var$rippleHandler, {
        parent: element,
        rippleOptions: rippleModel
    });
    (0, $aqzbR.EventHandler).add(element, "mouseup", $ec86d4a6fdd839f3$var$rippleUpHandler, {
        parent: element,
        rippleOptions: rippleModel,
        done: done
    });
    (0, $aqzbR.EventHandler).add(element, "mouseleave", $ec86d4a6fdd839f3$var$rippleLeaveHandler, {
        parent: element,
        rippleOptions: rippleModel
    });
    if ((0, $5q7BP.Browser).isPointer) (0, $aqzbR.EventHandler).add(element, "transitionend", $ec86d4a6fdd839f3$var$rippleLeaveHandler, {
        parent: element,
        rippleOptions: rippleModel
    });
    return function() {
        element.removeAttribute("data-ripple");
        (0, $aqzbR.EventHandler).remove(element, "mousedown", $ec86d4a6fdd839f3$var$rippleHandler);
        (0, $aqzbR.EventHandler).remove(element, "mouseup", $ec86d4a6fdd839f3$var$rippleUpHandler);
        (0, $aqzbR.EventHandler).remove(element, "mouseleave", $ec86d4a6fdd839f3$var$rippleLeaveHandler);
        (0, $aqzbR.EventHandler).remove(element, "transitionend", $ec86d4a6fdd839f3$var$rippleLeaveHandler);
    };
}
/**
 * Handler for ripple model
 *
 * @param {RippleOptions} rippleOptions ?
 * @returns {RippleOptions} ?
 */ function $ec86d4a6fdd839f3$var$getRippleModel(rippleOptions) {
    var rippleModel = {
        selector: rippleOptions && rippleOptions.selector ? rippleOptions.selector : null,
        ignore: rippleOptions && rippleOptions.ignore ? rippleOptions.ignore : null,
        rippleFlag: rippleOptions && rippleOptions.rippleFlag,
        isCenterRipple: rippleOptions && rippleOptions.isCenterRipple,
        duration: rippleOptions && rippleOptions.duration ? rippleOptions.duration : 350
    };
    return rippleModel;
}
/**
 * Handler for ripple event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */ function $ec86d4a6fdd839f3$var$rippleHandler(e) {
    var target = e.target;
    var selector = this.rippleOptions.selector;
    var element = selector ? (0, $4ZDHT.closest)(target, selector) : target;
    if (!element || this.rippleOptions && (0, $4ZDHT.closest)(target, this.rippleOptions.ignore)) return;
    var offset = element.getBoundingClientRect();
    var offsetX = e.pageX - document.body.scrollLeft;
    var offsetY = e.pageY - (!document.body.scrollTop && document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop);
    var pageX = Math.max(Math.abs(offsetX - offset.left), Math.abs(offsetX - offset.right));
    var pageY = Math.max(Math.abs(offsetY - offset.top), Math.abs(offsetY - offset.bottom));
    var radius = Math.sqrt(pageX * pageX + pageY * pageY);
    var diameter = radius * 2 + "px";
    var x = offsetX - offset.left - radius;
    var y = offsetY - offset.top - radius;
    if (this.rippleOptions && this.rippleOptions.isCenterRipple) {
        x = 0;
        y = 0;
        diameter = "100%";
    }
    element.classList.add("e-ripple");
    var duration = this.rippleOptions.duration.toString();
    var styles = "width: " + diameter + ";height: " + diameter + ";left: " + x + "px;top: " + y + "px;" + "transition-duration: " + duration + "ms;";
    var rippleElement = (0, $4ZDHT.createElement)("div", {
        className: "e-ripple-element",
        styles: styles
    });
    element.appendChild(rippleElement);
    window.getComputedStyle(rippleElement).getPropertyValue("opacity");
    rippleElement.style.transform = "scale(1)";
    if (element !== this.parent) (0, $aqzbR.EventHandler).add(element, "mouseleave", $ec86d4a6fdd839f3$var$rippleLeaveHandler, {
        parent: this.parent,
        rippleOptions: this.rippleOptions
    });
}
/**
 * Handler for ripple element mouse up event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */ function $ec86d4a6fdd839f3$var$rippleUpHandler(e) {
    $ec86d4a6fdd839f3$var$removeRipple(e, this);
}
/**
 * Handler for ripple element mouse move event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */ function $ec86d4a6fdd839f3$var$rippleLeaveHandler(e) {
    $ec86d4a6fdd839f3$var$removeRipple(e, this);
}
/**
 * Handler for removing ripple element
 *
 * @param {MouseEvent} e ?
 * @param {RippleArgs} eventArgs ?
 * @returns {void} ?
 * @private
 */ function $ec86d4a6fdd839f3$var$removeRipple(e, eventArgs) {
    var duration = eventArgs.rippleOptions.duration;
    var target = e.target;
    var selector = eventArgs.rippleOptions.selector;
    var element = selector ? (0, $4ZDHT.closest)(target, selector) : target;
    if (!element || element && element.className.indexOf("e-ripple") === -1) return;
    var rippleElements = (0, $4ZDHT.selectAll)(".e-ripple-element", element);
    var rippleElement = rippleElements[rippleElements.length - 1];
    if (rippleElement) rippleElement.style.opacity = "0.5";
    if (eventArgs.parent !== element) (0, $aqzbR.EventHandler).remove(element, "mouseleave", $ec86d4a6fdd839f3$var$rippleLeaveHandler);
    setTimeout(function() {
        if (rippleElement && rippleElement.parentNode) rippleElement.parentNode.removeChild(rippleElement);
        if (!element.getElementsByClassName("e-ripple-element").length) element.classList.remove("e-ripple");
        if (eventArgs.done) eventArgs.done(e);
    }, duration);
}
var $ec86d4a6fdd839f3$export$fc3137faa58fa615 = false;
function $ec86d4a6fdd839f3$export$d3b2d78603b7ae2e(isRipple) {
    $ec86d4a6fdd839f3$export$fc3137faa58fa615 = isRipple;
    return $ec86d4a6fdd839f3$export$fc3137faa58fa615;
}
var $ec86d4a6fdd839f3$export$50de33de7db4a164;
function $ec86d4a6fdd839f3$export$b6a4e276eeb0be5d(value) {
    $ec86d4a6fdd839f3$export$50de33de7db4a164 = value;
}
var $ec86d4a6fdd839f3$export$918231179b06f710;
(function(GlobalAnimationMode) {
    /**
     * Defines the global animation mode as Default. Animation is enabled or disabled based on the component's animation settings.
     */ GlobalAnimationMode["Default"] = "Default";
    /**
     * Defines the global animation mode as Enable. Enables the animation for all components, regardless of the individual component's animation settings.
     */ GlobalAnimationMode["Enable"] = "Enable";
    /**
     * Defines the global animation mode as Disable. Disables the animation for all components, regardless of the individual component's animation settings.
     */ GlobalAnimationMode["Disable"] = "Disable";
})($ec86d4a6fdd839f3$export$918231179b06f710 || ($ec86d4a6fdd839f3$export$918231179b06f710 = {}));

});
parcelRegister("4ZDHT", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3a2ba8e6abfb0c7e$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "attributes", () => $3a2ba8e6abfb0c7e$export$16bd37df0047a29c);
$parcel$export(module.exports, "addClass", () => $3a2ba8e6abfb0c7e$export$d2cf6cd1dc7067d3);
$parcel$export(module.exports, "removeClass", () => $3a2ba8e6abfb0c7e$export$c2255604a80b4506);
$parcel$export(module.exports, "isVisible", () => $3a2ba8e6abfb0c7e$export$795910f5f15a9633);
$parcel$export(module.exports, "prepend", () => $3a2ba8e6abfb0c7e$export$68159836694e22c1);
$parcel$export(module.exports, "append", () => $3a2ba8e6abfb0c7e$export$10d8903dec122b9d);
$parcel$export(module.exports, "detach", () => $3a2ba8e6abfb0c7e$export$3f780019ff766da6);
$parcel$export(module.exports, "remove", () => $3a2ba8e6abfb0c7e$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "select", () => $3a2ba8e6abfb0c7e$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "selectAll", () => $3a2ba8e6abfb0c7e$export$90aca4adda6ff0f5);
$parcel$export(module.exports, "closest", () => $3a2ba8e6abfb0c7e$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "matches", () => $3a2ba8e6abfb0c7e$export$de994efd351b291c);
$parcel$export(module.exports, "setStyleAttribute", () => $3a2ba8e6abfb0c7e$export$c177651ed3862cd6);
$parcel$export(module.exports, "classList", () => $3a2ba8e6abfb0c7e$export$11c615ce16f87241);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Functions related to dom operations.
 */ 
var $aqzbR = parcelRequire("aqzbR");

var $3EnZW = parcelRequire("3EnZW");
var $3a2ba8e6abfb0c7e$var$SVG_REG = /^svg|^path|^g/;
function $3a2ba8e6abfb0c7e$export$c8a8987d4410bf2d(tagName, properties) {
    var element = $3a2ba8e6abfb0c7e$var$SVG_REG.test(tagName) ? document.createElementNS("http://www.w3.org/2000/svg", tagName) : document.createElement(tagName);
    if (typeof properties === "undefined") return element;
    element.innerHTML = properties.innerHTML ? properties.innerHTML : "";
    if (properties.className !== undefined) element.className = properties.className;
    if (properties.id !== undefined) element.id = properties.id;
    if (properties.styles !== undefined) element.setAttribute("style", properties.styles);
    if (properties.attrs !== undefined) $3a2ba8e6abfb0c7e$export$16bd37df0047a29c(element, properties.attrs);
    return element;
}
function $3a2ba8e6abfb0c7e$export$d2cf6cd1dc7067d3(elements, classes) {
    var classList = $3a2ba8e6abfb0c7e$var$getClassList(classes);
    var regExp = RegExp;
    for(var _i = 0, _a = elements; _i < _a.length; _i++){
        var ele = _a[_i];
        for(var _b = 0, classList_1 = classList; _b < classList_1.length; _b++){
            var className = classList_1[_b];
            if ((0, $3EnZW.isObject)(ele)) {
                var curClass = (0, $3EnZW.getValue)("attributes.className", ele);
                if ((0, $3EnZW.isNullOrUndefined)(curClass)) (0, $3EnZW.setValue)("attributes.className", className, ele);
                else if (!new regExp("\\b" + className + "\\b", "i").test(curClass)) (0, $3EnZW.setValue)("attributes.className", curClass + " " + className, ele);
            } else if (!ele.classList.contains(className)) ele.classList.add(className);
        }
    }
    return elements;
}
function $3a2ba8e6abfb0c7e$export$c2255604a80b4506(elements, classes) {
    var classList = $3a2ba8e6abfb0c7e$var$getClassList(classes);
    for(var _i = 0, _a = elements; _i < _a.length; _i++){
        var ele = _a[_i];
        var flag = (0, $3EnZW.isObject)(ele);
        var canRemove = flag ? (0, $3EnZW.getValue)("attributes.className", ele) : ele.className !== "";
        if (canRemove) for(var _b = 0, classList_2 = classList; _b < classList_2.length; _b++){
            var className = classList_2[_b];
            if (flag) {
                var classes_1 = (0, $3EnZW.getValue)("attributes.className", ele);
                var classArr = classes_1.split(" ");
                var index = classArr.indexOf(className);
                if (index !== -1) classArr.splice(index, 1);
                (0, $3EnZW.setValue)("attributes.className", classArr.join(" "), ele);
            } else ele.classList.remove(className);
        }
    }
    return elements;
}
/**
 * The function used to get classlist.
 *
 * @param  {string | string[]} classes - An element the need to check visibility
 * @returns {string[]} ?
 * @private
 */ function $3a2ba8e6abfb0c7e$var$getClassList(classes) {
    var classList = [];
    if (typeof classes === "string") classList.push(classes);
    else classList = classes;
    return classList;
}
function $3a2ba8e6abfb0c7e$export$795910f5f15a9633(element) {
    var ele = element;
    return ele.style.visibility === "" && ele.offsetWidth > 0;
}
function $3a2ba8e6abfb0c7e$export$68159836694e22c1(fromElements, toElement, isEval) {
    var docFrag = document.createDocumentFragment();
    for(var _i = 0, _a = fromElements; _i < _a.length; _i++){
        var ele = _a[_i];
        docFrag.appendChild(ele);
    }
    toElement.insertBefore(docFrag, toElement.firstElementChild);
    if (isEval) $3a2ba8e6abfb0c7e$var$executeScript(toElement);
    return fromElements;
}
function $3a2ba8e6abfb0c7e$export$10d8903dec122b9d(fromElements, toElement, isEval) {
    var docFrag = document.createDocumentFragment();
    if (fromElements instanceof NodeList) while(fromElements.length > 0)docFrag.appendChild(fromElements[0]);
    else for(var _i = 0, _a = fromElements; _i < _a.length; _i++){
        var ele = _a[_i];
        docFrag.appendChild(ele);
    }
    toElement.appendChild(docFrag);
    if (isEval) $3a2ba8e6abfb0c7e$var$executeScript(toElement);
    return fromElements;
}
/**
 * The function is used to evaluate script from Ajax request
 *
 * @param {Element} ele - An element is going to evaluate the script
 * @returns {void} ?
 */ function $3a2ba8e6abfb0c7e$var$executeScript(ele) {
    var eleArray = ele.querySelectorAll("script");
    eleArray.forEach(function(element) {
        var script = document.createElement("script");
        script.text = element.innerHTML;
        document.head.appendChild(script);
        $3a2ba8e6abfb0c7e$export$3f780019ff766da6(script);
    });
}
function $3a2ba8e6abfb0c7e$export$3f780019ff766da6(element) {
    var parentNode = element.parentNode;
    if (parentNode) return parentNode.removeChild(element);
}
function $3a2ba8e6abfb0c7e$export$cd7f480d6b8286c3(element) {
    var parentNode = element.parentNode;
    (0, $aqzbR.EventHandler).clearEvents(element);
    parentNode.removeChild(element);
}
function $3a2ba8e6abfb0c7e$export$16bd37df0047a29c(element, attributes) {
    var keys = Object.keys(attributes);
    var ele = element;
    for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var key = keys_1[_i];
        if ((0, $3EnZW.isObject)(ele)) {
            var iKey = key;
            if (key === "tabindex") iKey = "tabIndex";
            ele.attributes["" + iKey] = attributes["" + key];
        } else ele.setAttribute(key, attributes["" + key]);
    }
    return ele;
}
function $3a2ba8e6abfb0c7e$export$2e6c959c16ff56b8(selector, context, needsVDOM) {
    if (context === void 0) context = document;
    selector = $3a2ba8e6abfb0c7e$var$querySelectId(selector);
    return context.querySelector(selector);
}
function $3a2ba8e6abfb0c7e$export$90aca4adda6ff0f5(selector, context, needsVDOM) {
    if (context === void 0) context = document;
    selector = $3a2ba8e6abfb0c7e$var$querySelectId(selector);
    var nodeList = context.querySelectorAll(selector);
    return nodeList;
}
/**
 * The function selects an id of element from the given context.
 *
 * @param  {string} selector - Selector string need fetch element
 * @returns {string} ?
 * @private
 */ function $3a2ba8e6abfb0c7e$var$querySelectId(selector) {
    var charRegex = /(!|"|\$|%|&|'|\(|\)|\*|\/|:|;|<|=|\?|@|\]|\^|`|{|}|\||\+|~)/g;
    if (selector.match(/#[0-9]/g) || selector.match(charRegex)) {
        var idList = selector.split(",");
        for(var i = 0; i < idList.length; i++){
            var list = idList[parseInt(i.toString(), 10)].split(" ");
            for(var j = 0; j < list.length; j++){
                if (list[parseInt(j.toString(), 10)].indexOf("#") > -1) {
                    if (!list[parseInt(j.toString(), 10)].match(/\[.*\]/)) {
                        var splitId = list[parseInt(j.toString(), 10)].split("#");
                        if (splitId[1].match(/^\d/) || splitId[1].match(charRegex)) {
                            var setId = list[parseInt(j.toString(), 10)].split(".");
                            setId[0] = setId[0].replace(/#/, "[id='") + "']";
                            list[parseInt(j.toString(), 10)] = setId.join(".");
                        }
                    }
                }
            }
            idList[parseInt(i.toString(), 10)] = list.join(" ");
        }
        return idList.join(",");
    }
    return selector;
}
function $3a2ba8e6abfb0c7e$export$ff7f7c97cdce86e(element, selector) {
    var el = element;
    if (typeof el.closest === "function") return el.closest(selector);
    while(el && el.nodeType === 1){
        if ($3a2ba8e6abfb0c7e$export$de994efd351b291c(el, selector)) return el;
        el = el.parentNode;
    }
    return null;
}
function $3a2ba8e6abfb0c7e$export$9866dd70b0dcd4c3(element) {
    var siblings = [];
    var childNodes = Array.prototype.slice.call(element.parentNode.childNodes);
    for(var _i = 0, childNodes_1 = childNodes; _i < childNodes_1.length; _i++){
        var curNode = childNodes_1[_i];
        if (curNode.nodeType === Node.ELEMENT_NODE && element !== curNode) siblings.push(curNode);
    }
    return siblings;
}
function $3a2ba8e6abfb0c7e$export$96e6083444d1bf69(element, property, value) {
    var attrVal;
    var isObj = (0, $3EnZW.isObject)(element);
    if (isObj) attrVal = (0, $3EnZW.getValue)("attributes." + property, element);
    else attrVal = element.getAttribute(property);
    if ((0, $3EnZW.isNullOrUndefined)(attrVal) && value) {
        if (!isObj) element.setAttribute(property, value.toString());
        else element.attributes["" + property] = value;
        attrVal = value;
    }
    return attrVal;
}
function $3a2ba8e6abfb0c7e$export$c177651ed3862cd6(element, attrs) {
    if (attrs !== undefined) Object.keys(attrs).forEach(function(key) {
        element.style["" + key] = attrs["" + key];
    });
}
function $3a2ba8e6abfb0c7e$export$11c615ce16f87241(element, addClasses, removeClasses) {
    $3a2ba8e6abfb0c7e$export$d2cf6cd1dc7067d3([
        element
    ], addClasses);
    $3a2ba8e6abfb0c7e$export$c2255604a80b4506([
        element
    ], removeClasses);
}
function $3a2ba8e6abfb0c7e$export$de994efd351b291c(element, selector) {
    var matches = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;
    if (matches) return matches.call(element, selector);
    else return [].indexOf.call(document.querySelectorAll(selector), element) !== -1;
}
function $3a2ba8e6abfb0c7e$export$9ee1313c0f908fde(ele, innerHTML) {
    ele.innerHTML = innerHTML;
}
function $3a2ba8e6abfb0c7e$export$366b6d00a7e2683b(ele, className) {
    if ((0, $3EnZW.isObject)(ele)) {
        var regExp = RegExp;
        return new regExp("\\b" + className + "\\b", "i").test(ele.attributes.className);
    } else return ele.classList.contains(className);
}
function $3a2ba8e6abfb0c7e$export$ae8e35ea29ddac22(element, deep) {
    if ((0, $3EnZW.isObject)(element)) {
        if (deep) return (0, $3EnZW.extend)({}, {}, element, true);
    } else return element.cloneNode(deep);
}

});
parcelRegister("aqzbR", function(module, exports) {

$parcel$export(module.exports, "EventHandler", () => $7977a12ac6841dfc$export$ce0ba2422a1c7815);

var $3EnZW = parcelRequire("3EnZW");

var $5q7BP = parcelRequire("5q7BP");
/**
 * EventHandler class provides option to add, remove, clear and trigger events to a HTML DOM element
 * ```html
 * <div id="Eventdiv">  </div>
 * <script>
 *   let node: HTMLElement = document.querySelector("#Eventdiv");
 *   EventHandler.addEventListener(node, "click", function(){
 *       // click handler function code
 *   });
 *   EventHandler.addEventListener(node, "onmouseover", function(){
 *       // mouseover handler function code
 *   });
 *   EventHandler.removeEventListener(node, "click", function(){
 *       // click handler function code
 *   });
 *   eventObj.clearEvents();
 * </script>
 * ```
 */ var $7977a12ac6841dfc$export$ce0ba2422a1c7815 = /** @class */ function() {
    function EventHandler() {}
    // to get the event data based on element
    EventHandler.addOrGetEventData = function(element) {
        if ("__eventList" in element) return element.__eventList.events;
        else {
            element.__eventList = {};
            return element.__eventList.events = [];
        }
    };
    /**
     * Add an event to the specified DOM element.
     *
     * @param {any} element - Target HTML DOM element
     * @param {string} eventName - A string that specifies the name of the event
     * @param {Function} listener - Specifies the function to run when the event occurs
     * @param {Object} bindTo - A object that binds 'this' variable in the event handler
     * @param {number} intDebounce - Specifies at what interval given event listener should be triggered.
     * @returns {Function} ?
     */ EventHandler.add = function(element, eventName, listener, bindTo, intDebounce) {
        var eventData = EventHandler.addOrGetEventData(element);
        var debounceListener;
        if (intDebounce) debounceListener = (0, $3EnZW.debounce)(listener, intDebounce);
        else debounceListener = listener;
        if (bindTo) debounceListener = debounceListener.bind(bindTo);
        var event = eventName.split(" ");
        for(var i = 0; i < event.length; i++){
            eventData.push({
                name: event[parseInt(i.toString(), 10)],
                listener: listener,
                debounce: debounceListener
            });
            if ((0, $5q7BP.Browser).isIE) element.addEventListener(event[parseInt(i.toString(), 10)], debounceListener);
            else element.addEventListener(event[parseInt(i.toString(), 10)], debounceListener, {
                passive: false
            });
        }
        return debounceListener;
    };
    /**
     * Remove an event listener that has been attached before.
     *
     * @param {any} element - Specifies the target html element to remove the event
     * @param {string} eventName - A string that specifies the name of the event to remove
     * @param {Function} listener - Specifies the function to remove
     * @returns {void} ?
     */ EventHandler.remove = function(element, eventName, listener) {
        var eventData = EventHandler.addOrGetEventData(element);
        var event = eventName.split(" ");
        var _loop_1 = function(j) {
            var index = -1;
            var debounceListener;
            if (eventData && eventData.length !== 0) eventData.some(function(x, i) {
                return x.name === event[parseInt(j.toString(), 10)] && x.listener === listener ? (index = i, debounceListener = x.debounce, true) : false;
            });
            if (index !== -1) eventData.splice(index, 1);
            if (debounceListener) element.removeEventListener(event[parseInt(j.toString(), 10)], debounceListener);
        };
        for(var j = 0; j < event.length; j++)_loop_1(j);
    };
    /**
     * Clear all the event listeners that has been previously attached to the element.
     *
     * @param {any} element - Specifies the target html element to clear the events
     * @returns {void} ?
     */ EventHandler.clearEvents = function(element) {
        var eventData = EventHandler.addOrGetEventData(element);
        var copyData = (0, $3EnZW.extend)([], undefined, eventData);
        for(var i = 0; i < copyData.length; i++){
            var parseValue = copyData[parseInt(i.toString(), 10)];
            element.removeEventListener(parseValue.name, parseValue.debounce);
            eventData.shift();
        }
    };
    /**
     * Trigger particular event of the element.
     *
     * @param {any} element - Specifies the target html element to trigger the events
     * @param {string} eventName - Specifies the event to trigger for the specified element.
     * Can be a custom event, or any of the standard events.
     * @param {any} eventProp - Additional parameters to pass on to the event properties
     * @returns {void} ?
     */ EventHandler.trigger = function(element, eventName, eventProp) {
        var eventData = EventHandler.addOrGetEventData(element);
        for(var _i = 0, eventData_1 = eventData; _i < eventData_1.length; _i++){
            var event_1 = eventData_1[_i];
            if (event_1.name === eventName) event_1.debounce.call(this, eventProp);
        }
    };
    return EventHandler;
}();

});
parcelRegister("5q7BP", function(module, exports) {

$parcel$export(module.exports, "Browser", () => $3f2548757ea0eaf2$export$5fefc2586e00a689);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");
var $3f2548757ea0eaf2$var$REGX_MOBILE = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
var $3f2548757ea0eaf2$var$REGX_IE = /msie|trident/i;
var $3f2548757ea0eaf2$var$REGX_IE11 = /Trident\/7\./;
var $3f2548757ea0eaf2$var$REGX_IOS = /(ipad|iphone|ipod touch)/i;
var $3f2548757ea0eaf2$var$REGX_IOS7 = /(ipad|iphone|ipod touch);.*os 7_\d|(ipad|iphone|ipod touch);.*os 8_\d/i;
var $3f2548757ea0eaf2$var$REGX_ANDROID = /android/i;
var $3f2548757ea0eaf2$var$REGX_WINDOWS = /trident|windows phone|edge/i;
var $3f2548757ea0eaf2$var$REGX_VERSION = /(version)[ /]([\w.]+)/i;
var $3f2548757ea0eaf2$var$REGX_BROWSER = {
    OPERA: /(opera|opr)(?:.*version|)[ /]([\w.]+)/i,
    EDGE: /(edge)(?:.*version|)[ /]([\w.]+)/i,
    CHROME: /(chrome|crios)[ /]([\w.]+)/i,
    PANTHOMEJS: /(phantomjs)[ /]([\w.]+)/i,
    SAFARI: /(safari)[ /]([\w.]+)/i,
    WEBKIT: /(webkit)[ /]([\w.]+)/i,
    MSIE: /(msie|trident) ([\w.]+)/i,
    MOZILLA: /(mozilla)(?:.*? rv:([\w.]+)|)/i
};
/* istanbul ignore else  */ if (typeof window !== "undefined") window.browserDetails = window.browserDetails || {};
/**
 * Get configuration details for Browser
 *
 * @private
 */ var $3f2548757ea0eaf2$export$5fefc2586e00a689 = /** @class */ function() {
    function Browser() {}
    Browser.extractBrowserDetail = function() {
        var browserInfo = {
            culture: {}
        };
        var keys = Object.keys($3f2548757ea0eaf2$var$REGX_BROWSER);
        var clientInfo = [];
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            clientInfo = Browser.userAgent.match($3f2548757ea0eaf2$var$REGX_BROWSER["" + key]);
            if (clientInfo) {
                browserInfo.name = clientInfo[1].toLowerCase() === "opr" ? "opera" : clientInfo[1].toLowerCase();
                browserInfo.name = clientInfo[1].toLowerCase() === "crios" ? "chrome" : browserInfo.name;
                browserInfo.version = clientInfo[2];
                browserInfo.culture.name = browserInfo.culture.language = navigator.language;
                if (Browser.userAgent.match($3f2548757ea0eaf2$var$REGX_IE11)) {
                    browserInfo.name = "msie";
                    break;
                }
                var version = Browser.userAgent.match($3f2548757ea0eaf2$var$REGX_VERSION);
                if (browserInfo.name === "safari" && version) browserInfo.version = version[2];
                break;
            }
        }
        return browserInfo;
    };
    /**
     * To get events from the browser
     *
     * @param {string} event - type of event triggered.
     * @returns {string} ?
     */ Browser.getEvent = function(event) {
        var events = {
            start: {
                isPointer: "pointerdown",
                isTouch: "touchstart",
                isDevice: "mousedown"
            },
            move: {
                isPointer: "pointermove",
                isTouch: "touchmove",
                isDevice: "mousemove"
            },
            end: {
                isPointer: "pointerup",
                isTouch: "touchend",
                isDevice: "mouseup"
            },
            cancel: {
                isPointer: "pointercancel",
                isTouch: "touchcancel",
                isDevice: "mouseleave"
            }
        };
        return Browser.isPointer ? events["" + event].isPointer : Browser.isTouch ? events["" + event].isTouch + (!Browser.isDevice ? " " + events["" + event].isDevice : "") : events["" + event].isDevice;
    };
    /**
     * To get the Touch start event from browser
     *
     * @returns {string}
     */ Browser.getTouchStartEvent = function() {
        return Browser.getEvent("start");
    };
    /**
     * To get the Touch end event from browser
     *
     * @returns {string}
     */ Browser.getTouchEndEvent = function() {
        return Browser.getEvent("end");
    };
    /**
     * To get the Touch move event from browser
     *
     * @returns {string}
     */ Browser.getTouchMoveEvent = function() {
        return Browser.getEvent("move");
    };
    /**
     * To cancel the touch event from browser
     *
     * @returns {string}
     */ Browser.getTouchCancelEvent = function() {
        return Browser.getEvent("cancel");
    };
    /**
     * Check whether the browser on the iPad device is Safari or not
     *
     * @returns {boolean}
     */ Browser.isSafari = function() {
        return Browser.isDevice && Browser.isIos && Browser.isTouch && typeof window !== "undefined" && window.navigator.userAgent.toLowerCase().indexOf("iphone") === -1 && window.navigator.userAgent.toLowerCase().indexOf("safari") > -1;
    };
    /**
     * To get the value based on provided key and regX
     *
     * @param {string} key ?
     * @param {RegExp} regX ?
     * @returns {Object} ?
     */ Browser.getValue = function(key, regX) {
        var browserDetails = typeof window !== "undefined" ? window.browserDetails : {};
        if (typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 && Browser.isTouch === true && !$3f2548757ea0eaf2$var$REGX_BROWSER.CHROME.test(navigator.userAgent)) {
            browserDetails["isIos"] = true;
            browserDetails["isDevice"] = true;
            browserDetails["isTouch"] = true;
            browserDetails["isPointer"] = true;
        }
        if (typeof window !== "undefined" && window.Capacitor && window.Capacitor.getPlatform() === "ios") browserDetails["isPointer"] = false;
        if ("undefined" === typeof browserDetails["" + key]) return browserDetails["" + key] = regX.test(Browser.userAgent);
        return browserDetails["" + key];
    };
    Object.defineProperty(Browser, "userAgent", {
        get: function() {
            return Browser.uA;
        },
        //Properties
        /**
         * Property specifies the userAgent of the browser. Default userAgent value is based on the browser.
         * Also we can set our own userAgent.
         *
         * @param {string} uA ?
         */ set: function(uA) {
            Browser.uA = uA;
            window.browserDetails = {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "info", {
        //Read Only Properties
        /**
         * Property is to get the browser information like Name, Version and Language
         *
         * @returns {BrowserInfo} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.info)) return window.browserDetails.info = Browser.extractBrowserDetail();
            return window.browserDetails.info;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIE", {
        /**
         * Property is to get whether the userAgent is based IE.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isIE", $3f2548757ea0eaf2$var$REGX_IE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isTouch", {
        /**
         * Property is to get whether the browser has touch support.
         *
         * @returns {boolean} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.isTouch)) return window.browserDetails.isTouch = "ontouchstart" in window.navigator || window && window.navigator && window.navigator.maxTouchPoints > 0 || "ontouchstart" in window;
            return window.browserDetails.isTouch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isPointer", {
        /**
         * Property is to get whether the browser has Pointer support.
         *
         * @returns {boolean} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.isPointer)) return window.browserDetails.isPointer = "pointerEnabled" in window.navigator;
            return window.browserDetails.isPointer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isMSPointer", {
        /**
         * Property is to get whether the browser has MSPointer support.
         *
         * @returns {boolean} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.isMSPointer)) return window.browserDetails.isMSPointer = "msPointerEnabled" in window.navigator;
            return window.browserDetails.isMSPointer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isDevice", {
        /**
         * Property is to get whether the userAgent is device based.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isDevice", $3f2548757ea0eaf2$var$REGX_MOBILE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIos", {
        /**
         * Property is to get whether the userAgent is IOS.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isIos", $3f2548757ea0eaf2$var$REGX_IOS);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIos7", {
        /**
         * Property is to get whether the userAgent is Ios7.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isIos7", $3f2548757ea0eaf2$var$REGX_IOS7);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isAndroid", {
        /**
         * Property is to get whether the userAgent is Android.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isAndroid", $3f2548757ea0eaf2$var$REGX_ANDROID);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isWebView", {
        /**
         * Property is to identify whether application ran in web view.
         *
         * @returns {boolean} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.isWebView)) {
                window.browserDetails.isWebView = !((0, $3EnZW.isUndefined)(window.cordova) && (0, $3EnZW.isUndefined)(window.PhoneGap) && (0, $3EnZW.isUndefined)(window.phonegap) && window.forge !== "object");
                return window.browserDetails.isWebView;
            }
            return window.browserDetails.isWebView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isWindows", {
        /**
         * Property is to get whether the userAgent is Windows.
         *
         * @returns {boolean} ?
         */ get: function() {
            return Browser.getValue("isWindows", $3f2548757ea0eaf2$var$REGX_WINDOWS);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchStartEvent", {
        /**
         * Property is to get the touch start event. It returns event name based on browser.
         *
         * @returns {string} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.touchStartEvent)) return window.browserDetails.touchStartEvent = Browser.getTouchStartEvent();
            return window.browserDetails.touchStartEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchMoveEvent", {
        /**
         * Property is to get the touch move event. It returns event name based on browser.
         *
         * @returns {string} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.touchMoveEvent)) return window.browserDetails.touchMoveEvent = Browser.getTouchMoveEvent();
            return window.browserDetails.touchMoveEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchEndEvent", {
        /**
         * Property is to get the touch end event. It returns event name based on browser.
         *
         * @returns {string} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.touchEndEvent)) return window.browserDetails.touchEndEvent = Browser.getTouchEndEvent();
            return window.browserDetails.touchEndEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchCancelEvent", {
        /**
         * Property is to cancel the touch end event.
         *
         * @returns {string} ?
         */ get: function() {
            if ((0, $3EnZW.isUndefined)(window.browserDetails.touchCancelEvent)) return window.browserDetails.touchCancelEvent = Browser.getTouchCancelEvent();
            return window.browserDetails.touchCancelEvent;
        },
        enumerable: true,
        configurable: true
    });
    /* istanbul ignore next */ Browser.uA = typeof navigator !== "undefined" ? navigator.userAgent : "";
    return Browser;
}();

});



parcelRegister("jmffE", function(module, exports) {

$parcel$export(module.exports, "Base", () => $e17be7097c739b37$export$ef88aa0d34c34520);
$parcel$export(module.exports, "getComponent", () => $e17be7097c739b37$export$21a8719ce41a1de2);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");

var $4ZDHT = parcelRequire("4ZDHT");

var $13zI2 = parcelRequire("13zI2");
var $e17be7097c739b37$var$isColEName = new RegExp("]");
/**
 * Base library module is common module for Framework modules like touch,keyboard and etc.,
 *
 * @private
 * @returns {void} ?
 */ var $e17be7097c739b37$export$ef88aa0d34c34520 = /** @class */ function() {
    /**
     * Base constructor accept options and element
     *
     * @param {Object} options ?
     * @param {string} element ?
     */ function Base(options, element) {
        this.isRendered = false;
        this.isComplexArraySetter = false;
        this.isServerRendered = false;
        this.allowServerDataBinding = true;
        this.isProtectedOnChange = true;
        this.properties = {};
        this.changedProperties = {};
        this.oldProperties = {};
        this.bulkChanges = {};
        this.refreshing = false;
        this.ignoreCollectionWatch = false;
        this.finalUpdate = function() {};
        this.childChangedProperties = {};
        this.modelObserver = new (0, $13zI2.Observer)(this);
        if (!(0, $3EnZW.isUndefined)(element)) {
            if ("string" === typeof element) this.element = document.querySelector(element);
            else this.element = element;
            if (!(0, $3EnZW.isNullOrUndefined)(this.element)) {
                this.isProtectedOnChange = false;
                this.addInstance();
            }
        }
        if (!(0, $3EnZW.isUndefined)(options)) this.setProperties(options, true);
        this.isDestroyed = false;
    }
    /** Property base section */ /**
     * Function used to set bunch of property at a time.
     *
     * @private
     * @param  {Object} prop - JSON object which holds components properties.
     * @param  {boolean} muteOnChange ? - Specifies to true when we set properties.
     * @returns {void} ?
     */ Base.prototype.setProperties = function(prop, muteOnChange) {
        var prevDetection = this.isProtectedOnChange;
        this.isProtectedOnChange = !!muteOnChange;
        (0, $3EnZW.merge)(this, prop);
        if (muteOnChange !== true) {
            (0, $3EnZW.merge)(this.changedProperties, prop);
            this.dataBind();
        } else if ((0, $3EnZW.isBlazor)() && this.isRendered) this.serverDataBind(prop);
        this.finalUpdate();
        this.changedProperties = {};
        this.oldProperties = {};
        this.isProtectedOnChange = prevDetection;
    };
    /**
     * Calls for child element data bind
     *
     * @param {Object} obj ?
     * @param {Object} parent ?
     * @returns {void} ?
     */ Base.callChildDataBind = function(obj, parent) {
        var keys = Object.keys(obj);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (parent["" + key] instanceof Array) for(var _a = 0, _b = parent["" + key]; _a < _b.length; _a++){
                var obj_1 = _b[_a];
                if (obj_1.dataBind !== undefined) obj_1.dataBind();
            }
            else parent["" + key].dataBind();
        }
    };
    Base.prototype.clearChanges = function() {
        this.finalUpdate();
        this.changedProperties = {};
        this.oldProperties = {};
        this.childChangedProperties = {};
    };
    /**
     * Bind property changes immediately to components
     *
     * @returns {void} ?
     */ Base.prototype.dataBind = function() {
        Base.callChildDataBind(this.childChangedProperties, this);
        if (Object.getOwnPropertyNames(this.changedProperties).length) {
            var prevDetection = this.isProtectedOnChange;
            var newChanges = this.changedProperties;
            var oldChanges = this.oldProperties;
            this.clearChanges();
            this.isProtectedOnChange = true;
            this.onPropertyChanged(newChanges, oldChanges);
            this.isProtectedOnChange = prevDetection;
        }
    };
    Base.prototype.serverDataBind = function(newChanges) {
        if (!(0, $3EnZW.isBlazor)()) return;
        newChanges = newChanges ? newChanges : {};
        (0, $3EnZW.extend)(this.bulkChanges, {}, newChanges, true);
        var sfBlazor = "sfBlazor";
        if (this.allowServerDataBinding && window["" + sfBlazor].updateModel) {
            window["" + sfBlazor].updateModel(this);
            this.bulkChanges = {};
        }
    };
    Base.prototype.saveChanges = function(key, newValue, oldValue) {
        if ((0, $3EnZW.isBlazor)()) {
            var newChanges = {};
            newChanges["" + key] = newValue;
            this.serverDataBind(newChanges);
        }
        if (this.isProtectedOnChange) return;
        this.oldProperties["" + key] = oldValue;
        this.changedProperties["" + key] = newValue;
        this.finalUpdate();
        this.finalUpdate = (0, $3EnZW.setImmediate)(this.dataBind.bind(this));
    };
    /** Event Base Section */ /**
     * Adds the handler to the given event listener.
     *
     * @param {string} eventName - A String that specifies the name of the event
     * @param {Function} handler - Specifies the call to run when the event occurs.
     * @returns {void} ?
     */ Base.prototype.addEventListener = function(eventName, handler) {
        this.modelObserver.on(eventName, handler);
    };
    /**
     * Removes the handler from the given event listener.
     *
     * @param {string} eventName - A String that specifies the name of the event to remove
     * @param {Function} handler - Specifies the function to remove
     * @returns {void} ?
     */ Base.prototype.removeEventListener = function(eventName, handler) {
        this.modelObserver.off(eventName, handler);
    };
    /**
     * Triggers the handlers in the specified event.
     *
     * @private
     * @param {string} eventName - Specifies the event to trigger for the specified component properties.
     * Can be a custom event, or any of the standard events.
     * @param {Event} eventProp - Additional parameters to pass on to the event properties
     * @param {Function} successHandler - this function will invoke after event successfully triggered
     * @param {Function} errorHandler - this function will invoke after event if it failured to call.
     * @returns {void} ?
     */ Base.prototype.trigger = function(eventName, eventProp, successHandler, errorHandler) {
        var _this = this;
        if (this.isDestroyed !== true) {
            var prevDetection = this.isProtectedOnChange;
            this.isProtectedOnChange = false;
            var data = this.modelObserver.notify(eventName, eventProp, successHandler, errorHandler);
            if ($e17be7097c739b37$var$isColEName.test(eventName)) {
                var handler = (0, $3EnZW.getValue)(eventName, this);
                if (handler) {
                    var blazor = "Blazor";
                    if (window["" + blazor]) {
                        var promise = handler.call(this, eventProp);
                        if (promise && typeof promise.then === "function") {
                            if (!successHandler) data = promise;
                            else promise.then(function(data) {
                                if (successHandler) {
                                    data = typeof data === "string" && _this.modelObserver.isJson(data) ? JSON.parse(data) : data;
                                    successHandler.call(_this, data);
                                }
                            }).catch(function(data) {
                                if (errorHandler) {
                                    data = typeof data === "string" && _this.modelObserver.isJson(data) ? JSON.parse(data) : data;
                                    errorHandler.call(_this, data);
                                }
                            });
                        } else if (successHandler) successHandler.call(this, eventProp);
                    } else {
                        handler.call(this, eventProp);
                        if (successHandler) successHandler.call(this, eventProp);
                    }
                } else if (successHandler) successHandler.call(this, eventProp);
            }
            this.isProtectedOnChange = prevDetection;
            return data;
        }
    };
    /**
     * To maintain instance in base class
     *
     * @returns {void} ?
     */ Base.prototype.addInstance = function() {
        // Add module class to the root element
        var moduleClass = "e-" + this.getModuleName().toLowerCase();
        (0, $4ZDHT.addClass)([
            this.element
        ], [
            "e-lib",
            moduleClass
        ]);
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.ej2_instances)) this.element.ej2_instances.push(this);
        else (0, $3EnZW.setValue)("ej2_instances", [
            this
        ], this.element);
    };
    /**
     * To remove the instance from the element
     *
     * @returns {void} ?
     */ Base.prototype.destroy = function() {
        var _this = this;
        // eslint-disable-next-line camelcase
        this.element.ej2_instances = this.element.ej2_instances ? this.element.ej2_instances.filter(function(i) {
            if ($e17be7097c739b37$export$c0ad6db86d1edebe) return $e17be7097c739b37$export$c0ad6db86d1edebe(i) !== $e17be7097c739b37$export$c0ad6db86d1edebe(_this);
            return i !== _this;
        }) : [];
        (0, $4ZDHT.removeClass)([
            this.element
        ], [
            "e-" + this.getModuleName()
        ]);
        if (this.element.ej2_instances.length === 0) // Remove module class from the root element
        (0, $4ZDHT.removeClass)([
            this.element
        ], [
            "e-lib"
        ]);
        this.clearChanges();
        this.modelObserver.destroy();
        this.isDestroyed = true;
    };
    return Base;
}();
function $e17be7097c739b37$export$21a8719ce41a1de2(elem, comp) {
    var instance;
    var i;
    var ele = typeof elem === "string" ? document.getElementById(elem) : elem;
    for(i = 0; i < ele.ej2_instances.length; i++){
        instance = ele.ej2_instances[parseInt(i.toString(), 10)];
        if (typeof comp === "string") {
            var compName = instance.getModuleName();
            if (comp === compName) return instance;
        } else {
            if (instance instanceof comp) return instance;
        }
    }
    return undefined;
}
function $e17be7097c739b37$export$6a6b01651d66a2a7(element) {
    var childEle = [].slice.call(element.getElementsByClassName("e-control"));
    for(var i = 0; i < childEle.length; i++){
        var compName = childEle[parseInt(i.toString(), 10)].classList[1].split("e-")[1];
        var compInstance = $e17be7097c739b37$export$21a8719ce41a1de2(childEle[parseInt(i.toString(), 10)], compName);
        if (!(0, $3EnZW.isUndefined)(compInstance)) compInstance.destroy();
    }
}
var $e17be7097c739b37$export$c0ad6db86d1edebe;
var $e17be7097c739b37$export$62e5a8fa6ea8a36a = function(toRaw) {
    $e17be7097c739b37$export$c0ad6db86d1edebe = toRaw;
};

});

parcelRegister("5rsSz", function(module, exports) {

$parcel$export(module.exports, "Property", () => $3f65e0256fde9819$export$41b04b3a73e7216d);
$parcel$export(module.exports, "Complex", () => $3f65e0256fde9819$export$50ceb3fb9926e63e);
$parcel$export(module.exports, "Collection", () => $3f65e0256fde9819$export$fb8073518f34e6ec);
$parcel$export(module.exports, "Event", () => $3f65e0256fde9819$export$d61e24a684f9e51);
$parcel$export(module.exports, "NotifyPropertyChanges", () => $3f65e0256fde9819$export$7f6bab69308c7176);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");
/**
 * Returns the Class Object
 *
 * @param {ClassObject} instance - instance of ClassObject
 * @param {string} curKey - key of the current instance
 * @param {Object} defaultValue - default Value
 * @param {Object[]} type ?
 * @returns {ClassObject} ?
 */ function $3f65e0256fde9819$var$getObject(instance, curKey, defaultValue, type) {
    if (!Object.prototype.hasOwnProperty.call(instance.properties, curKey) || !(instance.properties["" + curKey] instanceof type)) instance.properties["" + curKey] = (0, $3EnZW.createInstance)(type, [
        instance,
        curKey,
        defaultValue
    ]);
    return instance.properties["" + curKey];
}
/**
 * Returns object array
 *
 * @param {ClassObject} instance ?
 * @param {string} curKey ?
 * @param {Object[]} defaultValue ?
 * @param {Object} type ?
 * @param {boolean} isSetter ?
 * @param {boolean} isFactory ?
 * @returns {Object[]} ?
 */ function $3f65e0256fde9819$var$getObjectArray(instance, curKey, defaultValue, type, isSetter, isFactory) {
    var result = [];
    var len = defaultValue ? defaultValue.length : 0;
    for(var i = 0; i < len; i++){
        var curType = type;
        if (isFactory) curType = type(defaultValue[parseInt(i.toString(), 10)], instance);
        if (isSetter) {
            var inst = (0, $3EnZW.createInstance)(curType, [
                instance,
                curKey,
                {},
                true
            ]);
            inst.setProperties(defaultValue[parseInt(i.toString(), 10)], true);
            result.push(inst);
        } else result.push((0, $3EnZW.createInstance)(curType, [
            instance,
            curKey,
            defaultValue[parseInt(i.toString(), 10)],
            false
        ]));
    }
    return result;
}
/**
 * Returns the properties of the object
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$propertyGetter(defaultValue, curKey) {
    return function() {
        if (!Object.prototype.hasOwnProperty.call(this.properties, curKey)) this.properties["" + curKey] = defaultValue;
        return this.properties["" + curKey];
    };
}
/**
 * Set the properties for the object
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$propertySetter(defaultValue, curKey) {
    return function(newValue) {
        if (this.properties["" + curKey] !== newValue) {
            var oldVal = Object.prototype.hasOwnProperty.call(this.properties, curKey) ? this.properties["" + curKey] : defaultValue;
            this.saveChanges(curKey, newValue, oldVal);
            this.properties["" + curKey] = newValue;
        }
    };
}
/**
 * Returns complex objects
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexGetter(defaultValue, curKey, type) {
    return function() {
        return $3f65e0256fde9819$var$getObject(this, curKey, defaultValue, type);
    };
}
/**
 * Sets complex objects
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexSetter(defaultValue, curKey, type) {
    return function(newValue) {
        $3f65e0256fde9819$var$getObject(this, curKey, defaultValue, type).setProperties(newValue);
    };
}
/**
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {FunctionConstructor} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexFactoryGetter(defaultValue, curKey, type) {
    return function() {
        var curType = type({});
        if (Object.prototype.hasOwnProperty.call(this.properties, curKey)) return this.properties["" + curKey];
        else return $3f65e0256fde9819$var$getObject(this, curKey, defaultValue, curType);
    };
}
/**
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexFactorySetter(defaultValue, curKey, type) {
    return function(newValue) {
        var curType = type(newValue, this);
        $3f65e0256fde9819$var$getObject(this, curKey, defaultValue, curType).setProperties(newValue);
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexArrayGetter(defaultValue, curKey, type) {
    return function() {
        var _this = this;
        if (!Object.prototype.hasOwnProperty.call(this.properties, curKey)) {
            var defCollection = $3f65e0256fde9819$var$getObjectArray(this, curKey, defaultValue, type, false);
            this.properties["" + curKey] = defCollection;
        }
        var ignore = this.controlParent !== undefined && this.controlParent.ignoreCollectionWatch || this.ignoreCollectionWatch;
        if (!Object.prototype.hasOwnProperty.call(this.properties["" + curKey], "push") && !ignore) [
            "push",
            "pop"
        ].forEach(function(extendFunc) {
            var descriptor = {
                value: $3f65e0256fde9819$var$complexArrayDefinedCallback(extendFunc, curKey, type, _this.properties["" + curKey]).bind(_this),
                configurable: true
            };
            Object.defineProperty(_this.properties["" + curKey], extendFunc, descriptor);
        });
        if (!Object.prototype.hasOwnProperty.call(this.properties["" + curKey], "isComplexArray")) Object.defineProperty(this.properties["" + curKey], "isComplexArray", {
            value: true
        });
        return this.properties["" + curKey];
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexArraySetter(defaultValue, curKey, type) {
    return function(newValue) {
        this.isComplexArraySetter = true;
        var oldValueCollection = $3f65e0256fde9819$var$getObjectArray(this, curKey, defaultValue, type, false);
        var newValCollection = $3f65e0256fde9819$var$getObjectArray(this, curKey, newValue, type, true);
        this.isComplexArraySetter = false;
        this.saveChanges(curKey, newValCollection, oldValueCollection);
        this.properties["" + curKey] = newValCollection;
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexArrayFactorySetter(defaultValue, curKey, type) {
    return function(newValue) {
        var oldValueCollection = Object.prototype.hasOwnProperty.call(this.properties, curKey) ? this.properties["" + curKey] : defaultValue;
        var newValCollection = $3f65e0256fde9819$var$getObjectArray(this, curKey, newValue, type, true, true);
        this.saveChanges(curKey, newValCollection, oldValueCollection);
        this.properties["" + curKey] = newValCollection;
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {FunctionConstructor} type ?
 * @returns {void} ?
 */ function $3f65e0256fde9819$var$complexArrayFactoryGetter(defaultValue, curKey, type) {
    return function() {
        var curType = type({});
        if (!Object.prototype.hasOwnProperty.call(this.properties, curKey)) {
            var defCollection = $3f65e0256fde9819$var$getObjectArray(this, curKey, defaultValue, curType, false);
            this.properties["" + curKey] = defCollection;
        }
        return this.properties["" + curKey];
    };
}
/**
 *
 * @param {string} dFunc ?
 * @param {string} curKey ?
 * @param {Object} type ?
 * @param {Object} prop ?
 * @returns {Object} ?
 */ function $3f65e0256fde9819$var$complexArrayDefinedCallback(dFunc, curKey, type, prop) {
    return function() {
        var newValue = [];
        for(var _i = 0; _i < arguments.length; _i++)newValue[_i] = arguments[_i];
        var keyString = this.propName ? this.getParentKey() + "." + curKey + "-" : curKey + "-";
        switch(dFunc){
            case "push":
                for(var i = 0; i < newValue.length; i++){
                    var newValueParse = newValue[parseInt(i.toString(), 10)];
                    Array.prototype["" + dFunc].apply(prop, [
                        newValueParse
                    ]);
                    var model = $3f65e0256fde9819$var$getArrayModel(keyString + (prop.length - 1), newValueParse, !this.controlParent, dFunc);
                    this.serverDataBind(model, newValue[parseInt(i.toString(), 10)], false, dFunc);
                }
                break;
            case "pop":
                Array.prototype["" + dFunc].apply(prop);
                var model = $3f65e0256fde9819$var$getArrayModel(keyString + prop.length, null, !this.controlParent, dFunc);
                this.serverDataBind(model, {
                    ejsAction: "pop"
                }, false, dFunc);
                break;
        }
        return prop;
    };
}
/**
 *
 * @param {string} keyString ?
 * @param {Object} value ?
 * @param {boolean} isControlParent ?
 * @param {string} arrayFunction ?
 * @returns {Object} ?
 */ function $3f65e0256fde9819$var$getArrayModel(keyString, value, isControlParent, arrayFunction) {
    var modelObject = keyString;
    if (isControlParent) {
        modelObject = {};
        modelObject["" + keyString] = value;
        if (value && typeof value === "object") {
            var action = "ejsAction";
            modelObject["" + keyString]["" + action] = arrayFunction;
        }
    }
    return modelObject;
}
function $3f65e0256fde9819$export$41b04b3a73e7216d(defaultValue) {
    return function(target, key) {
        var propertyDescriptor = {
            set: $3f65e0256fde9819$var$propertySetter(defaultValue, key),
            get: $3f65e0256fde9819$var$propertyGetter(defaultValue, key),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "prop", defaultValue);
    };
}
function $3f65e0256fde9819$export$50ceb3fb9926e63e(defaultValue, type) {
    return function(target, key) {
        var propertyDescriptor = {
            set: $3f65e0256fde9819$var$complexSetter(defaultValue, key, type),
            get: $3f65e0256fde9819$var$complexGetter(defaultValue, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "complexProp", defaultValue, type);
    };
}
function $3f65e0256fde9819$export$96dc2841702973ef(type) {
    return function(target, key) {
        var propertyDescriptor = {
            set: $3f65e0256fde9819$var$complexFactorySetter({}, key, type),
            get: $3f65e0256fde9819$var$complexFactoryGetter({}, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "complexProp", {}, type);
    };
}
function $3f65e0256fde9819$export$fb8073518f34e6ec(defaultValue, type) {
    return function(target, key) {
        var propertyDescriptor = {
            set: $3f65e0256fde9819$var$complexArraySetter(defaultValue, key, type),
            get: $3f65e0256fde9819$var$complexArrayGetter(defaultValue, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "colProp", defaultValue, type);
    };
}
function $3f65e0256fde9819$export$e1151fb201803298(type) {
    return function(target, key) {
        var propertyDescriptor = {
            set: $3f65e0256fde9819$var$complexArrayFactorySetter([], key, type),
            get: $3f65e0256fde9819$var$complexArrayFactoryGetter([], key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "colProp", {}, type);
    };
}
function $3f65e0256fde9819$export$d61e24a684f9e51() {
    return function(target, key) {
        var eventDescriptor = {
            set: function(newValue) {
                var oldValue = this.properties["" + key];
                if (oldValue !== newValue) {
                    var finalContext = $3f65e0256fde9819$var$getParentContext(this, key);
                    if ((0, $3EnZW.isUndefined)(oldValue) === false) finalContext.context.removeEventListener(finalContext.prefix, oldValue);
                    finalContext.context.addEventListener(finalContext.prefix, newValue);
                    this.properties["" + key] = newValue;
                }
            },
            get: $3f65e0256fde9819$var$propertyGetter(undefined, key),
            enumerable: true,
            configurable: true
        };
        Object.defineProperty(target, key, eventDescriptor);
        $3f65e0256fde9819$var$addPropertyCollection(target, key, "event");
    };
}
function $3f65e0256fde9819$export$7f6bab69308c7176(classConstructor) {
/** Need to code */ }
/**
 * Method  used to create the builderObject for the target component.
 *
 * @param {BuildInfo} target ?
 * @param {string} key ?
 * @param {string} propertyType ?
 * @param {Object} defaultValue ?
 * @param {Function} type ?
 * @returns {void} ?
 * @private
 */ function $3f65e0256fde9819$var$addPropertyCollection(target, key, propertyType, defaultValue, type) {
    if ((0, $3EnZW.isUndefined)(target.propList)) target.propList = {
        props: [],
        complexProps: [],
        colProps: [],
        events: [],
        propNames: [],
        complexPropNames: [],
        colPropNames: [],
        eventNames: []
    };
    target.propList[propertyType + "s"].push({
        propertyName: key,
        defaultValue: defaultValue,
        type: type
    });
    target.propList[propertyType + "Names"].push(key);
}
/**
 * Returns an object containing the builder properties
 *
 * @param {Function} component ?
 * @returns {Object} ?
 * @private
 */ function $3f65e0256fde9819$var$getBuilderProperties(component) {
    if ((0, $3EnZW.isUndefined)(component.prototype.builderObject)) {
        component.prototype.builderObject = {
            properties: {},
            propCollections: [],
            add: function() {
                this.isPropertyArray = true;
                this.propCollections.push((0, $3EnZW.extend)({}, this.properties, {}));
            }
        };
        var rex = /complex/;
        for(var _i = 0, _a = Object.keys(component.prototype.propList); _i < _a.length; _i++){
            var key = _a[_i];
            var _loop_1 = function(prop) {
                if (rex.test(key)) component.prototype.builderObject[prop.propertyName] = function(value) {
                    var childType = {};
                    (0, $3EnZW.merge)(childType, $3f65e0256fde9819$var$getBuilderProperties(prop.type));
                    value(childType);
                    var tempValue;
                    if (!childType.isPropertyArray) tempValue = (0, $3EnZW.extend)({}, childType.properties, {});
                    else tempValue = childType.propCollections;
                    this.properties[prop.propertyName] = tempValue;
                    childType.properties = {};
                    childType.propCollections = [];
                    childType.isPropertyArray = false;
                    return this;
                };
                else component.prototype.builderObject[prop.propertyName] = function(value) {
                    this.properties[prop.propertyName] = value;
                    return this;
                };
            };
            for(var _b = 0, _c = component.prototype.propList["" + key]; _b < _c.length; _b++){
                var prop = _c[_b];
                _loop_1(prop);
            }
        }
    }
    return component.prototype.builderObject;
}
function $3f65e0256fde9819$export$2a92300579d8fa88(component) {
    var builderFunction = function(element) {
        this.element = element;
        return this;
    };
    var instanceFunction = function(element) {
        if (!Object.prototype.hasOwnProperty.call(builderFunction, "create")) {
            builderFunction.prototype = $3f65e0256fde9819$var$getBuilderProperties(component);
            builderFunction.prototype.create = function() {
                var temp = (0, $3EnZW.extend)({}, {}, this.properties);
                this.properties = {};
                return new component(temp, this.element);
            };
        }
        return new builderFunction(element);
    };
    return instanceFunction;
}
/**
 * Returns parent options for the object
 *
 * @param {Object} context ?
 * @param {string} prefix ?
 * @returns {ParentOption} ?
 * @private
 */ function $3f65e0256fde9819$var$getParentContext(context, prefix) {
    if (Object.prototype.hasOwnProperty.call(context, "parentObj") === false) return {
        context: context,
        prefix: prefix
    };
    else {
        var curText = (0, $3EnZW.getValue)("propName", context);
        if (curText) prefix = curText + "-" + prefix;
        return $3f65e0256fde9819$var$getParentContext((0, $3EnZW.getValue)("parentObj", context), prefix);
    }
}

});


parcelRegister("hQxLN", function(module, exports) {

$parcel$export(module.exports, "Component", () => $cfe17cfbbb134812$export$16fa2f45be04daa8);

var $3EnZW = parcelRequire("3EnZW");

var $6gool = parcelRequire("6gool");

var $jmffE = parcelRequire("jmffE");

var $13zI2 = parcelRequire("13zI2");

var $3fcxu = parcelRequire("3fcxu");

var $5rsSz = parcelRequire("5rsSz");

var $bWDaN = parcelRequire("bWDaN");

var $4ZDHT = parcelRequire("4ZDHT");

var $18li4 = parcelRequire("18li4");
var $cfe17cfbbb134812$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cfe17cfbbb134812$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cfe17cfbbb134812$var$componentCount = 0;
var $cfe17cfbbb134812$var$lastPageID;
var $cfe17cfbbb134812$var$lastHistoryLen = 0;
// Decalre the static variable to count the instance
var $cfe17cfbbb134812$var$instancecount = 0;
// Decalre the static variable to find if control limit exceed or not
var $cfe17cfbbb134812$var$isvalid = true;
// We have added styles to inline type so here declare the static variable to detect if banner is added or not
var $cfe17cfbbb134812$var$isBannerAdded = false;
var $cfe17cfbbb134812$export$5f818ca701ed1383 = false;
function $cfe17cfbbb134812$export$ff85987a9ef5b646(status) {
    $cfe17cfbbb134812$export$5f818ca701ed1383 = status;
}
/**
 * Base class for all Essential JavaScript components
 */ var $cfe17cfbbb134812$export$16fa2f45be04daa8 = /** @class */ function(_super) {
    $cfe17cfbbb134812$var$__extends(Component, _super);
    /**
     * Initialize the constructor for component base
     *
     * @param {Object} options ?
     * @param {string} selector ?
     */ function Component(options, selector) {
        var _this = _super.call(this, options, selector) || this;
        _this.randomId = (0, $3EnZW.uniqueID)();
        /**
         * string template option for Blazor template rendering
         *
         * @private
         */ _this.isStringTemplate = false;
        _this.needsID = false;
        _this.isReactHybrid = false;
        _this.isAngular = false;
        _this.isReact = false;
        _this.isVue = false;
        if ((0, $3EnZW.isNullOrUndefined)(_this.enableRtl)) _this.setProperties({
            "enableRtl": (0, $bWDaN.rightToLeft)
        }, true);
        if ((0, $3EnZW.isNullOrUndefined)(_this.locale)) _this.setProperties({
            "locale": (0, $bWDaN.defaultCulture)
        }, true);
        _this.moduleLoader = new (0, $6gool.ModuleLoader)(_this);
        _this.localObserver = new (0, $13zI2.Observer)(_this);
        (0, $bWDaN.onIntlChange).on("notifyExternalChange", _this.detectFunction, _this, _this.randomId);
        // Based on the considered control list we have count the instance
        if (typeof window !== "undefined" && typeof document !== "undefined" && !(0, $18li4.validateLicense)()) {
            if ((0, $18li4.componentList).indexOf(_this.getModuleName()) !== -1) {
                $cfe17cfbbb134812$var$instancecount = $cfe17cfbbb134812$var$instancecount + 1;
                if ($cfe17cfbbb134812$var$instancecount > 5) $cfe17cfbbb134812$var$isvalid = false;
            }
        }
        if (!(0, $3EnZW.isUndefined)(selector)) _this.appendTo();
        return _this;
    }
    Component.prototype.requiredModules = function() {
        return [];
    };
    /**
     * Destroys the sub modules while destroying the widget
     *
     * @returns {void} ?
     */ Component.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.enablePersistence) {
            this.setPersistData();
            this.detachUnloadEvent();
        }
        this.localObserver.destroy();
        if (this.refreshing) return;
        (0, $4ZDHT.removeClass)([
            this.element
        ], [
            "e-control"
        ]);
        this.trigger("destroyed", {
            cancel: false
        });
        _super.prototype.destroy.call(this);
        this.moduleLoader.clean();
        (0, $bWDaN.onIntlChange).off("notifyExternalChange", this.detectFunction, this.randomId);
    };
    /**
     * Applies all the pending property changes and render the component again.
     *
     * @returns {void} ?
     */ Component.prototype.refresh = function() {
        this.refreshing = true;
        this.moduleLoader.clean();
        this.destroy();
        this.clearChanges();
        this.localObserver = new (0, $13zI2.Observer)(this);
        this.preRender();
        this.injectModules();
        this.render();
        this.refreshing = false;
    };
    Component.prototype.accessMount = function() {
        if (this.mount && !this.isReactHybrid) this.mount();
    };
    /**
     * Returns the route element of the component
     *
     * @returns {HTMLElement} ?
     */ Component.prototype.getRootElement = function() {
        if (this.isReactHybrid) return this.actualElement;
        else return this.element;
    };
    /**
     * Returns the persistence data for component
     *
     * @returns {any} ?
     */ Component.prototype.getLocalData = function() {
        var eleId = this.getModuleName() + this.element.id;
        if ($cfe17cfbbb134812$export$5f818ca701ed1383) return window.localStorage.getItem(eleId + this.ej2StatePersistenceVersion);
        else return window.localStorage.getItem(eleId);
    };
    /**
     * Adding unload event to persist data when enable persistence true
     *
     * @returns {void}
     */ Component.prototype.attachUnloadEvent = function() {
        this.handleUnload = this.handleUnload.bind(this);
        window.addEventListener("pagehide", this.handleUnload);
    };
    /**
     * Handling unload event to persist data when enable persistence true
     *
     * @returns {void}
     */ Component.prototype.handleUnload = function() {
        this.setPersistData();
    };
    /**
     * Removing unload event to persist data when enable persistence true
     *
     * @returns {void}
     */ Component.prototype.detachUnloadEvent = function() {
        window.removeEventListener("pagehide", this.handleUnload);
    };
    /**
     * Appends the control within the given HTML element
     *
     * @param {string | HTMLElement} selector - Target element where control needs to be appended
     * @returns {void} ?
     */ Component.prototype.appendTo = function(selector) {
        if (!(0, $3EnZW.isNullOrUndefined)(selector) && typeof selector === "string") this.element = (0, $4ZDHT.select)(selector, document);
        else if (!(0, $3EnZW.isNullOrUndefined)(selector)) this.element = selector;
        if (!(0, $3EnZW.isNullOrUndefined)(this.element)) {
            var moduleClass = "e-" + this.getModuleName().toLowerCase();
            (0, $4ZDHT.addClass)([
                this.element
            ], [
                "e-control",
                moduleClass
            ]);
            this.isProtectedOnChange = false;
            if (this.needsID && !this.element.id) this.element.id = this.getUniqueID(this.getModuleName());
            if (this.enablePersistence) {
                this.mergePersistData();
                this.attachUnloadEvent();
            }
            var inst = (0, $3EnZW.getValue)("ej2_instances", this.element);
            if (!inst || inst.indexOf(this) === -1) _super.prototype.addInstance.call(this);
            this.preRender();
            this.injectModules();
            // Throw a warning for the required modules to be injected.
            var ignoredComponents = {
                schedule: "all",
                diagram: "all",
                PdfViewer: "all",
                grid: [
                    "logger"
                ],
                richtexteditor: [
                    "link",
                    "table",
                    "image",
                    "audio",
                    "video",
                    "formatPainter",
                    "emojiPicker",
                    "pasteCleanup",
                    "htmlEditor",
                    "toolbar",
                    "importExport"
                ],
                treegrid: [
                    "filter"
                ],
                gantt: [
                    "tooltip"
                ],
                chart: [
                    "Export",
                    "Zoom"
                ],
                accumulationchart: [
                    "Export"
                ],
                "query-builder": "all"
            };
            var component = this.getModuleName();
            if (this.requiredModules && (!ignoredComponents["" + component] || ignoredComponents["" + component] !== "all")) {
                var modulesRequired = this.requiredModules();
                for(var _i = 0, _a = this.moduleLoader.getNonInjectedModules(modulesRequired); _i < _a.length; _i++){
                    var module = _a[_i];
                    var moduleName = module.name ? module.name : module.member;
                    if (ignoredComponents["" + component] && ignoredComponents["" + component].indexOf(module.member) !== -1) continue;
                    var componentName = component.charAt(0).toUpperCase() + component.slice(1); // To capitalize the component name
                    console.warn('[WARNING] :: Module "' + moduleName + '" is not available in ' + componentName + " component! You either misspelled the module name or forgot to load it.");
                }
            }
            // Checked weather cases are valid or not. If control leads to more than five counts
            if (!$cfe17cfbbb134812$var$isvalid && !$cfe17cfbbb134812$var$isBannerAdded) {
                (0, $18li4.createLicenseOverlay)();
                $cfe17cfbbb134812$var$isBannerAdded = true;
            }
            this.render();
            if (!this.mount) this.trigger("created");
            else this.accessMount();
        }
    };
    /**
     * It is used to process the post rendering functionalities to a component.
     *
     * @param {Node} wrapperElement ?
     * @returns {void} ?
     */ Component.prototype.renderComplete = function(wrapperElement) {
        if ((0, $3EnZW.isBlazor)()) {
            var sfBlazor = "sfBlazor";
            window["" + sfBlazor].renderComplete(this.element, wrapperElement);
        }
        this.isRendered = true;
    };
    /**
     * When invoked, applies the pending property changes immediately to the component.
     *
     * @returns {void} ?
     */ Component.prototype.dataBind = function() {
        this.injectModules();
        _super.prototype.dataBind.call(this);
    };
    /**
     * Attach one or more  event handler to the current component context.
     * It is used for internal handling event internally within the component only.
     *
     * @param {BoundOptions[]| string} event - It is  optional type either to  Set the collection of event list or the eventName.
     * @param {Function} handler - optional parameter Specifies the handler to run when the event occurs
     * @param {Object} context - optional parameter Specifies the context to be bind in the handler.
     * @returns {void} ?
     * @private
     */ Component.prototype.on = function(event, handler, context) {
        if (typeof event === "string") this.localObserver.on(event, handler, context);
        else for(var _i = 0, event_1 = event; _i < event_1.length; _i++){
            var arg = event_1[_i];
            this.localObserver.on(arg.event, arg.handler, arg.context);
        }
    };
    /**
     * To remove one or more event handler that has been attached with the on() method.
     *
     * @param {BoundOptions[]| string} event - It is  optional type either to  Set the collection of event list or the eventName.
     * @param {Function} handler - optional parameter Specifies the function to run when the event occurs
     * @returns {void} ?
     * @private
     */ Component.prototype.off = function(event, handler) {
        if (typeof event === "string") this.localObserver.off(event, handler);
        else for(var _i = 0, event_2 = event; _i < event_2.length; _i++){
            var arg = event_2[_i];
            this.localObserver.off(arg.event, arg.handler);
        }
    };
    /**
     * To notify the handlers in the specified event.
     *
     * @param {string} property - Specifies the event to be notify.
     * @param {Object} argument - Additional parameters to pass while calling the handler.
     * @returns {void} ?
     * @private
     */ Component.prototype.notify = function(property, argument) {
        if (this.isDestroyed !== true) this.localObserver.notify(property, argument);
    };
    /**
     * Get injected modules
     *
     * @returns {Function} ?
     * @private
     */ Component.prototype.getInjectedModules = function() {
        return this.injectedModules;
    };
    /**
     * Dynamically injects the required modules to the component.
     *
     * @param {Function} moduleList ?
     * @returns {void} ?
     */ Component.Inject = function() {
        var moduleList = [];
        for(var _i = 0; _i < arguments.length; _i++)moduleList[_i] = arguments[_i];
        if (!this.prototype.injectedModules) this.prototype.injectedModules = [];
        for(var i = 0; i < moduleList.length; i++)if (this.prototype.injectedModules.indexOf(moduleList[parseInt(i.toString(), 10)]) === -1) this.prototype.injectedModules.push(moduleList[parseInt(i.toString(), 10)]);
    };
    /**
     * This is a instance method to create an element.
     *
     * @param {string} tagName ?
     * @param {ElementProperties} prop ?
     * @param {boolean} isVDOM ?
     * @returns {any} ?
     * @private
     */ Component.prototype.createElement = function(tagName, prop, isVDOM) {
        return (0, $4ZDHT.createElement)(tagName, prop);
    };
    /**
     *
     * @param {Function} handler - handler to be triggered after state Updated.
     * @param {any} argument - Arguments to be passed to caller.
     * @returns {void} .
     * @private
     */ Component.prototype.triggerStateChange = function(handler, argument) {
        if (this.isReactHybrid) {
            this.setState();
            this.currentContext = {
                calls: handler,
                args: argument
            };
        }
    };
    Component.prototype.injectModules = function() {
        if (this.injectedModules && this.injectedModules.length) this.moduleLoader.inject(this.requiredModules(), this.injectedModules);
    };
    Component.prototype.detectFunction = function(args) {
        var prop = Object.keys(args);
        if (prop.length) this[prop[0]] = args[prop[0]];
    };
    Component.prototype.mergePersistData = function() {
        var data;
        if ($cfe17cfbbb134812$export$5f818ca701ed1383) data = window.localStorage.getItem(this.getModuleName() + this.element.id + this.ej2StatePersistenceVersion);
        else data = window.localStorage.getItem(this.getModuleName() + this.element.id);
        if (!((0, $3EnZW.isNullOrUndefined)(data) || data === "")) this.setProperties(JSON.parse(data), true);
    };
    Component.prototype.setPersistData = function() {
        if (!this.isDestroyed) {
            if ($cfe17cfbbb134812$export$5f818ca701ed1383) window.localStorage.setItem(this.getModuleName() + this.element.id + this.ej2StatePersistenceVersion, this.getPersistData());
            else window.localStorage.setItem(this.getModuleName() + this.element.id, this.getPersistData());
        }
    };
    Component.prototype.renderReactTemplates = function(callback) {
        if (!(0, $3EnZW.isNullOrUndefined)(callback)) callback();
    };
    Component.prototype.clearTemplate = function(templateName, index) {
    //No Code
    };
    Component.prototype.getUniqueID = function(definedName) {
        if (this.isHistoryChanged()) $cfe17cfbbb134812$var$componentCount = 0;
        $cfe17cfbbb134812$var$lastPageID = this.pageID(location.href);
        $cfe17cfbbb134812$var$lastHistoryLen = history.length;
        return definedName + "_" + $cfe17cfbbb134812$var$lastPageID + "_" + $cfe17cfbbb134812$var$componentCount++;
    };
    Component.prototype.pageID = function(url) {
        var hash = 0;
        if (url.length === 0) return hash;
        for(var i = 0; i < url.length; i++){
            var char = url.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
    };
    Component.prototype.isHistoryChanged = function() {
        return $cfe17cfbbb134812$var$lastPageID !== this.pageID(location.href) || $cfe17cfbbb134812$var$lastHistoryLen !== history.length;
    };
    Component.prototype.addOnPersist = function(options) {
        var _this = this;
        var persistObj = {};
        for(var _i = 0, options_1 = options; _i < options_1.length; _i++){
            var key = options_1[_i];
            var objValue = (0, $3EnZW.getValue)(key, this);
            if (!(0, $3EnZW.isUndefined)(objValue)) (0, $3EnZW.setValue)(key, this.getActualProperties(objValue), persistObj);
        }
        return JSON.stringify(persistObj, function(key, value) {
            return _this.getActualProperties(value);
        });
    };
    Component.prototype.getActualProperties = function(obj) {
        if (obj instanceof (0, $3fcxu.ChildProperty)) return (0, $3EnZW.getValue)("properties", obj);
        else return obj;
    };
    Component.prototype.ignoreOnPersist = function(options) {
        return JSON.stringify(this.iterateJsonProperties(this.properties, options));
    };
    Component.prototype.iterateJsonProperties = function(obj, ignoreList) {
        var newObj = {};
        var _loop_1 = function(key) {
            if (ignoreList.indexOf(key) === -1) {
                var value = obj["" + key];
                if (typeof value === "object" && !(value instanceof Array)) {
                    var newList = ignoreList.filter(function(str) {
                        var regExp = RegExp;
                        return new regExp(key + ".").test(str);
                    }).map(function(str) {
                        return str.replace(key + ".", "");
                    });
                    newObj["" + key] = this_1.iterateJsonProperties(this_1.getActualProperties(value), newList);
                } else newObj["" + key] = value;
            }
        };
        var this_1 = this;
        for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
            var key = _a[_i];
            _loop_1(key);
        }
        return newObj;
    };
    $cfe17cfbbb134812$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Component.prototype, "enablePersistence", void 0);
    $cfe17cfbbb134812$var$__decorate([
        (0, $5rsSz.Property)()
    ], Component.prototype, "enableRtl", void 0);
    $cfe17cfbbb134812$var$__decorate([
        (0, $5rsSz.Property)()
    ], Component.prototype, "locale", void 0);
    Component = $cfe17cfbbb134812$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Component);
    return Component;
}((0, $jmffE.Base));
//Function handling for page navigation detection
/* istanbul ignore next */ (function() {
    if (typeof window !== "undefined") window.addEventListener("popstate", /* istanbul ignore next */ function() {
        $cfe17cfbbb134812$var$componentCount = 0;
    });
})();

});
parcelRegister("6gool", function(module, exports) {

$parcel$export(module.exports, "ModuleLoader", () => $48f7285d169bce55$export$5a7a1980e83bc806);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Module loading operations
 */ 
var $3EnZW = parcelRequire("3EnZW");
var $48f7285d169bce55$var$MODULE_SUFFIX = "Module";
var $48f7285d169bce55$export$5a7a1980e83bc806 = /** @class */ function() {
    function ModuleLoader(parent) {
        this.loadedModules = [];
        this.parent = parent;
    }
    /**
     * Inject required modules in component library
     *
     * @returns {void} ?
     * @param {ModuleDeclaration[]} requiredModules - Array of modules to be required
     * @param {Function[]} moduleList - Array of modules to be injected from sample side
     */ ModuleLoader.prototype.inject = function(requiredModules, moduleList) {
        var reqLength = requiredModules.length;
        if (reqLength === 0) {
            this.clean();
            return;
        }
        if (this.loadedModules.length) this.clearUnusedModule(requiredModules);
        for(var i = 0; i < reqLength; i++){
            var modl = requiredModules[parseInt(i.toString(), 10)];
            for(var _i = 0, moduleList_1 = moduleList; _i < moduleList_1.length; _i++){
                var module = moduleList_1[_i];
                var modName = modl.member;
                if (module && module.prototype.getModuleName() === modl.member && !this.isModuleLoaded(modName)) {
                    var moduleObject = (0, $3EnZW.createInstance)(module, modl.args);
                    var memberName = this.getMemberName(modName);
                    if (modl.isProperty) (0, $3EnZW.setValue)(memberName, module, this.parent);
                    else (0, $3EnZW.setValue)(memberName, moduleObject, this.parent);
                    var loadedModule = modl;
                    loadedModule.member = memberName;
                    this.loadedModules.push(loadedModule);
                }
            }
        }
    };
    /**
     * To remove the created object while destroying the control
     *
     * @returns {void}
     */ ModuleLoader.prototype.clean = function() {
        for(var _i = 0, _a = this.loadedModules; _i < _a.length; _i++){
            var modules = _a[_i];
            if (!modules.isProperty) (0, $3EnZW.getValue)(modules.member, this.parent).destroy();
        }
        this.loadedModules = [];
    };
    /**
     * Returns the array of modules that are not loaded in the component library.
     *
     * @param {ModuleDeclaration[]} requiredModules - Array of modules to be required
     * @returns {ModuleDeclaration[]} ?
     * @private
     */ ModuleLoader.prototype.getNonInjectedModules = function(requiredModules) {
        var _this = this;
        return requiredModules.filter(function(module) {
            return !_this.isModuleLoaded(module.member);
        });
    };
    /**
     * Removes all unused modules
     *
     * @param {ModuleDeclaration[]} moduleList ?
     * @returns {void} ?
     */ ModuleLoader.prototype.clearUnusedModule = function(moduleList) {
        var _this = this;
        var usedModules = moduleList.map(function(arg) {
            return _this.getMemberName(arg.member);
        });
        var removableModule = this.loadedModules.filter(function(module) {
            return usedModules.indexOf(module.member) === -1;
        });
        for(var _i = 0, removableModule_1 = removableModule; _i < removableModule_1.length; _i++){
            var mod = removableModule_1[_i];
            if (!mod.isProperty) (0, $3EnZW.getValue)(mod.member, this.parent).destroy();
            this.loadedModules.splice(this.loadedModules.indexOf(mod), 1);
            (0, $3EnZW.deleteObject)(this.parent, mod.member);
        }
    };
    /**
     * To get the name of the member.
     *
     * @param {string} name ?
     * @returns {string} ?
     */ ModuleLoader.prototype.getMemberName = function(name) {
        return name[0].toLowerCase() + name.substring(1) + $48f7285d169bce55$var$MODULE_SUFFIX;
    };
    /**
     * Returns boolean based on whether the module specified is loaded or not
     *
     * @param {string} modName ?
     * @returns {boolean} ?
     */ ModuleLoader.prototype.isModuleLoaded = function(modName) {
        for(var _i = 0, _a = this.loadedModules; _i < _a.length; _i++){
            var mod = _a[_i];
            if (mod.member === this.getMemberName(modName)) return true;
        }
        return false;
    };
    return ModuleLoader;
}();

});

parcelRegister("3fcxu", function(module, exports) {

$parcel$export(module.exports, "ChildProperty", () => $25cc7fcd8d81ac19$export$7d6dfbf5a7a808c3);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3EnZW = parcelRequire("3EnZW");

var $jmffE = parcelRequire("jmffE");
/**
 * To detect the changes for inner properties.
 *
 * @private
 * @returns {void} ?
 */ var $25cc7fcd8d81ac19$export$7d6dfbf5a7a808c3 = /** @class */ function() {
    function ChildProperty(parent, propName, defaultValue, isArray) {
        this.isComplexArraySetter = false;
        this.properties = {};
        this.changedProperties = {};
        this.childChangedProperties = {};
        this.oldProperties = {};
        this.finalUpdate = function() {};
        this.callChildDataBind = (0, $3EnZW.getValue)("callChildDataBind", (0, $jmffE.Base));
        this.parentObj = parent;
        this.controlParent = this.parentObj.controlParent || this.parentObj;
        this.propName = propName;
        this.isParentArray = isArray;
        this.setProperties(defaultValue, true);
    }
    /**
     * Updates the property changes
     *
     * @param {boolean} val ?
     * @param {string} propName ?
     * @returns {void} ?
     */ ChildProperty.prototype.updateChange = function(val, propName) {
        if (val === true) this.parentObj.childChangedProperties["" + propName] = val;
        else delete this.parentObj.childChangedProperties["" + propName];
        if (this.parentObj.updateChange) this.parentObj.updateChange(val, this.parentObj.propName);
    };
    /**
     * Updates time out duration
     *
     * @returns {void} ?
     */ ChildProperty.prototype.updateTimeOut = function() {
        if (this.parentObj.updateTimeOut) {
            this.parentObj.finalUpdate();
            this.parentObj.updateTimeOut();
        } else {
            var changeTime_1 = setTimeout(this.parentObj.dataBind.bind(this.parentObj));
            var clearUpdate = function() {
                clearTimeout(changeTime_1);
            };
            this.finalUpdate = clearUpdate;
        }
    };
    /**
     * Clears changed properties
     *
     * @returns {void} ?
     */ ChildProperty.prototype.clearChanges = function() {
        this.finalUpdate();
        this.updateChange(false, this.propName);
        this.oldProperties = {};
        this.changedProperties = {};
    };
    /**
     * Set property changes
     *
     * @param {Object} prop ?
     * @param {boolean} muteOnChange ?
     * @returns {void} ?
     */ ChildProperty.prototype.setProperties = function(prop, muteOnChange) {
        if (muteOnChange === true) {
            (0, $3EnZW.merge)(this, prop);
            this.updateChange(false, this.propName);
            this.clearChanges();
        } else (0, $3EnZW.merge)(this, prop);
    };
    /**
     * Binds data
     *
     * @returns {void} ?
     */ ChildProperty.prototype.dataBind = function() {
        this.callChildDataBind(this.childChangedProperties, this);
        if (this.isParentArray) {
            var curIndex = this.parentObj[this.propName].indexOf(this);
            if (Object.keys(this.changedProperties).length) {
                (0, $3EnZW.setValue)(this.propName + "." + curIndex, this.changedProperties, this.parentObj.changedProperties);
                (0, $3EnZW.setValue)(this.propName + "." + curIndex, this.oldProperties, this.parentObj.oldProperties);
            }
        } else {
            this.parentObj.changedProperties[this.propName] = this.changedProperties;
            this.parentObj.oldProperties[this.propName] = this.oldProperties;
        }
        this.clearChanges();
    };
    /**
     * Saves changes to newer values
     *
     * @param {string} key ?
     * @param {Object} newValue ?
     * @param {Object} oldValue ?
     * @param {boolean} restrictServerDataBind ?
     * @returns {void} ?
     */ ChildProperty.prototype.saveChanges = function(key, newValue, oldValue, restrictServerDataBind) {
        if (this.controlParent.isProtectedOnChange) return;
        if (!restrictServerDataBind) this.serverDataBind(key, newValue, true);
        this.oldProperties["" + key] = oldValue;
        this.changedProperties["" + key] = newValue;
        this.updateChange(true, this.propName);
        this.finalUpdate();
        this.updateTimeOut();
    };
    ChildProperty.prototype.serverDataBind = function(key, value, isSaveChanges, action) {
        if ((0, $3EnZW.isBlazor)() && !this.parentObj.isComplexArraySetter) {
            var parent_1;
            var newChanges = {};
            var parentKey = isSaveChanges ? this.getParentKey(true) + "." + key : key;
            /* istanbul ignore else  */ if (parentKey.indexOf(".") !== -1) {
                var complexKeys = parentKey.split(".");
                parent_1 = newChanges;
                for(var i = 0; i < complexKeys.length; i++){
                    var isFinal = i === complexKeys.length - 1;
                    parent_1[complexKeys[parseInt(i.toString(), 10)]] = isFinal ? value : {};
                    parent_1 = isFinal ? parent_1 : parent_1[complexKeys[parseInt(i.toString(), 10)]];
                }
            } else {
                newChanges["" + parentKey] = {};
                parent_1 = newChanges["" + parentKey];
                newChanges["" + parentKey]["" + key] = value;
            }
            /* istanbul ignore next */ if (this.isParentArray) {
                var actionProperty = "ejsAction";
                parent_1["" + actionProperty] = action ? action : "none";
            }
            this.controlParent.serverDataBind(newChanges);
        }
    };
    ChildProperty.prototype.getParentKey = function(isSaveChanges) {
        var index = "";
        var propName = this.propName;
        /* istanbul ignore next */ if (this.isParentArray) {
            index = this.parentObj[this.propName].indexOf(this);
            var valueLength = this.parentObj[this.propName].length;
            valueLength = isSaveChanges ? valueLength : valueLength > 0 ? valueLength - 1 : 0;
            index = index !== -1 ? "-" + index : "-" + valueLength;
            propName = propName + index;
        }
        if (this.controlParent !== this.parentObj) propName = this.parentObj.getParentKey() + "." + this.propName + index;
        return propName;
    };
    return ChildProperty;
}();

});

parcelRegister("18li4", function(module, exports) {

$parcel$export(module.exports, "componentList", () => $0d370da92623aedd$export$ba29925aaf75cf94);
$parcel$export(module.exports, "validateLicense", () => $0d370da92623aedd$export$87f9facc4ba348e1);
$parcel$export(module.exports, "createLicenseOverlay", () => $0d370da92623aedd$export$f9b2e4c51d5c6401);

var $4ZDHT = parcelRequire("4ZDHT");

var $3EnZW = parcelRequire("3EnZW");
var $0d370da92623aedd$export$ba29925aaf75cf94 = [
    "grid",
    "pivotview",
    "treegrid",
    "spreadsheet",
    "rangeNavigator",
    "DocumentEditor",
    "listbox",
    "inplaceeditor",
    "PdfViewer",
    "richtexteditor",
    "DashboardLayout",
    "chart",
    "stockChart",
    "circulargauge",
    "diagram",
    "heatmap",
    "lineargauge",
    "maps",
    "slider",
    "smithchart",
    "barcode",
    "sparkline",
    "treemap",
    "bulletChart",
    "kanban",
    "daterangepicker",
    "schedule",
    "gantt",
    "signature",
    "query-builder",
    "drop-down-tree",
    "carousel",
    "filemanager",
    "uploader",
    "accordion",
    "tab",
    "treeview"
];
var $0d370da92623aedd$var$bypassKey = [
    115,
    121,
    110,
    99,
    102,
    117,
    115,
    105,
    111,
    110,
    46,
    105,
    115,
    76,
    105,
    99,
    86,
    97,
    108,
    105,
    100,
    97,
    116,
    101,
    100
];
var $0d370da92623aedd$var$accountURL;
/**
 * License validation module
 *
 * @private
 */ var $0d370da92623aedd$var$LicenseValidator = /** @class */ function() {
    function LicenseValidator(key) {
        this.isValidated = false;
        this.isLicensed = true;
        this.version = "27";
        this.platform = /JavaScript|ASPNET|ASPNETCORE|ASPNETMVC|FileFormats|essentialstudio/i;
        this.errors = {
            noLicense: "<span>This application was built using a trial version of Syncfusion Essential Studio. To remove the license validation message permanently, a valid license key must be included.</span>",
            trailExpired: "<span>This application was built using a trial version of Syncfusion Essential Studio. To remove the license validation message permanently, a valid license key must be included.</span>",
            versionMismatched: "<span>The included Syncfusion license key is invalid.</span>",
            platformMismatched: "<span>The included Syncfusion license key is invalid.</span>",
            invalidKey: "<span>The included Syncfusion license key is invalid.</span>"
        };
        /**
         * To manage licensing operation.
         */ this.manager = function() {
            var licKey = null;
            /**
             * Sets the license key.
             *
             * @param {string} key - Specifies the license key.
             * @returns {void}
             */ function set(key) {
                licKey = key;
            }
            /**
             * Gets the license key.
             *
             * @returns {string} -Gets the license key.
             */ function get() {
                return licKey;
            }
            return {
                setKey: set,
                getKey: get
            };
        }();
        /**
         * To manage npx licensing operation.
         */ this.npxManager = function() {
            var npxLicKey = "npxKeyReplaceurHGscOzwrnAxIuCh36BfoSIi4GCf4OBf4mJiYlwgYGKhYmKhYlwoJ2LUA==";
            /**
             * Gets the license key.
             *
             * @returns {string} - Gets the license key.
             */ function get() {
                return npxLicKey;
            }
            return {
                getKey: get
            };
        }();
        this.manager.setKey(key);
    }
    /**
     * To validate the provided license key.
     *
     * @returns {boolean} ?
     */ LicenseValidator.prototype.validate = function() {
        var contentKey = [
            115,
            121,
            110,
            99,
            102,
            117,
            115,
            105,
            111,
            110,
            46,
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            67,
            111,
            110,
            116,
            101,
            110,
            116
        ];
        var URLKey = [
            115,
            121,
            110,
            99,
            102,
            117,
            115,
            105,
            111,
            110,
            46,
            99,
            108,
            97,
            105,
            109,
            65,
            99,
            99,
            111,
            117,
            110,
            116,
            85,
            82,
            76
        ];
        if (!this.isValidated && (0, $3EnZW.containerObject) && !(0, $3EnZW.getValue)($0d370da92623aedd$var$convertToChar($0d370da92623aedd$var$bypassKey), (0, $3EnZW.containerObject)) && !(0, $3EnZW.getValue)("Blazor", (0, $3EnZW.containerObject))) {
            var validateMsg = void 0;
            var validateURL = void 0;
            if (this.manager && this.manager.getKey() || this.npxManager && this.npxManager.getKey() !== "npxKeyReplace") {
                var result = this.getInfoFromKey();
                if (result && result.length) for(var _i = 0, result_1 = result; _i < result_1.length; _i++){
                    var res = result_1[_i];
                    if (!this.platform.test(res.platform) || res.invalidPlatform) validateMsg = this.errors.platformMismatched;
                    else if (res.version.indexOf(this.version) === -1) {
                        validateMsg = this.errors.versionMismatched;
                        validateMsg = validateMsg.replace("##LicenseVersion", res.version);
                        validateMsg = validateMsg.replace("##Requireversion", this.version + ".x");
                    } else if (res.expiryDate) {
                        var expDate = new Date(res.expiryDate);
                        var currDate = new Date();
                        if (expDate !== currDate && expDate < currDate) validateMsg = this.errors.trailExpired;
                        else break;
                    }
                }
                else validateMsg = this.errors.invalidKey;
            } else {
                var licenseContent = (0, $3EnZW.getValue)($0d370da92623aedd$var$convertToChar(contentKey), (0, $3EnZW.containerObject));
                validateURL = (0, $3EnZW.getValue)($0d370da92623aedd$var$convertToChar(URLKey), (0, $3EnZW.containerObject));
                if (licenseContent && licenseContent !== "") validateMsg = licenseContent;
                else validateMsg = this.errors.noLicense;
            }
            if (validateMsg && typeof document !== "undefined" && !(0, $3EnZW.isNullOrUndefined)(document)) {
                $0d370da92623aedd$var$accountURL = validateURL && validateURL !== "" ? validateURL : "https://www.syncfusion.com/account/claim-license-key?pl=SmF2YVNjcmlwdA==&vs=Mjc=&utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information";
                var errorDiv = (0, $4ZDHT.createElement)("div", {
                    innerHTML: "<img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE5OV80KSI+CjxwYXRoIGQ9Ik0xMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM0M3LjAyOTQ0IDMgMyA3LjAyOTQ0IDMgMTJDMyAxNi45NzA2IDcuMDI5NDQgMjEgMTIgMjFaIiBzdHJva2U9IiM3MzczNzMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMS4yNSAxMS4yNUgxMlYxNi41SDEyLjc1IiBmaWxsPSIjNjE2MDYzIi8+CjxwYXRoIGQ9Ik0xMS4yNSAxMS4yNUgxMlYxNi41SDEyLjc1IiBzdHJva2U9IiM3MzczNzMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMS44MTI1IDlDMTIuNDMzOCA5IDEyLjkzNzUgOC40OTYzMiAxMi45Mzc1IDcuODc1QzEyLjkzNzUgNy4yNTM2OCAxMi40MzM4IDYuNzUgMTEuODEyNSA2Ljc1QzExLjE5MTIgNi43NSAxMC42ODc1IDcuMjUzNjggMTAuNjg3NSA3Ljg3NUMxMC42ODc1IDguNDk2MzIgMTEuMTkxMiA5IDExLjgxMjUgOVoiIGZpbGw9IiM3MzczNzMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xOTlfNCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K' style=\"top: 6px;\n                    position: absolute;\n                    left: 16px;\n                    width: 24px;\n                    height: 24px;\"/>" + validateMsg + " " + '<a style="text-decoration: none;color: #0D6EFD;font-weight: 500;" href=' + $0d370da92623aedd$var$accountURL + ">Claim your free account</a>"
                });
                errorDiv.setAttribute("style", "position: fixed;\n                top: 10px;\n                left: 10px;\n                right: 10px;\n                font-size: 14px;\n                background: #EEF2FF;\n                color: #222222;\n                z-index: 999999999;\n                text-align: left;\n                border: 1px solid #EEEEEE;\n                padding: 10px 11px 10px 50px;\n                border-radius: 8px;\n                font-family: Helvetica Neue, Helvetica, Arial;");
                document.body.appendChild(errorDiv);
                this.isLicensed = false;
            }
            this.isValidated = true;
            (0, $3EnZW.setValue)($0d370da92623aedd$var$convertToChar($0d370da92623aedd$var$bypassKey), this.isValidated, (0, $3EnZW.containerObject));
        }
        return this.isLicensed;
    };
    LicenseValidator.prototype.getDecryptedData = function(key) {
        try {
            return atob(key);
        } catch (error) {
            return "";
        }
    };
    /**
     * Get license information from key.
     *
     * @returns {IValidator} - Get license information from key.
     */ LicenseValidator.prototype.getInfoFromKey = function() {
        try {
            var licKey = "";
            var pkey = [
                5439488,
                7929856,
                5111808,
                6488064,
                4587520,
                7667712,
                5439488,
                6881280,
                5177344,
                7208960,
                4194304,
                4456448,
                6619136,
                7733248,
                5242880,
                7077888,
                6356992,
                7602176,
                4587520,
                7274496,
                7471104,
                7143424
            ];
            var decryptedStr = [];
            var resultArray = [];
            var invalidPlatform = false;
            var isNpxKey = false;
            if (this.manager.getKey()) licKey = this.manager.getKey();
            else {
                isNpxKey = true;
                licKey = this.npxManager.getKey().split("npxKeyReplace")[1];
            }
            var licKeySplit = licKey.split(";");
            for(var _i = 0, licKeySplit_1 = licKeySplit; _i < licKeySplit_1.length; _i++){
                var lKey = licKeySplit_1[_i];
                var decodeStr = this.getDecryptedData(lKey);
                if (!decodeStr) continue;
                var k = 0;
                var buffr = "";
                if (!isNpxKey) for(var i = 0; i < decodeStr.length; i++, k++){
                    if (k === pkey.length) k = 0;
                    var c = decodeStr.charCodeAt(i);
                    buffr += String.fromCharCode(c ^ pkey[parseInt(k.toString(), 10)] >> 16);
                }
                else {
                    var charKey = decodeStr[decodeStr.length - 1];
                    var decryptedKey = [];
                    for(var i = 0; i < decodeStr.length; i++)decryptedKey[parseInt(i.toString(), 10)] = decodeStr[parseInt(i.toString(), 10)].charCodeAt(0) - charKey.charCodeAt(0);
                    for(var i = 0; i < decryptedKey.length; i++)buffr += String.fromCharCode(decryptedKey[parseInt(i.toString(), 10)]);
                }
                if (this.platform.test(buffr)) {
                    decryptedStr = buffr.split(";");
                    invalidPlatform = false;
                    // checked the length to verify the key in proper strucutre
                    if (decryptedStr.length > 3) resultArray.push({
                        platform: decryptedStr[0],
                        version: decryptedStr[1],
                        expiryDate: decryptedStr[2]
                    });
                } else if (buffr && buffr.split(";").length > 3) invalidPlatform = true;
            }
            if (invalidPlatform && !resultArray.length) return [
                {
                    invalidPlatform: invalidPlatform
                }
            ];
            else return resultArray.length ? resultArray : null;
        } catch (error) {
            return null;
        }
    };
    return LicenseValidator;
}();
var $0d370da92623aedd$var$licenseValidator = new $0d370da92623aedd$var$LicenseValidator();
/**
 * Converts the given number to characters.
 *
 * @param {number} cArr - Specifies the license key as number.
 * @returns {string} ?
 */ function $0d370da92623aedd$var$convertToChar(cArr) {
    var ret = "";
    for(var _i = 0, cArr_1 = cArr; _i < cArr_1.length; _i++){
        var arr = cArr_1[_i];
        ret += String.fromCharCode(arr);
    }
    return ret;
}
function $0d370da92623aedd$export$1f53520e2fdc41f1(key) {
    $0d370da92623aedd$var$licenseValidator = new $0d370da92623aedd$var$LicenseValidator(key);
}
var $0d370da92623aedd$export$87f9facc4ba348e1 = function(key) {
    if (key) $0d370da92623aedd$export$1f53520e2fdc41f1(key);
    return $0d370da92623aedd$var$licenseValidator.validate();
};
var $0d370da92623aedd$export$c506eb22e615ba4a = function() {
    return $0d370da92623aedd$var$licenseValidator.version;
};
var $0d370da92623aedd$export$f9b2e4c51d5c6401 = function() {
    var bannerTemplate = '\n    <div style="\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 99999;\n    ">\n        <div style="\n    background: #FFFFFF;\n    height: 455px;\n    width: 840px;\n    font-family: Helvetica Neue, Helvetica, Arial;\n    color: #000000;\n    box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%), 0px 25.6px 57.6px rgb(0 0 0 / 22%);\n    display: block;\n    margin: 8% auto;\n    border-radius: 20px;\n    ">\n            <div style="\n    position: absolute;\nwidth: 838px;\nheight: 62px;\nbackground-color: #F9F9F9;\nborder: 1px solid #EEEEEE;\nborder-top-left-radius: 20px;\nborder-top-right-radius: 20px;\n">\n                <img src="data:image/svg+xml;base64,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" style="\n    text-align: left;\n    width: 146px;\n    position: absolute;\n    top: 14px;\n    left: 31px;\n">\n            </div>\n            <div style="\n    position: relative;\n    top: 80px;\n    left: 32px;\n    font-size: 20px;\n    text-align: left;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    font-style: normal;\n    line-height: 125%;\n    ">Claim your FREE account and get a key in less than a minute</div>\n            <ul style="\n        font-size: 15px;\n        font-weight: 400;\n        color: #333333;\n        letter-spacing: 0.01em;\n        position: relative;\n        left: 32px;\n        top: 88px;\n        line-height: 180%;\n        ">\n                <li><span>Access to a 30-day free trial of any of our products.</span></li>\n                <li><span>Access to 24x5 support by developers via the <a href="https://support.syncfusion.com/create?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information" style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">support tickets</a>, <a href="https://www.syncfusion.com/forums?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information" style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">forum</a>, <a href="https://www.syncfusion.com/feedback?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information\n                " style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">feature &amp; feedback page</a> and chat.</span></li>\n                <li><span>200+ <a href="https://www.syncfusion.com/succinctly-free-ebooks?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information" style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">ebooks </a>on the latest technologies, industry trends, and research topics.</span>\n                </li>\n                <li><span>Largest collection of over 7,000 flat and wireframe icons for free with Syncfusion <a href="https://www.syncfusion.com/downloads/metrostudio?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information\n                " style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">Metro Studio.</a></span></li>\n                <li><span>Free and unlimited access to Syncfusion technical <a href="https://www.syncfusion.com/blogs/?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information\n                " style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">blogs</a> and <a href="https://www.syncfusion.com/resources/techportal/whitepapers?utm_source=es_license_validation_banner&utm_medium=listing&utm_campaign=license-information" style="text-decoration: none;\n                color: #0D6EFD;\n                font-weight: 500;">whitepapers.</a></span></li>\n            </ul>\n            <div style="\n            font-size: 18px;\n            font-weight: 700;\n            position: relative;\n            line-height: 125%;\n            letter-spacing: 0.02em;\n            top: 90px;\n            left: 32px;\n    ">Syncfusion is trusted by 29,000+ businesses worldwide</div>\n            <img src="data:image/svg+xml;base64,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" style="\n            width: 742.5px;\n            position: relative;\n            top: 107px;\n            left: 32px;\n            ">\n            <a href=' + $0d370da92623aedd$var$accountURL + ' style="\n        float: left;\n        border-radius: 56px;\n        background: #0D6EFD;\n        padding-top: 8px;\n        width: 280px;\n        height: 38px;\n        text-align: center;\n        position: relative;\n        top: 127px;\n        left: 274px;\n        font-size: 16px;\n        color: white;\n        text-decoration: none;\n        letter-spacing: 0.02em;\n    ">Claim your FREE account</a>\n            <div style="\n    font-size: 14px;\n    position: relative;\n    top: 180px;\n    left: 19px;\n    letter-spacing: 0.02em;\n    font-weight: 500;\n    line-height: 125%;\n">have a Syncfusion account? <a href="https://www.syncfusion.com/account/login?ReturnUrl=/account/login" style="text-decoration: none;\ncolor: #0D6EFD;\nfont-weight: 500;">Sign In</a></div>\n        </div>\n    </div>';
    if (typeof document !== "undefined" && !(0, $3EnZW.isNullOrUndefined)(document)) {
        var errorBackground = (0, $4ZDHT.createElement)("div", {
            innerHTML: bannerTemplate
        });
        document.body.appendChild(errorBackground);
    }
};

});


parcelRegister("eAUyT", function(module, exports) {

$parcel$export(module.exports, "Draggable", () => $aa004d7cf7acd014$export$f2a139e5d18b9882);

var $jmffE = parcelRequire("jmffE");

var $5q7BP = parcelRequire("5q7BP");

var $4ZDHT = parcelRequire("4ZDHT");

var $5rsSz = parcelRequire("5rsSz");

var $aqzbR = parcelRequire("aqzbR");

var $3fcxu = parcelRequire("3fcxu");

var $3EnZW = parcelRequire("3EnZW");
var $aa004d7cf7acd014$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa004d7cf7acd014$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa004d7cf7acd014$var$defaultPosition = {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
};
var $aa004d7cf7acd014$var$isDraggedObject = {
    isDragged: false
};
/**
 * Specifies the position coordinates
 */ var $aa004d7cf7acd014$export$13807d9ee5a34a42 = /** @class */ function(_super) {
    $aa004d7cf7acd014$var$__extends(Position, _super);
    function Position() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Position.prototype, "left", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Position.prototype, "top", void 0);
    return Position;
}((0, $3fcxu.ChildProperty));
/**
 * Draggable Module provides support to enable draggable functionality in Dom Elements.
 * ```html
 * <div id='drag'>Draggable</div>
 * <script>
 * var ele = document.getElementById('drag');
 * var drag:Draggable = new Draggable(ele,{
 *     clone:false,
 *     drag: function(e) {
 *      //drag handler code.
 *      },
 *     handle:'.class'
 * });
 * </script>
 * ```
 */ var $aa004d7cf7acd014$export$f2a139e5d18b9882 = /** @class */ function(_super) {
    $aa004d7cf7acd014$var$__extends(Draggable, _super);
    function Draggable(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.dragLimit = Draggable_1.getDefaultPosition();
        _this.borderWidth = Draggable_1.getDefaultPosition();
        _this.padding = Draggable_1.getDefaultPosition();
        _this.diffX = 0;
        _this.prevLeft = 0;
        _this.prevTop = 0;
        _this.dragProcessStarted = false;
        _this.eleTop = 0;
        _this.tapHoldTimer = 0;
        _this.externalInitialize = false;
        _this.diffY = 0;
        _this.parentScrollX = 0;
        _this.parentScrollY = 0;
        _this.droppables = {};
        _this.bind();
        return _this;
    }
    Draggable_1 = Draggable;
    Draggable.prototype.bind = function() {
        this.toggleEvents();
        if ((0, $5q7BP.Browser).isIE) (0, $4ZDHT.addClass)([
            this.element
        ], "e-block-touch");
        this.droppables[this.scope] = {};
    };
    Draggable.getDefaultPosition = function() {
        return (0, $3EnZW.extend)({}, $aa004d7cf7acd014$var$defaultPosition);
    };
    Draggable.prototype.toggleEvents = function(isUnWire) {
        var ele;
        if (!(0, $3EnZW.isUndefined)(this.handle)) ele = (0, $4ZDHT.select)(this.handle, this.element);
        var handler = this.enableTapHold && (0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isTouch ? this.mobileInitialize : this.initialize;
        if (isUnWire) (0, $aqzbR.EventHandler).remove(ele || this.element, (0, $5q7BP.Browser).isSafari() ? "touchstart" : (0, $5q7BP.Browser).touchStartEvent, handler);
        else (0, $aqzbR.EventHandler).add(ele || this.element, (0, $5q7BP.Browser).isSafari() ? "touchstart" : (0, $5q7BP.Browser).touchStartEvent, handler, this);
    };
    /* istanbul ignore next */ Draggable.prototype.mobileInitialize = function(evt) {
        var _this = this;
        var target = evt.currentTarget;
        this.tapHoldTimer = setTimeout(function() {
            _this.externalInitialize = true;
            _this.removeTapholdTimer();
            _this.initialize(evt, target);
        }, this.tapHoldThreshold);
        (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.removeTapholdTimer, this);
        (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.removeTapholdTimer, this);
    };
    /* istanbul ignore next */ Draggable.prototype.removeTapholdTimer = function() {
        clearTimeout(this.tapHoldTimer);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.removeTapholdTimer);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.removeTapholdTimer);
    };
    /* istanbul ignore next */ Draggable.prototype.getScrollableParent = function(element, axis) {
        var scroll = {
            "vertical": "scrollHeight",
            "horizontal": "scrollWidth"
        };
        var client = {
            "vertical": "clientHeight",
            "horizontal": "clientWidth"
        };
        if ((0, $3EnZW.isNullOrUndefined)(element)) return null;
        if (element[scroll["" + axis]] > element[client["" + axis]]) {
            if (axis === "vertical" ? element.scrollTop > 0 : element.scrollLeft > 0) {
                if (axis === "vertical") {
                    this.parentScrollY = this.parentScrollY + (this.parentScrollY === 0 ? element.scrollTop : element.scrollTop - this.parentScrollY);
                    this.tempScrollHeight = element.scrollHeight;
                } else {
                    this.parentScrollX = this.parentScrollX + (this.parentScrollX === 0 ? element.scrollLeft : element.scrollLeft - this.parentScrollX);
                    this.tempScrollWidth = element.scrollWidth;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(element)) return this.getScrollableParent(element.parentNode, axis);
                else return element;
            } else return this.getScrollableParent(element.parentNode, axis);
        } else return this.getScrollableParent(element.parentNode, axis);
    };
    Draggable.prototype.getScrollableValues = function() {
        this.parentScrollX = 0;
        this.parentScrollY = 0;
        var isModalDialog = this.element.classList.contains("e-dialog") && this.element.classList.contains("e-dlg-modal");
        var verticalScrollParent = this.getScrollableParent(this.element.parentNode, "vertical");
        var horizontalScrollParent = this.getScrollableParent(this.element.parentNode, "horizontal");
    };
    Draggable.prototype.initialize = function(evt, curTarget) {
        this.currentStateTarget = evt.target;
        if (this.isDragStarted()) return;
        else {
            this.isDragStarted(true);
            this.externalInitialize = false;
        }
        this.target = evt.currentTarget || curTarget;
        this.dragProcessStarted = false;
        if (this.abort) {
            var abortSelectors = this.abort;
            if (typeof abortSelectors === "string") abortSelectors = [
                abortSelectors
            ];
            for(var i = 0; i < abortSelectors.length; i++)if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(evt.target, abortSelectors[parseInt(i.toString(), 10)]))) {
                /* istanbul ignore next */ if (this.isDragStarted()) this.isDragStarted(true);
                return;
            }
        }
        if (this.preventDefault && !(0, $3EnZW.isUndefined)(evt.changedTouches) && evt.type !== "touchstart") evt.preventDefault();
        this.element.setAttribute("aria-grabbed", "true");
        var intCoord = this.getCoordinates(evt);
        this.initialPosition = {
            x: intCoord.pageX,
            y: intCoord.pageY
        };
        if (!this.clone) {
            var pos = this.element.getBoundingClientRect();
            this.getScrollableValues();
            if (evt.clientX === evt.pageX) this.parentScrollX = 0;
            if (evt.clientY === evt.pageY) this.parentScrollY = 0;
            this.relativeXPosition = intCoord.pageX - (pos.left + this.parentScrollX);
            this.relativeYPosition = intCoord.pageY - (pos.top + this.parentScrollY);
        }
        if (this.externalInitialize) this.intDragStart(evt);
        else {
            (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.intDragStart, this);
            (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDestroy, this);
        }
        this.toggleEvents(true);
        if (evt.type !== "touchstart" && this.isPreventSelect) document.body.classList.add("e-prevent-select");
        this.externalInitialize = false;
        (0, $aqzbR.EventHandler).trigger(document.documentElement, (0, $5q7BP.Browser).isSafari() ? "touchstart" : (0, $5q7BP.Browser).touchStartEvent, evt);
    };
    Draggable.prototype.intDragStart = function(evt) {
        this.removeTapholdTimer();
        var isChangeTouch = !(0, $3EnZW.isUndefined)(evt.changedTouches);
        if (isChangeTouch && evt.changedTouches.length !== 1) return;
        var intCordinate = this.getCoordinates(evt);
        var pos;
        var styleProp = getComputedStyle(this.element);
        this.margin = {
            left: parseInt(styleProp.marginLeft, 10),
            top: parseInt(styleProp.marginTop, 10),
            right: parseInt(styleProp.marginRight, 10),
            bottom: parseInt(styleProp.marginBottom, 10)
        };
        var element = this.element;
        if (this.clone && this.dragTarget) {
            var intClosest = (0, $4ZDHT.closest)(evt.target, this.dragTarget);
            if (!(0, $3EnZW.isNullOrUndefined)(intClosest)) element = intClosest;
        }
        /* istanbul ignore next */ if (this.isReplaceDragEle) element = this.currentStateCheck(evt.target, element);
        this.offset = this.calculateParentPosition(element);
        this.position = this.getMousePosition(evt, this.isDragScroll);
        var x = this.initialPosition.x - intCordinate.pageX;
        var y = this.initialPosition.y - intCordinate.pageY;
        var distance = Math.sqrt(x * x + y * y);
        if (distance >= this.distance || this.externalInitialize) {
            var ele = this.getHelperElement(evt);
            if (!ele || (0, $3EnZW.isNullOrUndefined)(ele)) return;
            if (isChangeTouch) evt.preventDefault();
            var dragTargetElement = this.helperElement = ele;
            this.parentClientRect = this.calculateParentPosition(dragTargetElement.offsetParent);
            if (this.dragStart) {
                var curTarget = this.getProperTargetElement(evt);
                var args = {
                    event: evt,
                    element: element,
                    target: curTarget,
                    bindEvents: (0, $3EnZW.isBlazor)() ? this.bindDragEvents.bind(this) : null,
                    dragElement: dragTargetElement
                };
                this.trigger("dragStart", args);
            }
            if (this.dragArea) this.setDragArea();
            else {
                this.dragLimit = {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0
                };
                this.borderWidth = {
                    top: 0,
                    left: 0
                };
            }
            pos = {
                left: this.position.left - this.parentClientRect.left,
                top: this.position.top - this.parentClientRect.top
            };
            if (this.clone && !this.enableTailMode) {
                this.diffX = this.position.left - this.offset.left;
                this.diffY = this.position.top - this.offset.top;
            }
            this.getScrollableValues();
            // when drag element has margin-top
            var styles = getComputedStyle(element);
            var marginTop = parseFloat(styles.marginTop);
            /* istanbul ignore next */ if (this.clone && marginTop !== 0) pos.top += marginTop;
            this.eleTop = !isNaN(parseFloat(styles.top)) ? parseFloat(styles.top) - this.offset.top : 0;
            /* istanbul ignore next */ // if (this.eleTop > 0) {
            //     pos.top += this.eleTop;
            // }
            if (this.enableScrollHandler && !this.clone) {
                pos.top -= this.parentScrollY;
                pos.left -= this.parentScrollX;
            }
            var posValue = this.getProcessedPositionValue({
                top: pos.top - this.diffY + "px",
                left: pos.left - this.diffX + "px"
            });
            if (this.dragArea && typeof this.dragArea !== "string" && this.dragArea.classList.contains("e-kanban-content") && this.dragArea.style.position === "relative") pos.top += this.dragArea.scrollTop;
            this.dragElePosition = {
                top: pos.top,
                left: pos.left
            };
            (0, $4ZDHT.setStyleAttribute)(dragTargetElement, this.getDragPosition({
                position: "absolute",
                left: posValue.left,
                top: posValue.top
            }));
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.intDragStart);
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDestroy);
            if (!(0, $3EnZW.isBlazor)()) this.bindDragEvents(dragTargetElement);
        }
    };
    Draggable.prototype.bindDragEvents = function(dragTargetElement) {
        if ((0, $4ZDHT.isVisible)(dragTargetElement)) {
            (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.intDrag, this);
            (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDragStop, this);
            this.setGlobalDroppables(false, this.element, dragTargetElement);
        } else {
            this.toggleEvents();
            document.body.classList.remove("e-prevent-select");
        }
    };
    Draggable.prototype.elementInViewport = function(el) {
        this.top = el.offsetTop;
        this.left = el.offsetLeft;
        this.width = el.offsetWidth;
        this.height = el.offsetHeight;
        while(el.offsetParent){
            el = el.offsetParent;
            this.top += el.offsetTop;
            this.left += el.offsetLeft;
        }
        return this.top >= window.pageYOffset && this.left >= window.pageXOffset && this.top + this.height <= window.pageYOffset + window.innerHeight && this.left + this.width <= window.pageXOffset + window.innerWidth;
    };
    Draggable.prototype.getProcessedPositionValue = function(value) {
        if (this.queryPositionInfo) return this.queryPositionInfo(value);
        return value;
    };
    Draggable.prototype.calculateParentPosition = function(ele) {
        if ((0, $3EnZW.isNullOrUndefined)(ele)) return {
            left: 0,
            top: 0
        };
        var rect = ele.getBoundingClientRect();
        var style = getComputedStyle(ele);
        return {
            left: rect.left + window.pageXOffset - parseInt(style.marginLeft, 10),
            top: rect.top + window.pageYOffset - parseInt(style.marginTop, 10)
        };
    };
    Draggable.prototype.intDrag = function(evt) {
        if (!(0, $3EnZW.isUndefined)(evt.changedTouches) && evt.changedTouches.length !== 1) return;
        if (this.clone && evt.changedTouches && (0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isTouch) evt.preventDefault();
        var left;
        var top;
        this.position = this.getMousePosition(evt, this.isDragScroll);
        var docHeight = this.getDocumentWidthHeight("Height");
        if (docHeight < this.position.top) this.position.top = docHeight;
        var docWidth = this.getDocumentWidthHeight("Width");
        if (docWidth < this.position.left) this.position.left = docWidth;
        if (this.drag) {
            var curTarget = this.getProperTargetElement(evt);
            this.trigger("drag", {
                event: evt,
                element: this.element,
                target: curTarget
            });
        }
        var eleObj = this.checkTargetElement(evt);
        if (eleObj.target && eleObj.instance) {
            var flag = true;
            if (this.hoverObject) {
                if (this.hoverObject.instance !== eleObj.instance) this.triggerOutFunction(evt, eleObj);
                else flag = false;
            }
            if (flag) {
                eleObj.instance.dragData[this.scope] = this.droppables[this.scope];
                eleObj.instance.intOver(evt, eleObj.target);
                this.hoverObject = eleObj;
            }
        } else if (this.hoverObject) this.triggerOutFunction(evt, eleObj);
        var helperElement = this.droppables[this.scope].helper;
        this.parentClientRect = this.calculateParentPosition(this.helperElement.offsetParent);
        var tLeft = this.parentClientRect.left;
        var tTop = this.parentClientRect.top;
        var intCoord = this.getCoordinates(evt);
        var pagex = intCoord.pageX;
        var pagey = intCoord.pageY;
        var dLeft = this.position.left - this.diffX;
        var dTop = this.position.top - this.diffY;
        var styles = getComputedStyle(helperElement);
        if (this.dragArea) {
            if (this.enableAutoScroll) this.setDragArea();
            if (this.pageX !== pagex || this.skipDistanceCheck) {
                var helperWidth = helperElement.offsetWidth + (parseFloat(styles.marginLeft) + parseFloat(styles.marginRight));
                if (this.dragLimit.left > dLeft && dLeft > 0) left = this.dragLimit.left;
                else if (this.dragLimit.right + window.pageXOffset < dLeft + helperWidth && dLeft > 0) left = dLeft - (dLeft - this.dragLimit.right) + window.pageXOffset - helperWidth;
                else left = dLeft < 0 ? this.dragLimit.left : dLeft;
            }
            if (this.pageY !== pagey || this.skipDistanceCheck) {
                var helperHeight = helperElement.offsetHeight + (parseFloat(styles.marginTop) + parseFloat(styles.marginBottom));
                if (this.dragLimit.top > dTop && dTop > 0) top = this.dragLimit.top;
                else if (this.dragLimit.bottom + window.pageYOffset < dTop + helperHeight && dTop > 0) top = dTop - (dTop - this.dragLimit.bottom) + window.pageYOffset - helperHeight;
                else top = dTop < 0 ? this.dragLimit.top : dTop;
            }
        } else {
            left = dLeft;
            top = dTop;
        }
        var iTop = tTop + this.borderWidth.top;
        var iLeft = tLeft + this.borderWidth.left;
        if (this.dragProcessStarted) {
            if ((0, $3EnZW.isNullOrUndefined)(top)) top = this.prevTop;
            if ((0, $3EnZW.isNullOrUndefined)(left)) left = this.prevLeft;
        }
        var draEleTop;
        var draEleLeft;
        if (this.helperElement.classList.contains("e-treeview")) {
            if (this.dragArea) {
                this.dragLimit.top = this.clone ? this.dragLimit.top : 0;
                draEleTop = top - iTop < 0 ? this.dragLimit.top : top - this.borderWidth.top;
                draEleLeft = left - iLeft < 0 ? this.dragLimit.left : left - this.borderWidth.left;
            } else {
                draEleTop = top - this.borderWidth.top;
                draEleLeft = left - this.borderWidth.left;
            }
        } else if (this.dragArea) {
            var isDialogEle = this.helperElement.classList.contains("e-dialog");
            this.dragLimit.top = this.clone ? this.dragLimit.top : 0;
            draEleTop = top - iTop < 0 ? this.dragLimit.top : top - iTop;
            draEleLeft = left - iLeft < 0 ? isDialogEle ? left - (iLeft - this.borderWidth.left) : this.dragElePosition.left : left - iLeft;
        } else {
            draEleTop = top - iTop;
            draEleLeft = left - iLeft;
        }
        var marginTop = parseFloat(getComputedStyle(this.element).marginTop);
        // when drag-element has margin-top
        /* istanbul ignore next */ if (marginTop > 0) {
            if (this.clone) {
                draEleTop += marginTop;
                if (dTop < 0) {
                    if (marginTop + dTop >= 0) draEleTop = marginTop + dTop;
                    else draEleTop -= marginTop;
                }
                if (this.dragArea) draEleTop = this.dragLimit.bottom < draEleTop ? this.dragLimit.bottom : draEleTop;
            }
            if (top - iTop < 0) {
                if (dTop + marginTop + (helperElement.offsetHeight - iTop) >= 0) {
                    var tempDraEleTop = this.dragLimit.top + dTop - iTop;
                    if (tempDraEleTop + marginTop + iTop < 0) draEleTop -= marginTop + iTop;
                    else draEleTop = tempDraEleTop;
                } else draEleTop -= marginTop + iTop;
            }
        }
        if (this.dragArea && this.helperElement.classList.contains("e-treeview")) {
            var helperHeight = helperElement.offsetHeight + (parseFloat(styles.marginTop) + parseFloat(styles.marginBottom));
            draEleTop = draEleTop + helperHeight > this.dragLimit.bottom ? this.dragLimit.bottom - helperHeight : draEleTop;
        }
        /* istanbul ignore next */ // if(this.eleTop > 0) {
        //      draEleTop += this.eleTop;
        // }
        if (this.enableScrollHandler && !this.clone) {
            draEleTop -= this.parentScrollY;
            draEleLeft -= this.parentScrollX;
        }
        if (this.dragArea && typeof this.dragArea !== "string" && this.dragArea.classList.contains("e-kanban-content") && this.dragArea.style.position === "relative") draEleTop += this.dragArea.scrollTop;
        var dragValue = this.getProcessedPositionValue({
            top: draEleTop + "px",
            left: draEleLeft + "px"
        });
        (0, $4ZDHT.setStyleAttribute)(helperElement, this.getDragPosition(dragValue));
        if (!this.elementInViewport(helperElement) && this.enableAutoScroll && !this.helperElement.classList.contains("e-treeview")) this.helperElement.scrollIntoView();
        var elements = document.querySelectorAll(":hover");
        if (this.enableAutoScroll && this.helperElement.classList.contains("e-treeview")) {
            if (elements.length === 0) elements = this.getPathElements(evt);
            var scrollParent = this.getScrollParent(elements, false);
            if (this.elementInViewport(this.helperElement)) this.getScrollPosition(scrollParent, draEleTop);
            else if (!this.elementInViewport(this.helperElement)) {
                elements = [].slice.call(document.querySelectorAll(":hover"));
                if (elements.length === 0) elements = this.getPathElements(evt);
                scrollParent = this.getScrollParent(elements, true);
                this.getScrollPosition(scrollParent, draEleTop);
            }
        }
        this.dragProcessStarted = true;
        this.prevLeft = left;
        this.prevTop = top;
        this.position.left = left;
        this.position.top = top;
        this.pageX = pagex;
        this.pageY = pagey;
    };
    Draggable.prototype.getScrollParent = function(node, reverse) {
        var nodeEl = reverse ? node.reverse() : node;
        var hasScroll;
        for(var i = nodeEl.length - 1; i >= 0; i--){
            hasScroll = window.getComputedStyle(nodeEl[parseInt(i.toString(), 10)])["overflow-y"];
            if ((hasScroll === "auto" || hasScroll === "scroll") && nodeEl[parseInt(i.toString(), 10)].scrollHeight > nodeEl[parseInt(i.toString(), 10)].clientHeight) return nodeEl[parseInt(i.toString(), 10)];
        }
        hasScroll = window.getComputedStyle(document.scrollingElement)["overflow-y"];
        if (hasScroll === "visible") {
            document.scrollingElement.style.overflow = "auto";
            return document.scrollingElement;
        }
    };
    Draggable.prototype.getScrollPosition = function(nodeEle, draEleTop) {
        if (nodeEle && nodeEle === document.scrollingElement) {
            if (nodeEle.clientHeight + document.scrollingElement.scrollTop - this.helperElement.clientHeight < draEleTop && nodeEle.getBoundingClientRect().height + this.parentClientRect.top > draEleTop) nodeEle.scrollTop += this.helperElement.clientHeight;
            else if (nodeEle.scrollTop > draEleTop - this.helperElement.clientHeight) nodeEle.scrollTop -= this.helperElement.clientHeight;
        } else if (nodeEle && nodeEle !== document.scrollingElement) {
            var docScrollTop = document.scrollingElement.scrollTop;
            var helperClientHeight = this.helperElement.clientHeight;
            if (nodeEle.clientHeight + nodeEle.getBoundingClientRect().top - helperClientHeight + docScrollTop < draEleTop) nodeEle.scrollTop += this.helperElement.clientHeight;
            else if (nodeEle.getBoundingClientRect().top > draEleTop - helperClientHeight - docScrollTop) nodeEle.scrollTop -= this.helperElement.clientHeight;
        }
    };
    Draggable.prototype.getPathElements = function(evt) {
        var elementTop = evt.clientX > 0 ? evt.clientX : 0;
        var elementLeft = evt.clientY > 0 ? evt.clientY : 0;
        return document.elementsFromPoint(elementTop, elementLeft);
    };
    Draggable.prototype.triggerOutFunction = function(evt, eleObj) {
        this.hoverObject.instance.intOut(evt, eleObj.target);
        this.hoverObject.instance.dragData[this.scope] = null;
        this.hoverObject = null;
    };
    Draggable.prototype.getDragPosition = function(dragValue) {
        var temp = (0, $3EnZW.extend)({}, dragValue);
        if (this.axis) {
            if (this.axis === "x") delete temp.top;
            else if (this.axis === "y") delete temp.left;
        }
        return temp;
    };
    Draggable.prototype.getDocumentWidthHeight = function(str) {
        var docBody = document.body;
        var docEle = document.documentElement;
        var returnValue = Math.max(docBody["scroll" + str], docEle["scroll" + str], docBody["offset" + str], docEle["offset" + str], docEle["client" + str]);
        return returnValue;
    };
    Draggable.prototype.intDragStop = function(evt) {
        this.dragProcessStarted = false;
        if (!(0, $3EnZW.isUndefined)(evt.changedTouches) && evt.changedTouches.length !== 1) return;
        var type = [
            "touchend",
            "pointerup",
            "mouseup"
        ];
        if (type.indexOf(evt.type) !== -1) {
            if (this.dragStop) {
                var curTarget = this.getProperTargetElement(evt);
                this.trigger("dragStop", {
                    event: evt,
                    element: this.element,
                    target: curTarget,
                    helper: this.helperElement
                });
            }
            this.intDestroy(evt);
        } else this.element.setAttribute("aria-grabbed", "false");
        var eleObj = this.checkTargetElement(evt);
        if (eleObj.target && eleObj.instance) {
            eleObj.instance.dragStopCalled = true;
            eleObj.instance.dragData[this.scope] = this.droppables[this.scope];
            eleObj.instance.intDrop(evt, eleObj.target);
        }
        this.setGlobalDroppables(true);
        document.body.classList.remove("e-prevent-select");
    };
    /**
     * @param {MouseEvent | TouchEvent} evt ?
     * @returns {void}
     * @private
     */ Draggable.prototype.intDestroy = function(evt) {
        this.dragProcessStarted = false;
        this.toggleEvents();
        document.body.classList.remove("e-prevent-select");
        this.element.setAttribute("aria-grabbed", "false");
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.intDragStart);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDragStop);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDestroy);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).isSafari() ? "touchmove" : (0, $5q7BP.Browser).touchMoveEvent, this.intDrag);
        if (this.isDragStarted()) this.isDragStarted(true);
    };
    // triggers when property changed
    Draggable.prototype.onPropertyChanged = function(newProp, oldProp) {
    //No Code to handle
    };
    Draggable.prototype.getModuleName = function() {
        return "draggable";
    };
    Draggable.prototype.isDragStarted = function(change) {
        if (change) $aa004d7cf7acd014$var$isDraggedObject.isDragged = !$aa004d7cf7acd014$var$isDraggedObject.isDragged;
        return $aa004d7cf7acd014$var$isDraggedObject.isDragged;
    };
    Draggable.prototype.setDragArea = function() {
        var eleWidthBound;
        var eleHeightBound;
        var top = 0;
        var left = 0;
        var ele;
        var type = typeof this.dragArea;
        if (type === "string") ele = (0, $4ZDHT.select)(this.dragArea);
        else ele = this.dragArea;
        if (ele) {
            var elementArea = ele.getBoundingClientRect();
            eleWidthBound = ele.scrollWidth ? ele.scrollWidth : elementArea.right - elementArea.left;
            eleHeightBound = ele.scrollHeight ? this.dragArea && !(0, $3EnZW.isNullOrUndefined)(this.helperElement) && this.helperElement.classList.contains("e-treeview") ? ele.clientHeight : ele.scrollHeight : elementArea.bottom - elementArea.top;
            var keys = [
                "Top",
                "Left",
                "Bottom",
                "Right"
            ];
            var styles = getComputedStyle(ele);
            for(var i = 0; i < keys.length; i++){
                var key = keys[parseInt(i.toString(), 10)];
                var tborder = styles["border" + key + "Width"];
                var tpadding = styles["padding" + key];
                var lowerKey = key.toLowerCase();
                this.borderWidth["" + lowerKey] = isNaN(parseFloat(tborder)) ? 0 : parseFloat(tborder);
                this.padding["" + lowerKey] = isNaN(parseFloat(tpadding)) ? 0 : parseFloat(tpadding);
            }
            if (this.dragArea && !(0, $3EnZW.isNullOrUndefined)(this.helperElement) && this.helperElement.classList.contains("e-treeview")) top = elementArea.top + document.scrollingElement.scrollTop;
            else top = elementArea.top;
            left = elementArea.left;
            this.dragLimit.left = left + this.borderWidth.left + this.padding.left;
            this.dragLimit.top = ele.offsetTop + this.borderWidth.top + this.padding.top;
            this.dragLimit.right = left + eleWidthBound - (this.borderWidth.right + this.padding.right);
            this.dragLimit.bottom = top + eleHeightBound - (this.borderWidth.bottom + this.padding.bottom);
        }
    };
    Draggable.prototype.getProperTargetElement = function(evt) {
        var intCoord = this.getCoordinates(evt);
        var ele;
        var prevStyle = this.helperElement.style.pointerEvents || "";
        var isPointer = evt.type.indexOf("pointer") !== -1 && (0, $5q7BP.Browser).info.name === "safari" && parseInt((0, $5q7BP.Browser).info.version, 10) > 12;
        if ((0, $3EnZW.compareElementParent)(evt.target, this.helperElement) || evt.type.indexOf("touch") !== -1 || isPointer) {
            this.helperElement.style.pointerEvents = "none";
            ele = document.elementFromPoint(intCoord.clientX, intCoord.clientY);
            this.helperElement.style.pointerEvents = prevStyle;
        } else ele = evt.target;
        return ele;
    };
    /* istanbul ignore next */ Draggable.prototype.currentStateCheck = function(ele, oldEle) {
        var elem;
        if (!(0, $3EnZW.isNullOrUndefined)(this.currentStateTarget) && this.currentStateTarget !== ele) elem = this.currentStateTarget;
        else elem = !(0, $3EnZW.isNullOrUndefined)(oldEle) ? oldEle : ele;
        return elem;
    };
    Draggable.prototype.getMousePosition = function(evt, isdragscroll) {
        var dragEle = evt.srcElement !== undefined ? evt.srcElement : evt.target;
        var intCoord = this.getCoordinates(evt);
        var pageX;
        var pageY;
        var isOffsetParent = (0, $3EnZW.isNullOrUndefined)(dragEle.offsetParent);
        /* istanbul ignore next */ if (isdragscroll) {
            pageX = this.clone ? intCoord.pageX : intCoord.pageX + (isOffsetParent ? 0 : dragEle.offsetParent.scrollLeft) - this.relativeXPosition;
            pageY = this.clone ? intCoord.pageY : intCoord.pageY + (isOffsetParent ? 0 : dragEle.offsetParent.scrollTop) - this.relativeYPosition;
        } else {
            pageX = this.clone ? intCoord.pageX : intCoord.pageX + window.pageXOffset - this.relativeXPosition;
            pageY = this.clone ? intCoord.pageY : intCoord.pageY + window.pageYOffset - this.relativeYPosition;
        }
        if (document.scrollingElement && !isdragscroll && !this.clone) {
            var ele = document.scrollingElement;
            var isVerticalScroll = ele.scrollHeight > 0 && ele.scrollHeight > ele.clientHeight && ele.scrollTop > 0;
            var isHorrizontalScroll = ele.scrollWidth > 0 && ele.scrollWidth > ele.clientWidth && ele.scrollLeft > 0;
            pageX = isHorrizontalScroll ? pageX - ele.scrollLeft : pageX;
            pageY = isVerticalScroll ? pageY - ele.scrollTop : pageY;
        }
        return {
            left: pageX - (this.margin.left + this.cursorAt.left),
            top: pageY - (this.margin.top + this.cursorAt.top)
        };
    };
    Draggable.prototype.getCoordinates = function(evt) {
        if (evt.type.indexOf("touch") > -1) return evt.changedTouches[0];
        return evt;
    };
    Draggable.prototype.getHelperElement = function(evt) {
        var element;
        if (this.clone) {
            if (this.helper) element = this.helper({
                sender: evt,
                element: this.target
            });
            else {
                element = (0, $4ZDHT.createElement)("div", {
                    className: "e-drag-helper e-block-touch",
                    innerHTML: "Draggable"
                });
                document.body.appendChild(element);
            }
        } else element = this.element;
        return element;
    };
    Draggable.prototype.setGlobalDroppables = function(reset, drag, helper) {
        this.droppables[this.scope] = reset ? null : {
            draggable: drag,
            helper: helper,
            draggedElement: this.element
        };
    };
    Draggable.prototype.checkTargetElement = function(evt) {
        var target = this.getProperTargetElement(evt);
        var dropIns = this.getDropInstance(target);
        if (!dropIns && target && !(0, $3EnZW.isNullOrUndefined)(target.parentNode)) {
            var parent_1 = (0, $4ZDHT.closest)(target.parentNode, ".e-droppable") || target.parentElement;
            if (parent_1) dropIns = this.getDropInstance(parent_1);
        }
        return {
            target: target,
            instance: dropIns
        };
    };
    Draggable.prototype.getDropInstance = function(ele) {
        var name = "getModuleName";
        var drop;
        var eleInst = ele && ele.ej2_instances;
        if (eleInst) for(var _i = 0, eleInst_1 = eleInst; _i < eleInst_1.length; _i++){
            var inst = eleInst_1[_i];
            if (inst["" + name]() === "droppable") {
                drop = inst;
                break;
            }
        }
        return drop;
    };
    Draggable.prototype.destroy = function() {
        this.toggleEvents(true);
        _super.prototype.destroy.call(this);
    };
    var Draggable_1;
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Complex)({}, $aa004d7cf7acd014$export$13807d9ee5a34a42)
    ], Draggable.prototype, "cursorAt", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Draggable.prototype, "clone", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "dragArea", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "isDragScroll", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "isReplaceDragEle", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Draggable.prototype, "isPreventSelect", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Event)()
    ], Draggable.prototype, "drag", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Event)()
    ], Draggable.prototype, "dragStart", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Event)()
    ], Draggable.prototype, "dragStop", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Draggable.prototype, "distance", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "handle", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "abort", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "helper", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)("default")
    ], Draggable.prototype, "scope", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Draggable.prototype, "dragTarget", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "axis", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)()
    ], Draggable.prototype, "queryPositionInfo", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Draggable.prototype, "enableTailMode", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Draggable.prototype, "skipDistanceCheck", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Draggable.prototype, "preventDefault", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Draggable.prototype, "enableAutoScroll", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Draggable.prototype, "enableTapHold", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(750)
    ], Draggable.prototype, "tapHoldThreshold", void 0);
    $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Draggable.prototype, "enableScrollHandler", void 0);
    Draggable = Draggable_1 = $aa004d7cf7acd014$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Draggable);
    return Draggable;
}((0, $jmffE.Base));

});

parcelRegister("g9Ic7", function(module, exports) {

$parcel$export(module.exports, "Droppable", () => $bc2fc4b106b4af46$export$423ec2075359570a);

var $jmffE = parcelRequire("jmffE");

var $5q7BP = parcelRequire("5q7BP");

var $4ZDHT = parcelRequire("4ZDHT");

var $5rsSz = parcelRequire("5rsSz");

var $aqzbR = parcelRequire("aqzbR");

var $3EnZW = parcelRequire("3EnZW");
var $bc2fc4b106b4af46$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bc2fc4b106b4af46$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Droppable Module provides support to enable droppable functionality in Dom Elements.
 * ```html
 * <div id='drop'>Droppable</div>
 * <script>
 * let ele:HTMLElement = document.getElementById('drop');
 * var drag:Droppable = new Droppable(ele,{
 *     accept:'.drop',
 *     drop: function(e) {
 *      //drop handler code.
 *     }
 * });
 * </script>
 * ```
 */ var $bc2fc4b106b4af46$export$423ec2075359570a = /** @class */ function(_super) {
    $bc2fc4b106b4af46$var$__extends(Droppable, _super);
    function Droppable(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.mouseOver = false;
        _this.dragData = {};
        _this.dragStopCalled = false;
        _this.bind();
        return _this;
    }
    Droppable.prototype.bind = function() {
        this.wireEvents();
    };
    Droppable.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDrop, this);
    };
    // triggers when property changed
    Droppable.prototype.onPropertyChanged = function(newProp, oldProp) {
    //No Code to handle
    };
    Droppable.prototype.getModuleName = function() {
        return "droppable";
    };
    Droppable.prototype.intOver = function(event, element) {
        if (!this.mouseOver) {
            var drag = this.dragData[this.scope];
            this.trigger("over", {
                event: event,
                target: element,
                dragData: drag
            });
            this.mouseOver = true;
        }
    };
    Droppable.prototype.intOut = function(event, element) {
        if (this.mouseOver) {
            this.trigger("out", {
                evt: event,
                target: element
            });
            this.mouseOver = false;
        }
    };
    Droppable.prototype.intDrop = function(evt, element) {
        if (!this.dragStopCalled) return;
        else this.dragStopCalled = false;
        var accept = true;
        var drag = this.dragData[this.scope];
        var isDrag = drag ? drag.helper && (0, $4ZDHT.isVisible)(drag.helper) : false;
        var area;
        if (isDrag) {
            area = this.isDropArea(evt, drag.helper, element);
            if (this.accept) accept = (0, $4ZDHT.matches)(drag.helper, this.accept);
        }
        if (isDrag && this.drop && area.canDrop && accept) this.trigger("drop", {
            event: evt,
            target: area.target,
            droppedElement: drag.helper,
            dragData: drag
        });
        this.mouseOver = false;
    };
    Droppable.prototype.isDropArea = function(evt, helper, element) {
        var area = {
            canDrop: true,
            target: element || evt.target
        };
        var isTouch = evt.type === "touchend";
        if (isTouch || area.target === helper) {
            helper.style.display = "none";
            var coord = isTouch ? evt.changedTouches[0] : evt;
            var ele = document.elementFromPoint(coord.clientX, coord.clientY);
            area.canDrop = false;
            area.canDrop = (0, $3EnZW.compareElementParent)(ele, this.element);
            if (area.canDrop) area.target = ele;
            helper.style.display = "";
        }
        return area;
    };
    Droppable.prototype.destroy = function() {
        (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).isSafari() ? "touchend" : (0, $5q7BP.Browser).touchEndEvent, this.intDrop);
        _super.prototype.destroy.call(this);
    };
    $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.Property)()
    ], Droppable.prototype, "accept", void 0);
    $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.Property)("default")
    ], Droppable.prototype, "scope", void 0);
    $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.Event)()
    ], Droppable.prototype, "drop", void 0);
    $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.Event)()
    ], Droppable.prototype, "over", void 0);
    $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.Event)()
    ], Droppable.prototype, "out", void 0);
    Droppable = $bc2fc4b106b4af46$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Droppable);
    return Droppable;
}((0, $jmffE.Base));

});

parcelRegister("dyv7X", function(module, exports) {

$parcel$export(module.exports, "KeyboardEvents", () => $9de69894505c7bf9$export$9bcbcfc970068010);

var $5rsSz = parcelRequire("5rsSz");

var $jmffE = parcelRequire("jmffE");
var $9de69894505c7bf9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9de69894505c7bf9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9de69894505c7bf9$var$keyCode = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "control": 17,
    "alt": 18,
    "pause": 19,
    "capslock": 20,
    "space": 32,
    "escape": 27,
    "pageup": 33,
    "pagedown": 34,
    "end": 35,
    "home": 36,
    "leftarrow": 37,
    "uparrow": 38,
    "rightarrow": 39,
    "downarrow": 40,
    "insert": 45,
    "delete": 46,
    "f1": 112,
    "f2": 113,
    "f3": 114,
    "f4": 115,
    "f5": 116,
    "f6": 117,
    "f7": 118,
    "f8": 119,
    "f9": 120,
    "f10": 121,
    "f11": 122,
    "f12": 123,
    "semicolon": 186,
    "plus": 187,
    "comma": 188,
    "minus": 189,
    "dot": 190,
    "forwardslash": 191,
    "graveaccent": 192,
    "openbracket": 219,
    "backslash": 220,
    "closebracket": 221,
    "singlequote": 222
};
/**
 * KeyboardEvents class enables you to bind key action desired key combinations for ex., Ctrl+A, Delete, Alt+Space etc.
 * ```html
 * <div id='testEle'>  </div>;
 * <script>
 *   let node: HTMLElement = document.querySelector('#testEle');
 *   let kbInstance = new KeyboardEvents({
 *       element: node,
 *       keyConfigs:{ selectAll : 'ctrl+a' },
 *       keyAction: function (e:KeyboardEvent, action:string) {
 *           // handler function code
 *       }
 *   });
 * </script>
 * ```
 */ var $9de69894505c7bf9$export$9bcbcfc970068010 = /** @class */ function(_super) {
    $9de69894505c7bf9$var$__extends(KeyboardEvents, _super);
    /**
     * Initializes the KeyboardEvents
     *
     * @param {HTMLElement} element ?
     * @param {KeyboardEventsModel} options ?
     */ function KeyboardEvents(element, options) {
        var _this = _super.call(this, options, element) || this;
        /**
         * To handle a key press event returns null
         *
         * @param {KeyboardEventArgs} e ?
         * @returns {void} ?
         */ _this.keyPressHandler = function(e) {
            var isAltKey = e.altKey;
            var isCtrlKey = e.ctrlKey;
            var isShiftKey = e.shiftKey;
            var curkeyCode = e.which;
            var keys = Object.keys(_this.keyConfigs);
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                var configCollection = _this.keyConfigs["" + key].split(",");
                for(var _a = 0, configCollection_1 = configCollection; _a < configCollection_1.length; _a++){
                    var rconfig = configCollection_1[_a];
                    var rKeyObj = KeyboardEvents_1.getKeyConfigData(rconfig.trim());
                    if (isAltKey === rKeyObj.altKey && isCtrlKey === rKeyObj.ctrlKey && isShiftKey === rKeyObj.shiftKey && curkeyCode === rKeyObj.keyCode) {
                        e.action = key;
                        if (_this.keyAction) _this.keyAction(e);
                    }
                }
            }
        };
        _this.bind();
        return _this;
    }
    KeyboardEvents_1 = KeyboardEvents;
    /**
     * Unwire bound events and destroy the instance.
     *
     * @returns {void} ?
     */ KeyboardEvents.prototype.destroy = function() {
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    /**
     * Function can be used to specify certain action if a property is changed
     *
     * @param {KeyboardEventsModel} newProp ?
     * @param {KeyboardEventsModel} oldProp ?
     * @returns {void} ?
     * @private
     */ KeyboardEvents.prototype.onPropertyChanged = function(newProp, oldProp) {
    // No code are needed
    };
    KeyboardEvents.prototype.bind = function() {
        this.wireEvents();
    };
    /**
     * To get the module name, returns 'keyboard'.
     *
     * @returns {string} ?
     * @private
     */ KeyboardEvents.prototype.getModuleName = function() {
        return "keyboard";
    };
    /**
     * Wiring event handlers to events
     *
     * @returns {void} ?
     * @private
     */ KeyboardEvents.prototype.wireEvents = function() {
        this.element.addEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * Unwiring event handlers to events
     *
     * @returns {void} ?
     * @private
     */ KeyboardEvents.prototype.unwireEvents = function() {
        this.element.removeEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * To get the key configuration data
     *
     * @param {string} config - configuration data
     * @returns {KeyData} ?
     */ KeyboardEvents.getKeyConfigData = function(config) {
        if (config in this.configCache) return this.configCache["" + config];
        var keys = config.toLowerCase().split("+");
        var keyData = {
            altKey: keys.indexOf("alt") !== -1 ? true : false,
            ctrlKey: keys.indexOf("ctrl") !== -1 ? true : false,
            shiftKey: keys.indexOf("shift") !== -1 ? true : false,
            keyCode: null
        };
        if (keys[keys.length - 1].length > 1 && !!Number(keys[keys.length - 1])) keyData.keyCode = Number(keys[keys.length - 1]);
        else keyData.keyCode = KeyboardEvents_1.getKeyCode(keys[keys.length - 1]);
        KeyboardEvents_1.configCache["" + config] = keyData;
        return keyData;
    };
    // Return the keycode value as string
    KeyboardEvents.getKeyCode = function(keyVal) {
        return $9de69894505c7bf9$var$keyCode["" + keyVal] || keyVal.toUpperCase().charCodeAt(0);
    };
    var KeyboardEvents_1;
    KeyboardEvents.configCache = {};
    $9de69894505c7bf9$var$__decorate([
        (0, $5rsSz.Property)({})
    ], KeyboardEvents.prototype, "keyConfigs", void 0);
    $9de69894505c7bf9$var$__decorate([
        (0, $5rsSz.Property)("keyup")
    ], KeyboardEvents.prototype, "eventName", void 0);
    $9de69894505c7bf9$var$__decorate([
        (0, $5rsSz.Event)()
    ], KeyboardEvents.prototype, "keyAction", void 0);
    KeyboardEvents = KeyboardEvents_1 = $9de69894505c7bf9$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], KeyboardEvents);
    return KeyboardEvents;
}((0, $jmffE.Base));

});

parcelRegister("e7i2H", function(module, exports) {

$parcel$export(module.exports, "L10n", () => $a46fb6ff083fa44b$export$16a1d11d19f44aa9);

var $3EnZW = parcelRequire("3EnZW");

var $bWDaN = parcelRequire("bWDaN");
/**
 * L10n modules provides localized text for different culture.
 * ```typescript
 * import {setCulture} from '@syncfusion/ts-base-library';
 * //load global locale object common for all components.
 * L10n.load({
 *    'fr-BE': {
 *       'button': {
 *            'check': 'vérifié'
 *        }
 *    }
 * });
 * //set globale default locale culture.
 * setCulture('fr-BE');
 * let instance: L10n = new L10n('button', {
 *    check: 'checked'
 * });
 * //Get locale text for current property.
 * instance.getConstant('check');
 * //Change locale culture in a component.
 * instance.setLocale('en-US');
 * ```
 */ var $a46fb6ff083fa44b$export$16a1d11d19f44aa9 = /** @class */ function() {
    /**
     * Constructor
     *
     * @param {string} controlName ?
     * @param {Object} localeStrings ?
     * @param {string} locale ?
     */ function L10n(controlName, localeStrings, locale) {
        this.controlName = controlName;
        this.localeStrings = localeStrings;
        this.setLocale(locale || (0, $bWDaN.defaultCulture));
    }
    /**
     * Sets the locale text
     *
     * @param {string} locale ?
     * @returns {void} ?
     */ L10n.prototype.setLocale = function(locale) {
        var intLocale = this.intGetControlConstant(L10n.locale, locale);
        this.currentLocale = intLocale || this.localeStrings;
    };
    /**
     * Sets the global locale for all components.
     *
     * @param {Object} localeObject - specifies the localeObject to be set as global locale.
     * @returns {void} ?
     */ L10n.load = function(localeObject) {
        this.locale = (0, $3EnZW.extend)(this.locale, localeObject, {}, true);
    };
    /**
     * Returns current locale text for the property based on the culture name and control name.
     *
     * @param {string} prop - specifies the property for which localize text to be returned.
     * @returns {string} ?
     */ L10n.prototype.getConstant = function(prop) {
        // Removed conditional operator because this method does not return correct value when passing 0 as value in localization
        if (!(0, $3EnZW.isNullOrUndefined)(this.currentLocale["" + prop])) return this.currentLocale["" + prop];
        else return this.localeStrings["" + prop] || "";
    };
    /**
     * Returns the control constant object for current object and the locale specified.
     *
     * @param {Object} curObject ?
     * @param {string} locale ?
     * @returns {Object} ?
     */ L10n.prototype.intGetControlConstant = function(curObject, locale) {
        if (curObject["" + locale]) return curObject["" + locale][this.controlName];
        return null;
    };
    L10n.locale = {};
    return L10n;
}();

});

parcelRegister("i528u", function(module, exports) {

$parcel$export(module.exports, "Touch", () => $d29a59cb2a0efb32$export$746b04bbf92762fd);

var $3EnZW = parcelRequire("3EnZW");

var $5rsSz = parcelRequire("5rsSz");

var $5q7BP = parcelRequire("5q7BP");

var $jmffE = parcelRequire("jmffE");

var $3fcxu = parcelRequire("3fcxu");

var $aqzbR = parcelRequire("aqzbR");
var $d29a59cb2a0efb32$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d29a59cb2a0efb32$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * SwipeSettings is a framework module that provides support to handle swipe event like swipe up, swipe right, etc..,
 */ var $d29a59cb2a0efb32$export$52124cf3c3d6de18 = /** @class */ function(_super) {
    $d29a59cb2a0efb32$var$__extends(SwipeSettings, _super);
    function SwipeSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Property)(50)
    ], SwipeSettings.prototype, "swipeThresholdDistance", void 0);
    return SwipeSettings;
}((0, $3fcxu.ChildProperty));
var $d29a59cb2a0efb32$var$swipeRegex = /(Up|Down)/;
/**
 * Touch class provides support to handle the touch event like tap, double tap, tap hold, etc..,
 * ```typescript
 *    let node: HTMLElement;
 * let touchObj: Touch = new Touch({
 *    element: node,
 *    tap: function (e) {
 *        // tap handler function code
 *    }
 *    tapHold: function (e) {
 *        // tap hold handler function code
 *    }
 *    scroll: function (e) {
 *        // scroll handler function code
 *    }
 *    swipe: function (e) {
 *        // swipe handler function code
 *    }
 * });
 * ```
 */ var $d29a59cb2a0efb32$export$746b04bbf92762fd = /** @class */ function(_super) {
    $d29a59cb2a0efb32$var$__extends(Touch, _super);
    /* End-Properties */ function Touch(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.touchAction = true;
        _this.tapCount = 0;
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */ _this.startEvent = function(evt) {
            if (_this.touchAction === true) {
                var point = _this.updateChangeTouches(evt);
                if (evt.changedTouches !== undefined) _this.touchAction = false;
                _this.isTouchMoved = false;
                _this.movedDirection = "";
                _this.startPoint = _this.lastMovedPoint = {
                    clientX: point.clientX,
                    clientY: point.clientY
                };
                _this.startEventData = point;
                _this.hScrollLocked = _this.vScrollLocked = false;
                _this.tStampStart = Date.now();
                _this.timeOutTapHold = setTimeout(function() {
                    _this.tapHoldEvent(evt);
                }, _this.tapHoldThreshold);
                (0, $aqzbR.EventHandler).add(_this.element, (0, $5q7BP.Browser).touchMoveEvent, _this.moveEvent, _this);
                (0, $aqzbR.EventHandler).add(_this.element, (0, $5q7BP.Browser).touchEndEvent, _this.endEvent, _this);
                (0, $aqzbR.EventHandler).add(_this.element, (0, $5q7BP.Browser).touchCancelEvent, _this.cancelEvent, _this);
            }
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */ _this.moveEvent = function(evt) {
            var point = _this.updateChangeTouches(evt);
            _this.movedPoint = point;
            _this.isTouchMoved = !(point.clientX === _this.startPoint.clientX && point.clientY === _this.startPoint.clientY);
            var eScrollArgs = {};
            if (_this.isTouchMoved) {
                clearTimeout(_this.timeOutTapHold);
                _this.calcScrollPoints(evt);
                var scrollArg = {
                    startEvents: _this.startEventData,
                    originalEvent: evt,
                    startX: _this.startPoint.clientX,
                    startY: _this.startPoint.clientY,
                    distanceX: _this.distanceX,
                    distanceY: _this.distanceY,
                    scrollDirection: _this.scrollDirection,
                    velocity: _this.getVelocity(point)
                };
                eScrollArgs = (0, $3EnZW.extend)(eScrollArgs, {}, scrollArg);
                _this.trigger("scroll", eScrollArgs);
                _this.lastMovedPoint = {
                    clientX: point.clientX,
                    clientY: point.clientY
                };
            }
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */ _this.cancelEvent = function(evt) {
            clearTimeout(_this.timeOutTapHold);
            clearTimeout(_this.timeOutTap);
            _this.tapCount = 0;
            _this.swipeFn(evt);
            (0, $aqzbR.EventHandler).remove(_this.element, (0, $5q7BP.Browser).touchCancelEvent, _this.cancelEvent);
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */ _this.endEvent = function(evt) {
            _this.swipeFn(evt);
            if (!_this.isTouchMoved) {
                if (typeof _this.tap === "function") {
                    _this.trigger("tap", {
                        originalEvent: evt,
                        tapCount: ++_this.tapCount
                    });
                    _this.timeOutTap = setTimeout(function() {
                        _this.tapCount = 0;
                    }, _this.tapThreshold);
                }
            }
            _this.modeclear();
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */ _this.swipeFn = function(evt) {
            clearTimeout(_this.timeOutTapHold);
            clearTimeout(_this.timeOutTap);
            var point = _this.updateChangeTouches(evt);
            var diffX = point.clientX - _this.startPoint.clientX;
            var diffY = point.clientY - _this.startPoint.clientY;
            diffX = Math.floor(diffX < 0 ? -1 * diffX : diffX);
            diffY = Math.floor(diffY < 0 ? -1 * diffY : diffX);
            _this.isTouchMoved = diffX > 1 || diffY > 1;
            var isFirefox = /Firefox/.test((0, $5q7BP.Browser).userAgent);
            if (isFirefox && point.clientX === 0 && point.clientY === 0 && evt.type === "mouseup") _this.isTouchMoved = false;
            _this.endPoint = point;
            _this.calcPoints(evt);
            var swipeArgs = {
                originalEvent: evt,
                startEvents: _this.startEventData,
                startX: _this.startPoint.clientX,
                startY: _this.startPoint.clientY,
                distanceX: _this.distanceX,
                distanceY: _this.distanceY,
                swipeDirection: _this.movedDirection,
                velocity: _this.getVelocity(point)
            };
            if (_this.isTouchMoved) {
                var tDistance = _this.swipeSettings.swipeThresholdDistance;
                var eSwipeArgs = (0, $3EnZW.extend)(undefined, _this.defaultArgs, swipeArgs);
                var canTrigger = false;
                var ele = _this.element;
                var scrollBool = _this.isScrollable(ele);
                var moved = $d29a59cb2a0efb32$var$swipeRegex.test(_this.movedDirection);
                if (tDistance < _this.distanceX && !moved || tDistance < _this.distanceY && moved) {
                    if (!scrollBool) canTrigger = true;
                    else canTrigger = _this.checkSwipe(ele, moved);
                }
                if (canTrigger) _this.trigger("swipe", eSwipeArgs);
            }
            _this.modeclear();
        };
        _this.modeclear = function() {
            _this.modeClear = setTimeout(function() {
                _this.touchAction = true;
            }, typeof _this.tap !== "function" ? 0 : 20);
            _this.lastTapTime = new Date().getTime();
            (0, $aqzbR.EventHandler).remove(_this.element, (0, $5q7BP.Browser).touchMoveEvent, _this.moveEvent);
            (0, $aqzbR.EventHandler).remove(_this.element, (0, $5q7BP.Browser).touchEndEvent, _this.endEvent);
            (0, $aqzbR.EventHandler).remove(_this.element, (0, $5q7BP.Browser).touchCancelEvent, _this.cancelEvent);
        };
        _this.bind();
        return _this;
    }
    // triggers when property changed
    /**
     *
     * @private
     * @param {TouchModel} newProp ?
     * @param {TouchModel} oldProp ?
     * @returns {void} ?
     */ Touch.prototype.onPropertyChanged = function(newProp, oldProp) {
    //No Code to handle
    };
    Touch.prototype.bind = function() {
        this.wireEvents();
        if ((0, $5q7BP.Browser).isIE) this.element.classList.add("e-block-touch");
    };
    /**
     * To destroy the touch instance.
     *
     * @returns {void}
     */ Touch.prototype.destroy = function() {
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    // Need to changes the event binding once we updated the event handler.
    Touch.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchStartEvent, this.startEvent, this);
    };
    Touch.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchStartEvent, this.startEvent);
    };
    /**
     * Returns module name as touch
     *
     * @returns {string} ?
     * @private
     */ Touch.prototype.getModuleName = function() {
        return "touch";
    };
    /**
     * Returns if the HTML element is Scrollable.
     *
     * @param {HTMLElement} element - HTML Element to check if Scrollable.
     * @returns {boolean} ?
     */ Touch.prototype.isScrollable = function(element) {
        var eleStyle = getComputedStyle(element);
        var style = eleStyle.overflow + eleStyle.overflowX + eleStyle.overflowY;
        if (/(auto|scroll)/.test(style)) return true;
        return false;
    };
    /**
     *
     * @param {MouseEventArgs | TouchEventArgs} evt ?
     * @returns {void} ?
     */ Touch.prototype.tapHoldEvent = function(evt) {
        this.tapCount = 0;
        this.touchAction = true;
        (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchMoveEvent, this.moveEvent);
        (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchEndEvent, this.endEvent);
        var eTapArgs = {
            originalEvent: evt
        };
        this.trigger("tapHold", eTapArgs);
        (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchCancelEvent, this.cancelEvent);
    };
    Touch.prototype.calcPoints = function(evt) {
        var point = this.updateChangeTouches(evt);
        this.defaultArgs = {
            originalEvent: evt
        };
        this.distanceX = Math.abs(Math.abs(point.clientX) - Math.abs(this.startPoint.clientX));
        this.distanceY = Math.abs(Math.abs(point.clientY) - Math.abs(this.startPoint.clientY));
        if (this.distanceX > this.distanceY) this.movedDirection = point.clientX > this.startPoint.clientX ? "Right" : "Left";
        else this.movedDirection = point.clientY < this.startPoint.clientY ? "Up" : "Down";
    };
    Touch.prototype.calcScrollPoints = function(evt) {
        var point = this.updateChangeTouches(evt);
        this.defaultArgs = {
            originalEvent: evt
        };
        this.distanceX = Math.abs(Math.abs(point.clientX) - Math.abs(this.lastMovedPoint.clientX));
        this.distanceY = Math.abs(Math.abs(point.clientY) - Math.abs(this.lastMovedPoint.clientY));
        if ((this.distanceX > this.distanceY || this.hScrollLocked === true) && this.vScrollLocked === false) {
            this.scrollDirection = point.clientX > this.lastMovedPoint.clientX ? "Right" : "Left";
            this.hScrollLocked = true;
        } else {
            this.scrollDirection = point.clientY < this.lastMovedPoint.clientY ? "Up" : "Down";
            this.vScrollLocked = true;
        }
    };
    Touch.prototype.getVelocity = function(pnt) {
        var newX = pnt.clientX;
        var newY = pnt.clientY;
        var newT = Date.now();
        var xDist = newX - this.startPoint.clientX;
        var yDist = newY - this.startPoint.clientX;
        var interval = newT - this.tStampStart;
        return Math.sqrt(xDist * xDist + yDist * yDist) / interval;
    };
    Touch.prototype.checkSwipe = function(ele, flag) {
        var keys = [
            "scroll",
            "offset"
        ];
        var temp = flag ? [
            "Height",
            "Top"
        ] : [
            "Width",
            "Left"
        ];
        if (ele[keys[0] + temp[0]] <= ele[keys[1] + temp[0]]) return true;
        return ele[keys[0] + temp[1]] === 0 || ele[keys[1] + temp[0]] + ele[keys[0] + temp[1]] >= ele[keys[0] + temp[0]];
    };
    Touch.prototype.updateChangeTouches = function(evt) {
        var point = evt.changedTouches && evt.changedTouches.length !== 0 ? evt.changedTouches[0] : evt;
        return point;
    };
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Event)()
    ], Touch.prototype, "tap", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Event)()
    ], Touch.prototype, "tapHold", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Event)()
    ], Touch.prototype, "swipe", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Event)()
    ], Touch.prototype, "scroll", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Property)(350)
    ], Touch.prototype, "tapThreshold", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Property)(750)
    ], Touch.prototype, "tapHoldThreshold", void 0);
    $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.Complex)({}, $d29a59cb2a0efb32$export$52124cf3c3d6de18)
    ], Touch.prototype, "swipeSettings", void 0);
    Touch = $d29a59cb2a0efb32$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Touch);
    return Touch;
}((0, $jmffE.Base));

});

parcelRegister("c2qqN", function(module, exports) {

$parcel$export(module.exports, "blazorTemplates", () => $8c3a2ca62caf7dc3$export$31f48b31633e2b99);
$parcel$export(module.exports, "compile", () => $8c3a2ca62caf7dc3$export$ef7acd7185315e22);
$parcel$export(module.exports, "updateBlazorTemplate", () => $8c3a2ca62caf7dc3$export$591016394133b4a);
$parcel$export(module.exports, "resetBlazorTemplate", () => $8c3a2ca62caf7dc3$export$aa6c9d04052e9f4a);
$parcel$export(module.exports, "initializeCSPTemplate", () => $8c3a2ca62caf7dc3$export$c610738193ab93f1);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */ /**
 * Template Engine Bridge
 */ 
var $2VmNg = parcelRequire("2VmNg");

var $4ZDHT = parcelRequire("4ZDHT");

var $3EnZW = parcelRequire("3EnZW");
var $8c3a2ca62caf7dc3$var$HAS_ROW = /^[\n\r.]+<tr|^<tr/;
var $8c3a2ca62caf7dc3$var$HAS_SVG = /^[\n\r.]+<svg|^<path|^<g/;
var $8c3a2ca62caf7dc3$export$31f48b31633e2b99 = {};
function $8c3a2ca62caf7dc3$export$fb4880a9bd1b182() {
    return "-" + Math.random().toString(36).substr(2, 5);
}
function $8c3a2ca62caf7dc3$export$ef7acd7185315e22(templateString, helper, ignorePrefix) {
    var compiler = $8c3a2ca62caf7dc3$var$engineObj.compile(templateString, helper, ignorePrefix);
    return function(data, component, propName, templateId, isStringTemplate, index, element, root) {
        var result = compiler(data, component, propName, element, root);
        var blazorTemplateId = "BlazorTemplateId";
        if ((0, $3EnZW.isBlazor)() && !isStringTemplate) {
            var randomId = $8c3a2ca62caf7dc3$export$fb4880a9bd1b182();
            var blazorId = templateId + randomId;
            if (!$8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId]) $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId] = [];
            if (!(0, $3EnZW.isNullOrUndefined)(index)) {
                var keys = Object.keys($8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId][parseInt(index.toString(), 10)]);
                for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                    var key = keys_1[_i];
                    if (key !== blazorTemplateId && data["" + key]) $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId][parseInt(index.toString(), 10)]["" + key] = data["" + key];
                    if (key === blazorTemplateId) blazorId = $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId][parseInt(index.toString(), 10)]["" + key];
                }
            } else {
                data["" + blazorTemplateId] = blazorId;
                $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId].push(data);
            }
            return propName === "rowTemplate" ? [
                (0, $4ZDHT.createElement)("tr", {
                    id: blazorId,
                    className: "e-blazor-template"
                })
            ] : [
                (0, $4ZDHT.createElement)("div", {
                    id: blazorId,
                    className: "e-blazor-template"
                })
            ];
        }
        if (typeof result === "string") {
            if ($8c3a2ca62caf7dc3$var$HAS_SVG.test(result)) {
                var ele = (0, $4ZDHT.createElement)("svg", {
                    innerHTML: result
                });
                return ele.childNodes;
            } else {
                var ele = (0, $4ZDHT.createElement)($8c3a2ca62caf7dc3$var$HAS_ROW.test(result) ? "table" : "div", {
                    innerHTML: result
                });
                return ele.childNodes;
            }
        } else return result;
    };
}
function $8c3a2ca62caf7dc3$export$591016394133b4a(templateId, templateName, comp, isEmpty, callBack) {
    if ((0, $3EnZW.isBlazor)()) {
        var ejsIntrop = "sfBlazor";
        window["" + ejsIntrop].updateTemplate(templateName, $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId], templateId, comp, callBack);
        if (isEmpty !== false) $8c3a2ca62caf7dc3$export$31f48b31633e2b99["" + templateId] = [];
    }
}
function $8c3a2ca62caf7dc3$export$aa6c9d04052e9f4a(templateId, templateName, index) {
    var templateDiv = document.getElementById(templateId);
    if (templateDiv) {
        var innerTemplates = templateDiv.getElementsByClassName("blazor-inner-template");
        for(var i = 0; i < innerTemplates.length; i++){
            var tempId = " ";
            if (!(0, $3EnZW.isNullOrUndefined)(index)) tempId = innerTemplates[parseInt(index.toString(), 10)].getAttribute("data-templateId");
            else tempId = innerTemplates[parseInt(i.toString(), 10)].getAttribute("data-templateId");
            var tempElement = document.getElementById(tempId);
            if (tempElement) {
                var length_1 = tempElement.childNodes.length;
                for(var j = 0; j < length_1; j++)if (!(0, $3EnZW.isNullOrUndefined)(index)) {
                    innerTemplates[parseInt(index.toString(), 10)].appendChild(tempElement.childNodes[0]);
                    i = innerTemplates.length;
                } else innerTemplates[parseInt(i.toString(), 10)].appendChild(tempElement.childNodes[0]);
            }
        }
    }
}
function $8c3a2ca62caf7dc3$export$9c6c39f50211dc91(classObj) {
    $8c3a2ca62caf7dc3$var$engineObj.compile = classObj.compile;
}
function $8c3a2ca62caf7dc3$export$a5fc108fdfdbb9f4() {
    return $8c3a2ca62caf7dc3$var$engineObj.compile;
}
function $8c3a2ca62caf7dc3$export$c610738193ab93f1(template, helper) {
    var boundFunc;
    template.prototype.CSPTemplate = true;
    if (!(0, $3EnZW.isNullOrUndefined)(helper)) {
        boundFunc = template.bind(helper);
        boundFunc.prototype = Object.create(template.prototype);
    } else boundFunc = template;
    return boundFunc;
}
//Default Engine Class
var $8c3a2ca62caf7dc3$var$Engine = /** @class */ function() {
    function Engine() {}
    Engine.prototype.compile = function(templateString, helper, ignorePrefix) {
        if (helper === void 0) helper = {};
        return (0, $2VmNg.compile)(templateString, helper);
    };
    return Engine;
}();
var $8c3a2ca62caf7dc3$var$engineObj = {
    compile: new $8c3a2ca62caf7dc3$var$Engine().compile
};

});
parcelRegister("2VmNg", function(module, exports) {

$parcel$export(module.exports, "compile", () => $221295f61c0de969$export$ef7acd7185315e22);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Template Engine
 */ var $221295f61c0de969$var$LINES = new RegExp("\\n|\\r|\\s\\s+", "g");
var $221295f61c0de969$var$QUOTES = new RegExp(/'|"/g);
var $221295f61c0de969$var$IF_STMT = new RegExp("if ?\\(");
var $221295f61c0de969$var$ELSEIF_STMT = new RegExp("else if ?\\(");
var $221295f61c0de969$var$ELSE_STMT = new RegExp("else");
var $221295f61c0de969$var$FOR_STMT = new RegExp("for ?\\(");
var $221295f61c0de969$var$IF_OR_FOR = new RegExp("(/if|/for)");
var $221295f61c0de969$var$CALL_FUNCTION = new RegExp("\\((.*)\\)", "");
var $221295f61c0de969$var$NOT_NUMBER = new RegExp("^[0-9]+$", "g");
var $221295f61c0de969$var$WORD = new RegExp("[\\w\"'.\\s+]+", "g");
var $221295f61c0de969$var$DBL_QUOTED_STR = new RegExp('"(.*?)"', "g");
var $221295f61c0de969$var$WORDIF = new RegExp("[\\w\"'@#$.\\s-+]+", "g");
var $221295f61c0de969$var$exp = new RegExp("\\${([^}]*)}", "g");
// let cachedTemplate: Object = {};
var $221295f61c0de969$var$ARR_OBJ = /^\..*/gm;
var $221295f61c0de969$var$SINGLE_SLASH = /\\/gi;
var $221295f61c0de969$var$DOUBLE_SLASH = /\\\\/gi;
var $221295f61c0de969$var$WORDFUNC = new RegExp("[\\w\"'@#$.\\s+]+", "g");
var $221295f61c0de969$var$WINDOWFUNC = /\window\./gm;
function $221295f61c0de969$export$743d82c2fd345b72(value) {
    if (value) $221295f61c0de969$var$exp = value;
    return $221295f61c0de969$var$exp;
}
function $221295f61c0de969$export$ef7acd7185315e22(template, helper, ignorePrefix) {
    if (typeof template === "function") return template;
    else {
        var argName = "data";
        var evalExpResult = $221295f61c0de969$var$evalExp(template, argName, helper, ignorePrefix);
        var condtion = "var valueRegEx = (/value=\\'([A-Za-z0-9 _]*)((.)([\\w)(!-;?-\u25A0\\s]+)['])/g);\n        var hrefRegex = (/(?:href)([\\s='\"./]+)([\\w-./?=&\\\\#\"]+)((.)([\\w)(!-;/?-\u25A0\\s]+)['])/g);\n        if(str.match(valueRegEx)){\n            var check = str.match(valueRegEx);\n            var str1 = str;\n            for (var i=0; i < check.length; i++) {\n                var check1 = str.match(valueRegEx)[i].split('value=')[1];\n                var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n                change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n                str1 = str1.replace(check1, change);\n            }\n            str = str.replace(str, str1);\n        }\n        else if (str.match(/(?:href='')/) === null) {\n            if(str.match(hrefRegex)) {\n                var check = str.match(hrefRegex);\n                var str1 = str;\n                for (var i=0; i < check.length; i++) {\n                    var check1 = str.match(hrefRegex)[i].split('href=')[1];\n                    if (check1) {\n                        var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n                        change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n                        str1 = str1.replace(check1, change);\n                    }\n                }\n                str = str.replace(str, str1);\n            }\n        }\n        ";
        var fnCode = 'var str="' + evalExpResult + '";' + condtion + " return str;";
        var fn = new Function(argName, fnCode);
        return fn.bind(helper);
    }
}
/** function used to evaluate the function expression
 *
 * @param {string} str ?
 * @param {string} nameSpace ?
 * @param {Object} helper ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */ function $221295f61c0de969$var$evalExp(str, nameSpace, helper, ignorePrefix) {
    var varCOunt = 0;
    /**
     * Variable containing Local Keys
     */ var localKeys = [];
    var isClass = str.match(/class="([^"]+|)\s{2}/g);
    var singleSpace = "";
    if (isClass) isClass.forEach(function(value) {
        singleSpace = value.replace(/\s\s+/g, " ");
        str = str.replace(value, singleSpace);
    });
    if ($221295f61c0de969$var$exp.test(str)) {
        var insideBraces = false;
        var outputString = "";
        for(var i = 0; i < str.length; i++){
            if (str[i + ""] === "$" && str[i + 1] === "{") insideBraces = true;
            else if (str[i + ""] === "}") insideBraces = false;
            outputString += str[i + ""] === '"' && !insideBraces ? '\\"' : str[i + ""];
        }
        str = outputString;
    } else str = str.replace(/\\?"/g, '\\"');
    return str.replace($221295f61c0de969$var$LINES, "").replace($221295f61c0de969$var$DBL_QUOTED_STR, "'$1'").replace($221295f61c0de969$var$exp, function(match, cnt, offset, matchStr) {
        var SPECIAL_CHAR = /@|#|\$/gm;
        var matches = cnt.match($221295f61c0de969$var$CALL_FUNCTION);
        // matches to detect any function calls
        if (matches) {
            var rlStr = matches[1];
            if ($221295f61c0de969$var$ELSEIF_STMT.test(cnt)) //handling else-if condition
            cnt = '";} ' + cnt.replace(matches[1], rlStr.replace($221295f61c0de969$var$WORD, function(str) {
                str = str.trim();
                return $221295f61c0de969$var$addNameSpace(str, !$221295f61c0de969$var$QUOTES.test(str) && localKeys.indexOf(str) === -1, nameSpace, localKeys, ignorePrefix);
            })) + '{ \n str = str + "';
            else if ($221295f61c0de969$var$IF_STMT.test(cnt)) //handling if condition
            cnt = '"; ' + cnt.replace(matches[1], rlStr.replace($221295f61c0de969$var$WORDIF, function(strs) {
                return $221295f61c0de969$var$HandleSpecialCharArrObj(strs, nameSpace, localKeys, ignorePrefix);
            })) + '{ \n str = str + "';
            else if ($221295f61c0de969$var$FOR_STMT.test(cnt)) {
                //handling for condition
                var rlStr_1 = matches[1].split(" of ");
                // replace for each into actual JavaScript
                cnt = '"; ' + cnt.replace(matches[1], function(mtc) {
                    localKeys.push(rlStr_1[0]);
                    localKeys.push(rlStr_1[0] + "Index");
                    varCOunt = varCOunt + 1;
                    return "var i" + varCOunt + "=0; i" + varCOunt + " < " + $221295f61c0de969$var$addNameSpace(rlStr_1[1], true, nameSpace, localKeys, ignorePrefix) + ".length; i" + varCOunt + "++";
                }) + "{ \n " + rlStr_1[0] + "= " + $221295f61c0de969$var$addNameSpace(rlStr_1[1], true, nameSpace, localKeys, ignorePrefix) + "[i" + varCOunt + "]; \n var " + rlStr_1[0] + "Index=i" + varCOunt + '; \n str = str + "';
            } else {
                //helper function handling
                var fnStr = cnt.split("(");
                var fNameSpace = helper && Object.prototype.hasOwnProperty.call(helper, fnStr[0]) ? "this." : "global";
                fNameSpace = /\./.test(fnStr[0]) ? "" : fNameSpace;
                var ftArray = matches[1].split(",");
                if (matches[1].length !== 0 && !/data/.test(ftArray[0]) && !/window./.test(ftArray[0])) matches[1] = fNameSpace === "global" ? nameSpace + "." + matches[1] : matches[1];
                var splRegexp = /@|\$|#/gm;
                var arrObj = /\]\./gm;
                if ($221295f61c0de969$var$WINDOWFUNC.test(cnt) && arrObj.test(cnt) || splRegexp.test(cnt)) {
                    var splArrRegexp = /@|\$|#|\]\./gm;
                    if (splArrRegexp.test(cnt)) cnt = '"+ ' + (fNameSpace === "global" ? "" : fNameSpace) + cnt.replace(matches[1], rlStr.replace($221295f61c0de969$var$WORDFUNC, function(strs) {
                        return $221295f61c0de969$var$HandleSpecialCharArrObj(strs, nameSpace, localKeys, ignorePrefix);
                    })) + '+ "';
                } else cnt = '" + ' + (fNameSpace === "global" ? "" : fNameSpace) + cnt.replace(rlStr, $221295f61c0de969$var$addNameSpace(matches[1].replace(/,( |)data.|,/gi, "," + nameSpace + ".").replace(/,( |)data.window/gi, ",window"), fNameSpace === "global" ? false : true, nameSpace, localKeys, ignorePrefix)) + '+"';
            }
        } else if ($221295f61c0de969$var$ELSE_STMT.test(cnt)) // handling else condition
        cnt = '"; ' + cnt.replace($221295f61c0de969$var$ELSE_STMT, '} else { \n str = str + "');
        else if (cnt.match($221295f61c0de969$var$IF_OR_FOR)) // close condition
        cnt = cnt.replace($221295f61c0de969$var$IF_OR_FOR, '"; \n } \n str = str + "');
        else if (SPECIAL_CHAR.test(cnt)) {
            // template string with double slash with special character
            if (cnt.match($221295f61c0de969$var$SINGLE_SLASH)) cnt = $221295f61c0de969$var$SlashReplace(cnt);
            cnt = '"+' + $221295f61c0de969$var$NameSpaceForspecialChar(cnt, localKeys.indexOf(cnt) === -1, nameSpace, localKeys) + '"]+"';
        } else // template string with double slash
        if (cnt.match($221295f61c0de969$var$SINGLE_SLASH)) {
            cnt = $221295f61c0de969$var$SlashReplace(cnt);
            cnt = '"+' + $221295f61c0de969$var$NameSpaceForspecialChar(cnt, localKeys.indexOf(cnt) === -1, nameSpace, localKeys) + '"]+"';
        } else // evaluate normal expression
        cnt = cnt !== "" ? '"+' + $221295f61c0de969$var$addNameSpace(cnt.replace(/,/gi, "+" + nameSpace + "."), localKeys.indexOf(cnt) === -1, nameSpace, localKeys, ignorePrefix) + '+"' : "${}";
        return cnt;
    });
}
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */ function $221295f61c0de969$var$addNameSpace(str, addNS, nameSpace, ignoreList, ignorePrefix) {
    return addNS && !$221295f61c0de969$var$NOT_NUMBER.test(str) && ignoreList.indexOf(str.split(".")[0]) === -1 && !ignorePrefix && str !== "true" && str !== "false" ? nameSpace + "." + str : str;
}
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @returns {string} ?
 */ function $221295f61c0de969$var$NameSpaceArrObj(str, addNS, nameSpace, ignoreList) {
    var arrObjReg = /^\..*/gm;
    return addNS && !$221295f61c0de969$var$NOT_NUMBER.test(str) && ignoreList.indexOf(str.split(".")[0]) === -1 && !arrObjReg.test(str) ? nameSpace + "." + str : str;
}
// // Create hashCode for template string to storeCached function
// function hashCode(str: string): string {
//     return str.split('').reduce((a: number, b: string) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0).toString();
// }
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @returns {string} ?
 */ function $221295f61c0de969$var$NameSpaceForspecialChar(str, addNS, nameSpace, ignoreList) {
    return addNS && !$221295f61c0de969$var$NOT_NUMBER.test(str) && ignoreList.indexOf(str.split(".")[0]) === -1 ? nameSpace + '["' + str : str;
}
/**
 * Replace double slashes to single slash.
 *
 * @param {string} tempStr ?
 * @returns {any} ?
 */ function $221295f61c0de969$var$SlashReplace(tempStr) {
    var double = "\\\\";
    if (tempStr.match($221295f61c0de969$var$DOUBLE_SLASH)) return tempStr;
    else return tempStr.replace($221295f61c0de969$var$SINGLE_SLASH, double);
}
/**
 *
 * @param {string} str ?
 * @param {string} nameSpaceNew ?
 * @param {string[]} keys ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */ function $221295f61c0de969$var$HandleSpecialCharArrObj(str, nameSpaceNew, keys, ignorePrefix) {
    str = str.trim();
    var windowFunc = /\window\./gm;
    if (!windowFunc.test(str)) {
        var quotes = /'|"/gm;
        var splRegexp = /@|\$|#/gm;
        if (splRegexp.test(str)) str = $221295f61c0de969$var$NameSpaceForspecialChar(str, keys.indexOf(str) === -1, nameSpaceNew, keys) + '"]';
        if ($221295f61c0de969$var$ARR_OBJ.test(str)) return $221295f61c0de969$var$NameSpaceArrObj(str, !quotes.test(str) && keys.indexOf(str) === -1, nameSpaceNew, keys);
        else return $221295f61c0de969$var$addNameSpace(str, !quotes.test(str) && keys.indexOf(str) === -1, nameSpaceNew, keys, ignorePrefix);
    } else return str;
}

});


parcelRegister("3P3ke", function(module, exports) {

$parcel$export(module.exports, "SanitizeHtmlHelper", () => $2c88b6d8bb5dc041$export$b466568c95decddf);
/**
 * SanitizeHtmlHelper for sanitize the value.
 */ 
var $4ZDHT = parcelRequire("4ZDHT");

var $3EnZW = parcelRequire("3EnZW");
var $2c88b6d8bb5dc041$var$removeTags = [
    "script",
    "style",
    "iframe[src]",
    'link[href*="javascript:"]',
    'object[type="text/x-scriptlet"]',
    'object[data^="data:text/html;base64"]',
    'img[src^="data:text/html;base64"]',
    '[src^="javascript:"]',
    '[dynsrc^="javascript:"]',
    '[lowsrc^="javascript:"]',
    '[type^="application/x-shockwave-flash"]'
];
var $2c88b6d8bb5dc041$var$removeAttrs = [
    {
        attribute: "href",
        selector: '[href*="javascript:"]'
    },
    {
        attribute: "href",
        selector: "a[href]"
    },
    {
        attribute: "background",
        selector: '[background^="javascript:"]'
    },
    {
        attribute: "style",
        selector: '[style*="javascript:"]'
    },
    {
        attribute: "style",
        selector: '[style*="expression("]'
    },
    {
        attribute: "href",
        selector: 'a[href^="data:text/html;base64"]'
    }
];
var $2c88b6d8bb5dc041$var$jsEvents = [
    "onchange",
    "onclick",
    "onmouseover",
    "onmouseout",
    "onkeydown",
    "onload",
    "onerror",
    "onblur",
    "onfocus",
    "onbeforeload",
    "onbeforeunload",
    "onkeyup",
    "onsubmit",
    "onafterprint",
    "onbeforeonload",
    "onbeforeprint",
    "oncanplay",
    "oncanplaythrough",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onformchange",
    "onforminput",
    "onhaschange",
    "oninput",
    "oninvalid",
    "onkeypress",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmousedown",
    "onmousemove",
    "onmouseup",
    "onmousewheel",
    "onoffline",
    "onoine",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreadystatechange",
    "onredo",
    "onresize",
    "onscroll",
    "onseeked",
    "onseeking",
    "onselect",
    "onstalled",
    "onstorage",
    "onsuspend",
    "ontimeupdate",
    "onundo",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onmouseenter",
    "onmouseleave",
    "onstart",
    "onpropertychange",
    "oncopy",
    "ontoggle",
    "onpointerout",
    "onpointermove",
    "onpointerleave",
    "onpointerenter",
    "onpointerrawupdate",
    "onpointerover",
    "onbeforecopy",
    "onbeforecut",
    "onbeforeinput"
];
var $2c88b6d8bb5dc041$export$b466568c95decddf = /** @class */ function() {
    function SanitizeHtmlHelper() {}
    SanitizeHtmlHelper.beforeSanitize = function() {
        return {
            selectors: {
                tags: $2c88b6d8bb5dc041$var$removeTags,
                attributes: $2c88b6d8bb5dc041$var$removeAttrs
            }
        };
    };
    SanitizeHtmlHelper.sanitize = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(value)) return value;
        var item = this.beforeSanitize();
        var output = this.serializeValue(item, value);
        return output;
    };
    SanitizeHtmlHelper.serializeValue = function(item, value) {
        this.removeAttrs = item.selectors.attributes;
        this.removeTags = item.selectors.tags;
        this.wrapElement = document.createElement("div");
        this.wrapElement.innerHTML = value;
        this.removeXssTags();
        this.removeJsEvents();
        this.removeXssAttrs();
        var tempEleValue = this.wrapElement.innerHTML;
        this.removeElement();
        this.wrapElement = null;
        return tempEleValue.replace(/&amp;/g, "&");
    };
    SanitizeHtmlHelper.removeElement = function() {
        // Removes an element's attibute to avoid html tag validation
        var nodes = this.wrapElement.children;
        for(var j = 0; j < nodes.length; j++){
            var attribute = nodes[parseInt(j.toString(), 10)].attributes;
            for(var i = 0; i < attribute.length; i++)this.wrapElement.children[parseInt(j.toString(), 10)].removeAttribute(attribute[parseInt(i.toString(), 10)].localName);
        }
    };
    SanitizeHtmlHelper.removeXssTags = function() {
        var elements = this.wrapElement.querySelectorAll(this.removeTags.join(","));
        if (elements.length > 0) elements.forEach(function(element) {
            (0, $4ZDHT.detach)(element);
        });
        else return;
    };
    SanitizeHtmlHelper.removeJsEvents = function() {
        var elements = this.wrapElement.querySelectorAll("[" + $2c88b6d8bb5dc041$var$jsEvents.join("],[") + "]");
        if (elements.length > 0) elements.forEach(function(element) {
            $2c88b6d8bb5dc041$var$jsEvents.forEach(function(attr) {
                if (element.hasAttribute(attr)) element.removeAttribute(attr);
            });
        });
        else return;
    };
    SanitizeHtmlHelper.removeXssAttrs = function() {
        var _this = this;
        this.removeAttrs.forEach(function(item, index) {
            var elements = _this.wrapElement.querySelectorAll(item.selector);
            if (elements.length > 0) {
                if (item.selector === "a[href]") elements.forEach(function(element) {
                    if (element.getAttribute(item.attribute).replace(/\t|\s|&/, "").indexOf("javascript:alert") !== -1) element.removeAttribute(item.attribute);
                });
                else elements.forEach(function(element) {
                    element.removeAttribute(item.attribute);
                });
            }
        });
    };
    return SanitizeHtmlHelper;
}();

});



parcelRegister("cWXlQ", function(module, exports) {

$parcel$export(module.exports, "calculateRelativeBasedPosition", () => $96d8f0bde23f693c$export$fb90720898c85708);
$parcel$export(module.exports, "calculatePosition", () => $96d8f0bde23f693c$export$b3ceb0cbf1056d98);
/**
 * Position library
 */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $96d8f0bde23f693c$var$elementRect;
var $96d8f0bde23f693c$var$popupRect;
var $96d8f0bde23f693c$var$element;
var $96d8f0bde23f693c$var$parentDocument;
var $96d8f0bde23f693c$var$fixedParent = false;
function $96d8f0bde23f693c$export$fb90720898c85708(anchor, element) {
    var fixedElement = false;
    var anchorPos = {
        left: 0,
        top: 0
    };
    var tempAnchor = anchor;
    if (!anchor || !element) return anchorPos;
    if ((0, $3EnZW.isNullOrUndefined)(element.offsetParent) && element.style.position === "fixed") fixedElement = true;
    while((element.offsetParent || fixedElement) && anchor && element.offsetParent !== anchor){
        anchorPos.left += anchor.offsetLeft;
        anchorPos.top += anchor.offsetTop;
        anchor = anchor.offsetParent;
    }
    anchor = tempAnchor;
    while((element.offsetParent || fixedElement) && anchor && element.offsetParent !== anchor){
        anchorPos.left -= anchor.scrollLeft;
        anchorPos.top -= anchor.scrollTop;
        anchor = anchor.parentElement;
    }
    return anchorPos;
}
function $96d8f0bde23f693c$export$b3ceb0cbf1056d98(currentElement, positionX, positionY, parentElement, targetValues) {
    $96d8f0bde23f693c$var$popupRect = undefined;
    $96d8f0bde23f693c$var$popupRect = targetValues;
    $96d8f0bde23f693c$var$fixedParent = parentElement ? true : false;
    if (!currentElement) return {
        left: 0,
        top: 0
    };
    if (!positionX) positionX = "left";
    if (!positionY) positionY = "top";
    $96d8f0bde23f693c$var$parentDocument = currentElement.ownerDocument;
    $96d8f0bde23f693c$var$element = currentElement;
    var pos = {
        left: 0,
        top: 0
    };
    return $96d8f0bde23f693c$var$updatePosition(positionX.toLowerCase(), positionY.toLowerCase(), pos);
}
/**
 *
 * @param {number} value - specifies the number
 * @param {OffsetPosition} pos - specifies the position
 * @returns {void}
 */ function $96d8f0bde23f693c$var$setPosx(value, pos) {
    pos.left = value;
}
/**
 *
 * @param {number} value - specifies the number
 * @param {OffsetPosition} pos - specifies the position
 * @returns {void}
 */ function $96d8f0bde23f693c$var$setPosy(value, pos) {
    pos.top = value;
}
/**
 *
 * @param {string} posX - specifies the position
 * @param {string} posY - specifies the position
 * @param {OffsetPosition} pos - specifies the position
 * @returns {OffsetPosition} - returns the postion
 */ function $96d8f0bde23f693c$var$updatePosition(posX, posY, pos) {
    $96d8f0bde23f693c$var$elementRect = $96d8f0bde23f693c$var$element.getBoundingClientRect();
    switch(posY + posX){
        case "topcenter":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementHCenter(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementTop(), pos);
            break;
        case "topright":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementRight(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementTop(), pos);
            break;
        case "centercenter":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementHCenter(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementVCenter(), pos);
            break;
        case "centerright":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementRight(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementVCenter(), pos);
            break;
        case "centerleft":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementLeft(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementVCenter(), pos);
            break;
        case "bottomcenter":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementHCenter(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementBottom(), pos);
            break;
        case "bottomright":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementRight(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementBottom(), pos);
            break;
        case "bottomleft":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementLeft(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementBottom(), pos);
            break;
        default:
        case "topleft":
            $96d8f0bde23f693c$var$setPosx($96d8f0bde23f693c$var$getElementLeft(), pos);
            $96d8f0bde23f693c$var$setPosy($96d8f0bde23f693c$var$getElementTop(), pos);
            break;
    }
    $96d8f0bde23f693c$var$element = null;
    return pos;
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getBodyScrollTop() {
    return $96d8f0bde23f693c$var$parentDocument.documentElement.scrollTop || $96d8f0bde23f693c$var$parentDocument.body.scrollTop;
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getBodyScrollLeft() {
    return $96d8f0bde23f693c$var$parentDocument.documentElement.scrollLeft || $96d8f0bde23f693c$var$parentDocument.body.scrollLeft;
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementBottom() {
    return $96d8f0bde23f693c$var$fixedParent ? $96d8f0bde23f693c$var$elementRect.bottom : $96d8f0bde23f693c$var$elementRect.bottom + $96d8f0bde23f693c$var$getBodyScrollTop();
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementVCenter() {
    return $96d8f0bde23f693c$var$getElementTop() + $96d8f0bde23f693c$var$elementRect.height / 2;
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementTop() {
    return $96d8f0bde23f693c$var$fixedParent ? $96d8f0bde23f693c$var$elementRect.top : $96d8f0bde23f693c$var$elementRect.top + $96d8f0bde23f693c$var$getBodyScrollTop();
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementLeft() {
    return $96d8f0bde23f693c$var$elementRect.left + $96d8f0bde23f693c$var$getBodyScrollLeft();
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementRight() {
    var popupWidth = $96d8f0bde23f693c$var$element && ($96d8f0bde23f693c$var$element.classList.contains("e-date-wrapper") || $96d8f0bde23f693c$var$element.classList.contains("e-datetime-wrapper") || $96d8f0bde23f693c$var$element.classList.contains("e-ddl") && $96d8f0bde23f693c$var$element.classList.contains("e-rtl") || $96d8f0bde23f693c$var$element.classList.contains("e-date-range-wrapper")) ? $96d8f0bde23f693c$var$popupRect ? $96d8f0bde23f693c$var$popupRect.width : 0 : $96d8f0bde23f693c$var$popupRect && $96d8f0bde23f693c$var$elementRect.width >= $96d8f0bde23f693c$var$popupRect.width ? $96d8f0bde23f693c$var$popupRect.width : 0;
    return $96d8f0bde23f693c$var$elementRect.right + $96d8f0bde23f693c$var$getBodyScrollLeft() - popupWidth;
}
/**
 * @returns {number} - specifies the number value
 */ function $96d8f0bde23f693c$var$getElementHCenter() {
    return $96d8f0bde23f693c$var$getElementLeft() + $96d8f0bde23f693c$var$elementRect.width / 2;
}

});

parcelRegister("49u5W", function(module, exports) {

$parcel$export(module.exports, "fit", () => $305f58df07cbfddd$export$1e044b7877db048c);
$parcel$export(module.exports, "isCollide", () => $305f58df07cbfddd$export$1af046d323e2551a);
$parcel$export(module.exports, "flip", () => $305f58df07cbfddd$export$8a83211c878a3f1f);
$parcel$export(module.exports, "getTransformElement", () => $305f58df07cbfddd$export$b1dc66ca9cf2f9f4);
$parcel$export(module.exports, "destroy", () => $305f58df07cbfddd$export$b1fb4cac938035f7);
/**
 * Collision module.
 */ 
var $cWXlQ = parcelRequire("cWXlQ");
parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $305f58df07cbfddd$var$parentDocument;
var $305f58df07cbfddd$var$targetContainer;
function $305f58df07cbfddd$export$1e044b7877db048c(element, viewPortElement, axis, position) {
    if (viewPortElement === void 0) viewPortElement = null;
    if (axis === void 0) axis = {
        X: false,
        Y: false
    };
    if (!axis.Y && !axis.X) return {
        left: 0,
        top: 0
    };
    var elemData = element.getBoundingClientRect();
    $305f58df07cbfddd$var$targetContainer = viewPortElement;
    $305f58df07cbfddd$var$parentDocument = element.ownerDocument;
    if (!position) position = (0, $cWXlQ.calculatePosition)(element, "left", "top");
    if (axis.X) {
        var containerWidth = $305f58df07cbfddd$var$targetContainer ? $305f58df07cbfddd$var$getTargetContainerWidth() : $305f58df07cbfddd$var$getViewPortWidth();
        var containerLeft = $305f58df07cbfddd$var$ContainerLeft();
        var containerRight = $305f58df07cbfddd$var$ContainerRight();
        var overLeft = containerLeft - position.left;
        var overRight = position.left + elemData.width - containerRight;
        if (elemData.width > containerWidth) {
            if (overLeft > 0 && overRight <= 0) position.left = containerRight - elemData.width;
            else if (overRight > 0 && overLeft <= 0) position.left = containerLeft;
            else position.left = overLeft > overRight ? containerRight - elemData.width : containerLeft;
        } else if (overLeft > 0) position.left += overLeft;
        else if (overRight > 0) position.left -= overRight;
    }
    if (axis.Y) {
        var containerHeight = $305f58df07cbfddd$var$targetContainer ? $305f58df07cbfddd$var$getTargetContainerHeight() : $305f58df07cbfddd$var$getViewPortHeight();
        var containerTop = $305f58df07cbfddd$var$ContainerTop();
        var containerBottom = $305f58df07cbfddd$var$ContainerBottom();
        var overTop = containerTop - position.top;
        var overBottom = position.top + elemData.height - containerBottom;
        if (elemData.height > containerHeight) {
            if (overTop > 0 && overBottom <= 0) position.top = containerBottom - elemData.height;
            else if (overBottom > 0 && overTop <= 0) position.top = containerTop;
            else position.top = overTop > overBottom ? containerBottom - elemData.height : containerTop;
        } else if (overTop > 0) position.top += overTop;
        else if (overBottom > 0) position.top -= overBottom;
    }
    return position;
}
function $305f58df07cbfddd$export$1af046d323e2551a(element, viewPortElement, x, y) {
    if (viewPortElement === void 0) viewPortElement = null;
    var elemOffset = (0, $cWXlQ.calculatePosition)(element, "left", "top");
    if (x) elemOffset.left = x;
    if (y) elemOffset.top = y;
    var data = [];
    $305f58df07cbfddd$var$targetContainer = viewPortElement;
    $305f58df07cbfddd$var$parentDocument = element.ownerDocument;
    var elementRect = element.getBoundingClientRect();
    var top = elemOffset.top;
    var left = elemOffset.left;
    var right = elemOffset.left + elementRect.width;
    var bottom = elemOffset.top + elementRect.height;
    var yAxis = $305f58df07cbfddd$var$topCollideCheck(top, bottom);
    var xAxis = $305f58df07cbfddd$var$leftCollideCheck(left, right);
    if (yAxis.topSide) data.push("top");
    if (xAxis.rightSide) data.push("right");
    if (xAxis.leftSide) data.push("left");
    if (yAxis.bottomSide) data.push("bottom");
    return data;
}
function $305f58df07cbfddd$export$8a83211c878a3f1f(element, target, offsetX, offsetY, positionX, positionY, viewPortElement, /* eslint-disable */ axis, fixedParent) {
    if (viewPortElement === void 0) viewPortElement = null;
    if (axis === void 0) axis = {
        X: true,
        Y: true
    };
    if (!target || !element || !positionX || !positionY || !axis.X && !axis.Y) return;
    var tEdge = {
        TL: null,
        TR: null,
        BL: null,
        BR: null
    }, eEdge = {
        TL: null,
        TR: null,
        BL: null,
        BR: null
    };
    var elementRect;
    if (window.getComputedStyle(element).display === "none") {
        var oldVisibility = element.style.visibility;
        element.style.visibility = "hidden";
        element.style.display = "block";
        elementRect = element.getBoundingClientRect();
        element.style.removeProperty("display");
        element.style.visibility = oldVisibility;
    } else elementRect = element.getBoundingClientRect();
    var pos = {
        posX: positionX,
        posY: positionY,
        offsetX: offsetX,
        offsetY: offsetY,
        position: {
            left: 0,
            top: 0
        }
    };
    $305f58df07cbfddd$var$targetContainer = viewPortElement;
    $305f58df07cbfddd$var$parentDocument = target.ownerDocument;
    $305f58df07cbfddd$var$updateElementData(target, tEdge, pos, fixedParent, elementRect);
    $305f58df07cbfddd$var$setPosition(eEdge, pos, elementRect);
    if (axis.X) $305f58df07cbfddd$var$leftFlip(target, eEdge, tEdge, pos, elementRect, true);
    if (axis.Y && tEdge.TL.top > -1) $305f58df07cbfddd$var$topFlip(target, eEdge, tEdge, pos, elementRect, true);
    $305f58df07cbfddd$var$setPopup(element, pos, elementRect);
}
/**
 *
 * @param {HTMLElement} element - specifies the element
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client rect
 * @returns {void}
 */ function $305f58df07cbfddd$var$setPopup(element, pos, elementRect) {
    var left = 0;
    var top = 0;
    if (element.offsetParent != null && (getComputedStyle(element.offsetParent).position === "absolute" || getComputedStyle(element.offsetParent).position === "relative")) {
        var data = (0, $cWXlQ.calculatePosition)(element.offsetParent, "left", "top", false, elementRect);
        left = data.left;
        top = data.top;
    }
    var scaleX = 1;
    var scaleY = 1;
    var tranformElement = $305f58df07cbfddd$export$b1dc66ca9cf2f9f4(element);
    if (tranformElement) {
        var transformStyle = getComputedStyle(tranformElement).transform;
        if (transformStyle !== "none") {
            var matrix = new DOMMatrix(transformStyle);
            scaleX = matrix.a;
            scaleY = matrix.d;
        }
    }
    element.style.top = pos.position.top / scaleY + pos.offsetY - top / scaleY + "px";
    element.style.left = pos.position.left / scaleX + pos.offsetX - left / scaleX + "px";
}
function $305f58df07cbfddd$export$b1dc66ca9cf2f9f4(element) {
    while(element){
        var transform = window.getComputedStyle(element).transform;
        if (transform && transform !== "none") return element;
        if (element === document.body) return null;
        element = element.offsetParent || element.parentElement;
    }
    return null;
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifies the offset
 * @param {PositionLocation} pos - specifies theloaction
 * @param {boolean} fixedParent - specifies the boolean
 * @param {ClientRect} elementRect - specifies the client rect
 * @returns {void}
 */ function $305f58df07cbfddd$var$updateElementData(target, edge, pos, fixedParent, elementRect) {
    pos.position = (0, $cWXlQ.calculatePosition)(target, pos.posX, pos.posY, fixedParent, elementRect);
    edge.TL = (0, $cWXlQ.calculatePosition)(target, "left", "top", fixedParent, elementRect);
    edge.TR = (0, $cWXlQ.calculatePosition)(target, "right", "top", fixedParent, elementRect);
    edge.BR = (0, $cWXlQ.calculatePosition)(target, "left", "bottom", fixedParent, elementRect);
    edge.BL = (0, $cWXlQ.calculatePosition)(target, "right", "bottom", fixedParent, elementRect);
}
/**
 *
 * @param {EdgeOffset} eStatus - specifies the status
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client
 * @returns {void}
 */ function $305f58df07cbfddd$var$setPosition(eStatus, pos, elementRect) {
    eStatus.TL = {
        top: pos.position.top + pos.offsetY,
        left: pos.position.left + pos.offsetX
    };
    eStatus.TR = {
        top: eStatus.TL.top,
        left: eStatus.TL.left + elementRect.width
    };
    eStatus.BL = {
        top: eStatus.TL.top + elementRect.height,
        left: eStatus.TL.left
    };
    eStatus.BR = {
        top: eStatus.TL.top + elementRect.height,
        left: eStatus.TL.left + elementRect.width
    };
}
/**
 *
 * @param {number} left - specifies the  number
 * @param {number} right - specifies the number
 * @returns {LeftCorners} - returns the value
 */ function $305f58df07cbfddd$var$leftCollideCheck(left, right) {
    //eslint-disable-next-line
    var leftSide = false, rightSide = false;
    if (left - $305f58df07cbfddd$var$getBodyScrollLeft() < $305f58df07cbfddd$var$ContainerLeft()) leftSide = true;
    if (right > $305f58df07cbfddd$var$ContainerRight()) rightSide = true;
    return {
        leftSide: leftSide,
        rightSide: rightSide
    };
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifes the element
 * @param {EdgeOffset} tEdge - specifies the edge offset
 * @param {PositionLocation} pos - specifes the location
 * @param {ClientRect} elementRect - specifies the client
 * @param {boolean} deepCheck - specifies the boolean value
 * @returns {void}
 */ function $305f58df07cbfddd$var$leftFlip(target, edge, tEdge, pos, elementRect, deepCheck) {
    var collideSide = $305f58df07cbfddd$var$leftCollideCheck(edge.TL.left, edge.TR.left);
    if (tEdge.TL.left - $305f58df07cbfddd$var$getBodyScrollLeft() <= $305f58df07cbfddd$var$ContainerLeft()) collideSide.leftSide = false;
    if (tEdge.TR.left > $305f58df07cbfddd$var$ContainerRight()) collideSide.rightSide = false;
    if (collideSide.leftSide && !collideSide.rightSide || !collideSide.leftSide && collideSide.rightSide) {
        if (pos.posX === "right") pos.posX = "left";
        else pos.posX = "right";
        pos.offsetX = pos.offsetX + elementRect.width;
        pos.offsetX = -1 * pos.offsetX;
        pos.position = (0, $cWXlQ.calculatePosition)(target, pos.posX, pos.posY, false);
        $305f58df07cbfddd$var$setPosition(edge, pos, elementRect);
        if (deepCheck) $305f58df07cbfddd$var$leftFlip(target, edge, tEdge, pos, elementRect, false);
    }
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifies the offset
 * @param {EdgeOffset} tEdge - specifies the offset
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client rect
 * @param {boolean} deepCheck - specifies the boolean
 * @returns {void}
 */ function $305f58df07cbfddd$var$topFlip(target, edge, tEdge, pos, elementRect, deepCheck) {
    var collideSide = $305f58df07cbfddd$var$topCollideCheck(edge.TL.top, edge.BL.top);
    if (tEdge.TL.top - $305f58df07cbfddd$var$getBodyScrollTop() <= $305f58df07cbfddd$var$ContainerTop()) collideSide.topSide = false;
    if (tEdge.BL.top >= $305f58df07cbfddd$var$ContainerBottom() && target.getBoundingClientRect().bottom < window.innerHeight) collideSide.bottomSide = false;
    if (collideSide.topSide && !collideSide.bottomSide || !collideSide.topSide && collideSide.bottomSide) {
        if (pos.posY === "top") pos.posY = "bottom";
        else pos.posY = "top";
        pos.offsetY = pos.offsetY + elementRect.height;
        pos.offsetY = -1 * pos.offsetY;
        pos.position = (0, $cWXlQ.calculatePosition)(target, pos.posX, pos.posY, false, elementRect);
        $305f58df07cbfddd$var$setPosition(edge, pos, elementRect);
        if (deepCheck) $305f58df07cbfddd$var$topFlip(target, edge, tEdge, pos, elementRect, false);
    }
}
/**
 *
 * @param {number} top - specifies the number
 * @param {number} bottom - specifies the number
 * @returns {TopCorners} - retyrns the value
 */ function $305f58df07cbfddd$var$topCollideCheck(top, bottom) {
    //eslint-disable-next-line
    var topSide = false, bottomSide = false;
    if (top - $305f58df07cbfddd$var$getBodyScrollTop() < $305f58df07cbfddd$var$ContainerTop()) topSide = true;
    if (bottom > $305f58df07cbfddd$var$ContainerBottom()) bottomSide = true;
    return {
        topSide: topSide,
        bottomSide: bottomSide
    };
}
/**
 * @returns {void}
 */ function $305f58df07cbfddd$var$getTargetContainerWidth() {
    return $305f58df07cbfddd$var$targetContainer.getBoundingClientRect().width;
}
/**
 * @returns {void}
 */ function $305f58df07cbfddd$var$getTargetContainerHeight() {
    return $305f58df07cbfddd$var$targetContainer.getBoundingClientRect().height;
}
/**
 * @returns {void}
 */ function $305f58df07cbfddd$var$getTargetContainerLeft() {
    return $305f58df07cbfddd$var$targetContainer.getBoundingClientRect().left;
}
/**
 * @returns {void}
 */ function $305f58df07cbfddd$var$getTargetContainerTop() {
    return $305f58df07cbfddd$var$targetContainer.getBoundingClientRect().top;
}
//eslint-disable-next-line
function $305f58df07cbfddd$var$ContainerTop() {
    if ($305f58df07cbfddd$var$targetContainer) return $305f58df07cbfddd$var$getTargetContainerTop();
    return 0;
}
//eslint-disable-next-line
function $305f58df07cbfddd$var$ContainerLeft() {
    if ($305f58df07cbfddd$var$targetContainer) return $305f58df07cbfddd$var$getTargetContainerLeft();
    return 0;
}
//eslint-disable-next-line
function $305f58df07cbfddd$var$ContainerRight() {
    if ($305f58df07cbfddd$var$targetContainer) return $305f58df07cbfddd$var$getBodyScrollLeft() + $305f58df07cbfddd$var$getTargetContainerLeft() + $305f58df07cbfddd$var$getTargetContainerWidth();
    return $305f58df07cbfddd$var$getBodyScrollLeft() + $305f58df07cbfddd$var$getViewPortWidth();
}
//eslint-disable-next-line
function $305f58df07cbfddd$var$ContainerBottom() {
    if ($305f58df07cbfddd$var$targetContainer) return $305f58df07cbfddd$var$getBodyScrollTop() + $305f58df07cbfddd$var$getTargetContainerTop() + $305f58df07cbfddd$var$getTargetContainerHeight();
    return $305f58df07cbfddd$var$getBodyScrollTop() + $305f58df07cbfddd$var$getViewPortHeight();
}
/**
 * @returns {number} - returns the scroll top value
 */ function $305f58df07cbfddd$var$getBodyScrollTop() {
    // if(targetContainer)
    //     return targetContainer.scrollTop;
    return $305f58df07cbfddd$var$parentDocument.documentElement.scrollTop || $305f58df07cbfddd$var$parentDocument.body.scrollTop;
}
/**
 * @returns {number} - returns the scroll left value
 */ function $305f58df07cbfddd$var$getBodyScrollLeft() {
    // if(targetContainer)
    //     return targetContainer.scrollLeft;
    return $305f58df07cbfddd$var$parentDocument.documentElement.scrollLeft || $305f58df07cbfddd$var$parentDocument.body.scrollLeft;
}
/**
 * @returns {number} - returns the viewport height
 */ function $305f58df07cbfddd$var$getViewPortHeight() {
    return window.innerHeight;
}
/**
 * @returns {number} - returns the viewport width
 */ function $305f58df07cbfddd$var$getViewPortWidth() {
    var windowWidth = window.innerWidth;
    var documentReact = document.documentElement.getBoundingClientRect();
    var offsetWidth = (0, $3EnZW.isNullOrUndefined)(document.documentElement) ? 0 : documentReact.width;
    return windowWidth - (windowWidth - offsetWidth);
}
function $305f58df07cbfddd$export$b1fb4cac938035f7() {
    $305f58df07cbfddd$var$targetContainer = null;
    $305f58df07cbfddd$var$parentDocument = null;
}

});


parcelRegister("dKI7M", function(module, exports) {
"use strict";
var $a031cc6b762c4e12$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $3ukNm = parcelRequire("3ukNm");
module.exports = function hasNativeSymbols() {
    if (typeof $a031cc6b762c4e12$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $a031cc6b762c4e12$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $3ukNm();
};

});
parcelRegister("3ukNm", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eNnvx", function(module, exports) {
"use strict";
var $ac57e0689712e64d$var$test = {
    __proto__: null,
    foo: {}
};
var $ac57e0689712e64d$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $ac57e0689712e64d$var$test
    }).foo === $ac57e0689712e64d$var$test.foo && !($ac57e0689712e64d$var$test instanceof $ac57e0689712e64d$var$$Object);
};

});

parcelRegister("aszze", function(module, exports) {
"use strict";

var $5bmkL = parcelRequire("5bmkL");
var $79d81bcf012c6ef5$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$5bmkL;
};
$79d81bcf012c6ef5$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$5bmkL) return null;
    try {
        return $5bmkL([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $79d81bcf012c6ef5$var$hasPropertyDescriptors;

});
parcelRegister("5bmkL", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
/** @type {import('.')} */ var $3c5f4de337a65054$var$$defineProperty = $2DXy1("%Object.defineProperty%", true) || false;
if ($3c5f4de337a65054$var$$defineProperty) try {
    $3c5f4de337a65054$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3c5f4de337a65054$var$$defineProperty = false;
}
module.exports = $3c5f4de337a65054$var$$defineProperty;

});
parcelRegister("2DXy1", function(module, exports) {
"use strict";
var $1ecd6a3b805ecadb$var$undefined1;

var $c7Ac6 = parcelRequire("c7Ac6");

var $elYtN = parcelRequire("elYtN");

var $1S2Qw = parcelRequire("1S2Qw");

var $8T8lL = parcelRequire("8T8lL");

var $f0gvj = parcelRequire("f0gvj");

var $6bQrM = parcelRequire("6bQrM");

var $03ZFS = parcelRequire("03ZFS");
var $1ecd6a3b805ecadb$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1ecd6a3b805ecadb$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1ecd6a3b805ecadb$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1ecd6a3b805ecadb$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1ecd6a3b805ecadb$var$$gOPD) try {
    $1ecd6a3b805ecadb$var$$gOPD({}, "");
} catch (e) {
    $1ecd6a3b805ecadb$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1ecd6a3b805ecadb$var$throwTypeError = function() {
    throw new $6bQrM();
};
var $1ecd6a3b805ecadb$var$ThrowTypeError = $1ecd6a3b805ecadb$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1ecd6a3b805ecadb$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1ecd6a3b805ecadb$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1ecd6a3b805ecadb$var$throwTypeError;
        }
    }
}() : $1ecd6a3b805ecadb$var$throwTypeError;

var $1ecd6a3b805ecadb$var$hasSymbols = (parcelRequire("dKI7M"))();

var $1ecd6a3b805ecadb$var$hasProto = (parcelRequire("eNnvx"))();
var $1ecd6a3b805ecadb$var$getProto = Object.getPrototypeOf || ($1ecd6a3b805ecadb$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1ecd6a3b805ecadb$var$needsEval = {};
var $1ecd6a3b805ecadb$var$TypedArray = typeof Uint8Array === "undefined" || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(Uint8Array);
var $1ecd6a3b805ecadb$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGenerator%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncIteratorPrototype%": $1ecd6a3b805ecadb$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $c7Ac6,
    "%eval%": eval,
    "%EvalError%": $elYtN,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1ecd6a3b805ecadb$var$$Function,
    "%GeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $1S2Qw,
    "%ReferenceError%": $8T8lL,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1ecd6a3b805ecadb$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $f0gvj,
    "%ThrowTypeError%": $1ecd6a3b805ecadb$var$ThrowTypeError,
    "%TypedArray%": $1ecd6a3b805ecadb$var$TypedArray,
    "%TypeError%": $6bQrM,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $03ZFS,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1ecd6a3b805ecadb$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1ecd6a3b805ecadb$var$errorProto = $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto(e));
    $1ecd6a3b805ecadb$var$INTRINSICS["%Error.prototype%"] = $1ecd6a3b805ecadb$var$errorProto;
}
var $1ecd6a3b805ecadb$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1ecd6a3b805ecadb$var$getProto) value = $1ecd6a3b805ecadb$var$getProto(gen.prototype);
    }
    $1ecd6a3b805ecadb$var$INTRINSICS[name] = value;
    return value;
};
var $1ecd6a3b805ecadb$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $6FqDH = parcelRequire("6FqDH");

var $aZPoB = parcelRequire("aZPoB");
var $1ecd6a3b805ecadb$var$$concat = $6FqDH.call(Function.call, Array.prototype.concat);
var $1ecd6a3b805ecadb$var$$spliceApply = $6FqDH.call(Function.apply, Array.prototype.splice);
var $1ecd6a3b805ecadb$var$$replace = $6FqDH.call(Function.call, String.prototype.replace);
var $1ecd6a3b805ecadb$var$$strSlice = $6FqDH.call(Function.call, String.prototype.slice);
var $1ecd6a3b805ecadb$var$$exec = $6FqDH.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1ecd6a3b805ecadb$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1ecd6a3b805ecadb$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1ecd6a3b805ecadb$var$stringToPath = function stringToPath(string) {
    var first = $1ecd6a3b805ecadb$var$$strSlice(string, 0, 1);
    var last = $1ecd6a3b805ecadb$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $f0gvj("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $f0gvj("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1ecd6a3b805ecadb$var$$replace(string, $1ecd6a3b805ecadb$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1ecd6a3b805ecadb$var$$replace(subString, $1ecd6a3b805ecadb$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1ecd6a3b805ecadb$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aZPoB($1ecd6a3b805ecadb$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1ecd6a3b805ecadb$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicName)) {
        var value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicName];
        if (value === $1ecd6a3b805ecadb$var$needsEval) value = $1ecd6a3b805ecadb$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $6bQrM("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $f0gvj("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $6bQrM("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $6bQrM('"allowMissing" argument must be a boolean');
    if ($1ecd6a3b805ecadb$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $f0gvj("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1ecd6a3b805ecadb$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1ecd6a3b805ecadb$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1ecd6a3b805ecadb$var$$spliceApply(parts, $1ecd6a3b805ecadb$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1ecd6a3b805ecadb$var$$strSlice(part, 0, 1);
        var last = $1ecd6a3b805ecadb$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $f0gvj("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicRealName)) value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $6bQrM("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1ecd6a3b805ecadb$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1ecd6a3b805ecadb$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aZPoB(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("c7Ac6", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("elYtN", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("1S2Qw", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("8T8lL", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("f0gvj", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("6bQrM", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("03ZFS", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6FqDH", function(module, exports) {
"use strict";

var $kfm3A = parcelRequire("kfm3A");
module.exports = Function.prototype.bind || $kfm3A;

});
parcelRegister("kfm3A", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $ebd6516147fbc56f$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $ebd6516147fbc56f$var$toStr = Object.prototype.toString;
var $ebd6516147fbc56f$var$max = Math.max;
var $ebd6516147fbc56f$var$funcType = "[object Function]";
var $ebd6516147fbc56f$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ebd6516147fbc56f$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ebd6516147fbc56f$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $ebd6516147fbc56f$var$toStr.apply(target) !== $ebd6516147fbc56f$var$funcType) throw new TypeError($ebd6516147fbc56f$var$ERROR_MESSAGE + target);
    var args = $ebd6516147fbc56f$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ebd6516147fbc56f$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ebd6516147fbc56f$var$concatty(args, arguments));
    };
    var boundLength = $ebd6516147fbc56f$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $ebd6516147fbc56f$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("aZPoB", function(module, exports) {
"use strict";
var $8017780892750505$var$call = Function.prototype.call;
var $8017780892750505$var$$hasOwn = Object.prototype.hasOwnProperty;

var $6FqDH = parcelRequire("6FqDH");
/** @type {import('.')} */ module.exports = $6FqDH.call($8017780892750505$var$call, $8017780892750505$var$$hasOwn);

});





/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $d37552697cc5ea39$exports = {};

$parcel$export($d37552697cc5ea39$exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export($d37552697cc5ea39$exports, "detectOverflow", () => $f765731200b57f98$export$2e2bcd8739ae039);
$parcel$export($d37552697cc5ea39$exports, "createPopperBase", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopperLite", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);
var $f5c54167a3c62105$exports = {};

$parcel$export($f5c54167a3c62105$exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export($f5c54167a3c62105$exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export($f5c54167a3c62105$exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export($f5c54167a3c62105$exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export($f5c54167a3c62105$exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export($f5c54167a3c62105$exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export($f5c54167a3c62105$exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export($f5c54167a3c62105$exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export($f5c54167a3c62105$exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export($f5c54167a3c62105$exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export($f5c54167a3c62105$exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export($f5c54167a3c62105$exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export($f5c54167a3c62105$exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export($f5c54167a3c62105$exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export($f5c54167a3c62105$exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export($f5c54167a3c62105$exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export($f5c54167a3c62105$exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export($f5c54167a3c62105$exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export($f5c54167a3c62105$exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export($f5c54167a3c62105$exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export($f5c54167a3c62105$exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export($f5c54167a3c62105$exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export($f5c54167a3c62105$exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export($f5c54167a3c62105$exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


var $1341d386dda6ba3e$exports = {};

$parcel$export($1341d386dda6ba3e$exports, "applyStyles", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "arrow", () => $1992f2d714808ab6$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "computeStyles", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "eventListeners", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "flip", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "hide", () => $174d14927bb4f43b$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "offset", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "popperOffsets", () => $e92fb10df1450f31$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "preventOverflow", () => $3295dac8746ffe59$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};


var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}








function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}










function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};



function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}








function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d37552697cc5ea39$exports, $f5c54167a3c62105$exports);
$parcel$exportWildcard($d37552697cc5ea39$exports, $1341d386dda6ba3e$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ""));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, "");
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? "element" : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(",") : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = "alert";
const $91ca15859685b28b$var$DATA_KEY$a = "bs.alert";
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = "button";
const $91ca15859685b28b$var$DATA_KEY$9 = "bs.button";
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = ".data-api";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = "swipe";
const $91ca15859685b28b$var$EVENT_KEY$9 = ".bs.swipe";
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = "touch";
const $91ca15859685b28b$var$POINTER_TYPE_PEN = "pen";
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = "carousel";
const $91ca15859685b28b$var$DATA_KEY$8 = "bs.carousel";
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = ".data-api";
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = "next";
const $91ca15859685b28b$var$ORDER_PREV = "prev";
const $91ca15859685b28b$var$DIRECTION_LEFT = "left";
const $91ca15859685b28b$var$DIRECTION_RIGHT = "right";
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = "carousel";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = "active";
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = "slide";
const $91ca15859685b28b$var$CLASS_NAME_END = "carousel-item-end";
const $91ca15859685b28b$var$CLASS_NAME_START = "carousel-item-start";
const $91ca15859685b28b$var$CLASS_NAME_NEXT = "carousel-item-next";
const $91ca15859685b28b$var$CLASS_NAME_PREV = "carousel-item-prev";
const $91ca15859685b28b$var$SELECTOR_ACTIVE = ".active";
const $91ca15859685b28b$var$SELECTOR_ITEM = ".carousel-item";
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $91ca15859685b28b$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = "collapse";
const $91ca15859685b28b$var$DATA_KEY$7 = "bs.collapse";
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = ".data-api";
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = "show";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = "collapse";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = "collapsing";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = "collapsed";
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $91ca15859685b28b$var$WIDTH = "width";
const $91ca15859685b28b$var$HEIGHT = "height";
const $91ca15859685b28b$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = "dropdown";
const $91ca15859685b28b$var$DATA_KEY$6 = "bs.dropdown";
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$2 = "Escape";
const $91ca15859685b28b$var$TAB_KEY$1 = "Tab";
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = "show";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = "dropup";
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = "dropend";
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = "dropstart";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$SELECTOR_NAVBAR = ".navbar";
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? "top-end" : "top-start";
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? "top-start" : "top-end";
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? "bottom-end" : "bottom-start";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? "bottom-start" : "bottom-end";
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? "left-start" : "right-start";
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? "right-start" : "left-start";
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = "top";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $d37552697cc5ea39$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $d37552697cc5ea39$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = "backdrop";
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = "show";
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = "focustrap";
const $91ca15859685b28b$var$DATA_KEY$5 = "bs.focustrap";
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = "Tab";
const $91ca15859685b28b$var$TAB_NAV_FORWARD = "forward";
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = "backward";
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $91ca15859685b28b$var$PROPERTY_PADDING = "padding-right";
const $91ca15859685b28b$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = "modal";
const $91ca15859685b28b$var$DATA_KEY$4 = "bs.modal";
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$1 = "Escape";
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = "modal-open";
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = "show";
const $91ca15859685b28b$var$CLASS_NAME_STATIC = "modal-static";
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = ".modal.show";
const $91ca15859685b28b$var$SELECTOR_DIALOG = ".modal-dialog";
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = ".modal-body";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = "offcanvas";
const $91ca15859685b28b$var$DATA_KEY$3 = "bs.offcanvas";
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = ".data-api";
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = "Escape";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = "showing";
const $91ca15859685b28b$var$CLASS_NAME_HIDING = "hiding";
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $91ca15859685b28b$var$OPEN_SELECTOR = ".offcanvas.show";
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = "TemplateFactory";
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = "tooltip";
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_MODAL = "modal";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = "show";
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $91ca15859685b28b$var$TRIGGER_HOVER = "hover";
const $91ca15859685b28b$var$TRIGGER_FOCUS = "focus";
const $91ca15859685b28b$var$TRIGGER_CLICK = "click";
const $91ca15859685b28b$var$TRIGGER_MANUAL = "manual";
const $91ca15859685b28b$var$EVENT_HIDE$2 = "hide";
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = "hidden";
const $91ca15859685b28b$var$EVENT_SHOW$2 = "show";
const $91ca15859685b28b$var$EVENT_SHOWN$2 = "shown";
const $91ca15859685b28b$var$EVENT_INSERTED = "inserted";
const $91ca15859685b28b$var$EVENT_CLICK$1 = "click";
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = "focusin";
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = "focusout";
const $91ca15859685b28b$var$EVENT_MOUSEENTER = "mouseenter";
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = "mouseleave";
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $91ca15859685b28b$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $91ca15859685b28b$var$isRTL() ? "right" : "left"
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $d37552697cc5ea39$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $d37552697cc5ea39$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = "popover";
const $91ca15859685b28b$var$SELECTOR_TITLE = ".popover-header";
const $91ca15859685b28b$var$SELECTOR_CONTENT = ".popover-body";
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = "scrollspy";
const $91ca15859685b28b$var$DATA_KEY$2 = "bs.scrollspy";
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = ".data-api";
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = "[href]";
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = ".nav-link";
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = ".dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = "tab";
const $91ca15859685b28b$var$DATA_KEY$1 = "bs.tab";
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = "ArrowRight";
const $91ca15859685b28b$var$ARROW_UP_KEY = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY = "ArrowDown";
const $91ca15859685b28b$var$HOME_KEY = "Home";
const $91ca15859685b28b$var$END_KEY = "End";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = "active";
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = "show";
const $91ca15859685b28b$var$CLASS_DROPDOWN = "dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = "toast";
const $91ca15859685b28b$var$DATA_KEY = "bs.toast";
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = "fade";
const $91ca15859685b28b$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = "showing";
const $91ca15859685b28b$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);


var $cdd05a6aa3de24f9$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $cdd05a6aa3de24f9$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$cdd05a6aa3de24f9$var$debounce.debounce = $cdd05a6aa3de24f9$var$debounce;
$cdd05a6aa3de24f9$exports = $cdd05a6aa3de24f9$var$debounce;


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/* eslint-disable valid-jsdoc */ /* eslint-disable security/detect-object-injection */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/* eslint-disable valid-jsdoc */ /* eslint-disable security/detect-object-injection */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $1MTdI = parcelRequire("1MTdI");

/* eslint-disable valid-jsdoc */ /* eslint-disable security/detect-object-injection */ 
parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Query class is used to build query which is used by the DataManager to communicate with datasource.
 */ var $56262f229d1cff45$export$62297b13309008b2 = /** @class */ function() {
    /**
     * Constructor for Query class.
     *
     * @param {string|string[]} from?
     * @param from
     * @hidden
     */ function Query(from) {
        /** @hidden */ this.subQuery = null;
        /** @hidden */ this.isChild = false;
        /** @hidden */ this.distincts = [];
        this.queries = [];
        this.key = "";
        this.fKey = "";
        if (typeof from === "string") this.fromTable = from;
        else if (from && from instanceof Array) this.lookups = from;
        this.expands = [];
        this.sortedColumns = [];
        this.groupedColumns = [];
        this.subQuery = null;
        this.isChild = false;
        this.params = [];
        this.lazyLoad = [];
        return this;
    }
    Object.defineProperty(Query.prototype, "moduleName", {
        /** @hidden */ get: function() {
            return "query";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the primary key.
     *
     * @param  {string} field - Defines the column field.
     */ Query.prototype.setKey = function(field) {
        this.key = field;
        return this;
    };
    /**
     * Sets default DataManager to execute query.
     *
     * @param  {DataManager} dataManager - Defines the DataManager.
     */ Query.prototype.using = function(dataManager) {
        this.dataManager = dataManager;
        return this;
    };
    /**
     * Executes query with the given DataManager.
     *
     * @param  {DataManager} dataManager - Defines the DataManager.
     * @param  {Function} done - Defines the success callback.
     * @param  {Function} fail - Defines the failure callback.
     * @param  {Function} always - Defines the callback which will be invoked on either success or failure.
     *
     * <pre>
     * let dataManager: DataManager = new DataManager([{ ID: '10' }, { ID: '2' }, { ID: '1' }, { ID: '20' }]);
     * let query: Query = new Query();
     * query.sortBy('ID', (x: string, y: string): number => { return parseInt(x, 10) - parseInt(y, 10) });
     * let promise: Promise< Object > = query.execute(dataManager);
     * promise.then((e: { result: Object }) => { });
     * </pre>
     */ Query.prototype.execute = function(dataManager, done, fail, always) {
        dataManager = dataManager || this.dataManager;
        if (dataManager) return dataManager.executeQuery(this, done, fail, always);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError('Query - execute() : dataManager needs to be is set using "using" function or should be passed as argument');
    };
    /**
     * Executes query with the local datasource.
     *
     * @param  {DataManager} dataManager - Defines the DataManager.
     */ Query.prototype.executeLocal = function(dataManager) {
        dataManager = dataManager || this.dataManager;
        if (dataManager) return dataManager.executeLocal(this);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError('Query - executeLocal() : dataManager needs to be is set using "using" function or should be passed as argument');
    };
    /**
     * Creates deep copy of the Query object.
     */ Query.prototype.clone = function() {
        var cloned = new Query();
        cloned.queries = this.queries.slice(0);
        cloned.key = this.key;
        cloned.isChild = this.isChild;
        cloned.dataManager = this.dataManager;
        cloned.fromTable = this.fromTable;
        cloned.params = this.params.slice(0);
        cloned.expands = this.expands.slice(0);
        cloned.sortedColumns = this.sortedColumns.slice(0);
        cloned.groupedColumns = this.groupedColumns.slice(0);
        cloned.subQuerySelector = this.subQuerySelector;
        cloned.subQuery = this.subQuery;
        cloned.fKey = this.fKey;
        cloned.isCountRequired = this.isCountRequired;
        cloned.distincts = this.distincts.slice(0);
        cloned.lazyLoad = this.lazyLoad.slice(0);
        return cloned;
    };
    /**
     * Specifies the name of table to retrieve data in query execution.
     *
     * @param  {string} tableName - Defines the table name.
     */ Query.prototype.from = function(tableName) {
        this.fromTable = tableName;
        return this;
    };
    /**
     * Adds additional parameter which will be sent along with the request which will be generated while DataManager execute.
     *
     * @param  {string} key - Defines the key of additional parameter.
     * @param  {Function|string} value - Defines the value for the key.
     */ Query.prototype.addParams = function(key, value) {
        if (typeof value === "function") this.params.push({
            key: key,
            fn: value
        });
        else this.params.push({
            key: key,
            value: value
        });
        return this;
    };
    /**
     * @param fields
     * @hidden
     */ Query.prototype.distinct = function(fields) {
        if (typeof fields === "string") this.distincts = [].slice.call([
            fields
        ], 0);
        else this.distincts = fields.slice(0);
        return this;
    };
    /**
     * Expands the related table.
     *
     * @param  {string|Object[]} tables
     */ Query.prototype.expand = function(tables) {
        if (typeof tables === "string") this.expands = [].slice.call([
            tables
        ], 0);
        else this.expands = tables.slice(0);
        return this;
    };
    /**
     * Filter data with given filter criteria.
     *
     * @param {string|Predicate} fieldName - Defines the column field or Predicate.
     * @param {string} operator - Defines the operator how to filter data.
     * @param {string|number|boolean} value - Defines the values to match with data.
     * @param {boolean} ignoreCase - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreAccent
     * @param matchCase
     */ Query.prototype.where = function(fieldName, operator, value, ignoreCase, ignoreAccent, matchCase) {
        operator = operator ? operator.toLowerCase() : null;
        var predicate = null;
        if (typeof fieldName === "string") predicate = new $56262f229d1cff45$export$7ce636318c5a9f17(fieldName, operator, value, ignoreCase, ignoreAccent, matchCase);
        else if (fieldName instanceof $56262f229d1cff45$export$7ce636318c5a9f17) predicate = fieldName;
        this.queries.push({
            fn: "onWhere",
            e: predicate
        });
        return this;
    };
    /**
     * Search data with given search criteria.
     *
     * @param {string|number|boolean} searchKey - Defines the search key.
     * @param {string|string[]} fieldNames - Defines the collection of column fields.
     * @param {string} operator - Defines the operator how to search data.
     * @param {boolean} ignoreCase - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreAccent
     */ Query.prototype.search = function(searchKey, fieldNames, operator, ignoreCase, ignoreAccent) {
        if (typeof fieldNames === "string") fieldNames = [
            fieldNames
        ];
        if (!operator || operator === "none") operator = "contains";
        var comparer = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnOperators[operator];
        this.queries.push({
            fn: "onSearch",
            e: {
                fieldNames: fieldNames,
                operator: operator,
                searchKey: searchKey,
                ignoreCase: ignoreCase,
                ignoreAccent: ignoreAccent,
                comparer: comparer
            }
        });
        return this;
    };
    /**
     * Sort the data with given sort criteria.
     * By default, sort direction is ascending.
     *
     * @param {string|string[]} fieldName - Defines the single or collection of column fields.
     * @param {string|Function} comparer - Defines the sort direction or custom sort comparer function.
     * @param isFromGroup
     */ Query.prototype.sortBy = function(fieldName, comparer, isFromGroup) {
        return this.sortByForeignKey(fieldName, comparer, isFromGroup);
    };
    /**
     * Sort the data with given sort criteria.
     * By default, sort direction is ascending.
     *
     * @param {string|string[]} fieldName - Defines the single or collection of column fields.
     * @param {string|Function} comparer - Defines the sort direction or custom sort comparer function.
     * @param isFromGroup
     * @param {string} direction - Defines the sort direction .
     */ Query.prototype.sortByForeignKey = function(fieldName, comparer, isFromGroup, direction) {
        var order = !(0, $3EnZW.isNullOrUndefined)(direction) ? direction : "ascending";
        var sorts;
        var temp;
        if (typeof fieldName === "string" && (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(fieldName.toLowerCase(), " desc")) {
            fieldName = fieldName.replace(/ desc$/i, "");
            comparer = "descending";
        }
        if (!comparer || typeof comparer === "string") {
            order = comparer ? comparer.toLowerCase() : "ascending";
            comparer = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnSort(comparer);
        }
        if (isFromGroup) {
            sorts = Query.filterQueries(this.queries, "onSortBy");
            for(var i = 0; i < sorts.length; i++){
                temp = sorts[i].e.fieldName;
                if (typeof temp === "string") {
                    if (temp === fieldName) return this;
                } else if (temp instanceof Array) for(var j = 0; j < temp.length; j++){
                    if (temp[j] === fieldName || fieldName.toLowerCase() === temp[j] + " desc") return this;
                }
            }
        }
        this.queries.push({
            fn: "onSortBy",
            e: {
                fieldName: fieldName,
                comparer: comparer,
                direction: order
            }
        });
        return this;
    };
    /**
     * Sorts data in descending order.
     *
     * @param  {string} fieldName - Defines the column field.
     */ Query.prototype.sortByDesc = function(fieldName) {
        return this.sortBy(fieldName, "descending");
    };
    /**
     * Groups data with the given field name.
     *
     * @param {string} fieldName - Defines the column field.
     * @param fn
     * @param format
     */ Query.prototype.group = function(fieldName, fn, format) {
        this.sortBy(fieldName, null, true);
        this.queries.push({
            fn: "onGroup",
            e: {
                fieldName: fieldName,
                comparer: fn ? fn : null,
                format: format ? format : null
            }
        });
        return this;
    };
    /**
     * Gets data based on the given page index and size.
     *
     * @param  {number} pageIndex - Defines the current page index.
     * @param  {number} pageSize - Defines the no of records per page.
     */ Query.prototype.page = function(pageIndex, pageSize) {
        this.queries.push({
            fn: "onPage",
            e: {
                pageIndex: pageIndex,
                pageSize: pageSize
            }
        });
        return this;
    };
    /**
     * Gets data based on the given start and end index.
     *
     * @param  {number} start - Defines the start index of the datasource.
     * @param  {number} end - Defines the end index of the datasource.
     */ Query.prototype.range = function(start, end) {
        this.queries.push({
            fn: "onRange",
            e: {
                start: start,
                end: end
            }
        });
        return this;
    };
    /**
     * Gets data from the top of the data source based on given number of records count.
     *
     * @param  {number} nos - Defines the no of records to retrieve from datasource.
     */ Query.prototype.take = function(nos) {
        this.queries.push({
            fn: "onTake",
            e: {
                nos: nos
            }
        });
        return this;
    };
    /**
     * Skips data with given number of records count from the top of the data source.
     *
     * @param  {number} nos - Defines the no of records skip in the datasource.
     */ Query.prototype.skip = function(nos) {
        this.queries.push({
            fn: "onSkip",
            e: {
                nos: nos
            }
        });
        return this;
    };
    /**
     * Selects specified columns from the data source.
     *
     * @param  {string|string[]} fieldNames - Defines the collection of column fields.
     */ Query.prototype.select = function(fieldNames) {
        if (typeof fieldNames === "string") fieldNames = [].slice.call([
            fieldNames
        ], 0);
        this.queries.push({
            fn: "onSelect",
            e: {
                fieldNames: fieldNames
            }
        });
        return this;
    };
    /**
     * Gets the records in hierarchical relationship from two tables. It requires the foreign key to relate two tables.
     *
     * @param  {Query} query - Defines the query to relate two tables.
     * @param  {Function} selectorFn - Defines the custom function to select records.
     */ Query.prototype.hierarchy = function(query, selectorFn) {
        this.subQuerySelector = selectorFn;
        this.subQuery = query;
        return this;
    };
    /**
     * Sets the foreign key which is used to get data from the related table.
     *
     * @param  {string} key - Defines the foreign key.
     */ Query.prototype.foreignKey = function(key) {
        this.fKey = key;
        return this;
    };
    /**
     * It is used to get total number of records in the DataManager execution result.
     */ Query.prototype.requiresCount = function() {
        this.isCountRequired = true;
        return this;
    };
    //type - sum, avg, min, max
    /**
     * Aggregate the data with given type and field name.
     *
     * @param  {string} type - Defines the aggregate type.
     * @param  {string} field - Defines the column field to aggregate.
     */ Query.prototype.aggregate = function(type, field) {
        this.queries.push({
            fn: "onAggregates",
            e: {
                field: field,
                type: type
            }
        });
        return this;
    };
    /**
     * Pass array of filterColumn query for performing filter operation.
     *
     * @param  {QueryOptions[]} queries
     * @param  {string} name
     * @hidden
     */ Query.filterQueries = function(queries, name) {
        return queries.filter(function(q) {
            return q.fn === name;
        });
    };
    /**
     * To get the list of queries which is already filtered in current data source.
     *
     * @param  {Object[]} queries
     * @param  {string[]} singles
     * @hidden
     */ Query.filterQueryLists = function(queries, singles) {
        var filtered = queries.filter(function(q) {
            return singles.indexOf(q.fn) !== -1;
        });
        var res = {};
        for(var i = 0; i < filtered.length; i++)if (!res[filtered[i].fn]) res[filtered[i].fn] = filtered[i].e;
        return res;
    };
    return Query;
}();
/**
 * Predicate class is used to generate complex filter criteria.
 * This will be used by DataManager to perform multiple filtering operation.
 */ var $56262f229d1cff45$export$7ce636318c5a9f17 = /** @class */ function() {
    /**
     * Constructor for Predicate class.
     *
     * @param {string|Predicate} field
     * @param {string} operator
     * @param {string|number|boolean|Predicate|Predicate[]} value
     * @param {boolean=false} ignoreCase
     * @param ignoreAccent
     * @param {boolean} matchCase
     * @hidden
     */ function Predicate(field, operator, value, ignoreCase, ignoreAccent, matchCase) {
        if (ignoreCase === void 0) ignoreCase = false;
        /** @hidden */ this.ignoreAccent = false;
        /** @hidden */ this.isComplex = false;
        if (typeof field === "string") {
            this.field = field;
            this.operator = operator.toLowerCase();
            this.value = value;
            this.matchCase = matchCase;
            this.ignoreCase = ignoreCase;
            this.ignoreAccent = ignoreAccent;
            this.isComplex = false;
            this.comparer = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnOperators.processOperator(this.operator);
        } else if (field instanceof Predicate && value instanceof Predicate || value instanceof Array) {
            this.isComplex = true;
            this.condition = operator.toLowerCase();
            this.predicates = [
                field
            ];
            this.matchCase = field.matchCase;
            this.ignoreCase = field.ignoreCase;
            this.ignoreAccent = field.ignoreAccent;
            if (value instanceof Array) [].push.apply(this.predicates, value);
            else this.predicates.push(value);
        }
        return this;
    }
    /**
     * Adds n-number of new predicates on existing predicate with “and” condition.
     *
     * @param  {Object[]} args - Defines the collection of predicates.
     */ Predicate.and = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return Predicate.combinePredicates([].slice.call(args, 0), "and");
    };
    /**
     * Adds new predicate on existing predicate with “and” condition.
     *
     * @param {string} field - Defines the column field.
     * @param {string} operator - Defines the operator how to filter data.
     * @param {string} value - Defines the values to match with data.
     * @param {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreCase
     * @param ignoreAccent
     */ Predicate.prototype.and = function(field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, "and", ignoreCase, ignoreAccent);
    };
    /**
     * Adds n-number of new predicates on existing predicate with “or” condition.
     *
     * @param  {Object[]} args - Defines the collection of predicates.
     */ Predicate.or = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return Predicate.combinePredicates([].slice.call(args, 0), "or");
    };
    /**
     * Adds new predicate on existing predicate with “or” condition.
     *
     * @param {string} field - Defines the column field.
     * @param {string} operator - Defines the operator how to filter data.
     * @param {string} value - Defines the values to match with data.
     * @param {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreCase
     * @param ignoreAccent
     */ Predicate.prototype.or = function(field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, "or", ignoreCase, ignoreAccent);
    };
    /**
     * Adds n-number of new predicates on existing predicate with “and not” condition.
     *
     * @param  {Object[]} args - Defines the collection of predicates.
     */ Predicate.ornot = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return Predicate.combinePredicates([].slice.call(args, 0), "or not");
    };
    /**
     * Adds new predicate on existing predicate with “and not” condition.
     *
     * @param {string} field - Defines the column field.
     * @param {string} operator - Defines the operator how to filter data.
     * @param {string} value - Defines the values to match with data.
     * @param {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreCase
     * @param ignoreAccent
     */ Predicate.prototype.ornot = function(field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, "ornot", ignoreCase, ignoreAccent);
    };
    /**
     * Adds n-number of new predicates on existing predicate with “and not” condition.
     *
     * @param  {Object[]} args - Defines the collection of predicates.
     */ Predicate.andnot = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return Predicate.combinePredicates([].slice.call(args, 0), "and not");
    };
    /**
     * Adds new predicate on existing predicate with “and not” condition.
     *
     * @param {string} field - Defines the column field.
     * @param {string} operator - Defines the operator how to filter data.
     * @param {string} value - Defines the values to match with data.
     * @param {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     * @param ignoreCase
     * @param ignoreAccent
     */ Predicate.prototype.andnot = function(field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, "andnot", ignoreCase, ignoreAccent);
    };
    /**
     * Converts plain JavaScript object to Predicate object.
     *
     * @param  {Predicate[]|Predicate} json - Defines single or collection of Predicate.
     */ Predicate.fromJson = function(json) {
        if (json instanceof Array) {
            var res = [];
            for(var i = 0, len = json.length; i < len; i++)res.push(this.fromJSONData(json[i]));
            return res;
        }
        var pred = json;
        return this.fromJSONData(pred);
    };
    /**
     * Validate the record based on the predicates.
     *
     * @param  {Object} record - Defines the datasource record.
     */ Predicate.prototype.validate = function(record) {
        var predicate = this.predicates ? this.predicates : [];
        var ret;
        var isAnd;
        if (!this.isComplex && this.comparer) {
            if (this.condition && this.condition.indexOf("not") !== -1) {
                this.condition = this.condition.split("not")[0] === "" ? undefined : this.condition.split("not")[0];
                return !this.comparer.call(this, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(this.field, record), this.value, this.ignoreCase, this.ignoreAccent);
            } else return this.comparer.call(this, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(this.field, record), this.value, this.ignoreCase, this.ignoreAccent);
        }
        if (this.condition && this.condition.indexOf("not") !== -1) isAnd = this.condition.indexOf("and") !== -1;
        else isAnd = this.condition === "and";
        for(var i = 0; i < predicate.length; i++){
            if (i > 0 && this.condition && this.condition.indexOf("not") !== -1) predicate[i].condition = predicate[i].condition ? predicate[i].condition + "not" : "not";
            ret = predicate[i].validate(record);
            if (isAnd) {
                if (!ret) return false;
            } else {
                if (ret) return true;
            }
        }
        return isAnd;
    };
    /**
     * Converts predicates to plain JavaScript.
     * This method is uses Json stringify when serializing Predicate object.
     */ Predicate.prototype.toJson = function() {
        var predicates;
        var p;
        if (this.isComplex) {
            predicates = [];
            p = this.predicates;
            for(var i = 0; i < p.length; i++)predicates.push(p[i].toJson());
        }
        return {
            isComplex: this.isComplex,
            field: this.field,
            operator: this.operator,
            value: this.value,
            ignoreCase: this.ignoreCase,
            ignoreAccent: this.ignoreAccent,
            condition: this.condition,
            predicates: predicates,
            matchCase: this.matchCase
        };
    };
    Predicate.combinePredicates = function(predicates, operator) {
        if (predicates.length === 1) {
            if (!(predicates[0] instanceof Array)) return predicates[0];
            predicates = predicates[0];
        }
        return new Predicate(predicates[0], operator, predicates.slice(1));
    };
    Predicate.combine = function(pred, field, operator, value, condition, ignoreCase, ignoreAccent) {
        if (field instanceof Predicate) return Predicate[condition](pred, field);
        if (typeof field === "string") return Predicate[condition](pred, new Predicate(field, operator, value, ignoreCase, ignoreAccent));
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("Predicate - " + condition + " : invalid arguments");
    };
    Predicate.fromJSONData = function(json) {
        var preds = json.predicates || [];
        var len = preds.length;
        var predicates = [];
        var result;
        for(var i = 0; i < len; i++)predicates.push(this.fromJSONData(preds[i]));
        if (!json.isComplex) result = new Predicate(json.field, json.operator, json.value, json.ignoreCase, json.ignoreAccent);
        else result = new Predicate(predicates[0], json.condition, predicates.slice(1));
        return result;
    };
    return Predicate;
}();



/**
 * DataManager is used to manage and manipulate relational data.
 */ var $a4fc1b4c34afe464$export$fedddcd2788076dd = /** @class */ function() {
    /**
     * Constructor for DataManager class
     *
     * @param {DataOptions|JSON[]} dataSource?
     * @param {Query} query?
     * @param {AdaptorOptions|string} adaptor?
     * @param dataSource
     * @param query
     * @param adaptor
     * @hidden
     */ function DataManager(dataSource, query, adaptor) {
        var _this = this;
        /** @hidden */ this.dateParse = true;
        /** @hidden */ this.timeZoneHandling = true;
        this.persistQuery = {};
        this.isInitialLoad = false;
        this.requests = [];
        this.isInitialLoad = true;
        if (!dataSource && !this.dataSource) dataSource = [];
        adaptor = adaptor || dataSource.adaptor;
        if (dataSource && dataSource.timeZoneHandling === false) this.timeZoneHandling = dataSource.timeZoneHandling;
        var data;
        if (dataSource instanceof Array) data = {
            json: dataSource,
            offline: true
        };
        else if (typeof dataSource === "object") {
            if (!dataSource.json) dataSource.json = [];
            if (!dataSource.enablePersistence) dataSource.enablePersistence = false;
            if (!dataSource.id) dataSource.id = "";
            if (!dataSource.ignoreOnPersist) dataSource.ignoreOnPersist = [];
            data = {
                url: dataSource.url,
                insertUrl: dataSource.insertUrl,
                removeUrl: dataSource.removeUrl,
                updateUrl: dataSource.updateUrl,
                crudUrl: dataSource.crudUrl,
                batchUrl: dataSource.batchUrl,
                json: dataSource.json,
                headers: dataSource.headers,
                accept: dataSource.accept,
                data: dataSource.data,
                timeTillExpiration: dataSource.timeTillExpiration,
                cachingPageSize: dataSource.cachingPageSize,
                enableCaching: dataSource.enableCaching,
                requestType: dataSource.requestType,
                key: dataSource.key,
                crossDomain: dataSource.crossDomain,
                jsonp: dataSource.jsonp,
                dataType: dataSource.dataType,
                offline: dataSource.offline !== undefined ? dataSource.offline : dataSource.adaptor instanceof (0, $e1170102ff02b3b7$export$90859058788a17cf) || dataSource.adaptor instanceof (0, $e1170102ff02b3b7$export$1619bf00353f7597) ? false : dataSource.url ? false : true,
                requiresFormat: dataSource.requiresFormat,
                enablePersistence: dataSource.enablePersistence,
                id: dataSource.id,
                ignoreOnPersist: dataSource.ignoreOnPersist
            };
        } else (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("DataManager: Invalid arguments");
        if (data.requiresFormat === undefined && !(0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isCors()) data.requiresFormat = (0, $3EnZW.isNullOrUndefined)(data.crossDomain) ? true : data.crossDomain;
        if (data.dataType === undefined) data.dataType = "json";
        this.dataSource = data;
        this.defaultQuery = query;
        if (this.dataSource.enablePersistence && this.dataSource.id) window.addEventListener("unload", this.setPersistData.bind(this));
        if (data.url && data.offline && !data.json.length) {
            this.isDataAvailable = false;
            this.adaptor = adaptor || new (0, $e1170102ff02b3b7$export$b1cc6088a1ba4742)();
            this.dataSource.offline = false;
            this.ready = this.executeQuery(query || new (0, $56262f229d1cff45$export$62297b13309008b2)());
            this.ready.then(function(e) {
                _this.dataSource.offline = true;
                _this.isDataAvailable = true;
                data.json = e.result;
                _this.adaptor = new (0, $e1170102ff02b3b7$export$650eb66a1d9d6599)();
            });
        } else this.adaptor = data.offline ? new (0, $e1170102ff02b3b7$export$650eb66a1d9d6599)() : new (0, $e1170102ff02b3b7$export$b1cc6088a1ba4742)();
        if (!data.jsonp && this.adaptor instanceof (0, $e1170102ff02b3b7$export$b1cc6088a1ba4742)) data.jsonp = "callback";
        this.adaptor = adaptor || this.adaptor;
        if (data.enableCaching) this.adaptor = new (0, $e1170102ff02b3b7$export$e2a2feb26dbf8c19)(this.adaptor, data.timeTillExpiration, data.cachingPageSize);
        return this;
    }
    Object.defineProperty(DataManager.prototype, "moduleName", {
        /** @hidden */ get: function() {
            return "datamanager";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get the queries maintained in the persisted state.
     * @param {string} id - The identifier of the persisted query to retrieve.
     * @returns {object} The persisted data object.
     */ DataManager.prototype.getPersistedData = function(id) {
        var persistedData = localStorage.getItem(id || this.dataSource.id);
        return JSON.parse(persistedData);
    };
    /**
    * Set the queries to be maintained in the persisted state.
    * @param {Event} e - The event parameter that triggers the setPersistData method.
    * @param {string} id - The identifier of the persisted query to set.
    * @param {object} persistData - The data to be persisted.
    * @returns {void} .
    */ DataManager.prototype.setPersistData = function(e, id, persistData) {
        localStorage.setItem(id || this.dataSource.id, JSON.stringify(persistData || this.persistQuery));
    };
    DataManager.prototype.setPersistQuery = function(query) {
        var _this = this;
        var persistedQuery = this.getPersistedData();
        if (this.isInitialLoad && persistedQuery && Object.keys(persistedQuery).length) {
            this.persistQuery = persistedQuery;
            this.persistQuery.queries = this.persistQuery.queries.filter(function(query) {
                if (_this.dataSource.ignoreOnPersist && _this.dataSource.ignoreOnPersist.length) {
                    if (query.fn && _this.dataSource.ignoreOnPersist.some(function(keyword) {
                        return query.fn === keyword;
                    })) return false; // Exclude the matching query
                }
                if (query.fn === "onWhere") {
                    var e = query.e;
                    if (e && e.isComplex && e.predicates instanceof Array) {
                        var allPredicates = e.predicates.map(function(predicateObj) {
                            if (predicateObj.predicates && predicateObj.predicates instanceof Array) {
                                // Process nested predicate array
                                var nestedPredicates = predicateObj.predicates.map(function(nestedPredicate) {
                                    var field = nestedPredicate.field, operator = nestedPredicate.operator, value = nestedPredicate.value, ignoreCase = nestedPredicate.ignoreCase, ignoreAccent = nestedPredicate.ignoreAccent, matchCase = nestedPredicate.matchCase;
                                    return new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, operator, value, ignoreCase, ignoreAccent, matchCase);
                                });
                                return predicateObj.condition === "and" ? (0, $56262f229d1cff45$export$7ce636318c5a9f17).and(nestedPredicates) : (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(nestedPredicates);
                            } else {
                                // Process individual predicate
                                var field = predicateObj.field, operator = predicateObj.operator, value = predicateObj.value, ignoreCase = predicateObj.ignoreCase, ignoreAccent = predicateObj.ignoreAccent, matchCase = predicateObj.matchCase;
                                return new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, operator, value, ignoreCase, ignoreAccent, matchCase);
                            }
                        });
                        query.e = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(allPredicates[0], e.condition, allPredicates.slice(1));
                    }
                }
                return true; // Keep all other queries
            });
            var newQuery = (0, $3EnZW.extend)(new (0, $56262f229d1cff45$export$62297b13309008b2)(), this.persistQuery);
            this.isInitialLoad = false;
            return newQuery;
        } else {
            this.persistQuery = query;
            this.isInitialLoad = false;
            return query;
        }
    };
    /**
     * Overrides DataManager's default query with given query.
     *
     * @param  {Query} query - Defines the new default query.
     */ DataManager.prototype.setDefaultQuery = function(query) {
        this.defaultQuery = query;
        return this;
    };
    /**
     * Executes the given query with local data source.
     *
     * @param  {Query} query - Defines the query to retrieve data.
     */ DataManager.prototype.executeLocal = function(query) {
        if (!this.defaultQuery && !(query instanceof (0, $56262f229d1cff45$export$62297b13309008b2))) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("DataManager - executeLocal() : A query is required to execute");
        if (!this.dataSource.json) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("DataManager - executeLocal() : Json data is required to execute");
        if (this.dataSource.enablePersistence && this.dataSource.id) query = this.setPersistQuery(query);
        query = query || this.defaultQuery;
        var result = this.adaptor.processQuery(this, query);
        if (query.subQuery) {
            var from = query.subQuery.fromTable;
            var lookup = query.subQuery.lookups;
            var res = query.isCountRequired ? result.result : result;
            if (lookup && lookup instanceof Array) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).buildHierarchy(query.subQuery.fKey, from, res, lookup, query.subQuery.key);
            for(var j = 0; j < res.length; j++)if (res[j][from] instanceof Array) {
                res[j] = (0, $3EnZW.extend)({}, {}, res[j]);
                res[j][from] = this.adaptor.processResponse(query.subQuery.using(new DataManager(res[j][from].slice(0))).executeLocal(), this, query);
            }
        }
        return this.adaptor.processResponse(result, this, query);
    };
    /**
     * Executes the given query with either local or remote data source.
     * It will be executed as asynchronously and returns Promise object which will be resolved or rejected after action completed.
     *
     * @param  {Query|Function} query - Defines the query to retrieve data.
     * @param  {Function} done - Defines the callback function and triggers when the Promise is resolved.
     * @param  {Function} fail - Defines the callback function and triggers when the Promise is rejected.
     * @param  {Function} always - Defines the callback function and triggers when the Promise is resolved or rejected.
     */ DataManager.prototype.executeQuery = function(query, done, fail, always) {
        var _this = this;
        var makeRequest = "makeRequest";
        if (this.dataSource.enablePersistence && this.dataSource.id) query = this.setPersistQuery(query);
        if (typeof query === "function") {
            always = fail;
            fail = done;
            done = query;
            query = null;
        }
        if (!query) query = this.defaultQuery;
        if (!(query instanceof (0, $56262f229d1cff45$export$62297b13309008b2))) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("DataManager - executeQuery() : A query is required to execute");
        var deffered = new $a4fc1b4c34afe464$export$85f6557964517f1a();
        var args = {
            query: query
        };
        if (!this.dataSource.offline && this.dataSource.url !== undefined && this.dataSource.url !== "" || !(0, $3EnZW.isNullOrUndefined)(this.adaptor[makeRequest]) || this.isCustomDataAdaptor(this.adaptor)) {
            var result = this.adaptor.processQuery(this, query);
            if (!(0, $3EnZW.isNullOrUndefined)(this.adaptor[makeRequest])) this.adaptor[makeRequest](result, deffered, args, query);
            else if (!(0, $3EnZW.isNullOrUndefined)(result.url) || this.isCustomDataAdaptor(this.adaptor)) {
                this.requests = [];
                this.makeRequest(result, deffered, args, query);
            } else {
                args = DataManager.getDeferedArgs(query, result, args);
                deffered.resolve(args);
            }
        } else DataManager.nextTick(function() {
            var res = _this.executeLocal(query);
            args = DataManager.getDeferedArgs(query, res, args);
            deffered.resolve(args);
        });
        if (done || fail) deffered.promise.then(done, fail);
        if (always) deffered.promise.then(always, always);
        return deffered.promise;
    };
    DataManager.getDeferedArgs = function(query, result, args) {
        if (query.isCountRequired) {
            args.result = result.result;
            args.count = result.count;
            args.aggregates = result.aggregates;
        } else args.result = result;
        return args;
    };
    DataManager.nextTick = function(fn) {
        /* eslint-disable @typescript-eslint/no-explicit-any */ // tslint:disable-next-line:no-any
        (window.setImmediate || window.setTimeout)(fn, 0);
    /* eslint-enable @typescript-eslint/no-explicit-any */ };
    DataManager.prototype.extendRequest = function(url, fnSuccess, fnFail) {
        return (0, $3EnZW.extend)({}, {
            type: "GET",
            dataType: this.dataSource.dataType,
            crossDomain: this.dataSource.crossDomain,
            jsonp: this.dataSource.jsonp,
            cache: true,
            processData: false,
            onSuccess: fnSuccess,
            onFailure: fnFail
        }, url);
    };
    // tslint:disable-next-line:max-func-body-length
    DataManager.prototype.makeRequest = function(url, deffered, args, query) {
        var _this = this;
        var isSelector = !!query.subQuerySelector;
        var fnFail = function(e) {
            args.error = e;
            deffered.reject(args);
        };
        var process = function(data, count, xhr, request, actual, aggregates, virtualSelectRecords) {
            args.xhr = xhr;
            args.count = count ? parseInt(count.toString(), 10) : 0;
            args.result = data;
            args.request = request;
            args.aggregates = aggregates;
            args.actual = actual;
            args.virtualSelectRecords = virtualSelectRecords;
            deffered.resolve(args);
        };
        var fnQueryChild = function(data, selector) {
            var subDeffer = new $a4fc1b4c34afe464$export$85f6557964517f1a();
            var childArgs = {
                parent: args
            };
            query.subQuery.isChild = true;
            var subUrl = _this.adaptor.processQuery(_this, query.subQuery, data ? _this.adaptor.processResponse(data) : selector);
            var childReq = _this.makeRequest(subUrl, subDeffer, childArgs, query.subQuery);
            if (!isSelector) subDeffer.then(function(subData) {
                if (data) {
                    (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).buildHierarchy(query.subQuery.fKey, query.subQuery.fromTable, data, subData, query.subQuery.key);
                    process(data, subData.count, subData.xhr);
                }
            }, fnFail);
            return childReq;
        };
        var fnSuccess = function(data, request) {
            if (_this.isGraphQLAdaptor(_this.adaptor)) {
                // tslint:disable-next-line:no-string-literal
                if (!(0, $3EnZW.isNullOrUndefined)(data["errors"])) // tslint:disable-next-line:no-string-literal
                return fnFail(data["errors"], request);
            }
            if (_this.isCustomDataAdaptor(_this.adaptor)) request = (0, $3EnZW.extend)({}, _this.fetchReqOption, request);
            if (request.contentType.indexOf("xml") === -1 && _this.dateParse) data = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(data);
            var result = _this.adaptor.processResponse(data, _this, query, request.fetchRequest, request);
            var count = 0;
            var aggregates = null;
            var virtualSelectRecords = "virtualSelectRecords";
            var virtualRecords = data[virtualSelectRecords];
            if (query.isCountRequired) {
                count = result.count;
                aggregates = result.aggregates;
                result = result.result;
            }
            if (!query.subQuery) {
                process(result, count, request.fetchRequest, request.type, data, aggregates, virtualRecords);
                return;
            }
            if (!isSelector) fnQueryChild(result, request);
        };
        var req = this.extendRequest(url, fnSuccess, fnFail);
        if (!this.isCustomDataAdaptor(this.adaptor)) {
            var fetch_1 = new (0, $1MTdI.Fetch)(req);
            fetch_1.beforeSend = function() {
                _this.beforeSend(fetch_1.fetchRequest, fetch_1);
            };
            req = fetch_1.send();
            req.catch(function(e) {
                return true;
            }); // to handle failure remote requests.
            this.requests.push(fetch_1);
        } else {
            this.fetchReqOption = req;
            var request = req;
            this.adaptor.options.getData({
                data: request.data,
                onSuccess: request.onSuccess,
                onFailure: request.onFailure
            });
        }
        if (isSelector) {
            var promise = void 0;
            var res = query.subQuerySelector.call(this, {
                query: query.subQuery,
                parent: query
            });
            if (res && res.length) {
                promise = Promise.all([
                    req,
                    fnQueryChild(null, res)
                ]);
                promise.then(function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var result = args[0];
                    var pResult = _this.adaptor.processResponse(result[0], _this, query, _this.requests[0].fetchRequest, _this.requests[0]);
                    var count = 0;
                    if (query.isCountRequired) {
                        count = pResult.count;
                        pResult = pResult.result;
                    }
                    var cResult = _this.adaptor.processResponse(result[1], _this, query.subQuery, _this.requests[1].fetchRequest, _this.requests[1]);
                    count = 0;
                    if (query.subQuery.isCountRequired) {
                        count = cResult.count;
                        cResult = cResult.result;
                    }
                    (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).buildHierarchy(query.subQuery.fKey, query.subQuery.fromTable, pResult, cResult, query.subQuery.key);
                    isSelector = false;
                    process(pResult, count, _this.requests[0].fetchRequest);
                });
            } else isSelector = false;
        }
        return req;
    };
    DataManager.prototype.beforeSend = function(request, settings) {
        this.adaptor.beforeSend(this, request, settings);
        var headers = this.dataSource.headers;
        var props;
        for(var i = 0; headers && i < headers.length; i++){
            props = [];
            var keys = Object.keys(headers[i]);
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var prop = keys_1[_i];
                props.push(prop);
                request.headers.set(prop, headers[i][prop]);
            }
        }
    };
    /**
     * Save bulk changes to the given table name.
     * User can add a new record, edit an existing record, and delete a record at the same time.
     * If the datasource from remote, then updated in a single post.
     *
     * @param {Object} changes - Defines the CrudOptions.
     * @param {string} key - Defines the column field.
     * @param {string|Query} tableName - Defines the table name.
     * @param {Query} query - Sets default query for the DataManager.
     * @param original
     */ DataManager.prototype.saveChanges = function(changes, key, tableName, query, original) {
        var _this = this;
        if (tableName instanceof (0, $56262f229d1cff45$export$62297b13309008b2)) {
            query = tableName;
            tableName = null;
        }
        var args = {
            url: tableName,
            key: key || this.dataSource.key
        };
        var req = this.adaptor.batchRequest(this, changes, args, query || new (0, $56262f229d1cff45$export$62297b13309008b2)(), original);
        var dofetchRequest = "dofetchRequest";
        if (this.dataSource.offline) return req;
        if (!(0, $3EnZW.isNullOrUndefined)(this.adaptor[dofetchRequest])) return this.adaptor[dofetchRequest](req);
        else if (!this.isCustomDataAdaptor(this.adaptor)) {
            var deff_1 = new $a4fc1b4c34afe464$export$85f6557964517f1a();
            var fetch_2 = new (0, $1MTdI.Fetch)(req);
            fetch_2.beforeSend = function() {
                _this.beforeSend(fetch_2.fetchRequest, fetch_2);
            };
            fetch_2.onSuccess = function(data, request) {
                if (_this.isGraphQLAdaptor(_this.adaptor)) // tslint:disable-next-line:no-string-literal
                {
                    if (!(0, $3EnZW.isNullOrUndefined)(data["errors"])) // tslint:disable-next-line:no-string-literal
                    fetch_2.onFailure(JSON.stringify(data["errors"]));
                }
                deff_1.resolve(_this.adaptor.processResponse(data, _this, null, request.fetchRequest, request, changes, args));
            };
            fetch_2.onFailure = function(e) {
                deff_1.reject([
                    {
                        error: e
                    }
                ]);
            };
            fetch_2.send().catch(function(e) {
                return true;
            }); // to handle the failure requests.
            return deff_1.promise;
        } else return this.dofetchRequest(req, this.adaptor.options.batchUpdate, changes);
    };
    /**
     * Inserts new record in the given table.
     *
     * @param {Object} data - Defines the data to insert.
     * @param {string|Query} tableName - Defines the table name.
     * @param {Query} query - Sets default query for the DataManager.
     * @param position
     */ DataManager.prototype.insert = function(data, tableName, query, position) {
        if (tableName instanceof (0, $56262f229d1cff45$export$62297b13309008b2)) {
            query = tableName;
            tableName = null;
        }
        var req = this.adaptor.insert(this, data, tableName, query, position);
        var dofetchRequest = "dofetchRequest";
        if (this.dataSource.offline) return req;
        if (!(0, $3EnZW.isNullOrUndefined)(this.adaptor[dofetchRequest])) return this.adaptor[dofetchRequest](req);
        else return this.dofetchRequest(req, this.adaptor.options.addRecord);
    };
    /**
     * Removes data from the table with the given key.
     *
     * @param  {string} keyField - Defines the column field.
     * @param  {Object} value - Defines the value to find the data in the specified column.
     * @param  {string|Query} tableName - Defines the table name
     * @param  {Query} query - Sets default query for the DataManager.
     */ DataManager.prototype.remove = function(keyField, value, tableName, query) {
        if (typeof value === "object") value = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(keyField, value);
        if (tableName instanceof (0, $56262f229d1cff45$export$62297b13309008b2)) {
            query = tableName;
            tableName = null;
        }
        var res = this.adaptor.remove(this, keyField, value, tableName, query);
        var dofetchRequest = "dofetchRequest";
        if (this.dataSource.offline) return res;
        if (!(0, $3EnZW.isNullOrUndefined)(this.adaptor[dofetchRequest])) return this.adaptor[dofetchRequest](res);
        else {
            var remove = this.adaptor.options.deleteRecord;
            return this.dofetchRequest(res, remove);
        }
    };
    /**
     * Updates existing record in the given table.
     *
     * @param {string} keyField - Defines the column field.
     * @param {Object} value - Defines the value to find the data in the specified column.
     * @param {string|Query} tableName - Defines the table name
     * @param {Query} query - Sets default query for the DataManager.
     * @param original
     */ DataManager.prototype.update = function(keyField, value, tableName, query, original) {
        if (tableName instanceof (0, $56262f229d1cff45$export$62297b13309008b2)) {
            query = tableName;
            tableName = null;
        }
        var res = this.adaptor.update(this, keyField, value, tableName, query, original);
        var dofetchRequest = "dofetchRequest";
        if (this.dataSource.offline) return res;
        if (!(0, $3EnZW.isNullOrUndefined)(this.adaptor[dofetchRequest])) return this.adaptor[dofetchRequest](res);
        else {
            var update = this.adaptor.options.updateRecord;
            return this.dofetchRequest(res, update);
        }
    };
    DataManager.prototype.isCustomDataAdaptor = function(dataSource) {
        return this.adaptor.getModuleName && this.adaptor.getModuleName() === "CustomDataAdaptor";
    };
    DataManager.prototype.isGraphQLAdaptor = function(dataSource) {
        return this.adaptor.getModuleName && this.adaptor.getModuleName() === "GraphQLAdaptor";
    };
    DataManager.prototype.successFunc = function(record, request, changes) {
        if (this.isGraphQLAdaptor(this.adaptor)) {
            var data = typeof record === "object" ? record : JSON.parse(record);
            // tslint:disable-next-line:no-string-literal
            if (!(0, $3EnZW.isNullOrUndefined)(data["errors"])) // tslint:disable-next-line:no-string-literal
            this.failureFunc(JSON.stringify(data["errors"]));
        }
        if (this.isCustomDataAdaptor(this.adaptor)) request = (0, $3EnZW.extend)({}, this.fetchReqOption, request);
        try {
            (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(record);
        } catch (e) {
            record = [];
        }
        record = this.adaptor.processResponse((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(record), this, null, request.fetchRequest, request, changes);
        this.fetchDeffered.resolve(record);
    };
    DataManager.prototype.failureFunc = function(e) {
        this.fetchDeffered.reject([
            {
                error: e
            }
        ]);
    };
    DataManager.prototype.dofetchRequest = function(res, fetchFunc, changes) {
        var _this = this;
        res = (0, $3EnZW.extend)({}, {
            type: "POST",
            contentType: "application/json; charset=utf-8",
            processData: false
        }, res);
        this.fetchDeffered = new $a4fc1b4c34afe464$export$85f6557964517f1a();
        if (!this.isCustomDataAdaptor(this.adaptor)) {
            var fetch_3 = new (0, $1MTdI.Fetch)(res);
            fetch_3.beforeSend = function() {
                _this.beforeSend(fetch_3.fetchRequest, fetch_3);
            };
            fetch_3.onSuccess = this.successFunc.bind(this);
            fetch_3.onFailure = this.failureFunc.bind(this);
            fetch_3.send().catch(function(e) {
                return true;
            }); // to handle the failure requests.
        } else {
            this.fetchReqOption = res;
            fetchFunc.call(this, {
                data: res.data,
                onSuccess: this.successFunc.bind(this),
                onFailure: this.failureFunc.bind(this),
                changes: changes
            });
        }
        return this.fetchDeffered.promise;
    };
    DataManager.prototype.clearPersistence = function() {
        window.removeEventListener("unload", this.setPersistData.bind(this));
        this.dataSource.enablePersistence = false;
        this.persistQuery = {};
        window.localStorage.setItem(this.dataSource.id, "[]");
    };
    return DataManager;
}();
/**
 * Deferred is used to handle asynchronous operation.
 */ var $a4fc1b4c34afe464$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        /**
         * Promise is an object that represents a value that may not be available yet, but will be resolved at some point in the future.
         */ this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        /**
         * Defines the callback function triggers when the Deferred object is resolved.
         */ this.then = this.promise.then.bind(this.promise);
        /**
         * Defines the callback function triggers when the Deferred object is rejected.
         */ this.catch = this.promise.catch.bind(this.promise);
    }
    return Deferred;
}();



var $fc77c1cdc02c8be7$var$consts = {
    GroupGuid: "{271bbba0-1ee7}"
};
/**
 * Data manager common utility methods.
 *
 * @hidden
 */ var $fc77c1cdc02c8be7$export$de67910a89dbf741 = /** @class */ function() {
    function DataUtil() {}
    /**
     * Returns the value by invoking the provided parameter function.
     * If the paramater is not of type function then it will be returned as it is.
     *
     * @param {Function|string|string[]|number} value
     * @param {Object} inst?
     * @param inst
     * @hidden
     */ DataUtil.getValue = function(value, inst) {
        if (typeof value === "function") return value.call(inst || {});
        return value;
    };
    /**
     * Returns true if the input string ends with given string.
     *
     * @param  {string} input
     * @param  {string} substr
     */ DataUtil.endsWith = function(input, substr) {
        return input.slice && input.slice(-substr.length) === substr;
    };
    /**
     * Returns true if the input string not ends with given string.
     *
     * @param  {string} input
     * @param  {string} substr
     */ DataUtil.notEndsWith = function(input, substr) {
        return input.slice && input.slice(-substr.length) !== substr;
    };
    /**
     * Returns true if the input string starts with given string.
     *
     * @param {string} str
     * @param {string} startstr
     * @param input
     * @param start
     */ DataUtil.startsWith = function(input, start) {
        return input.slice(0, start.length) === start;
    };
    /**
     * Returns true if the input string not starts with given string.
     *
     * @param {string} str
     * @param {string} startstr
     * @param input
     * @param start
     */ DataUtil.notStartsWith = function(input, start) {
        return input.slice(0, start.length) !== start;
    };
    /**
     * Returns true if the input string pattern(wildcard) matches with given string.
     *
     * @param {string} str
     * @param {string} startstr
     * @param input
     * @param pattern
     */ DataUtil.wildCard = function(input, pattern) {
        var asteriskSplit;
        var optionalSplit;
        // special character allowed search
        if (pattern.indexOf("[") !== -1) pattern = pattern.split("[").join("[[]");
        if (pattern.indexOf("(") !== -1) pattern = pattern.split("(").join("[(]");
        if (pattern.indexOf(")") !== -1) pattern = pattern.split(")").join("[)]");
        if (pattern.indexOf("\\") !== -1) pattern = pattern.split("\\").join("[\\\\]");
        if (pattern.indexOf("*") !== -1) {
            if (pattern.charAt(0) !== "*") pattern = "^" + pattern;
            if (pattern.charAt(pattern.length - 1) !== "*") pattern = pattern + "$";
            asteriskSplit = pattern.split("*");
            for(var i = 0; i < asteriskSplit.length; i++)if (asteriskSplit[i].indexOf(".") === -1) asteriskSplit[i] = asteriskSplit[i] + ".*";
            else asteriskSplit[i] = asteriskSplit[i] + "*";
            pattern = asteriskSplit.join("");
        }
        if (pattern.indexOf("%3f") !== -1 || pattern.indexOf("?") !== -1) {
            optionalSplit = pattern.indexOf("%3f") !== -1 ? pattern.split("%3f") : pattern.split("?");
            pattern = optionalSplit.join(".");
        }
        // eslint-disable-next-line security/detect-non-literal-regexp
        var regexPattern = new RegExp(pattern, "g");
        return regexPattern.test(input);
    };
    /**
     * Returns true if the input string pattern(like) matches with given string.
     *
     * @param {string} str
     * @param {string} startstr
     * @param input
     * @param pattern
     */ DataUtil.like = function(input, pattern) {
        if (pattern.indexOf("%") !== -1) {
            if (pattern.charAt(0) === "%" && pattern.lastIndexOf("%") < 2) {
                pattern = pattern.substring(1, pattern.length);
                return DataUtil.startsWith(DataUtil.toLowerCase(input), DataUtil.toLowerCase(pattern));
            } else if (pattern.charAt(pattern.length - 1) === "%" && pattern.indexOf("%") > pattern.length - 3) {
                pattern = pattern.substring(0, pattern.length - 1);
                return DataUtil.endsWith(DataUtil.toLowerCase(input), DataUtil.toLowerCase(pattern));
            } else if (pattern.lastIndexOf("%") !== pattern.indexOf("%") && pattern.lastIndexOf("%") > pattern.indexOf("%") + 1) {
                pattern = pattern.substring(pattern.indexOf("%") + 1, pattern.lastIndexOf("%"));
                return input.indexOf(pattern) !== -1;
            } else return input.indexOf(pattern) !== -1;
        } else return false;
    };
    /**
     * To return the sorting function based on the string.
     *
     * @param  {string} order
     * @hidden
     */ DataUtil.fnSort = function(order) {
        order = order ? DataUtil.toLowerCase(order) : "ascending";
        if (order === "ascending") return this.fnAscending;
        return this.fnDescending;
    };
    /**
     * Comparer function which is used to sort the data in ascending order.
     *
     * @param  {string|number} x
     * @param  {string|number} y
     * @returns number
     */ DataUtil.fnAscending = function(x, y) {
        if ((0, $3EnZW.isNullOrUndefined)(x) && (0, $3EnZW.isNullOrUndefined)(y)) return -1;
        if (y === null || y === undefined) return -1;
        if (typeof x === "string") return x.localeCompare(y);
        if (x === null || x === undefined) return 1;
        return x - y;
    };
    /**
     * Comparer function which is used to sort the data in descending order.
     *
     * @param  {string|number} x
     * @param  {string|number} y
     * @returns number
     */ DataUtil.fnDescending = function(x, y) {
        if ((0, $3EnZW.isNullOrUndefined)(x) && (0, $3EnZW.isNullOrUndefined)(y)) return -1;
        if (y === null || y === undefined) return 1;
        if (typeof x === "string") return x.localeCompare(y) * -1;
        if (x === null || x === undefined) return -1;
        return y - x;
    };
    DataUtil.extractFields = function(obj, fields) {
        var newObj = {};
        for(var i = 0; i < fields.length; i++)newObj = this.setValue(fields[i], this.getObject(fields[i], obj), newObj);
        return newObj;
    };
    /**
     * Select objects by given fields from jsonArray.
     *
     * @param  {Object[]} jsonArray
     * @param  {string[]} fields
     */ DataUtil.select = function(jsonArray, fields) {
        var newData = [];
        for(var i = 0; i < jsonArray.length; i++)newData.push(this.extractFields(jsonArray[i], fields));
        return newData;
    };
    /**
     * Group the input data based on the field name.
     * It also performs aggregation of the grouped records based on the aggregates paramater.
     *
     * @param {Object[]} jsonArray
     * @param {string} field?
     * @param {Object[]} agg?
     * @param {number} level?
     * @param {Object[]} groupDs?
     * @param field
     * @param aggregates
     * @param level
     * @param groupDs
     * @param format
     * @param isLazyLoad
     */ DataUtil.group = function(jsonArray, field, aggregates, level, groupDs, format, isLazyLoad) {
        level = level || 1;
        var jsonData = jsonArray;
        var guid = "GroupGuid";
        if (jsonData.GroupGuid === $fc77c1cdc02c8be7$var$consts[guid]) {
            var _loop_1 = function(j) {
                if (!(0, $3EnZW.isNullOrUndefined)(groupDs)) {
                    var indx = -1;
                    var temp = groupDs.filter(function(e) {
                        return e.key === jsonData[j].key;
                    });
                    indx = groupDs.indexOf(temp[0]);
                    jsonData[j].items = this_1.group(jsonData[j].items, field, aggregates, jsonData.level + 1, groupDs[indx].items, format, isLazyLoad);
                    jsonData[j].count = groupDs[indx].count;
                } else {
                    jsonData[j].items = this_1.group(jsonData[j].items, field, aggregates, jsonData.level + 1, null, format, isLazyLoad);
                    jsonData[j].count = jsonData[j].items.length;
                }
            };
            var this_1 = this;
            for(var j = 0; j < jsonData.length; j++)_loop_1(j);
            jsonData.childLevels += 1;
            return jsonData;
        }
        var grouped = {};
        var groupedArray = [];
        groupedArray.GroupGuid = $fc77c1cdc02c8be7$var$consts[guid];
        groupedArray.level = level;
        groupedArray.childLevels = 0;
        groupedArray.records = jsonData;
        var _loop_2 = function(i) {
            var val = this_2.getVal(jsonData, i, field);
            if (!(0, $3EnZW.isNullOrUndefined)(format)) val = format(val, field);
            if (!grouped[val]) {
                grouped[val] = {
                    key: val,
                    count: 0,
                    items: [],
                    aggregates: {},
                    field: field
                };
                groupedArray.push(grouped[val]);
                if (!(0, $3EnZW.isNullOrUndefined)(groupDs)) {
                    var tempObj = groupDs.filter(function(e) {
                        return e.key === grouped[val].key;
                    });
                    grouped[val].count = tempObj[0].count;
                }
            }
            grouped[val].count = !(0, $3EnZW.isNullOrUndefined)(groupDs) ? grouped[val].count : grouped[val].count += 1;
            if (!isLazyLoad || isLazyLoad && aggregates.length) grouped[val].items.push(jsonData[i]);
        };
        var this_2 = this;
        for(var i = 0; i < jsonData.length; i++)_loop_2(i);
        if (aggregates && aggregates.length) {
            var _loop_3 = function(i) {
                var res = {};
                var fn = void 0;
                var aggs = aggregates;
                for(var j = 0; j < aggregates.length; j++){
                    fn = DataUtil.aggregates[aggregates[j].type];
                    if (!(0, $3EnZW.isNullOrUndefined)(groupDs)) {
                        var temp = groupDs.filter(function(e) {
                            return e.key === groupedArray[i].key;
                        });
                        if (fn) res[aggs[j].field + " - " + aggs[j].type] = fn(temp[0].items, aggs[j].field);
                    } else if (fn) res[aggs[j].field + " - " + aggs[j].type] = fn(groupedArray[i].items, aggs[j].field);
                }
                groupedArray[i].aggregates = res;
            };
            for(var i = 0; i < groupedArray.length; i++)_loop_3(i);
        }
        if (isLazyLoad && groupedArray.length && aggregates.length) for(var i = 0; i < groupedArray.length; i++)groupedArray[i].items = [];
        return jsonData.length && groupedArray || jsonData;
    };
    /**
     * It is used to categorize the multiple items based on a specific field in jsonArray.
     * The hierarchical queries are commonly required when you use foreign key binding.
     *
     * @param {string} fKey
     * @param {string} from
     * @param {Object[]} source
     * @param {Group} lookup?
     * @param {string} pKey?
     * @param lookup
     * @param pKey
     * @hidden
     */ DataUtil.buildHierarchy = function(fKey, from, source, lookup, pKey) {
        var i;
        var grp = {};
        var temp;
        if (lookup.result) lookup = lookup.result;
        if (lookup.GroupGuid) this.throwError("DataManager: Do not have support Grouping in hierarchy");
        for(i = 0; i < lookup.length; i++){
            var fKeyData = this.getObject(fKey, lookup[i]);
            temp = grp[fKeyData] || (grp[fKeyData] = []);
            temp.push(lookup[i]);
        }
        for(i = 0; i < source.length; i++){
            var fKeyData = this.getObject(pKey || fKey, source[i]);
            source[i][from] = grp[fKeyData];
        }
    };
    /**
     * The method used to get the field names which started with specified characters.
     *
     * @param {Object} obj
     * @param {string[]} fields?
     * @param {string} prefix?
     * @param fields
     * @param prefix
     * @hidden
     */ DataUtil.getFieldList = function(obj, fields, prefix) {
        if (prefix === undefined) prefix = "";
        if (fields === undefined || fields === null) return this.getFieldList(obj, [], prefix);
        var copyObj = obj;
        var keys = Object.keys(obj);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var prop = keys_1[_i];
            if (typeof copyObj[prop] === "object" && !(copyObj[prop] instanceof Array)) this.getFieldList(copyObj[prop], fields, prefix + prop + ".");
            else fields.push(prefix + prop);
        }
        return fields;
    };
    /**
     * Gets the value of the property in the given object.
     * The complex object can be accessed by providing the field names concatenated with dot(.).
     *
     * @param  {string} nameSpace - The name of the property to be accessed.
     * @param  {Object} from - Defines the source object.
     */ DataUtil.getObject = function(nameSpace, from) {
        if (!nameSpace) return from;
        if (!from) return undefined;
        if (nameSpace.indexOf(".") === -1) {
            var lowerCaseNameSpace = nameSpace.charAt(0).toLowerCase() + nameSpace.slice(1);
            var upperCaseNameSpace = nameSpace.charAt(0).toUpperCase() + nameSpace.slice(1);
            if (!(0, $3EnZW.isNullOrUndefined)(from[nameSpace])) return from[nameSpace];
            else {
                if (!(0, $3EnZW.isNullOrUndefined)(from[lowerCaseNameSpace])) return from[lowerCaseNameSpace];
                else if (!(0, $3EnZW.isNullOrUndefined)(from[upperCaseNameSpace])) return from[upperCaseNameSpace];
                else return null;
            }
        }
        var value = from;
        var splits = nameSpace.split(".");
        for(var i = 0; i < splits.length; i++){
            if (value == null) break;
            value = value[splits[i]];
            if (value === undefined) {
                var casing = splits[i].charAt(0).toUpperCase() + splits[i].slice(1);
                value = from[casing] || from[casing.charAt(0).toLowerCase() + casing.slice(1)] || null;
            }
            from = value;
        }
        return value;
    };
    /**
     * To set value for the nameSpace in desired object.
     *
     * @param {string} nameSpace - String value to the get the inner object.
     * @param {Object} value - Value that you need to set.
     * @param {Object} obj - Object to get the inner object value.
     * @return { [key: string]: Object; } | Object
     * @hidden
     */ DataUtil.setValue = function(nameSpace, value, obj) {
        var keys = nameSpace.toString().split(".");
        var start = obj || {};
        var fromObj = start;
        var i;
        var length = keys.length;
        var key;
        for(i = 0; i < length; i++){
            key = keys[i];
            if (i + 1 === length) fromObj[key] = value === undefined ? undefined : value;
            else if ((0, $3EnZW.isNullOrUndefined)(fromObj[key])) fromObj[key] = {};
            fromObj = fromObj[key];
        }
        return start;
    };
    /**
     * Sort the given data based on the field and comparer.
     *
     * @param  {Object[]} ds - Defines the input data.
     * @param  {string} field - Defines the field to be sorted.
     * @param  {Function} comparer - Defines the comparer function used to sort the records.
     */ DataUtil.sort = function(ds, field, comparer) {
        if (ds.length <= 1) return ds;
        var middle = parseInt((ds.length / 2).toString(), 10);
        var left = ds.slice(0, middle);
        var right = ds.slice(middle);
        left = this.sort(left, field, comparer);
        right = this.sort(right, field, comparer);
        return this.merge(left, right, field, comparer);
    };
    DataUtil.ignoreDiacritics = function(value) {
        if (typeof value !== "string") return value;
        var result = value.split("");
        var newValue = result.map(function(temp) {
            return temp in DataUtil.diacritics ? DataUtil.diacritics[temp] : temp;
        });
        return newValue.join("");
    };
    DataUtil.merge = function(left, right, fieldName, comparer) {
        var result = [];
        var current;
        while(left.length > 0 || right.length > 0){
            if (left.length > 0 && right.length > 0) {
                if (comparer) current = comparer(this.getVal(left, 0, fieldName), this.getVal(right, 0, fieldName), left[0], right[0]) <= 0 ? left : right;
                else current = left[0][fieldName] < left[0][fieldName] ? left : right;
            } else current = left.length > 0 ? left : right;
            result.push(current.shift());
        }
        return result;
    };
    DataUtil.getVal = function(array, index, field) {
        return field ? this.getObject(field, array[index]) : array[index];
    };
    DataUtil.toLowerCase = function(val) {
        return val ? typeof val === "string" ? val.toLowerCase() : val.toString() : val === 0 || val === false ? val.toString() : "";
    };
    /**
     * To perform the filter operation with specified adaptor and returns the result.
     *
     * @param {Object} adaptor
     * @param {string} fnName
     * @param {Object} param1?
     * @param {Object} param2?
     * @param param1
     * @param param2
     * @hidden
     */ DataUtil.callAdaptorFunction = function(adaptor, fnName, param1, param2) {
        if (fnName in adaptor) {
            var res = adaptor[fnName](param1, param2);
            if (!(0, $3EnZW.isNullOrUndefined)(res)) param1 = res;
        }
        return param1;
    };
    DataUtil.getAddParams = function(adp, dm, query) {
        var req = {};
        DataUtil.callAdaptorFunction(adp, "addParams", {
            dm: dm,
            query: query,
            params: query ? query.params : [],
            reqParams: req
        });
        return req;
    };
    /**
     * Checks wheather the given input is a plain object or not.
     *
     * @param  {Object|Object[]} obj
     */ DataUtil.isPlainObject = function(obj) {
        return !!obj && obj.constructor === Object;
    };
    /**
     * Returns true when the browser cross origin request.
     */ DataUtil.isCors = function() {
        var xhr = null;
        var request = "XMLHttpRequest";
        try {
            xhr = new window[request]();
        } catch (e) {
        // No exception handling
        }
        return !!xhr && "withCredentials" in xhr;
    };
    /**
     * Generate random GUID value which will be prefixed with the given value.
     *
     * @param  {string} prefix
     */ DataUtil.getGuid = function(prefix) {
        var hexs = "0123456789abcdef";
        var rand;
        return (prefix || "") + "00000000-0000-4000-0000-000000000000".replace(/0/g, function(val, i) {
            if ("crypto" in window && "getRandomValues" in crypto) {
                var arr = new Uint8Array(1);
                window.crypto.getRandomValues(arr);
                rand = arr[0] % 16 | 0;
            } else rand = Math.random() * 16 | 0;
            return hexs[i === 19 ? rand & 0x3 | 0x8 : rand];
        });
    };
    /**
     * Checks wheather the given value is null or not.
     *
     * @param  {string|Object} val
     * @returns boolean
     */ DataUtil.isNull = function(val) {
        return val === undefined || val === null;
    };
    /**
     * To get the required items from collection of objects.
     *
     * @param  {Object[]} array
     * @param  {string} field
     * @param  {Function} comparer
     * @returns Object
     * @hidden
     */ DataUtil.getItemFromComparer = function(array, field, comparer) {
        var keyVal;
        var current;
        var key;
        var i = 0;
        var castRequired = typeof DataUtil.getVal(array, 0, field) === "string";
        if (array.length) while((0, $3EnZW.isNullOrUndefined)(keyVal) && i < array.length){
            keyVal = DataUtil.getVal(array, i, field);
            key = array[i++];
        }
        for(; i < array.length; i++){
            current = DataUtil.getVal(array, i, field);
            if ((0, $3EnZW.isNullOrUndefined)(current)) continue;
            if (castRequired) {
                keyVal = +keyVal;
                current = +current;
            }
            if (comparer(keyVal, current) > 0) {
                keyVal = current;
                key = array[i];
            }
        }
        return key;
    };
    /**
     * To get distinct values of Array or Array of Objects.
     *
     * @param {Object[]} json
     * @param {string} field
     * @param fieldName
     * @param {boolean} requiresCompleteRecord
     * @returns Object[]
     * * distinct array of objects is return when requiresCompleteRecord set as true.
     * @hidden
     */ DataUtil.distinct = function(json, fieldName, requiresCompleteRecord) {
        requiresCompleteRecord = (0, $3EnZW.isNullOrUndefined)(requiresCompleteRecord) ? false : requiresCompleteRecord;
        var result = [];
        var val;
        var tmp = {};
        json.forEach(function(data, index) {
            val = typeof json[index] === "object" ? DataUtil.getVal(json, index, fieldName) : json[index];
            if (!(val in tmp)) {
                result.push(!requiresCompleteRecord ? val : json[index]);
                tmp[val] = 1;
            }
        });
        return result;
    };
    /**
     * Process the given records based on the datamanager string.
     *
     * @param {string} datamanager
     * @param dm
     * @param {Object[]} records
     */ DataUtil.processData = function(dm, records) {
        var query = this.prepareQuery(dm);
        var sampledata = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(records);
        if (dm.requiresCounts) query.requiresCount();
        /* eslint-disable @typescript-eslint/no-explicit-any */ // tslint:disable-next-line:no-any
        var result = sampledata.executeLocal(query);
        /* eslint-enable @typescript-eslint/no-explicit-any */ var returnValue = {
            result: dm.requiresCounts ? result.result : result,
            count: result.count,
            aggregates: JSON.stringify(result.aggregates)
        };
        return dm.requiresCounts ? returnValue : result;
    };
    DataUtil.prepareQuery = function(dm) {
        var _this = this;
        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (dm.select) query.select(dm.select);
        if (dm.where) {
            var where = DataUtil.parse.parseJson(dm.where);
            where.filter(function(pred) {
                if ((0, $3EnZW.isNullOrUndefined)(pred.condition)) query.where(pred.field, pred.operator, pred.value, pred.ignoreCase, pred.ignoreAccent);
                else {
                    var predicateList = [];
                    if (pred.field) predicateList.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(pred.field, pred.operator, pred.value, pred.ignoreCase, pred.ignoreAccent));
                    else predicateList = predicateList.concat(_this.getPredicate(pred.predicates));
                    if (pred.condition === "or") query.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicateList));
                    else if (pred.condition === "and") query.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).and(predicateList));
                }
            });
        }
        if (dm.search) {
            var search = DataUtil.parse.parseJson(dm.search);
            // tslint:disable-next-line:no-string-literal
            search.filter(function(e) {
                return query.search(e.key, e.fields, e["operator"], // tslint:disable-next-line:no-string-literal
                e["ignoreCase"], e["ignoreAccent"]);
            });
        }
        if (dm.aggregates) dm.aggregates.filter(function(e) {
            return query.aggregate(e.type, e.field);
        });
        if (dm.sorted) dm.sorted.filter(function(e) {
            return query.sortBy(e.name, e.direction);
        });
        if (dm.skip) query.skip(dm.skip);
        if (dm.take) query.take(dm.take);
        if (dm.group) dm.group.filter(function(grp) {
            return query.group(grp);
        });
        return query;
    };
    DataUtil.getPredicate = function(pred) {
        var mainPred = [];
        for(var i = 0; i < pred.length; i++){
            var e = pred[i];
            if (e.field) mainPred.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(e.field, e.operator, e.value, e.ignoreCase, e.ignoreAccent));
            else {
                var childPred = [];
                // tslint:disable-next-line:typedef
                var cpre = this.getPredicate(e.predicates);
                for(var _i = 0, _a = Object.keys(cpre); _i < _a.length; _i++){
                    var prop = _a[_i];
                    childPred.push(cpre[prop]);
                }
                mainPred.push(e.condition === "or" ? (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(childPred) : (0, $56262f229d1cff45$export$7ce636318c5a9f17).and(childPred));
            }
        }
        return mainPred;
    };
    /**
     * Specifies the value which will be used to adjust the date value to server timezone.
     *
     * @default null
     */ DataUtil.serverTimezoneOffset = null;
    /**
     * Species whether are not to be parsed with serverTimezoneOffset value.
     *
     * @hidden
     */ DataUtil.timeZoneHandling = true;
    /**
     * Throw error with the given string as message.
     *
     * @param {string} er
     * @param error
     */ DataUtil.throwError = function(error) {
        try {
            throw new Error(error);
        } catch (e) {
            // eslint-disable-next-line no-throw-literal
            throw e.message + "\n" + e.stack;
        }
    };
    DataUtil.aggregates = {
        /**
         * Calculate sum of the given field in the data.
         *
         * @param  {Object[]} ds
         * @param  {string} field
         */ sum: function(ds, field) {
            var result = 0;
            var val;
            var castRequired = typeof DataUtil.getVal(ds, 0, field) !== "number";
            for(var i = 0; i < ds.length; i++){
                val = DataUtil.getVal(ds, i, field);
                if (!isNaN(val) && val !== null) {
                    if (castRequired) val = +val;
                    result += val;
                }
            }
            return result;
        },
        /**
         * Calculate average value of the given field in the data.
         *
         * @param  {Object[]} ds
         * @param  {string} field
         */ average: function(ds, field) {
            return DataUtil.aggregates.sum(ds, field) / ds.length;
        },
        /**
         * Returns the min value of the data based on the field.
         *
         * @param  {Object[]} ds
         * @param  {string|Function} field
         */ min: function(ds, field) {
            var comparer;
            if (typeof field === "function") {
                comparer = field;
                field = null;
            }
            return DataUtil.getObject(field, DataUtil.getItemFromComparer(ds, field, comparer || DataUtil.fnAscending));
        },
        /**
         * Returns the max value of the data based on the field.
         *
         * @param  {Object[]} ds
         * @param  {string} field
         * @returns number
         */ max: function(ds, field) {
            var comparer;
            if (typeof field === "function") {
                comparer = field;
                field = null;
            }
            return DataUtil.getObject(field, DataUtil.getItemFromComparer(ds, field, comparer || DataUtil.fnDescending));
        },
        /**
         * Returns the total number of true value present in the data based on the given boolean field name.
         *
         * @param  {Object[]} ds
         * @param  {string} field
         */ truecount: function(ds, field) {
            return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(ds).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(field, "equal", true, true)).length;
        },
        /**
         * Returns the total number of false value present in the data based on the given boolean field name.
         *
         * @param  {Object[]} ds
         * @param  {string} field
         */ falsecount: function(ds, field) {
            return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(ds).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(field, "equal", false, true)).length;
        },
        /**
         * Returns the length of the given data.
         *
         * @param {Object[]} ds
         * @param {string} field?
         * @param field
         * @returns number
         */ count: function(ds, field) {
            return ds.length;
        }
    };
    /**
     * Specifies the Object with filter operators.
     */ DataUtil.operatorSymbols = {
        "<": "lessthan",
        ">": "greaterthan",
        "<=": "lessthanorequal",
        ">=": "greaterthanorequal",
        "==": "equal",
        "!=": "notequal",
        "*=": "contains",
        "$=": "endswith",
        "^=": "startswith"
    };
    /**
     * Specifies the Object with filter operators which will be used for OData filter query generation.
     * * It will be used for date/number type filter query.
     */ DataUtil.odBiOperator = {
        "<": " lt ",
        ">": " gt ",
        "<=": " le ",
        ">=": " ge ",
        "==": " eq ",
        "!=": " ne ",
        "lessthan": " lt ",
        "lessthanorequal": " le ",
        "greaterthan": " gt ",
        "greaterthanorequal": " ge ",
        "equal": " eq ",
        "notequal": " ne "
    };
    /**
     * Specifies the Object with filter operators which will be used for OData filter query generation.
     * It will be used for string type filter query.
     */ DataUtil.odUniOperator = {
        "$=": "endswith",
        "^=": "startswith",
        "*=": "substringof",
        "endswith": "endswith",
        "startswith": "startswith",
        "contains": "substringof",
        "doesnotendwith": "not endswith",
        "doesnotstartwith": "not startswith",
        "doesnotcontain": "not substringof",
        "wildcard": "wildcard",
        "like": "like"
    };
    /**
     * Specifies the Object with filter operators which will be used for ODataV4 filter query generation.
     * It will be used for string type filter query.
     */ DataUtil.odv4UniOperator = {
        "$=": "endswith",
        "^=": "startswith",
        "*=": "contains",
        "endswith": "endswith",
        "startswith": "startswith",
        "contains": "contains",
        "doesnotendwith": "not endswith",
        "doesnotstartwith": "not startswith",
        "doesnotcontain": "not contains",
        "wildcard": "wildcard",
        "like": "like"
    };
    DataUtil.diacritics = {
        "\u24B6": "A",
        "\uFF21": "A",
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\u1EA6": "A",
        "\u1EA4": "A",
        "\u1EAA": "A",
        "\u1EA8": "A",
        "\xc3": "A",
        "\u0100": "A",
        "\u0102": "A",
        "\u1EB0": "A",
        "\u1EAE": "A",
        "\u1EB4": "A",
        "\u1EB2": "A",
        "\u0226": "A",
        "\u01E0": "A",
        "\xc4": "A",
        "\u01DE": "A",
        "\u1EA2": "A",
        "\xc5": "A",
        "\u01FA": "A",
        "\u01CD": "A",
        "\u0200": "A",
        "\u0202": "A",
        "\u1EA0": "A",
        "\u1EAC": "A",
        "\u1EB6": "A",
        "\u1E00": "A",
        "\u0104": "A",
        "\u023A": "A",
        "\u2C6F": "A",
        "\uA732": "AA",
        "\xc6": "AE",
        "\u01FC": "AE",
        "\u01E2": "AE",
        "\uA734": "AO",
        "\uA736": "AU",
        "\uA738": "AV",
        "\uA73A": "AV",
        "\uA73C": "AY",
        "\u24B7": "B",
        "\uFF22": "B",
        "\u1E02": "B",
        "\u1E04": "B",
        "\u1E06": "B",
        "\u0243": "B",
        "\u0182": "B",
        "\u0181": "B",
        "\u24B8": "C",
        "\uFF23": "C",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\xc7": "C",
        "\u1E08": "C",
        "\u0187": "C",
        "\u023B": "C",
        "\uA73E": "C",
        "\u24B9": "D",
        "\uFF24": "D",
        "\u1E0A": "D",
        "\u010E": "D",
        "\u1E0C": "D",
        "\u1E10": "D",
        "\u1E12": "D",
        "\u1E0E": "D",
        "\u0110": "D",
        "\u018B": "D",
        "\u018A": "D",
        "\u0189": "D",
        "\uA779": "D",
        "\u01F1": "DZ",
        "\u01C4": "DZ",
        "\u01F2": "Dz",
        "\u01C5": "Dz",
        "\u24BA": "E",
        "\uFF25": "E",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\u1EC0": "E",
        "\u1EBE": "E",
        "\u1EC4": "E",
        "\u1EC2": "E",
        "\u1EBC": "E",
        "\u0112": "E",
        "\u1E14": "E",
        "\u1E16": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\xcb": "E",
        "\u1EBA": "E",
        "\u011A": "E",
        "\u0204": "E",
        "\u0206": "E",
        "\u1EB8": "E",
        "\u1EC6": "E",
        "\u0228": "E",
        "\u1E1C": "E",
        "\u0118": "E",
        "\u1E18": "E",
        "\u1E1A": "E",
        "\u0190": "E",
        "\u018E": "E",
        "\u24BB": "F",
        "\uFF26": "F",
        "\u1E1E": "F",
        "\u0191": "F",
        "\uA77B": "F",
        "\u24BC": "G",
        "\uFF27": "G",
        "\u01F4": "G",
        "\u011C": "G",
        "\u1E20": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u01E6": "G",
        "\u0122": "G",
        "\u01E4": "G",
        "\u0193": "G",
        "\uA7A0": "G",
        "\uA77D": "G",
        "\uA77E": "G",
        "\u24BD": "H",
        "\uFF28": "H",
        "\u0124": "H",
        "\u1E22": "H",
        "\u1E26": "H",
        "\u021E": "H",
        "\u1E24": "H",
        "\u1E28": "H",
        "\u1E2A": "H",
        "\u0126": "H",
        "\u2C67": "H",
        "\u2C75": "H",
        "\uA78D": "H",
        "\u24BE": "I",
        "\uFF29": "I",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u0130": "I",
        "\xcf": "I",
        "\u1E2E": "I",
        "\u1EC8": "I",
        "\u01CF": "I",
        "\u0208": "I",
        "\u020A": "I",
        "\u1ECA": "I",
        "\u012E": "I",
        "\u1E2C": "I",
        "\u0197": "I",
        "\u24BF": "J",
        "\uFF2A": "J",
        "\u0134": "J",
        "\u0248": "J",
        "\u24C0": "K",
        "\uFF2B": "K",
        "\u1E30": "K",
        "\u01E8": "K",
        "\u1E32": "K",
        "\u0136": "K",
        "\u1E34": "K",
        "\u0198": "K",
        "\u2C69": "K",
        "\uA740": "K",
        "\uA742": "K",
        "\uA744": "K",
        "\uA7A2": "K",
        "\u24C1": "L",
        "\uFF2C": "L",
        "\u013F": "L",
        "\u0139": "L",
        "\u013D": "L",
        "\u1E36": "L",
        "\u1E38": "L",
        "\u013B": "L",
        "\u1E3C": "L",
        "\u1E3A": "L",
        "\u0141": "L",
        "\u023D": "L",
        "\u2C62": "L",
        "\u2C60": "L",
        "\uA748": "L",
        "\uA746": "L",
        "\uA780": "L",
        "\u01C7": "LJ",
        "\u01C8": "Lj",
        "\u24C2": "M",
        "\uFF2D": "M",
        "\u1E3E": "M",
        "\u1E40": "M",
        "\u1E42": "M",
        "\u2C6E": "M",
        "\u019C": "M",
        "\u24C3": "N",
        "\uFF2E": "N",
        "\u01F8": "N",
        "\u0143": "N",
        "\xd1": "N",
        "\u1E44": "N",
        "\u0147": "N",
        "\u1E46": "N",
        "\u0145": "N",
        "\u1E4A": "N",
        "\u1E48": "N",
        "\u0220": "N",
        "\u019D": "N",
        "\uA790": "N",
        "\uA7A4": "N",
        "\u01CA": "NJ",
        "\u01CB": "Nj",
        "\u24C4": "O",
        "\uFF2F": "O",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\u1ED2": "O",
        "\u1ED0": "O",
        "\u1ED6": "O",
        "\u1ED4": "O",
        "\xd5": "O",
        "\u1E4C": "O",
        "\u022C": "O",
        "\u1E4E": "O",
        "\u014C": "O",
        "\u1E50": "O",
        "\u1E52": "O",
        "\u014E": "O",
        "\u022E": "O",
        "\u0230": "O",
        "\xd6": "O",
        "\u022A": "O",
        "\u1ECE": "O",
        "\u0150": "O",
        "\u01D1": "O",
        "\u020C": "O",
        "\u020E": "O",
        "\u01A0": "O",
        "\u1EDC": "O",
        "\u1EDA": "O",
        "\u1EE0": "O",
        "\u1EDE": "O",
        "\u1EE2": "O",
        "\u1ECC": "O",
        "\u1ED8": "O",
        "\u01EA": "O",
        "\u01EC": "O",
        "\xd8": "O",
        "\u01FE": "O",
        "\u0186": "O",
        "\u019F": "O",
        "\uA74A": "O",
        "\uA74C": "O",
        "\u01A2": "OI",
        "\uA74E": "OO",
        "\u0222": "OU",
        "\u24C5": "P",
        "\uFF30": "P",
        "\u1E54": "P",
        "\u1E56": "P",
        "\u01A4": "P",
        "\u2C63": "P",
        "\uA750": "P",
        "\uA752": "P",
        "\uA754": "P",
        "\u24C6": "Q",
        "\uFF31": "Q",
        "\uA756": "Q",
        "\uA758": "Q",
        "\u024A": "Q",
        "\u24C7": "R",
        "\uFF32": "R",
        "\u0154": "R",
        "\u1E58": "R",
        "\u0158": "R",
        "\u0210": "R",
        "\u0212": "R",
        "\u1E5A": "R",
        "\u1E5C": "R",
        "\u0156": "R",
        "\u1E5E": "R",
        "\u024C": "R",
        "\u2C64": "R",
        "\uA75A": "R",
        "\uA7A6": "R",
        "\uA782": "R",
        "\u24C8": "S",
        "\uFF33": "S",
        "\u1E9E": "S",
        "\u015A": "S",
        "\u1E64": "S",
        "\u015C": "S",
        "\u1E60": "S",
        "\u0160": "S",
        "\u1E66": "S",
        "\u1E62": "S",
        "\u1E68": "S",
        "\u0218": "S",
        "\u015E": "S",
        "\u2C7E": "S",
        "\uA7A8": "S",
        "\uA784": "S",
        "\u24C9": "T",
        "\uFF34": "T",
        "\u1E6A": "T",
        "\u0164": "T",
        "\u1E6C": "T",
        "\u021A": "T",
        "\u0162": "T",
        "\u1E70": "T",
        "\u1E6E": "T",
        "\u0166": "T",
        "\u01AC": "T",
        "\u01AE": "T",
        "\u023E": "T",
        "\uA786": "T",
        "\uA728": "TZ",
        "\u24CA": "U",
        "\uFF35": "U",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\u0168": "U",
        "\u1E78": "U",
        "\u016A": "U",
        "\u1E7A": "U",
        "\u016C": "U",
        "\xdc": "U",
        "\u01DB": "U",
        "\u01D7": "U",
        "\u01D5": "U",
        "\u01D9": "U",
        "\u1EE6": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u01D3": "U",
        "\u0214": "U",
        "\u0216": "U",
        "\u01AF": "U",
        "\u1EEA": "U",
        "\u1EE8": "U",
        "\u1EEE": "U",
        "\u1EEC": "U",
        "\u1EF0": "U",
        "\u1EE4": "U",
        "\u1E72": "U",
        "\u0172": "U",
        "\u1E76": "U",
        "\u1E74": "U",
        "\u0244": "U",
        "\u24CB": "V",
        "\uFF36": "V",
        "\u1E7C": "V",
        "\u1E7E": "V",
        "\u01B2": "V",
        "\uA75E": "V",
        "\u0245": "V",
        "\uA760": "VY",
        "\u24CC": "W",
        "\uFF37": "W",
        "\u1E80": "W",
        "\u1E82": "W",
        "\u0174": "W",
        "\u1E86": "W",
        "\u1E84": "W",
        "\u1E88": "W",
        "\u2C72": "W",
        "\u24CD": "X",
        "\uFF38": "X",
        "\u1E8A": "X",
        "\u1E8C": "X",
        "\u24CE": "Y",
        "\uFF39": "Y",
        "\u1EF2": "Y",
        "\xdd": "Y",
        "\u0176": "Y",
        "\u1EF8": "Y",
        "\u0232": "Y",
        "\u1E8E": "Y",
        "\u0178": "Y",
        "\u1EF6": "Y",
        "\u1EF4": "Y",
        "\u01B3": "Y",
        "\u024E": "Y",
        "\u1EFE": "Y",
        "\u24CF": "Z",
        "\uFF3A": "Z",
        "\u0179": "Z",
        "\u1E90": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u1E92": "Z",
        "\u1E94": "Z",
        "\u01B5": "Z",
        "\u0224": "Z",
        "\u2C7F": "Z",
        "\u2C6B": "Z",
        "\uA762": "Z",
        "\u24D0": "a",
        "\uFF41": "a",
        "\u1E9A": "a",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\u1EA7": "a",
        "\u1EA5": "a",
        "\u1EAB": "a",
        "\u1EA9": "a",
        "\xe3": "a",
        "\u0101": "a",
        "\u0103": "a",
        "\u1EB1": "a",
        "\u1EAF": "a",
        "\u1EB5": "a",
        "\u1EB3": "a",
        "\u0227": "a",
        "\u01E1": "a",
        "\xe4": "a",
        "\u01DF": "a",
        "\u1EA3": "a",
        "\xe5": "a",
        "\u01FB": "a",
        "\u01CE": "a",
        "\u0201": "a",
        "\u0203": "a",
        "\u1EA1": "a",
        "\u1EAD": "a",
        "\u1EB7": "a",
        "\u1E01": "a",
        "\u0105": "a",
        "\u2C65": "a",
        "\u0250": "a",
        "\uA733": "aa",
        "\xe6": "ae",
        "\u01FD": "ae",
        "\u01E3": "ae",
        "\uA735": "ao",
        "\uA737": "au",
        "\uA739": "av",
        "\uA73B": "av",
        "\uA73D": "ay",
        "\u24D1": "b",
        "\uFF42": "b",
        "\u1E03": "b",
        "\u1E05": "b",
        "\u1E07": "b",
        "\u0180": "b",
        "\u0183": "b",
        "\u0253": "b",
        "\u24D2": "c",
        "\uFF43": "c",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\xe7": "c",
        "\u1E09": "c",
        "\u0188": "c",
        "\u023C": "c",
        "\uA73F": "c",
        "\u2184": "c",
        "\u24D3": "d",
        "\uFF44": "d",
        "\u1E0B": "d",
        "\u010F": "d",
        "\u1E0D": "d",
        "\u1E11": "d",
        "\u1E13": "d",
        "\u1E0F": "d",
        "\u0111": "d",
        "\u018C": "d",
        "\u0256": "d",
        "\u0257": "d",
        "\uA77A": "d",
        "\u01F3": "dz",
        "\u01C6": "dz",
        "\u24D4": "e",
        "\uFF45": "e",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\u1EC1": "e",
        "\u1EBF": "e",
        "\u1EC5": "e",
        "\u1EC3": "e",
        "\u1EBD": "e",
        "\u0113": "e",
        "\u1E15": "e",
        "\u1E17": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\xeb": "e",
        "\u1EBB": "e",
        "\u011B": "e",
        "\u0205": "e",
        "\u0207": "e",
        "\u1EB9": "e",
        "\u1EC7": "e",
        "\u0229": "e",
        "\u1E1D": "e",
        "\u0119": "e",
        "\u1E19": "e",
        "\u1E1B": "e",
        "\u0247": "e",
        "\u025B": "e",
        "\u01DD": "e",
        "\u24D5": "f",
        "\uFF46": "f",
        "\u1E1F": "f",
        "\u0192": "f",
        "\uA77C": "f",
        "\u24D6": "g",
        "\uFF47": "g",
        "\u01F5": "g",
        "\u011D": "g",
        "\u1E21": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u01E7": "g",
        "\u0123": "g",
        "\u01E5": "g",
        "\u0260": "g",
        "\uA7A1": "g",
        "\u1D79": "g",
        "\uA77F": "g",
        "\u24D7": "h",
        "\uFF48": "h",
        "\u0125": "h",
        "\u1E23": "h",
        "\u1E27": "h",
        "\u021F": "h",
        "\u1E25": "h",
        "\u1E29": "h",
        "\u1E2B": "h",
        "\u1E96": "h",
        "\u0127": "h",
        "\u2C68": "h",
        "\u2C76": "h",
        "\u0265": "h",
        "\u0195": "hv",
        "\u24D8": "i",
        "\uFF49": "i",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\xef": "i",
        "\u1E2F": "i",
        "\u1EC9": "i",
        "\u01D0": "i",
        "\u0209": "i",
        "\u020B": "i",
        "\u1ECB": "i",
        "\u012F": "i",
        "\u1E2D": "i",
        "\u0268": "i",
        "\u0131": "i",
        "\u24D9": "j",
        "\uFF4A": "j",
        "\u0135": "j",
        "\u01F0": "j",
        "\u0249": "j",
        "\u24DA": "k",
        "\uFF4B": "k",
        "\u1E31": "k",
        "\u01E9": "k",
        "\u1E33": "k",
        "\u0137": "k",
        "\u1E35": "k",
        "\u0199": "k",
        "\u2C6A": "k",
        "\uA741": "k",
        "\uA743": "k",
        "\uA745": "k",
        "\uA7A3": "k",
        "\u24DB": "l",
        "\uFF4C": "l",
        "\u0140": "l",
        "\u013A": "l",
        "\u013E": "l",
        "\u1E37": "l",
        "\u1E39": "l",
        "\u013C": "l",
        "\u1E3D": "l",
        "\u1E3B": "l",
        "\u017F": "l",
        "\u0142": "l",
        "\u019A": "l",
        "\u026B": "l",
        "\u2C61": "l",
        "\uA749": "l",
        "\uA781": "l",
        "\uA747": "l",
        "\u01C9": "lj",
        "\u24DC": "m",
        "\uFF4D": "m",
        "\u1E3F": "m",
        "\u1E41": "m",
        "\u1E43": "m",
        "\u0271": "m",
        "\u026F": "m",
        "\u24DD": "n",
        "\uFF4E": "n",
        "\u01F9": "n",
        "\u0144": "n",
        "\xf1": "n",
        "\u1E45": "n",
        "\u0148": "n",
        "\u1E47": "n",
        "\u0146": "n",
        "\u1E4B": "n",
        "\u1E49": "n",
        "\u019E": "n",
        "\u0272": "n",
        "\u0149": "n",
        "\uA791": "n",
        "\uA7A5": "n",
        "\u01CC": "nj",
        "\u24DE": "o",
        "\uFF4F": "o",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\u1ED3": "o",
        "\u1ED1": "o",
        "\u1ED7": "o",
        "\u1ED5": "o",
        "\xf5": "o",
        "\u1E4D": "o",
        "\u022D": "o",
        "\u1E4F": "o",
        "\u014D": "o",
        "\u1E51": "o",
        "\u1E53": "o",
        "\u014F": "o",
        "\u022F": "o",
        "\u0231": "o",
        "\xf6": "o",
        "\u022B": "o",
        "\u1ECF": "o",
        "\u0151": "o",
        "\u01D2": "o",
        "\u020D": "o",
        "\u020F": "o",
        "\u01A1": "o",
        "\u1EDD": "o",
        "\u1EDB": "o",
        "\u1EE1": "o",
        "\u1EDF": "o",
        "\u1EE3": "o",
        "\u1ECD": "o",
        "\u1ED9": "o",
        "\u01EB": "o",
        "\u01ED": "o",
        "\xf8": "o",
        "\u01FF": "o",
        "\u0254": "o",
        "\uA74B": "o",
        "\uA74D": "o",
        "\u0275": "o",
        "\u01A3": "oi",
        "\u0223": "ou",
        "\uA74F": "oo",
        "\u24DF": "p",
        "\uFF50": "p",
        "\u1E55": "p",
        "\u1E57": "p",
        "\u01A5": "p",
        "\u1D7D": "p",
        "\uA751": "p",
        "\uA753": "p",
        "\uA755": "p",
        "\u24E0": "q",
        "\uFF51": "q",
        "\u024B": "q",
        "\uA757": "q",
        "\uA759": "q",
        "\u24E1": "r",
        "\uFF52": "r",
        "\u0155": "r",
        "\u1E59": "r",
        "\u0159": "r",
        "\u0211": "r",
        "\u0213": "r",
        "\u1E5B": "r",
        "\u1E5D": "r",
        "\u0157": "r",
        "\u1E5F": "r",
        "\u024D": "r",
        "\u027D": "r",
        "\uA75B": "r",
        "\uA7A7": "r",
        "\uA783": "r",
        "\u24E2": "s",
        "\uFF53": "s",
        "\xdf": "s",
        "\u015B": "s",
        "\u1E65": "s",
        "\u015D": "s",
        "\u1E61": "s",
        "\u0161": "s",
        "\u1E67": "s",
        "\u1E63": "s",
        "\u1E69": "s",
        "\u0219": "s",
        "\u015F": "s",
        "\u023F": "s",
        "\uA7A9": "s",
        "\uA785": "s",
        "\u1E9B": "s",
        "\u24E3": "t",
        "\uFF54": "t",
        "\u1E6B": "t",
        "\u1E97": "t",
        "\u0165": "t",
        "\u1E6D": "t",
        "\u021B": "t",
        "\u0163": "t",
        "\u1E71": "t",
        "\u1E6F": "t",
        "\u0167": "t",
        "\u01AD": "t",
        "\u0288": "t",
        "\u2C66": "t",
        "\uA787": "t",
        "\uA729": "tz",
        "\u24E4": "u",
        "\uFF55": "u",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\u0169": "u",
        "\u1E79": "u",
        "\u016B": "u",
        "\u1E7B": "u",
        "\u016D": "u",
        "\xfc": "u",
        "\u01DC": "u",
        "\u01D8": "u",
        "\u01D6": "u",
        "\u01DA": "u",
        "\u1EE7": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u01D4": "u",
        "\u0215": "u",
        "\u0217": "u",
        "\u01B0": "u",
        "\u1EEB": "u",
        "\u1EE9": "u",
        "\u1EEF": "u",
        "\u1EED": "u",
        "\u1EF1": "u",
        "\u1EE5": "u",
        "\u1E73": "u",
        "\u0173": "u",
        "\u1E77": "u",
        "\u1E75": "u",
        "\u0289": "u",
        "\u24E5": "v",
        "\uFF56": "v",
        "\u1E7D": "v",
        "\u1E7F": "v",
        "\u028B": "v",
        "\uA75F": "v",
        "\u028C": "v",
        "\uA761": "vy",
        "\u24E6": "w",
        "\uFF57": "w",
        "\u1E81": "w",
        "\u1E83": "w",
        "\u0175": "w",
        "\u1E87": "w",
        "\u1E85": "w",
        "\u1E98": "w",
        "\u1E89": "w",
        "\u2C73": "w",
        "\u24E7": "x",
        "\uFF58": "x",
        "\u1E8B": "x",
        "\u1E8D": "x",
        "\u24E8": "y",
        "\uFF59": "y",
        "\u1EF3": "y",
        "\xfd": "y",
        "\u0177": "y",
        "\u1EF9": "y",
        "\u0233": "y",
        "\u1E8F": "y",
        "\xff": "y",
        "\u1EF7": "y",
        "\u1E99": "y",
        "\u1EF5": "y",
        "\u01B4": "y",
        "\u024F": "y",
        "\u1EFF": "y",
        "\u24E9": "z",
        "\uFF5A": "z",
        "\u017A": "z",
        "\u1E91": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u1E93": "z",
        "\u1E95": "z",
        "\u01B6": "z",
        "\u0225": "z",
        "\u0240": "z",
        "\u2C6C": "z",
        "\uA763": "z",
        "\u0386": "\u0391",
        "\u0388": "\u0395",
        "\u0389": "\u0397",
        "\u038A": "\u0399",
        "\u03AA": "\u0399",
        "\u038C": "\u039F",
        "\u038E": "\u03A5",
        "\u03AB": "\u03A5",
        "\u038F": "\u03A9",
        "\u03AC": "\u03B1",
        "\u03AD": "\u03B5",
        "\u03AE": "\u03B7",
        "\u03AF": "\u03B9",
        "\u03CA": "\u03B9",
        "\u0390": "\u03B9",
        "\u03CC": "\u03BF",
        "\u03CD": "\u03C5",
        "\u03CB": "\u03C5",
        "\u03B0": "\u03C5",
        "\u03C9": "\u03C9",
        "\u03C2": "\u03C3"
    };
    DataUtil.fnOperators = {
        /**
         * Returns true when the actual input is equal to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param {boolean} ignoreAccent?
         * @param ignoreCase
         * @param ignoreAccent
         */ equal: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return DataUtil.toLowerCase(actual) === DataUtil.toLowerCase(expected);
            return actual === expected;
        },
        /**
         * Returns true when the actual input is not equal to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         * @param ignoreAccent
         */ notequal: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            return !DataUtil.fnOperators.equal(actual, expected, ignoreCase);
        },
        /**
         * Returns true when the actual input is less than to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         */ lessthan: function(actual, expected, ignoreCase) {
            if (ignoreCase) return DataUtil.toLowerCase(actual) < DataUtil.toLowerCase(expected);
            if ((0, $3EnZW.isNullOrUndefined)(actual)) actual = undefined;
            return actual < expected;
        },
        /**
         * Returns true when the actual input is greater than to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         */ greaterthan: function(actual, expected, ignoreCase) {
            if (ignoreCase) return DataUtil.toLowerCase(actual) > DataUtil.toLowerCase(expected);
            return actual > expected;
        },
        /**
         * Returns true when the actual input is less than or equal to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         */ lessthanorequal: function(actual, expected, ignoreCase) {
            if (ignoreCase) return DataUtil.toLowerCase(actual) <= DataUtil.toLowerCase(expected);
            if ((0, $3EnZW.isNullOrUndefined)(actual)) actual = undefined;
            return actual <= expected;
        },
        /**
         * Returns true when the actual input is greater than or equal to the given input.
         *
         * @param {string|number|boolean} actual
         * @param {string|number|boolean} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         */ greaterthanorequal: function(actual, expected, ignoreCase) {
            if (ignoreCase) return DataUtil.toLowerCase(actual) >= DataUtil.toLowerCase(expected);
            return actual >= expected;
        },
        /**
         * Returns true when the actual input contains the given string.
         *
         * @param {string|number} actual
         * @param {string|number} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         * @param ignoreAccent
         */ contains: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return !(0, $3EnZW.isNullOrUndefined)(actual) && !(0, $3EnZW.isNullOrUndefined)(expected) && DataUtil.toLowerCase(actual).indexOf(DataUtil.toLowerCase(expected)) !== -1;
            return !(0, $3EnZW.isNullOrUndefined)(actual) && !(0, $3EnZW.isNullOrUndefined)(expected) && actual.toString().indexOf(expected) !== -1;
        },
        /**
         * Returns true when the actual input not contains the given string.
         *
         * @param  {string|number} actual
         * @param  {string|number} expected
         * @param  {boolean} ignoreCase?
         */ doesnotcontain: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return !(0, $3EnZW.isNullOrUndefined)(actual) && !(0, $3EnZW.isNullOrUndefined)(expected) && DataUtil.toLowerCase(actual).indexOf(DataUtil.toLowerCase(expected)) === -1;
            return !(0, $3EnZW.isNullOrUndefined)(actual) && !(0, $3EnZW.isNullOrUndefined)(expected) && actual.toString().indexOf(expected) === -1;
        },
        /**
         * Returns true when the given input value is not null.
         *
         * @param  {string|number} actual
         * @returns boolean
         */ isnotnull: function(actual) {
            return actual !== null && actual !== undefined;
        },
        /**
         * Returns true when the given input value is null.
         *
         * @param  {string|number} actual
         * @returns boolean
         */ isnull: function(actual) {
            return actual === null || actual === undefined;
        },
        /**
         * Returns true when the actual input starts with the given string
         *
         * @param {string} actual
         * @param {string} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         * @param ignoreAccent
         */ startswith: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return actual && expected && DataUtil.startsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return actual && expected && DataUtil.startsWith(actual, expected);
        },
        /**
         * Returns true when the actual input not starts with the given string
         *
         * @param  {string} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */ doesnotstartwith: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return actual && expected && DataUtil.notStartsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return actual && expected && DataUtil.notStartsWith(actual, expected);
        },
        /**
         * Returns true when the actual input like with the given string.
         *
         * @param  {string} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */ like: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return actual && expected && DataUtil.like(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return actual && expected && DataUtil.like(actual, expected);
        },
        /**
         * Returns true when the given input value is empty.
         *
         * @param  {string|number} actual
         * @returns boolean
         */ isempty: function(actual) {
            return actual === undefined || actual === "";
        },
        /**
         * Returns true when the given input value is not empty.
         *
         * @param  {string|number} actual
         * @returns boolean
         */ isnotempty: function(actual) {
            return actual !== undefined && actual !== "";
        },
        /**
         * Returns true when the actual input pattern(wildcard) matches with the given string.
         *
         * @param  {string|Date} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */ wildcard: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return (actual || typeof actual === "boolean") && expected && typeof actual !== "object" && DataUtil.wildCard(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return (actual || typeof actual === "boolean") && expected && DataUtil.wildCard(actual, expected);
        },
        /**
         * Returns true when the actual input ends with the given string.
         *
         * @param {string} actual
         * @param {string} expected
         * @param {boolean} ignoreCase?
         * @param ignoreCase
         * @param ignoreAccent
         */ endswith: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return actual && expected && DataUtil.endsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return actual && expected && DataUtil.endsWith(actual, expected);
        },
        /**
         * Returns true when the actual input not ends with the given string.
         *
         * @param  {string} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */ doesnotendwith: function(actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) return actual && expected && DataUtil.notEndsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            return actual && expected && DataUtil.notEndsWith(actual, expected);
        },
        /**
         * It will return the filter operator based on the filter symbol.
         *
         * @param  {string} operator
         * @hidden
         */ processSymbols: function(operator) {
            var fnName = DataUtil.operatorSymbols[operator];
            if (fnName) {
                var fn = DataUtil.fnOperators[fnName];
                return fn;
            }
            return DataUtil.throwError("Query - Process Operator : Invalid operator");
        },
        /**
         * It will return the valid filter operator based on the specified operators.
         *
         * @param  {string} operator
         * @hidden
         */ processOperator: function(operator) {
            var fn = DataUtil.fnOperators[operator];
            if (fn) return fn;
            return DataUtil.fnOperators.processSymbols(operator);
        }
    };
    /**
     * To perform the parse operation on JSON data, like convert to string from JSON or convert to JSON from string.
     */ DataUtil.parse = {
        /**
         * Parse the given string to the plain JavaScript object.
         *
         * @param  {string|Object|Object[]} jsonText
         */ parseJson: function(jsonText) {
            if (typeof jsonText === "string" && (/^[\s]*\[|^[\s]*\{(.)+:/g.test(jsonText) || jsonText.indexOf('"') === -1)) jsonText = JSON.parse(jsonText, DataUtil.parse.jsonReviver);
            else if (jsonText instanceof Array) DataUtil.parse.iterateAndReviveArray(jsonText);
            else if (typeof jsonText === "object" && jsonText !== null) DataUtil.parse.iterateAndReviveJson(jsonText);
            return jsonText;
        },
        /**
         * It will perform on array of values.
         *
         * @param  {string[]|Object[]} array
         * @hidden
         */ iterateAndReviveArray: function(array) {
            for(var i = 0; i < array.length; i++){
                if (typeof array[i] === "object" && array[i] !== null) DataUtil.parse.iterateAndReviveJson(array[i]);
                else if (typeof array[i] === "string" && (!/^[\s]*\[|^[\s]*\{(.)+:|\"/g.test(array[i]) || array[i].toString().indexOf('"') === -1)) array[i] = DataUtil.parse.jsonReviver("", array[i]);
                else array[i] = DataUtil.parse.parseJson(array[i]);
            }
        },
        /**
         * It will perform on JSON values
         *
         * @param  {JSON} json
         * @hidden
         */ iterateAndReviveJson: function(json) {
            var value;
            var keys = Object.keys(json);
            for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
                var prop = keys_2[_i];
                if (DataUtil.startsWith(prop, "__")) continue;
                value = json[prop];
                if (typeof value === "object") {
                    if (value instanceof Array) DataUtil.parse.iterateAndReviveArray(value);
                    else if (value) DataUtil.parse.iterateAndReviveJson(value);
                } else json[prop] = DataUtil.parse.jsonReviver(json[prop], value);
            }
        },
        /**
         * It will perform on JSON values
         *
         * @param  {string} field
         * @param  {string|Date} value
         * @hidden
         */ jsonReviver: function(field, value) {
            if (typeof value === "string") {
                // eslint-disable-next-line security/detect-unsafe-regex
                var ms = /^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(value);
                var offSet = DataUtil.timeZoneHandling ? DataUtil.serverTimezoneOffset : null;
                if (ms) return DataUtil.dateParse.toTimeZone(new Date(parseInt(ms[1], 10)), offSet, true);
                else if (/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(value)) {
                    var isUTC = value.indexOf("Z") > -1 || value.indexOf("z") > -1;
                    var arr = value.split(/[^0-9.]/);
                    if (isUTC) {
                        if (arr[5].indexOf(".") > -1) {
                            var secondsMs = arr[5].split(".");
                            arr[5] = secondsMs[0];
                            arr[6] = new Date(value).getUTCMilliseconds().toString();
                        } else arr[6] = "00";
                        value = DataUtil.dateParse.toTimeZone(new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5] ? arr[5] : "00", 10), parseInt(arr[6], 10)), DataUtil.serverTimezoneOffset, false);
                    } else {
                        var utcFormat = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5] ? arr[5] : "00", 10));
                        var hrs = parseInt(arr[6], 10);
                        var mins = parseInt(arr[7], 10);
                        if (isNaN(hrs) && isNaN(mins)) return utcFormat;
                        if (value.indexOf("+") > -1) utcFormat.setHours(utcFormat.getHours() - hrs, utcFormat.getMinutes() - mins);
                        else utcFormat.setHours(utcFormat.getHours() + hrs, utcFormat.getMinutes() + mins);
                        value = DataUtil.dateParse.toTimeZone(utcFormat, DataUtil.serverTimezoneOffset, false);
                    }
                    if (DataUtil.serverTimezoneOffset == null) value = DataUtil.dateParse.addSelfOffset(value);
                }
            }
            return value;
        },
        /**
         * Check wheather the given value is JSON or not.
         *
         * @param  {Object[]} jsonData
         */ isJson: function(jsonData) {
            if (typeof jsonData[0] === "string") return jsonData;
            return DataUtil.parse.parseJson(jsonData);
        },
        /**
         * Checks wheather the given value is GUID or not.
         *
         * @param  {string} value
         */ isGuid: function(value) {
            // eslint-disable-next-line security/detect-unsafe-regex
            var regex = /[A-Fa-f0-9]{8}(?:-[A-Fa-f0-9]{4}){3}-[A-Fa-f0-9]{12}/i;
            var match = regex.exec(value);
            return match != null;
        },
        /**
         * The method used to replace the value based on the type.
         *
         * @param  {Object} value
         * @param  {boolean} stringify
         * @hidden
         */ replacer: function(value, stringify) {
            if (DataUtil.isPlainObject(value)) return DataUtil.parse.jsonReplacer(value, stringify);
            if (value instanceof Array) return DataUtil.parse.arrayReplacer(value);
            if (value instanceof Date) return DataUtil.parse.jsonReplacer({
                val: value
            }, stringify).val;
            return value;
        },
        /**
         * It will replace the JSON value.
         *
         * @param {string} key
         * @param {Object} val
         * @param stringify
         * @hidden
         */ jsonReplacer: function(val, stringify) {
            var value;
            var keys = Object.keys(val);
            for(var _i = 0, keys_3 = keys; _i < keys_3.length; _i++){
                var prop = keys_3[_i];
                value = val[prop];
                if (!(value instanceof Date)) continue;
                var d = value;
                if (DataUtil.serverTimezoneOffset == null) val[prop] = DataUtil.dateParse.toTimeZone(d, null).toJSON();
                else {
                    d = new Date(+d + DataUtil.serverTimezoneOffset * 3600000);
                    val[prop] = DataUtil.dateParse.toTimeZone(DataUtil.dateParse.addSelfOffset(d), null).toJSON();
                }
            }
            return val;
        },
        /**
         * It will replace the Array of value.
         *
         * @param  {string} key
         * @param  {Object[]} val
         * @hidden
         */ arrayReplacer: function(val) {
            for(var i = 0; i < val.length; i++){
                if (DataUtil.isPlainObject(val[i])) val[i] = DataUtil.parse.jsonReplacer(val[i]);
                else if (val[i] instanceof Date) val[i] = DataUtil.parse.jsonReplacer({
                    date: val[i]
                }).date;
            }
            return val;
        },
        /**
         * It will replace the Date object with respective to UTC format value.
         *
         * @param  {string} key
         * @param  {any} value
         * @hidden
         */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* tslint:disable-next-line:no-any */ jsonDateReplacer: function(key, value) {
            /* eslint-enable @typescript-eslint/no-explicit-any */ if (key === "value" && value) {
                if (typeof value === "string") {
                    // eslint-disable-next-line security/detect-unsafe-regex
                    var ms = /^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(value);
                    if (ms) value = DataUtil.dateParse.toTimeZone(new Date(parseInt(ms[1], 10)), null, true);
                    else if (/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(value)) {
                        var arr = value.split(/[^0-9]/);
                        value = DataUtil.dateParse.toTimeZone(new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5], 10)), null, true);
                    }
                }
                if (value instanceof Date) {
                    value = DataUtil.dateParse.addSelfOffset(value);
                    if (DataUtil.serverTimezoneOffset === null) return DataUtil.dateParse.toTimeZone(DataUtil.dateParse.addSelfOffset(value), null).toJSON();
                    else {
                        value = DataUtil.dateParse.toTimeZone(value, value.getTimezoneOffset() / 60 - DataUtil.serverTimezoneOffset, false);
                        return value.toJSON();
                    }
                }
            }
            return value;
        }
    };
    /**
     * @hidden
     */ DataUtil.dateParse = {
        addSelfOffset: function(input) {
            return new Date(+input - input.getTimezoneOffset() * 60000);
        },
        toUTC: function(input) {
            return new Date(+input + input.getTimezoneOffset() * 60000);
        },
        toTimeZone: function(input, offset, utc) {
            if (offset === null) return input;
            var unix = utc ? DataUtil.dateParse.toUTC(input) : input;
            return new Date(+unix - offset * 3600000);
        },
        toLocalTime: function(input) {
            var datefn = input;
            var timeZone = -datefn.getTimezoneOffset();
            var differenceString = timeZone >= 0 ? "+" : "-";
            var localtimefn = function(num) {
                var norm = Math.floor(Math.abs(num));
                return (norm < 10 ? "0" : "") + norm;
            };
            var val = datefn.getFullYear() + "-" + localtimefn(datefn.getMonth() + 1) + "-" + localtimefn(datefn.getDate()) + "T" + localtimefn(datefn.getHours()) + ":" + localtimefn(datefn.getMinutes()) + ":" + localtimefn(datefn.getSeconds()) + differenceString + localtimefn(timeZone / 60) + ":" + localtimefn(timeZone % 60);
            return val;
        }
    };
    return DataUtil;
}();



var $e1170102ff02b3b7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e1170102ff02b3b7$var$consts = {
    GroupGuid: "{271bbba0-1ee7}"
};
/**
 * Adaptors are specific data source type aware interfaces that are used by DataManager to communicate with DataSource.
 * This is the base adaptor class that other adaptors can extend.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$4457cd68038afa91 = /** @class */ function() {
    /**
     * Constructor for Adaptor class
     *
     * @param {DataOptions} ds?
     * @param ds
     * @hidden
     * @returns aggregates
     */ function Adaptor(ds) {
        // common options for all the adaptors
        this.options = {
            from: "table",
            requestType: "json",
            sortBy: "sorted",
            select: "select",
            skip: "skip",
            group: "group",
            take: "take",
            search: "search",
            count: "requiresCounts",
            where: "where",
            aggregates: "aggregates",
            expand: "expand"
        };
        /**
         * Specifies the type of adaptor.
         *
         * @default Adaptor
         */ this.type = Adaptor;
        this.dataSource = ds;
        this.pvt = {};
    }
    /**
     * Returns the data from the query processing.
     *
     * @param {Object} data
     * @param {DataOptions} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param ds
     * @param query
     * @param xhr
     * @returns Object
     */ Adaptor.prototype.processResponse = function(data, ds, query, xhr) {
        return data;
    };
    return Adaptor;
}();
/**
 * JsonAdaptor is used to process JSON data. It contains methods to process the given JSON data based on the queries.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$650eb66a1d9d6599 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(JsonAdaptor, _super);
    function JsonAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Process the JSON data based on the provided queries.
     *
     * @param  {DataManager} dataManager
     * @param  {Query} query
     * @returns Object
     */ JsonAdaptor.prototype.processQuery = function(dataManager, query) {
        var result = dataManager.dataSource.json.slice(0);
        var count = result.length;
        var countFlg = true;
        var ret;
        var key;
        var lazyLoad = {};
        var keyCount = 0;
        var group = [];
        var sort = [];
        var page;
        for(var i = 0; i < query.lazyLoad.length; i++){
            keyCount++;
            lazyLoad[query.lazyLoad[i].key] = query.lazyLoad[i].value;
        }
        var agg = {};
        var isGroupByFormat = false;
        if (query.lazyLoad.length) for(var i = 0; i < query.queries.length; i++){
            key = query.queries[i];
            if (key.fn === "onGroup" && !(0, $3EnZW.isNullOrUndefined)(key.e.format)) {
                isGroupByFormat = true;
                break;
            }
        }
        for(var i = 0; i < query.queries.length; i++){
            key = query.queries[i];
            if ((key.fn === "onPage" || key.fn === "onGroup" || key.fn === "onSortBy" && !isGroupByFormat) && query.lazyLoad.length) {
                if (key.fn === "onGroup") group.push(key.e);
                if (key.fn === "onPage") page = key.e;
                if (key.fn === "onSortBy") sort.unshift(key.e);
                continue;
            }
            ret = this[key.fn].call(this, result, key.e, query);
            if (key.fn === "onAggregates") agg[key.e.field + " - " + key.e.type] = ret;
            else result = ret !== undefined ? ret : result;
            if (key.fn === "onPage" || key.fn === "onSkip" || key.fn === "onTake" || key.fn === "onRange") countFlg = false;
            if (countFlg) count = result.length;
        }
        if (keyCount) {
            var args = {
                query: query,
                lazyLoad: lazyLoad,
                result: result,
                group: group,
                page: page,
                sort: sort
            };
            var lazyLoadData = this.lazyLoadGroup(args);
            result = lazyLoadData.result;
            count = lazyLoadData.count;
        }
        if (query.isCountRequired) result = {
            result: result,
            count: count,
            aggregates: agg
        };
        return result;
    };
    /**
     * Perform lazy load grouping in JSON array based on the given query and lazy load details.
     *
     * @param  {LazyLoadGroupArgs} args
     */ JsonAdaptor.prototype.lazyLoadGroup = function(args) {
        var count = 0;
        var agg = this.getAggregate(args.query);
        var result = args.result;
        if (!(0, $3EnZW.isNullOrUndefined)(args.lazyLoad.onDemandGroupInfo)) {
            var req = args.lazyLoad.onDemandGroupInfo;
            for(var i = req.where.length - 1; i >= 0; i--)result = this.onWhere(result, req.where[i]);
            if (args.group.length !== req.level) {
                var field = args.group[req.level].fieldName;
                result = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(result, field, agg, null, null, args.group[req.level].comparer, true);
                if (args.sort.length) result = this.onSortBy(result, args.sort[parseInt(req.level.toString(), 10)], args.query, true);
            } else for(var i = args.sort.length - 1; i >= req.level; i--)result = this.onSortBy(result, args.sort[parseInt(i.toString(), 10)], args.query, false);
            count = result.length;
            var data = result;
            result = result.slice(req.skip);
            result = result.slice(0, req.take);
            if (args.group.length !== req.level) this.formGroupResult(result, data);
        } else {
            var field_1 = args.group[0].fieldName;
            result = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(result, field_1, agg, null, null, args.group[0].comparer, true);
            count = result.length;
            var data = result;
            if (args.sort.length) {
                var sort = args.sort.length > 1 ? args.sort.filter(function(x) {
                    return x.fieldName === field_1;
                })[0] : args.sort[0];
                result = this.onSortBy(result, sort, args.query, true);
            }
            if (args.page) result = this.onPage(result, args.page, args.query);
            this.formGroupResult(result, data);
        }
        return {
            result: result,
            count: count
        };
    };
    JsonAdaptor.prototype.formGroupResult = function(result, data) {
        if (result.length && data.length) {
            var uid = "GroupGuid";
            var childLevel = "childLevels";
            var level = "level";
            var records = "records";
            result[uid] = data[uid];
            result[childLevel] = data[childLevel];
            result[level] = data[level];
            result[records] = data[records];
        }
        return result;
    };
    /**
     * Separate the aggregate query from the given queries
     *
     * @param  {Query} query
     */ JsonAdaptor.prototype.getAggregate = function(query) {
        var aggQuery = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onAggregates");
        var agg = [];
        if (aggQuery.length) {
            var tmp = void 0;
            for(var i = 0; i < aggQuery.length; i++){
                tmp = aggQuery[i].e;
                agg.push({
                    type: tmp.type,
                    field: (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(tmp.field, query)
                });
            }
        }
        return agg;
    };
    /**
     * Performs batch update in the JSON array which add, remove and update records.
     *
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     */ JsonAdaptor.prototype.batchRequest = function(dm, changes, e) {
        var i;
        var deletedRecordsLen = changes.deletedRecords.length;
        for(i = 0; i < changes.addedRecords.length; i++)this.insert(dm, changes.addedRecords[i]);
        for(i = 0; i < changes.changedRecords.length; i++)this.update(dm, e.key, changes.changedRecords[i]);
        for(i = 0; i < deletedRecordsLen; i++)this.remove(dm, e.key, changes.deletedRecords[i]);
        return changes;
    };
    /**
     * Performs filter operation with the given data and where query.
     *
     * @param {Object[]} ds
     * @param {{validate:Function}} e
     * @param e.validate
     */ JsonAdaptor.prototype.onWhere = function(ds, e) {
        if (!ds || !ds.length) return ds;
        return ds.filter(function(obj) {
            if (e) return e.validate(obj);
        });
    };
    /**
     * Returns aggregate function based on the aggregate type.
     *
     * @param {Object[]} ds
     * @param e
     * @param {string} } type
     * @param e.field
     * @param e.type
     */ JsonAdaptor.prototype.onAggregates = function(ds, e) {
        var fn = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).aggregates[e.type];
        if (!ds || !fn || ds.length === 0) return null;
        return fn(ds, e.field);
    };
    /**
     * Performs search operation based on the given query.
     *
     * @param  {Object[]} ds
     * @param  {QueryOptions} e
     */ JsonAdaptor.prototype.onSearch = function(ds, e) {
        if (!ds || !ds.length) return ds;
        if (e.fieldNames.length === 0) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getFieldList(ds[0], e.fieldNames);
        return ds.filter(function(obj) {
            for(var j = 0; j < e.fieldNames.length; j++){
                if (e.comparer.call(obj, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(e.fieldNames[j], obj), e.searchKey, e.ignoreCase, e.ignoreAccent)) return true;
            }
            return false;
        });
    };
    /**
     * Sort the data with given direction and field.
     *
     * @param {Object[]} ds
     * @param e
     * @param {Object} b
     * @param e.comparer
     * @param e.fieldName
     * @param query
     * @param isLazyLoadGroupSort
     */ JsonAdaptor.prototype.onSortBy = function(ds, e, query, isLazyLoadGroupSort) {
        if (!ds || !ds.length) return ds;
        var fnCompare;
        var field = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.fieldName, query);
        if (!field) return ds.sort(e.comparer);
        if (field instanceof Array) {
            field = field.slice(0);
            for(var i = field.length - 1; i >= 0; i--){
                if (!field[i]) continue;
                fnCompare = e.comparer;
                if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(field[i], " desc")) {
                    fnCompare = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnSort("descending");
                    field[i] = field[i].replace(" desc", "");
                }
                ds = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).sort(ds, field[i], fnCompare);
            }
            return ds;
        }
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).sort(ds, isLazyLoadGroupSort ? "key" : field, e.comparer);
    };
    /**
     * Group the data based on the given query.
     *
     * @param  {Object[]} ds
     * @param  {QueryOptions} e
     * @param  {Query} query
     */ JsonAdaptor.prototype.onGroup = function(ds, e, query) {
        if (!ds || !ds.length) return ds;
        var agg = this.getAggregate(query);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(ds, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.fieldName, query), agg, null, null, e.comparer);
    };
    /**
     * Retrieves records based on the given page index and size.
     *
     * @param {Object[]} ds
     * @param e
     * @param {number} } pageIndex
     * @param e.pageSize
     * @param {Query} query
     * @param e.pageIndex
     */ JsonAdaptor.prototype.onPage = function(ds, e, query) {
        var size = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.pageSize, query);
        var start = ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.pageIndex, query) - 1) * size;
        var end = start + size;
        if (!ds || !ds.length) return ds;
        return ds.slice(start, end);
    };
    /**
     * Retrieves records based on the given start and end index from query.
     *
     * @param {Object[]} ds
     * @param e
     * @param {number} } end
     * @param e.start
     * @param e.end
     */ JsonAdaptor.prototype.onRange = function(ds, e) {
        if (!ds || !ds.length) return ds;
        return ds.slice((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.start), (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.end));
    };
    /**
     * Picks the given count of records from the top of the datasource.
     *
     * @param {Object[]} ds
     * @param {{nos:number}} e
     * @param e.nos
     */ JsonAdaptor.prototype.onTake = function(ds, e) {
        if (!ds || !ds.length) return ds;
        return ds.slice(0, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.nos));
    };
    /**
     * Skips the given count of records from the data source.
     *
     * @param {Object[]} ds
     * @param {{nos:number}} e
     * @param e.nos
     */ JsonAdaptor.prototype.onSkip = function(ds, e) {
        if (!ds || !ds.length) return ds;
        return ds.slice((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.nos));
    };
    /**
     * Selects specified columns from the data source.
     *
     * @param {Object[]} ds
     * @param {{fieldNames:string}} e
     * @param e.fieldNames
     */ JsonAdaptor.prototype.onSelect = function(ds, e) {
        if (!ds || !ds.length) return ds;
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).select(ds, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(e.fieldNames));
    };
    /**
     * Inserts new record in the table.
     *
     * @param {DataManager} dm
     * @param {Object} data
     * @param tableName
     * @param query
     * @param {number} position
     */ JsonAdaptor.prototype.insert = function(dm, data, tableName, query, position) {
        if ((0, $3EnZW.isNullOrUndefined)(position)) return dm.dataSource.json.push(data);
        else return dm.dataSource.json.splice(position, 0, data);
    };
    /**
     * Remove the data from the dataSource based on the key field value.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName?
     * @param tableName
     * @returns null
     */ JsonAdaptor.prototype.remove = function(dm, keyField, value, tableName) {
        var ds = dm.dataSource.json;
        var i;
        if (typeof value === "object" && !(value instanceof Date)) value = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(keyField, value);
        for(i = 0; i < ds.length; i++){
            if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(keyField, ds[i]) === value) break;
        }
        return i !== ds.length ? ds.splice(i, 1) : null;
    };
    /**
     * Updates existing record and saves the changes to the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName?
     * @param tableName
     * @returns null
     */ JsonAdaptor.prototype.update = function(dm, keyField, value, tableName) {
        var ds = dm.dataSource.json;
        var i;
        var key;
        if (!(0, $3EnZW.isNullOrUndefined)(keyField)) key = (0, $3EnZW.getValue)(keyField, value);
        for(i = 0; i < ds.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(keyField) && (0, $3EnZW.getValue)(keyField, ds[i]) === key) break;
        }
        return i < ds.length ? (0, $3EnZW.merge)(ds[i], value) : null;
    };
    return JsonAdaptor;
}($e1170102ff02b3b7$export$4457cd68038afa91);
/**
 * URL Adaptor of DataManager can be used when you are required to use remote service to retrieve data.
 * It interacts with server-side for all DataManager Queries and CRUD operations.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$b011aea473980a2d = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(UrlAdaptor, _super);
    function UrlAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Process the query to generate request body.
     *
     * @param {DataManager} dm
     * @param {Query} query
     * @param {Object[]} hierarchyFilters?
     * @param hierarchyFilters
     * @returns p
     */ // tslint:disable-next-line:max-func-body-length
    UrlAdaptor.prototype.processQuery = function(dm, query, hierarchyFilters) {
        var queries = this.getQueryRequest(query);
        var singles = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueryLists(query.queries, [
            "onSelect",
            "onPage",
            "onSkip",
            "onTake",
            "onRange"
        ]);
        var params = query.params;
        var url = dm.dataSource.url;
        var temp;
        var skip;
        var take = null;
        var options = this.options;
        var request = {
            sorts: [],
            groups: [],
            filters: [],
            searches: [],
            aggregates: []
        };
        // calc Paging & Range
        if ("onPage" in singles) {
            temp = singles.onPage;
            skip = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(temp.pageIndex, query);
            take = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(temp.pageSize, query);
            skip = (skip - 1) * take;
        } else if ("onRange" in singles) {
            temp = singles.onRange;
            skip = temp.start;
            take = temp.end - temp.start;
        }
        // Sorting
        for(var i = 0; i < queries.sorts.length; i++){
            temp = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(queries.sorts[i].e.fieldName, query);
            request.sorts.push((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onEachSort", {
                name: temp,
                direction: queries.sorts[i].e.direction
            }, query));
        }
        // hierarchy
        if (hierarchyFilters) {
            temp = this.getFiltersFrom(hierarchyFilters, query);
            if (temp) request.filters.push((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onEachWhere", temp.toJson(), query));
        }
        // Filters
        for(var i = 0; i < queries.filters.length; i++){
            var res = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onEachWhere", queries.filters[i].e.toJson(), query);
            if (this.getModuleName && this.getModuleName() === "ODataV4Adaptor" && !(0, $3EnZW.isNullOrUndefined)(queries.filters[i].e.key) && queries.filters.length > 1) res = "(" + res + ")";
            request.filters.push(res);
            var keys_3 = typeof request.filters[i] === "object" ? Object.keys(request.filters[i]) : [];
            for(var _i = 0, keys_1 = keys_3; _i < keys_1.length; _i++){
                var prop = keys_1[_i];
                if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(request[prop])) delete request[prop];
            }
        }
        // Searches
        for(var i = 0; i < queries.searches.length; i++){
            temp = queries.searches[i].e;
            request.searches.push((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onEachSearch", {
                fields: temp.fieldNames,
                operator: temp.operator,
                key: temp.searchKey,
                ignoreCase: temp.ignoreCase
            }, query));
        }
        // Grouping
        for(var i = 0; i < queries.groups.length; i++)request.groups.push((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(queries.groups[i].e.fieldName, query));
        // aggregates
        for(var i = 0; i < queries.aggregates.length; i++){
            temp = queries.aggregates[i].e;
            request.aggregates.push({
                type: temp.type,
                field: (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(temp.field, query)
            });
        }
        var req = {};
        this.getRequestQuery(options, query, singles, request, req);
        // Params
        (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "addParams", {
            dm: dm,
            query: query,
            params: params,
            reqParams: req
        });
        if (query.lazyLoad.length) for(var i = 0; i < query.lazyLoad.length; i++)req[query.lazyLoad[i].key] = query.lazyLoad[i].value;
        // cleanup
        var keys = Object.keys(req);
        for(var _a = 0, keys_2 = keys; _a < keys_2.length; _a++){
            var prop = keys_2[_a];
            if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(req[prop]) || req[prop] === "" || req[prop].length === 0) delete req[prop];
        }
        if (!(options.skip in req && options.take in req) && take !== null) {
            req[options.skip] = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onSkip", skip, query);
            req[options.take] = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onTake", take, query);
        }
        var p = this.pvt;
        this.pvt = {};
        if (this.options.requestType === "json") return {
            data: JSON.stringify(req, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.jsonDateReplacer),
            url: url,
            pvtData: p,
            type: "POST",
            contentType: "application/json; charset=utf-8"
        };
        temp = this.convertToQueryString(req, query, dm);
        temp = (dm.dataSource.url.indexOf("?") !== -1 ? "&" : "/") + temp;
        return {
            type: "GET",
            url: temp.length ? url.replace(/\/*$/, temp) : url,
            pvtData: p
        };
    };
    UrlAdaptor.prototype.getRequestQuery = function(options, query, singles, request, request1) {
        var param = "param";
        var req = request1;
        req[options.from] = query.fromTable;
        if (options.apply && query.distincts.length) req[options.apply] = "onDistinct" in this ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onDistinct", query.distincts) : "";
        if (!query.distincts.length && options.expand) req[options.expand] = "onExpand" in this && "onSelect" in singles ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onExpand", {
            selects: (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(singles.onSelect.fieldNames, query),
            expands: query.expands
        }, query) : query.expands;
        req[options.select] = "onSelect" in singles && !query.distincts.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onSelect", (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(singles.onSelect.fieldNames, query), query) : "";
        req[options.count] = query.isCountRequired ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onCount", query.isCountRequired, query) : "";
        req[options.search] = request.searches.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onSearch", request.searches, query) : "";
        req[options.skip] = "onSkip" in singles ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onSkip", (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(singles.onSkip.nos, query), query) : "";
        req[options.take] = "onTake" in singles ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onTake", (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getValue(singles.onTake.nos, query), query) : "";
        req[options.where] = request.filters.length || request.searches.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onWhere", request.filters, query) : "";
        req[options.sortBy] = request.sorts.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onSortBy", request.sorts, query) : "";
        req[options.group] = request.groups.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onGroup", request.groups, query) : "";
        req[options.aggregates] = request.aggregates.length ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).callAdaptorFunction(this, "onAggregates", request.aggregates, query) : "";
        req[param] = [];
    };
    /**
     * Convert the object from processQuery to string which can be added query string.
     *
     * @param {Object} req
     * @param request
     * @param {Query} query
     * @param {DataManager} dm
     */ UrlAdaptor.prototype.convertToQueryString = function(request, query, dm) {
        return "";
    // this needs to be overridden
    };
    /**
     * Return the data from the data manager processing.
     *
     * @param {DataResult} data
     * @param {DataOptions} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Object} request?
     * @param {CrudOptions} changes?
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @param changes
     */ UrlAdaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes) {
        if (xhr && xhr.headers.get("Content-Type") && xhr.headers.get("Content-Type").indexOf("application/json") !== -1) {
            var handleTimeZone = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).timeZoneHandling;
            if (ds && !ds.timeZoneHandling) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).timeZoneHandling = false;
            data = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(data);
            (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).timeZoneHandling = handleTimeZone;
        }
        var requests = request;
        var pvt = requests.pvtData || {};
        var groupDs = data ? data.groupDs : [];
        if (xhr && xhr.headers.get("Content-Type") && xhr.headers.get("Content-Type").indexOf("xml") !== -1) return query.isCountRequired ? {
            result: [],
            count: 0
        } : [];
        var d = JSON.parse(requests.data);
        if (d && d.action === "batch" && data && data.addedRecords && !(0, $3EnZW.isNullOrUndefined)(changes)) {
            changes.addedRecords = data.addedRecords;
            return changes;
        }
        if (data && data.d) data = data.d;
        var args = {};
        if (data && "count" in data) args.count = data.count;
        args.result = data && data.result ? data.result : data;
        var isExpand = false;
        if (Array.isArray(data.result) && data.result.length) {
            var key = "key";
            var val = "value";
            var level = "level";
            if (!(0, $3EnZW.isNullOrUndefined)(data.result[0][key])) args.result = this.formRemoteGroupedData(args.result, 1, pvt.groups.length - 1);
            if (query && query.lazyLoad.length && pvt.groups.length) {
                for(var i = 0; i < query.lazyLoad.length; i++)if (query.lazyLoad[i][key] === "onDemandGroupInfo") {
                    var value = query.lazyLoad[i][val][level];
                    if (pvt.groups.length === value) isExpand = true;
                }
            }
        }
        if (!isExpand) this.getAggregateResult(pvt, data, args, groupDs, query);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(args.count) ? args.result : {
            result: args.result,
            count: args.count,
            aggregates: args.aggregates
        };
    };
    UrlAdaptor.prototype.formRemoteGroupedData = function(data, level, childLevel) {
        for(var i = 0; i < data.length; i++)if (data[i].items.length && Object.keys(data[i].items[0]).indexOf("key") > -1) this.formRemoteGroupedData(data[i].items, level + 1, childLevel - 1);
        var uid = "GroupGuid";
        var childLvl = "childLevels";
        var lvl = "level";
        var records = "records";
        data[uid] = $e1170102ff02b3b7$var$consts[uid];
        data[lvl] = level;
        data[childLvl] = childLevel;
        data[records] = data[0].items.length ? this.getGroupedRecords(data, !(0, $3EnZW.isNullOrUndefined)(data[0].items[records])) : [];
        return data;
    };
    UrlAdaptor.prototype.getGroupedRecords = function(data, hasRecords) {
        var childGroupedRecords = [];
        var records = "records";
        for(var i = 0; i < data.length; i++){
            if (!hasRecords) for(var j = 0; j < data[i].items.length; j++)childGroupedRecords.push(data[i].items[j]);
            else childGroupedRecords = childGroupedRecords.concat(data[i].items[records]);
        }
        return childGroupedRecords;
    };
    /**
     * Add the group query to the adaptor`s option.
     *
     * @param  {Object[]} e
     * @returns void
     */ UrlAdaptor.prototype.onGroup = function(e) {
        this.pvt.groups = e;
        return e;
    };
    /**
     * Add the aggregate query to the adaptor`s option.
     *
     * @param  {Aggregates[]} e
     * @returns void
     */ UrlAdaptor.prototype.onAggregates = function(e) {
        this.pvt.aggregates = e;
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     *
     * @param {DataManager} dm
     * @param {CrudOptions} changes
     * @param {Object} e
     * @param query
     * @param original
     */ UrlAdaptor.prototype.batchRequest = function(dm, changes, e, query, original) {
        var url;
        var key;
        return {
            type: "POST",
            url: dm.dataSource.batchUrl || dm.dataSource.crudUrl || dm.dataSource.removeUrl || dm.dataSource.url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                changed: changes.changedRecords,
                added: changes.addedRecords,
                deleted: changes.deletedRecords,
                action: "batch",
                table: e[url],
                key: e[key]
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     *
     * @param  {DataManager} dm
     * @param  {Request} request
     * @param  {Fetch} settings?
     * @returns void
     */ UrlAdaptor.prototype.beforeSend = function(dm, request, settings) {
    // need to extend this method
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     *
     * @param {DataManager} dm
     * @param {Object} data
     * @param {string} tableName
     * @param query
     */ UrlAdaptor.prototype.insert = function(dm, data, tableName, query) {
        return {
            url: dm.dataSource.insertUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                value: data,
                table: tableName,
                action: "insert"
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {number|string} value
     * @param {string} tableName
     * @param query
     */ UrlAdaptor.prototype.remove = function(dm, keyField, value, tableName, query) {
        return {
            type: "POST",
            url: dm.dataSource.removeUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                key: value,
                keyColumn: keyField,
                table: tableName,
                action: "remove"
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    /**
     * Prepare and return request body which is used to update record.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName
     * @param query
     */ UrlAdaptor.prototype.update = function(dm, keyField, value, tableName, query) {
        return {
            type: "POST",
            url: dm.dataSource.updateUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                value: value,
                action: "update",
                keyColumn: keyField,
                key: (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(keyField, value),
                table: tableName
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    /**
     * To generate the predicate based on the filtered query.
     *
     * @param  {Object[]|string[]|number[]} data
     * @param  {Query} query
     * @hidden
     */ UrlAdaptor.prototype.getFiltersFrom = function(data, query) {
        var key = query.fKey;
        var value;
        var prop = key;
        var pKey = query.key;
        var predicats = [];
        if (typeof data[0] !== "object") prop = null;
        for(var i = 0; i < data.length; i++){
            if (typeof data[0] === "object") value = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(pKey || prop, data[i]);
            else value = data[i];
            predicats.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(key, "equal", value));
        }
        return (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicats);
    };
    UrlAdaptor.prototype.getAggregateResult = function(pvt, data, args, groupDs, query) {
        var pData = data;
        if (data && data.result) pData = data.result;
        if (pvt && pvt.aggregates && pvt.aggregates.length) {
            var agg = pvt.aggregates;
            var fn = void 0;
            var aggregateData = pData;
            var res = {};
            if (data.aggregate) aggregateData = data.aggregate;
            for(var i = 0; i < agg.length; i++){
                fn = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).aggregates[agg[i].type];
                if (fn) res[agg[i].field + " - " + agg[i].type] = fn(aggregateData, agg[i].field);
            }
            args.aggregates = res;
        }
        var key = "key";
        var isServerGrouping = Array.isArray(data.result) && data.result.length && !(0, $3EnZW.isNullOrUndefined)(data.result[0][key]);
        if (pvt && pvt.groups && pvt.groups.length && !isServerGrouping) {
            var groups = pvt.groups;
            for(var i = 0; i < groups.length; i++){
                var level = null;
                if (!(0, $3EnZW.isNullOrUndefined)(groupDs)) groupDs = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(groupDs, groups[i]);
                var groupQuery = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onGroup")[i].e;
                pData = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(pData, groups[i], pvt.aggregates, level, groupDs, groupQuery.comparer);
            }
            args.result = pData;
        }
        return args;
    };
    UrlAdaptor.prototype.getQueryRequest = function(query) {
        var req = {
            sorts: [],
            groups: [],
            filters: [],
            searches: [],
            aggregates: []
        };
        req.sorts = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onSortBy");
        req.groups = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onGroup");
        req.filters = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onWhere");
        req.searches = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onSearch");
        req.aggregates = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueries(query.queries, "onAggregates");
        return req;
    };
    UrlAdaptor.prototype.addParams = function(options) {
        var req = options.reqParams;
        if (options.params.length) req.params = {};
        for(var _i = 0, _a = options.params; _i < _a.length; _i++){
            var tmp = _a[_i];
            if (req[tmp.key]) throw new Error("Query() - addParams: Custom Param is conflicting other request arguments");
            req[tmp.key] = tmp.value;
            if (tmp.fn) req[tmp.key] = tmp.fn.call(options.query, tmp.key, options.query, options.dm);
            req.params[tmp.key] = req[tmp.key];
        }
    };
    return UrlAdaptor;
}($e1170102ff02b3b7$export$4457cd68038afa91);
/**
 * OData Adaptor that is extended from URL Adaptor, is used for consuming data through OData Service.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$b1cc6088a1ba4742 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(ODataAdaptor, _super);
    function ODataAdaptor(props) {
        var _this = _super.call(this) || this;
        // options replaced the default adaptor options
        _this.options = (0, $3EnZW.extend)({}, _this.options, {
            requestType: "get",
            accept: "application/json;odata=light;q=1,application/json;odata=verbose;q=0.5",
            multipartAccept: "multipart/mixed",
            sortBy: "$orderby",
            select: "$select",
            skip: "$skip",
            take: "$top",
            count: "$inlinecount",
            where: "$filter",
            expand: "$expand",
            batch: "$batch",
            changeSet: "--changeset_",
            batchPre: "batch_",
            contentId: "Content-Id: ",
            batchContent: "Content-Type: multipart/mixed; boundary=",
            changeSetContent: "Content-Type: application/http\nContent-Transfer-Encoding: binary ",
            batchChangeSetContentType: "Content-Type: application/json; charset=utf-8 ",
            updateType: "PUT"
        });
        (0, $3EnZW.extend)(_this.options, props || {});
        return _this;
    }
    ODataAdaptor.prototype.getModuleName = function() {
        return "ODataAdaptor";
    };
    /**
     * Generate request string based on the filter criteria from query.
     *
     * @param {Predicate} pred
     * @param {boolean} requiresCast?
     * @param predicate
     * @param query
     * @param requiresCast
     */ ODataAdaptor.prototype.onPredicate = function(predicate, query, requiresCast) {
        var returnValue = "";
        var operator;
        var guid;
        var val = predicate.value;
        var type = typeof val;
        var field = predicate.field ? ODataAdaptor.getField(predicate.field) : null;
        if (val instanceof Date) val = "datetime'" + (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.replacer(val) + "'";
        if (type === "string") {
            val = val.replace(/'/g, "''");
            if (predicate.ignoreCase) val = val.toLowerCase();
            if (predicate.operator !== "like") val = encodeURIComponent(val);
            if (predicate.operator !== "wildcard" && predicate.operator !== "like") val = "'" + val + "'";
            if (requiresCast) field = "cast(" + field + ", 'Edm.String')";
            if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(val)) guid = "guid";
            if (predicate.ignoreCase) {
                if (!guid) field = "tolower(" + field + ")";
                val = val.toLowerCase();
            }
        }
        if (predicate.operator === "isempty" || predicate.operator === "isnull" || predicate.operator === "isnotempty" || predicate.operator === "isnotnull") {
            operator = predicate.operator.indexOf("isnot") !== -1 ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odBiOperator["notequal"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odBiOperator["equal"];
            val = predicate.operator === "isnull" || predicate.operator === "isnotnull" ? null : "''";
        } else operator = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odBiOperator[predicate.operator];
        if (operator) {
            returnValue += field;
            returnValue += operator;
            if (guid) returnValue += guid;
            return returnValue + val;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor") operator = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator[predicate.operator];
        else operator = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator[predicate.operator];
        if (operator === "like") {
            val;
            if (val.indexOf("%") !== -1) {
                if (val.charAt(0) === "%" && val.lastIndexOf("%") < 2) {
                    val = val.substring(1, val.length);
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["startswith"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["startswith"];
                } else if (val.charAt(val.length - 1) === "%" && val.indexOf("%") > val.length - 3) {
                    val = val.substring(0, val.length - 1);
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["endswith"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["endswith"];
                } else if (val.lastIndexOf("%") !== val.indexOf("%") && val.lastIndexOf("%") > val.indexOf("%") + 1) {
                    val = val.substring(val.indexOf("%") + 1, val.lastIndexOf("%"));
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["contains"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["contains"];
                } else operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["contains"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["contains"];
            }
            val = encodeURIComponent(val);
            val = "'" + val + "'";
        } else if (operator === "wildcard") {
            val;
            if (val.indexOf("*") !== -1) {
                var splittedStringValue = val.split("*");
                var splittedValue = void 0;
                var count = 0;
                if (val.indexOf("*") !== 0 && splittedStringValue[0].indexOf("%3f") === -1 && splittedStringValue[0].indexOf("?") === -1) {
                    splittedValue = splittedStringValue[0];
                    splittedValue = "'" + splittedValue + "'";
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["startswith"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["startswith"];
                    returnValue += operator + "(";
                    returnValue += field + ",";
                    if (guid) returnValue += guid;
                    returnValue += splittedValue + ")";
                    count++;
                }
                if (val.lastIndexOf("*") !== val.length - 1 && splittedStringValue[splittedStringValue.length - 1].indexOf("%3f") === -1 && splittedStringValue[splittedStringValue.length - 1].indexOf("?") === -1) {
                    splittedValue = splittedStringValue[splittedStringValue.length - 1];
                    splittedValue = "'" + splittedValue + "'";
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["endswith"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["endswith"];
                    if (count > 0) returnValue += " and ";
                    returnValue += operator + "(";
                    returnValue += field + ",";
                    if (guid) returnValue += guid;
                    returnValue += splittedValue + ")";
                    count++;
                }
                if (splittedStringValue.length > 2) {
                    for(var i = 1; i < splittedStringValue.length - 1; i++)if (splittedStringValue[i].indexOf("%3f") === -1 && splittedStringValue[i].indexOf("?") === -1) {
                        splittedValue = splittedStringValue[i];
                        splittedValue = "'" + splittedValue + "'";
                        operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["contains"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["contains"];
                        if (count > 0) returnValue += " and ";
                        if (operator === "substringof" || operator === "not substringof") {
                            var temp = splittedValue;
                            splittedValue = field;
                            field = temp;
                        }
                        returnValue += operator + "(";
                        returnValue += field + ",";
                        if (guid) returnValue += guid;
                        returnValue += splittedValue + ")";
                        count++;
                    }
                }
                if (count === 0) {
                    operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["contains"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["contains"];
                    if (val.indexOf("?") !== -1 || val.indexOf("%3f") !== -1) val = val.indexOf("?") !== -1 ? val.split("?").join("") : val.split("%3f").join("");
                    val = "'" + val + "'";
                } else operator = "wildcard";
            } else {
                operator = !(0, $3EnZW.isNullOrUndefined)(this.getModuleName) && this.getModuleName() === "ODataV4Adaptor" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odv4UniOperator["contains"] : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).odUniOperator["contains"];
                if (val.indexOf("?") !== -1 || val.indexOf("%3f") !== -1) val = val.indexOf("?") !== -1 ? val.split("?").join("") : val.split("%3f").join("");
                val = "'" + val + "'";
            }
        }
        if (operator === "substringof" || operator === "not substringof") {
            var temp = val;
            val = field;
            field = temp;
        }
        if (operator !== "wildcard") {
            returnValue += operator + "(";
            returnValue += field + ",";
            if (guid) returnValue += guid;
            returnValue += val + ")";
        }
        return returnValue;
    };
    ODataAdaptor.prototype.addParams = function(options) {
        _super.prototype.addParams.call(this, options);
        delete options.reqParams.params;
    };
    /**
     * Generate request string based on the multiple filter criteria from query.
     *
     * @param {Predicate} pred
     * @param {boolean} requiresCast?
     * @param predicate
     * @param query
     * @param requiresCast
     */ ODataAdaptor.prototype.onComplexPredicate = function(predicate, query, requiresCast) {
        var res = [];
        for(var i = 0; i < predicate.predicates.length; i++)res.push("(" + this.onEachWhere(predicate.predicates[i], query, requiresCast) + ")");
        return res.join(" " + predicate.condition + " ");
    };
    /**
     * Generate query string based on the multiple filter criteria from query.
     *
     * @param {Predicate} filter
     * @param {boolean} requiresCast?
     * @param query
     * @param requiresCast
     */ ODataAdaptor.prototype.onEachWhere = function(filter, query, requiresCast) {
        return filter.isComplex ? this.onComplexPredicate(filter, query, requiresCast) : this.onPredicate(filter, query, requiresCast);
    };
    /**
     * Generate query string based on the multiple filter criteria from query.
     *
     * @param  {string[]} filters
     */ ODataAdaptor.prototype.onWhere = function(filters) {
        if (this.pvt.search) filters.push(this.onEachWhere(this.pvt.search, null, true));
        return filters.join(" and ");
    };
    /**
     * Generate query string based on the multiple search criteria from query.
     *
     * @param e
     * @param {string} operator
     * @param {string} key
     * @param {boolean} } ignoreCase
     * @param e.fields
     * @param e.operator
     * @param e.key
     * @param e.ignoreCase
     */ ODataAdaptor.prototype.onEachSearch = function(e) {
        if (e.fields && e.fields.length === 0) (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).throwError("Query() - Search : oData search requires list of field names to search");
        var filter = this.pvt.search || [];
        for(var i = 0; i < e.fields.length; i++)filter.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(e.fields[i], e.operator, e.key, e.ignoreCase));
        this.pvt.search = filter;
    };
    /**
     * Generate query string based on the search criteria from query.
     *
     * @param  {Object} e
     */ ODataAdaptor.prototype.onSearch = function(e) {
        this.pvt.search = (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(this.pvt.search);
        return "";
    };
    /**
     * Generate query string based on multiple sort criteria from query.
     *
     * @param  {QueryOptions} e
     */ ODataAdaptor.prototype.onEachSort = function(e) {
        var res = [];
        if (e.name instanceof Array) for(var i = 0; i < e.name.length; i++)res.push(ODataAdaptor.getField(e.name[i]) + (e.direction === "descending" ? " desc" : ""));
        else res.push(ODataAdaptor.getField(e.name) + (e.direction === "descending" ? " desc" : ""));
        return res.join(",");
    };
    /**
     * Returns sort query string.
     *
     * @param  {string[]} e
     */ ODataAdaptor.prototype.onSortBy = function(e) {
        return e.reverse().join(",");
    };
    /**
     * Adds the group query to the adaptor option.
     *
     * @param  {Object[]} e
     * @returns string
     */ ODataAdaptor.prototype.onGroup = function(e) {
        this.pvt.groups = e;
        return [];
    };
    /**
     * Returns the select query string.
     *
     * @param  {string[]} e
     */ ODataAdaptor.prototype.onSelect = function(e) {
        for(var i = 0; i < e.length; i++)e[i] = ODataAdaptor.getField(e[i]);
        return e.join(",");
    };
    /**
     * Add the aggregate query to the adaptor option.
     *
     * @param  {Object[]} e
     * @returns string
     */ ODataAdaptor.prototype.onAggregates = function(e) {
        this.pvt.aggregates = e;
        return "";
    };
    /**
     * Returns the query string which requests total count from the data source.
     *
     * @param  {boolean} e
     * @returns string
     */ ODataAdaptor.prototype.onCount = function(e) {
        return e === true ? "allpages" : "";
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     *
     * @param {DataManager} dm
     * @param {Request} request
     * @param {Fetch} settings?
     * @param settings
     */ ODataAdaptor.prototype.beforeSend = function(dm, request, settings) {
        if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(settings.url, this.options.batch) && settings.type.toLowerCase() === "post") {
            request.headers.set("Accept", this.options.multipartAccept);
            request.headers.set("DataServiceVersion", "2.0");
        //request.overrideMimeType('text/plain; charset=x-user-defined');
        } else request.headers.set("Accept", this.options.accept);
        request.headers.set("DataServiceVersion", "2.0");
        request.headers.set("MaxDataServiceVersion", "2.0");
    };
    /**
     * Returns the data from the query processing.
     *
     * @param {DataResult} data
     * @param {DataOptions} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Fetch} request?
     * @param {CrudOptions} changes?
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @param changes
     * @returns aggregateResult
     */ ODataAdaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes) {
        var metaCheck = "odata.metadata";
        if (request && request.type === "GET" && !this.rootUrl && data[metaCheck]) {
            var dataUrls = data[metaCheck].split("/$metadata#");
            this.rootUrl = dataUrls[0];
            this.resourceTableName = dataUrls[1];
        }
        var pvtData = "pvtData";
        if (!(0, $3EnZW.isNullOrUndefined)(data.d)) {
            var dataCopy = query && query.isCountRequired ? data.d.results : data.d;
            var metaData = "__metadata";
            if (!(0, $3EnZW.isNullOrUndefined)(dataCopy)) {
                for(var i = 0; i < dataCopy.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(dataCopy[i][metaData])) delete dataCopy[i][metaData];
            }
        }
        var pvt = request && request[pvtData];
        var emptyAndBatch = this.processBatchResponse(data, query, xhr, request, changes);
        if (emptyAndBatch) return emptyAndBatch;
        var versionCheck = xhr && request.fetchRequest.headers.get("DataServiceVersion");
        var count = null;
        var version = versionCheck && parseInt(versionCheck, 10) || 2;
        if (query && query.isCountRequired) {
            var oDataCount = "__count";
            if (data[oDataCount] || data["odata.count"]) count = data[oDataCount] || data["odata.count"];
            if (data.d) data = data.d;
            if (data[oDataCount] || data["odata.count"]) count = data[oDataCount] || data["odata.count"];
        }
        if (version === 3 && data.value) data = data.value;
        if (data.d) data = data.d;
        if (version < 3 && data.results) data = data.results;
        var args = {};
        args.count = count;
        args.result = data;
        this.getAggregateResult(pvt, data, args, null, query);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(count) ? args.result : {
            result: args.result,
            count: args.count,
            aggregates: args.aggregates
        };
    };
    /**
     * Converts the request object to query string.
     *
     * @param {Object} req
     * @param request
     * @param {Query} query
     * @param {DataManager} dm
     * @returns tableName
     */ ODataAdaptor.prototype.convertToQueryString = function(request, query, dm) {
        var res = [];
        var table = "table";
        var tableName = request[table] || "";
        var format = "$format";
        delete request[table];
        if (dm.dataSource.requiresFormat) request[format] = "json";
        var keys = Object.keys(request);
        for(var _i = 0, keys_4 = keys; _i < keys_4.length; _i++){
            var prop = keys_4[_i];
            res.push(prop + "=" + request[prop]);
        }
        res = res.join("&");
        if (dm.dataSource.url && dm.dataSource.url.indexOf("?") !== -1 && !tableName) return res;
        return res.length ? tableName + "?" + res : tableName || "";
    };
    ODataAdaptor.prototype.localTimeReplacer = function(key, convertObj) {
        for(var _i = 0, _a = !(0, $3EnZW.isNullOrUndefined)(convertObj) ? Object.keys(convertObj) : []; _i < _a.length; _i++){
            var prop = _a[_i];
            if (convertObj[prop] instanceof Date) convertObj[prop] = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).dateParse.toLocalTime(convertObj[prop]);
        }
        return convertObj;
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     *
     * @param {DataManager} dm
     * @param {Object} data
     * @param {string} tableName?
     * @param tableName
     */ ODataAdaptor.prototype.insert = function(dm, data, tableName) {
        return {
            url: (dm.dataSource.insertUrl || dm.dataSource.url).replace(/\/*$/, tableName ? "/" + tableName : ""),
            data: JSON.stringify(data, this.options.localTime ? this.localTimeReplacer : null)
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {number} value
     * @param {string} tableName?
     * @param tableName
     */ ODataAdaptor.prototype.remove = function(dm, keyField, value, tableName) {
        var url;
        if (typeof value === "string" && !(0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(value)) url = "('" + value + "')";
        else url = "(" + value + ")";
        return {
            type: "DELETE",
            url: (dm.dataSource.removeUrl || dm.dataSource.url).replace(/\/*$/, tableName ? "/" + tableName : "") + url
        };
    };
    /**
     * Updates existing record and saves the changes to the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName?
     * @param tableName
     * @param query
     * @param original
     * @returns this
     */ ODataAdaptor.prototype.update = function(dm, keyField, value, tableName, query, original) {
        if (this.options.updateType === "PATCH" && !(0, $3EnZW.isNullOrUndefined)(original)) value = this.compareAndRemove(value, original, keyField);
        var url;
        if (typeof value[keyField] === "string" && !(0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(value[keyField])) url = "('" + value[keyField] + "')";
        else url = "(" + value[keyField] + ")";
        return {
            type: this.options.updateType,
            url: (dm.dataSource.updateUrl || dm.dataSource.url).replace(/\/*$/, tableName ? "/" + tableName : "") + url,
            data: JSON.stringify(value, this.options.localTime ? this.localTimeReplacer : null),
            accept: this.options.accept
        };
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     *
     * @param {DataManager} dm
     * @param {CrudOptions} changes
     * @param {RemoteArgs} e
     * @param query
     * @param original
     * @returns {Object}
     */ ODataAdaptor.prototype.batchRequest = function(dm, changes, e, query, original) {
        var initialGuid = e.guid = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getGuid(this.options.batchPre);
        var url = dm.dataSource.batchUrl || this.rootUrl ? (dm.dataSource.batchUrl || this.rootUrl) + "/" + this.options.batch : (dm.dataSource.batchUrl || dm.dataSource.url).replace(/\/*$/, "/" + this.options.batch);
        e.url = this.resourceTableName ? this.resourceTableName : e.url;
        var args = {
            url: e.url,
            key: e.key,
            cid: 1,
            cSet: (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getGuid(this.options.changeSet)
        };
        var req = "--" + initialGuid + "\n";
        req += "Content-Type: multipart/mixed; boundary=" + args.cSet.replace("--", "") + "\n";
        this.pvt.changeSet = 0;
        req += this.generateInsertRequest(changes.addedRecords, args, dm);
        req += this.generateUpdateRequest(changes.changedRecords, args, dm, original ? original.changedRecords : []);
        req += this.generateDeleteRequest(changes.deletedRecords, args, dm);
        req += args.cSet + "--\n";
        req += "--" + initialGuid + "--";
        return {
            type: "POST",
            url: url,
            dataType: "json",
            contentType: "multipart/mixed; charset=UTF-8;boundary=" + initialGuid,
            data: req
        };
    };
    /**
     * Generate the string content from the removed records.
     * The result will be send during batch update.
     *
     * @param {Object[]} arr
     * @param {RemoteArgs} e
     * @param dm
     * @returns this
     */ ODataAdaptor.prototype.generateDeleteRequest = function(arr, e, dm) {
        if (!arr) return "";
        var req = "";
        var stat = {
            "method": "DELETE ",
            "url": function(data, i, key) {
                var url = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(key, data[i]);
                if (typeof url === "number" || (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(url)) return "(" + url + ")";
                else if (url instanceof Date) {
                    var dateTime = data[i][key];
                    return "(" + dateTime.toJSON() + ")";
                } else return "('" + url + "')";
            },
            "data": function(data, i) {
                return "";
            }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req + "\n";
    };
    /**
     * Generate the string content from the inserted records.
     * The result will be send during batch update.
     *
     * @param {Object[]} arr
     * @param {RemoteArgs} e
     * @param dm
     */ ODataAdaptor.prototype.generateInsertRequest = function(arr, e, dm) {
        if (!arr) return "";
        var req = "";
        var stat = {
            "method": "POST ",
            "url": function(data, i, key) {
                return "";
            },
            "data": function(data, i) {
                return JSON.stringify(data[i]) + "\n\n";
            }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req;
    };
    /**
     * Generate the string content from the updated records.
     * The result will be send during batch update.
     *
     * @param {Object[]} arr
     * @param {RemoteArgs} e
     * @param dm
     * @param org
     */ ODataAdaptor.prototype.generateUpdateRequest = function(arr, e, dm, org) {
        var _this = this;
        if (!arr) return "";
        var req = "";
        arr.forEach(function(change) {
            return change = _this.compareAndRemove(change, org.filter(function(o) {
                return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(e.key, o) === (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(e.key, change);
            })[0], e.key);
        });
        var stat = {
            "method": this.options.updateType + " ",
            "url": function(data, i, key) {
                if (typeof data[i][key] === "number" || (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(data[i][key])) return "(" + data[i][key] + ")";
                else if (data[i][key] instanceof Date) {
                    var date = data[i][key];
                    return "(" + date.toJSON() + ")";
                } else return "('" + data[i][key] + "')";
            },
            "data": function(data, i) {
                return JSON.stringify(data[i]) + "\n\n";
            }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req;
    };
    ODataAdaptor.getField = function(prop) {
        return prop.replace(/\./g, "/");
    };
    ODataAdaptor.prototype.generateBodyContent = function(arr, e, stat, dm) {
        var req = "";
        for(var i = 0; i < arr.length; i++){
            req += "\n" + e.cSet + "\n";
            req += this.options.changeSetContent + "\n\n";
            req += stat.method;
            if (stat.method === "POST ") req += (dm.dataSource.insertUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + " HTTP/1.1\n";
            else if (stat.method === "PUT " || stat.method === "PATCH ") req += (dm.dataSource.updateUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + " HTTP/1.1\n";
            else if (stat.method === "DELETE ") req += (dm.dataSource.removeUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + " HTTP/1.1\n";
            req += "Accept: " + this.options.accept + "\n";
            req += "Content-Id: " + this.pvt.changeSet++ + "\n";
            req += this.options.batchChangeSetContentType + "\n";
            if (!(0, $3EnZW.isNullOrUndefined)(arr[i]["@odata.etag"])) {
                req += "If-Match: " + arr[i]["@odata.etag"] + "\n\n";
                delete arr[i]["@odata.etag"];
            } else req += "\n";
            req += stat.data(arr, i);
        }
        return req;
    };
    ODataAdaptor.prototype.processBatchResponse = function(data, query, xhr, request, changes) {
        if (xhr && xhr.headers.get("Content-Type") && xhr.headers.get("Content-Type").indexOf("xml") !== -1) return query.isCountRequired ? {
            result: [],
            count: 0
        } : [];
        if (request && this.options.batch && (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(request.url, this.options.batch) && request.type.toLowerCase() === "post") {
            var guid = xhr.headers.get("Content-Type");
            var cIdx = void 0;
            var jsonObj = void 0;
            var d = data + "";
            guid = guid.substring(guid.indexOf("=batchresponse") + 1);
            d = d.split(guid);
            if (d.length < 2) return {};
            d = d[1];
            var exVal = /(?:\bContent-Type.+boundary=)(changesetresponse.+)/i.exec(d);
            if (exVal) d.replace(exVal[0], "");
            var changeGuid = exVal ? exVal[1] : "";
            d = d.split(changeGuid);
            for(var i = d.length; i > -1; i--){
                if (!/\bContent-ID:/i.test(d[i]) || !/\bHTTP.+201/.test(d[i])) continue;
                cIdx = parseInt(/\bContent-ID: (\d+)/i.exec(d[i])[1], 10);
                if (changes.addedRecords[cIdx]) {
                    jsonObj = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(/^\{.+\}/m.exec(d[i])[0]);
                    (0, $3EnZW.extend)({}, changes.addedRecords[cIdx], this.processResponse(jsonObj));
                }
            }
            return changes;
        }
        return null;
    };
    ODataAdaptor.prototype.compareAndRemove = function(data, original, key) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(original)) return data;
        Object.keys(data).forEach(function(prop) {
            if (prop !== key && prop !== "@odata.etag") {
                if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isPlainObject(data[prop])) {
                    _this.compareAndRemove(data[prop], original[prop]);
                    var final = Object.keys(data[prop]).filter(function(data) {
                        return data !== "@odata.etag";
                    });
                    if (final.length === 0) delete data[prop];
                } else if (data[prop] === original[prop]) delete data[prop];
                else if (data[prop] && original[prop] && data[prop].valueOf() === original[prop].valueOf()) delete data[prop];
            }
        });
        return data;
    };
    return ODataAdaptor;
}($e1170102ff02b3b7$export$b011aea473980a2d);
/**
 * The OData v4 is an improved version of OData protocols.
 * The DataManager uses the ODataV4Adaptor to consume OData v4 services.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$9f728b00627a401e = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(ODataV4Adaptor, _super);
    function ODataV4Adaptor(props) {
        var _this = _super.call(this, props) || this;
        // options replaced the default adaptor options
        _this.options = (0, $3EnZW.extend)({}, _this.options, {
            requestType: "get",
            accept: "application/json, text/javascript, */*; q=0.01",
            multipartAccept: "multipart/mixed",
            sortBy: "$orderby",
            select: "$select",
            skip: "$skip",
            take: "$top",
            count: "$count",
            search: "$search",
            where: "$filter",
            expand: "$expand",
            batch: "$batch",
            changeSet: "--changeset_",
            batchPre: "batch_",
            contentId: "Content-Id: ",
            batchContent: "Content-Type: multipart/mixed; boundary=",
            changeSetContent: "Content-Type: application/http\nContent-Transfer-Encoding: binary ",
            batchChangeSetContentType: "Content-Type: application/json; charset=utf-8 ",
            updateType: "PATCH",
            localTime: false,
            apply: "$apply"
        });
        (0, $3EnZW.extend)(_this.options, props || {});
        return _this;
    }
    /**
     * @hidden
     */ ODataV4Adaptor.prototype.getModuleName = function() {
        return "ODataV4Adaptor";
    };
    /**
     * Returns the query string which requests total count from the data source.
     *
     * @param  {boolean} e
     * @returns string
     */ ODataV4Adaptor.prototype.onCount = function(e) {
        return e === true ? "true" : "";
    };
    /**
     * Generate request string based on the filter criteria from query.
     *
     * @param {Predicate} pred
     * @param {boolean} requiresCast?
     * @param predicate
     * @param query
     * @param requiresCast
     */ ODataV4Adaptor.prototype.onPredicate = function(predicate, query, requiresCast) {
        var returnValue = "";
        var val = predicate.value;
        var isDate = val instanceof Date;
        if (query instanceof (0, $56262f229d1cff45$export$62297b13309008b2)) {
            var queries = this.getQueryRequest(query);
            for(var i = 0; i < queries.filters.length; i++)if (queries.filters[i].e.key === predicate.value) requiresCast = true;
        }
        returnValue = _super.prototype.onPredicate.call(this, predicate, query, requiresCast);
        if (isDate) returnValue = returnValue.replace(/datetime'(.*)'$/, "$1");
        if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(val)) returnValue = returnValue.replace("guid", "").replace(/'/g, "");
        return returnValue;
    };
    /**
     * Generate query string based on the multiple search criteria from query.
     *
     * @param e
     * @param {string} operator
     * @param {string} key
     * @param {boolean} } ignoreCase
     * @param e.fields
     * @param e.operator
     * @param e.key
     * @param e.ignoreCase
     */ ODataV4Adaptor.prototype.onEachSearch = function(e) {
        var search = this.pvt.searches || [];
        search.push(e.key);
        this.pvt.searches = search;
    };
    /**
     *  Generate query string based on the search criteria from query.
     *
     * @param  {Object} e
     */ ODataV4Adaptor.prototype.onSearch = function(e) {
        return this.pvt.searches.join(" OR ");
    };
    /**
     * Returns the expand query string.
     *
     * @param {string} e
     * @param e.selects
     * @param e.expands
     */ ODataV4Adaptor.prototype.onExpand = function(e) {
        var _this = this;
        var selected = {};
        var expanded = {};
        var expands = e.expands.slice();
        var exArr = [];
        var selects = e.selects.filter(function(item) {
            return item.indexOf(".") > -1;
        });
        selects.forEach(function(select) {
            var splits = select.split(".");
            if (!(splits[0] in selected)) selected[splits[0]] = [];
            if (splits.length === 2) {
                if (selected[splits[0]].length && Object.keys(selected).indexOf(splits[0]) !== -1) {
                    if (selected[splits[0]][0].indexOf("$expand") !== -1 && selected[splits[0]][0].indexOf(";$select=") === -1) selected[splits[0]][0] = selected[splits[0]][0] + ";" + "$select=" + splits[1];
                    else selected[splits[0]][0] = selected[splits[0]][0] + "," + splits[1];
                } else selected[splits[0]].push("$select=" + splits[1]);
            } else {
                var sel = "$select=" + splits[splits.length - 1];
                var exp = "";
                var close_1 = "";
                for(var i = 1; i < splits.length - 1; i++){
                    exp = exp + "$expand=" + splits[i] + "(";
                    close_1 = close_1 + ")";
                }
                var combineVal = exp + sel + close_1;
                if (selected[splits[0]].length && Object.keys(selected).indexOf(splits[0]) !== -1 && _this.expandQueryIndex(selected[splits[0]], true)) {
                    var idx = _this.expandQueryIndex(selected[splits[0]]);
                    selected[splits[0]][idx] = selected[splits[0]][idx] + combineVal.replace("$expand=", ",");
                } else selected[splits[0]].push(combineVal);
            }
        });
        //Auto expand from select query
        Object.keys(selected).forEach(function(expand) {
            if (expands.indexOf(expand) === -1) expands.push(expand);
        });
        expands.forEach(function(expand) {
            expanded[expand] = expand in selected ? expand + "(" + selected[expand].join(";") + ")" : expand;
        });
        Object.keys(expanded).forEach(function(ex) {
            return exArr.push(expanded[ex]);
        });
        return exArr.join(",");
    };
    ODataV4Adaptor.prototype.expandQueryIndex = function(query, isExpand) {
        for(var i = 0; i < query.length; i++){
            if (query[i].indexOf("$expand") !== -1) return isExpand ? true : i;
        }
        return isExpand ? false : 0;
    };
    /**
     * Returns the groupby query string.
     *
     * @param {string} e
     * @param distinctFields
     */ ODataV4Adaptor.prototype.onDistinct = function(distinctFields) {
        var fields = distinctFields.map(function(field) {
            return $e1170102ff02b3b7$export$b1cc6088a1ba4742.getField(field);
        }).join(",");
        return "groupby((" + fields + "))";
    };
    /**
     * Returns the select query string.
     *
     * @param  {string[]} e
     */ ODataV4Adaptor.prototype.onSelect = function(e) {
        return _super.prototype.onSelect.call(this, e.filter(function(item) {
            return item.indexOf(".") === -1;
        }));
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     *
     * @param  {DataManager} dm
     * @param  {Request} request
     * @param  {Fetch} settings
     * @returns void
     */ ODataV4Adaptor.prototype.beforeSend = function(dm, request, settings) {
        if (settings.type === "POST" || settings.type === "PUT" || settings.type === "PATCH") request.headers.set("Prefer", "return=representation");
        request.headers.set("Accept", this.options.accept);
    };
    /**
     * Returns the data from the query processing.
     *
     * @param {DataResult} data
     * @param {DataOptions} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Fetch} request?
     * @param {CrudOptions} changes?
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @param changes
     * @returns aggregateResult
     */ ODataV4Adaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes) {
        var metaName = "@odata.context";
        var metaV4Name = "@context";
        if (request && request.type === "GET" && !this.rootUrl && (data[metaName] || data[metaV4Name])) {
            var dataUrl = data[metaName] ? data[metaName].split("/$metadata#") : data[metaV4Name].split("/$metadata#");
            this.rootUrl = dataUrl[0];
            this.resourceTableName = dataUrl[1];
        }
        var pvtData = "pvtData";
        var pvt = request && request[pvtData];
        var emptyAndBatch = _super.prototype.processBatchResponse.call(this, data, query, xhr, request, changes);
        if (emptyAndBatch) return emptyAndBatch;
        var count = null;
        var dataCount = "@odata.count";
        var dataV4Count = "@count";
        if (query && query.isCountRequired) {
            if (dataCount in data) count = data[dataCount];
            else if (dataV4Count in data) count = data[dataV4Count];
        }
        data = !(0, $3EnZW.isNullOrUndefined)(data.value) ? data.value : data;
        var args = {};
        args.count = count;
        args.result = data;
        this.getAggregateResult(pvt, data, args, null, query);
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(count) ? args.result : {
            result: args.result,
            count: count,
            aggregates: args.aggregates
        };
    };
    return ODataV4Adaptor;
}($e1170102ff02b3b7$export$b1cc6088a1ba4742);
/**
 * The Web API is a programmatic interface to define the request and response messages system that is mostly exposed in JSON or XML.
 * The DataManager uses the WebApiAdaptor to consume Web API.
 * Since this adaptor is targeted to interact with Web API created using OData endpoint, it is extended from ODataAdaptor
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$9e9267b141a15a32 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(WebApiAdaptor, _super);
    function WebApiAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebApiAdaptor.prototype.getModuleName = function() {
        return "WebApiAdaptor";
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     *
     * @param {DataManager} dm
     * @param {Object} data
     * @param {string} tableName?
     * @param tableName
     */ WebApiAdaptor.prototype.insert = function(dm, data, tableName) {
        return {
            type: "POST",
            url: dm.dataSource.url,
            data: JSON.stringify(data)
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {number} value
     * @param {string} tableName?
     * @param tableName
     */ WebApiAdaptor.prototype.remove = function(dm, keyField, value, tableName) {
        return {
            type: "DELETE",
            url: dm.dataSource.url + "/" + value,
            data: JSON.stringify(value)
        };
    };
    /**
     * Prepare and return request body which is used to update record.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName?
     * @param tableName
     */ WebApiAdaptor.prototype.update = function(dm, keyField, value, tableName) {
        return {
            type: "PUT",
            url: dm.dataSource.url,
            data: JSON.stringify(value)
        };
    };
    WebApiAdaptor.prototype.batchRequest = function(dm, changes, e) {
        var _this = this;
        var initialGuid = e.guid = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getGuid(this.options.batchPre);
        var url = dm.dataSource.url.replace(/\/*$/, "/" + this.options.batch);
        e.url = this.resourceTableName ? this.resourceTableName : e.url;
        var req = [];
        var _loop_1 = function(i, x) {
            changes.addedRecords.forEach(function(j, d) {
                var stat = {
                    "method": "POST ",
                    "url": function(data, i, key) {
                        return "";
                    },
                    "data": function(data, i) {
                        return JSON.stringify(data[i]) + "\n\n";
                    }
                };
                req.push("--" + initialGuid);
                req.push("Content-Type: application/http; msgtype=request", "");
                req.push("POST /api/" + (dm.dataSource.insertUrl || dm.dataSource.crudUrl || e.url) + stat.url(changes.addedRecords, i, e.key) + " HTTP/1.1");
                req.push("Content-Type: application/json; charset=utf-8");
                req.push("Host: " + location.host);
                req.push("", j ? JSON.stringify(j) : "");
            });
        };
        //insertion
        for(var i = 0, x = changes.addedRecords.length; i < x; i++)_loop_1(i, x);
        var _loop_2 = function(i, x) {
            changes.changedRecords.forEach(function(j, d) {
                var stat = {
                    "method": _this.options.updateType + " ",
                    "url": function(data, i, key) {
                        return "";
                    },
                    "data": function(data, i) {
                        return JSON.stringify(data[i]) + "\n\n";
                    }
                };
                req.push("--" + initialGuid);
                req.push("Content-Type: application/http; msgtype=request", "");
                req.push("PUT /api/" + (dm.dataSource.updateUrl || dm.dataSource.crudUrl || e.url) + stat.url(changes.changedRecords, i, e.key) + " HTTP/1.1");
                req.push("Content-Type: application/json; charset=utf-8");
                req.push("Host: " + location.host);
                req.push("", j ? JSON.stringify(j) : "");
            });
        };
        //updation
        for(var i = 0, x = changes.changedRecords.length; i < x; i++)_loop_2(i, x);
        var _loop_3 = function(i, x) {
            changes.deletedRecords.forEach(function(j, d) {
                var state = {
                    "mtd": "DELETE ",
                    "url": function(data, i, key) {
                        var url = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(key, data[i]);
                        if (typeof url === "number" || (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.isGuid(url)) return "/" + url;
                        else if (url instanceof Date) {
                            var datTime = data[i][key];
                            return "/" + datTime.toJSON();
                        } else return "/'" + url + "'";
                    },
                    "data": function(data, i) {
                        return "";
                    }
                };
                req.push("--" + initialGuid);
                req.push("Content-Type: application/http; msgtype=request", "");
                req.push("DELETE /api/" + (dm.dataSource.removeUrl || dm.dataSource.crudUrl || e.url) + state.url(changes.deletedRecords, i, e.key) + " HTTP/1.1");
                req.push("Content-Type: application/json; charset=utf-8");
                req.push("Host: " + location.host);
                req.push("", j ? JSON.stringify(j) : "");
            });
        };
        //deletion
        for(var i = 0, x = changes.deletedRecords.length; i < x; i++)_loop_3(i, x);
        req.push("--" + initialGuid + "--", "");
        return {
            type: "POST",
            url: url,
            contentType: "multipart/mixed; boundary=" + initialGuid,
            data: req.join("\r\n")
        };
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     *
     * @param  {DataManager} dm
     * @param  {Request} request
     * @param  {Fetch} settings
     * @returns void
     */ WebApiAdaptor.prototype.beforeSend = function(dm, request, settings) {
        request.headers.set("Accept", "application/json, text/javascript, */*; q=0.01");
    };
    /**
     * Returns the data from the query processing.
     *
     * @param {DataResult} data
     * @param {DataOptions} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Fetch} request?
     * @param {CrudOptions} changes?
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @param changes
     * @returns aggregateResult
     */ WebApiAdaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes) {
        var pvtData = "pvtData";
        var pvt = request && request[pvtData];
        var count = null;
        var args = {};
        if (request && request.type.toLowerCase() !== "post") {
            var versionCheck = xhr && request.fetchRequest.headers.get("DataServiceVersion");
            var version = versionCheck && parseInt(versionCheck, 10) || 2;
            if (query && query.isCountRequired) {
                if (!(0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(data.Count)) count = data.Count;
            }
            if (version < 3 && data.Items) data = data.Items;
            args.count = count;
            args.result = data;
            this.getAggregateResult(pvt, data, args, null, query);
        }
        args.result = args.result || data;
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).isNull(count) ? args.result : {
            result: args.result,
            count: args.count,
            aggregates: args.aggregates
        };
    };
    return WebApiAdaptor;
}($e1170102ff02b3b7$export$b1cc6088a1ba4742);
/**
 * WebMethodAdaptor can be used by DataManager to interact with web method.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$e586cd52911ccf4f = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(WebMethodAdaptor, _super);
    function WebMethodAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Prepare the request body based on the query.
     * The query information can be accessed at the WebMethod using variable named `value`.
     *
     * @param {DataManager} dm
     * @param {Query} query
     * @param {Object[]} hierarchyFilters?
     * @param hierarchyFilters
     * @returns application
     */ WebMethodAdaptor.prototype.processQuery = function(dm, query, hierarchyFilters) {
        var obj = new $e1170102ff02b3b7$export$b011aea473980a2d().processQuery(dm, query, hierarchyFilters);
        var getData = "data";
        var data = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(obj[getData]);
        var result = {};
        var value = "value";
        if (data.param) for(var i = 0; i < data.param.length; i++){
            var param = data.param[i];
            var key = Object.keys(param)[0];
            result[key] = param[key];
        }
        result[value] = data;
        var pvtData = "pvtData";
        var url = "url";
        return {
            data: JSON.stringify(result, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.jsonDateReplacer),
            url: obj[url],
            pvtData: obj[pvtData],
            type: "POST",
            contentType: "application/json; charset=utf-8"
        };
    };
    return WebMethodAdaptor;
}($e1170102ff02b3b7$export$b011aea473980a2d);
/**
 * RemoteSaveAdaptor, extended from JsonAdaptor and it is used for binding local data and performs all DataManager queries in client-side.
 * It interacts with server-side only for CRUD operations.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$90859058788a17cf = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(RemoteSaveAdaptor, _super);
    /**
     * @hidden
     */ function RemoteSaveAdaptor() {
        var _this = _super.call(this) || this;
        (0, $3EnZW.setValue)("beforeSend", $e1170102ff02b3b7$export$b011aea473980a2d.prototype.beforeSend, _this);
        return _this;
    }
    RemoteSaveAdaptor.prototype.insert = function(dm, data, tableName, query, position) {
        this.pvt.position = position;
        this.updateType = "add";
        return {
            url: dm.dataSource.insertUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                value: data,
                table: tableName,
                action: "insert"
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.remove = function(dm, keyField, val, tableName, query) {
        _super.prototype.remove.call(this, dm, keyField, val);
        return {
            type: "POST",
            url: dm.dataSource.removeUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                key: val,
                keyColumn: keyField,
                table: tableName,
                action: "remove"
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.update = function(dm, keyField, val, tableName, query) {
        this.updateType = "update";
        this.updateKey = keyField;
        return {
            type: "POST",
            url: dm.dataSource.updateUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                value: val,
                action: "update",
                keyColumn: keyField,
                key: val[keyField],
                table: tableName
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes, e) {
        var i;
        var newData = request ? JSON.parse(request.data) : data;
        data = newData.action === "batch" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(data) : data;
        if (this.updateType === "add") _super.prototype.insert.call(this, ds, data, null, null, this.pvt.position);
        if (this.updateType === "update") _super.prototype.update.call(this, ds, this.updateKey, data);
        this.updateType = undefined;
        if (data.added) for(i = 0; i < data.added.length; i++)_super.prototype.insert.call(this, ds, data.added[i]);
        if (data.changed) for(i = 0; i < data.changed.length; i++)_super.prototype.update.call(this, ds, e.key, data.changed[i]);
        if (data.deleted) for(i = 0; i < data.deleted.length; i++)_super.prototype.remove.call(this, ds, e.key, data.deleted[i]);
        return data;
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * Also perform the changes in the locally cached data to sync with the remote data.
     * The result is used by the batch request.
     *
     * @param {DataManager} dm
     * @param {CrudOptions} changes
     * @param {RemoteArgs} e
     * @param query
     * @param original
     */ RemoteSaveAdaptor.prototype.batchRequest = function(dm, changes, e, query, original) {
        return {
            type: "POST",
            url: dm.dataSource.batchUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify((0, $3EnZW.extend)({}, {
                changed: changes.changedRecords,
                added: changes.addedRecords,
                deleted: changes.deletedRecords,
                action: "batch",
                table: e.url,
                key: e.key
            }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.addParams = function(options) {
        var urlParams = new $e1170102ff02b3b7$export$b011aea473980a2d();
        urlParams.addParams(options);
    };
    return RemoteSaveAdaptor;
}($e1170102ff02b3b7$export$650eb66a1d9d6599);
/**
 * Fetch Adaptor that is extended from URL Adaptor, is used for handle data operations with user defined functions.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$1619bf00353f7597 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(CustomDataAdaptor, _super);
    function CustomDataAdaptor(props) {
        var _this = _super.call(this) || this;
        // options replaced the default adaptor options
        _this.options = (0, $3EnZW.extend)({}, _this.options, {
            getData: function() {},
            addRecord: function() {},
            updateRecord: function() {},
            deleteRecord: function() {},
            batchUpdate: function() {}
        });
        (0, $3EnZW.extend)(_this.options, props || {});
        return _this;
    }
    CustomDataAdaptor.prototype.getModuleName = function() {
        return "CustomDataAdaptor";
    };
    return CustomDataAdaptor;
}($e1170102ff02b3b7$export$b011aea473980a2d);
/**
 * The GraphqlAdaptor that is extended from URL Adaptor, is used for retrieving data from the Graphql server.
 * It interacts with the Graphql server with all the DataManager Queries and performs CRUD operations.
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$44ca12c2060951f8 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(GraphQLAdaptor, _super);
    function GraphQLAdaptor(options) {
        var _this = _super.call(this) || this;
        _this.opt = options;
        _this.schema = _this.opt.response;
        _this.query = _this.opt.query;
        /* eslint-disable @typescript-eslint/no-empty-function */ // tslint:disable-next-line:no-empty
        _this.getVariables = _this.opt.getVariables ? _this.opt.getVariables : function() {};
        /* eslint-enable @typescript-eslint/no-empty-function */ _this.getQuery = function() {
            return _this.query;
        };
        return _this;
    }
    GraphQLAdaptor.prototype.getModuleName = function() {
        return "GraphQLAdaptor";
    };
    /**
     * Process the JSON data based on the provided queries.
     *
     * @param {DataManager} dm
     * @param {Query} query?
     * @param datamanager
     * @param query
     */ GraphQLAdaptor.prototype.processQuery = function(datamanager, query) {
        var urlQuery = _super.prototype.processQuery.apply(this, arguments);
        var dm = JSON.parse(urlQuery.data);
        // constructing GraphQL parameters
        var keys = [
            "skip",
            "take",
            "sorted",
            "table",
            "select",
            "where",
            "search",
            "requiresCounts",
            "aggregates",
            "params"
        ];
        var temp = {};
        var str = "searchwhereparams";
        keys.filter(function(e) {
            temp[e] = str.indexOf(e) > -1 ? JSON.stringify(dm[e]) : dm[e];
        });
        var vars = this.getVariables() || {};
        // tslint:disable-next-line:no-string-literal
        vars["datamanager"] = temp;
        var data = JSON.stringify({
            query: this.getQuery(),
            variables: vars
        });
        urlQuery.data = data;
        return urlQuery;
    };
    /**
     * Returns the data from the query processing.
     * It will also cache the data for later usage.
     *
     * @param {DataResult} data
     * @param {DataManager} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Object} request?
     * @param resData
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @returns DataResult
     */ GraphQLAdaptor.prototype.processResponse = function(resData, ds, query, xhr, request) {
        var res = resData;
        var count;
        var aggregates;
        var result = (0, $3EnZW.getValue)(this.schema.result, res.data);
        if (this.schema.count) count = (0, $3EnZW.getValue)(this.schema.count, res.data);
        if (this.schema.aggregates) {
            aggregates = (0, $3EnZW.getValue)(this.schema.aggregates, res.data);
            aggregates = !(0, $3EnZW.isNullOrUndefined)(aggregates) ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(aggregates) : aggregates;
        }
        var pvt = request.pvtData || {};
        var args = {
            result: result,
            aggregates: aggregates
        };
        var data = args;
        if (pvt && pvt.groups && pvt.groups.length) this.getAggregateResult(pvt, data, args, null, query);
        return !(0, $3EnZW.isNullOrUndefined)(count) ? {
            result: args.result,
            count: count,
            aggregates: aggregates
        } : args.result;
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     */ GraphQLAdaptor.prototype.insert = function() {
        var inserted = _super.prototype.insert.apply(this, arguments);
        return this.generateCrudData(inserted, "insert");
    };
    /**
     * Prepare and returns request body which is used to update a new record in the table.
     */ GraphQLAdaptor.prototype.update = function() {
        var inserted = _super.prototype.update.apply(this, arguments);
        return this.generateCrudData(inserted, "update");
    };
    /**
     * Prepare and returns request body which is used to remove a new record in the table.
     */ GraphQLAdaptor.prototype.remove = function() {
        var inserted = _super.prototype.remove.apply(this, arguments);
        return this.generateCrudData(inserted, "remove");
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     *
     * @param {DataManager} dm
     * @param {CrudOptions} changes
     * @param {Object} e
     * @param e.key
     * @param {Query} query
     * @param {Object} original
     */ GraphQLAdaptor.prototype.batchRequest = function(dm, changes, e, query, original) {
        var batch = _super.prototype.batchRequest.apply(this, arguments);
        // tslint:disable-next-line:typedef
        var bData = JSON.parse(batch.data);
        bData.key = e.key;
        batch.data = JSON.stringify(bData);
        return this.generateCrudData(batch, "batch");
    };
    GraphQLAdaptor.prototype.generateCrudData = function(crudData, action) {
        var parsed = JSON.parse(crudData.data);
        crudData.data = JSON.stringify({
            query: this.opt.getMutation(action),
            variables: parsed
        });
        return crudData;
    };
    return GraphQLAdaptor;
}($e1170102ff02b3b7$export$b011aea473980a2d);
/**
 * Cache Adaptor is used to cache the data of the visited pages. It prevents new requests for the previously visited pages.
 * You can configure cache page size and duration of caching by using cachingPageSize and timeTillExpiration properties of the DataManager
 *
 * @hidden
 */ var $e1170102ff02b3b7$export$e2a2feb26dbf8c19 = /** @class */ function(_super) {
    $e1170102ff02b3b7$var$__extends(CacheAdaptor, _super);
    /**
     * Constructor for CacheAdaptor class.
     *
     * @param {CacheAdaptor} adaptor?
     * @param {number} timeStamp?
     * @param {number} pageSize?
     * @param adaptor
     * @param timeStamp
     * @param pageSize
     * @hidden
     */ function CacheAdaptor(adaptor, timeStamp, pageSize) {
        var _this = _super.call(this) || this;
        _this.isCrudAction = false;
        _this.isInsertAction = false;
        if (!(0, $3EnZW.isNullOrUndefined)(adaptor)) _this.cacheAdaptor = adaptor;
        _this.pageSize = pageSize;
        _this.guidId = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getGuid("cacheAdaptor");
        var obj = {
            keys: [],
            results: []
        };
        window.localStorage.setItem(_this.guidId, JSON.stringify(obj));
        var guid = _this.guidId;
        if (!(0, $3EnZW.isNullOrUndefined)(timeStamp)) setInterval(function() {
            var data = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(window.localStorage.getItem(guid));
            var forDel = [];
            for(var i = 0; i < data.results.length; i++){
                var currentTime = +new Date();
                var requestTime = +new Date(data.results[i].timeStamp);
                data.results[i].timeStamp = currentTime - requestTime;
                if (currentTime - requestTime > timeStamp) forDel.push(i);
            }
            for(var i = 0; i < forDel.length; i++){
                data.results.splice(forDel[i], 1);
                data.keys.splice(forDel[i], 1);
            }
            window.localStorage.removeItem(guid);
            window.localStorage.setItem(guid, JSON.stringify(data));
        }, timeStamp);
        return _this;
    }
    /**
     * It will generate the key based on the URL when we send a request to server.
     *
     * @param {string} url
     * @param {Query} query?
     * @param query
     * @hidden
     */ CacheAdaptor.prototype.generateKey = function(url, query) {
        var queries = this.getQueryRequest(query);
        var singles = (0, $56262f229d1cff45$export$62297b13309008b2).filterQueryLists(query.queries, [
            "onSelect",
            "onPage",
            "onSkip",
            "onTake",
            "onRange"
        ]);
        var key = url;
        var page = "onPage";
        if (page in singles) key += singles[page].pageIndex;
        queries.sorts.forEach(function(obj) {
            key += obj.e.direction + obj.e.fieldName;
        });
        queries.groups.forEach(function(obj) {
            key += obj.e.fieldName;
        });
        queries.searches.forEach(function(obj) {
            key += obj.e.searchKey;
        });
        for(var filter = 0; filter < queries.filters.length; filter++){
            var currentFilter = queries.filters[filter];
            if (currentFilter.e.isComplex) {
                var newQuery = query.clone();
                newQuery.queries = [];
                for(var i = 0; i < currentFilter.e.predicates.length; i++)newQuery.queries.push({
                    fn: "onWhere",
                    e: currentFilter.e.predicates[i],
                    filter: query.queries.filter
                });
                key += currentFilter.e.condition + this.generateKey(url, newQuery);
            } else key += currentFilter.e.field + currentFilter.e.operator + currentFilter.e.value;
        }
        return key;
    };
    /**
     * Process the query to generate request body.
     * If the data is already cached, it will return the cached data.
     *
     * @param {DataManager} dm
     * @param {Query} query?
     * @param {Object[]} hierarchyFilters?
     * @param query
     * @param hierarchyFilters
     */ CacheAdaptor.prototype.processQuery = function(dm, query, hierarchyFilters) {
        var key = this.generateKey(dm.dataSource.url, query);
        var cachedItems = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(window.localStorage.getItem(this.guidId));
        var data = cachedItems ? cachedItems.results[cachedItems.keys.indexOf(key)] : null;
        if (data != null && !this.isCrudAction && !this.isInsertAction) return data;
        this.isCrudAction = null;
        this.isInsertAction = null;
        /* eslint-disable prefer-spread */ return this.cacheAdaptor.processQuery.apply(this.cacheAdaptor, [].slice.call(arguments, 0));
    /* eslint-enable prefer-spread */ };
    /**
     * Returns the data from the query processing.
     * It will also cache the data for later usage.
     *
     * @param {DataResult} data
     * @param {DataManager} ds?
     * @param {Query} query?
     * @param {Request} xhr?
     * @param {Fetch} request?
     * @param {CrudOptions} changes?
     * @param ds
     * @param query
     * @param xhr
     * @param request
     * @param changes
     */ CacheAdaptor.prototype.processResponse = function(data, ds, query, xhr, request, changes) {
        if (this.isInsertAction || request && this.cacheAdaptor.options.batch && (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(request.url, this.cacheAdaptor.options.batch) && request.type.toLowerCase() === "post") return this.cacheAdaptor.processResponse(data, ds, query, xhr, request, changes);
        /* eslint-disable prefer-spread */ data = this.cacheAdaptor.processResponse.apply(this.cacheAdaptor, [].slice.call(arguments, 0));
        /* eslint-enable prefer-spread */ var key = query ? this.generateKey(ds.dataSource.url, query) : ds.dataSource.url;
        var obj = {};
        obj = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson(window.localStorage.getItem(this.guidId));
        var index = obj.keys.indexOf(key);
        if (index !== -1) {
            obj.results.splice(index, 1);
            obj.keys.splice(index, 1);
        }
        obj.results[obj.keys.push(key) - 1] = {
            keys: key,
            result: data.result,
            timeStamp: new Date(),
            count: data.count
        };
        while(obj.results.length > this.pageSize){
            obj.results.splice(0, 1);
            obj.keys.splice(0, 1);
        }
        window.localStorage.setItem(this.guidId, JSON.stringify(obj));
        return data;
    };
    /**
     * Method will trigger before send the request to server side. Used to set the custom header or modify the request options.
     *
     * @param {DataManager} dm
     * @param {Request} request
     * @param {Fetch} settings?
     * @param settings
     */ CacheAdaptor.prototype.beforeSend = function(dm, request, settings) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.cacheAdaptor.options.batch) && (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).endsWith(settings.url, this.cacheAdaptor.options.batch) && settings.type.toLowerCase() === "post") request.headers.set("Accept", this.cacheAdaptor.options.multipartAccept);
        if (!dm.dataSource.crossDomain) request.headers.set("Accept", this.cacheAdaptor.options.accept);
    };
    /**
     * Updates existing record and saves the changes to the table.
     *
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName
     */ CacheAdaptor.prototype.update = function(dm, keyField, value, tableName) {
        this.isCrudAction = true;
        return this.cacheAdaptor.update(dm, keyField, value, tableName);
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     *
     * @param {DataManager} dm
     * @param {Object} data
     * @param {string} tableName?
     * @param tableName
     */ CacheAdaptor.prototype.insert = function(dm, data, tableName) {
        this.isInsertAction = true;
        return this.cacheAdaptor.insert(dm, data, tableName);
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     *
     * @param {DataManager} dm
     * @param {string} keyField
     * @param {Object} value
     * @param {string} tableName?
     * @param tableName
     */ CacheAdaptor.prototype.remove = function(dm, keyField, value, tableName) {
        this.isCrudAction = true;
        return this.cacheAdaptor.remove(dm, keyField, value, tableName);
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     *
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     */ CacheAdaptor.prototype.batchRequest = function(dm, changes, e) {
        return this.cacheAdaptor.batchRequest(dm, changes, e);
    };
    return CacheAdaptor;
}($e1170102ff02b3b7$export$b011aea473980a2d);


var $19ee14db620c232e$export$8829c45006c81633;
(function(MemberRole) {
    MemberRole[MemberRole["Staff"] = 0] = "Staff";
    MemberRole[MemberRole["Administrator"] = 1] = "Administrator";
})($19ee14db620c232e$export$8829c45006c81633 || ($19ee14db620c232e$export$8829c45006c81633 = {}));
var $19ee14db620c232e$export$97fd21cceb1e64f3;
(function(CompanyType) {
    CompanyType["LimitedCompany"] = "LimitedCompany";
    CompanyType["LimitedLiabilityPartnership"] = "LimitedLiabilityPartnership";
    CompanyType["SoleTrader"] = "SoleTrader";
    CompanyType["Partnership"] = "Partnership";
})($19ee14db620c232e$export$97fd21cceb1e64f3 || ($19ee14db620c232e$export$97fd21cceb1e64f3 = {}));
var $19ee14db620c232e$export$b32b5fd24133a029;
(function(VatSchedule) {
    VatSchedule[VatSchedule["JanAprJulOct"] = 0] = "JanAprJulOct";
    VatSchedule[VatSchedule["FebMayAugNov"] = 1] = "FebMayAugNov";
    VatSchedule[VatSchedule["MarJunSepDec"] = 2] = "MarJunSepDec";
    VatSchedule[VatSchedule["Monthly"] = 3] = "Monthly";
    VatSchedule[VatSchedule["Yearly"] = 4] = "Yearly";
})($19ee14db620c232e$export$b32b5fd24133a029 || ($19ee14db620c232e$export$b32b5fd24133a029 = {}));
var $19ee14db620c232e$export$a72d92a40abd73d4;
(function(VatDefaultPeriod) {
    VatDefaultPeriod[VatDefaultPeriod["First"] = 0] = "First";
    VatDefaultPeriod[VatDefaultPeriod["Current"] = 1] = "Current";
})($19ee14db620c232e$export$a72d92a40abd73d4 || ($19ee14db620c232e$export$a72d92a40abd73d4 = {}));
var $19ee14db620c232e$export$6753c3448f1fa548;
(function(BookkeepingFrequency) {
    BookkeepingFrequency[BookkeepingFrequency["Weekly"] = 0] = "Weekly";
    BookkeepingFrequency[BookkeepingFrequency["Monthly"] = 1] = "Monthly";
    // WeeklyAndMonthly = 2,
    BookkeepingFrequency[BookkeepingFrequency["Quarterly"] = 3] = "Quarterly";
    BookkeepingFrequency[BookkeepingFrequency["Yearly"] = 4] = "Yearly";
})($19ee14db620c232e$export$6753c3448f1fa548 || ($19ee14db620c232e$export$6753c3448f1fa548 = {}));
var $19ee14db620c232e$export$dea1348d86434c4a;
(function(PayrollFrequency) {
    PayrollFrequency[PayrollFrequency["Weekly"] = 0] = "Weekly";
    PayrollFrequency[PayrollFrequency["Fortnightly"] = 1] = "Fortnightly";
    PayrollFrequency[PayrollFrequency["Monthly"] = 2] = "Monthly";
    // WeeklyAndMonthly = 3,
    PayrollFrequency[PayrollFrequency["Quarterly"] = 4] = "Quarterly";
    PayrollFrequency[PayrollFrequency["Yearly"] = 5] = "Yearly";
})($19ee14db620c232e$export$dea1348d86434c4a || ($19ee14db620c232e$export$dea1348d86434c4a = {}));
var $19ee14db620c232e$export$27a7f855854fa13d;
(function(JobScheduleType) {
    JobScheduleType[JobScheduleType["OneOff"] = 0] = "OneOff";
    // Daily = 1,
    // DailyWorkingDaysOnly = 2,
    JobScheduleType[JobScheduleType["Weekly"] = 3] = "Weekly";
    // TwoWeekly = 4,
    // FourWeekly = 5,
    JobScheduleType[JobScheduleType["Monthly"] = 6] = "Monthly";
    // TwoMonthly = 7,
    JobScheduleType[JobScheduleType["Quarterly"] = 8] = "Quarterly";
    // FourMonthly = 9,
    // SixMonthly = 10,
    JobScheduleType[JobScheduleType["Yearly"] = 11] = "Yearly";
})($19ee14db620c232e$export$27a7f855854fa13d || ($19ee14db620c232e$export$27a7f855854fa13d = {}));
var $19ee14db620c232e$export$61db76a97f26b7e1;
(function(TaskStatus) {
    TaskStatus["Unscheduled"] = "Unscheduled";
    TaskStatus["Scheduled"] = "Scheduled";
    TaskStatus["StartDue"] = "StartDue";
    TaskStatus["Started"] = "Started";
    TaskStatus["CompletionDue"] = "CompletionDue";
    TaskStatus["Completed"] = "Completed";
    TaskStatus["DeadlineDue"] = "DeadlineDue";
})($19ee14db620c232e$export$61db76a97f26b7e1 || ($19ee14db620c232e$export$61db76a97f26b7e1 = {}));
var $19ee14db620c232e$export$63d378a8b71e6d2a;
(function(RecordsStatus) {
    RecordsStatus["Required"] = "Required";
    RecordsStatus["Received"] = "Received";
    RecordsStatus["NotRequired"] = "NotRequired";
})($19ee14db620c232e$export$63d378a8b71e6d2a || ($19ee14db620c232e$export$63d378a8b71e6d2a = {}));
var $19ee14db620c232e$export$8969cfa1402e2c52;
(function(RecurringTaskStatus) {
    RecurringTaskStatus["Scheduled"] = "Scheduled";
    RecurringTaskStatus["Completed"] = "Completed";
})($19ee14db620c232e$export$8969cfa1402e2c52 || ($19ee14db620c232e$export$8969cfa1402e2c52 = {}));
var $19ee14db620c232e$export$4cd8cc03ec8c034a;
(function(ClientType) {
    ClientType["Company"] = "Client";
    ClientType["Individual"] = "Individual";
})($19ee14db620c232e$export$4cd8cc03ec8c034a || ($19ee14db620c232e$export$4cd8cc03ec8c034a = {}));
var $19ee14db620c232e$export$96874393e71880e2;
(function(DueTimeFrameType) {
    DueTimeFrameType["Accounts"] = "Accounts";
    DueTimeFrameType["AmlCheck"] = "AmlCheck";
    DueTimeFrameType["Bookkeeping"] = "Bookkeeping";
    DueTimeFrameType["CisReturn"] = "CisReturn";
    DueTimeFrameType["ConfirmationStatement"] = "ConfirmationStatement";
    DueTimeFrameType["Payroll"] = "Payroll";
    DueTimeFrameType["TaxReturn"] = "TaxReturn";
    DueTimeFrameType["VatReturn"] = "VatReturn";
})($19ee14db620c232e$export$96874393e71880e2 || ($19ee14db620c232e$export$96874393e71880e2 = {}));
var $19ee14db620c232e$export$c3dc51c8ec50c91b;
(function(DueTimeFrame) {
    DueTimeFrame["Overdue"] = "Overdue";
    DueTimeFrame["Due"] = "Due";
    DueTimeFrame["DueToday"] = "DueToday";
    DueTimeFrame["DueTomorrow"] = "DueTomorrow";
    DueTimeFrame["DueThisWeek"] = "DueThisWeek";
    DueTimeFrame["DueNextWeek"] = "DueNextWeek";
    DueTimeFrame["DueThisMonth"] = "DueThisMonth";
    DueTimeFrame["DueNextMonth"] = "DueNextMonth";
    DueTimeFrame["DueMonthAfterNext"] = "DueMonthAfterNext";
    DueTimeFrame["DueWithin30Days"] = "DueWithin30Days";
    DueTimeFrame["DueWithin60Days"] = "DueWithin60Days";
    DueTimeFrame["DueWithin90Days"] = "DueWithin90Days";
    DueTimeFrame["DueWithin30To60Days"] = "DueWithin30To60Days";
    DueTimeFrame["DueWithin60To90Days"] = "DueWithin60To90Days";
})($19ee14db620c232e$export$c3dc51c8ec50c91b || ($19ee14db620c232e$export$c3dc51c8ec50c91b = {}));
var $19ee14db620c232e$export$33312d3da85d8994;
(function(DashboardView) {
    DashboardView["CompanyDeadlines"] = "CompanyDeadlines";
    DashboardView["TaskDeadlines"] = "TaskDeadlines";
})($19ee14db620c232e$export$33312d3da85d8994 || ($19ee14db620c232e$export$33312d3da85d8994 = {}));
var $19ee14db620c232e$export$e727880033120f08;
(function(CompanySmartTaskType) {
    CompanySmartTaskType["AccountsPeriodEnd"] = "AccountsPeriodEnd";
    CompanySmartTaskType["AccountsDue"] = "AccountsDue";
    CompanySmartTaskType["AmlCheckDue"] = "AmlCheckDue";
    CompanySmartTaskType["BookkeepingDue"] = "BookkeepingDue";
    CompanySmartTaskType["CompanyCreated"] = "CompanyCreated";
    CompanySmartTaskType["CisPeriodEnd"] = "CisPeriodEnd";
    CompanySmartTaskType["CisReturnDue"] = "CisReturnDue";
    CompanySmartTaskType["ConfirmationStatementDue"] = "ConfirmationStatementDue";
    CompanySmartTaskType["EngagementSignatureRequired"] = "EngagementSignatureRequired";
    CompanySmartTaskType["PayrollDue"] = "PayrollDue";
    CompanySmartTaskType["TaxPeriodEnd"] = "TaxPeriodEnd";
    CompanySmartTaskType["TaxReturnDue"] = "TaxReturnDue";
    CompanySmartTaskType["TaxPaymentDue"] = "TaxPaymentDue";
    CompanySmartTaskType["VatPeriodEnd"] = "VatPeriodEnd";
    CompanySmartTaskType["VatReturnDue"] = "VatReturnDue";
})($19ee14db620c232e$export$e727880033120f08 || ($19ee14db620c232e$export$e727880033120f08 = {}));
var $19ee14db620c232e$export$c45b9865f25d29ce;
(function(IndividualSmartTaskType) {
    IndividualSmartTaskType["AmlCheckDue"] = "AmlCheckDue";
    IndividualSmartTaskType["EngagementSignatureRequired"] = "EngagementSignatureRequired";
    IndividualSmartTaskType["IndividualCreated"] = "IndividualCreated";
    IndividualSmartTaskType["TaxPeriodEnd"] = "TaxPeriodEnd";
    IndividualSmartTaskType["TaxReturnDue"] = "TaxReturnDue";
})($19ee14db620c232e$export$c45b9865f25d29ce || ($19ee14db620c232e$export$c45b9865f25d29ce = {}));
const $19ee14db620c232e$export$565e37f6a005bc8 = {
    ...$19ee14db620c232e$export$e727880033120f08,
    ...$19ee14db620c232e$export$c45b9865f25d29ce
};
var $19ee14db620c232e$export$2c923b557f7b648e;
(function(CompanyUpdateOnCompletion) {
    CompanyUpdateOnCompletion["AccountsLastMadeUpTo"] = "AccountsLastMadeUpTo";
    CompanyUpdateOnCompletion["AmlLastChecked"] = "AmlLastChecked";
    CompanyUpdateOnCompletion["CisLastMadeUpTo"] = "CisLastMadeUpTo";
    CompanyUpdateOnCompletion["ConfirmationStatementLastMadeUpTo"] = "ConfirmationStatementLastMadeUpTo";
    CompanyUpdateOnCompletion["BookkeepingLastMadeUpTo"] = "BookkeepingLastMadeUpTo";
    CompanyUpdateOnCompletion["EngagementSigned"] = "EngagementSigned";
    CompanyUpdateOnCompletion["PayrollLastMadeUpTo"] = "PayrollLastMadeUpTo";
    CompanyUpdateOnCompletion["TaxReturnLastMadeUpTo"] = "TaxLastMadeUpTo";
    CompanyUpdateOnCompletion["TaxPaymentLastMadeUpTo"] = "TaxLastPaidUpTo";
    CompanyUpdateOnCompletion["VatLastMadeUpTo"] = "VatLastMadeUpTo";
})($19ee14db620c232e$export$2c923b557f7b648e || ($19ee14db620c232e$export$2c923b557f7b648e = {}));
var $19ee14db620c232e$export$560a7575455994fd;
(function(IndividualUpdateOnCompletion) {
    IndividualUpdateOnCompletion["AmlLastChecked"] = "AmlLastChecked";
    IndividualUpdateOnCompletion["EngagementSigned"] = "EngagementSigned";
    IndividualUpdateOnCompletion["TaxReturnLastMadeUpTo"] = "TaxLastMadeUpTo";
})($19ee14db620c232e$export$560a7575455994fd || ($19ee14db620c232e$export$560a7575455994fd = {}));
const $19ee14db620c232e$export$a2d5e26d840f3aaf = {
    ...$19ee14db620c232e$export$2c923b557f7b648e,
    ...$19ee14db620c232e$export$560a7575455994fd
};
var $19ee14db620c232e$export$300334f671c43555;
(function(Priority) {
    // Deferred = 0,
    Priority[Priority["Low"] = 1] = "Low";
    Priority[Priority["Medium"] = 2] = "Medium";
    Priority[Priority["High"] = 3] = "High";
})($19ee14db620c232e$export$300334f671c43555 || ($19ee14db620c232e$export$300334f671c43555 = {}));


const $bc9d09886380ca07$var$route = (...parts)=>"/" + parts.filter((part)=>part).map((part)=>part).map((part)=>part.startsWith("/") ? part.substring(1) : part).join("/");
const $bc9d09886380ca07$var$resourceRoute = (resource, resourceOptions)=>{
    return {
        list: (params)=>$bc9d09886380ca07$var$route(resourceOptions?.prefix, resource, resourceOptions?.archivable && (!params ? ":archived(archived)?" : params.archived && "archived")),
        create: ()=>$bc9d09886380ca07$var$route(resourceOptions?.prefix, resource, "new"),
        edit: (params)=>$bc9d09886380ca07$var$route(resourceOptions?.prefix, resource, !params ? ":id" : params.id)
    };
};
const $bc9d09886380ca07$export$66b32f6f30eb4b4 = {
    root: ()=>$bc9d09886380ca07$var$route(""),
    home: ()=>$bc9d09886380ca07$var$route("home"),
    successStories: {
        list: ()=>$bc9d09886380ca07$var$route("success-stories"),
        view: (params)=>$bc9d09886380ca07$var$route("success-stories", !params ? ":id" : params.id)
    },
    signUp: ()=>$bc9d09886380ca07$var$route("sign-up"),
    signIn: ()=>$bc9d09886380ca07$var$route("sign-in"),
    signInVerify: ()=>$bc9d09886380ca07$var$route("sign-in/verify"),
    signOut: ()=>$bc9d09886380ca07$var$route("sign-out"),
    trial: ()=>$bc9d09886380ca07$var$route("trial"),
    subscribe: ()=>$bc9d09886380ca07$var$route("subscribe"),
    password: {
        reset: ()=>$bc9d09886380ca07$var$route("password", "reset"),
        confirm: (params)=>$bc9d09886380ca07$var$route("password", "confirm", !params ? ":token" : params.token, !params ? ":email" : params.email)
    },
    account: {
        settings: ()=>$bc9d09886380ca07$var$route("account", "settings"),
        billing: ()=>$bc9d09886380ca07$var$route("account", "billing"),
        subscribe: (params)=>$bc9d09886380ca07$var$route("account", "subscribe", !params ? ":code" : params.code, !params ? ":interval" : params.interval)
    },
    members: {
        ...$bc9d09886380ca07$var$resourceRoute("users", {
            archivable: true
        }),
        resendInvite: (params)=>$bc9d09886380ca07$var$route("users", !params ? ":id" : params.id, "resend-invite"),
        resetPassword: (params)=>$bc9d09886380ca07$var$route("users", !params ? ":id" : params.id, "reset-password"),
        enableMfa: (params)=>$bc9d09886380ca07$var$route("users", !params ? ":id" : params.id, "enable-mfa"),
        confirmMfa: (params)=>$bc9d09886380ca07$var$route("users", !params ? ":id" : params.id, "confirm-mfa"),
        disableMfa: (params)=>$bc9d09886380ca07$var$route("users", !params ? ":id" : params.id, "disable-mfa")
    },
    dashboard: ()=>$bc9d09886380ca07$var$route("dashboard"),
    companies: {
        ...$bc9d09886380ca07$var$resourceRoute("companies", {
            archivable: true
        }),
        import: {
            upload: ()=>$bc9d09886380ca07$var$route("companies", "import"),
            delete: (params)=>$bc9d09886380ca07$var$route("companies", "import", !params ? ":id" : params.id)
        },
        sync: (params)=>$bc9d09886380ca07$var$route("companies", !params ? ":id" : params.id, "sync")
    },
    individuals: {
        ...$bc9d09886380ca07$var$resourceRoute("individuals", {
            archivable: true
        }),
        import: {
            upload: ()=>$bc9d09886380ca07$var$route("individuals", "import"),
            delete: (params)=>$bc9d09886380ca07$var$route("individuals", "import", !params ? ":id" : params.id)
        }
    },
    serviceManagers: $bc9d09886380ca07$var$resourceRoute("service-managers"),
    associations: $bc9d09886380ca07$var$resourceRoute("associations"),
    services: $bc9d09886380ca07$var$resourceRoute("services", {
        archivable: true
    }),
    tasks: {
        ...$bc9d09886380ca07$var$resourceRoute("tasks"),
        copy: (params)=>$bc9d09886380ca07$var$route("tasks", !params ? ":id" : params.id, "copy"),
        subTasks: (params)=>$bc9d09886380ca07$var$route("tasks", !params ? ":id" : params.id, "sub-tasks")
    },
    smartTasks: {
        ...$bc9d09886380ca07$var$resourceRoute("smart-tasks"),
        preview: ()=>$bc9d09886380ca07$var$route("smart-tasks", "preview"),
        offsets: (params)=>$bc9d09886380ca07$var$route("smart-tasks", !params ? ":id" : params.id, "offsets"),
        subTasks: (params)=>$bc9d09886380ca07$var$route("smart-tasks", !params ? ":id" : params.id, "sub-tasks"),
        options: {
            types: (params)=>$bc9d09886380ca07$var$route("smart-tasks", "options", "types", !params ? `:clientType(${Object.values((0, $19ee14db620c232e$export$4cd8cc03ec8c034a)).join("|")})` : params.clientType),
            updateFields: (params)=>$bc9d09886380ca07$var$route("smart-tasks", "options", "update-fields", !params ? `:clientType(${Object.values((0, $19ee14db620c232e$export$4cd8cc03ec8c034a)).join("|")})` : params.clientType)
        }
    },
    recurringTasks: {
        ...$bc9d09886380ca07$var$resourceRoute("recurring-tasks"),
        preview: ()=>$bc9d09886380ca07$var$route("recurring-tasks", "preview"),
        copy: (params)=>$bc9d09886380ca07$var$route("recurring-tasks", !params ? ":id" : params.id, "copy"),
        offsets: (params)=>$bc9d09886380ca07$var$route("recurring-tasks", !params ? ":id" : params.id, "offsets"),
        subTasks: (params)=>$bc9d09886380ca07$var$route("recurring-tasks", !params ? ":id" : params.id, "sub-tasks")
    },
    messages: $bc9d09886380ca07$var$resourceRoute("messages"),
    templates: {
        ...$bc9d09886380ca07$var$resourceRoute("templates"),
        preview: ()=>$bc9d09886380ca07$var$route("templates", "preview"),
        search: ()=>$bc9d09886380ca07$var$route("templates", "search")
    },
    admin: {
        accounts: {
            ...$bc9d09886380ca07$var$resourceRoute("accounts", {
                prefix: "admin"
            }),
            manage: ()=>$bc9d09886380ca07$var$route("admin", "accounts", "manage"),
            createSmartTasks: (params)=>$bc9d09886380ca07$var$route("admin", "accounts", !params ? ":id" : params.id, "create-smart-tasks")
        }
    },
    data: {
        grid: (params)=>$bc9d09886380ca07$var$route("data", "grid", !params ? ":model" : params.modelName, !params ? ":archived?" : params.archived && "archived"),
        editable: (params)=>$bc9d09886380ca07$var$route("data", "editable", !params ? ":model" : params.model),
        lookup: {
            list: (params)=>$bc9d09886380ca07$var$route("data", "lookup", !params ? ":model" : params.model),
            item: (params)=>$bc9d09886380ca07$var$route("data", "lookup", !params ? ":model" : params.model, !params ? ":value" : params.value)
        },
        search: ()=>$bc9d09886380ca07$var$route("data", "search"),
        uploads: {
            get: (template = true)=>$bc9d09886380ca07$var$route("data", "uploads", template ? ":name" : ""),
            put: ()=>$bc9d09886380ca07$var$route("data", "uploads", "put"),
            delete: ()=>$bc9d09886380ca07$var$route("data", "uploads", "delete")
        }
    },
    settings: {
        grid: (params)=>$bc9d09886380ca07$var$route("settings", "grid", !params ? ":id" : params.id, !params ? ":view?" : params.view)
    },
    unauthorised: $bc9d09886380ca07$var$route("unauthorised"),
    notFound: $bc9d09886380ca07$var$route("not-found"),
    error: $bc9d09886380ca07$var$route("error"),
    test: {
        frontendError: ()=>$bc9d09886380ca07$var$route("test", "frontend-error"),
        backendError: ()=>$bc9d09886380ca07$var$route("test", "backend-error")
    },
    legal: {
        terms: ()=>$bc9d09886380ca07$var$route("legal", "terms"),
        privacy: ()=>$bc9d09886380ca07$var$route("legal", "privacy"),
        gdpr: ()=>$bc9d09886380ca07$var$route("legal", "gdpr")
    }
};


var $7e63d782a157f66d$exports = {};
$parcel$export($7e63d782a157f66d$exports, "calculatePosition", () => (parcelRequire("cWXlQ")).calculatePosition);
$parcel$export($7e63d782a157f66d$exports, "calculateRelativeBasedPosition", () => (parcelRequire("cWXlQ")).calculateRelativeBasedPosition);
$parcel$export($7e63d782a157f66d$exports, "fit", () => (parcelRequire("49u5W")).fit);
$parcel$export($7e63d782a157f66d$exports, "isCollide", () => (parcelRequire("49u5W")).isCollide);
$parcel$export($7e63d782a157f66d$exports, "Dialog", () => $397c948d4a376450$export$3ddf2d174ce01153);
$parcel$export($7e63d782a157f66d$exports, "Tooltip", () => $47b4397f26bd41a3$export$28c660c63b792dea);
$parcel$export($7e63d782a157f66d$exports, "createSpinner", () => $d4834c37f505aa74$export$2342b8d835c798ac);
$parcel$export($7e63d782a157f66d$exports, "hideSpinner", () => $d4834c37f505aa74$export$95fec50f68454318);
$parcel$export($7e63d782a157f66d$exports, "showSpinner", () => $d4834c37f505aa74$export$2a7a135fa1ec651f);
/**
 * Popup Components
 */ 
var $2vAqh = parcelRequire("2vAqh");
parcelRequire("cWXlQ");parcelRequire("49u5W");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $c2qqN = parcelRequire("c2qqN");
var $hQxLN = parcelRequire("hQxLN");
var $eAUyT = parcelRequire("eAUyT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");
var $3P3ke = parcelRequire("3P3ke");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");
var $13zI2 = parcelRequire("13zI2");
var $3P3ke = parcelRequire("3P3ke");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");
function $6a51972c93f30c96$export$fae3ac1fb6b5c37c(createElement, tag, type, element, WRAPPER, role) {
    var input = element;
    if (element.tagName === tag) {
        var ejInstance = (0, $3EnZW.getValue)("ej2_instances", element);
        input = createElement("input", {
            attrs: {
                "type": type
            }
        });
        var props = [
            "change",
            "cssClass",
            "label",
            "labelPosition",
            "id"
        ];
        for(var index = 0, len = element.attributes.length; index < len; index++)if (props.indexOf(element.attributes[index].nodeName) === -1) input.setAttribute(element.attributes[index].nodeName, element.attributes[index].nodeValue);
        (0, $4ZDHT.attributes)(element, {
            "class": WRAPPER
        });
        element.appendChild(input);
        element.classList.add(role);
        element.classList.remove(role);
        (0, $3EnZW.setValue)("ej2_instances", ejInstance, input);
        (0, $3EnZW.deleteObject)(element, "ej2_instances");
    }
    return input;
}
function $6a51972c93f30c96$export$6a6468437b1d32f2(element) {
    var node;
    var childnode = element.childNodes;
    for(var i = 0; i < childnode.length; i++){
        node = childnode[i];
        if (node.nodeType === 3) return node;
    }
    return null;
}
function $6a51972c93f30c96$export$b1fb4cac938035f7(ejInst, wrapper, tagName) {
    if (tagName === "INPUT") {
        wrapper.parentNode.insertBefore(ejInst.element, wrapper);
        (0, $4ZDHT.detach)(wrapper);
        ejInst.element.checked = false;
        [
            "name",
            "value",
            "disabled"
        ].forEach(function(key) {
            ejInst.element.removeAttribute(key);
        });
    } else {
        [
            "role",
            "aria-checked",
            "class"
        ].forEach(function(key) {
            wrapper.removeAttribute(key);
        });
        wrapper.innerHTML = "";
        ejInst.element = wrapper;
    }
}
function $6a51972c93f30c96$export$a555f843fc00d55a(proxy, control, wrapper, element, moduleName) {
    element = $6a51972c93f30c96$export$fae3ac1fb6b5c37c(proxy.createElement, control, "checkbox", element, wrapper, moduleName);
    proxy.element = element;
    if (proxy.element.getAttribute("type") !== "checkbox") proxy.element.setAttribute("type", "checkbox");
    if (!proxy.element.id) proxy.element.id = (0, $3EnZW.getUniqueID)("e-" + moduleName);
}
function $6a51972c93f30c96$export$1ef36a84bae94342(createElement, enableRipple, options) {
    if (enableRipple === void 0) enableRipple = false;
    if (options === void 0) options = {};
    var wrapper = createElement("div", {
        className: "e-checkbox-wrapper e-css"
    });
    if (options.cssClass) (0, $4ZDHT.addClass)([
        wrapper
    ], options.cssClass.split(" "));
    if (options.enableRtl) wrapper.classList.add("e-rtl");
    if (enableRipple) {
        var rippleSpan = createElement("span", {
            className: "e-ripple-container"
        });
        (0, $kj1BR.rippleEffect)(rippleSpan, {
            isCenterRipple: true,
            duration: 400
        });
        wrapper.appendChild(rippleSpan);
    }
    var frameSpan = createElement("span", {
        className: "e-frame e-icons"
    });
    if (options.checked) frameSpan.classList.add("e-check");
    wrapper.appendChild(frameSpan);
    if (options.label) {
        var labelSpan = createElement("span", {
            className: "e-label"
        });
        if (options.disableHtmlEncode) labelSpan.textContent = options.label;
        else labelSpan.innerHTML = options.label;
        wrapper.appendChild(labelSpan);
    }
    return wrapper;
}
function $6a51972c93f30c96$export$e68f3fbf27cf73b(e, rippleSpan) {
    if (rippleSpan) {
        var event_1 = document.createEvent("MouseEvents");
        event_1.initEvent(e.type, false, true);
        rippleSpan.dispatchEvent(event_1);
    }
}
function $6a51972c93f30c96$export$4692e7592464f3a2(proxy, wrap) {
    if (proxy.element.getAttribute("ejs-for")) wrap.appendChild(proxy.createElement("input", {
        attrs: {
            "name": proxy.name || proxy.element.name,
            "value": "false",
            "type": "hidden"
        }
    }));
}


var $933f7ed08601bef4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $933f7ed08601bef4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $933f7ed08601bef4$export$73641af126067017;
(function(IconPosition) {
    /**
     * Positions the Icon at the left of the text content in the Button.
     */ IconPosition["Left"] = "Left";
    /**
     * Positions the Icon at the right of the text content in the Button.
     */ IconPosition["Right"] = "Right";
    /**
     * Positions the Icon at the top of the text content in the Button.
     */ IconPosition["Top"] = "Top";
    /**
     * Positions the Icon at the bottom of the text content in the Button.
     */ IconPosition["Bottom"] = "Bottom";
})($933f7ed08601bef4$export$73641af126067017 || ($933f7ed08601bef4$export$73641af126067017 = {}));
var $933f7ed08601bef4$export$b06d0f80a2cb721 = new (0, $13zI2.Observer)();
var $933f7ed08601bef4$var$cssClassName = {
    RTL: "e-rtl",
    BUTTON: "e-btn",
    PRIMARY: "e-primary",
    ICONBTN: "e-icon-btn"
};
/**
 * The Button is a graphical user interface element that triggers an event on its click action. It can contain a text, an image, or both.
 * ```html
 * <button id="button">Button</button>
 * ```
 * ```typescript
 * <script>
 * var btnObj = new Button();
 * btnObj.appendTo("#button");
 * </script>
 * ```
 */ var $933f7ed08601bef4$export$353f5b6fc5456de1 = /** @class */ function(_super) {
    $933f7ed08601bef4$var$__extends(Button, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {ButtonModel} options - Specifies the button model
     * @param  {string|HTMLButtonElement} element - Specifies the target element
     */ function Button(options, element) {
        return _super.call(this, options, element) || this;
    }
    Button.prototype.preRender = function() {
    // pre render code snippets
    };
    /**
     * Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Button.prototype.render = function() {
        this.initialize();
        this.removeRippleEffect = (0, $kj1BR.rippleEffect)(this.element, {
            selector: "." + $933f7ed08601bef4$var$cssClassName.BUTTON
        });
        this.renderComplete();
    };
    Button.prototype.initialize = function() {
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.element
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        if (this.isPrimary) this.element.classList.add($933f7ed08601bef4$var$cssClassName.PRIMARY);
        if (!(0, $3EnZW.isBlazor)() || (0, $3EnZW.isBlazor)() && this.getModuleName() !== "progress-btn") {
            if (this.content) {
                var tempContent = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(this.content) : this.content;
                this.element.innerHTML = tempContent;
            }
            this.setIconCss();
        }
        if (this.enableRtl) this.element.classList.add($933f7ed08601bef4$var$cssClassName.RTL);
        if (this.disabled) this.controlStatus(this.disabled);
        else this.wireEvents();
    };
    Button.prototype.controlStatus = function(disabled) {
        this.element.disabled = disabled;
    };
    Button.prototype.setIconCss = function() {
        if (this.iconCss) {
            var span = this.createElement("span", {
                className: "e-btn-icon " + this.iconCss
            });
            if (!this.element.textContent.trim()) this.element.classList.add($933f7ed08601bef4$var$cssClassName.ICONBTN);
            else {
                span.classList.add("e-icon-" + this.iconPosition.toLowerCase());
                if (this.iconPosition === "Top" || this.iconPosition === "Bottom") this.element.classList.add("e-" + this.iconPosition.toLowerCase() + "-icon-btn");
            }
            var node = this.element.childNodes[0];
            if (node && (this.iconPosition === "Left" || this.iconPosition === "Top")) this.element.insertBefore(span, node);
            else this.element.appendChild(span);
        }
    };
    Button.prototype.wireEvents = function() {
        if (this.isToggle) (0, $aqzbR.EventHandler).add(this.element, "click", this.btnClickHandler, this);
    };
    Button.prototype.unWireEvents = function() {
        if (this.isToggle) (0, $aqzbR.EventHandler).remove(this.element, "click", this.btnClickHandler);
    };
    Button.prototype.btnClickHandler = function() {
        if (this.element.classList.contains("e-active")) this.element.classList.remove("e-active");
        else this.element.classList.add("e-active");
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ Button.prototype.destroy = function() {
        var classList = [
            $933f7ed08601bef4$var$cssClassName.PRIMARY,
            $933f7ed08601bef4$var$cssClassName.RTL,
            $933f7ed08601bef4$var$cssClassName.ICONBTN,
            "e-success",
            "e-info",
            "e-danger",
            "e-warning",
            "e-flat",
            "e-outline",
            "e-small",
            "e-bigger",
            "e-active",
            "e-round",
            "e-top-icon-btn",
            "e-bottom-icon-btn"
        ];
        if (this.cssClass) classList = classList.concat(this.cssClass.split(" "));
        _super.prototype.destroy.call(this);
        (0, $4ZDHT.removeClass)([
            this.element
        ], classList);
        if (!this.element.getAttribute("class")) this.element.removeAttribute("class");
        if (this.disabled) this.element.removeAttribute("disabled");
        if (this.content) this.element.innerHTML = this.element.innerHTML.replace(this.content, "");
        var span = this.element.querySelector("span.e-btn-icon");
        if (span) (0, $4ZDHT.detach)(span);
        this.unWireEvents();
        if (0, $kj1BR.isRippleEnabled) this.removeRippleEffect();
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module name
     * @private
     */ Button.prototype.getModuleName = function() {
        return "btn";
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist Data
     * @private
     */ Button.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * Dynamically injects the required modules to the component.
     *
     * @private
     * @returns {void}
     */ Button.Inject = function() {
    // Inject code snippets
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {ButtonModel} newProp - Specifies new properties
     * @param  {ButtonModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */ Button.prototype.onPropertyChanged = function(newProp, oldProp) {
        var span = this.element.querySelector("span.e-btn-icon");
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "isPrimary":
                    if (newProp.isPrimary) this.element.classList.add($933f7ed08601bef4$var$cssClassName.PRIMARY);
                    else this.element.classList.remove($933f7ed08601bef4$var$cssClassName.PRIMARY);
                    break;
                case "disabled":
                    this.controlStatus(newProp.disabled);
                    break;
                case "iconCss":
                    span = this.element.querySelector("span.e-btn-icon");
                    if (span) {
                        if (newProp.iconCss) {
                            span.className = "e-btn-icon " + newProp.iconCss;
                            if (this.element.textContent.trim()) {
                                if (this.iconPosition === "Left") span.classList.add("e-icon-left");
                                else span.classList.add("e-icon-right");
                            }
                        } else (0, $4ZDHT.detach)(span);
                    } else this.setIconCss();
                    break;
                case "iconPosition":
                    (0, $4ZDHT.removeClass)([
                        this.element
                    ], [
                        "e-top-icon-btn",
                        "e-bottom-icon-btn"
                    ]);
                    span = this.element.querySelector("span.e-btn-icon");
                    if (span) (0, $4ZDHT.detach)(span);
                    this.setIconCss();
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        this.element
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        this.element
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) this.element.classList.add($933f7ed08601bef4$var$cssClassName.RTL);
                    else this.element.classList.remove($933f7ed08601bef4$var$cssClassName.RTL);
                    break;
                case "content":
                    var node = (0, $6a51972c93f30c96$export$6a6468437b1d32f2)(this.element);
                    if (!node) this.element.classList.remove($933f7ed08601bef4$var$cssClassName.ICONBTN);
                    if (!(0, $3EnZW.isBlazor)() || (0, $3EnZW.isBlazor)() && !this.isServerRendered && this.getModuleName() !== "progress-btn") {
                        if (this.enableHtmlSanitizer) newProp.content = (0, $3P3ke.SanitizeHtmlHelper).sanitize(newProp.content);
                        this.element.innerHTML = newProp.content;
                        this.setIconCss();
                    }
                    break;
                case "isToggle":
                    if (newProp.isToggle) (0, $aqzbR.EventHandler).add(this.element, "click", this.btnClickHandler, this);
                    else {
                        (0, $aqzbR.EventHandler).remove(this.element, "click", this.btnClickHandler);
                        (0, $4ZDHT.removeClass)([
                            this.element
                        ], [
                            "e-active"
                        ]);
                    }
                    break;
            }
        }
    };
    /**
     * Click the button element
     * its native method
     *
     * @public
     * @returns {void}
     */ Button.prototype.click = function() {
        this.element.click();
    };
    /**
     * Sets the focus to Button
     * its native method
     *
     * @public
     * @returns {void}
     */ Button.prototype.focusIn = function() {
        this.element.focus();
    };
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], Button.prototype, "iconPosition", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Button.prototype, "iconCss", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Button.prototype, "disabled", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Button.prototype, "isPrimary", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Button.prototype, "cssClass", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Button.prototype, "content", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Button.prototype, "isToggle", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)()
    ], Button.prototype, "locale", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Button.prototype, "enableHtmlSanitizer", void 0);
    $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Button.prototype, "created", void 0);
    Button = $933f7ed08601bef4$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Button);
    return Button;
}((0, $hQxLN.Component));



var $2vAqh = parcelRequire("2vAqh");
/**
 * Resize library
 */ parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $af188cccda90eb97$var$elementClass = [
    "north-west",
    "north",
    "north-east",
    "west",
    "east",
    "south-west",
    "south",
    "south-east"
];
var $af188cccda90eb97$var$RESIZE_HANDLER = "e-resize-handle";
var $af188cccda90eb97$var$FOCUSED_HANDLER = "e-focused-handle";
var $af188cccda90eb97$var$DIALOG_RESIZABLE = "e-dlg-resizable";
var $af188cccda90eb97$var$RESTRICT_LEFT = [
    "e-restrict-left"
];
var $af188cccda90eb97$var$RESIZE_WITHIN_VIEWPORT = "e-resize-viewport";
var $af188cccda90eb97$var$dialogBorderResize = [
    "north",
    "west",
    "east",
    "south"
];
var $af188cccda90eb97$var$targetElement;
var $af188cccda90eb97$var$selectedHandler;
var $af188cccda90eb97$var$originalWidth = 0;
var $af188cccda90eb97$var$originalHeight = 0;
var $af188cccda90eb97$var$originalX = 0;
var $af188cccda90eb97$var$originalY = 0;
var $af188cccda90eb97$var$originalMouseX = 0;
var $af188cccda90eb97$var$originalMouseY = 0;
var $af188cccda90eb97$var$minHeight;
var $af188cccda90eb97$var$maxHeight;
var $af188cccda90eb97$var$minWidth;
var $af188cccda90eb97$var$maxWidth;
var $af188cccda90eb97$var$containerElement;
var $af188cccda90eb97$var$resizeStart = null;
var $af188cccda90eb97$var$resize = null;
var $af188cccda90eb97$var$resizeEnd = null;
var $af188cccda90eb97$var$resizeWestWidth;
var $af188cccda90eb97$var$setLeft = true;
var $af188cccda90eb97$var$previousWidth = 0;
var $af188cccda90eb97$var$setWidth = true;
// eslint-disable-next-line
var $af188cccda90eb97$var$proxy;
function $af188cccda90eb97$export$58909557046ca413(args) {
    $af188cccda90eb97$var$resizeStart = args.resizeBegin;
    $af188cccda90eb97$var$resize = args.resizing;
    $af188cccda90eb97$var$resizeEnd = args.resizeComplete;
    $af188cccda90eb97$var$targetElement = $af188cccda90eb97$var$getDOMElement(args.element);
    $af188cccda90eb97$var$containerElement = $af188cccda90eb97$var$getDOMElement(args.boundary);
    var directions = args.direction.split(" ");
    for(var i = 0; i < directions.length; i++){
        if ($af188cccda90eb97$var$dialogBorderResize.indexOf(directions[i]) >= 0 && directions[i]) $af188cccda90eb97$var$setBorderResizeElm(directions[i]);
        else if (directions[i].trim() !== "") {
            var resizeHandler = (0, $4ZDHT.createElement)("div", {
                className: "e-icons " + $af188cccda90eb97$var$RESIZE_HANDLER + " " + "e-" + directions[i]
            });
            $af188cccda90eb97$var$targetElement.appendChild(resizeHandler);
        }
    }
    $af188cccda90eb97$var$minHeight = args.minHeight;
    $af188cccda90eb97$var$minWidth = args.minWidth;
    $af188cccda90eb97$var$maxWidth = args.maxWidth;
    $af188cccda90eb97$var$maxHeight = args.maxHeight;
    if (args.proxy && args.proxy.element && args.proxy.element.classList.contains("e-dialog")) $af188cccda90eb97$var$wireEvents(args.proxy);
    else $af188cccda90eb97$var$wireEvents();
}
/**
 *
 * @param {string} direction - specifies the string
 * @returns {void}
 */ function $af188cccda90eb97$var$setBorderResizeElm(direction) {
    $af188cccda90eb97$var$calculateValues();
    var borderBottom = (0, $4ZDHT.createElement)("span", {
        attrs: {
            "unselectable": "on",
            "contenteditable": "false"
        }
    });
    borderBottom.setAttribute("class", "e-dialog-border-resize e-" + direction);
    if (direction === "south") {
        borderBottom.style.height = "2px";
        borderBottom.style.width = "100%";
        borderBottom.style.bottom = "0px";
        borderBottom.style.left = "0px";
    }
    if (direction === "north") {
        borderBottom.style.height = "2px";
        borderBottom.style.width = "100%";
        borderBottom.style.top = "0px";
        borderBottom.style.left = "0px";
    }
    if (direction === "east") {
        borderBottom.style.height = "100%";
        borderBottom.style.width = "2px";
        borderBottom.style.right = "0px";
        borderBottom.style.top = "0px";
    }
    if (direction === "west") {
        borderBottom.style.height = "100%";
        borderBottom.style.width = "2px";
        borderBottom.style.left = "0px";
        borderBottom.style.top = "0px";
    }
    $af188cccda90eb97$var$targetElement.appendChild(borderBottom);
}
/**
 *
 * @param {string} element - specifies the element
 * @returns {HTMLElement} - returns the element
 */ function $af188cccda90eb97$var$getDOMElement(element) {
    var domElement;
    if (!(0, $3EnZW.isNullOrUndefined)(element)) {
        if (typeof element === "string") domElement = document.querySelector(element);
        else domElement = element;
    }
    return domElement;
}
/**
 * Wires up the event handlers for the resizable elements.
 *
 * @param {any} [args] - Optional arguments that provide context for the event handlers.
 * @returns {void}
 */ function $af188cccda90eb97$var$wireEvents(args) {
    var context = args || this;
    var resizers = $af188cccda90eb97$var$targetElement.querySelectorAll("." + $af188cccda90eb97$var$RESIZE_HANDLER);
    for(var i = 0; i < resizers.length; i++){
        $af188cccda90eb97$var$selectedHandler = resizers[i];
        (0, $aqzbR.EventHandler).add($af188cccda90eb97$var$selectedHandler, "mousedown", $af188cccda90eb97$var$onMouseDown, context);
        var eventName = (0, $5q7BP.Browser).info.name === "msie" ? "pointerdown" : "touchstart";
        (0, $aqzbR.EventHandler).add($af188cccda90eb97$var$selectedHandler, eventName, $af188cccda90eb97$var$onTouchStart, context);
    }
    var borderResizers = $af188cccda90eb97$var$targetElement.querySelectorAll(".e-dialog-border-resize");
    if (!(0, $3EnZW.isNullOrUndefined)(borderResizers)) for(var i = 0; i < borderResizers.length; i++){
        $af188cccda90eb97$var$selectedHandler = borderResizers[i];
        (0, $aqzbR.EventHandler).add($af188cccda90eb97$var$selectedHandler, "mousedown", $af188cccda90eb97$var$onMouseDown, context);
        var eventName = (0, $5q7BP.Browser).info.name === "msie" ? "pointerdown" : "touchstart";
        (0, $aqzbR.EventHandler).add($af188cccda90eb97$var$selectedHandler, eventName, $af188cccda90eb97$var$onTouchStart, context);
    }
}
/* istanbul ignore next */ /**
 *
 * @param {string} e - specifies the string
 * @returns {string} - returns the string
 */ function $af188cccda90eb97$var$getEventType(e) {
    return e.indexOf("mouse") > -1 ? "mouse" : "touch";
}
/* istanbul ignore next */ /**
 *
 * @param {MouseEvent} e - specifies the mouse event
 * @returns {void}
 */ function $af188cccda90eb97$var$onMouseDown(e) {
    e.preventDefault();
    $af188cccda90eb97$var$targetElement = e.target.parentElement;
    $af188cccda90eb97$var$calculateValues();
    $af188cccda90eb97$var$originalMouseX = e.pageX;
    $af188cccda90eb97$var$originalMouseY = e.pageY;
    e.target.classList.add($af188cccda90eb97$var$FOCUSED_HANDLER);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$resizeStart)) {
        var proxy_1 = this;
        if ($af188cccda90eb97$var$resizeStart(e, proxy_1) === true) return;
    }
    if (this.targetEle && $af188cccda90eb97$var$targetElement && $af188cccda90eb97$var$targetElement.querySelector("." + $af188cccda90eb97$var$DIALOG_RESIZABLE)) {
        $af188cccda90eb97$var$containerElement = this.target === "body" ? null : this.targetEle;
        $af188cccda90eb97$var$maxWidth = this.targetEle.clientWidth;
        $af188cccda90eb97$var$maxHeight = this.targetEle.clientHeight;
    }
    var target = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? document : $af188cccda90eb97$var$containerElement;
    (0, $aqzbR.EventHandler).add(target, "mousemove", $af188cccda90eb97$var$onMouseMove, this);
    (0, $aqzbR.EventHandler).add(document, "mouseup", $af188cccda90eb97$var$onMouseUp, this);
    for(var i = 0; i < $af188cccda90eb97$var$RESTRICT_LEFT.length; i++)if ($af188cccda90eb97$var$targetElement.classList.contains($af188cccda90eb97$var$RESTRICT_LEFT[i])) $af188cccda90eb97$var$setLeft = false;
    else $af188cccda90eb97$var$setLeft = true;
}
/* istanbul ignore next */ /**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */ function $af188cccda90eb97$var$onMouseUp(e) {
    var touchMoveEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointermove" : "touchmove";
    var touchEndEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointerup" : "touchend";
    var target = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? document : $af188cccda90eb97$var$containerElement;
    var eventName = (0, $5q7BP.Browser).info.name === "msie" ? "pointerdown" : "touchstart";
    (0, $aqzbR.EventHandler).remove(target, "mousemove", $af188cccda90eb97$var$onMouseMove);
    (0, $aqzbR.EventHandler).remove(target, touchMoveEvent, $af188cccda90eb97$var$onMouseMove);
    (0, $aqzbR.EventHandler).remove(target, eventName, $af188cccda90eb97$var$onMouseMove);
    if (!(0, $3EnZW.isNullOrUndefined)(document.body.querySelector("." + $af188cccda90eb97$var$FOCUSED_HANDLER))) document.body.querySelector("." + $af188cccda90eb97$var$FOCUSED_HANDLER).classList.remove($af188cccda90eb97$var$FOCUSED_HANDLER);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$resizeEnd)) {
        var proxy_2 = this;
        $af188cccda90eb97$var$resizeEnd(e, proxy_2);
    }
    (0, $aqzbR.EventHandler).remove(document, "mouseup", $af188cccda90eb97$var$onMouseUp);
    (0, $aqzbR.EventHandler).remove(document, touchEndEvent, $af188cccda90eb97$var$onMouseUp);
}
/* istanbul ignore next */ /**
 * @returns {void}
 */ function $af188cccda90eb97$var$calculateValues() {
    $af188cccda90eb97$var$originalWidth = parseFloat(getComputedStyle($af188cccda90eb97$var$targetElement, null).getPropertyValue("width").replace("px", ""));
    $af188cccda90eb97$var$originalHeight = parseFloat(getComputedStyle($af188cccda90eb97$var$targetElement, null).getPropertyValue("height").replace("px", ""));
    $af188cccda90eb97$var$originalX = $af188cccda90eb97$var$targetElement.getBoundingClientRect().left;
    $af188cccda90eb97$var$originalY = $af188cccda90eb97$var$targetElement.getBoundingClientRect().top;
}
/* istanbul ignore next */ /**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */ function $af188cccda90eb97$var$onTouchStart(e) {
    $af188cccda90eb97$var$targetElement = e.target.parentElement;
    $af188cccda90eb97$var$calculateValues();
    var dialogResizeElement = $af188cccda90eb97$var$targetElement.classList.contains("e-dialog");
    if ((e.target.classList.contains($af188cccda90eb97$var$RESIZE_HANDLER) || e.target.classList.contains("e-dialog-border-resize")) && dialogResizeElement) e.target.classList.add($af188cccda90eb97$var$FOCUSED_HANDLER);
    var coordinates = e.touches ? e.changedTouches[0] : e;
    $af188cccda90eb97$var$originalMouseX = coordinates.pageX;
    $af188cccda90eb97$var$originalMouseY = coordinates.pageY;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$resizeStart)) {
        var proxy_3 = this;
        if ($af188cccda90eb97$var$resizeStart(e, proxy_3) === true) return;
    }
    var touchMoveEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointermove" : "touchmove";
    var touchEndEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointerup" : "touchend";
    var target = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? document : $af188cccda90eb97$var$containerElement;
    (0, $aqzbR.EventHandler).add(target, touchMoveEvent, $af188cccda90eb97$var$onMouseMove, this);
    (0, $aqzbR.EventHandler).add(document, touchEndEvent, $af188cccda90eb97$var$onMouseUp, this);
}
/* istanbul ignore next */ /**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */ function $af188cccda90eb97$var$onMouseMove(e) {
    if (e.target.classList.contains($af188cccda90eb97$var$RESIZE_HANDLER) && e.target.classList.contains($af188cccda90eb97$var$FOCUSED_HANDLER)) $af188cccda90eb97$var$selectedHandler = e.target;
    else if (!(0, $3EnZW.isNullOrUndefined)(document.body.querySelector("." + $af188cccda90eb97$var$FOCUSED_HANDLER))) $af188cccda90eb97$var$selectedHandler = document.body.querySelector("." + $af188cccda90eb97$var$FOCUSED_HANDLER);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$selectedHandler)) {
        var resizeTowards = "";
        for(var i = 0; i < $af188cccda90eb97$var$elementClass.length; i++)if ($af188cccda90eb97$var$selectedHandler.classList.contains("e-" + $af188cccda90eb97$var$elementClass[i])) resizeTowards = $af188cccda90eb97$var$elementClass[i];
        if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$resize)) {
            var proxy_4 = this;
            $af188cccda90eb97$var$resize(e, proxy_4);
        }
        switch(resizeTowards){
            case "south":
                $af188cccda90eb97$var$resizeSouth(e);
                break;
            case "north":
                $af188cccda90eb97$var$resizeNorth(e);
                break;
            case "west":
                $af188cccda90eb97$var$resizeWest(e);
                break;
            case "east":
                $af188cccda90eb97$var$resizeEast(e);
                break;
            case "south-east":
                $af188cccda90eb97$var$resizeSouth(e);
                $af188cccda90eb97$var$resizeEast(e);
                break;
            case "south-west":
                $af188cccda90eb97$var$resizeSouth(e);
                $af188cccda90eb97$var$resizeWest(e);
                break;
            case "north-east":
                $af188cccda90eb97$var$resizeNorth(e);
                $af188cccda90eb97$var$resizeEast(e);
                break;
            case "north-west":
                $af188cccda90eb97$var$resizeNorth(e);
                $af188cccda90eb97$var$resizeWest(e);
                break;
            default:
                break;
        }
    }
}
/* istanbul ignore next */ /**
 *
 * @param {HTMLElement} element - specifies the eleemnt
 * @returns {ClientRect} - returns the client
 */ function $af188cccda90eb97$var$getClientRectValues(element) {
    return element.getBoundingClientRect();
}
/**
 * @param {MouseEvent | TouchEvent} e - specifies the event
 * @returns {void}
 */ function $af188cccda90eb97$var$resizeSouth(e) {
    var documentHeight = document.documentElement.clientHeight;
    var calculateValue = false;
    var coordinates = e.touches ? e.changedTouches[0] : e;
    var currentpageY = coordinates.pageY;
    var targetRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$targetElement);
    var containerRectValues;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$containerElement);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) calculateValue = true;
    else if ((0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && (documentHeight - currentpageY >= 0 || targetRectValues.top < 0)) calculateValue = true;
    var calculatedHeight = $af188cccda90eb97$var$originalHeight + (currentpageY - $af188cccda90eb97$var$originalMouseY);
    calculatedHeight = calculatedHeight > $af188cccda90eb97$var$minHeight ? calculatedHeight : $af188cccda90eb97$var$minHeight;
    var containerTop = 0;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerTop = containerRectValues.top;
    var borderValue = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? 0 : $af188cccda90eb97$var$containerElement.offsetHeight - $af188cccda90eb97$var$containerElement.clientHeight;
    var topWithoutborder = targetRectValues.top - containerTop - borderValue / 2;
    topWithoutborder = topWithoutborder < 0 ? 0 : topWithoutborder;
    if (targetRectValues.top > 0 && topWithoutborder + calculatedHeight > $af188cccda90eb97$var$maxHeight) {
        calculateValue = false;
        if ($af188cccda90eb97$var$targetElement.classList.contains($af188cccda90eb97$var$RESIZE_WITHIN_VIEWPORT)) return;
        $af188cccda90eb97$var$targetElement.style.height = $af188cccda90eb97$var$maxHeight - parseInt(topWithoutborder.toString(), 10) + "px";
        return;
    }
    var targetTop = 0;
    if (calculateValue) {
        if (targetRectValues.top < 0 && documentHeight + (targetRectValues.height + targetRectValues.top) > 0) {
            targetTop = targetRectValues.top;
            if (calculatedHeight + targetTop <= 30) calculatedHeight = targetRectValues.height - (targetRectValues.height + targetRectValues.top) + 30;
        }
        if (calculatedHeight + targetRectValues.top >= $af188cccda90eb97$var$maxHeight) $af188cccda90eb97$var$targetElement.style.height = targetRectValues.height + (documentHeight - (targetRectValues.height + targetRectValues.top)) + "px";
        var calculatedTop = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? targetTop : topWithoutborder;
        if (calculatedHeight >= $af188cccda90eb97$var$minHeight && calculatedHeight + calculatedTop <= $af188cccda90eb97$var$maxHeight) $af188cccda90eb97$var$targetElement.style.height = calculatedHeight + "px";
    }
}
/**
 * Resizes the element towards the north direction.
 *
 * @param {MouseEvent | TouchEvent} e - The event object.
 * @returns {void}
 */ function $af188cccda90eb97$var$resizeNorth(e) {
    var calculateValue = false;
    var boundaryRectValues;
    var pageY = $af188cccda90eb97$var$getEventType(e.type) === "mouse" ? e.pageY : e.touches[0].pageY;
    var targetRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$targetElement);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) boundaryRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$containerElement);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && targetRectValues.top - boundaryRectValues.top > 0) calculateValue = true;
    else if ((0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && pageY > 0) calculateValue = true;
    var currentHeight = $af188cccda90eb97$var$originalHeight - (pageY - $af188cccda90eb97$var$originalMouseY);
    if (calculateValue) {
        if (currentHeight >= $af188cccda90eb97$var$minHeight && currentHeight <= $af188cccda90eb97$var$maxHeight) {
            var containerTop = 0;
            if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerTop = boundaryRectValues.top;
            var top_1 = $af188cccda90eb97$var$originalY - containerTop + (pageY - $af188cccda90eb97$var$originalMouseY);
            top_1 = top_1 > 0 ? top_1 : 1;
            $af188cccda90eb97$var$targetElement.style.height = currentHeight + "px";
            if (!($af188cccda90eb97$var$targetElement.classList.contains("e-dlg-modal") && $af188cccda90eb97$var$targetElement.style.top === "0px")) $af188cccda90eb97$var$targetElement.style.top = top_1 + "px";
        }
    }
}
/**
 * Resizes the element towards the west direction.
 *
 * @param {MouseEvent | TouchEvent} e - The event object.
 * @returns {void}
 */ function $af188cccda90eb97$var$resizeWest(e) {
    var documentWidth = document.documentElement.clientWidth;
    var calculateValue = false;
    var rectValues;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) rectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$containerElement);
    var pageX = $af188cccda90eb97$var$getEventType(e.type) === "mouse" ? e.pageX : e.touches[0].pageX;
    var targetRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$targetElement);
    var borderValue = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? 0 : $af188cccda90eb97$var$containerElement.offsetWidth - $af188cccda90eb97$var$containerElement.clientWidth;
    /* eslint-disable */ var left = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? 0 : rectValues.left;
    var containerWidth = (0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) ? 0 : rectValues.width;
    /* eslint-enable */ if ((0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$resizeWestWidth)) {
        if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) {
            $af188cccda90eb97$var$resizeWestWidth = targetRectValues.left - left - borderValue / 2 + targetRectValues.width;
            $af188cccda90eb97$var$resizeWestWidth = $af188cccda90eb97$var$resizeWestWidth + (containerWidth - borderValue - $af188cccda90eb97$var$resizeWestWidth);
        } else $af188cccda90eb97$var$resizeWestWidth = documentWidth;
    }
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && Math.floor(targetRectValues.left - rectValues.left + targetRectValues.width + (rectValues.right - targetRectValues.right)) - borderValue <= $af188cccda90eb97$var$maxWidth) calculateValue = true;
    else if ((0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && pageX >= 0) calculateValue = true;
    var calculatedWidth = $af188cccda90eb97$var$originalWidth - (pageX - $af188cccda90eb97$var$originalMouseX);
    if ($af188cccda90eb97$var$setLeft) calculatedWidth = calculatedWidth > $af188cccda90eb97$var$resizeWestWidth ? $af188cccda90eb97$var$resizeWestWidth : calculatedWidth;
    if (calculateValue) {
        if (calculatedWidth >= $af188cccda90eb97$var$minWidth && calculatedWidth <= $af188cccda90eb97$var$maxWidth) {
            var containerLeft = 0;
            if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerLeft = rectValues.left;
            var left_1 = $af188cccda90eb97$var$originalX - containerLeft + (pageX - $af188cccda90eb97$var$originalMouseX);
            left_1 = left_1 > 0 ? left_1 : 1;
            if (calculatedWidth !== $af188cccda90eb97$var$previousWidth && $af188cccda90eb97$var$setWidth) $af188cccda90eb97$var$targetElement.style.width = calculatedWidth + "px";
            if ($af188cccda90eb97$var$setLeft) {
                if (!($af188cccda90eb97$var$targetElement.classList.contains("e-dlg-modal") && $af188cccda90eb97$var$targetElement.style.left === "0px")) $af188cccda90eb97$var$targetElement.style.left = left_1 + "px";
                if (left_1 === 1) $af188cccda90eb97$var$setWidth = false;
                else $af188cccda90eb97$var$setWidth = true;
            }
        }
    }
    $af188cccda90eb97$var$previousWidth = calculatedWidth;
}
/**
 * Resizes the element towards the east direction.
 *
 * @param {MouseEvent | TouchEvent} e - The event object.
 * @returns {void}
 */ function $af188cccda90eb97$var$resizeEast(e) {
    var documentWidth = document.documentElement.clientWidth;
    var calculateValue = false;
    var containerRectValues;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$containerElement);
    var coordinates = e.touches ? e.changedTouches[0] : e;
    var pageX = coordinates.pageX;
    var targetRectValues = $af188cccda90eb97$var$getClientRectValues($af188cccda90eb97$var$targetElement);
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && (targetRectValues.left - containerRectValues.left + targetRectValues.width <= $af188cccda90eb97$var$maxWidth || targetRectValues.right - containerRectValues.left >= targetRectValues.width)) calculateValue = true;
    else if ((0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement) && documentWidth - pageX > 0) calculateValue = true;
    var calculatedWidth = $af188cccda90eb97$var$originalWidth + (pageX - $af188cccda90eb97$var$originalMouseX);
    var containerLeft = 0;
    if (!(0, $3EnZW.isNullOrUndefined)($af188cccda90eb97$var$containerElement)) containerLeft = containerRectValues.left;
    if (targetRectValues.left - containerLeft + calculatedWidth > $af188cccda90eb97$var$maxWidth) {
        calculateValue = false;
        if ($af188cccda90eb97$var$targetElement.classList.contains($af188cccda90eb97$var$RESIZE_WITHIN_VIEWPORT)) return;
        $af188cccda90eb97$var$targetElement.style.width = $af188cccda90eb97$var$maxWidth - (targetRectValues.left - containerLeft) + "px";
    }
    if (calculateValue) {
        if (calculatedWidth >= $af188cccda90eb97$var$minWidth && calculatedWidth <= $af188cccda90eb97$var$maxWidth) $af188cccda90eb97$var$targetElement.style.width = calculatedWidth + "px";
    }
}
function $af188cccda90eb97$export$3bfa2c4cca286692(minimumHeight) {
    $af188cccda90eb97$var$minHeight = minimumHeight;
}
function $af188cccda90eb97$export$c9cb974c6ac41893(value) {
    $af188cccda90eb97$var$maxWidth = value;
}
function $af188cccda90eb97$export$e6dec7f2e1126484(value) {
    $af188cccda90eb97$var$maxHeight = value;
}
function $af188cccda90eb97$export$96142f6056a13e2a() {
    var handlers = $af188cccda90eb97$var$targetElement.querySelectorAll("." + $af188cccda90eb97$var$RESIZE_HANDLER);
    for(var i = 0; i < handlers.length; i++)(0, $4ZDHT.detach)(handlers[i]);
    var borderResizers = $af188cccda90eb97$var$targetElement.querySelectorAll(".e-dialog-border-resize");
    if (!(0, $3EnZW.isNullOrUndefined)(borderResizers)) for(var i = 0; i < borderResizers.length; i++)(0, $4ZDHT.detach)(borderResizers[i]);
}
function $af188cccda90eb97$export$6e30fb825043d4b5() {
    $af188cccda90eb97$var$targetElement = null;
    $af188cccda90eb97$var$selectedHandler = null;
    $af188cccda90eb97$var$containerElement = null;
    $af188cccda90eb97$var$resizeWestWidth = null;
}


var $397c948d4a376450$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $397c948d4a376450$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $397c948d4a376450$export$7d29148a1857e804 = /** @class */ function(_super) {
    $397c948d4a376450$var$__extends(ButtonProps, _super);
    function ButtonProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ButtonProps.prototype, "isFlat", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)()
    ], ButtonProps.prototype, "buttonModel", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("Button")
    ], ButtonProps.prototype, "type", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], ButtonProps.prototype, "click", void 0);
    return ButtonProps;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the animation properties for both open and close the dialog.
 */ var $397c948d4a376450$export$438778f27a7500c = /** @class */ function(_super) {
    $397c948d4a376450$var$__extends(AnimationSettings, _super);
    function AnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("Fade")
    ], AnimationSettings.prototype, "effect", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(400)
    ], AnimationSettings.prototype, "duration", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AnimationSettings.prototype, "delay", void 0);
    return AnimationSettings;
}((0, $3fcxu.ChildProperty));
var $397c948d4a376450$var$ROOT = "e-dialog";
var $397c948d4a376450$var$RTL = "e-rtl";
var $397c948d4a376450$var$DLG_HEADER_CONTENT = "e-dlg-header-content";
var $397c948d4a376450$var$DLG_HEADER = "e-dlg-header";
var $397c948d4a376450$var$DLG_FOOTER_CONTENT = "e-footer-content";
var $397c948d4a376450$var$MODAL_DLG = "e-dlg-modal";
var $397c948d4a376450$var$DLG_CONTENT = "e-dlg-content";
var $397c948d4a376450$var$DLG_CLOSE_ICON = "e-icon-dlg-close";
var $397c948d4a376450$var$DLG_OVERLAY = "e-dlg-overlay";
var $397c948d4a376450$var$DLG_TARGET = "e-dlg-target";
var $397c948d4a376450$var$DLG_CONTAINER = "e-dlg-container";
var $397c948d4a376450$var$SCROLL_DISABLED = "e-scroll-disabled";
var $397c948d4a376450$var$DLG_PRIMARY_BUTTON = "e-primary";
var $397c948d4a376450$var$ICON = "e-icons";
var $397c948d4a376450$var$POPUP_ROOT = "e-popup";
var $397c948d4a376450$var$DEVICE = "e-device";
var $397c948d4a376450$var$FULLSCREEN = "e-dlg-fullscreen";
var $397c948d4a376450$var$DLG_CLOSE_ICON_BTN = "e-dlg-closeicon-btn";
var $397c948d4a376450$var$DLG_HIDE = "e-popup-close";
var $397c948d4a376450$var$DLG_SHOW = "e-popup-open";
var $397c948d4a376450$var$DLG_UTIL_DEFAULT_TITLE = "Information";
var $397c948d4a376450$var$DLG_UTIL_ROOT = "e-scroll-disabled";
var $397c948d4a376450$var$DLG_UTIL_ALERT = "e-alert-dialog";
var $397c948d4a376450$var$DLG_UTIL_CONFIRM = "e-confirm-dialog";
var $397c948d4a376450$var$DLG_RESIZABLE = "e-dlg-resizable";
var $397c948d4a376450$var$DLG_RESTRICT_LEFT_VALUE = "e-restrict-left";
var $397c948d4a376450$var$DLG_RESTRICT_WIDTH_VALUE = "e-resize-viewport";
var $397c948d4a376450$var$DLG_REF_ELEMENT = "e-dlg-ref-element";
var $397c948d4a376450$var$DLG_USER_ACTION_CLOSED = "user action";
var $397c948d4a376450$var$DLG_CLOSE_ICON_CLOSED = "close icon";
var $397c948d4a376450$var$DLG_ESCAPE_CLOSED = "escape";
var $397c948d4a376450$var$DLG_OVERLAYCLICK_CLOSED = "overlayClick";
var $397c948d4a376450$var$DLG_DRAG = "e-draggable";
/**
 * Represents the dialog component that displays the information and get input from the user.
 * Two types of dialog components are `Modal and Modeless (non-modal)` depending on its interaction with parent application.
 * ```html
 * <div id="dialog"></div>
 * ```
 * ```typescript
 * <script>
 *   var dialogObj = new Dialog({ header: 'Dialog' });
 *   dialogObj.appendTo("#dialog");
 * </script>
 * ```
 */ var $397c948d4a376450$export$3ddf2d174ce01153 = /** @class */ function(_super) {
    $397c948d4a376450$var$__extends(Dialog, _super);
    /*
     * * Constructor for creating the widget
     *
     * @param
     * @param
     * @hidden
     */ function Dialog(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.needsID = true;
        return _this;
    }
    /**
     *Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.render = function() {
        this.initialize();
        this.initRender();
        this.wireEvents();
        if (this.width === "100%") this.element.style.width = "";
        if (this.minHeight !== "") this.element.style.minHeight = (0, $3EnZW.formatUnit)(this.minHeight);
        if (this.enableResize) {
            this.setResize();
            if (this.animationSettings.effect === "None") this.getMinHeight();
        }
        this.renderComplete();
    };
    Dialog.prototype.initializeValue = function() {
        this.dlgClosedBy = $397c948d4a376450$var$DLG_USER_ACTION_CLOSED;
    };
    /**
     *Initialize the event handler
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.preRender = function() {
        var _this = this;
        this.initializeValue();
        this.headerContent = null;
        this.allowMaxHeight = true;
        this.preventVisibility = true;
        this.clonedEle = this.element.cloneNode(true);
        this.closeIconClickEventHandler = function(event) {
            _this.dlgClosedBy = $397c948d4a376450$var$DLG_CLOSE_ICON_CLOSED;
            _this.hide(event);
        };
        this.dlgOverlayClickEventHandler = function(event) {
            _this.dlgClosedBy = $397c948d4a376450$var$DLG_OVERLAYCLICK_CLOSED;
            event.preventFocus = false;
            _this.trigger("overlayClick", event, function(overlayClickEventArgs) {
                if (!overlayClickEventArgs.preventFocus) _this.focusContent();
                _this.dlgClosedBy = $397c948d4a376450$var$DLG_USER_ACTION_CLOSED;
            });
        };
        var localeText = {
            close: "Close"
        };
        this.l10n = new (0, $e7i2H.L10n)("dialog", localeText, this.locale);
        this.checkPositionData();
        if ((0, $3EnZW.isNullOrUndefined)(this.target)) {
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.target = document.body;
            this.isProtectedOnChange = prevOnChange;
        }
    };
    Dialog.prototype.updatePersistData = function() {
        if (this.enablePersistence) this.setProperties({
            width: parseFloat(this.element.style.width),
            height: parseFloat(this.element.style.height),
            position: {
                X: parseFloat(this.dragObj.element.style.left),
                Y: parseFloat(this.dragObj.element.style.top)
            }
        }, true);
    };
    Dialog.prototype.isNumberValue = function(value) {
        var isNumber = /^[-+]?\d*\.?\d+$/.test(value);
        return isNumber;
    };
    Dialog.prototype.checkPositionData = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.position)) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.position.X) && typeof this.position.X !== "number") {
                var isNumber = this.isNumberValue(this.position.X);
                if (isNumber) {
                    var prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    this.position.X = parseFloat(this.position.X);
                    this.isProtectedOnChange = prevOnChange;
                }
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.position.Y) && typeof this.position.Y !== "number") {
                var isNumber = this.isNumberValue(this.position.Y);
                if (isNumber) {
                    var prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    this.position.Y = parseFloat(this.position.Y);
                    this.isProtectedOnChange = prevOnChange;
                }
            }
        }
    };
    Dialog.prototype.getEle = function(list, selector) {
        var element = undefined;
        for(var i = 0; i < list.length; i++)if (list[i].classList.contains(selector)) {
            element = list[i];
            break;
        }
        return element;
    };
    /* istanbul ignore next */ Dialog.prototype.getMinHeight = function() {
        var computedHeaderHeight = "0px";
        var computedFooterHeight = "0px";
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelector("." + $397c948d4a376450$var$DLG_HEADER_CONTENT))) computedHeaderHeight = getComputedStyle(this.headerContent).height;
        var footerEle = this.getEle(this.element.children, $397c948d4a376450$var$DLG_FOOTER_CONTENT);
        if (!(0, $3EnZW.isNullOrUndefined)(footerEle)) computedFooterHeight = getComputedStyle(footerEle).height;
        var headerHeight = parseInt(computedHeaderHeight.slice(0, computedHeaderHeight.indexOf("p")), 10);
        var footerHeight = parseInt(computedFooterHeight.slice(0, computedFooterHeight.indexOf("p")), 10);
        (0, $af188cccda90eb97$export$3bfa2c4cca286692)(headerHeight + 30 + (isNaN(footerHeight) ? 0 : footerHeight));
        return headerHeight + 30 + footerHeight;
    };
    Dialog.prototype.onResizeStart = function(args, dialogObj) {
        dialogObj.trigger("resizeStart", args);
        return args.cancel;
    };
    Dialog.prototype.onResizing = function(args, dialogObj) {
        dialogObj.trigger("resizing", args);
    };
    Dialog.prototype.onResizeComplete = function(args, dialogObj) {
        dialogObj.trigger("resizeStop", args);
        this.updatePersistData();
    };
    Dialog.prototype.setResize = function() {
        if (this.enableResize) {
            this.element.classList.add($397c948d4a376450$var$DLG_RESIZABLE);
            var computedHeight = getComputedStyle(this.element).minHeight;
            var computedWidth = getComputedStyle(this.element).minWidth;
            var direction = "";
            for(var i = 0; i < this.resizeHandles.length; i++)if (this.resizeHandles[i] === "All") {
                direction = "south north east west north-east north-west south-east south-west";
                break;
            } else {
                var directionValue = "";
                switch(this.resizeHandles[i].toString()){
                    case "SouthEast":
                        directionValue = "south-east";
                        break;
                    case "SouthWest":
                        directionValue = "south-west";
                        break;
                    case "NorthEast":
                        directionValue = "north-east";
                        break;
                    case "NorthWest":
                        directionValue = "north-west";
                        break;
                    default:
                        directionValue = this.resizeHandles[i].toString();
                        break;
                }
                direction += directionValue.toLocaleLowerCase() + " ";
            }
            if (this.enableRtl && direction.trim() === "south-east") direction = "south-west";
            else if (this.enableRtl && direction.trim() === "south-west") direction = "south-east";
            if (this.isModal && this.enableRtl) this.element.classList.add($397c948d4a376450$var$DLG_RESTRICT_LEFT_VALUE);
            else if (this.isModal && this.target === document.body) this.element.classList.add($397c948d4a376450$var$DLG_RESTRICT_WIDTH_VALUE);
            (0, $af188cccda90eb97$export$58909557046ca413)({
                element: this.element,
                direction: direction,
                minHeight: parseInt(computedHeight.slice(0, computedWidth.indexOf("p")), 10),
                maxHeight: this.targetEle.clientHeight,
                minWidth: parseInt(computedWidth.slice(0, computedWidth.indexOf("p")), 10),
                maxWidth: this.targetEle.clientWidth,
                boundary: this.target === document.body ? null : this.targetEle,
                resizeBegin: this.onResizeStart.bind(this),
                resizeComplete: this.onResizeComplete.bind(this),
                resizing: this.onResizing.bind(this),
                proxy: this
            });
            this.wireWindowResizeEvent();
        } else {
            (0, $af188cccda90eb97$export$96142f6056a13e2a)();
            this.unWireWindowResizeEvent();
            if (this.isModal) this.element.classList.remove($397c948d4a376450$var$DLG_RESTRICT_LEFT_VALUE);
            else this.element.classList.remove($397c948d4a376450$var$DLG_RESTRICT_WIDTH_VALUE);
            this.element.classList.remove($397c948d4a376450$var$DLG_RESIZABLE);
        }
    };
    Dialog.prototype.getFocusElement = function(target) {
        var value = 'input,select,textarea,button:enabled,a,[contenteditable="true"],[tabindex]';
        var items = target.querySelectorAll(value);
        return {
            element: items[items.length - 1]
        };
    };
    /* istanbul ignore next */ Dialog.prototype.keyDown = function(event) {
        var _this = this;
        if (event.keyCode === 9) {
            if (this.isModal) {
                var buttonObj = void 0;
                if (!(0, $3EnZW.isNullOrUndefined)(this.btnObj)) buttonObj = this.btnObj[this.btnObj.length - 1];
                if ((0, $3EnZW.isNullOrUndefined)(this.btnObj) && !(0, $3EnZW.isNullOrUndefined)(this.ftrTemplateContent)) buttonObj = this.getFocusElement(this.ftrTemplateContent);
                if ((0, $3EnZW.isNullOrUndefined)(this.btnObj) && (0, $3EnZW.isNullOrUndefined)(this.ftrTemplateContent) && !(0, $3EnZW.isNullOrUndefined)(this.contentEle)) buttonObj = this.getFocusElement(this.contentEle);
                if (!(0, $3EnZW.isNullOrUndefined)(buttonObj) && document.activeElement === buttonObj.element && !event.shiftKey) {
                    event.preventDefault();
                    this.focusableElements(this.element).focus();
                }
                if (document.activeElement === this.focusableElements(this.element) && event.shiftKey) {
                    event.preventDefault();
                    if (!(0, $3EnZW.isNullOrUndefined)(buttonObj)) buttonObj.element.focus();
                }
            }
        }
        var element = document.activeElement;
        var isTagName = [
            "input",
            "textarea"
        ].indexOf(element.tagName.toLowerCase()) > -1;
        var isContentEdit = false;
        if (!isTagName) isContentEdit = element.hasAttribute("contenteditable") && element.getAttribute("contenteditable") === "true";
        if (event.keyCode === 27 && this.closeOnEscape) {
            this.dlgClosedBy = $397c948d4a376450$var$DLG_ESCAPE_CLOSED;
            var query = document.querySelector(".e-popup-open:not(.e-dialog)");
            // 'document.querySelector' is used to find the elements rendered based on body
            if (!(!(0, $3EnZW.isNullOrUndefined)(query) && !query.classList.contains("e-toolbar-pop"))) this.hide(event);
        }
        if (event.keyCode === 13 && !event.ctrlKey && element.tagName.toLowerCase() !== "textarea" && isTagName && !(0, $3EnZW.isNullOrUndefined)(this.primaryButtonEle) || event.keyCode === 13 && event.ctrlKey && (element.tagName.toLowerCase() === "textarea" || isContentEdit) && !(0, $3EnZW.isNullOrUndefined)(this.primaryButtonEle)) {
            var buttonIndex_1;
            var firstPrimary = this.buttons.some(function(data, index) {
                buttonIndex_1 = index;
                var buttonModel = data.buttonModel;
                return !(0, $3EnZW.isNullOrUndefined)(buttonModel) && buttonModel.isPrimary === true;
            });
            if (firstPrimary && typeof this.buttons[buttonIndex_1].click === "function") setTimeout(function() {
                _this.buttons[buttonIndex_1].click.call(_this, event);
            });
        }
    };
    /**
     * Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.initialize = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.target)) this.targetEle = typeof this.target === "string" ? document.querySelector(this.target) : this.target;
        if (!this.isBlazorServerRender()) (0, $4ZDHT.addClass)([
            this.element
        ], $397c948d4a376450$var$ROOT);
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.addClass)([
            this.element
        ], $397c948d4a376450$var$DEVICE);
        if (!this.isBlazorServerRender()) this.setCSSClass();
        this.setMaxHeight();
    };
    /**
     * Initialize the rendering
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.initRender = function() {
        var _this = this;
        this.initialRender = true;
        if (!this.isBlazorServerRender()) (0, $4ZDHT.attributes)(this.element, {
            role: "dialog"
        });
        if (this.zIndex === 1000) {
            this.setzIndex(this.element, false);
            this.calculatezIndex = true;
        } else this.calculatezIndex = false;
        this.setTargetContent();
        if (this.header !== "" && !(0, $3EnZW.isNullOrUndefined)(this.header)) this.setHeader();
        this.renderCloseIcon();
        this.setContent();
        if (this.footerTemplate !== "" && !(0, $3EnZW.isNullOrUndefined)(this.footerTemplate)) this.setFooterTemplate();
        else if (!(0, $3EnZW.isNullOrUndefined)(this.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.buttons[0].buttonModel)) this.setButton();
        if (this.allowDragging && !(0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.setAllowDragging();
        (0, $4ZDHT.attributes)(this.element, {
            "aria-modal": this.isModal ? "true" : "false"
        });
        if (this.isModal) this.setIsModal();
        if (this.element.classList.contains($397c948d4a376450$var$DLG_UTIL_ALERT) !== true && this.element.classList.contains($397c948d4a376450$var$DLG_UTIL_CONFIRM) !== true && !(0, $3EnZW.isNullOrUndefined)(this.element.parentElement)) {
            var parentEle = this.isModal ? this.dlgContainer.parentElement : this.element.parentElement;
            this.refElement = this.createElement("div", {
                className: $397c948d4a376450$var$DLG_REF_ELEMENT
            });
            parentEle.insertBefore(this.refElement, this.isModal ? this.dlgContainer : this.element);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.targetEle)) {
            if (this.isModal) this.targetEle.appendChild(this.dlgContainer);
            else this.targetEle.appendChild(this.element);
        }
        this.popupObj = new (0, $2vAqh.Popup)(this.element, {
            height: this.height,
            width: this.width,
            zIndex: this.zIndex,
            relateTo: this.target,
            actionOnScroll: "none",
            enableRtl: this.enableRtl,
            // eslint-disable-next-line
            open: function(event) {
                var eventArgs = {
                    container: _this.isModal ? _this.dlgContainer : _this.element,
                    element: _this.element,
                    target: _this.target,
                    preventFocus: false
                };
                if (_this.enableResize) _this.resetResizeIcon();
                _this.trigger("open", eventArgs, function(openEventArgs) {
                    if (!openEventArgs.preventFocus) _this.focusContent();
                });
            },
            // eslint-disable-next-line
            close: function(event) {
                if (_this.isModal) (0, $4ZDHT.addClass)([
                    _this.dlgOverlay
                ], "e-fade");
                _this.unBindEvent(_this.element);
                if (_this.isModal) _this.dlgContainer.style.display = "none";
                _this.trigger("close", _this.closeArgs);
                var activeEle = document.activeElement;
                if (!(0, $3EnZW.isNullOrUndefined)(activeEle) && !(0, $3EnZW.isNullOrUndefined)(activeEle.blur)) activeEle.blur();
                if (!(0, $3EnZW.isNullOrUndefined)(_this.storeActiveElement) && !(0, $3EnZW.isNullOrUndefined)(_this.storeActiveElement.focus)) _this.storeActiveElement.focus();
            }
        });
        this.positionChange();
        this.setEnableRTL();
        if (!this.isBlazorServerRender()) {
            (0, $4ZDHT.addClass)([
                this.element
            ], $397c948d4a376450$var$DLG_HIDE);
            if (this.isModal) this.setOverlayZindex();
        }
        if (this.visible) {
            this.show();
            if (this.isModal) {
                var targetType = this.getTargetContainer(this.target);
                if (targetType instanceof Element) {
                    var computedStyle = window.getComputedStyle(targetType);
                    if (computedStyle.getPropertyValue("direction") === "rtl") this.setPopupPosition();
                }
            }
        } else if (this.isModal) this.dlgOverlay.style.display = "none";
        this.initialRender = false;
    };
    Dialog.prototype.getTargetContainer = function(targetValue) {
        var targetElement = null;
        if (typeof targetValue === "string") {
            if (targetValue.startsWith("#")) targetElement = document.getElementById(targetValue.substring(1));
            else if (targetValue.startsWith(".")) {
                var elements = document.getElementsByClassName(targetValue.substring(1));
                targetElement = elements.length > 0 ? elements[0] : null;
            } else if (!(targetValue instanceof HTMLElement) && targetValue !== document.body) targetElement = document.querySelector(targetValue);
        } else if (targetValue instanceof HTMLElement) targetElement = targetValue;
        return targetElement;
    };
    Dialog.prototype.resetResizeIcon = function() {
        var dialogConHeight = this.getMinHeight();
        if (this.targetEle.offsetHeight < dialogConHeight) {
            var className = this.enableRtl ? "e-south-west" : "e-south-east";
            var resizeIcon = this.element.querySelector("." + className);
            if (!(0, $3EnZW.isNullOrUndefined)(resizeIcon)) resizeIcon.style.bottom = "-" + dialogConHeight.toString() + "px";
        }
    };
    Dialog.prototype.setOverlayZindex = function(zIndexValue) {
        var zIndex;
        if ((0, $3EnZW.isNullOrUndefined)(zIndexValue)) zIndex = parseInt(this.element.style.zIndex, 10) ? parseInt(this.element.style.zIndex, 10) : this.zIndex;
        else zIndex = zIndexValue;
        this.dlgOverlay.style.zIndex = (zIndex - 1).toString();
        this.dlgContainer.style.zIndex = zIndex.toString();
    };
    Dialog.prototype.positionChange = function() {
        if (this.isModal) {
            if (!isNaN(parseFloat(this.position.X)) && !isNaN(parseFloat(this.position.Y))) this.setPopupPosition();
            else if (!isNaN(parseFloat(this.position.X)) && isNaN(parseFloat(this.position.Y)) || isNaN(parseFloat(this.position.X)) && !isNaN(parseFloat(this.position.Y))) this.setPopupPosition();
            else {
                this.element.style.top = "0px";
                this.element.style.left = "0px";
                this.dlgContainer.classList.add("e-dlg-" + this.position.X + "-" + this.position.Y);
            }
        } else this.setPopupPosition();
    };
    Dialog.prototype.setPopupPosition = function() {
        this.popupObj.setProperties({
            position: {
                X: this.position.X,
                Y: this.position.Y
            }
        });
    };
    Dialog.prototype.setAllowDragging = function() {
        var _this = this;
        var handleContent = "." + $397c948d4a376450$var$DLG_HEADER_CONTENT;
        if (!this.element.classList.contains($397c948d4a376450$var$DLG_DRAG)) {
            this.dragObj = new (0, $eAUyT.Draggable)(this.element, {
                clone: false,
                isDragScroll: true,
                abort: ".e-dlg-closeicon-btn",
                handle: handleContent,
                dragStart: function(event) {
                    _this.trigger("dragStart", event, function(dragEventArgs) {
                        if ((0, $3EnZW.isBlazor)()) dragEventArgs.bindEvents(event.dragElement);
                    });
                },
                dragStop: function(event) {
                    if (_this.isModal) {
                        _this.IsDragStop = true;
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.position)) _this.dlgContainer.classList.remove("e-dlg-" + _this.position.X + "-" + _this.position.Y);
                        // Reset the dialog position after drag completion.
                        var targetType = _this.getTargetContainer(_this.target);
                        if (targetType instanceof Element) {
                            var computedStyle = window.getComputedStyle(targetType);
                            if (computedStyle.getPropertyValue("direction") === "rtl") _this.element.style.position = "absolute";
                            else _this.element.style.position = "relative";
                        } else _this.element.style.position = "relative";
                    }
                    _this.trigger("dragStop", event);
                    _this.element.classList.remove($397c948d4a376450$var$DLG_RESTRICT_LEFT_VALUE);
                    _this.updatePersistData();
                },
                drag: function(event) {
                    _this.trigger("drag", event);
                }
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.targetEle)) this.dragObj.dragArea = this.targetEle;
        }
    };
    Dialog.prototype.setButton = function() {
        if (!this.isBlazorServerRender()) {
            this.buttonContent = [];
            this.btnObj = [];
            for(var i = 0; i < this.buttons.length; i++){
                if ((0, $3EnZW.isNullOrUndefined)(this.buttons[i].buttonModel)) continue;
                var buttonType = !(0, $3EnZW.isNullOrUndefined)(this.buttons[i].type) ? this.buttons[i].type.toLowerCase() : "button";
                var btn = this.createElement("button", {
                    className: this.cssClass,
                    attrs: {
                        type: buttonType
                    }
                });
                this.buttonContent.push(btn.outerHTML);
            }
            this.setFooterTemplate();
        }
        var footerBtn;
        for(var i = 0, childNodes = this.element.children; i < childNodes.length; i++)if (childNodes[i].classList.contains($397c948d4a376450$var$DLG_FOOTER_CONTENT)) footerBtn = childNodes[i].querySelectorAll("button");
        for(var i = 0; i < this.buttons.length; i++){
            if ((0, $3EnZW.isNullOrUndefined)(this.buttons[i].buttonModel)) continue;
            if (!this.isBlazorServerRender()) this.btnObj[i] = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)(this.buttons[i].buttonModel);
            if (!(0, $3EnZW.isNullOrUndefined)(this.ftrTemplateContent) && footerBtn.length > 0) {
                if (typeof this.buttons[i].click === "function") (0, $aqzbR.EventHandler).add(footerBtn[i], "click", this.buttons[i].click, this);
                if (typeof this.buttons[i].click === "object") (0, $aqzbR.EventHandler).add(footerBtn[i], "click", this.buttonClickHandler.bind(this, i), this);
            }
            if (!this.isBlazorServerRender() && !(0, $3EnZW.isNullOrUndefined)(this.ftrTemplateContent)) {
                this.btnObj[i].appendTo(this.ftrTemplateContent.children[i]);
                if (this.buttons[i].isFlat) this.btnObj[i].element.classList.add("e-flat");
                this.primaryButtonEle = this.element.getElementsByClassName("e-primary")[0];
            }
        }
    };
    Dialog.prototype.buttonClickHandler = function(index) {
        this.trigger("buttons[" + index + "].click", {});
    };
    Dialog.prototype.setContent = function() {
        this.contentEle = this.createElement("div", {
            className: $397c948d4a376450$var$DLG_CONTENT,
            id: this.element.id + "_dialog-content"
        });
        if (this.headerEle) (0, $4ZDHT.attributes)(this.element, {
            "aria-describedby": this.element.id + "_title" + " " + this.element.id + "_dialog-content"
        });
        else (0, $4ZDHT.attributes)(this.element, {
            "aria-describedby": this.element.id + "_dialog-content"
        });
        if (this.innerContentElement) this.contentEle.appendChild(this.innerContentElement);
        else if (!(0, $3EnZW.isNullOrUndefined)(this.content) && this.content !== "" || !this.initialRender) {
            if (typeof this.content === "string" && !(0, $3EnZW.isBlazor)()) this.setTemplate(this.content, this.contentEle, "content");
            else if (this.content instanceof HTMLElement) this.contentEle.appendChild(this.content);
            else this.setTemplate(this.content, this.contentEle, "content");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.element.insertBefore(this.contentEle, this.element.children[1]);
        else this.element.insertBefore(this.contentEle, this.element.children[0]);
        if (this.height === "auto") {
            if (!this.isBlazorServerRender() && (0, $5q7BP.Browser).isIE && this.element.style.width === "" && !(0, $3EnZW.isNullOrUndefined)(this.width)) this.element.style.width = (0, $3EnZW.formatUnit)(this.width);
            this.setMaxHeight();
        }
    };
    Dialog.prototype.setTemplate = function(template, toElement, prop) {
        var templateFn;
        var templateProps;
        if (toElement.classList.contains($397c948d4a376450$var$DLG_HEADER)) templateProps = this.element.id + "header";
        else if (toElement.classList.contains($397c948d4a376450$var$DLG_FOOTER_CONTENT)) templateProps = this.element.id + "footerTemplate";
        else templateProps = this.element.id + "content";
        var templateValue;
        if (!(0, $3EnZW.isNullOrUndefined)(template.outerHTML)) toElement.appendChild(template);
        else if (typeof template === "string" || typeof template !== "string" || (0, $3EnZW.isBlazor)() && !this.isStringTemplate) {
            if (typeof template === "string") template = this.sanitizeHelper(template);
            if (this.isVue || typeof template !== "string") {
                templateFn = (0, $c2qqN.compile)(template);
                templateValue = template;
            } else toElement.innerHTML = template;
        }
        var fromElements = [];
        if (!(0, $3EnZW.isNullOrUndefined)(templateFn)) {
            var isString = (0, $3EnZW.isBlazor)() && !this.isStringTemplate && templateValue.indexOf("<div>Blazor") === 0 ? this.isStringTemplate : true;
            for(var _i = 0, _a = templateFn({}, this, prop, templateProps, isString); _i < _a.length; _i++){
                var item = _a[_i];
                fromElements.push(item);
            }
            (0, $4ZDHT.append)([].slice.call(fromElements), toElement);
        }
    };
    /*
     * @returns {void}
     * @hidden
     * @value
     */ Dialog.prototype.sanitizeHelper = function(value) {
        if (this.enableHtmlSanitizer) {
            var dialogItem = (0, $3P3ke.SanitizeHtmlHelper).beforeSanitize();
            var beforeEvent = {
                cancel: false,
                helper: null
            };
            (0, $3EnZW.extend)(dialogItem, dialogItem, beforeEvent);
            this.trigger("beforeSanitizeHtml", dialogItem);
            if (dialogItem.cancel && !(0, $3EnZW.isNullOrUndefined)(dialogItem.helper)) value = dialogItem.helper(value);
            else if (!dialogItem.cancel) value = (0, $3P3ke.SanitizeHtmlHelper).serializeValue(dialogItem, value);
        }
        return value;
    };
    Dialog.prototype.setMaxHeight = function() {
        if (!this.allowMaxHeight) return;
        var display = this.element.style.display;
        this.element.style.display = "none";
        this.element.style.maxHeight = !(0, $3EnZW.isNullOrUndefined)(this.target) && this.targetEle.offsetHeight < window.innerHeight ? this.targetEle.offsetHeight - 20 + "px" : window.innerHeight - 20 + "px";
        this.element.style.display = display;
        if ((0, $5q7BP.Browser).isIE && this.height === "auto" && !(0, $3EnZW.isNullOrUndefined)(this.contentEle) && this.element.offsetHeight < this.contentEle.offsetHeight) this.element.style.height = "inherit";
    };
    Dialog.prototype.setEnableRTL = function() {
        if (!this.isBlazorServerRender()) {
            if (this.enableRtl) (0, $4ZDHT.addClass)([
                this.element
            ], $397c948d4a376450$var$RTL);
            else (0, $4ZDHT.removeClass)([
                this.element
            ], $397c948d4a376450$var$RTL);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-resize-handle"))) {
            (0, $af188cccda90eb97$export$96142f6056a13e2a)();
            this.setResize();
        }
    };
    Dialog.prototype.setTargetContent = function() {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(this.content) || this.content === "") {
            var isContent = this.element.innerHTML.replace(/\s|<(\/?|\/?)(!--!--)>/g, "") !== "";
            if (this.element.children.length > 0 || isContent) {
                this.innerContentElement = document.createDocumentFragment();
                [].slice.call(this.element.childNodes).forEach(function(el) {
                    if (el.nodeType !== 8) _this.innerContentElement.appendChild(el);
                });
            }
        }
    };
    Dialog.prototype.setHeader = function() {
        if (this.headerEle) this.headerEle.innerHTML = "";
        else this.headerEle = this.createElement("div", {
            id: this.element.id + "_title",
            className: $397c948d4a376450$var$DLG_HEADER
        });
        this.createHeaderContent();
        this.headerContent.appendChild(this.headerEle);
        this.setTemplate(this.header, this.headerEle, "header");
        (0, $4ZDHT.attributes)(this.element, {
            "aria-describedby": this.element.id + "_title"
        });
        (0, $4ZDHT.attributes)(this.element, {
            "aria-label": "dialog"
        });
        this.element.insertBefore(this.headerContent, this.element.children[0]);
        if (this.allowDragging && !(0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.setAllowDragging();
    };
    Dialog.prototype.setFooterTemplate = function() {
        if (this.ftrTemplateContent) this.ftrTemplateContent.innerHTML = "";
        else this.ftrTemplateContent = this.createElement("div", {
            className: $397c948d4a376450$var$DLG_FOOTER_CONTENT
        });
        if (this.footerTemplate !== "" && !(0, $3EnZW.isNullOrUndefined)(this.footerTemplate)) this.setTemplate(this.footerTemplate, this.ftrTemplateContent, "footerTemplate");
        else this.ftrTemplateContent.innerHTML = this.buttonContent.join("");
        this.element.appendChild(this.ftrTemplateContent);
    };
    Dialog.prototype.createHeaderContent = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.headerContent = this.createElement("div", {
            id: this.element.id + "_dialog-header",
            className: $397c948d4a376450$var$DLG_HEADER_CONTENT
        });
    };
    Dialog.prototype.renderCloseIcon = function() {
        if (this.showCloseIcon) {
            this.closeIcon = this.createElement("button", {
                className: $397c948d4a376450$var$DLG_CLOSE_ICON_BTN,
                attrs: {
                    type: "button"
                }
            });
            this.closeIconBtnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                cssClass: "e-flat",
                iconCss: $397c948d4a376450$var$DLG_CLOSE_ICON + " " + $397c948d4a376450$var$ICON
            });
            this.closeIconTitle();
            if (!(0, $3EnZW.isNullOrUndefined)(this.headerContent)) (0, $4ZDHT.prepend)([
                this.closeIcon
            ], this.headerContent);
            else {
                this.createHeaderContent();
                (0, $4ZDHT.prepend)([
                    this.closeIcon
                ], this.headerContent);
                this.element.insertBefore(this.headerContent, this.element.children[0]);
            }
            this.closeIconBtnObj.appendTo(this.closeIcon);
        }
    };
    Dialog.prototype.closeIconTitle = function() {
        this.l10n.setLocale(this.locale);
        var closeIconTitle = this.l10n.getConstant("close");
        this.closeIcon.setAttribute("title", closeIconTitle);
        this.closeIcon.setAttribute("aria-label", closeIconTitle);
    };
    Dialog.prototype.setCSSClass = function(oldCSSClass) {
        if (oldCSSClass) {
            (0, $4ZDHT.removeClass)([
                this.element
            ], oldCSSClass.split(" "));
            if (this.isModal && !(0, $3EnZW.isNullOrUndefined)(this.dlgContainer)) (0, $4ZDHT.removeClass)([
                this.dlgContainer
            ], oldCSSClass.split(" "));
        }
        if (this.cssClass) {
            (0, $4ZDHT.addClass)([
                this.element
            ], this.cssClass.split(" "));
            if (this.isModal && !(0, $3EnZW.isNullOrUndefined)(this.dlgContainer)) (0, $4ZDHT.addClass)([
                this.dlgContainer
            ], this.cssClass.split(" "));
        }
    };
    Dialog.prototype.setIsModal = function() {
        this.dlgContainer = this.createElement("div", {
            className: $397c948d4a376450$var$DLG_CONTAINER
        });
        this.setCSSClass();
        this.element.classList.remove($397c948d4a376450$var$DLG_SHOW);
        this.element.parentNode.insertBefore(this.dlgContainer, this.element);
        this.dlgContainer.appendChild(this.element);
        (0, $4ZDHT.addClass)([
            this.element
        ], $397c948d4a376450$var$MODAL_DLG);
        this.dlgOverlay = this.createElement("div", {
            className: $397c948d4a376450$var$DLG_OVERLAY
        });
        this.dlgOverlay.style.zIndex = (this.zIndex - 1).toString();
        this.dlgContainer.appendChild(this.dlgOverlay);
    };
    Dialog.prototype.getValidFocusNode = function(items) {
        var node;
        for(var u = 0; u < items.length; u++){
            node = items[u];
            if ((node.clientHeight > 0 || node.tagName.toLowerCase() === "a" && node.hasAttribute("href")) && node.tabIndex > -1 && !node.disabled && !this.disableElement(node, '[disabled],[aria-disabled="true"],[type="hidden"]')) return node;
            else node = null;
        }
        return node;
    };
    Dialog.prototype.focusableElements = function(content) {
        if (!(0, $3EnZW.isNullOrUndefined)(content)) {
            var value = 'input,select,textarea,button,a,[contenteditable="true"],[tabindex]';
            var items = content.querySelectorAll(value);
            return this.getValidFocusNode(items);
        }
        return null;
    };
    Dialog.prototype.getAutoFocusNode = function(container) {
        var node = container.querySelector("." + $397c948d4a376450$var$DLG_CLOSE_ICON_BTN);
        var value = "[autofocus]";
        var items = container.querySelectorAll(value);
        var validNode = this.getValidFocusNode(items);
        if ((0, $3EnZW.isBlazor)()) this.primaryButtonEle = this.element.getElementsByClassName("e-primary")[0];
        if (!(0, $3EnZW.isNullOrUndefined)(validNode)) node = validNode;
        else {
            validNode = this.focusableElements(this.contentEle);
            if (!(0, $3EnZW.isNullOrUndefined)(validNode)) return node = validNode;
            else if (!(0, $3EnZW.isNullOrUndefined)(this.primaryButtonEle)) return this.element.querySelector("." + $397c948d4a376450$var$DLG_PRIMARY_BUTTON);
        }
        return node;
    };
    Dialog.prototype.disableElement = function(element, t) {
        var elementMatch = element ? element.matches || element.webkitMatchesSelector || element.msGetRegionContent : null;
        if (elementMatch) for(; element; element = element.parentNode){
            if (element instanceof Element && elementMatch.call(element, t)) /* istanbul ignore next */ return element;
        }
        return null;
    };
    Dialog.prototype.focusContent = function() {
        var element = this.getAutoFocusNode(this.element);
        var node = !(0, $3EnZW.isNullOrUndefined)(element) ? element : this.element;
        var userAgent = (0, $5q7BP.Browser).userAgent;
        if (userAgent.indexOf("MSIE ") > 0 || userAgent.indexOf("Trident/") > 0) this.element.focus();
        node.focus();
        this.unBindEvent(this.element);
        this.bindEvent(this.element);
    };
    Dialog.prototype.bindEvent = function(element) {
        (0, $aqzbR.EventHandler).add(element, "keydown", this.keyDown, this);
    };
    Dialog.prototype.unBindEvent = function(element) {
        (0, $aqzbR.EventHandler).remove(element, "keydown", this.keyDown);
    };
    Dialog.prototype.updateSanitizeContent = function() {
        if (!this.isBlazorServerRender()) this.contentEle.innerHTML = this.sanitizeHelper(this.content);
    };
    Dialog.prototype.isBlazorServerRender = function() {
        return (0, $3EnZW.isBlazor)() && this.isServerRendered;
    };
    /**
     * Module required function
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.getModuleName = function() {
        return "dialog";
    };
    /**
     * Called internally if any of the property value changed
     *
     * @param {DialogModel} newProp - specifies the new property
     * @param {DialogModel} oldProp - specifies the old property
     * @private
     * @returns {void}
     */ Dialog.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (!this.element.classList.contains($397c948d4a376450$var$ROOT)) return;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "content":
                    if (!(0, $3EnZW.isNullOrUndefined)(this.content) && this.content !== "") {
                        if (this.isBlazorServerRender()) this.contentEle = this.element.querySelector(".e-dlg-content");
                        if (!(0, $3EnZW.isNullOrUndefined)(this.contentEle) && this.contentEle.getAttribute("role") !== "dialog") {
                            if (!this.isBlazorServerRender()) this.contentEle.innerHTML = "";
                            if (typeof this.content === "function") {
                                this.clearTemplate([
                                    "content"
                                ]);
                                (0, $4ZDHT.detach)(this.contentEle);
                                this.contentEle = null;
                                this.setContent();
                            } else if (typeof this.content === "string") this.updateSanitizeContent();
                            else this.contentEle.appendChild(this.content);
                            this.setMaxHeight();
                        } else this.setContent();
                    } else if (!(0, $3EnZW.isNullOrUndefined)(this.contentEle)) {
                        (0, $4ZDHT.detach)(this.contentEle);
                        this.contentEle = null;
                    }
                    break;
                case "header":
                    if (this.header === "" || (0, $3EnZW.isNullOrUndefined)(this.header)) {
                        if (this.headerEle) {
                            (0, $4ZDHT.detach)(this.headerEle);
                            this.headerEle = null;
                        }
                    } else this.setHeader();
                    break;
                case "footerTemplate":
                    if (this.footerTemplate === "" || (0, $3EnZW.isNullOrUndefined)(this.footerTemplate)) {
                        if (!this.ftrTemplateContent) return;
                        (0, $4ZDHT.detach)(this.ftrTemplateContent);
                        this.ftrTemplateContent = null;
                        this.buttons = [
                            {}
                        ];
                    } else {
                        this.setFooterTemplate();
                        this.buttons = [
                            {}
                        ];
                    }
                    break;
                case "showCloseIcon":
                    if (this.element.getElementsByClassName($397c948d4a376450$var$DLG_CLOSE_ICON).length > 0) {
                        if (!this.showCloseIcon && (this.header === "" || (0, $3EnZW.isNullOrUndefined)(this.header))) {
                            (0, $4ZDHT.detach)(this.headerContent);
                            this.headerContent = null;
                        } else if (!this.showCloseIcon) (0, $4ZDHT.detach)(this.closeIcon);
                    } else {
                        this.renderCloseIcon();
                        this.wireEvents();
                    }
                    break;
                case "locale":
                    if (this.showCloseIcon) this.closeIconTitle();
                    break;
                case "visible":
                    if (this.visible) this.show();
                    else this.hide();
                    break;
                case "isModal":
                    this.updateIsModal();
                    break;
                case "height":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "height": (0, $3EnZW.formatUnit)(newProp.height)
                    });
                    this.updatePersistData();
                    break;
                case "width":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "width": (0, $3EnZW.formatUnit)(newProp.width)
                    });
                    this.updatePersistData();
                    break;
                case "zIndex":
                    this.popupObj.zIndex = this.zIndex;
                    if (this.isModal) this.setOverlayZindex(this.zIndex);
                    if (this.element.style.zIndex !== this.zIndex.toString()) this.calculatezIndex = false;
                    break;
                case "cssClass":
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case "buttons":
                    this.unWireButtonEvents();
                    this.destroyButtons();
                    if (!(0, $3EnZW.isNullOrUndefined)(this.ftrTemplateContent)) {
                        (0, $4ZDHT.detach)(this.ftrTemplateContent);
                        this.ftrTemplateContent = null;
                    }
                    this.footerTemplate = "";
                    this.setButton();
                    break;
                case "allowDragging":
                    if (this.allowDragging && !(0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.setAllowDragging();
                    else this.dragObj.destroy();
                    break;
                case "target":
                    this.setTarget(newProp.target);
                    break;
                case "position":
                    this.checkPositionData();
                    if (this.isModal) {
                        var positionX = this.position.X;
                        var positionY = this.position.Y;
                        if (!(0, $3EnZW.isNullOrUndefined)(oldProp.position)) {
                            if (!(0, $3EnZW.isNullOrUndefined)(oldProp.position.X)) positionX = oldProp.position.X;
                            if (!(0, $3EnZW.isNullOrUndefined)(oldProp.position.Y)) positionY = oldProp.position.Y;
                        }
                        if (this.dlgContainer.classList.contains("e-dlg-" + positionX + "-" + positionY)) this.dlgContainer.classList.remove("e-dlg-" + positionX + "-" + positionY);
                    }
                    this.positionChange();
                    this.updatePersistData();
                    break;
                case "enableRtl":
                    this.setEnableRTL();
                    break;
                case "enableResize":
                    this.setResize();
                    break;
                case "minHeight":
                    if (this.minHeight !== "") this.element.style.minHeight = (0, $3EnZW.formatUnit)(this.minHeight);
                    break;
            }
        }
    };
    Dialog.prototype.setTarget = function(target) {
        this.popupObj.relateTo = target;
        this.target = target;
        this.targetEle = typeof this.target === "string" ? document.querySelector(this.target) : this.target;
        if (this.dragObj) this.dragObj.dragArea = this.targetEle;
        this.setMaxHeight();
        if (this.isModal) this.updateIsModal();
        if (this.enableResize) this.setResize();
    };
    Dialog.prototype.updateIsModal = function() {
        this.element.setAttribute("aria-modal", this.isModal ? "true" : "false");
        if (this.isModal) {
            if ((0, $3EnZW.isNullOrUndefined)(this.dlgOverlay)) {
                this.setIsModal();
                this.element.style.top = "0px";
                this.element.style.left = "0px";
                if (!(0, $3EnZW.isNullOrUndefined)(this.targetEle)) this.targetEle.appendChild(this.dlgContainer);
            }
        } else {
            (0, $4ZDHT.removeClass)([
                this.element
            ], $397c948d4a376450$var$MODAL_DLG);
            (0, $4ZDHT.removeClass)([
                document.body
            ], [
                $397c948d4a376450$var$DLG_TARGET,
                $397c948d4a376450$var$SCROLL_DISABLED
            ]);
            (0, $4ZDHT.detach)(this.dlgOverlay);
            while(this.dlgContainer.firstChild)this.dlgContainer.parentElement.insertBefore(this.dlgContainer.firstChild, this.dlgContainer);
            this.dlgContainer.parentElement.removeChild(this.dlgContainer);
        }
        if (this.visible) this.show();
        this.positionChange();
        if (this.isModal && this.dlgOverlay) (0, $aqzbR.EventHandler).add(this.dlgOverlay, "click", this.dlgOverlayClickEventHandler, this);
    };
    Dialog.prototype.setzIndex = function(zIndexElement, setPopupZindex) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        var currentzIndex = (0, $2vAqh.getZindexPartial)(zIndexElement);
        this.zIndex = currentzIndex > this.zIndex ? currentzIndex : this.zIndex;
        this.isProtectedOnChange = prevOnChange;
        if (setPopupZindex) this.popupObj.zIndex = this.zIndex;
    };
    Dialog.prototype.windowResizeHandler = function() {
        (0, $af188cccda90eb97$export$c9cb974c6ac41893)(this.targetEle.clientWidth);
        (0, $af188cccda90eb97$export$e6dec7f2e1126484)(this.targetEle.clientHeight);
        this.setMaxHeight();
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {void}
     * @private
     */ Dialog.prototype.getPersistData = function() {
        return this.addOnPersist([
            "width",
            "height",
            "position"
        ]);
    };
    Dialog.prototype.removeAllChildren = function(element) {
        while(element.children[0]){
            this.removeAllChildren(element.children[0]);
            element.removeChild(element.children[0]);
        }
    };
    /**
     * To destroy the widget
     *
     * @returns {void}
     */ Dialog.prototype.destroy = function() {
        if (this.isDestroyed) return;
        var classArray = [
            $397c948d4a376450$var$RTL,
            $397c948d4a376450$var$MODAL_DLG,
            $397c948d4a376450$var$DLG_RESIZABLE,
            $397c948d4a376450$var$DLG_RESTRICT_LEFT_VALUE,
            $397c948d4a376450$var$FULLSCREEN,
            $397c948d4a376450$var$DEVICE
        ];
        var attrs = [
            "role",
            "aria-modal",
            "aria-labelledby",
            "aria-describedby",
            "aria-grabbed",
            "tabindex",
            "style"
        ];
        (0, $4ZDHT.removeClass)([
            this.targetEle
        ], [
            $397c948d4a376450$var$DLG_TARGET,
            $397c948d4a376450$var$SCROLL_DISABLED
        ]);
        if (!(0, $3EnZW.isNullOrUndefined)(this.element) && this.element.classList.contains($397c948d4a376450$var$FULLSCREEN)) (0, $4ZDHT.removeClass)([
            document.body
        ], [
            $397c948d4a376450$var$DLG_TARGET,
            $397c948d4a376450$var$SCROLL_DISABLED
        ]);
        if (this.isModal) (0, $4ZDHT.removeClass)([
            !(0, $3EnZW.isNullOrUndefined)(this.targetEle) ? this.targetEle : document.body
        ], $397c948d4a376450$var$SCROLL_DISABLED);
        this.unWireEvents();
        this.unWireButtonEvents();
        this.destroyButtons();
        if (!(0, $3EnZW.isNullOrUndefined)(this.closeIconBtnObj)) this.closeIconBtnObj.destroy();
        if (!(0, $3EnZW.isNullOrUndefined)(this.dragObj)) this.dragObj.destroy();
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj.element) && this.popupObj.element.classList.contains($397c948d4a376450$var$POPUP_ROOT)) this.popupObj.destroy();
        (0, $4ZDHT.removeClass)([
            this.element
        ], classArray);
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") (0, $4ZDHT.removeClass)([
            this.element
        ], this.cssClass.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(this.refElement) && !(0, $3EnZW.isNullOrUndefined)(this.refElement.parentElement)) {
            this.refElement.parentElement.insertBefore(this.isModal ? this.dlgContainer : this.element, this.refElement);
            (0, $4ZDHT.detach)(this.refElement);
            this.refElement = undefined;
        }
        if (this.isModal) {
            (0, $4ZDHT.detach)(this.dlgOverlay);
            this.dlgContainer.parentNode.insertBefore(this.element, this.dlgContainer);
            (0, $4ZDHT.detach)(this.dlgContainer);
        }
        this.element.innerHTML = this.clonedEle.innerHTML;
        for(var i = 0; i < attrs.length; i++)this.element.removeAttribute(attrs[i]);
        this.ftrTemplateContent = null;
        this.headerContent = null;
        if (!this.isReact && !this.isVue && !(0, $3EnZW.isNullOrUndefined)(this.contentEle)) this.removeAllChildren(this.contentEle);
        this.contentEle = null;
        (0, $af188cccda90eb97$export$6e30fb825043d4b5)();
        _super.prototype.destroy.call(this);
        // eslint-disable-next-line
        if (this.isReact) this.clearTemplate();
    };
    Dialog.prototype.wireWindowResizeEvent = function() {
        this.boundWindowResizeHandler = this.windowResizeHandler.bind(this);
        window.addEventListener("resize", this.boundWindowResizeHandler);
    };
    Dialog.prototype.unWireWindowResizeEvent = function() {
        window.removeEventListener("resize", this.boundWindowResizeHandler);
        this.boundWindowResizeHandler = null;
    };
    /**
     * Binding event to the element while widget creation
     *
     * @returns {void}
     * @hidden
     */ Dialog.prototype.wireEvents = function() {
        if (this.showCloseIcon) (0, $aqzbR.EventHandler).add(this.closeIcon, "click", this.closeIconClickEventHandler, this);
        if (this.isModal && this.dlgOverlay) (0, $aqzbR.EventHandler).add(this.dlgOverlay, "click", this.dlgOverlayClickEventHandler, this);
    };
    /**
     * Unbinding event to the element while widget destroy
     *
     * @returns {void}
     * @hidden
     */ Dialog.prototype.unWireEvents = function() {
        if (this.showCloseIcon) (0, $aqzbR.EventHandler).remove(this.closeIcon, "click", this.closeIconClickEventHandler);
        if (this.isModal) (0, $aqzbR.EventHandler).remove(this.dlgOverlay, "click", this.dlgOverlayClickEventHandler);
    };
    /**
     * Refreshes the dialog's position when the user changes its header and footer height/width dynamically.
     *
     * @returns {void}
     */ Dialog.prototype.refreshPosition = function() {
        this.popupObj.refreshPosition();
        if (this.element.classList.contains($397c948d4a376450$var$MODAL_DLG)) this.positionChange();
    };
    /**
     * Returns the current width and height of the Dialog
     *
     * @returns {DialogDimension}- returns the dialog element Dimension.
     * @public
     */ Dialog.prototype.getDimension = function() {
        var dialogWidth = this.element.offsetWidth;
        var dialogHeight = this.element.offsetHeight;
        return {
            width: dialogWidth,
            height: dialogHeight
        };
    };
    /**
     * Opens the dialog if it is in hidden state.
     * To open the dialog with full screen width, set the parameter to true.
     *
     * @param { boolean } isFullScreen - Enable the fullScreen Dialog.
     * @returns {void}
     */ Dialog.prototype.show = function(isFullScreen) {
        var _this = this;
        if (!this.element.classList.contains($397c948d4a376450$var$ROOT)) return;
        if (!this.element.classList.contains($397c948d4a376450$var$DLG_SHOW) || !(0, $3EnZW.isNullOrUndefined)(isFullScreen)) {
            if (!(0, $3EnZW.isNullOrUndefined)(isFullScreen)) this.fullScreen(isFullScreen);
            var eventArgs_1 = (0, $3EnZW.isBlazor)() ? {
                cancel: false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                maxHeight: this.element.style.maxHeight
            } : {
                cancel: false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                target: this.target,
                maxHeight: this.element.style.maxHeight
            };
            this.trigger("beforeOpen", eventArgs_1, function(beforeOpenArgs) {
                if (!beforeOpenArgs.cancel) {
                    if (_this.element.style.maxHeight !== eventArgs_1.maxHeight) {
                        _this.allowMaxHeight = false;
                        _this.element.style.maxHeight = eventArgs_1.maxHeight;
                    }
                    if (_this.enableResize && _this.boundWindowResizeHandler == null && !_this.initialRender) _this.wireWindowResizeEvent();
                    _this.storeActiveElement = document.activeElement;
                    _this.element.tabIndex = -1;
                    if (_this.isModal && !(0, $3EnZW.isNullOrUndefined)(_this.dlgOverlay)) {
                        _this.dlgOverlay.style.display = "block";
                        _this.dlgContainer.style.display = "flex";
                        (0, $4ZDHT.removeClass)([
                            _this.dlgOverlay
                        ], "e-fade");
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.targetEle)) {
                            if (_this.targetEle === document.body) _this.dlgContainer.style.position = "fixed";
                            else _this.dlgContainer.style.position = "absolute";
                            _this.dlgOverlay.style.position = "absolute";
                            var targetType = _this.getTargetContainer(_this.target);
                            if (targetType instanceof Element) {
                                var computedStyle = window.getComputedStyle(targetType);
                                if (computedStyle.getPropertyValue("direction") === "rtl") _this.element.style.position = "absolute";
                                else _this.element.style.position = "relative";
                            } else _this.element.style.position = "relative";
                            (0, $4ZDHT.addClass)([
                                _this.targetEle
                            ], [
                                $397c948d4a376450$var$DLG_TARGET,
                                $397c948d4a376450$var$SCROLL_DISABLED
                            ]);
                        } else (0, $4ZDHT.addClass)([
                            document.body
                        ], [
                            $397c948d4a376450$var$DLG_TARGET,
                            $397c948d4a376450$var$SCROLL_DISABLED
                        ]);
                    }
                    var openAnimation = {
                        name: _this.animationSettings.effect === "None" && (0, $kj1BR.animationMode) === "Enable" ? "ZoomIn" : _this.animationSettings.effect + "In",
                        duration: _this.animationSettings.duration,
                        delay: _this.animationSettings.delay
                    };
                    var zIndexElement = _this.isModal ? _this.element.parentElement : _this.element;
                    if (_this.calculatezIndex) {
                        _this.setzIndex(zIndexElement, true);
                        (0, $4ZDHT.setStyleAttribute)(_this.element, {
                            "zIndex": _this.zIndex
                        });
                        if (_this.isModal) _this.setOverlayZindex(_this.zIndex);
                    }
                    // eslint-disable-next-line
                    _this.animationSettings.effect === "None" && (0, $kj1BR.animationMode) === "Enable" ? _this.popupObj.show(openAnimation) : _this.animationSettings.effect === "None" ? _this.popupObj.show() : _this.popupObj.show(openAnimation);
                    if (_this.isModal) {
                        var targetType = _this.getTargetContainer(_this.target);
                        if (targetType instanceof Element) {
                            var computedStyle = window.getComputedStyle(targetType);
                            if (computedStyle.getPropertyValue("direction") === "rtl" && !_this.IsDragStop) _this.setPopupPosition();
                        }
                    }
                    _this.dialogOpen = true;
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    _this.visible = true;
                    _this.preventVisibility = true;
                    _this.isProtectedOnChange = prevOnChange;
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) this.renderReactTemplates();
    };
    /**
     * Closes the dialog if it is in visible state.
     *
     * @param { Event } event - specifies the event
     * @returns {void}
     */ Dialog.prototype.hide = function(event) {
        var _this = this;
        if (!this.element.classList.contains($397c948d4a376450$var$ROOT)) return;
        if (this.preventVisibility) {
            var eventArgs = (0, $3EnZW.isBlazor)() ? {
                cancel: false,
                isInteracted: event ? true : false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                event: event
            } : {
                cancel: false,
                isInteracted: event ? true : false,
                element: this.element,
                target: this.target,
                container: this.isModal ? this.dlgContainer : this.element,
                event: event,
                closedBy: this.dlgClosedBy
            };
            this.closeArgs = eventArgs;
            this.trigger("beforeClose", eventArgs, function(beforeCloseArgs) {
                if (!beforeCloseArgs.cancel) {
                    if (_this.isModal) {
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.targetEle)) (0, $4ZDHT.removeClass)([
                            _this.targetEle
                        ], [
                            $397c948d4a376450$var$DLG_TARGET,
                            $397c948d4a376450$var$SCROLL_DISABLED
                        ]);
                    }
                    if (_this.enableResize) _this.unWireWindowResizeEvent();
                    if (document.body.classList.contains($397c948d4a376450$var$DLG_TARGET) && document.body.classList.contains($397c948d4a376450$var$SCROLL_DISABLED)) (0, $4ZDHT.removeClass)([
                        document.body
                    ], [
                        $397c948d4a376450$var$DLG_TARGET,
                        $397c948d4a376450$var$SCROLL_DISABLED
                    ]);
                    var closeAnimation = {
                        name: _this.animationSettings.effect === "None" && (0, $kj1BR.animationMode) === "Enable" ? "ZoomOut" : _this.animationSettings.effect + "Out",
                        duration: _this.animationSettings.duration,
                        delay: _this.animationSettings.delay
                    };
                    if (_this.animationSettings.effect === "None" && (0, $kj1BR.animationMode) === "Enable") _this.popupObj.hide(closeAnimation);
                    else if (_this.animationSettings.effect === "None") _this.popupObj.hide();
                    else _this.popupObj.hide(closeAnimation);
                    _this.dialogOpen = false;
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    _this.visible = false;
                    _this.preventVisibility = false;
                    _this.isProtectedOnChange = prevOnChange;
                }
                _this.dlgClosedBy = $397c948d4a376450$var$DLG_USER_ACTION_CLOSED;
            });
        }
    };
    /**
     * Specifies to view the Full screen Dialog.
     *
     * @param {boolean} args - specifies the arguments
     * @returns {boolean} - returns the boolean value
     * @private
     */ Dialog.prototype.fullScreen = function(args) {
        /* eslint-disable */ var top = this.element.offsetTop;
        var left = this.element.offsetLeft;
        /* eslint-enable */ if (args) {
            if (!this.isModal) this.element.style.top = document.scrollingElement.scrollTop + "px";
            (0, $4ZDHT.addClass)([
                this.element
            ], $397c948d4a376450$var$FULLSCREEN);
            var display = this.element.style.display;
            this.element.style.display = "none";
            this.element.style.maxHeight = !(0, $3EnZW.isNullOrUndefined)(this.target) ? this.targetEle.offsetHeight + "px" : window.innerHeight + "px";
            this.element.style.display = display;
            (0, $4ZDHT.addClass)([
                document.body
            ], [
                $397c948d4a376450$var$DLG_TARGET,
                $397c948d4a376450$var$SCROLL_DISABLED
            ]);
            if (this.allowDragging && !(0, $3EnZW.isNullOrUndefined)(this.dragObj)) this.dragObj.destroy();
        } else {
            (0, $4ZDHT.removeClass)([
                this.element
            ], $397c948d4a376450$var$FULLSCREEN);
            (0, $4ZDHT.removeClass)([
                document.body
            ], [
                $397c948d4a376450$var$DLG_TARGET,
                $397c948d4a376450$var$SCROLL_DISABLED
            ]);
            if (this.allowDragging && !(0, $3EnZW.isNullOrUndefined)(this.headerContent)) this.setAllowDragging();
        }
        return args;
    };
    /**
     * Returns the dialog button instances.
     * Based on that, you can dynamically change the button states.
     *
     * @param { number } index - Index of the button.
     * @returns {Button} - returns the button element
     */ Dialog.prototype.getButtons = function(index) {
        if (!(0, $3EnZW.isNullOrUndefined)(index)) return this.btnObj[index];
        return this.btnObj;
    };
    Dialog.prototype.unWireButtonEvents = function() {
        if (this.buttons.length > 0 && this.footerTemplate === "" && this.ftrTemplateContent) {
            for(var i = 0; i < this.buttons.length; i++)if (this.buttons[i].click && typeof this.buttons[i].click === "function" && this.ftrTemplateContent.children[i]) (0, $aqzbR.EventHandler).remove(this.ftrTemplateContent.children[i], "click", this.buttons[i].click);
        }
    };
    Dialog.prototype.destroyButtons = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.btnObj)) {
            for(var i = 0; i < this.btnObj.length; i++)if (this.btnObj[i] && !this.btnObj[i].isDestroyed) this.btnObj[i].destroy();
        }
    };
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Dialog.prototype, "content", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Dialog.prototype, "enableHtmlSanitizer", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Dialog.prototype, "enablePersistence", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Dialog.prototype, "showCloseIcon", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Dialog.prototype, "isModal", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Dialog.prototype, "header", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Dialog.prototype, "visible", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Dialog.prototype, "enableResize", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)([
            "South-East"
        ])
    ], Dialog.prototype, "resizeHandles", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Dialog.prototype, "height", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Dialog.prototype, "minHeight", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], Dialog.prototype, "width", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Dialog.prototype, "cssClass", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], Dialog.prototype, "zIndex", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Dialog.prototype, "target", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Dialog.prototype, "footerTemplate", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Dialog.prototype, "allowDragging", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], $397c948d4a376450$export$7d29148a1857e804)
    ], Dialog.prototype, "buttons", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Dialog.prototype, "closeOnEscape", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Complex)({}, $397c948d4a376450$export$438778f27a7500c)
    ], Dialog.prototype, "animationSettings", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Complex)({
            X: "center",
            Y: "center"
        }, (0, $2vAqh.PositionData))
    ], Dialog.prototype, "position", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "created", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "open", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "beforeSanitizeHtml", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "beforeOpen", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "close", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "beforeClose", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "dragStart", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "dragStop", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "drag", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "overlayClick", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "resizeStart", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "resizing", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "resizeStop", void 0);
    $397c948d4a376450$var$__decorate([
        (0, $5rsSz.Event)()
    ], Dialog.prototype, "destroyed", void 0);
    Dialog = $397c948d4a376450$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Dialog);
    return Dialog;
}((0, $hQxLN.Component));
var $397c948d4a376450$export$b433fd4d34f52d4c;
(function(DialogUtility) {
    /**
     * An alert dialog box is used to display warning like messages to the users.
     * ```
     * Eg : DialogUtility.alert('Alert message');
     *
     * ```
     */ /* istanbul ignore next */ /**
     *
     * @param {AlertDialogArgs} args - specifies the string
     * @returns {Dialog} - returns the dialog element.
     */ function alert(args) {
        var dialogElement = (0, $4ZDHT.createElement)("div", {
            "className": $397c948d4a376450$var$DLG_UTIL_ALERT
        });
        document.body.appendChild(dialogElement);
        var alertDialogObj;
        var okButtonModel = [
            {
                buttonModel: {
                    isPrimary: true,
                    content: "OK"
                },
                click: function() {
                    this.hide();
                }
            }
        ];
        if (typeof args === "string") alertDialogObj = createDialog({
            content: args,
            position: {
                X: "center",
                Y: "top"
            },
            isModal: true,
            header: $397c948d4a376450$var$DLG_UTIL_DEFAULT_TITLE,
            buttons: okButtonModel
        }, dialogElement);
        else alertDialogObj = createDialog(alertOptions(args), dialogElement);
        alertDialogObj.close = function() {
            if (args && args.close) args.close.apply(alertDialogObj);
            alertDialogObj.destroy();
            if (alertDialogObj.element.classList.contains("e-dlg-modal")) {
                alertDialogObj.element.parentElement.remove();
                alertDialogObj.target.classList.remove($397c948d4a376450$var$DLG_UTIL_ROOT);
            } else alertDialogObj.element.remove();
        };
        return alertDialogObj;
    }
    DialogUtility.alert = alert;
    /**
     * A confirm dialog displays a specified message along with ‘OK’ and ‘Cancel’ button.
     * ```
     * Eg : DialogUtility.confirm('Confirm dialog message');
     *
     * ```
     */ /* istanbul ignore next */ /**
     *
     * @param {ConfirmDialogArgs} args - specifies the args
     * @returns {Dialog} - returns te element
     */ function confirm(args) {
        var dialogElement = (0, $4ZDHT.createElement)("div", {
            "className": $397c948d4a376450$var$DLG_UTIL_CONFIRM
        });
        document.body.appendChild(dialogElement);
        var confirmDialogObj;
        var okCancelButtonModel = [
            {
                buttonModel: {
                    isPrimary: true,
                    content: "OK"
                },
                click: function() {
                    this.hide();
                }
            },
            {
                buttonModel: {
                    content: "Cancel"
                },
                click: function() {
                    this.hide();
                }
            }
        ];
        if (typeof args === "string") confirmDialogObj = createDialog({
            position: {
                X: "center",
                Y: "top"
            },
            content: args,
            isModal: true,
            header: $397c948d4a376450$var$DLG_UTIL_DEFAULT_TITLE,
            buttons: okCancelButtonModel
        }, dialogElement);
        else confirmDialogObj = createDialog(confirmOptions(args), dialogElement);
        confirmDialogObj.close = function() {
            if (args && args.close) args.close.apply(confirmDialogObj);
            confirmDialogObj.destroy();
            if (confirmDialogObj.element.classList.contains("e-dlg-modal")) {
                confirmDialogObj.element.parentElement.remove();
                confirmDialogObj.target.classList.remove($397c948d4a376450$var$DLG_UTIL_ROOT);
            } else confirmDialogObj.element.remove();
        };
        return confirmDialogObj;
    }
    DialogUtility.confirm = confirm;
    // eslint-disable-next-line
    function createDialog(options, element) {
        var dialogObject = new $397c948d4a376450$export$3ddf2d174ce01153(options);
        dialogObject.appendTo(element);
        return dialogObject;
    }
    // eslint-disable-next-line
    function alertOptions(option) {
        var options = {};
        options.buttons = [];
        options = formOptions(options, option);
        options = setAlertButtonModel(options, option);
        return options;
    }
    // eslint-disable-next-line
    function confirmOptions(option) {
        var options = {};
        options.buttons = [];
        options = formOptions(options, option);
        options = setConfirmButtonModel(options, option);
        return options;
    }
    // eslint-disable-next-line
    function formOptions(options, option) {
        options.header = !(0, $3EnZW.isNullOrUndefined)(option.title) ? option.title : null;
        options.content = !(0, $3EnZW.isNullOrUndefined)(option.content) ? option.content : "";
        options.isModal = !(0, $3EnZW.isNullOrUndefined)(option.isModal) ? option.isModal : true;
        options.showCloseIcon = !(0, $3EnZW.isNullOrUndefined)(option.showCloseIcon) ? option.showCloseIcon : false;
        options.allowDragging = !(0, $3EnZW.isNullOrUndefined)(option.isDraggable) ? option.isDraggable : false;
        options.closeOnEscape = !(0, $3EnZW.isNullOrUndefined)(option.closeOnEscape) ? option.closeOnEscape : false;
        options.position = !(0, $3EnZW.isNullOrUndefined)(option.position) ? option.position : {
            X: "center",
            Y: "top"
        };
        options.animationSettings = !(0, $3EnZW.isNullOrUndefined)(option.animationSettings) ? option.animationSettings : {
            effect: "Fade",
            duration: 400,
            delay: 0
        };
        options.cssClass = !(0, $3EnZW.isNullOrUndefined)(option.cssClass) ? option.cssClass : "";
        options.zIndex = !(0, $3EnZW.isNullOrUndefined)(option.zIndex) ? option.zIndex : 1000;
        options.open = !(0, $3EnZW.isNullOrUndefined)(option.open) ? option.open : null;
        options.width = !(0, $3EnZW.isNullOrUndefined)(option.width) ? option.width : "auto";
        options.height = !(0, $3EnZW.isNullOrUndefined)(option.height) ? option.height : "auto";
        return options;
    }
    // eslint-disable-next-line
    function setAlertButtonModel(options, option) {
        var alertButtonModel = [
            {
                buttonModel: {
                    isPrimary: true,
                    content: "OK"
                },
                click: function() {
                    this.hide();
                }
            }
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(option.okButton)) options.buttons[0] = formButtonModel(options.buttons[0], option.okButton, alertButtonModel[0]);
        else options.buttons = alertButtonModel;
        return options;
    }
    // eslint-disable-next-line
    function setConfirmButtonModel(options, option) {
        var okButtonModel = {
            buttonModel: {
                isPrimary: true,
                content: "OK"
            },
            click: function() {
                this.hide();
            }
        };
        var cancelButtonModel = {
            buttonModel: {
                content: "Cancel"
            },
            click: function() {
                this.hide();
            }
        };
        if (!(0, $3EnZW.isNullOrUndefined)(option.okButton)) options.buttons[0] = formButtonModel(options.buttons[0], option.okButton, okButtonModel);
        else options.buttons[0] = okButtonModel;
        if (!(0, $3EnZW.isNullOrUndefined)(option.cancelButton)) options.buttons[1] = formButtonModel(options.buttons[1], option.cancelButton, cancelButtonModel);
        else options.buttons[1] = cancelButtonModel;
        return options;
    }
    // eslint-disable-next-line
    function formButtonModel(buttonModel, option, buttonPropModel) {
        var buttonProps = buttonPropModel;
        if (!(0, $3EnZW.isNullOrUndefined)(option.text)) buttonProps.buttonModel.content = option.text;
        if (!(0, $3EnZW.isNullOrUndefined)(option.icon)) buttonProps.buttonModel.iconCss = option.icon;
        if (!(0, $3EnZW.isNullOrUndefined)(option.cssClass)) buttonProps.buttonModel.cssClass = option.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(option.click)) buttonProps.click = option.click;
        if (!(0, $3EnZW.isNullOrUndefined)(option.isFlat)) buttonProps.isFlat = option.isFlat;
        return buttonProps;
    }
})($397c948d4a376450$export$b433fd4d34f52d4c || ($397c948d4a376450$export$b433fd4d34f52d4c = {}));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $3P3ke = parcelRequire("3P3ke");
var $i528u = parcelRequire("i528u");

var $2vAqh = parcelRequire("2vAqh");

var $cWXlQ = parcelRequire("cWXlQ");

var $49u5W = parcelRequire("49u5W");
var $47b4397f26bd41a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $47b4397f26bd41a3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $47b4397f26bd41a3$var$TOUCHEND_HIDE_DELAY = 1500;
var $47b4397f26bd41a3$var$TAPHOLD_THRESHOLD = 500;
var $47b4397f26bd41a3$var$SHOW_POINTER_TIP_GAP = 0;
var $47b4397f26bd41a3$var$HIDE_POINTER_TIP_GAP = 8;
var $47b4397f26bd41a3$var$MOUSE_TRAIL_GAP = 2;
var $47b4397f26bd41a3$var$POINTER_ADJUST = 2;
var $47b4397f26bd41a3$var$ROOT = "e-tooltip";
var $47b4397f26bd41a3$var$RTL = "e-rtl";
var $47b4397f26bd41a3$var$DEVICE = "e-bigger";
var $47b4397f26bd41a3$var$ICON = "e-icons";
var $47b4397f26bd41a3$var$CLOSE = "e-tooltip-close";
var $47b4397f26bd41a3$var$TOOLTIP_WRAP = "e-tooltip-wrap";
var $47b4397f26bd41a3$var$CONTENT = "e-tip-content";
var $47b4397f26bd41a3$var$ARROW_TIP = "e-arrow-tip";
var $47b4397f26bd41a3$var$ARROW_TIP_OUTER = "e-arrow-tip-outer";
var $47b4397f26bd41a3$var$ARROW_TIP_INNER = "e-arrow-tip-inner";
var $47b4397f26bd41a3$var$TIP_BOTTOM = "e-tip-bottom";
var $47b4397f26bd41a3$var$TIP_TOP = "e-tip-top";
var $47b4397f26bd41a3$var$TIP_LEFT = "e-tip-left";
var $47b4397f26bd41a3$var$TIP_RIGHT = "e-tip-right";
var $47b4397f26bd41a3$var$POPUP_ROOT = "e-popup";
var $47b4397f26bd41a3$var$POPUP_OPEN = "e-popup-open";
var $47b4397f26bd41a3$var$POPUP_CLOSE = "e-popup-close";
var $47b4397f26bd41a3$var$POPUP_LIB = "e-lib";
var $47b4397f26bd41a3$var$HIDE_POPUP = "e-hidden";
var $47b4397f26bd41a3$var$POPUP_CONTAINER = "e-tooltip-popup-container";
var $47b4397f26bd41a3$export$c35d437ae5945fcd = /** @class */ function(_super) {
    $47b4397f26bd41a3$var$__extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)({
            effect: "FadeIn",
            duration: 150,
            delay: 0
        })
    ], Animation.prototype, "open", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)({
            effect: "FadeOut",
            duration: 150,
            delay: 0
        })
    ], Animation.prototype, "close", void 0);
    return Animation;
}((0, $3fcxu.ChildProperty));
/**
 * Represents the Tooltip component that displays a piece of information about the target element on mouse hover.
 * ```html
 * <div id="tooltip">Show Tooltip</div>
 * ```
 * ```typescript
 * <script>
 *   var tooltipObj = new Tooltip({ content: 'Tooltip text' });
 *   tooltipObj.appendTo("#tooltip");
 * </script>
 * ```
 */ var $47b4397f26bd41a3$export$28c660c63b792dea = /** @class */ function(_super) {
    $47b4397f26bd41a3$var$__extends(Tooltip, _super);
    /**
     * Constructor for creating the Tooltip Component
     *
     * @param {TooltipModel} options - specifies the options for the constructor
     * @param {string| HTMLElement} element - specifies the element for the constructor
     *
     */ function Tooltip(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.mouseMoveEvent = null;
        _this.mouseMoveTarget = null;
        _this.containerElement = null;
        _this.isBodyContainer = true;
        return _this;
    }
    Tooltip.prototype.initialize = function() {
        this.formatPosition();
        (0, $4ZDHT.addClass)([
            this.element
        ], $47b4397f26bd41a3$var$ROOT);
    };
    Tooltip.prototype.formatPosition = function() {
        var _a, _b;
        if (!this.position) return;
        if (this.position.indexOf("Top") === 0 || this.position.indexOf("Bottom") === 0) _a = this.position.split(/(?=[A-Z])/), this.tooltipPositionY = _a[0], this.tooltipPositionX = _a[1];
        else _b = this.position.split(/(?=[A-Z])/), this.tooltipPositionX = _b[0], this.tooltipPositionY = _b[1];
    };
    Tooltip.prototype.renderArrow = function() {
        this.setTipClass(this.position);
        var tip = this.createElement("div", {
            className: $47b4397f26bd41a3$var$ARROW_TIP + " " + this.tipClass
        });
        tip.appendChild(this.createElement("div", {
            className: $47b4397f26bd41a3$var$ARROW_TIP_OUTER + " " + this.tipClass
        }));
        tip.appendChild(this.createElement("div", {
            className: $47b4397f26bd41a3$var$ARROW_TIP_INNER + " " + this.tipClass
        }));
        this.tooltipEle.appendChild(tip);
    };
    Tooltip.prototype.setTipClass = function(position) {
        if (position.indexOf("Right") === 0) this.tipClass = $47b4397f26bd41a3$var$TIP_LEFT;
        else if (position.indexOf("Bottom") === 0) this.tipClass = $47b4397f26bd41a3$var$TIP_TOP;
        else if (position.indexOf("Left") === 0) this.tipClass = $47b4397f26bd41a3$var$TIP_RIGHT;
        else this.tipClass = $47b4397f26bd41a3$var$TIP_BOTTOM;
    };
    Tooltip.prototype.renderPopup = function(target) {
        var elePos = this.mouseTrail ? {
            top: 0,
            left: 0
        } : this.getTooltipPosition(target);
        this.tooltipEle.classList.remove($47b4397f26bd41a3$var$POPUP_LIB);
        this.popupObj = new (0, $2vAqh.Popup)(this.tooltipEle, {
            height: this.height,
            width: this.width,
            position: {
                X: elePos.left,
                Y: elePos.top
            },
            enableRtl: this.enableRtl,
            open: this.openPopupHandler.bind(this),
            close: this.closePopupHandler.bind(this)
        });
    };
    Tooltip.prototype.getScalingFactor = function(target) {
        if (!target) return {
            x: 1,
            y: 1
        };
        var scalingFactors = {
            x: 1,
            y: 1
        };
        var elementsWithTransform = target.closest('[style*="transform: scale"]');
        if (elementsWithTransform && elementsWithTransform !== this.tooltipEle && elementsWithTransform.contains(this.tooltipEle)) {
            var computedStyle = window.getComputedStyle(elementsWithTransform);
            var transformValue = computedStyle.getPropertyValue("transform");
            var matrixValues = transformValue.match(/matrix\(([^)]+)\)/)[1].split(",").map(parseFloat);
            scalingFactors.x = matrixValues[0];
            scalingFactors.y = matrixValues[3];
        }
        return scalingFactors;
    };
    Tooltip.prototype.getTooltipPosition = function(target) {
        this.tooltipEle.style.display = "block";
        var parentWithZoomStyle = this.element.closest('[style*="zoom"]');
        if (parentWithZoomStyle) {
            if (!parentWithZoomStyle.contains(this.tooltipEle)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.tooltipEle.style.zoom = getComputedStyle(parentWithZoomStyle).zoom;
        }
        var pos = (0, $cWXlQ.calculatePosition)(target, this.tooltipPositionX, this.tooltipPositionY, !this.isBodyContainer, this.isBodyContainer ? null : this.containerElement.getBoundingClientRect());
        var scalingFactors = this.getScalingFactor(target);
        var offsetPos = this.calculateTooltipOffset(this.position, scalingFactors.x, scalingFactors.y);
        var collisionPosition = this.calculateElementPosition(pos, offsetPos);
        var collisionLeft = collisionPosition[0];
        var collisionTop = collisionPosition[1];
        var elePos = this.collisionFlipFit(target, collisionLeft, collisionTop);
        elePos.left = elePos.left / scalingFactors.x;
        elePos.top = elePos.top / scalingFactors.y;
        this.tooltipEle.style.display = "";
        return elePos;
    };
    Tooltip.prototype.windowResize = function() {
        this.reposition(this.findTarget());
    };
    Tooltip.prototype.reposition = function(target) {
        if (this.popupObj && target) {
            var elePos = this.getTooltipPosition(target);
            this.popupObj.position = {
                X: elePos.left,
                Y: elePos.top
            };
            this.popupObj.dataBind();
        }
    };
    Tooltip.prototype.openPopupHandler = function() {
        if (!this.mouseTrail && this.needTemplateReposition()) this.reposition(this.findTarget());
        this.trigger("afterOpen", this.tooltipEventArgs);
        this.tooltipEventArgs = null;
    };
    Tooltip.prototype.closePopupHandler = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact && !(this.opensOn === "Click" || typeof this.content === "function")) this.clearTemplate([
            "content"
        ]);
        this.clear();
        var tooltipAfterCloseEventArgs = {
            type: this.tooltipEventArgs.event ? this.tooltipEventArgs.event.type : null,
            cancel: false,
            target: this.tooltipEventArgs.target,
            event: this.tooltipEventArgs.event ? this.tooltipEventArgs.event : null,
            element: this.tooltipEle,
            isInteracted: !(0, $3EnZW.isNullOrUndefined)(this.tooltipEventArgs.event)
        };
        this.trigger("afterClose", tooltipAfterCloseEventArgs);
        tooltipAfterCloseEventArgs = null;
    };
    Tooltip.prototype.calculateTooltipOffset = function(position, xScalingFactor, yScalingFactor) {
        if (xScalingFactor === void 0) xScalingFactor = 1;
        if (yScalingFactor === void 0) yScalingFactor = 1;
        var pos = {
            top: 0,
            left: 0
        };
        var tipWidth;
        var tipHeight;
        var tooltipEleWidth;
        var tooltipEleHeight;
        var arrowEle;
        var tipAdjust;
        var tipHeightAdjust;
        var tipWidthAdjust;
        if (xScalingFactor !== 1 || yScalingFactor !== 1) {
            var tooltipEleRect = this.tooltipEle.getBoundingClientRect();
            var arrowEleRect = void 0;
            tooltipEleWidth = Math.round(tooltipEleRect.width);
            tooltipEleHeight = Math.round(tooltipEleRect.height);
            arrowEle = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP, this.tooltipEle);
            if (arrowEle) arrowEleRect = arrowEle.getBoundingClientRect();
            tipWidth = arrowEle ? Math.round(arrowEleRect.width) : 0;
            tipHeight = arrowEle ? Math.round(arrowEleRect.height) : 0;
            tipAdjust = this.showTipPointer ? $47b4397f26bd41a3$var$SHOW_POINTER_TIP_GAP : $47b4397f26bd41a3$var$HIDE_POINTER_TIP_GAP;
            tipHeightAdjust = tipHeight / 2 + $47b4397f26bd41a3$var$POINTER_ADJUST + (tooltipEleHeight - this.tooltipEle.clientHeight * yScalingFactor);
            tipWidthAdjust = tipWidth / 2 + $47b4397f26bd41a3$var$POINTER_ADJUST + (tooltipEleWidth - this.tooltipEle.clientWidth * xScalingFactor);
        } else {
            tooltipEleWidth = this.tooltipEle.offsetWidth;
            tooltipEleHeight = this.tooltipEle.offsetHeight;
            arrowEle = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP, this.tooltipEle);
            tipWidth = arrowEle ? arrowEle.offsetWidth : 0;
            tipHeight = arrowEle ? arrowEle.offsetHeight : 0;
            tipAdjust = this.showTipPointer ? $47b4397f26bd41a3$var$SHOW_POINTER_TIP_GAP : $47b4397f26bd41a3$var$HIDE_POINTER_TIP_GAP;
            tipHeightAdjust = tipHeight / 2 + $47b4397f26bd41a3$var$POINTER_ADJUST + (this.tooltipEle.offsetHeight - this.tooltipEle.clientHeight);
            tipWidthAdjust = tipWidth / 2 + $47b4397f26bd41a3$var$POINTER_ADJUST + (this.tooltipEle.offsetWidth - this.tooltipEle.clientWidth);
        }
        if (this.mouseTrail) tipAdjust += $47b4397f26bd41a3$var$MOUSE_TRAIL_GAP;
        switch(position){
            case "RightTop":
                pos.left += tipWidth + tipAdjust;
                pos.top -= tooltipEleHeight - tipHeightAdjust;
                break;
            case "RightCenter":
                pos.left += tipWidth + tipAdjust;
                pos.top -= tooltipEleHeight / 2;
                break;
            case "RightBottom":
                pos.left += tipWidth + tipAdjust;
                pos.top -= tipHeightAdjust;
                break;
            case "BottomRight":
                pos.top += tipHeight + tipAdjust;
                pos.left -= tipWidthAdjust;
                break;
            case "BottomCenter":
                pos.top += tipHeight + tipAdjust;
                pos.left -= tooltipEleWidth / 2;
                break;
            case "BottomLeft":
                pos.top += tipHeight + tipAdjust;
                pos.left -= tooltipEleWidth - tipWidthAdjust;
                break;
            case "LeftBottom":
                pos.left -= tipWidth + tooltipEleWidth + tipAdjust;
                pos.top -= tipHeightAdjust;
                break;
            case "LeftCenter":
                pos.left -= tipWidth + tooltipEleWidth + tipAdjust;
                pos.top -= tooltipEleHeight / 2;
                break;
            case "LeftTop":
                pos.left -= tipWidth + tooltipEleWidth + tipAdjust;
                pos.top -= tooltipEleHeight - tipHeightAdjust;
                break;
            case "TopLeft":
                pos.top -= tooltipEleHeight + tipHeight + tipAdjust;
                pos.left -= tooltipEleWidth - tipWidthAdjust;
                break;
            case "TopRight":
                pos.top -= tooltipEleHeight + tipHeight + tipAdjust;
                pos.left -= tipWidthAdjust;
                break;
            default:
                pos.top -= tooltipEleHeight + tipHeight + tipAdjust;
                pos.left -= tooltipEleWidth / 2;
                break;
        }
        pos.left += this.offsetX;
        pos.top += this.offsetY;
        return pos;
    };
    Tooltip.prototype.updateTipPosition = function(position) {
        var selEle = (0, $4ZDHT.selectAll)("." + $47b4397f26bd41a3$var$ARROW_TIP + ",." + $47b4397f26bd41a3$var$ARROW_TIP_OUTER + ",." + $47b4397f26bd41a3$var$ARROW_TIP_INNER, this.tooltipEle);
        var removeList = [
            $47b4397f26bd41a3$var$TIP_BOTTOM,
            $47b4397f26bd41a3$var$TIP_TOP,
            $47b4397f26bd41a3$var$TIP_LEFT,
            $47b4397f26bd41a3$var$TIP_RIGHT
        ];
        (0, $4ZDHT.removeClass)(selEle, removeList);
        this.setTipClass(position);
        (0, $4ZDHT.addClass)(selEle, this.tipClass);
    };
    Tooltip.prototype.adjustArrow = function(target, position, tooltipPositionX, tooltipPositionY) {
        var arrowEle = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP, this.tooltipEle);
        if (this.showTipPointer === false || arrowEle === null) return;
        this.updateTipPosition(position);
        var leftValue;
        var topValue;
        this.tooltipEle.style.display = "block";
        var tooltipWidth = this.tooltipEle.clientWidth;
        var tooltipHeight = this.tooltipEle.clientHeight;
        var arrowInnerELe = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP_INNER, this.tooltipEle);
        var tipWidth = arrowEle.offsetWidth;
        var tipHeight = arrowEle.offsetHeight;
        this.tooltipEle.style.display = "";
        if (this.tipClass === $47b4397f26bd41a3$var$TIP_BOTTOM || this.tipClass === $47b4397f26bd41a3$var$TIP_TOP) {
            if (this.tipClass === $47b4397f26bd41a3$var$TIP_BOTTOM) {
                topValue = "99.9%";
                // Arrow icon aligned -2px height from ArrowOuterTip div
                arrowInnerELe.style.top = "-" + (tipHeight - 2) + "px";
            } else {
                topValue = -(tipHeight - 1) + "px";
                // Arrow icon aligned -6px height from ArrowOuterTip div
                arrowInnerELe.style.top = "-" + (tipHeight - 6) + "px";
            }
            if (target) {
                var tipPosExclude = tooltipPositionX !== "Center" || tooltipWidth > target.offsetWidth || this.mouseTrail;
                if (tipPosExclude && tooltipPositionX === "Left" || !tipPosExclude && this.tipPointerPosition === "End") leftValue = tooltipWidth - tipWidth - $47b4397f26bd41a3$var$POINTER_ADJUST + "px";
                else if (tipPosExclude && tooltipPositionX === "Right" || !tipPosExclude && this.tipPointerPosition === "Start") leftValue = $47b4397f26bd41a3$var$POINTER_ADJUST + "px";
                else if (tipPosExclude && (this.tipPointerPosition === "End" || this.tipPointerPosition === "Start")) leftValue = this.tipPointerPosition === "End" ? target.offsetWidth + (this.tooltipEle.offsetWidth - target.offsetWidth) / 2 - tipWidth / 2 - $47b4397f26bd41a3$var$POINTER_ADJUST + "px" : (this.tooltipEle.offsetWidth - target.offsetWidth) / 2 - tipWidth / 2 + $47b4397f26bd41a3$var$POINTER_ADJUST + "px";
                else leftValue = tooltipWidth / 2 - tipWidth / 2 + "px";
            }
        } else {
            if (this.tipClass === $47b4397f26bd41a3$var$TIP_RIGHT) {
                leftValue = "99.9%";
                // Arrow icon aligned -2px left from ArrowOuterTip div
                arrowInnerELe.style.left = "-" + (tipWidth - 2) + "px";
            } else {
                leftValue = -(tipWidth - 1) + "px";
                // Arrow icon aligned -2px from ArrowOuterTip width
                arrowInnerELe.style.left = -tipWidth + (tipWidth - 2) + "px";
            }
            var tipPosExclude = tooltipPositionY !== "Center" || tooltipHeight > target.offsetHeight || this.mouseTrail;
            if (tipPosExclude && tooltipPositionY === "Top" || !tipPosExclude && this.tipPointerPosition === "End") topValue = tooltipHeight - tipHeight - $47b4397f26bd41a3$var$POINTER_ADJUST + "px";
            else if (tipPosExclude && tooltipPositionY === "Bottom" || !tipPosExclude && this.tipPointerPosition === "Start") topValue = $47b4397f26bd41a3$var$POINTER_ADJUST + "px";
            else topValue = tooltipHeight / 2 - tipHeight / 2 + "px";
        }
        arrowEle.style.top = topValue;
        arrowEle.style.left = leftValue;
    };
    Tooltip.prototype.renderContent = function(target) {
        var _this = this;
        var tooltipContent = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$CONTENT, this.tooltipEle);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.tooltipEle
        ], this.cssClass.split(" "));
        if (target && !(0, $3EnZW.isNullOrUndefined)(target.getAttribute("title"))) {
            target.setAttribute("data-content", target.getAttribute("title"));
            target.removeAttribute("title");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.content)) {
            tooltipContent.innerHTML = "";
            if (this.content instanceof HTMLElement) tooltipContent.appendChild(this.content);
            else if (typeof this.content === "string") {
                if (this.isAngular) this.setProperties({
                    content: (0, $3P3ke.SanitizeHtmlHelper).sanitize(this.content)
                }, true);
                else this.content = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(this.content) : this.content;
                if (this.enableHtmlParse) {
                    var tempFunction = (0, $c2qqN.compile)(this.content);
                    var tempArr = tempFunction({}, this, "content", this.element.id + "content", undefined, undefined, tooltipContent, this.root);
                    if (tempArr) (0, $4ZDHT.append)(tempArr, tooltipContent);
                } else tooltipContent["textContent"] = this.content;
            } else {
                var templateFunction = (0, $c2qqN.compile)(this.content);
                var tempArr = templateFunction({}, this, "content", this.element.id + "content", undefined, undefined, tooltipContent);
                if (tempArr) {
                    if (this.isAngular) setTimeout(function() {
                        _this.reposition(target);
                    }, 1);
                    (0, $4ZDHT.append)(tempArr, tooltipContent);
                }
                this.renderReactTemplates();
            }
        } else if (target && !(0, $3EnZW.isNullOrUndefined)(target.getAttribute("data-content"))) tooltipContent.innerHTML = target.getAttribute("data-content");
    };
    Tooltip.prototype.renderCloseIcon = function() {
        if (!this.isSticky) {
            var existingCloseIcon = this.tooltipEle.querySelector("." + $47b4397f26bd41a3$var$ICON + "." + $47b4397f26bd41a3$var$CLOSE);
            if (existingCloseIcon) (0, $4ZDHT.remove)(existingCloseIcon);
            return;
        }
        var tipClose = this.createElement("div", {
            className: $47b4397f26bd41a3$var$ICON + " " + $47b4397f26bd41a3$var$CLOSE
        });
        this.tooltipEle.appendChild(tipClose);
        (0, $aqzbR.EventHandler).add(tipClose, (0, $5q7BP.Browser).touchStartEvent, this.onStickyClose, this);
    };
    Tooltip.prototype.addDescribedBy = function(target, id) {
        var describedby = (target.getAttribute("aria-describedby") || "").split(/\s+/);
        if (describedby.indexOf(id) < 0) describedby.push(id);
        (0, $4ZDHT.attributes)(target, {
            "aria-describedby": describedby.join(" ").trim(),
            "data-tooltip-id": id
        });
    };
    Tooltip.prototype.removeDescribedBy = function(target) {
        var id = target.getAttribute("data-tooltip-id");
        var describedby = (target.getAttribute("aria-describedby") || "").split(/\s+/);
        var index = describedby.indexOf(id);
        if (index !== -1) describedby.splice(index, 1);
        target.removeAttribute("data-tooltip-id");
        var orgdescribedby = describedby.join(" ").trim();
        if (orgdescribedby) target.setAttribute("aria-describedby", orgdescribedby);
        else target.removeAttribute("aria-describedby");
    };
    Tooltip.prototype.tapHoldHandler = function(evt) {
        clearTimeout(this.autoCloseTimer);
        this.targetHover(evt.originalEvent);
    };
    Tooltip.prototype.touchEndHandler = function() {
        var _this = this;
        if (this.isSticky) return;
        var close = function() {
            _this.close();
        };
        this.autoCloseTimer = setTimeout(close, $47b4397f26bd41a3$var$TOUCHEND_HIDE_DELAY);
    };
    Tooltip.prototype.targetClick = function(e) {
        var target;
        if (this.target) target = (0, $4ZDHT.closest)(e.target, this.target);
        else target = this.element;
        if ((0, $3EnZW.isNullOrUndefined)(target)) return;
        if (target.getAttribute("data-tooltip-id") === null) this.targetHover(e);
        else if (!this.isSticky) this.hideTooltip(this.animation.close, e, target);
    };
    Tooltip.prototype.targetHover = function(e) {
        var target;
        if (this.target) target = (0, $4ZDHT.closest)(e.target, this.target);
        else target = this.element;
        if ((0, $3EnZW.isNullOrUndefined)(target) || target.getAttribute("data-tooltip-id") !== null && this.closeDelay === 0) return;
        var targetList = [].slice.call((0, $4ZDHT.selectAll)('[data-tooltip-id= "' + this.ctrlId + '_content"]', document));
        for(var _i = 0, targetList_1 = targetList; _i < targetList_1.length; _i++){
            var target_1 = targetList_1[_i];
            this.restoreElement(target_1);
        }
        this.showTooltip(target, this.animation.open, e);
    };
    Tooltip.prototype.mouseMoveBeforeOpen = function(e) {
        this.mouseMoveEvent = e;
    };
    Tooltip.prototype.mouseMoveBeforeRemove = function() {
        if (this.mouseMoveTarget) (0, $aqzbR.EventHandler).remove(this.mouseMoveTarget, "mousemove touchstart", this.mouseMoveBeforeOpen);
    };
    Tooltip.prototype.showTooltip = function(target, showAnimation, e) {
        var _this = this;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
        if (this.openDelay && this.mouseTrail) {
            this.mouseMoveBeforeRemove();
            this.mouseMoveTarget = target;
            (0, $aqzbR.EventHandler).add(this.mouseMoveTarget, "mousemove touchstart", this.mouseMoveBeforeOpen, this);
        }
        this.tooltipEventArgs = {
            type: e ? e.type : null,
            cancel: false,
            target: target,
            event: e ? e : null,
            element: this.tooltipEle,
            isInteracted: !(0, $3EnZW.isNullOrUndefined)(e)
        };
        var observeCallback = function(beforeRenderArgs) {
            _this.beforeRenderCallback(beforeRenderArgs, target, e, showAnimation);
        };
        this.trigger("beforeRender", this.tooltipEventArgs, observeCallback.bind(this));
    };
    Tooltip.prototype.beforeRenderCallback = function(beforeRenderArgs, target, e, showAnimation) {
        if (beforeRenderArgs.cancel) {
            this.isHidden = true;
            this.clear();
            this.mouseMoveBeforeRemove();
        } else {
            this.isHidden = false;
            if ((0, $3EnZW.isNullOrUndefined)(this.tooltipEle)) {
                this.ctrlId = this.element.getAttribute("id") ? (0, $3EnZW.getUniqueID)(this.element.getAttribute("id")) : (0, $3EnZW.getUniqueID)("tooltip");
                this.tooltipEle = this.createElement("div", {
                    className: $47b4397f26bd41a3$var$TOOLTIP_WRAP + " " + $47b4397f26bd41a3$var$POPUP_ROOT + " " + $47b4397f26bd41a3$var$POPUP_LIB,
                    attrs: {
                        role: "tooltip",
                        "aria-hidden": "false",
                        "id": this.ctrlId + "_content"
                    },
                    styles: "width:" + (0, $3EnZW.formatUnit)(this.width) + ";height:" + (0, $3EnZW.formatUnit)(this.height) + ";position:absolute;"
                });
                this.tooltipBeforeRender(target, this);
                this.tooltipAfterRender(target, e, showAnimation, this);
            } else if (target) {
                this.adjustArrow(target, this.position, this.tooltipPositionX, this.tooltipPositionY);
                this.addDescribedBy(target, this.ctrlId + "_content");
                this.renderContent(target);
                (0, $kj1BR.Animation).stop(this.tooltipEle);
                this.reposition(target);
                this.tooltipAfterRender(target, e, showAnimation, this);
            }
        }
    };
    Tooltip.prototype.appendContainer = function(ctrlObj) {
        if (typeof this.container == "string") {
            if (this.container === "body") this.containerElement = document.body;
            else {
                this.isBodyContainer = false;
                this.containerElement = (0, $4ZDHT.select)(this.container, document);
            }
        } else if (this.container instanceof HTMLElement) {
            this.containerElement = this.container;
            this.isBodyContainer = this.containerElement.tagName === "BODY";
        }
        if (!this.isBodyContainer) (0, $4ZDHT.addClass)([
            this.containerElement
        ], $47b4397f26bd41a3$var$POPUP_CONTAINER);
        this.containerElement.appendChild(ctrlObj.tooltipEle);
    };
    Tooltip.prototype.tooltipBeforeRender = function(target, ctrlObj) {
        if (target) {
            if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.addClass)([
                ctrlObj.tooltipEle
            ], $47b4397f26bd41a3$var$DEVICE);
            if (ctrlObj.width !== "auto") ctrlObj.tooltipEle.style.maxWidth = (0, $3EnZW.formatUnit)(ctrlObj.width);
            ctrlObj.tooltipEle.appendChild(ctrlObj.createElement("div", {
                className: $47b4397f26bd41a3$var$CONTENT
            }));
            this.appendContainer(ctrlObj);
            (0, $4ZDHT.removeClass)([
                ctrlObj.tooltipEle
            ], $47b4397f26bd41a3$var$HIDE_POPUP);
            ctrlObj.addDescribedBy(target, ctrlObj.ctrlId + "_content");
            ctrlObj.renderContent(target);
            (0, $4ZDHT.addClass)([
                ctrlObj.tooltipEle
            ], $47b4397f26bd41a3$var$POPUP_OPEN);
            if (ctrlObj.showTipPointer) ctrlObj.renderArrow();
            ctrlObj.renderCloseIcon();
            ctrlObj.renderPopup(target);
            ctrlObj.adjustArrow(target, ctrlObj.position, ctrlObj.tooltipPositionX, ctrlObj.tooltipPositionY);
            (0, $kj1BR.Animation).stop(ctrlObj.tooltipEle);
            ctrlObj.reposition(target);
        }
    };
    Tooltip.prototype.tooltipAfterRender = function(target, e, showAnimation, ctrlObj) {
        if (target) {
            (0, $4ZDHT.removeClass)([
                ctrlObj.tooltipEle
            ], $47b4397f26bd41a3$var$POPUP_OPEN);
            (0, $4ZDHT.addClass)([
                ctrlObj.tooltipEle
            ], $47b4397f26bd41a3$var$POPUP_CLOSE);
            ctrlObj.tooltipEventArgs = {
                type: e ? e.type : null,
                cancel: false,
                target: target,
                event: e ? e : null,
                element: ctrlObj.tooltipEle,
                isInteracted: !(0, $3EnZW.isNullOrUndefined)(e)
            };
            if (ctrlObj.needTemplateReposition() && !ctrlObj.mouseTrail && (showAnimation.effect === "None" || showAnimation.effect === "FadeIn" || // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.isReact && typeof ctrlObj.content != "string")) ctrlObj.tooltipEle.style.display = "none";
            var observeCallback = function(observedArgs) {
                ctrlObj.beforeOpenCallback(observedArgs, target, showAnimation, e);
            };
            ctrlObj.trigger("beforeOpen", ctrlObj.tooltipEventArgs, observeCallback.bind(ctrlObj));
        }
    };
    Tooltip.prototype.beforeOpenCallback = function(observedArgs, target, showAnimation, e) {
        var _this = this;
        if (observedArgs.cancel) {
            this.isHidden = true;
            this.clear();
            this.mouseMoveBeforeRemove();
            this.restoreElement(target);
        } else {
            var openAnimation_1 = {
                name: showAnimation.effect === "None" && (0, $kj1BR.animationMode) === "Enable" ? "FadeIn" : this.animation.open.effect,
                duration: showAnimation.duration,
                delay: showAnimation.delay,
                timingFunction: "easeOut"
            };
            if (showAnimation.effect === "None") openAnimation_1 = undefined;
            if (this.openDelay > 0) {
                var show = function() {
                    if (_this.mouseTrail) (0, $aqzbR.EventHandler).add(target, "mousemove touchstart mouseenter", _this.onMouseMove, _this);
                    if (_this.popupObj) {
                        _this.popupObj.show(openAnimation_1, target);
                        if (_this.mouseMoveEvent && _this.mouseTrail) _this.onMouseMove(_this.mouseMoveEvent);
                    }
                };
                this.showTimer = setTimeout(show, this.openDelay);
            } else if (this.popupObj) this.popupObj.show(openAnimation_1, target);
        }
        if (e) this.wireMouseEvents(e, target);
    };
    Tooltip.prototype.needTemplateReposition = function() {
        // eslint-disable-next-line
        var tooltip = this;
        return !(0, $3EnZW.isNullOrUndefined)(tooltip.viewContainerRef) && typeof tooltip.viewContainerRef !== "string" || this.isReact;
    };
    Tooltip.prototype.checkCollision = function(target, x, y) {
        var elePos = {
            left: x,
            top: y,
            position: this.position,
            horizontal: this.tooltipPositionX,
            vertical: this.tooltipPositionY
        };
        var affectedPos = (0, $49u5W.isCollide)(this.tooltipEle, this.checkCollideTarget(), x, y);
        if (affectedPos.length > 0) {
            elePos.horizontal = affectedPos.indexOf("left") >= 0 ? "Right" : affectedPos.indexOf("right") >= 0 ? "Left" : this.tooltipPositionX;
            elePos.vertical = affectedPos.indexOf("top") >= 0 ? "Bottom" : affectedPos.indexOf("bottom") >= 0 ? "Top" : this.tooltipPositionY;
        }
        return elePos;
    };
    Tooltip.prototype.calculateElementPosition = function(pos, offsetPos) {
        return [
            this.isBodyContainer ? pos.left + offsetPos.left : pos.left - this.containerElement.getBoundingClientRect().left + offsetPos.left + window.pageXOffset + this.containerElement.scrollLeft,
            this.isBodyContainer ? pos.top + offsetPos.top : pos.top - this.containerElement.getBoundingClientRect().top + offsetPos.top + window.pageYOffset + this.containerElement.scrollTop
        ];
    };
    Tooltip.prototype.collisionFlipFit = function(target, x, y) {
        var elePos = this.checkCollision(target, x, y);
        var newpos = elePos.position;
        if (this.tooltipPositionY !== elePos.vertical) newpos = this.position.indexOf("Bottom") === 0 || this.position.indexOf("Top") === 0 ? elePos.vertical + this.tooltipPositionX : this.tooltipPositionX + elePos.vertical;
        if (this.tooltipPositionX !== elePos.horizontal) {
            if (newpos.indexOf("Left") === 0) {
                elePos.vertical = newpos === "LeftTop" || newpos === "LeftCenter" ? "Top" : "Bottom";
                newpos = elePos.vertical + "Left";
            }
            if (newpos.indexOf("Right") === 0) {
                elePos.vertical = newpos === "RightTop" || newpos === "RightCenter" ? "Top" : "Bottom";
                newpos = elePos.vertical + "Right";
            }
            elePos.horizontal = this.tooltipPositionX;
        }
        this.tooltipEventArgs = {
            type: null,
            cancel: false,
            target: target,
            event: null,
            element: this.tooltipEle,
            collidedPosition: newpos
        };
        this.trigger("beforeCollision", this.tooltipEventArgs);
        if (this.tooltipEventArgs.cancel) newpos = this.position;
        else {
            var elePosVertical = elePos.vertical;
            var elePosHorizontal = elePos.horizontal;
            if (elePos.position !== newpos) {
                var pos = (0, $cWXlQ.calculatePosition)(target, elePosHorizontal, elePosVertical, !this.isBodyContainer, this.isBodyContainer ? null : this.containerElement.getBoundingClientRect());
                this.adjustArrow(target, newpos, elePosHorizontal, elePosVertical);
                var scalingFactors = this.getScalingFactor(target);
                var offsetPos = this.calculateTooltipOffset(newpos, scalingFactors.x, scalingFactors.y);
                offsetPos.top -= this.getOffSetPosition("TopBottom", newpos, this.offsetY);
                offsetPos.left -= this.getOffSetPosition("RightLeft", newpos, this.offsetX);
                elePos.position = newpos;
                var elePosition = this.calculateElementPosition(pos, offsetPos);
                elePos.left = elePosition[0];
                elePos.top = elePosition[1];
            } else this.adjustArrow(target, newpos, elePosHorizontal, elePosVertical);
        }
        var eleOffset = {
            left: elePos.left,
            top: elePos.top
        };
        var position = this.isBodyContainer ? (0, $49u5W.fit)(this.tooltipEle, this.checkCollideTarget(), {
            X: true,
            Y: this.windowCollision
        }, eleOffset) : eleOffset;
        this.tooltipEle.style.display = "block";
        var arrowEle = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP, this.tooltipEle);
        if (this.showTipPointer && arrowEle != null && (newpos.indexOf("Bottom") === 0 || newpos.indexOf("Top") === 0)) {
            var arrowleft = parseInt(arrowEle.style.left, 10) - (position.left - elePos.left);
            if (arrowleft < 0) arrowleft = 0;
            else if (arrowleft + arrowEle.offsetWidth > this.tooltipEle.clientWidth) arrowleft = this.tooltipEle.clientWidth - arrowEle.offsetWidth;
            arrowEle.style.left = arrowleft.toString() + "px";
        }
        this.tooltipEle.style.display = "";
        eleOffset.left = position.left;
        eleOffset.top = position.top;
        return eleOffset;
    };
    Tooltip.prototype.getOffSetPosition = function(positionString, newPos, offsetType) {
        return positionString.indexOf(this.position.split(/(?=[A-Z])/)[0]) !== -1 && positionString.indexOf(newPos.split(/(?=[A-Z])/)[0]) !== -1 ? 2 * offsetType : 0;
    };
    Tooltip.prototype.checkCollideTarget = function() {
        return !this.windowCollision && this.target ? this.element : null;
    };
    Tooltip.prototype.hideTooltip = function(hideAnimation, e, targetElement) {
        var _this = this;
        if (this.closeDelay > 0) {
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            var hide = function() {
                if (_this.closeDelay && _this.tooltipEle && _this.isTooltipOpen) return;
                _this.tooltipHide(hideAnimation, e, targetElement);
            };
            this.hideTimer = setTimeout(hide, this.closeDelay);
        } else this.tooltipHide(hideAnimation, e, targetElement);
    };
    Tooltip.prototype.tooltipHide = function(hideAnimation, e, targetElement) {
        var _this = this;
        var target;
        if (e) target = this.target ? targetElement || e.target : this.element;
        else target = (0, $4ZDHT.select)('[data-tooltip-id= "' + this.ctrlId + '_content"]', document);
        this.tooltipEventArgs = {
            type: e ? e.type : null,
            cancel: false,
            target: target,
            event: e ? e : null,
            element: this.tooltipEle,
            isInteracted: !(0, $3EnZW.isNullOrUndefined)(e)
        };
        // this line commented for close the tooltip popup element even the target element destroyed in a page.
        //if (isNullOrUndefined(target)) { return; }
        this.trigger("beforeClose", this.tooltipEventArgs, function(observedArgs) {
            if (!observedArgs.cancel) {
                _this.mouseMoveBeforeRemove();
                _this.popupHide(hideAnimation, target, e);
            } else _this.isHidden = false;
        });
    };
    Tooltip.prototype.popupHide = function(hideAnimation, target, e) {
        if (target && e) this.restoreElement(target);
        this.isHidden = true;
        var closeAnimation = {
            name: hideAnimation.effect === "None" && (0, $kj1BR.animationMode) === "Enable" ? "FadeOut" : this.animation.close.effect,
            duration: hideAnimation.duration,
            delay: hideAnimation.delay,
            timingFunction: "easeIn"
        };
        if (hideAnimation.effect === "None") closeAnimation = undefined;
        if (this.popupObj) this.popupObj.hide(closeAnimation);
    };
    Tooltip.prototype.restoreElement = function(target) {
        this.unwireMouseEvents(target);
        if (!(0, $3EnZW.isNullOrUndefined)(target.getAttribute("data-content"))) {
            target.setAttribute("title", target.getAttribute("data-content"));
            target.removeAttribute("data-content");
        }
        this.removeDescribedBy(target);
    };
    Tooltip.prototype.clear = function() {
        var target = this.findTarget();
        if (target) this.restoreElement(target);
        if (this.tooltipEle) {
            (0, $4ZDHT.removeClass)([
                this.tooltipEle
            ], $47b4397f26bd41a3$var$POPUP_CLOSE);
            (0, $4ZDHT.addClass)([
                this.tooltipEle
            ], $47b4397f26bd41a3$var$POPUP_OPEN);
        }
        if (this.isHidden) {
            if (this.popupObj) this.popupObj.destroy();
            if (this.tooltipEle) (0, $4ZDHT.remove)(this.tooltipEle);
            this.tooltipEle = null;
            this.popupObj = null;
        }
    };
    Tooltip.prototype.tooltipHover = function() {
        if (this.tooltipEle) this.isTooltipOpen = true;
    };
    Tooltip.prototype.tooltipMouseOut = function(e) {
        this.isTooltipOpen = false;
        this.hideTooltip(this.animation.close, e, this.findTarget());
    };
    Tooltip.prototype.onMouseOut = function(e) {
        var enteredElement = e.relatedTarget;
        // don't close the tooltip only if it is tooltip content element
        if (enteredElement && !this.mouseTrail) {
            var checkForTooltipElement = (0, $4ZDHT.closest)(enteredElement, "." + $47b4397f26bd41a3$var$TOOLTIP_WRAP + "." + $47b4397f26bd41a3$var$POPUP_LIB + "." + $47b4397f26bd41a3$var$POPUP_ROOT);
            if (checkForTooltipElement) (0, $aqzbR.EventHandler).add(checkForTooltipElement, "mouseleave", this.tooltipElementMouseOut, this);
            else {
                this.hideTooltip(this.animation.close, e, this.findTarget());
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (this.closeDelay === 0 && (this.animation.close.effect === "None" || this.isReact && typeof this.content != "string")) this.clear();
            }
        } else {
            this.hideTooltip(this.animation.close, e, this.findTarget());
            this.clear();
        }
        if (this.popupObj && !this.popupObj.element.classList.contains($47b4397f26bd41a3$var$POPUP_OPEN)) this.clear();
    };
    Tooltip.prototype.tooltipElementMouseOut = function(e) {
        this.hideTooltip(this.animation.close, e, this.findTarget());
        (0, $aqzbR.EventHandler).remove(this.element, "mouseleave", this.tooltipElementMouseOut);
        this.clear();
    };
    Tooltip.prototype.onStickyClose = function() {
        this.close();
    };
    Tooltip.prototype.onMouseMove = function(event) {
        var eventPageX = 0;
        var eventPageY = 0;
        if (event.type.indexOf("touch") > -1) {
            event.preventDefault();
            eventPageX = event.touches[0].pageX;
            eventPageY = event.touches[0].pageY;
        } else {
            eventPageX = event.pageX;
            eventPageY = event.pageY;
        }
        (0, $kj1BR.Animation).stop(this.tooltipEle);
        (0, $4ZDHT.removeClass)([
            this.tooltipEle
        ], $47b4397f26bd41a3$var$POPUP_CLOSE);
        (0, $4ZDHT.addClass)([
            this.tooltipEle
        ], $47b4397f26bd41a3$var$POPUP_OPEN);
        this.adjustArrow(event.target, this.position, this.tooltipPositionX, this.tooltipPositionY);
        var scalingFactors = this.getScalingFactor(event.target);
        var pos = this.calculateTooltipOffset(this.position, scalingFactors.x, scalingFactors.y);
        var x = eventPageX + pos.left + this.offsetX;
        var y = eventPageY + pos.top + this.offsetY;
        var elePos = this.checkCollision(event.target, x, y);
        if (this.tooltipPositionX !== elePos.horizontal || this.tooltipPositionY !== elePos.vertical) {
            var newpos = this.position.indexOf("Bottom") === 0 || this.position.indexOf("Top") === 0 ? elePos.vertical + elePos.horizontal : elePos.horizontal + elePos.vertical;
            elePos.position = newpos;
            this.adjustArrow(event.target, elePos.position, elePos.horizontal, elePos.vertical);
            var colpos = this.calculateTooltipOffset(elePos.position, scalingFactors.x, scalingFactors.y);
            elePos.left = eventPageX + colpos.left - this.offsetX;
            elePos.top = eventPageY + colpos.top - this.offsetY;
        }
        this.tooltipEle.style.left = elePos.left + "px";
        this.tooltipEle.style.top = elePos.top + "px";
    };
    Tooltip.prototype.keyDown = function(event) {
        if (this.tooltipEle && event.keyCode === 27) this.close();
    };
    Tooltip.prototype.touchEnd = function(e) {
        if (this.tooltipEle && (0, $4ZDHT.closest)(e.target, "." + $47b4397f26bd41a3$var$ROOT) === null && !this.isSticky) this.close();
    };
    Tooltip.prototype.scrollHandler = function(e) {
        if (this.tooltipEle && !this.isSticky) {
            if (!(0, $4ZDHT.closest)(e.target, "." + $47b4397f26bd41a3$var$TOOLTIP_WRAP + "." + $47b4397f26bd41a3$var$POPUP_LIB + "." + $47b4397f26bd41a3$var$POPUP_ROOT) && !this.isSticky) this.close();
        }
    };
    /**
     * Core method that initializes the control rendering.
     *
     * @private
     * @returns {void}
     */ Tooltip.prototype.render = function() {
        this.initialize();
        this.wireEvents(this.opensOn);
        this.renderComplete();
    };
    /**
     * Initializes the values of private members.
     *
     * @private
     * @returns {void}
     */ Tooltip.prototype.preRender = function() {
        this.tipClass = $47b4397f26bd41a3$var$TIP_BOTTOM;
        this.tooltipPositionX = "Center";
        this.tooltipPositionY = "Top";
        this.isHidden = true;
    };
    /**
     * Binding events to the Tooltip element.
     *
     * @hidden
     * @param {string} trigger - specify the trigger string to the function
     * @returns {void}
     *
     */ Tooltip.prototype.wireEvents = function(trigger) {
        var triggerList = this.getTriggerList(trigger);
        for(var _i = 0, triggerList_1 = triggerList; _i < triggerList_1.length; _i++){
            var opensOn = triggerList_1[_i];
            if (opensOn === "Custom") return;
            if (opensOn === "Focus") this.wireFocusEvents();
            if (opensOn === "Click") (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchStartEvent, this.targetClick, this);
            if (opensOn === "Hover") {
                if ((0, $5q7BP.Browser).isDevice) {
                    this.touchModule = new (0, $i528u.Touch)(this.element, {
                        tapHoldThreshold: $47b4397f26bd41a3$var$TAPHOLD_THRESHOLD,
                        tapHold: this.tapHoldHandler.bind(this)
                    });
                    (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchEndEvent, this.touchEndHandler, this);
                } else (0, $aqzbR.EventHandler).add(this.element, "mouseover", this.targetHover, this);
            }
        }
        this.windowResizeBound = this.windowResize.bind(this);
        this.keyDownBound = this.keyDown.bind(this);
        this.touchEndBound = this.touchEnd.bind(this);
        this.scrollWheelBound = this.scrollHandler.bind(this);
        document.addEventListener("wheel", this.scrollWheelBound);
        document.addEventListener("scroll", this.scrollWheelBound);
        document.addEventListener("touchend", this.touchEndBound);
        document.addEventListener("keydown", this.keyDownBound);
        window.addEventListener("resize", this.windowResizeBound);
    };
    Tooltip.prototype.getTriggerList = function(trigger) {
        if (!trigger) return [];
        if (trigger === "Auto") trigger = (0, $5q7BP.Browser).isDevice ? "Hover" : "Hover Focus";
        return trigger.split(" ");
    };
    Tooltip.prototype.wireFocusEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.target)) {
            var targetList = [].slice.call((0, $4ZDHT.selectAll)(this.target, this.element));
            this.targetsList = targetList;
            if (!(0, $3EnZW.isNullOrUndefined)(this.targetsList) && this.targetsList.length > 0) for(var _i = 0, targetList_2 = targetList; _i < targetList_2.length; _i++){
                var target = targetList_2[_i];
                (0, $aqzbR.EventHandler).add(target, "focus", this.targetHover, this);
            }
            else (0, $aqzbR.EventHandler).add(this.element, "focusin", this.targetHover, this);
        } else (0, $aqzbR.EventHandler).add(this.element, "focusin", this.targetHover, this);
    };
    Tooltip.prototype.wireMouseEvents = function(e, target) {
        if (this.tooltipEle) {
            if (!this.isSticky) {
                if (e.type === "focus") (0, $aqzbR.EventHandler).add(target, "blur", this.onMouseOut, this);
                if (e.type === "focusin") (0, $aqzbR.EventHandler).add(target, "focusout", this.onMouseOut, this);
                if (e.type === "mouseover") (0, $aqzbR.EventHandler).add(target, "mouseleave", this.onMouseOut, this);
                if (this.closeDelay) {
                    (0, $aqzbR.EventHandler).add(this.tooltipEle, "mouseenter", this.tooltipHover, this);
                    (0, $aqzbR.EventHandler).add(this.tooltipEle, "mouseleave", this.tooltipMouseOut, this);
                }
            }
            if (this.mouseTrail && this.openDelay === 0) (0, $aqzbR.EventHandler).add(target, "mousemove touchstart mouseenter", this.onMouseMove, this);
        }
    };
    /**
     * Unbinding events from the element on widget destroy.
     *
     * @hidden
     *
     * @param {string} trigger - specify the trigger string to the function
     * @returns {void}
     *
     */ Tooltip.prototype.unwireEvents = function(trigger) {
        var triggerList = this.getTriggerList(trigger);
        for(var _i = 0, triggerList_2 = triggerList; _i < triggerList_2.length; _i++){
            var opensOn = triggerList_2[_i];
            if (opensOn === "Custom") return;
            if (opensOn === "Focus") this.unwireFocusEvents();
            if (opensOn === "Click") (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchStartEvent, this.targetClick);
            if (opensOn === "Hover") {
                if ((0, $5q7BP.Browser).isDevice) {
                    if (this.touchModule) this.touchModule.destroy();
                    (0, $aqzbR.EventHandler).remove(this.element, (0, $5q7BP.Browser).touchEndEvent, this.touchEndHandler);
                } else (0, $aqzbR.EventHandler).remove(this.element, "mouseover", this.targetHover);
            }
        }
        document.removeEventListener("touchend", this.touchEndBound);
        this.touchEndBound = null;
        document.removeEventListener("wheel", this.scrollWheelBound);
        document.removeEventListener("scroll", this.scrollWheelBound);
        this.scrollWheelBound = null;
        window.removeEventListener("resize", this.windowResizeBound);
        this.windowResizeBound = null;
        document.removeEventListener("keydown", this.keyDownBound);
        this.keyDownBound = null;
    };
    Tooltip.prototype.unwireFocusEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.target)) {
            var targetList = [].slice.call((0, $4ZDHT.selectAll)(this.target, this.element));
            if (!(0, $3EnZW.isNullOrUndefined)(this.targetsList) && this.targetsList.length > 0) for(var _i = 0, targetList_3 = targetList; _i < targetList_3.length; _i++){
                var target = targetList_3[_i];
                (0, $aqzbR.EventHandler).remove(target, "focus", this.targetHover);
            }
            else (0, $aqzbR.EventHandler).remove(this.element, "focusin", this.targetHover);
        } else (0, $aqzbR.EventHandler).remove(this.element, "focusin", this.targetHover);
    };
    Tooltip.prototype.unwireMouseEvents = function(target) {
        if (!this.isSticky) {
            var triggerList = this.getTriggerList(this.opensOn);
            for(var _i = 0, triggerList_3 = triggerList; _i < triggerList_3.length; _i++){
                var opensOn = triggerList_3[_i];
                if (opensOn === "Focus") {
                    (0, $aqzbR.EventHandler).remove(target, "blur", this.onMouseOut);
                    (0, $aqzbR.EventHandler).remove(target, "focusout", this.onMouseOut);
                }
                if (opensOn === "Hover" && !(0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).remove(target, "mouseleave", this.onMouseOut);
            }
            if (this.closeDelay) {
                (0, $aqzbR.EventHandler).remove(target, "mouseenter", this.tooltipHover);
                (0, $aqzbR.EventHandler).remove(target, "mouseleave", this.tooltipMouseOut);
            }
        }
        if (this.mouseTrail) (0, $aqzbR.EventHandler).remove(target, "mousemove touchstart mouseenter", this.onMouseMove);
    };
    Tooltip.prototype.findTarget = function() {
        var target = (0, $4ZDHT.select)('[data-tooltip-id= "' + this.ctrlId + '_content"]', document);
        return target;
    };
    /**
     * Core method to return the component name.
     *
     * @private
     *
     * @returns {string} - this method returns module name.
     */ Tooltip.prototype.getModuleName = function() {
        return "tooltip";
    };
    /**
     * Returns the properties to be maintained in the persisted state.
     *
     * @private
     *
     * @returns {string} - this method returns persisted data.
     */ Tooltip.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * Called internally, if any of the property value changed.
     *
     * @private
     *
     * @param {TooltipModel} newProp - this param gives new property values to the method
     * @param {TooltipModel} oldProp - this param gives old property values to the method
     * @returns {void}
     *
     */ Tooltip.prototype.onPropertyChanged = function(newProp, oldProp) {
        var targetElement = this.findTarget();
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "width":
                    if (this.tooltipEle && targetElement) {
                        this.tooltipEle.style.width = this.tooltipEle.style.maxWidth = (0, $3EnZW.formatUnit)(newProp.width);
                        this.reposition(targetElement);
                    }
                    break;
                case "height":
                    if (this.tooltipEle && targetElement) {
                        this.tooltipEle.style.height = (0, $3EnZW.formatUnit)(newProp.height);
                        this.reposition(targetElement);
                    }
                    break;
                case "content":
                    if (this.tooltipEle) this.renderContent();
                    break;
                case "opensOn":
                    this.unwireEvents(oldProp.opensOn);
                    this.wireEvents(newProp.opensOn);
                    break;
                case "position":
                    this.formatPosition();
                    if (this.tooltipEle && targetElement) {
                        var arrowInnerELe = (0, $4ZDHT.select)("." + $47b4397f26bd41a3$var$ARROW_TIP_INNER, this.tooltipEle);
                        if (arrowInnerELe) arrowInnerELe.style.top = arrowInnerELe.style.left = null;
                        this.reposition(targetElement);
                    }
                    break;
                case "tipPointerPosition":
                    if (this.tooltipEle && targetElement) this.reposition(targetElement);
                    break;
                case "offsetX":
                    if (this.tooltipEle) {
                        var x = newProp.offsetX - oldProp.offsetX;
                        this.tooltipEle.style.left = (parseInt(this.tooltipEle.style.left, 10) + x).toString() + "px";
                    }
                    break;
                case "offsetY":
                    if (this.tooltipEle) {
                        var y = newProp.offsetY - oldProp.offsetY;
                        this.tooltipEle.style.top = (parseInt(this.tooltipEle.style.top, 10) + y).toString() + "px";
                    }
                    break;
                case "cssClass":
                    if (this.tooltipEle) {
                        if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                            this.tooltipEle
                        ], oldProp.cssClass.split(" "));
                        if (newProp.cssClass) (0, $4ZDHT.addClass)([
                            this.tooltipEle
                        ], newProp.cssClass.split(" "));
                    }
                    break;
                case "enableRtl":
                    if (this.tooltipEle) {
                        if (this.enableRtl) (0, $4ZDHT.addClass)([
                            this.tooltipEle
                        ], $47b4397f26bd41a3$var$RTL);
                        else (0, $4ZDHT.removeClass)([
                            this.tooltipEle
                        ], $47b4397f26bd41a3$var$RTL);
                    }
                    break;
                case "isSticky":
                    if (this.tooltipEle && targetElement) {
                        this.renderCloseIcon();
                        this.reposition(targetElement);
                    }
                    break;
                case "container":
                    if (!(0, $3EnZW.isNullOrUndefined)(this.containerElement)) (0, $4ZDHT.removeClass)([
                        this.containerElement
                    ], $47b4397f26bd41a3$var$POPUP_CONTAINER);
                    this.container = newProp.container;
                    if (this.tooltipEle && targetElement) {
                        this.appendContainer(this);
                        this.reposition(targetElement);
                    }
            }
        }
    };
    /**
     * It is used to show the Tooltip on the specified target with specific animation settings.
     *
     * @param {HTMLElement} element - Target element where the Tooltip is to be displayed. (It is an optional parameter)
     * @param {TooltipAnimationSettings} animation - Sets the specific animation, while showing the Tooltip on the screen. (It is an optional parameter)
     * @returns {void}
     */ Tooltip.prototype.open = function(element, animation) {
        if ((0, $3EnZW.isNullOrUndefined)(animation)) animation = this.animation.open;
        if ((0, $3EnZW.isNullOrUndefined)(element)) element = this.element;
        if (element.style.display === "none") return;
        this.showTooltip(element, animation);
    };
    /**
     * It is used to hide the Tooltip with specific animation effect.
     *
     * @param {TooltipAnimationSettings} animation - Sets the specific animation when hiding Tooltip from the screen. (It is an optional parameter)
     * @returns {void}
     */ Tooltip.prototype.close = function(animation) {
        if (!animation) animation = this.animation.close;
        this.hideTooltip(animation);
    };
    /**
     * It is used to refresh the Tooltip content and its position.
     *
     * @param {HTMLElement} target - Target element where the Tooltip content or position needs to be refreshed.
     * @returns {void}
     */ Tooltip.prototype.refresh = function(target) {
        if (this.tooltipEle) this.renderContent(target);
        if (this.popupObj && target) this.reposition(target);
        if (!(0, $3EnZW.isNullOrUndefined)(this.targetsList) && !(0, $3EnZW.isNullOrUndefined)(this.target)) {
            var target_2 = (0, $4ZDHT.selectAll)(this.target, this.element);
            if (target_2.length !== this.targetsList.length) {
                this.unwireEvents(this.opensOn);
                this.wireEvents(this.opensOn);
            }
        }
    };
    /**
     *
     * It is used to destroy the Tooltip component.
     *
     * @method destroy
     * @returns {void}
     * @memberof Tooltip
     */ Tooltip.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        if (this.tooltipEle) (0, $4ZDHT.remove)(this.tooltipEle);
        if (this.popupObj) this.popupObj.destroy();
        (0, $49u5W.destroy)();
        (0, $4ZDHT.removeClass)([
            this.element
        ], $47b4397f26bd41a3$var$ROOT);
        this.unwireEvents(this.opensOn);
        this.unwireMouseEvents(this.element);
        this.tooltipEle = null;
        this.popupObj = null;
        var currentTarget = (0, $4ZDHT.selectAll)('[data-tooltip-id= "' + this.ctrlId + '_content"]', this.element);
        for(var _i = 0, currentTarget_1 = currentTarget; _i < currentTarget_1.length; _i++){
            var target = currentTarget_1[_i];
            this.restoreElement(target);
        }
        this.containerElement = null;
        this.tipClass = null;
        this.tooltipPositionX = null;
        this.tooltipPositionY = null;
        this.ctrlId = null;
        this.tooltipEventArgs = null;
        this.touchModule = null;
        this.mouseMoveEvent = null;
        this.mouseMoveTarget = null;
        this.containerElement = null;
        this.targetsList = null;
    };
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Tooltip.prototype, "width", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Tooltip.prototype, "height", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)()
    ], Tooltip.prototype, "content", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("body")
    ], Tooltip.prototype, "container", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)()
    ], Tooltip.prototype, "target", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("TopCenter")
    ], Tooltip.prototype, "position", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Tooltip.prototype, "offsetX", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Tooltip.prototype, "offsetY", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Tooltip.prototype, "showTipPointer", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Tooltip.prototype, "enableHtmlParse", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "windowCollision", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], Tooltip.prototype, "tipPointerPosition", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], Tooltip.prototype, "opensOn", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "mouseTrail", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "isSticky", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Complex)({}, $47b4397f26bd41a3$export$c35d437ae5945fcd)
    ], Tooltip.prototype, "animation", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Tooltip.prototype, "openDelay", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Tooltip.prototype, "closeDelay", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)()
    ], Tooltip.prototype, "cssClass", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Tooltip.prototype, "enableHtmlSanitizer", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Tooltip.prototype, "htmlAttributes", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "beforeRender", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "beforeOpen", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "afterOpen", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "beforeClose", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "afterClose", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "beforeCollision", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "created", void 0);
    $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "destroyed", void 0);
    Tooltip = $47b4397f26bd41a3$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Tooltip);
    return Tooltip;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $d4834c37f505aa74$var$globalTimeOut = {};
var $d4834c37f505aa74$var$DEFT_MAT_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_MAT3_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_FAB_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_FLUENT_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_FLUENT2_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_BOOT_WIDTH = 30;
var $d4834c37f505aa74$var$DEFT_BOOT4_WIDTH = 36;
var $d4834c37f505aa74$var$DEFT_BOOT5_WIDTH = 36;
var $d4834c37f505aa74$var$CLS_SHOWSPIN = "e-spin-show";
var $d4834c37f505aa74$var$CLS_HIDESPIN = "e-spin-hide";
var $d4834c37f505aa74$var$CLS_MATERIALSPIN = "e-spin-material";
var $d4834c37f505aa74$var$CLS_MATERIAL3SPIN = "e-spin-material3";
var $d4834c37f505aa74$var$CLS_FABRICSPIN = "e-spin-fabric";
var $d4834c37f505aa74$var$CLS_FLUENTSPIN = "e-spin-fluent";
var $d4834c37f505aa74$var$CLS_FLUENT2SPIN = "e-spin-fluent2";
var $d4834c37f505aa74$var$CLS_TAILWINDSPIN = "e-spin-tailwind";
var $d4834c37f505aa74$var$CLS_BOOTSPIN = "e-spin-bootstrap";
var $d4834c37f505aa74$var$CLS_BOOT4SPIN = "e-spin-bootstrap4";
var $d4834c37f505aa74$var$CLS_BOOT5SPIN = "e-spin-bootstrap5";
var $d4834c37f505aa74$var$CLS_HIGHCONTRASTSPIN = "e-spin-high-contrast";
var $d4834c37f505aa74$var$CLS_SPINWRAP = "e-spinner-pane";
var $d4834c37f505aa74$var$CLS_SPININWRAP = "e-spinner-inner";
var $d4834c37f505aa74$var$CLS_SPINCIRCLE = "e-path-circle";
var $d4834c37f505aa74$var$CLS_SPINARC = "e-path-arc";
var $d4834c37f505aa74$var$CLS_SPINLABEL = "e-spin-label";
var $d4834c37f505aa74$var$CLS_SPINTEMPLATE = "e-spin-template";
var $d4834c37f505aa74$var$spinTemplate = null;
var $d4834c37f505aa74$var$spinCSSClass = null;
function $d4834c37f505aa74$export$7f7cbe89f1eacd2(action, options, target, type) {
    switch(action){
        case "Create":
            /* eslint-disable */ var element = document.querySelector(options.target);
            var args = {
                type: type,
                target: element,
                cssClass: options.cssClass,
                label: options.label,
                width: options.width
            };
            /* eslint-enable */ $d4834c37f505aa74$export$2342b8d835c798ac(args);
            break;
        case "Show":
            $d4834c37f505aa74$export$2a7a135fa1ec651f(document.querySelector(target));
            break;
        case "Hide":
            $d4834c37f505aa74$export$95fec50f68454318(document.querySelector(target));
            break;
        case "Set":
            var setArgs = {
                cssClass: options.cssClass,
                type: type
            };
            $d4834c37f505aa74$export$db649f8a97a749c3(setArgs);
            break;
    }
}
function $d4834c37f505aa74$export$2342b8d835c798ac(args, internalCreateElement) {
    var _a;
    if (!args.target) return;
    var radius;
    var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
    // eslint-disable-next-line
    var container = $d4834c37f505aa74$var$create_spinner_container(args.target, makeElement);
    if (!(0, $3EnZW.isNullOrUndefined)(args.cssClass)) {
        var classNames = args.cssClass.split(" ").filter(function(className) {
            return className.trim() !== "";
        });
        (_a = container.wrap.classList).add.apply(_a, classNames);
    }
    if (!(0, $3EnZW.isNullOrUndefined)(args.template) || !(0, $3EnZW.isNullOrUndefined)($d4834c37f505aa74$var$spinTemplate)) {
        var template = !(0, $3EnZW.isNullOrUndefined)(args.template) ? args.template : $d4834c37f505aa74$var$spinTemplate;
        container.wrap.classList.add($d4834c37f505aa74$var$CLS_SPINTEMPLATE);
        $d4834c37f505aa74$var$replaceContent(container.wrap, template, $d4834c37f505aa74$var$spinCSSClass);
    } else {
        var theme = !(0, $3EnZW.isNullOrUndefined)(args.type) ? args.type : $d4834c37f505aa74$var$getTheme(container.wrap);
        var width = !(0, $3EnZW.isNullOrUndefined)(args.width) ? args.width : undefined;
        radius = $d4834c37f505aa74$var$calculateRadius(width, theme);
        $d4834c37f505aa74$var$setTheme(theme, container.wrap, radius, makeElement);
        if (!(0, $3EnZW.isNullOrUndefined)(args.label)) $d4834c37f505aa74$var$createLabel(container.inner_wrap, args.label, makeElement);
    }
    container.wrap.classList.add($d4834c37f505aa74$var$CLS_HIDESPIN);
    container = null;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} label - specifies the string
 * @param {createElementParams} makeElement - specifies the element
 * @returns {HTMLElement} - returns the element
 */ function $d4834c37f505aa74$var$createLabel(container, label, makeElement) {
    var labelEle = makeElement("div", {});
    labelEle.classList.add($d4834c37f505aa74$var$CLS_SPINLABEL);
    labelEle.innerHTML = label;
    container.appendChild(labelEle);
    return labelEle;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createMaterialSpinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Material",
        radius: radius
    };
    $d4834c37f505aa74$var$create_material_element(container, uniqueID, makeElement, $d4834c37f505aa74$var$CLS_MATERIALSPIN);
    $d4834c37f505aa74$var$mat_calculate_attributes(radius, container, "Material", $d4834c37f505aa74$var$CLS_MATERIALSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createMaterial3Spinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Material3",
        radius: radius
    };
    $d4834c37f505aa74$var$create_material_element(container, uniqueID, makeElement, $d4834c37f505aa74$var$CLS_MATERIAL3SPIN);
    $d4834c37f505aa74$var$mat_calculate_attributes(radius, container, "Material3", $d4834c37f505aa74$var$CLS_MATERIAL3SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createBootstrap4Spinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Bootstrap4",
        radius: radius
    };
    $d4834c37f505aa74$var$create_material_element(container, uniqueID, makeElement, $d4834c37f505aa74$var$CLS_BOOT4SPIN);
    $d4834c37f505aa74$var$mat_calculate_attributes(radius, container, "Bootstrap4", $d4834c37f505aa74$var$CLS_BOOT4SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createBootstrap5Spinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Bootstrap5",
        radius: radius
    };
    $d4834c37f505aa74$var$create_material_element(container, uniqueID, makeElement, $d4834c37f505aa74$var$CLS_BOOT5SPIN);
    $d4834c37f505aa74$var$mat_calculate_attributes(radius, container, "Bootstrap5", $d4834c37f505aa74$var$CLS_BOOT5SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} uniqueID - specifies the id.
 * @param {number} radius - specifies the radius
 * @returns {void}
 */ function $d4834c37f505aa74$var$startMatAnimate(container, uniqueID, radius) {
    var globalObject = {};
    var timeOutVar = 0;
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID].timeOut = 0;
    globalObject["" + uniqueID] = $d4834c37f505aa74$var$globalVariables(uniqueID, radius, 0, 0);
    var spinnerInfo = {
        uniqueID: uniqueID,
        container: container,
        globalInfo: globalObject,
        timeOutVar: timeOutVar
    };
    $d4834c37f505aa74$var$animateMaterial(spinnerInfo);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createFabricSpinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Fabric",
        radius: radius
    };
    $d4834c37f505aa74$var$create_fabric_element(container, uniqueID, $d4834c37f505aa74$var$CLS_FABRICSPIN, makeElement);
    $d4834c37f505aa74$var$fb_calculate_attributes(radius, container, $d4834c37f505aa74$var$CLS_FABRICSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createFluentSpinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Fluent",
        radius: radius
    };
    $d4834c37f505aa74$var$create_fabric_element(container, uniqueID, $d4834c37f505aa74$var$CLS_FLUENTSPIN, makeElement);
    $d4834c37f505aa74$var$fb_calculate_attributes(radius, container, $d4834c37f505aa74$var$CLS_FLUENTSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createFluent2Spinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Fluent2",
        radius: radius
    };
    $d4834c37f505aa74$var$create_fabric_element(container, uniqueID, $d4834c37f505aa74$var$CLS_FLUENT2SPIN, makeElement);
    $d4834c37f505aa74$var$fb_calculate_attributes(radius, container, $d4834c37f505aa74$var$CLS_FLUENT2SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createTailwindSpinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Tailwind",
        radius: radius
    };
    $d4834c37f505aa74$var$create_fabric_element(container, uniqueID, $d4834c37f505aa74$var$CLS_TAILWINDSPIN, makeElement);
    $d4834c37f505aa74$var$fb_calculate_attributes(radius, container, $d4834c37f505aa74$var$CLS_TAILWINDSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createHighContrastSpinner(container, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "HighContrast",
        radius: radius
    };
    $d4834c37f505aa74$var$create_fabric_element(container, uniqueID, $d4834c37f505aa74$var$CLS_HIGHCONTRASTSPIN, makeElement);
    $d4834c37f505aa74$var$fb_calculate_attributes(radius, container, $d4834c37f505aa74$var$CLS_HIGHCONTRASTSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @returns {string} - returns the string
 */ function $d4834c37f505aa74$var$getTheme(container) {
    var theme = window.getComputedStyle(container, ":after").getPropertyValue("content");
    return theme.replace(/['"]+/g, "");
}
/**
 *
 * @param {string} theme - specifies the theme
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$setTheme(theme, container, radius, makeElement) {
    var innerContainer = container.querySelector("." + $d4834c37f505aa74$var$CLS_SPININWRAP);
    var svg = innerContainer.querySelector("svg");
    if (!(0, $3EnZW.isNullOrUndefined)(svg)) innerContainer.removeChild(svg);
    switch(theme){
        case "Material":
            $d4834c37f505aa74$var$createMaterialSpinner(innerContainer, radius, makeElement);
            break;
        case "Material3":
            $d4834c37f505aa74$var$createMaterial3Spinner(innerContainer, radius, makeElement);
            break;
        case "Fabric":
            $d4834c37f505aa74$var$createFabricSpinner(innerContainer, radius, makeElement);
            break;
        case "Fluent":
            $d4834c37f505aa74$var$createFluentSpinner(innerContainer, radius, makeElement);
            break;
        case "Fluent2":
            $d4834c37f505aa74$var$createFluent2Spinner(innerContainer, radius, makeElement);
            break;
        case "Bootstrap":
            $d4834c37f505aa74$var$createBootstrapSpinner(innerContainer, radius, makeElement);
            break;
        case "HighContrast":
            $d4834c37f505aa74$var$createHighContrastSpinner(innerContainer, radius, makeElement);
            break;
        case "Bootstrap4":
            $d4834c37f505aa74$var$createBootstrap4Spinner(innerContainer, radius, makeElement);
            break;
        case "Bootstrap5":
            $d4834c37f505aa74$var$createBootstrap5Spinner(innerContainer, radius, makeElement);
            break;
        case "Tailwind":
        case "Tailwind-dark":
            $d4834c37f505aa74$var$createTailwindSpinner(innerContainer, radius, makeElement);
            break;
    }
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$createBootstrapSpinner(innerContainer, radius, makeElement) {
    var uniqueID = $d4834c37f505aa74$var$random_generator();
    $d4834c37f505aa74$var$globalTimeOut["" + uniqueID] = {
        timeOut: 0,
        type: "Bootstrap",
        radius: radius
    };
    $d4834c37f505aa74$var$create_bootstrap_element(innerContainer, uniqueID, makeElement);
    $d4834c37f505aa74$var$boot_calculate_attributes(innerContainer, radius);
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {string} uniqueID - specifies the id
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$create_bootstrap_element(innerContainer, uniqueID, makeElement) {
    var svgBoot = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var viewBoxValue = 64;
    var trans = 32;
    var defaultRadius = 2;
    svgBoot.setAttribute("id", uniqueID);
    svgBoot.setAttribute("class", $d4834c37f505aa74$var$CLS_BOOTSPIN);
    svgBoot.setAttribute("viewBox", "0 0 " + viewBoxValue + " " + viewBoxValue);
    innerContainer.insertBefore(svgBoot, innerContainer.firstChild);
    for(var item = 0; item <= 7; item++){
        var bootCircle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        bootCircle.setAttribute("class", $d4834c37f505aa74$var$CLS_SPINCIRCLE + "_" + item);
        bootCircle.setAttribute("r", defaultRadius + "");
        bootCircle.setAttribute("transform", "translate(" + trans + "," + trans + ")");
        svgBoot.appendChild(bootCircle);
    }
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {number} radius - specifies the radius
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$boot_calculate_attributes(innerContainer, radius) {
    var svg = innerContainer.querySelector("svg.e-spin-bootstrap");
    var x = 0;
    var y = 0;
    var rad = 24;
    svg.style.width = svg.style.height = radius + "px";
    var startArc = 90;
    for(var item = 0; item <= 7; item++){
        var start = $d4834c37f505aa74$var$defineArcPoints(x, y, rad, startArc);
        var circleEle = svg.querySelector("." + $d4834c37f505aa74$var$CLS_SPINCIRCLE + "_" + item);
        circleEle.setAttribute("cx", start.x + "");
        circleEle.setAttribute("cy", start.y + "");
        startArc = startArc >= 360 ? 0 : startArc;
        startArc = startArc + 45;
    }
}
/**
 *
 * @param {number} begin - specifies the number
 * @param {number} stop  - specifirs the number
 * @returns {number[]} - returns the array of number
 */ function $d4834c37f505aa74$var$generateSeries(begin, stop) {
    var series = [];
    var start = begin;
    var end = stop;
    var increment = false;
    var count = 1;
    formSeries(start);
    /**
     *
     * @param {number} i - specifies the number
     * @returns {void}
     */ function formSeries(i) {
        series.push(i);
        if (i !== end || count === 1) {
            if (i <= start && i > 1 && !increment) i = parseFloat((i - 0.2).toFixed(2));
            else if (i === 1) {
                i = 7;
                i = parseFloat((i + 0.2).toFixed(2));
                increment = true;
            } else if (i < 8 && increment) {
                i = parseFloat((i + 0.2).toFixed(2));
                if (i === 8) increment = false;
            } else if (i <= 8 && !increment) i = parseFloat((i - 0.2).toFixed(2));
            ++count;
            formSeries(i);
        }
    }
    return series;
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @returns {void}
 */ function $d4834c37f505aa74$var$animateBootstrap(innerContainer) {
    var svg = innerContainer.querySelector("svg.e-spin-bootstrap");
    var id = svg.getAttribute("id");
    for(var i = 1; i <= 8; i++){
        var circleEle = innerContainer.getElementsByClassName("e-path-circle_" + (i === 8 ? 0 : i))[0];
        rotation(circleEle, i, i, $d4834c37f505aa74$var$generateSeries(i, i), id);
    }
    /**
     *
     * @param {SVGCircleElement} circle - specifies the circl element
     * @param {number} start - specifies the number
     * @param {number} end - specifies the end number
     * @param {number} series - specifies the series
     * @param {string} id - specifies the id
     * @returns {void}
     */ function rotation(circle, start, end, series, id) {
        var count = 0;
        boot_animate(start);
        // eslint-disable-next-line
        function boot_animate(radius) {
            if ($d4834c37f505aa74$var$globalTimeOut["" + id].isAnimate) {
                ++count;
                circle.setAttribute("r", radius + "");
                if (count >= series.length) count = 0;
                // eslint-disable-next-line
                $d4834c37f505aa74$var$globalTimeOut[id].timeOut = setTimeout(boot_animate.bind(null, series[count]), 18);
            }
        }
    }
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} template - specifies the template
 * @param {string} cssClass - specifies the css class.
 * @returns {void}
 */ function $d4834c37f505aa74$var$replaceContent(container, template, cssClass) {
    if (!(0, $3EnZW.isNullOrUndefined)(cssClass)) container.classList.add(cssClass);
    var inner = container.querySelector(".e-spinner-inner");
    inner.innerHTML = template;
}
/**
 *
 * @param {string} width - specifies the width
 * @param {string} theme - specifies the string
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$calculateRadius(width, theme) {
    var defaultSize;
    switch(theme){
        case "Material":
            defaultSize = $d4834c37f505aa74$var$DEFT_MAT_WIDTH;
            break;
        case "Material3":
            defaultSize = $d4834c37f505aa74$var$DEFT_MAT3_WIDTH;
            break;
        case "Fabric":
            defaultSize = $d4834c37f505aa74$var$DEFT_FAB_WIDTH;
            break;
        case "Tailwind":
        case "Tailwind-dark":
            defaultSize = $d4834c37f505aa74$var$DEFT_FAB_WIDTH;
            break;
        case "Fluent":
            defaultSize = $d4834c37f505aa74$var$DEFT_FLUENT_WIDTH;
            break;
        case "Fluent2":
            defaultSize = $d4834c37f505aa74$var$DEFT_FLUENT2_WIDTH;
            break;
        case "Bootstrap4":
            defaultSize = $d4834c37f505aa74$var$DEFT_BOOT4_WIDTH;
            break;
        case "Bootstrap5":
            defaultSize = $d4834c37f505aa74$var$DEFT_BOOT5_WIDTH;
            break;
        default:
            defaultSize = $d4834c37f505aa74$var$DEFT_BOOT_WIDTH;
    }
    width = width ? parseFloat(width + "") : defaultSize;
    return theme === "Bootstrap" ? width : width / 2;
}
/**
 *
 * @param {string} id - specifies the id
 * @param {number} radius - specifies the radius
 * @param {number} count - specifies the number count
 * @param {number} previousId - specifies the previous id
 * @returns {GlobalVariables} - returns the variables
 */ function $d4834c37f505aa74$var$globalVariables(id, radius, count, previousId) {
    return {
        radius: radius,
        count: count,
        previousId: previousId
    };
}
/**
 * @returns {string} - returns the string
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$random_generator() {
    var random = "";
    var combine = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for(var i = 0; i < 5; i++)random += combine.charAt(Math.floor(Math.random() * combine.length));
    return random;
}
/**
 *
 * @param {HTMLElement} innerCon - specifies the element
 * @param {string} uniqueID - specifies the unique id
 * @param {string} themeClass - specifies the string
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$create_fabric_element(innerCon, uniqueID, themeClass, makeElement) {
    var svgFabric = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgFabric.setAttribute("id", uniqueID);
    svgFabric.setAttribute("class", themeClass);
    var fabricCirclePath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    fabricCirclePath.setAttribute("class", $d4834c37f505aa74$var$CLS_SPINCIRCLE);
    var fabricCircleArc = document.createElementNS("http://www.w3.org/2000/svg", "path");
    fabricCircleArc.setAttribute("class", $d4834c37f505aa74$var$CLS_SPINARC);
    innerCon.insertBefore(svgFabric, innerCon.firstChild);
    svgFabric.appendChild(fabricCirclePath);
    svgFabric.appendChild(fabricCircleArc);
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {string} uniqueID - specifies the unique id
 * @param {createElementParams} makeElement - specifies the element
 * @param {string} cls - specifies the string
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$create_material_element(innerContainer, uniqueID, makeElement, cls) {
    var svgMaterial = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var matCirclePath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    svgMaterial.setAttribute("class", cls);
    svgMaterial.setAttribute("id", uniqueID);
    matCirclePath.setAttribute("class", $d4834c37f505aa74$var$CLS_SPINCIRCLE);
    innerContainer.insertBefore(svgMaterial, innerContainer.firstChild);
    svgMaterial.appendChild(matCirclePath);
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$create_spinner_container(target, makeElement) {
    var spinnerContainer = makeElement("div", {});
    var spinnerInnerContainer = makeElement("div", {});
    spinnerContainer.classList.add($d4834c37f505aa74$var$CLS_SPINWRAP);
    spinnerInnerContainer.classList.add($d4834c37f505aa74$var$CLS_SPININWRAP);
    spinnerInnerContainer.setAttribute("aria-disabled", "true");
    target.appendChild(spinnerContainer);
    spinnerContainer.appendChild(spinnerInnerContainer);
    // eslint-disable-next-line
    return {
        wrap: spinnerContainer,
        inner_wrap: spinnerInnerContainer
    };
}
/**
 *
 * @param {SpinnerInfo} spinnerInfo - specifies the spinner
 * @returns {void}
 */ function $d4834c37f505aa74$var$animateMaterial(spinnerInfo) {
    var start = 1;
    var end = 149;
    var duration = 1333;
    var max = 75;
    $d4834c37f505aa74$var$createCircle(start, end, $d4834c37f505aa74$var$easeAnimation, duration, spinnerInfo.globalInfo[spinnerInfo.uniqueID].count, max, spinnerInfo);
    spinnerInfo.globalInfo[spinnerInfo.uniqueID].count = ++spinnerInfo.globalInfo[spinnerInfo.uniqueID].count % 4;
}
/**
 *
 * @param {number} start - specifies the number
 * @param {number} end - specifies the end number
 * @param {Function} easing - specifies the function
 * @param {number} duration - specifies the duration
 * @param {number} count - specifies the count
 * @param {number} max - specifies the max number
 * @param {SpinnerInfo} spinnerInfo - specifies the spinner info
 * @returns {void}
 */ function $d4834c37f505aa74$var$createCircle(start, end, easing, duration, count, max, spinnerInfo) {
    var id = ++spinnerInfo.globalInfo[spinnerInfo.uniqueID].previousId;
    var startTime = new Date().getTime();
    var change = end - start;
    var diameter = $d4834c37f505aa74$var$getSize(spinnerInfo.globalInfo[spinnerInfo.uniqueID].radius * 2 + "");
    var strokeSize = $d4834c37f505aa74$var$getStrokeSize(diameter);
    var rotate = -90 * (spinnerInfo.globalInfo[spinnerInfo.uniqueID].count || 0);
    mat_animation(spinnerInfo);
    // eslint-disable-next-line
    function mat_animation(spinnerInfo) {
        var currentTime = Math.max(0, Math.min(new Date().getTime() - startTime, duration));
        updatePath(easing(currentTime, start, change, duration), spinnerInfo.container);
        if (id === spinnerInfo.globalInfo[spinnerInfo.uniqueID].previousId && currentTime < duration) // eslint-disable-next-line
        $d4834c37f505aa74$var$globalTimeOut[spinnerInfo.uniqueID].timeOut = setTimeout(mat_animation.bind(null, spinnerInfo), 1);
        else $d4834c37f505aa74$var$animateMaterial(spinnerInfo);
    }
    /**
     *
     * @param {number} value - specifies the number value
     * @param {HTMLElement} container - specifies the container
     * @returns {void}
     */ function updatePath(value, container) {
        if (!(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material")) || !(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material3"))) {
            var svg = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material")) && !(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material").querySelector("path.e-path-circle"))) svg = container.querySelector("svg.e-spin-material");
            else if (!(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material3")) && !(0, $3EnZW.isNullOrUndefined)(container.querySelector("svg.e-spin-material3").querySelector("path.e-path-circle"))) svg = container.querySelector("svg.e-spin-material3");
            if (!(0, $3EnZW.isNullOrUndefined)(svg)) {
                var path = svg.querySelector("path.e-path-circle");
                path.setAttribute("stroke-dashoffset", $d4834c37f505aa74$var$getDashOffset(diameter, strokeSize, value, max) + "");
                path.setAttribute("transform", "rotate(" + rotate + " " + diameter / 2 + " " + diameter / 2 + ")");
            }
        }
    }
}
/**
 *
 * @param {number} radius - specifies the number
 * @param {HTMLElement} container - specifies the element
 * @param {string} type - specifies the string type
 * @param {string} cls - specifies the string
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$mat_calculate_attributes(radius, container, type, cls) {
    var diameter = radius * 2;
    var svg = container.querySelector("svg." + cls);
    var path = svg.querySelector("path.e-path-circle");
    var strokeSize = $d4834c37f505aa74$var$getStrokeSize(diameter);
    var transformOrigin = diameter / 2 + "px";
    svg.setAttribute("viewBox", "0 0 " + diameter + " " + diameter);
    svg.style.width = svg.style.height = diameter + "px";
    svg.style.transformOrigin = transformOrigin + " " + transformOrigin + " " + transformOrigin;
    path.setAttribute("d", $d4834c37f505aa74$var$drawArc(diameter, strokeSize));
    if (type === "Material" || type === "Material3" || type === "Fluent2") {
        path.setAttribute("stroke-width", strokeSize + "");
        path.setAttribute("stroke-dasharray", (diameter - strokeSize) * Math.PI * 0.75 + "");
        path.setAttribute("stroke-dashoffset", $d4834c37f505aa74$var$getDashOffset(diameter, strokeSize, 1, 75) + "");
    }
}
/**
 *
 * @param {string} value - specifies the value
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$getSize(value) {
    var parsed = parseFloat(value);
    return parsed;
}
/**
 *
 * @param {number} diameter - specifies the diameter
 * @param {number} strokeSize - specifies the size
 * @returns {string} - returns the string
 */ function $d4834c37f505aa74$var$drawArc(diameter, strokeSize) {
    var radius = diameter / 2;
    var offset = strokeSize / 2;
    return "M" + radius + "," + offset + "A" + (radius - offset) + "," + (radius - offset) + " 0 1 1 " + offset + "," + radius;
}
/**
 *
 * @param {number} diameter - specifies the number
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$getStrokeSize(diameter) {
    return 0.1 * diameter;
}
/**
 *
 * @param {number} diameter - specifies the number
 * @param {number} strokeSize - specifies the stroke size
 * @param {number} value - specifies the value
 * @param {number} max - specifies the max number
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$getDashOffset(diameter, strokeSize, value, max) {
    return (diameter - strokeSize) * Math.PI * (3 * max / 100 - value / 100);
}
/**
 *
 * @param {number} current - specifies the number
 * @param {number} start - specifies the stroke size
 * @param {number} change - specifies the value
 * @param {number} duration - specifies the max number
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$easeAnimation(current, start, change, duration) {
    var timestamp = (current /= duration) * current;
    var timecount = timestamp * current;
    return start + change * (6 * timecount * timestamp + -15 * timestamp * timestamp + 10 * timecount);
}
/**
 *
 * @param {number} radius - specifies the number
 * @param {HTMLElement} innerConainer - specifies the element
 * @param {string} trgClass - specifies the class
 * @returns {void}
 */ // eslint-disable-next-line
function $d4834c37f505aa74$var$fb_calculate_attributes(radius, innerConainer, trgClass) {
    var centerX = radius;
    var centerY = radius;
    var diameter = radius * 2;
    var startArc = 315;
    var endArc = 45;
    var svg = innerConainer.querySelector("." + trgClass);
    var circle = svg.querySelector(".e-path-circle");
    var path = svg.querySelector(".e-path-arc");
    var transformOrigin = diameter / 2 + "px";
    circle.setAttribute("d", $d4834c37f505aa74$var$defineCircle(centerX, centerY, radius));
    path.setAttribute("d", $d4834c37f505aa74$var$defineArc(centerX, centerY, radius, startArc, endArc));
    svg.setAttribute("viewBox", "0 0 " + diameter + " " + diameter);
    svg.style.transformOrigin = transformOrigin + " " + transformOrigin + " " + transformOrigin;
    svg.style.width = svg.style.height = diameter + "px";
}
/**
 *
 * @param {number} centerX - specifies the number
 * @param {number} centerY - specifies the stroke size
 * @param {number} radius - specifies the value
 * @param {number} angle - specifies the max number
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$defineArcPoints(centerX, centerY, radius, angle) {
    var radians = (angle - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(radians),
        y: centerY + radius * Math.sin(radians)
    };
}
/**
 *
 * @param {number} x - specifies the number
 * @param {number} y - specifies the stroke size
 * @param {number} radius - specifies the radius
 * @param {number} startArc - specifies the value
 * @param {number} endArc - specifies the max number
 * @returns {number} - returns the number
 */ function $d4834c37f505aa74$var$defineArc(x, y, radius, startArc, endArc) {
    var start = $d4834c37f505aa74$var$defineArcPoints(x, y, radius, endArc);
    var end = $d4834c37f505aa74$var$defineArcPoints(x, y, radius, startArc);
    var d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        0,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
/**
 *
 * @param {number} x - specifies the number
 * @param {number} y - specifies the stroke size
 * @param {number} radius - specifies the value
 * @returns {string} - returns the string
 */ function $d4834c37f505aa74$var$defineCircle(x, y, radius) {
    var d = [
        "M",
        x,
        y,
        "m",
        -radius,
        0,
        "a",
        radius,
        radius,
        0,
        1,
        0,
        radius * 2,
        0,
        "a",
        radius,
        radius,
        0,
        1,
        0,
        -radius * 2,
        0
    ].join(" ");
    return d;
}
function $d4834c37f505aa74$export$2a7a135fa1ec651f(container) {
    $d4834c37f505aa74$var$showHideSpinner(container, false);
    container = null;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {boolean} isHide - specifies the boolean
 * @returns {void}
 */ function $d4834c37f505aa74$var$showHideSpinner(container, isHide) {
    var spinnerWrap;
    if (container) {
        if (container.classList.contains($d4834c37f505aa74$var$CLS_SPINWRAP)) spinnerWrap = container;
        else {
            var spinWrapCollection = container.querySelectorAll("." + $d4834c37f505aa74$var$CLS_SPINWRAP);
            if ((0, $5q7BP.Browser).isIE) {
                for(var i = 0; i < spinWrapCollection.length; i++)if (spinWrapCollection[i].parentElement && spinWrapCollection[i].parentElement === container) {
                    spinnerWrap = spinWrapCollection[i];
                    break;
                }
            } else spinnerWrap = Array.from(spinWrapCollection).find(function(wrap) {
                return wrap.parentElement === container;
            }) || null;
        }
    }
    if (container && spinnerWrap) {
        var inner = spinnerWrap.querySelector("." + $d4834c37f505aa74$var$CLS_SPININWRAP);
        var spinCheck = isHide ? !spinnerWrap.classList.contains($d4834c37f505aa74$var$CLS_SPINTEMPLATE) && !spinnerWrap.classList.contains($d4834c37f505aa74$var$CLS_HIDESPIN) : !spinnerWrap.classList.contains($d4834c37f505aa74$var$CLS_SPINTEMPLATE) && !spinnerWrap.classList.contains($d4834c37f505aa74$var$CLS_SHOWSPIN);
        if (spinCheck) {
            var svgEle = spinnerWrap.querySelector("svg");
            if ((0, $3EnZW.isNullOrUndefined)(svgEle)) return;
            var id = svgEle.getAttribute("id");
            $d4834c37f505aa74$var$globalTimeOut["" + id].isAnimate = !isHide;
            switch($d4834c37f505aa74$var$globalTimeOut["" + id].type){
                case "Material":
                case "Material3":
                    if (isHide) clearTimeout($d4834c37f505aa74$var$globalTimeOut[id].timeOut);
                    else $d4834c37f505aa74$var$startMatAnimate(inner, id, $d4834c37f505aa74$var$globalTimeOut[id].radius);
                    break;
                case "Bootstrap":
                    if (isHide) clearTimeout($d4834c37f505aa74$var$globalTimeOut[id].timeOut);
                    else $d4834c37f505aa74$var$animateBootstrap(inner);
                    break;
            }
        }
        if (isHide) (0, $4ZDHT.classList)(spinnerWrap, [
            $d4834c37f505aa74$var$CLS_HIDESPIN
        ], [
            $d4834c37f505aa74$var$CLS_SHOWSPIN
        ]);
        else (0, $4ZDHT.classList)(spinnerWrap, [
            $d4834c37f505aa74$var$CLS_SHOWSPIN
        ], [
            $d4834c37f505aa74$var$CLS_HIDESPIN
        ]);
        container = null;
    }
}
function $d4834c37f505aa74$export$95fec50f68454318(container) {
    $d4834c37f505aa74$var$showHideSpinner(container, true);
    container = null;
}
function $d4834c37f505aa74$export$db649f8a97a749c3(args, internalCreateElement) {
    var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
    if (args.template !== undefined) {
        $d4834c37f505aa74$var$spinTemplate = args.template;
        if (args.template !== undefined) $d4834c37f505aa74$var$spinCSSClass = args.cssClass;
    }
    var container = document.querySelectorAll("." + $d4834c37f505aa74$var$CLS_SPINWRAP);
    for(var index = 0; index < container.length; index++)$d4834c37f505aa74$var$ensureTemplate(args.template, container[index], args.type, args.cssClass, makeElement);
}
/**
 *
 * @param {string} template - specifies the string
 * @param {HTMLElement} container - specifies the container
 * @param {string} theme - specifies the theme
 * @param {string} cssClass - specifies the string class
 * @param {createElementParams} makeEle - specifies the params
 * @returns {void}
 */ function $d4834c37f505aa74$var$ensureTemplate(template, container, theme, cssClass, makeEle) {
    if ((0, $3EnZW.isNullOrUndefined)(template) && !container.classList.contains($d4834c37f505aa74$var$CLS_SPINTEMPLATE)) {
        $d4834c37f505aa74$var$replaceTheme(container, theme, cssClass, makeEle);
        if (container.classList.contains($d4834c37f505aa74$var$CLS_SHOWSPIN)) {
            container.classList.remove($d4834c37f505aa74$var$CLS_SHOWSPIN);
            $d4834c37f505aa74$export$2a7a135fa1ec651f(container);
        } else {
            container.classList.remove($d4834c37f505aa74$var$CLS_HIDESPIN);
            $d4834c37f505aa74$export$95fec50f68454318(container);
        }
    } else {
        $d4834c37f505aa74$var$spinTemplate = template;
        if (!(0, $3EnZW.isNullOrUndefined)(cssClass)) $d4834c37f505aa74$var$spinCSSClass = cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)($d4834c37f505aa74$var$spinTemplate)) $d4834c37f505aa74$var$replaceContent(container, $d4834c37f505aa74$var$spinTemplate, $d4834c37f505aa74$var$spinCSSClass);
    }
}
/**
 *
 * @param {HTMLElement} container - specifies the container
 * @param {string} theme - specifies the theme
 * @param {string} cssClass - specifies the string class
 * @param {createElementParams} makeEle - specifies the params
 * @returns {void}
 */ function $d4834c37f505aa74$var$replaceTheme(container, theme, cssClass, makeEle) {
    if (!(0, $3EnZW.isNullOrUndefined)(cssClass)) container.classList.add(cssClass);
    var svgElement = container.querySelector("svg");
    if (!(0, $3EnZW.isNullOrUndefined)(svgElement)) {
        var radius = theme === "Bootstrap" ? parseFloat(svgElement.style.height) : parseFloat(svgElement.style.height) / 2;
        var classNames = svgElement.getAttribute("class");
        var svgClassList = classNames.split(/\s/);
        if (svgClassList.indexOf("e-spin-material") >= 0) {
            var id = svgElement.getAttribute("id");
            clearTimeout($d4834c37f505aa74$var$globalTimeOut["" + id].timeOut);
        }
        $d4834c37f505aa74$var$setTheme(theme, container, radius, makeEle);
    }
}


$parcel$exportWildcard($7e63d782a157f66d$exports, $2vAqh);


const $4f23fd74a1ec3f74$var$CONTAINER_ID = "content";
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
        target: document.getElementById($4f23fd74a1ec3f74$var$CONTAINER_ID)
    });
});
const $4f23fd74a1ec3f74$export$95fec50f68454318 = ()=>(0, $d4834c37f505aa74$export$95fec50f68454318)(document.getElementById($4f23fd74a1ec3f74$var$CONTAINER_ID));
const $4f23fd74a1ec3f74$export$2a7a135fa1ec651f = ()=>(0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(document.getElementById($4f23fd74a1ec3f74$var$CONTAINER_ID));


const $0690cfee00fb4cf1$export$1bb358554aac31c1 = async (url)=>await $0690cfee00fb4cf1$var$fetch_("GET", url);
const $0690cfee00fb4cf1$export$484f3009c2ee32ad = async (url, data)=>await $0690cfee00fb4cf1$var$fetch_("POST", url, data);
const $0690cfee00fb4cf1$export$54950d96c4d7b0 = async (url, data)=>await $0690cfee00fb4cf1$var$fetch_("PATCH", url, data);
const $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1 = async (url)=>await $0690cfee00fb4cf1$var$fetch_("DELETE", url);
const $0690cfee00fb4cf1$var$fetch_ = async (method, url, data)=>{
    (0, $4f23fd74a1ec3f74$export$2a7a135fa1ec651f)();
    try {
        const res = await fetch(url, {
            method: method,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        });
        (0, $4f23fd74a1ec3f74$export$95fec50f68454318)();
        if (!(res.ok || res.status === 400)) {
            $0690cfee00fb4cf1$export$82098646a2d4b90c(res.status);
            throw res.statusText;
        }
        return res;
    } catch (error) {
        (0, $4f23fd74a1ec3f74$export$95fec50f68454318)();
        throw error;
    }
};
const $0690cfee00fb4cf1$export$82098646a2d4b90c = (status)=>{
    if (status >= 401) {
        if (status === 401 || status === 403) window.location.href = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).unauthorised;
        else if (status === 404) window.location.href = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).notFound;
        else window.location.href = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).error;
    }
};


// Patch UrlAdaptor to set Accept header to application/json (not */*)
(0, $e1170102ff02b3b7$export$b011aea473980a2d).prototype.beforeSend = (_dm, request)=>{
    request.headers.set("Accept", "application/json");
};
// Patch XMLHttpRequest to redirect error statuses to appropriate page
// @ts-ignore
XMLHttpRequest.prototype.send_ = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function(body) {
    this.addEventListener("readystatechange", (0, (/*@__PURE__*/$parcel$interopDefault($cdd05a6aa3de24f9$exports)))(()=>{
        if (!this.responseURL.startsWith("https://beaconapi.helpscout.net")) (0, $0690cfee00fb4cf1$export$82098646a2d4b90c)(this.status);
    }));
    // @ts-ignore
    this.send_(body);
};


parcelRequire("j7YE8");
var $bWDaN = parcelRequire("bWDaN");
var $43d28fde80599c96$exports = {};
$43d28fde80599c96$exports = JSON.parse('{"main":{"en-GB":{"identity":{"version":{"_cldrVersion":"36"},"language":"en","territory":"GB"},"dates":{"calendars":{"gregorian":{"months":{"format":{"abbreviated":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"},"narrow":{"1":"J","2":"F","3":"M","4":"A","5":"M","6":"J","7":"J","8":"A","9":"S","10":"O","11":"N","12":"D"},"wide":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}},"stand-alone":{"abbreviated":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"},"narrow":{"1":"J","2":"F","3":"M","4":"A","5":"M","6":"J","7":"J","8":"A","9":"S","10":"O","11":"N","12":"D"},"wide":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}},"days":{"format":{"abbreviated":{"sun":"Sun","mon":"Mon","tue":"Tue","wed":"Wed","thu":"Thu","fri":"Fri","sat":"Sat"},"narrow":{"sun":"S","mon":"M","tue":"T","wed":"W","thu":"T","fri":"F","sat":"S"},"short":{"sun":"Su","mon":"Mo","tue":"Tu","wed":"We","thu":"Th","fri":"Fr","sat":"Sa"},"wide":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}},"stand-alone":{"abbreviated":{"sun":"Sun","mon":"Mon","tue":"Tue","wed":"Wed","thu":"Thu","fri":"Fri","sat":"Sat"},"narrow":{"sun":"S","mon":"M","tue":"T","wed":"W","thu":"T","fri":"F","sat":"S"},"short":{"sun":"Su","mon":"Mo","tue":"Tu","wed":"We","thu":"Th","fri":"Fr","sat":"Sa"},"wide":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}}},"quarters":{"format":{"abbreviated":{"1":"Q1","2":"Q2","3":"Q3","4":"Q4"},"narrow":{"1":"1","2":"2","3":"3","4":"4"},"wide":{"1":"1st quarter","2":"2nd quarter","3":"3rd quarter","4":"4th quarter"}},"stand-alone":{"abbreviated":{"1":"Q1","2":"Q2","3":"Q3","4":"Q4"},"narrow":{"1":"1","2":"2","3":"3","4":"4"},"wide":{"1":"1st quarter","2":"2nd quarter","3":"3rd quarter","4":"4th quarter"}}},"dayPeriods":{"format":{"abbreviated":{"midnight":"midnight","am":"am","am-alt-variant":"am","noon":"noon","pm":"pm","pm-alt-variant":"pm","morning1":"in the morning","afternoon1":"in the afternoon","evening1":"in the evening","night1":"at night"},"narrow":{"midnight":"mi","am":"a","am-alt-variant":"am","noon":"n","pm":"p","pm-alt-variant":"pm","morning1":"in the morning","afternoon1":"in the afternoon","evening1":"in the evening","night1":"at night"},"wide":{"midnight":"midnight","am":"am","am-alt-variant":"am","noon":"noon","pm":"pm","pm-alt-variant":"pm","morning1":"in the morning","afternoon1":"in the afternoon","evening1":"in the evening","night1":"at night"}},"stand-alone":{"abbreviated":{"midnight":"midnight","am":"am","am-alt-variant":"am","noon":"noon","pm":"pm","pm-alt-variant":"pm","morning1":"morning","afternoon1":"afternoon","evening1":"evening","night1":"night"},"narrow":{"midnight":"midnight","am":"am","am-alt-variant":"am","noon":"noon","pm":"pm","pm-alt-variant":"pm","morning1":"morning","afternoon1":"afternoon","evening1":"evening","night1":"night"},"wide":{"midnight":"midnight","am":"am","am-alt-variant":"am","noon":"noon","pm":"pm","pm-alt-variant":"pm","morning1":"morning","afternoon1":"afternoon","evening1":"evening","night1":"night"}}},"eras":{"eraNames":{"0":"Before Christ","1":"Anno Domini","0-alt-variant":"Before Common Era","1-alt-variant":"Common Era"},"eraAbbr":{"0":"BC","1":"AD","0-alt-variant":"BCE","1-alt-variant":"CE"},"eraNarrow":{"0":"B","1":"A","0-alt-variant":"BCE","1-alt-variant":"CE"}},"dateFormats":{"full":"EEEE, d MMMM y","long":"d MMMM y","medium":"d MMM y","short":"dd/MM/y"},"timeFormats":{"full":"HH:mm:ss zzzz","long":"HH:mm:ss z","medium":"HH:mm:ss","short":"HH:mm"},"dateTimeFormats":{"full":"{1} \'at\' {0}","long":"{1} \'at\' {0}","medium":"{1}, {0}","short":"{1}, {0}","availableFormats":{"Bh":"h B","Bhm":"h:mm B","Bhms":"h:mm:ss B","d":"d","E":"ccc","EBhm":"E h:mm B","EBhms":"E h:mm:ss B","Ed":"E d","Ehm":"E h:mm a","EHm":"E HH:mm","Ehms":"E h:mm:ss a","EHms":"E HH:mm:ss","Gy":"y G","GyMMM":"MMM y G","GyMMMd":"d MMM y G","GyMMMEd":"E, d MMM y G","h":"h a","H":"HH","hm":"h:mm a","Hm":"HH:mm","hms":"h:mm:ss a","Hms":"HH:mm:ss","hmsv":"h:mm:ss a v","Hmsv":"HH:mm:ss v","hmv":"h:mm a v","Hmv":"HH:mm v","M":"L","Md":"dd/MM","MEd":"E, dd/MM","MMdd":"dd/MM","MMM":"LLL","MMMd":"d MMM","MMMEd":"E, d MMM","MMMMd":"d MMMM","MMMMW-count-one":"\'week\' W \'of\' MMMM","MMMMW-count-other":"\'week\' W \'of\' MMMM","ms":"mm:ss","y":"y","yM":"MM/y","yMd":"dd/MM/y","yMEd":"E, dd/MM/y","yMMM":"MMM y","yMMMd":"d MMM y","yMMMEd":"E, d MMM y","yMMMM":"MMMM y","yQQQ":"QQQ y","yQQQQ":"QQQQ y","yw-count-one":"\'week\' w \'of\' Y","yw-count-other":"\'week\' w \'of\' Y"},"appendItems":{"Day":"{0} ({2}: {1})","Day-Of-Week":"{0} {1}","Era":"{0} {1}","Hour":"{0} ({2}: {1})","Minute":"{0} ({2}: {1})","Month":"{0} ({2}: {1})","Quarter":"{0} ({2}: {1})","Second":"{0} ({2}: {1})","Timezone":"{0} {1}","Week":"{0} ({2}: {1})","Year":"{0} {1}"},"intervalFormats":{"intervalFormatFallback":"{0} \u2013 {1}","Bh":{"B":"h B \u2013 h B","h":"h \u2013 h B"},"Bhm":{"B":"h:mm B \u2013 h:mm B","h":"h:mm \u2013 h:mm B","m":"h:mm \u2013 h:mm B"},"d":{"d":"d\u2013d"},"Gy":{"G":"y G \u2013 y G","y":"y \u2013 y G"},"GyM":{"G":"M/y GGGGG \u2013 M/y GGGGG","M":"M/y \u2013 M/y GGGGG","y":"M/y \u2013 M/y GGGGG"},"GyMd":{"d":"dd/MM/y \u2013 dd/MM/y GGGGG","G":"dd/MM/y GGGGG \u2013 dd/MM/y GGGGG","M":"dd/MM/y \u2013 dd/MM/y GGGGG","y":"dd/MM/y \u2013 dd/MM/y GGGGG"},"GyMEd":{"d":"E, dd/MM/y \u2013 E, dd/MM/y GGGGG","G":"E, dd/MM/y GGGGG \u2013 E, dd/MM/y GGGGG","M":"E, dd/MM/y \u2013 E, dd/MM/y GGGGG","y":"E, dd/MM/y \u2013 E, dd/MM/y GGGGG"},"GyMMM":{"G":"MMM y G \u2013 MMM y G","M":"MMM \u2013 MMM y G","y":"MMM y \u2013 MMM y G"},"GyMMMd":{"d":"d \u2013 d MMM y G","G":"d MMM y G \u2013 d MMM y G","M":"d MMM \u2013 d MMM y G","y":"d MMM y \u2013 d MMM y G"},"GyMMMEd":{"d":"E, d MMM \u2013 E, d MMM y G","G":"E, d MMM y G \u2013 E, d MMM y G","M":"E, d MMM \u2013 E, d MMM y G","y":"E, d MMM y \u2013 E, d MMM y G"},"h":{"a":"h a \u2013 h a","h":"h\u2013h a"},"H":{"H":"HH\u2013HH"},"hm":{"a":"h:mm a \u2013 h:mm a","h":"h:mm \u2013 h:mm a","m":"h:mm \u2013 h:mm a"},"Hm":{"H":"HH:mm\u2013HH:mm","m":"HH:mm\u2013HH:mm"},"hmv":{"a":"h:mm a \u2013 h:mm a v","h":"h:mm \u2013 h:mm a v","m":"h:mm \u2013 h:mm a v"},"Hmv":{"H":"HH:mm\u2013HH:mm v","m":"HH:mm\u2013HH:mm v"},"hv":{"a":"h a \u2013 h a v","h":"h\u2013h a v"},"Hv":{"H":"HH\u2013HH v"},"M":{"M":"M\u2013M"},"Md":{"d":"dd/MM \u2013 dd/MM","M":"dd/MM \u2013 dd/MM"},"MEd":{"d":"E dd/MM \u2013 E dd/MM","M":"E dd/MM \u2013 E dd/MM"},"MMM":{"M":"MMM \u2013 MMM"},"MMMd":{"d":"d\u2013d MMM","M":"d MMM \u2013 d MMM"},"MMMEd":{"d":"E d MMM \u2013 E d MMM","M":"E d MMM \u2013 E d MMM"},"y":{"y":"y\u2013y"},"yM":{"M":"MM/y \u2013 MM/y","y":"MM/y \u2013 MM/y"},"yMd":{"d":"dd/MM/y \u2013 dd/MM/y","M":"dd/MM/y \u2013 dd/MM/y","y":"dd/MM/y \u2013 dd/MM/y"},"yMEd":{"d":"E, dd/MM/y \u2013 E, dd/MM/y","M":"E, dd/MM/y \u2013 E, dd/MM/y","y":"E, dd/MM/y \u2013 E, dd/MM/y"},"yMMM":{"M":"MMM \u2013 MMM y","y":"MMM y \u2013 MMM y"},"yMMMd":{"d":"d\u2013d MMM y","M":"d MMM \u2013 d MMM y","y":"d MMM y \u2013 d MMM y"},"yMMMEd":{"d":"E, d MMM \u2013 E, d MMM y","M":"E, d MMM \u2013 E, d MMM y","y":"E, d MMM y \u2013 E, d MMM y"},"yMMMM":{"M":"MMMM \u2013 MMMM y","y":"MMMM y \u2013 MMMM y"}}}}}}}}}');


var $bc24ba34bca146b0$exports = {};
$bc24ba34bca146b0$exports = JSON.parse('{"main":{"en-GB":{"identity":{"version":{"_cldrVersion":"36"},"language":"en","territory":"GB"},"numbers":{"defaultNumberingSystem":"latn","otherNumberingSystems":{"native":"latn"},"minimumGroupingDigits":"1","symbols-numberSystem-latn":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"\xd7","perMille":"\u2030","infinity":"\u221E","nan":"NaN","timeSeparator":":"},"decimalFormats-numberSystem-latn":{"standard":"#,##0.###","long":{"decimalFormat":{"1000-count-one":"0 thousand","1000-count-other":"0 thousand","10000-count-one":"00 thousand","10000-count-other":"00 thousand","100000-count-one":"000 thousand","100000-count-other":"000 thousand","1000000-count-one":"0 million","1000000-count-other":"0 million","10000000-count-one":"00 million","10000000-count-other":"00 million","100000000-count-one":"000 million","100000000-count-other":"000 million","1000000000-count-one":"0 billion","1000000000-count-other":"0 billion","10000000000-count-one":"00 billion","10000000000-count-other":"00 billion","100000000000-count-one":"000 billion","100000000000-count-other":"000 billion","1000000000000-count-one":"0 trillion","1000000000000-count-other":"0 trillion","10000000000000-count-one":"00 trillion","10000000000000-count-other":"00 trillion","100000000000000-count-one":"000 trillion","100000000000000-count-other":"000 trillion"}},"short":{"decimalFormat":{"1000-count-one":"0K","1000-count-other":"0K","10000-count-one":"00K","10000-count-other":"00K","100000-count-one":"000K","100000-count-other":"000K","1000000-count-one":"0M","1000000-count-other":"0M","10000000-count-one":"00M","10000000-count-other":"00M","100000000-count-one":"000M","100000000-count-other":"000M","1000000000-count-one":"0B","1000000000-count-other":"0B","10000000000-count-one":"00B","10000000000-count-other":"00B","100000000000-count-one":"000B","100000000000-count-other":"000B","1000000000000-count-one":"0T","1000000000000-count-other":"0T","10000000000000-count-one":"00T","10000000000000-count-other":"00T","100000000000000-count-one":"000T","100000000000000-count-other":"000T"}}},"scientificFormats-numberSystem-latn":{"standard":"#E0"},"percentFormats-numberSystem-latn":{"standard":"#,##0%"},"currencyFormats-numberSystem-latn":{"currencySpacing":{"beforeCurrency":{"currencyMatch":"[:^S:]","surroundingMatch":"[:digit:]","insertBetween":"\xa0"},"afterCurrency":{"currencyMatch":"[:^S:]","surroundingMatch":"[:digit:]","insertBetween":"\xa0"}},"standard":"\xa4#,##0.00","accounting":"\xa4#,##0.00;(\xa4#,##0.00)","short":{"standard":{"1000-count-one":"\xa40K","1000-count-other":"\xa40K","10000-count-one":"\xa400K","10000-count-other":"\xa400K","100000-count-one":"\xa4000K","100000-count-other":"\xa4000K","1000000-count-one":"\xa40M","1000000-count-other":"\xa40M","10000000-count-one":"\xa400M","10000000-count-other":"\xa400M","100000000-count-one":"\xa4000M","100000000-count-other":"\xa4000M","1000000000-count-one":"\xa40B","1000000000-count-other":"\xa40B","10000000000-count-one":"\xa400B","10000000000-count-other":"\xa400B","100000000000-count-one":"\xa4000B","100000000000-count-other":"\xa4000B","1000000000000-count-one":"\xa40T","1000000000000-count-other":"\xa40T","10000000000000-count-one":"\xa400T","10000000000000-count-other":"\xa400T","100000000000000-count-one":"\xa4000T","100000000000000-count-other":"\xa4000T"}},"unitPattern-count-one":"{0} {1}","unitPattern-count-other":"{0} {1}"},"miscPatterns-numberSystem-latn":{"approximately":"~{0}","atLeast":"{0}+","atMost":"\u2264{0}","range":"{0}\u2013{1}"},"minimalPairs":{"pluralMinimalPairs-count-one":"{0}\xa0day","pluralMinimalPairs-count-other":"{0}\xa0days","few":"Take\xa0the\xa0{0}rd\xa0right.","one":"Take\xa0the\xa0{0}st\xa0right.","other":"Take\xa0the\xa0{0}th\xa0right.","two":"Take\xa0the\xa0{0}nd\xa0right."}}}}}');


var $dfd07ef432b5d001$exports = {};
$dfd07ef432b5d001$exports = JSON.parse('{"main":{"en-GB":{"identity":{"version":{"_cldrVersion":"36"},"language":"en","territory":"GB"},"dates":{"timeZoneNames":{"hourFormat":"+HH:mm;-HH:mm","gmtFormat":"GMT{0}","gmtZeroFormat":"GMT","regionFormat":"{0} Time","regionFormat-type-daylight":"{0} Daylight Time","regionFormat-type-standard":"{0} Standard Time","fallbackFormat":"{1} ({0})","zone":{"America":{"Adak":{"exemplarCity":"Adak"},"Anchorage":{"exemplarCity":"Anchorage"},"Anguilla":{"exemplarCity":"Anguilla"},"Antigua":{"exemplarCity":"Antigua"},"Araguaina":{"exemplarCity":"Araguaina"},"Argentina":{"Rio_Gallegos":{"exemplarCity":"Rio Gallegos"},"San_Juan":{"exemplarCity":"San Juan"},"Ushuaia":{"exemplarCity":"Ushuaia"},"La_Rioja":{"exemplarCity":"La Rioja"},"San_Luis":{"exemplarCity":"San Luis"},"Salta":{"exemplarCity":"Salta"},"Tucuman":{"exemplarCity":"Tucuman"}},"Aruba":{"exemplarCity":"Aruba"},"Asuncion":{"exemplarCity":"Asunci\xf3n"},"Bahia":{"exemplarCity":"Bahia"},"Bahia_Banderas":{"exemplarCity":"Bahia Banderas"},"Barbados":{"exemplarCity":"Barbados"},"Belem":{"exemplarCity":"Belem"},"Belize":{"exemplarCity":"Belize"},"Blanc-Sablon":{"exemplarCity":"Blanc-Sablon"},"Boa_Vista":{"exemplarCity":"Boa Vista"},"Bogota":{"exemplarCity":"Bogota"},"Boise":{"exemplarCity":"Boise"},"Buenos_Aires":{"exemplarCity":"Buenos Aires"},"Cambridge_Bay":{"exemplarCity":"Cambridge Bay"},"Campo_Grande":{"exemplarCity":"Campo Grande"},"Cancun":{"exemplarCity":"Cancun"},"Caracas":{"exemplarCity":"Caracas"},"Catamarca":{"exemplarCity":"Catamarca"},"Cayenne":{"exemplarCity":"Cayenne"},"Cayman":{"exemplarCity":"Cayman"},"Chicago":{"exemplarCity":"Chicago"},"Chihuahua":{"exemplarCity":"Chihuahua"},"Coral_Harbour":{"exemplarCity":"Atikokan"},"Cordoba":{"exemplarCity":"Cordoba"},"Costa_Rica":{"exemplarCity":"Costa Rica"},"Creston":{"exemplarCity":"Creston"},"Cuiaba":{"exemplarCity":"Cuiaba"},"Curacao":{"exemplarCity":"Cura\xe7ao"},"Danmarkshavn":{"exemplarCity":"Danmarkshavn"},"Dawson":{"exemplarCity":"Dawson"},"Dawson_Creek":{"exemplarCity":"Dawson Creek"},"Denver":{"exemplarCity":"Denver"},"Detroit":{"exemplarCity":"Detroit"},"Dominica":{"exemplarCity":"Dominica"},"Edmonton":{"exemplarCity":"Edmonton"},"Eirunepe":{"exemplarCity":"Eirunepe"},"El_Salvador":{"exemplarCity":"El Salvador"},"Fort_Nelson":{"exemplarCity":"Fort Nelson"},"Fortaleza":{"exemplarCity":"Fortaleza"},"Glace_Bay":{"exemplarCity":"Glace Bay"},"Godthab":{"exemplarCity":"Nuuk"},"Goose_Bay":{"exemplarCity":"Goose Bay"},"Grand_Turk":{"exemplarCity":"Grand Turk"},"Grenada":{"exemplarCity":"Grenada"},"Guadeloupe":{"exemplarCity":"Guadeloupe"},"Guatemala":{"exemplarCity":"Guatemala"},"Guayaquil":{"exemplarCity":"Guayaquil"},"Guyana":{"exemplarCity":"Guyana"},"Halifax":{"exemplarCity":"Halifax"},"Havana":{"exemplarCity":"Havana"},"Hermosillo":{"exemplarCity":"Hermosillo"},"Indiana":{"Vincennes":{"exemplarCity":"Vincennes, Indiana"},"Petersburg":{"exemplarCity":"Petersburg, Indiana"},"Tell_City":{"exemplarCity":"Tell City, Indiana"},"Knox":{"exemplarCity":"Knox, Indiana"},"Winamac":{"exemplarCity":"Winamac, Indiana"},"Marengo":{"exemplarCity":"Marengo, Indiana"},"Vevay":{"exemplarCity":"Vevay, Indiana"}},"Indianapolis":{"exemplarCity":"Indianapolis"},"Inuvik":{"exemplarCity":"Inuvik"},"Iqaluit":{"exemplarCity":"Iqaluit"},"Jamaica":{"exemplarCity":"Jamaica"},"Jujuy":{"exemplarCity":"Jujuy"},"Juneau":{"exemplarCity":"Juneau"},"Kentucky":{"Monticello":{"exemplarCity":"Monticello, Kentucky"}},"Kralendijk":{"exemplarCity":"Kralendijk"},"La_Paz":{"exemplarCity":"La Paz"},"Lima":{"exemplarCity":"Lima"},"Los_Angeles":{"exemplarCity":"Los Angeles"},"Louisville":{"exemplarCity":"Louisville"},"Lower_Princes":{"exemplarCity":"Lower Prince\u2019s Quarter"},"Maceio":{"exemplarCity":"Maceio"},"Managua":{"exemplarCity":"Managua"},"Manaus":{"exemplarCity":"Manaus"},"Marigot":{"exemplarCity":"Marigot"},"Martinique":{"exemplarCity":"Martinique"},"Matamoros":{"exemplarCity":"Matamoros"},"Mazatlan":{"exemplarCity":"Mazatlan"},"Mendoza":{"exemplarCity":"Mendoza"},"Menominee":{"exemplarCity":"Menominee"},"Merida":{"exemplarCity":"Merida"},"Metlakatla":{"exemplarCity":"Metlakatla"},"Mexico_City":{"exemplarCity":"Mexico City"},"Miquelon":{"exemplarCity":"Miquelon"},"Moncton":{"exemplarCity":"Moncton"},"Monterrey":{"exemplarCity":"Monterrey"},"Montevideo":{"exemplarCity":"Montevideo"},"Montserrat":{"exemplarCity":"Montserrat"},"Nassau":{"exemplarCity":"Nassau"},"New_York":{"exemplarCity":"New York"},"Nipigon":{"exemplarCity":"Nipigon"},"Nome":{"exemplarCity":"Nome"},"Noronha":{"exemplarCity":"Noronha"},"North_Dakota":{"Beulah":{"exemplarCity":"Beulah, North Dakota"},"New_Salem":{"exemplarCity":"New Salem, North Dakota"},"Center":{"exemplarCity":"Center, North Dakota"}},"Ojinaga":{"exemplarCity":"Ojinaga"},"Panama":{"exemplarCity":"Panama"},"Pangnirtung":{"exemplarCity":"Pangnirtung"},"Paramaribo":{"exemplarCity":"Paramaribo"},"Phoenix":{"exemplarCity":"Phoenix"},"Port-au-Prince":{"exemplarCity":"Port-au-Prince"},"Port_of_Spain":{"exemplarCity":"Port of Spain"},"Porto_Velho":{"exemplarCity":"Porto Velho"},"Puerto_Rico":{"exemplarCity":"Puerto Rico"},"Punta_Arenas":{"exemplarCity":"Punta Arenas"},"Rainy_River":{"exemplarCity":"Rainy River"},"Rankin_Inlet":{"exemplarCity":"Rankin Inlet"},"Recife":{"exemplarCity":"Recife"},"Regina":{"exemplarCity":"Regina"},"Resolute":{"exemplarCity":"Resolute"},"Rio_Branco":{"exemplarCity":"Rio Branco"},"Santarem":{"exemplarCity":"Santarem"},"Santiago":{"exemplarCity":"Santiago"},"Santo_Domingo":{"exemplarCity":"Santo Domingo"},"Sao_Paulo":{"exemplarCity":"Sao Paulo"},"Scoresbysund":{"exemplarCity":"Ittoqqortoormiit"},"Sitka":{"exemplarCity":"Sitka"},"St_Barthelemy":{"exemplarCity":"St Barth\xe9lemy"},"St_Johns":{"exemplarCity":"St John\u2019s"},"St_Kitts":{"exemplarCity":"St Kitts"},"St_Lucia":{"exemplarCity":"St Lucia"},"St_Thomas":{"exemplarCity":"St Thomas"},"St_Vincent":{"exemplarCity":"St Vincent"},"Swift_Current":{"exemplarCity":"Swift Current"},"Tegucigalpa":{"exemplarCity":"Tegucigalpa"},"Thule":{"exemplarCity":"Thule"},"Thunder_Bay":{"exemplarCity":"Thunder Bay"},"Tijuana":{"exemplarCity":"Tijuana"},"Toronto":{"exemplarCity":"Toronto"},"Tortola":{"exemplarCity":"Tortola"},"Vancouver":{"exemplarCity":"Vancouver"},"Whitehorse":{"exemplarCity":"Whitehorse"},"Winnipeg":{"exemplarCity":"Winnipeg"},"Yakutat":{"exemplarCity":"Yakutat"},"Yellowknife":{"exemplarCity":"Yellowknife"}},"Atlantic":{"Azores":{"exemplarCity":"Azores"},"Bermuda":{"exemplarCity":"Bermuda"},"Canary":{"exemplarCity":"Canary"},"Cape_Verde":{"exemplarCity":"Cape Verde"},"Faeroe":{"exemplarCity":"Faroe"},"Madeira":{"exemplarCity":"Madeira"},"Reykjavik":{"exemplarCity":"Reykjavik"},"South_Georgia":{"exemplarCity":"South Georgia"},"St_Helena":{"exemplarCity":"St Helena"},"Stanley":{"exemplarCity":"Stanley"}},"Europe":{"Amsterdam":{"exemplarCity":"Amsterdam"},"Andorra":{"exemplarCity":"Andorra"},"Astrakhan":{"exemplarCity":"Astrakhan"},"Athens":{"exemplarCity":"Athens"},"Belgrade":{"exemplarCity":"Belgrade"},"Berlin":{"exemplarCity":"Berlin"},"Bratislava":{"exemplarCity":"Bratislava"},"Brussels":{"exemplarCity":"Brussels"},"Bucharest":{"exemplarCity":"Bucharest"},"Budapest":{"exemplarCity":"Budapest"},"Busingen":{"exemplarCity":"Busingen"},"Chisinau":{"exemplarCity":"Chisinau"},"Copenhagen":{"exemplarCity":"Copenhagen"},"Dublin":{"long":{"daylight":"Irish Standard Time"},"exemplarCity":"Dublin"},"Gibraltar":{"exemplarCity":"Gibraltar"},"Guernsey":{"exemplarCity":"Guernsey"},"Helsinki":{"exemplarCity":"Helsinki"},"Isle_of_Man":{"exemplarCity":"Isle of Man"},"Istanbul":{"exemplarCity":"Istanbul"},"Jersey":{"exemplarCity":"Jersey"},"Kaliningrad":{"exemplarCity":"Kaliningrad"},"Kiev":{"exemplarCity":"Kiev","exemplarCity-alt-formal":"Kyiv"},"Kirov":{"exemplarCity":"Kirov"},"Lisbon":{"exemplarCity":"Lisbon"},"Ljubljana":{"exemplarCity":"Ljubljana"},"London":{"long":{"daylight":"British Summer Time"},"short":{"daylight":"BST"},"exemplarCity":"London"},"Luxembourg":{"exemplarCity":"Luxembourg"},"Madrid":{"exemplarCity":"Madrid"},"Malta":{"exemplarCity":"Malta"},"Mariehamn":{"exemplarCity":"Mariehamn"},"Minsk":{"exemplarCity":"Minsk"},"Monaco":{"exemplarCity":"Monaco"},"Moscow":{"exemplarCity":"Moscow"},"Oslo":{"exemplarCity":"Oslo"},"Paris":{"exemplarCity":"Paris"},"Podgorica":{"exemplarCity":"Podgorica"},"Prague":{"exemplarCity":"Prague"},"Riga":{"exemplarCity":"Riga"},"Rome":{"exemplarCity":"Rome"},"Samara":{"exemplarCity":"Samara"},"San_Marino":{"exemplarCity":"San Marino"},"Sarajevo":{"exemplarCity":"Sarajevo"},"Saratov":{"exemplarCity":"Saratov"},"Simferopol":{"exemplarCity":"Simferopol"},"Skopje":{"exemplarCity":"Skopje"},"Sofia":{"exemplarCity":"Sofia"},"Stockholm":{"exemplarCity":"Stockholm"},"Tallinn":{"exemplarCity":"Tallinn"},"Tirane":{"exemplarCity":"Tirane"},"Ulyanovsk":{"exemplarCity":"Ulyanovsk"},"Uzhgorod":{"exemplarCity":"Uzhhorod"},"Vaduz":{"exemplarCity":"Vaduz"},"Vatican":{"exemplarCity":"Vatican"},"Vienna":{"exemplarCity":"Vienna"},"Vilnius":{"exemplarCity":"Vilnius"},"Volgograd":{"exemplarCity":"Volgograd"},"Warsaw":{"exemplarCity":"Warsaw"},"Zagreb":{"exemplarCity":"Zagreb"},"Zaporozhye":{"exemplarCity":"Zaporozhye"},"Zurich":{"exemplarCity":"Zurich"}},"Africa":{"Abidjan":{"exemplarCity":"Abidjan"},"Accra":{"exemplarCity":"Accra"},"Addis_Ababa":{"exemplarCity":"Addis Ababa"},"Algiers":{"exemplarCity":"Algiers"},"Asmera":{"exemplarCity":"Asmara"},"Bamako":{"exemplarCity":"Bamako"},"Bangui":{"exemplarCity":"Bangui"},"Banjul":{"exemplarCity":"Banjul"},"Bissau":{"exemplarCity":"Bissau"},"Blantyre":{"exemplarCity":"Blantyre"},"Brazzaville":{"exemplarCity":"Brazzaville"},"Bujumbura":{"exemplarCity":"Bujumbura"},"Cairo":{"exemplarCity":"Cairo"},"Casablanca":{"exemplarCity":"Casablanca"},"Ceuta":{"exemplarCity":"Ceuta"},"Conakry":{"exemplarCity":"Conakry"},"Dakar":{"exemplarCity":"Dakar"},"Dar_es_Salaam":{"exemplarCity":"Dar es Salaam"},"Djibouti":{"exemplarCity":"Djibouti"},"Douala":{"exemplarCity":"Douala"},"El_Aaiun":{"exemplarCity":"El Aaiun"},"Freetown":{"exemplarCity":"Freetown"},"Gaborone":{"exemplarCity":"Gaborone"},"Harare":{"exemplarCity":"Harare"},"Johannesburg":{"exemplarCity":"Johannesburg"},"Juba":{"exemplarCity":"Juba"},"Kampala":{"exemplarCity":"Kampala"},"Khartoum":{"exemplarCity":"Khartoum"},"Kigali":{"exemplarCity":"Kigali"},"Kinshasa":{"exemplarCity":"Kinshasa"},"Lagos":{"exemplarCity":"Lagos"},"Libreville":{"exemplarCity":"Libreville"},"Lome":{"exemplarCity":"Lome"},"Luanda":{"exemplarCity":"Luanda"},"Lubumbashi":{"exemplarCity":"Lubumbashi"},"Lusaka":{"exemplarCity":"Lusaka"},"Malabo":{"exemplarCity":"Malabo"},"Maputo":{"exemplarCity":"Maputo"},"Maseru":{"exemplarCity":"Maseru"},"Mbabane":{"exemplarCity":"Mbabane"},"Mogadishu":{"exemplarCity":"Mogadishu"},"Monrovia":{"exemplarCity":"Monrovia"},"Nairobi":{"exemplarCity":"Nairobi"},"Ndjamena":{"exemplarCity":"Ndjamena"},"Niamey":{"exemplarCity":"Niamey"},"Nouakchott":{"exemplarCity":"Nouakchott"},"Ouagadougou":{"exemplarCity":"Ouagadougou"},"Porto-Novo":{"exemplarCity":"Porto-Novo"},"Sao_Tome":{"exemplarCity":"S\xe3o Tom\xe9"},"Tripoli":{"exemplarCity":"Tripoli"},"Tunis":{"exemplarCity":"Tunis"},"Windhoek":{"exemplarCity":"Windhoek"}},"Asia":{"Aden":{"exemplarCity":"Aden"},"Almaty":{"exemplarCity":"Almaty"},"Amman":{"exemplarCity":"Amman"},"Anadyr":{"exemplarCity":"Anadyr"},"Aqtau":{"exemplarCity":"Aqtau"},"Aqtobe":{"exemplarCity":"Aqtobe"},"Ashgabat":{"exemplarCity":"Ashgabat"},"Atyrau":{"exemplarCity":"Atyrau"},"Baghdad":{"exemplarCity":"Baghdad"},"Bahrain":{"exemplarCity":"Bahrain"},"Baku":{"exemplarCity":"Baku"},"Bangkok":{"exemplarCity":"Bangkok"},"Barnaul":{"exemplarCity":"Barnaul"},"Beirut":{"exemplarCity":"Beirut"},"Bishkek":{"exemplarCity":"Bishkek"},"Brunei":{"exemplarCity":"Brunei"},"Calcutta":{"exemplarCity":"Kolkata"},"Chita":{"exemplarCity":"Chita"},"Choibalsan":{"exemplarCity":"Choibalsan"},"Colombo":{"exemplarCity":"Colombo"},"Damascus":{"exemplarCity":"Damascus"},"Dhaka":{"exemplarCity":"Dhaka"},"Dili":{"exemplarCity":"Dili"},"Dubai":{"exemplarCity":"Dubai"},"Dushanbe":{"exemplarCity":"Dushanbe"},"Famagusta":{"exemplarCity":"Famagusta"},"Gaza":{"exemplarCity":"Gaza"},"Hebron":{"exemplarCity":"Hebron"},"Hong_Kong":{"exemplarCity":"Hong Kong"},"Hovd":{"exemplarCity":"Hovd"},"Irkutsk":{"exemplarCity":"Irkutsk"},"Jakarta":{"exemplarCity":"Jakarta"},"Jayapura":{"exemplarCity":"Jayapura"},"Jerusalem":{"exemplarCity":"Jerusalem"},"Kabul":{"exemplarCity":"Kabul"},"Kamchatka":{"exemplarCity":"Kamchatka"},"Karachi":{"exemplarCity":"Karachi"},"Katmandu":{"exemplarCity":"Kathmandu"},"Khandyga":{"exemplarCity":"Khandyga"},"Krasnoyarsk":{"exemplarCity":"Krasnoyarsk"},"Kuala_Lumpur":{"exemplarCity":"Kuala Lumpur"},"Kuching":{"exemplarCity":"Kuching"},"Kuwait":{"exemplarCity":"Kuwait"},"Macau":{"exemplarCity":"Macao"},"Magadan":{"exemplarCity":"Magadan"},"Makassar":{"exemplarCity":"Makassar"},"Manila":{"exemplarCity":"Manila"},"Muscat":{"exemplarCity":"Muscat"},"Nicosia":{"exemplarCity":"Nicosia"},"Novokuznetsk":{"exemplarCity":"Novokuznetsk"},"Novosibirsk":{"exemplarCity":"Novosibirsk"},"Omsk":{"exemplarCity":"Omsk"},"Oral":{"exemplarCity":"Oral"},"Phnom_Penh":{"exemplarCity":"Phnom Penh"},"Pontianak":{"exemplarCity":"Pontianak"},"Pyongyang":{"exemplarCity":"Pyongyang"},"Qatar":{"exemplarCity":"Qatar"},"Qostanay":{"exemplarCity":"Kostanay"},"Qyzylorda":{"exemplarCity":"Qyzylorda"},"Rangoon":{"exemplarCity":"Yangon"},"Riyadh":{"exemplarCity":"Riyadh"},"Saigon":{"exemplarCity":"Ho Chi Minh City"},"Sakhalin":{"exemplarCity":"Sakhalin"},"Samarkand":{"exemplarCity":"Samarkand"},"Seoul":{"exemplarCity":"Seoul"},"Shanghai":{"exemplarCity":"Shanghai"},"Singapore":{"exemplarCity":"Singapore"},"Srednekolymsk":{"exemplarCity":"Srednekolymsk"},"Taipei":{"exemplarCity":"Taipei"},"Tashkent":{"exemplarCity":"Tashkent"},"Tbilisi":{"exemplarCity":"Tbilisi"},"Tehran":{"exemplarCity":"Tehran"},"Thimphu":{"exemplarCity":"Thimphu"},"Tokyo":{"exemplarCity":"Tokyo"},"Tomsk":{"exemplarCity":"Tomsk"},"Ulaanbaatar":{"exemplarCity":"Ulaanbaatar"},"Urumqi":{"exemplarCity":"Urumqi"},"Ust-Nera":{"exemplarCity":"Ust-Nera"},"Vientiane":{"exemplarCity":"Vientiane"},"Vladivostok":{"exemplarCity":"Vladivostok"},"Yakutsk":{"exemplarCity":"Yakutsk"},"Yekaterinburg":{"exemplarCity":"Yekaterinburg"},"Yerevan":{"exemplarCity":"Yerevan"}},"Indian":{"Antananarivo":{"exemplarCity":"Antananarivo"},"Chagos":{"exemplarCity":"Chagos"},"Christmas":{"exemplarCity":"Christmas"},"Cocos":{"exemplarCity":"Cocos"},"Comoro":{"exemplarCity":"Comoro"},"Kerguelen":{"exemplarCity":"Kerguelen"},"Mahe":{"exemplarCity":"Mahe"},"Maldives":{"exemplarCity":"Maldives"},"Mauritius":{"exemplarCity":"Mauritius"},"Mayotte":{"exemplarCity":"Mayotte"},"Reunion":{"exemplarCity":"R\xe9union"}},"Australia":{"Adelaide":{"exemplarCity":"Adelaide"},"Brisbane":{"exemplarCity":"Brisbane"},"Broken_Hill":{"exemplarCity":"Broken Hill"},"Currie":{"exemplarCity":"Currie"},"Darwin":{"exemplarCity":"Darwin"},"Eucla":{"exemplarCity":"Eucla"},"Hobart":{"exemplarCity":"Hobart"},"Lindeman":{"exemplarCity":"Lindeman"},"Lord_Howe":{"exemplarCity":"Lord Howe"},"Melbourne":{"exemplarCity":"Melbourne"},"Perth":{"exemplarCity":"Perth"},"Sydney":{"exemplarCity":"Sydney"}},"Pacific":{"Apia":{"exemplarCity":"Apia"},"Auckland":{"exemplarCity":"Auckland"},"Bougainville":{"exemplarCity":"Bougainville"},"Chatham":{"exemplarCity":"Chatham"},"Easter":{"exemplarCity":"Easter"},"Efate":{"exemplarCity":"Efate"},"Enderbury":{"exemplarCity":"Enderbury"},"Fakaofo":{"exemplarCity":"Fakaofo"},"Fiji":{"exemplarCity":"Fiji"},"Funafuti":{"exemplarCity":"Funafuti"},"Galapagos":{"exemplarCity":"Galapagos"},"Gambier":{"exemplarCity":"Gambier"},"Guadalcanal":{"exemplarCity":"Guadalcanal"},"Guam":{"exemplarCity":"Guam"},"Johnston":{"exemplarCity":"Johnston"},"Kiritimati":{"exemplarCity":"Kiritimati"},"Kosrae":{"exemplarCity":"Kosrae"},"Kwajalein":{"exemplarCity":"Kwajalein"},"Majuro":{"exemplarCity":"Majuro"},"Marquesas":{"exemplarCity":"Marquesas"},"Midway":{"exemplarCity":"Midway"},"Nauru":{"exemplarCity":"Nauru"},"Niue":{"exemplarCity":"Niue"},"Norfolk":{"exemplarCity":"Norfolk"},"Noumea":{"exemplarCity":"Noumea"},"Pago_Pago":{"exemplarCity":"Pago Pago"},"Palau":{"exemplarCity":"Palau"},"Pitcairn":{"exemplarCity":"Pitcairn"},"Ponape":{"exemplarCity":"Pohnpei"},"Port_Moresby":{"exemplarCity":"Port Moresby"},"Rarotonga":{"exemplarCity":"Rarotonga"},"Saipan":{"exemplarCity":"Saipan"},"Tahiti":{"exemplarCity":"Tahiti"},"Tarawa":{"exemplarCity":"Tarawa"},"Tongatapu":{"exemplarCity":"Tongatapu"},"Truk":{"exemplarCity":"Chuuk"},"Wake":{"exemplarCity":"Wake"},"Wallis":{"exemplarCity":"Wallis"}},"Arctic":{"Longyearbyen":{"exemplarCity":"Longyearbyen"}},"Antarctica":{"Casey":{"exemplarCity":"Casey"},"Davis":{"exemplarCity":"Davis"},"DumontDUrville":{"exemplarCity":"Dumont d\u2019Urville"},"Macquarie":{"exemplarCity":"Macquarie"},"Mawson":{"exemplarCity":"Mawson"},"McMurdo":{"exemplarCity":"McMurdo"},"Palmer":{"exemplarCity":"Palmer"},"Rothera":{"exemplarCity":"Rothera"},"Syowa":{"exemplarCity":"Syowa"},"Troll":{"exemplarCity":"Troll"},"Vostok":{"exemplarCity":"Vostok"}},"Etc":{"UTC":{"long":{"standard":"Coordinated Universal Time"},"short":{"standard":"UTC"}},"Unknown":{"exemplarCity":"Unknown City"}}},"metazone":{"Acre":{"long":{"generic":"Acre Time","standard":"Acre Standard Time","daylight":"Acre Summer Time"}},"Afghanistan":{"long":{"standard":"Afghanistan Time"}},"Africa_Central":{"long":{"standard":"Central Africa Time"}},"Africa_Eastern":{"long":{"standard":"East Africa Time"}},"Africa_Southern":{"long":{"standard":"South Africa Standard Time"}},"Africa_Western":{"long":{"generic":"West Africa Time","standard":"West Africa Standard Time","daylight":"West Africa Summer Time"}},"Alaska":{"long":{"generic":"Alaska Time","standard":"Alaska Standard Time","daylight":"Alaska Daylight Time"}},"Almaty":{"long":{"generic":"Almaty Time","standard":"Almaty Standard Time","daylight":"Almaty Summer Time"}},"Amazon":{"long":{"generic":"Amazon Time","standard":"Amazon Standard Time","daylight":"Amazon Summer Time"}},"America_Central":{"long":{"generic":"Central Time","standard":"Central Standard Time","daylight":"Central Daylight Time"}},"America_Eastern":{"long":{"generic":"Eastern Time","standard":"Eastern Standard Time","daylight":"Eastern Daylight Time"}},"America_Mountain":{"long":{"generic":"Mountain Time","standard":"Mountain Standard Time","daylight":"Mountain Daylight Time"}},"America_Pacific":{"long":{"generic":"Pacific Time","standard":"Pacific Standard Time","daylight":"Pacific Daylight Time"}},"Anadyr":{"long":{"generic":"Anadyr Time","standard":"Anadyr Standard Time","daylight":"Anadyr Summer Time"}},"Apia":{"long":{"generic":"Apia Time","standard":"Apia Standard Time","daylight":"Apia Daylight Time"}},"Aqtau":{"long":{"generic":"Aqtau Time","standard":"Aqtau Standard Time","daylight":"Aqtau Summer Time"}},"Aqtobe":{"long":{"generic":"Aqtobe Time","standard":"Aqtobe Standard Time","daylight":"Aqtobe Summer Time"}},"Arabian":{"long":{"generic":"Arabian Time","standard":"Arabian Standard Time","daylight":"Arabian Daylight Time"}},"Argentina":{"long":{"generic":"Argentina Time","standard":"Argentina Standard Time","daylight":"Argentina Summer Time"}},"Argentina_Western":{"long":{"generic":"Western Argentina Time","standard":"Western Argentina Standard Time","daylight":"Western Argentina Summer Time"}},"Armenia":{"long":{"generic":"Armenia Time","standard":"Armenia Standard Time","daylight":"Armenia Summer Time"}},"Atlantic":{"long":{"generic":"Atlantic Time","standard":"Atlantic Standard Time","daylight":"Atlantic Daylight Time"}},"Australia_Central":{"long":{"generic":"Central Australia Time","standard":"Australian Central Standard Time","daylight":"Australian Central Daylight Time"}},"Australia_CentralWestern":{"long":{"generic":"Australian Central Western Time","standard":"Australian Central Western Standard Time","daylight":"Australian Central Western Daylight Time"}},"Australia_Eastern":{"long":{"generic":"Eastern Australia Time","standard":"Australian Eastern Standard Time","daylight":"Australian Eastern Daylight Time"}},"Australia_Western":{"long":{"generic":"Western Australia Time","standard":"Australian Western Standard Time","daylight":"Australian Western Daylight Time"}},"Azerbaijan":{"long":{"generic":"Azerbaijan Time","standard":"Azerbaijan Standard Time","daylight":"Azerbaijan Summer Time"}},"Azores":{"long":{"generic":"Azores Time","standard":"Azores Standard Time","daylight":"Azores Summer Time"}},"Bangladesh":{"long":{"generic":"Bangladesh Time","standard":"Bangladesh Standard Time","daylight":"Bangladesh Summer Time"}},"Bhutan":{"long":{"standard":"Bhutan Time"}},"Bolivia":{"long":{"standard":"Bolivia Time"}},"Brasilia":{"long":{"generic":"Brasilia Time","standard":"Brasilia Standard Time","daylight":"Brasilia Summer Time"}},"Brunei":{"long":{"standard":"Brunei Darussalam Time"}},"Cape_Verde":{"long":{"generic":"Cape Verde Time","standard":"Cape Verde Standard Time","daylight":"Cape Verde Summer Time"}},"Casey":{"long":{"standard":"Casey Time"}},"Chamorro":{"long":{"standard":"Chamorro Standard Time"}},"Chatham":{"long":{"generic":"Chatham Time","standard":"Chatham Standard Time","daylight":"Chatham Daylight Time"}},"Chile":{"long":{"generic":"Chile Time","standard":"Chile Standard Time","daylight":"Chile Summer Time"}},"China":{"long":{"generic":"China Time","standard":"China Standard Time","daylight":"China Daylight Time"}},"Choibalsan":{"long":{"generic":"Choibalsan Time","standard":"Choibalsan Standard Time","daylight":"Choibalsan Summer Time"}},"Christmas":{"long":{"standard":"Christmas Island Time"}},"Cocos":{"long":{"standard":"Cocos Islands Time"}},"Colombia":{"long":{"generic":"Colombia Time","standard":"Colombia Standard Time","daylight":"Colombia Summer Time"}},"Cook":{"long":{"generic":"Cook Islands Time","standard":"Cook Islands Standard Time","daylight":"Cook Islands Half Summer Time"}},"Cuba":{"long":{"generic":"Cuba Time","standard":"Cuba Standard Time","daylight":"Cuba Daylight Time"}},"Davis":{"long":{"standard":"Davis Time"}},"DumontDUrville":{"long":{"standard":"Dumont-d\u2019Urville Time"}},"East_Timor":{"long":{"standard":"East Timor Time"}},"Easter":{"long":{"generic":"Easter Island Time","standard":"Easter Island Standard Time","daylight":"Easter Island Summer Time"}},"Ecuador":{"long":{"standard":"Ecuador Time"}},"Europe_Central":{"long":{"generic":"Central European Time","standard":"Central European Standard Time","daylight":"Central European Summer Time"},"short":{"generic":"CET","standard":"CET","daylight":"CEST"}},"Europe_Eastern":{"long":{"generic":"Eastern European Time","standard":"Eastern European Standard Time","daylight":"Eastern European Summer Time"},"short":{"generic":"EET","standard":"EET","daylight":"EEST"}},"Europe_Further_Eastern":{"long":{"standard":"Further-eastern European Time"}},"Europe_Western":{"long":{"generic":"Western European Time","standard":"Western European Standard Time","daylight":"Western European Summer Time"},"short":{"generic":"WET","standard":"WET","daylight":"WEST"}},"Falkland":{"long":{"generic":"Falkland Islands Time","standard":"Falkland Islands Standard Time","daylight":"Falkland Islands Summer Time"}},"Fiji":{"long":{"generic":"Fiji Time","standard":"Fiji Standard Time","daylight":"Fiji Summer Time"}},"French_Guiana":{"long":{"standard":"French Guiana Time"}},"French_Southern":{"long":{"standard":"French Southern & Antarctic Time"}},"Galapagos":{"long":{"standard":"Galapagos Time"}},"Gambier":{"long":{"standard":"Gambier Time"}},"Georgia":{"long":{"generic":"Georgia Time","standard":"Georgia Standard Time","daylight":"Georgia Summer Time"}},"Gilbert_Islands":{"long":{"standard":"Gilbert Islands Time"}},"GMT":{"long":{"standard":"Greenwich Mean Time"},"short":{"standard":"GMT"}},"Greenland_Eastern":{"long":{"generic":"East Greenland Time","standard":"East Greenland Standard Time","daylight":"East Greenland Summer Time"}},"Greenland_Western":{"long":{"generic":"West Greenland Time","standard":"West Greenland Standard Time","daylight":"West Greenland Summer Time"}},"Guam":{"long":{"standard":"Guam Standard Time"}},"Gulf":{"long":{"standard":"Gulf Standard Time"}},"Guyana":{"long":{"standard":"Guyana Time"}},"Hawaii_Aleutian":{"long":{"generic":"Hawaii-Aleutian Time","standard":"Hawaii-Aleutian Standard Time","daylight":"Hawaii-Aleutian Daylight Time"}},"Hong_Kong":{"long":{"generic":"Hong Kong Time","standard":"Hong Kong Standard Time","daylight":"Hong Kong Summer Time"}},"Hovd":{"long":{"generic":"Hovd Time","standard":"Hovd Standard Time","daylight":"Hovd Summer Time"}},"India":{"long":{"standard":"India Standard Time"}},"Indian_Ocean":{"long":{"standard":"Indian Ocean Time"}},"Indochina":{"long":{"standard":"Indochina Time"}},"Indonesia_Central":{"long":{"standard":"Central Indonesia Time"}},"Indonesia_Eastern":{"long":{"standard":"Eastern Indonesia Time"}},"Indonesia_Western":{"long":{"standard":"Western Indonesia Time"}},"Iran":{"long":{"generic":"Iran Time","standard":"Iran Standard Time","daylight":"Iran Daylight Time"}},"Irkutsk":{"long":{"generic":"Irkutsk Time","standard":"Irkutsk Standard Time","daylight":"Irkutsk Summer Time"}},"Israel":{"long":{"generic":"Israel Time","standard":"Israel Standard Time","daylight":"Israel Daylight Time"}},"Japan":{"long":{"generic":"Japan Time","standard":"Japan Standard Time","daylight":"Japan Daylight Time"}},"Kamchatka":{"long":{"generic":"Petropavlovsk-Kamchatski Time","standard":"Petropavlovsk-Kamchatski Standard Time","daylight":"Petropavlovsk-Kamchatski Summer Time"}},"Kazakhstan_Eastern":{"long":{"standard":"East Kazakhstan Time"}},"Kazakhstan_Western":{"long":{"standard":"West Kazakhstan Time"}},"Korea":{"long":{"generic":"Korean Time","standard":"Korean Standard Time","daylight":"Korean Daylight Time"}},"Kosrae":{"long":{"standard":"Kosrae Time"}},"Krasnoyarsk":{"long":{"generic":"Krasnoyarsk Time","standard":"Krasnoyarsk Standard Time","daylight":"Krasnoyarsk Summer Time"}},"Kyrgystan":{"long":{"standard":"Kyrgyzstan Time"}},"Lanka":{"long":{"standard":"Lanka Time"}},"Line_Islands":{"long":{"standard":"Line Islands Time"}},"Lord_Howe":{"long":{"generic":"Lord Howe Time","standard":"Lord Howe Standard Time","daylight":"Lord Howe Daylight Time"}},"Macau":{"long":{"generic":"Macao Time","standard":"Macao Standard Time","daylight":"Macao Summer Time"}},"Macquarie":{"long":{"standard":"Macquarie Island Time"}},"Magadan":{"long":{"generic":"Magadan Time","standard":"Magadan Standard Time","daylight":"Magadan Summer Time"}},"Malaysia":{"long":{"standard":"Malaysia Time"}},"Maldives":{"long":{"standard":"Maldives Time"}},"Marquesas":{"long":{"standard":"Marquesas Time"}},"Marshall_Islands":{"long":{"standard":"Marshall Islands Time"}},"Mauritius":{"long":{"generic":"Mauritius Time","standard":"Mauritius Standard Time","daylight":"Mauritius Summer Time"}},"Mawson":{"long":{"standard":"Mawson Time"}},"Mexico_Northwest":{"long":{"generic":"Northwest Mexico Time","standard":"Northwest Mexico Standard Time","daylight":"Northwest Mexico Daylight Time"}},"Mexico_Pacific":{"long":{"generic":"Mexican Pacific Time","standard":"Mexican Pacific Standard Time","daylight":"Mexican Pacific Daylight Time"}},"Mongolia":{"long":{"generic":"Ulaanbaatar Time","standard":"Ulaanbaatar Standard Time","daylight":"Ulaanbaatar Summer Time"}},"Moscow":{"long":{"generic":"Moscow Time","standard":"Moscow Standard Time","daylight":"Moscow Summer Time"}},"Myanmar":{"long":{"standard":"Myanmar Time"}},"Nauru":{"long":{"standard":"Nauru Time"}},"Nepal":{"long":{"standard":"Nepal Time"}},"New_Caledonia":{"long":{"generic":"New Caledonia Time","standard":"New Caledonia Standard Time","daylight":"New Caledonia Summer Time"}},"New_Zealand":{"long":{"generic":"New Zealand Time","standard":"New Zealand Standard Time","daylight":"New Zealand Daylight Time"}},"Newfoundland":{"long":{"generic":"Newfoundland Time","standard":"Newfoundland Standard Time","daylight":"Newfoundland Daylight Time"}},"Niue":{"long":{"standard":"Niue Time"}},"Norfolk":{"long":{"standard":"Norfolk Island Time"}},"Noronha":{"long":{"generic":"Fernando de Noronha Time","standard":"Fernando de Noronha Standard Time","daylight":"Fernando de Noronha Summer Time"}},"North_Mariana":{"long":{"standard":"North Mariana Islands Time"}},"Novosibirsk":{"long":{"generic":"Novosibirsk Time","standard":"Novosibirsk Standard Time","daylight":"Novosibirsk Summer Time"}},"Omsk":{"long":{"generic":"Omsk Time","standard":"Omsk Standard Time","daylight":"Omsk Summer Time"}},"Pakistan":{"long":{"generic":"Pakistan Time","standard":"Pakistan Standard Time","daylight":"Pakistan Summer Time"}},"Palau":{"long":{"standard":"Palau Time"}},"Papua_New_Guinea":{"long":{"standard":"Papua New Guinea Time"}},"Paraguay":{"long":{"generic":"Paraguay Time","standard":"Paraguay Standard Time","daylight":"Paraguay Summer Time"}},"Peru":{"long":{"generic":"Peru Time","standard":"Peru Standard Time","daylight":"Peru Summer Time"}},"Philippines":{"long":{"generic":"Philippine Time","standard":"Philippine Standard Time","daylight":"Philippine Summer Time"}},"Phoenix_Islands":{"long":{"standard":"Phoenix Islands Time"}},"Pierre_Miquelon":{"long":{"generic":"St Pierre & Miquelon Time","standard":"St Pierre & Miquelon Standard Time","daylight":"St Pierre & Miquelon Daylight Time"}},"Pitcairn":{"long":{"standard":"Pitcairn Time"}},"Ponape":{"long":{"standard":"Ponape Time"}},"Pyongyang":{"long":{"standard":"Pyongyang Time"}},"Qyzylorda":{"long":{"generic":"Qyzylorda Time","standard":"Qyzylorda Standard Time","daylight":"Qyzylorda Summer Time"}},"Reunion":{"long":{"standard":"R\xe9union Time"}},"Rothera":{"long":{"standard":"Rothera Time"}},"Sakhalin":{"long":{"generic":"Sakhalin Time","standard":"Sakhalin Standard Time","daylight":"Sakhalin Summer Time"}},"Samara":{"long":{"generic":"Samara Time","standard":"Samara Standard Time","daylight":"Samara Summer Time"}},"Samoa":{"long":{"generic":"Samoa Time","standard":"Samoa Standard Time","daylight":"Samoa Daylight Time"}},"Seychelles":{"long":{"standard":"Seychelles Time"}},"Singapore":{"long":{"standard":"Singapore Standard Time"}},"Solomon":{"long":{"standard":"Solomon Islands Time"}},"South_Georgia":{"long":{"standard":"South Georgia Time"}},"Suriname":{"long":{"standard":"Suriname Time"}},"Syowa":{"long":{"standard":"Syowa Time"}},"Tahiti":{"long":{"standard":"Tahiti Time"}},"Taipei":{"long":{"generic":"Taipei Time","standard":"Taipei Standard Time","daylight":"Taipei Daylight Time"}},"Tajikistan":{"long":{"standard":"Tajikistan Time"}},"Tokelau":{"long":{"standard":"Tokelau Time"}},"Tonga":{"long":{"generic":"Tonga Time","standard":"Tonga Standard Time","daylight":"Tonga Summer Time"}},"Truk":{"long":{"standard":"Chuuk Time"}},"Turkmenistan":{"long":{"generic":"Turkmenistan Time","standard":"Turkmenistan Standard Time","daylight":"Turkmenistan Summer Time"}},"Tuvalu":{"long":{"standard":"Tuvalu Time"}},"Uruguay":{"long":{"generic":"Uruguay Time","standard":"Uruguay Standard Time","daylight":"Uruguay Summer Time"}},"Uzbekistan":{"long":{"generic":"Uzbekistan Time","standard":"Uzbekistan Standard Time","daylight":"Uzbekistan Summer Time"}},"Vanuatu":{"long":{"generic":"Vanuatu Time","standard":"Vanuatu Standard Time","daylight":"Vanuatu Summer Time"}},"Venezuela":{"long":{"standard":"Venezuela Time"}},"Vladivostok":{"long":{"generic":"Vladivostok Time","standard":"Vladivostok Standard Time","daylight":"Vladivostok Summer Time"}},"Volgograd":{"long":{"generic":"Volgograd Time","standard":"Volgograd Standard Time","daylight":"Volgograd Summer Time"}},"Vostok":{"long":{"standard":"Vostok Time"}},"Wake":{"long":{"standard":"Wake Island Time"}},"Wallis":{"long":{"standard":"Wallis & Futuna Time"}},"Yakutsk":{"long":{"generic":"Yakutsk Time","standard":"Yakutsk Standard Time","daylight":"Yakutsk Summer Time"}},"Yekaterinburg":{"long":{"generic":"Yekaterinburg Time","standard":"Yekaterinburg Standard Time","daylight":"Yekaterinburg Summer Time"}}}}}}}}');


var $a840e239ab3f909d$exports = {};
$a840e239ab3f909d$exports = JSON.parse('{"supplemental":{"version":{"_unicodeVersion":"12.1.0","_cldrVersion":"36"},"weekData":{"minDays":{"001":"1","AD":"4","AN":"4","AT":"4","AX":"4","BE":"4","BG":"4","CH":"4","CZ":"4","DE":"4","DK":"4","EE":"4","ES":"4","FI":"4","FJ":"4","FO":"4","FR":"4","GB":"4","GF":"4","GG":"4","GI":"4","GP":"4","GR":"4","GU":"1","HU":"4","IE":"4","IM":"4","IS":"4","IT":"4","JE":"4","LI":"4","LT":"4","LU":"4","MC":"4","MQ":"4","NL":"4","NO":"4","PL":"4","PT":"4","RE":"4","RU":"4","SE":"4","SJ":"4","SK":"4","SM":"4","UM":"1","US":"1","VA":"4","VI":"1"},"firstDay":{"001":"mon","AD":"mon","AE":"sat","AF":"sat","AG":"sun","AI":"mon","AL":"mon","AM":"mon","AN":"mon","AR":"mon","AS":"sun","AT":"mon","AU":"sun","AX":"mon","AZ":"mon","BA":"mon","BD":"sun","BE":"mon","BG":"mon","BH":"sat","BM":"mon","BN":"mon","BR":"sun","BS":"sun","BT":"sun","BW":"sun","BY":"mon","BZ":"sun","CA":"sun","CH":"mon","CL":"mon","CM":"mon","CN":"sun","CO":"sun","CR":"mon","CY":"mon","CZ":"mon","DE":"mon","DJ":"sat","DK":"mon","DM":"sun","DO":"sun","DZ":"sat","EC":"mon","EE":"mon","EG":"sat","ES":"mon","ET":"sun","FI":"mon","FJ":"mon","FO":"mon","FR":"mon","GB":"mon","GB-alt-variant":"sun","GE":"mon","GF":"mon","GP":"mon","GR":"mon","GT":"sun","GU":"sun","HK":"sun","HN":"sun","HR":"mon","HU":"mon","ID":"sun","IE":"mon","IL":"sun","IN":"sun","IQ":"sat","IR":"sat","IS":"mon","IT":"mon","JM":"sun","JO":"sat","JP":"sun","KE":"sun","KG":"mon","KH":"sun","KR":"sun","KW":"sat","KZ":"mon","LA":"sun","LB":"mon","LI":"mon","LK":"mon","LT":"mon","LU":"mon","LV":"mon","LY":"sat","MC":"mon","MD":"mon","ME":"mon","MH":"sun","MK":"mon","MM":"sun","MN":"mon","MO":"sun","MQ":"mon","MT":"sun","MV":"fri","MX":"sun","MY":"mon","MZ":"sun","NI":"sun","NL":"mon","NO":"mon","NP":"sun","NZ":"mon","OM":"sat","PA":"sun","PE":"sun","PH":"sun","PK":"sun","PL":"mon","PR":"sun","PT":"sun","PY":"sun","QA":"sat","RE":"mon","RO":"mon","RS":"mon","RU":"mon","SA":"sun","SD":"sat","SE":"mon","SG":"sun","SI":"mon","SK":"mon","SM":"mon","SV":"sun","SY":"sat","TH":"sun","TJ":"mon","TM":"mon","TR":"mon","TT":"sun","TW":"sun","UA":"mon","UM":"sun","US":"sun","UY":"mon","UZ":"mon","VA":"mon","VE":"sun","VI":"sun","VN":"mon","WS":"sun","XK":"mon","YE":"sun","ZA":"sun","ZW":"sun"},"weekendStart":{"001":"sat","AE":"fri","AF":"thu","BH":"fri","DZ":"fri","EG":"fri","IL":"fri","IN":"sun","IQ":"fri","IR":"fri","JO":"fri","KW":"fri","LY":"fri","OM":"fri","QA":"fri","SA":"fri","SD":"fri","SY":"fri","UG":"sun","YE":"fri"},"weekendEnd":{"001":"sun","AE":"sat","AF":"fri","BH":"sat","DZ":"sat","EG":"sat","IL":"sat","IQ":"sat","IR":"fri","JO":"sat","KW":"sat","LY":"sat","OM":"sat","QA":"sat","SA":"sat","SD":"sat","SY":"sat","YE":"sat"},"af":{"_ordering":"weekOfDate weekOfInterval weekOfMonth"},"am az bs cs cy da el et hi ky lt mk sk ta th":{"_ordering":"weekOfYear weekOfMonth"},"ar fil gu hu hy id kk ko":{"_ordering":"weekOfMonth"},"be ro ru":{"_ordering":"weekOfInterval weekOfMonth"},"bg de iw pt ur zh":{"_ordering":"weekOfDate weekOfMonth weekOfInterval"},"ca es fr gl":{"_ordering":"weekOfDate"},"en bn ja ka":{"_ordering":"weekOfDate weekOfMonth"},"eu":{"_ordering":"weekOfMonth weekOfDate"},"fa hr it lv pl si sr uk uz":{"_ordering":"weekOfMonth weekOfInterval"},"fi zh-TW":{"_ordering":"weekOfYear weekOfDate weekOfMonth"},"is mn no sv vi":{"_ordering":"weekOfYear weekOfMonth weekOfInterval"},"km mr":{"_ordering":"weekOfMonth weekOfYear"},"kn ml pa":{"_ordering":"weekOfMonth weekOfDate weekOfYear"},"lo sq":{"_ordering":"weekOfMonth weekOfInterval weekOfDate weekOfYear"},"ms tr":{"_ordering":"weekOfMonth weekOfYear weekOfInterval weekOfDate"},"nl":{"_ordering":"weekOfDate weekOfYear weekOfMonth"},"sl":{"_ordering":"weekOfInterval"},"sw te":{"_ordering":"weekOfMonth weekOfInterval weekOfYear"},"und":{"_ordering":"weekOfYear"},"zu":{"_ordering":"weekOfYear weekOfInterval"}}}}');


(0, $bWDaN.loadCldr)((0, (/*@__PURE__*/$parcel$interopDefault($43d28fde80599c96$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($bc24ba34bca146b0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($dfd07ef432b5d001$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a840e239ab3f909d$exports))));



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");

var $49u5W = parcelRequire("49u5W");
var $2vAqh = parcelRequire("2vAqh");
/* eslint-disable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $168e4e125732cd26$var$CLASSNAMES = {
    RTL: "e-rtl",
    DISABLE: "e-disabled",
    INPUT: "e-input",
    TEXTAREA: "e-multi-line-input",
    INPUTGROUP: "e-input-group",
    FLOATINPUT: "e-float-input",
    FLOATLINE: "e-float-line",
    FLOATTEXT: "e-float-text",
    FLOATTEXTCONTENT: "e-float-text-content",
    CLEARICON: "e-clear-icon",
    CLEARICONHIDE: "e-clear-icon-hide",
    LABELTOP: "e-label-top",
    LABELBOTTOM: "e-label-bottom",
    NOFLOATLABEL: "e-no-float-label",
    INPUTCUSTOMTAG: "e-input-custom-tag",
    FLOATCUSTOMTAG: "e-float-custom-tag"
};
var $168e4e125732cd26$export$32cda1f66e0b465f = [
    "title",
    "style",
    "class"
];
var $168e4e125732cd26$export$a88d92a7bdb59b3e = "e-input-focus";
var $168e4e125732cd26$export$f5b8910cec6cf069;
(function(Input) {
    var privateInputObj = {
        container: null,
        buttons: [],
        clearButton: null
    };
    var floatType;
    var isBindClearAction = true;
    /**
     * Create a wrapper to input element with multiple span elements and set the basic properties to input based components.
     * ```
     * E.g : Input.createInput({ element: element, floatLabelType : "Auto", properties: { placeholder: 'Search' } });
     * ```
     *
     */ function createInput(args, internalCreateElement) {
        args.element.__eventHandlers = {};
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var inputObject = {
            container: null,
            buttons: [],
            clearButton: null
        };
        floatType = args.floatLabelType;
        isBindClearAction = args.bindClearAction;
        if ((0, $3EnZW.isNullOrUndefined)(args.floatLabelType) || args.floatLabelType === "Never") {
            inputObject.container = createInputContainer(args, $168e4e125732cd26$var$CLASSNAMES.INPUTGROUP, $168e4e125732cd26$var$CLASSNAMES.INPUTCUSTOMTAG, "span", makeElement);
            args.element.parentNode.insertBefore(inputObject.container, args.element);
            (0, $4ZDHT.addClass)([
                args.element
            ], $168e4e125732cd26$var$CLASSNAMES.INPUT);
            inputObject.container.appendChild(args.element);
        } else createFloatingInput(args, inputObject, makeElement);
        bindInitialEvent(args);
        if (!(0, $3EnZW.isNullOrUndefined)(args.properties) && !(0, $3EnZW.isNullOrUndefined)(args.properties.showClearButton) && args.properties.showClearButton) {
            setClearButton(args.properties.showClearButton, args.element, inputObject, true, makeElement);
            inputObject.clearButton.setAttribute("role", "button");
            if (inputObject.container.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT)) (0, $4ZDHT.addClass)([
                inputObject.container
            ], $168e4e125732cd26$var$CLASSNAMES.INPUTGROUP);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.buttons)) for(var i = 0; i < args.buttons.length; i++)inputObject.buttons.push(appendSpan(args.buttons[i], inputObject.container, makeElement));
        if (!(0, $3EnZW.isNullOrUndefined)(args.element) && args.element.tagName === "TEXTAREA") (0, $4ZDHT.addClass)([
            inputObject.container
        ], $168e4e125732cd26$var$CLASSNAMES.TEXTAREA);
        validateInputType(inputObject.container, args.element);
        inputObject = setPropertyValue(args, inputObject);
        createSpanElement(inputObject.container, makeElement);
        privateInputObj = inputObject;
        return inputObject;
    }
    Input.createInput = createInput;
    function bindFocusEventHandler(args) {
        var parent = getParentNode(args.element);
        if (parent.classList.contains("e-input-group") || parent.classList.contains("e-outline") || parent.classList.contains("e-filled")) parent.classList.add("e-input-focus");
        if (args.floatLabelType !== "Never") setTimeout(function() {
            Input.calculateWidth(args.element, parent);
        }, 80);
    }
    function bindBlurEventHandler(args) {
        var parent = getParentNode(args.element);
        if (parent.classList.contains("e-input-group") || parent.classList.contains("e-outline") || parent.classList.contains("e-filled")) parent.classList.remove("e-input-focus");
        if (args.floatLabelType !== "Never") setTimeout(function() {
            Input.calculateWidth(args.element, parent);
        }, 80);
    }
    function bindInputEventHandler(args) {
        checkInputValue(args.floatLabelType, args.element);
    }
    function bindInitialEvent(args) {
        checkInputValue(args.floatLabelType, args.element);
        var focusHandler = function() {
            return bindFocusEventHandler(args);
        };
        var blurHandler = function() {
            return bindBlurEventHandler(args);
        };
        var inputHandler = function() {
            return bindInputEventHandler(args);
        };
        args.element.addEventListener("focus", focusHandler);
        args.element.addEventListener("blur", blurHandler);
        args.element.addEventListener("input", inputHandler);
        args.element.__eventHandlers["inputFocusHandler"] = {
            focusHandler: focusHandler
        };
        args.element.__eventHandlers["inputBlurHandler"] = {
            blurHandler: blurHandler
        };
        args.element.__eventHandlers["inputHandler"] = {
            inputHandler: inputHandler
        };
    }
    Input.bindInitialEvent = bindInitialEvent;
    function unbindInitialEvent(args) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.element)) {
            if (!(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers)) {
                if (!(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers["inputFocusHandler"]) && !(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers["inputBlurHandler"]) && !(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers["inputHandler"])) {
                    var focusHandler_1 = args.element.__eventHandlers["inputFocusHandler"].focusHandler;
                    var blurHandler_1 = args.element.__eventHandlers["inputBlurHandler"].blurHandler;
                    var inputHandler_1 = args.element.__eventHandlers["inputHandler"].inputHandler;
                    args.element.removeEventListener("focus", focusHandler_1);
                    args.element.removeEventListener("blur", blurHandler_1);
                    args.element.removeEventListener("input", inputHandler_1);
                    // Clean up stored bound functions
                    delete args.element.__eventHandlers["inputFocusHandler"];
                    delete args.element.__eventHandlers["inputBlurHandler"];
                    delete args.element.__eventHandlers["inputHandler"];
                }
            }
        }
    }
    function checkInputValue(floatLabelType, inputElement) {
        var inputValue = inputElement.value;
        var inputParent = inputElement.parentElement;
        var grandParent = inputParent && inputParent.parentElement;
        if (inputValue !== "" && !(0, $3EnZW.isNullOrUndefined)(inputValue)) {
            if (inputParent && inputParent.classList.contains("e-input-group")) inputParent.classList.add("e-valid-input");
            else if (grandParent && grandParent.classList.contains("e-input-group")) grandParent.classList.add("e-valid-input");
        } else if (floatLabelType !== "Always") {
            if (inputParent && inputParent.classList.contains("e-input-group")) inputParent.classList.remove("e-valid-input");
            else if (grandParent && grandParent.classList.contains("e-input-group")) grandParent.classList.remove("e-valid-input");
        }
    }
    function _focusFn() {
        var label = getParentNode(this).getElementsByClassName("e-float-text")[0];
        if (!(0, $3EnZW.isNullOrUndefined)(label)) {
            (0, $4ZDHT.addClass)([
                label
            ], $168e4e125732cd26$var$CLASSNAMES.LABELTOP);
            if (label.classList.contains($168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM)) (0, $4ZDHT.removeClass)([
                label
            ], $168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM);
        }
    }
    function _blurFn() {
        var parent = getParentNode(this);
        if (parent.getElementsByTagName("textarea")[0] ? parent.getElementsByTagName("textarea")[0].value === "" : parent.getElementsByTagName("input")[0].value === "") {
            var label = parent.getElementsByClassName("e-float-text")[0];
            if (!(0, $3EnZW.isNullOrUndefined)(label)) {
                if (label.classList.contains($168e4e125732cd26$var$CLASSNAMES.LABELTOP)) (0, $4ZDHT.removeClass)([
                    label
                ], $168e4e125732cd26$var$CLASSNAMES.LABELTOP);
                (0, $4ZDHT.addClass)([
                    label
                ], $168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM);
            }
        }
    }
    function wireFloatingEvents(element) {
        element.addEventListener("focus", _focusFn);
        element.addEventListener("blur", _blurFn);
    }
    Input.wireFloatingEvents = wireFloatingEvents;
    function unwireFloatingEvents(element) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            element.removeEventListener("focus", _focusFn);
            element.removeEventListener("blur", _blurFn);
        }
    }
    function inputEventHandler(args) {
        validateLabel(args.element, args.floatLabelType);
    }
    function blurEventHandler(args) {
        validateLabel(args.element, args.floatLabelType);
    }
    function createFloatingInput(args, inputObject, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        if (args.floatLabelType === "Auto") wireFloatingEvents(args.element);
        if ((0, $3EnZW.isNullOrUndefined)(inputObject.container)) {
            inputObject.container = createInputContainer(args, $168e4e125732cd26$var$CLASSNAMES.FLOATINPUT, $168e4e125732cd26$var$CLASSNAMES.FLOATCUSTOMTAG, "div", makeElement);
            inputObject.container.classList.add($168e4e125732cd26$var$CLASSNAMES.INPUTGROUP);
            if (args.element.parentNode) args.element.parentNode.insertBefore(inputObject.container, args.element);
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(args.customTag)) inputObject.container.classList.add($168e4e125732cd26$var$CLASSNAMES.FLOATCUSTOMTAG);
            inputObject.container.classList.add($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT);
        }
        var floatLinelement = makeElement("span", {
            className: $168e4e125732cd26$var$CLASSNAMES.FLOATLINE
        });
        var floatLabelElement = makeElement("label", {
            className: $168e4e125732cd26$var$CLASSNAMES.FLOATTEXT
        });
        if (!(0, $3EnZW.isNullOrUndefined)(args.element.id) && args.element.id !== "") {
            floatLabelElement.id = "label_" + args.element.id.replace(/ /g, "_");
            (0, $4ZDHT.attributes)(args.element, {
                "aria-labelledby": floatLabelElement.id
            });
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.element.placeholder) && args.element.placeholder !== "") {
            floatLabelElement.innerText = encodePlaceHolder(args.element.placeholder);
            args.element.removeAttribute("placeholder");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.properties) && !(0, $3EnZW.isNullOrUndefined)(args.properties.placeholder) && args.properties.placeholder !== "") floatLabelElement.innerText = encodePlaceHolder(args.properties.placeholder);
        if (!floatLabelElement.innerText) inputObject.container.classList.add($168e4e125732cd26$var$CLASSNAMES.NOFLOATLABEL);
        if (inputObject.container.classList.contains("e-float-icon-left")) {
            var inputWrap = inputObject.container.querySelector(".e-input-in-wrap");
            inputWrap.appendChild(args.element);
            inputWrap.appendChild(floatLinelement);
            inputWrap.appendChild(floatLabelElement);
        } else {
            inputObject.container.appendChild(args.element);
            inputObject.container.appendChild(floatLinelement);
            inputObject.container.appendChild(floatLabelElement);
        }
        updateLabelState(args.element.value, floatLabelElement);
        if (args.floatLabelType === "Always") {
            if (floatLabelElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM)) (0, $4ZDHT.removeClass)([
                floatLabelElement
            ], $168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM);
            (0, $4ZDHT.addClass)([
                floatLabelElement
            ], $168e4e125732cd26$var$CLASSNAMES.LABELTOP);
        }
        if (args.floatLabelType === "Auto") {
            var inputFloatHandler = function() {
                return inputEventHandler(args);
            };
            var blurFloatHandler = function() {
                return blurEventHandler(args);
            };
            // Add event listeners using the defined functions
            args.element.addEventListener("input", inputFloatHandler);
            args.element.addEventListener("blur", blurFloatHandler);
            // Store the event handler functions to remove them later
            args.element.__eventHandlers["floatInputHandler"] = {
                inputFloatHandler: inputFloatHandler
            };
            args.element.__eventHandlers["floatBlurHandler"] = {
                blurFloatHandler: blurFloatHandler
            };
        } else unWireFloatLabelEvents(args);
        if (!(0, $3EnZW.isNullOrUndefined)(args.element.getAttribute("id"))) floatLabelElement.setAttribute("for", args.element.getAttribute("id"));
    }
    function unWireFloatLabelEvents(args) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.element) && !(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers) && !(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers["floatInputHandler"]) && !(0, $3EnZW.isNullOrUndefined)(args.element.__eventHandlers["floatBlurHandler"])) {
            var inputFloatHandler = args.element.__eventHandlers["floatInputHandler"].inputFloatHandler;
            var blurFloatHandler = args.element.__eventHandlers["floatBlurHandler"].blurFloatHandler;
            // Remove the event listeners using the defined functions
            args.element.removeEventListener("input", inputFloatHandler);
            args.element.removeEventListener("blur", blurFloatHandler);
            // Clean up stored event handler functions
            delete args.element.__eventHandlers["floatInputHandler"];
            delete args.element.__eventHandlers["floatBlurHandler"];
        }
    }
    function checkFloatLabelType(type, container) {
        if (type === "Always" && container.classList.contains("e-outline")) container.classList.add("e-valid-input");
    }
    function setPropertyValue(args, inputObject) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.properties)) for(var _i = 0, _a = Object.keys(args.properties); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "cssClass":
                    setCssClass(args.properties.cssClass, [
                        inputObject.container
                    ]);
                    checkFloatLabelType(args.floatLabelType, inputObject.container);
                    break;
                case "enabled":
                    setEnabled(args.properties.enabled, args.element, args.floatLabelType, inputObject.container);
                    break;
                case "enableRtl":
                    setEnableRtl(args.properties.enableRtl, [
                        inputObject.container
                    ]);
                    break;
                case "placeholder":
                    setPlaceholder(args.properties.placeholder, args.element);
                    break;
                case "readonly":
                    setReadonly(args.properties.readonly, args.element);
                    break;
            }
        }
        return inputObject;
    }
    function updateIconState(value, button, readonly) {
        if (!(0, $3EnZW.isNullOrUndefined)(button)) {
            if (value && !readonly) (0, $4ZDHT.removeClass)([
                button
            ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
            else (0, $4ZDHT.addClass)([
                button
            ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
        }
    }
    function updateLabelState(value, label, element) {
        if (element === void 0) element = null;
        if (value) {
            (0, $4ZDHT.addClass)([
                label
            ], $168e4e125732cd26$var$CLASSNAMES.LABELTOP);
            if (label.classList.contains($168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM)) (0, $4ZDHT.removeClass)([
                label
            ], $168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM);
        } else {
            var isNotFocused = element != null ? element !== document.activeElement : true;
            if (isNotFocused) {
                if (label.classList.contains($168e4e125732cd26$var$CLASSNAMES.LABELTOP)) (0, $4ZDHT.removeClass)([
                    label
                ], $168e4e125732cd26$var$CLASSNAMES.LABELTOP);
                (0, $4ZDHT.addClass)([
                    label
                ], $168e4e125732cd26$var$CLASSNAMES.LABELBOTTOM);
            }
        }
    }
    function getParentNode(element) {
        var parentNode = (0, $3EnZW.isNullOrUndefined)(element.parentNode) ? element : element.parentNode;
        if (parentNode && parentNode.classList.contains("e-input-in-wrap")) parentNode = parentNode.parentNode;
        return parentNode;
    }
    /**
     * To create clear button.
     */ function createClearButton(element, inputObject, initial, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var button = makeElement("span", {
            className: $168e4e125732cd26$var$CLASSNAMES.CLEARICON
        });
        var container = inputObject.container;
        if (!(0, $3EnZW.isNullOrUndefined)(initial)) container.appendChild(button);
        else {
            var baseElement = inputObject.container.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT) ? inputObject.container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATTEXT) : element;
            baseElement.insertAdjacentElement("afterend", button);
        }
        (0, $4ZDHT.addClass)([
            button
        ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
        wireClearBtnEvents(element, button, container);
        button.setAttribute("aria-label", "close");
        return button;
    }
    function clickHandler(event, element, button) {
        if (!(element.classList.contains($168e4e125732cd26$var$CLASSNAMES.DISABLE) || element.readOnly)) {
            event.preventDefault();
            if (element !== document.activeElement) element.focus();
            element.value = "";
            (0, $4ZDHT.addClass)([
                button
            ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
        }
    }
    function inputHandler(element, button) {
        updateIconState(element.value, button);
    }
    function focusHandler(element, button) {
        updateIconState(element.value, button, element.readOnly);
    }
    function blurHandler(element, button) {
        setTimeout(function() {
            if (!(0, $3EnZW.isNullOrUndefined)(button)) {
                (0, $4ZDHT.addClass)([
                    button
                ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
                button = !(0, $3EnZW.isNullOrUndefined)(element) && element.classList.contains("e-combobox") ? null : button;
            }
        }, 200);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function wireClearBtnEvents(element, button, container) {
        if (isBindClearAction === undefined || isBindClearAction) {
            var clickHandlerEvent = function(e) {
                return clickHandler(e, element, button);
            };
            button.addEventListener("click", clickHandlerEvent);
            element.__eventHandlers["clearClickHandler"] = {
                clickHandlerEvent: clickHandlerEvent
            };
        }
        var inputHandlerEvent = function() {
            return inputHandler(element, button);
        };
        var focusHandlerEvent = function() {
            return focusHandler(element, button);
        };
        var blurHandlerEvent = function() {
            return blurHandler(element, button);
        };
        element.addEventListener("input", inputHandlerEvent);
        element.addEventListener("focus", focusHandlerEvent);
        element.addEventListener("blur", blurHandlerEvent);
        // Store the bound functions to remove them later
        element.__eventHandlers["clearInputHandler"] = {
            inputHandlerEvent: inputHandlerEvent
        };
        element.__eventHandlers["clearFocusHandler"] = {
            focusHandlerEvent: focusHandlerEvent
        };
        element.__eventHandlers["clearBlurHandler"] = {
            blurHandlerEvent: blurHandlerEvent
        };
    }
    Input.wireClearBtnEvents = wireClearBtnEvents;
    function unWireClearBtnEvents(element, button) {
        if (!(0, $3EnZW.isNullOrUndefined)(element) && !(0, $3EnZW.isNullOrUndefined)(element.__eventHandlers)) {
            if (!(0, $3EnZW.isNullOrUndefined)(element.__eventHandlers["clearClickHandler"])) {
                var clickHandlerEvent = element.__eventHandlers["clearClickHandler"].clickHandlerEvent;
                if (isBindClearAction === undefined || isBindClearAction) {
                    if (!(0, $3EnZW.isNullOrUndefined)(button)) button.removeEventListener("click", clickHandlerEvent);
                }
                delete element.__eventHandlers["clearClickHandler"];
            }
            if (!(0, $3EnZW.isNullOrUndefined)(element.__eventHandlers["clearInputHandler"]) && !(0, $3EnZW.isNullOrUndefined)(element.__eventHandlers["clearFocusHandler"]) && !(0, $3EnZW.isNullOrUndefined)(element.__eventHandlers["clearBlurHandler"])) {
                var inputHandlerEvent = element.__eventHandlers["clearInputHandler"].inputHandlerEvent;
                var focusHandlerEvent = element.__eventHandlers["clearFocusHandler"].focusHandlerEvent;
                var blurHandlerEvent = element.__eventHandlers["clearBlurHandler"].blurHandlerEvent;
                element.removeEventListener("input", inputHandlerEvent);
                element.removeEventListener("focus", focusHandlerEvent);
                element.removeEventListener("blur", blurHandlerEvent);
                // Clean up stored Event functions
                delete element.__eventHandlers["clearInputHandler"];
                delete element.__eventHandlers["clearFocusHandler"];
                delete element.__eventHandlers["clearBlurHandler"];
            }
        }
    }
    function destroy(args, button) {
        if (button === void 0) button = null;
        unbindInitialEvent(args);
        if (args.floatLabelType === "Auto") unWireFloatLabelEvents(args);
        if (args.properties.showClearButton) unWireClearBtnEvents(args.element, button);
        if (!(0, $3EnZW.isNullOrUndefined)(args.buttons)) _internalRipple(false, null, args.buttons);
        unwireFloatingEvents(args.element);
        if (!(0, $3EnZW.isNullOrUndefined)(args.element)) {
            delete args.element.__eventHandlers;
            if (args.element.classList.contains($168e4e125732cd26$var$CLASSNAMES.INPUT)) args.element.classList.remove($168e4e125732cd26$var$CLASSNAMES.INPUT);
        }
        privateInputObj = null;
    }
    Input.destroy = destroy;
    function validateLabel(element, floatLabelType) {
        var parent = getParentNode(element);
        if (parent.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT) && floatLabelType === "Auto") {
            var label = getParentNode(element).getElementsByClassName("e-float-text")[0];
            updateLabelState(element.value, label, element);
        }
    }
    /**
     * To create input box contianer.
     */ function createInputContainer(args, className, tagClass, tag, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var container;
        if (!(0, $3EnZW.isNullOrUndefined)(args.customTag)) {
            container = makeElement(args.customTag, {
                className: className
            });
            container.classList.add(tagClass);
        } else container = makeElement(tag, {
            className: className
        });
        container.classList.add("e-control-wrapper");
        return container;
    }
    function encodePlaceHolder(placeholder) {
        var result = "";
        if (!(0, $3EnZW.isNullOrUndefined)(placeholder) && placeholder !== "") {
            var spanEle = document.createElement("span");
            spanEle.innerHTML = '<input  placeholder="' + placeholder + '"/>';
            var hiddenInput = spanEle.children[0];
            result = hiddenInput.placeholder;
        }
        return result;
    }
    /**
     * Sets the value to the input element.
     * ```
     * E.g : Input.setValue('content', element, "Auto", true );
     * ```
     *
     * @param {string} value - Specify the value of the input element.
     * @param {HTMLInputElement | HTMLTextAreaElement} element - The element on which the specified value is updated.
     * @param {string} floatLabelType - Specify the float label type of the input element.
     * @param {boolean} clearButton - Boolean value to specify whether the clear icon is enabled / disabled on the input.
     */ function setValue(value, element, floatLabelType, clearButton) {
        element.value = value;
        if (floatLabelType !== "Never") calculateWidth(element, element.parentElement);
        if (!(0, $3EnZW.isNullOrUndefined)(floatLabelType) && floatLabelType === "Auto") validateLabel(element, floatLabelType);
        if (!(0, $3EnZW.isNullOrUndefined)(clearButton) && clearButton) {
            var parentElement = getParentNode(element);
            if (!(0, $3EnZW.isNullOrUndefined)(parentElement)) {
                var button = parentElement.getElementsByClassName($168e4e125732cd26$var$CLASSNAMES.CLEARICON)[0];
                if (!(0, $3EnZW.isNullOrUndefined)(button)) {
                    if (element.value && !(0, $3EnZW.isNullOrUndefined)(parentElement) && parentElement.classList.contains("e-input-focus")) (0, $4ZDHT.removeClass)([
                        button
                    ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
                    else (0, $4ZDHT.addClass)([
                        button
                    ], $168e4e125732cd26$var$CLASSNAMES.CLEARICONHIDE);
                }
            }
        }
        checkInputValue(floatLabelType, element);
    }
    Input.setValue = setValue;
    /**
     * Sets the single or multiple cssClass to wrapper of input element.
     * ```
     * E.g : Input.setCssClass('e-custom-class', [element]);
     * ```
     *
     * @param {string} cssClass - Css class names which are needed to add.
     * @param {Element[] | NodeList} elements - The elements which are needed to add / remove classes.
     * @param {string} oldClass
     * - Css class names which are needed to remove. If old classes are need to remove, can give this optional parameter.
     */ function setCssClass(cssClass, elements, oldClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass) && oldClass !== "") (0, $4ZDHT.removeClass)(elements, oldClass.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(cssClass) && cssClass !== "") (0, $4ZDHT.addClass)(elements, cssClass.split(" "));
    }
    Input.setCssClass = setCssClass;
    /**
     * Set the width to the placeholder when it overflows on the button such as spinbutton, clearbutton, icon etc
     * ```
     * E.g : Input.calculateWidth(element, container);
     * ```
     *
     * @param {any} element - Input element which is need to add.
     * @param {HTMLElement} container - The parent element which is need to get the label span to calculate width
     */ function calculateWidth(element, container, moduleName) {
        if (moduleName !== "multiselect" && !_isElementVisible(element)) return;
        var elementWidth = moduleName === "multiselect" ? element : element.clientWidth - parseInt(getComputedStyle(element, null).getPropertyValue("padding-left"), 10);
        if (!(0, $3EnZW.isNullOrUndefined)(container) && !(0, $3EnZW.isNullOrUndefined)(container.getElementsByClassName("e-float-text-content")[0])) {
            if (container.getElementsByClassName("e-float-text-content")[0].classList.contains("e-float-text-overflow")) container.getElementsByClassName("e-float-text-content")[0].classList.remove("e-float-text-overflow");
            if (elementWidth < container.getElementsByClassName("e-float-text-content")[0].clientWidth || elementWidth === container.getElementsByClassName("e-float-text-content")[0].clientWidth) container.getElementsByClassName("e-float-text-content")[0].classList.add("e-float-text-overflow");
        }
    }
    Input.calculateWidth = calculateWidth;
    /**
     * Set the width to the wrapper of input element.
     * ```
     * E.g : Input.setWidth('200px', container);
     * ```
     *
     * @param {number | string} width - Width value which is need to add.
     * @param {HTMLElement} container - The element on which the width is need to add.
     */ function setWidth(width, container) {
        if (typeof width === "number") container.style.width = (0, $3EnZW.formatUnit)(width);
        else if (typeof width === "string") container.style.width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        calculateWidth(container.firstChild, container);
    }
    Input.setWidth = setWidth;
    /**
     * Set the placeholder attribute to the input element.
     * ```
     * E.g : Input.setPlaceholder('Search here', element);
     * ```
     *
     * @param {string} placeholder - Placeholder value which is need to add.
     * @param {HTMLInputElement | HTMLTextAreaElement} element - The element on which the placeholder is need to add.
     */ function setPlaceholder(placeholder, element) {
        placeholder = encodePlaceHolder(placeholder);
        var parentElement = getParentNode(element);
        if (parentElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT)) {
            if (!(0, $3EnZW.isNullOrUndefined)(placeholder) && placeholder !== "") {
                var floatTextContent = parentElement.getElementsByClassName("e-float-text-content")[0];
                if (floatTextContent && floatTextContent.children[0]) floatTextContent.children[0].textContent = placeholder;
                else parentElement.getElementsByClassName($168e4e125732cd26$var$CLASSNAMES.FLOATTEXT)[0].textContent = placeholder;
                parentElement.classList.remove($168e4e125732cd26$var$CLASSNAMES.NOFLOATLABEL);
                element.removeAttribute("placeholder");
            } else {
                parentElement.classList.add($168e4e125732cd26$var$CLASSNAMES.NOFLOATLABEL);
                var floatTextContent = parentElement.getElementsByClassName("e-float-text-content")[0];
                if (floatTextContent) floatTextContent.children[0].textContent = "";
                else parentElement.getElementsByClassName($168e4e125732cd26$var$CLASSNAMES.FLOATTEXT)[0].textContent = "";
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(placeholder) && placeholder !== "") (0, $4ZDHT.attributes)(element, {
            "placeholder": placeholder
        });
        else element.removeAttribute("placeholder");
    }
    Input.setPlaceholder = setPlaceholder;
    /**
     * Set the read only attribute to the input element
     * ```
     * E.g : Input.setReadonly(true, element);
     * ```
     *
     * @param {boolean} isReadonly
     * - Boolean value to specify whether to set read only. Setting "True" value enables read only.
     * @param {HTMLInputElement | HTMLTextAreaElement} element
     * - The element which is need to enable read only.
     */ function setReadonly(isReadonly, element, floatLabelType) {
        if (isReadonly) (0, $4ZDHT.attributes)(element, {
            readonly: ""
        });
        else element.removeAttribute("readonly");
        if (!(0, $3EnZW.isNullOrUndefined)(floatLabelType)) validateLabel(element, floatLabelType);
    }
    Input.setReadonly = setReadonly;
    /**
     * Displays the element direction from right to left when its enabled.
     * ```
     * E.g : Input.setEnableRtl(true, [inputObj.container]);
     * ```
     *
     * @param {boolean} isRtl
     * - Boolean value to specify whether to set RTL. Setting "True" value enables the RTL mode.
     * @param {Element[] | NodeList} elements
     * - The elements that are needed to enable/disable RTL.
     */ function setEnableRtl(isRtl, elements) {
        if (isRtl) (0, $4ZDHT.addClass)(elements, $168e4e125732cd26$var$CLASSNAMES.RTL);
        else (0, $4ZDHT.removeClass)(elements, $168e4e125732cd26$var$CLASSNAMES.RTL);
    }
    Input.setEnableRtl = setEnableRtl;
    /**
     * Enables or disables the given input element.
     * ```
     * E.g : Input.setEnabled(false, element);
     * ```
     *
     * @param {boolean} isEnable
     * - Boolean value to specify whether to enable or disable.
     * @param {HTMLInputElement | HTMLTextAreaElement} element
     * - Element to be enabled or disabled.
     */ function setEnabled(isEnable, element, floatLabelType, inputContainer) {
        var disabledAttrs = {
            "disabled": "",
            "aria-disabled": "true"
        };
        var considerWrapper = (0, $3EnZW.isNullOrUndefined)(inputContainer) ? false : true;
        if (isEnable) {
            element.classList.remove($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            removeAttributes(disabledAttrs, element);
            if (considerWrapper) (0, $4ZDHT.removeClass)([
                inputContainer
            ], $168e4e125732cd26$var$CLASSNAMES.DISABLE);
        } else {
            element.classList.add($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            addAttributes(disabledAttrs, element);
            if (considerWrapper) (0, $4ZDHT.addClass)([
                inputContainer
            ], $168e4e125732cd26$var$CLASSNAMES.DISABLE);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(floatLabelType)) validateLabel(element, floatLabelType);
    }
    Input.setEnabled = setEnabled;
    function setClearButton(isClear, element, inputObject, initial, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        if (isClear) inputObject.clearButton = createClearButton(element, inputObject, initial, makeElement);
        else {
            (0, $4ZDHT.remove)(inputObject.clearButton);
            inputObject.clearButton = null;
        }
    }
    Input.setClearButton = setClearButton;
    /**
     * Removing the multiple attributes from the given element such as "disabled","id" , etc.
     * ```
     * E.g : Input.removeAttributes({ 'disabled': 'disabled', 'aria-disabled': 'true' }, element);
     * ```
     *
     * @param {string} attrs
     * - Array of attributes which are need to removed from the element.
     * @param {HTMLInputElement | HTMLElement} element
     * - Element on which the attributes are needed to be removed.
     */ function removeAttributes(attrs, element) {
        for(var _i = 0, _a = Object.keys(attrs); _i < _a.length; _i++){
            var key = _a[_i];
            var parentElement = getParentNode(element);
            if (key === "disabled") element.classList.remove($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            if (key === "disabled" && parentElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.INPUTGROUP)) parentElement.classList.remove($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            if (key === "placeholder" && parentElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT)) parentElement.getElementsByClassName($168e4e125732cd26$var$CLASSNAMES.FLOATTEXT)[0].textContent = "";
            else element.removeAttribute(key);
        }
    }
    Input.removeAttributes = removeAttributes;
    /**
     * Adding the multiple attributes to the given element such as "disabled","id" , etc.
     * ```
     * E.g : Input.addAttributes({ 'id': 'inputpopup' }, element);
     * ```
     *
     * @param {string} attrs
     * - Array of attributes which is added to element.
     * @param {HTMLInputElement | HTMLElement} element
     * - Element on which the attributes are needed to be added.
     */ function addAttributes(attrs, element) {
        for(var _i = 0, _a = Object.keys(attrs); _i < _a.length; _i++){
            var key = _a[_i];
            var parentElement = getParentNode(element);
            if (key === "disabled") element.classList.add($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            if (key === "disabled" && parentElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.INPUTGROUP)) parentElement.classList.add($168e4e125732cd26$var$CLASSNAMES.DISABLE);
            if (key === "placeholder" && parentElement.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT)) parentElement.getElementsByClassName($168e4e125732cd26$var$CLASSNAMES.FLOATTEXT)[0].textContent = attrs["" + key];
            else element.setAttribute(key, attrs["" + key]);
        }
    }
    Input.addAttributes = addAttributes;
    function removeFloating(input) {
        var container = input.container;
        if (!(0, $3EnZW.isNullOrUndefined)(container) && container.classList.contains($168e4e125732cd26$var$CLASSNAMES.FLOATINPUT)) {
            var inputEle = container.querySelector("textarea") ? container.querySelector("textarea") : container.querySelector("input");
            var placeholder = container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATTEXT).textContent;
            var clearButton = container.querySelector(".e-clear-icon") !== null;
            (0, $4ZDHT.detach)(container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATLINE));
            (0, $4ZDHT.detach)(container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATTEXT));
            (0, $4ZDHT.classList)(container, [
                $168e4e125732cd26$var$CLASSNAMES.INPUTGROUP
            ], [
                $168e4e125732cd26$var$CLASSNAMES.FLOATINPUT
            ]);
            unwireFloatingEvents(inputEle);
            (0, $4ZDHT.attributes)(inputEle, {
                "placeholder": placeholder
            });
            inputEle.classList.add($168e4e125732cd26$var$CLASSNAMES.INPUT);
            if (!clearButton && inputEle.tagName === "INPUT") inputEle.removeAttribute("required");
        }
    }
    Input.removeFloating = removeFloating;
    function addFloating(input, type, placeholder, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var container = (0, $4ZDHT.closest)(input, "." + $168e4e125732cd26$var$CLASSNAMES.INPUTGROUP);
        floatType = type;
        var customTag = container.tagName;
        customTag = customTag !== "DIV" && customTag !== "SPAN" ? customTag : null;
        var args = {
            element: input,
            floatLabelType: type,
            customTag: customTag,
            properties: {
                placeholder: placeholder
            }
        };
        if (type !== "Never") {
            var iconEle = container.querySelector(".e-clear-icon");
            var inputObj = {
                container: container
            };
            input.classList.remove($168e4e125732cd26$var$CLASSNAMES.INPUT);
            createFloatingInput(args, inputObj, makeElement);
            createSpanElement(inputObj.container, makeElement);
            calculateWidth(args.element, inputObj.container);
            var isPrependIcon = container.classList.contains("e-float-icon-left");
            if ((0, $3EnZW.isNullOrUndefined)(iconEle)) {
                if (isPrependIcon) {
                    var inputWrap = container.querySelector(".e-input-in-wrap");
                    iconEle = inputWrap.querySelector(".e-input-group-icon");
                } else iconEle = container.querySelector(".e-input-group-icon");
            }
            if ((0, $3EnZW.isNullOrUndefined)(iconEle)) {
                if (isPrependIcon) iconEle = container.querySelector(".e-input-group-icon");
            } else {
                var floatLine = container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATLINE);
                var floatText = container.querySelector("." + $168e4e125732cd26$var$CLASSNAMES.FLOATTEXT);
                var wrapper = isPrependIcon ? container.querySelector(".e-input-in-wrap") : container;
                wrapper.insertBefore(input, iconEle);
                wrapper.insertBefore(floatLine, iconEle);
                wrapper.insertBefore(floatText, iconEle);
            }
        } else unWireFloatLabelEvents(args);
        checkFloatLabelType(type, input.parentElement);
    }
    Input.addFloating = addFloating;
    /**
     * Create the span inside the label and add the label text into the span textcontent
     * ```
     * E.g : Input.createSpanElement(inputObject, makeElement);
     * ```
     *
     * @param {Element} inputObject
     * - Element which is need to get the label
     * @param {createElementParams} makeElement
     * - Element which is need to create the span
     */ function createSpanElement(inputObject, makeElement) {
        if (inputObject.classList.contains("e-outline") && inputObject.getElementsByClassName("e-float-text")[0]) {
            var labelSpanElement = makeElement("span", {
                className: $168e4e125732cd26$var$CLASSNAMES.FLOATTEXTCONTENT
            });
            labelSpanElement.innerHTML = inputObject.getElementsByClassName("e-float-text")[0].innerHTML;
            inputObject.getElementsByClassName("e-float-text")[0].innerHTML = "";
            inputObject.getElementsByClassName("e-float-text")[0].appendChild(labelSpanElement);
        }
    }
    Input.createSpanElement = createSpanElement;
    /**
     * Enable or Disable the ripple effect on the icons inside the Input. Ripple effect is only applicable for material theme.
     * ```
     * E.g : Input.setRipple(true, [inputObjects]);
     * ```
     *
     * @param {boolean} isRipple
     * - Boolean value to specify whether to enable the ripple effect.
     * @param {InputObject[]} inputObj
     * - Specify the collection of input objects.
     */ function setRipple(isRipple, inputObj) {
        for(var i = 0; i < inputObj.length; i++)_internalRipple(isRipple, inputObj[parseInt(i.toString(), 10)].container);
    }
    Input.setRipple = setRipple;
    function _internalRipple(isRipple, container, button) {
        var argsButton = [];
        argsButton.push(button);
        var buttons = (0, $3EnZW.isNullOrUndefined)(button) ? container.querySelectorAll(".e-input-group-icon") : argsButton;
        if (isRipple && buttons.length > 0) for(var index = 0; index < buttons.length; index++){
            buttons[parseInt(index.toString(), 10)].addEventListener("mousedown", _onMouseDownRipple, false);
            buttons[parseInt(index.toString(), 10)].addEventListener("mouseup", _onMouseUpRipple, false);
        }
        else if (buttons.length > 0) for(var index = 0; index < buttons.length; index++){
            buttons[parseInt(index.toString(), 10)].removeEventListener("mousedown", _onMouseDownRipple, this);
            buttons[parseInt(index.toString(), 10)].removeEventListener("mouseup", _onMouseUpRipple, this);
        }
    }
    function _onMouseRipple(container, button) {
        if (!container.classList.contains("e-disabled") && !container.querySelector("input").readOnly) button.classList.add("e-input-btn-ripple");
    }
    function _isElementVisible(element) {
        if (!element) return false;
        // Check if the element or any of its parents are hidden using display: none
        var currentElement = element;
        while(currentElement && currentElement !== document.body){
            var style = window.getComputedStyle(currentElement);
            if (style.display === "none") return false;
            currentElement = currentElement.parentElement;
        }
        // If none of the elements have display: none, the element is considered visible
        return true;
    }
    function _onMouseDownRipple() {
        var ele = this;
        var parentEle = this.parentElement;
        while(!parentEle.classList.contains("e-input-group"))parentEle = parentEle.parentElement;
        _onMouseRipple(parentEle, ele);
    }
    function _onMouseUpRipple() {
        var ele = this;
        setTimeout(function() {
            ele.classList.remove("e-input-btn-ripple");
        }, 500);
    }
    function createIconEle(iconClass, makeElement) {
        var button = makeElement("span", {
            className: iconClass
        });
        button.classList.add("e-input-group-icon");
        return button;
    }
    /**
     * Creates a new span element with the given icons added and append it in container element.
     * ```
     * E.g : Input.addIcon('append', 'e-icon-spin', inputObj.container, inputElement);
     * ```
     *
     * @param {string} position - Specify the icon placement on the input.Possible values are append and prepend.
     * @param {string | string[]} icons - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     * @param {HTMLElement} input - The inputElement on which created span element is going to prepend.
     */ function addIcon(position, icons, container, input, internalCreate) {
        var result = typeof icons === "string" ? icons.split(",") : icons;
        if (position.toLowerCase() === "append") for(var _i = 0, result_1 = result; _i < result_1.length; _i++){
            var icon = result_1[_i];
            appendSpan(icon, container, internalCreate);
        }
        else for(var _a = 0, result_2 = result; _a < result_2.length; _a++){
            var icon = result_2[_a];
            prependSpan(icon, container, input, internalCreate);
        }
        if (container.getElementsByClassName("e-input-group-icon")[0] && container.getElementsByClassName("e-float-text-overflow")[0]) container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
    }
    Input.addIcon = addIcon;
    /**
     * Creates a new span element with the given icons added and prepend it in input element.
     * ```
     * E.g : Input.prependSpan('e-icon-spin', inputObj.container, inputElement);
     * ```
     *
     * @param {string} iconClass - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     * @param {HTMLElement} inputElement - The inputElement on which created span element is going to prepend.
     */ function prependSpan(iconClass, container, inputElement, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var button = createIconEle(iconClass, makeElement);
        container.classList.add("e-float-icon-left");
        var innerWrapper = container.querySelector(".e-input-in-wrap");
        if ((0, $3EnZW.isNullOrUndefined)(innerWrapper)) {
            innerWrapper = makeElement("span", {
                className: "e-input-in-wrap"
            });
            inputElement.parentNode.insertBefore(innerWrapper, inputElement);
            var result = container.querySelectorAll(inputElement.tagName + " ~ *");
            innerWrapper.appendChild(inputElement);
            for(var i = 0; i < result.length; i++){
                var element = result[parseInt(i.toString(), 10)];
                var parentElement = innerWrapper.parentElement;
                if (!element.classList.contains("e-float-line") || !(parentElement && parentElement.classList.contains("e-filled")) && parentElement) innerWrapper.appendChild(element);
            }
        }
        innerWrapper.parentNode.insertBefore(button, innerWrapper);
        _internalRipple(true, container, button);
        return button;
    }
    Input.prependSpan = prependSpan;
    /**
     * Creates a new span element with the given icons added and append it in container element.
     * ```
     * E.g : Input.appendSpan('e-icon-spin', inputObj.container);
     * ```
     *
     * @param {string} iconClass - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     */ function appendSpan(iconClass, container, internalCreateElement) {
        var makeElement = !(0, $3EnZW.isNullOrUndefined)(internalCreateElement) ? internalCreateElement : (0, $4ZDHT.createElement);
        var button = createIconEle(iconClass, makeElement);
        var wrap = container.classList.contains("e-float-icon-left") ? container.querySelector(".e-input-in-wrap") : container;
        wrap.appendChild(button);
        _internalRipple(true, container, button);
        return button;
    }
    Input.appendSpan = appendSpan;
    function validateInputType(containerElement, input) {
        if (input.type === "hidden") containerElement.classList.add("e-hidden");
        else if (containerElement.classList.contains("e-hidden")) containerElement.classList.remove("e-hidden");
    }
    Input.validateInputType = validateInputType;
    function updateHTMLAttributesToElement(htmlAttributes, element) {
        if (!(0, $3EnZW.isNullOrUndefined)(htmlAttributes)) for(var _i = 0, _a = Object.keys(htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($168e4e125732cd26$export$32cda1f66e0b465f.indexOf(key) < 0) element.setAttribute(key, htmlAttributes["" + key]);
        }
    }
    Input.updateHTMLAttributesToElement = updateHTMLAttributesToElement;
    function updateCssClass(newClass, oldClass, container) {
        setCssClass(getInputValidClassList(newClass), [
            container
        ], getInputValidClassList(oldClass));
    }
    Input.updateCssClass = updateCssClass;
    function getInputValidClassList(inputClassName) {
        var result = inputClassName;
        if (!(0, $3EnZW.isNullOrUndefined)(inputClassName) && inputClassName !== "") result = inputClassName.replace(/\s+/g, " ").trim();
        return result;
    }
    Input.getInputValidClassList = getInputValidClassList;
    function updateHTMLAttributesToWrapper(htmlAttributes, container) {
        if (!(0, $3EnZW.isNullOrUndefined)(htmlAttributes)) for(var _i = 0, _a = Object.keys(htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($168e4e125732cd26$export$32cda1f66e0b465f.indexOf(key) > -1) {
                if (key === "class") {
                    var updatedClassValues = this.getInputValidClassList(htmlAttributes["" + key]);
                    if (updatedClassValues !== "") (0, $4ZDHT.addClass)([
                        container
                    ], updatedClassValues.split(" "));
                } else if (key === "style") {
                    var setStyle = container.getAttribute(key);
                    setStyle = !(0, $3EnZW.isNullOrUndefined)(setStyle) ? setStyle + htmlAttributes["" + key] : htmlAttributes["" + key];
                    container.setAttribute(key, setStyle);
                } else container.setAttribute(key, htmlAttributes["" + key]);
            }
        }
    }
    Input.updateHTMLAttributesToWrapper = updateHTMLAttributesToWrapper;
    function isBlank(inputString) {
        return !inputString || /^\s*$/.test(inputString);
    }
    Input.isBlank = isBlank;
})($168e4e125732cd26$export$f5b8910cec6cf069 || ($168e4e125732cd26$export$f5b8910cec6cf069 = {})); /* eslint-enable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */ 


/**
 * IncrementalSearch module file
 */ var $2b58887f1686dbd7$var$queryString = "";
var $2b58887f1686dbd7$var$prevString = "";
var $2b58887f1686dbd7$var$tempQueryString = "";
var $2b58887f1686dbd7$var$matches = [];
var $2b58887f1686dbd7$var$activeClass = "e-active";
var $2b58887f1686dbd7$var$prevElementId = "";
function $2b58887f1686dbd7$export$1421c86d5777695b(keyCode, items, selectedIndex, ignoreCase, elementId, queryStringUpdated, currentValue, isVirtual, refresh) {
    if (!queryStringUpdated || $2b58887f1686dbd7$var$queryString === "") {
        if ($2b58887f1686dbd7$var$tempQueryString !== "") {
            $2b58887f1686dbd7$var$queryString = $2b58887f1686dbd7$var$tempQueryString + String.fromCharCode(keyCode);
            $2b58887f1686dbd7$var$tempQueryString = "";
        } else $2b58887f1686dbd7$var$queryString += String.fromCharCode(keyCode);
    } else if ($2b58887f1686dbd7$var$queryString === $2b58887f1686dbd7$var$prevString) $2b58887f1686dbd7$var$tempQueryString = String.fromCharCode(keyCode);
    if (isVirtual) {
        setTimeout(function() {
            $2b58887f1686dbd7$var$tempQueryString = "";
        }, 700);
        setTimeout(function() {
            $2b58887f1686dbd7$var$queryString = "";
        }, 3000);
    } else setTimeout(function() {
        $2b58887f1686dbd7$var$queryString = "";
    }, 1000);
    var index;
    $2b58887f1686dbd7$var$queryString = ignoreCase ? $2b58887f1686dbd7$var$queryString.toLowerCase() : $2b58887f1686dbd7$var$queryString;
    if ($2b58887f1686dbd7$var$prevElementId === elementId && $2b58887f1686dbd7$var$prevString === $2b58887f1686dbd7$var$queryString && !refresh) {
        for(var i = 0; i < $2b58887f1686dbd7$var$matches.length; i++){
            if ($2b58887f1686dbd7$var$matches[i].classList.contains($2b58887f1686dbd7$var$activeClass)) {
                index = i;
                break;
            }
            if (currentValue && $2b58887f1686dbd7$var$matches[i].textContent.toLowerCase() === currentValue.toLowerCase()) {
                index = i;
                break;
            }
        }
        index = index + 1;
        if (isVirtual) return $2b58887f1686dbd7$var$matches[index] && $2b58887f1686dbd7$var$matches.length - 1 !== index ? $2b58887f1686dbd7$var$matches[index] : $2b58887f1686dbd7$var$matches[$2b58887f1686dbd7$var$matches.length];
        return $2b58887f1686dbd7$var$matches[index] ? $2b58887f1686dbd7$var$matches[index] : $2b58887f1686dbd7$var$matches[0];
    } else {
        var listItems = items;
        var strLength = $2b58887f1686dbd7$var$queryString.length;
        var text = void 0;
        var item = void 0;
        selectedIndex = selectedIndex ? selectedIndex + 1 : 0;
        var i = selectedIndex;
        $2b58887f1686dbd7$var$matches = [];
        do {
            if (i === listItems.length) i = -1;
            if (i === -1) index = 0;
            else index = i;
            item = listItems[index];
            text = ignoreCase ? item.innerText.toLowerCase() : item.innerText;
            if (text.substr(0, strLength) === $2b58887f1686dbd7$var$queryString) $2b58887f1686dbd7$var$matches.push(listItems[index]);
            i++;
        }while (i !== selectedIndex);
        $2b58887f1686dbd7$var$prevString = $2b58887f1686dbd7$var$queryString;
        $2b58887f1686dbd7$var$prevElementId = elementId;
        if (isVirtual) {
            var indexUpdated = false;
            for(var i_1 = 0; i_1 < $2b58887f1686dbd7$var$matches.length; i_1++)if (currentValue && $2b58887f1686dbd7$var$matches[i_1].textContent.toLowerCase() === currentValue.toLowerCase()) {
                index = i_1;
                indexUpdated = true;
                break;
            }
            if (currentValue && indexUpdated) index = index + 1;
            return $2b58887f1686dbd7$var$matches[index] ? $2b58887f1686dbd7$var$matches[index] : $2b58887f1686dbd7$var$matches[0];
        }
        return $2b58887f1686dbd7$var$matches[0];
    }
}
function $2b58887f1686dbd7$export$4b85d3515bd863a5(inputVal, items, searchType, ignoreCase, dataSource, fields, type) {
    var listItems = items;
    ignoreCase = ignoreCase !== undefined && ignoreCase !== null ? ignoreCase : true;
    var itemData = {
        item: null,
        index: null
    };
    if (inputVal && inputVal.length) {
        var strLength = inputVal.length;
        var queryStr = ignoreCase ? inputVal.toLocaleLowerCase() : inputVal;
        queryStr = $2b58887f1686dbd7$export$e30bc2f56512e61f(queryStr);
        var _loop_1 = function(i, itemsData) {
            var item = itemsData[i];
            var filterValue;
            if (items && dataSource) {
                var checkField_1 = item;
                var fieldValue_1 = fields.text.split(".");
                dataSource.filter(function(data) {
                    Array.prototype.slice.call(fieldValue_1).forEach(function(value) {
                        /* eslint-disable security/detect-object-injection */ if (type === "object" && !data.isHeader && checkField_1.textContent.toString().indexOf(data[value]) !== -1 && checkField_1.getAttribute("data-value") === data[fields.value].toString() || type === "string" && checkField_1.textContent.toString().indexOf(data) !== -1) filterValue = type === "object" ? data[value] : data;
                    });
                });
            }
            var text = dataSource && filterValue ? (ignoreCase ? filterValue.toString().toLocaleLowerCase() : filterValue).replace(/^\s+|\s+$/g, "") : (ignoreCase ? item.textContent.toLocaleLowerCase() : item.textContent).replace(/^\s+|\s+$/g, "");
            /* eslint-disable security/detect-non-literal-regexp */ if (searchType === "Equal" && text === queryStr || searchType === "StartsWith" && text.substr(0, strLength) === queryStr || searchType === "EndsWith" && text.substr(text.length - queryStr.length) === queryStr || searchType === "Contains" && new RegExp(queryStr, "g").test(text)) {
                itemData.item = item;
                itemData.index = i;
                return {
                    value: {
                        item: item,
                        index: i
                    }
                };
            }
        };
        for(var i = 0, itemsData = listItems; i < itemsData.length; i++){
            var state_1 = _loop_1(i, itemsData);
            if (typeof state_1 === "object") return state_1.value;
        }
        return itemData;
    /* eslint-enable security/detect-non-literal-regexp */ }
    return itemData;
}
function $2b58887f1686dbd7$export$e30bc2f56512e61f(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $2b58887f1686dbd7$export$4f33f295bddc1094(elementId) {
    if ($2b58887f1686dbd7$var$prevElementId === elementId) {
        $2b58887f1686dbd7$var$prevElementId = "";
        $2b58887f1686dbd7$var$prevString = "";
        $2b58887f1686dbd7$var$queryString = "";
        $2b58887f1686dbd7$var$matches = [];
    }
}


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");
var $kj1BR = parcelRequire("kj1BR");

/* eslint-disable no-inner-declarations */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $c2qqN = parcelRequire("c2qqN");
var $3EnZW = parcelRequire("3EnZW");
var $3P3ke = parcelRequire("3P3ke");

var $ebf1cfbcf051ff2a$export$1283875077dc8f0a = {
    li: "e-list-item",
    ul: "e-list-parent e-ul",
    group: "e-list-group-item",
    icon: "e-list-icon",
    text: "e-list-text",
    check: "e-list-check",
    checked: "e-checked",
    selected: "e-selected",
    expanded: "e-expanded",
    textContent: "e-text-content",
    hasChild: "e-has-child",
    level: "e-level",
    url: "e-list-url",
    collapsible: "e-icon-collapsible",
    disabled: "e-disabled",
    image: "e-list-img",
    iconWrapper: "e-icon-wrapper",
    anchorWrap: "e-anchor-wrap",
    navigable: "e-navigable"
};
var $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df;
(function(ListBase) {
    /**
     *
     * Default mapped fields.
     */ ListBase.defaultMappedFields = {
        id: "id",
        text: "text",
        url: "url",
        value: "value",
        isChecked: "isChecked",
        enabled: "enabled",
        expanded: "expanded",
        selected: "selected",
        iconCss: "iconCss",
        child: "child",
        isVisible: "isVisible",
        hasChildren: "hasChildren",
        tooltip: "tooltip",
        htmlAttributes: "htmlAttributes",
        urlAttributes: "urlAttributes",
        imageAttributes: "imageAttributes",
        imageUrl: "imageUrl",
        groupBy: null,
        sortBy: null
    };
    var defaultAriaAttributes = {
        level: 1,
        listRole: "presentation",
        itemRole: "presentation",
        groupItemRole: "group",
        itemText: "list-item",
        wrapperRole: "presentation"
    };
    var defaultListBaseOptions = {
        showCheckBox: false,
        showIcon: false,
        enableHtmlSanitizer: false,
        expandCollapse: false,
        fields: ListBase.defaultMappedFields,
        ariaAttributes: defaultAriaAttributes,
        listClass: "",
        itemClass: "",
        processSubChild: false,
        sortOrder: "None",
        template: null,
        groupTemplate: null,
        headerTemplate: null,
        expandIconClass: "e-icon-collapsible",
        moduleName: "list",
        expandIconPosition: "Right",
        itemNavigable: false
    };
    /**
     * Function helps to created and return the UL Li element based on your data.
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} [options] - Specifies the list options that need to provide.
     *
     * @param  {boolean} [isSingleLevel] - Specifies the list options that need to provide.
     *
     * @param  {any} [componentInstance] - Specifies the list options that need to provide.
     *
     * @returns  {createElement} createListFromJson - Specifies the list options that need to provide.
     */ function createList(createElement, dataSource, options, isSingleLevel, componentInstance) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var ariaAttributes = (0, $3EnZW.extend)({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var type = typeofData(dataSource).typeof;
        if (type === "string" || type === "number") return createListFromArray(createElement, dataSource, isSingleLevel, options, componentInstance);
        else return createListFromJson(createElement, dataSource, options, ariaAttributes.level, isSingleLevel, componentInstance);
    }
    ListBase.createList = createList;
    /**
     * Function helps to created an element list based on string array input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {boolean} [isSingleLevel] - Specifies the list options that need to provide.
     *
     * @param  {ListBaseOptions} [options] - Specifies the list options that need to provide.
     *
     * @param  {any} [componentInstance] - Specifies the list options that need to provide.
     *
     * @returns  {createElement} generateUL - returns the list options that need to provide.
     */ function createListFromArray(createElement, dataSource, isSingleLevel, options, componentInstance) {
        var subChild = createListItemFromArray(createElement, dataSource, isSingleLevel, options, componentInstance);
        return generateUL(createElement, subChild, null, options);
    }
    ListBase.createListFromArray = createListFromArray;
    /**
     * Function helps to created an element list based on string array input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {boolean} [isSingleLevel] - Specifies the list options that need to provide.
     *
     * @param  {ListBaseOptions} [options] - Specifies the list options that need to provide.
     *
     * @param  {any} [componentInstance] - Specifies the list options that need to provide.
     *
     * @returns  {HTMLElement[]} subChild - returns the list options that need to provide.
     */ function createListItemFromArray(createElement, dataSource, isSingleLevel, options, componentInstance) {
        var subChild = [];
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(curOpt.moduleName);
        var id = generateId(); // generate id for drop-down-list option.
        for(var i = 0; i < dataSource.length; i++){
            if ((0, $3EnZW.isNullOrUndefined)(dataSource[i])) continue;
            var li = void 0;
            if (curOpt.itemCreating && typeof curOpt.itemCreating === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: dataSource[i],
                    options: curOpt
                };
                curOpt.itemCreating(curData);
            }
            if (isSingleLevel) li = generateSingleLevelLI(createElement, dataSource[i], undefined, null, null, [], null, id, i, options);
            else li = generateLI(createElement, dataSource[i], undefined, null, null, options, componentInstance);
            if (curOpt.itemCreated && typeof curOpt.itemCreated === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: dataSource[i],
                    item: li,
                    options: curOpt
                };
                curOpt.itemCreated(curData);
            }
            subChild.push(li);
        }
        return subChild;
    }
    ListBase.createListItemFromArray = createListItemFromArray;
    /**
     * Function helps to created an element list based on array of JSON input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} [options] - Specifies the list options that need to provide.
     *
     * @param  {number} [level] - Specifies the list options that need to provide.
     *
     * @param  {boolean} [isSingleLevel] - Specifies the list options that need to provide.
     *
     * @param  {any} [componentInstance] - Specifies the list options that need to provide.
     *
     * @returns  {HTMLElement[]} child - returns the list options that need to provide.
     */ function createListItemFromJson(createElement, dataSource, options, level, isSingleLevel, componentInstance) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(curOpt.moduleName);
        var fields = componentInstance && (componentInstance.getModuleName() === "listview" || componentInstance.getModuleName() === "multiselect") ? curOpt.fields : (0, $3EnZW.extend)({}, ListBase.defaultMappedFields, curOpt.fields);
        var ariaAttributes = (0, $3EnZW.extend)({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var id;
        var checkboxElement = [];
        if (level) ariaAttributes.level = level;
        var child = [];
        var li;
        var anchorElement;
        if (dataSource && dataSource.length && !(0, $3EnZW.isNullOrUndefined)(typeofData(dataSource).item) && !Object.prototype.hasOwnProperty.call(typeofData(dataSource).item, fields.id)) id = generateId(); // generate id for drop-down-list option.
        for(var i = 0; i < dataSource.length; i++){
            var fieldData = $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataSource[i], fields);
            if ((0, $3EnZW.isNullOrUndefined)(dataSource[i])) continue;
            if (curOpt.itemCreating && typeof curOpt.itemCreating === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: fieldData[fields.text],
                    options: curOpt,
                    fields: fields
                };
                curOpt.itemCreating(curData);
            }
            var curItem = dataSource[i];
            if (curOpt.itemCreating && typeof curOpt.itemCreating === "function") fieldData = $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataSource[i], fields);
            if (Object.prototype.hasOwnProperty.call(fieldData, fields.id) && !(0, $3EnZW.isNullOrUndefined)(fieldData[fields.id])) id = fieldData[fields.id];
            var innerEle = [];
            if (curOpt.showCheckBox) {
                if (curOpt.itemNavigable && (fieldData[fields.url] || fieldData[fields.urlAttributes])) checkboxElement.push(createElement("input", {
                    className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.check,
                    attrs: {
                        type: "checkbox"
                    }
                }));
                else innerEle.push(createElement("input", {
                    className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.check,
                    attrs: {
                        type: "checkbox"
                    }
                }));
            }
            if (isSingleLevel === true) {
                if (curOpt.showIcon && Object.prototype.hasOwnProperty.call(fieldData, fields.iconCss) && !(0, $3EnZW.isNullOrUndefined)(fieldData[fields.iconCss])) innerEle.push(createElement("span", {
                    className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.icon + " " + fieldData[fields.iconCss]
                }));
                li = generateSingleLevelLI(createElement, curItem, fieldData, fields, curOpt.itemClass, innerEle, Object.prototype.hasOwnProperty.call(curItem, "isHeader") && curItem.isHeader ? true : false, id, i, options);
                anchorElement = li.querySelector("." + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.anchorWrap);
                if (curOpt.itemNavigable && checkboxElement.length) (0, $4ZDHT.prepend)(checkboxElement, li.firstElementChild);
            } else {
                li = generateLI(createElement, curItem, fieldData, fields, curOpt.itemClass, options, componentInstance);
                li.classList.add($ebf1cfbcf051ff2a$export$1283875077dc8f0a.level + "-" + ariaAttributes.level);
                li.setAttribute("aria-level", ariaAttributes.level.toString());
                if (ariaAttributes.groupItemRole === "presentation" || ariaAttributes.itemRole === "presentation") li.removeAttribute("aria-level");
                anchorElement = li.querySelector("." + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.anchorWrap);
                if (Object.prototype.hasOwnProperty.call(fieldData, fields.tooltip)) {
                    var tooltipText = fieldData[fields.tooltip];
                    if (options && options.enableHtmlSanitizer) tooltipText = (0, $3P3ke.SanitizeHtmlHelper).sanitize(tooltipText);
                    else {
                        var tooltipTextElement = createElement("span", {
                            innerHTML: tooltipText
                        });
                        tooltipText = tooltipTextElement.innerText;
                        tooltipTextElement = null;
                    }
                    li.setAttribute("title", tooltipText);
                }
                if (Object.prototype.hasOwnProperty.call(fieldData, fields.htmlAttributes) && fieldData[fields.htmlAttributes]) {
                    var htmlAttributes = fieldData[fields.htmlAttributes];
                    // Check if 'class' attribute is present and not an empty string
                    if ("class" in htmlAttributes && typeof htmlAttributes["class"] === "string" && htmlAttributes["class"].trim() === "") delete htmlAttributes["class"];
                    setAttribute(li, htmlAttributes);
                }
                if (Object.prototype.hasOwnProperty.call(fieldData, fields.enabled) && fieldData[fields.enabled] === false) li.classList.add($ebf1cfbcf051ff2a$export$1283875077dc8f0a.disabled);
                if (Object.prototype.hasOwnProperty.call(fieldData, fields.isVisible) && fieldData[fields.isVisible] === false) li.style.display = "none";
                if (Object.prototype.hasOwnProperty.call(fieldData, fields.imageUrl) && !(0, $3EnZW.isNullOrUndefined)(fieldData[fields.imageUrl]) && !curOpt.template) {
                    var attr = {
                        src: fieldData[fields.imageUrl],
                        alt: !(0, $3EnZW.isNullOrUndefined)(fieldData.name) ? "Displaying " + fieldData.name + " Image" : "Displaying Image"
                    };
                    (0, $3EnZW.merge)(attr, fieldData[fields.imageAttributes]);
                    var imageElemnt = createElement("img", {
                        className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.image,
                        attrs: attr
                    });
                    if (anchorElement) anchorElement.insertAdjacentElement("afterbegin", imageElemnt);
                    else (0, $4ZDHT.prepend)([
                        imageElemnt
                    ], li.firstElementChild);
                }
                if (curOpt.showIcon && Object.prototype.hasOwnProperty.call(fieldData, fields.iconCss) && !(0, $3EnZW.isNullOrUndefined)(fieldData[fields.iconCss]) && !curOpt.template) {
                    var iconElement = createElement("div", {
                        className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.icon + " " + fieldData[fields.iconCss]
                    });
                    if (anchorElement) anchorElement.insertAdjacentElement("afterbegin", iconElement);
                    else (0, $4ZDHT.prepend)([
                        iconElement
                    ], li.firstElementChild);
                }
                if (innerEle.length) (0, $4ZDHT.prepend)(innerEle, li.firstElementChild);
                if (curOpt.itemNavigable && checkboxElement.length) (0, $4ZDHT.prepend)(checkboxElement, li.firstElementChild);
                processSubChild(createElement, fieldData, fields, dataSource, curOpt, li, ariaAttributes.level);
            }
            if (anchorElement) (0, $4ZDHT.addClass)([
                li
            ], [
                $ebf1cfbcf051ff2a$export$1283875077dc8f0a.navigable
            ]);
            if (curOpt.itemCreated && typeof curOpt.itemCreated === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: fieldData[fields.text],
                    item: li,
                    options: curOpt,
                    fields: fields
                };
                curOpt.itemCreated(curData);
            }
            checkboxElement = [];
            child.push(li);
        }
        return child;
    }
    ListBase.createListItemFromJson = createListItemFromJson;
    /**
     * Function helps to created an element list based on array of JSON input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} [options] - Specifies the list options that need to provide.
     *
     * @param  {number} [level] - Specifies the list options that need to provide.
     *
     * @param  {boolean} [isSingleLevel] - Specifies the list options that need to provide.
     *
     * @param  {any} [componentInstance] - Specifies the list options that need to provide.
     *
     * @returns  {createElement} generateUL - Specifies the list options that need to provide.
     */ function createListFromJson(createElement, dataSource, options, level, isSingleLevel, componentInstance) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var li = createListItemFromJson(createElement, dataSource, options, level, isSingleLevel, componentInstance);
        return generateUL(createElement, li, curOpt.listClass, options);
    }
    ListBase.createListFromJson = createListFromJson;
    /**
     * Return the next or previous visible element.
     *
     * @param  {Element[]|NodeList} elementArray - An element array to find next or previous element.
     * @param  {Element} element - An element to find next or previous after this element.
     * @param  {boolean} [isPrevious] - Specify when the need get previous element from array.
     * @returns {Element|undefined} The next or previous visible element, or undefined if the element array is empty.
     */ function getSiblingLI(elementArray, element, isPrevious) {
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(defaultListBaseOptions.moduleName);
        if (!elementArray || !elementArray.length) return void 0;
        var siblingLI;
        var liIndex;
        var liCollections = Array.prototype.slice.call(elementArray);
        if (element) liIndex = indexOf(element, liCollections);
        else liIndex = isPrevious === true ? liCollections.length : -1;
        siblingLI = liCollections[liIndex + (isPrevious === true ? -1 : 1)];
        while(siblingLI && (!(0, $4ZDHT.isVisible)(siblingLI) || siblingLI.classList.contains($ebf1cfbcf051ff2a$export$1283875077dc8f0a.disabled))){
            liIndex = liIndex + (isPrevious === true ? -1 : 1);
            siblingLI = liCollections[liIndex];
        }
        return siblingLI;
    }
    ListBase.getSiblingLI = getSiblingLI;
    /**
     * Return the index of the li element
     *
     * @param  {Element} item - An element to find next or previous after this element.
     * @param  {Element[]} elementArray - An element array to find index of given li.
     * @returns {number} - The index of the item in the element array, or undefined if either parameter is false.
     */ function indexOf(item, elementArray) {
        if (!elementArray || !item) return void 0;
        else {
            var liCollections = elementArray;
            liCollections = Array.prototype.slice.call(elementArray);
            return liCollections.indexOf(item);
        }
    }
    ListBase.indexOf = indexOf;
    /**
     * Returns the grouped data from given dataSource.
     *
     * @param  {{Object}[]} dataSource - The JSON data which is necessary to process.
     * @param  {FieldsMapping} fields - Fields that are mapped from the data source.
     * @param  {SortOrder} [sortOrder='None'] - Specifies final result sort order. Defaults to 'None'.
     * @returns {Object[]} - The grouped data.
     */ function groupDataSource(dataSource, fields, sortOrder) {
        if (sortOrder === void 0) sortOrder = "None";
        var curFields = (0, $3EnZW.extend)({}, ListBase.defaultMappedFields, fields);
        var cusQuery = new (0, $56262f229d1cff45$export$62297b13309008b2)().group(curFields.groupBy);
        // need to remove once sorting issues fixed in DataManager
        cusQuery = addSorting(sortOrder, "key", cusQuery);
        var ds = getDataSource(dataSource, cusQuery);
        dataSource = [];
        for(var j = 0; j < ds.length; j++){
            var itemObj = ds[j].items;
            var grpItem = {};
            var hdr = "isHeader";
            grpItem[curFields.text] = ds[j].key;
            grpItem["" + hdr] = true;
            var newtext = curFields.text;
            if (newtext === "id") {
                newtext = "text";
                grpItem["" + newtext] = ds[j].key;
            }
            grpItem._id = "group-list-item-" + (ds[j].key ? ds[j].key.toString().trim() : "undefined");
            grpItem.items = itemObj;
            dataSource.push(grpItem);
            for(var k = 0; k < itemObj.length; k++)dataSource.push(itemObj[k]);
        }
        return dataSource;
    }
    ListBase.groupDataSource = groupDataSource;
    /**
     * Returns a sorted query object.
     *
     * @param  {SortOrder} sortOrder - Specifies that sort order.
     * @param  {string} sortBy - Specifies sortBy fields.
     * @param  {Query} query - Pass if any existing query.
     * @returns {Query} - The updated query object with sorting applied.
     */ function addSorting(sortOrder, sortBy, query) {
        if (query === void 0) query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (sortOrder === "Ascending") query.sortBy(sortBy, "ascending", true);
        else if (sortOrder === "Descending") query.sortBy(sortBy, "descending", true);
        else {
            for(var i = 0; i < query.queries.length; i++)if (query.queries[i].fn === "onSortBy") query.queries.splice(i, 1);
        }
        return query;
    }
    ListBase.addSorting = addSorting;
    /**
     * Return an array of JSON Data that processed based on queries.
     *
     * @param  {{Object}[]} dataSource - Specifies local JSON data source.
     *
     * @param  {Query} query - Specifies query that need to process.
     *
     * @returns {Object[]} - An array of objects representing the retrieved data.
     */ function getDataSource(dataSource, query) {
        return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource).executeLocal(query);
    }
    ListBase.getDataSource = getDataSource;
    /**
     * Created JSON data based the UL and LI element
     *
     * @param  {HTMLElement|Element} element - UL element that need to convert as a JSON
     * @param  {ListBaseOptions} [options] - Specifies ListBase option for fields.
     * @returns {Object[]} - An array of objects representing the JSON data.
     */ function createJsonFromElement(element, options) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var fields = (0, $3EnZW.extend)({}, ListBase.defaultMappedFields, curOpt.fields);
        var curEle = element.cloneNode(true);
        var jsonAr = [];
        curEle.classList.add("json-parent");
        var childs = curEle.querySelectorAll(".json-parent>li");
        curEle.classList.remove("json-parent");
        for(var i = 0; i < childs.length; i++){
            var li = childs[i];
            var anchor = li.querySelector("a");
            var ul = li.querySelector("ul");
            var json = {};
            var childNodes = anchor ? anchor.childNodes : li.childNodes;
            var keys = Object.keys(childNodes);
            for(var i_1 = 0; i_1 < childNodes.length; i_1++)if (!childNodes[Number(keys[i_1])].hasChildNodes()) json[fields.text] = childNodes[Number(keys[i_1])].textContent;
            var attributes_1 = getAllAttributes(li);
            if (attributes_1.id) {
                json[fields.id] = attributes_1.id;
                delete attributes_1.id;
            } else json[fields.id] = generateId();
            if (Object.keys(attributes_1).length) json[fields.htmlAttributes] = attributes_1;
            if (anchor) {
                attributes_1 = getAllAttributes(anchor);
                if (Object.keys(attributes_1).length) json[fields.urlAttributes] = attributes_1;
            }
            if (ul) json[fields.child] = createJsonFromElement(ul, options);
            jsonAr.push(json);
        }
        return jsonAr;
    }
    ListBase.createJsonFromElement = createJsonFromElement;
    /**
     * Determines the type of data in an array of objects, strings, or numbers.
     *
     * @param {Object[] | string[] | number[]} data - The array containing objects, strings, or numbers.
     * @returns {{typeof: (string | null), item: (Object | string | number)}} - An object containing the type of data and the corresponding item.
     */ function typeofData(data) {
        var match = {
            typeof: null,
            item: null
        };
        for(var i = 0; i < data.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(data[i])) return match = {
                typeof: typeof data[i],
                item: data[i]
            };
        }
        return match;
    }
    /**
     * Sets attributes on an HTML element.
     *
     * @param {HTMLElement} element - The HTML element to set attributes on.
     * @param {Object.<string, string>} elementAttributes - An object containing attribute names and their corresponding values.
     * @returns {void}
     */ function setAttribute(element, elementAttributes) {
        var attr = {};
        (0, $3EnZW.merge)(attr, elementAttributes);
        if (attr.class) {
            (0, $4ZDHT.addClass)([
                element
            ], attr.class.split(" "));
            delete attr.class;
        }
        (0, $4ZDHT.attributes)(element, attr);
    }
    /**
     * Retrieves all attributes of an HTML element.
     *
     * @param {HTMLElement} element - The HTML element to retrieve attributes from.
     * @returns {Object.<string, string>} - An object containing attribute names as keys and their corresponding values as values.
     */ function getAllAttributes(element) {
        var attributes = {};
        var attr = element.attributes;
        for(var index = 0; index < attr.length; index++)attributes[attr[index].nodeName] = attr[index].nodeValue;
        return attributes;
    }
    /**
     * Created UL element from content template.
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     * @param  {string} template - that need to convert and generate li element.
     * @param  {{Object}[]} dataSource - Specifies local JSON data source.
     * @param  {FieldsMapping} [fields] - Specifies fields for mapping the dataSource.
     * @param  {ListBaseOptions} [options] - Specifies ListBase option for fields.
     * @param  {any} [componentInstance] - Specifies component instance.
     * @returns {HTMLElement} - The generated LI element.
     */ function renderContentTemplate(createElement, template, dataSource, fields, options, componentInstance) {
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(defaultListBaseOptions.moduleName);
        var ulElement = createElement("ul", {
            className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.ul,
            attrs: {
                role: "presentation"
            }
        });
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var curFields = (0, $3EnZW.extend)({}, ListBase.defaultMappedFields, fields);
        var compiledString = $ebf1cfbcf051ff2a$var$compileTemplate(template);
        var liCollection = [];
        var value;
        var id = generateId(); // generate id for drop-down-list option.
        for(var i = 0; i < dataSource.length; i++){
            var fieldData = $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataSource[i], curFields);
            var curItem = dataSource[i];
            var isHeader = curItem.isHeader;
            if (typeof dataSource[i] === "string" || typeof dataSource[i] === "number") value = curItem;
            else value = fieldData[curFields.value];
            if (curOpt.itemCreating && typeof curOpt.itemCreating === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: curItem,
                    text: value,
                    options: curOpt,
                    fields: curFields
                };
                curOpt.itemCreating(curData);
            }
            if (curOpt.itemCreating && typeof curOpt.itemCreating === "function") {
                fieldData = $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataSource[i], curFields);
                if (typeof dataSource[i] === "string" || typeof dataSource[i] === "number") value = curItem;
                else value = fieldData[curFields.value];
            }
            var li = createElement("li", {
                id: id + "-" + i,
                className: isHeader ? $ebf1cfbcf051ff2a$export$1283875077dc8f0a.group : $ebf1cfbcf051ff2a$export$1283875077dc8f0a.li,
                attrs: {
                    role: "presentation"
                }
            });
            if (isHeader) {
                if (typeof dataSource[i] === "string" || typeof dataSource[i] === "number") li.innerText = curItem;
                else li.innerText = fieldData[curFields.text];
            } else {
                var currentID = isHeader ? curOpt.groupTemplateID : curOpt.templateID;
                if (isHeader) {
                    if (componentInstance && componentInstance.getModuleName() !== "listview") {
                        var compiledElement = compiledString(curItem, componentInstance, "headerTemplate", currentID, !!curOpt.isStringTemplate, null, li);
                        if (compiledElement) (0, $4ZDHT.append)(compiledElement, li);
                    } else (0, $4ZDHT.append)(compiledString(curItem, componentInstance, "headerTemplate", currentID, !!curOpt.isStringTemplate), li);
                } else if (componentInstance && componentInstance.getModuleName() !== "listview") {
                    var compiledElement = compiledString(curItem, componentInstance, "template", currentID, !!curOpt.isStringTemplate, null, li);
                    if (compiledElement) (0, $4ZDHT.append)(compiledElement, li);
                } else (0, $4ZDHT.append)(compiledString(curItem, componentInstance, "template", currentID, !!curOpt.isStringTemplate), li);
                li.setAttribute("data-value", (0, $3EnZW.isNullOrUndefined)(value) ? "null" : value);
                li.setAttribute("role", "option");
            }
            if (curOpt.itemCreated && typeof curOpt.itemCreated === "function") {
                var curData = {
                    dataSource: dataSource,
                    curData: curItem,
                    text: value,
                    item: li,
                    options: curOpt,
                    fields: curFields
                };
                curOpt.itemCreated(curData);
            }
            liCollection.push(li);
        }
        (0, $4ZDHT.append)(liCollection, ulElement);
        return ulElement;
    }
    ListBase.renderContentTemplate = renderContentTemplate;
    /**
     * Created header items from group template.
     *
     * @param  {string | Function} groupTemplate - that need to convert and generate li element.
     *
     * @param {{Object}[]} groupDataSource - Specifies local JSON data source.
     *
     * @param  {FieldsMapping} fields - Specifies fields for mapping the dataSource.
     *
     * @param  {Element[]} headerItems - Specifies ListBase header items.
     *
     * @param {ListBaseOptions} [options] - Optional ListBase options.
     *
     * @param {*} [componentInstance] - Optional component instance.
     *
     * @returns {Element[]} - An array of header elements with the rendered group template content.
     */ function renderGroupTemplate(groupTemplate, // tslint:disable-next-line
    groupDataSource, fields, headerItems, options, componentInstance) {
        var compiledString = $ebf1cfbcf051ff2a$var$compileTemplate(groupTemplate);
        var curFields = (0, $3EnZW.extend)({}, ListBase.defaultMappedFields, fields);
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var category = curFields.groupBy;
        for(var _i = 0, headerItems_1 = headerItems; _i < headerItems_1.length; _i++){
            var header = headerItems_1[_i];
            var headerData = {};
            headerData["" + category] = header.textContent;
            header.innerHTML = "";
            if (componentInstance && componentInstance.getModuleName() !== "listview") {
                var compiledElement = compiledString(headerData, componentInstance, "groupTemplate", curOpt.groupTemplateID, !!curOpt.isStringTemplate, null, header);
                if (compiledElement) (0, $4ZDHT.append)(compiledElement, header);
            } else (0, $4ZDHT.append)(compiledString(headerData, componentInstance, "groupTemplate", curOpt.groupTemplateID, !!curOpt.isStringTemplate), header);
        }
        return headerItems;
    }
    ListBase.renderGroupTemplate = renderGroupTemplate;
    /**
     * Generates a random hexadecimal ID string.
     *
     * @returns {string} - The generated ID string.
     */ function generateId() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    ListBase.generateId = generateId;
    /**
     * Processes the sub-child elements and creates corresponding elements based on the provided field data and options.
     *
     * @param {Function} createElement - Function for creating elements.
     * @param {Object} fieldData - Field data containing sub-child information.
     * @param {FieldsMapping} fields - Field mappings.
     * @param {Object[]} ds - The data source array containing sub-child elements.
     * @param {ListBaseOptions} options - ListBase options.
     * @param {HTMLElement} element - The parent HTML element to append sub-child elements to.
     * @param {number} level - The level of the sub-child elements.
     * @returns {void}
     */ function processSubChild(createElement, fieldData, fields, ds, options, element, level) {
        // Get SubList
        var subDS = fieldData[fields.child] || [];
        var hasChildren = fieldData[fields.hasChildren];
        //Create Sub child
        if (subDS.length) {
            hasChildren = true;
            element.classList.add($ebf1cfbcf051ff2a$export$1283875077dc8f0a.hasChild);
            if (options.processSubChild) {
                var subLi = createListFromJson(createElement, subDS, options, ++level);
                element.appendChild(subLi);
            }
        }
        // Create expand and collapse node
        if (!!options.expandCollapse && hasChildren && !options.template) {
            element.firstElementChild.classList.add($ebf1cfbcf051ff2a$export$1283875077dc8f0a.iconWrapper);
            var expandElement = options.expandIconPosition === "Left" ? (0, $4ZDHT.prepend) : (0, $4ZDHT.append);
            expandElement([
                createElement("div", {
                    className: "e-icons " + options.expandIconClass
                })
            ], element.querySelector("." + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.textContent));
        }
    }
    /**
     * Generates a single-level LI (list item) element based on the provided item and field data.
     *
     * @param {Function} createElement - Function for creating elements.
     * @param {string | Object | number} item - The item data.
     * @param {Object} fieldData - Field data mapped from the item.
     * @param {FieldsMapping} [fields] - Field mappings.
     * @param {string} [className] - Optional class name to add to the created LI element.
     * @param {HTMLElement[]} [innerElements] - Optional array of inner elements to append to the LI element.
     * @param {boolean} [grpLI] - Indicates if the LI element is a group item.
     * @param {string} [id] - The ID of the LI element.
     * @param {number} [index] - The index of the LI element.
     * @param {ListBaseOptions} [options] - Optional ListBase options.
     * @returns {HTMLElement} - The generated LI element.
     */ function generateSingleLevelLI(createElement, item, fieldData, fields, className, innerElements, grpLI, id, index, options) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var ariaAttributes = (0, $3EnZW.extend)({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var text = item;
        var value = item;
        var dataSource;
        if (typeof item !== "string" && typeof item !== "number" && typeof item !== "boolean") {
            dataSource = item;
            text = typeof fieldData[fields.text] === "boolean" || typeof fieldData[fields.text] === "number" ? fieldData[fields.text] : fieldData[fields.text] || "";
            value = fieldData[fields.value];
        }
        var elementID;
        if (!(0, $3EnZW.isNullOrUndefined)(dataSource) && !(0, $3EnZW.isNullOrUndefined)(fieldData[fields.id]) && fieldData[fields.id] !== "") elementID = id;
        else elementID = id + "-" + index;
        var li = createElement("li", {
            className: (grpLI === true ? $ebf1cfbcf051ff2a$export$1283875077dc8f0a.group : $ebf1cfbcf051ff2a$export$1283875077dc8f0a.li) + " " + ((0, $3EnZW.isNullOrUndefined)(className) ? "" : className),
            id: elementID,
            attrs: ariaAttributes.groupItemRole !== "" && ariaAttributes.itemRole !== "" ? {
                role: grpLI === true ? ariaAttributes.groupItemRole : ariaAttributes.itemRole
            } : {}
        });
        if (dataSource && Object.prototype.hasOwnProperty.call(fieldData, fields.enabled) && fieldData[fields.enabled].toString() === "false") li.classList.add($ebf1cfbcf051ff2a$export$1283875077dc8f0a.disabled);
        if (grpLI) li.innerText = text;
        else {
            li.setAttribute("data-value", (0, $3EnZW.isNullOrUndefined)(value) ? "null" : value);
            li.setAttribute("role", "option");
            if (dataSource && Object.prototype.hasOwnProperty.call(fieldData, fields.htmlAttributes) && fieldData[fields.htmlAttributes]) setAttribute(li, fieldData[fields.htmlAttributes]);
            if (innerElements.length && !curOpt.itemNavigable) (0, $4ZDHT.append)(innerElements, li);
            if (dataSource && (fieldData[fields.url] || fieldData[fields.urlAttributes] && fieldData[fields.urlAttributes].href)) li.appendChild(anchorTag(createElement, dataSource, fields, text, innerElements, curOpt.itemNavigable));
            else {
                if (innerElements.length && curOpt.itemNavigable) (0, $4ZDHT.append)(innerElements, li);
                li.appendChild(document.createTextNode(text));
            }
        }
        return li;
    }
    /**
     * Returns a set of CSS class names based on the provided module name.
     *
     * @param {string} moduleName - The name of the module.
     * @returns {ClassList} - The CSS class names associated with the module.
     */ function getModuleClass(moduleName) {
        var moduleClass;
        // eslint-disable-next-line
        return moduleClass = {
            li: "e-" + moduleName + "-item",
            ul: "e-" + moduleName + "-parent e-ul",
            group: "e-" + moduleName + "-group-item",
            icon: "e-" + moduleName + "-icon",
            text: "e-" + moduleName + "-text",
            check: "e-" + moduleName + "-check",
            checked: "e-checked",
            selected: "e-selected",
            expanded: "e-expanded",
            textContent: "e-text-content",
            hasChild: "e-has-child",
            level: "e-level",
            url: "e-" + moduleName + "-url",
            collapsible: "e-icon-collapsible",
            disabled: "e-disabled",
            image: "e-" + moduleName + "-img",
            iconWrapper: "e-icon-wrapper",
            anchorWrap: "e-anchor-wrap",
            navigable: "e-navigable"
        };
    }
    /**
     * Creates an anchor tag (<a>) element based on the provided data source, fields, and text.
     *
     * @param {Function} createElement - Function for creating elements.
     * @param {object} dataSource - The data source containing URL-related fields.
     * @param {FieldsMapping} fields - Field mappings for the data source.
     * @param {string} text - The text content of the anchor tag.
     * @param {HTMLElement[]} innerElements - Optional array of inner elements to append to the anchor tag.
     * @param {boolean} isFullNavigation - Indicates whether the anchor tag should be for full navigation.
     * @returns {HTMLElement} The created anchor tag element.
     */ function anchorTag(createElement, dataSource, fields, text, innerElements, isFullNavigation) {
        var fieldData = $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataSource, fields);
        var attr = {
            href: fieldData[fields.url]
        };
        if (Object.prototype.hasOwnProperty.call(fieldData, fields.urlAttributes) && fieldData[fields.urlAttributes]) {
            (0, $3EnZW.merge)(attr, fieldData[fields.urlAttributes]);
            attr.href = fieldData[fields.url] ? fieldData[fields.url] : fieldData[fields.urlAttributes].href;
        }
        var anchorTag;
        if (!isFullNavigation) anchorTag = createElement("a", {
            className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.text + " " + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.url,
            innerHTML: text
        });
        else {
            anchorTag = createElement("a", {
                className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.text + " " + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.url
            });
            var anchorWrapper = createElement("div", {
                className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.anchorWrap
            });
            if (innerElements && innerElements.length) (0, $4ZDHT.append)(innerElements, anchorWrapper);
            anchorWrapper.appendChild(document.createTextNode(text));
            (0, $4ZDHT.append)([
                anchorWrapper
            ], anchorTag);
        }
        setAttribute(anchorTag, attr);
        return anchorTag;
    }
    /**
     * Generates an LI element based on the provided item and field data.
     *
     * @param {Function} createElement - Function for creating elements.
     * @param {string | Object | number} item - The item data.
     * @param {Object} fieldData - Field data mapped from the item.
     * @param {FieldsMapping} fields - Field mappings.
     * @param {string} [className] - Optional class name to add to the created LI element.
     * @param {ListBaseOptions} [options] - Optional ListBase options.
     * @param {*} [componentInstance] - Optional component instance.
     * @returns {HTMLElement} - The generated LI element.
     */ function generateLI(createElement, item, fieldData, fields, className, options, componentInstance) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var ariaAttributes = (0, $3EnZW.extend)({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var text = item;
        var uID;
        var grpLI;
        var dataSource;
        if (typeof item !== "string" && typeof item !== "number") {
            dataSource = item;
            text = fieldData[fields.text] || "";
            uID = (0, $3EnZW.isNullOrUndefined)(fieldData["_id"]) ? fieldData[fields.id] : fieldData["_id"];
            grpLI = Object.prototype.hasOwnProperty.call(item, "isHeader") && item.isHeader ? true : false;
        }
        if (options && options.enableHtmlSanitizer) // eslint-disable-next-line no-self-assign
        text;
        var li = createElement("li", {
            className: (grpLI === true ? $ebf1cfbcf051ff2a$export$1283875077dc8f0a.group : $ebf1cfbcf051ff2a$export$1283875077dc8f0a.li) + " " + ((0, $3EnZW.isNullOrUndefined)(className) ? "" : className),
            attrs: ariaAttributes.groupItemRole !== "" && ariaAttributes.itemRole !== "" ? {
                role: grpLI === true ? ariaAttributes.groupItemRole : ariaAttributes.itemRole
            } : {}
        });
        if (!(0, $3EnZW.isNullOrUndefined)(uID) === true) li.setAttribute("data-uid", uID);
        else li.setAttribute("data-uid", generateId());
        if (grpLI && options && options.groupTemplate) {
            var compiledString = $ebf1cfbcf051ff2a$var$compileTemplate(options.groupTemplate);
            if (componentInstance && componentInstance.getModuleName() !== "listview") {
                var compiledElement = compiledString(item, componentInstance, "groupTemplate", curOpt.groupTemplateID, !!curOpt.isStringTemplate, null, li);
                if (compiledElement) (0, $4ZDHT.append)(compiledElement, li);
            } else (0, $4ZDHT.append)(compiledString(item, componentInstance, "groupTemplate", curOpt.groupTemplateID, !!curOpt.isStringTemplate), li);
        } else if (!grpLI && options && options.template) {
            var compiledString = $ebf1cfbcf051ff2a$var$compileTemplate(options.template);
            if (componentInstance && componentInstance.getModuleName() !== "listview") {
                var compiledElement = compiledString(item, componentInstance, "template", curOpt.templateID, !!curOpt.isStringTemplate, null, li);
                if (compiledElement) (0, $4ZDHT.append)(compiledElement, li);
            } else (0, $4ZDHT.append)(compiledString(item, componentInstance, "template", curOpt.templateID, !!curOpt.isStringTemplate), li);
        } else {
            var innerDiv = createElement("div", {
                className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.textContent,
                attrs: ariaAttributes.wrapperRole !== "" ? {
                    role: ariaAttributes.wrapperRole
                } : {}
            });
            if (dataSource && (fieldData[fields.url] || fieldData[fields.urlAttributes] && fieldData[fields.urlAttributes].href)) innerDiv.appendChild(anchorTag(createElement, dataSource, fields, text, null, curOpt.itemNavigable));
            else {
                var element = createElement("span", {
                    className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.text,
                    attrs: ariaAttributes.itemText !== "" ? {
                        role: ariaAttributes.itemText
                    } : {}
                });
                if (options && options.enableHtmlSanitizer) element.innerText = (0, $3P3ke.SanitizeHtmlHelper).sanitize(text);
                else element.innerHTML = text;
                innerDiv.appendChild(element);
            }
            li.appendChild(innerDiv);
        }
        return li;
    }
    /**
     * Returns UL element based on the given LI element.
     *
     * @param {Function} createElement - Function for creating elements.
     *
     * @param  {HTMLElement[]} liElement - Specifies array of LI element.
     *
     * @param  {string} [className] - Specifies class name that need to be added in UL element.
     *
     * @param  {ListBaseOptions} [options] - Specifies ListBase options.
     *
     * @returns {HTMLElement} - The created UL element.
     */ function generateUL(createElement, liElement, className, options) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        var ariaAttributes = (0, $3EnZW.extend)({}, defaultAriaAttributes, curOpt.ariaAttributes);
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(curOpt.moduleName);
        var ulElement = createElement("ul", {
            className: $ebf1cfbcf051ff2a$export$1283875077dc8f0a.ul + " " + ((0, $3EnZW.isNullOrUndefined)(className) ? "" : className),
            attrs: ariaAttributes.listRole !== "" ? {
                role: ariaAttributes.listRole
            } : {}
        });
        (0, $4ZDHT.append)(liElement, ulElement);
        return ulElement;
    }
    ListBase.generateUL = generateUL;
    /**
     * Returns LI element with additional DIV tag based on the given LI element.
     *
     * @param {Function} createElement - Function for creating elements.
     *
     * @param  {liElement} liElement - Specifies LI element.
     *
     * @param  {string} [className] - Specifies class name that need to be added in created DIV element.
     *
     * @param  {ListBaseOptions} [options] - Specifies ListBase options.
     *
     * @returns {HTMLElement} - The modified LI element.
     */ function generateIcon(createElement, liElement, className, options) {
        var curOpt = (0, $3EnZW.extend)({}, defaultListBaseOptions, options);
        $ebf1cfbcf051ff2a$export$1283875077dc8f0a = getModuleClass(curOpt.moduleName);
        var expandElement = curOpt.expandIconPosition === "Left" ? (0, $4ZDHT.prepend) : (0, $4ZDHT.append);
        expandElement([
            createElement("div", {
                className: "e-icons " + curOpt.expandIconClass + " " + ((0, $3EnZW.isNullOrUndefined)(className) ? "" : className)
            })
        ], liElement.querySelector("." + $ebf1cfbcf051ff2a$export$1283875077dc8f0a.textContent));
        return liElement;
    }
    ListBase.generateIcon = generateIcon;
})($ebf1cfbcf051ff2a$export$8f4a37dcf1e373df || ($ebf1cfbcf051ff2a$export$8f4a37dcf1e373df = {}));
function $ebf1cfbcf051ff2a$export$54119e4fbb06537c(dataItem, fields) {
    var fieldData = {};
    if ((0, $3EnZW.isNullOrUndefined)(dataItem) || typeof dataItem === "string" || typeof dataItem === "number" || !(0, $3EnZW.isNullOrUndefined)(dataItem.isHeader)) return dataItem;
    else for(var _i = 0, _a = Object.keys(fields); _i < _a.length; _i++){
        var field = _a[_i];
        var dataField = fields["" + field];
        var value = !(0, $3EnZW.isNullOrUndefined)(dataField) && typeof dataField === "string" ? (0, $3EnZW.getValue)(dataField, dataItem) : undefined;
        if (!(0, $3EnZW.isNullOrUndefined)(value)) fieldData["" + dataField] = value;
    }
    return fieldData;
}
/**
 * Compiles a template string or function into a compiled function.
 *
 * @param {string | Function} template - The template string or function to compile.
 * @returns {Function | undefined} - The compiled function, or undefined if the input is false.
 */ function $ebf1cfbcf051ff2a$var$compileTemplate(template) {
    if (template) try {
        if (typeof template !== "function" && document.querySelector(template)) return (0, $c2qqN.compile)(document.querySelector(template).innerHTML.trim());
        else return (0, $c2qqN.compile)(template);
    } catch (e) {
        return (0, $c2qqN.compile)(template);
    }
    return undefined;
}


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $3EnZW = parcelRequire("3EnZW");
var $5rsSz = parcelRequire("5rsSz");
var $61931d0ae0ca9b75$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $61931d0ae0ca9b75$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $61931d0ae0ca9b75$var$cssClassName = {
    TEXTSHAPE: "e-skeleton-text",
    CIRCLESHAPE: "e-skeleton-circle",
    SQUARESHAPE: "e-skeleton-square",
    RECTANGLESHAPE: "e-skeleton-rectangle",
    WAVEEFFECT: "e-shimmer-wave",
    PULSEEFFECT: "e-shimmer-pulse",
    FADEEFFECT: "e-shimmer-fade",
    VISIBLENONE: "e-visible-none"
};
var $61931d0ae0ca9b75$export$d617280680427479;
(function(SkeletonType) {
    /**
     * Defines the skeleton shape as text.
     */ SkeletonType["Text"] = "Text";
    /**
     * Defines the skeleton shape as circle.
     */ SkeletonType["Circle"] = "Circle";
    /**
     * Defines the skeleton shape as square.
     */ SkeletonType["Square"] = "Square";
    /**
     * Defines the skeleton shape as rectangle.
     */ SkeletonType["Rectangle"] = "Rectangle";
})($61931d0ae0ca9b75$export$d617280680427479 || ($61931d0ae0ca9b75$export$d617280680427479 = {}));
var $61931d0ae0ca9b75$export$c244e2fa07d24897;
(function(ShimmerEffect) {
    /**
     * Defines the animation as shimmer wave effect.
     */ ShimmerEffect["Wave"] = "Wave";
    /**
     * Defines the animation as fade effect.
     */ ShimmerEffect["Fade"] = "Fade";
    /**
     * Defines the animation as pulse effect.
     */ ShimmerEffect["Pulse"] = "Pulse";
    /**
     * Defines the animation as no effect.
     */ ShimmerEffect["None"] = "None";
})($61931d0ae0ca9b75$export$c244e2fa07d24897 || ($61931d0ae0ca9b75$export$c244e2fa07d24897 = {}));
/**
 * The Shimmer is a placeholder that animates a shimmer effect to let users know that the page’s content is loading at the moment.
 * In other terms, it simulates the layout of page content while loading the actual content.
 * ```html
 * <div id="skeletonCircle"></div>
 * ```
 * ```typescript
 * <script>
 * var skeletonObj = new Skeleton({ shape: 'Circle', width: "2rem" });
 * skeletonObj.appendTo("#skeletonCircle");
 * </script>
 * ```
 */ var $61931d0ae0ca9b75$export$8f31e4c4a37b8e9c = /** @class */ function(_super) {
    $61931d0ae0ca9b75$var$__extends(Skeleton, _super);
    /**
     * Constructor for creating Skeleton component.
     *
     * @param {SkeletonModel} options - Defines the model of Skeleton class.
     * @param {HTMLElement} element - Defines the target HTML element.
     */ function Skeleton(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Get component module name.
     *
     * @returns {string} - Module name
     * @private
     */ Skeleton.prototype.getModuleName = function() {
        return "skeleton";
    };
    Skeleton.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    Skeleton.prototype.preRender = function() {
        if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)("e-" + this.getModuleName());
        this.updateCssClass();
        (0, $4ZDHT.attributes)(this.element, {
            role: "alert",
            "aria-busy": "true",
            "aria-live": "polite",
            "aria-label": this.label
        });
    };
    /**
     * Method for initialize the component rendering.
     *
     * @returns {void}
     * @private
     */ Skeleton.prototype.render = function() {
        this.initialize();
    };
    Skeleton.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "width":
                case "height":
                    this.updateDimension();
                    break;
                case "shape":
                    this.updateShape();
                    break;
                case "shimmerEffect":
                    this.updateEffect();
                    break;
                case "visible":
                    this.updateVisibility();
                    break;
                case "label":
                    this.element.setAttribute("aria-label", this.label);
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        this.element
                    ], oldProp.cssClass.split(" "));
                    this.updateCssClass();
                    break;
            }
        }
    };
    /**
     * Method to destroys the Skeleton component.
     *
     * @returns {void}
     */ Skeleton.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        var attrs = [
            "role",
            "aria-live",
            "aria-busy",
            "aria-label"
        ];
        var cssClass = [];
        if (this.cssClass) cssClass = cssClass.concat(this.cssClass.split(" "));
        for(var i = 0; i < attrs.length; i++)this.element.removeAttribute(attrs[parseInt(i.toString(), 10)]);
        cssClass = cssClass.concat(this.element.classList.value.match(/(e-skeleton-[^\s]+)/g) || []);
        cssClass = cssClass.concat(this.element.classList.value.match(/(e-shimmer-[^\s]+)/g) || []);
        (0, $4ZDHT.removeClass)([
            this.element
        ], cssClass);
    };
    Skeleton.prototype.initialize = function() {
        this.updateShape();
        this.updateEffect();
        this.updateVisibility();
    };
    Skeleton.prototype.updateShape = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.shape)) {
            var shapeCss = $61931d0ae0ca9b75$var$cssClassName[this.shape.toUpperCase() + "SHAPE"];
            var removeCss = this.element.classList.value.match(/(e-skeleton-[^\s]+)/g) || [];
            this.updateDimension();
            if (removeCss) (0, $4ZDHT.removeClass)([
                this.element
            ], removeCss);
            (0, $4ZDHT.addClass)([
                this.element
            ], [
                shapeCss
            ]);
        }
    };
    Skeleton.prototype.updateDimension = function() {
        var width = !this.width && [
            "Text",
            "Rectangle"
        ].indexOf(this.shape) > -1 ? "100%" : (0, $3EnZW.formatUnit)(this.width);
        var height = [
            "Circle",
            "Square"
        ].indexOf(this.shape) > -1 ? width : (0, $3EnZW.formatUnit)(this.height);
        this.element.style.width = width;
        this.element.style.height = height;
    };
    Skeleton.prototype.updateEffect = function() {
        var removeCss = this.element.classList.value.match(/(e-shimmer-[^\s]+)/g) || [];
        if (removeCss) (0, $4ZDHT.removeClass)([
            this.element
        ], removeCss);
        if (!(0, $3EnZW.isNullOrUndefined)(this.shimmerEffect)) (0, $4ZDHT.addClass)([
            this.element
        ], [
            $61931d0ae0ca9b75$var$cssClassName[this.shimmerEffect.toUpperCase() + "EFFECT"]
        ]);
    };
    Skeleton.prototype.updateVisibility = function() {
        this.element.classList[this.visible ? "remove" : "add"]($61931d0ae0ca9b75$var$cssClassName.VISIBLENONE);
    };
    Skeleton.prototype.updateCssClass = function() {
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.element
        ], this.cssClass.split(" "));
    };
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Skeleton.prototype, "width", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Skeleton.prototype, "height", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Skeleton.prototype, "visible", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("Text")
    ], Skeleton.prototype, "shape", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("Wave")
    ], Skeleton.prototype, "shimmerEffect", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("Loading...")
    ], Skeleton.prototype, "label", void 0);
    $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Skeleton.prototype, "cssClass", void 0);
    Skeleton = $61931d0ae0ca9b75$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Skeleton);
    return Skeleton;
}((0, $hQxLN.Component));


var $8333a85b68b3ebf8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8333a85b68b3ebf8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8333a85b68b3ebf8$export$47acbd07e937cc3e = /** @class */ function(_super) {
    $8333a85b68b3ebf8$var$__extends(FieldSettings, _super);
    function FieldSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "text", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "value", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "iconCss", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "groupBy", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "htmlAttributes", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], FieldSettings.prototype, "disabled", void 0);
    return FieldSettings;
}((0, $3fcxu.ChildProperty));
var $8333a85b68b3ebf8$export$caaa541e4c87fe5d = {
    root: "e-dropdownbase",
    rtl: "e-rtl",
    content: "e-content",
    selected: "e-active",
    hover: "e-hover",
    noData: "e-nodata",
    fixedHead: "e-fixed-head",
    focus: "e-item-focus",
    li: "e-list-item",
    group: "e-list-group-item",
    disabled: "e-disabled",
    grouping: "e-dd-group",
    virtualList: "e-list-item e-virtual-list"
};
var $8333a85b68b3ebf8$var$ITEMTEMPLATE_PROPERTY = "ItemTemplate";
var $8333a85b68b3ebf8$var$DISPLAYTEMPLATE_PROPERTY = "DisplayTemplate";
var $8333a85b68b3ebf8$var$SPINNERTEMPLATE_PROPERTY = "SpinnerTemplate";
var $8333a85b68b3ebf8$var$VALUETEMPLATE_PROPERTY = "ValueTemplate";
var $8333a85b68b3ebf8$var$GROUPTEMPLATE_PROPERTY = "GroupTemplate";
var $8333a85b68b3ebf8$var$HEADERTEMPLATE_PROPERTY = "HeaderTemplate";
var $8333a85b68b3ebf8$var$FOOTERTEMPLATE_PROPERTY = "FooterTemplate";
var $8333a85b68b3ebf8$var$NORECORDSTEMPLATE_PROPERTY = "NoRecordsTemplate";
var $8333a85b68b3ebf8$var$ACTIONFAILURETEMPLATE_PROPERTY = "ActionFailureTemplate";
var $8333a85b68b3ebf8$var$HIDE_GROUPLIST = "e-hide-group-header";
/**
 * DropDownBase component will generate the list items based on given data and act as base class to drop-down related components
 */ var $8333a85b68b3ebf8$export$7dc99c6c1af7b42 = /** @class */ function(_super) {
    $8333a85b68b3ebf8$var$__extends(DropDownBase, _super);
    /**
     * * Constructor for DropDownBase class
     *
     * @param {DropDownBaseModel} options - Specifies the DropDownBase model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function DropDownBase(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.preventChange = false;
        _this.isPreventChange = false;
        _this.isDynamicDataChange = false;
        _this.addedNewItem = false;
        _this.isAddNewItemTemplate = false;
        _this.isRequesting = false;
        _this.isVirtualizationEnabled = false;
        _this.isCustomDataUpdated = false;
        _this.isAllowFiltering = false;
        _this.virtualizedItemsCount = 0;
        _this.isCheckBoxSelection = false;
        _this.totalItemCount = 0;
        _this.dataCount = 0;
        _this.remoteDataCount = -1;
        _this.isRemoteDataUpdated = false;
        _this.isIncrementalRequest = false;
        _this.itemCount = 30;
        _this.virtualListHeight = 0;
        _this.isVirtualScrolling = false;
        _this.isPreventScrollAction = false;
        _this.scrollPreStartIndex = 0;
        _this.isScrollActionTriggered = false;
        _this.previousStartIndex = 0;
        _this.isMouseScrollAction = false;
        _this.isKeyBoardAction = false;
        _this.isScrollChanged = false;
        _this.isUpwardScrolling = false;
        _this.startIndex = 0;
        _this.currentPageNumber = 0;
        _this.pageCount = 0;
        _this.isPreventKeyAction = false;
        _this.generatedDataObject = {};
        _this.skeletonCount = 32;
        _this.isVirtualTrackHeight = false;
        _this.virtualSelectAll = false;
        _this.incrementalQueryString = "";
        _this.incrementalEndIndex = 0;
        _this.incrementalStartIndex = 0;
        _this.incrementalPreQueryString = "";
        _this.isObjectCustomValue = false;
        _this.appendUncheckList = false;
        _this.getInitialData = false;
        _this.preventPopupOpen = true;
        _this.virtualSelectAllState = false;
        _this.CurrentEvent = null;
        _this.virtualListInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: 0
        };
        _this.viewPortInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: 0
        };
        _this.selectedValueInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: 0
        };
        return _this;
    }
    DropDownBase.prototype.getPropObject = function(prop, newProp, oldProp) {
        var newProperty = new Object();
        var oldProperty = new Object();
        var propName = function(prop) {
            return prop;
        };
        newProperty[propName(prop)] = newProp[propName(prop)];
        oldProperty[propName(prop)] = oldProp[propName(prop)];
        var data = new Object();
        data.newProperty = newProperty;
        data.oldProperty = oldProperty;
        return data;
    };
    DropDownBase.prototype.getValueByText = function(text, ignoreCase, ignoreAccent) {
        var value = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.listData)) {
            if (ignoreCase) value = this.checkValueCase(text, true, ignoreAccent);
            else value = this.checkValueCase(text, false, ignoreAccent);
        }
        return value;
    };
    DropDownBase.prototype.checkValueCase = function(text, ignoreCase, ignoreAccent, isTextByValue) {
        var _this = this;
        var value = null;
        if (isTextByValue) value = text;
        var dataSource = this.listData;
        var fields = this.fields;
        var type = this.typeOfData(dataSource).typeof;
        if (type === "string" || type === "number" || type === "boolean") for(var _i = 0, dataSource_1 = dataSource; _i < dataSource_1.length; _i++){
            var item = dataSource_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(item)) {
                if (ignoreAccent) value = this.checkingAccent(String(item), text, ignoreCase);
                else {
                    if (ignoreCase) {
                        if (this.checkIgnoreCase(String(item), text)) value = this.getItemValue(String(item), text, ignoreCase);
                    } else if (this.checkNonIgnoreCase(String(item), text)) value = this.getItemValue(String(item), text, ignoreCase, isTextByValue);
                }
            }
        }
        else {
            if (ignoreCase) dataSource.filter(function(item) {
                var itemValue = (0, $3EnZW.getValue)(fields.value, item);
                if (!(0, $3EnZW.isNullOrUndefined)(itemValue) && _this.checkIgnoreCase((0, $3EnZW.getValue)(fields.text, item).toString(), text)) value = (0, $3EnZW.getValue)(fields.value, item);
            });
            else if (isTextByValue) {
                var compareValue_1 = null;
                compareValue_1 = value;
                dataSource.filter(function(item) {
                    var itemValue = (0, $3EnZW.getValue)(fields.value, item);
                    if (!(0, $3EnZW.isNullOrUndefined)(itemValue) && !(0, $3EnZW.isNullOrUndefined)(value) && itemValue.toString() === compareValue_1.toString()) value = (0, $3EnZW.getValue)(fields.text, item);
                });
            } else dataSource.filter(function(item) {
                if (_this.checkNonIgnoreCase((0, $3EnZW.getValue)(fields.text, item), text)) value = (0, $3EnZW.getValue)(fields.value, item);
            });
        }
        return value;
    };
    DropDownBase.prototype.checkingAccent = function(item, text, ignoreCase) {
        var dataItem = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).ignoreDiacritics(String(item));
        var textItem = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).ignoreDiacritics(text.toString());
        var value = null;
        if (ignoreCase) {
            if (this.checkIgnoreCase(dataItem, textItem)) value = this.getItemValue(String(item), text, ignoreCase);
        } else if (this.checkNonIgnoreCase(String(item), text)) value = this.getItemValue(String(item), text, ignoreCase);
        return value;
    };
    DropDownBase.prototype.checkIgnoreCase = function(item, text) {
        return String(item).toLowerCase() === text.toString().toLowerCase() ? true : false;
    };
    DropDownBase.prototype.checkNonIgnoreCase = function(item, text) {
        return String(item) === text.toString() ? true : false;
    };
    DropDownBase.prototype.getItemValue = function(dataItem, typedText, ignoreCase, isTextByValue) {
        var value = null;
        var dataSource = this.listData;
        var type = this.typeOfData(dataSource).typeof;
        if (isTextByValue) value = dataItem.toString();
        else if (ignoreCase) value = type === "string" ? String(dataItem) : this.getFormattedValue(String(dataItem));
        else value = type === "string" ? typedText : this.getFormattedValue(typedText);
        return value;
    };
    DropDownBase.prototype.templateCompiler = function(baseTemplate) {
        var checkTemplate = false;
        if (typeof baseTemplate !== "function" && baseTemplate) try {
            checkTemplate = (0, $4ZDHT.selectAll)(baseTemplate, document).length ? true : false;
        } catch (exception) {
            checkTemplate = false;
        }
        return checkTemplate;
    };
    DropDownBase.prototype.l10nUpdate = function(actionFailure) {
        var ele = this.getModuleName() === "listbox" ? this.ulElement : this.list;
        if (!(0, $3EnZW.isNullOrUndefined)(this.noRecordsTemplate) && this.noRecordsTemplate !== "No records found" || this.actionFailureTemplate !== "Request failed") {
            var template = actionFailure ? this.actionFailureTemplate : this.noRecordsTemplate;
            var compiledString = void 0;
            var templateId = actionFailure ? this.actionFailureTemplateId : this.noRecordsTemplateId;
            ele.innerHTML = "";
            var tempaltecheck = this.templateCompiler(template);
            if (typeof template !== "function" && tempaltecheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(template, document).innerHTML.trim());
            else compiledString = (0, $c2qqN.compile)(template);
            var templateName = actionFailure ? "actionFailureTemplate" : "noRecordsTemplate";
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var noDataElement = void 0;
            if (this.isReact && typeof template === "function") noDataElement = compiledString({}, this, templateName, templateId, this.isStringTemplate, null);
            else noDataElement = compiledString({}, this, templateName, templateId, this.isStringTemplate, null, ele);
            if (noDataElement && noDataElement.length > 0) for(var i = 0; i < noDataElement.length; i++){
                if (this.getModuleName() === "listbox" && templateName === "noRecordsTemplate") {
                    if (noDataElement[i].nodeName === "#text") {
                        var liElem = this.createElement("li");
                        liElem.textContent = noDataElement[i].textContent;
                        liElem.classList.add("e-list-nrt");
                        liElem.setAttribute("role", "option");
                        ele.appendChild(liElem);
                    } else {
                        noDataElement[i].classList.add("e-list-nr-template");
                        ele.appendChild(noDataElement[i]);
                    }
                } else if (noDataElement[i] instanceof HTMLElement || noDataElement[i] instanceof Text && noDataElement[i].textContent !== "") ele.appendChild(noDataElement[i]);
            }
            this.renderReactTemplates();
        } else {
            var l10nLocale = {
                noRecordsTemplate: "No records found",
                actionFailureTemplate: "Request failed"
            };
            var componentLocale = new (0, $e7i2H.L10n)(this.getLocaleName(), {}, this.locale);
            if (componentLocale.getConstant("actionFailureTemplate") !== "" || componentLocale.getConstant("noRecordsTemplate") !== "") this.l10n = componentLocale;
            else this.l10n = new (0, $e7i2H.L10n)(this.getModuleName() === "listbox" ? "listbox" : this.getModuleName() === "mention" ? "mention" : "dropdowns", l10nLocale, this.locale);
            var content = actionFailure ? this.l10n.getConstant("actionFailureTemplate") : this.l10n.getConstant("noRecordsTemplate");
            if (this.getModuleName() === "listbox") {
                var liElem = this.createElement("li");
                liElem.textContent = content;
                ele.appendChild(liElem);
                liElem.classList.add("e-list-nrt");
                liElem.setAttribute("role", "option");
            } else if (!(0, $3EnZW.isNullOrUndefined)(ele)) ele.innerHTML = content;
        }
    };
    DropDownBase.prototype.checkAndResetCache = function() {
        if (this.isVirtualizationEnabled) {
            this.generatedDataObject = {};
            this.virtualItemStartIndex = this.virtualItemEndIndex = 0;
            this.viewPortInfo = {
                currentPageNumber: null,
                direction: null,
                sentinelInfo: {},
                offsets: {},
                startIndex: 0,
                endIndex: this.itemCount
            };
            this.selectedValueInfo = null;
        }
    };
    DropDownBase.prototype.updateIncrementalInfo = function(startIndex, endIndex) {
        this.viewPortInfo.startIndex = startIndex;
        this.viewPortInfo.endIndex = endIndex;
        this.updateVirtualItemIndex();
        this.isIncrementalRequest = true;
        this.resetList(this.dataSource, this.fields, this.query);
        this.isIncrementalRequest = false;
    };
    DropDownBase.prototype.updateIncrementalView = function(startIndex, endIndex) {
        this.viewPortInfo.startIndex = startIndex;
        this.viewPortInfo.endIndex = endIndex;
        this.updateVirtualItemIndex();
        this.resetList(this.dataSource, this.fields, this.query);
        this.UpdateSkeleton();
        this.liCollections = this.list.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
        this.ulElement = this.list.querySelector("ul");
    };
    DropDownBase.prototype.updateVirtualItemIndex = function() {
        this.virtualItemStartIndex = this.viewPortInfo.startIndex;
        this.virtualItemEndIndex = this.viewPortInfo.endIndex;
        this.virtualListInfo = this.viewPortInfo;
    };
    DropDownBase.prototype.getFilteringSkeletonCount = function() {
        var currentSkeletonCount = this.skeletonCount;
        this.getSkeletonCount(true);
        this.skeletonCount = this.dataCount < this.itemCount * 2 && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount <= this.itemCount) ? 0 : this.skeletonCount;
        var skeletonUpdated = true;
        if ((this.getModuleName() === "autocomplete" || this.getModuleName() === "multiselect") && this.totalItemCount < this.itemCount * 2 && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount <= this.itemCount)) {
            this.skeletonCount = 0;
            skeletonUpdated = false;
        }
        if (!this.list.classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData)) {
            if (currentSkeletonCount !== this.skeletonCount && skeletonUpdated) this.UpdateSkeleton(true, Math.abs(currentSkeletonCount - this.skeletonCount));
            else this.UpdateSkeleton();
            this.liCollections = this.list.querySelectorAll(".e-list-item");
            if (this.list.getElementsByClassName("e-virtual-ddl").length > 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
            else if (!this.list.querySelector(".e-virtual-ddl") && this.skeletonCount > 0 && this.list.querySelector(".e-dropdownbase")) {
                var virualElement = this.createElement("div", {
                    id: this.element.id + "_popup",
                    className: "e-virtual-ddl",
                    styles: this.GetVirtualTrackHeight()
                });
                this.list.querySelector(".e-dropdownbase").appendChild(virualElement);
            }
            if (this.list.getElementsByClassName("e-virtual-ddl-content").length > 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
        }
    };
    DropDownBase.prototype.getSkeletonCount = function(retainSkeleton) {
        this.virtualListHeight = this.listContainerHeight != null ? parseInt(this.listContainerHeight, 10) : this.virtualListHeight;
        var actualCount = this.virtualListHeight > 0 ? Math.floor(this.virtualListHeight / this.listItemHeight) : 0;
        this.skeletonCount = actualCount * 4 < this.itemCount ? this.itemCount : actualCount * 4;
        this.itemCount = retainSkeleton ? this.itemCount : this.skeletonCount;
        this.virtualItemCount = this.itemCount;
        this.skeletonCount = Math.floor(this.skeletonCount / 2);
    };
    DropDownBase.prototype.GetVirtualTrackHeight = function() {
        var height = this.totalItemCount === this.viewPortInfo.endIndex ? this.totalItemCount * this.listItemHeight - this.itemCount * this.listItemHeight : this.totalItemCount * this.listItemHeight;
        height = this.isVirtualTrackHeight ? 0 : height;
        var heightDimension = "height: " + (height - this.itemCount * this.listItemHeight) + "px;";
        if ((this.getModuleName() === "autocomplete" || this.getModuleName() === "multiselect") && this.skeletonCount === 0) return "height: 0px;";
        return heightDimension;
    };
    DropDownBase.prototype.getTransformValues = function() {
        var translateY = this.viewPortInfo.startIndex * this.listItemHeight;
        translateY = translateY - this.skeletonCount * this.listItemHeight;
        translateY = this.viewPortInfo.startIndex === 0 && this.listData && this.listData.length === 0 || this.skeletonCount === 0 ? 0 : translateY;
        var styleText = "transform: translate(0px, " + translateY + "px);";
        return styleText;
    };
    DropDownBase.prototype.UpdateSkeleton = function(isSkeletonCountChange, skeletonCount) {
        var isContainSkeleton = this.list.querySelector(".e-virtual-ddl-content");
        var isContainVirtualList = this.list.querySelector(".e-virtual-list");
        if (isContainSkeleton && (!isContainVirtualList || isSkeletonCountChange) && this.isVirtualizationEnabled) {
            var totalSkeletonCount = isSkeletonCountChange ? skeletonCount : this.skeletonCount;
            for(var i = 0; i < totalSkeletonCount; i++){
                var liElement = this.createElement("li", {
                    className: $8333a85b68b3ebf8$export$caaa541e4c87fe5d.virtualList,
                    styles: "overflow: inherit"
                });
                if (this.isVirtualizationEnabled && this.itemTemplate) liElement.style.height = this.listItemHeight + "px";
                var skeleton = new (0, $61931d0ae0ca9b75$export$8f31e4c4a37b8e9c)({
                    shape: "Text",
                    height: "10px",
                    width: "95%",
                    cssClass: "e-skeleton-text"
                });
                skeleton.appendTo(this.createElement("div"));
                liElement.appendChild(skeleton.element);
                if (isContainSkeleton.firstChild) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                isContainSkeleton.firstChild.insertBefore(liElement, isContainSkeleton.firstChild.children[0]);
            }
        }
    };
    DropDownBase.prototype.getLocaleName = function() {
        return "drop-down-base";
    };
    DropDownBase.prototype.getTextByValue = function(value) {
        var text = this.checkValueCase(value, false, false, true);
        return text;
    };
    DropDownBase.prototype.getFormattedValue = function(value) {
        if (this.listData && this.listData.length) {
            var item = void 0;
            if (this.properties.allowCustomValue && this.properties.value && this.properties.value instanceof Array && this.properties.value.length > 0) item = this.typeOfData(this.properties.value);
            else item = this.typeOfData(this.listData);
            if (typeof (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", item.item) === "number" || item.typeof === "number") return parseFloat(value);
            if (typeof (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", item.item) === "boolean" || item.typeof === "boolean") return value === "true" || "" + value === "true";
        }
        return value;
    };
    /**
     * Sets RTL to dropdownbase wrapper
     *
     * @returns {void}
     */ DropDownBase.prototype.setEnableRtl = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.enableRtlElements)) {
            if (this.list) this.enableRtlElements.push(this.list);
            if (this.enableRtl) (0, $4ZDHT.addClass)(this.enableRtlElements, $8333a85b68b3ebf8$export$caaa541e4c87fe5d.rtl);
            else (0, $4ZDHT.removeClass)(this.enableRtlElements, $8333a85b68b3ebf8$export$caaa541e4c87fe5d.rtl);
        }
    };
    /**
     * Initialize the Component.
     *
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} e - The event object.
     * @returns {void}
     */ DropDownBase.prototype.initialize = function(e) {
        this.bindEvent = true;
        this.preventPopupOpen = true;
        this.actionFailureTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$ACTIONFAILURETEMPLATE_PROPERTY;
        if (this.element.tagName === "UL") {
            var jsonElement = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createJsonFromElement(this.element);
            this.setProperties({
                fields: {
                    text: "text",
                    value: "text"
                }
            }, true);
            this.resetList(jsonElement, this.fields);
        } else if (this.element.tagName === "SELECT") {
            var dataSource = this.dataSource instanceof Array ? this.dataSource.length > 0 ? true : false : !(0, $3EnZW.isNullOrUndefined)(this.dataSource) ? true : false;
            if (!dataSource) this.renderItemsBySelect();
            else if (this.isDynamicDataChange) this.setListData(this.dataSource, this.fields, this.query);
        } else this.setListData(this.dataSource, this.fields, this.query, e);
    };
    /**
     * Get the properties to be maintained in persisted state.
     *
     * @returns {string} Returns the persisted data of the component.
     */ DropDownBase.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * Sets the enabled state to DropDownBase.
     *
     * @param {string} value - Specifies the attribute values to add on the input element.
     * @returns {void}
     */ DropDownBase.prototype.updateDataAttribute = function(value) {
        var invalidAttr = [
            "class",
            "style",
            "id",
            "type",
            "aria-expanded",
            "aria-autocomplete",
            "aria-readonly"
        ];
        var attr = {};
        for(var a = 0; a < this.element.attributes.length; a++)if (invalidAttr.indexOf(this.element.attributes[a].name) === -1 && !(this.getModuleName() === "dropdownlist" && this.element.attributes[a].name === "readonly")) attr[this.element.attributes[a].name] = this.element.getAttribute(this.element.attributes[a].name);
        (0, $3EnZW.extend)(attr, value, attr);
        this.setProperties({
            htmlAttributes: attr
        }, true);
    };
    DropDownBase.prototype.renderItemsBySelect = function() {
        var element = this.element;
        var fields = {
            value: "value",
            text: "text"
        };
        var jsonElement = [];
        var group = element.querySelectorAll("select>optgroup");
        var option = element.querySelectorAll("select>option");
        this.getJSONfromOption(jsonElement, option, fields);
        if (group.length) {
            for(var i = 0; i < group.length; i++){
                var item = group[i];
                var optionGroup = {};
                optionGroup[fields.text] = item.label;
                optionGroup.isHeader = true;
                var child = item.querySelectorAll("option");
                jsonElement.push(optionGroup);
                this.getJSONfromOption(jsonElement, child, fields);
            }
            element.querySelectorAll("select>option");
        }
        this.updateFields(fields.text, fields.value, this.fields.groupBy, this.fields.htmlAttributes, this.fields.iconCss, this.fields.disabled);
        this.resetList(jsonElement, fields);
    };
    DropDownBase.prototype.updateFields = function(text, value, groupBy, htmlAttributes, iconCss, disabled) {
        var field = {
            "fields": {
                text: text,
                value: value,
                groupBy: !(0, $3EnZW.isNullOrUndefined)(groupBy) ? groupBy : this.fields && this.fields.groupBy,
                htmlAttributes: !(0, $3EnZW.isNullOrUndefined)(htmlAttributes) ? htmlAttributes : this.fields && this.fields.htmlAttributes,
                iconCss: !(0, $3EnZW.isNullOrUndefined)(iconCss) ? iconCss : this.fields && this.fields.iconCss,
                disabled: !(0, $3EnZW.isNullOrUndefined)(disabled) ? disabled : this.fields && this.fields.disabled
            }
        };
        this.setProperties(field, true);
    };
    DropDownBase.prototype.getJSONfromOption = function(items, options, fields) {
        for(var _i = 0, options_1 = options; _i < options_1.length; _i++){
            var option = options_1[_i];
            var json = {};
            json[fields.text] = option.innerText;
            json[fields.value] = !(0, $3EnZW.isNullOrUndefined)(option.getAttribute(fields.value)) ? option.getAttribute(fields.value) : option.innerText;
            items.push(json);
        }
    };
    /**
     * Execute before render the list items
     *
     * @private
     * @returns {void}
     */ DropDownBase.prototype.preRender = function() {
        // there is no event handler
        this.scrollTimer = -1;
        this.enableRtlElements = [];
        this.isRequested = false;
        this.isDataFetched = false;
        this.itemTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$ITEMTEMPLATE_PROPERTY;
        this.displayTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$DISPLAYTEMPLATE_PROPERTY;
        this.spinnerTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$SPINNERTEMPLATE_PROPERTY;
        this.valueTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$VALUETEMPLATE_PROPERTY;
        this.groupTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$GROUPTEMPLATE_PROPERTY;
        this.headerTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$HEADERTEMPLATE_PROPERTY;
        this.footerTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$FOOTERTEMPLATE_PROPERTY;
        this.noRecordsTemplateId = "" + this.element.id + $8333a85b68b3ebf8$var$NORECORDSTEMPLATE_PROPERTY;
    };
    /**
     * Creates the list items of DropDownBase component.
     *
     * @param {Object[] | string[] | number[] | DataManager | boolean[]} dataSource - Specifies the data to generate the list.
     * @param {FieldSettingsModel} fields - Maps the columns of the data table and binds the data to the component.
     * @param {Query} query - Accepts the external Query that execute along with data processing.
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} event - Specifies the event which is the reason for the invocation of this method.
     * @returns {void}
     */ DropDownBase.prototype.setListData = function(dataSource, fields, query, event) {
        var _this = this;
        fields = fields ? fields : this.fields;
        var ulElement;
        this.isActive = true;
        var eventArgs = {
            cancel: false,
            data: dataSource,
            query: query
        };
        this.isPreventChange = this.isAngular && this.preventChange ? true : this.isPreventChange;
        if (!this.isRequesting) this.trigger("actionBegin", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel) {
                _this.isRequesting = true;
                _this.showSpinner();
                if (dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                    _this.isRequested = true;
                    var isWhereExist_1 = false;
                    if (_this.isDataFetched) {
                        _this.emptyDataRequest(fields);
                        return;
                    }
                    eventArgs.data.executeQuery(_this.getQuery(eventArgs.query)).then(function(e) {
                        _this.isPreventChange = _this.isAngular && _this.preventChange ? true : _this.isPreventChange;
                        var isReOrder = true;
                        if (!_this.virtualSelectAll) {
                            var newQuery = _this.getQuery(eventArgs.query);
                            for(var queryElements = 0; queryElements < newQuery.queries.length; queryElements++)if (newQuery.queries[queryElements].fn === "onWhere") isWhereExist_1 = true;
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            if (_this.isVirtualizationEnabled && e.count !== 0 && e.count < _this.itemCount * 2) {
                                if (newQuery) for(var queryElements = 0; queryElements < newQuery.queries.length; queryElements++){
                                    if (newQuery.queries[queryElements].fn === "onTake") // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    newQuery.queries[queryElements].e.nos = e.count;
                                    if (_this.getModuleName() === "multiselect" && (newQuery.queries[queryElements].e.condition === "or" || newQuery.queries[queryElements].e.operator === "equal")) isReOrder = false;
                                }
                            } else {
                                _this.isVirtualTrackHeight = false;
                                if (newQuery) {
                                    for(var queryElements = 0; queryElements < newQuery.queries.length; queryElements++)if (_this.getModuleName() === "multiselect" && (newQuery.queries[queryElements].e && newQuery.queries[queryElements].e.condition === "or" || newQuery.queries[queryElements].e && newQuery.queries[queryElements].e.operator === "equal")) isReOrder = false;
                                }
                            }
                        }
                        if (isReOrder) // eslint-disable @typescript-eslint/no-explicit-any
                        _this.dataCount = _this.totalItemCount = e.count;
                        _this.trigger("actionComplete", e, function(e) {
                            if (!e.cancel) {
                                _this.isRequesting = false;
                                var listItems = e.result;
                                if (_this.isIncrementalRequest) {
                                    ulElement = _this.renderItems(listItems, fields);
                                    return;
                                }
                                if (!_this.isVirtualizationEnabled && listItems.length === 0 || _this.isVirtualizationEnabled && listItems.length === 0 && !isWhereExist_1) _this.isDataFetched = true;
                                if (!isWhereExist_1) _this.remoteDataCount = e.count;
                                _this.dataCount = !_this.virtualSelectAll ? e.count : _this.dataCount;
                                _this.totalItemCount = !_this.virtualSelectAll ? e.count : _this.totalItemCount;
                                ulElement = _this.renderItems(listItems, fields);
                                _this.appendUncheckList = false;
                                _this.onActionComplete(ulElement, listItems, e);
                                if (_this.groupTemplate) _this.renderGroupTemplate(ulElement);
                                _this.isRequested = false;
                                _this.bindChildItems(listItems, ulElement, fields, e);
                                if (_this.getInitialData) {
                                    _this.setListData(dataSource, fields, query, event);
                                    _this.getInitialData = false;
                                    _this.preventPopupOpen = false;
                                    return;
                                }
                                if (_this.isVirtualizationEnabled && _this.setCurrentView) _this.notify("setCurrentViewDataAsync", {
                                    module: "VirtualScroll"
                                });
                                if (_this.keyboardEvent != null) _this.handleVirtualKeyboardActions(_this.keyboardEvent, _this.pageCount);
                                if (_this.isVirtualizationEnabled) _this.getFilteringSkeletonCount();
                                if (_this.virtualSelectAll && _this.virtualSelectAllData) {
                                    _this.virtualSelectionAll(_this.virtualSelectAllState, _this.liCollections, _this.CurrentEvent);
                                    _this.virtualSelectAllState = false;
                                    _this.CurrentEvent = null;
                                    _this.virtualSelectAll = false;
                                }
                            }
                        });
                    }).catch(function(e) {
                        _this.isRequested = false;
                        _this.isRequesting = false;
                        _this.onActionFailure(e);
                        _this.hideSpinner();
                    });
                } else {
                    _this.isRequesting = false;
                    var isReOrder = true;
                    var listItems = void 0;
                    if (_this.isVirtualizationEnabled && !_this.virtualGroupDataSource && _this.fields.groupBy) {
                        var data = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(_this.dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().group(_this.fields.groupBy));
                        _this.virtualGroupDataSource = data.records;
                    }
                    var dataManager = _this.isVirtualizationEnabled && _this.virtualGroupDataSource && !_this.isCustomDataUpdated ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(_this.virtualGroupDataSource) : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(eventArgs.data);
                    listItems = _this.getQuery(eventArgs.query).executeLocal(dataManager);
                    if (!_this.virtualSelectAll) {
                        var newQuery = _this.getQuery(eventArgs.query);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        if (_this.isVirtualizationEnabled && listItems.count !== 0 && listItems.count < _this.itemCount * 2) {
                            if (newQuery) {
                                for(var queryElements = 0; queryElements < newQuery.queries.length; queryElements++){
                                    if (newQuery.queries[queryElements].fn === "onTake") {
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        newQuery.queries[queryElements].e.nos = listItems.count;
                                        listItems = newQuery.executeLocal(dataManager);
                                    }
                                    if (_this.getModuleName() === "multiselect" && (newQuery.queries[queryElements].e.condition === "or" || newQuery.queries[queryElements].e.operator === "equal")) isReOrder = false;
                                }
                                if (isReOrder) {
                                    listItems = newQuery.executeLocal(dataManager);
                                    _this.isVirtualTrackHeight = !(_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && !_this.isCustomDataUpdated ? true : false;
                                }
                            }
                        } else {
                            _this.isVirtualTrackHeight = false;
                            if (newQuery) {
                                for(var queryElements = 0; queryElements < newQuery.queries.length; queryElements++)if (_this.getModuleName() === "multiselect" && (newQuery.queries[queryElements].e && newQuery.queries[queryElements].e.condition === "or" || newQuery.queries[queryElements].e && newQuery.queries[queryElements].e.operator === "equal")) isReOrder = false;
                            }
                        }
                    }
                    if (isReOrder && !(_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && !_this.isCustomDataUpdated && !_this.virtualSelectAll) // eslint-disable @typescript-eslint/no-explicit-any
                    _this.dataCount = _this.totalItemCount = _this.virtualSelectAll ? listItems.length : listItems.count;
                    listItems = _this.isVirtualizationEnabled ? listItems.result : listItems;
                    // eslint-enable @typescript-eslint/no-explicit-any
                    var localDataArgs = {
                        cancel: false,
                        result: listItems
                    };
                    _this.isPreventChange = _this.isAngular && _this.preventChange ? true : _this.isPreventChange;
                    _this.trigger("actionComplete", localDataArgs, function(localDataArgs) {
                        if (_this.isIncrementalRequest) {
                            ulElement = _this.renderItems(localDataArgs.result, fields);
                            return;
                        }
                        if (!localDataArgs.cancel) {
                            ulElement = _this.renderItems(localDataArgs.result, fields);
                            _this.onActionComplete(ulElement, localDataArgs.result, event);
                            if (_this.groupTemplate) _this.renderGroupTemplate(ulElement);
                            _this.bindChildItems(localDataArgs.result, ulElement, fields);
                            if (_this.getInitialData) {
                                _this.getInitialData = false;
                                _this.preventPopupOpen = false;
                                return;
                            }
                            setTimeout(function() {
                                if (_this.getModuleName() === "multiselect" && _this.itemTemplate != null && ulElement.childElementCount > 0 && (ulElement.children[0].childElementCount > 0 || _this.fields.groupBy && ulElement.children[1] && ulElement.children[1].childElementCount > 0)) _this.updateDataList();
                            });
                        }
                    });
                }
            }
        });
    };
    DropDownBase.prototype.handleVirtualKeyboardActions = function(e, pageCount) {
    // Used this method in component side.
    };
    DropDownBase.prototype.updatePopupState = function() {
    // Used this method in component side.
    };
    DropDownBase.prototype.virtualSelectionAll = function(state, li, event) {
    // Used this method in component side.
    };
    DropDownBase.prototype.updateRemoteData = function() {
        this.setListData(this.dataSource, this.fields, this.query);
    };
    DropDownBase.prototype.bindChildItems = function(listItems, ulElement, fields, e) {
        var _this = this;
        if (listItems.length >= 100 && this.getModuleName() === "autocomplete") setTimeout(function() {
            var childNode = _this.remainingItems(_this.sortedData, fields);
            (0, $4ZDHT.append)(childNode, ulElement);
            _this.liCollections = _this.list.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
            _this.updateListValues();
            _this.raiseDataBound(listItems, e);
        }, 0);
        else this.raiseDataBound(listItems, e);
    };
    DropDownBase.prototype.isObjectInArray = function(objectToFind, array) {
        return array.some(function(item) {
            return Object.keys(objectToFind).every(function(key) {
                return Object.prototype.hasOwnProperty.call(item, key) && item[key] === objectToFind[key];
            });
        });
    };
    DropDownBase.prototype.updateListValues = function() {
    // Used this method in component side.
    };
    DropDownBase.prototype.findListElement = function(list, findNode, attribute, value) {
        var liElement = null;
        if (list) {
            var listArr = [].slice.call(list.querySelectorAll(findNode));
            for(var index = 0; index < listArr.length; index++)if (listArr[index].getAttribute(attribute) === value + "") {
                liElement = listArr[index];
                break;
            }
        }
        return liElement;
    };
    DropDownBase.prototype.raiseDataBound = function(listItems, e) {
        this.hideSpinner();
        var dataBoundEventArgs = {
            items: listItems,
            e: e
        };
        this.trigger("dataBound", dataBoundEventArgs);
    };
    DropDownBase.prototype.remainingItems = function(dataSource, fields) {
        var spliceData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().skip(100));
        if (this.itemTemplate) {
            var listElements = this.templateListItem(spliceData, fields);
            return [].slice.call(listElements.childNodes);
        }
        var type = this.typeOfData(spliceData).typeof;
        if (type === "string" || type === "number" || type === "boolean") return (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createListItemFromArray(this.createElement, spliceData, true, this.listOption(spliceData, fields), this);
        return (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createListItemFromJson(this.createElement, spliceData, this.listOption(spliceData, fields), 1, true, this);
    };
    DropDownBase.prototype.emptyDataRequest = function(fields) {
        var listItems = [];
        this.onActionComplete(this.renderItems(listItems, fields), listItems);
        this.isRequested = false;
        this.isRequesting = false;
        this.hideSpinner();
    };
    DropDownBase.prototype.showSpinner = function() {
    // Used this method in component side.
    };
    DropDownBase.prototype.hideSpinner = function() {
    // Used this method in component side.
    };
    DropDownBase.prototype.onActionFailure = function(e) {
        this.liCollections = [];
        this.trigger("actionFailure", e);
        this.l10nUpdate(true);
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) (0, $4ZDHT.addClass)([
            this.list
        ], $8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData);
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ DropDownBase.prototype.onActionComplete = function(ulElement, list, e) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ this.listData = list;
        if (this.isVirtualizationEnabled && !this.isCustomDataUpdated && !this.virtualSelectAll) this.notify("setGeneratedData", {
            module: "VirtualScroll"
        });
        if (this.getModuleName() !== "listbox") ulElement.setAttribute("tabindex", "0");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) this.clearTemplate([
            "itemTemplate",
            "groupTemplate",
            "actionFailureTemplate",
            "noRecordsTemplate"
        ]);
        if (!this.isVirtualizationEnabled) this.fixedHeaderElement = (0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? this.fixedHeaderElement : null;
        if (this.getModuleName() === "multiselect" && this.properties.allowCustomValue && this.fields.groupBy) for(var i = 0; i < ulElement.childElementCount; i++){
            if (ulElement.children[i].classList.contains("e-list-group-item")) {
                if ((0, $3EnZW.isNullOrUndefined)(ulElement.children[i].innerHTML) || ulElement.children[i].innerHTML === "") (0, $4ZDHT.addClass)([
                    ulElement.children[i]
                ], $8333a85b68b3ebf8$var$HIDE_GROUPLIST);
            }
            if (ulElement.children[0].classList.contains("e-hide-group-header")) (0, $4ZDHT.setStyleAttribute)(ulElement.children[1], {
                zIndex: 11
            });
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) {
            if (!this.isVirtualizationEnabled) {
                this.list.innerHTML = "";
                this.list.appendChild(ulElement);
                this.liCollections = this.list.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
                this.ulElement = this.list.querySelector("ul");
                this.postRender(this.list, list, this.bindEvent);
            }
        }
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ DropDownBase.prototype.postRender = function(listElement, list, bindEvent) {
        if (this.fields.disabled) {
            var liCollections = listElement.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
            for(var index = 0; index < liCollections.length; index++)if (JSON.parse(JSON.stringify(this.listData[index]))[this.fields.disabled]) this.disableListItem(liCollections[index]);
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */ var focusItem = this.fields.disabled ? listElement.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li + ":not(.e-disabled") : listElement.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
        var selectedItem = listElement.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.selected);
        if (focusItem && !selectedItem) focusItem.classList.add($8333a85b68b3ebf8$export$caaa541e4c87fe5d.focus);
        if (list.length <= 0) {
            this.l10nUpdate();
            (0, $4ZDHT.addClass)([
                listElement
            ], $8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData);
        } else listElement.classList.remove($8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData);
    };
    /**
     * Get the query to do the data operation before list item generation.
     *
     * @param {Query} query - Accepts the external Query that execute along with data processing.
     * @returns {Query} Returns the query to do the data query operation.
     */ DropDownBase.prototype.getQuery = function(query) {
        return query ? query : this.query ? this.query : new (0, $56262f229d1cff45$export$62297b13309008b2)();
    };
    DropDownBase.prototype.updateVirtualizationProperties = function(itemCount, filtering, isCheckbox) {
        this.isVirtualizationEnabled = true;
        this.virtualizedItemsCount = itemCount;
        this.isAllowFiltering = filtering;
        this.isCheckBoxSelection = isCheckbox;
    };
    /**
     * To render the template content for group header element.
     *
     * @param {HTMLElement} listEle - Specifies the group list elements.
     * @returns {void}
     */ DropDownBase.prototype.renderGroupTemplate = function(listEle) {
        if (this.fields.groupBy !== null && this.dataSource || this.element.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.group)) {
            var dataSource = this.dataSource;
            var option = {
                groupTemplateID: this.groupTemplateId,
                isStringTemplate: this.isStringTemplate
            };
            var headerItems = listEle.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.group);
            var groupcheck = this.templateCompiler(this.groupTemplate);
            if (typeof this.groupTemplate !== "function" && groupcheck) {
                var groupValue = (0, $4ZDHT.select)(this.groupTemplate, document).innerHTML.trim();
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var tempHeaders = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).renderGroupTemplate(groupValue, dataSource, this.fields.properties, headerItems, option, this);
                //EJ2-55168- Group checkbox is not working with group template
                if (this.isGroupChecking) for(var i = 0; i < tempHeaders.length; i++)this.notify("addItem", {
                    module: "CheckBoxSelection",
                    item: tempHeaders[i]
                });
            } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var tempHeaders = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).renderGroupTemplate(this.groupTemplate, dataSource, this.fields.properties, headerItems, option, this);
                //EJ2-55168- Group checkbox is not working with group template
                if (this.isGroupChecking) for(var i = 0; i < tempHeaders.length; i++)this.notify("addItem", {
                    module: "CheckBoxSelection",
                    item: tempHeaders[i]
                });
            }
            this.renderReactTemplates();
        }
    };
    /**
     * To create the ul li list items
     *
     * @param {object []} dataSource - Specifies the data to generate the list.
     * @param {FieldSettingsModel} fields - Maps the columns of the data table and binds the data to the component.
     * @returns {HTMLElement} Return the ul li list items.
     */ DropDownBase.prototype.createListItems = function(dataSource, fields) {
        if (dataSource) {
            if (fields.groupBy || this.element.querySelector("optgroup")) {
                if (fields.groupBy) {
                    if (this.sortOrder !== "None") dataSource = this.getSortedDataSource(dataSource);
                    dataSource = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).groupDataSource(dataSource, fields.properties, this.sortOrder);
                }
                (0, $4ZDHT.addClass)([
                    this.list
                ], $8333a85b68b3ebf8$export$caaa541e4c87fe5d.grouping);
            } else if (this.getModuleName() !== "listbox" || this.getModuleName() === "listbox" && !this.preventDefActionFilter) dataSource = this.getSortedDataSource(dataSource);
            var options = this.listOption(dataSource, fields);
            var spliceData = dataSource.length > 100 ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().take(100)) : dataSource;
            this.sortedData = dataSource;
            return (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, this.getModuleName() === "autocomplete" ? spliceData : dataSource, options, true, this);
        }
        return null;
    };
    DropDownBase.prototype.listOption = function(dataSource, fields) {
        var iconCss = (0, $3EnZW.isNullOrUndefined)(fields.iconCss) ? false : true;
        var fieldValues = !(0, $3EnZW.isNullOrUndefined)(fields.properties) ? fields.properties : fields;
        var options = fields.text !== null || fields.value !== null ? {
            fields: fieldValues,
            showIcon: iconCss,
            ariaAttributes: {
                groupItemRole: "presentation"
            }
        } : {
            fields: {
                value: "text"
            }
        };
        return (0, $3EnZW.extend)({}, options, fields, true);
    };
    DropDownBase.prototype.setFloatingHeader = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.list) && !this.list.classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData)) {
            if ((0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement)) {
                this.fixedHeaderElement = this.createElement("div", {
                    className: $8333a85b68b3ebf8$export$caaa541e4c87fe5d.fixedHead
                });
                if (!(0, $3EnZW.isNullOrUndefined)(this.list) && !this.list.querySelector("li").classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.group)) this.fixedHeaderElement.style.display = "none";
                if (!(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) && !(0, $3EnZW.isNullOrUndefined)(this.list)) (0, $4ZDHT.prepend)([
                    this.fixedHeaderElement
                ], this.list);
                this.setFixedHeader();
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) && this.fixedHeaderElement.style.zIndex === "0") this.setFixedHeader();
            this.scrollStop(e);
        }
    };
    DropDownBase.prototype.scrollStop = function(e, isDownkey) {
        var target = !(0, $3EnZW.isNullOrUndefined)(e) ? e.target : this.list;
        var liHeight = parseInt(getComputedStyle(this.getValidLi(), null).getPropertyValue("height"), 10);
        var topIndex = Math.round(target.scrollTop / liHeight);
        var liCollections = this.list.querySelectorAll("li:not(.e-hide-listitem)");
        var virtualListCount = this.list.querySelectorAll(".e-virtual-list").length;
        var count = 0;
        var isCount = false;
        for(var i = topIndex; i > -1; i--){
            var index = this.isVirtualizationEnabled ? i + virtualListCount : i;
            if (this.isVirtualizationEnabled) {
                if (isCount) count++;
                if (this.fixedHeaderElement && this.updateGroupHeader(index, liCollections, target)) break;
                if (isDownkey) {
                    if (!(0, $3EnZW.isNullOrUndefined)(liCollections[index]) && liCollections[index].classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.selected) && this.getModuleName() !== "autocomplete" || !(0, $3EnZW.isNullOrUndefined)(liCollections[index]) && liCollections[index].classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.focus) && this.getModuleName() === "autocomplete") {
                        count++;
                        isCount = true;
                    }
                }
            } else {
                if (this.updateGroupHeader(index, liCollections, target)) break;
            }
        }
    };
    DropDownBase.prototype.getPageCount = function(returnExactCount) {
        if (this.list) {
            var liHeight = this.list.classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData) ? null : getComputedStyle(this.getItems()[0], null).getPropertyValue("height");
            var pageCount = Math.round(this.list.getBoundingClientRect().height / parseInt(liHeight, 10));
            return returnExactCount ? pageCount : Math.round(pageCount);
        } else return 0;
    };
    DropDownBase.prototype.updateGroupHeader = function(index, liCollections, target) {
        if (!(0, $3EnZW.isNullOrUndefined)(liCollections[index]) && liCollections[index].classList.contains($8333a85b68b3ebf8$export$caaa541e4c87fe5d.group)) {
            this.updateGroupFixedHeader(liCollections[index], target);
            return true;
        } else {
            this.fixedHeaderElement.style.display = "none";
            this.fixedHeaderElement.style.top = "none";
            return false;
        }
    };
    DropDownBase.prototype.updateGroupFixedHeader = function(element, target) {
        if (this.fixedHeaderElement) {
            if (!(0, $3EnZW.isNullOrUndefined)(element.innerHTML)) this.fixedHeaderElement.innerHTML = element.innerHTML;
            this.fixedHeaderElement.style.position = "fixed";
            this.fixedHeaderElement.style.top = this.list.parentElement.offsetTop + this.list.offsetTop - window.scrollY + "px";
            this.fixedHeaderElement.style.display = "block";
        }
    };
    DropDownBase.prototype.getValidLi = function() {
        if (this.isVirtualizationEnabled) return this.liCollections[0].classList.contains("e-virtual-list") ? this.liCollections[this.skeletonCount] : this.liCollections[0];
        return this.liCollections[0];
    };
    /**
     * To render the list items
     *
     * @param {object[]} listData - Specifies the list of array of data.
     * @param {FieldSettingsModel} fields - Maps the columns of the data table and binds the data to the component.
     * @param {boolean} isCheckBoxUpdate - Specifies whether the list item is updated with checkbox.
     * @returns {HTMLElement} Return the list items.
     */ DropDownBase.prototype.renderItems = function(listData, fields, isCheckBoxUpdate) {
        var ulElement;
        if (this.itemTemplate && listData) {
            if (this.getModuleName() === "multiselect" && this.virtualSelectAll) {
                this.virtualSelectAllData = listData;
                listData = listData.slice(this.virtualItemStartIndex, this.virtualItemEndIndex);
            }
            var dataSource = listData;
            if (dataSource && fields.groupBy) {
                if (this.sortOrder !== "None") dataSource = this.getSortedDataSource(dataSource);
                dataSource = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).groupDataSource(dataSource, fields.properties, this.sortOrder);
            } else if (this.getModuleName() !== "listbox" || this.getModuleName() === "listbox" && !this.preventDefActionFilter) dataSource = this.getSortedDataSource(dataSource);
            this.sortedData = dataSource;
            var spliceData = dataSource.length > 100 ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().take(100)) : dataSource;
            ulElement = this.templateListItem(this.getModuleName() === "autocomplete" ? spliceData : dataSource, fields);
            if (this.isVirtualizationEnabled) {
                var oldUlElement = this.list.querySelector(".e-list-parent");
                var virtualUlElement = this.list.querySelector(".e-virtual-ddl-content");
                if (listData.length >= this.virtualizedItemsCount && oldUlElement && virtualUlElement || oldUlElement && virtualUlElement && this.isAllowFiltering || oldUlElement && virtualUlElement && this.getModuleName() === "autocomplete") {
                    virtualUlElement.replaceChild(ulElement, oldUlElement);
                    var reOrderList = this.list.querySelectorAll(".e-reorder");
                    if (this.list.querySelector(".e-virtual-ddl-content") && reOrderList && reOrderList.length > 0 && !isCheckBoxUpdate) this.list.querySelector(".e-virtual-ddl-content").removeChild(reOrderList[0]);
                    this.updateListElements(listData);
                } else if (!virtualUlElement) {
                    this.list.innerHTML = "";
                    this.createVirtualContent();
                    this.list.querySelector(".e-virtual-ddl-content").appendChild(ulElement);
                    this.updateListElements(listData);
                }
            }
        } else {
            if (this.getModuleName() === "multiselect" && this.virtualSelectAll) {
                this.virtualSelectAllData = listData;
                listData = listData.slice(this.virtualItemStartIndex, this.virtualItemEndIndex);
            }
            ulElement = this.createListItems(listData, fields);
            if (this.isIncrementalRequest) {
                this.incrementalLiCollections = ulElement.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
                this.incrementalUlElement = ulElement;
                this.incrementalListData = listData;
                return ulElement;
            }
            if (this.isVirtualizationEnabled) {
                var oldUlElement = this.list.querySelector(".e-list-parent:not(.e-reorder)");
                var virtualUlElement = this.list.querySelector(".e-virtual-ddl-content");
                var isRemovedUlelement = false;
                if (!oldUlElement && this.list.querySelector(".e-list-parent.e-reorder")) oldUlElement = this.list.querySelector(".e-list-parent.e-reorder");
                if (listData.length >= this.virtualizedItemsCount && oldUlElement && virtualUlElement || oldUlElement && virtualUlElement && this.isAllowFiltering || oldUlElement && virtualUlElement && (this.getModuleName() === "autocomplete" || this.getModuleName() === "multiselect") || isRemovedUlelement) {
                    if (!this.appendUncheckList) virtualUlElement.replaceChild(ulElement, oldUlElement);
                    else virtualUlElement.appendChild(ulElement);
                    this.updateListElements(listData);
                } else if (!virtualUlElement || !virtualUlElement.firstChild) {
                    this.list.innerHTML = "";
                    this.createVirtualContent();
                    this.list.querySelector(".e-virtual-ddl-content").appendChild(ulElement);
                    this.updateListElements(listData);
                }
            }
        }
        return ulElement;
    };
    DropDownBase.prototype.createVirtualContent = function() {
        if (!this.list.querySelector(".e-virtual-ddl-content")) this.list.appendChild(this.createElement("div", {
            className: "e-virtual-ddl-content"
        }));
    };
    DropDownBase.prototype.updateListElements = function(listData) {
        this.liCollections = this.list.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
        this.ulElement = this.list.querySelector("ul");
        this.listData = listData;
        this.postRender(this.list, listData, this.bindEvent);
    };
    DropDownBase.prototype.templateListItem = function(dataSource, fields) {
        var option = this.listOption(dataSource, fields);
        option.templateID = this.itemTemplateId;
        option.isStringTemplate = this.isStringTemplate;
        var itemcheck = this.templateCompiler(this.itemTemplate);
        var ulElement;
        if (typeof this.itemTemplate !== "function" && itemcheck) {
            var itemValue = (0, $4ZDHT.select)(this.itemTemplate, document).innerHTML.trim();
            ulElement = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).renderContentTemplate(this.createElement, itemValue, dataSource, fields.properties, option, this);
            if (this.isVirtualizationEnabled && this.isReact) this.renderReactTemplates();
            return ulElement;
        } else {
            ulElement = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).renderContentTemplate(this.createElement, this.itemTemplate, dataSource, fields.properties, option, this);
            if (this.isVirtualizationEnabled && this.isReact) this.renderReactTemplates();
            return ulElement;
        }
    };
    DropDownBase.prototype.typeOfData = function(items) {
        var item = {
            typeof: null,
            item: null
        };
        for(var i = 0; !(0, $3EnZW.isNullOrUndefined)(items) && i < items.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(items[i])) {
            var listDataType = typeof items[i] === "string" || typeof items[i] === "number" || typeof items[i] === "boolean";
            var isNullData = listDataType ? (0, $3EnZW.isNullOrUndefined)(items[i]) : (0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", items[i]));
            if (!isNullData) return item = {
                typeof: typeof items[i],
                item: items[i]
            };
        }
        return item;
    };
    DropDownBase.prototype.setFixedHeader = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) this.list.parentElement.style.display = "block";
        var borderWidth = 0;
        if (this.list && this.list.parentElement) {
            borderWidth = parseInt(document.defaultView.getComputedStyle(this.list.parentElement, null).getPropertyValue("border-width"), 10);
            /*Shorthand property not working in Firefox for getComputedStyle method.
            Refer bug report https://bugzilla.mozilla.org/show_bug.cgi?id=137688
            Refer alternate solution https://stackoverflow.com/a/41696234/9133493*/ if (isNaN(borderWidth)) {
                var borderTopWidth = parseInt(document.defaultView.getComputedStyle(this.list.parentElement, null).getPropertyValue("border-top-width"), 10);
                var borderBottomWidth = parseInt(document.defaultView.getComputedStyle(this.list.parentElement, null).getPropertyValue("border-bottom-width"), 10);
                var borderLeftWidth = parseInt(document.defaultView.getComputedStyle(this.list.parentElement, null).getPropertyValue("border-left-width"), 10);
                var borderRightWidth = parseInt(document.defaultView.getComputedStyle(this.list.parentElement, null).getPropertyValue("border-right-width"), 10);
                borderWidth = borderTopWidth + borderBottomWidth + borderLeftWidth + borderRightWidth;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.liCollections)) {
            var liWidth = this.getValidLi().offsetWidth - borderWidth;
            this.fixedHeaderElement.style.width = liWidth.toString() + "px";
        }
        (0, $4ZDHT.setStyleAttribute)(this.fixedHeaderElement, {
            zIndex: 10
        });
        var firstLi = this.ulElement.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.group + ":not(.e-hide-listitem)");
        this.fixedHeaderElement.innerHTML = firstLi.innerHTML;
    };
    DropDownBase.prototype.getSortedDataSource = function(dataSource) {
        if (dataSource && this.sortOrder !== "None") {
            var textField = this.fields.text ? this.fields.text : "text";
            if (this.typeOfData(dataSource).typeof === "string" || this.typeOfData(dataSource).typeof === "number" || this.typeOfData(dataSource).typeof === "boolean") textField = "";
            dataSource = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).getDataSource(dataSource, (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).addSorting(this.sortOrder, textField));
        }
        return dataSource;
    };
    /**
     * Return the index of item which matched with given value in data source
     *
     * @param {string | number | boolean} value - Specifies given value.
     * @returns {number} Returns the index of the item.
     */ DropDownBase.prototype.getIndexByValue = function(value) {
        var index;
        var listItems = [];
        if (this.fields.disabled && this.getModuleName() === "multiselect" && this.liCollections) listItems = this.liCollections;
        else listItems = this.getItems();
        for(var i = 0; i < listItems.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(value) && listItems[i].getAttribute("data-value") === value.toString()) {
            index = i;
            break;
        }
        return index;
    };
    /**
     * Return the index of item which matched with given value in data source
     *
     * @param {string | number | boolean} value - Specifies given value.
     * @param {HTMLElement} ulElement - Specifies given value.
     * @returns {number} Returns the index of the item.
     */ DropDownBase.prototype.getIndexByValueFilter = function(value, ulElement) {
        var index;
        if (!ulElement) return null;
        var listItems = ulElement.querySelectorAll("li:not(.e-list-group-item)");
        if (listItems) {
            for(var i = 0; i < listItems.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(value) && listItems[i].getAttribute("data-value") === value.toString()) {
                index = i;
                break;
            }
        }
        return index;
    };
    /**
     * To dispatch the event manually
     *
     * @param {HTMLElement} element - Specifies the element to dispatch the event.
     * @param {string} type - Specifies the name of the event.
     * @returns {void}
     */ DropDownBase.prototype.dispatchEvent = function(element, type) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(type, false, true);
        if (element) element.dispatchEvent(evt);
    };
    /**
     * To set the current fields
     *
     * @returns {void}
     */ DropDownBase.prototype.setFields = function() {
        if (this.fields.value && !this.fields.text) this.updateFields(this.fields.value, this.fields.value);
        else if (!this.fields.value && this.fields.text) this.updateFields(this.fields.text, this.fields.text);
        else if (!this.fields.value && !this.fields.text) this.updateFields("text", "text");
    };
    /**
     * reset the items list.
     *
     * @param {Object[] | string[] | number[] | DataManager | boolean[]} dataSource - Specifies the data to generate the list.
     * @param {FieldSettingsModel} fields - Maps the columns of the data table and binds the data to the component.
     * @param {Query} query - Accepts the external Query that execute along with data processing.
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} e - Specifies the event.
     * @returns {void}
     */ DropDownBase.prototype.resetList = function(dataSource, fields, query, e) {
        if (this.list) {
            if (this.element.tagName === "SELECT" && this.element.options.length > 0 || this.element.tagName === "UL" && this.element.childNodes.length > 0) {
                var data = dataSource instanceof Array ? dataSource.length > 0 : !(0, $3EnZW.isNullOrUndefined)(dataSource);
                if (!data && this.selectData && this.selectData.length > 0) dataSource = this.selectData;
            }
            dataSource = this.getModuleName() === "combobox" && this.selectData && dataSource instanceof Array && dataSource.length < this.selectData.length && this.addedNewItem ? this.selectData : dataSource;
            this.addedNewItem = false;
            this.setListData(dataSource, fields, query, e);
        }
    };
    DropDownBase.prototype.updateSelectElementData = function(isFiltering) {
        if ((isFiltering || this.isVirtualizationEnabled) && (0, $3EnZW.isNullOrUndefined)(this.selectData) && this.listData && this.listData.length > 0) this.selectData = this.listData;
    };
    DropDownBase.prototype.updateSelection = function() {
    // This is for after added the item, need to update the selected index values.
    };
    DropDownBase.prototype.renderList = function() {
        // This is for render the list items.
        this.render();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownBase.prototype.updateDataSource = function(props, oldProps) {
        this.resetList(this.dataSource);
        this.totalItemCount = this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? this.dataSource.dataSource.json.length : 0;
    };
    DropDownBase.prototype.setUpdateInitial = function(props, newProp, oldProp) {
        this.isDataFetched = false;
        var updateData = {};
        for(var j = 0; props.length > j; j++){
            if (newProp[props[j]] && props[j] === "fields") {
                this.setFields();
                updateData[props[j]] = newProp[props[j]];
            } else if (newProp[props[j]]) updateData[props[j]] = newProp[props[j]];
        }
        if (Object.keys(updateData).length > 0) {
            if (Object.keys(updateData).indexOf("dataSource") === -1) updateData.dataSource = this.dataSource;
            if (this.getModuleName() === "listbox") {
                if (!this.isReact || this.isReact && !(0, $3EnZW.isNullOrUndefined)(newProp.dataSource)) this.updateDataSource(updateData, oldProp);
            } else this.updateDataSource(updateData, oldProp);
        }
    };
    /**
     * When property value changes happened, then onPropertyChanged method will execute the respective changes in this component.
     *
     * @param {DropDownBaseModel} newProp - Returns the dynamic property value of the component.
     * @param {DropDownBaseModel} oldProp - Returns the previous property value of the component.
     * @private
     * @returns {void}
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownBase.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (this.getModuleName() === "dropdownbase") this.setUpdateInitial([
            "fields",
            "query",
            "dataSource"
        ], newProp);
        this.setUpdateInitial([
            "sortOrder",
            "itemTemplate"
        ], newProp);
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "query":
                case "sortOrder":
                case "dataSource":
                case "itemTemplate":
                    break;
                case "enableRtl":
                    this.setEnableRtl();
                    break;
                case "groupTemplate":
                    this.renderGroupTemplate(this.list);
                    if (this.ulElement && this.fixedHeaderElement) {
                        var firstLi = this.ulElement.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.group);
                        this.fixedHeaderElement.innerHTML = firstLi.innerHTML;
                    }
                    break;
                case "locale":
                    if (this.list && !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && this.liCollections.length === 0) this.l10nUpdate();
                    break;
                case "zIndex":
                    this.setProperties({
                        zIndex: newProp.zIndex
                    }, true);
                    this.setZIndex();
                    break;
            }
        }
    };
    /**
     * Build and render the component
     *
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} e - Specifies the event.
     * @param {boolean} isEmptyData - Specifies the component to initialize with list data or not.
     * @private
     * @returns {void}
     */ DropDownBase.prototype.render = function(e, isEmptyData) {
        if (this.getModuleName() === "listbox") this.list = this.createElement("div", {
            className: $8333a85b68b3ebf8$export$caaa541e4c87fe5d.content,
            attrs: {
                "tabindex": "0"
            }
        });
        else this.list = this.createElement("div", {
            className: $8333a85b68b3ebf8$export$caaa541e4c87fe5d.content
        });
        this.list.classList.add($8333a85b68b3ebf8$export$caaa541e4c87fe5d.root);
        this.setFields();
        var rippleModel = {
            duration: 300,
            selector: "." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li
        };
        this.rippleFun = (0, $kj1BR.rippleEffect)(this.list, rippleModel);
        var group = this.element.querySelector("select>optgroup");
        if ((this.fields.groupBy || !(0, $3EnZW.isNullOrUndefined)(group)) && !this.isGroupChecking) {
            (0, $aqzbR.EventHandler).add(this.list, "scroll", this.setFloatingHeader, this);
            (0, $aqzbR.EventHandler).add(document, "scroll", this.updateGroupFixedHeader, this);
        }
        if (this.getModuleName() === "dropdownbase") {
            if (this.element.getAttribute("tabindex")) this.list.setAttribute("tabindex", this.element.getAttribute("tabindex"));
            (0, $4ZDHT.removeClass)([
                this.element
            ], $8333a85b68b3ebf8$export$caaa541e4c87fe5d.root);
            this.element.style.display = "none";
            var wrapperElement = this.createElement("div");
            this.element.parentElement.insertBefore(wrapperElement, this.element);
            wrapperElement.appendChild(this.element);
            wrapperElement.appendChild(this.list);
        }
        this.setEnableRtl();
        if (!isEmptyData) this.initialize(e);
    };
    DropDownBase.prototype.removeScrollEvent = function() {
        if (this.list) (0, $aqzbR.EventHandler).remove(this.list, "scroll", this.setFloatingHeader);
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ DropDownBase.prototype.getModuleName = function() {
        return "dropdownbase";
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets all the list items bound on this component.
     *
     * @returns {Element[]}
     */ DropDownBase.prototype.getItems = function() {
        return this.ulElement.querySelectorAll("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Adds a new item to the popup list. By default, new item appends to the list as the last item,
     * but you can insert based on the index parameter.
     *
     * @param { Object[] } items - Specifies an array of JSON data or a JSON data.
     * @param { number } itemIndex - Specifies the index to place the newly added item in the popup list.
     * @returns {void}

     */ DropDownBase.prototype.addItem = function(items, itemIndex) {
        if (!this.list || this.list.textContent === this.noRecordsTemplate && this.getModuleName() !== "listbox") this.renderList();
        if (this.sortOrder !== "None" && (0, $3EnZW.isNullOrUndefined)(itemIndex)) {
            var newList = [].slice.call(this.listData);
            newList.push(items);
            newList = this.getSortedDataSource(newList);
            if (this.fields.groupBy) {
                newList = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).groupDataSource(newList, this.fields.properties, this.sortOrder);
                itemIndex = newList.indexOf(items);
            } else itemIndex = newList.indexOf(items);
        }
        var itemsCount = this.getItems().length;
        var isListboxEmpty = itemsCount === 0;
        var selectedItemValue = this.list.querySelector("." + $8333a85b68b3ebf8$export$caaa541e4c87fe5d.selected);
        items = items instanceof Array ? items : [
            items
        ];
        var index;
        index = (0, $3EnZW.isNullOrUndefined)(itemIndex) || itemIndex < 0 || itemIndex > itemsCount - 1 ? itemsCount : itemIndex;
        var fields = this.fields;
        if (items && fields.groupBy) items = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).groupDataSource(items, fields.properties);
        var liCollections = [];
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            var isHeader = item.isHeader;
            var li = this.createElement("li", {
                className: isHeader ? $8333a85b68b3ebf8$export$caaa541e4c87fe5d.group : $8333a85b68b3ebf8$export$caaa541e4c87fe5d.li,
                id: "option-add-" + i
            });
            var itemText = item instanceof Object ? (0, $3EnZW.getValue)(fields.text, item) : item;
            if (isHeader) li.innerText = itemText;
            if (this.itemTemplate && !isHeader) {
                var itemCheck = this.templateCompiler(this.itemTemplate);
                var compiledString = typeof this.itemTemplate !== "function" && itemCheck ? (0, $c2qqN.compile)((0, $4ZDHT.select)(this.itemTemplate, document).innerHTML.trim()) : (0, $c2qqN.compile)(this.itemTemplate);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var addItemTemplate = compiledString(item, this, "itemTemplate", this.itemTemplateId, this.isStringTemplate, null, li);
                if (addItemTemplate) (0, $4ZDHT.append)(addItemTemplate, li);
            } else if (!isHeader) li.appendChild(document.createTextNode(itemText));
            li.setAttribute("data-value", item instanceof Object ? (0, $3EnZW.getValue)(fields.value, item) : item);
            li.setAttribute("role", "option");
            this.notify("addItem", {
                module: "CheckBoxSelection",
                item: li
            });
            liCollections.push(li);
            if (this.getModuleName() === "listbox") {
                this.listData.splice(isListboxEmpty ? this.listData.length : index, 0, item);
                if (this.listData.length !== this.sortedData.length) this.sortedData = this.listData;
            } else this.listData.push(item);
            if (this.sortOrder === "None" && (0, $3EnZW.isNullOrUndefined)(itemIndex) && index === 0) index = null;
            if (this.getModuleName() === "listbox") this.updateActionCompleteData(li, item, isListboxEmpty ? null : index + i);
            else this.updateActionCompleteData(li, item, index);
            //Listbox event
            this.trigger("beforeItemRender", {
                element: li,
                item: item
            });
        }
        if (itemsCount === 0 && (0, $3EnZW.isNullOrUndefined)(this.list.querySelector("ul"))) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.list)) {
                this.list.innerHTML = "";
                this.list.classList.remove($8333a85b68b3ebf8$export$caaa541e4c87fe5d.noData);
                this.isAddNewItemTemplate = true;
                if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement)) this.list.appendChild(this.ulElement);
            }
            this.liCollections = liCollections;
            if (!(0, $3EnZW.isNullOrUndefined)(liCollections) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement)) (0, $4ZDHT.append)(liCollections, this.ulElement);
            this.updateAddItemList(this.list, itemsCount);
        } else {
            if (this.getModuleName() === "listbox" && itemsCount === 0) this.ulElement.innerHTML = "";
            var attr = [];
            for(var i = 0; i < items.length; i++){
                var listGroupItem = this.ulElement.querySelectorAll(".e-list-group-item");
                for(var j = 0; j < listGroupItem.length; j++)attr[j] = listGroupItem[j].innerText;
                if (attr.indexOf(liCollections[i].innerText) > -1 && fields.groupBy) {
                    for(var j = 0; j < listGroupItem.length; j++)if (attr[j] === liCollections[i].innerText) {
                        if (this.sortOrder === "None") this.ulElement.insertBefore(liCollections[i + 1], listGroupItem[j + 1]);
                        else this.ulElement.insertBefore(liCollections[i + 1], this.ulElement.childNodes[itemIndex]);
                        i = i + 1;
                        break;
                    }
                } else {
                    if (this.liCollections[index] && this.liCollections[index].parentNode) this.liCollections[index].parentNode.insertBefore(liCollections[i], this.liCollections[index]);
                    else if (itemIndex && this.getModuleName() === "listbox") this.ulElement.insertBefore(liCollections[i], this.ulElement.childNodes[itemIndex + i]);
                    else this.ulElement.appendChild(liCollections[i]);
                }
                var tempLi = [].slice.call(this.liCollections);
                tempLi.splice(index, 0, liCollections[i]);
                this.liCollections = tempLi;
                index += 1;
                if (this.getModuleName() === "multiselect") this.updateDataList();
            }
        }
        if (this.getModuleName() === "listbox" && this.isReact) this.renderReactTemplates();
        if (selectedItemValue || itemIndex === 0) this.updateSelection();
        this.addedNewItem = true;
    };
    /**
     * Checks if the given HTML element is disabled.
     *
     * @param {HTMLElement} li - The HTML element to check.
     * @returns {boolean} - Returns true if the element is disabled, otherwise false.
     */ DropDownBase.prototype.isDisabledElement = function(li) {
        if (li && li.classList.contains("e-disabled")) return true;
        return false;
    };
    /**
     * Checks whether the list item at the specified index is disabled.
     *
     * @param {number} index - The index of the list item to check.
     * @returns {boolean} True if the list item is disabled, false otherwise.
     */ DropDownBase.prototype.isDisabledItemByIndex = function(index) {
        if (this.fields.disabled && this.liCollections) return this.isDisabledElement(this.liCollections[index]);
        return false;
    };
    /**
     * Disables the given list item.
     *
     * @param { HTMLLIElement } li - The list item to disable.
     * @returns {void}
     */ DropDownBase.prototype.disableListItem = function(li) {
        li.classList.add("e-disabled");
        li.setAttribute("aria-disabled", "true");
        li.setAttribute("aria-selected", "false");
    };
    DropDownBase.prototype.validationAttribute = function(target, hidden) {
        var name = target.getAttribute("name") ? target.getAttribute("name") : target.getAttribute("id");
        hidden.setAttribute("name", name);
        target.removeAttribute("name");
        var attributes = [
            "required",
            "aria-required",
            "form"
        ];
        for(var i = 0; i < attributes.length; i++){
            if (!target.getAttribute(attributes[i])) continue;
            var attr = target.getAttribute(attributes[i]);
            hidden.setAttribute(attributes[i], attr);
            target.removeAttribute(attributes[i]);
        }
    };
    DropDownBase.prototype.setZIndex = function() {
    // this is for component wise
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownBase.prototype.updateActionCompleteData = function(li, item, index) {
    // this is for ComboBox custom value
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownBase.prototype.updateAddItemList = function(list, itemCount) {
    // this is for multiselect add item
    };
    DropDownBase.prototype.updateDataList = function() {
    // this is for multiselect update list items
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the data Object that matches the given value.
     *
     * @param { string | number } value - Specifies the value of the list item.
     * @returns {Object}
     */ DropDownBase.prototype.getDataByValue = function(value) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.listData)) {
            var type = this.typeOfData(this.listData).typeof;
            if (type === "string" || type === "number" || type === "boolean") for(var _i = 0, _a = this.listData; _i < _a.length; _i++){
                var item = _a[_i];
                if (!(0, $3EnZW.isNullOrUndefined)(item) && item === value) return item;
            }
            else for(var _b = 0, _c = this.listData; _b < _c.length; _b++){
                var item = _c[_b];
                if (!(0, $3EnZW.isNullOrUndefined)(item) && (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", item) === value) return item;
            }
        }
        return null;
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Removes the component from the DOM and detaches all its related event handlers. It also removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ DropDownBase.prototype.destroy = function() {
        if (document) {
            (0, $aqzbR.EventHandler).remove(document, "scroll", this.updateGroupFixedHeader);
            if (document.body.contains(this.list)) {
                (0, $aqzbR.EventHandler).remove(this.list, "scroll", this.setFloatingHeader);
                if (!(0, $3EnZW.isNullOrUndefined)(this.rippleFun)) this.rippleFun();
                (0, $4ZDHT.detach)(this.list);
            }
        }
        this.liCollections = null;
        this.ulElement = null;
        this.list = null;
        this.enableRtlElements = null;
        this.rippleFun = null;
        _super.prototype.destroy.call(this);
    };
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Complex)({
            text: null,
            value: null,
            iconCss: null,
            groupBy: null,
            disabled: null
        }, $8333a85b68b3ebf8$export$47acbd07e937cc3e)
    ], DropDownBase.prototype, "fields", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownBase.prototype, "itemTemplate", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownBase.prototype, "groupTemplate", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)("No records found")
    ], DropDownBase.prototype, "noRecordsTemplate", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)("Request failed")
    ], DropDownBase.prototype, "actionFailureTemplate", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], DropDownBase.prototype, "sortOrder", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)([])
    ], DropDownBase.prototype, "dataSource", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownBase.prototype, "query", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)("StartsWith")
    ], DropDownBase.prototype, "filterType", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DropDownBase.prototype, "ignoreCase", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], DropDownBase.prototype, "zIndex", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownBase.prototype, "ignoreAccent", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Property)()
    ], DropDownBase.prototype, "locale", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "actionBegin", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "actionComplete", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "actionFailure", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "select", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "dataBound", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "created", void 0);
    $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownBase.prototype, "destroyed", void 0);
    DropDownBase = $8333a85b68b3ebf8$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], DropDownBase);
    return DropDownBase;
}((0, $hQxLN.Component));



var $e5d35cabace4110f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e5d35cabace4110f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5d35cabace4110f$export$9787c7b65ab00376 = {
    root: "e-dropdownlist",
    hover: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover,
    selected: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected,
    rtl: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).rtl,
    li: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li,
    disable: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).disabled,
    base: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).root,
    focus: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus,
    content: (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).content,
    input: "e-input-group",
    inputFocus: "e-input-focus",
    icon: "e-input-group-icon e-ddl-icon",
    iconAnimation: "e-icon-anim",
    value: "e-input-value",
    device: "e-ddl-device",
    backIcon: "e-input-group-icon e-back-icon e-icons",
    filterBarClearIcon: "e-input-group-icon e-clear-icon e-icons",
    filterInput: "e-input-filter",
    filterParent: "e-filter-parent",
    mobileFilter: "e-ddl-device-filter",
    footer: "e-ddl-footer",
    header: "e-ddl-header",
    clearIcon: "e-clear-icon",
    clearIconHide: "e-clear-icon-hide",
    popupFullScreen: "e-popup-full-page",
    disableIcon: "e-ddl-disable-icon",
    hiddenElement: "e-ddl-hidden",
    virtualList: "e-list-item e-virtual-list"
};
var $e5d35cabace4110f$var$inputObject = {
    container: null,
    buttons: []
};
/**
 * The DropDownList component contains a list of predefined values from which you can
 * choose a single value.
 * ```html
 * <input type="text" tabindex="1" id="list"> </input>
 * ```
 * ```typescript
 *   let dropDownListObj:DropDownList = new DropDownList();
 *   dropDownListObj.appendTo("#list");
 * ```
 */ var $e5d35cabace4110f$export$85ff158bc62a78c8 = /** @class */ function(_super) {
    $e5d35cabace4110f$var$__extends(DropDownList, _super);
    /**
     * * Constructor for creating the DropDownList component.
     *
     * @param {DropDownListModel} options - Specifies the DropDownList model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function DropDownList(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isListSearched = false;
        _this.preventChange = false;
        _this.isTouched = false;
        _this.isFocused = false;
        _this.autoFill = false;
        return _this;
    }
    /**
     * Initialize the event handler.
     *
     * @private
     * @returns {void}
     */ DropDownList.prototype.preRender = function() {
        this.valueTempElement = null;
        this.element.style.opacity = "0";
        this.initializeData();
        _super.prototype.preRender.call(this);
        this.activeIndex = this.index;
        this.queryString = "";
    };
    DropDownList.prototype.initializeData = function() {
        this.isPopupOpen = false;
        this.isDocumentClick = false;
        this.isInteracted = false;
        this.isFilterFocus = false;
        this.beforePopupOpen = false;
        this.initial = true;
        this.initialRemoteRender = false;
        this.isNotSearchList = false;
        this.isTyped = false;
        this.isSelected = false;
        this.preventFocus = false;
        this.preventAutoFill = false;
        this.isValidKey = false;
        this.typedString = "";
        this.isEscapeKey = false;
        this.isPreventBlur = false;
        this.isTabKey = false;
        this.actionCompleteData = {
            isUpdated: false
        };
        this.actionData = {
            isUpdated: false
        };
        this.prevSelectPoints = {};
        this.isSelectCustom = false;
        this.isDropDownClick = false;
        this.preventAltUp = false;
        this.isCustomFilter = false;
        this.isSecondClick = false;
        this.previousValue = null;
        this.keyConfigure = {
            tab: "tab",
            enter: "13",
            escape: "27",
            end: "35",
            home: "36",
            down: "40",
            up: "38",
            pageUp: "33",
            pageDown: "34",
            open: "alt+40",
            close: "shift+tab",
            hide: "alt+38",
            space: "32"
        };
        this.viewPortInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: this.itemCount
        };
    };
    DropDownList.prototype.setZIndex = function() {
        if (this.popupObj) this.popupObj.setProperties({
            "zIndex": this.zIndex
        });
    };
    DropDownList.prototype.requiredModules = function() {
        var modules = [];
        if (this.enableVirtualization) modules.push({
            args: [
                this
            ],
            member: "VirtualScroll"
        });
        return modules;
    };
    DropDownList.prototype.renderList = function(e, isEmptyData) {
        _super.prototype.render.call(this, e, isEmptyData);
        if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        if (this.enableVirtualization && this.isFiltering() && this.getModuleName() === "combobox") {
            this.UpdateSkeleton();
            this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
            this.ulElement = this.list.querySelector("ul");
        }
        this.unWireListEvents();
        this.wireListEvents();
    };
    DropDownList.prototype.floatLabelChange = function() {
        if (this.getModuleName() === "dropdownlist" && this.floatLabelType === "Auto") {
            var floatElement = this.inputWrapper.container.querySelector(".e-float-text");
            if (this.inputElement.value !== "" || this.isInteracted) (0, $4ZDHT.classList)(floatElement, [
                "e-label-top"
            ], [
                "e-label-bottom"
            ]);
            else (0, $4ZDHT.classList)(floatElement, [
                "e-label-bottom"
            ], [
                "e-label-top"
            ]);
        }
    };
    DropDownList.prototype.resetHandler = function(e) {
        e.preventDefault();
        this.clearAll(e);
        if (this.enableVirtualization) {
            this.list.scrollTop = 0;
            this.virtualListInfo = null;
            this.previousStartIndex = 0;
            this.previousEndIndex = 0;
        }
    };
    DropDownList.prototype.resetFocusElement = function() {
        this.removeHover();
        this.removeSelection();
        this.removeFocus();
        this.list.scrollTop = 0;
        if (this.getModuleName() !== "autocomplete" && !(0, $3EnZW.isNullOrUndefined)(this.ulElement)) {
            var li = this.fields.disabled ? this.ulElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.li + ":not(.e-disabled)") : this.ulElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.li);
            if (this.enableVirtualization) li = this.liCollections[this.skeletonCount];
            if (li) li.classList.add($e5d35cabace4110f$export$9787c7b65ab00376.focus);
        }
    };
    DropDownList.prototype.clearAll = function(e, properties) {
        this.previousItemData = !(0, $3EnZW.isNullOrUndefined)(this.itemData) ? this.itemData : null;
        if ((0, $3EnZW.isNullOrUndefined)(properties) || !(0, $3EnZW.isNullOrUndefined)(properties) && ((0, $3EnZW.isNullOrUndefined)(properties.dataSource) || !(properties.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && properties.dataSource.length === 0)) {
            this.isActive = true;
            this.resetSelection(properties);
        }
        var dataItem = this.getItemData();
        if (!this.allowObjectBinding && this.previousValue === dataItem.value || this.allowObjectBinding && this.previousValue && this.isObjectInArray(this.previousValue, [
            this.allowCustom ? this.value ? this.value : dataItem : dataItem.value ? this.getDataByValue(dataItem.value) : dataItem
        ])) return;
        this.onChangeEvent(e);
        this.checkAndResetCache();
        if (this.enableVirtualization) this.updateInitialData();
    };
    DropDownList.prototype.resetSelection = function(properties) {
        if (this.list) {
            if (!(0, $3EnZW.isNullOrUndefined)(properties) && ((0, $3EnZW.isNullOrUndefined)(properties.dataSource) || !(properties.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && properties.dataSource.length === 0)) {
                this.selectedLI = null;
                this.actionCompleteData.isUpdated = false;
                this.actionCompleteData.ulElement = null;
                this.actionCompleteData.list = null;
                this.resetList(properties.dataSource);
            } else {
                if (this.allowFiltering && this.getModuleName() !== "autocomplete" && !(0, $3EnZW.isNullOrUndefined)(this.actionCompleteData.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.actionCompleteData.list) && this.actionCompleteData.list.length > 0) this.onActionComplete(this.actionCompleteData.ulElement.cloneNode(true), this.actionCompleteData.list);
                this.resetFocusElement();
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.hiddenElement)) this.hiddenElement.innerHTML = "";
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) this.inputElement.value = "";
        this.value = null;
        this.itemData = null;
        this.text = null;
        this.index = null;
        this.activeIndex = null;
        this.item = null;
        this.queryString = "";
        if (this.valueTempElement) {
            (0, $4ZDHT.detach)(this.valueTempElement);
            this.inputElement.style.display = "block";
            this.valueTempElement = null;
        }
        this.setSelection(null, null);
        this.isSelectCustom = false;
        this.updateIconState();
        this.cloneElements();
    };
    DropDownList.prototype.setHTMLAttributes = function() {
        if (Object.keys(this.htmlAttributes).length) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var htmlAttr = _a[_i];
            if (htmlAttr === "class") {
                var updatedClassValue = this.htmlAttributes["" + htmlAttr].replace(/\s+/g, " ").trim();
                if (updatedClassValue !== "") (0, $4ZDHT.addClass)([
                    this.inputWrapper.container
                ], updatedClassValue.split(" "));
            } else if (htmlAttr === "disabled" && this.htmlAttributes["" + htmlAttr] === "disabled") {
                this.enabled = false;
                this.setEnable();
            } else if (htmlAttr === "readonly" && !(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes["" + htmlAttr])) {
                this.readonly = true;
                this.dataBind();
            } else if (htmlAttr === "style") this.inputWrapper.container.setAttribute("style", this.htmlAttributes["" + htmlAttr]);
            else if (htmlAttr === "aria-label") {
                if ((this.getModuleName() === "autocomplete" || this.getModuleName() === "combobox") && !this.readonly) this.inputElement.setAttribute("aria-label", this.htmlAttributes["" + htmlAttr]);
                else if (this.getModuleName() === "dropdownlist") this.inputWrapper.container.setAttribute("aria-label", this.htmlAttributes["" + htmlAttr]);
            } else {
                var defaultAttr = [
                    "title",
                    "id",
                    "placeholder",
                    "role",
                    "autocomplete",
                    "autocapitalize",
                    "spellcheck",
                    "minlength",
                    "maxlength"
                ];
                var validateAttr = [
                    "name",
                    "required"
                ];
                if (this.getModuleName() === "autocomplete" || this.getModuleName() === "combobox") defaultAttr.push("tabindex");
                if (validateAttr.indexOf(htmlAttr) > -1 || htmlAttr.indexOf("data") === 0) this.hiddenElement.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                else if (defaultAttr.indexOf(htmlAttr) > -1) {
                    if (htmlAttr === "placeholder") (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.htmlAttributes["" + htmlAttr], this.inputElement);
                    else this.inputElement.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                } else this.inputWrapper.container.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
            }
        }
        if (this.getModuleName() === "autocomplete" || this.getModuleName() === "combobox") this.inputWrapper.container.removeAttribute("tabindex");
    };
    DropDownList.prototype.getAriaAttributes = function() {
        return {
            "aria-disabled": "false",
            "role": "combobox",
            "aria-expanded": "false",
            "aria-live": "polite",
            "aria-labelledby": this.hiddenElement.id
        };
    };
    DropDownList.prototype.setEnableRtl = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(this.enableRtl, [
            this.inputElement.parentElement
        ]);
        if (this.popupObj) {
            this.popupObj.enableRtl = this.enableRtl;
            this.popupObj.dataBind();
        }
    };
    DropDownList.prototype.setEnable = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.inputElement);
        if (this.enabled) {
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], $e5d35cabace4110f$export$9787c7b65ab00376.disable);
            this.inputElement.setAttribute("aria-disabled", "false");
            this.targetElement().setAttribute("tabindex", this.tabIndex);
            if (this.inputWrapper && this.inputWrapper.container) {
                this.inputWrapper.container.setAttribute("aria-disabled", "false");
                this.inputWrapper.container.removeAttribute("disabled");
            }
        } else {
            this.hidePopup();
            (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], $e5d35cabace4110f$export$9787c7b65ab00376.disable);
            this.inputElement.setAttribute("aria-disabled", "true");
            this.targetElement().tabIndex = -1;
            if (this.inputWrapper && this.inputWrapper.container) {
                this.inputWrapper.container.setAttribute("aria-disabled", "true");
                this.inputWrapper.container.setAttribute("disabled", "");
            }
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} Returns the persisted data of the component.
     */ DropDownList.prototype.getPersistData = function() {
        return this.addOnPersist([
            "value"
        ]);
    };
    DropDownList.prototype.getLocaleName = function() {
        return "drop-down-list";
    };
    DropDownList.prototype.preventTabIndex = function(element) {
        if (this.getModuleName() === "dropdownlist") element.tabIndex = -1;
    };
    DropDownList.prototype.targetElement = function() {
        return !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) ? this.inputWrapper.container : null;
    };
    DropDownList.prototype.getNgDirective = function() {
        return "EJS-DROPDOWNLIST";
    };
    DropDownList.prototype.getElementByText = function(text) {
        return this.getElementByValue(this.getValueByText(text));
    };
    DropDownList.prototype.getElementByValue = function(value) {
        var item;
        var listItems = this.getItems();
        for(var _i = 0, listItems_1 = listItems; _i < listItems_1.length; _i++){
            var liItem = listItems_1[_i];
            if (this.getFormattedValue(liItem.getAttribute("data-value")) === value) {
                item = liItem;
                break;
            }
        }
        return item;
    };
    DropDownList.prototype.initValue = function() {
        this.viewPortInfo.startIndex = this.virtualItemStartIndex = 0;
        this.viewPortInfo.endIndex = this.virtualItemEndIndex = this.itemCount;
        this.renderList();
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.initialRemoteRender = true;
        else this.updateValues();
    };
    /**
     * Checks if the given value is disabled.
     *
     * @param { string | number | boolean | object } value - The value to check for disablement. Can be a string, number, boolean, or object.
     * @returns { boolean } A boolean indicating whether the value is disabled.
     */ DropDownList.prototype.isDisableItemValue = function(value) {
        if (typeof value === "object") {
            var objectValue = JSON.parse(JSON.stringify(value))[this.fields.value];
            return this.isDisabledItemByIndex(this.getIndexByValue(objectValue));
        }
        return this.isDisabledItemByIndex(this.getIndexByValue(value));
    };
    DropDownList.prototype.updateValues = function() {
        if (this.fields.disabled) {
            if (this.value != null) this.value = !this.isDisableItemValue(this.value) ? this.value : null;
            if (this.text != null) this.text = !this.isDisabledItemByIndex(this.getIndexByValue(this.getValueByText(this.text))) ? this.text : null;
            if (this.index != null) {
                this.index = !this.isDisabledItemByIndex(this.index) ? this.index : null;
                this.activeIndex = this.index;
            }
        }
        this.selectedValueInfo = this.viewPortInfo;
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
            this.setSelection(this.getElementByValue(value), null);
        } else if (this.text && (0, $3EnZW.isNullOrUndefined)(this.value)) {
            var element = this.getElementByText(this.text);
            if ((0, $3EnZW.isNullOrUndefined)(element)) {
                this.setProperties({
                    text: null
                });
                return;
            } else this.setSelection(element, null);
        } else this.setSelection(this.liCollections[this.activeIndex], null);
        this.setHiddenValue();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
    };
    DropDownList.prototype.onBlurHandler = function(e) {
        if (!this.enabled) return;
        var target = e.relatedTarget;
        var currentTarget = e.target;
        var isPreventBlur = this.isPreventBlur;
        this.isPreventBlur = false;
        //IE 11 - issue
        if (isPreventBlur && !this.isDocumentClick && this.isPopupOpen && (!(0, $3EnZW.isNullOrUndefined)(currentTarget) || !this.isFilterLayout() && (0, $3EnZW.isNullOrUndefined)(target))) {
            if (this.getModuleName() === "dropdownlist" && this.allowFiltering && this.isPopupOpen) this.filterInput.focus();
            else this.targetElement().focus();
            return;
        }
        if (this.isDocumentClick || !(0, $3EnZW.isNullOrUndefined)(this.popupObj) && document.body.contains(this.popupObj.element) && this.popupObj.element.classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.mobileFilter)) {
            if (!this.beforePopupOpen) this.isDocumentClick = false;
            return;
        }
        if (this.getModuleName() === "dropdownlist" && !this.isFilterFocus && target !== this.inputElement && (document.activeElement !== target || document.activeElement === target && currentTarget.classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.inputFocus)) || (0, $3EnZW.isNullOrUndefined)(target) && this.getModuleName() === "dropdownlist" && this.allowFiltering && currentTarget !== this.inputWrapper.container || this.getModuleName() !== "dropdownlist" && !this.inputWrapper.container.contains(target) || this.isTabKey) {
            this.isDocumentClick = this.isPopupOpen ? true : false;
            this.focusOutAction(e);
            this.isTabKey = false;
        }
        if (this.isRequested && !this.isPopupOpen && !this.isPreventBlur) {
            this.isActive = false;
            this.beforePopupOpen = false;
        }
        this.isFocused = false;
    };
    DropDownList.prototype.focusOutAction = function(e) {
        this.isInteracted = false;
        this.focusOut(e);
        this.onFocusOut(e);
    };
    DropDownList.prototype.onFocusOut = function(e) {
        if (!this.enabled) return;
        if (this.isSelected) {
            this.isSelectCustom = false;
            this.onChangeEvent(e);
        }
        this.floatLabelChange();
        this.dispatchEvent(this.hiddenElement, "change");
        if (this.getModuleName() === "dropdownlist" && this.element.tagName !== "INPUT") this.dispatchEvent(this.inputElement, "blur");
        if (this.inputWrapper.clearButton) (0, $4ZDHT.addClass)([
            this.inputWrapper.clearButton
        ], $e5d35cabace4110f$export$9787c7b65ab00376.clearIconHide);
        this.trigger("blur");
    };
    DropDownList.prototype.onFocus = function(e) {
        if (!this.isInteracted) {
            this.isInteracted = true;
            var args = {
                isInteracted: e ? true : false,
                event: e
            };
            this.trigger("focus", args);
        }
        this.updateIconState();
        this.isFocused = true;
    };
    DropDownList.prototype.resetValueHandler = function(e) {
        var formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
        if (formElement && e.target === formElement) {
            var val = this.element.tagName === this.getNgDirective() ? null : this.inputElement.getAttribute("value");
            this.text = val;
        }
    };
    DropDownList.prototype.wireEvent = function() {
        (0, $aqzbR.EventHandler).add(this.inputWrapper.container, "mousedown", this.dropDownClick, this);
        (0, $aqzbR.EventHandler).add(this.inputWrapper.container, "focus", this.focusIn, this);
        (0, $aqzbR.EventHandler).add(this.inputWrapper.container, "keypress", this.onSearch, this);
        (0, $aqzbR.EventHandler).add(window, "resize", this.windowResize, this);
        this.bindCommonEvent();
    };
    DropDownList.prototype.bindCommonEvent = function() {
        (0, $aqzbR.EventHandler).add(this.targetElement(), "blur", this.onBlurHandler, this);
        var formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
        if (formElement) (0, $aqzbR.EventHandler).add(formElement, "reset", this.resetValueHandler, this);
        if (!(0, $5q7BP.Browser).isDevice) this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.targetElement(), {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigure,
            eventName: "keydown"
        });
        else this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.targetElement(), {
            keyAction: this.mobileKeyActionHandler.bind(this),
            keyConfigs: this.keyConfigure,
            eventName: "keydown"
        });
        this.bindClearEvent();
    };
    DropDownList.prototype.windowResize = function() {
        if (this.isPopupOpen) this.popupObj.refreshPosition(this.inputWrapper.container);
    };
    DropDownList.prototype.bindClearEvent = function() {
        if (this.showClearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown", this.resetHandler, this);
    };
    DropDownList.prototype.unBindCommonEvent = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && this.targetElement()) (0, $aqzbR.EventHandler).remove(this.targetElement(), "blur", this.onBlurHandler);
        var formElement = this.inputElement && (0, $4ZDHT.closest)(this.inputElement, "form");
        if (formElement) (0, $aqzbR.EventHandler).remove(formElement, "reset", this.resetValueHandler);
        if (!(0, $5q7BP.Browser).isDevice) this.keyboardModule.destroy();
        if (this.showClearButton) (0, $aqzbR.EventHandler).remove(this.inputWrapper.clearButton, "mousedown", this.resetHandler);
    };
    DropDownList.prototype.updateIconState = function() {
        if (this.showClearButton) {
            if (this.inputElement.value !== "" && !this.readonly) (0, $4ZDHT.removeClass)([
                this.inputWrapper.clearButton
            ], $e5d35cabace4110f$export$9787c7b65ab00376.clearIconHide);
            else (0, $4ZDHT.addClass)([
                this.inputWrapper.clearButton
            ], $e5d35cabace4110f$export$9787c7b65ab00376.clearIconHide);
        }
    };
    /**
     * Event binding for list
     *
     * @returns {void}
     */ DropDownList.prototype.wireListEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) {
            (0, $aqzbR.EventHandler).add(this.list, "click", this.onMouseClick, this);
            (0, $aqzbR.EventHandler).add(this.list, "mouseover", this.onMouseOver, this);
            (0, $aqzbR.EventHandler).add(this.list, "mouseout", this.onMouseLeave, this);
        }
    };
    DropDownList.prototype.onSearch = function(e) {
        if (e.charCode !== 32 && e.charCode !== 13) {
            if (this.list === undefined) this.renderList();
            this.searchKeyEvent = e;
            this.onServerIncrementalSearch(e);
        }
    };
    DropDownList.prototype.onServerIncrementalSearch = function(e) {
        if (!this.isRequested && !(0, $3EnZW.isNullOrUndefined)(this.list) && !(0, $3EnZW.isNullOrUndefined)(this.list.querySelector("li")) && this.enabled && !this.readonly) this.incrementalSearch(e);
    };
    DropDownList.prototype.onMouseClick = function(e) {
        var target = e.target;
        this.keyboardEvent = null;
        var li = (0, $4ZDHT.closest)(target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        if (!this.isValidLI(li) || this.isDisabledElement(li)) return;
        this.setSelection(li, e);
        if ((0, $5q7BP.Browser).isDevice && this.isFilterLayout()) history.back();
        else {
            var delay = 100;
            this.closePopup(delay, e);
        }
    };
    DropDownList.prototype.onMouseOver = function(e) {
        var currentLi = (0, $4ZDHT.closest)(e.target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        this.setHover(currentLi);
    };
    DropDownList.prototype.setHover = function(li) {
        if (this.enabled && this.isValidLI(li) && !li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover)) {
            this.removeHover();
            (0, $4ZDHT.addClass)([
                li
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        }
    };
    DropDownList.prototype.onMouseLeave = function() {
        this.removeHover();
    };
    DropDownList.prototype.removeHover = function() {
        if (this.list) {
            var hoveredItem = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
            if (hoveredItem && hoveredItem.length) (0, $4ZDHT.removeClass)(hoveredItem, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        }
    };
    DropDownList.prototype.isValidLI = function(li) {
        return li && li.hasAttribute("role") && li.getAttribute("role") === "option";
    };
    DropDownList.prototype.updateIncrementalItemIndex = function(startIndex, endIndex) {
        this.incrementalStartIndex = startIndex;
        this.incrementalEndIndex = endIndex;
    };
    DropDownList.prototype.incrementalSearch = function(e) {
        if (this.liCollections.length > 0) {
            if (this.enableVirtualization) {
                var updatingincrementalindex = false;
                var queryStringUpdated = false;
                var activeElement = this.ulElement.getElementsByClassName("e-active")[0];
                var currentValue = activeElement ? activeElement.textContent : null;
                if (this.incrementalQueryString === "") {
                    this.incrementalQueryString = String.fromCharCode(e.charCode);
                    this.incrementalPreQueryString = this.incrementalQueryString;
                } else if (String.fromCharCode(e.charCode).toLocaleLowerCase() === this.incrementalPreQueryString.toLocaleLowerCase()) queryStringUpdated = true;
                else this.incrementalQueryString = String.fromCharCode(e.charCode);
                if (this.viewPortInfo.endIndex >= this.incrementalEndIndex && this.incrementalEndIndex <= this.totalItemCount || this.incrementalEndIndex === 0) {
                    updatingincrementalindex = true;
                    this.incrementalStartIndex = this.incrementalEndIndex;
                    if (this.incrementalEndIndex === 0) this.incrementalEndIndex = 100 > this.totalItemCount ? this.totalItemCount : 100;
                    else this.incrementalEndIndex = this.incrementalEndIndex + 100 > this.totalItemCount ? this.totalItemCount : this.incrementalEndIndex + 100;
                    this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                    updatingincrementalindex = true;
                }
                if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                var li = (0, $2b58887f1686dbd7$export$1421c86d5777695b)(e.charCode, this.incrementalLiCollections, this.activeIndex, true, this.element.id, queryStringUpdated, currentValue, true);
                while((0, $3EnZW.isNullOrUndefined)(li) && this.incrementalEndIndex < this.totalItemCount){
                    this.updateIncrementalItemIndex(this.incrementalEndIndex, this.incrementalEndIndex + 100 > this.totalItemCount ? this.totalItemCount : this.incrementalEndIndex + 100);
                    this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                    updatingincrementalindex = true;
                    if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                    li = (0, $2b58887f1686dbd7$export$1421c86d5777695b)(e.charCode, this.incrementalLiCollections, 0, true, this.element.id, queryStringUpdated, currentValue, true, true);
                    if (!(0, $3EnZW.isNullOrUndefined)(li)) break;
                    if ((0, $3EnZW.isNullOrUndefined)(li) && this.incrementalEndIndex >= this.totalItemCount) {
                        this.updateIncrementalItemIndex(0, 100 > this.totalItemCount ? this.totalItemCount : 100);
                        break;
                    }
                }
                if ((0, $3EnZW.isNullOrUndefined)(li) && this.incrementalEndIndex >= this.totalItemCount) {
                    this.updateIncrementalItemIndex(0, 100 > this.totalItemCount ? this.totalItemCount : 100);
                    this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                    updatingincrementalindex = true;
                    if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                    li = (0, $2b58887f1686dbd7$export$1421c86d5777695b)(e.charCode, this.incrementalLiCollections, 0, true, this.element.id, queryStringUpdated, currentValue, true, true);
                }
                var index = li && this.getIndexByValue(li.getAttribute("data-value"));
                if (!index) {
                    for(var i = 0; i < this.incrementalLiCollections.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(li) && !(0, $3EnZW.isNullOrUndefined)(li.getAttribute("data-value")) && this.incrementalLiCollections[i].getAttribute("data-value") === li.getAttribute("data-value").toString()) {
                        index = i;
                        index = this.incrementalStartIndex + index;
                        break;
                    }
                } else index = index - this.skeletonCount;
                if (index) {
                    if (!(this.viewPortInfo.startIndex >= index) || !(index >= this.viewPortInfo.endIndex)) {
                        var startIndex = index - (this.itemCount / 2 - 2) > 0 ? index - (this.itemCount / 2 - 2) : 0;
                        var endIndex = this.viewPortInfo.startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : this.viewPortInfo.startIndex + this.itemCount;
                        this.updateIncrementalView(startIndex, endIndex);
                    }
                }
                if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                    var index_1 = this.getIndexByValue(li.getAttribute("data-value")) - this.skeletonCount;
                    if (index_1 > this.itemCount / 2) {
                        var startIndex = this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) < this.totalItemCount ? this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) : this.totalItemCount;
                        var endIndex = this.viewPortInfo.startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : this.viewPortInfo.startIndex + this.itemCount;
                        this.updateIncrementalView(startIndex, endIndex);
                    }
                    li = this.getElementByValue(li.getAttribute("data-value"));
                    this.setSelection(li, e);
                    this.setScrollPosition();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                    if (this.enableVirtualization && !this.fields.groupBy) {
                        var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.selectedLI.offsetTop + this.virtualListInfo.startIndex * this.selectedLI.offsetHeight : this.selectedLI.offsetTop;
                        this.list.scrollTop = selectedLiOffsetTop - this.list.querySelectorAll(".e-virtual-list").length * this.selectedLI.offsetHeight;
                    }
                    this.incrementalPreQueryString = this.incrementalQueryString;
                } else {
                    this.updateIncrementalView(0, this.itemCount);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                    this.list.scrollTop = 0;
                }
            } else {
                var li = void 0;
                if (this.fields.disabled) {
                    var enableLiCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-disabled)");
                    li = (0, $2b58887f1686dbd7$export$1421c86d5777695b)(e.charCode, enableLiCollections, this.activeIndex, true, this.element.id);
                } else li = (0, $2b58887f1686dbd7$export$1421c86d5777695b)(e.charCode, this.liCollections, this.activeIndex, true, this.element.id);
                if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                    this.setSelection(li, e);
                    this.setScrollPosition();
                }
            }
        }
    };
    /**
     * Hides the spinner loader.
     *
     * @returns {void}
     */ DropDownList.prototype.hideSpinner = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinnerElement);
            (0, $4ZDHT.removeClass)([
                this.spinnerElement
            ], $e5d35cabace4110f$export$9787c7b65ab00376.disableIcon);
            this.spinnerElement.innerHTML = "";
            this.spinnerElement = null;
        }
    };
    /**
     * Shows the spinner loader.
     *
     * @returns {void}
     */ DropDownList.prototype.showSpinner = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            this.spinnerElement = (0, $5q7BP.Browser).isDevice && !(0, $3EnZW.isNullOrUndefined)(this.filterInputObj) && this.filterInputObj.buttons[1] || !(0, $3EnZW.isNullOrUndefined)(this.filterInputObj) && this.filterInputObj.buttons[0] || this.inputWrapper.buttons[0];
            (0, $4ZDHT.addClass)([
                this.spinnerElement
            ], $e5d35cabace4110f$export$9787c7b65ab00376.disableIcon);
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.spinnerElement,
                width: (0, $5q7BP.Browser).isDevice ? "16px" : "14px"
            }, this.createElement);
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinnerElement);
        }
    };
    DropDownList.prototype.keyActionHandler = function(e) {
        if (!this.enabled) return;
        this.keyboardEvent = e;
        if (this.isPreventKeyAction && this.enableVirtualization) e.preventDefault();
        var preventAction = e.action === "pageUp" || e.action === "pageDown";
        var preventHomeEnd = this.getModuleName() !== "dropdownlist" && (e.action === "home" || e.action === "end");
        this.isEscapeKey = e.action === "escape";
        this.isTabKey = !this.isPopupOpen && e.action === "tab";
        var isNavigation = e.action === "down" || e.action === "up" || e.action === "pageUp" || e.action === "pageDown" || e.action === "home" || e.action === "end";
        if ((this.isEditTextBox() || preventAction || preventHomeEnd) && !this.isPopupOpen) return;
        if (!this.readonly) {
            var isTabAction = e.action === "tab" || e.action === "close";
            if ((0, $3EnZW.isNullOrUndefined)(this.list) && !this.isRequested && !isTabAction && e.action !== "escape") {
                this.searchKeyEvent = e;
                if (!this.enableVirtualization || this.enableVirtualization && this.getModuleName() !== "autocomplete" && e.type !== "mousedown" && (e.keyCode === 40 || e.keyCode === 38)) {
                    this.renderList(e);
                    this.UpdateSkeleton();
                    this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                    this.ulElement = this.list.querySelector("ul");
                }
            }
            if ((0, $3EnZW.isNullOrUndefined)(this.list) || !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && isNavigation && this.liCollections.length === 0 || this.isRequested) return;
            if (isTabAction && this.getModuleName() !== "autocomplete" && this.isPopupOpen || e.action === "escape") e.preventDefault();
            this.isSelected = e.action === "escape" ? false : this.isSelected;
            this.isTyped = isNavigation || e.action === "escape" ? false : this.isTyped;
            switch(e.action){
                case "down":
                case "up":
                    this.updateUpDownAction(e);
                    break;
                case "pageUp":
                    this.pageUpSelection(this.activeIndex - this.getPageCount(), e);
                    e.preventDefault();
                    break;
                case "pageDown":
                    this.pageDownSelection(this.activeIndex + this.getPageCount(), e);
                    e.preventDefault();
                    break;
                case "home":
                    this.isMouseScrollAction = true;
                    this.updateHomeEndAction(e);
                    break;
                case "end":
                    this.isMouseScrollAction = true;
                    this.updateHomeEndAction(e);
                    break;
                case "space":
                    if (this.getModuleName() === "dropdownlist") {
                        if (!this.beforePopupOpen) {
                            this.showPopup();
                            e.preventDefault();
                        }
                    }
                    break;
                case "open":
                    this.showPopup(e);
                    break;
                case "hide":
                    this.preventAltUp = this.isPopupOpen;
                    this.hidePopup(e);
                    this.focusDropDown(e);
                    break;
                case "enter":
                    this.selectCurrentItem(e);
                    break;
                case "tab":
                    this.selectCurrentValueOnTab(e);
                    break;
                case "escape":
                case "close":
                    if (this.isPopupOpen) {
                        this.hidePopup(e);
                        this.focusDropDown(e);
                    }
                    break;
            }
        }
    };
    DropDownList.prototype.updateUpDownAction = function(e, isVirtualKeyAction) {
        if (this.fields.disabled && this.list && this.list.querySelectorAll(".e-list-item:not(.e-disabled)").length === 0) return;
        if (this.allowFiltering && !this.enableVirtualization && this.getModuleName() !== "autocomplete") {
            var value = this.getItemData().value;
            if ((0, $3EnZW.isNullOrUndefined)(value)) value = "null";
            var filterIndex = this.getIndexByValue(value);
            if (!(0, $3EnZW.isNullOrUndefined)(filterIndex)) this.activeIndex = filterIndex;
        }
        var focusEle = this.list.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.focus);
        if (this.isSelectFocusItem(focusEle) && !isVirtualKeyAction) {
            this.setSelection(focusEle, e);
            if (this.enableVirtualization) {
                var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.selectedLI.offsetTop + this.virtualListInfo.startIndex * this.selectedLI.offsetHeight : this.selectedLI.offsetTop;
                if (this.fields.groupBy) selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex === 0 ? this.selectedLI.offsetHeight - selectedLiOffsetTop : selectedLiOffsetTop - this.selectedLI.offsetHeight;
                this.list.scrollTop = selectedLiOffsetTop - this.list.querySelectorAll(".e-virtual-list").length * this.selectedLI.offsetHeight;
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.liCollections)) {
            var virtualIndex = this.activeIndex;
            var index = e.action === "down" ? this.activeIndex + 1 : this.activeIndex - 1;
            index = isVirtualKeyAction ? virtualIndex : index;
            var startIndex = 0;
            if (this.getModuleName() === "autocomplete") {
                startIndex = e.action === "down" && (0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? 0 : this.liCollections.length - 1;
                index = index < 0 ? this.liCollections.length - 1 : index === this.liCollections.length ? 0 : index;
            }
            var nextItem = void 0;
            if (this.getModuleName() !== "autocomplete" || this.getModuleName() === "autocomplete" && this.isPopupOpen) {
                if (!this.enableVirtualization) nextItem = (0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? this.liCollections[startIndex] : this.liCollections[index];
                else {
                    if (!isVirtualKeyAction) {
                        nextItem = (0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? this.liCollections[this.skeletonCount] : this.liCollections[index];
                        nextItem = !(0, $3EnZW.isNullOrUndefined)(nextItem) && !nextItem.classList.contains("e-virtual-list") ? nextItem : null;
                    } else if (this.getModuleName() === "autocomplete") {
                        var value = this.getFormattedValue(this.selectedLI.getAttribute("data-value"));
                        nextItem = this.getElementByValue(value);
                    } else nextItem = this.getElementByValue(this.getItemData().value);
                }
            }
            if (!(0, $3EnZW.isNullOrUndefined)(nextItem)) {
                var focusAtFirstElement = this.liCollections[this.skeletonCount] && this.liCollections[this.skeletonCount].classList.contains("e-item-focus");
                this.setSelection(nextItem, e);
                if (focusAtFirstElement && this.enableVirtualization && this.getModuleName() === "autocomplete" && !isVirtualKeyAction) {
                    var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.selectedLI.offsetTop + this.virtualListInfo.startIndex * this.selectedLI.offsetHeight : this.selectedLI.offsetTop;
                    selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex === 0 && this.fields.groupBy ? this.selectedLI.offsetHeight - selectedLiOffsetTop : selectedLiOffsetTop - this.selectedLI.offsetHeight;
                    this.list.scrollTop = selectedLiOffsetTop - this.list.querySelectorAll(".e-virtual-list").length * this.selectedLI.offsetHeight;
                }
            } else if (this.enableVirtualization && !this.isPopupOpen && this.getModuleName() !== "autocomplete" && (this.viewPortInfo.endIndex !== this.totalItemCount && e.action === "down" || this.viewPortInfo.startIndex !== 0 && e.action === "up")) {
                if (e.action === "down") {
                    this.viewPortInfo.startIndex = this.viewPortInfo.startIndex + this.itemCount < this.totalItemCount - this.itemCount ? this.viewPortInfo.startIndex + this.itemCount : this.totalItemCount - this.itemCount;
                    this.viewPortInfo.endIndex = this.viewPortInfo.startIndex + this.itemCount;
                    this.updateVirtualItemIndex();
                    this.isCustomFilter = this.getModuleName() === "combobox" ? true : this.isCustomFilter;
                    this.resetList(this.dataSource, this.fields, this.query);
                    this.isCustomFilter = this.getModuleName() === "combobox" ? false : this.isCustomFilter;
                    var value = this.liCollections[0].getAttribute("data-value") !== "null" ? this.getFormattedValue(this.liCollections[0].getAttribute("data-value")) : null;
                    var selectedData = this.getDataByValue(value);
                    if (selectedData) this.itemData = selectedData;
                } else if (e.action === "up") {
                    this.viewPortInfo.startIndex = this.viewPortInfo.startIndex - this.itemCount > 0 ? this.viewPortInfo.startIndex - this.itemCount : 0;
                    this.viewPortInfo.endIndex = this.viewPortInfo.startIndex + this.itemCount;
                    this.updateVirtualItemIndex();
                    this.isCustomFilter = this.getModuleName() === "combobox" ? true : this.isCustomFilter;
                    this.resetList(this.dataSource, this.fields, this.query);
                    this.isCustomFilter = this.getModuleName() === "combobox" ? false : this.isCustomFilter;
                    var value = this.liCollections[this.liCollections.length - 1].getAttribute("data-value") !== "null" ? this.getFormattedValue(this.liCollections[this.liCollections.length - 1].getAttribute("data-value")) : null;
                    var selectedData = this.getDataByValue(value);
                    if (selectedData) this.itemData = selectedData;
                }
                this.UpdateSkeleton();
                this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                this.ulElement = this.list.querySelector("ul");
                this.handleVirtualKeyboardActions(e, this.pageCount);
            }
        }
        if (this.allowFiltering && !this.enableVirtualization && this.getModuleName() !== "autocomplete") {
            var value = this.getItemData().value;
            var filterIndex = this.getIndexByValueFilter(value, this.actionCompleteData.ulElement);
            if (!(0, $3EnZW.isNullOrUndefined)(filterIndex)) this.activeIndex = filterIndex;
        }
        if (this.allowFiltering && this.getModuleName() === "dropdownlist" && this.filterInput) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
            });
            else if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-active")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-active")[0].id
            });
        }
        var itemIndex;
        for(var index = 0; index < this.liCollections.length; index++)if (this.liCollections[index].classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.focus) || this.liCollections[index].classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.selected)) {
            itemIndex = index;
            break;
        }
        if (itemIndex != null && this.isDisabledElement(this.liCollections[itemIndex])) {
            if (this.getModuleName() !== "autocomplete") {
                if (this.liCollections.length - 1 === itemIndex && e.action === "down") e.action = "up";
                if (itemIndex === 0 && e.action === "up") e.action = "down";
            }
            this.updateUpDownAction(e);
        }
        e.preventDefault();
    };
    DropDownList.prototype.updateHomeEndAction = function(e, isVirtualKeyAction) {
        if (this.getModuleName() === "dropdownlist") {
            var findLi = 0;
            if (e.action === "home") {
                findLi = 0;
                if (this.enableVirtualization && this.isPopupOpen) findLi = this.skeletonCount;
                else if (this.enableVirtualization && !this.isPopupOpen && this.viewPortInfo.startIndex !== 0) {
                    this.viewPortInfo.startIndex = 0;
                    this.viewPortInfo.endIndex = this.itemCount;
                    this.updateVirtualItemIndex();
                    this.resetList(this.dataSource, this.fields, this.query);
                }
            } else {
                if (this.enableVirtualization && !this.isPopupOpen && this.viewPortInfo.endIndex !== this.totalItemCount) {
                    this.viewPortInfo.startIndex = this.totalItemCount - this.itemCount;
                    this.viewPortInfo.endIndex = this.totalItemCount;
                    this.updateVirtualItemIndex();
                    this.resetList(this.dataSource, this.fields, this.query);
                }
                findLi = this.getItems().length - 1;
            }
            e.preventDefault();
            if (this.activeIndex === findLi) {
                if (isVirtualKeyAction) this.setSelection(this.liCollections[findLi], e);
                return;
            }
            this.setSelection(this.liCollections[findLi], e);
        }
    };
    DropDownList.prototype.selectCurrentValueOnTab = function(e) {
        if (this.getModuleName() === "autocomplete") this.selectCurrentItem(e);
        else if (this.isPopupOpen) {
            this.hidePopup(e);
            this.focusDropDown(e);
        }
    };
    DropDownList.prototype.mobileKeyActionHandler = function(e) {
        if (!this.enabled) return;
        if (this.isEditTextBox() && !this.isPopupOpen) return;
        if (!this.readonly) {
            if (this.list === undefined && !this.isRequested) {
                this.searchKeyEvent = e;
                this.renderList();
            }
            if ((0, $3EnZW.isNullOrUndefined)(this.list) || !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && this.liCollections.length === 0 || this.isRequested) return;
            if (e.action === "enter") this.selectCurrentItem(e);
        }
    };
    DropDownList.prototype.handleVirtualKeyboardActions = function(e, pageCount) {
        switch(e.action){
            case "down":
            case "up":
                if (this.itemData != null || this.getModuleName() === "autocomplete") this.updateUpDownAction(e, true);
                break;
            case "pageUp":
                this.activeIndex = this.getModuleName() === "autocomplete" ? this.getIndexByValue(this.selectedLI.getAttribute("data-value")) + this.getPageCount() - 1 : this.getIndexByValue(this.previousValue);
                this.pageUpSelection(this.activeIndex - this.getPageCount(), e, true);
                e.preventDefault();
                break;
            case "pageDown":
                this.activeIndex = this.getModuleName() === "autocomplete" ? this.getIndexByValue(this.selectedLI.getAttribute("data-value")) - this.getPageCount() : this.getIndexByValue(this.previousValue);
                this.pageDownSelection(!(0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? this.activeIndex + this.getPageCount() : 2 * this.getPageCount(), e, true);
                e.preventDefault();
                break;
            case "home":
                this.isMouseScrollAction = true;
                this.updateHomeEndAction(e, true);
                break;
            case "end":
                this.isMouseScrollAction = true;
                this.updateHomeEndAction(e, true);
                break;
        }
        this.keyboardEvent = null;
    };
    DropDownList.prototype.selectCurrentItem = function(e) {
        if (this.isPopupOpen) {
            var li = this.list.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.focus);
            if (this.isDisabledElement(li)) return;
            if (li) {
                this.setSelection(li, e);
                this.isTyped = false;
            }
            if (this.isSelected) {
                this.isSelectCustom = false;
                this.onChangeEvent(e);
            }
            this.hidePopup(e);
            this.focusDropDown(e);
        } else this.showPopup();
    };
    DropDownList.prototype.isSelectFocusItem = function(element) {
        return !(0, $3EnZW.isNullOrUndefined)(element);
    };
    DropDownList.prototype.pageUpSelection = function(steps, event, isVirtualKeyAction) {
        var previousItem = steps >= 0 ? this.liCollections[steps + 1] : this.liCollections[0];
        if (this.enableVirtualization && this.activeIndex == null) previousItem = this.liCollections.length >= steps && steps >= 0 ? this.liCollections[steps + this.skeletonCount + 1] : this.liCollections[0];
        if (!(0, $3EnZW.isNullOrUndefined)(previousItem) && previousItem.classList.contains("e-virtual-list")) previousItem = this.liCollections[this.skeletonCount];
        this.PageUpDownSelection(previousItem, event);
        if (this.allowFiltering && this.getModuleName() === "dropdownlist") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
            });
            else if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-active")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-active")[0].id
            });
        }
    };
    DropDownList.prototype.PageUpDownSelection = function(previousItem, event) {
        if (this.enableVirtualization) {
            if (!(0, $3EnZW.isNullOrUndefined)(previousItem) && (this.getModuleName() !== "autocomplete" && !previousItem.classList.contains("e-active") || this.getModuleName() === "autocomplete" && !previousItem.classList.contains("e-item-focus"))) this.setSelection(previousItem, event);
        } else this.setSelection(previousItem, event);
    };
    DropDownList.prototype.pageDownSelection = function(steps, event, isVirtualKeyAction) {
        var list = this.getItems();
        var previousItem = steps <= list.length ? this.liCollections[steps - 1] : this.liCollections[list.length - 1];
        if (this.enableVirtualization && this.skeletonCount > 0) {
            steps = this.getModuleName() === "dropdownlist" && this.allowFiltering ? steps + 1 : steps;
            previousItem = steps < list.length ? this.liCollections[steps] : this.liCollections[list.length - 1];
        }
        if (this.enableVirtualization && this.activeIndex == null) previousItem = steps <= list.length ? this.liCollections[steps + this.skeletonCount - 1] : this.liCollections[list.length - 1];
        this.PageUpDownSelection(previousItem, event);
        if (this.allowFiltering && this.getModuleName() === "dropdownlist") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
            });
            else if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-active")[0])) (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-activedescendant": this.ulElement.getElementsByClassName("e-active")[0].id
            });
        }
    };
    DropDownList.prototype.unWireEvent = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper)) {
            (0, $aqzbR.EventHandler).remove(this.inputWrapper.container, "mousedown", this.dropDownClick);
            (0, $aqzbR.EventHandler).remove(this.inputWrapper.container, "keypress", this.onSearch);
            (0, $aqzbR.EventHandler).remove(this.inputWrapper.container, "focus", this.focusIn);
            (0, $aqzbR.EventHandler).remove(window, "resize", this.windowResize);
        }
        this.unBindCommonEvent();
    };
    /**
     * Event un binding for list items.
     *
     * @returns {void}
     */ DropDownList.prototype.unWireListEvents = function() {
        if (this.list) {
            (0, $aqzbR.EventHandler).remove(this.list, "click", this.onMouseClick);
            (0, $aqzbR.EventHandler).remove(this.list, "mouseover", this.onMouseOver);
            (0, $aqzbR.EventHandler).remove(this.list, "mouseout", this.onMouseLeave);
        }
    };
    DropDownList.prototype.checkSelector = function(id) {
        return '[id="' + id.replace(/(:|\.|\[|\]|,|=|@|\\|\/|#)/g, "\\$1") + '"]';
    };
    DropDownList.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if (!(!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && (0, $4ZDHT.closest)(target, this.checkSelector(this.popupObj.element.id))) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && !this.inputWrapper.container.contains(e.target)) {
            if (this.inputWrapper.container.classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.inputFocus) || this.isPopupOpen) {
                this.isDocumentClick = true;
                var isActive = this.isRequested;
                if (this.getModuleName() === "combobox" && this.isTyped) this.isInteracted = false;
                this.hidePopup(e);
                this.isInteracted = false;
                if (!isActive) {
                    this.onFocusOut(e);
                    this.inputWrapper.container.classList.remove($e5d35cabace4110f$export$9787c7b65ab00376.inputFocus);
                }
            }
        } else if (target !== this.inputElement && !(this.allowFiltering && target === this.filterInput) && !(this.getModuleName() === "combobox" && !this.allowFiltering && (0, $5q7BP.Browser).isDevice && target === this.inputWrapper.buttons[0])) {
            this.isPreventBlur = ((0, $5q7BP.Browser).isIE || (0, $5q7BP.Browser).info.name === "edge") && (document.activeElement === this.targetElement() || document.activeElement === this.filterInput);
            e.preventDefault();
        }
    };
    DropDownList.prototype.activeStateChange = function() {
        if (this.isDocumentClick) {
            this.hidePopup();
            this.onFocusOut();
            this.inputWrapper.container.classList.remove($e5d35cabace4110f$export$9787c7b65ab00376.inputFocus);
        }
    };
    DropDownList.prototype.focusDropDown = function(e) {
        if (!this.initial && this.isFilterLayout()) this.focusIn(e);
    };
    DropDownList.prototype.dropDownClick = function(e) {
        if (e.which === 3 || e.button === 2) return;
        this.keyboardEvent = null;
        if (this.targetElement().classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.disable) || this.inputWrapper.clearButton === e.target) return;
        var target = e.target;
        if (target !== this.inputElement && !(this.allowFiltering && target === this.filterInput) && this.getModuleName() !== "combobox") e.preventDefault();
        if (!this.readonly) {
            if (this.isPopupOpen) {
                this.hidePopup(e);
                if (this.isFilterLayout()) this.focusDropDown(e);
            } else {
                this.focusIn(e);
                this.floatLabelChange();
                this.queryString = this.inputElement.value.trim() === "" ? null : this.inputElement.value;
                this.isDropDownClick = true;
                this.showPopup(e);
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var proxy_1 = this;
            // eslint-disable-next-line max-len
            var duration = this.element.tagName === this.getNgDirective() && this.itemTemplate ? 500 : 100;
            if (!this.isSecondClick) setTimeout(function() {
                proxy_1.cloneElements();
                proxy_1.isSecondClick = true;
            }, duration);
        } else this.focusIn(e);
    };
    DropDownList.prototype.cloneElements = function() {
        if (this.list) {
            var ulElement = this.list.querySelector("ul");
            if (ulElement) {
                ulElement = ulElement.cloneNode ? ulElement.cloneNode(true) : ulElement;
                this.actionCompleteData.ulElement = ulElement;
            }
        }
    };
    DropDownList.prototype.updateSelectedItem = function(li, e, preventSelect, isSelection) {
        var _this = this;
        this.removeSelection();
        li.classList.add((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
        this.removeHover();
        var value = li.getAttribute("data-value") !== null ? this.getFormattedValue(li.getAttribute("data-value")) : null;
        var selectedData = this.getDataByValue(value);
        if (!this.initial && !preventSelect && !(0, $3EnZW.isNullOrUndefined)(e)) {
            var items = this.detachChanges(selectedData);
            this.isSelected = true;
            var eventArgs = {
                e: e,
                item: li,
                itemData: items,
                isInteracted: e ? true : false,
                cancel: false
            };
            this.trigger("select", eventArgs, function(eventArgs) {
                if (eventArgs.cancel) li.classList.remove((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                else {
                    _this.selectEventCallback(li, e, preventSelect, selectedData, value);
                    if (isSelection) _this.setSelectOptions(li, e);
                }
            });
        } else {
            this.selectEventCallback(li, e, preventSelect, selectedData, value);
            if (isSelection) this.setSelectOptions(li, e);
        }
    };
    DropDownList.prototype.selectEventCallback = function(li, e, preventSelect, selectedData, value) {
        this.previousItemData = !(0, $3EnZW.isNullOrUndefined)(this.itemData) ? this.itemData : null;
        if (this.itemData !== selectedData) this.previousValue = !(0, $3EnZW.isNullOrUndefined)(this.itemData) ? typeof this.itemData == "object" && !this.allowObjectBinding ? this.checkFieldValue(this.itemData, this.fields.value.split(".")) : this.itemData : null;
        this.item = li;
        this.itemData = selectedData;
        var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (focusedItem) (0, $4ZDHT.removeClass)([
            focusedItem
        ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        li.setAttribute("aria-selected", "true");
        if ((0, $3EnZW.isNullOrUndefined)(value)) value = "null";
        if (this.allowFiltering && !this.enableVirtualization && this.getModuleName() !== "autocomplete") {
            var filterIndex = this.getIndexByValueFilter(value, this.actionCompleteData.ulElement);
            if (!(0, $3EnZW.isNullOrUndefined)(filterIndex)) this.activeIndex = filterIndex;
            else this.activeIndex = this.getIndexByValue(value);
        } else {
            if (this.enableVirtualization && this.activeIndex == null && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                this.UpdateSkeleton();
                this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                this.ulElement = this.list.querySelector("ul");
            }
            this.activeIndex = this.getIndexByValue(value);
        }
    };
    DropDownList.prototype.activeItem = function(li) {
        if (this.isValidLI(li) && !li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected)) {
            this.removeSelection();
            li.classList.add((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
            this.removeHover();
            li.setAttribute("aria-selected", "true");
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownList.prototype.setValue = function(e) {
        var dataItem = this.getItemData();
        this.isTouched = !(0, $3EnZW.isNullOrUndefined)(e);
        if (dataItem.value === null) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(null, this.inputElement, this.floatLabelType, this.showClearButton);
        else (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(dataItem.text, this.inputElement, this.floatLabelType, this.showClearButton);
        if (this.valueTemplate && this.itemData !== null) this.setValueTemplate();
        else if (!(0, $3EnZW.isNullOrUndefined)(this.valueTempElement) && this.inputElement.previousSibling === this.valueTempElement) {
            (0, $4ZDHT.detach)(this.valueTempElement);
            this.inputElement.style.display = "block";
        }
        if (!(0, $3EnZW.isNullOrUndefined)(dataItem.value) && !this.enableVirtualization && this.allowFiltering) this.activeIndex = this.getIndexByValueFilter(dataItem.value, this.actionCompleteData.ulElement);
        var clearIcon = $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon;
        var isFilterElement = this.isFiltering() && this.filterInput && this.getModuleName() === "combobox";
        var clearElement = isFilterElement && this.filterInput.parentElement.querySelector("." + clearIcon);
        if (this.isFiltering() && clearElement) clearElement.style.removeProperty("visibility");
        if (!this.allowObjectBinding && this.previousValue === dataItem.value || this.allowObjectBinding && this.previousValue != null && this.isObjectInArray(this.previousValue, [
            this.allowCustom && this.isObjectCustomValue ? this.value ? this.value : dataItem : dataItem.value ? this.getDataByValue(dataItem.value) : dataItem
        ])) {
            this.isSelected = false;
            return true;
        } else {
            this.isSelected = !this.initial ? true : false;
            this.isSelectCustom = false;
            if (this.getModuleName() === "dropdownlist") this.updateIconState();
            return false;
        }
    };
    DropDownList.prototype.setSelection = function(li, e) {
        if (this.isValidLI(li) && (!li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected) || this.isPopupOpen && this.isSelected && li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected))) this.updateSelectedItem(li, e, false, true);
        else {
            this.setSelectOptions(li, e);
            if (this.enableVirtualization && this.value) {
                var fields = this.fields.value ? this.fields.value : "";
                var currentValue = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
                if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                    var getItem = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.virtualGroupDataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields, "equal", currentValue)));
                    if (getItem && getItem.length > 0) {
                        this.itemData = getItem[0];
                        var dataItem = this.getItemData();
                        var value = this.allowObjectBinding ? this.getDataByValue(dataItem.value) : dataItem.value;
                        if (this.value === dataItem.value && this.text !== dataItem.text || this.value !== dataItem.value && this.text === dataItem.text) this.setProperties({
                            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
                            "value": value
                        });
                    }
                } else {
                    var getItem = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields, "equal", currentValue)));
                    if (getItem && getItem.length > 0) {
                        this.itemData = getItem[0];
                        var dataItem = this.getItemData();
                        var value = this.allowObjectBinding ? this.getDataByValue(dataItem.value) : dataItem.value;
                        if (this.value === dataItem.value && this.text !== dataItem.text || this.value !== dataItem.value && this.text === dataItem.text) this.setProperties({
                            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
                            "value": value
                        });
                    }
                }
            }
        }
    };
    DropDownList.prototype.setSelectOptions = function(li, e) {
        if (this.list) this.removeHover();
        this.previousSelectedLI = !(0, $3EnZW.isNullOrUndefined)(this.selectedLI) ? this.selectedLI : null;
        this.selectedLI = li;
        if (this.setValue(e)) return;
        if (!this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(li) || this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(e) && (e.type !== "keydown" || e.type === "keydown" && e.action === "enter")) {
            this.isSelectCustom = false;
            this.onChangeEvent(e);
        }
        if (this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(this.selectedLI) && this.itemData !== null && (!e || e.type !== "click")) this.setScrollPosition(e);
        if ((0, $5q7BP.Browser).info.name !== "mozilla") {
            if (this.targetElement()) {
                (0, $4ZDHT.attributes)(this.targetElement(), {
                    "aria-describedby": this.inputElement.id !== "" ? this.inputElement.id : this.element.id
                });
                this.targetElement().removeAttribute("aria-live");
            }
        }
        if (this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.targetElement(), {
            "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
        });
        else if (this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-active")[0])) (0, $4ZDHT.attributes)(this.targetElement(), {
            "aria-activedescendant": this.ulElement.getElementsByClassName("e-active")[0].id
        });
    };
    DropDownList.prototype.dropdownCompiler = function(dropdownTemplate) {
        var checkTemplate = false;
        if (typeof dropdownTemplate !== "function" && dropdownTemplate) try {
            checkTemplate = document.querySelectorAll(dropdownTemplate).length ? true : false;
        } catch (exception) {
            checkTemplate = false;
        }
        return checkTemplate;
    };
    DropDownList.prototype.setValueTemplate = function() {
        var compiledString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) {
            this.clearTemplate([
                "valueTemplate"
            ]);
            if (this.valueTempElement) {
                (0, $4ZDHT.detach)(this.valueTempElement);
                this.inputElement.style.display = "block";
                this.valueTempElement = null;
            }
        }
        if (!this.valueTempElement) {
            this.valueTempElement = this.createElement("span", {
                className: $e5d35cabace4110f$export$9787c7b65ab00376.value
            });
            this.inputElement.parentElement.insertBefore(this.valueTempElement, this.inputElement);
            this.inputElement.style.display = "none";
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) this.valueTempElement.innerHTML = "";
        var valuecheck = this.dropdownCompiler(this.valueTemplate);
        if (typeof this.valueTemplate !== "function" && valuecheck) compiledString = (0, $c2qqN.compile)(document.querySelector(this.valueTemplate).innerHTML.trim());
        else compiledString = (0, $c2qqN.compile)(this.valueTemplate);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var valueCompTemp = compiledString(this.itemData, this, "valueTemplate", this.valueTemplateId, this.isStringTemplate, null, this.valueTempElement);
        if (valueCompTemp && valueCompTemp.length > 0) (0, $4ZDHT.append)(valueCompTemp, this.valueTempElement);
        this.renderReactTemplates();
    };
    DropDownList.prototype.removeSelection = function() {
        if (this.list) {
            var selectedItems = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
            if (selectedItems.length) {
                (0, $4ZDHT.removeClass)(selectedItems, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                selectedItems[0].removeAttribute("aria-selected");
            }
        }
    };
    DropDownList.prototype.getItemData = function() {
        var fields = this.fields;
        var dataItem = null;
        dataItem = this.itemData;
        var dataValue;
        var dataText;
        if (!(0, $3EnZW.isNullOrUndefined)(dataItem)) {
            dataValue = (0, $3EnZW.getValue)(fields.value, dataItem);
            dataText = (0, $3EnZW.getValue)(fields.text, dataItem);
        }
        var value = !(0, $3EnZW.isNullOrUndefined)(dataItem) && !(0, $3EnZW.isUndefined)(dataValue) ? dataValue : dataItem;
        var text = !(0, $3EnZW.isNullOrUndefined)(dataItem) && !(0, $3EnZW.isUndefined)(dataValue) ? dataText : dataItem;
        return {
            value: value,
            text: text
        };
    };
    /**
     * To trigger the change event for list.
     *
     * @param {MouseEvent | KeyboardEvent | TouchEvent} eve - Specifies the event arguments.
     * @param {boolean} isCustomValue - Specifies whether the value is custom value or not.
     * @returns {void}
     */ DropDownList.prototype.onChangeEvent = function(eve, isCustomValue) {
        var _this = this;
        var dataItem = this.getItemData();
        var index = this.isSelectCustom ? null : this.activeIndex;
        if (this.enableVirtualization) {
            var datas = this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? this.virtualGroupDataSource : this.dataSource;
            if (dataItem.value && datas && datas.length > 0) {
                var foundIndex = datas.findIndex(function(data) {
                    return !(0, $3EnZW.isNullOrUndefined)(dataItem.value) && (0, $3EnZW.getValue)(_this.fields.value, data) === dataItem.value;
                });
                if (foundIndex !== -1) index = foundIndex;
            }
        }
        var value = this.allowObjectBinding ? isCustomValue ? this.value : this.getDataByValue(dataItem.value) : dataItem.value;
        this.setProperties({
            "index": index,
            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
            "value": value
        }, true);
        this.detachChangeEvent(eve);
    };
    DropDownList.prototype.detachChanges = function(value) {
        var items;
        if (typeof value === "string" || typeof value === "boolean" || typeof value === "number") items = Object.defineProperties({}, {
            value: {
                value: value,
                enumerable: true
            },
            text: {
                value: value,
                enumerable: true
            }
        });
        else items = value;
        return items;
    };
    DropDownList.prototype.detachChangeEvent = function(eve) {
        this.isSelected = false;
        this.previousValue = this.value;
        this.activeIndex = this.enableVirtualization ? this.getIndexByValue(this.value) : this.index;
        this.typedString = !(0, $3EnZW.isNullOrUndefined)(this.text) ? this.text : "";
        if (!this.initial) {
            var items = this.detachChanges(this.itemData);
            var preItems = void 0;
            if (typeof this.previousItemData === "string" || typeof this.previousItemData === "boolean" || typeof this.previousItemData === "number") preItems = Object.defineProperties({}, {
                value: {
                    value: this.previousItemData,
                    enumerable: true
                },
                text: {
                    value: this.previousItemData,
                    enumerable: true
                }
            });
            else preItems = this.previousItemData;
            this.setHiddenValue();
            var eventArgs = {
                e: eve,
                item: this.item,
                itemData: items,
                previousItem: this.previousSelectedLI,
                previousItemData: preItems,
                isInteracted: eve ? true : false,
                value: this.value,
                element: this.element,
                event: eve
            };
            if (this.isAngular && this.preventChange) this.preventChange = false;
            else this.trigger("change", eventArgs);
        }
        if (((0, $3EnZW.isNullOrUndefined)(this.value) || this.value === "") && this.floatLabelType !== "Always") (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], "e-valid-input");
    };
    DropDownList.prototype.setHiddenValue = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
            if (this.hiddenElement.querySelector("option")) {
                var selectedElement = this.hiddenElement.querySelector("option");
                selectedElement.textContent = this.text;
                selectedElement.setAttribute("value", value.toString());
            } else if (!(0, $3EnZW.isNullOrUndefined)(this.hiddenElement)) {
                var option = document.createElement("option");
                option.text = this.text;
                option.setAttribute("selected", "");
                this.hiddenElement.appendChild(option);
                var selectedElement = this.hiddenElement.querySelector("option");
                selectedElement.setAttribute("value", value.toString());
            }
        } else this.hiddenElement.innerHTML = "";
    };
    /**
     * Filter bar implementation
     *
     * @param {KeyboardEventArgs} e - Specifies the event arguments.
     * @returns {void}
     */ DropDownList.prototype.onFilterUp = function(e) {
        if (!(e.ctrlKey && e.keyCode === 86) && (this.isValidKey || e.keyCode === 40 || e.keyCode === 38)) {
            this.isValidKey = false;
            this.firstItem = this.dataSource && this.dataSource.length > 0 ? this.dataSource[0] : null;
            switch(e.keyCode){
                case 38:
                case 40:
                    if (this.getModuleName() === "autocomplete" && !this.isPopupOpen && !this.preventAltUp && !this.isRequested) {
                        this.preventAutoFill = true;
                        this.searchLists(e);
                    } else this.preventAutoFill = false;
                    this.preventAltUp = false;
                    if (this.getModuleName() === "autocomplete" && !(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.targetElement(), {
                        "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
                    });
                    e.preventDefault();
                    break;
                case 46:
                case 8:
                    this.typedString = this.filterInput.value;
                    if (!this.isPopupOpen && this.typedString !== "" || this.isPopupOpen && this.queryString.length > 0) {
                        this.preventAutoFill = true;
                        this.searchLists(e);
                    } else if (this.typedString === "" && this.queryString === "" && this.getModuleName() !== "autocomplete") {
                        this.preventAutoFill = true;
                        this.searchLists(e);
                    } else if (this.typedString === "") {
                        if (this.list) this.resetFocusElement();
                        this.activeIndex = null;
                        if (this.getModuleName() !== "dropdownlist") {
                            this.preventAutoFill = true;
                            this.searchLists(e);
                            if (this.getModuleName() === "autocomplete") this.hidePopup();
                        }
                    }
                    e.preventDefault();
                    break;
                default:
                    if (this.isFiltering() && this.getModuleName() === "combobox" && (0, $3EnZW.isNullOrUndefined)(this.list)) {
                        this.getInitialData = true;
                        this.renderList();
                    }
                    this.typedString = this.filterInput.value;
                    this.preventAutoFill = false;
                    this.searchLists(e);
                    if (this.enableVirtualization && this.getModuleName() !== "autocomplete" || this.getModuleName() === "autocomplete" && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.getModuleName() === "autocomplete" && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount !== 0) this.getFilteringSkeletonCount();
                    break;
            }
        } else this.isValidKey = false;
    };
    DropDownList.prototype.onFilterDown = function(e) {
        switch(e.keyCode){
            case 13:
                break;
            case 40:
            case 38:
                this.queryString = this.filterInput.value;
                e.preventDefault();
                break;
            case 9:
                if (this.isPopupOpen && this.getModuleName() !== "autocomplete") e.preventDefault();
                break;
            default:
                this.prevSelectPoints = this.getSelectionPoints();
                this.queryString = this.filterInput.value;
                break;
        }
    };
    DropDownList.prototype.removeFillSelection = function() {
        if (this.isInteracted) {
            var selection = this.getSelectionPoints();
            this.inputElement.setSelectionRange(selection.end, selection.end);
        }
    };
    DropDownList.prototype.getQuery = function(query) {
        var filterQuery;
        if (!this.isCustomFilter && this.allowFiltering && this.filterInput) {
            filterQuery = query ? query.clone() : this.query ? this.query.clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
            var filterType = this.typedString === "" ? "contains" : this.filterType;
            var dataType = this.typeOfData(this.dataSource).typeof;
            if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && dataType === "string" || dataType === "number") filterQuery.where("", filterType, this.typedString, this.ignoreCase, this.ignoreAccent);
            else if (this.getModuleName() !== "combobox" || this.isFiltering() && this.getModuleName() === "combobox" && this.typedString !== "") {
                var fields = this.fields.text ? this.fields.text : "";
                filterQuery.where(fields, filterType, this.typedString, this.ignoreCase, this.ignoreAccent);
            }
        } else filterQuery = this.enableVirtualization && !(0, $3EnZW.isNullOrUndefined)(this.customFilterQuery) ? this.customFilterQuery.clone() : query ? query.clone() : this.query ? this.query.clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (this.enableVirtualization && this.viewPortInfo.endIndex !== 0) {
            var takeValue = this.getTakeValue();
            var alreadySkipAdded = false;
            if (filterQuery) {
                for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++)if (filterQuery.queries[queryElements].fn === "onSkip") {
                    alreadySkipAdded = true;
                    break;
                }
            }
            var queryTakeValue = 0;
            var querySkipValue = 0;
            if (filterQuery && filterQuery.queries.length > 0) for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++){
                if (filterQuery.queries[queryElements].fn === "onSkip") querySkipValue = filterQuery.queries[queryElements].e.nos;
                if (filterQuery.queries[queryElements].fn === "onTake") queryTakeValue = takeValue <= filterQuery.queries[queryElements].e.nos ? filterQuery.queries[queryElements].e.nos : takeValue;
            }
            if (queryTakeValue <= 0 && this.query && this.query.queries.length > 0) {
                for(var queryElements = 0; queryElements < this.query.queries.length; queryElements++)if (this.query.queries[queryElements].fn === "onTake") queryTakeValue = takeValue <= this.query.queries[queryElements].e.nos ? this.query.queries[queryElements].e.nos : takeValue;
            }
            var skipExists = false;
            if (filterQuery && filterQuery.queries.length > 0) for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++){
                if (filterQuery.queries[queryElements].fn === "onSkip") {
                    querySkipValue = filterQuery.queries[queryElements].e.nos;
                    filterQuery.queries.splice(queryElements, 1);
                    alreadySkipAdded = false;
                    --queryElements;
                    continue;
                }
                if (filterQuery.queries[queryElements].fn === "onTake") {
                    queryTakeValue = filterQuery.queries[queryElements].e.nos <= queryTakeValue ? queryTakeValue : filterQuery.queries[queryElements].e.nos;
                    filterQuery.queries.splice(queryElements, 1);
                    --queryElements;
                }
            }
            if (!skipExists && (this.allowFiltering || !this.isPopupOpen || !alreadySkipAdded)) {
                if (querySkipValue > 0) filterQuery.skip(querySkipValue);
                else filterQuery.skip(this.virtualItemStartIndex);
            }
            if (this.isIncrementalRequest) filterQuery.take(this.incrementalEndIndex);
            else if (queryTakeValue > 0) filterQuery.take(queryTakeValue);
            else filterQuery.take(takeValue);
            filterQuery.requiresCount();
        }
        return filterQuery;
    };
    DropDownList.prototype.getSelectionPoints = function() {
        var input = this.inputElement;
        return {
            start: Math.abs(input.selectionStart),
            end: Math.abs(input.selectionEnd)
        };
    };
    DropDownList.prototype.searchLists = function(e) {
        var _this = this;
        this.isTyped = true;
        this.activeIndex = null;
        this.isListSearched = true;
        if (this.filterInput.parentElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon)) {
            var clearElement = this.filterInput.parentElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon);
            clearElement.style.visibility = this.filterInput.value === "" ? "hidden" : "visible";
        }
        this.isDataFetched = false;
        if (this.isFiltering()) {
            this.checkAndResetCache();
            this.isRequesting = false;
            var eventArgs_1 = {
                preventDefaultAction: false,
                text: this.filterInput.value,
                updateData: function(dataSource, query, fields) {
                    if (eventArgs_1.cancel) return;
                    _this.isCustomFilter = true;
                    _this.customFilterQuery = query.clone();
                    _this.filteringAction(dataSource, query, fields);
                },
                baseEventArgs: e,
                cancel: false
            };
            this.trigger("filtering", eventArgs_1, function(eventArgs) {
                if (!eventArgs.cancel && !_this.isCustomFilter && !eventArgs.preventDefaultAction) _this.filteringAction(_this.dataSource, null, _this.fields);
            });
        }
    };
    /**
     * To filter the data from given data source by using query
     *
     * @param {Object[] | DataManager } dataSource - Set the data source to filter.
     * @param {Query} query - Specify the query to filter the data.
     * @param {FieldSettingsModel} fields - Specify the fields to map the column in the data table.
     * @returns {void}

     */ DropDownList.prototype.filter = function(dataSource, query, fields) {
        this.isCustomFilter = true;
        this.filteringAction(dataSource, query, fields);
    };
    DropDownList.prototype.filteringAction = function(dataSource, query, fields) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.filterInput)) {
            this.beforePopupOpen = !this.isPopupOpen && this.getModuleName() === "combobox" && this.filterInput.value === "" || this.getInitialData ? false : true;
            var isNoData = this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData);
            if (this.filterInput.value.trim() === "" && !this.itemTemplate) {
                this.actionCompleteData.isUpdated = false;
                this.isTyped = false;
                if (!(0, $3EnZW.isNullOrUndefined)(this.actionCompleteData.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.actionCompleteData.list)) {
                    if (this.enableVirtualization) {
                        if (this.isFiltering()) {
                            this.isPreventScrollAction = true;
                            this.list.scrollTop = 0;
                            this.previousStartIndex = 0;
                            this.virtualListInfo = null;
                        }
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        this.totalItemCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
                        this.resetList(dataSource, fields, query);
                        if (isNoData && !this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                            if (!this.list.querySelector(".e-virtual-ddl-content")) this.list.appendChild(this.createElement("div", {
                                className: "e-virtual-ddl-content",
                                styles: this.getTransformValues()
                            })).appendChild(this.list.querySelector(".e-list-parent"));
                            if (!this.list.querySelector(".e-virtual-ddl")) {
                                var virualElement = this.createElement("div", {
                                    id: this.element.id + "_popup",
                                    className: "e-virtual-ddl",
                                    styles: this.GetVirtualTrackHeight()
                                });
                                document.getElementsByClassName("e-popup")[0].querySelector(".e-dropdownbase").appendChild(virualElement);
                            }
                        }
                    }
                    this.onActionComplete(this.actionCompleteData.ulElement, this.actionCompleteData.list);
                }
                this.isTyped = true;
                if (!(0, $3EnZW.isNullOrUndefined)(this.itemData) && this.getModuleName() === "dropdownlist") {
                    this.focusIndexItem();
                    this.setScrollPosition();
                }
                this.isNotSearchList = true;
            } else {
                this.isNotSearchList = false;
                query = this.filterInput.value.trim() === "" ? null : query;
                if (this.enableVirtualization && this.isFiltering() && this.isTyped) {
                    this.isPreventScrollAction = true;
                    this.list.scrollTop = 0;
                    this.previousStartIndex = 0;
                    this.virtualListInfo = null;
                }
                this.resetList(dataSource, fields, query);
                if (this.getModuleName() === "dropdownlist" && this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                    this.popupContentElement.setAttribute("role", "status");
                    this.popupContentElement.setAttribute("id", "no-record");
                    (0, $4ZDHT.attributes)(this.filterInputObj.container, {
                        "aria-activedescendant": "no-record"
                    });
                }
                if (this.enableVirtualization && isNoData && !this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                    if (!this.list.querySelector(".e-virtual-ddl-content")) this.list.appendChild(this.createElement("div", {
                        className: "e-virtual-ddl-content",
                        styles: this.getTransformValues()
                    })).appendChild(this.list.querySelector(".e-list-parent"));
                    if (!this.list.querySelector(".e-virtual-ddl")) {
                        var virualElement = this.createElement("div", {
                            id: this.element.id + "_popup",
                            className: "e-virtual-ddl",
                            styles: this.GetVirtualTrackHeight()
                        });
                        document.getElementsByClassName("e-popup")[0].querySelector(".e-dropdownbase").appendChild(virualElement);
                    }
                }
            }
            if (this.enableVirtualization) this.getFilteringSkeletonCount();
            this.renderReactTemplates();
        }
    };
    DropDownList.prototype.setSearchBox = function(popupElement) {
        if (this.isFiltering()) {
            var parentElement = popupElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.filterParent) ? popupElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.filterParent) : this.createElement("span", {
                className: $e5d35cabace4110f$export$9787c7b65ab00376.filterParent
            });
            this.filterInput = this.createElement("input", {
                attrs: {
                    type: "text"
                },
                className: $e5d35cabace4110f$export$9787c7b65ab00376.filterInput
            });
            this.element.parentNode.insertBefore(this.filterInput, this.element);
            var backIcon = false;
            if ((0, $5q7BP.Browser).isDevice && this.isDeviceFullScreen) backIcon = true;
            this.filterInputObj = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
                element: this.filterInput,
                buttons: backIcon ? [
                    $e5d35cabace4110f$export$9787c7b65ab00376.backIcon,
                    $e5d35cabace4110f$export$9787c7b65ab00376.filterBarClearIcon
                ] : [
                    $e5d35cabace4110f$export$9787c7b65ab00376.filterBarClearIcon
                ],
                properties: {
                    placeholder: this.filterBarPlaceholder
                }
            }, this.createElement);
            if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) {
                if (this.cssClass.split(" ").indexOf("e-outline") !== -1) (0, $4ZDHT.addClass)([
                    this.filterInputObj.container
                ], "e-outline");
                else if (this.cssClass.split(" ").indexOf("e-filled") !== -1) (0, $4ZDHT.addClass)([
                    this.filterInputObj.container
                ], "e-filled");
            }
            (0, $4ZDHT.append)([
                this.filterInputObj.container
            ], parentElement);
            (0, $4ZDHT.prepend)([
                parentElement
            ], popupElement);
            (0, $4ZDHT.attributes)(this.filterInput, {
                "aria-disabled": "false",
                "role": "combobox",
                "autocomplete": "off",
                "autocapitalize": "off",
                "spellcheck": "false"
            });
            this.clearIconElement = this.filterInput.parentElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon);
            if (!(0, $5q7BP.Browser).isDevice && this.clearIconElement) {
                (0, $aqzbR.EventHandler).add(this.clearIconElement, "click", this.clearText, this);
                this.clearIconElement.style.visibility = "hidden";
            }
            if (!(0, $5q7BP.Browser).isDevice) this.searchKeyModule = new (0, $dyv7X.KeyboardEvents)(this.filterInput, {
                keyAction: this.keyActionHandler.bind(this),
                keyConfigs: this.keyConfigure,
                eventName: "keydown"
            });
            else this.searchKeyModule = new (0, $dyv7X.KeyboardEvents)(this.filterInput, {
                keyAction: this.mobileKeyActionHandler.bind(this),
                keyConfigs: this.keyConfigure,
                eventName: "keydown"
            });
            (0, $aqzbR.EventHandler).add(this.filterInput, "input", this.onInput, this);
            (0, $aqzbR.EventHandler).add(this.filterInput, "keyup", this.onFilterUp, this);
            (0, $aqzbR.EventHandler).add(this.filterInput, "keydown", this.onFilterDown, this);
            (0, $aqzbR.EventHandler).add(this.filterInput, "blur", this.onBlurHandler, this);
            (0, $aqzbR.EventHandler).add(this.filterInput, "paste", this.pasteHandler, this);
            return this.filterInputObj;
        } else return $e5d35cabace4110f$var$inputObject;
    };
    DropDownList.prototype.onInput = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.data) && e.data.length > 1 && this.autoFill && (this.getModuleName() === "combobox" || this.getModuleName() === "autocomplete")) this.inputElement.value = e.data;
        this.isValidKey = true;
        if (this.getModuleName() === "combobox") this.updateIconState();
        // For filtering works in mobile firefox.
        if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).info.name === "mozilla") {
            this.typedString = this.filterInput.value;
            this.preventAutoFill = true;
            this.searchLists(e);
        }
    };
    DropDownList.prototype.pasteHandler = function(e) {
        var _this = this;
        setTimeout(function() {
            _this.typedString = _this.filterInput.value;
            _this.searchLists(e);
        });
    };
    DropDownList.prototype.onActionFailure = function(e) {
        _super.prototype.onActionFailure.call(this, e);
        if (this.beforePopupOpen) this.renderPopup();
    };
    DropDownList.prototype.getTakeValue = function() {
        return this.allowFiltering && this.getModuleName() === "dropdownlist" && (0, $5q7BP.Browser).isDevice ? Math.round(window.outerHeight / this.listItemHeight) : this.itemCount;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DropDownList.prototype.onActionComplete = function(ulElement, list, e, isUpdated) {
        var _this = this;
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)(e) && !this.virtualGroupDataSource) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = e.count;
        if (this.isNotSearchList && !this.enableVirtualization) {
            this.isNotSearchList = false;
            return;
        }
        if (this.getInitialData) this.updateActionCompleteDataValues(ulElement, list);
        if (!this.preventPopupOpen && this.getModuleName() === "combobox") {
            this.beforePopupOpen = true;
            this.preventPopupOpen = true;
        }
        var tempItemCount = this.itemCount;
        if (this.isActive || !(0, $3EnZW.isNullOrUndefined)(ulElement)) {
            var selectedItem = this.selectedLI ? this.selectedLI.cloneNode(true) : null;
            _super.prototype.onActionComplete.call(this, ulElement, list, e);
            this.skeletonCount = this.totalItemCount !== 0 && this.totalItemCount < this.itemCount * 2 && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount <= this.itemCount) ? 0 : this.skeletonCount;
            this.updateSelectElementData(this.allowFiltering);
            if (this.isRequested && !(0, $3EnZW.isNullOrUndefined)(this.searchKeyEvent) && this.searchKeyEvent.type === "keydown") {
                this.isRequested = false;
                this.keyActionHandler(this.searchKeyEvent);
                this.searchKeyEvent = null;
            }
            if (this.isRequested && !(0, $3EnZW.isNullOrUndefined)(this.searchKeyEvent)) {
                this.incrementalSearch(this.searchKeyEvent);
                this.searchKeyEvent = null;
            }
            if (!this.enableVirtualization) this.list.scrollTop = 0;
            if (!(0, $3EnZW.isNullOrUndefined)(ulElement)) (0, $4ZDHT.attributes)(ulElement, {
                "id": this.element.id + "_options",
                "role": "listbox",
                "aria-hidden": "false",
                "aria-label": "listbox"
            });
            if (this.initialRemoteRender) {
                this.initial = true;
                this.activeIndex = this.index;
                this.initialRemoteRender = false;
                if (this.value && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                    var checkField_1 = (0, $3EnZW.isNullOrUndefined)(this.fields.value) ? this.fields.text : this.fields.value;
                    var value_1 = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(checkField_1, this.value) : this.value;
                    var fieldValue_1 = this.fields.value.split(".");
                    var checkVal = list.some(function(x) {
                        return (0, $3EnZW.isNullOrUndefined)(x[checkField_1]) && fieldValue_1.length > 1 ? _this.checkFieldValue(x, fieldValue_1) === value_1 : x[checkField_1] === value_1;
                    });
                    if (this.enableVirtualization && this.virtualGroupDataSource) checkVal = this.virtualGroupDataSource.some(function(x) {
                        return (0, $3EnZW.isNullOrUndefined)(x[checkField_1]) && fieldValue_1.length > 1 ? _this.checkFieldValue(x, fieldValue_1) === value_1 : x[checkField_1] === value_1;
                    });
                    if (!checkVal) this.dataSource.executeQuery(this.getQuery(this.query).where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(checkField_1, "equal", value_1))).then(function(e) {
                        if (e.result.length > 0) {
                            _this.addItem(e.result, list.length);
                            _this.updateValues();
                        } else _this.updateValues();
                    });
                    else this.updateValues();
                } else this.updateValues();
                this.initial = false;
            } else if (this.getModuleName() === "autocomplete" && this.value) this.setInputValue();
            if (this.getModuleName() !== "autocomplete" && this.isFiltering() && !this.isTyped) {
                if (!this.actionCompleteData.isUpdated || !this.isCustomFilter && !this.isFilterFocus || (0, $3EnZW.isNullOrUndefined)(this.itemData) && this.allowFiltering && (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) || !(0, $3EnZW.isNullOrUndefined)(this.dataSource) && !(0, $3EnZW.isNullOrUndefined)(this.dataSource.length) && this.dataSource.length !== 0)) {
                    if (this.itemTemplate && this.element.tagName === "EJS-COMBOBOX" && this.allowFiltering) setTimeout(function() {
                        _this.updateActionCompleteDataValues(ulElement, list);
                    }, 0);
                    else this.updateActionCompleteDataValues(ulElement, list);
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if ((this.allowCustom || this.allowFiltering && !this.isValueInList(list, this.value) && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && !this.enableVirtualization) this.addNewItem(list, selectedItem);
                else if ((this.allowCustom || this.allowFiltering && this.isValueInList(list, this.value)) && !this.enableVirtualization) this.addNewItem(list, selectedItem);
                if (!(0, $3EnZW.isNullOrUndefined)(this.itemData) || (0, $3EnZW.isNullOrUndefined)(this.itemData) && this.enableVirtualization) {
                    this.getSkeletonCount();
                    this.skeletonCount = this.totalItemCount !== 0 && this.totalItemCount < this.itemCount * 2 && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount <= this.itemCount) ? 0 : this.skeletonCount;
                    this.UpdateSkeleton();
                    this.focusIndexItem();
                }
                if (this.enableVirtualization) this.updateActionCompleteDataValues(ulElement, list);
            } else if (this.enableVirtualization && this.getModuleName() !== "autocomplete" && !this.isFiltering()) {
                var value = this.getItemData().value;
                this.activeIndex = this.getIndexByValue(value);
                var element = this.findListElement(this.list, "li", "data-value", value);
                this.selectedLI = element;
            } else if (this.enableVirtualization && this.getModuleName() === "autocomplete") this.activeIndex = this.skeletonCount;
            if (this.beforePopupOpen) {
                this.renderPopup(e);
                if (this.enableVirtualization) {
                    if (!this.list.querySelector(".e-virtual-list")) {
                        this.UpdateSkeleton();
                        this.liCollections = this.list.querySelectorAll(".e-list-item");
                    }
                }
                if (this.enableVirtualization && tempItemCount !== this.itemCount) this.resetList(this.dataSource, this.fields);
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DropDownList.prototype.isValueInList = function(list, valueToFind) {
        if (Array.isArray(list)) for(var i = 0; i < list.length; i++){
            if (list[i] === valueToFind) return true;
        }
        else if (typeof list === "object" && list !== null) for(var key in list){
            if (Object.prototype.hasOwnProperty.call(list, key) && list[key] === valueToFind) return true;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DropDownList.prototype.checkFieldValue = function(list, fieldValue) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var checkField = list;
        fieldValue.forEach(function(value) {
            checkField = checkField[value];
        });
        return checkField;
    };
    DropDownList.prototype.updateActionCompleteDataValues = function(ulElement, list) {
        this.actionCompleteData = {
            ulElement: ulElement.cloneNode(true),
            list: list,
            isUpdated: true
        };
        if (this.actionData.list !== this.actionCompleteData.list && this.actionCompleteData.ulElement && this.actionCompleteData.list) this.actionData = this.actionCompleteData;
    };
    DropDownList.prototype.addNewItem = function(listData, newElement) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(this.itemData) && !(0, $3EnZW.isNullOrUndefined)(newElement)) {
            var value_2 = this.getItemData().value;
            var isExist = listData.some(function(data) {
                return (typeof data === "string" || typeof data === "number" || typeof data === "boolean") && data === value_2 || (0, $3EnZW.getValue)(_this.fields.value, data) === value_2;
            });
            if (!isExist) this.addItem(this.itemData);
        }
    };
    DropDownList.prototype.updateActionCompleteData = function(li, item, index) {
        var _this = this;
        if (this.getModuleName() !== "autocomplete" && this.actionCompleteData.ulElement) {
            if (this.itemTemplate && this.element.tagName === "EJS-COMBOBOX" && this.allowFiltering) setTimeout(function() {
                _this.actionCompleteDataUpdate(li, item, index);
            }, 0);
            else this.actionCompleteDataUpdate(li, item, index);
        }
    };
    DropDownList.prototype.actionCompleteDataUpdate = function(li, item, index) {
        if (index !== null) this.actionCompleteData.ulElement.insertBefore(li.cloneNode(true), this.actionCompleteData.ulElement.childNodes[index]);
        else this.actionCompleteData.ulElement.appendChild(li.cloneNode(true));
        if (this.isFiltering() && this.actionCompleteData.list && this.actionCompleteData.list.indexOf(item) < 0) this.actionCompleteData.list.push(item);
    };
    DropDownList.prototype.focusIndexItem = function() {
        var value = this.getItemData().value;
        this.activeIndex = this.enableVirtualization && !(0, $3EnZW.isNullOrUndefined)(value) || !this.enableVirtualization ? this.getIndexByValue(value) : this.activeIndex;
        var element = this.findListElement(this.list, "li", "data-value", value);
        this.selectedLI = element;
        this.activeItem(element);
        if (!(this.enableVirtualization && (0, $3EnZW.isNullOrUndefined)(element))) this.removeFocus();
    };
    DropDownList.prototype.updateSelection = function() {
        var selectedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
        if (selectedItem) {
            this.setProperties({
                "index": this.getIndexByValue(selectedItem.getAttribute("data-value"))
            });
            this.activeIndex = this.index;
        } else {
            this.removeFocus();
            this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li).classList.add($e5d35cabace4110f$export$9787c7b65ab00376.focus);
        }
    };
    DropDownList.prototype.updateSelectionList = function() {
        var selectedItem = this.list && this.list.querySelector(".e-active");
        if (!selectedItem && !(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
            var findEle = this.findListElement(this.list, "li", "data-value", value);
            if (findEle) findEle.classList.add("e-active");
        }
    };
    DropDownList.prototype.removeFocus = function() {
        var highlightedItem = this.list.querySelectorAll("." + $e5d35cabace4110f$export$9787c7b65ab00376.focus);
        if (highlightedItem && highlightedItem.length) (0, $4ZDHT.removeClass)(highlightedItem, $e5d35cabace4110f$export$9787c7b65ab00376.focus);
    };
    DropDownList.prototype.renderPopup = function(e) {
        var _this = this;
        if (this.popupObj && document.body.contains(this.popupObj.element)) {
            this.refreshPopup();
            return;
        }
        var args = {
            cancel: false
        };
        this.trigger("beforeOpen", args, function(args) {
            if (!args.cancel) {
                var popupEle = _this.createElement("div", {
                    id: _this.element.id + "_popup",
                    className: "e-ddl e-popup " + (_this.cssClass !== null ? _this.cssClass : "")
                });
                popupEle.setAttribute("aria-label", _this.element.id);
                popupEle.setAttribute("role", "dialog");
                var searchBox = _this.setSearchBox(popupEle);
                _this.listContainerHeight = _this.allowFiltering && _this.getModuleName() === "dropdownlist" && (0, $5q7BP.Browser).isDevice ? (0, $3EnZW.formatUnit)(Math.round(window.outerHeight).toString() + "px") : (0, $3EnZW.formatUnit)(_this.popupHeight);
                if (_this.headerTemplate) _this.setHeaderTemplate(popupEle);
                (0, $4ZDHT.append)([
                    _this.list
                ], popupEle);
                if (_this.footerTemplate) _this.setFooterTemplate(popupEle);
                document.body.appendChild(popupEle);
                popupEle.style.top = "0px";
                if (_this.enableVirtualization && _this.itemTemplate) {
                    var listitems = popupEle.querySelectorAll("li.e-list-item:not(.e-virtual-list)");
                    _this.listItemHeight = listitems.length > 0 ? Math.ceil(listitems[0].getBoundingClientRect().height) + parseInt(window.getComputedStyle(listitems[0]).marginBottom, 10) : 0;
                }
                if (_this.enableVirtualization && !_this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                    _this.getSkeletonCount();
                    _this.skeletonCount = _this.totalItemCount < _this.itemCount * 2 && (!(_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || _this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && _this.totalItemCount <= _this.itemCount) ? 0 : _this.skeletonCount;
                    if (!_this.list.querySelector(".e-virtual-ddl-content")) _this.list.appendChild(_this.createElement("div", {
                        className: "e-virtual-ddl-content",
                        styles: _this.getTransformValues()
                    })).appendChild(_this.list.querySelector(".e-list-parent"));
                    else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = _this.getTransformValues();
                    _this.UpdateSkeleton();
                    _this.liCollections = _this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                    _this.virtualItemCount = _this.itemCount;
                    if (!_this.list.querySelector(".e-virtual-ddl")) {
                        var virualElement = _this.createElement("div", {
                            id: _this.element.id + "_popup",
                            className: "e-virtual-ddl",
                            styles: _this.GetVirtualTrackHeight()
                        });
                        popupEle.querySelector(".e-dropdownbase").appendChild(virualElement);
                    } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this.list.getElementsByClassName("e-virtual-ddl")[0].style = _this.GetVirtualTrackHeight();
                }
                popupEle.style.visibility = "hidden";
                if (_this.popupHeight !== "auto") {
                    _this.searchBoxHeight = 0;
                    if (!(0, $3EnZW.isNullOrUndefined)(searchBox.container) && _this.getModuleName() !== "combobox" && _this.getModuleName() !== "autocomplete") {
                        _this.searchBoxHeight = searchBox.container.parentElement.getBoundingClientRect().height;
                        _this.listContainerHeight = (parseInt(_this.listContainerHeight, 10) - _this.searchBoxHeight).toString() + "px";
                    }
                    if (_this.headerTemplate) {
                        _this.header = _this.header ? _this.header : popupEle.querySelector(".e-ddl-header");
                        var height = Math.round(_this.header.getBoundingClientRect().height);
                        _this.listContainerHeight = (parseInt(_this.listContainerHeight, 10) - (height + _this.searchBoxHeight)).toString() + "px";
                    }
                    if (_this.footerTemplate) {
                        _this.footer = _this.footer ? _this.footer : popupEle.querySelector(".e-ddl-footer");
                        var height = Math.round(_this.footer.getBoundingClientRect().height);
                        _this.listContainerHeight = (parseInt(_this.listContainerHeight, 10) - (height + _this.searchBoxHeight)).toString() + "px";
                    }
                    _this.list.style.maxHeight = (parseInt(_this.listContainerHeight, 10) - 2).toString() + "px"; // due to box-sizing property
                    popupEle.style.maxHeight = (0, $3EnZW.formatUnit)(_this.popupHeight);
                } else popupEle.style.height = "auto";
                var offsetValue = 0;
                var left = void 0;
                _this.isPreventScrollAction = true;
                if (!(0, $3EnZW.isNullOrUndefined)(_this.selectedLI) && !(0, $3EnZW.isNullOrUndefined)(_this.activeIndex) && _this.activeIndex >= 0) _this.setScrollPosition();
                else if (_this.enableVirtualization) _this.setScrollPosition();
                else _this.list.scrollTop = 0;
                if ((0, $5q7BP.Browser).isDevice && _this.isDeviceFullScreen && !_this.allowFiltering && (_this.getModuleName() === "dropdownlist" || _this.isDropDownClick && _this.getModuleName() === "combobox")) {
                    offsetValue = _this.getOffsetValue(popupEle);
                    var firstItem = _this.isEmptyList() ? _this.list : _this.liCollections[0];
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.inputElement)) left = -(parseInt(getComputedStyle(firstItem).textIndent, 10) - parseInt(getComputedStyle(_this.inputElement).paddingLeft, 10) + parseInt(getComputedStyle(_this.inputElement.parentElement).borderLeftWidth, 10));
                }
                _this.createPopup(popupEle, offsetValue, left);
                _this.popupContentElement = _this.popupObj.element.querySelector(".e-content");
                _this.getFocusElement();
                _this.checkCollision(popupEle);
                if ((0, $5q7BP.Browser).isDevice) {
                    if (parseInt(_this.popupWidth.toString(), 10) > window.outerWidth && !(_this.getModuleName() === "dropdownlist" && _this.allowFiltering)) _this.popupObj.element.classList.add("e-wide-popup");
                    _this.popupObj.element.classList.add($e5d35cabace4110f$export$9787c7b65ab00376.device);
                    if (_this.getModuleName() === "dropdownlist" || _this.getModuleName() === "combobox" && !_this.allowFiltering && _this.isDropDownClick) _this.popupObj.collision = {
                        X: "fit",
                        Y: "fit"
                    };
                    if (_this.isFilterLayout() && _this.isDeviceFullScreen) {
                        _this.popupObj.element.classList.add($e5d35cabace4110f$export$9787c7b65ab00376.mobileFilter);
                        _this.popupObj.position = {
                            X: 0,
                            Y: 0
                        };
                        _this.popupObj.dataBind();
                        (0, $4ZDHT.attributes)(_this.popupObj.element, {
                            style: "left:0px;right:0px;top:0px;bottom:0px;"
                        });
                        (0, $4ZDHT.addClass)([
                            document.body,
                            _this.popupObj.element
                        ], $e5d35cabace4110f$export$9787c7b65ab00376.popupFullScreen);
                        _this.setSearchBoxPosition();
                        _this.backIconElement = searchBox.container.querySelector(".e-back-icon");
                        _this.clearIconElement = searchBox.container.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon);
                        (0, $aqzbR.EventHandler).add(_this.backIconElement, "click", _this.clickOnBackIcon, _this);
                        (0, $aqzbR.EventHandler).add(_this.clearIconElement, "click", _this.clearText, _this);
                    }
                }
                popupEle.style.visibility = "visible";
                (0, $4ZDHT.addClass)([
                    popupEle
                ], "e-popup-close");
                var scrollParentElements = _this.popupObj.getScrollableParent(_this.inputWrapper.container);
                for(var _i = 0, scrollParentElements_1 = scrollParentElements; _i < scrollParentElements_1.length; _i++){
                    var element = scrollParentElements_1[_i];
                    (0, $aqzbR.EventHandler).add(element, "scroll", _this.scrollHandler, _this);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(_this.list)) {
                    _this.unWireListEvents();
                    _this.wireListEvents();
                }
                _this.selectedElementID = _this.selectedLI ? _this.selectedLI.id : null;
                if (_this.enableVirtualization) {
                    _this.notify("bindScrollEvent", {
                        module: "VirtualScroll",
                        component: _this.getModuleName(),
                        enable: _this.enableVirtualization
                    });
                    setTimeout(function() {
                        if (_this.value || _this.list.querySelector(".e-active")) {
                            _this.updateSelectionList();
                            if (_this.selectedValueInfo && _this.viewPortInfo && _this.viewPortInfo.offsets.top) _this.list.scrollTop = _this.viewPortInfo.offsets.top;
                            else _this.scrollBottom(true, true);
                        }
                    }, 5);
                }
                (0, $4ZDHT.attributes)(_this.targetElement(), {
                    "aria-expanded": "true",
                    "aria-owns": _this.element.id + "_popup",
                    "aria-controls": _this.element.id
                });
                if (_this.getModuleName() !== "dropdownlist" && _this.list.classList.contains("e-nodata")) {
                    (0, $4ZDHT.attributes)(_this.targetElement(), {
                        "aria-activedescendant": "no-record"
                    });
                    _this.popupContentElement.setAttribute("role", "status");
                    _this.popupContentElement.setAttribute("id", "no-record");
                }
                _this.inputElement.setAttribute("aria-expanded", "true");
                _this.inputElement.setAttribute("aria-controls", _this.element.id + "_popup");
                var inputParent = _this.isFiltering() ? _this.filterInput.parentElement : _this.inputWrapper.container;
                (0, $4ZDHT.addClass)([
                    inputParent
                ], [
                    $e5d35cabace4110f$export$9787c7b65ab00376.inputFocus
                ]);
                var animModel = {
                    name: "FadeIn",
                    duration: 100
                };
                _this.beforePopupOpen = true;
                var popupInstance = _this.popupObj;
                var eventArgs = {
                    popup: popupInstance,
                    event: e,
                    cancel: false,
                    animation: animModel
                };
                _this.trigger("open", eventArgs, function(eventArgs) {
                    if (!eventArgs.cancel) {
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.inputWrapper)) (0, $4ZDHT.addClass)([
                            _this.inputWrapper.container
                        ], [
                            $e5d35cabace4110f$export$9787c7b65ab00376.iconAnimation
                        ]);
                        _this.renderReactTemplates();
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.popupObj)) _this.popupObj.show(new (0, $kj1BR.Animation)(eventArgs.animation), _this.zIndex === 1000 ? _this.element : null);
                    } else {
                        _this.beforePopupOpen = false;
                        _this.destroyPopup();
                    }
                });
            } else _this.beforePopupOpen = false;
        });
    };
    DropDownList.prototype.checkCollision = function(popupEle) {
        if (!(0, $5q7BP.Browser).isDevice || (0, $5q7BP.Browser).isDevice && !(this.getModuleName() === "dropdownlist" || this.isDropDownClick)) {
            var collision = (0, $49u5W.isCollide)(popupEle);
            if (collision.length > 0) popupEle.style.marginTop = -parseInt(getComputedStyle(popupEle).marginTop, 10) + "px";
            this.popupObj.resolveCollision();
        }
    };
    DropDownList.prototype.getOffsetValue = function(popupEle) {
        var popupStyles = getComputedStyle(popupEle);
        var borderTop = parseInt(popupStyles.borderTopWidth, 10);
        var borderBottom = parseInt(popupStyles.borderBottomWidth, 10);
        return this.setPopupPosition(borderTop + borderBottom);
    };
    DropDownList.prototype.createPopup = function(element, offsetValue, left) {
        var _this = this;
        this.popupObj = new (0, $2vAqh.Popup)(element, {
            width: this.setWidth(),
            targetType: "relative",
            relateTo: this.inputWrapper.container,
            collision: this.enableRtl ? {
                X: "fit",
                Y: "flip"
            } : {
                X: "flip",
                Y: "flip"
            },
            offsetY: offsetValue,
            enableRtl: this.enableRtl,
            offsetX: left,
            position: this.enableRtl ? {
                X: "right",
                Y: "bottom"
            } : {
                X: "left",
                Y: "bottom"
            },
            zIndex: this.zIndex,
            close: function() {
                if (!_this.isDocumentClick) _this.focusDropDown();
                // eslint-disable-next-line
                if (_this.isReact) _this.clearTemplate([
                    "headerTemplate",
                    "footerTemplate"
                ]);
                _this.isNotSearchList = false;
                _this.isDocumentClick = false;
                _this.destroyPopup();
                if (_this.isFiltering() && _this.actionCompleteData.list && _this.actionCompleteData.list.length > 0) {
                    _this.isActive = true;
                    if (_this.enableVirtualization) _this.onActionComplete(_this.ulElement, _this.listData, null, true);
                    else _this.onActionComplete(_this.actionCompleteData.ulElement, _this.actionCompleteData.list, null, true);
                } else if (_this.enableVirtualization) _this.focusIndexItem();
            },
            open: function() {
                (0, $aqzbR.EventHandler).add(document, "mousedown", _this.onDocumentClick, _this);
                _this.isPopupOpen = true;
                var actionList = _this.actionCompleteData && _this.actionCompleteData.ulElement && _this.actionCompleteData.ulElement.querySelector("li");
                var ulElement = _this.list.querySelector("ul li");
                if (!(0, $3EnZW.isNullOrUndefined)(_this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(_this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(_this.targetElement(), {
                    "aria-activedescendant": _this.ulElement.getElementsByClassName("e-item-focus")[0].id
                });
                else if (!(0, $3EnZW.isNullOrUndefined)(_this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(_this.ulElement.getElementsByClassName("e-active")[0])) (0, $4ZDHT.attributes)(_this.targetElement(), {
                    "aria-activedescendant": _this.ulElement.getElementsByClassName("e-active")[0].id
                });
                if (_this.isFiltering() && _this.itemTemplate && _this.element.tagName === _this.getNgDirective() && actionList && ulElement && actionList.textContent !== ulElement.textContent && _this.element.tagName !== "EJS-COMBOBOX") _this.cloneElements();
                if (_this.isFilterLayout()) {
                    (0, $4ZDHT.removeClass)([
                        _this.inputWrapper.container
                    ], [
                        $e5d35cabace4110f$export$9787c7b65ab00376.inputFocus
                    ]);
                    _this.isFilterFocus = true;
                    _this.filterInput.focus();
                    if (_this.inputWrapper.clearButton) (0, $4ZDHT.addClass)([
                        _this.inputWrapper.clearButton
                    ], $e5d35cabace4110f$export$9787c7b65ab00376.clearIconHide);
                }
                _this.activeStateChange();
            },
            targetExitViewport: function() {
                if (!(0, $5q7BP.Browser).isDevice) _this.hidePopup();
            }
        });
    };
    DropDownList.prototype.isEmptyList = function() {
        return !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && this.liCollections.length === 0;
    };
    DropDownList.prototype.getFocusElement = function() {
    // combo-box used this method
    };
    DropDownList.prototype.isFilterLayout = function() {
        return this.getModuleName() === "dropdownlist" && this.allowFiltering;
    };
    DropDownList.prototype.scrollHandler = function() {
        if ((0, $5q7BP.Browser).isDevice && (this.getModuleName() === "dropdownlist" && !this.isFilterLayout() || this.getModuleName() === "combobox" && !this.allowFiltering && this.isDropDownClick)) {
            if (this.element && !this.isElementInViewport(this.element)) this.hidePopup();
        }
    };
    DropDownList.prototype.isElementInViewport = function(element) {
        var elementRect = element.getBoundingClientRect();
        return elementRect.top >= 0 && elementRect.left >= 0 && elementRect.bottom <= window.innerHeight && elementRect.right <= window.innerWidth;
    };
    DropDownList.prototype.setSearchBoxPosition = function() {
        var searchBoxHeight = this.filterInput.parentElement.getBoundingClientRect().height;
        this.popupObj.element.style.maxHeight = "100%";
        this.popupObj.element.style.width = "100%";
        this.list.style.maxHeight = window.innerHeight - searchBoxHeight + "px";
        this.list.style.height = window.innerHeight - searchBoxHeight + "px";
        var clearElement = this.filterInput.parentElement.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.clearIcon);
        (0, $4ZDHT.detach)(this.filterInput);
        clearElement.parentElement.insertBefore(this.filterInput, clearElement);
    };
    DropDownList.prototype.setPopupPosition = function(border) {
        var offsetValue;
        var popupOffset = border;
        var selectedLI = this.list.querySelector("." + $e5d35cabace4110f$export$9787c7b65ab00376.focus) || this.selectedLI;
        var firstItem = this.isEmptyList() ? this.list : this.liCollections[0];
        var lastItem = this.isEmptyList() ? this.list : this.liCollections[this.getItems().length - 1];
        var liHeight = firstItem.getBoundingClientRect().height;
        this.listItemHeight = liHeight + parseInt(window.getComputedStyle(firstItem).marginBottom, 10);
        var listHeight = this.list.offsetHeight / 2;
        var height = (0, $3EnZW.isNullOrUndefined)(selectedLI) ? firstItem.offsetTop : selectedLI.offsetTop;
        var lastItemOffsetValue = lastItem.offsetTop;
        if (lastItemOffsetValue - listHeight < height && !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && this.liCollections.length > 0 && !(0, $3EnZW.isNullOrUndefined)(selectedLI)) {
            var count = this.list.offsetHeight / liHeight;
            var paddingBottom = parseInt(getComputedStyle(this.list).paddingBottom, 10);
            offsetValue = (count - (this.liCollections.length - this.activeIndex)) * liHeight - popupOffset + paddingBottom;
            this.list.scrollTop = selectedLI.offsetTop;
        } else if (height > listHeight && !this.enableVirtualization) {
            offsetValue = listHeight - liHeight / 2;
            this.list.scrollTop = height - listHeight + liHeight / 2;
        } else offsetValue = height;
        var inputHeight = this.inputWrapper.container.offsetHeight;
        offsetValue = offsetValue + liHeight + popupOffset - (liHeight - inputHeight) / 2;
        return -offsetValue;
    };
    DropDownList.prototype.setWidth = function() {
        var width = (0, $3EnZW.formatUnit)(this.popupWidth);
        if (width.indexOf("%") > -1) {
            var inputWidth = this.inputWrapper.container.offsetWidth * parseFloat(width) / 100;
            width = inputWidth.toString() + "px";
        }
        if ((0, $5q7BP.Browser).isDevice && width.indexOf("px") > -1 && !this.allowFiltering && (this.getModuleName() === "dropdownlist" || this.isDropDownClick && this.getModuleName() === "combobox")) {
            var firstItem = this.isEmptyList() ? this.list : this.liCollections[0];
            width = parseInt(width, 10) + (parseInt(getComputedStyle(firstItem).textIndent, 10) - parseInt(getComputedStyle(this.inputElement).paddingLeft, 10) + parseInt(getComputedStyle(this.inputElement.parentElement).borderLeftWidth, 10)) * 2 + "px";
        }
        return width;
    };
    DropDownList.prototype.scrollBottom = function(isInitial, isInitialSelection, keyAction) {
        var _this = this;
        if (isInitialSelection === void 0) isInitialSelection = false;
        if (keyAction === void 0) keyAction = null;
        if ((0, $3EnZW.isNullOrUndefined)(this.selectedLI) && this.enableVirtualization) {
            this.selectedLI = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
            if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI) && this.selectedLI.classList.contains("e-virtual-list")) this.selectedLI = this.liCollections[this.skeletonCount];
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) {
            var selectedListMargin = this.selectedLI && !isNaN(parseInt(window.getComputedStyle(this.selectedLI).marginBottom, 10)) ? parseInt(window.getComputedStyle(this.selectedLI).marginBottom, 10) : 0;
            this.isUpwardScrolling = false;
            var virtualListCount = this.list.querySelectorAll(".e-virtual-list").length;
            var lastElementValue = this.list.querySelector("li:last-of-type") ? this.list.querySelector("li:last-of-type").getAttribute("data-value") : null;
            var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.selectedLI.offsetTop + this.virtualListInfo.startIndex * (this.selectedLI.offsetHeight + selectedListMargin) : this.selectedLI.offsetTop;
            var currentOffset = this.list.offsetHeight;
            var nextBottom = selectedLiOffsetTop - virtualListCount * (this.selectedLI.offsetHeight + selectedListMargin) + (this.selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
            var nextOffset = this.list.scrollTop + nextBottom - currentOffset;
            var isScrollerCHanged = false;
            var isScrollTopChanged = false;
            nextOffset = isInitial ? nextOffset + parseInt(getComputedStyle(this.list).paddingTop, 10) * 2 : nextOffset + parseInt(getComputedStyle(this.list).paddingTop, 10);
            var boxRange = selectedLiOffsetTop - virtualListCount * (this.selectedLI.offsetHeight + selectedListMargin) + (this.selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
            boxRange = this.fields.groupBy && !(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? boxRange - this.fixedHeaderElement.offsetHeight : boxRange;
            if (this.activeIndex === 0 && !this.enableVirtualization) {
                this.list.scrollTop = 0;
                isScrollerCHanged = this.isKeyBoardAction;
            } else if (nextBottom > currentOffset || !(boxRange > 0 && this.list.offsetHeight > boxRange)) {
                var currentElementValue = this.selectedLI ? this.selectedLI.getAttribute("data-value") : null;
                var liCount = keyAction === "pageDown" ? this.getPageCount() - 2 : 1;
                if (!this.enableVirtualization || this.isKeyBoardAction || isInitialSelection) {
                    if (this.isKeyBoardAction && this.enableVirtualization && lastElementValue && currentElementValue === lastElementValue && keyAction !== "end" && !this.isVirtualScrolling) {
                        this.isPreventKeyAction = true;
                        if (this.enableVirtualization && this.itemTemplate) this.list.scrollTop += nextOffset;
                        else {
                            if (this.enableVirtualization) liCount = keyAction === "pageDown" ? this.getPageCount() + 1 : liCount;
                            this.list.scrollTop += (this.selectedLI.offsetHeight + selectedListMargin) * liCount;
                        }
                        this.isPreventKeyAction = this.IsScrollerAtEnd() ? false : this.isPreventKeyAction;
                        this.isKeyBoardAction = false;
                        this.isPreventScrollAction = false;
                    } else if (this.enableVirtualization && keyAction === "end") {
                        this.isPreventKeyAction = false;
                        this.isKeyBoardAction = false;
                        this.isPreventScrollAction = false;
                        this.list.scrollTop = this.list.scrollHeight;
                    } else {
                        if (keyAction === "pageDown" && this.enableVirtualization && !this.isVirtualScrolling) {
                            this.isPreventKeyAction = false;
                            this.isKeyBoardAction = false;
                            this.isPreventScrollAction = false;
                        }
                        this.list.scrollTop = nextOffset;
                    }
                } else this.list.scrollTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.virtualListInfo.startIndex * this.listItemHeight : 0;
                isScrollerCHanged = this.isKeyBoardAction;
                isScrollTopChanged = true;
            }
            this.isKeyBoardAction = isScrollerCHanged;
            if (this.enableVirtualization && this.fields.groupBy && this.fixedHeaderElement && keyAction === "down") setTimeout(function() {
                _this.scrollStop(null, true);
            }, 100);
        }
    };
    DropDownList.prototype.scrollTop = function(keyAction) {
        if (keyAction === void 0) keyAction = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) {
            var selectedListMargin = this.selectedLI && !isNaN(parseInt(window.getComputedStyle(this.selectedLI).marginBottom, 10)) ? parseInt(window.getComputedStyle(this.selectedLI).marginBottom, 10) : 0;
            var virtualListCount = this.list.querySelectorAll(".e-virtual-list").length;
            var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.selectedLI.offsetTop + this.virtualListInfo.startIndex * (this.selectedLI.offsetHeight + selectedListMargin) : this.selectedLI.offsetTop;
            var nextOffset = selectedLiOffsetTop - virtualListCount * (this.selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
            var firstElementValue = this.list.querySelector("li.e-list-item:not(.e-virtual-list)") ? this.list.querySelector("li.e-list-item:not(.e-virtual-list)").getAttribute("data-value") : null;
            nextOffset = this.fields.groupBy && !(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? nextOffset - this.fixedHeaderElement.offsetHeight : nextOffset;
            var boxRange = selectedLiOffsetTop - virtualListCount * (this.selectedLI.offsetHeight + selectedListMargin) + (this.selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
            var isPageUpKeyAction = this.enableVirtualization && this.getModuleName() === "autocomplete" && nextOffset <= 0;
            if (this.activeIndex === 0 && !this.enableVirtualization) this.list.scrollTop = 0;
            else if (nextOffset < 0 || isPageUpKeyAction) {
                var currentElementValue = this.selectedLI ? this.selectedLI.getAttribute("data-value") : null;
                var liCount = keyAction === "pageUp" ? this.getPageCount() - 2 : 1;
                if (this.enableVirtualization) liCount = keyAction === "pageUp" ? this.getPageCount() : liCount;
                if (this.enableVirtualization && this.isKeyBoardAction && firstElementValue && currentElementValue === firstElementValue && keyAction !== "home" && !this.isVirtualScrolling) {
                    this.isUpwardScrolling = true;
                    this.isPreventKeyAction = true;
                    this.list.scrollTop -= (this.selectedLI.offsetHeight + selectedListMargin) * liCount;
                    this.isPreventKeyAction = this.list.scrollTop !== 0 ? this.isPreventKeyAction : false;
                    this.isKeyBoardAction = false;
                    this.isPreventScrollAction = false;
                } else if (this.enableVirtualization && keyAction === "home") {
                    this.isPreventScrollAction = false;
                    this.isPreventKeyAction = true;
                    this.isKeyBoardAction = false;
                    this.list.scrollTo(0, 0);
                } else {
                    if (keyAction === "pageUp" && this.enableVirtualization && !this.isVirtualScrolling) {
                        this.isPreventKeyAction = false;
                        this.isKeyBoardAction = false;
                        this.isPreventScrollAction = false;
                    }
                    this.list.scrollTop = this.list.scrollTop + nextOffset;
                }
            } else if (!(boxRange > 0 && this.list.offsetHeight > boxRange)) this.list.scrollTop = this.selectedLI.offsetTop - (this.fields.groupBy && !(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? this.fixedHeaderElement.offsetHeight : 0);
        }
    };
    DropDownList.prototype.IsScrollerAtEnd = function() {
        return this.list && this.list.scrollTop + this.list.clientHeight >= this.list.scrollHeight;
    };
    DropDownList.prototype.isEditTextBox = function() {
        return false;
    };
    DropDownList.prototype.isFiltering = function() {
        return this.allowFiltering;
    };
    DropDownList.prototype.isPopupButton = function() {
        return true;
    };
    DropDownList.prototype.setScrollPosition = function(e) {
        this.isPreventScrollAction = true;
        if (!(0, $3EnZW.isNullOrUndefined)(e)) switch(e.action){
            case "pageDown":
            case "down":
            case "end":
                this.isKeyBoardAction = true;
                this.scrollBottom(false, false, e.action);
                break;
            default:
                this.isKeyBoardAction = e.action === "up" || e.action === "pageUp" || e.action === "open";
                this.scrollTop(e.action);
                break;
        }
        else this.scrollBottom(true);
        this.isKeyBoardAction = false;
    };
    DropDownList.prototype.clearText = function() {
        this.filterInput.value = this.typedString = "";
        this.searchLists(null);
        if (this.enableVirtualization) {
            this.list.scrollTop = 0;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.totalItemCount = this.dataCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.list.getElementsByClassName("e-virtual-ddl")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
            this.getSkeletonCount();
            this.UpdateSkeleton();
            this.liCollections = this.list.querySelectorAll(".e-list-item");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.list.getElementsByClassName("e-virtual-ddl-content")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
        }
    };
    DropDownList.prototype.setEleWidth = function(width) {
        if (!(0, $3EnZW.isNullOrUndefined)(width)) {
            if (typeof width === "number") this.inputWrapper.container.style.width = (0, $3EnZW.formatUnit)(width);
            else if (typeof width === "string") this.inputWrapper.container.style.width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        }
    };
    DropDownList.prototype.closePopup = function(delay, e) {
        var _this = this;
        var isFilterValue = !(0, $3EnZW.isNullOrUndefined)(this.filterInput) && !(0, $3EnZW.isNullOrUndefined)(this.filterInput.value) && this.filterInput.value !== "";
        var typedString = this.getModuleName() === "combobox" ? this.typedString : null;
        this.isTyped = false;
        this.isVirtualTrackHeight = false;
        if (!(this.popupObj && document.body.contains(this.popupObj.element) && this.beforePopupOpen)) return;
        this.keyboardEvent = null;
        (0, $aqzbR.EventHandler).remove(document, "mousedown", this.onDocumentClick);
        this.isActive = false;
        if (this.getModuleName() === "dropdownlist") (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.filterInput,
            floatLabelType: this.floatLabelType,
            properties: {
                placeholder: this.filterBarPlaceholder
            },
            buttons: this.clearIconElement
        }, this.clearIconElement);
        this.filterInputObj = null;
        this.isDropDownClick = false;
        this.preventAutoFill = false;
        var scrollableParentElements = this.popupObj.getScrollableParent(this.inputWrapper.container);
        for(var _i = 0, scrollableParentElements_1 = scrollableParentElements; _i < scrollableParentElements_1.length; _i++){
            var element = scrollableParentElements_1[_i];
            (0, $aqzbR.EventHandler).remove(element, "scroll", this.scrollHandler);
        }
        if ((0, $5q7BP.Browser).isDevice && this.isFilterLayout() && this.isDeviceFullScreen) (0, $4ZDHT.removeClass)([
            document.body,
            this.popupObj.element
        ], $e5d35cabace4110f$export$9787c7b65ab00376.popupFullScreen);
        if (this.isFilterLayout()) {
            if (!(0, $5q7BP.Browser).isDevice) {
                this.searchKeyModule.destroy();
                if (this.clearIconElement) (0, $aqzbR.EventHandler).remove(this.clearIconElement, "click", this.clearText);
            }
            if (this.backIconElement) {
                (0, $aqzbR.EventHandler).remove(this.backIconElement, "click", this.clickOnBackIcon);
                (0, $aqzbR.EventHandler).remove(this.clearIconElement, "click", this.clearText);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.filterInput)) {
                (0, $aqzbR.EventHandler).remove(this.filterInput, "input", this.onInput);
                (0, $aqzbR.EventHandler).remove(this.filterInput, "keyup", this.onFilterUp);
                (0, $aqzbR.EventHandler).remove(this.filterInput, "keydown", this.onFilterDown);
                (0, $aqzbR.EventHandler).remove(this.filterInput, "blur", this.onBlurHandler);
                (0, $aqzbR.EventHandler).remove(this.filterInput, "paste", this.pasteHandler);
            }
            if (this.allowFiltering && this.getModuleName() === "dropdownlist") {
                this.filterInput.removeAttribute("aria-activedescendant");
                this.filterInput.removeAttribute("aria-disabled");
                this.filterInput.removeAttribute("role");
                this.filterInput.removeAttribute("autocomplete");
                this.filterInput.removeAttribute("autocapitalize");
                this.filterInput.removeAttribute("spellcheck");
            }
            this.filterInput = null;
        }
        (0, $4ZDHT.attributes)(this.targetElement(), {
            "aria-expanded": "false"
        });
        this.inputElement.setAttribute("aria-expanded", "false");
        this.targetElement().removeAttribute("aria-owns");
        this.targetElement().removeAttribute("aria-activedescendant");
        this.inputWrapper.container.classList.remove($e5d35cabace4110f$export$9787c7b65ab00376.iconAnimation);
        if (this.isFiltering()) this.actionCompleteData.isUpdated = false;
        if (this.enableVirtualization) {
            if (this.value == null || this.isTyped) {
                this.viewPortInfo.endIndex = this.viewPortInfo && this.viewPortInfo.endIndex > 0 ? this.viewPortInfo.endIndex : this.itemCount;
                if (this.getModuleName() === "autocomplete" || this.getModuleName() === "dropdownlist" && !(0, $3EnZW.isNullOrUndefined)(this.typedString) && this.typedString !== "" || this.getModuleName() === "combobox" && this.allowFiltering && !(0, $3EnZW.isNullOrUndefined)(this.typedString) && this.typedString !== "") this.checkAndResetCache();
            } else if (this.getModuleName() === "autocomplete") this.checkAndResetCache();
            if ((this.getModuleName() === "dropdownlist" || this.getModuleName() === "combobox") && !(this.skeletonCount === 0)) this.getSkeletonCount(true);
        }
        this.beforePopupOpen = false;
        var animModel = {
            name: "FadeOut",
            duration: 100,
            delay: delay ? delay : 0
        };
        var popupInstance = this.popupObj;
        var eventArgs = {
            popup: popupInstance,
            cancel: false,
            animation: animModel,
            event: e || null
        };
        this.trigger("close", eventArgs, function(eventArgs) {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.popupObj) && !(0, $3EnZW.isNullOrUndefined)(_this.popupObj.element.querySelector(".e-fixed-head"))) {
                var fixedHeader = _this.popupObj.element.querySelector(".e-fixed-head");
                fixedHeader.parentNode.removeChild(fixedHeader);
                _this.fixedHeaderElement = null;
            }
            if (!eventArgs.cancel) {
                if (_this.getModuleName() === "autocomplete") _this.rippleFun();
                if (_this.isPopupOpen) _this.popupObj.hide(new (0, $kj1BR.Animation)(eventArgs.animation));
                else _this.destroyPopup();
            }
        });
        if ((0, $5q7BP.Browser).isDevice && !eventArgs.cancel && this.popupObj.element.classList.contains("e-wide-popup")) this.popupObj.element.classList.remove("e-wide-popup");
        var dataSourceCount;
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataSourceCount = this.virtualGroupDataSource && this.virtualGroupDataSource.length ? this.virtualGroupDataSource.length : 0;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataSourceCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        if (this.enableVirtualization && this.isFiltering() && isFilterValue && this.totalItemCount !== dataSourceCount) {
            this.updateInitialData();
            this.checkAndResetCache();
        }
    };
    DropDownList.prototype.updateInitialData = function() {
        var currentData = this.selectData;
        var ulElement = this.renderItems(currentData, this.fields);
        this.list.scrollTop = 0;
        this.virtualListInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: this.itemCount
        };
        if (this.getModuleName() === "combobox") this.typedString = "";
        this.previousStartIndex = 0;
        this.previousEndIndex = 0;
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            if (this.remoteDataCount >= 0) this.totalItemCount = this.dataCount = this.remoteDataCount;
            else this.resetList(this.dataSource);
        } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = this.dataCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.list.getElementsByClassName("e-virtual-ddl")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
        if (this.getModuleName() !== "autocomplete" && this.totalItemCount !== 0 && this.totalItemCount > this.itemCount * 2) this.getSkeletonCount();
        this.UpdateSkeleton();
        this.listData = currentData;
        this.updateActionCompleteDataValues(ulElement, currentData);
        this.liCollections = this.list.querySelectorAll(".e-list-item");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.list.getElementsByClassName("e-virtual-ddl-content")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
    };
    DropDownList.prototype.destroyPopup = function() {
        this.isPopupOpen = false;
        this.isFilterFocus = false;
        this.inputElement.removeAttribute("aria-controls");
        if (this.popupObj) {
            this.popupObj.destroy();
            (0, $4ZDHT.detach)(this.popupObj.element);
        }
    };
    DropDownList.prototype.clickOnBackIcon = function() {
        this.hidePopup();
        this.focusIn();
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ DropDownList.prototype.render = function() {
        this.preselectedIndex = !(0, $3EnZW.isNullOrUndefined)(this.index) ? this.index : null;
        if (this.element.tagName === "INPUT") {
            this.inputElement = this.element;
            if ((0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute("role"))) this.inputElement.setAttribute("role", "combobox");
            if ((0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute("type"))) this.inputElement.setAttribute("type", "text");
            this.inputElement.setAttribute("aria-expanded", "false");
        } else {
            this.inputElement = this.createElement("input", {
                attrs: {
                    role: "combobox",
                    type: "text"
                }
            });
            if (this.element.tagName !== this.getNgDirective()) this.element.style.display = "none";
            this.element.parentElement.insertBefore(this.inputElement, this.element);
            this.preventTabIndex(this.inputElement);
        }
        var updatedCssClassValues = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValues = this.cssClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        this.inputWrapper = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.inputElement,
            buttons: this.isPopupButton() ? [
                $e5d35cabace4110f$export$9787c7b65ab00376.icon
            ] : null,
            floatLabelType: this.floatLabelType,
            properties: {
                readonly: this.getModuleName() === "dropdownlist" ? true : this.readonly,
                placeholder: this.placeholder,
                cssClass: updatedCssClassValues,
                enabled: this.enabled,
                enableRtl: this.enableRtl,
                showClearButton: this.showClearButton
            }
        }, this.createElement);
        if (this.element.tagName === this.getNgDirective()) this.element.appendChild(this.inputWrapper.container);
        else this.inputElement.parentElement.insertBefore(this.element, this.inputElement);
        this.hiddenElement = this.createElement("select", {
            attrs: {
                "aria-hidden": "true",
                "tabindex": "-1",
                "class": $e5d35cabace4110f$export$9787c7b65ab00376.hiddenElement
            }
        });
        (0, $4ZDHT.prepend)([
            this.hiddenElement
        ], this.inputWrapper.container);
        if (!this.hiddenElement.hasAttribute("aria-label")) this.hiddenElement.setAttribute("aria-label", this.getModuleName());
        this.validationAttribute(this.element, this.hiddenElement);
        this.setReadOnly();
        this.setFields();
        this.inputWrapper.container.style.width = (0, $3EnZW.formatUnit)(this.width);
        this.inputWrapper.container.classList.add("e-ddl");
        if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && this.inputWrapper.container.getElementsByClassName("e-float-text-content")[0] && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-content")[0].classList.add("e-icon");
        this.wireEvent();
        this.tabIndex = this.element.hasAttribute("tabindex") ? this.element.getAttribute("tabindex") : "0";
        this.element.removeAttribute("tabindex");
        var id = this.element.getAttribute("id") ? this.element.getAttribute("id") : (0, $3EnZW.getUniqueID)("ej2_dropdownlist");
        this.element.id = id;
        this.hiddenElement.id = id + "_hidden";
        this.targetElement().setAttribute("tabindex", this.tabIndex);
        if ((this.getModuleName() === "autocomplete" || this.getModuleName() === "combobox") && !this.readonly) {
            if (!this.inputElement.hasAttribute("aria-label")) this.inputElement.setAttribute("aria-label", this.getModuleName());
        } else if (this.getModuleName() === "dropdownlist") {
            if (!this.targetElement().hasAttribute("aria-label")) (0, $4ZDHT.attributes)(this.targetElement(), {
                "aria-label": this.getModuleName()
            });
            if (!this.inputElement.hasAttribute("aria-label")) this.inputElement.setAttribute("aria-label", this.getModuleName());
            this.inputElement.setAttribute("aria-expanded", "false");
        }
        (0, $4ZDHT.attributes)(this.targetElement(), this.getAriaAttributes());
        this.updateDataAttribute(this.htmlAttributes);
        this.setHTMLAttributes();
        if (this.targetElement() === this.inputElement) this.inputElement.removeAttribute("aria-labelledby");
        if (this.value !== null || this.activeIndex !== null || this.text !== null) {
            if (this.enableVirtualization) {
                this.listItemHeight = this.getListHeight();
                this.getSkeletonCount();
                this.updateVirtualizationProperties(this.itemCount, this.allowFiltering);
                if (this.index !== null) this.activeIndex = this.index + this.skeletonCount;
            }
            this.initValue();
            this.selectedValueInfo = this.viewPortInfo;
            if (this.enableVirtualization) this.activeIndex = this.activeIndex + this.skeletonCount;
        } else if (this.element.tagName === "SELECT" && this.element.options[0]) {
            var selectElement = this.element;
            this.value = this.allowObjectBinding ? this.getDataByValue(selectElement.options[selectElement.selectedIndex].value) : selectElement.options[selectElement.selectedIndex].value;
            this.text = (0, $3EnZW.isNullOrUndefined)(this.value) ? null : selectElement.options[selectElement.selectedIndex].textContent;
            this.initValue();
        }
        this.setEnabled();
        this.preventTabIndex(this.element);
        if (!this.enabled) this.targetElement().tabIndex = -1;
        this.initial = false;
        this.element.style.opacity = "";
        this.inputElement.onselect = function(e) {
            e.stopImmediatePropagation();
        };
        this.inputElement.onchange = function(e) {
            e.stopImmediatePropagation();
        };
        if (this.element.hasAttribute("autofocus")) this.focusIn();
        if (!(0, $3EnZW.isNullOrUndefined)(this.text)) this.inputElement.setAttribute("value", this.text);
        if (this.element.hasAttribute("data-val")) this.element.setAttribute("data-val", "false");
        var floatLabelElement = this.inputWrapper.container.getElementsByClassName("e-float-text")[0];
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.id) && this.element.id !== "" && !(0, $3EnZW.isNullOrUndefined)(floatLabelElement)) {
            floatLabelElement.id = "label_" + this.element.id.replace(/ /g, "_");
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-labelledby": floatLabelElement.id
            });
        }
        this.renderComplete();
        this.listItemHeight = this.getListHeight();
        this.getSkeletonCount();
        if (this.enableVirtualization) this.updateVirtualizationProperties(this.itemCount, this.allowFiltering);
        this.viewPortInfo.startIndex = this.virtualItemStartIndex = 0;
        this.viewPortInfo.endIndex = this.virtualItemEndIndex = this.viewPortInfo.startIndex > 0 ? this.viewPortInfo.endIndex : this.itemCount;
    };
    DropDownList.prototype.getListHeight = function() {
        var listParent = this.createElement("div", {
            className: "e-dropdownbase"
        });
        var item = this.createElement("li", {
            className: "e-list-item"
        });
        var listParentHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
        listParent.style.height = parseInt(listParentHeight, 10).toString() + "px";
        listParent.appendChild(item);
        document.body.appendChild(listParent);
        this.virtualListHeight = listParent.getBoundingClientRect().height;
        var listItemHeight = Math.ceil(item.getBoundingClientRect().height) + parseInt(window.getComputedStyle(item).marginBottom, 10);
        listParent.remove();
        return listItemHeight;
    };
    DropDownList.prototype.setFooterTemplate = function(popupEle) {
        var compiledString;
        if (this.footer) {
            if (this.isReact && typeof this.footerTemplate === "function") this.clearTemplate([
                "footerTemplate"
            ]);
            else this.footer.innerHTML = "";
        } else {
            this.footer = this.createElement("div");
            (0, $4ZDHT.addClass)([
                this.footer
            ], $e5d35cabace4110f$export$9787c7b65ab00376.footer);
        }
        var footercheck = this.dropdownCompiler(this.footerTemplate);
        if (typeof this.footerTemplate !== "function" && footercheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(this.footerTemplate, document).innerHTML.trim());
        else compiledString = (0, $c2qqN.compile)(this.footerTemplate);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var footerCompTemp = compiledString({}, this, "footerTemplate", this.footerTemplateId, this.isStringTemplate, null, this.footer);
        if (footerCompTemp && footerCompTemp.length > 0) (0, $4ZDHT.append)(footerCompTemp, this.footer);
        (0, $4ZDHT.append)([
            this.footer
        ], popupEle);
    };
    DropDownList.prototype.setHeaderTemplate = function(popupEle) {
        var compiledString;
        if (this.header) this.header.innerHTML = "";
        else {
            this.header = this.createElement("div");
            (0, $4ZDHT.addClass)([
                this.header
            ], $e5d35cabace4110f$export$9787c7b65ab00376.header);
        }
        var headercheck = this.dropdownCompiler(this.headerTemplate);
        if (typeof this.headerTemplate !== "function" && headercheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(this.headerTemplate, document).innerHTML.trim());
        else compiledString = (0, $c2qqN.compile)(this.headerTemplate);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var headerCompTemp = compiledString({}, this, "headerTemplate", this.headerTemplateId, this.isStringTemplate, null, this.header);
        if (headerCompTemp && headerCompTemp.length) (0, $4ZDHT.append)(headerCompTemp, this.header);
        var contentEle = popupEle.querySelector("div.e-content");
        popupEle.insertBefore(this.header, contentEle);
    };
    /**
     * Sets the enabled state to DropDownBase.
     *
     * @returns {void}
     */ DropDownList.prototype.setEnabled = function() {
        this.element.setAttribute("aria-disabled", this.enabled ? "false" : "true");
    };
    DropDownList.prototype.setOldText = function(text) {
        this.text = text;
    };
    DropDownList.prototype.setOldValue = function(value) {
        this.value = value;
    };
    DropDownList.prototype.refreshPopup = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && document.body.contains(this.popupObj.element) && (this.allowFiltering && !((0, $5q7BP.Browser).isDevice && this.isFilterLayout()) || this.getModuleName() === "autocomplete")) {
            (0, $4ZDHT.removeClass)([
                this.popupObj.element
            ], "e-popup-close");
            this.popupObj.refreshPosition(this.inputWrapper.container);
            this.popupObj.resolveCollision();
        }
    };
    DropDownList.prototype.checkData = function(newProp) {
        if (newProp.dataSource && !(0, $3EnZW.isNullOrUndefined)(Object.keys(newProp.dataSource)) && this.itemTemplate && this.allowFiltering && !(this.isListSearched && newProp.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
            if (this.list && !this.isReact) this.list.innerHTML = "";
            else this.list = null;
            this.actionCompleteData = {
                ulElement: null,
                list: null,
                isUpdated: false
            };
        }
        this.isListSearched = false;
        var isChangeValue = Object.keys(newProp).indexOf("value") !== -1 && (0, $3EnZW.isNullOrUndefined)(newProp.value);
        var isChangeText = Object.keys(newProp).indexOf("text") !== -1 && (0, $3EnZW.isNullOrUndefined)(newProp.text);
        if (this.getModuleName() !== "autocomplete" && this.allowFiltering && (isChangeValue || isChangeText)) this.itemData = null;
        if (this.allowFiltering && newProp.dataSource && !(0, $3EnZW.isNullOrUndefined)(Object.keys(newProp.dataSource))) {
            this.actionCompleteData = {
                ulElement: null,
                list: null,
                isUpdated: false
            };
            this.actionData = this.actionCompleteData;
        } else if (this.allowFiltering && newProp.query && !(0, $3EnZW.isNullOrUndefined)(Object.keys(newProp.query))) {
            this.actionCompleteData = this.getModuleName() === "combobox" ? {
                ulElement: null,
                list: null,
                isUpdated: false
            } : this.actionCompleteData;
            this.actionData = this.actionCompleteData;
        }
    };
    DropDownList.prototype.updateDataSource = function(props, oldProps) {
        if (this.inputElement.value !== "" || !(0, $3EnZW.isNullOrUndefined)(props) && ((0, $3EnZW.isNullOrUndefined)(props.dataSource) || !(props.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && props.dataSource.length === 0)) this.clearAll(null, props);
        if (this.fields.groupBy && props.fields && !this.isGroupChecking && this.list) {
            (0, $aqzbR.EventHandler).remove(this.list, "scroll", this.setFloatingHeader);
            (0, $aqzbR.EventHandler).add(this.list, "scroll", this.setFloatingHeader, this);
        }
        if (!(!(0, $3EnZW.isNullOrUndefined)(props) && ((0, $3EnZW.isNullOrUndefined)(props.dataSource) || !(props.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && props.dataSource.length === 0)) || props.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) || !(0, $3EnZW.isNullOrUndefined)(props) && Array.isArray(props.dataSource) && !(0, $3EnZW.isNullOrUndefined)(oldProps) && Array.isArray(oldProps.dataSource) && props.dataSource.length !== oldProps.dataSource.length) {
            this.typedString = "";
            this.resetList(this.dataSource);
        }
        if (!this.isCustomFilter && !this.isFilterFocus && document.activeElement !== this.filterInput) this.checkCustomValue();
    };
    DropDownList.prototype.checkCustomValue = function() {
        var currentValue = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
        this.itemData = this.getDataByValue(currentValue);
        var dataItem = this.getItemData();
        var value = this.allowObjectBinding ? this.itemData : dataItem.value;
        var index = (0, $3EnZW.isNullOrUndefined)(value) ? null : this.index;
        if ((0, $3EnZW.isNullOrUndefined)(index) && currentValue === value || this.isAngular) this.setProperties({
            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
            "value": value
        });
        else this.setProperties({
            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
            "index": index,
            "value": value
        });
    };
    DropDownList.prototype.updateInputFields = function() {
        if (this.getModuleName() === "dropdownlist") (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
    };
    /**
     * Dynamically change the value of properties.
     *
     * @private
     * @param {DropDownListModel} newProp - Returns the dynamic property value of the component.
     * @param {DropDownListModel} oldProp - Returns the previous previous value of the component.
     * @returns {void}
     */ DropDownList.prototype.onPropertyChanged = function(newProp, oldProp) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.dataSource) && !this.isTouched && (0, $3EnZW.isNullOrUndefined)(newProp.value) && (0, $3EnZW.isNullOrUndefined)(newProp.index) && !(0, $3EnZW.isNullOrUndefined)(this.preselectedIndex) && !(0, $3EnZW.isNullOrUndefined)(this.index)) newProp.index = this.index;
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.value) || !(0, $3EnZW.isNullOrUndefined)(newProp.index)) this.isTouched = true;
        if (this.getModuleName() === "dropdownlist") {
            this.checkData(newProp);
            this.setUpdateInitial([
                "fields",
                "query",
                "dataSource"
            ], newProp);
        }
        var _loop_1 = function(prop) {
            switch(prop){
                case "query":
                case "dataSource":
                    this_1.getSkeletonCount();
                    this_1.checkAndResetCache();
                    break;
                case "htmlAttributes":
                    this_1.setHTMLAttributes();
                    break;
                case "width":
                    this_1.setEleWidth(newProp.width);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this_1.inputElement, this_1.inputWrapper.container);
                    break;
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(newProp.placeholder, this_1.inputElement);
                    break;
                case "filterBarPlaceholder":
                    if (this_1.filterInput) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(newProp.filterBarPlaceholder, this_1.filterInput);
                    break;
                case "readonly":
                    if (this_1.getModuleName() !== "dropdownlist") (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(newProp.readonly, this_1.inputElement);
                    this_1.setReadOnly();
                    break;
                case "cssClass":
                    this_1.setCssClass(newProp.cssClass, oldProp.cssClass);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this_1.inputElement, this_1.inputWrapper.container);
                    break;
                case "enableRtl":
                    this_1.setEnableRtl();
                    break;
                case "enabled":
                    this_1.setEnable();
                    break;
                case "text":
                    if (this_1.fields.disabled) newProp.text = newProp.text && !this_1.isDisabledItemByIndex(this_1.getIndexByValue(this_1.getValueByText(newProp.text))) ? newProp.text : null;
                    if (newProp.text === null) {
                        this_1.clearAll();
                        break;
                    }
                    if (this_1.enableVirtualization) {
                        this_1.updateValues();
                        this_1.updateInputFields();
                        this_1.notify("setCurrentViewDataAsync", {
                            module: "VirtualScroll"
                        });
                        break;
                    }
                    if (!this_1.list) {
                        if (this_1.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this_1.initialRemoteRender = true;
                        this_1.renderList();
                    }
                    if (!this_1.initialRemoteRender) {
                        var li = this_1.getElementByText(newProp.text);
                        if (!this_1.checkValidLi(li)) {
                            if (this_1.liCollections && this_1.liCollections.length === 100 && this_1.getModuleName() === "autocomplete" && this_1.listData.length > 100) this_1.setSelectionData(newProp.text, oldProp.text, "text");
                            else if (newProp.text && this_1.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                                var listLength_1 = this_1.getItems().length;
                                var checkField = (0, $3EnZW.isNullOrUndefined)(this_1.fields.text) ? this_1.fields.value : this_1.fields.text;
                                this_1.typedString = "";
                                this_1.dataSource.executeQuery(this_1.getQuery(this_1.query).where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(checkField, "equal", newProp.text))).then(function(e) {
                                    if (e.result.length > 0) {
                                        _this.addItem(e.result, listLength_1);
                                        _this.updateValues();
                                    } else _this.setOldText(oldProp.text);
                                });
                            } else if (this_1.getModuleName() === "autocomplete") this_1.setInputValue(newProp, oldProp);
                            else this_1.setOldText(oldProp.text);
                        }
                        this_1.updateInputFields();
                    }
                    break;
                case "value":
                    if (this_1.fields.disabled) newProp.value = newProp.value != null && !this_1.isDisableItemValue(newProp.value) ? newProp.value : null;
                    if (newProp.value === null) {
                        this_1.clearAll();
                        break;
                    }
                    if (this_1.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(newProp.value) && !(0, $3EnZW.isNullOrUndefined)(oldProp.value) && this_1.isObjectInArray(newProp.value, [
                        oldProp.value
                    ])) return {
                        value: void 0
                    };
                    if (this_1.enableVirtualization) {
                        this_1.updateValues();
                        this_1.updateInputFields();
                        this_1.notify("setCurrentViewDataAsync", {
                            module: "VirtualScroll"
                        });
                        this_1.preventChange = this_1.isAngular && this_1.preventChange ? !this_1.preventChange : this_1.preventChange;
                        break;
                    }
                    this_1.notify("beforeValueChange", {
                        newProp: newProp
                    }); // gird component value type change
                    if (!this_1.list) {
                        if (this_1.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this_1.initialRemoteRender = true;
                        this_1.renderList();
                    }
                    if (!this_1.initialRemoteRender) {
                        var value = this_1.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(newProp.value) ? (0, $3EnZW.getValue)(this_1.fields.value ? this_1.fields.value : "", newProp.value) : newProp.value;
                        var item = this_1.getElementByValue(value);
                        if (!this_1.checkValidLi(item)) {
                            if (this_1.liCollections && this_1.liCollections.length === 100 && this_1.getModuleName() === "autocomplete" && this_1.listData.length > 100) this_1.setSelectionData(newProp.value, oldProp.value, "value");
                            else if (newProp.value && this_1.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                                var listLength_2 = this_1.getItems().length;
                                var checkField = (0, $3EnZW.isNullOrUndefined)(this_1.fields.value) ? this_1.fields.text : this_1.fields.value;
                                this_1.typedString = "";
                                var value_3 = this_1.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(newProp.value) ? (0, $3EnZW.getValue)(checkField, newProp.value) : newProp.value;
                                this_1.dataSource.executeQuery(this_1.getQuery(this_1.query).where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(checkField, "equal", value_3))).then(function(e) {
                                    if (e.result.length > 0) {
                                        _this.addItem(e.result, listLength_2);
                                        _this.updateValues();
                                    } else _this.setOldValue(oldProp.value);
                                });
                            } else if (this_1.getModuleName() === "autocomplete") this_1.setInputValue(newProp, oldProp);
                            else this_1.setOldValue(oldProp.value);
                        }
                        this_1.updateInputFields();
                        this_1.preventChange = this_1.isAngular && this_1.preventChange ? !this_1.preventChange : this_1.preventChange;
                    }
                    break;
                case "index":
                    if (this_1.fields.disabled) newProp.index = newProp.index != null && !this_1.isDisabledItemByIndex(newProp.index) ? newProp.index : null;
                    if (newProp.index === null) {
                        this_1.clearAll();
                        break;
                    }
                    if (!this_1.list) {
                        if (this_1.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this_1.initialRemoteRender = true;
                        this_1.renderList();
                    }
                    if (!this_1.initialRemoteRender && this_1.liCollections) {
                        var element = this_1.liCollections[newProp.index];
                        if (!this_1.checkValidLi(element)) {
                            if (this_1.liCollections && this_1.liCollections.length === 100 && this_1.getModuleName() === "autocomplete" && this_1.listData.length > 100) this_1.setSelectionData(newProp.index, oldProp.index, "index");
                            else this_1.index = oldProp.index;
                        }
                        this_1.updateInputFields();
                    }
                    break;
                case "footerTemplate":
                    if (this_1.popupObj) this_1.setFooterTemplate(this_1.popupObj.element);
                    break;
                case "headerTemplate":
                    if (this_1.popupObj) this_1.setHeaderTemplate(this_1.popupObj.element);
                    break;
                case "valueTemplate":
                    if (!(0, $3EnZW.isNullOrUndefined)(this_1.itemData) && this_1.valueTemplate !== null) this_1.setValueTemplate();
                    break;
                case "allowFiltering":
                    if (this_1.allowFiltering) {
                        this_1.actionCompleteData = {
                            ulElement: this_1.ulElement,
                            list: this_1.listData,
                            isUpdated: true
                        };
                        this_1.actionData = this_1.actionCompleteData;
                        this_1.updateSelectElementData(this_1.allowFiltering);
                    }
                    break;
                case "floatLabelType":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this_1.inputWrapper);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this_1.inputElement, newProp.floatLabelType, this_1.placeholder, this_1.createElement);
                    if (!(0, $3EnZW.isNullOrUndefined)(this_1.inputWrapper.buttons[0]) && this_1.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0] && this_1.floatLabelType !== "Never") this_1.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                    break;
                case "showClearButton":
                    if (!this_1.inputWrapper.clearButton) {
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(newProp.showClearButton, this_1.inputElement, this_1.inputWrapper, null, this_1.createElement);
                        this_1.bindClearEvent();
                    }
                    break;
                default:
                    // eslint-disable-next-line max-len
                    var ddlProps = this_1.getPropObject(prop, newProp, oldProp);
                    _super.prototype.onPropertyChanged.call(this_1, ddlProps.newProperty, ddlProps.oldProperty);
                    break;
            }
        };
        var this_1 = this;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            var state_1 = _loop_1(prop);
            if (typeof state_1 === "object") return state_1.value;
        }
    };
    DropDownList.prototype.checkValidLi = function(element) {
        if (this.isValidLI(element)) {
            this.setSelection(element, null);
            return true;
        }
        return false;
    };
    DropDownList.prototype.setSelectionData = function(newProp, oldProp, prop) {
        var _this = this;
        var li;
        this.updateListValues = function() {
            if (prop === "text") {
                li = _this.getElementByText(newProp);
                if (!_this.checkValidLi(li)) _this.setOldText(oldProp);
            } else if (prop === "value") {
                var fields = _this.fields.value ? _this.fields.value : "";
                var value = _this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(newProp) ? (0, $3EnZW.getValue)(fields, newProp) : newProp;
                li = _this.getElementByValue(newProp);
                if (!_this.checkValidLi(li)) _this.setOldValue(oldProp);
            } else if (prop === "index") {
                li = _this.liCollections[newProp];
                if (!_this.checkValidLi(li)) _this.index = oldProp;
            }
        };
    };
    DropDownList.prototype.updatePopupState = function() {
        if (this.beforePopupOpen) {
            this.beforePopupOpen = false;
            this.showPopup();
        }
    };
    DropDownList.prototype.setReadOnly = function() {
        if (this.readonly) (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], [
            "e-readonly"
        ]);
        else (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], [
            "e-readonly"
        ]);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
    DropDownList.prototype.setInputValue = function(newProp, oldProp) {};
    DropDownList.prototype.setCssClass = function(newClass, oldClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass)) oldClass = oldClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(newClass)) newClass = newClass.replace(/\s+/g, " ").trim();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newClass, [
            this.inputWrapper.container
        ], oldClass);
        if (this.popupObj) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newClass, [
            this.popupObj.element
        ], oldClass);
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ DropDownList.prototype.getModuleName = function() {
        return "dropdownlist";
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Opens the popup that displays the list of items.
     *
     * @returns {void}
     */ DropDownList.prototype.showPopup = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ if (!this.enabled) return;
        this.firstItem = this.dataSource && this.dataSource.length > 0 ? this.dataSource[0] : null;
        if (this.isReact && this.getModuleName() === "combobox" && this.itemTemplate && this.isCustomFilter && this.isAddNewItemTemplate) {
            this.renderList();
            this.isAddNewItemTemplate = false;
        }
        if (this.isFiltering() && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.actionData.list !== this.actionCompleteData.list && this.actionData.list && this.actionData.ulElement) {
            this.actionCompleteData = this.actionData;
            this.onActionComplete(this.actionCompleteData.ulElement, this.actionCompleteData.list, null, true);
        }
        if (this.beforePopupOpen) {
            this.refreshPopup();
            return;
        }
        this.beforePopupOpen = true;
        if (this.isFiltering() && !this.isActive && this.actionCompleteData.list && this.actionCompleteData.list[0]) {
            this.isActive = true;
            this.onActionComplete(this.actionCompleteData.ulElement, this.actionCompleteData.list, null, true);
        } else if ((0, $3EnZW.isNullOrUndefined)(this.list) || !(0, $3EnZW.isUndefined)(this.list) && (this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData) || this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li).length <= 0)) {
            if (this.isReact && this.isFiltering() && this.itemTemplate != null) this.isSecondClick = false;
            this.renderList(e);
        }
        if (this.enableVirtualization && this.listData && this.listData.length) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && (this.getModuleName() === "dropdownlist" || this.getModuleName() === "combobox")) this.removeHover();
            if (!this.beforePopupOpen) this.notify("setCurrentViewDataAsync", {
                module: "VirtualScroll"
            });
        }
        if (this.beforePopupOpen) this.invokeRenderPopup(e);
        if (this.enableVirtualization && !this.allowFiltering && this.selectedValueInfo != null && this.selectedValueInfo.startIndex > 0 && this.value != null) this.notify("dataProcessAsync", {
            module: "VirtualScroll",
            isOpen: true
        });
    };
    DropDownList.prototype.invokeRenderPopup = function(e) {
        if ((0, $5q7BP.Browser).isDevice && this.isFilterLayout()) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var proxy_2 = this;
            window.onpopstate = function() {
                proxy_2.hidePopup();
            };
            history.pushState({}, "");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.list) && (!(0, $3EnZW.isNullOrUndefined)(this.list.children[0]) || this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData))) this.renderPopup(e);
    };
    DropDownList.prototype.renderHightSearch = function() {
    // update high light search
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Hides the popup if it is in an open state.
     *
     * @returns {void}
     */ DropDownList.prototype.hidePopup = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ if (this.isEscapeKey && this.getModuleName() === "dropdownlist") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
            this.isEscapeKey = false;
            if (!(0, $3EnZW.isNullOrUndefined)(this.index)) {
                var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
                var element = this.findListElement(this.ulElement, "li", "data-value", value);
                this.selectedLI = this.liCollections[this.index] || element;
                if (this.selectedLI) {
                    this.updateSelectedItem(this.selectedLI, null, true);
                    if (this.valueTemplate && this.itemData !== null) this.setValueTemplate();
                }
            } else this.resetSelection();
        }
        this.isVirtualTrackHeight = false;
        this.customFilterQuery = null;
        this.closePopup(0, e);
        var dataItem = this.getItemData();
        var isSelectVal = !(0, $3EnZW.isNullOrUndefined)(this.selectedLI);
        if (isSelectVal && this.enableVirtualization && this.selectedLI.classList) isSelectVal = this.selectedLI.classList.contains("e-active");
        if (this.inputElement && this.inputElement.value.trim() === "" && !this.isInteracted && (this.isSelectCustom || isSelectVal && this.inputElement.value !== dataItem.text)) {
            this.isSelectCustom = false;
            this.clearAll(e);
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Sets the focus on the component for interaction.
     *
     * @returns {void}
     */ DropDownList.prototype.focusIn = function(e) {
        if (!this.enabled) return;
        if (this.targetElement().classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.disable)) return;
        var isFocused = false;
        if (this.preventFocus && (0, $5q7BP.Browser).isDevice) {
            this.inputWrapper.container.tabIndex = 1;
            this.inputWrapper.container.focus();
            this.preventFocus = false;
            isFocused = true;
        }
        if (!isFocused) this.targetElement().focus();
        (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], [
            $e5d35cabace4110f$export$9787c7b65ab00376.inputFocus
        ]);
        this.onFocus(e);
        if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
    };
    /**
     * Moves the focus from the component if the component is already focused.
     *
     * @returns {void}
     */ DropDownList.prototype.focusOut = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ if (!this.enabled) return;
        if (!this.enableVirtualization && (this.getModuleName() === "combobox" || this.getModuleName() === "autocomplete")) this.isTyped = true;
        this.hidePopup(e);
        if (this.targetElement()) this.targetElement().blur();
        (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], [
            $e5d35cabace4110f$export$9787c7b65ab00376.inputFocus
        ]);
        if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
    };
    /**
     * Method to disable specific item in the popup.
     *
     * @param {string | number | object | HTMLLIElement} item - Specifies the item to be disabled.
     * @returns {void}

     */ DropDownList.prototype.disableItem = function(item) {
        if (this.fields.disabled) {
            if (!this.list) this.renderList();
            var itemIndex = -1;
            if (this.liCollections && this.liCollections.length > 0 && this.listData && this.fields.disabled) {
                if (typeof item === "string") itemIndex = this.getIndexByValue(item);
                else if (typeof item === "object") {
                    if (item instanceof HTMLLIElement) {
                        for(var index = 0; index < this.liCollections.length; index++)if (this.liCollections[index] === item) {
                            itemIndex = this.getIndexByValue(item.getAttribute("data-value"));
                            break;
                        }
                    } else {
                        var value = JSON.parse(JSON.stringify(item))[this.fields.value];
                        for(var index = 0; index < this.listData.length; index++)if (JSON.parse(JSON.stringify(this.listData[index]))[this.fields.value] === value) {
                            itemIndex = this.getIndexByValue(value);
                            break;
                        }
                    }
                } else itemIndex = item;
                var isValidIndex = itemIndex < this.liCollections.length && itemIndex > -1;
                if (isValidIndex && !JSON.parse(JSON.stringify(this.listData[itemIndex]))[this.fields.disabled]) {
                    var li = this.liCollections[itemIndex];
                    if (li) {
                        this.disableListItem(li);
                        var parsedData = JSON.parse(JSON.stringify(this.listData[itemIndex]));
                        parsedData[this.fields.disabled] = true;
                        this.listData[itemIndex] = parsedData;
                        this.dataSource = this.listData;
                        if (li.classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.focus)) this.removeFocus();
                        if (li.classList.contains($e5d35cabace4110f$export$9787c7b65ab00376.selected)) this.clear();
                    }
                }
            }
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ DropDownList.prototype.destroy = function() {
        this.isActive = false;
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        (0, $2b58887f1686dbd7$export$4f33f295bddc1094)(this.element.id);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) this.clearTemplate();
        this.hidePopup();
        if (this.popupObj) this.popupObj.hide();
        this.unWireEvent();
        if (this.list) this.unWireListEvents();
        if (this.element && !this.element.classList.contains("e-" + this.getModuleName())) return;
        if (this.inputElement) {
            var attrArray = [
                "readonly",
                "aria-disabled",
                "placeholder",
                "aria-labelledby",
                "aria-expanded",
                "autocomplete",
                "aria-readonly",
                "autocapitalize",
                "spellcheck",
                "aria-autocomplete",
                "aria-live",
                "aria-describedby",
                "aria-label"
            ];
            for(var i = 0; i < attrArray.length; i++)this.inputElement.removeAttribute(attrArray[i]);
            this.inputElement.setAttribute("tabindex", this.tabIndex);
            this.inputElement.classList.remove("e-input");
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue("", this.inputElement, this.floatLabelType, this.showClearButton);
        }
        this.element.style.display = "block";
        if (this.inputWrapper.container && this.inputWrapper.container.parentElement) {
            if (this.inputWrapper.container.parentElement.tagName === this.getNgDirective()) (0, $4ZDHT.detach)(this.inputWrapper.container);
            else {
                this.inputWrapper.container.parentElement.insertBefore(this.element, this.inputWrapper.container);
                (0, $4ZDHT.detach)(this.inputWrapper.container);
            }
        }
        delete this.hiddenElement;
        this.filterInput = null;
        this.keyboardModule = null;
        this.ulElement = null;
        this.list = null;
        this.clearIconElement = null;
        this.popupObj = null;
        this.popupContentElement = null;
        this.rippleFun = null;
        this.selectedLI = null;
        this.liCollections = null;
        this.item = null;
        this.footer = null;
        this.header = null;
        this.previousSelectedLI = null;
        this.valueTempElement = null;
        this.actionData.ulElement = null;
        if (this.inputElement && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.onchange)) this.inputElement.onchange = null;
        if (this.inputElement && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.onselect)) this.inputElement.onselect = null;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.inputElement,
            floatLabelType: this.floatLabelType,
            properties: this.properties,
            buttons: this.inputWrapper.container.querySelectorAll(".e-input-group-icon")[0]
        }, this.clearButton);
        this.clearButton = null;
        this.inputElement = null;
        this.inputWrapper = null;
        _super.prototype.destroy.call(this);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets all the list items bound on this component.
     *
     * @returns {Element[]}
     */ DropDownList.prototype.getItems = function() {
        if (!this.list) {
            if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.initialRemoteRender = true;
            this.renderList();
        }
        return this.ulElement ? _super.prototype.getItems.call(this) : [];
    };
    /**
     * Gets the data Object that matches the given value.
     *
     * @param { string | number } value - Specifies the value of the list item.
     * @returns {Object}
     */ DropDownList.prototype.getDataByValue = function(value) {
        return _super.prototype.getDataByValue.call(this, value);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Allows you to clear the selected values from the component.
     *
     * @returns {void}
     */ DropDownList.prototype.clear = function() {
        this.value = null;
    };
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "cssClass", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], DropDownList.prototype, "width", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DropDownList.prototype, "enabled", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "enablePersistence", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)("300px")
    ], DropDownList.prototype, "popupHeight", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], DropDownList.prototype, "popupWidth", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "placeholder", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "filterBarPlaceholder", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)({})
    ], DropDownList.prototype, "htmlAttributes", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "query", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "valueTemplate", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "headerTemplate", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "footerTemplate", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "allowFiltering", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DropDownList.prototype, "isDeviceFullScreen", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "readonly", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "enableVirtualization", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "text", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "value", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "allowObjectBinding", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DropDownList.prototype, "index", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], DropDownList.prototype, "floatLabelType", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownList.prototype, "showClearButton", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "filtering", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "change", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "beforeOpen", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "open", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "close", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "blur", void 0);
    $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownList.prototype, "focus", void 0);
    DropDownList = $e5d35cabace4110f$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], DropDownList);
    return DropDownList;
}((0, $8333a85b68b3ebf8$export$7dc99c6c1af7b42));






var $7ca2c62dd20a2561$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7ca2c62dd20a2561$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ca2c62dd20a2561$var$SPINNER_CLASS = "e-atc-spinner-icon";
(0, $e5d35cabace4110f$export$9787c7b65ab00376).root = "e-combobox";
var $7ca2c62dd20a2561$var$inputObject = {
    container: null,
    buttons: []
};
/**
 * The ComboBox component allows the user to type a value or choose an option from the list of predefined options.
 * ```html
 * <select id="list">
 *      <option value='1'>Badminton</option>
 *      <option value='2'>Basketball</option>
 *      <option value='3'>Cricket</option>
 *      <option value='4'>Football</option>
 *      <option value='5'>Tennis</option>
 * </select>
 * ```
 * ```typescript
 *   let games:ComboBox = new ComboBox();
 *   games.appendTo("#list");
 * ```
 */ var $7ca2c62dd20a2561$export$72b9695b8216309a = /** @class */ function(_super) {
    $7ca2c62dd20a2561$var$__extends(ComboBox, _super);
    /**
     * *Constructor for creating the component
     *
     * @param {ComboBoxModel} options - Specifies the ComboBox model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function ComboBox(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */ ComboBox.prototype.preRender = function() {
        _super.prototype.preRender.call(this);
    };
    ComboBox.prototype.getLocaleName = function() {
        return "combo-box";
    };
    ComboBox.prototype.wireEvent = function() {
        if (this.getModuleName() === "combobox") {
            (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "mousedown", this.preventBlur, this);
            (0, $aqzbR.EventHandler).add(this.inputWrapper.container, "blur", this.onBlurHandler, this);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0])) (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "mousedown", this.dropDownClick, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "focus", this.targetFocus, this);
        if (!this.readonly) {
            (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.onInput, this);
            (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.onFilterUp, this);
            (0, $aqzbR.EventHandler).add(this.inputElement, "keydown", this.onFilterDown, this);
            (0, $aqzbR.EventHandler).add(this.inputElement, "paste", this.pasteHandler, this);
            (0, $aqzbR.EventHandler).add(window, "resize", this.windowResize, this);
        }
        this.bindCommonEvent();
    };
    ComboBox.prototype.preventBlur = function(e) {
        if (!this.allowFiltering && document.activeElement !== this.inputElement && !document.activeElement.classList.contains((0, $e5d35cabace4110f$export$9787c7b65ab00376).input) && (0, $5q7BP.Browser).isDevice || !(0, $5q7BP.Browser).isDevice) e.preventDefault();
    };
    ComboBox.prototype.onBlurHandler = function(e) {
        var inputValue = this.inputElement && this.inputElement.value === "" ? null : this.inputElement && this.inputElement.value;
        if (!(0, $3EnZW.isNullOrUndefined)(this.listData) && !(0, $3EnZW.isNullOrUndefined)(inputValue) && inputValue !== this.text) this.customValue(e);
        _super.prototype.onBlurHandler.call(this, e);
    };
    ComboBox.prototype.targetElement = function() {
        return this.inputElement;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ComboBox.prototype.setOldText = function(text) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
        this.customValue();
        this.removeSelection();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ComboBox.prototype.setOldValue = function(value) {
        if (this.allowCustom) this.valueMuteChange(this.value);
        else this.valueMuteChange(null);
        this.removeSelection();
        this.setHiddenValue();
    };
    ComboBox.prototype.valueMuteChange = function(value) {
        value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
        var inputValue = (0, $3EnZW.isNullOrUndefined)(value) ? null : value.toString();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(inputValue, this.inputElement, this.floatLabelType, this.showClearButton);
        var changeData = {};
        if (this.allowObjectBinding) {
            value = this.getDataByValue(value);
            if ((0, $3EnZW.isNullOrUndefined)(value)) {
                var fields_1 = this.fields;
                var isvalidTextField_1 = false;
                var isValidValue_1 = false;
                if (this.allowObjectBinding) {
                    var keys = Object.keys(this.value);
                    keys.forEach(function(key) {
                        if (key === fields_1.value) {
                            isValidValue_1 = true;
                            return;
                        }
                    });
                    keys.forEach(function(key) {
                        if (key === fields_1.text) {
                            isvalidTextField_1 = true;
                            return;
                        }
                    });
                }
                changeData = {
                    text: isValidValue_1 ? isvalidTextField_1 ? (0, $3EnZW.getValue)(fields_1.text, this.value) : (0, $3EnZW.getValue)(fields_1.value, this.value) : null,
                    value: isValidValue_1 ? this.value : null,
                    index: null
                };
            }
        }
        if (this.allowObjectBinding) this.setProperties(changeData, true);
        else this.setProperties({
            value: value,
            text: value ? value.toString() : value,
            index: null
        }, true);
        this.activeIndex = this.index;
        var fields = this.fields;
        var dataItem = {};
        dataItem[fields.text] = (0, $3EnZW.isNullOrUndefined)(value) ? null : value.toString();
        dataItem[fields.value] = (0, $3EnZW.isNullOrUndefined)(value) ? null : value.toString();
        this.itemData = dataItem;
        this.item = null;
        if (!this.allowObjectBinding && this.previousValue !== this.value || this.allowObjectBinding && this.previousValue && this.value && !this.isObjectInArray(this.previousValue, [
            this.value
        ])) this.detachChangeEvent(null);
    };
    ComboBox.prototype.updateValues = function() {
        if (this.fields.disabled) {
            if (this.value != null) this.value = !this.isDisableItemValue(this.value) ? this.value : null;
            if (this.text != null) this.text = !this.isDisabledItemByIndex(this.getIndexByValue(this.getValueByText(this.text))) ? this.text : null;
            if (this.index != null) {
                this.index = !this.isDisabledItemByIndex(this.index) ? this.index : null;
                this.activeIndex = this.index;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var currentValue = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
            var li = this.getElementByValue(currentValue);
            var doesItemExist = !(0, $3EnZW.isNullOrUndefined)(li) ? true : false;
            if (this.enableVirtualization && this.value) {
                var fields = this.fields.value ? this.fields.value : "";
                var currentValue_1 = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
                if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                    var getItem = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.virtualGroupDataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields, "equal", currentValue_1)));
                    if (getItem && getItem.length > 0) {
                        this.itemData = getItem[0];
                        doesItemExist = true;
                        var dataItem = this.getItemData();
                        var value = this.allowObjectBinding ? this.getDataByValue(dataItem.value) : dataItem.value;
                        if (this.value === dataItem.value && this.text !== dataItem.text || this.value !== dataItem.value && this.text === dataItem.text) this.setProperties({
                            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
                            "value": value
                        });
                    }
                } else {
                    var getItem = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields, "equal", currentValue_1)));
                    if (getItem && getItem.length > 0) {
                        this.itemData = getItem[0];
                        doesItemExist = true;
                        var dataItem = this.getItemData();
                        var value = this.allowObjectBinding ? this.getDataByValue(dataItem.value) : dataItem.value;
                        if (this.value === dataItem.value && this.text !== dataItem.text || this.value !== dataItem.value && this.text === dataItem.text) this.setProperties({
                            "text": dataItem.text ? dataItem.text.toString() : dataItem.text,
                            "value": value
                        });
                    }
                }
            }
            if (li) this.setSelection(li, null);
            else if (!this.enableVirtualization && this.allowCustom || this.allowCustom && this.enableVirtualization && !doesItemExist) this.valueMuteChange(this.value);
            else if (!this.enableVirtualization || this.enableVirtualization && !doesItemExist) this.valueMuteChange(null);
        } else if (this.text && (0, $3EnZW.isNullOrUndefined)(this.value)) {
            var li = this.getElementByText(this.text);
            if (li) this.setSelection(li, null);
            else {
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
                this.customValue();
            }
        } else this.setSelection(this.liCollections[this.activeIndex], null);
        this.setHiddenValue();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.text, this.inputElement, this.floatLabelType, this.showClearButton);
    };
    ComboBox.prototype.updateIconState = function() {
        if (this.showClearButton) {
            if (this.inputElement && this.inputElement.value !== "" && !this.readonly) (0, $4ZDHT.removeClass)([
                this.inputWrapper.clearButton
            ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).clearIconHide);
            else (0, $4ZDHT.addClass)([
                this.inputWrapper.clearButton
            ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).clearIconHide);
        }
    };
    ComboBox.prototype.getAriaAttributes = function() {
        var ariaAttributes = {
            "role": "combobox",
            "aria-autocomplete": "both",
            "aria-labelledby": this.hiddenElement.id,
            "aria-expanded": "false",
            "aria-readonly": this.readonly ? this.readonly.toString() : "false",
            "autocomplete": "off",
            "autocapitalize": "off",
            "spellcheck": "false"
        };
        return ariaAttributes;
    };
    ComboBox.prototype.searchLists = function(e) {
        this.isTyped = true;
        if (this.isFiltering()) {
            _super.prototype.searchLists.call(this, e);
            if (this.ulElement && this.filterInput.value.trim() === "") this.setHoverList(this.ulElement.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).li));
        } else {
            if (this.ulElement && this.inputElement.value === "" && this.preventAutoFill) this.setHoverList(this.ulElement.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).li));
            this.incrementalSearch(e);
        }
    };
    ComboBox.prototype.getNgDirective = function() {
        return "EJS-COMBOBOX";
    };
    ComboBox.prototype.setSearchBox = function() {
        this.filterInput = this.inputElement;
        var searchBoxContainer = this.isFiltering() || this.isReact && this.getModuleName() === "combobox" ? this.inputWrapper : $7ca2c62dd20a2561$var$inputObject;
        return searchBoxContainer;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ComboBox.prototype.onActionComplete = function(ulElement, list, e, isUpdated) {
        var _this = this;
        _super.prototype.onActionComplete.call(this, ulElement, list, e);
        if (this.isSelectCustom) this.removeSelection();
        if (!this.preventAutoFill && this.getModuleName() === "combobox" && this.isTyped && !this.enableVirtualization) setTimeout(function() {
            _this.inlineSearch();
        });
    };
    ComboBox.prototype.getFocusElement = function() {
        var dataItem = this.isSelectCustom ? {
            text: ""
        } : this.getItemData();
        var selected = !(0, $3EnZW.isNullOrUndefined)(this.list) ? this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).selected) : this.list;
        var isSelected = dataItem.text && dataItem.text.toString() === this.inputElement.value && !(0, $3EnZW.isNullOrUndefined)(selected);
        if (isSelected) return selected;
        if (((0, $5q7BP.Browser).isDevice && !this.isDropDownClick || !(0, $5q7BP.Browser).isDevice) && !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && this.liCollections.length > 0) {
            var inputValue = this.inputElement.value;
            var dataSource = this.sortedData;
            var type = this.typeOfData(dataSource).typeof;
            var activeItem = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(inputValue, this.liCollections, this.filterType, true, dataSource, this.fields, type);
            if (this.enableVirtualization && inputValue !== "" && this.getModuleName() !== "autocomplete" && this.isTyped && !this.allowFiltering) {
                var updatingincrementalindex = false;
                var isEndIndexValid = this.viewPortInfo.endIndex >= this.incrementalEndIndex && this.incrementalEndIndex <= this.totalItemCount;
                var isIncrementalEndIndexZero = this.incrementalEndIndex === 0;
                if (isEndIndexValid || isIncrementalEndIndexZero) {
                    updatingincrementalindex = true;
                    this.incrementalStartIndex = this.incrementalEndIndex;
                    if (isIncrementalEndIndexZero) this.incrementalEndIndex = Math.min(100, this.totalItemCount);
                    else this.incrementalEndIndex = Math.min(this.incrementalEndIndex + 100, this.totalItemCount);
                    this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                    updatingincrementalindex = true;
                }
                if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                activeItem = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(inputValue, this.incrementalLiCollections, this.filterType, true, dataSource, this.fields, type);
                while((0, $3EnZW.isNullOrUndefined)(activeItem.item) && this.incrementalEndIndex < this.totalItemCount){
                    this.incrementalStartIndex = this.incrementalEndIndex;
                    this.incrementalEndIndex = this.incrementalEndIndex + 100 > this.totalItemCount ? this.totalItemCount : this.incrementalEndIndex + 100;
                    this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                    updatingincrementalindex = true;
                    if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                    activeItem = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(inputValue, this.incrementalLiCollections, this.filterType, true, dataSource, this.fields, type);
                    if (!(0, $3EnZW.isNullOrUndefined)(activeItem)) {
                        activeItem.index = activeItem.index + this.incrementalStartIndex;
                        break;
                    }
                    if ((0, $3EnZW.isNullOrUndefined)(activeItem) && this.incrementalEndIndex >= this.totalItemCount) {
                        this.incrementalStartIndex = 0;
                        this.incrementalEndIndex = 100 > this.totalItemCount ? this.totalItemCount : 100;
                        break;
                    }
                }
                var startIndex = activeItem.index - (this.itemCount / 2 - 2) > 0 ? activeItem.index - (this.itemCount / 2 - 2) : 0;
                var endIndex = this.viewPortInfo.startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : this.viewPortInfo.startIndex + this.itemCount;
                if (startIndex !== this.viewPortInfo.startIndex) this.updateIncrementalView(startIndex, endIndex);
                if (!(0, $3EnZW.isNullOrUndefined)(activeItem.item)) {
                    var startIndex_1 = this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) < this.totalItemCount ? this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) : this.totalItemCount;
                    var endIndex_1 = this.viewPortInfo.startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : this.viewPortInfo.startIndex + this.itemCount;
                    this.updateIncrementalView(startIndex_1, endIndex_1);
                    activeItem.item = this.getElementByValue(activeItem.item.getAttribute("data-value"));
                } else {
                    this.updateIncrementalView(0, this.itemCount);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                    this.list.scrollTop = 0;
                }
                if (activeItem && activeItem.item) activeItem.item = this.getElementByValue(activeItem.item.getAttribute("data-value"));
            }
            var activeElement = activeItem.item;
            if (!(0, $3EnZW.isNullOrUndefined)(activeElement)) {
                var count = this.getIndexByValue(activeElement.getAttribute("data-value")) - 1;
                var height = parseInt(getComputedStyle(this.liCollections[0], null).getPropertyValue("height"), 10);
                if (!isNaN(height) && this.getModuleName() !== "autocomplete") {
                    this.removeFocus();
                    var fixedHead = this.fields.groupBy ? this.liCollections[0].offsetHeight : 0;
                    if (!this.enableVirtualization) this.list.scrollTop = count * height + fixedHead;
                    else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var virtualContent = this.list.getElementsByClassName("e-virtual-ddl-content")[0];
                        virtualContent.style = this.getTransformValues();
                        if (this.enableVirtualization && !this.fields.groupBy) {
                            var selectedLiOffsetTop = activeElement.offsetTop;
                            var virtualListInfoStartIndex = this.virtualListInfo && this.virtualListInfo.startIndex ? this.virtualListInfo.startIndex : 0;
                            var virtualListHeight = activeElement.offsetHeight;
                            var selectedLiOffsetTopWithStartIndex = selectedLiOffsetTop + virtualListInfoStartIndex * virtualListHeight;
                            var virtualListLength = this.list.querySelectorAll(".e-virtual-list").length;
                            var scrollTopOffset = virtualListLength * virtualListHeight;
                            this.list.scrollTop = selectedLiOffsetTopWithStartIndex - scrollTopOffset;
                        }
                    }
                    (0, $4ZDHT.addClass)([
                        activeElement
                    ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).focus);
                }
            } else if (this.isSelectCustom && this.inputElement.value.trim() !== "") {
                this.removeFocus();
                if (!this.enableVirtualization) this.list.scrollTop = 0;
            }
            return activeElement;
        } else return null;
    };
    ComboBox.prototype.setValue = function(e) {
        if (e && e.type === "keydown" && e.action === "enter" || e && e.type === "click") this.removeFillSelection();
        if (this.autofill && this.getModuleName() === "combobox" && e && e.type === "keydown" && e.action !== "enter") {
            this.preventAutoFill = false;
            this.inlineSearch(e);
            return false;
        } else return _super.prototype.setValue.call(this, e);
    };
    ComboBox.prototype.checkCustomValue = function() {
        var value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
        this.itemData = this.getDataByValue(value);
        var dataItem = this.getItemData();
        var setValue = this.allowObjectBinding ? this.itemData : dataItem.value;
        if (!(this.allowCustom && (0, $3EnZW.isNullOrUndefined)(dataItem.value) && (0, $3EnZW.isNullOrUndefined)(dataItem.text))) this.setProperties({
            "value": setValue
        }, !this.allowCustom);
    };
    /**
     * Shows the spinner loader.
     *
     * @returns {void}

     */ ComboBox.prototype.showSpinner = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            this.spinnerElement = this.getModuleName() === "autocomplete" ? this.inputWrapper.buttons[0] || this.inputWrapper.clearButton || (0, $168e4e125732cd26$export$f5b8910cec6cf069).appendSpan("e-input-group-icon " + $7ca2c62dd20a2561$var$SPINNER_CLASS, this.inputWrapper.container, this.createElement) : this.inputWrapper.buttons[0] || this.inputWrapper.clearButton;
            (0, $4ZDHT.addClass)([
                this.spinnerElement
            ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).disableIcon);
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.spinnerElement,
                width: (0, $5q7BP.Browser).isDevice ? "16px" : "14px"
            }, this.createElement);
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinnerElement);
        }
    };
    /**
     * Hides the spinner loader.
     *
     * @returns {void}

     */ ComboBox.prototype.hideSpinner = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinnerElement);
            (0, $4ZDHT.removeClass)([
                this.spinnerElement
            ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).disableIcon);
            if (this.spinnerElement.classList.contains($7ca2c62dd20a2561$var$SPINNER_CLASS)) (0, $4ZDHT.detach)(this.spinnerElement);
            else this.spinnerElement.innerHTML = "";
            this.spinnerElement = null;
        }
    };
    ComboBox.prototype.setAutoFill = function(activeElement, isHover) {
        if (!isHover) this.setHoverList(activeElement);
        if (this.autofill && !this.preventAutoFill) {
            var currentValue = this.getTextByValue(activeElement.getAttribute("data-value")).toString();
            var currentFillValue = this.getFormattedValue(activeElement.getAttribute("data-value"));
            if (this.getModuleName() === "combobox") {
                if (!this.isSelected && !this.allowObjectBinding && this.previousValue !== currentFillValue || this.allowObjectBinding && this.previousValue && currentFillValue && !this.isObjectInArray(this.previousValue, [
                    this.getDataByValue(currentFillValue)
                ])) {
                    this.updateSelectedItem(activeElement, null);
                    this.isSelected = true;
                    this.previousValue = this.allowObjectBinding ? this.getDataByValue(this.getFormattedValue(activeElement.getAttribute("data-value"))) : this.getFormattedValue(activeElement.getAttribute("data-value"));
                } else this.updateSelectedItem(activeElement, null, true);
            }
            if (!this.isAndroidAutoFill(currentValue)) this.setAutoFillSelection(currentValue, isHover);
        }
    };
    ComboBox.prototype.isAndroidAutoFill = function(value) {
        if ((0, $5q7BP.Browser).isAndroid) {
            var currentPoints = this.getSelectionPoints();
            var prevEnd = this.prevSelectPoints.end;
            var curEnd = currentPoints.end;
            var prevStart = this.prevSelectPoints.start;
            var curStart = currentPoints.start;
            if (prevEnd !== 0 && (prevEnd === value.length && prevStart === value.length || prevStart > curStart && prevEnd > curEnd || prevEnd === curEnd && prevStart === curStart)) return true;
            else return false;
        } else return false;
    };
    ComboBox.prototype.clearAll = function(e, property) {
        if ((0, $3EnZW.isNullOrUndefined)(property) || !(0, $3EnZW.isNullOrUndefined)(property) && (0, $3EnZW.isNullOrUndefined)(property.dataSource)) _super.prototype.clearAll.call(this, e);
        if (this.isFiltering() && !(0, $3EnZW.isNullOrUndefined)(e) && e.target === this.inputWrapper.clearButton) this.searchLists(e);
    };
    ComboBox.prototype.isSelectFocusItem = function(element) {
        return !(0, $3EnZW.isNullOrUndefined)(element);
    };
    ComboBox.prototype.inlineSearch = function(e) {
        var isKeyNavigate = e && (e.action === "down" || e.action === "up" || e.action === "home" || e.action === "end" || e.action === "pageUp" || e.action === "pageDown");
        var activeElement = isKeyNavigate ? this.liCollections[this.activeIndex] : this.getFocusElement();
        if (!(0, $3EnZW.isNullOrUndefined)(activeElement)) {
            if (!isKeyNavigate) {
                var value = this.getFormattedValue(activeElement.getAttribute("data-value"));
                this.activeIndex = this.getIndexByValue(value);
                this.activeIndex = !(0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? this.activeIndex : null;
            }
            this.preventAutoFill = this.inputElement.value === "" ? false : this.preventAutoFill;
            this.setAutoFill(activeElement, isKeyNavigate);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement) && this.inputElement.value === "") {
            this.activeIndex = null;
            if (!(0, $3EnZW.isNullOrUndefined)(this.list)) {
                if (!this.enableVirtualization) this.list.scrollTop = 0;
                var focusItem = this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).li);
                this.setHoverList(focusItem);
            }
        } else {
            this.activeIndex = null;
            this.removeSelection();
            if (this.liCollections && this.liCollections.length > 0 && !this.isCustomFilter) this.removeFocus();
        }
    };
    ComboBox.prototype.incrementalSearch = function(e) {
        this.showPopup(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.listData)) {
            this.inlineSearch(e);
            e.preventDefault();
        }
    };
    ComboBox.prototype.setAutoFillSelection = function(currentValue, isKeyNavigate) {
        if (isKeyNavigate === void 0) isKeyNavigate = false;
        var selection = this.getSelectionPoints();
        var value = this.inputElement.value.substr(0, selection.start);
        if (value && value.toLowerCase() === currentValue.substr(0, selection.start).toLowerCase()) {
            var inputValue = value + currentValue.substr(value.length, currentValue.length);
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(inputValue, this.inputElement, this.floatLabelType, this.showClearButton);
            this.inputElement.setSelectionRange(selection.start, this.inputElement.value.length);
        } else if (isKeyNavigate) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(currentValue, this.inputElement, this.floatLabelType, this.showClearButton);
            this.inputElement.setSelectionRange(0, this.inputElement.value.length);
        }
    };
    ComboBox.prototype.getValueByText = function(text) {
        return _super.prototype.getValueByText.call(this, text, true, this.ignoreAccent);
    };
    ComboBox.prototype.unWireEvent = function() {
        if (this.getModuleName() === "combobox") {
            (0, $aqzbR.EventHandler).remove(this.inputWrapper.buttons[0], "mousedown", this.preventBlur);
            (0, $aqzbR.EventHandler).remove(this.inputWrapper.container, "blur", this.onBlurHandler);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0])) (0, $aqzbR.EventHandler).remove(this.inputWrapper.buttons[0], "mousedown", this.dropDownClick);
        if (this.inputElement) {
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.targetFocus);
            if (!this.readonly) {
                (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.onInput);
                (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.onFilterUp);
                (0, $aqzbR.EventHandler).remove(this.inputElement, "keydown", this.onFilterDown);
                (0, $aqzbR.EventHandler).remove(this.inputElement, "paste", this.pasteHandler);
                (0, $aqzbR.EventHandler).remove(window, "resize", this.windowResize);
            }
        }
        this.unBindCommonEvent();
    };
    ComboBox.prototype.setSelection = function(li, e) {
        _super.prototype.setSelection.call(this, li, e);
        if (!(0, $3EnZW.isNullOrUndefined)(li) && !this.autofill && !this.isDropDownClick) this.removeFocus();
    };
    ComboBox.prototype.selectCurrentItem = function(e) {
        var li;
        if (this.isPopupOpen) {
            if (this.isSelected) li = this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).selected);
            else li = this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).focus);
            if (this.isDisabledElement(li)) return;
            if (li) {
                this.setSelection(li, e);
                this.isTyped = false;
            }
            if (this.isSelected) {
                this.isSelectCustom = false;
                this.onChangeEvent(e);
            }
        }
        if (e.action === "enter" && this.inputElement.value.trim() === "") this.clearAll(e);
        else if (this.isTyped && !this.isSelected && (0, $3EnZW.isNullOrUndefined)(li)) this.customValue(e);
        this.hidePopup(e);
    };
    ComboBox.prototype.setHoverList = function(li) {
        this.removeSelection();
        if (this.isValidLI(li) && !li.classList.contains((0, $e5d35cabace4110f$export$9787c7b65ab00376).selected)) {
            this.removeFocus();
            li.classList.add((0, $e5d35cabace4110f$export$9787c7b65ab00376).focus);
        }
    };
    ComboBox.prototype.targetFocus = function(e) {
        if ((0, $5q7BP.Browser).isDevice && !this.allowFiltering) this.preventFocus = false;
        this.onFocus(e);
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
    };
    ComboBox.prototype.dropDownClick = function(e) {
        e.preventDefault();
        if ((0, $5q7BP.Browser).isDevice && !this.isFiltering()) this.preventFocus = true;
        _super.prototype.dropDownClick.call(this, e);
    };
    ComboBox.prototype.customValue = function(e) {
        var _this = this;
        var value = this.getValueByText(this.inputElement.value);
        if (!this.allowCustom && this.inputElement.value !== "") {
            var previousValue = this.previousValue;
            var currentValue = this.value;
            value = this.allowObjectBinding ? this.getDataByValue(value) : value;
            this.setProperties({
                value: value
            });
            if ((0, $3EnZW.isNullOrUndefined)(this.value)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue("", this.inputElement, this.floatLabelType, this.showClearButton);
            if (this.autofill && (!this.allowObjectBinding && previousValue === this.value || this.allowObjectBinding && previousValue && this.isObjectInArray(previousValue, [
                this.value
            ])) && (!this.allowObjectBinding && currentValue !== this.value || this.allowObjectBinding && currentValue && !this.isObjectInArray(currentValue, [
                this.value
            ]))) this.onChangeEvent(null);
        } else if (this.inputElement.value.trim() !== "") {
            var previousValue_1 = this.value;
            if ((0, $3EnZW.isNullOrUndefined)(value)) {
                var value_1 = this.inputElement.value === "" ? null : this.inputElement.value;
                // eslint-disable-next-line max-len
                var eventArgs = {
                    text: value_1,
                    item: {}
                };
                this.isObjectCustomValue = true;
                if (!this.initial) this.trigger("customValueSpecifier", eventArgs, function(eventArgs) {
                    _this.updateCustomValueCallback(value_1, eventArgs, previousValue_1, e);
                });
                else this.updateCustomValueCallback(value_1, eventArgs, previousValue_1);
            } else {
                this.isSelectCustom = false;
                value = this.allowObjectBinding ? this.getDataByValue(value) : value;
                this.setProperties({
                    value: value
                });
                if (!this.allowObjectBinding && previousValue_1 !== this.value || this.allowObjectBinding && previousValue_1 && this.value && !this.isObjectInArray(previousValue_1, [
                    this.value
                ])) this.onChangeEvent(e);
            }
        } else if (this.allowCustom && this.isFocused) this.isSelectCustom = true;
    };
    ComboBox.prototype.updateCustomValueCallback = function(value, eventArgs, previousValue, e) {
        var _this = this;
        var fields = this.fields;
        var item = eventArgs.item;
        var dataItem = {};
        if (item && (0, $3EnZW.getValue)(fields.text, item) && (0, $3EnZW.getValue)(fields.value, item)) dataItem = item;
        else {
            (0, $3EnZW.setValue)(fields.text, value, dataItem);
            (0, $3EnZW.setValue)(fields.value, value, dataItem);
        }
        this.itemData = dataItem;
        var emptyObject = {};
        if (this.allowObjectBinding) {
            var keys = this.listData && this.listData.length > 0 ? Object.keys(this.listData[0]) : Object.keys(this.itemData);
            if (!(this.listData && this.listData.length > 0) && (this.getModuleName() === "autocomplete" || this.getModuleName() === "combobox" && this.allowFiltering)) keys = this.firstItem ? Object.keys(this.firstItem) : Object.keys(this.itemData);
            // Create an empty object with predefined keys
            keys.forEach(function(key) {
                emptyObject[key] = key === fields.value || key === fields.text ? (0, $3EnZW.getValue)(fields.value, _this.itemData) : null;
            });
        }
        var changeData = {
            text: (0, $3EnZW.getValue)(fields.text, this.itemData),
            value: this.allowObjectBinding ? emptyObject : (0, $3EnZW.getValue)(fields.value, this.itemData),
            index: null
        };
        this.setProperties(changeData, true);
        this.setSelection(null, null);
        this.isSelectCustom = true;
        this.isObjectCustomValue = false;
        if (!this.allowObjectBinding && previousValue !== this.value || this.allowObjectBinding && (previousValue == null && this.value !== null || previousValue && !this.isObjectInArray(previousValue, [
            this.value
        ]))) this.onChangeEvent(e, true);
    };
    /**
     * Dynamically change the value of properties.
     *
     * @param {ComboBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {ComboBoxModel} oldProp - Returns the previous property value of the component.
     * @private
     * @returns {void}
     */ ComboBox.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (this.getModuleName() === "combobox") {
            this.checkData(newProp);
            this.setUpdateInitial([
                "fields",
                "query",
                "dataSource"
            ], newProp, oldProp);
        }
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.inputElement);
                    if (this.readonly) {
                        (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.onInput);
                        (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.onFilterUp);
                        (0, $aqzbR.EventHandler).remove(this.inputElement, "keydown", this.onFilterDown);
                    } else {
                        (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.onInput, this);
                        (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.onFilterUp, this);
                        (0, $aqzbR.EventHandler).add(this.inputElement, "keydown", this.onFilterDown, this);
                    }
                    this.setReadOnly();
                    break;
                case "allowFiltering":
                    this.setSearchBox();
                    if (this.isFiltering() && this.getModuleName() === "combobox" && (0, $3EnZW.isNullOrUndefined)(this.list)) _super.prototype.renderList.call(this);
                    break;
                case "allowCustom":
                    break;
                default:
                    // eslint-disable-next-line max-len
                    var comboProps = this.getPropObject(prop, newProp, oldProp);
                    _super.prototype.onPropertyChanged.call(this, comboProps.newProperty, comboProps.oldProperty);
                    if (this.isFiltering() && prop === "dataSource" && (0, $3EnZW.isNullOrUndefined)(this.list) && this.itemTemplate && this.getModuleName() === "combobox") _super.prototype.renderList.call(this);
                    break;
            }
        }
    };
    /**
     * To initialize the control rendering.
     *
     * @private
     * @returns {void}
     */ ComboBox.prototype.render = function() {
        _super.prototype.render.call(this);
        this.setSearchBox();
        this.renderComplete();
        this.autoFill = this.autofill;
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ ComboBox.prototype.getModuleName = function() {
        return "combobox";
    };
    /**
     * Adds a new item to the combobox popup list. By default, new item appends to the list as the last item,
     * but you can insert based on the index parameter.
     *
     * @param { Object[] } items - Specifies an array of JSON data or a JSON data.
     * @param { number } itemIndex - Specifies the index to place the newly added item in the popup list.
     * @returns {void}

     */ ComboBox.prototype.addItem = function(items, itemIndex) {
        _super.prototype.addItem.call(this, items, itemIndex);
    };
    /**
     * To filter the data from given data source by using query
     *
     * @param {Object[] | DataManager } dataSource - Set the data source to filter.
     * @param {Query} query - Specify the query to filter the data.
     * @param {FieldSettingsModel} fields - Specify the fields to map the column in the data table.
     * @returns {void}

     */ ComboBox.prototype.filter = function(dataSource, query, fields) {
        _super.prototype.filter.call(this, dataSource, query, fields);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Opens the popup that displays the list of items.
     *
     * @returns {void}

     */ ComboBox.prototype.showPopup = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ _super.prototype.showPopup.call(this, e);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Hides the popup if it is in open state.
     *
     * @returns {void}

     */ ComboBox.prototype.hidePopup = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ var inputValue = this.inputElement && this.inputElement.value === "" ? null : this.inputElement && this.inputElement.value;
        if (!(0, $3EnZW.isNullOrUndefined)(this.listData)) {
            var isEscape = this.isEscapeKey;
            if (this.isEscapeKey) {
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.typedString, this.inputElement, this.floatLabelType, this.showClearButton);
                this.isEscapeKey = false;
            }
            if (this.autofill) this.removeFillSelection();
            var dataItem = this.isSelectCustom ? {
                text: ""
            } : this.getItemData();
            var selected = !(0, $3EnZW.isNullOrUndefined)(this.list) ? this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).selected) : null;
            if (this.inputElement && dataItem.text === this.inputElement.value && !(0, $3EnZW.isNullOrUndefined)(selected)) {
                if (this.isSelected) {
                    this.onChangeEvent(e);
                    this.isSelectCustom = false;
                }
                _super.prototype.hidePopup.call(this, e);
                return;
            }
            if (this.getModuleName() === "combobox" && this.inputElement.value.trim() !== "") {
                var dataSource = this.sortedData;
                var type = this.typeOfData(dataSource).typeof;
                var searchItem = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.inputElement.value, this.liCollections, "Equal", true, dataSource, this.fields, type);
                this.selectedLI = searchItem.item;
                if ((0, $3EnZW.isNullOrUndefined)(searchItem.index)) searchItem.index = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.inputElement.value, this.liCollections, "StartsWith", true, dataSource, this.fields, type).index;
                this.activeIndex = searchItem.index;
                if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) this.updateSelectedItem(this.selectedLI, null, true);
                else if (isEscape) {
                    this.isSelectCustom = true;
                    this.removeSelection();
                }
            }
            if (!this.isEscapeKey && this.isTyped && !this.isInteracted) this.customValue(e);
        }
        var value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
        if ((0, $3EnZW.isNullOrUndefined)(this.listData) && this.allowCustom && !(0, $3EnZW.isNullOrUndefined)(inputValue) && inputValue !== value) this.customValue();
        _super.prototype.hidePopup.call(this, e);
    };
    /**
     * Sets the focus to the component for interaction.
     *
     * @returns {void}
     */ ComboBox.prototype.focusIn = function() {
        if (!this.enabled) return;
        if ((0, $5q7BP.Browser).isDevice && !this.isFiltering()) this.preventFocus = true;
        _super.prototype.focusIn.call(this);
    };
    /**
     * Allows you to clear the selected values from the component.
     *
     * @returns {void}

     */ ComboBox.prototype.clear = function() {
        this.value = null;
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Moves the focus from the component if the component is already focused.
     *
     * @returns {void}

     */ ComboBox.prototype.focusOut = function(e) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */ _super.prototype.focusOut.call(this, e);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets all the list items bound on this component.
     *
     * @returns {Element[]}

     */ ComboBox.prototype.getItems = function() {
        return _super.prototype.getItems.call(this);
    };
    /**
     * Gets the data Object that matches the given value.
     *
     * @param { string | number } value - Specifies the value of the list item.
     * @returns {Object}

     */ ComboBox.prototype.getDataByValue = function(value) {
        return _super.prototype.getDataByValue.call(this, value);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ ComboBox.prototype.renderHightSearch = function() {
    // update high light search
    };
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ComboBox.prototype, "autofill", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ComboBox.prototype, "allowCustom", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)({})
    ], ComboBox.prototype, "htmlAttributes", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ComboBox.prototype, "allowFiltering", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ComboBox.prototype, "isDeviceFullScreen", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "query", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "index", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ComboBox.prototype, "showClearButton", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ComboBox.prototype, "enableRtl", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Event)()
    ], ComboBox.prototype, "customValueSpecifier", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Event)()
    ], ComboBox.prototype, "filtering", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "valueTemplate", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], ComboBox.prototype, "floatLabelType", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "filterBarPlaceholder", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "cssClass", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "headerTemplate", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "footerTemplate", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "placeholder", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], ComboBox.prototype, "width", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)("300px")
    ], ComboBox.prototype, "popupHeight", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], ComboBox.prototype, "popupWidth", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ComboBox.prototype, "readonly", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "text", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ComboBox.prototype, "value", void 0);
    $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ComboBox.prototype, "allowObjectBinding", void 0);
    ComboBox = $7ca2c62dd20a2561$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], ComboBox);
    return ComboBox;
}((0, $e5d35cabace4110f$export$85ff158bc62a78c8));



document.addEventListener("DOMContentLoaded", ()=>{
    [
        ...document.querySelectorAll(".account-picker")
    ].map((element)=>element).forEach((element)=>{
        const input = element.querySelector("input");
        const form = input?.form;
        if (input && form) {
            const accountPicker = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
                dataSource: new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                    url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.list({
                        model: "Account"
                    }),
                    adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
                }),
                fields: {
                    value: "value",
                    text: "text"
                },
                placeholder: "Select account",
                sortOrder: "Ascending",
                value: input.dataset.value ?? undefined,
                allowCustom: false,
                allowFiltering: true,
                change: ()=>form.submit()
            });
            accountPicker.appendTo(input);
        }
    });
});





const $81088ee9a0e19312$export$ed97f33186d4b816 = (obj)=>Object.keys(obj).map((k)=>k);
const $81088ee9a0e19312$export$68c286be0e7e55b7 = (obj)=>Object.values(obj).map((v)=>v);
const $81088ee9a0e19312$export$30a06c8d3562193f = (obj, ...omitKeys)=>{
    return $81088ee9a0e19312$export$ed97f33186d4b816(obj).filter((key)=>!omitKeys.includes(key)).map((key)=>{
        return {
            [key]: obj[key]
        };
    }).reduce($81088ee9a0e19312$export$4950aa0f605343fb);
};
const $81088ee9a0e19312$export$357523c63a2253b9 = (obj, ...pickKeys)=>{
    return pickKeys.map((key)=>{
        return {
            [key]: obj[key]
        };
    }).reduce($81088ee9a0e19312$export$4950aa0f605343fb);
};
const $81088ee9a0e19312$export$4950aa0f605343fb = (obj1, obj2)=>{
    return {
        ...obj1,
        ...obj2
    };
};
const $81088ee9a0e19312$export$784d13d8ee351f07 = (obj)=>JSON.parse(JSON.stringify(obj));
const $81088ee9a0e19312$export$6897c284b6f9f4dc = (obj)=>{
    const inverted = {};
    for(const key in obj)inverted[obj[key]] = key;
    return inverted;
};


const $423e37bedf14916e$export$d04f7c6b0dc4a939 = 3;
const $423e37bedf14916e$export$6f63e37550343081 = 8;
const $423e37bedf14916e$export$7ef8f6e91d2e77dd = RegExp(/^[0-9]{6}$/);
const $423e37bedf14916e$export$7b7637218245c8a = RegExp(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i);
const $423e37bedf14916e$export$f5b357e8439f7f73 = RegExp(/^(([_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*)([;,]\s*))*([_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*)$/i);
const $423e37bedf14916e$export$bd3b61a70f794fa3 = RegExp(/^\d+$/);
const $423e37bedf14916e$export$ce49b64d74bc4f8b = RegExp(/^[+-]?\d+$/);
const $423e37bedf14916e$export$fb494e1fa2eeccc5 = RegExp(/^[0-9a-zA-Z]{8}$/);
const $423e37bedf14916e$export$2c46bcbc2d3998a2 = RegExp(/^([+-]{1}[0-9]+[dbwmystunez]{1})+$/);
const $423e37bedf14916e$export$169c309121fe1dbd = RegExp(/([+-]{1}[0-9]+[dbwmystunez]{1})/g);
const $423e37bedf14916e$export$502f3a150f265037 = RegExp(/^\d{4}-\d{2}-\d{2}$/);
const $423e37bedf14916e$export$26a17e0b1828f3e0 = RegExp(/^\d{2}\/\d{2}\/\d{2}$/);
const $423e37bedf14916e$export$371e338370561054 = (value)=>{
    return value ? $423e37bedf14916e$export$7b7637218245c8a.test(value) : false;
};
const $423e37bedf14916e$export$958c2f1b35e92787 = (value)=>{
    return value ? $423e37bedf14916e$export$f5b357e8439f7f73.test(value) : false;
};
const $423e37bedf14916e$export$bc94d825086f138 = (value)=>{
    return value ? $423e37bedf14916e$export$bd3b61a70f794fa3.test(value) : false;
};
const $423e37bedf14916e$export$bf47835b288d4eb9 = (value)=>{
    return value ? $423e37bedf14916e$export$ce49b64d74bc4f8b.test(value) : false;
};
const $423e37bedf14916e$export$6496ef4bebcdbe61 = (value)=>{
    return value ? $423e37bedf14916e$export$fb494e1fa2eeccc5.test(value) : false;
};
const $423e37bedf14916e$export$851050f61be62f1f = (value)=>{
    return value ? $423e37bedf14916e$export$26a17e0b1828f3e0.test(value) : false;
};
const $423e37bedf14916e$export$d04db459bdbf7a0c = (value)=>{
    return value ? $423e37bedf14916e$export$26a17e0b1828f3e0.test(value) : false;
};


parcelRequire("j7YE8");
var $jmffE = parcelRequire("jmffE");
var $4ZDHT = parcelRequire("4ZDHT");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");
var $e7i2H = parcelRequire("e7i2H");
var $37c994a07eb13072$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $37c994a07eb13072$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $37c994a07eb13072$export$17b0f4d84dbfeedf = {
    /* eslint-disable no-useless-escape */ EMAIL: new RegExp("^[A-Za-z0-9._%+-]{1,}@[A-Za-z0-9._%+-]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z0-9]{2,4}[.]{1}[a-zA-Z0-9]{2,4})$"),
    /* eslint-disable-next-line security/detect-unsafe-regex */ URL: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/m,
    DATE_ISO: new RegExp("^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$"),
    DIGITS: new RegExp("^[0-9]*$"),
    PHONE: new RegExp("^[+]?[0-9]{9,13}$"),
    CREDITCARD: new RegExp("^\\d{13,16}$")
};
var $37c994a07eb13072$export$9fbc4a175481bf4c;
(function(ErrorOption) {
    /**
     * Defines the error message.
     */ ErrorOption[ErrorOption["Message"] = 0] = "Message";
    /**
     * Defines the error element type.
     */ ErrorOption[ErrorOption["Label"] = 1] = "Label";
})($37c994a07eb13072$export$9fbc4a175481bf4c || ($37c994a07eb13072$export$9fbc4a175481bf4c = {}));
/**
 * FormValidator class enables you to validate the form fields based on your defined rules
 * ```html
 * <form id='formId'>
 *  <input type='text' name='Name' />
 *  <input type='text' name='Age' />
 * </form>
 * <script>
 *   let formObject = new FormValidator('#formId', {
 *      rules: { Name: { required: true }, Age: { range: [18, 30] } };
 *   });
 *   formObject.validate();
 * </script>
 * ```
 */ var $37c994a07eb13072$export$7c385359179c028a = /** @class */ function(_super) {
    $37c994a07eb13072$var$__extends(FormValidator, _super);
    /**
     * Initializes the FormValidator.
     *
     * @param {string | HTMLFormElement} element - Specifies the element to render as component.
     * @param {FormValidatorModel} options - Specifies the FormValidator model.
     * @private
     */ function FormValidator(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.validated = [];
        _this.errorRules = [];
        _this.allowSubmit = false;
        _this.required = "required";
        _this.infoElement = null;
        _this.inputElement = null;
        _this.selectQuery = "input:not([type=reset]):not([type=button]), select, textarea";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.localyMessage = {};
        /**
         * Specifies the default messages for validation rules.
         *
         * @default { List of validation message }
         */ _this.defaultMessages = {
            required: "This field is required.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateIso: "Please enter a valid date ( ISO ).",
            creditcard: "Please enter valid card number",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            maxLength: "Please enter no more than {0} characters.",
            minLength: "Please enter at least {0} characters.",
            rangeLength: "Please enter a value between {0} and {1} characters long.",
            range: "Please enter a value between {0} and {1}.",
            max: "Please enter a value less than or equal to {0}.",
            min: "Please enter a value greater than or equal to {0}.",
            regex: "Please enter a correct value.",
            tel: "Please enter a valid phone number.",
            pattern: "Please enter a correct pattern value.",
            equalTo: "Please enter the valid match text"
        };
        if (typeof _this.rules === "undefined") _this.rules = {};
        _this.l10n = new (0, $e7i2H.L10n)("formValidator", _this.defaultMessages, _this.locale);
        if (_this.locale) _this.localeFunc();
        (0, $bWDaN.onIntlChange).on("notifyExternalChange", _this.afterLocalization, _this);
        element = typeof element === "string" ? (0, $4ZDHT.select)(element, document) : element;
        // Set novalidate to prevent default HTML5 form validation
        if (_this.element != null) {
            _this.element.setAttribute("novalidate", "");
            _this.inputElements = (0, $4ZDHT.selectAll)(_this.selectQuery, _this.element);
            _this.createHTML5Rules();
            _this.wireEvents();
        } else return undefined;
        return _this;
    }
    FormValidator_1 = FormValidator;
    /* eslint-enable @typescript-eslint/no-explicit-any */ /**
     * Add validation rules to the corresponding input element based on `name` attribute.
     *
     * @param {string} name `name` of form field.
     * @param {Object} rules Validation rules for the corresponding element.
     * @returns {void}
     */ FormValidator.prototype.addRules = function(name, rules) {
        if (name) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.rules.hasOwnProperty(name)) (0, $3EnZW.extend)(this.rules["" + name], rules, {});
            else this.rules["" + name] = rules;
        }
    };
    /**
     * Remove validation to the corresponding field based on name attribute.
     * When no parameter is passed, remove all the validations in the form.
     *
     * @param {string} name Input name attribute value.
     * @param {string[]} rules List of validation rules need to be remove from the corresponding element.
     * @returns {void}
     */ FormValidator.prototype.removeRules = function(name, rules) {
        if (!name && !rules) this.rules = {};
        else if (this.rules["" + name] && !rules) delete this.rules["" + name];
        else if (!(0, $3EnZW.isNullOrUndefined)(this.rules["" + name] && rules)) for(var i = 0; i < rules.length; i++)delete this.rules["" + name][rules[parseInt(i.toString(), 10)]];
        else return;
    };
    /**
     * Validate the current form values using defined rules.
     * Returns `true` when the form is valid otherwise `false`
     *
     * @param {string} selected - Optional parameter to validate specified element.
     * @returns {boolean} - Returns form validation status.
     */ FormValidator.prototype.validate = function(selected) {
        var rules = Object.keys(this.rules);
        if (selected && rules.length) {
            this.validateRules(selected);
            //filter the selected element it don't have any valid input element
            return rules.indexOf(selected) !== -1 && this.errorRules.filter(function(data) {
                return data.name === selected;
            }).length === 0;
        } else {
            this.errorRules = [];
            for(var _i = 0, rules_1 = rules; _i < rules_1.length; _i++){
                var name_1 = rules_1[_i];
                this.validateRules(name_1);
            }
            return this.errorRules.length === 0;
        }
    };
    /**
     * Reset the value of all the fields in form.
     *
     * @returns {void}
     */ FormValidator.prototype.reset = function() {
        this.element.reset();
        this.clearForm();
    };
    /**
     * Get input element by name.
     *
     * @param {string} name - Input element name attribute value.
     * @returns {HTMLInputElement} - Returns the input element.
     */ FormValidator.prototype.getInputElement = function(name) {
        this.inputElement = (0, $4ZDHT.select)('[name="' + name + '"]', this.element);
        return this.inputElement;
    };
    /**
     * Destroy the form validator object and error elements.
     *
     * @returns {void}
     */ FormValidator.prototype.destroy = function() {
        this.reset();
        this.unwireEvents();
        this.rules = {};
        var elements = (0, $4ZDHT.selectAll)("." + this.errorClass + ", ." + this.validClass, this.element);
        for(var _i = 0, elements_1 = elements; _i < elements_1.length; _i++){
            var element = elements_1[_i];
            (0, $4ZDHT.detach)(element);
        }
        _super.prototype.destroy.call(this);
        this.infoElement = null;
        (0, $bWDaN.onIntlChange).off("notifyExternalChange", this.afterLocalization);
    };
    /**
     * @param {FormValidatorModel} newProp - Returns the dynamic property value of the component.
     * @param {FormValidatorModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    FormValidator.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "locale":
                    this.localeFunc();
                    break;
            }
        }
    };
    /**
     * @private
     * @returns {void}
     */ FormValidator.prototype.localeFunc = function() {
        for(var _i = 0, _a = Object.keys(this.defaultMessages); _i < _a.length; _i++){
            var key = _a[_i];
            this.l10n.setLocale(this.locale);
            var value = this.l10n.getConstant(key);
            this.localyMessage["" + key] = value;
        }
    };
    /**
     * @private
     * @returns {string} - Returns the component name.
     */ FormValidator.prototype.getModuleName = function() {
        return "formvalidator";
    };
    /**
     * @param {any} args - Specifies the culture name.
     * @returns {void}
     * @private
     */ FormValidator.prototype.afterLocalization = function(args) {
        this.locale = args.locale;
        this.localeFunc();
    };
    /**
     * Allows you to refresh the form validator base events to the elements inside the form.
     *
     * @returns {void}
     */ FormValidator.prototype.refresh = function() {
        this.unwireEvents();
        this.inputElements = (0, $4ZDHT.selectAll)(this.selectQuery, this.element);
        this.wireEvents();
    };
    FormValidator.prototype.clearForm = function() {
        this.errorRules = [];
        this.validated = [];
        var elements = (0, $4ZDHT.selectAll)(this.selectQuery, this.element);
        for(var _i = 0, elements_2 = elements; _i < elements_2.length; _i++){
            var element = elements_2[_i];
            var input = element;
            input.removeAttribute("aria-invalid");
            var inputParent = input.parentElement;
            var grandParent = inputParent.parentElement;
            if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper") || input.classList.contains("e-input") && inputParent.classList.contains("e-input-group")) inputParent.classList.remove(this.errorClass);
            else if (grandParent != null && (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper"))) grandParent.classList.remove(this.errorClass);
            else input.classList.remove(this.errorClass);
            if (input.name.length > 0) {
                this.getInputElement(input.name);
                this.getErrorElement(input.name);
                this.hideMessage(input.name);
            }
            if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper") || input.classList.contains("e-input") && inputParent.classList.contains("e-input-group")) inputParent.classList.remove(this.validClass);
            else if (grandParent != null && (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper"))) grandParent.classList.remove(this.validClass);
            else input.classList.remove(this.validClass);
        }
    };
    FormValidator.prototype.createHTML5Rules = function() {
        var defRules = [
            "required",
            "validateHidden",
            "regex",
            "rangeLength",
            "maxLength",
            "minLength",
            "dateIso",
            "digits",
            "pattern",
            "data-val-required",
            "type",
            "data-validation",
            "min",
            "max",
            "range",
            "equalTo",
            "data-val-minlength-min",
            "data-val-equalto-other",
            "data-val-maxlength-max",
            "data-val-range-min",
            "data-val-regex-pattern",
            "data-val-length-max",
            "data-val-creditcard",
            "data-val-phone"
        ];
        var acceptedTypes = [
            "hidden",
            "email",
            "url",
            "date",
            "number",
            "tel"
        ];
        for(var _i = 0, _a = this.inputElements; _i < _a.length; _i++){
            var input = _a[_i];
            // Default attribute rules
            var allRule = {};
            for(var _b = 0, defRules_1 = defRules; _b < defRules_1.length; _b++){
                var rule = defRules_1[_b];
                if (input.getAttribute(rule) !== null) switch(rule){
                    case "required":
                        this.defRule(input, allRule, rule, input.required);
                        break;
                    case "data-validation":
                        rule = input.getAttribute(rule);
                        this.defRule(input, allRule, rule, true);
                        break;
                    case "type":
                        if (acceptedTypes.indexOf(input.type) !== -1) this.defRule(input, allRule, input.type, true);
                        break;
                    case "rangeLength":
                    case "range":
                        this.defRule(input, allRule, rule, JSON.parse(input.getAttribute(rule)));
                        break;
                    case "equalTo":
                        var id = input.getAttribute(rule);
                        this.defRule(input, allRule, rule, id);
                        break;
                    default:
                        if (input.getAttribute("data-val") === "true") this.annotationRule(input, allRule, rule, input.getAttribute(rule));
                        else this.defRule(input, allRule, rule, input.getAttribute(rule));
                }
            }
            //adding pattern type validation
            if (Object.keys(allRule).length !== 0) this.addRules(input.name, allRule);
        }
    };
    FormValidator.prototype.annotationRule = function(input, ruleCon, ruleName, value) {
        var annotationRule = ruleName.split("-");
        var rulesList = [
            "required",
            "creditcard",
            "phone",
            "maxlength",
            "minlength",
            "range",
            "regex",
            "equalto"
        ];
        var ruleFirstName = annotationRule[annotationRule.length - 1];
        var ruleSecondName = annotationRule[annotationRule.length - 2];
        if (rulesList.indexOf(ruleFirstName) !== -1) switch(ruleFirstName){
            case "required":
                this.defRule(input, ruleCon, "required", value);
                break;
            case "creditcard":
                this.defRule(input, ruleCon, "creditcard", value);
                break;
            case "phone":
                this.defRule(input, ruleCon, "tel", value);
                break;
        }
        else if (rulesList.indexOf(ruleSecondName) !== -1) switch(ruleSecondName){
            case "maxlength":
                this.defRule(input, ruleCon, "maxLength", value);
                break;
            case "minlength":
                this.defRule(input, ruleCon, "minLength", value);
                break;
            case "range":
                var minvalue = input.getAttribute("data-val-range-min");
                var maxvalue = input.getAttribute("data-val-range-max");
                this.defRule(input, ruleCon, "range", [
                    minvalue,
                    maxvalue
                ]);
                break;
            case "equalto":
                var id = input.getAttribute(ruleName).split(".");
                this.defRule(input, ruleCon, "equalTo", id[id.length - 1]);
                break;
            case "regex":
                this.defRule(input, ruleCon, "regex", value);
                break;
        }
    };
    FormValidator.prototype.defRule = function(input, ruleCon, ruleName, value) {
        var message = input.getAttribute("data-" + ruleName + "-message");
        var annotationMessage = input.getAttribute("data-val-" + ruleName);
        var customMessage;
        if (this.rules[input.name] && ruleName !== "validateHidden" && ruleName !== "hidden") {
            this.getInputElement(input.name);
            customMessage = this.getErrorMessage(this.rules[input.name]["" + ruleName], ruleName);
        }
        if (message) value = [
            value,
            message
        ];
        else if (annotationMessage) value = [
            value,
            annotationMessage
        ];
        else if (customMessage) value = [
            value,
            customMessage
        ];
        ruleCon["" + ruleName] = value;
    };
    // Wire events to the form elements
    FormValidator.prototype.wireEvents = function() {
        for(var _i = 0, _a = this.inputElements; _i < _a.length; _i++){
            var input = _a[_i];
            if (FormValidator_1.isCheckable(input)) (0, $aqzbR.EventHandler).add(input, "click", this.clickHandler, this);
            else if (input.tagName === "SELECT") (0, $aqzbR.EventHandler).add(input, "change", this.changeHandler, this);
            else {
                (0, $aqzbR.EventHandler).add(input, "focusout", this.focusOutHandler, this);
                (0, $aqzbR.EventHandler).add(input, "keyup", this.keyUpHandler, this);
            }
        }
        (0, $aqzbR.EventHandler).add(this.element, "submit", this.submitHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "reset", this.resetHandler, this);
    };
    // UnWire events to the form elements
    FormValidator.prototype.unwireEvents = function() {
        for(var _i = 0, _a = this.inputElements; _i < _a.length; _i++){
            var input = _a[_i];
            (0, $aqzbR.EventHandler).clearEvents(input);
        }
        (0, $aqzbR.EventHandler).remove(this.element, "submit", this.submitHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "reset", this.resetHandler);
    };
    // Handle input element focusout event
    FormValidator.prototype.focusOutHandler = function(e) {
        this.trigger("focusout", e);
        //FormValidator.triggerCallback(this.focusout, e);
        var element = e.target;
        if (this.rules[element.name]) {
            if (this.rules[element.name][this.required] || element.value.length > 0) this.validate(element.name);
            else if (this.validated.indexOf(element.name) === -1) this.validated.push(element.name);
        }
    };
    // Handle input element keyup event
    FormValidator.prototype.keyUpHandler = function(e) {
        this.trigger("keyup", e);
        var element = e.target;
        // List of keys need to prevent while validation
        var excludeKeys = [
            16,
            17,
            18,
            20,
            35,
            36,
            37,
            38,
            39,
            40,
            45,
            144,
            225
        ];
        if (e.which === 9 && (!this.rules[element.name] || this.rules[element.name] && !this.rules[element.name][this.required])) return;
        if (this.validated.indexOf(element.name) !== -1 && this.rules[element.name] && excludeKeys.indexOf(e.which) === -1) this.validate(element.name);
    };
    // Handle input click event
    FormValidator.prototype.clickHandler = function(e) {
        this.trigger("click", e);
        var element = e.target;
        // If element type is not submit allow validation
        if (element.type !== "submit") this.validate(element.name);
        else if (element.getAttribute("formnovalidate") !== null) // Prevent form validation, if submit button has formnovalidate attribute
        this.allowSubmit = true;
    };
    // Handle input change event
    FormValidator.prototype.changeHandler = function(e) {
        this.trigger("change", e);
        var element = e.target;
        this.validate(element.name);
    };
    // Handle form submit event
    FormValidator.prototype.submitHandler = function(e) {
        this.trigger("submit", e);
        //FormValidator.triggerCallback(this.submit, e);
        // Prevent form submit if validation failed
        if (!this.allowSubmit && !this.validate()) e.preventDefault();
        else this.allowSubmit = false;
    };
    // Handle form reset
    FormValidator.prototype.resetHandler = function() {
        this.clearForm();
    };
    // Validate each rule based on input element name
    FormValidator.prototype.validateRules = function(name) {
        if (!this.rules["" + name]) return;
        var rules = Object.keys(this.rules["" + name]);
        var hiddenType = false;
        var validateHiddenType = false;
        var vhPos = rules.indexOf("validateHidden");
        var hPos = rules.indexOf("hidden");
        this.getInputElement(name);
        if (hPos !== -1) hiddenType = true;
        if (vhPos !== -1) validateHiddenType = true;
        if (!hiddenType || hiddenType && validateHiddenType) {
            if (vhPos !== -1) rules.splice(vhPos, 1);
            if (hPos !== -1) rules.splice(hPos - 1, 1);
            this.getErrorElement(name);
            for(var _i = 0, rules_2 = rules; _i < rules_2.length; _i++){
                var rule = rules_2[_i];
                var errorMessage = this.getErrorMessage(this.rules["" + name]["" + rule], rule);
                var errorRule = {
                    name: name,
                    message: errorMessage
                };
                var eventArgs = {
                    inputName: name,
                    element: this.inputElement,
                    message: errorMessage
                };
                if (!this.isValid(name, rule) && !this.inputElement.classList.contains(this.ignore)) {
                    this.removeErrorRules(name);
                    this.errorRules.push(errorRule);
                    // Set aria attributes to invalid elements
                    this.inputElement.setAttribute("aria-invalid", "true");
                    this.inputElement.setAttribute("aria-describedby", this.inputElement.id + "-info");
                    var inputParent = this.inputElement.parentElement;
                    var grandParent = inputParent.parentElement;
                    if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper") || this.inputElement.classList.contains("e-input") && inputParent.classList.contains("e-input-group")) {
                        inputParent.classList.add(this.errorClass);
                        inputParent.classList.remove(this.validClass);
                    } else if (grandParent != null && (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper"))) {
                        grandParent.classList.add(this.errorClass);
                        grandParent.classList.remove(this.validClass);
                    } else {
                        this.inputElement.classList.add(this.errorClass);
                        this.inputElement.classList.remove(this.validClass);
                    }
                    if (!this.infoElement) this.createErrorElement(name, errorRule.message, this.inputElement);
                    else this.showMessage(errorRule);
                    eventArgs.errorElement = this.infoElement;
                    eventArgs.status = "failure";
                    if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper") || this.inputElement.classList.contains("e-input") && inputParent.classList.contains("e-input-group")) {
                        inputParent.classList.add(this.errorClass);
                        inputParent.classList.remove(this.validClass);
                    } else if (grandParent != null && (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper"))) {
                        grandParent.classList.add(this.errorClass);
                        grandParent.classList.remove(this.validClass);
                    } else {
                        this.inputElement.classList.add(this.errorClass);
                        this.inputElement.classList.remove(this.validClass);
                    }
                    this.optionalValidationStatus(name, eventArgs);
                    this.trigger("validationComplete", eventArgs);
                    // Set aria-required to required rule elements
                    if (rule === "required") this.inputElement.setAttribute("aria-required", "true");
                    break;
                } else {
                    this.hideMessage(name);
                    eventArgs.status = "success";
                    this.trigger("validationComplete", eventArgs);
                }
            }
        } else return;
    };
    // Update the optional validation status
    FormValidator.prototype.optionalValidationStatus = function(name, refer) {
        if (!this.rules["" + name][this.required] && !this.inputElement.value.length && !(0, $3EnZW.isNullOrUndefined)(this.infoElement)) {
            this.infoElement.innerHTML = this.inputElement.value;
            this.infoElement.setAttribute("aria-invalid", "false");
            refer.status = "";
            this.hideMessage(name);
        }
    };
    // Check the input element whether it's value satisfy the validation rule or not
    FormValidator.prototype.isValid = function(name, rule) {
        var params = this.rules["" + name]["" + rule];
        var param = params instanceof Array && typeof params[1] === "string" ? params[0] : params;
        var currentRule = this.rules["" + name]["" + rule];
        var dateFormat = (rule === "min" || rule === "max") && this.rules["" + name].date && typeof this.rules["" + name].date === "string" ? this.rules["" + name].date : null;
        var args = {
            value: this.inputElement.value,
            param: param,
            element: this.inputElement,
            formElement: this.element,
            format: dateFormat
        };
        this.trigger("validationBegin", args);
        if (!args.param && rule === "required") return true;
        if (currentRule && typeof currentRule[0] === "function") {
            var fn = currentRule[0];
            return fn.call(this, {
                element: this.inputElement,
                value: this.inputElement.value
            });
        } else if (FormValidator_1.isCheckable(this.inputElement)) {
            if (rule !== "required") return true;
            return (0, $4ZDHT.selectAll)('input[name="' + name + '"]:checked', this.element).length > 0;
        } else return FormValidator_1.checkValidator["" + rule](args);
    };
    // Return default error message or custom error message
    FormValidator.prototype.getErrorMessage = function(ruleValue, rule) {
        var message = this.inputElement.getAttribute("data-" + rule + "-message") ? this.inputElement.getAttribute("data-" + rule + "-message") : ruleValue instanceof Array && typeof ruleValue[1] === "string" ? ruleValue[1] : Object.keys(this.localyMessage).length !== 0 ? this.localyMessage["" + rule] : this.defaultMessages["" + rule];
        var formats = message.match(/{(\d)}/g);
        if (!(0, $3EnZW.isNullOrUndefined)(formats)) for(var i = 0; i < formats.length; i++){
            var value = ruleValue instanceof Array ? ruleValue[parseInt(i.toString(), 10)] : ruleValue;
            message = message.replace(formats[parseInt(i.toString(), 10)], value);
        }
        return message;
    };
    // Create error element based on name and error message
    FormValidator.prototype.createErrorElement = function(name, message, input) {
        var errorElement = (0, $4ZDHT.createElement)(this.errorElement, {
            className: this.errorClass,
            innerHTML: message,
            attrs: {
                for: name
            }
        });
        // Create message design if errorOption is message
        if (this.errorOption === $37c994a07eb13072$export$9fbc4a175481bf4c.Message) {
            errorElement.classList.remove(this.errorClass);
            errorElement.classList.add("e-message");
            errorElement = (0, $4ZDHT.createElement)(this.errorContainer, {
                className: this.errorClass,
                innerHTML: errorElement.outerHTML
            });
        }
        errorElement.id = this.inputElement.name + "-info";
        // Append error message into MVC error message element
        if (this.element.querySelector('[data-valmsg-for="' + input.id + '"]')) this.element.querySelector('[data-valmsg-for="' + input.id + '"]').appendChild(errorElement);
        else if (input.hasAttribute("data-msg-containerid") === true) {
            // Append error message into custom div element
            var containerId = input.getAttribute("data-msg-containerid");
            var divElement = (0, $4ZDHT.select)("#" + containerId, this.element);
            divElement.appendChild(errorElement);
        } else if (this.customPlacement != null) // Call custom placement function if customPlacement is not null
        this.customPlacement.call(this, this.inputElement, errorElement);
        else {
            var inputParent = this.inputElement.parentElement;
            var grandParent = inputParent.parentElement;
            if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper")) grandParent.insertBefore(errorElement, inputParent.nextSibling);
            else if (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper")) grandParent.parentElement.insertBefore(errorElement, grandParent.nextSibling);
            else inputParent.insertBefore(errorElement, this.inputElement.nextSibling);
        }
        errorElement.style.display = "block";
        this.getErrorElement(name);
        this.validated.push(name);
        this.checkRequired(name);
    };
    // Get error element by name
    FormValidator.prototype.getErrorElement = function(name) {
        this.infoElement = (0, $4ZDHT.select)(this.errorElement + "." + this.errorClass, this.inputElement.parentElement);
        if (!this.infoElement) this.infoElement = (0, $4ZDHT.select)(this.errorElement + "." + this.errorClass + '[for="' + name + '"]', this.element);
        return this.infoElement;
    };
    // Remove existing rule from errorRules object
    FormValidator.prototype.removeErrorRules = function(name) {
        for(var i = 0; i < this.errorRules.length; i++){
            var rule = this.errorRules[parseInt(i.toString(), 10)];
            if (rule.name === name) this.errorRules.splice(i, 1);
        }
    };
    // Show error message to the input element
    FormValidator.prototype.showMessage = function(errorRule) {
        this.infoElement.style.display = "block";
        this.infoElement.innerHTML = errorRule.message;
        this.checkRequired(errorRule.name);
    };
    // Hide error message based on input name
    FormValidator.prototype.hideMessage = function(name) {
        if (this.infoElement) {
            this.infoElement.style.display = "none";
            this.removeErrorRules(name);
            var inputParent = this.inputElement.parentElement;
            var grandParent = inputParent.parentElement;
            if (inputParent.classList.contains("e-control-wrapper") || inputParent.classList.contains("e-wrapper") || this.inputElement.classList.contains("e-input") && inputParent.classList.contains("e-input-group")) {
                inputParent.classList.add(this.validClass);
                inputParent.classList.remove(this.errorClass);
            } else if (grandParent != null && (grandParent.classList.contains("e-control-wrapper") || grandParent.classList.contains("e-wrapper"))) {
                grandParent.classList.add(this.validClass);
                grandParent.classList.remove(this.errorClass);
            } else {
                this.inputElement.classList.add(this.validClass);
                this.inputElement.classList.remove(this.errorClass);
            }
            this.inputElement.setAttribute("aria-invalid", "false");
        }
    };
    // Check whether the input element have required rule and its value is not empty
    FormValidator.prototype.checkRequired = function(name) {
        if (!this.rules["" + name][this.required] && !this.inputElement.value.length && !(0, $3EnZW.isNullOrUndefined)(this.infoElement)) {
            this.infoElement.innerHTML = this.inputElement.value;
            this.infoElement.setAttribute("aria-invalid", "false");
            this.hideMessage(name);
        }
    };
    // Return boolean result if the input have checkable or submit types
    FormValidator.isCheckable = function(input) {
        var inputType = input.getAttribute("type");
        return inputType && (inputType === "checkbox" || inputType === "radio" || inputType === "submit");
    };
    var FormValidator_1;
    // List of function to validate the rules
    FormValidator.checkValidator = {
        required: function(option) {
            return !isNaN(Date.parse(option.value)) ? !isNaN(new Date(option.value).getTime()) : option.value.toString().length > 0;
        },
        email: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.EMAIL.test(option.value);
        },
        url: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.URL.test(option.value);
        },
        dateIso: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.DATE_ISO.test(option.value);
        },
        tel: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.PHONE.test(option.value);
        },
        creditcard: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.CREDITCARD.test(option.value);
        },
        number: function(option) {
            return !isNaN(Number(option.value)) && option.value.indexOf(" ") === -1;
        },
        digits: function(option) {
            return $37c994a07eb13072$export$17b0f4d84dbfeedf.DIGITS.test(option.value);
        },
        maxLength: function(option) {
            return option.value.length <= Number(option.param);
        },
        minLength: function(option) {
            return option.value.length >= Number(option.param);
        },
        rangeLength: function(option) {
            var param = option.param;
            return option.value.length >= param[0] && option.value.length <= param[1];
        },
        range: function(option) {
            var param = option.param;
            return !isNaN(Number(option.value)) && Number(option.value) >= param[0] && Number(option.value) <= param[1];
        },
        date: function(option) {
            if (!(0, $3EnZW.isNullOrUndefined)(option.param) && typeof option.param === "string" && option.param !== "") {
                var globalize = new (0, $bWDaN.Internationalization);
                var dateOptions = {
                    format: option.param.toString(),
                    type: "dateTime",
                    skeleton: "yMd"
                };
                var dateValue = globalize.parseDate(option.value, dateOptions);
                return !(0, $3EnZW.isNullOrUndefined)(dateValue) && dateValue instanceof Date && !isNaN(+dateValue);
            } else return !isNaN(new Date(option.value).getTime());
        },
        max: function(option) {
            if (!isNaN(Number(option.value))) // Maximum rule validation for number
            return +option.value <= +option.param;
            // Maximum rule validation for date
            if (option.format && option.format !== "") {
                var globalize = new (0, $bWDaN.Internationalization);
                var dateOptions = {
                    format: option.format.toString(),
                    type: "dateTime",
                    skeleton: "yMd"
                };
                var dateValue = globalize.parseDate(option.value, dateOptions);
                var maxValue = typeof option.param === "string" ? globalize.parseDate(JSON.parse(JSON.stringify(option.param)), dateOptions) : option.param;
                return new Date(dateValue).getTime() <= new Date(maxValue).getTime();
            } else return new Date(option.value).getTime() <= new Date(JSON.parse(JSON.stringify(option.param))).getTime();
        },
        min: function(option) {
            if (!isNaN(Number(option.value))) // Minimum rule validation for number
            return +option.value >= +option.param;
            else if (option.value.indexOf(",") !== -1) {
                var uNum = option.value.replace(/,/g, "");
                return parseFloat(uNum) >= Number(option.param); // Convert option.param to a number
            } else {
                // Minimum rule validation for date
                if (option.format && option.format !== "") {
                    var globalize = new (0, $bWDaN.Internationalization);
                    var dateOptions = {
                        format: option.format.toString(),
                        type: "dateTime",
                        skeleton: "yMd"
                    };
                    var dateValue = globalize.parseDate(option.value, dateOptions);
                    var minValue = typeof option.param === "string" ? globalize.parseDate(JSON.parse(JSON.stringify(option.param)), dateOptions) : option.param;
                    return new Date(dateValue).getTime() >= new Date(minValue).getTime();
                } else return new Date(option.value).getTime() >= new Date(JSON.parse(JSON.stringify(option.param))).getTime();
            }
        },
        regex: function(option) {
            /* eslint-disable-next-line security/detect-non-literal-regexp */ return new RegExp(option.param).test(option.value);
        },
        equalTo: function(option) {
            var compareTo = option.formElement.querySelector("#" + option.param);
            option.param = compareTo.value;
            return option.param === option.value;
        }
    };
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("")
    ], FormValidator.prototype, "locale", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("e-hidden")
    ], FormValidator.prototype, "ignore", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)()
    ], FormValidator.prototype, "rules", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("e-error")
    ], FormValidator.prototype, "errorClass", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("e-valid")
    ], FormValidator.prototype, "validClass", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("label")
    ], FormValidator.prototype, "errorElement", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)("div")
    ], FormValidator.prototype, "errorContainer", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Property)($37c994a07eb13072$export$9fbc4a175481bf4c.Label)
    ], FormValidator.prototype, "errorOption", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "focusout", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "keyup", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "click", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "change", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "submit", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "validationBegin", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "validationComplete", void 0);
    $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.Event)()
    ], FormValidator.prototype, "customPlacement", void 0);
    FormValidator = FormValidator_1 = $37c994a07eb13072$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], FormValidator);
    return FormValidator;
}((0, $jmffE.Base));



const $23645516f0d2c47e$export$fce6876652108ab = (value)=>value === undefined;
const $23645516f0d2c47e$export$4e62c701997796c1 = (value)=>!$23645516f0d2c47e$export$fce6876652108ab(value);
const $23645516f0d2c47e$export$630801d484da15df = (value)=>value === null;
const $23645516f0d2c47e$export$7909a8efff3699c9 = (value)=>!$23645516f0d2c47e$export$630801d484da15df(value);
const $23645516f0d2c47e$export$71fc1ee3e76bc1fe = (value)=>!($23645516f0d2c47e$export$fce6876652108ab(value) || $23645516f0d2c47e$export$630801d484da15df(value));
const $23645516f0d2c47e$export$844ec244b1367d54 = (value)=>typeof value === "string";
const $23645516f0d2c47e$export$e1fe2eb830813601 = (value)=>$23645516f0d2c47e$export$844ec244b1367d54(value) && value !== "";
const $23645516f0d2c47e$export$78d1711480f95c3e = (value)=>value === "";
const $23645516f0d2c47e$export$813e94b17b81f345 = (value)=>$23645516f0d2c47e$export$78d1711480f95c3e(value) || value === null;
const $23645516f0d2c47e$export$4c0262a4f954db45 = (value)=>Array.isArray(value) && value.length === 0;
const $23645516f0d2c47e$export$b57b2a4fc103e949 = (value)=>$23645516f0d2c47e$export$4c0262a4f954db45(value) || value === null;
const $23645516f0d2c47e$export$e90fb89750dba83f = (value)=>!isNaN(parseFloat(value)) && isFinite(value);
const $23645516f0d2c47e$export$d02631cccf789723 = (n, step)=>[
        ...Array(n).keys()
    ].filter((i)=>!step || i % step === 0);



const $fb0301734e2a6838$var$shiftUtc = (date, from)=>{
    if (typeof date === "string") date = new Date(Date.parse(date));
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset() * (from ? 1 : -1));
    return date;
};
const $fb0301734e2a6838$export$bf96ab0fd446bad3 = (date)=>$fb0301734e2a6838$var$shiftUtc(date, true);
const $fb0301734e2a6838$export$e3c952f8edd3566f = (date)=>$fb0301734e2a6838$var$shiftUtc(date, false);
const $fb0301734e2a6838$export$489a569037cfef1b = (value)=>{
    if (value) {
        const timestamp = Date.parse(value);
        if (!isNaN(timestamp)) return new Date(timestamp);
    }
};
const $fb0301734e2a6838$export$fef877680ef45aac = (value)=>{
    if (value && (0, $423e37bedf14916e$export$d04db459bdbf7a0c)(value)) {
        const [day, month, year] = value.split("/");
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
};
const $fb0301734e2a6838$export$1431bc52824a265 = (date)=>date.toISOString().substring(0, 10);
const $fb0301734e2a6838$export$c74c46dd12921472 = (from, to)=>new Date(new Date(from.getTime() + Math.random() * (to.getTime() - from.getTime())).toISOString().substring(0, 10));
const $fb0301734e2a6838$export$d59eaf38d704f928 = (from, to, quantity)=>(0, $23645516f0d2c47e$export$d02631cccf789723)(quantity).map(()=>$fb0301734e2a6838$export$c74c46dd12921472(from, to));
const $fb0301734e2a6838$export$aa5154ebe0440ad5 = (date1, date2)=>date1.getTime() === date2.getTime();
const $fb0301734e2a6838$export$871608497c498473 = (obj)=>typeof obj === "object" && "toISOString" in obj;




function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}


function $e5b6e627005992fb$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $33099d3a0ee000b6$export$2e2bcd8739ae039(value) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $db295730c81e792c$export$2e2bcd8739ae039(argument) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $62b6aa7362d709e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $33099d3a0ee000b6$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $915d833559b42c3f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $6ec7037ed5e3d5c3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $59c24a9e74e1c5c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $6ec7037ed5e3d5c3$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $f59bdeb98608936d$var$MILLISECONDS_IN_DAY = 86400000;
function $f59bdeb98608936d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $f59bdeb98608936d$var$MILLISECONDS_IN_DAY) + 1;
}





function $48caadaecccd9d4f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $c923e234d864ebd7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $d969d9c83bc56a0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK = 604800000;
function $d2c40956b8ab3953$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(date).getTime() - (0, $d969d9c83bc56a0e$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK) + 1;
}







var $5bdcb58bd181ac10$var$defaultOptions = {};
function $5bdcb58bd181ac10$export$430a3269e24b912e() {
    return $5bdcb58bd181ac10$var$defaultOptions;
}
function $5bdcb58bd181ac10$export$95365be1b0704abc(newOptions) {
    $5bdcb58bd181ac10$var$defaultOptions = newOptions;
}


function $a4a8a151e5e43f6b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $9acdbcf7776722e9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $f6aee5547809ce40$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK = 604800000;
function $c6f84a8f2fb5610c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(date, options).getTime() - (0, $f6aee5547809ce40$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $a818db1c2d04a150$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $5389fd1b998732ff$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $5389fd1b998732ff$export$2e2bcd8739ae039 = $5389fd1b998732ff$var$formatters;


var $4a2755b1807fc917$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4a2755b1807fc917$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c6f84a8f2fb5610c$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $d2c40956b8ab3953$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $f59bdeb98608936d$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4a2755b1807fc917$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(minutes, 2);
}
function $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter);
}
function $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4a2755b1807fc917$export$2e2bcd8739ae039 = $4a2755b1807fc917$var$formatters;


var $a188900c436ed76e$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $a188900c436ed76e$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $a188900c436ed76e$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $a188900c436ed76e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a188900c436ed76e$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a188900c436ed76e$var$timeLongFormatter(timePattern, formatLong));
};
var $a188900c436ed76e$var$longFormatters = {
    p: $a188900c436ed76e$var$timeLongFormatter,
    P: $a188900c436ed76e$var$dateTimeLongFormatter
};
var $a188900c436ed76e$export$2e2bcd8739ae039 = $a188900c436ed76e$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c6138e3e9e222cc3$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a47722dda2cd757f$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a47722dda2cd757f$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a47722dda2cd757f$export$c6cc36aa33304772(token) {
    return $a47722dda2cd757f$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$c6b49d6dceb604a1(token) {
    return $a47722dda2cd757f$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $a0fcf9a783a9c8cf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $a0fcf9a783a9c8cf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a0fcf9a783a9c8cf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $a0fcf9a783a9c8cf$export$2e2bcd8739ae039 = $a0fcf9a783a9c8cf$var$formatDistance;


function $46e336c804985263$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $f1af66fefd840e85$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $f1af66fefd840e85$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f1af66fefd840e85$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f1af66fefd840e85$var$formatLong = {
    date: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f1af66fefd840e85$export$2e2bcd8739ae039 = $f1af66fefd840e85$var$formatLong;


var $2d69cb397acad490$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $2d69cb397acad490$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2d69cb397acad490$var$formatRelativeLocale[token];
};
var $2d69cb397acad490$export$2e2bcd8739ae039 = $2d69cb397acad490$var$formatRelative;


function $e43ff33ed7f225ec$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $c4f46a8d544f3daa$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $c4f46a8d544f3daa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4f46a8d544f3daa$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $c4f46a8d544f3daa$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $c4f46a8d544f3daa$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $c4f46a8d544f3daa$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $c4f46a8d544f3daa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $c4f46a8d544f3daa$var$localize = {
    ordinalNumber: $c4f46a8d544f3daa$var$ordinalNumber,
    era: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c4f46a8d544f3daa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c4f46a8d544f3daa$export$2e2bcd8739ae039 = $c4f46a8d544f3daa$var$localize;


function $f3b96828de7939a6$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f3b96828de7939a6$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f3b96828de7939a6$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f3b96828de7939a6$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f3b96828de7939a6$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $13e5a388dae711de$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $32f30a5965252391$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $32f30a5965252391$var$parseOrdinalNumberPattern = /\d+/i;
var $32f30a5965252391$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $32f30a5965252391$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $32f30a5965252391$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $32f30a5965252391$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $32f30a5965252391$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $32f30a5965252391$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $32f30a5965252391$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $32f30a5965252391$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $32f30a5965252391$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $32f30a5965252391$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $32f30a5965252391$var$match = {
    ordinalNumber: (0, $13e5a388dae711de$export$2e2bcd8739ae039)({
        matchPattern: $32f30a5965252391$var$matchOrdinalNumberPattern,
        parsePattern: $32f30a5965252391$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $32f30a5965252391$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $32f30a5965252391$export$2e2bcd8739ae039 = $32f30a5965252391$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1fab302b13b08d66$var$locale = {
    code: "en-US",
    formatDistance: (0, $a0fcf9a783a9c8cf$export$2e2bcd8739ae039),
    formatLong: (0, $f1af66fefd840e85$export$2e2bcd8739ae039),
    formatRelative: (0, $2d69cb397acad490$export$2e2bcd8739ae039),
    localize: (0, $c4f46a8d544f3daa$export$2e2bcd8739ae039),
    match: (0, $32f30a5965252391$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1fab302b13b08d66$export$2e2bcd8739ae039 = $1fab302b13b08d66$var$locale;


var $ff2f5d41cd8b653b$export$2e2bcd8739ae039 = (0, $1fab302b13b08d66$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3aad3dc8a82b847c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3aad3dc8a82b847c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3aad3dc8a82b847c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3aad3dc8a82b847c$var$doubleQuoteRegExp = /''/g;
var $3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3aad3dc8a82b847c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $62b6aa7362d709e7$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3aad3dc8a82b847c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $a188900c436ed76e$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($3aad3dc8a82b847c$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3aad3dc8a82b847c$var$cleanEscapedString(substring);
        var formatter = (0, $4a2755b1807fc917$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a47722dda2cd757f$export$c6b49d6dceb604a1)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a47722dda2cd757f$export$c6cc36aa33304772)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $3aad3dc8a82b847c$var$cleanEscapedString(input) {
    var matched = input.match($3aad3dc8a82b847c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3aad3dc8a82b847c$var$doubleQuoteRegExp, "'");
}





function $dabc289cdb54673c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $af8883233baae810$var$MILLISECONDS_IN_DAY = 86400000;
function $af8883233baae810$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $dabc289cdb54673c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $dabc289cdb54673c$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $af8883233baae810$var$MILLISECONDS_IN_DAY);
}









function $965fc399e1b2030f$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var baseDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyBaseDate);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    if (!locale.formatRelative) throw new RangeError("locale must contain formatRelative property");
    var diff = (0, $af8883233baae810$export$2e2bcd8739ae039)(date, baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var utcDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(date, (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(date));
    var utcBaseDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(baseDate, (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $3aad3dc8a82b847c$export$2e2bcd8739ae039)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}



function $720df6800328dd5a$export$2e2bcd8739ae039(newOptions) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var result = {};
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) result[property] = defaultOptions[property];
    for(var _property in newOptions)if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
        if (newOptions[_property] === undefined) delete result[_property];
        else result[_property] = newOptions[_property];
    }
    (0, $5bdcb58bd181ac10$export$95365be1b0704abc)(result);
}





const $8f1a5b17b2b7f2a2$export$32c5963dbca2d477 = (type)=>Object.keys(type).filter((key)=>!(0, $423e37bedf14916e$export$bc94d825086f138)(key));
const $8f1a5b17b2b7f2a2$export$2eef8d24ed7a471 = (type)=>$8f1a5b17b2b7f2a2$export$32c5963dbca2d477(type).map((key)=>type[key]);
const $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3 = (type, separator = " ")=>$8f1a5b17b2b7f2a2$export$32c5963dbca2d477(type).map((key)=>{
        return {
            value: type[key],
            text: (0, $d47525176c3f6cd7$export$5850a84d4d68b1b5)(key).split(" ").map((part)=>part.trim()).join(separator ?? " ")
        };
    });
const $8f1a5b17b2b7f2a2$export$b7f70a3f15551b73 = (type, formatter)=>$8f1a5b17b2b7f2a2$export$2eef8d24ed7a471(type).map((value)=>{
        return {
            value: value,
            text: formatter ? formatter(value) : (0, $d47525176c3f6cd7$export$afe72249c42899d9)(type, value)
        };
    });
const $8f1a5b17b2b7f2a2$export$7d09211693ceb2bf = (enumObj, omitValues)=>{
    return Object.keys(enumObj).filter((key)=>!omitValues.includes(enumObj[key])).reduce((result, key)=>{
        result[key] = enumObj[key];
        return result;
    }, {});
};








var $1899cc3aa6626fc3$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $1899cc3aa6626fc3$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $1899cc3aa6626fc3$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $1899cc3aa6626fc3$var$formatLong = {
    date: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $1899cc3aa6626fc3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $1899cc3aa6626fc3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $1899cc3aa6626fc3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $1899cc3aa6626fc3$export$2e2bcd8739ae039 = $1899cc3aa6626fc3$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $d607670a07855b2b$var$locale = {
    code: "en-GB",
    formatDistance: (0, $a0fcf9a783a9c8cf$export$2e2bcd8739ae039),
    formatLong: (0, $1899cc3aa6626fc3$export$2e2bcd8739ae039),
    formatRelative: (0, $2d69cb397acad490$export$2e2bcd8739ae039),
    localize: (0, $c4f46a8d544f3daa$export$2e2bcd8739ae039),
    match: (0, $32f30a5965252391$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d607670a07855b2b$export$2e2bcd8739ae039 = $d607670a07855b2b$var$locale;


const $d47525176c3f6cd7$export$1af4c7e47ad72f44 = (0, $d607670a07855b2b$export$2e2bcd8739ae039);
(0, $720df6800328dd5a$export$2e2bcd8739ae039)({
    locale: $d47525176c3f6cd7$export$1af4c7e47ad72f44
});
const $d47525176c3f6cd7$export$4e4cb19dd88cd821 = "dd/MM/yy";
const $d47525176c3f6cd7$export$bf57ab38cc2c11f0 = "MMM";
const $d47525176c3f6cd7$export$167143d4db8c79b7 = "MMMM";
const $d47525176c3f6cd7$export$fee663b01e39c429 = "d MMM";
const $d47525176c3f6cd7$export$43a266027343dd39 = "d MMMM";
const $d47525176c3f6cd7$export$ed2e8365f2474b3 = "d MMM yy";
const $d47525176c3f6cd7$export$3c4a3a9e8c7b2500 = "EEE d MMM yy";
const $d47525176c3f6cd7$export$94f4d87fad5dcf9a = "H:mm";
const $d47525176c3f6cd7$export$b434509d4a847712 = `dd/MM/yy 'at' H:mm`;
const $d47525176c3f6cd7$export$65691f9e1b09bbf7 = `d MMM yy 'at' H:mm`;
const $d47525176c3f6cd7$export$3fddef0e5f877d32 = "dd/MM/yyyy";
const $d47525176c3f6cd7$export$8d512aaeb4a90c4e = `dd/MM/yyyy H:mm:ss`;
const $d47525176c3f6cd7$var$parseOrCloneDate = (date)=>date !== null && date !== undefined ? new Date(typeof date === "string" ? Date.parse(date) : date.getTime()) : undefined;
const $d47525176c3f6cd7$export$3ae94a2503e890a1 = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$4e4cb19dd88cd821);
const $d47525176c3f6cd7$export$8b492ed8828f789c = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$b434509d4a847712);
const $d47525176c3f6cd7$export$d0536c8e7f45796e = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$bf57ab38cc2c11f0);
const $d47525176c3f6cd7$export$8bc66d1bb2943e6e = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$167143d4db8c79b7);
const $d47525176c3f6cd7$export$c4e890008b690b8d = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$fee663b01e39c429);
const $d47525176c3f6cd7$export$9edae1c37cf7adb6 = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$43a266027343dd39);
const $d47525176c3f6cd7$export$d05cda19ddf5275d = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$65691f9e1b09bbf7);
const $d47525176c3f6cd7$export$6fc082e5cc44c8b5 = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$ed2e8365f2474b3);
const $d47525176c3f6cd7$export$8d572d60a0595891 = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$3c4a3a9e8c7b2500);
const $d47525176c3f6cd7$export$3203edd9e5edd663 = (date)=>$d47525176c3f6cd7$export$273a86af4e235dff(date, $d47525176c3f6cd7$export$94f4d87fad5dcf9a);
const $d47525176c3f6cd7$export$58fee0e241ef8390 = (date)=>{
    date = $d47525176c3f6cd7$var$parseOrCloneDate(date);
    return date ? $d47525176c3f6cd7$export$688230ca06b60d9d((0, $965fc399e1b2030f$export$2e2bcd8739ae039)(date, new Date()))// Mild hack to shorten year to 2 digits if present
    .replace(/\/\d{4}$/, (year)=>`/${year.slice(-2)}`) : "";
};
const $d47525176c3f6cd7$export$273a86af4e235dff = (date, pattern)=>{
    date = $d47525176c3f6cd7$var$parseOrCloneDate(date);
    if (!date) return "";
    return date ? (0, $3aad3dc8a82b847c$export$2e2bcd8739ae039)(date, pattern) : "";
};
const $d47525176c3f6cd7$export$5850a84d4d68b1b5 = (value, separator = " ")=>(value ?? "").replace(/([A-Z]{1}|[0-9]+)/g, `${separator}$1`).replaceAll("Aml", "AML").replaceAll("Cis", "CIS").replaceAll("Vat", "VAT").trim();
const $d47525176c3f6cd7$export$6067d94562c60bae = (type)=>(0, $8f1a5b17b2b7f2a2$export$32c5963dbca2d477)(type).map((key)=>$d47525176c3f6cd7$export$5850a84d4d68b1b5(key));
const $d47525176c3f6cd7$export$afe72249c42899d9 = (type, value)=>{
    const inverted = (0, $81088ee9a0e19312$export$6897c284b6f9f4dc)(type);
    return value !== null && value !== undefined && inverted[value] !== undefined ? $d47525176c3f6cd7$export$5850a84d4d68b1b5(inverted[value]) : "";
};
const $d47525176c3f6cd7$export$98721cd486e14331 = (schedule)=>$d47525176c3f6cd7$export$afe72249c42899d9((0, $19ee14db620c232e$export$b32b5fd24133a029), schedule).split(" ").join("/");
const $d47525176c3f6cd7$export$5fcfea026335fe4e = ()=>$d47525176c3f6cd7$export$6067d94562c60bae((0, $19ee14db620c232e$export$b32b5fd24133a029)).map((key)=>key.split(" ").join("/"));
const $d47525176c3f6cd7$export$91884aa883243770 = (text)=>text ? $d47525176c3f6cd7$export$5850a84d4d68b1b5(text).toLowerCase().replaceAll(" ", "-") : "";
const $d47525176c3f6cd7$export$ffcfe8f1c83fc2c3 = (value)=>{
    const ordinalSuffix = (value)=>{
        if (value > 3 && value < 21) return "th";
        switch(value % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };
    return value !== null && value !== undefined ? `${value}${ordinalSuffix(value)}` : "";
};
const $d47525176c3f6cd7$export$161d051f5dd25de7 = (text)=>text.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $d47525176c3f6cd7$export$a6c46a1565bf40e3 = (text, separator)=>text.replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`).replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`).toLowerCase();
const $d47525176c3f6cd7$export$688230ca06b60d9d = (text)=>text[0].toUpperCase() + (text.length > 1 ? text.slice(1) : "");
const $d47525176c3f6cd7$export$b45439f68c0cd8a8 = (companyNumber)=>{
    companyNumber = companyNumber?.trim().toUpperCase().replace(/[^0-9A-Z]/g, "");
    return companyNumber && companyNumber.length <= 8 ? companyNumber.padStart(8, "0") : "";
};
const $d47525176c3f6cd7$export$e0b576e7a74416cd = (text, length)=>{
    if (text) {
        if (text.length > length - 3) return `${text.substring(0, length - 3)}...`;
        return text;
    }
    return "";
};
const $d47525176c3f6cd7$export$e8b8be48b45905bb = (items)=>items.map((item, index)=>`${index > 0 ? index < items.length - 1 ? ", " : " and " : ""}${item}`);


const $0529b7a83755f1dd$var$DEFAULT_WIDTH = 200;
const $0529b7a83755f1dd$export$b5d8dae9ecb8541e = (p)=>({
        locale: (0, $d47525176c3f6cd7$export$1af4c7e47ad72f44).code,
        value: p.value,
        readonly: p.readOnly,
        format: p.format,
        autocomplete: "off",
        placeholder: p.placeholder,
        ...!p.fullwidth ? {
            width: p.width ?? $0529b7a83755f1dd$var$DEFAULT_WIDTH
        } : {},
        height: p.height
    });
const $0529b7a83755f1dd$export$d1df3c7859befd08 = (control)=>{
    return "checked" in control;
};




var $eb6f7fc63f627fea$exports = {};
"use strict";
var $21a857f2c632f015$exports = {};
"use strict";
var $7c2f85ad8c1b0afb$exports = {};
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $2fe227279405861b$exports = {};
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $b5098ac553b04d45$exports = {};
"use strict";

var $6FqDH = parcelRequire("6FqDH");

var $2DXy1 = parcelRequire("2DXy1");
var $d7e2241cf3c714ea$exports = {};
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $2356dfa83381ebc2$exports = {};
"use strict";

var $5bmkL = parcelRequire("5bmkL");

var $f0gvj = parcelRequire("f0gvj");

var $6bQrM = parcelRequire("6bQrM");
var $f8232ffed2d58f72$exports = {};
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $f8232ffed2d58f72$var$$gOPD = $2DXy1("%Object.getOwnPropertyDescriptor%", true);
if ($f8232ffed2d58f72$var$$gOPD) try {
    $f8232ffed2d58f72$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f8232ffed2d58f72$var$$gOPD = null;
}
$f8232ffed2d58f72$exports = $f8232ffed2d58f72$var$$gOPD;


/** @type {import('.')} */ $2356dfa83381ebc2$exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $6bQrM("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $6bQrM("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $6bQrM("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $6bQrM("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $6bQrM("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $6bQrM("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$f8232ffed2d58f72$exports && $f8232ffed2d58f72$exports(obj, property);
    if ($5bmkL) $5bmkL(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $f0gvj("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};



var $d7e2241cf3c714ea$var$hasDescriptors = (parcelRequire("aszze"))();


var $6bQrM = parcelRequire("6bQrM");
var $d7e2241cf3c714ea$var$$floor = $2DXy1("%Math.floor%");
/** @type {import('.')} */ $d7e2241cf3c714ea$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $6bQrM("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $d7e2241cf3c714ea$var$$floor(length) !== length) throw new $6bQrM("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $f8232ffed2d58f72$exports) {
        var desc = $f8232ffed2d58f72$exports(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($d7e2241cf3c714ea$var$hasDescriptors) $2356dfa83381ebc2$exports(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $2356dfa83381ebc2$exports(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};



var $6bQrM = parcelRequire("6bQrM");
var $b5098ac553b04d45$var$$apply = $2DXy1("%Function.prototype.apply%");
var $b5098ac553b04d45$var$$call = $2DXy1("%Function.prototype.call%");
var $b5098ac553b04d45$var$$reflectApply = $2DXy1("%Reflect.apply%", true) || $6FqDH.call($b5098ac553b04d45$var$$call, $b5098ac553b04d45$var$$apply);

var $5bmkL = parcelRequire("5bmkL");
var $b5098ac553b04d45$var$$max = $2DXy1("%Math.max%");
$b5098ac553b04d45$exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $6bQrM("a function is required");
    var func = $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$call, arguments);
    return $d7e2241cf3c714ea$exports(func, 1 + $b5098ac553b04d45$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $b5098ac553b04d45$var$applyBind = function applyBind() {
    return $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$apply, arguments);
};
if ($5bmkL) $5bmkL($b5098ac553b04d45$exports, "apply", {
    value: $b5098ac553b04d45$var$applyBind
});
else $b5098ac553b04d45$exports.apply = $b5098ac553b04d45$var$applyBind;


var $2fe227279405861b$var$$indexOf = $b5098ac553b04d45$exports($2DXy1("String.prototype.indexOf"));
$2fe227279405861b$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $2DXy1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2fe227279405861b$var$$indexOf(name, ".prototype.") > -1) return $b5098ac553b04d45$exports(intrinsic);
    return intrinsic;
};


var $119dab09bed9f066$exports = {};
var $119dab09bed9f066$var$hasMap = typeof Map === "function" && Map.prototype;
var $119dab09bed9f066$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $119dab09bed9f066$var$mapSize = $119dab09bed9f066$var$hasMap && $119dab09bed9f066$var$mapSizeDescriptor && typeof $119dab09bed9f066$var$mapSizeDescriptor.get === "function" ? $119dab09bed9f066$var$mapSizeDescriptor.get : null;
var $119dab09bed9f066$var$mapForEach = $119dab09bed9f066$var$hasMap && Map.prototype.forEach;
var $119dab09bed9f066$var$hasSet = typeof Set === "function" && Set.prototype;
var $119dab09bed9f066$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $119dab09bed9f066$var$setSize = $119dab09bed9f066$var$hasSet && $119dab09bed9f066$var$setSizeDescriptor && typeof $119dab09bed9f066$var$setSizeDescriptor.get === "function" ? $119dab09bed9f066$var$setSizeDescriptor.get : null;
var $119dab09bed9f066$var$setForEach = $119dab09bed9f066$var$hasSet && Set.prototype.forEach;
var $119dab09bed9f066$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $119dab09bed9f066$var$weakMapHas = $119dab09bed9f066$var$hasWeakMap ? WeakMap.prototype.has : null;
var $119dab09bed9f066$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $119dab09bed9f066$var$weakSetHas = $119dab09bed9f066$var$hasWeakSet ? WeakSet.prototype.has : null;
var $119dab09bed9f066$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $119dab09bed9f066$var$weakRefDeref = $119dab09bed9f066$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $119dab09bed9f066$var$booleanValueOf = Boolean.prototype.valueOf;
var $119dab09bed9f066$var$objectToString = Object.prototype.toString;
var $119dab09bed9f066$var$functionToString = Function.prototype.toString;
var $119dab09bed9f066$var$$match = String.prototype.match;
var $119dab09bed9f066$var$$slice = String.prototype.slice;
var $119dab09bed9f066$var$$replace = String.prototype.replace;
var $119dab09bed9f066$var$$toUpperCase = String.prototype.toUpperCase;
var $119dab09bed9f066$var$$toLowerCase = String.prototype.toLowerCase;
var $119dab09bed9f066$var$$test = RegExp.prototype.test;
var $119dab09bed9f066$var$$concat = Array.prototype.concat;
var $119dab09bed9f066$var$$join = Array.prototype.join;
var $119dab09bed9f066$var$$arrSlice = Array.prototype.slice;
var $119dab09bed9f066$var$$floor = Math.floor;
var $119dab09bed9f066$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $119dab09bed9f066$var$gOPS = Object.getOwnPropertySymbols;
var $119dab09bed9f066$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $119dab09bed9f066$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $119dab09bed9f066$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $119dab09bed9f066$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $119dab09bed9f066$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $119dab09bed9f066$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $119dab09bed9f066$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $119dab09bed9f066$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$119dab09bed9f066$var$$floor(-num) : $119dab09bed9f066$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $119dab09bed9f066$var$$slice.call(str, intStr.length + 1);
            return $119dab09bed9f066$var$$replace.call(intStr, sepRegex, "$&_") + "." + $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $119dab09bed9f066$var$$replace.call(str, sepRegex, "$&_");
}
var $b364f2cd2faf3e98$exports = {};
"use strict";


var $119dab09bed9f066$var$inspectCustom = $b364f2cd2faf3e98$exports.custom;
var $119dab09bed9f066$var$inspectSymbol = $119dab09bed9f066$var$isSymbol($119dab09bed9f066$var$inspectCustom) ? $119dab09bed9f066$var$inspectCustom : null;
$119dab09bed9f066$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($119dab09bed9f066$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($119dab09bed9f066$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $119dab09bed9f066$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($119dab09bed9f066$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($119dab09bed9f066$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $119dab09bed9f066$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $119dab09bed9f066$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $119dab09bed9f066$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($119dab09bed9f066$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $119dab09bed9f066$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($119dab09bed9f066$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$119dab09bed9f066$var$isRegExp(obj)) {
        var name = $119dab09bed9f066$var$nameOf(obj);
        var keys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $119dab09bed9f066$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($119dab09bed9f066$var$isSymbol(obj)) {
        var symString = $119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $119dab09bed9f066$var$symToString.call(obj);
        return typeof obj === "object" && !$119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$markBoxed(symString) : symString;
    }
    if ($119dab09bed9f066$var$isElement(obj)) {
        var s = "<" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $119dab09bed9f066$var$wrapQuotes($119dab09bed9f066$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($119dab09bed9f066$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (indent && !$119dab09bed9f066$var$singleLineValues(xs)) return "[" + $119dab09bed9f066$var$indentedJoin(xs, indent) + "]";
        return "[ " + $119dab09bed9f066$var$$join.call(xs, ", ") + " ]";
    }
    if ($119dab09bed9f066$var$isError(obj)) {
        var parts = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$119dab09bed9f066$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($119dab09bed9f066$var$inspectSymbol && typeof obj[$119dab09bed9f066$var$inspectSymbol] === "function" && $b364f2cd2faf3e98$exports) return $b364f2cd2faf3e98$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($119dab09bed9f066$var$isMap(obj)) {
        var mapParts = [];
        if ($119dab09bed9f066$var$mapForEach) $119dab09bed9f066$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Map", $119dab09bed9f066$var$mapSize.call(obj), mapParts, indent);
    }
    if ($119dab09bed9f066$var$isSet(obj)) {
        var setParts = [];
        if ($119dab09bed9f066$var$setForEach) $119dab09bed9f066$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Set", $119dab09bed9f066$var$setSize.call(obj), setParts, indent);
    }
    if ($119dab09bed9f066$var$isWeakMap(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakMap");
    if ($119dab09bed9f066$var$isWeakSet(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakSet");
    if ($119dab09bed9f066$var$isWeakRef(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakRef");
    if ($119dab09bed9f066$var$isNumber(obj)) return $119dab09bed9f066$var$markBoxed(inspect(Number(obj)));
    if ($119dab09bed9f066$var$isBigInt(obj)) return $119dab09bed9f066$var$markBoxed(inspect($119dab09bed9f066$var$bigIntValueOf.call(obj)));
    if ($119dab09bed9f066$var$isBoolean(obj)) return $119dab09bed9f066$var$markBoxed($119dab09bed9f066$var$booleanValueOf.call(obj));
    if ($119dab09bed9f066$var$isString(obj)) return $119dab09bed9f066$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$119dab09bed9f066$var$isDate(obj) && !$119dab09bed9f066$var$isRegExp(obj)) {
        var ys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        var isPlainObject = $119dab09bed9f066$var$gPO ? $119dab09bed9f066$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $119dab09bed9f066$var$toStringTag && Object(obj) === obj && $119dab09bed9f066$var$toStringTag in obj ? $119dab09bed9f066$var$$slice.call($119dab09bed9f066$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $119dab09bed9f066$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $119dab09bed9f066$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $119dab09bed9f066$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $119dab09bed9f066$var$quote(s) {
    return $119dab09bed9f066$var$$replace.call(String(s), /"/g, "&quot;");
}
function $119dab09bed9f066$var$isArray(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Array]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isDate(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Date]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isRegExp(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object RegExp]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isError(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Error]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isString(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object String]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isNumber(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Number]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isBoolean(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Boolean]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $119dab09bed9f066$var$isSymbol(obj) {
    if ($119dab09bed9f066$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$symToString) return false;
    try {
        $119dab09bed9f066$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$bigIntValueOf) return false;
    try {
        $119dab09bed9f066$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $119dab09bed9f066$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $119dab09bed9f066$var$has(obj, key) {
    return $119dab09bed9f066$var$hasOwn.call(obj, key);
}
function $119dab09bed9f066$var$toStr(obj) {
    return $119dab09bed9f066$var$objectToString.call(obj);
}
function $119dab09bed9f066$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $119dab09bed9f066$var$$match.call($119dab09bed9f066$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $119dab09bed9f066$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $119dab09bed9f066$var$isMap(x) {
    if (!$119dab09bed9f066$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$mapSize.call(x);
        try {
            $119dab09bed9f066$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakMap(x) {
    if (!$119dab09bed9f066$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        try {
            $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakRef(x) {
    if (!$119dab09bed9f066$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isSet(x) {
    if (!$119dab09bed9f066$var$setSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$setSize.call(x);
        try {
            $119dab09bed9f066$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakSet(x) {
    if (!$119dab09bed9f066$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        try {
            $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $119dab09bed9f066$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $119dab09bed9f066$var$inspectString($119dab09bed9f066$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $119dab09bed9f066$var$lowbyte);
    return $119dab09bed9f066$var$wrapQuotes(s, "single", opts);
}
function $119dab09bed9f066$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $119dab09bed9f066$var$$toUpperCase.call(n.toString(16));
}
function $119dab09bed9f066$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $119dab09bed9f066$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $119dab09bed9f066$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $119dab09bed9f066$var$indentedJoin(entries, indent) : $119dab09bed9f066$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $119dab09bed9f066$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($119dab09bed9f066$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $119dab09bed9f066$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $119dab09bed9f066$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $119dab09bed9f066$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $119dab09bed9f066$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $119dab09bed9f066$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $119dab09bed9f066$var$arrObjKeys(obj, inspect) {
    var isArr = $119dab09bed9f066$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $119dab09bed9f066$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $119dab09bed9f066$var$gOPS === "function" ? $119dab09bed9f066$var$gOPS(obj) : [];
    var symMap;
    if ($119dab09bed9f066$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$119dab09bed9f066$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($119dab09bed9f066$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($119dab09bed9f066$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $119dab09bed9f066$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($119dab09bed9f066$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}



var $6bQrM = parcelRequire("6bQrM");
var $7c2f85ad8c1b0afb$var$$WeakMap = $2DXy1("%WeakMap%", true);
var $7c2f85ad8c1b0afb$var$$Map = $2DXy1("%Map%", true);
var $7c2f85ad8c1b0afb$var$$weakMapGet = $2fe227279405861b$exports("WeakMap.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$weakMapSet = $2fe227279405861b$exports("WeakMap.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$weakMapHas = $2fe227279405861b$exports("WeakMap.prototype.has", true);
var $7c2f85ad8c1b0afb$var$$mapGet = $2fe227279405861b$exports("Map.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$mapSet = $2fe227279405861b$exports("Map.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$mapHas = $2fe227279405861b$exports("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $7c2f85ad8c1b0afb$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $7c2f85ad8c1b0afb$var$listGet = function(objects, key) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $7c2f85ad8c1b0afb$var$listSet = function(objects, key, value) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $7c2f85ad8c1b0afb$var$listHas = function(objects, key) {
    return !!$7c2f85ad8c1b0afb$var$listGetNode(objects, key);
};
/** @type {import('.')} */ $7c2f85ad8c1b0afb$exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6bQrM("Side channel does not contain " + $119dab09bed9f066$exports(key));
        },
        get: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapGet($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapGet($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapHas($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapHas($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $7c2f85ad8c1b0afb$var$$WeakMap();
                $7c2f85ad8c1b0afb$var$$weakMapSet($wm, key, value);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if (!$m) $m = new $7c2f85ad8c1b0afb$var$$Map();
                $7c2f85ad8c1b0afb$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $7c2f85ad8c1b0afb$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $c28806fde4f5d743$exports = {};
"use strict";
var $e77cc7fa9fbe3dde$exports = {};
"use strict";
var $e77cc7fa9fbe3dde$var$replace = String.prototype.replace;
var $e77cc7fa9fbe3dde$var$percentTwenties = /%20/g;
var $e77cc7fa9fbe3dde$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$e77cc7fa9fbe3dde$exports = {
    "default": $e77cc7fa9fbe3dde$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e77cc7fa9fbe3dde$var$replace.call(value, $e77cc7fa9fbe3dde$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e77cc7fa9fbe3dde$var$Format.RFC1738,
    RFC3986: $e77cc7fa9fbe3dde$var$Format.RFC3986
};


var $c28806fde4f5d743$var$has = Object.prototype.hasOwnProperty;
var $c28806fde4f5d743$var$isArray = Array.isArray;
var $c28806fde4f5d743$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $c28806fde4f5d743$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($c28806fde4f5d743$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $c28806fde4f5d743$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $c28806fde4f5d743$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($c28806fde4f5d743$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$c28806fde4f5d743$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($c28806fde4f5d743$var$isArray(target) && !$c28806fde4f5d743$var$isArray(source)) mergeTarget = $c28806fde4f5d743$var$arrayToObject(target, options);
    if ($c28806fde4f5d743$var$isArray(target) && $c28806fde4f5d743$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($c28806fde4f5d743$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($c28806fde4f5d743$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $c28806fde4f5d743$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $c28806fde4f5d743$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $c28806fde4f5d743$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $c28806fde4f5d743$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $c28806fde4f5d743$var$limit){
        var segment = string.length >= $c28806fde4f5d743$var$limit ? string.slice(j, j + $c28806fde4f5d743$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $e77cc7fa9fbe3dde$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xC0 | c >> 6] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xE0 | c >> 12] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xF0 | c >> 18] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 12 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $c28806fde4f5d743$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $c28806fde4f5d743$var$compactQueue(queue);
    return value;
};
var $c28806fde4f5d743$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $c28806fde4f5d743$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $c28806fde4f5d743$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $c28806fde4f5d743$var$maybeMap = function maybeMap(val, fn) {
    if ($c28806fde4f5d743$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$c28806fde4f5d743$exports = {
    arrayToObject: $c28806fde4f5d743$var$arrayToObject,
    assign: $c28806fde4f5d743$var$assign,
    combine: $c28806fde4f5d743$var$combine,
    compact: $c28806fde4f5d743$var$compact,
    decode: $c28806fde4f5d743$var$decode,
    encode: $c28806fde4f5d743$var$encode,
    isBuffer: $c28806fde4f5d743$var$isBuffer,
    isRegExp: $c28806fde4f5d743$var$isRegExp,
    maybeMap: $c28806fde4f5d743$var$maybeMap,
    merge: $c28806fde4f5d743$var$merge
};



var $21a857f2c632f015$var$has = Object.prototype.hasOwnProperty;
var $21a857f2c632f015$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $21a857f2c632f015$var$isArray = Array.isArray;
var $21a857f2c632f015$var$push = Array.prototype.push;
var $21a857f2c632f015$var$pushToArray = function(arr, valueOrArray) {
    $21a857f2c632f015$var$push.apply(arr, $21a857f2c632f015$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $21a857f2c632f015$var$toISO = Date.prototype.toISOString;
var $21a857f2c632f015$var$defaultFormat = $e77cc7fa9fbe3dde$exports.default;
var $21a857f2c632f015$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $c28806fde4f5d743$exports.encode,
    encodeValuesOnly: false,
    format: $21a857f2c632f015$var$defaultFormat,
    formatter: $e77cc7fa9fbe3dde$exports.formatters[$21a857f2c632f015$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $21a857f2c632f015$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $21a857f2c632f015$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $21a857f2c632f015$var$sentinel = {};
var $21a857f2c632f015$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($21a857f2c632f015$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($21a857f2c632f015$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) obj = $c28806fde4f5d743$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($21a857f2c632f015$var$isNonNullishPrimitive(obj) || $c28806fde4f5d743$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $21a857f2c632f015$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $c28806fde4f5d743$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($21a857f2c632f015$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $21a857f2c632f015$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $21a857f2c632f015$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $21a857f2c632f015$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $7c2f85ad8c1b0afb$exports();
        valueSideChannel.set($21a857f2c632f015$var$sentinel, sideChannel);
        $21a857f2c632f015$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $21a857f2c632f015$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $21a857f2c632f015$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $21a857f2c632f015$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $21a857f2c632f015$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $e77cc7fa9fbe3dde$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$21a857f2c632f015$var$has.call($e77cc7fa9fbe3dde$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $e77cc7fa9fbe3dde$exports.formatters[format];
    var filter = $21a857f2c632f015$var$defaults.filter;
    if (typeof opts.filter === "function" || $21a857f2c632f015$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $21a857f2c632f015$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $21a857f2c632f015$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $21a857f2c632f015$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $21a857f2c632f015$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $21a857f2c632f015$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $21a857f2c632f015$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $21a857f2c632f015$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $21a857f2c632f015$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $21a857f2c632f015$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $21a857f2c632f015$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $21a857f2c632f015$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $21a857f2c632f015$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $21a857f2c632f015$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $21a857f2c632f015$var$defaults.strictNullHandling
    };
};
$21a857f2c632f015$exports = function(object, opts) {
    var obj = object;
    var options = $21a857f2c632f015$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($21a857f2c632f015$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $21a857f2c632f015$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $7c2f85ad8c1b0afb$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $21a857f2c632f015$var$pushToArray(keys, $21a857f2c632f015$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $85c239e60adf14b2$exports = {};
"use strict";

var $85c239e60adf14b2$var$has = Object.prototype.hasOwnProperty;
var $85c239e60adf14b2$var$isArray = Array.isArray;
var $85c239e60adf14b2$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $c28806fde4f5d743$exports.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $85c239e60adf14b2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $85c239e60adf14b2$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $85c239e60adf14b2$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $85c239e60adf14b2$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $85c239e60adf14b2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $85c239e60adf14b2$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $85c239e60adf14b2$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = $c28806fde4f5d743$exports.maybeMap($85c239e60adf14b2$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $85c239e60adf14b2$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $85c239e60adf14b2$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $85c239e60adf14b2$var$isArray(val) ? [
            val
        ] : val;
        var existing = $85c239e60adf14b2$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $c28806fde4f5d743$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $85c239e60adf14b2$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $85c239e60adf14b2$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $85c239e60adf14b2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $85c239e60adf14b2$var$parseObject(keys, val, options, valuesParsed);
};
var $85c239e60adf14b2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $85c239e60adf14b2$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $85c239e60adf14b2$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $85c239e60adf14b2$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $85c239e60adf14b2$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $85c239e60adf14b2$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $85c239e60adf14b2$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $85c239e60adf14b2$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $85c239e60adf14b2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $85c239e60adf14b2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $85c239e60adf14b2$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $85c239e60adf14b2$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $85c239e60adf14b2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $c28806fde4f5d743$exports.isRegExp(opts.delimiter) ? opts.delimiter : $85c239e60adf14b2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $85c239e60adf14b2$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $85c239e60adf14b2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $85c239e60adf14b2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $85c239e60adf14b2$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $85c239e60adf14b2$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $85c239e60adf14b2$var$defaults.strictNullHandling
    };
};
$85c239e60adf14b2$exports = function(str, opts) {
    var options = $85c239e60adf14b2$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $85c239e60adf14b2$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $85c239e60adf14b2$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $c28806fde4f5d743$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $c28806fde4f5d743$exports.compact(obj);
};



$eb6f7fc63f627fea$exports = {
    formats: $e77cc7fa9fbe3dde$exports,
    parse: $85c239e60adf14b2$exports,
    stringify: $21a857f2c632f015$exports
};


const $e56e694ede576bd9$export$3b6bf62ab04cab53 = "00000000-0000-0000-0000-000000000000";
const $e56e694ede576bd9$export$e6d857db2421f697 = [
    14,
    7,
    2,
    -7
];
const $e56e694ede576bd9$export$f5cf78abc0513307 = new Date(2000, 0, 1);
const $e56e694ede576bd9$export$7ebe3995293fd6a4 = new Date(2000, 11, 31);
const $e56e694ede576bd9$export$530097e879f93363 = "Inter, sans-serif";
const $e56e694ede576bd9$export$9516f9e0a56cdf20 = 200;







const $9f9ac9f3de351425$var$clone = (date)=>new Date(date.toISOString());
const $9f9ac9f3de351425$var$day = (date)=>new Date(date.toISOString().substring(0, 10));
const $9f9ac9f3de351425$export$6e9f82d5020ebbe1 = ()=>$9f9ac9f3de351425$var$day(new Date());
const $9f9ac9f3de351425$export$a45dbfcf8ef64b29 = ()=>$9f9ac9f3de351425$export$aad298462b7e3d2($9f9ac9f3de351425$export$6e9f82d5020ebbe1(), 1);
const $9f9ac9f3de351425$export$d5412b292ff2eada = ()=>$9f9ac9f3de351425$export$1edf41940c330f6a($9f9ac9f3de351425$export$6e9f82d5020ebbe1(), 1);
const $9f9ac9f3de351425$export$cbb8a80bf7bff705 = (date, minutes)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    date.setUTCMinutes(date.getUTCMinutes() + minutes);
    return date;
};
const $9f9ac9f3de351425$export$7532231a9c294418 = (date, minutes)=>$9f9ac9f3de351425$export$cbb8a80bf7bff705(date, minutes * -1);
const $9f9ac9f3de351425$export$c3d63ac2c17701bb = (date, hours)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    date.setUTCHours(date.getUTCHours() + hours);
    return date;
};
const $9f9ac9f3de351425$export$7ba4c92ab1ea03f = (date, hours)=>$9f9ac9f3de351425$export$c3d63ac2c17701bb(date, hours * -1);
const $9f9ac9f3de351425$export$aad298462b7e3d2 = (date, days)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    date.setUTCDate(date.getUTCDate() + days);
    return date;
};
const $9f9ac9f3de351425$export$1edf41940c330f6a = (date, days)=>$9f9ac9f3de351425$export$aad298462b7e3d2(date, days * -1);
const $9f9ac9f3de351425$export$c10b95603af8c414 = (date, weeks)=>$9f9ac9f3de351425$export$aad298462b7e3d2(date, weeks * 7);
const $9f9ac9f3de351425$export$8e6a0de56683c9ed = (date, weeks)=>$9f9ac9f3de351425$export$c10b95603af8c414(date, weeks * -1);
const $9f9ac9f3de351425$export$1a67e3bf22830960 = (date, months)=>{
    const newDate = $9f9ac9f3de351425$var$clone(date);
    newDate.setUTCMonth(date.getUTCMonth() + months);
    const newDay = newDate.getUTCDate();
    if (newDay < date.getUTCDate()) newDate.setUTCDate(newDay + newDay * -1);
    return newDate;
};
const $9f9ac9f3de351425$export$a44b8acdac83201b = (date, months)=>$9f9ac9f3de351425$export$1a67e3bf22830960(date, months * -1);
const $9f9ac9f3de351425$export$49e2edb8f52bb533 = (date, years)=>$9f9ac9f3de351425$export$1a67e3bf22830960(date, years * 12);
const $9f9ac9f3de351425$export$d7a55d3170ab8791 = (date, years)=>$9f9ac9f3de351425$export$49e2edb8f52bb533(date, years * -1);
const $9f9ac9f3de351425$export$83e394efa4854fed = (date)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    let dow = date.getUTCDay();
    dow = dow === 0 ? 7 : dow;
    if (dow !== 1) date = $9f9ac9f3de351425$export$1edf41940c330f6a(date, dow - 1);
    return date;
};
const $9f9ac9f3de351425$export$bfaee0935f09ee8f = (date)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    let dow = date.getUTCDay();
    dow = dow === 0 ? 7 : dow;
    if (dow !== 7) date = $9f9ac9f3de351425$export$aad298462b7e3d2(date, 7 - dow);
    return date;
};
const $9f9ac9f3de351425$export$ba625e09403c9264 = (date)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    date.setUTCDate(1);
    return date;
};
const $9f9ac9f3de351425$export$8ae8127771512f54 = (date)=>{
    date = $9f9ac9f3de351425$export$ba625e09403c9264(date);
    date = $9f9ac9f3de351425$export$1a67e3bf22830960(date, 1);
    date = $9f9ac9f3de351425$export$1edf41940c330f6a(date, 1);
    return date;
};
const $9f9ac9f3de351425$export$1b4b7e6fc1942ead = (date)=>{
    date = $9f9ac9f3de351425$var$clone(date);
    date.setUTCMonth(0);
    date.setUTCDate(1);
    return date;
};
const $9f9ac9f3de351425$export$7cc497dfcde321 = (date)=>{
    date = $9f9ac9f3de351425$export$1b4b7e6fc1942ead(date);
    date = $9f9ac9f3de351425$export$49e2edb8f52bb533(date, 1);
    date = $9f9ac9f3de351425$export$1edf41940c330f6a(date, 1);
    return date;
};
const $9f9ac9f3de351425$export$2926186cdd904311 = (date1, date2)=>Math.floor((date1.getTime() - date2.getTime()) / 60000);
const $9f9ac9f3de351425$export$5c8a9d017225d0f3 = (date1, date2)=>Math.floor((date1.getTime() - date2.getTime()) / 3600000);
const $9f9ac9f3de351425$export$c9458bb7d024b650 = (date1, date2)=>Math.floor((date1.getTime() - date2.getTime()) / 86400000);
const $9f9ac9f3de351425$export$5448b37e743457d = (expires)=>expires ? $9f9ac9f3de351425$export$c9458bb7d024b650($9f9ac9f3de351425$var$day(expires), $9f9ac9f3de351425$export$6e9f82d5020ebbe1()) : undefined;
const $9f9ac9f3de351425$export$420184cfda1c644d = (from, to, step)=>(0, $23645516f0d2c47e$export$d02631cccf789723)($9f9ac9f3de351425$export$c9458bb7d024b650(to, from) + 1, step).map((i)=>$9f9ac9f3de351425$export$aad298462b7e3d2(from, i));


const $55576f0fdfdeec43$export$486d479307698859 = "https://find-and-update.company-information.service.gov.uk/company/${value}";
const $55576f0fdfdeec43$export$6ddccd71b44bdf08 = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).companies.edit({
    id: "${value}"
});
const $55576f0fdfdeec43$export$1e683a45f44ce12a = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).individuals.edit({
    id: "${value}"
});
const $55576f0fdfdeec43$export$8fa1eaeb4700701e = (url, query, encode)=>url + (url.indexOf("?") === -1 ? "?" : "&") + (0, (/*@__PURE__*/$parcel$interopDefault($eb6f7fc63f627fea$exports))).stringify(query, {
        encode: encode !== undefined ? encode : true
    });
const $55576f0fdfdeec43$export$fae5e008afc98d0e = (params)=>{
    const sortedParams = Object.entries(params).sort(([a], [b])=>a.localeCompare(b));
    return new URLSearchParams(sortedParams).toString();
};
const $55576f0fdfdeec43$export$99644c5386245dec = (url, query)=>$55576f0fdfdeec43$export$8fa1eaeb4700701e(url, {
        offcanvas: "true",
        ...query
    });
const $55576f0fdfdeec43$export$d40de045aa35670f = (url, query)=>$55576f0fdfdeec43$export$8fa1eaeb4700701e(url, {
        offcanvas: "true",
        back: "true",
        ...query
    });
const $55576f0fdfdeec43$export$9db65ea1b5d08a0 = (registrationNumber)=>$55576f0fdfdeec43$export$486d479307698859.replaceAll("${value}", registrationNumber);
const $55576f0fdfdeec43$var$filterUrl = (url, query)=>$55576f0fdfdeec43$export$8fa1eaeb4700701e(url, Object.keys(query).map((key)=>{
        return {
            [`f_${key}`]: query[key]
        };
    }).reduce((0, $81088ee9a0e19312$export$4950aa0f605343fb)), false);
const $55576f0fdfdeec43$export$49840abff869cea = (params)=>{
    const { userId: userId, dueTimeFrame: dueTimeFrame, dueTimeFrameType: dueTimeFrameType } = params;
    const query = {};
    if (userId) query.accountManagerId = userId;
    if (dueTimeFrame) {
        let dueTimeFramesField = "dueTimeFrames";
        if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).Accounts) dueTimeFramesField = "accountsDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).AmlCheck) dueTimeFramesField = "amlCheckDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).Bookkeeping) dueTimeFramesField = "bookkeepingDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).CisReturn) dueTimeFramesField = "cisReturnDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).ConfirmationStatement) dueTimeFramesField = "confirmationStatementDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).Payroll) dueTimeFramesField = "payrollDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).TaxReturn) dueTimeFramesField = "taxReturnDueTimeFrames";
        else if (dueTimeFrameType === (0, $19ee14db620c232e$export$96874393e71880e2).VatReturn) dueTimeFramesField = "vatReturnDueTimeFrames";
        query[dueTimeFramesField] = `contains|${dueTimeFrame}`;
    }
    return $55576f0fdfdeec43$var$filterUrl((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).companies.list({
        archived: false
    }), query);
};
const $55576f0fdfdeec43$export$77b11bc1d67f694f = (params)=>{
    const { clientId: clientId, serviceId: serviceId, userId: userId, dueTimeFrame: dueTimeFrame, recordsStatus: recordsStatus, status: status, preset: preset } = params;
    const query = {};
    if (clientId) query.clientId = clientId;
    if (serviceId) query.serviceId = serviceId !== (0, $e56e694ede576bd9$export$3b6bf62ab04cab53) ? serviceId : "isnull";
    if (userId) query.assignedToUserId = userId;
    if (dueTimeFrame) query.dueTimeFrames = `contains|${dueTimeFrame}`;
    if (recordsStatus) query.recordsStatus = recordsStatus;
    if (status) query.status = status;
    if (preset === "uncompleted") query.status = `notequal|${(0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed}`;
    else if (preset === "completed30Days") {
        query.completedDate = `greaterthanorequal|${(0, $fb0301734e2a6838$export$1431bc52824a265)((0, $9f9ac9f3de351425$export$1edf41940c330f6a)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 30))}`;
        query.status = (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed;
    }
    return $55576f0fdfdeec43$var$filterUrl((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).tasks.list(), query);
};
const $55576f0fdfdeec43$export$d7220ab4bc91d854 = (params)=>{
    const { clientId: clientId, serviceId: serviceId, userId: userId, status: status } = params;
    const query = {};
    if (clientId) query.clientId = clientId;
    if (serviceId) query.serviceId = serviceId;
    if (userId) query.assignedToUserId = userId;
    if (status) query.status = status;
    return $55576f0fdfdeec43$var$filterUrl((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).recurringTasks.list(), query);
};
const $55576f0fdfdeec43$export$6c686320cc2a12f9 = (params)=>{
    const { serviceId: serviceId, userId: userId } = params;
    const query = {};
    if (serviceId) query.serviceId = serviceId;
    if (userId) query.assignedToUserId = userId;
    return $55576f0fdfdeec43$var$filterUrl((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).smartTasks.list(), query);
};




parcelRequire("j7YE8");
var $c2qqN = parcelRequire("c2qqN");
var $4ZDHT = parcelRequire("4ZDHT");
var $e7i2H = parcelRequire("e7i2H");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");
var $i528u = parcelRequire("i528u");

var $2vAqh = parcelRequire("2vAqh");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $bWDaN = parcelRequire("bWDaN");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");
var $kj1BR = parcelRequire("kj1BR");
var $1d370936294fcc88$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1d370936294fcc88$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
//class constant defination.
var $1d370936294fcc88$var$OTHERMONTH = "e-other-month";
var $1d370936294fcc88$var$OTHERDECADE = "e-other-year";
var $1d370936294fcc88$var$ROOT = "e-calendar";
var $1d370936294fcc88$var$DEVICE = "e-device";
var $1d370936294fcc88$var$HEADER = "e-header";
var $1d370936294fcc88$var$RTL = "e-rtl";
var $1d370936294fcc88$var$CONTENT = "e-content";
var $1d370936294fcc88$var$CONTENTTABLE = "e-calendar-content-table";
var $1d370936294fcc88$var$YEAR = "e-year";
var $1d370936294fcc88$var$MONTH = "e-month";
var $1d370936294fcc88$var$DECADE = "e-decade";
var $1d370936294fcc88$var$ICON = "e-icons";
var $1d370936294fcc88$var$PREVICON = "e-prev";
var $1d370936294fcc88$var$NEXTICON = "e-next";
var $1d370936294fcc88$var$PREVSPAN = "e-date-icon-prev";
var $1d370936294fcc88$var$NEXTSPAN = "e-date-icon-next ";
var $1d370936294fcc88$var$ICONCONTAINER = "e-icon-container";
var $1d370936294fcc88$var$DISABLED = "e-disabled";
var $1d370936294fcc88$var$OVERLAY = "e-overlay";
var $1d370936294fcc88$var$WEEKEND = "e-weekend";
var $1d370936294fcc88$var$WEEKNUMBER = "e-week-number";
var $1d370936294fcc88$var$SELECTED = "e-selected";
var $1d370936294fcc88$var$FOCUSEDDATE = "e-focused-date";
var $1d370936294fcc88$var$FOCUSEDCELL = "e-focused-cell";
var $1d370936294fcc88$var$OTHERMONTHROW = "e-month-hide";
var $1d370936294fcc88$var$TODAY = "e-today";
var $1d370936294fcc88$var$TITLE = "e-title";
var $1d370936294fcc88$var$LINK = "e-day";
var $1d370936294fcc88$var$CELL = "e-cell";
var $1d370936294fcc88$var$WEEKHEADER = "e-week-header";
var $1d370936294fcc88$var$ZOOMIN = "e-zoomin";
var $1d370936294fcc88$var$FOOTER = "e-footer-container";
var $1d370936294fcc88$var$BTN = "e-btn";
var $1d370936294fcc88$var$FLAT = "e-flat";
var $1d370936294fcc88$var$CSS = "e-css";
var $1d370936294fcc88$var$PRIMARY = "e-primary";
var $1d370936294fcc88$var$DAYHEADERLONG = "e-calendar-day-header-lg";
var $1d370936294fcc88$var$dayMilliSeconds = 86400000;
var $1d370936294fcc88$var$minutesMilliSeconds = 60000;
/**
 *
 * @private
 */ var $1d370936294fcc88$export$bfd52a43017368fe = /** @class */ function(_super) {
    $1d370936294fcc88$var$__extends(CalendarBase, _super);
    /**
     * Initialized new instance of Calendar Class.
     * Constructor for creating the widget
     *
     * @param {CalendarBaseModel} options - Specifies the CalendarBase model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function CalendarBase(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.effect = "";
        _this.isPopupClicked = false;
        _this.isDateSelected = true;
        _this.isTodayClicked = false;
        _this.preventChange = false;
        _this.previousDates = false;
        return _this;
    }
    /**
     * To Initialize the control rendering.
     *
     * @returns {void}
     * @private
     */ CalendarBase.prototype.render = function() {
        this.rangeValidation(this.min, this.max);
        this.calendarEleCopy = this.element.cloneNode(true);
        if (this.calendarMode === "Islamic") {
            if (+this.min.setSeconds(0) === +new Date(1900, 0, 1, 0, 0, 0)) this.min = new Date(1944, 2, 18);
            if (+this.max === +new Date(2099, 11, 31)) this.max = new Date(2069, 10, 16);
        }
        this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
        if ((0, $3EnZW.isNullOrUndefined)(this.firstDayOfWeek) || this.firstDayOfWeek > 6 || this.firstDayOfWeek < 0) this.setProperties({
            firstDayOfWeek: this.globalize.getFirstDayOfWeek()
        }, true);
        this.todayDisabled = false;
        this.todayDate = new Date(new Date().setHours(0, 0, 0, 0));
        if (this.getModuleName() === "calendar") {
            this.element.classList.add($1d370936294fcc88$var$ROOT);
            if (this.enableRtl) this.element.classList.add($1d370936294fcc88$var$RTL);
            if ((0, $5q7BP.Browser).isDevice) this.element.classList.add($1d370936294fcc88$var$DEVICE);
            (0, $4ZDHT.attributes)(this.element, {
                "data-role": "calendar"
            });
            this.tabIndex = this.element.hasAttribute("tabindex") ? this.element.getAttribute("tabindex") : "0";
            this.element.setAttribute("tabindex", this.tabIndex);
        } else {
            this.calendarElement = this.createElement("div");
            this.calendarElement.classList.add($1d370936294fcc88$var$ROOT);
            if (this.enableRtl) this.calendarElement.classList.add($1d370936294fcc88$var$RTL);
            if ((0, $5q7BP.Browser).isDevice) this.calendarElement.classList.add($1d370936294fcc88$var$DEVICE);
            (0, $4ZDHT.attributes)(this.calendarElement, {
                "data-role": "calendar"
            });
        }
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        this.createHeader();
        this.createContent();
        this.wireEvents();
    };
    CalendarBase.prototype.rangeValidation = function(min, max) {
        if ((0, $3EnZW.isNullOrUndefined)(min)) this.setProperties({
            min: new Date(1900, 0, 1)
        }, true);
        if ((0, $3EnZW.isNullOrUndefined)(max)) this.setProperties({
            max: new Date(2099, 11, 31)
        }, true);
    };
    CalendarBase.prototype.getDefaultKeyConfig = function() {
        this.defaultKeyConfigs = {
            controlUp: "ctrl+38",
            controlDown: "ctrl+40",
            moveDown: "downarrow",
            moveUp: "uparrow",
            moveLeft: "leftarrow",
            moveRight: "rightarrow",
            select: "enter",
            home: "home",
            end: "end",
            pageUp: "pageup",
            pageDown: "pagedown",
            shiftPageUp: "shift+pageup",
            shiftPageDown: "shift+pagedown",
            controlHome: "ctrl+home",
            controlEnd: "ctrl+end",
            altUpArrow: "alt+uparrow",
            spacebar: "space",
            altRightArrow: "alt+rightarrow",
            altLeftArrow: "alt+leftarrow"
        };
        return this.defaultKeyConfigs;
    };
    CalendarBase.prototype.validateDate = function(value) {
        this.setProperties({
            min: this.checkDateValue(new Date(this.checkValue(this.min)))
        }, true);
        this.setProperties({
            max: this.checkDateValue(new Date(this.checkValue(this.max)))
        }, true);
        this.currentDate = this.currentDate ? this.currentDate : new Date(new Date().setHours(0, 0, 0, 0));
        if (!(0, $3EnZW.isNullOrUndefined)(value) && this.min <= this.max && value >= this.min && value <= this.max) this.currentDate = new Date(this.checkValue(value));
    };
    CalendarBase.prototype.setOverlayIndex = function(popupWrapper, popupElement, modal, isDevice) {
        if (isDevice && !(0, $3EnZW.isNullOrUndefined)(popupElement) && !(0, $3EnZW.isNullOrUndefined)(modal) && !(0, $3EnZW.isNullOrUndefined)(popupWrapper)) {
            var index = parseInt(popupElement.style.zIndex, 10) ? parseInt(popupElement.style.zIndex, 10) : 1000;
            modal.style.zIndex = (index - 1).toString();
            popupWrapper.style.zIndex = index.toString();
        }
    };
    CalendarBase.prototype.minMaxUpdate = function(value) {
        if (!(+this.min <= +this.max)) {
            this.setProperties({
                min: this.min
            }, true);
            (0, $4ZDHT.addClass)([
                this.element
            ], $1d370936294fcc88$var$OVERLAY);
        } else (0, $4ZDHT.removeClass)([
            this.element
        ], $1d370936294fcc88$var$OVERLAY);
        this.min = (0, $3EnZW.isNullOrUndefined)(this.min) || !+this.min ? this.min = new Date(1900, 0, 1) : this.min;
        this.max = (0, $3EnZW.isNullOrUndefined)(this.max) || !+this.max ? this.max = new Date(2099, 11, 31) : this.max;
        if (+this.min <= +this.max && value && +value <= +this.max && +value >= +this.min) this.currentDate = new Date(this.checkValue(value));
        else {
            if (+this.min <= +this.max && !value && +this.currentDate > +this.max) this.currentDate = new Date(this.checkValue(this.max));
            else if (+this.currentDate < +this.min) this.currentDate = new Date(this.checkValue(this.min));
        }
    };
    CalendarBase.prototype.createHeader = function() {
        var ariaPrevAttrs = {
            "aria-disabled": "false",
            "aria-label": "previous month"
        };
        var ariaNextAttrs = {
            "aria-disabled": "false",
            "aria-label": "next month"
        };
        var ariaTitleAttrs = {
            "aria-atomic": "true",
            "aria-live": "assertive",
            "aria-label": "title"
        };
        var tabIndexAttr = {
            "tabindex": "0"
        };
        this.headerElement = this.createElement("div", {
            className: $1d370936294fcc88$var$HEADER
        });
        var iconContainer = this.createElement("div", {
            className: $1d370936294fcc88$var$ICONCONTAINER
        });
        this.previousIcon = this.createElement("button", {
            className: "" + $1d370936294fcc88$var$PREVICON,
            attrs: {
                type: "button"
            }
        });
        (0, $kj1BR.rippleEffect)(this.previousIcon, {
            duration: 400,
            selector: ".e-prev",
            isCenterRipple: true
        });
        (0, $4ZDHT.attributes)(this.previousIcon, ariaPrevAttrs);
        (0, $4ZDHT.attributes)(this.previousIcon, tabIndexAttr);
        this.nextIcon = this.createElement("button", {
            className: "" + $1d370936294fcc88$var$NEXTICON,
            attrs: {
                type: "button"
            }
        });
        (0, $kj1BR.rippleEffect)(this.nextIcon, {
            selector: ".e-next",
            duration: 400,
            isCenterRipple: true
        });
        if (this.getModuleName() === "daterangepicker") {
            (0, $4ZDHT.attributes)(this.previousIcon, {
                tabIndex: "-1"
            });
            (0, $4ZDHT.attributes)(this.nextIcon, {
                tabIndex: "-1"
            });
        }
        (0, $4ZDHT.attributes)(this.nextIcon, ariaNextAttrs);
        (0, $4ZDHT.attributes)(this.nextIcon, tabIndexAttr);
        this.headerTitleElement = this.createElement("div", {
            className: "" + $1d370936294fcc88$var$LINK + " " + $1d370936294fcc88$var$TITLE
        });
        (0, $4ZDHT.attributes)(this.headerTitleElement, ariaTitleAttrs);
        (0, $4ZDHT.attributes)(this.headerTitleElement, tabIndexAttr);
        this.headerElement.appendChild(this.headerTitleElement);
        this.previousIcon.appendChild(this.createElement("span", {
            className: "" + $1d370936294fcc88$var$PREVSPAN + " " + $1d370936294fcc88$var$ICON
        }));
        this.nextIcon.appendChild(this.createElement("span", {
            className: "" + $1d370936294fcc88$var$NEXTSPAN + " " + $1d370936294fcc88$var$ICON
        }));
        iconContainer.appendChild(this.previousIcon);
        iconContainer.appendChild(this.nextIcon);
        this.headerElement.appendChild(iconContainer);
        if (this.getModuleName() === "calendar") this.element.appendChild(this.headerElement);
        else this.calendarElement.appendChild(this.headerElement);
        this.adjustLongHeaderSize();
    };
    CalendarBase.prototype.createContent = function() {
        this.contentElement = this.createElement("div", {
            className: $1d370936294fcc88$var$CONTENT
        });
        this.table = this.createElement("table", {
            attrs: {
                "class": $1d370936294fcc88$var$CONTENTTABLE,
                "tabIndex": "0",
                "role": "grid",
                "aria-activedescendant": "",
                "aria-labelledby": this.element.id
            }
        });
        if (this.getModuleName() === "calendar") this.element.appendChild(this.contentElement);
        else this.calendarElement.appendChild(this.contentElement);
        this.contentElement.appendChild(this.table);
        this.createContentHeader();
        this.createContentBody();
        if (this.showTodayButton) this.createContentFooter();
        if (this.getModuleName() !== "daterangepicker") {
            (0, $aqzbR.EventHandler).add(this.table, "focus", this.addContentFocus, this);
            (0, $aqzbR.EventHandler).add(this.table, "blur", this.removeContentFocus, this);
        }
    };
    CalendarBase.prototype.addContentFocus = function(args) {
        var focusedDate = this.tableBodyElement.querySelector("tr td.e-focused-date");
        var selectedDate = this.tableBodyElement.querySelector("tr td.e-selected");
        if (!(0, $3EnZW.isNullOrUndefined)(selectedDate)) selectedDate.classList.add($1d370936294fcc88$var$FOCUSEDCELL);
        else if (!(0, $3EnZW.isNullOrUndefined)(focusedDate)) focusedDate.classList.add($1d370936294fcc88$var$FOCUSEDCELL);
    };
    CalendarBase.prototype.removeContentFocus = function(args) {
        var focusedDate = !(0, $3EnZW.isNullOrUndefined)(this.tableBodyElement) ? this.tableBodyElement.querySelector("tr td.e-focused-date") : null;
        var selectedDate = !(0, $3EnZW.isNullOrUndefined)(this.tableBodyElement) ? this.tableBodyElement.querySelector("tr td.e-selected") : null;
        if (!(0, $3EnZW.isNullOrUndefined)(selectedDate)) selectedDate.classList.remove($1d370936294fcc88$var$FOCUSEDCELL);
        else if (!(0, $3EnZW.isNullOrUndefined)(focusedDate)) focusedDate.classList.remove($1d370936294fcc88$var$FOCUSEDCELL);
    };
    CalendarBase.prototype.getCultureValues = function() {
        var culShortNames = [];
        var cldrObj;
        var dayFormat = !(0, $3EnZW.isNullOrUndefined)(this.dayHeaderFormat) ? "days.stand-alone." + this.dayHeaderFormat.toLowerCase() : null;
        if ((this.locale === "en" || this.locale === "en-US") && !(0, $3EnZW.isNullOrUndefined)(dayFormat)) cldrObj = (0, $3EnZW.getValue)(dayFormat, (0, $bWDaN.getDefaultDateObject)());
        else cldrObj = this.getCultureObjects((0, $bWDaN.cldrData), "" + this.locale);
        if (!(0, $3EnZW.isNullOrUndefined)(cldrObj)) for(var _i = 0, _a = Object.keys(cldrObj); _i < _a.length; _i++){
            var obj = _a[_i];
            culShortNames.push((0, $3EnZW.getValue)(obj, cldrObj));
        }
        return culShortNames;
    };
    CalendarBase.prototype.toCapitalize = function(text) {
        return !(0, $3EnZW.isNullOrUndefined)(text) && text.length ? text[0].toUpperCase() + text.slice(1) : text;
    };
    CalendarBase.prototype.createContentHeader = function() {
        if (this.getModuleName() === "calendar") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll(".e-content .e-week-header")[0])) (0, $4ZDHT.detach)(this.element.querySelectorAll(".e-content .e-week-header")[0]);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.calendarElement.querySelectorAll(".e-content .e-week-header")[0])) (0, $4ZDHT.detach)(this.calendarElement.querySelectorAll(".e-content .e-week-header")[0]);
        var daysCount = 6;
        var html = "";
        if (this.firstDayOfWeek > 6 || this.firstDayOfWeek < 0) this.setProperties({
            firstDayOfWeek: 0
        }, true);
        this.tableHeadElement = this.createElement("thead", {
            className: $1d370936294fcc88$var$WEEKHEADER
        });
        if (this.weekNumber) {
            html += '<th class="e-week-number" aria-hidden="true"></th>';
            if (this.getModuleName() === "calendar") (0, $4ZDHT.addClass)([
                this.element
            ], "" + $1d370936294fcc88$var$WEEKNUMBER);
            else (0, $4ZDHT.addClass)([
                this.calendarElement
            ], "" + $1d370936294fcc88$var$WEEKNUMBER);
        }
        var shortNames = this.getCultureValues().length > 0 && this.getCultureValues() ? this.shiftArray(this.getCultureValues().length > 0 && this.getCultureValues(), this.firstDayOfWeek) : null;
        if (!(0, $3EnZW.isNullOrUndefined)(shortNames)) for(var days = 0; days <= daysCount; days++)html += '<th  class="">' + this.toCapitalize(shortNames[days]) + "</th>";
        html = "<tr>" + html + "</tr>";
        this.tableHeadElement.innerHTML = html;
        this.table.appendChild(this.tableHeadElement);
    };
    CalendarBase.prototype.createContentBody = function() {
        if (this.getModuleName() === "calendar") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll(".e-content tbody")[0])) (0, $4ZDHT.detach)(this.element.querySelectorAll(".e-content tbody")[0]);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.calendarElement.querySelectorAll(".e-content tbody")[0])) (0, $4ZDHT.detach)(this.calendarElement.querySelectorAll(".e-content tbody")[0]);
        switch(this.start){
            case "Year":
                this.renderYears();
                break;
            case "Decade":
                this.renderDecades();
                break;
            default:
                this.renderMonths();
        }
    };
    CalendarBase.prototype.updateFooter = function() {
        this.todayElement.textContent = this.l10.getConstant("today");
        this.todayElement.setAttribute("aria-label", this.l10.getConstant("today"));
        this.todayElement.setAttribute("tabindex", "0");
    };
    CalendarBase.prototype.createContentFooter = function() {
        if (this.showTodayButton) {
            var minimum = new Date(+this.min);
            var maximum = new Date(+this.max);
            var l10nLocale = {
                today: "Today"
            };
            this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
            this.l10 = new (0, $e7i2H.L10n)(this.getModuleName(), l10nLocale, this.locale);
            this.todayElement = this.createElement("button", {
                attrs: {
                    role: "button"
                }
            });
            (0, $kj1BR.rippleEffect)(this.todayElement);
            this.updateFooter();
            (0, $4ZDHT.addClass)([
                this.todayElement
            ], [
                $1d370936294fcc88$var$BTN,
                $1d370936294fcc88$var$TODAY,
                $1d370936294fcc88$var$FLAT,
                $1d370936294fcc88$var$PRIMARY,
                $1d370936294fcc88$var$CSS
            ]);
            if (!(+new Date(minimum.setHours(0, 0, 0, 0)) <= +this.todayDate && +this.todayDate <= +new Date(maximum.setHours(0, 0, 0, 0))) || this.todayDisabled) (0, $4ZDHT.addClass)([
                this.todayElement
            ], $1d370936294fcc88$var$DISABLED);
            this.footer = this.createElement("div", {
                className: $1d370936294fcc88$var$FOOTER
            });
            this.footer.appendChild(this.todayElement);
            if (this.getModuleName() === "calendar") this.element.appendChild(this.footer);
            if (this.getModuleName() === "datepicker") this.calendarElement.appendChild(this.footer);
            if (this.getModuleName() === "datetimepicker") this.calendarElement.appendChild(this.footer);
            if (!this.todayElement.classList.contains($1d370936294fcc88$var$DISABLED)) (0, $aqzbR.EventHandler).add(this.todayElement, "click", this.todayButtonClick, this);
        }
    };
    CalendarBase.prototype.wireEvents = function(id, ref, keyConfig, moduleName) {
        (0, $aqzbR.EventHandler).add(this.headerTitleElement, "click", this.navigateTitle, this);
        this.defaultKeyConfigs = (0, $3EnZW.extend)(this.defaultKeyConfigs, this.keyConfigs);
        if (this.getModuleName() === "calendar") this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            eventName: "keydown",
            keyAction: this.keyActionHandle.bind(this),
            keyConfigs: this.defaultKeyConfigs
        });
        else this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.calendarElement, {
            eventName: "keydown",
            keyAction: this.keyActionHandle.bind(this),
            keyConfigs: this.defaultKeyConfigs
        });
    };
    CalendarBase.prototype.dateWireEvents = function(id, ref, keyConfig, moduleName) {
        this.defaultKeyConfigs = this.getDefaultKeyConfig();
        this.defaultKeyConfigs = (0, $3EnZW.extend)(this.defaultKeyConfigs, keyConfig);
        this.serverModuleName = moduleName;
    };
    CalendarBase.prototype.todayButtonClick = function(e, value, isCustomDate) {
        if (this.showTodayButton) {
            if (this.currentView() === this.depth) this.effect = "";
            else this.effect = "e-zoomin";
            if (this.getViewNumber(this.start) >= this.getViewNumber(this.depth)) this.navigateTo(this.depth, new Date(this.checkValue(value)), isCustomDate);
            else this.navigateTo("Month", new Date(this.checkValue(value)), isCustomDate);
        }
    };
    CalendarBase.prototype.resetCalendar = function() {
        this.calendarElement && (0, $4ZDHT.detach)(this.calendarElement);
        this.tableBodyElement && (0, $4ZDHT.detach)(this.tableBodyElement);
        this.table && (0, $4ZDHT.detach)(this.table);
        this.tableHeadElement && (0, $4ZDHT.detach)(this.tableHeadElement);
        this.nextIcon && (0, $4ZDHT.detach)(this.nextIcon);
        this.previousIcon && (0, $4ZDHT.detach)(this.previousIcon);
        this.footer && (0, $4ZDHT.detach)(this.footer);
        this.todayElement = null;
        this.renderDayCellArgs = null;
        this.calendarElement = this.tableBodyElement = this.footer = this.tableHeadElement = this.nextIcon = this.previousIcon = this.table = null;
    };
    CalendarBase.prototype.keyActionHandle = function(e, value, multiSelection) {
        if (this.calendarElement === null && e.action === "escape") return;
        var focusedDate = this.tableBodyElement.querySelector("tr td.e-focused-date");
        var selectedDate;
        if (multiSelection) {
            if (!(0, $3EnZW.isNullOrUndefined)(focusedDate) && +value === parseInt(focusedDate.getAttribute("id").split("_")[0], 10)) selectedDate = focusedDate;
            else selectedDate = this.tableBodyElement.querySelector("tr td.e-selected");
        } else selectedDate = this.tableBodyElement.querySelector("tr td.e-selected");
        var view = this.getViewNumber(this.currentView());
        var depthValue = this.getViewNumber(this.depth);
        var levelRestrict = view === depthValue && this.getViewNumber(this.start) >= depthValue;
        this.effect = "";
        switch(e.action){
            case "moveLeft":
                if (this.getModuleName() !== "daterangepicker" && !(0, $3EnZW.isNullOrUndefined)(e.target)) {
                    this.keyboardNavigate(-1, view, e, this.max, this.min);
                    e.preventDefault();
                }
                break;
            case "moveRight":
                if (this.getModuleName() !== "daterangepicker" && !(0, $3EnZW.isNullOrUndefined)(e.target)) {
                    this.keyboardNavigate(1, view, e, this.max, this.min);
                    e.preventDefault();
                }
                break;
            case "moveUp":
                if (this.getModuleName() !== "daterangepicker" && !(0, $3EnZW.isNullOrUndefined)(e.target)) {
                    if (view === 0) this.keyboardNavigate(-7, view, e, this.max, this.min); // move the current date to the previous seven days.
                    else this.keyboardNavigate(-4, view, e, this.max, this.min); // move the current year to the previous four days.
                    e.preventDefault();
                }
                break;
            case "moveDown":
                if (this.getModuleName() !== "daterangepicker" && !(0, $3EnZW.isNullOrUndefined)(e.target)) {
                    if (view === 0) this.keyboardNavigate(7, view, e, this.max, this.min);
                    else this.keyboardNavigate(4, view, e, this.max, this.min);
                    e.preventDefault();
                }
                break;
            case "select":
                if (e.target === this.headerTitleElement) this.navigateTitle(e);
                else if (e.target === this.previousIcon && !e.target.className.includes($1d370936294fcc88$var$DISABLED)) this.navigatePrevious(e);
                else if (e.target === this.nextIcon && !e.target.className.includes($1d370936294fcc88$var$DISABLED)) this.navigateNext(e);
                else if (e.target === this.todayElement && !e.target.className.includes($1d370936294fcc88$var$DISABLED)) {
                    this.todayButtonClick(e, value);
                    if (this.getModuleName() === "datepicker" || this.getModuleName() === "datetimepicker") {
                        if (this.isAngular) this.inputElement.focus();
                        else this.element.focus();
                    }
                } else {
                    var element = !(0, $3EnZW.isNullOrUndefined)(focusedDate) ? focusedDate : selectedDate;
                    if (!(0, $3EnZW.isNullOrUndefined)(element) && !element.classList.contains($1d370936294fcc88$var$DISABLED)) {
                        if (levelRestrict) {
                            // eslint-disable-next-line radix
                            var d = new Date(parseInt("" + element.id, 0));
                            this.selectDate(e, d, element);
                            if (this.getModuleName() === "datepicker" || this.getModuleName() === "datetimepicker") {
                                if (this.isAngular) this.inputElement.focus();
                                else this.element.focus();
                            }
                        } else if (!e.target.className.includes($1d370936294fcc88$var$DISABLED)) this.contentClick(null, --view, element, value);
                    }
                }
                break;
            case "controlUp":
                this.title();
                e.preventDefault();
                break;
            case "controlDown":
                if (!(0, $3EnZW.isNullOrUndefined)(focusedDate) && !levelRestrict || !(0, $3EnZW.isNullOrUndefined)(selectedDate) && !levelRestrict) this.contentClick(null, --view, focusedDate || selectedDate, value);
                e.preventDefault();
                break;
            case "home":
                this.currentDate = this.firstDay(this.currentDate);
                (0, $4ZDHT.detach)(this.tableBodyElement);
                if (view === 0) this.renderMonths(e);
                else if (view === 1) this.renderYears(e);
                else this.renderDecades(e);
                e.preventDefault();
                break;
            case "end":
                this.currentDate = this.lastDay(this.currentDate, view);
                (0, $4ZDHT.detach)(this.tableBodyElement);
                if (view === 0) this.renderMonths(e);
                else if (view === 1) this.renderYears(e);
                else this.renderDecades(e);
                e.preventDefault();
                break;
            case "pageUp":
                this.addMonths(this.currentDate, -1);
                this.navigateTo("Month", this.currentDate);
                e.preventDefault();
                break;
            case "pageDown":
                this.addMonths(this.currentDate, 1);
                this.navigateTo("Month", this.currentDate);
                e.preventDefault();
                break;
            case "shiftPageUp":
                this.addYears(this.currentDate, -1);
                this.navigateTo("Month", this.currentDate);
                e.preventDefault();
                break;
            case "shiftPageDown":
                this.addYears(this.currentDate, 1);
                this.navigateTo("Month", this.currentDate);
                e.preventDefault();
                break;
            case "controlHome":
                this.navigateTo("Month", new Date(this.currentDate.getFullYear(), 0, 1));
                e.preventDefault();
                break;
            case "controlEnd":
                this.navigateTo("Month", new Date(this.currentDate.getFullYear(), 11, 31));
                e.preventDefault();
                break;
            case "tab":
                if ((this.getModuleName() === "datepicker" || this.getModuleName() === "datetimepicker") && e.target === this.todayElement) {
                    e.preventDefault();
                    if (this.isAngular) this.inputElement.focus();
                    else this.element.focus();
                    this.hide();
                }
                break;
            case "shiftTab":
                if ((this.getModuleName() === "datepicker" || this.getModuleName() === "datetimepicker") && e.target === this.headerTitleElement) {
                    e.preventDefault();
                    if (this.isAngular) this.inputElement.focus();
                    else this.element.focus();
                    this.hide();
                }
                break;
            case "escape":
                if ((this.getModuleName() === "datepicker" || this.getModuleName() === "datetimepicker") && (e.target === this.headerTitleElement || e.target === this.previousIcon || e.target === this.nextIcon || e.target === this.todayElement)) this.hide();
                break;
        }
    };
    CalendarBase.prototype.keyboardNavigate = function(number, currentView, e, max, min) {
        var date = new Date(this.checkValue(this.currentDate));
        switch(currentView){
            case 2:
                this.addYears(this.currentDate, number);
                if (this.isMonthYearRange(this.currentDate)) {
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.renderDecades(e);
                } else this.currentDate = date;
                break;
            case 1:
                this.addMonths(this.currentDate, number);
                if (this.calendarMode === "Gregorian") {
                    if (this.isMonthYearRange(this.currentDate)) {
                        (0, $4ZDHT.detach)(this.tableBodyElement);
                        this.renderYears(e);
                    } else this.currentDate = date;
                } else if (this.isMonthYearRange(this.currentDate)) {
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.renderYears(e);
                } else this.currentDate = date;
                break;
            case 0:
                this.addDay(this.currentDate, number, e, max, min);
                if (this.isMinMaxRange(this.currentDate)) {
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.renderMonths(e);
                } else this.currentDate = date;
                break;
        }
    };
    /**
     * Initialize the event handler
     *
     * @param {Date} value - Specifies value of date.
     * @returns {void}
     * @private
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CalendarBase.prototype.preRender = function(value) {
        var _this = this;
        this.navigatePreviousHandler = this.navigatePrevious.bind(this);
        this.navigateNextHandler = this.navigateNext.bind(this);
        this.defaultKeyConfigs = this.getDefaultKeyConfig();
        this.navigateHandler = function(e) {
            _this.triggerNavigate(e);
        };
    };
    CalendarBase.prototype.minMaxDate = function(localDate) {
        var currentDate = new Date(new Date(+localDate).setHours(0, 0, 0, 0));
        var minDate = new Date(new Date(+this.min).setHours(0, 0, 0, 0));
        var maxDate = new Date(new Date(+this.max).setHours(0, 0, 0, 0));
        if (+currentDate === +minDate || +currentDate === +maxDate) {
            if (+localDate < +this.min) localDate = new Date(+this.min);
            if (+localDate > +this.max) localDate = new Date(+this.max);
        }
        return localDate;
    };
    CalendarBase.prototype.renderMonths = function(e, value, isCustomDate) {
        var numCells = this.weekNumber ? 8 : 7;
        var tdEles;
        if (this.calendarMode === "Gregorian") tdEles = this.renderDays(this.currentDate, value, null, null, isCustomDate, e);
        else tdEles = !(0, $3EnZW.isNullOrUndefined)(this.islamicModule) ? this.islamicModule.islamicRenderDays(this.currentDate, value) : null;
        this.createContentHeader();
        if (this.calendarMode === "Gregorian") this.renderTemplate(tdEles, numCells, $1d370936294fcc88$var$MONTH, e, value);
        else if (!(0, $3EnZW.isNullOrUndefined)(this.islamicModule)) this.islamicModule.islamicRenderTemplate(tdEles, numCells, $1d370936294fcc88$var$MONTH, e, value);
    };
    CalendarBase.prototype.renderDays = function(currentDate, value, multiSelection, values, isTodayDate, e) {
        var tdEles = [];
        var cellsCount = 42;
        var todayDate = isTodayDate ? new Date(+currentDate) : this.getDate(new Date(), this.timezone);
        var localDate = new Date(this.checkValue(currentDate));
        var minMaxDate;
        var currentMonth = localDate.getMonth();
        this.titleUpdate(currentDate, "days");
        var d = localDate;
        localDate = new Date(d.getFullYear(), d.getMonth(), 0, d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
        while(localDate.getDay() !== this.firstDayOfWeek)this.setStartDate(localDate, -1 * $1d370936294fcc88$var$dayMilliSeconds);
        for(var day = 0; day < cellsCount; ++day){
            var weekEle = this.createElement("td", {
                className: $1d370936294fcc88$var$CELL
            });
            var weekAnchor = this.createElement("span");
            if (day % 7 === 0 && this.weekNumber) {
                // 6 days are added to get Last day of the week and 3 days are added to get middle day of the week.
                var numberOfDays = this.weekRule === "FirstDay" ? 6 : this.weekRule === "FirstFourDayWeek" ? 3 : 0;
                var finalDate = new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate() + numberOfDays);
                weekAnchor.textContent = "" + this.getWeek(finalDate);
                weekEle.appendChild(weekAnchor);
                (0, $4ZDHT.addClass)([
                    weekEle
                ], "" + $1d370936294fcc88$var$WEEKNUMBER);
                tdEles.push(weekEle);
            }
            minMaxDate = new Date(+localDate);
            localDate = this.minMaxDate(localDate);
            var dateFormatOptions = {
                type: "dateTime",
                skeleton: "full"
            };
            var date = this.globalize.parseDate(this.globalize.formatDate(localDate, dateFormatOptions), dateFormatOptions);
            var tdEle = this.dayCell(localDate);
            var title = this.globalize.formatDate(localDate, {
                type: "date",
                skeleton: "full"
            });
            var dayLink = this.createElement("span");
            dayLink.textContent = this.globalize.formatDate(localDate, {
                format: "d",
                type: "date",
                skeleton: "yMd"
            });
            var disabled = this.min > localDate || this.max < localDate;
            if (disabled) {
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$DISABLED);
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$OVERLAY);
            } else dayLink.setAttribute("title", "" + title);
            if (currentMonth !== localDate.getMonth()) {
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$OTHERMONTH);
                dayLink.setAttribute("aria-disabled", "true");
            }
            if (localDate.getDay() === 0 || localDate.getDay() === 6) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$WEEKEND);
            tdEle.appendChild(dayLink);
            this.renderDayCellArgs = {
                date: localDate,
                isDisabled: false,
                element: tdEle,
                isOutOfRange: disabled
            };
            var argument = this.renderDayCellArgs;
            this.renderDayCellEvent(argument);
            if (argument.isDisabled) {
                var selectDate = new Date(this.checkValue(value));
                var argsDate = new Date(this.checkValue(argument.date));
                if (multiSelection) {
                    if (!(0, $3EnZW.isNullOrUndefined)(values) && values.length > 0) for(var index = 0; index < values.length; index++){
                        var localDateString = +new Date(this.globalize.formatDate(argument.date, {
                            type: "date",
                            skeleton: "yMd"
                        }));
                        var tempDateString = +new Date(this.globalize.formatDate(values[index], {
                            type: "date",
                            skeleton: "yMd"
                        }));
                        if (localDateString === tempDateString) {
                            values.splice(index, 1);
                            index = -1;
                        }
                    }
                } else if (selectDate && +selectDate === +argsDate) this.setProperties({
                    value: null
                }, true);
            }
            if (this.renderDayCellArgs.isDisabled && !tdEle.classList.contains($1d370936294fcc88$var$SELECTED)) {
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$DISABLED);
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$OVERLAY);
                dayLink.setAttribute("aria-disabled", "true");
                if (+this.renderDayCellArgs.date === +this.todayDate) this.todayDisabled = true;
            }
            var otherMnthBool = tdEle.classList.contains($1d370936294fcc88$var$OTHERMONTH);
            var disabledCls = tdEle.classList.contains($1d370936294fcc88$var$DISABLED);
            if (!disabledCls) (0, $aqzbR.EventHandler).add(tdEle, "click", this.clickHandler, this);
            // to set the value as null while setting the disabled date onProperty change.
            // if (args.isDisabled && +this.value === +args.date) {
            //     this.setProperties({ value: null }, true);
            // }
            var currentTarget = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(e) && e.type === "click") currentTarget = e.currentTarget;
            if (multiSelection && !(0, $3EnZW.isNullOrUndefined)(values) && !disabledCls) {
                for(var tempValue = 0; tempValue < values.length; tempValue++){
                    var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
                    var formatOptions = {
                        format: null,
                        type: "date",
                        skeleton: "short",
                        calendar: type
                    };
                    var localDateString = this.globalize.formatDate(localDate, formatOptions);
                    var tempDateString = this.globalize.formatDate(values[tempValue], formatOptions);
                    if (localDateString === tempDateString && this.getDateVal(localDate, values[tempValue]) || this.getDateVal(localDate, value)) (0, $4ZDHT.addClass)([
                        tdEle
                    ], $1d370936294fcc88$var$SELECTED);
                    if (!(0, $3EnZW.isNullOrUndefined)(currentTarget) && currentTarget.innerText === tdEle.innerText && this.previousDates && tdEle.classList.contains($1d370936294fcc88$var$SELECTED) && currentTarget.classList.contains($1d370936294fcc88$var$SELECTED)) {
                        (0, $4ZDHT.removeClass)([
                            tdEle
                        ], $1d370936294fcc88$var$SELECTED);
                        this.previousDates = false;
                        var copyValues = this.copyValues(values);
                        for(var i = 0; i < copyValues.length; i++){
                            var type_1 = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
                            var formatOptions_1 = {
                                format: null,
                                type: "date",
                                skeleton: "short",
                                calendar: type_1
                            };
                            var localDateString_1 = this.globalize.formatDate(date, formatOptions_1);
                            var tempDateString_1 = this.globalize.formatDate(copyValues[i], formatOptions_1);
                            if (localDateString_1 === tempDateString_1) {
                                var index = copyValues.indexOf(copyValues[i]);
                                copyValues.splice(index, 1);
                                values.splice(index, 1);
                            }
                        }
                        this.setProperties({
                            values: copyValues
                        }, true);
                    } else this.updateFocus(otherMnthBool, disabledCls, localDate, tdEle, currentDate);
                }
                if (values.length <= 0) this.updateFocus(otherMnthBool, disabledCls, localDate, tdEle, currentDate);
            } else if (!disabledCls && this.getDateVal(localDate, value)) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$SELECTED);
            this.updateFocus(otherMnthBool, disabledCls, localDate, tdEle, currentDate);
            if (!(0, $3EnZW.isNullOrUndefined)(date) && date.getFullYear() === todayDate.getFullYear() && date.getMonth() === todayDate.getMonth() && date.getDate() === todayDate.getDate()) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$TODAY);
            tdEles.push(this.renderDayCellArgs.element);
            localDate = new Date(+minMaxDate);
            this.addDay(localDate, 1, null, this.max, this.min);
        }
        return tdEles;
    };
    CalendarBase.prototype.updateFocus = function(otherMonth, disabled, localDate, tableElement, currentDate) {
        if (currentDate.getDate() === localDate.getDate() && !otherMonth && !disabled) (0, $4ZDHT.addClass)([
            tableElement
        ], $1d370936294fcc88$var$FOCUSEDDATE);
        else {
            // eslint-disable-next-line radix
            if (currentDate >= this.max && parseInt(tableElement.id, 0) === +this.max && !otherMonth && !disabled) (0, $4ZDHT.addClass)([
                tableElement
            ], $1d370936294fcc88$var$FOCUSEDDATE);
            // eslint-disable-next-line radix
            if (currentDate <= this.min && parseInt(tableElement.id, 0) === +this.min && !otherMonth && !disabled) (0, $4ZDHT.addClass)([
                tableElement
            ], $1d370936294fcc88$var$FOCUSEDDATE);
        }
    };
    CalendarBase.prototype.renderYears = function(e, value) {
        this.removeTableHeadElement();
        var numCells = 4;
        var tdEles = [];
        var valueUtil = (0, $3EnZW.isNullOrUndefined)(value);
        var curDate = new Date(this.checkValue(this.currentDate));
        var mon = curDate.getMonth();
        var yr = curDate.getFullYear();
        var localDate = curDate;
        var curYrs = localDate.getFullYear();
        var minYr = new Date(this.checkValue(this.min)).getFullYear();
        var minMonth = new Date(this.checkValue(this.min)).getMonth();
        var maxYr = new Date(this.checkValue(this.max)).getFullYear();
        var maxMonth = new Date(this.checkValue(this.max)).getMonth();
        localDate.setMonth(0);
        this.titleUpdate(this.currentDate, "months");
        localDate.setDate(1);
        for(var month = 0; month < 12; ++month){
            var tdEle = this.dayCell(localDate);
            var dayLink = this.createElement("span");
            var localMonth = value && value.getMonth() === localDate.getMonth();
            var select = value && value.getFullYear() === yr && localMonth;
            var title = this.globalize.formatDate(localDate, {
                type: "date",
                format: "MMM y"
            });
            dayLink.textContent = this.toCapitalize(this.globalize.formatDate(localDate, {
                format: null,
                type: "dateTime",
                skeleton: "MMM"
            }));
            if (this.min && (curYrs < minYr || month < minMonth && curYrs === minYr) || this.max && (curYrs > maxYr || month > maxMonth && curYrs >= maxYr)) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$DISABLED);
            else if (!valueUtil && select) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$SELECTED);
            else if (localDate.getMonth() === mon && this.currentDate.getMonth() === mon) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$FOCUSEDDATE);
            localDate.setDate(1);
            localDate.setMonth(localDate.getMonth() + 1);
            if (!tdEle.classList.contains($1d370936294fcc88$var$DISABLED)) {
                (0, $aqzbR.EventHandler).add(tdEle, "click", this.clickHandler, this);
                dayLink.setAttribute("title", "" + title);
            }
            tdEle.appendChild(dayLink);
            tdEles.push(tdEle);
        }
        this.renderTemplate(tdEles, numCells, $1d370936294fcc88$var$YEAR, e, value);
    };
    CalendarBase.prototype.renderDecades = function(e, value) {
        this.removeTableHeadElement();
        var numCells = 4;
        var yearCell = 12;
        var tdEles = [];
        var localDate = new Date(this.checkValue(this.currentDate));
        localDate.setMonth(0);
        localDate.setDate(1);
        var localYr = localDate.getFullYear();
        var startYr = new Date(localDate.setFullYear(localYr - localYr % 10));
        var endYr = new Date(localDate.setFullYear(localYr - localYr % 10 + 9));
        var startFullYr = startYr.getFullYear();
        var endFullYr = endYr.getFullYear();
        var startHdrYr = this.globalize.formatDate(startYr, {
            format: null,
            type: "dateTime",
            skeleton: "y"
        });
        var endHdrYr = this.globalize.formatDate(endYr, {
            format: null,
            type: "dateTime",
            skeleton: "y"
        });
        this.headerTitleElement.textContent = startHdrYr + " - " + endHdrYr;
        var start = new Date(localYr - localYr % 10 - 1, 0, 1);
        var startYear = start.getFullYear();
        for(var rowIterator = 0; rowIterator < yearCell; ++rowIterator){
            var year = startYear + rowIterator;
            localDate.setFullYear(year);
            var tdEle = this.dayCell(localDate);
            var dayLink = this.createElement("span");
            dayLink.textContent = this.globalize.formatDate(localDate, {
                format: null,
                type: "dateTime",
                skeleton: "y"
            });
            if (year < startFullYr || year > endFullYr) {
                (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$OTHERDECADE);
                dayLink.setAttribute("aria-disabled", "true");
                if (!(0, $3EnZW.isNullOrUndefined)(value) && localDate.getFullYear() === value.getFullYear()) (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$SELECTED);
                if (year < new Date(this.checkValue(this.min)).getFullYear() || year > new Date(this.checkValue(this.max)).getFullYear()) (0, $4ZDHT.addClass)([
                    tdEle
                ], $1d370936294fcc88$var$DISABLED);
            } else if (year < new Date(this.checkValue(this.min)).getFullYear() || year > new Date(this.checkValue(this.max)).getFullYear()) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$DISABLED);
            else if (!(0, $3EnZW.isNullOrUndefined)(value) && localDate.getFullYear() === value.getFullYear()) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$SELECTED);
            else if (localDate.getFullYear() === this.currentDate.getFullYear() && !tdEle.classList.contains($1d370936294fcc88$var$DISABLED)) (0, $4ZDHT.addClass)([
                tdEle
            ], $1d370936294fcc88$var$FOCUSEDDATE);
            if (!tdEle.classList.contains($1d370936294fcc88$var$DISABLED)) {
                (0, $aqzbR.EventHandler).add(tdEle, "click", this.clickHandler, this);
                dayLink.setAttribute("title", "" + dayLink.textContent);
            }
            tdEle.appendChild(dayLink);
            tdEles.push(tdEle);
        }
        this.renderTemplate(tdEles, numCells, "e-decade", e, value);
    };
    CalendarBase.prototype.dayCell = function(localDate) {
        var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
        var dateFormatOptions = {
            skeleton: "full",
            type: "dateTime",
            calendar: type
        };
        var date = this.globalize.parseDate(this.globalize.formatDate(localDate, dateFormatOptions), dateFormatOptions);
        var value;
        if (!(0, $3EnZW.isNullOrUndefined)(date)) value = date.valueOf();
        var attrs = {
            className: $1d370936294fcc88$var$CELL,
            attrs: {
                "id": "" + (0, $3EnZW.getUniqueID)("" + value),
                "aria-selected": "false"
            }
        };
        return this.createElement("td", attrs);
    };
    CalendarBase.prototype.firstDay = function(date) {
        var collection = this.currentView() !== "Decade" ? this.tableBodyElement.querySelectorAll("td:not(." + $1d370936294fcc88$var$OTHERMONTH + "):not(." + $1d370936294fcc88$var$WEEKNUMBER + ")") : this.tableBodyElement.querySelectorAll("td:not(." + $1d370936294fcc88$var$OTHERDECADE + "");
        if (collection.length) {
            for(var i = 0; i < collection.length; i++)if (!collection[i].classList.contains($1d370936294fcc88$var$DISABLED)) {
                // eslint-disable-next-line radix
                date = new Date(parseInt(collection[i].id, 0));
                break;
            }
        }
        return date;
    };
    CalendarBase.prototype.lastDay = function(date, view) {
        var lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        if (view !== 2) {
            var timeOffset = Math.abs(lastDate.getTimezoneOffset() - this.firstDay(date).getTimezoneOffset());
            if (timeOffset) lastDate.setHours(this.firstDay(date).getHours() + timeOffset / 60);
            return this.findLastDay(lastDate);
        } else return this.findLastDay(this.firstDay(lastDate));
    };
    CalendarBase.prototype.checkDateValue = function(value) {
        return !(0, $3EnZW.isNullOrUndefined)(value) && value instanceof Date && !isNaN(+value) ? value : null;
    };
    CalendarBase.prototype.findLastDay = function(date) {
        var collection = this.currentView() === "Decade" ? this.tableBodyElement.querySelectorAll("td:not(." + $1d370936294fcc88$var$OTHERDECADE + "") : this.tableBodyElement.querySelectorAll("td:not(." + $1d370936294fcc88$var$OTHERMONTH + "):not(." + $1d370936294fcc88$var$WEEKNUMBER + ")");
        if (collection.length) {
            for(var i = collection.length - 1; i >= 0; i--)if (!collection[i].classList.contains($1d370936294fcc88$var$DISABLED)) {
                // eslint-disable-next-line radix
                date = new Date(parseInt(collection[i].id, 0));
                break;
            }
        }
        return date;
    };
    CalendarBase.prototype.removeTableHeadElement = function() {
        if (this.getModuleName() === "calendar") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll(".e-content table thead")[0])) (0, $4ZDHT.detach)(this.tableHeadElement);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.calendarElement.querySelectorAll(".e-content table thead")[0])) (0, $4ZDHT.detach)(this.tableHeadElement);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CalendarBase.prototype.renderTemplate = function(elements, count, classNm, e, value) {
        var view = this.getViewNumber(this.currentView());
        var trEle;
        this.tableBodyElement = this.createElement("tbody");
        this.table.appendChild(this.tableBodyElement);
        (0, $4ZDHT.removeClass)([
            this.contentElement,
            this.headerElement
        ], [
            $1d370936294fcc88$var$MONTH,
            $1d370936294fcc88$var$DECADE,
            $1d370936294fcc88$var$YEAR
        ]);
        (0, $4ZDHT.addClass)([
            this.contentElement,
            this.headerElement
        ], [
            classNm
        ]);
        var weekNumCell = 41;
        var numberCell = 35;
        var otherMonthCell = 6;
        var row = count;
        var rowIterator = 0;
        for(var dayCell = 0; dayCell < elements.length / count; ++dayCell){
            trEle = this.createElement("tr");
            for(rowIterator = 0 + rowIterator; rowIterator < row; rowIterator++){
                if (!elements[rowIterator].classList.contains("e-week-number") && !(0, $3EnZW.isNullOrUndefined)(elements[rowIterator].children[0])) {
                    (0, $4ZDHT.addClass)([
                        elements[rowIterator].children[0]
                    ], [
                        $1d370936294fcc88$var$LINK
                    ]);
                    (0, $kj1BR.rippleEffect)(elements[rowIterator].children[0], {
                        duration: 600,
                        isCenterRipple: true
                    });
                }
                trEle.appendChild(elements[rowIterator]);
                if (this.weekNumber && rowIterator === otherMonthCell + 1 && elements[otherMonthCell + 1].classList.contains($1d370936294fcc88$var$OTHERMONTH)) (0, $4ZDHT.addClass)([
                    trEle
                ], $1d370936294fcc88$var$OTHERMONTHROW);
                if (!this.weekNumber && rowIterator === otherMonthCell && elements[otherMonthCell].classList.contains($1d370936294fcc88$var$OTHERMONTH)) (0, $4ZDHT.addClass)([
                    trEle
                ], $1d370936294fcc88$var$OTHERMONTHROW);
                if (this.weekNumber) {
                    if (rowIterator === weekNumCell && elements[weekNumCell].classList.contains($1d370936294fcc88$var$OTHERMONTH)) (0, $4ZDHT.addClass)([
                        trEle
                    ], $1d370936294fcc88$var$OTHERMONTHROW);
                } else if (rowIterator === numberCell && elements[numberCell].classList.contains($1d370936294fcc88$var$OTHERMONTH)) (0, $4ZDHT.addClass)([
                    trEle
                ], $1d370936294fcc88$var$OTHERMONTHROW);
            }
            row = row + count;
            rowIterator = rowIterator + 0;
            this.tableBodyElement.appendChild(trEle);
        }
        this.table.querySelector("tbody").className = this.effect;
        if (this.calendarMode === "Gregorian") this.iconHandler();
        else this.islamicModule.islamicIconHandler();
        if (view !== this.getViewNumber(this.currentView()) || view === 0 && view !== this.getViewNumber(this.currentView())) this.navigateHandler(e);
        this.setAriaActiveDescendant();
    };
    CalendarBase.prototype.clickHandler = function(e, value) {
        this.clickEventEmitter(e);
        var eve = e.currentTarget;
        var view = this.getViewNumber(this.currentView());
        if (eve.classList.contains($1d370936294fcc88$var$OTHERMONTH)) this.contentClick(e, 0, null, value);
        else if (view === this.getViewNumber(this.depth) && this.getViewNumber(this.start) >= this.getViewNumber(this.depth)) this.contentClick(e, 1, null, value);
        else if (2 === view) this.contentClick(e, 1, null, value);
        else if (!eve.classList.contains($1d370936294fcc88$var$OTHERMONTH) && view === 0) this.selectDate(e, this.getIdValue(e, null), null);
        else this.contentClick(e, 0, eve, value);
        if (this.getModuleName() === "calendar") this.table.focus();
    };
    // Content click event handler required for extended components
    CalendarBase.prototype.clickEventEmitter = function(e) {
        e.preventDefault();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CalendarBase.prototype.contentClick = function(e, view, element, value) {
        var currentView = this.getViewNumber(this.currentView());
        var d = this.getIdValue(e, element);
        switch(view){
            case 0:
                if (currentView === this.getViewNumber(this.depth) && this.getViewNumber(this.start) >= this.getViewNumber(this.depth)) {
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.currentDate = d;
                    this.effect = $1d370936294fcc88$var$ZOOMIN;
                    this.renderMonths(e);
                } else {
                    if (this.calendarMode === "Gregorian") {
                        this.currentDate.setMonth(d.getMonth());
                        if (d.getMonth() > 0 && this.currentDate.getMonth() !== d.getMonth()) this.currentDate.setDate(0);
                        this.currentDate.setFullYear(d.getFullYear());
                    } else this.currentDate = d;
                    this.effect = $1d370936294fcc88$var$ZOOMIN;
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.renderMonths(e);
                }
                break;
            case 1:
                if (currentView === this.getViewNumber(this.depth) && this.getViewNumber(this.start) >= this.getViewNumber(this.depth)) this.selectDate(e, d, null);
                else {
                    if (this.calendarMode === "Gregorian") this.currentDate.setFullYear(d.getFullYear());
                    else {
                        this.islamicPreviousHeader = this.headerElement.textContent;
                        var islamicDate = this.islamicModule.getIslamicDate(d);
                        this.currentDate = this.islamicModule.toGregorian(islamicDate.year, islamicDate.month, 1);
                    }
                    this.effect = $1d370936294fcc88$var$ZOOMIN;
                    (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.renderYears(e);
                }
        }
    };
    CalendarBase.prototype.switchView = function(view, e, multiSelection, isCustomDate) {
        switch(view){
            case 0:
                (0, $4ZDHT.detach)(this.tableBodyElement);
                this.renderMonths(e, null, isCustomDate);
                break;
            case 1:
                (0, $4ZDHT.detach)(this.tableBodyElement);
                this.renderYears(e);
                break;
            case 2:
                (0, $4ZDHT.detach)(this.tableBodyElement);
                this.renderDecades(e);
        }
    };
    /**
     * To get component name
     *
     * @returns {string} Returns the component name.
     * @private
     */ CalendarBase.prototype.getModuleName = function() {
        return "calendar";
    };
    /**
     *
     * @returns {void}

     */ CalendarBase.prototype.requiredModules = function() {
        var modules = [];
        if (this.calendarMode === "Islamic") modules.push({
            args: [
                this
            ],
            member: "islamic",
            name: "Islamic"
        });
        return modules;
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the properties to be maintained upon browser refresh.
     *
     * @returns {string}
     */ CalendarBase.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Called internally if any of the property value changed.
     *
     * @param {CalendarBaseModel} newProp - Returns the dynamic property value of the component.
     * @param {CalendarBaseModel} oldProp - Returns the previous property value of the component.
     * @param {boolean} multiSelection - - Specifies whether multiple date selection is enabled or not.
     * @param {Date[]} values - Specifies the dates.
     * @returns {void}
     * @private
     */ CalendarBase.prototype.onPropertyChanged = function(newProp, oldProp, multiSelection, values) {
        this.effect = "";
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "enableRtl":
                    if (newProp.enableRtl) {
                        if (this.getModuleName() === "calendar") this.element.classList.add("e-rtl");
                        else this.calendarElement.classList.add("e-rtl");
                    } else if (this.getModuleName() === "calendar") this.element.classList.remove("e-rtl");
                    else this.calendarElement.classList.remove("e-rtl");
                    break;
                case "dayHeaderFormat":
                    this.getCultureValues();
                    if (this.getModuleName() !== "datepicker") this.createContentHeader();
                    else if (this.calendarElement) this.createContentHeader();
                    this.adjustLongHeaderSize();
                    break;
                case "min":
                case "max":
                    this.rangeValidation(this.min, this.max);
                    if (prop === "min") this.setProperties({
                        min: this.checkDateValue(new Date(this.checkValue(newProp.min)))
                    }, true);
                    else this.setProperties({
                        max: this.checkDateValue(new Date(this.checkValue(newProp.max)))
                    }, true);
                    this.setProperties({
                        start: this.currentView()
                    }, true);
                    if (this.tableBodyElement) (0, $4ZDHT.detach)(this.tableBodyElement);
                    this.minMaxUpdate();
                    if (multiSelection) this.validateValues(multiSelection, values);
                    if (this.getModuleName() !== "datepicker") this.createContentBody();
                    else if (this.calendarElement) this.createContentBody();
                    if ((this.todayDate < this.min || this.max < this.todayDate) && this.footer && this.todayElement) {
                        (0, $4ZDHT.detach)(this.todayElement);
                        (0, $4ZDHT.detach)(this.footer);
                        this.todayElement = this.footer = null;
                        this.createContentFooter();
                    } else if (this.footer && this.todayElement && this.todayElement.classList.contains("e-disabled")) {
                        (0, $4ZDHT.removeClass)([
                            this.todayElement
                        ], $1d370936294fcc88$var$DISABLED);
                        (0, $4ZDHT.detach)(this.todayElement);
                        (0, $4ZDHT.detach)(this.footer);
                        this.todayElement = this.footer = null;
                        this.createContentFooter();
                    }
                    break;
                case "start":
                case "depth":
                case "weekNumber":
                case "firstDayOfWeek":
                case "weekRule":
                    this.checkView();
                    if (this.getModuleName() !== "datepicker") {
                        this.createContentHeader();
                        this.createContentBody();
                    } else if (this.calendarElement) {
                        this.createContentHeader();
                        this.createContentBody();
                    }
                    break;
                case "locale":
                    this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
                    if (this.getModuleName() !== "datepicker") {
                        this.createContentHeader();
                        this.createContentBody();
                    } else if (this.calendarElement) {
                        this.createContentHeader();
                        this.createContentBody();
                    }
                    if (this.getModuleName() === "calendar") {
                        var l10nLocale = {
                            today: "Today"
                        };
                        this.l10 = new (0, $e7i2H.L10n)(this.getModuleName(), l10nLocale, this.locale);
                    }
                    this.l10.setLocale(this.locale);
                    if (this.showTodayButton) this.updateFooter();
                    break;
                case "showTodayButton":
                    if (newProp.showTodayButton) this.createContentFooter();
                    else if (!(0, $3EnZW.isNullOrUndefined)(this.todayElement) && !(0, $3EnZW.isNullOrUndefined)(this.footer)) {
                        (0, $4ZDHT.detach)(this.todayElement);
                        (0, $4ZDHT.detach)(this.footer);
                        this.todayElement = this.footer = undefined;
                    }
                    this.setProperties({
                        showTodayButton: newProp.showTodayButton
                    }, true);
                    break;
            }
        }
    };
    /**
     * values property updated with considered disabled dates of the calendar.
     *
     * @param {boolean} multiSelection - Specifies whether multiple date selection is enabled.
     * @param {Date[]} values - Specifies the dates to validate.
     * @returns {void}
     */ CalendarBase.prototype.validateValues = function(multiSelection, values) {
        if (multiSelection && !(0, $3EnZW.isNullOrUndefined)(values) && values.length > 0) {
            var copyValues = this.copyValues(values);
            for(var skipIndex = 0; skipIndex < copyValues.length; skipIndex++){
                var tempValue = copyValues[skipIndex];
                var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
                var tempValueString = void 0;
                if (this.calendarMode === "Gregorian") tempValueString = this.globalize.formatDate(tempValue, {
                    type: "date",
                    skeleton: "yMd"
                });
                else tempValueString = this.globalize.formatDate(tempValue, {
                    type: "dateTime",
                    skeleton: "full",
                    calendar: "islamic"
                });
                var minFormatOption = {
                    type: "date",
                    skeleton: "yMd",
                    calendar: type
                };
                var minStringValue = this.globalize.formatDate(this.min, minFormatOption);
                var minString = minStringValue;
                var maxFormatOption = {
                    type: "date",
                    skeleton: "yMd",
                    calendar: type
                };
                var maxStringValue = this.globalize.formatDate(this.max, maxFormatOption);
                var maxString = maxStringValue;
                if (+new Date(tempValueString) < +new Date(minString) || +new Date(tempValueString) > +new Date(maxString)) {
                    copyValues.splice(skipIndex, 1);
                    skipIndex = -1;
                }
            }
            this.setProperties({
                values: copyValues
            }, true);
        }
    };
    CalendarBase.prototype.setValueUpdate = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.tableBodyElement)) {
            (0, $4ZDHT.detach)(this.tableBodyElement);
            this.setProperties({
                start: this.currentView()
            }, true);
            this.createContentBody();
        }
    };
    CalendarBase.prototype.copyValues = function(values) {
        var copyValues = [];
        if (!(0, $3EnZW.isNullOrUndefined)(values) && values.length > 0) for(var index = 0; index < values.length; index++)copyValues.push(new Date(+values[index]));
        return copyValues;
    };
    CalendarBase.prototype.titleUpdate = function(date, view) {
        var globalize = new (0, $bWDaN.Internationalization)(this.locale);
        var dayFormatOptions;
        var monthFormatOptions;
        var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
        if (this.calendarMode === "Gregorian") {
            dayFormatOptions = globalize.formatDate(date, {
                type: "dateTime",
                skeleton: "yMMMM",
                calendar: type
            });
            monthFormatOptions = globalize.formatDate(date, {
                format: null,
                type: "dateTime",
                skeleton: "y",
                calendar: type
            });
        } else {
            dayFormatOptions = globalize.formatDate(date, {
                type: "dateTime",
                format: "MMMM y",
                calendar: type
            });
            monthFormatOptions = globalize.formatDate(date, {
                type: "dateTime",
                format: "y",
                calendar: type
            });
        }
        switch(view){
            case "days":
                this.headerTitleElement.textContent = this.toCapitalize(dayFormatOptions);
                break;
            case "months":
                this.headerTitleElement.textContent = monthFormatOptions;
        }
    };
    CalendarBase.prototype.setActiveDescendant = function() {
        var id;
        var focusedEle = this.tableBodyElement.querySelector("tr td.e-focused-date");
        var selectedEle = this.tableBodyElement.querySelector("tr td.e-selected");
        var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
        var title;
        var view = this.currentView();
        if (view === "Month") title = this.globalize.formatDate(this.currentDate, {
            type: "date",
            skeleton: "full",
            calendar: type
        });
        else if (view === "Year") {
            if (type !== "islamic") title = this.globalize.formatDate(this.currentDate, {
                type: "date",
                skeleton: "yMMMM",
                calendar: type
            });
            else title = this.globalize.formatDate(this.currentDate, {
                type: "date",
                skeleton: "GyMMM",
                calendar: type
            });
        } else title = this.globalize.formatDate(this.currentDate, {
            format: null,
            type: "date",
            skeleton: "y",
            calendar: type
        });
        if (selectedEle || focusedEle) {
            if (!(0, $3EnZW.isNullOrUndefined)(selectedEle)) selectedEle.setAttribute("aria-selected", "true");
            (focusedEle || selectedEle).setAttribute("aria-label", title);
            id = (focusedEle || selectedEle).getAttribute("id");
        }
        return id;
    };
    CalendarBase.prototype.iconHandler = function() {
        new Date(this.checkValue(this.currentDate)).setDate(1);
        switch(this.currentView()){
            case "Month":
                this.previousIconHandler(this.compareMonth(new Date(this.checkValue(this.currentDate)), this.min) < 1);
                this.nextIconHandler(this.compareMonth(new Date(this.checkValue(this.currentDate)), this.max) > -1);
                break;
            case "Year":
                this.previousIconHandler(this.compareYear(new Date(this.checkValue(this.currentDate)), this.min) < 1);
                this.nextIconHandler(this.compareYear(new Date(this.checkValue(this.currentDate)), this.max) > -1);
                break;
            case "Decade":
                this.previousIconHandler(this.compareDecade(new Date(this.checkValue(this.currentDate)), this.min) < 1);
                this.nextIconHandler(this.compareDecade(new Date(this.checkValue(this.currentDate)), this.max) > -1);
        }
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ CalendarBase.prototype.destroy = function() {
        if (this.getModuleName() === "calendar" && this.element) (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $1d370936294fcc88$var$ROOT
        ]);
        else if (this.calendarElement && this.element) (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $1d370936294fcc88$var$ROOT
        ]);
        if (this.getModuleName() === "calendar" && this.element) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.headerTitleElement)) (0, $aqzbR.EventHandler).remove(this.headerTitleElement, "click", this.navigateTitle);
            if (this.todayElement) (0, $aqzbR.EventHandler).remove(this.todayElement, "click", this.todayButtonClick);
            this.previousIconHandler(true);
            this.nextIconHandler(true);
            this.keyboardModule.destroy();
            this.element.removeAttribute("data-role");
            if (!(0, $3EnZW.isNullOrUndefined)(this.calendarEleCopy.getAttribute("tabindex"))) this.element.setAttribute("tabindex", this.tabIndex);
            else this.element.removeAttribute("tabindex");
        }
        if (this.element) this.element.innerHTML = "";
        this.todayElement = null;
        this.tableBodyElement = null;
        this.todayButtonEvent = null;
        this.renderDayCellArgs = null;
        this.headerElement = null;
        this.nextIcon = null;
        this.table = null;
        this.tableHeadElement = null;
        this.previousIcon = null;
        this.headerTitleElement = null;
        this.footer = null;
        this.contentElement = null;
        _super.prototype.destroy.call(this);
    };
    CalendarBase.prototype.title = function(e) {
        var currentView = this.getViewNumber(this.currentView());
        this.effect = $1d370936294fcc88$var$ZOOMIN;
        this.switchView(++currentView, e);
    };
    CalendarBase.prototype.getViewNumber = function(stringVal) {
        if (stringVal === "Month") return 0;
        else if (stringVal === "Year") return 1;
        else return 2;
    };
    CalendarBase.prototype.navigateTitle = function(e) {
        e.preventDefault();
        this.title(e);
    };
    CalendarBase.prototype.previous = function() {
        this.effect = "";
        var currentView = this.getViewNumber(this.currentView());
        switch(this.currentView()){
            case "Month":
                this.addMonths(this.currentDate, -1);
                this.switchView(currentView);
                break;
            case "Year":
                this.addYears(this.currentDate, -1);
                this.switchView(currentView);
                break;
            case "Decade":
                this.addYears(this.currentDate, -10);
                this.switchView(currentView);
                break;
        }
    };
    CalendarBase.prototype.navigatePrevious = function(e) {
        !(0, $5q7BP.Browser).isDevice && e.preventDefault();
        if (this.calendarMode === "Gregorian") this.previous();
        else this.islamicModule.islamicPrevious();
        this.triggerNavigate(e);
    };
    CalendarBase.prototype.next = function() {
        this.effect = "";
        var currentView = this.getViewNumber(this.currentView());
        switch(this.currentView()){
            case "Month":
                this.addMonths(this.currentDate, 1);
                this.switchView(currentView);
                break;
            case "Year":
                this.addYears(this.currentDate, 1);
                this.switchView(currentView);
                break;
            case "Decade":
                this.addYears(this.currentDate, 10);
                this.switchView(currentView);
                break;
        }
    };
    CalendarBase.prototype.navigateNext = function(eve) {
        !(0, $5q7BP.Browser).isDevice && eve.preventDefault();
        if (this.calendarMode === "Gregorian") this.next();
        else this.islamicModule.islamicNext();
        this.triggerNavigate(eve);
    };
    /**
     * This method is used to navigate to the month/year/decade view of the Calendar.
     *
     * @param {string} view - Specifies the view of the Calendar.
     * @param {Date} date - Specifies the focused date in a view.
     * @param {boolean} isCustomDate - Specifies whether the calendar is rendered with custom today date or not.
     * @returns {void}
     */ CalendarBase.prototype.navigateTo = function(view, date, isCustomDate) {
        if (+date >= +this.min && +date <= +this.max) this.currentDate = date;
        if (+date <= +this.min) this.currentDate = new Date(this.checkValue(this.min));
        if (+date >= +this.max) this.currentDate = new Date(this.checkValue(this.max));
        if (this.getViewNumber(this.depth) >= this.getViewNumber(view)) {
            if (this.getViewNumber(this.depth) <= this.getViewNumber(this.start) || this.getViewNumber(this.depth) === this.getViewNumber(view)) view = this.depth;
        }
        this.switchView(this.getViewNumber(view), null, null, isCustomDate);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the current view of the Calendar.
     *
     * @returns {string}
     */ CalendarBase.prototype.currentView = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentElement) && this.contentElement.classList.contains($1d370936294fcc88$var$YEAR)) return "Year";
        else if (!(0, $3EnZW.isNullOrUndefined)(this.contentElement) && this.contentElement.classList.contains($1d370936294fcc88$var$DECADE)) return "Decade";
        else return "Month";
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ CalendarBase.prototype.getDateVal = function(date, value) {
        return !(0, $3EnZW.isNullOrUndefined)(value) && date.getDate() === value.getDate() && date.getMonth() === value.getMonth() && date.getFullYear() === value.getFullYear();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CalendarBase.prototype.getCultureObjects = function(ld, c) {
        var gregorianFormat = !(0, $3EnZW.isNullOrUndefined)(this.dayHeaderFormat) ? ".dates.calendars.gregorian.days.format." + this.dayHeaderFormat.toLowerCase() : null;
        var islamicFormat = !(0, $3EnZW.isNullOrUndefined)(this.dayHeaderFormat) ? ".dates.calendars.islamic.days.format." + this.dayHeaderFormat.toLowerCase() : null;
        var mainVal = "main.";
        if (this.calendarMode === "Gregorian") return (0, $3EnZW.getValue)(mainVal + "" + this.locale + gregorianFormat, ld);
        else return (0, $3EnZW.getValue)("main." + this.locale + islamicFormat, ld);
    };
    CalendarBase.prototype.getWeek = function(d) {
        var currentDate = new Date(this.checkValue(d)).valueOf();
        var date = new Date(d.getFullYear(), 0, 1).valueOf();
        return Math.ceil((currentDate - date + $1d370936294fcc88$var$dayMilliSeconds) / $1d370936294fcc88$var$dayMilliSeconds / 7);
    };
    CalendarBase.prototype.setStartDate = function(date, time) {
        var tzOffset = date.getTimezoneOffset();
        var d = new Date(date.getTime() + time);
        var tzOffsetDiff = d.getTimezoneOffset() - tzOffset;
        date.setTime(d.getTime() + tzOffsetDiff * $1d370936294fcc88$var$minutesMilliSeconds);
    };
    CalendarBase.prototype.addMonths = function(date, i) {
        if (this.calendarMode === "Gregorian") {
            var day = date.getDate();
            date.setDate(1);
            date.setMonth(date.getMonth() + i);
            date.setDate(Math.min(day, this.getMaxDays(date)));
        } else {
            var islamicDate = this.islamicModule.getIslamicDate(date);
            this.currentDate = this.islamicModule.toGregorian(islamicDate.year, islamicDate.month + i, 1);
        }
    };
    CalendarBase.prototype.addYears = function(date, i) {
        if (this.calendarMode === "Gregorian") {
            var day = date.getDate();
            date.setDate(1);
            date.setFullYear(date.getFullYear() + i);
            date.setDate(Math.min(day, this.getMaxDays(date)));
        } else {
            var islamicDate = this.islamicModule.getIslamicDate(date);
            this.currentDate = this.islamicModule.toGregorian(islamicDate.year + i, islamicDate.month, 1);
        }
    };
    CalendarBase.prototype.getIdValue = function(e, element) {
        var eve;
        if (e) eve = e.currentTarget;
        else eve = element;
        var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
        var dateFormatOptions = {
            type: "dateTime",
            skeleton: "full",
            calendar: type
        };
        // eslint-disable-next-line radix
        var dateString = this.globalize.formatDate(new Date(parseInt("" + eve.getAttribute("id"), 0)), dateFormatOptions);
        var date = this.globalize.parseDate(dateString, dateFormatOptions);
        var value = date.valueOf() - date.valueOf() % 1000;
        return new Date(value);
    //return this.globalize.parseDate(dateString, dateFormatOptions);
    };
    CalendarBase.prototype.adjustLongHeaderSize = function() {
        (0, $4ZDHT.removeClass)([
            this.element
        ], $1d370936294fcc88$var$DAYHEADERLONG);
        if (this.dayHeaderFormat === "Wide") (0, $4ZDHT.addClass)([
            this.getModuleName() === "calendar" ? this.element : this.calendarElement
        ], $1d370936294fcc88$var$DAYHEADERLONG);
    };
    CalendarBase.prototype.selectDate = function(e, date, node, multiSelection, values) {
        var element = node || e.currentTarget;
        this.isDateSelected = false;
        if (this.currentView() === "Decade") this.setDateDecade(this.currentDate, date.getFullYear());
        else if (this.currentView() === "Year") this.setDateYear(this.currentDate, date);
        else {
            if (multiSelection && !this.checkPresentDate(date, values)) {
                var copyValues = this.copyValues(values);
                if (!(0, $3EnZW.isNullOrUndefined)(values) && copyValues.length > 0) {
                    copyValues.push(new Date(this.checkValue(date)));
                    this.setProperties({
                        values: copyValues
                    }, true);
                    this.setProperties({
                        value: values[values.length - 1]
                    }, true);
                } else this.setProperties({
                    values: [
                        new Date(this.checkValue(date))
                    ]
                }, true);
            } else this.setProperties({
                value: new Date(this.checkValue(date))
            }, true);
            this.currentDate = new Date(this.checkValue(date));
        }
        var tableBodyElement = (0, $4ZDHT.closest)(element, "." + $1d370936294fcc88$var$ROOT);
        if ((0, $3EnZW.isNullOrUndefined)(tableBodyElement)) tableBodyElement = this.tableBodyElement;
        if (!multiSelection && !(0, $3EnZW.isNullOrUndefined)(tableBodyElement.querySelector("." + $1d370936294fcc88$var$SELECTED))) (0, $4ZDHT.removeClass)([
            tableBodyElement.querySelector("." + $1d370936294fcc88$var$SELECTED)
        ], $1d370936294fcc88$var$SELECTED);
        if (!multiSelection && !(0, $3EnZW.isNullOrUndefined)(tableBodyElement.querySelector("." + $1d370936294fcc88$var$FOCUSEDDATE))) (0, $4ZDHT.removeClass)([
            tableBodyElement.querySelector("." + $1d370936294fcc88$var$FOCUSEDDATE)
        ], $1d370936294fcc88$var$FOCUSEDDATE);
        if (!multiSelection && !(0, $3EnZW.isNullOrUndefined)(tableBodyElement.querySelector("." + $1d370936294fcc88$var$FOCUSEDCELL))) (0, $4ZDHT.removeClass)([
            tableBodyElement.querySelector("." + $1d370936294fcc88$var$FOCUSEDCELL)
        ], $1d370936294fcc88$var$FOCUSEDCELL);
        if (multiSelection) {
            var copyValues = this.copyValues(values);
            var collection = Array.prototype.slice.call(this.tableBodyElement.querySelectorAll("td"));
            for(var index = 0; index < collection.length; index++){
                var tempElement = tableBodyElement.querySelectorAll("td." + $1d370936294fcc88$var$FOCUSEDDATE)[0];
                var selectedElement = tableBodyElement.querySelectorAll("td." + $1d370936294fcc88$var$SELECTED)[0];
                if (collection[index] === tempElement) (0, $4ZDHT.removeClass)([
                    collection[index]
                ], $1d370936294fcc88$var$FOCUSEDDATE);
                if (collection[index] === selectedElement && !this.checkPresentDate(new Date(parseInt(selectedElement.getAttribute("id").split("_")[0], 10)), values)) (0, $4ZDHT.removeClass)([
                    collection[index]
                ], $1d370936294fcc88$var$SELECTED);
            }
            if (element.classList.contains($1d370936294fcc88$var$SELECTED)) {
                (0, $4ZDHT.removeClass)([
                    element
                ], $1d370936294fcc88$var$SELECTED);
                for(var i = 0; i < copyValues.length; i++){
                    var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
                    var formatOptions = {
                        format: null,
                        type: "date",
                        skeleton: "short",
                        calendar: type
                    };
                    var localDateString = this.globalize.formatDate(date, formatOptions);
                    var tempDateString = this.globalize.formatDate(copyValues[i], formatOptions);
                    if (localDateString === tempDateString) {
                        var index = copyValues.indexOf(copyValues[i]);
                        copyValues.splice(index, 1);
                        (0, $4ZDHT.addClass)([
                            element
                        ], $1d370936294fcc88$var$FOCUSEDDATE);
                    }
                }
                this.setProperties({
                    values: copyValues
                }, true);
            } else (0, $4ZDHT.addClass)([
                element
            ], $1d370936294fcc88$var$SELECTED);
        } else (0, $4ZDHT.addClass)([
            element
        ], $1d370936294fcc88$var$SELECTED);
        this.isDateSelected = true;
    };
    CalendarBase.prototype.checkPresentDate = function(dates, values) {
        var previousValue = false;
        if (!(0, $3EnZW.isNullOrUndefined)(values)) for(var checkPrevious = 0; checkPrevious < values.length; checkPrevious++){
            var type = this.calendarMode === "Gregorian" ? "gregorian" : "islamic";
            var localDateString = this.globalize.formatDate(dates, {
                format: null,
                type: "date",
                skeleton: "short",
                calendar: type
            });
            var tempDateString = this.globalize.formatDate(values[checkPrevious], {
                format: null,
                type: "date",
                skeleton: "short",
                calendar: type
            });
            if (localDateString === tempDateString) previousValue = true;
        }
        return previousValue;
    };
    CalendarBase.prototype.setAriaActiveDescendant = function() {
        (0, $4ZDHT.attributes)(this.table, {
            "aria-activedescendant": "" + this.setActiveDescendant()
        });
    };
    CalendarBase.prototype.previousIconHandler = function(disabled) {
        if (disabled) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.previousIcon)) {
                (0, $aqzbR.EventHandler).remove(this.previousIcon, "click", this.navigatePreviousHandler);
                (0, $4ZDHT.addClass)([
                    this.previousIcon
                ], "" + $1d370936294fcc88$var$DISABLED);
                (0, $4ZDHT.addClass)([
                    this.previousIcon
                ], "" + $1d370936294fcc88$var$OVERLAY);
                this.previousIcon.setAttribute("aria-disabled", "true");
            }
        } else {
            (0, $aqzbR.EventHandler).add(this.previousIcon, "click", this.navigatePreviousHandler);
            (0, $4ZDHT.removeClass)([
                this.previousIcon
            ], "" + $1d370936294fcc88$var$DISABLED);
            (0, $4ZDHT.removeClass)([
                this.previousIcon
            ], "" + $1d370936294fcc88$var$OVERLAY);
            this.previousIcon.setAttribute("aria-disabled", "false");
        }
    };
    CalendarBase.prototype.renderDayCellEvent = function(args) {
        (0, $3EnZW.extend)(this.renderDayCellArgs, {
            name: "renderDayCell"
        });
        this.trigger("renderDayCell", args);
    };
    CalendarBase.prototype.navigatedEvent = function(eve) {
        (0, $3EnZW.extend)(this.navigatedArgs, {
            name: "navigated",
            event: eve
        });
        this.trigger("navigated", this.navigatedArgs);
    };
    CalendarBase.prototype.triggerNavigate = function(event) {
        this.navigatedArgs = {
            view: this.currentView(),
            date: this.currentDate
        };
        this.navigatedEvent(event);
    };
    CalendarBase.prototype.nextIconHandler = function(disabled) {
        if (disabled) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.previousIcon)) {
                (0, $aqzbR.EventHandler).remove(this.nextIcon, "click", this.navigateNextHandler);
                (0, $4ZDHT.addClass)([
                    this.nextIcon
                ], $1d370936294fcc88$var$DISABLED);
                (0, $4ZDHT.addClass)([
                    this.nextIcon
                ], $1d370936294fcc88$var$OVERLAY);
                this.nextIcon.setAttribute("aria-disabled", "true");
            }
        } else {
            (0, $aqzbR.EventHandler).add(this.nextIcon, "click", this.navigateNextHandler);
            (0, $4ZDHT.removeClass)([
                this.nextIcon
            ], $1d370936294fcc88$var$DISABLED);
            (0, $4ZDHT.removeClass)([
                this.nextIcon
            ], $1d370936294fcc88$var$OVERLAY);
            this.nextIcon.setAttribute("aria-disabled", "false");
        }
    };
    CalendarBase.prototype.compare = function(startDate, endDate, modifier) {
        var start = endDate.getFullYear();
        var end;
        var result;
        end = start;
        result = 0;
        if (modifier) {
            start = start - start % modifier;
            end = start - start % modifier + modifier - 1;
        }
        if (startDate.getFullYear() > end) result = 1;
        else if (startDate.getFullYear() < start) result = -1;
        return result;
    };
    CalendarBase.prototype.isMinMaxRange = function(date) {
        return +date >= +this.min && +date <= +this.max;
    };
    CalendarBase.prototype.isMonthYearRange = function(date) {
        if (this.calendarMode === "Gregorian") return date.getMonth() >= this.min.getMonth() && date.getFullYear() >= this.min.getFullYear() && date.getMonth() <= this.max.getMonth() && date.getFullYear() <= this.max.getFullYear();
        else {
            var islamicDate = this.islamicModule.getIslamicDate(date);
            return islamicDate.month >= this.islamicModule.getIslamicDate(new Date(1944, 1, 18)).month && islamicDate.year >= this.islamicModule.getIslamicDate(new Date(1944, 1, 18)).year && islamicDate.month <= this.islamicModule.getIslamicDate(new Date(2069, 1, 16)).month && islamicDate.year <= this.islamicModule.getIslamicDate(new Date(2069, 1, 16)).year;
        }
    };
    CalendarBase.prototype.compareYear = function(start, end) {
        return this.compare(start, end, 0);
    };
    CalendarBase.prototype.compareDecade = function(start, end) {
        return this.compare(start, end, 10);
    };
    CalendarBase.prototype.shiftArray = function(array, i) {
        return array.slice(i).concat(array.slice(0, i));
    };
    CalendarBase.prototype.addDay = function(date, i, e, max, min) {
        var column = i;
        var value = new Date(+date);
        if (!(0, $3EnZW.isNullOrUndefined)(this.tableBodyElement) && !(0, $3EnZW.isNullOrUndefined)(e)) {
            while(this.findNextTD(new Date(+date), column, max, min))column += i;
            var rangeValue = new Date(value.setDate(value.getDate() + column));
            column = +rangeValue > +max || +rangeValue < +min ? column === i ? i - i : i : column;
        }
        date.setDate(date.getDate() + column);
    };
    CalendarBase.prototype.findNextTD = function(date, column, max, min) {
        var value = new Date(date.setDate(date.getDate() + column));
        var collection = [];
        var isDisabled = false;
        if ((!(0, $3EnZW.isNullOrUndefined)(value) && value.getMonth()) === (!(0, $3EnZW.isNullOrUndefined)(this.currentDate) && this.currentDate.getMonth())) {
            var tdEles = void 0;
            if (this.calendarMode === "Gregorian") tdEles = this.renderDays(value);
            else tdEles = this.islamicModule.islamicRenderDays(this.currentDate, value);
            collection = tdEles.filter(function(element) {
                return element.classList.contains($1d370936294fcc88$var$DISABLED);
            });
        } else collection = this.tableBodyElement.querySelectorAll("td." + $1d370936294fcc88$var$DISABLED);
        if (+value <= +max && +value >= +min) {
            if (collection.length) for(var i = 0; i < collection.length; i++){
                // eslint-disable-next-line radix
                isDisabled = +value === +new Date(parseInt(collection[i].id, 0)) ? true : false;
                if (isDisabled) break;
            }
        }
        return isDisabled;
    };
    CalendarBase.prototype.getMaxDays = function(d) {
        var date;
        var tmpDate = new Date(this.checkValue(d));
        date = 28;
        var month = tmpDate.getMonth();
        while(tmpDate.getMonth() === month){
            ++date;
            tmpDate.setDate(date);
        }
        return date - 1;
    };
    CalendarBase.prototype.setDateDecade = function(date, year) {
        date.setFullYear(year);
        this.setProperties({
            value: new Date(this.checkValue(date))
        }, true);
    };
    CalendarBase.prototype.setDateYear = function(date, value) {
        date.setFullYear(value.getFullYear(), value.getMonth(), date.getDate());
        if (value.getMonth() !== date.getMonth()) {
            date.setDate(0);
            this.currentDate = new Date(this.checkValue(value));
        }
        this.setProperties({
            value: new Date(this.checkValue(date))
        }, true);
    };
    CalendarBase.prototype.compareMonth = function(start, end) {
        var result;
        if (start.getFullYear() > end.getFullYear()) result = 1;
        else if (start.getFullYear() < end.getFullYear()) result = -1;
        else result = start.getMonth() === end.getMonth() ? 0 : start.getMonth() > end.getMonth() ? 1 : -1;
        return result;
    };
    CalendarBase.prototype.checkValue = function(inValue) {
        if (inValue instanceof Date) return inValue.toUTCString();
        else return "" + inValue;
    };
    CalendarBase.prototype.checkView = function() {
        if (this.start !== "Decade" && this.start !== "Year") this.setProperties({
            start: "Month"
        }, true);
        if (this.depth !== "Decade" && this.depth !== "Year") this.setProperties({
            depth: "Month"
        }, true);
        if (this.getViewNumber(this.depth) > this.getViewNumber(this.start)) this.setProperties({
            depth: "Month"
        }, true);
    };
    CalendarBase.prototype.getDate = function(date, timezone) {
        if (timezone) date = new Date(date.toLocaleString("en-US", {
            timeZone: timezone
        }));
        return date;
    };
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(new Date(1900, 0, 1))
    ], CalendarBase.prototype, "min", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], CalendarBase.prototype, "enabled", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CalendarBase.prototype, "cssClass", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(new Date(2099, 11, 31))
    ], CalendarBase.prototype, "max", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CalendarBase.prototype, "firstDayOfWeek", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)("Gregorian")
    ], CalendarBase.prototype, "calendarMode", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)("Month")
    ], CalendarBase.prototype, "start", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)("Month")
    ], CalendarBase.prototype, "depth", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CalendarBase.prototype, "weekNumber", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)("FirstDay")
    ], CalendarBase.prototype, "weekRule", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], CalendarBase.prototype, "showTodayButton", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)("Short")
    ], CalendarBase.prototype, "dayHeaderFormat", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CalendarBase.prototype, "enablePersistence", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CalendarBase.prototype, "keyConfigs", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CalendarBase.prototype, "serverTimezoneOffset", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Event)()
    ], CalendarBase.prototype, "created", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Event)()
    ], CalendarBase.prototype, "destroyed", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Event)()
    ], CalendarBase.prototype, "navigated", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Event)()
    ], CalendarBase.prototype, "renderDayCell", void 0);
    CalendarBase = $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], CalendarBase);
    return CalendarBase;
}((0, $hQxLN.Component));
/**
 * Represents the Calendar component that allows the user to select a date.
 * ```html
 * <div id="calendar"/>
 * ```
 * ```typescript
 * <script>
 *   var calendarObj = new Calendar({ value: new Date() });
 *   calendarObj.appendTo("#calendar");
 * </script>
 * ```
 */ var $1d370936294fcc88$export$e1aef45b828286de = /** @class */ function(_super) {
    $1d370936294fcc88$var$__extends(Calendar, _super);
    /**
     * Initialized new instance of Calendar Class.
     * Constructor for creating the widget
     *
     * @param {CalendarModel} options - Specifies the Calendar model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function Calendar(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * To Initialize the control rendering.
     *
     * @returns {void}
     * @private
     */ Calendar.prototype.render = function() {
        if (this.calendarMode === "Islamic" && this.islamicModule === undefined) (0, $3EnZW.throwError)("Requires the injectable Islamic modules to render Calendar in Islamic mode");
        if (this.isMultiSelection && typeof this.values === "object" && !(0, $3EnZW.isNullOrUndefined)(this.values) && this.values.length > 0) {
            var tempValues = [];
            var copyValues = [];
            for(var limit = 0; limit < this.values.length; limit++)if (tempValues.indexOf(+this.values[limit]) === -1) {
                tempValues.push(+this.values[limit]);
                copyValues.push(this.values[limit]);
            }
            this.setProperties({
                values: copyValues
            }, true);
            for(var index = 0; index < this.values.length; index++)if (!this.checkDateValue(this.values[index])) {
                if (typeof this.values[index] === "string" && this.checkDateValue(new Date(this.checkValue(this.values[index])))) {
                    var copyDate = new Date(this.checkValue(this.values[index]));
                    this.values.splice(index, 1);
                    this.values.splice(index, 0, copyDate);
                } else this.values.splice(index, 1);
            }
            this.setProperties({
                value: this.values[this.values.length - 1]
            }, true);
            this.previousValues = this.values.length;
        }
        this.validateDate();
        this.minMaxUpdate();
        if (this.getModuleName() === "calendar") {
            this.setEnable(this.enabled);
            this.setClass(this.cssClass);
        }
        _super.prototype.render.call(this);
        if (this.getModuleName() === "calendar") {
            var form = (0, $4ZDHT.closest)(this.element, "form");
            if (form) (0, $aqzbR.EventHandler).add(form, "reset", this.formResetHandler.bind(this));
            this.setTimeZone(this.serverTimezoneOffset);
        }
        this.renderComplete();
    };
    Calendar.prototype.setEnable = function(enable) {
        if (!enable) (0, $4ZDHT.addClass)([
            this.element
        ], $1d370936294fcc88$var$DISABLED);
        else (0, $4ZDHT.removeClass)([
            this.element
        ], $1d370936294fcc88$var$DISABLED);
    };
    Calendar.prototype.setClass = function(newCssClass, oldCssClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldCssClass)) oldCssClass = oldCssClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(newCssClass)) newCssClass = newCssClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(oldCssClass) && oldCssClass !== "") (0, $4ZDHT.removeClass)([
            this.element
        ], oldCssClass.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(newCssClass)) (0, $4ZDHT.addClass)([
            this.element
        ], newCssClass.split(" "));
    };
    Calendar.prototype.isDayLightSaving = function() {
        var secondOffset = new Date(this.value.getFullYear(), 6, 1).getTimezoneOffset();
        var firstOffset = new Date(this.value.getFullYear(), 0, 1).getTimezoneOffset();
        return this.value.getTimezoneOffset() < Math.max(firstOffset, secondOffset);
    };
    Calendar.prototype.setTimeZone = function(offsetValue) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.serverTimezoneOffset) && this.value) {
            var serverTimezoneDiff = offsetValue;
            var clientTimeZoneDiff = new Date().getTimezoneOffset() / 60;
            var timeZoneDiff = serverTimezoneDiff + clientTimeZoneDiff;
            timeZoneDiff = this.isDayLightSaving() ? timeZoneDiff-- : timeZoneDiff;
            this.value = new Date(this.value.getTime() + timeZoneDiff * 3600000);
        }
    };
    Calendar.prototype.formResetHandler = function() {
        this.setProperties({
            value: null
        }, true);
    };
    Calendar.prototype.validateDate = function() {
        if (typeof this.value === "string") this.setProperties({
            value: this.checkDateValue(new Date(this.checkValue(this.value)))
        }, true); // persist the value property.
        _super.prototype.validateDate.call(this, this.value);
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.min <= this.max && this.value >= this.min && this.value <= this.max) this.currentDate = new Date(this.checkValue(this.value));
        if (isNaN(+this.value)) this.setProperties({
            value: null
        }, true);
    };
    Calendar.prototype.minMaxUpdate = function() {
        if (this.getModuleName() === "calendar") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value <= this.min && this.min <= this.max) {
                this.setProperties({
                    value: this.min
                }, true);
                this.changedArgs = {
                    value: this.value
                };
            } else if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value >= this.max && this.min <= this.max) {
                this.setProperties({
                    value: this.max
                }, true);
                this.changedArgs = {
                    value: this.value
                };
            }
        }
        if (this.getModuleName() !== "calendar" && !(0, $3EnZW.isNullOrUndefined)(this.value)) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value < this.min && this.min <= this.max) _super.prototype.minMaxUpdate.call(this, this.min);
            else if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value > this.max && this.min <= this.max) _super.prototype.minMaxUpdate.call(this, this.max);
        } else _super.prototype.minMaxUpdate.call(this, this.value);
    };
    Calendar.prototype.generateTodayVal = function(value) {
        var tempValue = new Date();
        if (!(0, $3EnZW.isNullOrUndefined)(this.timezone)) tempValue = _super.prototype.getDate.call(this, tempValue, this.timezone);
        if (value && (0, $3EnZW.isNullOrUndefined)(this.timezone)) {
            tempValue.setHours(value.getHours());
            tempValue.setMinutes(value.getMinutes());
            tempValue.setSeconds(value.getSeconds());
            tempValue.setMilliseconds(value.getMilliseconds());
        } else tempValue = new Date(tempValue.getFullYear(), tempValue.getMonth(), tempValue.getDate(), 0, 0, 0, 0);
        return tempValue;
    };
    Calendar.prototype.todayButtonClick = function(e) {
        if (this.showTodayButton) {
            var tempValue = this.generateTodayVal(this.value);
            this.setProperties({
                value: tempValue
            }, true);
            this.isTodayClicked = true;
            this.todayButtonEvent = e;
            if (this.isMultiSelection) {
                var copyValues = this.copyValues(this.values);
                if (!_super.prototype.checkPresentDate.call(this, tempValue, this.values)) {
                    copyValues.push(tempValue);
                    this.setProperties({
                        values: copyValues
                    });
                }
            }
            _super.prototype.todayButtonClick.call(this, e, new Date(+this.value));
        }
    };
    Calendar.prototype.keyActionHandle = function(e) {
        _super.prototype.keyActionHandle.call(this, e, this.value, this.isMultiSelection);
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */ Calendar.prototype.preRender = function() {
        var _this = this;
        this.changeHandler = function(e) {
            _this.triggerChange(e);
        };
        this.checkView();
        _super.prototype.preRender.call(this, this.value);
    };
    /**
     * @returns {void}

     */ Calendar.prototype.createContent = function() {
        this.previousDate = this.value;
        this.previousDateTime = this.value;
        _super.prototype.createContent.call(this);
    };
    Calendar.prototype.minMaxDate = function(localDate) {
        return _super.prototype.minMaxDate.call(this, localDate);
    };
    Calendar.prototype.renderMonths = function(e, value, isCustomDate) {
        _super.prototype.renderMonths.call(this, e, this.value, isCustomDate);
    };
    Calendar.prototype.renderDays = function(currentDate, value, isMultiSelect, values, isCustomDate, e) {
        var tempDays = _super.prototype.renderDays.call(this, currentDate, this.value, this.isMultiSelection, this.values, isCustomDate, e);
        if (this.isMultiSelection) _super.prototype.validateValues.call(this, this.isMultiSelection, this.values);
        return tempDays;
    };
    Calendar.prototype.renderYears = function(e) {
        if (this.calendarMode === "Gregorian") _super.prototype.renderYears.call(this, e, this.value);
        else this.islamicModule.islamicRenderYears(e, this.value);
    };
    Calendar.prototype.renderDecades = function(e) {
        if (this.calendarMode === "Gregorian") _super.prototype.renderDecades.call(this, e, this.value);
        else this.islamicModule.islamicRenderDecade(e, this.value);
    };
    Calendar.prototype.renderTemplate = function(elements, count, classNm, e) {
        if (this.calendarMode === "Gregorian") _super.prototype.renderTemplate.call(this, elements, count, classNm, e, this.value);
        else this.islamicModule.islamicRenderTemplate(elements, count, classNm, e, this.value);
        this.changedArgs = {
            value: this.value,
            values: this.values
        };
        e && e.type === "click" && e.currentTarget.classList.contains($1d370936294fcc88$var$OTHERMONTH) ? this.changeHandler(e) : this.changeHandler();
    };
    Calendar.prototype.clickHandler = function(e) {
        var eve = e.currentTarget;
        this.isPopupClicked = true;
        if (eve.classList.contains($1d370936294fcc88$var$OTHERMONTH)) {
            if (this.isMultiSelection) {
                var copyValues = this.copyValues(this.values);
                if (copyValues.toString().indexOf(this.getIdValue(e, null).toString()) === -1) {
                    copyValues.push(this.getIdValue(e, null));
                    this.setProperties({
                        values: copyValues
                    }, true);
                    this.setProperties({
                        value: this.values[this.values.length - 1]
                    }, true);
                } else this.previousDates = true;
            } else this.setProperties({
                value: this.getIdValue(e, null)
            }, true);
        }
        var storeView = this.currentView();
        _super.prototype.clickHandler.call(this, e, this.value);
        if (this.isMultiSelection && this.currentDate !== this.value && !(0, $3EnZW.isNullOrUndefined)(this.tableBodyElement.querySelectorAll("." + $1d370936294fcc88$var$FOCUSEDDATE)[0]) && storeView === "Year") this.tableBodyElement.querySelectorAll("." + $1d370936294fcc88$var$FOCUSEDDATE)[0].classList.remove($1d370936294fcc88$var$FOCUSEDDATE);
    };
    Calendar.prototype.switchView = function(view, e, isMultiSelection, isCustomDate) {
        _super.prototype.switchView.call(this, view, e, this.isMultiSelection, isCustomDate);
    };
    /**
     * To get component name
     *
     * @returns {string} Return the component name.
     * @private
     */ Calendar.prototype.getModuleName = function() {
        _super.prototype.getModuleName.call(this);
        return "calendar";
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the properties to be maintained upon browser refresh.
     *
     * @returns {string}
     */ Calendar.prototype.getPersistData = function() {
        _super.prototype.getPersistData.call(this);
        var keyEntity = [
            "value",
            "values"
        ];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Called internally if any of the property value changed.
     *
     * @param {CalendarModel} newProp - Returns the dynamic property value of the component.
     * @param {CalendarModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ Calendar.prototype.onPropertyChanged = function(newProp, oldProp) {
        this.effect = "";
        this.rangeValidation(this.min, this.max);
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "value":
                    if (this.isDateSelected) {
                        if (typeof newProp.value === "string") this.setProperties({
                            value: new Date(this.checkValue(newProp.value))
                        }, true);
                        else newProp.value = new Date(this.checkValue(newProp.value));
                        if (isNaN(+this.value)) this.setProperties({
                            value: oldProp.value
                        }, true);
                        this.update();
                    }
                    break;
                case "values":
                    if (this.isDateSelected) {
                        if (typeof newProp.values === "string" || typeof newProp.values === "number") this.setProperties({
                            values: null
                        }, true);
                        else {
                            var copyValues = this.copyValues(this.values);
                            for(var index = 0; index < copyValues.length; index++){
                                var tempDate = copyValues[index];
                                if (this.checkDateValue(tempDate) && !_super.prototype.checkPresentDate.call(this, tempDate, copyValues)) copyValues.push(tempDate);
                            }
                            this.setProperties({
                                values: copyValues
                            }, true);
                            if (this.values.length > 0) this.setProperties({
                                value: newProp.values[newProp.values.length - 1]
                            }, true);
                        }
                        this.validateValues(this.isMultiSelection, this.values);
                        this.update();
                    }
                    break;
                case "isMultiSelection":
                    if (this.isDateSelected) {
                        this.setProperties({
                            isMultiSelection: newProp.isMultiSelection
                        }, true);
                        this.update();
                    }
                    break;
                case "enabled":
                    this.setEnable(this.enabled);
                    break;
                case "cssClass":
                    if (this.getModuleName() === "calendar") this.setClass(newProp.cssClass, oldProp.cssClass);
                    break;
                default:
                    _super.prototype.onPropertyChanged.call(this, newProp, oldProp, this.isMultiSelection, this.values);
            }
        }
        this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ Calendar.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        if (this.getModuleName() === "calendar") {
            this.changedArgs = null;
            var form = (0, $4ZDHT.closest)(this.element, "form");
            if (form) (0, $aqzbR.EventHandler).remove(form, "reset", this.formResetHandler.bind(this));
        }
    };
    /**
     * This method is used to navigate to the month/year/decade view of the Calendar.
     *
     * @param {string} view - Specifies the view of the Calendar.
     * @param {Date} date - Specifies the focused date in a view.
     * @param {boolean} isCustomDate - Specifies whether the calendar is rendered with custom today date or not.
     * @returns {void}

     */ Calendar.prototype.navigateTo = function(view, date, isCustomDate) {
        this.minMaxUpdate();
        _super.prototype.navigateTo.call(this, view, date, isCustomDate);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the current view of the Calendar.
     *
     * @returns {string}

     */ Calendar.prototype.currentView = function() {
        return _super.prototype.currentView.call(this);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * This method is used to add the single or multiple dates to the values property of the Calendar.
     *
     * @param {Date | Date[]} dates - Specifies the date or dates to be added to the values property of the Calendar.
     * @returns {void}

     */ Calendar.prototype.addDate = function(dates) {
        if (typeof dates !== "string" && typeof dates !== "number") {
            var copyValues = this.copyValues(this.values);
            if (typeof dates === "object" && dates.length > 0) {
                var tempDates = dates;
                for(var i = 0; i < tempDates.length; i++)if (this.checkDateValue(tempDates[i]) && !_super.prototype.checkPresentDate.call(this, tempDates[i], copyValues)) {
                    if (!(0, $3EnZW.isNullOrUndefined)(copyValues) && copyValues.length > 0) copyValues.push(tempDates[i]);
                    else copyValues = [
                        new Date(+tempDates[i])
                    ];
                }
            } else if (this.checkDateValue(dates) && !_super.prototype.checkPresentDate.call(this, dates, copyValues)) {
                if (!(0, $3EnZW.isNullOrUndefined)(copyValues) && copyValues.length > 0) copyValues.push(dates);
                else copyValues = [
                    new Date(+dates)
                ];
            }
            this.setProperties({
                values: copyValues
            }, true);
            if (this.isMultiSelection) this.setProperties({
                value: this.values[this.values.length - 1]
            }, true);
            this.validateValues(this.isMultiSelection, copyValues);
            this.update();
            this.changedArgs = {
                value: this.value,
                values: this.values
            };
            this.changeHandler();
        }
    };
    /**
     * This method is used to remove the single or multiple dates from the values property of the Calendar.
     *
     * @param {Date | Date[]} dates - Specifies the date or dates which need to be removed from the values property of the Calendar.
     * @returns {void}

     */ Calendar.prototype.removeDate = function(dates) {
        if (typeof dates !== "string" && typeof dates !== "number" && !(0, $3EnZW.isNullOrUndefined)(this.values) && this.values.length > 0) {
            var copyValues = this.copyValues(this.values);
            if (typeof dates === "object" && dates.length > 0) {
                var tempDates = dates;
                for(var index = 0; index < tempDates.length; index++){
                    for(var i = 0; i < copyValues.length; i++)if (+copyValues[i] === +tempDates[index]) copyValues.splice(i, 1);
                }
            } else {
                for(var i = 0; i < copyValues.length; i++)if (+copyValues[i] === +dates) copyValues.splice(i, 1);
            }
            this.setProperties({
                values: copyValues
            }, false);
            this.update();
            if (this.isMultiSelection) this.setProperties({
                value: this.values[this.values.length - 1]
            }, true);
            this.changedArgs = {
                value: this.value,
                values: this.values
            };
            this.changeHandler();
        }
    };
    /**
     * To set custom today date in calendar
     *
     * @param {Date} date - Specifies date value to be set.
     * @private
     * @returns {void}
     */ Calendar.prototype.setTodayDate = function(date) {
        var todayDate = new Date(+date);
        this.setProperties({
            value: todayDate
        }, true);
        _super.prototype.todayButtonClick.call(this, null, todayDate, true);
    };
    Calendar.prototype.update = function() {
        this.validateDate();
        this.minMaxUpdate();
        _super.prototype.setValueUpdate.call(this);
    };
    Calendar.prototype.selectDate = function(e, date, element) {
        _super.prototype.selectDate.call(this, e, date, element, this.isMultiSelection, this.values);
        if (this.isMultiSelection && !(0, $3EnZW.isNullOrUndefined)(this.values) && this.values.length > 0) this.setProperties({
            value: this.values[this.values.length - 1]
        }, true);
        this.changedArgs = {
            value: this.value,
            values: this.values
        };
        this.changeHandler(e);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Calendar.prototype.changeEvent = function(e) {
        if ((this.value && this.value.valueOf()) !== (this.previousDate && +this.previousDate.valueOf()) || this.isMultiSelection) {
            if (this.isAngular && this.preventChange) this.preventChange = false;
            else this.trigger("change", this.changedArgs);
            this.previousDate = new Date(+this.value);
        }
    };
    Calendar.prototype.triggerChange = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.todayButtonEvent) && this.isTodayClicked) {
            e = this.todayButtonEvent;
            this.isTodayClicked = false;
        }
        this.changedArgs.event = e || null;
        this.changedArgs.isInteracted = !(0, $3EnZW.isNullOrUndefined)(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) this.setProperties({
            value: this.value
        }, true);
        // eslint-disable-next-line
        if (!this.isMultiSelection && +this.value !== Number.NaN && (!(0, $3EnZW.isNullOrUndefined)(this.value) && !(0, $3EnZW.isNullOrUndefined)(this.previousDate) || this.previousDate === null && !isNaN(+this.value))) this.changeEvent(e);
        else if (!(0, $3EnZW.isNullOrUndefined)(this.values) && this.previousValues !== this.values.length) {
            this.changeEvent(e);
            this.previousValues = this.values.length;
        }
    };
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Calendar.prototype, "value", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Calendar.prototype, "values", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Calendar.prototype, "isMultiSelection", void 0);
    $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.Event)()
    ], Calendar.prototype, "change", void 0);
    Calendar = $1d370936294fcc88$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Calendar);
    return Calendar;
}($1d370936294fcc88$export$bfd52a43017368fe);


var $d5f6934cad42758d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d5f6934cad42758d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
//class constant defination
var $d5f6934cad42758d$var$DATEWRAPPER = "e-date-wrapper";
var $d5f6934cad42758d$var$ROOT = "e-datepicker";
var $d5f6934cad42758d$var$LIBRARY = "e-lib";
var $d5f6934cad42758d$var$CONTROL = "e-control";
var $d5f6934cad42758d$var$POPUPWRAPPER = "e-popup-wrapper";
var $d5f6934cad42758d$var$INPUTWRAPPER = "e-input-group-icon";
var $d5f6934cad42758d$var$POPUP = "e-popup";
var $d5f6934cad42758d$var$INPUTCONTAINER = "e-input-group";
var $d5f6934cad42758d$var$INPUTFOCUS = "e-input-focus";
var $d5f6934cad42758d$var$INPUTROOT = "e-input";
var $d5f6934cad42758d$var$ERROR = "e-error";
var $d5f6934cad42758d$var$ACTIVE = "e-active";
var $d5f6934cad42758d$var$OVERFLOW = "e-date-overflow";
var $d5f6934cad42758d$var$DATEICON = "e-date-icon";
var $d5f6934cad42758d$var$CLEARICON = "e-clear-icon";
var $d5f6934cad42758d$var$ICONS = "e-icons";
var $d5f6934cad42758d$var$OPENDURATION = 300;
var $d5f6934cad42758d$var$OFFSETVALUE = 4;
var $d5f6934cad42758d$var$SELECTED = "e-selected";
var $d5f6934cad42758d$var$FOCUSEDDATE = "e-focused-date";
var $d5f6934cad42758d$var$NONEDIT = "e-non-edit";
var $d5f6934cad42758d$var$containerAttr = [
    "title",
    "class",
    "style"
];
/**
 * Represents the DatePicker component that allows user to select
 * or enter a date value.
 * ```html
 * <input id='datepicker'/>
 * ```
 * ```typescript
 * <script>
 *   let datePickerObject:DatePicker = new DatePicker({ value: new Date() });
 *   datePickerObject.appendTo('#datepicker');
 * </script>
 * ```
 */ var $d5f6934cad42758d$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $d5f6934cad42758d$var$__extends(DatePicker, _super);
    /**
     * Constructor for creating the widget.
     *
     * @param {DatePickerModel} options - Specifies the DatePicker model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function DatePicker(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isDateIconClicked = false;
        _this.isAltKeyPressed = false;
        _this.isInteracted = true;
        _this.invalidValueString = null;
        _this.checkPreviousValue = null;
        _this.maskedDateValue = "";
        _this.preventChange = false;
        _this.isIconClicked = false;
        _this.isDynamicValueChanged = false;
        _this.moduleName = _this.getModuleName();
        _this.isFocused = false;
        _this.isBlur = false;
        _this.isKeyAction = false;
        _this.datepickerOptions = options;
        return _this;
    }
    /**
     * To Initialize the control rendering.
     *
     * @returns {void}
     * @private
     */ DatePicker.prototype.render = function() {
        this.initialize();
        this.bindEvents();
        if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        this.renderComplete();
        this.setTimeZone(this.serverTimezoneOffset);
    };
    DatePicker.prototype.setTimeZone = function(offsetValue) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.serverTimezoneOffset) && this.value) {
            var clientTimeZoneDiff = new Date().getTimezoneOffset() / 60;
            var serverTimezoneDiff = offsetValue;
            var timeZoneDiff = serverTimezoneDiff + clientTimeZoneDiff;
            timeZoneDiff = this.isDayLightSaving() ? timeZoneDiff-- : timeZoneDiff;
            this.value = new Date(this.value.getTime() + timeZoneDiff * 3600000);
            this.updateInput();
        }
    };
    DatePicker.prototype.isDayLightSaving = function() {
        var firstOffset = new Date(this.value.getFullYear(), 0, 1).getTimezoneOffset();
        var secondOffset = new Date(this.value.getFullYear(), 6, 1).getTimezoneOffset();
        return this.value.getTimezoneOffset() < Math.max(firstOffset, secondOffset);
    };
    DatePicker.prototype.setAllowEdit = function() {
        if (this.allowEdit) {
            if (!this.readonly) this.inputElement.removeAttribute("readonly");
        } else (0, $4ZDHT.attributes)(this.inputElement, {
            "readonly": ""
        });
        this.updateIconState();
    };
    DatePicker.prototype.updateIconState = function() {
        if (!this.allowEdit && this.inputWrapper && !this.readonly) {
            if (this.inputElement.value === "") (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], [
                $d5f6934cad42758d$var$NONEDIT
            ]);
            else (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], [
                $d5f6934cad42758d$var$NONEDIT
            ]);
        } else if (this.inputWrapper) (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], [
            $d5f6934cad42758d$var$NONEDIT
        ]);
    };
    DatePicker.prototype.initialize = function() {
        this.checkInvalidValue(this.value);
        if (this.enableMask) this.notify("createMask", {
            module: "MaskedDateTime"
        });
        this.createInput();
        this.updateHtmlAttributeToWrapper();
        this.setAllowEdit();
        if (this.enableMask && !this.value && this.maskedDateValue && (this.floatLabelType === "Always" || !this.floatLabelType || !this.placeholder)) {
            this.updateInput(true);
            this.updateInputValue(this.maskedDateValue);
        } else if (!this.enableMask) this.updateInput(true);
        this.previousElementValue = this.inputElement.value;
        this.previousDate = !(0, $3EnZW.isNullOrUndefined)(this.value) ? new Date(+this.value) : null;
        this.inputElement.setAttribute("value", this.inputElement.value);
        this.inputValueCopy = this.value;
    };
    DatePicker.prototype.createInput = function() {
        var ariaAttrs = {
            "aria-atomic": "true",
            "aria-expanded": "false",
            "role": "combobox",
            "autocomplete": "off",
            "autocorrect": "off",
            "autocapitalize": "off",
            "spellcheck": "false",
            "aria-invalid": "false"
        };
        if (this.getModuleName() === "datepicker") {
            var l10nLocale = {
                placeholder: this.placeholder
            };
            this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
            this.l10n = new (0, $e7i2H.L10n)("datepicker", l10nLocale, this.locale);
            this.setProperties({
                placeholder: this.placeholder || this.l10n.getConstant("placeholder")
            }, true);
        }
        if (this.fullScreenMode && (0, $5q7BP.Browser).isDevice) this.cssClass += " e-popup-expand";
        var updatedCssClassValues = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValues = this.cssClass.replace(/\s+/g, " ").trim();
        var isBindClearAction = this.enableMask ? false : true;
        this.inputWrapper = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.inputElement,
            floatLabelType: this.floatLabelType,
            bindClearAction: isBindClearAction,
            properties: {
                readonly: this.readonly,
                placeholder: this.placeholder,
                cssClass: updatedCssClassValues,
                enabled: this.enabled,
                enableRtl: this.enableRtl,
                showClearButton: this.showClearButton
            },
            buttons: [
                $d5f6934cad42758d$var$INPUTWRAPPER + " " + $d5f6934cad42758d$var$DATEICON + " " + $d5f6934cad42758d$var$ICONS
            ]
        }, this.createElement);
        this.setWidth(this.width);
        if (this.inputElement.name !== "") this.inputElement.setAttribute("name", "" + this.inputElement.getAttribute("name"));
        else this.inputElement.setAttribute("name", "" + this.element.id);
        (0, $4ZDHT.attributes)(this.inputElement, ariaAttrs);
        if (!this.inputElement.hasAttribute("aria-label")) this.inputElement.setAttribute("aria-label", this.getModuleName());
        if (!this.enabled) {
            this.inputElement.setAttribute("aria-disabled", "true");
            this.inputElement.tabIndex = -1;
        } else {
            this.inputElement.setAttribute("aria-disabled", "false");
            this.inputElement.setAttribute("tabindex", this.tabIndex);
        }
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).addAttributes({
            "aria-label": "select",
            "role": "button"
        }, this.inputWrapper.buttons[0]);
        (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], $d5f6934cad42758d$var$DATEWRAPPER);
    };
    DatePicker.prototype.updateInput = function(isDynamic, isBlur) {
        if (isDynamic === void 0) isDynamic = false;
        if (isBlur === void 0) isBlur = false;
        var formatOptions;
        if (this.value && !this.isCalendar()) this.disabledDates(isDynamic, isBlur);
        if (isNaN(+new Date(this.checkValue(this.value)))) this.setProperties({
            value: null
        }, true);
        if (this.strictMode) {
            //calls the Calendar processDate protected method to update the date value according to the strictMode true behaviour.
            _super.prototype.validateDate.call(this);
            this.minMaxUpdates();
            _super.prototype.minMaxUpdate.call(this);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var dateValue = this.value;
            var dateString = void 0;
            var tempFormat = !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat;
            if (this.getModuleName() === "datetimepicker") {
                if (this.calendarMode === "Gregorian") dateString = this.globalize.formatDate(this.value, {
                    format: tempFormat,
                    type: "dateTime",
                    skeleton: "yMd"
                });
                else dateString = this.globalize.formatDate(this.value, {
                    format: tempFormat,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                });
            } else {
                if (this.calendarMode === "Gregorian") formatOptions = {
                    format: this.formatString,
                    type: "dateTime",
                    skeleton: "yMd"
                };
                else formatOptions = {
                    format: this.formatString,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                };
                dateString = this.globalize.formatDate(this.value, formatOptions);
            }
            if (+dateValue <= +this.max && +dateValue >= +this.min) this.updateInputValue(dateString);
            else {
                var value = +dateValue >= +this.max || !+this.value || !+this.value || +dateValue <= +this.min;
                if (!this.strictMode && value) this.updateInputValue(dateString);
            }
        }
        if ((0, $3EnZW.isNullOrUndefined)(this.value) && this.strictMode) {
            if (!this.enableMask) this.updateInputValue("");
            else {
                this.updateInputValue(this.maskedDateValue);
                this.notify("createMask", {
                    module: "MaskedDateTime"
                });
            }
        }
        if (!this.strictMode && (0, $3EnZW.isNullOrUndefined)(this.value) && this.invalidValueString) this.updateInputValue(this.invalidValueString);
        this.changedArgs = {
            value: this.value
        };
        this.errorClass();
        this.updateIconState();
    };
    DatePicker.prototype.minMaxUpdates = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value < this.min && this.min <= this.max && this.strictMode) {
            this.setProperties({
                value: this.min
            }, true);
            this.changedArgs = {
                value: this.value
            };
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value > this.max && this.min <= this.max && this.strictMode) {
            this.setProperties({
                value: this.max
            }, true);
            this.changedArgs = {
                value: this.value
            };
        }
    };
    DatePicker.prototype.checkStringValue = function(val) {
        var returnDate = null;
        var formatOptions = null;
        var formatDateTime = null;
        if (this.getModuleName() === "datetimepicker") {
            var culture = new (0, $bWDaN.Internationalization)(this.locale);
            if (this.calendarMode === "Gregorian") {
                formatOptions = {
                    format: this.dateTimeFormat,
                    type: "dateTime",
                    skeleton: "yMd"
                };
                formatDateTime = {
                    format: culture.getDatePattern({
                        skeleton: "yMd"
                    }),
                    type: "dateTime"
                };
            } else {
                formatOptions = {
                    format: this.dateTimeFormat,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                };
                formatDateTime = {
                    format: culture.getDatePattern({
                        skeleton: "yMd"
                    }),
                    type: "dateTime",
                    calendar: "islamic"
                };
            }
        } else if (this.calendarMode === "Gregorian") formatOptions = {
            format: this.formatString,
            type: "dateTime",
            skeleton: "yMd"
        };
        else formatOptions = {
            format: this.formatString,
            type: "dateTime",
            skeleton: "yMd",
            calendar: "islamic"
        };
        returnDate = this.checkDateValue(this.globalize.parseDate(this.getAmPmValue(val), formatOptions));
        if ((0, $3EnZW.isNullOrUndefined)(returnDate) && this.getModuleName() === "datetimepicker") returnDate = this.checkDateValue(this.globalize.parseDate(this.getAmPmValue(val), formatDateTime));
        return returnDate;
    };
    DatePicker.prototype.checkInvalidValue = function(value) {
        if (!(value instanceof Date) && !(0, $3EnZW.isNullOrUndefined)(value)) {
            var valueDate = null;
            var valueString = value;
            if (typeof value === "number") valueString = value.toString();
            var formatOptions = null;
            var formatDateTime = null;
            if (this.getModuleName() === "datetimepicker") {
                var culture = new (0, $bWDaN.Internationalization)(this.locale);
                if (this.calendarMode === "Gregorian") {
                    formatOptions = {
                        format: this.dateTimeFormat,
                        type: "dateTime",
                        skeleton: "yMd"
                    };
                    formatDateTime = {
                        format: culture.getDatePattern({
                            skeleton: "yMd"
                        }),
                        type: "dateTime"
                    };
                } else {
                    formatOptions = {
                        format: this.dateTimeFormat,
                        type: "dateTime",
                        skeleton: "yMd",
                        calendar: "islamic"
                    };
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    formatDateTime = {
                        format: culture.getDatePattern({
                            skeleton: "yMd"
                        }),
                        type: "dateTime",
                        calendar: "islamic"
                    };
                }
            } else if (this.calendarMode === "Gregorian") formatOptions = {
                format: this.formatString,
                type: "dateTime",
                skeleton: "yMd"
            };
            else // eslint-disable-next-line @typescript-eslint/no-unused-vars
            formatOptions = {
                format: this.formatString,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
            var invalid = false;
            if (typeof valueString !== "string") {
                valueString = null;
                invalid = true;
            } else {
                if (typeof valueString === "string") valueString = valueString.trim();
                valueDate = this.checkStringValue(valueString);
                if (!valueDate) {
                    var extISOString = null;
                    var basicISOString = null;
                    // eslint-disable-next-line
                    extISOString = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
                    // eslint-disable-next-line
                    basicISOString = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
                    if (!extISOString.test(valueString) && !basicISOString.test(valueString) || /^[a-zA-Z0-9- ]*$/.test(valueString) || isNaN(+new Date(this.checkValue(valueString)))) invalid = true;
                    else valueDate = new Date(valueString);
                }
            }
            if (invalid) {
                if (!this.strictMode) this.invalidValueString = valueString;
                this.setProperties({
                    value: null
                }, true);
            } else this.setProperties({
                value: valueDate
            }, true);
        }
    };
    DatePicker.prototype.bindInputEvent = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.formatString) || this.enableMask) {
            if (this.enableMask || this.formatString.indexOf("y") === -1) (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.inputHandler, this);
            else (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.inputHandler);
        }
    };
    DatePicker.prototype.bindEvents = function() {
        (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "mousedown", this.dateIconHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "mouseup", this.mouseUpHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "focus", this.inputFocusHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "blur", this.inputBlurHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.keyupHandler, this);
        if (this.enableMask) (0, $aqzbR.EventHandler).add(this.inputElement, "keydown", this.keydownHandler, this);
        this.bindInputEvent();
        // To prevent the twice triggering.
        (0, $aqzbR.EventHandler).add(this.inputElement, "change", this.inputChangeHandler, this);
        if (this.showClearButton && this.inputWrapper.clearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown touchstart", this.resetHandler, this);
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.resetFormHandler, this);
        this.defaultKeyConfigs = (0, $3EnZW.extend)(this.defaultKeyConfigs, this.keyConfigs);
        this.keyboardModules = new (0, $dyv7X.KeyboardEvents)(this.inputElement, {
            eventName: "keydown",
            keyAction: this.inputKeyActionHandle.bind(this),
            keyConfigs: this.defaultKeyConfigs
        });
    };
    DatePicker.prototype.keydownHandler = function(e) {
        switch(e.code){
            case "ArrowLeft":
            case "ArrowRight":
            case "ArrowUp":
            case "ArrowDown":
            case "Home":
            case "End":
            case "Backspace":
            case "Delete":
                if (this.enableMask && !this.popupObj && !this.readonly) {
                    if (e.code !== "Delete" && e.code !== "Backspace") e.preventDefault();
                    this.notify("keyDownHandler", {
                        module: "MaskedDateTime",
                        e: e
                    });
                }
                break;
            default:
                break;
        }
    };
    DatePicker.prototype.unBindEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper)) (0, $aqzbR.EventHandler).remove(this.inputWrapper.buttons[0], "mousedown", this.dateIconHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "mouseup", this.mouseUpHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.inputFocusHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "blur", this.inputBlurHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "change", this.inputChangeHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.keyupHandler);
        if (this.enableMask) (0, $aqzbR.EventHandler).remove(this.inputElement, "keydown", this.keydownHandler);
        if (this.showClearButton && this.inputWrapper.clearButton) (0, $aqzbR.EventHandler).remove(this.inputWrapper.clearButton, "mousedown touchstart", this.resetHandler);
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.resetFormHandler);
    };
    DatePicker.prototype.resetFormHandler = function() {
        if (!this.enabled) return;
        if (!this.inputElement.disabled) {
            var value = this.inputElement.getAttribute("value");
            if (this.element.tagName === "EJS-DATEPICKER" || this.element.tagName === "EJS-DATETIMEPICKER") {
                value = "";
                this.inputValueCopy = null;
                this.inputElement.setAttribute("value", "");
            }
            this.setProperties({
                value: this.inputValueCopy
            }, true);
            this.restoreValue();
            if (this.inputElement) {
                this.updateInputValue(value);
                this.errorClass();
            }
        }
    };
    DatePicker.prototype.restoreValue = function() {
        this.currentDate = this.value ? this.value : new Date();
        this.previousDate = this.value;
        this.previousElementValue = (0, $3EnZW.isNullOrUndefined)(this.inputValueCopy) ? "" : this.globalize.formatDate(this.inputValueCopy, {
            format: this.formatString,
            type: "dateTime",
            skeleton: "yMd"
        });
    };
    DatePicker.prototype.inputChangeHandler = function(e) {
        if (!this.enabled) return;
        e.stopPropagation();
    };
    DatePicker.prototype.bindClearEvent = function() {
        if (this.showClearButton && this.inputWrapper.clearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown touchstart", this.resetHandler, this);
    };
    DatePicker.prototype.resetHandler = function(e) {
        if (!this.enabled) return;
        e.preventDefault();
        this.clear(e);
    };
    DatePicker.prototype.mouseUpHandler = function(e) {
        if (this.enableMask) {
            e.preventDefault();
            this.notify("setMaskSelection", {
                module: "MaskedDateTime"
            });
        }
    };
    DatePicker.prototype.clear = function(event) {
        this.setProperties({
            value: null
        }, true);
        if (!this.enableMask) this.updateInputValue("");
        var clearedArgs = {
            event: event
        };
        this.trigger("cleared", clearedArgs);
        this.invalidValueString = "";
        this.updateInput();
        this.popupUpdate();
        this.changeEvent(event);
        if (this.enableMask) this.notify("clearHandler", {
            module: "MaskedDateTime"
        });
        if ((0, $4ZDHT.closest)(this.element, "form")) {
            var element = this.element;
            var keyupEvent = document.createEvent("KeyboardEvent");
            keyupEvent.initEvent("keyup", false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    DatePicker.prototype.preventEventBubbling = function(e) {
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.interopAdaptor.invokeMethodAsync("OnDateIconClick");
    };
    DatePicker.prototype.updateInputValue = function(value) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(value, this.inputElement, this.floatLabelType, this.showClearButton);
    };
    DatePicker.prototype.dateIconHandler = function(e) {
        if (!this.enabled) return;
        this.isIconClicked = true;
        if ((0, $5q7BP.Browser).isDevice) {
            this.inputElement.setAttribute("readonly", "");
            this.inputElement.blur();
        }
        e.preventDefault();
        if (!this.readonly) {
            if (this.isCalendar()) this.hide(e);
            else {
                this.isDateIconClicked = true;
                this.show(null, e);
                if (this.getModuleName() === "datetimepicker") this.inputElement.focus();
                this.inputElement.focus();
                (0, $4ZDHT.addClass)([
                    this.inputWrapper.container
                ], [
                    $d5f6934cad42758d$var$INPUTFOCUS
                ]);
                (0, $4ZDHT.addClass)(this.inputWrapper.buttons, $d5f6934cad42758d$var$ACTIVE);
            }
        }
        this.isIconClicked = false;
    };
    DatePicker.prototype.updateHtmlAttributeToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes["" + key])) {
                if ($d5f6934cad42758d$var$containerAttr.indexOf(key) > -1) {
                    if (key === "class") {
                        var updatedClassValues = this.htmlAttributes["" + key].replace(/\s+/g, " ").trim();
                        if (updatedClassValues !== "") (0, $4ZDHT.addClass)([
                            this.inputWrapper.container
                        ], updatedClassValues.split(" "));
                    } else if (key === "style") {
                        var setStyle = this.inputWrapper.container.getAttribute(key);
                        if (!(0, $3EnZW.isNullOrUndefined)(setStyle)) {
                            if (setStyle.charAt(setStyle.length - 1) === ";") setStyle = setStyle + this.htmlAttributes["" + key];
                            else setStyle = setStyle + ";" + this.htmlAttributes["" + key];
                        } else setStyle = this.htmlAttributes["" + key];
                        this.inputWrapper.container.setAttribute(key, setStyle);
                    } else this.inputWrapper.container.setAttribute(key, this.htmlAttributes["" + key]);
                }
            }
        }
    };
    DatePicker.prototype.updateHtmlAttributeToElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($d5f6934cad42758d$var$containerAttr.indexOf(key) < 0) this.inputElement.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    DatePicker.prototype.updateCssClass = function(newCssClass, oldCssClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldCssClass)) oldCssClass = oldCssClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(newCssClass)) newCssClass = newCssClass.replace(/\s+/g, " ").trim();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newCssClass, [
            this.inputWrapper.container
        ], oldCssClass);
        if (this.popupWrapper) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newCssClass, [
            this.popupWrapper
        ], oldCssClass);
    };
    DatePicker.prototype.calendarKeyActionHandle = function(e) {
        switch(e.action){
            case "escape":
                if (this.isCalendar()) this.hide(e);
                else this.inputWrapper.container.children[this.index].blur();
                break;
            case "enter":
                if (!this.isCalendar()) this.show(null, e);
                else if (+this.value !== +this.currentDate && !this.isCalendar()) this.inputWrapper.container.children[this.index].focus();
                if (this.getModuleName() === "datetimepicker") this.inputElement.focus();
                break;
        }
    };
    DatePicker.prototype.inputFocusHandler = function() {
        this.isFocused = true;
        if (!this.enabled) return;
        if (this.enableMask && !this.inputElement.value && this.placeholder) {
            if (this.maskedDateValue && !this.value && (this.floatLabelType === "Auto" || this.floatLabelType === "Never" || this.placeholder)) {
                this.updateInputValue(this.maskedDateValue);
                this.inputElement.selectionStart = 0;
                this.inputElement.selectionEnd = this.inputElement.value.length;
            }
        }
        var focusArguments = {
            model: this
        };
        this.isDateIconClicked = false;
        this.trigger("focus", focusArguments);
        this.updateIconState();
        if (this.openOnFocus && !this.isIconClicked) this.show();
    };
    DatePicker.prototype.inputHandler = function(e) {
        this.isPopupClicked = false;
        if (this.enableMask) {
            if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.inputType) && e.inputType === "insertFromPaste") this.notify("maskPasteInputHandler", {
                module: "MaskedDateTime"
            });
            else this.notify("inputHandler", {
                module: "MaskedDateTime"
            });
        }
    };
    DatePicker.prototype.inputBlurHandler = function(e) {
        if (!this.enabled) return;
        this.strictModeUpdate();
        if (this.inputElement.value === "" && (0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.invalidValueString = null;
            this.updateInputValue("");
        }
        this.isBlur = true;
        this.updateInput(false, true);
        this.isBlur = false;
        this.popupUpdate();
        this.changeTrigger(e);
        if (this.enableMask && this.maskedDateValue && this.placeholder && this.floatLabelType !== "Always") {
            if (this.inputElement.value === this.maskedDateValue && !this.value && (this.floatLabelType === "Auto" || this.floatLabelType === "Never" || this.placeholder)) this.updateInputValue("");
        }
        this.errorClass();
        if (this.isCalendar() && document.activeElement === this.inputElement) this.hide(e);
        if (this.getModuleName() === "datepicker") {
            var blurArguments = {
                model: this
            };
            this.trigger("blur", blurArguments);
        }
        if (this.isCalendar()) {
            this.defaultKeyConfigs = (0, $3EnZW.extend)(this.defaultKeyConfigs, this.keyConfigs);
            this.calendarKeyboardModules = new (0, $dyv7X.KeyboardEvents)(this.calendarElement.children[1].firstElementChild, {
                eventName: "keydown",
                keyAction: this.calendarKeyActionHandle.bind(this),
                keyConfigs: this.defaultKeyConfigs
            });
        }
        this.isPopupClicked = false;
    };
    DatePicker.prototype.documentHandler = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && (this.inputWrapper.container.contains(e.target) && e.type !== "mousedown" || this.popupObj.element && this.popupObj.element.contains(e.target)) && e.type !== "touchstart") e.preventDefault();
        var target = e.target;
        if (!(0, $4ZDHT.closest)(target, ".e-datepicker.e-popup-wrapper") && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && !((0, $4ZDHT.closest)(target, "." + $d5f6934cad42758d$var$INPUTCONTAINER) === this.inputWrapper.container) && !target.classList.contains("e-day") && !target.classList.contains("e-dlg-overlay")) {
            this.hide(e);
            this.focusOut();
        } else if ((0, $4ZDHT.closest)(target, ".e-datepicker.e-popup-wrapper")) {
            // Fix for close the popup when select the previously selected value.
            if (target.classList.contains("e-day") && !(0, $3EnZW.isNullOrUndefined)(e.target.parentElement) && e.target.parentElement.classList.contains("e-selected") && (0, $4ZDHT.closest)(target, ".e-content") && (0, $4ZDHT.closest)(target, ".e-content").classList.contains("e-" + this.depth.toLowerCase())) this.hide(e);
            else if ((0, $4ZDHT.closest)(target, ".e-footer-container") && target.classList.contains("e-today") && target.classList.contains("e-btn") && +new Date(+this.value) === +_super.prototype.generateTodayVal.call(this, this.value)) this.hide(e);
        }
    };
    DatePicker.prototype.inputKeyActionHandle = function(e) {
        var clickedView = this.currentView();
        switch(e.action){
            case "altUpArrow":
                this.isAltKeyPressed = false;
                this.hide(e);
                this.inputElement.focus();
                break;
            case "altDownArrow":
                this.isAltKeyPressed = true;
                this.strictModeUpdate();
                this.updateInput();
                this.changeTrigger(e);
                if (this.getModuleName() === "datepicker") this.show(null, e);
                break;
            case "escape":
                this.hide(e);
                break;
            case "enter":
                this.strictModeUpdate();
                this.updateInput();
                this.popupUpdate();
                this.changeTrigger(e);
                this.errorClass();
                if (!this.isCalendar() && document.activeElement === this.inputElement) this.hide(e);
                if (this.isCalendar()) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                break;
            case "tab":
            case "shiftTab":
                var start = this.inputElement.selectionStart;
                var end = this.inputElement.selectionEnd;
                if (this.enableMask && !this.popupObj && !this.readonly) {
                    var length_1 = this.inputElement.value.length;
                    if (start === 0 && end === length_1 || end !== length_1 && e.action === "tab" || start !== 0 && e.action === "shiftTab") e.preventDefault();
                    this.notify("keyDownHandler", {
                        module: "MaskedDateTime",
                        e: e
                    });
                    start = this.inputElement.selectionStart;
                    end = this.inputElement.selectionEnd;
                }
                this.strictModeUpdate();
                this.updateInput();
                this.popupUpdate();
                this.changeTrigger(e);
                this.errorClass();
                if (this.enableMask) {
                    this.inputElement.selectionStart = start;
                    this.inputElement.selectionEnd = end;
                }
                if (e.action === "tab" && e.target === this.inputElement && this.isCalendar() && document.activeElement === this.inputElement) {
                    e.preventDefault();
                    this.headerTitleElement.focus();
                }
                if (e.action === "shiftTab" && e.target === this.inputElement && this.isCalendar() && document.activeElement === this.inputElement) this.hide(e);
                break;
            default:
                this.defaultAction(e);
                // Fix for close the popup when select the previously selected value.
                if (e.action === "select" && clickedView === this.depth) this.hide(e);
        }
    };
    DatePicker.prototype.defaultAction = function(e) {
        this.previousDate = !(0, $3EnZW.isNullOrUndefined)(this.value) && new Date(+this.value) || null;
        if (this.isCalendar()) {
            _super.prototype.keyActionHandle.call(this, e);
            if (this.isCalendar()) (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-activedescendant": "" + this.setActiveDescendant()
            });
        }
    };
    DatePicker.prototype.popupUpdate = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.value) && !(0, $3EnZW.isNullOrUndefined)(this.previousDate) || this.getModuleName() !== "datetimepicker" && +this.value !== +this.previousDate || this.getModuleName() === "datetimepicker" && +this.value !== +this.previousDateTime) {
            if (this.popupObj) {
                if (this.popupObj.element.querySelectorAll("." + $d5f6934cad42758d$var$SELECTED).length > 0) (0, $4ZDHT.removeClass)(this.popupObj.element.querySelectorAll("." + $d5f6934cad42758d$var$SELECTED), [
                    $d5f6934cad42758d$var$SELECTED
                ]);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
                if (+this.value >= +this.min && +this.value <= +this.max) {
                    var targetdate = new Date(this.checkValue(this.value));
                    _super.prototype.navigateTo.call(this, "Month", targetdate);
                }
            }
        }
    };
    DatePicker.prototype.strictModeUpdate = function() {
        var format;
        var pattern = /^y/;
        var charPattern = /[^a-zA-Z]/;
        var formatOptions;
        if (this.getModuleName() === "datetimepicker") format = !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat;
        else if (!pattern.test(this.formatString) || charPattern.test(this.formatString)) format = (0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.formatString.replace("dd", "d");
        if (!(0, $3EnZW.isNullOrUndefined)(format)) {
            var len = format.split("M").length - 1;
            if (len < 3) format = format.replace("MM", "M");
        } else format = this.formatString;
        var dateOptions;
        if (this.getModuleName() === "datetimepicker") {
            if (this.calendarMode === "Gregorian") dateOptions = {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd"
            };
            else dateOptions = {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
        } else {
            if (this.calendarMode === "Gregorian") formatOptions = {
                format: format,
                type: "dateTime",
                skeleton: "yMd"
            };
            else formatOptions = {
                format: format,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
            dateOptions = formatOptions;
        }
        var date;
        if (typeof this.inputElement.value === "string") this.inputElement.value = this.inputElement.value.trim();
        if (this.getModuleName() === "datetimepicker") {
            if (this.checkDateValue(this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), dateOptions))) date = this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), dateOptions);
            else {
                if (this.calendarMode === "Gregorian") formatOptions = {
                    format: format,
                    type: "dateTime",
                    skeleton: "yMd"
                };
                else formatOptions = {
                    format: format,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                };
                date = this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), formatOptions);
            }
        } else {
            date = this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), dateOptions);
            date = !(0, $3EnZW.isNullOrUndefined)(date) && isNaN(+date) ? null : date;
            if (!(0, $3EnZW.isNullOrUndefined)(this.formatString) && this.inputElement.value !== "" && this.strictMode) {
                if ((this.isPopupClicked || !this.isPopupClicked && this.inputElement.value === this.previousElementValue) && this.formatString.indexOf("y") === -1) date.setFullYear(this.value.getFullYear());
            }
        }
        // EJ2-35061 - To prevent change event from triggering twice when using strictmode and format property
        if (this.getModuleName() === "datepicker" && this.value && !isNaN(+this.value) && date) date.setHours(this.value.getHours(), this.value.getMinutes(), this.value.getSeconds(), this.value.getMilliseconds());
        if (this.strictMode && date) {
            this.updateInputValue(this.globalize.formatDate(date, dateOptions));
            if (this.inputElement.value !== this.previousElementValue) this.setProperties({
                value: date
            }, true);
        } else if (!this.strictMode) {
            if (this.inputElement.value !== this.previousElementValue) this.setProperties({
                value: date
            }, true);
        }
        if (this.strictMode && !date && this.inputElement.value === (this.enableMask ? this.maskedDateValue : "")) this.setProperties({
            value: null
        }, true);
        if (isNaN(+this.value)) this.setProperties({
            value: null
        }, true);
        if ((0, $3EnZW.isNullOrUndefined)(this.value)) this.currentDate = new Date(new Date().setHours(0, 0, 0, 0));
    };
    DatePicker.prototype.createCalendar = function() {
        var _this = this;
        this.popupWrapper = this.createElement("div", {
            className: "" + $d5f6934cad42758d$var$ROOT + " " + $d5f6934cad42758d$var$POPUPWRAPPER,
            id: this.inputElement.id + "_options"
        });
        this.popupWrapper.setAttribute("aria-label", this.element.id);
        this.popupWrapper.setAttribute("role", "dialog");
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) this.popupWrapper.className += " " + this.cssClass;
        if ((0, $5q7BP.Browser).isDevice) {
            this.modelHeader();
            this.modal = this.createElement("div");
            this.modal.className = "" + $d5f6934cad42758d$var$ROOT + " e-date-modal";
            document.body.className += " " + $d5f6934cad42758d$var$OVERFLOW;
            this.modal.style.display = "block";
            document.body.appendChild(this.modal);
        }
        //this.calendarElement represent the Calendar object from the Calendar class.
        this.calendarElement.querySelector("table tbody").className = "";
        this.popupObj = new (0, $2vAqh.Popup)(this.popupWrapper, {
            content: this.calendarElement,
            relateTo: (0, $5q7BP.Browser).isDevice ? document.body : this.inputWrapper.container,
            position: (0, $5q7BP.Browser).isDevice ? {
                X: "center",
                Y: "center"
            } : this.enableRtl ? {
                X: "right",
                Y: "bottom"
            } : {
                X: "left",
                Y: "bottom"
            },
            offsetY: $d5f6934cad42758d$var$OFFSETVALUE,
            targetType: "container",
            enableRtl: this.enableRtl,
            zIndex: this.zIndex,
            collision: (0, $5q7BP.Browser).isDevice ? {
                X: "fit",
                Y: "fit"
            } : this.enableRtl ? {
                X: "fit",
                Y: "flip"
            } : {
                X: "flip",
                Y: "flip"
            },
            open: function() {
                if ((0, $5q7BP.Browser).isDevice && _this.fullScreenMode) {
                    _this.iconRight = parseInt(window.getComputedStyle(_this.calendarElement.querySelector(".e-header.e-month .e-prev")).marginRight, 10) > 16 ? true : false;
                    _this.touchModule = new (0, $i528u.Touch)(_this.calendarElement.querySelector(".e-content.e-month"), {
                        swipe: _this.CalendarSwipeHandler.bind(_this)
                    });
                    (0, $aqzbR.EventHandler).add(_this.calendarElement.querySelector(".e-content.e-month"), "touchstart", _this.TouchStartHandler, _this);
                }
                if (_this.getModuleName() !== "datetimepicker") {
                    if (document.activeElement !== _this.inputElement) {
                        _this.defaultKeyConfigs = (0, $3EnZW.extend)(_this.defaultKeyConfigs, _this.keyConfigs);
                        _this.calendarElement.children[1].firstElementChild.focus();
                        _this.calendarKeyboardModules = new (0, $dyv7X.KeyboardEvents)(_this.calendarElement.children[1].firstElementChild, {
                            eventName: "keydown",
                            keyAction: _this.calendarKeyActionHandle.bind(_this),
                            keyConfigs: _this.defaultKeyConfigs
                        });
                        _this.calendarKeyboardModules = new (0, $dyv7X.KeyboardEvents)(_this.inputWrapper.container.children[_this.index], {
                            eventName: "keydown",
                            keyAction: _this.calendarKeyActionHandle.bind(_this),
                            keyConfigs: _this.defaultKeyConfigs
                        });
                    }
                }
            },
            close: function() {
                if (_this.isDateIconClicked) _this.inputWrapper.container.children[_this.index].focus();
                if (_this.value) _this.disabledDates();
                if (_this.popupObj) _this.popupObj.destroy();
                _this.resetCalendar();
                (0, $4ZDHT.detach)(_this.popupWrapper);
                _this.popupObj = _this.popupWrapper = null;
                _this.preventArgs = null;
                _this.calendarKeyboardModules = null;
                _this.setAriaAttributes();
            },
            targetExitViewport: function() {
                if (!(0, $5q7BP.Browser).isDevice) _this.hide();
            }
        });
        this.popupObj.element.className += " " + this.cssClass;
        this.setAriaAttributes();
    };
    DatePicker.prototype.getAmPmValue = function(date) {
        try {
            if (typeof date === "string" && date.trim() !== "") // Replace am/pm variants with uppercase AM/PM
            return date.replace(/(am|pm|Am|aM|pM|Pm)/g, function(match) {
                return match.toLocaleUpperCase();
            });
            // If date is null, undefined, or an empty string, return a default value or empty string
            return "";
        } catch (error) {
            console.error("Error occurred while processing date:", error);
            return ""; // Return a default value in case of an error
        }
    };
    DatePicker.prototype.CalendarSwipeHandler = function(e) {
        var direction = 0;
        if (this.iconRight) switch(e.swipeDirection){
            case "Left":
                direction = 1;
                break;
            case "Right":
                direction = -1;
                break;
            default:
                break;
        }
        else switch(e.swipeDirection){
            case "Up":
                direction = 1;
                break;
            case "Down":
                direction = -1;
                break;
            default:
                break;
        }
        if (this.touchStart) {
            if (direction === 1) this.navigateNext(e);
            else if (direction === -1) this.navigatePrevious(e);
            this.touchStart = false;
        }
    };
    DatePicker.prototype.TouchStartHandler = function(e) {
        this.touchStart = true;
    };
    DatePicker.prototype.setAriaDisabled = function() {
        if (!this.enabled) {
            this.inputElement.setAttribute("aria-disabled", "true");
            this.inputElement.tabIndex = -1;
        } else {
            this.inputElement.setAttribute("aria-disabled", "false");
            this.inputElement.setAttribute("tabindex", this.tabIndex);
        }
    };
    DatePicker.prototype.modelHeader = function() {
        var dateOptions;
        var modelHeader = this.createElement("div", {
            className: "e-model-header"
        });
        var yearHeading = this.createElement("h1", {
            className: "e-model-year"
        });
        var h2 = this.createElement("div");
        var daySpan = this.createElement("span", {
            className: "e-model-day"
        });
        var monthSpan = this.createElement("span", {
            className: "e-model-month"
        });
        if (this.calendarMode === "Gregorian") dateOptions = {
            format: "y",
            skeleton: "dateTime"
        };
        else dateOptions = {
            format: "y",
            skeleton: "dateTime",
            calendar: "islamic"
        };
        yearHeading.textContent = "" + this.globalize.formatDate(this.value || new Date(), dateOptions);
        if (this.calendarMode === "Gregorian") dateOptions = {
            format: "E",
            skeleton: "dateTime"
        };
        else dateOptions = {
            format: "E",
            skeleton: "dateTime",
            calendar: "islamic"
        };
        daySpan.textContent = "" + this.globalize.formatDate(this.value || new Date(), dateOptions) + ", ";
        if (this.calendarMode === "Gregorian") dateOptions = {
            format: "MMM d",
            skeleton: "dateTime"
        };
        else dateOptions = {
            format: "MMM d",
            skeleton: "dateTime",
            calendar: "islamic"
        };
        monthSpan.textContent = "" + this.globalize.formatDate(this.value || new Date(), dateOptions);
        if (this.fullScreenMode) {
            var modelCloseIcon = this.createElement("span", {
                className: "e-popup-close"
            });
            (0, $aqzbR.EventHandler).add(modelCloseIcon, "mousedown touchstart", this.modelCloseHandler, this);
            var modelTodayButton = this.calendarElement.querySelector("button.e-today");
            h2.classList.add("e-day-wrapper");
            modelTodayButton.classList.add("e-outline");
            modelHeader.appendChild(modelCloseIcon);
            modelHeader.appendChild(modelTodayButton);
        }
        if (!this.fullScreenMode) modelHeader.appendChild(yearHeading);
        h2.appendChild(daySpan);
        h2.appendChild(monthSpan);
        modelHeader.appendChild(h2);
        this.calendarElement.insertBefore(modelHeader, this.calendarElement.firstElementChild);
    };
    DatePicker.prototype.modelCloseHandler = function(e) {
        this.hide();
    };
    DatePicker.prototype.changeTrigger = function(event) {
        if (this.inputElement.value !== this.previousElementValue) {
            if ((this.previousDate && this.previousDate.valueOf()) !== (this.value && this.value.valueOf())) {
                if (this.isDynamicValueChanged && this.isCalendar()) this.popupUpdate();
                this.changedArgs.value = this.value;
                this.changedArgs.event = event || null;
                this.changedArgs.element = this.element;
                this.changedArgs.isInteracted = !(0, $3EnZW.isNullOrUndefined)(event);
                if (this.isAngular && this.preventChange) this.preventChange = false;
                else this.trigger("change", this.changedArgs);
                this.previousElementValue = this.inputElement.value;
                this.previousDate = !isNaN(+new Date(this.checkValue(this.value))) ? new Date(this.checkValue(this.value)) : null;
                this.isInteracted = true;
            }
        }
        this.isKeyAction = false;
    };
    DatePicker.prototype.navigatedEvent = function() {
        this.trigger("navigated", this.navigatedArgs);
    };
    DatePicker.prototype.keyupHandler = function(e) {
        this.isKeyAction = this.inputElement.value !== this.previousElementValue ? true : false;
    };
    DatePicker.prototype.changeEvent = function(event) {
        if (!this.isIconClicked && !(this.isBlur || this.isKeyAction)) this.selectCalendar(event);
        if ((this.previousDate && this.previousDate.valueOf()) !== (this.value && this.value.valueOf())) {
            this.changedArgs.event = event ? event : null;
            this.changedArgs.element = this.element;
            this.changedArgs.isInteracted = this.isInteracted;
            if (!this.isDynamicValueChanged) this.trigger("change", this.changedArgs);
            this.previousDate = this.value && new Date(+this.value);
            if (!this.isDynamicValueChanged) this.hide(event);
            this.previousElementValue = this.inputElement.value;
            this.errorClass();
        } else if (event) this.hide(event);
        this.isKeyAction = false;
    };
    DatePicker.prototype.requiredModules = function() {
        var modules = [];
        if (this.calendarMode === "Islamic") modules.push({
            args: [
                this
            ],
            member: "islamic",
            name: "Islamic"
        });
        if (this.enableMask) modules.push({
            args: [
                this
            ],
            member: "MaskedDateTime"
        });
        return modules;
    };
    DatePicker.prototype.selectCalendar = function(e) {
        var date;
        var tempFormat;
        var formatOptions;
        if (this.getModuleName() === "datetimepicker") tempFormat = !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat;
        else tempFormat = this.formatString;
        if (this.value) {
            if (this.getModuleName() === "datetimepicker") {
                if (this.calendarMode === "Gregorian") formatOptions = {
                    format: tempFormat,
                    type: "dateTime",
                    skeleton: "yMd"
                };
                else formatOptions = {
                    format: tempFormat,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                };
                date = this.globalize.formatDate(this.changedArgs.value, formatOptions);
            } else {
                if (this.calendarMode === "Gregorian") formatOptions = {
                    format: this.formatString,
                    type: "dateTime",
                    skeleton: "yMd"
                };
                else formatOptions = {
                    format: this.formatString,
                    type: "dateTime",
                    skeleton: "yMd",
                    calendar: "islamic"
                };
                date = this.globalize.formatDate(this.changedArgs.value, formatOptions);
            }
            if (this.enableMask) this.notify("createMask", {
                module: "MaskedDateTime"
            });
        }
        if (!(0, $3EnZW.isNullOrUndefined)(date)) {
            this.updateInputValue(date);
            if (this.enableMask) this.notify("setMaskSelection", {
                module: "MaskedDateTime"
            });
        }
    };
    DatePicker.prototype.isCalendar = function() {
        if (this.popupWrapper && this.popupWrapper.classList.contains("" + $d5f6934cad42758d$var$POPUPWRAPPER)) return true;
        return false;
    };
    DatePicker.prototype.setWidth = function(width) {
        if (typeof width === "number") this.inputWrapper.container.style.width = (0, $3EnZW.formatUnit)(this.width);
        else if (typeof width === "string") this.inputWrapper.container.style.width = width.match(/px|%|em/) ? this.width : (0, $3EnZW.formatUnit)(this.width);
        else this.inputWrapper.container.style.width = "100%";
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Shows the Calendar.
     *
     * @returns {void}

     */ DatePicker.prototype.show = function(type, e) {
        var _this = this;
        if (this.enabled && this.readonly || !this.enabled || this.popupObj) return;
        else {
            var prevent_1 = true;
            var outOfRange = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && !(+this.value >= +new Date(this.checkValue(this.min)) && +this.value <= +new Date(this.checkValue(this.max)))) {
                outOfRange = new Date(this.checkValue(this.value));
                this.setProperties({
                    "value": null
                }, true);
            } else outOfRange = this.value || null;
            if (!this.isCalendar()) {
                _super.prototype.render.call(this);
                this.setProperties({
                    "value": outOfRange || null
                }, true);
                this.previousDate = outOfRange;
                this.createCalendar();
            }
            if ((0, $5q7BP.Browser).isDevice) {
                this.mobilePopupWrapper = this.createElement("div", {
                    className: "e-datepick-mob-popup-wrap"
                });
                document.body.appendChild(this.mobilePopupWrapper);
            }
            this.preventArgs = {
                preventDefault: function() {
                    prevent_1 = false;
                },
                popup: this.popupObj,
                event: e || null,
                cancel: false,
                appendTo: (0, $5q7BP.Browser).isDevice ? this.mobilePopupWrapper : document.body
            };
            var eventArgs = this.preventArgs;
            this.trigger("open", eventArgs, function(eventArgs) {
                _this.preventArgs = eventArgs;
                if (prevent_1 && !_this.preventArgs.cancel) {
                    (0, $4ZDHT.addClass)(_this.inputWrapper.buttons, $d5f6934cad42758d$var$ACTIVE);
                    _this.preventArgs.appendTo.appendChild(_this.popupWrapper);
                    _this.popupObj.refreshPosition(_this.inputElement);
                    var openAnimation = {
                        name: "FadeIn",
                        duration: (0, $5q7BP.Browser).isDevice ? 0 : $d5f6934cad42758d$var$OPENDURATION
                    };
                    if (_this.zIndex === 1000) _this.popupObj.show(new (0, $kj1BR.Animation)(openAnimation), _this.element);
                    else _this.popupObj.show(new (0, $kj1BR.Animation)(openAnimation), null);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _super.prototype.setOverlayIndex.call(_this, _this.mobilePopupWrapper, _this.popupObj.element, _this.modal, (0, $5q7BP.Browser).isDevice);
                    _this.setAriaAttributes();
                } else {
                    _this.popupObj.destroy();
                    _this.popupWrapper = _this.popupObj = null;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(_this.inputElement) && _this.inputElement.value === "") {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.tableBodyElement) && _this.tableBodyElement.querySelectorAll("td.e-selected").length > 0) {
                        (0, $4ZDHT.addClass)([
                            _this.tableBodyElement.querySelector("td.e-selected")
                        ], $d5f6934cad42758d$var$FOCUSEDDATE);
                        (0, $4ZDHT.removeClass)(_this.tableBodyElement.querySelectorAll("td.e-selected"), $d5f6934cad42758d$var$SELECTED);
                    }
                }
                (0, $aqzbR.EventHandler).add(document, "mousedown touchstart", _this.documentHandler, _this);
            });
            if ((0, $5q7BP.Browser).isDevice) {
                var dlgOverlay = this.createElement("div", {
                    className: "e-dlg-overlay"
                });
                dlgOverlay.style.zIndex = (this.zIndex - 1).toString();
                this.mobilePopupWrapper.appendChild(dlgOverlay);
            }
        }
    };
    /**
     * Hide the Calendar.
     *
     * @returns {void}

     */ DatePicker.prototype.hide = function(event) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) {
            var prevent_2 = true;
            this.preventArgs = {
                preventDefault: function() {
                    prevent_2 = false;
                },
                popup: this.popupObj,
                event: event || null,
                cancel: false
            };
            (0, $4ZDHT.removeClass)(this.inputWrapper.buttons, $d5f6934cad42758d$var$ACTIVE);
            (0, $4ZDHT.removeClass)([
                document.body
            ], $d5f6934cad42758d$var$OVERFLOW);
            var eventArgs = this.preventArgs;
            if (this.isCalendar()) this.trigger("close", eventArgs, function(eventArgs) {
                _this.closeEventCallback(prevent_2, eventArgs);
            });
            else this.closeEventCallback(prevent_2, eventArgs);
        } else {
            if ((0, $5q7BP.Browser).isDevice && this.allowEdit && !this.readonly) this.inputElement.removeAttribute("readonly");
            this.setAllowEdit();
        }
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-param */ DatePicker.prototype.closeEventCallback = function(prevent, eventArgs) {
        this.preventArgs = eventArgs;
        if (this.isCalendar() && prevent && !this.preventArgs.cancel) {
            this.popupObj.hide();
            this.isAltKeyPressed = false;
            this.keyboardModule.destroy();
            (0, $4ZDHT.removeClass)(this.inputWrapper.buttons, $d5f6934cad42758d$var$ACTIVE);
        }
        this.setAriaAttributes();
        if ((0, $5q7BP.Browser).isDevice && this.modal) {
            this.modal.style.display = "none";
            this.modal.outerHTML = "";
            this.modal = null;
        }
        if ((0, $5q7BP.Browser).isDevice) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.mobilePopupWrapper) && prevent && ((0, $3EnZW.isNullOrUndefined)(this.preventArgs) || !this.preventArgs.cancel)) {
                this.mobilePopupWrapper.remove();
                this.mobilePopupWrapper = null;
            }
        }
        (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", this.documentHandler);
        if ((0, $5q7BP.Browser).isDevice && this.allowEdit && !this.readonly) this.inputElement.removeAttribute("readonly");
        this.setAllowEdit();
    };
    /* eslint-disable jsdoc/require-param */ /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DatePicker.prototype.focusIn = function(triggerEvent) {
        if (document.activeElement !== this.inputElement && this.enabled) {
            this.inputElement.focus();
            (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], [
                $d5f6934cad42758d$var$INPUTFOCUS
            ]);
        }
    };
    /* eslint-enable jsdoc/require-param */ /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ DatePicker.prototype.focusOut = function() {
        if (document.activeElement === this.inputElement) {
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], [
                $d5f6934cad42758d$var$INPUTFOCUS
            ]);
            this.inputElement.blur();
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the current view of the DatePicker.
     *
     * @returns {string}

     */ DatePicker.prototype.currentView = function() {
        var currentView;
        if (this.calendarElement) // calls the Calendar currentView public method
        currentView = _super.prototype.currentView.call(this);
        return currentView;
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Navigates to specified month or year or decade view of the DatePicker.
     *
     * @param  {string} view - Specifies the view of the calendar.
     * @param  {Date} date - Specifies the focused date in a view.
     * @returns {void}

     */ DatePicker.prototype.navigateTo = function(view, date) {
        if (this.calendarElement) // calls the Calendar navigateTo public method
        _super.prototype.navigateTo.call(this, view, date);
    };
    /**
     * To destroy the widget.
     *
     * @returns {void}
     */ DatePicker.prototype.destroy = function() {
        this.unBindEvents();
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        _super.prototype.destroy.call(this);
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.inputElement,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        if (!(0, $3EnZW.isNullOrUndefined)(this.keyboardModules)) this.keyboardModules.destroy();
        if (this.popupObj && this.popupObj.element.classList.contains($d5f6934cad42758d$var$POPUP)) _super.prototype.destroy.call(this);
        var ariaAttrs = {
            "aria-atomic": "true",
            "aria-disabled": "true",
            "aria-expanded": "false",
            "role": "combobox",
            "autocomplete": "off",
            "autocorrect": "off",
            "autocapitalize": "off",
            "spellcheck": "false"
        };
        if (this.inputElement.hasAttribute("aria-label")) this.inputElement.removeAttribute("aria-label");
        if (this.inputElement) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeAttributes(ariaAttrs, this.inputElement);
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputElementCopy.getAttribute("tabindex"))) this.inputElement.setAttribute("tabindex", this.tabIndex);
            else this.inputElement.removeAttribute("tabindex");
            (0, $aqzbR.EventHandler).remove(this.inputElement, "blur", this.inputBlurHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.inputFocusHandler);
            this.ensureInputAttribute();
        }
        if (this.isCalendar()) {
            if (this.popupWrapper) (0, $4ZDHT.detach)(this.popupWrapper);
            this.popupObj = this.popupWrapper = null;
            this.keyboardModule.destroy();
        }
        if (this.ngTag === null) {
            if (this.inputElement) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper)) this.inputWrapper.container.insertAdjacentElement("afterend", this.inputElement);
                (0, $4ZDHT.removeClass)([
                    this.inputElement
                ], [
                    $d5f6934cad42758d$var$INPUTROOT
                ]);
            }
            (0, $4ZDHT.removeClass)([
                this.element
            ], [
                $d5f6934cad42758d$var$ROOT
            ]);
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper)) (0, $4ZDHT.detach)(this.inputWrapper.container);
        }
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.resetFormHandler);
        this.inputWrapper = null;
        this.keyboardModules = null;
    };
    DatePicker.prototype.ensureInputAttribute = function() {
        var prop = [];
        for(var i = 0; i < this.inputElement.attributes.length; i++)prop[i] = this.inputElement.attributes[i].name;
        for(var i = 0; i < prop.length; i++)if ((0, $3EnZW.isNullOrUndefined)(this.inputElementCopy.getAttribute(prop[i]))) {
            if (prop[i].toLowerCase() === "value") this.inputElement.value = "";
            this.inputElement.removeAttribute(prop[i]);
        } else {
            if (prop[i].toLowerCase() === "value") this.inputElement.value = this.inputElementCopy.getAttribute(prop[i]);
            this.inputElement.setAttribute(prop[i], this.inputElementCopy.getAttribute(prop[i]));
        }
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */ DatePicker.prototype.preRender = function() {
        this.inputElementCopy = this.element.cloneNode(true);
        (0, $4ZDHT.removeClass)([
            this.inputElementCopy
        ], [
            $d5f6934cad42758d$var$ROOT,
            $d5f6934cad42758d$var$CONTROL,
            $d5f6934cad42758d$var$LIBRARY
        ]);
        this.inputElement = this.element;
        this.formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
        this.index = this.showClearButton ? 2 : 1;
        this.ngTag = null;
        if (this.element.tagName === "EJS-DATEPICKER" || this.element.tagName === "EJS-DATETIMEPICKER") {
            this.ngTag = this.element.tagName;
            this.inputElement = this.createElement("input");
            this.element.appendChild(this.inputElement);
        }
        if (this.element.getAttribute("id")) {
            if (this.ngTag !== null) this.inputElement.id = this.element.getAttribute("id") + "_input";
        } else if (this.getModuleName() === "datetimepicker") {
            this.element.id = (0, $3EnZW.getUniqueID)("ej2-datetimepicker");
            if (this.ngTag !== null) (0, $4ZDHT.attributes)(this.inputElement, {
                "id": this.element.id + "_input"
            });
        } else {
            this.element.id = (0, $3EnZW.getUniqueID)("ej2-datepicker");
            if (this.ngTag !== null) (0, $4ZDHT.attributes)(this.inputElement, {
                "id": this.element.id + "_input"
            });
        }
        if (this.ngTag !== null) this.validationAttribute(this.element, this.inputElement);
        this.updateHtmlAttributeToElement();
        this.defaultKeyConfigs = this.getDefaultKeyConfig();
        this.checkHtmlAttributes(false);
        this.tabIndex = this.element.hasAttribute("tabindex") ? this.element.getAttribute("tabindex") : "0";
        this.element.removeAttribute("tabindex");
        _super.prototype.preRender.call(this);
    };
    DatePicker.prototype.getDefaultKeyConfig = function() {
        this.defaultKeyConfigs = {
            altUpArrow: "alt+uparrow",
            altDownArrow: "alt+downarrow",
            escape: "escape",
            enter: "enter",
            controlUp: "ctrl+38",
            controlDown: "ctrl+40",
            moveDown: "downarrow",
            moveUp: "uparrow",
            moveLeft: "leftarrow",
            moveRight: "rightarrow",
            select: "enter",
            home: "home",
            end: "end",
            pageUp: "pageup",
            pageDown: "pagedown",
            shiftPageUp: "shift+pageup",
            shiftPageDown: "shift+pagedown",
            controlHome: "ctrl+home",
            controlEnd: "ctrl+end",
            shiftTab: "shift+tab",
            tab: "tab"
        };
        return this.defaultKeyConfigs;
    };
    DatePicker.prototype.validationAttribute = function(target, inputElement) {
        var nameAttribute = target.getAttribute("name") ? target.getAttribute("name") : target.getAttribute("id");
        inputElement.setAttribute("name", nameAttribute);
        target.removeAttribute("name");
        var attribute = [
            "required",
            "aria-required",
            "form"
        ];
        for(var i = 0; i < attribute.length; i++){
            if ((0, $3EnZW.isNullOrUndefined)(target.getAttribute(attribute[i]))) continue;
            var attr = target.getAttribute(attribute[i]);
            inputElement.setAttribute(attribute[i], attr);
            target.removeAttribute(attribute[i]);
        }
    };
    DatePicker.prototype.checkFormat = function() {
        var culture = new (0, $bWDaN.Internationalization)(this.locale);
        if (this.format) {
            if (typeof this.format === "string") this.formatString = this.format;
            else if (this.format.skeleton !== "" && !(0, $3EnZW.isNullOrUndefined)(this.format.skeleton)) {
                var skeletonString = this.format.skeleton;
                if (this.getModuleName() === "datetimepicker") this.formatString = culture.getDatePattern({
                    skeleton: skeletonString,
                    type: "dateTime"
                });
                else this.formatString = culture.getDatePattern({
                    skeleton: skeletonString,
                    type: "date"
                });
            } else if (this.getModuleName() === "datetimepicker") this.formatString = this.dateTimeFormat;
            else this.formatString = null;
        } else this.formatString = null;
    };
    DatePicker.prototype.checkHtmlAttributes = function(dynamic) {
        this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
        this.checkFormat();
        this.checkView();
        var attributes = dynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "value",
            "min",
            "max",
            "disabled",
            "readonly",
            "style",
            "name",
            "placeholder",
            "type"
        ];
        var options;
        if (this.getModuleName() === "datetimepicker") {
            if (this.calendarMode === "Gregorian") options = {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd"
            };
            else options = {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
        } else if (this.calendarMode === "Gregorian") options = {
            format: this.formatString,
            type: "dateTime",
            skeleton: "yMd"
        };
        else options = {
            format: this.formatString,
            type: "dateTime",
            skeleton: "yMd",
            calendar: "islamic"
        };
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var prop = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute(prop))) switch(prop){
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.datepickerOptions) || this.datepickerOptions["enabled"] === undefined || dynamic) {
                        var enabled = this.inputElement.getAttribute(prop) === "disabled" || this.inputElement.getAttribute(prop) === "" || this.inputElement.getAttribute(prop) === "true" ? false : true;
                        this.setProperties({
                            enabled: enabled
                        }, !dynamic);
                    }
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.datepickerOptions) || this.datepickerOptions["readonly"] === undefined || dynamic) {
                        var readonly = this.inputElement.getAttribute(prop) === "readonly" || this.inputElement.getAttribute(prop) === "" || this.inputElement.getAttribute(prop) === "true" ? true : false;
                        this.setProperties({
                            readonly: readonly
                        }, !dynamic);
                    }
                    break;
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.datepickerOptions) || this.datepickerOptions["placeholder"] === undefined || dynamic) this.setProperties({
                        placeholder: this.inputElement.getAttribute(prop)
                    }, !dynamic);
                    break;
                case "style":
                    this.inputElement.setAttribute("style", "" + this.inputElement.getAttribute(prop));
                    break;
                case "name":
                    this.inputElement.setAttribute("name", "" + this.inputElement.getAttribute(prop));
                    break;
                case "value":
                    if ((0, $3EnZW.isNullOrUndefined)(this.datepickerOptions) || this.datepickerOptions["value"] === undefined || dynamic) {
                        var value = this.inputElement.getAttribute(prop);
                        this.setProperties((0, $3EnZW.setValue)(prop, this.globalize.parseDate(this.getAmPmValue(value), options), {}), !dynamic);
                    }
                    break;
                case "min":
                    if (+this.min === +new Date(1900, 0, 1) || dynamic) {
                        var min = this.inputElement.getAttribute(prop);
                        this.setProperties((0, $3EnZW.setValue)(prop, this.globalize.parseDate(this.getAmPmValue(min), options), {}), !dynamic);
                    }
                    break;
                case "max":
                    if (+this.max === +new Date(2099, 11, 31) || dynamic) {
                        var max = this.inputElement.getAttribute(prop);
                        this.setProperties((0, $3EnZW.setValue)(prop, this.globalize.parseDate(this.getAmPmValue(max), options), {}), !dynamic);
                    }
                    break;
                case "type":
                    if (this.inputElement.getAttribute(prop) !== "text") this.inputElement.setAttribute("type", "text");
                    break;
            }
        }
    };
    /**
     * To get component name.
     *
     * @returns {string} Returns the component name.
     * @private
     */ DatePicker.prototype.getModuleName = function() {
        return "datepicker";
    };
    DatePicker.prototype.disabledDates = function(isDynamic, isBlur) {
        if (isDynamic === void 0) isDynamic = false;
        if (isBlur === void 0) isBlur = false;
        var formatOptions;
        var globalize;
        var valueCopy = this.checkDateValue(this.value) ? new Date(+this.value) : new Date(this.checkValue(this.value));
        var previousValCopy = this.previousDate;
        //calls the Calendar render method to check the disabled dates through renderDayCell event and update the input value accordingly.
        this.minMaxUpdates();
        if (!isDynamic || isDynamic && !(0, $3EnZW.isNullOrUndefined)(this.renderDayCell)) _super.prototype.render.call(this);
        this.previousDate = previousValCopy;
        var date = valueCopy && +valueCopy;
        var dateIdString = '*[id^="/id"]'.replace("/id", "" + date);
        if (!this.strictMode) {
            if (typeof this.value === "string" || typeof this.value === "object" && +this.value !== +valueCopy) this.setProperties({
                value: valueCopy
            }, true);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.calendarElement) && !(0, $3EnZW.isNullOrUndefined)(this.calendarElement.querySelectorAll(dateIdString)[0])) {
            if (this.calendarElement.querySelectorAll(dateIdString)[0].classList.contains("e-disabled")) {
                if (!this.strictMode) this.currentDate = new Date(new Date().setHours(0, 0, 0, 0));
            }
        }
        var inputVal;
        if (this.getModuleName() === "datetimepicker") {
            if (this.calendarMode === "Gregorian") globalize = this.globalize.formatDate(valueCopy, {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd"
            });
            else globalize = this.globalize.formatDate(valueCopy, {
                format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.dateTimeFormat,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            });
            inputVal = globalize;
        } else {
            if (this.calendarMode === "Gregorian") formatOptions = {
                format: this.formatString,
                type: "dateTime",
                skeleton: "yMd"
            };
            else formatOptions = {
                format: this.formatString,
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
            inputVal = this.globalize.formatDate(valueCopy, formatOptions);
        }
        if (!this.popupObj) {
            this.updateInputValue(inputVal);
            if (this.enableMask) {
                this.updateInputValue(this.maskedDateValue);
                this.notify("createMask", {
                    module: "MaskedDateTime",
                    isBlur: isBlur
                });
            }
        }
    };
    DatePicker.prototype.setAriaAttributes = function() {
        if (this.isCalendar()) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).addAttributes({
                "aria-expanded": "true"
            }, this.inputElement);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-owns": this.inputElement.id + "_options"
            });
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-controls": this.inputElement.id
            });
            if (this.value) (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-activedescendant": "" + this.setActiveDescendant()
            });
        } else {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).addAttributes({
                "aria-expanded": "false"
            }, this.inputElement);
            this.inputElement.removeAttribute("aria-owns");
            this.inputElement.removeAttribute("aria-controls");
            this.inputElement.removeAttribute("aria-activedescendant");
        }
    };
    DatePicker.prototype.errorClass = function() {
        var dateIdString = '*[id^="/id"]'.replace("/id", "" + +this.value);
        var isDisabledDate = this.calendarElement && this.calendarElement.querySelectorAll(dateIdString)[0] && this.calendarElement.querySelectorAll(dateIdString)[0].classList.contains("e-disabled");
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && !(0, $3EnZW.isNullOrUndefined)(this.min) && !(0, $3EnZW.isNullOrUndefined)(this.max) && !(new Date(this.value).setMilliseconds(0) >= new Date(this.min).setMilliseconds(0) && new Date(this.value).setMilliseconds(0) <= new Date(this.max).setMilliseconds(0)) || !this.strictMode && this.inputElement.value !== "" && this.inputElement.value !== this.maskedDateValue && (0, $3EnZW.isNullOrUndefined)(this.value) || isDisabledDate || !this.isValidTime(this.value)) {
            (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], $d5f6934cad42758d$var$ERROR);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-invalid": "true"
            });
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper)) {
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], $d5f6934cad42758d$var$ERROR);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-invalid": "false"
            });
        }
    };
    DatePicker.prototype.isValidTime = function(value) {
        return true;
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {DatePickerModel} newProp - Returns the dynamic property value of the component.
     * @param {DatePickerModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ DatePicker.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            var openPopup = [
                "blur",
                "change",
                "cleared",
                "close",
                "created",
                "destroyed",
                "focus",
                "navigated",
                "open",
                "renderDayCell"
            ];
            if (openPopup.indexOf(prop) > 0 && this.isReact) this.isDynamicValueChanged = true;
            switch(prop){
                case "value":
                    this.isDynamicValueChanged = true;
                    this.isInteracted = false;
                    this.invalidValueString = null;
                    this.checkInvalidValue(newProp.value);
                    newProp.value = this.value;
                    this.previousElementValue = this.inputElement.value;
                    if ((0, $3EnZW.isNullOrUndefined)(this.value)) {
                        if (this.enableMask) this.updateInputValue(this.maskedDateValue);
                        else this.updateInputValue("");
                        this.currentDate = new Date(new Date().setHours(0, 0, 0, 0));
                    }
                    this.updateInput(true);
                    if (+this.previousDate !== +this.value) this.changeTrigger(null);
                    this.isInteracted = true;
                    this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
                    if (this.enableMask) this.notify("createMask", {
                        module: "MaskedDateTime"
                    });
                    break;
                case "format":
                    this.checkFormat();
                    this.bindInputEvent();
                    this.updateInput();
                    if (this.enableMask) {
                        this.notify("createMask", {
                            module: "MaskedDateTime"
                        });
                        if (!this.value) this.updateInputValue(this.maskedDateValue);
                    }
                    break;
                case "allowEdit":
                    this.setAllowEdit();
                    break;
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.inputElement);
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.inputElement);
                    break;
                case "enabled":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.inputElement);
                    this.setAriaDisabled();
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttributeToElement();
                    this.updateHtmlAttributeToWrapper();
                    this.checkHtmlAttributes(true);
                    break;
                case "locale":
                    this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
                    this.l10n.setLocale(this.locale);
                    if (this.datepickerOptions && this.datepickerOptions.placeholder == null) {
                        this.setProperties({
                            placeholder: this.l10n.getConstant("placeholder")
                        }, true);
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.inputElement);
                    }
                    this.updateInput();
                    if (this.enableMask) this.notify("createMask", {
                        module: "MaskedDateTime"
                    });
                    break;
                case "enableRtl":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(this.enableRtl, [
                        this.inputWrapper.container
                    ]);
                    break;
                case "start":
                case "depth":
                    this.checkView();
                    if (this.calendarElement) _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
                    break;
                case "zIndex":
                    this.setProperties({
                        zIndex: newProp.zIndex
                    }, true);
                    break;
                case "cssClass":
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case "showClearButton":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(this.showClearButton, this.inputElement, this.inputWrapper);
                    this.bindClearEvent();
                    this.index = this.showClearButton ? 2 : 1;
                    break;
                case "strictMode":
                    this.invalidValueString = null;
                    this.updateInput();
                    break;
                case "width":
                    this.setWidth(newProp.width);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                    break;
                case "floatLabelType":
                    this.floatLabelType = newProp.floatLabelType;
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.inputWrapper);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.inputElement, this.floatLabelType, this.placeholder);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                    break;
                case "enableMask":
                    if (this.enableMask) {
                        this.notify("createMask", {
                            module: "MaskedDateTime"
                        });
                        this.updateInputValue(this.maskedDateValue);
                        this.bindInputEvent();
                    } else if (this.inputElement.value === this.maskedDateValue) this.updateInputValue("");
                    break;
                default:
                    if (this.calendarElement && this.isCalendar()) _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
                    break;
            }
            if (!this.isDynamicValueChanged) this.hide(null);
            this.isDynamicValueChanged = false;
        }
    };
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "width", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "value", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "cssClass", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "strictMode", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "format", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DatePicker.prototype, "enabled", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "fullScreenMode", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)({})
    ], DatePicker.prototype, "htmlAttributes", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "values", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "isMultiSelection", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DatePicker.prototype, "showClearButton", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DatePicker.prototype, "allowEdit", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "keyConfigs", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "enablePersistence", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], DatePicker.prototype, "zIndex", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "readonly", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "placeholder", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], DatePicker.prototype, "floatLabelType", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DatePicker.prototype, "serverTimezoneOffset", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "openOnFocus", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DatePicker.prototype, "enableMask", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Property)({
            day: "day",
            month: "month",
            year: "year",
            hour: "hour",
            minute: "minute",
            second: "second",
            dayOfTheWeek: "day of the week"
        })
    ], DatePicker.prototype, "maskPlaceholder", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "open", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "cleared", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "close", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "blur", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "focus", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "created", void 0);
    $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.Event)()
    ], DatePicker.prototype, "destroyed", void 0);
    DatePicker = $d5f6934cad42758d$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], DatePicker);
    return DatePicker;
}((0, $1d370936294fcc88$export$e1aef45b828286de));




parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");

/** @hidden */ var $17b89d3b1fc93cdb$export$2e3d29103780bd37 = "create";
var $17b89d3b1fc93cdb$export$ee16d7cb334f2c25 = "destroy";
var $17b89d3b1fc93cdb$export$11e63f7b0f3d9900 = "load";
var $17b89d3b1fc93cdb$export$7528dc9435097481 = "rowDataBound";
var $17b89d3b1fc93cdb$export$7a849352d4f0bf7b = "queryCellInfo";
var $17b89d3b1fc93cdb$export$c72883aa0a0b0dc9 = "headerCellInfo";
var $17b89d3b1fc93cdb$export$df204737a6131aab = "actionBegin";
var $17b89d3b1fc93cdb$export$830631a3cb598490 = "actionComplete";
var $17b89d3b1fc93cdb$export$6df5a05f342711e3 = "actionFailure";
var $17b89d3b1fc93cdb$export$a04129a54dd9eaf2 = "dataBound";
var $17b89d3b1fc93cdb$export$f44ea1c4fd45e709 = "rowSelecting";
var $17b89d3b1fc93cdb$export$547c6771ab2f0fc5 = "rowSelected";
var $17b89d3b1fc93cdb$export$fd7be91b8e06050 = "rowDeselecting";
var $17b89d3b1fc93cdb$export$14e00a934586ea7b = "rowDeselected";
var $17b89d3b1fc93cdb$export$b38edb82895c7fcf = "cellSelecting";
var $17b89d3b1fc93cdb$export$5ce057a02585195d = "cellSelected";
var $17b89d3b1fc93cdb$export$ddb5b152fc2e4709 = "cellDeselecting";
var $17b89d3b1fc93cdb$export$103fc9af7fdf4985 = "cellDeselected";
var $17b89d3b1fc93cdb$export$81e76a668f94b6d8 = "columnSelecting";
var $17b89d3b1fc93cdb$export$b4e257dd92fec7b1 = "columnSelected";
var $17b89d3b1fc93cdb$export$9491b2dd79aacca2 = "columnDeselecting";
var $17b89d3b1fc93cdb$export$10e5a36803dd4c24 = "columnDeselected";
var $17b89d3b1fc93cdb$export$e7b0ce279c912385 = "columnDragStart";
var $17b89d3b1fc93cdb$export$ccfabd9386eb4ea2 = "columnDrag";
var $17b89d3b1fc93cdb$export$553a7dc8a546fa4c = "columnDrop";
var $17b89d3b1fc93cdb$export$ff55968580c2b8e7 = "rowDragStartHelper";
var $17b89d3b1fc93cdb$export$2d7b6ea514b2adac = "rowDragStart";
var $17b89d3b1fc93cdb$export$435be585436fd96d = "rowDrag";
var $17b89d3b1fc93cdb$export$7c09f105bf93b024 = "rowDrop";
var $17b89d3b1fc93cdb$export$239eb85392ed959a = "beforePrint";
var $17b89d3b1fc93cdb$export$2b7078dd4f4e226a = "printComplete";
var $17b89d3b1fc93cdb$export$6af477339269af99 = "detailDataBound";
var $17b89d3b1fc93cdb$export$56b876c24dda3084 = "toolbarClick";
var $17b89d3b1fc93cdb$export$32c7bb9403361dde = "batchAdd";
var $17b89d3b1fc93cdb$export$da4cf21ede5d704e = "batchCancel";
var $17b89d3b1fc93cdb$export$290fe11ec3c54640 = "batchDelete";
var $17b89d3b1fc93cdb$export$f9c61176b82bfaef = "beforeBatchAdd";
var $17b89d3b1fc93cdb$export$4a933062eae30007 = "beforeBatchDelete";
var $17b89d3b1fc93cdb$export$e0e7b17b6014f491 = "beforeBatchSave";
var $17b89d3b1fc93cdb$export$e4120247b9ae7d04 = "beginEdit";
var $17b89d3b1fc93cdb$export$fc689bb5b676c23 = "cellEdit";
var $17b89d3b1fc93cdb$export$7f2038a7068d332a = "cellSave";
var $17b89d3b1fc93cdb$export$2d26cfa8dfa27606 = "cellSaved";
var $17b89d3b1fc93cdb$export$5d78e37051b50249 = "endAdd";
var $17b89d3b1fc93cdb$export$4c3e27d7fde720b5 = "endDelete";
var $17b89d3b1fc93cdb$export$7510514f179a601f = "endEdit";
var $17b89d3b1fc93cdb$export$97f77ca7385478dc = "recordDoubleClick";
var $17b89d3b1fc93cdb$export$2c9eb917b6993180 = "recordClick";
var $17b89d3b1fc93cdb$export$b59f29322b4450c6 = "beforeDataBound";
var $17b89d3b1fc93cdb$export$1ba26bc61ad01b07 = "beforeOpenColumnChooser";
var $17b89d3b1fc93cdb$export$5ea7d2089851ef30 = "beforeOpenAdaptiveDialog";
var $17b89d3b1fc93cdb$export$6aff6a45c0c4e7c4 = "resizeStart";
var $17b89d3b1fc93cdb$export$45b39e67d4ce4921 = "resizing";
var $17b89d3b1fc93cdb$export$8c4d3b559babc6db = "resizeStop";
var $17b89d3b1fc93cdb$export$a5f23337b8be1397 = "checkBoxChange";
var $17b89d3b1fc93cdb$export$2e00246183f332a2 = "beforeCopy";
var $17b89d3b1fc93cdb$export$8f6d6233f3016d36 = "beforePaste";
var $17b89d3b1fc93cdb$export$f270b6744c50ca0e = "beforeAutoFill";
var $17b89d3b1fc93cdb$export$dd083bccb8aaee05 = "filterchoicerequest";
var $17b89d3b1fc93cdb$export$cd06942d33b49aad = "filterAfterOpen";
var $17b89d3b1fc93cdb$export$a23907baab3479c2 = "filterBeforeOpen";
var $17b89d3b1fc93cdb$export$cbe36cdf89a5e152 = "filterSearchBegin";
var $17b89d3b1fc93cdb$export$28522a4404df7093 = "commandClick";
var $17b89d3b1fc93cdb$export$43919fe2f0396d45 = "exportGroupCaption";
var $17b89d3b1fc93cdb$export$a48ca5500d7db0ed = "lazyLoadGroupExpand";
var $17b89d3b1fc93cdb$export$538fa13d261bed64 = "lazyLoadGroupCollapse";
var $17b89d3b1fc93cdb$export$b70fe0c8c3456154 = "initial-load";
var $17b89d3b1fc93cdb$export$5d4840440f592fca = "initial-end";
var $17b89d3b1fc93cdb$export$32ed53e78850bc76 = "data-ready";
var $17b89d3b1fc93cdb$export$f44d9209b353bf3e = "content-ready";
var $17b89d3b1fc93cdb$export$27ad5926bed65d9 = "ui-update";
var $17b89d3b1fc93cdb$export$63287e93462800a4 = "on-empty";
var $17b89d3b1fc93cdb$export$f4000f83c4e293d0 = "inbound-model-changed";
var $17b89d3b1fc93cdb$export$80cded91831c5507 = "model-changed";
var $17b89d3b1fc93cdb$export$dd9331973c9310ae = "colgroup-refresh";
var $17b89d3b1fc93cdb$export$265a66bcae9d11dd = "header-refreshed";
var $17b89d3b1fc93cdb$export$662828734ba1abec = "paging-begin";
var $17b89d3b1fc93cdb$export$f8b3c4e59d5a531a = "paging-complete";
var $17b89d3b1fc93cdb$export$de6eb25ce9b07c0 = "sorting-begin";
var $17b89d3b1fc93cdb$export$157fcb0735825622 = "sorting-complete";
var $17b89d3b1fc93cdb$export$2568b985d3403ddf = "filtering-begin";
var $17b89d3b1fc93cdb$export$cc6e6748dbb9bba9 = "filtering-complete";
var $17b89d3b1fc93cdb$export$5a5b49f95eb58d24 = "searching-begin";
var $17b89d3b1fc93cdb$export$93675ce65bb4868f = "searching-complete";
var $17b89d3b1fc93cdb$export$5797d375cf958a3b = "reorder-begin";
var $17b89d3b1fc93cdb$export$82efde204a1957f2 = "reorder-complete";
var $17b89d3b1fc93cdb$export$e6089491315b0258 = "rowdraganddrop-begin";
var $17b89d3b1fc93cdb$export$a1354899ac0c7d01 = "rowdraganddrop-complete";
var $17b89d3b1fc93cdb$export$22a72906c95f283d = "grouping-begin";
var $17b89d3b1fc93cdb$export$45acafeece38b8a2 = "grouping-complete";
var $17b89d3b1fc93cdb$export$683eadab45ed2e88 = "ungrouping-begin";
var $17b89d3b1fc93cdb$export$9bcde1a530e0aaf1 = "ungrouping-complete";
var $17b89d3b1fc93cdb$export$7102324ec21b2ea7 = "group-aggregates";
var $17b89d3b1fc93cdb$export$14053228fa0745d8 = "refresh-footer-rendered";
var $17b89d3b1fc93cdb$export$195df17369c093a1 = "refresh-aggregate-cell";
var $17b89d3b1fc93cdb$export$29fbb5f95d18041d = "refresh-aggregates";
var $17b89d3b1fc93cdb$export$1407d7a0da490aaa = "rowselecting";
var $17b89d3b1fc93cdb$export$19203d5d8509aaa9 = "rowselected";
var $17b89d3b1fc93cdb$export$3f2b247db91ef245 = "columnselecting";
var $17b89d3b1fc93cdb$export$a315cbd110333ca = "columnselected";
var $17b89d3b1fc93cdb$export$3533bd07203efd26 = "cellselecting";
var $17b89d3b1fc93cdb$export$786880bfe8c92895 = "cellselected";
var $17b89d3b1fc93cdb$export$5876580e0ddf0aa4 = "destroy-autofill-elements";
var $17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0 = "beforecellfocused";
var $17b89d3b1fc93cdb$export$859ade0ced56eb99 = "cellfocused";
var $17b89d3b1fc93cdb$export$e09b512eecac7579 = "key-pressed";
var $17b89d3b1fc93cdb$export$64ef1bee2b9504c1 = "click";
var $17b89d3b1fc93cdb$export$b1fb4cac938035f7 = "destroy";
var $17b89d3b1fc93cdb$export$c480fa254fb70e72 = "column-visible-changed";
var $17b89d3b1fc93cdb$export$209876d7b1ac8f3 = "scroll";
var $17b89d3b1fc93cdb$export$deabcf5530617ea3 = "column-width-changed";
var $17b89d3b1fc93cdb$export$cd2e9ca316e8efca = "column-position-changed";
var $17b89d3b1fc93cdb$export$89b6562ba0b38ce3 = "row-drag-and-drop";
var $17b89d3b1fc93cdb$export$7a9fe616f081a21e = "rows-added";
var $17b89d3b1fc93cdb$export$15a612017ee5398c = "rows-removed";
var $17b89d3b1fc93cdb$export$d8cb7828e3a46f05 = "column-drag-stop";
var $17b89d3b1fc93cdb$export$b0a9271d3fcee092 = "header-drop";
var $17b89d3b1fc93cdb$export$a8ad22510e401e59 = "datasource-modified";
var $17b89d3b1fc93cdb$export$ae8f3774777d16d3 = "refresh-complete";
var $17b89d3b1fc93cdb$export$68c56a16fdd92a5 = "refresh-virtual-block";
var $17b89d3b1fc93cdb$export$efb8dd8d61939266 = "dblclick";
var $17b89d3b1fc93cdb$export$6a017cfaa3b33c68 = "toolbar-refresh";
var $17b89d3b1fc93cdb$export$b53da9940f8876f4 = "bulk-save";
var $17b89d3b1fc93cdb$export$bb86da570a7327af = "auto-col";
var $17b89d3b1fc93cdb$export$7edde809d061e = "tooltip-destroy";
var $17b89d3b1fc93cdb$export$3bf0495508a61ee = "update-data";
var $17b89d3b1fc93cdb$export$904d43c26f57855d = "edit-begin";
var $17b89d3b1fc93cdb$export$3cd9d5f1b28a5c2f = "edit-complete";
var $17b89d3b1fc93cdb$export$effc604548592ac9 = "add-begin";
var $17b89d3b1fc93cdb$export$ad4bef6754c2d8ee = "add-complete";
var $17b89d3b1fc93cdb$export$628350d303d1eea6 = "save-complete";
var $17b89d3b1fc93cdb$export$fec1f7aeb7be7f46 = "delete-begin";
var $17b89d3b1fc93cdb$export$a7f69ca3248694c5 = "delete-complete";
var $17b89d3b1fc93cdb$export$df7abab87e90ad9b = "prevent-batch";
var $17b89d3b1fc93cdb$export$552ed46ea2685f10 = "dialog-destroy";
var $17b89d3b1fc93cdb$export$a8508f3e3cbfd48b = "crud-Action";
var $17b89d3b1fc93cdb$export$3c545d3a48cc1b2f = "add-delete-Action";
var $17b89d3b1fc93cdb$export$91074a49a0f64311 = "destroy-form";
var $17b89d3b1fc93cdb$export$cfa10a7feffa0766 = "double-tap";
var $17b89d3b1fc93cdb$export$fc33b9b4a870b862 = "beforeExcelExport";
var $17b89d3b1fc93cdb$export$dfb371c8ddbf1a2c = "excelExportComplete";
var $17b89d3b1fc93cdb$export$daa4bec6e7025493 = "excelQueryCellInfo";
var $17b89d3b1fc93cdb$export$c2c4a3442a2ab768 = "excelHeaderQueryCellInfo";
var $17b89d3b1fc93cdb$export$47abd346227d718b = "exportDetailDataBound";
var $17b89d3b1fc93cdb$export$4807207a16495a60 = "exportDetailTemplate";
var $17b89d3b1fc93cdb$export$f9f9dd98810deee = "beforePdfExport";
var $17b89d3b1fc93cdb$export$7a8d89800dc1933f = "pdfExportComplete";
var $17b89d3b1fc93cdb$export$e994f1ebdba13290 = "pdfQueryCellInfo";
var $17b89d3b1fc93cdb$export$1e87179d61662966 = "pdfHeaderQueryCellInfo";
var $17b89d3b1fc93cdb$export$df765c2bdb30c21c = "access-predicate";
var $17b89d3b1fc93cdb$export$d21e637e8c1f5e9d = "contextMenuClick";
var $17b89d3b1fc93cdb$export$5f16ec1d7f7bf943 = "freezerender";
var $17b89d3b1fc93cdb$export$44e657841681036 = "freezerefresh";
var $17b89d3b1fc93cdb$export$f34b303782c25f4 = "contextMenuOpen";
var $17b89d3b1fc93cdb$export$6d34ba823d0e33f7 = "columnMenuClick";
var $17b89d3b1fc93cdb$export$c78568a485accad6 = "columnMenuOpen";
var $17b89d3b1fc93cdb$export$bdff1bc700cd682b = "filterOpen";
var $17b89d3b1fc93cdb$export$4cc1ec161750f031 = "filterDialogCreated";
var $17b89d3b1fc93cdb$export$64f956c4dbd84d3b = "filter-menu-close";
var $17b89d3b1fc93cdb$export$fe0819b09824c208 = "initForeignKeyColumn";
var $17b89d3b1fc93cdb$export$8c378ad6a18d0e6f = "getForeignKeyData";
var $17b89d3b1fc93cdb$export$40afe28aee4686d4 = "generateQuery";
var $17b89d3b1fc93cdb$export$5254084c06ba0d7f = "showEmptyGrid";
var $17b89d3b1fc93cdb$export$4e76384d33160ddd = "foreignKeyData";
var $17b89d3b1fc93cdb$export$58561f15ab5739bf = "columnDataStateChange";
var $17b89d3b1fc93cdb$export$4727fff3327259ae = "dataStateChange";
var $17b89d3b1fc93cdb$export$e9138ee323ad1b39 = "dataSourceChanged";
var $17b89d3b1fc93cdb$export$73ce1dd8756c84c3 = "rtl-updated";
var $17b89d3b1fc93cdb$export$9bac90be894496e8 = "beforeFragAppend";
var $17b89d3b1fc93cdb$export$b8f6e1dc8f300fdf = "frozenHeight";
var $17b89d3b1fc93cdb$export$2c01e4c7592b4497 = "textWrapRefresh";
var $17b89d3b1fc93cdb$export$48969e4b6e5bb8d7 = "recordAdded";
var $17b89d3b1fc93cdb$export$13b99c0e226e6ca4 = "cancel-Begin";
var $17b89d3b1fc93cdb$export$9fff589d4f0a3d53 = "editNextValCell";
var $17b89d3b1fc93cdb$export$5f9cb737ece1af6 = "hierarchyprint";
var $17b89d3b1fc93cdb$export$e904de7866e7f466 = "expandchildgrid";
var $17b89d3b1fc93cdb$export$e1bc4d46edb95a18 = "printGrid-Init";
var $17b89d3b1fc93cdb$export$37f61a67cc87a415 = "export-RowDataBound";
var $17b89d3b1fc93cdb$export$8a28500fff253474 = "export-DataBound";
var $17b89d3b1fc93cdb$export$907e5a7aa493beb5 = "row-position-changed";
var $17b89d3b1fc93cdb$export$2c86483b611367a6 = "columnChooserOpened";
var $17b89d3b1fc93cdb$export$f70460048909be86 = "batchedit-form";
var $17b89d3b1fc93cdb$export$b0559b5c933832aa = "edit-form";
var $17b89d3b1fc93cdb$export$fc1adc878c26066d = "before-batch-cancel";
var $17b89d3b1fc93cdb$export$8edad305e0465562 = "batcheditform-rendered";
var $17b89d3b1fc93cdb$export$868d7674f5a0caf5 = "partial-refresh";
var $17b89d3b1fc93cdb$export$2f83bf8959673709 = "beforeCustomFilterOpen";
var $17b89d3b1fc93cdb$export$d6c7825c8cd16473 = "select-virtual-Row";
var $17b89d3b1fc93cdb$export$32aae452a9346e5 = "columns-prepared";
var $17b89d3b1fc93cdb$export$5d169c634b93365b = "cbox-filter-begin";
var $17b89d3b1fc93cdb$export$75dd3538f0f880b3 = "cbox-filter-complete";
var $17b89d3b1fc93cdb$export$16e6cefe38bdd512 = "filter-Prevent";
var $17b89d3b1fc93cdb$export$5f4beafdf6c8c6a1 = "before-filter-cmenu-open";
var $17b89d3b1fc93cdb$export$ef01c28b197b6d01 = "validation-custom-placement";
var $17b89d3b1fc93cdb$export$1254425c2f6cc0c4 = "filter-cbox-value";
var $17b89d3b1fc93cdb$export$f1c7bc90392be8fa = "component-rendered";
var $17b89d3b1fc93cdb$export$2284e449d64b22d5 = "restore-Focus";
var $17b89d3b1fc93cdb$export$d85af9682ec6acc6 = "detail-state-change";
var $17b89d3b1fc93cdb$export$74c82625a332a083 = "detail-indentcell-info";
var $17b89d3b1fc93cdb$export$74974966766a0523 = "virtaul-key-handler";
var $17b89d3b1fc93cdb$export$9ee6037f4bacdaa7 = "virtaul-cell-focus";
var $17b89d3b1fc93cdb$export$6d303e5560d57498 = "virtual-scroll-edit-action-begin";
var $17b89d3b1fc93cdb$export$d2863c79b905c4cd = "virtual-scroll-edit-success";
var $17b89d3b1fc93cdb$export$7fd078d634a647bc = "virtual-scroll-edit-cancel";
var $17b89d3b1fc93cdb$export$ca52857b7b04ae17 = "virtual-scroll-edit";
var $17b89d3b1fc93cdb$export$a715e34adf8189a2 = "refresh-virtual-cache";
var $17b89d3b1fc93cdb$export$82a793dcb3807178 = "edit-reset";
var $17b89d3b1fc93cdb$export$25a0d5e14cd34614 = "virtual-scroll-add-action-begin";
var $17b89d3b1fc93cdb$export$a1aad2683385fb49 = "get-virtual-data";
var $17b89d3b1fc93cdb$export$c2efdb1b36d9fb1f = "refresh-infinite-mode-blocks";
var $17b89d3b1fc93cdb$export$795a13a52b6b60d3 = "reset-infinite-blocks";
var $17b89d3b1fc93cdb$export$d2df54dc266fa920 = "infinite-scroll-handler";
var $17b89d3b1fc93cdb$export$e8809d2928c13994 = "infinite-page-query";
var $17b89d3b1fc93cdb$export$acf275d6bf7c2a3 = "infinite-show-hide";
var $17b89d3b1fc93cdb$export$d1d974c345b7e95 = "append-infinite-content";
var $17b89d3b1fc93cdb$export$d74111ea55be118d = "remove-infinite-rows";
var $17b89d3b1fc93cdb$export$54948f7b626812fe = "set-infinite-cache";
var $17b89d3b1fc93cdb$export$b3a2f7adafd2c20 = "infinite-edit-handler";
var $17b89d3b1fc93cdb$export$21f05f465c475796 = "initial-collapse";
var $17b89d3b1fc93cdb$export$cbaf9f31dd31e714 = "get-aggregate-query";
var $17b89d3b1fc93cdb$export$992e182ea3a73b5d = "close-filter-dialog";
var $17b89d3b1fc93cdb$export$1c8994c032170add = "columnChooserCancelBtnClick";
var $17b89d3b1fc93cdb$export$9837be318e7e9b3 = "get-filterbar-operator";
var $17b89d3b1fc93cdb$export$8d1f04a619d5db82 = "reset-columns";
var $17b89d3b1fc93cdb$export$84db6b91e23ae16e = "pdfAggregateQueryCellInfo";
var $17b89d3b1fc93cdb$export$eb167a270aa0f522 = "excelAggregateQueryCellInfo";
var $17b89d3b1fc93cdb$export$608ee9cfb623fa81 = "group-cache";
var $17b89d3b1fc93cdb$export$2416ce2c5bd34d0a = "lazy-load-scroll-handler";
var $17b89d3b1fc93cdb$export$223c4411dd55f1a = "group-collapse";
var $17b89d3b1fc93cdb$export$99d678e9ef145614 = "beforeCheckboxRenderer";
var $17b89d3b1fc93cdb$export$d5e4329e23182602 = "refreshResizeHandlers";
var $17b89d3b1fc93cdb$export$4d730823cc408798 = "refresh-frozen-columns";
var $17b89d3b1fc93cdb$export$f74f9215dc0c5d14 = "set-reorder-destination-element";
var $17b89d3b1fc93cdb$export$a93bfbc041c6ccb0 = "refresh-virtual-frozen-height";
var $17b89d3b1fc93cdb$export$7cf2fb2539b85de4 = "set-freeze-selection";
var $17b89d3b1fc93cdb$export$43ea4d7fe1586575 = "set-infinite-frozen-height";
var $17b89d3b1fc93cdb$export$62bb49f906706405 = "set-infinite-col-frozen-height";
var $17b89d3b1fc93cdb$export$725c4d1f8c0e1c70 = "before-refresh-on-data-change";
var $17b89d3b1fc93cdb$export$e595ce879f0d4e35 = "immutable-batch-cancel";
var $17b89d3b1fc93cdb$export$66883d42f956398d = "refresh-virtual-frozenrows";
var $17b89d3b1fc93cdb$export$4b9274a2d5fb643d = "check-scroll-reset";
var $17b89d3b1fc93cdb$export$95cd39be84bbd337 = "refresh-frozen-height";
var $17b89d3b1fc93cdb$export$77d7273d963cf33a = "set-height-to-frozen-element";
var $17b89d3b1fc93cdb$export$8fba6c752b79b5a6 = "prevent-frozen-scroll-refresh";
var $17b89d3b1fc93cdb$export$61509f5c6e992036 = "next-cell-index";
var $17b89d3b1fc93cdb$export$26c30b44f2e7f30d = "refresh-infinite-current-view-data";
var $17b89d3b1fc93cdb$export$b38d92d450e1c729 = "infinite-crud-cancel";
var $17b89d3b1fc93cdb$export$2542708340471a26 = "filter-dialog-close";
var $17b89d3b1fc93cdb$export$acd547ecab270561 = "refresh-cutsom-filter-ok-button";
var $17b89d3b1fc93cdb$export$4f835fcb4bd1b58c = "refresh-cutsom-filter-clear-button";
var $17b89d3b1fc93cdb$export$9b39fce63b060dec = "render-responsive-cmenu";
var $17b89d3b1fc93cdb$export$fafad99bbd7983c0 = "filter-cmenu-select";
var $17b89d3b1fc93cdb$export$9cc49c8e691f8e1e = "custom-filter-close";
var $17b89d3b1fc93cdb$export$f66e9a7f793619a4 = "set-fullscreen-dialog";
var $17b89d3b1fc93cdb$export$c70b4b413518c03b = "refresh-Expand-and-Collapse";
var $17b89d3b1fc93cdb$export$ec2bbd6db9c2d185 = "row-mode-change";
var $17b89d3b1fc93cdb$export$294312b870d7fb5c = "enter-key-handler";
var $17b89d3b1fc93cdb$export$8fcd90c21e6d64a3 = "refresh-virtual-max-page";
var $17b89d3b1fc93cdb$export$d51281e311b00699 = "set-virtual-page-query";
var $17b89d3b1fc93cdb$export$dee075e2eb3f74a8 = "select-row-on-context-open";
var $17b89d3b1fc93cdb$export$40d5e22137cfb455 = "pager-refresh";
var $17b89d3b1fc93cdb$export$4291871f9574afe1 = "closeinline";
var $17b89d3b1fc93cdb$export$7aeba4b6d044ef6a = "closebatch";
var $17b89d3b1fc93cdb$export$ef3763a0d698e5a6 = "close-edit";
var $17b89d3b1fc93cdb$export$4621d2cf9ca5b53b = "reset-virtual-focus";
var $17b89d3b1fc93cdb$export$5653aae49840b30a = "after-content-renderer";
var $17b89d3b1fc93cdb$export$8cbbcbf676a1a501 = "refresh-virtual-editform-cells";
var $17b89d3b1fc93cdb$export$51907d4a017438aa = "scroll-to-edit";
var $17b89d3b1fc93cdb$export$3e9336abe13e1480 = "before-checkbox-renderer-query";
var $17b89d3b1fc93cdb$export$cd929038e92da795 = "create-virtual-validation-form";
var $17b89d3b1fc93cdb$export$4ff55734cc1d30f6 = "validate-virtual-form";
var $17b89d3b1fc93cdb$export$c554910bef133b44 = "destroy-child-grid";
var $17b89d3b1fc93cdb$export$c77f723cf0645ced = "sticky-scroll-complete";
var $17b89d3b1fc93cdb$export$f4e4d2b069f96288 = "infinite-group-collapse";
var $17b89d3b1fc93cdb$export$50807bf602c28512 = "refresh-infinite-persist-selection";
var $17b89d3b1fc93cdb$export$97df389aeb32c2d5 = "refresh-infinite-editrowindex";
var $17b89d3b1fc93cdb$export$9c0eb2753b60aa09 = "after-filter-column-menu-close";
var $17b89d3b1fc93cdb$export$b659f27f1089267e = "beforeCheckboxfilterRenderer";
var $17b89d3b1fc93cdb$export$f7916aff5645ab3f = "commandColumnDestroy";
var $17b89d3b1fc93cdb$export$748c68c5d9aa1854 = "cancelcnfrmDlg";
var $17b89d3b1fc93cdb$export$c0e33c0984c61ab9 = "refresh-Virtual-LazyLoad-Cache";
var $17b89d3b1fc93cdb$export$cdacb1a8abdadeeb = "refresh-Frozen-Position";
var $17b89d3b1fc93cdb$export$35c81900237a8009 = "refresh-Resize-Position";
var $17b89d3b1fc93cdb$export$6c0bde196efce5fe = "refresh-Split-Frozen-Column";
var $17b89d3b1fc93cdb$export$57e9c95e9e650443 = "render-Responsive-Change-Action";
var $17b89d3b1fc93cdb$export$87d96ac382feb05c = "render-Responsive-Column-Chooser-Div";
var $17b89d3b1fc93cdb$export$68dd90c72fa20ca = "show-Add-New-Row-Focus";
var $17b89d3b1fc93cdb$export$a257d8735e2aaa37 = "infinitescroll-complete";



var $cWXlQ = parcelRequire("cWXlQ");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");

parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $5rsSz = parcelRequire("5rsSz");

parcelRequire("j7YE8");
var $bWDaN = parcelRequire("bWDaN");
var $3EnZW = parcelRequire("3EnZW");
/**
 * ValueFormatter class to globalize the value.
 *
 * @hidden
 */ var $52aed6227a4600c2$export$4ad21d94aae28a17 = /** @class */ function() {
    function ValueFormatter(cultureName) {
        this.intl = new (0, $bWDaN.Internationalization)();
        if (!(0, $3EnZW.isNullOrUndefined)(cultureName)) this.intl.culture = cultureName;
    }
    ValueFormatter.prototype.getFormatFunction = function(format) {
        if (!(0, $3EnZW.isNullOrUndefined)(format) && (format.type === "dateTime" || format.type === "datetime" || format.type === "date" || format.type === "time")) return this.intl.getDateFormat(format);
        else return this.intl.getNumberFormat(format);
    };
    ValueFormatter.prototype.getParserFunction = function(format) {
        if (format.type) return this.intl.getDateParser(format);
        else return this.intl.getNumberParser(format);
    };
    ValueFormatter.prototype.fromView = function(value, format, type) {
        if ((type === "date" || type === "datetime" || type === "number") && !(0, $3EnZW.isNullOrUndefined)(format)) return format(value);
        else return value;
    };
    ValueFormatter.prototype.toView = function(value, format) {
        var result = value;
        if (!(0, $3EnZW.isNullOrUndefined)(format) && !(0, $3EnZW.isNullOrUndefined)(value)) result = format(value);
        return result;
    };
    ValueFormatter.prototype.setCulture = function(cultureName) {
        if (!(0, $3EnZW.isNullOrUndefined)(cultureName)) (0, $bWDaN.setCulture)(cultureName);
    };
    return ValueFormatter;
}();



var $0cb66def079b19f9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0cb66def079b19f9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Represents Grid `Column` model class.
 */ var $0cb66def079b19f9$export$816b5d811295e6bc = /** @class */ function() {
    function Column(options, parent) {
        var _this = this;
        /**
         * If `disableHtmlEncode` is set to true, it encodes the HTML of the header and content cells.
         *
         * @default true
         */ this.disableHtmlEncode = true;
        /**
         * If `allowSorting` set to false, then it disables sorting option of a particular column.
         * By default all columns are sortable.
         *
         * @default true
         */ this.allowSorting = true;
        /**
         * If `allowResizing` is set to false, it disables resize option of a particular column.
         * By default all the columns can be resized.
         *
         * @default true
         */ this.allowResizing = true;
        /**
         * If `allowFiltering` set to false, then it disables filtering option and filter bar element of a particular column.
         * By default all columns are filterable.
         *
         * @default true
         */ this.allowFiltering = true;
        /**
         * If `allowGrouping` set to false, then it disables grouping of a particular column.
         * By default all columns are groupable.
         *
         * @default true
         */ this.allowGrouping = true;
        /**
         * If `allowReordering` set to false, then it disables reorder of a particular column.
         * By default all columns can be reorder.
         *
         * @default true
         */ this.allowReordering = true;
        /**
         * If `showColumnMenu` set to false, then it disable the column menu of a particular column.
         * By default column menu will show for all columns
         *
         * @default true
         */ this.showColumnMenu = true;
        /**
         * If `enableGroupByFormat` set to true, then it groups the particular column by formatted values.
         *
         * @default true
         */ this.enableGroupByFormat = false;
        /**
         * If `allowEditing` set to false, then it disables editing of a particular column.
         * By default all columns are editable.
         *
         * @default true
         */ this.allowEditing = true;
        /**
         *  It is used to customize the default filter options for a specific columns.
         * * type -  Specifies the filter type as menu or checkbox.
         * * ui - to render custom component for specific column it has following functions.
         * * ui.create – It is used for creating custom components.
         * * ui.read -  It is used for read the value from the component.
         * * ui.write - It is used to apply component model as dynamically.
         * {% codeBlock src="grid/filter-menu-api/index.ts" %}{% endcodeBlock %}
         *
         * > Check the [`Filter UI`](../../grid/filtering/filter-menu/#custom-component-in-filter-menu) for its customization.
         *
         *  @default {}
         */ this.filter = {};
        /**
         * If `showInColumnChooser` set to false, then hide the particular column in column chooser.
         *  By default all columns are displayed in column Chooser.
         *
         * @default true
         */ this.showInColumnChooser = true;
        /**
         * Defines the `IEditCell` object to customize default edit cell.
         *
         * @default {}
         */ this.edit = {};
        /**
         * If `allowSearching` set to false, then it disables Searching of a particular column.
         * By default all columns allow Searching.
         *
         * @default true
         */ this.allowSearching = true;
        /**
         * If `autoFit` set to true, then the particular column content width will be
         * adjusted based on its content in the initial rendering itself.
         * Setting this property as true is equivalent to calling `autoFitColumns` method in the `dataBound` event.
         *
         * @default false
         */ this.autoFit = false;
        this.sortDirection = "Descending";
        /**
         * @returns {Function} returns the edit template
         * @hidden */ this.getEditTemplate = function() {
            return _this.editTemplateFn;
        };
        /**
         * @returns {Function} returns the filter template
         * @hidden */ this.getFilterTemplate = function() {
            return _this.filterTemplateFn;
        };
        (0, $3EnZW.merge)(this, options);
        this.parent = parent;
        if (this.type === "none") this.type = null;
        else if (this.type) this.type = typeof this.type === "string" ? this.type.toLowerCase() : undefined;
        if (this.editType) this.editType = this.editType.toLowerCase();
        if ((0, $3EnZW.isNullOrUndefined)(this.uid)) this.uid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("grid-column");
        var valueFormatter = new (0, $52aed6227a4600c2$export$4ad21d94aae28a17)();
        if (options.format && (options.format.skeleton || options.format.format && typeof options.format.format === "string")) {
            this.setFormatter(valueFormatter.getFormatFunction((0, $3EnZW.extend)({}, options.format)));
            this.setParser(valueFormatter.getParserFunction(options.format));
        }
        this.toJSON = function() {
            var col = {};
            var skip = [
                "filter",
                "dataSource",
                "headerText",
                "template",
                "headerTemplate",
                "edit",
                "editTemplate",
                "filterTemplate",
                "commandsTemplate",
                "parent"
            ];
            var keys = Object.keys(_this);
            for(var i = 0; i < keys.length; i++){
                if (keys[parseInt(i.toString(), 10)] === "columns") {
                    col[keys[parseInt(i.toString(), 10)]] = [];
                    for(var j = 0; j < _this[keys[parseInt(i.toString(), 10)]].length; j++)col[keys[parseInt(i.toString(), 10)]].push(_this[keys[parseInt(i.toString(), 10)]][parseInt(j.toString(), 10)].toJSON());
                } else if (skip.indexOf(keys[parseInt(i.toString(), 10)]) < 0) col[keys[parseInt(i.toString(), 10)]] = _this[keys[parseInt(i.toString(), 10)]];
            }
            return col;
        };
        if (!this.field) {
            this.allowFiltering = false;
            this.allowGrouping = false;
            this.allowSorting = false;
            if (this.columns) this.allowResizing = this.columns.some(function(col) {
                return col.allowResizing;
            });
        }
        if (this.commands && !this.textAlign) this.textAlign = "Right";
        if (this.template || this.commandsTemplate) this.templateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.template || this.commandsTemplate);
        if (this.headerTemplate) this.headerTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.headerTemplate);
        if (!(0, $3EnZW.isNullOrUndefined)(this.filter) && this.filter.itemTemplate) this.fltrTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.filter.itemTemplate);
        if (this.editTemplate) this.editTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.editTemplate);
        if (this.filterTemplate) this.filterTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.filterTemplate);
        if (this.isForeignColumn() && ((0, $3EnZW.isNullOrUndefined)(this.editType) || this.editType === "dropdownedit" || this.editType === "defaultedit")) {
            this.editType = "dropdownedit";
            if (this.edit.params && this.edit.params.dataSource) this.edit.params.ddEditedData = true;
            this.edit.params = (0, $3EnZW.extend)({
                dataSource: this.dataSource,
                query: new (0, $56262f229d1cff45$export$62297b13309008b2)(),
                fields: {
                    value: this.foreignKeyField || this.field,
                    text: this.foreignKeyValue
                }
            }, this.edit.params);
        }
        if (this.sortComparer) {
            var a_1 = this.sortComparer;
            this.sortComparer = function(x, y, xObj, yObj) {
                if (typeof a_1 === "string") a_1 = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(a_1, window);
                if (_this.sortDirection === "Descending") {
                    var z = x;
                    x = y;
                    y = z;
                    var obj = xObj;
                    xObj = yObj;
                    yObj = obj;
                }
                return a_1(x, y, xObj, yObj);
            };
        }
        if (!this.sortComparer && this.isForeignColumn()) this.sortComparer = function(x, y) {
            x = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(_this.foreignKeyValue, (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(_this, {}, x)[0]);
            y = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(_this.foreignKeyValue, (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(_this, {}, y)[0]);
            return _this.sortDirection === "Descending" ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnDescending(x, y) : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnAscending(x, y);
        };
    }
    /**
     * @returns {string} returns the sort direction
     * @hidden */ Column.prototype.getSortDirection = function() {
        return this.sortDirection;
    };
    /**
     * @param {string} direction - specifies the direction
     * @returns {void}
     * @hidden
     */ Column.prototype.setSortDirection = function(direction) {
        this.sortDirection = direction;
    };
    /**
     * @returns {freezeTable} returns the FreezeTable
     * @hidden */ Column.prototype.getFreezeTableName = function() {
        return this.freezeTable;
    };
    /**
     * @param {Column} column - specifies the column
     * @returns {void}
     * @hidden
     */ Column.prototype.setProperties = function(column) {
        //Angular two way binding
        var keys = Object.keys(column);
        var _loop_1 = function(i) {
            if (keys[parseInt(i.toString(), 10)] === "columns") {
                var cols_1 = column[keys[parseInt(i.toString(), 10)]];
                var _loop_2 = function(j) {
                    this_1.columns.find(function(col) {
                        return col.field === cols_1[parseInt(j.toString(), 10)].field;
                    }).setProperties(cols_1[parseInt(j.toString(), 10)]);
                };
                for(var j = 0; j < cols_1.length; j++)_loop_2(j);
            } else this_1[keys[parseInt(i.toString(), 10)]] = column[keys[parseInt(i.toString(), 10)]];
            //Refresh the react columnTemplates on state change
            if (this_1.parent && this_1.parent.isReact) {
                if (keys[parseInt(i.toString(), 10)] === "template") {
                    this_1.templateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(column[keys[parseInt(i.toString(), 10)]]);
                    this_1.parent.refreshReactColumnTemplateByUid(this_1.uid, true);
                } else if (keys[parseInt(i.toString(), 10)] === "headerTemplate") {
                    this_1.headerTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(column[keys[parseInt(i.toString(), 10)]]);
                    this_1.parent.refreshReactHeaderTemplateByUid(this_1.uid);
                } else if (keys[parseInt(i.toString(), 10)] === "editTemplate") this_1.editTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(column[keys[parseInt(i.toString(), 10)]]);
            }
        };
        var this_1 = this;
        for(var i = 0; i < keys.length; i++)_loop_1(i);
    };
    /**
     * @returns {boolean} returns true for foreign column
     * @hidden
     * It defines the column is foreign key column or not.
     */ Column.prototype.isForeignColumn = function() {
        return !!(this.dataSource && this.foreignKeyValue);
    };
    /**
     * @returns {Function} returns the function
     * @hidden
     */ Column.prototype.getFormatter = function() {
        return this.formatFn;
    };
    /**
     * @param {Function} value - specifies the value
     * @returns {void}
     * @hidden
     */ Column.prototype.setFormatter = function(value) {
        this.formatFn = value;
    };
    /**
     * @returns {Function} returns the function
     * @hidden */ Column.prototype.getParser = function() {
        return this.parserFn;
    };
    /**
     * @param {Function} value - specifies the value
     * @returns {void}
     * @hidden
     */ Column.prototype.setParser = function(value) {
        this.parserFn = value;
    };
    /**
     * @returns {Function} returns the function
     * @hidden */ Column.prototype.getColumnTemplate = function() {
        return this.templateFn;
    };
    /**
     * @returns {Function} returns the function
     * @hidden */ Column.prototype.getHeaderTemplate = function() {
        return this.headerTemplateFn;
    };
    /**
     * @returns {Function} returns the function
     * @hidden */ Column.prototype.getFilterItemTemplate = function() {
        return this.fltrTemplateFn;
    };
    /**
     * @returns {string} returns the string
     * @hidden */ Column.prototype.getDomSetter = function() {
        return this.disableHtmlEncode ? "textContent" : "innerHTML";
    };
    return Column;
}();
/**
 * Define options for custom command buttons.
 */ var $0cb66def079b19f9$export$7438af8abe1d24e8 = /** @class */ function() {
    function CommandColumnModel() {}
    $0cb66def079b19f9$var$__decorate([
        (0, $5rsSz.Property)()
    ], CommandColumnModel.prototype, "title", void 0);
    $0cb66def079b19f9$var$__decorate([
        (0, $5rsSz.Property)()
    ], CommandColumnModel.prototype, "type", void 0);
    $0cb66def079b19f9$var$__decorate([
        (0, $5rsSz.Property)()
    ], CommandColumnModel.prototype, "buttonOption", void 0);
    return CommandColumnModel;
}();
/**
 * Defines Grid column
 */ var $0cb66def079b19f9$export$cc81acb7d2e85c4e = /** @class */ function(_super) {
    $0cb66def079b19f9$var$__extends(GridColumn, _super);
    function GridColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $0cb66def079b19f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], GridColumn.prototype, "columns", void 0);
    return GridColumn;
}($0cb66def079b19f9$export$816b5d811295e6bc);
/**
 * Defines stacked grid column
 */ var $0cb66def079b19f9$export$7fcd1e8d3389a036 = /** @class */ function(_super) {
    $0cb66def079b19f9$var$__extends(StackedColumn, _super);
    function StackedColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StackedColumn;
}($0cb66def079b19f9$export$cc81acb7d2e85c4e);



var $cWXlQ = parcelRequire("cWXlQ");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $bWDaN = parcelRequire("bWDaN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");
var $3P3ke = parcelRequire("3P3ke");




parcelRequire("j7YE8");
var $c2qqN = parcelRequire("c2qqN");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");


/**
 * Defines types of Cell
 *
 * @hidden
 */ var $6b76944ddf827cb7$export$705e36171f4cbbfe;
(function(CellType) {
    /**  Defines CellType as Data */ CellType[CellType["Data"] = 0] = "Data";
    /**  Defines CellType as Header */ CellType[CellType["Header"] = 1] = "Header";
    /**  Defines CellType as Summary */ CellType[CellType["Summary"] = 2] = "Summary";
    /**  Defines CellType as GroupSummary */ CellType[CellType["GroupSummary"] = 3] = "GroupSummary";
    /**  Defines CellType as CaptionSummary */ CellType[CellType["CaptionSummary"] = 4] = "CaptionSummary";
    /**  Defines CellType as Filter */ CellType[CellType["Filter"] = 5] = "Filter";
    /**  Defines CellType as Indent */ CellType[CellType["Indent"] = 6] = "Indent";
    /**  Defines CellType as GroupCaption */ CellType[CellType["GroupCaption"] = 7] = "GroupCaption";
    /**  Defines CellType as GroupCaptionEmpty */ CellType[CellType["GroupCaptionEmpty"] = 8] = "GroupCaptionEmpty";
    /**  Defines CellType as Expand */ CellType[CellType["Expand"] = 9] = "Expand";
    /**  Defines CellType as HeaderIndent */ CellType[CellType["HeaderIndent"] = 10] = "HeaderIndent";
    /**  Defines CellType as StackedHeader */ CellType[CellType["StackedHeader"] = 11] = "StackedHeader";
    /**  Defines CellType as DetailHeader */ CellType[CellType["DetailHeader"] = 12] = "DetailHeader";
    /**  Defines CellType as DetailExpand */ CellType[CellType["DetailExpand"] = 13] = "DetailExpand";
    /**  Defines CellType as CommandColumn */ CellType[CellType["CommandColumn"] = 14] = "CommandColumn";
    /**  Defines CellType as DetailFooterIntent */ CellType[CellType["DetailFooterIntent"] = 15] = "DetailFooterIntent";
    /**  Defines CellType as RowDrag */ CellType[CellType["RowDragIcon"] = 16] = "RowDragIcon";
    /**  Defines CellType as RowDragHeader */ CellType[CellType["RowDragHIcon"] = 17] = "RowDragHIcon";
})($6b76944ddf827cb7$export$705e36171f4cbbfe || ($6b76944ddf827cb7$export$705e36171f4cbbfe = {}));
var $6b76944ddf827cb7$export$ed706b0a66efb05c;
(function(RenderType) {
    /**  Defines RenderType as Header */ RenderType[RenderType["Header"] = 0] = "Header";
    /**  Defines RenderType as Content */ RenderType[RenderType["Content"] = 1] = "Content";
    /**  Defines RenderType as Summary */ RenderType[RenderType["Summary"] = 2] = "Summary";
})($6b76944ddf827cb7$export$ed706b0a66efb05c || ($6b76944ddf827cb7$export$ed706b0a66efb05c = {}));
var $6b76944ddf827cb7$export$cb67beb212e92bbd;
(function(ToolbarItem) {
    ToolbarItem[ToolbarItem["Add"] = 0] = "Add";
    ToolbarItem[ToolbarItem["Edit"] = 1] = "Edit";
    ToolbarItem[ToolbarItem["Update"] = 2] = "Update";
    ToolbarItem[ToolbarItem["Delete"] = 3] = "Delete";
    ToolbarItem[ToolbarItem["Cancel"] = 4] = "Cancel";
    ToolbarItem[ToolbarItem["Print"] = 5] = "Print";
    ToolbarItem[ToolbarItem["Search"] = 6] = "Search";
    ToolbarItem[ToolbarItem["ColumnChooser"] = 7] = "ColumnChooser";
    ToolbarItem[ToolbarItem["PdfExport"] = 8] = "PdfExport";
    ToolbarItem[ToolbarItem["ExcelExport"] = 9] = "ExcelExport";
    ToolbarItem[ToolbarItem["CsvExport"] = 10] = "CsvExport";
    ToolbarItem[ToolbarItem["WordExport"] = 11] = "WordExport";
})($6b76944ddf827cb7$export$cb67beb212e92bbd || ($6b76944ddf827cb7$export$cb67beb212e92bbd = {}));
var $6b76944ddf827cb7$export$b69201db7f59899c;
(function(ResponsiveDialogAction) {
    /**  Defines dialog type as Edit */ ResponsiveDialogAction[ResponsiveDialogAction["isEdit"] = 0] = "isEdit";
    /**  Defines dialog type as Add */ ResponsiveDialogAction[ResponsiveDialogAction["isAdd"] = 1] = "isAdd";
    /**  Defines dialog type as Sort */ ResponsiveDialogAction[ResponsiveDialogAction["isSort"] = 2] = "isSort";
    /**  Defines dialog type as Filter */ ResponsiveDialogAction[ResponsiveDialogAction["isFilter"] = 3] = "isFilter";
    /**  Defines dialog type as ColMenu */ ResponsiveDialogAction[ResponsiveDialogAction["isColMenu"] = 4] = "isColMenu";
    /**  Defines dialog type as ColumChooser */ ResponsiveDialogAction[ResponsiveDialogAction["isColumnChooser"] = 5] = "isColumnChooser";
})($6b76944ddf827cb7$export$b69201db7f59899c || ($6b76944ddf827cb7$export$b69201db7f59899c = {}));
var $6b76944ddf827cb7$export$28a147f5fe91911;
(function(ResponsiveToolbarAction) {
    /**  Defines initial responsive toolbar buttons */ ResponsiveToolbarAction[ResponsiveToolbarAction["isInitial"] = 0] = "isInitial";
    /**  Defines responsive toolbar search */ ResponsiveToolbarAction[ResponsiveToolbarAction["isSearch"] = 1] = "isSearch";
})($6b76944ddf827cb7$export$28a147f5fe91911 || ($6b76944ddf827cb7$export$28a147f5fe91911 = {}));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");




/* tslint:disable-next-line:max-line-length */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $aqzbR = parcelRequire("aqzbR");
var $bWDaN = parcelRequire("bWDaN");
var $3P3ke = parcelRequire("3P3ke");







/**
 * @hidden
 * `CheckBoxFilterBase` module is used to handle filtering action.
 */ var $66db5ede9cdf4d76$export$325f55b6c744802a = /** @class */ function() {
    /**
     * Constructor for checkbox filtering module
     *
     * @param {IXLFilter} parent - specifies the IXLFilter
     * @hidden
     */ function CheckBoxFilterBase(parent) {
        this.searchInputArgs = null;
        this.isExecuteLocal = false;
        this.existingPredicate = {};
        this.foreignKeyQuery = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        /** @hidden */ this.filterState = true;
        this.values = {};
        this.renderEmpty = false;
        this.isCheckboxFilterTemplate = false;
        this.infiniteRenderMod = false;
        // for infinite scroll ui
        this.infiniteInitialLoad = false;
        this.infiniteSearchValChange = false;
        this.infinitePermenantLocalData = [];
        this.infiniteQueryExecutionPending = false;
        this.infiniteSkipCnt = 0;
        this.infiniteScrollAppendDiff = 0;
        this.prevInfiniteScrollDirection = "";
        this.infiniteLoadedElem = [];
        this.infiniteDataCount = 0;
        this.infiniteLocalSelectAll = true;
        this.localInfiniteSelectAllClicked = false;
        this.localInfiniteSelectionInteracted = false;
        this.infiniteManualSelectMaintainPred = [];
        this.parent = parent;
        this.id = this.parent.element.id;
        this.valueFormatter = new (0, $52aed6227a4600c2$export$4ad21d94aae28a17)(this.parent.locale);
        this.cBoxTrue = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
            checked: true,
            label: " "
        });
        this.cBoxFalse = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
            checked: false,
            label: " "
        });
        this.cBoxTrue.insertBefore(this.parent.createElement("input", {
            className: "e-chk-hidden",
            attrs: {
                type: "checkbox"
            }
        }), this.cBoxTrue.firstChild);
        this.cBoxFalse.insertBefore(this.parent.createElement("input", {
            className: "e-chk-hidden",
            attrs: {
                "type": "checkbox"
            }
        }), this.cBoxFalse.firstChild);
        this.cBoxFalse.querySelector(".e-frame").classList.add("e-uncheck");
        if (this.parent.enableRtl) (0, $4ZDHT.addClass)([
            this.cBoxTrue,
            this.cBoxFalse
        ], [
            "e-rtl"
        ]);
        if (this.parent.cssClass) {
            if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                this.cBoxTrue,
                this.cBoxFalse
            ], this.parent.cssClass.split(" "));
            else (0, $4ZDHT.addClass)([
                this.cBoxTrue,
                this.cBoxFalse
            ], [
                this.parent.cssClass
            ]);
        }
    }
    /**
     * @returns {void}
     * @hidden
     */ CheckBoxFilterBase.prototype.destroy = function() {
        this.closeDialog();
    };
    CheckBoxFilterBase.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.dlg, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.dlg, "keyup", this.keyupHandler, this);
        this.searchHandler = (0, $3EnZW.debounce)(this.searchBoxKeyUp, 200);
        var elem = this.dialogObj.element.querySelector(".e-searchinput");
        if (elem) {
            (0, $aqzbR.EventHandler).add(elem, "keyup", this.searchHandler, this);
            (0, $aqzbR.EventHandler).add(elem, "input", this.searchHandler, this);
        }
    };
    CheckBoxFilterBase.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.dlg, "click", this.clickHandler);
        (0, $aqzbR.EventHandler).remove(this.dlg, "keyup", this.keyupHandler);
        var elem = this.dialogObj.element.querySelector(".e-searchinput");
        if (elem) {
            (0, $aqzbR.EventHandler).remove(elem, "keyup", this.searchHandler);
            (0, $aqzbR.EventHandler).remove(elem, "input", this.searchHandler);
        }
    };
    CheckBoxFilterBase.prototype.foreignKeyFilter = function(args, fColl, mPredicate) {
        var _this = this;
        var fPredicate = {};
        var filterCollection = [];
        var query = this.foreignKeyQuery.clone();
        this.options.column.dataSource.executeQuery(query.where(mPredicate)).then(function(e) {
            _this.options.column.columnData = e.result;
            _this.parent.notify($17b89d3b1fc93cdb$export$40afe28aee4686d4, {
                predicate: fPredicate,
                column: _this.options.column
            });
            args.ejpredicate = fPredicate.predicate.predicates;
            var fpred = fPredicate.predicate.predicates;
            for(var i = 0; i < fpred.length; i++)filterCollection.push({
                field: fpred[parseInt(i.toString(), 10)].field,
                predicate: "or",
                matchCase: fpred[parseInt(i.toString(), 10)].ignoreCase,
                ignoreAccent: fpred[parseInt(i.toString(), 10)].ignoreAccent,
                operator: fpred[parseInt(i.toString(), 10)].operator,
                value: fpred[parseInt(i.toString(), 10)].value,
                type: _this.options.type
            });
            args.filterCollection = filterCollection.length ? filterCollection : fColl.filter(function(col) {
                return col.field = _this.options.field;
            });
            _this.options.handler(args);
        });
    };
    CheckBoxFilterBase.prototype.searchBoxClick = function(e) {
        var target = e.target;
        if (target.classList.contains("e-searchclear")) {
            this.sInput.value = target.classList.contains("e-chkcancel-icon") ? "" : this.sInput.value;
            if (this.isCheckboxFilterTemplate) this.parent.notify("refreshCheckbox", {
                event: e
            });
            else this.refreshCheckboxes();
            this.updateSearchIcon();
            this.sInput.focus();
        }
    };
    CheckBoxFilterBase.prototype.searchBoxKeyUp = function(e) {
        if ((0, $3EnZW.isNullOrUndefined)(this.sInput)) return;
        if ((0, $3EnZW.isNullOrUndefined)(e) || e.key !== "ArrowUp" && e.key !== "ArrowDown" && e.key !== "Tab" && !(e.key === "Tab" && e.shiftKey)) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.loadingIndicator) && this.parent.loadingIndicator.indicatorType === "Shimmer") this.parent.showMaskRow(undefined, this.dialogObj.element);
            if (this.isCheckboxFilterTemplate) this.parent.notify("refreshCheckbox", {
                event: e
            });
            else this.refreshCheckboxes();
            this.updateSearchIcon();
        }
    };
    CheckBoxFilterBase.prototype.updateSearchIcon = function() {
        if (this.sInput.value.length) {
            (0, $4ZDHT.classList)(this.sIcon, [
                "e-chkcancel-icon"
            ], [
                "e-search-icon"
            ]);
            if (!(0, $3EnZW.isNullOrUndefined)(document.body.querySelector(".e-chkcancel-icon"))) document.body.querySelector(".e-chkcancel-icon").setAttribute("title", this.localeObj.getConstant("Clear"));
        } else {
            (0, $4ZDHT.classList)(this.sIcon, [
                "e-search-icon"
            ], [
                "e-chkcancel-icon"
            ]);
            if (!(0, $3EnZW.isNullOrUndefined)(document.body.querySelector(".e-searchclear.e-search-icon"))) document.body.querySelector(".e-searchclear.e-search-icon").setAttribute("title", this.localeObj.getConstant("Search"));
        }
    };
    /**
     * Gets the localized label by locale keyword.
     *
     * @param {string} key - Defines localization key
     * @returns {string} - returns localization label
     */ CheckBoxFilterBase.prototype.getLocalizedLabel = function(key) {
        return this.localeObj.getConstant(key);
    };
    CheckBoxFilterBase.prototype.updateDataSource = function() {
        var dataSource = this.options.dataSource;
        var str = "object";
        if (!(dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
            for(var i = 0; i < dataSource.length; i++)// eslint-disable-next-line valid-typeof
            if (typeof dataSource !== str) {
                var obj = {};
                obj[this.options.field] = dataSource[parseInt(i.toString(), 10)];
                dataSource[parseInt(i.toString(), 10)] = obj;
            }
        }
    };
    CheckBoxFilterBase.prototype.updateModel = function(options) {
        this.options = options;
        this.existingPredicate = options.actualPredicate || {};
        this.options.dataSource = options.dataSource;
        this.options.dataManager = options.dataManager ? options.dataManager : options.dataSource;
        this.updateDataSource();
        this.options.type = options.type;
        this.options.format = options.format || "";
        this.options.ignoreAccent = options.ignoreAccent || false;
        this.options.filteredColumns = options.filteredColumns || this.parent.filterSettings.columns;
        this.options.query = options.query || new (0, $56262f229d1cff45$export$62297b13309008b2)();
        this.options.allowCaseSensitive = options.allowCaseSensitive || false;
        this.options.uid = options.column.uid;
        this.options.disableHtmlEncode = options.column.disableHtmlEncode || false;
        this.values = {};
        this.localeObj = options.localeObj;
        this.isFiltered = options.filteredColumns.length;
        this.infiniteRenderMod = this.parent.filterSettings && this.parent.filterSettings.enableInfiniteScrolling ? true : false;
        this.infiniteUnloadParentExistPred = this.infiniteRenderMod && this.existingPredicate[this.options.column.field] ? this.existingPredicate[this.options.column.field].slice() : [];
    };
    CheckBoxFilterBase.prototype.getAndSetChkElem = function(options) {
        this.dlg = this.parent.createElement("div", {
            id: this.id + this.options.type + "_excelDlg",
            attrs: {
                uid: this.options.column.uid
            },
            className: "e-checkboxfilter e-filter-popup"
        });
        this.sBox = this.parent.createElement("div", {
            className: "e-searchcontainer"
        });
        if (!options.hideSearchbox) {
            this.sInput = this.parent.createElement("input", {
                id: this.id + "_SearchBox",
                className: "e-searchinput"
            });
            this.sIcon = this.parent.createElement("span", {
                className: "e-searchclear e-search-icon e-icons e-input-group-icon",
                attrs: {
                    type: "text",
                    title: this.getLocalizedLabel("Search")
                }
            });
            this.searchBox = this.parent.createElement("span", {
                className: "e-searchbox e-fields"
            });
            this.searchBox.appendChild(this.sInput);
            this.sBox.appendChild(this.searchBox);
            this.searchInputArgs = {
                element: this.sInput,
                floatLabelType: "Never",
                properties: {
                    placeholder: this.getLocalizedLabel("Search"),
                    cssClass: this.parent.cssClass
                }
            };
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput(this.searchInputArgs, this.parent.createElement);
            this.searchBox.querySelector(".e-input-group").appendChild(this.sIcon);
        }
        this.spinner = this.parent.createElement("div", {
            className: "e-spinner"
        }); //for spinner
        this.cBox = this.parent.createElement("div", {
            id: this.id + this.options.type + "_CheckBoxList",
            className: "e-checkboxlist e-fields"
        });
        this.spinner.appendChild(this.cBox);
        this.sBox.appendChild(this.spinner);
        return this.sBox;
    };
    CheckBoxFilterBase.prototype.showDialog = function(options) {
        var args = {
            requestType: $17b89d3b1fc93cdb$export$a23907baab3479c2,
            columnName: this.options.field,
            columnType: this.options.type,
            cancel: false
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        this.parent.notify($17b89d3b1fc93cdb$export$5d169c634b93365b, args);
        if (args.cancel) {
            options.cancel = args.cancel;
            return;
        }
        this.dialogObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            visible: false,
            content: this.sBox,
            close: this.closeDialog.bind(this),
            enableRtl: this.parent.enableRtl,
            width: !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(options.target, "e-bigger")) || this.parent.element.classList.contains("e-device") ? 260 : 255,
            target: this.parent.element,
            animationSettings: {
                effect: "None"
            },
            buttons: [
                {
                    click: this.btnClick.bind(this),
                    buttonModel: {
                        content: this.getLocalizedLabel(this.isExcel ? "OKButton" : "FilterButton"),
                        cssClass: this.parent.cssClass ? "e-primary " + this.parent.cssClass : "e-primary",
                        isPrimary: true
                    }
                },
                {
                    click: this.btnClick.bind(this),
                    buttonModel: {
                        cssClass: this.parent.cssClass ? "e-flat " + this.parent.cssClass : "e-flat",
                        content: this.getLocalizedLabel(this.isExcel ? "CancelButton" : "ClearButton")
                    }
                }
            ],
            created: this.dialogCreated.bind(this),
            open: this.dialogOpen.bind(this),
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        var isStringTemplate = "isStringTemplate";
        this.dialogObj["" + isStringTemplate] = true;
        this.renderResponsiveFilter(options);
        var dialogLabel = this.parent.filterSettings && this.parent.filterSettings.type === "CheckBox" ? this.getLocalizedLabel("CheckBoxFilterDialogARIA") : this.getLocalizedLabel("ExcelFilterDialogARIA");
        this.dlg.setAttribute("aria-label", dialogLabel);
        if (options.isResponsiveFilter) {
            var responsiveCnt = document.querySelector(".e-responsive-dialog > .e-dlg-content > .e-mainfilterdiv");
            responsiveCnt.appendChild(this.dlg);
        } else this.parent.element.appendChild(this.dlg);
        this.dialogObj.appendTo(this.dlg);
        this.dialogObj.element.style.maxHeight = options.isResponsiveFilter ? "none" : this.options.height + "px";
        this.dialogObj.show();
        if (this.parent && this.parent.filterSettings && this.parent.filterSettings.type === "CheckBox" && this.parent.getContent().firstElementChild.offsetHeight < this.dialogObj.element.offsetHeight) (0, $748c2240e597a9b7$export$35819a1a44286094)(this.parent, this.dialogObj);
        var content = this.dialogObj.element.querySelector(".e-dlg-content");
        content.appendChild(this.sBox);
        this.wireEvents();
        if (!this.parent.enableAdaptiveUI) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.loadingIndicator) && this.parent.loadingIndicator.indicatorType === "Shimmer" && !this.infiniteRenderMod) this.parent.showMaskRow(undefined, this.dialogObj.element);
            if (this.infiniteRenderMod && this.parent.filterSettings && this.parent.filterSettings.loadingIndicator === "Shimmer") this.showMask();
        } else {
            if (this.parent.enableAdaptiveUI && this.parent.filterSettings && this.parent.filterSettings.loadingIndicator === "Shimmer") {
                this.getAllData();
                return;
            }
            if (this.infiniteRenderMod) this.cBox.style.marginTop = this.getListHeight(this.cBox) + "px";
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.spinner,
                cssClass: this.parent.cssClass ? this.parent.cssClass : null
            }, this.parent.createElement);
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinner);
        }
        this.getAllData();
    };
    CheckBoxFilterBase.prototype.renderResponsiveFilter = function(options) {
        if (options.isResponsiveFilter) {
            this.dialogObj.buttons = [
                {}
            ];
            this.dialogObj.position = {
                X: "",
                Y: ""
            };
            this.dialogObj.target = document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv");
            this.dialogObj.width = "100%";
        }
    };
    CheckBoxFilterBase.prototype.dialogCreated = function(e) {
        if (this.options.isResponsiveFilter) this.dialogObj.element.style.left = "0px";
        else if (!(0, $5q7BP.Browser).isDevice) (0, $748c2240e597a9b7$export$2b9ad9396c9b6e69)(this.options.target, this.dialogObj);
        else this.dialogObj.position = {
            X: "center",
            Y: "center"
        };
        if (this.options.column.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$4cc1ec161750f031, e);
    };
    CheckBoxFilterBase.prototype.openDialog = function(options) {
        this.updateModel(options);
        this.getAndSetChkElem(options);
        this.showDialog(options);
    };
    CheckBoxFilterBase.prototype.closeDialog = function() {
        if (this.infiniteRenderMod && this.infinitePermenantLocalData.length && !this.options.isRemote) this.options.dataSource.dataSource.json = this.infinitePermenantLocalData;
        if (this.dialogObj && !this.dialogObj.isDestroyed) {
            this.isBlanks = false;
            var filterTemplateCol = this.options.columns.filter(function(col) {
                return col.getFilterItemTemplate();
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var registeredTemplate = this.parent.registeredTemplate;
            if (filterTemplateCol.length && !(0, $3EnZW.isNullOrUndefined)(registeredTemplate) && registeredTemplate.filterItemTemplate) this.parent.destroyTemplate([
                "filterItemTemplate"
            ]);
            if ((this.parent.isReact || this.parent.isVue) && this.parent.destroyTemplate !== undefined) (0, $748c2240e597a9b7$export$d9aeb73a9e271813)(this.parent, [
                "filterItemTemplate"
            ]);
            this.parent.notify($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, {
                field: this.options.field
            });
            this.unWireEvents();
            if (this.searchInputArgs && this.searchInputArgs.element && this.searchInputArgs.element.parentElement) {
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy(this.searchInputArgs);
                (0, $4ZDHT.remove)(this.searchInputArgs.element);
            }
            this.searchInputArgs = null;
            this.sInput = null;
            if (this.parent.isReact && this.options.column.filter && typeof this.options.column.filter.itemTemplate !== "string" && (this.options.column.filter.type === "CheckBox" || this.options.column.filter.type === "Excel")) this.dialogObj.element.querySelector(".e-dlg-content").innerHTML = "";
            this.dialogObj.destroy();
            if (this.dlg && this.dlg.parentElement) (0, $4ZDHT.remove)(this.dlg);
            this.dlg = null;
            this.parent.notify($17b89d3b1fc93cdb$export$2542708340471a26, {});
        }
    };
    /**
     * @param {Column} col - Defines column details
     * @returns {void}
     * @hidden
     */ CheckBoxFilterBase.prototype.clearFilter = function(col) {
        // eslint-disable-next-line max-len
        var args = {
            instance: this,
            handler: this.clearFilter,
            cancel: false
        };
        this.parent.notify($17b89d3b1fc93cdb$export$16e6cefe38bdd512, args);
        if (args.cancel) return;
        this.options.handler({
            action: "clear-filter",
            field: col ? col.field : this.options.field
        });
    };
    CheckBoxFilterBase.prototype.btnClick = function(e) {
        if (this.filterState) {
            if (e.target.tagName.toLowerCase() === "input" && e.target.classList.contains("e-searchinput") || e.keyCode === 13) {
                if (!this.isCheckboxFilterTemplate) this.fltrBtnHandler();
            } else {
                var text = e.target.firstChild.textContent.toLowerCase();
                if (this.getLocalizedLabel(this.isExcel ? "OKButton" : "FilterButton").toLowerCase() === text) {
                    if (!this.isCheckboxFilterTemplate) this.fltrBtnHandler();
                } else if (this.getLocalizedLabel("ClearButton").toLowerCase() === text) this.clearFilter();
            }
            this.closeDialog();
        } else if (e.target && e.target.firstChild && e.target.firstChild.textContent.toLowerCase() === this.getLocalizedLabel("CancelButton").toLowerCase()) this.closeDialog();
        else if (!(e.target.tagName.toLowerCase() === "input")) {
            this.clearFilter();
            this.closeDialog();
        }
        if (this.options.column.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$9c0eb2753b60aa09, {});
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.focusModule)) this.parent.focusModule.filterfocus();
    };
    /**
     * @returns {void}
     * @hidden
     */ CheckBoxFilterBase.prototype.fltrBtnHandler = function() {
        var _this = this;
        if (this.infiniteRenderMod) {
            this.cBox.innerHTML = "";
            (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.cBox, this.infiniteLoadedElem.slice());
        }
        var checked = [].slice.call(this.cBox.querySelectorAll(".e-check:not(.e-selectall):not(.e-add-current)"));
        var check = checked;
        var optr = "equal";
        var ddlValue = this.dialogObj.element.querySelector(".e-dropdownlist");
        if (ddlValue) this.options.operator = optr = ddlValue.ej2_instances[0].value;
        this.isMenuNotEqual = this.options.operator === "notequal";
        var searchInput;
        if (!this.options.hideSearchbox) searchInput = this.searchBox.querySelector(".e-searchinput");
        var caseSen = this.options.allowCaseSensitive;
        var defaults = {
            field: this.options.field,
            predicate: this.isMenuNotEqual ? "and" : "or",
            uid: this.options.uid,
            operator: optr,
            type: this.options.type,
            matchCase: caseSen,
            ignoreAccent: this.options.ignoreAccent
        };
        var isNotEqual = this.itemsCnt !== checked.length && this.itemsCnt - checked.length < checked.length;
        if (isNotEqual && searchInput && searchInput.value === "") {
            optr = this.isMenuNotEqual ? "equal" : "notequal";
            checked = [].slice.call(this.cBox.querySelectorAll(".e-uncheck:not(.e-selectall)"));
            defaults.predicate = this.isMenuNotEqual ? "or" : "and";
            defaults.operator = optr;
        }
        var val;
        var length;
        var coll = [];
        if (checked.length !== this.itemsCnt || searchInput && searchInput.value && searchInput.value !== "" || this.infiniteRenderMod) {
            if (!this.infiniteRenderMod) coll = this.complexQueryPredicate(checked, defaults, isNotEqual);
            else if (this.infiniteRenderMod && (!this.infiniteSearchPred || this.infiniteSearchPred && !this.infiniteSearchPred.isComplex)) this.infiniteFltrBtnHandler(coll);
            else if (this.infiniteSearchPred.isComplex) coll = this.complexQueryPredicate(checked, defaults, isNotEqual);
            if ((this.options.type === "date" || this.options.type === "datetime") && check.length) {
                length = check.length - 1;
                val = this.values[(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(check[parseInt(length.toString(), 10)], "e-ftrchk").getAttribute("uid")];
                if ((0, $3EnZW.isNullOrUndefined)(val) && isNotEqual) coll.push({
                    field: defaults.field,
                    matchCase: defaults.matchCase,
                    operator: "equal",
                    predicate: "or",
                    value: null
                });
            }
            var addCurrSelection = this.infiniteRenderMod ? this.sBox.querySelector(".e-add-current") : this.cBox.querySelector(".e-add-current");
            if (addCurrSelection && addCurrSelection.classList.contains("e-check")) {
                var existingPredicate_1 = this.existingPredicate[this.options.field];
                if (existingPredicate_1) {
                    var _loop_1 = function(j) {
                        if (!coll.some(function(data) {
                            return data.value === existingPredicate_1[parseInt(j.toString(), 10)].value;
                        })) coll.push(existingPredicate_1[parseInt(j.toString(), 10)]);
                    };
                    for(var j = 0; j < existingPredicate_1.length; j++)_loop_1(j);
                } else return;
            }
            if (!this.infiniteRenderMod) this.initiateFilter(coll);
            else if (coll.length) this.initiateFilter(coll);
            else if (this.sBox.querySelector(".e-selectall").classList.contains("e-check") && !coll.length) {
                var isClearFilter = this.options.filteredColumns.some(function(value) {
                    return _this.options.field === value.field;
                });
                if (isClearFilter) this.clearFilter();
            }
        } else {
            var isClearFilter = this.options.filteredColumns.some(function(value) {
                return _this.options.field === value.field;
            });
            if (isClearFilter) this.clearFilter();
        }
    };
    CheckBoxFilterBase.prototype.complexQueryPredicate = function(checkBoxChecked, defaults, isNotEqual) {
        var value;
        var fObj;
        var coll = [];
        for(var i = 0; i < checkBoxChecked.length; i++){
            value = this.values[(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(checkBoxChecked[parseInt(i.toString(), 10)], "e-ftrchk").getAttribute("uid")];
            fObj = (0, $3EnZW.extend)({}, {
                value: value
            }, defaults);
            if (value && !value.toString().length) fObj.operator = isNotEqual ? "notequal" : "equal";
            if (value === "" || (0, $3EnZW.isNullOrUndefined)(value)) coll = coll.concat(CheckBoxFilterBase.generateNullValuePredicates(defaults));
            else coll.push(fObj);
            this.notifyFilterPrevEvent(fObj);
        }
        return coll;
    };
    CheckBoxFilterBase.prototype.infiniteFltrBtnHandler = function(coll) {
        var value;
        if (this.infiniteManualSelectMaintainPred.length) for(var i = 0; i < this.infiniteManualSelectMaintainPred.length; i++){
            var pred = this.infiniteManualSelectMaintainPred[i];
            value = pred.value + "";
            if (value === "" || (0, $3EnZW.isNullOrUndefined)(value)) {
                var dummyDefaults = {
                    predicate: pred.predicate,
                    field: pred.field,
                    type: pred.type,
                    uid: pred.uid,
                    operator: pred.operator,
                    matchCase: pred.matchCase,
                    ignoreAccent: pred.ignoreAccent
                };
                coll.push.apply(coll, CheckBoxFilterBase.generateNullValuePredicates(dummyDefaults));
            } else coll.push(this.infiniteManualSelectMaintainPred[i]);
            this.notifyFilterPrevEvent(this.infiniteManualSelectMaintainPred[i]);
        }
        if (!this.localInfiniteSelectAllClicked && this.sInput.value === "" && !(!this.options.parentCurrentViewDataCount && coll.length)) for(var i = 0; i < this.infiniteUnloadParentExistPred.length; i++){
            coll.unshift(this.infiniteUnloadParentExistPred[i]);
            this.notifyFilterPrevEvent(this.existingPredicate[this.options.field][i]);
        }
        if (this.sInput.value !== "" && (!this.localInfiniteSelectAllClicked || this.infiniteLocalSelectAll)) {
            this.infiniteSearchPred["predicate"] = "or";
            coll.unshift(this.infiniteSearchPred);
            this.notifyFilterPrevEvent(this.infiniteSearchPred);
        }
    };
    CheckBoxFilterBase.prototype.notifyFilterPrevEvent = function(predicate) {
        var args = {
            instance: this,
            handler: this.fltrBtnHandler,
            arg1: predicate.field,
            arg2: predicate.predicate,
            arg3: predicate.operator,
            arg4: predicate.matchCase,
            arg5: predicate.ignoreAccent,
            arg6: predicate.value,
            cancel: false
        };
        this.parent.notify($17b89d3b1fc93cdb$export$16e6cefe38bdd512, args);
        if (args.cancel) return;
    };
    // eslint-disable-next-line
    /** @hidden */ CheckBoxFilterBase.generateNullValuePredicates = function(defaults) {
        var coll = [];
        if (defaults.type === "string") coll.push({
            field: defaults.field,
            ignoreAccent: defaults.ignoreAccent,
            matchCase: defaults.matchCase,
            operator: defaults.operator,
            predicate: defaults.predicate,
            value: ""
        });
        coll.push({
            field: defaults.field,
            matchCase: defaults.matchCase,
            operator: defaults.operator,
            predicate: defaults.predicate,
            value: null
        });
        coll.push({
            field: defaults.field,
            matchCase: defaults.matchCase,
            operator: defaults.operator,
            predicate: defaults.predicate,
            value: undefined
        });
        return coll;
    };
    // eslint-disable-next-line
    /** @hidden */ CheckBoxFilterBase.prototype.initiateFilter = function(fColl) {
        var firstVal = fColl[0];
        var predicate;
        if (!(0, $3EnZW.isNullOrUndefined)(firstVal)) {
            predicate = firstVal.ejpredicate ? firstVal.ejpredicate : new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(firstVal.field, firstVal.operator, firstVal.value, !firstVal.matchCase, firstVal.ignoreAccent);
            for(var j = 1; j < fColl.length; j++)predicate = fColl[parseInt(j.toString(), 10)].ejpredicate !== undefined ? predicate[fColl[parseInt(j.toString(), 10)].predicate](fColl[parseInt(j.toString(), 10)].ejpredicate) : predicate[fColl[parseInt(j.toString(), 10)].predicate](fColl[parseInt(j.toString(), 10)].field, fColl[parseInt(j.toString(), 10)].operator, fColl[parseInt(j.toString(), 10)].value, !fColl[parseInt(j.toString(), 10)].matchCase, fColl[parseInt(j.toString(), 10)].ignoreAccent);
            var args = {
                action: "filtering",
                filterCollection: fColl,
                field: this.options.field,
                ejpredicate: (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicate)
            };
            this.options.handler(args);
        }
    };
    CheckBoxFilterBase.prototype.isForeignColumn = function(col) {
        return col.isForeignColumn ? col.isForeignColumn() : false;
    };
    CheckBoxFilterBase.prototype.refreshCheckboxes = function() {
        var _this = this;
        var val = this.sInput.value;
        var column = this.options.column;
        var query = this.isForeignColumn(column) ? this.foreignKeyQuery.clone() : this.options.query.clone();
        var foreignQuery = this.options.query.clone();
        var pred = query.queries.filter(function(e) {
            return e && e.fn === "onWhere";
        })[0];
        query.queries = [];
        foreignQuery.queries = [];
        var parsed = this.options.type !== "string" && parseFloat(val) ? parseFloat(val) : val;
        var operator = this.options.isRemote ? this.options.type === "string" ? "contains" : "equal" : this.options.type ? "contains" : "equal";
        var matchCase = true;
        var ignoreAccent = this.options.ignoreAccent;
        var field = this.isForeignColumn(column) ? column.foreignKeyValue : column.field;
        parsed = parsed === "" || parsed === undefined ? undefined : parsed;
        var coll = [];
        var defaults = {
            field: field,
            predicate: "or",
            uid: this.options.uid,
            operator: "equal",
            type: this.options.type,
            matchCase: matchCase,
            ignoreAccent: ignoreAccent
        };
        var predicte;
        var moduleName = this.options.dataManager.adaptor.getModuleName;
        if (this.options.type === "boolean") {
            if (parsed !== undefined && this.getLocalizedLabel("FilterTrue").toLowerCase().indexOf(parsed.toLowerCase()) !== -1) parsed = "true";
            else if (parsed !== undefined && this.getLocalizedLabel("FilterFalse").toLowerCase().indexOf(parsed.toLowerCase()) !== -1) parsed = "false";
            if (parsed !== undefined && this.getLocalizedLabel("FilterTrue").toLowerCase().indexOf(parsed.toLowerCase()) !== -1 && moduleName) // eslint-disable-next-line no-constant-condition
            parsed = (moduleName(), true);
            else if (parsed !== undefined && this.getLocalizedLabel("FilterFalse").toLowerCase().indexOf(parsed.toLowerCase()) !== -1 && moduleName) // eslint-disable-next-line no-constant-condition
            parsed = (moduleName(), false);
            operator = "equal";
        }
        if ((this.options.type === "date" || this.options.type === "datetime" || this.options.type === "dateonly") && this.options.format) {
            var intl = new (0, $bWDaN.Internationalization)();
            var format = typeof this.options.format === "string" ? this.options.format : this.options.format.format;
            if (format) parsed = intl.parseDate(val, {
                format: format
            }) || new Date(val);
            else parsed = new Date(val);
            if (this.options.type === "dateonly") parsed = parsed.getFullYear() + "-" + (0, $748c2240e597a9b7$export$6ff84f8b5533737)(parsed.getMonth() + 1) + "-" + (0, $748c2240e597a9b7$export$6ff84f8b5533737)(parsed.getDate());
        }
        this.infiniteSearchValChange = true;
        this.infiniteLoadedElem = [];
        this.infiniteLocalSelectAll = true;
        this.localInfiniteSelectAllClicked = false;
        this.localInfiniteSelectionInteracted = false;
        this.infiniteSkipCnt = 0;
        this.infiniteDataCount = 0;
        this.infiniteManualSelectMaintainPred = [];
        if (this.sInput.value === "") this.infiniteUnloadParentExistPred = this.infiniteRenderMod && this.existingPredicate[this.options.column.field] ? this.existingPredicate[this.options.column.field].slice() : [];
        else this.infiniteUnloadParentExistPred = [];
        this.addDistinct(query);
        var args = {
            requestType: $17b89d3b1fc93cdb$export$cbe36cdf89a5e152,
            filterModel: this,
            columnName: field,
            column: column,
            operator: operator,
            matchCase: matchCase,
            ignoreAccent: ignoreAccent,
            filterChoiceCount: null,
            query: query,
            value: parsed
        };
        if (this.infiniteRenderMod && this.parent.filterSettings.itemsCount) args.filterChoiceCount = this.parent.filterSettings.itemsCount;
        this.parent.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, args, function(filterargs) {
            // eslint-disable-next-line no-self-assign
            filterargs.operator = filterargs.operator;
            predicte = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, filterargs.operator, args.value, filterargs.matchCase, filterargs.ignoreAccent);
            if (_this.options.type === "date" || _this.options.type === "datetime" || _this.options.type === "dateonly") {
                operator = "equal";
                var filterObj = {
                    field: field,
                    operator: operator,
                    value: parsed,
                    matchCase: matchCase,
                    ignoreAccent: ignoreAccent
                };
                if (!(0, $3EnZW.isNullOrUndefined)(parsed)) predicte = (0, $748c2240e597a9b7$export$4c58a38283ee9c83)(filterObj, _this.options.type);
            }
            if (val && typeof val === "string" && _this.isBlanks && _this.getLocalizedLabel("Blanks").toLowerCase().indexOf(val.toLowerCase()) >= 0) {
                coll = coll.concat(CheckBoxFilterBase.generateNullValuePredicates(defaults));
                var emptyValPredicte = CheckBoxFilterBase.generatePredicate(coll);
                emptyValPredicte.predicates.push(predicte);
                predicte = emptyValPredicte;
                query.where(emptyValPredicte);
            } else if (val.length) {
                predicte = !(0, $3EnZW.isNullOrUndefined)(pred) ? predicte.and(pred.e) : predicte;
                query.where(predicte);
            } else if (!(0, $3EnZW.isNullOrUndefined)(pred)) {
                predicte = pred.e;
                query.where(pred.e);
            }
            _this.infiniteSearchPred = predicte;
            filterargs.filterChoiceCount = !(0, $3EnZW.isNullOrUndefined)(filterargs.filterChoiceCount) ? filterargs.filterChoiceCount : 1000;
            if (_this.infiniteRenderMod && _this.parent.filterSettings.itemsCount !== filterargs.filterChoiceCount) _this.parent.filterSettings.itemsCount = args.filterChoiceCount;
            var fPredicate = {};
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(_this.spinner);
            _this.renderEmpty = false;
            if (_this.isForeignColumn(column) && val.length) {
                var colData = "result" in column.dataSource ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(column.dataSource.result) : column.dataSource;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                colData.executeQuery(query).then(function(e) {
                    var columnData = _this.options.column.columnData;
                    _this.options.column.columnData = e.result;
                    _this.parent.notify($17b89d3b1fc93cdb$export$40afe28aee4686d4, {
                        predicate: fPredicate,
                        column: column
                    });
                    if (fPredicate.predicate.predicates.length) foreignQuery.where(fPredicate.predicate);
                    else _this.renderEmpty = true;
                    _this.options.column.columnData = columnData;
                    if (_this.infiniteRenderMod) {
                        _this.infiniteInitialLoad = (0, $3EnZW.isNullOrUndefined)(_this.fullData) ? true : false;
                        _this.makeInfiniteScrollRequest(foreignQuery);
                        foreignQuery.requiresCount();
                    } else foreignQuery.take(filterargs.filterChoiceCount);
                    _this.search(filterargs, foreignQuery);
                });
            } else {
                if (_this.infiniteRenderMod && _this.parent.filterSettings.itemsCount) {
                    _this.infiniteInitialLoad = (0, $3EnZW.isNullOrUndefined)(_this.fullData) ? true : false;
                    _this.makeInfiniteScrollRequest(query);
                    query.requiresCount();
                } else query.take(filterargs.filterChoiceCount);
                _this.search(filterargs, query);
            }
        });
    };
    CheckBoxFilterBase.prototype.search = function(args, query) {
        if (this.parent.dataSource && "result" in this.parent.dataSource) this.filterEvent(args, query);
        else this.processSearch(query);
    };
    CheckBoxFilterBase.prototype.getPredicateFromCols = function(columns, isExecuteLocal) {
        var predicates = CheckBoxFilterBase.getPredicate(columns, isExecuteLocal);
        var predicateList = [];
        var fPredicate = {};
        var isGrid = this.parent.getForeignKeyColumns !== undefined;
        var foreignColumn = isGrid ? this.parent.getForeignKeyColumns() : [];
        for(var _i = 0, _a = Object.keys(predicates); _i < _a.length; _i++){
            var prop = _a[_i];
            var col = void 0;
            if (isGrid && !this.parent.getColumnByField(prop)) col = (0, $748c2240e597a9b7$export$e0d896ad751b9ff7)(prop, foreignColumn);
            if (col) {
                this.parent.notify($17b89d3b1fc93cdb$export$40afe28aee4686d4, {
                    predicate: fPredicate,
                    column: col
                });
                if (fPredicate.predicate.predicates.length) predicateList.push((0, $56262f229d1cff45$export$7ce636318c5a9f17).or(fPredicate.predicate.predicates));
            } else predicateList.push(predicates["" + prop]);
        }
        return predicateList.length && (0, $56262f229d1cff45$export$7ce636318c5a9f17).and(predicateList);
    };
    CheckBoxFilterBase.prototype.getQuery = function() {
        return this.parent.getQuery ? this.parent.getQuery().clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
    };
    CheckBoxFilterBase.prototype.getAllData = function() {
        var _this = this;
        this.customQuery = false;
        var query = this.getQuery();
        var moduleName = this.options.dataManager.adaptor.getModuleName;
        if (!(!(0, $3EnZW.isNullOrUndefined)(this.parent.getDataModule) && moduleName && moduleName() === "ODataV4Adaptor")) query.requiresCount(); //consider take query
        this.addDistinct(query);
        var args = {
            requestType: $17b89d3b1fc93cdb$export$dd083bccb8aaee05,
            query: query,
            filterChoiceCount: null
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        if (this.infiniteRenderMod && this.parent.filterSettings.itemsCount) args.filterChoiceCount = this.parent.filterSettings.itemsCount;
        this.parent.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, args, function(args) {
            args.filterChoiceCount = !(0, $3EnZW.isNullOrUndefined)(args.filterChoiceCount) ? args.filterChoiceCount : 1000;
            if (_this.infiniteRenderMod && _this.parent.filterSettings.itemsCount !== args.filterChoiceCount) _this.parent.filterSettings.itemsCount = args.filterChoiceCount;
            if (!_this.infiniteRenderMod) query.take(args.filterChoiceCount);
            if (!args.query.distincts.length || _this.infiniteRenderMod) {
                _this.customQuery = true;
                _this.queryGenerate(query);
            }
            if (_this.infiniteRenderMod) {
                _this.infiniteInitialLoad = (0, $3EnZW.isNullOrUndefined)(_this.fullData) ? true : false;
                _this.makeInfiniteScrollRequest(query);
            }
            if (_this.parent.dataSource && "result" in _this.parent.dataSource) _this.filterEvent(args, query);
            else _this.processDataOperation(query, true);
        });
    };
    CheckBoxFilterBase.prototype.addDistinct = function(query) {
        var _this = this;
        var _a;
        var filteredColumn = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).distinct(this.options.filteredColumns, "field");
        if (filteredColumn.indexOf(this.options.column.field) <= -1) filteredColumn = filteredColumn.concat(this.options.column.field);
        if (!this.infiniteRenderMod) query.distinct(filteredColumn);
        if (this.infiniteRenderMod && !this.options.isRemote && this.sInput.value === "") {
            this.options.dataSource = this.options.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? this.options.dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.options.dataSource);
            this.infinitePermenantLocalData = this.options.dataSource.dataSource.json.slice();
            this.options.dataSource.dataSource.json = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).distinct((_a = this.options.parentFilteredLocalRecords).concat.apply(_a, this.infinitePermenantLocalData), this.options.column.field, true);
            if (this.isForeignColumn(this.options.column)) {
                this.options.column.dataSource = this.options.column.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? this.options.column.dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.options.column.dataSource);
                this.options.dataSource.dataSource.json = this.options.dataSource.dataSource.json.map(function(item, i) {
                    return Object.assign({}, item, _this.options.column.dataSource.dataSource.json[i]);
                });
            }
        } else if (this.infiniteRenderMod && this.options.isRemote) {
            query.select(this.options.column.field);
            query.sortBy(this.options.column.field, "ascending");
            var moduleName = this.options.dataManager.adaptor.getModuleName;
            if (moduleName && moduleName() && (moduleName() === "ODataV4Adaptor" || moduleName() === "WebApiAdaptor" || moduleName() === "CustomDataAdaptor" || moduleName() === "GraphQLAdaptor" || moduleName() === "ODataAdaptor")) query.distinct(filteredColumn);
        }
        return query;
    };
    CheckBoxFilterBase.prototype.filterEvent = function(args, query) {
        var _this = this;
        var defObj = (0, $748c2240e597a9b7$export$5bafd3a29592d203)(args, query);
        this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, defObj.state);
        var def = defObj.deffered;
        def.promise.then(function(e) {
            _this.dataSuccess(e);
        });
    };
    CheckBoxFilterBase.prototype.infiniteScrollMouseKeyDownHandler = function() {
        (0, $aqzbR.EventHandler).remove(this.cBox, "scroll", this.infiniteScrollHandler);
    };
    CheckBoxFilterBase.prototype.infiniteScrollMouseKeyUpHandler = function(e) {
        var _this = this;
        (0, $aqzbR.EventHandler).add(this.cBox, "scroll", this.infiniteScrollHandler, this);
        var target = this.cBox;
        if (target.children.length > 1 && (target.scrollTop >= target.scrollHeight - target.offsetHeight || target.scrollTop <= 0)) this.infiniteScrollHandler();
        (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = setTimeout(function() {
            _this.clickHandler(e);
            (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = null;
        }, 0);
    };
    CheckBoxFilterBase.prototype.getListHeight = function(element) {
        var listDiv = (0, $4ZDHT.createElement)("div", {
            className: "e-ftrchk",
            styles: "visibility: hidden"
        });
        listDiv.innerHTML = '<div class="e-checkbox-wrapper"><span class="e-frame e-icons e-check"></span><span class="e-label e-checkboxfiltertext">A</div></span>';
        element.appendChild(listDiv);
        var rect = listDiv.getBoundingClientRect();
        element.removeChild(listDiv);
        var listHeight = Math.round(rect.height);
        return listHeight;
    };
    CheckBoxFilterBase.prototype.getShimmerTemplate = function() {
        return '<span class="e-mask e-skeleton e-skeleton-text e-shimmer-wave"></span>';
    };
    /**
     * @returns {void}
     * @hidden
     */ CheckBoxFilterBase.prototype.showMask = function() {
        var maskRowCount = 5;
        var maskItemHeight;
        var maskList = this.parent.createElement("div", {
            id: this.id + this.options.type + "_CheckBoxMaskList",
            className: "e-checkboxlist e-fields e-infinite-list e-masklist",
            styles: "z-index: 10;"
        });
        var wrapperElem = this.cBox;
        this.removeMask();
        if (wrapperElem) {
            var computedStyle = getComputedStyle(wrapperElem);
            var liHeight = this.getListHeight(wrapperElem);
            var height = wrapperElem.children.length ? parseInt(computedStyle.height, 10) : Math.floor(parseInt(computedStyle.height.split("px")[0], 10)) - 5;
            if (this.parent.enableAdaptiveUI && this.infiniteRenderMod) {
                maskList.style.height = height - liHeight + "px";
                this.dlg.querySelector(".e-dlg-content").style.overflow = "hidden";
            }
            var backgroundColor = this.isExcel && !wrapperElem.children.length && !this.dlg.classList.contains("e-excelfilter") ? "" : getComputedStyle(this.dlg.querySelector(".e-dlg-content")).backgroundColor;
            maskList.style.cssText = "width: " + computedStyle.width + "; min-height: " + computedStyle.minHeight + "; height: " + height + "px; margin: " + computedStyle.margin + "; border-style: " + computedStyle.borderStyle + "; border-width: " + computedStyle.borderWidth + "; border-color: " + computedStyle.borderColor + "; position: absolute; background-color: " + backgroundColor + ";";
            maskRowCount = Math.floor(height / liHeight);
            maskRowCount = wrapperElem.children.length > maskRowCount ? wrapperElem.children.length : maskRowCount;
            maskItemHeight = liHeight + "px";
        }
        var maskTemplate = '<div class="e-ftrchk e-mask-ftrchk" style="width: 100%; height:' + maskItemHeight + ';">' + '<div class="e-checkbox-wrapper" style="width: 100%;"><input class="e-chk-hidden">' + this.getShimmerTemplate() + this.getShimmerTemplate() + "</div></div>";
        maskList.innerHTML = "";
        if (!wrapperElem.children.length) {
            this.spinner.insertAdjacentHTML("beforebegin", maskTemplate);
            var maskSpan = [].slice.call(this.spinner.parentElement.querySelectorAll(".e-mask:not(.e-mask-checkbox-filter-intent):not(.e-mask-checkbox-filter-span-intent)"));
            maskSpan[0].classList.add("e-mask-checkbox-filter-intent");
            maskSpan[1].classList.add("e-mask-checkbox-filter-span-intent");
        }
        this.spinner.insertBefore(maskList, this.cBox);
        for(var i = 0; maskRowCount && i < maskRowCount; i++){
            maskList.innerHTML += maskTemplate;
            var maskSpan = [].slice.call(maskList.querySelectorAll(".e-mask:not(.e-mask-checkbox-filter-intent):not(.e-mask-checkbox-filter-span-intent)"));
            maskSpan[0].classList.add("e-mask-checkbox-filter-intent");
            maskSpan[1].classList.add("e-mask-checkbox-filter-span-intent");
        }
        if (this.cBox) maskList.scrollTop = this.cBox.scrollTop;
    };
    CheckBoxFilterBase.prototype.removeMask = function() {
        var maskLists = this.dialogObj.element.querySelectorAll(".e-mask-ftrchk");
        if (maskLists.length) for(var i = 0; i < maskLists.length; i++)(0, $4ZDHT.remove)(maskLists[i]);
        var maskParent = this.dialogObj.element.querySelector(".e-checkboxlist.e-masklist");
        if (maskParent) (0, $4ZDHT.remove)(this.dialogObj.element.querySelector(".e-checkboxlist.e-masklist"));
    };
    CheckBoxFilterBase.prototype.infiniteScrollHandler = function() {
        var target = this.cBox;
        if (target.scrollTop >= target.scrollHeight - target.offsetHeight && !this.infiniteQueryExecutionPending && this.infiniteLoadedElem.length <= this.infiniteSkipCnt + this.parent.filterSettings.itemsCount && this.cBox.children.length === this.parent.filterSettings.itemsCount * 3 && (!this.infiniteDataCount || this.infiniteDataCount > this.infiniteSkipCnt + this.parent.filterSettings.itemsCount)) {
            this.makeInfiniteScrollRequest();
            this.prevInfiniteScrollDirection = "down";
        } else if (target.scrollTop >= target.scrollHeight - target.offsetHeight && !this.infiniteQueryExecutionPending && this.infiniteLoadedElem.length > this.infiniteSkipCnt + this.parent.filterSettings.itemsCount && this.cBox.children.length === this.parent.filterSettings.itemsCount * 3) {
            this.infiniteRemoveElements([].slice.call(this.cBox.children).splice(0, this.parent.filterSettings.itemsCount));
            this.infiniteSkipCnt += this.prevInfiniteScrollDirection === "down" ? this.parent.filterSettings.itemsCount : this.parent.filterSettings.itemsCount * 3;
            (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.cBox, this.infiniteLoadedElem.slice(this.infiniteSkipCnt, this.parent.filterSettings.itemsCount + this.infiniteSkipCnt));
            this.prevInfiniteScrollDirection = "down";
        } else if (target.scrollTop === 0 && !this.infiniteInitialLoad && !this.infiniteSearchValChange && this.infiniteSkipCnt && this.infiniteLoadedElem.length && this.infiniteLoadedElem.length > this.parent.filterSettings.itemsCount * 3 && this.cBox.children.length === this.parent.filterSettings.itemsCount * 3) {
            this.infiniteRemoveElements([].slice.call(this.cBox.children).splice(this.parent.filterSettings.itemsCount * 2, this.parent.filterSettings.itemsCount));
            this.infiniteSkipCnt -= this.prevInfiniteScrollDirection === "up" ? this.parent.filterSettings.itemsCount : this.parent.filterSettings.itemsCount * 3;
            this.infiniteAppendElements([].slice.call(this.infiniteLoadedElem.slice(this.infiniteSkipCnt, this.infiniteSkipCnt + this.parent.filterSettings.itemsCount)));
            this.cBox.scrollTop = this.infiniteScrollAppendDiff;
            this.prevInfiniteScrollDirection = "up";
        } else if (target.scrollTop === 0 && !this.infiniteInitialLoad && !this.infiniteSearchValChange && this.infiniteSkipCnt && this.infiniteLoadedElem.length && this.cBox.children.length < this.parent.filterSettings.itemsCount * 3) {
            this.infiniteRemoveElements([].slice.call(this.cBox.children).splice(this.parent.filterSettings.itemsCount * 2, this.infiniteDataCount % this.parent.filterSettings.itemsCount));
            this.infiniteSkipCnt = (Math.floor(this.infiniteDataCount / this.parent.filterSettings.itemsCount) - 3) * this.parent.filterSettings.itemsCount;
            this.infiniteAppendElements([].slice.call(this.infiniteLoadedElem.slice(this.infiniteSkipCnt, this.infiniteSkipCnt + this.parent.filterSettings.itemsCount)));
            this.cBox.scrollTop = this.infiniteScrollAppendDiff;
            this.prevInfiniteScrollDirection = "up";
        }
    };
    CheckBoxFilterBase.prototype.infiniteRemoveElements = function(removeElem) {
        for(var i = 0; i < removeElem.length; i++)(0, $4ZDHT.remove)(removeElem[i]);
    };
    CheckBoxFilterBase.prototype.infiniteAppendElements = function(appendElem) {
        for(var i = 0; i < appendElem.length; i++)this.cBox.insertBefore(appendElem[i], this.cBox.children[i]);
    };
    CheckBoxFilterBase.prototype.makeInfiniteScrollRequest = function(query) {
        var _this = this;
        if (!this.infiniteInitialLoad && this.parent.filterSettings && this.parent.filterSettings.loadingIndicator === "Shimmer") setTimeout(function() {
            if (_this.infiniteQueryExecutionPending) _this.showMask();
        }, 500);
        else if (!this.infiniteInitialLoad) {
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.spinner,
                cssClass: this.parent.cssClass ? this.parent.cssClass : null
            }, this.parent.createElement);
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinner);
        }
        var fName = "fn";
        if (this.infiniteQuery && this.infiniteQuery.queries && this.infiniteQuery.queries.length) {
            for(var i = 0; i < this.infiniteQuery.queries.length; i++)if (this.infiniteQuery.queries[i]["" + fName] === "onTake" || this.infiniteQuery.queries[i]["" + fName] === "onSkip") {
                this.infiniteQuery.queries.splice(i, 1);
                i--;
            }
        }
        var existQuery = query ? true : false;
        query = query ? query : this.infiniteQuery;
        if (this.infiniteInitialLoad || this.infiniteSearchValChange) this.infiniteSkipCnt = 0;
        else this.infiniteSkipCnt += this.parent.filterSettings.itemsCount;
        query.skip(this.infiniteSkipCnt);
        if (this.infiniteInitialLoad || this.infiniteSearchValChange) {
            query.take(this.parent.filterSettings.itemsCount * 3);
            this.infiniteSkipCnt += this.parent.filterSettings.itemsCount * 2;
        } else query.take(this.parent.filterSettings.itemsCount);
        if (!existQuery) {
            this.processDataOperation(query);
            this.infiniteQueryExecutionPending = true;
        }
    };
    CheckBoxFilterBase.prototype.processDataOperation = function(query, isInitial) {
        var _this = this;
        this.options.dataSource = this.options.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? this.options.dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.options.dataSource);
        var allPromise = [];
        var runArray = [];
        if (this.isForeignColumn(this.options.column) && isInitial) {
            var colData = "result" in this.options.column.dataSource ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.options.column.dataSource.result) : this.options.column.dataSource;
            this.foreignKeyQuery.params = query.params;
            allPromise.push(colData.executeQuery(this.foreignKeyQuery));
            runArray.push(function(data) {
                return _this.foreignKeyData = data;
            });
        }
        if (this.infiniteRenderMod) {
            this.infiniteQuery = query.clone();
            if (this.infiniteInitialLoad) {
                this.cBox.classList.add("e-checkbox-infinitescroll");
                (0, $aqzbR.EventHandler).add(this.cBox, "scroll", this.infiniteScrollHandler, this);
                (0, $aqzbR.EventHandler).add(this.cBox, "mouseup", this.infiniteScrollMouseKeyUpHandler, this);
                (0, $aqzbR.EventHandler).add(this.cBox, "mousedown", this.infiniteScrollMouseKeyDownHandler, this);
            } else if (this.infiniteSearchValChange) this.cBox.innerHTML = "";
        }
        if (this.infiniteRenderMod && this.infiniteInitialLoad && !this.options.isRemote) {
            var field = this.isForeignColumn(this.options.column) ? this.options.foreignKeyValue : this.options.column.field;
            this.options.dataSource.executeQuery(new (0, $56262f229d1cff45$export$62297b13309008b2)().sortBy(field, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnAscending)).then(function(e) {
                _this.options.dataSource.dataSource.json = e.result;
                _this.executeQueryOperations(query, allPromise, runArray);
            });
        } else this.executeQueryOperations(query, allPromise, runArray);
    };
    CheckBoxFilterBase.prototype.executeQueryOperations = function(query, allPromise, runArray) {
        var _this = this;
        allPromise.push(this.options.dataSource.executeQuery(query));
        runArray.push(this.dataSuccess.bind(this));
        var i = 0;
        Promise.all(allPromise).then(function(e) {
            _this.infiniteQueryExecutionPending = _this.infiniteRenderMod ? false : _this.infiniteQueryExecutionPending;
            for(var j = 0; j < e.length; j++){
                _this.infiniteDataCount = _this.infiniteRenderMod && !_this.infiniteDataCount ? e[j].count : _this.infiniteDataCount;
                runArray[i++](e[parseInt(j.toString(), 10)].result);
            }
        }).catch(function() {
            if (_this.infiniteRenderMod && _this.parent.filterSettings && _this.parent.filterSettings.loadingIndicator === "Shimmer") _this.parent.showMaskRow(undefined, _this.dialogObj.element);
        });
    };
    CheckBoxFilterBase.prototype.dataSuccess = function(e) {
        if (!this.infiniteInitialLoad && this.infiniteDataCount && (this.infiniteSkipCnt >= this.infiniteDataCount && !this.infiniteSearchValChange || e.length === 0)) return;
        this.fullData = e;
        var args1 = {
            dataSource: this.fullData,
            executeQuery: true,
            field: this.options.field
        };
        this.parent.notify($17b89d3b1fc93cdb$export$99d678e9ef145614, args1);
        if (args1.executeQuery) {
            var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
            if (!this.customQuery) {
                this.isExecuteLocal = true;
                this.queryGenerate(query);
                this.isExecuteLocal = false;
            }
            // query.select(this.options.field);
            var result = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(args1.dataSource).executeLocal(query);
            var col = this.options.column;
            this.filteredData = CheckBoxFilterBase.getDistinct(result, this.options.field, col, this.foreignKeyData, this).records || [];
        }
        var data = args1.executeQuery ? this.filteredData : args1.dataSource;
        this.processDataSource(null, true, data, args1);
        if (this.sInput && (this.infiniteRenderMod && this.infiniteInitialLoad || !this.infiniteRenderMod)) this.sInput.focus();
        if (this.infiniteInitialLoad || this.infiniteSearchValChange) {
            this.infiniteInitialLoad = false;
            this.infiniteSearchValChange = false;
        }
        var args = {
            requestType: $17b89d3b1fc93cdb$export$cd06942d33b49aad,
            columnName: this.options.field,
            columnType: this.options.type
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        this.parent.notify($17b89d3b1fc93cdb$export$75dd3538f0f880b3, args);
        if (this.isCheckboxFilterTemplate) (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinner);
    };
    CheckBoxFilterBase.prototype.queryGenerate = function(query) {
        if (this.parent.searchSettings && this.parent.searchSettings.key.length) {
            var moduleName = this.options.dataManager.adaptor.getModuleName;
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getDataModule) && moduleName && moduleName() === "ODataV4Adaptor") this.parent.getDataModule().searchQuery(query);
            else {
                var searchSettings = this.parent.searchSettings;
                var fields = searchSettings.fields.length ? searchSettings.fields : this.options.columns.map(function(f) {
                    return f.field;
                });
                query.search(searchSettings.key, fields, searchSettings.operator, searchSettings.ignoreCase, searchSettings.ignoreAccent);
            }
        }
        if (this.options.filteredColumns.length) {
            var cols = [];
            for(var i = 0; i < this.options.filteredColumns.length; i++){
                var filterColumn = this.options.filteredColumns[parseInt(i.toString(), 10)];
                if (this.options.uid) {
                    filterColumn.uid = filterColumn.uid || this.parent.getColumnByField(filterColumn.field).uid;
                    if (filterColumn.uid !== this.options.uid) cols.push(this.options.filteredColumns[parseInt(i.toString(), 10)]);
                } else if (filterColumn.field !== this.options.field) cols.push(this.options.filteredColumns[parseInt(i.toString(), 10)]);
            }
            var predicate = this.getPredicateFromCols(cols, this.isExecuteLocal);
            if (predicate) query.where(predicate);
        }
    };
    CheckBoxFilterBase.prototype.processDataSource = function(query, isInitial, dataSource, args) {
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinner);
        // query = query ? query : this.options.query.clone();
        // query.requiresCount();
        // let result: Object = new DataManager(dataSource as JSON[]).executeLocal(query);
        // let res: { result: Object[] } = result as { result: Object[] };
        this.isExecuteLocal = true;
        this.updateResult();
        this.isExecuteLocal = false;
        var args1 = {
            dataSource: this.fullData,
            isCheckboxFilterTemplate: false,
            column: this.options.column,
            element: this.cBox,
            type: this.options.type,
            format: this.options.type,
            btnObj: this.options.isResponsiveFilter ? null : this.dialogObj.btnObj[0],
            searchBox: this.searchBox
        };
        this.parent.notify($17b89d3b1fc93cdb$export$b659f27f1089267e, args1);
        this.isCheckboxFilterTemplate = args1.isCheckboxFilterTemplate;
        if (!this.isCheckboxFilterTemplate) this.createFilterItems(dataSource, isInitial, args);
        else if (this.infiniteRenderMod && this.parent.filterSettings && this.parent.filterSettings.loadingIndicator === "Shimmer") this.removeMask();
    };
    CheckBoxFilterBase.prototype.processSearch = function(query) {
        this.processDataOperation(query);
    };
    CheckBoxFilterBase.prototype.updateResult = function() {
        this.result = {};
        var predicate = this.infiniteRenderMod && this.existingPredicate[this.options.field] ? this.getPredicateFromCols(this.existingPredicate[this.options.field], this.isExecuteLocal) : this.getPredicateFromCols(this.options.filteredColumns, this.isExecuteLocal);
        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (predicate) query.where(predicate);
        this.parent.notify($17b89d3b1fc93cdb$export$3e9336abe13e1480, {
            query: query
        });
        var result = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.fullData).executeLocal(query);
        for(var _i = 0, result_1 = result; _i < result_1.length; _i++){
            var res = result_1[_i];
            this.result[(0, $748c2240e597a9b7$export$93534728ecb2e7b9)(this.options.field, res)] = true;
        }
    };
    CheckBoxFilterBase.prototype.clickHandler = function(e) {
        var _a;
        if (!(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$98f03c5d19621d70).timer)) clearTimeout((0, $748c2240e597a9b7$export$98f03c5d19621d70).timer);
        var target = e.target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.loadingIndicator) && this.parent.loadingIndicator.indicatorType === "Shimmer" && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-mask-ftrchk")) return;
        var elem = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-checkbox-wrapper");
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-searchbox")) this.searchBoxClick(e);
        if (elem && !this.isCheckboxFilterTemplate) {
            var selectAll = elem.querySelector(".e-selectall");
            if (selectAll) this.updateAllCBoxes(!selectAll.classList.contains("e-check"));
            else {
                (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(elem.parentElement);
                if (this.infiniteRenderMod && !elem.parentElement.querySelector(".e-add-current")) {
                    this.localInfiniteSelectionInteracted = true;
                    var caseSen = this.options.allowCaseSensitive;
                    var span = elem.parentElement.querySelector(".e-frame");
                    var input = span.previousSibling;
                    var optr = input.checked ? "equal" : "notequal";
                    var pred = input.checked ? "or" : "and";
                    var defaults = {
                        field: this.options.field,
                        predicate: pred,
                        uid: this.options.uid,
                        operator: optr,
                        type: this.options.type,
                        matchCase: caseSen,
                        ignoreAccent: this.options.ignoreAccent
                    };
                    var value = this.values[(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(input, "e-ftrchk").getAttribute("uid")];
                    this.updateInfiniteManualSelectPred(defaults, value);
                    if (this.infiniteRenderMod && !this.options.isRemote && this.options.parentTotalDataCount && this.infiniteUnloadParentExistPred.length) {
                        var predicate = this.getPredicateFromCols((_a = this.options.filteredColumns).concat.apply(_a, this.infiniteManualSelectMaintainPred), true);
                        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
                        if (predicate) query.where(predicate);
                        var result = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.infinitePermenantLocalData).executeLocal(query);
                        if (this.options.parentTotalDataCount !== result.length) this.options.parentTotalDataCount = result.length;
                        if (!this.options.parentTotalDataCount && this.infiniteUnloadParentExistPred.length) this.infiniteUnloadParentExistPred = [];
                    }
                    if (this.infiniteUnloadParentExistPred.length && (this.options.parentTotalDataCount === this.infiniteDataCount || !this.options.parentTotalDataCount)) this.infiniteUnloadParentExistPred = [];
                }
            }
            this.updateIndeterminatenBtn();
            elem.querySelector(".e-chk-hidden").focus();
        }
        this.setFocus((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(elem, "e-ftrchk"));
    };
    CheckBoxFilterBase.prototype.updateInfiniteManualSelectPred = function(defaults, value) {
        for(var i = 0; i < this.infiniteManualSelectMaintainPred.length; i++){
            var predmdl = this.infiniteManualSelectMaintainPred[i];
            if (predmdl.value + "" === value + "" && (predmdl.operator === "equal" || predmdl.operator === "notequal")) {
                this.infiniteManualSelectMaintainPred.splice(i, 1);
                break;
            }
        }
        if (defaults.predicate === "or" && (!this.localInfiniteSelectAllClicked || !this.infiniteLocalSelectAll) || defaults.predicate === "and" && (!this.localInfiniteSelectAllClicked || this.infiniteLocalSelectAll)) {
            this.infiniteManualSelectMaintainPred.push((0, $3EnZW.extend)({}, {
                value: value
            }, defaults));
            if (defaults.predicate === "or") this.options.parentTotalDataCount++;
            else this.options.parentTotalDataCount--;
        }
    };
    /**
     * Method to set the next target element on keyboard navigation using arrow keys.
     *
     * @param {KeyboardEventArgs} e - Defines the Keyboard event argument
     * @param {HTMLElement[]} focusableElements - Defines the Focusable elements
     * @returns {void}
     */ CheckBoxFilterBase.prototype.focusNextOrPrev = function(e, focusableElements) {
        var nextIndex = e.key === "ArrowUp" ? focusableElements.indexOf(document.activeElement) - 1 : focusableElements.indexOf(document.activeElement) + 1;
        var nextElement = focusableElements[(nextIndex + focusableElements.length) % focusableElements.length];
        // Set focus on the next / previous element
        if (nextElement) {
            nextElement.focus();
            var target = nextElement.classList.contains("e-chk-hidden") ? (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(nextElement, "e-ftrchk") : nextElement;
            this.setFocus(target);
        }
    };
    CheckBoxFilterBase.prototype.keyupHandler = function(e) {
        if (e.key === "Tab" || (e.key === "ArrowUp" || e.key === "ArrowDown") && !e.altKey) this.setFocus((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-ftrchk"));
        if ((e.key === "ArrowUp" || e.key === "ArrowDown") && !e.altKey && this.parent.filterSettings && this.parent.filterSettings.type === "CheckBox") {
            e.preventDefault();
            var focusableElements = Array.from(this.dlg.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])'));
            this.focusNextOrPrev(e, focusableElements);
        }
    };
    CheckBoxFilterBase.prototype.setFocus = function(elem) {
        var prevElem = this.dlg.querySelector(".e-chkfocus");
        if (prevElem) prevElem.classList.remove("e-chkfocus");
        if (elem && elem !== prevElem) elem.classList.add("e-chkfocus");
    };
    CheckBoxFilterBase.prototype.updateAllCBoxes = function(checked) {
        if (this.infiniteRenderMod) {
            this.localInfiniteSelectAllClicked = true;
            this.infiniteLocalSelectAll = checked;
            this.infiniteUnloadParentExistPred = [];
            this.infiniteManualSelectMaintainPred = [];
        }
        var cBoxes = this.infiniteRenderMod ? this.infiniteLoadedElem.map(function(arr) {
            return arr.querySelector(".e-frame");
        }) : [].slice.call(this.cBox.querySelectorAll(".e-frame:not(.e-add-current)"));
        for(var _i = 0, cBoxes_1 = cBoxes; _i < cBoxes_1.length; _i++){
            var cBox = cBoxes_1[_i];
            (0, $748c2240e597a9b7$export$39b02a8864b327ad)(cBox, checked);
            (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(cBox.previousSibling, checked);
        }
    };
    CheckBoxFilterBase.prototype.dialogOpen = function() {
        if (this.parent.element.classList.contains("e-device")) {
            this.dialogObj.element.querySelector(".e-input-group").classList.remove("e-input-focus");
            if (!this.options.isResponsiveFilter) this.dialogObj.element.querySelector(".e-btn").focus();
        }
    };
    CheckBoxFilterBase.prototype.createCheckbox = function(value, checked, data) {
        var elem = checked ? this.cBoxTrue.cloneNode(true) : this.cBoxFalse.cloneNode(true);
        (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(elem.querySelector("input"), checked);
        var label = elem.querySelector(".e-label");
        var dummyData = (0, $748c2240e597a9b7$export$8f9fa30750711038)({}, data, {
            column: this.options.column,
            parent: this.parent
        });
        var innerText = this.options.disableHtmlEncode ? "textContent" : "innerHTML";
        label["" + innerText] = !(0, $3EnZW.isNullOrUndefined)(value) && value.toString().length ? this.parent.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(value) : value : this.getLocalizedLabel("Blanks");
        var checkboxUid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("cbox");
        label.setAttribute("id", checkboxUid + "cboxLabel");
        elem.querySelector("input").setAttribute("aria-labelledby", label.id);
        if (label.innerHTML === this.getLocalizedLabel("Blanks")) this.isBlanks = true;
        if (typeof value === "boolean") label.innerHTML = value === true ? this.getLocalizedLabel("FilterTrue") : this.getLocalizedLabel("FilterFalse");
        (0, $4ZDHT.addClass)([
            label
        ], [
            "e-checkboxfiltertext"
        ]);
        if (this.options.template && data[this.options.column.field] !== this.getLocalizedLabel("SelectAll") && data[this.options.column.field] !== this.getLocalizedLabel("AddCurrentSelection")) {
            label.innerHTML = "";
            var isReactCompiler = this.parent.isReact && this.options.column.filter && typeof this.options.column.filter.itemTemplate !== "string";
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.parent.parentDetails.parentInstObj.isReact;
            if (isReactCompiler || isReactChild) {
                this.options.template(dummyData, this.parent, "filterItemTemplate", null, null, null, label);
                this.parent.renderTemplates();
            } else (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(label, this.options.template(dummyData, this.parent, "filterItemTemplate", null, null, null, null, this.parent.root));
        }
        return elem;
    };
    CheckBoxFilterBase.prototype.updateIndeterminatenBtn = function() {
        var cnt = this.infiniteRenderMod ? this.infiniteLoadedElem.length : this.cBox.children.length - 1;
        var className = [];
        var disabled = false;
        var elem = this.infiniteRenderMod ? this.sBox.querySelector(".e-selectall") : this.cBox.querySelector(".e-selectall");
        var selected = this.infiniteRenderMod ? this.infiniteLoadedElem.filter(function(arr) {
            return arr.querySelector(".e-check");
        }).length : this.cBox.querySelectorAll(".e-check:not(.e-selectall):not(.e-add-current)").length;
        if (this.cBox.querySelector(".e-add-current")) cnt -= 1;
        var btn;
        if (!this.options.isResponsiveFilter) {
            btn = this.dialogObj.btnObj[0];
            btn.disabled = false;
        }
        var input = elem.previousSibling;
        (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(input, false);
        input.indeterminate = false;
        if (this.infiniteRenderMod && this.sInput.value === "" && !this.options.parentCurrentViewDataCount && !this.localInfiniteSelectionInteracted && (!this.localInfiniteSelectAllClicked || !this.infiniteLocalSelectAll && !selected) && (cnt !== selected || cnt === selected)) selected = 0;
        else if (this.infiniteRenderMod && this.infiniteLoadedElem.length < this.infiniteDataCount && this.infiniteUnloadParentExistPred.length && (!selected || cnt === selected) && this.infiniteLocalSelectAll) {
            if (!selected) selected += this.infiniteUnloadParentExistPred.length;
            else cnt += this.infiniteUnloadParentExistPred.length;
        }
        if (cnt === selected) {
            if (this.infiniteRenderMod) {
                this.infiniteLocalSelectAll = true;
                this.localInfiniteSelectAllClicked = true;
                this.infiniteManualSelectMaintainPred = [];
            }
            className = [
                "e-check"
            ];
            (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(input, true);
        } else if (selected) {
            className = [
                "e-stop"
            ];
            input.indeterminate = true;
        } else {
            if (this.infiniteRenderMod) {
                this.infiniteLocalSelectAll = false;
                this.localInfiniteSelectAllClicked = true;
                this.infiniteManualSelectMaintainPred = [];
            }
            className = [
                "e-uncheck"
            ];
            disabled = true;
            if (btn) btn.disabled = true;
        }
        if (btn) {
            this.filterState = !btn.disabled;
            btn.dataBind();
        }
        (0, $4ZDHT.removeClass)([
            elem
        ], [
            "e-check",
            "e-stop",
            "e-uncheck"
        ]);
        (0, $4ZDHT.addClass)([
            elem
        ], className);
        this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
            disabled: disabled
        });
    };
    CheckBoxFilterBase.prototype.createFilterItems = function(data, isInitial, args1) {
        var _a, _b, _c;
        var cBoxes = this.parent.createElement("div");
        var btn;
        var disabled = false;
        if (!this.options.isResponsiveFilter) btn = this.dialogObj.btnObj[0];
        var nullCounter = -1;
        var key = "ejValue";
        if (!args1.executeQuery) key = args1.field;
        for(var i = 0; i < data.length; i++){
            var val = (0, $3EnZW.getValue)(key, data[parseInt(i.toString(), 10)]);
            if (val === "" || (0, $3EnZW.isNullOrUndefined)(val)) nullCounter = nullCounter + 1;
        }
        if (!this.infiniteRenderMod) this.itemsCnt = nullCounter !== -1 ? data.length - nullCounter : data.length;
        if (this.infiniteRenderMod && this.parent.filterSettings && this.parent.filterSettings.loadingIndicator === "Shimmer") this.removeMask();
        if (data.length && !this.renderEmpty) {
            var selectAllValue = this.getLocalizedLabel("SelectAll");
            var innerDiv = this.cBox.querySelector(".e-checkfltrnmdiv");
            if (innerDiv) innerDiv.classList.remove("e-checkfltrnmdiv");
            var checkBox = this.createCheckbox(selectAllValue, false, (_a = {}, _a[this.options.field] = selectAllValue, _a));
            if (this.parent.cssClass) {
                if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                    checkBox
                ], this.parent.cssClass.split(" "));
                else (0, $4ZDHT.addClass)([
                    checkBox
                ], [
                    this.parent.cssClass
                ]);
            }
            if (this.infiniteInitialLoad || !this.infiniteRenderMod) {
                var selectAll = (0, $748c2240e597a9b7$export$cc092c6fe78fc98a)((0, $748c2240e597a9b7$export$5e82334337e0f204)("cbox"), checkBox, "e-ftrchk");
                selectAll.querySelector(".e-frame").classList.add("e-selectall");
                if (this.infiniteRenderMod) {
                    selectAll.classList.add("e-infinitescroll");
                    if (this.parent.enableAdaptiveUI) this.spinner.style.height = this.spinner.offsetHeight - this.getListHeight(this.cBox) + "px";
                    this.sBox.insertBefore(selectAll, this.spinner);
                } else cBoxes.appendChild(selectAll);
            } else if (this.sBox.querySelector(".e-ftrchk .e-selectall")) {
                this.sBox.querySelector(".e-ftrchk .e-selectall").previousSibling.disabled = false;
                this.sBox.querySelector(".e-ftrchk .e-selectall").parentElement.classList.remove("e-checkbox-disabled");
            }
            var predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)("field", "equal", this.options.field);
            if (this.options.foreignKeyValue) predicate = predicate.or("field", "equal", this.options.foreignKeyValue);
            var isColFiltered = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.options.filteredColumns).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate)).length;
            if (this.sInput.value) {
                var predicateCheckBox = this.createCheckbox(this.getLocalizedLabel("AddCurrentSelection"), false, (_b = {}, _b[this.options.field] = this.getLocalizedLabel("AddCurrentSelection"), _b));
                if (this.parent.cssClass) {
                    if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                        predicateCheckBox
                    ], this.parent.cssClass.split(" "));
                    else (0, $4ZDHT.addClass)([
                        predicateCheckBox
                    ], [
                        this.parent.cssClass
                    ]);
                }
                if (this.infiniteRenderMod && !(0, $3EnZW.isNullOrUndefined)(this.sBox.children[2]) && this.sBox.children[2].innerText !== this.getLocalizedLabel("AddCurrentSelection") || !this.infiniteRenderMod) {
                    var predicateElement = (0, $748c2240e597a9b7$export$cc092c6fe78fc98a)((0, $748c2240e597a9b7$export$5e82334337e0f204)("cbox"), predicateCheckBox, "e-ftrchk");
                    predicateElement.querySelector(".e-frame").classList.add("e-add-current");
                    if (this.infiniteRenderMod) {
                        this.sBox.insertBefore(predicateElement, this.spinner);
                        var checkBoxListElem = this.spinner.querySelector(".e-checkboxlist");
                        var reduceHeight = Math.ceil(predicateElement.getBoundingClientRect().height);
                        checkBoxListElem.style.height = parseInt(getComputedStyle(checkBoxListElem).height.split("px")[0], 10) - reduceHeight + "px";
                        checkBoxListElem.style.minHeight = checkBoxListElem.style.height;
                    } else cBoxes.appendChild(predicateElement);
                } else if (this.sBox.querySelector(".e-ftrchk .e-add-current")) {
                    this.sBox.querySelector(".e-ftrchk .e-add-current").previousSibling.disabled = false;
                    this.sBox.querySelector(".e-ftrchk .e-add-current").parentElement.classList.remove("e-checkbox-disabled");
                }
            } else if (this.infiniteRenderMod && !(0, $3EnZW.isNullOrUndefined)(this.sBox.children[2]) && this.sBox.children[2].innerText === this.getLocalizedLabel("AddCurrentSelection")) {
                var checkBoxListElem = this.spinner.querySelector(".e-checkboxlist");
                var increaseHeight = Math.ceil(this.sBox.children[2].getBoundingClientRect().height);
                checkBoxListElem.style.height = parseInt(getComputedStyle(checkBoxListElem).height.split("px")[0], 10) + increaseHeight + "px";
                checkBoxListElem.style.minHeight = checkBoxListElem.style.height;
                (0, $4ZDHT.remove)(this.sBox.children[2]);
            }
            var isRndere = void 0;
            for(var i = 0; i < data.length; i++){
                var uid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("cbox");
                this.values["" + uid] = (0, $3EnZW.getValue)(key, data[parseInt(i.toString(), 10)]);
                var value = (0, $3EnZW.getValue)(this.options.field, data[parseInt(i.toString(), 10)]);
                if (this.options.formatFn) value = this.valueFormatter.toView(value, this.options.formatFn);
                var args_1 = {
                    value: value,
                    column: this.options.column,
                    data: data[parseInt(i.toString(), 10)]
                };
                this.parent.notify($17b89d3b1fc93cdb$export$1254425c2f6cc0c4, args_1);
                value = args_1.value;
                if (value === "" || (0, $3EnZW.isNullOrUndefined)(value)) {
                    if (isRndere) continue;
                    isRndere = true;
                }
                if (this.infiniteRenderMod) this.updateInfiniteUnLoadedCheckboxExistPred(value, this.infiniteUnloadParentExistPred);
                var checkbox = this.localInfiniteSelectAllClicked ? this.createCheckbox(value, this.infiniteLocalSelectAll, (0, $3EnZW.getValue)("dataObj", data[i])) : this.createCheckbox(value, this.getCheckedState(isColFiltered, this.values["" + uid]), (0, $3EnZW.getValue)("dataObj", data[i]));
                cBoxes.appendChild((0, $748c2240e597a9b7$export$cc092c6fe78fc98a)(uid, checkbox, "e-ftrchk"));
                if (this.infiniteRenderMod) cBoxes.lastChild.style.height = this.getListHeight(this.cBox) + "px";
            }
            var scrollTop = this.cBox.scrollTop;
            if (!this.infiniteRenderMod || this.infiniteSearchValChange) this.cBox.innerHTML = "";
            else if (this.infiniteRenderMod && this.cBox.children.length) this.infiniteRemoveElements([].slice.call(this.cBox.children).splice(0, this.parent.filterSettings.itemsCount));
            if (this.infiniteRenderMod) {
                (_c = this.infiniteLoadedElem).push.apply(_c, [].slice.call(cBoxes.children));
                this.itemsCnt = nullCounter !== -1 ? this.infiniteLoadedElem.length - nullCounter : this.infiniteLoadedElem.length;
            }
            if (this.infiniteUnloadParentExistPred.length && (this.infiniteLoadedElem.length >= this.infiniteDataCount || !this.options.parentCurrentViewDataCount || this.options.parentTotalDataCount === this.infiniteDataCount && this.options.parentCurrentViewDataCount)) this.infiniteUnloadParentExistPred = [];
            (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.cBox, [].slice.call(cBoxes.children));
            if (this.infiniteRenderMod && !this.infiniteScrollAppendDiff) this.infiniteScrollAppendDiff = Math.round(scrollTop - this.cBox.scrollTop);
            this.updateIndeterminatenBtn();
            if (!this.infiniteRenderMod) {
                if (btn) btn.disabled = false;
                disabled = false;
            } else if (btn && btn.disabled) disabled = true;
            else disabled = false;
        } else {
            cBoxes.appendChild(this.parent.createElement("span", {
                innerHTML: this.getLocalizedLabel("NoResult")
            }));
            this.cBox.innerHTML = "";
            if (this.infiniteRenderMod) {
                var selectAll = this.sBox.querySelector(".e-ftrchk .e-selectall");
                if (selectAll) {
                    var selectAllParent = selectAll.parentElement.parentElement;
                    if (selectAll.classList.contains("e-check")) (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(selectAllParent);
                    else if (selectAll.classList.contains("e-stop")) {
                        (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(selectAllParent);
                        selectAll.classList.remove("e-stop");
                        (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(selectAllParent);
                    }
                    selectAll.previousSibling.disabled = true;
                    selectAll.parentElement.classList.add("e-checkbox-disabled");
                }
                var addCurrSelection = this.sBox.querySelector(".e-ftrchk .e-add-current");
                if (addCurrSelection) {
                    var addCurrSelectionParent = addCurrSelection.parentElement.parentElement;
                    if (addCurrSelection.classList.contains("e-check")) (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(addCurrSelectionParent);
                    addCurrSelection.previousSibling.disabled = true;
                    addCurrSelection.parentElement.classList.add("e-checkbox-disabled");
                }
            }
            this.cBox.appendChild(this.parent.createElement("div", {
                className: "e-checkfltrnmdiv"
            }));
            (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.cBox.children[0], [].slice.call(cBoxes.children));
            if (btn) btn.disabled = true;
            disabled = true;
            this.filterState = !disabled;
        }
        if (btn && data.length) {
            this.filterState = !btn.disabled;
            btn.dataBind();
        }
        var args = {
            requestType: $17b89d3b1fc93cdb$export$dd083bccb8aaee05,
            dataSource: this.renderEmpty ? [] : data
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        this.parent.notify($17b89d3b1fc93cdb$export$75dd3538f0f880b3, args);
        this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
            disabled: disabled
        });
        if (this.infiniteRenderMod && this.infiniteInitialLoad) this.cBox.style.marginTop = "0px";
        (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinner);
    };
    CheckBoxFilterBase.prototype.updateInfiniteUnLoadedCheckboxExistPred = function(value, updatePredArr) {
        for(var j = 0; j < updatePredArr.length; j++){
            var pred = updatePredArr[j];
            var predValue = pred.value instanceof Date ? this.valueFormatter.toView(pred.value, this.options.formatFn) : pred.value;
            if (value === predValue && (pred.operator === "equal" || pred.operator === "notequal")) {
                this.infiniteManualSelectMaintainPred.push(updatePredArr[j]);
                updatePredArr.splice(j, 1);
                j--;
            }
        }
    };
    CheckBoxFilterBase.prototype.getCheckedState = function(isColFiltered, value) {
        if (!this.isFiltered || !isColFiltered) return true;
        else {
            var checkState = this.sInput.value ? true : this.result["" + value];
            if (this.infiniteRenderMod) return checkState;
            else return this.options.operator === "notequal" ? !checkState : checkState;
        }
    };
    CheckBoxFilterBase.getDistinct = function(json, field, column, foreignKeyData, checkboxFilter) {
        var len = json.length;
        var result = [];
        var value;
        var ejValue = "ejValue";
        var lookup = {};
        var isForeignKey = column && column.isForeignColumn ? column.isForeignColumn() : false;
        while(len--){
            value = json[parseInt(len.toString(), 10)];
            if (column && column.type === "dateonly" && typeof value["" + field] === "string" && value["" + field]) {
                var arr = value["" + field].split(/[^0-9.]/);
                value["" + field] = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10));
            }
            value = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(field, value); //local remote diff, check with mdu
            var currentFilterValue = typeof value === "string" && !(0, $3EnZW.isNullOrUndefined)(checkboxFilter) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !(0, $3EnZW.isNullOrUndefined)(checkboxFilter.parent) && !(0, $3EnZW.isNullOrUndefined)(checkboxFilter.parent.filterSettings) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !(0, $3EnZW.isNullOrUndefined)(checkboxFilter.parent.filterSettings.enableCaseSensitivity) ? value.toLowerCase() : value;
            if (!(currentFilterValue in lookup)) {
                var obj = {};
                obj["" + ejValue] = value;
                lookup["" + currentFilterValue] = true;
                if (isForeignKey) {
                    var foreignDataObj = (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(column, {}, value, foreignKeyData)[0];
                    (0, $3EnZW.setValue)($17b89d3b1fc93cdb$export$4e76384d33160ddd, foreignDataObj, json[parseInt(len.toString(), 10)]);
                    value = (0, $3EnZW.getValue)(column.foreignKeyValue, foreignDataObj);
                }
                (0, $3EnZW.setValue)(field, (0, $3EnZW.isNullOrUndefined)(value) ? null : value, obj);
                (0, $3EnZW.setValue)("dataObj", json[parseInt(len.toString(), 10)], obj);
                result.push(obj);
            }
        }
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).sort(result, field, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).fnAscending), "ejValue");
    };
    CheckBoxFilterBase.getPredicate = function(columns, isExecuteLocal) {
        var cols = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).distinct(columns, "field", true) || [];
        var collection = [];
        var pred = {};
        for(var i = 0; i < cols.length; i++){
            collection = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(columns).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("field", "equal", cols[parseInt(i.toString(), 10)].field));
            if (collection.length !== 0) pred[cols[parseInt(i.toString(), 10)].field] = CheckBoxFilterBase.generatePredicate(collection, isExecuteLocal);
        }
        return pred;
    };
    CheckBoxFilterBase.generatePredicate = function(cols, isExecuteLocal) {
        var len = cols ? cols.length : 0;
        var predicate;
        var operate = "or";
        var first = CheckBoxFilterBase.updateDateFilter(cols[0]);
        first.ignoreAccent = !(0, $3EnZW.isNullOrUndefined)(first.ignoreAccent) ? first.ignoreAccent : false;
        if (first.type === "date" || first.type === "datetime" || first.type === "dateonly") predicate = (0, $748c2240e597a9b7$export$4c58a38283ee9c83)(first, first.type, isExecuteLocal);
        else predicate = first.ejpredicate ? first.ejpredicate : new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(first.field, first.operator, first.value, !CheckBoxFilterBase.getCaseValue(first), first.ignoreAccent);
        for(var p = 1; p < len; p++){
            cols[parseInt(p.toString(), 10)] = CheckBoxFilterBase.updateDateFilter(cols[parseInt(p.toString(), 10)]);
            if (len > 2 && p > 1 && (cols[p].predicate === "or" && cols[p - 1].predicate === "or" || cols[p].predicate === "and" && cols[p - 1].predicate === "and")) {
                if (cols[p].type === "date" || cols[p].type === "datetime" || cols[p].type === "dateonly") predicate.predicates.push((0, $748c2240e597a9b7$export$4c58a38283ee9c83)(cols[parseInt(p.toString(), 10)], cols[p].type, isExecuteLocal));
                else predicate.predicates.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(cols[p].field, cols[parseInt(p.toString(), 10)].operator, cols[parseInt(p.toString(), 10)].value, !CheckBoxFilterBase.getCaseValue(cols[parseInt(p.toString(), 10)]), cols[parseInt(p.toString(), 10)].ignoreAccent));
            } else if (cols[p].type === "date" || cols[p].type === "datetime" || cols[p].type === "dateonly") {
                if (cols[parseInt(p.toString(), 10)].predicate === "and" && cols[parseInt(p.toString(), 10)].operator === "equal") predicate = predicate["" + operate]((0, $748c2240e597a9b7$export$4c58a38283ee9c83)(cols[parseInt(p.toString(), 10)], cols[parseInt(p.toString(), 10)].type, isExecuteLocal), cols[parseInt(p.toString(), 10)].type, cols[parseInt(p.toString(), 10)].ignoreAccent);
                else predicate = predicate[cols[parseInt(p.toString(), 10)].predicate]((0, $748c2240e597a9b7$export$4c58a38283ee9c83)(cols[parseInt(p.toString(), 10)], cols[parseInt(p.toString(), 10)].type, isExecuteLocal), cols[parseInt(p.toString(), 10)].type, cols[parseInt(p.toString(), 10)].ignoreAccent);
            } else predicate = cols[parseInt(p.toString(), 10)].ejpredicate ? predicate[cols[parseInt(p.toString(), 10)].predicate](cols[parseInt(p.toString(), 10)].ejpredicate) : predicate[cols[parseInt(p.toString(), 10)].predicate](cols[parseInt(p.toString(), 10)].field, cols[parseInt(p.toString(), 10)].operator, cols[parseInt(p.toString(), 10)].value, !CheckBoxFilterBase.getCaseValue(cols[parseInt(p.toString(), 10)]), cols[parseInt(p.toString(), 10)].ignoreAccent);
        }
        return predicate || null;
    };
    CheckBoxFilterBase.getCaseValue = function(filter) {
        if ((0, $3EnZW.isNullOrUndefined)(filter.matchCase)) {
            if (filter.type === "string" || (0, $3EnZW.isNullOrUndefined)(filter.type) && typeof filter.value === "string") return false;
            else return true;
        } else return filter.matchCase;
    };
    CheckBoxFilterBase.updateDateFilter = function(filter) {
        if (filter.type === "date" || filter.type === "datetime" || filter.type === "dateonly" || filter.value instanceof Date) filter.type = filter.type || "date";
        return filter;
    };
    return CheckBoxFilterBase;
}();


/**
 * Grid data module is used to generate query and data source.
 *
 * @hidden
 */ var $2c6cbc1793f29e30$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructor for data module.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} serviceLocator - specifies the service locator
     * @hidden
     */ function Data(parent, serviceLocator) {
        this.dataState = {
            isPending: false,
            resolver: null,
            group: []
        };
        this.foreignKeyDataState = {
            isPending: false,
            resolver: null
        };
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.initDataManager();
        if (this.parent.isDestroyed || this.getModuleName() === "foreignKey") return;
        this.parent.on($17b89d3b1fc93cdb$export$7a9fe616f081a21e, this.addRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$907e5a7aa493beb5, this.reorderRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$15a612017ee5398c, this.removeRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$a8ad22510e401e59, this.initDataManager, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($17b89d3b1fc93cdb$export$3bf0495508a61ee, this.crudActions, this);
        this.parent.on($17b89d3b1fc93cdb$export$3c545d3a48cc1b2f, this.getData, this);
        this.parent.on($17b89d3b1fc93cdb$export$bb86da570a7327af, this.refreshFilteredCols, this);
        this.parent.on($17b89d3b1fc93cdb$export$32aae452a9346e5, this.refreshFilteredCols, this);
    }
    Data.prototype.reorderRows = function(e) {
        if (this.parent.getDataModule().isRemote()) this.parent.getCurrentViewRecords().splice(e.toIndex, 0, this.parent.getCurrentViewRecords().splice(e.fromIndex, 1)[0]);
        else this.dataManager.dataSource.json.splice(e.toIndex, 0, this.dataManager.dataSource.json.splice(e.fromIndex, 1)[0]);
    };
    Data.prototype.getModuleName = function() {
        return "data";
    };
    /**
     * The function used to initialize dataManager and external query
     *
     * @returns {void}
     */ Data.prototype.initDataManager = function() {
        var gObj = this.parent;
        this.dataManager = gObj.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? gObj.dataSource : (0, $3EnZW.isNullOrUndefined)(gObj.dataSource) ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)() : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(gObj.dataSource);
        if (gObj.isAngular && !(gObj.query instanceof (0, $56262f229d1cff45$export$62297b13309008b2))) gObj.setProperties({
            query: new (0, $56262f229d1cff45$export$62297b13309008b2)()
        }, true);
        else {
            this.isQueryInvokedFromData = true;
            if (!(gObj.query instanceof (0, $56262f229d1cff45$export$62297b13309008b2))) gObj.query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        }
    };
    /**
     * The function is used to generate updated Query from Grid model.
     *
     * @param {boolean} skipPage - specifies the boolean to skip the page
     * @param {boolean} isAutoCompleteCall - specifies for auto complete call
     * @returns {Query} returns the Query
     * @hidden
     */ Data.prototype.generateQuery = function(skipPage, isAutoCompleteCall) {
        var gObj = this.parent;
        var query = !(0, $3EnZW.isNullOrUndefined)(gObj.getQuery()) ? gObj.getQuery().clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (this.parent.columnQueryMode === "ExcludeHidden") query.select(this.parent.getColumns().filter(function(column) {
            return !(column.isPrimaryKey !== true && column.visible === false || column.field === undefined);
        }).map(function(column) {
            return column.field;
        }));
        else if (this.parent.columnQueryMode === "Schema") {
            var selectQueryFields = [];
            var columns = this.parent.columns;
            for(var i = 0; i < columns.length; i++)selectQueryFields.push(columns[parseInt(i.toString(), 10)].field);
            query.select(selectQueryFields);
        }
        this.filterQuery(query);
        this.searchQuery(query);
        this.aggregateQuery(query);
        this.sortQuery(query);
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent)) this.virtualGroupPageQuery(query);
        else this.pageQuery(query, skipPage);
        if ((0, $3EnZW.isNullOrUndefined)(isAutoCompleteCall) || !isAutoCompleteCall) this.groupQuery(query);
        return query;
    };
    /**
     * @param {Query} query - specifies the query
     * @returns {Query} - returns the query
     * @hidden
     */ Data.prototype.aggregateQuery = function(query) {
        var rows = this.parent.aggregates;
        for(var i = 0; i < rows.length; i++){
            var row = rows[parseInt(i.toString(), 10)];
            for(var j = 0; j < row.columns.length; j++){
                var cols = row.columns[parseInt(j.toString(), 10)];
                var types = cols.type instanceof Array ? cols.type : [
                    cols.type
                ];
                for(var k = 0; k < types.length; k++)query.aggregate(types[parseInt(k.toString(), 10)].toLowerCase(), cols.field);
            }
        }
        return query;
    };
    Data.prototype.virtualGroupPageQuery = function(query) {
        var fName = "fn";
        if (query.queries.length) {
            for(var i = 0; i < query.queries.length; i++)if (query.queries[parseInt(i.toString(), 10)]["" + fName] === "onPage") query.queries.splice(i, 1);
        }
        return query;
    };
    Data.prototype.pageQuery = function(query, skipPage) {
        var gObj = this.parent;
        var fName = "fn";
        var args = {
            query: query,
            skipPage: false
        };
        gObj.notify($17b89d3b1fc93cdb$export$d51281e311b00699, args);
        if (args.skipPage) return query;
        if ((gObj.allowPaging || gObj.enableVirtualization || gObj.enableInfiniteScrolling) && skipPage !== true) {
            gObj.pageSettings.currentPage = Math.max(1, gObj.pageSettings.currentPage);
            if (gObj.pageSettings.pageCount <= 0) gObj.pageSettings.pageCount = 8;
            if (gObj.pageSettings.pageSize <= 0) gObj.pageSettings.pageSize = 12;
            if (query.queries.length) {
                for(var i = 0; i < query.queries.length; i++)if (query.queries[parseInt(i.toString(), 10)]["" + fName] === "onPage") query.queries.splice(i, 1);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(gObj.infiniteScrollModule) && gObj.enableInfiniteScrolling) this.parent.notify($17b89d3b1fc93cdb$export$e8809d2928c13994, query);
            else query.page(gObj.pageSettings.currentPage, gObj.allowPaging && gObj.pagerModule && gObj.pagerModule.pagerObj.isAllPage && !gObj.isManualRefresh && !this.dataManager.dataSource.offline && !(this.dataManager.adaptor instanceof (0, $e1170102ff02b3b7$export$90859058788a17cf)) ? null : gObj.pageSettings.pageSize);
        }
        return query;
    };
    Data.prototype.groupQuery = function(query) {
        var gObj = this.parent;
        if (gObj.allowGrouping && gObj.groupSettings.columns.length) {
            if (this.parent.groupSettings.enableLazyLoading) query.lazyLoad.push({
                key: "isLazyLoad",
                value: this.parent.groupSettings.enableLazyLoading
            });
            var columns = gObj.groupSettings.columns;
            for(var i = 0, len = columns.length; i < len; i++){
                var column = this.getColumnByField(columns[parseInt(i.toString(), 10)]);
                if (!column) this.parent.log("initial_action", {
                    moduleName: "group",
                    columnName: columns[parseInt(i.toString(), 10)]
                });
                var isGrpFmt = column.enableGroupByFormat;
                var format = column.format;
                if (isGrpFmt) query.group(columns[parseInt(i.toString(), 10)], this.formatGroupColumn.bind(this), format);
                else query.group(columns[parseInt(i.toString(), 10)], null);
            }
        }
        return query;
    };
    Data.prototype.sortQuery = function(query) {
        var gObj = this.parent;
        if ((gObj.allowSorting || gObj.allowGrouping) && gObj.sortSettings.columns.length) {
            var columns = gObj.sortSettings.columns;
            var sortGrp = [];
            for(var i = columns.length - 1; i > -1; i--){
                var col = this.getColumnByField(columns[parseInt(i.toString(), 10)].field);
                if (col) col.setSortDirection(columns[parseInt(i.toString(), 10)].direction);
                else {
                    this.parent.log("initial_action", {
                        moduleName: "sort",
                        columnName: columns[parseInt(i.toString(), 10)].field
                    });
                    return query;
                }
                var fn = columns[parseInt(i.toString(), 10)].direction;
                if (col.sortComparer) {
                    this.parent.log("grid_sort_comparer");
                    fn = !this.isRemote() ? col.sortComparer.bind(col) : columns[parseInt(i.toString(), 10)].direction;
                }
                if (gObj.groupSettings.columns.indexOf(columns[parseInt(i.toString(), 10)].field) === -1) {
                    if (col.isForeignColumn() || col.sortComparer) query.sortByForeignKey(col.field, fn, undefined, columns[parseInt(i.toString(), 10)].direction.toLowerCase());
                    else query.sortBy(col.field, fn);
                } else sortGrp.push({
                    direction: fn,
                    field: col.field
                });
            }
            for(var i = 0, len = sortGrp.length; i < len; i++)if (typeof sortGrp[parseInt(i.toString(), 10)].direction === "string") query.sortBy(sortGrp[parseInt(i.toString(), 10)].field, sortGrp[parseInt(i.toString(), 10)].direction);
            else {
                var col = this.getColumnByField(sortGrp[parseInt(i.toString(), 10)].field);
                query.sortByForeignKey(sortGrp[parseInt(i.toString(), 10)].field, sortGrp[parseInt(i.toString(), 10)].direction, undefined, col.getSortDirection().toLowerCase());
            }
        }
        return query;
    };
    /**
     * @param {Query} query - specifies the query
     * @param {Column} fcolumn - specifies the forein key column model
     * @param {boolean} isForeignKey - Confirms whether the column is a foreign key or not
     * @returns {Query} - returns the query
     * @hidden
     */ Data.prototype.searchQuery = function(query, fcolumn, isForeignKey) {
        var sSettings = this.parent.searchSettings;
        var fields = !(0, $3EnZW.isNullOrUndefined)(sSettings.fields) && sSettings.fields.length ? sSettings.fields : this.getSearchColumnFieldNames();
        var predicateList = [];
        var needForeignKeySearch = false;
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.searchSettings.key) && this.parent.searchSettings.key.length) {
            needForeignKeySearch = this.parent.getForeignKeyColumns().some(function(col) {
                return fields.indexOf(col.field) > -1;
            });
            var adaptor = !isForeignKey ? this.dataManager.adaptor : fcolumn.dataSource.adaptor;
            if (needForeignKeySearch || adaptor.getModuleName && adaptor.getModuleName() === "ODataV4Adaptor") {
                fields = isForeignKey ? [
                    fcolumn.foreignKeyValue
                ] : fields;
                for(var i = 0; i < fields.length; i++){
                    var column = isForeignKey ? fcolumn : this.getColumnByField(fields[parseInt(i.toString(), 10)]);
                    if (column.isForeignColumn() && !isForeignKey) predicateList = this.fGeneratePredicate(column, predicateList);
                    else predicateList.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields[parseInt(i.toString(), 10)], sSettings.operator, sSettings.key, sSettings.ignoreCase, sSettings.ignoreAccent));
                }
                var predList = (0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicateList);
                predList.key = sSettings.key;
                query.where(predList);
            } else query.search(sSettings.key, fields, sSettings.operator, sSettings.ignoreCase, sSettings.ignoreAccent);
        }
        return query;
    };
    Data.prototype.filterQuery = function(query, column, skipFoerign) {
        var gObj = this.parent;
        var predicateList = [];
        var actualFilter = [];
        var foreignColumn = this.parent.getForeignKeyColumns();
        var foreignColEmpty;
        if (gObj.allowFiltering && gObj.filterSettings.columns.length) {
            var columns = column ? column : gObj.filterSettings.columns;
            var colType = {};
            for(var _i = 0, _a = gObj.getColumns(); _i < _a.length; _i++){
                var col = _a[_i];
                colType[col.field] = col.filter.type ? col.filter.type : gObj.filterSettings.type;
            }
            var foreignCols = [];
            var defaultFltrCols = [];
            for(var _b = 0, columns_1 = columns; _b < columns_1.length; _b++){
                var col = columns_1[_b];
                var gridColumn = col.isForeignKey ? gObj.getColumnByUid(col.uid) : gObj.getColumnByField(col.field);
                if ((0, $3EnZW.isNullOrUndefined)(col.type) && gridColumn && (gridColumn.type === "date" || gridColumn.type === "datetime" || gridColumn.type === "dateonly")) col.type = col.isForeignKey ? gObj.getColumnByUid(col.uid).type : gObj.getColumnByField(col.field).type;
                if (col.isForeignKey) foreignCols.push(col);
                else defaultFltrCols.push(col);
            }
            if (defaultFltrCols.length) {
                for(var i = 0, len = defaultFltrCols.length; i < len; i++)defaultFltrCols[parseInt(i.toString(), 10)].uid = defaultFltrCols[parseInt(i.toString(), 10)].uid || this.parent.grabColumnByFieldFromAllCols(defaultFltrCols[parseInt(i.toString(), 10)].field, defaultFltrCols[parseInt(i.toString(), 10)].isForeignKey).uid;
                var excelPredicate = (0, $66db5ede9cdf4d76$export$325f55b6c744802a).getPredicate(defaultFltrCols);
                for(var _c = 0, _d = Object.keys(excelPredicate); _c < _d.length; _c++){
                    var prop = _d[_c];
                    predicateList.push(excelPredicate["" + prop]);
                }
            }
            if (foreignCols.length) for(var _e = 0, foreignCols_1 = foreignCols; _e < foreignCols_1.length; _e++){
                var col = foreignCols_1[_e];
                col.uid = col.uid || this.parent.grabColumnByFieldFromAllCols(col.field, col.isForeignKey).uid;
                var column_1 = this.parent.grabColumnByUidFromAllCols(col.uid);
                if (!column_1) this.parent.log("initial_action", {
                    moduleName: "filter",
                    columnName: col.field
                });
                if (column_1.isForeignColumn() && (0, $748c2240e597a9b7$export$e0d896ad751b9ff7)(col.field, foreignColumn) && !skipFoerign) {
                    actualFilter.push(col);
                    if (!column_1.columnData.length) foreignColEmpty = true;
                    predicateList = this.fGeneratePredicate(column_1, predicateList);
                } else {
                    var excelPredicate = (0, $66db5ede9cdf4d76$export$325f55b6c744802a).getPredicate(columns);
                    for(var _f = 0, _g = Object.keys(excelPredicate); _f < _g.length; _f++){
                        var prop = _g[_f];
                        predicateList.push(excelPredicate["" + prop]);
                    }
                }
            }
            if (predicateList.length && !foreignColEmpty) query.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).and(predicateList));
            else this.parent.notify($17b89d3b1fc93cdb$export$5254084c06ba0d7f, {});
        }
        return query;
    };
    Data.prototype.fGeneratePredicate = function(col, predicateList) {
        var fPredicate = {};
        if (col) {
            this.parent.notify($17b89d3b1fc93cdb$export$40afe28aee4686d4, {
                predicate: fPredicate,
                column: col
            });
            if (fPredicate.predicate.predicates.length) predicateList.push(fPredicate.predicate);
        }
        return predicateList;
    };
    /**
     * The function is used to get dataManager promise by executing given Query.
     *
     * @param {object} args - specifies the object
     * @param {string} args.requestType - Defines the request type
     * @param {string[]} args.foreignKeyData - Defines the foreignKeyData.string
     * @param {Object} args.data - Defines the data.
     * @param {number} args.index - Defines the index .
     * @param {Query} query - Defines the query which will execute along with data processing.
     * @returns {Promise<Object>} - returns the object
     * @hidden
     */ Data.prototype.getData = function(args, query) {
        var _this = this;
        if (args === void 0) args = {
            requestType: ""
        };
        var key = this.getKey(args.foreignKeyData && Object.keys(args.foreignKeyData).length ? args.foreignKeyData : this.parent.getPrimaryKeyFieldNames());
        this.parent.log("datasource_syntax_mismatch", {
            dataState: this.parent
        });
        if (this.parent.dataSource && "result" in this.parent.dataSource) {
            var def = this.eventPromise(args, query, key);
            return def.promise;
        } else {
            var crud = void 0;
            switch(args.requestType){
                case "delete":
                    query = query ? query : this.generateQuery();
                    // eslint-disable-next-line no-case-declarations
                    var len = Object.keys(args.data).length;
                    if (len === 1) crud = this.dataManager.remove(key, args.data[0], query.fromTable, query);
                    else {
                        var changes = {
                            addedRecords: [],
                            deletedRecords: [],
                            changedRecords: []
                        };
                        changes.deletedRecords = args.data;
                        crud = this.dataManager.saveChanges(changes, key, query.fromTable, query.requiresCount());
                    }
                    break;
                case "save":
                    query = query ? query : this.generateQuery();
                    args.index = (0, $3EnZW.isNullOrUndefined)(args.index) ? 0 : args.index;
                    crud = this.dataManager.insert(args.data, query.fromTable, query, args.index);
                    break;
            }
            var promise = "promise";
            args["" + promise] = crud;
            // eslint-disable-next-line no-prototype-builtins
            if (crud && !Array.isArray(crud) && !crud.hasOwnProperty("deletedRecords")) return crud.then(function() {
                return _this.insert(query, args);
            });
            else return this.insert(query, args);
        }
    };
    Data.prototype.insert = function(query, args) {
        if (args.requestType === "save") this.parent.notify($17b89d3b1fc93cdb$export$48969e4b6e5bb8d7, args);
        return this.executeQuery(query);
    };
    Data.prototype.executeQuery = function(query) {
        var _this = this;
        if (this.dataManager.ready) {
            var deferred_1 = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
            var ready = this.dataManager.ready;
            ready.then(function() {
                _this.dataManager.executeQuery(query).then(function(result) {
                    deferred_1.resolve(result);
                });
            }).catch(function(e) {
                deferred_1.reject(e);
            });
            return deferred_1.promise;
        } else return this.dataManager.executeQuery(query);
    };
    Data.prototype.formatGroupColumn = function(value, field) {
        var serviceLocator = this.serviceLocator;
        var column = this.getColumnByField(field);
        var date = value;
        if (!column.type) column.type = date.getDay ? date.getHours() > 0 || date.getMinutes() > 0 || date.getSeconds() > 0 || date.getMilliseconds() > 0 ? "datetime" : "date" : typeof value;
        if ((0, $3EnZW.isNullOrUndefined)(column.getFormatter())) (0, $748c2240e597a9b7$export$1986f8c9221d3ee2)(serviceLocator, column);
        var formatVal = (0, $52aed6227a4600c2$export$4ad21d94aae28a17).prototype.toView(value, column.getFormatter());
        return formatVal;
    };
    Data.prototype.crudActions = function(args) {
        var query = this.generateQuery();
        var promise = null;
        var pr = "promise";
        var key = this.getKey(args.foreignKeyData && Object.keys(args.foreignKeyData).length ? args.foreignKeyData : this.parent.getPrimaryKeyFieldNames());
        if (this.parent.dataSource && "result" in this.parent.dataSource) this.eventPromise(args, query, key);
        switch(args.requestType){
            case "save":
                promise = this.dataManager.update(key, args.data, query.fromTable, query, args.previousData);
                break;
        }
        args["" + pr] = promise ? promise : args["" + pr];
        this.parent.notify($17b89d3b1fc93cdb$export$a8508f3e3cbfd48b, args);
    };
    /**
     * @param {object} changes - specifies the changes
     * @param {string} key - specifies the key
     * @param {object} original - specifies the original data
     * @param {Query} query - specifies the query
     * @returns {Promise<Object>} returns the object
     * @hidden
     */ Data.prototype.saveChanges = function(changes, key, original, query) {
        if (query === void 0) query = this.generateQuery();
        query.requiresCount();
        if ("result" in this.parent.dataSource) {
            var deff = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
            var args = {
                requestType: "batchsave",
                changes: changes,
                key: key,
                query: query,
                endEdit: deff.resolve
            };
            this.setState({
                isPending: true,
                resolver: deff.resolve
            });
            this.parent.trigger($17b89d3b1fc93cdb$export$e9138ee323ad1b39, args);
            return deff.promise;
        } else {
            var promise = this.dataManager.saveChanges(changes, key, query.fromTable, query, original);
            return promise;
        }
    };
    Data.prototype.getKey = function(keys) {
        if (keys && keys.length) return keys[0];
        return undefined;
    };
    /**
     * @returns {boolean} returns whether its remote data
     * @hidden
     */ Data.prototype.isRemote = function() {
        return this.dataManager.dataSource.offline !== true && this.dataManager.dataSource.url !== undefined && this.dataManager.dataSource.url !== "";
    };
    Data.prototype.addRows = function(e) {
        for(var i = e.records.length; i > 0; i--){
            if (this.parent.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.dataManager.dataSource.offline) this.dataManager.dataSource.json.splice(e.toIndex, 0, e.records[i - 1]);
            else if (!this.parent.getDataModule().isRemote() && !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && !this.parent.dataSource.result) this.parent.dataSource["splice"](e.toIndex, 0, e.records[i - 1]);
        }
    };
    Data.prototype.removeRows = function(e) {
        var json = this.dataManager.dataSource.json;
        if (this.parent.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.dataManager.dataSource.offline) this.dataManager.dataSource.json = json.filter(function(value) {
            return e.records.indexOf(value) === -1;
        });
        else if (!this.parent.getDataModule().isRemote() && !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && !this.parent.dataSource.result) this.parent.dataSource = json.filter(function(value) {
            return e.records.indexOf(value) === -1;
        });
    };
    Data.prototype.getColumnByField = function(field) {
        var col;
        return this.parent.columnModel.some(function(column) {
            col = column;
            return column.field === field;
        }) && col;
    };
    Data.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$7a9fe616f081a21e, this.addRows);
        this.parent.off($17b89d3b1fc93cdb$export$15a612017ee5398c, this.removeRows);
        this.parent.off($17b89d3b1fc93cdb$export$a8ad22510e401e59, this.initDataManager);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$3bf0495508a61ee, this.crudActions);
        this.parent.off($17b89d3b1fc93cdb$export$3c545d3a48cc1b2f, this.getData);
        this.parent.off($17b89d3b1fc93cdb$export$bb86da570a7327af, this.refreshFilteredCols);
        this.parent.off($17b89d3b1fc93cdb$export$32aae452a9346e5, this.refreshFilteredCols);
    };
    Data.prototype.getState = function() {
        return this.dataState;
    };
    Data.prototype.setState = function(state) {
        return this.dataState = state;
    };
    Data.prototype.getForeignKeyDataState = function() {
        return this.foreignKeyDataState;
    };
    Data.prototype.setForeignKeyDataState = function(state) {
        this.foreignKeyDataState = state;
    };
    Data.prototype.getStateEventArgument = function(query) {
        var adaptr = new (0, $e1170102ff02b3b7$export$b011aea473980a2d)();
        var dm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
            url: "",
            adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)
        });
        var state = adaptr.processQuery(dm, query);
        var data = JSON.parse(state.data);
        return (0, $3EnZW.extend)(data, state.pvtData);
    };
    Data.prototype.eventPromise = function(args, query, key) {
        var _this = this;
        var dataArgs = args;
        var state = this.getStateEventArgument(query);
        var def = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
        var deff = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
        if ((args.requestType !== undefined || this.parent.groupSettings.disablePageWiseAggregates && query.queries.some(function(query) {
            return query.fn === "onGroup";
        })) && this.dataState.isDataChanged !== false) {
            state.action = args;
            if (args.requestType === "save" || args.requestType === "delete") {
                var editArgs_1 = args;
                editArgs_1.key = key;
                var promise = "promise";
                editArgs_1["" + promise] = deff.promise;
                editArgs_1.state = state;
                this.setState({
                    isPending: true,
                    resolver: deff.resolve
                });
                dataArgs.endEdit = deff.resolve;
                dataArgs.cancelEdit = deff.reject;
                this.parent.trigger($17b89d3b1fc93cdb$export$e9138ee323ad1b39, editArgs_1);
                deff.promise.then(function() {
                    _this.setState({
                        isPending: true,
                        resolver: def.resolve,
                        group: state.group,
                        aggregates: state.aggregates
                    });
                    if (editArgs_1.requestType === "save") _this.parent.notify($17b89d3b1fc93cdb$export$48969e4b6e5bb8d7, editArgs_1);
                    _this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, state);
                }).catch(function() {
                    return void 0;
                });
            } else {
                this.setState({
                    isPending: true,
                    resolver: def.resolve,
                    group: state.group,
                    aggregates: state.aggregates
                });
                this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, state);
            }
        } else {
            this.setState({});
            def.resolve(this.parent.dataSource);
        }
        return def;
    };
    /**
     * Gets the columns where searching needs to be performed from the Grid.
     *
     * @returns {string[]} returns the searched column field names
     */ Data.prototype.getSearchColumnFieldNames = function() {
        var colFieldNames = [];
        var columns = this.parent.getColumns();
        for(var _i = 0, columns_2 = columns; _i < columns_2.length; _i++){
            var col = columns_2[_i];
            if (col.allowSearching && !(0, $3EnZW.isNullOrUndefined)(col.field)) colFieldNames.push(col.field);
        }
        return colFieldNames;
    };
    Data.prototype.refreshFilteredCols = function() {
        if (this.parent.allowFiltering && this.parent.filterSettings.columns.length) (0, $748c2240e597a9b7$export$f09b34d3b1ff9814)(this.parent, this.parent.filterSettings.columns);
    };
    return Data;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Row
 *
 * @hidden
 */ var $34f7b5fd578df3e1$export$b59bdbef9ce70de2 = /** @class */ function() {
    function Row(options, parent) {
        (0, $3EnZW.merge)(this, options);
        this.parent = parent;
    }
    Row.prototype.clone = function() {
        var row = new Row({});
        (0, $3EnZW.merge)(row, this);
        row.cells = this.cells.map(function(cell) {
            return cell.clone();
        });
        return row;
    };
    /**
     * Replaces the row data and grid refresh the particular row element only.
     *
     * @param  {Object} data - To update new data for the particular row.
     * @returns {void}
     */ Row.prototype.setRowValue = function(data) {
        if (!this.parent) return;
        var key = this.data[this.parent.getPrimaryKeyFieldNames()[0]];
        this.parent.setRowData(key, data);
    };
    /**
     * Replaces the given field value and refresh the particular cell element only.
     *
     * @param {string} field - Specifies the field name which you want to update.
     * @param {string | number | boolean | Date} value - To update new value for the particular cell.
     * @returns {void}
     */ Row.prototype.setCellValue = function(field, value) {
        if (!this.parent) return;
        var isValDiff = !(this.data["" + field].toString() === value.toString());
        if (isValDiff) {
            var pKeyField = this.parent.getPrimaryKeyFieldNames()[0];
            var key = this.data["" + pKeyField];
            this.parent.setCellValue(key, field, value);
            this.makechanges(pKeyField, this.data);
        } else return;
    };
    Row.prototype.makechanges = function(key, data) {
        if (!this.parent) return;
        var gObj = this.parent;
        var dataManager = gObj.getDataModule().dataManager;
        dataManager.update(key, data);
    };
    return Row;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Cell
 *
 * @hidden
 */ var $6362359d69c4bb1e$export$f6f0c3fe4ec306ea = /** @class */ function() {
    function Cell(options) {
        this.isSpanned = false;
        this.isRowSpanned = false;
        (0, $3EnZW.merge)(this, options);
    }
    Cell.prototype.clone = function() {
        var cell = new Cell({});
        (0, $3EnZW.merge)(cell, this);
        return cell;
    };
    return Cell;
}();




parcelRequire("j7YE8");
var $g9Ic7 = parcelRequire("g9Ic7");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");
var $c2qqN = parcelRequire("c2qqN");


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


/**
 * `CellMergeRender` module.
 *
 * @hidden
 */ var $8b8d76cc41e062b2$export$fd5814f904f8f3b4 = /** @class */ function() {
    function CellMergeRender(serviceLocator, parent) {
        this.serviceLocator = serviceLocator;
        this.parent = parent;
    }
    CellMergeRender.prototype.render = function(cellArgs, row, i, td) {
        var cellRendererFact = this.serviceLocator.getService("cellRendererFactory");
        var cellRenderer = cellRendererFact.getCellRenderer(row.cells[parseInt(i.toString(), 10)].cellType || (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data);
        var colSpan = row.cells[parseInt(i.toString(), 10)].cellSpan ? row.cells[parseInt(i.toString(), 10)].cellSpan : cellArgs.colSpan + i <= row.cells.length ? cellArgs.colSpan : row.cells.length - i;
        var rowSpan = cellArgs.rowSpan;
        var visible = 0;
        var spannedCell;
        if (row.index > 0) {
            var rowsObject = this.parent.getRowsObject();
            var cells = this.parent.groupSettings.columns.length > 0 && !rowsObject[row.index - 1].isDataRow ? rowsObject[row.index].cells : rowsObject[row.index - 1].cells;
            var targetCell_1 = row.cells[parseInt(i.toString(), 10)];
            var uid_1 = "uid";
            spannedCell = cells.filter(function(cell) {
                return cell.column.uid === targetCell_1.column["" + uid_1];
            })[0];
        }
        var colSpanLen = spannedCell && spannedCell.colSpanRange > 1 && spannedCell.rowSpanRange > 1 ? spannedCell.colSpanRange : colSpan;
        for(var j = i + 1; j < i + colSpanLen && j < row.cells.length; j++)if (row.cells[parseInt(j.toString(), 10)].visible === false) visible++;
        else row.cells[parseInt(j.toString(), 10)].isSpanned = true;
        if (visible > 0) {
            for(var j = i + colSpan; j < i + colSpan + visible && j < row.cells.length; j++)row.cells[parseInt(j.toString(), 10)].isSpanned = true;
            if (i + colSpan + visible >= row.cells.length) colSpan -= i + colSpan + visible - row.cells.length;
        }
        if (row.cells[parseInt(i.toString(), 10)].cellSpan) {
            row.data[cellArgs.column.field] = row.cells[parseInt(i.toString(), 10)].spanText;
            td = cellRenderer.render(row.cells[parseInt(i.toString(), 10)], row.data, {
                "index": !(0, $3EnZW.isNullOrUndefined)(row.index) ? row.index.toString() : ""
            });
        }
        if (colSpan > 1) (0, $4ZDHT.attributes)(td, {
            "colSpan": colSpan.toString(),
            "aria-colSpan": colSpan.toString()
        });
        if (rowSpan > 1) {
            (0, $4ZDHT.attributes)(td, {
                "rowspan": rowSpan.toString(),
                "aria-rowspan": rowSpan.toString()
            });
            row.cells[parseInt(i.toString(), 10)].isRowSpanned = true;
            row.cells[parseInt(i.toString(), 10)].rowSpanRange = Number(rowSpan);
            if (colSpan > 1) row.cells[parseInt(i.toString(), 10)].colSpanRange = Number(colSpan);
        }
        if (row.index > 0 && spannedCell.rowSpanRange > 1) {
            row.cells[parseInt(i.toString(), 10)].isSpanned = true;
            row.cells[parseInt(i.toString(), 10)].rowSpanRange = Number(spannedCell.rowSpanRange - 1);
            row.cells[parseInt(i.toString(), 10)].colSpanRange = spannedCell.rowSpanRange > 0 ? spannedCell.colSpanRange : 1;
        }
        if (this.parent.enableColumnVirtualization && !row.cells[parseInt(i.toString(), 10)].cellSpan && !this.containsKey(cellArgs.column.field, cellArgs.data[cellArgs.column.field])) this.backupMergeCells(cellArgs.column.field, cellArgs.data[cellArgs.column.field], cellArgs.colSpan);
        return td;
    };
    CellMergeRender.prototype.backupMergeCells = function(fName, data, span) {
        this.setMergeCells(this.generteKey(fName, data), span);
    };
    CellMergeRender.prototype.generteKey = function(fname, data) {
        return fname + "__" + data.toString();
    };
    CellMergeRender.prototype.splitKey = function(key) {
        return key.split("__");
    };
    CellMergeRender.prototype.containsKey = function(fname, data) {
        // eslint-disable-next-line no-prototype-builtins
        return this.getMergeCells().hasOwnProperty(this.generteKey(fname, data));
    };
    CellMergeRender.prototype.getMergeCells = function() {
        return this.parent.mergeCells;
    };
    CellMergeRender.prototype.setMergeCells = function(key, span) {
        this.parent.mergeCells["" + key] = span;
    };
    CellMergeRender.prototype.updateVirtualCells = function(rows) {
        var mCells = this.getMergeCells();
        for(var _i = 0, _a = Object.keys(mCells); _i < _a.length; _i++){
            var key = _a[_i];
            var value = mCells["" + key];
            var merge = this.splitKey(key);
            var columnIndex = this.getIndexFromAllColumns(merge[0]);
            var vColumnIndices = this.parent.getColumnIndexesInView();
            var span = value - (vColumnIndices[0] - columnIndex);
            if (columnIndex < vColumnIndices[0] && span > 1) for(var _b = 0, rows_1 = rows; _b < rows_1.length; _b++){
                var row = rows_1[_b];
                if (row.data[merge[0]].toString() === merge[1].toString()) {
                    row.cells[0].cellSpan = span;
                    row.cells[0].spanText = merge[1];
                    break;
                }
            }
        }
        return rows;
    };
    CellMergeRender.prototype.getIndexFromAllColumns = function(field) {
        var index = (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(this.parent.getVisibleColumns(), function(item, index) {
            if (item.field === field) return index;
            return undefined;
        })[0];
        return index;
    };
    return CellMergeRender;
}();


/**
 * Specifies class names
 */ /** @hidden */ var $1b5568e76cdae6d4$export$deb49d6cac2bdaca = "e-rowcell";
var $1b5568e76cdae6d4$export$b8cf6f078a9012e0 = "e-gridheader";
var $1b5568e76cdae6d4$export$ee5f1442ff7df474 = "e-gridcontent";
var $1b5568e76cdae6d4$export$71ae40cd68e383eb = "e-gridfooter";
var $1b5568e76cdae6d4$export$838c0e7679321ff3 = "e-headercontent";
var $1b5568e76cdae6d4$export$3a619000c6e2d0b1 = "e-movablecontent";
var $1b5568e76cdae6d4$export$af4960656b46803f = "e-movableheader";
var $1b5568e76cdae6d4$export$2e0375c1e01d2501 = "e-frozencontent";
var $1b5568e76cdae6d4$export$4e0f34628fc163a4 = "e-frozenheader";
var $1b5568e76cdae6d4$export$a7db06668cad9adb = "e-content";
var $1b5568e76cdae6d4$export$9852986a3ec5f6a0 = "e-table";
var $1b5568e76cdae6d4$export$120ff0929b202a6d = "e-row";
var $1b5568e76cdae6d4$export$71f350cebd38389f = "e-gridchkbox";
var $1b5568e76cdae6d4$export$76a2698a7195dbfe = "e-editedrow";
var $1b5568e76cdae6d4$export$792eb12cf4991bf2 = "e-addedrow";
var $1b5568e76cdae6d4$export$368b824418d94f0 = "e-groupcaptionrow";
var $1b5568e76cdae6d4$export$f7789a67e74c1e3f = "changedRecords";
var $1b5568e76cdae6d4$export$aef5e1398935f398 = "addedRecords";
var $1b5568e76cdae6d4$export$c509ef778c751c4e = "deletedRecords";
var $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2 = "Left-Right";
var $1b5568e76cdae6d4$export$b86d31d94d6c8026 = "frozen-right";
var $1b5568e76cdae6d4$export$89f0bdeca852d972 = "frozen-left";
var $1b5568e76cdae6d4$export$fff541542e3093ed = "data-colindex";
var $1b5568e76cdae6d4$export$d3d64e794dbd0f6b = "aria-colindex";
var $1b5568e76cdae6d4$export$bbfd9040f0589a82 = "data-rowindex";
var $1b5568e76cdae6d4$export$be459c01dd76713e = "aria-rowindex";
var $1b5568e76cdae6d4$export$7cdd536eaa8f163c = "tbody";
var $1b5568e76cdae6d4$export$f7c2e8f0e9310cd9 = "colgroup";
var $1b5568e76cdae6d4$export$3ce6949f20cea765 = "open";
var $1b5568e76cdae6d4$export$d8a7b8f475ec0161 = "change";
var $1b5568e76cdae6d4$export$d7ddd398f22d79ef = "focus";
var $1b5568e76cdae6d4$export$185802fd694ee1f5 = "created";
var $1b5568e76cdae6d4$export$dae5a2074316fa75 = "beforeOpen";
var $1b5568e76cdae6d4$export$d81610064893988e = "downArrow";
var $1b5568e76cdae6d4$export$d12bbdaa0e5320e2 = "upArrow";
var $1b5568e76cdae6d4$export$f5b94b14e1c1cc2a = "PageUp";
var $1b5568e76cdae6d4$export$12fe17f871ef6d2a = "PageDown";
var $1b5568e76cdae6d4$export$e668df1bcd81e4d2 = "enter";
var $1b5568e76cdae6d4$export$9f99fe2ed5bb7a29 = "shiftEnter";
var $1b5568e76cdae6d4$export$62d58b1c91e8e902 = "tab";
var $1b5568e76cdae6d4$export$9ad63694f5781e16 = "shiftTab";
var $1b5568e76cdae6d4$export$1083832cc21be1bf = "initialFrozenColumnIndex";


/**
 * RowRenderer class which responsible for building row content.
 *
 * @hidden
 */ var $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8 = /** @class */ function() {
    function RowRenderer(serviceLocator, cellType, parent) {
        this.isSpan = false;
        this.cellType = cellType;
        this.serviceLocator = serviceLocator;
        this.parent = parent;
        this.element = this.parent.createElement("tr", {
            attrs: {
                role: "row"
            }
        });
    }
    /* eslint-disable */ /**
     * Function to render the row content based on Column[] and data.
     *
     * @param {Row<T>} row - specifies the row
     * @param {Column[]} columns - specifies the columns
     * @param {Object} attributes - specifies the attributes
     * @param {string} rowTemplate - specifies the rowTemplate
     * @param {Element} cloneNode - specifies the cloneNode
     * @returns {Element} returns the element
     */ /* eslint-enable */ RowRenderer.prototype.render = function(row, columns, attributes, rowTemplate, cloneNode) {
        return this.refreshRow(row, columns, attributes, rowTemplate, cloneNode);
    };
    /* eslint-disable */ /**
     * Function to refresh the row content based on Column[] and data.
     *
     * @param {Row<T>} row - specifies the row
     * @param {Column[]} columns - specifies the column
     * @param {boolean} isChanged - specifies isChanged
     * @param {Object} attributes - specifies the attributes
     * @param {string} rowTemplate - specifies the rowTemplate
     * @returns {void}
     */ /* eslint-enable */ RowRenderer.prototype.refresh = function(row, columns, isChanged, attributes, rowTemplate) {
        var _this = this;
        if (isChanged) {
            row.data = (0, $748c2240e597a9b7$export$8f9fa30750711038)({}, row.changes);
            this.refreshMergeCells(row);
        }
        var node = this.parent.element.querySelector("[data-uid=" + row.uid + "]");
        var tr = this.refreshRow(row, columns, attributes, rowTemplate, null, isChanged);
        var cells = [].slice.call(tr.cells);
        var tempCells = [].slice.call(node.querySelectorAll(".e-templatecell"));
        if (this.parent.isReact && tempCells.length) {
            var _loop_1 = function(col) {
                if (col.template) {
                    setTimeout(function() {
                        _this.parent.refreshReactColumnTemplateByUid(col.uid, true);
                    }, 0);
                    return "break";
                }
            };
            for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
                var col = columns_1[_i];
                var state_1 = _loop_1(col);
                if (state_1 === "break") break;
            }
        }
        var attr = [].slice.call(tr.attributes);
        attr.map(function(item) {
            node.setAttribute(item["name"], item["value"]);
        });
        node.innerHTML = "";
        for(var _a = 0, cells_1 = cells; _a < cells_1.length; _a++){
            var cell = cells_1[_a];
            node.appendChild(cell);
        }
    };
    // tslint:disable-next-line:max-func-body-length
    RowRenderer.prototype.refreshRow = function(row, columns, attributes, rowTemplate, cloneNode, isEdit) {
        var tr = !(0, $3EnZW.isNullOrUndefined)(cloneNode) ? cloneNode : this.element.cloneNode();
        var rowArgs = {
            data: row.data
        };
        var cellArgs = {
            data: row.data
        };
        var chekBoxEnable = this.parent.getColumns().filter(function(col) {
            return col.type === "checkbox" && col.field;
        })[0];
        var value = false;
        var isFrozen = this.parent.isFrozenGrid();
        var isFirstVisibleCell = true;
        if (chekBoxEnable) value = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(chekBoxEnable.field, rowArgs.data);
        var selIndex = this.parent.getSelectedRowIndexes();
        if (row.isDataRow) row.isSelected = selIndex.indexOf(row.index) > -1 || value;
        if (row.isDataRow && this.parent.isCheckBoxSelection && this.parent.checkAllRows === "Check" && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) {
            row.isSelected = true;
            if (selIndex.indexOf(row.index) === -1) selIndex.push(row.index);
        }
        this.buildAttributeFromRow(tr, row);
        (0, $4ZDHT.attributes)(tr, (0, $3EnZW.extend)({}, attributes, {}));
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(tr, row.attributes);
        var cellRendererFact = this.serviceLocator.getService("cellRendererFactory");
        var _loop_2 = function(i, len) {
            var cell = row.cells[parseInt(i.toString(), 10)];
            cell.isSelected = row.isSelected;
            cell.isColumnSelected = cell.column.isSelected;
            var cellRenderer = cellRendererFact.getCellRenderer(row.cells[parseInt(i.toString(), 10)].cellType || (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data);
            var attrs = {
                "index": !(0, $3EnZW.isNullOrUndefined)(row.index) ? row.index.toString() : ""
            };
            if (row.isExpand && row.cells[parseInt(i.toString(), 10)].cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailExpand) attrs["class"] = this_1.parent.isPrinting ? "e-detailrowcollapse" : "e-detailrowexpand";
            var isGroupFirstCell = !this_1.parent.enableRtl && this_1.parent.groupSettings && isFirstVisibleCell && this_1.parent.groupSettings.columns.length && (this_1.parent.gridLines === "Vertical" || this_1.parent.gridLines === "Both");
            var td = cellRenderer.render(row.cells[parseInt(i.toString(), 10)], row.data, attrs, row.isExpand, isEdit);
            if (row.cells[parseInt(i.toString(), 10)].cellType !== (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Filter) {
                if (row.cells[parseInt(i.toString(), 10)].cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data || row.cells[parseInt(i.toString(), 10)].cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CommandColumn) {
                    if (cell.visible && isGroupFirstCell) {
                        td.classList.add("e-grid-group-first-cell");
                        isFirstVisibleCell = false;
                    }
                    var isReactChild = this_1.parent.parentDetails && this_1.parent.parentDetails.parentInstObj && this_1.parent.parentDetails.parentInstObj.isReact;
                    if ((this_1.parent.isReact && this_1.parent.requireTemplateRef || isReactChild && this_1.parent.parentDetails.parentInstObj.requireTemplateRef) && cell.isTemplate) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        var thisRef_1 = this_1;
                        thisRef_1.parent.renderTemplates(function() {
                            if (typeof cell.column.template !== "string") {
                                var ariaAttr = td.getAttribute("aria-label");
                                td.setAttribute("aria-label", td.innerText + ariaAttr);
                            }
                            thisRef_1.parent.trigger((0, $17b89d3b1fc93cdb$export$7a849352d4f0bf7b), (0, $3EnZW.extend)(cellArgs, {
                                cell: td,
                                column: cell.column,
                                colSpan: 1,
                                rowSpan: 1,
                                foreignKeyData: row.cells[parseInt(i.toString(), 10)].foreignKeyData,
                                requestType: thisRef_1.parent.requestTypeAction
                            }));
                        });
                    } else this_1.parent.trigger((0, $17b89d3b1fc93cdb$export$7a849352d4f0bf7b), (0, $3EnZW.extend)(cellArgs, {
                        cell: td,
                        column: cell.column,
                        colSpan: 1,
                        rowSpan: 1,
                        foreignKeyData: row.cells[parseInt(i.toString(), 10)].foreignKeyData,
                        requestType: this_1.parent.requestTypeAction
                    }));
                    var isRowSpanned = false;
                    if (row.index > 0 && (this_1.isSpan || this_1.parent.isSpan && isEdit)) {
                        var rowsObject = this_1.parent.getRowsObject();
                        var prevRowCells = this_1.parent.groupSettings.columns.length > 0 && !rowsObject[row.index - 1].isDataRow ? rowsObject[row.index].cells : rowsObject[row.index - 1].cells;
                        var uid_1 = "uid";
                        var prevRowCell = prevRowCells.filter(function(cell) {
                            return cell.column.uid === row.cells[parseInt(i.toString(), 10)].column["" + uid_1];
                        })[0];
                        isRowSpanned = prevRowCell.isRowSpanned ? prevRowCell.isRowSpanned : prevRowCell.rowSpanRange > 1;
                    }
                    if (cellArgs.rowSpan > 1 || cellArgs.colSpan > 1) {
                        this_1.resetrowSpanvalue(this_1.parent.frozenRows > row.index ? this_1.parent.frozenRows : this_1.parent.currentViewData.length, cellArgs, row.index);
                        if (cellArgs.column.visible === false) cellArgs.colSpan = 1;
                        else if (isFrozen) {
                            var columns_2 = this_1.parent.getColumns();
                            var right = this_1.parent.getFrozenRightColumnsCount();
                            var left = this_1.parent.getFrozenLeftCount();
                            var movableCount = columns_2.length - right;
                            var cellIdx = cellArgs.column.index;
                            if (left > cellIdx && left < cellIdx + cellArgs.colSpan) {
                                var colSpan = cellIdx + cellArgs.colSpan - left;
                                cellArgs.colSpan = cellArgs.colSpan - colSpan;
                            } else if (movableCount <= cellIdx && columns_2.length < cellIdx + cellArgs.colSpan) {
                                var colSpan = cellIdx + cellArgs.colSpan - columns_2.length;
                                cellArgs.colSpan = cellArgs.colSpan - colSpan;
                            } else if (cellArgs.column.freeze === "Fixed") {
                                var colSpan = 1;
                                var index = cellIdx;
                                for(var j = index + 1; j < index + cellArgs.colSpan; j++){
                                    if (columns_2[parseInt(j.toString(), 10)].freeze === "Fixed") colSpan++;
                                    else break;
                                }
                                cellArgs.colSpan = colSpan;
                            } else if (movableCount > cellIdx && movableCount < cellIdx + cellArgs.colSpan) {
                                var colSpan = cellIdx + cellArgs.colSpan - movableCount;
                                cellArgs.colSpan = cellArgs.colSpan - colSpan;
                            }
                        }
                    }
                    if (cellArgs.colSpan > 1 || row.cells[parseInt(i.toString(), 10)].cellSpan > 1 || cellArgs.rowSpan > 1 || isRowSpanned) {
                        this_1.parent.isSpan = true;
                        this_1.isSpan = true;
                        var cellMerge = new (0, $8b8d76cc41e062b2$export$fd5814f904f8f3b4)(this_1.serviceLocator, this_1.parent);
                        td = cellMerge.render(cellArgs, row, i, td);
                        if (isFrozen) (0, $748c2240e597a9b7$export$e4e976bbecdb8c5d)(this_1.parent, cellArgs.column, td, cellArgs.colSpan);
                    }
                }
                if ((cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader) && isGroupFirstCell && (cell.visible || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader)) {
                    var visibleColumns = this_1.parent.getVisibleColumns();
                    var field = "field";
                    var type = "type";
                    if (cell.column["" + type] && cell.column["" + type] === "checkbox" || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header && cell.column["" + field] && visibleColumns.length && visibleColumns[0].field === cell.column["" + field] || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader) {
                        td.classList.add("e-grid-group-first-cell");
                        isFirstVisibleCell = false;
                    }
                }
                if (this_1.isSpan) {
                    var rowsObject = this_1.parent.getRowsObject();
                    var isRtl = this_1.parent.enableRtl;
                    if (rowsObject[row.index - 1]) {
                        var prevRowCells = rowsObject[row.index - 1].cells;
                        var prevRowCell = prevRowCells[i - 1];
                        var currentRowCell = prevRowCells[parseInt(i.toString(), 10)];
                        var nextRowCell = prevRowCells[i + 1];
                        var direction = prevRowCells[parseInt(i.toString(), 10)].column.freeze;
                        if (prevRowCell && (prevRowCell.isRowSpanned || prevRowCell.rowSpanRange > 1) && prevRowCell.visible) {
                            if (!isRtl && (!currentRowCell.isRowSpanned || prevRowCell.rowSpanRange > currentRowCell.rowSpanRange)) td.classList.add("e-rowcell-firstchild");
                            if (isFrozen) {
                                if (prevRowCell.column.freeze === "Fixed" && direction === "Fixed") td.classList.add(isRtl ? "e-removefreezerightborder" : "e-removefreezeleftborder");
                                else if (!isRtl && i === 1 && direction === "Left") td.classList.add("e-addfreezefirstchildborder");
                            }
                        }
                        if (nextRowCell && (nextRowCell.isRowSpanned || nextRowCell.rowSpanRange > 1) && nextRowCell.visible) {
                            if (isRtl && (!currentRowCell.isRowSpanned || nextRowCell.rowSpanRange > currentRowCell.rowSpanRange)) td.classList.add("e-rowcell-lastchild");
                            if (isFrozen && nextRowCell.column.freeze === "Fixed" && direction === "Fixed" && cellArgs.colSpan < 2) td.classList.add(isRtl ? "e-removefreezeleftborder" : "e-removefreezerightborder");
                        }
                    }
                }
                if (cellArgs.rowSpan > 1 && this_1.parent.currentViewData.length - row.index === cellArgs.rowSpan) td.classList.add("e-row-span-lastrowcell");
                if (!row.cells[parseInt(i.toString(), 10)].isSpanned) tr.appendChild(td);
            }
        };
        var this_1 = this;
        for(var i = 0, len = row.cells.length; i < len; i++)_loop_2(i, len);
        var emptyColspan = 0;
        if (this.parent.groupSettings.columns.length && this.parent.getFrozenLeftColumnsCount()) {
            if (tr.classList.contains("e-groupcaptionrow")) {
                var freezeCells = [].slice.call(tr.querySelectorAll(".e-leftfreeze,.e-unfreeze,.e-rightfreeze,.e-fixedfreeze,.e-freezerightborder,.e-freezeleftborder"));
                if (freezeCells.length) (0, $4ZDHT.removeClass)(freezeCells, [
                    "e-leftfreeze",
                    "e-unfreeze",
                    "e-rightfreeze",
                    "e-fixedfreeze",
                    "e-freezerightborder",
                    "e-freezeleftborder"
                ]);
                if (tr.querySelector(".e-summarycell")) (0, $748c2240e597a9b7$export$27d8d7d7d18b4954)(tr, this.parent);
                else {
                    for(var j = 0; j < tr.childNodes.length; j++){
                        var td = tr.childNodes[parseInt(j.toString(), 10)];
                        td.classList.add("e-leftfreeze");
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(td, j * 30, this.parent.enableRtl, "Left");
                        if (td.classList.contains("e-groupcaption")) {
                            var oldColspan = parseInt(td.getAttribute("colspan"), 10);
                            var colspan = (0, $748c2240e597a9b7$export$fe694ccc69e43b4)(this.parent, j);
                            td.setAttribute("colspan", colspan.toString());
                            emptyColspan = oldColspan - colspan;
                        }
                    }
                    if (emptyColspan) {
                        var td = this.parent.createElement("TD", {
                            className: "e-groupcaption",
                            attrs: {
                                colspan: emptyColspan.toString(),
                                id: this.parent.element.id + "captioncell",
                                tabindex: "-1"
                            }
                        });
                        tr.appendChild(td);
                    }
                }
            }
            if ((tr.querySelectorAll(".e-leftfreeze").length || tr.classList.contains("e-columnheader")) && (tr.querySelectorAll(".e-indentcell").length || tr.querySelectorAll(".e-grouptopleftcell").length)) {
                var td = tr.querySelectorAll(".e-indentcell, .e-grouptopleftcell");
                for(var i = 0; i < td.length; i++){
                    td[parseInt(i.toString(), 10)].classList.add("e-leftfreeze");
                    (0, $748c2240e597a9b7$export$45a1adeafba636b0)(td[parseInt(i.toString(), 10)], i * 30, this.parent.enableRtl, "Left");
                }
            }
        }
        var args = {
            row: tr,
            rowHeight: this.parent.rowHeight
        };
        if (row.isDataRow) {
            var eventArg_1 = (0, $3EnZW.extend)(rowArgs, args);
            eventArg_1.isSelectable = true;
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
            var cellTemplate = eventArg_1.row.querySelectorAll(".e-templatecell");
            if ((this.parent.isReact && this.parent.requireTemplateRef || isReactChild && this.parent.parentDetails.parentInstObj.requireTemplateRef) && cellTemplate.length) {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var thisRef_2 = this;
                thisRef_2.parent.renderTemplates(function() {
                    thisRef_2.parent.trigger((0, $17b89d3b1fc93cdb$export$7528dc9435097481), eventArg_1);
                    if (!eventArg_1.isSelectable) {
                        row.isSelectable = eventArg_1.isSelectable;
                        thisRef_2.disableRowSelection(thisRef_2, row, args, eventArg_1);
                    }
                });
            } else this.parent.trigger((0, $17b89d3b1fc93cdb$export$7528dc9435097481), eventArg_1);
            row.isSelectable = eventArg_1.isSelectable;
            var isDraggable = this.parent.isRowDragable();
            if (this.parent.allowPaging && this.parent.selectionSettings.persistSelection) {
                var primaryKey_1 = this.parent.getPrimaryKeyFieldNames()[0];
                var pKey_1 = row.data ? row.data["" + primaryKey_1] : null;
                var SelectedRecords = eventArg_1.isSelectable ? this.parent.partialSelectedRecords : this.parent.disableSelectedRecords;
                if (!SelectedRecords.some(function(data) {
                    return data["" + primaryKey_1] === pKey_1;
                })) SelectedRecords.push(row.data);
            }
            if (!eventArg_1.isSelectable) this.disableRowSelection(this, row, args, eventArg_1);
            if (this.parent.childGrid || isDraggable || this.parent.detailTemplate) {
                var td = tr.querySelectorAll(".e-rowcell:not(.e-hide)")[0];
                if (td) td.classList.add("e-detailrowvisible");
            }
        }
        if (this.parent.enableVirtualization) rowArgs.rowHeight = this.parent.rowHeight;
        if (rowArgs.rowHeight) tr.style.height = rowArgs.rowHeight + "px";
        else if (this.parent.rowHeight && (tr.querySelector(".e-headercell") || tr.querySelector(".e-groupcaption"))) tr.style.height = this.parent.rowHeight + "px";
        if (row.cssClass) tr.classList.add(row.cssClass);
        if (row.lazyLoadCssClass) tr.classList.add(row.lazyLoadCssClass);
        if (this.parent.rowRenderingMode === "Vertical" && this.parent.allowTextWrap && (this.parent.textWrapSettings.wrapMode === "Header" || this.parent.textWrapSettings.wrapMode === "Both")) tr.classList.add("e-verticalwrap");
        var vFTable = this.parent.enableColumnVirtualization;
        if (!vFTable && this.parent.aggregates.length && this.parent.element.scrollHeight > this.parent.height) for(var i = 0; i < this.parent.aggregates.length; i++){
            var property = "properties";
            var column = "columns";
            if (this.parent.aggregates[parseInt(i.toString(), 10)]["" + property]["" + column][0].footerTemplate) {
                var summarycell = [].slice.call(tr.getElementsByClassName("e-summarycell"));
                if (summarycell.length) {
                    var lastSummaryCell = summarycell[summarycell.length - 1];
                    (0, $4ZDHT.addClass)([
                        lastSummaryCell
                    ], [
                        "e-lastsummarycell"
                    ]);
                    var firstSummaryCell = summarycell[0];
                    (0, $4ZDHT.addClass)([
                        firstSummaryCell
                    ], [
                        "e-firstsummarycell"
                    ]);
                }
            }
        }
        return tr;
    };
    RowRenderer.prototype.resetrowSpanvalue = function(rowCount, cellArgs, rowIndex) {
        if (rowCount > rowIndex && rowCount < rowIndex + cellArgs.rowSpan) {
            var rowSpan = rowIndex + cellArgs.rowSpan - rowCount;
            cellArgs.rowSpan = cellArgs.rowSpan - rowSpan;
        }
    };
    RowRenderer.prototype.disableRowSelection = function(thisRef, row, args, eventArg) {
        var selIndex = this.parent.getSelectedRowIndexes();
        this.parent.selectionModule.isPartialSelection = true;
        row.isSelected = false;
        var selRowIndex = selIndex.indexOf(row.index);
        if (selRowIndex > -1) selIndex.splice(selRowIndex, 1);
        var chkBox = args.row.querySelectorAll(".e-rowcell.e-gridchkbox");
        var isDrag = eventArg.row.querySelector(".e-rowdragdrop");
        var cellIdx = thisRef.parent.groupSettings.columns.length + (isDrag || thisRef.parent.isDetail() ? 1 : 0);
        for(var i = 0; i < chkBox.length; i++){
            chkBox[parseInt(i.toString(), 10)].firstElementChild.classList.add("e-checkbox-disabled");
            chkBox[parseInt(i.toString(), 10)].querySelector(".e-frame").classList.remove("e-check");
        }
        if (row.cells.length) for(var i = cellIdx; i < row.cells.length; i++){
            var cell = eventArg.row.querySelector('.e-rowcell[data-colindex="' + row.cells[parseInt(i.toString(), 10)].index + '"]');
            if (cell) (0, $4ZDHT.removeClass)([
                cell
            ], [
                "e-selectionbackground",
                "e-active"
            ]);
        }
        if (isDrag) (0, $4ZDHT.removeClass)([
            isDrag
        ], [
            "e-selectionbackground",
            "e-active"
        ]);
    };
    RowRenderer.prototype.refreshMergeCells = function(row) {
        for(var _i = 0, _a = row.cells; _i < _a.length; _i++){
            var cell = _a[_i];
            cell.isSpanned = false;
        }
        return row;
    };
    /* eslint-disable */ /**
     * Function to check and add alternative row css class.
     *
     * @param {Element} tr - specifies the tr element
     * @param {Row<T>} row - specifies the row
     * @returns {void}
     */ /* eslint-enable */ RowRenderer.prototype.buildAttributeFromRow = function(tr, row) {
        var attr = {};
        var prop = {
            "rowindex": $1b5568e76cdae6d4$export$bbfd9040f0589a82,
            "dataUID": "data-uid",
            "ariaSelected": "aria-selected"
        };
        var classes = [];
        if (row.isDataRow) classes.push($1b5568e76cdae6d4$export$120ff0929b202a6d);
        if (row.isAltRow) classes.push("e-altrow");
        if (row.isCaptionRow) classes.push("e-groupcaptionrow");
        if (row.isAggregateRow && row.parentUid) classes.push("e-groupfooterrow");
        if (!(0, $3EnZW.isNullOrUndefined)(row.index)) {
            attr[$1b5568e76cdae6d4$export$be459c01dd76713e] = row.index + 1;
            attr[prop.rowindex] = row.index;
        }
        if (row.rowSpan) attr.rowSpan = row.rowSpan;
        if (row.uid) attr[prop.dataUID] = row.uid;
        if (row.isSelected) attr[prop.ariaSelected] = true;
        if (row.visible === false) classes.push("e-hide");
        attr.class = classes;
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(tr, attr);
    };
    return RowRenderer;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");






/**
 * RowModelGenerator is used to generate grid data rows.
 *
 * @hidden
 */ var $7ddfd3da489c240b$export$2cf41885b7ecbd06 = /** @class */ function() {
    /**
     * Constructor for header renderer module
     *
     * @param {IGrid} parent - specifies the IGrid
     */ function RowModelGenerator(parent) {
        this.parent = parent;
    }
    RowModelGenerator.prototype.generateRows = function(data, args) {
        var rows = [];
        var startIndex = this.parent.enableVirtualization && args ? args.startIndex : 0;
        startIndex = this.parent.enableInfiniteScrolling && args ? this.getInfiniteIndex(args) : startIndex;
        if (this.parent.enableImmutableMode && args && args.startIndex) startIndex = args.startIndex;
        for(var i = 0, len = Object.keys(data).length; i < len; i++, startIndex++)rows[parseInt(i.toString(), 10)] = this.generateRow(data[parseInt(i.toString(), 10)], startIndex);
        return rows;
    };
    RowModelGenerator.prototype.ensureColumns = function() {
        //TODO: generate dummy column for group, detail here;
        var cols = [];
        if (this.parent.detailTemplate || this.parent.childGrid) {
            var args = {};
            this.parent.notify($17b89d3b1fc93cdb$export$74c82625a332a083, args);
            cols.push(this.generateCell(args, null, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailExpand));
        }
        if (this.parent.isRowDragable()) cols.push(this.generateCell({}, null, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragIcon));
        return cols;
    };
    RowModelGenerator.prototype.generateRow = function(data, index, cssClass, indent, pid, tIndex, parentUid) {
        var options = {};
        options.foreignKeyData = {};
        options.uid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("grid-row");
        options.data = data;
        options.index = index;
        options.indent = indent;
        options.tIndex = tIndex;
        options.isDataRow = true;
        options.parentGid = pid;
        options.parentUid = parentUid;
        if (this.parent.isPrinting) {
            if (this.parent.hierarchyPrintMode === "All") options.isExpand = true;
            else if (this.parent.hierarchyPrintMode === "Expanded" && this.parent.expandedRows && this.parent.expandedRows[parseInt(index.toString(), 10)]) options.isExpand = this.parent.expandedRows[parseInt(index.toString(), 10)].isExpand;
        }
        options.cssClass = cssClass;
        options.isAltRow = this.parent.enableAltRow ? index % 2 !== 0 : false;
        options.isAltRow = this.parent.enableAltRow ? index % 2 !== 0 : false;
        options.isSelected = this.parent.getSelectedRowIndexes().indexOf(index) > -1;
        this.refreshForeignKeyRow(options);
        var cells = this.ensureColumns();
        var row = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)(options, this.parent);
        row.cells = this.parent.getFrozenMode() === "Right" ? this.generateCells(options).concat(cells) : cells.concat(this.generateCells(options));
        return row;
    };
    RowModelGenerator.prototype.refreshForeignKeyRow = function(options) {
        var foreignKeyColumns = this.parent.getForeignKeyColumns();
        for(var i = 0; i < foreignKeyColumns.length; i++)(0, $3EnZW.setValue)(foreignKeyColumns[parseInt(i.toString(), 10)].field, (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(foreignKeyColumns[parseInt(i.toString(), 10)], options.data), options.foreignKeyData);
    };
    RowModelGenerator.prototype.generateCells = function(options) {
        var dummies = this.parent.getColumns();
        var tmp = [];
        for(var i = 0; i < dummies.length; i++)tmp.push(this.generateCell(dummies[parseInt(i.toString(), 10)], options.uid, (0, $3EnZW.isNullOrUndefined)(dummies[parseInt(i.toString(), 10)].commands) ? undefined : (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CommandColumn, null, i, options.foreignKeyData));
        return tmp;
    };
    /**
     *
     * @param {Column} column - Defines column details
     * @param {string} rowId - Defines row id
     * @param {CellType} cellType  - Defines cell type
     * @param {number} colSpan - Defines colSpan
     * @param {number} oIndex - Defines index
     * @param {Object} foreignKeyData - Defines foreign key data
     * @returns {Cell<Column>} returns cell model
     * @hidden
     */ RowModelGenerator.prototype.generateCell = function(column, rowId, cellType, colSpan, oIndex, foreignKeyData) {
        var opt = {
            "visible": column.visible,
            "isDataCell": !(0, $3EnZW.isNullOrUndefined)(column.field || column.template),
            "isTemplate": !(0, $3EnZW.isNullOrUndefined)(column.template),
            "rowID": rowId,
            "column": column,
            "cellType": !(0, $3EnZW.isNullOrUndefined)(cellType) ? cellType : (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data,
            "colSpan": colSpan,
            "commands": column.commands,
            "isForeignKey": column.isForeignColumn && column.isForeignColumn(),
            "foreignKeyData": column.isForeignColumn && column.isForeignColumn() && (0, $3EnZW.getValue)(column.field, foreignKeyData)
        };
        if (opt.isDataCell || opt.column.type === "checkbox" || opt.commands) opt.index = oIndex;
        return new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)(opt);
    };
    RowModelGenerator.prototype.refreshRows = function(input) {
        for(var i = 0; i < input.length; i++){
            this.refreshForeignKeyRow(input[parseInt(i.toString(), 10)]);
            input[parseInt(i.toString(), 10)].cells = this.generateCells(input[parseInt(i.toString(), 10)]);
        }
        return input;
    };
    RowModelGenerator.prototype.getInfiniteIndex = function(args) {
        return args.requestType === "infiniteScroll" || args.requestType === "delete" || args.action === "add" ? (0, $3EnZW.isNullOrUndefined)(args.startIndex) ? args["index"] : args.startIndex : 0;
    };
    return RowModelGenerator;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");




parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



var $add3e338055b95e6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Summary row model generator
 *
 * @hidden
 */ var $add3e338055b95e6$export$5d9b1dac619ba2d8 = /** @class */ function() {
    /**
     * Constructor for Summary row model generator
     *
     * @param {IGrid} parent - specifies the IGrid
     */ function SummaryModelGenerator(parent) {
        this.parent = parent;
    }
    SummaryModelGenerator.prototype.getData = function() {
        var _this = this;
        var rows = [];
        var row = this.parent.aggregates.slice();
        for(var i = 0; i < row.length; i++){
            var columns = row[parseInt(i.toString(), 10)].columns.filter(function(column) {
                return !(column.footerTemplate || column.groupFooterTemplate || column.groupCaptionTemplate) || _this.columnSelector(column);
            });
            if (columns.length) rows.push({
                columns: columns
            });
        }
        return rows;
    };
    SummaryModelGenerator.prototype.columnSelector = function(column) {
        return column.footerTemplate !== undefined;
    };
    SummaryModelGenerator.prototype.getColumns = function(start) {
        var columns = [];
        if (this.parent.detailTemplate || !(0, $3EnZW.isNullOrUndefined)(this.parent.childGrid)) columns.push(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({}));
        if (this.parent.allowGrouping) for(var i = 0; i < this.parent.groupSettings.columns.length; i++)columns.push(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({}));
        if (this.parent.isRowDragable() && !start) columns.push(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({}));
        columns.push.apply(columns, this.parent.getColumns());
        return columns;
    };
    SummaryModelGenerator.prototype.generateRows = function(input, args, start, end, columns) {
        if (input.length === 0) {
            if (args === undefined || !(args.count || args.loadSummaryOnEmpty)) return [];
        }
        var data = this.buildSummaryData(input, args);
        var rows = [];
        var row = this.getData();
        for(var i = 0; i < row.length; i++)rows.push(this.getGeneratedRow(row[parseInt(i.toString(), 10)], data[parseInt(i.toString(), 10)], args ? args.level : undefined, start, end, args ? args.parentUid : undefined, columns));
        return rows;
    };
    SummaryModelGenerator.prototype.getGeneratedRow = function(summaryRow, data, raw, start, end, parentUid, columns) {
        var tmp = [];
        var indents = this.getIndentByLevel();
        var isDetailGridAlone = !(0, $3EnZW.isNullOrUndefined)(this.parent.childGrid);
        var indentLength = this.parent.getIndentCount();
        if (this.parent.groupSettings.columns.length && this.parent.allowRowDragAndDrop) indents.push("e-indentcelltop");
        else if (this.parent.isRowDragable() && !start) indents = [
            "e-indentcelltop"
        ];
        var values = columns ? columns : this.getColumns(start);
        for(var i = 0; i < values.length; i++)tmp.push(this.getGeneratedCell(values[parseInt(i.toString(), 10)], summaryRow, i >= indentLength ? this.getCellType() : i === 0 && this.parent.childGrid ? (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailFooterIntent : (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Indent, indents[parseInt(i.toString(), 10)], isDetailGridAlone));
        var row = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)({
            data: data,
            attributes: {
                class: "e-summaryrow"
            }
        });
        row.cells = tmp;
        row.uid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("grid-row");
        row.parentUid = parentUid;
        row.isAggregateRow = true;
        row.visible = tmp.some(function(cell) {
            return cell.isDataCell && cell.visible;
        });
        return row;
    };
    SummaryModelGenerator.prototype.getGeneratedCell = function(column, summaryRow, cellType, indent, isDetailGridAlone) {
        //Get the summary column by display
        var sColumn = summaryRow.columns.filter(function(scolumn) {
            return scolumn.columnName === column.field;
        })[0];
        var attrs = {
            "style": {
                "textAlign": column.textAlign
            },
            "e-mappinguid": column.uid,
            index: column.index
        };
        if (indent) attrs.class = indent;
        if ((0, $3EnZW.isNullOrUndefined)(indent) && isDetailGridAlone) attrs.class = "e-detailindentcelltop";
        var opt = {
            "visible": column.visible,
            "isDataCell": !(0, $3EnZW.isNullOrUndefined)(sColumn),
            "isTemplate": sColumn && !(0, $3EnZW.isNullOrUndefined)(sColumn.footerTemplate || sColumn.groupFooterTemplate || sColumn.groupCaptionTemplate),
            "column": sColumn || {},
            "attributes": attrs,
            "cellType": cellType
        };
        opt.column.headerText = column.headerText;
        return new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)(opt);
    };
    SummaryModelGenerator.prototype.buildSummaryData = function(data, args) {
        var dummy = [];
        var summaryRows = this.getData();
        var single = {};
        for(var i = 0; i < summaryRows.length; i++){
            single = {};
            var column = summaryRows[parseInt(i.toString(), 10)].columns;
            for(var j = 0; j < column.length; j++)single = this.setTemplate(column[parseInt(j.toString(), 10)], args && args.aggregates ? args : data, single);
            dummy.push(single);
        }
        return dummy;
    };
    SummaryModelGenerator.prototype.getIndentByLevel = function() {
        return this.parent.groupSettings.columns.map(function() {
            return "e-indentcelltop";
        });
    };
    SummaryModelGenerator.prototype.setTemplate = function(column, data, single) {
        var types = column.type;
        var helper = {};
        var formatFn = column.getFormatter() || function() {
            return function(a) {
                return a;
            };
        }();
        var group = data;
        if (!(types instanceof Array)) types = [
            column.type
        ];
        for(var i = 0; i < types.length; i++){
            var key = column.field + " - " + types[parseInt(i.toString(), 10)].toLowerCase();
            var disp = column.columnName;
            var disablePageWiseAggregatesGroup = this.parent.groupSettings.disablePageWiseAggregates && this.parent.groupSettings.columns.length && group.items ? true : false;
            var val = (types[parseInt(i.toString(), 10)] !== "Custom" || disablePageWiseAggregatesGroup) && group.aggregates && key in group.aggregates ? group.aggregates["" + key] : (0, $748c2240e597a9b7$export$cbe16b853cd7bbc8)(types[parseInt(i.toString(), 10)], group.aggregates ? group : data, column, this.parent);
            single["" + disp] = single["" + disp] || {};
            single["" + disp]["" + key] = val;
            single["" + disp][types[parseInt(i.toString(), 10)]] = !(0, $3EnZW.isNullOrUndefined)(val) ? formatFn(val) : " ";
            if (group.field) {
                single["" + disp].field = group.field;
                single["" + disp].key = group.key;
            }
        }
        helper.format = column.getFormatter();
        column.setTemplate(helper);
        return single;
    };
    SummaryModelGenerator.prototype.getCellType = function() {
        return (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Summary;
    };
    return SummaryModelGenerator;
}();
var $add3e338055b95e6$export$f766a86dea6dd817 = /** @class */ function(_super) {
    $add3e338055b95e6$var$__extends(GroupSummaryModelGenerator, _super);
    function GroupSummaryModelGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupSummaryModelGenerator.prototype.columnSelector = function(column) {
        return column.groupFooterTemplate !== undefined;
    };
    GroupSummaryModelGenerator.prototype.getIndentByLevel = function(level) {
        if (level === void 0) level = this.parent.groupSettings.columns.length;
        if (this.parent.allowRowDragAndDrop && this.parent.groupSettings.columns.length) level -= 1;
        return this.parent.groupSettings.columns.map(function(v, indx) {
            return indx <= level - 1 ? "" : "e-indentcelltop";
        });
    };
    GroupSummaryModelGenerator.prototype.getCellType = function() {
        return (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary;
    };
    return GroupSummaryModelGenerator;
}($add3e338055b95e6$export$5d9b1dac619ba2d8);
var $add3e338055b95e6$export$626eb12b5cc2f09f = /** @class */ function(_super) {
    $add3e338055b95e6$var$__extends(CaptionSummaryModelGenerator, _super);
    function CaptionSummaryModelGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaptionSummaryModelGenerator.prototype.columnSelector = function(column) {
        return column.groupCaptionTemplate !== undefined;
    };
    CaptionSummaryModelGenerator.prototype.getData = function() {
        var initVal = {
            columns: []
        };
        return [
            _super.prototype.getData.call(this).reduce(function(prev, cur) {
                prev.columns = prev.columns.concat(cur.columns);
                return prev;
            }, initVal)
        ];
    };
    CaptionSummaryModelGenerator.prototype.isEmpty = function() {
        return (this.getData()[0].columns || []).length === 0;
    };
    CaptionSummaryModelGenerator.prototype.getCellType = function() {
        return (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary;
    };
    return CaptionSummaryModelGenerator;
}($add3e338055b95e6$export$5d9b1dac619ba2d8);



var $00f5ac64cc4c9276$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * GroupModelGenerator is used to generate group caption rows and data rows.
 *
 * @hidden
 */ var $00f5ac64cc4c9276$export$e121011a4bc11d9e = /** @class */ function(_super) {
    $00f5ac64cc4c9276$var$__extends(GroupModelGenerator, _super);
    function GroupModelGenerator(parent) {
        var _this = _super.call(this, parent) || this;
        _this.rows = [];
        /** @hidden */ _this.index = 0;
        _this.infiniteChildCount = 0;
        _this.renderInfiniteAgg = true;
        _this.parent = parent;
        _this.summaryModelGen = new (0, $add3e338055b95e6$export$f766a86dea6dd817)(parent);
        _this.captionModelGen = new (0, $add3e338055b95e6$export$626eb12b5cc2f09f)(parent);
        return _this;
    }
    GroupModelGenerator.prototype.generateRows = function(data, args) {
        if (this.parent.groupSettings.columns.length === 0) return _super.prototype.generateRows.call(this, data, args);
        this.isInfiniteScroll = args.requestType === "infiniteScroll";
        this.rows = [];
        this.index = this.parent.enableVirtualization || this.isInfiniteScroll ? args.startIndex : 0;
        for(var i = 0, len = data.length; i < len; i++){
            this.infiniteChildCount = 0;
            this.renderInfiniteAgg = true;
            this.getGroupedRecords(0, data[parseInt(i.toString(), 10)], data.level, i, undefined, this.rows.length);
        }
        this.index = 0;
        if (this.parent.isCollapseStateEnabled()) this.ensureRowVisibility();
        return this.rows;
    };
    GroupModelGenerator.prototype.getGroupedRecords = function(index, data, raw, parentid, childId, tIndex, parentUid) {
        var _a;
        var level = raw;
        if ((0, $3EnZW.isNullOrUndefined)(data.items)) {
            if ((0, $3EnZW.isNullOrUndefined)(data.GroupGuid)) this.rows = this.rows.concat(this.generateDataRows(data, index, parentid, this.rows.length, parentUid));
            else for(var j = 0, len = data.length; j < len; j++)this.getGroupedRecords(index, data[parseInt(j.toString(), 10)], data.level, parentid, index, this.rows.length, parentUid);
        } else {
            var preCaption = void 0;
            var captionRow = this.generateCaptionRow(data, index, parentid, childId, tIndex, parentUid);
            if (this.isInfiniteScroll) preCaption = this.getPreCaption(index, captionRow.data.key);
            if (!preCaption) this.rows = this.rows.concat(captionRow);
            else captionRow.uid = preCaption.uid;
            if (data.items && data.items.length) this.getGroupedRecords(index + 1, data.items, data.items.level, parentid, index + 1, this.rows.length, captionRow.uid);
            if (this.parent.aggregates.length && this.isRenderAggregate(captionRow)) {
                var rowCnt = this.rows.length;
                (_a = this.rows).push.apply(_a, this.summaryModelGen.generateRows(data, {
                    level: level,
                    parentUid: captionRow.uid
                }));
                for(var i = rowCnt - 1; i >= 0; i--){
                    if (this.rows[parseInt(i.toString(), 10)].isCaptionRow) this.rows[parseInt(i.toString(), 10)].aggregatesCount = this.rows.length - rowCnt;
                    else if (!this.rows[parseInt(i.toString(), 10)].isCaptionRow && !this.rows[parseInt(i.toString(), 10)].isDataRow) break;
                }
            }
            if (preCaption) this.setInfiniteRowVisibility(preCaption);
        }
    };
    GroupModelGenerator.prototype.isRenderAggregate = function(data) {
        if (this.parent.enableInfiniteScrolling) {
            if (!this.renderInfiniteAgg) return false;
            this.getPreCaption(data.indent, data.data.key);
            this.renderInfiniteAgg = data.data.count === this.infiniteChildCount;
            return this.renderInfiniteAgg;
        }
        return !this.parent.enableInfiniteScrolling;
    };
    GroupModelGenerator.prototype.getPreCaption = function(indent, key) {
        var rowObj = this.parent.getRowsObject().concat(this.rows);
        var preCap;
        this.infiniteChildCount = 0;
        var i = rowObj.length;
        while(i--){
            if (rowObj[parseInt(i.toString(), 10)].isCaptionRow && rowObj[parseInt(i.toString(), 10)].indent === indent) {
                var groupKey = rowObj[parseInt(i.toString(), 10)].data.key;
                if (groupKey.toString() === key.toString() && groupKey instanceof Date || groupKey === key) preCap = rowObj[parseInt(i.toString(), 10)];
            }
            if (rowObj[parseInt(i.toString(), 10)].indent === indent || rowObj[parseInt(i.toString(), 10)].indent < indent) break;
            if (rowObj[parseInt(i.toString(), 10)].indent === indent + 1) this.infiniteChildCount++;
        }
        return preCap;
    };
    GroupModelGenerator.prototype.getCaptionRowCells = function(field, indent, data) {
        var cells = [];
        var visibles = [];
        var column = this.parent.getColumnByField(field);
        var indexes = this.parent.getColumnIndexesInView();
        if (this.parent.enableColumnVirtualization) column = this.parent.columns.filter(function(c) {
            return c.field === field;
        })[0];
        var groupedLen = this.parent.groupSettings.columns.length;
        var gObj = this.parent;
        if (!this.parent.enableColumnVirtualization || indexes.indexOf(indent) !== -1) {
            for(var i = 0; i < indent; i++)cells.push(this.generateIndentCell());
            cells.push(this.generateCell({}, null, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Expand));
        }
        indent = this.parent.enableColumnVirtualization ? 1 : this.parent.getVisibleColumns().length + groupedLen + (gObj.detailTemplate || gObj.childGrid ? 1 : 0) - indent + (this.parent.getVisibleColumns().length ? -1 : 0);
        //Captionsummary cells will be added here.
        if (this.parent.aggregates.length && !this.captionModelGen.isEmpty()) {
            var captionCells = this.captionModelGen.generateRows(data)[0];
            (0, $3EnZW.extend)(data, captionCells.data);
            var cIndex_1 = 0;
            captionCells.cells.some(function(cell, index) {
                cIndex_1 = index;
                return cell.visible && cell.isDataCell;
            });
            visibles = captionCells.cells.slice(cIndex_1).filter(function(cell) {
                return cell.visible;
            });
            if (captionCells.visible && visibles[0].column.field === this.parent.getVisibleColumns()[0].field) visibles = visibles.slice(1);
            if (this.parent.getVisibleColumns().length === 1) visibles = [];
            indent = indent - visibles.length;
        }
        var cols = !this.parent.enableColumnVirtualization ? [
            column
        ] : this.parent.getColumns();
        var wFlag = true;
        for(var j = 0; j < cols.length; j++){
            var tmpFlag = wFlag && indexes.indexOf(indent) !== -1;
            if (tmpFlag) wFlag = false;
            var cellType = !this.parent.enableColumnVirtualization || tmpFlag ? (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaption : (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaptionEmpty;
            indent = this.parent.enableColumnVirtualization && cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaption ? indent + groupedLen : indent;
            if (gObj.isRowDragable()) indent++;
            cells.push(this.generateCell(column, null, cellType, indent));
        }
        cells.push.apply(cells, visibles);
        return cells;
    };
    /**
     * @param {GroupedData} data - specifies the data
     * @param {number} indent - specifies the indent
     * @param {number} parentID - specifies the parentID
     * @param {number} childID - specifies the childID
     * @param {number} tIndex - specifies the TIndex
     * @param {string} parentUid - specifies the ParentUid
     * @returns {Row<Column>} returns the Row object
     * @hidden
     */ GroupModelGenerator.prototype.generateCaptionRow = function(data, indent, parentID, childID, tIndex, parentUid) {
        var options = {};
        var records = "records";
        var col = this.parent.getColumnByField(data.field);
        options.data = (0, $3EnZW.extend)({}, data);
        if (col) options.data.field = data.field;
        options.isDataRow = false;
        options.isExpand = !this.parent.groupSettings.enableLazyLoading && !this.parent.isCollapseStateEnabled();
        options.parentGid = parentID;
        options.childGid = childID;
        options.tIndex = tIndex;
        options.isCaptionRow = true;
        options.parentUid = parentUid;
        options.gSummary = !(0, $3EnZW.isNullOrUndefined)(data.items["" + records]) ? data.items["" + records].length : data.items.length;
        options.uid = (0, $748c2240e597a9b7$export$5e82334337e0f204)("grid-row");
        var row = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)(options);
        row.indent = indent;
        this.getForeignKeyData(row);
        row.cells = this.getCaptionRowCells(data.field, indent, row.data);
        return row;
    };
    GroupModelGenerator.prototype.getForeignKeyData = function(row) {
        var data = row.data;
        var col = this.parent.getColumnByField(data.field);
        if (col && col.isForeignColumn && col.isForeignColumn()) {
            var fkValue = (0, $3EnZW.isNullOrUndefined)(data.key) ? "" : col.valueAccessor(col.foreignKeyValue, (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(col, {}, data.key)[0], col);
            (0, $3EnZW.setValue)("foreignKey", fkValue, row.data);
        }
    };
    /**
     * @param {Object[]} data - specifies the data
     * @param {number} indent - specifies the indent
     * @param {number} childID - specifies the childID
     * @param {number} tIndex - specifies the tIndex
     * @param {string} parentUid - specifies the ParentUid
     * @returns {Row<Column>[]} returns the row object
     * @hidden
     */ GroupModelGenerator.prototype.generateDataRows = function(data, indent, childID, tIndex, parentUid) {
        var rows = [];
        var indexes = this.parent.getColumnIndexesInView();
        for(var i = 0, len = data.length; i < len; i++, tIndex++){
            rows[parseInt(i.toString(), 10)] = this.generateRow(data[parseInt(i.toString(), 10)], this.index, i ? undefined : "e-firstchildrow", indent, childID, tIndex, parentUid);
            for(var j = 0; j < indent; j++){
                if (this.parent.enableColumnVirtualization && indexes.indexOf(indent) === -1) continue;
                rows[parseInt(i.toString(), 10)].cells.unshift(this.generateIndentCell());
            }
            this.index++;
        }
        return rows;
    };
    GroupModelGenerator.prototype.generateIndentCell = function() {
        return this.generateCell({}, null, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Indent);
    };
    GroupModelGenerator.prototype.refreshRows = function(input) {
        var indexes = this.parent.getColumnIndexesInView();
        for(var i = 0; i < input.length; i++)if (input[parseInt(i.toString(), 10)].isDataRow) {
            input[parseInt(i.toString(), 10)].cells = this.generateCells(input[parseInt(i.toString(), 10)]);
            for(var j = 0; j < input[parseInt(i.toString(), 10)].indent; j++){
                if (this.parent.enableColumnVirtualization && indexes.indexOf(input[parseInt(i.toString(), 10)].indent) === -1) continue;
                input[parseInt(i.toString(), 10)].cells.unshift(this.generateIndentCell());
            }
        } else {
            var cRow = this.generateCaptionRow(input[parseInt(i.toString(), 10)].data, input[parseInt(i.toString(), 10)].indent);
            input[parseInt(i.toString(), 10)].cells = cRow.cells;
        }
        return input;
    };
    GroupModelGenerator.prototype.setInfiniteRowVisibility = function(caption) {
        if (!caption.isExpand || caption.visible === false) for(var _i = 0, _a = this.rows; _i < _a.length; _i++){
            var row = _a[_i];
            if (row.parentUid === caption.uid) {
                row.visible = false;
                if (row.isCaptionRow) this.setInfiniteRowVisibility(row);
            }
        }
    };
    GroupModelGenerator.prototype.ensureRowVisibility = function() {
        for(var i = 0; i < this.rows.length; i++){
            var row = this.rows[parseInt(i.toString(), 10)];
            if (!row.isCaptionRow) continue;
            for(var j = i + 1; j < this.rows.length; j++){
                var childRow = this.rows[parseInt(j.toString(), 10)];
                if (row.uid === childRow.parentUid) this.rows[parseInt(j.toString(), 10)].visible = row.isExpand;
            }
        }
    };
    return GroupModelGenerator;
}((0, $7ddfd3da489c240b$export$2cf41885b7ecbd06));



// eslint-disable-next-line valid-jsdoc, jsdoc/require-param, jsdoc/require-returns
/**
 * Content module is used to render grid content
 *
 * @hidden
 */ var $c2232dcd2e373cda$export$6e65718da26e0698 = /** @class */ function() {
    /**
     * Constructor for content renderer module
     *
     * @param {IGrid} parent - specifies the Igrid
     * @param {ServiceLocator} serviceLocator - specifies the service locator
     */ function ContentRender(parent, serviceLocator) {
        var _this = this;
        this.rows = [];
        this.freezeRows = [];
        this.movableRows = [];
        this.freezeRowElements = [];
        /** @hidden */ this.currentInfo = {};
        /** @hidden */ this.prevCurrentView = [];
        this.isLoaded = true;
        this.drop = function(e) {
            _this.parent.notify($17b89d3b1fc93cdb$export$553a7dc8a546fa4c, {
                target: e.target,
                droppedElement: e.droppedElement
            });
            (0, $4ZDHT.remove)(e.droppedElement);
        };
        this.infiniteCache = {};
        /** @hidden */ this.visibleRows = [];
        this.visibleFrozenRows = [];
        this.rightFreezeRows = [];
        this.isAddRows = false;
        this.isInfiniteFreeze = false;
        this.useGroupCache = false;
        /** @hidden */ this.tempFreezeRows = [];
        this.rafCallback = function(args) {
            var arg = args;
            return function() {
                _this.ariaService.setBusy(_this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb), false);
                if (_this.parent.isDestroyed) return;
                var rows = _this.rows.slice(0);
                if (_this.parent.enableInfiniteScrolling) {
                    if (_this.parent.groupSettings.enableLazyLoading) for(var i = 0; i < _this.visibleRows.length; i++)_this.setRowsInLazyGroup(_this.visibleRows[parseInt(i.toString(), 10)], i);
                    rows = _this.parent.getRowsObject();
                    var prevPage = arg.prevPage;
                    if (_this.parent.infiniteScrollSettings.enableCache && prevPage) {
                        var maxBlock = _this.parent.infiniteScrollSettings.maxBlocks;
                        rows = [];
                        var rowIdx = parseInt(_this.rowElements[0].getAttribute("data-rowindex"), 10) + 1;
                        var startIdx = Math.ceil(rowIdx / _this.parent.pageSettings.pageSize);
                        for(var i = 0, count = startIdx; i < maxBlock; i++, count++)if (_this.infiniteCache[parseInt(count.toString(), 10)]) rows = rows.concat(_this.infiniteCache[parseInt(count.toString(), 10)]);
                    }
                }
                _this.parent.notify($17b89d3b1fc93cdb$export$f44d9209b353bf3e, {
                    rows: rows,
                    args: arg
                });
                if (_this.parent.editSettings.showAddNewRow && _this.parent.addNewRowFocus) {
                    _this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
                    _this.parent.addNewRowFocus = false;
                }
                if (_this.parent.autoFit) _this.parent.preventAdjustColumns();
                if (!_this.parent.isInitialLoad) _this.parent.focusModule.setFirstFocusableTabIndex();
                if (_this.isLoaded) {
                    _this.parent.isManualRefresh = false;
                    if (_this.parent.enableInfiniteScrolling && _this.parent.groupSettings.enableLazyLoading && args.requestType === "sorting") _this.parent.infiniteScrollModule["groupCaptionAction"] = undefined;
                    var isReactChild = _this.parent.parentDetails && _this.parent.parentDetails.parentInstObj && _this.parent.parentDetails.parentInstObj.isReact;
                    if ((_this.parent.isReact || isReactChild) && _this.parent.element.querySelectorAll(".e-templatecell").length) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        var thisRef_1 = _this;
                        thisRef_1.parent.renderTemplates(function() {
                            thisRef_1.parent.trigger($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, {}, function() {
                                if (thisRef_1.parent.allowTextWrap) thisRef_1.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
                                    case: "textwrap"
                                });
                            });
                        });
                    } else _this.parent.trigger($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, {}, function() {
                        if (_this.parent.allowTextWrap) _this.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
                            case: "textwrap"
                        });
                    });
                    if (_this.parent.allowTextWrap && _this.parent.height === "auto") {
                        if (_this.parent.getContentTable().scrollHeight > _this.parent.getContent().clientHeight) _this.parent.scrollModule.setPadding();
                        else _this.parent.scrollModule.removePadding();
                    }
                }
                if (arg) {
                    var action = (arg.requestType || "").toLowerCase() + "-complete";
                    _this.parent.notify(action, arg);
                    if (args.requestType === "batchsave") {
                        args.cancel = false;
                        _this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, args);
                    }
                }
                if (_this.isLoaded) _this.parent.hideSpinner();
            };
        };
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.widthService = serviceLocator.getService("widthService");
        this.ariaService = this.serviceLocator.getService("ariaService");
        this.parent.enableDeepCompare = this.parent.getDataModule().isRemote();
        this.generator = this.getModelGenerator();
        if (this.parent.isDestroyed) return;
        if (!this.parent.enableColumnVirtualization && !this.parent.enableVirtualization && !this.parent.groupSettings.enableLazyLoading) this.parent.on($17b89d3b1fc93cdb$export$c480fa254fb70e72, this.setVisible, this);
        this.parent.on($17b89d3b1fc93cdb$export$dd9331973c9310ae, this.colGroupRefresh, this);
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender, this);
        this.parent.on($17b89d3b1fc93cdb$export$c2efdb1b36d9fb1f, this.refreshContentRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0, this.beforeCellFocused, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.droppableDestroy, this);
    }
    ContentRender.prototype.beforeCellFocused = function(e) {
        if (e.byKey && (e.keyArgs.action === "upArrow" || e.keyArgs.action === "downArrow")) this.pressedKey = e.keyArgs.action;
        else this.pressedKey = undefined;
    };
    /**
     * The function is used to render grid content div
     *
     * @returns {void}
     */ ContentRender.prototype.renderPanel = function() {
        var gObj = this.parent;
        var div = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474);
        if (div) {
            this.ariaService.setOptions(this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb), {
                busy: false
            });
            this.setPanel(div);
            return;
        }
        div = this.parent.createElement("div", {
            className: $1b5568e76cdae6d4$export$ee5f1442ff7df474
        });
        var innerDiv = this.parent.createElement("div", {
            className: $1b5568e76cdae6d4$export$a7db06668cad9adb
        });
        this.ariaService.setOptions(innerDiv, {
            busy: false
        });
        if (this.parent.enableColumnVirtualization && this.parent.isFrozenGrid()) {
            this.renderHorizontalScrollbar(div);
            innerDiv.classList.add("e-virtual-content");
        }
        div.appendChild(innerDiv);
        this.setPanel(div);
        gObj.element.appendChild(div);
    };
    ContentRender.prototype.renderHorizontalScrollbar = function(element) {
        var parent = this.parent.createElement("div", {
            className: "e-movablescrollbar"
        });
        var child = this.parent.createElement("div", {
            className: "e-movablechild"
        });
        var scrollbarHeight = (0, $748c2240e597a9b7$export$1df2a1438d36fb55)().toString();
        this.setScrollbarHeight(child, scrollbarHeight);
        this.setScrollbarHeight(parent, scrollbarHeight);
        parent.appendChild(child);
        element.appendChild(parent);
    };
    ContentRender.prototype.setScrollbarHeight = function(ele, height) {
        ele.style.minHeight = height + "px";
        ele.style.maxHeight = height + "px";
    };
    /**
     * The function is used to render grid content table
     *
     * @returns {void}
     */ ContentRender.prototype.renderTable = function() {
        var contentDiv = this.getPanel();
        var virtualTable = contentDiv.querySelector(".e-virtualtable");
        var virtualTrack = contentDiv.querySelector(".e-virtualtrack");
        if (this.parent.enableVirtualization && !(0, $3EnZW.isNullOrUndefined)(virtualTable) && !(0, $3EnZW.isNullOrUndefined)(virtualTrack)) {
            (0, $4ZDHT.remove)(virtualTable);
            (0, $4ZDHT.remove)(virtualTrack);
        }
        contentDiv.appendChild(this.createContentTable("_content_table"));
        this.setTable(contentDiv.querySelector("." + $1b5568e76cdae6d4$export$9852986a3ec5f6a0));
        if (this.parent.selectionSettings.type === "Multiple") this.ariaService.setOptions(this.parent.element, {
            multiselectable: true
        });
        this.initializeContentDrop();
        if (this.parent.frozenRows) this.parent.getHeaderContent().classList.add("e-frozenhdr");
    };
    /**
     * The function is used to create content table elements
     *
     * @param {string} id - specifies the id
     * @returns {Element} returns the element
     * @hidden
     */ ContentRender.prototype.createContentTable = function(id) {
        var innerDiv = this.getPanel().firstElementChild;
        if (this.getTable()) (0, $4ZDHT.remove)(this.getTable());
        var table = innerDiv.querySelector("." + $1b5568e76cdae6d4$export$9852986a3ec5f6a0) ? innerDiv.querySelector("." + $1b5568e76cdae6d4$export$9852986a3ec5f6a0) : this.parent.createElement("table", {
            className: $1b5568e76cdae6d4$export$9852986a3ec5f6a0,
            attrs: {
                cellspacing: "0.25px",
                role: "presentation",
                id: this.parent.element.id + id
            }
        });
        this.setColGroup(this.parent.getHeaderTable().querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).cloneNode(true));
        table.appendChild(this.getColGroup());
        table.appendChild(this.parent.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
            attrs: {
                role: "rowgroup"
            }
        }));
        innerDiv.appendChild(table);
        return innerDiv;
    };
    /**
     * Refresh the content of the Grid.
     *
     * @param {NotifyArgs} args - specifies the args
     * @returns {void}
     */ // tslint:disable-next-line:max-func-body-length
    ContentRender.prototype.refreshContentRows = function(args) {
        var _this = this;
        if (args === void 0) args = {};
        var gObj = this.parent;
        if (gObj.currentViewData.length === 0) return;
        if (gObj.editSettings && gObj.editModule && gObj.editSettings.mode === "Batch" && gObj.editModule.formObj && gObj.editSettings.showConfirmDialog === false) gObj.editModule.destroyForm();
        var dataSource = this.currentMovableRows || gObj.currentViewData;
        var isReact = gObj.isReact && !(0, $3EnZW.isNullOrUndefined)(gObj.rowTemplate);
        var frag = isReact ? gObj.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
            attrs: {
                role: "rowgroup"
            }
        }) : document.createDocumentFragment();
        if (!this.initialPageRecords) this.initialPageRecords = (0, $3EnZW.extend)([], dataSource);
        var hdrfrag = isReact ? gObj.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
            attrs: {
                role: "rowgroup"
            }
        }) : document.createDocumentFragment();
        var refFrag;
        var refHdrfrag;
        if (gObj.isReact && gObj.rowTemplate) {
            refFrag = frag;
            refHdrfrag = hdrfrag;
        }
        var columns = gObj.getColumns();
        var tr;
        var hdrTbody;
        var trElement;
        var row = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, this.parent);
        var isInfiniteScroll = this.parent.enableInfiniteScrolling && args.requestType === "infiniteScroll";
        var isColumnVirtualInfiniteProcess = this.isInfiniteColumnvirtualization() && args.requestType !== "virtualscroll";
        gObj.notify($17b89d3b1fc93cdb$export$c554910bef133b44, {});
        this.rowElements = [];
        this.rows = [];
        this.tempFreezeRows = [];
        var tbdy;
        var tableName;
        var isGroupFrozenHdr = this.parent.frozenRows && this.parent.groupSettings.columns.length ? true : false;
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) {
            if ([
                "sorting",
                "filtering",
                "searching",
                "grouping",
                "ungrouping",
                "reorder",
                "save",
                "delete"
            ].some(function(value) {
                return args.requestType === value;
            })) this.emptyVcRows();
        }
        var modelData;
        modelData = this.checkCache(modelData, args);
        if (!this.isAddRows && !this.useGroupCache) modelData = this.generator.generateRows(dataSource, args);
        this.setGroupCache(modelData, args);
        this.parent.notify($17b89d3b1fc93cdb$export$54948f7b626812fe, {
            isInfiniteScroll: isInfiniteScroll,
            modelData: modelData,
            args: args
        });
        var isFrozenLeft = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var registeredTemplates = this.parent.registeredTemplate;
        if (!(args.requestType === "infiniteScroll" && !this.parent.infiniteScrollSettings.enableCache) && registeredTemplates && registeredTemplates.template && !args.isFrozen && !isFrozenLeft) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var templatetoclear = [];
            for(var i = 0; i < registeredTemplates.template.length; i++){
                for(var j = 0; j < registeredTemplates.template[parseInt(i.toString(), 10)].rootNodes.length; j++)if ((0, $3EnZW.isNullOrUndefined)(registeredTemplates.template[parseInt(i.toString(), 10)].rootNodes[parseInt(j.toString(), 10)].parentNode)) templatetoclear.push(registeredTemplates.template[parseInt(i.toString(), 10)]);
            }
            this.parent.destroyTemplate([
                "template"
            ], templatetoclear);
        }
        if ((this.parent.isReact || this.parent.isVue) && !(args.requestType === "infiniteScroll" && !this.parent.infiniteScrollSettings.enableCache) && !args.isFrozen) {
            var templates = [
                this.parent.isVue ? "template" : "columnTemplate",
                "rowTemplate",
                "detailTemplate",
                "captionTemplate",
                "commandsTemplate",
                "groupFooterTemplate",
                "groupCaptionTemplate"
            ];
            if (args.requestType === "infiniteScroll" && this.parent.infiniteScrollSettings.enableCache) templates = [
                this.parent.isVue ? "template" : "columnTemplate",
                "commandsTemplate"
            ];
            (0, $748c2240e597a9b7$export$d9aeb73a9e271813)(this.parent, templates);
        }
        if (this.parent.enableColumnVirtualization) {
            var cellMerge = new (0, $8b8d76cc41e062b2$export$fd5814f904f8f3b4)(this.serviceLocator, this.parent);
            cellMerge.updateVirtualCells(modelData);
        }
        this.tbody = this.getTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        var startIndex = 0;
        var blockLoad = true;
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj) && gObj.vcRows.length) {
            var top_1 = "top";
            var scrollTop = !(0, $3EnZW.isNullOrUndefined)(args.virtualInfo.offsets) ? args.virtualInfo.offsets.top : !(0, $3EnZW.isNullOrUndefined)(args.scrollTop) ? args.scrollTop["" + top_1] : 0;
            if (scrollTop !== 0) {
                var offsets_1 = gObj.vGroupOffsets;
                var bSize = gObj.pageSettings.pageSize / 2;
                var values = Object.keys(offsets_1).map(function(key) {
                    return offsets_1["" + key];
                });
                for(var m = 0; m < values.length; m++)if (scrollTop < values[parseInt(m.toString(), 10)]) {
                    if (!(0, $3EnZW.isNullOrUndefined)(args.virtualInfo) && args.virtualInfo.direction === "up") {
                        startIndex = m > 0 ? (m - 1) * bSize : m * bSize;
                        break;
                    } else {
                        startIndex = m * bSize;
                        if (this.parent.contentModule.isEndBlock(m) || this.parent.contentModule.isEndBlock(m + 1)) args.virtualInfo.blockIndexes = [
                            m,
                            m + 1
                        ];
                        break;
                    }
                }
                if (Math.round(scrollTop + this.contentPanel.firstElementChild.offsetHeight) >= this.contentPanel.firstElementChild.scrollHeight && !args.rowObject) blockLoad = false;
            }
        }
        var isVFFrozenOnly = gObj.frozenRows && this.parent.enableVirtualization && args.requestType === "reorder";
        if (gObj.frozenRows && args.requestType === "virtualscroll" && args.virtualInfo.sentinelInfo.axis === "X" || isVFFrozenOnly) {
            var bIndex = args.virtualInfo.blockIndexes;
            var page = args.virtualInfo.page;
            args.virtualInfo.blockIndexes = [
                1,
                2
            ];
            if (isVFFrozenOnly) args.virtualInfo.page = 1;
            var data = isVFFrozenOnly ? this.initialPageRecords : dataSource;
            var mhdrData = this.vgenerator.generateRows(data, args);
            mhdrData.splice(this.parent.frozenRows);
            for(var i = 0; i < this.parent.frozenRows; i++){
                // mhdrData[parseInt(i.toString(), 10)].cells.splice(0, this.parent.getFrozenColumns());
                tr = row.render(mhdrData[parseInt(i.toString(), 10)], columns);
                (0, $748c2240e597a9b7$export$20c2eda854b6814a)(tr);
                hdrfrag.appendChild(tr);
            }
            args.virtualInfo.blockIndexes = bIndex;
            args.virtualInfo.page = page;
            if (isVFFrozenOnly && args.virtualInfo.page === 1) modelData.splice(0, this.parent.frozenRows);
        }
        this.virtualFrozenHdrRefresh(hdrfrag, modelData, row, args, dataSource, columns);
        if (this.parent.groupSettings.enableLazyLoading && !this.useGroupCache && this.parent.groupSettings.columns.length) (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).refRowsObj[this.parent.pageSettings.currentPage] = [];
        if (this.parent.enableInfiniteScrolling && this.parent.groupSettings.enableLazyLoading && args.requestType === "delete") this.visibleRows = [];
        var _loop_1 = function(i, len) {
            this_1.rows.push(modelData[parseInt(i.toString(), 10)]);
            if (this_1.parent.groupSettings.enableLazyLoading && !this_1.useGroupCache && this_1.parent.groupSettings.columns.length) {
                (this_1.parent.enableVirtualization ? this_1.parent.lazyLoadRender : this_1.parent.contentModule).refRowsObj[this_1.parent.pageSettings.currentPage].push(modelData[parseInt(i.toString(), 10)]);
                this_1.setRowsInLazyGroup(modelData[parseInt(i.toString(), 10)], i);
                if ((0, $3EnZW.isNullOrUndefined)(modelData[parseInt(i.toString(), 10)].indent)) return "continue";
            }
            this_1.setInfiniteVisibleRows(args, modelData[parseInt(i.toString(), 10)]);
            if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj) && args.virtualInfo && args.virtualInfo.blockIndexes && this_1.rowElements.length >= args.virtualInfo.blockIndexes.length * this_1.parent.contentModule.getBlockSize() && blockLoad) {
                this_1.parent.currentViewData["records"] = this_1.rows.map(function(m) {
                    return m.data;
                });
                return "break";
            }
            if (!gObj.rowTemplate) {
                tr = row.render(modelData[parseInt(i.toString(), 10)], columns);
                (0, $748c2240e597a9b7$export$20c2eda854b6814a)(tr);
                var isVFreorder = this_1.ensureFrozenHeaderRender(args);
                if (gObj.frozenRows && (i < gObj.frozenRows || isGroupFrozenHdr) && !isInfiniteScroll && args.requestType !== "virtualscroll" && isVFreorder && this_1.ensureVirtualFrozenHeaderRender(args)) hdrfrag.appendChild(tr);
                else frag.appendChild(tr);
                var rowIdx = parseInt(tr.getAttribute("data-rowindex"), 10);
                if (rowIdx + 1 === gObj.frozenRows) isGroupFrozenHdr = false;
                if (modelData[parseInt(i.toString(), 10)].isExpand) gObj.notify($17b89d3b1fc93cdb$export$e904de7866e7f466, tr.cells[gObj.groupSettings.columns.length]);
            } else {
                var rowTemplateID = gObj.element.id + "rowTemplate";
                var elements = void 0;
                if (gObj.isReact) {
                    var isHeader = gObj.frozenRows && i < gObj.frozenRows;
                    var copied = (0, $3EnZW.extend)({
                        index: i
                    }, dataSource[parseInt(i.toString(), 10)]);
                    gObj.getRowTemplate()(copied, gObj, "rowTemplate", rowTemplateID, null, null, isHeader ? hdrfrag : frag);
                    if (gObj.requireTemplateRef) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        var thisRef_2 = this_1;
                        thisRef_2.parent.renderTemplates(function() {
                            if (gObj.frozenRows && i < gObj.frozenRows) tr = refHdrfrag.childNodes[parseInt(i.toString(), 10)];
                            else trElement = refFrag.childNodes[parseInt(i.toString(), 10)];
                            var arg = {
                                data: modelData[parseInt(i.toString(), 10)].data,
                                row: trElement ? trElement : tr
                            };
                            thisRef_2.parent.trigger($17b89d3b1fc93cdb$export$7528dc9435097481, arg);
                            if (modelData[parseInt(i.toString(), 10)].isDataRow || thisRef_2.parent.enableVirtualization && thisRef_2.parent.groupSettings.enableLazyLoading) thisRef_2.rowElements.push(arg.row);
                            thisRef_2.ariaService.setOptions(thisRef_2.parent.element, {
                                colcount: gObj.getColumns().length.toString()
                            });
                            if (i === modelData.length - 1) {
                                refFrag = null;
                                refHdrfrag = null;
                            }
                        });
                        return "continue";
                    }
                } else elements = gObj.getRowTemplate()((0, $3EnZW.extend)({
                    index: i
                }, dataSource[parseInt(i.toString(), 10)]), gObj, "rowTemplate", rowTemplateID, undefined, undefined, undefined, this_1.parent["root"]);
                if (!gObj.isReact && elements[0].tagName === "TBODY") {
                    for(var j = 0; j < elements.length; j++){
                        var isTR = elements[parseInt(j.toString(), 10)].nodeName.toLowerCase() === "tr";
                        if (isTR || elements[parseInt(j.toString(), 10)].querySelectorAll && elements[parseInt(j.toString(), 10)].querySelectorAll("tr").length) tr = isTR ? elements[parseInt(j.toString(), 10)] : elements[parseInt(j.toString(), 10)].querySelector("tr");
                    }
                    if (gObj.frozenRows && i < gObj.frozenRows) hdrfrag.appendChild(tr);
                    else frag.appendChild(tr);
                } else if (gObj.frozenRows && i < gObj.frozenRows) tr = !gObj.isReact ? (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(hdrfrag, elements) : hdrfrag.lastElementChild;
                else {
                    // frag.appendChild(tr);
                    if (!gObj.isReact) tr = (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(frag, elements);
                    trElement = gObj.isReact ? frag.lastElementChild : tr.lastElementChild;
                }
                var arg = {
                    data: modelData[parseInt(i.toString(), 10)].data,
                    row: trElement ? trElement : tr
                };
                this_1.parent.trigger($17b89d3b1fc93cdb$export$7528dc9435097481, arg);
            }
            if (modelData[parseInt(i.toString(), 10)].isDataRow || this_1.parent.enableVirtualization && this_1.parent.groupSettings.enableLazyLoading) {
                if (!(0, $3EnZW.isNullOrUndefined)(gObj.rowTemplate) && (gObj.isAngular || gObj.isVue3 || gObj.isVue)) this_1.rowElements.push(trElement ? trElement : tr);
                else this_1.rowElements.push(tr);
            }
            this_1.ariaService.setOptions(this_1.parent.element, {
                colcount: gObj.getColumns().length.toString()
            });
        };
        var this_1 = this;
        for(var i = startIndex, len = modelData.length; i < len; i++){
            var state_1 = _loop_1(i, len);
            if (state_1 === "break") break;
        }
        var isReactChild = gObj.parentDetails && gObj.parentDetails.parentInstObj && gObj.parentDetails.parentInstObj.isReact;
        if ((gObj.isReact || isReactChild) && !gObj.requireTemplateRef) gObj.renderTemplates();
        if (this.parent.enableInfiniteScrolling && this.parent.groupSettings.enableLazyLoading) this.parent.contentModule.refRowsObj[this.parent.pageSettings.currentPage] = this.parent.contentModule["groupCache"][this.parent.pageSettings.currentPage];
        if (this.parent.groupSettings.enableLazyLoading && !this.useGroupCache && this.parent.groupSettings.columns.length) this.parent.notify($17b89d3b1fc93cdb$export$c70b4b413518c03b, {
            rows: (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).refRowsObj[this.parent.pageSettings.currentPage]
        });
        gObj.removeMaskRow();
        this.parent.notify("removeGanttShimmer", {
            requestType: "hideShimmer"
        });
        if (gObj.frozenRows && args.requestType !== "virtualscroll" && !isInfiniteScroll && this.ensureVirtualFrozenHeaderRender(args) || args.requestType === "virtualscroll" && args.virtualInfo.sentinelInfo && args.virtualInfo.sentinelInfo.axis === "X") {
            hdrTbody = gObj.getHeaderTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
            if (isReact) {
                var parentTable = hdrTbody.parentElement;
                (0, $4ZDHT.remove)(hdrTbody);
                parentTable.appendChild(hdrfrag);
            } else {
                hdrTbody.innerHTML = "";
                hdrTbody.appendChild(hdrfrag);
            }
            if (!gObj.isInitialLoad) gObj.scrollModule.setHeight();
        }
        // if (!gObj.enableVirtualization && hdrTbody && gObj.frozenRows && idx === 0 && cont.offsetHeight === Number(gObj.height)) {
        //     cont.style.height = (cont.offsetHeight - hdrTbody.offsetHeight) + 'px';
        // }
        args.rows = this.rows.slice(0);
        (0, $748c2240e597a9b7$export$1a5f3b7403a8bf39)(function() {
            _this.parent.notify($17b89d3b1fc93cdb$export$9bac90be894496e8, args);
            if (!_this.parent.enableVirtualization && (!_this.parent.enableColumnVirtualization || isColumnVirtualInfiniteProcess) && !isInfiniteScroll) {
                if (!gObj.isReact) _this.tbody.innerHTML = "";
                if (!(0, $3EnZW.isNullOrUndefined)(_this.tbody.parentElement)) (0, $4ZDHT.remove)(_this.tbody);
                else (0, $4ZDHT.remove)(gObj.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c));
                _this.tbody = _this.parent.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
                    attrs: {
                        role: "rowgroup"
                    }
                });
            }
            if (gObj.rowTemplate) (0, $c2qqN.updateBlazorTemplate)(gObj.element.id + "rowTemplate", "RowTemplate", gObj);
            if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.infiniteScrollModule) && (_this.parent.enableInfiniteScrolling && !_this.isInfiniteColumnvirtualization() || isColumnVirtualInfiniteProcess)) {
                _this.isAddRows = false;
                _this.parent.notify($17b89d3b1fc93cdb$export$d74111ea55be118d, {
                    args: args
                });
                _this.parent.notify($17b89d3b1fc93cdb$export$d1d974c345b7e95, {
                    tbody: tbdy ? tbdy : _this.tbody,
                    frag: frag,
                    args: args,
                    rows: _this.rows,
                    rowElements: _this.rowElements,
                    visibleRows: _this.visibleRows,
                    tableName: tableName
                });
                if (_this.isInfiniteColumnvirtualization() && _this.parent.isFrozenGrid()) {
                    var virtualTable = _this.parent.getContent().querySelector(".e-virtualtable");
                    var transform = (0, $748c2240e597a9b7$export$3046fdef117e6822)(virtualTable);
                    _this.parent.contentModule.resetStickyLeftPos(transform.width);
                    _this.widthService.refreshFrozenScrollbar();
                }
            } else {
                _this.useGroupCache = false;
                _this.appendContent(_this.tbody, frag, args);
            }
            if (_this.parent.editSettings.showAddNewRow && (_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling)) {
                var newRow = _this.parent.element.querySelector(".e-addrow-removed");
                if (newRow) (0, $4ZDHT.remove)(newRow);
            }
            var startAdd = !_this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2);
            if (_this.parent.editSettings.showAddNewRow && _this.parent.editSettings.mode === "Normal") {
                if (startAdd) {
                    if (_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling) _this.parent.isAddNewRow = true;
                    _this.parent.isEdit = false;
                    _this.parent.addRecord();
                }
                if (startAdd || (_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling) && [
                    "sorting",
                    "filtering",
                    "searching",
                    "grouping",
                    "ungrouping",
                    "reorder"
                ].some(function(value) {
                    return args.requestType === value;
                })) _this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
            }
            if (_this.parent.getVisibleFrozenRightCount() && _this.parent.getContent() && (0, $748c2240e597a9b7$export$cf8661d2a8ee09cc)(_this.parent) > 0) _this.parent.element.classList.add("e-right-shadow");
            frag = null;
        }, this.rafCallback((0, $3EnZW.extend)({}, args)));
    };
    ContentRender.prototype.isInfiniteColumnvirtualization = function() {
        return this.parent.enableColumnVirtualization && this.parent.enableInfiniteScrolling;
    };
    ContentRender.prototype.enableCacheOnInfiniteColumnVirtual = function() {
        return this.isInfiniteColumnvirtualization() && this.parent.infiniteScrollSettings.enableCache;
    };
    ContentRender.prototype.emptyVcRows = function() {
        this.parent.vcRows = [];
        this.parent.vRows = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ContentRender.prototype.appendContent = function(tbody, frag, args, tableName) {
        var isReact = this.parent.isReact && !(0, $3EnZW.isNullOrUndefined)(this.parent.rowTemplate);
        if (isReact) this.getTable().appendChild(frag);
        else {
            tbody.appendChild(frag);
            this.getTable().appendChild(tbody);
        }
        if (this.parent.rowRenderingMode === "Vertical" && this.parent.allowTextWrap && (this.parent.textWrapSettings.wrapMode === "Header" || this.parent.textWrapSettings.wrapMode === "Both")) {
            var cells = tbody.querySelectorAll("td");
            for(var i = 0; i < cells.length; i++){
                var headerCellHeight = parseFloat(document.defaultView.getComputedStyle(cells[parseInt(i.toString(), 10)], "::before").getPropertyValue("height"));
                var cellHeight = cells[parseInt(i.toString(), 10)].offsetHeight;
                if (headerCellHeight > cellHeight) {
                    cells[parseInt(i.toString(), 10)].style.height = headerCellHeight + "px";
                    cells[parseInt(i.toString(), 10)].style.boxSizing = "content-box";
                }
            }
        }
        if (this.parent.getVisibleFrozenLeftCount() && this.parent.enableColumnVirtualization) this.widthService.refreshFrozenScrollbar();
    };
    ContentRender.prototype.setRowsInLazyGroup = function(row, index) {
        if (this.parent.groupSettings.enableLazyLoading && !this.useGroupCache && this.parent.groupSettings.columns.length) (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).maintainRows(row, index);
    };
    ContentRender.prototype.setGroupCache = function(data, args) {
        if (!this.useGroupCache && this.parent.groupSettings.enableLazyLoading) this.parent.notify($17b89d3b1fc93cdb$export$608ee9cfb623fa81, {
            args: args,
            data: data
        });
    };
    ContentRender.prototype.ensureFrozenHeaderRender = function(args) {
        return !(this.parent.enableVirtualization && (args.requestType === "reorder" || args.requestType === "refresh") || this.parent.infiniteScrollSettings.enableCache && this.parent.frozenRows && this.parent.infiniteScrollModule.requestType === "delete" && this.parent.pageSettings.currentPage !== 1);
    };
    ContentRender.prototype.ensureVirtualFrozenHeaderRender = function(args) {
        return !(this.parent.enableVirtualization && args.requestType === "delete");
    };
    ContentRender.prototype.checkCache = function(modelData, args) {
        if (this.parent.infiniteScrollSettings.enableCache && args.requestType === "infiniteScroll") {
            this.isAddRows = !(0, $3EnZW.isNullOrUndefined)(this.infiniteCache[this.parent.pageSettings.currentPage]);
            if (this.isAddRows) {
                var data = this.infiniteCache[this.parent.pageSettings.currentPage];
                modelData = this.parent.pageSettings.currentPage === 1 ? data.slice(this.parent.frozenRows) : data;
            }
            return modelData;
        }
        if (this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && (args.requestType === "paging" || args.requestType === "columnstate" || args.requestType === "reorder" || args.requestType === "virtualscroll") && (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).getGroupCache()[this.parent.pageSettings.currentPage]) {
            if (!this.parent.enableVirtualization) this.useGroupCache = true;
            return this.parent.enableVirtualization ? this.parent.getRowsObject() : this.parent.contentModule.initialGroupRows(args.requestType === "reorder");
        }
        return null;
    };
    ContentRender.prototype.setInfiniteVisibleRows = function(args, data) {
        if (this.parent.enableInfiniteScrolling && !this.parent.infiniteScrollSettings.enableCache && !(this.isInfiniteColumnvirtualization() && args.requestType === "virtualscroll")) this.visibleRows.push(data);
    };
    ContentRender.prototype.getCurrentBlockInfiniteRecords = function() {
        var data = [];
        if (this.parent.infiniteScrollSettings.enableCache) {
            if (!Object.keys(this.infiniteCache).length) return [];
            var rows = this.parent.getRows();
            var index = parseInt(rows[this.parent.frozenRows].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            var first = Math.ceil((index + 1) / this.parent.pageSettings.pageSize);
            index = parseInt(rows[rows.length - 1].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            var last = Math.ceil((index + (rows.length ? 1 : 0)) / this.parent.pageSettings.pageSize);
            for(var i = first; i <= last; i++)data = !data.length ? this.infiniteCache[parseInt(i.toString(), 10)] : data.concat(this.infiniteCache[parseInt(i.toString(), 10)]);
            if (this.parent.frozenRows && this.parent.pageSettings.currentPage > 1) data = this.infiniteCache[1].slice(0, this.parent.frozenRows).concat(data);
        }
        return data;
    };
    ContentRender.prototype.getReorderedRows = function(args) {
        return this.parent.contentModule.getReorderedFrozenRows(args);
    };
    ContentRender.prototype.virtualFrozenHdrRefresh = function(hdrfrag, modelData, row, args, dataSource, columns) {
        if (this.parent.frozenRows && this.parent.enableVirtualization && (args.requestType === "reorder" || args.requestType === "refresh")) {
            var tr = void 0;
            var fhdrData = this.getReorderedRows(args);
            for(var i = 0; i < fhdrData.length; i++){
                tr = row.render(fhdrData[parseInt(i.toString(), 10)], columns);
                hdrfrag.appendChild(tr);
            }
            if (args.virtualInfo.page === 1) modelData.splice(0, this.parent.frozenRows);
        }
    };
    ContentRender.prototype.getInfiniteRows = function() {
        var rows = [];
        if (this.parent.enableInfiniteScrolling) {
            if (this.parent.infiniteScrollSettings.enableCache) {
                var keys = Object.keys(this.infiniteCache);
                for(var i = 0; i < keys.length; i++)rows = rows.concat(this.infiniteCache[keys[parseInt(i.toString(), 10)]]);
            } else rows = this.visibleRows;
        }
        return rows;
    };
    ContentRender.prototype.getInfiniteMovableRows = function() {
        var infiniteCacheRows = this.getCurrentBlockInfiniteRecords();
        var infiniteRows = this.parent.enableInfiniteScrolling ? infiniteCacheRows.length ? infiniteCacheRows : this.visibleRows : [];
        return infiniteRows;
    };
    /**
     * Get the content div element of grid
     *
     * @returns {Element} returns the element
     */ ContentRender.prototype.getPanel = function() {
        return this.contentPanel;
    };
    /**
     * Set the content div element of grid
     *
     * @param  {Element} panel - specifies the panel
     * @returns {void}
     */ ContentRender.prototype.setPanel = function(panel) {
        this.contentPanel = panel;
    };
    /**
     * Get the content table element of grid
     *
     * @returns {Element} returns the element
     */ ContentRender.prototype.getTable = function() {
        return this.contentTable;
    };
    /**
     * Set the content table element of grid
     *
     * @param  {Element} table - specifies the table
     * @returns {void}
     */ ContentRender.prototype.setTable = function(table) {
        this.contentTable = table;
    };
    /**
     * Get the Movable Row collection in the Freeze pane Grid.
     *
     * @returns {Row[] | HTMLCollectionOf<HTMLTableRowElement>} returns the row
     */ ContentRender.prototype.getRows = function() {
        var infiniteRows = this.getInfiniteRows();
        return infiniteRows.length ? infiniteRows : this.rows;
    };
    /**
     * Get the content table data row elements
     *
     * @returns {Element} returns the element
     */ ContentRender.prototype.getRowElements = function() {
        return this.rowElements;
    };
    /**
     * Get the content table data row elements
     *
     * @param {Element[]} elements - specifies the elements
     * @returns {void}
     */ ContentRender.prototype.setRowElements = function(elements) {
        this.rowElements = elements;
    };
    /**
     * Get the header colgroup element
     *
     * @returns {Element} returns the element
     */ ContentRender.prototype.getColGroup = function() {
        return this.colgroup;
    };
    /**
     * Set the header colgroup element
     *
     * @param {Element} colGroup - specifies the colgroup
     * @returns {Element} returns the element
     */ ContentRender.prototype.setColGroup = function(colGroup) {
        if (!(0, $3EnZW.isNullOrUndefined)(colGroup)) colGroup.id = "content-" + colGroup.id;
        return this.colgroup = colGroup;
    };
    /**
     * Function to hide content table column based on visible property
     *
     * @param {Column[]} columns - specifies the column
     * @returns {void}
     */ ContentRender.prototype.setVisible = function(columns) {
        var gObj = this.parent;
        var rows = this.getRows();
        var testRow;
        rows.some(function(r) {
            if (r.isDataRow) testRow = r;
            return r.isDataRow;
        });
        var needFullRefresh = true;
        if (!gObj.groupSettings.columns.length && testRow) needFullRefresh = false;
        var tr = gObj.getDataRows();
        var args = {};
        var infiniteData = this.infiniteRowVisibility();
        var contentrows = infiniteData ? infiniteData : this.rows.filter(function(row) {
            return !row.isDetailRow;
        });
        for(var c = 0, clen = columns.length; c < clen; c++){
            var column = columns[parseInt(c.toString(), 10)];
            var idx = this.parent.getNormalizedColumnIndex(column.uid);
            var colIdx = this.parent.getColumnIndexByUid(column.uid);
            var displayVal = column.visible === true ? "" : "none";
            if (idx !== -1 && testRow && idx < testRow.cells.length) (0, $4ZDHT.setStyleAttribute)(this.getColGroup().childNodes[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
            if (!needFullRefresh) this.setDisplayNone(tr, colIdx, displayVal, contentrows);
            if (!this.parent.invokedFromMedia && column.hideAtMedia) this.parent.updateMediaColumns(column);
            this.parent.invokedFromMedia = false;
        }
        if (needFullRefresh) this.refreshContentRows({
            requestType: "refresh"
        });
        else {
            this.parent.notify($17b89d3b1fc93cdb$export$868d7674f5a0caf5, {
                rows: contentrows,
                args: args
            });
            if (this.parent.editSettings.showAddNewRow && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
        }
    };
    /**
     * @param {Object} tr - specifies the trr
     * @param {number} idx - specifies the idx
     * @param {string} displayVal - specifies the displayval
     * @param {Row<Column>} rows - specifies the rows
     * @returns {void}
     * @hidden
     */ ContentRender.prototype.setDisplayNone = function(tr, idx, displayVal, rows) {
        (0, $748c2240e597a9b7$export$55afbdac1540a938)(tr, idx, displayVal, rows, this.parent, this.parent.isRowDragable());
        this.parent.notify($17b89d3b1fc93cdb$export$acf275d6bf7c2a3, {
            visible: displayVal,
            index: idx,
            isFreeze: this.isInfiniteFreeze
        });
    };
    ContentRender.prototype.infiniteRowVisibility = function(isFreeze) {
        var infiniteData;
        if (this.parent.enableInfiniteScrolling) {
            this.isInfiniteFreeze = isFreeze;
            if (this.parent.infiniteScrollSettings.enableCache) infiniteData = this.getCurrentBlockInfiniteRecords();
            else infiniteData = isFreeze ? this.visibleFrozenRows : this.visibleRows;
        }
        return infiniteData;
    };
    ContentRender.prototype.colGroupRefresh = function() {
        if (this.getColGroup()) {
            var colGroup = this.getHeaderColGroup();
            this.getTable().replaceChild(colGroup, this.getColGroup());
            this.setColGroup(colGroup);
        }
    };
    ContentRender.prototype.getHeaderColGroup = function() {
        return this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0).querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9 + ":not(.e-masked-colgroup)").cloneNode(true);
    };
    ContentRender.prototype.initializeContentDrop = function() {
        var gObj = this.parent;
        this.droppable = new (0, $g9Ic7.Droppable)(gObj.element, {
            accept: ".e-dragclone",
            drop: this.drop
        });
    };
    ContentRender.prototype.droppableDestroy = function() {
        if (this.droppable && !this.droppable.isDestroyed) this.droppable.destroy();
    };
    ContentRender.prototype.canSkip = function(column, row, index) {
        /**
         * Skip the toggle visiblity operation when one of the following success
         * 1. Grid has empty records
         * 2. column visible property is unchanged
         * 3. cell`s isVisible property is same as column`s visible property.
         */ return (0, $3EnZW.isNullOrUndefined)(row) || //(1)
        (0, $3EnZW.isNullOrUndefined)(column.visible) || //(2)
        row.cells[parseInt(index.toString(), 10)].visible === column.visible; //(3)
    };
    ContentRender.prototype.getModelGenerator = function() {
        return this.generator = this.parent.allowGrouping ? new (0, $00f5ac64cc4c9276$export$e121011a4bc11d9e)(this.parent) : new (0, $7ddfd3da489c240b$export$2cf41885b7ecbd06)(this.parent);
    };
    ContentRender.prototype.renderEmpty = function(tbody) {
        this.getTable().appendChild(tbody);
        if (this.parent.frozenRows) this.parent.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).innerHTML = "";
    };
    ContentRender.prototype.setSelection = function(uid, set, clearAll) {
        this.parent.notify($17b89d3b1fc93cdb$export$7cf2fb2539b85de4, {
            uid: uid,
            set: set,
            clearAll: clearAll
        });
        var row = this.getRows().filter(function(row) {
            return clearAll || uid === row.uid;
        });
        for(var j = 0; j < row.length; j++){
            row[parseInt(j.toString(), 10)].isSelected = set;
            var cells = row[parseInt(j.toString(), 10)].cells;
            for(var k = 0; k < cells.length; k++)cells[parseInt(k.toString(), 10)].isSelected = set;
        }
    };
    ContentRender.prototype.getRowByIndex = function(index) {
        index = this.getInfiniteRowIndex(index);
        return !(0, $3EnZW.isNullOrUndefined)(index) ? this.parent.getDataRows()[parseInt(index.toString(), 10)] : undefined;
    };
    ContentRender.prototype.getInfiniteRowIndex = function(index) {
        if (this.parent.infiniteScrollSettings.enableCache && !(0, $3EnZW.isNullOrUndefined)(index)) {
            var fRows = this.parent.frozenRows;
            var idx = fRows > index ? 0 : fRows;
            var firstRowIndex = parseInt(this.parent.getRows()[parseInt(idx.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            index = fRows > index ? index : index - firstRowIndex + fRows;
        }
        return index;
    };
    ContentRender.prototype.getVirtualRowIndex = function(index) {
        return index;
    };
    ContentRender.prototype.enableAfterRender = function(e) {
        if (e.module === "group" && e.enable) this.generator = this.getModelGenerator();
    };
    ContentRender.prototype.setRowObjects = function(rows) {
        this.rows = rows;
    };
    /**
     * @param {NotifyArgs} args - specifies the args
     * @returns {void}
     * @hidden
     */ ContentRender.prototype.immutableModeRendering = function(args) {
        var _this = this;
        if (args === void 0) args = {};
        var gObj = this.parent;
        gObj.hideSpinner();
        var key = gObj.getPrimaryKeyFieldNames()[0];
        var oldKeys = {};
        var newKeys = {};
        var newRowObjs = [];
        var oldIndexes = {};
        var oldRowObjs = gObj.getRowsObject().slice();
        var batchChangeKeys = this.getBatchEditedRecords(key, oldRowObjs);
        var newIndexes = {};
        var hasBatch = Object.keys(batchChangeKeys).length !== 0;
        if (gObj.getContent().querySelector(".e-emptyrow") || args.requestType === "reorder" || this.parent.groupSettings.columns.length) this.refreshContentRows(args);
        else {
            if (gObj.currentViewData.length === 0) return;
            var oldRowElements = {};
            var tbody = gObj.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
                attrs: {
                    role: "rowgroup"
                }
            });
            var dataSource = gObj.currentViewData;
            var trs = [].slice.call(this.getTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children);
            if (this.prevCurrentView.length) {
                var prevLen = this.prevCurrentView.length;
                var currentLen = dataSource.length;
                if (prevLen === currentLen) for(var i = 0; i < currentLen; i++){
                    if (this.parent.editSettings.mode === "Batch" && trs[parseInt(i.toString(), 10)].classList.contains("e-insertedrow")) {
                        trs.splice(i, 1);
                        --i;
                        continue;
                    }
                    newKeys[dataSource[parseInt(i.toString(), 10)]["" + key]] = oldKeys[this.prevCurrentView[parseInt(i.toString(), 10)]["" + key]] = i;
                    newIndexes[parseInt(i.toString(), 10)] = dataSource[parseInt(i.toString(), 10)]["" + key];
                    oldRowElements[oldRowObjs[parseInt(i.toString(), 10)].uid] = trs[parseInt(i.toString(), 10)];
                    oldIndexes[parseInt(i.toString(), 10)] = this.prevCurrentView[parseInt(i.toString(), 10)]["" + key];
                }
                else {
                    for(var i = 0; i < currentLen; i++){
                        newKeys[dataSource[parseInt(i.toString(), 10)]["" + key]] = i;
                        newIndexes[parseInt(i.toString(), 10)] = dataSource[parseInt(i.toString(), 10)]["" + key];
                    }
                    for(var i = 0; i < prevLen; i++){
                        if (this.parent.editSettings.mode === "Batch" && trs[parseInt(i.toString(), 10)].classList.contains("e-insertedrow")) {
                            trs.splice(i, 1);
                            --i;
                            continue;
                        }
                        oldRowElements[oldRowObjs[parseInt(i.toString(), 10)].uid] = trs[parseInt(i.toString(), 10)];
                        oldKeys[this.prevCurrentView[parseInt(i.toString(), 10)]["" + key]] = i;
                        oldIndexes[parseInt(i.toString(), 10)] = this.prevCurrentView[parseInt(i.toString(), 10)]["" + key];
                    }
                }
            }
            for(var i = 0; i < dataSource.length; i++){
                var oldIndex = oldKeys[dataSource[parseInt(i.toString(), 10)]["" + key]];
                if (!(0, $3EnZW.isNullOrUndefined)(oldIndex)) {
                    var isEqual = false;
                    if (this.parent.enableDeepCompare) isEqual = this.objectEqualityChecker(this.prevCurrentView[parseInt(oldIndex.toString(), 10)], dataSource[parseInt(i.toString(), 10)]);
                    var tr = oldRowElements[oldRowObjs[parseInt(oldIndex.toString(), 10)].uid];
                    newRowObjs.push(oldRowObjs[parseInt(oldIndex.toString(), 10)]);
                    if (this.rowElements[parseInt(oldIndex.toString(), 10)] && this.rowElements[parseInt(oldIndex.toString(), 10)].getAttribute("data-uid") === newRowObjs[parseInt(i.toString(), 10)].uid && (hasBatch && (0, $3EnZW.isNullOrUndefined)(batchChangeKeys[newIndexes[parseInt(i.toString(), 10)]]) || !hasBatch && (isEqual || this.prevCurrentView[parseInt(oldIndex.toString(), 10)] === dataSource[parseInt(i.toString(), 10)]))) {
                        if (oldIndex !== i) this.refreshImmutableContent(i, tr, newRowObjs[parseInt(i.toString(), 10)]);
                        tbody.appendChild(tr);
                        continue;
                    }
                    if (hasBatch && !(0, $3EnZW.isNullOrUndefined)(batchChangeKeys[newIndexes[parseInt(i.toString(), 10)]]) || !this.parent.enableDeepCompare && dataSource[parseInt(i.toString(), 10)] !== this.prevCurrentView[parseInt(oldIndex.toString(), 10)] || this.parent.enableDeepCompare && !isEqual) oldRowObjs[parseInt(oldIndex.toString(), 10)].setRowValue(dataSource[parseInt(i.toString(), 10)]);
                    tbody.appendChild(tr);
                    this.refreshImmutableContent(i, tr, newRowObjs[parseInt(i.toString(), 10)]);
                } else {
                    var row = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, gObj);
                    var args_1 = {
                        startIndex: i
                    };
                    var modelData = this.generator.generateRows([
                        dataSource[parseInt(i.toString(), 10)]
                    ], args_1);
                    newRowObjs.push(modelData[0]);
                    var tr = row.render(modelData[0], gObj.getColumns());
                    tbody.appendChild(tr);
                    this.refreshImmutableContent(i, tr, newRowObjs[parseInt(i.toString(), 10)]);
                }
            }
            this.rows = newRowObjs;
            this.rowElements = [].slice.call(tbody.children);
            (0, $4ZDHT.remove)(this.getTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c));
            this.getTable().appendChild(tbody);
            this.parent.trigger($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, {}, function() {
                if (_this.parent.allowTextWrap) _this.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
                    case: "textwrap"
                });
            });
            if (args) {
                var action = (args.requestType || "").toLowerCase() + "-complete";
                this.parent.notify(action, args);
            }
        }
    };
    ContentRender.prototype.objectEqualityChecker = function(old, next) {
        var keys = Object.keys(old);
        var isEqual = true;
        for(var i = 0; i < keys.length; i++)if (old[keys[parseInt(i.toString(), 10)]] !== next[keys[parseInt(i.toString(), 10)]]) {
            var isDate = old[keys[parseInt(i.toString(), 10)]] instanceof Date && next[keys[parseInt(i.toString(), 10)]] instanceof Date;
            if (!isDate || old[keys[parseInt(i.toString(), 10)]].getTime() !== next[keys[parseInt(i.toString(), 10)]].getTime()) {
                isEqual = false;
                break;
            }
        }
        return isEqual;
    };
    ContentRender.prototype.getBatchEditedRecords = function(primaryKey, rows) {
        var keys = {};
        var changes = this.parent.getBatchChanges();
        var changedRecords = [];
        var addedRecords = [];
        if (Object.keys(changes).length) {
            changedRecords = changes.changedRecords;
            addedRecords = changes.addedRecords;
        }
        var args = {
            cancel: false
        };
        this.parent.notify($17b89d3b1fc93cdb$export$e595ce879f0d4e35, {
            rows: rows,
            args: args
        });
        if (addedRecords.length) {
            if (this.parent.editSettings.newRowPosition === "Bottom") rows.splice(rows.length - 1, addedRecords.length);
            else if (!args.cancel) rows.splice(0, addedRecords.length);
        }
        for(var i = 0; i < changedRecords.length; i++)keys[changedRecords[parseInt(i.toString(), 10)]["" + primaryKey]] = i;
        return keys;
    };
    ContentRender.prototype.refreshImmutableContent = function(index, tr, row) {
        row.isAltRow = this.parent.enableAltRow ? index % 2 !== 0 : false;
        if (row.isAltRow) tr.classList.add("e-altrow");
        else tr.classList.remove("e-altrow");
        row.index = index;
        row.edit = undefined;
        row.isDirty = false;
        tr.setAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82, index.toString());
        tr.setAttribute($1b5568e76cdae6d4$export$be459c01dd76713e, (index + 1).toString());
        this.updateCellIndex(tr, index);
    };
    ContentRender.prototype.updateCellIndex = function(rowEle, index) {
        for(var i = 0; i < rowEle.cells.length; i++)rowEle.cells[parseInt(i.toString(), 10)].setAttribute("index", index.toString());
    };
    return ContentRender;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $eAUyT = parcelRequire("eAUyT");
var $g9Ic7 = parcelRequire("g9Ic7");
var $3EnZW = parcelRequire("3EnZW");








// eslint-disable-next-line valid-jsdoc, jsdoc/require-param
/**
 * Content module is used to render grid content
 *
 * @hidden
 */ var $837013bb596bf019$export$83fd0f90b83678b1 = /** @class */ function() {
    /**
     * Constructor for header renderer module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     */ function HeaderRender(parent, serviceLocator) {
        var _this = this;
        this.frzIdx = 0;
        this.notfrzIdx = 0;
        this.isFirstCol = false;
        this.isReplaceDragEle = true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.helper = function(e) {
            var gObj = _this.parent;
            var target = _this.draggable.currentStateTarget;
            var parentEle = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headercell");
            if (!(gObj.allowReordering || gObj.allowGrouping) || !(0, $3EnZW.isNullOrUndefined)(parentEle) && parentEle.getElementsByClassName("e-checkselectall").length > 0) return false;
            var visualElement = _this.parent.createElement("div", {
                className: "e-cloneproperties e-dragclone e-headerclone"
            });
            var element = target.classList.contains("e-headercell") ? target : parentEle;
            if (!element || !gObj.allowReordering && element.classList.contains("e-stackedheadercell")) return false;
            var height = element.offsetHeight;
            var headercelldiv = element.querySelector(".e-headercelldiv") || element.querySelector(".e-stackedheadercelldiv");
            var col;
            if (headercelldiv) {
                if (element.querySelector(".e-stackedheadercelldiv")) col = gObj.getStackedHeaderColumnByHeaderText(headercelldiv.innerText.trim(), gObj.columns);
                else col = gObj.getColumnByUid(headercelldiv.getAttribute("e-mappinguid"));
                _this.column = col;
                if (_this.column.lockColumn) return false;
                visualElement.setAttribute("e-mappinguid", _this.column.uid);
            }
            if (col && !(0, $3EnZW.isNullOrUndefined)(col.headerTemplate)) {
                if (!(0, $3EnZW.isNullOrUndefined)(col.headerTemplate)) {
                    var colIndex = gObj.getColumnIndexByField(col.field);
                    var result = col.getHeaderTemplate()((0, $3EnZW.extend)({
                        "index": colIndex
                    }, col), gObj, "headerTemplate", null, null, null, null, gObj.root);
                    var isReactCompiler = gObj.isReact && typeof col.headerTemplate !== "string";
                    var isReactChild = gObj.parentDetails && gObj.parentDetails.parentInstObj && gObj.parentDetails.parentInstObj.isReact;
                    if (isReactCompiler || isReactChild) gObj.renderTemplates();
                    (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(visualElement, result);
                } else visualElement.innerHTML = col.headerTemplate;
                if (!(0, $3EnZW.isNullOrUndefined)(visualElement.firstChild) && visualElement.firstChild.nodeType === 1) visualElement.firstChild.style.pointerEvents = "none";
            } else visualElement.innerHTML = headercelldiv ? col.headerText : element.firstElementChild.innerHTML;
            visualElement.style.width = element.offsetWidth + "px";
            visualElement.style.height = element.offsetHeight + "px";
            visualElement.style.lineHeight = (height - 6).toString() + "px";
            gObj.element.appendChild(visualElement);
            return visualElement;
        };
        this.dragStart = function(e) {
            var gObj = _this.parent;
            gObj.element.querySelector(".e-gridpopup").style.display = "none";
            gObj.notify($17b89d3b1fc93cdb$export$e7b0ce279c912385, {
                target: _this.draggable.currentStateTarget,
                column: _this.column,
                event: e.event
            });
        };
        this.drag = function(e) {
            var gObj = _this.parent;
            var target = e.target;
            if (target) {
                var closest = (0, $4ZDHT.closest)(target, ".e-grid");
                var cloneElement = _this.parent.element.querySelector(".e-cloneproperties");
                if (!closest || closest.getAttribute("id") !== gObj.element.getAttribute("id")) {
                    (0, $4ZDHT.classList)(cloneElement, [
                        "e-notallowedcur"
                    ], [
                        "e-defaultcur"
                    ]);
                    if (gObj.allowReordering) {
                        gObj.element.querySelector(".e-reorderuparrow").style.display = "none";
                        gObj.element.querySelector(".e-reorderdownarrow").style.display = "none";
                    }
                    if (!gObj.groupSettings.allowReordering) return;
                }
                gObj.notify($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, {
                    target: e.target,
                    column: _this.column,
                    event: e.event
                });
            }
        };
        this.dragStop = function(e) {
            var gObj = _this.parent;
            var cancel;
            gObj.element.querySelector(".e-gridpopup").style.display = "none";
            if (!(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea") || !gObj.allowReordering && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell") || !e.helper.getAttribute("e-mappinguid") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea")) {
                (0, $4ZDHT.remove)(e.helper);
                cancel = true;
            }
            gObj.notify($17b89d3b1fc93cdb$export$d8cb7828e3a46f05, {
                target: e.target,
                event: e.event,
                column: _this.column,
                cancel: cancel
            });
        };
        this.drop = function(e) {
            var gObj = _this.parent;
            var uid = e.droppedElement.getAttribute("e-mappinguid");
            var closest = (0, $4ZDHT.closest)(e.target, ".e-grid");
            (0, $4ZDHT.remove)(e.droppedElement);
            if (closest && closest.getAttribute("id") !== gObj.element.getAttribute("id") || !(gObj.allowReordering || gObj.allowGrouping)) return;
            gObj.notify($17b89d3b1fc93cdb$export$b0a9271d3fcee092, {
                target: e.target,
                uid: uid,
                droppedElement: e.droppedElement
            });
        };
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.ariaService = this.serviceLocator.getService("ariaService");
        this.widthService = this.serviceLocator.getService("widthService");
        if (this.parent.isDestroyed) return;
        if (!this.parent.enableColumnVirtualization) this.parent.on($17b89d3b1fc93cdb$export$c480fa254fb70e72, this.setVisible, this);
        this.parent.on($17b89d3b1fc93cdb$export$cd2e9ca316e8efca, this.colPosRefresh, this);
        this.parent.on($17b89d3b1fc93cdb$export$5d4840440f592fca, this.renderCustomToolbar, this);
        if (this.parent.rowRenderingMode === "Vertical") this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.updateCustomResponsiveToolbar, this);
    }
    /**
     * The function is used to render grid header div
     *
     * @returns {void}
     */ HeaderRender.prototype.renderPanel = function() {
        var div = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0);
        var isRendered = div != null;
        div = isRendered ? div : this.parent.createElement("div", {
            className: "e-gridheader"
        });
        var innerDiv = isRendered ? div.querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3) : this.parent.createElement("div", {
            className: $1b5568e76cdae6d4$export$838c0e7679321ff3
        });
        this.toggleStackClass(div);
        div.appendChild(innerDiv);
        this.setPanel(div);
        if (!isRendered) this.parent.element.appendChild(div);
    };
    /**
     * The function is used to render grid header div
     *
     * @returns {void}
     */ HeaderRender.prototype.renderTable = function() {
        var headerDiv = this.getPanel();
        headerDiv.appendChild(this.createHeaderTable());
        this.setTable(headerDiv.querySelector("." + $1b5568e76cdae6d4$export$9852986a3ec5f6a0));
        this.initializeHeaderDrag();
        this.initializeHeaderDrop();
        this.parent.notify($17b89d3b1fc93cdb$export$265a66bcae9d11dd, {
            rows: this.rows
        });
    };
    /**
     * Get the header content div element of grid
     *
     * @returns {Element} returns the element
     */ HeaderRender.prototype.getPanel = function() {
        return this.headerPanel;
    };
    /**
     * Set the header content div element of grid
     *
     * @param  {Element} panel - specifies the panel element
     * @returns {void}
     */ HeaderRender.prototype.setPanel = function(panel) {
        this.headerPanel = panel;
    };
    /**
     * Get the header table element of grid
     *
     * @returns {Element} returns the element
     */ HeaderRender.prototype.getTable = function() {
        return this.headerTable;
    };
    /**
     * Set the header table element of grid
     *
     * @param  {Element} table - specifies the table element
     * @returns {void}
     */ HeaderRender.prototype.setTable = function(table) {
        this.headerTable = table;
    };
    /**
     * Get the header colgroup element
     *
     * @returns {Element} returns the element
     */ HeaderRender.prototype.getColGroup = function() {
        return this.colgroup;
    };
    /**
     * Set the header colgroup element
     *
     * @param {Element} colGroup - specifies the colgroup
     * @returns {Element} returns the element
     */ HeaderRender.prototype.setColGroup = function(colGroup) {
        return this.colgroup = colGroup;
    };
    /**
     * Get the header row element collection.
     *
     * @returns {Element[]} returns the element
     */ HeaderRender.prototype.getRows = function() {
        var table = this.getTable();
        return table.tHead.rows;
    };
    /**
     * The function is used to create header table elements
     *
     * @returns {Element} returns the element
     * @hidden
     */ HeaderRender.prototype.createHeaderTable = function() {
        var table = this.createTable();
        var innerDiv = this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
        innerDiv.appendChild(table);
        return innerDiv;
    };
    /**
     * The function is used to create header table elements
     *
     * @param {Element} tableEle - specifies the table Element
     * @param {freezeTable} tableName - specifies the table name
     * @returns {Element} returns the element
     * @hidden
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HeaderRender.prototype.createHeader = function(tableEle, tableName) {
        if (tableEle === void 0) tableEle = null;
        var gObj = this.parent;
        if (this.getTable()) (0, $4ZDHT.remove)(this.getTable());
        var table = this.parent.createElement("table", {
            className: $1b5568e76cdae6d4$export$9852986a3ec5f6a0,
            attrs: {
                cellspacing: "0.25px",
                role: "presentation"
            }
        });
        var findHeaderRow = this.createHeaderContent(tableName);
        var thead = findHeaderRow.thead;
        var tbody = this.parent.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
            className: this.parent.frozenRows || (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && this.parent.editSettings.showAddNewRow ? "" : "e-hide",
            attrs: {
                role: "rowgroup"
            }
        });
        this.caption = this.parent.createElement("caption", {
            innerHTML: this.parent.element.id + "_header_table",
            className: "e-hide"
        });
        var colGroup = this.parent.createElement($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9);
        var rowBody = this.parent.createElement("tr", {
            attrs: {
                role: "row"
            },
            className: (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && this.parent.editSettings.showAddNewRow ? "e-hide" : ""
        });
        var bodyCell;
        var rows = this.rows = findHeaderRow.rows;
        for(var i = 0, len = rows.length; i < len; i++)for(var j = 0, len_1 = rows[parseInt(i.toString(), 10)].cells.length; j < len_1; j++){
            bodyCell = this.parent.createElement("td");
            rowBody.appendChild(bodyCell);
        }
        if (gObj.allowFiltering || gObj.allowSorting || gObj.allowGrouping) table.classList.add("e-sortfilter");
        this.updateColGroup(colGroup);
        tbody.appendChild(rowBody);
        table.appendChild(this.setColGroup(colGroup));
        table.appendChild(thead);
        table.appendChild(tbody);
        table.appendChild(this.caption);
        return table;
    };
    /**
     * @param {Element} tableEle - specifies the column
     * @returns {Element} returns the element
     * @hidden
     */ HeaderRender.prototype.createTable = function(tableEle) {
        if (tableEle === void 0) tableEle = null;
        return this.createHeader(tableEle);
    };
    HeaderRender.prototype.createHeaderContent = function(tableName) {
        var gObj = this.parent;
        var columns = gObj.getColumns();
        var thead = this.parent.createElement("thead", {
            attrs: {
                "role": "rowgroup"
            }
        });
        var colHeader = this.parent.createElement("tr", {
            className: "e-columnheader",
            attrs: {
                role: "row"
            }
        });
        var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header, gObj);
        rowRenderer.element = colHeader;
        var rows = [];
        var headerRow;
        this.colDepth = (0, $748c2240e597a9b7$export$d6485206a212c36b)(gObj.columns);
        for(var i = 0, len = this.colDepth; i < len; i++){
            rows[parseInt(i.toString(), 10)] = this.generateRow(i);
            rows[parseInt(i.toString(), 10)].cells = [];
        }
        rows = this.ensureColumns(rows);
        rows = this.getHeaderCells(rows, tableName);
        if (gObj.isRowDragable() && this.parent.getFrozenMode() === "Right") for(var i = 0, len = rows.length; i < len; i++)rows[parseInt(i.toString(), 10)].cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragHIcon));
        var headerTemplateColumn = columns.filter(function(a) {
            return a.headerTemplate;
        });
        if (headerTemplateColumn.length && (this.parent.isReact || this.parent.isVue)) (0, $748c2240e597a9b7$export$d9aeb73a9e271813)(this.parent, [
            "headerTemplate"
        ]);
        for(var i = 0, len = this.colDepth; i < len; i++){
            headerRow = rowRenderer.render(rows[parseInt(i.toString(), 10)], columns);
            if (this.parent.rowHeight && headerRow.querySelector(".e-headercell")) headerRow.style.height = this.parent.rowHeight + "px";
            (0, $748c2240e597a9b7$export$20c2eda854b6814a)(headerRow);
            thead.appendChild(headerRow);
        }
        var findHeaderRow = {
            thead: thead,
            rows: rows
        };
        return findHeaderRow;
    };
    HeaderRender.prototype.updateColGroup = function(colGroup) {
        var cols = this.parent.getColumns();
        var col;
        var indexes = this.parent.getColumnIndexesInView();
        colGroup.id = this.parent.element.id + $1b5568e76cdae6d4$export$f7c2e8f0e9310cd9;
        if (this.parent.allowGrouping) for(var i = 0, len = this.parent.groupSettings.columns.length; i < len; i++){
            if (this.parent.enableColumnVirtualization && indexes.indexOf(i) === -1) continue;
            col = this.parent.createElement("col", {
                className: "e-group-intent"
            });
            colGroup.appendChild(col);
        }
        if (this.parent.detailTemplate || this.parent.childGrid) {
            col = this.parent.createElement("col", {
                className: "e-detail-intent"
            });
            colGroup.appendChild(col);
        }
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() !== "Right") {
            col = this.parent.createElement("col", {
                className: "e-drag-intent"
            });
            colGroup.appendChild(col);
        }
        for(var i = 0, len = cols.length; i < len; i++){
            col = this.parent.createElement("col");
            if (cols[parseInt(i.toString(), 10)].visible === false) (0, $4ZDHT.setStyleAttribute)(col, {
                "display": "none"
            });
            colGroup.appendChild(col);
        }
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() === "Right") {
            col = this.parent.createElement("col", {
                className: "e-drag-intent"
            });
            colGroup.appendChild(col);
        }
        return colGroup;
    };
    HeaderRender.prototype.ensureColumns = function(rows) {
        //TODO: generate dummy column for group, detail, stacked row here; ensureColumns here
        var gObj = this.parent;
        var indexes = this.parent.getColumnIndexesInView();
        for(var i = 0, len = rows.length; i < len; i++){
            if (gObj.allowGrouping) for(var c = 0, len_2 = gObj.groupSettings.columns.length; c < len_2; c++){
                if (this.parent.enableColumnVirtualization && indexes.indexOf(c) === -1) continue;
                rows[parseInt(i.toString(), 10)].cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent));
            }
            if (gObj.detailTemplate || gObj.childGrid) {
                var args = {};
                this.parent.notify($17b89d3b1fc93cdb$export$74c82625a332a083, args);
                rows[parseInt(i.toString(), 10)].cells.push(this.generateCell(args, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailHeader));
            }
            if (gObj.isRowDragable() && this.parent.getFrozenMode() !== "Right") rows[parseInt(i.toString(), 10)].cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragHIcon));
        }
        return rows;
    };
    HeaderRender.prototype.getHeaderCells = function(rows, tableName) {
        var thead = this.parent.getHeaderTable() && this.parent.getHeaderTable().querySelector("thead");
        var cols = this.parent.enableColumnVirtualization ? this.parent.getColumns(this.parent.enablePersistence) : this.parent.columns;
        this.frzIdx = 0;
        this.notfrzIdx = 0;
        if (this.parent.lockcolPositionCount) for(var i = 0; i < (!(0, $3EnZW.isNullOrUndefined)(cols) ? cols.length : 0); i++){
            this.lockColsRendered = false;
            rows = this.appendCells(cols[parseInt(i.toString(), 10)], rows, 0, i === 0, false, i === cols.length - 1, thead, tableName, false);
        }
        for(var i = 0, len = !(0, $3EnZW.isNullOrUndefined)(cols) ? cols.length : 0; i < len; i++){
            this.notfrzIdx = 0;
            this.lockColsRendered = true;
            rows = this.appendCells(cols[parseInt(i.toString(), 10)], rows, 0, i === 0, false, i === len - 1, thead, tableName, false);
        }
        return rows;
    };
    HeaderRender.prototype.appendCells = function(cols, rows, index, isFirstObj, isFirstCol, isLastCol, isMovable, tableName, isStackLastCol) {
        var lastCol = isLastCol ? isStackLastCol ? "e-laststackcell" : "e-lastcell" : "";
        var isLockColumn = !this.parent.lockcolPositionCount || cols.lockColumn && !this.lockColsRendered || !cols.lockColumn && this.lockColsRendered;
        if (!cols.columns) {
            if (isLockColumn) rows[parseInt(index.toString(), 10)].cells.push(this.generateCell(cols, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header, this.colDepth - index, (isFirstObj ? "" : isFirstCol ? "e-firstcell" : "") + lastCol, index, this.parent.getColumnIndexByUid(cols.uid)));
            if (this.parent.lockcolPositionCount) {
                if (this.frzIdx + this.notfrzIdx < this.parent.frozenColumns && (cols.lockColumn && !this.lockColsRendered || !cols.lockColumn && this.lockColsRendered)) this.frzIdx++;
                else this.notfrzIdx++;
            } else this.frzIdx++;
        } else {
            this.isFirstCol = false;
            var colSpan = this.getCellCnt(cols, 0);
            if (colSpan) {
                var stackedLockColsCount = this.getStackedLockColsCount(cols, 0);
                var isStackedLockColumn = this.parent.lockcolPositionCount === 0 || !this.lockColsRendered && stackedLockColsCount !== 0 || this.lockColsRendered && colSpan - stackedLockColsCount !== 0;
                if (isStackedLockColumn) rows[parseInt(index.toString(), 10)].cells.push(new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)({
                    cellType: (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader,
                    column: cols,
                    colSpan: this.getColSpan(colSpan, stackedLockColsCount),
                    className: isFirstObj ? "" : isFirstCol ? "e-firstcell" : ""
                }));
            }
            if (this.parent.lockcolPositionCount && !this.lockColsRendered) for(var i = 0; i < cols.columns.length; i++)rows = this.appendCells(cols.columns[parseInt(i.toString(), 10)], rows, index + 1, isFirstObj, i === 0, i === cols.columns.length - 1 && isLastCol, isMovable, tableName, false);
            if (this.lockColsRendered) for(var i = 0, len = cols.columns.length; i < len; i++){
                isFirstObj = isFirstObj && i === 0;
                var isFirstCol_1 = this.isFirstCol = cols.columns[parseInt(i.toString(), 10)].visible && !isFirstObj;
                var isLaststackedCol = i === len - 1 && isLastCol;
                rows = this.appendCells(cols.columns[parseInt(i.toString(), 10)], rows, index + 1, isFirstObj, isFirstCol_1 && !isLaststackedCol, isLaststackedCol, isMovable, tableName, true);
            }
        }
        return rows;
    };
    HeaderRender.prototype.getStackedLockColsCount = function(col, lockColsCount) {
        if (col.columns) for(var i = 0; i < col.columns.length; i++)lockColsCount = this.getStackedLockColsCount(col.columns[parseInt(i.toString(), 10)], lockColsCount);
        else if (col.lockColumn) lockColsCount++;
        return lockColsCount;
    };
    HeaderRender.prototype.getColSpan = function(colSpan, stackedLockColsCount) {
        colSpan = !this.lockColsRendered ? stackedLockColsCount : colSpan - stackedLockColsCount;
        return colSpan;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HeaderRender.prototype.generateRow = function(index) {
        return new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)({});
    };
    HeaderRender.prototype.generateCell = function(column, cellType, rowSpan, className, rowIndex, colIndex) {
        var opt = {
            "visible": column.visible,
            "isDataCell": false,
            "isTemplate": !(0, $3EnZW.isNullOrUndefined)(column.headerTemplate),
            "rowID": "",
            "column": column,
            "cellType": cellType,
            "rowSpan": rowSpan,
            "className": className,
            "index": rowIndex,
            "colIndex": colIndex
        };
        if (!opt.rowSpan || opt.rowSpan < 2) delete opt.rowSpan;
        return new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)(opt);
    };
    /**
     * Function to hide header table column based on visible property
     *
     * @param {Column[]} columns - specifies the column
     * @returns {void}
     */ HeaderRender.prototype.setVisible = function(columns) {
        var gObj = this.parent;
        var displayVal;
        var idx;
        for(var c = 0, clen = columns.length; c < clen; c++){
            var column = columns[parseInt(c.toString(), 10)];
            idx = gObj.getNormalizedColumnIndex(column.uid);
            displayVal = column.visible ? "" : "none";
            (0, $4ZDHT.setStyleAttribute)(this.getColGroup().children[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
            if (gObj.editSettings.showAddNewRow && gObj.element.querySelector(".e-addedrow")) (0, $4ZDHT.setStyleAttribute)(gObj.element.querySelector(".e-addedrow").querySelector("colgroup").childNodes[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
        }
        this.refreshUI();
        if (this.parent.editSettings.showAddNewRow) this.parent.isAddNewRow = true;
    };
    HeaderRender.prototype.colPosRefresh = function() {
        this.refreshUI();
    };
    /**
     * Refresh the header of the Grid.
     *
     * @returns {void}
     */ HeaderRender.prototype.refreshUI = function() {
        var headerDiv = this.getPanel();
        this.toggleStackClass(headerDiv);
        var table = this.getTable();
        var tableName = undefined;
        if (table) {
            (0, $4ZDHT.remove)(table);
            if (this.parent.editSettings.showAddNewRow && !this.parent.isAddNewRow && table.querySelector(".e-addedrow") && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) {
                table.querySelector(".e-addedrow").classList.add("e-addrow-removed");
                this.parent.isAddNewRow = true;
            }
            table.removeChild(table.firstChild);
            table.removeChild(table.childNodes[0]);
            var colGroup = this.parent.createElement($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9);
            var findHeaderRow = this.createHeaderContent(tableName);
            this.rows = findHeaderRow.rows;
            table.insertBefore(findHeaderRow.thead, table.firstChild);
            this.updateColGroup(colGroup);
            table.insertBefore(this.setColGroup(colGroup), table.firstChild);
            this.appendContent(table);
            this.parent.notify($17b89d3b1fc93cdb$export$dd9331973c9310ae, {});
            this.widthService.setWidthToColumns();
            this.parent.updateDefaultCursor();
            this.initializeHeaderDrag();
            var rows = [].slice.call(headerDiv.querySelectorAll("tr.e-columnheader"));
            for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
                var row = rows_1[_i];
                var gCells = [].slice.call(row.getElementsByClassName("e-grouptopleftcell"));
                if (gCells.length) gCells[gCells.length - 1].classList.add("e-lastgrouptopleftcell");
            }
            this.parent.notify($17b89d3b1fc93cdb$export$265a66bcae9d11dd, {
                rows: this.rows
            });
            if (this.parent.enableColumnVirtualization && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(table, $1b5568e76cdae6d4$export$af4960656b46803f)) this.parent.notify($17b89d3b1fc93cdb$export$265a66bcae9d11dd, {
                rows: this.rows,
                args: {
                    isFrozen: false,
                    isXaxis: true
                }
            });
            if (this.parent.allowTextWrap && this.parent.textWrapSettings.wrapMode === "Header") (0, $748c2240e597a9b7$export$4997ffc0176396a6)(rows, true);
        }
        var firstHeaderCell = this.parent.getHeaderContent().querySelector(".e-headercell:not(.e-hide)");
        if (!(0, $3EnZW.isNullOrUndefined)(firstHeaderCell)) firstHeaderCell.tabIndex = 0;
    };
    HeaderRender.prototype.toggleStackClass = function(div) {
        var column = this.parent.columns;
        var stackedHdr = !(0, $3EnZW.isNullOrUndefined)(column) ? column.some(function(column) {
            return !(0, $3EnZW.isNullOrUndefined)(column.columns);
        }) : false;
        if (stackedHdr) div.classList.add("e-stackedheader");
        else div.classList.remove("e-stackedheader");
    };
    HeaderRender.prototype.appendContent = function(table) {
        this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).appendChild(table);
    };
    HeaderRender.prototype.getCellCnt = function(col, cnt) {
        if (col.columns) for(var i = 0, len = col.columns.length; i < len; i++)cnt = this.getCellCnt(col.columns[parseInt(i.toString(), 10)], cnt);
        else if (col.visible) cnt++;
        return cnt;
    };
    HeaderRender.prototype.initializeHeaderDrag = function() {
        var gObj = this.parent;
        if (!(this.parent.allowReordering || this.parent.allowGrouping && this.parent.groupSettings.showDropArea)) return;
        this.draggable = new (0, $eAUyT.Draggable)(gObj.getHeaderContent(), {
            dragTarget: ".e-headercell",
            distance: 5,
            helper: this.helper,
            dragStart: this.dragStart,
            drag: this.drag,
            dragStop: this.dragStop,
            abort: ".e-rhandler",
            isReplaceDragEle: this.isReplaceDragEle
        });
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.droppableDestroy, this);
    };
    HeaderRender.prototype.initializeHeaderDrop = function() {
        var gObj = this.parent;
        this.droppable = new (0, $g9Ic7.Droppable)(gObj.getHeaderContent(), {
            accept: ".e-dragclone",
            drop: this.drop
        });
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.droppableDestroy, this);
    };
    HeaderRender.prototype.droppableDestroy = function() {
        if (this.droppable && !this.droppable.isDestroyed) this.droppable.destroy();
        if (this.draggable && !this.draggable.isDestroyed) this.draggable.destroy();
    };
    HeaderRender.prototype.renderCustomToolbar = function() {
        var _this = this;
        var gObj = this.parent;
        if (gObj.rowRenderingMode === "Vertical" && !gObj.toolbar && (gObj.allowSorting || gObj.allowFiltering && gObj.filterSettings.type !== "FilterBar")) {
            var div = gObj.createElement("div", {
                className: "e-res-toolbar e-toolbar"
            });
            var toolbarItems = gObj.createElement("div", {
                className: "e-toolbar-items"
            });
            var toolbarLeft = gObj.createElement("div", {
                className: "e-toolbar-left"
            });
            var count = this.parent.allowFiltering && this.parent.allowSorting ? 2 : 1;
            for(var i = 0; i < count; i++){
                var toolbarItem = gObj.createElement("div", {
                    className: "e-toolbar-item e-gridresponsiveicons e-icons e-tbtn-align"
                });
                var cls = count === 1 ? this.parent.allowSorting ? "sort" : "filter" : i === 1 ? "sort" : "filter";
                var button = gObj.createElement("button", {
                    className: "e-tbar-btn e-control e-btn e-lib e-icon-btn"
                });
                var span = gObj.createElement("span", {
                    className: "e-btn-icon e-res" + cls + "-icon e-icons"
                });
                button.appendChild(span);
                var btnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                    cssClass: this.parent.cssClass ? this.parent.cssClass : ""
                });
                btnObj.appendTo(button);
                button.onclick = function(e) {
                    if (e.target.classList.contains("e-ressort-btn") || e.target.classList.contains("e-ressort-icon") || e.target.querySelector(".e-ressort-icon")) _this.parent.showResponsiveCustomSort();
                    else _this.parent.showResponsiveCustomFilter();
                };
                toolbarItem.appendChild(button);
                toolbarLeft.appendChild(toolbarItem);
            }
            toolbarItems.appendChild(toolbarLeft);
            div.appendChild(toolbarItems);
            gObj.element.insertBefore(div, this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0));
        } else if (gObj.enableAdaptiveUI && !gObj.toolbar) gObj.getContent().classList.add("e-responsive-header");
    };
    HeaderRender.prototype.updateCustomResponsiveToolbar = function(args) {
        var resToolbar = this.parent.element.querySelector(".e-responsive-toolbar");
        if (args.module === "toolbar") {
            if (resToolbar) (0, $4ZDHT.remove)(resToolbar);
            else this.renderCustomToolbar();
        }
    };
    return HeaderRender;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");





/**
 * CellRenderer class which responsible for building cell content.
 *
 * @hidden
 */ var $e992c1409d919677$export$efe8300dd67deed4 = /** @class */ function() {
    function CellRenderer(parent, locator) {
        this.localizer = locator.getService("localization");
        this.formatter = locator.getService("valueFormatter");
        this.parent = parent;
        this.element = this.parent.createElement("TD", {
            className: $1b5568e76cdae6d4$export$deb49d6cac2bdaca,
            attrs: {
                role: "gridcell",
                tabindex: "-1"
            }
        });
        this.rowChkBox = this.parent.createElement("input", {
            className: "e-checkselect",
            attrs: {
                "type": "checkbox",
                "aria-label": this.localizer.getConstant("SelectRow")
            }
        });
    }
    /**
     * Function to return the wrapper for the TD content
     *
     * @returns {string | Element} returns the string
     */ CellRenderer.prototype.getGui = function() {
        return "";
    };
    /**
     * Function to format the cell value.
     *
     * @param  {Column} column - specifies the column
     * @param  {Object} value - specifies the value
     * @param  {Object} data - specifies the data
     * @returns {string} returns the format
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CellRenderer.prototype.format = function(column, value, data) {
        if (!(0, $3EnZW.isNullOrUndefined)(column.format)) {
            if (column.type === "number" && isNaN(parseInt(value, 10))) value = null;
            if (column.type === "dateonly" && typeof value === "string" && value) {
                var arr = value.split(/[^0-9.]/);
                value = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10));
            }
            value = this.formatter.toView(value, column.getFormatter());
        }
        return (0, $3EnZW.isNullOrUndefined)(value) ? "" : value.toString();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CellRenderer.prototype.evaluate = function(node, cell, data, attributes, fData, isEdit) {
        var _a;
        var result;
        if (cell.column.template) {
            var isReactCompiler = this.parent.isReact && typeof cell.column.template !== "string" && cell.column.template.prototype && !cell.column.template.prototype.CSPTemplate;
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
            var literals_1 = [
                "index"
            ];
            var dummyData = (0, $748c2240e597a9b7$export$8f9fa30750711038)({}, data, (_a = {}, _a[0, $17b89d3b1fc93cdb$export$4e76384d33160ddd] = fData, _a.column = cell.column, _a));
            var templateID = this.parent.element.id + cell.column.uid;
            var str = "isStringTemplate";
            if (isReactCompiler || isReactChild) {
                var copied = {
                    "index": attributes[literals_1[0]]
                };
                cell.column.getColumnTemplate()((0, $3EnZW.extend)(copied, dummyData), this.parent, "columnTemplate", templateID, this.parent["" + str], null, node);
            } else result = cell.column.getColumnTemplate()((0, $3EnZW.extend)({
                "index": attributes[literals_1[0]]
            }, dummyData), this.parent, "template", templateID, this.parent["" + str], undefined, undefined, this.parent["root"]);
            if (!isReactCompiler && !isReactChild) (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(node, result);
            this.parent.notify("template-result", {
                template: result
            });
            result = null;
            node.setAttribute("aria-label", node.innerText + this.localizer.getConstant("TemplateCell") + this.localizer.getConstant("ColumnHeader") + cell.column.headerText);
            return false;
        }
        return true;
    };
    /**
     * Function to invoke the custom formatter available in the column object.
     *
     * @param  {Column} column - specifies the column
     * @param  {Object} value - specifies the value
     * @param  {Object} data - specifies the data
     * @returns {Object} returns the object
     */ CellRenderer.prototype.invokeFormatter = function(column, value, data) {
        if (!(0, $3EnZW.isNullOrUndefined)(column.formatter)) {
            if ((0, $748c2240e597a9b7$export$9661456f2f103224)(column.formatter, "getValue")) {
                var formatter = column.formatter;
                value = new formatter().getValue(column, data);
            } else if (typeof column.formatter === "function") value = column.formatter(column, data);
            else value = column.formatter.getValue(column, data);
        }
        return value;
    };
    /**
     * Function to render the cell content based on Column object.
     *
     * @param {Cell<Column>} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @param {Object} attributes - specifies the attributes
     * @param {boolean} isExpand - specifies the boolean for expand
     * @param {boolean} isEdit - specifies the boolean for edit
     * @returns {Element} returns the element
     */ CellRenderer.prototype.render = function(cell, data, attributes, isExpand, isEdit) {
        return this.refreshCell(cell, data, attributes, isEdit);
    };
    /**
     * Function to refresh the cell content based on Column object.
     *
     * @param {Element} td - specifies the element
     * @param {Cell<Column>} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @param {Object} attributes - specifies the attribute
     * @returns {void}
     */ CellRenderer.prototype.refreshTD = function(td, cell, data, attributes) {
        var isEdit = this.parent.editSettings.mode === "Batch" && td.classList.contains("e-editedbatchcell");
        if (this.parent.isReact) {
            var cellIndex = td.cellIndex;
            var parentRow = td.parentElement;
            (0, $4ZDHT.remove)(td);
            var newTD = this.refreshCell(cell, data, attributes, isEdit);
            this.cloneAttributes(newTD, td);
            if (parentRow.cells.length !== cellIndex - 1) parentRow.insertBefore(newTD, parentRow.cells[parseInt(cellIndex.toString(), 10)]);
            else parentRow.appendChild(newTD);
        } else {
            var node = this.refreshCell(cell, data, attributes, isEdit);
            td.innerHTML = "";
            var arialabelText = node.getAttribute("aria-label");
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            arialabelText && td.setAttribute("aria-label", arialabelText);
            var elements = [].slice.call(node.childNodes);
            for(var _i = 0, elements_1 = elements; _i < elements_1.length; _i++){
                var elem = elements_1[_i];
                td.appendChild(elem);
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CellRenderer.prototype.cloneAttributes = function(target, source) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = source.attributes;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var i = attrs.length;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attr;
        while(i--){
            attr = attrs[parseInt(i.toString(), 10)];
            target.setAttribute(attr.name, attr.value);
        }
    };
    CellRenderer.prototype.refreshCell = function(cell, data, attributes, isEdit) {
        var _a;
        var node = this.element.cloneNode();
        var column = cell.column;
        var fData;
        if (cell.isForeignKey) fData = cell.foreignKeyData[0] || (_a = {}, _a[column.foreignKeyValue] = column.format ? null : "", _a);
        //Prepare innerHtml
        var innerHtml = this.getGui();
        var value = cell.isForeignKey ? this.getValue(column.foreignKeyValue, fData, column) : this.getValue(column.field, data, column);
        if ((column.type === "date" || column.type === "datetime") && !(0, $3EnZW.isNullOrUndefined)(value)) value = new Date(value);
        if (column.type === "dateonly" && !(0, $3EnZW.isNullOrUndefined)(value) && typeof value === "string") {
            var arr = value.split(/[^0-9.]/);
            value = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10));
        }
        value = this.format(column, value, data);
        innerHtml = value.toString();
        if (column.type === "boolean" && !column.displayAsCheckBox) {
            var localeStr = value !== "true" && value !== "false" ? null : value === "true" ? "True" : "False";
            innerHtml = localeStr ? this.localizer.getConstant(localeStr) : innerHtml;
        }
        var fromFormatter = this.invokeFormatter(column, value, data);
        innerHtml = !(0, $3EnZW.isNullOrUndefined)(column.formatter) ? (0, $3EnZW.isNullOrUndefined)(fromFormatter) ? "" : fromFormatter.toString() : innerHtml;
        if (this.evaluate(node, cell, data, attributes, fData, isEdit) && column.type !== "checkbox") this.appendHtml(node, this.parent.sanitize(innerHtml), column.getDomSetter ? column.getDomSetter() : "innerHTML");
        else if (column.type === "checkbox") {
            node.classList.add($1b5568e76cdae6d4$export$71f350cebd38389f);
            if (this.parent.selectionSettings.persistSelection) value = value === "true";
            else value = false;
            var checkWrap = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
                checked: value,
                label: " "
            });
            if (this.parent.cssClass) (0, $4ZDHT.addClass)([
                checkWrap
            ], [
                this.parent.cssClass
            ]);
            this.rowChkBox.id = "checkbox-" + cell.rowID;
            checkWrap.insertBefore(this.rowChkBox.cloneNode(), checkWrap.firstChild);
            node.appendChild(checkWrap);
        }
        if (this.parent.checkAllRows === "Check" && this.parent.enableVirtualization) cell.isSelected = true;
        this.setAttributes(node, cell, attributes);
        if (column.type === "boolean" && column.displayAsCheckBox) {
            var checked = isNaN(parseInt(value.toString(), 10)) ? value === "true" : parseInt(value.toString(), 10) > 0;
            var checkWrap = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
                checked: checked,
                label: " "
            });
            node.innerHTML = "";
            node.classList.add("e-gridchkbox-cell");
            checkWrap.classList.add("e-checkbox-disabled");
            if (this.parent.cssClass) (0, $4ZDHT.addClass)([
                checkWrap
            ], [
                this.parent.cssClass
            ]);
            node.appendChild(checkWrap);
        }
        if (node.classList.contains("e-summarycell") && !data.key) {
            var uid = node.getAttribute("e-mappinguid");
            column = this.parent.getColumnByUid(uid);
            node.setAttribute("aria-label", innerHtml + this.localizer.getConstant("ColumnHeader") + cell.column.headerText);
        }
        if (this.parent.isFrozenGrid() && (!data || data && !data.key)) (0, $748c2240e597a9b7$export$a94a28b9cbe22d6a)(this.parent, column, node);
        return node;
    };
    /**
     * Function to specifies how the result content to be placed in the cell.
     *
     * @param {Element} node - specifies the node
     * @param {string|Element} innerHtml - specifies the innerHTML
     * @param {string} property - specifies the element
     * @returns {Element} returns the element
     */ CellRenderer.prototype.appendHtml = function(node, innerHtml, property) {
        if (property === void 0) property = "innerHTML";
        node["" + property] = innerHtml;
        return node;
    };
    /**
     * @param {HTMLElement} node - specifies the node
     * @param {cell<Column>} cell - specifies the cell
     * @param {Object} attributes - specifies the attributes
     * @returns {void}
     * @hidden
     */ CellRenderer.prototype.setAttributes = function(node, cell, attributes) {
        var column = cell.column;
        this.buildAttributeFromCell(node, cell, column.type === "checkbox");
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, attributes);
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, cell.attributes);
        if (column.customAttributes) (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, column.customAttributes);
        if (this.parent.rowRenderingMode === "Vertical") (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, {
            "data-cell": column.headerText
        });
        if (column.textAlign) node.style.textAlign = column.textAlign;
        if (column.clipMode === "Clip" || !column.clipMode && this.parent.clipMode === "Clip") node.classList.add("e-gridclip");
        else if (column.clipMode === "EllipsisWithTooltip" || !column.clipMode && this.parent.clipMode === "EllipsisWithTooltip" && !(this.parent.allowTextWrap && (this.parent.textWrapSettings.wrapMode === "Content" || this.parent.textWrapSettings.wrapMode === "Both"))) {
            if (column.type !== "checkbox") node.classList.add("e-ellipsistooltip");
        }
    };
    CellRenderer.prototype.buildAttributeFromCell = function(node, cell, isCheckBoxType) {
        var attr = {};
        var prop = {
            "colindex": $1b5568e76cdae6d4$export$fff541542e3093ed
        };
        var classes = [];
        if (cell.colSpan) attr.colSpan = cell.colSpan;
        if (cell.rowSpan) attr.rowSpan = cell.rowSpan;
        if (cell.isTemplate) classes.push("e-templatecell");
        if (cell.isSelected) {
            classes.push.apply(classes, [
                "e-selectionbackground",
                "e-active"
            ]);
            if (isCheckBoxType) node.querySelector(".e-frame").classList.add("e-check");
        }
        if (cell.isColumnSelected) classes.push.apply(classes, [
            "e-columnselection"
        ]);
        if (cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header) {
            attr[prop.colindex] = cell.colIndex;
            attr[$1b5568e76cdae6d4$export$d3d64e794dbd0f6b] = cell.colIndex + 1;
        } else if (!(0, $3EnZW.isNullOrUndefined)(cell.index)) {
            attr[prop.colindex] = cell.index;
            attr[$1b5568e76cdae6d4$export$d3d64e794dbd0f6b] = cell.index + 1;
        }
        if (!cell.visible) classes.push("e-hide");
        attr.class = classes;
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, attr);
    };
    CellRenderer.prototype.getValue = function(field, data, column) {
        return column.valueAccessor(field, data, column);
    };
    return CellRenderer;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


/**
 * AriaService
 *
 * @hidden
 */ var $93af6f2061a6f920$export$aaeab4162651d364 = /** @class */ function() {
    function AriaService() {}
    AriaService.prototype.setOptions = function(target, options) {
        var props = Object.keys(options);
        for(var i = 0; i < props.length; i++)$93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config[props[parseInt(i.toString(), 10)]], options[props[parseInt(i.toString(), 10)]]);
    };
    AriaService.prototype.setExpand = function(target, expand) {
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.expand, expand);
    };
    AriaService.prototype.setSort = function(target, direction) {
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.sort, direction, typeof direction === "boolean");
    };
    AriaService.prototype.setBusy = function(target, isBusy) {
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.busy, isBusy);
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.invalid, null, true);
    };
    AriaService.prototype.setGrabbed = function(target, isGrabbed, remove) {
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.grabbed, isGrabbed, remove);
    };
    AriaService.prototype.setDropTarget = function(target, isTarget) {
        $93af6f2061a6f920$var$setStateAndProperties(target, $93af6f2061a6f920$var$config.dropeffect, "copy", !isTarget);
    };
    return AriaService;
}();
/**
 * @param {HTMLElement} target - specifies the target
 * @param {string} attribute - specifies the attribute
 * @param {ValueType} value - specifies the value
 * @param {boolean} remove - specifies the boolean for remove
 * @returns {void}
 * @hidden
 */ function $93af6f2061a6f920$var$setStateAndProperties(target, attribute, value, remove) {
    if (remove && target) {
        target.removeAttribute(attribute);
        return;
    }
    if (target) target.setAttribute(attribute, value);
}
var $93af6f2061a6f920$var$config = {
    expand: "aria-expanded",
    role: "role",
    datarole: "data-role",
    selected: "aria-selected",
    multiselectable: "aria-multiselectable",
    sort: "aria-sort",
    busy: "aria-busy",
    invalid: "aria-invalid",
    grabbed: "aria-grabbed",
    dropeffect: "aria-dropeffect",
    haspopup: "aria-haspopup",
    level: "aria-level",
    colcount: "aria-colcount",
    rowcount: "aria-rowcount"
};




var $138c77c0bef20541$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * HeaderCellRenderer class which responsible for building header cell content.
 *
 * @hidden
 */ var $138c77c0bef20541$export$84ffe2c521da4c06 = /** @class */ function(_super) {
    $138c77c0bef20541$var$__extends(HeaderCellRenderer, _super);
    function HeaderCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-headercell",
            attrs: {
                tabindex: "-1",
                role: "columnheader"
            }
        });
        _this.ariaService = new (0, $93af6f2061a6f920$export$aaeab4162651d364)();
        _this.hTxtEle = _this.parent.createElement("span", {
            className: "e-headertext"
        });
        _this.sortEle = _this.parent.createElement("div", {
            className: "e-sortfilterdiv e-icons",
            attrs: {
                "aria-hidden": "true"
            }
        });
        _this.gui = _this.parent.createElement("div");
        _this.chkAllBox = _this.parent.createElement("input", {
            className: "e-checkselectall",
            attrs: {
                "type": "checkbox",
                "aria-label": _this.localizer.getConstant("SelectAllCheckbox")
            }
        });
        return _this;
    }
    /**
     * Function to return the wrapper for the TH content.
     *
     * @returns {string | Element} returns the element
     */ HeaderCellRenderer.prototype.getGui = function() {
        return this.gui.cloneNode();
    };
    /**
     * Function to render the cell content based on Column object.
     *
     * @param {Cell} cell - specifies the column
     * @param {Object} data - specifies the data
     * @param {object} attributes - specifies the aattributes
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HeaderCellRenderer.prototype.render = function(cell, data, attributes) {
        var node = this.element.cloneNode();
        var fltrMenuEle = this.parent.createElement("div", {
            className: "e-filtermenudiv e-icons e-icon-filter",
            attrs: {
                "aria-hidden": "true"
            }
        });
        return this.prepareHeader(cell, node, fltrMenuEle);
    };
    /**
     * Function to refresh the cell content based on Column object.
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Element} node - specifies the noe
     * @returns {Element} returns the element
     */ HeaderCellRenderer.prototype.refresh = function(cell, node) {
        this.clean(node);
        var fltrMenuEle = this.parent.createElement("div", {
            className: "e-filtermenudiv e-icons e-icon-filter",
            attrs: {
                "aria-hidden": "true"
            }
        });
        return this.prepareHeader(cell, node, fltrMenuEle);
    };
    HeaderCellRenderer.prototype.clean = function(node) {
        node.innerHTML = "";
    };
    /* tslint:disable-next-line:max-func-body-length */ HeaderCellRenderer.prototype.prepareHeader = function(cell, node, fltrMenuEle) {
        var column = cell.column;
        var ariaAttr = {};
        var elementDesc = "";
        //Prepare innerHtml
        var innerDIV = this.getGui();
        var hValueAccer;
        (0, $4ZDHT.attributes)(innerDIV, {
            "e-mappinguid": column.uid,
            "class": "e-headercelldiv"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(column.headerValueAccessor)) hValueAccer = this.getValue(column.headerText, column);
        if (this.parent.allowSorting && column.allowSorting && !(0, $3EnZW.isNullOrUndefined)(column.field)) node.classList.add("e-sort-icon");
        if (column.type !== "checkbox") {
            var value = column.headerText;
            if (!(0, $3EnZW.isNullOrUndefined)(hValueAccer)) value = hValueAccer;
            var headerText = this.hTxtEle.cloneNode();
            headerText[column.getDomSetter()] = this.parent.sanitize(value);
            innerDIV.appendChild(headerText);
        } else {
            column.editType = "booleanedit";
            var checkAllWrap = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
                checked: false,
                label: " "
            });
            this.chkAllBox.id = "checkbox-" + column.uid;
            checkAllWrap.insertBefore(this.chkAllBox.cloneNode(), checkAllWrap.firstChild);
            if (this.parent.cssClass) (0, $4ZDHT.addClass)([
                checkAllWrap
            ], [
                this.parent.cssClass
            ]);
            innerDIV.appendChild(checkAllWrap);
            innerDIV.classList.add("e-headerchkcelldiv");
        }
        this.buildAttributeFromCell(node, cell);
        this.appendHtml(node, innerDIV);
        node.appendChild(this.sortEle.cloneNode());
        if (this.parent.allowFiltering && this.parent.filterSettings.type !== "FilterBar" && column.allowFiltering && !(0, $3EnZW.isNullOrUndefined)(column.field) && !(this.parent.showColumnMenu && column.showColumnMenu)) {
            (0, $4ZDHT.attributes)(fltrMenuEle, {
                "e-mappinguid": "e-flmenu-" + column.uid
            });
            elementDesc = elementDesc.length ? elementDesc + ". " + this.localizer.getConstant("FilterDescription") : this.localizer.getConstant("FilterDescription");
            node.classList.add("e-fltr-icon");
            var matchFlColumns = [];
            if (this.parent.filterSettings.columns.length && this.parent.filterSettings.columns.length !== matchFlColumns.length) {
                var foreignColumn = this.parent.getForeignKeyColumns();
                for(var index = 0; index < this.parent.columns.length; index++){
                    for(var count = 0; count < this.parent.filterSettings.columns.length; count++)if (this.parent.filterSettings.columns[parseInt(count.toString(), 10)].field === column.field || foreignColumn.length && column.foreignKeyValue === this.parent.filterSettings.columns[parseInt(count.toString(), 10)].field) {
                        fltrMenuEle.classList.add("e-filtered");
                        matchFlColumns.push(column.field);
                        break;
                    }
                }
            }
            node.appendChild(fltrMenuEle.cloneNode());
        }
        if (cell.className) node.classList.add(cell.className);
        if (column.customAttributes) (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, column.customAttributes);
        if (this.parent.allowSorting && column.allowSorting) {
            ariaAttr.sort = "none";
            elementDesc = elementDesc.length ? elementDesc + ". " + this.localizer.getConstant("SortDescription") : this.localizer.getConstant("SortDescription");
        }
        if (this.parent.allowGrouping && column.allowGrouping || this.parent.allowReordering && column.allowReordering) {
            ariaAttr.grabbed = false;
            elementDesc = elementDesc.length ? elementDesc + ". " + this.localizer.getConstant("GroupDescription") : this.localizer.getConstant("GroupDescription");
        }
        if (this.parent.showColumnMenu && column.type !== "checkbox" && !column.template) elementDesc = elementDesc.length ? elementDesc + ". " + this.localizer.getConstant("ColumnMenuDescription") : this.localizer.getConstant("ColumnMenuDescription");
        node = this.extendPrepareHeader(column, node);
        var result;
        var gridObj = this.parent;
        var colIndex = gridObj.getColumnIndexByField(column.field);
        if (!(0, $3EnZW.isNullOrUndefined)(column.headerTemplate)) {
            //need to pass the template id for blazor headertemplate
            var headerTempID = gridObj.element.id + column.uid + "headerTemplate";
            var str = "isStringTemplate";
            var col = column;
            var isReactCompiler = this.parent.isReact && typeof column.headerTemplate !== "string";
            var isReactChild_1 = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
            if (isReactCompiler || isReactChild_1) {
                var copied = {
                    "index": colIndex
                };
                node.firstElementChild.innerHTML = "";
                column.getHeaderTemplate()((0, $3EnZW.extend)(copied, col), gridObj, "headerTemplate", headerTempID, this.parent["" + str], null, node.firstElementChild);
                this.parent.renderTemplates();
            } else {
                result = column.getHeaderTemplate()((0, $3EnZW.extend)({
                    "index": colIndex
                }, col), gridObj, "headerTemplate", headerTempID, this.parent["" + str], undefined, undefined, this.parent["root"]);
                node.firstElementChild.innerHTML = "";
                (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(node.firstElementChild, result);
            }
        }
        this.ariaService.setOptions(node, ariaAttr);
        if (!(0, $3EnZW.isNullOrUndefined)(column.headerTextAlign) || !(0, $3EnZW.isNullOrUndefined)(column.textAlign)) {
            var alignment = column.headerTextAlign || column.textAlign;
            innerDIV.style.textAlign = alignment;
            if (alignment === "Right" || alignment === "Left") node.classList.add(alignment === "Right" ? "e-rightalign" : "e-leftalign");
            else if (alignment === "Center") node.classList.add("e-centeralign");
        }
        if (column.clipMode === "Clip" || !column.clipMode && this.parent.clipMode === "Clip") node.classList.add("e-gridclip");
        else if ((column.clipMode === "EllipsisWithTooltip" || !column.clipMode && this.parent.clipMode === "EllipsisWithTooltip") && !(gridObj.allowTextWrap && (gridObj.textWrapSettings.wrapMode === "Header" || gridObj.textWrapSettings.wrapMode === "Both"))) {
            if (column.type !== "checkbox") node.classList.add("e-ellipsistooltip");
        }
        if (elementDesc) {
            var titleElem = this.parent.createElement("span", {
                id: "headerTitle-" + column.uid,
                innerHTML: elementDesc,
                attrs: {
                    style: "display:none"
                }
            });
            node.appendChild(titleElem);
            node.setAttribute("aria-describedby", titleElem.id);
        }
        node.setAttribute("aria-rowspan", (!(0, $3EnZW.isNullOrUndefined)(cell.rowSpan) ? cell.rowSpan : 1).toString());
        node.setAttribute("aria-colspan", "1");
        var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
        if ((this.parent.isReact && this.parent.requireTemplateRef || isReactChild && this.parent.parentDetails.parentInstObj.requireTemplateRef) && !(0, $3EnZW.isNullOrUndefined)(column.headerTemplate)) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var thisRef_1 = this;
            thisRef_1.parent.renderTemplates(function() {
                thisRef_1.parent.trigger((0, $17b89d3b1fc93cdb$export$c72883aa0a0b0dc9), {
                    cell: cell,
                    node: node
                });
            });
        } else this.parent.trigger((0, $17b89d3b1fc93cdb$export$c72883aa0a0b0dc9), {
            cell: cell,
            node: node
        });
        if (this.parent.isFrozenGrid()) (0, $748c2240e597a9b7$export$a94a28b9cbe22d6a)(this.parent, column, node);
        return node;
    };
    HeaderCellRenderer.prototype.getValue = function(field, column) {
        return column.headerValueAccessor(field, column);
    };
    HeaderCellRenderer.prototype.extendPrepareHeader = function(column, node) {
        if (this.parent.showColumnMenu && column.showColumnMenu && !(0, $3EnZW.isNullOrUndefined)(column.field)) {
            var element = this.parent.createElement("div", {
                className: "e-icons e-columnmenu",
                attrs: {
                    "aria-hidden": "true"
                }
            });
            var matchFilteredColumns = [];
            if (this.parent.filterSettings.columns.length && this.parent.filterSettings.columns.length !== matchFilteredColumns.length) for(var i = 0; i < this.parent.columns.length; i++){
                for(var j = 0; j < this.parent.filterSettings.columns.length; j++)if (this.parent.filterSettings.columns[parseInt(j.toString(), 10)].field === column.field) {
                    element.classList.add("e-filtered");
                    matchFilteredColumns.push(column.field);
                    break;
                }
            }
            node.classList.add("e-fltr-icon");
            node.appendChild(element);
        }
        if (this.parent.allowResizing) {
            var handler = this.parent.createElement("div");
            handler.className = column.allowResizing ? "e-rhandler e-rcursor" : "e-rsuppress";
            node.appendChild(handler);
        }
        return node;
    };
    /**
     * Function to specifies how the result content to be placed in the cell.
     *
     * @param  {Element} node - specifies the node
     * @param  {string|Element} innerHtml - specifies the innerHtml
     * @returns {Element} returns the element
     */ HeaderCellRenderer.prototype.appendHtml = function(node, innerHtml) {
        node.appendChild(innerHtml);
        return node;
    };
    return HeaderCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



var $b24f3c4bfad11a8f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * StackedHeaderCellRenderer class which responsible for building stacked header cell content.
 *
 * @hidden
 */ var $b24f3c4bfad11a8f$export$e989b059caa4681f = /** @class */ function(_super) {
    $b24f3c4bfad11a8f$var$__extends(StackedHeaderCellRenderer, _super);
    function StackedHeaderCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-headercell e-stackedheadercell",
            attrs: {
                tabindex: "-1",
                role: "columnheader"
            }
        });
        return _this;
    }
    /**
     * Function to render the cell content based on Column object.
     *
     * @param {Cell<Column>} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @param {object} attributes - specifies the attributes
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    StackedHeaderCellRenderer.prototype.render = function(cell, data, attributes) {
        var node = this.element.cloneNode();
        var div = this.parent.createElement("div", {
            className: "e-stackedheadercelldiv",
            attrs: {
                "e-mappinguid": cell.column.uid
            }
        });
        var column = cell.column;
        node.appendChild(div);
        if (!(0, $3EnZW.isNullOrUndefined)(column.headerTemplate)) (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(div, column.getHeaderTemplate()(column, this.parent, "headerTemplate", null, null, null, null, this.parent.root));
        else this.appendHtml(div, this.parent.sanitize(column.headerText), column.getDomSetter());
        if (cell.column.toolTip) node.setAttribute("title", cell.column.toolTip);
        if (column.clipMode === "Clip" || !column.clipMode && this.parent.clipMode === "Clip") node.classList.add("e-gridclip");
        else if (column.clipMode === "EllipsisWithTooltip" || !column.clipMode && this.parent.clipMode === "EllipsisWithTooltip") node.classList.add("e-ellipsistooltip");
        if (!(0, $3EnZW.isNullOrUndefined)(cell.column.textAlign)) div.style.textAlign = cell.column.textAlign;
        if (cell.column.customAttributes) (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, cell.column.customAttributes);
        node.setAttribute("colspan", cell.colSpan.toString());
        node.setAttribute("aria-colspan", cell.colSpan.toString());
        node.setAttribute("aria-rowspan", "1");
        if (this.parent.allowResizing) {
            var handler = this.parent.createElement("div");
            handler.className = cell.column.allowResizing ? "e-rhandler e-rcursor" : "e-rsuppress";
            node.appendChild(handler);
        }
        if (cell.className) node.classList.add(cell.className);
        this.parent.trigger((0, $17b89d3b1fc93cdb$export$c72883aa0a0b0dc9), {
            cell: cell,
            node: node
        });
        if ((0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(column) === "Left") {
            node.classList.add("e-leftfreeze");
            if (column.border === "Left") node.classList.add("e-freezeleftborder");
            if (column.index === 0) (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, this.parent.getIndentCount() * 30, this.parent.enableRtl, "Left");
            else {
                var cols = this.parent.getColumns();
                var width = this.parent.getIndentCount() * 30;
                for(var i = 0; i < cols.length; i++){
                    if (column.index < cols[parseInt(i.toString(), 10)].index) break;
                    if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
                }
                (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width, this.parent.enableRtl, "Left");
            }
        } else if ((0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(column) === "Right") {
            node.classList.add("e-rightfreeze");
            var cols = this.parent.getColumns();
            var width = this.parent.getFrozenMode() === "Right" && this.parent.isRowDragable() ? 30 : 0;
            for(var i = cols.length - 1; i >= 0; i--){
                if ((0, $748c2240e597a9b7$export$3289971ebd775b18)(column, cols[parseInt(i.toString(), 10)].uid) || column.index > cols[parseInt(i.toString(), 10)].index) break;
                if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
            }
            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width, this.parent.enableRtl, "Right");
            if (column.border === "Right") node.classList.add("e-freezerightborder");
        } else if ((0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(column) === "Fixed") {
            node.classList.add("e-fixedfreeze");
            var cols = this.parent.getColumns();
            var width = 0;
            if (this.parent.getVisibleFrozenLeftCount()) width = this.parent.getIndentCount() * 30;
            else if (this.parent.getFrozenMode() === "Right") width = this.parent.groupSettings.columns.length * 30;
            for(var i = 0; i < cols.length; i++)if (column.index > cols[parseInt(i.toString(), 10)].index) {
                if (cols[parseInt(i.toString(), 10)].freeze === "Left" || cols[parseInt(i.toString(), 10)].isFrozen || cols[parseInt(i.toString(), 10)].freeze === "Fixed") {
                    if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
                }
            }
            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width - 1, this.parent.enableRtl, "Left");
            width = this.parent.getFrozenMode() === "Right" && this.parent.isRowDragable() ? 30 : 0;
            for(var i = cols.length - 1; i >= 0; i--)if (column.index < cols[parseInt(i.toString(), 10)].index) {
                if ((0, $748c2240e597a9b7$export$3289971ebd775b18)(column, cols[parseInt(i.toString(), 10)].uid) || column.index > cols[parseInt(i.toString(), 10)].index) break;
                if (cols[parseInt(i.toString(), 10)].freeze === "Right" || cols[parseInt(i.toString(), 10)].freeze === "Fixed") {
                    if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
                }
            }
            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width - 1, this.parent.enableRtl, "Right");
        } else node.classList.add("e-unfreeze");
        return node;
    };
    return StackedHeaderCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));




var $2381caa4fc4cba7a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * IndentCellRenderer class which responsible for building group indent cell.
 *
 * @hidden
 */ var $2381caa4fc4cba7a$export$93132838e1b9b702 = /** @class */ function(_super) {
    $2381caa4fc4cba7a$var$__extends(IndentCellRenderer, _super);
    function IndentCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TD", {
            className: "e-indentcell"
        });
        return _this;
    }
    /**
     * Function to render the indent cell
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the data
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    IndentCellRenderer.prototype.render = function(cell, data) {
        var node = this.element.cloneNode();
        (0, $748c2240e597a9b7$export$811a58cea531d41d)(node, cell.attributes);
        return node;
    };
    return IndentCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



var $a6192fd4261a3789$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * GroupCaptionCellRenderer class which responsible for building group caption cell.
 *
 * @hidden
 */ var $a6192fd4261a3789$export$b7b473be47286b10 = /** @class */ function(_super) {
    $a6192fd4261a3789$var$__extends(GroupCaptionCellRenderer, _super);
    function GroupCaptionCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cellUid = 0;
        _this.element = _this.parent.createElement("TD", {
            className: "e-groupcaption",
            attrs: {
                id: _this.parent.element.id + "captioncell",
                tabindex: "-1"
            }
        });
        return _this;
    }
    /**
     * Function to render the cell content based on Column object.
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the GroupedData
     * @returns {Element} returns the element
     */ GroupCaptionCellRenderer.prototype.render = function(cell, data) {
        this.element.id = this.parent.element.id + "captioncell" + this.cellUid++;
        var node = this.element.cloneNode();
        var gObj = this.parent;
        var column = cell.column;
        var domSetter = column.getDomSetter ? column.getDomSetter() : "innerHTML";
        var result;
        var fKeyValue;
        var gTemplateValue;
        data.headerText = cell.column.headerText;
        if (cell.isForeignKey) fKeyValue = this.format(cell.column, cell.column.valueAccessor("foreignKey", data, cell.column));
        var value = cell.isForeignKey ? fKeyValue : cell.column.enableGroupByFormat ? data.key : this.format(cell.column, cell.column.valueAccessor("key", data, cell.column));
        for(var j = 0; j < gObj.aggregates.length; j++){
            var _loop_1 = function(i) {
                if (gObj.getVisibleColumns()[0].field === gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].field && gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].groupCaptionTemplate) {
                    var gCaptionTemp = gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].groupCaptionTemplate;
                    if (typeof gCaptionTemp === "string" && gCaptionTemp.includes("$")) gTemplateValue = gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].groupCaptionTemplate.split("$")[0] + data[gObj.getVisibleColumns()[0].field][gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].type] + gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)].groupCaptionTemplate.split("}")[1];
                    else {
                        var column_1 = gObj.aggregates[parseInt(j.toString(), 10)].columns[parseInt(i.toString(), 10)];
                        var tempObj = column_1.getTemplate((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary);
                        var tempID = "";
                        if (!(0, $3EnZW.isNullOrUndefined)(tempObj)) {
                            var tempValue_1 = tempObj.fn(data[column_1.columnName], this_1.parent, tempObj.property, tempID);
                            if (this_1.parent.isReact && typeof column_1.groupCaptionTemplate !== "string") this_1.parent.renderTemplates(function() {
                                if (tempValue_1 && tempValue_1.length) {
                                    if (!(0, $3EnZW.isNullOrUndefined)(gObj.groupSettings.captionTemplate)) node.appendChild(tempValue_1[0]);
                                    else node.innerText += " " + tempValue_1[0].textContent;
                                }
                            });
                            else if (tempValue_1 && tempValue_1.length) {
                                if (!(0, $3EnZW.isNullOrUndefined)(gObj.groupSettings.captionTemplate)) gTemplateValue = tempValue_1;
                                else gTemplateValue = tempValue_1[0].textContent;
                            }
                        }
                    }
                    return "break";
                }
            };
            var this_1 = this;
            for(var i = 0; i < gObj.aggregates[parseInt(j.toString(), 10)].columns.length; i++){
                var state_1 = _loop_1(i);
                if (state_1 === "break") break;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(gObj.groupSettings.captionTemplate)) {
            var isReactCompiler = this.parent.isReact && typeof gObj.groupSettings.captionTemplate !== "string";
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
            if (isReactCompiler || isReactChild) {
                var tempID = gObj.element.id + "captionTemplate";
                (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(gObj.groupSettings.captionTemplate)(data, this.parent, "captionTemplate", tempID, null, null, node);
                this.parent.renderTemplates();
            } else if (this.parent.isVue || gObj.parentDetails && gObj.parentDetails.parentInstObj && gObj.parentDetails.parentInstObj.isVue) result = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(gObj.groupSettings.captionTemplate)(data, this.parent, "captionTemplate", null, null, null, null, gObj.root);
            else result = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(gObj.groupSettings.captionTemplate)(data);
            if (!isReactCompiler && !isReactChild) {
                (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(node, result);
                if (gTemplateValue && gTemplateValue.length && gTemplateValue[0].textContent) node.appendChild(gTemplateValue[0]);
            }
        } else if (gObj.groupSettings.enableLazyLoading) node["" + domSetter] = this.parent.sanitize(cell.column.headerText) + ": " + this.parent.sanitize(value) + (gTemplateValue ? "   " + gTemplateValue : "");
        else node["" + domSetter] = this.parent.sanitize(cell.column.headerText) + ": " + this.parent.sanitize(value) + " - " + data.count + " " + (data.count < 2 ? this.localizer.getConstant("Item") : this.localizer.getConstant("Items")) + (gTemplateValue ? "   " + gTemplateValue : "");
        node.setAttribute("colspan", cell.colSpan.toString());
        node.setAttribute("aria-label", node.innerHTML + this.localizer.getConstant("GroupCaption"));
        node.setAttribute("title", node.textContent);
        return node;
    };
    return GroupCaptionCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));
/**
 * GroupCaptionEmptyCellRenderer class which responsible for building group caption empty cell.
 *
 * @hidden
 */ var $a6192fd4261a3789$export$80df530b32b5c1a8 = /** @class */ function(_super) {
    $a6192fd4261a3789$var$__extends(GroupCaptionEmptyCellRenderer, _super);
    function GroupCaptionEmptyCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TD", {
            className: "e-groupcaption"
        });
        return _this;
    }
    /**
     * Function to render the cell content based on Column object.
     *
     * @param {Cell} cell - specifies the cell
     * @param {Object} data - specifies the Object
     * @param {string} data.field - Defines the field
     * @param {string} data.key - Defines the key
     * @param {number} data.count - Defines the count
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GroupCaptionEmptyCellRenderer.prototype.render = function(cell, data) {
        var node = this.element.cloneNode();
        node.innerHTML = "&nbsp;";
        node.setAttribute("colspan", cell.colSpan.toString());
        return node;
    };
    return GroupCaptionEmptyCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));




var $2db89a8cf740fc95$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * ExpandCellRenderer class which responsible for building group expand cell.
 *
 * @hidden
 */ var $2db89a8cf740fc95$export$61bd913eacefc4ab = /** @class */ function(_super) {
    $2db89a8cf740fc95$var$__extends(ExpandCellRenderer, _super);
    function ExpandCellRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Function to render the expand cell
     *
     * @param {Cell} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @param {string} data.field - Defines the field
     * @param {string} data.key - Defines the key
     * @param {Object} attr - specifies the attribute
     * @param {boolean} isExpand - specifies isexpand
     * @returns {Element} returns the element
     */ ExpandCellRenderer.prototype.render = function(cell, data, attr, isExpand) {
        var node = this.element.cloneNode();
        node.setAttribute("ej-mappingname", data.field);
        node.setAttribute("ej-mappingvalue", data.key);
        node.setAttribute("aria-expanded", isExpand ? "true" : "false");
        node.setAttribute("tabindex", "-1");
        if (this.parent.infiniteScrollSettings && this.parent.infiniteScrollSettings.enableCache && !this.parent.groupSettings.enableLazyLoading) {
            cell.cellType = (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Indent;
            node.className = isExpand ? "e-recordplusexpand e-disablepointer" : "e-recordpluscollapse e-disablepointer";
        } else {
            node.className = isExpand ? "e-recordplusexpand" : "e-recordpluscollapse";
            node.appendChild(this.parent.createElement("a", {
                className: isExpand ? "e-icons e-gdiagonaldown e-icon-gdownarrow" : "e-icons e-gnextforward e-icon-grightarrow",
                attrs: {
                    href: "#",
                    "title": isExpand ? this.localizer.getConstant("Expanded") : this.localizer.getConstant("Collapsed")
                }
            }));
        }
        return node;
    };
    return ExpandCellRenderer;
}((0, $2381caa4fc4cba7a$export$93132838e1b9b702));



var $4393b3d8f06c20f2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * HeaderIndentCellRenderer class which responsible for building header indent cell.
 *
 * @hidden
 */ var $4393b3d8f06c20f2$export$e465f05cc739f565 = /** @class */ function(_super) {
    $4393b3d8f06c20f2$var$__extends(HeaderIndentCellRenderer, _super);
    function HeaderIndentCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-grouptopleftcell"
        });
        return _this;
    }
    /**
     * Function to render the indent cell
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the data
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HeaderIndentCellRenderer.prototype.render = function(cell, data) {
        var node = this.element.cloneNode();
        node.appendChild(this.parent.createElement("div", {
            className: "e-headercelldiv e-emptycell",
            innerHTML: ""
        }));
        return node;
    };
    return HeaderIndentCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));



var $7012dd1706b509fe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * DetailHeaderIndentCellRenderer class which responsible for building detail header indent cell.
 *
 * @hidden
 */ var $7012dd1706b509fe$export$ec45019db5492d93 = /** @class */ function(_super) {
    $7012dd1706b509fe$var$__extends(DetailHeaderIndentCellRenderer, _super);
    function DetailHeaderIndentCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-detailheadercell"
        });
        return _this;
    }
    /**
     * Function to render the detail indent cell
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the data
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DetailHeaderIndentCellRenderer.prototype.render = function(cell, data) {
        var node = this.element.cloneNode();
        node.appendChild(this.parent.createElement("div", {
            className: "e-emptycell"
        }));
        return node;
    };
    return DetailHeaderIndentCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

var $86030f57de34892f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * ExpandCellRenderer class which responsible for building group expand cell.
 *
 * @hidden
 */ var $86030f57de34892f$export$9fb1641b3f8f5140 = /** @class */ function(_super) {
    $86030f57de34892f$var$__extends(DetailExpandCellRenderer, _super);
    function DetailExpandCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TD", {
            className: "e-detailrowcollapse",
            attrs: {
                "aria-expanded": "false",
                tabindex: "-1"
            }
        });
        return _this;
    }
    /**
     * Function to render the detail expand cell
     *
     * @param {Cell<Column>} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @param {Object} attributes - specifies the attributes
     * @returns {Element} returns the element
     */ DetailExpandCellRenderer.prototype.render = function(cell, data, attributes) {
        var node = this.element.cloneNode();
        if (attributes && !(0, $3EnZW.isNullOrUndefined)(attributes["class"])) {
            node.className = "";
            node.className = attributes["class"];
            node.appendChild(this.parent.createElement("a", {
                className: "e-icons e-dtdiagonaldown e-icon-gdownarrow",
                attrs: {
                    href: "#",
                    "title": this.localizer.getConstant("Expanded")
                }
            }));
        } else node.appendChild(this.parent.createElement("a", {
            className: "e-icons e-dtdiagonalright e-icon-grightarrow",
            attrs: {
                href: "#",
                "title": this.localizer.getConstant("Collapsed")
            }
        }));
        if (cell.isSelected) node.classList.add("e-selectionbackground", "e-active");
        return node;
    };
    return DetailExpandCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));




var $39056b56ca84927f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * ExpandCellRenderer class which responsible for building group expand cell.
 *
 * @hidden
 */ var $39056b56ca84927f$export$be74257ce5600364 = /** @class */ function(_super) {
    $39056b56ca84927f$var$__extends(RowDragDropRenderer, _super);
    function RowDragDropRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TD", {
            className: "e-rowdragdrop e-rowdragdropcell",
            attrs: {
                tabindex: "-1",
                role: "gridcell"
            }
        });
        return _this;
    }
    /**
     * Function to render the detail expand cell
     *
     * @param {Cell<Column>} cell - specifies the cell
     * @param {Object} data - specifies the data
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RowDragDropRenderer.prototype.render = function(cell, data) {
        var nodeElement = this.element.cloneNode();
        nodeElement.appendChild(this.parent.createElement("div", {
            className: "e-icons e-rowcelldrag e-dtdiagonalright e-icon-rowdragicon",
            attrs: {
                "aria-hidden": "true"
            }
        }));
        if (cell.isSelected) {
            nodeElement.classList.add("e-selectionbackground");
            nodeElement.classList.add("e-active");
        }
        if (this.parent.getVisibleFrozenRightCount() || this.parent.getVisibleFrozenLeftCount()) {
            nodeElement.classList.add("e-leftfreeze");
            var width = this.parent.getFrozenMode() === "Right" ? 0 : this.parent.groupSettings.columns.length * 30;
            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(nodeElement, width, this.parent.enableRtl, this.parent.getFrozenMode() === "Right" ? "Right" : "Left");
        }
        return nodeElement;
    };
    return RowDragDropRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");


var $61338fc3d15be771$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * DetailHeaderIndentCellRenderer class which responsible for building detail header indent cell.
 *
 * @hidden
 */ var $61338fc3d15be771$export$c6f30b6cf2856f51 = /** @class */ function(_super) {
    $61338fc3d15be771$var$__extends(RowDragDropHeaderRenderer, _super);
    function RowDragDropHeaderRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-rowdragheader"
        });
        return _this;
    }
    /**
     * Function to render the detail indent cell
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the data
     * @returns {Element} returns the element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RowDragDropHeaderRenderer.prototype.render = function(cell, data) {
        var node = this.element.cloneNode();
        node.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-emptycell"
        }));
        if (this.parent.getVisibleFrozenRightCount() || this.parent.getVisibleFrozenLeftCount()) {
            node.classList.add("e-leftfreeze");
            var width = this.parent.getFrozenMode() === "Right" ? 0 : this.parent.groupSettings.columns.length * 30;
            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width, this.parent.enableRtl, this.parent.getFrozenMode() === "Right" ? "Right" : "Left");
        }
        return node;
    };
    return RowDragDropHeaderRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));



/**
 * Content module is used to render grid content
 *
 * @hidden
 */ var $f586be72c61d2967$export$160ae30d75f98247 = /** @class */ function() {
    /**
     * Constructor for render module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} locator - specifies the serviceLocator
     */ function Render(parent, locator) {
        this.emptyGrid = false;
        this.counter = 0;
        this.parent = parent;
        this.locator = locator;
        this.data = new (0, $2c6cbc1793f29e30$export$2d0294657ab35f1b)(parent, locator);
        this.l10n = locator.getService("localization");
        this.ariaService = this.locator.getService("ariaService");
        this.renderer = this.locator.getService("rendererFactory");
        this.addEventListener();
    }
    /**
     * To initialize grid header, content and footer rendering
     *
     * @returns {void}
     */ Render.prototype.render = function() {
        var gObj = this.parent;
        this.headerRenderer = this.renderer.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header);
        this.contentRenderer = this.renderer.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content);
        this.headerRenderer.renderPanel();
        this.contentRenderer.renderPanel();
        if (gObj.getColumns().length) {
            this.isLayoutRendered = true;
            this.headerRenderer.renderTable();
            this.contentRenderer.renderTable();
            this.emptyRow(false);
        }
        this.parent.scrollModule.setWidth();
        this.parent.scrollModule.setHeight();
        if (this.parent.height !== "auto") this.parent.scrollModule.setPadding();
        this.refreshDataManager();
    };
    /**
     * Refresh the entire Grid.
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     */ Render.prototype.refresh = function(e) {
        var _this = this;
        if (e === void 0) e = {
            requestType: "refresh"
        };
        var gObj = this.parent;
        gObj.notify(e.requestType + "-begin", e);
        gObj.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, e, function(args) {
            if (args === void 0) args = {
                requestType: "refresh"
            };
            if (args.cancel) {
                gObj.notify($17b89d3b1fc93cdb$export$13b99c0e226e6ca4, args);
                if (args.action === "clearFilter" && _this.parent.filterSettings.type === "Menu") {
                    _this.parent.filterSettings.columns[_this.parent.filterModule.filterObjIndex] = _this.parent.filterModule.prevFilterObject;
                    var iconClass = _this.parent.showColumnMenu && _this.parent.filterModule["column"].showColumnMenu ? ".e-columnmenu" : ".e-icon-filter";
                    var col = _this.parent.element.querySelector('[e-mappinguid="' + _this.parent.filterModule["column"].uid + '"]').parentElement;
                    var flIcon = col.querySelector(iconClass);
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.filterModule.prevFilterObject)) flIcon.classList.add("e-filtered");
                }
                if (args.action === "clear-filter" && (_this.parent.filterSettings.type === "CheckBox" || _this.parent.filterSettings.type === "Excel")) _this.parent.filterSettings.columns = _this.parent.filterModule.checkboxPrevFilterObject;
                if (args.requestType === "grouping") {
                    // Remove the dropped column name from groupsettings.columns if args.cancel is true
                    var index = gObj.groupSettings.columns.indexOf(args.columnName);
                    if (index !== -1) {
                        gObj.setProperties({
                            groupSettings: {
                                Columns: gObj.groupSettings.columns.splice(index, 1)
                            }
                        }, true);
                        gObj.setProperties({
                            sortSettings: {
                                Columns: gObj.sortSettings.columns.splice(index, 1)
                            }
                        }, true);
                        var column = gObj.getColumnByField(args.columnName);
                        var headerCell = gObj.getColumnHeaderByField(column.field);
                        column.visible = !(0, $3EnZW.isNullOrUndefined)(headerCell) && !headerCell.classList.contains("e-hide");
                    }
                }
                return;
            }
            if (gObj.allowSelection && (args.action === "clearFilter" || args.action === "clear-filter" || args.requestType === "searching" && args.searchString === "" || args.action === "add")) gObj.selectionModule["rmtHdrChkbxClicked"] = false;
            if (gObj.allowPaging && gObj.pageSettings.pageSizes && gObj.pagerModule.pagerObj.isAllPage && args.action === "add" && args.requestType === "save" && gObj.pagerModule.pagerObj.checkAll) gObj.setProperties({
                pageSettings: {
                    pageSize: gObj.pageSettings.pageSize + 1
                }
            }, true);
            if (args.requestType === "delete" && gObj.allowPaging) {
                var dataLength = args.data.length;
                var count = gObj.pageSettings.totalRecordsCount - dataLength;
                var currentViewData = gObj.getCurrentViewRecords().length;
                // eslint-disable-next-line max-len
                if (!(currentViewData - dataLength) && count && (gObj.pageSettings.currentPage - 1) * gObj.pageSettings.pageSize === count || count && count <= dataLength) {
                    gObj.prevPageMoving = true;
                    gObj.setProperties({
                        pageSettings: {
                            totalRecordsCount: count,
                            currentPage: Math.ceil(count / gObj.pageSettings.pageSize)
                        }
                    }, true);
                    gObj.pagerModule.pagerObj.totalRecordsCount = count;
                }
            }
            if (args.requestType === "reorder" && _this.parent.dataSource && "result" in _this.parent.dataSource) _this.contentRenderer.refreshContentRows(args);
            else if ((args.requestType === "paging" || args.requestType === "columnstate" || args.requestType === "reorder") && _this.parent.groupSettings.enableLazyLoading && _this.parent.groupSettings.columns.length && (_this.parent.enableVirtualization ? _this.parent.lazyLoadRender : _this.parent.contentModule).getGroupCache()[_this.parent.pageSettings.currentPage]) _this.contentRenderer.refreshContentRows(args);
            else _this.refreshDataManager(args);
        });
    };
    /**
     * @returns {void}
     * @hidden
     */ Render.prototype.resetTemplates = function() {
        var gObj = this.parent;
        var gridColumns = gObj.getColumns();
        if (gObj.detailTemplate) {
            var detailTemplateID = gObj.element.id + "detailTemplate";
            (0, $c2qqN.blazorTemplates)["" + detailTemplateID] = [];
            (0, $c2qqN.resetBlazorTemplate)(detailTemplateID, "DetailTemplate");
        }
        if (gObj.groupSettings.captionTemplate) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + "captionTemplate", "CaptionTemplate");
        if (gObj.rowTemplate) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + "rowTemplate", "RowTemplate");
        if (gObj.toolbarTemplate) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + "toolbarTemplate", "ToolbarTemplate");
        if (gObj.pageSettings.template) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + "_template", "pageSettings");
        for(var i = 0; i < gridColumns.length; i++){
            if (gridColumns[parseInt(i.toString(), 10)].template) {
                (0, $c2qqN.blazorTemplates)[gObj.element.id + gridColumns[parseInt(i.toString(), 10)].uid] = [];
                (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + gridColumns[parseInt(i.toString(), 10)].uid, "Template");
            }
            if (gridColumns[parseInt(i.toString(), 10)].headerTemplate) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + gridColumns[parseInt(i.toString(), 10)].uid + "headerTemplate", "HeaderTemplate");
            if (gridColumns[parseInt(i.toString(), 10)].filterTemplate) (0, $c2qqN.resetBlazorTemplate)(gObj.element.id + gridColumns[parseInt(i.toString(), 10)].uid + "filterTemplate", "FilterTemplate");
        }
        var guid = "guid";
        for(var k = 0; k < gObj.aggregates.length; k++)for(var j = 0; j < gObj.aggregates[parseInt(k.toString(), 10)].columns.length; j++){
            if (gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)].footerTemplate) {
                var tempID = gObj.element.id + gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)]["" + guid] + "footerTemplate";
                (0, $c2qqN.resetBlazorTemplate)(tempID, "FooterTemplate");
            }
            if (gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)].groupFooterTemplate) {
                var tempID = gObj.element.id + gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)]["" + guid] + "groupFooterTemplate";
                (0, $c2qqN.resetBlazorTemplate)(tempID, "GroupFooterTemplate");
            }
            if (gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)].groupCaptionTemplate) {
                var tempID = gObj.element.id + gObj.aggregates[parseInt(k.toString(), 10)].columns[parseInt(j.toString(), 10)]["" + guid] + "groupCaptionTemplate";
                (0, $c2qqN.resetBlazorTemplate)(tempID, "GroupCaptionTemplate");
            }
        }
    };
    Render.prototype.refreshComplete = function(e) {
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, e);
    };
    /**
     * The function is used to refresh the dataManager
     *
     * @param {NotifyArgs} args - specifies the args
     * @returns {void}
     */ Render.prototype.refreshDataManager = function(args) {
        var _this = this;
        if (args === void 0) args = {};
        var gObj = this.parent;
        var maskRow = gObj.loadingIndicator.indicatorType === "Shimmer" && args.requestType !== "virtualscroll" && args.requestType !== "infiniteScroll" || (args.requestType === "virtualscroll" || args.requestType === "infiniteScroll") && gObj.enableVirtualMaskRow;
        if (args.requestType !== "virtualscroll" && !args.isCaptionCollapse && !maskRow) this.parent.showSpinner();
        if (maskRow) gObj.showMaskRow(args.requestType === "virtualscroll" ? args.virtualInfo.sentinelInfo.axis : args.requestType === "infiniteScroll" ? args.direction : undefined);
        this.parent.notify($17b89d3b1fc93cdb$export$795a13a52b6b60d3, args);
        this.emptyGrid = false;
        var dataManager;
        var isFActon = this.isNeedForeignAction();
        this.ariaService.setBusy(this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb), true);
        if (isFActon) {
            var deffered = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
            dataManager = this.getFData(deffered, args);
        }
        if (!dataManager) {
            if (gObj.allowPaging && !gObj.getDataModule().dataManager.dataSource.offline && gObj.pageSettings && gObj.pageSettings.pageSizes && gObj.pagerModule && gObj.pagerModule.pagerObj && gObj.pagerModule.pagerObj.isAllPage) gObj.pagerModule.pagerObj.isAllPage = undefined;
            dataManager = this.data.getData(args, this.data.generateQuery().requiresCount());
        } else // eslint-disable-next-line @typescript-eslint/no-unused-vars
        dataManager = dataManager.then(function(e) {
            var query = _this.data.generateQuery().requiresCount();
            if (_this.emptyGrid) {
                var def = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
                def.resolve({
                    result: [],
                    count: 0
                });
                return def.promise;
            }
            return _this.data.getData(args, query);
        });
        var foreignKeyColumns = this.parent.getForeignKeyColumns();
        var foreignKeyLength = foreignKeyColumns.length;
        if (this.parent.columnQueryMode === "ExcludeHidden" && foreignKeyLength) foreignKeyLength = foreignKeyColumns.filter(function(col) {
            return col.visible !== false;
        }).length;
        if (foreignKeyLength && (!isFActon || this.parent.searchSettings.key.length)) {
            var deffered_1 = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
            dataManager = dataManager.then(function(e) {
                _this.parent.notify($17b89d3b1fc93cdb$export$8c378ad6a18d0e6f, {
                    dataManager: dataManager,
                    result: e,
                    promise: deffered_1,
                    action: args
                });
                return deffered_1.promise;
            });
        }
        if (this.parent.groupSettings.disablePageWiseAggregates && this.parent.groupSettings.columns.length) dataManager = dataManager.then(function(e) {
            return _this.validateGroupRecords(e);
        });
        dataManager.then(function(e) {
            return _this.dataManagerSuccess(e, args);
        }).catch(function(e) {
            return _this.dataManagerFailure(e, args);
        });
    };
    Render.prototype.getFData = function(deferred, args) {
        this.parent.notify($17b89d3b1fc93cdb$export$8c378ad6a18d0e6f, {
            isComplex: true,
            promise: deferred,
            action: args
        });
        return deferred.promise;
    };
    Render.prototype.isNeedForeignAction = function() {
        var gObj = this.parent;
        return !!(gObj.allowFiltering && gObj.filterSettings.columns.length || !(0, $3EnZW.isNullOrUndefined)(gObj.searchSettings.key) && gObj.searchSettings.key.length) && this.foreignKey(this.parent.getForeignKeyColumns());
    };
    Render.prototype.foreignKey = function(columns) {
        var _this = this;
        return columns.some(function(col) {
            var fbool = false;
            fbool = _this.parent.filterSettings.columns.some(function(value) {
                return col.uid === value.uid;
            });
            return !!(fbool || _this.parent.searchSettings.key.length);
        });
    };
    Render.prototype.sendBulkRequest = function(args) {
        var _this = this;
        args.requestType = "batchsave";
        var gObj = this.parent;
        if (gObj.allowPaging && gObj.pageSettings.pageSizes && gObj.pagerModule.pagerObj.isAllPage && gObj.pagerModule.pagerObj.checkAll) {
            var dataLength = args["changes"].addedRecords.length;
            if (dataLength) gObj.setProperties({
                pageSettings: {
                    pageSize: gObj.pageSettings.pageSize + dataLength
                }
            }, true);
        }
        if (gObj.allowPaging && (args.changes.addedRecords.length || args.changes.deletedRecords.length || args.changes.changedRecords.length) && gObj.pageSettings && gObj.pageSettings.pageSizes && gObj.pagerModule && gObj.pagerModule.pagerObj && !gObj.getDataModule().dataManager.dataSource.offline && gObj.pagerModule.pagerObj.isAllPage) gObj.pagerModule.pagerObj.isAllPage = undefined;
        var promise = this.data.saveChanges(args.changes, this.parent.getPrimaryKeyFieldNames()[0], args.original);
        var query = this.data.generateQuery().requiresCount();
        if (this.data.dataManager.dataSource.offline) {
            this.refreshDataManager({
                requestType: "batchsave"
            });
            return;
        } else // eslint-disable-next-line @typescript-eslint/no-unused-vars
        promise.then(function(e) {
            _this.data.getData(args, query).then(function(e) {
                return _this.dmSuccess(e, args);
            }).catch(function(e) {
                return _this.dmFailure(e, args);
            });
        }).catch(function(e) {
            return _this.dmFailure(e, args);
        });
    };
    Render.prototype.dmSuccess = function(e, args) {
        this.dataManagerSuccess(e, args);
    };
    Render.prototype.dmFailure = function(e, args) {
        this.dataManagerFailure(e, args);
    };
    /**
     * Render empty row to Grid which is used at the time to represent to no records.
     *
     * @returns {void}
     * @hidden
     */ Render.prototype.renderEmptyRow = function() {
        this.emptyRow(true);
    };
    Render.prototype.emptyRow = function(isTrigger) {
        var gObj = this.parent;
        var tbody = this.contentRenderer.getTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        if (!(0, $3EnZW.isNullOrUndefined)(tbody)) (0, $4ZDHT.remove)(tbody);
        tbody = this.parent.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
            attrs: {
                role: "rowgroup"
            }
        });
        var spanCount = gObj.allowRowDragAndDrop && (0, $3EnZW.isNullOrUndefined)(gObj.rowDropSettings.targetID) ? 1 : 0;
        if (gObj.detailTemplate || gObj.childGrid) ++spanCount;
        var className = gObj.editSettings.showAddNewRow && gObj.editSettings.newRowPosition === "Bottom" ? "e-emptyrow e-show-added-row" : "e-emptyrow";
        var tr = this.parent.createElement("tr", {
            className: className,
            attrs: {
                role: "row"
            }
        });
        var td;
        if (gObj.emptyRecordTemplate) {
            var emptyRecordTemplateID = gObj.element.id + "emptyRecordTemplate";
            td = this.parent.createElement("td", {
                attrs: {
                    colspan: (gObj.getVisibleColumns().length + spanCount + gObj.groupSettings.columns.length).toString()
                }
            });
            if (gObj.isVue || gObj.parentDetails && gObj.parentDetails.parentInstObj && gObj.parentDetails.parentInstObj.isVue) td.appendChild(gObj.getEmptyRecordTemplate()(gObj.dataSource, gObj, "emptyRecordTemplate", emptyRecordTemplateID, undefined, undefined, undefined, this.parent["root"])[1]);
            else td.appendChild(gObj.getEmptyRecordTemplate()(gObj.dataSource, gObj, "emptyRecordTemplate", emptyRecordTemplateID, undefined, undefined, undefined, this.parent["root"])[0]);
            if (gObj.isReact) this.parent.renderTemplates();
        } else td = this.parent.createElement("td", {
            innerHTML: this.l10n.getConstant("EmptyRecord"),
            attrs: {
                colspan: (gObj.getVisibleColumns().length + spanCount + (!(0, $3EnZW.isNullOrUndefined)(gObj.groupSettings.columns) ? gObj.groupSettings.columns.length : 0)).toString()
            }
        });
        if (gObj.isFrozenGrid()) {
            td.classList.add("e-leftfreeze");
            td.style.left = "0px";
        }
        if (gObj.frozenRows && gObj.element.querySelector(".e-frozenrow-border")) this.parent.element.querySelector(".e-frozenrow-border").classList.add("e-frozenrow-empty");
        tr.appendChild(td);
        tbody.appendChild(tr);
        this.contentRenderer.renderEmpty(tbody);
        if (isTrigger) {
            if (!this.parent.isInitialLoad) this.parent.focusModule.setFirstFocusableTabIndex();
            this.parent.trigger($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, {});
            this.parent.notify($17b89d3b1fc93cdb$export$63287e93462800a4, {
                rows: [
                    new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)({
                        isDataRow: true,
                        cells: [
                            new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)({
                                isDataCell: true,
                                visible: true
                            })
                        ]
                    })
                ]
            });
            if (gObj.editSettings.showAddNewRow) {
                gObj.addRecord();
                this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
            }
        }
    };
    Render.prototype.dynamicColumnChange = function() {
        if (this.parent.getCurrentViewRecords().length) this.updateColumnType(this.parent.getCurrentViewRecords()[0]);
    };
    Render.prototype.updateColumnType = function(record) {
        var columns = this.parent.getColumns();
        var value;
        var cFormat = "customFormat";
        var equalTo = "equalTo";
        var data = record && record.items ? record.items[0] : record;
        var fmtr = this.locator.getService("valueFormatter");
        for(var i = 0, len = columns.length; i < len; i++){
            value = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(columns[parseInt(i.toString(), 10)].field || "", data);
            if (!(0, $3EnZW.isNullOrUndefined)(columns[parseInt(i.toString(), 10)]["" + cFormat])) columns[parseInt(i.toString(), 10)].format = columns[parseInt(i.toString(), 10)]["" + cFormat];
            if (!(0, $3EnZW.isNullOrUndefined)(columns[parseInt(i.toString(), 10)].validationRules) && !(0, $3EnZW.isNullOrUndefined)(columns[parseInt(i.toString(), 10)].validationRules["" + equalTo])) columns[parseInt(i.toString(), 10)].validationRules["" + equalTo][0] = this.parent.element.id + columns[parseInt(i.toString(), 10)].validationRules["" + equalTo][0];
            if (columns[parseInt(i.toString(), 10)].isForeignColumn() && columns[parseInt(i.toString(), 10)].columnData) value = (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(columns[parseInt(i.toString(), 10)].foreignKeyValue || "", columns[parseInt(i.toString(), 10)].columnData[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(value)) {
                this.isColTypeDef = true;
                if (!columns[parseInt(i.toString(), 10)].type) columns[parseInt(i.toString(), 10)].type = value.getDay ? value.getHours() > 0 || value.getMinutes() > 0 || value.getSeconds() > 0 || value.getMilliseconds() > 0 ? "datetime" : "date" : typeof value;
            } else columns[parseInt(i.toString(), 10)].type = columns[parseInt(i.toString(), 10)].type || null;
            var valueFormatter = new (0, $52aed6227a4600c2$export$4ad21d94aae28a17)();
            if (columns[parseInt(i.toString(), 10)].format && (columns[parseInt(i.toString(), 10)].format.skeleton || columns[parseInt(i.toString(), 10)].format.format && typeof columns[parseInt(i.toString(), 10)].format.format === "string")) {
                columns[parseInt(i.toString(), 10)].setFormatter(valueFormatter.getFormatFunction((0, $3EnZW.extend)({}, columns[parseInt(i.toString(), 10)].format)));
                columns[parseInt(i.toString(), 10)].setParser(valueFormatter.getParserFunction(columns[parseInt(i.toString(), 10)].format));
            }
            if (typeof columns[parseInt(i.toString(), 10)].format === "string") (0, $748c2240e597a9b7$export$1986f8c9221d3ee2)(this.locator, columns[parseInt(i.toString(), 10)]);
            else if (!columns[parseInt(i.toString(), 10)].format && columns[parseInt(i.toString(), 10)].type === "number") columns[parseInt(i.toString(), 10)].setParser(fmtr.getParserFunction({
                format: "n2"
            }));
            if (columns[parseInt(i.toString(), 10)].type === "dateonly" && !columns[parseInt(i.toString(), 10)].format) {
                columns[parseInt(i.toString(), 10)].format = "yMd";
                (0, $748c2240e597a9b7$export$1986f8c9221d3ee2)(this.locator, columns[parseInt(i.toString(), 10)]);
            }
        }
    };
    /**
     * @param {ReturnType} e - specifies the return type
     * @param {NotifyArgs} args - specifies the Notifyargs
     * @returns {void}
     * @hidden
     */ // tslint:disable-next-line:max-func-body-length
    Render.prototype.dataManagerSuccess = function(e, args) {
        var _this = this;
        var gObj = this.parent;
        this.contentRenderer = this.renderer.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content);
        this.headerRenderer = this.renderer.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header);
        e.actionArgs = args;
        var isInfiniteDelete = this.parent.enableInfiniteScrolling && !this.parent.infiniteScrollSettings.enableCache && !gObj.groupSettings.enableLazyLoading && (args.requestType === "delete" || args.requestType === "save" && this.parent.infiniteScrollModule.requestType === "add" && !(gObj.sortSettings.columns.length || gObj.filterSettings.columns.length || this.parent.groupSettings.columns.length || gObj.searchSettings.key));
        // tslint:disable-next-line:max-func-body-length
        gObj.trigger($17b89d3b1fc93cdb$export$b59f29322b4450c6, e, function(dataArgs) {
            if (dataArgs.cancel) return;
            dataArgs.result = (0, $3EnZW.isNullOrUndefined)(dataArgs.result) ? [] : dataArgs.result;
            var len = Object.keys(dataArgs.result).length;
            if (_this.parent.isDestroyed) return;
            if (!gObj.getColumns().length && !len && !(gObj.columns.length && gObj.columns[0] instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc))) {
                gObj.hideSpinner();
                return;
            }
            if (_this.isInfiniteEnd(args) && !len) {
                _this.parent.notify($17b89d3b1fc93cdb$export$b3a2f7adafd2c20, {
                    e: args,
                    result: e.result,
                    count: e.count,
                    agg: e.aggregates
                });
                return;
            }
            _this.parent.isEdit = false;
            _this.parent.notify($17b89d3b1fc93cdb$export$82a793dcb3807178, {});
            _this.parent.notify($17b89d3b1fc93cdb$export$7edde809d061e, {});
            if (args && !((args.requestType === "infiniteScroll" || args.requestType === "delete" || args.action === "add") && gObj.enableInfiniteScrolling)) _this.parent.notify($17b89d3b1fc93cdb$export$f7916aff5645ab3f, {
                type: "refreshCommandColumn"
            });
            _this.contentRenderer.prevCurrentView = !(0, $3EnZW.isNullOrUndefined)(_this.parent.currentViewData) && _this.parent.currentViewData.slice();
            gObj.currentViewData = dataArgs.result;
            gObj.notify($17b89d3b1fc93cdb$export$26c30b44f2e7f30d, {
                args: args,
                data: dataArgs.result
            });
            if (dataArgs.count && !gObj.allowPaging && (gObj.enableVirtualization || gObj.enableInfiniteScrolling)) gObj.totalDataRecordsCount = dataArgs.count;
            if (!len && dataArgs.count && gObj.allowPaging && args && args.requestType !== "delete") {
                if (_this.parent.groupSettings.enableLazyLoading && (args.requestType === "grouping" || args.requestType === "ungrouping")) _this.parent.notify($17b89d3b1fc93cdb$export$45acafeece38b8a2, args);
                gObj.prevPageMoving = true;
                gObj.pageSettings.totalRecordsCount = dataArgs.count;
                if (args.requestType !== "paging") gObj.pageSettings.currentPage = Math.ceil(dataArgs.count / gObj.pageSettings.pageSize);
                gObj.dataBind();
                return;
            }
            if ((!gObj.getColumns().length && len || !_this.isLayoutRendered) && !(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) {
                gObj.removeMaskRow();
                _this.updatesOnInitialRender(dataArgs);
            }
            if (!_this.isColTypeDef && gObj.getCurrentViewRecords()) {
                if (_this.data.dataManager.dataSource.offline && gObj.dataSource && gObj.dataSource.length) _this.updateColumnType(gObj.dataSource[0]);
                else _this.updateColumnType(gObj.getCurrentViewRecords()[0]);
            }
            if (!_this.parent.isInitialLoad && _this.parent.groupSettings.disablePageWiseAggregates && !_this.parent.groupSettings.columns.length) dataArgs.result = _this.parent.dataSource instanceof Array ? _this.parent.dataSource : _this.parent.currentViewData;
            if ((_this.parent.isReact || _this.parent.isVue) && !(0, $3EnZW.isNullOrUndefined)(args) && args.requestType !== "infiniteScroll" && !args.isFrozen) (0, $748c2240e597a9b7$export$d9aeb73a9e271813)(_this.parent, [
                "footerTemplate"
            ]);
            if (_this.parent.isAngular && _this.parent.allowGrouping && _this.parent.groupSettings.captionTemplate && !(!(0, $3EnZW.isNullOrUndefined)(args) && args.requestType === "infiniteScroll")) _this.parent.destroyTemplate([
                "groupSettings_captionTemplate"
            ]);
            _this.parent.notify($17b89d3b1fc93cdb$export$32ed53e78850bc76, (0, $3EnZW.extend)({
                count: dataArgs.count,
                result: dataArgs.result,
                aggregates: dataArgs.aggregates,
                loadSummaryOnEmpty: false
            }, args));
            if ((gObj.groupSettings.columns.length || args && args.requestType === "ungrouping") && args && args.requestType !== "filtering") _this.headerRenderer.refreshUI();
            if (len) {
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) {
                    var content = "content";
                    args.scrollTop = {
                        top: _this.contentRenderer["" + content].scrollTop
                    };
                }
                if (!isInfiniteDelete) {
                    if (_this.parent.enableImmutableMode) _this.contentRenderer.immutableModeRendering(args);
                    else _this.contentRenderer.refreshContentRows(args);
                } else _this.parent.notify($17b89d3b1fc93cdb$export$b3a2f7adafd2c20, {
                    e: args,
                    result: e.result,
                    count: e.count,
                    agg: e.aggregates
                });
            } else {
                if (args && args.isCaptionCollapse) return;
                if (!gObj.getColumns().length) {
                    gObj.element.innerHTML = "";
                    alert(_this.l10n.getConstant("EmptyDataSourceError")); //ToDO: change this alert as dialog
                    return;
                }
                _this.contentRenderer.setRowElements([]);
                _this.contentRenderer.setRowObjects([]);
                _this.ariaService.setBusy(_this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb), false);
                gObj.removeMaskRow();
                _this.renderEmptyRow();
                if (gObj.enableColumnVirtualization && !len) _this.parent.notify($17b89d3b1fc93cdb$export$f44d9209b353bf3e, {
                    rows: gObj.getRowsObject(),
                    args: {}
                });
                if (args) {
                    var action = (args.requestType || "").toLowerCase() + "-complete";
                    _this.parent.notify(action, args);
                    if (args.requestType === "batchsave") {
                        args.cancel = false;
                        args.rows = [];
                        args.isFrozen = !args.isFrozen;
                        _this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, args);
                    }
                }
                if (_this.parent.autoFit) _this.parent.preventAdjustColumns();
                _this.parent.hideSpinner();
            }
            _this.parent.notify($17b89d3b1fc93cdb$export$6a017cfaa3b33c68, {});
            _this.setRowCount(_this.parent.getCurrentViewRecords().length);
            if ("query" in e) _this.parent.getDataModule().isQueryInvokedFromData = false;
        });
    };
    /**
     * @param {object} e - specifies the object
     * @param {Object[]} e.result - specifies the result
     * @param {NotifyArgs} args - specifies the args
     * @returns {void}
     * @hidden
     */ Render.prototype.dataManagerFailure = function(e, args) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.contentModule)) {
            this.ariaService.setOptions(this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb), {
                busy: false,
                invalid: true
            });
            this.setRowCount(1);
        }
        this.parent.trigger($17b89d3b1fc93cdb$export$6df5a05f342711e3, {
            error: e
        });
        this.parent.hideSpinner();
        this.parent.removeMaskRow();
        if (args.requestType === "save" || args.requestType === "delete" || args.name === "bulk-save") return;
        this.parent.currentViewData = [];
        this.renderEmptyRow();
        if (!this.parent.isInitialLoad) this.parent.focusModule.setFirstFocusableTabIndex();
        this.parent.log("actionfailure", {
            error: e
        });
    };
    Render.prototype.setRowCount = function(dataRowCount) {
        this.ariaService.setOptions(this.parent.element, {
            rowcount: dataRowCount ? dataRowCount.toString() : "1"
        });
    };
    Render.prototype.isInfiniteEnd = function(args) {
        return this.parent.enableInfiniteScrolling && !this.parent.infiniteScrollSettings.enableCache && args.requestType === "delete";
    };
    Render.prototype.updatesOnInitialRender = function(e) {
        this.isLayoutRendered = true;
        var isEmptyCol = false;
        if (this.parent.columns.length < 1) {
            this.buildColumns(e.result[0]);
            isEmptyCol = true;
        }
        (0, $748c2240e597a9b7$export$1147582dfae658c6)(this.parent.columns, null, this.parent);
        if (isEmptyCol) this.parent.notify($17b89d3b1fc93cdb$export$6c0bde196efce5fe, {});
        this.headerRenderer.renderTable();
        this.contentRenderer.renderTable();
        this.parent.isAutoGen = true;
        this.parent.notify($17b89d3b1fc93cdb$export$bb86da570a7327af, {});
    };
    Render.prototype.iterateComplexColumns = function(obj, field, split) {
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length; i++){
            var childKeys = typeof obj[keys[parseInt(i.toString(), 10)]] === "object" && obj[keys[parseInt(i.toString(), 10)]] && !(obj[keys[parseInt(i.toString(), 10)]] instanceof Date) ? Object.keys(obj[keys[parseInt(i.toString(), 10)]]) : [];
            if (childKeys.length) this.iterateComplexColumns(obj[keys[parseInt(i.toString(), 10)]], field + (keys[parseInt(i.toString(), 10)] + "."), split);
            else {
                split[this.counter] = field + keys[parseInt(i.toString(), 10)];
                this.counter++;
            }
        }
    };
    Render.prototype.buildColumns = function(record) {
        var cols = [];
        var complexCols = {};
        this.iterateComplexColumns(record, "", complexCols);
        var columns = Object.keys(complexCols).filter(function(e) {
            return complexCols["" + e] !== "BlazId";
        }).map(function(field) {
            return complexCols["" + field];
        });
        for(var i = 0, len = columns.length; i < len; i++){
            cols[parseInt(i.toString(), 10)] = {
                "field": columns[parseInt(i.toString(), 10)]
            };
            if (this.parent.enableColumnVirtualization) cols[parseInt(i.toString(), 10)].width = !(0, $3EnZW.isNullOrUndefined)(cols[parseInt(i.toString(), 10)].width) ? cols[parseInt(i.toString(), 10)].width : 200;
        }
        this.parent.setProperties({
            "columns": cols
        }, true);
    };
    Render.prototype.instantiateRenderer = function() {
        this.renderer.addRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header, new (0, $837013bb596bf019$export$83fd0f90b83678b1)(this.parent, this.locator));
        this.renderer.addRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content, new (0, $c2232dcd2e373cda$export$6e65718da26e0698)(this.parent, this.locator));
        var cellrender = this.locator.getService("cellRendererFactory");
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header, new (0, $138c77c0bef20541$export$84ffe2c521da4c06)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data, new (0, $e992c1409d919677$export$efe8300dd67deed4)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader, new (0, $b24f3c4bfad11a8f$export$e989b059caa4681f)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Indent, new (0, $2381caa4fc4cba7a$export$93132838e1b9b702)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaption, new (0, $a6192fd4261a3789$export$b7b473be47286b10)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaptionEmpty, new (0, $a6192fd4261a3789$export$80df530b32b5c1a8)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Expand, new (0, $2db89a8cf740fc95$export$61bd913eacefc4ab)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent, new (0, $4393b3d8f06c20f2$export$e465f05cc739f565)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader, new (0, $b24f3c4bfad11a8f$export$e989b059caa4681f)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailHeader, new (0, $7012dd1706b509fe$export$ec45019db5492d93)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragHIcon, new (0, $61338fc3d15be771$export$c6f30b6cf2856f51)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailExpand, new (0, $86030f57de34892f$export$9fb1641b3f8f5140)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailFooterIntent, new (0, $2381caa4fc4cba7a$export$93132838e1b9b702)(this.parent, this.locator));
        cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragIcon, new (0, $39056b56ca84927f$export$be74257ce5600364)(this.parent, this.locator));
    };
    Render.prototype.addEventListener = function() {
        var _this = this;
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$b70fe0c8c3456154, this.instantiateRenderer, this);
        this.parent.on("refreshdataSource", this.dataManagerSuccess, this);
        this.parent.on($17b89d3b1fc93cdb$export$80cded91831c5507, this.refresh, this);
        this.parent.on($17b89d3b1fc93cdb$export$ae8f3774777d16d3, this.refreshComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$b53da9940f8876f4, this.sendBulkRequest, this);
        this.parent.on($17b89d3b1fc93cdb$export$5254084c06ba0d7f, function() {
            _this.emptyGrid = true;
        }, this);
        this.parent.on($17b89d3b1fc93cdb$export$bb86da570a7327af, this.dynamicColumnChange, this);
    };
    /**
     * @param {ReturnType} e - specifies the Return type
     * @returns {Promise<Object>} returns the object
     * @hidden
     */ Render.prototype.validateGroupRecords = function(e) {
        var _this = this;
        var index = e.result.length - 1;
        if (index < 0) return Promise.resolve(e);
        var group0 = e.result[0];
        var groupN = e.result[parseInt(index.toString(), 10)];
        var predicate = [];
        var addWhere = function(input) {
            var groups = [
                group0,
                groupN
            ];
            for(var i = 0; i < groups.length; i++)predicate.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)("field", "==", groups[parseInt(i.toString(), 10)].field).and(_this.getPredicate("key", "equal", groups[parseInt(i.toString(), 10)].key)));
            input.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicate));
        };
        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        addWhere(query);
        var curDm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(e.result);
        var curFilter = curDm.executeLocal(query);
        var newQuery = this.data.generateQuery(true);
        var rPredicate = [];
        if (this.data.isRemote()) {
            var groups = [
                group0,
                groupN
            ];
            for(var i = 0; i < groups.length; i++)rPredicate.push(this.getPredicate(groups[parseInt(i.toString(), 10)].field, "equal", groups[parseInt(i.toString(), 10)].key));
            newQuery.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).or(rPredicate));
        } else addWhere(newQuery);
        var deferred = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
        this.data.getData({}, newQuery).then(function(r) {
            _this.updateGroupInfo(curFilter, r.result);
            deferred.resolve(e);
        }).catch(function(e) {
            return deferred.reject(e);
        });
        return deferred.promise;
    };
    /**
     * @param {string} key - Defines the key
     * @param {string} operator - Defines the operator
     * @param {string | number | Date} value - Defines the value
     * @returns {Predicate} - Returns the predicate
     * @hidden */ Render.prototype.getPredicate = function(key, operator, value) {
        if (value instanceof Date) return (0, $748c2240e597a9b7$export$4c58a38283ee9c83)({
            field: key,
            operator: operator,
            value: value
        });
        return new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(key, operator, value);
    };
    /**
     * @param {Object[]} current - Defines the current object
     * @param {Object[]} untouched - Defines the object needs to merge
     * @returns {Object[]} - Returns the updated group information
     * @hidden */ Render.prototype.updateGroupInfo = function(current, untouched) {
        var dm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(untouched);
        var elements = current;
        for(var i = 0; i < elements.length; i++){
            var updatedGroup = dm.executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)("field", "==", elements[parseInt(i.toString(), 10)].field).and(this.getPredicate("key", "equal", elements[parseInt(i.toString(), 10)].key))))[0];
            if (!(0, $3EnZW.isNullOrUndefined)(updatedGroup)) {
                elements[parseInt(i.toString(), 10)].count = updatedGroup.count;
                var itemGroup = elements[parseInt(i.toString(), 10)].items;
                var updatedGroupItem = updatedGroup.items;
                if (itemGroup.GroupGuid) elements[parseInt(i.toString(), 10)].items = this.updateGroupInfo(elements[parseInt(i.toString(), 10)].items, updatedGroup.items);
                var rows = this.parent.aggregates;
                for(var j = 0; j < rows.length; j++){
                    var row = rows[parseInt(j.toString(), 10)];
                    for(var k = 0; k < row.columns.length; k++){
                        var column = row.columns[parseInt(k.toString(), 10)];
                        var types = column.type instanceof Array ? column.type : [
                            column.type
                        ];
                        for(var l = 0; l < types.length; l++){
                            var key = column.field + " - " + types[parseInt(l.toString(), 10)].toLowerCase();
                            var data = itemGroup.level ? updatedGroupItem.records : updatedGroup.items;
                            var context = this.parent;
                            if (types[parseInt(l.toString(), 10)] === "Custom") {
                                var data_1 = itemGroup.level ? updatedGroupItem : updatedGroup;
                                var temp = column.customAggregate;
                                if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
                                elements[parseInt(i.toString(), 10)].aggregates["" + key] = temp ? temp.call(context, data_1, row.columns[parseInt(k.toString(), 10)]) : "";
                            } else elements[parseInt(i.toString(), 10)].aggregates["" + key] = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).aggregates[types[parseInt(l.toString(), 10)].toLowerCase()](data, row.columns[parseInt(k.toString(), 10)].field);
                        }
                    }
                }
            }
        }
        return current;
    };
    return Render;
}();






parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * CellRendererFactory
 *
 * @hidden
 */ var $1a4abae492179d7d$export$cb229f7feb229cc0 = /** @class */ function() {
    function CellRendererFactory() {
        this.cellRenderMap = {};
    }
    CellRendererFactory.prototype.addCellRenderer = function(name, type) {
        name = typeof name === "string" ? name : (0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.cellRenderMap["" + name])) this.cellRenderMap["" + name] = type;
    };
    CellRendererFactory.prototype.getCellRenderer = function(name) {
        name = typeof name === "string" ? name : (0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.cellRenderMap["" + name])) // eslint-disable-next-line no-throw-literal
        throw "The cellRenderer " + name + " is not found";
        else return this.cellRenderMap["" + name];
    };
    return CellRendererFactory;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");




/**
 *
 * The `ResponsiveDialogRenderer` module is used to render the responsive dialogs.
 */ var $ea5a6a6076446a6d$export$cbe435acf057884d = /** @class */ function() {
    function ResponsiveDialogRenderer(parent, serviceLocator) {
        this.sortedCols = [];
        this.sortPredicate = [];
        /** @hidden */ this.isCustomDialog = false;
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.addEventListener();
    }
    ResponsiveDialogRenderer.prototype.addEventListener = function() {
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$2542708340471a26,
                handler: this.closeCustomDialog
            },
            {
                event: $17b89d3b1fc93cdb$export$acd547ecab270561,
                handler: this.refreshCustomFilterOkBtn
            },
            {
                event: $17b89d3b1fc93cdb$export$9b39fce63b060dec,
                handler: this.renderResponsiveContextMenu
            },
            {
                event: $17b89d3b1fc93cdb$export$fafad99bbd7983c0,
                handler: this.renderCustomFilterDiv
            },
            {
                event: $17b89d3b1fc93cdb$export$9cc49c8e691f8e1e,
                handler: this.customExFilterClose
            },
            {
                event: $17b89d3b1fc93cdb$export$4f835fcb4bd1b58c,
                handler: this.refreshCustomFilterClearBtn
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
        this.onActionCompleteFn = this.editComplate.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.onActionCompleteFn);
    };
    ResponsiveDialogRenderer.prototype.customExFilterClose = function() {
        this.isCustomDlgRender = false;
    };
    ResponsiveDialogRenderer.prototype.renderCustomFilterDiv = function() {
        var header = this.customResponsiveDlg.element.querySelector(".e-dlg-header-content");
        var title = header.querySelector(".e-dlg-custom-header");
        var closeBtn = header.querySelector(".e-dlg-closeicon-btn");
        this.isCustomDlgRender = true;
        this.parent.filterModule.filterModule.closeDialog();
        this.saveBtn.element.style.display = "";
        this.refreshCustomFilterOkBtn({
            disabled: false
        });
        this.backBtn.element.style.display = "none";
        closeBtn.style.display = "";
        title.innerHTML = this.parent.localeObj.getConstant("CustomFilter");
        var content = this.customResponsiveDlg.element.querySelector(".e-dlg-content");
        this.customExcelFilterParent = this.parent.createElement("div", {
            className: "e-xl-customfilterdiv e-default-filter"
        });
        content.appendChild(this.customExcelFilterParent);
    };
    ResponsiveDialogRenderer.prototype.renderResponsiveContextMenu = function(args) {
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) {
            var content = this.customResponsiveDlg.element.querySelector(".e-dlg-content");
            var header = this.customResponsiveDlg.element.querySelector(".e-dlg-header-content");
            var closeBtn = header.querySelector(".e-dlg-closeicon-btn");
            var text = header.querySelector(".e-dlg-custom-header");
            if (args.isOpen) {
                content.firstChild.style.display = "none";
                content.appendChild(args.target);
                closeBtn.style.display = "none";
                this.saveBtn.element.style.display = "none";
                this.filterClearBtn.element.style.display = "none";
                text.innerHTML = args.header;
                var backBtn = this.parent.createElement("button");
                var span = this.parent.createElement("span", {
                    className: "e-btn-icon e-resfilterback e-icons"
                });
                backBtn.appendChild(span);
                this.backBtn = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                    cssClass: this.parent.cssClass ? "e-res-back-btn " + this.parent.cssClass : "e-res-back-btn"
                });
                this.backBtn.appendTo(backBtn);
                text.parentElement.insertBefore(backBtn, text);
            } else if (this.backBtn && !this.isCustomDlgRender) {
                content.firstChild.style.display = "";
                (0, $4ZDHT.remove)(this.backBtn.element);
                closeBtn.style.display = "";
                this.saveBtn.element.style.display = "";
                if (this.isFiltered) this.filterClearBtn.element.style.display = "";
                text.innerHTML = this.getHeaderTitle({
                    action: (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter
                }, args.col);
            }
        }
    };
    ResponsiveDialogRenderer.prototype.refreshCustomFilterClearBtn = function(args) {
        if (this.filterClearBtn) {
            this.isFiltered = args.isFiltered;
            this.filterClearBtn.element.style.display = args.isFiltered ? "" : "none";
        }
    };
    ResponsiveDialogRenderer.prototype.refreshCustomFilterOkBtn = function(args) {
        if (this.saveBtn) this.saveBtn.disabled = args.disabled;
        if (this.parent.columnChooserModule && this.parent.columnChooserModule.responsiveDialogRenderer.saveBtn) this.parent.columnChooserModule.responsiveDialogRenderer.saveBtn.disabled = args.disabled;
    };
    ResponsiveDialogRenderer.prototype.columnMenuResponsiveContent = function(str, locale, disabled) {
        var cDiv = this.parent.createElement("div", {
            className: "e-responsivecoldiv e-responsive" + str.toLowerCase() + "div" + (disabled ? " e-disabled" : "")
        });
        var span = this.parent.createElement("span", {
            className: "e-icons e-res" + str.toLowerCase() + "-icon e-btn-icon"
        });
        var icon = this.parent.createElement("span", {
            innerHTML: locale,
            className: "e-rescolumn-menu e-res-header-text"
        });
        cDiv.appendChild(span);
        cDiv.appendChild(icon);
        this.customColumnDiv.appendChild(cDiv);
    };
    ResponsiveDialogRenderer.prototype.renderResponsiveContent = function(col, column) {
        var _this = this;
        var gObj = this.parent;
        var isColumnChooser = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser;
        if (col || isColumnChooser) {
            this.filterParent = this.parent.createElement("div", {
                className: (isColumnChooser ? "e-maincolumnchooserdiv " : "") + "e-mainfilterdiv e-default-filter",
                id: (isColumnChooser ? "columchooser" : col.uid) + "-main-filter"
            });
            return this.filterParent;
        } else {
            this.customColumnDiv = gObj.createElement("div", {
                className: "columndiv columnmenudiv",
                styles: "width: 100%"
            });
            if (this.parent.showColumnMenu && this.parent.rowRenderingMode === "Horizontal" && this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu) {
                this.columnMenuResponsiveContent("AutoFitAll", gObj.localeObj.getConstant("AutoFitAll"));
                this.columnMenuResponsiveContent("AutoFit", gObj.localeObj.getConstant("AutoFit"));
                if (column.allowGrouping && gObj.allowGrouping) {
                    this.columnMenuResponsiveContent("Group", gObj.localeObj.getConstant("Group"), gObj.groupSettings.columns.indexOf(column.field) >= 0);
                    this.columnMenuResponsiveContent("UnGroup", gObj.localeObj.getConstant("Ungroup"), gObj.groupSettings.columns.indexOf(column.field) < 0);
                }
                if (column.allowSorting && gObj.allowSorting) {
                    var direction = "None";
                    var sortColumns = this.parent.sortSettings.columns;
                    for(var i = 0; i < sortColumns.length; i++)if (sortColumns[parseInt(i.toString(), 10)].field === column.field) {
                        direction = sortColumns[parseInt(i.toString(), 10)].direction;
                        break;
                    }
                    this.columnMenuResponsiveContent("ascending", gObj.localeObj.getConstant("SortAscending"), direction === "Ascending");
                    this.columnMenuResponsiveContent("descending", gObj.localeObj.getConstant("SortDescending"), direction === "Descending");
                }
                if (gObj.showColumnChooser) this.columnMenuResponsiveContent("Column", gObj.localeObj.getConstant("Columnchooser"));
                if (column.allowFiltering && gObj.allowFiltering) this.columnMenuResponsiveContent("Filter", gObj.localeObj.getConstant("FilterMenu"));
            } else {
                var cols = gObj.getColumns();
                var sortBtnParent = gObj.createElement("div", {
                    className: "e-ressortbutton-parent"
                });
                var filteredCols = [];
                var isSort = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort;
                var isFilter = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter;
                if (isFilter) for(var i = 0; i < gObj.filterSettings.columns.length; i++)filteredCols.push(gObj.filterSettings.columns[parseInt(i.toString(), 10)].field);
                for(var i = 0; i < cols.length; i++){
                    if (!cols[parseInt(i.toString(), 10)].visible || !cols[parseInt(i.toString(), 10)].allowSorting && isSort || !cols[parseInt(i.toString(), 10)].allowFiltering && isFilter) continue;
                    var cDiv = gObj.createElement("div", {
                        className: "e-responsivecoldiv"
                    });
                    cDiv.setAttribute("data-e-mappingname", cols[parseInt(i.toString(), 10)].field);
                    cDiv.setAttribute("data-e-mappinguid", cols[parseInt(i.toString(), 10)].uid);
                    var span = gObj.createElement("span", {
                        innerHTML: cols[parseInt(i.toString(), 10)].headerText,
                        className: "e-res-header-text"
                    });
                    cDiv.appendChild(span);
                    this.customColumnDiv.appendChild(cDiv);
                    if (isSort) {
                        var fields = this.getSortedFieldsAndDirections("field");
                        var index = fields.indexOf(cols[parseInt(i.toString(), 10)].field);
                        var button = gObj.createElement("button", {
                            id: gObj.element.id + cols[parseInt(i.toString(), 10)].field + "sortbutton"
                        });
                        var clone = sortBtnParent.cloneNode();
                        clone.appendChild(button);
                        cDiv.appendChild(clone);
                        var btnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                            cssClass: this.parent.cssClass ? "e-ressortbutton " + this.parent.cssClass : "e-ressortbutton"
                        });
                        btnObj.appendTo(button);
                        var buttonInnerText = void 0;
                        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.sortSettings.columns[parseInt(index.toString(), 10)])) buttonInnerText = this.parent.sortSettings.columns[parseInt(index.toString(), 10)].direction === "Ascending" ? this.parent.localeObj.getConstant("AscendingText") : this.parent.localeObj.getConstant("DescendingText");
                        button.innerHTML = index > -1 ? buttonInnerText : this.parent.localeObj.getConstant("NoneText");
                        button.onclick = function(e) {
                            _this.sortButtonClickHandler(e.target);
                        };
                    }
                    if (isFilter && filteredCols.indexOf(cols[parseInt(i.toString(), 10)].field) > -1) {
                        var divIcon = gObj.createElement("div", {
                            className: "e-icons e-res-icon e-filtersetdiv"
                        });
                        var iconSpan = gObj.createElement("span", {
                            className: "e-icons e-res-icon e-filterset"
                        });
                        iconSpan.setAttribute("colType", cols[parseInt(i.toString(), 10)].type);
                        divIcon.appendChild(iconSpan);
                        cDiv.appendChild(divIcon);
                    }
                }
            }
            (0, $aqzbR.EventHandler).add(this.customColumnDiv, (0, $5q7BP.Browser).isDevice ? "touchend" : "click", this.customFilterColumnClickHandler, this);
            return this.customColumnDiv;
        }
    };
    ResponsiveDialogRenderer.prototype.getSortedFieldsAndDirections = function(name) {
        var fields = [];
        for(var i = 0; i < this.parent.sortSettings.columns.length; i++)fields.push(this.parent.sortSettings.columns[parseInt(i.toString(), 10)]["" + name]);
        return fields;
    };
    ResponsiveDialogRenderer.prototype.sortButtonClickHandler = function(target) {
        if (target) {
            var columndiv = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivecoldiv");
            var field = columndiv.getAttribute("data-e-mappingname");
            if (!this.parent.allowMultiSorting) {
                this.sortPredicate = [];
                this.sortedCols = [];
                this.isSortApplied = false;
                this.resetSortButtons(target);
            }
            var txt = target.textContent;
            var directionTxt = txt === this.parent.localeObj.getConstant("NoneText") ? this.parent.localeObj.getConstant("AscendingText") : txt === this.parent.localeObj.getConstant("AscendingText") ? this.parent.localeObj.getConstant("DescendingText") : this.parent.localeObj.getConstant("NoneText");
            var direction = directionTxt === this.parent.localeObj.getConstant("AscendingText") ? "Ascending" : directionTxt === this.parent.localeObj.getConstant("DescendingText") ? "Descending" : "None";
            target.innerHTML = directionTxt;
            this.setSortedCols(field, direction);
        }
    };
    ResponsiveDialogRenderer.prototype.resetSortButtons = function(target) {
        var buttons = [].slice.call(this.customColumnDiv.getElementsByClassName("e-ressortbutton"));
        for(var i = 0; i < buttons.length; i++)if (buttons[parseInt(i.toString(), 10)] !== target) buttons[parseInt(i.toString(), 10)].innerHTML = this.parent.localeObj.getConstant("NoneText");
    };
    ResponsiveDialogRenderer.prototype.setSortedCols = function(field, direction) {
        var fields = this.getCurrentSortedFields();
        var index = fields.indexOf(field);
        if (this.parent.allowMultiSorting && index > -1) {
            this.sortedCols.splice(index, 1);
            this.sortPredicate.splice(index, 1);
        }
        this.isSortApplied = true;
        if (direction !== "None") {
            this.sortedCols.push(field);
            this.sortPredicate.push({
                field: field,
                direction: direction
            });
        }
    };
    ResponsiveDialogRenderer.prototype.getCurrentSortedFields = function() {
        var fields = [];
        for(var i = 0; i < this.sortedCols.length; i++)fields.push(this.sortedCols[parseInt(i.toString(), 10)]);
        return fields;
    };
    ResponsiveDialogRenderer.prototype.customFilterColumnClickHandler = function(e) {
        var gObj = this.parent;
        var target = e.target;
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "columnmenudiv") && this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-disabled")) {
            var column = this.menuCol ? this.menuCol : this.filteredCol;
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsiveautofitalldiv")) {
                gObj.autoFitColumns([]);
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsiveautofitdiv")) {
                gObj.autoFitColumns(column.field);
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivegroupdiv")) {
                gObj.groupColumn(column.field);
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsiveungroupdiv")) {
                gObj.ungroupColumn(column.field);
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsiveascendingdiv")) {
                gObj.sortColumn(column.field, "Ascending");
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivedescendingdiv")) {
                gObj.sortColumn(column.field, "Descending");
                this.closeCustomFilter();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivecolumndiv")) {
                gObj.notify($17b89d3b1fc93cdb$export$57e9c95e9e650443, {
                    action: 5
                });
                gObj.showResponsiveCustomColumnChooser();
            } else if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivefilterdiv")) {
                gObj.notify($17b89d3b1fc93cdb$export$57e9c95e9e650443, {
                    action: 3
                });
                this.isRowResponsive = true;
                this.isCustomDialog = false;
                if (gObj.filterModule) gObj.filterModule.responsiveDialogRenderer.showResponsiveDialog(column);
            }
            e.preventDefault();
        }
        if (this.action !== (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) return;
        if (gObj.filterSettings.type !== "FilterBar") {
            if (target.classList.contains("e-responsivecoldiv") || target.parentElement.classList.contains("e-responsivecoldiv")) {
                var field = target.getAttribute("data-e-mappingname");
                if (!field) field = target.parentElement.getAttribute("data-e-mappingname");
                if (field) {
                    var col = gObj.getColumnByField(field);
                    this.isRowResponsive = true;
                    this.showResponsiveDialog(col);
                }
            } else if (target.classList.contains("e-filterset") || target.parentElement.classList.contains("e-filtersetdiv")) {
                var colDiv = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-responsivecoldiv");
                if (colDiv) {
                    var field = colDiv.getAttribute("data-e-mappingname");
                    var col = gObj.getColumnByField(field);
                    if (col.filter.type === "Menu" || !col.filter.type && gObj.filterSettings.type === "Menu") this.isDialogClose = true;
                    this.parent.filterModule.filterModule.clearCustomFilter(col);
                    this.removeCustomDlgFilterEle(target);
                }
            }
        }
    };
    /**
     * Function to show the responsive dialog
     *
     * @param {Column} col - specifies the filter column
     * @param {Column} column - specifies the menu column
     * @returns {void}
     */ ResponsiveDialogRenderer.prototype.showResponsiveDialog = function(col, column) {
        if (this.isCustomDialog && this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter && !this.isRowResponsive || column && this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu) {
            this.menuCol = column;
            this.renderCustomFilterDialog(null, column);
        } else {
            this.filteredCol = col;
            this.renderResponsiveDialog(col);
            if (this.parent.enableAdaptiveUI && col) {
                this.parent.filterModule.setFilterModel(col);
                this.parent.filterModule.filterModule.openDialog(this.parent.filterModule.createOptions(col, undefined));
            }
            if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) this.parent.notify($17b89d3b1fc93cdb$export$87d96ac382feb05c, {
                action: "open"
            });
            if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort) {
                var args = {
                    cancel: false,
                    dialogObj: this.customResponsiveDlg,
                    requestType: "beforeOpenAptiveSortDialog"
                };
                this.parent.trigger($17b89d3b1fc93cdb$export$5ea7d2089851ef30, args);
                if (args.cancel) return;
            }
            this.customResponsiveDlg.show(true);
            this.customResponsiveDlg.element.style.maxHeight = "100%";
            this.setTopToChildDialog(this.customResponsiveDlg.element);
            if (this.parent.enableAdaptiveUI && this.parent.filterSettings && (this.parent.filterSettings.type === "CheckBox" || this.parent.filterSettings.type === "Excel") && this.parent.filterSettings.enableInfiniteScrolling && this.parent.filterSettings.loadingIndicator === "Shimmer") {
                var filterBase = this.parent.filterSettings.type === "CheckBox" ? this.parent.filterModule.filterModule.checkBoxBase : this.parent.filterModule.filterModule.excelFilterBase;
                filterBase.showMask();
            }
        }
    };
    ResponsiveDialogRenderer.prototype.setTopToChildDialog = function(dialogEle) {
        var child = dialogEle.querySelector(".e-dialog");
        if (child) {
            var top_1 = dialogEle.querySelector(".e-dlg-header-content").getBoundingClientRect().height;
            child.style.top = top_1 + "px";
        }
    };
    ResponsiveDialogRenderer.prototype.renderCustomFilterDialog = function(col, column) {
        var gObj = this.parent;
        var isColMenu = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu;
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter && gObj.filterSettings.type === "FilterBar") return;
        var colMenu = isColMenu ? "e-customcolumnmenudiv " : "";
        var outerDiv = this.parent.createElement("div", {
            id: gObj.element.id + (isColMenu ? "customcolumnmenu" : "customfilter"),
            className: this.parent.cssClass ? colMenu + "e-customfilterdiv e-responsive-dialog " + this.parent.cssClass : colMenu + "e-customfilterdiv e-responsive-dialog"
        });
        this.parent.element.appendChild(outerDiv);
        this.customFilterDlg = this.getDialogOptions(col, true, null, column);
        var args = {
            cancel: false,
            dialogObj: this.customFilterDlg,
            requestType: "beforeOpenAptiveFilterDialog"
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$5ea7d2089851ef30, args);
        if (args.cancel) return;
        this.customFilterDlg.appendTo(outerDiv);
        this.customFilterDlg.show(true);
        this.customFilterDlg.element.style.maxHeight = "100%";
    };
    ResponsiveDialogRenderer.prototype.getDialogOptions = function(col, isCustomFilter, id, column) {
        var options = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            isModal: true,
            showCloseIcon: true,
            closeOnEscape: false,
            locale: this.parent.locale,
            target: this.parent.adaptiveDlgTarget ? this.parent.adaptiveDlgTarget : document.body,
            visible: false,
            enableRtl: this.parent.enableRtl,
            content: this.renderResponsiveContent(col, column),
            open: this.dialogOpen.bind(this),
            created: this.dialogCreated.bind(this),
            close: this.beforeDialogClose.bind(this),
            width: "100%",
            height: "100%",
            animationSettings: {
                effect: "None"
            },
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        var isStringTemplate = "isStringTemplate";
        options["" + isStringTemplate] = true;
        if (isCustomFilter) {
            options.header = this.renderResponsiveHeader(col, undefined, true);
            var colMenu = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu ? "e-customcolumnmenu " : "";
            options.cssClass = colMenu + "e-customfilter";
        } else {
            options.header = this.renderResponsiveHeader(col);
            options.cssClass = this.parent.rowRenderingMode === "Vertical" && this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter ? "e-res" + id + " e-row-responsive-filter" : "e-res" + id;
        }
        return options;
    };
    ResponsiveDialogRenderer.prototype.renderResponsiveDialog = function(col) {
        var gObj = this.parent;
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter && gObj.filterSettings.type === "FilterBar") return;
        var id = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter ? "filter" : "sort";
        id = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser ? "columnchooser" : id;
        var outerDiv = this.parent.createElement("div", {
            id: gObj.element.id + "responsive" + id,
            className: this.parent.cssClass ? "e-res" + id + "div e-responsive-dialog " + this.parent.cssClass : "e-res" + id + "div e-responsive-dialog"
        });
        this.parent.element.appendChild(outerDiv);
        this.customResponsiveDlg = this.getDialogOptions(col, false, id);
        this.customResponsiveDlg.appendTo(outerDiv);
    };
    ResponsiveDialogRenderer.prototype.dialogCreated = function() {
        (0, $748c2240e597a9b7$export$9098854bd97850c7)(this.parent);
    };
    ResponsiveDialogRenderer.prototype.dialogOpen = function() {
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort && this.parent.allowMultiSorting) for(var i = 0; i < this.parent.sortSettings.columns.length; i++){
            this.sortedCols.push(this.parent.sortSettings.columns[parseInt(i.toString(), 10)].field);
            var sortField = this.parent.sortSettings.columns[parseInt(i.toString(), 10)].field;
            var sortDirection = this.parent.sortSettings.columns[parseInt(i.toString(), 10)].direction;
            this.sortPredicate.push({
                field: sortField,
                direction: sortDirection
            });
        }
    };
    ResponsiveDialogRenderer.prototype.beforeDialogClose = function(args) {
        this.isDialogClose = args.element && !args.element.querySelector(".e-xl-customfilterdiv") && args.element.classList.contains("e-resfilterdiv");
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) {
            if (args.element.classList.contains("e-resfilterdiv")) this.parent.filterModule.filterModule.closeResponsiveDialog(this.isCustomDlgRender);
            else if (args.element.classList.contains("e-customfilterdiv")) this.closeCustomFilter();
            if (this.parent.rowRenderingMode === "Horizontal" && this.parent.showColumnMenu) {
                this.parent.notify($17b89d3b1fc93cdb$export$57e9c95e9e650443, {
                    action: 4
                });
                var custom = document.querySelector(".e-resfilter");
                if (custom) (0, $4ZDHT.remove)(custom);
            }
        } else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort) this.closeCustomDialog();
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu) {
            this.closeCustomFilter();
            var custom = document.querySelector(".e-rescolummenu");
            if (custom) (0, $4ZDHT.remove)(custom);
        } else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) {
            this.parent.notify($17b89d3b1fc93cdb$export$87d96ac382feb05c, {
                action: "clear"
            });
            var custom = document.querySelector(".e-rescolumnchooser");
            if (custom) (0, $4ZDHT.remove)(custom);
            if (this.parent.rowRenderingMode === "Horizontal" && this.parent.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$57e9c95e9e650443, {
                action: 4
            });
            this.isCustomDialog = false;
            this.isDialogClose = false;
        }
        this.parent.off($17b89d3b1fc93cdb$export$294312b870d7fb5c, this.keyHandler);
    };
    ResponsiveDialogRenderer.prototype.sortColumn = function() {
        if (!this.isSortApplied) {
            this.closeCustomDialog();
            return;
        }
        if (this.sortPredicate.length) this.parent.setProperties({
            sortSettings: {
                columns: []
            }
        }, true);
        for(var i = 0; i < this.sortPredicate.length; i++)this.parent.sortColumn(this.sortPredicate[parseInt(i.toString(), 10)].field, this.sortPredicate[parseInt(i.toString(), 10)].direction, this.parent.allowMultiSorting);
        if (!this.sortPredicate.length) this.parent.clearSorting();
        this.closeCustomDialog();
    };
    ResponsiveDialogRenderer.prototype.getHeaderTitle = function(args, col) {
        var gObj = this.parent;
        var title;
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isEdit) title = gObj.localeObj.getConstant("EditFormTitle") + args.primaryKeyValue[0];
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isAdd) title = gObj.localeObj.getConstant("AddFormTitle");
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) title = col ? col.headerText || col.field : gObj.localeObj.getConstant("FilterTitle");
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort) title = gObj.localeObj.getConstant("Sort");
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColMenu) title = gObj.localeObj.getConstant("ColumnMenu");
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) title = gObj.localeObj.getConstant("ChooseColumns");
        return title;
    };
    ResponsiveDialogRenderer.prototype.getDialogName = function(action) {
        var name;
        if (action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isAdd || action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isEdit) name = "dialogEdit_wrapper_title";
        else if (action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) name = "responsive_filter_dialog_wrapper";
        else if (action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) name = "responsive_column_chooser_dialog_wrapper";
        return name;
    };
    ResponsiveDialogRenderer.prototype.getButtonText = function(action) {
        var text;
        if (action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isAdd || action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isEdit) text = "Save";
        else if (action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter || this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort || action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser || this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) text = "OKButton";
        return text;
    };
    /**
     * Function to render the responsive header
     *
     * @param {Column} col - specifies the column
     * @param {ResponsiveDialogArgs} args - specifies the responsive dialog arguments
     * @param {boolean} isCustomFilter - specifies whether it is custom filter or not
     * @returns {HTMLElement | string} returns the html element or string
     */ ResponsiveDialogRenderer.prototype.renderResponsiveHeader = function(col, args, isCustomFilter) {
        var _this = this;
        var gObj = this.parent;
        gObj.on($17b89d3b1fc93cdb$export$294312b870d7fb5c, this.keyHandler, this);
        var id = gObj.element.id + this.getDialogName(this.action);
        var header = gObj.createElement("div", {
            className: "e-res-custom-element"
        });
        var titleDiv = gObj.createElement("div", {
            className: "e-dlg-custom-header",
            id: id
        });
        titleDiv.innerHTML = this.getHeaderTitle(args, col);
        header.appendChild(titleDiv);
        var saveBtn = gObj.createElement("button");
        if (!isCustomFilter) {
            this.saveBtn = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                cssClass: this.parent.cssClass ? "e-primary e-flat e-res-apply-btn " + this.parent.cssClass : "e-primary e-flat e-res-apply-btn"
            });
            saveBtn.innerHTML = gObj.localeObj.getConstant(this.getButtonText(this.action));
            this.saveBtn.appendTo(saveBtn);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            saveBtn.onclick = function(e) {
                _this.dialogHdrBtnClickHandler();
            };
        }
        var isSort = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort;
        var isFilter = this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter;
        if (isFilter || isSort) {
            var id_1 = isSort ? "sort" : "filter";
            var clearBtn = gObj.createElement("button");
            this.filterClearBtn = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
                cssClass: this.parent.cssClass ? "e-primary e-flat e-res-" + id_1 + "-clear-btn" + " " + this.parent.cssClass : "e-primary e-flat e-res-" + id_1 + "-clear-btn"
            });
            if (isFilter) {
                var span = gObj.createElement("span", {
                    className: "e-btn-icon e-icon-filter-clear e-icons"
                });
                clearBtn.appendChild(span);
            } else clearBtn.innerHTML = gObj.localeObj.getConstant("Clear");
            header.appendChild(clearBtn);
            this.filterClearBtn.appendTo(clearBtn);
            clearBtn.onclick = function(e) {
                if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-customfilter")) {
                    _this.parent.filterModule.clearFiltering();
                    _this.removeCustomDlgFilterEle();
                } else if (isFilter) _this.filterClear();
                else {
                    _this.resetSortButtons();
                    _this.sortedCols = [];
                    _this.sortPredicate = [];
                    _this.isSortApplied = true;
                }
            };
            header.appendChild(clearBtn);
        }
        if (!isCustomFilter) header.appendChild(saveBtn);
        return header;
    };
    ResponsiveDialogRenderer.prototype.filterClear = function() {
        this.parent.filterModule.filterModule.clearCustomFilter(this.filteredCol);
        this.parent.filterModule.filterModule.closeResponsiveDialog();
    };
    ResponsiveDialogRenderer.prototype.removeCustomFilterElement = function() {
        var elem = document.getElementById(this.parent.element.id + "customcolumnmenu");
        if (elem) {
            (0, $4ZDHT.remove)(elem);
            var custom = document.querySelector(".e-customfilter");
            if (custom) (0, $4ZDHT.remove)(custom);
        }
        var custommenu = document.querySelector(".e-rescolumnchooser");
        if (custommenu) (0, $4ZDHT.remove)(custommenu);
    };
    ResponsiveDialogRenderer.prototype.dialogHdrBtnClickHandler = function() {
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isEdit || this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isAdd) this.parent.endEdit();
        else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter) {
            this.parent.filterModule.filterModule.applyCustomFilter({
                col: this.filteredCol,
                isCustomFilter: this.isCustomDlgRender
            });
            this.removeCustomFilterElement();
        } else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort) {
            this.sortColumn();
            this.removeCustomFilterElement();
        } else if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser) {
            this.parent.notify($17b89d3b1fc93cdb$export$87d96ac382feb05c, {
                action: "confirm"
            });
            this.removeCustomFilterElement();
            this.isCustomDialog = false;
            this.isDialogClose = false;
        }
    };
    ResponsiveDialogRenderer.prototype.closeCustomDialog = function() {
        if (this.isCustomDlgRender) {
            var mainfilterdiv = this.customResponsiveDlg.element.querySelector(".e-mainfilterdiv");
            (0, $4ZDHT.remove)(mainfilterdiv);
            return;
        }
        this.isRowResponsive = false;
        this.isCustomDlgRender = false;
        this.destroyCustomFilterDialog();
    };
    ResponsiveDialogRenderer.prototype.destroyCustomFilterDialog = function() {
        if (!this.customResponsiveDlg) return;
        var elem = document.getElementById(this.customResponsiveDlg.element.id);
        if (this.customResponsiveDlg && !this.customResponsiveDlg.isDestroyed && elem) {
            this.customResponsiveDlg.destroy();
            (0, $4ZDHT.remove)(elem);
        }
        this.closeCustomFilter();
        if (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort) {
            this.sortPredicate = [];
            this.sortedCols = [];
            this.isSortApplied = false;
        }
    };
    ResponsiveDialogRenderer.prototype.closeCustomFilter = function() {
        if (!this.isDialogClose && this.customFilterDlg) {
            var customEle = document.getElementById(this.customFilterDlg.element.id);
            if (this.customFilterDlg && !this.customFilterDlg.isDestroyed && customEle) {
                this.customFilterDlg.destroy();
                (0, $4ZDHT.remove)(customEle);
            }
        }
        this.isCustomDialog = false;
        this.isDialogClose = false;
    };
    ResponsiveDialogRenderer.prototype.removeCustomDlgFilterEle = function(target) {
        if (target) {
            if (target.parentElement.classList.contains("e-filtersetdiv")) (0, $4ZDHT.remove)(target.parentElement);
            else (0, $4ZDHT.remove)(target);
        } else {
            var child = this.customColumnDiv.children;
            for(var i = 0; i < child.length; i++){
                target = child[parseInt(i.toString(), 10)].querySelector(".e-filtersetdiv");
                if (target) {
                    (0, $4ZDHT.remove)(target);
                    i--;
                }
            }
        }
    };
    ResponsiveDialogRenderer.prototype.keyHandler = function(e) {
        if (e.keyCode === 13 && (this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter && e.target.classList.contains("e-searchinput") || this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isEdit || this.action === (0, $6b76944ddf827cb7$export$b69201db7f59899c).isAdd)) this.dialogHdrBtnClickHandler();
    };
    ResponsiveDialogRenderer.prototype.editComplate = function(args) {
        if (args.requestType === "save" || args.requestType === "cancel") this.parent.off($17b89d3b1fc93cdb$export$294312b870d7fb5c, this.keyHandler);
    };
    ResponsiveDialogRenderer.prototype.removeEventListener = function() {
        if (this.customColumnDiv) (0, $aqzbR.EventHandler).remove(this.customColumnDiv, (0, $5q7BP.Browser).isDevice ? "touchend" : "click", this.customFilterColumnClickHandler);
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.onActionCompleteFn);
    };
    return ResponsiveDialogRenderer;
}();


/**
 * ServiceLocator
 *
 * @hidden
 */ var $be04f19d782f3472$export$6cd6e3ed1512e78f = /** @class */ function() {
    function ServiceLocator() {
        this.services = {};
    }
    ServiceLocator.prototype.register = function(name, type) {
        if ((0, $3EnZW.isNullOrUndefined)(this.services["" + name])) this.services["" + name] = type;
    };
    ServiceLocator.prototype.getService = function(name) {
        if ((0, $3EnZW.isNullOrUndefined)(this.services["" + name])) // eslint-disable-next-line no-throw-literal
        throw "The service " + name + " is not registered";
        return this.services["" + name];
    };
    ServiceLocator.prototype.registerAdaptiveService = function(type, isAdaptiveUI, action) {
        if (isAdaptiveUI) {
            type.responsiveDialogRenderer = new (0, $ea5a6a6076446a6d$export$cbe435acf057884d)(type.parent, type.serviceLocator);
            type.responsiveDialogRenderer.action = action;
        } else if (type.responsiveDialogRenderer) {
            type.responsiveDialogRenderer.removeEventListener();
            type.responsiveDialogRenderer = undefined;
        }
    };
    return ServiceLocator;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * RendererFactory
 *
 * @hidden
 */ var $15313f6956d76a3f$export$35d194b5f3387064 = /** @class */ function() {
    function RendererFactory() {
        this.rendererMap = {};
    }
    RendererFactory.prototype.addRenderer = function(name, type) {
        var rName = (0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$ed706b0a66efb05c), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.rendererMap["" + rName])) this.rendererMap["" + rName] = type;
    };
    RendererFactory.prototype.getRenderer = function(name) {
        var rName = (0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$ed706b0a66efb05c), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.rendererMap["" + rName])) // eslint-disable-next-line no-throw-literal
        throw "The renderer " + rName + " is not found";
        else return this.rendererMap["" + rName];
    };
    return RendererFactory;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");




/**
 * ColumnWidthService
 *
 * @hidden
 */ var $95d0259945049a0f$export$96000d5616e57e96 = /** @class */ function() {
    function ColumnWidthService(parent) {
        this.parent = parent;
    }
    ColumnWidthService.prototype.setWidthToColumns = function() {
        var i = 0;
        var indexes = this.parent.getColumnIndexesInView();
        var wFlag = true;
        var totalColumnsWidth = 0;
        if (this.parent.allowGrouping) for(var len = this.parent.groupSettings.columns.length; i < len; i++){
            if (this.parent.enableColumnVirtualization && indexes.indexOf(i) === -1) {
                wFlag = false;
                continue;
            }
            this.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                width: "30px"
            }), i);
        }
        if (this.parent.detailTemplate || this.parent.childGrid) {
            this.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                width: "30px"
            }), i);
            i++;
        }
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() !== "Right") {
            this.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                width: "30px"
            }), i);
            i++;
        }
        var columns = this.parent.getColumns();
        for(var j = 0; j < columns.length; j++)this.setColumnWidth(columns[parseInt(j.toString(), 10)], wFlag && this.parent.enableColumnVirtualization ? undefined : j + i);
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() === "Right") this.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
            width: "30px"
        }), this.parent.groupSettings.columns.length + columns.length);
        totalColumnsWidth = this.getTableWidth(this.parent.getColumns());
        if (totalColumnsWidth !== "auto") {
            if (this.parent.width !== "auto" && this.parent.width.toString().indexOf("%") === -1) this.setMinwidthBycalculation(totalColumnsWidth);
            var maxWidthColumns = columns.filter(function(a) {
                return !(0, $3EnZW.isNullOrUndefined)(a.maxWidth);
            });
            var header = this.parent.getHeaderTable();
            var content = this.parent.getContentTable();
            if (this.parent.allowResizing && this.parent.element.getBoundingClientRect().width > totalColumnsWidth && maxWidthColumns.length === columns.length && header && content) (0, $4ZDHT.addClass)([
                header,
                content
            ], [
                "e-tableborder"
            ]);
        }
    };
    ColumnWidthService.prototype.setMinwidthBycalculation = function(tWidth) {
        var _this = this;
        var difference = 0;
        var collection = this.parent.getColumns().filter(function(a) {
            if (_this.parent.allowResizing) return ((0, $3EnZW.isNullOrUndefined)(a.width) || a.width === "auto") && (0, $3EnZW.isNullOrUndefined)(a.maxWidth);
            else return (0, $3EnZW.isNullOrUndefined)(a.width) || a.width === "auto";
        });
        if (collection.length) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.width) && this.parent.width !== "auto" && typeof this.parent.width === "string" && this.parent.width.indexOf("%") === -1) difference = parseInt(this.parent.width, 10) - tWidth;
            else difference = this.parent.element.getBoundingClientRect().width - tWidth;
            var tmWidth = 0;
            for(var _i = 0, collection_1 = collection; _i < collection_1.length; _i++){
                var cols = collection_1[_i];
                tmWidth += !(0, $3EnZW.isNullOrUndefined)(cols.minWidth) ? typeof cols.minWidth === "string" ? parseInt(cols.minWidth, 10) : cols.minWidth : 0;
            }
            for(var i = 0; i < collection.length; i++){
                if (tWidth === 0 && this.parent.allowResizing && this.isWidthUndefined() && i !== collection.length - 1) this.setUndefinedColumnWidth(collection);
                var index = this.parent.getColumnIndexByField(collection[parseInt(i.toString(), 10)].field) + this.parent.getIndentCount();
                if (tWidth !== 0 && difference < tmWidth) this.setWidth(collection[parseInt(i.toString(), 10)].minWidth, index);
                else if (tWidth !== 0 && difference > tmWidth) this.setWidth("", index, true);
            }
        }
    };
    ColumnWidthService.prototype.setUndefinedColumnWidth = function(collection) {
        for(var k = 0; k < collection.length; k++)if (k !== collection.length - 1) {
            collection[parseInt(k.toString(), 10)].width = 200;
            this.setWidth(200, this.parent.getColumnIndexByField(collection[parseInt(k.toString(), 10)].field));
        }
    };
    ColumnWidthService.prototype.setColumnWidth = function(column, index, module) {
        if (this.parent.getColumns().length < 1) return;
        var columnIndex = (0, $3EnZW.isNullOrUndefined)(index) ? this.parent.getNormalizedColumnIndex(column.uid) : index;
        var cWidth = this.getWidth(column);
        var tgridWidth = this.getTableWidth(this.parent.getColumns());
        if (cWidth !== null) {
            this.setWidth(cWidth, columnIndex);
            if (this.parent.width !== "auto" && this.parent.width.toString().indexOf("%") === -1 && tgridWidth !== "auto") this.setMinwidthBycalculation(tgridWidth);
            if (this.parent.allowResizing && (module === "resize" || this.parent.getFrozenColumns())) {
                var contentTable = this.parent.getContentTable();
                this.setWidthToTable(this.parent.getFrozenColumns() && contentTable.style.width.indexOf("px") === -1);
            }
            this.parent.notify((0, $17b89d3b1fc93cdb$export$deabcf5530617ea3), {
                index: columnIndex,
                width: cWidth,
                column: column,
                module: module
            });
        }
    };
    ColumnWidthService.prototype.setWidth = function(width, index, clear) {
        if (this.parent.groupSettings.columns.length > index && (0, $748c2240e597a9b7$export$4605faa9bb01ebb8)(this.parent)) {
            var elementWidth = this.parent.element.offsetWidth;
            width = (30 / elementWidth * 100).toFixed(1) + "%";
        }
        var header = this.parent.getHeaderTable();
        var content = this.parent.getContentTable();
        var fWidth = (0, $3EnZW.formatUnit)(width);
        var headerCol = header.querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).children[parseInt(index.toString(), 10)];
        if (headerCol && !clear) headerCol.style.width = fWidth;
        else if (headerCol && clear) headerCol.style.width = "";
        var contentCol = content.querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).children[parseInt(index.toString(), 10)];
        if (contentCol && !clear) contentCol.style.width = fWidth;
        else if (contentCol && clear) contentCol.style.width = "";
        if (!this.parent.enableColumnVirtualization && this.parent.isEdit) {
            var edit = this.parent.element.querySelectorAll(".e-table.e-inline-edit");
            var editTableCol = [];
            for(var i = 0; i < edit.length; i++){
                if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(edit[parseInt(i.toString(), 10)], "e-grid").id === this.parent.element.id) for(var j = 0; j < edit[parseInt(i.toString(), 10)].querySelector("colgroup").children.length; j++)editTableCol.push(edit[parseInt(i.toString(), 10)].querySelector("colgroup").children[parseInt(j.toString(), 10)]);
            }
            if (edit.length && editTableCol.length && editTableCol[parseInt(index.toString(), 10)]) editTableCol[parseInt(index.toString(), 10)].style.width = fWidth;
        }
        if (this.parent.isFrozenGrid() && this.parent.enableColumnVirtualization) this.refreshFrozenScrollbar();
    };
    /**
     * @returns {void}
     * @hidden
     */ ColumnWidthService.prototype.refreshFrozenScrollbar = function() {
        var args = {
            cancel: false
        };
        this.parent.notify((0, $17b89d3b1fc93cdb$export$8fba6c752b79b5a6), args);
        if (args.cancel) return;
        var scrollWidth = (0, $748c2240e597a9b7$export$1df2a1438d36fb55)();
        var movableScrollbar = this.parent.element.querySelector(".e-movablescrollbar");
        var movableWidth = this.parent.getContent().firstElementChild.getBoundingClientRect().width;
        if (this.parent.enableColumnVirtualization) {
            var placeHolder = this.parent.getContent().querySelector(".e-virtualtrack");
            if (placeHolder) movableWidth = placeHolder.scrollWidth;
        }
        if (this.parent.height !== "auto") movableWidth = movableWidth + scrollWidth;
        movableScrollbar.firstElementChild.style.width = movableWidth + "px";
    };
    ColumnWidthService.prototype.getSiblingsHeight = function(element) {
        var previous = this.getHeightFromDirection(element, "previous");
        var next = this.getHeightFromDirection(element, "next");
        return previous + next;
    };
    ColumnWidthService.prototype.getHeightFromDirection = function(element, direction) {
        var sibling = element[direction + "ElementSibling"];
        var result = 0;
        var classList = [
            $1b5568e76cdae6d4$export$b8cf6f078a9012e0,
            $1b5568e76cdae6d4$export$71ae40cd68e383eb,
            "e-groupdroparea",
            "e-gridpager",
            "e-toolbar",
            "e-temp-toolbar"
        ];
        while(sibling){
            if (classList.some(function(value) {
                return sibling.classList.contains(value);
            })) result += sibling.offsetHeight;
            sibling = sibling[direction + "ElementSibling"];
        }
        return result;
    };
    ColumnWidthService.prototype.isWidthUndefined = function() {
        var isWidUndefCount = this.parent.getColumns().filter(function(col) {
            return (0, $3EnZW.isNullOrUndefined)(col.width) && (0, $3EnZW.isNullOrUndefined)(col.minWidth);
        }).length;
        return this.parent.getColumns().length === isWidUndefCount;
    };
    ColumnWidthService.prototype.getWidth = function(column) {
        if (this.parent.allowResizing && (0, $3EnZW.isNullOrUndefined)(column.width)) {
            if ((0, $3EnZW.isNullOrUndefined)(column.minWidth) && (0, $3EnZW.isNullOrUndefined)(column.maxWidth) && !this.isWidthUndefined()) column.width = 200;
            else if (column.maxWidth) column.width = column.maxWidth;
        }
        if (!column.width) return null;
        var width = parseInt(column.width.toString(), 10);
        if (column.minWidth && width < parseInt(column.minWidth.toString(), 10)) return column.minWidth;
        else if (column.maxWidth && width > parseInt(column.maxWidth.toString(), 10)) return column.maxWidth;
        else return column.width;
    };
    ColumnWidthService.prototype.getTableWidth = function(columns, resetIndentWidth) {
        var tWidth = 0;
        var isAutoColumn = false;
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var column = columns_1[_i];
            if (column.visible !== false) {
                var cWidth = this.getWidth(column);
                if (column.width === "auto" || !column.width) {
                    if (this.parent.allowResizing && !resetIndentWidth) {
                        if (!column.maxWidth) isAutoColumn = true;
                    } else cWidth = 0;
                }
                if (cWidth !== null) tWidth += parseInt(cWidth.toString(), 10);
            }
        }
        tWidth = isAutoColumn ? "auto" : tWidth;
        return tWidth;
    };
    ColumnWidthService.prototype.setWidthToTable = function(isMaxWidth) {
        var tWidth = (0, $3EnZW.formatUnit)(this.getTableWidth(this.parent.getColumns()));
        if (this.parent.detailTemplate || this.parent.childGrid) this.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
            width: "30px"
        }));
        tWidth = this.isAutoResize() || tWidth === "auto" || isMaxWidth ? "100%" : tWidth;
        this.parent.getHeaderTable().style.width = tWidth;
        this.parent.getContentTable().style.width = tWidth;
        var edit = this.parent.element.querySelector(".e-table.e-inline-edit");
        if (edit) edit.style.width = tWidth;
    };
    ColumnWidthService.prototype.isAutoResize = function() {
        return this.parent.allowResizing && this.parent.resizeSettings.mode === "Auto";
    };
    return ColumnWidthService;
}();



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");






var $008b258884e5b2ce$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * FocusStrategy class
 *
 * @hidden
 */ var $008b258884e5b2ce$export$d989ec6d6c3876c5 = /** @class */ function() {
    function FocusStrategy(parent) {
        this.currentInfo = {};
        this.oneTime = true;
        this.swap = {};
        /** @hidden */ this.isInfiniteScroll = false;
        /** @hidden */ this.virtualSelectionInfo = {};
        this.forget = false;
        this.skipFocus = true;
        this.focusByClick = false;
        this.firstHeaderCellClick = false;
        /** @hidden */ this.prevIndexes = {};
        this.refMatrix = this.refreshMatrix(true);
        this.actions = [
            "downArrow",
            "upArrow"
        ];
        this.isVirtualScroll = false;
        this.groupedFrozenRow = 0;
        this.parent = parent;
        this.rowModelGen = new (0, $7ddfd3da489c240b$export$2cf41885b7ecbd06)(this.parent);
        this.addEventListener();
    }
    FocusStrategy.prototype.focusCheck = function(e) {
        var target = e.target;
        this.focusByClick = true;
        this.firstHeaderCellClick = true;
        this.skipFocus = target.classList.contains("e-grid");
    };
    FocusStrategy.prototype.onFocus = function(e) {
        if (this.parent.isDestroyed || (0, $5q7BP.Browser).isDevice || this.parent.enableVirtualization || this.parent.element.querySelector(".e-masked-table") || !this.parent.isInitialLoad && e && e.target === this.parent.element && this.parent.element.querySelector(".e-spin-show")) return;
        this.setActive(!this.parent.enableHeaderFocus && this.parent.frozenRows === 0);
        if (!this.parent.enableHeaderFocus && !this.parent.getCurrentViewRecords().length && (this.parent.editSettings.mode !== "Batch" || this.parent.editSettings.mode === "Batch" && this.parent.editModule && !this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$aef5e1398935f398].length)) this.getContent().matrix.generate(this.rowModelGen.generateRows({
            rows: [
                new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)({
                    isDataRow: true
                })
            ]
        }), this.getContent().selector, false);
        var current = this.getContent().matrix.get(0, -1, [
            0,
            1
        ], null, this.getContent().validator());
        this.getContent().matrix.select(current[0], current[1]);
        if (this.skipFocus && !(e && e.target === this.parent.element)) {
            this.focus(e);
            this.skipFocus = false;
        }
    };
    FocusStrategy.prototype.passiveFocus = function(e) {
        if (this.parent.isDestroyed) return;
        var firstHeaderCell = this.parent.getHeaderContent().querySelector(".e-headercell:not(.e-hide)");
        if (e.target === firstHeaderCell && e.relatedTarget && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.relatedTarget, "e-grid") && !this.firstHeaderCellClick) {
            var firstHeaderCellIndex = [
                0,
                0
            ];
            if (this.active.matrix.matrix[firstHeaderCellIndex[0]][firstHeaderCellIndex[1]] === 0) firstHeaderCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, firstHeaderCellIndex, true);
            this.active.matrix.current = firstHeaderCellIndex;
            this.currentInfo.element = e.target;
            this.currentInfo.elementToFocus = e.target;
            if (this.currentInfo.element.querySelector(".e-checkselectall")) {
                this.removeFocus();
                this.addFocus(this.getContent().getFocusInfo(), e);
            } else (0, $4ZDHT.addClass)([
                this.currentInfo.element
            ], [
                "e-focused",
                "e-focus"
            ]);
        }
        this.firstHeaderCellClick = false;
        if (e.target && e.target.classList.contains("e-detailcell")) {
            this.currentInfo.skipAction = false;
            (0, $4ZDHT.addClass)([
                this.currentInfo.element
            ], [
                "e-focused",
                "e-focus"
            ]);
        }
    };
    FocusStrategy.prototype.onBlur = function(e) {
        if (this.parent.allowPaging && this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer")) this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer").removeAttribute("aria-hidden");
        // The below boolean condition for gantt team focus fix.
        var isGantt = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gantt") && e.target.classList.contains("e-rowcell") && !(0, $3EnZW.isNullOrUndefined)(e.target.nextElementSibling) && e.target.nextElementSibling.classList.contains("e-rowcell") ? true : false;
        if ((this.parent.isEdit || e && (!e.relatedTarget || (0, $4ZDHT.closest)(e.relatedTarget, ".e-grid")) && !(this.parent.element.classList.contains("e-childgrid") && !this.parent.element.matches(":focus-within"))) && !(!isGantt && (0, $3EnZW.isNullOrUndefined)(e.relatedTarget) && parseInt(e.target.getAttribute("data-colindex"), 10) === 0 && parseInt(e.target.getAttribute("index"), 10) === 0) && !(!isGantt && (0, $3EnZW.isNullOrUndefined)(e.relatedTarget) && !(0, $4ZDHT.closest)(document.activeElement, ".e-grid") && !(0, $3EnZW.isNullOrUndefined)(e["sourceCapabilities"]))) return;
        this.removeFocus();
        this.skipFocus = true;
        this.currentInfo.skipAction = false;
        this.setLastContentCellTabIndex();
        this.setFirstFocusableTabIndex();
        this.firstHeaderCellClick = false;
    };
    /**
     * @returns {void}
     * @hidden */ FocusStrategy.prototype.setFirstFocusableTabIndex = function() {
        var gObj = this.parent;
        gObj.element.tabIndex = -1;
        if (gObj.allowGrouping && gObj.groupSettings.showDropArea) {
            var groupModule = gObj.groupModule;
            var focusableGroupedItems = groupModule.getFocusableGroupedItems();
            if (focusableGroupedItems.length > 0) {
                groupModule.element.tabIndex = -1;
                focusableGroupedItems[0].tabIndex = 0;
            } else groupModule.element.tabIndex = 0;
            return;
        }
        if (gObj.toolbar || gObj.toolbarTemplate) {
            var toolbarElement = gObj.toolbarModule.element;
            var focusableToolbarItems = this.parent.toolbarModule.getFocusableToolbarItems();
            if (focusableToolbarItems.length > 0 && focusableToolbarItems[0].querySelector(".e-toolbar-item-focus,.e-btn,.e-input")) {
                toolbarElement.tabIndex = -1;
                focusableToolbarItems[0].querySelector(".e-toolbar-item-focus,.e-btn,.e-input").tabIndex = 0;
            } else toolbarElement.tabIndex = 0;
            return;
        }
        if (gObj.getColumns().length) {
            var firstHeaderCell = gObj.getHeaderContent().querySelector(".e-headercell:not(.e-hide)");
            firstHeaderCell.tabIndex = 0;
            this.setActive(false);
            if (!(0, $3EnZW.isNullOrUndefined)(this.active) && ((0, $3EnZW.isNullOrUndefined)(this.active.target) || !this.active.target.classList.contains("e-columnmenu"))) {
                var firstHeaderCellIndex = [
                    0,
                    0
                ];
                if (this.active.matrix.matrix[firstHeaderCellIndex[0]][firstHeaderCellIndex[1]] === 0) firstHeaderCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, firstHeaderCellIndex, true);
                this.active.matrix.current = firstHeaderCellIndex;
            }
            return;
        }
    };
    FocusStrategy.prototype.setLastContentCellTabIndex = function() {
        var contentTable = this.parent.getContentTable();
        if (contentTable.rows[contentTable.rows.length - 1]) {
            var lastCell = contentTable.rows[contentTable.rows.length - 1].lastElementChild;
            lastCell.tabIndex = 0;
        }
    };
    FocusStrategy.prototype.onClick = function(e, force) {
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-filterbarcell") && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-multiselect") || e.target.classList.contains("e-input-group-icon"))) return;
        var isContent = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, "." + $1b5568e76cdae6d4$export$ee5f1442ff7df474));
        var isHeader = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, "." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0));
        isContent = isContent && isHeader ? !isContent : isContent;
        if (!isContent && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, "." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0)) || e.target.classList.contains($1b5568e76cdae6d4$export$a7db06668cad9adb) || e.target.classList.contains($1b5568e76cdae6d4$export$838c0e7679321ff3) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, ".e-unboundcell")) && !force) return;
        this.setActive(isContent);
        var beforeArgs = {
            cancel: false,
            byKey: false,
            byClick: !(0, $3EnZW.isNullOrUndefined)(e.target),
            clickArgs: e
        };
        this.parent.notify($17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0, beforeArgs);
        if (beforeArgs.cancel || (0, $4ZDHT.closest)(e.target, ".e-inline-edit") && !this.parent.editSettings.showAddNewRow && this.parent.editSettings.showAddNewRow && !this.parent.element.querySelector(".e-editedrow")) return;
        this.setActive(isContent);
        if (this.getContent()) {
            var returnVal = this.getContent().onClick(e, force);
            if (returnVal === false) return;
            this.focus();
            if (this.currentInfo.element.classList.contains("e-rowcell") && e.type && e.type === "click") (0, $4ZDHT.addClass)([
                this.currentInfo.element
            ], [
                "e-focused",
                "e-focus"
            ]);
        }
    };
    FocusStrategy.prototype.handleFilterNavigation = function(e, inputSelector, buttonSelector) {
        if (e.target === document.querySelector(inputSelector) && e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            document.querySelector(buttonSelector).focus();
        } else if (e.target === document.querySelector(buttonSelector) && e.key === "Tab" && !e.shiftKey && document.activeElement === document.querySelector(buttonSelector)) {
            e.preventDefault();
            document.querySelector(inputSelector).focus();
        }
    };
    FocusStrategy.prototype.onKeyPress = function(e) {
        if (this.parent.editSettings.mode === "Batch") this.content.target = null;
        if (this.parent.allowPaging) {
            var pagerElement = this.parent.pagerModule.pagerObj.element;
            var focusablePagerElements = this.parent.pagerModule.pagerObj.getFocusablePagerElements(pagerElement, []);
            if (this.parent.childGrid && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridpager") && this.allowToPaging(e) && focusablePagerElements.length) focusablePagerElements[0].tabIndex = 0;
            if (this.parent.pagerModule.pagerObj.checkPagerHasFocus()) {
                if (e.action === "shiftTab" && focusablePagerElements.length && focusablePagerElements[0] === e.target) {
                    this.setActive(true);
                    var lastHeaderCellIndex = [
                        this.active.matrix.matrix.length - 1,
                        this.active.matrix.matrix[this.active.matrix.matrix.length - 1].length - 1
                    ];
                    if (this.active.matrix.matrix[lastHeaderCellIndex[0]][lastHeaderCellIndex[1]] === 0) lastHeaderCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, lastHeaderCellIndex, false);
                    this.active.matrix.current = this.parent.editSettings.mode === "Batch" ? this.isValidBatchEditCell(lastHeaderCellIndex) ? lastHeaderCellIndex : this.findBatchEditCell(lastHeaderCellIndex, false) : lastHeaderCellIndex;
                    e.preventDefault();
                    this.focus(e);
                    return;
                }
                if (!(e.action === "tab" && this.parent.element.classList.contains("e-childgrid") && (!this.parent.pageSettings.pageSizes && focusablePagerElements.length && focusablePagerElements[focusablePagerElements.length - 1] === e.target || this.parent.pagerModule.pagerObj.getDropDownPage() === e.target))) {
                    this.parent.pagerModule.pagerObj.changePagerFocus(e);
                    return;
                } else {
                    var parentCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.parent.element, "e-detailcell");
                    (0, $4ZDHT.removeClass)([
                        this.parent.element
                    ], [
                        "e-focus"
                    ]);
                    (0, $4ZDHT.removeClass)([
                        parentCell
                    ], [
                        "e-focused"
                    ]);
                    parentCell.tabIndex = -1;
                }
            }
            if (this.parent.pagerModule.pagerObj.element.tabIndex === 0 && (e.keyCode === 38 || e.shiftKey && e.keyCode === 9)) {
                e.preventDefault();
                this.focus(e);
                return;
            } else if (this.parent.pagerModule.pagerObj.element.tabIndex === 0 && e.keyCode === 9) {
                e.preventDefault();
                this.parent.pagerModule.pagerObj.setPagerFocus();
                return;
            }
            if (this.parent.pagerModule.pagerObj.checkFirstPagerFocus()) {
                var lastRow = this.getContent().matrix.rows;
                var lastColumn = this.getContent().matrix.columns;
                this.getContent().matrix.current = [
                    lastRow,
                    lastColumn
                ];
            }
        }
        if (this.parent.filterSettings.type === "Excel") this.handleFilterNavigation(e, ".e-excelfilter .e-menu-item:not(.e-disabled)", ".e-excelfilter .e-footer-content button:nth-child(2)");
        if (this.parent.filterSettings.type === "CheckBox") this.handleFilterNavigation(e, ".e-searchinput.e-input", ".e-checkboxfilter .e-footer-content button:nth-child(2)");
        if (this.parent.filterSettings.type === "Menu") this.handleFilterNavigation(e, ".e-flmenu .e-input-group.e-popup-flmenu", ".e-flmenu .e-footer-content button:nth-child(2)");
        if (this.parent.showColumnChooser) this.handleFilterNavigation(e, ".e-ccdlg .e-ccsearch.e-cc.e-input", ".e-ccdlg .e-footer-content button:nth-child(2)");
        if (this.skipOn(e)) return;
        if (e.target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridcontent")) {
            var rows = [].slice.call(this.parent.getContentTable().rows);
            var lastCell = rows[rows.length - 1].lastElementChild;
            if (e.target === lastCell) {
                this.setActive(true);
                this.setLastContentCellActive();
            }
        }
        if (e.action === "shiftTab" && e.target && (e.target === this.parent.element || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea"))) {
            if (e.target === this.parent.element) {
                if (this.parent.element.classList.contains("e-childgrid")) this.focusOutFromChildGrid(e);
                return;
            }
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea")) {
                if (this.parent.element.classList.contains("e-childgrid")) {
                    e.preventDefault();
                    this.parent.element.focus();
                }
                return;
            }
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar")) {
                if (this.parent.allowGrouping && this.parent.groupSettings.showDropArea) {
                    var groupModule = this.parent.groupModule;
                    var focusableGroupedItems = groupModule.getFocusableGroupedItems();
                    e.preventDefault();
                    if (focusableGroupedItems.length > 0) focusableGroupedItems[focusableGroupedItems.length - 1].focus();
                    else groupModule.element.focus();
                } else if (this.parent.element.classList.contains("e-childgrid")) {
                    e.preventDefault();
                    this.parent.element.focus();
                }
                return;
            }
        }
        var focusFirstHeaderCell = false;
        if (e.action === "tab" && e.target && (e.target === this.parent.element || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea"))) {
            if (this.parent.allowGrouping && this.parent.groupSettings.showDropArea && (e.target === this.parent.element || e.target.classList.contains("e-groupdroparea"))) {
                var groupModule = this.parent.groupModule;
                var focusableGroupedItems = groupModule.getFocusableGroupedItems();
                if (focusableGroupedItems.length > 0) {
                    e.preventDefault();
                    focusableGroupedItems[0].focus();
                    return;
                }
                if (!e.target.classList.contains("e-groupdroparea")) {
                    e.preventDefault();
                    groupModule.element.focus();
                    return;
                }
            }
            if ((this.parent.toolbar || this.parent.toolbarTemplate) && (e.target === this.parent.element || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea") || e.target.classList.contains("e-toolbar"))) {
                var toolbarElement = this.parent.toolbarModule.element;
                var focusableToolbarItems = this.parent.toolbarModule.getFocusableToolbarItems();
                if (focusableToolbarItems.length > 0) {
                    e.preventDefault();
                    focusableToolbarItems[0].querySelector(".e-toolbar-item-focus,.e-btn,.e-input").focus();
                    return;
                }
                if (!e.target.classList.contains("e-toolbar")) {
                    e.preventDefault();
                    toolbarElement.focus();
                    return;
                }
            }
            if (e.target === this.parent.element || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea")) focusFirstHeaderCell = true;
        }
        if (focusFirstHeaderCell) {
            if (this.parent.allowGrouping && !(0, $3EnZW.isNullOrUndefined)(this.parent.groupSettings.columns) && this.parent.groupSettings.columns.length === this.parent.columns.length) this.setActive(true);
            else this.setActive(false);
            this.active.matrix.current = [
                0,
                -1
            ];
        }
        this.activeKey = e.action;
        var beforeArgs = {
            cancel: false,
            byKey: true,
            byClick: false,
            keyArgs: e
        };
        this.parent.notify($17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0, beforeArgs);
        if (beforeArgs.cancel) return;
        var bValue = this.getContent().matrix.current;
        var prevBatchValue = this.active && this.active.matrix.current ? [
            this.active.matrix.current[0],
            this.active.matrix.current[1]
        ] : undefined;
        this.currentInfo.outline = true;
        var swapInfo = this.getContent().jump(e.action, bValue);
        this.swap = swapInfo;
        if (swapInfo.swap && !(this.parent.editSettings.mode === "Batch" && (e.action === "tab" || e.action === "shiftTab"))) {
            this.setActive(!swapInfo.toHeader);
            this.getContent().matrix.current = this.getContent().getNextCurrent(bValue, swapInfo, this.active, e.action);
            this.prevIndexes = {};
        }
        this.setActiveByKey(e.action, this.getContent());
        var returnVal = this.content.lastIdxCell ? false : this.getContent().onKeyPress(e);
        if (e.target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridheader")) {
            if (e.action === "tab" && bValue.toString() === this.active.matrix.current.toString()) {
                var nextHeaderCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, this.active.matrix.current, true);
                var lastHeaderCellIndex = [
                    this.active.matrix.matrix.length - 1,
                    this.active.matrix.matrix[this.active.matrix.matrix.length - 1].length - 1
                ];
                if (this.active.matrix.matrix[lastHeaderCellIndex[0]][lastHeaderCellIndex[1]] === 0) lastHeaderCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, lastHeaderCellIndex, false);
                if (this.active.matrix.current.toString() === lastHeaderCellIndex.toString() && this.content.matrix.matrix.length) {
                    returnVal = true;
                    this.setActive(true);
                    var firstContentCellIndex = [
                        0,
                        0
                    ];
                    if (this.parent.allowPaging && this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer")) this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer").setAttribute("aria-hidden", "true");
                    if (this.active.matrix.matrix[firstContentCellIndex[0]][firstContentCellIndex[1]] === 0) firstContentCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, [
                        0,
                        0
                    ], true);
                    this.active.matrix.current = this.parent.editSettings.mode === "Batch" ? this.isValidBatchEditCell(firstContentCellIndex) ? firstContentCellIndex : this.findBatchEditCell(firstContentCellIndex, true) : firstContentCellIndex;
                } else if (this.active.matrix.current.toString() !== nextHeaderCellIndex.toString()) this.active.matrix.current = nextHeaderCellIndex;
            }
            if (e.action === "shiftTab" && bValue.toString() === this.active.matrix.current.toString()) {
                var previousCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, this.active.matrix.current, false);
                if (previousCellIndex.toString() === this.active.matrix.current.toString()) {
                    this.focusOutFromHeader(e);
                    return;
                }
                if (this.active.matrix.current.toString() !== previousCellIndex.toString() && !returnVal) {
                    returnVal = true;
                    this.active.matrix.current = previousCellIndex;
                }
            }
        }
        if (e.target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridcontent")) {
            if (this.parent.allowPaging && this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer")) this.parent.pagerModule.pagerObj.element.querySelector(".e-pagercontainer").removeAttribute("aria-hidden");
            if (this.parent.editSettings.mode === "Batch" && (e.action === "tab" || e.action === "shiftTab")) {
                this.active.matrix.current = this.findBatchEditCell(prevBatchValue, e.action === "tab" ? true : false);
                if (e.action === "tab" && prevBatchValue.toString() === this.active.matrix.current.toString()) this.parent.editModule.editModule.addBatchRow = true;
            }
            if (e.action === "shiftTab" && bValue.toString() === this.active.matrix.current.toString()) {
                if (this.parent.allowGrouping && !(0, $3EnZW.isNullOrUndefined)(this.parent.groupSettings.columns) && this.parent.groupSettings.columns.length === this.parent.columns.length) {
                    this.focusOutFromHeader(e);
                    return;
                }
                var firstContentCellIndex = [
                    0,
                    0
                ];
                if (this.active.matrix.matrix[firstContentCellIndex[0]][firstContentCellIndex[1]] === 0) firstContentCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, [
                    0,
                    0
                ], true);
                if (!returnVal && (firstContentCellIndex.toString() === this.active.matrix.current.toString() || this.parent.editSettings.mode === "Batch" && prevBatchValue.toString() === this.active.matrix.current.toString())) {
                    returnVal = true;
                    this.setActive(false);
                    this.setLastContentCellActive();
                }
            }
        }
        if (returnVal === false) {
            this.clearIndicator();
            if (e.action === "shiftTab" && bValue.toString() === [
                0,
                0
            ].toString()) this.parent.element.tabIndex = -1;
            if (this.parent.allowPaging && !this.parent.pagerModule.pagerObj.checkPagerHasFocus() && this.allowToPaging(e) && bValue.toString() !== [
                0,
                0
            ].toString()) {
                e.preventDefault();
                if (e.keyCode === 40) {
                    this.parent.pagerModule.pagerObj.setPagerContainerFocus();
                    return;
                } else if (e.keyCode === 9) {
                    this.parent.pagerModule.pagerObj.setPagerFocus();
                    return;
                }
            }
            if (this.parent.element.classList.contains("e-childgrid")) this.focusOutFromChildGrid(e);
            return;
        }
        this.header.action = e.action;
        this.header.currentTarget = null;
        this.header.focusType = "key";
        if (e.target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-fltrtemp") && (e.action === "tab" || e.action === "shiftTab")) {
            var target = e.target;
            var focusElement = [].slice.call((0, $4ZDHT.closest)(target, "th").querySelectorAll(".e-fltrtemp-focus"));
            if (focusElement.length) {
                var elementIndex = focusElement.indexOf(target);
                var resetActive = e.action === "tab" && elementIndex < focusElement.length - 1 || e.action === "shiftTab" && elementIndex > 0 ? true : false;
                if (resetActive) {
                    this.setActive(false);
                    this.active.matrix.current = bValue;
                    this.active.currentTarget = target;
                }
            }
        }
        if (focusFirstHeaderCell && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.active.getTable(), "e-gridheader") && e.target && e.target.id === this.parent.element.id + "_searchbar") this.parent.searchModule.headerFocus = true;
        e.preventDefault();
        this.focus(e);
    };
    FocusStrategy.prototype.isValidBatchEditCell = function(cellIndex) {
        var cell = this.active.getTable().rows[cellIndex[0]].cells[cellIndex[1]];
        var tr = (0, $4ZDHT.closest)(cell, "tr");
        var cellColIndex = parseInt(cell.getAttribute("data-colindex"), 10);
        var cellCol = this.parent.getColumns()[parseInt(cellColIndex.toString(), 10)];
        if (this.active.matrix.matrix[cellIndex[0]][cellIndex[1]] === 1 && (!tr.classList.contains("e-row") || (tr.classList.contains("e-insertedrow") || !cellCol.isPrimaryKey) && cellCol.allowEditing)) return true;
        return false;
    };
    FocusStrategy.prototype.findBatchEditCell = function(currentCellIndex, next, limitRow) {
        var cellIndex = currentCellIndex;
        var tempCellIndex = currentCellIndex;
        var cellIndexObtain = false;
        while(!cellIndexObtain){
            var prevTempCellIndex = tempCellIndex;
            tempCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, tempCellIndex, next);
            if (prevTempCellIndex.toString() === tempCellIndex.toString() || limitRow && prevTempCellIndex[0] !== tempCellIndex[0]) {
                cellIndexObtain = true;
                continue;
            }
            if (this.isValidBatchEditCell(tempCellIndex)) {
                cellIndex = tempCellIndex;
                cellIndexObtain = true;
            }
        }
        return cellIndex;
    };
    FocusStrategy.prototype.setLastContentCellActive = function() {
        var lastContentCellIndex = [
            this.active.matrix.matrix.length - 1,
            this.active.matrix.matrix[this.active.matrix.matrix.length - 1].length - 1
        ];
        if (this.active.matrix.matrix[lastContentCellIndex[0]][lastContentCellIndex[1]] === 0) lastContentCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.active.matrix.matrix, lastContentCellIndex, false);
        this.active.matrix.current = lastContentCellIndex;
    };
    FocusStrategy.prototype.focusOutFromChildGrid = function(e) {
        var parentTable = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.parent.element, "e-table");
        var parentGrid = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(parentTable, "e-grid").ej2_instances[0];
        var parentCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.parent.element, "e-detailcell");
        var uid = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.parent.element, "e-detailrow").getAttribute("data-uid");
        var parentRows = [].slice.call(parentGrid.getContentTable().rows);
        var parentRowIndex = parentRows.map(function(m) {
            return m.getAttribute("data-uid");
        }).indexOf(uid);
        if (e.action === "tab" && parentRowIndex >= parentRows.length - 1) return;
        (0, $4ZDHT.removeClass)([
            this.parent.element
        ], [
            "e-focus"
        ]);
        (0, $4ZDHT.removeClass)([
            parentCell
        ], [
            "e-focused"
        ]);
        parentCell.tabIndex = -1;
        e.preventDefault();
        var nextFocusCell;
        parentGrid.focusModule.removeFocus();
        if (e.action === "shiftTab") {
            var previousRow = parentRows[parentRowIndex - 1];
            var rowCells = previousRow.cells;
            for(var i = rowCells.length - 1; i >= 0; i--){
                nextFocusCell = rowCells[parseInt(i.toString(), 10)];
                if (!nextFocusCell.classList.contains("e-hide")) {
                    parentGrid.focusModule.active.matrix.current = [
                        parentRowIndex - 1,
                        i
                    ];
                    break;
                }
            }
        } else {
            nextFocusCell = parentRows[parentRowIndex + 1].cells[0];
            parentGrid.focusModule.active.matrix.current = [
                parentRowIndex + 1,
                0
            ];
        }
        parentGrid.focusModule.currentInfo.element = nextFocusCell;
        parentGrid.focusModule.currentInfo.elementToFocus = nextFocusCell;
        (0, $4ZDHT.addClass)([
            nextFocusCell
        ], [
            "e-focused",
            "e-focus"
        ]);
        nextFocusCell.tabIndex = 0;
        nextFocusCell.focus();
    };
    FocusStrategy.prototype.focusOutFromHeader = function(e) {
        this.removeFocus();
        if (this.parent.toolbar || this.parent.toolbarTemplate) {
            var toolbarElement = this.parent.toolbarModule.element;
            var focusableToolbarItems = this.parent.toolbarModule.getFocusableToolbarItems();
            e.preventDefault();
            if (focusableToolbarItems.length > 0) focusableToolbarItems[focusableToolbarItems.length - 1].querySelector(".e-toolbar-item-focus,.e-btn,.e-input").focus();
            else toolbarElement.focus();
            return;
        }
        if (this.parent.allowGrouping && this.parent.groupSettings.showDropArea) {
            var groupModule = this.parent.groupModule;
            var focusableGroupedItems = groupModule.getFocusableGroupedItems();
            e.preventDefault();
            if (focusableGroupedItems.length > 0) focusableGroupedItems[focusableGroupedItems.length - 1].focus();
            else groupModule.element.focus();
            return;
        }
        if (this.parent.element.classList.contains("e-childgrid")) {
            e.preventDefault();
            this.parent.element.focus();
        }
    };
    FocusStrategy.prototype.allowToPaging = function(e) {
        if (this.parent.editSettings.mode === "Batch" && this.parent.editSettings.allowAdding && e.keyCode !== 40) return false;
        return true;
    };
    FocusStrategy.prototype.skipOn = function(e) {
        var target = e.target;
        if (!target) return false;
        if (!this.parent.isEdit && target && target.closest(".e-unboundcell") && this.currentInfo.skipAction && (e.action === "shiftTab" && this.commandColumnFocusElement(target.closest(".e-unboundcell"), false) === target || e.action === "tab" && this.commandColumnFocusElement(target.closest(".e-unboundcell"), true) === target)) return this.currentInfo.skipAction = false;
        if (this.currentInfo.skipAction) {
            this.clearIndicator();
            return true;
        }
        if ([
            "pageUp",
            "pageDown",
            "altDownArrow"
        ].indexOf(e.action) > -1) {
            this.clearIndicator();
            return true;
        }
        if (this.parent.allowGrouping) {
            var focusableGroupedItems = this.parent.groupModule.getFocusableGroupedItems();
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupheadercell") && !(e.target === focusableGroupedItems[0] && e.action === "shiftTab" || e.target === focusableGroupedItems[focusableGroupedItems.length - 1] && e.action === "tab")) return true;
        }
        if (this.parent.toolbar || this.parent.toolbarTemplate) {
            var toolbarElement = this.parent.toolbarModule.element;
            var focusableToolbarItems = toolbarElement.querySelectorAll(".e-toolbar-item:not(.e-overlay):not(.e-hidden)");
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar-item") && !(focusableToolbarItems.length > 0 && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar-item") === focusableToolbarItems[0] && e.action === "shiftTab" || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar-item") === focusableToolbarItems[focusableToolbarItems.length - 1] && e.action === "tab"))) return true;
        }
        var th = (0, $4ZDHT.closest)(target, "th") && !(0, $4ZDHT.closest)(target, "th").tabIndex;
        if (e.target.classList.contains("e-filterbaroperator") && (e.keyCode === 13 || e.keyCode === 27)) {
            var inputTarget = (0, $4ZDHT.closest)(e.target, ".e-filterbarcell");
            inputTarget.querySelector("input").focus();
        }
        var addNewRow = this.parent.editSettings.showAddNewRow && (0, $4ZDHT.closest)(document.activeElement, ".e-addedrow") !== null;
        if (th && (0, $4ZDHT.closest)(document.activeElement, ".e-filterbarcell") !== null || addNewRow) this.removeFocus();
        var filterCell = (0, $4ZDHT.closest)(document.activeElement, ".e-filterbarcell") !== null;
        if (this.parent.enableHeaderFocus && filterCell) {
            var matrix = this.active.matrix;
            var current = matrix.current;
            filterCell = matrix.matrix[current[0]].lastIndexOf(1) !== current[1];
        }
        if (this.parent.isEdit && (e.action === "tab" || e.action === "shiftTab") && this.parent.editSettings.mode === "Normal" && !this.parent.editSettings.showAddNewRow && !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow"))) {
            var inputElements = this.parent.editModule.formObj.element.querySelectorAll("input.e-field:not(.e-disabled),button:not(.e-hide)");
            var inputTarget = target.classList.contains("e-ddl") ? target.querySelector("input") : target;
            var firstEditCell = e.action === "tab" && inputTarget === inputElements[inputElements.length - 1];
            var lastEditCell = e.action === "shiftTab" && inputTarget === inputElements[0];
            if (firstEditCell || lastEditCell) {
                e.preventDefault();
                var focusElement = inputElements[firstEditCell ? 0 : inputElements.length - 1];
                focusElement = focusElement.parentElement.classList.contains("e-ddl") ? focusElement.parentElement : focusElement;
                focusElement.focus();
            }
        }
        return e.action === "delete" || this.parent.editSettings.mode !== "Batch" && (this.parent.isEdit && (!this.parent.editSettings.showAddNewRow || this.parent.editSettings.showAddNewRow && (!(0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector(".e-editedrow")) || !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow")) && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, "input")) && !(0, $3EnZW.isNullOrUndefined)(document.querySelector(".e-popup-open")) || !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow")) && target && !target.querySelector(".e-cancel-icon") && !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-unboundcell")))) || [
            "insert",
            "f2"
        ].indexOf(e.action) > -1) || filterCell && this.parent.enableHeaderFocus || (filterCell || addNewRow) && e.action !== "tab" && e.action !== "shiftTab" || (0, $4ZDHT.closest)(document.activeElement, "#" + this.parent.element.id + "_searchbar") !== null && [
            "enter",
            "leftArrow",
            "rightArrow",
            "shiftLeft",
            "shiftRight",
            "ctrlPlusA"
        ].indexOf(e.action) > -1 || (0, $4ZDHT.closest)(target, "." + $1b5568e76cdae6d4$export$ee5f1442ff7df474) === null && (0, $4ZDHT.closest)(target, "." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) === null && !(e.target === this.parent.element || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea")) || e.action === "space" && !target.classList.contains($1b5568e76cdae6d4$export$71f350cebd38389f) && (0, $4ZDHT.closest)(target, "." + $1b5568e76cdae6d4$export$71f350cebd38389f) === null && (0, $4ZDHT.closest)(target, ".e-headerchkcelldiv") === null || (0, $4ZDHT.closest)(target, ".e-filter-popup") !== null;
    };
    FocusStrategy.prototype.focusVirtualElement = function(e) {
        var _this = this;
        if (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) {
            var data = {
                virtualData: {},
                isAdd: false,
                isCancel: false
            };
            this.parent.notify($17b89d3b1fc93cdb$export$a1aad2683385fb49, data);
            var isKeyFocus = this.actions.some(function(value) {
                return value === _this.activeKey;
            });
            var isSelected = this.parent.contentModule ? this.parent.contentModule.selectedRowIndex > -1 : false;
            if (data.isAdd || Object.keys(data.virtualData).length || isKeyFocus || data.isCancel || isSelected) {
                this.parent.notify($17b89d3b1fc93cdb$export$4621d2cf9ca5b53b, {
                    isCancel: false
                });
                data.isCancel = false;
                this.parent.contentModule.selectedRowIndex = -1;
                if (isKeyFocus) {
                    this.activeKey = this.empty;
                    this.parent.notify("virtaul-key-handler", e);
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.currentInfo.elementToFocus.focus({
                    preventScroll: true
                });
            } else if (this.isVirtualScroll || this.isInfiniteScroll) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.currentInfo.elementToFocus.focus({
                preventScroll: true
            });
            else this.currentInfo.elementToFocus.focus();
        }
        this.isVirtualScroll = this.isInfiniteScroll = false;
    };
    FocusStrategy.prototype.getFocusedElement = function() {
        return this.currentInfo.elementToFocus;
    };
    FocusStrategy.prototype.getContent = function() {
        return this.active || this.content;
    };
    FocusStrategy.prototype.setActive = function(content) {
        this.active = content ? this.content : this.header;
    };
    FocusStrategy.prototype.setFocusedElement = function(element, e) {
        var _this = this;
        this.currentInfo.elementToFocus = element;
        setTimeout(function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.currentInfo.elementToFocus)) {
                var filterMenuElement = (0, $3EnZW.isNullOrUndefined)(_this.parent.element.querySelector(".e-flmenu")) ? document.querySelector(".e-grid-popup .e-flmenu") : _this.parent.element.querySelector(".e-flmenu");
                if (_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling) _this.focusVirtualElement(e);
                else if ((0, $3EnZW.isNullOrUndefined)(filterMenuElement) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(document.activeElement, "e-flmenu-valuediv") !== filterMenuElement.querySelector(".e-flmenu-valuediv")) _this.currentInfo.elementToFocus.focus();
            }
        }, 0);
    };
    FocusStrategy.prototype.focus = function(e) {
        this.parent.notify($17b89d3b1fc93cdb$export$9ee6037f4bacdaa7, e);
        this.removeFocus();
        this.addFocus(this.getContent().getFocusInfo(), e);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    FocusStrategy.prototype.removeFocus = function(e) {
        if (!this.currentInfo.element) return;
        if (this.parent.isReact && !this.parent.isEdit && this.currentInfo.element.classList.contains("e-rowcell") && !this.currentInfo.element.parentElement && !(this.parent.allowGrouping && !(0, $3EnZW.isNullOrUndefined)(this.parent.groupSettings.columns) && this.parent.groupSettings.columns.length) && this.parent.getRowByIndex(this.prevIndexes.rowIndex)) {
            var cellElem = this.parent.getCellFromIndex(this.prevIndexes.rowIndex, this.prevIndexes.cellIndex);
            this.currentInfo.element = cellElem ? cellElem : this.currentInfo.element;
        }
        (0, $4ZDHT.removeClass)([
            this.currentInfo.element,
            this.currentInfo.elementToFocus
        ], [
            "e-focused",
            "e-focus"
        ]);
        this.currentInfo.element.tabIndex = -1;
    };
    /**
     * @returns {void}
     * @hidden */ FocusStrategy.prototype.addOutline = function() {
        var info = this.getContent().getFocusInfo();
        if (info.element) {
            (0, $4ZDHT.addClass)([
                info.element
            ], [
                "e-focused"
            ]);
            (0, $4ZDHT.addClass)([
                info.elementToFocus
            ], [
                "e-focus"
            ]);
        }
    };
    /**
     * @returns {void}
     * @hidden */ FocusStrategy.prototype.focusHeader = function() {
        this.setActive(false);
        this.resetFocus();
    };
    /**
     * @returns {void}
     * @hidden */ FocusStrategy.prototype.focusContent = function() {
        this.setActive(true);
        this.resetFocus();
    };
    FocusStrategy.prototype.resetFocus = function() {
        var current = this.getContent().matrix.get(0, -1, [
            0,
            1
        ], null, this.getContent().validator());
        this.getContent().matrix.select(current[0], current[1]);
        this.focus();
    };
    FocusStrategy.prototype.addFocus = function(info, e) {
        this.currentInfo = info;
        this.currentInfo.outline = info.outline && (!(0, $3EnZW.isNullOrUndefined)(e) || this.isVirtualScroll);
        if (this.isInfiniteScroll) this.currentInfo.outline = true;
        if (!info.element) return;
        var isFocused = info.elementToFocus.classList.contains("e-focus");
        if (isFocused) return;
        if (this.currentInfo.outline) (0, $4ZDHT.addClass)([
            info.element
        ], [
            "e-focused"
        ]);
        (0, $4ZDHT.addClass)([
            info.elementToFocus
        ], [
            "e-focus"
        ]);
        info.element.tabIndex = 0;
        if (!isFocused) this.setFocusedElement(info.elementToFocus, e);
        this.parent.notify($17b89d3b1fc93cdb$export$859ade0ced56eb99, {
            element: info.elementToFocus,
            parent: info.element,
            indexes: this.getContent().matrix.current,
            byKey: !(0, $3EnZW.isNullOrUndefined)(e),
            byClick: (0, $3EnZW.isNullOrUndefined)(e),
            keyArgs: e,
            isJump: this.swap.swap,
            container: this.getContent().getInfo(e),
            outline: !(0, $3EnZW.isNullOrUndefined)(e),
            swapInfo: this.swap
        });
        var _a = this.getContent().matrix.current, rowIndex = _a[0], cellIndex = _a[1];
        this.prevIndexes = {
            rowIndex: rowIndex,
            cellIndex: cellIndex
        };
        this.focusedColumnUid = this.parent.getColumnByIndex(cellIndex).uid;
        this.focusByClick = false;
    };
    FocusStrategy.prototype.refreshMatrix = function(content) {
        var _this = this;
        return function(e) {
            if (content && !_this.content) _this.content = new $008b258884e5b2ce$export$b18f85c700beb1a6(_this.parent);
            if (!content && !_this.header) _this.header = new $008b258884e5b2ce$export$84664db8b649a521(_this.parent);
            var cFocus = content ? _this.content : _this.header;
            var frozenRow = _this.parent.frozenRows;
            var batchLen = 0;
            if (frozenRow && _this.parent.editSettings.mode === "Batch") batchLen = _this.parent.getHeaderContent().querySelectorAll(".e-insertedrow").length + _this.parent.getHeaderContent().querySelectorAll(".e-hiddenrow").length;
            if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.groupSettings.columns) && _this.parent.groupSettings.columns.length && frozenRow && content) {
                frozenRow = 0;
                for(var i = 0; i < e.rows.length; i++){
                    frozenRow++;
                    if (e.rows[parseInt(i.toString(), 10)].index + 1 === _this.parent.frozenRows) break;
                }
                _this.groupedFrozenRow = frozenRow;
            }
            var rows = content ? e.rows.slice(frozenRow + batchLen) : e.rows;
            var updateRow = content ? e.rows.slice(0, frozenRow + batchLen) : e.rows;
            if (_this.parent.isCollapseStateEnabled() && content) rows = rows.filter(function(x) {
                return x.visible !== false;
            });
            var isRowTemplate = !(0, $3EnZW.isNullOrUndefined)(_this.parent.rowTemplate);
            if (frozenRow && (_this.parent.editSettings.mode === "Batch" && content && (e.name === "batchDelete" || e.name === "batchAdd" || e.name === "batchCancel" || e.args && e.args.requestType === "batchsave") || e.args && (e.args.requestType === "delete" || e.args.requestType === "save"))) {
                var matrixcs = _this.header.matrix.matrix;
                var hdrLen = _this.parent.headerModule.rows.length;
                matrixcs.splice(hdrLen, matrixcs.length - hdrLen);
            }
            var matrix = cFocus.matrix.generate(updateRow, cFocus.selector, isRowTemplate);
            cFocus.matrix.generate(rows, cFocus.selector, isRowTemplate);
            var isScroll = _this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling;
            if (_this.parent.editSettings.showAddNewRow && content && _this.header && _this.header.matrix && (!isScroll || isScroll && _this.parent.isAddNewRow)) {
                var tempMatrix = _this.header.matrix.matrix;
                var lastRowHeaderIdx = _this.parent.allowFiltering && _this.parent.filterSettings.type === "FilterBar" ? 2 : 1;
                cFocus.matrix.rows = _this.parent.frozenRows && _this.parent.editSettings.newRowPosition === "Top" ? cFocus.matrix.rows : ++cFocus.matrix.rows;
                if (_this.parent.editSettings.newRowPosition === "Top") (_this.parent.frozenRows || isScroll ? matrix : cFocus.matrix.matrix).unshift(_this.refreshAddNewRowMatrix(tempMatrix[tempMatrix.length - lastRowHeaderIdx]));
                else cFocus.matrix.matrix.push(_this.refreshAddNewRowMatrix(tempMatrix[tempMatrix.length - lastRowHeaderIdx]));
                _this.parent.isAddNewRow = false;
            }
            if (!(_this.parent.isFrozenGrid() && e.args && (e.args.requestType === "sorting" || e.args.requestType === "batchsave" || e.args.requestType === "paging")) || frozenRow && _this.parent.editSettings.mode === "Batch" && content && (e.name === "batchDelete" || e.name === "batchAdd" || e.name === "batchCancel" || e.args.requestType === "batchsave")) cFocus.generateRows(updateRow, {
                matrix: matrix,
                handlerInstance: _this.header
            });
            if (!(0, $5q7BP.Browser).isDevice && e && e.args) {
                if (!_this.focusByClick && e.args.requestType === "paging" && !_this.parent.pagerModule.pagerObj.checkPagerHasFocus()) {
                    _this.skipFocus = false;
                    _this.parent.element.focus();
                }
                if (e.args.requestType === "grouping") _this.skipFocus = true;
            }
            if (e && e.args && e.args.requestType === "virtualscroll") {
                if (_this.currentInfo.uid) {
                    var index_1;
                    var bool = e.rows.some(function(row, i) {
                        index_1 = i;
                        return row.uid === _this.currentInfo.uid;
                    });
                    if (bool) {
                        _this.content.matrix.current[0] = index_1;
                        _this.content.matrix.current[1] = _this.parent.getColumnIndexByUid(_this.focusedColumnUid) || 0;
                        var frzLeftCount = _this.parent.getVisibleFrozenLeftCount();
                        var frzRightCount = _this.parent.getVisibleFrozenRightCount();
                        if (_this.parent.enableColumnVirtualization && !(frzLeftCount && frzRightCount) && _this.parent.isFrozenGrid() && e.args.virtualInfo.direction === "right") _this.content.matrix.current[1] = _this.content.matrix.current[1] - (frzLeftCount + (frzRightCount ? frzRightCount + 1 : 0));
                        var isGroup = _this.parent.allowGrouping && _this.parent.groupSettings.columns.length ? true : false;
                        if (isGroup) {
                            _this.content.matrix.current[1] = _this.prevIndexes.cellIndex;
                            if (_this.virtualSelectionInfo.isPending) _this.content.matrix.current[0] = _this.virtualSelectionInfo.direction === "downArrow" ? _this.content.matrix.current[0] + 1 : _this.content.matrix.current[0] - 1;
                        }
                        var focusElement = _this.getContent().getFocusInfo().elementToFocus;
                        if (focusElement) {
                            var cellPosition = focusElement.getBoundingClientRect();
                            var gridPosition = _this.parent.element.getBoundingClientRect();
                            var freezeLeftColWidth = 0;
                            var freezeRightColWidth = 0;
                            if (_this.parent.enableColumnVirtualization && !(frzLeftCount && frzRightCount) && _this.parent.isFrozenGrid() && e.args.virtualInfo.direction === "right") {
                                if (frzLeftCount) freezeLeftColWidth = _this.parent.leftrightColumnWidth("left");
                                else freezeRightColWidth = _this.parent.leftrightColumnWidth("right");
                            }
                            if (cellPosition.top >= 0 && cellPosition.left >= 0 && cellPosition.right - freezeLeftColWidth - freezeRightColWidth <= Math.min(gridPosition.right, window.innerWidth || document.documentElement.clientWidth) + freezeRightColWidth && cellPosition.bottom <= Math.min(gridPosition.bottom, window.innerHeight || document.documentElement.clientHeight) || isGroup) {
                                _this.isVirtualScroll = true;
                                _this.focus(isGroup && _this.virtualSelectionInfo.isPending ? _this.virtualSelectionInfo.event : undefined);
                            }
                        }
                    }
                } else if (e.args.focusElement && e.args.focusElement.classList.contains("e-filtertext")) {
                    var focusElement = _this.parent.element.querySelector("#" + e.args.focusElement.id);
                    if (focusElement) focusElement.focus();
                }
                _this.virtualSelectionInfo = {};
            }
            if (e && e.args && e.args.requestType === "infiniteScroll") _this.isInfiniteScroll = true;
        };
    };
    FocusStrategy.prototype.refreshAddNewRowMatrix = function(matrix) {
        var cols = this.parent.getColumns();
        var indent = this.parent.getIndentCount();
        for(var i = indent; i < matrix.length - 1; i++)if (cols[i - indent] && cols[i - indent].visible && cols[i - indent].allowEditing) matrix[parseInt(i.toString(), 10)] = 1;
        else matrix[parseInt(i.toString(), 10)] = 0;
        return matrix;
    };
    FocusStrategy.prototype.addEventListener = function() {
        var _this = this;
        if (this.parent.isDestroyed) return;
        (0, $aqzbR.EventHandler).add(this.parent.element, "mousedown", this.focusCheck, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "touchstart", this.focusCheck, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "focus", this.onFocus, this);
        this.parent.element.addEventListener("focus", this.passiveHandler = function(e) {
            return _this.passiveFocus(e);
        }, true);
        (0, $aqzbR.EventHandler).add(this.parent.element, "focusout", this.onBlur, this);
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$e09b512eecac7579,
                handler: this.onKeyPress
            },
            {
                event: $17b89d3b1fc93cdb$export$64ef1bee2b9504c1,
                handler: this.onClick
            },
            {
                event: $17b89d3b1fc93cdb$export$f44d9209b353bf3e,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$868d7674f5a0caf5,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$c70b4b413518c03b,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$68dd90c72fa20ca,
                handler: this.showAddNewRowFocus
            },
            {
                event: $17b89d3b1fc93cdb$export$265a66bcae9d11dd,
                handler: this.refreshMatrix()
            },
            {
                event: $17b89d3b1fc93cdb$export$ef3763a0d698e5a6,
                handler: this.restoreFocus
            },
            {
                event: $17b89d3b1fc93cdb$export$2284e449d64b22d5,
                handler: this.restoreFocus
            },
            {
                event: "start-edit",
                handler: this.clearIndicator
            },
            {
                event: "start-add",
                handler: this.clearIndicator
            },
            {
                event: "sorting-complete",
                handler: this.restoreFocus
            },
            {
                event: "filtering-complete",
                handler: this.filterfocus
            },
            {
                event: "custom-filter-close",
                handler: this.filterfocus
            },
            {
                event: "grouping-complete",
                handler: this.restoreFocusWithAction
            },
            {
                event: "ungrouping-complete",
                handler: this.restoreFocusWithAction
            },
            {
                event: $17b89d3b1fc93cdb$export$32c7bb9403361dde,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$da4cf21ede5d704e,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$290fe11ec3c54640,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$6af477339269af99,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$63287e93462800a4,
                handler: this.refMatrix
            },
            {
                event: $17b89d3b1fc93cdb$export$859ade0ced56eb99,
                handler: this.internalCellFocus
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
    };
    FocusStrategy.prototype.showAddNewRowFocus = function() {
        if (this.parent.editSettings.showAddNewRow) {
            var startIdx = this.parent.editSettings.newRowPosition === "Top" ? 0 : this.content.matrix.matrix.length - 1;
            var startCellIdx = this.parent.getIndentCount();
            if (this.parent.editSettings.newRowPosition === "Top" && (this.parent.frozenRows || this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) {
                var headrIdx = this.header.matrix.matrix.length - (this.groupedFrozenRow ? this.groupedFrozenRow : this.parent.frozenRows);
                startCellIdx = this.findNextCellFocus(this.header.matrix.matrix[headrIdx - 1], startCellIdx);
                this.header.matrix.current = [
                    headrIdx - 1,
                    startCellIdx
                ];
                this.active = this.header;
            } else {
                startCellIdx = this.findNextCellFocus(this.content.matrix.matrix[parseInt(startIdx.toString(), 10)], startCellIdx);
                this.content.matrix.current = [
                    startIdx,
                    startCellIdx
                ];
                this.active = this.content;
            }
            var addedrow = this.parent.element.querySelector(".e-addedrow");
            if (addedrow && addedrow.querySelectorAll("tr") && addedrow.querySelector("tr").cells[parseInt(startCellIdx.toString(), 10)].querySelector("input")) addedrow.querySelector("tr").cells[parseInt(startCellIdx.toString(), 10)].querySelector("input").select();
        }
    };
    FocusStrategy.prototype.findNextCellFocus = function(matrix, cellIndex) {
        for(var i = cellIndex; i < matrix.length; i++){
            if (matrix[parseInt(i.toString(), 10)] === 1) return i;
        }
        return cellIndex;
    };
    FocusStrategy.prototype.filterfocus = function() {
        if (this.parent.filterSettings.type !== "FilterBar") this.restoreFocus();
    };
    FocusStrategy.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $aqzbR.EventHandler).remove(this.parent.element, "mousedown", this.focusCheck);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "touchstart", this.focusCheck);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "focus", this.onFocus);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "focusout", this.onBlur);
        this.parent.element.removeEventListener("focus", this.passiveHandler, true);
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, false);
    };
    FocusStrategy.prototype.destroy = function() {
        this.removeEventListener();
    };
    FocusStrategy.prototype.restoreFocus = function() {
        var groupModule = this.parent.groupModule;
        if (this.parent.allowGrouping && groupModule && (groupModule.groupSortFocus || groupModule.groupTextFocus)) {
            groupModule.groupSortFocus = false;
            groupModule.groupTextFocus = false;
            return;
        }
        this.firstHeaderCellClick = true;
        this.addFocus(this.getContent().getFocusInfo());
    };
    FocusStrategy.prototype.restoreFocusWithAction = function(e) {
        if (!this.parent.enableInfiniteScrolling) {
            var matrix = this.getContent().matrix;
            var current = matrix.current;
            switch(e.requestType){
                case "grouping":
                case "ungrouping":
                    current[1] = current.length && !this.parent.groupSettings.showGroupedColumn && !(0, $3EnZW.isNullOrUndefined)(matrix.matrix[current[0]]) ? matrix.matrix[current[0]].indexOf(1) : e.requestType === "grouping" ? current[1] + 1 : current[1] - 1;
                    break;
            }
            this.getContent().matrix.current = current;
            this.prevIndexes = {
                rowIndex: current[0],
                cellIndex: current[1]
            };
            var groupModule = this.parent.groupModule;
            if (this.parent.allowGrouping && groupModule && groupModule.groupCancelFocus) {
                var focusableGroupedItems = groupModule.getFocusableGroupedItems();
                if (focusableGroupedItems.length) {
                    if (focusableGroupedItems[0].parentElement.getAttribute("ej-mappingname") === e.columnName) focusableGroupedItems[3].focus();
                    else focusableGroupedItems[0].focus();
                } else groupModule.element.focus();
                groupModule.groupCancelFocus = false;
                return;
            }
            this.addFocus(this.getContent().getFocusInfo());
        }
    };
    FocusStrategy.prototype.clearIndicator = function() {
        if (!this.currentInfo.element || !this.currentInfo.elementToFocus) return;
        (0, $4ZDHT.removeClass)([
            this.currentInfo.element,
            this.currentInfo.elementToFocus
        ], [
            "e-focus",
            "e-focused"
        ]);
    };
    FocusStrategy.prototype.getPrevIndexes = function() {
        var forget = this.forget;
        this.forget = false;
        return forget || !Object.keys(this.prevIndexes).length ? {
            rowIndex: null,
            cellIndex: null
        } : this.prevIndexes;
    };
    FocusStrategy.prototype.forgetPrevious = function() {
        this.forget = true;
    };
    FocusStrategy.prototype.setActiveByKey = function(action, active) {
        if (this.parent.frozenRows === 0) return;
        // eslint-disable-next-line prefer-const
        var info;
        var actions = {
            "home": function() {
                return {
                    toHeader: !info.isContent,
                    toFrozen: true
                };
            },
            "end": function() {
                return {
                    toHeader: !info.isContent,
                    toFrozen: false
                };
            },
            "ctrlHome": function() {
                return {
                    toHeader: true,
                    toFrozen: false
                };
            },
            "ctrlEnd": function() {
                return {
                    toHeader: false,
                    toFrozen: false
                };
            }
        };
        if (!(action in actions)) return;
        info = active.getInfo();
        var swap = actions["" + action]();
        this.setActive(!swap.toHeader);
        this.getContent().matrix.current = active.matrix.current;
    };
    FocusStrategy.prototype.internalCellFocus = function(e) {
        if (!(e.byKey && e.container.isContent && (e.keyArgs.action === "enter" && e.parent.classList.contains("e-detailcell") || (e.keyArgs.action === "tab" || e.keyArgs.action === "shiftTab") && e.parent.classList.contains("e-unboundcell")))) return;
        this.clearIndicator();
        var focusEle;
        if (e.parent && e.parent.closest(".e-unboundcell") && e.keyArgs.action === "shiftTab") focusEle = this.commandColumnFocusElement(e.parent, true);
        else focusEle = this.getContent().getFocusable(this.getFocusedElement());
        this.setFocusedElement(focusEle);
        this.currentInfo.skipAction = true;
    };
    FocusStrategy.prototype.commandColumnFocusElement = function(cell, isLast) {
        var commandButtons = cell.querySelectorAll("button:not(.e-hide)");
        return isLast ? commandButtons[commandButtons.length - 1] : commandButtons[0];
    };
    return FocusStrategy;
}();
/**
 * Create matrix from row collection which act as mental model for cell navigation
 *
 * @hidden
 */ var $008b258884e5b2ce$export$5b12bf1653c0dd85 = /** @class */ function() {
    function Matrix() {
        this.matrix = [];
        this.current = [];
    }
    Matrix.prototype.set = function(rowIndex, columnIndex, allow) {
        rowIndex = Math.max(0, Math.min(rowIndex, this.rows));
        columnIndex = Math.max(0, Math.min(columnIndex, this.columns));
        this.matrix[parseInt(rowIndex.toString(), 10)] = this.matrix[parseInt(rowIndex.toString(), 10)] || [];
        this.matrix[parseInt(rowIndex.toString(), 10)][parseInt(columnIndex.toString(), 10)] = allow ? 1 : 0;
    };
    Matrix.prototype.get = function(rowIndex, columnIndex, navigator1, action, validator) {
        var tmp = columnIndex;
        if (rowIndex + navigator1[0] < 0) return [
            rowIndex,
            columnIndex
        ];
        if (!document.getElementsByClassName("e-popup-open").length || document.querySelectorAll(".e-popup-open .e-editedrow").length && !document.querySelectorAll(".e-popup-open:not(.e-dialog)").length) rowIndex = Math.max(0, Math.min(rowIndex + navigator1[0], this.rows));
        var emptyTable = true;
        if ((0, $3EnZW.isNullOrUndefined)(this.matrix[parseInt(rowIndex.toString(), 10)])) return null;
        columnIndex = Math.max(0, Math.min(columnIndex + navigator1[1], this.matrix[parseInt(rowIndex.toString(), 10)].length - 1));
        if (tmp + navigator1[1] > this.matrix[parseInt(rowIndex.toString(), 10)].length - 1 && validator(rowIndex, columnIndex, action)) return [
            rowIndex,
            tmp
        ];
        var first = this.first(this.matrix[parseInt(rowIndex.toString(), 10)], columnIndex, navigator1, true, action);
        columnIndex = first === null ? tmp : first;
        var val = (0, $3EnZW.getValue)(rowIndex + "." + columnIndex, this.matrix);
        if (rowIndex === this.rows && (action === "downArrow" || action === "enter")) navigator1[0] = -1;
        if (first === null) {
            for(var i = 0; i < this.rows; i++)if (this.matrix[parseInt(i.toString(), 10)].some(function(v) {
                return v === 1;
            })) {
                emptyTable = false;
                break;
            }
            if (emptyTable) {
                rowIndex = this.current.length ? this.current[0] : 0;
                return [
                    rowIndex,
                    columnIndex
                ];
            }
        }
        return this.inValid(val) || !validator(rowIndex, columnIndex, action) ? this.get(rowIndex, tmp, navigator1, action, validator) : [
            rowIndex,
            columnIndex
        ];
    };
    Matrix.prototype.first = function(vector, index, navigator1, moveTo, action) {
        if ((index < 0 || index === vector.length) && this.inValid(vector[parseInt(index.toString(), 10)]) && action !== "upArrow" && action !== "downArrow" || !vector.some(function(v) {
            return v === 1;
        })) return null;
        return !this.inValid(vector[parseInt(index.toString(), 10)]) ? index : this.first(vector, [
            "upArrow",
            "downArrow",
            "shiftUp",
            "shiftDown",
            "enter",
            "shiftEnter"
        ].indexOf(action) !== -1 ? moveTo ? 0 : ++index : index + navigator1[1], navigator1, false, action);
    };
    Matrix.prototype.select = function(rowIndex, columnIndex) {
        rowIndex = Math.max(0, Math.min(rowIndex, this.rows));
        columnIndex = Math.max(0, Math.min(columnIndex, this.matrix[parseInt(rowIndex.toString(), 10)].length - 1));
        this.current = [
            rowIndex,
            columnIndex
        ];
    };
    Matrix.prototype.generate = function(rows, selector, isRowTemplate) {
        this.rows = rows.length - 1;
        this.matrix = [];
        for(var i = 0; i < rows.length; i++){
            var cells = rows[parseInt(i.toString(), 10)].cells.filter(function(c) {
                return c.isSpanned !== true;
            });
            this.columns = Math.max(cells.length - 1, this.columns | 0);
            var incrementNumber = 0;
            for(var j = 0; j < cells.length; j++){
                if (cells[parseInt(j.toString(), 10)].column && cells[parseInt(j.toString(), 10)].column.columns) incrementNumber = this.columnsCount(cells[parseInt(j.toString(), 10)].column.columns, incrementNumber);
                else incrementNumber++;
                this.set(i, j, rows[parseInt(i.toString(), 10)].visible === false ? false : selector(rows[parseInt(i.toString(), 10)], cells[parseInt(j.toString(), 10)], isRowTemplate));
            }
            this.columns = Math.max(incrementNumber - 1, this.columns | 0);
        }
        return this.matrix;
    };
    Matrix.prototype.columnsCount = function(rowColumns, currentColumnCount) {
        var columns = rowColumns;
        var incrementNumber = currentColumnCount;
        for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].columns) incrementNumber = this.columnsCount(columns[parseInt(i.toString(), 10)].columns, incrementNumber);
        else incrementNumber++;
        return incrementNumber;
    };
    Matrix.prototype.inValid = function(value) {
        return value === 0 || value === undefined;
    };
    return Matrix;
}();
/**
 * @hidden
 */ var $008b258884e5b2ce$export$b18f85c700beb1a6 = /** @class */ function() {
    function ContentFocus(parent) {
        var _this = this;
        this.matrix = new $008b258884e5b2ce$export$5b12bf1653c0dd85();
        this.lastIdxCell = false;
        this.parent = parent;
        this.keyActions = {
            "rightArrow": [
                0,
                1
            ],
            "tab": [
                0,
                1
            ],
            "leftArrow": [
                0,
                -1
            ],
            "shiftTab": [
                0,
                -1
            ],
            "upArrow": [
                -1,
                0
            ],
            "downArrow": [
                1,
                0
            ],
            "shiftUp": [
                -1,
                0
            ],
            "shiftDown": [
                1,
                0
            ],
            "shiftRight": [
                0,
                1
            ],
            "shiftLeft": [
                0,
                -1
            ],
            "enter": [
                1,
                0
            ],
            "shiftEnter": [
                -1,
                0
            ]
        };
        this.indexesByKey = function(action) {
            var opt = {
                "home": [
                    _this.matrix.current[0],
                    -1,
                    0,
                    1
                ],
                "end": [
                    _this.matrix.current[0],
                    _this.matrix.columns + 1,
                    0,
                    -1
                ],
                "ctrlHome": [
                    0,
                    -1,
                    0,
                    1
                ],
                "ctrlEnd": [
                    _this.matrix.rows,
                    _this.matrix.columns + 1,
                    0,
                    -1
                ]
            };
            return opt["" + action] || null;
        };
    }
    ContentFocus.prototype.getTable = function() {
        return this.parent.getContentTable();
    };
    ContentFocus.prototype.onKeyPress = function(e) {
        var isMacLike = /(Mac)/i.test(navigator.platform);
        if (isMacLike && e.metaKey) {
            if (e.action === "home") e.action = "ctrlHome";
            else if (e.action === "end") e.action = "ctrlEnd";
            else if ([
                "downArrow",
                "upArrow",
                "leftArrow",
                "rightArrow"
            ].indexOf(e.action) !== -1) return;
        }
        var navigators = this.keyActions[e.action];
        var current = this.getCurrentFromAction(e.action, navigators, e.action in this.keyActions, e);
        if (!current) return;
        if (([
            "tab",
            "shiftTab"
        ].indexOf(e.action) > -1 && this.matrix.current || []).toString() === current.toString() || this.parent.allowPaging && !this.parent.pagerModule.pagerObj.checkPagerHasFocus() && this.matrix.current[0] === this.matrix.rows && (this.parent.editSettings.mode === "Batch" && this.parent.editSettings.allowAdding && e.keyCode === 40 || e.keyCode === 40)) {
            if (current.toString() === [
                this.matrix.rows,
                this.matrix.columns
            ].toString() || current.toString() === [
                0,
                0
            ].toString() || this.matrix.current[0] === this.matrix.rows && this.matrix.current.toString() === current.toString() || this.parent.allowGrouping && this.parent.infiniteScrollSettings.enableCache && current.toString() === [
                0,
                1
            ].toString()) return false;
            else current = this.editNextRow(current[0], current[1], e.action);
        }
        this.matrix.select(current[0], current[1]);
    };
    ContentFocus.prototype.editNextRow = function(rowIndex, cellIndex, action) {
        var gObj = this.parent;
        var editNextRow = gObj.editSettings.allowNextRowEdit && (gObj.isEdit || gObj.isLastCellPrimaryKey);
        var visibleIndex = gObj.getColumnIndexByField(gObj.getVisibleColumns()[0].field);
        var row = this.getTable().rows[parseInt(rowIndex.toString(), 10)];
        var cell = gObj.editSettings.showAddNewRow && row.classList.contains("e-addedrow") ? row.querySelectorAll("td:not(.e-editcell)")[parseInt(cellIndex.toString(), 10)] : row.cells[parseInt(cellIndex.toString(), 10)];
        if (action === "tab" && editNextRow) {
            rowIndex++;
            var index = this.getTable().rows[parseInt(rowIndex.toString(), 10)].getElementsByClassName("e-indentcell").length + this.getTable().rows[parseInt(rowIndex.toString(), 10)].getElementsByClassName("e-detailrowcollapse").length;
            cellIndex = visibleIndex + index;
        }
        if (action === "shiftTab" && editNextRow) {
            rowIndex--;
            cellIndex = gObj.getColumnIndexByField(gObj.getVisibleColumns()[gObj.getVisibleColumns().length - 1].field);
        }
        return !cell.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) && !cell.classList.contains("e-headercell") && !cell.classList.contains("e-groupcaption") && !cell.classList.contains("e-filterbarcell") ? this.editNextRow(rowIndex, cellIndex, action) : [
            rowIndex,
            cellIndex
        ];
    };
    ContentFocus.prototype.getCurrentFromAction = function(action, navigator1, isPresent, e) {
        if (navigator1 === void 0) navigator1 = [
            0,
            0
        ];
        if (!isPresent && !this.indexesByKey(action) || this.matrix.current.length === 0) return null;
        if (!this.shouldFocusChange(e)) return this.matrix.current;
        // eslint-disable-next-line
        var _a = this.indexesByKey(action) || this.matrix.current.concat(navigator1), rowIndex = _a[0], cellIndex = _a[1], rN = _a[2], cN = _a[3];
        if (this.parent.allowGrouping && !(0, $3EnZW.isNullOrUndefined)(this.parent.groupSettings.columns) && this.parent.groupSettings.columns.length && this.parent.aggregates.length && action === "enter") for(var i = rowIndex; i < this.matrix.matrix.length; i++){
            var row = this.getTable().rows[i + 1];
            if (row && row.cells[parseInt(cellIndex.toString(), 10)] && row.cells[parseInt(cellIndex.toString(), 10)].classList.contains("e-rowcell")) return [
                i + 1,
                cellIndex
            ];
            if (i === this.matrix.matrix.length - 1) return [
                rowIndex,
                cellIndex
            ];
        }
        if (action === "ctrlEnd" || action === "end") {
            var lastContentCellIndex = [
                this.matrix.matrix.length - 1,
                this.matrix.matrix[this.matrix.matrix.length - 1].length - 1
            ];
            if (action === "end") lastContentCellIndex = [
                rowIndex,
                this.matrix.matrix[parseInt(rowIndex.toString(), 10)].length - 1
            ];
            if (this.matrix.matrix[lastContentCellIndex[0]][lastContentCellIndex[1]] === 0) lastContentCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(this.matrix.matrix, lastContentCellIndex, false);
            rowIndex = lastContentCellIndex[0];
            cellIndex = lastContentCellIndex[1] + 1;
        }
        var current = this.matrix.get(rowIndex, cellIndex, [
            rN,
            cN
        ], action, this.validator());
        return current;
    };
    ContentFocus.prototype.onClick = function(e, force) {
        var target = e.target;
        this.target = target;
        target = target.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) ? target : (0, $4ZDHT.closest)(target, "td");
        target = target ? target : (0, $4ZDHT.closest)(e.target, "td.e-detailrowcollapse") || (0, $4ZDHT.closest)(e.target, "td.e-detailrowexpand");
        target = (0, $4ZDHT.closest)(e.target, "td.e-detailcell") ? (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)((0, $4ZDHT.closest)(e.target, ".e-grid"), "td.e-detailcell")) ? null : target : target;
        target = target && (0, $4ZDHT.closest)(target, "table").classList.contains($1b5568e76cdae6d4$export$9852986a3ec5f6a0) ? target : null;
        if (!target) return false;
        var rowIdx = target.parentElement.rowIndex;
        if (this.parent.editSettings.showAddNewRow && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow")) rowIdx = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow").rowIndex;
        var _a = [
            rowIdx,
            target.cellIndex
        ], rowIndex = _a[0], cellIndex = _a[1];
        var _b = this.matrix.current, oRowIndex = _b[0], oCellIndex = _b[1];
        var val = (0, $3EnZW.getValue)(rowIndex + "." + cellIndex, this.matrix.matrix);
        if (this.matrix.inValid(val) || !force && oRowIndex === rowIndex && oCellIndex === cellIndex || !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca) && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupcaption") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-recordpluscollapse") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-recordplusexpand") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-detailrowcollapse") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-detailrowexpand") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-templatecell")) return false;
        this.matrix.select(rowIndex, cellIndex);
    };
    ContentFocus.prototype.getFocusInfo = function() {
        var info = {};
        var _a = this.matrix.current, _b = _a[0], rowIndex = _b === void 0 ? 0 : _b, _c = _a[1], cellIndex = _c === void 0 ? 0 : _c;
        this.matrix.current = [
            rowIndex,
            cellIndex
        ];
        var row = this.getTable().rows[parseInt(rowIndex.toString(), 10)];
        info.element = !(0, $3EnZW.isNullOrUndefined)(row) ? this.parent.editSettings.showAddNewRow && row.classList.contains("e-addedrow") ? row.querySelectorAll("td:not(.e-editcell)")[parseInt(cellIndex.toString(), 10)] : row.cells[parseInt(cellIndex.toString(), 10)] : null;
        if (!info.element) return info;
        info.elementToFocus = (!info.element.classList.contains("e-unboundcell") || this.parent.editSettings.showAddNewRow && info.element.classList.contains("e-unboundcell") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(info.element, "e-addedrow")) && !info.element.classList.contains("e-detailcell") ? this.getFocusable(info.element) : info.element;
        info.elementToFocus = info.element.classList.contains("e-detailcell") && info.element.querySelector(".e-childgrid") ? info.element.querySelector(".e-childgrid") : info.elementToFocus;
        if (this.parent.editSettings.mode === "Batch" && this.parent.isEdit && info.elementToFocus.tagName.toLowerCase() === "input" && info.elementToFocus.classList.contains("e-dropdownlist")) info.elementToFocus = info.elementToFocus.parentElement;
        info.outline = true;
        info.uid = info.element.parentElement.getAttribute("data-uid");
        return info;
    };
    ContentFocus.prototype.getFocusable = function(element) {
        var query = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
        var isTemplate = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(element, ".e-templatecell"));
        if (this.parent.isEdit) {
            var commandCellQuery = this.parent.editSettings.showAddNewRow && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(element, "e-addedrow") ? ", button:not(.e-hide)" : "";
            query = 'input:not([type="hidden"]), select:not([aria-hidden="true"]), textarea' + commandCellQuery;
        }
        var child = [].slice.call(element.querySelectorAll(query));
        if (element.classList.contains("e-fltrtemp")) {
            var focusElement = [].slice.call(element.querySelectorAll(".e-fltrtemp-focus"));
            if (this.focusType === "click" && this.target && this.target.classList.contains("e-fltrtemp-focus")) return this.target;
            else if (this.focusType === "key" && focusElement.length && (this.action === "tab" || this.action === "shiftTab")) {
                var elementIndex = focusElement.indexOf(this.currentTarget);
                return elementIndex === -1 ? focusElement[this.action === "tab" ? 0 : focusElement.length - 1] : focusElement[this.action === "tab" ? elementIndex + 1 : elementIndex - 1];
            }
        }
        /* Select the first focusable child element
         * if no child found then select the cell itself.
         * if Grid is in editable state, check for editable control inside child.
         */ return child.length ? isTemplate && child.length > 1 && !(this.parent.editSettings.mode === "Batch" && this.parent.isEdit && this.target) ? this.target ? this.target : element : child[0] : element;
    };
    ContentFocus.prototype.selector = function(row, cell, isRowTemplate) {
        var types = [
            (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Expand,
            (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupCaption,
            (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary,
            (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary
        ];
        return (row.isDataRow && cell.visible && (cell.isDataCell || cell.isTemplate) || row.isDataRow && cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailExpand && (0, $3EnZW.isNullOrUndefined)(cell.visible) || !row.isDataRow && types.indexOf(cell.cellType) > -1 && !((cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary) && !(cell.isDataCell && cell.visible)) || cell.column && cell.visible && cell.column.type === "checkbox" || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CommandColumn || row.isDataRow && isRowTemplate) && !(row.edit === "delete" && row.isDirty);
    };
    ContentFocus.prototype.nextRowFocusValidate = function(index) {
        var lastIndex = index;
        for(var i = index, len = this.matrix.rows; i <= len; i++){
            if (this.matrix.matrix[parseInt(index.toString(), 10)].indexOf(1) === -1) index = index + 1;
            else return index;
        }
        this.lastIdxCell = true;
        return lastIndex;
    };
    ContentFocus.prototype.previousRowFocusValidate = function(index) {
        var firstIndex = index;
        for(var i = index, len = 0; i >= len; i--){
            if (this.matrix.matrix[parseInt(index.toString(), 10)].indexOf(1) === -1) {
                index = index - 1;
                if (index < 0) {
                    this.lastIdxCell = true;
                    return firstIndex;
                }
            } else return index;
        }
        return firstIndex;
    };
    ContentFocus.prototype.jump = function(action, current) {
        this.lastIdxCell = false;
        var enterFrozen = this.parent.frozenRows !== 0 && action === "shiftEnter";
        var headerSwap = (action === "upArrow" || enterFrozen) && current[0] === 0;
        if (this.matrix.matrix[current[0]]) {
            if (action === "tab" && this.matrix.matrix.length && current[1] === this.matrix.matrix[current[0]].lastIndexOf(1) && this.matrix.matrix.length - 1 !== current[0]) {
                this.matrix.current[0] = this.nextRowFocusValidate(this.matrix.current[0] + 1);
                this.matrix.current[1] = -1;
            }
        }
        if (action === "shiftTab" && current[0] !== 0 && this.matrix.matrix[current[0]].indexOf(1) === current[1]) {
            this.matrix.current[0] = this.previousRowFocusValidate(this.matrix.current[0] - 1);
            this.matrix.current[1] = this.matrix.matrix[current[0]].length;
        }
        var isHeaderFocus = false;
        var row = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(document.activeElement, "e-addedrow") && this.parent.editSettings.showAddNewRow ? (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(document.activeElement, "e-addedrow") : document.activeElement.parentElement;
        if ((this.parent.enableVirtualization || this.parent.infiniteScrollSettings.enableCache) && !(0, $3EnZW.isNullOrUndefined)(row) && row.classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d)) {
            var rowIndex = parseInt(row.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            isHeaderFocus = rowIndex > 0;
        }
        var info = {
            swap: !isHeaderFocus ? (action === "upArrow" || enterFrozen) && current[0] === 0 : false,
            toHeader: headerSwap
        };
        return info;
    };
    ContentFocus.prototype.getNextCurrent = function(previous, swap, active, action) {
        if (previous === void 0) previous = [];
        var current = [];
        if (action === "rightArrow" || action === "tab") {
            current[0] = previous[0];
            current[1] = -1;
        }
        if (action === "downArrow" || action === "enter") {
            current[0] = -1;
            current[1] = previous[1];
        }
        return current;
    };
    ContentFocus.prototype.generateRows = function(rows, optionals) {
        var _a;
        var matrix = optionals.matrix, handlerInstance = optionals.handlerInstance;
        var len = handlerInstance.matrix.matrix.length;
        var defaultLen = this.parent.allowFiltering && this.parent.filterSettings.type === "FilterBar" ? len + 1 : len;
        handlerInstance.matrix.matrix = handlerInstance.matrix.matrix.slice(0, defaultLen); //Header matrix update.
        handlerInstance.matrix.rows = defaultLen;
        (_a = handlerInstance.matrix.matrix).push.apply(_a, matrix);
        handlerInstance.matrix.rows += matrix.length;
    };
    ContentFocus.prototype.getInfo = function(e) {
        var info = this.getFocusInfo();
        var _a = this.matrix.current, rIndex = _a[0], cIndex = _a[1];
        var isData = info.element.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca);
        var isSelectable = isData || e && e.action !== "enter" && (info.element.classList.contains("e-detailrowcollapse") || info.element.classList.contains("e-detailrowexpand"));
        // eslint-disable-next-line
        var _b = [
            Math.min(parseInt(info.element.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10), rIndex),
            Math.min(parseInt(info.element.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10), cIndex)
        ], rowIndex = _b[0], cellIndex = _b[1];
        if (this.parent.allowGrouping && this.parent.groupSettings.enableLazyLoading && isData) rowIndex = this.parent.getDataRows().indexOf(info.element.parentElement);
        if (this.parent.enableVirtualization && this.parent.groupSettings.columns.length) {
            rowIndex = rIndex;
            cellIndex = cIndex;
        }
        if (this.parent.editSettings.showAddNewRow && this.parent.editSettings.newRowPosition === "Top" && !this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling && e && e.action === "downArrow") rowIndex++;
        return {
            isContent: true,
            isDataCell: isData,
            indexes: [
                rowIndex,
                cellIndex
            ],
            isSelectable: isSelectable
        };
    };
    ContentFocus.prototype.validator = function() {
        var table = this.getTable();
        return function(rowIndex, cellIndex, action) {
            if (!(0, $3EnZW.isNullOrUndefined)(table.rows[parseInt(rowIndex.toString(), 10)])) {
                var cell = void 0;
                cellIndex = table.querySelector(".e-emptyrow") ? 0 : cellIndex;
                if (table.rows[parseInt(rowIndex.toString(), 10)].cells[0].classList.contains("e-editcell")) cell = table.rows[parseInt(rowIndex.toString(), 10)].cells[0].querySelectorAll("td")[parseInt(cellIndex.toString(), 10)];
                else cell = table.rows[parseInt(rowIndex.toString(), 10)].cells[parseInt(cellIndex.toString(), 10)];
                var isCellWidth = cell.getBoundingClientRect().width !== 0;
                if (action === "enter" || action === "shiftEnter") return isCellWidth && cell.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca);
                if ((action === "shiftUp" || action === "shiftDown") && cell.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca)) return isCellWidth;
                else if (action !== "shiftUp" && action !== "shiftDown") return isCellWidth;
            }
            return false;
        };
    };
    ContentFocus.prototype.shouldFocusChange = function(e) {
        var _a = this.matrix.current, _b = _a[0], rIndex = _b === void 0 ? -1 : _b, _c = _a[1], cIndex = _c === void 0 ? -1 : _c;
        if (rIndex < 0 || cIndex < 0) return true;
        var cell = (0, $3EnZW.getValue)(rIndex + ".cells." + cIndex, this.getTable().rows);
        if (!cell) return true;
        return e.action === "enter" || e.action === "shiftEnter" ? cell.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) && !cell.classList.contains("e-unboundcell") || cell.classList.contains("e-editedbatchcell") && !cell.classList.contains("e-detailcell") : true;
    };
    ContentFocus.prototype.getGridSeletion = function() {
        return this.parent.allowSelection && this.parent.selectionSettings.allowColumnSelection;
    };
    return ContentFocus;
}();
/**
 * @hidden
 */ var $008b258884e5b2ce$export$84664db8b649a521 = /** @class */ function(_super) {
    $008b258884e5b2ce$var$__extends(HeaderFocus, _super);
    function HeaderFocus(parent) {
        return _super.call(this, parent) || this;
    }
    HeaderFocus.prototype.getTable = function() {
        return this.parent.getHeaderTable();
    };
    HeaderFocus.prototype.onClick = function(e) {
        this.focusType = "click";
        var target = e.target;
        this.target = target;
        target = target.classList.contains("e-headercell") ? target : (0, $4ZDHT.closest)(target, "th");
        if (!target && (this.parent.frozenRows !== 0 || (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && this.parent.editSettings.showAddNewRow)) target = e.target.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) ? e.target : (0, $4ZDHT.closest)(e.target, "td");
        if (e.target.classList.contains("e-columnheader") || e.target.querySelector(".e-stackedheadercell")) return false;
        if (!target) return;
        var rowIdx = target.parentElement.rowIndex;
        if (this.parent.editSettings.showAddNewRow && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow")) rowIdx = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-addedrow").rowIndex;
        var _a = [
            rowIdx,
            target.cellIndex
        ], rowIndex = _a[0], cellIndex = _a[1];
        var val = (0, $3EnZW.getValue)(rowIndex + "." + cellIndex, this.matrix.matrix);
        if (this.matrix.inValid(val)) return false;
        this.matrix.select(rowIdx, target.cellIndex);
    };
    HeaderFocus.prototype.getFocusInfo = function() {
        var info = {};
        var _a = this.matrix.current, _b = _a[0], rowIndex = _b === void 0 ? 0 : _b, _c = _a[1], cellIndex = _c === void 0 ? 0 : _c;
        var row = this.getTable().rows[parseInt(rowIndex.toString(), 10)];
        info.element = !(0, $3EnZW.isNullOrUndefined)(row) ? this.parent.editSettings.showAddNewRow && row.classList.contains("e-addedrow") ? row.querySelectorAll("td:not(.e-editcell)")[parseInt(cellIndex.toString(), 10)] : row.cells[parseInt(cellIndex.toString(), 10)] : null;
        if (!(0, $3EnZW.isNullOrUndefined)(info.element)) {
            info.elementToFocus = this.getFocusable(info.element);
            info.outline = !info.element.classList.contains("e-filterbarcell");
        }
        return info;
    };
    HeaderFocus.prototype.selector = function(row, cell) {
        return cell.visible && (cell.column.field !== undefined || cell.isTemplate || !(0, $3EnZW.isNullOrUndefined)(cell.column.template) || !(0, $3EnZW.isNullOrUndefined)(cell.column.commands)) || cell.column.type === "checkbox" || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader;
    };
    HeaderFocus.prototype.jump = function(action, current) {
        var enterFrozen = this.parent.frozenRows !== 0 && action === "enter";
        var isLastCell;
        var lastRow;
        if (this.parent.enableHeaderFocus && action === "tab") {
            lastRow = this.matrix.matrix.length - 1 === current[0];
            isLastCell = current[1] === this.matrix.matrix[current[0]].lastIndexOf(1);
            if (isLastCell) {
                if (!lastRow) this.matrix.current[0] = this.matrix.current[0] + 1;
                else this.matrix.current[0] = 0;
                this.matrix.current[1] = -1;
            }
        }
        return {
            swap: (action === "downArrow" || enterFrozen) && current[0] === this.matrix.matrix.length - 1 || action === "tab" && lastRow && isLastCell
        };
    };
    HeaderFocus.prototype.getNextCurrent = function(previous, swap, active, action) {
        if (previous === void 0) previous = [];
        var current1 = [];
        if (action === "rightArrow" || action === "shiftRight" && this.getGridSeletion() || action === "tab") {
            current1[0] = previous[0];
            current1[1] = -1;
        }
        if (action === "upArrow" || action === "shiftEnter") {
            current1[0] = this.matrix.matrix.length;
            current1[1] = previous[1];
        }
        return current1;
    };
    HeaderFocus.prototype.generateRows = function(rows) {
        var length = this.matrix.matrix.length;
        if (this.parent.allowFiltering && this.parent.filterSettings.type === "FilterBar") {
            this.matrix.rows = ++this.matrix.rows;
            var cells = rows[0].cells;
            var incrementNumber = 0;
            for(var i = 0; i < cells.length; i++)if (cells[parseInt(i.toString(), 10)].column && cells[parseInt(i.toString(), 10)].column.columns) incrementNumber = this.checkFilterColumn(cells[parseInt(i.toString(), 10)].column.columns, length, incrementNumber);
            else {
                this.matrix.set(length, incrementNumber, cells[parseInt(i.toString(), 10)].visible && cells[parseInt(i.toString(), 10)].column.allowFiltering !== false);
                incrementNumber++;
            }
        }
    };
    HeaderFocus.prototype.checkFilterColumn = function(rowColumns, rowIndex, columnIndex) {
        var columns = rowColumns;
        var incrementNumber = columnIndex;
        for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].columns) incrementNumber = this.checkFilterColumn(columns[parseInt(i.toString(), 10)].columns, rowIndex, incrementNumber);
        else {
            this.matrix.set(rowIndex, incrementNumber, columns[parseInt(i.toString(), 10)].visible && columns[parseInt(i.toString(), 10)].allowFiltering !== false);
            incrementNumber++;
        }
        return incrementNumber;
    };
    HeaderFocus.prototype.getInfo = function(e) {
        return (0, $3EnZW.extend)(_super.prototype.getInfo.call(this, e), {
            isContent: false,
            isHeader: true
        });
    };
    HeaderFocus.prototype.validator = function() {
        return function() {
            return true;
        };
    };
    HeaderFocus.prototype.shouldFocusChange = function(e) {
        var _a = this.matrix.current, rowIndex = _a[0], columnIndex = _a[1];
        if (rowIndex < 0 || columnIndex < 0) return true;
        var cell = (0, $3EnZW.getValue)(rowIndex + ".cells." + columnIndex, this.getTable().rows);
        if (!cell) return true;
        return e.action === "enter" || e.action === "altDownArrow" ? !cell.classList.contains("e-headercell") : true;
    };
    HeaderFocus.prototype.getHeaderType = function() {
        return "HeaderFocus";
    };
    return HeaderFocus;
}($008b258884e5b2ce$export$b18f85c700beb1a6);
/** @hidden */ var $008b258884e5b2ce$export$5a58787633b0b5d8 = /** @class */ function() {
    function SearchBox(searchBox, serviceLocator) {
        this.searchBox = searchBox;
        this.serviceLocator = serviceLocator;
        this.l10n = this.serviceLocator.getService("localization");
    }
    SearchBox.prototype.searchFocus = function(args) {
        args.target.parentElement.classList.add("e-input-focus");
        if (args.target.classList.contains("e-input") && args.target.classList.contains("e-search") && args.target.value) {
            var sIcon = args.target.parentElement.querySelector(".e-sicon");
            sIcon.classList.add("e-clear-icon");
            sIcon.setAttribute("title", this.l10n.getConstant("Clear"));
            sIcon.style.cursor = "pointer";
        }
    };
    SearchBox.prototype.searchBlur = function(args) {
        var relatedTarget = args.relatedTarget ? args.relatedTarget : null;
        if (relatedTarget && relatedTarget.classList.contains("e-sicon")) {
            if (relatedTarget.classList.contains("e-clear-icon")) args.target.parentElement.classList.remove("e-input-focus");
        } else args.target.parentElement.classList.remove("e-input-focus");
        if (args.target.classList.contains("e-search") && (relatedTarget && !relatedTarget.classList.contains("e-sicon e-clear-icon") && !relatedTarget.classList.contains("e-sicon") || (0, $3EnZW.isNullOrUndefined)(relatedTarget))) {
            var sIcon = args.target.parentElement.querySelector(".e-sicon");
            sIcon.classList.remove("e-clear-icon");
            sIcon.removeAttribute("title");
            sIcon.style.cursor = "default";
        }
    };
    SearchBox.prototype.wireEvent = function() {
        if (this.searchBox) {
            (0, $aqzbR.EventHandler).add(this.searchBox, "focus", this.searchFocus, this);
            (0, $aqzbR.EventHandler).add(this.searchBox, "blur", this.searchBlur, this);
        }
    };
    SearchBox.prototype.unWireEvent = function() {
        if (this.searchBox) {
            (0, $aqzbR.EventHandler).remove(this.searchBox, "focus", this.searchFocus);
            (0, $aqzbR.EventHandler).remove(this.searchBox, "blur", this.searchBlur);
        }
    };
    return SearchBox;
}();


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $0f1c8bc7df35ce7b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0f1c8bc7df35ce7b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the paging behavior of the Grid.
 */ var $0f1c8bc7df35ce7b$export$803d23cfbdb4ac71 = /** @class */ function(_super) {
    $0f1c8bc7df35ce7b$var$__extends(PageSettings, _super);
    function PageSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(12)
    ], PageSettings.prototype, "pageSize", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(8)
    ], PageSettings.prototype, "pageCount", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], PageSettings.prototype, "currentPage", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)()
    ], PageSettings.prototype, "totalRecordsCount", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PageSettings.prototype, "enableQueryString", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PageSettings.prototype, "pageSizes", void 0);
    $0f1c8bc7df35ce7b$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PageSettings.prototype, "template", void 0);
    return PageSettings;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $b46e76cd3738afcf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b46e76cd3738afcf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the column chooser behavior of the Grid.
 */ var $b46e76cd3738afcf$export$ff0549a76c45d2e4 = /** @class */ function(_super) {
    $b46e76cd3738afcf$var$__extends(ColumnChooserSettings, _super);
    function ColumnChooserSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $b46e76cd3738afcf$var$__decorate([
        (0, $5rsSz.Property)("startsWith")
    ], ColumnChooserSettings.prototype, "operator", void 0);
    $b46e76cd3738afcf$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColumnChooserSettings.prototype, "ignoreAccent", void 0);
    return ColumnChooserSettings;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");





/**
 * The `Selection` module is used to handle cell and row selection.
 */ var $f156c0a94af14ffc$export$52baac22726c72bf = /** @class */ function() {
    /**
     * Constructor for the Grid selection module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {SelectionSettings} selectionSettings - specifies the selectionsettings
     * @param {ServiceLocator} locator - specifies the ServiceLocator
     * @hidden
     */ function Selection(parent, selectionSettings, locator) {
        //Internal letiables
        /**
         * @hidden
         */ this.selectedRowIndexes = [];
        /**
         * @hidden
         */ this.selectedRowCellIndexes = [];
        /**
         * @hidden
         */ this.selectedRecords = [];
        /**
         * @hidden
         */ this.preventFocus = false;
        /**
         *  @hidden
         */ this.selectedColumnsIndexes = [];
        this.checkBoxState = false;
        this.isMultiShiftRequest = false;
        this.isMultiCtrlRequest = false;
        this.isMultiCtrlRequestCell = false;
        this.enableSelectMultiTouch = false;
        this.clearRowCheck = false;
        this.selectRowCheck = false;
        /**
         * @hidden
         */ this.selectedRowState = {};
        this.unSelectedRowState = {};
        this.totalRecordsCount = 0;
        this.chkAllCollec = [];
        this.isCheckedOnAdd = false;
        this.persistSelectedData = [];
        this.deSelectedData = [];
        this.isHdrSelectAllClicked = false;
        this.needColumnSelection = false;
        this.isCancelDeSelect = false;
        this.isPreventCellSelect = false;
        this.disableUI = false;
        this.isPersisted = false;
        this.cmdKeyPressed = false;
        this.cellselected = false;
        this.isMultiSelection = false;
        this.isAddRowsToSelection = false;
        this.initialRowSelection = false;
        this.isPrevRowSelection = false;
        this.isKeyAction = false;
        this.isRowDragSelected = false;
        this.isPartialSelection = false;
        this.rmtHdrChkbxClicked = false;
        this.isCheckboxReset = false;
        this.isRowDeselect = false;
        /**
         * @hidden
         */ this.autoFillRLselection = true;
        this.bottom = "0 0 2px 0";
        this.top = "2px 0 0 0";
        /* eslint-disable */ this.right_bottom = "0 2px 2px 0";
        this.bottom_left = "0 0 2px 2px";
        this.top_right = "2px 2px 0 0";
        this.top_left = "2px 0 0 2px";
        this.top_bottom = "2px 0 2px 0";
        this.top_right_bottom = "2px 2px 2px 0";
        this.top_bottom_left = "2px 0 2px 2px";
        this.top_right_left = "2px 2px 0 2px";
        this.right_bottom_left = "0 2px 2px 2px";
        this.all_border = "2px";
        this.parent = parent;
        this.selectionSettings = selectionSettings;
        this.factory = locator.getService("rendererFactory");
        this.focus = locator.getService("focus");
        this.addEventListener();
        this.wireEvents();
    }
    Selection.prototype.initializeSelection = function() {
        this.parent.log("selection_key_missing");
        this.render();
    };
    /**
     * The function used to trigger onActionBegin
     *
     * @param {Object} args - specifies the args
     * @param {string} type - specifies the type
     * @returns {void}
     * @hidden
     */ Selection.prototype.onActionBegin = function(args, type) {
        this.parent.trigger(type, this.fDataUpdate(args));
    };
    Selection.prototype.fDataUpdate = function(args) {
        if (!this.isMultiSelection && (!(0, $3EnZW.isNullOrUndefined)(args.cellIndex) || !(0, $3EnZW.isNullOrUndefined)(args.rowIndex))) {
            var rowObj = this.getRowObj((0, $3EnZW.isNullOrUndefined)(args.rowIndex) ? (0, $3EnZW.isNullOrUndefined)(args.cellIndex) ? this.currentIndex : args.cellIndex.rowIndex : args.rowIndex);
            args.foreignKeyData = rowObj.foreignKeyData;
        }
        return args;
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {Object} args - specifies the args
     * @param {string} type - specifies the type
     * @returns {void}
     * @hidden
     */ Selection.prototype.onActionComplete = function(args, type) {
        this.parent.trigger(type, this.fDataUpdate(args));
        this.isMultiSelection = false;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Selection.prototype.getModuleName = function() {
        return "selection";
    };
    /**
     * To destroy the selection
     *
     * @returns {void}
     * @hidden
     */ Selection.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        this.hidePopUp();
        this.clearSelection();
        this.destroyAutoFillElements();
        this.removeEventListener();
        this.unWireEvents();
        (0, $aqzbR.EventHandler).remove(this.parent.getContent(), "mousedown", this.mouseDownHandler);
        (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), "mousedown", this.mouseDownHandler);
    };
    Selection.prototype.isEditing = function() {
        return (this.parent.editSettings.mode === "Normal" || this.parent.editSettings.mode === "Batch" && this.parent.editModule && this.parent.editModule.formObj && !this.parent.editModule.formObj.validate()) && this.parent.isEdit && !this.parent.editSettings.showAddNewRow && !this.parent.isPersistSelection;
    };
    Selection.prototype.getCurrentBatchRecordChanges = function() {
        var gObj = this.parent;
        if (gObj.editSettings.mode === "Batch" && gObj.editModule) {
            var currentRecords = (0, $748c2240e597a9b7$export$5788824bee325a29)(this.parent.getCurrentViewRecords());
            currentRecords = gObj.editSettings.newRowPosition === "Bottom" ? currentRecords.concat(this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$aef5e1398935f398]) : this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$aef5e1398935f398].concat(currentRecords);
            var deletedRecords = this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$c509ef778c751c4e];
            var primaryKey = this.parent.getPrimaryKeyFieldNames()[0];
            for(var i = 0; i < deletedRecords.length; i++){
                for(var j = 0; j < currentRecords.length; j++)if (deletedRecords[parseInt(i.toString(), 10)]["" + primaryKey] === currentRecords[parseInt(j.toString(), 10)]["" + primaryKey]) {
                    currentRecords.splice(j, 1);
                    break;
                }
            }
            return currentRecords;
        } else if (this.parent.enableVirtualization && this.parent.groupSettings.columns.length && !this.parent.isPersistSelection) {
            var selectedGroupedData = gObj.getCurrentViewRecords().filter(function(col) {
                return col["key"] === undefined;
            });
            return selectedGroupedData;
        } else return gObj.getCurrentViewRecords();
    };
    /**
     * Selects a row by the given index.
     *
     * @param  {number} index - Defines the row index.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     * @returns {void}
     */ Selection.prototype.selectRow = function(index, isToggle) {
        if (this.selectedRowIndexes.length && this.selectionSettings.enableSimpleMultiRowSelection) {
            this.addRowsToSelection([
                index
            ]);
            return;
        }
        var gObj = this.parent;
        var selectedRow = gObj.getRowByIndex(index);
        var rowObj = selectedRow && gObj.getRowObjectFromUID(selectedRow.getAttribute("data-uid"));
        if (this.isPartialSelection && rowObj && rowObj.isDataRow && !rowObj.isSelectable) return;
        var selectData;
        var isRemoved = false;
        if (gObj.enableVirtualization && index > -1) {
            var e = {
                selectedIndex: index,
                isAvailable: true
            };
            this.parent.notify($17b89d3b1fc93cdb$export$d6c7825c8cd16473, e);
            if (selectedRow && gObj.getRowObjectFromUID(selectedRow.getAttribute("data-uid"))) selectData = gObj.getRowObjectFromUID(selectedRow.getAttribute("data-uid")).data;
            else {
                if (e.isAvailable && !gObj.selectionSettings.persistSelection) {
                    var prevSelectedData = this.parent.getSelectedRecords();
                    if (prevSelectedData.length > 0) this.clearRowSelection();
                }
                return;
            }
        } else selectData = this.getRowObj(index).data;
        if (!this.isRowType() || !selectedRow || this.isEditing()) // if (this.isEditing()) {
        //     gObj.selectedRowIndex = index;
        // }
        return;
        var isRowSelected = selectedRow.hasAttribute("aria-selected");
        this.activeTarget();
        if (!isToggle || !this.selectedRowIndexes.length) isToggle = false;
        else {
            var isCheckboxModeResetOnRowClick = this.selectionSettings.checkboxMode === "ResetOnRowClick";
            var isSelectionTypeMultiple = !this.parent.isCheckBoxSelection && this.selectionSettings.type === "Multiple";
            if (!isCheckboxModeResetOnRowClick && !isSelectionTypeMultiple || this.selectedRowIndexes.length === 1 && (isCheckboxModeResetOnRowClick || isSelectionTypeMultiple)) isToggle = !(this.isKeyAction && this.parent.isCheckBoxSelection) ? this.selectedRowIndexes.indexOf(index) !== -1 : false;
            else isToggle = false;
        }
        this.isKeyAction = false;
        var args;
        var can = "cancel";
        if (!isToggle) {
            args = {
                data: selectData,
                rowIndex: index,
                isCtrlPressed: this.isMultiCtrlRequest,
                isShiftPressed: this.isMultiShiftRequest,
                row: selectedRow,
                previousRow: gObj.getRowByIndex(this.prevRowIndex),
                previousRowIndex: this.prevRowIndex,
                target: this.actualTarget,
                cancel: false,
                isInteracted: this.isInteracted,
                isHeaderCheckboxClicked: this.isHeaderCheckboxClicked
            };
            this.parent.trigger($17b89d3b1fc93cdb$export$f44ea1c4fd45e709, this.fDataUpdate(args), this.rowSelectingCallBack(args, isToggle, index, selectData, isRemoved, isRowSelected, can));
        } else {
            if (this.selectionSettings.checkboxMode !== "ResetOnRowClick" && this.selectionSettings.persistSelection) {
                this.rowDeselect($17b89d3b1fc93cdb$export$fd7be91b8e06050, [
                    rowObj.index
                ], [
                    rowObj.data
                ], [
                    selectedRow
                ], [
                    rowObj.foreignKeyData
                ], this.actualTarget);
                if (this.isCancelDeSelect) return;
                if (!this.parent.isCheckBoxSelection) {
                    this.selectedRowIndexes = [];
                    this.selectedRecords = [];
                    this.isRowSelected = false;
                    this.selectRowIndex(-1);
                }
                this.rowDeselect($17b89d3b1fc93cdb$export$14e00a934586ea7b, [
                    rowObj.index
                ], [
                    rowObj.data
                ], [
                    selectedRow
                ], [
                    rowObj.foreignKeyData
                ], this.actualTarget, undefined, undefined, undefined);
            }
            this.rowSelectingCallBack(args, isToggle, index, selectData, isRemoved, isRowSelected, can)(args);
        }
    };
    Selection.prototype.rowSelectingCallBack = function(args, isToggle, index, selectData, isRemoved, isRowSelected, can) {
        var _this = this;
        return function(args) {
            if (!(0, $3EnZW.isNullOrUndefined)(args) && args["" + can] === true) {
                _this.disableInteracted();
                return;
            }
            _this.index = index;
            _this.toggle = isToggle;
            _this.data = selectData;
            _this.removed = isRemoved;
            if (isRowSelected && _this.selectionSettings.persistSelection && !(_this.selectionSettings.checkboxMode === "ResetOnRowClick")) {
                _this.clearSelectedRow(index);
                _this.selectRowCallBack();
            } else if (!isRowSelected && _this.selectionSettings.persistSelection && _this.selectionSettings.checkboxMode !== "ResetOnRowClick") _this.selectRowCallBack();
            if (_this.selectionSettings.checkboxMode === "ResetOnRowClick") {
                _this.isCheckboxReset = true;
                _this.clearSelection();
            }
            if (!_this.selectionSettings.persistSelection || _this.selectionSettings.checkboxMode === "ResetOnRowClick" || !_this.parent.isCheckBoxSelection && _this.selectionSettings.persistSelection) {
                _this.selectRowCheck = true;
                _this.clearRow();
            }
        };
    };
    Selection.prototype.selectRowCallBack = function() {
        var gObj = this.parent;
        var args;
        var index = this.index;
        var isToggle = this.toggle;
        var selectData = this.data;
        var isRemoved = this.removed;
        var selectedRow = gObj.getRowByIndex(index);
        if (!isToggle && !isRemoved) {
            if (this.selectedRowIndexes.indexOf(index) <= -1) this.updateRowSelection(selectedRow, index);
            this.selectRowIndex(index);
        }
        if (!isToggle) {
            args = {
                data: selectData,
                rowIndex: index,
                row: selectedRow,
                previousRow: gObj.getRowByIndex(this.prevRowIndex),
                previousRowIndex: this.prevRowIndex,
                target: this.actualTarget,
                isInteracted: this.isInteracted,
                isHeaderCheckBoxClicked: this.isHeaderCheckboxClicked,
                rowIndexes: index
            };
            this.onActionComplete(args, $17b89d3b1fc93cdb$export$547c6771ab2f0fc5);
        }
        this.isInteracted = false;
        this.updateRowProps(index);
    };
    /**
     * Selects a range of rows from start and end row indexes.
     *
     * @param  {number} startIndex - Specifies the start row index.
     * @param  {number} endIndex - Specifies the end row index.
     * @returns {void}
     */ Selection.prototype.selectRowsByRange = function(startIndex, endIndex) {
        this.selectRows(this.getCollectionFromIndexes(startIndex, endIndex));
        this.selectRowIndex(endIndex);
    };
    Selection.prototype.selectedDataUpdate = function(selectedData, foreignKeyData, selectedRows, rowIndexes, selectableRowIndex) {
        for(var i = 0, len = rowIndexes.length; i < len; i++){
            var currentRow = this.parent.getDataRows()[rowIndexes[parseInt(i.toString(), 10)]];
            if (this.parent.enableVirtualization) currentRow = this.parent.getRowByIndex(rowIndexes[parseInt(i.toString(), 10)]);
            var rowObj = this.getRowObj(currentRow);
            if (rowObj && rowObj.isDataRow && rowObj.isSelectable) {
                selectedData.push(rowObj.data);
                selectedRows.push(currentRow);
                foreignKeyData.push(rowObj.foreignKeyData);
            } else if (this.isPartialSelection && selectableRowIndex) selectableRowIndex.splice(selectableRowIndex.indexOf(rowIndexes[parseInt(i.toString(), 10)]), 1);
        }
    };
    /**
     * Selects a collection of rows by index.
     *
     * @param  {number[]} rowIndexes - Specifies an array of row indexes.
     * @returns {void}
     */ Selection.prototype.selectRows = function(rowIndexes) {
        var _this = this;
        var gObj = this.parent;
        var selectableRowIndex = rowIndexes.slice();
        var rowIndex = !this.isSingleSel() ? rowIndexes[0] : rowIndexes[rowIndexes.length - 1];
        this.isMultiSelection = true;
        var selectedRows = [];
        var foreignKeyData = [];
        var can = "cancel";
        var selectedData = [];
        if (!this.isRowType() || this.isEditing()) return;
        this.selectedDataUpdate(selectedData, foreignKeyData, selectedRows, rowIndexes, selectableRowIndex);
        this.activeTarget();
        var args = {
            cancel: false,
            rowIndexes: selectableRowIndex,
            row: selectedRows,
            rowIndex: rowIndex,
            target: this.actualTarget,
            prevRow: gObj.getRows()[this.prevRowIndex],
            previousRowIndex: this.prevRowIndex,
            isInteracted: this.isInteracted,
            isCtrlPressed: this.isMultiCtrlRequest,
            isShiftPressed: this.isMultiShiftRequest,
            data: selectedData,
            isHeaderCheckboxClicked: this.isHeaderCheckboxClicked,
            foreignKeyData: foreignKeyData
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$f44ea1c4fd45e709, this.fDataUpdate(args), function(args) {
            if (!(0, $3EnZW.isNullOrUndefined)(args) && args["" + can] === true) {
                _this.disableInteracted();
                return;
            }
            if (!(_this.selectionSettings.persistSelection && gObj.allowRowDragAndDrop && _this.isDragged)) _this.clearRow();
            _this.selectRowIndex(selectableRowIndex.slice(-1)[0]);
            var selectRowFn = function(index, preventFocus) {
                _this.updateRowSelection(gObj.getRowByIndex(index), index, preventFocus);
                _this.updateRowProps(rowIndex);
            };
            if (!_this.isSingleSel()) for(var _i = 0, selectableRowIndex_1 = selectableRowIndex; _i < selectableRowIndex_1.length; _i++){
                var rowIdx = selectableRowIndex_1[_i];
                selectRowFn(rowIdx, gObj.enableVirtualization ? true : false);
            }
            else selectRowFn(rowIndex);
            args = {
                rowIndexes: selectableRowIndex,
                row: selectedRows,
                rowIndex: rowIndex,
                target: _this.actualTarget,
                prevRow: gObj.getRows()[_this.prevRowIndex],
                previousRowIndex: _this.prevRowIndex,
                data: _this.getSelectedRecords(),
                isInteracted: _this.isInteracted,
                isHeaderCheckboxClicked: _this.isHeaderCheckboxClicked,
                foreignKeyData: foreignKeyData
            };
            if (_this.isRowSelected) _this.onActionComplete(args, $17b89d3b1fc93cdb$export$547c6771ab2f0fc5);
            _this.isInteracted = false;
        });
    };
    /**
     * Select rows with existing row selection by passing row indexes.
     *
     * @param {number} rowIndexes - Specifies the row indexes.
     * @returns {void}
     * @hidden
     */ Selection.prototype.addRowsToSelection = function(rowIndexes) {
        var gObj = this.parent;
        var can = "cancel";
        var target = this.target;
        this.isMultiSelection = true;
        var selectedRows = [];
        var foreignKeyData = [];
        var selectedData = [];
        var indexes = gObj.getSelectedRowIndexes().concat(rowIndexes);
        var selectedRow = !this.isSingleSel() ? gObj.getRowByIndex(rowIndexes[0]) : gObj.getRowByIndex(rowIndexes[rowIndexes.length - 1]);
        if ((!this.isRowType() || this.isEditing()) && !this.selectionSettings.checkboxOnly) return;
        var args;
        var checkboxColumn = this.parent.getColumns().filter(function(col) {
            return col.type === "checkbox";
        });
        if (this.isMultiCtrlRequest && !checkboxColumn.length) this.selectedDataUpdate(selectedData, foreignKeyData, selectedRows, indexes);
        for(var _i = 0, rowIndexes_1 = rowIndexes; _i < rowIndexes_1.length; _i++){
            var rowIndex = rowIndexes_1[_i];
            var rowObj = this.getRowObj(rowIndex);
            var isUnSelected = this.selectedRowIndexes.indexOf(rowIndex) > -1;
            if (this.isPartialSelection && rowObj && rowObj.isDataRow && !rowObj.isSelectable) continue;
            this.selectRowIndex(rowIndex);
            if (isUnSelected && ((checkboxColumn.length ? true : this.selectionSettings.enableToggle) || this.isMultiCtrlRequest)) {
                this.isAddRowsToSelection = true;
                this.rowDeselect($17b89d3b1fc93cdb$export$fd7be91b8e06050, [
                    rowIndex
                ], [
                    rowObj.data
                ], [
                    selectedRow
                ], [
                    rowObj.foreignKeyData
                ], target);
                if (this.isCancelDeSelect) return;
                this.selectedRowIndexes.splice(this.selectedRowIndexes.indexOf(rowIndex), 1);
                this.selectedRecords.splice(this.selectedRecords.indexOf(selectedRow), 1);
                this.selectRowIndex(this.selectedRowIndexes.length ? this.selectedRowIndexes[this.selectedRowIndexes.length - 1] : -1);
                selectedRow.removeAttribute("aria-selected");
                this.addRemoveClassesForRow(selectedRow, false, null, "e-selectionbackground", "e-active");
                this.rowDeselect($17b89d3b1fc93cdb$export$14e00a934586ea7b, [
                    rowIndex
                ], [
                    rowObj.data
                ], [
                    selectedRow
                ], [
                    rowObj.foreignKeyData
                ], target, undefined, undefined, undefined);
                this.isInteracted = false;
                this.isMultiSelection = false;
                this.isAddRowsToSelection = false;
                this.isHdrSelectAllClicked = false;
            } else {
                this.activeTarget();
                args = {
                    cancel: false,
                    data: selectedData.length ? selectedData : rowObj.data,
                    rowIndex: rowIndex,
                    row: selectedRows.length ? selectedRows : selectedRow,
                    target: this.actualTarget,
                    prevRow: gObj.getRows()[this.prevRowIndex],
                    previousRowIndex: this.prevRowIndex,
                    isCtrlPressed: this.isMultiCtrlRequest,
                    isShiftPressed: this.isMultiShiftRequest,
                    foreignKeyData: foreignKeyData.length ? foreignKeyData : rowObj.foreignKeyData,
                    isInteracted: this.isInteracted,
                    isHeaderCheckboxClicked: this.isHeaderCheckboxClicked,
                    rowIndexes: indexes
                };
                this.parent.trigger($17b89d3b1fc93cdb$export$f44ea1c4fd45e709, this.fDataUpdate(args));
                if (!(0, $3EnZW.isNullOrUndefined)(args) && args["" + can] === true) {
                    this.disableInteracted();
                    return;
                }
                if (this.isSingleSel()) this.clearRow();
                this.updateRowSelection(selectedRow, rowIndex);
            }
            if (!isUnSelected) {
                args = {
                    data: selectedData.length ? selectedData : rowObj.data,
                    rowIndex: rowIndex,
                    row: selectedRows.length ? selectedRows : selectedRow,
                    target: this.actualTarget,
                    prevRow: gObj.getRows()[this.prevRowIndex],
                    previousRowIndex: this.prevRowIndex,
                    foreignKeyData: foreignKeyData.length ? foreignKeyData : rowObj.foreignKeyData,
                    isInteracted: this.isInteracted,
                    isHeaderCheckboxClicked: this.isHeaderCheckboxClicked,
                    rowIndexes: indexes
                };
                this.onActionComplete(args, $17b89d3b1fc93cdb$export$547c6771ab2f0fc5);
            }
            this.isInteracted = false;
            this.updateRowProps(rowIndex);
            if (this.isSingleSel()) break;
        }
    };
    Selection.prototype.getCollectionFromIndexes = function(startIndex, endIndex) {
        var indexes = [];
        // eslint-disable-next-line prefer-const
        var _a = startIndex <= endIndex ? {
            i: startIndex,
            max: endIndex
        } : {
            i: endIndex,
            max: startIndex
        }, i = _a.i, max = _a.max;
        for(; i <= max; i++)indexes.push(i);
        if (startIndex > endIndex) indexes.reverse();
        return indexes;
    };
    Selection.prototype.clearRow = function() {
        this.clearRowCheck = true;
        this.clearRowSelection();
    };
    Selection.prototype.clearRowCallBack = function() {
        if (this.isCancelDeSelect && this.parent.checkAllRows !== "Check") return;
        this.selectedRowIndexes = [];
        this.selectedRecords = [];
        this.selectRowIndex(-1);
        if (this.isSingleSel() && this.parent.isPersistSelection) this.selectedRowState = {};
    };
    Selection.prototype.clearSelectedRow = function(index) {
        if (this.toggle) {
            var selectedEle = this.parent.getRowByIndex(index);
            if (!this.disableUI) {
                selectedEle.removeAttribute("aria-selected");
                this.addRemoveClassesForRow(selectedEle, false, true, "e-selectionbackground", "e-active");
            }
            this.removed = true;
            this.updatePersistCollection(selectedEle, false);
            this.updateCheckBoxes(selectedEle);
            this.selectedRowIndexes.splice(this.selectedRowIndexes.indexOf(index), 1);
            this.selectedRecords.splice(this.selectedRecords.indexOf(this.parent.getRowByIndex(index)), 1);
        }
    };
    Selection.prototype.updateRowProps = function(startIndex) {
        this.prevRowIndex = startIndex;
        this.isRowSelected = this.selectedRowIndexes.length && true;
    };
    Selection.prototype.getPkValue = function(pkField, data) {
        return pkField ? (0, $748c2240e597a9b7$export$9850823255bfa4ed)(pkField) ? (0, $748c2240e597a9b7$export$93534728ecb2e7b9)(pkField, data) : data["" + pkField] : data["" + pkField];
    };
    Selection.prototype.updatePersistCollection = function(selectedRow, chkState) {
        var _this = this;
        if ((this.parent.isPersistSelection || this.parent.selectionSettings.persistSelection && this.parent.getPrimaryKeyFieldNames().length > 0) && !(0, $3EnZW.isNullOrUndefined)(selectedRow)) {
            if (!this.parent.isPersistSelection) this.ensureCheckboxFieldSelection();
            var rowObj = this.getRowObj(selectedRow);
            var pKey_1 = rowObj.data ? this.getPkValue(this.primaryKey, rowObj.data) : null;
            if (pKey_1 === null) return;
            rowObj.isSelected = chkState;
            if (chkState && !this.isPartialSelection || this.isPartialSelection && rowObj.isSelectable && rowObj.isSelected) {
                this.selectedRowState["" + pKey_1] = chkState;
                delete this.unSelectedRowState["" + pKey_1];
                if (!this.persistSelectedData.some(function(data) {
                    return _this.getPkValue(_this.primaryKey, data) === pKey_1;
                })) this.persistSelectedData.push(rowObj.data);
            } else this.updatePersistDelete(pKey_1);
        }
    };
    Selection.prototype.updatePersistDelete = function(pKey, isPartialSelection) {
        var _this = this;
        delete this.selectedRowState["" + pKey];
        if (this.rmtHdrChkbxClicked) this.unSelectedRowState["" + pKey] = true;
        var index;
        var isPresent = this.persistSelectedData.some(function(data, i) {
            index = i;
            return _this.getPkValue(_this.primaryKey, data) === pKey;
        });
        if (isPresent) {
            this.persistSelectedData.splice(index, 1);
            if (isPartialSelection) this.parent.partialSelectedRecords.splice(index, 1);
        }
    };
    Selection.prototype.updateCheckBoxes = function(row, chkState, rowIndex) {
        if (!(0, $3EnZW.isNullOrUndefined)(row)) {
            var chkBox = row.querySelector(".e-checkselect");
            if (!(0, $3EnZW.isNullOrUndefined)(chkBox)) {
                (0, $748c2240e597a9b7$export$39b02a8864b327ad)(chkBox.nextElementSibling, chkState);
                (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(chkBox, chkState);
                if ((0, $3EnZW.isNullOrUndefined)(this.checkedTarget) || !(0, $3EnZW.isNullOrUndefined)(this.checkedTarget) && !this.checkedTarget.classList.contains("e-checkselectall")) this.setCheckAllState(rowIndex);
            }
        }
    };
    Selection.prototype.updateRowSelection = function(selectedRow, startIndex, preventFocus) {
        if (!selectedRow) return;
        if (this.selectedRowIndexes.indexOf(startIndex) === -1) {
            this.selectedRowIndexes.push(startIndex);
            this.selectedRecords.push(selectedRow);
        }
        selectedRow.setAttribute("aria-selected", "true");
        this.updatePersistCollection(selectedRow, true);
        this.updateCheckBoxes(selectedRow, true);
        this.addRemoveClassesForRow(selectedRow, true, null, "e-selectionbackground", "e-active");
        if (!this.preventFocus) {
            var target = this.focus.getPrevIndexes().cellIndex ? selectedRow.cells[this.focus.getPrevIndexes().cellIndex] : selectedRow.querySelector(".e-selectionbackground:not(.e-hide):not(.e-detailrowcollapse):not(.e-detailrowexpand)");
            if (this.parent.contextMenuModule && this.mouseButton === 2) target = this.parent.contextMenuModule.cell;
            if (!target || preventFocus) return;
            this.focus.onClick({
                target: target
            }, true);
        }
    };
    /**
     * Deselects the currently selected rows and cells.
     *
     * @returns {void}
     */ Selection.prototype.clearSelection = function() {
        this.checkSelectAllClicked = true;
        if (this.selectionSettings.persistSelection && this.persistSelectedData.length) this.deSelectedData = (0, $748c2240e597a9b7$export$5788824bee325a29)(this.persistSelectedData);
        if (!this.parent.isPersistSelection || this.parent.isPersistSelection && !this.parent.isEdit || !(0, $3EnZW.isNullOrUndefined)(this.checkedTarget) && this.checkedTarget.classList.contains("e-checkselectall")) {
            var span = this.parent.element.querySelector(".e-gridpopup").querySelector("span");
            if (span.classList.contains("e-rowselect")) span.classList.remove("e-spanclicked");
            if (this.parent.isPersistSelection) {
                this.persistSelectedData = [];
                this.selectedRowState = {};
            }
            this.clearRowSelection();
            this.clearCellSelection();
            this.clearColumnSelection();
            this.prevRowIndex = undefined;
            this.prevCIdxs = undefined;
            this.prevECIdxs = undefined;
            this.enableSelectMultiTouch = false;
            this.isInteracted = false;
            this.checkSelectAllClicked = false;
            this.isHdrSelectAllClicked = false;
        }
    };
    /**
     * Deselects the currently selected rows.
     *
     * @returns {void}
     */ Selection.prototype.clearRowSelection = function() {
        var _this = this;
        if (this.isRowSelected) {
            var rows_1 = this.parent.getDataRows();
            var data_1 = [];
            var row_1 = [];
            var rowIndex_1 = [];
            var foreignKeyData_1 = [];
            var target_1 = this.target;
            this.isRowDeselect = true;
            for(var i = 0, len = this.selectedRowIndexes.length; i < len; i++){
                var currentRow = this.parent.editSettings.mode === "Batch" ? this.parent.getRows()[this.selectedRowIndexes[parseInt(i.toString(), 10)]] : this.parent.getDataRows()[this.selectedRowIndexes[parseInt(i.toString(), 10)]];
                var rowObj = this.getRowObj(currentRow);
                if (rowObj) {
                    data_1.push(rowObj.data);
                    row_1.push(currentRow);
                    rowIndex_1.push(this.selectedRowIndexes[parseInt(i.toString(), 10)]);
                    foreignKeyData_1.push(rowObj.foreignKeyData);
                }
            }
            if (this.selectionSettings.persistSelection && this.selectionSettings.checkboxMode !== "ResetOnRowClick") this.isRowClicked = this.checkSelectAllClicked ? true : false;
            this.rowDeselect($17b89d3b1fc93cdb$export$fd7be91b8e06050, rowIndex_1, data_1, row_1, foreignKeyData_1, target_1, null, function() {
                if (_this.isCancelDeSelect && (_this.isRowClicked || _this.checkSelectAllClicked || _this.isInteracted && !_this.parent.isPersistSelection)) {
                    if (_this.parent.isPersistSelection) {
                        if (_this.getCheckAllStatus(_this.parent.element.querySelector(".e-checkselectall")) === "Intermediate" || _this.parent.isPersistSelection) for(var i = 0; i < _this.selectedRecords.length; i++)_this.updatePersistCollection(_this.selectedRecords[parseInt(i.toString(), 10)], true);
                        else {
                            _this.parent.checkAllRows = "Check";
                            _this.updatePersistSelectedData(true);
                        }
                    }
                    if (_this.clearRowCheck) {
                        _this.clearRowCallBack();
                        _this.clearRowCheck = false;
                        if (_this.selectRowCheck) {
                            _this.selectRowCallBack();
                            _this.selectRowCheck = false;
                        }
                    }
                    return;
                }
                var element = [].slice.call(rows_1.filter(function(record) {
                    return record.hasAttribute("aria-selected");
                }));
                for(var j = 0; j < element.length; j++){
                    if (!_this.disableUI) {
                        element[parseInt(j.toString(), 10)].removeAttribute("aria-selected");
                        _this.addRemoveClassesForRow(element[parseInt(j.toString(), 10)], false, true, "e-selectionbackground", "e-active");
                    }
                    // tslint:disable-next-line:align
                    if (!_this.isPrevRowSelection) _this.updatePersistCollection(element[parseInt(j.toString(), 10)], false);
                    _this.updateCheckBoxes(element[parseInt(j.toString(), 10)]);
                }
                _this.selectedRowIndexes = [];
                _this.selectedRecords = [];
                _this.isRowSelected = false;
                _this.selectRowIndex(-1);
                _this.isPrevRowSelection = false;
                _this.rowDeselect($17b89d3b1fc93cdb$export$14e00a934586ea7b, rowIndex_1, data_1, row_1, foreignKeyData_1, target_1, null, undefined, null);
                if (_this.clearRowCheck) {
                    _this.clearRowCallBack();
                    _this.clearRowCheck = false;
                    if (_this.selectRowCheck) {
                        _this.selectRowCallBack();
                        _this.selectRowCheck = false;
                    }
                }
            }, null);
            this.isRowDeselect = false;
        } else if (this.clearRowCheck) {
            this.clearRowCallBack();
            this.clearRowCheck = false;
            if (this.selectRowCheck) {
                this.selectRowCallBack();
                this.selectRowCheck = false;
            }
        }
    };
    Selection.prototype.rowDeselect = function(type, rowIndex, data, row, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    foreignKeyData, target, mRow, rowDeselectCallBack, frozenRightRow) {
        var _this = this;
        if (this.selectionSettings.persistSelection && (this.isRowClicked || !this.isRowDeselect || this.checkSelectAllClicked || this.focus["activeKey"] && this.focus.currentInfo.element.classList.contains("e-gridchkbox") && this.focus["activeKey"] === "space") || !this.selectionSettings.persistSelection) {
            var cancl_1 = "cancel";
            var isSingleDeSel = rowIndex.length === 1 && this.deSelectedData.length === 1;
            var rowDeselectObj = {
                rowIndex: rowIndex[0],
                data: this.selectionSettings.persistSelection && this.parent.checkAllRows === "Uncheck" && !isSingleDeSel && this.selectionSettings.checkboxMode !== "ResetOnRowClick" ? this.deSelectedData : data,
                foreignKeyData: foreignKeyData,
                cancel: false,
                isInteracted: this.isInteracted,
                isHeaderCheckboxClicked: this.isHeaderCheckboxClicked
            };
            if (type === "rowDeselected") delete rowDeselectObj.cancel;
            var rowInString = "row";
            var target_2 = "target";
            var rowidx = "rowIndex";
            var rowidxex = "rowIndexes";
            var dataTxt = "data";
            var foreignKey = "foreignKeyData";
            rowDeselectObj["" + rowInString] = row;
            rowDeselectObj["" + target_2] = this.actualTarget;
            var isHeaderCheckBxClick = this.actualTarget && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.actualTarget, "thead"));
            if (isHeaderCheckBxClick || rowIndex.length > 1) {
                rowDeselectObj["" + rowidx] = rowIndex[0];
                rowDeselectObj["" + rowidxex] = rowIndex;
            } else if (rowIndex.length === 1) {
                rowDeselectObj["" + dataTxt] = rowDeselectObj["" + dataTxt][0];
                rowDeselectObj["" + rowInString] = rowDeselectObj["" + rowInString][0];
                rowDeselectObj["" + foreignKey] = rowDeselectObj["" + foreignKey][0];
                if (this.isAddRowsToSelection) rowDeselectObj["" + rowidxex] = rowIndex;
            }
            this.parent.trigger(type, rowDeselectObj, function(args) {
                _this.isCancelDeSelect = args["" + cancl_1];
                if (!_this.isCancelDeSelect || !_this.isRowClicked && !_this.isInteracted && !_this.checkSelectAllClicked) {
                    _this.updatePersistCollection(row[0], false);
                    _this.updateCheckBoxes(row[0], undefined, rowIndex[0]);
                }
                if (rowDeselectCallBack !== undefined) rowDeselectCallBack();
            });
        } else if (this.selectionSettings.persistSelection && !this.isInteracted) {
            if (rowDeselectCallBack !== undefined) rowDeselectCallBack();
        }
    };
    Selection.prototype.getRowObj = function(row) {
        if (row === void 0) row = this.currentIndex;
        if ((0, $3EnZW.isNullOrUndefined)(row)) return {};
        if (typeof row === "number") row = this.parent.getRowByIndex(row);
        if (row) return this.parent.getRowObjectFromUID(row.getAttribute("data-uid")) || {};
        return {};
    };
    /**
     * Selects a cell by the given index.
     *
     * @param  {IIndex} cellIndex - Defines the row and column indexes.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     * @returns {void}
     */ Selection.prototype.selectCell = function(cellIndex, isToggle) {
        if (!this.isCellType()) return;
        var gObj = this.parent;
        var args;
        var selectedCell = gObj.getCellFromIndex(cellIndex.rowIndex, this.getColIndex(cellIndex.rowIndex, cellIndex.cellIndex));
        this.currentIndex = cellIndex.rowIndex;
        var selectedData = this.getCurrentBatchRecordChanges()[this.currentIndex];
        if (!this.isCellType() || !selectedCell || this.isEditing()) return;
        var isCellSelected = selectedCell.classList.contains("e-cellselectionbackground");
        isToggle = !isToggle ? isToggle : !(0, $3EnZW.isUndefined)(this.prevCIdxs) && cellIndex.rowIndex === this.prevCIdxs.rowIndex && cellIndex.cellIndex === this.prevCIdxs.cellIndex && isCellSelected;
        if (!isToggle) {
            args = {
                data: selectedData,
                cellIndex: cellIndex,
                isCtrlPressed: this.isMultiCtrlRequest,
                isShiftPressed: this.isMultiShiftRequest,
                previousRowCell: this.prevECIdxs ? this.getCellIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined,
                cancel: false
            };
            var currentCell = "currentCell";
            args["" + currentCell] = selectedCell;
            var previousRowCellIndex = "previousRowCellIndex";
            args["" + previousRowCellIndex] = this.prevECIdxs;
            this.parent.trigger($17b89d3b1fc93cdb$export$b38edb82895c7fcf, this.fDataUpdate(args), this.successCallBack(args, isToggle, cellIndex, selectedCell, selectedData));
            this.cellselected = true;
        } else this.successCallBack(args, isToggle, cellIndex, selectedCell, selectedData)(args);
    };
    Selection.prototype.successCallBack = function(cellSelectingArgs, isToggle, cellIndex, selectedCell, selectedData) {
        var _this = this;
        return function(cellSelectingArgs) {
            var cncl = "cancel";
            var currentCell = "currentCell";
            if (!(0, $3EnZW.isNullOrUndefined)(cellSelectingArgs) && cellSelectingArgs["" + cncl] === true) return;
            if (!isToggle) cellSelectingArgs["" + currentCell] = cellSelectingArgs["" + currentCell] ? cellSelectingArgs["" + currentCell] : selectedCell;
            _this.clearCell();
            if (!isToggle) _this.updateCellSelection(selectedCell, cellIndex.rowIndex, cellIndex.cellIndex);
            if (!isToggle) {
                var args = {
                    data: selectedData,
                    cellIndex: cellIndex,
                    currentCell: selectedCell,
                    selectedRowCellIndex: _this.selectedRowCellIndexes,
                    previousRowCell: _this.prevECIdxs ? _this.getCellIndex(_this.prevECIdxs.rowIndex, _this.prevECIdxs.cellIndex) : undefined
                };
                var previousRowCellIndex = "previousRowCellIndex";
                args["" + previousRowCellIndex] = _this.prevECIdxs;
                _this.updateCellProps(cellIndex, cellIndex);
                _this.onActionComplete(args, $17b89d3b1fc93cdb$export$5ce057a02585195d);
            }
        };
    };
    Selection.prototype.getCellIndex = function(rIdx, cIdx) {
        return this.parent.getCellFromIndex(rIdx, cIdx);
    };
    /**
     * Selects a range of cells from start and end indexes.
     *
     * @param  {IIndex} startIndex - Specifies the row and column's start index.
     * @param  {IIndex} endIndex - Specifies the row and column's end index.
     * @returns {void}
     */ Selection.prototype.selectCellsByRange = function(startIndex, endIndex) {
        var _this = this;
        if (!this.isCellType()) return;
        var gObj = this.parent;
        var selectedCell = this.parent.isSpan ? (0, $748c2240e597a9b7$export$136558233620d0e9)(this.parent, startIndex.rowIndex, startIndex.cellIndex) : gObj.getCellFromIndex(startIndex.rowIndex, startIndex.cellIndex);
        var min;
        var max;
        var stIndex = startIndex;
        var edIndex = endIndex = endIndex ? endIndex : startIndex;
        var cellIndexes;
        this.currentIndex = startIndex.rowIndex;
        var cncl = "cancel";
        var selectedData = this.getCurrentBatchRecordChanges()[this.currentIndex];
        if (this.isSingleSel() || !this.isCellType() || this.isEditing()) return;
        var args = {
            data: selectedData,
            cellIndex: startIndex,
            currentCell: selectedCell,
            isCtrlPressed: this.isMultiCtrlRequest,
            isShiftPressed: this.isMultiShiftRequest,
            previousRowCell: this.prevECIdxs ? this.getCellIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined
        };
        var previousRowCellIndex = "previousRowCellIndex";
        args["" + previousRowCellIndex] = this.prevECIdxs;
        this.parent.trigger($17b89d3b1fc93cdb$export$b38edb82895c7fcf, this.fDataUpdate(args), function(cellSelectingArgs) {
            if (!(0, $3EnZW.isNullOrUndefined)(cellSelectingArgs) && cellSelectingArgs["" + cncl] === true) return;
            _this.clearCell();
            if (startIndex.rowIndex > endIndex.rowIndex) {
                var temp = startIndex;
                startIndex = endIndex;
                endIndex = temp;
            }
            for(var i = startIndex.rowIndex; i <= endIndex.rowIndex; i++){
                if (_this.selectionSettings.cellSelectionMode.indexOf("Box") < 0) {
                    min = i === startIndex.rowIndex ? startIndex.cellIndex : 0;
                    max = i === endIndex.rowIndex ? endIndex.cellIndex : _this.getLastColIndex(i);
                } else {
                    min = startIndex.cellIndex;
                    max = endIndex.cellIndex;
                }
                cellIndexes = [];
                for(var j = min < max ? min : max, len = min > max ? min : max; j <= len; j++){
                    selectedCell = _this.parent.isSpan ? (0, $748c2240e597a9b7$export$136558233620d0e9)(gObj, i, j) : gObj.getCellFromIndex(i, j);
                    if (!selectedCell) continue;
                    cellIndexes.push(j);
                    _this.updateCellSelection(selectedCell);
                    _this.addAttribute(selectedCell);
                }
                _this.selectedRowCellIndexes.push({
                    rowIndex: i,
                    cellIndexes: cellIndexes
                });
            }
            var cellSelectedArgs = {
                data: selectedData,
                cellIndex: edIndex,
                currentCell: gObj.getCellFromIndex(edIndex.rowIndex, edIndex.cellIndex),
                selectedRowCellIndex: _this.selectedRowCellIndexes,
                previousRowCell: _this.prevECIdxs ? _this.getCellIndex(_this.prevECIdxs.rowIndex, _this.prevECIdxs.cellIndex) : undefined
            };
            var previousRowCellIndex = "previousRowCellIndex";
            cellSelectedArgs["" + previousRowCellIndex] = _this.prevECIdxs;
            if (!_this.isDragged) {
                _this.onActionComplete(cellSelectedArgs, $17b89d3b1fc93cdb$export$5ce057a02585195d);
                _this.cellselected = true;
            }
            _this.updateCellProps(stIndex, edIndex);
        });
    };
    /**
     * Selects a collection of cells by row and column indexes.
     *
     * @param  {ISelectedCell[]} rowCellIndexes - Specifies the row and column indexes.
     * @returns {void}
     */ Selection.prototype.selectCells = function(rowCellIndexes) {
        if (!this.isCellType()) return;
        var gObj = this.parent;
        var selectedCell = gObj.getCellFromIndex(rowCellIndexes[0].rowIndex, rowCellIndexes[0].cellIndexes[0]);
        this.currentIndex = rowCellIndexes[0].rowIndex;
        var selectedData = this.getCurrentBatchRecordChanges()[this.currentIndex];
        if (this.isSingleSel() || !this.isCellType() || this.isEditing()) return;
        var cellSelectArgs = {
            data: selectedData,
            cellIndex: rowCellIndexes[0].cellIndexes[0],
            currentCell: selectedCell,
            isCtrlPressed: this.isMultiCtrlRequest,
            isShiftPressed: this.isMultiShiftRequest,
            previousRowCell: this.prevECIdxs ? this.getCellIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined
        };
        var previousRowCellIndex = "previousRowCellIndex";
        cellSelectArgs["" + previousRowCellIndex] = this.prevECIdxs;
        this.onActionBegin(cellSelectArgs, $17b89d3b1fc93cdb$export$b38edb82895c7fcf);
        for(var i = 0, len = rowCellIndexes.length; i < len; i++)for(var j = 0, cellLen = rowCellIndexes[parseInt(i.toString(), 10)].cellIndexes.length; j < cellLen; j++){
            selectedCell = gObj.getCellFromIndex(rowCellIndexes[parseInt(i.toString(), 10)].rowIndex, rowCellIndexes[parseInt(i.toString(), 10)].cellIndexes[parseInt(j.toString(), 10)]);
            if (!selectedCell) continue;
            this.updateCellSelection(selectedCell);
            this.addAttribute(selectedCell);
            this.addRowCellIndex({
                rowIndex: rowCellIndexes[parseInt(i.toString(), 10)].rowIndex,
                cellIndex: rowCellIndexes[parseInt(i.toString(), 10)].cellIndexes[parseInt(j.toString(), 10)]
            });
        }
        this.updateCellProps({
            rowIndex: rowCellIndexes[0].rowIndex,
            cellIndex: rowCellIndexes[0].cellIndexes[0]
        }, {
            rowIndex: rowCellIndexes[0].rowIndex,
            cellIndex: rowCellIndexes[0].cellIndexes[0]
        });
        var cellSelectedArgs = {
            data: selectedData,
            cellIndex: rowCellIndexes[0].cellIndexes[0],
            currentCell: selectedCell,
            selectedRowCellIndex: this.selectedRowCellIndexes,
            previousRowCell: this.prevECIdxs ? this.getCellIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined
        };
        var prvRowCellIndex = "previousRowCellIndex";
        cellSelectedArgs["" + prvRowCellIndex] = this.prevECIdxs;
        this.onActionComplete(cellSelectedArgs, $17b89d3b1fc93cdb$export$5ce057a02585195d);
    };
    /**
     * Select cells with existing cell selection by passing row and column index.
     *
     * @param {IIndex} cellIndexes - Defines the collection of row and column index.
     * @returns {void}
     * @hidden
     */ Selection.prototype.addCellsToSelection = function(cellIndexes) {
        if (!this.isCellType()) return;
        var gObj = this.parent;
        var selectedCell;
        var index;
        this.currentIndex = cellIndexes[0].rowIndex;
        var cncl = "cancel";
        var selectedData = this.getCurrentBatchRecordChanges()[this.currentIndex];
        if (this.isSingleSel() || !this.isCellType() || this.isEditing()) return;
        this.hideAutoFill();
        var rowObj;
        rowObj = gObj.getRowsObject()[cellIndexes[0].rowIndex];
        if (gObj.groupSettings.columns.length > 0) rowObj = gObj.getRowObjectFromUID(this.target.parentElement.getAttribute("data-uid"));
        var foreignKeyData = [];
        for(var _i = 0, cellIndexes_1 = cellIndexes; _i < cellIndexes_1.length; _i++){
            var cellIndex = cellIndexes_1[_i];
            for(var i = 0, len = this.selectedRowCellIndexes.length; i < len; i++)if (this.selectedRowCellIndexes[parseInt(i.toString(), 10)].rowIndex === cellIndex.rowIndex) {
                index = i;
                break;
            }
            selectedCell = gObj.getCellFromIndex(cellIndex.rowIndex, this.getColIndex(cellIndex.rowIndex, cellIndex.cellIndex));
            var idx = cellIndex.cellIndex;
            if (gObj.groupSettings.columns.length > 0) foreignKeyData.push(rowObj.cells[idx + gObj.groupSettings.columns.length].foreignKeyData);
            else foreignKeyData.push(rowObj.cells[parseInt(idx.toString(), 10)].foreignKeyData);
            var args = {
                cancel: false,
                data: selectedData,
                cellIndex: cellIndexes[0],
                isShiftPressed: this.isMultiShiftRequest,
                currentCell: selectedCell,
                isCtrlPressed: this.isMultiCtrlRequest,
                previousRowCell: this.prevECIdxs ? gObj.getCellFromIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined
            };
            var prvRowCellIndex = "previousRowCellIndex";
            args["" + prvRowCellIndex] = this.prevECIdxs;
            var isUnSelected = index > -1;
            if (isUnSelected) {
                var selectedCellIdx = this.selectedRowCellIndexes[parseInt(index.toString(), 10)].cellIndexes;
                if (selectedCellIdx.indexOf(cellIndex.cellIndex) > -1 || this.selectionSettings.mode === "Both" && selectedCell.classList.contains("e-gridchkbox") && !selectedCell.getAttribute("aria-selected")) {
                    this.cellDeselect($17b89d3b1fc93cdb$export$ddb5b152fc2e4709, [
                        {
                            rowIndex: cellIndex.rowIndex,
                            cellIndexes: [
                                cellIndex.cellIndex
                            ]
                        }
                    ], selectedData, [
                        selectedCell
                    ], foreignKeyData);
                    selectedCellIdx.splice(selectedCellIdx.indexOf(cellIndex.cellIndex), 1);
                    if (selectedCellIdx.length === 0) this.selectedRowCellIndexes.splice(index, 1);
                    selectedCell.classList.remove("e-cellselectionbackground");
                    selectedCell.removeAttribute("aria-selected");
                    this.cellDeselect($17b89d3b1fc93cdb$export$103fc9af7fdf4985, [
                        {
                            rowIndex: cellIndex.rowIndex,
                            cellIndexes: [
                                cellIndex.cellIndex
                            ]
                        }
                    ], selectedData, [
                        selectedCell
                    ], foreignKeyData);
                } else {
                    isUnSelected = false;
                    this.onActionBegin(args, $17b89d3b1fc93cdb$export$b38edb82895c7fcf);
                    this.addRowCellIndex({
                        rowIndex: cellIndex.rowIndex,
                        cellIndex: cellIndex.cellIndex
                    });
                    this.updateCellSelection(selectedCell);
                    this.addAttribute(selectedCell);
                }
            } else {
                this.onActionBegin(args, $17b89d3b1fc93cdb$export$b38edb82895c7fcf);
                if (!(0, $3EnZW.isNullOrUndefined)(args) && args["" + cncl] === true) return;
                this.updateCellSelection(selectedCell, cellIndex.rowIndex, cellIndex.cellIndex);
            }
            if (!isUnSelected) {
                var cellSelectedArgs = {
                    data: selectedData,
                    cellIndex: cellIndexes[0],
                    currentCell: selectedCell,
                    previousRowCell: this.prevECIdxs ? this.getCellIndex(this.prevECIdxs.rowIndex, this.prevECIdxs.cellIndex) : undefined,
                    selectedRowCellIndex: this.selectedRowCellIndexes
                };
                cellSelectedArgs["" + prvRowCellIndex] = this.prevECIdxs;
                this.onActionComplete(cellSelectedArgs, $17b89d3b1fc93cdb$export$5ce057a02585195d);
                this.cellselected = true;
            }
            this.updateCellProps(cellIndex, cellIndex);
        }
    };
    Selection.prototype.getColIndex = function(rowIndex, index) {
        var col = this.parent.getColumnByIndex(index);
        var cells = (0, $748c2240e597a9b7$export$ecc8ba29dc2847f4)(this.parent, col, rowIndex);
        if (cells) for(var m = 0; m < cells.length; m++){
            var colIndex = parseInt(cells[parseInt(m.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
            if (colIndex === index) return m;
        }
        return -1;
    };
    Selection.prototype.getLastColIndex = function(rowIndex) {
        var cells = this.parent.getDataRows()[parseInt(rowIndex.toString(), 10)].querySelectorAll("td.e-rowcell");
        return parseInt(cells[cells.length - 1].getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
    };
    Selection.prototype.clearCell = function() {
        this.clearCellSelection();
    };
    Selection.prototype.cellDeselect = function(type, cellIndexes, data, cells, foreignKeyData) {
        var cancl = "cancel";
        if (cells && cells.length > 0) for(var _i = 0, cells_1 = cells; _i < cells_1.length; _i++){
            var cell = cells_1[_i];
            if (cell && cell.classList.contains($1b5568e76cdae6d4$export$71f350cebd38389f)) this.updateCheckBoxes((0, $4ZDHT.closest)(cell, "tr"));
        }
        var args = {
            cells: cells,
            data: data,
            cellIndexes: cellIndexes,
            foreignKeyData: foreignKeyData,
            cancel: false
        };
        this.parent.trigger(type, args);
        this.isPreventCellSelect = args["" + cancl];
    };
    Selection.prototype.updateCellSelection = function(selectedCell, rowIndex, cellIndex) {
        if (!(0, $3EnZW.isNullOrUndefined)(rowIndex)) this.addRowCellIndex({
            rowIndex: rowIndex,
            cellIndex: cellIndex
        });
        selectedCell.classList.add("e-cellselectionbackground");
        if (selectedCell.classList.contains($1b5568e76cdae6d4$export$71f350cebd38389f)) this.updateCheckBoxes((0, $4ZDHT.closest)(selectedCell, "tr"), true);
        this.addAttribute(selectedCell);
    };
    Selection.prototype.addAttribute = function(cell) {
        this.target = cell;
        if (!(0, $3EnZW.isNullOrUndefined)(cell)) {
            cell.setAttribute("aria-selected", "true");
            if (!this.preventFocus) this.focus.onClick({
                target: cell
            }, true);
        }
    };
    Selection.prototype.updateCellProps = function(startIndex, endIndex) {
        this.prevCIdxs = startIndex;
        this.prevECIdxs = endIndex;
        this.isCellSelected = this.selectedRowCellIndexes.length && true;
    };
    Selection.prototype.addRowCellIndex = function(rowCellIndex) {
        var isRowAvail;
        var index;
        for(var i = 0, len = this.selectedRowCellIndexes.length; i < len; i++)if (this.selectedRowCellIndexes[parseInt(i.toString(), 10)].rowIndex === rowCellIndex.rowIndex) {
            isRowAvail = true;
            index = i;
            break;
        }
        if (isRowAvail) {
            if (this.selectedRowCellIndexes[parseInt(index.toString(), 10)].cellIndexes.indexOf(rowCellIndex.cellIndex) < 0) this.selectedRowCellIndexes[parseInt(index.toString(), 10)].cellIndexes.push(rowCellIndex.cellIndex);
        } else this.selectedRowCellIndexes.push({
            rowIndex: rowCellIndex.rowIndex,
            cellIndexes: [
                rowCellIndex.cellIndex
            ]
        });
    };
    /**
     * Deselects the currently selected cells.
     *
     * @returns {void}
     */ Selection.prototype.clearCellSelection = function() {
        if (this.isCellSelected) {
            var gObj = this.parent;
            var selectedCells = this.getSelectedCellsElement();
            var rowCell = this.selectedRowCellIndexes;
            var data = [];
            var cells = [];
            var foreignKeyData = [];
            var currentViewData = this.getCurrentBatchRecordChanges();
            this.hideAutoFill();
            for(var i = 0, len = rowCell.length; i < len; i++){
                data.push(currentViewData[rowCell[parseInt(i.toString(), 10)].rowIndex]);
                var rowObj = this.getRowObj(rowCell[parseInt(i.toString(), 10)].rowIndex);
                for(var j = 0, cLen = rowCell[parseInt(i.toString(), 10)].cellIndexes.length; j < cLen; j++){
                    if (rowObj.cells) foreignKeyData.push(rowObj.cells[rowCell[parseInt(i.toString(), 10)].cellIndexes[parseInt(j.toString(), 10)]].foreignKeyData);
                    cells.push(gObj.getCellFromIndex(rowCell[parseInt(i.toString(), 10)].rowIndex, rowCell[parseInt(i.toString(), 10)].cellIndexes[parseInt(j.toString(), 10)]));
                }
            }
            this.cellDeselect($17b89d3b1fc93cdb$export$ddb5b152fc2e4709, rowCell, data, cells, foreignKeyData);
            if (this.isPreventCellSelect === true) return;
            for(var i = 0, len = selectedCells.length; i < len; i++){
                selectedCells[parseInt(i.toString(), 10)].classList.remove("e-cellselectionbackground");
                selectedCells[parseInt(i.toString(), 10)].removeAttribute("aria-selected");
            }
            if (this.bdrElement) this.showHideBorders("none");
            this.selectedRowCellIndexes = [];
            this.isCellSelected = false;
            if (!this.isDragged && this.cellselected) this.cellDeselect($17b89d3b1fc93cdb$export$103fc9af7fdf4985, rowCell, data, cells, foreignKeyData);
        }
    };
    Selection.prototype.getSelectedCellsElement = function() {
        var gObj = this.parent;
        var rows = gObj.getDataRows();
        var cells = [];
        for(var i = 0, len = rows.length; i < len; i++)cells = cells.concat([].slice.call(rows[parseInt(i.toString(), 10)].getElementsByClassName("e-cellselectionbackground")));
        return cells;
    };
    Selection.prototype.mouseMoveHandler = function(e) {
        e.preventDefault();
        this.stopTimer();
        var gBRect = this.parent.element.getBoundingClientRect();
        var x1 = this.x;
        var y1 = this.y;
        var position = (0, $748c2240e597a9b7$export$1690e12b840569b9)(e);
        var x2 = position.x - gBRect.left;
        var y2 = position.y - gBRect.top;
        var tmp;
        var target = (0, $4ZDHT.closest)(e.target, "tr");
        this.isDragged = true;
        if (!this.isCellDrag) {
            if (!target) target = (0, $4ZDHT.closest)(document.elementFromPoint(this.parent.element.offsetLeft + 2, e.clientY), "tr");
            if (x1 > x2) {
                tmp = x2;
                x2 = x1;
                x1 = tmp;
            }
            if (y1 > y2) {
                tmp = y2;
                y2 = y1;
                y1 = tmp;
            }
            this.element.style.left = x1 + "px";
            this.element.style.top = y1 + "px";
            this.element.style.width = x2 - x1 + "px";
            this.element.style.height = y2 - y1 + "px";
        }
        if (target && !e.ctrlKey && !e.shiftKey) {
            var rowIndex = parseInt(target.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            if (!this.isCellDrag) {
                this.hideAutoFill();
                this.selectRowsByRange(this.startDIndex, rowIndex);
                this.isRowDragSelected = true;
            } else {
                var td = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
                if (td) {
                    this.startAFCell = this.startCell;
                    this.endAFCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
                    if (rowIndex > -1) this.selectLikeExcel(e, rowIndex, parseInt(td.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10));
                }
            }
        }
        if (!e.ctrlKey && !e.shiftKey && !this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling && !this.parent.enableColumnVirtualization && !this.parent.groupSettings.columns.length && this.isCellDrag) this.updateScrollPosition(e, position, this.parent.getContent());
    };
    Selection.prototype.updateScrollPosition = function(mouseEvent, position, scrollElement) {
        var _this = this;
        var clientRect = scrollElement.getBoundingClientRect();
        if (clientRect.left >= position.x - 20 - (this.parent.enableRtl && this.parent.height !== "auto" ? (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() : 0)) this.timer1 = window.setInterval(function() {
            _this.setScrollPosition(scrollElement.firstElementChild, _this.parent.enableRtl ? "right" : "left", mouseEvent);
        }, 200);
        else if (clientRect.left + scrollElement.clientWidth - 20 - (!this.parent.enableRtl && this.parent.height !== "auto" ? (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() : 0) < position.x) this.timer1 = window.setInterval(function() {
            _this.setScrollPosition(scrollElement.firstElementChild, _this.parent.enableRtl ? "left" : "right", mouseEvent);
        }, 200);
        if (clientRect.top >= position.y - this.parent.getRowHeight() * 0.5) this.timer2 = window.setInterval(function() {
            _this.setScrollPosition(scrollElement.firstElementChild, "up", mouseEvent);
        }, 200);
        else if (clientRect.top + scrollElement.clientHeight - this.parent.getRowHeight() * 0.5 - (scrollElement.firstElementChild.scrollWidth > scrollElement.firstElementChild.offsetWidth ? (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() : 0) <= position.y) this.timer2 = window.setInterval(function() {
            _this.setScrollPosition(scrollElement.firstElementChild, "down", mouseEvent);
        }, 200);
    };
    Selection.prototype.stopTimer = function() {
        if (this.timer1) {
            window.clearInterval(this.timer1);
            this.timer1 = null;
        }
        if (this.timer2) {
            window.clearInterval(this.timer2);
            this.timer2 = null;
        }
        this.preventFocus = false;
    };
    Selection.prototype.setScrollPosition = function(scrollElement, direction, mouseEvent) {
        var rowIndex = -1;
        var columnIndex = -1;
        if (this.endAFCell || this.prevECIdxs) {
            rowIndex = this.endAFCell ? parseInt(this.endAFCell.getAttribute("index"), 10) : this.prevECIdxs.rowIndex;
            columnIndex = this.endAFCell ? parseInt(this.endAFCell.getAttribute("data-colindex"), 10) : this.prevECIdxs.cellIndex;
        }
        switch(direction){
            case "up":
                if (mouseEvent && (0, $4ZDHT.closest)(mouseEvent.target, ".e-headercontent")) return;
                if (this.isAutoFillSel && this.startAFCell && this.selectedRowCellIndexes.length && (this.selectedRowCellIndexes.length === 1 && this.startAFCell !== this.startCell || this.selectedRowCellIndexes.length > 1 && this.startAFCell.getBoundingClientRect().top > 0)) rowIndex = parseInt(this.startAFCell.getAttribute("index"), 10);
                rowIndex -= 1;
                if (this.parent.frozenRows) rowIndex += this.parent.frozenRows + 1;
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                rowIndex < 1 ? scrollElement.scrollTop = 0 : scrollElement.scrollTop -= this.parent.getRowByIndex(rowIndex).offsetHeight;
                break;
            case "down":
                if (this.isAutoFillSel && this.startAFCell && this.startAFCell !== this.startCell) rowIndex = parseInt(this.startAFCell.getAttribute("index"), 10);
                if (rowIndex < this.parent.getRows().length - 1) {
                    rowIndex += 1;
                    if (this.isAutoFillSel && this.startAFCell && this.startAFCell !== this.startCell) this.startAFCell = this.parent.getCellFromIndex(rowIndex, this.selectedRowCellIndexes[0].cellIndexes[0]);
                    scrollElement.scrollTop += this.parent.getRowByIndex(rowIndex).offsetHeight;
                } else scrollElement.scrollTop = scrollElement.scrollHeight;
                break;
            case "left":
                if (columnIndex > 0 && rowIndex > -1) {
                    if (this.isAutoFillSel && this.startAFCell && this.selectedRowCellIndexes.length && (this.selectedRowCellIndexes[0].cellIndexes.length > 0 && this.startAFCell !== this.startCell || this.selectedRowCellIndexes[0].cellIndexes.length > 1 && (!this.parent.enableRtl && this.startAFCell.getBoundingClientRect().left > 0 || this.parent.enableRtl && this.startAFCell.getBoundingClientRect().left < this.parent.element.offsetWidth))) columnIndex = parseInt(this.startAFCell.getAttribute("data-colindex"), 10);
                    var nextElement_1 = this.findNextCell(scrollElement, direction, columnIndex, rowIndex);
                    columnIndex = nextElement_1 ? parseInt(nextElement_1.getAttribute("data-colindex"), 10) : -1;
                    if (this.parent.enableRtl && nextElement_1) // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    columnIndex < 1 ? scrollElement.scrollLeft = scrollElement.scrollWidth : scrollElement.scrollLeft += nextElement_1.offsetWidth;
                    else if (nextElement_1) // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    columnIndex < 1 ? scrollElement.scrollLeft = 0 : scrollElement.scrollLeft -= nextElement_1.offsetWidth;
                }
                break;
            case "right":
                if (this.isAutoFillSel && this.startAFCell && this.startAFCell !== this.startCell) columnIndex = parseInt(this.startAFCell.getAttribute("data-colindex"), 10);
                // eslint-disable-next-line no-case-declarations
                var currentElement = this.parent.getCellFromIndex(rowIndex, columnIndex);
                // eslint-disable-next-line no-case-declarations
                var nextElement = this.findNextCell(scrollElement, direction, columnIndex, rowIndex);
                if (nextElement && this.isAutoFillSel && this.startAFCell && this.startAFCell !== this.startCell) this.startAFCell = this.parent.getCellFromIndex(this.selectedRowCellIndexes[0].rowIndex, parseInt(nextElement.getAttribute("data-colindex"), 10));
                columnIndex = nextElement ? parseInt(nextElement.getAttribute("data-colindex"), 10) : -1;
                if (this.parent.enableRtl && nextElement) // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                columnIndex < this.parent.columns.length - 1 ? scrollElement.scrollLeft -= currentElement.offsetWidth : scrollElement.scrollLeft = -scrollElement.scrollWidth;
                else if (nextElement) // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                columnIndex < this.parent.columns.length - 1 ? scrollElement.scrollLeft += currentElement.offsetWidth : scrollElement.scrollLeft = scrollElement.scrollWidth;
                if (this.isAutoFillSel && (columnIndex === this.parent.columns.length - 1 || columnIndex === -1) && this.startAFCell && this.endAFCell) {
                    this.positionAFBorders();
                    scrollElement.scrollLeft = this.parent.enableRtl ? -scrollElement.scrollWidth : scrollElement.scrollWidth;
                }
                break;
        }
        if (rowIndex > -1 && rowIndex < this.parent.getRows().length && columnIndex > -1) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var mouseEvent_1 = {
                target: this.parent.getCellFromIndex(rowIndex, columnIndex)
            };
            if (this.isAutoFillSel && mouseEvent_1.target.classList.contains("e-cellselectionbackground") && (direction === "down" && parseInt(mouseEvent_1.target.getAttribute("index"), 10) === this.parent.getRows().length - 1 || direction === "right" && parseInt(mouseEvent_1.target.getAttribute("data-colindex"), 10) === this.parent.columns.length - 1)) return;
            this.endAFCell = mouseEvent_1.target;
            this.preventFocus = true;
            this.selectLikeExcel(mouseEvent_1, rowIndex, columnIndex);
        }
    };
    Selection.prototype.findNextCell = function(scrollElement, direction, columnIndex, rowIndex) {
        var nextElement = this.parent.getCellFromIndex(rowIndex, direction === "left" ? columnIndex - 1 : columnIndex + 1);
        if (nextElement && nextElement.classList.contains("e-hide")) {
            var siblingEles = nextElement.closest("tr").querySelectorAll(".e-rowcell:not(.e-hide)");
            var nextEleInd = Array.from(siblingEles).indexOf(nextElement.nextElementSibling);
            if (nextEleInd > 0 && nextEleInd < siblingEles.length - 1) {
                nextElement = siblingEles[nextEleInd + (direction === "left" ? -1 : 1)];
                return nextElement;
            } else {
                scrollElement.scrollLeft = 0;
                return null;
            }
        }
        return nextElement;
    };
    Selection.prototype.selectLikeExcel = function(e, rowIndex, cellIndex) {
        if (!this.isAutoFillSel) {
            this.clearCellSelection();
            this.selectCellsByRange({
                rowIndex: this.startDIndex,
                cellIndex: this.startDCellIndex
            }, {
                rowIndex: rowIndex,
                cellIndex: cellIndex
            });
            this.drawBorders();
        } else {
            this.showAFBorders();
            this.selectLikeAutoFill(e);
        }
    };
    Selection.prototype.setFrozenBorders = function(parentEle, border, bdrStr) {
        var width = border.style.borderWidth.toString().split(" ");
        var strCell = [
            "",
            "e-leftfreeze",
            "e-unfreeze",
            "e-leftfreeze",
            "e-unfreeze",
            "e-rightfreeze",
            "e-rightfreeze"
        ];
        var cells = [].slice.call(parentEle.querySelectorAll(".e-cellselectionbackground." + strCell["" + bdrStr])).filter(function(ele) {
            return ele.style.display === "";
        });
        var fixedCells = [].slice.call(parentEle.querySelectorAll(".e-cellselectionbackground.e-fixedfreeze")).filter(function(ele) {
            return ele.style.display === "";
        });
        var isRtl = this.parent.enableRtl;
        if (cells.length) {
            var firstRowIdx = cells[0].getAttribute("index");
            var firstColIdx = cells[0].getAttribute("data-colindex");
            var lastRowIdx = cells[cells.length - 1].getAttribute("index");
            var lastColIdx = cells[cells.length - 1].getAttribute("data-colindex");
            for(var i = 0; i < cells.length; i++){
                if (cells[parseInt(i.toString(), 10)].getAttribute("index") === firstRowIdx && (width.length === 1 || width.length === 3 && parseInt(width[0], 10) === 2 || width.length === 4 && parseInt(width[0], 10) === 2)) cells[parseInt(i.toString(), 10)].classList.add("e-xlsel-top-border");
                if (cells[parseInt(i.toString(), 10)].getAttribute("data-colindex") === firstColIdx && (width.length === 1 || width.length === 3 && parseInt(width[1], 10) === 2 || width.length === 4 && (!isRtl && parseInt(width[3], 10) === 2 || isRtl && parseInt(width[1], 10) === 2))) cells[parseInt(i.toString(), 10)].classList.add(isRtl ? "e-xlsel-right-border" : "e-xlsel-left-border");
                if (cells[parseInt(i.toString(), 10)].getAttribute("index") === lastRowIdx && (width.length === 1 || width.length === 3 && parseInt(width[2], 10) === 2 || width.length === 4 && parseInt(width[2], 10) === 2)) cells[parseInt(i.toString(), 10)].classList.add("e-xlsel-bottom-border");
                if (cells[parseInt(i.toString(), 10)].getAttribute("data-colindex") === lastColIdx && (width.length === 1 || width.length === 3 && parseInt(width[1], 10) === 2 || width.length === 4 && !isRtl && parseInt(width[1], 10) === 2 || isRtl && parseInt(width[3], 10) === 2)) cells[parseInt(i.toString(), 10)].classList.add(isRtl ? "e-xlsel-left-border" : "e-xlsel-right-border");
            }
        }
        if (fixedCells.length) {
            var firstRowIdx = fixedCells[0].getAttribute("index");
            var firstColIdx = fixedCells[0].getAttribute("data-colindex");
            var lastRowIdx = fixedCells[fixedCells.length - 1].getAttribute("index");
            var lastColIdx = fixedCells[fixedCells.length - 1].getAttribute("data-colindex");
            for(var i = 0; i < fixedCells.length; i++){
                var idx = fixedCells[parseInt(i.toString(), 10)].getAttribute("index");
                var colIdx = fixedCells[parseInt(i.toString(), 10)].getAttribute("data-colindex");
                if (idx === firstRowIdx && (!this.parent.getHeaderContent().querySelector(".e-cellselectionbackground.e-fixedfreeze") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(parentEle, "e-content") || !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(parentEle, "e-content"))) fixedCells[parseInt(i.toString(), 10)].classList.add("e-xlsel-top-border");
                if (idx === lastRowIdx && (!this.parent.getContent().querySelector(".e-cellselectionbackground.e-fixedfreeze") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(parentEle, "e-headercontent") || !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(parentEle, "e-headercontent"))) fixedCells[parseInt(i.toString(), 10)].classList.add("e-xlsel-bottom-border");
                var preCell = fixedCells[parseInt(i.toString(), 10)].parentElement.children[parseInt(colIdx, 10) - 1];
                if (colIdx === firstColIdx && (!preCell || preCell && !preCell.classList.contains("e-cellselectionbackground"))) fixedCells[parseInt(i.toString(), 10)].classList.add(isRtl ? "e-xlsel-right-border" : "e-xlsel-left-border");
                var nextCell = fixedCells[parseInt(i.toString(), 10)].parentElement.children[parseInt(colIdx, 10) + 1];
                if (colIdx === lastColIdx && (!nextCell || nextCell && !nextCell.classList.contains("e-cellselectionbackground"))) fixedCells[parseInt(i.toString(), 10)].classList.add(isRtl ? "e-xlsel-left-border" : "e-xlsel-right-border");
            }
        }
    };
    Selection.prototype.refreshFrozenBorders = function() {
        if (this.bdrElement) {
            this.setFrozenBorders(this.parent.getContentTable(), this.bdrElement, "1");
            if (this.parent.isFrozenGrid() && this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.setFrozenBorders(this.parent.getContentTable(), this.frcBdrElement, "5");
            if (this.parent.frozenRows) {
                this.setFrozenBorders(this.parent.getHeaderTable(), this.fhBdrElement, "3");
                if (this.parent.isFrozenGrid() && this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.setFrozenBorders(this.parent.getHeaderTable(), this.frhBdrElement, "6");
            }
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Selection.prototype.drawBorders = function() {
        if (this.selectionSettings.cellSelectionMode === "BoxWithBorder" && this.selectedRowCellIndexes.length && !this.parent.isEdit) {
            this.parent.element.classList.add("e-enabledboxbdr");
            if (!this.bdrElement) this.createBorders();
            this.positionBorders();
            if (this.parent.isFrozenGrid()) {
                this.showHideBorders("none", true);
                this.refreshFrozenBorders();
            }
        } else this.showHideBorders("none");
    };
    Selection.prototype.isLastCell = function(cell) {
        var cells = [].slice.call(cell.parentElement.querySelectorAll(".e-rowcell:not(.e-hide)"));
        return cells[cells.length - 1] === cell;
    };
    Selection.prototype.isLastRow = function(cell) {
        var rows = [].slice.call((0, $4ZDHT.closest)(cell, $1b5568e76cdae6d4$export$7cdd536eaa8f163c).querySelectorAll(".e-row:not(.e-hiddenrow)"));
        return cell.parentElement === rows[rows.length - 1];
    };
    Selection.prototype.isFirstRow = function(cell) {
        var rows = [].slice.call((0, $4ZDHT.closest)(cell, $1b5568e76cdae6d4$export$7cdd536eaa8f163c).querySelectorAll(".e-row:not(.e-hiddenrow)"));
        return cell.parentElement === rows[0];
    };
    Selection.prototype.isFirstCell = function(cell) {
        var cells = [].slice.call(cell.parentElement.querySelectorAll(".e-rowcell:not(.e-hide)"));
        return cells[0] === cell;
    };
    Selection.prototype.setBorders = function(parentEle, border, bdrStr) {
        var cells = [].slice.call(parentEle.getElementsByClassName("e-cellselectionbackground")).filter(function(ele) {
            return ele.style.display === "";
        });
        if (cells.length && this.parent.isFrozenGrid()) {
            var strCell = [
                "",
                "e-leftfreeze",
                "e-unfreeze",
                "e-leftfreeze",
                "e-unfreeze",
                "e-rightfreeze",
                "e-rightfreeze"
            ];
            cells = [].slice.call(parentEle.querySelectorAll(".e-cellselectionbackground." + strCell["" + bdrStr] + ":not(.e-hide)")).filter(function(ele) {
                return ele.style.display === "";
            });
        }
        if (cells.length) {
            var isFrozen = this.parent.isFrozenGrid();
            var start = cells[0];
            var end = cells[cells.length - 1];
            var stOff = start.getBoundingClientRect();
            var endOff = end.getBoundingClientRect();
            var parentOff = start.offsetParent.getBoundingClientRect();
            if (start.offsetParent.classList.contains("e-content") || start.offsetParent.classList.contains("e-headercontent")) parentOff = start.offsetParent.querySelector("table").getBoundingClientRect();
            var rowHeight = !isFrozen && this.isLastRow(end) && (bdrStr === "1" || bdrStr === "2" || bdrStr === "5") ? 2 : 0;
            var topOffSet = 0;
            var leftOffset = isFrozen && (bdrStr === "2" || bdrStr === "4") && this.isFirstCell(start) ? 1 : 0;
            var rightOffset = (this.parent.getFrozenMode() === "Right" && (bdrStr === "1" || bdrStr === "3") || this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2 && (bdrStr === "5" || bdrStr === "6")) && this.isFirstCell(start) ? 1 : 0;
            if (this.parent.enableRtl) {
                border.style.right = parentOff.right - stOff.right - leftOffset + "px";
                border.style.width = stOff.right - endOff.left + leftOffset + 1 + "px";
            } else {
                border.style.left = stOff.left - parentOff.left - leftOffset - rightOffset + "px";
                border.style.width = endOff.right - stOff.left + leftOffset - rightOffset + 1 + "px";
            }
            border.style.top = stOff.top - parentOff.top - topOffSet + "px";
            border.style.height = endOff.top - stOff.top > 0 ? endOff.top - parentOff.top + endOff.height + (isFrozen ? 0 : 1) - (stOff.top - parentOff.top) - rowHeight + topOffSet + "px" : endOff.height + topOffSet - rowHeight + (isFrozen ? 0 : 1) + "px";
            this.selectDirection += bdrStr;
        } else border.style.display = "none";
    };
    Selection.prototype.positionBorders = function() {
        this.updateStartEndCells();
        if (!this.startCell || !this.bdrElement || !this.selectedRowCellIndexes.length) return;
        this.selectDirection = "";
        this.showHideBorders("");
        this.setBorders(this.parent.getContentTable(), this.bdrElement, "1");
        if (this.parent.isFrozenGrid()) {
            this.setBorders(this.parent.getContentTable(), this.mcBdrElement, "2");
            if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.setBorders(this.parent.getContentTable(), this.frcBdrElement, "5");
        }
        if (this.parent.frozenRows) {
            this.setBorders(this.parent.getHeaderTable(), this.fhBdrElement, "3");
            if (this.parent.isFrozenGrid()) {
                this.setBorders(this.parent.getHeaderTable(), this.mhBdrElement, "4");
                if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.setBorders(this.parent.getHeaderTable(), this.frhBdrElement, "6");
            }
        }
        this.applyBorders(this.selectDirection);
    };
    /* eslint-enable */ Selection.prototype.applyBothFrozenBorders = function(str) {
        var rtl = this.parent.enableRtl;
        switch(str.length){
            case 6:
                this.bdrElement.style.borderWidth = rtl ? this.right_bottom : this.bottom_left;
                this.mcBdrElement.style.borderWidth = this.bottom;
                this.fhBdrElement.style.borderWidth = rtl ? this.top_right : this.top_left;
                this.mhBdrElement.style.borderWidth = this.top;
                this.frcBdrElement.style.borderWidth = rtl ? this.bottom_left : this.right_bottom;
                this.frhBdrElement.style.borderWidth = rtl ? this.top_left : this.top_right;
                break;
            case 4:
                if (str.includes("1") && str.includes("2") && str.includes("3") && str.includes("4")) {
                    this.fhBdrElement.style.borderWidth = rtl ? this.top_right : this.top_left;
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_left : this.top_right;
                    this.bdrElement.style.borderWidth = rtl ? this.right_bottom : this.bottom_left;
                    this.mcBdrElement.style.borderWidth = rtl ? this.bottom_left : this.right_bottom;
                }
                if (str.includes("2") && str.includes("4") && str.includes("5") && str.includes("6")) {
                    this.mcBdrElement.style.borderWidth = rtl ? this.right_bottom : this.bottom_left;
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_right : this.top_left;
                    this.frcBdrElement.style.borderWidth = rtl ? this.bottom_left : this.right_bottom;
                    this.frhBdrElement.style.borderWidth = rtl ? this.top_left : this.top_right;
                }
                break;
            case 3:
                this.bdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                this.mcBdrElement.style.borderWidth = this.top_bottom;
                this.frcBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                if (this.parent.frozenRows) {
                    this.fhBdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                    this.mhBdrElement.style.borderWidth = this.top_bottom;
                    this.frcBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                }
                break;
            case 2:
                if (str.includes("1")) {
                    this.mcBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                    if (this.parent.frozenRows) this.fhBdrElement.style.borderWidth = this.top_right_left;
                }
                if (str.includes("2")) {
                    this.bdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                    this.frcBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                    if (this.parent.frozenRows) this.mhBdrElement.style.borderWidth = this.top_right_left;
                }
                if (str.includes("3")) {
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                    this.bdrElement.style.borderWidth = this.right_bottom_left;
                }
                if (str.includes("4")) {
                    this.fhBdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                    this.frhBdrElement.style.borderWidth = rtl ? this.top_bottom_left : this.top_right_bottom;
                    this.mcBdrElement.style.borderWidth = this.right_bottom_left;
                }
                if (str.includes("5")) {
                    this.mcBdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                    if (this.parent.frozenRows) this.frhBdrElement.style.borderWidth = this.top_right_left;
                }
                if (str.includes("6")) {
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_right_bottom : this.top_bottom_left;
                    this.frcBdrElement.style.borderWidth = this.right_bottom_left;
                }
                break;
            default:
                this.bdrElement.style.borderWidth = this.all_border;
                this.mcBdrElement.style.borderWidth = this.all_border;
                this.frcBdrElement.style.borderWidth = this.all_border;
                if (this.parent.frozenRows) {
                    this.fhBdrElement.style.borderWidth = this.all_border;
                    this.mhBdrElement.style.borderWidth = this.all_border;
                    this.frhBdrElement.style.borderWidth = this.all_border;
                }
                break;
        }
    };
    Selection.prototype.applyBorders = function(str) {
        var rtl = this.parent.enableRtl;
        if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.applyBothFrozenBorders(str);
        else switch(str.length){
            case 4:
                if (this.parent.getFrozenMode() === "Right") {
                    this.bdrElement.style.borderWidth = rtl ? this.bottom_left : this.right_bottom;
                    this.mcBdrElement.style.borderWidth = rtl ? this.right_bottom : this.bottom_left;
                    this.fhBdrElement.style.borderWidth = rtl ? this.top_left : this.top_right;
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_right : this.top_left;
                } else {
                    this.bdrElement.style.borderWidth = rtl ? this.right_bottom : this.bottom_left;
                    this.mcBdrElement.style.borderWidth = rtl ? this.bottom_left : this.right_bottom;
                    this.fhBdrElement.style.borderWidth = rtl ? this.top_right : this.top_left;
                    this.mhBdrElement.style.borderWidth = rtl ? this.top_left : this.top_right;
                }
                break;
            case 2:
                if (this.parent.getFrozenMode() === "Right") {
                    this.bdrElement.style.borderWidth = str.includes("2") ? rtl ? this.top_bottom_left : this.top_right_bottom : this.right_bottom_left;
                    this.mcBdrElement.style.borderWidth = str.includes("1") ? rtl ? this.top_right_bottom : this.top_bottom_left : this.right_bottom_left;
                    if (this.parent.frozenRows) {
                        this.fhBdrElement.style.borderWidth = str.includes("1") ? this.top_right_left : rtl ? this.top_bottom_left : this.top_right_bottom;
                        this.mhBdrElement.style.borderWidth = str.includes("2") ? this.top_right_left : rtl ? this.top_right_bottom : this.top_bottom_left;
                    }
                } else {
                    this.bdrElement.style.borderWidth = str.includes("2") ? rtl ? this.top_right_bottom : this.top_bottom_left : this.right_bottom_left;
                    if (this.parent.isFrozenGrid()) this.mcBdrElement.style.borderWidth = str.includes("1") ? rtl ? this.top_bottom_left : this.top_right_bottom : this.right_bottom_left;
                    if (this.parent.frozenRows) {
                        this.fhBdrElement.style.borderWidth = str.includes("1") ? this.top_right_left : rtl ? this.top_right_bottom : this.top_bottom_left;
                        if (this.parent.isFrozenGrid()) this.mhBdrElement.style.borderWidth = str.includes("2") ? this.top_right_left : rtl ? this.top_bottom_left : this.top_right_bottom;
                    }
                }
                break;
            default:
                this.bdrElement.style.borderWidth = this.all_border;
                if (this.parent.isFrozenGrid()) this.mcBdrElement.style.borderWidth = this.all_border;
                if (this.parent.frozenRows) {
                    this.fhBdrElement.style.borderWidth = this.all_border;
                    if (this.parent.isFrozenGrid()) this.mhBdrElement.style.borderWidth = this.all_border;
                }
                break;
        }
    };
    Selection.prototype.createBorders = function() {
        if (!this.bdrElement) {
            this.bdrElement = this.parent.getContentTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlsel",
                id: this.parent.element.id + "_bdr",
                styles: "width: 2px; border-width: 0;"
            }));
            if (this.parent.isFrozenGrid()) {
                this.mcBdrElement = this.parent.getContentTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                    className: "e-xlsel",
                    id: this.parent.element.id + "_mcbdr",
                    styles: "height: 2px; border-width: 0;"
                }));
                if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.frcBdrElement = this.parent.getContentTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                    className: "e-xlsel",
                    id: this.parent.element.id + "_frcbdr",
                    styles: "height: 2px; border-width: 0;"
                }));
            }
            if (this.parent.frozenRows) this.fhBdrElement = this.parent.getHeaderTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlsel",
                id: this.parent.element.id + "_fhbdr",
                styles: "height: 2px;"
            }));
            if (this.parent.frozenRows && this.parent.isFrozenGrid()) {
                this.mhBdrElement = this.parent.getHeaderTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                    className: "e-xlsel",
                    id: this.parent.element.id + "_mhbdr",
                    styles: "height: 2px;"
                }));
                if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.frhBdrElement = this.parent.getHeaderTable().parentElement.appendChild((0, $4ZDHT.createElement)("div", {
                    className: "e-xlsel",
                    id: this.parent.element.id + "_frhbdr",
                    styles: "height: 2px;"
                }));
            }
        }
    };
    Selection.prototype.showHideBorders = function(display, freeze) {
        if (this.bdrElement) {
            this.bdrElement.style.display = display;
            if (this.parent.isFrozenGrid()) {
                var parentEle = this.parent.getContentTable();
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-top-border"), "e-xlsel-top-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-left-border"), "e-xlsel-left-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-right-border"), "e-xlsel-right-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-bottom-border"), "e-xlsel-bottom-border");
                if (!freeze) this.mcBdrElement.style.display = display;
                if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.frcBdrElement.style.display = display;
            }
            if (this.parent.frozenRows) {
                var parentEle = this.parent.getHeaderTable();
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-top-border"), "e-xlsel-top-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-left-border"), "e-xlsel-left-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-right-border"), "e-xlsel-right-border");
                (0, $4ZDHT.removeClass)(parentEle.querySelectorAll(".e-xlsel-bottom-border"), "e-xlsel-bottom-border");
                this.fhBdrElement.style.display = display;
            }
            if (this.parent.frozenRows && this.parent.isFrozenGrid()) {
                if (!freeze) this.mhBdrElement.style.display = display;
                if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) this.frhBdrElement.style.display = display;
            }
        }
    };
    Selection.prototype.drawAFBorders = function() {
        if (!this.bdrAFBottom) this.createAFBorders();
        this.positionAFBorders();
    };
    Selection.prototype.positionAFBorders = function() {
        if (!this.startCell || !this.bdrAFLeft) return;
        var stOff = this.startAFCell.getBoundingClientRect();
        var endOff = this.endAFCell.getBoundingClientRect();
        var top = endOff.top - stOff.top > 0 ? 1 : 0;
        var firstCellTop = endOff.top - stOff.top >= 0 && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$3a619000c6e2d0b1) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, "e-frozencontent")) && this.isFirstRow(this.startAFCell) ? 1.5 : 0;
        var firstCellLeft = ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$3a619000c6e2d0b1) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$af4960656b46803f)) && this.isFirstCell(this.startAFCell) ? 1 : 0;
        var rowHeight = this.isLastRow(this.endAFCell) && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.endAFCell, $1b5568e76cdae6d4$export$3a619000c6e2d0b1) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.endAFCell, "e-frozencontent")) ? 2 : 0;
        var parentOff = this.startAFCell.offsetParent.getBoundingClientRect();
        var parentRect = this.parent.element.getBoundingClientRect();
        var sTop = this.startAFCell.offsetParent.parentElement.scrollTop;
        var sLeft = this.startAFCell.offsetParent.parentElement.scrollLeft;
        var scrollTop = sTop - this.startAFCell.offsetTop;
        var scrollLeft = sLeft - this.startAFCell.offsetLeft;
        var totalHeight = this.parent.element.clientHeight - (0, $748c2240e597a9b7$export$1df2a1438d36fb55)();
        if (this.parent.allowPaging) totalHeight -= this.parent.element.querySelector(".e-pager").offsetHeight;
        if (this.parent.aggregates.length) totalHeight -= this.parent.getFooterContent().offsetHeight;
        var totalWidth = this.parent.element.clientWidth - (this.parent.height !== "auto" ? (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() : 0);
        scrollTop = scrollTop > 0 ? Math.floor(scrollTop) - 1 : 0;
        scrollLeft = scrollLeft > 0 ? scrollLeft : 0;
        var left = stOff.left - parentRect.left;
        if (!this.parent.enableRtl) {
            this.bdrAFLeft.style.left = left - firstCellLeft + scrollLeft - 1 + "px";
            this.bdrAFRight.style.left = endOff.left - parentRect.left - 2 + endOff.width + "px";
            this.bdrAFRight.style.width = totalWidth <= parseInt(this.bdrAFRight.style.left, 10) ? "0px" : "2px";
            this.bdrAFTop.style.left = left + scrollLeft - 0.5 + "px";
            this.bdrAFTop.style.width = parseInt(this.bdrAFRight.style.left, 10) - parseInt(this.bdrAFLeft.style.left, 10) - firstCellLeft + 1 + "px";
            if (totalWidth <= parseInt(this.bdrAFTop.style.width, 10) + parseInt(this.bdrAFTop.style.left, 10)) {
                var leftRemove = parseInt(this.bdrAFTop.style.width, 10) + parseInt(this.bdrAFTop.style.left, 10) - totalWidth;
                this.bdrAFTop.style.width = parseInt(this.bdrAFTop.style.width, 10) - leftRemove + "px";
            }
        } else {
            var scrolloffSet = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$3a619000c6e2d0b1) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$af4960656b46803f) ? stOff.right - this.startAFCell.offsetParent.parentElement.getBoundingClientRect().width - parentRect.left : 0;
            this.bdrAFLeft.style.right = parentRect.right - endOff.right - 2 + endOff.width + "px";
            this.bdrAFLeft.style.width = totalWidth <= parseInt(this.bdrAFLeft.style.right, 10) ? "0px" : "2px";
            var borderAFRightValue = parentRect.right - stOff.right - firstCellLeft + scrolloffSet - 1;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            borderAFRightValue > 0 ? this.bdrAFRight.style.right = borderAFRightValue + "px" : this.bdrAFRight.style.right = "0px";
            this.bdrAFTop.style.left = endOff.left - parentRect.left - 0.5 + "px";
            this.bdrAFTop.style.width = parseInt(this.bdrAFLeft.style.right, 10) - parseInt(this.bdrAFRight.style.right, 10) - firstCellLeft + 1 + "px";
            if (parseInt(this.bdrAFTop.style.left, 10) < 0) {
                this.bdrAFTop.style.width = parseInt(this.bdrAFTop.style.width, 10) + parseInt(this.bdrAFTop.style.left, 10) + "px";
                if (this.parent.height !== "auto" && (0, $748c2240e597a9b7$export$1df2a1438d36fb55)()) {
                    this.bdrAFTop.style.left = (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() + "px";
                    this.bdrAFTop.style.width = parseInt(this.bdrAFTop.style.width, 10) - (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() + "px";
                } else this.bdrAFTop.style.left = "0px";
            }
        }
        this.bdrAFLeft.style.top = stOff.top - parentRect.top - firstCellTop + scrollTop + "px";
        this.bdrAFLeft.style.height = endOff.top - stOff.top > 0 ? endOff.top - parentOff.top + endOff.height + 1 - (stOff.top - parentOff.top) + firstCellTop - rowHeight - scrollTop + "px" : endOff.height + firstCellTop - rowHeight - scrollTop + "px";
        this.bdrAFRight.style.top = this.bdrAFLeft.style.top;
        this.bdrAFRight.style.height = parseInt(this.bdrAFLeft.style.height, 10) + "px";
        this.bdrAFTop.style.top = this.bdrAFRight.style.top;
        this.bdrAFBottom.style.left = this.bdrAFTop.style.left;
        this.bdrAFBottom.style.top = parseFloat(this.bdrAFLeft.style.top) + parseFloat(this.bdrAFLeft.style.height) - top - 1 + "px";
        this.bdrAFBottom.style.width = totalHeight <= parseFloat(this.bdrAFBottom.style.top) ? "0px" : this.bdrAFTop.style.width;
        if (totalHeight <= parseInt(this.bdrAFLeft.style.height, 10) + parseInt(this.bdrAFLeft.style.top, 10)) {
            var topRemove = parseInt(this.bdrAFLeft.style.height, 10) + parseInt(this.bdrAFLeft.style.top, 10) - totalHeight;
            this.bdrAFLeft.style.height = parseInt(this.bdrAFLeft.style.height, 10) - topRemove + "px";
            this.bdrAFRight.style.height = parseInt(this.bdrAFLeft.style.height, 10) + "px";
        }
    };
    Selection.prototype.createAFBorders = function() {
        if (!this.bdrAFLeft) {
            this.bdrAFLeft = this.parent.element.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlselaf",
                id: this.parent.element.id + "_bdrafleft",
                styles: "width: 2px;"
            }));
            this.bdrAFRight = this.parent.element.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlselaf",
                id: this.parent.element.id + "_bdrafright",
                styles: "width: 2px;"
            }));
            this.bdrAFBottom = this.parent.element.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlselaf",
                id: this.parent.element.id + "_bdrafbottom",
                styles: "height: 2px;"
            }));
            this.bdrAFTop = this.parent.element.appendChild((0, $4ZDHT.createElement)("div", {
                className: "e-xlselaf",
                id: this.parent.element.id + "_bdraftop",
                styles: "height: 2px;"
            }));
        }
    };
    Selection.prototype.destroyAutoFillElements = function() {
        if (this.bdrAFLeft) {
            this.bdrAFLeft.remove();
            this.bdrAFRight.remove();
            this.bdrAFBottom.remove();
            this.bdrAFTop.remove();
            this.bdrAFLeft = this.bdrAFRight = this.bdrAFBottom = this.bdrAFTop = null;
        }
        if (this.autofill) {
            this.autofill.remove();
            this.autofill = null;
        }
    };
    Selection.prototype.showAFBorders = function() {
        if (this.bdrAFLeft) {
            this.bdrAFLeft.style.display = "";
            this.bdrAFRight.style.display = "";
            this.bdrAFBottom.style.display = "";
            this.bdrAFTop.style.display = "";
        }
    };
    Selection.prototype.hideAFBorders = function() {
        if (this.bdrAFLeft) {
            this.bdrAFLeft.style.display = "none";
            this.bdrAFRight.style.display = "none";
            this.bdrAFBottom.style.display = "none";
            this.bdrAFTop.style.display = "none";
        }
    };
    Selection.prototype.updateValue = function(rIdx, cIdx, cell) {
        var args = this.createBeforeAutoFill(rIdx, cIdx, cell);
        if (!args.cancel) {
            var col = this.parent.getColumnByIndex(cIdx);
            if (this.parent.editModule && cell) {
                if (col.type === "number") this.parent.editModule.updateCell(rIdx, col.field, parseFloat(args.value));
                else this.parent.editModule.updateCell(rIdx, col.field, args.value);
            }
        }
    };
    Selection.prototype.createBeforeAutoFill = function(rowIndex, colIndex, cell) {
        var col = this.parent.getColumnByIndex(colIndex);
        var args = {
            column: col,
            value: cell.innerText
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$f270b6744c50ca0e, args);
        return args;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Selection.prototype.getAutoFillCells = function(rowIndex, startCellIdx) {
        var cls = ".e-cellselectionbackground";
        var cells = [].slice.call(this.parent.getDataRows()[parseInt(rowIndex.toString(), 10)].querySelectorAll(cls));
        return cells;
    };
    Selection.prototype.selectLikeAutoFill = function(e, isApply) {
        var startrowIdx = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startAFCell, $1b5568e76cdae6d4$export$120ff0929b202a6d).getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
        var startCellIdx = parseInt(this.startAFCell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        var endrowIdx = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.endAFCell, $1b5568e76cdae6d4$export$120ff0929b202a6d).getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
        var endCellIdx = parseInt(this.endAFCell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        var rowLen = this.selectedRowCellIndexes.length - 1;
        var colLen = this.selectedRowCellIndexes[0].cellIndexes.length - 1;
        switch(true){
            case !isApply && this.endAFCell.classList.contains("e-cellselectionbackground") && !!(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca):
                this.startAFCell = this.parent.getCellFromIndex(startrowIdx, startCellIdx);
                this.endAFCell = this.parent.getCellFromIndex(startrowIdx + rowLen, startCellIdx + colLen);
                this.drawAFBorders();
                break;
            case this.autoFillRLselection && startCellIdx + colLen < endCellIdx && //right
            endCellIdx - startCellIdx - colLen + 1 > endrowIdx - startrowIdx - rowLen // right bottom
             && endCellIdx - startCellIdx - colLen + 1 > startrowIdx - endrowIdx:
                this.endAFCell = this.parent.getCellFromIndex(startrowIdx + rowLen, endCellIdx);
                endrowIdx = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.endAFCell, $1b5568e76cdae6d4$export$120ff0929b202a6d).getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                endCellIdx = parseInt(this.endAFCell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
                if (!isApply) this.drawAFBorders();
                else {
                    var cellIdx = parseInt(this.endCell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
                    for(var i = startrowIdx; i <= endrowIdx; i++){
                        var cells = this.getAutoFillCells(i, startCellIdx);
                        var c = 0;
                        for(var j = cellIdx + 1; j <= endCellIdx; j++){
                            if (c > colLen) c = 0;
                            this.updateValue(i, j, cells[parseInt(c.toString(), 10)]);
                            c++;
                        }
                    }
                    this.selectCellsByRange({
                        rowIndex: startrowIdx,
                        cellIndex: this.startCellIndex
                    }, {
                        rowIndex: endrowIdx,
                        cellIndex: endCellIdx
                    });
                }
                break;
            case this.autoFillRLselection && startCellIdx > endCellIdx && // left
            startCellIdx - endCellIdx + 1 > endrowIdx - startrowIdx - rowLen && //left top
            startCellIdx - endCellIdx + 1 > startrowIdx - endrowIdx:
                this.startAFCell = this.parent.getCellFromIndex(startrowIdx, endCellIdx);
                this.endAFCell = this.endCell;
                if (!isApply) this.drawAFBorders();
                else {
                    for(var i = startrowIdx; i <= startrowIdx + rowLen; i++){
                        var cells = this.getAutoFillCells(i, startCellIdx);
                        cells.reverse();
                        var c = 0;
                        for(var j = this.startCellIndex - 1; j >= endCellIdx; j--){
                            if (c > colLen) c = 0;
                            this.updateValue(i, j, cells[parseInt(c.toString(), 10)]);
                            c++;
                        }
                    }
                    this.selectCellsByRange({
                        rowIndex: startrowIdx,
                        cellIndex: endCellIdx
                    }, {
                        rowIndex: startrowIdx + rowLen,
                        cellIndex: this.startCellIndex + colLen
                    });
                }
                break;
            case startrowIdx > endrowIdx:
                this.startAFCell = this.parent.getCellFromIndex(endrowIdx, startCellIdx);
                this.endAFCell = this.endCell;
                if (!isApply) this.drawAFBorders();
                else {
                    var trIdx = parseInt(this.endCell.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                    var r = trIdx;
                    for(var i = startrowIdx - 1; i >= endrowIdx; i--){
                        if (r === this.startIndex - 1) r = trIdx;
                        var cells = this.getAutoFillCells(r, startCellIdx);
                        var c = 0;
                        r--;
                        for(var j = this.startCellIndex; j <= this.startCellIndex + colLen; j++){
                            this.updateValue(i, j, cells[parseInt(c.toString(), 10)]);
                            c++;
                        }
                    }
                    this.selectCellsByRange({
                        rowIndex: endrowIdx,
                        cellIndex: startCellIdx + colLen
                    }, {
                        rowIndex: startrowIdx + rowLen,
                        cellIndex: startCellIdx
                    });
                }
                break;
            default:
                this.endAFCell = this.parent.getCellFromIndex(endrowIdx, startCellIdx + colLen);
                if (!isApply) this.drawAFBorders();
                else {
                    var trIdx = parseInt(this.endCell.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                    var r = this.startIndex;
                    for(var i = trIdx + 1; i <= endrowIdx; i++){
                        if (r === trIdx + 1) r = this.startIndex;
                        var cells = this.getAutoFillCells(r, startCellIdx);
                        r++;
                        var c = 0;
                        for(var m = this.startCellIndex; m <= this.startCellIndex + colLen; m++){
                            this.updateValue(i, m, cells[parseInt(c.toString(), 10)]);
                            c++;
                        }
                    }
                    this.selectCellsByRange({
                        rowIndex: trIdx - rowLen,
                        cellIndex: startCellIdx
                    }, {
                        rowIndex: endrowIdx,
                        cellIndex: startCellIdx + colLen
                    });
                }
                break;
        }
    };
    Selection.prototype.mouseUpHandler = function(e) {
        this.stopTimer();
        document.body.classList.remove("e-disableuserselect");
        if (this.element && !(0, $3EnZW.isNullOrUndefined)(this.element.parentElement)) (0, $4ZDHT.remove)(this.element);
        if (this.isDragged && this.selectedRowCellIndexes.length === 1 && this.selectedRowCellIndexes[0].cellIndexes.length === 1) this.mUPTarget = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
        else this.mUPTarget = null;
        var closeRowCell = (0, $4ZDHT.closest)(e.target, ".e-rowcell");
        if (this.isDragged && !this.isAutoFillSel && this.selectionSettings.mode === "Cell" && closeRowCell && closeRowCell.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca)) {
            var rowIndex = parseInt(closeRowCell.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            var cellIndex = parseInt(closeRowCell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
            this.isDragged = false;
            this.clearCellSelection();
            this.selectCellsByRange({
                rowIndex: this.startDIndex,
                cellIndex: this.startDCellIndex
            }, {
                rowIndex: rowIndex,
                cellIndex: cellIndex
            });
        }
        this.isDragged = false;
        this.updateAutoFillPosition();
        if (this.isAutoFillSel) {
            this.preventFocus = true;
            var lastCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
            this.endAFCell = lastCell ? lastCell : this.endCell === this.endAFCell ? this.startAFCell : this.endAFCell;
            this.startAFCell = this.startCell;
            if (!(0, $3EnZW.isNullOrUndefined)(this.endAFCell) && !(0, $3EnZW.isNullOrUndefined)(this.startAFCell)) {
                this.updateStartCellsIndex();
                this.selectLikeAutoFill(e, true);
                this.updateAutoFillPosition();
                this.hideAFBorders();
                this.positionBorders();
                if (this.parent.isFrozenGrid()) {
                    this.showHideBorders("none", true);
                    this.refreshFrozenBorders();
                }
                if (this.parent.aggregates.length > 0) this.parent.notify($17b89d3b1fc93cdb$export$14053228fa0745d8, {});
            }
            this.isAutoFillSel = false;
            this.preventFocus = false;
        }
        (0, $aqzbR.EventHandler).remove(this.parent.getContent(), "mousemove", this.mouseMoveHandler);
        if (this.parent.frozenRows) (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), "mousemove", this.mouseMoveHandler);
        (0, $aqzbR.EventHandler).remove(document, "mouseup", this.mouseUpHandler);
    };
    Selection.prototype.hideAutoFill = function() {
        if (this.autofill) this.autofill.style.display = "none";
    };
    /**
     * @returns {void}
     * @hidden
     */ Selection.prototype.updateAutoFillPosition = function() {
        if (this.parent.enableAutoFill && !this.parent.isEdit && this.selectionSettings.cellSelectionMode.indexOf("Box") > -1 && !this.isRowType() && !this.isSingleSel() && this.selectedRowCellIndexes.length) {
            var index = parseInt(this.target.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
            var rindex = parseInt(this.target.getAttribute("index"), 10);
            var rowIndex = this.selectedRowCellIndexes[this.selectedRowCellIndexes.length - 1].rowIndex;
            var cells = this.getAutoFillCells(rowIndex, index).filter(function(ele) {
                return ele.style.display === "";
            });
            var col = this.parent.getColumnByIndex(index);
            var isFrozenCol = col.getFreezeTableName() === "movable";
            var isFrozenRow = rindex < this.parent.frozenRows;
            var isFrozenRight = this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2 && col.getFreezeTableName() === $1b5568e76cdae6d4$export$b86d31d94d6c8026;
            if (!(0, $4ZDHT.select)("#" + this.parent.element.id + "_autofill", (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.target, $1b5568e76cdae6d4$export$9852986a3ec5f6a0))) {
                if ((0, $4ZDHT.select)("#" + this.parent.element.id + "_autofill", this.parent.element)) (0, $4ZDHT.select)("#" + this.parent.element.id + "_autofill", this.parent.element).remove();
                this.autofill = (0, $4ZDHT.createElement)("div", {
                    className: "e-autofill",
                    id: this.parent.element.id + "_autofill"
                });
                this.autofill.style.display = "none";
                if (this.target.classList.contains("e-leftfreeze") || this.target.classList.contains("e-rightfreeze") || this.target.classList.contains("e-fixedfreeze")) this.autofill.classList.add("e-freeze-autofill");
                if (!isFrozenRow) {
                    if (!isFrozenCol) this.parent.getContentTable().parentElement.appendChild(this.autofill);
                    else this.parent.getContentTable().parentElement.appendChild(this.autofill);
                } else if (!isFrozenCol) this.parent.getHeaderTable().parentElement.appendChild(this.autofill);
                else this.parent.getHeaderTable().parentElement.appendChild(this.autofill);
                if (isFrozenRight) {
                    if (isFrozenRow) this.parent.getHeaderTable().parentElement.appendChild(this.autofill);
                    else this.parent.getContentTable().parentElement.appendChild(this.autofill);
                }
            }
            var cell = cells[cells.length - 1];
            if (cell && cell.offsetParent) {
                var clientRect = cell.getBoundingClientRect();
                var parentOff = cell.offsetParent.getBoundingClientRect();
                if (cell.offsetParent.classList.contains("e-content") || cell.offsetParent.classList.contains("e-headercontent")) parentOff = cell.offsetParent.querySelector("table").getBoundingClientRect();
                var colWidth = this.isLastCell(cell) ? 4 : 0;
                var rowHeight = this.isLastRow(cell) ? 3 : 0;
                if (!this.parent.enableRtl) this.autofill.style.left = clientRect.left - parentOff.left + clientRect.width - 4 - colWidth + "px";
                else this.autofill.style.right = parentOff.right - clientRect.right + clientRect.width - 4 - colWidth + "px";
                this.autofill.style.top = clientRect.top - parentOff.top + clientRect.height - 5 - rowHeight + "px";
            }
            this.autofill.style.display = "";
        } else this.hideAutoFill();
    };
    Selection.prototype.mouseDownHandler = function(e) {
        this.mouseButton = e.button;
        var target = e.target;
        var gObj = this.parent;
        var isDrag;
        var gridElement = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-grid");
        if (gridElement && gridElement.id !== gObj.element.id || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$838c0e7679321ff3) && !this.parent.frozenRows || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-editedbatchcell") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$76a2698a7195dbfe)) return;
        if (e.shiftKey || e.ctrlKey) e.preventDefault();
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca) && !e.shiftKey && !e.ctrlKey) {
            if (gObj.selectionSettings.cellSelectionMode.indexOf("Box") > -1 && !this.isRowType() && !this.isSingleSel()) {
                this.isCellDrag = true;
                isDrag = true;
            } else if (gObj.allowRowDragAndDrop && !gObj.isEdit && !this.parent.selectionSettings.checkboxOnly) {
                this.isRowDragSelected = false;
                if (!this.isRowType() || this.isSingleSel() || (0, $4ZDHT.closest)(target, "td").classList.contains("e-selectionbackground")) {
                    this.isDragged = false;
                    return;
                }
                isDrag = true;
                this.element = this.parent.createElement("div", {
                    className: "e-griddragarea"
                });
                gObj.getContent().appendChild(this.element);
            }
            if (isDrag) this.enableDrag(e, true);
        }
        this.updateStartEndCells();
        if (target.classList.contains("e-autofill") || target.classList.contains("e-xlsel")) {
            this.isCellDrag = true;
            this.isAutoFillSel = true;
            this.enableDrag(e);
        }
    };
    Selection.prototype.updateStartEndCells = function() {
        var cells = [].slice.call(this.parent.element.getElementsByClassName("e-cellselectionbackground"));
        this.startCell = cells[0];
        this.endCell = cells[cells.length - 1];
        if (this.startCell) {
            this.startIndex = parseInt(this.startCell.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            this.startCellIndex = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startCell, $1b5568e76cdae6d4$export$deb49d6cac2bdaca).getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        }
    };
    Selection.prototype.updateStartCellsIndex = function() {
        if (this.startCell) {
            this.startIndex = parseInt(this.startCell.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            this.startCellIndex = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.startCell, $1b5568e76cdae6d4$export$deb49d6cac2bdaca).getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        }
    };
    Selection.prototype.enableDrag = function(e, isUpdate) {
        var gObj = this.parent;
        if (isUpdate) {
            var tr = (0, $4ZDHT.closest)(e.target, "tr");
            this.startDIndex = parseInt(tr.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            this.startDCellIndex = parseInt((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca).getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        }
        document.body.classList.add("e-disableuserselect");
        var gBRect = gObj.element.getBoundingClientRect();
        var postion = (0, $748c2240e597a9b7$export$1690e12b840569b9)(e);
        this.x = postion.x - gBRect.left;
        this.y = postion.y - gBRect.top;
        (0, $aqzbR.EventHandler).add(gObj.getContent(), "mousemove", this.mouseMoveHandler, this);
        if (this.parent.frozenRows) (0, $aqzbR.EventHandler).add(gObj.getHeaderContent(), "mousemove", this.mouseMoveHandler, this);
        (0, $aqzbR.EventHandler).add(document, "mouseup", this.mouseUpHandler, this);
    };
    Selection.prototype.clearSelAfterRefresh = function(e) {
        var isInfiniteScroll = this.parent.enableInfiniteScrolling && e.requestType === "infiniteScroll";
        if (e.requestType !== "virtualscroll" && !this.parent.isPersistSelection && !isInfiniteScroll) this.clearSelection();
        if ((e.requestType === "virtualscroll" || isInfiniteScroll) && this.parent.isPersistSelection && this.isPartialSelection && this.isHdrSelectAllClicked) {
            var rowObj = this.parent.getRowsObject().filter(function(e) {
                return e.isSelectable;
            });
            var indexes = [];
            this.selectedRowState = {};
            this.persistSelectedData = [];
            for(var i = 0; i < rowObj.length; i++){
                indexes.push(rowObj[parseInt(i.toString(), 10)].index);
                var pkValue = this.getPkValue(this.primaryKey, rowObj[parseInt(i.toString(), 10)].data);
                this.selectedRowState["" + pkValue] = true;
                this.persistSelectedData.push(rowObj[parseInt(i.toString(), 10)].data);
            }
            this.selectedRowIndexes = indexes;
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Selection.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$27ad5926bed65d9,
                handler: this.enableAfterRender
            },
            {
                event: $17b89d3b1fc93cdb$export$5d4840440f592fca,
                handler: this.initializeSelection
            },
            {
                event: $17b89d3b1fc93cdb$export$19203d5d8509aaa9,
                handler: this.onActionComplete
            },
            {
                event: $17b89d3b1fc93cdb$export$786880bfe8c92895,
                handler: this.onActionComplete
            },
            {
                event: $17b89d3b1fc93cdb$export$f4000f83c4e293d0,
                handler: this.onPropertyChanged
            },
            {
                event: $17b89d3b1fc93cdb$export$859ade0ced56eb99,
                handler: this.onCellFocused
            },
            {
                event: $17b89d3b1fc93cdb$export$9bac90be894496e8,
                handler: this.clearSelAfterRefresh
            },
            {
                event: $17b89d3b1fc93cdb$export$cd2e9ca316e8efca,
                handler: this.columnPositionChanged
            },
            {
                event: $17b89d3b1fc93cdb$export$f44d9209b353bf3e,
                handler: this.initialEnd
            },
            {
                event: $17b89d3b1fc93cdb$export$15a612017ee5398c,
                handler: this.rowsRemoved
            },
            {
                event: $17b89d3b1fc93cdb$export$265a66bcae9d11dd,
                handler: this.refreshHeader
            },
            {
                event: $17b89d3b1fc93cdb$export$5876580e0ddf0aa4,
                handler: this.destroyAutoFillElements
            },
            {
                event: $17b89d3b1fc93cdb$export$b1fb4cac938035f7,
                handler: this.destroy
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
        this.actionBeginFunction = this.actionBegin.bind(this);
        this.actionCompleteFunction = this.actionComplete.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunction);
        this.addEventListener_checkbox();
    };
    /**
     * @returns {void}
     * @hidden
     */ Selection.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $aqzbR.EventHandler).remove(document, "mouseup", this.mouseUpHandler);
        (0, $aqzbR.EventHandler).remove(this.parent.getContent(), "mousedown", this.mouseDownHandler);
        (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), "mousedown", this.mouseDownHandler);
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, false);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunction);
        this.removeEventListener_checkbox();
        this.parent.off($17b89d3b1fc93cdb$export$5876580e0ddf0aa4, this.destroyAutoFillElements);
    };
    Selection.prototype.wireEvents = function() {
        this.isMacOS = navigator.userAgent.indexOf("Mac OS") !== -1;
        if (this.isMacOS) {
            (0, $aqzbR.EventHandler).add(this.parent.element, "keydown", this.keyDownHandler, this);
            (0, $aqzbR.EventHandler).add(this.parent.element, "keyup", this.keyUpHandler, this);
        } else if (!this.parent.allowKeyboard) (0, $aqzbR.EventHandler).add(this.parent.element, "keydown", this.keyDownHandler, this);
    };
    Selection.prototype.unWireEvents = function() {
        if (this.isMacOS) {
            (0, $aqzbR.EventHandler).remove(this.parent.element, "keydown", this.keyDownHandler);
            (0, $aqzbR.EventHandler).remove(this.parent.element, "keyup", this.keyUpHandler);
        } else if (!this.parent.allowKeyboard) (0, $aqzbR.EventHandler).remove(this.parent.element, "keydown", this.keyDownHandler);
    };
    Selection.prototype.columnPositionChanged = function() {
        if (!this.parent.isPersistSelection) this.clearSelection();
    };
    Selection.prototype.refreshHeader = function() {
        this.setCheckAllState();
    };
    Selection.prototype.rowsRemoved = function(e) {
        for(var i = 0; i < e.records.length; i++){
            var pkValue = this.getPkValue(this.primaryKey, e.records[parseInt(i.toString(), 10)]);
            delete this.selectedRowState["" + pkValue];
            --this.totalRecordsCount;
        }
        this.setCheckAllState();
    };
    Selection.prototype.beforeFragAppend = function(e) {
        if (e.requestType !== "virtualscroll" && !this.parent.isPersistSelection) this.clearSelection();
    };
    Selection.prototype.getCheckAllBox = function() {
        return this.parent.getHeaderContent().querySelector(".e-checkselectall");
    };
    Selection.prototype.enableAfterRender = function(e) {
        if (e.module === this.getModuleName() && e.enable) {
            this.render();
            this.initPerisistSelection();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Selection.prototype.render = function(e) {
        (0, $aqzbR.EventHandler).add(this.parent.getContent(), "mousedown", this.mouseDownHandler, this);
        (0, $aqzbR.EventHandler).add(this.parent.getHeaderContent(), "mousedown", this.mouseDownHandler, this);
    };
    Selection.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        var gObj = this.parent;
        if (!(0, $3EnZW.isNullOrUndefined)(e.properties.type)) {
            if (this.selectionSettings.type === "Single") {
                gObj.element.removeAttribute("aria-multiselectable");
                if (this.selectedRowCellIndexes.length > 1) {
                    this.clearCellSelection();
                    this.prevCIdxs = undefined;
                }
                if (this.selectedRowIndexes.length > 1) {
                    this.clearRowSelection();
                    this.prevRowIndex = undefined;
                }
                if (this.selectedColumnsIndexes.length > 1) {
                    this.clearColumnSelection();
                    this.prevColIndex = undefined;
                }
                this.enableSelectMultiTouch = false;
                this.hidePopUp();
            } else if (this.selectionSettings.type === "Multiple") gObj.element.setAttribute("aria-multiselectable", "true");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(e.properties.mode) || !(0, $3EnZW.isNullOrUndefined)(e.properties.cellSelectionMode)) {
            this.clearSelection();
            this.prevRowIndex = undefined;
            this.prevCIdxs = undefined;
            this.prevColIndex = undefined;
        }
        this.isPersisted = true;
        this.checkBoxSelectionChanged();
        this.isPersisted = false;
        if (!this.parent.isCheckBoxSelection) this.initPerisistSelection();
        var checkboxColumn = this.parent.getColumns().filter(function(col) {
            return col.type === "checkbox";
        });
        if (checkboxColumn.length) gObj.isCheckBoxSelection = !(this.selectionSettings.checkboxMode === "ResetOnRowClick");
        this.drawBorders();
    };
    Selection.prototype.hidePopUp = function() {
        if (this.parent.element.querySelector(".e-gridpopup").getElementsByClassName("e-rowselect").length) this.parent.element.querySelector(".e-gridpopup").style.display = "none";
    };
    Selection.prototype.initialEnd = function() {
        if (!this.selectedRowIndexes.length) {
            this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
            this.selectRow(this.parent.selectedRowIndex);
        }
    };
    Selection.prototype.checkBoxSelectionChanged = function() {
        var gobj = this.parent;
        gobj.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.checkBoxSelectionChanged);
        var checkboxColumn = gobj.getColumns().filter(function(col) {
            return col.type === "checkbox";
        });
        if (checkboxColumn.length > 0) {
            gobj.isCheckBoxSelection = true;
            this.chkField = checkboxColumn[0].field;
            this.totalRecordsCount = this.parent.pageSettings.totalRecordsCount;
            if ((0, $3EnZW.isNullOrUndefined)(this.totalRecordsCount)) this.totalRecordsCount = this.getCurrentBatchRecordChanges().length;
            if (this.isSingleSel()) {
                gobj.selectionSettings.type = "Multiple";
                gobj.dataBind();
            } else this.initPerisistSelection();
        }
        if (!gobj.isCheckBoxSelection && !this.isPersisted) {
            this.chkField = null;
            this.initPerisistSelection();
        }
    };
    Selection.prototype.initPerisistSelection = function() {
        var gobj = this.parent;
        if (this.parent.selectionSettings.persistSelection && this.parent.getPrimaryKeyFieldNames().length > 0) {
            gobj.isPersistSelection = true;
            this.ensureCheckboxFieldSelection();
        } else if (this.parent.getPrimaryKeyFieldNames().length > 0) {
            gobj.isPersistSelection = false;
            this.ensureCheckboxFieldSelection();
        } else {
            gobj.isPersistSelection = false;
            this.selectedRowState = {};
        }
    };
    Selection.prototype.ensureCheckboxFieldSelection = function() {
        var gobj = this.parent;
        this.primaryKey = this.parent.getPrimaryKeyFieldNames()[0];
        if (!gobj.enableVirtualization && this.chkField && (gobj.isPersistSelection && Object.keys(this.selectedRowState).length === 0 || !gobj.isPersistSelection)) this.dataSuccess(!(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result || this.parent.getDataModule().isRemote() ? this.parent.getCurrentViewRecords() : this.parent.renderModule.data.dataManager.dataSource.json);
    };
    Selection.prototype.dataSuccess = function(res) {
        for(var i = 0; i < res.length; i++){
            var pkValue = this.getPkValue(this.primaryKey, res[parseInt(i.toString(), 10)]);
            var checkedFieldData = res[parseInt(i.toString(), 10)][this.chkField];
            if ((0, $3EnZW.isNullOrUndefined)(this.selectedRowState["" + pkValue]) && checkedFieldData && typeof checkedFieldData === "boolean") {
                this.selectedRowState["" + pkValue] = checkedFieldData;
                if (this.parent.isPersistSelection) this.persistSelectedData.push(res[parseInt(i.toString(), 10)]);
            }
        }
    };
    Selection.prototype.setRowSelection = function(state) {
        if (!(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result)) {
            if (state) {
                if (this.isPartialSelection && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) {
                    var rowObj = this.parent.getRowsObject().filter(function(e) {
                        return e.isSelectable;
                    });
                    for(var _i = 0, rowObj_1 = rowObj; _i < rowObj_1.length; _i++){
                        var row = rowObj_1[_i];
                        this.selectedRowState[this.getPkValue(this.primaryKey, row.data)] = true;
                    }
                } else {
                    var selectedData = this.isPartialSelection ? this.parent.partialSelectedRecords : this.getData();
                    if (this.parent.groupSettings.columns.length) for(var _a = 0, _b = this.isPartialSelection ? selectedData : selectedData.records; _a < _b.length; _a++){
                        var data = _b[_a];
                        this.selectedRowState[this.getPkValue(this.primaryKey, data)] = true;
                    }
                    else for(var _c = 0, selectedData_1 = selectedData; _c < selectedData_1.length; _c++){
                        var data = selectedData_1[_c];
                        this.selectedRowState[this.getPkValue(this.primaryKey, data)] = true;
                    }
                }
            } else this.selectedRowState = {};
        } else if (state) {
            var selectedStateKeys = Object.keys(this.selectedRowState);
            var unSelectedRowStateKeys = Object.keys(this.unSelectedRowState);
            if (!this.isCheckboxReset) {
                var rowData = this.parent.groupSettings.columns.length && this.parent.isPersistSelection ? this.parent.currentViewData["records"] : this.parent.currentViewData;
                for(var _d = 0, rowData_1 = rowData; _d < rowData_1.length; _d++){
                    var data = rowData_1[_d];
                    if (!(0, $3EnZW.isNullOrUndefined)(data[this.primaryKey])) {
                        var key = data[this.primaryKey].toString();
                        if (selectedStateKeys.indexOf(key) === -1 && unSelectedRowStateKeys.indexOf(key) === -1) this.selectedRowState[data[this.primaryKey]] = true;
                    }
                }
            }
        } else {
            this.selectedRowState = {};
            this.unSelectedRowState = {};
            this.rmtHdrChkbxClicked = false;
        }
    };
    Selection.prototype.getData = function() {
        return this.parent.getDataModule().dataManager.executeLocal(this.parent.getDataModule().generateQuery(true));
    };
    Selection.prototype.getAvailableSelectedData = function() {
        var filteredSearchedSelectedData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.persistSelectedData).executeLocal(this.parent.getDataModule().generateQuery(true));
        if (this.parent.groupSettings.columns.length && filteredSearchedSelectedData && filteredSearchedSelectedData.records) filteredSearchedSelectedData = filteredSearchedSelectedData.records.slice();
        return filteredSearchedSelectedData;
    };
    Selection.prototype.refreshPersistSelection = function() {
        var rows = this.parent.getRows();
        this.totalRecordsCount = this.parent.getCurrentViewRecords().length;
        if (this.parent.allowPaging) this.totalRecordsCount = this.parent.pageSettings.totalRecordsCount;
        if (!(0, $3EnZW.isNullOrUndefined)(rows) && rows.length > 0 && (this.parent.isPersistSelection || this.chkField)) {
            var indexes = [];
            for(var j = 0; j < rows.length; j++){
                var rowObj = this.getRowObj(rows[parseInt(j.toString(), 10)]);
                var pKey = rowObj ? rowObj.data ? this.getPkValue(this.primaryKey, rowObj.data) : null : null;
                if (pKey === null) return;
                if (this.isPartialSelection && !rowObj.isSelectable) continue;
                var checkState = void 0;
                var chkBox = rows[parseInt(j.toString(), 10)].querySelector(".e-checkselect");
                if (this.selectedRowState["" + pKey] || this.parent.checkAllRows === "Check" && this.selectedRowState["" + pKey] && this.totalRecordsCount === Object.keys(this.selectedRowState).length && this.chkAllCollec.indexOf(pKey) < 0 || this.parent.checkAllRows === "Uncheck" && this.chkAllCollec.indexOf(pKey) > 0 && !this.parent.selectedRowIndex || this.parent.checkAllRows === "Intermediate" && !(0, $3EnZW.isNullOrUndefined)(this.chkField) && rowObj.data[this.chkField]) {
                    indexes.push(parseInt(rows[parseInt(j.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10));
                    checkState = true;
                } else {
                    checkState = false;
                    if (this.checkedTarget !== chkBox && this.parent.isCheckBoxSelection && chkBox) (0, $748c2240e597a9b7$export$39b02a8864b327ad)(chkBox.nextElementSibling, checkState);
                }
                this.updatePersistCollection(rows[parseInt(j.toString(), 10)], checkState);
            }
            if (this.isSingleSel() && indexes.length > 0) this.selectRow(indexes[0], true);
            else this.selectRows(indexes);
        }
        if ((this.parent.isCheckBoxSelection || this.parent.selectionSettings.checkboxMode === "ResetOnRowClick") && this.getCurrentBatchRecordChanges().length > 0) this.setCheckAllState();
    };
    Selection.prototype.actionBegin = function(e) {
        if (e.requestType === "save" && this.parent.isPersistSelection) {
            var editChkBox = this.parent.element.querySelector(".e-edit-checkselect");
            if (!(0, $3EnZW.isNullOrUndefined)(editChkBox)) {
                var row = (0, $4ZDHT.closest)(editChkBox, "." + $1b5568e76cdae6d4$export$76a2698a7195dbfe);
                if (row) {
                    if (this.parent.editSettings.mode === "Dialog") row = this.parent.element.querySelector(".e-dlgeditrow");
                    var rowObj = this.getRowObj(row);
                    if (!rowObj) return;
                    this.selectedRowState[this.getPkValue(this.primaryKey, rowObj.data)] = rowObj.isSelected = editChkBox.checked;
                } else this.isCheckedOnAdd = editChkBox.checked;
            }
        }
        if (this.parent.isPersistSelection && this.isPartialSelection) {
            if (e.requestType === "paging" && (this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result)) this.selectedRowIndexes = [];
            if (e.requestType === "filtering" || e.requestType === "searching") {
                this.parent.partialSelectedRecords = [];
                this.parent.disableSelectedRecords = [];
            }
        }
    };
    Selection.prototype.actionComplete = function(e) {
        if (e.requestType === "save" && this.parent.isPersistSelection) {
            if (e.action === "add") {
                if (this.isCheckedOnAdd) {
                    var rowObj = this.parent.getRowObjectFromUID(this.parent.getRows()[e.selectedRow].getAttribute("data-uid"));
                    this.selectedRowState[this.getPkValue(this.primaryKey, rowObj.data)] = rowObj.isSelected = this.isCheckedOnAdd;
                }
                this.isHdrSelectAllClicked = false;
                this.setCheckAllState();
            }
            this.refreshPersistSelection();
        }
        if (e.requestType === "delete" && this.parent.isPersistSelection) {
            var records = e.data;
            var data = records.slice();
            for(var i = 0; i < data.length; i++){
                var pkValue = this.getPkValue(this.primaryKey, data[parseInt(i.toString(), 10)]);
                if (!(0, $3EnZW.isNullOrUndefined)(pkValue)) this.updatePersistDelete(pkValue, this.isPartialSelection);
            }
            this.isHdrSelectAllClicked = false;
            this.setCheckAllState();
            this.totalRecordsCount = this.parent.pageSettings.totalRecordsCount;
        }
        if (e.requestType === "paging") {
            if (this.parent.isPersistSelection && this.isPartialSelection && this.isHdrSelectAllClicked) {
                var rows = this.parent.getRowsObject();
                var indexes = [];
                for(var i = 0; i < rows.length; i++)if (rows[parseInt(i.toString(), 10)].isSelectable) indexes.push(rows[parseInt(i.toString(), 10)].index);
                if (indexes.length) this.selectRows(indexes);
            }
            this.prevRowIndex = undefined;
            this.prevCIdxs = undefined;
            this.prevECIdxs = undefined;
        }
    };
    Selection.prototype.onDataBound = function() {
        if (!this.parent.enableVirtualization && this.parent.isPersistSelection) {
            if (this.selectedRecords.length) this.isPrevRowSelection = true;
        }
        if ((this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && this.rmtHdrChkbxClicked) {
            if (this.parent.checkAllRows === "Intermediate") this.setRowSelection(true);
            else if (this.parent.checkAllRows === "Uncheck") this.setRowSelection(false);
        }
        if (this.parent.enableVirtualization) this.setCheckAllState();
        if (this.parent.isPersistSelection) this.refreshPersistSelection();
        this.initialRowSelection = this.isRowType() && this.parent.element.querySelectorAll(".e-selectionbackground") && this.parent.getSelectedRows().length ? true : false;
        if (this.parent.isCheckBoxSelection && !this.initialRowSelection) {
            var totalRecords = this.parent.getRowsObject();
            var indexes = [];
            for(var i = 0; i < totalRecords.length; i++)if (totalRecords[parseInt(i.toString(), 10)].isSelected) indexes.push(i);
            if (indexes.length) this.selectRows(indexes);
            this.initialRowSelection = true;
        }
    };
    Selection.prototype.updatePersistSelectedData = function(checkState) {
        if (this.parent.isPersistSelection) {
            var rows = this.parent.getRows();
            for(var i = 0; i < rows.length; i++)this.updatePersistCollection(rows[parseInt(i.toString(), 10)], checkState);
            if (this.parent.checkAllRows === "Uncheck") {
                this.setRowSelection(false);
                this.persistSelectedData = this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result ? this.persistSelectedData : [];
            } else if (this.parent.checkAllRows === "Check") {
                this.setRowSelection(true);
                this.persistSelectedData = !(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && !this.isPartialSelection ? this.parent.groupSettings.columns.length ? this.getData().records.slice() : this.getData().slice() : this.persistSelectedData;
            }
        }
    };
    Selection.prototype.checkSelectAllAction = function(checkState) {
        var cRenderer = this.getRenderer();
        var editForm = this.parent.element.querySelector(".e-gridform");
        this.checkedTarget = this.getCheckAllBox();
        if (checkState && this.getCurrentBatchRecordChanges().length) {
            this.parent.checkAllRows = "Check";
            this.updatePersistSelectedData(checkState);
            this.selectRowsByRange(cRenderer.getVirtualRowIndex(0), cRenderer.getVirtualRowIndex(this.getCurrentBatchRecordChanges().length - 1));
        } else {
            this.parent.checkAllRows = "Uncheck";
            this.updatePersistSelectedData(checkState);
            this.clearSelection();
        }
        this.chkAllCollec = [];
        if (!(0, $3EnZW.isNullOrUndefined)(editForm)) {
            var editChkBox = editForm.querySelector(".e-edit-checkselect");
            if (!(0, $3EnZW.isNullOrUndefined)(editChkBox)) (0, $748c2240e597a9b7$export$39b02a8864b327ad)(editChkBox.nextElementSibling, checkState);
        }
    };
    Selection.prototype.checkSelectAll = function(checkBox) {
        var _this = this;
        var stateStr = this.getCheckAllStatus(checkBox);
        var state = stateStr === "Check";
        this.isHeaderCheckboxClicked = true;
        if ((this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && (stateStr === "Uncheck" || this.isCheckboxReset || stateStr === "Intermediate" && this.parent.isPersistSelection)) this.rmtHdrChkbxClicked = true;
        else this.rmtHdrChkbxClicked = false;
        if (this.rmtHdrChkbxClicked && this.isCheckboxReset) this.unSelectedRowState = {};
        this.isCheckboxReset = false;
        if (stateStr === "Intermediate") {
            if (!this.chkField && !this.parent.isPersistSelection) state = this.getCurrentBatchRecordChanges().some(function(data) {
                return _this.getPkValue(_this.primaryKey, data) in _this.selectedRowState;
            });
            if ((this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && this.parent.isPersistSelection) {
                for(var i = 0; i < this.getCurrentBatchRecordChanges().length; i++)if (!(0, $3EnZW.isNullOrUndefined)(this.getPkValue(this.primaryKey, this.getCurrentBatchRecordChanges()["" + i]))) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (Object.keys(this.selectedRowState).includes(this.getPkValue(this.primaryKey, this.getCurrentBatchRecordChanges()["" + i]).toString())) state = true;
                    else {
                        state = false;
                        break;
                    }
                }
            }
        }
        if (this.parent.isPersistSelection && this.parent.allowPaging) this.totalRecordsCount = this.parent.pageSettings.totalRecordsCount;
        this.checkSelectAllAction(!state);
        this.target = null;
        if (this.getCurrentBatchRecordChanges().length > 0) {
            this.setCheckAllState();
            this.updateSelectedRowIndexes();
        }
        this.triggerChkChangeEvent(checkBox, !state);
    };
    Selection.prototype.getCheckAllStatus = function(ele) {
        var classes;
        if (!(0, $3EnZW.isNullOrUndefined)(ele)) classes = ele.nextElementSibling.classList;
        else if (!(0, $3EnZW.isNullOrUndefined)(this.getCheckAllBox())) classes = this.getCheckAllBox().nextElementSibling.classList;
        var status = "None";
        if (classes instanceof DOMTokenList) {
            if (classes.contains("e-check")) status = "Check";
            else if (classes.contains("e-uncheck")) status = "Uncheck";
            else if (classes.contains("e-stop")) status = "Intermediate";
        }
        return status;
    };
    Selection.prototype.checkSelect = function(checkBox) {
        var target = (0, $4ZDHT.closest)(this.checkedTarget, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
        var gObj = this.parent;
        this.isMultiCtrlRequest = true;
        var rIndex = 0;
        this.isHeaderCheckboxClicked = false;
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) {
            var uid = target.parentElement.getAttribute("data-uid");
            if (this.parent.enableVirtualization && this.parent.groupSettings.columns.length) rIndex = parseInt(target.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            else rIndex = gObj.getRows().map(function(m) {
                return m.getAttribute("data-uid");
            }).indexOf(uid);
        } else rIndex = parseInt(target.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
        if (this.parent.isPersistSelection && this.parent.element.getElementsByClassName($1b5568e76cdae6d4$export$792eb12cf4991bf2).length > 0 && this.parent.editSettings.newRowPosition === "Top" && !this.parent.editSettings.showAddNewRow) ++rIndex;
        this.rowCellSelectionHandler(rIndex, parseInt(target.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10));
        this.moveIntoUncheckCollection((0, $4ZDHT.closest)(target, "." + $1b5568e76cdae6d4$export$120ff0929b202a6d));
        this.setCheckAllState();
        this.isMultiCtrlRequest = false;
        this.triggerChkChangeEvent(checkBox, checkBox.nextElementSibling.classList.contains("e-check"));
    };
    Selection.prototype.moveIntoUncheckCollection = function(row) {
        if (this.parent.checkAllRows === "Check" || this.parent.checkAllRows === "Uncheck") {
            var rowObj = this.getRowObj(row);
            var pKey = rowObj && rowObj.data ? this.getPkValue(this.primaryKey, rowObj.data) : null;
            if (!pKey) return;
            if (this.chkAllCollec.indexOf(pKey) < 0) this.chkAllCollec.push(pKey);
            else this.chkAllCollec.splice(this.chkAllCollec.indexOf(pKey), 1);
        }
    };
    Selection.prototype.triggerChkChangeEvent = function(checkBox, checkState) {
        this.parent.trigger($17b89d3b1fc93cdb$export$a5f23337b8be1397, {
            checked: checkState,
            selectedRowIndexes: this.parent.getSelectedRowIndexes(),
            target: checkBox
        });
        if (!this.parent.isEdit) this.checkedTarget = null;
    };
    Selection.prototype.updateSelectedRowIndexes = function() {
        if (this.parent.isCheckBoxSelection && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && this.isPartialSelection && !(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && this.parent.selectionSettings.persistSelection) {
            if (this.parent.checkAllRows !== "Uncheck") {
                var rowObj = this.parent.getRowsObject().filter(function(e) {
                    return e.isSelectable;
                });
                for(var _i = 0, rowObj_2 = rowObj; _i < rowObj_2.length; _i++){
                    var row = rowObj_2[_i];
                    this.selectedRowIndexes.push(row.index);
                }
            }
        }
        if (this.parent.isCheckBoxSelection && this.parent.enableVirtualization && !this.isPartialSelection && (this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && !this.parent.isPersistSelection && this.parent.checkAllRows === "Check") {
            var rowObj = this.parent.getRowsObject().filter(function(e) {
                return e.isSelectable;
            });
            if (rowObj.length !== this.selectedRowIndexes.length) for(var _a = 0, rowObj_3 = rowObj; _a < rowObj_3.length; _a++){
                var row = rowObj_3[_a];
                if (this.selectedRowIndexes.indexOf(row.index) <= -1) this.selectedRowIndexes.push(row.index);
            }
        }
    };
    Selection.prototype.updateSelectedRowIndex = function(index) {
        if (this.parent.isCheckBoxSelection && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && !(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && !this.isPartialSelection) {
            if (this.parent.checkAllRows === "Check") {
                this.selectedRowIndexes = [];
                var dataLength = this.parent.groupSettings.columns.length ? this.getData()["records"].length : this.getData().length;
                for(var data = 0; data < dataLength; data++)this.selectedRowIndexes.push(data);
            } else if (this.parent.checkAllRows === "Uncheck") this.selectedRowIndexes = [];
            else {
                var row = this.parent.getRowByIndex(index);
                if (index && row && row.getAttribute("aria-selected") === "false") {
                    var selectedVal = this.selectedRowIndexes.indexOf(index);
                    this.selectedRowIndexes.splice(selectedVal, 1);
                }
            }
        }
    };
    Selection.prototype.isAllSelected = function(count) {
        if (this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) return this.getAvailableSelectedData().length === (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling ? this.parent.totalDataRecordsCount : this.totalRecordsCount);
        else if (this.isPartialSelection) {
            if (this.parent.allowPaging && this.parent.pageSettings.pageSize < this.parent.pageSettings.totalRecordsCount) {
                var data = this.parent.partialSelectedRecords;
                for(var i = 0; i < data.length; i++){
                    var pKey = this.getPkValue(this.primaryKey, data[parseInt(i.toString(), 10)]);
                    if (!this.selectedRowState["" + pKey]) return false;
                }
                return true;
            } else return this.isSelectAllRowCount(count);
        } else {
            var data = this.parent.groupSettings.columns.length ? this.getData()["records"] : this.getData();
            for(var i = 0; i < data.length; i++){
                var pKey = this.getPkValue(this.primaryKey, data[parseInt(i.toString(), 10)]);
                if (!this.selectedRowState["" + pKey]) return false;
            }
            return true;
        }
    };
    Selection.prototype.someDataSelected = function() {
        if ((this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && (this.parent.searchSettings.key.length || this.parent.filterSettings.columns.length)) {
            var filteredSearchedSelectedData = this.getAvailableSelectedData();
            for(var i = 0; i < filteredSearchedSelectedData.length; i++){
                var pKey = this.getPkValue(this.primaryKey, filteredSearchedSelectedData[parseInt(i.toString(), 10)]);
                if (this.selectedRowState["" + pKey]) return false;
            }
        }
        var data = this.isPartialSelection ? this.parent.partialSelectedRecords : this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result ? [] : this.getData();
        for(var i = 0; i < data.length; i++){
            var pKey = this.getPkValue(this.primaryKey, data[parseInt(i.toString(), 10)]);
            if (this.selectedRowState["" + pKey]) return false;
        }
        return true;
    };
    Selection.prototype.setCheckAllState = function(index, isInteraction) {
        if (this.parent.isCheckBoxSelection || this.parent.selectionSettings.checkboxMode === "ResetOnRowClick") {
            var checkToSelectAll = false;
            var isFiltered = false;
            var checkedLen = Object.keys(this.selectedRowState).length;
            if (!this.parent.isPersistSelection) {
                checkedLen = this.selectedRowIndexes.length;
                this.totalRecordsCount = this.getCurrentBatchRecordChanges().length;
            }
            if (this.parent.isPersistSelection && !((this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && this.isPartialSelection) && (this.parent.searchSettings.key.length || this.parent.filterSettings.columns.length)) {
                isFiltered = true;
                checkToSelectAll = this.isAllSelected(checkedLen);
            }
            var input = this.getCheckAllBox();
            if (input) {
                var spanEle = input.nextElementSibling;
                (0, $4ZDHT.removeClass)([
                    spanEle
                ], [
                    "e-check",
                    "e-stop",
                    "e-uncheck"
                ]);
                (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(input, false);
                input.indeterminate = false;
                var getRecord = this.parent.getDataModule().isRemote() ? [] : this.parent.groupSettings.columns.length ? this.getData()["records"] : this.getData();
                if (checkToSelectAll && isFiltered && (this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result || getRecord.length) || !isFiltered && (checkedLen === this.totalRecordsCount && this.totalRecordsCount && !this.isPartialSelection && (!(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) || this.parent.allowPaging) || !this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling && this.isPartialSelection && (this.isSelectAllRowCount(checkedLen) || this.isHdrSelectAllClicked) || (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && !this.parent.allowPaging && (!(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && getRecord.length && checkedLen === getRecord.length || (this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result) && !this.isPartialSelection && (checkedLen === this.parent.totalDataRecordsCount || (this.isSelectAllRowCount(checkedLen) || checkedLen === this.totalRecordsCount) && !this.parent.isPersistSelection) || this.isPartialSelection && (this.isHdrSelectAllClicked || this.isSelectAllRowCount(checkedLen))) || checkedLen === this.totalRecordsCount && this.totalRecordsCount && !this.isPartialSelection && !this.parent.allowPaging && !this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling)) {
                    (0, $4ZDHT.addClass)([
                        spanEle
                    ], [
                        "e-check"
                    ]);
                    (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(input, true);
                    if (isInteraction) this.getRenderer().setSelection(null, true, true);
                    this.parent.checkAllRows = "Check";
                } else if ((!this.selectedRowIndexes.length && (!this.parent.enableVirtualization || !this.persistSelectedData.length && !isFiltered || isFiltered && this.someDataSelected()) || checkedLen === 0 && this.getCurrentBatchRecordChanges().length === 0) && !this.parent.allowPaging || this.parent.allowPaging && (checkedLen === 0 || checkedLen && isFiltered && this.someDataSelected())) {
                    (0, $4ZDHT.addClass)([
                        spanEle
                    ], [
                        "e-uncheck"
                    ]);
                    if (isInteraction) this.getRenderer().setSelection(null, false, true);
                    this.parent.checkAllRows = "Uncheck";
                } else {
                    (0, $4ZDHT.addClass)([
                        spanEle
                    ], [
                        "e-stop"
                    ]);
                    this.parent.checkAllRows = "Intermediate";
                    input.indeterminate = true;
                }
                if (checkedLen === 0 && this.getCurrentBatchRecordChanges().length === 0) (0, $4ZDHT.addClass)([
                    spanEle.parentElement
                ], [
                    "e-checkbox-disabled"
                ]);
                else (0, $4ZDHT.removeClass)([
                    spanEle.parentElement
                ], [
                    "e-checkbox-disabled"
                ]);
                if (this.isPartialSelection) {
                    var rowCount = this.parent.getRowsObject().filter(function(e) {
                        return e.isSelectable;
                    }).length;
                    if (rowCount === 0 && spanEle.parentElement.querySelector(".e-frame").classList.contains("e-uncheck")) (0, $4ZDHT.addClass)([
                        spanEle.parentElement
                    ], [
                        "e-checkbox-disabled"
                    ]);
                    else (0, $4ZDHT.removeClass)([
                        spanEle.parentElement
                    ], [
                        "e-checkbox-disabled"
                    ]);
                }
                if ((this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && !this.parent.allowPaging && !(this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result)) this.updateSelectedRowIndex(index);
            }
        }
    };
    Selection.prototype.isSelectAllRowCount = function(count) {
        var rowCount = 0;
        var rowObj = this.parent.getRowsObject();
        if (this.parent.selectionSettings.persistSelection && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling)) {
            var dataLen = this.parent.getDataModule().isRemote() || !(0, $3EnZW.isNullOrUndefined)(this.parent.dataSource) && this.parent.dataSource.result ? this.parent.totalDataRecordsCount : this.getData() && this.getData().length;
            if (dataLen === rowObj.length) {
                rowCount = rowObj.filter(function(e) {
                    return e.isSelectable;
                }).length;
                return rowCount && count === rowCount;
            } else return false;
        } else if (this.parent.allowPaging && this.parent.selectionSettings.persistSelection) {
            rowCount = this.parent.partialSelectedRecords.length + this.parent.disableSelectedRecords.length;
            if (rowCount === this.totalRecordsCount) return this.parent.partialSelectedRecords.length && count === this.parent.partialSelectedRecords.length;
            else return false;
        } else {
            rowCount = rowObj.filter(function(e) {
                return e.isSelectable;
            }).length;
            return rowCount && count === rowCount;
        }
    };
    Selection.prototype.keyDownHandler = function(e) {
        // Below are keyCode for command key in MAC OS. Safari/Chrome(91-Left command, 93-Right Command), Opera(17), FireFox(224)
        if ((0, $5q7BP.Browser).info.name === "opera" && e.keyCode === 17 || (0, $5q7BP.Browser).info.name === "mozilla" && e.keyCode === 224 || ((0, $5q7BP.Browser).info.name === "safari" || (0, $5q7BP.Browser).info.name === "chrome") && (e.keyCode === 91 || e.keyCode === 93)) this.cmdKeyPressed = true;
        var targetHeadCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell");
        var targetRowCell = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
        var isCheckBox = targetHeadCell ? targetHeadCell.children[0].classList.contains("e-headerchkcelldiv") : targetRowCell ? targetRowCell.classList.contains("e-gridchkbox") : false;
        if (isCheckBox && !this.parent.allowKeyboard && e.keyCode === 32) e.preventDefault();
    };
    Selection.prototype.keyUpHandler = function(e) {
        if ((0, $5q7BP.Browser).info.name === "opera" && e.keyCode === 17 || (0, $5q7BP.Browser).info.name === "mozilla" && e.keyCode === 224 || ((0, $5q7BP.Browser).info.name === "safari" || (0, $5q7BP.Browser).info.name === "chrome") && (e.keyCode === 91 || e.keyCode === 93)) this.cmdKeyPressed = false;
    };
    Selection.prototype.clickHandler = function(e) {
        var target = e.target;
        this.actualTarget = target;
        if (!this.isAutoFillSel && !e.ctrlKey && !e.shiftKey) this.startAFCell = this.endAFCell = null;
        if (this.selectionSettings.persistSelection) this.deSelectedData = (0, $748c2240e597a9b7$export$5788824bee325a29)(this.persistSelectedData);
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$120ff0929b202a6d) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headerchkcelldiv") || this.selectionSettings.allowColumnSelection && target.classList.contains("e-headercell")) this.isInteracted = true;
        this.cmdKeyPressed = e.metaKey;
        this.isMultiCtrlRequest = e.ctrlKey || this.enableSelectMultiTouch || this.isMacOS && this.cmdKeyPressed;
        if (!this.parent.allowKeyboard) {
            this.isMultiShiftRequest = false;
            this.isMultiCtrlRequest = false;
        } else this.isMultiShiftRequest = e.shiftKey;
        this.isMultiCtrlRequestCell = this.isMultiCtrlRequest;
        this.popUpClickHandler(e);
        var chkSelect = false;
        this.preventFocus = true;
        var checkBox;
        var checkWrap = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-checkbox-wrapper");
        this.checkSelectAllClicked = checkWrap && checkWrap.getElementsByClassName("e-checkselectall") || this.selectionSettings.persistSelection && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$120ff0929b202a6d) ? true : false;
        if (this.selectionSettings.persistSelection && this.isPartialSelection && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headerchkcelldiv") && !target.querySelector(".e-checkbox-disabled")) this.isHdrSelectAllClicked = true;
        if (checkWrap && checkWrap.querySelectorAll(".e-checkselect,.e-checkselectall").length > 0) {
            checkBox = checkWrap.querySelector('input[type="checkbox"]');
            chkSelect = true;
        }
        this.drawBorders();
        this.updateAutoFillPosition();
        target = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
        if (this.parent.isReact && target && !target.parentElement && target.classList.contains("e-rowcell")) target = this.parent.getCellFromIndex(parseInt(target.getAttribute("index"), 10), parseInt(target.getAttribute("data-colindex"), 10));
        if (this.isRowDragSelected && (0, $3EnZW.isNullOrUndefined)(target) && this.parent.allowRowDragAndDrop && this.selectionSettings.persistSelection && this.checkSelectAllClicked) this.isRowDragSelected = false;
        if ((target && target.parentElement.classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d) && !this.parent.selectionSettings.checkboxOnly || chkSelect) && !this.isRowDragSelected) {
            if (this.parent.isCheckBoxSelection) this.isMultiCtrlRequest = true;
            this.target = target;
            if (!(0, $3EnZW.isNullOrUndefined)(checkBox)) {
                this.checkedTarget = checkBox;
                if (checkBox.classList.contains("e-checkselectall")) this.checkSelectAll(checkBox);
                else this.checkSelect(checkBox);
            } else {
                var rIndex = 0;
                rIndex = parseInt(target.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                if (this.parent.isPersistSelection && !this.parent.editSettings.showAddNewRow && this.parent.element.getElementsByClassName($1b5568e76cdae6d4$export$792eb12cf4991bf2).length > 0) ++rIndex;
                if (!this.mUPTarget || !this.mUPTarget.isEqualNode(target)) this.rowCellSelectionHandler(rIndex, parseInt(target.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10));
                if (this.parent.isCheckBoxSelection) {
                    this.moveIntoUncheckCollection((0, $4ZDHT.closest)(target, "." + $1b5568e76cdae6d4$export$120ff0929b202a6d));
                    this.setCheckAllState();
                }
            }
            if (!this.parent.isCheckBoxSelection && (0, $5q7BP.Browser).isDevice && !this.isSingleSel()) this.showPopup(e);
        } else if (e.target.classList.contains("e-headercell") && !e.target.classList.contains("e-stackedheadercell")) {
            var uid = e.target.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");
            this.headerSelectionHandler(this.parent.getColumnIndexByUid(uid));
        }
        this.isMultiCtrlRequest = false;
        this.isMultiCtrlRequestCell = this.isMultiCtrlRequest;
        this.isMultiShiftRequest = false;
        if ((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, ".e-unboundcell"))) this.preventFocus = false;
    };
    Selection.prototype.popUpClickHandler = function(e) {
        var target = e.target;
        if ((0, $4ZDHT.closest)(target, ".e-headercell") || e.target.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) || (0, $4ZDHT.closest)(target, ".e-gridpopup")) {
            if (target.classList.contains("e-rowselect")) {
                if (!target.classList.contains("e-spanclicked")) {
                    target.classList.add("e-spanclicked");
                    this.enableSelectMultiTouch = true;
                } else {
                    target.classList.remove("e-spanclicked");
                    this.enableSelectMultiTouch = false;
                    this.parent.element.querySelector(".e-gridpopup").style.display = "none";
                }
            }
        } else this.parent.element.querySelector(".e-gridpopup").style.display = "none";
    };
    Selection.prototype.showPopup = function(e) {
        if (!this.selectionSettings.enableSimpleMultiRowSelection) (0, $748c2240e597a9b7$export$7ad8741a0e3edfbb)(this.parent.element.querySelector(".e-gridpopup"), e, "e-rowselect e-icons e-icon-rowselect" + (!this.isSingleSel() && (this.selectedRecords.length > 1 || this.selectedRowCellIndexes.length > 1) ? " e-spanclicked" : ""));
    };
    Selection.prototype.rowCellSelectionHandler = function(rowIndex, cellIndex) {
        if (!this.isMultiCtrlRequest && !this.isMultiShiftRequest || this.isSingleSel()) {
            if (!this.isDragged) this.selectRow(rowIndex, this.selectionSettings.enableToggle);
            this.selectCell({
                rowIndex: rowIndex,
                cellIndex: cellIndex
            }, this.selectionSettings.enableToggle);
            if (this.selectedRowCellIndexes.length) this.updateAutoFillPosition();
            this.drawBorders();
        } else if (this.isMultiShiftRequest) {
            if (this.parent.isCheckBoxSelection || !this.parent.isCheckBoxSelection && !(0, $4ZDHT.closest)(this.target, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca).classList.contains($1b5568e76cdae6d4$export$71f350cebd38389f)) this.selectRowsByRange((0, $3EnZW.isUndefined)(this.prevRowIndex) ? rowIndex : this.prevRowIndex, rowIndex);
            else this.addRowsToSelection([
                rowIndex
            ]);
            this.selectCellsByRange((0, $3EnZW.isUndefined)(this.prevCIdxs) ? {
                rowIndex: rowIndex,
                cellIndex: cellIndex
            } : this.prevCIdxs, {
                rowIndex: rowIndex,
                cellIndex: cellIndex
            });
            this.updateAutoFillPosition();
            this.drawBorders();
        } else {
            this.addRowsToSelection([
                rowIndex
            ]);
            if (this.selectionSettings.mode === "Both") {
                var checkboxColumn = this.parent.getColumns().find(function(col) {
                    return col.type === "checkbox";
                });
                var checkboxColumnIndexCheck = checkboxColumn && checkboxColumn.index !== cellIndex;
                if (checkboxColumnIndexCheck && !this.isMultiCtrlRequestCell) this.selectCell({
                    rowIndex: rowIndex,
                    cellIndex: cellIndex
                }, this.selectionSettings.enableToggle);
                else if (!checkboxColumn || checkboxColumnIndexCheck) this.addCellsToSelection([
                    {
                        rowIndex: rowIndex,
                        cellIndex: cellIndex
                    }
                ]);
            } else this.addCellsToSelection([
                {
                    rowIndex: rowIndex,
                    cellIndex: cellIndex
                }
            ]);
            this.showHideBorders("none");
        }
        this.isDragged = false;
    };
    Selection.prototype.onCellFocused = function(e) {
        if (this.parent.frozenRows && e.container.isHeader && e.byKey) {
            if (e.keyArgs.action === "upArrow") {
                if (this.parent.allowFiltering) e.isJump = e.element.tagName === "INPUT" ? true : false;
                else e.isJump = e.element.tagName === "TH" ? true : false;
            } else {
                if (e.keyArgs.action === "downArrow") {
                    var rIdx = Number(e.element.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82));
                    e.isJump = rIdx === 0 ? true : false;
                } else if (e.keyArgs.action === "ctrlHome") e.isJump = true;
            }
        }
        var clear = (e.container.isHeader && e.isJump || e.container.isContent && !e.container.isSelectable) && !(e.byKey && e.keyArgs.action === "space") && !(e.element.classList.contains("e-detailrowexpand") || e.element.classList.contains("e-detailrowcollapse"));
        var headerAction = e.container.isHeader && e.element.tagName !== "TD" && !(0, $4ZDHT.closest)(e.element, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca) && !(e.byKey && e.keyArgs.action === "space");
        if (!e.byKey || clear) {
            if (clear && !this.parent.isCheckBoxSelection) this.clearSelection();
            return;
        }
        var _a = e.container.isContent ? e.container.indexes : e.indexes, rowIndex = _a[0], cellIndex = _a[1];
        var prev = this.focus.getPrevIndexes();
        if (e.element.parentElement.querySelector(".e-rowcelldrag") || e.element.parentElement.querySelector(".e-dtdiagonalright") || e.element.parentElement.querySelector(".e-dtdiagonaldown")) prev.cellIndex = prev.cellIndex - 1;
        if (this.parent.frozenRows) {
            if (e.container.isHeader && (e.element.tagName === "TD" || (0, $4ZDHT.closest)(e.element, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca))) {
                var hdrLength = this.parent.getHeaderTable().querySelector("thead").childElementCount;
                if (this.parent.editSettings.showAddNewRow && this.parent.editSettings.newRowPosition === "Top" && e.keyArgs.action === "upArrow") hdrLength++;
                rowIndex -= hdrLength;
                prev.rowIndex = !(0, $3EnZW.isNullOrUndefined)(prev.rowIndex) ? prev.rowIndex - hdrLength : null;
            } else {
                rowIndex += this.parent.frozenRows;
                prev.rowIndex = prev.rowIndex === 0 || !(0, $3EnZW.isNullOrUndefined)(prev.rowIndex) ? prev.rowIndex + this.parent.frozenRows : null;
            }
        }
        if (this.parent.enableInfiniteScrolling && this.parent.infiniteScrollSettings.enableCache) rowIndex = parseInt(e.element.parentElement.getAttribute("data-rowindex"), 10);
        if ((headerAction || [
            "ctrlPlusA",
            "escape"
        ].indexOf(e.keyArgs.action) === -1 && e.keyArgs.action !== "space" && rowIndex === prev.rowIndex && cellIndex === prev.cellIndex) && !this.selectionSettings.allowColumnSelection) return;
        if (this.parent.enableVirtualization && this.parent.allowGrouping && this.parent.groupSettings.columns.length) rowIndex = parseInt(e.element.parentElement.getAttribute("data-rowindex"), 10);
        if (this.parent.editSettings.showAddNewRow && this.parent.editSettings.newRowPosition === "Top" && !this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling && e.keyArgs.action === "downArrow") rowIndex--;
        this.preventFocus = true;
        var columnIndex = this.getKeyColIndex(e);
        if (this.needColumnSelection) cellIndex = columnIndex;
        if (this.parent.element.classList.contains("e-gridcell-read") && (e.keyArgs.action === "tab" || e.keyArgs.action === "shiftTab" || e.keyArgs.action === "rightArrow" || e.keyArgs.action === "leftArrow")) {
            var targetLabel = this.target.getAttribute("aria-label");
            targetLabel = this.target.innerHTML + " column header " + this.parent.getColumnByIndex(cellIndex).field;
            this.target.setAttribute("aria-label", targetLabel);
        }
        switch(e.keyArgs.action){
            case "downArrow":
            case "upArrow":
            case "enter":
            case "shiftEnter":
                this.target = e.element;
                this.isKeyAction = true;
                this.applyDownUpKey(rowIndex, cellIndex);
                break;
            case "rightArrow":
            case "leftArrow":
                this.applyRightLeftKey(rowIndex, cellIndex);
                break;
            case "shiftDown":
            case "shiftUp":
                this.shiftDownKey(rowIndex, cellIndex);
                break;
            case "shiftLeft":
            case "shiftRight":
                this.applyShiftLeftRightKey(rowIndex, cellIndex);
                break;
            case "home":
            case "end":
                cellIndex = e.keyArgs.action === "end" ? this.getLastColIndex(rowIndex) : 0;
                this.applyHomeEndKey(rowIndex, cellIndex);
                break;
            case "ctrlHome":
            case "ctrlEnd":
                this.applyCtrlHomeEndKey(rowIndex, cellIndex);
                break;
            case "escape":
                this.clearSelection();
                if (this.parent.clipboardModule) window.navigator["clipboard"].writeText("");
                break;
            case "ctrlPlusA":
                this.ctrlPlusA();
                break;
            case "space":
                this.applySpaceSelection(e.element);
                break;
            case "tab":
                if (this.parent.editSettings.allowNextRowEdit) this.selectRow(rowIndex);
                break;
        }
        this.needColumnSelection = false;
        this.preventFocus = false;
        this.positionBorders();
        if (this.parent.isFrozenGrid()) {
            this.showHideBorders("none", true);
            this.refreshFrozenBorders();
        }
        this.updateAutoFillPosition();
    };
    Selection.prototype.getKeyColIndex = function(e) {
        var uid;
        var index = null;
        var stackedHeader = e.element.querySelector(".e-stackedheadercelldiv");
        if (this.selectionSettings.allowColumnSelection && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.element, "e-columnheader")) {
            this.needColumnSelection = e.container.isHeader ? true : false;
            if (stackedHeader) {
                if (e.keyArgs.action === "rightArrow" || e.keyArgs.action === "leftArrow") return index;
                uid = stackedHeader.getAttribute("e-mappinguid");
                var innerColumn = this.getstackedColumns(this.parent.getColumnByUid(uid).columns);
                var lastIndex = this.parent.getColumnIndexByUid(innerColumn[innerColumn.length - 1].uid);
                var firstIndex = this.parent.getColumnIndexByUid(innerColumn[0].uid);
                index = this.prevColIndex >= lastIndex ? firstIndex : lastIndex;
            } else index = this.parent.getColumnIndexByUid(e.element.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));
        }
        return index;
    };
    /**
     * Apply ctrl + A key selection
     *
     * @returns {void}
     * @hidden
     */ Selection.prototype.ctrlPlusA = function() {
        if (this.isRowType() && !this.isSingleSel()) {
            var rowObj = this.parent.getRowsObject();
            this.selectRowsByRange(rowObj[0].index, rowObj[rowObj.length - 1].index);
        }
        if (this.isCellType() && !this.isSingleSel()) this.selectCellsByRange({
            rowIndex: 0,
            cellIndex: 0
        }, {
            rowIndex: this.parent.getRows().length - 1,
            cellIndex: this.parent.getColumns().length - 1
        });
    };
    Selection.prototype.applySpaceSelection = function(target) {
        if (target.classList.contains("e-checkselectall")) {
            this.checkedTarget = target;
            this.checkSelectAll(this.checkedTarget);
        } else if (target.classList.contains("e-checkselect")) {
            this.checkedTarget = target;
            this.checkSelect(this.checkedTarget);
        }
    };
    Selection.prototype.applyDownUpKey = function(rowIndex, cellIndex) {
        var gObj = this.parent;
        if (this.parent.isCheckBoxSelection && this.parent.checkAllRows === "Check" && !this.selectionSettings.persistSelection && !this.selectionSettings.checkboxOnly) {
            this.checkSelectAllAction(false);
            this.checkedTarget = null;
        }
        if (this.isRowType() && !this.selectionSettings.checkboxOnly) {
            if (this.parent.frozenRows) {
                this.selectRow(rowIndex, true);
                this.applyUpDown(gObj.selectedRowIndex);
            } else {
                this.selectRow(rowIndex, true);
                this.applyUpDown(gObj.selectedRowIndex);
            }
        }
        if (this.isCellType()) this.selectCell({
            rowIndex: rowIndex,
            cellIndex: cellIndex
        }, true);
        if (this.selectionSettings.allowColumnSelection && this.needColumnSelection) this.selectColumn(cellIndex);
    };
    Selection.prototype.applyUpDown = function(rowIndex) {
        if (rowIndex < 0) return;
        if (!this.target) this.target = this.parent.getRows()[0].children[this.parent.groupSettings.columns.length || 0];
        var cIndex = parseInt(this.target.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
        var row = this.contentRenderer.getRowByIndex(rowIndex);
        if (row) this.target = row.getElementsByClassName($1b5568e76cdae6d4$export$deb49d6cac2bdaca)[parseInt(cIndex.toString(), 10)];
        this.addAttribute(this.target);
        if (this.parent.element.classList.contains("e-gridcell-read")) {
            var targetLabel = this.target.getAttribute("aria-label");
            targetLabel = this.target.innerHTML;
            this.target.setAttribute("aria-label", targetLabel);
        }
    };
    Selection.prototype.applyRightLeftKey = function(rowIndex, cellIndex) {
        if (this.selectionSettings.allowColumnSelection && this.needColumnSelection) this.selectColumn(cellIndex);
        else if (this.isCellType()) {
            this.selectCell({
                rowIndex: rowIndex,
                cellIndex: cellIndex
            }, true);
            this.addAttribute(this.target);
        }
    };
    Selection.prototype.applyHomeEndKey = function(rowIndex, cellIndex) {
        if (this.isCellType()) this.selectCell({
            rowIndex: rowIndex,
            cellIndex: cellIndex
        }, true);
        else this.addAttribute(this.parent.getCellFromIndex(rowIndex, cellIndex));
    };
    /**
     * Apply shift+down key selection
     *
     * @param {number} rowIndex - specfies the rowIndex
     * @param {number} cellIndex - specifies the CellIndex
     * @returns {void}
     * @hidden
     */ Selection.prototype.shiftDownKey = function(rowIndex, cellIndex) {
        this.isMultiShiftRequest = true;
        if (this.isRowType() && !this.isSingleSel()) {
            if (!(0, $3EnZW.isUndefined)(this.prevRowIndex)) {
                this.selectRowsByRange(this.prevRowIndex, rowIndex);
                this.applyUpDown(rowIndex);
            } else if (this.isPartialSelection) this.selectRow(rowIndex, true);
            else this.selectRow(0, true);
        }
        if (this.isCellType() && !this.isSingleSel()) this.selectCellsByRange(this.prevCIdxs || {
            rowIndex: 0,
            cellIndex: 0
        }, {
            rowIndex: rowIndex,
            cellIndex: cellIndex
        });
        this.isMultiShiftRequest = false;
    };
    Selection.prototype.applyShiftLeftRightKey = function(rowIndex, cellIndex) {
        this.isMultiShiftRequest = true;
        if (this.selectionSettings.allowColumnSelection && this.needColumnSelection) this.selectColumnsByRange(this.prevColIndex, cellIndex);
        else this.selectCellsByRange(this.prevCIdxs, {
            rowIndex: rowIndex,
            cellIndex: cellIndex
        });
        this.isMultiShiftRequest = false;
    };
    Selection.prototype.getstackedColumns = function(column) {
        var innerColumnIndexes = [];
        for(var i = 0, len = column.length; i < len; i++)if (column[parseInt(i.toString(), 10)].columns) this.getstackedColumns(column[parseInt(i.toString(), 10)].columns);
        else innerColumnIndexes.push(column[parseInt(i.toString(), 10)]);
        return innerColumnIndexes;
    };
    Selection.prototype.applyCtrlHomeEndKey = function(rowIndex, cellIndex) {
        if (this.isRowType()) {
            this.selectRow(rowIndex, true);
            this.addAttribute(this.parent.getCellFromIndex(rowIndex, cellIndex));
        }
        if (this.isCellType()) this.selectCell({
            rowIndex: rowIndex,
            cellIndex: cellIndex
        }, true);
    };
    Selection.prototype.addRemoveClassesForRow = function(row, isAdd, clearAll) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        if (row) {
            var cells = [].slice.call(row.getElementsByClassName($1b5568e76cdae6d4$export$deb49d6cac2bdaca));
            var detailIndentCell = row.querySelector(".e-detailrowcollapse") || row.querySelector(".e-detailrowexpand");
            var dragdropIndentCell = row.querySelector(".e-rowdragdrop");
            if (detailIndentCell) cells.push(detailIndentCell);
            if (dragdropIndentCell) cells.push(dragdropIndentCell);
            (0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf).apply(void 0, [
                cells,
                isAdd
            ].concat(args));
        }
        this.getRenderer().setSelection(row ? row.getAttribute("data-uid") : null, isAdd, clearAll);
    };
    Selection.prototype.isRowType = function() {
        return this.selectionSettings.mode === "Row" || this.selectionSettings.mode === "Both";
    };
    Selection.prototype.isCellType = function() {
        return this.selectionSettings.mode === "Cell" || this.selectionSettings.mode === "Both";
    };
    Selection.prototype.isSingleSel = function() {
        return this.selectionSettings.type === "Single";
    };
    Selection.prototype.getRenderer = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.contentRenderer)) this.contentRenderer = this.factory.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content);
        return this.contentRenderer;
    };
    /**
     * Gets the collection of selected records.
     *
     * @returns {Object[]} returns the Object
     */ Selection.prototype.getSelectedRecords = function() {
        var selectedData = [];
        if (!this.selectionSettings.persistSelection && this.selectedRecords.length) selectedData = this.parent.getRowsObject().filter(function(row) {
            return row.isSelected;
        }).map(function(m) {
            return m.data;
        });
        else selectedData = this.persistSelectedData;
        return selectedData;
    };
    /**
     * Select the column by passing start column index
     *
     * @param {number} index - specifies the index
     * @returns {void}
     */ Selection.prototype.selectColumn = function(index) {
        var gObj = this.parent;
        if ((0, $3EnZW.isNullOrUndefined)(gObj.getColumns()[parseInt(index.toString(), 10)])) return;
        var column = gObj.getColumnByIndex(index);
        var selectedCol = gObj.getColumnHeaderByUid(column.uid);
        var isColSelected = selectedCol.classList.contains("e-columnselection");
        if (!gObj.selectionSettings.allowColumnSelection) return;
        var isMultiColumns = this.selectedColumnsIndexes.length > 1 && this.selectedColumnsIndexes.indexOf(index) > -1;
        this.clearColDependency();
        if (!this.selectionSettings.enableToggle || isMultiColumns || !isColSelected) {
            var args = {
                columnIndex: index,
                headerCell: selectedCol,
                column: column,
                cancel: false,
                target: this.actualTarget,
                isInteracted: this.isInteracted,
                previousColumnIndex: this.prevColIndex,
                isCtrlPressed: this.isMultiCtrlRequest,
                isShiftPressed: this.isMultiShiftRequest
            };
            this.onActionBegin(args, $17b89d3b1fc93cdb$export$81e76a668f94b6d8);
            if (args.cancel) {
                this.disableInteracted();
                return;
            }
            if (isMultiColumns || !(isColSelected && gObj.selectionSettings.enableToggle && index === this.prevColIndex)) this.updateColSelection(selectedCol, index);
            var selectedArgs = {
                columnIndex: index,
                headerCell: selectedCol,
                column: column,
                target: this.actualTarget,
                isInteracted: this.isInteracted,
                previousColumnIndex: this.prevColIndex
            };
            this.onActionComplete(selectedArgs, $17b89d3b1fc93cdb$export$b4e257dd92fec7b1);
        }
        this.updateColProps(index);
    };
    /**
     * Select the columns by passing start and end column index
     *
     * @param  {number} startIndex - specifies the start index
     * @param  {number} endIndex - specifies the end index
     * @returns {void}
     */ Selection.prototype.selectColumnsByRange = function(startIndex, endIndex) {
        var gObj = this.parent;
        if ((0, $3EnZW.isNullOrUndefined)(gObj.getColumns()[parseInt(startIndex.toString(), 10)])) return;
        var indexes = [];
        if (gObj.selectionSettings.type === "Single" || (0, $3EnZW.isNullOrUndefined)(endIndex)) indexes[0] = startIndex;
        else {
            var min = startIndex < endIndex;
            for(var i = startIndex; min ? i <= endIndex : i >= endIndex; min ? i++ : i--)indexes.push(i);
        }
        this.selectColumns(indexes);
    };
    /**
     * Select the columns by passing column indexes
     *
     * @param  {number[]} columnIndexes - specifies the columnIndexes
     * @returns {void}
     */ Selection.prototype.selectColumns = function(columnIndexes) {
        var gObj = this.parent;
        var selectedCol = this.getselectedCols();
        if (gObj.selectionSettings.type === "Single") columnIndexes = [
            columnIndexes[0]
        ];
        if (!gObj.selectionSettings.allowColumnSelection) return;
        this.clearColDependency();
        var selectingArgs = {
            columnIndex: columnIndexes[0],
            headerCell: selectedCol,
            columnIndexes: columnIndexes,
            column: gObj.getColumnByIndex(columnIndexes[0]),
            cancel: false,
            target: this.actualTarget,
            isInteracted: this.isInteracted,
            previousColumnIndex: this.prevColIndex,
            isCtrlPressed: this.isMultiCtrlRequest,
            isShiftPressed: this.isMultiShiftRequest
        };
        this.onActionBegin(selectingArgs, $17b89d3b1fc93cdb$export$81e76a668f94b6d8);
        if (selectingArgs.cancel) {
            this.disableInteracted();
            return;
        }
        for(var i = 0, len = columnIndexes.length; i < len; i++)this.updateColSelection(gObj.getColumnHeaderByUid(gObj.getColumnByIndex(columnIndexes[parseInt(i.toString(), 10)]).uid), columnIndexes[parseInt(i.toString(), 10)]);
        selectedCol = this.getselectedCols();
        var selectedArgs = {
            columnIndex: columnIndexes[0],
            headerCell: selectedCol,
            columnIndexes: columnIndexes,
            column: gObj.getColumnByIndex(columnIndexes[0]),
            target: this.actualTarget,
            isInteracted: this.isInteracted,
            previousColumnIndex: this.prevColIndex
        };
        this.onActionComplete(selectedArgs, $17b89d3b1fc93cdb$export$b4e257dd92fec7b1);
        this.updateColProps(columnIndexes[0]);
    };
    /**
     * Select the column with existing column by passing column index
     *
     * @param  {number} startIndex - specifies the start index
     * @returns {void}
     */ Selection.prototype.selectColumnWithExisting = function(startIndex) {
        var gObj = this.parent;
        if ((0, $3EnZW.isNullOrUndefined)(gObj.getColumns()[parseInt(startIndex.toString(), 10)])) return;
        var newCol = gObj.getColumnHeaderByUid(gObj.getColumnByIndex(startIndex).uid);
        var selectedCol = this.getselectedCols();
        if (gObj.selectionSettings.type === "Single") this.clearColDependency();
        if (!gObj.selectionSettings.allowColumnSelection) return;
        if (this.selectedColumnsIndexes.indexOf(startIndex) > -1) this.clearColumnSelection(startIndex);
        else {
            var selectingArgs = {
                columnIndex: startIndex,
                headerCell: selectedCol,
                columnIndexes: this.selectedColumnsIndexes,
                column: gObj.getColumnByIndex(startIndex),
                cancel: false,
                target: this.actualTarget,
                isInteracted: this.isInteracted,
                previousColumnIndex: this.prevColIndex,
                isCtrlPressed: this.isMultiCtrlRequest,
                isShiftPressed: this.isMultiShiftRequest
            };
            this.onActionBegin(selectingArgs, $17b89d3b1fc93cdb$export$81e76a668f94b6d8);
            if (selectingArgs.cancel) {
                this.disableInteracted();
                return;
            }
            this.updateColSelection(newCol, startIndex);
            selectedCol = this.getselectedCols();
            var selectedArgs = {
                columnIndex: startIndex,
                headerCell: selectedCol,
                column: gObj.getColumnByIndex(startIndex),
                columnIndexes: this.selectedColumnsIndexes,
                target: this.actualTarget,
                isInteracted: this.isInteracted,
                previousColumnIndex: this.prevColIndex
            };
            this.onActionComplete(selectedArgs, $17b89d3b1fc93cdb$export$b4e257dd92fec7b1);
        }
        this.updateColProps(startIndex);
    };
    /**
     * Clear the column selection
     *
     * @param {number} clearIndex - specifies the clearIndex
     * @returns {void}
     */ Selection.prototype.clearColumnSelection = function(clearIndex) {
        if (this.isColumnSelected) {
            var gObj = this.parent;
            if (!(0, $3EnZW.isNullOrUndefined)(clearIndex) && this.selectedColumnsIndexes.indexOf(clearIndex) === -1) return;
            var index = !(0, $3EnZW.isNullOrUndefined)(clearIndex) ? clearIndex : this.selectedColumnsIndexes[this.selectedColumnsIndexes.length - 1];
            var column = gObj.getColumnByIndex(index);
            var selectedCol = gObj.getColumnHeaderByUid(column.uid);
            var deselectedArgs = {
                columnIndex: index,
                headerCell: selectedCol,
                columnIndexes: this.selectedColumnsIndexes,
                column: column,
                cancel: false,
                target: this.actualTarget,
                isInteracted: this.isInteracted
            };
            var isCanceled = this.columnDeselect(deselectedArgs, $17b89d3b1fc93cdb$export$9491b2dd79aacca2);
            if (isCanceled) {
                this.disableInteracted();
                return;
            }
            var selectedHeader = !(0, $3EnZW.isNullOrUndefined)(clearIndex) ? [
                selectedCol
            ] : [].slice.call(gObj.getHeaderContent().getElementsByClassName("e-columnselection"));
            var selectedCells = this.getSelectedColumnCells(clearIndex);
            for(var i = 0, len = selectedHeader.length; i < len; i++)(0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
                selectedHeader[parseInt(i.toString(), 10)]
            ], false, "e-columnselection");
            for(var i = 0, len = selectedCells.length; i < len; i++)(0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
                selectedCells[parseInt(i.toString(), 10)]
            ], false, "e-columnselection");
            if (!(0, $3EnZW.isNullOrUndefined)(clearIndex)) {
                this.selectedColumnsIndexes.splice(this.selectedColumnsIndexes.indexOf(clearIndex), 1);
                this.parent.getColumns()[parseInt(clearIndex.toString(), 10)].isSelected = false;
            } else {
                this.columnDeselect(deselectedArgs, $17b89d3b1fc93cdb$export$10e5a36803dd4c24);
                this.selectedColumnsIndexes = [];
                this.isColumnSelected = false;
                this.parent.getColumns().filter(function(col) {
                    return col.isSelected = false;
                });
            }
        }
    };
    Selection.prototype.getselectedCols = function() {
        var gObj = this.parent;
        var selectedCol;
        if (this.selectedColumnsIndexes.length > 1) {
            selectedCol = [];
            for(var i = 0; i < this.selectedColumnsIndexes.length; i++)selectedCol.push(gObj.getColumnHeaderByUid(gObj.getColumnByIndex(this.selectedColumnsIndexes[parseInt(i.toString(), 10)]).uid));
        } else selectedCol = gObj.getColumnHeaderByUid(gObj.getColumnByIndex(this.selectedColumnsIndexes[0]).uid);
        return selectedCol;
    };
    Selection.prototype.getSelectedColumnCells = function(clearIndex) {
        var gObj = this.parent;
        var isRowTemplate = !(0, $3EnZW.isNullOrUndefined)(this.parent.rowTemplate);
        var rows = isRowTemplate ? gObj.getRows() : gObj.getDataRows();
        var seletedcells = [];
        var selectionString = !(0, $3EnZW.isNullOrUndefined)(clearIndex) ? '[data-colindex="' + clearIndex + '"]' : ".e-columnselection";
        for(var i = 0, len = rows.length; i < len; i++)seletedcells = seletedcells.concat([].slice.call(rows[parseInt(i.toString(), 10)].querySelectorAll(selectionString)));
        return seletedcells;
    };
    Selection.prototype.columnDeselect = function(args, event) {
        if (event === "columnDeselected") delete args.cancel;
        this.onActionComplete(args, event);
        return args.cancel;
    };
    Selection.prototype.updateColProps = function(startIndex) {
        this.prevColIndex = startIndex;
        this.isColumnSelected = this.selectedColumnsIndexes.length && true;
    };
    Selection.prototype.clearColDependency = function() {
        this.clearColumnSelection();
        this.selectedColumnsIndexes = [];
    };
    Selection.prototype.updateColSelection = function(selectedCol, startIndex) {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.getColumns()[parseInt(startIndex.toString(), 10)])) return;
        var isRowTemplate = !(0, $3EnZW.isNullOrUndefined)(this.parent.rowTemplate);
        var rows = isRowTemplate ? this.parent.getRows() : this.parent.getDataRows();
        this.selectedColumnsIndexes.push(startIndex);
        this.parent.getColumns()[parseInt(startIndex.toString(), 10)].isSelected = true;
        startIndex = startIndex + this.parent.getIndentCount();
        (0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
            selectedCol
        ], true, "e-columnselection");
        for(var j = 0, len = rows.length; j < len; j++)if (rows[parseInt(j.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d)) {
            if ((rows[parseInt(j.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$76a2698a7195dbfe) || rows[parseInt(j.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$792eb12cf4991bf2)) && this.parent.editSettings.mode === "Normal" && !(0, $3EnZW.isNullOrUndefined)(rows[parseInt(j.toString(), 10)].querySelector("tr").childNodes[parseInt(startIndex.toString(), 10)])) (0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
                rows[parseInt(j.toString(), 10)].querySelector("tr").childNodes[parseInt(startIndex.toString(), 10)]
            ], true, "e-columnselection");
            else {
                if (this.parent.isSpan && this.parent.isFrozenGrid()) {
                    var cells = rows[parseInt(j.toString(), 10)].querySelectorAll(".e-rowcell");
                    for(var i = 0; i < cells.length; i++)if (cells[parseInt(i.toString(), 10)].getAttribute("aria-colindex") === selectedCol.getAttribute("aria-colindex")) (0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
                        cells[parseInt(i.toString(), 10)]
                    ], true, "e-columnselection");
                } else if (!(0, $3EnZW.isNullOrUndefined)(rows[parseInt(j.toString(), 10)].childNodes[parseInt(startIndex.toString(), 10)])) (0, $748c2240e597a9b7$export$cc04b0fcbbab6cbf)([
                    rows[parseInt(j.toString(), 10)].childNodes[parseInt(startIndex.toString(), 10)]
                ], true, "e-columnselection");
            }
        }
    };
    Selection.prototype.headerSelectionHandler = function(colIndex) {
        if (!this.isMultiCtrlRequest && !this.isMultiShiftRequest || this.isSingleSel()) this.selectColumn(colIndex);
        else if (this.isMultiShiftRequest) this.selectColumnsByRange((0, $3EnZW.isUndefined)(this.prevColIndex) ? colIndex : this.prevColIndex, colIndex);
        else this.selectColumnWithExisting(colIndex);
    };
    // eslint-disable-next-line camelcase
    Selection.prototype.addEventListener_checkbox = function() {
        var _this = this;
        this.parent.on($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.dataReady, this);
        this.onDataBoundFunction = this.onDataBound.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.onDataBoundFunction);
        this.parent.on($17b89d3b1fc93cdb$export$50807bf602c28512, this.onDataBoundFunction);
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.checkBoxSelectionChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$725c4d1f8c0e1c70, this.initPerisistSelection, this);
        this.parent.on($17b89d3b1fc93cdb$export$63287e93462800a4, this.setCheckAllForEmptyGrid, this);
        this.actionCompleteFunc = this.actionCompleteHandler.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunc);
        this.parent.on($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler, this);
        this.resizeEndFn = function() {
            _this.updateAutoFillPosition();
            _this.drawBorders();
        };
        this.resizeEndFn.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$8c4d3b559babc6db, this.resizeEndFn);
    };
    // eslint-disable-next-line camelcase
    Selection.prototype.removeEventListener_checkbox = function() {
        this.parent.off($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.dataReady);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.onDataBoundFunction);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunc);
        this.parent.off($17b89d3b1fc93cdb$export$50807bf602c28512, this.onDataBoundFunction);
        this.parent.off($17b89d3b1fc93cdb$export$63287e93462800a4, this.setCheckAllForEmptyGrid);
        this.parent.off($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$8c4d3b559babc6db, this.resizeEndFn);
        this.parent.off($17b89d3b1fc93cdb$export$725c4d1f8c0e1c70, this.initPerisistSelection);
    };
    Selection.prototype.setCheckAllForEmptyGrid = function() {
        var checkAllBox = this.getCheckAllBox();
        if (checkAllBox) {
            this.parent.isCheckBoxSelection = true;
            var spanEle = checkAllBox.nextElementSibling;
            (0, $4ZDHT.removeClass)([
                spanEle
            ], [
                "e-check",
                "e-stop",
                "e-uncheck"
            ]);
            (0, $4ZDHT.addClass)([
                spanEle.parentElement
            ], [
                "e-checkbox-disabled"
            ]);
        }
    };
    Selection.prototype.dataReady = function(e) {
        this.isHeaderCheckboxClicked = false;
        var isInfinitecroll = this.parent.enableInfiniteScrolling && e.requestType === "infiniteScroll";
        if (e.requestType !== "virtualscroll" && !this.parent.isPersistSelection && !isInfinitecroll) {
            this.disableUI = !this.parent.enableImmutableMode && !(e.requestType === "save" && e["action"] === "add");
            this.clearSelection();
            this.setCheckAllState();
            this.disableUI = false;
        }
    };
    Selection.prototype.actionCompleteHandler = function(e) {
        if (e.requestType === "save" && this.parent.isPersistSelection) this.refreshPersistSelection();
    };
    Selection.prototype.selectRowIndex = function(index) {
        this.parent.isSelectedRowIndexUpdating = true;
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.selectedRowIndex) || this.parent.selectedRowIndex === -1 || !this.parent.enablePersistence) this.parent.selectedRowIndex = index;
        else this.parent.selectedRowIndex = -1;
    };
    Selection.prototype.disableInteracted = function() {
        this.isInteracted = false;
    };
    Selection.prototype.activeTarget = function() {
        this.actualTarget = this.isInteracted ? this.actualTarget : null;
    };
    return Selection;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


/**
 * The `Search` module is used to handle search action.
 */ var $1c44575f41b05087$export$4b85d3515bd863a5 = /** @class */ function() {
    /**
     * Constructor for Grid search module.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function Search(parent) {
        //Internal variables
        /** @hidden */ this.headerFocus = false;
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * Checks if the input string contains non-numeric characters.
     *
     * @param {string} searchString - The string to be checked for non-numeric characters.
     * @returns {boolean} - `true` if the input string contains non-numeric characters, `false` otherwise.
     */ Search.prototype.hasNonNumericCharacters = function(searchString) {
        var decimalFound = false;
        for(var _i = 0, searchString_1 = searchString; _i < searchString_1.length; _i++){
            var char = searchString_1[_i];
            if ((char < "0" || char > "9") && char !== ".") return true;
            if (char === ".") {
                if (decimalFound) // If decimal is found more than once, it's not valid
                return true;
                decimalFound = true;
            }
        }
        return false;
    };
    /**
     * Searches Grid records by given key.
     *
     * > You can customize the default search action by using [`searchSettings`](./searchsettings/).
     *
     * @param  {string} searchString - Defines the key.
     * @returns {void}
     */ Search.prototype.search = function(searchString) {
        var gObj = this.parent;
        searchString = (0, $3EnZW.isNullOrUndefined)(searchString) ? "" : searchString;
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj)) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.search,
                arg1: searchString
            });
            return;
        }
        if (searchString !== gObj.searchSettings.key) {
            this.headerFocus = false;
            // Check searchString is number and parseFloat to remove trailing zeros
            if (searchString !== "" && !this.hasNonNumericCharacters(searchString)) {
                if (searchString === ".") gObj.searchSettings.key = searchString.toString();
                else gObj.searchSettings.key = parseFloat(searchString).toString();
            } else gObj.searchSettings.key = searchString.toString();
            gObj.dataBind();
        } else if (this.refreshSearch) gObj.refresh();
        else this.headerFocus = false;
    };
    /**
     * @returns {void}
     * @hidden
     */ Search.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$93675ce65bb4868f, this.onSearchComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.actionCompleteFunc = this.onActionComplete.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunc);
        this.parent.on($17b89d3b1fc93cdb$export$13b99c0e226e6ca4, this.cancelBeginEvent, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Search.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged);
        this.parent.off($17b89d3b1fc93cdb$export$93675ce65bb4868f, this.onSearchComplete);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunc);
        this.parent.off($17b89d3b1fc93cdb$export$13b99c0e226e6ca4, this.cancelBeginEvent);
    };
    /**
     * To destroy the print
     *
     * @returns {void}
     * @hidden
     */ Search.prototype.destroy = function() {
        this.removeEventListener();
    };
    /**
     * @param {NotifyArgs} e - specfies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Search.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        if (!(0, $3EnZW.isNullOrUndefined)(e.properties.key)) this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, {
            requestType: "searching",
            type: $17b89d3b1fc93cdb$export$df204737a6131aab,
            searchString: this.parent.searchSettings.key
        });
        else this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, {
            requestType: "searching",
            type: $17b89d3b1fc93cdb$export$df204737a6131aab
        });
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Search.prototype.onSearchComplete = function(e) {
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, {
            searchString: this.parent.searchSettings.key,
            requestType: "searching",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        }));
    };
    /**
     * The function used to store the requestType
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Search.prototype.onActionComplete = function(e) {
        if (this.refreshSearch && e.requestType === "refresh" && this.headerFocus) {
            this.headerFocus = false;
            this.parent.focusModule.focus();
            (0, $4ZDHT.addClass)([
                this.parent.focusModule.currentInfo.element
            ], [
                "e-focused"
            ]);
        }
        this.refreshSearch = e.requestType !== "searching";
    };
    Search.prototype.cancelBeginEvent = function(e) {
        if (e.requestType === "searching") this.parent.setProperties({
            searchSettings: {
                key: ""
            }
        }, true);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Search.prototype.getModuleName = function() {
        return "search";
    };
    return Search;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");



/**
 * The `ShowHide` module is used to control column visibility.
 */ var $2895c91985d75027$export$7b1795bf935bef37 = /** @class */ function() {
    /**
     * Constructor for the show hide module.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function ShowHide(parent) {
        this.colName = [];
        this.isShowHide = false;
        this.parent = parent;
        this.addEventListener();
        this.widthService = new (0, $95d0259945049a0f$export$96000d5616e57e96)(parent);
    }
    ShowHide.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$da4cf21ede5d704e,
                handler: this.batchChanges
            },
            {
                event: $17b89d3b1fc93cdb$export$748c68c5d9aa1854,
                handler: this.resetColumnState
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ ShowHide.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, false);
    };
    ShowHide.prototype.batchChanges = function() {
        if (this.isShowHide) {
            this.isShowHide = false;
            this.setVisible(this.colName, this.changedCol);
            this.changedCol = this.colName = [];
        }
    };
    /**
     * Shows a column by column name.
     *
     * @param  {string|string[]} columnName - Defines a single or collection of column names to show.
     * @param  {string} showBy - Defines the column key either as field name or header text.
     * @returns {void}
     */ ShowHide.prototype.show = function(columnName, showBy) {
        var keys = this.getToggleFields(columnName);
        var columns = this.getColumns(keys, showBy);
        this.parent.notify($17b89d3b1fc93cdb$export$7edde809d061e, {
            module: "edit"
        });
        for(var i = 0; i < columns.length; i++)columns[parseInt(i.toString(), 10)].visible = true;
        this.setVisible(columns);
    };
    /**
     * Hides a column by column name.
     *
     * @param  {string|string[]} columnName - Defines a single or collection of column names to hide.
     * @param  {string} hideBy - Defines the column key either as field name or header text.
     * @returns {void}
     */ ShowHide.prototype.hide = function(columnName, hideBy) {
        var keys = this.getToggleFields(columnName);
        var columns = this.getColumns(keys, hideBy);
        this.parent.notify($17b89d3b1fc93cdb$export$7edde809d061e, {
            module: "edit"
        });
        for(var i = 0; i < columns.length; i++)columns[parseInt(i.toString(), 10)].visible = false;
        this.setVisible(columns);
    };
    ShowHide.prototype.getToggleFields = function(key) {
        var finalized = [];
        if (typeof key === "string") finalized = [
            key
        ];
        else finalized = key;
        return finalized;
    };
    ShowHide.prototype.getColumns = function(keys, getKeyBy) {
        var _this = this;
        var columns = (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(keys, function(key) {
            return (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(_this.parent.columnModel, function(item) {
                if (item["" + getKeyBy] === key) return item;
                return undefined;
            })[0];
        });
        return columns;
    };
    ShowHide.prototype.batchActionPrevent = function(columns, changedStateColumns) {
        if (changedStateColumns === void 0) changedStateColumns = [];
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(this.parent)) {
            this.colName = columns;
            this.changedCol = changedStateColumns;
            this.parent.closeEdit();
            return false;
        }
        return true;
    };
    ShowHide.prototype.resetColumnState = function() {
        if (this.isShowHide) for(var i = 0; i < this.colName.length; i++)this.colName[parseInt(i.toString(), 10)].visible = !this.colName[parseInt(i.toString(), 10)].visible;
    };
    /**
     * Shows or hides columns by given column collection.
     *
     * @private
     * @param {Column[]} columns - Specifies the columns.
     * @param {Column[]} changedStateColumns - specifies the changedStateColumns
     * @returns {void}
     */ ShowHide.prototype.setVisible = function(columns, changedStateColumns) {
        var _this = this;
        if (changedStateColumns === void 0) changedStateColumns = [];
        this.isShowHide = true;
        if (!this.batchActionPrevent(columns, changedStateColumns)) return;
        changedStateColumns = changedStateColumns.length > 0 ? changedStateColumns : columns;
        var args = {
            requestType: "columnstate",
            cancel: false,
            columns: changedStateColumns
        };
        var cancel = "cancel";
        if (this.parent.enableInfiniteScrolling && this.parent.allowGrouping && this.parent.groupModule.groupSettings.columns.length > 0) this.parent.contentModule.visibleRows = [];
        this.parent.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, args, function(showHideArgs) {
            var currentViewCols = _this.parent.getColumns();
            columns = (0, $3EnZW.isNullOrUndefined)(columns) ? currentViewCols : columns;
            if (showHideArgs["" + cancel]) {
                _this.parent.notify($17b89d3b1fc93cdb$export$8d1f04a619d5db82, {
                    showHideArgs: showHideArgs
                });
                if (columns.length > 0) columns[0].visible = true;
                return;
            }
            if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(_this.parent)) _this.parent.contentModule.emptyVcRows();
            var addedRow = _this.parent.element.querySelector(".e-addedrow");
            if (_this.parent.editSettings.showAddNewRow && addedRow) {
                (0, $4ZDHT.remove)(addedRow);
                if (_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling) _this.parent.isAddNewRow = true;
                _this.parent.addNewRowFocus = true;
                _this.parent.isEdit = false;
            }
            if (_this.parent.allowSelection && _this.parent.getSelectedRecords().length && !_this.parent.selectionSettings.persistSelection) _this.parent.clearSelection();
            if (_this.parent.enableColumnVirtualization) {
                var colsInCurrentView = columns.filter(function(col1) {
                    return currentViewCols.some(function(col2) {
                        return col1.field === col2.field;
                    });
                });
                if (colsInCurrentView.length) _this.parent.notify($17b89d3b1fc93cdb$export$c480fa254fb70e72, columns);
            } else {
                if (_this.parent.isFrozenGrid() && columns.length) _this.parent.notify($17b89d3b1fc93cdb$export$cdacb1a8abdadeeb, {
                    isModeChg: true
                });
                _this.parent.notify($17b89d3b1fc93cdb$export$c480fa254fb70e72, columns);
            }
            var params = {
                requestType: "columnstate",
                columns: changedStateColumns
            };
            _this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, params);
            var startAdd = !_this.parent.element.querySelector(".e-addedrow");
            if (_this.parent.editSettings.showAddNewRow && startAdd) {
                _this.parent.isEdit = false;
                _this.parent.addRecord();
                if (!(_this.parent.enableVirtualization || _this.parent.enableInfiniteScrolling)) _this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
            }
            if (_this.parent.columnQueryMode !== "All") _this.parent.refresh();
        });
        if (!this.parent.groupSettings.columns.length) {
            if (this.parent.autoFit) this.parent.preventAdjustColumns();
            else if (this.parent.allowResizing && this.parent.resizeSettings.mode === "Normal") {
                var isMaxWidth = this.parent.getHeaderTable().style.width.indexOf("px") === -1;
                this.widthService.setWidthToTable(isMaxWidth);
            }
        }
    };
    return ShowHide;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");




/**
 * The `Scroll` module is used to handle scrolling behaviour.
 */ var $479ae25f4fbe2186$export$6ed4a4084f55ee7c = /** @class */ function() {
    /**
     * Constructor for the Grid scrolling.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function Scroll(parent) {
        //To maintain scroll state on grid actions.
        this.previousValues = {
            top: 0,
            left: 0
        };
        this.oneTimeReady = true;
        this.parent = parent;
        this.widthService = new (0, $95d0259945049a0f$export$96000d5616e57e96)(parent);
        this.addEventListener();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Scroll.prototype.getModuleName = function() {
        return "scroll";
    };
    /**
     * @param {boolean} uiupdate - specifies the uiupdate
     * @returns {void}
     * @hidden
     */ Scroll.prototype.setWidth = function(uiupdate) {
        this.parent.element.style.width = (0, $3EnZW.formatUnit)(this.parent.width);
        if (uiupdate) this.widthService.setWidthToColumns();
        if (this.parent.toolbarModule && this.parent.toolbarModule.toolbar && this.parent.toolbarModule.toolbar.element) {
            var tlbrElement = this.parent.toolbarModule.toolbar.element;
            var tlbrLeftElement = tlbrElement.querySelector(".e-toolbar-left");
            var tlbrCenterElement = tlbrElement.querySelector(".e-toolbar-center");
            var tlbrRightElement = tlbrElement.querySelector(".e-toolbar-right");
            var tlbrItems = tlbrElement.querySelector(".e-toolbar-items");
            var tlbrLeftWidth = tlbrLeftElement ? tlbrLeftElement.clientWidth : 0;
            var tlbrCenterWidth = tlbrCenterElement ? tlbrCenterElement.clientWidth : 0;
            var tlbrRightWidth = tlbrRightElement ? tlbrRightElement.clientWidth : 0;
            var tlbrItemsWidth = tlbrItems ? tlbrItems.clientWidth : 0;
            var tlbrWidth = tlbrElement ? tlbrElement.clientWidth : 0;
            if (!this.parent.enableAdaptiveUI || tlbrLeftWidth > tlbrWidth || tlbrCenterWidth > tlbrWidth || tlbrRightWidth > tlbrWidth || tlbrItemsWidth > tlbrWidth) this.parent.toolbarModule.toolbar.refreshOverflow();
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.setHeight = function() {
        var mHdrHeight = 0;
        var content = this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
        var height = this.parent.height;
        if (this.parent.enableColumnVirtualization && this.parent.isFrozenGrid() && this.parent.height !== "auto" && this.parent.height.toString().indexOf("%") < 0) height = parseInt(height, 10) - Scroll.getScrollBarWidth();
        if (!this.parent.enableVirtualization && this.parent.frozenRows && this.parent.height !== "auto") {
            var tbody = this.parent.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c + ":not(.e-masked-tbody)");
            mHdrHeight = tbody ? tbody.offsetHeight : 0;
            if (tbody && mHdrHeight) {
                var add = tbody.getElementsByClassName($1b5568e76cdae6d4$export$792eb12cf4991bf2).length;
                var height_1 = add * this.parent.getRowHeight();
                mHdrHeight -= height_1;
            } else if (!this.parent.isInitialLoad && this.parent.loadingIndicator.indicatorType === "Shimmer" && this.parent.getHeaderContent().querySelector(".e-masked-table")) height = parseInt(height, 10) - this.parent.frozenRows * this.parent.getRowHeight();
            content.style.height = (0, $3EnZW.formatUnit)(height - mHdrHeight);
        } else content.style.height = (0, $3EnZW.formatUnit)(height);
        this.ensureOverflow(content);
        if (this.parent.isFrozenGrid()) this.refresh();
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.setPadding = function() {
        var content = this.parent.getHeaderContent();
        var scrollWidth = Scroll.getScrollBarWidth() - this.getThreshold();
        var cssProps = this.getCssProperties();
        content.querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).style[cssProps.border] = scrollWidth > 0 ? "1px" : "0px";
        content.style[cssProps.padding] = scrollWidth > 0 ? scrollWidth + "px" : "0px";
    };
    /**
     * @param {boolean} rtl - specifies the rtl
     * @returns {void}
     * @hidden
     */ Scroll.prototype.removePadding = function(rtl) {
        var cssProps = this.getCssProperties(rtl);
        var hDiv = this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
        hDiv.style[cssProps.border] = "";
        hDiv.parentElement.style[cssProps.padding] = "";
        var footerDiv = this.parent.getFooterContent();
        if (footerDiv && footerDiv.classList.contains("e-footerpadding")) footerDiv.classList.remove("e-footerpadding");
    };
    /**
     * Refresh makes the Grid adoptable with the height of parent container.
     *
     * > The [`height`](./#height) must be set to 100%.
     *
     * @returns {void}
     */ Scroll.prototype.refresh = function() {
        if (this.parent.height !== "100%") return;
        var content = this.parent.getContent();
        this.parent.element.style.height = "100%";
        var height = this.widthService.getSiblingsHeight(content);
        content.style.height = "calc(100% - " + height + "px)"; //Set the height to the  '.' + literals.gridContent;
    };
    Scroll.prototype.getThreshold = function() {
        /* Some browsers places the scroller outside the content,
         * hence the padding should be adjusted.*/ var appName = (0, $5q7BP.Browser).info.name;
        if (appName === "mozilla") return 0.5;
        return 1;
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on((0, $17b89d3b1fc93cdb$export$63287e93462800a4), this.wireEvents, this);
        this.parent.on((0, $17b89d3b1fc93cdb$export$f44d9209b353bf3e), this.wireEvents, this);
        this.parent.on((0, $17b89d3b1fc93cdb$export$27ad5926bed65d9), this.onPropertyChanged, this);
        this.parent.on((0, $17b89d3b1fc93cdb$export$2c01e4c7592b4497), this.wireEvents, this);
        this.parent.on((0, $17b89d3b1fc93cdb$export$265a66bcae9d11dd), this.setScrollLeft, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off((0, $17b89d3b1fc93cdb$export$63287e93462800a4), this.wireEvents);
        this.parent.off((0, $17b89d3b1fc93cdb$export$f44d9209b353bf3e), this.wireEvents);
        this.parent.off((0, $17b89d3b1fc93cdb$export$27ad5926bed65d9), this.onPropertyChanged);
        this.parent.off((0, $17b89d3b1fc93cdb$export$2c01e4c7592b4497), this.wireEvents);
        this.parent.off((0, $17b89d3b1fc93cdb$export$265a66bcae9d11dd), this.setScrollLeft);
        this.unwireEvents();
    };
    Scroll.prototype.unwireEvents = function() {
        if (this.parent.frozenRows && this.header) {
            (0, $aqzbR.EventHandler).remove(this.header, "touchstart pointerdown", this.setPageXY);
            (0, $aqzbR.EventHandler).remove(this.header, "touchmove pointermove", this.onTouchScroll);
        }
        var mScrollBar = this.parent.getContent() ? this.parent.getContent().querySelector(".e-movablescrollbar") : null;
        if (this.parent.isFrozenGrid() && this.parent.enableColumnVirtualization) {
            if (mScrollBar) (0, $aqzbR.EventHandler).remove(mScrollBar, "scroll", this.onCustomScrollbarScroll);
            if (this.content) {
                (0, $aqzbR.EventHandler).remove(this.content, "scroll", this.onCustomScrollbarScroll);
                (0, $aqzbR.EventHandler).remove(this.content, "touchstart pointerdown", this.setPageXY);
                if (!(/macintosh|ipad/.test((0, $5q7BP.Browser).userAgent.toLowerCase()) && (0, $5q7BP.Browser).isDevice)) (0, $aqzbR.EventHandler).remove(this.content, "touchmove pointermove", this.onTouchScroll);
            }
            if (this.header) {
                (0, $aqzbR.EventHandler).remove(this.header, "scroll", this.onCustomScrollbarScroll);
                (0, $aqzbR.EventHandler).remove(this.header, "touchstart pointerdown", this.setPageXY);
                (0, $aqzbR.EventHandler).remove(this.header, "touchmove pointermove", this.onTouchScroll);
            }
        }
        if (this.content) (0, $aqzbR.EventHandler).remove(this.content, "scroll", this.contentScrollHandler);
        if (this.header) (0, $aqzbR.EventHandler).remove(this.header, "scroll", this.headerScrollHandler);
        this.contentScrollHandler = null;
        this.headerScrollHandler = null;
        if (this.parent.aggregates.length && this.parent.getFooterContent()) (0, $aqzbR.EventHandler).remove(this.parent.getFooterContent().firstChild, "scroll", this.onContentScroll);
    };
    Scroll.prototype.setScrollLeft = function() {
        this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).scrollLeft = this.previousValues.left;
    };
    Scroll.prototype.onContentScroll = function(scrollTarget) {
        var _this = this;
        var element = scrollTarget;
        var isHeader = element.classList.contains($1b5568e76cdae6d4$export$838c0e7679321ff3);
        return function(e) {
            if (_this.content.querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c) === null || _this.parent.isPreventScrollEvent) return;
            var target = e.target;
            if (_this.parent.frozenRows) {
                if (_this.content.scrollTop > 0 && _this.parent.frozenRows) (0, $4ZDHT.addClass)([
                    _this.parent.element
                ], "e-top-shadow");
                else (0, $4ZDHT.removeClass)([
                    _this.parent.element
                ], "e-top-shadow");
            }
            if (_this.parent.element.querySelectorAll(".e-leftfreeze,.e-fixedfreeze,.e-rightfreeze").length) {
                var errorFreeze = _this.parent.getContent().querySelectorAll('.e-freezeerror:not([style*="display: none"])');
                var errorFixed = _this.parent.getContent().querySelectorAll('.e-fixederror:not([style*="display: none"])');
                if (target.scrollLeft !== 0 && _this.parent.getVisibleFrozenLeftCount()) (0, $4ZDHT.addClass)([
                    _this.parent.element
                ], "e-left-shadow");
                else (0, $4ZDHT.removeClass)([
                    _this.parent.element
                ], "e-left-shadow");
                var widthVal = Math.round((_this.parent.enableRtl ? target.scrollWidth + target.scrollLeft : target.scrollWidth - target.scrollLeft) + (_this.parent.height === "auto" ? 0 : 1));
                if (widthVal === target.offsetWidth && _this.parent.getVisibleFrozenRightCount()) (0, $4ZDHT.removeClass)([
                    _this.parent.element
                ], "e-right-shadow");
                else (0, $4ZDHT.addClass)([
                    _this.parent.element
                ], "e-right-shadow");
                var rows = [].slice.call(_this.parent.getContent().querySelectorAll(".e-row:not(.e-hiddenrow)"));
                if ((rows.length === 1 && errorFreeze.length || _this.parent.element.querySelector('.e-freeze-autofill:not([style*="display: none"])') || errorFixed.length) && target.scrollLeft !== _this.previousValues.left) {
                    target.scrollLeft = _this.previousValues.left;
                    return;
                }
                if (rows.length !== 1 && (errorFreeze.length || errorFixed.length) && target.scrollTop !== _this.previousValues.top) {
                    target.scrollTop = _this.previousValues.top;
                    return;
                }
            }
            var left = target.scrollLeft;
            if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.infiniteScrollModule) && _this.parent.enableInfiniteScrolling && (!_this.parent.isEdit || _this.parent.editSettings.showAddNewRow && !_this.parent.element.querySelector(".e-editedrow"))) _this.parent.notify((0, $17b89d3b1fc93cdb$export$d2df54dc266fa920), {
                target: e.target,
                isLeft: _this.previousValues.left !== left
            });
            if (_this.parent.groupSettings.columns.length && _this.parent.groupSettings.enableLazyLoading) {
                var isDown = _this.previousValues.top < _this.parent.getContent().firstElementChild.scrollTop;
                _this.parent.notify((0, $17b89d3b1fc93cdb$export$2416ce2c5bd34d0a), {
                    scrollDown: isDown
                });
            }
            _this.parent.notify((0, $17b89d3b1fc93cdb$export$ca52857b7b04ae17), {});
            var isFooter = target.classList.contains("e-summarycontent");
            if (_this.previousValues.left === left) {
                _this.previousValues.top = !isHeader ? _this.previousValues.top : target.scrollTop;
                return;
            }
            _this.parent.notify((0, $17b89d3b1fc93cdb$export$992e182ea3a73b5d), e);
            element.scrollLeft = left;
            if (isFooter) _this.header.scrollLeft = left;
            _this.previousValues.left = left;
            _this.parent.notify((0, $17b89d3b1fc93cdb$export$209876d7b1ac8f3), {
                left: left
            });
        };
    };
    Scroll.prototype.onCustomScrollbarScroll = function(cont, hdr) {
        var _this = this;
        var content = cont;
        var header = hdr;
        return function(e) {
            if (_this.content.querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c) === null) return;
            var target = e.target;
            var left = target.scrollLeft;
            if (_this.previousValues.left === left) return;
            content.scrollLeft = left;
            header.scrollLeft = left;
            _this.previousValues.left = left;
            _this.parent.notify((0, $17b89d3b1fc93cdb$export$209876d7b1ac8f3), {
                left: left
            });
            if (_this.parent.isDestroyed) return;
        };
    };
    Scroll.prototype.onTouchScroll = function(scrollTarget) {
        var _this = this;
        var element = scrollTarget;
        return function(e) {
            if (e.pointerType === "mouse") return;
            var isFrozen = _this.parent.isFrozenGrid();
            var pageXY = _this.getPointXY(e);
            var left = element.scrollLeft + (_this.pageXY.x - pageXY.x);
            var mHdr = _this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
            var mCont = _this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
            if (_this.previousValues.left === left || left < 0 || mHdr.scrollWidth - mHdr.clientWidth < left) return;
            e.preventDefault();
            mHdr.scrollLeft = left;
            mCont.scrollLeft = left;
            if (isFrozen && _this.parent.enableColumnVirtualization) {
                var scrollBar = _this.parent.getContent().querySelector(".e-movablescrollbar");
                scrollBar.scrollLeft = left;
            }
            _this.pageXY.x = pageXY.x;
            _this.previousValues.left = left;
        };
    };
    Scroll.prototype.setPageXY = function() {
        var _this = this;
        return function(e) {
            if (e.pointerType === "mouse") return;
            _this.pageXY = _this.getPointXY(e);
        };
    };
    Scroll.prototype.getPointXY = function(e) {
        var pageXY = {
            x: 0,
            y: 0
        };
        if (e.touches && e.touches.length) {
            pageXY.x = e.touches[0].pageX;
            pageXY.y = e.touches[0].pageY;
        } else {
            pageXY.x = e.pageX;
            pageXY.y = e.pageY;
        }
        return pageXY;
    };
    Scroll.prototype.getScrollbleParent = function(node) {
        if (node === null) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var parent = (0, $3EnZW.isNullOrUndefined)(node.tagName) ? node.scrollingElement : node;
        var overflowY = document.defaultView.getComputedStyle(parent, null).overflowY;
        if (parent.scrollHeight > parent.clientHeight && overflowY !== "hidden" && overflowY !== "visible" || node.tagName === "HTML" || node.tagName === "BODY") return node;
        else return this.getScrollbleParent(node.parentNode);
    };
    /**
     * @param {boolean} isAdd - specifies whether adding/removing the event
     * @returns {void}
     * @hidden
     */ Scroll.prototype.addStickyListener = function(isAdd) {
        this.parentElement = this.getScrollbleParent(this.parent.element.parentElement);
        if (isAdd && this.parentElement) {
            this.eventElement = this.parentElement.tagName === "HTML" || this.parentElement.tagName === "BODY" ? document : this.parentElement;
            (0, $aqzbR.EventHandler).add(this.eventElement, "scroll", this.makeStickyHeader, this);
        } else if (this.eventElement) {
            (0, $aqzbR.EventHandler).remove(this.eventElement, "scroll", this.makeStickyHeader);
            this.eventElement = null;
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.resizeFrozenRowBorder = function() {
        var div;
        if (!this.parent.element.querySelector(".e-frozenrow-border")) {
            div = this.parent.createElement("div", {
                className: "e-frozenrow-border"
            });
            this.parent.element.insertBefore(div, this.parent.element.querySelector(".e-gridcontent"));
        } else div = this.parent.element.querySelector(".e-frozenrow-border");
        var scrollWidth = this.parent.height !== "auto" ? Scroll.getScrollBarWidth() : 0;
        div.style.width = this.parent.element.offsetWidth - scrollWidth - 0.5 + "px";
    };
    Scroll.prototype.wireEvents = function() {
        var _this = this;
        if (this.oneTimeReady) {
            var frzCols = this.parent.isFrozenGrid();
            this.content = this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
            this.header = this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
            var mScrollBar = this.parent.getContent().querySelector(".e-movablescrollbar");
            if (this.parent.frozenRows && this.header && this.content) {
                (0, $aqzbR.EventHandler).add(this.header, "touchstart pointerdown", this.setPageXY(), this);
                (0, $aqzbR.EventHandler).add(this.header, "touchmove pointermove", this.onTouchScroll(this.content), this);
            }
            if (frzCols && mScrollBar && this.parent.enableColumnVirtualization) {
                (0, $aqzbR.EventHandler).add(mScrollBar, "scroll", this.onCustomScrollbarScroll(this.content, this.header), this);
                (0, $aqzbR.EventHandler).add(this.content, "scroll", this.onCustomScrollbarScroll(mScrollBar, this.header), this);
                (0, $aqzbR.EventHandler).add(this.header, "scroll", this.onCustomScrollbarScroll(mScrollBar, this.content), this);
                (0, $aqzbR.EventHandler).add(this.header, "touchstart pointerdown", this.setPageXY(), this);
                (0, $aqzbR.EventHandler).add(this.header, "touchmove pointermove", this.onTouchScroll(this.content), this);
                (0, $aqzbR.EventHandler).add(this.content, "touchstart pointerdown", this.setPageXY(), this);
                if (!(/macintosh|ipad/.test((0, $5q7BP.Browser).userAgent.toLowerCase()) && (0, $5q7BP.Browser).isDevice)) (0, $aqzbR.EventHandler).add(this.content, "touchmove pointermove", this.onTouchScroll(this.header), this);
            }
            this.contentScrollHandler = this.onContentScroll(this.header);
            this.headerScrollHandler = this.onContentScroll(this.content);
            (0, $aqzbR.EventHandler).add(this.content, "scroll", this.contentScrollHandler, this);
            (0, $aqzbR.EventHandler).add(this.header, "scroll", this.headerScrollHandler, this);
            if (this.parent.aggregates.length) (0, $aqzbR.EventHandler).add(this.parent.getFooterContent().firstChild, "scroll", this.onContentScroll(this.content), this);
            if (this.parent.enableStickyHeader) this.addStickyListener(true);
            this.refresh();
            this.oneTimeReady = false;
        }
        var table = this.parent.getContentTable();
        var sLeft;
        var sHeight;
        var clientHeight;
        (0, $748c2240e597a9b7$export$1a5f3b7403a8bf39)(function() {
            sLeft = _this.header.scrollLeft;
            sHeight = table.scrollHeight;
            clientHeight = _this.parent.getContent().clientHeight;
        }, function() {
            var args = {
                cancel: false
            };
            _this.parent.notify((0, $17b89d3b1fc93cdb$export$4b9274a2d5fb643d), args);
            if (sHeight < clientHeight && _this.parent.height !== "auto") _this.setLastRowCell();
            if (_this.parent.frozenRows) _this.resizeFrozenRowBorder();
            if (!_this.parent.enableVirtualization && !_this.parent.enableInfiniteScrolling) {
                if (!args.cancel) {
                    _this.header.scrollLeft = _this.previousValues.left;
                    _this.content.scrollLeft = _this.previousValues.left;
                    _this.content.scrollTop = _this.previousValues.top;
                }
            }
            if (!_this.parent.enableColumnVirtualization) {
                _this.content.scrollLeft = sLeft;
                if (_this.parent.isFrozenGrid()) _this.previousValues.left = sLeft;
            }
        });
        this.parent.isPreventScrollEvent = false;
    };
    /**
     * @returns {void} returns void
     * @hidden
     */ Scroll.prototype.setLastRowCell = function() {
        var table = this.parent.getContentTable();
        (0, $4ZDHT.removeClass)(table.querySelectorAll("td"), "e-lastrowcell");
        if (table.querySelector("tr:nth-last-child(2)")) {
            if (this.parent.editSettings.showAddNewRow && this.parent.editSettings.newRowPosition === "Bottom") (0, $4ZDHT.addClass)(table.querySelector("tr:nth-last-child(2)").querySelectorAll("td"), "e-lastrowcell");
        }
        (0, $4ZDHT.addClass)(table.querySelectorAll("tr:last-child td"), "e-lastrowcell");
        if (this.parent.isSpan) (0, $4ZDHT.addClass)(table.querySelectorAll(".e-row-span-lastrowcell"), "e-lastrowcell");
    };
    /**
     * @param {boolean} rtl - specifies the rtl
     * @returns {ScrollCss} returns the ScrollCss
     * @hidden
     */ Scroll.prototype.getCssProperties = function(rtl) {
        var css = {};
        var enableRtl = (0, $3EnZW.isNullOrUndefined)(rtl) ? this.parent.enableRtl : rtl;
        css.border = enableRtl ? "borderLeftWidth" : "borderRightWidth";
        css.padding = enableRtl ? "paddingLeft" : "paddingRight";
        return css;
    };
    Scroll.prototype.ensureOverflow = function(content) {
        content.style.overflowY = this.parent.height === "auto" ? "auto" : "scroll";
    };
    Scroll.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        this.setPadding();
        this.oneTimeReady = true;
        if (this.parent.height === "auto") this.removePadding();
        this.wireEvents();
        this.setHeight();
        var width = "width";
        this.setWidth(!(0, $3EnZW.isNullOrUndefined)(e.properties["" + width]));
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.makeStickyHeader = function() {
        if (this.parent.enableStickyHeader && this.parent.element && this.parent.getContent()) {
            var contentRect = this.parent.getContent().getClientRects()[0];
            if (contentRect) {
                var headerEle = this.parent.getHeaderContent();
                var toolbarEle = this.parent.element.querySelector(".e-toolbar");
                var groupHeaderEle = this.parent.element.querySelector(".e-groupdroparea");
                var height = headerEle.offsetHeight + (toolbarEle ? toolbarEle.offsetHeight : 0) + (groupHeaderEle ? groupHeaderEle.offsetHeight : 0);
                var parentTop = this.parentElement.getClientRects()[0].top;
                var top_1 = contentRect.top - (parentTop < 0 ? 0 : parentTop);
                var left = contentRect.left;
                var colMenuEle = document.body.querySelector("#" + this.parent.element.id + "_columnmenu");
                if (top_1 < height && contentRect.bottom > 0) {
                    headerEle.classList.add("e-sticky");
                    var elemTop = 0;
                    if (groupHeaderEle && this.parent.groupSettings.showDropArea) {
                        this.setSticky(groupHeaderEle, elemTop, contentRect.width, left, true);
                        elemTop += groupHeaderEle.getClientRects()[0].height;
                    }
                    if (toolbarEle) {
                        this.setSticky(toolbarEle, elemTop, contentRect.width, left, true);
                        elemTop += toolbarEle.getClientRects()[0].height;
                    }
                    this.setSticky(headerEle, elemTop, contentRect.width, left, true);
                    if (!(0, $3EnZW.isNullOrUndefined)(colMenuEle)) {
                        colMenuEle.style.position = "fixed";
                        colMenuEle.style.top = height + "px";
                    }
                } else if (headerEle.classList.contains("e-sticky")) {
                    this.setSticky(headerEle, null, null, null, false);
                    if (toolbarEle) this.setSticky(toolbarEle, null, null, null, false);
                    if (groupHeaderEle) this.setSticky(groupHeaderEle, null, null, null, false);
                    var ccDlg = this.parent.element.querySelector(".e-ccdlg");
                    if (ccDlg) ccDlg.classList.remove("e-sticky");
                    if (!(0, $3EnZW.isNullOrUndefined)(colMenuEle)) {
                        colMenuEle.style.position = "absolute";
                        var topStyle = contentRect.top - parentTop;
                        colMenuEle.style.top = topStyle + "px";
                    }
                }
                this.parent.notify($17b89d3b1fc93cdb$export$c77f723cf0645ced, {});
            }
        }
    };
    Scroll.prototype.setSticky = function(ele, top, width, left, isAdd) {
        if (isAdd) ele.classList.add("e-sticky");
        else ele.classList.remove("e-sticky");
        ele.style.width = width != null ? width + "px" : "";
        ele.style.top = top != null ? top + "px" : "";
        ele.style.left = left !== null ? parseInt(ele.style.left, 10) !== left ? left + "px" : ele.style.left : "";
    };
    /**
     * @returns {void}
     * @hidden
     */ Scroll.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        this.removeEventListener();
        //Remove Dom event
        var cont = this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
        (0, $aqzbR.EventHandler).remove(cont, "scroll", this.onContentScroll);
        if (this.parent.enableStickyHeader) this.addStickyListener(false);
        //Remove padding
        this.removePadding();
        (0, $4ZDHT.removeClass)([
            this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3)
        ], $1b5568e76cdae6d4$export$838c0e7679321ff3);
        (0, $4ZDHT.removeClass)([
            cont
        ], $1b5568e76cdae6d4$export$a7db06668cad9adb);
        //Remove height
        cont.style.height = "";
        //Remove width
        this.parent.element.style.width = "";
    };
    /**
     * Function to get the scrollbar width of the browser.
     *
     * @returns {number} return the width
     * @hidden
     */ Scroll.getScrollBarWidth = function() {
        return (0, $748c2240e597a9b7$export$1df2a1438d36fb55)();
    };
    return Scroll;
}();



parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $c2qqN = parcelRequire("c2qqN");
var $3EnZW = parcelRequire("3EnZW");

var $00d8239bc4893f3a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $00d8239bc4893f3a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the Grid's aggregate column.
 */ var $00d8239bc4893f3a$export$172706a724c25988 = /** @class */ function(_super) {
    $00d8239bc4893f3a$var$__extends(AggregateColumn, _super);
    function AggregateColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateFn = {};
        return _this;
    }
    /**
     * @param {Function} value - specifies the value
     * @returns {void}
     * @hidden
     */ AggregateColumn.prototype.setFormatter = function(value) {
        this.formatFn = value;
    };
    /**
     * @returns {Function} returns the Function
     * @hidden
     */ AggregateColumn.prototype.getFormatter = function() {
        return this.formatFn;
    };
    /**
     * @param {Object} helper - specifies the helper
     * @returns {void}
     * @hidden
     */ AggregateColumn.prototype.setTemplate = function(helper) {
        if (helper === void 0) helper = {};
        if (this.footerTemplate !== undefined) this.templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Summary)] = {
            fn: (0, $c2qqN.compile)(this.footerTemplate, helper),
            property: "footerTemplate"
        };
        if (this.groupFooterTemplate !== undefined) this.templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary)] = {
            fn: (0, $c2qqN.compile)(this.groupFooterTemplate, helper),
            property: "groupFooterTemplate"
        };
        if (this.groupCaptionTemplate !== undefined) this.templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary)] = {
            fn: (0, $c2qqN.compile)(this.groupCaptionTemplate, helper),
            property: "groupCaptionTemplate"
        };
    };
    /**
     * @param {CellType} type - specifies the cell type
     * @returns {Object} returns the object
     * @hidden
     */ AggregateColumn.prototype.getTemplate = function(type) {
        return this.templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), type)];
    };
    /**
     * @param {Object} prop - returns the Object
     * @returns {void}
     * @hidden
     */ AggregateColumn.prototype.setPropertiesSilent = function(prop) {
        this.setProperties(prop, true);
    };
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "type", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "field", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "columnName", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "format", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "footerTemplate", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "groupFooterTemplate", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "groupCaptionTemplate", void 0);
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Property)()
    ], AggregateColumn.prototype, "customAggregate", void 0);
    return AggregateColumn;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the aggregate rows.
 */ var $00d8239bc4893f3a$export$f4fb7a899a7c5783 = /** @class */ function(_super) {
    $00d8239bc4893f3a$var$__extends(AggregateRow, _super);
    function AggregateRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $00d8239bc4893f3a$var$__decorate([
        (0, $5rsSz.Collection)([], $00d8239bc4893f3a$export$172706a724c25988)
    ], AggregateRow.prototype, "columns", void 0);
    return AggregateRow;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");



/**
 * The `Clipboard` module is used to handle clipboard copy action.
 */ var $5d15e52cfa78cdcc$export$8b44c43c7d8f0830 = /** @class */ function() {
    /**
     * Constructor for the Grid clipboard module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     * @hidden
     */ function Clipboard(parent, serviceLocator) {
        this.copyContent = "";
        this.isSelect = false;
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.addEventListener();
    }
    /**
     * @returns {void}
     * @hidden
     */ Clipboard.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd, this);
        this.parent.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyDownHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$63287e93462800a4, this.initialEnd, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "keydown", this.pasteHandler, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Clipboard.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyDownHandler);
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
        this.parent.off($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler);
        this.parent.off($17b89d3b1fc93cdb$export$63287e93462800a4, this.initialEnd);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "keydown", this.pasteHandler);
    };
    Clipboard.prototype.clickHandler = function(e) {
        var target = e.target;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        target = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-rowcell");
    };
    Clipboard.prototype.pasteHandler = function(e) {
        var _this = this;
        var grid = this.parent;
        var isMacLike = /(Mac)/i.test(navigator.platform);
        var selectedRowCellIndexes = this.parent.getSelectedRowCellIndexes();
        if (!grid.isEdit && e.keyCode === 67 && isMacLike && e.metaKey) this.copy();
        if (selectedRowCellIndexes.length && e.keyCode === 86 && (!isMacLike && e.ctrlKey || isMacLike && e.metaKey) && !grid.isEdit) {
            var target = (0, $4ZDHT.closest)(document.activeElement, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
            if (!this.clipBoardTextArea || !target || !grid.editSettings.allowEditing || grid.editSettings.mode !== "Batch" || grid.selectionSettings.mode !== "Cell" || grid.selectionSettings.cellSelectionMode === "Flow") return;
            this.activeElement = document.activeElement;
            var x_1 = window.scrollX;
            var y_1 = window.scrollY;
            this.clipBoardTextArea.focus();
            setTimeout(function() {
                _this.activeElement.focus();
                window.scrollTo(x_1, y_1);
                _this.paste(_this.clipBoardTextArea.value, selectedRowCellIndexes[0].rowIndex, selectedRowCellIndexes[0].cellIndexes[0]);
            }, isMacLike ? 100 : 10);
        }
    };
    /**
     * Paste data from clipboard to selected cells.
     *
     * @param {boolean} data - Specifies the date for paste.
     * @param {boolean} rowIndex - Specifies the row index.
     * @param {boolean} colIndex - Specifies the column index.
     * @returns {void}
     */ Clipboard.prototype.paste = function(data, rowIndex, colIndex) {
        var grid = this.parent;
        var cIdx = colIndex;
        var rIdx = rowIndex;
        var col;
        var value;
        var isAvail;
        var rows = data.split("\n");
        var cols;
        for(var r = 0; r < rows.length; r++){
            cols = rows[parseInt(r.toString(), 10)].split("	");
            cIdx = colIndex;
            if (r === rows.length - 1 && rows[parseInt(r.toString(), 10)] === "" || (0, $3EnZW.isUndefined)(grid.getRowByIndex(rIdx))) {
                cIdx++;
                break;
            }
            for(var c = 0; c < cols.length; c++){
                isAvail = grid.getCellFromIndex(rIdx, cIdx);
                if (!isAvail) {
                    cIdx++;
                    break;
                }
                col = grid.getColumnByIndex(cIdx);
                value = col.getParser() ? col.getParser()(cols[parseInt(c.toString(), 10)]) : cols[parseInt(c.toString(), 10)];
                if (col.allowEditing && !col.isPrimaryKey && !col.template) {
                    var args = {
                        column: col,
                        data: value,
                        rowIndex: rIdx
                    };
                    this.parent.trigger($17b89d3b1fc93cdb$export$8f6d6233f3016d36, args);
                    rIdx = args.rowIndex;
                    if (!args.cancel) {
                        if (grid.editModule) {
                            if (col.type === "number") this.parent.editModule.updateCell(rIdx, col.field, parseFloat(args.data));
                            else grid.editModule.updateCell(rIdx, col.field, args.data);
                        }
                    }
                }
                cIdx++;
            }
            rIdx++;
        }
        grid.selectionModule.selectCellsByRange({
            rowIndex: rowIndex,
            cellIndex: colIndex
        }, {
            rowIndex: rIdx - 1,
            cellIndex: cIdx - 1
        });
        var cell = this.parent.getCellFromIndex(rIdx - 1, cIdx - 1);
        if (cell) (0, $4ZDHT.classList)(cell, [
            "e-focus",
            "e-focused"
        ], []);
        this.clipBoardTextArea.value = "";
    };
    Clipboard.prototype.initialEnd = function() {
        this.l10n = this.serviceLocator.getService("localization");
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
        this.clipBoardTextArea = this.parent.createElement("textarea", {
            className: "e-clipboard",
            styles: "opacity: 0",
            attrs: {
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("ClipBoard")
            }
        });
        this.parent.element.appendChild(this.clipBoardTextArea);
    };
    Clipboard.prototype.keyDownHandler = function(e) {
        if (e.action === "ctrlPlusC") this.copy();
        else if (e.action === "ctrlShiftPlusH") this.copy(true);
    };
    Clipboard.prototype.setCopyData = function(withHeader) {
        if (window.getSelection().toString() === "") {
            this.clipBoardTextArea.value = this.copyContent = "";
            var rows = this.parent.getDataRows();
            if (this.parent.selectionSettings.mode !== "Cell") {
                var selectedIndexes = this.parent.getSelectedRowIndexes().sort(function(a, b) {
                    return a - b;
                });
                if (withHeader) {
                    var headerTextArray = [];
                    for(var i = 0; i < this.parent.getVisibleColumns().length; i++)headerTextArray[parseInt(i.toString(), 10)] = this.parent.getVisibleColumns()[parseInt(i.toString(), 10)].headerText;
                    this.getCopyData(headerTextArray, false, "	", withHeader);
                    this.copyContent += "\n";
                }
                for(var i = 0; i < selectedIndexes.length; i++){
                    if (i > 0) this.copyContent += "\n";
                    var leftCols = [];
                    var idx = selectedIndexes[parseInt(i.toString(), 10)];
                    if (!(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && (this.parent.enableVirtualization || this.parent.enableInfiniteScrolling && this.parent.infiniteScrollSettings.enableCache || this.parent.groupSettings.columns.length && this.parent.groupSettings.enableLazyLoading)) idx = rows.map(function(m) {
                        return m.getAttribute("data-rowindex");
                    }).indexOf(selectedIndexes[parseInt(i.toString(), 10)].toString());
                    leftCols.push.apply(leftCols, [].slice.call(rows[parseInt(idx.toString(), 10)].querySelectorAll(".e-rowcell:not(.e-hide)")));
                    this.getCopyData(leftCols, false, "	", withHeader);
                }
            } else {
                var obj = this.checkBoxSelection();
                if (obj.status) {
                    if (withHeader) {
                        var headers = [];
                        for(var i = 0; i < obj.colIndexes.length; i++){
                            var colHeader = this.parent.getColumnHeaderByIndex(obj.colIndexes[parseInt(i.toString(), 10)]);
                            if (!colHeader.classList.contains("e-hide")) headers.push(colHeader);
                        }
                        this.getCopyData(headers, false, "	", withHeader);
                        this.copyContent += "\n";
                    }
                    for(var i = 0; i < obj.rowIndexes.length; i++){
                        if (i > 0) this.copyContent += "\n";
                        var cells = [].slice.call(rows[obj.rowIndexes[parseInt(i.toString(), 10)]].querySelectorAll(".e-cellselectionbackground:not(.e-hide)"));
                        this.getCopyData(cells, false, "	", withHeader);
                    }
                } else this.getCopyData([].slice.call(this.parent.element.getElementsByClassName("e-cellselectionbackground")), true, "\n", withHeader);
            }
            var args = {
                data: this.copyContent,
                cancel: false
            };
            this.parent.trigger($17b89d3b1fc93cdb$export$2e00246183f332a2, args);
            if (args.cancel) return;
            this.clipBoardTextArea.value = this.copyContent = args.data;
            if (!(0, $5q7BP.Browser).userAgent.match(/ipad|ipod|iphone/i)) this.clipBoardTextArea.select();
            else this.clipBoardTextArea.setSelectionRange(0, this.clipBoardTextArea.value.length);
            this.isSelect = true;
        }
    };
    Clipboard.prototype.getCopyData = function(cells, isCell, splitKey, withHeader) {
        var isElement = typeof cells[0] !== "string";
        for(var j = 0; j < cells.length; j++){
            if (withHeader && isCell) {
                var colIdx = parseInt(cells[parseInt(j.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
                this.copyContent += this.parent.getColumns()[parseInt(colIdx.toString(), 10)].headerText + "\n";
            }
            if (isElement) {
                if (!cells[parseInt(j.toString(), 10)].classList.contains("e-hide")) this.copyContent += cells[parseInt(j.toString(), 10)].innerText;
            } else this.copyContent += cells[parseInt(j.toString(), 10)];
            if (j < cells.length - 1) this.copyContent += splitKey;
        }
    };
    /**
     * Copy selected rows or cells data into clipboard.
     *
     * @returns {void}
     * @param {boolean} withHeader - Specifies whether the column header data need to be copied or not.
     */ Clipboard.prototype.copy = function(withHeader) {
        if (document.queryCommandSupported("copy") && this.clipBoardTextArea) {
            this.setCopyData(withHeader);
            document.execCommand("copy");
            this.clipBoardTextArea.blur();
        }
        if (this.isSelect) {
            window.getSelection().removeAllRanges();
            this.isSelect = false;
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Clipboard.prototype.getModuleName = function() {
        return "clipboard";
    };
    /**
     * To destroy the clipboard
     *
     * @returns {void}
     * @hidden
     */ Clipboard.prototype.destroy = function() {
        this.removeEventListener();
        if (this.clipBoardTextArea) {
            (0, $4ZDHT.remove)(this.clipBoardTextArea);
            this.clipBoardTextArea = null;
        }
    };
    Clipboard.prototype.checkBoxSelection = function() {
        var gridObj = this.parent;
        var obj = {
            status: false
        };
        if (gridObj.selectionSettings.mode === "Cell") {
            var rowCellIndxes = gridObj.getSelectedRowCellIndexes();
            var str = void 0;
            var rowIndexes = [];
            var i = void 0;
            for(i = 0; i < rowCellIndxes.length; i++){
                if (rowCellIndxes[parseInt(i.toString(), 10)].cellIndexes.length) rowIndexes.push(rowCellIndxes[parseInt(i.toString(), 10)].rowIndex);
                if (rowCellIndxes[parseInt(i.toString(), 10)].cellIndexes.length) {
                    if (!str) str = JSON.stringify(rowCellIndxes[parseInt(i.toString(), 10)].cellIndexes.sort());
                    if (str !== JSON.stringify(rowCellIndxes[parseInt(i.toString(), 10)].cellIndexes.sort())) break;
                }
            }
            rowIndexes.sort(function(a, b) {
                return a - b;
            });
            if (i === rowCellIndxes.length) obj = {
                status: true,
                rowIndexes: rowIndexes,
                colIndexes: rowCellIndxes[0].cellIndexes
            };
        }
        return obj;
    };
    return Clipboard;
}();


/**
 *
 * `Logger` class
 */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");

var $059246c685cae6e0$var$BASE_DOC_URL = "https://ej2.syncfusion.com/documentation/grid";
var $059246c685cae6e0$var$DOC_URL = "https://ej2.syncfusion.com/documentation/";
var $059246c685cae6e0$var$WARNING = "[EJ2Grid.Warning]";
var $059246c685cae6e0$var$ERROR = "[EJ2Grid.Error]";
var $059246c685cae6e0$var$INFO = "[EJ2Grid.Info]";
var $059246c685cae6e0$export$efa9a398d6368992 = /** @class */ function() {
    function Logger(parent) {
        this.parent = parent;
        this.parent.on("initial-end", this.patchadaptor, this);
    }
    Logger.prototype.getModuleName = function() {
        return "logger";
    };
    Logger.prototype.log = function(types, args) {
        if (!(types instanceof Array)) types = [
            types
        ];
        var type = types;
        for(var i = 0; i < type.length; i++){
            var item = $059246c685cae6e0$export$1a64b0694580a11b[type[parseInt(i.toString(), 10)]];
            var cOp = item.check(args, this.parent);
            if (cOp.success) // eslint-disable-next-line no-console
            console[item.logType](item.generateMessage(args, this.parent, cOp.options));
        }
    };
    Logger.prototype.patchadaptor = function() {
        var adaptor = this.parent.getDataModule().dataManager.adaptor;
        var original = adaptor.beforeSend;
        if (original) adaptor.beforeSend = function(dm, request, settings) {
            original.call(adaptor, dm, request, settings);
        };
    };
    Logger.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off("initial-end", this.patchadaptor);
    };
    return Logger;
}();
var $059246c685cae6e0$export$1a64b0694580a11b = {
    // eslint-disable-next-line camelcase
    module_missing: {
        type: "module_missing",
        logType: "warn",
        check: function(args, parent) {
            var injected = parent.getInjectedModules().map(function(m) {
                return m.prototype.getModuleName();
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var modules = parent.requiredModules().map(function(m) {
                return m.member;
            }).filter(function(name) {
                return injected.indexOf(name) === -1;
            });
            return {
                success: modules.filter(function(m) {
                    return m !== "resize";
                }).length > 0,
                options: modules
            };
        },
        generateMessage: function(args, parent, modules) {
            modules = modules.filter(function(m) {
                return m !== "resize";
            }).reduce(function(prev, cur) {
                return prev + ("* " + cur + "\n");
            }, "");
            return $059246c685cae6e0$var$WARNING + ": MODULES MISSING\n" + "The following modules are not injected:.\n" + ("" + modules) + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/module.html for documentation on importing feature modules.");
        }
    },
    // eslint-disable-next-line camelcase
    promise_enabled: {
        type: "promise_enabled",
        logType: "error",
        check: function() {
            return {
                success: typeof Promise === "undefined"
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$ERROR + ": PROMISE UNDEFINED\n" + "Promise object is not present in the global environment," + "please use polyfil to support Promise object in your environment.\n" + ("Refer to " + $059246c685cae6e0$var$DOC_URL + "/base/browser.html?#required-polyfills for more information.");
        }
    },
    // eslint-disable-next-line camelcase
    primary_column_missing: {
        type: "primary_column_missing",
        logType: "warn",
        check: function(args, parent) {
            return {
                success: parent.enableColumnVirtualization ? parent.getPrimaryKeyFieldNames().length === 0 : parent.getColumns().filter(function(column) {
                    return column.isPrimaryKey;
                }).length === 0
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$WARNING + ": PRIMARY KEY MISSING\n" + "Editing is enabled but primary key column is not specified.\n" + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/api-column.html?#isprimarykey for documentation on providing primary key columns.");
        }
    },
    // eslint-disable-next-line camelcase
    selection_key_missing: {
        type: "selection_key_missing",
        logType: "warn",
        check: function(args, parent) {
            return {
                success: parent.selectionSettings.persistSelection && parent.getColumns().filter(function(column) {
                    return column.isPrimaryKey;
                }).length === 0
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$WARNING + ": PRIMARY KEY MISSING\n" + "selectionSettings.persistSelection property is enabled. It requires one primary key column to persist selection.\n" + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/api-column.html?#isprimarykey for documentation on providing primary key columns.");
        }
    },
    actionfailure: {
        type: "actionfailure",
        logType: "error",
        check: function() {
            return {
                success: true
            };
        },
        generateMessage: function(args, parent) {
            var message = "";
            var formatError = $059246c685cae6e0$var$formatErrorHandler(args, parent);
            var ajaxError = $059246c685cae6e0$var$ajaxErrorHandler(args, parent);
            if (ajaxError !== "") message = ajaxError;
            else if (formatError !== "") message = formatError;
            else message = args.error;
            return $059246c685cae6e0$var$WARNING + ": " + message;
        }
    },
    // eslint-disable-next-line camelcase
    locale_missing: {
        type: "locale_missing",
        logType: "warn",
        check: function(args, parent) {
            var lObj = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject("locale." + parent.locale + ".grid", (0, $e7i2H.L10n));
            return {
                success: parent.locale !== "en-US" && (0, $3EnZW.isNullOrUndefined)(lObj)
            };
        },
        generateMessage: function(args, parent) {
            return $059246c685cae6e0$var$WARNING + ": LOCALE CONFIG MISSING\n" + ("Locale configuration for '" + parent.locale + "' is not provided.\n") + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/globalization-and-localization.html?#localization \n             for documentation on setting locale configuration.");
        }
    },
    limitation: {
        type: "limitation",
        logType: "warn",
        check: function(args, parent) {
            var name = args;
            var opt;
            switch(name){
                case "freeze":
                    opt = {
                        success: !(0, $3EnZW.isUndefined)(parent.detailTemplate) || !(0, $3EnZW.isUndefined)(parent.childGrid),
                        options: {
                            name: "freeze"
                        }
                    };
                    break;
                case "virtualization":
                    opt = {
                        success: !(0, $3EnZW.isUndefined)(parent.detailTemplate) || !(0, $3EnZW.isUndefined)(parent.childGrid),
                        options: {
                            name: "virtualization"
                        }
                    };
                    break;
                default:
                    opt = {
                        success: false
                    };
                    break;
            }
            return opt;
        },
        generateMessage: function(args, parent, options) {
            var name = options.name;
            var opt;
            switch(name){
                case "freeze":
                    opt = "Frozen rows and columns do not support the following features:\n* Details Template\n* Hierarchy Grid\n";
                    break;
                case "virtualization":
                    opt = "Virtualization does not support the following features.\n* Details Template.\n* Hierarchy Grid.\n";
                    break;
                default:
                    opt = "";
                    break;
            }
            return $059246c685cae6e0$var$WARNING + (": " + name.toUpperCase() + " LIMITATIONS\n") + opt;
        }
    },
    // eslint-disable-next-line camelcase
    check_datasource_columns: {
        type: "check_datasource_columns",
        logType: "warn",
        check: function(args, parent) {
            return {
                success: !(parent.columns.length || parent.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) || !(0, $3EnZW.isNullOrUndefined)(parent.dataSource) && parent.dataSource.length)
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$WARNING + ": GRID CONFIG MISSING\n" + "dataSource and columns are not provided in the grid. " + "At least one of either must be provided for grid configuration.\n" + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/columns.html for documentation on configuring the grid data and columns.");
        }
    },
    // eslint-disable-next-line camelcase
    virtual_height: {
        type: "virtual_height",
        logType: "error",
        check: function(args, parent) {
            return {
                success: (0, $3EnZW.isNullOrUndefined)(parent.height) || parent.height === "auto"
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$ERROR + ": GRID HEIGHT MISSING \n" + "height property is required to use virtualization.\n" + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/virtual.html for documentation on configuring the virtual grid.");
        }
    },
    // eslint-disable-next-line camelcase
    grid_remote_edit: {
        type: "grid_remote_edit",
        logType: "error",
        check: function(args) {
            return {
                success: Array.isArray(args) || Array.isArray(args.result)
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$ERROR + ": RETRUN VALUE MISSING  \n" + "Remote service returns invalid data. \n" + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/edit.html for documentation on configuring editing with remote data.");
        }
    },
    // eslint-disable-next-line camelcase
    grid_sort_comparer: {
        type: "grid_sort_comparer",
        logType: "warn",
        check: function(args, parent) {
            return {
                success: parent.getDataModule().isRemote()
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$WARNING + ": SORT COMPARER NOT WORKING  \n" + "Sort comparer will not work with remote data." + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/sorting/#custom-sort-comparer for documentation on using the sort comparer.");
        }
    },
    // eslint-disable-next-line camelcase
    resize_min_max: {
        type: "resize_min_max",
        logType: "info",
        check: function(args) {
            return {
                success: args.column.minWidth && args.column.minWidth >= args.width || args.column.maxWidth && args.column.maxWidth <= args.width
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$INFO + ": RESIZING COLUMN REACHED MIN OR MAX  \n" + "The column resizing width is at its min or max.";
        }
    },
    // eslint-disable-next-line camelcase
    action_disabled_column: {
        type: "action_disabled_column",
        logType: "info",
        check: function(args) {
            var success = true;
            var fn;
            switch(args.moduleName){
                case "reorder":
                    if ((0, $3EnZW.isNullOrUndefined)(args.destColumn)) fn = "reordering action is disabled for the " + args.column.headerText + " column";
                    else fn = "reordering action is disabled for the " + (args.column.allowReordering ? args.destColumn.headerText : args.column.headerText) + " column";
                    break;
                case "group":
                    fn = "grouping action is disabled for the " + args.columnName + " column.";
                    break;
                case "filter":
                    fn = "filtering action is disabled for the " + args.columnName + " column.";
                    break;
                case "sort":
                    fn = "sorting action is disabled for the " + args.columnName + " column.";
                    break;
            }
            return {
                success: success,
                options: {
                    fn: fn
                }
            };
        },
        generateMessage: function(args, parent, options) {
            return $059246c685cae6e0$var$INFO + (": ACTION DISABLED \n " + options.fn);
        }
    },
    // eslint-disable-next-line camelcase
    exporting_begin: {
        type: "exporting_begin",
        logType: "info",
        check: function(args) {
            return {
                success: true,
                options: {
                    args: args
                }
            };
        },
        generateMessage: function(args, parent, options) {
            return $059246c685cae6e0$var$INFO + (": EXPORTING INPROGRESS \n Grid " + options.args + "ing is in progress");
        }
    },
    // eslint-disable-next-line camelcase
    exporting_complete: {
        type: "exporting_complete",
        logType: "info",
        check: function(args) {
            return {
                success: true,
                options: {
                    args: args
                }
            };
        },
        generateMessage: function(args, parent, options) {
            return $059246c685cae6e0$var$INFO + (": EXPORTING COMPLETED \n Grid " + options.args + "ing is complete");
        }
    },
    // eslint-disable-next-line camelcase
    foreign_key_failure: {
        type: "foreign_key_failure",
        logType: "error",
        check: function() {
            return {
                success: true
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$ERROR + ": FOREIGNKEY CONFIG \n  Grid foreign key column needs a valid data source/service." + ("Refer to " + $059246c685cae6e0$var$BASE_DOC_URL + "/columns/#foreign-key-column for documentation on configuring foreign key columns.");
        }
    },
    // eslint-disable-next-line camelcase
    initial_action: {
        type: "initial_action",
        logType: "error",
        check: function(args) {
            var success = true;
            var fn;
            switch(args.moduleName){
                case "group":
                    fn = "The " + args.columnName + " column is not available in the grid's column model." + "Please provide a valid field name to group the column";
                    break;
                case "filter":
                    fn = "The " + args.columnName + " column is not available in the grid's column model." + "Please provide a valid field name to filter the column.";
                    break;
                case "sort":
                    fn = "The " + args.columnName + " column is not available in the grid's column model." + "Please provide a valid field name to sort the column.";
                    break;
            }
            return {
                success: success,
                options: {
                    fn: fn
                }
            };
        },
        generateMessage: function(args, parent, options) {
            return $059246c685cae6e0$var$ERROR + (": INITIAL ACTION FAILURE \n " + options.fn);
        }
    },
    // eslint-disable-next-line camelcase
    frozen_rows_columns: {
        type: "frozen_rows_columns",
        logType: "error",
        check: function(args, parent) {
            return {
                success: parent.getColumns().length <= parent.frozenColumns || parent.currentViewData.length && parent.frozenRows >= parent.currentViewData.length
            };
        },
        generateMessage: function(args, parent) {
            return $059246c685cae6e0$var$ERROR + (": OUT OF RANGE ERROR-\n " + (parent.getColumns().length <= parent.frozenColumns ? "FROZEN COLUMNS," : "")) + ((parent.frozenRows >= parent.currentViewData.length ? "FROZEN ROWS" : "") + " invalid");
        }
    },
    // eslint-disable-next-line camelcase
    column_type_missing: {
        type: "column_type_missing",
        logType: "error",
        check: function(args) {
            return {
                success: (0, $3EnZW.isNullOrUndefined)(args.column.type),
                options: args.column.headerText
            };
        },
        generateMessage: function(args, parent, options) {
            return $059246c685cae6e0$var$ERROR + (": COLUMN TYPE MISSING-\n  " + options + " column type was invalid or not defined.") + ("Please go through below help link: " + $059246c685cae6e0$var$DOC_URL + "/grid/columns/#column-type");
        }
    },
    // eslint-disable-next-line camelcase
    datasource_syntax_mismatch: {
        type: "datasource_syntax_mismatch",
        logType: "warn",
        check: function(args) {
            return {
                success: args.dataState.dataSource && !(args.dataState.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) || "result" in args.dataState.dataSource || args.dataState.dataSource instanceof Array) && !(0, $3EnZW.isNullOrUndefined)(args.dataState.dataStateChange)
            };
        },
        generateMessage: function() {
            return $059246c685cae6e0$var$WARNING + ": DATASOURCE SYNTAX WARNING\n" + "DataSource should be in the form of {result: Object[], count: number}" + "when dataStateChangeEvent used";
        }
    }
};
var $059246c685cae6e0$var$formatErrorHandler = function(args) {
    var error = args.error;
    if (error.indexOf && error.indexOf("Format options") !== 0) return "";
    return "INVALID FORMAT\nFor more information, refer to the following documentation links:\n" + ("Number format: " + $059246c685cae6e0$var$DOC_URL + "/common/internationalization#supported-format-string\n") + ("Date format: " + $059246c685cae6e0$var$DOC_URL + "/common/internationalization#manipulating-datetime\n") + ("Message: " + error);
};
var $059246c685cae6e0$var$ajaxErrorHandler = function(args) {
    var error = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject("error.error", args);
    if ((0, $3EnZW.isNullOrUndefined)(error)) return "";
    var jsonResult = "";
    try {
        jsonResult = JSON.parse(error.responseText);
    } catch (_a) {
        jsonResult = "";
    }
    return "XMLHTTPREQUEST FAILED\n" + ("Url: " + error.responseURL + "\n") + ("Status: " + error.status + " - " + error.statusText + "\n") + ("" + (jsonResult !== "" ? "Message: " + jsonResult : ""));
};





var $503c118799028775$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $503c118799028775$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Represents the field name and direction of sort column.
 */ var $503c118799028775$export$8df77f7e50eac21b = /** @class */ function(_super) {
    $503c118799028775$var$__extends(SortDescriptor, _super);
    function SortDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], SortDescriptor.prototype, "field", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], SortDescriptor.prototype, "direction", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SortDescriptor.prototype, "isFromGroup", void 0);
    return SortDescriptor;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the sorting behavior of Grid.
 */ var $503c118799028775$export$28c72d0529782de = /** @class */ function(_super) {
    $503c118799028775$var$__extends(SortSettings, _super);
    function SortSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Collection)([], $503c118799028775$export$8df77f7e50eac21b)
    ], SortSettings.prototype, "columns", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SortSettings.prototype, "allowUnsort", void 0);
    return SortSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Represents the predicate for the filter column.
 */ var $503c118799028775$export$7ce636318c5a9f17 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(Predicate, _super);
    function Predicate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "field", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "operator", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "value", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "matchCase", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Predicate.prototype, "ignoreAccent", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "predicate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)({})
    ], Predicate.prototype, "actualFilterValue", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)({})
    ], Predicate.prototype, "actualOperator", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "type", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "ejpredicate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "uid", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "isForeignKey", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Predicate.prototype, "condition", void 0);
    return Predicate;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the infinite scroll behavior of Grid.
 */ var $503c118799028775$export$4fe2fce573ada070 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(InfiniteScrollSettings, _super);
    function InfiniteScrollSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], InfiniteScrollSettings.prototype, "enableCache", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], InfiniteScrollSettings.prototype, "maxBlocks", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], InfiniteScrollSettings.prototype, "initialBlocks", void 0);
    return InfiniteScrollSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the filtering behavior of the Grid.
 */ var $503c118799028775$export$9fa85cf4a9b19444 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(FilterSettings, _super);
    function FilterSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Collection)([], $503c118799028775$export$7ce636318c5a9f17)
    ], FilterSettings.prototype, "columns", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("FilterBar")
    ], FilterSettings.prototype, "type", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("OnEnter")
    ], FilterSettings.prototype, "mode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FilterSettings.prototype, "showFilterBarStatus", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(1500)
    ], FilterSettings.prototype, "immediateModeDelay", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], FilterSettings.prototype, "operators", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FilterSettings.prototype, "ignoreAccent", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FilterSettings.prototype, "enableInfiniteScrolling", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(50)
    ], FilterSettings.prototype, "itemsCount", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Shimmer")
    ], FilterSettings.prototype, "loadingIndicator", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FilterSettings.prototype, "enableCaseSensitivity", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FilterSettings.prototype, "showFilterBarOperator", void 0);
    return FilterSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the selection behavior of the Grid.
 */ var $503c118799028775$export$771166eca748644a = /** @class */ function(_super) {
    $503c118799028775$var$__extends(SelectionSettings, _super);
    function SelectionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Row")
    ], SelectionSettings.prototype, "mode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Flow")
    ], SelectionSettings.prototype, "cellSelectionMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Single")
    ], SelectionSettings.prototype, "type", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SelectionSettings.prototype, "checkboxOnly", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SelectionSettings.prototype, "persistSelection", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Default")
    ], SelectionSettings.prototype, "checkboxMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SelectionSettings.prototype, "enableSimpleMultiRowSelection", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SelectionSettings.prototype, "enableToggle", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SelectionSettings.prototype, "allowColumnSelection", void 0);
    return SelectionSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the search behavior of the Grid.
 */ var $503c118799028775$export$352475af1e1a6201 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(SearchSettings, _super);
    function SearchSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)([])
    ], SearchSettings.prototype, "fields", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SearchSettings.prototype, "key", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("contains")
    ], SearchSettings.prototype, "operator", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SearchSettings.prototype, "ignoreCase", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SearchSettings.prototype, "ignoreAccent", void 0);
    return SearchSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the row drop settings of the Grid.
 */ var $503c118799028775$export$4972d1402d3d782b = /** @class */ function(_super) {
    $503c118799028775$var$__extends(RowDropSettings, _super);
    function RowDropSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], RowDropSettings.prototype, "targetID", void 0);
    return RowDropSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the text wrap settings of the Grid.
 */ var $503c118799028775$export$4fd0f6c72cc1b945 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(TextWrapSettings, _super);
    function TextWrapSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], TextWrapSettings.prototype, "wrapMode", void 0);
    return TextWrapSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the resize behavior of the Grid.
 */ var $503c118799028775$export$c9afda34c579f960 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(ResizeSettings, _super);
    function ResizeSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], ResizeSettings.prototype, "mode", void 0);
    return ResizeSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the group behavior of the Grid.
 */ var $503c118799028775$export$7756bc8dbeb9ec70 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(GroupSettings, _super);
    function GroupSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], GroupSettings.prototype, "showDropArea", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], GroupSettings.prototype, "allowReordering", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], GroupSettings.prototype, "showToggleButton", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], GroupSettings.prototype, "showGroupedColumn", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], GroupSettings.prototype, "showUngroupButton", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], GroupSettings.prototype, "disablePageWiseAggregates", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)([])
    ], GroupSettings.prototype, "columns", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], GroupSettings.prototype, "captionTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], GroupSettings.prototype, "enableLazyLoading", void 0);
    return GroupSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the edit behavior of the Grid.
 */ var $503c118799028775$export$55fd657a92ecd4ad = /** @class */ function(_super) {
    $503c118799028775$var$__extends(EditSettings, _super);
    function EditSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "allowAdding", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "allowEditing", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "allowDeleting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], EditSettings.prototype, "mode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], EditSettings.prototype, "allowEditOnDblClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], EditSettings.prototype, "showConfirmDialog", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "showDeleteConfirmDialog", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], EditSettings.prototype, "template", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], EditSettings.prototype, "headerTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], EditSettings.prototype, "footerTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Top")
    ], EditSettings.prototype, "newRowPosition", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)({})
    ], EditSettings.prototype, "dialog", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "allowNextRowEdit", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], EditSettings.prototype, "showAddNewRow", void 0);
    return EditSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the Loading Indicator of the Grid.
 */ var $503c118799028775$export$7c20be4c1d342248 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Spinner")
    ], LoadingIndicator.prototype, "indicatorType", void 0);
    return LoadingIndicator;
}((0, $3fcxu.ChildProperty));
/**
 * Represents the Grid component.
 * ```html
 * <div id="grid"></div>
 * <script>
 *  var gridObj = new Grid({ allowPaging: true });
 *  gridObj.appendTo("#grid");
 * </script>
 * ```
 */ var $503c118799028775$export$ef2184bd89960b14 = /** @class */ function(_super) {
    $503c118799028775$var$__extends(Grid, _super);
    /**
     * Constructor for creating the component
     *
     * @param {GridModel} options - specifies the options
     * @param {string | HTMLElement} element - specifies the element
     * @hidden
     */ function Grid(options, element) {
        var _this_1 = _super.call(this, options, element) || this;
        _this_1.isPreventScrollEvent = false;
        _this_1.inViewIndexes = [];
        _this_1.keyA = false;
        _this_1.frozenRightCount = 0;
        _this_1.freezeColumnRefresh = true;
        _this_1.rightcount = 0;
        _this_1.frozenLeftCount = 0;
        _this_1.leftcount = 0;
        _this_1.tablesCount = 1;
        _this_1.movableCount = 0;
        _this_1.movablecount = 0;
        _this_1.fixedcount = 0;
        _this_1.fixedCount = 0;
        _this_1.visibleFrozenLeft = 0;
        _this_1.visibleFrozenFixed = 0;
        _this_1.isPreparedFrozenColumns = false;
        _this_1.visibleFrozenRight = 0;
        _this_1.visibleMovable = 0;
        _this_1.frozenLeftColumns = [];
        _this_1.frozenRightColumns = [];
        _this_1.movableColumns = [];
        _this_1.fixedColumns = [];
        _this_1.stackedLeft = [];
        _this_1.stackedRight = [];
        _this_1.stackedFixed = [];
        _this_1.stackedMovable = [];
        _this_1.stackedarrayLeft = [];
        _this_1.stackedarrayRight = [];
        _this_1.stackedarrayFixed = [];
        _this_1.stackedarrayMovable = [];
        _this_1.media = {};
        _this_1.autoFitColumnsResize = false;
        /** @hidden */ _this_1.tableIndex = 0;
        _this_1.componentRefresh = (0, $hQxLN.Component).prototype.refresh;
        _this_1.isChangeDataSourceCall = false;
        _this_1.mergedColumns = false;
        /** @hidden */ _this_1.isVirtualAdaptive = false;
        /** @hidden */ /**
         * * If `requireTemplateRef` is set to false in the load event, then the template element can't be accessed in grid queryCellInfo, and rowDataBound events.
         * * By default, React's grid queryCellInfo and rowDataBound events allow access to the template element.
         * * Avoid accessing the template elements in the grid queryCellInfo and rowDataBound events to improve rendering performance by setting this value as false.
         *
         * @default true
         */ _this_1.requireTemplateRef = true;
        /** @hidden */ _this_1.vRows = [];
        /** @hidden */ _this_1.vcRows = [];
        /** @hidden */ _this_1.vGroupOffsets = {};
        /** @hidden */ _this_1.rowUid = 0;
        /** @hidden */ _this_1.translateX = 0;
        /** @hidden */ _this_1.isManualRefresh = false;
        /** @hidden */ _this_1.isAutoFitColumns = false;
        /** @hidden */ _this_1.enableDeepCompare = false;
        /** @hidden */ _this_1.totalDataRecordsCount = 0;
        /** @hidden */ _this_1.disableSelectedRecords = [];
        /** @hidden */ _this_1.partialSelectedRecords = [];
        /** @hidden */ _this_1.isSpan = false;
        /** @hidden */ _this_1.islazyloadRequest = false;
        /** @hidden */ _this_1.isAddNewRow = false;
        /** @hidden */ _this_1.addNewRowFocus = true;
        /** @hidden */ _this_1.lockcolPositionCount = 0;
        /** @hidden */ _this_1.prevPageMoving = false;
        /** @hidden */ _this_1.pageTemplateChange = false;
        /** @hidden */ _this_1.isAutoGen = false;
        /** @hidden */ _this_1.isAutoGenerateColumns = false;
        /** @hidden */ _this_1.pageRequireRefresh = true;
        _this_1.mediaBindInstance = {};
        /** @hidden */ _this_1.commandDelIndex = undefined;
        /** @hidden */ _this_1.asyncTimeOut = 50;
        /** @hidden */ _this_1.isExportGrid = false;
        /** @hidden */ _this_1.isWidgetsDestroyed = false;
        _this_1.enableLogger = false;
        _this_1.needsID = true;
        Grid_1.Inject((0, $f156c0a94af14ffc$export$52baac22726c72bf));
        (0, $3EnZW.setValue)("mergePersistData", _this_1.mergePersistGridData, _this_1);
        return _this_1;
    }
    Grid_1 = Grid;
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} returns the persist data
     */ Grid.prototype.getPersistData = function() {
        var keyEntity = [
            "pageSettings",
            "sortSettings",
            "filterSettings",
            "groupSettings",
            "columns",
            "searchSettings",
            "selectedRowIndex",
            "scrollPosition"
        ];
        var ignoreOnPersist = {
            pageSettings: [
                "template",
                "pageSizes",
                "enableQueryString",
                "totalRecordsCount",
                "pageCount"
            ],
            filterSettings: [
                "type",
                "mode",
                "showFilterBarStatus",
                "immediateModeDelay",
                "ignoreAccent"
            ],
            groupSettings: [
                "showDropArea",
                "showToggleButton",
                "showGroupedColumn",
                "showUngroupButton",
                "disablePageWiseAggregates",
                "hideCaptionCount"
            ],
            searchSettings: [
                "fields",
                "operator",
                "ignoreCase"
            ],
            sortSettings: [],
            columns: [],
            selectedRowIndex: [],
            scrollPosition: []
        };
        for(var i = 0; i < keyEntity.length; i++){
            var currentObject = this[keyEntity[parseInt(i.toString(), 10)]];
            for(var _i = 0, _a = ignoreOnPersist[keyEntity[parseInt(i.toString(), 10)]]; _i < _a.length; _i++){
                var val = _a[_i];
                delete currentObject["" + val];
            }
        }
        var temp = this.pageSettings.template;
        var settings = Object.assign({
            template: undefined
        }, this.pageSettings);
        this.setProperties({
            pageSettings: settings
        }, true);
        var captionTemplateRef = this.groupSettings.captionTemplate;
        var isAngularCaptionTemplate = captionTemplateRef && this.isAngular;
        if (isAngularCaptionTemplate) delete this.groupSettings["properties"]["captionTemplate"];
        this.pageTemplateChange = !(0, $3EnZW.isNullOrUndefined)(this.pagerTemplate);
        var persistData = this.addOnPersist(keyEntity);
        settings.template = temp;
        this.setProperties({
            pageSettings: settings
        }, true);
        if (isAngularCaptionTemplate) this.groupSettings.captionTemplate = captionTemplateRef;
        return persistData;
    };
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} Returns the module Declaration
     * @hidden
     */ Grid.prototype.requiredModules = function() {
        this.setFrozenCount();
        this.enableInfiniteAggrgate();
        var modules = [];
        if (this.isDestroyed) return modules;
        if (this.allowFiltering) modules.push({
            member: "filter",
            args: [
                this,
                this.filterSettings,
                this.serviceLocator
            ],
            name: "Filter"
        });
        if (this.allowExcelExport) modules.push({
            member: "ExcelExport",
            args: [
                this,
                this.serviceLocator
            ],
            name: "ExcelExport"
        });
        if (this.allowPdfExport) modules.push({
            member: "PdfExport",
            args: [
                this
            ],
            name: "PdfExport"
        });
        if (this.allowSorting) modules.push({
            member: "sort",
            args: [
                this,
                this.sortSettings,
                this.sortedColumns,
                this.serviceLocator
            ],
            name: "Sort"
        });
        if (this.allowPaging) modules.push({
            member: "pager",
            args: [
                this,
                this.pageSettings
            ],
            name: "Page"
        });
        if (this.allowSelection) modules.push({
            member: "selection",
            args: [
                this,
                this.selectionSettings,
                this.serviceLocator
            ],
            name: "Selection"
        });
        if (this.resizeCheck()) modules.push({
            member: "resize",
            args: [
                this
            ],
            name: "Resize"
        });
        if (this.allowReordering) modules.push({
            member: "reorder",
            args: [
                this
            ],
            name: "Reorder"
        });
        if (this.allowRowDragAndDrop) modules.push({
            member: "rowDragAndDrop",
            args: [
                this
            ],
            name: "RowDD"
        });
        if (this.allowGrouping) modules.push({
            member: "group",
            args: [
                this,
                this.groupSettings,
                this.sortedColumns,
                this.serviceLocator
            ],
            name: "Group"
        });
        if (this.aggregates.length) modules.push({
            member: "aggregate",
            args: [
                this,
                this.serviceLocator
            ],
            name: "Aggregate"
        });
        if (this.isDetail()) modules.push({
            member: "detailRow",
            args: [
                this,
                this.serviceLocator
            ],
            name: "DetailRow"
        });
        if (this.toolbar || this.toolbarTemplate) modules.push({
            member: "toolbar",
            args: [
                this,
                this.serviceLocator
            ],
            name: "Toolbar"
        });
        if (this.enableVirtualization || this.enableColumnVirtualization) modules.push({
            member: "virtualscroll",
            args: [
                this,
                this.serviceLocator
            ],
            name: "VirtualScroll"
        });
        if (this.getFrozenColumns() || this.frozenRows || this.frozenRightCount || this.frozenLeftCount) modules.push({
            member: "freeze",
            args: [
                this,
                this.serviceLocator
            ],
            name: "Freeze"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.columns) && this.isCommandColumn(this.columns)) modules.push({
            member: "commandColumn",
            args: [
                this,
                this.serviceLocator
            ],
            name: "CommandColumn"
        });
        if (this.editSettings.allowAdding || this.editSettings.allowDeleting || this.editSettings.allowEditing) modules.push({
            member: "edit",
            args: [
                this,
                this.serviceLocator
            ],
            name: "Edit"
        });
        this.extendRequiredModules(modules);
        return modules;
    };
    Grid.prototype.extendRequiredModules = function(modules) {
        if (this.enableInfiniteScrolling) modules.push({
            member: "infiniteScroll",
            args: [
                this,
                this.serviceLocator
            ],
            name: "InfiniteScroll"
        });
        if (this.groupSettings.enableLazyLoading) modules.push({
            member: "lazyLoadGroup",
            args: [
                this,
                this.serviceLocator
            ],
            name: "LazyLoadGroup"
        });
        if (this.contextMenuItems) modules.push({
            member: "contextMenu",
            args: [
                this,
                this.serviceLocator
            ],
            name: "ContextMenu"
        });
        if (this.showColumnMenu) modules.push({
            member: "columnMenu",
            args: [
                this,
                this.serviceLocator
            ],
            name: "ColumnMenu"
        });
        if (this.showColumnChooser) modules.push({
            member: "columnChooser",
            args: [
                this,
                this.serviceLocator
            ],
            name: "ColumnChooser"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.columns) && this.isForeignKeyEnabled(this.columns)) modules.push({
            member: "foreignKey",
            args: [
                this,
                this.serviceLocator
            ],
            name: "ForeignKey"
        });
        if (this.enableLogger) modules.push({
            member: "logger",
            args: [
                this
            ],
            name: "Logger"
        });
    };
    Grid.prototype.resizeCheck = function() {
        var autoFitColumns = this.getColumns().filter(function(c) {
            return c.autoFit === true;
        }).length ? true : false;
        if (!(0, $3EnZW.isNullOrUndefined)(this.columnModel) && this.columnModel.length && !(this.columnModel[0] instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc))) this.columnModel = [];
        var columnMenu = this.showColumnMenu && (!this.columnMenuItems || this.columnMenuItems.filter(function(c) {
            return c === "AutoFit" || c === "AutoFitAll";
        }).length) ? true : false;
        var contextMenu = this.contextMenuItems && this.contextMenuItems.filter(function(c) {
            return c === "AutoFit" || c === "AutoFitAll";
        }).length ? true : false;
        return this.allowResizing || this.autoFitColumnsResize || autoFitColumns || columnMenu || contextMenu;
    };
    /**
     * For internal use only - Initialize the event handler;
     *
     * @returns {void}
     * @private
     */ Grid.prototype.preRender = function() {
        this.serviceLocator = new (0, $be04f19d782f3472$export$6cd6e3ed1512e78f);
        this.initProperties();
        this.initializeServices();
    };
    Grid.prototype.initProperties = function() {
        this.isInitial = true;
        this.sortedColumns = [];
        this.inViewIndexes = [];
        this.mediaCol = [];
        this.isInitialLoad = false;
        this.allowServerDataBinding = false;
        this.ignoreCollectionWatch = true;
        this.mergeCells = {};
        this.isEdit = false;
        this.checkAllRows = "None";
        this.isCheckBoxSelection = false;
        this.isPersistSelection = false;
        this.componentRefresh = (0, $hQxLN.Component).prototype.refresh;
        this.freezeColumnRefresh = true;
        this.filterOperators = {
            contains: "contains",
            endsWith: "endswith",
            equal: "equal",
            greaterThan: "greaterthan",
            greaterThanOrEqual: "greaterthanorequal",
            lessThan: "lessthan",
            lessThanOrEqual: "lessthanorequal",
            notEqual: "notequal",
            startsWith: "startswith",
            wildCard: "wildcard",
            isNull: "isnull",
            notNull: "notnull",
            like: "like"
        };
        this.defaultLocale = {
            EmptyRecord: "No records to display",
            True: "true",
            False: "false",
            InvalidFilterMessage: "Invalid Filter Data",
            GroupDropArea: "Drag a column header here to group its column",
            UnGroup: "Click here to ungroup",
            UnGroupButton: "Click here to ungroup",
            GroupDisable: "Grouping is disabled for this column",
            FilterbarTitle: "'s filter bar cell",
            EmptyDataSourceError: "DataSource must not be empty at initial load since columns are generated from dataSource in AutoGenerate Column Grid",
            // Toolbar Items
            Add: "Add",
            Edit: "Edit",
            Cancel: "Cancel",
            Update: "Update",
            Delete: "Delete",
            Print: "Print",
            Pdfexport: "PDF Export",
            Excelexport: "Excel Export",
            Wordexport: "Word Export",
            Csvexport: "CSV Export",
            Search: "Search",
            Columnchooser: "Columns",
            Save: "Save",
            Item: "item",
            Items: "items",
            EditOperationAlert: "No records selected for edit operation",
            DeleteOperationAlert: "No records selected for delete operation",
            SaveButton: "Save",
            OKButton: "OK",
            CancelButton: "Cancel",
            EditFormTitle: "Details of ",
            AddFormTitle: "Add New Record",
            BatchSaveConfirm: "Are you sure you want to save changes?",
            BatchSaveLostChanges: "Unsaved changes will be lost. Are you sure you want to continue?",
            ConfirmDelete: "Are you sure you want to Delete Record?",
            CancelEdit: "Are you sure you want to Cancel the changes?",
            ChooseColumns: "Choose Column",
            ColumnMenu: "Column Menu",
            SearchColumns: "search columns",
            Matchs: "No matches found",
            FilterButton: "Filter",
            FilterTitle: "Filter",
            FilterIcon: "Filter",
            ClearButton: "Clear",
            StartsWith: "Starts With",
            NotStartsWith: "Does Not Start With",
            Like: "Like",
            EndsWith: "Ends With",
            NotEndsWith: "Does Not End With",
            Contains: "Contains",
            NotContains: "Does Not Contain",
            IsNull: "Null",
            NotNull: "Not Null",
            IsEmpty: "Empty",
            IsNotEmpty: "Not Empty",
            Equal: "Equal",
            NotEqual: "Not Equal",
            LessThan: "Less Than",
            LessThanOrEqual: "Less Than Or Equal",
            GreaterThan: "Greater Than",
            GreaterThanOrEqual: "Greater Than Or Equal",
            ChooseDate: "Choose a Date",
            EnterValue: "Enter the value",
            Copy: "Copy",
            Group: "Group by this column",
            Ungroup: "Ungroup by this column",
            GroupButton: "Group button",
            UnGroupAria: "ungroup button",
            GroupSeperator: "Separator for the grouped columns",
            UnGroupIcon: "ungroup the grouped column ",
            GroupedSortIcon: "sort the grouped column ",
            GroupedDrag: "Drag the grouped column",
            GroupCaption: " is groupcaption cell",
            CheckBoxLabel: "checkbox",
            SelectAllCheckbox: "Select all checkbox",
            SelectRow: "Select row",
            autoFitAll: "Autofit all columns",
            autoFit: "Autofit this column",
            AutoFitAll: "Autofit all columns",
            AutoFit: "Autofit this column",
            Export: "Export",
            FirstPage: "First Page",
            LastPage: "Last Page",
            PreviousPage: "Previous Page",
            NextPage: "Next Page",
            SortAscending: "Sort Ascending",
            SortDescending: "Sort Descending",
            EditRecord: "Edit Record",
            DeleteRecord: "Delete Record",
            FilterMenu: "Filter",
            SelectAll: "Select All",
            AddCurrentSelection: "Add current selection to filter",
            Blanks: "Blanks",
            FilterTrue: "True",
            FilterFalse: "False",
            NoResult: "No matches found",
            ClearFilter: "Clear Filter",
            Clear: "Clear",
            NumberFilter: "Number Filters",
            TextFilter: "Text Filters",
            DateFilter: "Date Filters",
            DateTimeFilter: "DateTime Filters",
            MatchCase: "Match Case",
            Between: "Between",
            CustomFilter: "Custom Filter",
            CustomFilterPlaceHolder: "Enter the value",
            CustomFilterDatePlaceHolder: "Choose a date",
            AND: "AND",
            OR: "OR",
            ShowRowsWhere: "Show rows where:",
            ToolbarMenuDialogARIA: "Toolbar menu dialog",
            FilterMenuDialogARIA: "Filter menu",
            ExcelFilterDialogARIA: "Excel filter",
            CheckBoxFilterDialogARIA: "Checkbox filter",
            DialogEditARIA: "Edit dialog",
            ColumnMenuDialogARIA: "Column menu dialog",
            CustomFilterDialogARIA: "Customer filter dialog",
            SortAtoZ: "Sort A to Z",
            SortZtoA: "Sort Z to A",
            SortByOldest: "Sort by Oldest",
            SortByNewest: "Sort by Newest",
            SortSmallestToLargest: "Sort Smallest to Largest",
            SortLargestToSmallest: "Sort Largest to Smallest",
            Sort: "Sort",
            SortIcon: "Sort",
            FilterDescription: "Press Alt Down to open filter Menu",
            SortDescription: "Press Enter to sort",
            ColumnMenuDescription: "Press Alt Down to open Column Menu",
            GroupDescription: "Press Ctrl space to group",
            ColumnHeader: " column header ",
            TemplateCell: " is template cell",
            CommandColumnAria: "is Command column column header ",
            DialogEdit: "Dialog edit",
            ClipBoard: "clipboard",
            AscendingText: "Ascending",
            DescendingText: "Descending",
            NoneText: "None",
            Expanded: "Expanded",
            Collapsed: "Collapsed"
        };
        this.keyConfigs = {
            downArrow: "downarrow",
            upArrow: "uparrow",
            rightArrow: "rightarrow",
            leftArrow: "leftarrow",
            shiftDown: "shift+downarrow",
            shiftUp: "shift+uparrow",
            shiftRight: "shift+rightarrow",
            shiftLeft: "shift+leftarrow",
            home: "home",
            end: "end",
            escape: "escape",
            ctrlHome: "ctrl+home",
            ctrlEnd: "ctrl+end",
            pageUp: "pageup",
            pageDown: "pagedown",
            ctrlAltPageUp: "ctrl+alt+pageup",
            ctrlAltPageDown: "ctrl+alt+pagedown",
            altPageUp: "alt+pageup",
            altPageDown: "alt+pagedown",
            altDownArrow: "alt+downarrow",
            altUpArrow: "alt+uparrow",
            ctrlDownArrow: "ctrl+downarrow",
            ctrlUpArrow: "ctrl+uparrow",
            ctrlPlusA: "ctrl+A",
            ctrlPlusP: "ctrl+P",
            insert: "insert",
            delete: "delete",
            f2: "f2",
            enter: "enter",
            ctrlEnter: "ctrl+enter",
            shiftEnter: "shift+enter",
            tab: "tab",
            shiftTab: "shift+tab",
            space: "space",
            ctrlPlusC: "ctrl+C",
            ctrlShiftPlusH: "ctrl+shift+H",
            ctrlSpace: "ctrl+space",
            ctrlLeftArrow: "ctrl+leftarrow",
            ctrlRightArrow: "ctrl+rightarrow"
        };
    };
    /**
     * For internal use only - To Initialize the component rendering.
     *
     * @returns {void}
     * @private
     */ Grid.prototype.render = function() {
        this.log([
            "module_missing",
            "promise_enabled",
            "locale_missing",
            "check_datasource_columns"
        ]);
        this.ariaService.setOptions(this.element, {
            role: "grid"
        });
        (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
            target: this.element,
            cssClass: this.cssClass ? this.cssClass : null
        }, this.createElement);
        this.renderModule = new (0, $f586be72c61d2967$export$160ae30d75f98247)(this, this.serviceLocator);
        this.searchModule = new (0, $1c44575f41b05087$export$4b85d3515bd863a5)(this);
        this.scrollModule = new (0, $479ae25f4fbe2186$export$6ed4a4084f55ee7c)(this);
        this.notify($17b89d3b1fc93cdb$export$b70fe0c8c3456154, {});
        if (this.pageSettings.enableQueryString) {
            var pageValue = new URL(window.location.href).searchParams.get("page");
            if (!(0, $3EnZW.isNullOrUndefined)(pageValue) && window.location.href.indexOf("?page=") > 0) {
                var currentPageValue = parseInt(pageValue, 10);
                this.setProperties({
                    pageSettings: {
                        currentPage: currentPageValue
                    }
                }, true);
                this.pageSettings.currentPage = currentPageValue;
            }
        }
        if ((this.getDataModule().dataManager.dataSource.offline === true || this.getDataModule().dataManager.dataSource.url === undefined) && !(!(0, $3EnZW.isNullOrUndefined)(this.dataSource) && this.dataSource.result)) this.isVirtualAdaptive = true;
        if (this.aggregateModule && this.aggregates.length) {
            for(var i = 0; i < this.aggregates.length; i++)for(var j = 0; j < this.aggregates[parseInt(i.toString(), 10)].columns.length; j++){
                var column = this.aggregates[parseInt(i.toString(), 10)].columns[parseInt(j.toString(), 10)];
                if (column["types"]) column.type = column["types"];
            }
        }
        if (this.isReact) {
            var args = {
                requireTemplateRef: this.requireTemplateRef
            };
            this.trigger($17b89d3b1fc93cdb$export$11e63f7b0f3d9900, args);
            if (!args.requireTemplateRef) this.requireTemplateRef = args.requireTemplateRef;
        } else this.trigger($17b89d3b1fc93cdb$export$11e63f7b0f3d9900);
        (0, $748c2240e597a9b7$export$1147582dfae658c6)(this.columns, this.enableColumnVirtualization, this);
        if (this.enableColumnVirtualization && this.isChangeDataSourceCall && this.columnModel) {
            this.columnModel = [];
            this.updateColumnModel(this.columns);
        }
        this.isPreparedFrozenColumns = true;
        if (this.enablePersistence) this.notify($17b89d3b1fc93cdb$export$32aae452a9346e5, {});
        this.getMediaColumns();
        (0, $748c2240e597a9b7$export$64b518da455ab951)(this.columns);
        if (this.isFrozenGrid() && !this.mergedColumns) this.setInitialFrozenColumnIndex(this.columns);
        this.checkLockColumns(this.columns);
        this.getColumns();
        this.processModel();
        this.gridRender();
        this.wireEvents();
        this.addListener();
        this.updateDefaultCursor();
        this.updateStackedFilter();
        if (this.loadingIndicator.indicatorType === "Spinner") this.showSpinner();
        this.notify($17b89d3b1fc93cdb$export$5d4840440f592fca, {});
        if (this.loadingIndicator.indicatorType === "Shimmer") this.refreshMaskRow();
        if (this.refreshing) this.trigger("created");
    };
    Grid.prototype.setInitialFrozenColumnIndex = function(columns) {
        for(var i = 0; i < columns.length; i++){
            var column = columns[parseInt(i.toString(), 10)];
            column["" + $1b5568e76cdae6d4$export$1083832cc21be1bf] = column.index;
            if (column.columns) this.setInitialFrozenColumnIndex(column.columns);
        }
    };
    /**
     * By default, grid shows the spinner for all its actions. You can use this method to show spinner at your needed time.
     *
     * @returns {void}
     */ Grid.prototype.showSpinner = function() {
        if (!this.isExportGrid) (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.element);
    };
    /**
     * By default, grid shows the spinner for all its actions. You can use this method to show spinner at your needed time.
     *
     * @returns {void}
     */ Grid.prototype.hideSpinner = function() {
        if (!this.isExportGrid) (0, $d4834c37f505aa74$export$95fec50f68454318)(this.element);
    };
    Grid.prototype.showMaskRow = function(axisDirection, dialogElement) {
        if ((0, $3EnZW.isNullOrUndefined)(this.headerModule) || (0, $3EnZW.isNullOrUndefined)(this.contentModule)) return;
        var gridHeader = this.getHeaderContent().firstChild;
        var gridContent = this.getContent().firstChild;
        var gridFooter = this.getFooterContent();
        if (dialogElement) {
            var dialogHolder = dialogElement.querySelector(".e-checkboxlist");
            var maskRowCount = Math.floor(dialogHolder.getBoundingClientRect().height / this.getRowHeight());
            var maskTemplate = '<div class="e-ftrchk e-mask-ftrchk" style="width: 100%;"><div class="e-checkbox-wrapper" style="width: 100%;"><input class="e-chk-hidden">' + this.getShimmerTemplate() + this.getShimmerTemplate() + "</div></div>";
            dialogHolder.innerHTML = "";
            for(var i = 0; i < maskRowCount; i++){
                dialogHolder.innerHTML += maskTemplate;
                var maskSpan = [].slice.call(dialogHolder.querySelectorAll(".e-mask:not(.e-mask-checkbox-filter-intent):not(.e-mask-checkbox-filter-span-intent)"));
                maskSpan[0].classList.add("e-mask-checkbox-filter-intent");
                maskSpan[1].classList.add("e-mask-checkbox-filter-span-intent");
            }
            return;
        }
        if (!this.enableRtl && !this.getHeaderContent().style.paddingRight || this.enableRtl && !this.getHeaderContent().style.paddingLeft) gridContent.style.overflowY = "hidden";
        if (!this.isInitialLoad && !this.getColumns().length) {
            var contentHeight = gridContent.getBoundingClientRect().height;
            var maskTableHeight = contentHeight === 0 ? this.allowPaging ? this.pageSettings.pageSize * this.getRowHeight() : window.innerHeight : contentHeight;
            var contentRowCount = Math.ceil(maskTableHeight / this.getRowHeight());
            if (this.rowRenderingMode !== "Vertical") this.headerMaskTable = this.createEmptyMaskTable(gridHeader, 1);
            this.contentMaskTable = this.createEmptyMaskTable(gridContent, contentRowCount);
            return;
        }
        this.maskRowContentScroll = (this.enableVirtualization || this.enableColumnVirtualization) && axisDirection ? true : false;
        if (!this.contentMaskTable) {
            var content = gridContent;
            if (this.enableVirtualization || this.enableColumnVirtualization) content = content.querySelector(".e-virtualtable");
            if (!(0, $3EnZW.isNullOrUndefined)(content.querySelector("tbody"))) this.contentMaskTable = this.createMaskTable(content, this.getContentMaskColumns(), axisDirection);
        }
        if (!this.headerMaskTable && (this.isFrozenGrid() || this.enableColumnVirtualization && axisDirection === "X")) {
            var content = gridHeader;
            if (this.enableColumnVirtualization && axisDirection === "X") content = content.querySelector(".e-virtualtable");
            this.headerMaskTable = this.createMaskTable(content, this.getContentMaskColumns(), axisDirection);
        }
        if (gridFooter && gridFooter.querySelector(".e-summaryrow")) {
            var gridFooterContent = gridFooter.firstChild;
            if (!this.footerContentMaskTable) {
                var footerContent = gridFooterContent;
                this.footerContentMaskTable = this.createMaskTable(footerContent);
            }
        }
        if (!(this.enableVirtualization && axisDirection)) (0, $aqzbR.EventHandler).add(gridContent, "scroll", this.translateMaskRow, this);
    };
    Grid.prototype.getContentMaskColumns = function() {
        return this.getColumns();
    };
    Grid.prototype.createEmptyMaskTable = function(maskElement, rowCount) {
        var table = this.createElement("table", {
            className: "e-table e-masked-table"
        });
        var tbody = this.createElement("tbody", {
            className: "e-masked-tbody"
        });
        var row = this.createElement("tr", {
            className: "e-masked-row e-row",
            attrs: {
                style: "height: " + this.getRowHeight() + "px;"
            }
        });
        var cell = this.createElement("td", {
            className: "e-masked-cell e-rowcell"
        });
        cell.innerHTML = this.getShimmerTemplate();
        row.appendChild(cell);
        for(var i = 0; i < rowCount; i++)tbody.appendChild(row.cloneNode(true));
        table.appendChild(tbody);
        maskElement.appendChild(table);
        return table;
    };
    Grid.prototype.createMaskTable = function(element, columns, axisDirection) {
        var parentElement = element;
        var header = (0, $4ZDHT.closest)(parentElement, ".e-gridheader") ? true : false;
        var content = (0, $4ZDHT.closest)(parentElement, ".e-gridcontent") ? true : false;
        var footer = (0, $4ZDHT.closest)(parentElement, ".e-gridfooter") ? true : false;
        var gridContent = this.getContent().firstChild;
        var gridContentScrollHeight = gridContent.scrollHeight;
        var table = parentElement.querySelector("table");
        var maskTable = table.cloneNode();
        maskTable.removeAttribute("role");
        maskTable.removeAttribute("id");
        maskTable.style.position = "absolute";
        maskTable.style.zIndex = "5";
        maskTable.style.width = table.getBoundingClientRect().width + "px";
        if (header && !(this.enableColumnVirtualization && axisDirection === "X")) maskTable.style.transform = "translate(0px," + table.querySelector("thead").getBoundingClientRect().height + "px)";
        maskTable.setAttribute("class", "e-table e-masked-table");
        var maskColgroup = table.querySelector("colgroup").cloneNode(true);
        maskColgroup.removeAttribute("id");
        maskColgroup.setAttribute("class", "e-masked-colgroup");
        maskTable.appendChild(maskColgroup);
        if (header && this.enableColumnVirtualization && axisDirection === "X") {
            var row = this.createMaskRow(maskColgroup, columns);
            if (this.isFrozenGrid()) {
                var frzTd = [].slice.call(row.querySelectorAll(".e-rowcell"));
                for(var i = 0; i < frzTd.length; i++){
                    if (i < this.frozenLeftCount) {
                        if (this.frozenLeftCount - 1 === i) frzTd[parseInt(i.toString(), 10)].classList.add("e-freezeleftborder");
                        frzTd[parseInt(i.toString(), 10)].classList.add("e-leftfreeze");
                        frzTd[parseInt(i.toString(), 10)].setAttribute("data-colindex", i.toString());
                        frzTd[parseInt(i.toString(), 10)].style.left = columns[parseInt(i.toString(), 10)].valueX - this.translateX + "px";
                    } else if (frzTd.length - this.frozenRightCount <= i && columns[parseInt(i.toString(), 10)]) {
                        if (frzTd.length - this.frozenRightCount === i) frzTd[parseInt(i.toString(), 10)].classList.add("e-freezerightborder");
                        frzTd[parseInt(i.toString(), 10)].classList.add("e-rightfreeze");
                        frzTd[parseInt(i.toString(), 10)].setAttribute("data-colindex", i.toString());
                        frzTd[parseInt(i.toString(), 10)].style.right = this.translateX + columns[parseInt(i.toString(), 10)].valueX + "px";
                    }
                }
            }
            var thead = table.querySelector("thead");
            var rows = [].slice.call(thead.querySelectorAll("tr"));
            var maskTHead = thead.cloneNode();
            maskTHead.removeAttribute("role");
            maskTHead.setAttribute("class", "e-masked-thead");
            var rowCount = rows.length;
            for(var i = 0; i < rowCount; i++){
                maskTHead.appendChild(row.cloneNode(true));
                maskTHead.childNodes[parseInt(i.toString(), 10)].style.height = rows[parseInt(i.toString(), 10)].getBoundingClientRect().height + "px";
            }
            maskTable.appendChild(maskTHead);
        }
        var maskTBody = table.querySelector("tbody").cloneNode();
        maskTBody.removeAttribute("role");
        maskTBody.setAttribute("class", "e-masked-tbody");
        var tbody = table.querySelector("tbody");
        if (content || header) {
            var rowCountElement = gridContent;
            var rowCount = Math.ceil(rowCountElement.getBoundingClientRect().height / this.getRowHeight());
            if (this.allowPaging && this.pageSettings.pageSize !== this.currentViewData.length && this.pagerModule.pagerObj.totalPages !== this.pageSettings.currentPage) for(var i = 0; i < this.pageSettings.pageSize - this.currentViewData.length; i++){
                var row = this.createMaskRow(maskColgroup, columns);
                var altRow = row.cloneNode(true);
                altRow.classList.add("e-altrow");
                for(var i_1 = 0; i_1 < rowCount; i_1++){
                    var altNumber = 1;
                    maskTBody.appendChild((i_1 + altNumber) % 2 === 0 ? altRow.cloneNode(true) : row.cloneNode(true));
                }
            }
            if (tbody.querySelector(".e-emptyrow") || !tbody.childNodes.length || content && this.childGrid) {
                var row = this.createMaskRow(maskColgroup, columns);
                var altRow = row.cloneNode(true);
                altRow.classList.add("e-altrow");
                for(var i = 0; i < rowCount; i++){
                    var altNumber = 1;
                    maskTBody.appendChild((i + altNumber) % 2 === 0 ? altRow.cloneNode(true) : row.cloneNode(true));
                }
            } else {
                var rowsQuery = 'tr:not(.e-hide):not([style*="display:none"]):not([style*="display: none"])';
                var rows = [].slice.call(tbody.querySelectorAll(rowsQuery));
                var addEditRow = tbody.querySelector(".e-addedrow, .e-editedrow");
                var addEditRowIndex = void 0;
                if (addEditRow) {
                    addEditRowIndex = rows.indexOf(addEditRow);
                    if (this.isFrozenGrid() && this.enableColumnVirtualization) {
                        var frzTd = [].slice.call(rows[addEditRowIndex + 1].querySelectorAll(".e-rowcell"));
                        for(var i = 0; i < frzTd.length; i++){
                            if (i < this.frozenLeftCount) {
                                frzTd[parseInt(i.toString(), 10)].classList.add("e-leftfreeze");
                                frzTd[parseInt(i.toString(), 10)].setAttribute("data-colindex", i.toString());
                                frzTd[parseInt(i.toString(), 10)].style.left = columns[parseInt(i.toString(), 10)].valueX - this.translateX + "px";
                            } else if (frzTd.length - this.frozenRightCount <= i && columns[parseInt(i.toString(), 10)]) {
                                frzTd[parseInt(i.toString(), 10)].classList.add("e-rightfreeze");
                                frzTd[parseInt(i.toString(), 10)].setAttribute("data-colindex", i.toString());
                                frzTd[parseInt(i.toString(), 10)].style.right = this.translateX + columns[parseInt(i.toString(), 10)].valueX + "px";
                            }
                        }
                    }
                    if (addEditRow.classList.contains("e-addedrow")) rows.splice(addEditRowIndex, 2);
                    else rows.splice(addEditRowIndex, 1);
                }
                rowCount = (this.enableVirtualization || this.enableColumnVirtualization) && axisDirection ? rows.length : rowCount <= rows.length ? rowCount : rows.length;
                for(var i = 0; i < rowCount; i++)maskTBody.appendChild(this.applyMaskRow(rows[parseInt(i.toString(), 10)].cloneNode(true), rows[parseInt(i.toString(), 10)].getBoundingClientRect().height));
                if (addEditRow && addEditRow.classList.contains("e-editedrow") && addEditRowIndex < rowCount) {
                    var addEditMaskRow = maskTBody.childNodes[parseInt(addEditRowIndex.toString(), 10)];
                    addEditMaskRow.style.height = this.getRowHeight() + "px";
                    addEditMaskRow.classList.add("e-row");
                    if (addEditRow.classList.contains("e-altrow")) addEditMaskRow.classList.add("e-altrow");
                }
            }
        }
        maskTable.appendChild(maskTBody);
        if (footer) {
            var tfoot = table.querySelector("tfoot");
            var maskTFoot = tfoot.cloneNode();
            maskTFoot.setAttribute("class", "e-masked-tfoot");
            var rows = [].slice.call(tfoot.querySelectorAll("tr"));
            for(var i = 0; i < rows.length; i++)maskTFoot.appendChild(this.applyMaskRow(rows[parseInt(i.toString(), 10)].cloneNode(true), rows[parseInt(i.toString(), 10)].getBoundingClientRect().height));
            maskTable.appendChild(maskTFoot);
        }
        if (header && this.isFrozenGrid() && !this.enableColumnVirtualization) this.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).style.position = "relative";
        parentElement.insertBefore(maskTable, parentElement.firstChild);
        if (content && !(this.enableVirtualization && axisDirection)) {
            var minScrollTop = gridContentScrollHeight - maskTable.getBoundingClientRect().height;
            minScrollTop = minScrollTop < 0 ? 0 : minScrollTop;
            var scrollTop = gridContent.scrollTop <= minScrollTop ? gridContent.scrollTop : minScrollTop;
            if (this.enableVirtualization) scrollTop -= (0, $748c2240e597a9b7$export$3046fdef117e6822)((0, $4ZDHT.closest)(parentElement, ".e-virtualtable")).height;
            maskTable.style.transform = "translate(0px," + scrollTop + "px)";
        }
        return maskTable;
    };
    Grid.prototype.applyMaskRow = function(row, rowHeight) {
        var maskRow = row;
        maskRow.removeAttribute("role");
        maskRow.removeAttribute("aria-rowindex");
        maskRow.removeAttribute("data-rowindex");
        maskRow.removeAttribute("data-uid");
        maskRow.classList.add("e-masked-row");
        maskRow.style.height = rowHeight + "px";
        var maskCells = [].slice.call(maskRow.childNodes);
        for(var i = 0; i < maskCells.length; i++){
            var maskCell = maskCells[parseInt(i.toString(), 10)];
            var displayAsCheckBoxCell = maskCell.firstChild && maskCell.firstChild.classList && maskCell.firstChild.classList.contains("e-checkbox-wrapper");
            maskCell.removeAttribute("role");
            maskCell.removeAttribute("tabindex");
            maskCell.removeAttribute("aria-label");
            if (this.enableColumnVirtualization && maskCell.classList.contains("e-fixedfreeze")) {
                (0, $4ZDHT.removeClass)([
                    maskCell
                ], [
                    "e-fixedfreeze",
                    "e-freezeleftborder",
                    "e-freezerightborder"
                ]);
                (0, $4ZDHT.addClass)([
                    maskCell
                ], [
                    "e-unfreeze"
                ]);
            }
            if (!(this.enableColumnVirtualization && (maskCell.classList.contains("e-leftfreeze") || maskCell.classList.contains("e-rightfreeze")))) maskCell.removeAttribute("data-colindex");
            maskCell.removeAttribute("aria-colindex");
            maskCell.removeAttribute("index");
            maskCell.removeAttribute("ej-mappingname");
            maskCell.removeAttribute("ej-mappingvalue");
            maskCell.removeAttribute("e-mappinguid");
            maskCell.removeAttribute("aria-expanded");
            maskCell.classList.add("e-masked-cell");
            maskCell.innerHTML = this.getShimmerTemplate();
            if (maskCell.classList.contains("e-recordplusexpand") || maskCell.classList.contains("e-recordpluscollapse")) maskCell.firstChild.classList.add("e-mask-group-intent");
            else if (maskCell.classList.contains("e-gridchkbox") || displayAsCheckBoxCell) maskCell.firstChild.classList.add("e-mask-checkbox-intent");
            else if (maskCell.classList.contains("e-rowdragdrop")) maskCell.firstChild.classList.add("e-mask-drag-intent");
            else if (maskCell.classList.contains("e-indentcell")) maskCell.innerHTML = "";
        }
        return maskRow;
    };
    Grid.prototype.createMaskRow = function(refColgroup, refColumns) {
        var colgroup = refColgroup;
        var columns = refColumns;
        var row = this.createElement("tr", {
            className: "e-masked-row e-row"
        });
        if (this.rowRenderingMode !== "Vertical") row.style.height = this.getRowHeight() + "px";
        var td = this.createElement("td", {
            className: "e-masked-cell e-rowcell"
        });
        for(var i = 0, colIndex = 0; i < colgroup.childNodes.length; i++){
            var col = colgroup.childNodes[parseInt(i.toString(), 10)];
            var localTD = td.cloneNode();
            localTD.innerHTML = this.getShimmerTemplate();
            if (!(col.classList.contains("e-group-intent") || col.classList.contains("e-detail-intent") || col.classList.contains("e-drag-intent"))) {
                if (this.rowRenderingMode === "Vertical" && columns[parseInt(colIndex.toString(), 10)]) localTD.setAttribute("data-cell", columns[parseInt(colIndex.toString(), 10)].headerText ? columns[parseInt(colIndex.toString(), 10)].headerText : columns[parseInt(colIndex.toString(), 10)].field);
                if (col.style.display === "none") localTD.classList.add("e-hide");
                else {
                    localTD.style.textAlign = columns[parseInt(colIndex.toString(), 10)] && columns[parseInt(colIndex.toString(), 10)].textAlign ? columns[parseInt(colIndex.toString(), 10)].textAlign.toLowerCase() : this.enableRtl ? "right" : "left";
                    if (columns[parseInt(colIndex.toString(), 10)] && (columns[parseInt(colIndex.toString(), 10)].type === "checkbox" || columns[parseInt(colIndex.toString(), 10)].displayAsCheckBox)) localTD.firstChild.classList.add("e-mask-checkbox-intent");
                }
                colIndex++;
            } else {
                if (col.classList.contains("e-group-intent")) localTD.firstChild.classList.add("e-mask-group-intent");
                else if (col.classList.contains("e-detail-intent")) localTD.firstChild.classList.add("e-mask-detail-intent");
                else if (col.classList.contains("e-drag-intent")) localTD.firstChild.classList.add("e-mask-drag-intent");
            }
            row.appendChild(localTD);
        }
        return row;
    };
    Grid.prototype.getShimmerTemplate = function() {
        if (this.maskRowContentScroll) return '<span class="e-mask e-skeleton e-skeleton-text"></span>';
        return '<span class="e-mask e-skeleton e-skeleton-text e-shimmer-wave"></span>';
    };
    Grid.prototype.addShimmerEffect = function() {
        this.maskRowContentScroll = false;
        var maskSpan = [].slice.call(this.element.querySelectorAll(".e-mask:not(.e-shimmer-wave)"));
        for(var i = 0; i < maskSpan.length; i++)if (maskSpan[parseInt(i.toString(), 10)]) maskSpan[parseInt(i.toString(), 10)].classList.add("e-shimmer-wave");
    };
    Grid.prototype.translateMaskRow = function(e) {
        var target = e.target;
        var maskTables = target.querySelectorAll(".e-masked-table");
        for(var i = 0; i < maskTables.length; i++){
            var maskTable = maskTables[parseInt(i.toString(), 10)];
            if (maskTable) {
                var minScrollTop = target.scrollHeight - maskTable.getBoundingClientRect().height;
                minScrollTop = minScrollTop < 0 ? 0 : minScrollTop;
                var scrollTop = target.scrollTop <= minScrollTop ? target.scrollTop : minScrollTop;
                if (this.enableVirtualization) scrollTop -= (0, $748c2240e597a9b7$export$3046fdef117e6822)((0, $4ZDHT.closest)(maskTable, ".e-virtualtable")).height;
                maskTable.style.transform = "translate(0px," + scrollTop + "px)";
            }
        }
    };
    Grid.prototype.removeMaskRow = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule)) {
            var gridContent = this.getContent().firstChild;
            (0, $aqzbR.EventHandler).remove(gridContent, "scroll", this.translateMaskRow);
        }
        if (this.headerMaskTable && this.isFrozenGrid() && !this.enableColumnVirtualization) this.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).style.position = "";
        var maskTables = [
            this.headerMaskTable,
            this.contentMaskTable,
            this.footerContentMaskTable
        ];
        for(var i = 0; i < maskTables.length; i++){
            var maskTable = maskTables[parseInt(i.toString(), 10)];
            if (maskTable) (0, $4ZDHT.remove)(maskTable);
        }
        this.headerMaskTable = null;
        this.contentMaskTable = null;
        this.footerContentMaskTable = null;
    };
    Grid.prototype.refreshMaskRow = function() {
        var gridContent = this.getContent().firstChild;
        if (!this.isInitialLoad && !this.getColumns().length) return;
        if (this.contentMaskTable && gridContent.querySelector(".e-masked-table")) {
            var content = gridContent;
            if (this.enableVirtualization) content = content.querySelector(".e-virtualtable");
            this.refreshMaskRowColgroupWidth(content);
        }
    };
    Grid.prototype.refreshMaskRowColgroupWidth = function(content) {
        var table = content.querySelector("table:not(.e-masked-table)");
        var colgroup = table.querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).cloneNode(true);
        var maskTable = content.querySelector(".e-masked-table");
        colgroup.removeAttribute("id");
        colgroup.setAttribute("class", "e-masked-colgroup");
        for(var i = 0; i < colgroup.childNodes.length; i++)colgroup.childNodes[parseInt(i.toString(), 10)].removeAttribute("class");
        (0, $4ZDHT.remove)(maskTable.querySelector(".e-masked-colgroup"));
        maskTable.insertBefore(colgroup, maskTable.firstChild);
        maskTable.style.width = table.getBoundingClientRect().width + "px";
    };
    Grid.prototype.updateStackedFilter = function() {
        if (this.allowFiltering && this.filterSettings.type === "FilterBar" && this.getHeaderContent().getElementsByClassName("e-stackedheadercell").length) this.getHeaderContent().classList.add("e-stackedfilter");
        else this.getHeaderContent().classList.remove("e-stackedfilter");
    };
    Grid.prototype.getMediaColumns = function() {
        if (!this.enableColumnVirtualization) {
            var gcol = this.getColumns();
            this.getShowHideService = this.serviceLocator.getService("showHideService");
            if (!(0, $3EnZW.isNullOrUndefined)(gcol)) {
                for(var index = 0; index < gcol.length; index++)if (!(0, $3EnZW.isNullOrUndefined)(gcol[parseInt(index.toString(), 10)].hideAtMedia) && ((0, $3EnZW.isNullOrUndefined)(gcol[parseInt(index.toString(), 10)].visible) || gcol[parseInt(index.toString(), 10)].visible)) this.pushMediaColumn(gcol[parseInt(index.toString(), 10)], index);
            }
        }
        this.updateFrozenColumnsWidth();
    };
    Grid.prototype.pushMediaColumn = function(col, index) {
        this.mediaCol.push(col);
        this.media[col.uid] = window.matchMedia(col.hideAtMedia);
        this.mediaQueryUpdate(index, this.media[col.uid]);
        this.mediaBindInstance[parseInt(index.toString(), 10)] = this.mediaQueryUpdate.bind(this, index);
        this.media[col.uid].addListener(this.mediaBindInstance[parseInt(index.toString(), 10)]);
    };
    /**
     * @param {Column} col - specifies the column
     * @returns {void}
     * @hidden
     */ Grid.prototype.updateMediaColumns = function(col) {
        if (!this.enableColumnVirtualization) {
            var index = this.getColumnIndexByUid(col.uid);
            for(var i = 0; i < this.mediaCol.length; i++)if (col.uid === this.mediaCol[parseInt(i.toString(), 10)].uid) {
                this.mediaCol.splice(i, 1);
                return;
            }
            this.pushMediaColumn(col, index);
        }
    };
    /**
     * @param {number} columnIndex - specifies the column index
     * @param {MediaQueryList} e - specifies the MediaQueryList
     * @returns {void}
     * @hidden
     */ Grid.prototype.mediaQueryUpdate = function(columnIndex, e) {
        var col = this.getColumns()[parseInt(columnIndex.toString(), 10)];
        if (this.mediaCol.some(function(mediaColumn) {
            return mediaColumn.uid === col.uid;
        })) {
            col.visible = e.matches;
            if (this.isInitialLoad) {
                this.invokedFromMedia = true;
                if (col.visible) this.showHider.show(col.headerText, "headerText");
                else this.showHider.hide(col.headerText, "headerText");
            }
        }
    };
    Grid.prototype.refreshMediaCol = function() {
        this.isInitialLoad = true;
        var footerContent = this.element.querySelector("." + $1b5568e76cdae6d4$export$71ae40cd68e383eb);
        if (this.aggregates.length && this.element.scrollHeight > parseInt(this.height.toString(), 10) && footerContent) (0, $4ZDHT.addClass)([
            footerContent
        ], [
            "e-footerpadding"
        ]);
        var checkboxColumn = this.getColumns().filter(function(col) {
            return col.type === "checkbox";
        });
        if (checkboxColumn.length === 0 || checkboxColumn.length && this.selectionSettings.checkboxMode === "ResetOnRowClick") this.isCheckBoxSelection = false;
        if (this.rowRenderingMode === "Vertical") {
            if (this.enableHover) {
                this.setProperties({
                    enableAdaptiveUI: true,
                    enableHover: false
                }, true);
                (0, $4ZDHT.removeClass)([
                    this.element
                ], "e-gridhover");
            }
        }
        if (this.enableAdaptiveUI && this.scrollModule) this.scrollModule.refresh();
        if (this.isFrozenGrid() && this.isAutoGenerateColumns) {
            this.widthService.setWidthToColumns();
            this.isAutoGenerateColumns = false;
        }
    };
    Grid.prototype.removeMediaListener = function() {
        for(var i = 0; i < this.mediaCol.length; i++)this.media[this.mediaCol[parseInt(i.toString(), 10)].uid].removeListener(this.mediaBindInstance[this.mediaCol[parseInt(i.toString(), 10)].index]);
    };
    /**
     * For internal use only - Initialize the event handler
     *
     * @returns {void}
     * @private
     */ Grid.prototype.eventInitializer = function() {
    //eventInitializer
    };
    /**
     * Destroys the component (detaches/removes all event handlers, attributes, classes, and empties the component element).
     *
     * @function destroy
     * @returns {void}
     */ Grid.prototype.destroy = function() {
        var gridElement = this.element;
        if (!gridElement) return;
        var hasGridChild = gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474) ? true : false;
        if (hasGridChild) this.unwireEvents();
        this.removeListener();
        this.removeMediaListener();
        this.notify($17b89d3b1fc93cdb$export$b1fb4cac938035f7, {});
        this.destroyDependentModules();
        if (this.isReact) this.destroyTemplate([
            "template"
        ]);
        if (this.isVue) this.destroyTemplate();
        if (hasGridChild) _super.prototype.destroy.call(this);
        this.toolTipObj.destroy();
        if (this.isReact && !(0, $5q7BP.Browser).isIE) this.element.innerHTML = "";
        var modules = [
            "renderModule",
            "headerModule",
            "contentModule",
            "valueFormatterService",
            "serviceLocator",
            "ariaService",
            "keyboardModule",
            "widthService",
            "searchModule",
            "showHider",
            "scrollModule",
            "printModule",
            "clipboardModule",
            "focusModule"
        ];
        for(var i = 0; i < modules.length; i++)if (this[modules[parseInt(i.toString(), 10)]]) this[modules[parseInt(i.toString(), 10)]] = null;
        this.element.innerHTML = "";
        (0, $4ZDHT.classList)(this.element, [], [
            "e-rtl",
            "e-gridhover",
            "e-responsive",
            "e-default",
            "e-device",
            "e-grid-min-height"
        ]);
    };
    Grid.prototype.destroyDependentModules = function() {
        var gridElement = this.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        this.scrollModule.destroy();
        this.keyboardModule.destroy();
        this.focusModule.destroy();
        this.clipboardModule.destroy();
        this.printModule.destroy();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Grid.prototype.getModuleName = function() {
        return "grid";
    };
    Grid.prototype.enableBoxSelection = function() {
        if (this.enableAutoFill) {
            this.selectionSettings.cellSelectionMode = "BoxWithBorder";
            this.element.classList.add("e-afenabled");
        } else {
            this.element.classList.remove("e-afenabled");
            this.notify($17b89d3b1fc93cdb$export$5876580e0ddf0aa4, {});
        }
    };
    Grid.prototype.setCSSClass = function(oldCSSClass) {
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.element
        ], this.cssClass.split(" "));
        if (oldCSSClass) (0, $4ZDHT.removeClass)([
            this.element
        ], oldCSSClass.split(" "));
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {GridModel} newProp - Defines new properties
     * @param {GridModel} oldProp - Defines old properties
     * @returns {void}
     * @hidden
     */ Grid.prototype.onPropertyChanged = function(newProp, oldProp) {
        var requireRefresh = false;
        var requireGridRefresh = false;
        var freezeRefresh = false;
        var checkCursor;
        var args = {
            requestType: "refresh"
        };
        var childGridParent = null;
        var parentInstance = null;
        if (this.isDestroyed) return;
        this.log("module_missing");
        if (this.isEllipsisTooltip()) this.toolTipObj.close();
        var properties = Object.keys(newProp);
        if (properties.indexOf("columns") > -1) {
            if (this.enableColumnVirtualization) this.columnModel = [];
            this.updateColumnObject();
            requireGridRefresh = true;
        }
        for(var _i = 0, properties_1 = properties; _i < properties_1.length; _i++){
            var prop = properties_1[_i];
            switch(prop){
                case "allowPaging":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "pager",
                        enable: this.allowPaging
                    });
                    requireRefresh = true;
                    if (this.height === "100%") this.scrollModule.refresh();
                    break;
                case "pageSettings":
                    if (this.pageTemplateChange) {
                        this.pageTemplateChange = false;
                        this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                            module: "pager",
                            properties: newProp.pageSettings
                        });
                        break;
                    }
                    if (this.pagerModule && this.pagerModule.isCancel) {
                        this.pagerModule.isCancel = false;
                        return;
                    }
                    this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                        module: "pager",
                        properties: newProp.pageSettings
                    });
                    if ((0, $3EnZW.isNullOrUndefined)(newProp.pageSettings.currentPage) && (0, $3EnZW.isNullOrUndefined)(newProp.pageSettings.pageSize) && (0, $3EnZW.isNullOrUndefined)(newProp.pageSettings.totalRecordsCount) || !(0, $3EnZW.isNullOrUndefined)(oldProp.pageSettings) && newProp.pageSettings.currentPage !== oldProp.pageSettings.currentPage && !this.enableColumnVirtualization && !this.enableVirtualization && this.pageRequireRefresh && this.pageSettings.totalRecordsCount <= this.pageSettings.pageSize) requireRefresh = true;
                    if (!this.pageRequireRefresh) this.pageRequireRefresh = true;
                    if (this.pagerModule && this.pagerModule.isCancel) this.pagerModule.isCancel = false;
                    break;
                case "allowSorting":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "sort",
                        enable: this.allowSorting
                    });
                    requireRefresh = true;
                    checkCursor = true;
                    break;
                case "allowFiltering":
                    this.updateStackedFilter();
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "filter",
                        enable: this.allowFiltering
                    });
                    requireRefresh = true;
                    if (this.filterSettings.type !== "FilterBar" || this.editSettings.showAddNewRow && this.filterSettings.type === "FilterBar") this.refreshHeader();
                    else if (this.height === "100%") this.scrollModule.refresh();
                    break;
                case "height":
                case "width":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "scroll",
                        properties: {
                            width: newProp.width,
                            height: newProp.height
                        }
                    });
                    if (this.allowPaging) this.pagerModule.refresh();
                    break;
                case "allowReordering":
                    this.headerModule.refreshUI();
                    checkCursor = true;
                    break;
                case "allowRowDragAndDrop":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "rowDragAndDrop",
                        enable: this.allowRowDragAndDrop
                    });
                    this.renderModule.refresh();
                    this.headerModule.refreshUI();
                    break;
                case "allowSelection":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "selection",
                        enable: this.allowSelection
                    });
                    break;
                case "cssClass":
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case "enableAutoFill":
                    if (this.selectionModule) {
                        this.enableBoxSelection();
                        this.selectionModule.updateAutoFillPosition();
                    }
                    break;
                case "rowTemplate":
                    this.rowTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.rowTemplate);
                    requireRefresh = true;
                    break;
                case "emptyRecordTemplate":
                    this.emptyRecordTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.emptyRecordTemplate);
                    requireRefresh = true;
                    break;
                case "detailTemplate":
                    this.detailTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.detailTemplate);
                    requireRefresh = true;
                    break;
                case "allowGrouping":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "group",
                        enable: this.allowGrouping
                    });
                    this.headerModule.refreshUI();
                    requireRefresh = true;
                    checkCursor = true;
                    if (this.height === "100%") this.scrollModule.refresh();
                    break;
                case "enableInfiniteScrolling":
                case "childGrid":
                    requireRefresh = true;
                    childGridParent = this.parentDetails ? document.querySelector("#" + this.parentDetails.parentID) : null;
                    parentInstance = childGridParent ? childGridParent.ej2_instances[0] : null;
                    if (this.childGrid && parentInstance && (0, $3EnZW.isNullOrUndefined)(parentInstance.childGrid.childGrid)) {
                        var childGridObject = Object.assign({}, parentInstance.childGrid, {
                            childGrid: newProp.childGrid
                        });
                        parentInstance.setProperties({
                            childGrid: childGridObject
                        }, true);
                        while(!(0, $3EnZW.isNullOrUndefined)(parentInstance.parentDetails)){
                            var currentParent = document.querySelector("#" + parentInstance.parentDetails.parentID);
                            var currentParentInstance = currentParent ? currentParent.ej2_instances[0] : null;
                            if (currentParentInstance) {
                                var currentChildObject = Object.assign({}, currentParentInstance.childGrid);
                                currentChildObject.childGrid = parentInstance.childGrid;
                                currentParentInstance.setProperties({
                                    childGrid: currentChildObject
                                }, true);
                            }
                            parentInstance = currentParentInstance;
                        }
                    }
                    this.headerModule.refreshUI();
                    break;
                case "toolbar":
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "toolbar"
                    });
                    if (this.height === "100%") this.scrollModule.refresh();
                    break;
                case "groupSettings":
                    this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                        module: "group",
                        properties: newProp.groupSettings,
                        oldProperties: oldProp.groupSettings
                    });
                    break;
                case "aggregates":
                    if (!this.aggregates.length && this.allowGrouping && this.groupSettings.columns.length) requireRefresh = true;
                    this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                        module: "aggregate",
                        properties: newProp
                    });
                    if (this.height === "100%") this.scrollModule.refresh();
                    break;
                case "frozenColumns":
                case "frozenRows":
                case "enableVirtualization":
                case "enableColumnVirtualization":
                case "currencyCode":
                case "locale":
                    if (this.isFrozenGrid()) this.log("frozen_rows_columns");
                    freezeRefresh = true;
                    requireGridRefresh = true;
                    this.addNewRowFocus = true;
                    break;
                case "query":
                    if (!this.getDataModule().isQueryInvokedFromData) requireRefresh = true;
                    this.getDataModule().isQueryInvokedFromData = false;
                    break;
                case "autoFit":
                    if (this.autoFit) this.preventAdjustColumns();
                    else this.restoreAdjustColumns();
                    break;
                default:
                    this.extendedPropertyChange(prop, newProp, requireGridRefresh);
            }
        }
        if (checkCursor) this.updateDefaultCursor();
        if (requireGridRefresh) {
            if (freezeRefresh || this.getFrozenColumns() || this.frozenRows || this.frozenLeftColumns.length || this.frozenRightColumns.length) this.freezeRefresh();
            else this.refresh();
        } else if (requireRefresh) {
            this.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
            requireRefresh = false;
            this.maintainSelection(newProp.selectedRowIndex);
        }
    };
    Grid.prototype.extendedPropertyChange = function(prop, newProp, requireGridRefresh) {
        switch(prop){
            case "enableRtl":
                this.updateRTL();
                if (this.allowPaging) {
                    this.element.querySelector(".e-gridpager").ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.element.querySelector(".e-gridpager").ej2_instances[0].dataBind();
                }
                if (this.height !== "auto") {
                    this.scrollModule.removePadding(!newProp.enableRtl);
                    this.scrollModule.setPadding();
                }
                if (this.toolbar && this.toolbarModule) {
                    this.toolbarModule.getToolbar().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.toolbarModule.getToolbar().ej2_instances[0].dataBind();
                }
                if (this.contextMenuItems && this.contextMenuModule) {
                    this.contextMenuModule.getContextMenu().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.contextMenuModule.getContextMenu().ej2_instances[0].dataBind();
                }
                if (this.showColumnMenu && this.columnMenuModule && !this.enableAdaptiveUI) {
                    this.columnMenuModule.getColumnMenu().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.columnMenuModule.getColumnMenu().ej2_instances[0].dataBind();
                }
                if (this.filterSettings.type === "FilterBar" && this.filterSettings.showFilterBarOperator) this.refreshHeader();
                this.notify($17b89d3b1fc93cdb$export$73ce1dd8756c84c3, {});
                break;
            case "enableAltRow":
                this.renderModule.refresh();
                break;
            case "allowResizing":
                if (this.resizeModule) this.resizeModule.render();
                this.headerModule.refreshUI();
                this.updateResizeLines();
                break;
            case "rowHeight":
                if (this.rowHeight) (0, $4ZDHT.addClass)([
                    this.element
                ], "e-grid-min-height");
                else (0, $4ZDHT.removeClass)([
                    this.element
                ], "e-grid-min-height");
                this.renderModule.refresh();
                this.headerModule.refreshUI();
                break;
            case "gridLines":
                this.updateGridLines();
                break;
            case "showColumnMenu":
                this.headerModule.refreshUI();
                this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                    module: "columnMenu",
                    enable: true
                });
                break;
            case "columnMenuItems":
                this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                    module: "columnMenu",
                    enable: this.columnMenuItems
                });
                break;
            case "contextMenuItems":
                this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                    module: "contextMenu",
                    enable: this.contextMenuItems
                });
                break;
            case "showColumnChooser":
                this.notify($17b89d3b1fc93cdb$export$27ad5926bed65d9, {
                    module: "columnChooser",
                    enable: this.showColumnChooser
                });
                break;
            case "filterSettings":
                this.updateStackedFilter();
                this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                    module: "filter",
                    properties: newProp.filterSettings
                });
                break;
            case "searchSettings":
                this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                    module: "search",
                    properties: newProp.searchSettings
                });
                break;
            case "sortSettings":
                this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                    module: "sort"
                });
                break;
            case "selectionSettings":
                this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                    module: "selection",
                    properties: newProp.selectionSettings
                });
                break;
            case "editSettings":
                this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
                    module: "edit",
                    properties: newProp.editSettings
                });
                break;
            case "allowTextWrap":
            case "textWrapSettings":
                if (this.allowTextWrap) this.applyTextWrap();
                else this.removeTextWrap();
                this.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
                    case: "textwrap",
                    isModeChg: prop === "textWrapSettings"
                });
                break;
            case "dataSource":
                // eslint-disable-next-line no-case-declarations
                var pending_1 = this.getDataModule().getState();
                if (this.allowSelection && this.isPersistSelection && !(pending_1 && pending_1.isPending)) this.clearSelection();
                if (!(0, $3EnZW.isNullOrUndefined)(this.dataSource) && this.dataSource.result) this.isVirtualAdaptive = false;
                if (Object.getPrototypeOf(newProp).deepWatch) {
                    var pKeyField = this.getPrimaryKeyFieldNames()[0];
                    for(var i = 0, props = Object.keys(newProp.dataSource); i < props.length; i++)this.setRowData((0, $3EnZW.getValue)(pKeyField, this.dataSource[props[parseInt(i.toString(), 10)]]), this.dataSource[props[parseInt(i.toString(), 10)]]);
                } else if (pending_1.isPending) {
                    var gResult = !(0, $3EnZW.isNullOrUndefined)(this.dataSource) ? this.dataSource.result : [];
                    var names = pending_1.group || [];
                    if (names.length && !this.groupSettings.enableLazyLoading && !(gResult.length && gResult[0].field)) for(var i = 0; i < names.length; i++)gResult = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(gResult, names[parseInt(i.toString(), 10)], pending_1.aggregates || []);
                    this.dataSource = {
                        result: gResult,
                        count: this.dataSource.count,
                        aggregates: this.dataSource.aggregates
                    };
                    this.getDataModule().setState({});
                    pending_1.resolver(this.dataSource);
                } else {
                    if (!(0, $3EnZW.isNullOrUndefined)(this.dataSource) && this.dataSource.result && this.dataSource.count && this.groupSettings.columns.length) {
                        var gResult = this.dataSource.result;
                        var names = this.groupSettings.columns;
                        if (names.length && !(gResult.length && gResult[0].field)) for(var i = 0; i < names.length; i++)gResult = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(gResult, names[parseInt(i.toString(), 10)]);
                        this.dataSource = {
                            result: gResult,
                            count: this.dataSource.count
                        };
                    }
                    this.getDataModule().setState({
                        isDataChanged: false
                    });
                    this.notify($17b89d3b1fc93cdb$export$a8ad22510e401e59, {});
                    if (!requireGridRefresh) {
                        this.renderModule.refresh();
                        if (this.isCheckBoxSelection) this.notify($17b89d3b1fc93cdb$export$725c4d1f8c0e1c70, {});
                    }
                }
                this.scrollRefresh();
                break;
            case "enableHover":
                // eslint-disable-next-line no-case-declarations
                var action = newProp.enableHover ? (0, $4ZDHT.addClass) : (0, $4ZDHT.removeClass);
                action([
                    this.element
                ], "e-gridhover");
                break;
            case "selectedRowIndex":
                if (!this.isSelectedRowIndexUpdating) this.selectRow(newProp.selectedRowIndex);
                this.isSelectedRowIndexUpdating = false;
                break;
            case "resizeSettings":
                this.widthService.setWidthToTable();
                break;
            case "enableAdaptiveUI":
                this.notify($17b89d3b1fc93cdb$export$f66e9a7f793619a4, {});
                break;
            case "rowRenderingMode":
                this.enableVerticalRendering();
                this.notify($17b89d3b1fc93cdb$export$ec2bbd6db9c2d185, {});
                this.refresh();
                break;
            case "enableStickyHeader":
                this.scrollModule.addStickyListener(newProp.enableStickyHeader);
                break;
        }
    };
    Grid.prototype.maintainSelection = function(index) {
        var _this_1 = this;
        if (index !== -1) {
            var fn_1 = function() {
                _this_1.selectRow(index);
                _this_1.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, fn_1);
            };
            this.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, fn_1, this);
        }
    };
    /**
     * @param {Object} prop - Defines the property
     * @param {boolean} muteOnChange - Defines the mute on change
     * @returns {void}
     * @private
     */ Grid.prototype.setProperties = function(prop, muteOnChange) {
        _super.prototype.setProperties.call(this, prop, muteOnChange);
        var filterSettings = "filterSettings";
        if (prop["" + filterSettings] && this.filterModule && muteOnChange) this.filterModule.refreshFilter();
    };
    /**
     * @hidden
     * @returns {number} - Returns the tables count
     */ Grid.prototype.getTablesCount = function() {
        return this.tablesCount;
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.updateDefaultCursor = function() {
        var headerCells = [].slice.call(this.getHeaderContent().querySelectorAll(".e-headercell:not(.e-stackedheadercell)"));
        var stdHdrCell = [].slice.call(this.getHeaderContent().getElementsByClassName("e-stackedheadercell"));
        var cols = this.getColumns();
        for(var i = 0; i < headerCells.length; i++){
            var cell = headerCells[parseInt(i.toString(), 10)];
            if (this.allowGrouping || this.allowReordering || this.allowSorting) {
                if (!cols[parseInt(i.toString(), 10)].allowReordering || !cols[parseInt(i.toString(), 10)].allowSorting || !cols[parseInt(i.toString(), 10)].allowGrouping) cell.classList.add("e-defaultcursor");
                else cell.classList.add("e-mousepointer");
            }
        }
        for(var count = 0; count < stdHdrCell.length; count++)if (this.allowReordering) stdHdrCell[parseInt(count.toString(), 10)].classList.add("e-mousepointer");
    };
    Grid.prototype.updateColumnModel = function(columns, isRecursion) {
        for(var i = 0, len = !(0, $3EnZW.isNullOrUndefined)(columns) ? columns.length : 0; i < len; i++)if (columns[parseInt(i.toString(), 10)].columns) this.updateColumnModel(columns[parseInt(i.toString(), 10)].columns, true);
        else this.columnModel.push(columns[parseInt(i.toString(), 10)]);
        if ((0, $3EnZW.isNullOrUndefined)(isRecursion) || !isRecursion) this.updateLockableColumns();
    };
    Grid.prototype.getFrozenLeftCount = function() {
        return this.getFrozenColumns() || this.getFrozenLeftColumnsCount();
    };
    Grid.prototype.isFrozenGrid = function() {
        return this.getFrozenColumns() !== 0 || this.frozenLeftColumns.length !== 0 || this.frozenRightColumns.length !== 0 || this.fixedColumns.length !== 0;
    };
    Grid.prototype.getFrozenMode = function() {
        return this.frozenName;
    };
    Grid.prototype.updateLockableColumns = function() {
        var cols = this.columnModel;
        var frozenCount = 0;
        var movableCount = 0;
        var frozenColumns = this.getFrozenColumns();
        for(var i = 0; i < cols.length; i++)if (cols[parseInt(i.toString(), 10)].lockColumn) {
            if (i < frozenColumns) {
                cols.splice(frozenCount, 0, cols.splice(i, 1)[0]);
                frozenCount++;
            } else {
                cols.splice(frozenColumns + movableCount, 0, cols.splice(i, 1)[0]);
                movableCount++;
            }
        }
    };
    Grid.prototype.checkLockColumns = function(cols) {
        for(var i = 0; i < cols.length; i++){
            if (cols[parseInt(i.toString(), 10)].columns) this.checkLockColumns(cols[parseInt(i.toString(), 10)].columns);
            else if (cols[parseInt(i.toString(), 10)].lockColumn) this.lockcolPositionCount++;
        }
    };
    /**
     * @param {string} position - specifies position
     * @returns {number} returns the width
     * @hidden
     */ Grid.prototype.leftrightColumnWidth = function(position) {
        var cols = position === "left" ? this.getFrozenLeftColumns() : position === "right" ? this.getFrozenRightColumns() : [];
        var width = 0;
        cols.filter(function(col) {
            if (col.visible) width += parseInt(col.width.toString(), 10);
        });
        return width;
    };
    /**
     * Gets the columns from the Grid.
     *
     * @param {boolean} isRefresh - Defines the boolean whether to refresh
     * @returns {Column[]} - returns the column
     */ Grid.prototype.getColumns = function(isRefresh) {
        var _this_1 = this;
        var inview = this.inViewIndexes.map(function(v) {
            return v - _this_1.groupSettings.columns.length;
        }).filter(function(v) {
            return v > -1;
        });
        var vLen = inview.length;
        if (!this.enableColumnVirtualization || (0, $3EnZW.isNullOrUndefined)(this.columnModel) || this.columnModel.length === 0 || isRefresh) {
            this.columnModel = [];
            this.updateColumnModel(this.columns);
        }
        var columns = vLen === 0 ? this.columnModel : this.columnModel.slice(inview[0], inview[vLen - 1] + 1);
        var left = [];
        var right = [];
        var movable = [];
        var isLeftRightFrozen = this.enableColumnVirtualization && this.isPreparedFrozenColumns && vLen === 0;
        if (isLeftRightFrozen) {
            this.frozenRightColumns = [];
            this.frozenLeftColumns = [];
        }
        for(var i = 0; i < columns.length; i++){
            if (columns[parseInt(i.toString(), 10)].freeze === "Left" || columns[parseInt(i.toString(), 10)].isFrozen) {
                left.push(columns[parseInt(i.toString(), 10)]);
                if (isLeftRightFrozen) this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Right") {
                right.push(columns[parseInt(i.toString(), 10)]);
                if (isLeftRightFrozen) this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
            } else movable.push(columns[parseInt(i.toString(), 10)]);
        }
        if (this.enableColumnVirtualization && this.isFrozenGrid()) {
            if (this.frozenLeftColumns.length) left = this.frozenLeftColumns;
            if (this.frozenRightColumns.length) right = this.frozenRightColumns;
        }
        return left.concat(movable).concat(right);
    };
    /**
     * @private
     * @param {string} stackedHeader - Defines the stacked header
     * @param {Column[]} col - Defines the column
     * @returns {Column} Returns the Column
     */ Grid.prototype.getStackedHeaderColumnByHeaderText = function(stackedHeader, col) {
        for(var i = 0; i < col.length; i++){
            var individualColumn = col[parseInt(i.toString(), 10)];
            if (individualColumn.field === stackedHeader || individualColumn.headerText === stackedHeader) {
                this.stackedColumn = individualColumn;
                break;
            } else if (individualColumn.columns) this.getStackedHeaderColumnByHeaderText(stackedHeader, individualColumn.columns);
        }
        return this.stackedColumn;
    };
    /**
     * @private
     * @returns {number[]} Returns the column indexes
     */ Grid.prototype.getColumnIndexesInView = function() {
        return this.inViewIndexes;
    };
    /**
     * @private
     * @returns {Query} - returns the query
     */ Grid.prototype.getQuery = function() {
        return this.query;
    };
    /**
     * @private
     * @returns {object} - returns the locale constants
     */ Grid.prototype.getLocaleConstants = function() {
        return this.defaultLocale;
    };
    /**
     * @param {number[]} indexes - specifies the indexes
     * @returns {void}
     * @private
     */ Grid.prototype.setColumnIndexesInView = function(indexes) {
        this.inViewIndexes = indexes;
    };
    /**
     * Gets the visible columns from the Grid.
     *
     * @returns {Column[]} returns the column
     */ Grid.prototype.getVisibleColumns = function() {
        return this.getCurrentVisibleColumns();
    };
    /**
     * Gets the header div of the Grid.
     *
     * @returns {Element} - Returns the element
     */ Grid.prototype.getHeaderContent = function() {
        return this.headerModule.getPanel();
    };
    /**
     * Sets the header div of the Grid to replace the old header.
     *
     * @param  {Element} element - Specifies the Grid header.
     *
     * @returns {void}
     */ Grid.prototype.setGridHeaderContent = function(element) {
        this.headerModule.setPanel(element);
    };
    /**
     * Gets the content table of the Grid.
     *
     * @returns {Element} - Returns the element
     */ Grid.prototype.getContentTable = function() {
        return this.contentModule.getTable();
    };
    /**
     * Sets the content table of the Grid to replace the old content table.
     *
     * @param  {Element} element - Specifies the Grid content table.
     *
     * @returns {void}
     */ Grid.prototype.setGridContentTable = function(element) {
        this.contentModule.setTable(element);
    };
    /**
     * Gets the content div of the Grid.
     *
     * @returns {Element} Returns the element
     */ Grid.prototype.getContent = function() {
        return this.contentModule.getPanel();
    };
    /**
     * Sets the content div of the Grid to replace the old Grid content.
     *
     * @param  {Element} element - Specifies the Grid content.
     *
     * @returns {void}
     */ Grid.prototype.setGridContent = function(element) {
        this.contentModule.setPanel(element);
    };
    /**
     * Gets the header table element of the Grid.
     *
     * @returns {Element} returns the element
     */ Grid.prototype.getHeaderTable = function() {
        return this.headerModule.getTable();
    };
    /**
     * Sets the header table of the Grid to replace the old one.
     *
     * @param  {Element} element - Specifies the Grid header table.
     *
     * @returns {void}
     */ Grid.prototype.setGridHeaderTable = function(element) {
        this.headerModule.setTable(element);
    };
    /**
     * Gets the footer div of the Grid.
     *
     * @returns {Element} returns the element
     */ Grid.prototype.getFooterContent = function() {
        this.footerElement = this.element.getElementsByClassName($1b5568e76cdae6d4$export$71ae40cd68e383eb)[0];
        return this.footerElement;
    };
    /**
     * Gets the footer table element of the Grid.
     *
     * @returns {Element} returns the element
     */ Grid.prototype.getFooterContentTable = function() {
        this.footerElement = this.element.getElementsByClassName($1b5568e76cdae6d4$export$71ae40cd68e383eb)[0];
        return this.footerElement.firstChild.firstChild;
    };
    /**
     * Gets the pager of the Grid.
     *
     * @returns {Element} returns the element
     */ Grid.prototype.getPager = function() {
        return this.gridPager; //get element from pager
    };
    /**
     * Sets the pager of the Grid to replace the old pager.
     *
     * @param  {Element} element - Specifies the Grid pager.
     *
     * @returns {void}
     */ Grid.prototype.setGridPager = function(element) {
        this.gridPager = element;
    };
    /**
     * Gets a row by index.
     *
     * @param  {number} index - Specifies the row index.
     *
     * @returns {Element} returns the element
     */ Grid.prototype.getRowByIndex = function(index) {
        if (this.enableVirtualization && this.groupSettings.enableLazyLoading) return this.lazyLoadRender.getRowByIndex(index);
        else return this.contentModule.getRowByIndex(index);
    };
    /**
     * Gets a movable tables row by index.
     *
     * @param  {number} index - Specifies the row index.
     *
     * @returns {Element} returns the element

     */ Grid.prototype.getMovableRowByIndex = function(index) {
        return this.contentModule.getRowByIndex(index);
    };
    /**
     * Gets a frozen tables row by index.
     *
     * @param  {number} index - Specifies the row index.
     * @returns {Element} returns the element

     */ Grid.prototype.getFrozenRowByIndex = function(index) {
        return this.contentModule.getRowByIndex(index);
    };
    /**
     * Gets all the data rows of the Grid.
     *
     * @returns {Element[]} returns the element
     */ Grid.prototype.getRows = function() {
        return this.contentModule.getRowElements();
    };
    /**
     * Gets a frozen right tables row element by index.
     *
     * @param  {number} index - Specifies the row index.
     * @returns {Element} returns the element

     */ Grid.prototype.getFrozenRightRowByIndex = function(index) {
        return this.contentModule.getRowByIndex(index);
    };
    /**
     * Get a row information based on cell
     *
     * @param {Element | EventTarget} target - specifies the element
     *
     * @returns {RowInfo} returns the row info
     */ Grid.prototype.getRowInfo = function(target) {
        var ele = target;
        var args = {
            target: target
        };
        if (!(0, $3EnZW.isNullOrUndefined)(target) && (0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(ele, "e-detailrowcollapse") && (0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(ele, "e-recordplusexpand")))) {
            var cell = (0, $4ZDHT.closest)(ele, "." + $1b5568e76cdae6d4$export$deb49d6cac2bdaca);
            if (!cell) {
                var row_1 = (0, $4ZDHT.closest)(ele, "." + $1b5568e76cdae6d4$export$120ff0929b202a6d);
                if (!(0, $3EnZW.isNullOrUndefined)(row_1) && !row_1.classList.contains("e-addedrow")) {
                    var rowObj = this.getRowObjectFromUID(row_1.getAttribute("data-uid"));
                    var rowIndex = parseInt(row_1.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                    args = {
                        row: row_1,
                        rowData: rowObj.data,
                        rowIndex: rowIndex
                    };
                }
                return args;
            }
            var cellIndex = parseInt(cell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
            var row_2 = (0, $4ZDHT.closest)(cell, "." + $1b5568e76cdae6d4$export$120ff0929b202a6d);
            if (!(0, $3EnZW.isNullOrUndefined)(cell) && !isNaN(cellIndex) && !(0, $3EnZW.isNullOrUndefined)(row_2)) {
                var rowIndex = parseInt(row_2.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
                var rows = this.contentModule.getRows();
                var index = cellIndex + this.getIndentCount();
                var rowsObject = rows.filter(function(r) {
                    return r.uid === row_2.getAttribute("data-uid");
                });
                var rowData = {};
                var column = void 0;
                if (Object.keys(rowsObject).length) {
                    rowData = rowsObject[0].data;
                    column = rowsObject[0].cells[parseInt(index.toString(), 10)].column;
                }
                args = {
                    cell: cell,
                    cellIndex: cellIndex,
                    row: row_2,
                    rowIndex: rowIndex,
                    rowData: rowData,
                    column: column,
                    target: target
                };
            }
        }
        return args;
    };
    /**
     * Gets the Grid's movable content rows from frozen grid.
     *
     * @returns {Element[]} returns the element

     */ Grid.prototype.getMovableRows = function() {
        return this.contentModule.getRowElements();
    };
    /**
     * Gets the Grid's frozen right content rows from frozen grid.
     *
     * @returns {Element[]} returns the element

     */ Grid.prototype.getFrozenRightRows = function() {
        return this.contentModule.getRowElements();
    };
    /**
     * Gets all the Grid's data rows.
     *
     * @returns {Element[]} returns the element
     */ Grid.prototype.getDataRows = function() {
        return this.getAllDataRows();
    };
    /**
     * @param {boolean} includeAdd - specifies includeAdd
     * @returns {Element[]} returns the element
     * @hidden
     */ Grid.prototype.getAllDataRows = function(includeAdd) {
        if ((0, $3EnZW.isNullOrUndefined)(this.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c))) return [];
        var tbody = this.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        var rows = [].slice.call(tbody.children);
        if (this.editSettings.showAddNewRow) {
            if (rows[0].classList.contains("e-addedrow")) rows.shift();
            else if (rows[rows.length - 1].classList.contains("e-addedrow")) rows.pop();
        }
        if (this.frozenRows) {
            var hdrTbody = this.getHeaderTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
            var freezeRows = [].slice.call(hdrTbody.children);
            rows = this.addMovableRows(freezeRows, rows);
            if (this.editSettings.showAddNewRow && freezeRows[0].classList.contains("e-addedrow")) freezeRows.shift();
        }
        var dataRows = this.generateDataRows(rows, includeAdd);
        return dataRows;
    };
    /**
     * @param {HTMLElement[]} fRows - Defines the frozen Rows
     * @param {HTMLElement[]} mrows - Defines the movable Rows
     * @returns {HTMLElement[]} Returns the element
     * @hidden
     */ Grid.prototype.addMovableRows = function(fRows, mrows) {
        for(var i = 0, len = mrows.length; i < len; i++)fRows.push(mrows[parseInt(i.toString(), 10)]);
        return fRows;
    };
    Grid.prototype.generateDataRows = function(rows, includAdd) {
        var dRows = [];
        for(var i = 0, len = rows.length; i < len; i++)if (rows[parseInt(i.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d) && (!rows[parseInt(i.toString(), 10)].classList.contains("e-hiddenrow") || includAdd)) {
            if (this.isCollapseStateEnabled()) dRows[parseInt(rows[parseInt(i.toString(), 10)].getAttribute("data-rowindex"), 10)] = rows[parseInt(i.toString(), 10)];
            else dRows.push(rows[parseInt(i.toString(), 10)]);
        }
        return dRows;
    };
    /**
     * Gets all the Grid's movable table data rows.
     *
     * @returns {Element[]} Returns the element

     */ Grid.prototype.getMovableDataRows = function() {
        return this.getAllMovableDataRows();
    };
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element

     * @hidden
     */ Grid.prototype.getAllMovableDataRows = function(includeAdd) {
        return this.getAllDataRows(includeAdd);
    };
    /**
     * Gets all the Grid's frozen table data rows.
     *
     * @returns {Element[]} returns the element

     */ Grid.prototype.getFrozenDataRows = function() {
        return this.getAllFrozenDataRows();
    };
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element

     * @hidden
     */ Grid.prototype.getAllFrozenDataRows = function(includeAdd) {
        return this.getAllDataRows(includeAdd);
    };
    /**
     * Gets all the Grid's frozen right table data rows.
     *
     * @returns {Element[]} Returns the Element

     */ Grid.prototype.getFrozenRightDataRows = function() {
        return this.getAllFrozenRightDataRows();
    };
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element

     * @hidden
     */ Grid.prototype.getAllFrozenRightDataRows = function(includeAdd) {
        return this.getAllDataRows(includeAdd);
    };
    /**
     * Updates particular cell value based on the given primary key value.
     * > Primary key column must be specified using `columns.isPrimaryKey` property.
     *
     * @param {string| number} key - Specifies the PrimaryKey value of dataSource.
     * @param {string } field - Specifies the field name which you want to update.
     * @param {string | number | boolean | Date} value - To update new value for the particular cell.
     *
     * @returns {void}
     */ Grid.prototype.setCellValue = function(key, field, value) {
        var cells = "cells";
        var rowData = "data";
        var rowIdx = "index";
        var rowuID = "uid";
        var pkName = this.getPrimaryKeyFieldNames()[0];
        var cell = new (0, $e992c1409d919677$export$efe8300dd67deed4)(this, this.serviceLocator);
        var fieldIdx = this.getColumnIndexByField(field);
        var col = this.getColumnByField(field);
        var rowObjects = this.contentModule.getRows();
        var selectedRow = rowObjects.filter(function(r) {
            return (0, $3EnZW.getValue)(pkName, r.data) === key;
        })[0];
        var tr = selectedRow ? this.element.querySelector("[data-uid=" + selectedRow["" + rowuID] + "]") : null;
        if (!(0, $3EnZW.isNullOrUndefined)(tr)) {
            if (typeof value === "string") value = this.sanitize(value);
            (0, $3EnZW.setValue)(field, value, selectedRow["" + rowData]);
            var td = this.enableVirtualization ? tr.children[parseInt(fieldIdx.toString(), 10)] : this.getCellFromIndex(selectedRow["" + rowIdx], fieldIdx);
            if (!(0, $3EnZW.isNullOrUndefined)(td)) {
                var Idx = 0;
                if (this.groupSettings.columns.length) fieldIdx = fieldIdx + this.groupSettings.columns.length;
                if (this.childGrid || this.detailTemplate) fieldIdx++;
                if (this.isRowDragable()) fieldIdx++;
                var sRow = selectedRow["" + cells][fieldIdx - Idx];
                cell.refreshTD(td, sRow, selectedRow["" + rowData], {
                    index: selectedRow["" + rowIdx]
                });
                if (this.isReact) td = this.enableVirtualization ? tr.children[parseInt(fieldIdx.toString(), 10)] : this.getCellFromIndex(selectedRow["" + rowIdx], fieldIdx);
                if (this.aggregates.length > 0) {
                    this.notify($17b89d3b1fc93cdb$export$14053228fa0745d8, {});
                    if (this.groupSettings.columns.length > 0) this.notify($17b89d3b1fc93cdb$export$7102324ec21b2ea7, {});
                }
                /* tslint:disable:no-string-literal */ if (!(0, $3EnZW.isNullOrUndefined)(selectedRow) && !(0, $3EnZW.isNullOrUndefined)(selectedRow["changes"])) selectedRow["changes"]["" + field] = value;
                /* tslint:disable:no-string-literal */ this.trigger($17b89d3b1fc93cdb$export$7a849352d4f0bf7b, {
                    cell: td,
                    column: col,
                    data: selectedRow["" + rowData]
                });
                if (this.isReact && td.getAttribute("tabindex") === "0" && td.classList.contains("e-focused")) td.focus();
            }
        } else return;
    };
    /**
     * @param {string} columnUid - Defines column uid
     * @param {boolean} renderTemplates - Defines renderTemplates need to invoke
     * @returns {void}
     * @hidden
     */ Grid.prototype.refreshReactColumnTemplateByUid = function(columnUid, renderTemplates) {
        var _this_1 = this;
        if (this.isReact) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.clearTemplate([
            "columnTemplate"
        ], undefined, function() {
            var isChildGrid = _this_1.childGrid && _this_1.element.querySelectorAll(".e-childgrid").length ? true : false;
            var rows = isChildGrid ? _this_1.getContentTable().querySelectorAll(".e-row") : _this_1.getDataRows();
            _this_1.refreshReactTemplateTD(rows, isChildGrid);
            if (renderTemplates) _this_1.renderTemplates();
        });
    };
    /**
     * @param {Element[] | NodeListOf<Element>} rows - Defines the rows
     * @param {boolean} isChildGrid - Defines whether it is a Hierarchy Grid.
     * @param {boolean} isFrozen - Defines whether it is a Frozen Grid
     * @returns {void}
     * @hidden
     */ Grid.prototype.refreshReactTemplateTD = function(rows, isChildGrid, isFrozen) {
        var cells = "cells";
        var rowIdx = "index";
        var indent = this.getIndentCount();
        var childIndent = 0;
        var isChildRow = false;
        for(var j = 0; j < rows.length; j++){
            var rowsObj = this.getRowObjectFromUID(rows[parseInt(j.toString(), 10)].getAttribute("data-uid"));
            if (isChildGrid && !rowsObj && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(rows[parseInt(j.toString(), 10)], "e-childgrid")) {
                var gridObj = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(rows[parseInt(j.toString(), 10)], "e-childgrid").ej2_instances[0];
                rowsObj = gridObj.getRowObjectFromUID(rows[parseInt(j.toString(), 10)].getAttribute("data-uid"));
                childIndent = gridObj.getIndentCount();
                isChildRow = true;
            }
            if (rowsObj && rowsObj.isDataRow && !(0, $3EnZW.isNullOrUndefined)(rowsObj.index) && !rows[parseInt(j.toString(), 10)].classList.contains("e-editedrow")) for(var i = 0; i < rowsObj["" + cells].length; i++){
                var cell = rowsObj["" + cells][parseInt(i.toString(), 10)];
                if (cell.isTemplate) {
                    var cellRenderer = new (0, $e992c1409d919677$export$efe8300dd67deed4)(this, this.serviceLocator);
                    var td = isChildGrid ? rows[parseInt(j.toString(), 10)].children[cell.index + (isChildRow ? childIndent : indent)] : this.getCellFromIndex(j, isFrozen ? cell.index : i - indent);
                    cellRenderer.refreshTD(td, cell, rowsObj.data, {
                        index: rowsObj["" + rowIdx]
                    });
                }
            }
            isChildRow = false;
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Grid.prototype.refreshGroupCaptionFooterTemplate = function() {
        var isChildGrid = this.childGrid && this.element.querySelectorAll(".e-childgrid").length ? true : false;
        var rows = this.getContentTable().querySelectorAll(".e-groupcaptionrow, .e-groupfooterrow");
        for(var i = 0; i < rows.length; i++){
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var gridObj = this;
            var rowsObj = this.getRowObjectFromUID(rows[parseInt(i.toString(), 10)].getAttribute("data-uid"));
            if (isChildGrid && !rowsObj && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(rows[parseInt(i.toString(), 10)], "e-childgrid")) {
                gridObj = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(rows[parseInt(i.toString(), 10)], "e-childgrid").ej2_instances[0];
                rowsObj = gridObj.getRowObjectFromUID(rows[parseInt(i.toString(), 10)].getAttribute("data-uid"));
            }
            if (rowsObj) {
                var cells = rowsObj.cells.filter(function(cell) {
                    return cell.isDataCell;
                });
                var args = {
                    cells: cells,
                    data: rowsObj.data,
                    dataUid: rowsObj.uid
                };
                gridObj.notify($17b89d3b1fc93cdb$export$195df17369c093a1, args);
            }
        }
    };
    /**
     * @param {string} columnUid - Defines column uid
     * @returns {void}
     * @hidden
     */ Grid.prototype.refreshReactHeaderTemplateByUid = function(columnUid) {
        if (this.isReact) {
            var cells = "cells";
            var rowsObj = this.headerModule.rows;
            var cellIndex = this.getNormalizedColumnIndex(columnUid);
            var _loop_1 = function(j) {
                var cell = rowsObj[parseInt(j.toString(), 10)]["" + cells][parseInt(cellIndex.toString(), 10)];
                if (cell && cell.column.uid === columnUid) {
                    var headerCellRenderer = new (0, $138c77c0bef20541$export$84ffe2c521da4c06)(this_1, this_1.serviceLocator);
                    var td = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this_1.element.querySelectorAll("[e-mappinguid=" + columnUid + "]")[0], "e-templatecell");
                    headerCellRenderer.refresh(cell, td);
                    var cols = this_1.sortSettings.columns;
                    var columnIndex = cols.findIndex(function(col) {
                        return col.field === cell.column.field;
                    });
                    if (columnIndex !== -1) {
                        var header = this_1.getColumnHeaderByField(cell.column.field);
                        this_1.ariaService.setSort(header, cols[parseInt(columnIndex.toString(), 10)].direction.toLowerCase());
                        if (cols.length > 1) header.querySelector(".e-headercelldiv").insertBefore(this_1.createElement("span", {
                            className: "e-sortnumber",
                            innerHTML: (columnIndex + 1).toString()
                        }), header.querySelector(".e-headertext"));
                        var filterElement = header.querySelector(".e-sortfilterdiv");
                        if (cols[parseInt(columnIndex.toString(), 10)].direction === "Ascending") (0, $4ZDHT.classList)(filterElement, [
                            "e-ascending",
                            "e-icon-ascending"
                        ], []);
                        else (0, $4ZDHT.classList)(filterElement, [
                            "e-descending",
                            "e-icon-descending"
                        ], []);
                    }
                }
            };
            var this_1 = this;
            for(var j = 0; j < rowsObj.length; j++)_loop_1(j);
        }
    };
    /**
     * Updates and refresh the particular row values based on the given primary key value.
     * > Primary key column must be specified using `columns.isPrimaryKey` property.
     *
     * @param {string| number} key - Specifies the PrimaryKey value of dataSource.
     * @param {Object} rowData - To update new data for the particular row.
     *
     * @returns {void}
     */ Grid.prototype.setRowData = function(key, rowData) {
        var rowuID = "uid";
        var rowObjects = this.contentModule.getRows();
        var pkName = this.getPrimaryKeyFieldNames()[0];
        if (this.groupSettings.columns.length > 0 && this.aggregates.length > 0) rowObjects = rowObjects.filter(function(row) {
            return row.isDataRow;
        });
        var selectedRow = rowObjects.filter(function(r) {
            return (0, $3EnZW.getValue)(pkName, r.data) === key;
        })[0];
        var selectRowEle = selectedRow ? [].slice.call(this.element.querySelectorAll("[data-uid=" + selectedRow["" + rowuID] + "]")) : undefined;
        if (!(0, $3EnZW.isNullOrUndefined)(selectedRow) && selectRowEle.length) {
            selectedRow.changes = rowData;
            if (this.frozenRows) {
                var fRowTr = this.getRowsObject()[selectedRow.index];
                this.setFrozenRowData(fRowTr, rowData);
            } else this.setFrozenRowData(selectedRow, rowData);
            if (this.aggregates.length > 0) {
                this.notify($17b89d3b1fc93cdb$export$14053228fa0745d8, {});
                if (this.groupSettings.columns.length > 0) this.notify($17b89d3b1fc93cdb$export$7102324ec21b2ea7, {});
            }
        } else return;
    };
    Grid.prototype.setFrozenRowData = function(fTr, rowData) {
        var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, this);
        fTr.changes = rowData;
        (0, $748c2240e597a9b7$export$64108eaaf316656b)(fTr, this.getForeignKeyColumns(), fTr.changes);
        rowRenderer.refresh(fTr, this.getColumns(), true);
    };
    /**
     * Gets a cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     *
     * @returns {Element} Returns the Element
     */ Grid.prototype.getCellFromIndex = function(rowIndex, columnIndex) {
        var col = this.getColumnByIndex(columnIndex);
        return (0, $748c2240e597a9b7$export$eb0a0b01b8ba40c0)(this, col, rowIndex, columnIndex);
    };
    /**
     * Gets a movable table cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     *
     * @returns {Element} Returns the Element

     */ Grid.prototype.getMovableCellFromIndex = function(rowIndex, columnIndex) {
        return this.getCellFromIndex(rowIndex, columnIndex);
    };
    /**
     * Gets a frozen right table cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     * @returns {Element} Returns the Element

     */ Grid.prototype.getFrozenRightCellFromIndex = function(rowIndex, columnIndex) {
        return this.getCellFromIndex(rowIndex, columnIndex);
    };
    /**
     * Gets a column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     *
     * @returns {Element} Returns the Element
     */ Grid.prototype.getColumnHeaderByIndex = function(index) {
        return this.getHeaderTable().getElementsByClassName("e-headercell")[parseInt(index.toString(), 10)];
    };
    /**
     * Gets a movable column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element

     */ Grid.prototype.getMovableColumnHeaderByIndex = function(index) {
        return this.getColumnHeaderByIndex(index);
    };
    /**
     * Gets a frozen right column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element

     */ Grid.prototype.getFrozenRightColumnHeaderByIndex = function(index) {
        return this.getColumnHeaderByIndex(index);
    };
    /**
     * Gets a frozen left column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element

     */ Grid.prototype.getFrozenLeftColumnHeaderByIndex = function(index) {
        return this.getColumnHeaderByIndex(index);
    };
    /**
     * @param {string} uid - Defines the uid
     * @returns {Row<Column>} Returns the row object
     * @hidden
     */ Grid.prototype.getRowObjectFromUID = function(uid) {
        var rows = this.contentModule.getRows();
        var row = this.rowObject(rows, uid);
        if ((0, $3EnZW.isNullOrUndefined)(row) && this.enableVirtualization && this.groupSettings.columns.length > 0) {
            row = this.rowObject(this.vRows, uid);
            return row;
        }
        return row;
    };
    Grid.prototype.rowObject = function(rows, uid) {
        if (rows) for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
            var row = rows_1[_i];
            if (row.uid === uid) return row;
        }
        return null;
    };
    /**
     * @hidden
     * @returns {Row<Column>[]} Returns the Row object
     */ Grid.prototype.getRowsObject = function() {
        return this.contentModule.getRows();
    };
    /**
     * @hidden
     * @returns {Row<Column>[]} Returns the Row object

     */ Grid.prototype.getMovableRowsObject = function() {
        return this.contentModule.getRows();
    };
    /**
     * @hidden
     * @returns {Row<Column>[]} Returns the Row object

     */ Grid.prototype.getFrozenRightRowsObject = function() {
        return this.contentModule.getRows();
    };
    /**
     * Gets a column header by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {Element} - Returns the element
     */ Grid.prototype.getColumnHeaderByField = function(field) {
        var column = this.getColumnByField(field);
        return column ? this.getColumnHeaderByUid(column.uid) : undefined;
    };
    /**
     * Gets a column header by UID.
     *
     * @param {string} uid - Specifies the column uid.
     *
     * @returns {Element} - Returns the element
     */ Grid.prototype.getColumnHeaderByUid = function(uid) {
        var element = this.getHeaderContent().querySelector("[e-mappinguid=" + uid + "]");
        return element ? element.parentElement : undefined;
    };
    /**
     * @hidden
     * @param {number} index - Defines the index
     * @returns {Column} Returns the column
     */ Grid.prototype.getColumnByIndex = function(index) {
        var column;
        this.getColumns().some(function(col, i) {
            column = col;
            return i === index;
        });
        return column;
    };
    /**
     * Gets a Column by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {Column} Returns the column
     */ Grid.prototype.getColumnByField = function(field) {
        return (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(this.getColumns(), function(item) {
            if (item.field === field) return item;
            return undefined;
        })[0];
    };
    /**
     * Gets a column index by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {number} Returns the index by field
     */ Grid.prototype.getColumnIndexByField = function(field) {
        var cols = this.getColumns();
        for(var i = 0; i < cols.length; i++){
            if (cols[parseInt(i.toString(), 10)].field === field) return i;
        }
        return -1;
    };
    /**
     * Gets a column by UID.
     *
     * @param  {string} uid - Specifies the column UID.
     *
     * @returns {Column} Returns the column
     */ Grid.prototype.getColumnByUid = function(uid) {
        return (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(this.getColumns().concat(this.getStackedColumns(this.columns)), function(item) {
            if (item.uid === uid) return item;
            return undefined;
        })[0];
    };
    /**
     * @param {Column[]} columns - Defines the columns
     * @param {Column[]} stackedColumn - Defines the stacked columns
     * @returns {Column[]} Returns the columns
     * @hidden
     */ Grid.prototype.getStackedColumns = function(columns, stackedColumn) {
        if (stackedColumn === void 0) stackedColumn = [];
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var column = columns_1[_i];
            if (column.columns) {
                stackedColumn.push(column);
                this.getStackedColumns(column.columns, stackedColumn);
            }
        }
        return stackedColumn;
    };
    /**
     * Gets a column index by UID.
     *
     * @param  {string} uid - Specifies the column UID.
     *
     * @returns {number} Returns the column by index
     */ Grid.prototype.getColumnIndexByUid = function(uid) {
        var index = (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(this.getColumns(), function(item, index) {
            if (item.uid === uid) return index;
            return undefined;
        })[0];
        return !(0, $3EnZW.isNullOrUndefined)(index) ? index : -1;
    };
    /**
     * Gets UID by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {string} Returns the column by field
     */ Grid.prototype.getUidByColumnField = function(field) {
        return (0, $748c2240e597a9b7$export$88cbd5a9815d5a0a)(this.getColumns(), function(item) {
            if (item.field === field) return item.uid;
            return undefined;
        })[0];
    };
    /**
     * Gets column index by column uid value.
     *
     * @private
     * @param  {string} uid - Specifies the column uid.
     * @returns {number} Returns the column by field
     */ Grid.prototype.getNormalizedColumnIndex = function(uid) {
        var index = this.getColumnIndexByUid(uid);
        return index + this.getIndentCount();
    };
    /**
     * Gets indent cell count.
     *
     * @private
     * @returns {number} Returns the indent count
     */ Grid.prototype.getIndentCount = function() {
        var index = 0;
        if (this.allowGrouping) index += this.groupSettings.columns.length;
        if (this.isDetail()) index++;
        if (this.isRowDragable() && (0, $3EnZW.isNullOrUndefined)(this.rowDropSettings.targetID)) index++;
        /**
         * TODO: index normalization based on the stacked header, grouping and detailTemplate
         * and frozen should be handled here
         */ return index;
    };
    /**
     * Gets the collection of column fields.
     *
     * @returns {string[]} Returns the Field names
     */ Grid.prototype.getColumnFieldNames = function() {
        var columnNames = [];
        var column;
        for(var i = 0, len = this.getColumns().length; i < len; i++){
            column = this.getColumns()[parseInt(i.toString(), 10)];
            if (column.visible) columnNames.push(column.field);
        }
        return columnNames;
    };
    /**
     * Gets a compiled row template.
     *
     * @returns {Function} Returns the row TEmplate
     * @private
     */ Grid.prototype.getRowTemplate = function() {
        return this.rowTemplateFn;
    };
    /**
     * Gets a compiled empty Record template.
     *
     * @returns {Function} Returns the empty Record template
     * @private
     */ Grid.prototype.getEmptyRecordTemplate = function() {
        return this.emptyRecordTemplateFn;
    };
    /**
     * Gets a compiled detail row template.
     *
     * @private
     * @returns {Function} Returns the Detail template
     */ Grid.prototype.getDetailTemplate = function() {
        return this.detailTemplateFn;
    };
    /**
     * Gets a compiled detail row template.
     *
     * @private
     * @returns {Function}Returns the Edit template
     */ Grid.prototype.getEditTemplate = function() {
        return this.editTemplateFn;
    };
    /**
     * Gets a compiled dialog edit header template.
     *
     * @private
     * @returns {Function} returns template function
     */ Grid.prototype.getEditHeaderTemplate = function() {
        return this.editHeaderTemplateFn;
    };
    /**
     * Gets a compiled dialog edit footer template.
     *
     * @private
     * @returns {Function} Returns the Footer template
     */ Grid.prototype.getEditFooterTemplate = function() {
        return this.editFooterTemplateFn;
    };
    /**
     * Get the names of the primary key columns of the Grid.
     *
     * @returns {string[]} Returns the field names
     */ Grid.prototype.getPrimaryKeyFieldNames = function() {
        var keys = [];
        for(var k = 0; k < this.columnModel.length; k++)if (this.columnModel[parseInt(k.toString(), 10)].isPrimaryKey) keys.push(this.columnModel[parseInt(k.toString(), 10)].field);
        return keys;
    };
    /**
     * Refreshes the Grid header and content.
     *
     * @returns {void}
     */ Grid.prototype.refresh = function() {
        if (!this.isDestroyed) {
            this.isManualRefresh = true;
            this.headerModule.refreshUI();
            this.updateStackedFilter();
            this.renderModule.refresh();
        }
    };
    /**
     * Refreshes the Grid header.
     *
     * @returns {void}
     */ Grid.prototype.refreshHeader = function() {
        this.headerModule.refreshUI();
    };
    /**
     * Gets the collection of selected rows.
     *
     * @returns {Element[]} Returns the element
     */ Grid.prototype.getSelectedRows = function() {
        return this.selectionModule ? this.selectionModule.selectedRecords : [];
    };
    /**
     * Gets the collection of selected row indexes.
     *
     * @returns {number[]} Returns the Selected row indexes
     */ Grid.prototype.getSelectedRowIndexes = function() {
        return this.selectionModule ? this.selectionModule.selectedRowIndexes : [];
    };
    /**
     * Gets the collection of selected row and cell indexes.
     *
     * @returns {number[]} Returns the Selected row cell indexes
     */ Grid.prototype.getSelectedRowCellIndexes = function() {
        return this.selectionModule ? this.selectionModule.selectedRowCellIndexes : [];
    };
    /**
     * Gets the collection of selected records.
     *
     * @returns {Object[]} Returns the selected records
     * @isGenericType true
     */ Grid.prototype.getSelectedRecords = function() {
        return this.selectionModule ? this.selectionModule.getSelectedRecords() : [];
    };
    /**
     * Gets the collection of selected columns uid.
     *
     * @returns {string[]} Returns the selected column uid
     * @isGenericType true
     */ Grid.prototype.getSelectedColumnsUid = function() {
        var _this_1 = this;
        var uid = [];
        if (this.selectionModule) this.selectionModule.selectedColumnsIndexes.filter(function(i) {
            return uid.push(_this_1.getColumns()[parseInt(i.toString(), 10)].uid);
        });
        return uid;
    };
    /**
     * Gets the data module.
     *
     * @returns {Data} Returns the data
     */ Grid.prototype.getDataModule = function() {
        return this.renderModule.data;
    };
    /**
     * Shows a column by its column name.
     *
     * @param  {string|string[]} keys - Defines a single or collection of column names.
     * @param  {string} showBy - Defines the column key either as field name or header text.
     *
     * @returns {void}
     */ Grid.prototype.showColumns = function(keys, showBy) {
        showBy = showBy ? showBy : "headerText";
        this.showHider.show(keys, showBy);
    };
    /**
     * Hides a column by column name.
     *
     * @param  {string|string[]} keys - Defines a single or collection of column names.
     * @param  {string} hideBy - Defines the column key either as field name or header text.
     *
     * @returns {void}
     */ Grid.prototype.hideColumns = function(keys, hideBy) {
        hideBy = hideBy ? hideBy : "headerText";
        this.showHider.hide(keys, hideBy);
    };
    /**
     * @hidden
     * @returns {number} Returns the Frozen column
     */ Grid.prototype.getFrozenColumns = function() {
        return this.frozenColumns + this.getFrozenCount(this.columns, 0, 0);
    };
    /**
     * @hidden
     * @returns {number} Returns the Frozen Right column count
     */ Grid.prototype.getFrozenRightColumnsCount = function() {
        return this.frozenRightCount || this.rightcount;
    };
    /**
     * @hidden
     * @returns {number} Returns the Frozen Left column
     */ Grid.prototype.getFrozenLeftColumnsCount = function() {
        return this.frozenLeftCount || this.leftcount;
    };
    /**
     * @hidden
     * @returns {number} Returns the movable column count
     */ Grid.prototype.getMovableColumnsCount = function() {
        return this.movableCount || this.movablecount;
    };
    Grid.prototype.updateFrozenColumnsWidth = function() {
        if (this.isFrozenGrid() && !this.enableColumnVirtualization) {
            var gcol = this.getColumns();
            var isAutoWidth = true;
            var autoCol_1 = 0;
            var difference_1 = 0;
            var autoWidth_1 = 0;
            var isFrozenAuto = gcol.some(function(data) {
                return (data.freeze === "Left" || data.freeze === "Right" || data.freeze === "Fixed" || data.isFrozen) && data.width === "auto";
            });
            var _loop_2 = function(i) {
                var col = gcol[parseInt(i.toString(), 10)];
                if ((0, $3EnZW.isNullOrUndefined)(col.width) && (col.freeze === "Left" || col.freeze === "Right" || col.freeze === "Fixed" || col.isFrozen)) {
                    col.width = Math.max(200, col.minWidth ? parseFloat(col.minWidth.toString()) : 0);
                    if (!(0, $3EnZW.isNullOrUndefined)(col.maxWidth) && parseFloat(col.maxWidth.toString()) < col.width) col.width = col.maxWidth;
                }
                if (col.width === "auto" && isFrozenAuto) {
                    var tWidth_1 = 0;
                    if (isAutoWidth) {
                        gcol.filter(function(cols) {
                            if (cols.visible) {
                                if (cols.width === "auto") autoCol_1++;
                                if (cols.width !== "auto") {
                                    var width = !(0, $3EnZW.isNullOrUndefined)(cols.width) ? parseFloat(cols.width.toString()) : Math.max(200, cols.minWidth ? parseFloat(cols.minWidth.toString()) : 0);
                                    tWidth_1 += width;
                                }
                            }
                        });
                        var gWidth = this_2.isPercentageWidthGrid() || this_2.width === "auto" ? this_2.element.getBoundingClientRect().width : parseFloat(this_2.width.toString());
                        difference_1 = this_2.height === "auto" ? gWidth - tWidth_1 : gWidth - tWidth_1 - (0, $748c2240e597a9b7$export$1df2a1438d36fb55)();
                        if (difference_1 < 0) difference_1 = 0;
                        autoWidth_1 = parseFloat((difference_1 / autoCol_1).toString());
                        gcol.filter(function(col) {
                            if (col.visible) {
                                if (col.minWidth && parseFloat(col.minWidth.toString()) > autoWidth_1) {
                                    difference_1 = difference_1 - parseFloat(col.minWidth.toString());
                                    autoCol_1--;
                                }
                            }
                        });
                        isAutoWidth = false;
                    }
                    if (col.minWidth && parseFloat(col.minWidth.toString()) > autoWidth_1) col.width = parseFloat(col.minWidth.toString());
                    else col.width = difference_1 / autoCol_1;
                }
            };
            var this_2 = this;
            for(var i = 0; i < gcol.length; i++)_loop_2(i);
        }
    };
    Grid.prototype.refreshSplitFrozenColumn = function() {
        this.splitFrozenCount(this.columns);
        this.updateFrozenColumnsWidth();
        this.isAutoGenerateColumns = true;
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.setFrozenCount = function() {
        this.frozenLeftCount = this.frozenRightCount = this.movableCount = 0;
        this.visibleFrozenLeft = this.visibleFrozenRight = this.visibleMovable = 0;
        this.frozenLeftColumns = [];
        this.frozenRightColumns = [];
        this.movableColumns = [];
        this.fixedColumns = [];
        this.splitFrozenCount(this.columns);
        this.leftcount = this.frozenLeftCount;
        this.rightcount = this.frozenRightCount;
        this.movablecount = this.movableCount;
        // if (this.frozenColumns && (this.frozenLeftCount || this.frozenRightCount)) {
        //     this.setProperties({ frozenColumns: 0 }, true);
        // }
        if (this.frozenLeftCount && !this.frozenRightCount) this.frozenName = "Left";
        else if (this.frozenRightCount && !this.frozenLeftCount) this.frozenName = "Right";
        else if (this.frozenLeftCount && this.frozenRightCount) this.frozenName = "Left-Right";
        else if (this.frozenColumns || this.frozenRows) this.frozenName = "Left";
        else this.frozenName = undefined;
    };
    /**
     * @hidden
     * @returns {number} Returns the visible Frozen left count
     */ Grid.prototype.getVisibleFrozenLeftCount = function() {
        return this.visibleFrozenLeft;
    };
    /**
     * @hidden
     * @returns {number} Returns the visible Frozen Right count
     */ Grid.prototype.getVisibleFrozenRightCount = function() {
        return this.visibleFrozenRight;
    };
    /**
     * @hidden
     * @returns {number} Returns the visible movable count
     */ Grid.prototype.getVisibleMovableCount = function() {
        return this.visibleMovable;
    };
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */ Grid.prototype.getFrozenRightColumns = function() {
        return this.frozenRightColumns;
    };
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */ Grid.prototype.getFrozenLeftColumns = function() {
        return this.frozenLeftColumns;
    };
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */ Grid.prototype.getMovableColumns = function() {
        return this.movableColumns;
    };
    Grid.prototype.splitStackedColumns = function(columns) {
        for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].columns) this.splitStackedColumns(columns[parseInt(i.toString(), 10)].columns);
        else {
            if (columns[parseInt(i.toString(), 10)].freeze === "Left" || columns[parseInt(i.toString(), 10)].isFrozen) {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleFrozenLeft++;
                this.leftcount++;
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Right") {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleFrozenRight++;
                this.rightcount++;
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Fixed") {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleFrozenFixed++;
                this.fixedcount++;
            } else {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleMovable++;
                this.movablecount++;
            }
        }
    };
    Grid.prototype.pushStackedColumns = function(columns, index, arr, col, stackedcol) {
        arr[parseInt(index.toString(), 10)] = col.headerText;
        for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].columns) {
            index = index + 1;
            this.pushStackedColumns(columns[parseInt(i.toString(), 10)].columns, index, arr, columns[parseInt(i.toString(), 10)], stackedcol);
            index = index - 1;
        } else {
            var stockCol = [];
            stockCol = arr.slice().slice(0, index + 1);
            if (columns[parseInt(i.toString(), 10)].freeze === "Left" || columns[parseInt(i.toString(), 10)].isFrozen) {
                this.stackedLeft.push(stockCol);
                this.stackedarrayLeft.push(columns[parseInt(i.toString(), 10)]);
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Right") {
                this.stackedRight.push(stockCol);
                this.stackedarrayRight.push(columns[parseInt(i.toString(), 10)]);
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Fixed") {
                this.stackedFixed.push(stockCol);
                this.stackedarrayFixed.push(columns[parseInt(i.toString(), 10)]);
            } else {
                this.stackedMovable.push(stockCol);
                this.stackedarrayMovable.push(columns[parseInt(i.toString(), 10)]);
            }
        }
    };
    Grid.prototype.pushallcol = function(text, text1, col, columns, isTrue) {
        if (col.headerText === text1) {
            if (isTrue) col.columns.push(columns);
            else col.columns.push({
                headerText: text,
                columns: []
            });
        } else {
            if (col.columns && col.columns.length) for(var i = 0; i < col.columns.length; i++)this.pushallcol(text, text1, col.columns[parseInt(i.toString(), 10)], columns, isTrue);
        }
    };
    Grid.prototype.resetStackedColumns = function(headercol, gridcolumns, freeze) {
        var col = {};
        var tempHead = [];
        for(var i = 1; i <= headercol.length; i++){
            var firstcol = headercol[i - 1];
            for(var j = 0; j < firstcol.length; j++){
                if (!col.columns && i === 1) {
                    col = {
                        headerText: firstcol[parseInt(j.toString(), 10)],
                        columns: []
                    };
                    tempHead.push(firstcol[parseInt(j.toString(), 10)]);
                } else if (tempHead.indexOf(firstcol[parseInt(j.toString(), 10)]) === -1) {
                    this.pushallcol(firstcol[parseInt(j.toString(), 10)], firstcol[j - 1], col);
                    tempHead.push(firstcol[parseInt(j.toString(), 10)]);
                }
                if (j === firstcol.length - 1) {
                    this.pushallcol(null, firstcol[parseInt(j.toString(), 10)], col, gridcolumns[i - 1], true);
                    var count = 0;
                    while(count !== headercol.length - 1 && i !== headercol.length){
                        if (firstcol.toString() === headercol[parseInt(i.toString(), 10)].toString()) {
                            i++;
                            this.pushallcol(null, firstcol[parseInt(j.toString(), 10)], col, gridcolumns[i - 1], true);
                        }
                        count++;
                    }
                }
            }
        }
        if (freeze === "Left") this.frozenLeftColumns.push(col);
        else if (freeze === "Right") this.frozenRightColumns.push(col);
        else this.movableColumns.push(col);
    };
    Grid.prototype.splitFrozenCount = function(columns) {
        if (this.frozenColumns || this.changedProperties && this.changedProperties.frozenColumns === 0) {
            var cols = !this.enableColumnVirtualization || this.enableColumnVirtualization && this.isPreparedFrozenColumns ? this.enableColumnVirtualization && this.columnModel && this.columnModel.length ? this.columnModel : this.getColumns() : this.columns;
            if (!this.changedProperties || this.changedProperties && !this.changedProperties.frozenColumns) for(var i = 0; i < cols.length; i++){
                if (this.frozenColumns > i) cols[parseInt(i.toString(), 10)].freeze = "Left";
                else if (cols[parseInt(i.toString(), 10)].freeze === "Right" || cols[parseInt(i.toString(), 10)].freeze === "Fixed") cols[parseInt(i.toString(), 10)].freeze = cols[parseInt(i.toString(), 10)].freeze;
                else cols[parseInt(i.toString(), 10)].freeze = undefined;
            }
        }
        for(var i = 0; i < (!(0, $3EnZW.isNullOrUndefined)(columns) ? columns.length : 0); i++)if (columns[parseInt(i.toString(), 10)].columns) {
            this.leftcount = 0;
            this.rightcount = 0;
            this.movablecount = 0;
            this.fixedcount = 0;
            var arr = [];
            this.splitStackedColumns(columns[parseInt(i.toString(), 10)].columns);
            if (this.leftcount && !this.rightcount && !this.movablecount && !this.fixedcount) {
                this.frozenLeftCount += this.leftcount;
                this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
            } else if (this.rightcount && !this.leftcount && !this.movablecount && !this.fixedcount) {
                this.frozenRightCount += this.rightcount;
                this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
            } else if (this.movablecount && !this.leftcount && !this.rightcount && !this.fixedcount) {
                this.movableCount += this.movablecount;
                this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
            } else if (this.fixedcount && !this.leftcount && !this.rightcount && !this.movablecount) {
                this.fixedCount += this.fixedcount;
                this.fixedColumns.push(columns[parseInt(i.toString(), 10)]);
                this.movableCount += this.movablecount;
                this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
            } else {
                this.frozenLeftCount += this.leftcount;
                this.frozenRightCount += this.rightcount;
                this.movableCount += this.movablecount;
                this.fixedCount += this.fixedcount;
                this.leftcount = 0;
                this.rightcount = 0;
                this.movablecount = 0;
                this.fixedcount = 0;
                this.stackedLeft = [];
                this.stackedRight = [];
                this.stackedFixed = [];
                this.stackedMovable = [];
                this.stackedarrayLeft = [];
                this.stackedarrayRight = [];
                this.stackedarrayFixed = [];
                this.stackedarrayMovable = [];
                this.pushStackedColumns(columns[parseInt(i.toString(), 10)].columns, 0, arr, columns[parseInt(i.toString(), 10)], {
                    headerText: columns[parseInt(i.toString(), 10)].headerText,
                    columns: []
                });
                if (this.stackedarrayLeft.length) this.resetStackedColumns(this.stackedLeft, this.stackedarrayLeft, "Left");
                if (this.stackedarrayRight.length) this.resetStackedColumns(this.stackedRight, this.stackedarrayRight, "Right");
                if (this.stackedarrayFixed.length) this.resetStackedColumns(this.stackedFixed, this.stackedarrayFixed, "Fixed");
                if (this.stackedarrayMovable.length) this.resetStackedColumns(this.stackedMovable, this.stackedarrayMovable, "Movable");
                this.stackedLeft = [];
                this.stackedRight = [];
                this.stackedMovable = [];
                this.stackedFixed = [];
                this.stackedarrayLeft = [];
                this.stackedarrayRight = [];
                this.stackedarrayMovable = [];
                this.stackedarrayFixed = [];
            }
        } else {
            if (columns[parseInt(i.toString(), 10)].freeze === "Right") {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleFrozenRight++;
                this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
                this.frozenRightCount++;
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Left" || columns[parseInt(i.toString(), 10)].isFrozen) {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleFrozenLeft++;
                this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
                this.frozenLeftCount++;
            } else if (columns[parseInt(i.toString(), 10)].freeze === "Fixed") {
                this.fixedColumns.push(columns[parseInt(i.toString(), 10)]);
                this.fixedCount++;
                this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                this.movableCount++;
            } else {
                if (columns[parseInt(i.toString(), 10)].visible !== false) this.visibleMovable++;
                this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                this.movableCount++;
            }
        }
        if (this.frozenLeftColumns.length) {
            var cols = this.frozenLeftColumns[this.frozenLeftColumns.length - 1];
            this.removeBorder(this.frozenLeftColumns);
            this.frozenLeftBorderColumns(cols instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc) ? this.lastVisibleLeftCol(this.frozenLeftColumns) : cols);
        }
        if (this.frozenRightColumns.length) {
            var cols = this.frozenRightColumns[0];
            this.removeBorder(this.frozenRightColumns);
            this.frozenRightBorderColumns(cols instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc) ? this.firstVisibleRightCol(this.frozenRightColumns) : cols);
        }
        if ((this.frozenLeftColumns.length || this.frozenRightColumns.length) && this.freezeColumnRefresh) {
            var cols = this.frozenLeftColumns.concat(this.movableColumns).concat(this.frozenRightColumns);
            this.setProperties({
                columns: cols
            }, true);
            this.freezeColumnRefresh = false;
        }
    };
    Grid.prototype.removeBorder = function(columns) {
        for(var i = 0; i < columns.length; i++){
            if (columns[parseInt(i.toString(), 10)].columns && columns[parseInt(i.toString(), 10)].columns.length) {
                if (columns[parseInt(i.toString(), 10)].border === "Right" || columns[parseInt(i.toString(), 10)].border === "Left") columns[parseInt(i.toString(), 10)].border = undefined;
                this.removeBorder(columns[parseInt(i.toString(), 10)].columns);
            } else if (columns[parseInt(i.toString(), 10)].border === "Right" || columns[parseInt(i.toString(), 10)].border === "Left") columns[parseInt(i.toString(), 10)].border = undefined;
        }
    };
    Grid.prototype.isVisibleColumns = function(column, arr) {
        if (column.columns && column.columns.length) for(var i = 0; i < column.columns.length; i++){
            this.isVisibleColumns(column.columns[parseInt(i.toString(), 10)], arr);
            if (column.columns[parseInt(i.toString(), 10)].visible && (0, $3EnZW.isNullOrUndefined)(column.columns[parseInt(i.toString(), 10)].columns) && (!(0, $3EnZW.isNullOrUndefined)(column.columns[parseInt(i.toString(), 10)].freeze) || column.columns[parseInt(i.toString(), 10)].isFrozen)) arr.push("true");
        }
        else if (column.visible && (!(0, $3EnZW.isNullOrUndefined)(column.freeze) || column.isFrozen)) arr.push("true");
    };
    Grid.prototype.lastVisibleLeftCol = function(columns) {
        var column;
        for(var i = columns.length - 1; i >= 0; i--){
            var arr = [];
            this.isVisibleColumns(columns[parseInt(i.toString(), 10)], arr);
            if (columns[parseInt(i.toString(), 10)].visible && arr.indexOf("true") !== -1) {
                column = columns[parseInt(i.toString(), 10)];
                break;
            }
        }
        return column;
    };
    Grid.prototype.firstVisibleRightCol = function(columns) {
        var column;
        for(var i = 0; i < columns.length; i++){
            var arr = [];
            this.isVisibleColumns(columns[parseInt(i.toString(), 10)], arr);
            if (columns[parseInt(i.toString(), 10)].visible && arr.indexOf("true") !== -1) {
                column = columns[parseInt(i.toString(), 10)];
                break;
            }
        }
        return column;
    };
    Grid.prototype.frozenLeftBorderColumns = function(columns) {
        if ((0, $3EnZW.isNullOrUndefined)(columns)) return;
        if (columns.columns && columns.columns.length) {
            columns.border = "Left";
            var cols = columns.columns[columns.columns.length - 1];
            this.frozenLeftBorderColumns(cols instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc) && cols.columns ? this.lastVisibleLeftCol(columns.columns) : cols);
        } else columns.border = "Left";
    };
    Grid.prototype.frozenRightBorderColumns = function(columns) {
        if ((0, $3EnZW.isNullOrUndefined)(columns)) return;
        if (columns.columns && columns.columns.length) {
            columns.border = "Right";
            var cols = columns.columns[0];
            this.frozenRightBorderColumns(cols instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc) && cols.columns ? this.firstVisibleRightCol(columns.columns) : cols);
        } else columns.border = "Right";
    };
    /**
     * @hidden
     * @returns {number} Returns the visible frozen columns count
     */ Grid.prototype.getVisibleFrozenColumns = function() {
        return this.getVisibleFrozenColumnsCount() + this.getVisibleFrozenCount(this.columns, 0);
    };
    /**
     * Get the current Filter operator and field.
     *
     * @returns {FilterUI} Returns the filter UI
     */ Grid.prototype.getFilterUIInfo = function() {
        return this.filterModule ? this.filterModule.getFilterUIInfo() : {};
    };
    Grid.prototype.getVisibleFrozenColumnsCount = function() {
        var visibleFrozenColumns = 0;
        var columns = this.columnModel;
        for(var i = 0; i < this.frozenColumns; i++)if (columns[parseInt(i.toString(), 10)].visible) visibleFrozenColumns++;
        if (this.frozenLeftCount || this.leftcount || this.frozenRightCount || this.rightcount) {
            for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].visible && (columns[parseInt(i.toString(), 10)].freeze === "Left" || columns[parseInt(i.toString(), 10)].freeze === "Right")) visibleFrozenColumns++;
        }
        return visibleFrozenColumns;
    };
    Grid.prototype.getVisibleFrozenCount = function(cols, cnt) {
        if (!this.frozenLeftCount && !this.leftcount && (!this.frozenRightCount || !this.rightcount)) for(var i = 0, len = cols.length; i < len; i++){
            if (cols[parseInt(i.toString(), 10)].columns) cnt = this.getVisibleFrozenCount(cols[parseInt(i.toString(), 10)].columns, cnt);
            else if (cols[parseInt(i.toString(), 10)].isFrozen && cols[parseInt(i.toString(), 10)].visible) cnt++;
        }
        return cnt;
    };
    Grid.prototype.getFrozenCount = function(cols, cnt, index) {
        for(var i = 0, len = !(0, $3EnZW.isNullOrUndefined)(cols) ? cols.length : 0; i < len; i++)if (cols[parseInt(i.toString(), 10)].columns) cnt = this.getFrozenCount(cols[parseInt(i.toString(), 10)].columns, cnt, index);
        else {
            if (cols[parseInt(i.toString(), 10)].isFrozen && index > this.frozenColumns - 1) cnt++;
            index++;
        }
        return cnt;
    };
    /**
     * Navigates to the specified target page.
     *
     * @param  {number} pageNo - Defines the page number to navigate.
     *
     * @returns {void}
     */ Grid.prototype.goToPage = function(pageNo) {
        if (this.pagerModule) this.pagerModule.goToPage(pageNo);
    };
    /**
     * Defines the text of external message.
     *
     * @param  {string} message - Defines the message to update.
     *
     * @returns {void}
     */ Grid.prototype.updateExternalMessage = function(message) {
        if (this.pagerModule && !this.pagerTemplate) this.pagerModule.updateExternalMessage(message);
    };
    /**
     * Sorts a column with the given options.
     *
     * @param {string} columnName - Defines the column name to be sorted.
     * @param {SortDirection} direction - Defines the direction of sorting field.
     * @param {boolean} isMultiSort - Specifies whether the previous sorted columns are to be maintained.
     *
     * @returns {void}
     */ Grid.prototype.sortColumn = function(columnName, direction, isMultiSort) {
        if (this.sortModule) this.sortModule.sortColumn(columnName, direction, isMultiSort);
    };
    /**
     * Remove the existing columns along with the grid actions like sorting, filtering, searching, grouping, aggregate, etc., and grid will refresh with new columns based on the updated new data source.
     * > * If no columns are specified while changing the data source, then the columns are auto generated in the Grid based on the list of columns in the updated data source.
     *
     * @param {Object | DataManager | DataResult} dataSource -  Assign the new datasource.
     * @param {Column[] | string[] | ColumnModel[]} columns - Defines columns.
     * @returns {void}
     *
     *
     * ```typescript
     * <button id="btn">change dataSource </button>
     * <div id="Grid"></div>
     * <script>
     * let gridObj: Grid = new Grid({
     *     dataSource: employeeData,  // you can define the datamanager here if you are binding a data through datamanager
     *     columns: [
     *         { field: 'OrderID', headerText: 'Order ID', width:100 },
     *         { field: 'EmployeeID', headerText: 'Employee ID' }],
     * });
     * gridObj.appendTo('#Grid');
     * document.getElementById('btn').addEventListener("click", function(){
     * let newColumn: [
     *     { field: 'CustomerID', headerText: 'Customer ID', width:100 },
     *     { field: 'FirstName', headerText: 'Name' }];
     * gridObj.changeDataSource(customerData, newColumn);
     * });
     * </script>
     * ```
     *
     */ Grid.prototype.changeDataSource = function(dataSource, columns) {
        this.isChangeDataSourceCall = true;
        this.setProperties({
            sortSettings: {
                columns: []
            }
        }, true);
        this.setProperties({
            filterSettings: {
                columns: []
            }
        }, true);
        this.setProperties({
            searchSettings: {
                key: ""
            }
        }, true);
        if (this.allowGrouping) this.setProperties({
            groupSettings: {
                columns: []
            }
        }, true);
        if (columns && columns.length) this.setProperties({
            columns: columns
        }, true);
        if (dataSource) {
            if ((0, $3EnZW.isNullOrUndefined)(columns)) this.setProperties({
                columns: []
            }, true);
            this.setProperties({
                dataSource: dataSource
            }, true);
        }
        this.freezeRefresh();
        this.isChangeDataSourceCall = false;
    };
    /**
     * Clears all the sorted columns of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.clearSorting = function() {
        if (this.sortModule) this.sortModule.clearSorting();
    };
    /**
     * Remove sorted column by field name.
     *
     * @param {string} field - Defines the column field name to remove sort.
     * @returns {void}
     * @hidden
     */ Grid.prototype.removeSortColumn = function(field) {
        if (this.sortModule) this.sortModule.removeSortColumn(field);
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.clearGridActions = function() {
        this.setProperties({
            sortSettings: {
                columns: []
            }
        }, true);
        this.setProperties({
            filterSettings: {
                columns: []
            }
        }, true);
        this.setProperties({
            searchSettings: {
                key: ""
            }
        }, true);
        if (this.allowGrouping) this.setProperties({
            groupSettings: {
                columns: []
            }
        }, false);
        else this.freezeRefresh();
    };
    /**
     * Filters grid row by column name with the given options.
     *
     * @param  {string} fieldName - Defines the field name of the column.
     * @param  {string} filterOperator - Defines the operator to filter records.
     * @param  {string | number | Date | boolean} filterValue - Defines the value used to filter records.
     * @param  {string} predicate - Defines the relationship between one filter query and another by using AND or OR predicate.
     * @param  {boolean} matchCase - If match case is set to true, the grid filters the records with exact match. if false, it filters case
     * insensitive records (uppercase and lowercase letters treated the same).
     * @param  {boolean} ignoreAccent - If ignoreAccent set to true,
     * then filter ignores the diacritic characters or accents while filtering.
     * @param  {string} actualFilterValue - Defines the actual filter value for the filter column.
     * @param  {string} actualOperator - Defines the actual filter operator for the filter column.
     *
     * @returns {void}
     */ Grid.prototype.filterByColumn = function(fieldName, filterOperator, filterValue, predicate, matchCase, ignoreAccent, actualFilterValue, actualOperator) {
        if (this.filterModule) this.filterModule.filterByColumn(fieldName, filterOperator, filterValue, predicate, matchCase, ignoreAccent, actualFilterValue, actualOperator);
    };
    /**
     * Clears all the filtered rows of the Grid.
     *
     * @param {string[]} fields - Defines the Fields
     * @returns {void}
     */ Grid.prototype.clearFiltering = function(fields) {
        if (this.filterModule) this.filterModule.clearFiltering(fields);
    };
    /**
     * Removes filtered column by field name.
     *
     * @param  {string} field - Defines column field name to remove filter.
     * @param  {boolean} isClearFilterBar -  Specifies whether the filter bar value needs to be cleared.
     * @returns {void}
     * @hidden
     */ Grid.prototype.removeFilteredColsByField = function(field, isClearFilterBar) {
        if (this.filterModule) this.filterModule.removeFilteredColsByField(field, isClearFilterBar);
    };
    /**
     * Selects a row by given index.
     *
     * @param  {number} index - Defines the row index.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     *
     * @returns {void}
     */ Grid.prototype.selectRow = function(index, isToggle) {
        if (this.selectionModule) this.selectionModule.selectRow(index, isToggle);
    };
    /**
     * Selects a collection of rows by indexes.
     *
     * @param  {number[]} rowIndexes - Specifies the row indexes.
     *
     * @returns {void}
     */ Grid.prototype.selectRows = function(rowIndexes) {
        if (this.selectionModule) this.selectionModule.selectRows(rowIndexes);
    };
    /**
     * Deselects the current selected rows and cells.
     *
     * @returns {void}
     */ Grid.prototype.clearSelection = function() {
        if (this.selectionModule) this.selectionModule.clearSelection();
    };
    /**
     * Selects a cell by the given index.
     *
     * @param  {IIndex} cellIndex - Defines the row and column indexes.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     *
     * @returns {void}
     */ Grid.prototype.selectCell = function(cellIndex, isToggle) {
        if (this.selectionModule) this.selectionModule.selectCell(cellIndex, isToggle);
    };
    /**
     * Selects a range of cells from start and end indexes.
     *
     * @param  {IIndex} startIndex - Specifies the row and column's start index.
     * @param  {IIndex} endIndex - Specifies the row and column's end index.
     *
     * @returns {void}
     */ Grid.prototype.selectCellsByRange = function(startIndex, endIndex) {
        this.selectionModule.selectCellsByRange(startIndex, endIndex);
    };
    /**
     * Searches Grid records using the given key.
     * You can customize the default search option by using the
     * [`searchSettings`](./#searchsettings/).
     *
     * @param  {string} searchString - Defines the key.
     *
     * @returns {void}
     */ Grid.prototype.search = function(searchString) {
        if (this.searchModule) this.searchModule.search(searchString);
    };
    /**
     * By default, prints all the pages of the Grid and hides the pager.
     * > You can customize print options using the
     * [`printMode`](./#printmode).
     *
     * @returns {void}
     */ Grid.prototype.print = function() {
        if (this.printModule) this.printModule.print();
    };
    /**
     * Delete a record with Given options. If fieldname and data is not given then grid will delete the selected record.
     * > `editSettings.allowDeleting` should be true.
     *
     * @param {string} fieldname - Defines the primary key field, 'Name of the column'.
     * @param {Object} data - Defines the JSON data of the record to be deleted.
     * @returns {void}
     */ Grid.prototype.deleteRecord = function(fieldname, data) {
        if (this.editModule) this.editModule.deleteRecord(fieldname, data);
    };
    /**
     * Starts edit the selected row. At least one row must be selected before invoking this method.
     * `editSettings.allowEditing` should be true.
     * {% codeBlock src='grid/startEdit/index.md' %}{% endcodeBlock %}
     *
     * @returns {void}
     */ Grid.prototype.startEdit = function() {
        if (this.editModule) this.editModule.startEdit();
    };
    /**
     * If Grid is in editable state, you can save a record by invoking endEdit.
     *
     * @returns {void}
     */ Grid.prototype.endEdit = function() {
        if (this.editModule) this.editModule.endEdit();
    };
    /**
     * Cancels edited state.
     *
     * @returns {void}
     */ Grid.prototype.closeEdit = function() {
        if (this.editModule) this.editModule.closeEdit();
    };
    /**
     * Adds a new record to the Grid. Without passing parameters, it adds empty rows.
     * > `editSettings.allowEditing` should be true.
     *
     * @param {Object} data - Defines the new add record data.
     * @param {number} index - Defines the row index to be added
     * @returns {void}
     */ Grid.prototype.addRecord = function(data, index) {
        if (this.editModule) this.editModule.addRecord(data, index);
    };
    /**
     * Delete any visible row by TR element.
     *
     * @param {HTMLTableRowElement} tr - Defines the table row element.
     * @returns {void}
     */ Grid.prototype.deleteRow = function(tr) {
        if (this.editModule) this.editModule.deleteRow(tr);
    };
    /**
     * Changes a particular cell into edited state based on the row index and field name provided in the `batch` mode.
     *
     * @param {number} index - Defines row index to edit a particular cell.
     * @param {string} field - Defines the field name of the column to perform batch edit.
     *
     * @returns {void}
     */ Grid.prototype.editCell = function(index, field) {
        if (this.editModule) this.editModule.editCell(index, field);
    };
    /**
     * Saves the cell that is currently edited. It does not save the value to the DataSource.
     *
     * @returns {void}
     * {% codeBlock src='grid/saveCell/index.md' %}{% endcodeBlock %}
     */ Grid.prototype.saveCell = function() {
        if (this.editModule) this.editModule.saveCell();
    };
    /**
     * To update the specified cell by given value without changing into edited state.
     *
     * @param {number} rowIndex Defines the row index.
     * @param {string} field Defines the column field.
     * @param {string | number | boolean | Date} value - Defines the value to be changed.
     *
     * @returns {void}
     */ Grid.prototype.updateCell = function(rowIndex, field, value) {
        if (this.editModule) this.editModule.updateCell(rowIndex, field, value);
    };
    /**
     * To update the specified row by given values without changing into edited state.
     *
     * {% codeBlock src='grid/updateRow/index.md' %}{% endcodeBlock %}
     *
     * @param {number} index Defines the row index.
     * @param {Object} data Defines the data object to be updated.
     *
     * @returns {void}
     */ Grid.prototype.updateRow = function(index, data) {
        if (this.editModule) this.editModule.updateRow(index, data);
    };
    /**
     * Gets the added, edited,and deleted data before bulk save to the DataSource in batch mode.
     *
     * @returns {Object} Returns the batch changes
     */ Grid.prototype.getBatchChanges = function() {
        if (this.editModule) return this.editModule.getBatchChanges();
        return {};
    };
    /**
     * Enables or disables ToolBar items.
     *
     * @param {string[]} items - Defines the collection of itemID of ToolBar items.
     * @param {boolean} isEnable - Defines the items to be enabled or disabled.
     *
     * @returns {void}
     */ Grid.prototype.enableToolbarItems = function(items, isEnable) {
        if (this.toolbarModule) this.toolbarModule.enableItems(items, isEnable);
    };
    /**
     * Copy the selected rows or cells data into clipboard.
     *
     * @param {boolean} withHeader - Specifies whether the column header text needs to be copied along with rows or cells.
     * @returns {void}
     */ Grid.prototype.copy = function(withHeader) {
        if (this.clipboardModule) this.clipboardModule.copy(withHeader);
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.recalcIndentWidth = function() {
        var _this_1 = this;
        if (!this.getHeaderTable().querySelector(".e-emptycell")) return;
        if (!this.groupSettings.columns.length && !this.isDetail() && !this.isRowDragable() || this.getHeaderTable().querySelector(".e-emptycell").getAttribute("indentRefreshed") || !this.getContentTable()) return;
        var indentWidth = this.getHeaderTable().querySelector(".e-emptycell").parentElement.offsetWidth;
        var headerCol = [].slice.call(this.getHeaderTable().querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).childNodes);
        var contentCol = [].slice.call(this.getContentTable().querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).childNodes);
        var perPixel = indentWidth / 30;
        var i = this.getFrozenMode() === "Right" ? this.groupSettings.columns.length + this.getColumns().length : 0;
        var parentOffset = this.element.offsetWidth;
        var applyWidth = function(index, width) {
            if ((0, $748c2240e597a9b7$export$4605faa9bb01ebb8)(_this_1)) {
                var newWidth = (width / parentOffset * 100).toFixed(1) + "%";
                headerCol[parseInt(index.toString(), 10)].style.width = newWidth;
                contentCol[parseInt(index.toString(), 10)].style.width = newWidth;
            } else {
                headerCol[parseInt(index.toString(), 10)].style.width = width + "px";
                contentCol[parseInt(index.toString(), 10)].style.width = width + "px";
            }
            _this_1.notify($17b89d3b1fc93cdb$export$deabcf5530617ea3, {
                index: index,
                width: width
            });
        };
        if (perPixel >= 1) indentWidth = 30 / perPixel;
        if (indentWidth < 1) indentWidth = 1;
        if (this.enableColumnVirtualization || this.isAutoGen || this.columns.length === this.groupSettings.columns.length) indentWidth = 30;
        while(i < this.groupSettings.columns.length){
            applyWidth(i, indentWidth);
            i++;
        }
        if (this.isDetail()) {
            applyWidth(i, indentWidth);
            i++;
        }
        if (this.isRowDragable()) applyWidth(i, indentWidth);
        this.isAutoGen = false;
        this.getHeaderTable().querySelector(".e-emptycell").setAttribute("indentRefreshed", "true");
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.resetIndentWidth = function() {
        if (this.isDestroyed) return;
        if ((0, $748c2240e597a9b7$export$4605faa9bb01ebb8)(this)) {
            this.getHeaderTable().querySelector(".e-emptycell").removeAttribute("indentRefreshed");
            this.widthService.setWidthToColumns();
            this.recalcIndentWidth();
            if (this.autoFit) this.preventAdjustColumns();
        }
        if ((this.width === "auto" || typeof this.width === "string" && this.width.indexOf("%") !== -1) && this.getColumns().filter(function(col) {
            return (!col.width || col.width === "auto") && col.minWidth;
        }).length > 0) {
            var tgridWidth = this.widthService.getTableWidth(this.getColumns(), true);
            this.widthService.setMinwidthBycalculation(tgridWidth);
        }
        if (this.isFrozenGrid() && this.enableColumnVirtualization && this.widthService) this.widthService.refreshFrozenScrollbar();
        if (this.allowTextWrap && this.textWrapSettings.wrapMode !== "Content") this.notify($17b89d3b1fc93cdb$export$d5e4329e23182602, {});
        if (this.frozenRows && this.scrollModule) this.scrollModule.resizeFrozenRowBorder();
        if (this.enableStickyHeader) this.scrollModule.makeStickyHeader();
        if (this.enableAutoFill && this.selectionSettings.type === "Multiple" && this.selectionModule && this.selectionSettings.mode === "Cell" && this.selectionModule.selectedRowCellIndexes.length) {
            this.selectionModule.updateAutoFillPosition();
            this.selectionModule.drawBorders();
        }
    };
    /**
     * @hidden
     * @returns {boolean} Returns isRowDragable
     */ Grid.prototype.isRowDragable = function() {
        return this.allowRowDragAndDrop && !this.rowDropSettings.targetID;
    };
    /**
     * Changes the Grid column positions by field names.
     *
     * @param  {string} fromFName - Defines the origin field name.
     * @param  {string} toFName - Defines the destination field name.
     *
     * @returns {void}
     */ Grid.prototype.reorderColumns = function(fromFName, toFName) {
        if (this.reorderModule) this.reorderModule.reorderColumns(fromFName, toFName);
    };
    /**
     * Changes the Grid column positions by field index. If you invoke reorderColumnByIndex multiple times,
     * then you won't get the same results every time.
     *
     * @param  {number} fromIndex - Defines the origin field index.
     * @param  {number} toIndex - Defines the destination field index.
     *
     * @returns {void}
     */ Grid.prototype.reorderColumnByIndex = function(fromIndex, toIndex) {
        if (this.reorderModule) this.reorderModule.reorderColumnByIndex(fromIndex, toIndex);
    };
    /**
     * Changes the Grid column positions by field index. If you invoke reorderColumnByTargetIndex multiple times,
     * then you will get the same results every time.
     *
     * @param  {string} fieldName - Defines the field name.
     * @param  {number} toIndex - Defines the destination field index.
     *
     * @returns {void}
     */ Grid.prototype.reorderColumnByTargetIndex = function(fieldName, toIndex) {
        if (this.reorderModule) this.reorderModule.reorderColumnByTargetIndex(fieldName, toIndex);
    };
    /**
     * Changes the Grid Row position with given indexes.
     *
     * @param  {number} fromIndexes - Defines the origin Indexes.
     * @param  {number} toIndex - Defines the destination Index.
     *
     * @returns {void}
     */ Grid.prototype.reorderRows = function(fromIndexes, toIndex) {
        if (this.rowDragAndDropModule) this.rowDragAndDropModule.reorderRows(fromIndexes, toIndex);
    };
    /**
     * @param {ReturnType} e - Defines the Return type
     * @returns {void}
     * @hidden
     */ Grid.prototype.refreshDataSource = function(e) {
        this.notify("refreshdataSource", e);
    };
    /**
     * @param {boolean} enable -Defines the enable
     * @returns {void}
     * @hidden
     */ Grid.prototype.disableRowDD = function(enable) {
        var headerTable = this.getHeaderTable();
        var contentTable = this.getContentTable();
        var headerRows = headerTable.querySelectorAll("th.e-rowdragheader, th.e-mastercell");
        var rows = this.getRows();
        var disValue = enable ? "none" : "";
        (0, $4ZDHT.setStyleAttribute)(headerTable.querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).childNodes[0], {
            "display": disValue
        });
        (0, $4ZDHT.setStyleAttribute)(contentTable.querySelector($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9).childNodes[0], {
            "display": disValue
        });
        for(var i = 0; i < this.getRows().length; i++){
            var ele = rows[parseInt(i.toString(), 10)].firstElementChild;
            if (enable) (0, $4ZDHT.addClass)([
                ele
            ], "e-hide");
            else (0, $4ZDHT.removeClass)([
                ele
            ], [
                "e-hide"
            ]);
        }
        for(var j = 0; j < headerTable.querySelectorAll("th.e-rowdragheader, th.e-mastercell").length; j++){
            var ele = headerRows[parseInt(j.toString(), 10)];
            if (enable) (0, $4ZDHT.addClass)([
                ele
            ], "e-hide");
            else (0, $4ZDHT.removeClass)([
                ele
            ], [
                "e-hide"
            ]);
        }
    };
    /**
     * Changes the column width to automatically fit its content to ensure that the width shows the content without wrapping/hiding.
     * > * This method ignores the hidden columns.
     * > * Uses the `autoFitColumns` method in the `dataBound` event to resize at initial rendering.
     * > * By specifying the start row index and end row index, providing the range within which the maximum width for that column should be considered when applying `autoFitColumns`.
     * > * The width of header rows is always calculated. If the width of a header row exceeds the specified range, its width will be allocated to the specific content rows.
     *
     * @param  {string |string[]} fieldNames - Defines the column names.
     * @param  {number} startRowIndex - Specifies the start index of the content row.
     * @param  {number} endRowIndex - Specifies the end index of content row.
     * @returns {void}
     *
     *
     * ```typescript
     * <div id="Grid"></div>
     * <script>
     * let gridObj: Grid = new Grid({
     *     dataSource: employeeData,
     *     columns: [
     *         { field: 'OrderID', headerText: 'Order ID', width:100 },
     *         { field: 'EmployeeID', headerText: 'Employee ID' }],
     *     dataBound: () => gridObj.autoFitColumns('EmployeeID');
     * });
     * gridObj.appendTo('#Grid');
     * </script>
     * ```
     *
     */ Grid.prototype.autoFitColumns = function(fieldNames, startRowIndex, endRowIndex) {
        var injectedModules = this.getInjectedModules();
        var resize = injectedModules.find(function(item) {
            if (typeof item === "function" && !(0, $3EnZW.isNullOrUndefined)(item.prototype)) return item.prototype.getModuleName() === "resize";
            else return item.name === "Resize";
        });
        if (!this.resizeModule && resize) {
            this.autoFitColumnsResize = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.injectModules();
        }
        if (this.resizeModule) this.resizeModule.autoFitColumns(fieldNames, startRowIndex, endRowIndex);
    };
    /**
     * @returns {void}
     * @hidden
     */ Grid.prototype.preventAdjustColumns = function() {
        if (this.enableAdaptiveUI && this.rowRenderingMode === "Vertical" || this.allowResizing && this.resizeSettings.mode === "Auto") return;
        var columns = this.getColumns();
        var headerTable = this.getHeaderTable();
        var tableWidth = 0;
        for(var i = 0; i < columns.length; i++)if (columns[parseInt(i.toString(), 10)].visible) {
            if (this.groupSettings.columns.length && this.groupSettings.columns.indexOf(columns[parseInt(i.toString(), 10)].field) > -1) {
                var headerCol = [].slice.call(headerTable.querySelector("colgroup").querySelectorAll(":not(.e-group-intent):not(.e-detail-intent):not(.e-drag-intent)"));
                if (headerCol[parseInt(i.toString(), 10)].style.display === "none") continue;
            }
            if (columns[parseInt(i.toString(), 10)].width) tableWidth += parseFloat(columns[parseInt(i.toString(), 10)].width.toString());
            else {
                tableWidth = 0;
                break;
            }
        }
        if (tableWidth) {
            var percentageWidth = this.isPercentageWidthGrid();
            var unit = this.widthUnit(percentageWidth);
            var contentTable = this.getContentTable();
            if (this.groupSettings.columns.length || this.isDetail() || this.isRowDragable()) {
                var indentWidth = this.defaultIndentWidth(percentageWidth);
                var indentWidthUnitFormat = indentWidth.toString() + unit;
                var headerIndentCol = [].slice.call(headerTable.querySelector("colgroup").querySelectorAll(".e-group-intent, .e-detail-intent, .e-drag-intent"));
                var contentIndentCol = [].slice.call(contentTable.querySelector("colgroup").querySelectorAll(".e-group-intent, .e-detail-intent, .e-drag-intent"));
                for(var i = 0; i < headerIndentCol.length; i++){
                    headerIndentCol[parseInt(i.toString(), 10)].style.setProperty("width", indentWidthUnitFormat);
                    contentIndentCol[parseInt(i.toString(), 10)].style.setProperty("width", indentWidthUnitFormat);
                    tableWidth += indentWidth;
                }
            }
            if (percentageWidth && tableWidth < 100 || !percentageWidth && tableWidth < contentTable.parentElement.clientWidth) {
                if (!(0, $3EnZW.isNullOrUndefined)(contentTable.querySelector(".e-emptyrow"))) {
                    (0, $4ZDHT.addClass)([
                        headerTable
                    ], [
                        "e-tableborder"
                    ]);
                    (0, $4ZDHT.removeClass)([
                        contentTable
                    ], [
                        "e-tableborder"
                    ]);
                } else (0, $4ZDHT.addClass)([
                    headerTable,
                    contentTable
                ], [
                    "e-tableborder"
                ]);
            }
            var tableWidthUnitFormat = tableWidth.toString() + unit;
            headerTable.style.setProperty("width", tableWidthUnitFormat);
            contentTable.style.setProperty("width", tableWidthUnitFormat);
        } else this.restoreAdjustColumns();
    };
    Grid.prototype.restoreAdjustColumns = function() {
        if (this.enableAdaptiveUI && this.rowRenderingMode === "Vertical" || this.allowResizing && this.resizeSettings.mode === "Auto") return;
        var headerTable = this.getHeaderTable();
        var contentTable = this.getContentTable();
        (0, $4ZDHT.removeClass)([
            headerTable,
            contentTable
        ], [
            "e-tableborder"
        ]);
        headerTable.style.removeProperty("width");
        contentTable.style.removeProperty("width");
        if (this.groupSettings.columns.length || this.isDetail() || this.isRowDragable()) {
            var percentageWidth = this.isPercentageWidthGrid();
            var indentWidthUnitFormat_1 = this.defaultIndentWidth(percentageWidth).toString() + this.widthUnit(percentageWidth);
            var headerIndentCol = [].slice.call(headerTable.querySelector("colgroup").querySelectorAll(".e-group-intent, .e-detail-intent, .e-drag-intent"));
            headerIndentCol.forEach(function(element) {
                element.style.setProperty("width", indentWidthUnitFormat_1);
            });
            headerTable.querySelector(".e-emptycell").removeAttribute("indentRefreshed");
            this.recalcIndentWidth();
        }
    };
    Grid.prototype.widthUnit = function(percentageWidth) {
        return percentageWidth ? "%" : "px";
    };
    Grid.prototype.defaultIndentWidth = function(percentageWidth) {
        return percentageWidth ? parseFloat((30 / this.element.offsetWidth * 100).toFixed(1)) : 30;
    };
    Grid.prototype.isPercentageWidthGrid = function() {
        return this.getColumns()[0].width.toString().indexOf("%") > -1;
    };
    /**
     * @param {number} x - Defines the number
     * @param {number} y - Defines the number
     * @param {Element} target - Defines the Element
     * @returns {void}
     * @hidden
     */ Grid.prototype.createColumnchooser = function(x, y, target) {
        if (this.columnChooserModule) this.columnChooserModule.renderColumnChooser(x, y, target);
    };
    Grid.prototype.initializeServices = function() {
        this.serviceLocator.register("widthService", this.widthService = new (0, $95d0259945049a0f$export$96000d5616e57e96)(this));
        this.serviceLocator.register("cellRendererFactory", new (0, $1a4abae492179d7d$export$cb229f7feb229cc0));
        this.serviceLocator.register("rendererFactory", new (0, $15313f6956d76a3f$export$35d194b5f3387064));
        this.serviceLocator.register("localization", this.localeObj = new (0, $e7i2H.L10n)(this.getModuleName(), this.defaultLocale, this.locale));
        this.serviceLocator.register("valueFormatter", this.valueFormatterService = new (0, $52aed6227a4600c2$export$4ad21d94aae28a17)(this.locale));
        this.serviceLocator.register("showHideService", this.showHider = new (0, $2895c91985d75027$export$7b1795bf935bef37)(this));
        this.serviceLocator.register("ariaService", this.ariaService = new (0, $93af6f2061a6f920$export$aaeab4162651d364)());
        this.serviceLocator.register("focus", this.focusModule = new (0, $008b258884e5b2ce$export$d989ec6d6c3876c5)(this));
    };
    Grid.prototype.processModel = function() {
        var gCols = this.groupSettings.columns;
        var sCols = this.sortSettings.columns;
        var flag;
        var j;
        if (this.allowGrouping) {
            var _loop_3 = function(i, len) {
                flag = false;
                j = 0;
                for(var sLen = sCols.length; j < sLen; j++)if (sCols[parseInt(j.toString(), 10)].field === gCols[parseInt(i.toString(), 10)]) {
                    flag = true;
                    break;
                }
                if (!flag) sCols.push({
                    field: gCols[parseInt(i.toString(), 10)],
                    direction: "Ascending",
                    isFromGroup: true
                });
                else if (this_3.allowSorting) this_3.sortedColumns.push(sCols[parseInt(j.toString(), 10)].field);
                else sCols[parseInt(j.toString(), 10)].direction = "Ascending";
                if (!this_3.groupSettings.showGroupedColumn) {
                    var column = this_3.enableColumnVirtualization ? this_3.columns.filter(function(c) {
                        return c.field === gCols[parseInt(i.toString(), 10)];
                    })[0] : this_3.getColumnByField(gCols[parseInt(i.toString(), 10)]);
                    if (column) column.visible = false;
                    else this_3.log("initial_action", {
                        moduleName: "group",
                        columnName: gCols[parseInt(i.toString(), 10)]
                    });
                }
            };
            var this_3 = this;
            for(var i = 0, len = gCols.length; i < len; i++)_loop_3(i, len);
        }
        if (!gCols.length) for(var i = 0; i < sCols.length; i++)this.sortedColumns.push(sCols[parseInt(i.toString(), 10)].field);
        this.rowTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.rowTemplate);
        this.emptyRecordTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.emptyRecordTemplate);
        this.detailTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.detailTemplate);
        this.editTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.editSettings.template);
        this.editHeaderTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.editSettings.headerTemplate);
        this.editFooterTemplateFn = (0, $748c2240e597a9b7$export$4ffdcfa44babc928)(this.editSettings.footerTemplate);
        if (!(0, $3EnZW.isNullOrUndefined)(this.parentDetails)) {
            var value = (0, $3EnZW.isNullOrUndefined)(this.parentDetails.parentKeyFieldValue) ? "undefined" : this.parentDetails.parentKeyFieldValue;
            this.query.where(this.queryString, "equal", value, true);
        }
        this.initForeignColumn();
    };
    Grid.prototype.initForeignColumn = function() {
        if (this.isForeignKeyEnabled(this.getColumns())) this.notify($17b89d3b1fc93cdb$export$fe0819b09824c208, this.getForeignKeyColumns());
    };
    Grid.prototype.enableVerticalRendering = function() {
        if (this.rowRenderingMode === "Vertical") this.element.classList.add("e-row-responsive");
        else this.element.classList.remove("e-row-responsive");
    };
    Grid.prototype.gridRender = function() {
        var _a;
        this.updateRTL();
        if (this.rowRenderingMode === "Vertical") this.element.classList.add("e-row-responsive");
        if (this.enableHover) this.element.classList.add("e-gridhover");
        if ((0, $5q7BP.Browser).isDevice && this.adaptiveUIMode === "Desktop") {
            this.element.classList.add("e-device");
            this.enableAdaptiveUI = false;
        }
        if (this.adaptiveUIMode === "Mobile" && !(0, $5q7BP.Browser).isDevice) this.enableAdaptiveUI = false;
        if (this.rowHeight) this.element.classList.add("e-grid-min-height");
        if (this.cssClass) {
            if (this.cssClass.indexOf(" ") !== -1) (_a = this.element.classList).add.apply(_a, this.cssClass.split(" "));
            else this.element.classList.add(this.cssClass);
        }
        // If the below if statement is removed, then drag and drop between grids will not work in firefox browser.
        if (this.allowRowDragAndDrop && this.rowDropSettings.targetID && (0, $5q7BP.Browser).info.name === "mozilla") this.element.classList.add("e-disableuserselect");
        if (this.editSettings.showAddNewRow && (this.enableVirtualization || this.enableInfiniteScrolling)) this.editSettings.newRowPosition = "Top";
        (0, $4ZDHT.classList)(this.element, [
            "e-responsive",
            "e-default"
        ], []);
        var rendererFactory = this.serviceLocator.getService("rendererFactory");
        this.headerModule = rendererFactory.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header);
        this.contentModule = rendererFactory.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content);
        this.printModule = new (0, $41e4fa99f5153f53$export$531cef85654f2406)(this, this.scrollModule);
        this.clipboardModule = new (0, $5d15e52cfa78cdcc$export$8b44c43c7d8f0830)(this, this.serviceLocator);
        this.renderModule.render();
        this.eventInitializer();
        this.createGridPopUpElement();
        this.widthService.setWidthToColumns();
        this.updateGridLines();
        this.applyTextWrap();
        this.createTooltip(); //for clip mode ellipsis
        this.enableBoxSelection();
    };
    Grid.prototype.dataReady = function() {
        this.scrollModule.setWidth();
        this.scrollModule.setHeight();
        if (this.height !== "auto") this.scrollModule.setPadding();
    };
    Grid.prototype.updateRTL = function() {
        if (this.enableRtl) this.element.classList.add("e-rtl");
        else this.element.classList.remove("e-rtl");
    };
    Grid.prototype.createGridPopUpElement = function() {
        var popup = this.createElement("div", {
            className: "e-gridpopup",
            styles: "display:none;"
        });
        var content = this.createElement("div", {
            className: $1b5568e76cdae6d4$export$a7db06668cad9adb,
            attrs: {
                tabIndex: "-1"
            }
        });
        (0, $4ZDHT.append)([
            content,
            this.createElement("div", {
                className: "e-uptail e-tail"
            })
        ], popup);
        content.appendChild(this.createElement("span"));
        (0, $4ZDHT.append)([
            content,
            this.createElement("div", {
                className: "e-downtail e-tail"
            })
        ], popup);
        this.element.appendChild(popup);
    };
    Grid.prototype.updateGridLines = function() {
        (0, $4ZDHT.classList)(this.element, [], [
            "e-verticallines",
            "e-horizontallines",
            "e-hidelines",
            "e-bothlines"
        ]);
        switch(this.gridLines){
            case "Horizontal":
                this.element.classList.add("e-horizontallines");
                break;
            case "Vertical":
                this.element.classList.add("e-verticallines");
                break;
            case "None":
                this.element.classList.add("e-hidelines");
                break;
            case "Both":
                this.element.classList.add("e-bothlines");
                break;
        }
        this.updateResizeLines();
    };
    Grid.prototype.updateResizeLines = function() {
        if (this.allowResizing && !(this.gridLines === "Vertical" || this.gridLines === "Both")) this.element.classList.add("e-resize-lines");
        else this.element.classList.remove("e-resize-lines");
    };
    /**
     * The function is used to apply text wrap
     *
     * @returns {void}
     * @hidden
     */ Grid.prototype.applyTextWrap = function() {
        if (this.allowTextWrap) {
            var headerRows = [].slice.call(this.element.getElementsByClassName("e-columnheader"));
            switch(this.textWrapSettings.wrapMode){
                case "Header":
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.element, false);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.getContent(), false);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(headerRows, true);
                    break;
                case "Content":
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.getContent(), true);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.element, false);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(headerRows, false);
                    break;
                default:
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.element, true);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.getContent(), false);
                    (0, $748c2240e597a9b7$export$4997ffc0176396a6)(headerRows, false);
            }
            if (this.textWrapSettings.wrapMode !== "Content") this.notify($17b89d3b1fc93cdb$export$d5e4329e23182602, {});
        }
    };
    /**
     * The function is used to remove text wrap
     *
     * @returns {void}
     * @hidden
     */ Grid.prototype.removeTextWrap = function() {
        (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.element, false);
        var headerRows = [].slice.call(this.element.getElementsByClassName("e-columnheader"));
        (0, $748c2240e597a9b7$export$4997ffc0176396a6)(headerRows, false);
        (0, $748c2240e597a9b7$export$4997ffc0176396a6)(this.getContent(), false);
        if (this.textWrapSettings.wrapMode !== "Content") this.notify($17b89d3b1fc93cdb$export$d5e4329e23182602, {});
    };
    /**
     * The function is used to add Tooltip to the grid cell that has ellipsiswithtooltip clip mode.
     *
     * @returns {void}
     * @hidden
     */ Grid.prototype.createTooltip = function() {
        this.toolTipObj = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)({
            opensOn: "custom",
            content: "",
            cssClass: this.cssClass ? this.cssClass : null
        }, this.element);
    };
    /** @hidden
     * @returns {void}
     */ Grid.prototype.freezeRefresh = function() {
        if (this.enableVirtualization || this.enableInfiniteScrolling) this.pageSettings.currentPage = 1;
        this.componentRefresh();
    };
    Grid.prototype.getTooltipStatus = function(element) {
        var headerTable = this.getHeaderTable();
        var headerDivTag = this.enableAdaptiveUI && this.rowRenderingMode === "Vertical" ? "e-gridcontent" : "e-gridheader";
        var htable = this.createTable(headerTable, headerDivTag, "header");
        var ctable = this.createTable(headerTable, headerDivTag, "content");
        var table = element.classList.contains("e-headercell") ? htable : ctable;
        var ele = element.classList.contains("e-headercell") ? "th" : "tr";
        table.querySelector(ele).className = element.className;
        table.querySelector(ele).innerHTML = element.innerHTML;
        var width = table.querySelector(ele).getBoundingClientRect().width;
        document.body.removeChild(htable);
        document.body.removeChild(ctable);
        if (width > element.getBoundingClientRect().width && !element.classList.contains("e-editedbatchcell") || this.enableAdaptiveUI && this.rowRenderingMode === "Vertical" && width > element.getBoundingClientRect().width * 0.55 - (this.height !== "auto" ? 16 : 0)) // 0.55 - defines the width of adaptive content cell, 16 - defines the scrollbar width
        return true;
        return false;
    };
    Grid.prototype.mouseMoveHandler = function(e) {
        if (this.isEllipsisTooltip()) {
            var element = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-ellipsistooltip");
            if (this.prevElement !== element || e.type === "mouseout") this.toolTipObj.close();
            var tagName = e.target.tagName;
            var elemNames = [
                "A",
                "BUTTON",
                "INPUT"
            ];
            if (element && e.type !== "mouseout" && !((0, $5q7BP.Browser).isDevice && elemNames.indexOf(tagName) !== -1)) {
                if (this.getTooltipStatus(element)) {
                    var col = this.getColumns()[parseInt(element.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10)];
                    var domSetter = col.disableHtmlEncode ? "innerText" : "innerHTML";
                    var contentDiv = this.createElement("div");
                    if (element.getElementsByClassName("e-headertext").length) {
                        var innerElement = element.getElementsByClassName("e-headertext")[0];
                        contentDiv["" + domSetter] = this.sanitize(innerElement.innerText);
                        this.toolTipObj.content = contentDiv;
                    } else {
                        contentDiv["" + domSetter] = this.sanitize(element.innerText);
                        this.toolTipObj.content = contentDiv;
                    }
                    this.prevElement = element;
                    if (this.enableHtmlSanitizer) this.toolTipObj.enableHtmlSanitizer = true;
                    if (col.disableHtmlEncode) this.toolTipObj.enableHtmlParse = false;
                    this.toolTipObj["open"](element);
                }
            }
        }
    };
    Grid.prototype.isEllipsisTooltip = function() {
        var cols = this.getColumns();
        if (this.clipMode === "EllipsisWithTooltip") return true;
        for(var i = 0; i < cols.length; i++){
            if (cols[parseInt(i.toString(), 10)].clipMode === "EllipsisWithTooltip") return true;
        }
        return false;
    };
    Grid.prototype.scrollHandler = function() {
        if (this.isEllipsisTooltip()) this.toolTipObj.close();
    };
    /**
     * To create table for ellipsiswithtooltip
     *
     * @param {Element} table - Defines the table
     * @param {string} tag - Defines the tag
     * @param {string} type - Defines the type
     * @returns {HTMLDivElement} Returns the HTML div ELement
     * @hidden
     */ Grid.prototype.createTable = function(table, tag, type) {
        var myTableDiv = this.createElement("div");
        myTableDiv.className = this.element.className;
        myTableDiv.style.cssText = "display: inline-block;visibility:hidden;position:absolute";
        var mySubDiv = this.createElement("div");
        mySubDiv.className = tag;
        var myTable = this.createElement("table");
        myTable.className = table.className;
        myTable.style.cssText = "table-layout: auto;width: auto";
        var ele = type === "header" ? "th" : "td";
        var myTr = this.createElement("tr", {
            attrs: {
                role: "row"
            }
        });
        var mytd = this.createElement(ele);
        myTr.appendChild(mytd);
        myTable.appendChild(myTr);
        mySubDiv.appendChild(myTable);
        myTableDiv.appendChild(mySubDiv);
        document.body.appendChild(myTableDiv);
        return myTableDiv;
    };
    Grid.prototype.onKeyPressed = function(e) {
        if (e.action === "tab" || e.action === "shiftTab") this.toolTipObj.close();
    };
    /**
     * Binding events to the element while component creation.
     *
     * @hidden
     * @returns {void}
     */ Grid.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, "click", this.mouseClickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "touchend", this.mouseClickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.focusOutHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "dblclick", this.dblClickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.keyPressHandler, this);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).add(window, "resize", this.resetIndentWidth, this);
        if (this.allowKeyboard) this.element.tabIndex = this.element.tabIndex === -1 ? 0 : this.element.tabIndex;
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
        (0, $aqzbR.EventHandler).add(this.getContent().firstElementChild, "scroll", this.scrollHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "mouseover", this.mouseMoveHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "mouseout", this.mouseMoveHandler, this);
        (0, $aqzbR.EventHandler).add(this.getContent(), "touchstart", this.tapEvent, this);
        (0, $aqzbR.EventHandler).add(document.body, "keydown", this.keyDownHandler, this);
    };
    /**
     * Unbinding events from the element while component destroy.
     *
     * @hidden
     * @returns {void}
     */ Grid.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.mouseClickHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "touchend", this.mouseClickHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.focusOutHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "dblclick", this.dblClickHandler);
        (0, $aqzbR.EventHandler).remove(this.getContent().firstElementChild, "scroll", this.scrollHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseover", this.mouseMoveHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseout", this.mouseMoveHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.keyPressHandler);
        (0, $aqzbR.EventHandler).remove(this.getContent(), "touchstart", this.tapEvent);
        (0, $aqzbR.EventHandler).remove(document.body, "keydown", this.keyDownHandler);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).remove(window, "resize", this.resetIndentWidth);
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.addListener = function() {
        if (this.isDestroyed) return;
        this.on($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.dataReady, this);
        this.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.recalcIndentWidth, this);
        this.on($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.recalcIndentWidth, this);
        this.on($17b89d3b1fc93cdb$export$cdacb1a8abdadeeb, this.refreshFrozenPosition, this);
        this.on($17b89d3b1fc93cdb$export$6c0bde196efce5fe, this.refreshSplitFrozenColumn, this);
        this.dataBoundFunction = this.refreshMediaCol.bind(this);
        this.addEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.dataBoundFunction);
        this.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.onKeyPressed, this);
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.removeListener = function() {
        if (this.isDestroyed) return;
        this.off($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.dataReady);
        this.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.recalcIndentWidth);
        this.off($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.recalcIndentWidth);
        this.on($17b89d3b1fc93cdb$export$cdacb1a8abdadeeb, this.refreshFrozenPosition, this);
        this.on($17b89d3b1fc93cdb$export$6c0bde196efce5fe, this.refreshSplitFrozenColumn, this);
        this.removeEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.dataBoundFunction);
        this.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.onKeyPressed);
    };
    /**
     * Get current visible data of grid.
     *
     * @returns {Object[]} Returns the current view records
     *
     * @isGenericType true
     */ Grid.prototype.getCurrentViewRecords = function() {
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this)) return (0, $3EnZW.isNullOrUndefined)(this.currentViewData.records) ? this.currentViewData : this.currentViewData.records;
        if (this.groupSettings.enableLazyLoading) return this.currentViewData;
        return this.allowGrouping && this.groupSettings.columns.length && this.currentViewData.length && this.currentViewData.records ? this.currentViewData.records : this.currentViewData;
    };
    Grid.prototype.mouseClickHandler = function(e) {
        if (this.isChildGrid(e) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridpopup") && e.touches || this.element.getElementsByClassName("e-cloneproperties").length || this.checkEdit(e)) return;
        if ((!this.allowRowDragAndDrop && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$ee5f1442ff7df474) || e.target.tagName === "TD") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell").querySelector(".e-checkselectall") || !(this.allowGrouping || this.allowReordering) && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridheader")) && e.touches) return;
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridheader") && this.allowRowDragAndDrop && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-filterbarcell") && e.target && [
            "A",
            "BUTTON",
            "INPUT"
        ].indexOf(e.target.tagName) === -1) e.preventDefault();
        var args = this.getRowInfo(e.target);
        var cancel = "cancel";
        args["" + cancel] = false;
        var isDataRow = false;
        var tr = (0, $4ZDHT.closest)(e.target, "tr");
        if (tr && tr.getAttribute("data-uid")) {
            var rowObj = this.getRowObjectFromUID(tr.getAttribute("data-uid"));
            isDataRow = rowObj ? rowObj.isDataRow : false;
        }
        if (isDataRow) this.trigger($17b89d3b1fc93cdb$export$2c9eb917b6993180, args);
        this.notify($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, e);
    };
    Grid.prototype.checkEdit = function(e) {
        var tr = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$120ff0929b202a6d);
        var isEdit = this.editSettings.mode !== "Batch" && this.isEdit && tr && (tr.classList.contains($1b5568e76cdae6d4$export$76a2698a7195dbfe) || tr.classList.contains($1b5568e76cdae6d4$export$792eb12cf4991bf2) && !this.editSettings.showAddNewRow);
        return !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-unboundcelldiv") && (isEdit || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca) && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$deb49d6cac2bdaca).classList.contains("e-editedbatchcell"));
    };
    Grid.prototype.dblClickHandler = function(e) {
        var grid = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-grid");
        if ((0, $3EnZW.isNullOrUndefined)(grid) || grid.id !== this.element.id || (0, $4ZDHT.closest)(e.target, ".e-unboundcelldiv")) return;
        var dataRow = false;
        var tr = (0, $4ZDHT.closest)(e.target, "tr");
        if (tr && tr.getAttribute("data-uid")) {
            var rowObj = this.getRowObjectFromUID(tr.getAttribute("data-uid"));
            dataRow = rowObj ? rowObj.isDataRow : false;
        }
        var args = this.getRowInfo(e.target);
        args.target = e.target;
        if (dataRow) this.trigger($17b89d3b1fc93cdb$export$97f77ca7385478dc, args);
        this.notify($17b89d3b1fc93cdb$export$efb8dd8d61939266, e);
    };
    Grid.prototype.focusOutHandler = function(e) {
        if (this.isChildGrid(e)) return;
        if (!(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-grid")) this.element.querySelector(".e-gridpopup").style.display = "None";
        var filterClear = this.element.querySelector(".e-cancel:not(.e-hide)");
        if (filterClear && !filterClear.parentElement.classList.contains("e-tbar-btn")) filterClear.classList.add("e-hide");
        var relatedTarget = e.relatedTarget;
        var ariaOwns = relatedTarget ? relatedTarget.getAttribute("aria-owns") : null;
        if ((!relatedTarget || !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-grid") && (!(0, $3EnZW.isNullOrUndefined)(ariaOwns) && ariaOwns) !== e.target.getAttribute("aria-owns")) && !this.keyPress && this.isEdit && !(0, $5q7BP.Browser).isDevice) {
            if (this.editSettings.mode === "Batch" && !(((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-ddl") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-ddt")) && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-multi-select-list-wrapper") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-input-filter")) && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-input-group")) && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-uploader") || !(relatedTarget && (0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(relatedTarget, "e-input-group"))) && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "edit-custom-template"))) {
                this.editModule.saveCell();
                this.notify($17b89d3b1fc93cdb$export$9fff589d4f0a3d53, {});
            }
            if (this.editSettings.mode === "Normal" && !this.isWidgetsDestroyed) this.editModule.editFormValidate();
        }
        if (this.editSettings.showAddNewRow) this.editModule.isShowAddedRowValidate = false;
        this.keyPress = false;
    };
    Grid.prototype.isChildGrid = function(e) {
        var gridElement = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-grid");
        if (gridElement && gridElement.id !== this.element.id || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-unboundcelldiv") && (0, $3EnZW.isNullOrUndefined)(gridElement)) return true;
        return false;
    };
    /**
     * @param {Object} persistedData - Defines the persisted data
     * @returns {void}
     * @hidden
     */ Grid.prototype.mergePersistGridData = function(persistedData) {
        var data = this.getLocalData();
        if (!((0, $3EnZW.isNullOrUndefined)(data) || data === "") || !(0, $3EnZW.isNullOrUndefined)(persistedData)) {
            var dataObj = !(0, $3EnZW.isNullOrUndefined)(persistedData) ? persistedData : JSON.parse(data);
            if (this.enableVirtualization && dataObj.pageSettings) dataObj.pageSettings.currentPage = 1;
            var keys = Object.keys(dataObj);
            this.isProtectedOnChange = true;
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                if (typeof this["" + key] === "object" && !(0, $3EnZW.isNullOrUndefined)(this["" + key])) {
                    if (Array.isArray(this["" + key]) && key === "columns") {
                        this.setFrozenCount();
                        (0, $748c2240e597a9b7$export$64b518da455ab951)(this["" + key]);
                        this.mergeColumns(dataObj["" + key], this["" + key]);
                        this.mergedColumns = true;
                        this["" + key] = dataObj["" + key];
                    } else (0, $3EnZW.extend)(this["" + key], dataObj["" + key]);
                } else this["" + key] = dataObj["" + key];
            }
            this.isProtectedOnChange = false;
        }
    };
    Grid.prototype.mergeColumns = function(storedColumn, columns) {
        var storedColumns = storedColumn;
        var isFrozenGrid = this.isFrozenGrid();
        var _loop_4 = function(i) {
            var localCol = columns.filter(function(tCol) {
                return isFrozenGrid ? tCol.index === storedColumns[parseInt(i.toString(), 10)]["" + $1b5568e76cdae6d4$export$1083832cc21be1bf] : tCol.index === storedColumns[parseInt(i.toString(), 10)].index;
            })[0];
            if (!(0, $3EnZW.isNullOrUndefined)(localCol)) {
                if (isFrozenGrid) {
                    localCol = (0, $3EnZW.extend)({}, localCol, {}, true);
                    localCol.freeze = storedColumns[parseInt(i.toString(), 10)].freeze;
                }
                if (localCol.columns && localCol.columns.length) {
                    this_4.mergeColumns(storedColumns[parseInt(i.toString(), 10)].columns, localCol.columns);
                    storedColumns[parseInt(i.toString(), 10)] = (0, $3EnZW.extend)(localCol, storedColumns[parseInt(i.toString(), 10)], {}, true);
                } else storedColumns[parseInt(i.toString(), 10)] = (0, $3EnZW.extend)(localCol, storedColumns[parseInt(i.toString(), 10)], {}, true);
            }
        };
        var this_4 = this;
        for(var i = 0; i < storedColumns.length; i++)_loop_4(i);
    };
    /**
     * @hidden
     * @returns {boolean} Returns the isDetail
     */ Grid.prototype.isDetail = function() {
        return !(0, $3EnZW.isNullOrUndefined)(this.detailTemplate) || !(0, $3EnZW.isNullOrUndefined)(this.childGrid);
    };
    Grid.prototype.isCommandColumn = function(columns) {
        var _this_1 = this;
        return columns.some(function(col) {
            if (col.columns) return _this_1.isCommandColumn(col.columns);
            return !!(col.commands || col.commandsTemplate);
        });
    };
    Grid.prototype.isForeignKeyEnabled = function(columns) {
        var _this_1 = this;
        return columns.some(function(col) {
            if (col.columns) return _this_1.isForeignKeyEnabled(col.columns);
            return !!(col.dataSource && col.foreignKeyValue);
        });
    };
    Grid.prototype.keyPressHandler = function(e) {
        var presskey = (0, $3EnZW.extend)(e, {
            cancel: false
        });
        this.trigger("keyPressed", presskey);
        if (presskey.cancel === true) e.stopImmediatePropagation();
    };
    Grid.prototype.keyDownHandler = function(e) {
        if (e.altKey) {
            if (e.keyCode === 74) {
                if (this.keyA) {
                    this.notify($17b89d3b1fc93cdb$export$223c4411dd55f1a, {
                        target: e.target,
                        collapse: false
                    });
                    this.keyA = false;
                } else {
                    if (this.focusModule && this.focusModule.currentInfo && this.focusModule.currentInfo.element) {
                        (0, $4ZDHT.removeClass)([
                            this.focusModule.currentInfo.element,
                            this.focusModule.currentInfo.elementToFocus
                        ], [
                            "e-focused",
                            "e-focus"
                        ]);
                        this.focusModule.currentInfo.element.tabIndex = -1;
                    }
                    if (!this.element.classList.contains("e-childgrid")) this.element.focus();
                }
            }
            if (e.keyCode === 87) {
                var focusModule = this.focusModule;
                if (focusModule) {
                    if (!this.currentViewData.length) return;
                    focusModule.focusContent();
                    focusModule.addOutline();
                }
            }
            if (e.keyCode === 65) this.keyA = true;
            if (e.keyCode === 72 && this.keyA) {
                this.notify($17b89d3b1fc93cdb$export$223c4411dd55f1a, {
                    target: e.target,
                    collapse: true
                });
                this.keyA = false;
            }
        }
        if (e.keyCode === 13) this.notify($17b89d3b1fc93cdb$export$294312b870d7fb5c, e);
    };
    Grid.prototype.keyActionHandler = function(e) {
        if (this.isChildGrid(e) || this.isEdit && (!this.editSettings.showAddNewRow || this.editSettings.showAddNewRow && this.element.querySelector($1b5568e76cdae6d4$export$76a2698a7195dbfe)) && e.action !== "escape" && e.action !== "enter" && e.action !== "shiftEnter" && e.action !== "tab" && e.action !== "shiftTab") return;
        else this.keyPress = true;
        if (this.allowKeyboard) {
            if (e.action === "ctrlPlusP") {
                e.preventDefault();
                this.print();
            }
            this.notify($17b89d3b1fc93cdb$export$e09b512eecac7579, e);
        }
    };
    /**
     * @param {Function[]} modules - Defines the modules
     * @returns {void}
     * @hidden
     */ Grid.prototype.setInjectedModules = function(modules) {
        this.injectedModules = modules;
    };
    Grid.prototype.updateColumnObject = function() {
        (0, $748c2240e597a9b7$export$1147582dfae658c6)(this.columns, this.enableColumnVirtualization, this);
        (0, $748c2240e597a9b7$export$64b518da455ab951)(this.columns);
        this.initForeignColumn();
        this.notify($17b89d3b1fc93cdb$export$bb86da570a7327af, {});
    };
    Grid.prototype.refreshFrozenPosition = function(obj) {
        if (obj && obj.isModeChg) {
            this.refreshColumns();
            this.notify($17b89d3b1fc93cdb$export$35c81900237a8009, {});
        } else this.refreshColumns();
    };
    /**
     * Gets the foreign columns from Grid.
     *
     * @returns {Column[]} Returns Foreign key column
     */ Grid.prototype.getForeignKeyColumns = function() {
        return this.getColumns().filter(function(col) {
            return col.isForeignColumn();
        });
    };
    /**
     * @hidden
     * @returns {number} Returns row height
     */ Grid.prototype.getRowHeight = function() {
        return this.rowHeight ? this.rowHeight : (0, $748c2240e597a9b7$export$69b171017bdea2b4)(this.element);
    };
    /**
     * Refreshes the Grid column changes.
     *
     * @returns {void}
     */ Grid.prototype.refreshColumns = function() {
        this.freezeColumnRefresh = true;
        this.setFrozenCount();
        this.updateFrozenColumnsWidth();
        if (this.isFrozenGrid()) this.isPreventScrollEvent = true;
        this.updateColumnObject();
        this.checkLockColumns(this.getColumns());
        this.refresh();
        if (this.isFrozenGrid() && this.enableColumnVirtualization) {
            var left = this.getContent().querySelector(".e-movablescrollbar").scrollLeft;
            this.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3).scrollLeft = left;
            this.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb).scrollLeft = left;
        }
    };
    /**
     * Export Grid data to Excel file(.xlsx).
     *
     * @param  {ExcelExportProperties} excelExportProperties - Defines the export properties of the Grid.
     * @param  {boolean} isMultipleExport - Define to enable multiple export.
     * @param  {Workbook} workbook - Defines the Workbook if multiple export is enabled.
     * @param  {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     * @returns {Promise<any>} Returns the excelexport
     */ Grid.prototype.excelExport = function(excelExportProperties, isMultipleExport, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workbook, isBlob) {
        if (this.exportGrids && this.exportGrids.length) {
            var gridIds = this.exportGrids.slice();
            return this.exportMultipleExcelGrids(gridIds, excelExportProperties, isMultipleExport, workbook, isBlob);
        } else return this.excelExportModule ? this.excelExportModule.Map(this, excelExportProperties, isMultipleExport, workbook, false, isBlob) : null;
    };
    /**
     * Export Grid data to CSV file.
     *
     * @param  {ExcelExportProperties} excelExportProperties - Defines the export properties of the Grid.
     * @param  {boolean} isMultipleExport - Define to enable multiple export.
     * @param  {Workbook} workbook - Defines the Workbook if multiple export is enabled.
     * @param  {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     * @returns {Promise<any>} Returns csv export
     */ Grid.prototype.csvExport = function(excelExportProperties, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isMultipleExport, workbook, isBlob) {
        return this.excelExportModule ? this.excelExportModule.Map(this, excelExportProperties, isMultipleExport, workbook, true, isBlob) : null;
    };
    /**
     * Export Grid data to PDF document.
     *
     * @param {pdfExportProperties} pdfExportProperties - Defines the export properties of the Grid.
     * @param {isMultipleExport} isMultipleExport - Define to enable multiple export.
     * @param {pdfDoc} pdfDoc - Defined the Pdf Document if multiple export is enabled.
     * @param {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     *
     * @returns {Promise<any>} Returns pdfexport
     */ Grid.prototype.pdfExport = function(pdfExportProperties, isMultipleExport, pdfDoc, isBlob) {
        if (this.exportGrids && this.exportGrids.length) {
            var gridIds = this.exportGrids.slice();
            return this.exportMultiplePdfGrids(gridIds, pdfExportProperties, isMultipleExport, pdfDoc, isBlob);
        } else return this.pdfExportModule ? this.pdfExportModule.Map(this, pdfExportProperties, isMultipleExport, pdfDoc, isBlob) : null;
    };
    Grid.prototype.exportMultiplePdfGrids = function(gridIds, pdfExportProperties, isMultipleExport, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pdfDoc, isBlob) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _this = this;
        if (gridIds.length !== 0) {
            var currentGridId = gridIds.shift();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var currentGridInstance = document.getElementById(currentGridId).ej2_instances[0];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var exportPromise = currentGridInstance.pdfExportModule ? currentGridInstance.pdfExportModule.Map(currentGridInstance, pdfExportProperties, isMultipleExport, pdfDoc, isBlob) : Promise.resolve();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return exportPromise.then(function(exportedGridResults) {
                isMultipleExport = gridIds.length === 1 ? false : true;
                return _this.exportMultiplePdfGrids(gridIds, pdfExportProperties, isMultipleExport, exportedGridResults, isBlob);
            });
        }
        return null;
    };
    Grid.prototype.exportMultipleExcelGrids = function(gridIds, excelExportProperties, isMultipleExport, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workbook, isBlob) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _this = this;
        if (gridIds.length !== 0) {
            var currentGridId = gridIds.shift();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var currentGridInstance = document.getElementById(currentGridId).ej2_instances[0];
            var exportPromise = currentGridInstance.excelExportModule ? currentGridInstance.excelExportModule.Map(currentGridInstance, excelExportProperties, isMultipleExport, workbook, false, isBlob) : null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return exportPromise.then(function(exportedGridResults) {
                isMultipleExport = gridIds.length === 1 ? false : true;
                return _this.exportMultipleExcelGrids(gridIds, excelExportProperties, isMultipleExport, exportedGridResults, isBlob);
            });
        }
        return null;
    };
    /**
     * Groups a column by column name.
     *
     * @param  {string} columnName - Defines the column name to group.
     *
     * @returns {void}
     */ Grid.prototype.groupColumn = function(columnName) {
        if (this.groupModule) this.groupModule.groupColumn(columnName);
    };
    /**
     * Expands all the grouped rows of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.groupExpandAll = function() {
        if (this.groupModule) this.groupModule.expandAll();
    };
    /**
     * Collapses all the grouped rows of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.groupCollapseAll = function() {
        if (this.groupModule) this.groupModule.collapseAll();
    };
    /**
     * Expands or collapses grouped rows by target element.
     *
     * @param  {Element} target - Defines the target element of the grouped row.
     * @returns {void}
     */ // public expandCollapseRows(target: Element): void {
    //     if (this.groupModule) {
    //         this.groupModule.expandCollapseRows(target);
    //     }
    // }
    /**
     * Clears all the grouped columns of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.clearGrouping = function() {
        if (this.groupModule) this.groupModule.clearGrouping();
    };
    /**
     * Ungroups a column by column name.
     *
     * {% codeBlock src='grid/ungroupColumn/index.md' %}{% endcodeBlock %}
     *
     * @param  {string} columnName - Defines the column name to ungroup.
     *
     * @returns {void}
     */ Grid.prototype.ungroupColumn = function(columnName) {
        if (this.groupModule) this.groupModule.ungroupColumn(columnName);
    };
    /**
     * Column chooser can be displayed on screen by given position(X and Y axis).
     *
     * @param {number} x - Defines the X axis.
     * @param {number} y - Defines the Y axis.
     *
     * @returns {void}
     */ Grid.prototype.openColumnChooser = function(x, y) {
        if (this.columnChooserModule) this.columnChooserModule.openColumnChooser(x, y);
    };
    Grid.prototype.scrollRefresh = function() {
        var _this_1 = this;
        var refresh = function() {
            _this_1.scrollModule.refresh();
            _this_1.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, refresh);
        };
        this.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, refresh, this);
    };
    /**
     * Collapses a detail row with the given target.
     *
     * @param  {Element} target - Defines the expanded element to collapse.
     * @returns {void}
     */ // public detailCollapse(target: number | Element): void {
    //     if (this.detailRowModule) {
    //         this.detailRowModule.collapse(target);
    //     }
    // }
    /**
     * Collapses all the detail rows of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.detailCollapseAll = function() {
        if (this.detailRowModule) this.detailRowModule.collapseAll();
    };
    /**
     * Expands a detail row with the given target.
     *
     * @param  {Element} target - Defines the collapsed element to expand.
     * @returns {void}
     */ // public detailExpand(target: number | Element): void {
    //     if (this.detailRowModule) {
    //         this.detailRowModule.expand(target);
    //     }
    // }
    /**
     * Expands all the detail rows of the Grid.
     *
     * @returns {void}
     */ Grid.prototype.detailExpandAll = function() {
        if (this.detailRowModule) this.detailRowModule.expandAll();
    };
    /**
     * Deselects the currently selected cells.
     *
     * @returns {void}
     */ Grid.prototype.clearCellSelection = function() {
        if (this.selectionModule) this.selectionModule.clearCellSelection();
    };
    /**
     * Deselects the currently selected rows.
     *
     * @returns {void}
     */ Grid.prototype.clearRowSelection = function() {
        if (this.selectionModule) this.selectionModule.clearRowSelection();
    };
    /**
     * Selects a collection of cells by row and column indexes.
     *
     * @param  {ISelectedCell[]} rowCellIndexes - Specifies the row and column indexes.
     *
     * @returns {void}
     */ Grid.prototype.selectCells = function(rowCellIndexes) {
        if (this.selectionModule) this.selectionModule.selectCells(rowCellIndexes);
    };
    /**
     * Selects a range of rows from start and end row indexes.
     *
     * @param  {number} startIndex - Specifies the start row index.
     * @param  {number} endIndex - Specifies the end row index.
     *
     * @returns {void}
     */ Grid.prototype.selectRowsByRange = function(startIndex, endIndex) {
        if (this.selectionModule) this.selectionModule.selectRowsByRange(startIndex, endIndex);
    };
    /**
     * @hidden
     * @returns {boolean} Returns whether context menu is open or not
     */ Grid.prototype.isContextMenuOpen = function() {
        return this.contextMenuModule && this.contextMenuModule.isOpen;
    };
    /**
     * @param {Function} module - Defines the module
     * @returns {boolean} return the injected modules
     * @hidden
     */ Grid.prototype.ensureModuleInjected = function(module) {
        return this.getInjectedModules().indexOf(module) >= 0;
    };
    /**
     * Destroys the given template reference.
     *
     * @param {string[]} propertyNames - Defines the collection of template name.
     * @param {any} index - specifies the index
     *
     * @returns {void}
     */ // eslint-disable-next-line
    Grid.prototype.destroyTemplate = function(propertyNames, index) {
        this.clearTemplate(propertyNames, index);
    };
    /**
     * @param {string | string[]} type - Defines the type
     * @param {Object} args - Defines the arguments
     * @returns {void}
     * @hidden
     * @private
     */ Grid.prototype.log = function(type, args) {
        var injectedModules = this.getInjectedModules();
        var logger = injectedModules.find(function(item) {
            return item.name === "Logger";
        });
        if (!logger) {
            Grid_1.Inject((0, $059246c685cae6e0$export$efa9a398d6368992));
            this.enableLogger = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.injectModules();
        }
        // eslint-disable-next-line
        this.loggerModule ? this.loggerModule.log(type, args) : function() {
            return 0;
        }();
    };
    /**
     * @param {Element} element - Defines the element
     * @returns {void}
     * @hidden
     */ Grid.prototype.applyBiggerTheme = function(element) {
        if (this.element.classList.contains("e-bigger")) element.classList.add("e-bigger");
    };
    /**
     * @hidden
     * @returns {Object} Returns the previous row data
     */ Grid.prototype.getPreviousRowData = function() {
        var previousRowData = this.getRowsObject()[this.getRows().length - 1].data;
        return previousRowData;
    };
    /**
     * Hides the scrollbar placeholder of Grid content when grid content is not overflown.
     *
     * @returns {void}
     */ Grid.prototype.hideScroll = function() {
        var content = this.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
        if (content.scrollHeight <= content.clientHeight) {
            this.scrollModule.removePadding();
            content.style.overflowY = "auto";
        }
    };
    /**
     * Get row index by primary key or row data.
     *
     * @param  {string | Object} value - Defines the primary key value.
     *
     * @returns {number} Returns the index
     */ Grid.prototype.getRowIndexByPrimaryKey = function(value) {
        var pkName = this.getPrimaryKeyFieldNames()[0];
        value = typeof value === "object" ? value["" + pkName] : value;
        var rows = this.getRowsObject();
        for(var i = 0; i < rows.length; i++){
            if (rows[parseInt(i.toString(), 10)].isDetailRow || rows[parseInt(i.toString(), 10)].isCaptionRow) continue;
            var pKvalue = rows[parseInt(i.toString(), 10)].data["" + pkName];
            if (pkName.split(".").length > 1) pKvalue = (0, $748c2240e597a9b7$export$64e408221c1d245b)(pkName, rows[parseInt(i.toString(), 10)].data);
            if (pKvalue === value) return rows[parseInt(i.toString(), 10)].index;
        }
        return -1;
    };
    /**
     * @param {string} field - Defines the field name
     * @param {boolean} isForeignKey - Defines the foreign key
     * @returns {Column} returns the column
     * @hidden
     */ // Need to have all columns while filtering with ColumnVirtualization.
    Grid.prototype.grabColumnByFieldFromAllCols = function(field, isForeignKey) {
        var column;
        this.columnModel = [];
        this.updateColumnModel(this.columns);
        var gCols = this.columnModel;
        for(var i = 0; i < gCols.length; i++)if (!isForeignKey && field === gCols[parseInt(i.toString(), 10)].field || isForeignKey && gCols[parseInt(i.toString(), 10)].isForeignColumn() && field === gCols[parseInt(i.toString(), 10)].foreignKeyValue) {
            column = gCols[parseInt(i.toString(), 10)];
            break;
        }
        return column;
    };
    /**
     * @param {string} uid - Defines the uid
     * @returns {Column} returns the column
     * @hidden
     */ // Need to have all columns while filtering with ColumnVirtualization.
    Grid.prototype.grabColumnByUidFromAllCols = function(uid) {
        var column;
        this.columnModel = [];
        this.updateColumnModel(this.columns);
        var gCols = this.columnModel;
        for(var i = 0; i < gCols.length; i++)if (uid === gCols[parseInt(i.toString(), 10)].uid) column = gCols[parseInt(i.toString(), 10)];
        return column;
    };
    /**
     * Get all filtered records from the Grid and it returns array of objects for the local dataSource, returns a promise object if the Grid has remote data.
     *
     * @returns {Object[] | Promise<Object>} Returns the filtered records
     */ Grid.prototype.getFilteredRecords = function() {
        if (this.allowFiltering && this.filterSettings.columns.length || this.searchSettings.key.length) {
            var query = this.renderModule.data.generateQuery(true);
            if (this.dataSource && this.renderModule.data.isRemote() && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) return this.renderModule.data.getData(this.dataSource, query);
            else {
                if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) return this.dataSource.executeLocal(query);
                else return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.dataSource, query).executeLocal(query);
            }
        }
        return [];
    };
    Grid.prototype.getUserAgent = function() {
        var userAgent = (0, $5q7BP.Browser).userAgent.toLowerCase();
        return /iphone|ipod|ipad|macintosh/.test(userAgent);
    };
    /**
     * @param {TouchEventArgs} e - Defines the TouchEventArgs
     * @returns {void}
     * @hidden
     */ // Need to have all columns while filtering with ColumnVirtualization.
    // eslint-disable-next-line
    Grid.prototype.tapEvent = function(e) {
        if (this.getUserAgent()) {
            if (!(0, $748c2240e597a9b7$export$98f03c5d19621d70).timer) (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = setTimeout(function() {
                (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = null;
            }, 300);
            else {
                clearTimeout((0, $748c2240e597a9b7$export$98f03c5d19621d70).timer);
                (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = null;
                this.dblClickHandler(e);
                this.notify($17b89d3b1fc93cdb$export$cfa10a7feffa0766, e);
            }
        }
    };
    /**
     * @param {string} prefix - specifies the prefix
     * @returns {string} returns the row uid
     * @hidden
     */ Grid.prototype.getRowUid = function(prefix) {
        return "" + prefix + this.rowUid++;
    };
    /**
     * @param {string} uid - specifies the uid
     * @returns {Element} returns the element
     * @hidden
     */ Grid.prototype.getRowElementByUID = function(uid) {
        var rowEle;
        var rows = [];
        var cntRows = [].slice.call(this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children);
        if (this.frozenRows) {
            rows = [].slice.call(this.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children);
            rows = rows.concat(cntRows);
        } else rows = cntRows;
        for(var _i = 0, rows_2 = rows; _i < rows_2.length; _i++){
            var row = rows_2[_i];
            if (row.getAttribute("data-uid") === uid) {
                rowEle = row;
                break;
            }
        }
        return rowEle;
    };
    /**
     * Gets the hidden columns from the Grid.
     *
     * @returns {Column[]} Returns the Column
     */ Grid.prototype.getHiddenColumns = function() {
        var cols = [];
        for(var _i = 0, _a = this.columnModel; _i < _a.length; _i++){
            var col = _a[_i];
            if (col.visible === false) cols.push(col);
        }
        return cols;
    };
    /**
     * Calculates the page size by parent element height
     *
     * @param {number | string } containerHeight - specifies the container height
     * @returns {number} returns the page size
     */ Grid.prototype.calculatePageSizeByParentHeight = function(containerHeight) {
        if (this.allowPaging) {
            if (this.allowTextWrap && this.textWrapSettings.wrapMode === "Header" || !this.allowTextWrap) {
                var pagesize = 0;
                if (containerHeight.indexOf("%") !== -1) containerHeight = parseInt(containerHeight, 10) / 100 * this.element.clientHeight;
                var nonContentHeight = this.getNoncontentHeight() + this.getRowHeight();
                if (containerHeight > nonContentHeight) {
                    var contentHeight = 0;
                    contentHeight = containerHeight - this.getNoncontentHeight();
                    pagesize = contentHeight / this.getRowHeight();
                }
                if (pagesize > 0) return Math.floor(pagesize);
            }
        }
        return 0;
    };
    Grid.prototype.getNoncontentHeight = function() {
        var height = 0;
        if (this.getHeaderContent() && !(0, $3EnZW.isNullOrUndefined)(this.getHeaderContent().clientHeight)) height += this.getHeaderContent().clientHeight;
        if (this.toolbar && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-toolbar").clientHeight)) height += this.element.querySelector(".e-toolbar").clientHeight;
        if (this.allowPaging && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-gridpager").clientHeight)) height += this.element.querySelector(".e-gridpager").clientHeight;
        if (this.showColumnChooser && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-columnheader").clientHeight)) height += this.element.querySelector(".e-columnheader").clientHeight;
        if (this.allowGrouping && this.groupSettings.showDropArea && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-groupdroparea").clientHeight)) height += this.element.querySelector(".e-groupdroparea").clientHeight;
        if (this.aggregates.length > 0 && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-summaryrow").clientHeight)) for(var i = 0; i < this.element.getElementsByClassName("e-summaryrow").length; i++)height += this.element.getElementsByClassName("e-summaryrow")[parseInt(i.toString(), 10)].clientHeight;
        return height;
    };
    /**
     *To perform aggregate operation on a column.
     *
     * @param  {AggregateColumnModel} summaryCol - Pass Aggregate Column details.
     * @param  {Object} summaryData - Pass JSON Array for which its field values to be calculated.
     *
     * @returns {number} returns the summary values
     */ Grid.prototype.getSummaryValues = function(summaryCol, summaryData) {
        return (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).aggregates[summaryCol.type.toLowerCase()](summaryData, summaryCol.field);
    };
    /**
     * Sends a Post request to export Grid to Excel file in server side.
     *
     * @param  {string} url - Pass Url for server side excel export action.
     *
     * @returns {void}
     */ Grid.prototype.serverExcelExport = function(url) {
        this.isExcel = true;
        this.exportGrid(url);
    };
    /**
     * Sends a Post request to export Grid to Pdf file in server side.
     *
     * @param  {string} url - Pass Url for server side pdf export action.
     *
     * @returns {void}
     */ Grid.prototype.serverPdfExport = function(url) {
        this.isExcel = false;
        this.exportGrid(url);
    };
    /**
     * Sends a Post request to export Grid to CSV file in server side.
     *
     * @param  {string} url - Pass Url for server side pdf export action.
     *
     * @returns {void}
     */ Grid.prototype.serverCsvExport = function(url) {
        this.isExcel = true;
        this.exportGrid(url);
    };
    /**
     * @param {string} url - Defines exporting url
     * @returns {void}
     * @hidden
     */ Grid.prototype.exportGrid = function(url) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var grid = this;
        var query = grid.getDataModule().generateQuery(true);
        var state = new (0, $e1170102ff02b3b7$export$b011aea473980a2d)().processQuery(new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
            url: ""
        }), query);
        var queries = JSON.parse(state.data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var gridModel = JSON.parse(this.addOnPersist([
            "allowGrouping",
            "allowPaging",
            "pageSettings",
            "sortSettings",
            "allowPdfExport",
            "allowExcelExport",
            "aggregates",
            "filterSettings",
            "groupSettings",
            "columns",
            "locale",
            "searchSettings"
        ]));
        var include = [
            "field",
            "headerText",
            "type",
            "format",
            "visible",
            "foreignKeyValue",
            "foreignKeyField",
            "template",
            "index",
            "width",
            "textAlign",
            "headerTextAlign",
            "columns"
        ];
        gridModel.filterSettings.columns = queries.where;
        gridModel.searchSettings.fields = queries.search && queries.search[0]["fields"] || [];
        gridModel.sortSettings.columns = queries.sorted;
        gridModel.columns = this.setHeaderText(gridModel.columns, include);
        var form = this.createElement("form", {
            id: "ExportForm",
            styles: "display:none;"
        });
        var gridInput = this.createElement("input", {
            id: "gridInput",
            attrs: {
                name: "gridModel"
            }
        });
        gridInput.value = JSON.stringify(gridModel);
        form.method = "POST";
        form.action = url;
        form.appendChild(gridInput);
        document.body.appendChild(form);
        form.submit();
        form.remove();
    };
    /**
     * @param {Column[]} columns - Defines array of columns
     * @param {string[]} include - Defines array of sting
     * @returns {Column[]} returns array of columns
     * @hidden
     */ Grid.prototype.setHeaderText = function(columns, include) {
        for(var i = 0; i < columns.length; i++){
            var column = this.getColumnByUid(columns[parseInt(i.toString(), 10)].uid);
            columns[parseInt(i.toString(), 10)].headerText = column.headerText;
            if (!(0, $3EnZW.isNullOrUndefined)(column.template)) columns[parseInt(i.toString(), 10)].template = "true";
            if (columns[parseInt(i.toString(), 10)].format) columns[parseInt(i.toString(), 10)].format = (0, $748c2240e597a9b7$export$9a25ca3301c594da)(this.getFormat(columns[parseInt(i.toString(), 10)].format), columns[parseInt(i.toString(), 10)].type, this.isExcel, (0, $bWDaN.defaultCurrencyCode));
            if (columns[parseInt(i.toString(), 10)].columns) this.setHeaderText(columns[parseInt(i.toString(), 10)].columns, include);
            var keys = Object.keys(columns[parseInt(i.toString(), 10)]);
            for(var j = 0; j < keys.length; j++)if (include.indexOf(keys[parseInt(j.toString(), 10)]) < 0) delete columns[parseInt(i.toString(), 10)][keys[parseInt(j.toString(), 10)]];
        }
        return columns;
    };
    Grid.prototype.getFormat = function(format) {
        return typeof format === "object" ? !(0, $3EnZW.isNullOrUndefined)(format.format) ? format.format : format.skeleton : format;
    };
    /**
     * @hidden
     * @returns {boolean} returns the isCollapseStateEnabled
     */ Grid.prototype.isCollapseStateEnabled = function() {
        var isExpanded = "isExpanded";
        return this["" + isExpanded] === false;
    };
    /**
     * @param {number} key - Defines the primary key value.
     * @param {Object} rowData - Defines the rowData
     * @returns {void}
     */ Grid.prototype.updateRowValue = function(key, rowData) {
        var args = {
            requestType: "save",
            data: rowData
        };
        this.showSpinner();
        this.notify($17b89d3b1fc93cdb$export$3bf0495508a61ee, args);
        this.refresh();
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.setForeignKeyData = function() {
        this.dataBind();
        var colpending = this.getDataModule().getForeignKeyDataState();
        if (colpending.isPending) {
            this.getDataModule().setForeignKeyDataState({});
            colpending.resolver();
        } else {
            this.getDataModule().setForeignKeyDataState({
                isDataChanged: false
            });
            if (this.contentModule || this.headerModule) this.renderModule.render();
        }
    };
    /**
     * @param {string} field - specifies the field
     * @returns {void}
     * @hidden
     */ Grid.prototype.resetFilterDlgPosition = function(field) {
        var header = this.getColumnHeaderByField(field);
        if (header) {
            var target = header.querySelector(".e-filtermenudiv");
            var filterDlg = this.element.querySelector(".e-filter-popup");
            if (target) {
                var gClient = this.element.getBoundingClientRect();
                var fClient = target.getBoundingClientRect();
                if (filterDlg) {
                    if (filterDlg.offsetWidth + fClient.right > gClient.right) filterDlg.style.left = (fClient.right - filterDlg.offsetWidth - gClient.left).toString() + "px";
                    else filterDlg.style.left = (fClient.right - gClient.left).toString() + "px";
                }
            }
        }
    };
    /**
     * @param {any} callBack - specifies the callBack method
     * @returns {void}
     * @hidden
     */ // eslint-disable-next-line
    Grid.prototype.renderTemplates = function(callBack) {
        var isReactChild = this.parentDetails && this.parentDetails.parentInstObj && this.parentDetails.parentInstObj.isReact;
        if (isReactChild && this["portals"]) {
            this.parentDetails.parentInstObj["portals"] = this.parentDetails.parentInstObj["portals"].concat(this["portals"]);
            this.parentDetails.parentInstObj.renderTemplates(callBack);
            this["portals"] = undefined;
        } else {
            var portals = "portals";
            this.notify("reactTemplateRender", this["" + portals]);
            this.renderReactTemplates(callBack);
        }
    };
    /**
     * Apply the changes to the Grid without refreshing the rows.
     *
     * @param  {BatchChanges} changes - Defines changes to be updated.
     * @returns {void}
     */ Grid.prototype.batchUpdate = function(changes) {
        this.processRowChanges(changes);
    };
    /**
     * Apply the changes to the Grid in one batch after 50ms without refreshing the rows.
     *
     * @param  {BatchChanges} changes - Defines changes to be updated.
     * @returns {void}
     */ Grid.prototype.batchAsyncUpdate = function(changes) {
        this.processBulkRowChanges(changes);
    };
    Grid.prototype.processBulkRowChanges = function(changes) {
        var _this_1 = this;
        if (!this.dataToBeUpdated) {
            this.dataToBeUpdated = Object.assign({
                addedRecords: [],
                changedRecords: [],
                deletedRecords: []
            }, changes);
            setTimeout(function() {
                _this_1.processRowChanges(_this_1.dataToBeUpdated);
                _this_1.dataToBeUpdated = null;
            }, this.asyncTimeOut);
        } else {
            var loopstring = [
                $1b5568e76cdae6d4$export$aef5e1398935f398,
                $1b5568e76cdae6d4$export$f7789a67e74c1e3f,
                $1b5568e76cdae6d4$export$c509ef778c751c4e
            ];
            var keyField = this.getPrimaryKeyFieldNames()[0];
            for(var i = 0; i < loopstring.length; i++)if (changes[loopstring[parseInt(i.toString(), 10)]]) (0, $748c2240e597a9b7$export$cae8611b08076487)(this, changes, loopstring[parseInt(i.toString(), 10)], keyField);
        }
    };
    Grid.prototype.processRowChanges = function(changes) {
        var _this_1 = this;
        var keyField = this.getPrimaryKeyFieldNames()[0];
        changes = Object.assign({
            addedRecords: [],
            changedRecords: [],
            deletedRecords: []
        }, changes);
        var promise = this.getDataModule().saveChanges(changes, keyField, {}, this.getDataModule().generateQuery().requiresCount());
        if (this.getDataModule().isRemote()) promise.then(function() {
            _this_1.setNewData();
        });
        else this.setNewData();
    };
    Grid.prototype.setNewData = function() {
        var _this_1 = this;
        var oldValues = JSON.parse(JSON.stringify(this.getCurrentViewRecords()));
        var getData = this.getDataModule().getData({}, this.getDataModule().generateQuery().requiresCount());
        getData.then(function(e) {
            _this_1.bulkRefresh(e.result, oldValues, e.count);
        });
    };
    Grid.prototype.deleteRowElement = function(row) {
        var tr = this.getRowElementByUID(row.uid);
        (0, $4ZDHT.remove)(tr);
    };
    Grid.prototype.bulkRefresh = function(result, oldValues, count) {
        var _this_1 = this;
        var rowObj = this.getRowsObject();
        var keyField = this.getPrimaryKeyFieldNames()[0];
        var _loop_5 = function(i) {
            if (!result.filter(function(e) {
                return e["" + keyField] === rowObj[parseInt(i.toString(), 10)].data["" + keyField];
            }).length) {
                this_5.deleteRowElement(rowObj[parseInt(i.toString(), 10)]);
                rowObj.splice(i, 1);
                i--;
            }
            out_i_1 = i;
        };
        var this_5 = this, out_i_1;
        for(var i = 0; i < rowObj.length; i++){
            _loop_5(i);
            i = out_i_1;
        }
        var _loop_6 = function(i) {
            var isRowExist;
            oldValues.filter(function(e) {
                if (e["" + keyField] === result[parseInt(i.toString(), 10)]["" + keyField]) {
                    if (e !== result[parseInt(i.toString(), 10)]) _this_1.setRowData(result[parseInt(i.toString(), 10)]["" + keyField], result[parseInt(i.toString(), 10)]);
                    isRowExist = true;
                }
            });
            if (!isRowExist) this_6.renderRowElement(result[parseInt(i.toString(), 10)], i);
        };
        var this_6 = this;
        for(var i = 0; i < result.length; i++)_loop_6(i);
        this.currentViewData = result;
        var rows = [].slice.call(this.getContentTable().getElementsByClassName($1b5568e76cdae6d4$export$120ff0929b202a6d));
        (0, $748c2240e597a9b7$export$ba639a32ffcf7814)(this, this.getRowsObject(), rows);
        (0, $748c2240e597a9b7$export$ef806be2fa1b9130)(this);
        if (this.allowPaging) this.notify($17b89d3b1fc93cdb$export$f4000f83c4e293d0, {
            module: "pager",
            properties: {
                totalRecordsCount: count
            }
        });
    };
    Grid.prototype.renderRowElement = function(data, index) {
        var row = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, this);
        var model = new (0, $7ddfd3da489c240b$export$2cf41885b7ecbd06)(this);
        var modelData = model.generateRows([
            data
        ]);
        var tr = row.render(modelData[0], this.getColumns());
        this.addRowObject(modelData[0], index);
        var tbody = this.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        if (tbody.querySelector(".e-emptyrow")) {
            var emptyRow = tbody.querySelector(".e-emptyrow");
            emptyRow.parentNode.removeChild(emptyRow);
            if (this.frozenRows && this.element.querySelector(".e-frozenrow-empty")) this.element.querySelector(".e-frozenrow-empty").classList.remove("e-frozenrow-empty");
        }
        if (this.frozenRows && index < this.frozenRows) tbody = this.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        else tbody = this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        tbody = this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        tbody.appendChild(tr);
    };
    Grid.prototype.addRowObject = function(row, index) {
        this.getRowsObject().splice(index, 1, row);
    };
    /**
     * @hidden
     * @returns {void}
     */ Grid.prototype.updateVisibleExpandCollapseRows = function() {
        var rows = this.getRowsObject();
        for(var i = 0, len = rows.length; i < len; i++)if ((rows[parseInt(i.toString(), 10)].isDataRow || rows[parseInt(i.toString(), 10)].isAggregateRow) && this.getRowElementByUID(rows[parseInt(i.toString(), 10)].uid) && this.getRowElementByUID(rows[parseInt(i.toString(), 10)].uid).style.display === "none") rows[parseInt(i.toString(), 10)].visible = false;
        else rows[parseInt(i.toString(), 10)].visible = true;
    };
    /**
     * Method to sanitize any suspected untrusted strings and scripts before rendering them.
     *
     * @param {string} value - Specifies the html value to sanitize
     * @returns {string} Returns the sanitized html string
     * @hidden
     */ Grid.prototype.sanitize = function(value) {
        if (this.enableHtmlSanitizer) return (0, $3P3ke.SanitizeHtmlHelper).sanitize(value);
        return value;
    };
    /**
     * @param {string | number} height - specifies the height
     * @returns {number | string} - specifies the height number
     * @hidden
     */ Grid.prototype.getHeight = function(height) {
        if (!Number.isInteger(height) && height.indexOf("%") !== -1) height = parseInt(height, 10) / 100 * this.element.clientHeight;
        else if (!Number.isInteger(height) && this.height !== "auto") height = parseInt(height, 10);
        else height = this.height;
        return height;
    };
    /**
     * @hidden
     * @returns {Element} - returns frozen right content

     */ Grid.prototype.getFrozenRightContent = function() {
        return this.contentModule.getPanel();
    };
    /**
     * @hidden
     * @returns {Element} - returns frozen right header

     */ Grid.prototype.getFrozenRightHeader = function() {
        return this.headerModule.getPanel();
    };
    /**
     * @hidden
     * @returns {Element} - returns movable header tbody

     */ Grid.prototype.getMovableHeaderTbody = function() {
        return this.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @hidden
     * @returns {Element} - returns movable content tbody

     */ Grid.prototype.getMovableContentTbody = function() {
        return this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @hidden
     * @returns {Element} - returns frozen header tbody

     */ Grid.prototype.getFrozenHeaderTbody = function() {
        return this.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @hidden
     * @returns {Element} - returns frozen left content tbody

     */ Grid.prototype.getFrozenLeftContentTbody = function() {
        return this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @hidden
     * @returns {Element} - returns frozen right header tbody

     */ Grid.prototype.getFrozenRightHeaderTbody = function() {
        return this.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @returns {Element} returns frozen right content tbody

     * @hidden
     */ Grid.prototype.getFrozenRightContentTbody = function() {
        return this.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
    };
    /**
     * @param {boolean} isCustom - Defines custom filter dialog open
     * @returns {void}
     * @hidden
     */ Grid.prototype.showResponsiveCustomFilter = function(isCustom) {
        if (this.filterModule) this.filterModule.showCustomFilter(isCustom || this.rowRenderingMode === "Vertical");
    };
    /**
     * @param {boolean} isCustom - Defines custom sort dialog open
     * @returns {void}
     * @hidden
     */ Grid.prototype.showResponsiveCustomSort = function(isCustom) {
        if (this.sortModule) this.sortModule.showCustomSort(isCustom || this.rowRenderingMode === "Vertical");
    };
    /**
     * @param {boolean} isCustom - Defines custom column chooser dialog open
     * @returns {void}
     * @hidden
     */ Grid.prototype.showResponsiveCustomColumnChooser = function(isCustom) {
        if (this.columnChooserModule) this.columnChooserModule.showCustomColumnChooser(isCustom || this.rowRenderingMode === "Vertical");
    };
    /**
     * To manually show the vertical row mode filter dialog
     *
     * @returns {void}
     */ Grid.prototype.showAdaptiveFilterDialog = function() {
        if (this.enableAdaptiveUI) this.showResponsiveCustomFilter(true);
    };
    /**
     * To manually show the vertical row sort filter dialog
     *
     * @returns {void}
     */ Grid.prototype.showAdaptiveSortDialog = function() {
        if (this.enableAdaptiveUI) this.showResponsiveCustomSort(true);
    };
    /**
     * @param {boolean} isColVirtualization - Defines column virtualization
     * @returns {Column[]} returns array of column models
     * @hidden
     */ Grid.prototype.getCurrentVisibleColumns = function(isColVirtualization) {
        var cols = [];
        var gridCols = isColVirtualization ? this.getColumns() : this.columnModel;
        for(var _i = 0, gridCols_1 = gridCols; _i < gridCols_1.length; _i++){
            var col = gridCols_1[_i];
            if (col.visible) cols.push(col);
        }
        return cols;
    };
    Grid.prototype.enableInfiniteAggrgate = function() {
        if (this.enableInfiniteScrolling && this.groupSettings.columns.length && !this.groupSettings.disablePageWiseAggregates && !this.groupSettings.enableLazyLoading) this.setProperties({
            groupSettings: {
                disablePageWiseAggregates: true
            }
        }, true);
    };
    var Grid_1;
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Grid.prototype, "currentViewData", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "parentDetails", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "showHider", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Grid.prototype, "columns", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "enableAltRow", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "enableHover", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableAutoFill", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "allowKeyboard", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableStickyHeader", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableHtmlSanitizer", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowTextWrap", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$4fd0f6c72cc1b945)
    ], Grid.prototype, "textWrapSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$c9afda34c579f960)
    ], Grid.prototype, "resizeSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowPaging", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $0f1c8bc7df35ce7b$export$803d23cfbdb4ac71))
    ], Grid.prototype, "pageSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$7c20be4c1d342248)
    ], Grid.prototype, "loadingIndicator", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "enableVirtualMaskRow", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableVirtualization", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableColumnVirtualization", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableInfiniteScrolling", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$352475af1e1a6201)
    ], Grid.prototype, "searchSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowSorting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Ellipsis")
    ], Grid.prototype, "clipMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "allowMultiSorting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowExcelExport", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowPdfExport", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$28c72d0529782de)
    ], Grid.prototype, "sortSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$4fe2fce573ada070)
    ], Grid.prototype, "infiniteScrollSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Grid.prototype, "allowSelection", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(-1)
    ], Grid.prototype, "selectedRowIndex", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$771166eca748644a)
    ], Grid.prototype, "selectionSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowFiltering", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Horizontal")
    ], Grid.prototype, "rowRenderingMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableAdaptiveUI", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], Grid.prototype, "adaptiveUIMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowReordering", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowResizing", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowRowDragAndDrop", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$4972d1402d3d782b)
    ], Grid.prototype, "rowDropSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$9fa85cf4a9b19444)
    ], Grid.prototype, "filterSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "allowGrouping", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableImmutableMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "showColumnMenu", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "autoFit", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$7756bc8dbeb9ec70)
    ], Grid.prototype, "groupSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, $503c118799028775$export$55fd657a92ecd4ad)
    ], Grid.prototype, "editSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $00d8239bc4893f3a$export$f4fb7a899a7c5783))
    ], Grid.prototype, "aggregates", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "showColumnChooser", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $b46e76cd3738afcf$export$ff0549a76c45d2e4))
    ], Grid.prototype, "columnChooserSettings", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Grid.prototype, "enableHeaderFocus", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Grid.prototype, "height", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Grid.prototype, "width", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Default")
    ], Grid.prototype, "gridLines", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "rowTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "emptyRecordTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "detailTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "childGrid", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "queryString", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("AllPages")
    ], Grid.prototype, "printMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("Expanded")
    ], Grid.prototype, "hierarchyPrintMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Grid.prototype, "dataSource", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Grid.prototype, "rowHeight", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "query", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("USD")
    ], Grid.prototype, "currencyCode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "exportGrids", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "toolbar", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "contextMenuItems", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "columnMenuItems", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "toolbarTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)()
    ], Grid.prototype, "pagerTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Grid.prototype, "frozenRows", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Grid.prototype, "frozenColumns", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Grid.prototype, "cssClass", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("All")
    ], Grid.prototype, "columnQueryMode", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)({})
    ], Grid.prototype, "currentAction", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Grid.prototype, "ej2StatePersistenceVersion", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "created", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "destroyed", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "load", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDataBound", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "queryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "headerCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "actionBegin", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "actionComplete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "actionFailure", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "dataBound", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "recordDoubleClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "recordClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowSelecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowSelected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDeselecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDeselected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellSelecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellSelected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellDeselecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellDeselected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnSelecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnSelected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDeselecting", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDeselected", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDragStart", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDrag", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDrop", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "printComplete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforePrint", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "pdfQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "pdfHeaderQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "pdfAggregateQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "excelAggregateQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "exportDetailDataBound", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "exportDetailTemplate", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "excelQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "excelHeaderQueryCellInfo", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeExcelExport", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "excelExportComplete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforePdfExport", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "pdfExportComplete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDragStartHelper", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "detailDataBound", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDragStart", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDrag", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "rowDrop", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "toolbarClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeOpenColumnChooser", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeOpenAdaptiveDialog", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "batchAdd", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "batchDelete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "batchCancel", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeBatchAdd", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeBatchDelete", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeBatchSave", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beginEdit", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "commandClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellEdit", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellSave", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "cellSaved", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "resizeStart", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "resizing", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "resizeStop", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "keyPressed", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeDataBound", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "contextMenuOpen", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "contextMenuClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnMenuOpen", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnMenuClick", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "checkBoxChange", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeCopy", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforePaste", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "beforeAutoFill", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "columnDataStateChange", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "dataStateChange", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "dataSourceChanged", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "exportGroupCaption", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "lazyLoadGroupExpand", void 0);
    $503c118799028775$var$__decorate([
        (0, $5rsSz.Event)()
    ], Grid.prototype, "lazyLoadGroupCollapse", void 0);
    Grid = Grid_1 = $503c118799028775$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Grid);
    return Grid;
}((0, $hQxLN.Component));





function $41e4fa99f5153f53$export$ef84e4e67f168fa1() {
    return [
        "aggregates",
        "allowGrouping",
        "allowFiltering",
        "allowMultiSorting",
        "allowReordering",
        "allowSorting",
        "allowTextWrap",
        "childGrid",
        "columns",
        "currentViewData",
        "dataSource",
        "detailTemplate",
        "enableAltRow",
        "enableColumnVirtualization",
        "filterSettings",
        "gridLines",
        "groupSettings",
        "height",
        "locale",
        "pageSettings",
        "printMode",
        "query",
        "queryString",
        "enableRtl",
        "rowHeight",
        "rowTemplate",
        "sortSettings",
        "textWrapSettings",
        "allowPaging",
        "hierarchyPrintMode",
        "searchSettings",
        "queryCellInfo",
        "beforeDataBound"
    ];
}
/**
 *
 * The `Print` module is used to handle print action.
 */ var $41e4fa99f5153f53$export$531cef85654f2406 = /** @class */ function() {
    /**
     * Constructor for the Grid print module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {Scroll} scrollModule - specifies the scroll module
     * @hidden
     */ function Print(parent, scrollModule) {
        this.isAsyncPrint = false;
        this.defered = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
        this.parent = parent;
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.isContentReady(), this);
        this.actionBeginFunction = this.actionBegin.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.on($17b89d3b1fc93cdb$export$63287e93462800a4, this.onEmpty.bind(this));
        this.parent.on($17b89d3b1fc93cdb$export$5f9cb737ece1af6, this.hierarchyPrint, this);
        this.scrollModule = scrollModule;
    }
    Print.prototype.isContentReady = function() {
        var _this = this;
        if (this.isPrintGrid() && (this.parent.hierarchyPrintMode === "None" || !this.parent.childGrid)) return this.contentReady;
        return function() {
            _this.defered.promise.then(function() {
                _this.contentReady();
            });
            if (_this.isPrintGrid()) _this.hierarchyPrint();
        };
    };
    Print.prototype.hierarchyPrint = function() {
        this.removeColGroup(this.parent);
        var printGridObj = window.printGridObj;
        if (printGridObj && !printGridObj.element.querySelector("[aria-busy=true")) printGridObj.printModule.defered.resolve();
    };
    /**
     * By default, prints all the Grid pages and hides the pager.
     * > You can customize print options using the
     * [`printMode`](./printmode/).
     *
     * @returns {void}
     */ Print.prototype.print = function() {
        this.renderPrintGrid();
    };
    Print.prototype.onEmpty = function() {
        if (this.isPrintGrid()) this.contentReady();
    };
    Print.prototype.actionBegin = function() {
        if (this.isPrintGrid()) this.isAsyncPrint = true;
    };
    Print.prototype.renderPrintGrid = function() {
        var gObj = this.parent;
        var element = (0, $4ZDHT.createElement)("div", {
            id: this.parent.element.id + "_print",
            className: gObj.element.className + " e-print-grid"
        });
        element.classList.remove("e-gridhover");
        document.body.appendChild(element);
        var printGrid = new (0, $503c118799028775$export$ef2184bd89960b14)((0, $748c2240e597a9b7$export$854231c97a3cacb6)(gObj, gObj.hierarchyPrintMode));
        for(var i = 0; i < printGrid.columns.length; i++){
            printGrid.columns[parseInt(i.toString(), 10)] = (0, $3EnZW.extend)({}, printGrid.columns[parseInt(i.toString(), 10)]);
            if (!gObj.getFrozenColumns() && gObj.isFrozenGrid()) printGrid.columns[parseInt(i.toString(), 10)].freeze = undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.parent.isAngular) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        printGrid.viewContainerRef = this.parent.viewContainerRef;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        printGrid.load = function() {};
        printGrid.query = gObj.getQuery().clone();
        window.printGridObj = printGrid;
        printGrid.isPrinting = true;
        var modules = printGrid.getInjectedModules();
        var injectedModues = gObj.getInjectedModules();
        if (!modules || modules.length !== injectedModues.length) printGrid.setInjectedModules(injectedModues);
        gObj.notify($17b89d3b1fc93cdb$export$e1bc4d46edb95a18, {
            element: element,
            printgrid: printGrid
        });
        this.parent.log("exporting_begin", this.getModuleName());
        printGrid.registeredTemplate = this.parent.registeredTemplate;
        printGrid.isVue = this.parent.isVue;
        if (this.parent.isVue) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        printGrid.vueInstance = this.parent.vueInstance;
        printGrid.appendTo(element);
        if (!gObj.isVue3) printGrid.trigger = gObj.trigger;
    };
    Print.prototype.contentReady = function() {
        if (this.isPrintGrid()) {
            var gObj = this.parent;
            if (this.isAsyncPrint) {
                this.printGrid();
                return;
            }
            var args = {
                requestType: "print",
                element: gObj.element,
                selectedRows: gObj.getContentTable().querySelectorAll('tr[aria-selected="true"]'),
                cancel: false,
                hierarchyPrintMode: gObj.hierarchyPrintMode
            };
            if (!this.isAsyncPrint) gObj.trigger($17b89d3b1fc93cdb$export$239eb85392ed959a, args);
            if (args.cancel) {
                (0, $4ZDHT.detach)(gObj.element);
                return;
            }
            if (!this.isAsyncPrint) this.printGrid();
        }
    };
    Print.prototype.printGrid = function() {
        var gObj = this.parent;
        // Height adjustment on print grid
        if (gObj.height !== "auto") {
            var cssProps = this.scrollModule.getCssProperties();
            var contentDiv = gObj.element.querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
            var headerDiv = gObj.element.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0);
            contentDiv.style.height = "auto";
            contentDiv.style.overflowY = "auto";
            headerDiv.style[cssProps.padding] = "";
            headerDiv.firstElementChild.style[cssProps.border] = "";
        }
        // Grid alignment adjustment on grouping
        if (gObj.allowGrouping) {
            if (!gObj.groupSettings.columns.length) gObj.element.querySelector(".e-groupdroparea").style.display = "none";
            else this.removeColGroup(gObj);
        }
        // hide horizontal scroll
        for(var _i = 0, _a = [].slice.call(gObj.element.getElementsByClassName($1b5568e76cdae6d4$export$a7db06668cad9adb)); _i < _a.length; _i++){
            var element = _a[_i];
            element.style.overflowX = "hidden";
        }
        // Hide the waiting popup
        var waitingPop = [].slice.call(gObj.element.getElementsByClassName("e-spin-show"));
        for(var _b = 0, _c = [].slice.call(waitingPop); _b < _c.length; _b++){
            var element = _c[_b];
            (0, $4ZDHT.classList)(element, [
                "e-spin-hide"
            ], [
                "e-spin-show"
            ]);
        }
        this.printGridElement(gObj);
        gObj.isPrinting = false;
        delete window.printGridObj;
        var args = {
            element: gObj.element
        };
        gObj.trigger($17b89d3b1fc93cdb$export$2b7078dd4f4e226a, args);
        gObj.destroy();
        this.parent.log("exporting_complete", this.getModuleName());
    };
    Print.prototype.printGridElement = function(gObj) {
        (0, $4ZDHT.classList)(gObj.element, [
            "e-print-grid-layout"
        ], [
            "e-print-grid"
        ]);
        if (gObj.isPrinting) (0, $4ZDHT.detach)(gObj.element);
        this.printWind = window.open("", "print", "height=" + window.outerHeight + ",width=" + window.outerWidth + ",tabbar=no");
        if (!(0, $3EnZW.isNullOrUndefined)(this.printWind)) {
            this.printWind.moveTo(0, 0);
            this.printWind.resizeTo(screen.availWidth, screen.availHeight);
            this.printWind = (0, $3EnZW.print)(gObj.element, this.printWind);
        }
    };
    Print.prototype.removeColGroup = function(gObj) {
        var depth = gObj.groupSettings.columns.length;
        var element = gObj.element;
        var id = "#" + gObj.element.id;
        if (!depth) return;
        var groupCaption = (0, $4ZDHT.selectAll)(".e-groupcaption", element);
        var colSpan = groupCaption[depth - 1].getAttribute("colspan");
        for(var i = 0; i < groupCaption.length; i++)groupCaption[parseInt(i.toString(), 10)].setAttribute("colspan", colSpan);
        var colGroups = (0, $4ZDHT.selectAll)("colgroup" + id + "colgroup", element);
        var contentColGroups = (0, $4ZDHT.selectAll)(".e-content colgroup", element);
        var footerColGroups = (0, $4ZDHT.selectAll)(".e-summarycontent colgroup", element);
        this.hideColGroup(colGroups, depth);
        this.hideColGroup(contentColGroups, depth);
        this.hideColGroup(footerColGroups, depth);
    };
    Print.prototype.hideColGroup = function(colGroups, depth) {
        for(var i = 0; i < colGroups.length; i++)for(var j = 0; j < depth; j++)colGroups[parseInt(i.toString(), 10)].children[parseInt(j.toString(), 10)].style.display = "none";
    };
    /**
     * To destroy the print
     *
     * @returns {boolean} returns the isPrintGrid or not
     * @hidden
     */ Print.prototype.isPrintGrid = function() {
        return this.parent.element.id.indexOf("_print") > 0 && this.parent.isPrinting;
    };
    /**
     * To destroy the print
     *
     * @returns {void}
     * @hidden
     */ Print.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.contentReady.bind(this));
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.off($17b89d3b1fc93cdb$export$63287e93462800a4, this.onEmpty.bind(this));
        this.parent.off($17b89d3b1fc93cdb$export$5f9cb737ece1af6, this.hierarchyPrint);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Print.prototype.getModuleName = function() {
        return "print";
    };
    Print.printGridProp = $41e4fa99f5153f53$export$ef84e4e67f168fa1().concat([
        $17b89d3b1fc93cdb$export$239eb85392ed959a,
        $17b89d3b1fc93cdb$export$2b7078dd4f4e226a,
        $17b89d3b1fc93cdb$export$11e63f7b0f3d9900
    ]);
    return Print;
}();




function $748c2240e597a9b7$export$9661456f2f103224(target, checkFor) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return target.prototype && checkFor in target.prototype;
}
function $748c2240e597a9b7$export$3261869d17a2d1fe(field, data, column) {
    return (0, $3EnZW.isNullOrUndefined)(field) || field === "" ? "" : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(field, data);
}
function $748c2240e597a9b7$export$48a4b714dfd08416(field, column) {
    return (0, $3EnZW.isNullOrUndefined)(field) || field === "" ? "" : (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(field, column);
}
function $748c2240e597a9b7$export$1a5f3b7403a8bf39(updateFunction, callBack) {
    requestAnimationFrame(function() {
        try {
            callBack(null, updateFunction());
        } catch (e) {
            callBack(e);
        }
    });
}
function $748c2240e597a9b7$export$54b64ba4d3ca13b3(exportProperties) {
    return !(0, $3EnZW.isNullOrUndefined)(exportProperties) && !(0, $3EnZW.isNullOrUndefined)(exportProperties.columns) && exportProperties.columns.length > 0;
}
function $748c2240e597a9b7$export$e25aefb92a91af83(exportProperties, gObj) {
    var exportColumns = exportProperties.columns;
    var gridColumns = gObj.columns;
    for(var i = 0; i < exportColumns.length; i++)if (gridColumns.length - 1 >= i) {
        if (gridColumns[parseInt(i.toString(), 10)].columns) for(var j = 0; j < gridColumns[parseInt(i.toString(), 10)].columns.length; j++)exportColumns[parseInt(i.toString(), 10)].columns[parseInt(j.toString(), 10)].type = gridColumns[parseInt(i.toString(), 10)].columns[parseInt(j.toString(), 10)].type;
        else exportColumns[parseInt(i.toString(), 10)].type = gridColumns[parseInt(i.toString(), 10)].type;
    }
}
function $748c2240e597a9b7$export$a16bd681357a4a59(grid) {
    var nRows = [];
    var actualRows = grid.vRows;
    for(var i = 0; i < actualRows.length; i++){
        if (actualRows[parseInt(i.toString(), 10)].isDataRow) nRows.push(actualRows[parseInt(i.toString(), 10)]);
        else if (!actualRows[parseInt(i.toString(), 10)].isDataRow) {
            nRows.push(actualRows[parseInt(i.toString(), 10)]);
            if (!actualRows[parseInt(i.toString(), 10)].isExpand && actualRows[parseInt(i.toString(), 10)].isCaptionRow) i += $748c2240e597a9b7$export$218845438ab3526f(actualRows[parseInt(i.toString(), 10)], grid);
        }
    }
    grid.vcRows = nRows;
}
var $748c2240e597a9b7$var$count = 0;
function $748c2240e597a9b7$export$218845438ab3526f(val, grid) {
    $748c2240e597a9b7$var$count = 0;
    var gSummary = "gSummary";
    var total = "count";
    var gLen = grid.groupSettings.columns.length;
    var records = "records";
    var items = "items";
    var value = val["" + gSummary];
    var dataRowCnt = 0;
    var agrCnt = "aggregatesCount";
    if (value === val.data["" + total]) {
        if (grid.groupSettings.columns.length && !(0, $3EnZW.isNullOrUndefined)(val["" + agrCnt]) && val["" + agrCnt]) {
            if (grid.groupSettings.columns.length !== 1) $748c2240e597a9b7$var$count += val.indent !== 0 && value < 2 ? val["" + gSummary] * (gLen - val.indent + (gLen - val.indent) * val["" + agrCnt]) : val["" + gSummary] * (gLen - val.indent + (gLen - val.indent - 1) * val["" + agrCnt]) + val["" + agrCnt];
            else if (grid.groupSettings.columns.length === 1) $748c2240e597a9b7$var$count += val["" + gSummary] * (gLen - val.indent) + val["" + agrCnt];
        } else if (grid.groupSettings.columns.length) {
            if (grid.groupSettings.columns.length !== 1) $748c2240e597a9b7$var$count += val["" + gSummary] * (grid.groupSettings.columns.length - val.indent);
            else $748c2240e597a9b7$var$count += val["" + gSummary];
        }
        return $748c2240e597a9b7$var$count;
    } else {
        for(var i = 0, len = val.data["" + items].length; i < len; i++){
            var gLevel = val.data["" + items][parseInt(i.toString(), 10)];
            $748c2240e597a9b7$var$count += gLevel["" + items].length + (gLen !== grid.columns.length && !(0, $3EnZW.isNullOrUndefined)(gLevel["" + items]["" + records]) ? gLevel["" + items]["" + records].length : 0);
            dataRowCnt += !(0, $3EnZW.isNullOrUndefined)(gLevel["" + items]["" + records]) && !(0, $3EnZW.isNullOrUndefined)(val["" + agrCnt]) ? gLevel["" + items]["" + records].length : gLevel["" + items].length;
            if (gLevel["" + items].GroupGuid && gLevel["" + items].childLevels !== 0) $748c2240e597a9b7$export$43a194da3ac23518(gLevel);
        }
        $748c2240e597a9b7$var$count += val.data["" + items].length;
        if (!(0, $3EnZW.isNullOrUndefined)(val["" + agrCnt])) {
            if (val["" + agrCnt] && $748c2240e597a9b7$var$count && dataRowCnt !== 0) $748c2240e597a9b7$var$count += ($748c2240e597a9b7$var$count - dataRowCnt) * val["" + agrCnt] + val["" + agrCnt];
        }
    }
    return $748c2240e597a9b7$var$count;
}
function $748c2240e597a9b7$export$43a194da3ac23518(row) {
    var items = "items";
    var rCount = "count";
    for(var j = 0, length_1 = row["" + items].length; j < length_1; j++){
        var nLevel = row["" + items][parseInt(j.toString(), 10)];
        $748c2240e597a9b7$var$count += nLevel["" + rCount];
        if (nLevel["" + items].childLevels !== 0) $748c2240e597a9b7$export$43a194da3ac23518(nLevel);
    }
}
function $748c2240e597a9b7$export$88cbd5a9815d5a0a(collection, predicate) {
    var result = [];
    for(var i = 0, len = collection.length; i < len; i++){
        var pred = predicate(collection[parseInt(i.toString(), 10)], i);
        if (!(0, $3EnZW.isNullOrUndefined)(pred)) result.push(pred);
    }
    return result;
}
function $748c2240e597a9b7$export$5788824bee325a29(array) {
    var obj = [];
    for(var i = 0; i < array.length; i++)obj.push((0, $3EnZW.extend)({}, $748c2240e597a9b7$export$8d71c07056cfde24(array[parseInt(i.toString(), 10)]), {}, true));
    return obj;
}
function $748c2240e597a9b7$export$4ffdcfa44babc928(template) {
    if (template) try {
        var validSelector = template[0] !== "<";
        if (typeof template === "function") return (0, $c2qqN.compile)(template);
        else if (validSelector && document.querySelectorAll(template).length) return (0, $c2qqN.compile)(document.querySelector(template).innerHTML.trim());
        else return (0, $c2qqN.compile)(template);
    } catch (e) {
        return (0, $c2qqN.compile)(template);
    }
    return undefined;
}
function $748c2240e597a9b7$export$811a58cea531d41d(node, customAttributes) {
    var copyAttr = {};
    var literals = [
        "style",
        "class"
    ];
    //Dont touch the original object - make a copy
    (0, $3EnZW.extend)(copyAttr, customAttributes, {});
    if ("style" in copyAttr) {
        (0, $4ZDHT.setStyleAttribute)(node, copyAttr[literals[0]]);
        delete copyAttr[literals[0]];
    }
    if ("class" in copyAttr) {
        (0, $4ZDHT.addClass)([
            node
        ], copyAttr[literals[1]]);
        delete copyAttr[literals[1]];
    }
    (0, $4ZDHT.attributes)(node, copyAttr);
}
function $748c2240e597a9b7$export$8b58be045bf06082(copied, first, second, exclude) {
    var moved = (0, $3EnZW.extend)(copied, first, second);
    var values = Object.keys(moved);
    for(var i = 0; i < values.length; i++)if (exclude && exclude.indexOf(values[parseInt(i.toString(), 10)]) !== -1) delete moved[values[parseInt(i.toString(), 10)]];
    return moved;
}
function $748c2240e597a9b7$export$64b518da455ab951(columnModel, ind) {
    if (ind === void 0) ind = 0;
    for(var i = 0, len = !(0, $3EnZW.isNullOrUndefined)(columnModel) ? columnModel.length : 0; i < len; i++)if (columnModel[parseInt(i.toString(), 10)].columns) {
        columnModel[parseInt(i.toString(), 10)].index = (0, $3EnZW.isNullOrUndefined)(columnModel[parseInt(i.toString(), 10)].index) ? ind : columnModel[parseInt(i.toString(), 10)].index;
        ind++;
        ind = $748c2240e597a9b7$export$64b518da455ab951(columnModel[parseInt(i.toString(), 10)].columns, ind);
    } else {
        columnModel[parseInt(i.toString(), 10)].index = (0, $3EnZW.isNullOrUndefined)(columnModel[parseInt(i.toString(), 10)].index) ? ind : columnModel[parseInt(i.toString(), 10)].index;
        ind++;
    }
    return ind;
}
function $748c2240e597a9b7$export$1147582dfae658c6(columns, autoWidth, gObj) {
    for(var c = 0, len = !(0, $3EnZW.isNullOrUndefined)(columns) ? columns.length : 0; c < len; c++){
        var column = void 0;
        if (typeof columns[parseInt(c.toString(), 10)] === "string") column = new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
            field: columns[parseInt(c.toString(), 10)]
        }, gObj);
        else if (!(columns[parseInt(c.toString(), 10)] instanceof (0, $0cb66def079b19f9$export$816b5d811295e6bc)) || columns[parseInt(c.toString(), 10)].columns) {
            if (!columns[parseInt(c.toString(), 10)].columns) column = new (0, $0cb66def079b19f9$export$816b5d811295e6bc)(columns[parseInt(c.toString(), 10)], gObj);
            else {
                columns[parseInt(c.toString(), 10)].columns = $748c2240e597a9b7$export$1147582dfae658c6(columns[parseInt(c.toString(), 10)].columns, null, gObj);
                column = new (0, $0cb66def079b19f9$export$816b5d811295e6bc)(columns[parseInt(c.toString(), 10)], gObj);
            }
        } else column = columns[parseInt(c.toString(), 10)];
        if (column.type && column.type.toLowerCase() === "checkbox") column.allowReordering = false;
        column.headerText = (0, $3EnZW.isNullOrUndefined)(column.headerText) ? column.foreignKeyValue || column.field || "" : column.headerText;
        column.foreignKeyField = column.foreignKeyField || column.field;
        column.valueAccessor = (typeof column.valueAccessor === "string" ? (0, $3EnZW.getValue)(column.valueAccessor, window) : column.valueAccessor) || $748c2240e597a9b7$export$3261869d17a2d1fe;
        column.width = autoWidth && (0, $3EnZW.isNullOrUndefined)(column.width) ? 200 : column.width;
        if ((0, $3EnZW.isNullOrUndefined)(column.visible)) column.visible = true;
        columns[parseInt(c.toString(), 10)] = column;
    }
    return columns;
}
function $748c2240e597a9b7$export$7ad8741a0e3edfbb(popUp, e, className) {
    var popUpSpan = popUp.querySelector("span");
    var position = popUp.parentElement.getBoundingClientRect();
    var targetPosition = e.target.getBoundingClientRect();
    popUpSpan.className = className;
    popUp.style.display = "";
    var isBottomTail = ((0, $3EnZW.isNullOrUndefined)(e.clientY) ? e.changedTouches[0].clientY : e.clientY) > popUp.offsetHeight + 10;
    popUp.style.top = targetPosition.top - position.top + (isBottomTail ? -(popUp.offsetHeight + 10) : popUp.offsetHeight + 10) + "px"; //10px for tail element
    popUp.style.left = $748c2240e597a9b7$var$getPopupLeftPosition(popUp, e, targetPosition, position.left) + "px";
    if (isBottomTail) {
        popUp.querySelector(".e-downtail").style.display = "";
        popUp.querySelector(".e-uptail").style.display = "none";
    } else {
        popUp.querySelector(".e-downtail").style.display = "none";
        popUp.querySelector(".e-uptail").style.display = "";
    }
}
/**
 * @param {HTMLElement} popup - Defines the popup element
 * @param {MouseEvent | TouchEvent} e  - Defines the mouse event
 * @param {Object} targetPosition - Defines the target position
 * @param {number} targetPosition.top - Defines the top position
 * @param {number} targetPosition.left  - Defines the left position
 * @param {number} targetPosition.right  - Defines the right position
 * @param {number} left - Defines the left position
 * @returns {number} Returns the popup left position
 * @hidden
 */ function $748c2240e597a9b7$var$getPopupLeftPosition(popup, e, targetPosition, left) {
    var width = popup.offsetWidth / 2;
    var x = $748c2240e597a9b7$export$1690e12b840569b9(e).x;
    if (x - targetPosition.left < width) return targetPosition.left - left;
    else if (targetPosition.right - x < width) return targetPosition.right - left - width * 2;
    else return x - left - width;
}
function $748c2240e597a9b7$export$8d71c07056cfde24(obj) {
    if (obj instanceof (0, $3fcxu.ChildProperty)) return (0, $3EnZW.getValue)("properties", obj);
    else return obj;
}
function $748c2240e597a9b7$export$dcd0aa73ca0eb350(elem, selector, isID) {
    var parent = elem;
    while(parent){
        if (isID ? parent.id === selector : parent.classList.contains(selector)) break;
        parent = parent.parentElement;
    }
    return parent;
}
function $748c2240e597a9b7$export$54176e6d71b37692(element, elements) {
    var index = -1;
    for(var i = 0, len = elements.length; i < len; i++)if (elements[parseInt(i.toString(), 10)].isEqualNode(element)) {
        index = i;
        break;
    }
    return index;
}
function $748c2240e597a9b7$export$6632823c2c02cb2c(value, collection) {
    for(var i = 0, len = collection.length; i < len; i++){
        if (collection[parseInt(i.toString(), 10)] === value) return i;
    }
    return -1;
}
function $748c2240e597a9b7$export$3adc9e17a2947b53(collection) {
    var coll = [];
    for(var i = 0, len = collection.length; i < len; i++)// eslint-disable-next-line no-prototype-builtins
    if (collection[parseInt(i.toString(), 10)].hasOwnProperty("properties")) coll.push(collection[parseInt(i.toString(), 10)].properties);
    else coll.push(collection[parseInt(i.toString(), 10)]);
    return coll;
}
function $748c2240e597a9b7$export$f883456a56996078(target, selector) {
    var elements = [].slice.call(target.querySelectorAll(selector));
    for(var i = 0; i < elements.length; i++)(0, $4ZDHT.remove)(elements[parseInt(i.toString(), 10)]);
}
function $748c2240e597a9b7$export$1690e12b840569b9(e) {
    var position = {};
    position.x = (0, $3EnZW.isNullOrUndefined)(e.clientX) ? e.changedTouches[0].clientX : e.clientX;
    position.y = (0, $3EnZW.isNullOrUndefined)(e.clientY) ? e.changedTouches[0].clientY : e.clientY;
    return position;
}
var $748c2240e597a9b7$var$uid = 0;
function $748c2240e597a9b7$export$5e82334337e0f204(prefix) {
    return prefix + $748c2240e597a9b7$var$uid++;
}
function $748c2240e597a9b7$export$6dfa4c34d2d32617(elem, children) {
    for(var i = 0, len = children.length; i < len; i++)if (len === children.length) elem.appendChild(children[parseInt(i.toString(), 10)]);
    else elem.appendChild(children[0]);
    return elem;
}
function $748c2240e597a9b7$export$7901f6cd558b9a93(elem, selector, isID) {
    var parent = elem;
    var parents = [];
    while(parent){
        if (isID ? parent.id === selector : parent.classList.contains(selector)) parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $748c2240e597a9b7$export$cbe16b853cd7bbc8(type, data, column, context) {
    if (type === "Custom") {
        var temp = column.customAggregate;
        if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
        return temp ? temp.call(context, data, column) : "";
    }
    return column.field in data || data instanceof Array ? (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).aggregates[type.toLowerCase()](data, column.field) : null;
}
/** @hidden */ var $748c2240e597a9b7$var$scrollWidth = null;
function $748c2240e597a9b7$export$1df2a1438d36fb55() {
    if ($748c2240e597a9b7$var$scrollWidth !== null) return $748c2240e597a9b7$var$scrollWidth;
    var divNode = document.createElement("div");
    var value = 0;
    divNode.style.cssText = "width:100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;";
    document.body.appendChild(divNode);
    value = divNode.offsetWidth - divNode.clientWidth | 0;
    document.body.removeChild(divNode);
    return $748c2240e597a9b7$var$scrollWidth = value;
}
/** @hidden */ var $748c2240e597a9b7$var$rowHeight;
function $748c2240e597a9b7$export$69b171017bdea2b4(element) {
    if ($748c2240e597a9b7$var$rowHeight !== undefined) return $748c2240e597a9b7$var$rowHeight;
    var table = (0, $4ZDHT.createElement)("table", {
        className: $1b5568e76cdae6d4$export$9852986a3ec5f6a0,
        styles: "visibility: hidden",
        attrs: {
            role: "grid"
        }
    });
    table.innerHTML = '<tr><td class="e-rowcell">A<td></tr>';
    element.appendChild(table);
    var rect = table.querySelector("td").getBoundingClientRect();
    element.removeChild(table);
    $748c2240e597a9b7$var$rowHeight = Math.ceil(rect.height);
    return $748c2240e597a9b7$var$rowHeight;
}
function $748c2240e597a9b7$export$b59dee4aba40153d(element) {
    var table = (0, $4ZDHT.createElement)("table", {
        className: $1b5568e76cdae6d4$export$9852986a3ec5f6a0,
        styles: "visibility: hidden",
        attrs: {
            role: "grid"
        }
    });
    table.innerHTML = '<tr><td class="e-rowcell">A<td></tr>';
    element.appendChild(table);
    var rect = table.querySelector("tr").getBoundingClientRect();
    element.removeChild(table);
    return rect.height;
}
function $748c2240e597a9b7$export$9850823255bfa4ed(field) {
    return field.split(".").length > 1;
}
function $748c2240e597a9b7$export$d0c60e9a423ac807(field) {
    if (field === void 0) field = "";
    return field.replace(/\./g, "___");
}
function $748c2240e597a9b7$export$bd555f260694987a(field) {
    if (field === void 0) field = "";
    return field.replace(/[^a-zA-Z0-9_.]/g, "\\$&");
}
function $748c2240e597a9b7$export$71b71683b3fc7313(field) {
    if (field === void 0) field = "";
    return field.replace(/___/g, ".");
}
function $748c2240e597a9b7$export$5469c988647fcb7b(col, type, elem) {
    var row = $748c2240e597a9b7$export$dcd0aa73ca0eb350(elem, $1b5568e76cdae6d4$export$120ff0929b202a6d);
    var isOldRow = !row ? true : row && !row.classList.contains("e-insertedrow");
    if (type === "beginEdit" && isOldRow) {
        if (col.isIdentity || col.isPrimaryKey || !col.allowEditing) return false;
        return true;
    } else if (type === "add" && col.isIdentity) return false;
    else {
        if (isOldRow && !col.allowEditing && !col.isIdentity && !col.isPrimaryKey) return false;
        return true;
    }
}
function $748c2240e597a9b7$export$fbf5228cd2134af7(inst) {
    var dlg = (0, $4ZDHT.select)("#" + inst.element.id + "EditConfirm", inst.element);
    return inst.editSettings.mode === "Batch" && ((0, $4ZDHT.selectAll)(".e-updatedtd", inst.element).length || (0, $4ZDHT.selectAll)(".e-gridform.e-formvalidator", inst.element).length) && inst.editSettings.showConfirmDialog && (dlg ? dlg.classList.contains("e-popup-close") : true);
}
function $748c2240e597a9b7$export$4997ffc0176396a6(elem, action) {
    var clName = "e-wrap";
    elem = elem instanceof Array ? elem : [
        elem
    ];
    for(var i = 0; i < elem.length; i++)if (action) elem[parseInt(i.toString(), 10)].classList.add(clName);
    else elem[parseInt(i.toString(), 10)].classList.remove(clName);
}
function $748c2240e597a9b7$export$1986f8c9221d3ee2(serviceLocator, column) {
    var fmtr = serviceLocator.getService("valueFormatter");
    var format = "format";
    var args;
    if (column.type === "date" || column.type === "datetime" || column.type === "dateonly") {
        args = {
            type: column.type === "dateonly" ? "date" : column.type,
            skeleton: column.format
        };
        if (typeof column.format === "string" && column.format !== "yMd") args["" + format] = column.format;
    }
    switch(column.type){
        case "date":
            column.setFormatter(fmtr.getFormatFunction(args));
            column.setParser(fmtr.getParserFunction(args));
            break;
        case "dateonly":
            column.setFormatter(fmtr.getFormatFunction(args));
            column.setParser(fmtr.getParserFunction(args));
            break;
        case "datetime":
            column.setFormatter(fmtr.getFormatFunction(args));
            column.setParser(fmtr.getParserFunction(args));
            break;
        case "number":
            column.setFormatter(fmtr.getFormatFunction({
                format: column.format
            }));
            column.setParser(fmtr.getParserFunction({
                format: column.format
            }));
            break;
    }
}
function $748c2240e597a9b7$export$cc04b0fcbbab6cbf(cells, add) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    for(var i = 0, len = cells.length; i < len; i++)if (add) {
        (0, $4ZDHT.classList)(cells[parseInt(i.toString(), 10)], args.slice(), []);
        cells[parseInt(i.toString(), 10)].setAttribute("aria-selected", "true");
    } else {
        (0, $4ZDHT.classList)(cells[parseInt(i.toString(), 10)], [], args.slice());
        cells[parseInt(i.toString(), 10)].removeAttribute("aria-selected");
    }
}
function $748c2240e597a9b7$export$7f03ccbb98203610(result) {
    var temp = {};
    var res = [];
    for(var i = 0; i < result.length; i++)if (!(result[parseInt(i.toString(), 10)] in temp)) {
        res.push(result[parseInt(i.toString(), 10)].toString());
        temp[result[parseInt(i.toString(), 10)]] = 1;
    }
    return res;
}
function $748c2240e597a9b7$export$2b9ad9396c9b6e69(target, dialogObj) {
    var elementVisible = dialogObj.element.style.display;
    dialogObj.element.style.display = "block";
    var dlgWidth = dialogObj.width;
    var newpos = (0, $cWXlQ.calculateRelativeBasedPosition)(target, dialogObj.element);
    dialogObj.element.style.display = elementVisible;
    dialogObj.element.style.top = newpos.top + target.getBoundingClientRect().height - 5 + "px";
    var leftPos = newpos.left - dlgWidth + target.clientWidth;
    if (leftPos < 1) dialogObj.element.style.left = dlgWidth + leftPos - 16 + "px"; // right calculation
    else dialogObj.element.style.left = leftPos + -4 + "px";
}
function $748c2240e597a9b7$export$c50bf978b3bcbfde(args, dialogObj) {
    args.popup.element.style.zIndex = (dialogObj.zIndex + 1).toString();
}
function $748c2240e597a9b7$export$40f7f1b3a5921618(elem) {
    var span = elem.querySelector(".e-frame");
    var input = span.previousSibling;
    if (span.classList.contains("e-check")) {
        input.checked = false;
        (0, $4ZDHT.classList)(span, [
            "e-uncheck"
        ], [
            "e-check"
        ]);
    } else {
        input.checked = true;
        (0, $4ZDHT.classList)(span, [
            "e-check"
        ], [
            "e-uncheck"
        ]);
    }
}
function $748c2240e597a9b7$export$d2270ed72c00a9b2(elem, checked) {
    elem.checked = checked;
}
function $748c2240e597a9b7$export$cc092c6fe78fc98a(uid, elem, className) {
    var div = (0, $4ZDHT.createElement)("div", {
        className: className
    });
    div.appendChild(elem);
    div.setAttribute("uid", uid);
    return div;
}
function $748c2240e597a9b7$export$39b02a8864b327ad(elem, checked) {
    (0, $4ZDHT.removeClass)([
        elem
    ], [
        "e-check",
        "e-stop",
        "e-uncheck"
    ]);
    if (checked) elem.classList.add("e-check");
    else elem.classList.add("e-uncheck");
}
function $748c2240e597a9b7$export$64108eaaf316656b(row, columns, data) {
    for(var i = 0; i < (!(0, $3EnZW.isNullOrUndefined)(columns) ? columns.length : 0); i++)(0, $3EnZW.setValue)(columns[parseInt(i.toString(), 10)].field, $748c2240e597a9b7$export$ee62846b5e1ebfff(columns[parseInt(i.toString(), 10)], data), row.foreignKeyData);
    var cells = row.cells;
    for(var i = 0; i < cells.length; i++)if (cells[parseInt(i.toString(), 10)].isForeignKey) (0, $3EnZW.setValue)("foreignKeyData", (0, $3EnZW.getValue)(cells[parseInt(i.toString(), 10)].column.field, row.foreignKeyData), cells[parseInt(i.toString(), 10)]);
}
function $748c2240e597a9b7$export$ee62846b5e1ebfff(column, data, lValue, foreignKeyData) {
    var fField = column.foreignKeyField;
    var key = !(0, $3EnZW.isNullOrUndefined)(lValue) ? lValue : $748c2240e597a9b7$export$3261869d17a2d1fe(column.field, data, column);
    key = (0, $3EnZW.isNullOrUndefined)(key) ? "" : key;
    var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
    var fdata = foreignKeyData || (column.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && column.dataSource.dataSource.json.length ? column.dataSource.dataSource.json : column.columnData);
    if (key.getDay) query.where($748c2240e597a9b7$export$4c58a38283ee9c83({
        field: fField,
        operator: "equal",
        value: key,
        matchCase: false
    }));
    else query.where(fField, "==", key, false);
    return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(fdata).executeLocal(query);
}
function $748c2240e597a9b7$export$e0d896ad751b9ff7(foreignKeyValue, columns) {
    var column;
    return columns.some(function(col) {
        column = col;
        return col.foreignKeyValue === foreignKeyValue;
    }) && column;
}
function $748c2240e597a9b7$export$6ff84f8b5533737(value) {
    if (value < 10) return "0" + value;
    return String(value);
}
function $748c2240e597a9b7$export$4c58a38283ee9c83(filterObject, type, isExecuteLocal) {
    var datePredicate;
    var prevDate;
    var nextDate;
    var prevObj = (0, $3EnZW.extend)({}, $748c2240e597a9b7$export$8d71c07056cfde24(filterObject));
    var nextObj = (0, $3EnZW.extend)({}, $748c2240e597a9b7$export$8d71c07056cfde24(filterObject));
    if ((0, $3EnZW.isNullOrUndefined)(filterObject.value) || filterObject.value === "") {
        datePredicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(prevObj.field, prevObj.operator, prevObj.value, false);
        return datePredicate;
    }
    var value = new Date(filterObject.value);
    if (type === "dateonly" && !isExecuteLocal) {
        if (typeof prevObj.value === "string") prevObj.value = new Date(prevObj.value);
        var dateOnlyString = prevObj.value.getFullYear() + "-" + $748c2240e597a9b7$export$6ff84f8b5533737(prevObj.value.getMonth() + 1) + "-" + $748c2240e597a9b7$export$6ff84f8b5533737(prevObj.value.getDate());
        var predicates = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(prevObj.field, prevObj.operator, dateOnlyString, false);
        datePredicate = predicates;
    } else if (filterObject.operator === "equal" || filterObject.operator === "notequal") {
        if (type === "datetime") {
            prevDate = new Date(value.setSeconds(value.getSeconds() - 1));
            nextDate = new Date(value.setSeconds(value.getSeconds() + 2));
            filterObject.value = new Date(value.setSeconds(nextDate.getSeconds() - 1));
        } else {
            prevDate = new Date(value.setHours(0) - 1);
            nextDate = new Date(value.setHours(24));
        }
        prevObj.value = prevDate;
        nextObj.value = nextDate;
        if (filterObject.operator === "equal") {
            prevObj.operator = "greaterthan";
            nextObj.operator = "lessthan";
        } else if (filterObject.operator === "notequal") {
            prevObj.operator = "lessthanorequal";
            nextObj.operator = "greaterthanorequal";
        }
        var predicateSt = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(prevObj.field, prevObj.operator, prevObj.value, false);
        var predicateEnd = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(nextObj.field, nextObj.operator, nextObj.value, false);
        datePredicate = filterObject.operator === "equal" ? predicateSt.and(predicateEnd) : predicateSt.or(predicateEnd);
    } else {
        if (type === "date" && (filterObject.operator === "lessthanorequal" || filterObject.operator === "greaterthan")) prevObj.value = new Date(value.setHours(24) - 1);
        if (typeof prevObj.value === "string") prevObj.value = new Date(prevObj.value);
        var predicates = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(prevObj.field, prevObj.operator, prevObj.value, false);
        datePredicate = predicates;
    }
    if (filterObject.setProperties) filterObject.setProperties({
        ejpredicate: datePredicate
    }, true);
    else filterObject.ejpredicate = datePredicate;
    return datePredicate;
}
function $748c2240e597a9b7$export$d3edab9aa707d65f(grid) {
    return grid.enableVirtualization && grid.groupSettings.columns.length > 0 && grid.isVirtualAdaptive && !grid.groupSettings.enableLazyLoading;
}
function $748c2240e597a9b7$export$93534728ecb2e7b9(field, object) {
    if (field === void 0) field = "";
    if (field) {
        var value = object;
        var splits = field.split(".");
        for(var i = 0; i < splits.length && !(0, $3EnZW.isNullOrUndefined)(value); i++){
            value = value[splits[parseInt(i.toString(), 10)]];
            if ((0, $3EnZW.isUndefined)(value)) {
                var newCase = splits[parseInt(i.toString(), 10)].charAt(0).toUpperCase() + splits[parseInt(i.toString(), 10)].slice(1);
                value = object["" + newCase] || object[("" + newCase).charAt(0).toLowerCase() + ("" + newCase).slice(1)];
            }
        }
        return value;
    }
}
function $748c2240e597a9b7$export$cd23debbf9725d(format, colType) {
    var intl = new (0, $bWDaN.Internationalization)();
    var formatvalue;
    var formatter = "format";
    var type = "type";
    if (colType === "date") formatvalue = typeof format === "object" ? intl.getDatePattern({
        type: format["" + type] ? format["" + type] : "date",
        format: format["" + formatter]
    }, false) : intl.getDatePattern({
        type: "dateTime",
        skeleton: format
    }, false);
    else formatvalue = typeof format === "object" ? intl.getDatePattern({
        type: format["" + type] ? format["" + type] : "dateTime",
        format: format["" + formatter]
    }, false) : intl.getDatePattern({
        type: "dateTime",
        skeleton: format
    }, false);
    return formatvalue;
}
function $748c2240e597a9b7$export$6038553d90b3a59e(gObj, hierarchyPrintMode) {
    var rows = gObj.getRowsObject();
    var obj = {};
    for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
        var row = rows_1[_i];
        if (row.isExpand && !row.isDetailRow) {
            var index = gObj.allowPaging && gObj.printMode === "AllPages" ? row.index + gObj.pageSettings.currentPage * gObj.pageSettings.pageSize - gObj.pageSettings.pageSize : row.index;
            if (!(0, $3EnZW.isNullOrUndefined)(index)) {
                obj[parseInt(index.toString(), 10)] = {};
                obj[parseInt(index.toString(), 10)].isExpand = true;
                if (gObj.childGrid) {
                    obj[parseInt(index.toString(), 10)].gridModel = $748c2240e597a9b7$export$854231c97a3cacb6(row.childGrid, hierarchyPrintMode);
                    obj[parseInt(index.toString(), 10)].gridModel.query = gObj.childGrid.query;
                }
            }
        }
    }
    return obj;
}
function $748c2240e597a9b7$export$854231c97a3cacb6(gObj, hierarchyPrintMode) {
    if (hierarchyPrintMode === void 0) hierarchyPrintMode = "Expanded";
    var printGridModel = {};
    if (!gObj) return printGridModel;
    for(var _i = 0, _a = (0, $41e4fa99f5153f53$export$531cef85654f2406).printGridProp; _i < _a.length; _i++){
        var key = _a[_i];
        if (key === "columns") printGridModel["" + key] = $748c2240e597a9b7$export$3adc9e17a2947b53(gObj["" + key]);
        else if (key === "allowPaging") printGridModel["" + key] = gObj.printMode === "CurrentPage";
        else printGridModel["" + key] = $748c2240e597a9b7$export$8d71c07056cfde24(gObj["" + key]);
    }
    printGridModel["enableHover"] = false;
    if ((gObj.childGrid || gObj.detailTemplate) && hierarchyPrintMode !== "None") printGridModel.expandedRows = $748c2240e597a9b7$export$6038553d90b3a59e(gObj, hierarchyPrintMode);
    return printGridModel;
}
function $748c2240e597a9b7$export$8f9fa30750711038(copied, first, second, deep) {
    var res = copied || {};
    var len = arguments.length;
    if (deep) len = len - 1;
    for(var i = 1; i < len; i++){
        // eslint-disable-next-line prefer-rest-params
        if (!arguments[parseInt(i.toString(), 10)]) continue;
        // eslint-disable-next-line prefer-rest-params
        var obj1 = arguments[parseInt(i.toString(), 10)];
        var keys = Object.keys(Object.getPrototypeOf(obj1)).length ? Object.keys(obj1).concat($748c2240e597a9b7$export$410c72191cc815a0(obj1)) : Object.keys(obj1);
        for(var i_1 = 0; i_1 < keys.length; i_1++){
            var source = res[keys[parseInt(i_1.toString(), 10)]];
            var cpy = obj1[keys[parseInt(i_1.toString(), 10)]];
            var cln = void 0;
            if (deep && ((0, $3EnZW.isObject)(cpy) || Array.isArray(cpy))) {
                if ((0, $3EnZW.isObject)(cpy)) {
                    cln = source ? source : {};
                    res[keys[parseInt(i_1.toString(), 10)]] = (0, $3EnZW.extend)({}, cln, cpy, deep);
                } else {
                    cln = source ? source : [];
                    res[keys[parseInt(i_1.toString(), 10)]] = (0, $3EnZW.extend)([], cln, cpy, deep);
                }
            } else res[keys[parseInt(i_1.toString(), 10)]] = cpy;
        }
    }
    return res;
}
function $748c2240e597a9b7$export$410c72191cc815a0(obj) {
    var keys = [];
    while(Object.getPrototypeOf(obj) && Object.keys(Object.getPrototypeOf(obj)).length){
        keys = keys.concat(Object.keys(Object.getPrototypeOf(obj)));
        obj = Object.getPrototypeOf(obj);
    }
    return keys;
}
function $748c2240e597a9b7$export$d6485206a212c36b(column) {
    var max = 0;
    for(var i = 0; i < (!(0, $3EnZW.isNullOrUndefined)(column) ? column.length : 0); i++){
        var depth = $748c2240e597a9b7$export$ae9107eff441cee5(column[parseInt(i.toString(), 10)], 0);
        if (max < depth) max = depth;
    }
    return max + 1;
}
function $748c2240e597a9b7$export$ae9107eff441cee5(col, index) {
    var max = index;
    var indices = [];
    if (col.columns) {
        index++;
        for(var i = 0; i < col.columns.length; i++)indices[parseInt(i.toString(), 10)] = $748c2240e597a9b7$export$ae9107eff441cee5(col.columns[parseInt(i.toString(), 10)], index);
        for(var j = 0; j < indices.length; j++)if (max < indices[parseInt(j.toString(), 10)]) max = indices[parseInt(j.toString(), 10)];
        index = max;
    }
    return index;
}
function $748c2240e597a9b7$export$f09b34d3b1ff9814(gObj, filteredCols) {
    for(var i = 0; i < filteredCols.length; i++)filteredCols[parseInt(i.toString(), 10)].uid = filteredCols[parseInt(i.toString(), 10)].isForeignKey ? $748c2240e597a9b7$export$e0d896ad751b9ff7(filteredCols[parseInt(i.toString(), 10)].field, gObj.getForeignKeyColumns()).uid : gObj.enableColumnVirtualization ? $748c2240e597a9b7$export$b228bd03696496fb(gObj, filteredCols[parseInt(i.toString(), 10)].field).uid : gObj.getColumnByField(filteredCols[parseInt(i.toString(), 10)].field).uid;
}
var $748c2240e597a9b7$export$98f03c5d19621d70;
(function(Global) {
    // eslint-disable-next-line prefer-const
    Global.timer = null;
})($748c2240e597a9b7$export$98f03c5d19621d70 || ($748c2240e597a9b7$export$98f03c5d19621d70 = {}));
function $748c2240e597a9b7$export$3046fdef117e6822(element) {
    var style = document.defaultView.getComputedStyle(element, null);
    var transformV = style.getPropertyValue("transform");
    var replacedTv = transformV.replace(/,/g, "");
    var translateX = parseFloat(replacedTv.split(" ")[4]);
    var translateY = parseFloat(replacedTv.split(" ")[5]);
    return {
        width: translateX,
        height: translateY
    };
}
function $748c2240e597a9b7$export$b6c750d9a4b9bf2b(rootElement, element) {
    if (rootElement.classList.contains("e-bigger")) element.classList.add("e-bigger");
}
function $748c2240e597a9b7$export$cf8661d2a8ee09cc(gObj) {
    var scrollElem = gObj.getContent().firstElementChild;
    return scrollElem.scrollWidth > scrollElem.offsetWidth ? $748c2240e597a9b7$export$1df2a1438d36fb55() : 0;
}
function $748c2240e597a9b7$export$fe694ccc69e43b4(gObj, idx) {
    var colspan = 0;
    var cols = gObj.getColumns();
    var width = idx * 30;
    if (gObj.isRowDragable()) {
        colspan++;
        width += 30;
    }
    colspan += gObj.groupSettings.columns.length - idx;
    width += 30 * (gObj.groupSettings.columns.length - idx);
    var gridWidth = (gObj.width === "auto" ? gObj.element.offsetWidth : parseInt(gObj.width.toString(), 10)) - $748c2240e597a9b7$export$cf8661d2a8ee09cc(gObj);
    for(var i = 0; i < cols.length; i++){
        if (cols[parseInt(i.toString(), 10)].visible) {
            width += parseInt(cols[parseInt(i.toString(), 10)].width.toString(), 10);
            colspan++;
        }
        if (width > gridWidth) {
            colspan--;
            break;
        }
    }
    return colspan;
}
function $748c2240e597a9b7$export$27d8d7d7d18b4954(tr, gObj) {
    var width = 0;
    var idx = 0;
    var frozenCount = gObj.getVisibleFrozenLeftCount();
    for(var j = 0; j < tr.childNodes.length; j++){
        var td = tr.childNodes[parseInt(j.toString(), 10)];
        if (frozenCount === idx) break;
        if (td.classList.contains("e-groupcaption") || td.classList.contains("e-summarycell")) idx += parseInt(td.getAttribute("colspan"), 10);
        td.classList.add("e-leftfreeze");
        if (td.classList.contains("e-groupcaption") && parseInt(td.getAttribute("colspan"), 10) === 1) td.classList.add("e-freezeleftborder");
        $748c2240e597a9b7$export$45a1adeafba636b0(td, width, gObj.enableRtl, "Left");
        if (td.classList.contains("e-indentcell") || td.classList.contains("e-recordplusexpand") || td.classList.contains("e-recordpluscollapse")) width += 30;
        if (td.classList.contains("e-groupcaption")) {
            var colspan = parseInt(td.getAttribute("colspan"), 10);
            if (gObj.isRowDragable()) {
                colspan--;
                width += 30;
            }
            colspan = colspan - (gObj.groupSettings.columns.length - j);
            width = width + 30 * (gObj.groupSettings.columns.length - j);
            var cols = gObj.getColumns();
            for(var i = 0; i < cols.length; i++){
                if (parseInt(td.getAttribute("colspan"), 10) > 1 && parseInt(cols[parseInt(i.toString(), 10)].width.toString(), 10) + width > parseInt(gObj.width.toString(), 10) - $748c2240e597a9b7$export$cf8661d2a8ee09cc(gObj)) {
                    var newColspan = $748c2240e597a9b7$export$fe694ccc69e43b4(gObj, j);
                    td.setAttribute("colspan", newColspan.toString());
                    break;
                }
                if (cols[parseInt(i.toString(), 10)].visible) {
                    width += parseInt(cols[parseInt(i.toString(), 10)].width.toString(), 10);
                    colspan--;
                }
                if (colspan === 0) break;
            }
        }
        if (td.classList.contains("e-summarycell")) {
            var uid_1 = td.getAttribute("e-mappinguid");
            var column = gObj.getColumnByUid(uid_1);
            width += parseInt(column.width.toString(), 10);
        }
    }
}
function $748c2240e597a9b7$export$f783eb11715a8ca3(row, gridObj) {
    var content = gridObj.getContent().firstElementChild;
    return row && row.getBoundingClientRect().top - content.getBoundingClientRect().top + gridObj.getRowHeight() > content.offsetHeight;
}
function $748c2240e597a9b7$export$80c5f36a72f4a3c7(row, rowTop) {
    return row && row.getBoundingClientRect().top < rowTop;
}
function $748c2240e597a9b7$export$878bcf7b6ccc61fb(index, gObj) {
    var rowHeight = gObj.getRowHeight();
    var startIndex = gObj.getContent().firstElementChild.scrollTop / rowHeight;
    var endIndex = startIndex + gObj.getContent().firstElementChild.offsetHeight / rowHeight;
    return index < endIndex && index > startIndex;
}
function $748c2240e597a9b7$export$b52dd6069dba6e03(gObj, data) {
    var keyField = gObj.getPrimaryKeyFieldNames()[0];
    var dataIndex;
    gObj.getCurrentViewRecords().filter(function(e, index) {
        if (keyField.includes(".")) {
            var currentValue = $748c2240e597a9b7$export$93534728ecb2e7b9(keyField, e);
            var originalValue = $748c2240e597a9b7$export$93534728ecb2e7b9(keyField, data);
            if (currentValue === originalValue) dataIndex = index;
        } else if (e["" + keyField] === data["" + keyField]) dataIndex = index;
    });
    return dataIndex;
}
function $748c2240e597a9b7$export$5bafd3a29592d203(args, query) {
    var state = $748c2240e597a9b7$export$dfa4547485ca7715(query);
    var def = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
    state.dataSource = def.resolve;
    state.action = args;
    return {
        state: state,
        deffered: def
    };
}
function $748c2240e597a9b7$export$dfa4547485ca7715(query) {
    var adaptr = new (0, $e1170102ff02b3b7$export$b011aea473980a2d)();
    var dm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
        url: "",
        adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)
    });
    var state = adaptr.processQuery(dm, query);
    var data = JSON.parse(state.data);
    return data;
}
function $748c2240e597a9b7$export$4605faa9bb01ebb8(gObj) {
    var columns = gObj.getVisibleColumns();
    var percentageCol = 0;
    var undefinedWidthCol = 0;
    for(var i = 0; i < columns.length; i++){
        if ((0, $3EnZW.isUndefined)(columns[parseInt(i.toString(), 10)].width)) undefinedWidthCol++;
        else if (columns[parseInt(i.toString(), 10)].width.toString().indexOf("%") !== -1) percentageCol++;
    }
    return (gObj.width === "auto" || typeof gObj.width === "string" && gObj.width.indexOf("%") !== -1) && !gObj.groupSettings.showGroupedColumn && gObj.groupSettings.columns.length && percentageCol && !undefinedWidthCol;
}
function $748c2240e597a9b7$export$ba639a32ffcf7814(gObj, rows, rowElms, index, startRowIndex) {
    var startIndex = index ? index : 0;
    for(var i = startRowIndex ? startRowIndex : 0; i < rows.length; i++)if (rows[parseInt(i.toString(), 10)] && rows[parseInt(i.toString(), 10)].isDataRow) {
        rows[parseInt(i.toString(), 10)].index = startIndex;
        rows[parseInt(i.toString(), 10)].isAltRow = gObj.enableAltRow ? startIndex % 2 !== 0 : false;
        rowElms[parseInt(i.toString(), 10)].setAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82, startIndex.toString());
        rowElms[parseInt(i.toString(), 10)].setAttribute($1b5568e76cdae6d4$export$be459c01dd76713e, (startIndex + 1).toString());
        if (rows[parseInt(i.toString(), 10)].isAltRow) rowElms[parseInt(i.toString(), 10)].classList.add("e-altrow");
        else rowElms[parseInt(i.toString(), 10)].classList.remove("e-altrow");
        for(var j = 0; j < rowElms[parseInt(i.toString(), 10)].cells.length; j++)rowElms[parseInt(i.toString(), 10)].cells[parseInt(j.toString(), 10)].setAttribute("index", startIndex.toString());
        startIndex++;
    }
    if (!rows.length) gObj.renderModule.emptyRow(true);
}
function $748c2240e597a9b7$export$34d0271fbe106b75(gObj) {
    var rowObjects = gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings.enableCache ? gObj.getRowsObject() : gObj.vRows;
    var rowElements = gObj.getRows();
    for(var i = 0, startIndex = 0, k = 0; i < rowObjects.length; i++){
        var rowObject = rowObjects[parseInt(i.toString(), 10)];
        if (rowObject.isDataRow) {
            rowObject.index = startIndex;
            rowObject.isAltRow = gObj.enableAltRow ? startIndex % 2 !== 0 : false;
            var rowElement = gObj.getRowElementByUID(rowObject.uid);
            if (!(0, $3EnZW.isNullOrUndefined)(rowElement)) {
                rowElements[parseInt(k.toString(), 10)] = rowElement;
                rowElement.setAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82, startIndex.toString());
                rowElement.setAttribute($1b5568e76cdae6d4$export$be459c01dd76713e, (startIndex + 1).toString());
                if (rowObject.isAltRow) rowElement.classList.add("e-altrow");
                else rowElement.classList.remove("e-altrow");
                for(var j = 0; j < rowElement.cells.length; j++)rowElement.cells[parseInt(j.toString(), 10)].setAttribute("index", startIndex.toString());
                k++;
            }
            startIndex++;
        }
    }
    if (gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings.enableCache) gObj.infiniteScrollModule.resetInfiniteCache(rowObjects);
}
function $748c2240e597a9b7$export$5f6b78a41ee2e2e8(gObj, args, tr, dropRObj) {
    var rowObjects = gObj.enableVirtualization ? gObj.vRows : gObj.getRowsObject();
    var orderChangeRowObjects = [];
    var dropRowObject = dropRObj ? dropRObj : gObj.getRowObjectFromUID(args.target.closest("tr").getAttribute("data-uid"));
    var rowObjectDropIndex;
    for(var i = 0; i < args.rows.length; i++){
        var orderChangeRowObject = gObj.getRowObjectFromUID(args.rows[parseInt(i.toString(), 10)].getAttribute("data-uid"));
        if (dropRowObject === orderChangeRowObject) rowObjectDropIndex = rowObjects.indexOf(dropRowObject);
        orderChangeRowObjects.push(rowObjects.splice(rowObjects.indexOf(orderChangeRowObject), 1)[0]);
    }
    if ((0, $3EnZW.isNullOrUndefined)(rowObjectDropIndex)) {
        rowObjectDropIndex = rowObjects.indexOf(dropRowObject);
        if (args.fromIndex > args.dropIndex) rowObjects.splice.apply(rowObjects, [
            rowObjectDropIndex,
            0
        ].concat(orderChangeRowObjects));
        else rowObjects.splice.apply(rowObjects, [
            rowObjectDropIndex + 1,
            0
        ].concat(orderChangeRowObjects));
    } else rowObjects.splice.apply(rowObjects, [
        rowObjectDropIndex,
        0
    ].concat(orderChangeRowObjects));
    if (!gObj.enableVirtualization && !gObj.infiniteScrollSettings.enableCache) {
        var record = {};
        var currentViewData = gObj.getCurrentViewRecords();
        for(var i = 0, len = tr.length; i < len; i++){
            var index = parseInt(tr[parseInt(i.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            record[parseInt(i.toString(), 10)] = currentViewData[parseInt(index.toString(), 10)];
        }
        var rows = gObj.getRows();
        for(var i = 0, len = tr.length; i < len; i++){
            rows[parseInt(i.toString(), 10)] = tr[parseInt(i.toString(), 10)];
            currentViewData[parseInt(i.toString(), 10)] = record[parseInt(i.toString(), 10)];
        }
    }
    if (gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings.enableCache) gObj.infiniteScrollModule.resetInfiniteCache(rowObjects);
}
function $748c2240e597a9b7$export$cae8611b08076487(gObj, changes, type, keyField) {
    var newArray = gObj.dataToBeUpdated["" + type].concat(changes["" + type]).reduce(function(r, o) {
        r[o["" + keyField]] = r[o["" + keyField]] === undefined ? o : Object.assign(r[o["" + keyField]], o);
        return r;
    }, {});
    gObj.dataToBeUpdated["" + type] = Object.keys(newArray).map(function(k) {
        return newArray["" + k];
    });
}
function $748c2240e597a9b7$export$ef806be2fa1b9130(gObj) {
    gObj.contentModule.rowElements = [].slice.call(gObj.element.querySelectorAll(".e-row:not(.e-addedrow):not(.e-cloneproperties .e-row)"));
}
function $748c2240e597a9b7$export$7bf4ce8da62c6299(row, start, end) {
    var cells = row.children;
    var len = cells.length;
    var k = 0;
    for(var i = 0; i < len; i++, k++){
        if (i >= start && i < end) continue;
        row.removeChild(row.children[parseInt(k.toString(), 10)]);
        k--;
    }
}
function $748c2240e597a9b7$export$35819a1a44286094(gObj, dlgObj) {
    var element = gObj.createElement("div", {
        className: "e-grid-popup",
        id: gObj.element.id + "_e-popup"
    });
    var pos = (0, $cWXlQ.calculatePosition)(gObj.element, "left", "Top");
    if (document.getElementById(gObj.element.id + "_e-popup")) element = document.getElementById(gObj.element.id + "_e-popup");
    element.style.top = pos.top + "px";
    element.style.left = pos.left + "px";
    element.style.zIndex = dlgObj.zIndex.toString();
    element.style.width = dlgObj.element.offsetWidth + "px";
    element.appendChild(dlgObj.element);
    var sbPanel = document.querySelector(".sb-demo-section");
    if (sbPanel) {
        var sbPos = (0, $cWXlQ.calculateRelativeBasedPosition)(gObj.element, sbPanel);
        element.style.top = sbPos.top + "px";
        element.style.left = sbPos.left + "px";
        sbPanel.insertBefore(element, sbPanel.firstChild);
    } else document.body.insertBefore(element, document.body.firstChild);
}
function $748c2240e597a9b7$export$3289971ebd775b18(column, uid) {
    var uids = [];
    uids.push(column.uid);
    $748c2240e597a9b7$export$ecc236f4d986856d(column, uids);
    if (uids.indexOf(uid) > -1) return true;
    else return false;
}
function $748c2240e597a9b7$export$ecc236f4d986856d(column, uids) {
    for(var i = 0; i < column.columns.length; i++){
        if (column.columns[parseInt(i.toString(), 10)].uid) uids.push(column.columns[parseInt(i.toString(), 10)].uid);
        if (column.columns[parseInt(i.toString(), 10)].columns && column.columns[parseInt(i.toString(), 10)].columns.length) $748c2240e597a9b7$export$ecc236f4d986856d(column.columns[parseInt(i.toString(), 10)], uids);
    }
}
function $748c2240e597a9b7$export$1463b8a6e6d02d19(column) {
    if (column.columns[0].freeze || column.columns[0].isFrozen) {
        if (column.columns[0].freeze === "Left" || column.columns[0].isFrozen) return "Left";
        else if (column.columns[0].freeze === "Right") return "Right";
        else if (column.columns[0].freeze === "Fixed") return "Fixed";
        else return "None";
    } else {
        if (column.columns[0].columns && column.columns[0].columns.length) return $748c2240e597a9b7$export$1463b8a6e6d02d19(column.columns[0]);
        else return "None";
    }
}
function $748c2240e597a9b7$export$20c2eda854b6814a(row) {
    if (row.querySelector(".e-fixedfreeze")) {
        var cells = [].slice.call(row.querySelectorAll(".e-filterbarcell:not(.e-hide),.e-summarycell:not(.e-hide),.e-headercell:not(.e-hide),.e-rowcell:not(.e-hide)"));
        for(var j = 0; j < cells.length; j++){
            if (cells[parseInt(j.toString(), 10)].classList.contains("e-fixedfreeze") && (!cells[j - 1] || cells[j - 1] && !cells[j - 1].classList.contains("e-fixedfreeze"))) cells[parseInt(j.toString(), 10)].classList.add("e-freezeleftborder");
            if (cells[parseInt(j.toString(), 10)].classList.contains("e-fixedfreeze") && (!cells[j + 1] || cells[j + 1] && !cells[j + 1].classList.contains("e-fixedfreeze"))) cells[parseInt(j.toString(), 10)].classList.add("e-freezerightborder");
        }
    }
}
function $748c2240e597a9b7$export$45a1adeafba636b0(node, width, isRtl, position) {
    if (position === "Left") {
        if (isRtl) node.style.right = width + "px";
        else node.style.left = width + "px";
    }
    if (position === "Right") {
        if (isRtl) node.style.left = width + "px";
        else node.style.right = width + "px";
    }
}
function $748c2240e597a9b7$export$e4e976bbecdb8c5d(gObj, column, node, colSpan) {
    var columns = gObj.getColumns();
    var index = column.index;
    if (column.freeze === "Left" && column.border !== "Left") {
        var idx = index + (colSpan - 1);
        while(columns[parseInt(idx.toString(), 10)].visible === false)idx++;
        if (columns[parseInt(idx.toString(), 10)].border === "Left") node.classList.add("e-freezeleftborder");
    } else if (column.freeze === "Right" || column.freeze === "Fixed") {
        var width = 0;
        for(var j = index + 1; j < index + colSpan; j++){
            if (j === columns.length) break;
            if (columns[parseInt(j.toString(), 10)].visible) width += parseInt(columns[parseInt(j.toString(), 10)].width.toString(), 10);
            else colSpan++;
        }
        if (gObj.enableRtl) node.style.left = parseInt(node.style.left, 10) - width + "px";
        else node.style.right = parseInt(node.style.right, 10) - width + "px";
    }
}
function $748c2240e597a9b7$export$136558233620d0e9(gObj, rowIndex, colIndex) {
    var row = gObj.getRowByIndex(rowIndex);
    for(var i = 0; i < row.cells.length; i++){
        if (row.cells[parseInt(i.toString(), 10)].getAttribute("data-colindex") === colIndex.toString()) return row.cells[parseInt(i.toString(), 10)];
    }
    return null;
}
function $748c2240e597a9b7$export$a94a28b9cbe22d6a(gObj, column, node) {
    if (column.freeze === "Left" || column.isFrozen) {
        node.classList.add("e-leftfreeze");
        if (column.border === "Left") node.classList.add("e-freezeleftborder");
        if (column.index === 0) {
            $748c2240e597a9b7$export$45a1adeafba636b0(node, gObj.getIndentCount() * 30, gObj.enableRtl, "Left");
            if (gObj.enableColumnVirtualization) column.valueX = gObj.getIndentCount() * 30;
        } else {
            var cols = gObj.getColumns();
            var width = gObj.getIndentCount() * 30;
            for(var i = 0; i < cols.length; i++){
                if (column.uid === cols[parseInt(i.toString(), 10)].uid) break;
                if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
            }
            $748c2240e597a9b7$export$45a1adeafba636b0(node, width, gObj.enableRtl, "Left");
            if (gObj.enableColumnVirtualization) column.valueX = width;
        }
    } else if (column.freeze === "Right") {
        node.classList.add("e-rightfreeze");
        var cols = gObj.getColumns();
        if (column.border === "Right") node.classList.add("e-freezerightborder");
        if (column.index === cols[cols.length - 1].index) {
            var width = gObj.getFrozenMode() === "Right" && gObj.isRowDragable() ? 30 : 0;
            $748c2240e597a9b7$export$45a1adeafba636b0(node, width, gObj.enableRtl, "Right");
            if (gObj.enableColumnVirtualization) column.valueX = width;
        } else {
            var width = gObj.getFrozenMode() === "Right" && gObj.isRowDragable() ? 30 : 0;
            for(var i = cols.length - 1; i >= 0; i--){
                if (column.uid === cols[parseInt(i.toString(), 10)].uid) break;
                if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
            }
            $748c2240e597a9b7$export$45a1adeafba636b0(node, width, gObj.enableRtl, "Right");
            if (gObj.enableColumnVirtualization) column.valueX = width;
        }
    } else if (column.freeze === "Fixed") {
        node.classList.add("e-fixedfreeze");
        var cols = gObj.getColumns();
        var width = 0;
        if (gObj.getVisibleFrozenLeftCount()) width = gObj.getIndentCount() * 30;
        else if (gObj.getFrozenMode() === "Right") width = gObj.groupSettings.columns.length * 30;
        for(var i = 0; i < cols.length; i++){
            if (column.uid === cols[parseInt(i.toString(), 10)].uid) break;
            if (cols[parseInt(i.toString(), 10)].freeze === "Left" || cols[parseInt(i.toString(), 10)].isFrozen || cols[parseInt(i.toString(), 10)].freeze === "Fixed") {
                if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
            }
        }
        $748c2240e597a9b7$export$45a1adeafba636b0(node, width - 1, gObj.enableRtl, "Left");
        width = gObj.getFrozenMode() === "Right" && gObj.isRowDragable() ? 30 : 0;
        for(var i = cols.length - 1; i >= 0; i--){
            if (column.uid === cols[parseInt(i.toString(), 10)].uid) break;
            if (cols[parseInt(i.toString(), 10)].freeze === "Right" || cols[parseInt(i.toString(), 10)].freeze === "Fixed") {
                if (cols[parseInt(i.toString(), 10)].visible) width += parseFloat(cols[parseInt(i.toString(), 10)].width.toString());
            }
        }
        $748c2240e597a9b7$export$45a1adeafba636b0(node, width - 1, gObj.enableRtl, "Right");
    } else node.classList.add("e-unfreeze");
}
function $748c2240e597a9b7$export$ecc8ba29dc2847f4(gObj, col, rowIndex) {
    return [].slice.call(gObj.getDataRows()[parseInt(rowIndex.toString(), 10)].getElementsByClassName($1b5568e76cdae6d4$export$deb49d6cac2bdaca));
}
function $748c2240e597a9b7$export$eb0a0b01b8ba40c0(gObj, col, rowIndex, index) {
    return $748c2240e597a9b7$export$ecc8ba29dc2847f4(gObj, col, rowIndex)[parseInt(index.toString(), 10)];
}
function $748c2240e597a9b7$export$8bd3ebb3e5212b46(col, index, rules, mRules, frRules, len, isCustom) {
    if (isCustom) rules[$748c2240e597a9b7$export$d0c60e9a423ac807(col.field)] = col.validationRules;
    else {
        if (col.getFreezeTableName() === $1b5568e76cdae6d4$export$89f0bdeca852d972 || !index && col.getFreezeTableName() === $1b5568e76cdae6d4$export$b86d31d94d6c8026 || len === 1) rules[$748c2240e597a9b7$export$d0c60e9a423ac807(col.field)] = col.validationRules;
        else if (col.getFreezeTableName() === "movable" || !col.getFreezeTableName()) mRules[$748c2240e597a9b7$export$d0c60e9a423ac807(col.field)] = col.validationRules;
        else if (col.getFreezeTableName() === $1b5568e76cdae6d4$export$b86d31d94d6c8026) frRules[$748c2240e597a9b7$export$d0c60e9a423ac807(col.field)] = col.validationRules;
    }
}
function $748c2240e597a9b7$export$9a25ca3301c594da(numberFormat, type, isExcel, currencyCode) {
    var format;
    var intl = new (0, $bWDaN.Internationalization)();
    if (type === "number") try {
        format = intl.getNumberPattern({
            format: numberFormat,
            currency: currencyCode,
            useGrouping: true
        }, true);
    } catch (error) {
        format = numberFormat;
    }
    else if (type === "date" || type === "time" || type === "datetime") try {
        format = intl.getDatePattern({
            skeleton: numberFormat,
            type: type
        }, isExcel);
        if ((0, $3EnZW.isNullOrUndefined)(format)) // eslint-disable-next-line
        throw "error";
    } catch (error) {
        try {
            format = intl.getDatePattern({
                format: numberFormat,
                type: type
            }, isExcel);
        } catch (error) {
            format = numberFormat;
        }
    }
    else format = numberFormat;
    if (type !== "number") {
        var patternRegex = /G|H|c|'| a|yy|y|EEEE|E/g;
        var mtch_1 = {
            "G": "",
            "H": "h",
            "c": "d",
            "'": '"',
            " a": " AM/PM",
            "yy": "yy",
            "y": "yyyy",
            "EEEE": "dddd",
            "E": "ddd"
        };
        format = format.replace(patternRegex, function(pattern) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return mtch_1["" + pattern];
        });
    }
    return format;
}
function $748c2240e597a9b7$export$9098854bd97850c7(gObj) {
    if (gObj.enableAdaptiveUI) {
        var dialogs = document.getElementsByClassName("e-responsive-dialog");
        for(var i = 0; i < dialogs.length; i++)dialogs[parseInt(i.toString(), 10)].classList.add("e-bigger");
    }
}
function $748c2240e597a9b7$export$64e408221c1d245b(value, mapObject) {
    var returnObj;
    var length = value.split(".").length;
    var splits = value.split(".");
    var duplicateMap = mapObject;
    for(var i = 0; i < length; i++){
        returnObj = duplicateMap[splits[parseInt(i.toString(), 10)]];
        duplicateMap = returnObj;
    }
    return returnObj;
}
function $748c2240e597a9b7$export$55afbdac1540a938(tr, idx, displayVal, rows, parent, isContent) {
    var trs = Object.keys(tr);
    var actualIndex = idx;
    for(var i = 0; i < trs.length; i++){
        var td = tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell")[parseInt(idx.toString(), 10)];
        if (parent && !parent.isFrozenGrid() && !parent.isRowDragable()) {
            td = !(0, $3EnZW.isNullOrUndefined)(td) && (parseInt(td.getAttribute("data-colindex"), 10) === idx || $748c2240e597a9b7$export$dcd0aa73ca0eb350(td, "e-addedrow") && td.parentElement.childNodes[parseInt(idx.toString(), 10)] === td) ? td : tr[parseInt(i.toString(), 10)].querySelector('td[data-colindex="' + idx + '"]');
            if ((0, $3EnZW.isNullOrUndefined)(td)) continue;
            else idx = parent.getContentTable().querySelector(".e-detailrowcollapse, .e-detailrowexpand") ? td.cellIndex - 1 : td.cellIndex;
        }
        if (tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell").length && td) {
            (0, $4ZDHT.setStyleAttribute)(tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell")[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
            if (tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell")[parseInt(idx.toString(), 10)].classList.contains("e-hide")) (0, $4ZDHT.removeClass)([
                tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell")[parseInt(idx.toString(), 10)]
            ], [
                "e-hide"
            ]);
            if (isContent && parent.isRowDragable() || parent && parent.isDetail()) {
                var index = idx + 1;
                rows[trs[parseInt(i.toString(), 10)]].cells[parseInt(index.toString(), 10)].visible = displayVal === "" ? true : false;
            } else if (!(0, $3EnZW.isNullOrUndefined)(rows[trs[parseInt(i.toString(), 10)]])) {
                rows[trs[parseInt(i.toString(), 10)]].cells[parseInt(idx.toString(), 10)].visible = displayVal === "" ? true : false;
                if (rows[trs[parseInt(i.toString(), 10)]].cells[parseInt(idx.toString(), 10)].visible === false) tr[trs[parseInt(i.toString(), 10)]].querySelectorAll("td.e-rowcell")[parseInt(idx.toString(), 10)].classList.add("e-hide");
            }
            idx = actualIndex;
        }
    }
}
function $748c2240e597a9b7$export$1f4003be8e1e6b7c(parent, evt, isOn, module) {
    for(var _i = 0, evt_1 = evt; _i < evt_1.length; _i++){
        var inst = evt_1[_i];
        if (isOn) parent.on(inst.event, inst.handler, module);
        else parent.off(inst.event, inst.handler);
    }
}
function $748c2240e597a9b7$export$5c47fa8ca4a890c8(parent, column, classNames, attr) {
    var complexFieldName = $748c2240e597a9b7$export$d0c60e9a423ac807(column.field);
    attr = Object.assign(attr, {
        id: parent.element.id + complexFieldName,
        name: complexFieldName,
        "e-mappinguid": column.uid
    });
    return parent.createElement("input", {
        className: classNames,
        attrs: attr
    });
}
function $748c2240e597a9b7$export$bab3b2013af0811b(gObj, uid) {
    var column;
    for(var _i = 0, _a = gObj.columnModel; _i < _a.length; _i++){
        var col = _a[_i];
        if (col.uid === uid) {
            column = col;
            break;
        }
    }
    return column;
}
function $748c2240e597a9b7$export$b228bd03696496fb(gObj, field) {
    var column;
    if (!gObj.columnModel) gObj.getColumns();
    for(var _i = 0, _a = gObj.columnModel; _i < _a.length; _i++){
        var col = _a[_i];
        if (col.field === field) {
            column = col;
            break;
        }
    }
    return column;
}
function $748c2240e597a9b7$export$5bbc0e5c6786f345(id, evts, handlers, instance) {
    instance.eventHandlers["" + id] = {};
    for(var i = 0; i < evts.length; i++)instance.eventHandlers["" + id][evts[parseInt(i.toString(), 10)]] = handlers[evts[parseInt(i.toString(), 10)]];
}
function $748c2240e597a9b7$export$b318228c6d042f7c(component, evts, instance) {
    for(var i = 0; i < evts.length; i++){
        if (component.isDestroyed) break;
        component.removeEventListener(evts[parseInt(i.toString(), 10)], instance.eventHandlers[component.element.id][evts[parseInt(i.toString(), 10)]]);
    }
}
function $748c2240e597a9b7$export$d9aeb73a9e271813(parent, templates) {
    parent.destroyTemplate(templates);
    if (parent.isReact) parent.renderTemplates();
}
function $748c2240e597a9b7$export$cc75f426469dab70(row) {
    return parseInt(row.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
}
function $748c2240e597a9b7$export$27d99c9d2959ecb(grid) {
    return grid.parentDetails && grid.parentDetails.parentInstObj ? $748c2240e597a9b7$export$27d99c9d2959ecb(grid.parentDetails.parentInstObj) : grid;
}
function $748c2240e597a9b7$export$78fdc30439dd7cde(fields, values, instance) {
    var filterCols = [];
    for(var i = 0; i < fields.length; i++){
        var column = instance.parent.getColumnByField(fields[parseInt(i.toString(), 10)]);
        var value = values[parseInt(i.toString(), 10)] === "null" ? null : values[parseInt(i.toString(), 10)];
        var pred = {
            field: fields[parseInt(i.toString(), 10)],
            predicate: "or",
            uid: column.uid,
            operator: "equal",
            type: column.type,
            matchCase: instance.allowCaseSensitive,
            ignoreAccent: instance.parent.filterSettings.ignoreAccent
        };
        if (value === "" || (0, $3EnZW.isNullOrUndefined)(value)) filterCols = filterCols.concat((0, $66db5ede9cdf4d76$export$325f55b6c744802a).generateNullValuePredicates(pred));
        else filterCols.push($748c2240e597a9b7$export$8b58be045bf06082({}, {
            value: value
        }, pred));
    }
    return (0, $66db5ede9cdf4d76$export$325f55b6c744802a).getPredicate(filterCols);
}
function $748c2240e597a9b7$export$365f0bc04eed0222(pred) {
    var predicateList = [];
    for(var _i = 0, _a = Object.keys(pred); _i < _a.length; _i++){
        var prop = _a[_i];
        predicateList.push(pred["" + prop]);
    }
    return predicateList;
}
function $748c2240e597a9b7$export$bc3365938ce5a51a(index, rowsObject) {
    var fields = [];
    var keys = [];
    for(var i = index; i >= 0; i--)if (rowsObject[parseInt(i.toString(), 10)].isCaptionRow && fields.indexOf(rowsObject[parseInt(i.toString(), 10)].data.field) === -1 && (rowsObject[parseInt(i.toString(), 10)].indent < rowsObject[parseInt(index.toString(), 10)].indent || i === index)) {
        fields.push(rowsObject[parseInt(i.toString(), 10)].data.field);
        keys.push(rowsObject[parseInt(i.toString(), 10)].data.key);
        if (rowsObject[parseInt(i.toString(), 10)].indent === 0) break;
    }
    return {
        fields: fields,
        keys: keys
    };
}
function $748c2240e597a9b7$export$375d9927fa4cce82(checkActiveMatrix, checkCellIndex, next) {
    var activeMatrix = checkActiveMatrix;
    var cellIndex = checkCellIndex;
    var currentCellIndexPass = false;
    if (next) for(var i = cellIndex[0]; i < activeMatrix.length; i++){
        var rowCell = activeMatrix[parseInt(i.toString(), 10)];
        for(var j = 0; j < rowCell.length; j++){
            if (currentCellIndexPass && activeMatrix[parseInt(i.toString(), 10)][parseInt(j.toString(), 10)] === 1) {
                cellIndex = [
                    i,
                    j
                ];
                return cellIndex;
            }
            if (!currentCellIndexPass && cellIndex.toString() === [
                i,
                j
            ].toString()) currentCellIndexPass = true;
        }
    }
    else for(var i = cellIndex[0]; i >= 0; i--){
        var rowCell = activeMatrix[parseInt(i.toString(), 10)];
        for(var j = rowCell.length - 1; j >= 0; j--){
            if (currentCellIndexPass && activeMatrix[parseInt(i.toString(), 10)][parseInt(j.toString(), 10)] === 1) {
                cellIndex = [
                    i,
                    j
                ];
                return cellIndex;
            }
            if (!currentCellIndexPass && cellIndex.toString() === [
                i,
                j
            ].toString()) currentCellIndexPass = true;
        }
    }
    return cellIndex;
}
function $748c2240e597a9b7$export$d07f57595c356899(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $748c2240e597a9b7$export$bab3117844264a75(grid) {
    return !($748c2240e597a9b7$export$d3edab9aa707d65f(grid) || grid.groupSettings.enableLazyLoading || !grid.enableVirtualization && grid.enableColumnVirtualization);
}
function $748c2240e597a9b7$export$e3139d168f68ec7e(blockes) {
    var visiblePage = [];
    for(var i = 0; i < blockes.length; i++){
        var page = Math.ceil(blockes[parseInt(i.toString(), 10)] / 2);
        if (visiblePage.indexOf(page) === -1) visiblePage.push(page);
    }
    return visiblePage;
}






/**
 * The `ColumnChooser` module is used to show or hide columns dynamically.
 */ var $6df371599d7d9c78$export$83e0e5d4eae2b8ed = /** @class */ function() {
    /**
     * Constructor for the Grid ColumnChooser module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     * @hidden
     */ function ColumnChooser(parent, serviceLocator) {
        this.filterColumns = [];
        this.showColumn = [];
        this.hideColumn = [];
        this.changedColumns = [];
        this.unchangedColumns = [];
        this.isDlgOpen = false;
        this.isColumnChooserOpen = false;
        this.initialOpenDlg = true;
        this.stateChangeColumns = [];
        this.changedStateColumns = [];
        this.isInitialOpen = false;
        this.isCustomizeOpenCC = false;
        this.searchOperator = "startswith";
        this.prevShowedCols = [];
        this.hideDialogFunction = this.hideDialog.bind(this);
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.addEventListener();
        this.cBoxTrue = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
            checked: true,
            label: " "
        });
        this.cBoxFalse = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.parent.createElement, false, {
            checked: false,
            label: " "
        });
        this.cBoxTrue.insertBefore(this.parent.createElement("input", {
            className: "e-chk-hidden e-cc e-cc-chbox",
            attrs: {
                type: "checkbox"
            }
        }), this.cBoxTrue.firstChild);
        this.cBoxFalse.insertBefore(this.parent.createElement("input", {
            className: "e-chk-hidden e-cc e-cc-chbox",
            attrs: {
                "type": "checkbox"
            }
        }), this.cBoxFalse.firstChild);
        this.cBoxFalse.querySelector(".e-frame").classList.add("e-uncheck");
        if (this.parent.enableRtl) (0, $4ZDHT.addClass)([
            this.cBoxTrue,
            this.cBoxFalse
        ], [
            "e-rtl"
        ]);
        if (this.parent.cssClass) {
            if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                this.cBoxTrue,
                this.cBoxFalse
            ], this.parent.cssClass.split(" "));
            else (0, $4ZDHT.addClass)([
                this.cBoxTrue,
                this.cBoxFalse
            ], [
                this.parent.cssClass
            ]);
        }
        if (this.parent.enableAdaptiveUI) this.setFullScreenDialog();
    }
    ColumnChooser.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) || !gridElement) return;
        this.removeEventListener();
        this.unWireEvents();
        if (!(0, $3EnZW.isNullOrUndefined)(this.dlgObj) && this.dlgObj.element && !this.dlgObj.isDestroyed) this.dlgObj.destroy();
    };
    ColumnChooser.prototype.setFullScreenDialog = function() {
        if (this.serviceLocator) this.serviceLocator.registerAdaptiveService(this, this.parent.enableAdaptiveUI, (0, $6b76944ddf827cb7$export$b69201db7f59899c).isColumnChooser);
        if (this.parent.enableAdaptiveUI) {
            this.parent.on($17b89d3b1fc93cdb$export$87d96ac382feb05c, this.renderResponsiveColumnChooserDiv, this);
            this.parent.on($17b89d3b1fc93cdb$export$57e9c95e9e650443, this.renderResponsiveChangeAction, this);
        }
    };
    ColumnChooser.prototype.rtlUpdate = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.innerDiv)) {
            if (this.parent.enableRtl) (0, $4ZDHT.addClass)([].slice.call(this.innerDiv.getElementsByClassName("e-checkbox-wrapper")), [
                "e-rtl"
            ]);
            else (0, $4ZDHT.removeClass)([].slice.call(this.innerDiv.getElementsByClassName("e-checkbox-wrapper")), [
                "e-rtl"
            ]);
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ ColumnChooser.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $aqzbR.EventHandler).add(document, "click", this.clickHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRenderEle, this);
        this.parent.on($17b89d3b1fc93cdb$export$5d4840440f592fca, this.render, this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.hideDialogFunction);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($17b89d3b1fc93cdb$export$73ce1dd8756c84c3, this.rtlUpdate, this);
        this.parent.on($17b89d3b1fc93cdb$export$8d1f04a619d5db82, this.onResetColumns, this);
        this.parent.on($17b89d3b1fc93cdb$export$f66e9a7f793619a4, this.setFullScreenDialog, this);
        if (this.parent.enableAdaptiveUI) {
            this.parent.on($17b89d3b1fc93cdb$export$87d96ac382feb05c, this.renderResponsiveColumnChooserDiv, this);
            this.parent.on($17b89d3b1fc93cdb$export$57e9c95e9e650443, this.renderResponsiveChangeAction, this);
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ ColumnChooser.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $aqzbR.EventHandler).remove(document, "click", this.clickHandler);
        this.parent.off($17b89d3b1fc93cdb$export$5d4840440f592fca, this.render);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRenderEle);
        this.parent.off($17b89d3b1fc93cdb$export$73ce1dd8756c84c3, this.rtlUpdate);
        this.parent.off($17b89d3b1fc93cdb$export$8d1f04a619d5db82, this.onResetColumns);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.hideDialogFunction);
        this.parent.off($17b89d3b1fc93cdb$export$f66e9a7f793619a4, this.setFullScreenDialog);
        if (this.parent.enableAdaptiveUI) {
            this.parent.off($17b89d3b1fc93cdb$export$f66e9a7f793619a4, this.setFullScreenDialog);
            this.parent.off($17b89d3b1fc93cdb$export$87d96ac382feb05c, this.renderResponsiveColumnChooserDiv);
            this.parent.off($17b89d3b1fc93cdb$export$57e9c95e9e650443, this.renderResponsiveChangeAction);
        }
    };
    ColumnChooser.prototype.render = function() {
        this.l10n = this.serviceLocator.getService("localization");
        if (!this.parent.enableAdaptiveUI) this.renderDlgContent();
        this.getShowHideService = this.serviceLocator.getService("showHideService");
    };
    ColumnChooser.prototype.clickHandler = function(e) {
        var targetElement = e.target;
        if (!this.isCustomizeOpenCC) {
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(targetElement, ".e-cc-toolbar")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(targetElement, ".e-cc"))) {
                if (targetElement.classList.contains("e-columnchooser-btn") || targetElement.classList.contains("e-cc-toolbar")) {
                    if (this.initialOpenDlg && this.dlgObj.visible || !this.isDlgOpen) {
                        this.isDlgOpen = true;
                        return;
                    }
                } else if (targetElement.classList.contains("e-cc-cancel")) {
                    targetElement.parentElement.querySelector(".e-ccsearch").value = "";
                    this.columnChooserSearch("");
                    this.removeCancelIcon();
                    this.refreshCheckboxButton();
                }
            } else if (!(0, $3EnZW.isNullOrUndefined)(this.dlgObj) && this.dlgObj.visible && !targetElement.classList.contains("e-toolbar-items")) {
                this.dlgObj.hide();
                this.clearActions();
                this.refreshCheckboxState();
                // this.unWireEvents();
                this.isDlgOpen = false;
            }
            if (this.parent.detailTemplate || this.parent.childGrid) this.targetdlg = e.target;
        }
        if (this.isCustomizeOpenCC && e.target.classList.contains("e-cc-cancel")) this.refreshCheckboxState();
        if (!this.parent.enableAdaptiveUI) this.rtlUpdate();
        else if (this.parent.enableRtl) (0, $4ZDHT.addClass)([
            this.cBoxTrue,
            this.cBoxFalse
        ], [
            "e-rtl"
        ]);
    };
    ColumnChooser.prototype.hideDialog = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.dlgObj) && this.dlgObj.visible) {
            this.dlgObj.hide();
            // this.unWireEvents();
            this.isDlgOpen = false;
        }
    };
    /**
     * To render columnChooser when showColumnChooser enabled.
     *
     * @param {number} x - specifies the position x
     * @param {number} y - specifies the position y
     * @param {Element} target - specifies the target
     * @returns {void}
     * @hidden
     */ ColumnChooser.prototype.renderColumnChooser = function(x, y, target) {
        if (!this.dlgObj.visible && (this.parent.detailTemplate || this.parent.childGrid)) this.hideOpenedDialog();
        if (!this.dlgObj.visible) {
            var args = this.beforeOpenColumnChooserEvent();
            if (args.cancel) return;
            if (target) this.targetdlg = target;
            this.refreshCheckboxState();
            this.dlgObj.dataBind();
            this.dlgObj.element.style.maxHeight = "430px";
            var elementVisible = this.dlgObj.element.style.display;
            this.dlgObj.element.style.display = "block";
            var isSticky = this.parent.getHeaderContent().classList.contains("e-sticky");
            var toolbarItem = (0, $4ZDHT.closest)(target, ".e-toolbar-item");
            var newpos = void 0;
            if (document.getElementById(this.parent.element.id + "_e-popup") && document.getElementById(this.parent.element.id + "_e-popup").querySelector(".e-ccdlg")) this.parent.element.appendChild(this.dlgObj.element);
            if (isSticky) {
                newpos = toolbarItem.getBoundingClientRect();
                this.dlgObj.element.classList.add("e-sticky");
            } else {
                this.dlgObj.element.classList.remove("e-sticky");
                newpos = (0, $cWXlQ.calculateRelativeBasedPosition)(toolbarItem, this.dlgObj.element);
            }
            this.dlgObj.element.style.display = elementVisible;
            this.dlgObj.element.style.top = newpos.top + (0, $4ZDHT.closest)(target, ".e-cc-toolbar").getBoundingClientRect().height + "px";
            var dlgWidth = 250;
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, ".e-bigger"))) this.dlgObj.width = 258;
            if ((0, $5q7BP.Browser).isDevice) {
                this.dlgObj.target = document.body;
                this.dlgObj.position = {
                    X: "center",
                    Y: "center"
                };
                this.dlgObj.refreshPosition();
                this.dlgObj.open = this.mOpenDlg.bind(this);
            } else if (this.parent.enableRtl) this.dlgObj.element.style.left = target.offsetLeft + "px";
            else this.dlgObj.element.style.left = newpos.left - dlgWidth + (0, $4ZDHT.closest)(target, ".e-cc-toolbar").clientWidth + 2 + "px";
            this.removeCancelIcon();
            this.dlgObj.show();
            if (this.parent.getContent().firstElementChild.offsetHeight < this.dlgObj.element.offsetHeight && !this.parent.element.classList.contains("e-drillthrough-grid")) {
                (0, $748c2240e597a9b7$export$35819a1a44286094)(this.parent, this.dlgObj);
                this.dlgObj.element.querySelector(".e-ccsearch").select();
            }
            this.parent.notify($17b89d3b1fc93cdb$export$2c86483b611367a6, {
                dialog: this.dlgObj
            });
        } else {
            // this.unWireEvents();
            this.hideDialog();
            this.addcancelIcon();
            this.clearActions();
            this.refreshCheckboxState();
        }
        this.rtlUpdate();
    };
    /**
     * Column chooser can be displayed on screen by given position(X and Y axis).
     *
     * @param  {number} X - Defines the X axis.
     * @param  {number} Y - Defines the Y axis.
     * @return {void}
     */ ColumnChooser.prototype.openColumnChooser = function(X, Y) {
        this.isCustomizeOpenCC = true;
        if (this.parent.enableAdaptiveUI) {
            if (!this.isColumnChooserOpen) this.parent.showResponsiveCustomColumnChooser();
            this.isColumnChooserOpen = false;
            this.renderDlgContent();
        }
        if (this.dlgObj.visible) {
            this.hideDialog();
            return;
        }
        var args = this.beforeOpenColumnChooserEvent();
        if (args.cancel) return;
        if (!this.isInitialOpen) {
            this.dlgObj.content = this.renderChooserList();
            this.updateIntermediateBtn();
        } else this.refreshCheckboxState();
        this.dlgObj.dataBind();
        this.dlgObj.position = {
            X: "center",
            Y: "center"
        };
        if ((0, $3EnZW.isNullOrUndefined)(X)) {
            if (this.parent.enableAdaptiveUI) this.dlgObj.position = {
                X: "",
                Y: ""
            };
            this.dlgObj.refreshPosition();
        } else {
            this.dlgObj.element.style.top = "";
            this.dlgObj.element.style.left = "";
            this.dlgObj.element.style.top = Y + "px";
            this.dlgObj.element.style.left = X + "px";
        }
        this.dlgObj.beforeOpen = this.customDialogOpen.bind(this);
        this.dlgObj.show();
        if (this.parent.getContent().firstElementChild.offsetHeight < this.dlgObj.element.offsetHeight && !this.parent.element.classList.contains("e-drillthrough-grid")) (0, $748c2240e597a9b7$export$35819a1a44286094)(this.parent, this.dlgObj);
        this.isInitialOpen = true;
        this.dlgObj.beforeClose = this.customDialogClose.bind(this);
    };
    ColumnChooser.prototype.enableAfterRenderEle = function(e) {
        if (e.module === this.getModuleName() && e.enable) this.render();
    };
    ColumnChooser.prototype.keyUpHandler = function(e) {
        if (e.key === "Escape") this.resetColumnState();
        this.setFocus((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-cclist"));
    };
    ColumnChooser.prototype.setFocus = function(elem) {
        var prevElem = this.dlgDiv.querySelector(".e-colfocus");
        if (prevElem) prevElem.classList.remove("e-colfocus");
        if (elem) elem.classList.add("e-colfocus");
    };
    ColumnChooser.prototype.customDialogOpen = function() {
        var searchElement = this.dlgObj.content.querySelector("input.e-ccsearch");
        (0, $aqzbR.EventHandler).add(searchElement, "keyup", this.columnChooserManualSearch, this);
    };
    ColumnChooser.prototype.customDialogClose = function() {
        var searchElement = this.dlgObj.content.querySelector("input.e-ccsearch");
        (0, $aqzbR.EventHandler).remove(searchElement, "keyup", this.columnChooserManualSearch);
    };
    ColumnChooser.prototype.getColumns = function() {
        var columns = this.parent.getColumns().filter(function(column) {
            return column.type !== "checkbox" && column.showInColumnChooser === true || column.type === "checkbox" && column.field !== undefined;
        });
        return columns;
    };
    ColumnChooser.prototype.renderDlgContent = function() {
        var isAdaptive = this.parent.enableAdaptiveUI;
        this.dlgDiv = this.parent.createElement("div", {
            className: "e-ccdlg e-cc",
            id: this.parent.element.id + "_ccdlg"
        });
        if (!isAdaptive) this.parent.element.appendChild(this.dlgDiv);
        this.dlgObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            header: this.parent.enableAdaptiveUI ? null : this.l10n.getConstant("ChooseColumns"),
            showCloseIcon: false,
            closeOnEscape: false,
            locale: this.parent.locale,
            visible: false,
            enableRtl: this.parent.enableRtl,
            target: document.getElementById(this.parent.element.id),
            content: this.renderChooserList(),
            width: 250,
            cssClass: this.parent.cssClass ? "e-cc " + this.parent.cssClass : "e-cc",
            animationSettings: {
                effect: "None"
            }
        });
        if (!isAdaptive) this.dlgObj.buttons = [
            {
                click: this.confirmDlgBtnClick.bind(this),
                buttonModel: {
                    content: this.l10n.getConstant("OKButton"),
                    isPrimary: true,
                    cssClass: this.parent.cssClass ? "e-cc e-cc_okbtn " + this.parent.cssClass : "e-cc e-cc_okbtn"
                }
            },
            {
                click: this.clearBtnClick.bind(this),
                buttonModel: {
                    cssClass: this.parent.cssClass ? "e-flat e-cc e-cc-cnbtn " + this.parent.cssClass : "e-flat e-cc e-cc-cnbtn",
                    content: this.l10n.getConstant("CancelButton")
                }
            }
        ];
        var isStringTemplate = "isStringTemplate";
        this.dlgObj["" + isStringTemplate] = true;
        this.dlgObj.appendTo(this.dlgDiv);
        if (isAdaptive) {
            var responsiveCnt = document.querySelector(".e-responsive-dialog > .e-dlg-content > .e-mainfilterdiv");
            if (responsiveCnt) responsiveCnt.appendChild(this.dlgDiv);
            this.dlgObj.open = this.mOpenDlg.bind(this);
            this.dlgObj.target = document.querySelector(".e-rescolumnchooser > .e-dlg-content > .e-mainfilterdiv");
        }
        this.wireEvents();
    };
    ColumnChooser.prototype.renderChooserList = function() {
        this.mainDiv = this.parent.createElement("div", {
            className: "e-main-div e-cc"
        });
        var searchDiv = this.parent.createElement("div", {
            className: "e-cc-searchdiv e-cc e-input-group"
        });
        var ccsearchele = this.parent.createElement("input", {
            className: "e-ccsearch e-cc e-input",
            attrs: {
                placeholder: this.l10n.getConstant("Search"),
                cssClass: this.parent.cssClass
            }
        });
        var ccsearchicon = this.parent.createElement("span", {
            className: "e-ccsearch-icon e-icons e-cc e-input-group-icon",
            attrs: {
                title: this.l10n.getConstant("Search")
            }
        });
        var conDiv = this.parent.createElement("div", {
            className: "e-cc-contentdiv"
        });
        this.innerDiv = this.parent.createElement("div", {
            className: "e-innerdiv e-cc"
        });
        searchDiv.appendChild(ccsearchele);
        searchDiv.appendChild(ccsearchicon);
        this.searchBoxObj = new (0, $008b258884e5b2ce$export$5a58787633b0b5d8)(ccsearchele, this.serviceLocator);
        var innerDivContent = this.refreshCheckboxList(this.parent.getColumns());
        this.innerDiv.appendChild(innerDivContent);
        conDiv.appendChild(this.innerDiv);
        if (this.parent.enableAdaptiveUI) {
            var searchBoxDiv = this.parent.createElement("div", {
                className: "e-cc-searchBox"
            });
            searchBoxDiv.appendChild(searchDiv);
            this.mainDiv.appendChild(searchBoxDiv);
        } else this.mainDiv.appendChild(searchDiv);
        this.mainDiv.appendChild(conDiv);
        return this.mainDiv;
    };
    ColumnChooser.prototype.confirmDlgBtnClick = function(args) {
        var _this = this;
        this.stateChangeColumns = [];
        this.changedStateColumns = [];
        if (this.filterColumns.length && this.ulElement.querySelector(".e-selectall.e-check")) {
            this.changedColumns = this.filterColumns.map(function(column) {
                return column.uid;
            });
            this.showColumn = [];
            this.hideColumn = [];
            this.parent.getColumns().map(function(column) {
                if (_this.changedColumns.indexOf(column.uid) !== -1) _this.showColumn.push(column.uid);
                else _this.hideColumn.push(column.uid);
            });
        } else this.changedColumns = this.changedColumns.length > 0 ? this.changedColumns : this.unchangedColumns;
        this.changedColumnState(this.changedColumns);
        var uncheckedLength = this.ulElement.querySelector(".e-uncheck") && this.ulElement.querySelectorAll(".e-uncheck:not(.e-selectall)").length;
        if (!(0, $3EnZW.isNullOrUndefined)(args)) {
            if (uncheckedLength < this.parent.getColumns().length) {
                if (this.hideColumn.length) this.columnStateChange(this.hideColumn, false);
                if (this.showColumn.length) this.columnStateChange(this.showColumn, true);
                this.getShowHideService.setVisible(this.stateChangeColumns, this.changedStateColumns);
                this.clearActions();
                this.parent.notify($17b89d3b1fc93cdb$export$7edde809d061e, {
                    module: "edit"
                });
                if (this.parent.getCurrentViewRecords().length === 0) {
                    var emptyRowCell = this.parent.element.querySelector(".e-emptyrow").querySelector("td");
                    emptyRowCell.setAttribute("colSpan", this.parent.getVisibleColumns().length.toString());
                }
            }
            if (this.parent.enableAdaptiveUI && this.parent.scrollModule) this.parent.scrollModule.refresh();
            if (this.parent.editSettings.showAddNewRow) this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
        }
    };
    ColumnChooser.prototype.onResetColumns = function(e) {
        if (e.requestType === "columnstate") {
            this.resetColumnState();
            return;
        }
    };
    ColumnChooser.prototype.renderResponsiveColumnChooserDiv = function(args) {
        if (args.action === "open") {
            this.isColumnChooserOpen = true;
            this.openColumnChooser();
        } else if (args.action === "clear") this.clearBtnClick();
        else if (args.action === "confirm") this.confirmDlgBtnClick(true);
    };
    ColumnChooser.prototype.resetColumnState = function() {
        this.showColumn = [];
        this.hideColumn = [];
        this.changedColumns = [];
        this.filterColumns = [];
        this.searchValue = "";
        this.hideDialog();
    };
    ColumnChooser.prototype.changedColumnState = function(changedColumns) {
        for(var index = 0; index < changedColumns.length; index++){
            var colUid = changedColumns[parseInt(index.toString(), 10)];
            var currentCol = this.parent.getColumnByUid(colUid);
            this.changedStateColumns.push(currentCol);
        }
    };
    ColumnChooser.prototype.columnStateChange = function(stateColumns, state) {
        for(var index = 0; index < stateColumns.length; index++){
            var colUid = stateColumns[parseInt(index.toString(), 10)];
            var currentCol = this.parent.getColumnByUid(colUid);
            if (currentCol.type !== "checkbox") currentCol.visible = state;
            this.stateChangeColumns.push(currentCol);
        }
    };
    ColumnChooser.prototype.clearActions = function() {
        this.resetColumnState();
        this.addcancelIcon();
    };
    ColumnChooser.prototype.clearBtnClick = function() {
        this.clearActions();
        this.parent.notify($17b89d3b1fc93cdb$export$1c8994c032170add, {
            dialog: this.dlgObj
        });
    };
    ColumnChooser.prototype.checkstatecolumn = function(isChecked, coluid, selectAll) {
        if (selectAll === void 0) selectAll = false;
        var currentCol = this.parent.getColumnByUid(coluid);
        if (isChecked) {
            if (this.hideColumn.indexOf(coluid) !== -1) this.hideColumn.splice(this.hideColumn.indexOf(coluid), 1);
            if (this.showColumn.indexOf(coluid) === -1 && !(currentCol && currentCol.visible)) this.showColumn.push(coluid);
        } else {
            if (this.showColumn.indexOf(coluid) !== -1) this.showColumn.splice(this.showColumn.indexOf(coluid), 1);
            if (this.hideColumn.indexOf(coluid) === -1 && currentCol && currentCol.visible) this.hideColumn.push(coluid);
        }
        if (selectAll) {
            if (!isChecked) this.changedColumns.push(coluid);
            else this.unchangedColumns.push(coluid);
        } else if (this.changedColumns.indexOf(coluid) !== -1) this.changedColumns.splice(this.changedColumns.indexOf(coluid), 1);
        else this.changedColumns.push(coluid);
    };
    ColumnChooser.prototype.columnChooserSearch = function(searchVal) {
        var clearSearch = false;
        var okButton;
        var buttonEle = this.dlgDiv.querySelector(".e-footer-content");
        var selectedCbox = this.ulElement.querySelector(".e-check") && this.ulElement.querySelectorAll(".e-check:not(.e-selectall)").length;
        this.isInitialOpen = true;
        if (buttonEle) okButton = buttonEle.querySelector(".e-btn").ej2_instances[0];
        if (searchVal === "") {
            this.removeCancelIcon();
            this.filterColumns = this.getColumns();
            clearSearch = true;
        } else this.filterColumns = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.getColumns()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("headerText", this.searchOperator, searchVal, true, this.parent.columnChooserSettings.ignoreAccent));
        if (this.filterColumns.length) {
            this.innerDiv.innerHTML = " ";
            this.innerDiv.classList.remove("e-ccnmdiv");
            this.innerDiv.appendChild(this.refreshCheckboxList(this.filterColumns));
            if (!clearSearch) {
                this.addcancelIcon();
                this.refreshCheckboxButton();
            } else {
                if (okButton && selectedCbox) okButton.disabled = false;
                if (selectedCbox && this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
                    disabled: false
                });
            }
        } else {
            var nMatchele = this.parent.createElement("span", {
                className: "e-cc e-nmatch"
            });
            nMatchele.innerHTML = this.l10n.getConstant("Matchs");
            this.innerDiv.innerHTML = " ";
            this.innerDiv.appendChild(nMatchele);
            this.innerDiv.classList.add("e-ccnmdiv");
            if (okButton) okButton.disabled = true;
            if (this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
                disabled: true
            });
        }
        this.flag = true;
        this.stopTimer();
    };
    ColumnChooser.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.dlgObj.element, "click", this.checkBoxClickHandler, this);
        (0, $aqzbR.EventHandler).add(this.searchBoxObj.searchBox, "keyup", this.columnChooserManualSearch, this);
        (0, $aqzbR.EventHandler).add(this.dlgObj.element, "keyup", this.keyUpHandler, this);
        this.searchBoxObj.wireEvent();
    };
    ColumnChooser.prototype.unWireEvents = function() {
        if (this.parent.isDestroyed) return;
        if (this.dlgObj && this.dlgObj.element) {
            (0, $aqzbR.EventHandler).remove(this.dlgObj.element, "click", this.checkBoxClickHandler);
            (0, $aqzbR.EventHandler).remove(this.dlgObj.element, "keyup", this.keyUpHandler);
        }
        if (this.searchBoxObj) {
            (0, $aqzbR.EventHandler).remove(this.searchBoxObj.searchBox, "keyup", this.columnChooserManualSearch);
            this.searchBoxObj.unWireEvent();
        }
    };
    ColumnChooser.prototype.checkBoxClickHandler = function(e) {
        var checkstate;
        var elem = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-checkbox-wrapper");
        if (elem) {
            var selectAll = elem.querySelector(".e-selectall");
            if (selectAll) this.updateSelectAll(!elem.querySelector(".e-check"));
            else (0, $748c2240e597a9b7$export$40f7f1b3a5921618)(elem.parentElement);
            elem.querySelector(".e-chk-hidden").focus();
            if (elem.querySelector(".e-check")) checkstate = true;
            else if (elem.querySelector(".e-uncheck")) checkstate = false;
            this.updateIntermediateBtn();
            var columnUid = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(elem, "e-ccheck").getAttribute("uid");
            var column = this.searchValue && this.searchValue.length ? this.filterColumns : this.parent.getColumns();
            if (columnUid === this.parent.element.id + "-selectAll") {
                this.changedColumns = [];
                this.unchangedColumns = [];
                for(var i = 0; i < column.length; i++)if (column[parseInt(i.toString(), 10)].showInColumnChooser) this.checkstatecolumn(checkstate, column[parseInt(i.toString(), 10)].uid, true);
            } else this.checkstatecolumn(checkstate, columnUid);
            this.refreshCheckboxButton();
            this.setFocus((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-cclist"));
        }
    };
    ColumnChooser.prototype.updateIntermediateBtn = function() {
        var cnt = this.ulElement.children.length - 1;
        var className = [];
        var elem = this.ulElement.children[0].querySelector(".e-frame");
        var selected = this.ulElement.querySelectorAll(".e-check:not(.e-selectall)").length;
        var btn;
        if (!this.parent.enableAdaptiveUI) {
            btn = this.dlgObj.btnObj[0];
            btn.disabled = false;
        } else if (this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
            disabled: false
        });
        var inputElem = elem.parentElement.querySelector("input");
        if (cnt === selected) {
            className = [
                "e-check"
            ];
            (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(inputElem, true);
        } else if (selected) {
            className = [
                "e-stop"
            ];
            inputElem.indeterminate = true;
        } else {
            className = [
                "e-uncheck"
            ];
            (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(inputElem, false);
            if (!this.parent.enableAdaptiveUI) btn.disabled = true;
            else if (this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
                disabled: true
            });
        }
        if (!this.parent.enableAdaptiveUI) btn.dataBind();
        (0, $4ZDHT.removeClass)([
            elem
        ], [
            "e-check",
            "e-stop",
            "e-uncheck"
        ]);
        (0, $4ZDHT.addClass)([
            elem
        ], className);
    };
    ColumnChooser.prototype.updateSelectAll = function(checked) {
        var cBoxes = [].slice.call(this.ulElement.getElementsByClassName("e-frame"));
        for(var _i = 0, cBoxes_1 = cBoxes; _i < cBoxes_1.length; _i++){
            var cBox = cBoxes_1[_i];
            (0, $748c2240e597a9b7$export$39b02a8864b327ad)(cBox, checked);
            var cBoxInput = cBox.parentElement.querySelector("input");
            if (cBox.classList.contains("e-check")) (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(cBoxInput, true);
            else if (cBox.classList.contains("e-uncheck")) (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(cBoxInput, false);
        }
    };
    ColumnChooser.prototype.refreshCheckboxButton = function() {
        var visibleCols = this.parent.getVisibleColumns();
        for(var i = 0; i < visibleCols.length; i++){
            var columnUID = visibleCols[parseInt(i.toString(), 10)].uid;
            if (this.prevShowedCols.indexOf(columnUID) === -1 && visibleCols[parseInt(i.toString(), 10)].type !== "checkbox") this.prevShowedCols.push(columnUID);
        }
        for(var i = 0; i < this.hideColumn.length; i++){
            var index = this.prevShowedCols.indexOf(this.hideColumn[parseInt(i.toString(), 10)]);
            if (index !== -1) this.prevShowedCols.splice(index, 1);
        }
        var selected = this.showColumn.length !== 0 ? 1 : this.prevShowedCols.length;
        var btn;
        if (!this.parent.enableAdaptiveUI) {
            btn = this.dlgDiv.querySelector(".e-footer-content").querySelector(".e-btn").ej2_instances[0];
            btn.disabled = false;
        } else if (this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
            disabled: false
        });
        var srchShowCols = [];
        var searchData = [].slice.call(this.parent.element.getElementsByClassName("e-cc-chbox"));
        for(var i = 0, itemsLen = searchData.length; i < itemsLen; i++){
            var element = searchData[parseInt(i.toString(), 10)];
            var columnUID = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(element, "e-ccheck").getAttribute("uid");
            srchShowCols.push(columnUID);
        }
        var hideCols = this.showColumn.filter(function(column) {
            return srchShowCols.indexOf(column) !== -1;
        });
        if (selected === 0 && hideCols.length === 0) {
            if (!this.parent.enableAdaptiveUI) btn.disabled = true;
            else if (this.parent.enableAdaptiveUI && this.responsiveDialogRenderer) this.parent.notify($17b89d3b1fc93cdb$export$acd547ecab270561, {
                disabled: true
            });
        }
        if (!this.parent.enableAdaptiveUI) btn.dataBind();
    };
    ColumnChooser.prototype.refreshCheckboxList = function(gdCol) {
        this.ulElement = this.parent.createElement("ul", {
            className: "e-ccul-ele e-cc"
        });
        var selectAllValue = this.l10n.getConstant("SelectAll");
        var cclist = this.parent.createElement("li", {
            className: "e-cclist e-cc e-cc-selectall"
        });
        var selectAll = this.createCheckBox(selectAllValue, false, this.parent.element.id + "-selectAll");
        if (gdCol.length) {
            selectAll.querySelector(".e-checkbox-wrapper").firstElementChild.classList.add("e-selectall");
            selectAll.querySelector(".e-frame").classList.add("e-selectall");
            this.checkState(selectAll.querySelector(".e-icons"), true);
            cclist.appendChild(selectAll);
            this.ulElement.appendChild(cclist);
        }
        if (this.parent.cssClass) {
            if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                selectAll
            ], this.parent.cssClass.split(" "));
            else (0, $4ZDHT.addClass)([
                selectAll
            ], [
                this.parent.cssClass
            ]);
        }
        for(var i = 0; i < gdCol.length; i++){
            var columns = gdCol[parseInt(i.toString(), 10)];
            this.renderCheckbox(columns);
        }
        return this.ulElement;
    };
    ColumnChooser.prototype.refreshCheckboxState = function() {
        this.dlgObj.element.querySelector(".e-cc.e-input").value = "";
        this.columnChooserSearch("");
        var gridObject = this.parent;
        var currentCheckBoxColls = this.dlgObj.element.querySelectorAll(".e-cc-chbox:not(.e-selectall)");
        for(var i = 0, itemLen = currentCheckBoxColls.length; i < itemLen; i++){
            var element = currentCheckBoxColls[parseInt(i.toString(), 10)];
            var columnUID = void 0;
            if (this.parent.childGrid || this.parent.detailTemplate) columnUID = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.dlgObj.element.querySelectorAll(".e-cc-chbox:not(.e-selectall)")[parseInt(i.toString(), 10)], "e-ccheck").getAttribute("uid");
            else columnUID = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(element, "e-ccheck").getAttribute("uid");
            var column = gridObject.getColumnByUid(columnUID);
            var uncheck = [].slice.call(element.parentElement.getElementsByClassName("e-uncheck"));
            if (column.visible && !uncheck.length) {
                element.checked = true;
                this.checkState(element.parentElement.querySelector(".e-icons"), true);
            } else {
                element.checked = false;
                this.checkState(element.parentElement.querySelector(".e-icons"), false);
            }
        }
    };
    ColumnChooser.prototype.checkState = function(element, state) {
        if (state) (0, $4ZDHT.classList)(element, [
            "e-check"
        ], [
            "e-uncheck"
        ]);
        else (0, $4ZDHT.classList)(element, [
            "e-uncheck"
        ], [
            "e-check"
        ]);
    };
    ColumnChooser.prototype.createCheckBox = function(label, checked, uid) {
        var cbox = checked ? this.cBoxTrue.cloneNode(true) : this.cBoxFalse.cloneNode(true);
        if (!this.parent.enableAdaptiveUI && this.parent.enableRtl && !cbox.classList.contains("e-rtl")) cbox.classList.add("e-rtl");
        var cboxLabel = cbox.querySelector(".e-label");
        var inputcbox = cbox.querySelector("input");
        (0, $748c2240e597a9b7$export$d2270ed72c00a9b2)(inputcbox, checked);
        cboxLabel.setAttribute("id", uid + "label");
        cboxLabel.innerHTML = label;
        inputcbox.setAttribute("aria-labelledby", cboxLabel.id);
        return (0, $748c2240e597a9b7$export$cc092c6fe78fc98a)(uid, cbox, "e-ccheck");
    };
    ColumnChooser.prototype.renderCheckbox = function(column) {
        var cclist;
        var hideColState;
        var showColState;
        if (column.showInColumnChooser) {
            cclist = this.parent.createElement("li", {
                className: "e-cclist e-cc",
                styles: "list-style:None",
                id: "e-ccli_" + column.uid
            });
            hideColState = this.hideColumn.indexOf(column.uid) === -1 ? false : true;
            showColState = this.showColumn.indexOf(column.uid) === -1 ? false : true;
            var cccheckboxlist = this.createCheckBox(column.headerText, column.visible && !hideColState || showColState, column.uid);
            cclist.appendChild(cccheckboxlist);
            if (this.parent.cssClass) {
                if (this.parent.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                    cccheckboxlist
                ], this.parent.cssClass.split(" "));
                else (0, $4ZDHT.addClass)([
                    cccheckboxlist
                ], [
                    this.parent.cssClass
                ]);
            }
            this.ulElement.appendChild(cclist);
        }
        if (this.isInitialOpen) this.updateIntermediateBtn();
    };
    ColumnChooser.prototype.columnChooserManualSearch = function(e) {
        this.addcancelIcon();
        this.searchValue = e.target.value;
        this.stopTimer();
        this.startTimer(e);
    };
    ColumnChooser.prototype.startTimer = function(e) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var interval = !proxy.flag && e.keyCode !== 13 ? 500 : 0;
        this.timer = window.setInterval(function() {
            proxy.columnChooserSearch(proxy.searchValue);
        }, interval);
    };
    ColumnChooser.prototype.stopTimer = function() {
        window.clearInterval(this.timer);
    };
    ColumnChooser.prototype.addcancelIcon = function() {
        this.dlgDiv.querySelector(".e-cc.e-ccsearch-icon").classList.add("e-cc-cancel");
        this.dlgDiv.querySelector(".e-cc-cancel").setAttribute("title", this.l10n.getConstant("Clear"));
    };
    ColumnChooser.prototype.removeCancelIcon = function() {
        this.dlgDiv.querySelector(".e-cc.e-ccsearch-icon").classList.remove("e-cc-cancel");
        this.dlgDiv.querySelector(".e-cc.e-ccsearch-icon").setAttribute("title", this.l10n.getConstant("Search"));
    };
    ColumnChooser.prototype.mOpenDlg = function() {
        if ((0, $5q7BP.Browser).isDevice) {
            this.dlgObj.element.querySelector(".e-cc-searchdiv").classList.remove("e-input-focus");
            this.dlgObj.element.querySelectorAll(".e-cc-chbox")[0].focus();
        }
        if (this.parent.enableAdaptiveUI) this.dlgObj.element.querySelector(".e-cc-searchdiv").classList.add("e-input-focus");
    };
    // internally use
    ColumnChooser.prototype.getModuleName = function() {
        return "columnChooser";
    };
    ColumnChooser.prototype.hideOpenedDialog = function() {
        var openCC = [].slice.call(document.getElementsByClassName("e-ccdlg")).filter(function(dlgEle) {
            return dlgEle.classList.contains("e-popup-open");
        });
        for(var i = 0, dlgLen = openCC.length; i < dlgLen; i++)if (this.parent.element.id + "_ccdlg" !== openCC[parseInt(i.toString(), 10)].id || openCC[parseInt(i.toString(), 10)].classList.contains("e-dialog")) openCC[parseInt(i.toString(), 10)].ej2_instances[0].hide();
    };
    ColumnChooser.prototype.beforeOpenColumnChooserEvent = function() {
        var args1 = {
            requestType: "beforeOpenColumnChooser",
            element: this.parent.element,
            columns: this.getColumns(),
            cancel: false,
            searchOperator: this.parent.columnChooserSettings.operator
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$1ba26bc61ad01b07, args1);
        this.searchOperator = args1.searchOperator;
        return args1;
    };
    ColumnChooser.prototype.renderResponsiveChangeAction = function(args) {
        this.responsiveDialogRenderer.action = args.action;
    };
    /**
     * To show the responsive custom sort dialog
     *
     * @param {boolean} enable - specifes dialog open
     * @returns {void}
     * @hidden
     */ ColumnChooser.prototype.showCustomColumnChooser = function(enable) {
        this.responsiveDialogRenderer.isCustomDialog = enable;
        this.responsiveDialogRenderer.showResponsiveDialog();
    };
    return ColumnChooser;
}();


var $9c109334a35cffc4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Worksheets class
 * @private
 */ /* eslint-disable */ var $9c109334a35cffc4$export$452036259364aa71 = /** @class */ function(_super) {
    $9c109334a35cffc4$var$__extends(Worksheets, _super);
    function Worksheets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Worksheets;
}(Array);


var $67d8c6e4cf60a7eb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Worksheet class
 * @private
 */ /* eslint-disable */ var $67d8c6e4cf60a7eb$export$9149bd1ee08cae1b = /** @class */ function() {
    function Worksheet() {
        this.isSummaryRowBelow = true;
        this.showGridLines = true;
        this.enableRtl = false;
    }
    return Worksheet;
}();
/**
 * Hyperlink class
 * @private
 */ var $67d8c6e4cf60a7eb$export$9ffbcd112f010b63 = /** @class */ function() {
    function HyperLink() {}
    return HyperLink;
}();
/**
 * Grouping class
 * @private
 */ var $67d8c6e4cf60a7eb$export$3885c0af90651e94 = /** @class */ function() {
    function Grouping() {}
    return Grouping;
}();
/**
 * FreezePane class
 * @private
 */ var $67d8c6e4cf60a7eb$export$dab43b34d064965 = /** @class */ function() {
    function FreezePane() {}
    return FreezePane;
}();
/**
 * MergeCell
 * @private
 */ var $67d8c6e4cf60a7eb$export$4e0dd0bdc0b39907 = /** @class */ function() {
    function MergeCell() {}
    return MergeCell;
}();
/**
 * MergeCells class
 * @private
 */ var $67d8c6e4cf60a7eb$export$3ad3169641d18926 = /** @class */ function(_super) {
    $67d8c6e4cf60a7eb$var$__extends(MergeCells, _super);
    function MergeCells() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.add = function(mergeCell) {
            var inserted = false;
            var count = 0;
            for(var _i = 0, _a = _this; _i < _a.length; _i++){
                var mCell = _a[_i];
                if (MergeCells.isIntersecting(mCell, mergeCell)) {
                    var intersectingCell = new $67d8c6e4cf60a7eb$export$4e0dd0bdc0b39907();
                    intersectingCell.x = Math.min(mCell.x, mergeCell.x);
                    intersectingCell.y = Math.min(mCell.Y, mergeCell.y);
                    intersectingCell.width = Math.max(mCell.Width + mCell.X, mergeCell.width + mergeCell.x);
                    intersectingCell.height = Math.max(mCell.Height + mCell.Y, mergeCell.height + mergeCell.y);
                    intersectingCell.ref = _this[count].ref.split(":")[0] + ":" + mergeCell.ref.split(":")[1];
                    _this[count] = intersectingCell;
                    mergeCell = intersectingCell;
                    inserted = true;
                }
                count++;
            }
            if (!inserted) _this.push(mergeCell);
            return mergeCell;
        };
        return _this;
    }
    MergeCells.isIntersecting = function(base, compare) {
        return base.x <= compare.x + compare.width && compare.x <= base.x + base.width && base.y <= compare.y + compare.height && compare.y <= base.y + base.height;
    };
    return MergeCells;
}(Array);


/**
 * CellStyle class
 * @private
 */ /* eslint-disable */ var $46b0c7517f7f6010$export$6dcbd134ed4660ff = /** @class */ function() {
    function CellStyle() {
        this.numFmtId = 0;
        this.backColor = "none";
        this.fontName = "Calibri";
        this.fontSize = 10.5;
        this.fontColor = "#000000";
        this.italic = false;
        this.bold = false;
        this.underline = false;
        this.strikeThrough = false;
        this.wrapText = false;
        this.hAlign = "general";
        this.vAlign = "bottom";
        this.indent = 0;
        this.rotation = 0;
        this.numberFormat = "GENERAL";
        this.type = "datetime";
        this.borders = new $46b0c7517f7f6010$export$fe4fc692d691c0b0();
        this.isGlobalStyle = false;
    }
    return CellStyle;
}();
/**
 * Font Class
 * @private
 */ var $46b0c7517f7f6010$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        this.sz = 10.5;
        this.name = "Calibri";
        this.u = false;
        this.b = false;
        this.i = false;
        this.color = "FF000000";
        this.strike = false;
    }
    return Font;
}();
/**
 * CellXfs class
 * @private
 */ var $46b0c7517f7f6010$export$98a97e53c3248335 = /** @class */ function() {
    function CellXfs() {}
    return CellXfs;
}();
/**
 * Alignment class
 * @private
 */ var $46b0c7517f7f6010$export$9d7927214ed7d2cf = /** @class */ function() {
    function Alignment() {}
    return Alignment;
}();
/**
 * CellStyleXfs class
 * @private
 */ var $46b0c7517f7f6010$export$a73427ac4777aa87 = /** @class */ function() {
    function CellStyleXfs() {}
    return CellStyleXfs;
}();
/**
 * CellStyles class
 * @private
 */ var $46b0c7517f7f6010$export$4d06df561c8b8a10 = /** @class */ function() {
    function CellStyles() {
        this.name = "Normal";
        this.xfId = 0;
    }
    return CellStyles;
}();
/**
 * NumFmt class
 * @private
 */ var $46b0c7517f7f6010$export$8a1320b211f3c33f = /** @class */ function() {
    function NumFmt(id, code) {
        this.numFmtId = id;
        this.formatCode = code;
    }
    return NumFmt;
}();
/**
 * Border class
 * @private
 */ var $46b0c7517f7f6010$export$d8e9c9d63e86d41e = /** @class */ function() {
    function Border(mLine, mColor) {
        this.lineStyle = mLine;
        this.color = mColor;
    }
    return Border;
}();
/**
 * Borders class
 * @private
 */ var $46b0c7517f7f6010$export$fe4fc692d691c0b0 = /** @class */ function() {
    function Borders() {
        this.left = new $46b0c7517f7f6010$export$d8e9c9d63e86d41e("none", "#FFFFFF");
        this.right = new $46b0c7517f7f6010$export$d8e9c9d63e86d41e("none", "#FFFFFF");
        this.top = new $46b0c7517f7f6010$export$d8e9c9d63e86d41e("none", "#FFFFFF");
        this.bottom = new $46b0c7517f7f6010$export$d8e9c9d63e86d41e("none", "#FFFFFF");
        this.all = new $46b0c7517f7f6010$export$d8e9c9d63e86d41e("none", "#FFFFFF");
    }
    return Borders;
}();


/**
 * Column class
 * @private
 */ /* eslint-disable */ var $af687566b951b90e$export$816b5d811295e6bc = /** @class */ function() {
    function Column() {}
    return Column;
}();


var $c82e544914982989$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Row class
 * @private
 */ /* eslint-disable */ var $c82e544914982989$export$b59bdbef9ce70de2 = /** @class */ function() {
    function Row() {}
    return Row;
}();
/**
 * Rows class
 * @private
 */ var $c82e544914982989$export$9ba739f4e3fc4d9 = /** @class */ function(_super) {
    $c82e544914982989$var$__extends(Rows, _super);
    function Rows() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.add = function(row) {
            _this.push(row);
        };
        return _this;
    }
    return Rows;
}(Array);


/**
 * Image class
 * @private
 */ /* eslint-disable */ var $ddf824fb1d8942b1$export$3e431a229df88919 = /** @class */ function() {
    function Image() {}
    return Image;
}();


var $85645432c0358509$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Worksheet class
 * @private
 */ /* eslint-disable */ var $85645432c0358509$export$f6f0c3fe4ec306ea = /** @class */ function() {
    function Cell() {}
    return Cell;
}();
/**
 * Cells class
 * @private
 */ var $85645432c0358509$export$99889833ab266a29 = /** @class */ function(_super) {
    $85645432c0358509$var$__extends(Cells, _super);
    function Cells() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.add = function(cell) {
            var inserted = false;
            var count = 0;
            for(var _i = 0, _a = _this; _i < _a.length; _i++){
                var c = _a[_i];
                if (c.index === cell.index) {
                    _this[count] = cell;
                    inserted = true;
                }
                count++;
            }
            if (!inserted) _this.push(cell);
        };
        return _this;
    }
    return Cells;
}(Array);


/* eslint-disable */ /* eslint-disable */ /* eslint-disable */ /* eslint-disable */ var $f67072eb46bd887e$export$d2ca453b913dcdea = /** @class */ function() {
    function Utils() {}
    Utils.bitReverse = function(value) {
        return Utils.reverseBits[value & 15] << 12 | Utils.reverseBits[value >> 4 & 15] << 8 | Utils.reverseBits[value >> 8 & 15] << 4 | Utils.reverseBits[value >> 12];
    };
    Utils.bitConverterToInt32 = function(value, index) {
        return value[index] | value[index + 1] << 8 | value[index + 2] << 16 | value[index + 3] << 24;
    };
    Utils.bitConverterToInt16 = function(value, index) {
        return value[index] | value[index + 1] << 8;
    };
    Utils.bitConverterToUInt32 = function(value) {
        var uint = new Uint32Array(1);
        uint[0] = value;
        return uint[0];
    };
    Utils.bitConverterToUInt16 = function(value, index) {
        var uint = new Uint16Array(1);
        uint[0] = value[index] | value[index + 1] << 8;
        return uint[0];
    };
    Utils.bitConverterUintToInt32 = function(value) {
        var uint = new Int32Array(1);
        uint[0] = value;
        return uint[0];
    };
    Utils.bitConverterInt32ToUint = function(value) {
        var uint = new Uint32Array(1);
        uint[0] = value;
        return uint[0];
    };
    Utils.bitConverterInt32ToInt16 = function(value) {
        var uint = new Int16Array(1);
        uint[0] = value;
        return uint[0];
    };
    Utils.byteToString = function(value) {
        var str = "";
        for(var i = 0; i < value.length; i++)str += String.fromCharCode(value[i]);
        return str;
    };
    Utils.byteIntToString = function(value) {
        var str = "";
        for(var i = 0; i < value.length; i++)str += String.fromCharCode(value[i]);
        return str;
    };
    Utils.arrayCopy = function(source, sourceIndex, destination, destinationIndex, dataToCopy) {
        var temp = new Uint8Array(source.buffer, sourceIndex);
        var data = temp.subarray(0, dataToCopy);
        destination.set(data, destinationIndex);
    };
    Utils.mergeArray = function(arrayOne, arrayTwo) {
        var mergedArray = new Uint8Array(arrayOne.length + arrayTwo.length);
        mergedArray.set(arrayOne);
        mergedArray.set(arrayTwo, arrayOne.length);
        return mergedArray;
    };
    /**
     * @private
     */ Utils.encodedString = function(input) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var chr1;
        var chr2;
        var chr3;
        var encode1;
        var encode2;
        var encode3;
        var encode4;
        var count = 0;
        var resultIndex = 0;
        /*let dataUrlPrefix: string = 'data:';*/ input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        var totalLength = input.length * 3 / 4;
        if (input.charAt(input.length - 1) === keyStr.charAt(64)) totalLength--;
        if (input.charAt(input.length - 2) === keyStr.charAt(64)) totalLength--;
        if (totalLength % 1 !== 0) // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        // beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
        var output = new Uint8Array(totalLength | 0);
        while(count < input.length){
            encode1 = keyStr.indexOf(input.charAt(count++));
            encode2 = keyStr.indexOf(input.charAt(count++));
            encode3 = keyStr.indexOf(input.charAt(count++));
            encode4 = keyStr.indexOf(input.charAt(count++));
            chr1 = encode1 << 2 | encode2 >> 4;
            chr2 = (encode2 & 15) << 4 | encode3 >> 2;
            chr3 = (encode3 & 3) << 6 | encode4;
            output[resultIndex++] = chr1;
            if (encode3 !== 64) output[resultIndex++] = chr2;
            if (encode4 !== 64) output[resultIndex++] = chr3;
        }
        return output;
    };
    Utils.reverseBits = [
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ];
    Utils.huffCodeLengthOrders = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    return Utils;
}();
 /* eslint-enable */ 

var $04fb74d0ebaebcd6$export$12c70882ce25e356 = /** @class */ function() {
    function DecompressorHuffmanTree(lengths) {
        this.buildTree(lengths);
    }
    DecompressorHuffmanTree.init = function() {
        var lengths;
        var index;
        // Generate huffman tree for lengths.
        lengths = new Uint8Array(288);
        index = 0;
        while(index < 144)lengths[index++] = 8;
        while(index < 256)lengths[index++] = 9;
        while(index < 280)lengths[index++] = 7;
        while(index < 288)lengths[index++] = 8;
        DecompressorHuffmanTree.m_LengthTree = new DecompressorHuffmanTree(lengths);
        // Generate huffman tree for distances.
        lengths = new Uint8Array(32);
        index = 0;
        while(index < 32)lengths[index++] = 5;
        DecompressorHuffmanTree.m_DistanceTree = new DecompressorHuffmanTree(lengths);
    };
    /// <summary>
    /// Prepares data for generating huffman tree.
    /// </summary>
    /// <param name="blCount">Array of counts of each code length.</param>
    /// <param name="nextCode">Numerical values of the smallest code for each code length.</param>
    /// <param name="lengths">Array of code lengths.</param>
    /// <param name="treeSize">Calculated tree size.</param>
    /// <returns>Code.</returns>
    DecompressorHuffmanTree.prototype.prepareData = function(blCount, nextCode, lengths) {
        var code = 0;
        var treeSize = 512;
        // Count number of codes for each code length.
        for(var i = 0; i < lengths.length; i++){
            var length_1 = lengths[i];
            if (length_1 > 0) blCount[length_1]++;
        }
        for(var bits = 1; bits <= DecompressorHuffmanTree.MAX_BITLEN; bits++){
            nextCode[bits] = code;
            code += blCount[bits] << 16 - bits;
            if (bits >= 10) {
                var start = nextCode[bits] & 0x1ff80;
                var end = code & 0x1ff80;
                treeSize += end - start >> 16 - bits;
            }
        }
        /*      if( code != 65536 )
          throw new ZipException( "Code lengths don't add up properly." );*/ return {
            "code": code,
            "treeSize": treeSize
        };
    };
    /// <summary>
    /// Generates huffman tree.
    /// </summary>
    /// <param name="blCount">Array of counts of each code length.</param>
    /// <param name="nextCode">Numerical values of the smallest code for each code length.</param>
    /// <param name="code">Precalculated code.</param>
    /// <param name="lengths">Array of code lengths.</param>
    /// <param name="treeSize">Calculated size of the tree.</param>
    /// <returns>Generated tree.</returns>
    DecompressorHuffmanTree.prototype.treeFromData = function(blCount, nextCode, lengths, code, treeSize) {
        var tree = new Int16Array(treeSize);
        var pointer = 512;
        var increment = 128;
        for(var bits = DecompressorHuffmanTree.MAX_BITLEN; bits >= 10; bits--){
            var end = code & 0x1ff80;
            code -= blCount[bits] << 16 - bits;
            var start = code & 0x1ff80;
            for(var i = start; i < end; i += increment){
                tree[(0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitReverse(i)] = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToInt16(-pointer << 4 | bits);
                pointer += 1 << bits - 9;
            }
        }
        for(var i = 0; i < lengths.length; i++){
            var bits = lengths[i];
            if (bits == 0) continue;
            code = nextCode[bits];
            var revcode = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitReverse(code);
            if (bits <= 9) do {
                tree[revcode] = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToInt16(i << 4 | bits);
                revcode += 1 << bits;
            }while (revcode < 512);
            else {
                var subTree = tree[revcode & 511];
                var treeLen = 1 << (subTree & 15);
                subTree = -(subTree >> 4);
                do {
                    tree[subTree | revcode >> 9] = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToInt16(i << 4 | bits);
                    revcode += 1 << bits;
                }while (revcode < treeLen);
            }
            nextCode[bits] = code + (1 << 16 - bits);
        }
        return tree;
    };
    /// <summary>
    /// Builds huffman tree from array of code lengths.
    /// </summary>
    /// <param name="lengths">Array of code lengths.</param>
    DecompressorHuffmanTree.prototype.buildTree = function(lengths) {
        // Count of codes for each code length.
        var blCount = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        // Numerical value of the smallest code for each code length.
        var nextCode = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var prepareData = this.prepareData(blCount, nextCode, lengths);
        this.m_Tree = this.treeFromData(blCount, nextCode, lengths, prepareData.code, prepareData.treeSize);
    };
    /// <summary>
    /// Reads and decompresses one symbol.
    /// </summary>
    /// <param name="input"></param>
    /// <returns></returns>
    DecompressorHuffmanTree.prototype.unpackSymbol = function(input) {
        var lookahead;
        var symbol;
        if ((lookahead = input.peekBits(9)) >= 0) {
            if ((symbol = this.m_Tree[lookahead]) >= 0) {
                input.skipBits(symbol & 15);
                return symbol >> 4;
            }
            var subtree = -(symbol >> 4);
            var bitlen = symbol & 15;
            if ((lookahead = input.peekBits(bitlen)) >= 0) {
                symbol = this.m_Tree[subtree | lookahead >> 9];
                input.skipBits(symbol & 15);
                return symbol >> 4;
            } else {
                var bits = input.availableBits;
                lookahead = input.peekBits(bits);
                symbol = this.m_Tree[subtree | lookahead >> 9];
                if ((symbol & 15) <= bits) {
                    input.skipBits(symbol & 15);
                    return symbol >> 4;
                } else return -1;
            }
        } else {
            var bits = input.availableBits;
            lookahead = input.peekBits(bits);
            symbol = this.m_Tree[lookahead];
            if (symbol >= 0 && (symbol & 15) <= bits) {
                input.skipBits(symbol & 15);
                return symbol >> 4;
            } else return -1;
        }
    };
    Object.defineProperty(DecompressorHuffmanTree, "lengthTree", {
        /// <summary>
        /// GET huffman tree for encoding and decoding lengths.
        /// </summary>
        get: function() {
            return this.m_LengthTree;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecompressorHuffmanTree, "distanceTree", {
        /// <summary>
        /// GET huffman tree for encoding and decoding distances.
        /// </summary>
        get: function() {
            return this.m_DistanceTree;
        },
        enumerable: true,
        configurable: true
    });
    /// <summary>
    /// Maximum count of bits.
    /// </summary>
    DecompressorHuffmanTree.MAX_BITLEN = 15;
    return DecompressorHuffmanTree;
}();
 /* eslint-enable */ 


/* eslint-disable */ /// <summary>
/// Checksum calculator, based on Adler32 algorithm.
/// </summary>
var $a7c42dfe2eed33b1$export$903dab4681b04bb6 = /** @class */ function() {
    function ChecksumCalculator() {}
    /// <summary>
    /// Updates checksum by calculating checksum of the
    /// given buffer and adding it to current value.
    /// </summary>
    /// <param name="checksum">Current checksum.</param>
    /// <param name="buffer">Data byte array.</param>
    /// <param name="offset">Offset in the buffer.</param>
    /// <param name="length">Length of data to be used from the stream.</param>
    ChecksumCalculator.ChecksumUpdate = function(checksum, buffer, offset, length) {
        var checkSumUInt = checksum;
        var s1 = checkSumUInt & 65535;
        var s2 = checkSumUInt >> this.DEF_CHECKSUM_BIT_OFFSET;
        while(length > 0){
            var steps = Math.min(length, this.DEF_CHECKSUM_ITERATIONSCOUNT);
            length -= steps;
            while(--steps >= 0){
                s1 = s1 + (buffer[offset++] & 255);
                s2 = s2 + s1;
            }
            s1 %= this.DEF_CHECKSUM_BASE;
            s2 %= this.DEF_CHECKSUM_BASE;
        }
        checkSumUInt = s2 << this.DEF_CHECKSUM_BIT_OFFSET | s1;
        checksum = checkSumUInt;
    };
    /// <summary>
    /// Generates checksum by calculating checksum of the
    /// given buffer.
    /// </summary>
    /// <param name="buffer">Data byte array.</param>
    /// <param name="offset">Offset in the buffer.</param>
    /// <param name="length">Length of data to be used from the stream.</param>
    ChecksumCalculator.ChecksumGenerate = function(buffer, offset, length) {
        var result = 1;
        ChecksumCalculator.ChecksumUpdate(result, buffer, offset, length);
        return result;
    };
    /// <summary>
    /// Bits offset, used in adler checksum calculation.
    /// </summary>
    ChecksumCalculator.DEF_CHECKSUM_BIT_OFFSET = 16;
    /// <summary>
    /// Lagrest prime, less than 65535
    /// </summary>
    ChecksumCalculator.DEF_CHECKSUM_BASE = 65521;
    /// <summary>
    /// Count of iteration used in calculated of the adler checksumm.
    /// </summary>
    ChecksumCalculator.DEF_CHECKSUM_ITERATIONSCOUNT = 3800;
    return ChecksumCalculator;
}();
 /* eslint-enable */ 

var $a089c8693a234160$export$f9c1d364098b1462 = /** @class */ function() {
    function CompressedStreamReader(stream, bNoWrap) {
        /// <summary>
        /// Code lengths for the code length alphabet.
        /// </summary>
        this.defaultHuffmanDynamicTree = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ];
        /// <summary>
        /// Mask for compression method to be decoded from 16-bit header.
        /// </summary>
        this.DEF_HEADER_METHOD_MASK = 3840;
        /// <summary>
        /// Mask for compression info to be decoded from 16-bit header.
        /// </summary>
        this.DEF_HEADER_INFO_MASK = 61440;
        /// <summary>
        /// Mask for check bits to be decoded from 16-bit header.
        /// </summary>
        this.DEF_HEADER_FLAGS_FCHECK = 31;
        /// <summary>
        /// Mask for dictionary presence to be decoded from 16-bit header.
        /// </summary>
        this.DEF_HEADER_FLAGS_FDICT = 32;
        /// <summary>
        /// Mask for compression level to be decoded from 16-bit header.
        /// </summary>
        this.DEF_HEADER_FLAGS_FLEVEL = 192;
        /// <summary>
        /// Maximum size of the data window.
        /// </summary>
        this.DEF_MAX_WINDOW_SIZE = 65535;
        /// <summary>
        /// Maximum length of the repeatable block.
        /// </summary>
        this.DEF_HUFFMAN_REPEATE_MAX = 258;
        /// <summary>
        /// End of the block sign.
        /// </summary>
        this.DEF_HUFFMAN_END_BLOCK = 256;
        /// <summary>
        /// Minimal length code.
        /// </summary>
        this.DEF_HUFFMAN_LENGTH_MINIMUMCODE = 257;
        /// <summary>
        /// Maximal length code.
        /// </summary>
        this.DEF_HUFFMAN_LENGTH_MAXIMUMCODE = 285;
        /// <summary>
        /// Maximal distance code.
        /// </summary>
        this.DEF_HUFFMAN_DISTANCE_MAXIMUMCODE = 29;
        /// <summary>
        /// Currently calculated checksum,
        /// based on Adler32 algorithm.
        /// </summary>
        this.mCheckSum = 1;
        /// <summary>
        /// Currently read 4 bytes.
        /// </summary>
        this.tBuffer = 0;
        /// <summary>
        /// Count of bits that are in buffer.
        /// </summary>
        this.mBufferedBits = 0;
        /// <summary>
        /// Temporary buffer.
        /// </summary>
        this.mTempBuffer = new Uint8Array(4);
        /// <summary>
        /// 32k buffer for unpacked data.
        /// </summary>
        this.mBlockBuffer = new Uint8Array(this.DEF_MAX_WINDOW_SIZE);
        /// <summary>
        /// No wrap mode.
        /// </summary>
        this.mbNoWrap = false;
        /// <summary>
        /// Window size, can not be larger than 32k.
        /// </summary>
        this.mWindowSize = 0;
        /// <summary>
        /// Current position in output stream.
        /// Current in-block position can be extracted by applying Int16.MaxValue mask.
        /// </summary>
        this.mCurrentPosition = 0;
        /// <summary>
        /// Data length.
        /// Current in-block position can be extracted by applying Int16.MaxValue mask.
        /// </summary>
        this.mDataLength = 0;
        /// <summary>
        /// Specifies wheather next block can to be read.
        /// Reading can be denied because the header of the last block have been read.
        /// </summary>
        this.mbCanReadNextBlock = true;
        /// <summary>
        /// Specifies wheather user can read more data from stream.
        /// </summary>
        this.mbCanReadMoreData = true;
        /// <summary>
        /// Specifies wheather checksum has been read.
        /// </summary>
        this.mbCheckSumRead = false;
        if (stream == null) throw new DOMException("stream");
        if (stream.length === 0) throw new DOMException("stream - string can not be empty");
        (0, $04fb74d0ebaebcd6$export$12c70882ce25e356).init();
        this.mInputStream = new $a089c8693a234160$export$6a4eb2e7fc9e8903(stream);
        this.mbNoWrap = bNoWrap;
        if (!this.mbNoWrap) this.readZLibHeader();
        this.decodeBlockHeader();
    }
    Object.defineProperty(CompressedStreamReader.prototype, "mBuffer", {
        get: function() {
            return this.tBuffer;
        },
        set: function(value) {
            this.tBuffer = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initializes compressor and writes ZLib header if needed.
     * @param {boolean} noWrap - optional if true, ZLib header and checksum will not be written.
     */ /// <summary>
    /// Reads specified count of bits without adjusting position.
    /// </summary>
    /// <param name="count">Count of bits to be read.</param>
    /// <returns>Read value.</returns>
    CompressedStreamReader.prototype.peekBits = function(count) {
        if (count < 0) throw new DOMException("count", "Bits count can not be less than zero.");
        if (count > 32) throw new DOMException("count", "Count of bits is too large.");
        // If buffered data is not enough to give result,
        // fill buffer.
        if (this.mBufferedBits < count) this.fillBuffer();
        // If you want to read 4 bytes and there is partial data in
        // buffer, than you will fail.
        if (this.mBufferedBits < count) return -1;
        // Create bitmask for reading of count bits
        var bitMask = ~(4294967295 << count);
        var result = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterUintToInt32(this.mBuffer & bitMask);
        //Debug.WriteLine( /*new string( ' ', 32 - mBufferedBits + (int)( ( 32 - mBufferedBits ) / 8 ) ) + BitsToString( (int)mBuffer, mBufferedBits ) + " " + BitsToString( result, count ) +*/ " " + result.ToString() );
        return result;
    };
    CompressedStreamReader.prototype.fillBuffer = function() {
        var length = 4 - (this.mBufferedBits >> 3) - ((this.mBufferedBits & 7) !== 0 ? 1 : 0);
        if (length === 0) return;
        //TODO: fix this
        var bytesRead = this.mInputStream.read(this.mTempBuffer, 0, length);
        for(var i = 0; i < bytesRead; i++){
            this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer | (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mTempBuffer[i] << this.mBufferedBits));
            this.mBufferedBits += 8;
        }
    //TODO: fix this
    };
    /// <summary>
    /// Skips specified count of bits.
    /// </summary>
    /// <param name="count">Count of bits to be skipped.</param>
    CompressedStreamReader.prototype.skipBits = function(count) {
        if (count < 0) throw new DOMException("count", "Bits count can not be less than zero.");
        if (count === 0) return;
        if (count >= this.mBufferedBits) {
            count -= this.mBufferedBits;
            this.mBufferedBits = 0;
            this.mBuffer = 0;
            // if something left, skip it.
            if (count > 0) {
                // Skip entire bytes.
                this.mInputStream.position += count >> 3; //TODO: fix this
                count &= 7;
                // Skip bits.
                if (count > 0) {
                    this.fillBuffer();
                    this.mBufferedBits -= count;
                    this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer >>> count);
                }
            }
        } else {
            this.mBufferedBits -= count;
            this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer >>> count);
        }
    };
    Object.defineProperty(CompressedStreamReader.prototype, "availableBits", {
        get: function() {
            return this.mBufferedBits;
        },
        enumerable: true,
        configurable: true
    });
    /// <summary>
    /// Reads ZLib header with compression method and flags.
    /// </summary>
    CompressedStreamReader.prototype.readZLibHeader = function() {
        // first 8 bits - compression Method and flags
        // 8 other - flags
        var header = this.readInt16();
        //Debug.WriteLine( BitsToString( header ) );
        if (header === -1) throw new DOMException("Header of the stream can not be read.");
        if (header % 31 !== 0) throw new DOMException("Header checksum illegal");
        if ((header & this.DEF_HEADER_METHOD_MASK) !== 2048) throw new DOMException("Unsupported compression method.");
        this.mWindowSize = Math.pow(2, ((header & this.DEF_HEADER_INFO_MASK) >> 12) + 8);
        if (this.mWindowSize > 65535) throw new DOMException("Unsupported window size for deflate compression method.");
        if ((header & this.DEF_HEADER_FLAGS_FDICT) >> 5 === 1) // Get dictionary.
        throw new DOMException("Custom dictionary is not supported at the moment.");
    };
    /// <summary>
    /// TODO: place correct comment here
    /// </summary>
    /// <returns>
    /// TODO: place correct comment here
    /// </returns>
    CompressedStreamReader.prototype.readInt16 = function() {
        var result = this.readBits(8) << 8;
        result |= this.readBits(8);
        return result;
    };
    /// <summary>
    /// Reads specified count of bits from stream.
    /// </summary>
    /// <param name="count">Count of bits to be read.</param>
    /// <returns>
    /// TODO: place correct comment here
    /// </returns>
    CompressedStreamReader.prototype.readBits = function(count) {
        var result = this.peekBits(count);
        if (result === -1) return -1;
        this.mBufferedBits -= count;
        this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer >>> count);
        return result;
    };
    /// <summary>
    /// Reads and decodes block of data.
    /// </summary>
    /// <returns>True if buffer was empty and new data was read, otherwise - False.</returns>
    CompressedStreamReader.prototype.decodeBlockHeader = function() {
        if (!this.mbCanReadNextBlock) return false;
        var bFinalBlock = this.readBits(1);
        if (bFinalBlock === -1) return false;
        var blockType = this.readBits(2);
        if (blockType === -1) return false;
        this.mbCanReadNextBlock = bFinalBlock === 0;
        //      ChecksumReset();
        switch(blockType){
            case 0:
                // Uncompressed data
                this.mbReadingUncompressed = true;
                this.skipToBoundary();
                var length_1 = this.readInt16Inverted();
                var lengthComplement = this.readInt16Inverted();
                if (length_1 !== (lengthComplement ^ 0xffff)) throw new DOMException("Wrong block length.");
                if (length_1 > 65535) throw new DOMException("Uncompressed block length can not be more than 65535.");
                this.mUncompressedDataLength = length_1;
                this.mCurrentLengthTree = null;
                this.mCurrentDistanceTree = null;
                break;
            case 1:
                // Compressed data with fixed huffman codes.
                this.mbReadingUncompressed = false;
                this.mUncompressedDataLength = -1;
                this.mCurrentLengthTree = (0, $04fb74d0ebaebcd6$export$12c70882ce25e356).lengthTree;
                this.mCurrentDistanceTree = (0, $04fb74d0ebaebcd6$export$12c70882ce25e356).distanceTree;
                break;
            case 2:
                // Compressed data with dynamic huffman codes.
                this.mbReadingUncompressed = false;
                this.mUncompressedDataLength = -1;
                var trees = this.decodeDynamicHeader(this.mCurrentLengthTree, this.mCurrentDistanceTree);
                this.mCurrentLengthTree = trees.lengthTree;
                this.mCurrentDistanceTree = trees.distanceTree;
                break;
            default:
                throw new DOMException("Wrong block type.");
        }
        return true;
    };
    /// <summary>
    /// Discards left-most partially used byte.
    /// </summary>
    CompressedStreamReader.prototype.skipToBoundary = function() {
        this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer >>> (this.mBufferedBits & 7));
        this.mBufferedBits &= -8;
    };
    /// <summary>
    /// TODO: place correct comment here
    /// </summary>
    /// <returns>
    /// TODO: place correct comment here
    /// </returns>
    CompressedStreamReader.prototype.readInt16Inverted = function() {
        var result = this.readBits(8);
        result |= this.readBits(8) << 8;
        return result;
    };
    /// <summary>
    /// Reades dynamic huffman codes from block header.
    /// </summary>
    /// <param name="lengthTree">Literals/Lengths tree.</param>
    /// <param name="distanceTree">Distances tree.</param>
    CompressedStreamReader.prototype.decodeDynamicHeader = function(lengthTree, distanceTree) {
        var bLastSymbol = 0;
        var iLengthsCount = this.readBits(5);
        var iDistancesCount = this.readBits(5);
        var iCodeLengthsCount = this.readBits(4);
        if (iLengthsCount < 0 || iDistancesCount < 0 || iCodeLengthsCount < 0) throw new DOMException("Wrong dynamic huffman codes.");
        iLengthsCount += 257;
        iDistancesCount += 1;
        var iResultingCodeLengthsCount = iLengthsCount + iDistancesCount;
        var arrResultingCodeLengths = new Uint8Array(iResultingCodeLengthsCount);
        var arrDecoderCodeLengths = new Uint8Array(19);
        iCodeLengthsCount += 4;
        var iCurrentCode = 0;
        while(iCurrentCode < iCodeLengthsCount){
            var len = this.readBits(3);
            if (len < 0) throw new DOMException("Wrong dynamic huffman codes.");
            arrDecoderCodeLengths[this.defaultHuffmanDynamicTree[iCurrentCode++]] = len;
        }
        var treeInternalDecoder = new (0, $04fb74d0ebaebcd6$export$12c70882ce25e356)(arrDecoderCodeLengths);
        iCurrentCode = 0;
        for(;;){
            var symbol = void 0;
            var bNeedBreak = false;
            symbol = treeInternalDecoder.unpackSymbol(this);
            while((symbol & -16) === 0){
                arrResultingCodeLengths[iCurrentCode++] = bLastSymbol = symbol;
                if (iCurrentCode === iResultingCodeLengthsCount) {
                    bNeedBreak = true;
                    break;
                }
                symbol = treeInternalDecoder.unpackSymbol(this);
            }
            if (bNeedBreak) break;
            if (symbol < 0) throw new DOMException("Wrong dynamic huffman codes.");
            if (symbol >= 17) bLastSymbol = 0;
            else if (iCurrentCode === 0) throw new DOMException("Wrong dynamic huffman codes.");
            var miRepSymbol = symbol - 16;
            var bits = CompressedStreamReader.DEF_HUFFMAN_DYNTREE_REPEAT_BITS[miRepSymbol];
            var count = this.readBits(bits);
            if (count < 0) throw new DOMException("Wrong dynamic huffman codes.");
            count += CompressedStreamReader.DEF_HUFFMAN_DYNTREE_REPEAT_MINIMUMS[miRepSymbol];
            if (iCurrentCode + count > iResultingCodeLengthsCount) throw new DOMException("Wrong dynamic huffman codes.");
            while(count-- > 0)arrResultingCodeLengths[iCurrentCode++] = bLastSymbol;
            if (iCurrentCode === iResultingCodeLengthsCount) break;
        }
        var tempArray = new Uint8Array(iLengthsCount);
        tempArray.set(arrResultingCodeLengths.subarray(0, iLengthsCount), 0);
        //sourceArray, sourceIndex, destinationArray, destinationIndex, length
        //Array.copy( arrResultingCodeLengths, 0, tempArray, 0, iLengthsCount );
        lengthTree = new (0, $04fb74d0ebaebcd6$export$12c70882ce25e356)(tempArray);
        tempArray = arrResultingCodeLengths.slice(iLengthsCount, iLengthsCount + iDistancesCount);
        //Array.copy( arrResultingCodeLengths, iLengthsCount, tempArray, 0, iDistancesCount );
        distanceTree = new (0, $04fb74d0ebaebcd6$export$12c70882ce25e356)(tempArray);
        return {
            "lengthTree": lengthTree,
            "distanceTree": distanceTree
        };
    };
    /// <summary>
    /// Decodes huffman codes.
    /// </summary>
    /// <returns>True if some data was read.</returns>
    CompressedStreamReader.prototype.readHuffman = function() {
        var free = this.DEF_MAX_WINDOW_SIZE - (this.mDataLength - this.mCurrentPosition);
        var dataRead = false;
        //long maxdistance = DEF_MAX_WINDOW_SIZE >> 1;
        var readdata = {};
        // DEF_HUFFMAN_REPEATE_MAX - longest repeatable block, we should always reserve space for it because
        // if we should not, we will have buffer overrun.
        while(free >= this.DEF_HUFFMAN_REPEATE_MAX){
            var symbol = void 0;
            symbol = this.mCurrentLengthTree.unpackSymbol(this);
            // Only codes 0..255 are valid independent symbols.
            while((symbol & -256) === 0){
                readdata[(this.mDataLength + 1) % this.DEF_MAX_WINDOW_SIZE] = symbol;
                this.mBlockBuffer[this.mDataLength++ % this.DEF_MAX_WINDOW_SIZE] = symbol;
                dataRead = true;
                if (--free < this.DEF_HUFFMAN_REPEATE_MAX) return true;
                //if( (mDataLength - mCurrentPosition ) < maxdistance ) return true;
                symbol = this.mCurrentLengthTree.unpackSymbol(this);
            }
            if (symbol < this.DEF_HUFFMAN_LENGTH_MINIMUMCODE) {
                if (symbol < this.DEF_HUFFMAN_END_BLOCK) throw new DOMException("Illegal code.");
                var numDataRead = dataRead ? 1 : 0;
                this.mbCanReadMoreData = this.decodeBlockHeader();
                var numReadMore = this.mbCanReadMoreData ? 1 : 0;
                return numDataRead | numReadMore ? true : false;
            }
            if (symbol > this.DEF_HUFFMAN_LENGTH_MAXIMUMCODE) throw new DOMException("Illegal repeat code length.");
            var iRepeatLength = CompressedStreamReader.DEF_HUFFMAN_REPEAT_LENGTH_BASE[symbol - this.DEF_HUFFMAN_LENGTH_MINIMUMCODE];
            var iRepeatExtraBits = CompressedStreamReader.DEF_HUFFMAN_REPEAT_LENGTH_EXTENSION[symbol - this.DEF_HUFFMAN_LENGTH_MINIMUMCODE];
            if (iRepeatExtraBits > 0) {
                var extra = this.readBits(iRepeatExtraBits);
                if (extra < 0) throw new DOMException("Wrong data.");
                iRepeatLength += extra;
            }
            // Unpack repeat distance.
            symbol = this.mCurrentDistanceTree.unpackSymbol(this);
            if (symbol < 0 || symbol > CompressedStreamReader.DEF_HUFFMAN_REPEAT_DISTANCE_BASE.length) throw new DOMException("Wrong distance code.");
            var iRepeatDistance = CompressedStreamReader.DEF_HUFFMAN_REPEAT_DISTANCE_BASE[symbol];
            iRepeatExtraBits = CompressedStreamReader.DEF_HUFFMAN_REPEAT_DISTANCE_EXTENSION[symbol];
            if (iRepeatExtraBits > 0) {
                var extra = this.readBits(iRepeatExtraBits);
                if (extra < 0) throw new DOMException("Wrong data.");
                iRepeatDistance += extra;
            }
            // Copy data in slow repeat mode
            for(var i = 0; i < iRepeatLength; i++){
                this.mBlockBuffer[this.mDataLength % this.DEF_MAX_WINDOW_SIZE] = this.mBlockBuffer[(this.mDataLength - iRepeatDistance) % this.DEF_MAX_WINDOW_SIZE];
                this.mDataLength++;
                free--;
            }
            dataRead = true;
        }
        return dataRead;
    };
    /// <summary>
    /// Reads data to buffer.
    /// </summary>
    /// <param name="buffer">Output buffer for data.</param>
    /// <param name="offset">Offset in output data.</param>
    /// <param name="length">Length of the data to be read.</param>
    /// <returns>Count of bytes actually read.</returns>
    CompressedStreamReader.prototype.read = function(buffer, offset, length) {
        if (buffer == null) throw new DOMException("buffer");
        if (offset < 0 || offset > buffer.length - 1) throw new DOMException("offset", "Offset does not belong to specified buffer.");
        if (length < 0 || length > buffer.length - offset) throw new DOMException("length", "Length is illegal.");
        var initialLength = length;
        while(length > 0)// Read from internal buffer.
        if (this.mCurrentPosition < this.mDataLength) {
            // Position in buffer array.
            var inBlockPosition = this.mCurrentPosition % this.DEF_MAX_WINDOW_SIZE;
            // We can not read more than we have in buffer at once,
            // and we not read more than till the array end.
            var dataToCopy = Math.min(this.DEF_MAX_WINDOW_SIZE - inBlockPosition, this.mDataLength - this.mCurrentPosition);
            // Reading not more, than the rest of the buffer.
            dataToCopy = Math.min(dataToCopy, length);
            //sourceArray, sourceIndex, destinationArray, destinationIndex, length
            // Copy data.
            //Array.Copy( mBlockBuffer, inBlockPosition, buffer, offset, dataToCopy );
            //buffer.set(this.mBlockBuffer.slice(inBlockPosition, dataToCopy), offset);
            (0, $f67072eb46bd887e$export$d2ca453b913dcdea).arrayCopy(this.mBlockBuffer, inBlockPosition, buffer, offset, dataToCopy);
            // Correct position, length,
            this.mCurrentPosition += dataToCopy;
            offset += dataToCopy;
            length -= dataToCopy;
        } else {
            if (!this.mbCanReadMoreData) break;
            var oldDataLength = this.mDataLength;
            if (!this.mbReadingUncompressed) {
                if (!this.readHuffman()) break;
            } else if (this.mUncompressedDataLength === 0) {
                // If there is no more data in stream, just exit.
                this.mbCanReadMoreData = this.decodeBlockHeader();
                if (!this.mbCanReadMoreData) break;
            } else {
                // Position of the data end in block buffer.
                var inBlockPosition = this.mDataLength % this.DEF_MAX_WINDOW_SIZE;
                var dataToRead = Math.min(this.mUncompressedDataLength, this.DEF_MAX_WINDOW_SIZE - inBlockPosition);
                var dataRead = this.readPackedBytes(this.mBlockBuffer, inBlockPosition, dataToRead);
                if (dataToRead !== dataRead) throw new DOMException("Not enough data in stream.");
                this.mUncompressedDataLength -= dataRead;
                this.mDataLength += dataRead;
            }
            if (oldDataLength < this.mDataLength) {
                var start = oldDataLength % this.DEF_MAX_WINDOW_SIZE;
                var end = this.mDataLength % this.DEF_MAX_WINDOW_SIZE;
                if (start < end) this.checksumUpdate(this.mBlockBuffer, start, end - start);
                else {
                    this.checksumUpdate(this.mBlockBuffer, start, this.DEF_MAX_WINDOW_SIZE - start);
                    if (end > 0) this.checksumUpdate(this.mBlockBuffer, 0, end);
                }
            }
        }
        if (!this.mbCanReadMoreData && !this.mbCheckSumRead && !this.mbNoWrap) {
            this.skipToBoundary();
            var checkSum = this.readInt32();
            //Debug.Assert( checkSum == mCheckSum, "" );
            if (checkSum !== this.mCheckSum) throw new DOMException("Checksum check failed.");
            this.mbCheckSumRead = true;
        }
        return initialLength - length;
    };
    /// <summary>
    /// Reads array of bytes.
    /// </summary>
    /// <param name="buffer">Output buffer.</param>
    /// <param name="offset">Offset in output buffer.</param>
    /// <param name="length">Length of the data to be read.</param>
    /// <returns>Count of bytes actually read to the buffer.</returns>
    CompressedStreamReader.prototype.readPackedBytes = function(buffer, offset, length) {
        if (buffer == null) throw new DOMException("buffer");
        if (offset < 0 || offset > buffer.length - 1) throw new DOMException('offset", "Offset can not be less than zero or greater than buffer length - 1.');
        if (length < 0) throw new DOMException('length", "Length can not be less than zero.');
        if (length > buffer.length - offset) throw new DOMException('length", "Length is too large.');
        if ((this.mBufferedBits & 7) !== 0) throw new DOMException("Reading of unalligned data is not supported.");
        if (length === 0) return 0;
        var result = 0;
        while(this.mBufferedBits > 0 && length > 0){
            buffer[offset++] = this.mBuffer;
            this.mBufferedBits -= 8;
            this.mBuffer = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterInt32ToUint(this.mBuffer >>> 8);
            length--;
            result++;
        }
        if (length > 0) //TODO: Fix this.
        result += this.mInputStream.read(buffer, offset, length);
        return result;
    };
    /// <summary>
    /// TODO: place correct comment here
    /// </summary>
    /// <returns>
    /// TODO: place correct comment here
    /// </returns>
    CompressedStreamReader.prototype.readInt32 = function() {
        var result = this.readBits(8) << 24;
        result |= this.readBits(8) << 16;
        result |= this.readBits(8) << 8;
        result |= this.readBits(8);
        return result;
    };
    /// <summary>
    /// Updates checksum by calculating checksum of the
    /// given buffer and adding it to current value.
    /// </summary>
    /// <param name="buffer">Data byte array.</param>
    /// <param name="offset">Offset in the buffer.</param>
    /// <param name="length">Length of data to be used from the stream.</param>
    CompressedStreamReader.prototype.checksumUpdate = function(buffer, offset, length) {
        (0, $a7c42dfe2eed33b1$export$903dab4681b04bb6).ChecksumUpdate(this.mCheckSum, buffer, offset, length);
    };
    CompressedStreamReader.DEF_REVERSE_BITS = new Uint8Array([
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ]);
    /// <summary>
    /// Minimum count of repetions.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_DYNTREE_REPEAT_MINIMUMS = [
        3,
        3,
        11
    ];
    /// <summary>
    /// Bits, that responds for different repetion modes.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_DYNTREE_REPEAT_BITS = [
        2,
        3,
        7
    ];
    /// <summary>
    /// Length bases.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_REPEAT_LENGTH_BASE = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /// <summary>
    /// Length extended bits count.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_REPEAT_LENGTH_EXTENSION = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        0
    ];
    /// <summary>
    /// Distance bases.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_REPEAT_DISTANCE_BASE = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    /// <summary>
    /// Distance extanded bits count.
    /// </summary>
    CompressedStreamReader.DEF_HUFFMAN_REPEAT_DISTANCE_EXTENSION = [
        0,
        0,
        0,
        0,
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        5,
        5,
        6,
        6,
        7,
        7,
        8,
        8,
        9,
        9,
        10,
        10,
        11,
        11,
        12,
        12,
        13,
        13
    ];
    return CompressedStreamReader;
}();
var $a089c8693a234160$export$6a4eb2e7fc9e8903 = /** @class */ function() {
    function Stream(input) {
        this.position = 0;
        this.inputStream = new Uint8Array(input.buffer);
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.inputStream.buffer.byteLength;
        },
        enumerable: true,
        configurable: true
    });
    Stream.prototype.read = function(buffer, start, length) {
        var temp = new Uint8Array(this.inputStream.buffer, this.position + start);
        var data = temp.subarray(0, length);
        buffer.set(data, 0);
        this.position += data.byteLength;
        return data.byteLength;
    };
    Stream.prototype.readByte = function() {
        return this.inputStream[this.position++];
    };
    Stream.prototype.write = function(inputBuffer, offset, count) {
        (0, $f67072eb46bd887e$export$d2ca453b913dcdea).arrayCopy(inputBuffer, 0, this.inputStream, this.position + offset, count);
        // this.inputStream = new Uint8Array(this.inputStream.buffer, this.position + offset);
        // this.inputStream.set(inputBuffer, offset);
        this.position += count;
    };
    Stream.prototype.toByteArray = function() {
        return new Uint8Array(this.inputStream.buffer);
    };
    return Stream;
}();
 /* eslint-enable */ 
/* eslint-disable */ /**
 * Encoding class: Contains the details about encoding type, whether to write a Unicode byte order mark (BOM).
 * ```typescript
 * let encoding : Encoding = new Encoding();
 * encoding.type = 'Utf8';
 * encoding.getBytes('Encoding', 0, 5);
 * ```
 */ var $d16335ea6d5a8183$export$72958ca7c468c63b = /** @class */ function() {
    /**
     * Initializes a new instance of the Encoding class. A parameter specifies whether to write a Unicode byte order mark
     * @param  {boolean} includeBom?-true to specify that a Unicode byte order mark is written; otherwise, false.
     */ function Encoding(includeBom) {
        this.emitBOM = true;
        this.encodingType = "Ansi";
        this.initBOM(includeBom);
    }
    Object.defineProperty(Encoding.prototype, "includeBom", {
        /**
         * Gets a value indicating whether to write a Unicode byte order mark
         * @returns boolean- true to specify that a Unicode byte order mark is written; otherwise, false
         */ get: function() {
            return this.emitBOM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Encoding.prototype, "type", {
        /**
         * Gets the encoding type.
         * @returns EncodingType
         */ get: function() {
            return this.encodingType;
        },
        /**
         * Sets the encoding type.
         * @param  {EncodingType} value
         */ set: function(value) {
            this.encodingType = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initialize the includeBom to emit BOM or Not
     * @param  {boolean} includeBom
     */ Encoding.prototype.initBOM = function(includeBom) {
        if (includeBom === undefined || includeBom === null) this.emitBOM = true;
        else this.emitBOM = includeBom;
    };
    /**
     * Calculates the number of bytes produced by encoding the characters in the specified string
     * @param  {string} chars - The string containing the set of characters to encode
     * @returns {number} - The number of bytes produced by encoding the specified characters
     */ Encoding.prototype.getByteCount = function(chars) {
        var byteCount = 0;
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(chars, "string");
        if (chars === "") {
            var byte = this.utf8Len(chars.charCodeAt(0));
            return byte;
        }
        if (this.type === null || this.type === undefined) this.type = "Ansi";
        return this.getByteCountInternal(chars, 0, chars.length);
    };
    /**
     * Return the Byte of character
     * @param  {number} codePoint
     * @returns {number}
     */ Encoding.prototype.utf8Len = function(codePoint) {
        var bytes = codePoint <= 0x7F ? 1 : codePoint <= 0x7FF ? 2 : codePoint <= 0xFFFF ? 3 : codePoint <= 0x1FFFFF ? 4 : 0;
        return bytes;
    };
    /**
     * for 4 byte character return surrogate pair true, otherwise false
     * @param  {number} codeUnit
     * @returns {boolean}
     */ Encoding.prototype.isHighSurrogate = function(codeUnit) {
        return codeUnit >= 0xD800 && codeUnit <= 0xDBFF;
    };
    /**
     * for 4byte character generate the surrogate pair
     * @param  {number} highCodeUnit
     * @param  {number} lowCodeUnit
     */ Encoding.prototype.toCodepoint = function(highCodeUnit, lowCodeUnit) {
        highCodeUnit = (0x3FF & highCodeUnit) << 10;
        var u = highCodeUnit | 0x3FF & lowCodeUnit;
        return u + 0x10000;
    };
    /**
     * private method to get the byte count for specific charindex and count
     * @param  {string} chars
     * @param  {number} charIndex
     * @param  {number} charCount
     */ Encoding.prototype.getByteCountInternal = function(chars, charIndex, charCount) {
        var byteCount = 0;
        if (this.encodingType === "Utf8" || this.encodingType === "Unicode") {
            var isUtf8 = this.encodingType === "Utf8";
            for(var i = 0; i < charCount; i++){
                var charCode = chars.charCodeAt(isUtf8 ? charIndex : charIndex++);
                if (this.isHighSurrogate(charCode)) {
                    if (isUtf8) {
                        var high = charCode;
                        var low = chars.charCodeAt(++charIndex);
                        byteCount += this.utf8Len(this.toCodepoint(high, low));
                    } else {
                        byteCount += 4;
                        ++i;
                    }
                } else if (isUtf8) byteCount += this.utf8Len(charCode);
                else byteCount += 2;
                if (isUtf8) charIndex++;
            }
            return byteCount;
        } else {
            byteCount = charCount;
            return byteCount;
        }
    };
    /**
     * Encodes a set of characters from the specified string into the ArrayBuffer.
     * @param  {string} s- The string containing the set of characters to encode
     * @param  {number} charIndex-The index of the first character to encode.
     * @param  {number} charCount- The number of characters to encode.
     * @returns {ArrayBuffer} - The ArrayBuffer that contains the resulting sequence of bytes.
     */ Encoding.prototype.getBytes = function(s, charIndex, charCount) {
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(s, "string");
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(charIndex, "charIndex");
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(charCount, "charCount");
        if (charIndex < 0 || charCount < 0) throw new RangeError("Argument Out Of Range Exception: charIndex or charCount is less than zero");
        if (s.length - charIndex < charCount) throw new RangeError("Argument Out Of Range Exception: charIndex and charCount do not denote a valid range in string");
        var bytes;
        if (s === "") {
            bytes = new ArrayBuffer(0);
            return bytes;
        }
        if (this.type === null || this.type === undefined) this.type = "Ansi";
        var byteCount = this.getByteCountInternal(s, charIndex, charCount);
        switch(this.type){
            case "Utf8":
                bytes = this.getBytesOfUtf8Encoding(byteCount, s, charIndex, charCount);
                return bytes;
            case "Unicode":
                bytes = this.getBytesOfUnicodeEncoding(byteCount, s, charIndex, charCount);
                return bytes;
            default:
                bytes = this.getBytesOfAnsiEncoding(byteCount, s, charIndex, charCount);
                return bytes;
        }
    };
    /**
     * Decodes a sequence of bytes from the specified ArrayBuffer into the string.
     * @param  {ArrayBuffer} bytes- The ArrayBuffer containing the sequence of bytes to decode.
     * @param  {number} index- The index of the first byte to decode.
     * @param  {number} count- The number of bytes to decode.
     * @returns {string} - The string that contains the resulting set of characters.
     */ Encoding.prototype.getString = function(bytes, index, count) {
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(bytes, "bytes");
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(index, "index");
        $d16335ea6d5a8183$export$923fbdaad5ed00bc(count, "count");
        if (index < 0 || count < 0) throw new RangeError("Argument Out Of Range Exception: index or count is less than zero");
        if (bytes.byteLength - index < count) throw new RangeError("Argument Out Of Range Exception: index and count do not denote a valid range in bytes");
        if (bytes.byteLength === 0 || count === 0) return "";
        if (this.type === null || this.type === undefined) this.type = "Ansi";
        var out = "";
        var byteCal = new Uint8Array(bytes);
        switch(this.type){
            case "Utf8":
                var s = this.getStringOfUtf8Encoding(byteCal, index, count);
                return s;
            case "Unicode":
                var byteUnicode = new Uint16Array(bytes);
                out = this.getStringofUnicodeEncoding(byteUnicode, index, count);
                return out;
            default:
                var j = index;
                for(var i = 0; i < count; i++){
                    var c = byteCal[j];
                    out += String.fromCharCode(c); // 1 byte(ASCII) character                  
                    j++;
                }
                return out;
        }
    };
    Encoding.prototype.getBytesOfAnsiEncoding = function(byteCount, s, charIndex, charCount) {
        var bytes = new ArrayBuffer(byteCount);
        var bufview = new Uint8Array(bytes);
        var k = 0;
        for(var i = 0; i < charCount; i++){
            var charcode = s.charCodeAt(charIndex++);
            if (charcode < 0x800) bufview[k] = charcode;
            else bufview[k] = 63; //replacement character '?'
            k++;
        }
        return bytes;
    };
    Encoding.prototype.getBytesOfUtf8Encoding = function(byteCount, s, charIndex, charCount) {
        var bytes = new ArrayBuffer(byteCount);
        var uint = new Uint8Array(bytes);
        var index = charIndex;
        var j = 0;
        for(var i = 0; i < charCount; i++){
            var charcode = s.charCodeAt(index);
            if (charcode <= 0x7F) uint[j] = charcode;
            else if (charcode < 0x800) {
                uint[j] = 0xc0 | charcode >> 6;
                uint[++j] = 0x80 | charcode & 0x3f;
            } else if (charcode < 0xd800 || charcode >= 0xe000) {
                uint[j] = 0xe0 | charcode >> 12;
                uint[++j] = 0x80 | charcode >> 6 & 0x3f;
                uint[++j] = 0x80 | charcode & 0x3f;
            } else {
                uint[j] = 0xef;
                uint[++j] = 0xbf;
                uint[++j] = 0xbd; // U+FFFE "replacement character"
            }
            ++j;
            ++index;
        }
        return bytes;
    };
    Encoding.prototype.getBytesOfUnicodeEncoding = function(byteCount, s, charIndex, charCount) {
        var bytes = new ArrayBuffer(byteCount);
        var uint16 = new Uint16Array(bytes);
        for(var i = 0; i < charCount; i++){
            var charcode = s.charCodeAt(i);
            uint16[i] = charcode;
        }
        return bytes;
    };
    Encoding.prototype.getStringOfUtf8Encoding = function(byteCal, index, count) {
        var j = 0;
        var i = index;
        var s = "";
        for(j; j < count; j++){
            var c = byteCal[i++];
            while(i > byteCal.length)return s;
            if (c > 127) {
                if (c > 191 && c < 224 && i < count) c = (c & 31) << 6 | byteCal[i] & 63;
                else if (c > 223 && c < 240 && i < byteCal.byteLength) c = (c & 15) << 12 | (byteCal[i] & 63) << 6 | byteCal[++i] & 63;
                else if (c > 239 && c < 248 && i < byteCal.byteLength) c = (c & 7) << 18 | (byteCal[i] & 63) << 12 | (byteCal[++i] & 63) << 6 | byteCal[++i] & 63;
                ++i;
            }
            s += String.fromCharCode(c); // 1 byte(ASCII) character                          
        }
        return s;
    };
    Encoding.prototype.getStringofUnicodeEncoding = function(byteUni, index, count) {
        if (count > byteUni.length) throw new RangeError("ArgumentOutOfRange_Count");
        var byte16 = new Uint16Array(count);
        var out = "";
        for(var i = 0; i < count && i < byteUni.length; i++)byte16[i] = byteUni[index++];
        out = String.fromCharCode.apply(null, byte16);
        return out;
    };
    /**
     * To clear the encoding instance
     * @return {void}
     */ Encoding.prototype.destroy = function() {
        this.emitBOM = undefined;
        this.encodingType = undefined;
    };
    return Encoding;
}();
function $d16335ea6d5a8183$export$923fbdaad5ed00bc(value, message) {
    if (value === null || value === undefined) throw new Error("ArgumentException: " + message + " cannot be null or undefined");
}


/**
 * array literal codes
 */ var $74aa42b3315e6e4b$var$ARR_LITERAL_CODES = new Int16Array(286);
var $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS = new Uint8Array(286);
var $74aa42b3315e6e4b$var$ARR_DISTANCE_CODES = new Int16Array(30);
var $74aa42b3315e6e4b$var$ARR_DISTANCE_LENGTHS = new Uint8Array(30);
/**
 * represent compression stream writer
 * ```typescript
 * let compressedWriter = new CompressedStreamWriter();
 * let text: string = 'Hello world!!!';
 * compressedWriter.write(text, 0, text.length);
 * compressedWriter.close();
 * ```
 */ var $74aa42b3315e6e4b$export$c79d5db3b1b174f2 = /** @class */ function() {
    /**
     * Initializes compressor and writes ZLib header if needed.
     * @param {boolean} noWrap - optional if true, ZLib header and checksum will not be written.
     */ function CompressedStreamWriter(noWrap) {
        this.pendingBuffer = new Uint8Array(65536);
        this.pendingBufLength = 0;
        this.pendingBufCache = 0;
        this.pendingBufBitsInCache = 0;
        this.bufferPosition = 0;
        this.extraBits = 0;
        this.currentHash = 0;
        this.matchStart = 0;
        this.matchLength = 0;
        this.matchPrevAvail = false;
        this.blockStart = 0;
        this.stringStart = 0;
        this.lookAhead = 0;
        this.totalBytesIn = 0;
        this.inputOffset = 0;
        this.inputEnd = 0;
        this.windowSize = 32768;
        this.windowMask = this.windowSize - 1;
        this.hashSize = 32768;
        this.hashMask = this.hashSize - 1;
        this.hashShift = Math.floor(17 / 3);
        this.maxDist = this.windowSize - 262;
        this.checkSum = 1;
        this.noWrap = false;
        if (!CompressedStreamWriter.isHuffmanTreeInitiated) {
            CompressedStreamWriter.initHuffmanTree();
            CompressedStreamWriter.isHuffmanTreeInitiated = true;
        }
        this.treeLiteral = new $74aa42b3315e6e4b$export$4be64d1f7d294047(this, 286, 257, 15);
        this.treeDistances = new $74aa42b3315e6e4b$export$4be64d1f7d294047(this, 30, 1, 15);
        this.treeCodeLengths = new $74aa42b3315e6e4b$export$4be64d1f7d294047(this, 19, 4, 7);
        this.arrDistances = new Uint16Array(16384);
        this.arrLiterals = new Uint8Array(16384);
        this.stream = [];
        this.dataWindow = new Uint8Array(2 * this.windowSize);
        this.hashHead = new Int16Array(this.hashSize);
        this.hashPrevious = new Int16Array(this.windowSize);
        this.blockStart = this.stringStart = 1;
        this.noWrap = noWrap;
        if (!noWrap) this.writeZLibHeader();
    }
    Object.defineProperty(CompressedStreamWriter.prototype, "compressedData", {
        /**
         * get compressed data
         */ get: function() {
            return this.stream;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompressedStreamWriter.prototype, "getCompressedString", {
        get: function() {
            var compressedString = "";
            if (this.stream !== undefined) for(var i = 0; i < this.stream.length; i++)compressedString += String.fromCharCode.apply(null, this.stream[i]);
            return compressedString;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Compresses data and writes it to the stream.
     * @param {Uint8Array} data - data to compress
     * @param {number} offset - offset in data
     * @param {number} length - length of the data
     * @returns {void}
     */ CompressedStreamWriter.prototype.write = function(data, offset, length) {
        if (data === undefined || data === null) throw new Error("ArgumentException: data cannot null or undefined");
        var end = offset + length;
        if (0 > offset || offset > end || end > data.length) throw new Error("ArgumentOutOfRangeException: Offset or length is incorrect");
        if (typeof data === "string") {
            var encode = new (0, $d16335ea6d5a8183$export$72958ca7c468c63b)(false);
            encode.type = "Utf8";
            data = new Uint8Array(encode.getBytes(data, 0, data.length));
            end = offset + data.length;
        }
        this.inputBuffer = data;
        this.inputOffset = offset;
        this.inputEnd = end;
        if (!this.noWrap) this.checkSum = $74aa42b3315e6e4b$export$903dab4681b04bb6.checksumUpdate(this.checkSum, this.inputBuffer, this.inputOffset, end);
        while(!(this.inputEnd === this.inputOffset) || !(this.pendingBufLength === 0)){
            this.pendingBufferFlush();
            this.compressData(false);
        }
    };
    /**
     * write ZLib header to the compressed data
     * @return {void}
     */ CompressedStreamWriter.prototype.writeZLibHeader = function() {
        /* Initialize header.*/ var headerDate = 30720;
        /* Save compression level.*/ headerDate |= 64;
        /* Align header.*/ headerDate += 31 - headerDate % 31;
        /* Write header to stream.*/ this.pendingBufferWriteShortBytes(headerDate);
    };
    /**
     *  Write Most Significant Bytes in to stream
     * @param {number} s - check sum value
     */ CompressedStreamWriter.prototype.pendingBufferWriteShortBytes = function(s) {
        this.pendingBuffer[this.pendingBufLength++] = s >> 8;
        this.pendingBuffer[this.pendingBufLength++] = s;
    };
    CompressedStreamWriter.prototype.compressData = function(finish) {
        var success;
        do {
            this.fillWindow();
            var canFlush = finish && this.inputEnd === this.inputOffset;
            success = this.compressSlow(canFlush, finish);
        }while (this.pendingBufLength === 0 && success);
        return success;
    };
    CompressedStreamWriter.prototype.compressSlow = function(flush, finish) {
        if (this.lookAhead < 262 && !flush) return false;
        while(this.lookAhead >= 262 || flush){
            if (this.lookAhead === 0) return this.lookAheadCompleted(finish);
            if (this.stringStart >= 2 * this.windowSize - 262) this.slideWindow();
            var prevMatch = this.matchStart;
            var prevLen = this.matchLength;
            if (this.lookAhead >= 3) this.discardMatch();
            if (prevLen >= 3 && this.matchLength <= prevLen) prevLen = this.matchPreviousBest(prevMatch, prevLen);
            else this.matchPreviousAvailable();
            if (this.bufferPosition >= 16384) return this.huffmanIsFull(finish);
        }
        return true;
    };
    CompressedStreamWriter.prototype.discardMatch = function() {
        var hashHead = this.insertString();
        if (hashHead !== 0 && this.stringStart - hashHead <= this.maxDist && this.findLongestMatch(hashHead)) {
            if (this.matchLength <= 5 && this.matchLength === 3 && this.stringStart - this.matchStart > 4096) this.matchLength = 2;
        }
    };
    CompressedStreamWriter.prototype.matchPreviousAvailable = function() {
        if (this.matchPrevAvail) this.huffmanTallyLit(this.dataWindow[this.stringStart - 1] & 0xff);
        this.matchPrevAvail = true;
        this.stringStart++;
        this.lookAhead--;
    };
    CompressedStreamWriter.prototype.matchPreviousBest = function(prevMatch, prevLen) {
        this.huffmanTallyDist(this.stringStart - 1 - prevMatch, prevLen);
        prevLen -= 2;
        do {
            this.stringStart++;
            this.lookAhead--;
            if (this.lookAhead >= 3) this.insertString();
        }while (--prevLen > 0);
        this.stringStart++;
        this.lookAhead--;
        this.matchPrevAvail = false;
        this.matchLength = 2;
        return prevLen;
    };
    CompressedStreamWriter.prototype.lookAheadCompleted = function(finish) {
        if (this.matchPrevAvail) this.huffmanTallyLit(this.dataWindow[this.stringStart - 1] & 0xff);
        this.matchPrevAvail = false;
        this.huffmanFlushBlock(this.dataWindow, this.blockStart, this.stringStart - this.blockStart, finish);
        this.blockStart = this.stringStart;
        return false;
    };
    CompressedStreamWriter.prototype.huffmanIsFull = function(finish) {
        var len = this.stringStart - this.blockStart;
        if (this.matchPrevAvail) len--;
        var lastBlock = finish && this.lookAhead === 0 && !this.matchPrevAvail;
        this.huffmanFlushBlock(this.dataWindow, this.blockStart, len, lastBlock);
        this.blockStart += len;
        return !lastBlock;
    };
    CompressedStreamWriter.prototype.fillWindow = function() {
        if (this.stringStart >= this.windowSize + this.maxDist) this.slideWindow();
        while(this.lookAhead < 262 && this.inputOffset < this.inputEnd){
            var more = 2 * this.windowSize - this.lookAhead - this.stringStart;
            if (more > this.inputEnd - this.inputOffset) more = this.inputEnd - this.inputOffset;
            this.dataWindow.set(this.inputBuffer.subarray(this.inputOffset, this.inputOffset + more), this.stringStart + this.lookAhead);
            this.inputOffset += more;
            this.totalBytesIn += more;
            this.lookAhead += more;
        }
        if (this.lookAhead >= 3) this.updateHash();
    };
    CompressedStreamWriter.prototype.slideWindow = function() {
        this.dataWindow.set(this.dataWindow.subarray(this.windowSize, this.windowSize + this.windowSize), 0);
        this.matchStart -= this.windowSize;
        this.stringStart -= this.windowSize;
        this.blockStart -= this.windowSize;
        for(var i = 0; i < this.hashSize; ++i){
            var m = this.hashHead[i] & 0xffff;
            this.hashHead[i] = m >= this.windowSize ? m - this.windowSize : 0;
        }
        for(var i = 0; i < this.windowSize; i++){
            var m = this.hashPrevious[i] & 0xffff;
            this.hashPrevious[i] = m >= this.windowSize ? m - this.windowSize : 0;
        }
    };
    CompressedStreamWriter.prototype.insertString = function() {
        var match;
        var hash = (this.currentHash << this.hashShift ^ this.dataWindow[this.stringStart + 2]) & this.hashMask;
        this.hashPrevious[this.stringStart & this.windowMask] = match = this.hashHead[hash];
        this.hashHead[hash] = this.stringStart;
        this.currentHash = hash;
        return match & 0xffff;
    };
    CompressedStreamWriter.prototype.findLongestMatch = function(curMatch) {
        var chainLen = 4096;
        var niceLen = 258;
        var scan = this.stringStart;
        var match;
        var bestEnd = this.stringStart + this.matchLength;
        var bestLength = Math.max(this.matchLength, 2);
        var limit = Math.max(this.stringStart - this.maxDist, 0);
        var stringEnd = this.stringStart + 258 - 1;
        var scanEnd1 = this.dataWindow[bestEnd - 1];
        var scanEnd = this.dataWindow[bestEnd];
        var data = this.dataWindow;
        if (bestLength >= 32) chainLen >>= 2;
        if (niceLen > this.lookAhead) niceLen = this.lookAhead;
        do {
            if (data[curMatch + bestLength] !== scanEnd || data[curMatch + bestLength - 1] !== scanEnd1 || data[curMatch] !== data[scan] || data[curMatch + 1] !== data[scan + 1]) continue;
            match = curMatch + 2;
            scan += 2;
            /* tslint:disable */ while(data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && data[++scan] === data[++match] && scan < stringEnd);
            if (scan > bestEnd) {
                this.matchStart = curMatch;
                bestEnd = scan;
                bestLength = scan - this.stringStart;
                if (bestLength >= niceLen) break;
                scanEnd1 = data[bestEnd - 1];
                scanEnd = data[bestEnd];
            }
            scan = this.stringStart;
        }while ((curMatch = this.hashPrevious[curMatch & this.windowMask] & 0xffff) > limit && --chainLen !== 0);
        this.matchLength = Math.min(bestLength, this.lookAhead);
        return this.matchLength >= 3;
    };
    CompressedStreamWriter.prototype.updateHash = function() {
        this.currentHash = this.dataWindow[this.stringStart] << this.hashShift ^ this.dataWindow[this.stringStart + 1];
    };
    CompressedStreamWriter.prototype.huffmanTallyLit = function(literal) {
        this.arrDistances[this.bufferPosition] = 0;
        this.arrLiterals[this.bufferPosition++] = literal;
        this.treeLiteral.codeFrequencies[literal]++;
        return this.bufferPosition >= 16384;
    };
    CompressedStreamWriter.prototype.huffmanTallyDist = function(dist, len) {
        this.arrDistances[this.bufferPosition] = dist;
        this.arrLiterals[this.bufferPosition++] = len - 3;
        var lc = this.huffmanLengthCode(len - 3);
        this.treeLiteral.codeFrequencies[lc]++;
        if (lc >= 265 && lc < 285) this.extraBits += Math.floor((lc - 261) / 4);
        var dc = this.huffmanDistanceCode(dist - 1);
        this.treeDistances.codeFrequencies[dc]++;
        if (dc >= 4) this.extraBits += Math.floor(dc / 2 - 1);
        return this.bufferPosition >= 16384;
    };
    CompressedStreamWriter.prototype.huffmanFlushBlock = function(stored, storedOffset, storedLength, lastBlock) {
        this.treeLiteral.codeFrequencies[256]++;
        this.treeLiteral.buildTree();
        this.treeDistances.buildTree();
        this.treeLiteral.calculateBLFreq(this.treeCodeLengths);
        this.treeDistances.calculateBLFreq(this.treeCodeLengths);
        this.treeCodeLengths.buildTree();
        var blTreeCodes = 4;
        for(var i = 18; i > blTreeCodes; i--)if (this.treeCodeLengths.codeLengths[$74aa42b3315e6e4b$export$4be64d1f7d294047.huffCodeLengthOrders[i]] > 0) blTreeCodes = i + 1;
        var opt_len = 14 + blTreeCodes * 3 + this.treeCodeLengths.getEncodedLength() + this.treeLiteral.getEncodedLength() + this.treeDistances.getEncodedLength() + this.extraBits;
        var static_len = this.extraBits;
        for(var i = 0; i < 286; i++)static_len += this.treeLiteral.codeFrequencies[i] * $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS[i];
        for(var i = 0; i < 30; i++)static_len += this.treeDistances.codeFrequencies[i] * $74aa42b3315e6e4b$var$ARR_DISTANCE_LENGTHS[i];
        if (opt_len >= static_len) // Force static trees.
        opt_len = static_len;
        if (storedOffset >= 0 && storedLength + 4 < opt_len >> 3) this.huffmanFlushStoredBlock(stored, storedOffset, storedLength, lastBlock);
        else if (opt_len == static_len) {
            // Encode with static tree.
            this.pendingBufferWriteBits(2 + (lastBlock ? 1 : 0), 3);
            this.treeLiteral.setStaticCodes($74aa42b3315e6e4b$var$ARR_LITERAL_CODES, $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS);
            this.treeDistances.setStaticCodes($74aa42b3315e6e4b$var$ARR_DISTANCE_CODES, $74aa42b3315e6e4b$var$ARR_DISTANCE_LENGTHS);
            this.huffmanCompressBlock();
            this.huffmanReset();
        } else {
            this.pendingBufferWriteBits(4 + (lastBlock ? 1 : 0), 3);
            this.huffmanSendAllTrees(blTreeCodes);
            this.huffmanCompressBlock();
            this.huffmanReset();
        }
    };
    CompressedStreamWriter.prototype.huffmanFlushStoredBlock = function(stored, storedOffset, storedLength, lastBlock) {
        this.pendingBufferWriteBits(0 + (lastBlock ? 1 : 0), 3);
        this.pendingBufferAlignToByte();
        this.pendingBufferWriteShort(storedLength);
        this.pendingBufferWriteShort(~storedLength);
        this.pendingBufferWriteByteBlock(stored, storedOffset, storedLength);
        this.huffmanReset();
    };
    CompressedStreamWriter.prototype.huffmanLengthCode = function(len) {
        if (len === 255) return 285;
        var code = 257;
        while(len >= 8){
            code += 4;
            len >>= 1;
        }
        return code + len;
    };
    CompressedStreamWriter.prototype.huffmanDistanceCode = function(distance) {
        var code = 0;
        while(distance >= 4){
            code += 2;
            distance >>= 1;
        }
        return code + distance;
    };
    CompressedStreamWriter.prototype.huffmanSendAllTrees = function(blTreeCodes) {
        this.treeCodeLengths.buildCodes();
        this.treeLiteral.buildCodes();
        this.treeDistances.buildCodes();
        this.pendingBufferWriteBits(this.treeLiteral.treeLength - 257, 5);
        this.pendingBufferWriteBits(this.treeDistances.treeLength - 1, 5);
        this.pendingBufferWriteBits(blTreeCodes - 4, 4);
        for(var rank = 0; rank < blTreeCodes; rank++)this.pendingBufferWriteBits(this.treeCodeLengths.codeLengths[$74aa42b3315e6e4b$export$4be64d1f7d294047.huffCodeLengthOrders[rank]], 3);
        this.treeLiteral.writeTree(this.treeCodeLengths);
        this.treeDistances.writeTree(this.treeCodeLengths);
    };
    CompressedStreamWriter.prototype.huffmanReset = function() {
        this.bufferPosition = 0;
        this.extraBits = 0;
        this.treeLiteral.reset();
        this.treeDistances.reset();
        this.treeCodeLengths.reset();
    };
    CompressedStreamWriter.prototype.huffmanCompressBlock = function() {
        for(var i = 0; i < this.bufferPosition; i++){
            var literalLen = this.arrLiterals[i] & 255;
            var dist = this.arrDistances[i];
            if (dist-- !== 0) {
                var lc = this.huffmanLengthCode(literalLen);
                this.treeLiteral.writeCodeToStream(lc);
                var bits = Math.floor((lc - 261) / 4);
                if (bits > 0 && bits <= 5) this.pendingBufferWriteBits(literalLen & (1 << bits) - 1, bits);
                var dc = this.huffmanDistanceCode(dist);
                this.treeDistances.writeCodeToStream(dc);
                bits = Math.floor(dc / 2 - 1);
                if (bits > 0) this.pendingBufferWriteBits(dist & (1 << bits) - 1, bits);
            } else this.treeLiteral.writeCodeToStream(literalLen);
        }
        this.treeLiteral.writeCodeToStream(256);
    };
    /**
     * write bits in to internal buffer
     * @param {number} b - source of bits
     * @param {number} count - count of bits to write
     */ CompressedStreamWriter.prototype.pendingBufferWriteBits = function(b, count) {
        var uint = new Uint32Array(1);
        uint[0] = this.pendingBufCache | b << this.pendingBufBitsInCache;
        this.pendingBufCache = uint[0];
        this.pendingBufBitsInCache += count;
        this.pendingBufferFlushBits();
    };
    CompressedStreamWriter.prototype.pendingBufferFlush = function(isClose) {
        this.pendingBufferFlushBits();
        if (this.pendingBufLength > 0) {
            var array = new Uint8Array(this.pendingBufLength);
            array.set(this.pendingBuffer.subarray(0, this.pendingBufLength), 0);
            this.stream.push(array);
        }
        this.pendingBufLength = 0;
    };
    CompressedStreamWriter.prototype.pendingBufferFlushBits = function() {
        var result = 0;
        while(this.pendingBufBitsInCache >= 8 && this.pendingBufLength < 65536){
            this.pendingBuffer[this.pendingBufLength++] = this.pendingBufCache;
            this.pendingBufCache >>= 8;
            this.pendingBufBitsInCache -= 8;
            result++;
        }
        return result;
    };
    CompressedStreamWriter.prototype.pendingBufferWriteByteBlock = function(data, offset, length) {
        var array = data.subarray(offset, offset + length);
        this.pendingBuffer.set(array, this.pendingBufLength);
        this.pendingBufLength += length;
    };
    CompressedStreamWriter.prototype.pendingBufferWriteShort = function(s) {
        this.pendingBuffer[this.pendingBufLength++] = s;
        this.pendingBuffer[this.pendingBufLength++] = s >> 8;
    };
    CompressedStreamWriter.prototype.pendingBufferAlignToByte = function() {
        if (this.pendingBufBitsInCache > 0) this.pendingBuffer[this.pendingBufLength++] = this.pendingBufCache;
        this.pendingBufCache = 0;
        this.pendingBufBitsInCache = 0;
    };
    /**
     * Huffman Tree literal calculation
     * @private
     */ CompressedStreamWriter.initHuffmanTree = function() {
        var i = 0;
        while(i < 144){
            $74aa42b3315e6e4b$var$ARR_LITERAL_CODES[i] = $74aa42b3315e6e4b$export$4be64d1f7d294047.bitReverse(0x030 + i << 8);
            $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS[i++] = 8;
        }
        while(i < 256){
            $74aa42b3315e6e4b$var$ARR_LITERAL_CODES[i] = $74aa42b3315e6e4b$export$4be64d1f7d294047.bitReverse(256 + i << 7);
            $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS[i++] = 9;
        }
        while(i < 280){
            $74aa42b3315e6e4b$var$ARR_LITERAL_CODES[i] = $74aa42b3315e6e4b$export$4be64d1f7d294047.bitReverse(-256 + i << 9);
            $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS[i++] = 7;
        }
        while(i < 286){
            $74aa42b3315e6e4b$var$ARR_LITERAL_CODES[i] = $74aa42b3315e6e4b$export$4be64d1f7d294047.bitReverse(-88 + i << 8);
            $74aa42b3315e6e4b$var$ARR_LITERAL_LENGTHS[i++] = 8;
        }
        for(i = 0; i < 30; i++){
            $74aa42b3315e6e4b$var$ARR_DISTANCE_CODES[i] = $74aa42b3315e6e4b$export$4be64d1f7d294047.bitReverse(i << 11);
            $74aa42b3315e6e4b$var$ARR_DISTANCE_LENGTHS[i] = 5;
        }
    };
    /**
     * close the stream and write all pending buffer in to stream
     * @returns {void}
     */ CompressedStreamWriter.prototype.close = function() {
        do {
            this.pendingBufferFlush(true);
            if (!this.compressData(true)) {
                this.pendingBufferFlush(true);
                this.pendingBufferAlignToByte();
                if (!this.noWrap) {
                    this.pendingBufferWriteShortBytes(this.checkSum >> 16);
                    this.pendingBufferWriteShortBytes(this.checkSum & 0xffff);
                }
                this.pendingBufferFlush(true);
            }
        }while (!(this.inputEnd === this.inputOffset) || !(this.pendingBufLength === 0));
    };
    /**
     * release allocated un-managed resource
     * @returns {void}
     */ CompressedStreamWriter.prototype.destroy = function() {
        this.stream = [];
        this.stream = undefined;
        this.pendingBuffer = undefined;
        this.treeLiteral = undefined;
        this.treeDistances = undefined;
        this.treeCodeLengths = undefined;
        this.arrLiterals = undefined;
        this.arrDistances = undefined;
        this.hashHead = undefined;
        this.hashPrevious = undefined;
        this.dataWindow = undefined;
        this.inputBuffer = undefined;
        this.pendingBufLength = undefined;
        this.pendingBufCache = undefined;
        this.pendingBufBitsInCache = undefined;
        this.bufferPosition = undefined;
        this.extraBits = undefined;
        this.currentHash = undefined;
        this.matchStart = undefined;
        this.matchLength = undefined;
        this.matchPrevAvail = undefined;
        this.blockStart = undefined;
        this.stringStart = undefined;
        this.lookAhead = undefined;
        this.totalBytesIn = undefined;
        this.inputOffset = undefined;
        this.inputEnd = undefined;
        this.windowSize = undefined;
        this.windowMask = undefined;
        this.hashSize = undefined;
        this.hashMask = undefined;
        this.hashShift = undefined;
        this.maxDist = undefined;
        this.checkSum = undefined;
        this.noWrap = undefined;
    };
    CompressedStreamWriter.isHuffmanTreeInitiated = false;
    return CompressedStreamWriter;
}();
/**
 * represent the Huffman Tree
 */ var $74aa42b3315e6e4b$export$4be64d1f7d294047 = /** @class */ function() {
    /**
     * Create new Huffman Tree
     * @param {CompressedStreamWriter} writer instance
     * @param {number} elementCount - element count
     * @param {number} minCodes - minimum count
     * @param {number} maxLength - maximum count
     */ function CompressorHuffmanTree(writer, elementCount, minCodes, maxLength) {
        this.writer = writer;
        this.codeMinCount = minCodes;
        this.maxLength = maxLength;
        this.codeFrequency = new Uint16Array(elementCount);
        this.lengthCount = new Int32Array(maxLength);
    }
    Object.defineProperty(CompressorHuffmanTree.prototype, "treeLength", {
        get: function() {
            return this.codeCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompressorHuffmanTree.prototype, "codeLengths", {
        get: function() {
            return this.codeLength;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompressorHuffmanTree.prototype, "codeFrequencies", {
        get: function() {
            return this.codeFrequency;
        },
        enumerable: true,
        configurable: true
    });
    CompressorHuffmanTree.prototype.setStaticCodes = function(codes, lengths) {
        var temp = new Int16Array(codes.length);
        temp.set(codes, 0);
        this.codes = temp;
        var lengthTemp = new Uint8Array(lengths.length);
        lengthTemp.set(lengths, 0);
        this.codeLength = lengthTemp;
    };
    /**
     * reset all code data in tree
     * @returns {void}
     */ CompressorHuffmanTree.prototype.reset = function() {
        for(var i = 0; i < this.codeFrequency.length; i++)this.codeFrequency[i] = 0;
        this.codes = undefined;
        this.codeLength = undefined;
    };
    /**
     * write code to the compressor output stream
     * @param {number} code - code to be written
     * @returns {void}
     */ CompressorHuffmanTree.prototype.writeCodeToStream = function(code) {
        this.writer.pendingBufferWriteBits(this.codes[code] & 0xffff, this.codeLength[code]);
    };
    /**
     * calculate code from their frequencies
     * @returns {void}
     */ CompressorHuffmanTree.prototype.buildCodes = function() {
        var nextCode = new Int32Array(this.maxLength);
        this.codes = new Int16Array(this.codeCount);
        var code = 0;
        for(var bitsCount = 0; bitsCount < this.maxLength; bitsCount++){
            nextCode[bitsCount] = code;
            code += this.lengthCount[bitsCount] << 15 - bitsCount;
        }
        for(var i = 0; i < this.codeCount; i++){
            var bits = this.codeLength[i];
            if (bits > 0) {
                this.codes[i] = CompressorHuffmanTree.bitReverse(nextCode[bits - 1]);
                nextCode[bits - 1] += 1 << 16 - bits;
            }
        }
    };
    CompressorHuffmanTree.bitReverse = function(value) {
        return CompressorHuffmanTree.reverseBits[value & 15] << 12 | CompressorHuffmanTree.reverseBits[value >> 4 & 15] << 8 | CompressorHuffmanTree.reverseBits[value >> 8 & 15] << 4 | CompressorHuffmanTree.reverseBits[value >> 12];
    };
    /**
     * calculate length of compressed data
     * @returns {number}
     */ CompressorHuffmanTree.prototype.getEncodedLength = function() {
        var len = 0;
        for(var i = 0; i < this.codeFrequency.length; i++)len += this.codeFrequency[i] * this.codeLength[i];
        return len;
    };
    /**
     * calculate code frequencies
     * @param {CompressorHuffmanTree} blTree
     * @returns {void}
     */ CompressorHuffmanTree.prototype.calculateBLFreq = function(blTree) {
        var maxCount;
        var minCount;
        var count;
        var curLen = -1;
        var i = 0;
        while(i < this.codeCount){
            count = 1;
            var nextLen = this.codeLength[i];
            if (nextLen === 0) {
                maxCount = 138;
                minCount = 3;
            } else {
                maxCount = 6;
                minCount = 3;
                if (curLen !== nextLen) {
                    blTree.codeFrequency[nextLen]++;
                    count = 0;
                }
            }
            curLen = nextLen;
            i++;
            while(i < this.codeCount && curLen === this.codeLength[i]){
                i++;
                if (++count >= maxCount) break;
            }
            if (count < minCount) blTree.codeFrequency[curLen] += count;
            else if (curLen !== 0) blTree.codeFrequency[16]++;
            else if (count <= 10) blTree.codeFrequency[17]++;
            else blTree.codeFrequency[18]++;
        }
    };
    /**
     * @param {CompressorHuffmanTree} blTree - write tree to output stream
     * @returns {void}
     */ CompressorHuffmanTree.prototype.writeTree = function(blTree) {
        var maxRepeatCount;
        var minRepeatCount;
        var currentRepeatCount;
        var currentCodeLength = -1;
        var i = 0;
        while(i < this.codeCount){
            currentRepeatCount = 1;
            var nextLen = this.codeLength[i];
            if (nextLen === 0) {
                maxRepeatCount = 138;
                minRepeatCount = 3;
            } else {
                maxRepeatCount = 6;
                minRepeatCount = 3;
                if (currentCodeLength !== nextLen) {
                    blTree.writeCodeToStream(nextLen);
                    currentRepeatCount = 0;
                }
            }
            currentCodeLength = nextLen;
            i++;
            while(i < this.codeCount && currentCodeLength === this.codeLength[i]){
                i++;
                if (++currentRepeatCount >= maxRepeatCount) break;
            }
            if (currentRepeatCount < minRepeatCount) while(currentRepeatCount-- > 0)blTree.writeCodeToStream(currentCodeLength);
            else if (currentCodeLength !== 0) {
                blTree.writeCodeToStream(16);
                this.writer.pendingBufferWriteBits(currentRepeatCount - 3, 2);
            } else if (currentRepeatCount <= 10) {
                blTree.writeCodeToStream(17);
                this.writer.pendingBufferWriteBits(currentRepeatCount - 3, 3);
            } else {
                blTree.writeCodeToStream(18);
                this.writer.pendingBufferWriteBits(currentRepeatCount - 11, 7);
            }
        }
    };
    /**
     * Build huffman tree
     * @returns {void}
     */ CompressorHuffmanTree.prototype.buildTree = function() {
        var codesCount = this.codeFrequency.length;
        var arrTree = new Int32Array(codesCount);
        var treeLength = 0;
        var maxCount = 0;
        for(var n = 0; n < codesCount; n++){
            var freq = this.codeFrequency[n];
            if (freq !== 0) {
                var pos = treeLength++;
                var pPos = 0;
                while(pos > 0 && this.codeFrequency[arrTree[pPos = Math.floor((pos - 1) / 2)]] > freq){
                    arrTree[pos] = arrTree[pPos];
                    pos = pPos;
                }
                arrTree[pos] = n;
                maxCount = n;
            }
        }
        while(treeLength < 2)arrTree[treeLength++] = maxCount < 2 ? ++maxCount : 0;
        this.codeCount = Math.max(maxCount + 1, this.codeMinCount);
        var leafsCount = treeLength;
        var nodesCount = leafsCount;
        var child = new Int32Array(4 * treeLength - 2);
        var values = new Int32Array(2 * treeLength - 1);
        for(var i = 0; i < treeLength; i++){
            var node = arrTree[i];
            var iIndex = 2 * i;
            child[iIndex] = node;
            child[iIndex + 1] = -1;
            values[i] = this.codeFrequency[node] << 8;
            arrTree[i] = i;
        }
        this.constructHuffmanTree(arrTree, treeLength, values, nodesCount, child);
        this.buildLength(child);
    };
    CompressorHuffmanTree.prototype.constructHuffmanTree = function(arrTree, treeLength, values, nodesCount, child) {
        do {
            var first = arrTree[0];
            var last = arrTree[--treeLength];
            var lastVal = values[last];
            var pPos = 0;
            var path = 1;
            while(path < treeLength){
                if (path + 1 < treeLength && values[arrTree[path]] > values[arrTree[path + 1]]) path++;
                arrTree[pPos] = arrTree[path];
                pPos = path;
                path = pPos * 2 + 1;
            }
            while((path = pPos) > 0 && values[arrTree[pPos = Math.floor((path - 1) / 2)]] > lastVal)arrTree[path] = arrTree[pPos];
            arrTree[path] = last;
            var second = arrTree[0];
            last = nodesCount++;
            child[2 * last] = first;
            child[2 * last + 1] = second;
            var minDepth = Math.min(values[first] & 0xff, values[second] & 0xff);
            values[last] = lastVal = values[first] + values[second] - minDepth + 1;
            pPos = 0;
            path = 1;
            /* tslint:disable */ while(path < treeLength){
                if (path + 1 < treeLength && values[arrTree[path]] > values[arrTree[path + 1]]) path++;
                arrTree[pPos] = arrTree[path];
                pPos = path;
                path = pPos * 2 + 1;
            } /* tslint:disable */ 
            while((path = pPos) > 0 && values[arrTree[pPos = Math.floor((path - 1) / 2)]] > lastVal)arrTree[path] = arrTree[pPos];
            arrTree[path] = last;
        }while (treeLength > 1);
    };
    CompressorHuffmanTree.prototype.buildLength = function(child) {
        this.codeLength = new Uint8Array(this.codeFrequency.length);
        var numNodes = Math.floor(child.length / 2);
        var numLeafs = Math.floor((numNodes + 1) / 2);
        var overflow = 0;
        for(var i = 0; i < this.maxLength; i++)this.lengthCount[i] = 0;
        overflow = this.calculateOptimalCodeLength(child, overflow, numNodes);
        if (overflow === 0) return;
        var iIncreasableLength = this.maxLength - 1;
        do {
            while(this.lengthCount[--iIncreasableLength] === 0);
            do {
                this.lengthCount[iIncreasableLength]--;
                this.lengthCount[++iIncreasableLength]++;
                overflow -= 1 << this.maxLength - 1 - iIncreasableLength;
            }while (overflow > 0 && iIncreasableLength < this.maxLength - 1);
        }while (overflow > 0);
        this.recreateTree(child, overflow, numLeafs);
    };
    CompressorHuffmanTree.prototype.recreateTree = function(child, overflow, numLeafs) {
        this.lengthCount[this.maxLength - 1] += overflow;
        this.lengthCount[this.maxLength - 2] -= overflow;
        var nodePtr = 2 * numLeafs;
        for(var bits = this.maxLength; bits !== 0; bits--){
            var n = this.lengthCount[bits - 1];
            while(n > 0){
                var childPtr = 2 * child[nodePtr++];
                if (child[childPtr + 1] === -1) {
                    this.codeLength[child[childPtr]] = bits;
                    n--;
                }
            }
        }
    };
    CompressorHuffmanTree.prototype.calculateOptimalCodeLength = function(child, overflow, numNodes) {
        var lengths = new Int32Array(numNodes);
        lengths[numNodes - 1] = 0;
        for(var i = numNodes - 1; i >= 0; i--){
            var childIndex = 2 * i + 1;
            if (child[childIndex] !== -1) {
                var bitLength = lengths[i] + 1;
                if (bitLength > this.maxLength) {
                    bitLength = this.maxLength;
                    overflow++;
                }
                lengths[child[childIndex - 1]] = lengths[child[childIndex]] = bitLength;
            } else {
                var bitLength = lengths[i];
                this.lengthCount[bitLength - 1]++;
                this.codeLength[child[childIndex - 1]] = lengths[i];
            }
        }
        return overflow;
    };
    CompressorHuffmanTree.reverseBits = [
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ];
    CompressorHuffmanTree.huffCodeLengthOrders = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    return CompressorHuffmanTree;
}();
/**
 * Checksum calculator, based on Adler32 algorithm.
 */ var $74aa42b3315e6e4b$export$903dab4681b04bb6 = /** @class */ function() {
    function ChecksumCalculator() {}
    /**
     * Updates checksum by calculating checksum of the
     * given buffer and adding it to current value.
     * @param {number} checksum - current checksum.
     * @param {Uint8Array} buffer - data byte array.
     * @param {number} offset - offset in the buffer.
     * @param {number} length - length of data to be used from the stream.
     * @returns {number}
     */ ChecksumCalculator.checksumUpdate = function(checksum, buffer, offset, length) {
        var uint = new Uint32Array(1);
        uint[0] = checksum;
        var checksum_uint = uint[0];
        var s1 = uint[0] = checksum_uint & 65535;
        var s2 = uint[0] = checksum_uint >> ChecksumCalculator.checkSumBitOffset;
        while(length > 0){
            var steps = Math.min(length, ChecksumCalculator.checksumIterationCount);
            length -= steps;
            while(--steps >= 0){
                s1 = s1 + (uint[0] = buffer[offset++] & 255);
                s2 = s2 + s1;
            }
            s1 %= ChecksumCalculator.checksumBase;
            s2 %= ChecksumCalculator.checksumBase;
        }
        checksum_uint = s2 << ChecksumCalculator.checkSumBitOffset | s1;
        return checksum_uint;
    };
    ChecksumCalculator.checkSumBitOffset = 16;
    ChecksumCalculator.checksumBase = 65521;
    ChecksumCalculator.checksumIterationCount = 3800;
    return ChecksumCalculator;
}();
 /* eslint-enable */ 

/**
 * Save class provide method to save file
 * ```typescript
 * let blob : Blob = new Blob([''], { type: 'text/plain' });
 * Save.save('fileName.txt',blob);
 */ var $2da9a4aa9748e8c8$export$be11e187edb4cb0c = /** @class */ function() {
    /**
     * Initialize new instance of {save}
     */ function Save() {
    // tslint:disable
    }
    /**
     * Saves the file with specified name and sends the file to client browser
     * @param  {string} fileName- file name to save.
     * @param  {Blob} buffer- the content to write in file
     * @param  {boolean} isMicrosoftBrowser- specify whether microsoft browser or not
     * @returns {void}
     */ Save.save = function(fileName, buffer) {
        if (fileName === null || fileName === undefined || fileName === "") throw new Error("ArgumentException: fileName cannot be undefined, null or empty");
        var extension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
        var mimeType = this.getMimeType(extension);
        if (mimeType !== "") buffer = new Blob([
            buffer
        ], {
            type: mimeType
        });
        if (this.isMicrosoftBrowser) navigator.msSaveBlob(buffer, fileName);
        else {
            var downloadLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            this.saveInternal(fileName, extension, buffer, downloadLink, "download" in downloadLink);
        }
    };
    Save.saveInternal = function(fileName, extension, buffer, downloadLink, hasDownloadAttribute) {
        if (hasDownloadAttribute) {
            downloadLink.download = fileName;
            var dataUrl_1 = window.URL.createObjectURL(buffer);
            downloadLink.href = dataUrl_1;
            var event_1 = document.createEvent("MouseEvent");
            event_1.initEvent("click", true, true);
            downloadLink.dispatchEvent(event_1);
            setTimeout(function() {
                window.URL.revokeObjectURL(dataUrl_1);
                dataUrl_1 = undefined;
            });
        } else if (extension !== "docx" && extension !== "xlsx") {
            var url = window.URL.createObjectURL(buffer);
            var isPopupBlocked = window.open(url, "_blank");
            if (!isPopupBlocked) window.location.href = url;
        } else {
            var reader_1 = new FileReader();
            reader_1.onloadend = function() {
                var isPopupBlocked = window.open(reader_1.result, "_blank");
                if (!isPopupBlocked) window.location.href = reader_1.result;
            };
            reader_1.readAsDataURL(buffer);
        }
    };
    /**
     *
     * @param {string} extension - get mime type of the specified extension
     * @private
     */ Save.getMimeType = function(extension) {
        var mimeType = "";
        switch(extension){
            case "html":
                mimeType = "text/html";
                break;
            case "pdf":
                mimeType = "application/pdf";
                break;
            case "docx":
                mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                break;
            case "xlsx":
                mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                break;
            case "txt":
                mimeType = "text/plain";
                break;
        }
        return mimeType;
    };
    return Save;
}();



var $c2dd4e274b017c1a$var$CRC32TABLE = [];
/// <summary>
/// Size of the int value in bytes.
/// </summary>
var $c2dd4e274b017c1a$var$INT_SIZE = 4;
/// <summary>
/// Size of the short value in bytes.
/// </summary>
var $c2dd4e274b017c1a$var$SHORT_SIZE = 2;
/// <summary>
/// End of central directory signature.
/// </summary>
var $c2dd4e274b017c1a$var$CentralDirectoryEndSignature = 0x06054b50;
/// <summary>
/// Offset to the size field in the End of central directory record.
/// </summary>
var $c2dd4e274b017c1a$var$CentralDirSizeOffset = 12;
/// <summary>
/// Central header signature.
/// </summary>
var $c2dd4e274b017c1a$var$CentralHeaderSignature = 0x02014b50;
/// <summary>
/// Buffer size.
/// </summary>
var $c2dd4e274b017c1a$var$BufferSize = 4096;
/**
 * class provide compression library
 * ```typescript
 * let archive = new ZipArchive();
 * archive.compressionLevel = 'Normal';
 * let archiveItem = new ZipArchiveItem(archive, 'directoryName\fileName.txt');
 * archive.addItem(archiveItem);
 * archive.save(fileName.zip);
 * ```
 */ var $c2dd4e274b017c1a$export$6fef560ea28f8cc8 = /** @class */ function() {
    /**
     * constructor for creating ZipArchive instance
     */ function ZipArchive() {
        if ($c2dd4e274b017c1a$var$CRC32TABLE.length === 0) ZipArchive.initCrc32Table();
        this.files = [];
        this.level = "Normal";
        (0, $2da9a4aa9748e8c8$export$be11e187edb4cb0c).isMicrosoftBrowser = !!navigator.msSaveBlob;
    }
    Object.defineProperty(ZipArchive.prototype, "items", {
        get: function() {
            return this.files;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ZipArchive.prototype, "compressionLevel", {
        /**
         * gets compression level
         */ get: function() {
            return this.level;
        },
        /**
         * sets compression level
         */ set: function(level) {
            this.level = level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ZipArchive.prototype, "length", {
        /**
         * gets items count
         */ get: function() {
            if (this.files === undefined) return 0;
            return this.files.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * add new item to archive
     * @param {ZipArchiveItem} item - item to be added
     * @returns {void}
     */ ZipArchive.prototype.addItem = function(item) {
        if (item === null || item === undefined) throw new Error("ArgumentException: item cannot be null or undefined");
        for(var i = 0; i < this.files.length; i++){
            var file = this.files[i];
            if (file instanceof $c2dd4e274b017c1a$export$8e9149356d002cff) {
                if (file.name === item.name) throw new Error("item with same name already exist");
            }
        }
        this.files.push(item);
    };
    /**
     * add new directory to archive
     * @param directoryName directoryName to be created
     * @returns {void}
     */ ZipArchive.prototype.addDirectory = function(directoryName) {
        if (directoryName === null || directoryName === undefined) throw new Error("ArgumentException: string cannot be null or undefined");
        if (directoryName.length === 0) throw new Error("ArgumentException: string cannot be empty");
        if (directoryName.slice(-1) !== "/") directoryName += "/";
        if (this.files.indexOf(directoryName) !== -1) throw new Error("item with same name already exist");
        this.files.push(directoryName);
    };
    /**
     * gets item at specified index
     * @param {number} index - item index
     * @returns {ZipArchiveItem}
     */ ZipArchive.prototype.getItem = function(index) {
        if (index >= 0 && index < this.files.length) return this.files[index];
        return undefined;
    };
    /**
     * determines whether an element is in the collection
     * @param {string | ZipArchiveItem} item - item to search
     * @returns {boolean}
     */ ZipArchive.prototype.contains = function(item) {
        return this.files.indexOf(item) !== -1 ? true : false;
    };
    ZipArchive.prototype.open = function(base64String) {
        //return promise = new Promise((resolve: Function, reject: Function) => {
        var zipArchive = this;
        var zipByteArray = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).encodedString(base64String);
        if (zipByteArray.length == 0) throw new DOMException("stream");
        var stream = new (0, $a089c8693a234160$export$6a4eb2e7fc9e8903)(zipByteArray);
        //let lCentralDirEndPosition = this.findValueFromEnd( arrBuffer, Constants.CentralDirectoryEndSignature, 65557 );
        var lCentralDirEndPosition = ZipArchive.findValueFromEnd(stream, $c2dd4e274b017c1a$var$CentralDirectoryEndSignature, 65557);
        if (lCentralDirEndPosition < 0) throw new DOMException("Can't locate end of central directory record. Possible wrong file format or archive is corrupt.");
        // Step2. Locate central directory and iterate through all items
        stream.position = lCentralDirEndPosition + $c2dd4e274b017c1a$var$CentralDirSizeOffset;
        var iCentralDirSize = ZipArchive.ReadInt32(stream);
        var lCentralDirPosition = lCentralDirEndPosition - iCentralDirSize;
        // verify that this is really central directory
        stream.position = lCentralDirPosition;
        this.readCentralDirectoryDataAndExtractItems(stream);
    //});
    // let zipArchive: ZipArchive = this;
    //let promise: Promise<ZipArchive>;
    // return promise = new Promise((resolve: Function, reject: Function) => {
    //     let reader: FileReader = new FileReader();
    //     reader.onload = (e: Event) => {
    //         let data: Uint8Array = new Uint8Array((e.target as any).result);
    //         let zipReader: ZipReader = new ZipReader(data);
    //         zipReader.readEntries().then((entries: ZipEntry[]) => {
    //             for (let i: number = 0; i < entries.length; i++) {
    //                 let entry: ZipEntry = entries[i];
    //                 let item: ZipArchiveItem = new ZipArchiveItem(zipArchive, entry.fileName);
    //                 item.data = entry.data;
    //                 item.compressionMethod = entry.compressionMethod;
    //                 item.crc = entry.crc;
    //                 item.lastModified = entry.lastModified;
    //                 item.lastModifiedDate = entry.lastModifiedDate;
    //                 item.size = entry.size;
    //                 item.uncompressedSize = entry.uncompressedSize;
    //                 zipArchive.addItem(item);
    //             }
    //             resolve(zipArchive);
    //         });
    //     };
    //     reader.readAsArrayBuffer(fileName);
    // });
    };
    /// <summary>
    /// Read central directory record from the stream.
    /// </summary>
    /// <param name="stream">Stream to read from.</param>
    ZipArchive.prototype.readCentralDirectoryDataAndExtractItems = function(stream) {
        if (stream == null) throw new DOMException("stream");
        var itemHelper;
        while(ZipArchive.ReadInt32(stream) == $c2dd4e274b017c1a$var$CentralHeaderSignature){
            itemHelper = new $c2dd4e274b017c1a$export$a974b0eec5de9f8f();
            itemHelper.readCentralDirectoryData(stream);
            itemHelper;
        // let item: ZipArchiveItem = new ZipArchiveItem(this);
        // item.ReadCentralDirectoryData(stream);
        // m_arrItems.Add(item);
        }
        itemHelper.readData(stream, itemHelper.checkCrc);
        itemHelper.decompressData();
        this.files.push(new $c2dd4e274b017c1a$export$8e9149356d002cff(itemHelper.unCompressedStream.buffer, itemHelper.name));
    };
    /**
     * save archive with specified file name
     * @param {string} fileName save archive with specified file name
     * @returns {Promise<ZipArchive>}
     */ ZipArchive.prototype.save = function(fileName) {
        if (fileName === null || fileName === undefined || fileName.length === 0) throw new Error("ArgumentException: fileName cannot be null or undefined");
        if (this.files.length === 0) throw new Error("InvalidOperation");
        var zipArchive = this;
        var promise;
        return promise = new Promise(function(resolve, reject) {
            zipArchive.saveInternal(fileName, false).then(function() {
                resolve(zipArchive);
            });
        });
    };
    /**
     * Save archive as blob
     * @return {Promise<Blob>}
     */ ZipArchive.prototype.saveAsBlob = function() {
        var zipArchive = this;
        var promise;
        return promise = new Promise(function(resolve, reject) {
            zipArchive.saveInternal("", true).then(function(blob) {
                resolve(blob);
            });
        });
    };
    ZipArchive.prototype.saveInternal = function(fileName, skipFileSave) {
        var _this = this;
        var zipArchive = this;
        var promise;
        return promise = new Promise(function(resolve, reject) {
            var zipData = [];
            var dirLength = 0;
            for(var i = 0; i < zipArchive.files.length; i++){
                var compressedObject = _this.getCompressedData(_this.files[i]);
                compressedObject.then(function(data) {
                    dirLength = zipArchive.constructZippedObject(zipData, data, dirLength, data.isDirectory);
                    if (zipData.length === zipArchive.files.length) {
                        var blob = zipArchive.writeZippedContent(fileName, zipData, dirLength, skipFileSave);
                        resolve(blob);
                    }
                });
            }
        });
    };
    /**
     * release allocated un-managed resource
     * @returns {void}
     */ ZipArchive.prototype.destroy = function() {
        if (this.files !== undefined && this.files.length > 0) {
            for(var i = 0; i < this.files.length; i++){
                var file = this.files[i];
                if (file instanceof $c2dd4e274b017c1a$export$8e9149356d002cff) file.destroy();
                file = undefined;
            }
            this.files = [];
        }
        this.files = undefined;
        this.level = undefined;
    };
    ZipArchive.prototype.getCompressedData = function(item) {
        var zipArchive = this;
        var promise = new Promise(function(resolve, reject) {
            if (item instanceof $c2dd4e274b017c1a$export$8e9149356d002cff) {
                var reader_1 = new FileReader();
                reader_1.onload = function() {
                    var input = new Uint8Array(reader_1.result);
                    var data = {
                        fileName: item.name,
                        crc32Value: 0,
                        compressedData: [],
                        compressedSize: undefined,
                        uncompressedDataSize: input.length,
                        compressionType: undefined,
                        isDirectory: false
                    };
                    if (zipArchive.level === "Normal") {
                        zipArchive.compressData(input, data, $c2dd4e274b017c1a$var$CRC32TABLE);
                        var length_1 = 0;
                        for(var i = 0; i < data.compressedData.length; i++)length_1 += data.compressedData[i].length;
                        data.compressedSize = length_1;
                        data.compressionType = "\b\0"; //Deflated = 8
                    } else {
                        data.compressedSize = input.length;
                        data.crc32Value = zipArchive.calculateCrc32Value(0, input, $c2dd4e274b017c1a$var$CRC32TABLE);
                        data.compressionType = "\0\0"; // Stored = 0
                        data.compressedData.push(input);
                    }
                    resolve(data);
                };
                reader_1.readAsArrayBuffer(item.data);
            } else {
                var data = {
                    fileName: item,
                    crc32Value: 0,
                    compressedData: "",
                    compressedSize: 0,
                    uncompressedDataSize: 0,
                    compressionType: "\0\0",
                    isDirectory: true
                };
                resolve(data);
            }
        });
        return promise;
    };
    ZipArchive.prototype.compressData = function(input, data, crc32Table) {
        var compressor = new (0, $74aa42b3315e6e4b$export$c79d5db3b1b174f2)(true);
        var currentIndex = 0;
        var nextIndex = 0;
        do {
            if (currentIndex >= input.length) {
                compressor.close();
                break;
            }
            nextIndex = Math.min(input.length, currentIndex + 16384);
            var subArray = input.subarray(currentIndex, nextIndex);
            data.crc32Value = this.calculateCrc32Value(data.crc32Value, subArray, crc32Table);
            compressor.write(subArray, 0, nextIndex - currentIndex);
            currentIndex = nextIndex;
        }while (currentIndex <= input.length);
        data.compressedData = compressor.compressedData;
        compressor.destroy();
    };
    ZipArchive.prototype.constructZippedObject = function(zipParts, data, dirLength, isDirectory) {
        var extFileAttr = 0;
        var date = new Date();
        if (isDirectory) extFileAttr = extFileAttr | 0x00010; // directory flag
        extFileAttr = extFileAttr | 0;
        var header = this.writeHeader(data, date);
        var localHeader = "PK\x03\x04" + header + data.fileName;
        var centralDir = this.writeCentralDirectory(data, header, dirLength, extFileAttr);
        zipParts.push({
            localHeader: localHeader,
            centralDir: centralDir,
            compressedData: data
        });
        return dirLength + localHeader.length + data.compressedSize;
    };
    ZipArchive.prototype.writeHeader = function(data, date) {
        var zipHeader = "";
        zipHeader += "\n\0\0\0"; // version needed to extract & general purpose bit flag
        zipHeader += data.compressionType; // compression method Deflate=8,Stored=0
        zipHeader += this.getBytes(this.getModifiedTime(date), 2); // last modified Time
        zipHeader += this.getBytes(this.getModifiedDate(date), 2); // last modified date
        zipHeader += this.getBytes(data.crc32Value, 4); // crc-32 value
        zipHeader += this.getBytes(data.compressedSize, 4); // compressed file size
        zipHeader += this.getBytes(data.uncompressedDataSize, 4); // uncompressed file size
        zipHeader += this.getBytes(data.fileName.length, 2); // file name length
        zipHeader += this.getBytes(0, 2); // extra field length
        return zipHeader;
    };
    ZipArchive.prototype.writeZippedContent = function(fileName, zipData, localDirLen, skipFileSave) {
        var cenDirLen = 0;
        var buffer = [];
        for(var i = 0; i < zipData.length; i++){
            var item = zipData[i];
            cenDirLen += item.centralDir.length;
            buffer.push(this.getArrayBuffer(item.localHeader));
            while(item.compressedData.compressedData.length)buffer.push(item.compressedData.compressedData.shift().buffer);
        }
        for(var i = 0; i < zipData.length; i++)buffer.push(this.getArrayBuffer(zipData[i].centralDir));
        buffer.push(this.getArrayBuffer(this.writeFooter(zipData, cenDirLen, localDirLen)));
        var blob = new Blob(buffer, {
            type: "application/zip"
        });
        if (!skipFileSave) (0, $2da9a4aa9748e8c8$export$be11e187edb4cb0c).save(fileName, blob);
        return blob;
    };
    ZipArchive.prototype.writeCentralDirectory = function(data, localHeader, offset, externalFileAttribute) {
        var directoryHeader = "PK\x01\x02" + this.getBytes(0x0014, 2) + localHeader + // inherit from file header
        this.getBytes(0, 2) + // comment length
        "\0\0" + "\0\0" + // internal file attributes 
        this.getBytes(externalFileAttribute, 4) + // external file attributes
        this.getBytes(offset, 4) + // local fileHeader relative offset
        data.fileName;
        return directoryHeader;
    };
    ZipArchive.prototype.writeFooter = function(zipData, centralLength, localLength) {
        var dirEnd = "PK\x05\x06\0\0\0\0" + this.getBytes(zipData.length, 2) + this.getBytes(zipData.length, 2) + this.getBytes(centralLength, 4) + this.getBytes(localLength, 4) + this.getBytes(0, 2);
        return dirEnd;
    };
    ZipArchive.prototype.getArrayBuffer = function(input) {
        var a = new Uint8Array(input.length);
        for(var j = 0; j < input.length; ++j)a[j] = input.charCodeAt(j) & 0xFF;
        return a.buffer;
    };
    ZipArchive.prototype.getBytes = function(value, offset) {
        var bytes = "";
        for(var i = 0; i < offset; i++){
            bytes += String.fromCharCode(value & 0xff);
            value = value >>> 8;
        }
        return bytes;
    };
    ZipArchive.prototype.getModifiedTime = function(date) {
        var modTime = date.getHours();
        modTime = modTime << 6;
        modTime = modTime | date.getMinutes();
        modTime = modTime << 5;
        return modTime = modTime | date.getSeconds() / 2;
    };
    ZipArchive.prototype.getModifiedDate = function(date) {
        var modiDate = date.getFullYear() - 1980;
        modiDate = modiDate << 4;
        modiDate = modiDate | date.getMonth() + 1;
        modiDate = modiDate << 5;
        return modiDate = modiDate | date.getDate();
    };
    ZipArchive.prototype.calculateCrc32Value = function(crc32Value, input, crc32Table) {
        crc32Value ^= -1;
        for(var i = 0; i < input.length; i++)crc32Value = crc32Value >>> 8 ^ crc32Table[(crc32Value ^ input[i]) & 0xFF];
        return crc32Value ^ -1;
    };
    /**
     * construct cyclic redundancy code table
     * @private
     */ ZipArchive.initCrc32Table = function() {
        var i;
        for(var j = 0; j < 256; j++){
            i = j;
            for(var k = 0; k < 8; k++)i = i & 1 ? 0xEDB88320 ^ i >>> 1 : i >>> 1;
            $c2dd4e274b017c1a$var$CRC32TABLE[j] = i;
        }
    };
    ZipArchive.findValueFromEnd = function(stream, value, maxCount) {
        if (stream == null) throw new DOMException("stream");
        //   if( !stream.CanSeek || !stream.CanRead )
        //     throw new ArgumentOutOfRangeException( "We need to have seekable and readable stream." );
        // read last 4 bytes and compare with required value
        var lStreamSize = stream.inputStream.buffer.byteLength;
        if (lStreamSize < 4) return -1;
        var arrBuffer = new Uint8Array(4);
        var lLastPos = Math.max(0, lStreamSize - maxCount);
        var lCurrentPosition = lStreamSize - 1 - $c2dd4e274b017c1a$var$INT_SIZE;
        stream.position = lCurrentPosition;
        stream.read(arrBuffer, 0, $c2dd4e274b017c1a$var$INT_SIZE);
        var uiCurValue = arrBuffer[0];
        var bFound = uiCurValue == value;
        if (!bFound) while(lCurrentPosition > lLastPos){
            // remove unnecessary byte and replace it with new value.
            uiCurValue <<= 8;
            lCurrentPosition--;
            stream.position = lCurrentPosition;
            uiCurValue += stream.readByte();
            if (uiCurValue == value) {
                bFound = true;
                break;
            }
        }
        return bFound ? lCurrentPosition : -1;
    };
    /// <summary>
    /// Extracts Int32 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    ZipArchive.ReadInt32 = function(stream) {
        var buffer = new Uint8Array($c2dd4e274b017c1a$var$INT_SIZE);
        if (stream.read(buffer, 0, $c2dd4e274b017c1a$var$INT_SIZE) != $c2dd4e274b017c1a$var$INT_SIZE) throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
        return (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterToInt32(buffer, 0);
    };
    /// <summary>
    /// Extracts Int16 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    ZipArchive.ReadInt16 = function(stream) {
        var buffer = new Uint8Array($c2dd4e274b017c1a$var$SHORT_SIZE);
        if (stream.read(buffer, 0, $c2dd4e274b017c1a$var$SHORT_SIZE) != $c2dd4e274b017c1a$var$SHORT_SIZE) throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
        return (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterToInt16(buffer, 0);
    };
    /// <summary>
    /// Extracts unsigned Int16 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    ZipArchive.ReadUInt16 = function(stream) {
        var buffer = new Uint8Array($c2dd4e274b017c1a$var$SHORT_SIZE);
        if (stream.read(buffer, 0, $c2dd4e274b017c1a$var$SHORT_SIZE) != $c2dd4e274b017c1a$var$SHORT_SIZE) throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
        return (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterToInt16(buffer, 0);
    };
    return ZipArchive;
}();
var $c2dd4e274b017c1a$export$a974b0eec5de9f8f = /** @class */ function() {
    function ZipArchiveItemHelper() {
        /// <summary>
        /// Zip header signature.
        /// </summary>
        this.headerSignature = 0x04034b50;
        /// <summary>
        /// Indicates whether we should check Crc value when reading item's data. Check
        /// is performed when user gets access to decompressed data for the first time.
        /// </summary>
        this.checkCrc = true;
        /// <summary>
        /// Crc.
        /// </summary>
        this.crc32 = 0;
    }
    /// <summary>
    /// Read data from the stream based on the central directory.
    /// </summary>
    /// <param name="stream">Stream to read data from, stream.Position must point at just after correct file header.</param>
    ZipArchiveItemHelper.prototype.readCentralDirectoryData = function(stream) {
        // on the current moment we ignore "version made by" and "version needed to extract" fields.
        stream.position += 4;
        this.options = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        this.compressionMethod = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        this.checkCrc = this.compressionMethod != 99; //COmpression.Defalte != SecurityConstants.AES
        //m_bCompressed = true;
        // on the current moment we ignore "last mod file time" and "last mod file date" fields.
        var lastModified = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream);
        //LastModified = ConvertToDateTime(lastModified);
        this.crc32 = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).bitConverterToUInt32($c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream));
        this.compressedSize = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream);
        this.originalSize = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream);
        var iFileNameLength = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        var iExtraFieldLenth = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        var iCommentLength = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        // on the current moment we ignore and "disk number start" (2 bytes),
        // "internal file attributes" (2 bytes).
        stream.position += 4;
        this.externalAttributes = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream);
        this.localHeaderOffset = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream);
        var arrBuffer = new Uint8Array(iFileNameLength);
        stream.read(arrBuffer, 0, iFileNameLength);
        var m_strItemName = (0, $f67072eb46bd887e$export$d2ca453b913dcdea).byteToString(arrBuffer);
        m_strItemName = m_strItemName.replace("\\", "/");
        this.name = m_strItemName;
        stream.position += iExtraFieldLenth + iCommentLength;
        if (this.options != 0) this.options = 0;
    };
    /// <summary>
    /// Reads zipped data from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <param name="checkCrc">Indicates whether we should check crc value after data decompression.</param>
    ZipArchiveItemHelper.prototype.readData = function(stream, checkCrc) {
        if (stream.length == 0) throw new DOMException("stream");
        stream.position = this.localHeaderOffset;
        this.checkCrc = checkCrc;
        this.readLocalHeader(stream);
        this.readCompressedData(stream);
    };
    ZipArchiveItemHelper.prototype.decompressData = function() {
        if (this.compressionMethod == 8) {
            if (this.originalSize > 0) this.decompressDataOld();
        }
    };
    ZipArchiveItemHelper.prototype.decompressDataOld = function() {
        var reader = new (0, $a089c8693a234160$export$f9c1d364098b1462)(this.compressedStream, true);
        var decompressedData;
        if (this.originalSize > 0) decompressedData = new (0, $a089c8693a234160$export$6a4eb2e7fc9e8903)(new Uint8Array(this.originalSize));
        var arrBuffer = new Uint8Array($c2dd4e274b017c1a$var$BufferSize);
        var iReadBytes;
        var past = new Uint8Array(0);
        while((iReadBytes = reader.read(arrBuffer, 0, $c2dd4e274b017c1a$var$BufferSize)) > 0)//             past = new Uint8Array(decompressedData.length);
        // let currentBlock: Uint8Array = arrBuffer.subarray(0, iReadBytes);
        decompressedData.write(arrBuffer.subarray(0, iReadBytes), 0, iReadBytes);
        this.unCompressedStream = decompressedData.toByteArray();
        //   this.originalSize = decompressedData.Length;
        //   m_bControlStream = true;
        //   m_streamData = decompressedData;
        //   decompressedData.SetLength( m_lOriginalSize );
        //   decompressedData.Capacity = ( int )m_lOriginalSize;
        this.checkCrc;
    //m_streamData.Position = 0;
    };
    /// <summary>
    /// Extracts local header from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    ZipArchiveItemHelper.prototype.readLocalHeader = function(stream) {
        if (stream.length == 0) throw new DOMException("stream");
        if ($c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt32(stream) != this.headerSignature) throw new DOMException("Can't find local header signature - wrong file format or file is corrupt.");
        // TODO: it is good to verify data read from the central directory record,
        // but on the current moment we simply skip it.
        stream.position += 22;
        var iNameLength = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
        var iExtraLength = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadUInt16(stream);
        if (this.compressionMethod == 99) ;
        else if (iExtraLength > 2) {
            stream.position += iNameLength;
            var headerVal = $c2dd4e274b017c1a$export$6fef560ea28f8cc8.ReadInt16(stream);
            if (headerVal == 0x0017) throw new DOMException("UnSupported");
            else stream.position += iExtraLength - 2;
        } else stream.position += iNameLength + iExtraLength;
    };
    /// <summary>
    /// Extracts compressed data from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    ZipArchiveItemHelper.prototype.readCompressedData = function(stream) {
        var dataStream;
        if (this.compressedSize > 0) {
            var iBytesLeft = this.compressedSize;
            dataStream = new (0, $a089c8693a234160$export$6a4eb2e7fc9e8903)(new Uint8Array(iBytesLeft));
            var arrBuffer = new Uint8Array($c2dd4e274b017c1a$var$BufferSize);
            while(iBytesLeft > 0){
                var iBytesToRead = Math.min(iBytesLeft, $c2dd4e274b017c1a$var$BufferSize);
                if (stream.read(arrBuffer, 0, iBytesToRead) != iBytesToRead) throw new DOMException("End of file reached - wrong file format or file is corrupt.");
                dataStream.write(arrBuffer.subarray(0, iBytesToRead), 0, iBytesToRead);
                iBytesLeft -= iBytesToRead;
            }
            // if(m_archive.Password != null)
            // {
            //     byte[] dataBuffer = new byte[dataStream.Length];
            //     dataBuffer = dataStream.ToArray();
            //     dataStream=new MemoryStream( Decrypt(dataBuffer));
            // }
            this.compressedStream = new Uint8Array(dataStream.inputStream);
        // m_bControlStream = true;
        } else if (this.compressedSize < 0) ;
        else this.compressedSize;
    };
    return ZipArchiveItemHelper;
}();
/**
 * Class represent unique ZipArchive item
 * ```typescript
 * let archiveItem = new ZipArchiveItem(archive, 'directoryName\fileName.txt');
 * ```
 */ var $c2dd4e274b017c1a$export$8e9149356d002cff = /** @class */ function() {
    /**
     * constructor for creating {ZipArchiveItem} instance
     * @param {Blob|ArrayBuffer} data file data
     * @param {itemName} itemName absolute file path
     */ function ZipArchiveItem(data, itemName) {
        if (data === null || data === undefined) throw new Error("ArgumentException: data cannot be null or undefined");
        if (itemName === null || itemName === undefined) throw new Error("ArgumentException: string cannot be null or undefined");
        if (itemName.length === 0) throw new Error("string cannot be empty");
        this.data = data;
        this.name = itemName;
    }
    Object.defineProperty(ZipArchiveItem.prototype, "dataStream", {
        get: function() {
            return this.decompressedStream;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ZipArchiveItem.prototype, "name", {
        /**
         * Get the name of archive item
         * @returns string
         */ get: function() {
            return this.fileName;
        },
        /**
         * Set the name of archive item
         * @param  {string} value
         */ set: function(value) {
            this.fileName = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * release allocated un-managed resource
     * @returns {void}
     */ ZipArchiveItem.prototype.destroy = function() {
        this.fileName = undefined;
        this.data = undefined;
    };
    return ZipArchiveItem;
}();
 /* eslint-enable */ 

parcelRequire("j7YE8");
var $bWDaN = parcelRequire("bWDaN");
var $3EnZW = parcelRequire("3EnZW");
// import { IValueFormatter } from '../base/interface';
/**
 * ValueFormatter class to globalize the value.
 * @private
 */ /* eslint-disable */ var $5d6ae562d0454aa9$export$4ad21d94aae28a17 = /** @class */ function() {
    function ValueFormatter(cultureName) {
        this.intl = new (0, $bWDaN.Internationalization)();
    // if (!isNullOrUndefined(cultureName)) {
    //     this.intl.culture = cultureName;
    // }
    }
    ValueFormatter.prototype.getFormatFunction = function(format, isServerRendered) {
        if (format.type) {
            if (isServerRendered) format.isServerRendered = true;
            return this.intl.getDateFormat(format);
        } else return this.intl.getNumberFormat(format);
    };
    // public getParserFunction(format: NumberFormatOptions | DateFormatOptions): Function {
    //     if ((<DateFormatOptions>format).type) {
    //         return this.intl.getDateParser(<DateFormatOptions>format);
    //     } else {
    //         return this.intl.getNumberParser(<DateFormatOptions>format);
    //     }
    // }
    // public fromView(value: string, format: Function, type?: string): string | number | Date {
    //     if (type === 'date' || type === 'datetime' || type === 'number') {
    //         return format(value);
    //     } else {
    //         return value;
    //     }
    // }
    ValueFormatter.prototype.toView = function(value, format) {
        var result = value;
        if (!(0, $3EnZW.isNullOrUndefined)(format) && !(0, $3EnZW.isNullOrUndefined)(value)) result = format(value);
        return result;
    };
    // public setCulture(cultureName: string): void {
    //     if (!isNullOrUndefined(cultureName)) {
    //         setCulture(cultureName);
    //     }
    // }
    /* tslint:disable:no-any */ ValueFormatter.prototype.displayText = function(value, format, isServerRendered) {
        return this.toView(value, this.getFormatFunction(format, isServerRendered));
    };
    return ValueFormatter;
}();



/**
 * CsvHelper class
 * @private
 */ /* eslint-disable */ var $0af6de7b94a1fba7$export$a9e0444473dcb771 = /** @class */ function() {
    /* tslint:disable:no-any */ function CsvHelper(json, separator) {
        this.csvStr = "";
        if (separator === null || separator === undefined) this.separator = ",";
        else this.separator = separator;
        this.formatter = new (0, $5d6ae562d0454aa9$export$4ad21d94aae28a17)();
        this.isMicrosoftBrowser = !!navigator.msSaveBlob;
        if (json.isServerRendered !== null && json.isServerRendered !== undefined) this.isServerRendered = json.isServerRendered;
        if (json.styles !== null && json.styles !== undefined) {
            this.globalStyles = new Map();
            for(var i = 0; i < json.styles.length; i++)if (json.styles[i].name !== undefined && json.styles[i].numberFormat !== undefined) this.globalStyles.set(json.styles[i].name, json.styles[i].numberFormat);
        }
        // Parses Worksheets data to DOM.        
        if (json.worksheets !== null && json.worksheets !== undefined) this.parseWorksheet(json.worksheets[0]);
    //this.csvStr = 'a1,a2,a3\nb1,b2,b3';
    }
    CsvHelper.prototype.parseWorksheet = function(json) {
        //Rows
        if (json.rows !== null && json.rows !== undefined) this.parseRows(json.rows);
    };
    /* tslint:disable:no-any */ CsvHelper.prototype.parseRows = function(rows) {
        var count = 1;
        for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
            var row = rows_1[_i];
            //Row index
            if (row.index !== null && row.index !== undefined) {
                while(count < row.index){
                    this.csvStr += "\r\n";
                    count++;
                }
                this.parseRow(row);
            } else throw Error("Row index is missing.");
        }
        this.csvStr += "\r\n";
    };
    /* tslint:disable:no-any */ CsvHelper.prototype.parseRow = function(row) {
        if (row.cells !== null && row.cells !== undefined) {
            var count = 1;
            for(var _i = 0, _a = row.cells; _i < _a.length; _i++){
                var cell = _a[_i];
                //cell index
                if (cell.index !== null && cell.index !== undefined) {
                    while(count < cell.index){
                        this.csvStr += this.separator;
                        count++;
                    }
                    this.parseCell(cell);
                } else throw Error("Cell index is missing.");
            }
        }
    };
    /* tslint:disable:no-any */ CsvHelper.prototype.parseCell = function(cell) {
        var csv = this.csvStr;
        if (cell.value !== undefined) {
            if (cell.value instanceof Date) {
                if (cell.style !== undefined && cell.style.numberFormat !== undefined) /* tslint:disable-next-line:max-line-length */ try {
                    csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                        type: "dateTime",
                        skeleton: cell.style.numberFormat
                    }, this.isServerRendered));
                } catch (error) {
                    /* tslint:disable-next-line:max-line-length */ csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                        type: "dateTime",
                        format: cell.style.numberFormat
                    }, this.isServerRendered));
                }
                else if (cell.style !== undefined && cell.style.name !== undefined && this.globalStyles.has(cell.style.name)) /* tslint:disable-next-line:max-line-length */ try {
                    csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                        type: "dateTime",
                        skeleton: this.globalStyles.get(cell.style.name)
                    }, this.isServerRendered));
                } catch (error) {
                    /* tslint:disable-next-line:max-line-length */ csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                        type: "dateTime",
                        format: this.globalStyles.get(cell.style.name)
                    }, this.isServerRendered));
                }
                else csv += cell.value;
            } else if (typeof cell.value === "boolean") csv += cell.value ? "TRUE" : "FALSE";
            else if (typeof cell.value === "number") {
                if (cell.style !== undefined && cell.style.numberFormat !== undefined) /* tslint:disable-next-line:max-line-length */ csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                    format: cell.style.numberFormat,
                    ignoreCurrency: true
                }, this.isServerRendered));
                else if (cell.style !== undefined && cell.style.name !== undefined && this.globalStyles.has(cell.style.name)) /* tslint:disable-next-line:max-line-length */ csv += this.parseCellValue(this.formatter.displayText(cell.value, {
                    format: this.globalStyles.get(cell.style.name),
                    ignoreCurrency: true
                }, this.isServerRendered));
                else csv += cell.value;
            } else csv += this.parseCellValue(cell.value);
        }
        this.csvStr = csv;
    };
    CsvHelper.prototype.parseCellValue = function(value) {
        var val = "";
        var length = value.length;
        for(var start = 0; start < length; start++)if (value[start] === '"') val += value[start].replace('"', '""');
        else val += value[start];
        value = val;
        if (value.indexOf(this.separator) !== -1 || value.indexOf("\n") !== -1 || value.indexOf('"') !== -1) return value = '"' + value + '"';
        else return value;
    };
    /**
     * Saves the file with specified name and sends the file to client browser
     * @param  {string} fileName- file name to save.
     * @param  {Blob} buffer- the content to write in file
     */ CsvHelper.prototype.save = function(fileName) {
        this.buffer = new Blob([
            "\uFEFF" + this.csvStr
        ], {
            type: "text/csv;charset=UTF-8"
        });
        if (this.isMicrosoftBrowser) navigator.msSaveBlob(this.buffer, fileName);
        else {
            var dataUrl_1 = window.URL.createObjectURL(this.buffer);
            var dwlLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            dwlLink.download = fileName;
            dwlLink.href = dataUrl_1;
            var event_1 = document.createEvent("MouseEvent");
            event_1.initEvent("click", true, true);
            dwlLink.dispatchEvent(event_1);
            setTimeout(function() {
                window.URL.revokeObjectURL(dataUrl_1);
            });
        }
    };
    /**
    * Returns a Blob object containing CSV data with optional encoding.
    * @param {string} [encodingType] - The supported encoding types are "ansi", "unicode" and "utf8".
    */ /* tslint:disable:no-any */ CsvHelper.prototype.saveAsBlob = function(encodingType) {
        if (encodingType != undefined) {
            var encoding = new (0, $d16335ea6d5a8183$export$72958ca7c468c63b)();
            var encodeString = "UTF-8";
            if (encodingType.toUpperCase() == "ANSI") {
                encoding.type = "Ansi";
                encodeString = "ANSI";
            } else if (encodingType.toUpperCase() == "UNICODE") {
                encoding.type = "Unicode";
                encodeString = "UNICODE";
            } else {
                encoding.type = "Utf8";
                encodeString = "UTF-8";
            }
            var buffer = encoding.getBytes(this.csvStr, 0, this.csvStr.length);
            return new Blob([
                buffer
            ], {
                type: "text/csv;charset=" + encodeString
            });
        } else return new Blob([
            "\uFEFF" + this.csvStr
        ], {
            type: "text/csv;charset=UTF-8"
        });
    };
    return CsvHelper;
}();


parcelRequire("j7YE8");
var $bWDaN = parcelRequire("bWDaN");
var $3EnZW = parcelRequire("3EnZW");
/**
 * BlobHelper class
 * @private
 */ /* eslint-disable */ var $91022db04aa48828$export$1846e193db7166fd = /** @class */ function() {
    function BlobHelper() {
        /* tslint:disable:no-any */ this.parts = [];
    }
    /* tslint:disable:no-any */ BlobHelper.prototype.append = function(part) {
        this.parts.push(part);
        this.blob = undefined; // Invalidate the blob
    };
    BlobHelper.prototype.getBlob = function() {
        return new Blob(this.parts, {
            type: "text/plain"
        });
    };
    return BlobHelper;
}();


/**
 * AutoFilters class
 * @private
 */ /* eslint-disable */ var $dcad8a7a99c65072$export$d013f69c76501a03 = /** @class */ function() {
    function AutoFilters() {}
    return AutoFilters;
}();


/**
 * Workbook class
 */ /* eslint-disable */ var $1539d026739990ad$export$886c8830dfe227e7 = /** @class */ function() {
    /* tslint:disable:no-any */ function Workbook(json, saveType, culture, currencyString, separator) {
        this.sharedStringCount = 0;
        this.unitsProportions = [
            1.28,
            0.32,
            96,
            96 / 25.4,
            96 / 2.54,
            1,
            96 / 72.0,
            96 / 72.0 / 12700
        ];
        /* tslint:disable:no-any */ this.hyperlinkStyle = {
            fontColor: "#0000FF",
            underline: true
        };
        if (culture !== undefined) this.culture = culture;
        else this.culture = "en-US";
        if (currencyString !== undefined) this.currency = currencyString;
        else this.currency = "USD";
        this.intl = new (0, $bWDaN.Internationalization)(this.culture);
        this.mSaveType = saveType;
        if (saveType === "xlsx") {
            this.mArchive = new (0, $c2dd4e274b017c1a$export$6fef560ea28f8cc8)();
            this.sharedString = [];
            this.mFonts = [];
            this.mBorders = [];
            this.mStyles = [];
            this.printTitles = new Map();
            this.cellStyles = new Map();
            this.mNumFmt = new Map();
            this.mFills = new Map();
            this.mStyles.push(new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)());
            this.mFonts.push(new (0, $46b0c7517f7f6010$export$89abf52a030e56ee)());
            /* tslint:disable */ this.cellStyles.set("Normal", new (0, $46b0c7517f7f6010$export$4d06df561c8b8a10)());
            /* tslint:enable */ this.mCellXfs = [];
            this.mCellStyleXfs = [];
            this.drawingCount = 0;
            this.imageCount = 0;
            if (json.styles !== null && json.styles !== undefined) {
                /* tslint:disable-next-line:no-any */ this.globalStyles = new Map();
                for(var i = 0; i < json.styles.length; i++)if (json.styles[i].name !== undefined) {
                    if (!this.cellStyles.has(json.styles[i].name)) {
                        var cellStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
                        cellStyle.isGlobalStyle = true;
                        this.parserCellStyle(json.styles[i], cellStyle, "none");
                        var cellStylesIn = new (0, $46b0c7517f7f6010$export$4d06df561c8b8a10)();
                        cellStylesIn.name = cellStyle.name;
                        cellStylesIn.xfId = cellStyle.index - 1;
                        this.cellStyles.set(cellStylesIn.name, cellStylesIn);
                        /* tslint:disable-next-line:no-any */ var tFormat = {};
                        if (json.styles[i].numberFormat !== undefined) tFormat.format = json.styles[i].numberFormat;
                        if (json.styles[i].type !== undefined) tFormat.type = json.styles[i].type;
                        else tFormat.type = "datetime";
                        if (tFormat.format !== undefined) this.globalStyles.set(json.styles[i].name, tFormat);
                    } else throw Error("Style name " + json.styles[i].name + " is already existed");
                }
            }
            // Parses Worksheets data to DOM.        
            if (json.worksheets !== null && json.worksheets !== undefined) this.parserWorksheets(json.worksheets);
            else throw Error("Worksheet is expected.");
            // Parses the BuiltInProperties data to DOM.        
            if (json.builtInProperties !== null && json.builtInProperties !== undefined) {
                this.builtInProperties = new $1539d026739990ad$export$800e564db2edc59c();
                this.parserBuiltInProperties(json.builtInProperties, this.builtInProperties);
            }
        } else this.csvHelper = new (0, $0af6de7b94a1fba7$export$a9e0444473dcb771)(json, separator);
    }
    /* tslint:disable:no-any */ Workbook.prototype.parserBuiltInProperties = function(jsonBuiltInProperties, builtInProperties) {
        //Author
        if (jsonBuiltInProperties.author !== null && jsonBuiltInProperties.author !== undefined) builtInProperties.author = jsonBuiltInProperties.author;
        //Comments
        if (jsonBuiltInProperties.comments !== null && jsonBuiltInProperties.comments !== undefined) builtInProperties.comments = jsonBuiltInProperties.comments;
        //Category
        if (jsonBuiltInProperties.category !== null && jsonBuiltInProperties.category !== undefined) builtInProperties.category = jsonBuiltInProperties.category;
        //Company
        if (jsonBuiltInProperties.company !== null && jsonBuiltInProperties.company !== undefined) builtInProperties.company = jsonBuiltInProperties.company;
        //Manager
        if (jsonBuiltInProperties.manager !== null && jsonBuiltInProperties.manager !== undefined) builtInProperties.manager = jsonBuiltInProperties.manager;
        //Subject
        if (jsonBuiltInProperties.subject !== null && jsonBuiltInProperties.subject !== undefined) builtInProperties.subject = jsonBuiltInProperties.subject;
        //Title
        if (jsonBuiltInProperties.title !== null && jsonBuiltInProperties.title !== undefined) builtInProperties.title = jsonBuiltInProperties.title;
        //Creation date
        if (jsonBuiltInProperties.createdDate !== null && jsonBuiltInProperties.createdDate !== undefined) builtInProperties.createdDate = jsonBuiltInProperties.createdDate;
        //Modified date
        if (jsonBuiltInProperties.modifiedDate !== null && jsonBuiltInProperties.modifiedDate !== undefined) builtInProperties.modifiedDate = jsonBuiltInProperties.modifiedDate;
        //Tags
        if (jsonBuiltInProperties.tags !== null && jsonBuiltInProperties.tags !== undefined) builtInProperties.tags = jsonBuiltInProperties.tags;
        //Status
        if (jsonBuiltInProperties.status !== null && jsonBuiltInProperties.status !== undefined) builtInProperties.status = jsonBuiltInProperties.status;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserWorksheets = function(json) {
        this.worksheets = new (0, $9c109334a35cffc4$export$452036259364aa71)();
        var length = json.length;
        for(var i = 0; i < length; i++){
            var jsonSheet = json[i];
            var sheet = new (0, $67d8c6e4cf60a7eb$export$9149bd1ee08cae1b)();
            this.mergeCells = new (0, $67d8c6e4cf60a7eb$export$3ad3169641d18926)();
            this.mergedCellsStyle = new Map();
            this.mHyperLinks = [];
            //Name
            if (jsonSheet.name !== null && jsonSheet.name !== undefined) sheet.name = jsonSheet.name;
            else sheet.name = "Sheet" + (i + 1).toString();
            if (jsonSheet.enableRtl !== null && jsonSheet.enableRtl !== undefined) sheet.enableRtl = jsonSheet.enableRtl;
            sheet.index = i + 1;
            //Columns
            if (jsonSheet.columns !== null && jsonSheet.columns !== undefined) this.parserColumns(jsonSheet.columns, sheet);
            //Rows
            if (jsonSheet.rows !== null && jsonSheet.rows !== undefined) this.parserRows(jsonSheet.rows, sheet);
            //showGridLines
            if (jsonSheet.showGridLines !== null && jsonSheet.showGridLines !== undefined) sheet.showGridLines = jsonSheet.showGridLines;
            //FreezePanes
            if (jsonSheet.freeze !== null && jsonSheet.freeze !== undefined) this.parserFreezePanes(jsonSheet.freeze, sheet);
            //Print Title
            if (jsonSheet.printTitle !== null && jsonSheet.printTitle !== undefined) this.parserPrintTitle(jsonSheet.printTitle, sheet);
            if (jsonSheet.pageSetup !== undefined) {
                if (jsonSheet.pageSetup.isSummaryRowBelow !== undefined) sheet.isSummaryRowBelow = jsonSheet.pageSetup.isSummaryRowBelow;
            }
            if (jsonSheet.images !== undefined) this.parserImages(jsonSheet.images, sheet);
            if (jsonSheet.autoFilters !== null && jsonSheet.autoFilters !== undefined) this.parseFilters(jsonSheet.autoFilters, sheet);
            sheet.index = i + 1;
            sheet.mergeCells = this.mergeCells;
            sheet.hyperLinks = this.mHyperLinks;
            this.worksheets.push(sheet);
        }
    };
    /* tslint:disable:no-any */ Workbook.prototype.mergeOptions = function(fromJson, toJson) {
        /* tslint:disable:no-any */ var result = {};
        this.applyProperties(fromJson, result);
        this.applyProperties(toJson, result);
        return result;
    };
    /* tslint:disable:no-any */ Workbook.prototype.applyProperties = function(sourceJson, destJson) {
        var keys = Object.keys(sourceJson);
        for(var index = 0; index < keys.length; index++)if (keys[index] !== "name") destJson[keys[index]] = sourceJson[keys[index]];
    };
    Workbook.prototype.getCellName = function(row, column) {
        return this.getColumnName(column) + row.toString();
    };
    Workbook.prototype.getColumnName = function(col) {
        col--;
        var strColumnName = "";
        do {
            var iCurrentDigit = col % 26;
            col = col / 26 - 1;
            strColumnName = String.fromCharCode(65 + iCurrentDigit) + strColumnName;
        }while (col >= 0);
        return strColumnName;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserPrintTitle = function(json, sheet) {
        var printTitleName = "";
        var titleRowName;
        if (json.fromRow !== null && json.fromRow !== undefined) {
            var fromRow = json.fromRow;
            var toRow = void 0;
            if (json.toRow !== null && json.toRow !== undefined) toRow = json.toRow;
            else toRow = json.fromRow;
            titleRowName = "$" + fromRow + ":$" + toRow;
        }
        var titleColName;
        if (json.fromColumn !== null && json.fromColumn !== undefined) {
            var fromColumn = json.fromColumn;
            var toColumn = void 0;
            if (json.toColumn !== null && json.toColumn !== undefined) toColumn = json.toColumn;
            else toColumn = json.fromColumn;
            titleColName = "$" + this.getColumnName(fromColumn) + ":$" + this.getColumnName(toColumn);
        }
        if (titleRowName !== undefined) printTitleName += sheet.name + "!" + titleRowName;
        if (titleColName !== undefined && titleRowName !== undefined) printTitleName += "," + (sheet.name + "!" + titleColName);
        else if (titleColName !== undefined) printTitleName += sheet.name + "!" + titleColName;
        if (printTitleName !== "") this.printTitles.set(sheet.index - 1, printTitleName);
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserFreezePanes = function(json, sheet) {
        sheet.freezePanes = new (0, $67d8c6e4cf60a7eb$export$dab43b34d064965)();
        if (json.row !== null && json.row !== undefined) sheet.freezePanes.row = json.row;
        else sheet.freezePanes.row = 0;
        if (json.column !== null && json.column !== undefined) sheet.freezePanes.column = json.column;
        else sheet.freezePanes.column = 0;
        sheet.freezePanes.leftCell = this.getCellName(sheet.freezePanes.row + 1, sheet.freezePanes.column + 1);
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserColumns = function(json, sheet) {
        var columnsLength = json.length;
        sheet.columns = [];
        for(var column = 0; column < columnsLength; column++){
            var col = new (0, $af687566b951b90e$export$816b5d811295e6bc)();
            if (json[column].index !== null && json[column].index !== undefined) col.index = json[column].index;
            else throw Error("Column index is missing.");
            if (json[column].width !== null && json[column].width !== undefined) col.width = json[column].width;
            sheet.columns.push(col);
        }
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserRows = function(json, sheet) {
        var rowsLength = json.length;
        sheet.rows = new (0, $c82e544914982989$export$9ba739f4e3fc4d9)();
        var rowId = 0;
        for(var r = 0; r < rowsLength; r++){
            var row = this.parserRow(json[r], rowId);
            rowId = row.index;
            sheet.rows.add(row);
        }
        this.insertMergedCellsStyle(sheet);
    };
    Workbook.prototype.insertMergedCellsStyle = function(sheet) {
        var _this = this;
        if (this.mergeCells.length > 0) this.mergedCellsStyle.forEach(function(value, key) {
            var row = sheet.rows.filter(function(item) {
                return item.index === value.y;
            })[0];
            if (!(0, $3EnZW.isNullOrUndefined)(row)) {
                var cell = row.cells.filter(function(item) {
                    return item.index === value.x;
                })[0];
                if (!(0, $3EnZW.isNullOrUndefined)(cell)) cell.styleIndex = value.styleIndex;
                else {
                    var cells = row.cells.filter(function(item) {
                        return item.index <= value.x;
                    });
                    var insertIndex = 0;
                    if (cells.length > 0) insertIndex = row.cells.indexOf(cells[cells.length - 1]) + 1;
                    row.cells.splice(insertIndex, 0, _this.createCell(value, key));
                }
            } else {
                var rows = sheet.rows.filter(function(item) {
                    return item.index <= value.y;
                });
                var rowToInsert = new (0, $c82e544914982989$export$b59bdbef9ce70de2)();
                rowToInsert.index = value.y;
                rowToInsert.cells = new (0, $85645432c0358509$export$99889833ab266a29)();
                rowToInsert.cells.add(_this.createCell(value, key));
                var insertIndex = 0;
                if (rows.length > 0) insertIndex = sheet.rows.indexOf(rows[rows.length - 1]) + 1;
                sheet.rows.splice(insertIndex, 0, rowToInsert);
            }
        });
    };
    Workbook.prototype.createCell = function(value, key) {
        var cellToInsert = new (0, $85645432c0358509$export$f6f0c3fe4ec306ea)();
        cellToInsert.refName = key;
        cellToInsert.index = value.x;
        cellToInsert.cellStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
        cellToInsert.styleIndex = value.styleIndex;
        return cellToInsert;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserRow = function(json, rowIndex) {
        var row = new (0, $c82e544914982989$export$b59bdbef9ce70de2)();
        //Row Height
        if (json.height !== null && json.height !== undefined) row.height = json.height;
        //Row index
        if (json.index !== null && json.index !== undefined) row.index = json.index;
        else throw Error("Row index is missing.");
        if (json.grouping !== null && json.grouping !== undefined) this.parseGrouping(json.grouping, row);
        this.parseCells(json.cells, row);
        return row;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parseGrouping = function(json, row) {
        row.grouping = new (0, $67d8c6e4cf60a7eb$export$3885c0af90651e94)();
        if (json.outlineLevel !== undefined) row.grouping.outlineLevel = json.outlineLevel;
        if (json.isCollapsed !== undefined) row.grouping.isCollapsed = json.isCollapsed;
        if (json.isHidden !== undefined) row.grouping.isHidden = json.isHidden;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parseCells = function(json, row) {
        row.cells = new (0, $85645432c0358509$export$99889833ab266a29)();
        var cellsLength = json !== undefined ? json.length : 0;
        var spanMin = 1;
        var spanMax = 1;
        var curCellIndex = 0;
        for(var cellId = 0; cellId < cellsLength; cellId++){
            /* tslint:disable:no-any */ var jsonCell = json[cellId];
            var cell = new (0, $85645432c0358509$export$f6f0c3fe4ec306ea)();
            //cell index
            if (jsonCell.index !== null && jsonCell.index !== undefined) cell.index = jsonCell.index;
            else throw Error("Cell index is missing.");
            if (cell.index < spanMin) spanMin = cell.index;
            else if (cell.index > spanMax) spanMax = cell.index;
            //Update the Cell name
            cell.refName = this.getCellName(row.index, cell.index);
            //Row span
            if (jsonCell.rowSpan !== null && jsonCell.rowSpan !== undefined) cell.rowSpan = jsonCell.rowSpan - 1;
            else cell.rowSpan = 0;
            //Column span
            if (jsonCell.colSpan !== null && jsonCell.colSpan !== undefined) cell.colSpan = jsonCell.colSpan - 1;
            else cell.colSpan = 0;
            //Hyperlink
            if (jsonCell.hyperlink !== null && jsonCell.hyperlink !== undefined) {
                var hyperLink = new (0, $67d8c6e4cf60a7eb$export$9ffbcd112f010b63)();
                if (jsonCell.hyperlink.target !== undefined) {
                    hyperLink.target = jsonCell.hyperlink.target;
                    if (jsonCell.hyperlink.displayText !== undefined) cell.value = jsonCell.hyperlink.displayText;
                    else cell.value = jsonCell.hyperlink.target;
                    cell.type = this.getCellValueType(cell.value);
                    hyperLink.ref = cell.refName;
                    hyperLink.rId = this.mHyperLinks.length + 1;
                    this.mHyperLinks.push(hyperLink);
                    cell.cellStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
                    /* tslint:disable-next-line:max-line-length */ this.parserCellStyle(jsonCell.style !== undefined ? this.mergeOptions(jsonCell.style, this.hyperlinkStyle) : this.hyperlinkStyle, cell.cellStyle, "string");
                    cell.styleIndex = cell.cellStyle.index;
                }
            }
            // formulas
            if (jsonCell.formula !== null && jsonCell.formula !== undefined) {
                cell.formula = jsonCell.formula;
                cell.type = "formula";
            }
            //Cell value
            if (jsonCell.value !== null && jsonCell.value !== undefined) {
                if (cell.formula !== undefined) cell.value = 0;
                else {
                    cell.value = jsonCell.value;
                    cell.type = this.getCellValueType(cell.value);
                }
            }
            if (jsonCell.style !== null && jsonCell.style !== undefined && cell.styleIndex === undefined) {
                cell.cellStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
                if (cell.value instanceof Date) this.parserCellStyle(jsonCell.style, cell.cellStyle, cell.type, 14);
                else this.parserCellStyle(jsonCell.style, cell.cellStyle, cell.type);
                cell.styleIndex = cell.cellStyle.index;
            } else if (cell.value instanceof Date) {
                cell.cellStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
                this.parserCellStyle({}, cell.cellStyle, cell.type, 14);
                cell.styleIndex = cell.cellStyle.index;
            }
            this.parseCellType(cell);
            this.mergeCells = this.processMergeCells(cell, row.index, this.mergeCells);
            row.cells.add(cell);
            curCellIndex = cell.index + 1;
        }
        row.spans = spanMin + ":" + spanMax;
    };
    Workbook.prototype.GetColors = function() {
        var colors;
        colors = new Map();
        /* tslint:disable */ colors.set("WHITE", "FFFFFFFF");
        /* tslint:disable */ colors.set("SILVER", "FFC0C0C0");
        /* tslint:disable */ colors.set("GRAY", "FF808080");
        /* tslint:disable */ colors.set("BLACK", "FF000000");
        /* tslint:disable */ colors.set("RED", "FFFF0000");
        /* tslint:disable */ colors.set("MAROON", "FF800000");
        /* tslint:disable */ colors.set("YELLOW", "FFFFFF00");
        /* tslint:disable */ colors.set("OLIVE", "FF808000");
        /* tslint:disable */ colors.set("LIME", "FF00FF00");
        /* tslint:disable */ colors.set("GREEN", "FF008000");
        /* tslint:disable */ colors.set("AQUA", "FF00FFFF");
        /* tslint:disable */ colors.set("TEAL", "FF008080");
        /* tslint:disable */ colors.set("BLUE", "FF0000FF");
        /* tslint:disable */ colors.set("NAVY", "FF000080");
        /* tslint:disable */ colors.set("FUCHSIA", "FFFF00FF");
        /* tslint:disable */ colors.set("PURPLE", "FF800080");
        return colors;
    };
    Workbook.prototype.processColor = function(colorVal) {
        if (colorVal.indexOf("#") === 0) return colorVal.replace("#", "FF");
        colorVal = colorVal.toUpperCase();
        this.rgbColors = this.GetColors();
        if (this.rgbColors.has(colorVal)) colorVal = this.rgbColors.get(colorVal);
        else colorVal = "FF000000";
        return colorVal;
    };
    Workbook.prototype.processCellValue = function(value, cell) {
        var cellValue = value;
        if (value.indexOf("<font") !== -1 || value.indexOf("<a") !== -1 || value.indexOf("<b>") !== -1 || value.indexOf("<i>") !== -1 || value.indexOf("<u>") !== -1) {
            var processedVal = "";
            var startindex = value.indexOf("<", 0);
            var endIndex = value.indexOf(">", startindex + 1);
            if (startindex >= 0 && endIndex >= 0) {
                if (startindex !== 0) processedVal += '<r><t xml:space="preserve">' + this.processString(value.substring(0, startindex)) + "</t></r>";
                while(startindex >= 0 && endIndex >= 0){
                    endIndex = value.indexOf(">", startindex + 1);
                    if (endIndex >= 0) {
                        var subString = value.substring(startindex + 1, endIndex);
                        startindex = value.indexOf("<", endIndex + 1);
                        if (startindex < 0) startindex = cellValue.length;
                        var text = cellValue.substring(endIndex + 1, startindex);
                        if (text.length !== 0) {
                            var subSplit = subString.split(" ");
                            if (subSplit.length > 0) processedVal += "<r><rPr>";
                            if (subSplit.length > 1) for(var _i = 0, subSplit_1 = subSplit; _i < subSplit_1.length; _i++){
                                var element = subSplit_1[_i];
                                var start = element.trim().substring(0, 5);
                                switch(start){
                                    case "size=":
                                        processedVal += '<sz val="' + element.substring(6, element.length - 1) + '"/>';
                                        break;
                                    case "face=":
                                        processedVal += '<rFont val="' + element.substring(6, element.length - 1) + '"/>';
                                        break;
                                    case "color":
                                        processedVal += '<color rgb="' + this.processColor(element.substring(7, element.length - 1)) + '"/>';
                                        break;
                                    case "href=":
                                        var hyperLink = new (0, $67d8c6e4cf60a7eb$export$9ffbcd112f010b63)();
                                        hyperLink.target = element.substring(6, element.length - 1).trim();
                                        hyperLink.ref = cell.refName;
                                        hyperLink.rId = this.mHyperLinks.length + 1;
                                        this.mHyperLinks.push(hyperLink);
                                        processedVal += '<color rgb="FF0000FF"/><u/><b/>';
                                        break;
                                }
                            }
                            else if (subSplit.length === 1) {
                                var style = subSplit[0].trim();
                                switch(style){
                                    case "b":
                                        processedVal += "<b/>";
                                        break;
                                    case "i":
                                        processedVal += "<i/>";
                                        break;
                                    case "u":
                                        processedVal += "<u/>";
                                        break;
                                }
                            }
                            processedVal += '</rPr><t xml:space="preserve">' + this.processString(text) + "</t></r>";
                        }
                    }
                }
                if (processedVal === "") return cellValue;
                return processedVal;
            } else return cellValue;
        } else return cellValue;
    };
    Workbook.prototype.applyGlobalStyle = function(json, cellStyle) {
        var index = 0;
        if (this.cellStyles.has(json.name)) {
            cellStyle.index = this.mStyles.filter(function(a) {
                return a.name === json.name;
            })[0].index;
            cellStyle.name = json.name;
        }
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserCellStyle = function(json, cellStyle, cellType, defStyleIndex) {
        //name
        if (json.name !== null && json.name !== undefined) {
            if (cellStyle.isGlobalStyle) cellStyle.name = json.name;
            else {
                this.applyGlobalStyle(json, cellStyle);
                return;
            }
        }
        //background color
        if (json.backColor !== null && json.backColor !== undefined) cellStyle.backColor = json.backColor;
        //borders
        //leftBorder
        cellStyle.borders = new (0, $46b0c7517f7f6010$export$fe4fc692d691c0b0)();
        //AllBorder
        if (json.borders !== null && json.borders !== undefined) this.parserBorder(json.borders, cellStyle.borders.all);
        //leftborder
        if (json.leftBorder !== null && json.leftBorder !== undefined) this.parserBorder(json.leftBorder, cellStyle.borders.left);
        //rightBorder
        if (json.rightBorder !== null && json.rightBorder !== undefined) this.parserBorder(json.rightBorder, cellStyle.borders.right);
        //topBorder
        if (json.topBorder !== null && json.topBorder !== undefined) this.parserBorder(json.topBorder, cellStyle.borders.top);
        //bottomBorder
        if (json.bottomBorder !== null && json.bottomBorder !== undefined) this.parserBorder(json.bottomBorder, cellStyle.borders.bottom);
        //fontName
        if (json.fontName !== null && json.fontName !== undefined) cellStyle.fontName = json.fontName;
        //fontSize
        if (json.fontSize !== null && json.fontSize !== undefined) cellStyle.fontSize = json.fontSize;
        //fontColor
        if (json.fontColor !== null && json.fontColor !== undefined) cellStyle.fontColor = json.fontColor;
        //italic
        if (json.italic !== null && json.italic !== undefined) cellStyle.italic = json.italic;
        //bold
        if (json.bold !== null && json.bold !== undefined) cellStyle.bold = json.bold;
        //hAlign
        if (json.hAlign !== null && json.hAlign !== undefined) cellStyle.hAlign = json.hAlign.toLowerCase();
        //indent
        if (json.indent !== null && json.indent !== undefined) {
            cellStyle.indent = json.indent;
            if (!(cellStyle.hAlign === "left" || cellStyle.hAlign === "right")) cellStyle.hAlign = "left";
        }
        if (json.rotation !== null && json.rotation !== undefined) cellStyle.rotation = json.rotation;
        //vAlign
        if (json.vAlign !== null && json.vAlign !== undefined) cellStyle.vAlign = json.vAlign.toLowerCase();
        //underline
        if (json.underline !== null && json.underline !== undefined) cellStyle.underline = json.underline;
        //strikeThrough
        if (json.strikeThrough !== null && json.strikeThrough !== undefined) cellStyle.strikeThrough = json.strikeThrough;
        //wrapText
        if (json.wrapText !== null && json.wrapText !== undefined) cellStyle.wrapText = json.wrapText;
        //numberFormat
        if (json.numberFormat !== null && json.numberFormat !== undefined) {
            if (json.type !== null && json.type !== undefined) cellStyle.numberFormat = this.getNumberFormat(json.numberFormat, json.type);
            else cellStyle.numberFormat = this.getNumberFormat(json.numberFormat, cellType);
        } else if (defStyleIndex !== undefined) {
            cellStyle.numFmtId = 14;
            cellStyle.numberFormat = "GENERAL";
        } else cellStyle.numberFormat = "GENERAL";
        cellStyle.index = this.processCellStyle(cellStyle);
    };
    Workbook.prototype.switchNumberFormat = function(numberFormat, type) {
        var format = this.getNumberFormat(numberFormat, type);
        if (format !== numberFormat) {
            var numFmt = this.mNumFmt.get(numberFormat);
            if (numFmt !== undefined) {
                numFmt.formatCode = format;
                if (this.mNumFmt.has(format)) {
                    for(var _i = 0, _a = this.mCellStyleXfs; _i < _a.length; _i++){
                        var cellStyleXfs = _a[_i];
                        if (cellStyleXfs.numFmtId === numFmt.numFmtId) cellStyleXfs.numFmtId = this.mNumFmt.get(format).numFmtId;
                    }
                    for(var _b = 0, _c = this.mCellXfs; _b < _c.length; _b++){
                        var cellXfs = _c[_b];
                        if (cellXfs.numFmtId === numFmt.numFmtId) cellXfs.numFmtId = this.mNumFmt.get(format).numFmtId;
                    }
                }
            }
        }
    };
    Workbook.prototype.changeNumberFormats = function(value) {
        if (typeof value == "string") {
            var regex = new RegExp(this.currency, "g");
            value = value.replace(regex, "[$" + this.currency + "]");
        } else if (typeof value == "object") for(var i = 0; i < value.length; i++)value[i] = value[i].replace(this.currency, "[$" + this.currency + "]");
        return value;
    };
    Workbook.prototype.getNumberFormat = function(numberFormat, type) {
        var returnFormat;
        switch(type){
            case "number":
                try {
                    returnFormat = this.intl.getNumberPattern({
                        format: numberFormat,
                        currency: this.currency,
                        useGrouping: true
                    }, true);
                    if (this.currency.length > 1) returnFormat = this.changeNumberFormats(returnFormat);
                } catch (error) {
                    returnFormat = numberFormat;
                }
                break;
            case "datetime":
                try {
                    returnFormat = this.intl.getDatePattern({
                        skeleton: numberFormat,
                        type: "dateTime"
                    }, true);
                } catch (error) {
                    try {
                        returnFormat = this.intl.getDatePattern({
                            format: numberFormat,
                            type: "dateTime"
                        }, true);
                    } catch (error) {
                        returnFormat = numberFormat;
                    }
                }
                break;
            case "date":
                try {
                    returnFormat = this.intl.getDatePattern({
                        skeleton: numberFormat,
                        type: "date"
                    }, true);
                } catch (error) {
                    try {
                        returnFormat = this.intl.getDatePattern({
                            format: numberFormat,
                            type: "date"
                        }, true);
                    } catch (error) {
                        returnFormat = numberFormat;
                    }
                }
                break;
            case "time":
                try {
                    returnFormat = this.intl.getDatePattern({
                        skeleton: numberFormat,
                        type: "time"
                    }, true);
                } catch (error) {
                    try {
                        returnFormat = this.intl.getDatePattern({
                            format: numberFormat,
                            type: "time"
                        }, true);
                    } catch (error) {
                        returnFormat = numberFormat;
                    }
                }
                break;
            default:
                returnFormat = numberFormat;
                break;
        }
        return returnFormat;
    };
    /* tslint:disable:no-any */ Workbook.prototype.parserBorder = function(json, border) {
        if (json.color !== null && json.color !== undefined) border.color = json.color;
        else border.color = "#000000";
        if (json.lineStyle !== null && json.lineStyle !== undefined) border.lineStyle = json.lineStyle;
        else border.lineStyle = "thin";
    };
    Workbook.prototype.processCellStyle = function(style) {
        if (style.isGlobalStyle) {
            this.processNumFormatId(style);
            this.mStyles.push(style);
            return this.mStyles.length;
        } else {
            var compareResult = this.compareStyle(style);
            if (!compareResult.result) {
                this.processNumFormatId(style);
                this.mStyles.push(style);
                return this.mStyles.length;
            } else //Return the index of the already existing style.
            return compareResult.index;
        }
    };
    Workbook.prototype.processNumFormatId = function(style) {
        if (style.numberFormat !== "GENERAL" && !this.mNumFmt.has(style.numberFormat)) {
            var id = this.mNumFmt.size + 164;
            this.mNumFmt.set(style.numberFormat, new (0, $46b0c7517f7f6010$export$8a1320b211f3c33f)(id, style.numberFormat));
        }
    };
    Workbook.prototype.isNewFont = function(toCompareStyle) {
        var result = false;
        var index = 0;
        for(var _i = 0, _a = this.mFonts; _i < _a.length; _i++){
            var font = _a[_i];
            index++;
            var fontColor = undefined;
            if (toCompareStyle.fontColor !== undefined) fontColor = "FF" + toCompareStyle.fontColor.replace("#", "");
            result = font.color === fontColor && font.b === toCompareStyle.bold && font.i === toCompareStyle.italic && font.u === toCompareStyle.underline && font.strike === toCompareStyle.strikeThrough && font.name === toCompareStyle.fontName && font.sz === toCompareStyle.fontSize;
            if (result) break;
        }
        index = index - 1;
        return {
            index: index,
            result: result
        };
    };
    Workbook.prototype.isNewBorder = function(toCompareStyle) {
        var bStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
        if (this.isAllBorder(toCompareStyle.borders)) return bStyle.borders.all.color === toCompareStyle.borders.all.color && bStyle.borders.all.lineStyle === toCompareStyle.borders.all.lineStyle;
        else return bStyle.borders.left.color === toCompareStyle.borders.left.color && bStyle.borders.left.lineStyle === toCompareStyle.borders.left.lineStyle && bStyle.borders.right.color === toCompareStyle.borders.right.color && bStyle.borders.right.lineStyle === toCompareStyle.borders.right.lineStyle && bStyle.borders.top.color === toCompareStyle.borders.top.color && bStyle.borders.top.lineStyle === toCompareStyle.borders.top.lineStyle && bStyle.borders.bottom.color === toCompareStyle.borders.bottom.color && bStyle.borders.bottom.lineStyle === toCompareStyle.borders.bottom.lineStyle;
    };
    Workbook.prototype.isAllBorder = function(toCompareBorder) {
        var allBorderStyle = new (0, $46b0c7517f7f6010$export$6dcbd134ed4660ff)();
        return allBorderStyle.borders.all.color !== toCompareBorder.all.color && allBorderStyle.borders.all.lineStyle !== toCompareBorder.all.lineStyle;
    };
    Workbook.prototype.compareStyle = function(toCompareStyle) {
        var result = true;
        var index = 0;
        var globalStyleIndex = 0;
        for(var _i = 0, _a = this.mStyles; _i < _a.length; _i++){
            var baseStyle = _a[_i];
            result = baseStyle.isGlobalStyle ? false : baseStyle.backColor === toCompareStyle.backColor && baseStyle.bold === toCompareStyle.bold && baseStyle.numFmtId === toCompareStyle.numFmtId && baseStyle.numberFormat === toCompareStyle.numberFormat && baseStyle.type === toCompareStyle.type && baseStyle.fontColor === toCompareStyle.fontColor && baseStyle.fontName === toCompareStyle.fontName && baseStyle.fontSize === toCompareStyle.fontSize && baseStyle.hAlign === toCompareStyle.hAlign && baseStyle.italic === toCompareStyle.italic && baseStyle.underline === toCompareStyle.underline && baseStyle.strikeThrough === toCompareStyle.strikeThrough && baseStyle.vAlign === toCompareStyle.vAlign && baseStyle.indent === toCompareStyle.indent && baseStyle.rotation === toCompareStyle.rotation && baseStyle.wrapText === toCompareStyle.wrapText && baseStyle.borders.all.color === toCompareStyle.borders.all.color && baseStyle.borders.all.lineStyle === toCompareStyle.borders.all.lineStyle && baseStyle.borders.left.color === toCompareStyle.borders.left.color && baseStyle.borders.left.lineStyle === toCompareStyle.borders.left.lineStyle && baseStyle.borders.right.color === toCompareStyle.borders.right.color && baseStyle.borders.right.lineStyle === toCompareStyle.borders.right.lineStyle && baseStyle.borders.top.color === toCompareStyle.borders.top.color && baseStyle.borders.top.lineStyle === toCompareStyle.borders.top.lineStyle && baseStyle.borders.bottom.color === toCompareStyle.borders.bottom.color && baseStyle.borders.bottom.lineStyle === toCompareStyle.borders.bottom.lineStyle;
            if (result) {
                index = baseStyle.index;
                break;
            }
        }
        return {
            index: index,
            result: result
        };
    };
    Workbook.prototype.contains = function(array, item) {
        var index = array.indexOf(item);
        return index > -1 && index < array.length;
    };
    Workbook.prototype.getCellValueType = function(value) {
        if (value instanceof Date) return "datetime";
        else if (typeof value === "boolean") return "boolean";
        else if (typeof value === "number") return "number";
        else return "string";
    };
    Workbook.prototype.parseCellType = function(cell) {
        var type = cell.type;
        var saveType;
        var value = cell.value;
        switch(type){
            case "datetime":
                value = this.toOADate(value);
                if (cell.cellStyle !== undefined && cell.cellStyle.name !== undefined) {
                    if (this.globalStyles.has(cell.cellStyle.name)) {
                        var value_1 = this.globalStyles.get(cell.cellStyle.name);
                        this.switchNumberFormat(value_1.format, value_1.type);
                    }
                }
                saveType = "n";
                break;
            //TODO: Update the number format index and style
            case "boolean":
                value = value ? 1 : 0;
                saveType = "b";
                break;
            case "number":
                saveType = "n";
                if (cell.cellStyle !== undefined && cell.cellStyle.name !== undefined) {
                    if (this.globalStyles.has(cell.cellStyle.name)) this.switchNumberFormat(this.globalStyles.get(cell.cellStyle.name).format, "number");
                }
                break;
            case "string":
                this.sharedStringCount++;
                saveType = "s";
                var sstvalue = this.processCellValue(value, cell);
                if (!this.contains(this.sharedString, sstvalue)) this.sharedString.push(sstvalue);
                value = this.sharedString.indexOf(sstvalue);
                break;
            default:
                break;
        }
        cell.saveType = saveType;
        cell.value = value;
    };
    Workbook.prototype.parserImages = function(json, sheet) {
        var imagesLength = json.length;
        sheet.images = [];
        var imageId = 0;
        for(var p = 0; p < imagesLength; p++){
            var image = this.parserImage(json[p]);
            sheet.images.push(image);
        }
    };
    Workbook.prototype.parseFilters = function(json, sheet) {
        sheet.autoFilters = new (0, $dcad8a7a99c65072$export$d013f69c76501a03)();
        if (json.row !== null && json.row !== undefined) sheet.autoFilters.row = json.row;
        else throw new Error("Argument Null Exception: row null or empty");
        if (json.lastRow !== null && json.lastRow !== undefined) sheet.autoFilters.lastRow = json.lastRow;
        else throw new Error("Argument Null Exception: lastRow cannot be null or empty");
        if (json.column !== null && json.column !== undefined) sheet.autoFilters.column = json.column;
        else throw new Error("Argument Null Exception: column cannot be null or empty");
        if (json.lastColumn !== null && json.row !== undefined) sheet.autoFilters.lastColumn = json.lastColumn;
        else throw new Error("Argument Null Exception: lastColumn cannot be null or empty");
    };
    Workbook.prototype.parserImage = function(json) {
        var image = new (0, $ddf824fb1d8942b1$export$3e431a229df88919)();
        if (json.image !== null && json.image !== undefined) image.image = json.image;
        if (json.row !== null && json.row !== undefined) image.row = json.row;
        if (json.column !== null && json.column !== undefined) image.column = json.column;
        if (json.lastRow !== null && json.lastRow !== undefined) image.lastRow = json.lastRow;
        if (json.lastColumn !== null && json.lastColumn !== undefined) image.lastColumn = json.lastColumn;
        if (json.width !== null && json.width !== undefined) image.width = json.width;
        if (json.height !== null && json.height !== undefined) image.height = json.height;
        if (json.horizontalFlip !== null && json.horizontalFlip !== undefined) image.horizontalFlip = json.horizontalFlip;
        if (json.verticalFlip !== null && json.verticalFlip !== undefined) image.verticalFlip = json.verticalFlip;
        if (json.rotation !== null && json.rotation !== undefined) image.rotation = json.rotation;
        return image;
    };
    /**
     * Returns a Promise with a Blob based on the specified BlobSaveType and optional encoding.
     * @param {BlobSaveType} blobSaveType - A string indicating the type of Blob to generate ('text/csv' or other).
     * @param {string} [encodingType] - The supported encoding types are "ansi", "unicode" and "utf8".
     */ /* tslint:disable:no-any */ Workbook.prototype.saveAsBlob = function(blobSaveType, encodingType) {
        var _this = this;
        switch(blobSaveType){
            case "text/csv":
                return new Promise(function(resolve, reject) {
                    var obj = {};
                    obj.blobData = _this.csvHelper.saveAsBlob(encodingType);
                    resolve(obj);
                });
            default:
                return new Promise(function(resolve, reject) {
                    _this.saveInternal();
                    _this.mArchive.saveAsBlob().then(function(blob) {
                        var obj = {};
                        obj.blobData = new Blob([
                            blob
                        ], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        resolve(obj);
                    });
                });
        }
    };
    Workbook.prototype.save = function(fileName, proxyUrl) {
        var _this = this;
        if (fileName === null || fileName === undefined || fileName === "") throw new Error("Argument Null Exception: fileName cannot be null or empty");
        var xlsxMatch = fileName.match(".xlsx$");
        var csvMatch = fileName.match(".csv$");
        if (xlsxMatch !== null && xlsxMatch[0] === "." + this.mSaveType) {
            this.saveInternal();
            this.mArchive.save(fileName).then(function() {
                _this.mArchive.destroy();
            });
        } else if (csvMatch !== null && csvMatch[0] === "." + this.mSaveType) this.csvHelper.save(fileName);
        else throw Error("Save type and file extension is different.");
    };
    Workbook.prototype.saveInternal = function() {
        this.saveWorkbook();
        this.saveWorksheets();
        this.saveSharedString();
        this.saveStyles();
        this.saveApp(this.builtInProperties);
        this.saveCore(this.builtInProperties);
        this.saveContentType();
        this.saveTopLevelRelation();
        this.saveWorkbookRelation();
    };
    Workbook.prototype.saveWorkbook = function() {
        /* tslint:disable-next-line:max-line-length */ var workbookTemp = '<?xml version="1.0" encoding="utf-8"?><workbook xmlns:r = "http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns= "http://schemas.openxmlformats.org/spreadsheetml/2006/main"><workbookPr codeName="ThisWorkbook" defaultThemeVersion= "153222"/><bookViews><workbookView activeTab="0"/></bookViews>';
        var sheets = "<sheets>";
        var length = this.worksheets.length;
        for(var i = 0; i < length; i++){
            /* tslint:disable-next-line:max-line-length */ var sheetName = this.worksheets[i].name;
            sheetName = sheetName.replace("&", "&amp;");
            sheetName = sheetName.replace("<", "&lt;");
            sheetName = sheetName.replace(">", "&gt;");
            sheetName = sheetName.replace('"', "&quot;");
            sheets += '<sheet name="' + sheetName + '" sheetId="' + (i + 1).toString() + '" r:id ="rId' + (i + 1).toString() + '" />';
        }
        sheets += "</sheets>";
        workbookTemp += sheets;
        if (this.printTitles.size > 0) {
            var printTitle_1 = "<definedNames>";
            this.printTitles.forEach(function(value, key) {
                printTitle_1 += '<definedName name="_xlnm.Print_Titles" localSheetId="' + key + '">' + value + "</definedName>";
            });
            printTitle_1 += "</definedNames>";
            workbookTemp += printTitle_1;
        }
        this.addToArchive(workbookTemp + "</workbook>", "xl/workbook.xml");
    };
    Workbook.prototype.saveWorksheets = function() {
        var length = this.worksheets.length;
        for(var i = 0; i < length; i++)this.saveWorksheet(this.worksheets[i], i);
    };
    Workbook.prototype.saveWorksheet = function(sheet, index) {
        var sheetBlob = new (0, $91022db04aa48828$export$1846e193db7166fd)();
        /* tslint:disable-next-line:max-line-length */ var sheetString = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><worksheet xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';
        if (!sheet.isSummaryRowBelow) sheetString += '<sheetPr><outlinePr summaryBelow="0" ></outlinePr></sheetPr>';
        else sheetString += "<sheetPr />";
        sheetString += this.saveSheetView(sheet);
        if (sheet.columns !== undefined) {
            var colString = "<cols>";
            for(var _i = 0, _a = sheet.columns; _i < _a.length; _i++){
                var column = _a[_i];
                /* tslint:disable-next-line:max-line-length */ if (column.width !== undefined) colString += '<col min="' + column.index + '" max="' + column.index + '" width="' + this.pixelsToColumnWidth(column.width) + '" customWidth="1" />';
                else colString += '<col min="' + column.index + '" max="' + column.index + '" width="' + "8.43" + '" customWidth="1" />';
            }
            sheetString += colString + "</cols>";
        }
        sheetString += "<sheetData>";
        sheetBlob.append(sheetString);
        sheetString = "";
        if (sheet.rows !== undefined) for(var _b = 0, _c = sheet.rows; _b < _c.length; _b++){
            var row = _c[_b];
            var rowString = '<row r="' + row.index + '" ';
            if (!(0, $3EnZW.isNullOrUndefined)(row.spans)) rowString += 'spans="' + row.spans + '" ';
            if (row.height !== undefined) rowString += 'ht="' + this.pixelsToRowHeight(row.height) + '" customHeight="1" ';
            if (row.grouping !== undefined) {
                if (row.grouping.isHidden) rowString += 'hidden="1" ';
                if (row.grouping.outlineLevel !== undefined) rowString += 'outlineLevel="' + row.grouping.outlineLevel + '" ';
                if (row.grouping.isCollapsed) rowString += 'collapsed="1" ';
            }
            rowString += ">";
            for(var _d = 0, _e = row.cells; _d < _e.length; _d++){
                var cell = _e[_d];
                if (cell !== undefined && (cell.value !== undefined || cell.cellStyle !== undefined)) {
                    rowString += '<c r="' + cell.refName + '" ';
                    if (cell.saveType !== undefined) rowString += 't="' + cell.saveType + '" ';
                    if (cell.styleIndex !== undefined) rowString += 's="' + cell.styleIndex + '" ';
                    rowString += " >";
                    if (cell.formula !== undefined) rowString += "<f>" + cell.formula + "</f>";
                    if (cell.value !== undefined) rowString += "<v>" + cell.value + "</v></c>";
                    else rowString += "</c>";
                }
            }
            rowString += "</row>";
            sheetBlob.append(rowString);
        }
        sheetString += "</sheetData>";
        /* tslint:disable-next-line:max-line-length */ if (sheet.autoFilters !== null && sheet.autoFilters !== undefined) sheetString += '<autoFilter ref="' + this.getCellName(sheet.autoFilters.row, sheet.autoFilters.column) + ":" + this.getCellName(sheet.autoFilters.lastRow, sheet.autoFilters.lastColumn) + '"/>';
        if (sheet.mergeCells.length > 0) {
            sheetString += '<mergeCells count="' + sheet.mergeCells.length + '">';
            for(var _f = 0, _g = sheet.mergeCells; _f < _g.length; _f++){
                var mCell = _g[_f];
                sheetString += '<mergeCell ref="' + mCell.ref + '" />';
            }
            sheetString += "</mergeCells>";
        }
        if (sheet.hyperLinks.length > 0) {
            sheetString += "<hyperlinks>";
            for(var _h = 0, _j = sheet.hyperLinks; _h < _j.length; _h++){
                var hLink = _j[_h];
                sheetString += '<hyperlink ref="' + hLink.ref + '" r:id="rId' + hLink.rId + '" />';
            }
            sheetString += "</hyperlinks>";
        }
        /* tslint:disable-next-line:max-line-length */ sheetString += '<pageMargins left="0.75" right="0.75" top="1" bottom="1" header="0.5" footer="0.5" /><headerFooter scaleWithDoc="1" alignWithMargins="0" differentFirst="0" differentOddEven="0" />';
        if (sheet.images != undefined && sheet.images.length > 0) {
            this.drawingCount++;
            this.saveDrawings(sheet, sheet.index);
            sheetString += '<drawing r:id="rId' + (sheet.hyperLinks.length + 1) + '"/>';
        }
        this.addToArchive(this.saveSheetRelations(sheet), "xl/worksheets/_rels/sheet" + sheet.index + ".xml.rels");
        sheetBlob.append(sheetString + "</worksheet>");
        this.addToArchive(sheetBlob.getBlob(), "xl/worksheets/sheet" + (index + 1) + ".xml");
    };
    Workbook.prototype.saveDrawings = function(sheet, index) {
        var drawings = new (0, $91022db04aa48828$export$1846e193db7166fd)();
        /* tslint:disable-next-line:max-line-length */ var sheetDrawingString = '<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">';
        if (sheet.images !== undefined) {
            var imgId = 0;
            for(var _i = 0, _a = sheet.images; _i < _a.length; _i++){
                var pic = _a[_i];
                if (pic.height !== undefined && pic.width !== undefined) {
                    this.updatelastRowOffset(sheet, pic);
                    this.updatelastColumnOffSet(sheet, pic);
                    pic.lastRow -= 1;
                    pic.lastColumn -= 1;
                } else if (pic.lastRow !== undefined && pic.lastColumn !== undefined) {
                    pic.lastRowOffset = 0;
                    pic.lastColOffset = 0;
                }
                imgId++;
                sheetDrawingString += '<xdr:twoCellAnchor editAs="oneCell">';
                sheetDrawingString += "<xdr:from><xdr:col>";
                //col
                sheetDrawingString += pic.column - 1;
                sheetDrawingString += "</xdr:col><xdr:colOff>";
                //colOff
                sheetDrawingString += 0;
                sheetDrawingString += "</xdr:colOff><xdr:row>";
                //row
                sheetDrawingString += pic.row - 1;
                sheetDrawingString += "</xdr:row><xdr:rowOff>";
                //rowOff
                sheetDrawingString += 0;
                sheetDrawingString += "</xdr:rowOff></xdr:from>";
                sheetDrawingString += "<xdr:to><xdr:col>";
                //col
                sheetDrawingString += pic.lastColumn;
                sheetDrawingString += "</xdr:col><xdr:colOff>";
                //colOff
                sheetDrawingString += pic.lastColOffset;
                sheetDrawingString += "</xdr:colOff><xdr:row>";
                //row
                sheetDrawingString += pic.lastRow;
                sheetDrawingString += "</xdr:row><xdr:rowOff>";
                //rowOff
                sheetDrawingString += pic.lastRowOffset;
                sheetDrawingString += "</xdr:rowOff></xdr:to>";
                sheetDrawingString += "<xdr:pic>";
                sheetDrawingString += "<xdr:nvPicPr>";
                sheetDrawingString += '<xdr:cNvPr id="' + imgId + '" name="Picture ' + imgId + '"> </xdr:cNvPr>';
                sheetDrawingString += '<xdr:cNvPicPr><a:picLocks noChangeAspect="1"/></xdr:cNvPicPr> </xdr:nvPicPr>';
                sheetDrawingString += "<xdr:blipFill>";
                /* tslint:disable-next-line:max-line-length */ sheetDrawingString += '<a:blip xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:embed="rId' + imgId + '" cstate="print">';
                sheetDrawingString += "</a:blip><a:stretch><a:fillRect /></a:stretch></xdr:blipFill>";
                sheetDrawingString += "<xdr:spPr>";
                sheetDrawingString += "<a:xfrm";
                if (pic.rotation != undefined && pic.rotation <= 3600 && pic.rotation >= -3600) sheetDrawingString += ' rot="' + pic.rotation * 60000 + '"';
                if (pic.verticalFlip != undefined && pic.verticalFlip != false) sheetDrawingString += ' flipV="1"';
                if (pic.horizontalFlip != undefined && pic.horizontalFlip != false) sheetDrawingString += ' flipH="1"';
                sheetDrawingString += "/>";
                sheetDrawingString += '<a:prstGeom prst="rect"><a:avLst /></a:prstGeom></xdr:spPr>';
                sheetDrawingString += "</xdr:pic><xdr:clientData /></xdr:twoCellAnchor>";
                var imageFile = new (0, $91022db04aa48828$export$1846e193db7166fd)();
                var imageData = this.convertBase64toImage(pic.image);
                this.imageCount += 1;
                this.addToArchive(imageData, "xl/media/image" + this.imageCount + ".png");
            }
            drawings.append(sheetDrawingString);
            drawings.append("</xdr:wsDr>");
            this.saveDrawingRelations(sheet);
            this.addToArchive(drawings.getBlob(), "xl/drawings/drawing" + this.drawingCount + ".xml");
        }
    };
    Workbook.prototype.updatelastRowOffset = function(sheet, picture) {
        var iCurHeight = picture.height;
        var iCurRow = picture.row;
        var iCurOffset = 0;
        while(iCurHeight >= 0){
            var iRowHeight = 0;
            if (sheet.rows !== undefined && sheet.rows[iCurRow - 1] !== undefined) iRowHeight = this.convertToPixels(sheet.rows[iCurRow - 1].height === undefined ? 15 : sheet.rows[iCurRow - 1].height);
            else iRowHeight = this.convertToPixels(15);
            var iSpaceInCell = iRowHeight - iCurOffset * iRowHeight / 256;
            if (iSpaceInCell > iCurHeight) {
                picture.lastRow = iCurRow;
                picture.lastRowOffset = iCurOffset + iCurHeight * 256 / iRowHeight;
                var rowHiddenHeight = 0;
                if (sheet.rows !== undefined && sheet.rows[iCurRow - 1] !== undefined) rowHiddenHeight = this.convertToPixels(sheet.rows[iCurRow - 1].height === undefined ? 15 : sheet.rows[iCurRow - 1].height);
                else rowHiddenHeight = this.convertToPixels(15);
                picture.lastRowOffset = rowHiddenHeight * picture.lastRowOffset / 256;
                picture.lastRowOffset = Math.round(picture.lastRowOffset / this.unitsProportions[7]);
                break;
            } else {
                iCurHeight -= iSpaceInCell;
                iCurRow++;
                iCurOffset = 0;
            }
        }
    };
    Workbook.prototype.updatelastColumnOffSet = function(sheet, picture) {
        var iCurWidth = picture.width;
        var iCurCol = picture.column;
        var iCurOffset = 0;
        while(iCurWidth >= 0){
            var iColWidth = 0;
            if (sheet.columns !== undefined && sheet.columns[iCurCol - 1] !== undefined) iColWidth = this.ColumnWidthToPixels(sheet.columns[iCurCol - 1].width === undefined ? 8.43 : sheet.columns[iCurCol - 1].width);
            else iColWidth = this.ColumnWidthToPixels(8.43);
            var iSpaceInCell = iColWidth - iCurOffset * iColWidth / 1024;
            if (iSpaceInCell > iCurWidth) {
                picture.lastColumn = iCurCol;
                picture.lastColOffset = iCurOffset + iCurWidth * 1024 / iColWidth;
                var colHiddenWidth = 0;
                if (sheet.columns !== undefined && sheet.columns[iCurCol - 1] !== undefined) colHiddenWidth = this.ColumnWidthToPixels(sheet.columns[iCurCol - 1].width === undefined ? 8.43 : sheet.columns[iCurCol - 1].width);
                else colHiddenWidth = this.ColumnWidthToPixels(8.43);
                picture.lastColOffset = colHiddenWidth * picture.lastColOffset / 1024;
                picture.lastColOffset = Math.round(picture.lastColOffset / this.unitsProportions[7]);
                break;
            } else {
                iCurWidth -= iSpaceInCell;
                iCurCol++;
                iCurOffset = 0;
            }
        }
    };
    Workbook.prototype.convertToPixels = function(value) {
        return value * this.unitsProportions[6];
    };
    Workbook.prototype.convertBase64toImage = function(img) {
        var byteStr = window.atob(img);
        var buffer = new ArrayBuffer(byteStr.length);
        var data = new Uint8Array(buffer);
        for(var i = 0; i < byteStr.length; i++)data[i] = byteStr.charCodeAt(i);
        var blob = new Blob([
            data
        ], {
            type: "image/png"
        });
        return blob;
    };
    Workbook.prototype.saveDrawingRelations = function(sheet) {
        /* tslint:disable-next-line:max-line-length */ var drawingRelation = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
        var length = sheet.images.length;
        var id = this.imageCount - sheet.images.length;
        for(var i = 1; i <= length; i++){
            id++;
            /* tslint:disable-next-line:max-line-length */ drawingRelation += '<Relationship Id="rId' + i + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/image' + id + '.png" />';
        }
        this.addToArchive(drawingRelation + "</Relationships>", "xl/drawings/_rels/drawing" + this.drawingCount + ".xml.rels");
    };
    Workbook.prototype.pixelsToColumnWidth = function(pixels) {
        var dDigitWidth = 7;
        var val = pixels > dDigitWidth + 5 ? this.trunc((pixels - 5) / dDigitWidth * 100 + 0.5) / 100 : pixels / (dDigitWidth + 5);
        return val > 1 ? (val * dDigitWidth + 5) / dDigitWidth * 256.0 / 256.0 : val * (dDigitWidth + 5) / dDigitWidth * 256.0 / 256.0;
    };
    Workbook.prototype.ColumnWidthToPixels = function(val) {
        var dDigitWidth = 7;
        var fileWidth = val > 1 ? (val * dDigitWidth + 5) / dDigitWidth * 256.0 / 256.0 : val * (dDigitWidth + 5) / dDigitWidth * 256.0 / 256.0;
        return this.trunc((256 * fileWidth + this.trunc(128 / dDigitWidth)) / 256 * dDigitWidth);
    };
    Workbook.prototype.trunc = function(x) {
        var n = x - x % 1;
        return n === 0 && (x < 0 || x === 0 && 1 / x !== 1 / 0) ? -0 : n;
    };
    Workbook.prototype.pixelsToRowHeight = function(pixels) {
        return pixels * this.unitsProportions[5] / this.unitsProportions[6];
    };
    Workbook.prototype.saveSheetRelations = function(sheet) {
        /* tslint:disable-next-line:max-line-length */ var relStr = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
        for(var _i = 0, _a = sheet.hyperLinks; _i < _a.length; _i++){
            var hLink = _a[_i];
            /* tslint:disable-next-line:max-line-length */ relStr += '<Relationship Id="rId' + hLink.rId + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="' + this.processString(hLink.target) + '" TargetMode="External" />';
        }
        if (sheet.images != undefined && sheet.images.length > 0) /* tslint:disable-next-line:max-line-length */ relStr += '<Relationship Id="rId' + (sheet.hyperLinks.length + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing' + this.drawingCount + '.xml" />';
        relStr += "</Relationships>";
        return relStr;
    };
    Workbook.prototype.saveSheetView = function(sheet) {
        var paneString = '<sheetViews><sheetView workbookViewId="0" ';
        if (sheet.enableRtl === true) paneString += 'rightToLeft="1"';
        if (sheet.showGridLines === false) paneString += 'showGridLines="0" >';
        else paneString += ">";
        if (sheet.freezePanes !== undefined) {
            paneString += '<pane state="frozen" topLeftCell="' + sheet.freezePanes.leftCell + '" ';
            if (sheet.freezePanes.row !== 0) paneString += 'ySplit="' + sheet.freezePanes.row + '" ';
            if (sheet.freezePanes.column !== 0) paneString += 'xSplit="' + sheet.freezePanes.column + '" ';
            paneString += "/>";
        }
        paneString += "</sheetView></sheetViews > ";
        return paneString;
    };
    Workbook.prototype.saveSharedString = function() {
        var length = this.sharedString.length;
        if (length > 0) {
            /* tslint:disable-next-line:max-line-length */ var sstStart = '<?xml version="1.0" encoding="utf-8"?><sst uniqueCount="' + length + '" count="' + this.sharedStringCount + '" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';
            var si = "";
            for(var i = 0; i < length; i++)if (this.sharedString[i].indexOf("<r>") !== 0) {
                si += "<si><t>";
                si += this.processString(this.sharedString[i]);
                si += "</t></si>";
            } else {
                si += "<si>";
                si += this.sharedString[i];
                si += "</si>";
            }
            si += "</sst>";
            this.addToArchive(sstStart + si, "xl/sharedStrings.xml");
        }
    };
    Workbook.prototype.processString = function(value) {
        if (typeof value == "string") {
            if (value.indexOf("&") !== -1) value = value.replace(/&/g, "&amp;");
            if (value.indexOf("<") !== -1) value = value.replace(/</g, "&lt;");
            if (value.indexOf(">") !== -1) value = value.replace(/>/g, "&gt;");
            if (value.indexOf("\v") !== -1) value = value.replace(/\v/g, "_x000B_");
        } else if (typeof value == "object") for(var i = 0; i < value.length; i++){
            if (value[i].indexOf("&") !== -1) value[i] = value[i].replace(/&/g, "&amp;");
            if (value[i].indexOf("<") !== -1) value[i] = value[i].replace(/</g, "&lt;");
            if (value[i].indexOf(">") !== -1) value[i] = value[i].replace(/>/g, "&gt;");
            if (value[i].indexOf("\v") !== -1) value[i] = value[i].replace(/\v/g, "_x000B_");
        }
        return value;
    };
    Workbook.prototype.saveStyles = function() {
        this.updateCellXfsStyleXfs();
        /* tslint:disable-next-line:max-line-length */ var styleTemp = '<?xml version="1.0" encoding="utf-8"?><styleSheet xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';
        styleTemp += this.saveNumberFormats();
        styleTemp += this.saveFonts();
        styleTemp += this.saveFills();
        styleTemp += this.saveBorders();
        styleTemp += this.saveCellStyleXfs();
        styleTemp += this.saveCellXfs();
        styleTemp += this.saveCellStyles();
        this.addToArchive(styleTemp + "</styleSheet>", "xl/styles.xml");
    };
    Workbook.prototype.updateCellXfsStyleXfs = function() {
        for(var _i = 0, _a = this.mStyles; _i < _a.length; _i++){
            var style = _a[_i];
            var cellXfs = undefined;
            if (style.isGlobalStyle) {
                cellXfs = new (0, $46b0c7517f7f6010$export$a73427ac4777aa87)();
                cellXfs.xfId = style.index - 1;
            } else {
                cellXfs = new (0, $46b0c7517f7f6010$export$98a97e53c3248335)();
                cellXfs.xfId = 0;
            }
            //Add font
            var compareFontResult = this.isNewFont(style);
            if (!compareFontResult.result) {
                var font = new (0, $46b0c7517f7f6010$export$89abf52a030e56ee)();
                font.b = style.bold;
                font.i = style.italic;
                font.name = style.fontName;
                font.sz = style.fontSize;
                font.u = style.underline;
                font.strike = style.strikeThrough;
                font.color = "FF" + style.fontColor.replace("#", "");
                this.mFonts.push(font);
                cellXfs.fontId = this.mFonts.length - 1;
            } else cellXfs.fontId = compareFontResult.index;
            //Add fill
            if (style.backColor !== "none") {
                var backColor = "FF" + style.backColor.replace("#", "");
                if (this.mFills.has(backColor)) {
                    var fillId = this.mFills.get(backColor);
                    cellXfs.fillId = fillId;
                } else {
                    var fillId = this.mFills.size + 2;
                    this.mFills.set(backColor, fillId);
                    cellXfs.fillId = fillId;
                }
            } else cellXfs.fillId = 0;
            //Add border            
            if (!this.isNewBorder(style)) {
                this.mBorders.push(style.borders);
                cellXfs.borderId = this.mBorders.length;
            } else cellXfs.borderId = 0;
            //Add Number Format            
            if (style.numberFormat !== "GENERAL") {
                if (this.mNumFmt.has(style.numberFormat)) {
                    var numFmt = this.mNumFmt.get(style.numberFormat);
                    cellXfs.numFmtId = numFmt.numFmtId;
                } else {
                    var id = this.mNumFmt.size + 164;
                    this.mNumFmt.set(style.numberFormat, new (0, $46b0c7517f7f6010$export$8a1320b211f3c33f)(id, style.numberFormat));
                    cellXfs.numFmtId = id;
                }
            } else if (style.numberFormat === "GENERAL" && style.numFmtId === 14) cellXfs.numFmtId = 14;
            else cellXfs.numFmtId = 0;
            //Add alignment            
            if (!style.isGlobalStyle) cellXfs.applyAlignment = 1;
            cellXfs.alignment = new (0, $46b0c7517f7f6010$export$9d7927214ed7d2cf)();
            cellXfs.alignment.indent = style.indent;
            cellXfs.alignment.horizontal = style.hAlign;
            cellXfs.alignment.vertical = style.vAlign;
            cellXfs.alignment.wrapText = style.wrapText ? 1 : 0;
            cellXfs.alignment.rotation = style.rotation;
            if (style.isGlobalStyle) {
                this.mCellStyleXfs.push(cellXfs);
                this.mCellXfs.push(cellXfs);
            } else //Add cellxfs
            this.mCellXfs.push(cellXfs);
        }
    };
    Workbook.prototype.saveNumberFormats = function() {
        if (this.mNumFmt.size >= 1) {
            var numFmtStyle_1 = '<numFmts count="' + this.mNumFmt.size + '">';
            this.mNumFmt.forEach(function(value, key) {
                numFmtStyle_1 += '<numFmt numFmtId="' + value.numFmtId + '" formatCode="' + value.formatCode.replace(/"/g, "&quot;") + '" />';
            });
            return numFmtStyle_1 += "</numFmts>";
        } else return "";
    };
    Workbook.prototype.saveFonts = function() {
        /* tslint:disable-next-line:max-line-length */ var fontStyle = '<fonts count="' + this.mFonts.length + '">';
        if (this.mFonts.length >= 1) for(var _i = 0, _a = this.mFonts; _i < _a.length; _i++){
            var font = _a[_i];
            fontStyle += "<font>";
            if (font.b) fontStyle += "<b />";
            if (font.i) fontStyle += "<i />";
            if (font.u) fontStyle += "<u />";
            if (font.strike) fontStyle += "<strike />";
            fontStyle += '<sz val="' + font.sz + '" />';
            fontStyle += '<color rgb="' + font.color + '" />';
            fontStyle += '<name val="' + font.name + '" /></font>';
        }
        return fontStyle + "</fonts>";
    };
    Workbook.prototype.saveFills = function() {
        /* tslint:disable-next-line:max-line-length */ var fillsStyle = '<fills count="' + (this.mFills.size + 2) + '"><fill><patternFill patternType="none"></patternFill></fill><fill><patternFill patternType="gray125"></patternFill></fill>';
        if (this.mFills.size >= 1) this.mFills.forEach(function(value, key) {
            /* tslint:disable-next-line:max-line-length */ fillsStyle += '<fill><patternFill patternType="solid"><fgColor rgb="' + key + '" /><bgColor rgb="FFFFFFFF" /></patternFill></fill>';
        });
        return fillsStyle + "</fills>";
    };
    Workbook.prototype.saveBorders = function() {
        /* tslint:disable-next-line:max-line-length */ var bordersStyle = '<borders count="' + (this.mBorders.length + 1) + '"><border><left /><right /><top /><bottom /><diagonal /></border>';
        if (this.mBorders.length >= 1) for(var _i = 0, _a = this.mBorders; _i < _a.length; _i++){
            var borders = _a[_i];
            if (this.isAllBorder(borders)) {
                var color = borders.all.color.replace("#", "");
                var lineStyle = borders.all.lineStyle;
                /* tslint:disable-next-line:max-line-length */ bordersStyle += '<border><left style="' + lineStyle + '"><color rgb="FF' + color + '" /></left><right style="' + lineStyle + '"><color rgb="FF' + color + '" /></right><top style="' + lineStyle + '"><color rgb="FF' + color + '" /></top><bottom style="' + lineStyle + '"><color rgb="FF' + color + '" /></bottom></border>';
            } else /* tslint:disable-next-line:max-line-length */ bordersStyle += '<border><left style="' + borders.left.lineStyle + '"><color rgb="FF' + borders.left.color.replace("#", "") + '" /></left><right style="' + borders.right.lineStyle + '"><color rgb="FF' + borders.right.color.replace("#", "") + '" /></right><top style="' + borders.top.lineStyle + '"><color rgb="FF' + borders.top.color.replace("#", "") + '" /></top><bottom style="' + borders.bottom.lineStyle + '"><color rgb="FF' + borders.bottom.color.replace("#", "") + '" /></bottom></border>';
        }
        return bordersStyle + "</borders>";
    };
    Workbook.prototype.saveCellStyles = function() {
        var _this = this;
        var cellStyleString = '<cellStyles  count="' + this.cellStyles.size + '">';
        this.cellStyles.forEach(function(value, key) {
            cellStyleString += '<cellStyle name="' + key + '" xfId="' + _this.cellStyles.get(key).xfId + '"';
            if (key === "Normal") cellStyleString += ' builtinId="0"';
            cellStyleString += " />";
        });
        return cellStyleString += "</cellStyles>";
    };
    Workbook.prototype.saveCellStyleXfs = function() {
        /* tslint:disable-next-line:max-line-length */ var cellXfsStyle = '<cellStyleXfs count="' + (this.mCellStyleXfs.length + 1) + '"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" />';
        if (this.mCellStyleXfs.length >= 1) for(var _i = 0, _a = this.mCellStyleXfs; _i < _a.length; _i++){
            var cellStyleXf = _a[_i];
            /* tslint:disable-next-line:max-line-length */ cellXfsStyle += '<xf numFmtId="' + cellStyleXf.numFmtId + '" fontId="' + cellStyleXf.fontId + '" fillId="' + cellStyleXf.fillId + '" borderId="' + cellStyleXf.borderId + '" ';
            if (cellStyleXf.alignment !== undefined) cellXfsStyle += ">" + this.saveAlignment(cellStyleXf) + "</xf>";
            else cellXfsStyle += " />";
        }
        return cellXfsStyle + "</cellStyleXfs>";
    };
    Workbook.prototype.saveCellXfs = function() {
        /* tslint:disable-next-line:max-line-length */ var cellXfsStyle = '<cellXfs count="' + (this.mCellXfs.length + 1) + '"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />';
        if (this.mCellXfs.length >= 1) for(var _i = 0, _a = this.mCellXfs; _i < _a.length; _i++){
            var cellXf = _a[_i];
            /* tslint:disable-next-line:max-line-length */ cellXfsStyle += '<xf numFmtId="' + cellXf.numFmtId + '" fontId="' + cellXf.fontId + '" fillId="' + cellXf.fillId + '" borderId="' + cellXf.borderId + '" xfId="' + cellXf.xfId + '" ';
            if (cellXf.applyAlignment === 1) cellXfsStyle += 'applyAlignment="1"';
            cellXfsStyle += ">" + this.saveAlignment(cellXf) + "</xf>";
        }
        return cellXfsStyle + "</cellXfs>";
    };
    Workbook.prototype.saveAlignment = function(cellXf) {
        var alignString = "<alignment ";
        if (cellXf.alignment.horizontal !== undefined) alignString += 'horizontal="' + cellXf.alignment.horizontal + '" ';
        if (cellXf.alignment.indent !== undefined && cellXf.alignment.indent !== 0) alignString += 'indent="' + cellXf.alignment.indent + '" ';
        else if (cellXf.alignment.rotation !== undefined && cellXf.alignment.rotation !== 0) alignString += 'textRotation="' + cellXf.alignment.rotation + '" ';
        if (cellXf.alignment.vertical !== undefined) alignString += 'vertical="' + cellXf.alignment.vertical + '" ';
        alignString += 'wrapText="' + cellXf.alignment.wrapText + '" />';
        return alignString;
    };
    Workbook.prototype.saveApp = function(builtInProperties) {
        /* tslint:disable-next-line:max-line-length */ var appString = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties"><Application>Essential XlsIO</Application>';
        if (builtInProperties !== undefined) {
            if (builtInProperties.manager !== undefined) appString += "<Manager>" + builtInProperties.manager + "</Manager>";
            if (builtInProperties.company !== undefined) appString += "<Company>" + builtInProperties.company + "</Company>";
        }
        this.addToArchive(appString + "</Properties>", "docProps/app.xml");
    };
    Workbook.prototype.saveCore = function(builtInProperties) {
        var createdDate = new Date();
        /* tslint:disable-next-line:max-line-length */ var coreString = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><cp:coreProperties xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties">';
        if (this.builtInProperties !== undefined) {
            if (builtInProperties.author !== undefined) coreString += "<dc:creator>" + builtInProperties.author + "</dc:creator>";
            if (builtInProperties.subject !== undefined) coreString += "<dc:subject>" + builtInProperties.subject + "</dc:subject>";
            if (builtInProperties.category !== undefined) coreString += "<cp:category>" + builtInProperties.category + "</cp:category>";
            if (builtInProperties.comments !== undefined) coreString += "<dc:description>" + builtInProperties.comments + "</dc:description>";
            if (builtInProperties.title !== undefined) coreString += "<dc:title>" + builtInProperties.title + "</dc:title>";
            if (builtInProperties.tags !== undefined) coreString += "<cp:keywords>" + builtInProperties.tags + "</cp:keywords>";
            if (builtInProperties.status !== undefined) coreString += "<cp:contentStatus>" + builtInProperties.status + "</cp:contentStatus>";
            if (builtInProperties.createdDate !== undefined) /* tslint:disable-next-line:max-line-length */ coreString += '<dcterms:created xsi:type="dcterms:W3CDTF">' + builtInProperties.createdDate.toISOString() + "</dcterms:created>";
            else coreString += '<dcterms:created xsi:type="dcterms:W3CDTF">' + createdDate.toISOString() + "</dcterms:created>";
            if (builtInProperties.modifiedDate !== undefined) /* tslint:disable-next-line:max-line-length */ coreString += '<dcterms:modified xsi:type="dcterms:W3CDTF">' + builtInProperties.modifiedDate.toISOString() + "</dcterms:modified>";
            else coreString += '<dcterms:modified xsi:type="dcterms:W3CDTF">' + createdDate.toISOString() + "</dcterms:modified>";
        } else {
            coreString += '<dcterms:created xsi:type="dcterms:W3CDTF">' + createdDate.toISOString() + "</dcterms:created>";
            coreString += '<dcterms:modified xsi:type="dcterms:W3CDTF">' + createdDate.toISOString() + "</dcterms:modified>";
        }
        /* tslint:disable-next-line:max-line-length */ coreString += "</cp:coreProperties>";
        this.addToArchive(coreString, "docProps/core.xml");
    };
    Workbook.prototype.saveTopLevelRelation = function() {
        /* tslint:disable-next-line:max-line-length */ var topRelation = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml" /><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml" /><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml" /></Relationships>';
        this.addToArchive(topRelation, "_rels/.rels");
    };
    Workbook.prototype.saveWorkbookRelation = function() {
        /* tslint:disable-next-line:max-line-length */ var wbRelation = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
        var length = this.worksheets.length;
        var count = 0;
        for(var i = 0; i < length; i++, count++)/* tslint:disable-next-line:max-line-length */ wbRelation += '<Relationship Id="rId' + (i + 1).toString() + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + (i + 1).toString() + '.xml" />';
        /* tslint:disable-next-line:max-line-length */ wbRelation += '<Relationship Id="rId' + (++count).toString() + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />';
        if (this.sharedStringCount > 0) /* tslint:disable-next-line:max-line-length */ wbRelation += '<Relationship Id="rId' + (++count).toString() + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />';
        this.addToArchive(wbRelation + "</Relationships>", "xl/_rels/workbook.xml.rels");
    };
    Workbook.prototype.saveContentType = function() {
        /* tslint:disable-next-line:max-line-length */ var contentTypeString = '<?xml version="1.0" encoding="utf-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="xml" ContentType="application/xml" /><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" /><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" /><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" /><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" /><Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml" />';
        var sheetsOverride = "";
        var length = this.worksheets.length;
        var drawingIndex = 0;
        for(var i = 0; i < length; i++){
            /* tslint:disable-next-line:max-line-length */ sheetsOverride += '<Override PartName="/xl/worksheets/sheet' + (i + 1).toString() + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />';
            if (this.worksheets[i].images != undefined && this.worksheets[i].images.length > 0) {
                drawingIndex++;
                /* tslint:disable-next-line:max-line-length */ sheetsOverride += '<Override PartName="/xl/drawings/drawing' + drawingIndex.toString() + '.xml" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml" />';
            }
        }
        if (this.imageCount > 0) sheetsOverride += '<Default Extension="png" ContentType="image/png" />';
        if (this.sharedStringCount > 0) /* tslint:disable-next-line:max-line-length */ contentTypeString += '<Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" />';
        this.addToArchive(contentTypeString + sheetsOverride + "</Types>", "[Content_Types].xml");
    };
    Workbook.prototype.addToArchive = function(xmlString, itemName) {
        if (typeof xmlString === "string") {
            var blob = new Blob([
                xmlString
            ], {
                type: "text/plain"
            });
            var archiveItem = new (0, $c2dd4e274b017c1a$export$8e9149356d002cff)(blob, itemName);
            this.mArchive.addItem(archiveItem);
        } else {
            var archiveItem = new (0, $c2dd4e274b017c1a$export$8e9149356d002cff)(xmlString, itemName);
            this.mArchive.addItem(archiveItem);
        }
    };
    Workbook.prototype.processMergeCells = function(cell, rowIndex, mergeCells) {
        if (cell.rowSpan !== 0 || cell.colSpan !== 0) {
            var mCell = new (0, $67d8c6e4cf60a7eb$export$4e0dd0bdc0b39907)();
            mCell.x = cell.index;
            mCell.width = cell.colSpan;
            mCell.y = rowIndex;
            mCell.height = cell.rowSpan;
            var startCell = this.getCellName(mCell.y, mCell.x);
            var endCell = this.getCellName(rowIndex + mCell.height, cell.index + mCell.width);
            mCell.ref = startCell + ":" + endCell;
            var mergedCell = mergeCells.add(mCell);
            var start = {
                x: mCell.x,
                y: mCell.y
            };
            var end = {
                x: cell.index + mCell.width,
                y: rowIndex + mCell.height
            };
            this.updatedMergedCellStyles(start, end, cell);
        }
        return mergeCells;
    };
    Workbook.prototype.updatedMergedCellStyles = function(sCell, eCell, cell) {
        for(var x = sCell.x; x <= eCell.x; x++)for(var y = sCell.y; y <= eCell.y; y++)this.mergedCellsStyle.set(this.getCellName(y, x), {
            x: x,
            y: y,
            styleIndex: cell.styleIndex
        });
    };
    /**
     * Returns the tick count corresponding to the given year, month, and day.
     * @param year number value of year
     * @param month number value of month
     * @param day number value of day
     */ Workbook.prototype.dateToTicks = function(year, month, day) {
        var ticksPerDay = 864000000000;
        var daysToMonth365 = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334,
            365
        ];
        var daysToMonth366 = [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335,
            366
        ];
        if (year >= 1 && year <= 9999 && month >= 1 && month <= 12) {
            var days = this.isLeapYear(year) ? daysToMonth366 : daysToMonth365;
            var y = year - 1;
            var n = y * 365 + (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0) + days[month - 1] + day - 1;
            return n * ticksPerDay;
        }
        throw new Error("Not a valid date");
    };
    /**
     * Return the tick count corresponding to the given hour, minute, second.
     * @param hour number value of hour
     * @param minute number value if minute
     * @param second number value of second
     */ Workbook.prototype.timeToTicks = function(hour, minute, second) {
        if (hour >= 0 && hour < 24 && minute >= 0 && minute < 60 && second >= 0 && second < 60) {
            var totalSeconds = hour * 3600 + minute * 60 + second;
            return totalSeconds * 10000000;
        }
        throw new Error("Not valid time");
    };
    /**
     * Checks if given year is a leap year.
     * @param year Year value.
     */ Workbook.prototype.isLeapYear = function(year) {
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    };
    /**
     * Converts `DateTime` to the equivalent OLE Automation date.
     */ Workbook.prototype.toOADate = function(date) {
        var ticks = 0;
        /* tslint:disable-next-line:max-line-length */ ticks = this.dateToTicks(date.getFullYear(), date.getMonth() + 1, date.getDate()) + this.timeToTicks(date.getHours(), date.getMinutes(), date.getSeconds());
        if (ticks === 0) return 0.0;
        var ticksPerDay = 864000000000;
        var daysTo1899 = 693593;
        var doubleDateOffset = daysTo1899 * ticksPerDay;
        var oaDateMinAsTicks = 36159 * ticksPerDay;
        if (ticks < oaDateMinAsTicks) throw new Error("Arg_OleAutDateInvalid");
        var millisPerDay = 86400000;
        return (ticks - doubleDateOffset) / 10000 / millisPerDay;
    };
    return Workbook;
}();
/**
 * BuiltInProperties Class
 * @private
 */ var $1539d026739990ad$export$800e564db2edc59c = /** @class */ function() {
    function BuiltInProperties() {}
    return BuiltInProperties;
}();


parcelRequire("j7YE8");
var $c2qqN = parcelRequire("c2qqN");
var $bWDaN = parcelRequire("bWDaN");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");





/**
 * @hidden
 * `ExportHelper` for `PdfExport` & `ExcelExport`
 */ var $4c91757c13b9ef0b$export$5c1397e8a9aad872 = /** @class */ function() {
    function ExportHelper(parent, foreignKeyData) {
        this.hideColumnInclude = false;
        this.foreignKeyData = {};
        this.parent = parent;
        if (!parent.parentDetails && foreignKeyData) this.foreignKeyData = foreignKeyData;
    }
    ExportHelper.getQuery = function(parent, data) {
        var query = data.generateQuery(true).requiresCount();
        if (data.isRemote()) {
            if (parent.groupSettings.enableLazyLoading && parent.groupSettings.columns.length) query.lazyLoad = [];
            else query.take(parent.pageSettings.totalRecordsCount);
        }
        return query;
    };
    ExportHelper.prototype.getFData = function(value, column) {
        var foreignKeyData = (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(column, {}, value, this.foreignKeyData[column.field])[0];
        return foreignKeyData;
    };
    ExportHelper.prototype.getGridRowModel = function(columns, dataSource, gObj, startIndex) {
        if (startIndex === void 0) startIndex = 0;
        var rows = [];
        var length = dataSource.length;
        if (length) {
            for(var i = 0; i < length; i++, startIndex++){
                var options = {
                    isExpand: false
                };
                options.data = dataSource[parseInt(i.toString(), 10)];
                options.index = startIndex;
                if (gObj.childGrid || gObj.detailTemplate) {
                    if (gObj.hierarchyPrintMode === "All") options.isExpand = true;
                    else if (gObj.hierarchyPrintMode === "Expanded" && this.parent.expandedRows && this.parent.expandedRows[parseInt(startIndex.toString(), 10)]) options.isExpand = gObj.expandedRows[parseInt(startIndex.toString(), 10)].isExpand;
                }
                var row = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)(options);
                row.cells = this.generateCells(columns, gObj);
                rows.push(row);
            }
            this.processColumns(rows);
        }
        return rows;
    };
    ExportHelper.prototype.generateCells = function(columns, gObj) {
        var cells = [];
        if (gObj.childGridLevel) {
            var len = gObj.childGridLevel;
            for(var i = 0; len > i; i++)cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Indent));
        }
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var col = columns_1[_i];
            cells.push(this.generateCell(col, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data));
        }
        return cells;
    };
    ExportHelper.prototype.getColumnData = function(gridObj) {
        var _this = this;
        var columnPromise = [];
        var promise;
        var fColumns = gridObj.getForeignKeyColumns();
        if (fColumns.length) {
            for(var i = 0; i < fColumns.length; i++){
                var colData = "result" in fColumns[parseInt(i.toString(), 10)].dataSource ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(fColumns[parseInt(i.toString(), 10)].dataSource.result) : fColumns[parseInt(i.toString(), 10)].dataSource;
                columnPromise.push(colData.executeQuery(new (0, $56262f229d1cff45$export$62297b13309008b2)()));
            }
            promise = Promise.all(columnPromise).then(function(e) {
                for(var j = 0; j < fColumns.length; j++)_this.foreignKeyData[fColumns[parseInt(j.toString(), 10)].field] = e[parseInt(j.toString(), 10)].result;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            });
        }
        return promise;
    };
    ExportHelper.prototype.getHeaders = function(columns, isHideColumnInclude) {
        if (isHideColumnInclude) this.hideColumnInclude = true;
        else this.hideColumnInclude = false;
        this.colDepth = (0, $748c2240e597a9b7$export$d6485206a212c36b)(columns);
        var rows = [];
        for(var i = 0; i < this.colDepth; i++){
            rows[parseInt(i.toString(), 10)] = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)({});
            rows[parseInt(i.toString(), 10)].cells = [];
        }
        rows = this.processColumns(rows);
        rows = this.processHeaderCells(rows, columns);
        return {
            rows: rows,
            columns: this.generateActualColumns(columns)
        };
    };
    ExportHelper.prototype.getConvertedWidth = function(input) {
        var value = parseFloat(input);
        return input.indexOf("%") !== -1 ? this.parent.element.getBoundingClientRect().width * value / 100 : value;
    };
    ExportHelper.prototype.generateActualColumns = function(columns, actualColumns) {
        if (actualColumns === void 0) actualColumns = [];
        for(var _i = 0, columns_2 = columns; _i < columns_2.length; _i++){
            var column = columns_2[_i];
            if (column.commands) continue;
            if (!column.columns) {
                if (column.visible || this.hideColumnInclude) actualColumns.push(column);
            } else if (column.visible || this.hideColumnInclude) {
                var colSpan = this.getCellCount(column, 0);
                if (colSpan !== 0) this.generateActualColumns(column.columns, actualColumns);
            }
        }
        return actualColumns;
    };
    ExportHelper.prototype.processHeaderCells = function(rows, cols) {
        var columns = cols;
        for(var i = 0; i < columns.length; i++)if (!columns[parseInt(i.toString(), 10)].commands) rows = this.appendGridCells(columns[parseInt(i.toString(), 10)], rows, 0);
        return rows;
    };
    ExportHelper.prototype.appendGridCells = function(cols, gridRows, index) {
        if (!cols.columns && (cols.visible !== false || this.hideColumnInclude) && !cols.commands) gridRows[parseInt(index.toString(), 10)].cells.push(this.generateCell(cols, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Header, this.colDepth - index, index));
        else if (cols.columns) {
            var colSpan = this.getCellCount(cols, 0);
            if (colSpan) gridRows[parseInt(index.toString(), 10)].cells.push(new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)({
                cellType: (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).StackedHeader,
                column: cols,
                colSpan: colSpan
            }));
            var isIgnoreFirstCell = void 0;
            for(var i = 0, len = cols.columns.length; i < len; i++){
                if (cols.columns[parseInt(i.toString(), 10)].visible && !isIgnoreFirstCell) isIgnoreFirstCell = true;
                gridRows = this.appendGridCells(cols.columns[parseInt(i.toString(), 10)], gridRows, index + 1);
            }
        }
        return gridRows;
    };
    ExportHelper.prototype.generateCell = function(gridColumn, cellType, rowSpan, rowIndex) {
        var option = {
            "visible": gridColumn.visible,
            "isDataCell": cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data,
            "column": gridColumn,
            "cellType": cellType,
            "rowSpan": rowSpan,
            "index": rowIndex
        };
        if (!option.rowSpan || option.rowSpan < 2) delete option.rowSpan;
        return new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)(option);
    };
    ExportHelper.prototype.processColumns = function(rows) {
        //TODO: generate dummy column for group, detail, stacked row here; ensureColumns here
        var gridObj = this.parent;
        var columnIndexes = [];
        if (gridObj.enableColumnVirtualization) columnIndexes = gridObj.getColumnIndexesInView();
        for(var i = 0, len = rows.length; i < len; i++){
            if (gridObj.allowGrouping) for(var j = 0, len_1 = gridObj.groupSettings.columns.length - 1; j < len_1; j++){
                if (gridObj.enableColumnVirtualization && columnIndexes.indexOf(j) === -1) continue;
                rows[parseInt(i.toString(), 10)].cells.splice(0, 0, this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent));
            }
        }
        return rows;
    };
    ExportHelper.prototype.getCellCount = function(column, count) {
        if (column.columns) for(var i = 0; i < column.columns.length; i++)count = this.getCellCount(column.columns[parseInt(i.toString(), 10)], count);
        else if (column.visible || this.hideColumnInclude) count++;
        return count;
    };
    ExportHelper.prototype.checkAndExport = function(gridPool, globalResolve) {
        var bool = Object.keys(gridPool).some(function(key) {
            return !gridPool["" + key];
        });
        if (!bool) globalResolve();
    };
    ExportHelper.prototype.failureHandler = function(gridPool, childGridObj, resolve) {
        var _this = this;
        return function() {
            gridPool[childGridObj.id] = true;
            _this.checkAndExport(gridPool, resolve);
        };
    };
    ExportHelper.prototype.createChildGrid = function(gObj, row, exportType, gridPool) {
        var childGridObj = new (0, $503c118799028775$export$ef2184bd89960b14)(this.parent.detailRowModule.getGridModel(gObj, row, exportType));
        gObj.isPrinting = false;
        var parent = "parentDetails";
        childGridObj["" + parent] = {
            parentID: gObj.element.id,
            parentPrimaryKeys: gObj.getPrimaryKeyFieldNames(),
            parentKeyField: gObj.childGrid.queryString,
            parentKeyFieldValue: (0, $3EnZW.getValue)(childGridObj.queryString, row.data),
            parentRowData: row.data
        };
        var exportId = (0, $748c2240e597a9b7$export$5e82334337e0f204)("child-grid");
        var element = (0, $4ZDHT.createElement)("div", {
            id: exportId,
            styles: "display: none"
        });
        document.body.appendChild(element);
        childGridObj.id = exportId;
        gridPool["" + exportId] = false;
        childGridObj.isExportGrid = true;
        return {
            childGrid: childGridObj,
            element: element
        };
    };
    ExportHelper.prototype.getGridExportColumns = function(columns) {
        var actualGridColumns = [];
        for(var i = 0, gridColumns = columns; i < gridColumns.length; i++)if (gridColumns[parseInt(i.toString(), 10)].type !== "checkbox") actualGridColumns.push(gridColumns[parseInt(i.toString(), 10)]);
        return actualGridColumns;
    };
    /**
     * Gets the foreignkey data.
     *
     * @returns {ForeignKeyFormat} returns the foreignkey data
     * @hidden
     */ ExportHelper.prototype.getForeignKeyData = function() {
        return this.foreignKeyData;
    };
    return ExportHelper;
}();
/**
 * @hidden
 * `ExportValueFormatter` for `PdfExport` & `ExcelExport`
 */ var $4c91757c13b9ef0b$export$83adc223acd57528 = /** @class */ function() {
    function ExportValueFormatter(culture) {
        this.valueFormatter = new (0, $52aed6227a4600c2$export$4ad21d94aae28a17)(culture);
        this.internationalization = new (0, $bWDaN.Internationalization)(culture);
    }
    ExportValueFormatter.prototype.returnFormattedValue = function(args, customFormat) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.value) && args.value) return this.valueFormatter.getFormatFunction(customFormat)(args.value);
        else return "";
    };
    /**
     * Used to format the exporting cell value
     *
     * @param  {ExportHelperArgs} args - Specifies cell details.
     * @returns {string} returns formated value
     * @hidden
     */ ExportValueFormatter.prototype.formatCellValue = function(args) {
        if (args.isForeignKey) args.value = (0, $3EnZW.getValue)(args.column.foreignKeyValue, (0, $748c2240e597a9b7$export$ee62846b5e1ebfff)(args.column, {}, args.value)[0]);
        if (args.column.type === "number" && args.column.format !== undefined && args.column.format !== "") {
            if (typeof args.column.format === "string") args.column.format = {
                format: args.column.format
            };
            return args.value || args.value === 0 ? this.internationalization.getNumberFormat(args.column.format)(args.value) : "";
        } else if (args.column.type === "boolean" && args.value !== "") return args.value ? "true" : "false";
        else if ((args.column.type === "date" || args.column.type === "dateonly" || args.column.type === "datetime" || args.column.type === "time") && args.column.format !== undefined) {
            if (typeof args.value === "string") args.value = new Date(args.value);
            if (typeof args.column.format === "string") {
                var format = void 0;
                var cFormat = args.column.format;
                if (args.column.type === "date" || args.column.type === "dateonly") format = {
                    type: "date",
                    skeleton: cFormat
                };
                else if (args.column.type === "time") format = {
                    type: "time",
                    skeleton: cFormat
                };
                else format = {
                    type: "dateTime",
                    skeleton: cFormat
                };
                return this.returnFormattedValue(args, format);
            } else {
                if (args.column.format instanceof Object && args.column.format.type === undefined) return args.value.toString();
                else {
                    var customFormat = void 0;
                    if (args.column.type === "date" || args.column.type === "dateonly") customFormat = {
                        type: args.column.format.type,
                        format: args.column.format.format,
                        skeleton: args.column.format.skeleton
                    };
                    else if (args.column.type === "time") customFormat = {
                        type: "time",
                        format: args.column.format.format,
                        skeleton: args.column.format.skeleton
                    };
                    else customFormat = {
                        type: "dateTime",
                        format: args.column.format.format,
                        skeleton: args.column.format.skeleton
                    };
                    return this.returnFormattedValue(args, customFormat);
                }
            }
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(args.column.type) && !(0, $3EnZW.isNullOrUndefined)(args.value) || !(0, $3EnZW.isNullOrUndefined)(args.value)) return args.value.toString();
            else return "";
        }
    };
    return ExportValueFormatter;
}();






/**
 * @hidden
 * `ExcelExport` module is used to handle the Excel export action.
 */ var $0f7a73cd92e9f074$export$9860ff607cfdeed8 = /** @class */ function() {
    /**
     * Constructor for the Grid Excel Export module.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} locator - specifies the ServiceLocator
     * @hidden
     */ function ExcelExport(parent, locator) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.book = {};
        this.workSheet = [];
        this.rows = [];
        this.columns = [];
        this.styles = [];
        this.rowLength = 1;
        this.expType = "AppendToSheet";
        this.includeHiddenColumn = false;
        this.isCsvExport = false;
        this.isChild = false;
        this.isElementIdChanged = false;
        this.gridPool = {};
        this.sheet = {};
        this.grpFooterTemplates = [];
        this.footerTemplates = [];
        this.aggIndex = 0;
        this.totalAggregates = 0;
        this.parent = parent;
        this.helper = new (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872)(parent);
        this.locator = locator;
        this.l10n = this.locator.getService("localization");
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     */ ExcelExport.prototype.getModuleName = function() {
        return "ExcelExport";
    };
    ExcelExport.prototype.init = function(gObj) {
        if (gObj.element !== null && gObj.element.id === "") {
            gObj.element.id = new Date().toISOString();
            this.isElementIdChanged = true;
        }
        this.parent = gObj;
        if (this.parent.isDestroyed) return;
        this.isExporting = undefined;
        this.book = {};
        this.workSheet = [];
        this.rows = [];
        this.columns = [];
        this.styles = [];
        this.rowLength = 1;
        this.footer = undefined;
        this.expType = "AppendToSheet";
        this.includeHiddenColumn = false;
        this.exportValueFormatter = new (0, $4c91757c13b9ef0b$export$83adc223acd57528)(gObj.locale);
        gObj.id = (0, $748c2240e597a9b7$export$5e82334337e0f204)("main-grid");
        this.gridPool[gObj.id] = false;
    };
    /**
     * Export Grid to Excel file.
     *
     * @param {IGrid} grid - Defines the grid.
     * @param  {exportProperties} exportProperties - Defines the export properties of the Grid.
     * @param  {isMultipleExport} isMultipleExport - Defines is multiple Grid's are exported.
     * @param  {Workbook} workbook - Defined the Workbook if multiple Grid is exported.
     * @param  {boolean} isCsv - true if export to CSV.
     * @param {boolean} isBlob - true if isBlob is enabled.
     * @returns {Promise<any>} - Returns the map for export.
     */ // eslint-disable-next-line
    ExcelExport.prototype.Map = function(grid, exportProperties, isMultipleExport, workbook, isCsv, isBlob) {
        var gObj = grid;
        var cancel = "cancel";
        var isBlb = "isBlob";
        var Child = "isChild";
        var csv = "isCsv";
        var workbk = "workbook";
        var isMultiEx = "isMultipleExport";
        this.gridPool = {};
        if ((grid.childGrid || grid.detailTemplate) && !(!(0, $3EnZW.isNullOrUndefined)(exportProperties) && exportProperties.hierarchyExportMode === "None")) grid.expandedRows = (0, $748c2240e597a9b7$export$854231c97a3cacb6)(grid).expandedRows;
        var args = {
            requestType: "beforeExcelExport",
            gridObject: gObj,
            cancel: false,
            isMultipleExport: isMultipleExport,
            workbook: workbook,
            isCsv: isCsv,
            isBlob: isBlob,
            isChild: this.isChild,
            grpFooterTemplates: this.grpFooterTemplates
        };
        gObj.trigger($17b89d3b1fc93cdb$export$fc33b9b4a870b862, args);
        if (args["" + cancel]) return new Promise(function(resolve) {
            return resolve();
        });
        this.parent.log("exporting_begin", this.getModuleName());
        this.data = new (0, $2c6cbc1793f29e30$export$2d0294657ab35f1b)(gObj);
        this.isExporting = true;
        this.isBlob = args["" + isBlb];
        this.isChild = args["" + Child];
        this.grpFooterTemplates = args["grpFooterTemplates"];
        if (args["" + csv]) this.isCsvExport = args["" + csv];
        else this.isCsvExport = false;
        if ((0, $748c2240e597a9b7$export$54b64ba4d3ca13b3)(exportProperties)) (0, $748c2240e597a9b7$export$e25aefb92a91af83)(exportProperties, gObj);
        return this.processRecords(gObj, exportProperties, args["" + isMultiEx], args["" + workbk]);
    };
    ExcelExport.prototype.exportingSuccess = function(resolve) {
        this.isExporting = false;
        this.parent.trigger($17b89d3b1fc93cdb$export$dfb371c8ddbf1a2c, this.isBlob ? {
            promise: this.blobPromise
        } : {
            gridInstance: this.parent
        });
        this.parent.log("exporting_complete", this.getModuleName());
        resolve(this.book);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ExcelExport.prototype.processRecords = function(gObj, exportProperties, isMultipleExport, workbook) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(exportProperties) && !(0, $3EnZW.isNullOrUndefined)(exportProperties.dataSource)) {
            exportProperties.dataSource = exportProperties.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? exportProperties.dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(exportProperties.dataSource);
            var query_1 = exportProperties.query ? exportProperties.query : new (0, $56262f229d1cff45$export$62297b13309008b2)();
            if ((0, $3EnZW.isNullOrUndefined)(query_1.isCountRequired) || gObj.aggregates) query_1.isCountRequired = true;
            return new Promise(function(resolve) {
                var dataManager = exportProperties.dataSource.executeQuery(query_1);
                dataManager.then(function(r) {
                    _this.init(gObj);
                    _this.processInnerRecords(gObj, exportProperties, isMultipleExport, workbook, r).then(function() {
                        _this.exportingSuccess(resolve);
                    });
                });
            });
        } else if (!(0, $3EnZW.isNullOrUndefined)(exportProperties) && exportProperties.exportType === "CurrentPage" && !(this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && !this.parent.getDataModule().isRemote())) return new Promise(function(resolve) {
            _this.init(gObj);
            _this.processInnerRecords(gObj, exportProperties, isMultipleExport, workbook, _this.parent.getCurrentViewRecords());
            _this.exportingSuccess(resolve);
        });
        else {
            var allPromise_1 = [];
            var query = (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872).getQuery(gObj, this.data);
            if (this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && !this.parent.getDataModule().isRemote()) {
                if ((0, $3EnZW.isNullOrUndefined)(exportProperties)) exportProperties = {
                    hierarchyExportMode: "All"
                };
                exportProperties.hierarchyExportMode = exportProperties.hierarchyExportMode === "None" ? "None" : "All";
                if (exportProperties.hierarchyExportMode === "All") query.lazyLoad = [];
            }
            allPromise_1.push(this.data.getData({}, query));
            allPromise_1.push(this.helper.getColumnData(gObj));
            return new Promise(function(resolve, reject) {
                Promise.all(allPromise_1).then(function(e) {
                    _this.init(gObj);
                    _this.processInnerRecords(gObj, exportProperties, isMultipleExport, workbook, e[0]).then(function() {
                        _this.exportingSuccess(resolve);
                    });
                }).catch(function(e) {
                    reject(_this.book);
                    _this.parent.trigger($17b89d3b1fc93cdb$export$6df5a05f342711e3, e);
                });
            });
        }
    };
    ExcelExport.prototype.processInnerRecords = function(gObj, exportProperties, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isMultipleExport, workbook, r) {
        var _this = this;
        this.groupedColLength = gObj.groupSettings.columns.length;
        var blankRows = 5;
        var separator;
        var rows = [];
        var colDepth = (0, $748c2240e597a9b7$export$d6485206a212c36b)(gObj.columns);
        var isExportPropertiesPresent = !(0, $3EnZW.isNullOrUndefined)(exportProperties);
        if (isExportPropertiesPresent && !(0, $3EnZW.isNullOrUndefined)(exportProperties.multipleExport)) {
            this.expType = !(0, $3EnZW.isNullOrUndefined)(exportProperties.multipleExport.type) ? exportProperties.multipleExport.type : "AppendToSheet";
            if (!(0, $3EnZW.isNullOrUndefined)(exportProperties.multipleExport.blankRows)) blankRows = exportProperties.multipleExport.blankRows;
        }
        if ((0, $3EnZW.isNullOrUndefined)(workbook)) {
            this.workSheet = [];
            this.rows = [];
            this.columns = [];
            this.styles = [];
            this.sheet.images = [];
        } else if (this.expType === "NewSheet") {
            this.workSheet = workbook.worksheets;
            this.rows = [];
            this.columns = [];
            this.sheet.images = [];
            this.styles = workbook.styles;
        } else {
            this.workSheet = [];
            this.rows = workbook.worksheets[0].rows;
            this.columns = workbook.worksheets[0].columns;
            this.styles = workbook.styles;
            this.sheet.images = workbook.worksheets[0].images;
            this.rowLength = this.rows[this.rows.length - 1].index + blankRows;
            this.rowLength++;
        }
        if (isExportPropertiesPresent) {
            if (!(0, $3EnZW.isNullOrUndefined)(isMultipleExport)) {
                if (!(0, $3EnZW.isNullOrUndefined)(exportProperties.header) && (isMultipleExport || this.expType === "NewSheet")) this.processExcelHeader(JSON.parse(JSON.stringify(exportProperties.header)));
                if (!(0, $3EnZW.isNullOrUndefined)(exportProperties.footer)) {
                    if (this.expType === "AppendToSheet") {
                        if (!isMultipleExport) this.footer = JSON.parse(JSON.stringify(exportProperties.footer));
                    } else this.footer = JSON.parse(JSON.stringify(exportProperties.footer));
                }
            } else {
                if (!(0, $3EnZW.isNullOrUndefined)(exportProperties.header)) this.processExcelHeader(JSON.parse(JSON.stringify(exportProperties.header)));
                if (!(0, $3EnZW.isNullOrUndefined)(exportProperties.footer)) this.footer = JSON.parse(JSON.stringify(exportProperties.footer));
            }
        }
        this.includeHiddenColumn = isExportPropertiesPresent ? exportProperties.includeHiddenColumn : false;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return new Promise(function(resolve, reject) {
            gObj.childGridLevel = 0;
            rows = _this.processGridExport(gObj, exportProperties, r);
            _this.globalResolve = resolve;
            _this.gridPool[gObj.id] = true;
            _this.helper.checkAndExport(_this.gridPool, _this.globalResolve);
        }).then(function() {
            var organisedRows = [];
            _this.organiseRows(rows, rows[0].index, organisedRows);
            _this.rows = _this.rows.concat(organisedRows);
            //footer template add
            if (!(0, $3EnZW.isNullOrUndefined)(_this.footer)) {
                if (_this.expType === "AppendToSheet" && !isMultipleExport || _this.expType === "NewSheet") _this.processExcelFooter(_this.footer);
            }
            if (_this.columns.length > 0) _this.sheet.columns = _this.columns;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _this.sheet.rows = _this.rows;
            _this.sheet.enableRtl = _this.parent.enableRtl;
            if (_this.parent.allowFiltering && gObj.getVisibleColumns().length && isExportPropertiesPresent && exportProperties.enableFilter) {
                var headerRowLen = exportProperties.header ? exportProperties.header.headerRows || exportProperties.header.rows.length : 0;
                var autoFilters = {
                    row: colDepth + headerRowLen,
                    column: _this.groupedColLength ? _this.groupedColLength + 1 : _this.sheet.columns[0].index,
                    lastRow: _this.sheet.rows.length,
                    lastColumn: _this.sheet.columns.length
                };
                _this.sheet.autoFilters = autoFilters;
            }
            _this.workSheet.push(_this.sheet);
            _this.book.worksheets = _this.workSheet;
            _this.book.styles = _this.styles;
            gObj.notify("finalPageSetup", _this.book);
            if (!isMultipleExport) {
                if (_this.isCsvExport) {
                    if (isExportPropertiesPresent && !(0, $3EnZW.isNullOrUndefined)(exportProperties.separator) && exportProperties.separator !== ",") separator = exportProperties.separator;
                    var book = new (0, $1539d026739990ad$export$886c8830dfe227e7)(_this.book, "csv", gObj.locale, (0, $bWDaN.defaultCurrencyCode), separator);
                    if (!_this.isBlob) {
                        if (isExportPropertiesPresent && exportProperties.fileName) book.save(exportProperties.fileName);
                        else book.save("Export.csv");
                    } else _this.blobPromise = book.saveAsBlob("text/csv");
                } else {
                    var book = new (0, $1539d026739990ad$export$886c8830dfe227e7)(_this.book, "xlsx", gObj.locale, (0, $bWDaN.defaultCurrencyCode));
                    if (!_this.isBlob) {
                        if (isExportPropertiesPresent && exportProperties.fileName) book.save(exportProperties.fileName);
                        else book.save("Export.xlsx");
                    } else _this.blobPromise = book.saveAsBlob("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                }
                if (_this.isElementIdChanged) gObj.element.id = "";
                delete gObj.expandedRows;
            }
            return workbook;
        });
    };
    ExcelExport.prototype.organiseRows = function(rows, initialIndex, organisedRows) {
        if (!rows.length) return initialIndex;
        for(var i = 0; i < rows.length; i++){
            var row = rows[parseInt(i.toString(), 10)];
            var childRows = row.childRows;
            if (childRows) {
                row.index = initialIndex++;
                delete row.childRows;
                organisedRows.push(row);
                initialIndex = this.organiseRows(childRows, initialIndex, organisedRows);
            } else {
                row.index = initialIndex++;
                organisedRows.push(row);
            }
        }
        return initialIndex;
    };
    ExcelExport.prototype.processGridExport = function(gObj, exportProperties, r) {
        var excelRows = [];
        if (!(0, $3EnZW.isNullOrUndefined)(exportProperties) && !(0, $3EnZW.isNullOrUndefined)(exportProperties.theme)) this.theme = exportProperties.theme;
        if ((gObj.childGrid || gObj.detailTemplate) && !(0, $3EnZW.isNullOrUndefined)(exportProperties)) gObj.hierarchyPrintMode = exportProperties.hierarchyExportMode || "Expanded";
        var helper = new (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872)(gObj, this.helper.getForeignKeyData());
        var gColumns = (0, $748c2240e597a9b7$export$54b64ba4d3ca13b3)(exportProperties) ? (0, $748c2240e597a9b7$export$1147582dfae658c6)(exportProperties.columns, gObj.enableColumnVirtualization) : helper.getGridExportColumns(gObj.columns);
        var headerRow = helper.getHeaders(gColumns, this.includeHiddenColumn);
        var groupIndent = gObj.groupSettings.columns.length ? gObj.groupSettings.columns.length - 1 : 0;
        excelRows = this.processHeaderContent(gObj, headerRow, groupIndent, excelRows);
        if (!(0, $3EnZW.isNullOrUndefined)(exportProperties) && Object.keys(exportProperties).length && (0, $3EnZW.isNullOrUndefined)(exportProperties.dataSource)) {
            if (exportProperties.exportType === "CurrentPage" && (!gObj.groupSettings.enableLazyLoading || gObj.getDataModule().isRemote())) excelRows = this.processRecordContent(gObj, r, headerRow, exportProperties, gObj.currentViewData, excelRows, helper);
            else excelRows = this.processRecordContent(gObj, r, headerRow, exportProperties, undefined, excelRows, helper);
        } else excelRows = this.processRecordContent(gObj, r, headerRow, exportProperties, undefined, excelRows, helper);
        gObj.notify($17b89d3b1fc93cdb$export$8a28500fff253474, {
            excelRows: excelRows,
            type: "excel"
        });
        this.capTemplate = undefined;
        this.footerTemplates = [];
        this.grpFooterTemplates = [];
        this.aggIndex = 0;
        this.totalAggregates = 0;
        return excelRows;
    };
    ExcelExport.prototype.processRecordContent = function(gObj, returnType, headerRow, exportProperties, currentViewRecords, excelRow, helper) {
        var record;
        if (!(0, $3EnZW.isNullOrUndefined)(currentViewRecords) && currentViewRecords.length) record = currentViewRecords;
        else record = returnType.result;
        if (!(0, $3EnZW.isNullOrUndefined)(record.level)) this.processGroupedRows(gObj, record, headerRow, record.level, 0, exportProperties, excelRow, helper);
        else this.processRecordRows(gObj, record, headerRow, 0, 0, exportProperties, excelRow, helper);
        if (!(0, $3EnZW.isNullOrUndefined)(returnType.aggregates)) {
            if (!(0, $3EnZW.isNullOrUndefined)(currentViewRecords) && !this.parent.groupSettings.enableLazyLoading) this.processAggregates(gObj, returnType.result, excelRow, currentViewRecords);
            else {
                var result = returnType.result.GroupGuid ? returnType.result.records : returnType.result;
                this.processAggregates(gObj, result, excelRow);
            }
        }
        return excelRow;
    };
    ExcelExport.prototype.processGroupedRows = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    gObj, dataSource, headerRow, level, startIndex, excelExportProperties, excelRows, helper) {
        for(var _i = 0, dataSource_1 = dataSource; _i < dataSource_1.length; _i++){
            var item = dataSource_1[_i];
            var cells = [];
            var index = 1;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var cell = {};
            cell.index = index + level - 1;
            var col = gObj.getColumnByField(item.field);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var args = {
                value: item.key,
                column: col,
                style: undefined,
                isForeignKey: col.isForeignColumn()
            };
            var value = gObj.getColumnByField(item.field).headerText + ": " + (!col.enableGroupByFormat ? this.exportValueFormatter.formatCellValue(args) : item.key) + " - ";
            if (item.count > 1) value += item.count + " items";
            else value += item.count + " item";
            var cArgs = {
                captionText: value,
                type: this.isCsvExport ? "CSV" : "Excel",
                data: item
            };
            this.parent.trigger($17b89d3b1fc93cdb$export$43919fe2f0396d45, cArgs);
            cell.value = cArgs.captionText;
            cell.style = this.getCaptionThemeStyle(this.theme);
            if (!(0, $3EnZW.isNullOrUndefined)(cArgs.style)) cell.style = this.mergeOptions(cell.style, cArgs.style);
            var captionModelGen = new (0, $add3e338055b95e6$export$626eb12b5cc2f09f)(gObj);
            var groupCaptionSummaryRows = captionModelGen.generateRows(item);
            this.fillAggregates(gObj, groupCaptionSummaryRows, dataSource.level + dataSource.childLevels - 1, excelRows, this.rowLength);
            cells.push(cell);
            if (excelRows[excelRows.length - 1].cells.length > 0) {
                var lIndex = dataSource.level + dataSource.childLevels + groupCaptionSummaryRows[0].cells.length;
                var hIndex = 0;
                for(var _a = 0, _b = excelRows[excelRows.length - 1].cells; _a < _b.length; _a++){
                    var tCell = _b[_a];
                    if (tCell.index < lIndex) lIndex = tCell.index;
                    if (tCell.index > hIndex) hIndex = tCell.index;
                    if (cells[cells.length - 1].index !== tCell.index) cells.push(tCell);
                }
                if (lIndex - cell.index > 1) cell.colSpan = lIndex - cell.index;
                while(hIndex < headerRow.columns.length + level + dataSource.childLevels){
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var sCell = {};
                    sCell.index = hIndex + 1;
                    sCell.style = this.getCaptionThemeStyle(this.theme);
                    cells.push(sCell);
                    hIndex++;
                }
            } else {
                var span = 0;
                //Calculation for column span when group caption dont have aggregates
                for(var _c = 0, _d = headerRow.columns; _c < _d.length; _c++){
                    var col_1 = _d[_c];
                    if (col_1.visible) span++;
                }
                cell.colSpan = dataSource.childLevels + span;
            }
            excelRows[excelRows.length - 1].cells = cells;
            this.rowLength++;
            if (this.groupedColLength < 8 && level > 1) {
                var grouping = {
                    outlineLevel: level - 1,
                    isCollapsed: true
                };
                excelRows[excelRows.length - 1].grouping = grouping;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(dataSource.childLevels) && dataSource.childLevels > 0) {
                this.processGroupedRows(gObj, item.items, headerRow, item.items.level, startIndex, excelExportProperties, excelRows, helper);
                this.processAggregates(gObj, item, excelRows, undefined, level - 1 + dataSource.childLevels, true);
            } else {
                startIndex = this.processRecordRows(gObj, item.items, headerRow, level - 1, startIndex, excelExportProperties, excelRows, helper);
                this.processAggregates(gObj, item, excelRows, undefined, level - 1, true);
            }
        }
    };
    ExcelExport.prototype.processRecordRows = function(gObj, record, headerRow, level, startIndex, excelExportProperties, excelRows, helper) {
        var index = 1;
        var cells = [];
        var columns = headerRow.columns;
        var rows = helper.getGridRowModel(columns, record, gObj, startIndex);
        for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
            var row = rows_1[_i];
            cells = [];
            startIndex++;
            index = 1;
            var templateRowHeight = void 0;
            for(var c = 0, len = row.cells.length; c < len; c++){
                var gCell = row.cells[parseInt(c.toString(), 10)];
                if (gCell.cellType !== (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data) continue;
                var column = gCell.column;
                var field = column.field;
                var cellValue = !(0, $3EnZW.isNullOrUndefined)(field) ? column.valueAccessor(field, row.data, column) : "";
                var value = !(0, $3EnZW.isNullOrUndefined)(cellValue) ? cellValue : "";
                if (column.type === "dateonly" && typeof value === "string" && value) {
                    var arr = value.split(/[^0-9.]/);
                    value = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10));
                }
                var fkData = void 0;
                if (column.isForeignColumn && column.isForeignColumn()) {
                    fkData = helper.getFData(value, column);
                    value = (0, $3EnZW.getValue)(column.foreignKeyValue, fkData);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(value)) {
                    var cell = {};
                    var idx = index + level + gObj.childGridLevel;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var excelCellArgs = {
                        data: row.data,
                        column: column,
                        foreignKeyData: fkData,
                        value: value,
                        style: undefined,
                        colSpan: 1,
                        cell: cell
                    };
                    gObj.trigger($17b89d3b1fc93cdb$export$daa4bec6e7025493, excelCellArgs);
                    if (!(0, $3EnZW.isNullOrUndefined)(excelCellArgs.image) && !(0, $3EnZW.isNullOrUndefined)(excelCellArgs.image.base64)) {
                        templateRowHeight = this.setImage(excelCellArgs, idx);
                        if (excelCellArgs.image.height && excelCellArgs.value !== "") templateRowHeight += 30;
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(excelCellArgs.hyperLink)) {
                        excelCellArgs.cell.hyperlink = {
                            target: excelCellArgs.hyperLink.target
                        };
                        excelCellArgs.value = excelCellArgs.hyperLink.displayText || excelCellArgs.value;
                    }
                    cell = excelCellArgs.cell;
                    cell.index = idx;
                    cell.value = excelCellArgs.value;
                    if (excelCellArgs.data === "" && gObj.childGridLevel && index === 1) {
                        var style = {};
                        style.hAlign = "left";
                        excelCellArgs = {
                            style: style
                        };
                        cell.colSpan = gObj.getVisibleColumns().length;
                        cell.value = this.l10n.getConstant("EmptyRecord");
                    }
                    if (excelCellArgs.colSpan > 1) cell.colSpan = excelCellArgs.colSpan;
                    if (!(0, $3EnZW.isNullOrUndefined)(excelCellArgs.style)) {
                        var styleIndex = this.getColumnStyle(gObj, index + level);
                        cell.style = this.mergeOptions(this.styles[parseInt(styleIndex.toString(), 10)], excelCellArgs.style);
                    } else cell.style = {
                        name: gObj.element.id + "column" + (index + level)
                    };
                    cells.push(cell);
                }
                index++;
            }
            var excelRow = {
                index: this.rowLength++,
                cells: cells
            };
            if (!(0, $3EnZW.isNullOrUndefined)(templateRowHeight)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            excelRow.height = templateRowHeight;
            if (this.groupedColLength && this.groupedColLength < 8 && level + 1 > 0) {
                excelRow.grouping = {
                    outlineLevel: level + 1,
                    isCollapsed: true
                };
                excelRows.push(excelRow);
            } else excelRows.push(excelRow);
            if ((row.isExpand || this.isChild) && (!(0, $3EnZW.isNullOrUndefined)(gObj.childGrid) || !(0, $3EnZW.isNullOrUndefined)(gObj.detailTemplate))) {
                if (!(0, $3EnZW.isNullOrUndefined)(gObj.childGrid)) {
                    gObj.isPrinting = true;
                    var exportType = !(0, $3EnZW.isNullOrUndefined)(excelExportProperties) && excelExportProperties.exportType ? excelExportProperties.exportType : "AllPages";
                    var returnVal = this.helper.createChildGrid(gObj, row, exportType, this.gridPool);
                    var childGridObj = returnVal.childGrid;
                    var element = returnVal.element;
                    childGridObj.actionFailure = helper.failureHandler(this.gridPool, childGridObj, this.globalResolve);
                    childGridObj.childGridLevel = gObj.childGridLevel + 1;
                    var childExportProperties = (0, $3EnZW.extend)(excelExportProperties, {
                        columns: null,
                        dataSource: null,
                        query: null
                    });
                    var args = {
                        childGrid: childGridObj,
                        row: row,
                        exportProperties: childExportProperties
                    };
                    this.parent.trigger($17b89d3b1fc93cdb$export$47abd346227d718b, args);
                    childGridObj.beforeDataBound = this.childGridCell(excelRow, childGridObj, childExportProperties, row);
                    childGridObj.appendTo(element);
                } else {
                    var args = {
                        parentRow: row,
                        row: excelRow,
                        value: {},
                        action: "excelexport",
                        gridInstance: gObj
                    };
                    this.parent.trigger($17b89d3b1fc93cdb$export$4807207a16495a60, args);
                    excelRow.childRows = this.processDetailTemplate(args);
                }
            }
            gObj.notify($17b89d3b1fc93cdb$export$37f61a67cc87a415, {
                rowObj: row,
                type: "excel",
                excelRows: excelRows
            });
        }
        return startIndex;
    };
    ExcelExport.prototype.processDetailTemplate = function(templateData) {
        var _this = this;
        var rows = [];
        var templateRowHeight;
        var detailIndent = 2;
        var detailCellIndex;
        if (templateData.value.columnHeader || templateData.value.rows) {
            var processCell_1 = function(currentCell, isHeader) {
                var cell = {};
                if ((0, $3EnZW.isNullOrUndefined)(currentCell.index)) {
                    currentCell.index = detailCellIndex;
                    detailCellIndex++;
                }
                cell.index = currentCell.index + detailIndent;
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.value)) cell.value = currentCell.value;
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.colSpan)) cell.colSpan = currentCell.colSpan;
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.rowSpan)) cell.rowSpan = currentCell.rowSpan;
                if (isHeader) cell.style = _this.getHeaderThemeStyle(_this.theme);
                else cell.style = _this.getRecordThemeStyle(_this.theme);
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.style)) {
                    var cellStyle = {
                        fontColor: currentCell.style.fontColor,
                        fontName: currentCell.style.fontName,
                        fontSize: currentCell.style.fontSize,
                        hAlign: currentCell.style.excelHAlign,
                        vAlign: currentCell.style.excelVAlign,
                        rotation: currentCell.style.excelRotation,
                        bold: currentCell.style.bold,
                        indent: currentCell.style.indent,
                        italic: currentCell.style.italic,
                        underline: currentCell.style.underline,
                        backColor: currentCell.style.backColor,
                        wrapText: currentCell.style.wrapText,
                        borders: currentCell.style.excelBorders,
                        numberFormat: currentCell.style.excelNumberFormat,
                        type: currentCell.style.excelType,
                        strikeThrough: currentCell.style.strikeThrough
                    };
                    cell.style = _this.mergeOptions(cellStyle, cell.style);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.image) && !(0, $3EnZW.isNullOrUndefined)(currentCell.image.base64)) {
                    if (currentCell.rowSpan > 1) _this.setImage(currentCell, cell.index);
                    else {
                        templateRowHeight = _this.setImage(currentCell, cell.index);
                        if (currentCell.image.height && currentCell.value !== "") templateRowHeight += 30;
                    }
                }
                if (!(0, $3EnZW.isNullOrUndefined)(currentCell.hyperLink)) {
                    cell.hyperlink = {
                        target: currentCell.hyperLink.target
                    };
                    cell.value = currentCell.hyperLink.displayText;
                }
                return cell;
            };
            var processRow = function(currentRow, isHeader) {
                var excelDetailCells = [];
                detailCellIndex = 0;
                for(var j = 0; j < currentRow.cells.length; j++){
                    var currentCell = currentRow.cells[parseInt(j.toString(), 10)];
                    var detailCell = processCell_1(currentCell, isHeader);
                    excelDetailCells.push(detailCell);
                }
                var row = {
                    index: _this.rowLength++,
                    cells: excelDetailCells
                };
                if (!(0, $3EnZW.isNullOrUndefined)(templateRowHeight)) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    row.height = templateRowHeight;
                    templateRowHeight = null;
                }
                rows.push(row);
            };
            if (templateData.value.columnHeader) for(var i = 0; i < templateData.value.columnHeader.length; i++)processRow(templateData.value.columnHeader[parseInt(i.toString(), 10)], true);
            if (templateData.value.rows) for(var i = 0; i < templateData.value.rows.length; i++)processRow(templateData.value.rows[parseInt(i.toString(), 10)]);
        } else if (templateData.value.image) {
            templateRowHeight = this.setImage(templateData.value, detailIndent);
            var row = {
                index: this.rowLength++,
                cells: [
                    {
                        index: detailIndent,
                        style: this.getRecordThemeStyle(this.theme)
                    }
                ]
            };
            if (!(0, $3EnZW.isNullOrUndefined)(templateRowHeight)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                row.height = templateRowHeight;
                templateRowHeight = null;
            }
            rows.push(row);
        } else if (templateData.value.text) {
            var row = {
                index: this.rowLength++,
                cells: [
                    {
                        index: detailIndent,
                        value: templateData.value.text,
                        style: this.getRecordThemeStyle(this.theme)
                    }
                ]
            };
            rows.push(row);
        } else if (templateData.value.hyperLink) {
            var row = {
                index: this.rowLength++,
                cells: [
                    {
                        index: 2,
                        hyperlink: {
                            target: templateData.value.hyperLink.target
                        },
                        value: templateData.value.hyperLink.displayText,
                        style: this.getRecordThemeStyle(this.theme)
                    }
                ]
            };
            rows.push(row);
        }
        for(var i = 0; i < rows.length; i++)rows[parseInt(i.toString(), 10)].grouping = {
            outlineLevel: 1,
            isCollapsed: !templateData.parentRow.isExpand,
            isHidden: !templateData.parentRow.isExpand
        };
        return rows;
    };
    ExcelExport.prototype.setImage = function(args, idx) {
        if ((0, $3EnZW.isNullOrUndefined)(this.sheet.images)) this.sheet.images = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var excelImage = {
            image: args.image.base64,
            row: this.rowLength,
            column: idx,
            lastRow: this.rowLength,
            lastColumn: idx
        };
        if (args.image.width && args.image.height) {
            excelImage.width = args.image.width;
            excelImage.height = args.image.height;
        }
        this.sheet.images.push(excelImage);
        this.columns[idx - 1].width = args.image.width || this.columns[idx - 1].width;
        return args.image.height || 50;
    };
    ExcelExport.prototype.childGridCell = function(excelRow, childGridObj, excelExportProps, gRow) {
        var _this = this;
        return function(result) {
            childGridObj.beforeDataBound = null;
            result.cancel = true;
            if (result.result.length === 0) result.result = [
                ""
            ];
            excelRow.childRows = _this.processGridExport(childGridObj, excelExportProps, result);
            var intent = _this.parent.groupSettings.columns.length;
            var rows = excelRow.childRows;
            for(var i = 0; i < rows.length; i++)rows[parseInt(i.toString(), 10)].grouping = {
                outlineLevel: intent + childGridObj.childGridLevel,
                isCollapsed: !gRow.isExpand,
                isHidden: !gRow.isExpand
            };
            childGridObj.destroy();
            (0, $4ZDHT.detach)(childGridObj.element);
            _this.gridPool[childGridObj.id] = true;
            _this.helper.checkAndExport(_this.gridPool, _this.globalResolve);
            return excelRow;
        };
    };
    ExcelExport.prototype.processAggregates = function(gObj, rec, excelRows, currentViewRecords, indent, byGroup) {
        var summaryModel = new (0, $add3e338055b95e6$export$5d9b1dac619ba2d8)(gObj);
        var columns = summaryModel.getColumns();
        columns = columns.filter(function(col) {
            return (0, $3EnZW.isNullOrUndefined)(col.commands) && col.type !== "checkbox";
        });
        if (gObj.aggregates.length && this.parent !== gObj) gObj.aggregateModule.prepareSummaryInfo();
        var data = undefined;
        if (!(0, $3EnZW.isNullOrUndefined)(currentViewRecords)) data = currentViewRecords;
        else data = rec;
        if (indent === undefined) indent = 0;
        if (gObj.groupSettings.columns.length > 0 && byGroup) {
            var groupSummaryModel = new (0, $add3e338055b95e6$export$f766a86dea6dd817)(gObj);
            var groupSummaryRows = groupSummaryModel.generateRows(data, {
                level: data.level
            });
            if (groupSummaryRows.length > 0) excelRows = this.fillAggregates(gObj, groupSummaryRows, indent, excelRows);
        } else {
            indent = gObj.groupSettings.columns.length > 0 && !byGroup ? gObj.groupSettings.columns.length : indent;
            var sRows = summaryModel.generateRows(data, rec.aggregates, null, null, columns);
            if (sRows.length > 0 && !byGroup) {
                indent = gObj.groupSettings.columns.length ? indent - 1 : indent;
                excelRows = this.fillAggregates(gObj, sRows, indent, excelRows);
            }
        }
        return excelRows;
    };
    ExcelExport.prototype.fillAggregates = function(gObj, rows, indent, excelRows, customIndex) {
        for(var _i = 0, rows_2 = rows; _i < rows_2.length; _i++){
            var row = rows_2[_i];
            var cells = [];
            var isEmpty = true;
            var index = 0;
            for(var _a = 0, _b = row.cells; _a < _b.length; _a++){
                var cell = _b[_a];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var eCell = {};
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var columnsDetails = {};
                if (!(0, $3EnZW.isNullOrUndefined)(cell.attributes.index)) columnsDetails = this.parent.getColumnByIndex(cell.attributes.index);
                if (cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailFooterIntent || columnsDetails.type === "checkbox" || columnsDetails.commands) continue;
                if (cell.visible || this.includeHiddenColumn) {
                    index++;
                    if (cell.isDataCell) {
                        isEmpty = false;
                        var footerTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.footerTemplate);
                        var groupFooterTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.groupFooterTemplate);
                        var groupCaptionTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.groupCaptionTemplate);
                        eCell.index = index + indent + gObj.childGridLevel;
                        if (footerTemplate) eCell.value = this.getAggreateValue(gObj, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Summary, cell.column.footerTemplate, cell, row);
                        else if (groupFooterTemplate) eCell.value = this.getAggreateValue(gObj, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary, cell.column.groupFooterTemplate, cell, row);
                        else if (groupCaptionTemplate) eCell.value = this.getAggreateValue(gObj, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary, cell.column.groupCaptionTemplate, cell, row);
                        else for(var _c = 0, _d = Object.keys(row.data[cell.column.field]); _c < _d.length; _c++){
                            var key = _d[_c];
                            if (key === cell.column.type) {
                                if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Sum)) eCell.value = row.data[cell.column.field][cell.column.field + " - sum"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Average)) eCell.value = row.data[cell.column.field][cell.column.field + " - average"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Max)) eCell.value = row.data[cell.column.field][cell.column.field + " - max"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Min)) eCell.value = row.data[cell.column.field][cell.column.field + " - min"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Count)) eCell.value = row.data[cell.column.field][cell.column.field + " - count"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].TrueCount)) eCell.value = row.data[cell.column.field][cell.column.field + " - truecount"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].FalseCount)) eCell.value = row.data[cell.column.field][cell.column.field + " - falsecount"];
                                else if (!(0, $3EnZW.isNullOrUndefined)(row.data[cell.column.field].Custom)) eCell.value = row.data[cell.column.field].Custom;
                            }
                        }
                        eCell.style = this.getCaptionThemeStyle(this.theme); //{ name: gObj.element.id + 'column' + index };
                        this.aggregateStyle(cell.column, eCell.style, cell.column.field);
                        var gridCellStyle = cell.attributes.style;
                        if (gridCellStyle.textAlign) eCell.style.hAlign = gridCellStyle.textAlign.toLowerCase();
                        var args = {
                            row: row,
                            type: footerTemplate ? "Footer" : groupFooterTemplate ? "GroupFooter" : "GroupCaption",
                            style: eCell,
                            cell: cell
                        };
                        this.parent.trigger($17b89d3b1fc93cdb$export$eb167a270aa0f522, args);
                        cells.push(eCell);
                    } else if (customIndex === undefined) {
                        eCell.index = index + indent + gObj.childGridLevel;
                        eCell.style = this.getCaptionThemeStyle(this.theme); //{ name: gObj.element.id + 'column' + index };
                        cells.push(eCell);
                    }
                }
            }
            if (!(0, $3EnZW.isNullOrUndefined)(customIndex)) excelRows.push({
                index: customIndex,
                cells: cells
            });
            else {
                var row_1 = {};
                var dummyOutlineLevel = "outlineLevel";
                var dummyGrouping = "grouping";
                if (this.groupedColLength < 8 && this.groupedColLength > 0 && !(gObj.groupSettings.enableLazyLoading && (0, $3EnZW.isNullOrUndefined)(excelRows[excelRows.length - 1]["" + dummyGrouping]))) {
                    var level = excelRows[excelRows.length - 1]["" + dummyGrouping]["" + dummyOutlineLevel];
                    var grouping = {
                        outlineLevel: level,
                        isCollapsed: true
                    };
                    row_1 = {
                        index: this.rowLength++,
                        cells: cells,
                        grouping: grouping
                    };
                } else row_1 = {
                    index: this.rowLength++,
                    cells: cells
                };
                if (!isEmpty) excelRows.push(row_1);
            }
        }
        return excelRows;
    };
    ExcelExport.prototype.aggregateStyle = function(col, style, field) {
        var column = this.parent.getColumnByField(field);
        if (typeof col.format === "object") {
            var format = col.format;
            style.numberFormat = !(0, $3EnZW.isNullOrUndefined)(format.format) ? format.format : format.skeleton;
            if (!(0, $3EnZW.isNullOrUndefined)(format.type)) style.type = format.type.toLowerCase();
        } else style.numberFormat = col.format;
        if (!(0, $3EnZW.isNullOrUndefined)(column) && (0, $3EnZW.isNullOrUndefined)(style.type)) style.type = column.type.toLowerCase();
    };
    ExcelExport.prototype.getAggreateValue = function(gObj, cellType, template, cell, row) {
        var templateFn = {};
        templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), cell.cellType)] = (0, $c2qqN.compile)(template);
        var txt;
        var data = row.data[cell.column.field ? cell.column.field : cell.column.columnName];
        if ((this.parent.isReact || this.parent.isVue || this.parent.isVue3 || this.parent.isAngular) && !(typeof cell.column.footerTemplate === "string" || typeof cell.column.groupFooterTemplate === "string" || typeof cell.column.groupCaptionTemplate === "string")) {
            txt = data[cell.column.type];
            return !(0, $3EnZW.isNullOrUndefined)(txt) ? txt : "";
        } else {
            txt = templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), cell.cellType)](data, this.parent);
            if (this.parent.isVue3 && !(0, $3EnZW.isNullOrUndefined)(txt[1])) return txt[1].textContent;
        }
        return !(0, $3EnZW.isNullOrUndefined)(txt[0]) ? txt[0].textContent : "";
    };
    ExcelExport.prototype.mergeOptions = function(JSON1, JSON2) {
        var result = {};
        var attrname = Object.keys(JSON1);
        for(var index = 0; index < attrname.length; index++)if (attrname[parseInt(index.toString(), 10)] !== "name") result[attrname[parseInt(index.toString(), 10)]] = JSON1[attrname[parseInt(index.toString(), 10)]];
        attrname = Object.keys(JSON2);
        for(var index = 0; index < attrname.length; index++)if (attrname[parseInt(index.toString(), 10)] !== "name") result[attrname[parseInt(index.toString(), 10)]] = JSON2[attrname[parseInt(index.toString(), 10)]];
        return result;
    };
    ExcelExport.prototype.getColumnStyle = function(gObj, columnIndex) {
        var index = 0;
        for(var _i = 0, _a = this.styles; _i < _a.length; _i++){
            var style = _a[_i];
            if (style.name === gObj.element.id + "column" + columnIndex) return index;
            index++;
        }
        return undefined;
    };
    ExcelExport.prototype.headerRotation = function(args) {
        var degree = args.style.rotation;
        if (degree <= 90 && degree >= 0) args.style.hAlign = "Left";
        else if (degree > 90 && degree <= 180) args.style.hAlign = "Right";
        else {
            degree = 180;
            args.style.hAlign = "Right";
        }
        args.style.rotation = degree;
    };
    ExcelExport.prototype.processHeaderContent = function(gObj, headerRow, indent, excelRows) {
        var rowIndex = 1;
        var gridRows = headerRow.rows;
        // Column collection with respect to the records in the grid
        var gridColumns = headerRow.columns;
        var spannedCells = [];
        if (indent > 0) {
            var index = 0;
            while(index !== indent){
                this.columns.push({
                    index: index + 1,
                    width: 30
                });
                index++;
            }
        }
        for(var col = 0; col < gridColumns.length; col++)this.parseStyles(gObj, gridColumns[parseInt(col.toString(), 10)], this.getRecordThemeStyle(this.theme), indent + col + 1);
        var templateRowHeight;
        for(var row = 0; row < gridRows.length; row++){
            var currentCellIndex = 1 + indent;
            var cells = [];
            for(var column = 0; column < gridRows[parseInt(row.toString(), 10)].cells.length; column++){
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var style = {};
                var cell = {};
                var gridCell = gridRows[parseInt(row.toString(), 10)].cells[parseInt(column.toString(), 10)];
                if (gridCell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent || gridCell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailHeader) continue;
                var result = {
                    contains: true,
                    index: 1
                };
                while(result.contains){
                    result = this.getIndex(spannedCells, rowIndex, currentCellIndex);
                    currentCellIndex = result.index;
                    if (!result.contains) {
                        cell.index = result.index + gObj.childGridLevel;
                        break;
                    }
                }
                if (!(0, $3EnZW.isNullOrUndefined)(gridCell.rowSpan) && gridCell.rowSpan !== 1) {
                    cell.rowSpan = gridCell.rowSpan;
                    for(var i = rowIndex; i < gridCell.rowSpan + rowIndex; i++){
                        var spannedCell = {
                            rowIndex: 0,
                            columnIndex: 0
                        };
                        spannedCell.rowIndex = i;
                        spannedCell.columnIndex = currentCellIndex;
                        spannedCells.push(spannedCell);
                    }
                }
                if (!(0, $3EnZW.isNullOrUndefined)(gridCell.colSpan) && gridCell.colSpan !== 1) {
                    cell.colSpan = gridCell.colSpan;
                    currentCellIndex = currentCellIndex + cell.colSpan - 1;
                }
                cell.value = gridCell.column.headerText;
                style = this.getHeaderThemeStyle(this.theme);
                if (!(0, $3EnZW.isNullOrUndefined)(gridCell.column.textAlign)) style.hAlign = gridCell.column.textAlign.toLowerCase();
                if (!(0, $3EnZW.isNullOrUndefined)(gridCell.column.headerTextAlign)) style.hAlign = gridCell.column.headerTextAlign.toLowerCase();
                var excelHeaderCellArgs = {
                    cell: cell,
                    gridCell: gridCell,
                    style: style
                };
                gObj.trigger($17b89d3b1fc93cdb$export$c2c4a3442a2ab768, excelHeaderCellArgs);
                if (excelHeaderCellArgs.style.rotation) this.headerRotation(excelHeaderCellArgs);
                if (!(0, $3EnZW.isNullOrUndefined)(excelHeaderCellArgs.image) && !(0, $3EnZW.isNullOrUndefined)(excelHeaderCellArgs.image.base64)) templateRowHeight = this.setImage(excelHeaderCellArgs, currentCellIndex);
                if (!(0, $3EnZW.isNullOrUndefined)(excelHeaderCellArgs.hyperLink)) {
                    excelHeaderCellArgs.cell.hyperlink = {
                        target: excelHeaderCellArgs.hyperLink.target
                    };
                    cell.value = excelHeaderCellArgs.hyperLink.displayText || cell.value;
                }
                cell.style = excelHeaderCellArgs.style;
                cells.push(cell);
                currentCellIndex++;
            }
            var excelRow = {
                index: this.rowLength++,
                cells: cells
            };
            if (!(0, $3EnZW.isNullOrUndefined)(templateRowHeight)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            excelRow.height = templateRowHeight;
            excelRows.push(excelRow);
        }
        return excelRows;
    };
    ExcelExport.prototype.getHeaderThemeStyle = function(theme) {
        var style = {};
        style.fontSize = 12;
        style.borders = {
            color: "#E0E0E0"
        };
        style.bold = true;
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && !(0, $3EnZW.isNullOrUndefined)(theme.header)) style = this.updateThemeStyle(theme.header, style);
        return style;
    };
    ExcelExport.prototype.updateThemeStyle = function(themestyle, style) {
        return (0, $3EnZW.extend)(style, themestyle);
    };
    ExcelExport.prototype.getCaptionThemeStyle = function(theme) {
        var style = {};
        style.fontSize = 13;
        style.backColor = "#F6F6F6";
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && !(0, $3EnZW.isNullOrUndefined)(theme.caption)) style = this.updateThemeStyle(theme.caption, style);
        return style;
    };
    ExcelExport.prototype.getRecordThemeStyle = function(theme) {
        var style = {};
        style.fontSize = 13;
        style.borders = {
            color: "#E0E0E0"
        };
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && !(0, $3EnZW.isNullOrUndefined)(theme.record)) style = this.updateThemeStyle(theme.record, style);
        return style;
    };
    ExcelExport.prototype.processExcelHeader = function(header) {
        if (!(0, $3EnZW.isNullOrUndefined)(header.rows) && (this.expType === "NewSheet" || this.rowLength === 1)) {
            var noRows = void 0;
            if (header.headerRows === undefined) this.rowLength = header.rows.length;
            else this.rowLength = header.headerRows;
            if (this.rowLength < header.rows.length) noRows = this.rowLength;
            else noRows = header.rows.length;
            this.rowLength++;
            for(var row = 0; row < noRows; row++){
                var json = header.rows[parseInt(row.toString(), 10)];
                //Row index
                if (!(json.index !== null && !(0, $3EnZW.isNullOrUndefined)(json.index))) json.index = row + 1;
                this.updatedCellIndex(json);
            }
        }
    };
    ExcelExport.prototype.updatedCellIndex = function(json) {
        var cellsLength = json.cells.length;
        for(var cellId = 0; cellId < cellsLength; cellId++){
            var jsonCell = json.cells[parseInt(cellId.toString(), 10)];
            //cell index
            if (!(jsonCell.index !== null && !(0, $3EnZW.isNullOrUndefined)(jsonCell.index))) jsonCell.index = cellId + 1;
        }
        this.rows.push(json);
    };
    ExcelExport.prototype.processExcelFooter = function(footer) {
        if (!(0, $3EnZW.isNullOrUndefined)(footer.rows)) {
            var noRows = void 0;
            if (footer.footerRows === undefined) this.rowLength += footer.rows.length;
            else if (footer.footerRows > footer.rows.length) {
                this.rowLength += footer.footerRows - footer.rows.length;
                noRows = footer.rows.length;
            } else noRows = footer.footerRows;
            for(var row = 0; row < noRows; row++){
                var json = footer.rows[parseInt(row.toString(), 10)];
                //Row index
                if (json.index === null || json.index === undefined) json.index = this.rowLength++;
                else json.index += this.rowLength;
                this.updatedCellIndex(json);
            }
        }
    };
    ExcelExport.prototype.getIndex = function(spannedCells, rowIndex, columnIndex) {
        for(var _i = 0, spannedCells_1 = spannedCells; _i < spannedCells_1.length; _i++){
            var spannedCell = spannedCells_1[_i];
            if (spannedCell.rowIndex === rowIndex && spannedCell.columnIndex === columnIndex) {
                columnIndex = columnIndex + 1;
                return {
                    contains: true,
                    index: columnIndex
                };
            }
        }
        return {
            contains: false,
            index: columnIndex
        };
    };
    ExcelExport.prototype.parseStyles = function(gObj, col, style, index) {
        if (!(0, $3EnZW.isNullOrUndefined)(col.format)) {
            if (typeof col.format === "object") {
                var format = col.format;
                style.numberFormat = !(0, $3EnZW.isNullOrUndefined)(format.format) ? format.format : format.skeleton;
                if (!(0, $3EnZW.isNullOrUndefined)(format.type)) style.type = format.type === "dateonly" ? "date" : format.type.toLowerCase();
            } else {
                style.numberFormat = col.format;
                style.type = col.type === "dateonly" ? "date" : col.type;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(col.textAlign)) style.hAlign = col.textAlign.toLowerCase();
        if (Object.keys(style).length > 0) {
            style.name = gObj.element.id + "column" + index;
            this.styles.push(style);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(col.width) && col.width !== "auto" && !gObj.childGridLevel) this.columns.push({
            index: index + gObj.childGridLevel,
            width: typeof col.width === "number" ? col.width : this.helper.getConvertedWidth(col.width)
        });
    };
    ExcelExport.prototype.destroy = function() {
    //destroy for exporting
    };
    return ExcelExport;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");







parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");





var $13bc42b7d3ad33cb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * FilterCellRenderer class which responsible for building filter cell.
 *
 * @hidden
 */ var $13bc42b7d3ad33cb$export$5f9ad5ac1a77194 = /** @class */ function(_super) {
    $13bc42b7d3ad33cb$var$__extends(FilterCellRenderer, _super);
    function FilterCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement("TH", {
            className: "e-filterbarcell",
            attrs: {
                role: "columnheader"
            }
        });
        return _this;
    }
    /**
     * Function to return the wrapper for the TH content.
     *
     * @returns {string} returns the gui
     */ FilterCellRenderer.prototype.getGui = function() {
        return this.parent.createElement("div");
    };
    /**
     * Function to render the cell content based on Column object.
     *
     * @param  {Cell} cell
     * @param  {Object} data
     */ /* tslint:disable-next-line:max-func-body-length */ FilterCellRenderer.prototype.render = function(cell, data) {
        var tr = this.parent.element.querySelector(".e-filterbar");
        var node = this.element.cloneNode();
        var innerDIV = this.getGui();
        var input;
        var column = cell.column;
        tr.appendChild(node);
        node.setAttribute("e-mappinguid", column.uid);
        if (column.filterTemplate) {
            var fltrData = {};
            if (data) fltrData[column.field] = data[column.field];
            var col = "column";
            fltrData["" + col] = column;
            if (column.visible) {
                if (this.parent.filterSettings.type === "FilterBar") node.classList.add("e-fltrtemp");
                var isReactCompiler = this.parent.isReact && typeof column.filterTemplate !== "string";
                var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
                var tempID = this.parent.element.id + column.uid + "filterTemplate";
                if (isReactCompiler || isReactChild) {
                    column.getFilterTemplate()(fltrData, this.parent, "filterTemplate", tempID, null, null, node);
                    this.parent.renderTemplates();
                } else {
                    var element = column.getFilterTemplate()(fltrData, this.parent, "filterTemplate", tempID, null, null, null, this.parent.root);
                    (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(node, element);
                }
            } else node.classList.add("e-hide");
        } else {
            if (column.type !== "checkbox") {
                if (((0, $3EnZW.isNullOrUndefined)(column.allowFiltering) || column.allowFiltering) && !(0, $3EnZW.isNullOrUndefined)(column.filterBarTemplate)) {
                    node.classList.add("e-fltrtemp");
                    (0, $4ZDHT.attributes)(innerDIV, {
                        "class": "e-fltrtempdiv"
                    });
                    if ((0, $3EnZW.isNullOrUndefined)(column.filterBarTemplate.create)) {
                        input = this.parent.createElement("input", {
                            id: column.field + "_filterBarcell",
                            className: "e-filterUi_input e-filtertext e-fltrTemp",
                            attrs: {
                                type: "search",
                                title: column.headerText
                            }
                        });
                        innerDIV.appendChild(input);
                    } else {
                        var args = {
                            column: column,
                            node: Element
                        };
                        var temp = column.filterBarTemplate.create;
                        if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
                        input = temp(args);
                        if (typeof input === "string") {
                            var div = this.parent.createElement("div");
                            div.innerHTML = input;
                            input = div.firstChild;
                        }
                        (0, $4ZDHT.attributes)(innerDIV, {
                            class: "e-filterUi_input e-filtertext e-fltrTemp",
                            title: column.headerText,
                            id: column.field + "_filterBarcell"
                        });
                        innerDIV.appendChild(input);
                    }
                } else {
                    (0, $4ZDHT.attributes)(innerDIV, {
                        "class": "e-filterdiv e-fltrinputdiv"
                    });
                    input = this.parent.createElement("input", {
                        id: column.field + "_filterBarcell",
                        className: "e-filtertext",
                        attrs: {
                            type: "search",
                            title: column.headerText + cell.attributes.title,
                            value: data[cell.column.field] ? data[cell.column.field] : ""
                        }
                    });
                    innerDIV.appendChild(input);
                    var args = {
                        element: input,
                        floatLabelType: "Never",
                        properties: {
                            enableRtl: this.parent.enableRtl,
                            showClearButton: true,
                            cssClass: this.parent.cssClass
                        }
                    };
                    this.parent.filterModule.inputList.push(args);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput(args, this.parent.createElement);
                }
                //TODO: apply intial filtering
                if (column.allowFiltering === false || column.field === "" || (0, $3EnZW.isNullOrUndefined)(column.field)) {
                    input.setAttribute("disabled", "true");
                    input.classList.add("e-disable");
                }
                var clearIconElem = innerDIV.querySelector(".e-clear-icon");
                if (clearIconElem) clearIconElem.setAttribute("title", this.parent.localeObj.getConstant("ClearButton"));
                if (!column.visible) node.classList.add("e-hide");
                this.appendHtml(node, innerDIV);
                // render's the dropdownlist component if showFilterBarOperator sets to true
                if (this.parent.filterSettings.showFilterBarOperator && this.parent.filterSettings.type === "FilterBar" && !this.parent.isPrinting && (0, $3EnZW.isNullOrUndefined)(column.filterTemplate) && (0, $3EnZW.isNullOrUndefined)(column.filterBarTemplate)) this.operatorIconRender(innerDIV, column, cell);
                if (((0, $3EnZW.isNullOrUndefined)(column.allowFiltering) || column.allowFiltering) && !(0, $3EnZW.isNullOrUndefined)(column.filterBarTemplate)) {
                    var templateWrite = column.filterBarTemplate.write;
                    var args = {
                        element: input,
                        column: column
                    };
                    if (typeof templateWrite === "string") templateWrite = (0, $3EnZW.getValue)(templateWrite, window);
                    templateWrite.call(this, args);
                }
            } else if (!column.visible) node.classList.add("e-hide");
        }
        if (this.parent.isFrozenGrid()) (0, $748c2240e597a9b7$export$a94a28b9cbe22d6a)(this.parent, column, node);
        return node;
    };
    /**
     * Function to specifies how the result content to be placed in the cell.
     *
     * @param {Element} node - specifies the node
     * @param {string|Element} innerHtml - specifies the innerHTML
     * @returns {Element} retruns the element
     */ FilterCellRenderer.prototype.appendHtml = function(node, innerHtml) {
        node.appendChild(innerHtml);
        return node;
    };
    FilterCellRenderer.prototype.operatorIconRender = function(innerDIV, column, cell) {
        var gObj = this.parent;
        var operators;
        var fbicon = this.parent.createElement("input", {
            className: " e-filterbaroperator e-icons e-icon-filter",
            id: cell.column.uid
        });
        innerDIV.querySelector("span").appendChild(fbicon);
        if (column.filter && column.filter.operator) operators = column.filter.operator;
        else if (gObj.filterSettings.columns.length) for(var i = 0, a = gObj.filterSettings.columns; i < a.length; i++){
            var col = a[parseInt(i.toString(), 10)];
            if (col.field === column.field) {
                operators = col.operator;
                break;
            } else operators = "equal";
        }
        else operators = "equal";
        if (!(0, $3EnZW.isNullOrUndefined)(gObj.filterModule.operators[column.field])) operators = gObj.filterModule.operators[column.field];
        this.dropOptr = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)({
            fields: {
                text: "text",
                value: "value"
            },
            popupHeight: "auto",
            value: operators,
            width: "0px",
            enabled: column.allowFiltering,
            popupWidth: "auto",
            enableRtl: this.parent.enableRtl,
            change: this.internalEvent.bind(this),
            beforeOpen: function() {
                var operator = gObj.filterModule.customOperators;
                this.dataSource = operator[gObj.getColumnByUid(this.element.id).type + "Operator"];
                for(var i = 0; i < this.dataSource.length; i++)if (column.filter && column.filter.operator && (0, $3EnZW.isNullOrUndefined)(gObj.filterModule.operators[column.field]) && this.dataSource[parseInt(i.toString(), 10)].value === column.filter.operator) this.value = column.filter.operator;
            },
            cssClass: this.parent.cssClass ? "e-popup-flbar " + this.parent.cssClass : "e-popup-flbar"
        });
        this.dropOptr.appendTo(fbicon);
        var spanElmt = (0, $4ZDHT.closest)(this.dropOptr.element, "span");
        spanElmt.classList.add("e-filterbardropdown");
        spanElmt.removeAttribute("tabindex");
    };
    FilterCellRenderer.prototype.internalEvent = function(e) {
        var gObj = this.parent;
        var col = gObj.getColumnByUid(e.element.getAttribute("id"));
        e.column = col;
        gObj.filterModule.operators[col.field] = e.value;
        gObj.notify($17b89d3b1fc93cdb$export$9837be318e7e9b3, e);
    };
    return FilterCellRenderer;
}((0, $e992c1409d919677$export$efe8300dd67deed4));


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



/**
 * `filter operators` render boolean column.
 *
 * @hidden
 */ var $b2864fc08e9bdf97$export$f2c2f59e9901ed10 = /** @class */ function() {
    function FlMenuOptrUI(parent, customFltrOperators, serviceLocator, filterSettings) {
        this.ddOpen = this.dropDownOpen.bind(this);
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.filterSettings = filterSettings;
        this.customFilterOperators = customFltrOperators;
        if (this.parent) {
            this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroyDropDownList, this);
            this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroyDropDownList, this);
        }
    }
    /**
     * @param {Element} dlgConetntEle - specifies the content element
     * @param {Element} target - specifies the target
     * @param {Column} column - specifies the column
     * @param {Dialog} dlgObj - specifies the dialog
     * @param {Object[]} operator - specifies the operator list
     * @returns {void}
     * @hidden
     */ // eslint-disable-next-line max-len
    FlMenuOptrUI.prototype.renderOperatorUI = function(dlgConetntEle, target, column, dlgObj, operator) {
        this.dialogObj = dlgObj;
        var optr = column.type + "Operator";
        this.optrData = this.customOptr = !(0, $3EnZW.isNullOrUndefined)(operator) ? operator : !(0, $3EnZW.isNullOrUndefined)(this.parent.filterSettings.operators) && !(0, $3EnZW.isNullOrUndefined)(this.parent.filterSettings.operators["" + optr]) ? this.parent.filterSettings.operators["" + optr] : this.customFilterOperators["" + optr];
        var dropDatasource = this.customOptr;
        var selectedValue = this.dropSelectedVal(column, optr);
        var optrDiv = this.parent.createElement("div", {
            className: "e-flm_optrdiv"
        });
        dlgConetntEle.appendChild(optrDiv);
        var optrInput = this.parent.createElement("input", {
            id: column.uid + "-floptr"
        });
        optrDiv.appendChild(optrInput);
        this.dropOptr = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)({
            dataSource: dropDatasource,
            fields: {
                text: "text",
                value: "value"
            },
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            enableRtl: this.parent.enableRtl,
            text: selectedValue,
            // eslint-disable-next-line @typescript-eslint/tslint/config
            change: function() {
                var valInput = document.querySelector(".e-flmenu-valuediv").querySelector("input");
                if (this.value === "isempty" || this.value === "isnotempty" || this.value === "isnotnull" || this.value === "isnull") {
                    if (!(0, $3EnZW.isNullOrUndefined)(valInput["ej2_instances"])) valInput["ej2_instances"][0]["enabled"] = false;
                    else valInput.setAttribute("disabled", "true");
                } else if (!(0, $3EnZW.isNullOrUndefined)(valInput.getAttribute("disabled"))) {
                    if (!(0, $3EnZW.isNullOrUndefined)(valInput["ej2_instances"])) valInput["ej2_instances"][0]["enabled"] = true;
                    else valInput.removeAttribute("disabled");
                }
            }
        });
        this.dropOptr.addEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.ddOpen);
        this.dropOptr.appendTo("#" + column.uid + "-floptr");
    };
    FlMenuOptrUI.prototype.renderResponsiveDropDownList = function(args) {
        args.popup.element.style.width = "100%";
    };
    FlMenuOptrUI.prototype.dropDownOpen = function(args) {
        args.popup.element.style.zIndex = (this.dialogObj.zIndex + 1).toString();
        if (this.parent.enableAdaptiveUI) this.renderResponsiveDropDownList(args);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    FlMenuOptrUI.prototype.dropSelectedVal = function(col, optr) {
        var selValue = "";
        var columns = this.parent.filterSettings.columns;
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var column = columns_1[_i];
            if (col.field === column.field || col.isForeignColumn() && col.foreignKeyValue === column.field) {
                var selectedField = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.optrData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("value", "equal", column.operator));
                selValue = !(0, $3EnZW.isNullOrUndefined)(selectedField[0]) ? selectedField[0].text : "";
            }
        }
        if (selValue === "") {
            if (col.filter.operator) {
                var optrLen = Object.keys(this.optrData).length;
                for(var i = 0; i < optrLen; i++)if (this.optrData[parseInt(i.toString(), 10)].value === col.filter.operator) selValue = this.optrData[parseInt(i.toString(), 10)].text;
            } else selValue = this.optrData[0].text;
        }
        return selValue;
    };
    /**
     * @returns {string} returns the operator
     * @hidden
     */ FlMenuOptrUI.prototype.getFlOperator = function() {
        return this.dropOptr.value;
    };
    FlMenuOptrUI.prototype.destroyDropDownList = function() {
        if (this.dropOptr.isDestroyed) return;
        this.dropOptr.removeEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.ddOpen);
        this.dropOptr.destroy();
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroyDropDownList);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroyDropDownList);
    };
    return FlMenuOptrUI;
}();


parcelRequire("j7YE8");
var $5rsSz = parcelRequire("5rsSz");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");


/**
 * Function helps to find which highlightSearch is to call based on your data.
 *
 * @param  {HTMLElement} element - Specifies an li element.
 * @param  {string} query - Specifies the string to be highlighted.
 * @param  {boolean} ignoreCase - Specifies the ignoreCase option.
 * @param  {HightLightType} type - Specifies the type of highlight.
 * @returns {void}
 */ function $faaab5eef2504967$export$9183789c55011a91(element, query, ignoreCase, type) {
    var isHtmlElement = /<[^>]*>/g.test(element.innerText);
    if (isHtmlElement) element.innerText = element.innerText.replace(/[\u00A0-\u9999<>&]/g, function(match) {
        return "&#" + match.charCodeAt(0) + ";";
    });
    if (query === "") return;
    else {
        var ignoreRegex = ignoreCase ? "gim" : "gm";
        // eslint-disable-next-line
        query = /^[a-zA-Z0-9- ]*$/.test(query) ? query : query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        var replaceQuery = type === "StartsWith" ? "^(" + query + ")" : type === "EndsWith" ? "(" + query + ")$" : "(" + query + ")";
        // eslint-disable-next-line security/detect-non-literal-regexp
        $faaab5eef2504967$var$findTextNode(element, new RegExp(replaceQuery, ignoreRegex));
    }
}
/* eslint-enable jsdoc/require-param, valid-jsdoc */ /**
 *
 * @param {HTMLElement} element - Specifies the element.
 * @param {RegExp} pattern - Specifies the regex to match the searched text.
 * @returns {void}
 */ function $faaab5eef2504967$var$findTextNode(element, pattern) {
    for(var index = 0; element.childNodes && index < element.childNodes.length; index++)if (element.childNodes[index].nodeType === 3 && element.childNodes[index].textContent.trim() !== "") {
        var value = element.childNodes[index].nodeValue.trim().replace(pattern, '<span class="e-highlight">$1</span>');
        element.childNodes[index].nodeValue = "";
        element.innerHTML = element.innerHTML.trim() + value;
        break;
    } else $faaab5eef2504967$var$findTextNode(element.childNodes[index], pattern);
}
function $faaab5eef2504967$export$97545a2550156b83(content) {
    var contentElement = content.querySelectorAll(".e-highlight");
    for(var i = contentElement.length - 1; i >= 0; i--){
        var parent_1 = contentElement[i].parentNode;
        var text = document.createTextNode(contentElement[i].textContent);
        parent_1.replaceChild(text, contentElement[i]);
    }
}






var $1b6f3188acd1d256$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1b6f3188acd1d256$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(0, $e5d35cabace4110f$export$9787c7b65ab00376).root = "e-autocomplete";
(0, $e5d35cabace4110f$export$9787c7b65ab00376).icon = "e-input-group-icon e-ddl-icon e-search-icon";
/**
 * The AutoComplete component provides the matched suggestion list when type into the input,
 * from which the user can select one.
 * ```html
 * <input id="list" type="text"/>
 * ```
 * ```typescript
 *   let atcObj:AutoComplete = new AutoComplete();
 *   atcObj.appendTo("#list");
 * ```
 */ var $1b6f3188acd1d256$export$6b41f50dc0c59fb3 = /** @class */ function(_super) {
    $1b6f3188acd1d256$var$__extends(AutoComplete, _super);
    /**
     * * Constructor for creating the widget
     *
     * @param {AutoCompleteModel} options - Specifies the AutoComplete model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function AutoComplete(options, element) {
        var _this_1 = _super.call(this, options, element) || this;
        _this_1.isFiltered = false;
        _this_1.searchList = false;
        return _this_1;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */ AutoComplete.prototype.preRender = function() {
        _super.prototype.preRender.call(this);
    };
    AutoComplete.prototype.getLocaleName = function() {
        return "auto-complete";
    };
    AutoComplete.prototype.getNgDirective = function() {
        return "EJS-AUTOCOMPLETE";
    };
    AutoComplete.prototype.getQuery = function(query) {
        var filterQuery = query ? query.clone() : this.query ? this.query.clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        var value = this.allowObjectBinding && !(0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value) : this.value;
        var filterType = this.queryString === "" && !(0, $3EnZW.isNullOrUndefined)(value) ? "equal" : this.filterType;
        var queryString = this.queryString === "" && !(0, $3EnZW.isNullOrUndefined)(value) ? value : this.queryString;
        if (this.isFiltered) {
            if (this.enableVirtualization && !(0, $3EnZW.isNullOrUndefined)(this.customFilterQuery)) filterQuery = this.customFilterQuery.clone();
            else if (!this.enableVirtualization) return filterQuery;
        }
        if (this.queryString !== null && this.queryString !== "") {
            var dataType = this.typeOfData(this.dataSource).typeof;
            if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && dataType === "string" || dataType === "number") filterQuery.where("", filterType, queryString, this.ignoreCase, this.ignoreAccent);
            else {
                var mapping = !(0, $3EnZW.isNullOrUndefined)(this.fields.value) ? this.fields.value : "";
                filterQuery.where(mapping, filterType, queryString, this.ignoreCase, this.ignoreAccent);
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.suggestionCount) && !this.enableVirtualization) {
            // Since default value of suggestioncount is 20, checked the condition
            if (this.suggestionCount !== 20) {
                for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++)if (filterQuery.queries[queryElements].fn === "onTake") filterQuery.queries.splice(queryElements, 1);
            }
            filterQuery.take(this.suggestionCount);
        }
        if (this.enableVirtualization) {
            var queryTakeValue = 0;
            var querySkipValue = 0;
            var takeValue = this.getTakeValue();
            if (filterQuery && filterQuery.queries.length > 0) for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++){
                if (filterQuery.queries[queryElements].fn === "onSkip") querySkipValue = filterQuery.queries[queryElements].e.nos;
                if (filterQuery.queries[queryElements].fn === "onTake") queryTakeValue = takeValue <= filterQuery.queries[queryElements].e.nos ? filterQuery.queries[queryElements].e.nos : takeValue;
            }
            if (queryTakeValue <= 0 && this.query && this.query.queries.length > 0) {
                for(var queryElements = 0; queryElements < this.query.queries.length; queryElements++)if (this.query.queries[queryElements].fn === "onTake") {
                    var currentTakeValue = this.query.queries[queryElements].e.nos;
                    queryTakeValue = takeValue <= currentTakeValue ? currentTakeValue : takeValue;
                }
            }
            if (filterQuery && filterQuery.queries.length > 0) for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++){
                if (filterQuery.queries[queryElements].fn === "onSkip") {
                    querySkipValue = filterQuery.queries[queryElements].e.nos;
                    filterQuery.queries.splice(queryElements, 1);
                    --queryElements;
                    continue;
                }
                if (filterQuery.queries[queryElements].fn === "onTake") {
                    var currentQueryTakeValue = filterQuery.queries[queryElements].e.nos;
                    queryTakeValue = currentQueryTakeValue <= queryTakeValue ? queryTakeValue : currentQueryTakeValue;
                    filterQuery.queries.splice(queryElements, 1);
                    --queryElements;
                }
            }
            if (querySkipValue > 0 && this.virtualItemStartIndex <= querySkipValue) filterQuery.skip(querySkipValue);
            else filterQuery.skip(this.virtualItemStartIndex);
            if (queryTakeValue > 0 && takeValue <= queryTakeValue) filterQuery.take(queryTakeValue);
            else filterQuery.take(takeValue);
            filterQuery.requiresCount();
        }
        return filterQuery;
    };
    AutoComplete.prototype.searchLists = function(e) {
        var _this_1 = this;
        this.isTyped = true;
        this.isDataFetched = this.isSelectCustom = false;
        this.firstItem = this.dataSource && this.dataSource.length > 0 ? this.dataSource[0] : null;
        this.checkAndResetCache();
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) _super.prototype.renderList.call(this, e, true);
        this.queryString = this.filterInput.value;
        if (e.type !== "mousedown" && (e.keyCode === 40 || e.keyCode === 38)) {
            this.queryString = this.queryString === "" ? null : this.queryString;
            this.beforePopupOpen = true;
            this.resetList(this.dataSource, this.fields, null, e);
            return;
        }
        this.isSelected = false;
        this.activeIndex = null;
        this.isRequesting = false;
        var eventArgs = {
            preventDefaultAction: false,
            text: this.filterInput.value,
            updateData: function(dataSource, query, fields) {
                if (eventArgs.cancel) return;
                _this_1.isFiltered = true;
                _this_1.customFilterQuery = query;
                _this_1.filterAction(dataSource, query, fields);
            },
            cancel: false
        };
        this.trigger("filtering", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel && !_this_1.isFiltered && !eventArgs.preventDefaultAction) {
                _this_1.searchList = true;
                _this_1.filterAction(_this_1.dataSource, null, _this_1.fields, e);
            }
        });
    };
    /**
     * To filter the data from given data source by using query
     *
     * @param {Object[] | DataManager } dataSource - Set the data source to filter.
     * @param {Query} query - Specify the query to filter the data.
     * @param {FieldSettingsModel} fields - Specify the fields to map the column in the data table.
     * @returns {void}

     */ AutoComplete.prototype.filter = function(dataSource, query, fields) {
        this.isFiltered = true;
        this.filterAction(dataSource, query, fields);
    };
    AutoComplete.prototype.filterAction = function(dataSource, query, fields, e) {
        this.beforePopupOpen = true;
        var isNoDataElement = this.list.classList.contains("e-nodata");
        if (this.queryString !== "" && this.queryString.length >= this.minLength) {
            if (this.enableVirtualization && this.isFiltering() && this.isTyped) {
                this.isPreventScrollAction = true;
                this.list.scrollTop = 0;
                this.previousStartIndex = 0;
                this.virtualListInfo = null;
            }
            this.resetList(dataSource, fields, query, e);
            isNoDataElement = this.list.classList.contains("e-nodata");
            if (this.enableVirtualization && !isNoDataElement) {
                if (!this.list.querySelector(".e-virtual-ddl-content") && this.list.querySelector(".e-list-parent")) {
                    var virtualElement = this.createElement("div", {
                        className: "e-virtual-ddl-content",
                        styles: this.getTransformValues()
                    });
                    this.list.appendChild(virtualElement).appendChild(this.list.querySelector(".e-list-parent"));
                }
                if (!this.list.querySelector(".e-virtual-ddl") && document.getElementsByClassName("e-popup") && document.getElementsByClassName("e-popup")[0]) {
                    var virtualElement = this.createElement("div", {
                        id: this.element.id + "_popup",
                        className: "e-virtual-ddl",
                        styles: this.GetVirtualTrackHeight()
                    });
                    document.getElementsByClassName("e-popup")[0].querySelector(".e-dropdownbase").appendChild(virtualElement);
                }
            }
            if (this.getModuleName() === "autocomplete" && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.getModuleName() === "autocomplete" && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount !== 0) this.getFilteringSkeletonCount();
        } else {
            this.hidePopup(e);
            this.beforePopupOpen = false;
        }
        this.renderReactTemplates();
    };
    AutoComplete.prototype.clearAll = function(e, property) {
        if ((0, $3EnZW.isNullOrUndefined)(property) || !(0, $3EnZW.isNullOrUndefined)(property) && (0, $3EnZW.isNullOrUndefined)(property.dataSource)) {
            _super.prototype.clearAll.call(this, e);
            this.checkAndResetCache();
        }
        if (this.beforePopupOpen) this.hidePopup();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    AutoComplete.prototype.onActionComplete = function(ulElement, list, e, isUpdated) {
        if (!this.enableVirtualization) this.fixedHeaderElement = null;
        if (this.getModuleName() === "autocomplete" && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.getModuleName() === "autocomplete" && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount !== 0) this.getFilteringSkeletonCount();
        _super.prototype.onActionComplete.call(this, ulElement, list, e);
        var item = this.list.querySelector("." + (0, $e5d35cabace4110f$export$9787c7b65ab00376).li);
        if (!(0, $3EnZW.isNullOrUndefined)(item)) (0, $4ZDHT.removeClass)([
            item
        ], (0, $e5d35cabace4110f$export$9787c7b65ab00376).focus);
        this.postBackAction();
    };
    AutoComplete.prototype.postBackAction = function() {
        if (this.autofill && !(0, $3EnZW.isNullOrUndefined)(this.liCollections[0]) && this.searchList) {
            var items = [
                this.liCollections[0]
            ];
            var dataSource = this.listData;
            var type = this.typeOfData(dataSource).typeof;
            var searchItem = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.inputElement.value, items, "StartsWith", this.ignoreCase, dataSource, this.fields, type);
            this.searchList = false;
            if (!(0, $3EnZW.isNullOrUndefined)(searchItem.item)) _super.prototype.setAutoFill.call(this, this.liCollections[0], true);
        }
    };
    AutoComplete.prototype.setSelection = function(li, e) {
        if (!this.isValidLI(li)) {
            this.selectedLI = li;
            return;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(e) && e.type === "keydown" && e.action !== "enter" && e.action !== "tab" && this.isValidLI(li)) {
            var value = this.getFormattedValue(li.getAttribute("data-value"));
            this.activeIndex = this.getIndexByValue(value);
            this.setHoverList(li);
            this.selectedLI = li;
            this.setScrollPosition(e);
            if (this.autofill && this.isPopupOpen) {
                this.preventAutoFill = false;
                var isKeyNavigate = e && e.action === "down" || e.action === "up" || e.action === "home" || e.action === "end" || e.action === "pageUp" || e.action === "pageDown";
                _super.prototype.setAutoFill.call(this, li, isKeyNavigate);
            }
        } else _super.prototype.setSelection.call(this, li, e);
    };
    AutoComplete.prototype.listOption = function(dataSource, fieldsSettings) {
        var _this_1 = this;
        var fields = _super.prototype.listOption.call(this, dataSource, fieldsSettings);
        if ((0, $3EnZW.isNullOrUndefined)(fields.itemCreated)) fields.itemCreated = function(e) {
            if (_this_1.highlight) {
                if (_this_1.element.tagName === _this_1.getNgDirective() && _this_1.itemTemplate) setTimeout(function() {
                    (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this_1.queryString, _this_1.ignoreCase, _this_1.filterType);
                }, 0);
                else (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this_1.queryString, _this_1.ignoreCase, _this_1.filterType);
            }
        };
        else {
            var itemCreated_1 = fields.itemCreated;
            fields.itemCreated = function(e) {
                if (_this_1.highlight) (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this_1.queryString, _this_1.ignoreCase, _this_1.filterType);
                itemCreated_1.apply(_this_1, [
                    e
                ]);
            };
        }
        return fields;
    };
    AutoComplete.prototype.isFiltering = function() {
        return true;
    };
    AutoComplete.prototype.renderPopup = function(e) {
        if (!this.enableVirtualization) this.list.scrollTop = 0;
        _super.prototype.renderPopup.call(this, e);
    };
    AutoComplete.prototype.isEditTextBox = function() {
        return false;
    };
    AutoComplete.prototype.isPopupButton = function() {
        return this.showPopupButton;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    AutoComplete.prototype.isSelectFocusItem = function(element) {
        return false;
    };
    AutoComplete.prototype.setInputValue = function(newProp, oldProp) {
        var oldValue = oldProp && oldProp.text ? oldProp.text : oldProp ? oldProp.value : oldProp;
        var value = newProp && newProp.text ? newProp.text : newProp && newProp.value ? newProp.value : this.value;
        if (this.allowObjectBinding) {
            oldValue = !(0, $3EnZW.isNullOrUndefined)(oldValue) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", oldValue) : oldValue;
            value = !(0, $3EnZW.isNullOrUndefined)(value) ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
        }
        if (value && this.typedString === "" && !this.allowCustom && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
            var checkFields1_1 = this.typeOfData(this.dataSource).typeof === "string" ? "" : this.fields.value;
            var listLength_1 = this.getItems().length;
            var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
            // eslint-disable-next-line @typescript-eslint/tslint/config
            var _this_2 = this;
            new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.dataSource).executeQuery(query.where(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(checkFields1_1, "equal", value))).then(function(e) {
                if (e.result.length > 0) {
                    _this_2.value = checkFields1_1 !== "" ? _this_2.allowObjectBinding ? e.result[0] : e.result[0][_this_2.fields.value].toString() : e.result[0].toString();
                    _this_2.addItem(e.result, listLength_1);
                    _this_2.updateValues();
                } else {
                    if (newProp && newProp.text) _this_2.setOldText(oldValue);
                    else if (newProp && newProp.value) _this_2.setOldValue(oldValue);
                    else _this_2.updateValues();
                }
            });
        } else if (newProp) {
            if (newProp.text) this.setOldText(oldValue);
            else this.setOldValue(oldValue);
        }
    };
    /**
     * Search the entered text and show it in the suggestion list if available.
     *
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} e - The event object.
     * @returns {void}

     */ AutoComplete.prototype.showPopup = function(e) {
        if (!this.enabled) return;
        if (this.beforePopupOpen) {
            this.refreshPopup();
            return;
        }
        this.beforePopupOpen = true;
        this.preventAutoFill = true;
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) this.renderList(e);
        else this.resetList(this.dataSource, this.fields, null, e);
    };
    /**
     * Hides the popup if it is in open state.
     *
     * @param {MouseEvent | KeyboardEventArgs | TouchEvent} e - The event object.
     * @returns {void}
     */ AutoComplete.prototype.hidePopup = function(e) {
        _super.prototype.hidePopup.call(this, e);
        this.activeIndex = null;
        this.virtualListInfo = this.viewPortInfo;
        this.previousStartIndex = this.viewPortInfo.startIndex;
        this.startIndex = this.viewPortInfo.startIndex;
        this.previousEndIndex = this.viewPortInfo.endIndex;
    };
    /**
     * Dynamically change the value of properties.
     *
     * @param {AutoCompleteModel} newProp - Returns the dynamic property value of the component.
     * @param {AutoCompleteModel} oldProp - Returns the previous property value of the component.
     * @private
     * @returns {void}
     */ AutoComplete.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (this.getModuleName() === "autocomplete") this.setUpdateInitial([
            "fields",
            "query",
            "dataSource"
        ], newProp);
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "showPopupButton":
                    if (this.showPopupButton) {
                        var button = (0, $168e4e125732cd26$export$f5b8910cec6cf069).appendSpan((0, $e5d35cabace4110f$export$9787c7b65ab00376).icon, this.inputWrapper.container, this.createElement);
                        this.inputWrapper.buttons[0] = button;
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
                        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                        if (this.inputWrapper && this.inputWrapper.buttons && this.inputWrapper.buttons[0]) (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "click", this.dropDownClick, this);
                    } else {
                        (0, $4ZDHT.detach)(this.inputWrapper.buttons[0]);
                        this.inputWrapper.buttons[0] = null;
                    }
                    break;
                default:
                    // eslint-disable-next-line max-len
                    var atcProps = this.getPropObject(prop, newProp, oldProp);
                    _super.prototype.onPropertyChanged.call(this, atcProps.newProperty, atcProps.oldProperty);
                    break;
            }
        }
    };
    AutoComplete.prototype.renderHightSearch = function() {
        if (this.highlight) for(var i = 0; i < this.liCollections.length; i++){
            var isHighlight = this.ulElement.querySelector(".e-active");
            if (!isHighlight) {
                (0, $faaab5eef2504967$export$97545a2550156b83)(this.liCollections[i]);
                (0, $faaab5eef2504967$export$9183789c55011a91)(this.liCollections[i], this.queryString, this.ignoreCase, this.filterType);
            }
            isHighlight = null;
        }
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ AutoComplete.prototype.getModuleName = function() {
        return "autocomplete";
    };
    /**
     * To initialize the control rendering
     *
     * @private
     * @returns {void}
     */ AutoComplete.prototype.render = function() {
        _super.prototype.render.call(this);
    };
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Complex)({
            value: null,
            iconCss: null,
            groupBy: null,
            disabled: null
        }, (0, $8333a85b68b3ebf8$export$47acbd07e937cc3e))
    ], AutoComplete.prototype, "fields", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], AutoComplete.prototype, "ignoreCase", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], AutoComplete.prototype, "showPopupButton", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], AutoComplete.prototype, "highlight", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(20)
    ], AutoComplete.prototype, "suggestionCount", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)({})
    ], AutoComplete.prototype, "htmlAttributes", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AutoComplete.prototype, "query", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], AutoComplete.prototype, "minLength", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)("Contains")
    ], AutoComplete.prototype, "filterType", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Event)()
    ], AutoComplete.prototype, "filtering", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AutoComplete.prototype, "index", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], AutoComplete.prototype, "floatLabelType", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AutoComplete.prototype, "valueTemplate", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AutoComplete.prototype, "filterBarPlaceholder", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], AutoComplete.prototype, "allowFiltering", void 0);
    $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AutoComplete.prototype, "text", void 0);
    AutoComplete = $1b6f3188acd1d256$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], AutoComplete);
    return AutoComplete;
}((0, $7ca2c62dd20a2561$export$72b9695b8216309a));



parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");




/**
 * `string filterui` render string column.
 *
 * @hidden
 */ var $a54cca84c1c45646$export$ddd9b05a64438cbf = /** @class */ function() {
    function StringFilterUI(parent, serviceLocator, filterSettings) {
        this.parent = parent;
        this.serLocator = serviceLocator;
        this.filterSettings = filterSettings;
        if (this.parent) {
            this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy, this);
            this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        }
    }
    StringFilterUI.prototype.create = function(args) {
        this.instance = this.parent.createElement("input", {
            className: "e-flmenu-input",
            id: "strui-" + args.column.uid
        });
        args.target.appendChild(this.instance);
        this.dialogObj = args.dialogObj;
        this.processDataOperation(args);
    };
    StringFilterUI.prototype.processDataOperation = function(args) {
        var _this = this;
        if (args.column.isForeignColumn()) {
            this.parent.getDataModule().dataManager.executeQuery(this.parent.getDataModule().generateQuery(true)).then(function(result) {
                _this.getAutoCompleteOptions(args, result);
            });
            return;
        }
        this.getAutoCompleteOptions(args);
    };
    StringFilterUI.prototype.getAutoCompleteOptions = function(args, result) {
        var isForeignColumn = args.column.isForeignColumn();
        var foreignColumnQuery;
        if (isForeignColumn) {
            var filteredData = (0, $66db5ede9cdf4d76$export$325f55b6c744802a).getDistinct(result.result, args.column.field).records || [];
            var filterQuery = void 0;
            for(var i = 0; i < filteredData.length; i++)if (filterQuery) filterQuery = filterQuery.or(args.column.field, "contains", filteredData[parseInt(i.toString(), 10)][args.column.field], this.parent.filterSettings.enableCaseSensitivity, this.parent.filterSettings.ignoreAccent);
            else filterQuery = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(args.column.field, "contains", filteredData[parseInt(i.toString(), 10)][args.column.field], this.parent.filterSettings.enableCaseSensitivity, this.parent.filterSettings.ignoreAccent);
            foreignColumnQuery = new (0, $56262f229d1cff45$export$62297b13309008b2)().where(filterQuery);
            foreignColumnQuery.params = this.parent.query.params;
        }
        var dataSource = isForeignColumn ? args.column.dataSource : this.parent.dataSource;
        var fields = {
            value: isForeignColumn ? args.column.foreignKeyValue : args.column.field
        };
        var autoComplete = new (0, $1b6f3188acd1d256$export$6b41f50dc0c59fb3)((0, $3EnZW.extend)({
            dataSource: dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource),
            fields: fields,
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl,
            query: isForeignColumn ? foreignColumnQuery : this.parent.getDataModule().generateQuery(true, true),
            sortOrder: "Ascending",
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            autofill: true,
            placeholder: args.localizeText.getConstant("EnterValue"),
            actionBegin: function() {
                if (this.query.queries.length && this.query.queries[0].fn === "onWhere" && this.query.queries[0].e && this.query.queries[0].e.predicates) {
                    for(var i = 0; i < this.query.queries[0].e.predicates.length; i++)if (this.properties.fields.value === this.query.queries[0].e.predicates["" + i].field) {
                        this.query.queries[0].e.predicates.splice(i, 1);
                        i = i - 1;
                    }
                    if (!this.query.queries[0].e.predicates.length) this.query.queries.splice(0, 1);
                }
            }
        }, args.column.filter.params));
        this.acFocus = this.focus(autoComplete, args);
        this.acComplete = this.actionComplete(autoComplete);
        this.acOpen = this.openPopup.bind(this);
        autoComplete.addEventListener($1b5568e76cdae6d4$export$d7ddd398f22d79ef, this.acFocus);
        autoComplete.addEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.acOpen);
        autoComplete.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.acComplete);
        if (dataSource && "result" in dataSource) {
            var query = this.parent.getQuery ? this.parent.getQuery().clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
            var defObj = (0, $748c2240e597a9b7$export$5bafd3a29592d203)({
                requestType: "stringfilterrequest"
            }, query);
            this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, defObj.state);
            var def = defObj.deffered;
            def.promise.then(function(e) {
                autoComplete.dataSource = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(e);
            });
        }
        this.actObj = autoComplete;
        this.actObj.appendTo(this.instance);
        if (isForeignColumn) this.parent.filterModule.filterModule.afterRenderFilterUI();
    };
    StringFilterUI.prototype.write = function(args) {
        if (args.filteredValue !== "" && !(0, $3EnZW.isNullOrUndefined)(args.filteredValue)) {
            var struiObj = document.querySelector("#strui-" + args.column.uid).ej2_instances[0];
            struiObj.value = args.filteredValue;
        }
    };
    StringFilterUI.prototype.read = function(element, column, filterOptr, filterObj) {
        var actuiObj = document.querySelector("#strui-" + column.uid).ej2_instances[0];
        if ((0, $5q7BP.Browser).isDevice) {
            actuiObj.hidePopup();
            actuiObj.focusOut();
        }
        var filterValue = actuiObj.value;
        if ((0, $3EnZW.isNullOrUndefined)(filterValue) || filterValue === "") filterValue = null;
        filterObj.filterByColumn(column.field, filterOptr, filterValue, "and", this.parent.filterSettings.enableCaseSensitivity);
    };
    StringFilterUI.prototype.openPopup = function(args) {
        (0, $748c2240e597a9b7$export$c50bf978b3bcbfde)(args, this.dialogObj);
    };
    StringFilterUI.prototype.focus = function(actObj, args) {
        return function() {
            actObj.filterType = args.getOptrInstance.getFlOperator();
        };
    };
    StringFilterUI.prototype.actionComplete = function(actObj) {
        return function(e) {
            e.result = e.result.filter(function(obj, index, arr) {
                return arr.map(function(mapObj) {
                    return (0, $3EnZW.getValue)(actObj.fields.value, mapObj);
                }).indexOf((0, $3EnZW.getValue)(actObj.fields.value, obj)) === index;
            });
        };
    };
    StringFilterUI.prototype.destroy = function() {
        if (!this.actObj || this.actObj.isDestroyed) return;
        this.actObj.removeEventListener($1b5568e76cdae6d4$export$d7ddd398f22d79ef, this.acFocus);
        this.actObj.removeEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.acOpen);
        this.actObj.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.acComplete);
        this.actObj.destroy();
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    return StringFilterUI;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");
var $e7i2H = parcelRequire("e7i2H");

var $75082a70d3498091$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $75082a70d3498091$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $75082a70d3498091$var$ROOT = "e-control-wrapper e-numeric";
var $75082a70d3498091$var$SPINICON = "e-input-group-icon";
var $75082a70d3498091$var$SPINUP = "e-spin-up";
var $75082a70d3498091$var$SPINDOWN = "e-spin-down";
var $75082a70d3498091$var$ERROR = "e-error";
var $75082a70d3498091$var$INCREMENT = "increment";
var $75082a70d3498091$var$DECREMENT = "decrement";
var $75082a70d3498091$var$INTREGEXP = new RegExp("^(-)?(\\d*)$");
var $75082a70d3498091$var$DECIMALSEPARATOR = ".";
var $75082a70d3498091$var$COMPONENT = "e-numerictextbox";
var $75082a70d3498091$var$CONTROL = "e-control";
var $75082a70d3498091$var$NUMERIC_FOCUS = "e-input-focus";
var $75082a70d3498091$var$HIDDENELEMENT = "e-numeric-hidden";
var $75082a70d3498091$var$wrapperAttributes = [
    "title",
    "style",
    "class"
];
var $75082a70d3498091$var$selectionTimeOut = 0;
/**
 * Represents the NumericTextBox component that allows the user to enter only numeric values.
 * ```html
 * <input type='text' id="numeric"/>
 * ```
 * ```typescript
 * <script>
 *   var numericObj = new NumericTextBox({ value: 10 });
 *   numericObj.appendTo("#numeric");
 * </script>
 * ```
 */ var $75082a70d3498091$export$d910e4596d16bb81 = /** @class */ function(_super) {
    $75082a70d3498091$var$__extends(NumericTextBox, _super);
    /**
     *
     * @param {NumericTextBoxModel} options - Specifies the NumericTextBox model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function NumericTextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.preventChange = false;
        _this.isDynamicChange = false;
        _this.numericOptions = options;
        return _this;
    }
    NumericTextBox.prototype.preRender = function() {
        this.isPrevFocused = false;
        this.decimalSeparator = ".";
        // eslint-disable-next-line no-useless-escape
        this.intRegExp = new RegExp("/^(-)?(d*)$/");
        this.isCalled = false;
        var ejInstance = (0, $3EnZW.getValue)("ej2_instances", this.element);
        this.cloneElement = this.element.cloneNode(true);
        (0, $4ZDHT.removeClass)([
            this.cloneElement
        ], [
            $75082a70d3498091$var$CONTROL,
            $75082a70d3498091$var$COMPONENT,
            "e-lib"
        ]);
        this.angularTagName = null;
        this.formEle = (0, $4ZDHT.closest)(this.element, "form");
        if (this.element.tagName === "EJS-NUMERICTEXTBOX") {
            this.angularTagName = this.element.tagName;
            var input = this.createElement("input");
            var index = 0;
            for(index; index < this.element.attributes.length; index++){
                var attributeName = this.element.attributes[index].nodeName;
                if (attributeName !== "id" && attributeName !== "class") {
                    input.setAttribute(this.element.attributes[index].nodeName, this.element.attributes[index].nodeValue);
                    input.innerHTML = this.element.innerHTML;
                } else if (attributeName === "class") input.setAttribute(attributeName, this.element.className.split(" ").filter(function(item) {
                    return item.indexOf("ng-") !== 0;
                }).join(" "));
            }
            if (this.element.hasAttribute("name")) this.element.removeAttribute("name");
            this.element.classList.remove("e-control", "e-numerictextbox");
            this.element.appendChild(input);
            this.element = input;
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, this.element);
        }
        (0, $4ZDHT.attributes)(this.element, {
            "role": "spinbutton",
            "tabindex": "0",
            "autocomplete": "off"
        });
        var localeText = {
            incrementTitle: "Increment value",
            decrementTitle: "Decrement value",
            placeholder: this.placeholder
        };
        this.l10n = new (0, $e7i2H.L10n)("numerictextbox", localeText, this.locale);
        if (this.l10n.getConstant("placeholder") !== "") this.setProperties({
            placeholder: this.placeholder || this.l10n.getConstant("placeholder")
        }, true);
        if (!this.element.hasAttribute("id")) this.element.setAttribute("id", (0, $3EnZW.getUniqueID)("numerictextbox"));
        this.isValidState = true;
        this.inputStyle = null;
        this.inputName = null;
        this.cultureInfo = {};
        this.initCultureInfo();
        this.initCultureFunc();
        this.prevValue = this.value;
        this.updateHTMLAttrToElement();
        this.checkAttributes(false);
        if (this.formEle) this.inputEleValue = this.value;
        this.validateMinMax();
        this.validateStep();
        if (this.placeholder === null) this.updatePlaceholder();
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ NumericTextBox.prototype.render = function() {
        if (this.element.tagName.toLowerCase() === "input") {
            this.createWrapper();
            if (this.showSpinButton) this.spinBtnCreation();
            this.setElementWidth(this.width);
            if (!this.container.classList.contains("e-input-group")) this.container.classList.add("e-input-group");
            this.changeValue(this.value === null || isNaN(this.value) ? null : this.strictMode ? this.trimValue(this.value) : this.value);
            this.wireEvents();
            if (this.value !== null && !isNaN(this.value)) {
                if (this.decimals) this.setProperties({
                    value: this.roundNumber(this.value, this.decimals)
                }, true);
            }
            if (this.element.getAttribute("value") || this.value) {
                this.element.setAttribute("value", this.element.value);
                this.hiddenInput.setAttribute("value", this.hiddenInput.value);
            }
            this.elementPrevValue = this.element.value;
            if (this.element.hasAttribute("data-val")) this.element.setAttribute("data-val", "false");
            if (!this.element.hasAttribute("aria-labelledby") && !this.element.hasAttribute("placeholder") && !this.element.hasAttribute("aria-label")) this.element.setAttribute("aria-label", "numerictextbox");
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
            this.renderComplete();
        }
    };
    NumericTextBox.prototype.checkAttributes = function(isDynamic) {
        var attributes = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "value",
            "min",
            "max",
            "step",
            "disabled",
            "readonly",
            "style",
            "name",
            "placeholder"
        ];
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var prop = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.getAttribute(prop))) switch(prop){
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["enabled"] === undefined || isDynamic) {
                        var enabled = this.element.getAttribute(prop) === "disabled" || this.element.getAttribute(prop) === "" || this.element.getAttribute(prop) === "true" ? false : true;
                        this.setProperties({
                            enabled: enabled
                        }, !isDynamic);
                    }
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["readonly"] === undefined || isDynamic) {
                        var readonly = this.element.getAttribute(prop) === "readonly" || this.element.getAttribute(prop) === "" || this.element.getAttribute(prop) === "true" ? true : false;
                        this.setProperties({
                            readonly: readonly
                        }, !isDynamic);
                    }
                    break;
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["placeholder"] === undefined || isDynamic) this.setProperties({
                        placeholder: this.element.placeholder
                    }, !isDynamic);
                    break;
                case "value":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["value"] === undefined || isDynamic) {
                        var setNumber = this.instance.getNumberParser({
                            format: "n"
                        })(this.element.getAttribute(prop));
                        this.setProperties((0, $3EnZW.setValue)(prop, setNumber, {}), !isDynamic);
                    }
                    break;
                case "min":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["min"] === undefined || isDynamic) {
                        var minValue = this.instance.getNumberParser({
                            format: "n"
                        })(this.element.getAttribute(prop));
                        if (minValue !== null && !isNaN(minValue)) this.setProperties((0, $3EnZW.setValue)(prop, minValue, {}), !isDynamic);
                    }
                    break;
                case "max":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["max"] === undefined || isDynamic) {
                        var maxValue = this.instance.getNumberParser({
                            format: "n"
                        })(this.element.getAttribute(prop));
                        if (maxValue !== null && !isNaN(maxValue)) this.setProperties((0, $3EnZW.setValue)(prop, maxValue, {}), !isDynamic);
                    }
                    break;
                case "step":
                    if ((0, $3EnZW.isNullOrUndefined)(this.numericOptions) || this.numericOptions["step"] === undefined || isDynamic) {
                        var stepValue = this.instance.getNumberParser({
                            format: "n"
                        })(this.element.getAttribute(prop));
                        if (stepValue !== null && !isNaN(stepValue)) this.setProperties((0, $3EnZW.setValue)(prop, stepValue, {}), !isDynamic);
                    }
                    break;
                case "style":
                    this.inputStyle = this.element.getAttribute(prop);
                    break;
                case "name":
                    this.inputName = this.element.getAttribute(prop);
                    break;
                default:
                    var value = this.instance.getNumberParser({
                        format: "n"
                    })(this.element.getAttribute(prop));
                    if (value !== null && !isNaN(value) || prop === "value") this.setProperties((0, $3EnZW.setValue)(prop, value, {}), true);
                    break;
            }
        }
    };
    NumericTextBox.prototype.updatePlaceholder = function() {
        this.setProperties({
            placeholder: this.l10n.getConstant("placeholder")
        }, true);
    };
    NumericTextBox.prototype.initCultureFunc = function() {
        this.instance = new (0, $bWDaN.Internationalization)(this.locale);
    };
    NumericTextBox.prototype.initCultureInfo = function() {
        this.cultureInfo.format = this.format;
        if ((0, $3EnZW.getValue)("currency", this) !== null) {
            (0, $3EnZW.setValue)("currency", this.currency, this.cultureInfo);
            this.setProperties({
                currencyCode: this.currency
            }, true);
        }
    };
    /* Wrapper creation */ NumericTextBox.prototype.createWrapper = function() {
        var updatedCssClassValue = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValue = this.getNumericValidClassList(this.cssClass);
        var inputObj = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: {
                readonly: this.readonly,
                placeholder: this.placeholder,
                cssClass: updatedCssClassValue,
                enableRtl: this.enableRtl,
                showClearButton: this.showClearButton,
                enabled: this.enabled
            }
        }, this.createElement);
        this.inputWrapper = inputObj;
        this.container = inputObj.container;
        this.container.setAttribute("class", $75082a70d3498091$var$ROOT + " " + this.container.getAttribute("class"));
        this.updateHTMLAttrToWrapper();
        if (this.readonly) (0, $4ZDHT.attributes)(this.element, {
            "aria-readonly": "true"
        });
        this.hiddenInput = this.createElement("input", {
            attrs: {
                type: "text",
                "validateHidden": "true",
                "aria-label": "hidden",
                "class": $75082a70d3498091$var$HIDDENELEMENT
            }
        });
        this.inputName = this.inputName !== null ? this.inputName : this.element.id;
        this.element.removeAttribute("name");
        if (this.isAngular && this.angularTagName === "EJS-NUMERICTEXTBOX" && this.cloneElement.id.length > 0) (0, $4ZDHT.attributes)(this.hiddenInput, {
            "name": this.cloneElement.id
        });
        else (0, $4ZDHT.attributes)(this.hiddenInput, {
            "name": this.inputName
        });
        this.container.insertBefore(this.hiddenInput, this.container.childNodes[1]);
        this.updateDataAttribute(false);
        if (this.inputStyle !== null) (0, $4ZDHT.attributes)(this.container, {
            "style": this.inputStyle
        });
    };
    NumericTextBox.prototype.updateDataAttribute = function(isDynamic) {
        var attr = {};
        if (!isDynamic) for(var a = 0; a < this.element.attributes.length; a++)attr[this.element.attributes[a].name] = this.element.getAttribute(this.element.attributes[a].name);
        else attr = this.htmlAttributes;
        for(var _i = 0, _a = Object.keys(attr); _i < _a.length; _i++){
            var key = _a[_i];
            if (key.indexOf("data") === 0) this.hiddenInput.setAttribute(key, attr["" + key]);
        }
    };
    NumericTextBox.prototype.updateHTMLAttrToElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var pro = _a[_i];
            if ($75082a70d3498091$var$wrapperAttributes.indexOf(pro) < 0) this.element.setAttribute(pro, this.htmlAttributes["" + pro]);
        }
    };
    NumericTextBox.prototype.updateCssClass = function(newClass, oldClass) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(this.getNumericValidClassList(newClass), [
            this.container
        ], this.getNumericValidClassList(oldClass));
    };
    NumericTextBox.prototype.getNumericValidClassList = function(numericClassName) {
        var result = numericClassName;
        if (!(0, $3EnZW.isNullOrUndefined)(numericClassName) && numericClassName !== "") result = numericClassName.replace(/\s+/g, " ").trim();
        return result;
    };
    NumericTextBox.prototype.updateHTMLAttrToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var pro = _a[_i];
            if ($75082a70d3498091$var$wrapperAttributes.indexOf(pro) > -1) {
                if (pro === "class") {
                    var updatedClassValue = this.getNumericValidClassList(this.htmlAttributes["" + pro]);
                    if (updatedClassValue !== "") (0, $4ZDHT.addClass)([
                        this.container
                    ], updatedClassValue.split(" "));
                } else if (pro === "style") {
                    var numericStyle = this.container.getAttribute(pro);
                    numericStyle = !(0, $3EnZW.isNullOrUndefined)(numericStyle) ? numericStyle + this.htmlAttributes["" + pro] : this.htmlAttributes["" + pro];
                    this.container.setAttribute(pro, numericStyle);
                } else this.container.setAttribute(pro, this.htmlAttributes["" + pro]);
            }
        }
    };
    NumericTextBox.prototype.setElementWidth = function(width) {
        if (!(0, $3EnZW.isNullOrUndefined)(width)) {
            if (typeof width === "number") this.container.style.width = (0, $3EnZW.formatUnit)(width);
            else if (typeof width === "string") this.container.style.width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        }
    };
    /* Spinner creation */ NumericTextBox.prototype.spinBtnCreation = function() {
        this.spinDown = (0, $168e4e125732cd26$export$f5b8910cec6cf069).appendSpan($75082a70d3498091$var$SPINICON + " " + $75082a70d3498091$var$SPINDOWN, this.container, this.createElement);
        (0, $4ZDHT.attributes)(this.spinDown, {
            "title": this.l10n.getConstant("decrementTitle")
        });
        this.spinUp = (0, $168e4e125732cd26$export$f5b8910cec6cf069).appendSpan($75082a70d3498091$var$SPINICON + " " + $75082a70d3498091$var$SPINUP, this.container, this.createElement);
        (0, $4ZDHT.attributes)(this.spinUp, {
            "title": this.l10n.getConstant("incrementTitle")
        });
        this.wireSpinBtnEvents();
    };
    NumericTextBox.prototype.validateMinMax = function() {
        if (!(typeof this.min === "number" && !isNaN(this.min))) this.setProperties({
            min: -Number.MAX_VALUE
        }, true);
        if (!(typeof this.max === "number" && !isNaN(this.max))) this.setProperties({
            max: Number.MAX_VALUE
        }, true);
        if (this.decimals !== null) {
            if (this.min !== -Number.MAX_VALUE) this.setProperties({
                min: this.instance.getNumberParser({
                    format: "n"
                })(this.formattedValue(this.decimals, this.min))
            }, true);
            if (this.max !== Number.MAX_VALUE) this.setProperties({
                max: this.instance.getNumberParser({
                    format: "n"
                })(this.formattedValue(this.decimals, this.max))
            }, true);
        }
        this.setProperties({
            min: this.min > this.max ? this.max : this.min
        }, true);
        if (this.min !== -Number.MAX_VALUE) (0, $4ZDHT.attributes)(this.element, {
            "aria-valuemin": this.min.toString()
        });
        if (this.max !== Number.MAX_VALUE) (0, $4ZDHT.attributes)(this.element, {
            "aria-valuemax": this.max.toString()
        });
    };
    NumericTextBox.prototype.formattedValue = function(decimals, value) {
        return this.instance.getNumberFormat({
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals,
            useGrouping: false
        })(value);
    };
    NumericTextBox.prototype.validateStep = function() {
        if (this.decimals !== null) this.setProperties({
            step: this.instance.getNumberParser({
                format: "n"
            })(this.formattedValue(this.decimals, this.step))
        }, true);
    };
    NumericTextBox.prototype.action = function(operation, event) {
        this.isInteract = true;
        var value = this.isFocused ? this.instance.getNumberParser({
            format: "n"
        })(this.element.value) : this.value;
        this.changeValue(this.performAction(value, this.step, operation));
        this.raiseChangeEvent(event);
    };
    NumericTextBox.prototype.checkErrorClass = function() {
        if (this.isValidState) (0, $4ZDHT.removeClass)([
            this.container
        ], $75082a70d3498091$var$ERROR);
        else (0, $4ZDHT.addClass)([
            this.container
        ], $75082a70d3498091$var$ERROR);
        (0, $4ZDHT.attributes)(this.element, {
            "aria-invalid": this.isValidState ? "false" : "true"
        });
    };
    NumericTextBox.prototype.bindClearEvent = function() {
        if (this.showClearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown touchstart", this.resetHandler, this);
    };
    NumericTextBox.prototype.resetHandler = function(e) {
        e.preventDefault();
        if (!this.inputWrapper.clearButton.classList.contains("e-clear-icon-hide") || this.inputWrapper.container.classList.contains("e-static-clear")) this.clear(e);
        this.isInteract = true;
        this.raiseChangeEvent(e);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    NumericTextBox.prototype.clear = function(event) {
        this.setProperties({
            value: null
        }, true);
        this.setElementValue("");
        this.hiddenInput.value = "";
        var formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent("KeyboardEvent");
            keyupEvent.initEvent("keyup", false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.resetFormHandler = function() {
        if (this.element.tagName === "EJS-NUMERICTEXTBOX") this.updateValue(null);
        else this.updateValue(this.inputEleValue);
    };
    NumericTextBox.prototype.setSpinButton = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinDown)) (0, $4ZDHT.attributes)(this.spinDown, {
            "title": this.l10n.getConstant("decrementTitle"),
            "aria-label": this.l10n.getConstant("decrementTitle")
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinUp)) (0, $4ZDHT.attributes)(this.spinUp, {
            "title": this.l10n.getConstant("incrementTitle"),
            "aria-label": this.l10n.getConstant("incrementTitle")
        });
    };
    NumericTextBox.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, "focus", this.focusHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "blur", this.focusOutHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.keyDownHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keyup", this.keyUpHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "input", this.inputHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keypress", this.keyPressHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "change", this.changeHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "paste", this.pasteHandler, this);
        if (this.enabled) {
            this.bindClearEvent();
            if (this.formEle) (0, $aqzbR.EventHandler).add(this.formEle, "reset", this.resetFormHandler, this);
        }
    };
    NumericTextBox.prototype.wireSpinBtnEvents = function() {
        /* bind spin button events */ (0, $aqzbR.EventHandler).add(this.spinUp, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownOnSpinner, this);
        (0, $aqzbR.EventHandler).add(this.spinDown, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownOnSpinner, this);
        (0, $aqzbR.EventHandler).add(this.spinUp, (0, $5q7BP.Browser).touchEndEvent, this.mouseUpOnSpinner, this);
        (0, $aqzbR.EventHandler).add(this.spinDown, (0, $5q7BP.Browser).touchEndEvent, this.mouseUpOnSpinner, this);
        (0, $aqzbR.EventHandler).add(this.spinUp, (0, $5q7BP.Browser).touchMoveEvent, this.touchMoveOnSpinner, this);
        (0, $aqzbR.EventHandler).add(this.spinDown, (0, $5q7BP.Browser).touchMoveEvent, this.touchMoveOnSpinner, this);
    };
    NumericTextBox.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "focus", this.focusHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "blur", this.focusOutHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keyup", this.keyUpHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "input", this.inputHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.keyDownHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keypress", this.keyPressHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "change", this.changeHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "paste", this.pasteHandler);
        if (this.formEle) (0, $aqzbR.EventHandler).remove(this.formEle, "reset", this.resetFormHandler);
    };
    NumericTextBox.prototype.unwireSpinBtnEvents = function() {
        /* unbind spin button events */ (0, $aqzbR.EventHandler).remove(this.spinUp, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownOnSpinner);
        (0, $aqzbR.EventHandler).remove(this.spinDown, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownOnSpinner);
        (0, $aqzbR.EventHandler).remove(this.spinUp, (0, $5q7BP.Browser).touchEndEvent, this.mouseUpOnSpinner);
        (0, $aqzbR.EventHandler).remove(this.spinDown, (0, $5q7BP.Browser).touchEndEvent, this.mouseUpOnSpinner);
        (0, $aqzbR.EventHandler).remove(this.spinUp, (0, $5q7BP.Browser).touchMoveEvent, this.touchMoveOnSpinner);
        (0, $aqzbR.EventHandler).remove(this.spinDown, (0, $5q7BP.Browser).touchMoveEvent, this.touchMoveOnSpinner);
    };
    NumericTextBox.prototype.changeHandler = function(event) {
        event.stopPropagation();
        if (!this.element.value.length) this.setProperties({
            value: null
        }, true);
        var parsedInput = this.instance.getNumberParser({
            format: "n"
        })(this.element.value);
        this.updateValue(parsedInput, event);
    };
    NumericTextBox.prototype.raiseChangeEvent = function(event) {
        this.inputValue = (0, $3EnZW.isNullOrUndefined)(this.inputValue) || isNaN(this.inputValue) ? null : this.inputValue;
        if (this.prevValue !== this.value || this.prevValue !== this.inputValue) {
            var eventArgs = {};
            this.changeEventArgs = {
                value: this.value,
                previousValue: this.prevValue,
                isInteracted: this.isInteract,
                isInteraction: this.isInteract,
                event: event
            };
            if (event) this.changeEventArgs.event = event;
            if (this.changeEventArgs.event === undefined) {
                this.changeEventArgs.isInteracted = false;
                this.changeEventArgs.isInteraction = false;
            }
            (0, $3EnZW.merge)(eventArgs, this.changeEventArgs);
            this.prevValue = this.value;
            this.isInteract = false;
            this.elementPrevValue = this.element.value;
            this.preventChange = false;
            this.trigger("change", eventArgs);
        }
    };
    NumericTextBox.prototype.pasteHandler = function() {
        var _this = this;
        if (!this.enabled || this.readonly) return;
        var beforeUpdate = this.element.value;
        setTimeout(function() {
            if (!_this.numericRegex().test(_this.element.value)) _this.setElementValue(beforeUpdate);
        });
    };
    NumericTextBox.prototype.preventHandler = function() {
        var _this = this;
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        setTimeout(function() {
            if (_this.element.selectionStart > 0) {
                var currentPos = _this.element.selectionStart;
                var prevPos = _this.element.selectionStart - 1;
                var start = 0;
                var valArray = _this.element.value.split("");
                var numericObject = (0, $bWDaN.getNumericObject)(_this.locale);
                var decimalSeparator = (0, $3EnZW.getValue)("decimal", numericObject);
                var ignoreKeyCode = decimalSeparator.charCodeAt(0);
                if (_this.element.value[prevPos] === " " && _this.element.selectionStart > 0 && !iOS) {
                    if ((0, $3EnZW.isNullOrUndefined)(_this.prevVal)) _this.element.value = _this.element.value.trim();
                    else if (prevPos !== 0) _this.element.value = _this.prevVal;
                    else if (prevPos === 0) _this.element.value = _this.element.value.trim();
                    _this.element.setSelectionRange(prevPos, prevPos);
                } else if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1])) && _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) !== 45) {
                    if (valArray.indexOf(_this.element.value[_this.element.selectionStart - 1]) !== valArray.lastIndexOf(_this.element.value[_this.element.selectionStart - 1]) && _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) === ignoreKeyCode || _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) !== ignoreKeyCode) {
                        _this.element.value = _this.element.value.substring(0, prevPos) + _this.element.value.substring(currentPos, _this.element.value.length);
                        _this.element.setSelectionRange(prevPos, prevPos);
                        if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1])) && _this.element.selectionStart > 0 && _this.element.value.length) _this.preventHandler();
                    }
                } else if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 2])) && _this.element.selectionStart > 1 && _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) !== 45) {
                    if (valArray.indexOf(_this.element.value[_this.element.selectionStart - 2]) !== valArray.lastIndexOf(_this.element.value[_this.element.selectionStart - 2]) && _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) === ignoreKeyCode || _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) !== ignoreKeyCode) {
                        _this.element.setSelectionRange(prevPos, prevPos);
                        _this.nextEle = _this.element.value[_this.element.selectionStart];
                        _this.cursorPosChanged = true;
                        _this.preventHandler();
                    }
                }
                if (_this.cursorPosChanged === true && _this.element.value[_this.element.selectionStart] === _this.nextEle && isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1]))) {
                    _this.element.setSelectionRange(_this.element.selectionStart + 1, _this.element.selectionStart + 1);
                    _this.cursorPosChanged = false;
                    _this.nextEle = null;
                }
                if (_this.element.value.trim() === "") _this.element.setSelectionRange(start, start);
                if (_this.element.selectionStart > 0) {
                    if (_this.element.value[_this.element.selectionStart - 1].charCodeAt(0) === 45 && _this.element.selectionStart > 1) {
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.prevVal)) _this.element.value = _this.prevVal;
                        _this.element.setSelectionRange(_this.element.selectionStart, _this.element.selectionStart);
                    }
                    if (_this.element.value[_this.element.selectionStart - 1] === decimalSeparator && _this.decimals === 0 && _this.validateDecimalOnType) _this.element.value = _this.element.value.substring(0, prevPos) + _this.element.value.substring(currentPos, _this.element.value.length);
                }
                _this.prevVal = _this.element.value;
            }
        });
    };
    NumericTextBox.prototype.keyUpHandler = function() {
        if (!this.enabled || this.readonly) return;
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if (!iOS && (0, $5q7BP.Browser).isDevice) this.preventHandler();
        var parseValue = this.instance.getNumberParser({
            format: "n"
        })(this.element.value);
        parseValue = parseValue === null || isNaN(parseValue) ? null : parseValue;
        this.hiddenInput.value = parseValue || parseValue === 0 ? parseValue.toString() : null;
        var formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent("KeyboardEvent");
            keyupEvent.initEvent("keyup", false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.inputHandler = function(event) {
        var numerictextboxObj = this;
        if (!this.enabled || this.readonly) return;
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        var fireFox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        if ((fireFox || iOS) && (0, $5q7BP.Browser).isDevice) this.preventHandler();
        /* istanbul ignore next */ if (this.isAngular && this.element.value !== (0, $3EnZW.getValue)("decimal", (0, $bWDaN.getNumericObject)(this.locale)) && this.element.value !== (0, $3EnZW.getValue)("minusSign", (0, $bWDaN.getNumericObject)(this.locale))) {
            var parsedValue = this.instance.getNumberParser({
                format: "n"
            })(this.element.value);
            parsedValue = isNaN(parsedValue) ? null : parsedValue;
            numerictextboxObj.localChange({
                value: parsedValue
            });
            this.preventChange = true;
        }
        if (this.isVue) {
            var current = this.instance.getNumberParser({
                format: "n"
            })(this.element.value);
            var previous = this.instance.getNumberParser({
                format: "n"
            })(this.elementPrevValue);
            //EJ2-54963-if type "." or ".0" or "-.0" it converts to "0" automatically when binding v-model
            var nonZeroRegex = new RegExp("[^0-9]+$");
            if (nonZeroRegex.test(this.element.value) || (this.elementPrevValue.indexOf(".") !== -1 || this.elementPrevValue.indexOf("-") !== -1) && this.element.value[this.element.value.length - 1] === "0") current = this.value;
            var eventArgs = {
                event: event,
                value: current === null || isNaN(current) ? null : current,
                previousValue: previous === null || isNaN(previous) ? null : previous
            };
            this.preventChange = true;
            this.elementPrevValue = this.element.value;
            this.trigger("input", eventArgs);
        }
    };
    NumericTextBox.prototype.keyDownHandler = function(event) {
        if (!this.readonly) switch(event.keyCode){
            case 38:
                event.preventDefault();
                this.action($75082a70d3498091$var$INCREMENT, event);
                break;
            case 40:
                event.preventDefault();
                this.action($75082a70d3498091$var$DECREMENT, event);
                break;
            default:
                break;
        }
    };
    NumericTextBox.prototype.performAction = function(value, step, operation) {
        if (value === null || isNaN(value)) value = 0;
        var updatedValue = operation === $75082a70d3498091$var$INCREMENT ? value + step : value - step;
        updatedValue = this.correctRounding(value, step, updatedValue);
        return this.strictMode ? this.trimValue(updatedValue) : updatedValue;
    };
    NumericTextBox.prototype.correctRounding = function(value, step, result) {
        var floatExp = new RegExp("[,.](.*)");
        var floatValue = floatExp.test(value.toString());
        var floatStep = floatExp.test(step.toString());
        if (floatValue || floatStep) {
            var valueCount = floatValue ? floatExp.exec(value.toString())[0].length : 0;
            var stepCount = floatStep ? floatExp.exec(step.toString())[0].length : 0;
            var max = Math.max(valueCount, stepCount);
            return value = this.roundValue(result, max);
        }
        return result;
    };
    NumericTextBox.prototype.roundValue = function(result, precision) {
        precision = precision || 0;
        var divide = Math.pow(10, precision);
        return result *= divide, result = Math.round(result) / divide;
    };
    NumericTextBox.prototype.updateValue = function(value, event) {
        if (event) this.isInteract = true;
        if (value !== null && !isNaN(value)) {
            if (this.decimals) value = this.roundNumber(value, this.decimals);
        }
        this.inputValue = value;
        this.changeValue(value === null || isNaN(value) ? null : this.strictMode ? this.trimValue(value) : value);
        /* istanbul ignore next */ if (!this.isDynamicChange) this.raiseChangeEvent(event);
    };
    NumericTextBox.prototype.updateCurrency = function(prop, propVal) {
        (0, $3EnZW.setValue)(prop, propVal, this.cultureInfo);
        this.updateValue(this.value);
    };
    NumericTextBox.prototype.changeValue = function(value) {
        if (!(value || value === 0)) {
            value = null;
            this.setProperties({
                value: value
            }, true);
        } else {
            var numberOfDecimals = this.getNumberOfDecimals(value);
            this.setProperties({
                value: this.roundNumber(value, numberOfDecimals)
            }, true);
        }
        this.modifyText();
        if (!this.strictMode) this.validateState();
    };
    NumericTextBox.prototype.modifyText = function() {
        if (this.value || this.value === 0) {
            var value = this.formatNumber();
            var elementValue = this.isFocused ? value : this.instance.getNumberFormat(this.cultureInfo)(this.value);
            this.setElementValue(elementValue);
            (0, $4ZDHT.attributes)(this.element, {
                "aria-valuenow": value
            });
            this.hiddenInput.value = this.value.toString();
            if (this.value !== null && this.serverDecimalSeparator) this.hiddenInput.value = this.hiddenInput.value.replace(".", this.serverDecimalSeparator);
        } else {
            this.setElementValue("");
            this.element.removeAttribute("aria-valuenow");
            this.hiddenInput.value = null;
        }
    };
    NumericTextBox.prototype.setElementValue = function(val, element) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(val, element ? element : this.element, this.floatLabelType, this.showClearButton);
    };
    NumericTextBox.prototype.validateState = function() {
        this.isValidState = true;
        if (this.value || this.value === 0) this.isValidState = !(this.value > this.max || this.value < this.min);
        this.checkErrorClass();
    };
    NumericTextBox.prototype.getNumberOfDecimals = function(value) {
        var numberOfDecimals;
        // eslint-disable-next-line no-useless-escape
        var EXPREGEXP = new RegExp("[eE][-+]?([0-9]+)");
        var valueString = value.toString();
        if (EXPREGEXP.test(valueString)) {
            var result = EXPREGEXP.exec(valueString);
            if (!(0, $3EnZW.isNullOrUndefined)(result)) valueString = value.toFixed(Math.min(parseInt(result[1], 10), 20));
        }
        var decimalPart = valueString.split(".")[1];
        numberOfDecimals = !decimalPart || !decimalPart.length ? 0 : decimalPart.length;
        if (this.decimals !== null) numberOfDecimals = numberOfDecimals < this.decimals ? numberOfDecimals : this.decimals;
        return numberOfDecimals;
    };
    NumericTextBox.prototype.formatNumber = function() {
        var numberOfDecimals = this.getNumberOfDecimals(this.value);
        return this.instance.getNumberFormat({
            maximumFractionDigits: numberOfDecimals,
            minimumFractionDigits: numberOfDecimals,
            useGrouping: false
        })(this.value);
    };
    NumericTextBox.prototype.trimValue = function(value) {
        if (value > this.max) return this.max;
        if (value < this.min) return this.min;
        return value;
    };
    NumericTextBox.prototype.roundNumber = function(value, precision) {
        var result = value;
        var decimals = precision || 0;
        var result1 = result.toString().split("e");
        result = Math.round(Number(result1[0] + "e" + (result1[1] ? Number(result1[1]) + decimals : decimals)));
        var result2 = result.toString().split("e");
        result = Number(result2[0] + "e" + (result2[1] ? Number(result2[1]) - decimals : -decimals));
        return Number(result.toFixed(decimals));
    };
    NumericTextBox.prototype.cancelEvent = function(event) {
        event.preventDefault();
        return false;
    };
    NumericTextBox.prototype.keyPressHandler = function(event) {
        if (!this.enabled || this.readonly) return true;
        if (!(0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).info.version === "11.0" && event.keyCode === 13) {
            var parsedInput = this.instance.getNumberParser({
                format: "n"
            })(this.element.value);
            this.updateValue(parsedInput, event);
            return true;
        }
        if (event.which === 0 || event.metaKey || event.ctrlKey || event.keyCode === 8 || event.keyCode === 13) return true;
        var currentChar = String.fromCharCode(event.which);
        var decimalSeparator = (0, $3EnZW.getValue)("decimal", (0, $bWDaN.getNumericObject)(this.locale));
        var isAlterNumPadDecimalChar = event.code === "NumpadDecimal" && currentChar !== decimalSeparator;
        //EJ2-59813-replace the culture decimal separator value with numberpad decimal separator value when culture decimal separator and numberpad decimal separator are different
        if (isAlterNumPadDecimalChar) currentChar = decimalSeparator;
        var text = this.element.value;
        text = text.substring(0, this.element.selectionStart) + currentChar + text.substring(this.element.selectionEnd);
        if (!this.numericRegex().test(text)) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        } else {
            //EJ2-59813-update the numberpad decimal separator and update the cursor position
            if (isAlterNumPadDecimalChar) {
                var start = this.element.selectionStart + 1;
                this.element.value = text;
                this.element.setSelectionRange(start, start);
                event.preventDefault();
                event.stopPropagation();
            }
            return true;
        }
    };
    NumericTextBox.prototype.numericRegex = function() {
        var numericObject = (0, $bWDaN.getNumericObject)(this.locale);
        var decimalSeparator = (0, $3EnZW.getValue)("decimal", numericObject);
        var fractionRule = "*";
        if (decimalSeparator === $75082a70d3498091$var$DECIMALSEPARATOR) decimalSeparator = "\\" + decimalSeparator;
        if (this.decimals === 0 && this.validateDecimalOnType) return $75082a70d3498091$var$INTREGEXP;
        if (this.decimals && this.validateDecimalOnType) fractionRule = "{0," + this.decimals + "}";
        /* eslint-disable-next-line security/detect-non-literal-regexp */ return new RegExp("^(-)?(((\\d+(" + decimalSeparator + "\\d" + fractionRule + ")?)|(" + decimalSeparator + "\\d" + fractionRule + ")))?$");
    };
    NumericTextBox.prototype.mouseWheel = function(event) {
        event.preventDefault();
        var delta;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var rawEvent = event;
        if (rawEvent.wheelDelta) delta = rawEvent.wheelDelta / 120;
        else if (rawEvent.detail) delta = -rawEvent.detail / 3;
        if (delta > 0) this.action($75082a70d3498091$var$INCREMENT, event);
        else if (delta < 0) this.action($75082a70d3498091$var$DECREMENT, event);
        this.cancelEvent(event);
    };
    NumericTextBox.prototype.focusHandler = function(event) {
        var _this = this;
        clearTimeout($75082a70d3498091$var$selectionTimeOut);
        this.focusEventArgs = {
            event: event,
            value: this.value,
            container: this.container
        };
        this.trigger("focus", this.focusEventArgs);
        if (!this.enabled || this.readonly) return;
        this.isFocused = true;
        this.prevValue = this.value;
        if (this.value || this.value === 0) {
            var formatValue_1 = this.formatNumber();
            this.setElementValue(formatValue_1);
            if (!this.isPrevFocused) {
                if (!(0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).info.version === "11.0") this.element.setSelectionRange(0, formatValue_1.length);
                else {
                    var delay = (0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos ? 600 : 0;
                    $75082a70d3498091$var$selectionTimeOut = setTimeout(function() {
                        _this.element.setSelectionRange(0, formatValue_1.length);
                    }, delay);
                }
            }
        }
        if (!(0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).add(this.element, "mousewheel DOMMouseScroll", this.mouseWheel, this);
    };
    NumericTextBox.prototype.focusOutHandler = function(event) {
        var _this = this;
        this.blurEventArgs = {
            event: event,
            value: this.value,
            container: this.container
        };
        this.trigger("blur", this.blurEventArgs);
        if (!this.enabled || this.readonly) return;
        if (this.isPrevFocused) {
            event.preventDefault();
            if ((0, $5q7BP.Browser).isDevice) {
                var value_1 = this.element.value;
                this.element.focus();
                this.isPrevFocused = false;
                var ele_1 = this.element;
                setTimeout(function() {
                    _this.setElementValue(value_1, ele_1);
                }, 200);
            }
        } else {
            this.isFocused = false;
            if (!this.element.value.length) this.setProperties({
                value: null
            }, true);
            var parsedInput = this.instance.getNumberParser({
                format: "n"
            })(this.element.value);
            this.updateValue(parsedInput);
            if (!(0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).remove(this.element, "mousewheel DOMMouseScroll", this.mouseWheel);
        }
        var formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (formElement) {
            var element = this.element.nextElementSibling;
            var focusEvent = document.createEvent("FocusEvent");
            focusEvent.initEvent("focusout", false, true);
            element.dispatchEvent(focusEvent);
        }
    };
    NumericTextBox.prototype.mouseDownOnSpinner = function(event) {
        var _this = this;
        if (this.isFocused) {
            this.isPrevFocused = true;
            event.preventDefault();
        }
        if (!this.getElementData(event)) return;
        this.getElementData(event);
        var target = event.currentTarget;
        var action = target.classList.contains($75082a70d3498091$var$SPINUP) ? $75082a70d3498091$var$INCREMENT : $75082a70d3498091$var$DECREMENT;
        (0, $aqzbR.EventHandler).add(target, "mouseleave", this.mouseUpClick, this);
        this.timeOut = setInterval(function() {
            _this.isCalled = true;
            _this.action(action, event);
        }, 150);
        (0, $aqzbR.EventHandler).add(document, "mouseup", this.mouseUpClick, this);
    };
    NumericTextBox.prototype.touchMoveOnSpinner = function(event) {
        var target;
        if (event.type === "touchmove") {
            var touchEvent = event.touches;
            target = touchEvent.length && document.elementFromPoint(touchEvent[0].pageX, touchEvent[0].pageY);
        } else target = document.elementFromPoint(event.clientX, event.clientY);
        if (!target.classList.contains($75082a70d3498091$var$SPINICON)) clearInterval(this.timeOut);
    };
    NumericTextBox.prototype.mouseUpOnSpinner = function(event) {
        this.prevValue = this.value;
        if (this.isPrevFocused) {
            this.element.focus();
            if (!(0, $5q7BP.Browser).isDevice) this.isPrevFocused = false;
        }
        if (!(0, $5q7BP.Browser).isDevice) event.preventDefault();
        if (!this.getElementData(event)) return;
        var target = event.currentTarget;
        var action = target.classList.contains($75082a70d3498091$var$SPINUP) ? $75082a70d3498091$var$INCREMENT : $75082a70d3498091$var$DECREMENT;
        (0, $aqzbR.EventHandler).remove(target, "mouseleave", this.mouseUpClick);
        if (!this.isCalled) this.action(action, event);
        this.isCalled = false;
        (0, $aqzbR.EventHandler).remove(document, "mouseup", this.mouseUpClick);
        var formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent("KeyboardEvent");
            keyupEvent.initEvent("keyup", false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.getElementData = function(event) {
        if (event.which && event.which === 3 || event.button && event.button === 2 || !this.enabled || this.readonly) return false;
        clearInterval(this.timeOut);
        return true;
    };
    NumericTextBox.prototype.floatLabelTypeUpdate = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.inputWrapper);
        var hiddenInput = this.hiddenInput;
        this.hiddenInput.remove();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.element, this.floatLabelType, this.placeholder, this.createElement);
        this.container.insertBefore(hiddenInput, this.container.childNodes[1]);
    };
    NumericTextBox.prototype.mouseUpClick = function(event) {
        event.stopPropagation();
        clearInterval(this.timeOut);
        this.isCalled = false;
        if (this.spinUp) (0, $aqzbR.EventHandler).remove(this.spinUp, "mouseleave", this.mouseUpClick);
        if (this.spinDown) (0, $aqzbR.EventHandler).remove(this.spinDown, "mouseleave", this.mouseUpClick);
    };
    /**
     * Increments the NumericTextBox value with the specified step value.
     *
     * @param {number} step - Specifies the value used to increment the NumericTextBox value.
     * if its not given then numeric value will be incremented based on the step property value.
     * @returns {void}
     */ NumericTextBox.prototype.increment = function(step) {
        if (step === void 0) step = this.step;
        this.isInteract = false;
        this.changeValue(this.performAction(this.value, step, $75082a70d3498091$var$INCREMENT));
        this.raiseChangeEvent();
    };
    /**
     * Decrements the NumericTextBox value with specified step value.
     *
     * @param {number} step - Specifies the value used to decrement the NumericTextBox value.
     * if its not given then numeric value will be decremented based on the step property value.
     * @returns {void}
     */ NumericTextBox.prototype.decrement = function(step) {
        if (step === void 0) step = this.step;
        this.isInteract = false;
        this.changeValue(this.performAction(this.value, step, $75082a70d3498091$var$DECREMENT));
        this.raiseChangeEvent();
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */ NumericTextBox.prototype.destroy = function() {
        this.unwireEvents();
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        (0, $4ZDHT.detach)(this.hiddenInput);
        if (this.showSpinButton) {
            this.unwireSpinBtnEvents();
            (0, $4ZDHT.detach)(this.spinUp);
            (0, $4ZDHT.detach)(this.spinDown);
        }
        var attrArray = [
            "aria-labelledby",
            "role",
            "autocomplete",
            "aria-readonly",
            "aria-disabled",
            "autocapitalize",
            "spellcheck",
            "aria-autocomplete",
            "tabindex",
            "aria-valuemin",
            "aria-valuemax",
            "aria-valuenow",
            "aria-invalid"
        ];
        for(var i = 0; i < attrArray.length; i++)this.element.removeAttribute(attrArray[i]);
        this.element.classList.remove("e-input");
        this.container.insertAdjacentElement("afterend", this.element);
        (0, $4ZDHT.detach)(this.container);
        this.spinUp = null;
        this.spinDown = null;
        this.container = null;
        this.hiddenInput = null;
        this.changeEventArgs = null;
        this.blurEventArgs = null;
        this.focusEventArgs = null;
        this.inputWrapper = null;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        _super.prototype.destroy.call(this);
    };
    /**
     * Returns the value of NumericTextBox with the format applied to the NumericTextBox.
     *
     * @returns {string} - Returns the formatted value of the NumericTextBox.
     */ NumericTextBox.prototype.getText = function() {
        return this.element.value;
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ NumericTextBox.prototype.focusIn = function() {
        if (document.activeElement !== this.element && this.enabled) {
            this.element.focus();
            (0, $4ZDHT.addClass)([
                this.container
            ], [
                $75082a70d3498091$var$NUMERIC_FOCUS
            ]);
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ NumericTextBox.prototype.focusOut = function() {
        if (document.activeElement === this.element && this.enabled) {
            this.element.blur();
            (0, $4ZDHT.removeClass)([
                this.container
            ], [
                $75082a70d3498091$var$NUMERIC_FOCUS
            ]);
        }
    };
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string} - Returns the persisted data.
     */ NumericTextBox.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {NumericTextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {NumericTextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ NumericTextBox.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "width":
                    this.setElementWidth(newProp.width);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.element, this.container);
                    break;
                case "cssClass":
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case "enabled":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(newProp.enabled, this.element);
                    this.bindClearEvent();
                    break;
                case "enableRtl":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(newProp.enableRtl, [
                        this.container
                    ]);
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(newProp.readonly, this.element);
                    if (this.readonly) (0, $4ZDHT.attributes)(this.element, {
                        "aria-readonly": "true"
                    });
                    else this.element.removeAttribute("aria-readonly");
                    break;
                case "htmlAttributes":
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.updateDataAttribute(true);
                    this.checkAttributes(true);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).validateInputType(this.container, this.element);
                    break;
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(newProp.placeholder, this.element);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.element, this.container);
                    break;
                case "step":
                    this.step = newProp.step;
                    this.validateStep();
                    break;
                case "showSpinButton":
                    this.updateSpinButton(newProp);
                    break;
                case "showClearButton":
                    this.updateClearButton(newProp);
                    break;
                case "floatLabelType":
                    this.floatLabelType = newProp.floatLabelType;
                    this.floatLabelTypeUpdate();
                    break;
                case "value":
                    this.isDynamicChange = (this.isAngular || this.isVue) && this.preventChange;
                    this.updateValue(newProp.value);
                    if (this.isDynamicChange) {
                        this.preventChange = false;
                        this.isDynamicChange = false;
                    }
                    break;
                case "min":
                case "max":
                    (0, $3EnZW.setValue)(prop, (0, $3EnZW.getValue)(prop, newProp), this);
                    this.validateMinMax();
                    this.updateValue(this.value);
                    break;
                case "strictMode":
                    this.strictMode = newProp.strictMode;
                    this.updateValue(this.value);
                    this.validateState();
                    break;
                case "locale":
                    this.initCultureFunc();
                    this.l10n.setLocale(this.locale);
                    this.setSpinButton();
                    this.updatePlaceholder();
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.element);
                    this.updateValue(this.value);
                    break;
                case "currency":
                    var propVal = (0, $3EnZW.getValue)(prop, newProp);
                    this.setProperties({
                        currencyCode: propVal
                    }, true);
                    this.updateCurrency(prop, propVal);
                    break;
                case "currencyCode":
                    var propValue = (0, $3EnZW.getValue)(prop, newProp);
                    this.setProperties({
                        currency: propValue
                    }, true);
                    this.updateCurrency("currency", propValue);
                    break;
                case "format":
                    (0, $3EnZW.setValue)(prop, (0, $3EnZW.getValue)(prop, newProp), this);
                    this.initCultureInfo();
                    this.updateValue(this.value);
                    break;
                case "decimals":
                    this.decimals = newProp.decimals;
                    this.updateValue(this.value);
            }
        }
    };
    NumericTextBox.prototype.updateClearButton = function(newProp) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(newProp.showClearButton, this.element, this.inputWrapper, undefined, this.createElement);
        this.bindClearEvent();
    };
    NumericTextBox.prototype.updateSpinButton = function(newProp) {
        if (newProp.showSpinButton) this.spinBtnCreation();
        else {
            (0, $4ZDHT.detach)(this.spinUp);
            (0, $4ZDHT.detach)(this.spinDown);
        }
    };
    /**
     * Gets the component name
     *
     * @returns {string} Returns the component name.
     * @private
     */ NumericTextBox.prototype.getModuleName = function() {
        return "numerictextbox";
    };
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)("")
    ], NumericTextBox.prototype, "cssClass", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "value", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(-Number.MAX_VALUE)
    ], NumericTextBox.prototype, "min", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(Number.MAX_VALUE)
    ], NumericTextBox.prototype, "max", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], NumericTextBox.prototype, "step", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "width", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "placeholder", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)({})
    ], NumericTextBox.prototype, "htmlAttributes", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], NumericTextBox.prototype, "showSpinButton", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], NumericTextBox.prototype, "readonly", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], NumericTextBox.prototype, "enabled", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], NumericTextBox.prototype, "showClearButton", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], NumericTextBox.prototype, "enablePersistence", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)("n2")
    ], NumericTextBox.prototype, "format", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "decimals", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "currency", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], NumericTextBox.prototype, "currencyCode", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], NumericTextBox.prototype, "strictMode", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], NumericTextBox.prototype, "validateDecimalOnType", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], NumericTextBox.prototype, "floatLabelType", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Event)()
    ], NumericTextBox.prototype, "created", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Event)()
    ], NumericTextBox.prototype, "destroyed", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Event)()
    ], NumericTextBox.prototype, "change", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Event)()
    ], NumericTextBox.prototype, "focus", void 0);
    $75082a70d3498091$var$__decorate([
        (0, $5rsSz.Event)()
    ], NumericTextBox.prototype, "blur", void 0);
    NumericTextBox = $75082a70d3498091$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], NumericTextBox);
    return NumericTextBox;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * `numberfilterui` render number column.
 *
 * @hidden
 */ var $b46d0bdbed85f2ce$export$71f5da6d9d2d9db9 = /** @class */ function() {
    function NumberFilterUI(parent, serviceLocator, filterSettings) {
        this.filterSettings = filterSettings;
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        if (this.parent) {
            this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy, this);
            this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        }
    }
    NumberFilterUI.prototype.keyEventHandler = function(args) {
        if (args.keyCode === 13 || args.keyCode === 9) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.dispatchEvent(evt);
        }
    };
    NumberFilterUI.prototype.create = function(args) {
        this.instance = this.parent.createElement("input", {
            className: "e-flmenu-input",
            id: "numberui-" + args.column.uid
        });
        args.target.appendChild(this.instance);
        this.numericTxtObj = new (0, $75082a70d3498091$export$d910e4596d16bb81)((0, $3EnZW.extend)({
            format: typeof args.column.format === "string" || (0, $3EnZW.isUndefined)(args.column.format) ? args.column.format : args.column.format.format,
            locale: this.parent.locale,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            placeholder: args.localizeText.getConstant("EnterValue"),
            enableRtl: this.parent.enableRtl
        }, args.column.filter.params));
        this.numericTxtObj.appendTo(this.instance);
    };
    NumberFilterUI.prototype.write = function(args) {
        var numberuiObj = document.querySelector("#numberui-" + args.column.uid).ej2_instances[0];
        numberuiObj.element.addEventListener("keydown", this.keyEventHandler);
        numberuiObj.value = args.filteredValue;
    };
    NumberFilterUI.prototype.read = function(element, column, filterOptr, filterObj) {
        var numberuiObj = document.querySelector("#numberui-" + column.uid).ej2_instances[0];
        var filterValue = numberuiObj.value;
        filterObj.filterByColumn(column.field, filterOptr, filterValue, "and", true);
    };
    NumberFilterUI.prototype.destroy = function() {
        if (!this.numericTxtObj || this.numericTxtObj.isDestroyed) return;
        this.numericTxtObj.destroy();
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    return NumberFilterUI;
}();





parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");


/**
 * `boolfilterui` render boolean column.
 *
 * @hidden
 */ var $5b9495c82ec39fe5$export$451b20ccd6968eec = /** @class */ function() {
    function BooleanFilterUI(parent, serviceLocator, filterSettings) {
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.filterSettings = filterSettings;
        if (this.parent) {
            this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy, this);
            this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        }
    }
    BooleanFilterUI.prototype.create = function(args) {
        var _this = this;
        var isForeignColumn = args.column.isForeignColumn();
        var dataSource = isForeignColumn ? args.column.dataSource : this.parent.dataSource;
        var fields = isForeignColumn ? args.column.foreignKeyValue : args.column.field;
        this.elem = this.parent.createElement("input", {
            className: "e-flmenu-input",
            id: "bool-ui-" + args.column.uid
        });
        args.target.appendChild(this.elem);
        this.dialogObj = args.dialogObj;
        this.dropInstance = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)((0, $3EnZW.extend)({
            dataSource: dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource),
            query: new (0, $56262f229d1cff45$export$62297b13309008b2)().select(fields),
            fields: {
                text: fields,
                value: fields
            },
            placeholder: args.localizeText.getConstant("SelectValue"),
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl
        }, args.column.filter.params));
        this.ddOpen = this.openPopup.bind(this);
        this.ddComplete = this.actionComplete(fields);
        this.dropInstance.addEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.ddOpen);
        this.dropInstance.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.ddComplete);
        if (dataSource && "result" in dataSource) {
            var query = this.parent.getQuery ? this.parent.getQuery().clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
            var defObj = (0, $748c2240e597a9b7$export$5bafd3a29592d203)({
                requestType: "booleanfilterrequest"
            }, query);
            this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, defObj.state);
            var def = defObj.deffered;
            def.promise.then(function(e) {
                _this.dropInstance.dataSource = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(e);
                _this.dropInstance.dataBind();
                var columns = _this.parent.filterSettings.columns;
                for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
                    var column = columns_1[_i];
                    if (args.column.uid === column.uid) _this.dropInstance.value = column.value;
                }
            });
        }
        this.dropInstance.appendTo(this.elem);
    };
    BooleanFilterUI.prototype.write = function(args) {
        var drpuiObj = document.querySelector("#bool-ui-" + args.column.uid).ej2_instances[0];
        if (!(0, $3EnZW.isNullOrUndefined)(args.filteredValue)) drpuiObj.value = args.filteredValue;
    };
    BooleanFilterUI.prototype.read = function(element, column, filterOptr, filterObj) {
        var drpuiObj = document.querySelector("#bool-ui-" + column.uid).ej2_instances[0];
        var filterValue = drpuiObj.value;
        filterObj.filterByColumn(column.field, filterOptr, filterValue, "and", false);
    };
    BooleanFilterUI.prototype.openPopup = function(args) {
        (0, $748c2240e597a9b7$export$c50bf978b3bcbfde)(args, this.dialogObj);
    };
    BooleanFilterUI.prototype.actionComplete = function(fields) {
        return function(e) {
            e.result = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).distinct(e.result, fields, true);
        };
    };
    BooleanFilterUI.prototype.destroy = function() {
        if (!this.dropInstance || this.dropInstance.isDestroyed) return;
        this.dropInstance.removeEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.ddOpen);
        this.dropInstance.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.ddComplete);
        this.dropInstance.destroy();
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    return BooleanFilterUI;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $bWDaN = parcelRequire("bWDaN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");

var $2vAqh = parcelRequire("2vAqh");


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $bWDaN = parcelRequire("bWDaN");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");

var $2vAqh = parcelRequire("2vAqh");


var $01d3e22a44cfc2f9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $01d3e22a44cfc2f9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $01d3e22a44cfc2f9$var$WRAPPERCLASS = "e-time-wrapper";
var $01d3e22a44cfc2f9$var$POPUP = "e-popup";
var $01d3e22a44cfc2f9$var$ERROR = "e-error";
var $01d3e22a44cfc2f9$var$POPUPDIMENSION = "240px";
var $01d3e22a44cfc2f9$var$DAY = new Date().getDate();
var $01d3e22a44cfc2f9$var$MONTH = new Date().getMonth();
var $01d3e22a44cfc2f9$var$YEAR = new Date().getFullYear();
var $01d3e22a44cfc2f9$var$ROOT = "e-timepicker";
var $01d3e22a44cfc2f9$var$LIBRARY = "e-lib";
var $01d3e22a44cfc2f9$var$CONTROL = "e-control";
var $01d3e22a44cfc2f9$var$CONTENT = "e-content";
var $01d3e22a44cfc2f9$var$SELECTED = "e-active";
var $01d3e22a44cfc2f9$var$HOVER = "e-hover";
var $01d3e22a44cfc2f9$var$NAVIGATION = "e-navigation";
var $01d3e22a44cfc2f9$var$DISABLED = "e-disabled";
var $01d3e22a44cfc2f9$var$ICONANIMATION = "e-icon-anim";
var $01d3e22a44cfc2f9$var$FOCUS = "e-input-focus";
var $01d3e22a44cfc2f9$var$LISTCLASS = "e-list-item";
var $01d3e22a44cfc2f9$var$HALFPOSITION = 2;
var $01d3e22a44cfc2f9$var$ANIMATIONDURATION = 50;
var $01d3e22a44cfc2f9$var$OVERFLOW = "e-time-overflow";
var $01d3e22a44cfc2f9$var$OFFSETVAL = 4;
var $01d3e22a44cfc2f9$var$EDITABLE = "e-non-edit";
var $01d3e22a44cfc2f9$var$wrapperAttributes = [
    "title",
    "class",
    "style"
];
var $01d3e22a44cfc2f9$export$552eaada9a5fa010;
(function(TimePickerBase) {
    // eslint-disable-next-line max-len, jsdoc/require-jsdoc
    function createListItems(createdEl, min, max, globalize, timeFormat, step) {
        var formatOptions;
        if (this.calendarMode === "Gregorian") formatOptions = {
            format: timeFormat,
            type: "time"
        };
        else // eslint-disable-next-line @typescript-eslint/no-unused-vars
        formatOptions = {
            format: timeFormat,
            type: "time",
            calendar: "islamic"
        };
        var start;
        var interval = step * 60000;
        var listItems = [];
        var timeCollections = [];
        start = +min.setMilliseconds(0);
        var end = +max.setMilliseconds(0);
        while(end >= start){
            timeCollections.push(start);
            listItems.push(globalize.formatDate(new Date(start), {
                format: timeFormat,
                type: "time"
            }));
            start += interval;
        }
        var listTag = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(createdEl, listItems, null, true);
        return {
            collection: timeCollections,
            list: listTag
        };
    }
    TimePickerBase.createListItems = createListItems;
})($01d3e22a44cfc2f9$export$552eaada9a5fa010 || ($01d3e22a44cfc2f9$export$552eaada9a5fa010 = {}));
var $01d3e22a44cfc2f9$export$e1f582bc1d3e967e = /** @class */ function(_super) {
    $01d3e22a44cfc2f9$var$__extends(TimeMaskPlaceholder, _super);
    function TimeMaskPlaceholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("day")
    ], TimeMaskPlaceholder.prototype, "day", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("month")
    ], TimeMaskPlaceholder.prototype, "month", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("year")
    ], TimeMaskPlaceholder.prototype, "year", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("day of the week")
    ], TimeMaskPlaceholder.prototype, "dayOfTheWeek", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("hour")
    ], TimeMaskPlaceholder.prototype, "hour", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("minute")
    ], TimeMaskPlaceholder.prototype, "minute", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("second")
    ], TimeMaskPlaceholder.prototype, "second", void 0);
    return TimeMaskPlaceholder;
}((0, $3fcxu.ChildProperty));
/**
 * TimePicker is an intuitive interface component which provides an options to select a time value
 * from popup list or to set a desired time value.
 * ```
 * <input id='timepicker' type='text'/>
 * <script>
 *   var timePickerObj = new TimePicker({ value: new Date() });
 *   timePickerObj.appendTo('#timepicker');
 * </script>
 * ```
 */ var $01d3e22a44cfc2f9$export$5f876910ea565cd3 = /** @class */ function(_super) {
    $01d3e22a44cfc2f9$var$__extends(TimePicker, _super);
    /**
     * Constructor for creating the widget
     *
     * @param {TimePickerModel} options - Specifies the TimePicker model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function TimePicker(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.liCollections = [];
        _this.timeCollections = [];
        _this.disableItemCollection = [];
        _this.invalidValueString = null;
        _this.preventChange = false;
        _this.maskedDateValue = "";
        _this.moduleName = _this.getModuleName();
        _this.timeOptions = options;
        return _this;
    }
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */ TimePicker.prototype.preRender = function() {
        this.keyConfigure = {
            enter: "enter",
            escape: "escape",
            end: "end",
            tab: "tab",
            home: "home",
            down: "downarrow",
            up: "uparrow",
            left: "leftarrow",
            right: "rightarrow",
            open: "alt+downarrow",
            close: "alt+uparrow"
        };
        this.cloneElement = this.element.cloneNode(true);
        (0, $4ZDHT.removeClass)([
            this.cloneElement
        ], [
            $01d3e22a44cfc2f9$var$ROOT,
            $01d3e22a44cfc2f9$var$CONTROL,
            $01d3e22a44cfc2f9$var$LIBRARY
        ]);
        this.inputElement = this.element;
        this.angularTag = null;
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (this.element.tagName === "EJS-TIMEPICKER") {
            this.angularTag = this.element.tagName;
            this.inputElement = this.createElement("input");
            this.element.appendChild(this.inputElement);
        }
        this.tabIndex = this.element.hasAttribute("tabindex") ? this.element.getAttribute("tabindex") : "0";
        this.element.removeAttribute("tabindex");
        this.openPopupEventArgs = {
            appendTo: document.body
        };
    };
    // element creation
    TimePicker.prototype.render = function() {
        this.initialize();
        this.createInputElement();
        this.updateHtmlAttributeToWrapper();
        this.setTimeAllowEdit();
        this.setEnable();
        this.validateInterval();
        this.bindEvents();
        this.validateDisable();
        this.setTimeZone();
        this.setValue(this.getFormattedValue(this.value));
        if (this.enableMask && !this.value && this.maskedDateValue && (this.floatLabelType === "Always" || !this.floatLabelType || !this.placeholder)) {
            this.updateInputValue(this.maskedDateValue);
            this.checkErrorState(this.maskedDateValue);
        }
        this.anchor = this.inputElement;
        this.inputElement.setAttribute("value", this.inputElement.value);
        this.inputEleValue = this.getDateObject(this.inputElement.value);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        this.renderComplete();
    };
    TimePicker.prototype.setTimeZone = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.serverTimezoneOffset) && this.value) {
            var clientTimeZoneDiff = new Date().getTimezoneOffset() / 60;
            var serverTimezoneDiff = this.serverTimezoneOffset;
            var timeZoneDiff = serverTimezoneDiff + clientTimeZoneDiff;
            timeZoneDiff = this.isDayLightSaving() ? timeZoneDiff-- : timeZoneDiff;
            this.value = new Date(this.value.getTime() + timeZoneDiff * 3600000);
        }
    };
    TimePicker.prototype.isDayLightSaving = function() {
        var firstOffset = new Date(this.value.getFullYear(), 0, 1).getTimezoneOffset();
        var secondOffset = new Date(this.value.getFullYear(), 6, 1).getTimezoneOffset();
        return this.value.getTimezoneOffset() < Math.max(firstOffset, secondOffset);
    };
    TimePicker.prototype.setTimeAllowEdit = function() {
        if (this.allowEdit) {
            if (!this.readonly) this.inputElement.removeAttribute("readonly");
        } else (0, $4ZDHT.attributes)(this.inputElement, {
            "readonly": ""
        });
        this.clearIconState();
    };
    TimePicker.prototype.clearIconState = function() {
        if (!this.allowEdit && this.inputWrapper && !this.readonly) {
            if (this.inputElement.value === "") (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], [
                $01d3e22a44cfc2f9$var$EDITABLE
            ]);
            else (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], [
                $01d3e22a44cfc2f9$var$EDITABLE
            ]);
        } else if (this.inputWrapper) (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], [
            $01d3e22a44cfc2f9$var$EDITABLE
        ]);
    };
    TimePicker.prototype.validateDisable = function() {
        this.setMinMax(this.initMin, this.initMax);
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.popupCreation();
            this.popupObj.destroy();
            this.popupWrapper = this.popupObj = null;
        }
        if (!isNaN(+this.value) && this.value !== null) {
            if (!this.valueIsDisable(this.value)) {
                //disable value given in value property so reset the date based on current date
                if (this.strictMode) this.resetState();
                this.initValue = null;
                this.initMax = this.getDateObject(this.initMax);
                this.initMin = this.getDateObject(this.initMin);
                this.timeCollections = this.liCollections = [];
                this.setMinMax(this.initMin, this.initMax);
            }
        }
    };
    TimePicker.prototype.validationAttribute = function(target, input) {
        var name = target.getAttribute("name") ? target.getAttribute("name") : target.getAttribute("id");
        input.setAttribute("name", name);
        target.removeAttribute("name");
        var attributes = [
            "required",
            "aria-required",
            "form"
        ];
        for(var i = 0; i < attributes.length; i++){
            if ((0, $3EnZW.isNullOrUndefined)(target.getAttribute(attributes[i]))) continue;
            var attr = target.getAttribute(attributes[i]);
            input.setAttribute(attributes[i], attr);
            target.removeAttribute(attributes[i]);
        }
    };
    TimePicker.prototype.initialize = function() {
        this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
        this.defaultCulture = new (0, $bWDaN.Internationalization)("en");
        this.checkTimeFormat();
        this.checkInvalidValue(this.value);
        // persist the value property.
        this.setProperties({
            value: this.checkDateValue(new Date(this.checkInValue(this.value)))
        }, true);
        this.setProperties({
            min: this.checkDateValue(new Date(this.checkInValue(this.min)))
        }, true);
        this.setProperties({
            max: this.checkDateValue(new Date(this.checkInValue(this.max)))
        }, true);
        this.setProperties({
            scrollTo: this.checkDateValue(new Date(this.checkInValue(this.scrollTo)))
        }, true);
        if (this.angularTag !== null) this.validationAttribute(this.element, this.inputElement);
        this.updateHtmlAttributeToElement();
        this.checkAttributes(false); //check the input element attributes
        var localeText = {
            placeholder: this.placeholder
        };
        this.l10n = new (0, $e7i2H.L10n)("timepicker", localeText, this.locale);
        this.setProperties({
            placeholder: this.placeholder || this.l10n.getConstant("placeholder")
        }, true);
        this.initValue = this.checkDateValue(this.value);
        this.initMin = this.checkDateValue(this.min);
        this.initMax = this.checkDateValue(this.max);
        this.isNavigate = this.isPreventBlur = this.isTextSelected = false;
        this.activeIndex = this.valueWithMinutes = this.prevDate = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.getAttribute("id"))) {
            if (this.angularTag !== null) this.inputElement.id = this.element.getAttribute("id") + "_input";
        } else {
            //for angular case
            this.element.id = (0, $3EnZW.getUniqueID)("ej2_timepicker");
            if (this.angularTag !== null) (0, $4ZDHT.attributes)(this.inputElement, {
                "id": this.element.id + "_input"
            });
        }
        if ((0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute("name"))) (0, $4ZDHT.attributes)(this.inputElement, {
            "name": this.element.id
        });
        if (this.enableMask) this.notify("createMask", {
            module: "MaskedDateTime"
        });
    };
    TimePicker.prototype.checkTimeFormat = function() {
        if (this.format) {
            if (typeof this.format === "string") this.formatString = this.format;
            else if (!(0, $3EnZW.isNullOrUndefined)(this.format.skeleton) && this.format.skeleton !== "") {
                var skeletonString = this.format.skeleton;
                this.formatString = this.globalize.getDatePattern({
                    type: "time",
                    skeleton: skeletonString
                });
            } else this.formatString = this.globalize.getDatePattern({
                type: "time",
                skeleton: "short"
            });
        } else this.formatString = null;
    };
    TimePicker.prototype.checkDateValue = function(value) {
        return !(0, $3EnZW.isNullOrUndefined)(value) && value instanceof Date && !isNaN(+value) ? value : null;
    };
    TimePicker.prototype.createInputElement = function() {
        if (this.fullScreenMode && (0, $5q7BP.Browser).isDevice) this.cssClass += " e-popup-expand";
        var updatedCssClassesValue = this.cssClass;
        var isBindClearAction = this.enableMask ? false : true;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassesValue = this.cssClass.replace(/\s+/g, " ").trim();
        this.inputWrapper = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.inputElement,
            bindClearAction: isBindClearAction,
            floatLabelType: this.floatLabelType,
            properties: {
                readonly: this.readonly,
                placeholder: this.placeholder,
                cssClass: updatedCssClassesValue,
                enabled: this.enabled,
                enableRtl: this.enableRtl,
                showClearButton: this.showClearButton
            },
            buttons: [
                " e-input-group-icon e-time-icon e-icons"
            ]
        }, this.createElement);
        this.inputWrapper.container.style.width = this.setWidth(this.width);
        (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-autocomplete": "list",
            "tabindex": "0",
            "aria-expanded": "false",
            "role": "combobox",
            "autocomplete": "off",
            "autocorrect": "off",
            "autocapitalize": "off",
            "spellcheck": "false",
            "aria-disabled": "false",
            "aria-invalid": "false"
        });
        if (!this.isNullOrEmpty(this.inputStyle)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).addAttributes({
            "style": this.inputStyle
        }, this.inputElement);
        (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], $01d3e22a44cfc2f9$var$WRAPPERCLASS);
    };
    TimePicker.prototype.getCldrDateTimeFormat = function() {
        var culture = new (0, $bWDaN.Internationalization)(this.locale);
        var cldrTime;
        var dateFormat = culture.getDatePattern({
            skeleton: "yMd"
        });
        if (this.isNullOrEmpty(this.formatString)) cldrTime = dateFormat + " " + this.cldrFormat("time");
        else cldrTime = this.formatString;
        return cldrTime;
    };
    TimePicker.prototype.checkInvalidValue = function(value) {
        var isInvalid = false;
        if (typeof value !== "object" && !(0, $3EnZW.isNullOrUndefined)(value)) {
            var valueString = value;
            if (typeof valueString === "string") valueString = valueString.trim();
            var valueExpression = null;
            var valueExp = null;
            if (typeof value === "number") valueString = value.toString();
            else if (typeof value === "string") {
                if (!/^[a-zA-Z0-9- ]*$/.test(value)) {
                    valueExpression = this.setCurrentDate(this.getDateObject(value));
                    if ((0, $3EnZW.isNullOrUndefined)(valueExpression)) {
                        valueExpression = this.checkDateValue(this.globalize.parseDate(this.getAmPmValue(valueString), {
                            format: this.getCldrDateTimeFormat(),
                            type: "datetime"
                        }));
                        if ((0, $3EnZW.isNullOrUndefined)(valueExpression)) valueExpression = this.checkDateValue(this.globalize.parseDate(this.getAmPmValue(valueString), {
                            format: this.formatString,
                            type: "dateTime",
                            skeleton: "yMd"
                        }));
                    }
                }
            }
            valueExp = this.globalize.parseDate(this.getAmPmValue(valueString), {
                format: this.getCldrDateTimeFormat(),
                type: "datetime"
            });
            valueExpression = !(0, $3EnZW.isNullOrUndefined)(valueExp) && valueExp instanceof Date && !isNaN(+valueExp) ? valueExp : null;
            if ((0, $3EnZW.isNullOrUndefined)(valueExpression) && valueString.replace(/\s/g, "").length) {
                var extISOString = null;
                var basicISOString = null;
                // eslint-disable-next-line
                extISOString = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
                // eslint-disable-next-line
                basicISOString = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
                if (!extISOString.test(valueString) && !basicISOString.test(valueString) || /^[a-zA-Z0-9- ]*$/.test(value) || isNaN(+new Date("" + valueString))) isInvalid = true;
                else valueExpression = new Date("" + valueString);
            }
            if (isInvalid) {
                if (!this.strictMode) this.invalidValueString = valueString;
                this.setProperties({
                    value: null
                }, true);
                this.initValue = null;
            } else {
                this.setProperties({
                    value: valueExpression
                }, true);
                this.initValue = this.value;
            }
        }
    };
    TimePicker.prototype.requiredModules = function() {
        var modules = [];
        if (this.enableMask) modules.push({
            args: [
                this
            ],
            member: "MaskedDateTime"
        });
        return modules;
    };
    TimePicker.prototype.getAmPmValue = function(date) {
        try {
            if (typeof date === "string" && date.trim() !== "") // Replace am/pm variants with uppercase AM/PM
            return date.replace(/(am|pm|Am|aM|pM|Pm)/g, function(match) {
                return match.toLocaleUpperCase();
            });
            // If date is null, undefined, or an empty string, return a default value or empty string
            return "";
        } catch (error) {
            console.error("Error occurred while processing date:", error);
            return ""; // Return a default value in case of an error
        }
    };
    TimePicker.prototype.cldrFormat = function(type) {
        var cldrDateTimeString;
        if (this.locale === "en" || this.locale === "en-US") cldrDateTimeString = (0, $3EnZW.getValue)("timeFormats.short", (0, $bWDaN.getDefaultDateObject)());
        else cldrDateTimeString = this.getCultureTimeObject((0, $bWDaN.cldrData), "" + this.locale);
        return cldrDateTimeString;
    };
    // destroy function
    TimePicker.prototype.destroy = function() {
        this.hide();
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        this.unBindEvents();
        var ariaAttribute = {
            "aria-autocomplete": "list",
            "tabindex": "0",
            "aria-expanded": "false",
            "role": "combobox",
            "autocomplete": "off",
            "autocorrect": "off",
            "autocapitalize": "off",
            "spellcheck": "false",
            "aria-disabled": "true",
            "aria-invalid": "false"
        };
        if (this.inputElement) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeAttributes(ariaAttribute, this.inputElement);
            if (this.angularTag === null) this.inputWrapper.container.parentElement.appendChild(this.inputElement);
            if (!(0, $3EnZW.isNullOrUndefined)(this.cloneElement.getAttribute("tabindex"))) this.inputElement.setAttribute("tabindex", this.tabIndex);
            else this.inputElement.removeAttribute("tabindex");
            this.ensureInputAttribute();
            this.enableElement([
                this.inputElement
            ]);
            this.inputElement.classList.remove("e-input");
            if ((0, $3EnZW.isNullOrUndefined)(this.cloneElement.getAttribute("disabled"))) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(true, this.inputElement, this.floatLabelType);
        }
        if (this.inputWrapper.container) (0, $4ZDHT.detach)(this.inputWrapper.container);
        this.inputWrapper = this.popupWrapper = this.cloneElement = undefined;
        this.liCollections = this.timeCollections = this.disableItemCollection = [];
        if (!(0, $3EnZW.isNullOrUndefined)(this.rippleFn)) this.rippleFn();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.inputElement,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        _super.prototype.destroy.call(this);
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.formResetHandler);
        this.rippleFn = null;
        this.openPopupEventArgs = null;
        this.selectedElement = null;
        this.listTag = null;
        this.liCollections = null;
    };
    TimePicker.prototype.ensureInputAttribute = function() {
        var propertyList = [];
        for(var i = 0; i < this.inputElement.attributes.length; i++)propertyList[i] = this.inputElement.attributes[i].name;
        for(var i = 0; i < propertyList.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(this.cloneElement.getAttribute(propertyList[i]))) {
            this.inputElement.setAttribute(propertyList[i], this.cloneElement.getAttribute(propertyList[i]));
            if (propertyList[i].toLowerCase() === "value") this.inputElement.value = this.cloneElement.getAttribute(propertyList[i]);
        } else {
            this.inputElement.removeAttribute(propertyList[i]);
            if (propertyList[i].toLowerCase() === "value") this.inputElement.value = "";
        }
    };
    //popup creation
    TimePicker.prototype.popupCreation = function() {
        this.popupWrapper = this.createElement("div", {
            className: $01d3e22a44cfc2f9$var$ROOT + " " + $01d3e22a44cfc2f9$var$POPUP,
            attrs: {
                "id": this.element.id + "_popup",
                "style": "visibility:hidden"
            }
        });
        this.popupWrapper.setAttribute("aria-label", this.element.id);
        this.popupWrapper.setAttribute("role", "dialog");
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) this.popupWrapper.className += " " + this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.step) && this.step > 0) {
            this.generateList();
            (0, $4ZDHT.append)([
                this.listWrapper
            ], this.popupWrapper);
        }
        this.addSelection();
        this.renderPopup();
        (0, $4ZDHT.detach)(this.popupWrapper);
    };
    TimePicker.prototype.getPopupHeight = function() {
        var height = parseInt($01d3e22a44cfc2f9$var$POPUPDIMENSION, 10);
        var popupHeight = this.popupWrapper.getBoundingClientRect().height;
        return popupHeight > height ? height : popupHeight;
    };
    TimePicker.prototype.generateList = function() {
        this.createListItems();
        this.wireListEvents();
        var rippleModel = {
            duration: 300,
            selector: "." + $01d3e22a44cfc2f9$var$LISTCLASS
        };
        this.rippleFn = (0, $kj1BR.rippleEffect)(this.listWrapper, rippleModel);
        this.liCollections = this.listWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$LISTCLASS);
    };
    TimePicker.prototype.renderPopup = function() {
        var _this = this;
        this.containerStyle = this.inputWrapper.container.getBoundingClientRect();
        this.popupObj = new (0, $2vAqh.Popup)(this.popupWrapper, {
            width: this.setPopupWidth(this.width),
            zIndex: this.zIndex,
            targetType: "relative",
            position: (0, $5q7BP.Browser).isDevice ? {
                X: "center",
                Y: "center"
            } : {
                X: "left",
                Y: "bottom"
            },
            collision: (0, $5q7BP.Browser).isDevice ? {
                X: "fit",
                Y: "fit"
            } : {
                X: "flip",
                Y: "flip"
            },
            enableRtl: this.enableRtl,
            relateTo: (0, $5q7BP.Browser).isDevice ? document.body : this.inputWrapper.container,
            offsetY: $01d3e22a44cfc2f9$var$OFFSETVAL,
            open: function() {
                _this.popupWrapper.style.visibility = "visible";
                (0, $4ZDHT.addClass)([
                    _this.inputWrapper.buttons[0]
                ], $01d3e22a44cfc2f9$var$SELECTED);
            },
            close: function() {
                (0, $4ZDHT.removeClass)([
                    _this.inputWrapper.buttons[0]
                ], $01d3e22a44cfc2f9$var$SELECTED);
                _this.unWireListEvents();
                _this.inputElement.removeAttribute("aria-activedescendant");
                (0, $4ZDHT.remove)(_this.popupObj.element);
                _this.popupObj.destroy();
                _this.popupWrapper.innerHTML = "";
                _this.listWrapper = _this.popupWrapper = _this.listTag = undefined;
            },
            targetExitViewport: function() {
                if (!(0, $5q7BP.Browser).isDevice) _this.hide();
            }
        });
        if (!(0, $5q7BP.Browser).isDevice) this.popupObj.collision = {
            X: "none",
            Y: "flip"
        };
        if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) {
            this.popupObj.element.style.maxHeight = "100%";
            this.popupObj.element.style.width = "100%";
        } else this.popupObj.element.style.maxHeight = $01d3e22a44cfc2f9$var$POPUPDIMENSION;
        if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) {
            var modelHeader = this.createElement("div", {
                className: "e-model-header"
            });
            var modelTitleSpan = this.createElement("span", {
                className: "e-model-title"
            });
            modelTitleSpan.textContent = "Select time";
            var modelCloseIcon = this.createElement("span", {
                className: "e-popup-close"
            });
            (0, $aqzbR.EventHandler).add(modelCloseIcon, "mousedown touchstart", this.timePopupCloseHandler, this);
            modelHeader.appendChild(modelCloseIcon);
            modelHeader.appendChild(modelTitleSpan);
            this.popupWrapper.insertBefore(modelHeader, this.popupWrapper.firstElementChild);
        }
    };
    TimePicker.prototype.timePopupCloseHandler = function(e) {
        this.hide();
    };
    //util function
    TimePicker.prototype.getFormattedValue = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) return null;
        else return this.globalize.formatDate(value, {
            skeleton: "medium",
            type: "time"
        });
    };
    TimePicker.prototype.getDateObject = function(text) {
        if (!this.isNullOrEmpty(text)) {
            var dateValue = this.createDateObj(text);
            var value = !this.isNullOrEmpty(this.initValue);
            if (this.checkDateValue(dateValue)) {
                var date = value ? this.initValue.getDate() : $01d3e22a44cfc2f9$var$DAY;
                var month = value ? this.initValue.getMonth() : $01d3e22a44cfc2f9$var$MONTH;
                var year = value ? this.initValue.getFullYear() : $01d3e22a44cfc2f9$var$YEAR;
                return new Date(year, month, date, dateValue.getHours(), dateValue.getMinutes(), dateValue.getSeconds());
            }
        }
        return null;
    };
    TimePicker.prototype.updateHtmlAttributeToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($01d3e22a44cfc2f9$var$wrapperAttributes.indexOf(key) > -1) {
                if (key === "class") {
                    var updatedClassesValue = this.htmlAttributes["" + key].replace(/\s+/g, " ").trim();
                    if (updatedClassesValue !== "") (0, $4ZDHT.addClass)([
                        this.inputWrapper.container
                    ], updatedClassesValue.split(" "));
                } else if (key === "style") {
                    var timeStyle = this.inputWrapper.container.getAttribute(key);
                    timeStyle = !(0, $3EnZW.isNullOrUndefined)(timeStyle) ? timeStyle + this.htmlAttributes["" + key] : this.htmlAttributes["" + key];
                    this.inputWrapper.container.setAttribute(key, timeStyle);
                } else this.inputWrapper.container.setAttribute(key, this.htmlAttributes["" + key]);
            }
        }
    };
    TimePicker.prototype.updateHtmlAttributeToElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($01d3e22a44cfc2f9$var$wrapperAttributes.indexOf(key) < 0) this.inputElement.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    TimePicker.prototype.updateCssClass = function(cssClassNew, cssClassOld) {
        if (!(0, $3EnZW.isNullOrUndefined)(cssClassOld)) cssClassOld = cssClassOld.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(cssClassNew)) cssClassNew = cssClassNew.replace(/\s+/g, " ").trim();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(cssClassNew, [
            this.inputWrapper.container
        ], cssClassOld);
        if (this.popupWrapper) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(cssClassNew, [
            this.popupWrapper
        ], cssClassOld);
    };
    TimePicker.prototype.removeErrorClass = function() {
        (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], $01d3e22a44cfc2f9$var$ERROR);
        (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-invalid": "false"
        });
    };
    TimePicker.prototype.checkErrorState = function(val) {
        var value = this.getDateObject(val);
        if (this.validateState(value) && !this.invalidValueString || this.enableMask && this.inputElement.value === this.maskedDateValue) this.removeErrorClass();
        else {
            (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], $01d3e22a44cfc2f9$var$ERROR);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-invalid": "true"
            });
        }
    };
    TimePicker.prototype.validateInterval = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.step) && this.step > 0) this.enableElement([
            this.inputWrapper.buttons[0]
        ]);
        else this.disableTimeIcon();
    };
    TimePicker.prototype.disableTimeIcon = function() {
        this.disableElement([
            this.inputWrapper.buttons[0]
        ]);
        this.hide();
    };
    TimePicker.prototype.disableElement = function(element) {
        (0, $4ZDHT.addClass)(element, $01d3e22a44cfc2f9$var$DISABLED);
    };
    TimePicker.prototype.enableElement = function(element) {
        (0, $4ZDHT.removeClass)(element, $01d3e22a44cfc2f9$var$DISABLED);
    };
    TimePicker.prototype.selectInputText = function() {
        this.inputElement.setSelectionRange(0, this.inputElement.value.length);
    };
    TimePicker.prototype.setCursorToEnd = function() {
        this.inputElement.setSelectionRange(this.inputElement.value.length, this.inputElement.value.length);
    };
    TimePicker.prototype.getMeridianText = function() {
        var meridian;
        if (this.locale === "en" || this.locale === "en-US") meridian = (0, $3EnZW.getValue)("dayPeriods.format.wide", (0, $bWDaN.getDefaultDateObject)());
        else {
            var gregorianFormat = ".dates.calendars.gregorian.dayPeriods.format.abbreviated";
            var mainVal = "main.";
            meridian = (0, $3EnZW.getValue)(mainVal + "" + this.locale + gregorianFormat, (0, $bWDaN.cldrData));
        }
        return meridian;
    };
    TimePicker.prototype.getCursorSelection = function() {
        var input = this.inputElement;
        var start = 0;
        var end = 0;
        if (!isNaN(input.selectionStart)) {
            start = input.selectionStart;
            end = input.selectionEnd;
        }
        return {
            start: Math.abs(start),
            end: Math.abs(end)
        };
    };
    TimePicker.prototype.getActiveElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) return this.popupWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$SELECTED);
        else return null;
    };
    TimePicker.prototype.isNullOrEmpty = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(value) || typeof value === "string" && value.trim() === "") return true;
        else return false;
    };
    TimePicker.prototype.setWidth = function(width) {
        if (typeof width === "number") width = (0, $3EnZW.formatUnit)(width);
        else if (typeof width === "string") width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        else width = "100%";
        return width;
    };
    TimePicker.prototype.setPopupWidth = function(width) {
        width = this.setWidth(width);
        if (width.indexOf("%") > -1) {
            var inputWidth = this.containerStyle.width * parseFloat(width) / 100;
            width = inputWidth.toString() + "px";
        }
        return width;
    };
    TimePicker.prototype.setScrollPosition = function() {
        var element = this.selectedElement;
        if (!(0, $3EnZW.isNullOrUndefined)(element)) this.findScrollTop(element);
        else if (this.popupWrapper && this.checkDateValue(this.scrollTo)) this.setScrollTo();
    };
    TimePicker.prototype.findScrollTop = function(element) {
        var listHeight = this.getPopupHeight();
        var nextEle = element.nextElementSibling;
        var height = nextEle ? nextEle.offsetTop : element.offsetTop;
        var liHeight = element.getBoundingClientRect().height;
        if (height + element.offsetTop > listHeight) this.popupWrapper.scrollTop = nextEle ? height - (listHeight / $01d3e22a44cfc2f9$var$HALFPOSITION + liHeight / $01d3e22a44cfc2f9$var$HALFPOSITION) : height;
        else this.popupWrapper.scrollTop = 0;
    };
    TimePicker.prototype.setScrollTo = function() {
        var element;
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) {
            var items = this.popupWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$LISTCLASS);
            if (items.length) {
                var initialTime = this.timeCollections[0];
                var scrollTime = this.getDateObject(this.checkDateValue(this.scrollTo)).getTime();
                element = items[Math.round((scrollTime - initialTime) / (this.step * 60000))];
            }
        } else this.popupWrapper.scrollTop = 0;
        if (!(0, $3EnZW.isNullOrUndefined)(element)) this.findScrollTop(element);
        else this.popupWrapper.scrollTop = 0;
    };
    TimePicker.prototype.getText = function() {
        return (0, $3EnZW.isNullOrUndefined)(this.checkDateValue(this.value)) ? "" : this.getValue(this.value);
    };
    TimePicker.prototype.getValue = function(value) {
        return (0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value)) ? null : this.globalize.formatDate(value, {
            format: this.cldrTimeFormat(),
            type: "time"
        });
    };
    TimePicker.prototype.cldrDateFormat = function() {
        var cldrDate;
        if (this.locale === "en" || this.locale === "en-US") cldrDate = (0, $3EnZW.getValue)("dateFormats.short", (0, $bWDaN.getDefaultDateObject)());
        else cldrDate = this.getCultureDateObject((0, $bWDaN.cldrData), "" + this.locale);
        return cldrDate;
    };
    TimePicker.prototype.cldrTimeFormat = function() {
        var cldrTime;
        if (this.isNullOrEmpty(this.formatString)) {
            if (this.locale === "en" || this.locale === "en-US") cldrTime = (0, $3EnZW.getValue)("timeFormats.short", (0, $bWDaN.getDefaultDateObject)());
            else cldrTime = this.getCultureTimeObject((0, $bWDaN.cldrData), "" + this.locale);
        } else cldrTime = this.formatString;
        return cldrTime;
    };
    TimePicker.prototype.dateToNumeric = function() {
        var cldrTime;
        if (this.locale === "en" || this.locale === "en-US") cldrTime = (0, $3EnZW.getValue)("timeFormats.medium", (0, $bWDaN.getDefaultDateObject)());
        else cldrTime = (0, $3EnZW.getValue)("main." + this.locale + ".dates.calendars.gregorian.timeFormats.medium", (0, $bWDaN.cldrData));
        return cldrTime;
    };
    TimePicker.prototype.getExactDateTime = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) return null;
        else return this.globalize.formatDate(value, {
            format: this.dateToNumeric(),
            type: "time"
        });
    };
    TimePicker.prototype.setValue = function(value) {
        var time = this.checkValue(value);
        if (!this.strictMode && !this.validateState(time)) {
            if (this.checkDateValue(this.valueWithMinutes) === null) this.initValue = this.valueWithMinutes = null;
            this.validateMinMax(this.value, this.min, this.max);
        } else if (this.isNullOrEmpty(time)) {
            this.initValue = null;
            this.validateMinMax(this.value, this.min, this.max);
        } else this.initValue = this.compareFormatChange(time);
        this.updateInput(true, this.initValue);
    };
    TimePicker.prototype.compareFormatChange = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(value)) return null;
        return value !== this.getText() ? this.getDateObject(value) : this.getDateObject(this.value);
    };
    TimePicker.prototype.updatePlaceHolder = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.l10n.getConstant("placeholder"), this.inputElement);
    };
    //event related functions
    TimePicker.prototype.updateInputValue = function(value) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(value, this.inputElement, this.floatLabelType, this.showClearButton);
    };
    TimePicker.prototype.preventEventBubbling = function(e) {
        e.preventDefault();
        this.interopAdaptor.invokeMethodAsync("OnTimeIconClick");
    };
    TimePicker.prototype.popupHandler = function(e) {
        if (!this.enabled) return;
        if ((0, $5q7BP.Browser).isDevice) this.inputElement.setAttribute("readonly", "");
        e.preventDefault();
        if (this.isPopupOpen()) this.closePopup(0, e);
        else {
            this.inputElement.focus();
            this.show(e);
        }
    };
    TimePicker.prototype.mouseDownHandler = function() {
        if (!this.enabled) return;
        if (!this.readonly) {
            this.inputElement.setSelectionRange(0, 0);
            (0, $aqzbR.EventHandler).add(this.inputElement, "mouseup", this.mouseUpHandler, this);
        }
    };
    TimePicker.prototype.mouseUpHandler = function(event) {
        if (!this.readonly) {
            event.preventDefault();
            if (this.enableMask) {
                event.preventDefault();
                this.notify("setMaskSelection", {
                    module: "MaskedDateTime"
                });
                return;
            } else {
                (0, $aqzbR.EventHandler).remove(this.inputElement, "mouseup", this.mouseUpHandler);
                var curPos = this.getCursorSelection();
                if (!(curPos.start === 0 && curPos.end === this.inputElement.value.length)) {
                    if (this.inputElement.value.length > 0) this.cursorDetails = this.focusSelection();
                    this.inputElement.setSelectionRange(this.cursorDetails.start, this.cursorDetails.end);
                }
            }
        }
    };
    TimePicker.prototype.focusSelection = function() {
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        var split = this.inputElement.value.split("");
        split.push(" ");
        var curPos = this.getCursorSelection();
        var start = 0;
        var end = 0;
        var isSeparator = false;
        if (!this.isTextSelected) for(var i = 0; i < split.length; i++){
            if (!regex.test(split[i])) {
                end = i;
                isSeparator = true;
            }
            if (isSeparator) {
                if (curPos.start >= start && curPos.end <= end) {
                    // eslint-disable-next-line no-self-assign
                    end;
                    this.isTextSelected = true;
                    break;
                } else {
                    start = i + 1;
                    isSeparator = false;
                }
            }
        }
        else {
            start = curPos.start;
            end = curPos.end;
            this.isTextSelected = false;
        }
        return {
            start: start,
            end: end
        };
    };
    TimePicker.prototype.inputHandler = function(event) {
        if (!this.readonly && this.enabled) {
            if (!(event.action === "right" || event.action === "left" || event.action === "tab" || (event.action === "home" || event.action === "end" || event.action === "up" || event.action === "down") && !this.isPopupOpen() && !this.enableMask)) event.preventDefault();
            switch(event.action){
                case "home":
                case "end":
                case "up":
                case "down":
                    if (!this.isPopupOpen()) {
                        this.popupCreation();
                        this.popupObj.destroy();
                        this.popupObj = this.popupWrapper = null;
                    }
                    if (this.enableMask && !this.readonly && !this.isPopupOpen()) {
                        event.preventDefault();
                        this.notify("keyDownHandler", {
                            module: "MaskedDateTime",
                            e: event
                        });
                    }
                    if (this.isPopupOpen()) this.keyHandler(event);
                    break;
                case "enter":
                    if (this.isNavigate) {
                        this.selectedElement = this.liCollections[this.activeIndex];
                        this.valueWithMinutes = new Date(this.timeCollections[this.activeIndex]);
                        this.updateValue(this.valueWithMinutes, event);
                    } else this.updateValue(this.inputElement.value, event);
                    this.hide();
                    this.isNavigate = false;
                    if (this.isPopupOpen()) event.stopPropagation();
                    break;
                case "open":
                    this.show(event);
                    break;
                case "escape":
                    this.updateInputValue(this.objToString(this.value));
                    if (this.enableMask) {
                        if (!this.value) this.updateInputValue(this.maskedDateValue);
                        this.createMask();
                    }
                    this.previousState(this.value);
                    this.hide();
                    break;
                case "close":
                    this.hide();
                    break;
                case "right":
                case "left":
                case "tab":
                case "shiftTab":
                    if (!this.isPopupOpen() && this.enableMask && !this.readonly) {
                        if (this.inputElement.selectionStart === 0 && this.inputElement.selectionEnd === this.inputElement.value.length || this.inputElement.selectionEnd !== this.inputElement.value.length && event.action === "tab" || this.inputElement.selectionStart !== 0 && event.action === "shiftTab" || event.action === "left" || event.action === "right") event.preventDefault();
                        this.notify("keyDownHandler", {
                            module: "MaskedDateTime",
                            e: event
                        });
                    }
                    break;
                default:
                    this.isNavigate = false;
                    break;
            }
        }
    };
    TimePicker.prototype.onMouseClick = function(event) {
        var target = event.target;
        var li = this.selectedElement = (0, $4ZDHT.closest)(target, "." + $01d3e22a44cfc2f9$var$LISTCLASS);
        this.setSelection(li, event);
        if (li && li.classList.contains($01d3e22a44cfc2f9$var$LISTCLASS)) this.hide();
    };
    TimePicker.prototype.closePopup = function(delay, e) {
        var _this = this;
        if (this.isPopupOpen() && this.popupWrapper) {
            var args = {
                popup: this.popupObj,
                event: e || null,
                cancel: false,
                name: "open"
            };
            (0, $4ZDHT.removeClass)([
                document.body
            ], $01d3e22a44cfc2f9$var$OVERFLOW);
            this.trigger("close", args, function(args) {
                if (!args.cancel) {
                    var animModel = {
                        name: "FadeOut",
                        duration: $01d3e22a44cfc2f9$var$ANIMATIONDURATION,
                        delay: delay ? delay : 0
                    };
                    _this.popupObj.hide(new (0, $kj1BR.Animation)(animModel));
                    (0, $4ZDHT.removeClass)([
                        _this.inputWrapper.container
                    ], [
                        $01d3e22a44cfc2f9$var$ICONANIMATION
                    ]);
                    (0, $4ZDHT.attributes)(_this.inputElement, {
                        "aria-expanded": "false"
                    });
                    _this.inputElement.removeAttribute("aria-owns");
                    _this.inputElement.removeAttribute("aria-controls");
                    _this.inputElement.removeAttribute("aria-activedescendant");
                    (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", _this.documentClickHandler);
                }
                if ((0, $5q7BP.Browser).isDevice && _this.modal) {
                    _this.modal.style.display = "none";
                    _this.modal.outerHTML = "";
                    _this.modal = null;
                }
                if ((0, $5q7BP.Browser).isDevice) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.mobileTimePopupWrap)) {
                        _this.mobileTimePopupWrap.remove();
                        _this.mobileTimePopupWrap = null;
                    }
                }
                if ((0, $5q7BP.Browser).isDevice && _this.allowEdit && !_this.readonly) _this.inputElement.removeAttribute("readonly");
            });
        } else if ((0, $5q7BP.Browser).isDevice && this.allowEdit && !this.readonly) this.inputElement.removeAttribute("readonly");
    };
    TimePicker.prototype.disposeServerPopup = function() {
        if (this.popupWrapper) {
            this.popupWrapper.style.visibility = "hidden";
            this.popupWrapper.style.top = "-9999px";
            this.popupWrapper.style.left = "-9999px";
            this.popupWrapper.style.width = "0px";
            this.popupWrapper.style.height = "0px";
        }
    };
    TimePicker.prototype.checkValueChange = function(event, isNavigation) {
        if (!this.strictMode && !this.validateState(this.valueWithMinutes)) {
            if (this.checkDateValue(this.valueWithMinutes) === null) this.initValue = this.valueWithMinutes = null;
            this.setProperties({
                value: this.compareFormatChange(this.inputElement.value)
            }, true);
            this.initValue = this.valueWithMinutes = this.compareFormatChange(this.inputElement.value);
            this.prevValue = this.inputElement.value;
            if (+this.prevDate !== +this.value) this.changeEvent(event);
        } else {
            if (!isNavigation) {
                if (this.prevValue !== this.inputElement.value || (0, $3EnZW.isNullOrUndefined)(this.checkDateValue(this.value))) this.valueProcess(event, this.compareFormatChange(this.inputElement.value));
            } else {
                var value = this.getDateObject(new Date(this.timeCollections[this.activeIndex]));
                if (+this.prevDate !== +value) this.valueProcess(event, value);
            }
        }
    };
    TimePicker.prototype.onMouseOver = function(event) {
        var currentLi = (0, $4ZDHT.closest)(event.target, "." + $01d3e22a44cfc2f9$var$LISTCLASS);
        this.setHover(currentLi, $01d3e22a44cfc2f9$var$HOVER);
    };
    TimePicker.prototype.setHover = function(li, className) {
        if (this.enabled && this.isValidLI(li) && !li.classList.contains(className)) {
            this.removeHover(className);
            (0, $4ZDHT.addClass)([
                li
            ], className);
            if (className === $01d3e22a44cfc2f9$var$NAVIGATION) li.setAttribute("aria-selected", "true");
        }
    };
    TimePicker.prototype.setSelection = function(li, event) {
        if (this.isValidLI(li)) {
            this.checkValue(li.getAttribute("data-value"));
            if (this.enableMask) this.createMask();
            this.selectedElement = li;
            this.activeIndex = Array.prototype.slice.call(this.liCollections).indexOf(li);
            this.valueWithMinutes = new Date(this.timeCollections[this.activeIndex]);
            (0, $4ZDHT.addClass)([
                this.selectedElement
            ], $01d3e22a44cfc2f9$var$SELECTED);
            this.selectedElement.setAttribute("aria-selected", "true");
            this.checkValueChange(event, true);
        }
    };
    TimePicker.prototype.onMouseLeave = function() {
        this.removeHover($01d3e22a44cfc2f9$var$HOVER);
    };
    TimePicker.prototype.scrollHandler = function() {
        if (this.getModuleName() === "timepicker" && (0, $5q7BP.Browser).isDevice) return;
        else this.hide();
    };
    TimePicker.prototype.setMinMax = function(minVal, maxVal) {
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(minVal))) this.initMin = this.getDateObject("12:00:00 AM");
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(maxVal))) this.initMax = this.getDateObject("11:59:59 PM");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TimePicker.prototype.validateMinMax = function(dateVal, minVal, maxVal) {
        var value = dateVal instanceof Date ? dateVal : this.getDateObject(dateVal);
        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) dateVal = this.strictOperation(this.initMin, this.initMax, dateVal, value);
        else if (+this.createDateObj(this.getFormattedValue(this.initMin)) > +this.createDateObj(this.getFormattedValue(this.initMax))) this.disableTimeIcon();
        if (this.strictMode) dateVal = this.valueIsDisable(dateVal) ? dateVal : null;
        this.checkErrorState(dateVal);
        return dateVal;
    };
    TimePicker.prototype.valueIsDisable = function(value) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.disableItemCollection) && this.disableItemCollection.length > 0) {
            if (this.disableItemCollection.length === this.timeCollections.length) return false;
            var time = value instanceof Date ? this.objToString(value) : value;
            for(var index = 0; index < this.disableItemCollection.length; index++){
                if (time === this.disableItemCollection[index]) return false;
            }
        }
        return true;
    };
    TimePicker.prototype.validateState = function(val) {
        if (!this.strictMode) {
            if (this.valueIsDisable(val)) {
                var value = typeof val === "string" ? this.setCurrentDate(this.getDateObject(val)) : this.setCurrentDate(this.getDateObject(val));
                var maxValue = this.setCurrentDate(this.getDateObject(this.initMax));
                var minValue = this.setCurrentDate(this.getDateObject(this.initMin));
                if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) {
                    if (+value > +maxValue || +value < +minValue) return false;
                } else {
                    if (+maxValue < +minValue || this.inputElement.value !== "") return false;
                }
            } else return false;
        }
        return true;
    };
    TimePicker.prototype.strictOperation = function(minimum, maximum, dateVal, val) {
        var maxValue = this.createDateObj(this.getFormattedValue(maximum));
        var minValue = this.createDateObj(this.getFormattedValue(minimum));
        var value = this.createDateObj(this.getFormattedValue(val));
        if (this.strictMode) {
            if (+minValue > +maxValue) {
                this.disableTimeIcon();
                this.initValue = this.getDateObject(maxValue);
                this.updateInputValue(this.getValue(this.initValue));
                if (this.enableMask) this.createMask();
                return this.inputElement.value;
            } else if (+minValue >= +value) return this.getDateObject(minValue);
            else if (+value >= +maxValue || +minValue === +maxValue) return this.getDateObject(maxValue);
        } else if (+minValue > +maxValue) {
            this.disableTimeIcon();
            if (!isNaN(+this.createDateObj(dateVal))) return dateVal;
        }
        return dateVal;
    };
    TimePicker.prototype.bindEvents = function() {
        (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "mousedown", this.popupHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "blur", this.inputBlurHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "focus", this.inputFocusHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "change", this.inputChangeHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.inputEventHandler, this);
        if (this.enableMask) (0, $aqzbR.EventHandler).add(this.inputElement, "keydown", this.keydownHandler, this);
        if (this.showClearButton && this.inputWrapper.clearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown", this.clearHandler, this);
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.formResetHandler, this);
        if (!(0, $5q7BP.Browser).isDevice) {
            this.keyConfigure = (0, $3EnZW.extend)(this.keyConfigure, this.keyConfigs);
            this.inputEvent = new (0, $dyv7X.KeyboardEvents)(this.inputWrapper.container, {
                keyAction: this.inputHandler.bind(this),
                keyConfigs: this.keyConfigure,
                eventName: "keydown"
            });
            if (this.showClearButton && this.inputElement) (0, $aqzbR.EventHandler).add(this.inputElement, "mousedown", this.mouseDownHandler, this);
        }
    };
    TimePicker.prototype.keydownHandler = function(e) {
        switch(e.code){
            case "Delete":
                if (this.enableMask && !this.popupObj && !this.readonly) this.notify("keyDownHandler", {
                    module: "MaskedDateTime",
                    e: e
                });
                break;
            default:
                break;
        }
    };
    TimePicker.prototype.formResetHandler = function() {
        if (!this.enabled) return;
        if (!this.inputElement.disabled) {
            var timeValue = this.inputElement.getAttribute("value");
            var val = this.checkDateValue(this.inputEleValue);
            if (this.element.tagName === "EJS-TIMEPICKER") {
                val = null;
                timeValue = "";
                this.inputElement.setAttribute("value", "");
            }
            this.setProperties({
                value: val
            }, true);
            this.prevDate = this.value;
            this.valueWithMinutes = this.value;
            this.initValue = this.value;
            if (this.inputElement) {
                this.updateInputValue(timeValue);
                if (this.enableMask) {
                    if (!timeValue) this.updateInputValue(this.maskedDateValue);
                    this.createMask();
                }
                this.checkErrorState(timeValue);
                this.prevValue = this.inputElement.value;
            }
        }
    };
    TimePicker.prototype.inputChangeHandler = function(e) {
        if (!this.enabled) return;
        e.stopPropagation();
    };
    TimePicker.prototype.inputEventHandler = function() {
        if (this.enableMask) this.notify("inputHandler", {
            module: "MaskedDateTime"
        });
    };
    TimePicker.prototype.unBindEvents = function() {
        if (this.inputWrapper) (0, $aqzbR.EventHandler).remove(this.inputWrapper.buttons[0], "mousedown touchstart", this.popupHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "blur", this.inputBlurHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.inputFocusHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "change", this.inputChangeHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.inputEventHandler);
        if (this.inputEvent) this.inputEvent.destroy();
        (0, $aqzbR.EventHandler).remove(this.inputElement, "mousedown touchstart", this.mouseDownHandler);
        if (this.showClearButton && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.clearButton)) (0, $aqzbR.EventHandler).remove(this.inputWrapper.clearButton, "mousedown touchstart", this.clearHandler);
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.formResetHandler);
    };
    TimePicker.prototype.bindClearEvent = function() {
        if (this.showClearButton && this.inputWrapper.clearButton) (0, $aqzbR.EventHandler).add(this.inputWrapper.clearButton, "mousedown", this.clearHandler, this);
    };
    TimePicker.prototype.raiseClearedEvent = function(e) {
        var clearedArgs = {
            event: e
        };
        this.trigger("cleared", clearedArgs);
    };
    TimePicker.prototype.clearHandler = function(e) {
        if (!this.enabled) return;
        e.preventDefault();
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) this.clear(e);
        else {
            this.resetState();
            this.raiseClearedEvent(e);
        }
        if (this.popupWrapper) this.popupWrapper.scrollTop = 0;
        if (this.enableMask) this.notify("clearHandler", {
            module: "MaskedDateTime"
        });
        if ((0, $4ZDHT.closest)(this.element, "form")) {
            var element = this.element;
            var keyupEvent = document.createEvent("KeyboardEvent");
            keyupEvent.initEvent("keyup", false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    TimePicker.prototype.clear = function(event) {
        this.setProperties({
            value: null
        }, true);
        this.initValue = null;
        this.resetState();
        this.raiseClearedEvent(event);
        this.changeEvent(event);
    };
    TimePicker.prototype.setZIndex = function() {
        if (this.popupObj) {
            this.popupObj.zIndex = this.zIndex;
            this.popupObj.dataBind();
        }
    };
    TimePicker.prototype.checkAttributes = function(isDynamic) {
        var attributes = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "step",
            "disabled",
            "readonly",
            "style",
            "name",
            "value",
            "min",
            "max",
            "placeholder"
        ];
        var value;
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var prop = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute(prop))) switch(prop){
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["enabled"] === undefined || isDynamic) {
                        var enabled = this.inputElement.getAttribute(prop) === "disabled" || this.inputElement.getAttribute(prop) === "" || this.inputElement.getAttribute(prop) === "true" ? false : true;
                        this.setProperties({
                            enabled: enabled
                        }, !isDynamic);
                    }
                    break;
                case "style":
                    this.inputStyle = this.inputElement.getAttribute(prop);
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["readonly"] === undefined || isDynamic) {
                        var readonly = this.inputElement.getAttribute(prop) === "readonly" || this.inputElement.getAttribute(prop) === "" || this.inputElement.getAttribute(prop) === "true" ? true : false;
                        this.setProperties({
                            readonly: readonly
                        }, !isDynamic);
                    }
                    break;
                case "name":
                    this.inputElement.setAttribute("name", this.inputElement.getAttribute(prop));
                    break;
                case "step":
                    this.step = parseInt(this.inputElement.getAttribute(prop), 10);
                    break;
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["placeholder"] === undefined || isDynamic) this.setProperties({
                        placeholder: this.inputElement.getAttribute(prop)
                    }, !isDynamic);
                    break;
                case "min":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["min"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) this.setProperties({
                            min: value
                        }, !isDynamic);
                    }
                    break;
                case "max":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["max"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) this.setProperties({
                            max: value
                        }, !isDynamic);
                    }
                    break;
                case "value":
                    if ((0, $3EnZW.isNullOrUndefined)(this.timeOptions) || this.timeOptions["value"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) {
                            this.initValue = value;
                            this.updateInput(false, this.initValue);
                            this.setProperties({
                                value: value
                            }, !isDynamic);
                        }
                    }
                    break;
            }
        }
    };
    TimePicker.prototype.setCurrentDate = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) return null;
        return new Date($01d3e22a44cfc2f9$var$YEAR, $01d3e22a44cfc2f9$var$MONTH, $01d3e22a44cfc2f9$var$DAY, value.getHours(), value.getMinutes(), value.getSeconds());
    };
    TimePicker.prototype.getTextFormat = function() {
        var time = 0;
        if (this.cldrTimeFormat().split(" ")[0] === "a" || this.cldrTimeFormat().indexOf("a") === 0) time = 1;
        else if (this.cldrTimeFormat().indexOf("a") < 0) {
            var strArray = this.cldrTimeFormat().split(" ");
            for(var i = 0; i < strArray.length; i++)if (strArray[i].toLowerCase().indexOf("h") >= 0) {
                time = i;
                break;
            }
        }
        return time;
    };
    TimePicker.prototype.updateValue = function(value, event) {
        var val;
        if (this.isNullOrEmpty(value)) this.resetState();
        else {
            val = this.checkValue(value);
            if (this.strictMode) {
                // this case set previous value to the text box when set invalid date
                var inputVal = val === null && value.trim().length > 0 ? this.previousState(this.prevDate) : this.inputElement.value;
                this.updateInputValue(inputVal);
                if (this.enableMask) {
                    if (!inputVal) this.updateInputValue(this.maskedDateValue);
                    if ((0, $3EnZW.isNullOrUndefined)(val) && value !== this.maskedDateValue) this.createMask();
                    if ((0, $3EnZW.isNullOrUndefined)(val) && value === this.maskedDateValue) this.updateInputValue(this.maskedDateValue);
                }
            }
        }
        this.checkValueChange(event, typeof value === "string" ? false : true);
    };
    TimePicker.prototype.previousState = function(date) {
        var value = this.getDateObject(date);
        for(var i = 0; i < this.timeCollections.length; i++)if (+value === this.timeCollections[i]) {
            this.activeIndex = i;
            this.selectedElement = this.liCollections[i];
            this.valueWithMinutes = new Date(this.timeCollections[i]);
            break;
        }
        return this.getValue(date);
    };
    TimePicker.prototype.resetState = function() {
        this.removeSelection();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue("", this.inputElement, this.floatLabelType, false);
        this.valueWithMinutes = this.activeIndex = null;
        if (!this.strictMode) this.checkErrorState(null);
    };
    TimePicker.prototype.objToString = function(val) {
        if ((0, $3EnZW.isNullOrUndefined)(this.checkDateValue(val))) return null;
        else return this.globalize.formatDate(val, {
            format: this.cldrTimeFormat(),
            type: "time"
        });
    };
    TimePicker.prototype.checkValue = function(value) {
        if (!this.isNullOrEmpty(value)) {
            var date = value instanceof Date ? value : this.getDateObject(value);
            return this.validateValue(date, value);
        }
        this.resetState();
        return this.valueWithMinutes = null;
    };
    TimePicker.prototype.validateValue = function(date, value) {
        var time;
        var val = this.validateMinMax(value, this.min, this.max);
        var newval = this.getDateObject(val);
        if (this.getFormattedValue(newval) !== this.getFormattedValue(this.value)) {
            this.valueWithMinutes = (0, $3EnZW.isNullOrUndefined)(newval) ? null : newval;
            time = this.objToString(this.valueWithMinutes);
        } else {
            if (this.strictMode) //for strict mode case, when value not present within a range. Reset the nearest range value.
            date = newval;
            this.valueWithMinutes = this.checkDateValue(date);
            time = this.objToString(this.valueWithMinutes);
        }
        if (!this.strictMode && (0, $3EnZW.isNullOrUndefined)(time)) {
            var value_1 = val.trim().length > 0 ? val : "";
            this.updateInputValue(value_1);
            if (this.enableMask) {
                if (!value_1) this.updateInputValue(this.maskedDateValue);
            }
        } else {
            this.updateInputValue(time);
            if (this.enableMask) {
                if (time === "") this.updateInputValue(this.maskedDateValue);
                if ((0, $3EnZW.isNullOrUndefined)(time) && value !== this.maskedDateValue) this.createMask();
                if ((0, $3EnZW.isNullOrUndefined)(time) && value === this.maskedDateValue) this.updateInputValue(this.maskedDateValue);
            }
        }
        return time;
    };
    TimePicker.prototype.createMask = function() {
        this.notify("createMask", {
            module: "MaskedDateTime"
        });
    };
    TimePicker.prototype.findNextElement = function(event) {
        var textVal = this.inputElement.value;
        var value = (0, $3EnZW.isNullOrUndefined)(this.valueWithMinutes) ? this.createDateObj(textVal) : this.getDateObject(this.valueWithMinutes);
        var timeVal = null;
        var count = this.liCollections.length;
        var collections = this.timeCollections;
        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value)) || !(0, $3EnZW.isNullOrUndefined)(this.activeIndex)) {
            if (event.action === "home") {
                var index = this.validLiElement(0);
                timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                this.activeIndex = index;
            } else if (event.action === "end") {
                var index = this.validLiElement(collections.length - 1, true);
                timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                this.activeIndex = index;
            } else {
                if (event.action === "down") for(var i = 0; i < count; i++){
                    if (+value < this.timeCollections[i]) {
                        var index = this.validLiElement(i);
                        timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                        this.activeIndex = index;
                        break;
                    } else if (i === count - 1) {
                        var index = this.validLiElement(0);
                        timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                        this.activeIndex = index;
                        break;
                    }
                }
                else for(var i = count - 1; i >= 0; i--){
                    if (+value > this.timeCollections[i]) {
                        var index = this.validLiElement(i, true);
                        timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                        this.activeIndex = index;
                        break;
                    } else if (i === 0) {
                        var index = this.validLiElement(count - 1);
                        timeVal = +this.createDateObj(new Date(this.timeCollections[index]));
                        this.activeIndex = index;
                        break;
                    }
                }
            }
            this.selectedElement = this.liCollections[this.activeIndex];
            this.elementValue((0, $3EnZW.isNullOrUndefined)(timeVal) ? null : new Date(timeVal));
        } else this.selectNextItem(event);
    };
    TimePicker.prototype.selectNextItem = function(event) {
        var index = this.validLiElement(0, event.action === "down" ? false : true);
        this.activeIndex = index;
        this.selectedElement = this.liCollections[index];
        this.elementValue(new Date(this.timeCollections[index]));
    };
    TimePicker.prototype.elementValue = function(value) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) this.checkValue(value);
    };
    TimePicker.prototype.validLiElement = function(index, backward) {
        var elementIndex = null;
        var items = (0, $3EnZW.isNullOrUndefined)(this.popupWrapper) ? this.liCollections : this.popupWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$LISTCLASS);
        var isCheck = true;
        if (items.length) {
            if (backward) for(var i = index; i >= 0; i--){
                if (!items[i].classList.contains($01d3e22a44cfc2f9$var$DISABLED)) {
                    elementIndex = i;
                    break;
                } else if (i === 0) {
                    if (isCheck) {
                        index = i = items.length;
                        isCheck = false;
                    }
                }
            }
            else for(var i = index; i <= items.length - 1; i++){
                if (!items[i].classList.contains($01d3e22a44cfc2f9$var$DISABLED)) {
                    elementIndex = i;
                    break;
                } else if (i === items.length - 1) {
                    if (isCheck) {
                        index = i = -1;
                        isCheck = false;
                    }
                }
            }
        }
        return elementIndex;
    };
    TimePicker.prototype.keyHandler = function(event) {
        if ((0, $3EnZW.isNullOrUndefined)(this.step) || this.step <= 0 || !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && this.inputWrapper.buttons[0].classList.contains($01d3e22a44cfc2f9$var$DISABLED)) return;
        var count = this.timeCollections.length;
        if ((0, $3EnZW.isNullOrUndefined)(this.getActiveElement()) || this.getActiveElement().length === 0) {
            if (this.liCollections.length > 0) {
                if ((0, $3EnZW.isNullOrUndefined)(this.value) && (0, $3EnZW.isNullOrUndefined)(this.activeIndex)) {
                    var index = this.validLiElement(0, event.action === "down" ? false : true);
                    this.activeIndex = index;
                    this.selectedElement = this.liCollections[index];
                    this.elementValue(new Date(this.timeCollections[index]));
                } else this.findNextElement(event);
            } else this.findNextElement(event);
        } else {
            var nextItem = void 0;
            if (event.keyCode >= 37 && event.keyCode <= 40) {
                var index = event.keyCode === 40 || event.keyCode === 39 ? ++this.activeIndex : --this.activeIndex;
                this.activeIndex = index = this.activeIndex === count ? 0 : this.activeIndex;
                this.activeIndex = index = this.activeIndex < 0 ? count - 1 : this.activeIndex;
                this.activeIndex = index = this.validLiElement(this.activeIndex, event.keyCode === 40 || event.keyCode === 39 ? false : true);
                nextItem = (0, $3EnZW.isNullOrUndefined)(this.timeCollections[index]) ? this.timeCollections[0] : this.timeCollections[index];
            } else if (event.action === "home") {
                var index = this.validLiElement(0);
                this.activeIndex = index;
                nextItem = this.timeCollections[index];
            } else if (event.action === "end") {
                var index = this.validLiElement(count - 1, true);
                this.activeIndex = index;
                nextItem = this.timeCollections[index];
            }
            this.selectedElement = this.liCollections[this.activeIndex];
            this.elementValue(new Date(nextItem));
        }
        this.isNavigate = true;
        this.setHover(this.selectedElement, $01d3e22a44cfc2f9$var$NAVIGATION);
        this.setActiveDescendant();
        if (this.enableMask) this.selectInputText();
        if (this.isPopupOpen() && this.selectedElement !== null && (!event || event.type !== "click")) this.setScrollPosition();
    };
    TimePicker.prototype.getCultureTimeObject = function(ld, c) {
        return (0, $3EnZW.getValue)("main." + c + ".dates.calendars.gregorian.timeFormats.short", ld);
    };
    TimePicker.prototype.getCultureDateObject = function(ld, c) {
        return (0, $3EnZW.getValue)("main." + c + ".dates.calendars.gregorian.dateFormats.short", ld);
    };
    TimePicker.prototype.wireListEvents = function() {
        (0, $aqzbR.EventHandler).add(this.listWrapper, "click", this.onMouseClick, this);
        if (!(0, $5q7BP.Browser).isDevice) {
            (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseover", this.onMouseOver, this);
            (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseout", this.onMouseLeave, this);
        }
    };
    TimePicker.prototype.unWireListEvents = function() {
        if (this.listWrapper) {
            (0, $aqzbR.EventHandler).remove(this.listWrapper, "click", this.onMouseClick);
            if (!(0, $5q7BP.Browser).isDevice) {
                (0, $aqzbR.EventHandler).remove(this.listWrapper, "mouseover", this.onMouseOver);
                (0, $aqzbR.EventHandler).remove(this.listWrapper, "mouseout", this.onMouseLeave);
            }
        }
    };
    TimePicker.prototype.valueProcess = function(event, value) {
        var result = (0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value)) ? null : value;
        if (+this.prevDate !== +result) {
            this.initValue = result;
            this.changeEvent(event);
        }
    };
    TimePicker.prototype.changeEvent = function(e) {
        this.addSelection();
        this.updateInput(true, this.initValue);
        var eventArgs = {
            event: e || null,
            value: this.value,
            text: this.inputElement.value,
            isInteracted: !(0, $3EnZW.isNullOrUndefined)(e),
            element: this.element
        };
        eventArgs.value = this.valueWithMinutes || this.getDateObject(this.inputElement.value);
        this.prevDate = this.valueWithMinutes || this.getDateObject(this.inputElement.value);
        if (this.isAngular && this.preventChange) this.preventChange = false;
        else this.trigger("change", eventArgs);
        this.invalidValueString = null;
        this.checkErrorState(this.value);
    };
    TimePicker.prototype.updateInput = function(isUpdate, date) {
        if (isUpdate) this.prevValue = this.getValue(this.prevDate);
        this.prevDate = this.valueWithMinutes = date;
        if (typeof date !== "number" || (this.value && +new Date(+this.value).setMilliseconds(0)) !== +date) {
            this.setProperties({
                value: date
            }, true);
            if (this.enableMask && this.value) this.createMask();
        }
        if (!this.strictMode && (0, $3EnZW.isNullOrUndefined)(this.value) && this.invalidValueString) {
            this.checkErrorState(this.invalidValueString);
            this.updateInputValue(this.invalidValueString);
        }
        this.clearIconState();
    };
    TimePicker.prototype.setActiveDescendant = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedElement) && this.value) (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-activedescendant": this.selectedElement.getAttribute("id")
        });
        else this.inputElement.removeAttribute("aria-activedescendant");
    };
    TimePicker.prototype.removeSelection = function() {
        this.removeHover($01d3e22a44cfc2f9$var$HOVER);
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) {
            var items = this.popupWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$SELECTED);
            if (items.length) {
                (0, $4ZDHT.removeClass)(items, $01d3e22a44cfc2f9$var$SELECTED);
                items[0].removeAttribute("aria-selected");
            }
        }
    };
    TimePicker.prototype.removeHover = function(className) {
        var hoveredItem = this.getHoverItem(className);
        if (hoveredItem && hoveredItem.length) {
            (0, $4ZDHT.removeClass)(hoveredItem, className);
            if (className === $01d3e22a44cfc2f9$var$NAVIGATION) hoveredItem[0].removeAttribute("aria-selected");
        }
    };
    TimePicker.prototype.getHoverItem = function(className) {
        var hoveredItem;
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) hoveredItem = this.popupWrapper.querySelectorAll("." + className);
        return hoveredItem;
    };
    TimePicker.prototype.setActiveClass = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) {
            var items = this.popupWrapper.querySelectorAll("." + $01d3e22a44cfc2f9$var$LISTCLASS);
            if (items.length) {
                for(var i = 0; i < items.length; i++)if (this.timeCollections[i] === +this.getDateObject(this.valueWithMinutes)) {
                    items[i].setAttribute("aria-selected", "true");
                    this.selectedElement = items[i];
                    this.activeIndex = i;
                    break;
                }
            }
        }
    };
    TimePicker.prototype.addSelection = function() {
        this.selectedElement = null;
        this.removeSelection();
        this.setActiveClass();
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedElement)) {
            (0, $4ZDHT.addClass)([
                this.selectedElement
            ], $01d3e22a44cfc2f9$var$SELECTED);
            this.selectedElement.setAttribute("aria-selected", "true");
        }
    };
    TimePicker.prototype.isValidLI = function(li) {
        return li && li.classList.contains($01d3e22a44cfc2f9$var$LISTCLASS) && !li.classList.contains($01d3e22a44cfc2f9$var$DISABLED);
    };
    TimePicker.prototype.createDateObj = function(val) {
        var formatStr = null;
        var today = this.globalize.formatDate(new Date(), {
            format: formatStr,
            skeleton: "short",
            type: "date"
        });
        var value = null;
        if (typeof val === "string") {
            if (val.toUpperCase().indexOf("AM") > -1 || val.toUpperCase().indexOf("PM") > -1) {
                today = this.defaultCulture.formatDate(new Date(), {
                    format: formatStr,
                    skeleton: "short",
                    type: "date"
                });
                value = isNaN(+new Date(today + " " + val)) ? null : new Date(new Date(today + " " + val).setMilliseconds(0));
                if ((0, $3EnZW.isNullOrUndefined)(value)) value = this.timeParse(today, val);
            } else value = this.timeParse(today, val);
        } else if (val instanceof Date) value = val;
        return value;
    };
    TimePicker.prototype.timeParse = function(today, val) {
        var value;
        value = this.globalize.parseDate(this.getAmPmValue(today + " " + val), {
            format: this.cldrDateFormat() + " " + this.cldrTimeFormat(),
            type: "datetime"
        });
        value = (0, $3EnZW.isNullOrUndefined)(value) ? this.globalize.parseDate(this.getAmPmValue(today + " " + val), {
            format: this.cldrDateFormat() + " " + this.dateToNumeric(),
            type: "datetime"
        }) : value;
        value = (0, $3EnZW.isNullOrUndefined)(value) ? value : new Date(value.setMilliseconds(0));
        return value;
    };
    TimePicker.prototype.createListItems = function() {
        var _this = this;
        this.listWrapper = this.createElement("div", {
            className: $01d3e22a44cfc2f9$var$CONTENT,
            attrs: {
                "tabindex": "-1"
            }
        });
        var start;
        var interval = this.step * 60000;
        var listItems = [];
        this.timeCollections = [];
        this.disableItemCollection = [];
        start = +this.getDateObject(this.initMin).setMilliseconds(0);
        var end = +this.getDateObject(this.initMax).setMilliseconds(0);
        while(end >= start){
            this.timeCollections.push(start);
            listItems.push(this.globalize.formatDate(new Date(start), {
                format: this.cldrTimeFormat(),
                type: "time"
            }));
            start += interval;
        }
        var listBaseOptions = {
            itemCreated: function(args) {
                var eventArgs = {
                    element: args.item,
                    text: args.text,
                    value: _this.getDateObject(args.text),
                    isDisabled: false
                };
                _this.trigger("itemRender", eventArgs, function(eventArgs) {
                    if (eventArgs.isDisabled) eventArgs.element.classList.add($01d3e22a44cfc2f9$var$DISABLED);
                    if (eventArgs.element.classList.contains($01d3e22a44cfc2f9$var$DISABLED)) _this.disableItemCollection.push(eventArgs.element.getAttribute("data-value"));
                });
            }
        };
        this.listTag = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, listItems, listBaseOptions, true);
        (0, $4ZDHT.attributes)(this.listTag, {
            "role": "listbox",
            "aria-hidden": "false",
            "id": this.element.id + "_options",
            "tabindex": "0"
        });
        (0, $4ZDHT.append)([
            this.listTag
        ], this.listWrapper);
    };
    TimePicker.prototype.documentClickHandler = function(event) {
        var target = event.target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && (this.inputWrapper.container.contains(target) && event.type !== "mousedown" || this.popupObj.element && this.popupObj.element.contains(target)) && event.type !== "touchstart") event.preventDefault();
        if (!(0, $4ZDHT.closest)(target, '[id="' + this.popupObj.element.id + '"]') && target !== this.inputElement && target !== (this.inputWrapper && this.inputWrapper.buttons[0]) && target !== (this.inputWrapper && this.inputWrapper.clearButton) && target !== (this.inputWrapper && this.inputWrapper.container) && !target.classList.contains("e-dlg-overlay")) {
            if (this.isPopupOpen()) {
                this.hide();
                this.focusOut();
            }
        } else if (target !== this.inputElement) {
            if (!(0, $5q7BP.Browser).isDevice) this.isPreventBlur = ((0, $5q7BP.Browser).isIE || (0, $5q7BP.Browser).info.name === "edge") && document.activeElement === this.inputElement && target === this.popupWrapper;
        }
    };
    TimePicker.prototype.setEnableRtl = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(this.enableRtl, [
            this.inputWrapper.container
        ]);
        if (this.popupObj) {
            this.popupObj.enableRtl = this.enableRtl;
            this.popupObj.dataBind();
        }
    };
    TimePicker.prototype.setEnable = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.inputElement, this.floatLabelType);
        if (this.enabled) {
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], $01d3e22a44cfc2f9$var$DISABLED);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-disabled": "false"
            });
            this.inputElement.setAttribute("tabindex", this.tabIndex);
        } else {
            this.hide();
            (0, $4ZDHT.addClass)([
                this.inputWrapper.container
            ], $01d3e22a44cfc2f9$var$DISABLED);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-disabled": "true"
            });
            this.inputElement.tabIndex = -1;
        }
    };
    TimePicker.prototype.getProperty = function(date, val) {
        if (val === "min") {
            this.initMin = this.checkDateValue(new Date(this.checkInValue(date.min)));
            this.setProperties({
                min: this.initMin
            }, true);
        } else {
            this.initMax = this.checkDateValue(new Date(this.checkInValue(date.max)));
            this.setProperties({
                max: this.initMax
            }, true);
        }
        if (this.inputElement.value === "") this.validateMinMax(this.value, this.min, this.max);
        else this.checkValue(this.inputElement.value);
        this.checkValueChange(null, false);
    };
    TimePicker.prototype.inputBlurHandler = function(e) {
        if (!this.enabled) return;
        // IE popup closing issue when click over the scrollbar
        if (this.isPreventBlur && this.isPopupOpen()) {
            this.inputElement.focus();
            return;
        }
        this.closePopup(0, e);
        if (this.enableMask && this.maskedDateValue && this.placeholder && this.floatLabelType !== "Always") {
            if (this.inputElement.value === this.maskedDateValue && !this.value && (this.floatLabelType === "Auto" || this.floatLabelType === "Never" || this.placeholder)) this.updateInputValue("");
        }
        (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], [
            $01d3e22a44cfc2f9$var$FOCUS
        ]);
        if (this.getText() !== this.inputElement.value) this.updateValue(this.inputElement.value, e);
        else if (this.inputElement.value.trim().length === 0) this.resetState();
        this.cursorDetails = null;
        this.isNavigate = false;
        if (this.inputElement.value === "") this.invalidValueString = null;
        var blurArguments = {
            model: this
        };
        this.trigger("blur", blurArguments);
    };
    /**
     * Focuses out the TimePicker textbox element.
     *
     * @returns {void}
     */ TimePicker.prototype.focusOut = function() {
        if (document.activeElement === this.inputElement) {
            this.inputElement.blur();
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], [
                $01d3e22a44cfc2f9$var$FOCUS
            ]);
            var blurArguments = {
                model: this
            };
            this.trigger("blur", blurArguments);
        }
    };
    TimePicker.prototype.isPopupOpen = function() {
        if (this.popupWrapper && this.popupWrapper.classList.contains("" + $01d3e22a44cfc2f9$var$ROOT)) return true;
        return false;
    };
    TimePicker.prototype.inputFocusHandler = function() {
        if (!this.enabled) return;
        var focusArguments = {
            model: this
        };
        if (!this.readonly && !(0, $5q7BP.Browser).isDevice && !this.enableMask) this.selectInputText();
        if (this.enableMask && !this.inputElement.value && this.placeholder) {
            if (this.maskedDateValue && !this.value && (this.floatLabelType === "Auto" || this.floatLabelType === "Never" || this.placeholder)) {
                this.updateInputValue(this.maskedDateValue);
                this.inputElement.selectionStart = 0;
                this.inputElement.selectionEnd = this.inputElement.value.length;
            }
        }
        this.trigger("focus", focusArguments);
        this.clearIconState();
        if (this.openOnFocus) this.show();
    };
    /**
     * Focused the TimePicker textbox element.
     *
     * @returns {void}
     */ TimePicker.prototype.focusIn = function() {
        if (document.activeElement !== this.inputElement && this.enabled) this.inputElement.focus();
    };
    /**
     * Hides the TimePicker popup.
     *
     * @returns {void}

     */ TimePicker.prototype.hide = function() {
        this.closePopup(100, null);
        this.clearIconState();
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Opens the popup to show the list items.
     *
     * @returns {void}

     */ TimePicker.prototype.show = function(event) {
        var _this = this;
        if (this.enabled && this.readonly || !this.enabled || this.popupWrapper) return;
        else {
            this.popupCreation();
            if ((0, $5q7BP.Browser).isDevice && this.listWrapper) {
                this.modal = this.createElement("div");
                this.modal.className = "" + $01d3e22a44cfc2f9$var$ROOT + " e-time-modal";
                document.body.className += " " + $01d3e22a44cfc2f9$var$OVERFLOW;
                document.body.appendChild(this.modal);
            }
            if ((0, $5q7BP.Browser).isDevice) {
                this.mobileTimePopupWrap = this.createElement("div", {
                    className: "e-timepicker-mob-popup-wrap"
                });
                document.body.appendChild(this.mobileTimePopupWrap);
            }
            this.openPopupEventArgs = {
                popup: this.popupObj || null,
                cancel: false,
                event: event || null,
                name: "open",
                appendTo: (0, $5q7BP.Browser).isDevice ? this.mobileTimePopupWrap : document.body
            };
            var eventArgs = this.openPopupEventArgs;
            this.trigger("open", eventArgs, function(eventArgs) {
                _this.openPopupEventArgs = eventArgs;
                if (!_this.openPopupEventArgs.cancel && !_this.inputWrapper.buttons[0].classList.contains($01d3e22a44cfc2f9$var$DISABLED)) {
                    _this.openPopupEventArgs.appendTo.appendChild(_this.popupWrapper);
                    _this.popupAlignment(_this.openPopupEventArgs);
                    _this.setScrollPosition();
                    if (!(0, $5q7BP.Browser).isDevice) _this.inputElement.focus();
                    var openAnimation = {
                        name: "FadeIn",
                        duration: $01d3e22a44cfc2f9$var$ANIMATIONDURATION
                    };
                    _this.popupObj.refreshPosition(_this.anchor);
                    if (_this.zIndex === 1000) _this.popupObj.show(new (0, $kj1BR.Animation)(openAnimation), _this.element);
                    else _this.popupObj.show(new (0, $kj1BR.Animation)(openAnimation), null);
                    _this.setActiveDescendant();
                    (0, $4ZDHT.attributes)(_this.inputElement, {
                        "aria-expanded": "true"
                    });
                    (0, $4ZDHT.attributes)(_this.inputElement, {
                        "aria-owns": _this.inputElement.id + "_options"
                    });
                    (0, $4ZDHT.attributes)(_this.inputElement, {
                        "aria-controls": _this.inputElement.id
                    });
                    (0, $4ZDHT.addClass)([
                        _this.inputWrapper.container
                    ], $01d3e22a44cfc2f9$var$FOCUS);
                    (0, $aqzbR.EventHandler).add(document, "mousedown touchstart", _this.documentClickHandler, _this);
                    _this.setOverlayIndex(_this.mobileTimePopupWrap, _this.popupObj.element, _this.modal, (0, $5q7BP.Browser).isDevice);
                } else {
                    _this.popupObj.destroy();
                    _this.popupWrapper = _this.listTag = undefined;
                    _this.liCollections = _this.timeCollections = _this.disableItemCollection = [];
                    _this.popupObj = null;
                }
            });
            if ((0, $5q7BP.Browser).isDevice) {
                var dlgOverlay = this.createElement("div", {
                    className: "e-dlg-overlay"
                });
                dlgOverlay.style.zIndex = (this.zIndex - 1).toString();
                this.mobileTimePopupWrap.appendChild(dlgOverlay);
            }
        }
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-param */ TimePicker.prototype.setOverlayIndex = function(popupWrapper, timePopupElement, modal, isDevice) {
        if (isDevice && !(0, $3EnZW.isNullOrUndefined)(timePopupElement) && !(0, $3EnZW.isNullOrUndefined)(modal) && !(0, $3EnZW.isNullOrUndefined)(popupWrapper)) {
            var index = parseInt(timePopupElement.style.zIndex, 10) ? parseInt(timePopupElement.style.zIndex, 10) : 1000;
            modal.style.zIndex = (index - 1).toString();
            popupWrapper.style.zIndex = index.toString();
        }
    };
    TimePicker.prototype.formatValues = function(type) {
        var value;
        if (typeof type === "number") value = (0, $3EnZW.formatUnit)(type);
        else if (typeof type === "string") value = type.match(/px|%|em/) ? type : isNaN(parseInt(type, 10)) ? type : (0, $3EnZW.formatUnit)(type);
        return value;
    };
    TimePicker.prototype.popupAlignment = function(args) {
        args.popup.position.X = this.formatValues(args.popup.position.X);
        args.popup.position.Y = this.formatValues(args.popup.position.Y);
        if (!isNaN(parseFloat(args.popup.position.X)) || !isNaN(parseFloat(args.popup.position.Y))) {
            this.popupObj.relateTo = this.anchor = document.body;
            this.popupObj.targetType = "container";
        }
        if (!isNaN(parseFloat(args.popup.position.X))) this.popupObj.offsetX = parseFloat(args.popup.position.X);
        if (!isNaN(parseFloat(args.popup.position.Y))) this.popupObj.offsetY = parseFloat(args.popup.position.Y);
        if (!(0, $5q7BP.Browser).isDevice) {
            switch(args.popup.position.X){
                case "left":
                    break;
                case "right":
                    args.popup.offsetX = this.containerStyle.width;
                    break;
                case "center":
                    args.popup.offsetX = -(this.containerStyle.width / 2);
                    break;
            }
            switch(args.popup.position.Y){
                case "top":
                    break;
                case "bottom":
                    break;
                case "center":
                    args.popup.offsetY = -(this.containerStyle.height / 2);
                    break;
            }
            if (args.popup.position.X === "center" && args.popup.position.Y === "center") {
                this.popupObj.relateTo = this.inputWrapper.container;
                this.anchor = this.inputElement;
                this.popupObj.targetType = "relative";
            }
        } else if (args.popup.position.X === "center" && args.popup.position.Y === "center") {
            this.popupObj.relateTo = this.anchor = document.body;
            this.popupObj.offsetY = 0;
            this.popupObj.targetType = "container";
            this.popupObj.collision = {
                X: "fit",
                Y: "fit"
            };
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the properties to be maintained upon browser refresh.
     *
     * @returns {string}
     */ TimePicker.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * To get component name
     *
     * @returns {string} Returns the component name.
     * @private
     */ TimePicker.prototype.getModuleName = function() {
        return "timepicker";
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {TimePickerModel} newProp - Returns the dynamic property value of the component.
     * @param {TimePickerModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ TimePicker.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(newProp.placeholder, this.inputElement);
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.inputElement, this.floatLabelType);
                    if (this.readonly) this.hide();
                    this.setTimeAllowEdit();
                    break;
                case "enabled":
                    this.setProperties({
                        enabled: newProp.enabled
                    }, true);
                    this.setEnable();
                    break;
                case "allowEdit":
                    this.setTimeAllowEdit();
                    break;
                case "enableRtl":
                    this.setProperties({
                        enableRtl: newProp.enableRtl
                    }, true);
                    this.setEnableRtl();
                    break;
                case "cssClass":
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case "zIndex":
                    this.setProperties({
                        zIndex: newProp.zIndex
                    }, true);
                    this.setZIndex();
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttributeToElement();
                    this.updateHtmlAttributeToWrapper();
                    this.checkAttributes(true);
                    break;
                case "min":
                case "max":
                    this.getProperty(newProp, prop);
                    break;
                case "showClearButton":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(this.showClearButton, this.inputElement, this.inputWrapper);
                    this.bindClearEvent();
                    break;
                case "locale":
                    this.setProperties({
                        locale: newProp.locale
                    }, true);
                    this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
                    this.l10n.setLocale(this.locale);
                    if (this.timeOptions && this.timeOptions.placeholder == null) this.updatePlaceHolder();
                    this.setValue(this.value);
                    if (this.enableMask) this.notify("createMask", {
                        module: "MaskedDateTime"
                    });
                    break;
                case "width":
                    (0, $4ZDHT.setStyleAttribute)(this.inputWrapper.container, {
                        "width": this.setWidth(newProp.width)
                    });
                    this.containerStyle = this.inputWrapper.container.getBoundingClientRect();
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                    break;
                case "format":
                    this.setProperties({
                        format: newProp.format
                    }, true);
                    this.checkTimeFormat();
                    this.setValue(this.value);
                    if (this.enableMask) {
                        this.createMask();
                        if (!this.value) this.updateInputValue(this.maskedDateValue);
                    }
                    break;
                case "value":
                    this.invalidValueString = null;
                    this.checkInvalidValue(newProp.value);
                    newProp.value = this.value;
                    if (!this.invalidValueString) {
                        if (typeof newProp.value === "string") {
                            this.setProperties({
                                value: this.checkDateValue(new Date(newProp.value))
                            }, true);
                            newProp.value = this.value;
                        } else if ((newProp.value && +new Date(+newProp.value).setMilliseconds(0)) !== +this.value) newProp.value = this.checkDateValue(new Date("" + newProp.value));
                        this.initValue = newProp.value;
                        newProp.value = this.compareFormatChange(this.checkValue(newProp.value));
                    } else {
                        this.updateInputValue(this.invalidValueString);
                        this.checkErrorState(this.invalidValueString);
                    }
                    if (this.enableMask && (0, $3EnZW.isNullOrUndefined)(newProp.value)) {
                        this.updateInputValue(this.maskedDateValue);
                        this.checkErrorState(this.maskedDateValue);
                    }
                    this.checkValueChange(null, false);
                    if (this.isPopupOpen()) this.setScrollPosition();
                    if (this.isAngular && this.preventChange) this.preventChange = false;
                    if (this.enableMask) this.notify("createMask", {
                        module: "MaskedDateTime"
                    });
                    break;
                case "floatLabelType":
                    this.floatLabelType = newProp.floatLabelType;
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.inputWrapper);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.inputElement, this.floatLabelType, this.placeholder);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-icon");
                    break;
                case "strictMode":
                    this.invalidValueString = null;
                    if (newProp.strictMode) this.checkErrorState(null);
                    this.setProperties({
                        strictMode: newProp.strictMode
                    }, true);
                    this.checkValue(this.inputElement.value);
                    this.checkValueChange(null, false);
                    break;
                case "scrollTo":
                    if (this.checkDateValue(new Date(this.checkInValue(newProp.scrollTo)))) {
                        if (this.popupWrapper) this.setScrollTo();
                        this.setProperties({
                            scrollTo: this.checkDateValue(new Date(this.checkInValue(newProp.scrollTo)))
                        }, true);
                    } else this.setProperties({
                        scrollTo: null
                    }, true);
                    break;
                case "enableMask":
                    if (this.enableMask) {
                        this.notify("createMask", {
                            module: "MaskedDateTime"
                        });
                        this.updateInputValue(this.maskedDateValue);
                    } else if (this.inputElement.value === this.maskedDateValue) this.updateInputValue("");
                    break;
            }
        }
    };
    TimePicker.prototype.checkInValue = function(inValue) {
        if (inValue instanceof Date) return inValue.toUTCString();
        else return "" + inValue;
    };
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "width", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "cssClass", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "strictMode", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "keyConfigs", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "format", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TimePicker.prototype, "enabled", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "fullScreenMode", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "readonly", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)({})
    ], TimePicker.prototype, "htmlAttributes", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], TimePicker.prototype, "floatLabelType", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "placeholder", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], TimePicker.prototype, "zIndex", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "enablePersistence", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TimePicker.prototype, "showClearButton", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(30)
    ], TimePicker.prototype, "step", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "scrollTo", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "value", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "min", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "max", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TimePicker.prototype, "allowEdit", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "openOnFocus", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TimePicker.prototype, "enableMask", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)({
            day: "day",
            month: "month",
            year: "year",
            hour: "hour",
            minute: "minute",
            second: "second",
            dayOfTheWeek: "day of the week"
        })
    ], TimePicker.prototype, "maskPlaceholder", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TimePicker.prototype, "serverTimezoneOffset", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "change", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "created", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "destroyed", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "open", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "itemRender", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "close", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "cleared", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "blur", void 0);
    $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.Event)()
    ], TimePicker.prototype, "focus", void 0);
    TimePicker = $01d3e22a44cfc2f9$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], TimePicker);
    return TimePicker;
}((0, $hQxLN.Component));
 /* eslint-enable @typescript-eslint/no-explicit-any */ 

var $3812471840bc0638$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3812471840bc0638$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
//class constant defination
var $3812471840bc0638$var$DATEWRAPPER = "e-date-wrapper";
var $3812471840bc0638$var$DATEPICKERROOT = "e-datepicker";
var $3812471840bc0638$var$DATETIMEWRAPPER = "e-datetime-wrapper";
var $3812471840bc0638$var$DAY = new Date().getDate();
var $3812471840bc0638$var$MONTH = new Date().getMonth();
var $3812471840bc0638$var$YEAR = new Date().getFullYear();
var $3812471840bc0638$var$HOUR = new Date().getHours();
var $3812471840bc0638$var$MINUTE = new Date().getMinutes();
var $3812471840bc0638$var$SECOND = new Date().getSeconds();
var $3812471840bc0638$var$MILLISECOND = new Date().getMilliseconds();
var $3812471840bc0638$var$ROOT = "e-datetimepicker";
var $3812471840bc0638$var$DATETIMEPOPUPWRAPPER = "e-datetimepopup-wrapper";
var $3812471840bc0638$var$INPUTWRAPPER = "e-input-group-icon";
var $3812471840bc0638$var$POPUP = "e-popup";
var $3812471840bc0638$var$TIMEICON = "e-time-icon";
var $3812471840bc0638$var$INPUTFOCUS = "e-input-focus";
var $3812471840bc0638$var$POPUPDIMENSION = "250px";
var $3812471840bc0638$var$ICONANIMATION = "e-icon-anim";
var $3812471840bc0638$var$DISABLED = "e-disabled";
var $3812471840bc0638$var$ERROR = "e-error";
var $3812471840bc0638$var$CONTENT = "e-content";
var $3812471840bc0638$var$NAVIGATION = "e-navigation";
var $3812471840bc0638$var$ACTIVE = "e-active";
var $3812471840bc0638$var$HOVER = "e-hover";
var $3812471840bc0638$var$ICONS = "e-icons";
var $3812471840bc0638$var$HALFPOSITION = 2;
var $3812471840bc0638$var$LISTCLASS = "e-list-item";
var $3812471840bc0638$var$ANIMATIONDURATION = 100;
var $3812471840bc0638$var$OVERFLOW = "e-time-overflow";
/**
 * Represents the DateTimePicker component that allows user to select
 * or enter a date time value.
 * ```html
 * <input id="dateTimePicker"/>
 * ```
 * ```typescript
 * <script>
 *   let dateTimePickerObject:DateTimePicker = new DateTimePicker({ value: new Date() });
 *   dateTimePickerObject.appendTo("#dateTimePicker");
 * </script>
 * ```
 */ var $3812471840bc0638$export$ccdfd7928785632e = /** @class */ function(_super) {
    $3812471840bc0638$var$__extends(DateTimePicker, _super);
    /**
     * Constructor for creating the widget
     *
     * @param {DateTimePickerModel} options - Specifies the DateTimePicker model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function DateTimePicker(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.valueWithMinutes = null;
        _this.scrollInvoked = false;
        _this.moduleName = _this.getModuleName();
        _this.formatRegex = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yyy|yy|y|'[^']*'|'[^']*'/g;
        _this.dateFormatString = "";
        _this.dateTimeOptions = options;
        return _this;
    }
    DateTimePicker.prototype.focusHandler = function() {
        if (!this.enabled) return;
        (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$INPUTFOCUS);
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ DateTimePicker.prototype.focusIn = function() {
        _super.prototype.focusIn.call(this);
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ DateTimePicker.prototype.focusOut = function() {
        if (document.activeElement === this.inputElement) {
            this.inputElement.blur();
            (0, $4ZDHT.removeClass)([
                this.inputWrapper.container
            ], [
                $3812471840bc0638$var$INPUTFOCUS
            ]);
        }
    };
    DateTimePicker.prototype.blurHandler = function(e) {
        if (!this.enabled) return;
        // IE popup closing issue when click over the scrollbar
        if (this.isTimePopupOpen() && this.isPreventBlur) {
            this.inputElement.focus();
            return;
        }
        (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$INPUTFOCUS);
        var blurArguments = {
            model: this
        };
        if (this.isTimePopupOpen()) this.hide(e);
        this.trigger("blur", blurArguments);
    };
    /**
     * To destroy the widget.
     *
     * @returns {void}
     */ DateTimePicker.prototype.destroy = function() {
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        if (this.popupObject && this.popupObject.element.classList.contains($3812471840bc0638$var$POPUP)) {
            this.popupObject.destroy();
            (0, $4ZDHT.detach)(this.dateTimeWrapper);
            this.dateTimeWrapper = undefined;
            this.liCollections = this.timeCollections = [];
            if (!(0, $3EnZW.isNullOrUndefined)(this.rippleFn)) this.rippleFn();
        }
        var ariaAttribute = {
            "aria-live": "assertive",
            "aria-atomic": "true",
            "aria-invalid": "false",
            "autocorrect": "off",
            "autocapitalize": "off",
            "spellcheck": "false",
            "aria-expanded": "false",
            "role": "combobox",
            "autocomplete": "off"
        };
        if (this.inputElement) (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeAttributes(ariaAttribute, this.inputElement);
        if (this.isCalendar()) {
            if (this.popupWrapper) (0, $4ZDHT.detach)(this.popupWrapper);
            this.popupObject = this.popupWrapper = null;
            this.keyboardHandler.destroy();
        }
        this.unBindInputEvents();
        this.liCollections = null;
        this.rippleFn = null;
        this.selectedElement = null;
        this.listTag = null;
        this.timeIcon = null;
        this.popupObject = null;
        this.preventArgs = null;
        this.keyboardModule = null;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.inputElement,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        _super.prototype.destroy.call(this);
    };
    /**
     * To Initialize the control rendering.
     *
     * @returns {void}
     * @private
     */ DateTimePicker.prototype.render = function() {
        this.timekeyConfigure = {
            enter: "enter",
            escape: "escape",
            end: "end",
            tab: "tab",
            home: "home",
            down: "downarrow",
            up: "uparrow",
            left: "leftarrow",
            right: "rightarrow",
            open: "alt+downarrow",
            close: "alt+uparrow"
        };
        this.valueWithMinutes = null;
        this.previousDateTime = null;
        this.isPreventBlur = false;
        this.cloneElement = this.element.cloneNode(true);
        this.dateTimeFormat = this.cldrDateTimeFormat();
        this.initValue = this.value;
        if (typeof this.min === "string") this.min = this.checkDateValue(new Date(this.min));
        if (typeof this.max === "string") this.max = this.checkDateValue(new Date(this.max));
        if (typeof this.minTime === "string") this.minTime = this.checkDateValue(new Date(this.minTime));
        if (typeof this.maxTime === "string") this.maxTime = this.checkDateValue(new Date(this.maxTime));
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        _super.prototype.updateHtmlAttributeToElement.call(this);
        this.checkAttributes(false);
        var localeText = {
            placeholder: this.placeholder
        };
        this.l10n = new (0, $e7i2H.L10n)("datetimepicker", localeText, this.locale);
        this.setProperties({
            placeholder: this.placeholder || this.l10n.getConstant("placeholder")
        }, true);
        _super.prototype.render.call(this);
        this.createInputElement();
        _super.prototype.updateHtmlAttributeToWrapper.call(this);
        this.bindInputEvents();
        if (this.enableMask) this.notify("createMask", {
            module: "MaskedDateTime"
        });
        this.setValue(true);
        if (this.enableMask && !this.value && this.maskedDateValue && (this.floatLabelType === "Always" || !this.floatLabelType || !this.placeholder)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.maskedDateValue, this.inputElement, this.floatLabelType, this.showClearButton);
        this.setProperties({
            scrollTo: this.checkDateValue(new Date(this.checkValue(this.scrollTo)))
        }, true);
        this.previousDateTime = this.value && new Date(+this.value);
        if (this.element.tagName === "EJS-DATETIMEPICKER") {
            this.tabIndex = this.element.hasAttribute("tabindex") ? this.element.getAttribute("tabindex") : "0";
            this.element.removeAttribute("tabindex");
            if (!this.enabled) this.inputElement.tabIndex = -1;
        }
        if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-date-time-icon");
        this.renderComplete();
    };
    DateTimePicker.prototype.setValue = function(isDynamic) {
        if (isDynamic === void 0) isDynamic = false;
        this.initValue = this.validateMinMaxRange(this.value);
        if (!this.strictMode && this.isDateObject(this.initValue)) {
            var value = this.validateMinMaxRange(this.initValue);
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.getFormattedValue(value), this.inputElement, this.floatLabelType, this.showClearButton);
            this.setProperties({
                value: value
            }, true);
        } else if ((0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.initValue = null;
            this.setProperties({
                value: null
            }, true);
        }
        this.valueWithMinutes = this.value;
        _super.prototype.updateInput.call(this, isDynamic);
    };
    DateTimePicker.prototype.validateMinMaxRange = function(value) {
        var result = value;
        if (this.isDateObject(value)) result = this.validateValue(value);
        else if (+this.min > +this.max) this.disablePopupButton(true);
        this.checkValidState(result);
        return result;
    };
    DateTimePicker.prototype.checkValidState = function(value) {
        this.isValidState = true;
        if (!this.strictMode) {
            if (+value > +this.max || +value < +this.min || !this.isValidTime(value)) this.isValidState = false;
        }
        this.checkErrorState();
    };
    DateTimePicker.prototype.checkErrorState = function() {
        if (this.isValidState) (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$ERROR);
        else (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$ERROR);
        (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-invalid": this.isValidState ? "false" : "true"
        });
    };
    DateTimePicker.prototype.isValidTime = function(value) {
        if (value != null && (this.minTime || this.maxTime)) {
            var minTimeValue = void 0;
            var maxTimeValue = void 0;
            var maxValue = void 0;
            var minValue = void 0;
            var valueTime = value.getHours() * 3600000 + value.getMinutes() * 60000 + value.getSeconds() * 1000 + value.getMilliseconds();
            if (this.minTime) minTimeValue = this.minTime.getHours() * 3600000 + this.minTime.getMinutes() * 60000 + this.minTime.getSeconds() * 1000 + this.minTime.getMilliseconds();
            if (this.maxTime) maxTimeValue = this.maxTime.getHours() * 3600000 + this.maxTime.getMinutes() * 60000 + this.maxTime.getSeconds() * 1000 + this.maxTime.getMilliseconds();
            if (this.min && +value.getDate() === +this.min.getDate() && +value.getMonth() === +this.min.getMonth() && +value.getFullYear() === +this.min.getFullYear()) {
                minValue = this.min.getHours() * 3600000 + this.min.getMinutes() * 60000 + this.min.getSeconds() * 1000 + this.min.getMilliseconds();
                minTimeValue = minTimeValue < minValue ? minValue : minTimeValue;
            }
            if (this.max && +value.getDate() === +this.max.getDate() && +value.getMonth() === +this.max.getMonth() && +this.max.getFullYear() === +this.max.getFullYear()) {
                maxValue = this.max.getHours() * 3600000 + this.max.getMinutes() * 60000 + this.max.getSeconds() * 1000 + this.max.getMilliseconds();
                maxTimeValue = maxTimeValue > maxValue ? maxValue : maxTimeValue;
            }
            if (this.strictMode) {
                var newValue = void 0;
                if (minTimeValue && valueTime < minTimeValue) {
                    newValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), this.minTime.getHours(), this.minTime.getMinutes(), this.minTime.getSeconds(), this.minTime.getMilliseconds());
                    this.setProperties({
                        value: newValue
                    }, true);
                    this.changedArgs = {
                        value: this.value
                    };
                } else if (maxTimeValue && valueTime > maxTimeValue) {
                    newValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), this.maxTime.getHours(), this.maxTime.getMinutes(), this.maxTime.getSeconds(), this.maxTime.getMilliseconds());
                    this.setProperties({
                        value: newValue
                    }, true);
                    this.changedArgs = {
                        value: this.value
                    };
                }
                return true;
            } else return !(minTimeValue && valueTime < minTimeValue || maxTimeValue && valueTime > maxTimeValue);
        }
        return true;
    };
    DateTimePicker.prototype.validateValue = function(value) {
        var dateVal = value;
        if (this.strictMode) {
            if (+this.min > +this.max) {
                this.disablePopupButton(true);
                dateVal = this.max;
            } else if (+value < +this.min) dateVal = this.min;
            else if (+value > +this.max) dateVal = this.max;
        } else if (+this.min > +this.max) {
            this.disablePopupButton(true);
            dateVal = value;
        }
        return dateVal;
    };
    DateTimePicker.prototype.disablePopupButton = function(isDisable) {
        if (isDisable) {
            (0, $4ZDHT.addClass)([
                this.inputWrapper.buttons[0],
                this.timeIcon
            ], $3812471840bc0638$var$DISABLED);
            this.hide();
        } else (0, $4ZDHT.removeClass)([
            this.inputWrapper.buttons[0],
            this.timeIcon
        ], $3812471840bc0638$var$DISABLED);
    };
    DateTimePicker.prototype.getFormattedValue = function(value) {
        var dateOptions;
        if (!(0, $3EnZW.isNullOrUndefined)(value)) {
            if (this.calendarMode === "Gregorian") dateOptions = {
                format: this.cldrDateTimeFormat(),
                type: "dateTime",
                skeleton: "yMd"
            };
            else dateOptions = {
                format: this.cldrDateTimeFormat(),
                type: "dateTime",
                skeleton: "yMd",
                calendar: "islamic"
            };
            return this.globalize.formatDate(value, dateOptions);
        } else return null;
    };
    DateTimePicker.prototype.isDateObject = function(value) {
        return !(0, $3EnZW.isNullOrUndefined)(value) && !isNaN(+value) ? true : false;
    };
    DateTimePicker.prototype.createInputElement = function() {
        (0, $4ZDHT.removeClass)([
            this.inputElement
        ], $3812471840bc0638$var$DATEPICKERROOT);
        (0, $4ZDHT.removeClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$DATEWRAPPER);
        (0, $4ZDHT.addClass)([
            this.inputWrapper.container
        ], $3812471840bc0638$var$DATETIMEWRAPPER);
        (0, $4ZDHT.addClass)([
            this.inputElement
        ], $3812471840bc0638$var$ROOT);
        this.renderTimeIcon();
    };
    DateTimePicker.prototype.renderTimeIcon = function() {
        this.timeIcon = (0, $168e4e125732cd26$export$f5b8910cec6cf069).appendSpan($3812471840bc0638$var$INPUTWRAPPER + " " + $3812471840bc0638$var$TIMEICON + " " + $3812471840bc0638$var$ICONS, this.inputWrapper.container);
    };
    DateTimePicker.prototype.bindInputEvents = function() {
        (0, $aqzbR.EventHandler).add(this.timeIcon, "mousedown", this.timeHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputWrapper.buttons[0], "mousedown", this.dateHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "blur", this.blurHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "focus", this.focusHandler, this);
        this.defaultKeyConfigs = (0, $3EnZW.extend)(this.defaultKeyConfigs, this.keyConfigs);
        this.keyboardHandler = new (0, $dyv7X.KeyboardEvents)(this.inputElement, {
            eventName: "keydown",
            keyAction: this.inputKeyAction.bind(this),
            keyConfigs: this.defaultKeyConfigs
        });
    };
    DateTimePicker.prototype.unBindInputEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.timeIcon, "mousedown touchstart", this.timeHandler);
        (0, $aqzbR.EventHandler).remove(this.inputWrapper.buttons[0], "mousedown touchstart", this.dateHandler);
        if (this.inputElement) {
            (0, $aqzbR.EventHandler).remove(this.inputElement, "blur", this.blurHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.focusHandler);
        }
        if (this.keyboardHandler) this.keyboardHandler.destroy();
    };
    DateTimePicker.prototype.cldrTimeFormat = function() {
        var cldrTime;
        if (this.isNullOrEmpty(this.timeFormat)) {
            if (this.locale === "en" || this.locale === "en-US") cldrTime = (0, $3EnZW.getValue)("timeFormats.short", (0, $bWDaN.getDefaultDateObject)());
            else cldrTime = this.getCultureTimeObject((0, $bWDaN.cldrData), "" + this.locale);
        } else cldrTime = this.timeFormat;
        return cldrTime;
    };
    DateTimePicker.prototype.cldrDateTimeFormat = function() {
        var cldrTime;
        var culture = new (0, $bWDaN.Internationalization)(this.locale);
        var dateFormat = culture.getDatePattern({
            skeleton: "yMd"
        });
        if (this.isNullOrEmpty(this.formatString)) cldrTime = dateFormat + " " + this.getCldrFormat("time");
        else cldrTime = this.formatString;
        return cldrTime;
    };
    DateTimePicker.prototype.getCldrFormat = function(type) {
        var cldrDateTime;
        if (this.locale === "en" || this.locale === "en-US") cldrDateTime = (0, $3EnZW.getValue)("timeFormats.short", (0, $bWDaN.getDefaultDateObject)());
        else cldrDateTime = this.getCultureTimeObject((0, $bWDaN.cldrData), "" + this.locale);
        return cldrDateTime;
    };
    DateTimePicker.prototype.isNullOrEmpty = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(value) || typeof value === "string" && value.trim() === "") return true;
        else return false;
    };
    DateTimePicker.prototype.getCultureTimeObject = function(ld, c) {
        if (this.calendarMode === "Gregorian") return (0, $3EnZW.getValue)("main." + this.locale + ".dates.calendars.gregorian.timeFormats.short", ld);
        else return (0, $3EnZW.getValue)("main." + this.locale + ".dates.calendars.islamic.timeFormats.short", ld);
    };
    DateTimePicker.prototype.timeHandler = function(e) {
        if (!this.enabled) return;
        this.isIconClicked = true;
        if ((0, $5q7BP.Browser).isDevice) this.inputElement.setAttribute("readonly", "");
        if (e.currentTarget === this.timeIcon) e.preventDefault();
        if (this.enabled && !this.readonly) {
            if (this.isDatePopupOpen()) _super.prototype.hide.call(this, e);
            if (this.isTimePopupOpen()) this.closePopup(e);
            else {
                this.inputElement.focus();
                this.popupCreation("time", e);
                (0, $4ZDHT.addClass)([
                    this.inputWrapper.container
                ], [
                    $3812471840bc0638$var$INPUTFOCUS
                ]);
            }
        }
        this.isIconClicked = false;
    };
    DateTimePicker.prototype.dateHandler = function(e) {
        if (!this.enabled) return;
        if (e.currentTarget === this.inputWrapper.buttons[0]) e.preventDefault();
        if (this.enabled && !this.readonly) {
            if (this.isTimePopupOpen()) this.closePopup(e);
            if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) this.popupCreation("date", e);
        }
    };
    DateTimePicker.prototype.show = function(type, e) {
        if (this.enabled && this.readonly || !this.enabled) return;
        else {
            if (type === "time" && !this.dateTimeWrapper) {
                if (this.isDatePopupOpen()) this.hide(e);
                this.popupCreation("time", e);
            } else if (!this.popupObj) {
                if (this.isTimePopupOpen()) this.hide(e);
                _super.prototype.show.call(this);
                this.popupCreation("date", e);
            }
        }
    };
    DateTimePicker.prototype.toggle = function(e) {
        if (this.isDatePopupOpen()) {
            _super.prototype.hide.call(this, e);
            this.show("time", null);
        } else if (this.isTimePopupOpen()) {
            this.hide(e);
            _super.prototype.show.call(this, null, e);
            this.popupCreation("date", null);
        } else this.show(null, e);
    };
    DateTimePicker.prototype.listCreation = function() {
        var dateObject;
        if (this.calendarMode === "Gregorian") {
            this.cldrDateTimeFormat().replace(this.formatRegex, this.TimePopupFormat());
            if (this.dateFormatString === "") this.dateFormatString = this.cldrDateTimeFormat();
            dateObject = this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), {
                format: this.dateFormatString,
                type: "datetime"
            });
        } else dateObject = this.globalize.parseDate(this.getAmPmValue(this.inputElement.value), {
            format: this.cldrDateTimeFormat(),
            type: "datetime",
            calendar: "islamic"
        });
        var value = (0, $3EnZW.isNullOrUndefined)(this.value) ? this.inputElement.value !== "" ? dateObject : new Date() : this.value;
        this.valueWithMinutes = value;
        this.listWrapper = (0, $4ZDHT.createElement)("div", {
            className: $3812471840bc0638$var$CONTENT,
            attrs: {
                "tabindex": "0"
            }
        });
        var min = this.startTime(value);
        var max = this.endTime(value);
        var listDetails = (0, $01d3e22a44cfc2f9$export$552eaada9a5fa010).createListItems(this.createElement, min, max, this.globalize, this.cldrTimeFormat(), this.step);
        this.timeCollections = listDetails.collection;
        this.listTag = listDetails.list;
        (0, $4ZDHT.attributes)(this.listTag, {
            "role": "listbox",
            "aria-hidden": "false",
            "id": this.element.id + "_options"
        });
        (0, $4ZDHT.append)([
            listDetails.list
        ], this.listWrapper);
        this.wireTimeListEvents();
        var rippleModel = {
            duration: 300,
            selector: "." + $3812471840bc0638$var$LISTCLASS
        };
        this.rippleFn = (0, $kj1BR.rippleEffect)(this.listWrapper, rippleModel);
        this.liCollections = this.listWrapper.querySelectorAll("." + $3812471840bc0638$var$LISTCLASS);
    };
    DateTimePicker.prototype.popupCreation = function(type, e) {
        if ((0, $5q7BP.Browser).isDevice) this.element.setAttribute("readonly", "readonly");
        if (type === "date") {
            if (!this.readonly && this.popupWrapper) {
                (0, $4ZDHT.addClass)([
                    this.popupWrapper
                ], $3812471840bc0638$var$DATETIMEPOPUPWRAPPER);
                (0, $4ZDHT.attributes)(this.popupWrapper, {
                    "id": this.element.id + "_options"
                });
            }
        } else if (!this.readonly) {
            this.dateTimeWrapper = (0, $4ZDHT.createElement)("div", {
                className: $3812471840bc0638$var$ROOT + " " + $3812471840bc0638$var$POPUP,
                attrs: {
                    "id": this.element.id + "_timepopup",
                    "style": "visibility:hidden ; display:block"
                }
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) this.dateTimeWrapper.className += " " + this.cssClass;
            if (!(0, $3EnZW.isNullOrUndefined)(this.step) && this.step > 0) {
                this.listCreation();
                (0, $4ZDHT.append)([
                    this.listWrapper
                ], this.dateTimeWrapper);
            }
            document.body.appendChild(this.dateTimeWrapper);
            this.addTimeSelection();
            this.renderPopup();
            this.setTimeScrollPosition();
            this.openPopup(e);
            if (!(0, $5q7BP.Browser).isDevice || (0, $5q7BP.Browser).isDevice && !this.fullScreenMode) this.popupObject.refreshPosition(this.inputElement);
            if ((0, $5q7BP.Browser).isDevice) {
                this.modelWrapper.style.zIndex = (this.popupObject.zIndex - 1).toString();
                if (this.fullScreenMode) this.dateTimeWrapper.style.left = "0px";
            }
        }
    };
    DateTimePicker.prototype.openPopup = function(e) {
        var _this = this;
        this.preventArgs = {
            cancel: false,
            popup: this.popupObject,
            event: e || null
        };
        var eventArgs = this.preventArgs;
        this.trigger("open", eventArgs, function(eventArgs) {
            _this.preventArgs = eventArgs;
            if (!_this.preventArgs.cancel && !_this.readonly) {
                var openAnimation = {
                    name: "FadeIn",
                    duration: $3812471840bc0638$var$ANIMATIONDURATION
                };
                if (_this.zIndex === 1000) _this.popupObject.show(new (0, $kj1BR.Animation)(openAnimation), _this.element);
                else _this.popupObject.show(new (0, $kj1BR.Animation)(openAnimation), null);
                (0, $4ZDHT.addClass)([
                    _this.inputWrapper.container
                ], [
                    $3812471840bc0638$var$ICONANIMATION
                ]);
                (0, $4ZDHT.attributes)(_this.inputElement, {
                    "aria-expanded": "true"
                });
                (0, $4ZDHT.attributes)(_this.inputElement, {
                    "aria-owns": _this.inputElement.id + "_options"
                });
                (0, $4ZDHT.attributes)(_this.inputElement, {
                    "aria-controls": _this.inputElement.id
                });
                (0, $aqzbR.EventHandler).add(document, "mousedown touchstart", _this.documentClickHandler, _this);
            }
        });
    };
    DateTimePicker.prototype.documentClickHandler = function(event) {
        var target = event.target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObject) && (this.inputWrapper.container.contains(target) && event.type !== "mousedown" || this.popupObject.element && this.popupObject.element.contains(target)) && event.type !== "touchstart") event.preventDefault();
        if (!(0, $4ZDHT.closest)(target, '[id="' + (this.popupObject && this.popupObject.element.id + '"]')) && target !== this.inputElement && target !== this.timeIcon && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper) && target !== this.inputWrapper.container && !target.classList.contains("e-dlg-overlay")) {
            if (this.isTimePopupOpen()) {
                this.hide(event);
                this.focusOut();
            }
        } else if (target !== this.inputElement) {
            if (!(0, $5q7BP.Browser).isDevice) this.isPreventBlur = document.activeElement === this.inputElement && ((0, $5q7BP.Browser).isIE || (0, $5q7BP.Browser).info.name === "edge") && target === this.popupObject.element;
        }
    };
    DateTimePicker.prototype.isTimePopupOpen = function() {
        return this.dateTimeWrapper && this.dateTimeWrapper.classList.contains("" + $3812471840bc0638$var$ROOT) ? true : false;
    };
    DateTimePicker.prototype.isDatePopupOpen = function() {
        return this.popupWrapper && this.popupWrapper.classList.contains("" + $3812471840bc0638$var$DATETIMEPOPUPWRAPPER) ? true : false;
    };
    DateTimePicker.prototype.renderPopup = function() {
        var _this = this;
        this.containerStyle = this.inputWrapper.container.getBoundingClientRect();
        if ((0, $5q7BP.Browser).isDevice) {
            this.timeModal = (0, $4ZDHT.createElement)("div");
            this.timeModal.className = "" + $3812471840bc0638$var$ROOT + " e-time-modal";
            document.body.className += " " + $3812471840bc0638$var$OVERFLOW;
            this.timeModal.style.display = "block";
            document.body.appendChild(this.timeModal);
        }
        if ((0, $5q7BP.Browser).isDevice) {
            this.modelWrapper = (0, $4ZDHT.createElement)("div", {
                className: "e-datetime-mob-popup-wrap"
            });
            this.modelWrapper.appendChild(this.dateTimeWrapper);
            var dlgOverlay = (0, $4ZDHT.createElement)("div", {
                className: "e-dlg-overlay"
            });
            dlgOverlay.style.zIndex = (this.zIndex - 1).toString();
            this.modelWrapper.appendChild(dlgOverlay);
            document.body.appendChild(this.modelWrapper);
        }
        var offset = 4;
        this.popupObject = new (0, $2vAqh.Popup)(this.dateTimeWrapper, {
            width: this.setPopupWidth(),
            zIndex: this.zIndex,
            targetType: "container",
            collision: (0, $5q7BP.Browser).isDevice ? {
                X: "fit",
                Y: "fit"
            } : {
                X: "flip",
                Y: "flip"
            },
            relateTo: (0, $5q7BP.Browser).isDevice ? document.body : this.inputWrapper.container,
            position: (0, $5q7BP.Browser).isDevice ? {
                X: "center",
                Y: "center"
            } : {
                X: "left",
                Y: "bottom"
            },
            enableRtl: this.enableRtl,
            offsetY: offset,
            open: function() {
                _this.dateTimeWrapper.style.visibility = "visible";
                (0, $4ZDHT.addClass)([
                    _this.timeIcon
                ], $3812471840bc0638$var$ACTIVE);
                if (!(0, $5q7BP.Browser).isDevice) {
                    _this.timekeyConfigure = (0, $3EnZW.extend)(_this.timekeyConfigure, _this.keyConfigs);
                    _this.inputEvent = new (0, $dyv7X.KeyboardEvents)(_this.inputWrapper.container, {
                        keyAction: _this.timeKeyActionHandle.bind(_this),
                        keyConfigs: _this.timekeyConfigure,
                        eventName: "keydown"
                    });
                }
            },
            close: function() {
                (0, $4ZDHT.removeClass)([
                    _this.timeIcon
                ], $3812471840bc0638$var$ACTIVE);
                _this.unWireTimeListEvents();
                _this.inputElement.removeAttribute("aria-activedescendant");
                (0, $4ZDHT.remove)(_this.popupObject.element);
                _this.popupObject.destroy();
                _this.dateTimeWrapper.innerHTML = "";
                if (_this.modelWrapper) (0, $4ZDHT.remove)(_this.modelWrapper);
                _this.listWrapper = _this.dateTimeWrapper = undefined;
                if (_this.inputEvent) _this.inputEvent.destroy();
            },
            targetExitViewport: function() {
                if (!(0, $5q7BP.Browser).isDevice) _this.hide();
            }
        });
        if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) {
            this.popupObject.element.style.maxHeight = "100%";
            this.popupObject.element.style.width = "100%";
        } else this.popupObject.element.style.maxHeight = $3812471840bc0638$var$POPUPDIMENSION;
        if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) {
            var modelHeader = this.createElement("div", {
                className: "e-model-header"
            });
            var modelTitleSpan = this.createElement("span", {
                className: "e-model-title"
            });
            modelTitleSpan.textContent = "Select time";
            var modelCloseIcon = this.createElement("span", {
                className: "e-popup-close"
            });
            (0, $aqzbR.EventHandler).add(modelCloseIcon, "mousedown touchstart", this.dateTimeCloseHandler, this);
            modelHeader.appendChild(modelCloseIcon);
            modelHeader.appendChild(modelTitleSpan);
            this.dateTimeWrapper.insertBefore(modelHeader, this.dateTimeWrapper.firstElementChild);
        }
    };
    DateTimePicker.prototype.dateTimeCloseHandler = function(e) {
        this.hide();
    };
    DateTimePicker.prototype.setDimension = function(width) {
        if (typeof width === "number") width = (0, $3EnZW.formatUnit)(width);
        else if (typeof width === "string") // eslint-disable-next-line no-self-assign
        width;
        else width = "100%";
        return width;
    };
    DateTimePicker.prototype.setPopupWidth = function() {
        var width = this.setDimension(this.width);
        if (width.indexOf("%") > -1) {
            var inputWidth = this.containerStyle.width * parseFloat(width) / 100;
            width = inputWidth.toString() + "px";
        }
        return width;
    };
    DateTimePicker.prototype.wireTimeListEvents = function() {
        (0, $aqzbR.EventHandler).add(this.listWrapper, "click", this.onMouseClick, this);
        if (!(0, $5q7BP.Browser).isDevice) {
            (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseover", this.onMouseOver, this);
            (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseout", this.onMouseLeave, this);
        }
    };
    DateTimePicker.prototype.unWireTimeListEvents = function() {
        if (this.listWrapper) {
            (0, $aqzbR.EventHandler).remove(this.listWrapper, "click", this.onMouseClick);
            (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", this.documentClickHandler);
            if (!(0, $5q7BP.Browser).isDevice) {
                (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseover", this.onMouseOver, this);
                (0, $aqzbR.EventHandler).add(this.listWrapper, "mouseout", this.onMouseLeave, this);
            }
        }
    };
    DateTimePicker.prototype.onMouseOver = function(event) {
        var currentLi = (0, $4ZDHT.closest)(event.target, "." + $3812471840bc0638$var$LISTCLASS);
        this.setTimeHover(currentLi, $3812471840bc0638$var$HOVER);
    };
    DateTimePicker.prototype.onMouseLeave = function() {
        this.removeTimeHover($3812471840bc0638$var$HOVER);
    };
    DateTimePicker.prototype.setTimeHover = function(li, className) {
        if (this.enabled && this.isValidLI(li) && !li.classList.contains(className)) {
            this.removeTimeHover(className);
            (0, $4ZDHT.addClass)([
                li
            ], className);
        }
    };
    DateTimePicker.prototype.getPopupHeight = function() {
        var height = parseInt($3812471840bc0638$var$POPUPDIMENSION, 10);
        var popupHeight = this.dateTimeWrapper.getBoundingClientRect().height;
        if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) return popupHeight;
        else return popupHeight > height ? height : popupHeight;
    };
    DateTimePicker.prototype.changeEvent = function(e) {
        _super.prototype.changeEvent.call(this, e);
        if ((this.value && this.value.valueOf()) !== (this.previousDateTime && +this.previousDateTime.valueOf())) {
            this.valueWithMinutes = this.value;
            this.setInputValue("date");
            this.previousDateTime = this.value && new Date(+this.value);
        }
    };
    DateTimePicker.prototype.updateValue = function(e) {
        this.setInputValue("time");
        if (+this.previousDateTime !== +this.value) {
            this.changedArgs = {
                value: this.value,
                event: e || null,
                isInteracted: !(0, $3EnZW.isNullOrUndefined)(e),
                element: this.element
            };
            this.addTimeSelection();
            this.trigger("change", this.changedArgs);
            this.previousDateTime = this.previousDate = this.value;
        }
    };
    DateTimePicker.prototype.setTimeScrollPosition = function() {
        var popupElement = this.selectedElement;
        if (!(0, $3EnZW.isNullOrUndefined)(popupElement)) this.findScrollTop(popupElement);
        else if (this.dateTimeWrapper && this.checkDateValue(this.scrollTo)) this.setScrollTo();
    };
    DateTimePicker.prototype.findScrollTop = function(element) {
        var listHeight = this.getPopupHeight();
        var nextElement = element.nextElementSibling;
        var height = nextElement ? nextElement.offsetTop : element.offsetTop;
        var lineHeight = element.getBoundingClientRect().height;
        if (height + element.offsetTop > listHeight) {
            if ((0, $5q7BP.Browser).isDevice && this.fullScreenMode) {
                var listContent = this.dateTimeWrapper.querySelector(".e-content");
                listContent.scrollTop = nextElement ? height - (listHeight / $3812471840bc0638$var$HALFPOSITION + lineHeight / $3812471840bc0638$var$HALFPOSITION) : height;
            } else this.dateTimeWrapper.scrollTop = nextElement ? height - (listHeight / $3812471840bc0638$var$HALFPOSITION + lineHeight / $3812471840bc0638$var$HALFPOSITION) : height;
        } else this.dateTimeWrapper.scrollTop = 0;
    };
    DateTimePicker.prototype.setScrollTo = function() {
        var element;
        var items = this.dateTimeWrapper.querySelectorAll("." + $3812471840bc0638$var$LISTCLASS);
        if (items.length >= 0) {
            this.scrollInvoked = true;
            var initialTime = this.timeCollections[0];
            var scrollTime = this.getDateObject(this.checkDateValue(this.scrollTo)).getTime();
            element = items[Math.round((scrollTime - initialTime) / (this.step * 60000))];
        } else this.dateTimeWrapper.scrollTop = 0;
        if (!(0, $3EnZW.isNullOrUndefined)(element)) this.findScrollTop(element);
        else this.dateTimeWrapper.scrollTop = 0;
    };
    DateTimePicker.prototype.setInputValue = function(type) {
        if (type === "date") {
            this.inputElement.value = this.previousElementValue = this.getFormattedValue(this.getFullDateTime());
            this.setProperties({
                value: this.getFullDateTime()
            }, true);
        } else {
            var tempVal = this.getFormattedValue(new Date(this.timeCollections[this.activeIndex]));
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(tempVal, this.inputElement, this.floatLabelType, this.showClearButton);
            this.previousElementValue = this.inputElement.value;
            this.setProperties({
                value: new Date(this.timeCollections[this.activeIndex])
            }, true);
            if (this.enableMask) this.createMask();
        }
        this.updateIconState();
    };
    DateTimePicker.prototype.getFullDateTime = function() {
        var value = null;
        if (this.isDateObject(this.valueWithMinutes)) value = this.combineDateTime(this.valueWithMinutes);
        else value = this.previousDate;
        return this.validateMinMaxRange(value);
    };
    DateTimePicker.prototype.createMask = function() {
        this.notify("createMask", {
            module: "MaskedDateTime"
        });
    };
    DateTimePicker.prototype.combineDateTime = function(value) {
        if (this.isDateObject(value)) {
            var day = this.previousDate.getDate();
            var month = this.previousDate.getMonth();
            var year = this.previousDate.getFullYear();
            var hour = value.getHours();
            var minutes = value.getMinutes();
            var seconds = value.getSeconds();
            return new Date(year, month, day, hour, minutes, seconds);
        } else return this.previousDate;
    };
    DateTimePicker.prototype.onMouseClick = function(event) {
        var target = event.target;
        var li = this.selectedElement = (0, $4ZDHT.closest)(target, "." + $3812471840bc0638$var$LISTCLASS);
        if (li && li.classList.contains($3812471840bc0638$var$LISTCLASS)) {
            this.timeValue = li.getAttribute("data-value");
            this.hide(event);
        }
        this.setSelection(li, event);
    };
    DateTimePicker.prototype.setSelection = function(li, event) {
        if (this.isValidLI(li) && !li.classList.contains($3812471840bc0638$var$ACTIVE)) {
            this.selectedElement = li;
            var index = Array.prototype.slice.call(this.liCollections).indexOf(li);
            this.activeIndex = index;
            this.valueWithMinutes = new Date(this.timeCollections[this.activeIndex]);
            (0, $4ZDHT.addClass)([
                this.selectedElement
            ], $3812471840bc0638$var$ACTIVE);
            this.selectedElement.setAttribute("aria-selected", "true");
            this.updateValue(event);
        }
    };
    DateTimePicker.prototype.setTimeActiveClass = function() {
        var collections = (0, $3EnZW.isNullOrUndefined)(this.dateTimeWrapper) ? this.listWrapper : this.dateTimeWrapper;
        if (!(0, $3EnZW.isNullOrUndefined)(collections)) {
            var items = collections.querySelectorAll("." + $3812471840bc0638$var$LISTCLASS);
            if (items.length) {
                for(var i = 0; i < items.length; i++)if (this.timeCollections[i] === +this.valueWithMinutes) {
                    items[i].setAttribute("aria-selected", "true");
                    this.selectedElement = items[i];
                    this.activeIndex = i;
                    this.setTimeActiveDescendant();
                    break;
                }
            }
        }
    };
    DateTimePicker.prototype.setTimeActiveDescendant = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedElement) && this.value) (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-activedescendant": this.selectedElement.getAttribute("id")
        });
        else this.inputElement.removeAttribute("aria-activedescendant");
    };
    DateTimePicker.prototype.addTimeSelection = function() {
        this.selectedElement = null;
        this.removeTimeSelection();
        this.setTimeActiveClass();
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedElement)) {
            (0, $4ZDHT.addClass)([
                this.selectedElement
            ], $3812471840bc0638$var$ACTIVE);
            this.selectedElement.setAttribute("aria-selected", "true");
        }
    };
    DateTimePicker.prototype.removeTimeSelection = function() {
        this.removeTimeHover($3812471840bc0638$var$HOVER);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dateTimeWrapper)) {
            var items = this.dateTimeWrapper.querySelectorAll("." + $3812471840bc0638$var$ACTIVE);
            if (items.length) {
                (0, $4ZDHT.removeClass)(items, $3812471840bc0638$var$ACTIVE);
                items[0].removeAttribute("aria-selected");
            }
        }
    };
    DateTimePicker.prototype.removeTimeHover = function(className) {
        var hoveredItem = this.getTimeHoverItem(className);
        if (hoveredItem && hoveredItem.length) (0, $4ZDHT.removeClass)(hoveredItem, className);
    };
    DateTimePicker.prototype.getTimeHoverItem = function(className) {
        var collections = (0, $3EnZW.isNullOrUndefined)(this.dateTimeWrapper) ? this.listWrapper : this.dateTimeWrapper;
        var hoveredItem;
        if (!(0, $3EnZW.isNullOrUndefined)(collections)) hoveredItem = collections.querySelectorAll("." + className);
        return hoveredItem;
    };
    DateTimePicker.prototype.isValidLI = function(li) {
        return li && li.classList.contains($3812471840bc0638$var$LISTCLASS) && !li.classList.contains($3812471840bc0638$var$DISABLED);
    };
    DateTimePicker.prototype.calculateStartEnd = function(value, range, method) {
        var day = value.getDate();
        var month = value.getMonth();
        var year = value.getFullYear();
        var hours = value.getHours();
        var minutes = value.getMinutes();
        var seconds = value.getSeconds();
        var milliseconds = value.getMilliseconds();
        if (range) {
            if (method === "starttime") return new Date(year, month, day, 0, 0, 0);
            else return new Date(year, month, day, 23, 59, 59);
        } else return new Date(year, month, day, hours, minutes, seconds, milliseconds);
    };
    DateTimePicker.prototype.startTime = function(date) {
        var tempStartValue;
        var start;
        var tempMin = this.min;
        var tempMax = this.max;
        var value = date === null ? new Date() : date;
        var isModified = false;
        var startValue;
        if (this.minTime) {
            startValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), this.minTime.getHours(), this.minTime.getMinutes(), this.minTime.getSeconds(), this.minTime.getMilliseconds());
            isModified = true;
        } else startValue = value;
        if (+startValue.getDate() === +tempMin.getDate() && +startValue.getMonth() === +tempMin.getMonth() && +startValue.getFullYear() === +tempMin.getFullYear() || +new Date(startValue.getFullYear(), startValue.getMonth(), startValue.getDate()) <= +new Date(tempMin.getFullYear(), tempMin.getMonth(), tempMin.getDate())) {
            start = false;
            tempStartValue = tempMin;
            if (isModified && +new Date(startValue.getFullYear(), startValue.getMonth(), startValue.getDate(), startValue.getHours(), startValue.getMinutes(), startValue.getSeconds(), startValue.getMilliseconds()) >= +new Date(tempMin.getFullYear(), tempMin.getMonth(), tempMin.getDate(), tempMin.getHours(), tempMin.getMinutes(), tempMin.getSeconds(), tempMin.getMilliseconds())) tempStartValue.setHours(startValue.getHours(), startValue.getMinutes(), startValue.getSeconds(), startValue.getMilliseconds());
        } else if (+startValue < +tempMax && +startValue > +tempMin) {
            start = !isModified;
            tempStartValue = startValue;
        } else if (+startValue >= +tempMax) {
            start = true;
            tempStartValue = tempMax;
        }
        return this.calculateStartEnd(tempStartValue, start, "starttime");
    };
    DateTimePicker.prototype.TimePopupFormat = function() {
        var format = "";
        var formatCount = 0;
        var proxy = this;
        /**
         * Formats the value specifier.
         *
         * @param {string} formattext - The format text.
         * @returns {string} The formatted value specifier.
         */ function formatValueSpecifier(formattext) {
            switch(formattext){
                case "d":
                case "dd":
                case "ddd":
                case "dddd":
                case "M":
                case "MM":
                case "MMM":
                case "MMMM":
                case "y":
                case "yy":
                case "yyy":
                case "yyyy":
                    if (format === "") format = format + formattext;
                    else format = format + "/" + formattext;
                    formatCount = formatCount + 1;
                    break;
            }
            if (formatCount > 2) proxy.dateFormatString = format;
            return format;
        }
        return formatValueSpecifier;
    };
    DateTimePicker.prototype.endTime = function(date) {
        var tempEndValue;
        var end;
        var tempMax = this.max;
        var value = date === null ? new Date() : date;
        var isModified = false;
        var endValue;
        if (this.maxTime) {
            endValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), this.maxTime.getHours(), this.maxTime.getMinutes(), this.maxTime.getSeconds(), this.maxTime.getMilliseconds());
            isModified = true;
        } else endValue = value;
        if (+endValue.getDate() === +tempMax.getDate() && +endValue.getMonth() === +tempMax.getMonth() && +endValue.getFullYear() === +tempMax.getFullYear() || +new Date(endValue.getUTCFullYear(), endValue.getMonth(), endValue.getDate()) >= +new Date(tempMax.getFullYear(), tempMax.getMonth(), tempMax.getDate())) {
            end = false;
            tempEndValue = this.max;
            if (isModified && +new Date(endValue.getUTCFullYear(), endValue.getMonth(), endValue.getDate(), endValue.getHours(), endValue.getMinutes(), endValue.getSeconds(), endValue.getMilliseconds()) <= +new Date(tempMax.getFullYear(), tempMax.getMonth(), tempMax.getDate(), tempMax.getHours(), tempMax.getMinutes(), tempMax.getSeconds(), tempMax.getMilliseconds())) tempEndValue.setHours(endValue.getHours(), endValue.getMinutes(), endValue.getSeconds(), endValue.getMilliseconds());
        } else if (+endValue < +this.max && +endValue > +this.min) {
            end = !isModified;
            tempEndValue = endValue;
        } else if (+endValue <= +this.min) {
            end = true;
            tempEndValue = this.min;
        }
        return this.calculateStartEnd(tempEndValue, end, "endtime");
    };
    DateTimePicker.prototype.hide = function(e) {
        var _this = this;
        if (this.popupObj || this.dateTimeWrapper) {
            this.preventArgs = {
                cancel: false,
                popup: this.popupObj || this.popupObject,
                event: e || null
            };
            var eventArgs = this.preventArgs;
            if ((0, $3EnZW.isNullOrUndefined)(this.popupObj)) this.trigger("close", eventArgs, function(eventArgs) {
                _this.dateTimeCloseEventCallback(e, eventArgs);
            });
            else this.dateTimeCloseEventCallback(e, eventArgs);
        } else {
            if ((0, $5q7BP.Browser).isDevice && this.allowEdit && !this.readonly) this.inputElement.removeAttribute("readonly");
            this.setAllowEdit();
        }
    };
    DateTimePicker.prototype.dateTimeCloseEventCallback = function(e, eventArgs) {
        this.preventArgs = eventArgs;
        if (!this.preventArgs.cancel) {
            if (this.isDatePopupOpen()) _super.prototype.hide.call(this, e);
            else if (this.isTimePopupOpen()) {
                this.closePopup(e);
                (0, $4ZDHT.removeClass)([
                    document.body
                ], $3812471840bc0638$var$OVERFLOW);
                if ((0, $5q7BP.Browser).isDevice && this.timeModal) {
                    this.timeModal.style.display = "none";
                    this.timeModal.outerHTML = "";
                    this.timeModal = null;
                }
                this.setTimeActiveDescendant();
            }
        }
        if ((0, $5q7BP.Browser).isDevice && this.allowEdit && !this.readonly) this.inputElement.removeAttribute("readonly");
        this.setAllowEdit();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DateTimePicker.prototype.closePopup = function(e) {
        if (this.isTimePopupOpen() && this.popupObject) {
            var animModel = {
                name: "FadeOut",
                duration: $3812471840bc0638$var$ANIMATIONDURATION,
                delay: 0
            };
            this.popupObject.hide(new (0, $kj1BR.Animation)(animModel));
            this.inputWrapper.container.classList.remove($3812471840bc0638$var$ICONANIMATION);
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-expanded": "false"
            });
            this.inputElement.removeAttribute("aria-owns");
            this.inputElement.removeAttribute("aria-controls");
            (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", this.documentClickHandler);
        }
    };
    DateTimePicker.prototype.preRender = function() {
        this.checkFormat();
        this.dateTimeFormat = this.cldrDateTimeFormat();
        _super.prototype.preRender.call(this);
        (0, $4ZDHT.removeClass)([
            this.inputElementCopy
        ], [
            $3812471840bc0638$var$ROOT
        ]);
    };
    DateTimePicker.prototype.getProperty = function(date, val) {
        if (val === "min") this.setProperties({
            min: this.validateValue(date.min)
        }, true);
        else this.setProperties({
            max: this.validateValue(date.max)
        }, true);
    };
    DateTimePicker.prototype.checkAttributes = function(isDynamic) {
        var attributes = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "style",
            "name",
            "step",
            "disabled",
            "readonly",
            "value",
            "min",
            "max",
            "placeholder",
            "type"
        ];
        var value;
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var prop = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement.getAttribute(prop))) switch(prop){
                case "name":
                    this.inputElement.setAttribute("name", this.inputElement.getAttribute(prop));
                    break;
                case "step":
                    this.step = parseInt(this.inputElement.getAttribute(prop), 10);
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["readonly"] === undefined || isDynamic) {
                        var readonly = this.inputElement.getAttribute(prop) === "disabled" || this.inputElement.getAttribute(prop) === "" || this.inputElement.getAttribute(prop) === "true" ? true : false;
                        this.setProperties({
                            readonly: readonly
                        }, !isDynamic);
                    }
                    break;
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["placeholder"] === undefined || isDynamic) this.setProperties({
                        placeholder: this.inputElement.getAttribute(prop)
                    }, !isDynamic);
                    break;
                case "min":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["min"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!this.isNullOrEmpty(value) && !isNaN(+value)) this.setProperties({
                            min: value
                        }, !isDynamic);
                    }
                    break;
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["enabled"] === undefined || isDynamic) {
                        var enabled = this.inputElement.getAttribute(prop) === "disabled" || this.inputElement.getAttribute(prop) === "true" || this.inputElement.getAttribute(prop) === "" ? false : true;
                        this.setProperties({
                            enabled: enabled
                        }, !isDynamic);
                    }
                    break;
                case "value":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["value"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!this.isNullOrEmpty(value) && !isNaN(+value)) this.setProperties({
                            value: value
                        }, !isDynamic);
                    }
                    break;
                case "max":
                    if ((0, $3EnZW.isNullOrUndefined)(this.dateTimeOptions) || this.dateTimeOptions["max"] === undefined || isDynamic) {
                        value = new Date(this.inputElement.getAttribute(prop));
                        if (!this.isNullOrEmpty(value) && !isNaN(+value)) this.setProperties({
                            max: value
                        }, !isDynamic);
                    }
                    break;
            }
        }
    };
    DateTimePicker.prototype.requiredModules = function() {
        var modules = [];
        if (this.calendarMode === "Islamic") modules.push({
            args: [
                this
            ],
            member: "islamic",
            name: "Islamic"
        });
        if (this.enableMask) modules.push(this.maskedDateModule());
        return modules;
    };
    DateTimePicker.prototype.maskedDateModule = function() {
        var modules = {
            args: [
                this
            ],
            member: "MaskedDateTime"
        };
        return modules;
    };
    DateTimePicker.prototype.getTimeActiveElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.dateTimeWrapper)) return this.dateTimeWrapper.querySelectorAll("." + $3812471840bc0638$var$ACTIVE);
        else return null;
    };
    DateTimePicker.prototype.createDateObj = function(val) {
        return val instanceof Date ? val : null;
    };
    DateTimePicker.prototype.getDateObject = function(text) {
        if (!this.isNullOrEmpty(text)) {
            var dateValue = this.createDateObj(text);
            var value = this.valueWithMinutes;
            var status_1 = !(0, $3EnZW.isNullOrUndefined)(value);
            if (this.checkDateValue(dateValue)) {
                var date = status_1 ? value.getDate() : $3812471840bc0638$var$DAY;
                var month = status_1 ? value.getMonth() : $3812471840bc0638$var$MONTH;
                var year = status_1 ? value.getFullYear() : $3812471840bc0638$var$YEAR;
                var hour = status_1 ? value.getHours() : $3812471840bc0638$var$HOUR;
                var minute = status_1 ? value.getMinutes() : $3812471840bc0638$var$MINUTE;
                var second = status_1 ? value.getSeconds() : $3812471840bc0638$var$SECOND;
                var millisecond = status_1 ? value.getMilliseconds() : $3812471840bc0638$var$MILLISECOND;
                if (!this.scrollInvoked) return new Date(year, month, date, hour, minute, second, millisecond);
                else {
                    this.scrollInvoked = false;
                    return new Date(year, month, date, dateValue.getHours(), dateValue.getMinutes(), dateValue.getSeconds(), dateValue.getMilliseconds());
                }
            }
        }
        return null;
    };
    DateTimePicker.prototype.findNextTimeElement = function(event) {
        var textVal = this.inputElement.value;
        var value = (0, $3EnZW.isNullOrUndefined)(this.valueWithMinutes) ? this.createDateObj(textVal) : this.getDateObject(this.valueWithMinutes);
        var dateTimeVal = null;
        var listCount = this.liCollections.length;
        if (!(0, $3EnZW.isNullOrUndefined)(this.activeIndex) || !(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value))) {
            if (event.action === "home") {
                dateTimeVal = +this.createDateObj(new Date(this.timeCollections[0]));
                this.activeIndex = 0;
            } else if (event.action === "end") {
                dateTimeVal = +this.createDateObj(new Date(this.timeCollections[this.timeCollections.length - 1]));
                this.activeIndex = this.timeCollections.length - 1;
            } else if (event.action === "down") {
                for(var i = 0; i < listCount; i++)if (+value < this.timeCollections[i]) {
                    dateTimeVal = +this.createDateObj(new Date(this.timeCollections[i]));
                    this.activeIndex = i;
                    break;
                }
            } else {
                for(var i = listCount - 1; i >= 0; i--)if (+value > this.timeCollections[i]) {
                    dateTimeVal = +this.createDateObj(new Date(this.timeCollections[i]));
                    this.activeIndex = i;
                    break;
                }
            }
            this.selectedElement = this.liCollections[this.activeIndex];
            this.timeElementValue((0, $3EnZW.isNullOrUndefined)(dateTimeVal) ? null : new Date(dateTimeVal));
        }
    };
    DateTimePicker.prototype.setTimeValue = function(date, value) {
        var dateString;
        var time;
        var val = this.validateMinMaxRange(value);
        var newval = this.createDateObj(val);
        if (this.getFormattedValue(newval) !== (!(0, $3EnZW.isNullOrUndefined)(this.value) ? this.getFormattedValue(this.value) : null)) {
            this.valueWithMinutes = (0, $3EnZW.isNullOrUndefined)(newval) ? null : newval;
            time = new Date(+this.valueWithMinutes);
        } else {
            if (this.strictMode) //for strict mode case, when value not present within a range. Reset the nearest range value.
            date = newval;
            this.valueWithMinutes = this.checkDateValue(date);
            time = new Date(+this.valueWithMinutes);
        }
        if (this.calendarMode === "Gregorian") dateString = this.globalize.formatDate(time, {
            format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.cldrDateTimeFormat(),
            type: "dateTime",
            skeleton: "yMd"
        });
        else dateString = this.globalize.formatDate(time, {
            format: !(0, $3EnZW.isNullOrUndefined)(this.formatString) ? this.formatString : this.cldrDateTimeFormat(),
            type: "dateTime",
            skeleton: "yMd",
            calendar: "islamic"
        });
        if (!this.strictMode && (0, $3EnZW.isNullOrUndefined)(time)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(dateString, this.inputElement, this.floatLabelType, this.showClearButton);
        else (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(dateString, this.inputElement, this.floatLabelType, this.showClearButton);
        return time;
    };
    DateTimePicker.prototype.timeElementValue = function(value) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.checkDateValue(value)) && !this.isNullOrEmpty(value)) {
            var date = value instanceof Date ? value : this.getDateObject(value);
            return this.setTimeValue(date, value);
        }
        return null;
    };
    DateTimePicker.prototype.timeKeyHandler = function(event) {
        if ((0, $3EnZW.isNullOrUndefined)(this.step) || this.step <= 0) return;
        var listCount = this.timeCollections.length;
        if ((0, $3EnZW.isNullOrUndefined)(this.getTimeActiveElement()) || this.getTimeActiveElement().length === 0) {
            if (this.liCollections.length > 0) {
                if ((0, $3EnZW.isNullOrUndefined)(this.value) && (0, $3EnZW.isNullOrUndefined)(this.activeIndex)) {
                    this.activeIndex = 0;
                    this.selectedElement = this.liCollections[0];
                    this.timeElementValue(new Date(this.timeCollections[0]));
                } else this.findNextTimeElement(event);
            }
        } else {
            var nextItemValue = void 0;
            if (event.keyCode >= 37 && event.keyCode <= 40) {
                var index = event.keyCode === 40 || event.keyCode === 39 ? ++this.activeIndex : --this.activeIndex;
                this.activeIndex = index = this.activeIndex === listCount ? 0 : this.activeIndex;
                this.activeIndex = index = this.activeIndex < 0 ? listCount - 1 : this.activeIndex;
                nextItemValue = (0, $3EnZW.isNullOrUndefined)(this.timeCollections[index]) ? this.timeCollections[0] : this.timeCollections[index];
            } else if (event.action === "home") {
                this.activeIndex = 0;
                nextItemValue = this.timeCollections[0];
            } else if (event.action === "end") {
                this.activeIndex = listCount - 1;
                nextItemValue = this.timeCollections[listCount - 1];
            }
            this.selectedElement = this.liCollections[this.activeIndex];
            this.timeElementValue(new Date(nextItemValue));
        }
        this.isNavigate = true;
        this.setTimeHover(this.selectedElement, $3812471840bc0638$var$NAVIGATION);
        this.setTimeActiveDescendant();
        if (this.isTimePopupOpen() && this.selectedElement !== null && (!event || event.type !== "click")) this.setTimeScrollPosition();
    };
    DateTimePicker.prototype.timeKeyActionHandle = function(event) {
        if (this.enabled) {
            if (event.action !== "right" && event.action !== "left" && event.action !== "tab") event.preventDefault();
            switch(event.action){
                case "up":
                case "down":
                case "home":
                case "end":
                    this.timeKeyHandler(event);
                    break;
                case "enter":
                    if (this.isNavigate) {
                        this.selectedElement = this.liCollections[this.activeIndex];
                        this.valueWithMinutes = new Date(this.timeCollections[this.activeIndex]);
                        this.setInputValue("time");
                        if (+this.previousDateTime !== +this.value) {
                            this.changedArgs.value = this.value;
                            this.addTimeSelection();
                            this.previousDateTime = this.value;
                        }
                    } else this.updateValue(event);
                    this.hide(event);
                    (0, $4ZDHT.addClass)([
                        this.inputWrapper.container
                    ], $3812471840bc0638$var$INPUTFOCUS);
                    this.isNavigate = false;
                    event.stopPropagation();
                    break;
                case "escape":
                    this.hide(event);
                    break;
                default:
                    this.isNavigate = false;
                    break;
            }
        }
    };
    DateTimePicker.prototype.inputKeyAction = function(event) {
        switch(event.action){
            case "altDownArrow":
                this.strictModeUpdate();
                this.updateInput();
                this.toggle(event);
                break;
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {DateTimePickerModel} newProp - Returns the dynamic property value of the component.
     * @param {DateTimePickerModel} oldProp - Returns the previous property value of the component.
     * @returns {void}

     */ DateTimePicker.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            var openPopup = [
                "blur",
                "change",
                "cleared",
                "close",
                "created",
                "destroyed",
                "focus",
                "navigated",
                "open",
                "renderDayCell"
            ];
            if (openPopup.indexOf(prop) > 0 && this.isReact) this.isDynamicValueChanged = true;
            switch(prop){
                case "value":
                    this.isDynamicValueChanged = true;
                    this.invalidValueString = null;
                    this.checkInvalidValue(newProp.value);
                    newProp.value = this.value;
                    newProp.value = this.validateValue(newProp.value);
                    if (this.enableMask) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.maskedDateValue, this.inputElement, this.floatLabelType, this.showClearButton);
                    else (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.getFormattedValue(newProp.value), this.inputElement, this.floatLabelType, this.showClearButton);
                    this.valueWithMinutes = newProp.value;
                    this.setProperties({
                        value: newProp.value
                    }, true);
                    if (this.popupObj) this.popupUpdate();
                    this.previousDateTime = new Date(this.inputElement.value);
                    this.updateInput();
                    this.changeTrigger(null);
                    this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
                    if (this.enableMask && this.value) this.notify("createMask", {
                        module: "MaskedDateTime"
                    });
                    break;
                case "min":
                case "max":
                    this.getProperty(newProp, prop);
                    this.updateInput();
                    break;
                case "enableRtl":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(this.enableRtl, [
                        this.inputWrapper.container
                    ]);
                    break;
                case "cssClass":
                    if (!(0, $3EnZW.isNullOrUndefined)(oldProp.cssClass)) oldProp.cssClass = oldProp.cssClass.replace(/\s+/g, " ").trim();
                    if (!(0, $3EnZW.isNullOrUndefined)(newProp.cssClass)) newProp.cssClass = newProp.cssClass.replace(/\s+/g, " ").trim();
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newProp.cssClass, [
                        this.inputWrapper.container
                    ], oldProp.cssClass);
                    if (this.dateTimeWrapper) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(newProp.cssClass, [
                        this.dateTimeWrapper
                    ], oldProp.cssClass);
                    break;
                case "locale":
                    this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
                    this.l10n.setLocale(this.locale);
                    if (this.dateTimeOptions && this.dateTimeOptions.placeholder == null) {
                        this.setProperties({
                            placeholder: this.l10n.getConstant("placeholder")
                        }, true);
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.l10n.getConstant("placeholder"), this.inputElement);
                    }
                    this.dateTimeFormat = this.cldrDateTimeFormat();
                    _super.prototype.updateInput.call(this);
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttributeToElement();
                    this.updateHtmlAttributeToWrapper();
                    this.checkAttributes(true);
                    break;
                case "format":
                    this.setProperties({
                        format: newProp.format
                    }, true);
                    this.checkFormat();
                    this.dateTimeFormat = this.formatString;
                    this.setValue();
                    if (this.enableMask) {
                        this.notify("createMask", {
                            module: "MaskedDateTime"
                        });
                        if (!this.value) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.maskedDateValue, this.inputElement, this.floatLabelType, this.showClearButton);
                    }
                    break;
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(newProp.placeholder, this.inputElement);
                    break;
                case "enabled":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.inputElement);
                    if (this.enabled) this.inputElement.setAttribute("tabindex", this.tabIndex);
                    else this.inputElement.tabIndex = -1;
                    break;
                case "strictMode":
                    this.invalidValueString = null;
                    this.updateInput();
                    break;
                case "width":
                    this.setWidth(newProp.width);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.inputElement, this.inputWrapper.container);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-date-time-icon");
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.inputElement);
                    break;
                case "floatLabelType":
                    this.floatLabelType = newProp.floatLabelType;
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.inputWrapper);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.inputElement, this.floatLabelType, this.placeholder);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.buttons[0]) && !(0, $3EnZW.isNullOrUndefined)(this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0]) && this.floatLabelType !== "Never") this.inputWrapper.container.getElementsByClassName("e-float-text-overflow")[0].classList.add("e-date-time-icon");
                    break;
                case "scrollTo":
                    if (this.checkDateValue(new Date(this.checkValue(newProp.scrollTo)))) {
                        if (this.dateTimeWrapper) this.setScrollTo();
                        this.setProperties({
                            scrollTo: this.checkDateValue(new Date(this.checkValue(newProp.scrollTo)))
                        }, true);
                    } else this.setProperties({
                        scrollTo: null
                    }, true);
                    break;
                case "enableMask":
                    if (this.enableMask) {
                        this.notify("createMask", {
                            module: "MaskedDateTime"
                        });
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.maskedDateValue, this.inputElement, this.floatLabelType, this.showClearButton);
                    } else if (this.inputElement.value === this.maskedDateValue) {
                        this.maskedDateValue = "";
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.maskedDateValue, this.inputElement, this.floatLabelType, this.showClearButton);
                    }
                    break;
                default:
                    _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
                    break;
            }
            if (!this.isDynamicValueChanged) this.hide(null);
            this.isDynamicValueChanged = false;
        }
    };
    /**
     * To get component name.
     *
     * @returns {string} Returns the component name.
     * @private
     */ DateTimePicker.prototype.getModuleName = function() {
        return "datetimepicker";
    };
    DateTimePicker.prototype.restoreValue = function() {
        this.previousDateTime = this.previousDate;
        this.currentDate = this.value ? this.value : new Date();
        this.valueWithMinutes = this.value;
        this.previousDate = this.value;
        this.previousElementValue = this.previousElementValue = (0, $3EnZW.isNullOrUndefined)(this.inputValueCopy) ? "" : this.getFormattedValue(this.inputValueCopy);
    };
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "timeFormat", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(30)
    ], DateTimePicker.prototype, "step", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "scrollTo", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], DateTimePicker.prototype, "zIndex", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "value", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "keyConfigs", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)({})
    ], DateTimePicker.prototype, "htmlAttributes", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "enablePersistence", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DateTimePicker.prototype, "allowEdit", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "isMultiSelection", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "values", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DateTimePicker.prototype, "showClearButton", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "placeholder", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "strictMode", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "fullScreenMode", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "serverTimezoneOffset", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(new Date(1900, 0, 1))
    ], DateTimePicker.prototype, "min", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(new Date(2099, 11, 31))
    ], DateTimePicker.prototype, "max", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "minTime", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "maxTime", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DateTimePicker.prototype, "firstDayOfWeek", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)("Gregorian")
    ], DateTimePicker.prototype, "calendarMode", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)("Month")
    ], DateTimePicker.prototype, "start", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)("Month")
    ], DateTimePicker.prototype, "depth", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "weekNumber", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DateTimePicker.prototype, "showTodayButton", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)("Short")
    ], DateTimePicker.prototype, "dayHeaderFormat", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "openOnFocus", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DateTimePicker.prototype, "enableMask", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Property)({
            day: "day",
            month: "month",
            year: "year",
            hour: "hour",
            minute: "minute",
            second: "second",
            dayOfTheWeek: "day of the week"
        })
    ], DateTimePicker.prototype, "maskPlaceholder", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "open", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "close", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "cleared", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "blur", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "focus", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "created", void 0);
    $3812471840bc0638$var$__decorate([
        (0, $5rsSz.Event)()
    ], DateTimePicker.prototype, "destroyed", void 0);
    DateTimePicker = $3812471840bc0638$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], DateTimePicker);
    return DateTimePicker;
}((0, $d5f6934cad42758d$export$5109c6dd95d8fb00));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



/**
 * `datefilterui` render date column.
 *
 * @hidden
 */ var $2f06dd4a619af880$export$7772ea698de4df2e = /** @class */ function() {
    function DateFilterUI(parent, serviceLocator, filterSettings) {
        this.dpOpen = this.openPopup.bind(this);
        this.parent = parent;
        this.locator = serviceLocator;
        this.fltrSettings = filterSettings;
        if (this.parent) {
            this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy, this);
            this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        }
    }
    DateFilterUI.prototype.create = function(args) {
        var format = (0, $748c2240e597a9b7$export$cd23debbf9725d)(args.column.format, args.column.type);
        this.dialogObj = args.dialogObj;
        this.inputElem = this.parent.createElement("input", {
            className: "e-flmenu-input",
            id: "dateui-" + args.column.uid
        });
        args.target.appendChild(this.inputElem);
        if (args.column.type === "date" || args.column.type === "dateonly") this.datePickerObj = new (0, $d5f6934cad42758d$export$5109c6dd95d8fb00)((0, $3EnZW.extend)({
            format: format,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            placeholder: args.localizeText.getConstant("ChooseDate"),
            width: "100%",
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl
        }, args.column.filter.params));
        else if (args.column.type === "datetime") this.datePickerObj = new (0, $3812471840bc0638$export$ccdfd7928785632e)((0, $3EnZW.extend)({
            format: format,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            placeholder: args.localizeText.getConstant("ChooseDate"),
            width: "100%",
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl
        }, args.column.filter.params));
        this.datePickerObj.addEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.dpOpen);
        this.datePickerObj.appendTo(this.inputElem);
    };
    DateFilterUI.prototype.write = function(args) {
        var dateuiObj = document.querySelector("#dateui-" + args.column.uid).ej2_instances[0];
        dateuiObj.value = !(0, $3EnZW.isNullOrUndefined)(args.filteredValue) ? new Date(args.filteredValue) : null;
    };
    DateFilterUI.prototype.read = function(element, column, filterOptr, filterObj) {
        var dateuiObj = document.querySelector("#dateui-" + column.uid).ej2_instances[0];
        var filterValue = dateuiObj.value;
        filterValue = (0, $3EnZW.isNullOrUndefined)(filterValue) ? null : filterValue;
        filterObj.filterByColumn(column.field, filterOptr, filterValue, "and", true);
    };
    DateFilterUI.prototype.openPopup = function(args) {
        args.popup.element.style.zIndex = (this.dialogObj.zIndex + 1).toString();
    };
    DateFilterUI.prototype.destroy = function() {
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        if ((0, $3EnZW.isNullOrUndefined)(this.datePickerObj) || this.datePickerObj.isDestroyed) return;
        this.datePickerObj.removeEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.dpOpen);
        this.datePickerObj.destroy();
    };
    return DateFilterUI;
}();





/**
 * `filter menu` render boolean column.
 *
 * @hidden
 */ var $f02efb0a243e5b6e$export$1a0e2f3e930f82cb = /** @class */ function() {
    function FilterMenuRenderer(parent, filterSettings, serviceLocator, customFltrOperators, fltrObj) {
        this.isDialogOpen = false;
        this.maxHeight = "350px";
        this.isMenuCheck = false;
        this.colTypes = {
            "string": (0, $a54cca84c1c45646$export$ddd9b05a64438cbf),
            "number": (0, $b46d0bdbed85f2ce$export$71f5da6d9d2d9db9),
            "date": (0, $2f06dd4a619af880$export$7772ea698de4df2e),
            "dateonly": (0, $2f06dd4a619af880$export$7772ea698de4df2e),
            "boolean": (0, $5b9495c82ec39fe5$export$451b20ccd6968eec),
            "datetime": (0, $2f06dd4a619af880$export$7772ea698de4df2e)
        };
        this.parent = parent;
        this.filterSettings = filterSettings;
        this.serviceLocator = serviceLocator;
        this.customFilterOperators = customFltrOperators;
        this.filterObj = fltrObj;
        this.flMuiObj = new (0, $b2864fc08e9bdf97$export$f2c2f59e9901ed10)(this.parent, this.customFilterOperators, this.serviceLocator);
        this.l10n = this.serviceLocator.getService("localization");
        this.menuFilterBase = new (0, $66db5ede9cdf4d76$export$325f55b6c744802a)(parent);
    }
    FilterMenuRenderer.prototype.clearCustomFilter = function(col) {
        this.clearBtnClick(col);
    };
    FilterMenuRenderer.prototype.applyCustomFilter = function(args) {
        this.filterBtnClick(args.col);
    };
    FilterMenuRenderer.prototype.openDialog = function(args) {
        this.options = args;
        this.col = this.parent.getColumnByField(args.field);
        if ((0, $3EnZW.isNullOrUndefined)(this.col.filter) || (0, $3EnZW.isNullOrUndefined)(this.col.filter.type) || this.col.filter.type === "Menu") this.renderDlgContent(args.target, this.col);
    };
    FilterMenuRenderer.prototype.closeDialog = function(target) {
        var _this = this;
        if (!this.dlgObj) return;
        var elem = document.getElementById(this.dlgObj.element.id);
        if (this.dlgObj && !this.dlgObj.isDestroyed && elem) {
            var argument = {
                cancel: false,
                column: this.col,
                target: target,
                element: elem
            };
            this.parent.notify($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, argument);
            if (argument.cancel) return;
            this.isDialogOpen = false;
            if (this.isMenuCheck) {
                this.menuFilterBase.unWireEvents();
                this.parent.off($17b89d3b1fc93cdb$export$75dd3538f0f880b3, this.actionComplete);
                this.isMenuCheck = false;
            }
            if ((this.parent.isReact || this.parent.isVue) && this.col.filterTemplate && this.col.filterTemplate instanceof Function) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.parent.clearTemplate([
                "filterTemplate"
            ], undefined, function() {
                _this.dlgObj.destroy();
            });
            else {
                this.dlgObj.destroy();
                (0, $4ZDHT.remove)(elem);
            }
        }
        this.parent.notify($17b89d3b1fc93cdb$export$2542708340471a26, {});
    };
    FilterMenuRenderer.prototype.renderDlgContent = function(target, column) {
        var args = {
            requestType: $17b89d3b1fc93cdb$export$a23907baab3479c2,
            columnName: column.field,
            columnType: column.type
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        this.parent.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, args);
        var mainDiv = this.parent.createElement("div", {
            className: "e-flmenu-maindiv",
            id: column.uid + "-flmenu"
        });
        this.dlgDiv = this.parent.createElement("div", {
            className: "e-flmenu",
            id: column.uid + "-flmdlg"
        });
        this.dlgDiv.setAttribute("aria-label", this.l10n.getConstant("FilterMenuDialogARIA"));
        if (this.parent.enableAdaptiveUI) {
            var responsiveCnt = document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv");
            responsiveCnt.appendChild(this.dlgDiv);
        } else this.parent.element.appendChild(this.dlgDiv);
        this.dlgObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            showCloseIcon: false,
            closeOnEscape: false,
            locale: this.parent.locale,
            visible: false,
            enableRtl: this.parent.enableRtl,
            created: this.dialogCreated.bind(this, target, column),
            position: this.parent.element.classList.contains("e-device") ? {
                X: "center",
                Y: "center"
            } : {
                X: "",
                Y: ""
            },
            target: this.parent.element.classList.contains("e-device") ? document.body : this.parent.element,
            buttons: [
                {
                    click: this.filterBtnClick.bind(this, column),
                    buttonModel: {
                        content: this.l10n.getConstant("FilterButton"),
                        isPrimary: true,
                        cssClass: this.parent.cssClass ? "e-flmenu-okbtn " + this.parent.cssClass : "e-flmenu-okbtn"
                    }
                },
                {
                    click: this.clearBtnClick.bind(this, column),
                    buttonModel: {
                        content: this.l10n.getConstant("ClearButton"),
                        cssClass: this.parent.cssClass ? "e-flmenu-cancelbtn " + this.parent.cssClass : "e-flmenu-cancelbtn"
                    }
                }
            ],
            content: mainDiv,
            width: !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-bigger")) || this.parent.element.classList.contains("e-device") ? 260 : 250,
            animationSettings: {
                effect: "None"
            },
            cssClass: this.parent.cssClass ? "e-filter-popup " + this.parent.cssClass : "e-filter-popup"
        });
        var isStringTemplate = "isStringTemplate";
        this.dlgObj["" + isStringTemplate] = true;
        this.renderResponsiveDialog();
        this.dlgObj.appendTo(this.dlgDiv);
    };
    FilterMenuRenderer.prototype.renderResponsiveDialog = function() {
        var gObj = this.parent;
        if (gObj.enableAdaptiveUI) {
            this.dlgObj.position = {
                X: "",
                Y: ""
            };
            this.dlgObj.target = document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv");
            this.dlgObj.width = "100%";
            this.dlgObj.isModal = false;
            this.dlgObj.buttons = [
                {}
            ];
        }
    };
    FilterMenuRenderer.prototype.dialogCreated = function(target, column) {
        if (!(0, $5q7BP.Browser).isDevice && target) (0, $748c2240e597a9b7$export$2b9ad9396c9b6e69)(target, this.dlgObj);
        this.currentDialogCreatedColumn = column;
        this.renderFilterUI(target, column);
        if (!(column.isForeignColumn() && !(!(0, $3EnZW.isNullOrUndefined)(column.filter) && !(0, $3EnZW.isNullOrUndefined)(column.filter.ui) && !(0, $3EnZW.isNullOrUndefined)(column.filter.ui.create)))) this.afterRenderFilterUI();
        var isReactCompiler = this.parent.isReact && typeof column.filterTemplate !== "string";
        var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
        if (!(0, $3EnZW.isNullOrUndefined)(column.filterTemplate) && !(isReactCompiler || isReactChild)) {
            this.dlgDiv.querySelector(".e-flmenu-valuediv").firstElementChild.focus();
            this.dlgDiv.querySelector(".e-flmenu-valuediv").firstElementChild.classList.add("e-input-focus");
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.dlgDiv.querySelector(".e-flmenu-input"))) {
            this.dlgDiv.querySelector(".e-flmenu-input").focus();
            this.dlgDiv.querySelector(".e-flmenu-input").parentElement.classList.add("e-input-focus");
        }
    };
    /**
     * Function to notify filterDialogCreated and trigger actionComplete
     *
     * @returns {void}
     * @hidden
     */ FilterMenuRenderer.prototype.afterRenderFilterUI = function() {
        var column = this.currentDialogCreatedColumn;
        if (column.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$4cc1ec161750f031, {});
        if (this.parent.enableAdaptiveUI) {
            this.dlgObj.element.style.left = "0px";
            this.dlgObj.element.style.maxHeight = "none";
        } else this.dlgObj.element.style.maxHeight = this.maxHeight;
        this.dlgObj.show();
        if (this.parent.getContent().firstElementChild.offsetHeight < this.dlgObj.element.offsetHeight) (0, $748c2240e597a9b7$export$35819a1a44286094)(this.parent, this.dlgObj);
        var optrInput = this.dlgObj.element.querySelector(".e-flm_optrdiv").querySelector("input");
        var valInput = this.dlgObj.element.querySelector(".e-flmenu-valuediv").querySelector("input");
        if (optrInput.value === "Empty" || optrInput.value === "Not Empty" || optrInput.value === "Null" || optrInput.value === "Not Null") {
            if (!(0, $3EnZW.isNullOrUndefined)(valInput["ej2_instances"])) valInput["ej2_instances"][0]["enabled"] = false;
            else valInput.setAttribute("disabled", "true");
        } else if (!(0, $3EnZW.isNullOrUndefined)(valInput && valInput.getAttribute("disabled"))) {
            if (!(0, $3EnZW.isNullOrUndefined)(valInput["ej2_instances"])) valInput["ej2_instances"][0]["enabled"] = true;
            else valInput.removeAttribute("disabled");
        }
        if (!column.filterTemplate) this.writeMethod(column, this.dlgObj.element.querySelector("#" + column.uid + "-flmenu"));
        var args = {
            requestType: $17b89d3b1fc93cdb$export$cd06942d33b49aad,
            columnName: column.field,
            columnType: column.type
        };
        var filterModel = "filterModel";
        args["" + filterModel] = this;
        this.isDialogOpen = true;
        if (!this.isMenuCheck) this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, args);
    };
    FilterMenuRenderer.prototype.renderFilterUI = function(target, col) {
        var dlgConetntEle = this.dlgObj.element.querySelector(".e-flmenu-maindiv");
        this.parent.log("column_type_missing", {
            column: col
        });
        this.renderOperatorUI(dlgConetntEle, target, col);
        this.renderFlValueUI(dlgConetntEle, target, col);
    };
    FilterMenuRenderer.prototype.renderOperatorUI = function(dlgConetntEle, target, column) {
        this.flMuiObj.renderOperatorUI(dlgConetntEle, target, column, this.dlgObj, this.filterObj.menuOperator);
    };
    FilterMenuRenderer.prototype.renderFlValueUI = function(dlgConetntEle, target, column) {
        var valueDiv = this.parent.createElement("div", {
            className: "e-flmenu-valuediv"
        });
        var fObj = this.filterObj;
        dlgConetntEle.appendChild(valueDiv);
        var instanceofFilterUI = new this.colTypes[column.type](this.parent, this.serviceLocator, this.parent.filterSettings);
        if (column.filterTemplate) {
            var fltrData = {};
            var valueInString = "value";
            fltrData[column.field] = fltrData["" + valueInString] = fObj.values[column.field];
            if (column.foreignKeyValue) {
                fltrData[column.foreignKeyValue] = fObj.values[column.field];
                fltrData[column.field] = undefined;
            }
            var col = "column";
            fltrData["" + col] = column;
            var isReactCompiler = this.parent.isReact && typeof column.filterTemplate !== "string";
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isReact;
            var tempID = this.parent.element.id + column.uid + "filterTemplate";
            if (isReactCompiler || isReactChild) {
                column.getFilterTemplate()(fltrData, this.parent, "filterTemplate", tempID, null, null, valueDiv);
                this.parent.renderTemplates();
            } else {
                var compElement = column.getFilterTemplate()(fltrData, this.parent, "filterTemplate", tempID, null, null, null, this.parent.root);
                (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(valueDiv, compElement);
            }
            if (this.isMenuCheck) {
                this.menuFilterBase.cBox = this.dlgObj.element.querySelector(".e-checkboxlist.e-fields");
                this.menuFilterBase.wireEvents();
                this.parent.on($17b89d3b1fc93cdb$export$75dd3538f0f880b3, this.actionComplete, this);
                this.menuFilterBase.getAllData();
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(column.filter) && !(0, $3EnZW.isNullOrUndefined)(column.filter.ui) && !(0, $3EnZW.isNullOrUndefined)(column.filter.ui.create)) {
            var temp = column.filter.ui.create;
            if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
            temp({
                column: column,
                target: valueDiv,
                getOptrInstance: this.flMuiObj,
                dialogObj: this.dlgObj
            });
        } else instanceofFilterUI.create({
            column: column,
            target: valueDiv,
            getOptrInstance: this.flMuiObj,
            localizeText: this.l10n,
            dialogObj: this.dlgObj
        });
    };
    FilterMenuRenderer.prototype.writeMethod = function(col, dlgContentEle) {
        var flValue;
        var target = dlgContentEle.querySelector(".e-flmenu-valinput");
        var instanceofFilterUI = new this.colTypes[col.type](this.parent, this.serviceLocator, this.parent.filterSettings);
        var columns = this.filterSettings.columns;
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var column = columns_1[_i];
            if (col.uid === column.uid) flValue = column.value;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(col.filter) && !(0, $3EnZW.isNullOrUndefined)(col.filter.ui) && !(0, $3EnZW.isNullOrUndefined)(col.filter.ui.write)) {
            var temp = col.filter.ui.write;
            if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
            temp({
                column: col,
                target: target,
                parent: this.parent,
                filteredValue: flValue
            });
        } else instanceofFilterUI.write({
            column: col,
            target: target,
            parent: this.parent,
            filteredValue: flValue
        });
    };
    FilterMenuRenderer.prototype.filterBtnClick = function(col) {
        var flValue;
        var targ = this.dlgObj.element.querySelector(".e-flmenu-valuediv input");
        var flOptrValue = this.flMuiObj.getFlOperator();
        var instanceofFilterUI = new this.colTypes[col.type](this.parent, this.serviceLocator, this.parent.filterSettings);
        if (col.filterTemplate) {
            var element = this.dlgDiv.querySelector(".e-flmenu-valuediv");
            var fltrValue = void 0;
            if (element.children[0].value) fltrValue = element.children[0].value;
            else if (!(0, $3EnZW.isNullOrUndefined)(element.children[0].ej2_instances)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fltrValue = (this.parent.isAngular ? element.children[0] : element.querySelector("input")).ej2_instances[0].value;
            else {
                var eControl = element.querySelector(".e-control");
                if (!(0, $3EnZW.isNullOrUndefined)(eControl)) fltrValue = col.type === "boolean" ? eControl.checked : !(0, $3EnZW.isNullOrUndefined)(eControl.ej2_instances) ? eControl.ej2_instances[0].value : eControl.value;
            }
            this.filterObj.filterByColumn(col.field, flOptrValue, fltrValue);
        } else if (!(0, $3EnZW.isNullOrUndefined)(col.filter) && !(0, $3EnZW.isNullOrUndefined)(col.filter.ui) && !(0, $3EnZW.isNullOrUndefined)(col.filter.ui.read)) {
            var temp = col.filter.ui.read;
            if (typeof temp === "string") temp = (0, $3EnZW.getValue)(temp, window);
            // eslint-disable-next-line
            flValue = temp({
                element: targ,
                column: col,
                operator: flOptrValue,
                fltrObj: this.filterObj
            });
        } else instanceofFilterUI.read(targ, col, flOptrValue, this.filterObj);
        this.closeDialog();
        if (this.parent.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$9c0eb2753b60aa09, {});
    };
    FilterMenuRenderer.prototype.closeResponsiveDialog = function() {
        this.closeDialog();
    };
    FilterMenuRenderer.prototype.clearBtnClick = function(column) {
        this.filterObj.removeFilteredColsByField(column.field);
        this.closeDialog();
    };
    FilterMenuRenderer.prototype.destroy = function() {
        this.closeDialog();
    };
    /**
     * @returns {FilterUI} returns the filterUI
     * @hidden
     */ FilterMenuRenderer.prototype.getFilterUIInfo = function() {
        return {
            field: this.col.field,
            operator: this.flMuiObj.getFlOperator()
        };
    };
    FilterMenuRenderer.prototype.renderCheckBoxMenu = function() {
        this.isMenuCheck = true;
        this.menuFilterBase.updateModel(this.options);
        this.menuFilterBase.getAndSetChkElem(this.options);
        this.dlgObj.buttons = [
            {
                click: this.menuFilterBase.btnClick.bind(this.menuFilterBase),
                buttonModel: {
                    content: this.menuFilterBase.getLocalizedLabel("FilterButton"),
                    cssClass: "e-primary",
                    isPrimary: true
                }
            },
            {
                click: this.menuFilterBase.btnClick.bind(this.menuFilterBase),
                buttonModel: {
                    cssClass: "e-flat",
                    content: this.menuFilterBase.getLocalizedLabel("ClearButton")
                }
            }
        ];
        this.menuFilterBase.dialogObj = this.dlgObj;
        this.menuFilterBase.dlg = this.dlgObj.element;
        this.menuFilterBase.dlg.classList.add("e-menucheckbox");
        this.menuFilterBase.dlg.classList.remove("e-checkboxfilter");
        this.maxHeight = "800px";
        return this.menuFilterBase.sBox.innerHTML;
    };
    FilterMenuRenderer.prototype.actionComplete = function(args) {
        if (this.isMenuCheck) this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, args);
    };
    return FilterMenuRenderer;
}();





/**
 * @hidden
 * `CheckBoxFilter` module is used to handle filtering action.
 */ var $99474349aa277ec7$export$b75a66120a90a757 = /** @class */ function() {
    /**
     * Constructor for checkbox filtering module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {FilterSettings} filterSettings - specifies the filtersettings
     * @param {ServiceLocator} serviceLocator - specifies the ServiceLocator
     * @hidden
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function CheckBoxFilter(parent, filterSettings, serviceLocator) {
        this.parent = parent;
        this.isresetFocus = true;
        this.checkBoxBase = new (0, $66db5ede9cdf4d76$export$325f55b6c744802a)(parent);
        this.addEventListener();
    }
    /**
     * To destroy the check box filter.
     *
     * @returns {void}
     * @hidden
     */ CheckBoxFilter.prototype.destroy = function() {
        this.removeEventListener();
        this.checkBoxBase.closeDialog();
    };
    CheckBoxFilter.prototype.openDialog = function(options) {
        this.checkBoxBase.openDialog(options);
        this.parent.log("column_type_missing", {
            column: options.column
        });
    };
    CheckBoxFilter.prototype.closeDialog = function() {
        this.destroy();
        if (this.isresetFocus) this.parent.notify($17b89d3b1fc93cdb$export$2284e449d64b22d5, {});
    };
    CheckBoxFilter.prototype.closeResponsiveDialog = function() {
        this.checkBoxBase.closeDialog();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the module name
     * @private
     */ CheckBoxFilter.prototype.getModuleName = function() {
        return "checkboxFilter";
    };
    CheckBoxFilter.prototype.actionBegin = function(args) {
        this.parent.trigger($17b89d3b1fc93cdb$export$df204737a6131aab, args);
    };
    CheckBoxFilter.prototype.actionComplete = function(args) {
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, args);
    };
    CheckBoxFilter.prototype.actionPrevent = function(args) {
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(this.parent)) {
            this.parent.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, args);
            args.cancel = true;
        }
    };
    CheckBoxFilter.prototype.clearCustomFilter = function(col) {
        this.checkBoxBase.clearFilter(col);
    };
    CheckBoxFilter.prototype.applyCustomFilter = function() {
        this.checkBoxBase.fltrBtnHandler();
        this.checkBoxBase.closeDialog();
    };
    CheckBoxFilter.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$5d169c634b93365b, this.actionBegin, this);
        this.parent.on($17b89d3b1fc93cdb$export$75dd3538f0f880b3, this.actionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$16e6cefe38bdd512, this.actionPrevent, this);
    };
    CheckBoxFilter.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$5d169c634b93365b, this.actionBegin);
        this.parent.off($17b89d3b1fc93cdb$export$75dd3538f0f880b3, this.actionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$16e6cefe38bdd512, this.actionPrevent);
    };
    return CheckBoxFilter;
}();


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");




parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");
var $3P3ke = parcelRequire("3P3ke");

var $1c7c93589ae50f14$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1c7c93589ae50f14$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1c7c93589ae50f14$var$CHECK = "e-check";
var $1c7c93589ae50f14$var$DISABLED = "e-checkbox-disabled";
var $1c7c93589ae50f14$var$FRAME = "e-frame";
var $1c7c93589ae50f14$var$INDETERMINATE = "e-stop";
var $1c7c93589ae50f14$var$LABEL = "e-label";
var $1c7c93589ae50f14$var$RIPPLE = "e-ripple-container";
var $1c7c93589ae50f14$var$RIPPLECHECK = "e-ripple-check";
var $1c7c93589ae50f14$var$RIPPLEINDETERMINATE = "e-ripple-stop";
var $1c7c93589ae50f14$var$RTL = "e-rtl";
var $1c7c93589ae50f14$var$WRAPPER = "e-checkbox-wrapper";
var $1c7c93589ae50f14$var$containerAttr = [
    "title",
    "class",
    "style",
    "disabled",
    "readonly",
    "name",
    "value",
    "id",
    "tabindex",
    "aria-label",
    "required"
];
/**
 * The CheckBox is a graphical user interface element that allows you to select one or more options from the choices.
 * It contains checked, unchecked, and indeterminate states.
 * ```html
 * <input type="checkbox" id="checkbox"/>
 * <script>
 * var checkboxObj = new CheckBox({ label: "Default" });
 * checkboxObj.appendTo("#checkbox");
 * </script>
 * ```
 */ var $1c7c93589ae50f14$export$ea5f704b89d806f6 = /** @class */ function(_super) {
    $1c7c93589ae50f14$var$__extends(CheckBox, _super);
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {CheckBoxModel} options - Specifies checkbox model
     * @param {string | HTMLInputElement} element - Specifies target element
     */ function CheckBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        _this.isMouseClick = false;
        _this.clickTriggered = false;
        _this.validCheck = true;
        _this.type = "checkbox";
        return _this;
    }
    CheckBox.prototype.changeState = function(state, isInitialize, isInterAction) {
        var wrapper = this.getWrapper();
        var rippleSpan = null;
        var frameSpan = null;
        if (wrapper) {
            frameSpan = wrapper.getElementsByClassName($1c7c93589ae50f14$var$FRAME)[0];
            if (0, $kj1BR.isRippleEnabled) rippleSpan = wrapper.getElementsByClassName($1c7c93589ae50f14$var$RIPPLE)[0];
        }
        if (state === "check") {
            if (frameSpan) {
                frameSpan.classList.remove($1c7c93589ae50f14$var$INDETERMINATE);
                frameSpan.classList.add($1c7c93589ae50f14$var$CHECK);
            }
            if (rippleSpan) {
                rippleSpan.classList.remove($1c7c93589ae50f14$var$RIPPLEINDETERMINATE);
                rippleSpan.classList.add($1c7c93589ae50f14$var$RIPPLECHECK);
            }
            this.element.checked = true;
            if ((this.element.required || (0, $4ZDHT.closest)(this.element, "form") && (0, $4ZDHT.closest)(this.element, "form").classList.contains("e-formvalidator")) && this.validCheck && !isInitialize && isInterAction) {
                this.element.checked = false;
                this.validCheck = false;
            } else if (this.element.required || (0, $4ZDHT.closest)(this.element, "form") && (0, $4ZDHT.closest)(this.element, "form").classList.contains("e-formvalidator")) this.validCheck = true;
        } else if (state === "uncheck") {
            if (frameSpan) (0, $4ZDHT.removeClass)([
                frameSpan
            ], [
                $1c7c93589ae50f14$var$CHECK,
                $1c7c93589ae50f14$var$INDETERMINATE
            ]);
            if (rippleSpan) (0, $4ZDHT.removeClass)([
                rippleSpan
            ], [
                $1c7c93589ae50f14$var$RIPPLECHECK,
                $1c7c93589ae50f14$var$RIPPLEINDETERMINATE
            ]);
            this.element.checked = false;
            if ((this.element.required || (0, $4ZDHT.closest)(this.element, "form") && (0, $4ZDHT.closest)(this.element, "form").classList.contains("e-formvalidator")) && this.validCheck && !isInitialize && isInterAction) {
                this.element.checked = true;
                this.validCheck = false;
            } else if (this.element.required || (0, $4ZDHT.closest)(this.element, "form") && (0, $4ZDHT.closest)(this.element, "form").classList.contains("e-formvalidator")) this.validCheck = true;
        } else {
            if (frameSpan) {
                frameSpan.classList.remove($1c7c93589ae50f14$var$CHECK);
                frameSpan.classList.add($1c7c93589ae50f14$var$INDETERMINATE);
            }
            if (rippleSpan) {
                rippleSpan.classList.remove($1c7c93589ae50f14$var$RIPPLECHECK);
                rippleSpan.classList.add($1c7c93589ae50f14$var$RIPPLEINDETERMINATE);
            }
            this.element.indeterminate = true;
            this.indeterminate = true;
        }
    };
    CheckBox.prototype.clickHandler = function(event) {
        if (event.target.tagName === "INPUT" && this.clickTriggered) {
            this.clickTriggered = false;
            return;
        }
        if (event.target.tagName === "SPAN" || event.target.tagName === "LABEL" || (0, $4ZDHT.closest)(event.target, ".e-label")) this.clickTriggered = true;
        if (this.isMouseClick) {
            this.focusOutHandler();
            this.isMouseClick = false;
        }
        if (this.indeterminate) {
            this.changeState(this.checked ? "check" : "uncheck", false, true);
            this.indeterminate = false;
            this.element.indeterminate = false;
        } else if (this.checked) {
            this.changeState("uncheck", false, true);
            this.checked = false;
        } else {
            this.changeState("check", false, true);
            this.checked = true;
        }
        var changeEventArgs = {
            checked: this.updateVueArrayModel(false),
            event: event
        };
        this.trigger("change", changeEventArgs);
        event.stopPropagation();
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ CheckBox.prototype.destroy = function() {
        var _this = this;
        var wrapper = this.getWrapper();
        _super.prototype.destroy.call(this);
        if (this.wrapper) {
            wrapper = this.wrapper;
            if (!this.disabled) this.unWireEvents();
            if (this.tagName === "INPUT") {
                if (this.getWrapper() && wrapper.parentNode) wrapper.parentNode.insertBefore(this.element, wrapper);
                (0, $4ZDHT.detach)(wrapper);
                this.element.checked = false;
                if (this.indeterminate) this.element.indeterminate = false;
                [
                    "name",
                    "value",
                    "disabled"
                ].forEach(function(key) {
                    _this.element.removeAttribute(key);
                });
            } else {
                [
                    "class"
                ].forEach(function(key) {
                    wrapper.removeAttribute(key);
                });
                wrapper.innerHTML = "";
                this.element = wrapper;
                if (this.refreshing) {
                    [
                        "e-control",
                        "e-checkbox",
                        "e-lib"
                    ].forEach(function(key) {
                        _this.element.classList.add(key);
                    });
                    (0, $3EnZW.setValue)("ej2_instances", [
                        this
                    ], this.element);
                }
            }
        }
    };
    CheckBox.prototype.focusHandler = function() {
        this.isFocused = true;
    };
    CheckBox.prototype.focusOutHandler = function() {
        var wrapper = this.getWrapper();
        if (wrapper) wrapper.classList.remove("e-focus");
        this.isFocused = false;
    };
    /**
     * Gets the module name.
     *
     * @private
     * @returns {string} - Module Name
     */ CheckBox.prototype.getModuleName = function() {
        return "checkbox";
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist Data
     */ CheckBox.prototype.getPersistData = function() {
        return this.addOnPersist([
            "checked",
            "indeterminate"
        ]);
    };
    CheckBox.prototype.getWrapper = function() {
        if (this.element && this.element.parentElement) return this.element.parentElement.parentElement;
        else return null;
    };
    CheckBox.prototype.getLabel = function() {
        if (this.element) return this.element.parentElement;
        else return null;
    };
    CheckBox.prototype.initialize = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.initialCheckedValue)) this.initialCheckedValue = this.checked;
        if (this.name) this.element.setAttribute("name", this.name);
        if (this.value) {
            this.element.setAttribute("value", this.value);
            if (this.isVue && typeof this.value === "boolean" && this.value === true) this.setProperties({
                "checked": true
            }, true);
        }
        if (this.checked) this.changeState("check", true);
        if (this.indeterminate) this.changeState();
        if (this.disabled) this.setDisabled();
    };
    CheckBox.prototype.initWrapper = function() {
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains($1c7c93589ae50f14$var$WRAPPER)) {
            wrapper = this.createElement("div", {
                className: $1c7c93589ae50f14$var$WRAPPER
            });
            if (this.element.parentNode) this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var label = this.createElement("label", {
            attrs: {
                for: this.element.id
            }
        });
        var frameSpan = this.createElement("span", {
            className: "e-icons " + $1c7c93589ae50f14$var$FRAME
        });
        wrapper.classList.add("e-wrapper");
        if (this.enableRtl) wrapper.classList.add($1c7c93589ae50f14$var$RTL);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        wrapper.appendChild(label);
        label.appendChild(this.element);
        (0, $6a51972c93f30c96$export$4692e7592464f3a2)(this, label);
        label.appendChild(frameSpan);
        if (0, $kj1BR.isRippleEnabled) {
            var rippleSpan = this.createElement("span", {
                className: $1c7c93589ae50f14$var$RIPPLE
            });
            if (this.labelPosition === "Before") label.appendChild(rippleSpan);
            else label.insertBefore(rippleSpan, frameSpan);
            (0, $kj1BR.rippleEffect)(rippleSpan, {
                duration: 400,
                isCenterRipple: true
            });
        }
        if (this.label) this.setText(this.label);
    };
    CheckBox.prototype.keyUpHandler = function() {
        if (this.isFocused) this.getWrapper().classList.add("e-focus");
    };
    CheckBox.prototype.labelMouseDownHandler = function(e) {
        this.isMouseClick = true;
        var rippleSpan = this.getWrapper().getElementsByClassName($1c7c93589ae50f14$var$RIPPLE)[0];
        (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
    };
    CheckBox.prototype.labelMouseLeaveHandler = function(e) {
        var rippleSpan = this.getLabel().getElementsByClassName($1c7c93589ae50f14$var$RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll(".e-ripple-element");
            for(var i = rippleElem.length - 1; i > 0; i--)rippleSpan.removeChild(rippleSpan.childNodes[i]);
            (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        }
    };
    CheckBox.prototype.labelMouseUpHandler = function(e) {
        this.isMouseClick = true;
        var rippleSpan = this.getWrapper().getElementsByClassName($1c7c93589ae50f14$var$RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll(".e-ripple-element");
            for(var i = 0; i < rippleElem.length - 1; i++)rippleSpan.removeChild(rippleSpan.childNodes[i]);
            (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        }
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {CheckBoxModel} newProp - Specifies new Properties
     * @param {CheckBoxModel} oldProp - Specifies old Properties
     *
     * @returns {void}
     */ CheckBox.prototype.onPropertyChanged = function(newProp, oldProp) {
        var wrapper = this.getWrapper();
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "checked":
                    this.indeterminate = false;
                    this.element.indeterminate = false;
                    this.changeState(newProp.checked ? "check" : "uncheck");
                    break;
                case "indeterminate":
                    if (newProp.indeterminate) this.changeState();
                    else {
                        this.element.indeterminate = false;
                        this.changeState(this.checked ? "check" : "uncheck");
                    }
                    break;
                case "disabled":
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.wrapper = this.getWrapper();
                        this.unWireEvents();
                    } else {
                        this.element.disabled = false;
                        wrapper.classList.remove($1c7c93589ae50f14$var$DISABLED);
                        wrapper.setAttribute("aria-disabled", "false");
                        this.wireEvents();
                    }
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        wrapper
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        wrapper
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) wrapper.classList.add($1c7c93589ae50f14$var$RTL);
                    else wrapper.classList.remove($1c7c93589ae50f14$var$RTL);
                    break;
                case "label":
                    this.setText(newProp.label);
                    break;
                case "labelPosition":
                    var label = wrapper.getElementsByClassName($1c7c93589ae50f14$var$LABEL)[0];
                    var labelWrap = wrapper.getElementsByTagName("label")[0];
                    (0, $4ZDHT.detach)(label);
                    if (newProp.labelPosition === "After") labelWrap.appendChild(label);
                    else labelWrap.insertBefore(label, wrapper.getElementsByClassName($1c7c93589ae50f14$var$FRAME)[0]);
                    break;
                case "name":
                    this.element.setAttribute("name", newProp.name);
                    break;
                case "value":
                    if (this.isVue && typeof newProp.value === "object") break;
                    this.element.setAttribute("value", newProp.value);
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttributeToWrapper();
                    break;
            }
        }
    };
    /**
     * Initialize Angular, React and Unique ID support.
     *
     * @private
     * @returns {void}
     */ CheckBox.prototype.preRender = function() {
        var element = this.element;
        this.tagName = this.element.tagName;
        element = (0, $6a51972c93f30c96$export$fae3ac1fb6b5c37c)(this.createElement, "EJS-CHECKBOX", "checkbox", element, $1c7c93589ae50f14$var$WRAPPER, "checkbox");
        this.element = element;
        if (this.element.getAttribute("type") !== "checkbox") this.element.setAttribute("type", "checkbox");
        if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)("e-" + this.getModuleName());
    };
    /**
     * Initialize the control rendering.
     *
     * @private
     * @returns {void}
     */ CheckBox.prototype.render = function() {
        this.initWrapper();
        this.initialize();
        if (!this.disabled) this.wireEvents();
        this.updateHtmlAttributeToWrapper();
        this.updateVueArrayModel(true);
        this.renderComplete();
        this.wrapper = this.getWrapper();
    };
    CheckBox.prototype.setDisabled = function() {
        var wrapper = this.getWrapper();
        this.element.disabled = true;
        wrapper.classList.add($1c7c93589ae50f14$var$DISABLED);
        wrapper.setAttribute("aria-disabled", "true");
    };
    CheckBox.prototype.setText = function(text) {
        var wrapper = this.getWrapper();
        if (!wrapper) return;
        var label = wrapper.getElementsByClassName($1c7c93589ae50f14$var$LABEL)[0];
        if (label) label.innerHTML = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(text) : text;
        else {
            text = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(text) : text;
            label = this.createElement("span", {
                className: $1c7c93589ae50f14$var$LABEL,
                innerHTML: text
            });
            var labelWrap = wrapper.getElementsByTagName("label")[0];
            if (this.labelPosition === "Before") labelWrap.insertBefore(label, wrapper.getElementsByClassName($1c7c93589ae50f14$var$FRAME)[0]);
            else labelWrap.appendChild(label);
        }
    };
    CheckBox.prototype.changeHandler = function(e) {
        e.stopPropagation();
    };
    CheckBox.prototype.formResetHandler = function() {
        this.checked = this.initialCheckedValue;
        this.element.checked = this.initialCheckedValue;
    };
    CheckBox.prototype.unWireEvents = function() {
        var wrapper = this.wrapper;
        (0, $aqzbR.EventHandler).remove(wrapper, "click", this.clickHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keyup", this.keyUpHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focus", this.focusHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.focusOutHandler);
        var label = wrapper.getElementsByTagName("label")[0];
        if (label) {
            (0, $aqzbR.EventHandler).remove(label, "mousedown", this.labelMouseDownHandler);
            (0, $aqzbR.EventHandler).remove(label, "mouseup", this.labelMouseUpHandler);
            (0, $aqzbR.EventHandler).remove(label, "mouseleave", this.labelMouseLeaveHandler);
        }
        var formElem = (0, $4ZDHT.closest)(this.element, "form");
        if (formElem) (0, $aqzbR.EventHandler).remove(formElem, "reset", this.formResetHandler);
        if (this.tagName === "EJS-CHECKBOX") (0, $aqzbR.EventHandler).remove(this.element, "change", this.changeHandler);
    };
    CheckBox.prototype.wireEvents = function() {
        var wrapper = this.getWrapper();
        (0, $aqzbR.EventHandler).add(wrapper, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keyup", this.keyUpHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focus", this.focusHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.focusOutHandler, this);
        var label = wrapper.getElementsByTagName("label")[0];
        (0, $aqzbR.EventHandler).add(label, "mousedown", this.labelMouseDownHandler, this);
        (0, $aqzbR.EventHandler).add(label, "mouseup", this.labelMouseUpHandler, this);
        (0, $aqzbR.EventHandler).add(label, "mouseleave", this.labelMouseLeaveHandler, this);
        var formElem = (0, $4ZDHT.closest)(this.element, "form");
        if (formElem) (0, $aqzbR.EventHandler).add(formElem, "reset", this.formResetHandler, this);
        if (this.tagName === "EJS-CHECKBOX") (0, $aqzbR.EventHandler).add(this.element, "change", this.changeHandler, this);
    };
    CheckBox.prototype.updateVueArrayModel = function(init) {
        if (this.isVue && typeof this.value === "object") {
            var value = this.element.value;
            if (value && this.value) {
                if (init) {
                    for(var i = 0; i < this.value.length; i++)if (value === this.value[i]) {
                        this.changeState("check");
                        this.setProperties({
                            "checked": true
                        }, true);
                    }
                } else {
                    var index = this.value.indexOf(value);
                    if (this.checked) {
                        if (index < 0) this.value.push(value);
                    } else if (index > -1) this.value.splice(index, 1);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return this.value;
                }
            }
        }
        return this.validCheck ? this.element.checked : !this.element.checked;
    };
    CheckBox.prototype.updateHtmlAttributeToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            var wrapper = this.getWrapper();
            if ($1c7c93589ae50f14$var$containerAttr.indexOf(key) > -1) {
                if (key === "class") (0, $4ZDHT.addClass)([
                    wrapper
                ], this.htmlAttributes["" + key].split(" "));
                else if (key === "title") wrapper.setAttribute(key, this.htmlAttributes["" + key]);
                else if (key === "style") {
                    var frameSpan = this.getWrapper().getElementsByClassName($1c7c93589ae50f14$var$FRAME)[0];
                    frameSpan.setAttribute(key, this.htmlAttributes["" + key]);
                } else if (key === "disabled") {
                    if (this.htmlAttributes["" + key] === "true") this.setDisabled();
                    this.element.setAttribute(key, this.htmlAttributes["" + key]);
                } else this.element.setAttribute(key, this.htmlAttributes["" + key]);
            } else wrapper.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    /**
     * Click the CheckBox element
     * its native method
     *
     * @public
     * @returns {void}
     */ CheckBox.prototype.click = function() {
        this.element.click();
    };
    /**
     * Sets the focus to CheckBox
     * its native method
     *
     * @public
     * @returns {void}
     */ CheckBox.prototype.focusIn = function() {
        this.element.focus();
    };
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Event)()
    ], CheckBox.prototype, "change", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Event)()
    ], CheckBox.prototype, "created", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CheckBox.prototype, "checked", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CheckBox.prototype, "cssClass", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CheckBox.prototype, "disabled", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CheckBox.prototype, "indeterminate", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CheckBox.prototype, "label", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)("After")
    ], CheckBox.prototype, "labelPosition", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CheckBox.prototype, "name", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CheckBox.prototype, "value", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], CheckBox.prototype, "enableHtmlSanitizer", void 0);
    $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.Property)({})
    ], CheckBox.prototype, "htmlAttributes", void 0);
    CheckBox = $1c7c93589ae50f14$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], CheckBox);
    return CheckBox;
}((0, $hQxLN.Component));

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");
var $3P3ke = parcelRequire("3P3ke");

var $8828e72750329966$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8828e72750329966$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8828e72750329966$var$LABEL = "e-label";
var $8828e72750329966$var$RIPPLE = "e-ripple-container";
var $8828e72750329966$var$RTL = "e-rtl";
var $8828e72750329966$var$WRAPPER = "e-radio-wrapper";
var $8828e72750329966$var$ATTRIBUTES = [
    "title",
    "class",
    "style",
    "disabled",
    "readonly",
    "name",
    "value",
    "id"
];
/**
 * The RadioButton is a graphical user interface element that allows you to select one option from the choices.
 * It contains checked and unchecked states.
 * ```html
 * <input type="radio" id="radio"/>
 * <script>
 * var radioObj = new RadioButton({ label: "Default" });
 * radioObj.appendTo("#radio");
 * </script>
 * ```
 */ var $8828e72750329966$export$f4422ae58352e179 = /** @class */ function(_super) {
    $8828e72750329966$var$__extends(RadioButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {RadioButtonModel} options - Specifies Radio button model
     * @param {string | HTMLInputElement} element - Specifies target element
     */ function RadioButton(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        _this.type = "radio";
        return _this;
    }
    RadioButton_1 = RadioButton;
    RadioButton.prototype.changeHandler = function(event) {
        this.checked = true;
        this.dataBind();
        var value = this.element.getAttribute("value");
        value = this.isVue && value ? this.element.value : this.value;
        var type = typeof this.value;
        if (this.isVue && type === "boolean") value = value === "true" ? true : false;
        this.trigger("change", {
            value: value,
            event: event
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isAngular) event.stopPropagation();
    };
    RadioButton.prototype.updateChange = function() {
        var input;
        var instance;
        var radioGrp = this.getRadioGroup();
        for(var i = 0; i < radioGrp.length; i++){
            input = radioGrp[i];
            if (input !== this.element) {
                instance = (0, $3EnZW.getInstance)(input, RadioButton_1);
                instance.checked = false;
                if (this.tagName === "EJS-RADIOBUTTON") instance.angularValue = this.value;
            }
        }
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ RadioButton.prototype.destroy = function() {
        var _this = this;
        var radioWrap = this.wrapper;
        _super.prototype.destroy.call(this);
        if (radioWrap) {
            if (!this.disabled) this.unWireEvents();
            if (this.tagName === "INPUT") {
                if (radioWrap.parentNode) radioWrap.parentNode.insertBefore(this.element, radioWrap);
                (0, $4ZDHT.detach)(radioWrap);
                this.element.checked = false;
                [
                    "name",
                    "value",
                    "disabled"
                ].forEach(function(key) {
                    _this.element.removeAttribute(key);
                });
            } else {
                [
                    "role",
                    "aria-checked",
                    "class"
                ].forEach(function(key) {
                    radioWrap.removeAttribute(key);
                });
                radioWrap.innerHTML = "";
                this.element = this.wrapper;
                if (this.refreshing) {
                    [
                        "e-control",
                        "e-radio",
                        "e-lib"
                    ].forEach(function(key) {
                        _this.element.classList.add(key);
                    });
                    (0, $3EnZW.setValue)("ej2_instances", [
                        this
                    ], this.element);
                }
            }
        }
    };
    RadioButton.prototype.focusHandler = function() {
        this.isFocused = true;
    };
    RadioButton.prototype.focusOutHandler = function() {
        var label = this.getLabel();
        if (label) label.classList.remove("e-focus");
    };
    RadioButton.prototype.getModuleName = function() {
        return "radio";
    };
    /**
     * To get the value of selected radio button in a group.
     *
     * @method getSelectedValue
     * @returns {string} - Selected Value
     */ RadioButton.prototype.getSelectedValue = function() {
        var input;
        var radioGrp = this.getRadioGroup();
        for(var i = 0, len = radioGrp.length; i < len; i++){
            input = radioGrp[i];
            if (input.checked) return input.value;
        }
        return "";
    };
    RadioButton.prototype.getRadioGroup = function() {
        return document.querySelectorAll('input.e-radio[name="' + this.element.getAttribute("name") + '"]');
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist Data
     */ RadioButton.prototype.getPersistData = function() {
        return this.addOnPersist([
            "checked"
        ]);
    };
    RadioButton.prototype.getWrapper = function() {
        if (this.element.parentElement) return this.element.parentElement;
        else return null;
    };
    RadioButton.prototype.getLabel = function() {
        if (this.element.nextElementSibling) return this.element.nextElementSibling;
        else return null;
    };
    RadioButton.prototype.initialize = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.initialCheckedValue)) this.initialCheckedValue = this.checked;
        this.initWrapper();
        this.updateHtmlAttribute();
        if (this.name) this.element.setAttribute("name", this.name);
        var value = this.element.getAttribute("value");
        var type = typeof this.value;
        if (this.isVue && type === "boolean") value = value === "true" ? true : false;
        if (this.isVue ? this.value && type !== "boolean" && !value : this.value) this.element.setAttribute("value", this.value);
        if (this.checked) this.element.checked = true;
        if (this.disabled) this.setDisabled();
    };
    RadioButton.prototype.initWrapper = function() {
        var rippleSpan;
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains($8828e72750329966$var$WRAPPER)) {
            wrapper = this.createElement("div", {
                className: $8828e72750329966$var$WRAPPER
            });
            if (this.element.parentNode) this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var label = this.createElement("label", {
            attrs: {
                for: this.element.id
            }
        });
        wrapper.appendChild(this.element);
        wrapper.appendChild(label);
        if (0, $kj1BR.isRippleEnabled) {
            rippleSpan = this.createElement("span", {
                className: $8828e72750329966$var$RIPPLE
            });
            label.appendChild(rippleSpan);
            (0, $kj1BR.rippleEffect)(rippleSpan, {
                duration: 400,
                isCenterRipple: true
            });
        }
        wrapper.classList.add("e-wrapper");
        if (this.enableRtl) label.classList.add($8828e72750329966$var$RTL);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        if (this.label) this.setText(this.label);
    };
    RadioButton.prototype.keyUpHandler = function() {
        if (this.isFocused) this.getLabel().classList.add("e-focus");
    };
    RadioButton.prototype.labelMouseDownHandler = function(e) {
        var rippleSpan = this.getLabel().getElementsByClassName($8828e72750329966$var$RIPPLE)[0];
        (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
    };
    RadioButton.prototype.labelMouseLeaveHandler = function(e) {
        var rippleSpan = this.getLabel().getElementsByClassName($8828e72750329966$var$RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll(".e-ripple-element");
            for(var i = rippleElem.length - 1; i > 0; i--)rippleSpan.removeChild(rippleSpan.childNodes[i]);
            (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        }
    };
    RadioButton.prototype.labelMouseUpHandler = function(e) {
        var rippleSpan = this.getLabel().getElementsByClassName($8828e72750329966$var$RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll(".e-ripple-element");
            for(var i = rippleElem.length - 1; i > 0; i--)rippleSpan.removeChild(rippleSpan.childNodes[i]);
            (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        }
    };
    RadioButton.prototype.formResetHandler = function() {
        this.checked = this.initialCheckedValue;
        if (this.initialCheckedValue) (0, $4ZDHT.attributes)(this.element, {
            "checked": "true"
        });
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {RadioButtonModel} newProp - Specifies New Properties
     * @param {RadioButtonModel} oldProp - Specifies Old Properties
     * @returns {void}
     */ RadioButton.prototype.onPropertyChanged = function(newProp, oldProp) {
        var wrap = this.getWrapper();
        var label = this.getLabel();
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "checked":
                    if (newProp.checked) this.updateChange();
                    this.element.checked = newProp.checked;
                    break;
                case "disabled":
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.unWireEvents();
                    } else {
                        this.element.disabled = false;
                        this.wireEvents();
                    }
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        wrap
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        wrap
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) label.classList.add($8828e72750329966$var$RTL);
                    else label.classList.remove($8828e72750329966$var$RTL);
                    break;
                case "label":
                    this.setText(newProp.label);
                    break;
                case "labelPosition":
                    if (newProp.labelPosition === "Before") label.classList.add("e-right");
                    else label.classList.remove("e-right");
                    break;
                case "name":
                    this.element.setAttribute("name", newProp.name);
                    break;
                case "value":
                    // eslint-disable-next-line no-case-declarations
                    var type = typeof this.htmlAttributes.value;
                    if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) && (this.htmlAttributes.value || type === "boolean" && !this.htmlAttributes.value)) break;
                    this.element.setAttribute("value", newProp.value);
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttribute();
                    break;
            }
        }
    };
    /**
     * Initialize checked Property, Angular and React and Unique ID support.
     *
     * @private
     * @returns {void}
     */ RadioButton.prototype.preRender = function() {
        var element = this.element;
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        this.tagName = this.element.tagName;
        element = (0, $6a51972c93f30c96$export$fae3ac1fb6b5c37c)(this.createElement, "EJS-RADIOBUTTON", "radio", element, $8828e72750329966$var$WRAPPER, "radio");
        this.element = element;
        if (this.element.getAttribute("type") !== "radio") this.element.setAttribute("type", "radio");
        if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)("e-" + this.getModuleName());
        if (this.tagName === "EJS-RADIOBUTTON") {
            var formControlName = this.element.getAttribute("formcontrolname");
            if (formControlName) {
                this.setProperties({
                    "name": formControlName
                }, true);
                this.element.setAttribute("name", formControlName);
            }
        }
    };
    /**
     * Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ RadioButton.prototype.render = function() {
        this.initialize();
        if (!this.disabled) this.wireEvents();
        this.renderComplete();
        this.wrapper = this.getWrapper();
    };
    RadioButton.prototype.setDisabled = function() {
        this.element.disabled = true;
    };
    RadioButton.prototype.setText = function(text) {
        var label = this.getLabel();
        var textLabel = label.getElementsByClassName($8828e72750329966$var$LABEL)[0];
        if (textLabel) textLabel.textContent = text;
        else {
            text = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(text) : text;
            textLabel = this.createElement("span", {
                className: $8828e72750329966$var$LABEL,
                innerHTML: text
            });
            label.appendChild(textLabel);
        }
        if (this.labelPosition === "Before") this.getLabel().classList.add("e-right");
        else this.getLabel().classList.remove("e-right");
    };
    RadioButton.prototype.updateHtmlAttribute = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            var wrapper = this.element.parentElement;
            if ($8828e72750329966$var$ATTRIBUTES.indexOf(key) > -1) {
                if (key === "class") (0, $4ZDHT.addClass)([
                    wrapper
                ], this.htmlAttributes["" + key].replace(/\s+/g, " ").trim().split(" "));
                else if (key === "title" || key === "style") wrapper.setAttribute(key, this.htmlAttributes["" + key]);
                else this.element.setAttribute(key, this.htmlAttributes["" + key]);
            } else wrapper.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    RadioButton.prototype.unWireEvents = function() {
        var label = this.wrapper;
        (0, $aqzbR.EventHandler).remove(this.element, "change", this.changeHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focus", this.focusHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.focusOutHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keyup", this.keyUpHandler);
        var rippleLabel = label.getElementsByTagName("label")[0];
        if (rippleLabel) {
            (0, $aqzbR.EventHandler).remove(rippleLabel, "mousedown", this.labelMouseDownHandler);
            (0, $aqzbR.EventHandler).remove(rippleLabel, "mouseup", this.labelMouseUpHandler);
            (0, $aqzbR.EventHandler).remove(rippleLabel, "mouseleave", this.labelMouseLeaveHandler);
        }
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.formResetHandler);
    };
    RadioButton.prototype.wireEvents = function() {
        var label = this.getLabel();
        (0, $aqzbR.EventHandler).add(this.element, "change", this.changeHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keyup", this.keyUpHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focus", this.focusHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.focusOutHandler, this);
        var rippleLabel = label.getElementsByClassName($8828e72750329966$var$LABEL)[0];
        if (rippleLabel) {
            (0, $aqzbR.EventHandler).add(rippleLabel, "mousedown", this.labelMouseDownHandler, this);
            (0, $aqzbR.EventHandler).add(rippleLabel, "mouseup", this.labelMouseUpHandler, this);
            (0, $aqzbR.EventHandler).add(rippleLabel, "mouseleave", this.labelMouseLeaveHandler, this);
        }
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.formResetHandler, this);
    };
    /**
     * Click the RadioButton element
     * its native method
     *
     * @public
     * @returns {void}
     */ RadioButton.prototype.click = function() {
        this.element.click();
    };
    /**
     * Sets the focus to RadioButton
     * its native method
     *
     * @public
     * @returns {void}
     */ RadioButton.prototype.focusIn = function() {
        this.element.focus();
    };
    var RadioButton_1;
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Event)()
    ], RadioButton.prototype, "change", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Event)()
    ], RadioButton.prototype, "created", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RadioButton.prototype, "checked", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)("")
    ], RadioButton.prototype, "cssClass", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RadioButton.prototype, "disabled", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)("")
    ], RadioButton.prototype, "label", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)("After")
    ], RadioButton.prototype, "labelPosition", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)("")
    ], RadioButton.prototype, "name", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)("")
    ], RadioButton.prototype, "value", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], RadioButton.prototype, "enableHtmlSanitizer", void 0);
    $8828e72750329966$var$__decorate([
        (0, $5rsSz.Property)({})
    ], RadioButton.prototype, "htmlAttributes", void 0);
    RadioButton = RadioButton_1 = $8828e72750329966$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], RadioButton);
    return RadioButton;
}((0, $hQxLN.Component));





parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5rsSz = parcelRequire("5rsSz");
var $3EnZW = parcelRequire("3EnZW");

var $2vAqh = parcelRequire("2vAqh");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $3P3ke = parcelRequire("3P3ke");
var $i528u = parcelRequire("i528u");


var $cWXlQ = parcelRequire("cWXlQ");
var $49u5W = parcelRequire("49u5W");
var $2vAqh = parcelRequire("2vAqh");
parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $5rsSz = parcelRequire("5rsSz");
var $i528u = parcelRequire("i528u");
var $ffe4a1d7d733585d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ffe4a1d7d733585d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ffe4a1d7d733585d$var$CLS_ROOT = "e-hscroll";
var $ffe4a1d7d733585d$var$CLS_RTL = "e-rtl";
var $ffe4a1d7d733585d$var$CLS_DISABLE = "e-overlay";
var $ffe4a1d7d733585d$var$CLS_HSCROLLBAR = "e-hscroll-bar";
var $ffe4a1d7d733585d$var$CLS_HSCROLLCON = "e-hscroll-content";
var $ffe4a1d7d733585d$var$CLS_NAVARROW = "e-nav-arrow";
var $ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW = "e-nav-right-arrow";
var $ffe4a1d7d733585d$var$CLS_NAVLEFTARROW = "e-nav-left-arrow";
var $ffe4a1d7d733585d$var$CLS_HSCROLLNAV = "e-scroll-nav";
var $ffe4a1d7d733585d$var$CLS_HSCROLLNAVRIGHT = "e-scroll-right-nav";
var $ffe4a1d7d733585d$var$CLS_HSCROLLNAVLEFT = "e-scroll-left-nav";
var $ffe4a1d7d733585d$var$CLS_DEVICE = "e-scroll-device";
var $ffe4a1d7d733585d$var$CLS_OVERLAY = "e-scroll-overlay";
var $ffe4a1d7d733585d$var$CLS_RIGHTOVERLAY = "e-scroll-right-overlay";
var $ffe4a1d7d733585d$var$CLS_LEFTOVERLAY = "e-scroll-left-overlay";
var $ffe4a1d7d733585d$var$OVERLAY_MAXWID = 40;
/**
 * HScroll module is introduces horizontal scroller when content exceeds the current viewing area.
 * It can be useful for the components like Toolbar, Tab which needs horizontal scrolling alone.
 * Hidden content can be view by touch moving or icon click.
 * ```html
 * <div id="scroll"/>
 * <script>
 *   var scrollObj = new HScroll();
 *   scrollObj.appendTo("#scroll");
 * </script>
 * ```
 */ var $ffe4a1d7d733585d$export$49487f80cf9ca6b1 = /** @class */ function(_super) {
    $ffe4a1d7d733585d$var$__extends(HScroll, _super);
    /**
     * Initializes a new instance of the HScroll class.
     *
     * @param {HScrollModel} options  - Specifies HScroll model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element for which horizontal scrolling applies.
     */ function HScroll(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */ HScroll.prototype.preRender = function() {
        this.browser = (0, $5q7BP.Browser).info.name;
        this.browserCheck = this.browser === "mozilla";
        this.isDevice = (0, $5q7BP.Browser).isDevice;
        this.customStep = true;
        var element = this.element;
        this.ieCheck = this.browser === "edge" || this.browser === "msie";
        this.initialize();
        if (element.id === "") {
            element.id = (0, $3EnZW.getUniqueID)("hscroll");
            this.uniqueId = true;
        }
        element.style.display = "block";
        if (this.enableRtl) element.classList.add($ffe4a1d7d733585d$var$CLS_RTL);
    };
    /**
     * To Initialize the horizontal scroll  rendering
     *
     * @private
     * @returns {void}
     */ HScroll.prototype.render = function() {
        this.touchModule = new (0, $i528u.Touch)(this.element, {
            scroll: this.touchHandler.bind(this),
            swipe: this.swipeHandler.bind(this)
        });
        (0, $aqzbR.EventHandler).add(this.scrollEle, "scroll", this.scrollHandler, this);
        if (!this.isDevice) this.createNavIcon(this.element);
        else {
            this.element.classList.add($ffe4a1d7d733585d$var$CLS_DEVICE);
            this.createOverlay(this.element);
        }
        this.setScrollState();
    };
    HScroll.prototype.setScrollState = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.scrollStep) || this.scrollStep < 0) {
            this.scrollStep = this.scrollEle.offsetWidth;
            this.customStep = false;
        } else this.customStep = true;
    };
    HScroll.prototype.initialize = function() {
        var scrollEle = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_HSCROLLCON
        });
        var scrollDiv = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_HSCROLLBAR
        });
        scrollDiv.setAttribute("tabindex", "-1");
        var ele = this.element;
        var innerEle = [].slice.call(ele.children);
        for(var _i = 0, innerEle_1 = innerEle; _i < innerEle_1.length; _i++){
            var ele_1 = innerEle_1[_i];
            scrollEle.appendChild(ele_1);
        }
        scrollDiv.appendChild(scrollEle);
        ele.appendChild(scrollDiv);
        scrollDiv.style.overflowX = "hidden";
        this.scrollEle = scrollDiv;
        this.scrollItems = scrollEle;
    };
    HScroll.prototype.getPersistData = function() {
        var keyEntity = [
            "scrollStep"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */ HScroll.prototype.getModuleName = function() {
        return "hScroll";
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */ HScroll.prototype.destroy = function() {
        var ele = this.element;
        ele.style.display = "";
        ele.classList.remove($ffe4a1d7d733585d$var$CLS_ROOT);
        ele.classList.remove($ffe4a1d7d733585d$var$CLS_DEVICE);
        ele.classList.remove($ffe4a1d7d733585d$var$CLS_RTL);
        var nav = (0, $4ZDHT.selectAll)(".e-" + ele.id + "_nav." + $ffe4a1d7d733585d$var$CLS_HSCROLLNAV, ele);
        var overlay = (0, $4ZDHT.selectAll)("." + $ffe4a1d7d733585d$var$CLS_OVERLAY, ele);
        [].slice.call(overlay).forEach(function(ele) {
            (0, $4ZDHT.detach)(ele);
        });
        for(var _i = 0, _a = [].slice.call(this.scrollItems.children); _i < _a.length; _i++){
            var elem = _a[_i];
            ele.appendChild(elem);
        }
        if (this.uniqueId) this.element.removeAttribute("id");
        (0, $4ZDHT.detach)(this.scrollEle);
        if (nav.length > 0) {
            (0, $4ZDHT.detach)(nav[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(nav[1])) (0, $4ZDHT.detach)(nav[1]);
        }
        (0, $aqzbR.EventHandler).remove(this.scrollEle, "scroll", this.scrollHandler);
        this.touchModule.destroy();
        this.touchModule = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Specifies the value to disable/enable the HScroll component.
     * When set to `true` , the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, HScroll will be enabled (false) or disabled (true).
     * @returns {void}.
     */ HScroll.prototype.disable = function(value) {
        var navEles = (0, $4ZDHT.selectAll)(".e-scroll-nav:not(." + $ffe4a1d7d733585d$var$CLS_DISABLE + ")", this.element);
        if (value) this.element.classList.add($ffe4a1d7d733585d$var$CLS_DISABLE);
        else this.element.classList.remove($ffe4a1d7d733585d$var$CLS_DISABLE);
        [].slice.call(navEles).forEach(function(el) {
            el.setAttribute("tabindex", !value ? "0" : "-1");
        });
    };
    HScroll.prototype.createOverlay = function(element) {
        var id = element.id.concat("_nav");
        var rightOverlayEle = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_OVERLAY + " " + $ffe4a1d7d733585d$var$CLS_RIGHTOVERLAY
        });
        var clsRight = "e-" + element.id.concat("_nav " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAV + " " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAVRIGHT);
        var rightEle = this.createElement("div", {
            id: id.concat("_right"),
            className: clsRight
        });
        var navItem = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW + " " + $ffe4a1d7d733585d$var$CLS_NAVARROW + " e-icons"
        });
        rightEle.appendChild(navItem);
        var leftEle = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_OVERLAY + " " + $ffe4a1d7d733585d$var$CLS_LEFTOVERLAY
        });
        if (this.ieCheck) rightEle.classList.add("e-ie-align");
        element.appendChild(rightOverlayEle);
        element.appendChild(rightEle);
        element.insertBefore(leftEle, element.firstChild);
        this.eventBinding([
            rightEle
        ]);
    };
    HScroll.prototype.createNavIcon = function(element) {
        var id = element.id.concat("_nav");
        var clsRight = "e-" + element.id.concat("_nav " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAV + " " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAVRIGHT);
        var rightAttributes = {
            "role": "button",
            "id": id.concat("_right"),
            "aria-label": "Scroll right"
        };
        var nav = this.createElement("div", {
            className: clsRight,
            attrs: rightAttributes
        });
        nav.setAttribute("aria-disabled", "false");
        var navItem = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW + " " + $ffe4a1d7d733585d$var$CLS_NAVARROW + " e-icons"
        });
        var clsLeft = "e-" + element.id.concat("_nav " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAV + " " + $ffe4a1d7d733585d$var$CLS_HSCROLLNAVLEFT);
        var leftAttributes = {
            "role": "button",
            "id": id.concat("_left"),
            "aria-label": "Scroll left"
        };
        var navEle = this.createElement("div", {
            className: clsLeft + " " + $ffe4a1d7d733585d$var$CLS_DISABLE,
            attrs: leftAttributes
        });
        navEle.setAttribute("aria-disabled", "true");
        var navLeftItem = this.createElement("div", {
            className: $ffe4a1d7d733585d$var$CLS_NAVLEFTARROW + " " + $ffe4a1d7d733585d$var$CLS_NAVARROW + " e-icons"
        });
        navEle.appendChild(navLeftItem);
        nav.appendChild(navItem);
        element.appendChild(nav);
        element.insertBefore(navEle, element.firstChild);
        if (this.ieCheck) {
            nav.classList.add("e-ie-align");
            navEle.classList.add("e-ie-align");
        }
        this.eventBinding([
            nav,
            navEle
        ]);
    };
    HScroll.prototype.onKeyPress = function(e) {
        var _this = this;
        if (e.key === "Enter") {
            var timeoutFun_1 = function() {
                _this.keyTimeout = true;
                _this.eleScrolling(10, e.target, true);
            };
            this.keyTimer = window.setTimeout(function() {
                timeoutFun_1();
            }, 100);
        }
    };
    HScroll.prototype.onKeyUp = function(e) {
        if (e.key !== "Enter") return;
        if (this.keyTimeout) this.keyTimeout = false;
        else e.target.click();
        clearTimeout(this.keyTimer);
    };
    HScroll.prototype.eventBinding = function(ele) {
        var _this = this;
        [].slice.call(ele).forEach(function(el) {
            new (0, $i528u.Touch)(el, {
                tapHold: _this.tabHoldHandler.bind(_this),
                tapHoldThreshold: 500
            });
            el.addEventListener("keydown", _this.onKeyPress.bind(_this));
            el.addEventListener("keyup", _this.onKeyUp.bind(_this));
            el.addEventListener("mouseup", _this.repeatScroll.bind(_this));
            el.addEventListener("touchend", _this.repeatScroll.bind(_this));
            el.addEventListener("contextmenu", function(e) {
                e.preventDefault();
            });
            (0, $aqzbR.EventHandler).add(el, "click", _this.clickEventHandler, _this);
        });
    };
    HScroll.prototype.repeatScroll = function() {
        clearInterval(this.timeout);
    };
    HScroll.prototype.tabHoldHandler = function(e) {
        var _this = this;
        var trgt = e.originalEvent.target;
        trgt = this.contains(trgt, $ffe4a1d7d733585d$var$CLS_HSCROLLNAV) ? trgt.firstElementChild : trgt;
        var scrollDis = 10;
        var timeoutFun = function() {
            _this.eleScrolling(scrollDis, trgt, true);
        };
        this.timeout = window.setInterval(function() {
            timeoutFun();
        }, 50);
    };
    HScroll.prototype.contains = function(ele, className) {
        return ele.classList.contains(className);
    };
    HScroll.prototype.eleScrolling = function(scrollDis, trgt, isContinuous) {
        var rootEle = this.element;
        var classList = trgt.classList;
        if (classList.contains($ffe4a1d7d733585d$var$CLS_HSCROLLNAV)) classList = trgt.querySelector("." + $ffe4a1d7d733585d$var$CLS_NAVARROW).classList;
        if (this.contains(rootEle, $ffe4a1d7d733585d$var$CLS_RTL) && this.browserCheck) scrollDis = -scrollDis;
        if (!this.contains(rootEle, $ffe4a1d7d733585d$var$CLS_RTL) || this.browserCheck || this.ieCheck) {
            if (classList.contains($ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW)) this.frameScrollRequest(scrollDis, "add", isContinuous);
            else this.frameScrollRequest(scrollDis, "", isContinuous);
        } else if (classList.contains($ffe4a1d7d733585d$var$CLS_NAVLEFTARROW)) this.frameScrollRequest(scrollDis, "add", isContinuous);
        else this.frameScrollRequest(scrollDis, "", isContinuous);
    };
    HScroll.prototype.clickEventHandler = function(e) {
        this.eleScrolling(this.scrollStep, e.target, false);
    };
    HScroll.prototype.swipeHandler = function(e) {
        var swipeEle = this.scrollEle;
        var distance;
        if (e.velocity <= 1) distance = e.distanceX / (e.velocity * 10);
        else distance = e.distanceX / e.velocity;
        var start = 0.5;
        var animate = function() {
            var step = Math.sin(start);
            if (step <= 0) window.cancelAnimationFrame(step);
            else {
                if (e.swipeDirection === "Left") swipeEle.scrollLeft += distance * step;
                else if (e.swipeDirection === "Right") swipeEle.scrollLeft -= distance * step;
                start -= 0.5;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    HScroll.prototype.scrollUpdating = function(scrollVal, action) {
        if (action === "add") this.scrollEle.scrollLeft += scrollVal;
        else this.scrollEle.scrollLeft -= scrollVal;
        if (this.enableRtl && this.scrollEle.scrollLeft > 0) this.scrollEle.scrollLeft = 0;
    };
    HScroll.prototype.frameScrollRequest = function(scrollVal, action, isContinuous) {
        var _this = this;
        var step = 10;
        if (isContinuous) {
            this.scrollUpdating(scrollVal, action);
            return;
        }
        if (!this.customStep) [].slice.call((0, $4ZDHT.selectAll)("." + $ffe4a1d7d733585d$var$CLS_OVERLAY, this.element)).forEach(function(el) {
            scrollVal -= el.offsetWidth;
        });
        var animate = function() {
            var scrollValue;
            var scrollStep;
            if (_this.contains(_this.element, $ffe4a1d7d733585d$var$CLS_RTL) && _this.browserCheck) {
                scrollValue = -scrollVal;
                scrollStep = -step;
            } else {
                scrollValue = scrollVal;
                scrollStep = step;
            }
            if (scrollValue < step) window.cancelAnimationFrame(scrollStep);
            else {
                _this.scrollUpdating(scrollStep, action);
                scrollVal -= scrollStep;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    HScroll.prototype.touchHandler = function(e) {
        var ele = this.scrollEle;
        var distance = e.distanceX;
        if (this.ieCheck && this.contains(this.element, $ffe4a1d7d733585d$var$CLS_RTL)) distance = -distance;
        if (e.scrollDirection === "Left") ele.scrollLeft = ele.scrollLeft + distance;
        else if (e.scrollDirection === "Right") ele.scrollLeft = ele.scrollLeft - distance;
    };
    HScroll.prototype.arrowDisabling = function(addDisable, removeDisable) {
        if (this.isDevice) {
            var arrowEle = (0, $3EnZW.isNullOrUndefined)(addDisable) ? removeDisable : addDisable;
            var arrowIcon = arrowEle.querySelector("." + $ffe4a1d7d733585d$var$CLS_NAVARROW);
            if ((0, $3EnZW.isNullOrUndefined)(addDisable)) (0, $4ZDHT.classList)(arrowIcon, [
                $ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW
            ], [
                $ffe4a1d7d733585d$var$CLS_NAVLEFTARROW
            ]);
            else (0, $4ZDHT.classList)(arrowIcon, [
                $ffe4a1d7d733585d$var$CLS_NAVLEFTARROW
            ], [
                $ffe4a1d7d733585d$var$CLS_NAVRIGHTARROW
            ]);
        } else if (addDisable && removeDisable) {
            addDisable.classList.add($ffe4a1d7d733585d$var$CLS_DISABLE);
            addDisable.setAttribute("aria-disabled", "true");
            addDisable.removeAttribute("tabindex");
            removeDisable.classList.remove($ffe4a1d7d733585d$var$CLS_DISABLE);
            removeDisable.setAttribute("aria-disabled", "false");
            removeDisable.setAttribute("tabindex", "0");
        }
        this.repeatScroll();
    };
    HScroll.prototype.scrollHandler = function(e) {
        var target = e.target;
        var width = target.offsetWidth;
        var rootEle = this.element;
        var navLeftEle = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_HSCROLLNAVLEFT);
        var navRightEle = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_HSCROLLNAVRIGHT);
        var leftOverlay = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_LEFTOVERLAY);
        var rightOverlay = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_RIGHTOVERLAY);
        var scrollLeft = target.scrollLeft;
        if (scrollLeft <= 0) scrollLeft = -scrollLeft;
        if (this.isDevice) {
            if (this.enableRtl && !(this.browserCheck || this.ieCheck)) {
                leftOverlay = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_RIGHTOVERLAY);
                rightOverlay = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_LEFTOVERLAY);
            }
            if (scrollLeft < $ffe4a1d7d733585d$var$OVERLAY_MAXWID) leftOverlay.style.width = scrollLeft + "px";
            else leftOverlay.style.width = "40px";
            if (target.scrollWidth - Math.ceil(width + scrollLeft) < $ffe4a1d7d733585d$var$OVERLAY_MAXWID) rightOverlay.style.width = target.scrollWidth - Math.ceil(width + scrollLeft) + "px";
            else rightOverlay.style.width = "40px";
        }
        if (scrollLeft === 0) this.arrowDisabling(navLeftEle, navRightEle);
        else if (Math.ceil(width + scrollLeft + .1) >= target.scrollWidth) this.arrowDisabling(navRightEle, navLeftEle);
        else {
            var disEle = this.element.querySelector("." + $ffe4a1d7d733585d$var$CLS_HSCROLLNAV + "." + $ffe4a1d7d733585d$var$CLS_DISABLE);
            if (disEle) {
                disEle.classList.remove($ffe4a1d7d733585d$var$CLS_DISABLE);
                disEle.setAttribute("aria-disabled", "false");
                disEle.setAttribute("tabindex", "0");
            }
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of property that changed.
     *
     * @param  {HScrollModel} newProp - It contains the new value of data.
     * @param  {HScrollModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */ HScroll.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "scrollStep":
                    this.setScrollState();
                    break;
                case "enableRtl":
                    newProp.enableRtl ? this.element.classList.add($ffe4a1d7d733585d$var$CLS_RTL) : this.element.classList.remove($ffe4a1d7d733585d$var$CLS_RTL);
                    break;
            }
        }
    };
    $ffe4a1d7d733585d$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], HScroll.prototype, "scrollStep", void 0);
    HScroll = $ffe4a1d7d733585d$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], HScroll);
    return HScroll;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $5rsSz = parcelRequire("5rsSz");
var $i528u = parcelRequire("i528u");
var $3471080cb1b09001$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3471080cb1b09001$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3471080cb1b09001$var$CLS_ROOT = "e-vscroll";
var $3471080cb1b09001$var$CLS_RTL = "e-rtl";
var $3471080cb1b09001$var$CLS_DISABLE = "e-overlay";
var $3471080cb1b09001$var$CLS_VSCROLLBAR = "e-vscroll-bar";
var $3471080cb1b09001$var$CLS_VSCROLLCON = "e-vscroll-content";
var $3471080cb1b09001$var$CLS_NAVARROW = "e-nav-arrow";
var $3471080cb1b09001$var$CLS_NAVUPARROW = "e-nav-up-arrow";
var $3471080cb1b09001$var$CLS_NAVDOWNARROW = "e-nav-down-arrow";
var $3471080cb1b09001$var$CLS_VSCROLLNAV = "e-scroll-nav";
var $3471080cb1b09001$var$CLS_VSCROLLNAVUP = "e-scroll-up-nav";
var $3471080cb1b09001$var$CLS_VSCROLLNAVDOWN = "e-scroll-down-nav";
var $3471080cb1b09001$var$CLS_DEVICE = "e-scroll-device";
var $3471080cb1b09001$var$CLS_OVERLAY = "e-scroll-overlay";
var $3471080cb1b09001$var$CLS_UPOVERLAY = "e-scroll-up-overlay";
var $3471080cb1b09001$var$CLS_DOWNOVERLAY = "e-scroll-down-overlay";
var $3471080cb1b09001$var$OVERLAY_MAXWID = 40;
/**
 * VScroll module is introduces vertical scroller when content exceeds the current viewing area.
 * It can be useful for the components like Toolbar, Tab which needs vertical scrolling alone.
 * Hidden content can be view by touch moving or icon click.
 * ```html
 * <div id="scroll"/>
 * <script>
 *   var scrollObj = new VScroll();
 *   scrollObj.appendTo("#scroll");
 * </script>
 * ```
 */ var $3471080cb1b09001$export$d9880af5395880d2 = /** @class */ function(_super) {
    $3471080cb1b09001$var$__extends(VScroll, _super);
    /**
     * Initializes a new instance of the VScroll class.
     *
     * @param {VScrollModel} options  - Specifies VScroll model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element for which vertical scrolling applies.
     */ function VScroll(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */ VScroll.prototype.preRender = function() {
        this.browser = (0, $5q7BP.Browser).info.name;
        this.browserCheck = this.browser === "mozilla";
        this.isDevice = (0, $5q7BP.Browser).isDevice;
        this.customStep = true;
        var ele = this.element;
        this.ieCheck = this.browser === "edge" || this.browser === "msie";
        this.initialize();
        if (ele.id === "") {
            ele.id = (0, $3EnZW.getUniqueID)("vscroll");
            this.uniqueId = true;
        }
        ele.style.display = "block";
        if (this.enableRtl) ele.classList.add($3471080cb1b09001$var$CLS_RTL);
    };
    /**
     * To Initialize the vertical scroll rendering
     *
     * @private
     * @returns {void}
     */ VScroll.prototype.render = function() {
        this.touchModule = new (0, $i528u.Touch)(this.element, {
            scroll: this.touchHandler.bind(this),
            swipe: this.swipeHandler.bind(this)
        });
        (0, $aqzbR.EventHandler).add(this.scrollEle, "scroll", this.scrollEventHandler, this);
        if (!this.isDevice) this.createNavIcon(this.element);
        else {
            this.element.classList.add($3471080cb1b09001$var$CLS_DEVICE);
            this.createOverlayElement(this.element);
        }
        this.setScrollState();
        (0, $aqzbR.EventHandler).add(this.element, "wheel", this.wheelEventHandler, this);
    };
    VScroll.prototype.setScrollState = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.scrollStep) || this.scrollStep < 0) {
            this.scrollStep = this.scrollEle.offsetHeight;
            this.customStep = false;
        } else this.customStep = true;
    };
    VScroll.prototype.initialize = function() {
        var scrollCnt = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_VSCROLLCON
        });
        var scrollBar = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_VSCROLLBAR
        });
        scrollBar.setAttribute("tabindex", "-1");
        var ele = this.element;
        var innerEle = [].slice.call(ele.children);
        for(var _i = 0, innerEle_1 = innerEle; _i < innerEle_1.length; _i++){
            var ele_1 = innerEle_1[_i];
            scrollCnt.appendChild(ele_1);
        }
        scrollBar.appendChild(scrollCnt);
        ele.appendChild(scrollBar);
        scrollBar.style.overflow = "hidden";
        this.scrollEle = scrollBar;
        this.scrollItems = scrollCnt;
    };
    VScroll.prototype.getPersistData = function() {
        var keyEntity = [
            "scrollStep"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */ VScroll.prototype.getModuleName = function() {
        return "vScroll";
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */ VScroll.prototype.destroy = function() {
        var el = this.element;
        el.style.display = "";
        (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $3471080cb1b09001$var$CLS_ROOT,
            $3471080cb1b09001$var$CLS_DEVICE,
            $3471080cb1b09001$var$CLS_RTL
        ]);
        var navs = (0, $4ZDHT.selectAll)(".e-" + el.id + "_nav." + $3471080cb1b09001$var$CLS_VSCROLLNAV, el);
        var overlays = (0, $4ZDHT.selectAll)("." + $3471080cb1b09001$var$CLS_OVERLAY, el);
        [].slice.call(overlays).forEach(function(ele) {
            (0, $4ZDHT.detach)(ele);
        });
        for(var _i = 0, _a = [].slice.call(this.scrollItems.children); _i < _a.length; _i++){
            var elem = _a[_i];
            el.appendChild(elem);
        }
        if (this.uniqueId) this.element.removeAttribute("id");
        (0, $4ZDHT.detach)(this.scrollEle);
        if (navs.length > 0) {
            (0, $4ZDHT.detach)(navs[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(navs[1])) (0, $4ZDHT.detach)(navs[1]);
        }
        (0, $aqzbR.EventHandler).remove(this.scrollEle, "scroll", this.scrollEventHandler);
        this.touchModule.destroy();
        this.touchModule = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Specifies the value to disable/enable the VScroll component.
     * When set to `true` , the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, VScroll will be enabled (false) or disabled (true).
     * @returns {void}.
     */ VScroll.prototype.disable = function(value) {
        var navEle = (0, $4ZDHT.selectAll)(".e-scroll-nav:not(." + $3471080cb1b09001$var$CLS_DISABLE + ")", this.element);
        if (value) this.element.classList.add($3471080cb1b09001$var$CLS_DISABLE);
        else this.element.classList.remove($3471080cb1b09001$var$CLS_DISABLE);
        [].slice.call(navEle).forEach(function(el) {
            el.setAttribute("tabindex", !value ? "0" : "-1");
        });
    };
    VScroll.prototype.createOverlayElement = function(element) {
        var id = element.id.concat("_nav");
        var downOverlayEle = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_OVERLAY + " " + $3471080cb1b09001$var$CLS_DOWNOVERLAY
        });
        var clsDown = "e-" + element.id.concat("_nav " + $3471080cb1b09001$var$CLS_VSCROLLNAV + " " + $3471080cb1b09001$var$CLS_VSCROLLNAVDOWN);
        var downEle = (0, $4ZDHT.createElement)("div", {
            id: id.concat("down"),
            className: clsDown
        });
        var navItem = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_NAVDOWNARROW + " " + $3471080cb1b09001$var$CLS_NAVARROW + " e-icons"
        });
        downEle.appendChild(navItem);
        var upEle = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_OVERLAY + " " + $3471080cb1b09001$var$CLS_UPOVERLAY
        });
        if (this.ieCheck) downEle.classList.add("e-ie-align");
        element.appendChild(downOverlayEle);
        element.appendChild(downEle);
        element.insertBefore(upEle, element.firstChild);
        this.eventBinding([
            downEle
        ]);
    };
    VScroll.prototype.createNavIcon = function(element) {
        var id = element.id.concat("_nav");
        var clsDown = "e-" + element.id.concat("_nav " + $3471080cb1b09001$var$CLS_VSCROLLNAV + " " + $3471080cb1b09001$var$CLS_VSCROLLNAVDOWN);
        var nav = (0, $4ZDHT.createElement)("div", {
            id: id.concat("_down"),
            className: clsDown
        });
        nav.setAttribute("aria-disabled", "false");
        var navItem = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_NAVDOWNARROW + " " + $3471080cb1b09001$var$CLS_NAVARROW + " e-icons"
        });
        var clsUp = "e-" + element.id.concat("_nav " + $3471080cb1b09001$var$CLS_VSCROLLNAV + " " + $3471080cb1b09001$var$CLS_VSCROLLNAVUP);
        var navElement = (0, $4ZDHT.createElement)("div", {
            id: id.concat("_up"),
            className: clsUp + " " + $3471080cb1b09001$var$CLS_DISABLE
        });
        navElement.setAttribute("aria-disabled", "true");
        var navUpItem = (0, $4ZDHT.createElement)("div", {
            className: $3471080cb1b09001$var$CLS_NAVUPARROW + " " + $3471080cb1b09001$var$CLS_NAVARROW + " e-icons"
        });
        navElement.appendChild(navUpItem);
        nav.appendChild(navItem);
        nav.setAttribute("tabindex", "0");
        element.appendChild(nav);
        element.insertBefore(navElement, element.firstChild);
        if (this.ieCheck) {
            nav.classList.add("e-ie-align");
            navElement.classList.add("e-ie-align");
        }
        this.eventBinding([
            nav,
            navElement
        ]);
    };
    VScroll.prototype.onKeyPress = function(ev) {
        var _this = this;
        if (ev.key === "Enter") {
            var timeoutFun_1 = function() {
                _this.keyTimeout = true;
                _this.eleScrolling(10, ev.target, true);
            };
            this.keyTimer = window.setTimeout(function() {
                timeoutFun_1();
            }, 100);
        }
    };
    VScroll.prototype.onKeyUp = function(ev) {
        if (ev.key !== "Enter") return;
        if (this.keyTimeout) this.keyTimeout = false;
        else ev.target.click();
        clearTimeout(this.keyTimer);
    };
    VScroll.prototype.eventBinding = function(element) {
        var _this = this;
        [].slice.call(element).forEach(function(ele) {
            new (0, $i528u.Touch)(ele, {
                tapHold: _this.tabHoldHandler.bind(_this),
                tapHoldThreshold: 500
            });
            ele.addEventListener("keydown", _this.onKeyPress.bind(_this));
            ele.addEventListener("keyup", _this.onKeyUp.bind(_this));
            ele.addEventListener("mouseup", _this.repeatScroll.bind(_this));
            ele.addEventListener("touchend", _this.repeatScroll.bind(_this));
            ele.addEventListener("contextmenu", function(e) {
                e.preventDefault();
            });
            (0, $aqzbR.EventHandler).add(ele, "click", _this.clickEventHandler, _this);
        });
    };
    VScroll.prototype.repeatScroll = function() {
        clearInterval(this.timeout);
    };
    VScroll.prototype.tabHoldHandler = function(ev) {
        var _this = this;
        var trgt = ev.originalEvent.target;
        trgt = this.contains(trgt, $3471080cb1b09001$var$CLS_VSCROLLNAV) ? trgt.firstElementChild : trgt;
        var scrollDistance = 10;
        var timeoutFun = function() {
            _this.eleScrolling(scrollDistance, trgt, true);
        };
        this.timeout = window.setInterval(function() {
            timeoutFun();
        }, 50);
    };
    VScroll.prototype.contains = function(element, className) {
        return element.classList.contains(className);
    };
    VScroll.prototype.eleScrolling = function(scrollDis, trgt, isContinuous) {
        var classList = trgt.classList;
        if (classList.contains($3471080cb1b09001$var$CLS_VSCROLLNAV)) classList = trgt.querySelector("." + $3471080cb1b09001$var$CLS_NAVARROW).classList;
        if (classList.contains($3471080cb1b09001$var$CLS_NAVDOWNARROW)) this.frameScrollRequest(scrollDis, "add", isContinuous);
        else if (classList.contains($3471080cb1b09001$var$CLS_NAVUPARROW)) this.frameScrollRequest(scrollDis, "", isContinuous);
    };
    VScroll.prototype.clickEventHandler = function(event) {
        this.eleScrolling(this.scrollStep, event.target, false);
    };
    VScroll.prototype.wheelEventHandler = function(e) {
        e.preventDefault();
        this.frameScrollRequest(this.scrollStep, e.deltaY > 0 ? "add" : "", false);
    };
    VScroll.prototype.swipeHandler = function(e) {
        var swipeElement = this.scrollEle;
        var distance;
        if (e.velocity <= 1) distance = e.distanceY / (e.velocity * 10);
        else distance = e.distanceY / e.velocity;
        var start = 0.5;
        var animate = function() {
            var step = Math.sin(start);
            if (step <= 0) window.cancelAnimationFrame(step);
            else {
                if (e.swipeDirection === "Up") swipeElement.scrollTop += distance * step;
                else if (e.swipeDirection === "Down") swipeElement.scrollTop -= distance * step;
                start -= 0.02;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    VScroll.prototype.scrollUpdating = function(scrollVal, action) {
        if (action === "add") this.scrollEle.scrollTop += scrollVal;
        else this.scrollEle.scrollTop -= scrollVal;
    };
    VScroll.prototype.frameScrollRequest = function(scrollValue, action, isContinuous) {
        var _this = this;
        var step = 10;
        if (isContinuous) {
            this.scrollUpdating(scrollValue, action);
            return;
        }
        if (!this.customStep) [].slice.call((0, $4ZDHT.selectAll)("." + $3471080cb1b09001$var$CLS_OVERLAY, this.element)).forEach(function(el) {
            scrollValue -= el.offsetHeight;
        });
        var animate = function() {
            if (scrollValue < step) window.cancelAnimationFrame(step);
            else {
                _this.scrollUpdating(step, action);
                scrollValue -= step;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    VScroll.prototype.touchHandler = function(e) {
        var el = this.scrollEle;
        var distance = e.distanceY;
        if (e.scrollDirection === "Up") el.scrollTop = el.scrollTop + distance;
        else if (e.scrollDirection === "Down") el.scrollTop = el.scrollTop - distance;
    };
    VScroll.prototype.arrowDisabling = function(addDisableCls, removeDisableCls) {
        if (this.isDevice) {
            var arrowEle = (0, $3EnZW.isNullOrUndefined)(addDisableCls) ? removeDisableCls : addDisableCls;
            var arrowIcon = arrowEle.querySelector("." + $3471080cb1b09001$var$CLS_NAVARROW);
            if ((0, $3EnZW.isNullOrUndefined)(addDisableCls)) (0, $4ZDHT.classList)(arrowIcon, [
                $3471080cb1b09001$var$CLS_NAVDOWNARROW
            ], [
                $3471080cb1b09001$var$CLS_NAVUPARROW
            ]);
            else (0, $4ZDHT.classList)(arrowIcon, [
                $3471080cb1b09001$var$CLS_NAVUPARROW
            ], [
                $3471080cb1b09001$var$CLS_NAVDOWNARROW
            ]);
        } else {
            addDisableCls.classList.add($3471080cb1b09001$var$CLS_DISABLE);
            addDisableCls.setAttribute("aria-disabled", "true");
            addDisableCls.removeAttribute("tabindex");
            removeDisableCls.classList.remove($3471080cb1b09001$var$CLS_DISABLE);
            removeDisableCls.setAttribute("aria-disabled", "false");
            removeDisableCls.setAttribute("tabindex", "0");
        }
        this.repeatScroll();
    };
    VScroll.prototype.scrollEventHandler = function(e) {
        var target = e.target;
        var height = target.offsetHeight;
        var navUpEle = this.element.querySelector("." + $3471080cb1b09001$var$CLS_VSCROLLNAVUP);
        var navDownEle = this.element.querySelector("." + $3471080cb1b09001$var$CLS_VSCROLLNAVDOWN);
        var upOverlay = this.element.querySelector("." + $3471080cb1b09001$var$CLS_UPOVERLAY);
        var downOverlay = this.element.querySelector("." + $3471080cb1b09001$var$CLS_DOWNOVERLAY);
        var scrollTop = target.scrollTop;
        if (scrollTop <= 0) scrollTop = -scrollTop;
        if (this.isDevice) {
            if (scrollTop < $3471080cb1b09001$var$OVERLAY_MAXWID) upOverlay.style.height = scrollTop + "px";
            else upOverlay.style.height = "40px";
            if (target.scrollHeight - Math.ceil(height + scrollTop) < $3471080cb1b09001$var$OVERLAY_MAXWID) downOverlay.style.height = target.scrollHeight - Math.ceil(height + scrollTop) + "px";
            else downOverlay.style.height = "40px";
        }
        if (scrollTop === 0) this.arrowDisabling(navUpEle, navDownEle);
        else if (Math.ceil(height + scrollTop + .1) >= target.scrollHeight) this.arrowDisabling(navDownEle, navUpEle);
        else {
            var disEle = this.element.querySelector("." + $3471080cb1b09001$var$CLS_VSCROLLNAV + "." + $3471080cb1b09001$var$CLS_DISABLE);
            if (disEle) {
                disEle.classList.remove($3471080cb1b09001$var$CLS_DISABLE);
                disEle.setAttribute("aria-disabled", "false");
                disEle.setAttribute("tabindex", "0");
            }
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of property that changed.
     *
     * @param  {VScrollModel} newProp - It contains the new value of data.
     * @param  {VScrollModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */ VScroll.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "scrollStep":
                    this.setScrollState();
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) this.element.classList.add($3471080cb1b09001$var$CLS_RTL);
                    else this.element.classList.remove($3471080cb1b09001$var$CLS_RTL);
                    break;
            }
        }
    };
    $3471080cb1b09001$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VScroll.prototype, "scrollStep", void 0);
    VScroll = $3471080cb1b09001$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], VScroll);
    return VScroll;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");


function $cd13d8ef6effb9e3$export$a45b277437001805(createElement, container, content, scrollType, enableRtl, offset) {
    var containerOffset;
    var contentOffset;
    var parentElem = container.parentElement;
    if (scrollType === "vscroll") {
        containerOffset = offset || container.getBoundingClientRect().height;
        contentOffset = content.getBoundingClientRect().height;
    } else {
        containerOffset = container.getBoundingClientRect().width;
        contentOffset = content.getBoundingClientRect().width;
    }
    if (containerOffset < contentOffset) return $cd13d8ef6effb9e3$var$createScrollbar(createElement, container, content, scrollType, enableRtl, offset);
    else if (parentElem) {
        var width = parentElem.getBoundingClientRect().width;
        if (width < containerOffset && scrollType === "hscroll") {
            contentOffset = width;
            container.style.maxWidth = width + "px";
            return $cd13d8ef6effb9e3$var$createScrollbar(createElement, container, content, scrollType, enableRtl, offset);
        }
        return content;
    } else return content;
}
/**
 * Used to create scroll bar in menu.
 *
 * @param {createElementType} createElement - Specifies the create element model
 * @param {HTMLElement} container - Specifies the element container
 * @param {HTMLElement} content - Specifies the content element
 * @param {string} scrollType - Specifies the scroll type
 * @param {boolean} enableRtl - Specifies the enable RTL property
 * @param {boolean} offset - Specifies the offset value
 * @returns {HTMLElement} - Element
 * @hidden
 */ function $cd13d8ef6effb9e3$var$createScrollbar(createElement, container, content, scrollType, enableRtl, offset) {
    var scrollEle = createElement("div", {
        className: "e-menu-" + scrollType
    });
    container.appendChild(scrollEle);
    scrollEle.appendChild(content);
    if (offset) {
        scrollEle.style.overflow = "hidden";
        scrollEle.style.height = offset + "px";
    } else {
        scrollEle.style.maxHeight = container.style.maxHeight;
        container.style.overflow = "hidden";
    }
    var scrollObj;
    if (scrollType === "vscroll") {
        scrollObj = new (0, $3471080cb1b09001$export$d9880af5395880d2)({
            enableRtl: enableRtl
        }, scrollEle);
        scrollObj.scrollStep = (0, $4ZDHT.select)(".e-" + scrollType + "-bar", container).offsetHeight / 2;
    } else {
        scrollObj = new (0, $ffe4a1d7d733585d$export$49487f80cf9ca6b1)({
            enableRtl: enableRtl
        }, scrollEle);
        scrollObj.scrollStep = (0, $4ZDHT.select)(".e-" + scrollType + "-bar", container).offsetWidth;
    }
    return scrollEle;
}
function $cd13d8ef6effb9e3$export$3f5ade24e7a444c3(scrollObj, element, skipEle) {
    if (scrollObj) {
        var menu = (0, $4ZDHT.select)(".e-menu-parent", element);
        if (menu) {
            if (!skipEle || skipEle === menu) {
                scrollObj.destroy();
                element.parentElement.appendChild(menu);
                (0, $4ZDHT.detach)(element);
            }
        } else {
            scrollObj.destroy();
            (0, $4ZDHT.detach)(element);
        }
    }
}


var $b0f7c8984d47d037$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b0f7c8984d47d037$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b0f7c8984d47d037$var$ENTER = "enter";
var $b0f7c8984d47d037$var$ESCAPE = "escape";
var $b0f7c8984d47d037$var$FOCUSED = "e-focused";
var $b0f7c8984d47d037$var$HEADER = "e-menu-header";
var $b0f7c8984d47d037$var$SELECTED = "e-selected";
var $b0f7c8984d47d037$var$SEPARATOR = "e-separator";
var $b0f7c8984d47d037$var$UPARROW = "uparrow";
var $b0f7c8984d47d037$var$DOWNARROW = "downarrow";
var $b0f7c8984d47d037$var$LEFTARROW = "leftarrow";
var $b0f7c8984d47d037$var$RIGHTARROW = "rightarrow";
var $b0f7c8984d47d037$var$HOME = "home";
var $b0f7c8984d47d037$var$END = "end";
var $b0f7c8984d47d037$var$TAB = "tab";
var $b0f7c8984d47d037$var$CARET = "e-caret";
var $b0f7c8984d47d037$var$ITEM = "e-menu-item";
var $b0f7c8984d47d037$var$DISABLED = "e-disabled";
var $b0f7c8984d47d037$var$HIDE = "e-menu-hide";
var $b0f7c8984d47d037$var$ICONS = "e-icons";
var $b0f7c8984d47d037$var$RTL = "e-rtl";
var $b0f7c8984d47d037$var$POPUP = "e-menu-popup";
var $b0f7c8984d47d037$var$TEMPLATE_PROPERTY = "Template";
/**
 * Configures the field options of the Menu.
 */ var $b0f7c8984d47d037$export$47acbd07e937cc3e = /** @class */ function(_super) {
    $b0f7c8984d47d037$var$__extends(FieldSettings, _super);
    function FieldSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("id")
    ], FieldSettings.prototype, "itemId", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("parentId")
    ], FieldSettings.prototype, "parentId", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("text")
    ], FieldSettings.prototype, "text", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("iconCss")
    ], FieldSettings.prototype, "iconCss", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("url")
    ], FieldSettings.prototype, "url", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("separator")
    ], FieldSettings.prototype, "separator", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("items")
    ], FieldSettings.prototype, "children", void 0);
    return FieldSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Specifies menu items.
 */ var $b0f7c8984d47d037$export$2ce376c2cc3355c8 = /** @class */ function(_super) {
    $b0f7c8984d47d037$var$__extends(MenuItem, _super);
    function MenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MenuItem.prototype, "iconCss", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuItem.prototype, "id", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MenuItem.prototype, "separator", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Collection)([], MenuItem)
    ], MenuItem.prototype, "items", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuItem.prototype, "text", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuItem.prototype, "url", void 0);
    return MenuItem;
}((0, $3fcxu.ChildProperty));
/**
 * Animation configuration settings.
 */ var $b0f7c8984d47d037$export$b6114198c1e3ba8c = /** @class */ function(_super) {
    $b0f7c8984d47d037$var$__extends(MenuAnimationSettings, _super);
    function MenuAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("SlideDown")
    ], MenuAnimationSettings.prototype, "effect", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(400)
    ], MenuAnimationSettings.prototype, "duration", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("ease")
    ], MenuAnimationSettings.prototype, "easing", void 0);
    return MenuAnimationSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Base class for Menu and ContextMenu components.
 *
 *  @private
 */ var $b0f7c8984d47d037$export$5118460d8209bf35 = /** @class */ function(_super) {
    $b0f7c8984d47d037$var$__extends(MenuBase, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     * @param {MenuBaseModel} options - Specifies the menu base model
     * @param {string | HTMLUListElement} element - Specifies the element
     */ function MenuBase(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.navIdx = [];
        _this.animation = new (0, $kj1BR.Animation)({});
        _this.isTapHold = false;
        _this.tempItem = [];
        _this.showSubMenuOn = "Auto";
        _this.isAnimationNone = false;
        return _this;
    }
    /**
     * Initialized third party configuration settings.
     *
     * @private
     * @returns {void}
     */ MenuBase.prototype.preRender = function() {
        if (!this.isMenu) {
            var ul = void 0;
            if (this.element.tagName === "EJS-CONTEXTMENU") {
                ul = this.createElement("ul", {
                    id: (0, $3EnZW.getUniqueID)(this.getModuleName()),
                    className: "e-control e-lib e-" + this.getModuleName()
                });
                var ejInst = (0, $3EnZW.getValue)("ej2_instances", this.element);
                (0, $4ZDHT.removeClass)([
                    this.element
                ], [
                    "e-control",
                    "e-lib",
                    "e-" + this.getModuleName()
                ]);
                this.clonedElement = this.element;
                this.element = ul;
                (0, $3EnZW.setValue)("ej2_instances", ejInst, this.element);
            } else {
                ul = this.createElement("ul", {
                    id: (0, $3EnZW.getUniqueID)(this.getModuleName())
                });
                (0, $4ZDHT.append)([].slice.call(this.element.cloneNode(true).children), ul);
                var refEle = this.element.nextElementSibling;
                if (refEle) this.element.parentElement.insertBefore(ul, refEle);
                else this.element.parentElement.appendChild(ul);
                this.clonedElement = ul;
            }
            this.clonedElement.style.display = "none";
        }
        if (this.element.tagName === "EJS-MENU") {
            var ele = this.element;
            var ejInstance = (0, $3EnZW.getValue)("ej2_instances", ele);
            var ul = this.createElement("ul");
            var wrapper = this.createElement("EJS-MENU", {
                className: "e-" + this.getModuleName() + "-wrapper"
            });
            for(var idx = 0, len = ele.attributes.length; idx < len; idx++)ul.setAttribute(ele.attributes[idx].nodeName, ele.attributes[idx].nodeValue);
            ele.parentNode.insertBefore(wrapper, ele);
            (0, $4ZDHT.detach)(ele);
            ele = ul;
            wrapper.appendChild(ele);
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, ele);
            this.clonedElement = wrapper;
            this.element = ele;
            if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)(this.getModuleName());
        }
    };
    /**
     * Initialize the control rendering.
     *
     * @private
     * @returns {void}
     */ MenuBase.prototype.render = function() {
        var _this = this;
        this.initialize();
        this.renderItems();
        this.wireEvents();
        this.renderComplete();
        var wrapper = this.getWrapper();
        // eslint-disable-next-line
        if (this.template && this.enableScrolling && (this.isReact || this.isAngular)) requestAnimationFrame(function() {
            (0, $cd13d8ef6effb9e3$export$a45b277437001805)(_this.createElement, wrapper, _this.element, "hscroll", _this.enableRtl);
        });
    };
    MenuBase.prototype.initialize = function() {
        var wrapper = this.getWrapper();
        if (!wrapper) {
            wrapper = this.createElement("div", {
                className: "e-" + this.getModuleName() + "-wrapper"
            });
            if (this.isMenu) this.element.parentElement.insertBefore(wrapper, this.element);
            else document.body.appendChild(wrapper);
        }
        if (this.cssClass) (0, $4ZDHT.addClass)([
            wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        if (this.enableRtl) wrapper.classList.add($b0f7c8984d47d037$var$RTL);
        wrapper.appendChild(this.element);
        if (this.isMenu && this.hamburgerMode) {
            if (!this.target) this.createHeaderContainer(wrapper);
        }
        this.defaultOption = this.showItemOnClick;
    };
    MenuBase.prototype.renderItems = function() {
        if (!this.items.length) {
            var items = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createJsonFromElement(this.element, {
                fields: {
                    child: "items"
                }
            });
            this.setProperties({
                items: items
            }, true);
            if ((0, $3EnZW.isBlazor)() && !this.isMenu) this.element = this.removeChildElement(this.element);
            else this.element.innerHTML = "";
        }
        var ul = this.createItems(this.items);
        (0, $4ZDHT.append)(Array.prototype.slice.call(ul.children), this.element);
        this.element.classList.add("e-menu-parent");
        if (this.isMenu) {
            if (!this.hamburgerMode && this.element.classList.contains("e-vertical")) this.setBlankIconStyle(this.element);
            if (this.enableScrolling) {
                var wrapper = this.getWrapper();
                if (this.element.classList.contains("e-vertical")) (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this.createElement, wrapper, this.element, "vscroll", this.enableRtl);
                else (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this.createElement, wrapper, this.element, "hscroll", this.enableRtl);
            }
        } else {
            this.element.parentElement.setAttribute("role", "dialog");
            this.element.parentElement.setAttribute("aria-label", "context menu");
        }
    };
    MenuBase.prototype.wireEvents = function() {
        var wrapper = this.getWrapper();
        if (this.target) {
            var target = void 0;
            var targetElems = (0, $4ZDHT.selectAll)(this.target);
            for(var i = 0, len = targetElems.length; i < len; i++){
                target = targetElems[i];
                if (this.isMenu) (0, $aqzbR.EventHandler).add(target, "click", this.menuHeaderClickHandler, this);
                else if ((0, $5q7BP.Browser).isIos) new (0, $i528u.Touch)(target, {
                    tapHold: this.touchHandler.bind(this)
                });
                else (0, $aqzbR.EventHandler).add(target, "contextmenu", this.cmenuHandler, this);
            }
            this.targetElement = target;
            if (!this.isMenu) {
                (0, $aqzbR.EventHandler).add(this.targetElement, "scroll", this.scrollHandler, this);
                for(var _i = 0, _a = (0, $2vAqh.getScrollableParent)(this.targetElement); _i < _a.length; _i++){
                    var parent_1 = _a[_i];
                    (0, $aqzbR.EventHandler).add(parent_1, "scroll", this.scrollHandler, this);
                }
            }
        }
        if (!(0, $5q7BP.Browser).isDevice) {
            this.delegateMoverHandler = this.moverHandler.bind(this);
            this.delegateMouseDownHandler = this.mouseDownHandler.bind(this);
            (0, $aqzbR.EventHandler).add(this.isMenu ? document : wrapper, "mouseover", this.delegateMoverHandler, this);
            (0, $aqzbR.EventHandler).add(document, "mousedown", this.delegateMouseDownHandler, this);
        }
        this.delegateClickHandler = this.clickHandler.bind(this);
        (0, $aqzbR.EventHandler).add(document, "click", this.delegateClickHandler, this);
        this.wireKeyboardEvent(wrapper);
        this.rippleFn = (0, $kj1BR.rippleEffect)(wrapper, {
            selector: "." + $b0f7c8984d47d037$var$ITEM
        });
    };
    MenuBase.prototype.wireKeyboardEvent = function(element) {
        var keyConfigs = {
            downarrow: $b0f7c8984d47d037$var$DOWNARROW,
            uparrow: $b0f7c8984d47d037$var$UPARROW,
            enter: $b0f7c8984d47d037$var$ENTER,
            leftarrow: $b0f7c8984d47d037$var$LEFTARROW,
            rightarrow: $b0f7c8984d47d037$var$RIGHTARROW,
            escape: $b0f7c8984d47d037$var$ESCAPE
        };
        if (this.isMenu) {
            keyConfigs.home = $b0f7c8984d47d037$var$HOME;
            keyConfigs.end = $b0f7c8984d47d037$var$END;
            keyConfigs.tab = $b0f7c8984d47d037$var$TAB;
        }
        new (0, $dyv7X.KeyboardEvents)(element, {
            keyAction: this.keyBoardHandler.bind(this),
            keyConfigs: keyConfigs
        });
    };
    MenuBase.prototype.mouseDownHandler = function(e) {
        if ((0, $4ZDHT.closest)(e.target, ".e-" + this.getModuleName() + "-wrapper") !== this.getWrapper() && !(0, $4ZDHT.closest)(e.target, ".e-" + this.getModuleName() + "-popup")) this.closeMenu(this.isMenu ? null : this.navIdx.length, e);
    };
    MenuBase.prototype.keyHandler = function(e) {
        if (e.keyCode === 38 || e.keyCode === 40) {
            if (e.target && (e.target.classList.contains("e-contextmenu") || e.target.classList.contains("e-menu-item"))) e.preventDefault();
        }
    };
    MenuBase.prototype.keyBoardHandler = function(e) {
        var actionName = "";
        var trgt = e.target;
        var actionNeeded = this.isMenu && !this.hamburgerMode && !this.element.classList.contains("e-vertical") && this.navIdx.length < 1;
        e.preventDefault();
        if (this.enableScrolling && e.keyCode === 13 && trgt.classList.contains("e-scroll-nav")) this.removeLIStateByClass([
            $b0f7c8984d47d037$var$FOCUSED,
            $b0f7c8984d47d037$var$SELECTED
        ], [
            (0, $4ZDHT.closest)(trgt, ".e-" + this.getModuleName() + "-wrapper")
        ]);
        if (actionNeeded) switch(e.action){
            case $b0f7c8984d47d037$var$RIGHTARROW:
                actionName = $b0f7c8984d47d037$var$RIGHTARROW;
                e.action = $b0f7c8984d47d037$var$DOWNARROW;
                break;
            case $b0f7c8984d47d037$var$LEFTARROW:
                actionName = $b0f7c8984d47d037$var$LEFTARROW;
                e.action = $b0f7c8984d47d037$var$UPARROW;
                break;
            case $b0f7c8984d47d037$var$DOWNARROW:
                actionName = $b0f7c8984d47d037$var$DOWNARROW;
                e.action = $b0f7c8984d47d037$var$RIGHTARROW;
                break;
            case $b0f7c8984d47d037$var$UPARROW:
                actionName = $b0f7c8984d47d037$var$UPARROW;
                e.action = "";
                break;
        }
        else if (this.enableRtl) switch(e.action){
            case $b0f7c8984d47d037$var$LEFTARROW:
                actionNeeded = true;
                actionName = $b0f7c8984d47d037$var$LEFTARROW;
                e.action = $b0f7c8984d47d037$var$RIGHTARROW;
                break;
            case $b0f7c8984d47d037$var$RIGHTARROW:
                actionNeeded = true;
                actionName = $b0f7c8984d47d037$var$RIGHTARROW;
                e.action = $b0f7c8984d47d037$var$LEFTARROW;
                break;
        }
        switch(e.action){
            case $b0f7c8984d47d037$var$DOWNARROW:
            case $b0f7c8984d47d037$var$UPARROW:
            case $b0f7c8984d47d037$var$END:
            case $b0f7c8984d47d037$var$HOME:
            case $b0f7c8984d47d037$var$TAB:
                this.upDownKeyHandler(e);
                break;
            case $b0f7c8984d47d037$var$RIGHTARROW:
                this.rightEnterKeyHandler(e);
                break;
            case $b0f7c8984d47d037$var$LEFTARROW:
                this.leftEscKeyHandler(e);
                break;
            case $b0f7c8984d47d037$var$ENTER:
                if (this.hamburgerMode && trgt.tagName === "SPAN" && trgt.classList.contains("e-menu-icon")) this.menuHeaderClickHandler(e);
                else this.rightEnterKeyHandler(e);
                break;
            case $b0f7c8984d47d037$var$ESCAPE:
                this.leftEscKeyHandler(e);
                break;
        }
        if (actionNeeded) e.action = actionName;
    };
    MenuBase.prototype.upDownKeyHandler = function(e) {
        var cul = this.getUlByNavIdx();
        var defaultIdx = e.action === $b0f7c8984d47d037$var$DOWNARROW || e.action === $b0f7c8984d47d037$var$HOME || e.action === $b0f7c8984d47d037$var$TAB ? 0 : cul.childElementCount - 1;
        var fliIdx = defaultIdx;
        var fli = this.getLIByClass(cul, $b0f7c8984d47d037$var$FOCUSED);
        if (fli) {
            if (e.action !== $b0f7c8984d47d037$var$END && e.action !== $b0f7c8984d47d037$var$HOME) fliIdx = this.getIdx(cul, fli);
            fli.classList.remove($b0f7c8984d47d037$var$FOCUSED);
            if (e.action !== $b0f7c8984d47d037$var$END && e.action !== $b0f7c8984d47d037$var$HOME) {
                if (e.action === $b0f7c8984d47d037$var$DOWNARROW) fliIdx++;
                else fliIdx--;
                if (fliIdx === (e.action === $b0f7c8984d47d037$var$DOWNARROW ? cul.childElementCount : -1)) fliIdx = defaultIdx;
            }
        }
        var cli = cul.children[fliIdx];
        fliIdx = this.isValidLI(cli, fliIdx, e.action);
        cul.children[fliIdx].classList.add($b0f7c8984d47d037$var$FOCUSED);
        cul.children[fliIdx].focus();
    };
    MenuBase.prototype.isValidLI = function(cli, index, action) {
        var cul = this.getUlByNavIdx();
        var defaultIdx = action === $b0f7c8984d47d037$var$DOWNARROW || action === $b0f7c8984d47d037$var$HOME || action === $b0f7c8984d47d037$var$TAB ? 0 : cul.childElementCount - 1;
        if (cli.classList.contains($b0f7c8984d47d037$var$SEPARATOR) || cli.classList.contains($b0f7c8984d47d037$var$DISABLED) || cli.classList.contains($b0f7c8984d47d037$var$HIDE)) {
            if (action === $b0f7c8984d47d037$var$DOWNARROW && index === cul.childElementCount - 1) index = defaultIdx;
            else if (action === $b0f7c8984d47d037$var$UPARROW && index === 0) index = defaultIdx;
            else if (action === $b0f7c8984d47d037$var$DOWNARROW || action === $b0f7c8984d47d037$var$RIGHTARROW) index++;
            else if (action === "tab" && cli.classList.contains($b0f7c8984d47d037$var$SEPARATOR)) index++;
            else index--;
        }
        cli = cul.children[index];
        if (cli && (cli.classList.contains($b0f7c8984d47d037$var$SEPARATOR) || cli.classList.contains($b0f7c8984d47d037$var$DISABLED) || cli.classList.contains($b0f7c8984d47d037$var$HIDE))) index = this.isValidLI(cli, index, action);
        return index;
    };
    MenuBase.prototype.getUlByNavIdx = function(navIdxLen) {
        var _this = this;
        if (navIdxLen === void 0) navIdxLen = this.navIdx.length;
        if (this.isMenu) {
            var popup = [
                this.getWrapper()
            ].concat([].slice.call((0, $4ZDHT.selectAll)("." + $b0f7c8984d47d037$var$POPUP)))[navIdxLen];
            var popups_1 = [];
            var allPopup = (0, $4ZDHT.selectAll)("." + $b0f7c8984d47d037$var$POPUP);
            allPopup.forEach(function(elem) {
                if (_this.element.id === elem.id.split("-")[2] || elem.id.split("-")[2] + "-" + elem.id.split("-")[3]) popups_1.push(elem);
            });
            popup = [
                this.getWrapper()
            ].concat([].slice.call(popups_1))[navIdxLen];
            return (0, $3EnZW.isNullOrUndefined)(popup) ? null : (0, $4ZDHT.select)(".e-menu-parent", popup);
        } else {
            if (!document.body.contains(this.element) && navIdxLen === 0) return null;
            return this.getWrapper().children[navIdxLen];
        }
    };
    MenuBase.prototype.rightEnterKeyHandler = function(e) {
        var eventArgs;
        var cul = this.getUlByNavIdx();
        var fli = this.getLIByClass(cul, $b0f7c8984d47d037$var$FOCUSED);
        if (fli) {
            var fliIdx = this.getIdx(cul, fli);
            var navIdx = this.navIdx.concat(fliIdx);
            var item = this.getItem(navIdx);
            if (item.items.length) {
                this.navIdx.push(fliIdx);
                this.keyType = "right";
                this.action = e.action;
                this.openMenu(fli, item, -1, -1, e);
            } else if (e.action === $b0f7c8984d47d037$var$ENTER) {
                if (this.isMenu && this.navIdx.length === 0) this.removeLIStateByClass([
                    $b0f7c8984d47d037$var$SELECTED
                ], [
                    this.getWrapper()
                ]);
                else fli.classList.remove($b0f7c8984d47d037$var$FOCUSED);
                fli.classList.add($b0f7c8984d47d037$var$SELECTED);
                eventArgs = {
                    element: fli,
                    item: item,
                    event: e
                };
                this.trigger("select", eventArgs);
                var aEle = fli.querySelector(".e-menu-url");
                if (item.url && aEle) switch(aEle.getAttribute("target")){
                    case "_blank":
                        window.open(item.url, "_blank");
                        break;
                    case "_parent":
                        window.parent.location.href = item.url;
                        break;
                    default:
                        window.location.href = item.url;
                }
                this.closeMenu(null, e);
                var sli = this.getLIByClass(this.getUlByNavIdx(), $b0f7c8984d47d037$var$SELECTED);
                if (sli) {
                    sli.classList.add($b0f7c8984d47d037$var$FOCUSED);
                    sli.focus();
                }
            }
        }
    };
    MenuBase.prototype.leftEscKeyHandler = function(e) {
        if (this.navIdx.length) {
            this.keyType = "left";
            this.closeMenu(this.navIdx.length, e);
        } else if (e.action === $b0f7c8984d47d037$var$ESCAPE) this.closeMenu(null, e);
    };
    MenuBase.prototype.scrollHandler = function(e) {
        this.closeMenu(null, e);
    };
    MenuBase.prototype.touchHandler = function(e) {
        this.isTapHold = true;
        this.cmenuHandler(e.originalEvent);
    };
    MenuBase.prototype.cmenuHandler = function(e) {
        e.preventDefault();
        this.currentTarget = e.target;
        this.isCMenu = true;
        this.pageX = e.changedTouches ? e.changedTouches[0].pageX + 1 : e.pageX + 1;
        this.pageY = e.changedTouches ? e.changedTouches[0].pageY + 1 : e.pageY + 1;
        this.closeMenu(null, e);
        if (this.isCMenu) {
            if (this.canOpen(e.target)) this.openMenu(null, null, this.pageY, this.pageX, e);
            this.isCMenu = false;
        }
    };
    // eslint:disable-next-line:max-func-body-length
    MenuBase.prototype.closeMenu = function(ulIndex, e, isIterated) {
        var _this = this;
        if (ulIndex === void 0) ulIndex = 0;
        if (e === void 0) e = null;
        if (this.isMenuVisible()) {
            var sli = void 0;
            var item_1;
            var wrapper_1 = this.getWrapper();
            var beforeCloseArgs = void 0;
            var items_1;
            var popups = this.getPopups();
            var isClose = false;
            var cnt = this.isMenu ? popups.length + 1 : wrapper_1.childElementCount;
            var ul_1 = this.isMenu && cnt !== 1 ? (0, $4ZDHT.select)(".e-ul", popups[cnt - 2]) : (0, $4ZDHT.selectAll)(".e-menu-parent", wrapper_1)[cnt - 1];
            if (this.isMenu && ul_1.classList.contains("e-menu")) {
                sli = this.getLIByClass(ul_1, $b0f7c8984d47d037$var$SELECTED);
                if (sli) sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
                isClose = true;
            }
            if (!isClose) {
                var liElem_1 = e && e.target && this.getLI(e.target);
                if (liElem_1) this.cli = liElem_1;
                else this.cli = ul_1.children[0];
                item_1 = this.navIdx.length ? this.getItem(this.navIdx) : null;
                items_1 = item_1 ? item_1.items : this.items;
                beforeCloseArgs = {
                    element: ul_1,
                    parentItem: item_1,
                    items: items_1,
                    event: e,
                    cancel: false,
                    isFocused: true
                };
                this.trigger("beforeClose", beforeCloseArgs, function(observedCloseArgs) {
                    var popupEle;
                    var closeArgs;
                    var popupId = "";
                    var popupObj;
                    var isOpen = !observedCloseArgs.cancel;
                    if (isOpen || _this.isCMenu) {
                        if (_this.isMenu) {
                            popupEle = (0, $4ZDHT.closest)(ul_1, "." + $b0f7c8984d47d037$var$POPUP);
                            if (_this.hamburgerMode) {
                                popupEle.parentElement.style.minHeight = "";
                                (0, $4ZDHT.closest)(ul_1, ".e-menu-item").setAttribute("aria-expanded", "false");
                            }
                            _this.unWireKeyboardEvent(popupEle);
                            (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(popupEle.children[0], (0, $3471080cb1b09001$export$d9880af5395880d2)), popupEle.children[0]);
                            popupObj = (0, $3EnZW.getInstance)(popupEle, (0, $2vAqh.Popup));
                            popupObj.hide();
                            popupId = popupEle.id;
                            popupObj.destroy();
                            (0, $4ZDHT.detach)(popupEle);
                        } else {
                            _this.isContextMenuClosed = false;
                            _this.toggleAnimation(ul_1, false);
                        }
                        closeArgs = {
                            element: ul_1,
                            parentItem: item_1,
                            items: items_1
                        };
                        _this.trigger("onClose", closeArgs);
                        _this.navIdx.pop();
                        if (_this.navIdx.length === 0 && e && e.type === "keyup") _this.showSubMenu = false;
                        if (!_this.isMenu) {
                            (0, $aqzbR.EventHandler).remove(ul_1, "keydown", _this.keyHandler);
                            if (_this.keyType === "right") _this.keyType = "";
                        }
                    }
                    _this.updateReactTemplate();
                    var trgtliId;
                    var closedLi;
                    var trgtLi;
                    var trgtpopUp = _this.getWrapper() && _this.getUlByNavIdx();
                    if (_this.isCMenu) {
                        if (_this.canOpen(e.target)) _this.openMenu(null, null, _this.pageY, _this.pageX, e);
                        _this.isCMenu = false;
                    }
                    if (_this.isMenu && trgtpopUp && popupId.length) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var regExp = RegExp;
                        trgtliId = new regExp("(.*)-ej2menu-" + _this.element.id + "-popup").exec(popupId)[1];
                        closedLi = trgtpopUp.querySelector('[id="' + trgtliId + '"]');
                        trgtLi = liElem_1 && trgtpopUp.querySelector('[id="' + liElem_1.id + '"]');
                    } else if (trgtpopUp) {
                        closedLi = trgtpopUp.querySelector(".e-menu-item.e-selected");
                        trgtLi = liElem_1 && trgtpopUp.querySelector('[id="' + liElem_1.id + '"]');
                    }
                    var submenus = liElem_1 && liElem_1.querySelectorAll(".e-menu-item");
                    if (isOpen && _this.hamburgerMode && ulIndex && !submenus.length) _this.afterCloseMenu(e);
                    else if (isOpen && !_this.hamburgerMode && closedLi && !trgtLi && _this.keyType !== "left" && (_this.navIdx.length || !_this.isMenu && _this.navIdx.length === 0)) {
                        var ele = e && (e.target.classList.contains("e-vscroll") || e.target.classList.contains("e-scroll-nav")) ? (0, $4ZDHT.closest)(e.target, ".e-menu-wrapper") : null;
                        if (ele) {
                            ele = ele.querySelector(".e-menu-item");
                            if (_this.showItemOnClick || ele && _this.getIndex(ele.id, true).length <= _this.navIdx.length) _this.closeMenu(_this.navIdx[_this.navIdx.length - 1], e, true);
                        } else if (!(e && e.target.classList.contains("e-nav-arrow"))) _this.closeMenu(_this.navIdx[_this.navIdx.length - 1], e);
                    } else if (isOpen && !isIterated && !ulIndex && (_this.hamburgerMode && _this.navIdx.length || _this.navIdx.length === 1 && liElem_1 && trgtpopUp !== liElem_1.parentElement)) _this.closeMenu(null, e);
                    else if (isOpen && (0, $3EnZW.isNullOrUndefined)(ulIndex) && _this.navIdx.length) _this.closeMenu(null, e);
                    else if (isOpen && !_this.isMenu && !ulIndex && _this.navIdx.length === 0 && !_this.isMenusClosed && !_this.isCmenuHover) {
                        _this.isMenusClosed = true;
                        _this.closeMenu(0, e);
                    } else if (isOpen && _this.isMenu && e && e.target && _this.navIdx.length !== 0 && (0, $4ZDHT.closest)(e.target, ".e-menu-parent.e-control")) _this.closeMenu(0, e);
                    else if (isOpen && !_this.isMenu && (0, $4ZDHT.selectAll)(".e-menu-parent", wrapper_1)[ulIndex - 1] && e.which === 3) _this.closeMenu(null, e);
                    else {
                        if (isOpen && (_this.keyType === "right" || _this.keyType === "click")) _this.afterCloseMenu(e);
                        else {
                            var cul = _this.getUlByNavIdx();
                            var sli_1 = _this.getLIByClass(cul, $b0f7c8984d47d037$var$SELECTED);
                            if (sli_1) {
                                sli_1.setAttribute("aria-expanded", "false");
                                sli_1.classList.remove($b0f7c8984d47d037$var$SELECTED);
                                if (observedCloseArgs.isFocused && liElem_1 || _this.keyType === "left") {
                                    sli_1.classList.add($b0f7c8984d47d037$var$FOCUSED);
                                    if (!e.target || !e.target.classList.contains("e-edit-template")) sli_1.focus();
                                }
                            }
                            if (!isOpen && _this.hamburgerMode && liElem_1 && liElem_1.getAttribute("aria-expanded") === "false" && liElem_1.getAttribute("aria-haspopup") === "true") {
                                if ((0, $4ZDHT.closest)(liElem_1, ".e-menu-parent.e-control")) _this.navIdx = [];
                                else _this.navIdx.pop();
                                _this.navIdx.push(_this.cliIdx);
                                var item_2 = _this.getItem(_this.navIdx);
                                liElem_1.setAttribute("aria-expanded", "true");
                                _this.openMenu(liElem_1, item_2, -1, -1, e);
                            }
                        }
                        if (_this.navIdx.length < 1) {
                            if (_this.showSubMenuOn === "Hover" || _this.showSubMenuOn === "Click") {
                                _this.showItemOnClick = _this.defaultOption;
                                _this.showSubMenuOn = "Auto";
                            }
                        }
                    }
                    _this.removeStateWrapper();
                });
            }
        }
    };
    MenuBase.prototype.updateReactTemplate = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact && this.template && this.navIdx.length === 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var portals = void 0;
            if (this.portals) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            portals = this.portals.splice(0, this.items.length);
            this.clearTemplate([
                "template"
            ]);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.portals = portals;
            this.renderReactTemplates();
        }
    };
    MenuBase.prototype.getMenuItemModel = function(item, level) {
        if ((0, $3EnZW.isNullOrUndefined)(item)) return null;
        if ((0, $3EnZW.isNullOrUndefined)(level)) level = 0;
        var fields = this.getFields(level);
        return {
            text: item[fields.text],
            id: item[fields.id],
            items: item[fields.child],
            separator: item[fields.separator],
            iconCss: item[fields.iconCss],
            url: item[fields.url]
        };
    };
    MenuBase.prototype.getPopups = function() {
        var _this = this;
        var popups = [];
        [].slice.call(document.querySelectorAll("." + $b0f7c8984d47d037$var$POPUP)).forEach(function(elem) {
            if (!(0, $3EnZW.isNullOrUndefined)(elem.querySelector("." + $b0f7c8984d47d037$var$ITEM)) && _this.getIndex(elem.querySelector("." + $b0f7c8984d47d037$var$ITEM).id, true).length) popups.push(elem);
        });
        return popups;
    };
    MenuBase.prototype.isMenuVisible = function() {
        return this.navIdx.length > 0 || this.element.classList.contains("e-contextmenu") && (0, $4ZDHT.isVisible)(this.element).valueOf();
    };
    MenuBase.prototype.canOpen = function(target) {
        var canOpen = true;
        if (this.filter) {
            canOpen = false;
            var filter = this.filter.split(" ");
            for(var i = 0, len = filter.length; i < len; i++)if ((0, $4ZDHT.closest)(target, "." + filter[i])) {
                canOpen = true;
                break;
            }
        }
        return canOpen;
    };
    MenuBase.prototype.openMenu = function(li, item, top, left, e, target) {
        var _this = this;
        if (top === void 0) top = 0;
        if (left === void 0) left = 0;
        if (e === void 0) e = null;
        if (target === void 0) target = this.targetElement;
        var wrapper = this.getWrapper();
        this.lItem = li;
        var elemId = this.element.id !== "" ? this.element.id : "menu";
        this.isMenusClosed = false;
        if ((0, $3EnZW.isNullOrUndefined)(top)) top = -1;
        if ((0, $3EnZW.isNullOrUndefined)(left)) left = -1;
        if (li) {
            this.uList = this.createItems(item[this.getField("children", this.navIdx.length - 1)]);
            if (!this.isMenu && (0, $5q7BP.Browser).isDevice) {
                wrapper.lastChild.style.display = "none";
                var data = {
                    text: item[this.getField("text")].toString(),
                    iconCss: $b0f7c8984d47d037$var$ICONS + " e-previous"
                };
                var hdata = new $b0f7c8984d47d037$export$2ce376c2cc3355c8(this.items[0], "items", data, true);
                var hli = this.createItems([
                    hdata
                ]).children[0];
                hli.classList.add($b0f7c8984d47d037$var$HEADER);
                this.uList.insertBefore(hli, this.uList.children[0]);
            }
            if (this.isMenu) {
                this.popupWrapper = this.createElement("div", {
                    className: "e-" + this.getModuleName() + "-wrapper " + $b0f7c8984d47d037$var$POPUP,
                    id: li.id + "-ej2menu-" + elemId + "-popup"
                });
                if (this.hamburgerMode) {
                    top = li.offsetHeight;
                    li.appendChild(this.popupWrapper);
                } else document.body.appendChild(this.popupWrapper);
                this.isNestedOrVertical = this.element.classList.contains("e-vertical") || this.navIdx.length !== 1;
                this.popupObj = this.generatePopup(this.popupWrapper, this.uList, li, this.isNestedOrVertical);
                if (this.template) this.renderReactTemplates();
                if (this.hamburgerMode) this.calculateIndentSize(this.uList, li);
                else {
                    if (this.cssClass) (0, $4ZDHT.addClass)([
                        this.popupWrapper
                    ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    this.popupObj.hide();
                }
                if (!this.hamburgerMode && !this.showItemOnClick && this.hoverDelay) {
                    window.clearInterval(this.timer);
                    this.timer = window.setTimeout(function() {
                        _this.triggerBeforeOpen(li, _this.uList, item, e, 0, 0, "menu");
                    }, this.hoverDelay);
                } else this.triggerBeforeOpen(li, this.uList, item, e, 0, 0, "menu");
            } else {
                this.uList.style.zIndex = this.element.style.zIndex;
                wrapper.appendChild(this.uList);
                if (!this.showItemOnClick && this.hoverDelay) {
                    window.clearInterval(this.timer);
                    this.timer = window.setTimeout(function() {
                        _this.triggerBeforeOpen(li, _this.uList, item, e, top, left, "none");
                    }, this.hoverDelay);
                } else this.triggerBeforeOpen(li, this.uList, item, e, top, left, "none");
            }
        } else {
            this.uList = this.element;
            this.uList.style.zIndex = (0, $2vAqh.getZindexPartial)(target ? target : this.element).toString();
            if ((0, $3EnZW.isNullOrUndefined)(e)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var ev = document.createEvent("MouseEvents");
                ev.initEvent("click", true, false);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var targetEvent = this.copyObject(ev, {});
                targetEvent.target = targetEvent.srcElement = target;
                targetEvent.currentTarget = target;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.triggerBeforeOpen(li, this.uList, item, targetEvent, top, left, "none");
            } else this.triggerBeforeOpen(li, this.uList, item, e, top, left, "none");
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MenuBase.prototype.copyObject = function(source, destination) {
        // eslint-disable-next-line guard-for-in
        for(var prop in source)destination["" + prop] = source["" + prop];
        return destination;
    };
    MenuBase.prototype.calculateIndentSize = function(ul, li) {
        var liStyle = getComputedStyle(li);
        var liIndent = parseInt(liStyle.textIndent, 10);
        if (this.navIdx.length < 2 && !li.classList.contains("e-blankicon")) liIndent *= 2;
        else liIndent += liIndent / 4;
        ul.style.textIndent = liIndent + "px";
        var blankIconElem = ul.querySelectorAll(".e-blankicon");
        if (blankIconElem && blankIconElem.length) {
            var menuIconElem = ul.querySelector(".e-menu-icon");
            var menuIconElemStyle = getComputedStyle(menuIconElem);
            var blankIconIndent = parseInt(menuIconElemStyle.marginRight, 10) + menuIconElem.offsetWidth + liIndent;
            for(var i = 0; i < blankIconElem.length; i++)blankIconElem[i].style.textIndent = blankIconIndent + "px";
        }
    };
    MenuBase.prototype.generatePopup = function(popupWrapper, ul, li, isNestedOrVertical) {
        var _this = this;
        var popupObj = new (0, $2vAqh.Popup)(popupWrapper, {
            actionOnScroll: this.hamburgerMode ? "none" : "reposition",
            relateTo: li,
            collision: this.hamburgerMode ? {
                X: "none",
                Y: "none"
            } : {
                X: isNestedOrVertical || this.enableRtl ? "none" : "flip",
                Y: "fit"
            },
            position: isNestedOrVertical && !this.hamburgerMode ? {
                X: "right",
                Y: "top"
            } : {
                X: "left",
                Y: "bottom"
            },
            targetType: "relative",
            enableRtl: this.enableRtl,
            content: ul,
            open: function() {
                var scrollEle = (0, $4ZDHT.select)(".e-menu-vscroll", popupObj.element);
                if (scrollEle) {
                    scrollEle.style.height = "inherit";
                    scrollEle.style.maxHeight = "";
                }
                var ul = (0, $4ZDHT.select)(".e-ul", popupObj.element);
                popupObj.element.style.maxHeight = "";
                ul.focus();
                _this.triggerOpen(ul);
            }
        });
        return popupObj;
    };
    MenuBase.prototype.createHeaderContainer = function(wrapper) {
        wrapper = wrapper || this.getWrapper();
        var spanElem = this.createElement("span", {
            className: "e-" + this.getModuleName() + "-header"
        });
        var tempTitle = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(this.title) : this.title;
        var spanTitle = this.createElement("span", {
            className: "e-" + this.getModuleName() + "-title",
            innerHTML: tempTitle
        });
        var spanIcon = this.createElement("span", {
            className: "e-icons e-" + this.getModuleName() + "-icon",
            attrs: {
                "tabindex": "0"
            }
        });
        spanElem.appendChild(spanTitle);
        spanElem.appendChild(spanIcon);
        wrapper.insertBefore(spanElem, this.element);
    };
    MenuBase.prototype.openHamburgerMenu = function(e) {
        if (this.hamburgerMode) this.triggerBeforeOpen(null, this.element, null, e, 0, 0, "hamburger");
    };
    MenuBase.prototype.closeHamburgerMenu = function(e) {
        var _this = this;
        var beforeCloseArgs = {
            element: this.element,
            parentItem: null,
            event: e,
            items: this.items,
            cancel: false
        };
        this.trigger("beforeClose", beforeCloseArgs, function(observedHamburgerCloseArgs) {
            if (!observedHamburgerCloseArgs.cancel) {
                _this.closeMenu(null, e);
                _this.element.classList.add("e-hide-menu");
                _this.trigger("onClose", {
                    element: _this.element,
                    parentItem: null,
                    items: _this.items
                });
            }
        });
    };
    MenuBase.prototype.callFit = function(element, x, y, top, left) {
        return (0, $49u5W.fit)(element, null, {
            X: x,
            Y: y
        }, {
            top: top,
            left: left
        });
    };
    MenuBase.prototype.triggerBeforeOpen = function(li, ul, item, e, top, left, type) {
        var _this = this;
        var items = li ? item[this.getField("children", this.navIdx.length - 1)] : this.items;
        var eventArgs = {
            element: ul,
            items: items,
            parentItem: item,
            event: e,
            cancel: false,
            top: top,
            left: left,
            showSubMenuOn: "Auto"
        };
        var menuType = type;
        this.trigger("beforeOpen", eventArgs, function(observedOpenArgs) {
            switch(menuType){
                case "menu":
                    if (!_this.hamburgerMode) {
                        if (observedOpenArgs.showSubMenuOn !== "Auto") {
                            _this.showItemOnClick = !_this.defaultOption;
                            _this.showSubMenuOn = observedOpenArgs.showSubMenuOn;
                        }
                        _this.top = observedOpenArgs.top;
                        _this.left = observedOpenArgs.left;
                    }
                    _this.popupWrapper.style.display = "block";
                    if (!_this.hamburgerMode) {
                        _this.popupWrapper.style.maxHeight = _this.popupWrapper.getBoundingClientRect().height + "px";
                        if (_this.enableScrolling) (0, $cd13d8ef6effb9e3$export$a45b277437001805)(_this.createElement, _this.popupWrapper, _this.uList, "vscroll", _this.enableRtl);
                        _this.checkScrollOffset(e);
                    }
                    if (!_this.hamburgerMode && !_this.left && !_this.top) {
                        _this.popupObj.refreshPosition(_this.lItem, true);
                        _this.left = parseInt(_this.popupWrapper.style.left, 10);
                        _this.top = parseInt(_this.popupWrapper.style.top, 10);
                        if (_this.enableRtl) _this.left = _this.isNestedOrVertical ? _this.left - _this.popupWrapper.offsetWidth - _this.lItem.parentElement.offsetWidth + 2 : _this.left - _this.popupWrapper.offsetWidth + _this.lItem.offsetWidth;
                        // eslint-disable-next-line
                        if (_this.template && (_this.isReact || _this.isAngular)) requestAnimationFrame(function() {
                            _this.collision();
                            _this.popupWrapper.style.display = "";
                        });
                        else {
                            _this.collision();
                            _this.popupWrapper.style.display = "";
                        }
                    } else {
                        _this.popupObj.collision = {
                            X: "none",
                            Y: "none"
                        };
                        _this.popupWrapper.style.display = "";
                    }
                    break;
                case "none":
                    _this.top = observedOpenArgs.top;
                    _this.left = observedOpenArgs.left;
                    _this.isContextMenuClosed = true;
                    break;
                case "hamburger":
                    if (!observedOpenArgs.cancel) {
                        _this.element.classList.remove("e-hide-menu");
                        _this.triggerOpen(_this.element);
                    }
                    break;
            }
            if (menuType !== "hamburger") {
                if (observedOpenArgs.cancel) {
                    if (_this.isMenu) {
                        _this.popupObj.destroy();
                        (0, $4ZDHT.detach)(_this.popupWrapper);
                    } else if (ul.className.indexOf("e-ul") > -1) (0, $4ZDHT.detach)(ul);
                    _this.navIdx.pop();
                } else if (_this.isMenu) {
                    if (_this.hamburgerMode) {
                        _this.popupWrapper.style.top = _this.top + "px";
                        _this.popupWrapper.style.left = "0px";
                        _this.toggleAnimation(_this.popupWrapper);
                    } else {
                        _this.setBlankIconStyle(_this.popupWrapper);
                        _this.wireKeyboardEvent(_this.popupWrapper);
                        (0, $kj1BR.rippleEffect)(_this.popupWrapper, {
                            selector: "." + $b0f7c8984d47d037$var$ITEM
                        });
                        _this.popupWrapper.style.left = _this.left + "px";
                        _this.popupWrapper.style.top = _this.top + "px";
                        var animationOptions = _this.animationSettings.effect !== "None" ? {
                            name: _this.animationSettings.effect,
                            duration: _this.animationSettings.duration,
                            timingFunction: _this.animationSettings.easing
                        } : null;
                        _this.popupObj.show(animationOptions, _this.lItem);
                    }
                } else {
                    _this.setBlankIconStyle(_this.uList);
                    _this.setPosition(_this.lItem, _this.uList, _this.top, _this.left);
                    _this.toggleAnimation(_this.uList);
                }
            }
            if (_this.keyType === "right") {
                var cul = _this.getUlByNavIdx();
                li.classList.remove($b0f7c8984d47d037$var$FOCUSED);
                if (_this.isMenu && _this.navIdx.length === 1) _this.removeLIStateByClass([
                    $b0f7c8984d47d037$var$SELECTED
                ], [
                    _this.getWrapper()
                ]);
                li.classList.add($b0f7c8984d47d037$var$SELECTED);
                if (_this.action === $b0f7c8984d47d037$var$ENTER) {
                    var eventArgs_1 = {
                        element: li,
                        item: item,
                        event: e
                    };
                    _this.trigger("select", eventArgs_1);
                }
                li.focus();
                cul = _this.getUlByNavIdx();
                var index = _this.isValidLI(cul.children[0], 0, _this.action);
                cul.children[index].classList.add($b0f7c8984d47d037$var$FOCUSED);
                cul.children[index].focus();
            }
        });
    };
    MenuBase.prototype.collision = function() {
        var collide;
        collide = (0, $49u5W.isCollide)(this.popupWrapper, null, this.left, this.top);
        if ((this.isNestedOrVertical || this.enableRtl) && (collide.indexOf("right") > -1 || collide.indexOf("left") > -1)) {
            this.popupObj.collision.X = "none";
            var offWidth = (0, $4ZDHT.closest)(this.lItem, ".e-" + this.getModuleName() + "-wrapper").offsetWidth;
            this.left = this.enableRtl ? (0, $cWXlQ.calculatePosition)(this.lItem, this.isNestedOrVertical ? "right" : "left", "top").left : this.left - this.popupWrapper.offsetWidth - offWidth + 2;
        }
        collide = (0, $49u5W.isCollide)(this.popupWrapper, null, this.left, this.top);
        if (collide.indexOf("left") > -1 || collide.indexOf("right") > -1) this.left = this.callFit(this.popupWrapper, true, false, this.top, this.left).left;
        this.popupWrapper.style.left = this.left + "px";
    };
    MenuBase.prototype.setBlankIconStyle = function(menu) {
        var blankIconList = [].slice.call(menu.getElementsByClassName("e-blankicon"));
        if (!blankIconList.length) return;
        var iconLi = menu.querySelector(".e-menu-item:not(.e-blankicon):not(.e-separator)");
        if (!iconLi) return;
        var icon = iconLi.querySelector(".e-menu-icon");
        if (!icon) return;
        var cssProp = this.enableRtl ? {
            padding: "paddingRight",
            margin: "marginLeft"
        } : {
            padding: "paddingLeft",
            margin: "marginRight"
        };
        var iconCssProps = getComputedStyle(icon);
        var iconSize = parseInt(iconCssProps.fontSize, 10);
        if (!!parseInt(iconCssProps.width, 10) && parseInt(iconCssProps.width, 10) > iconSize) iconSize = parseInt(iconCssProps.width, 10);
        // eslint:disable
        var size = iconSize + parseInt(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        iconCssProps[cssProp.margin], 10) + parseInt(getComputedStyle(iconLi)[cssProp.padding], 10) + "px";
        blankIconList.forEach(function(li) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            li.style[cssProp.padding] = size;
        });
    // eslint:enable
    };
    MenuBase.prototype.checkScrollOffset = function(e) {
        var wrapper = this.getWrapper();
        if (wrapper.children[0].classList.contains("e-menu-hscroll") && this.navIdx.length === 1) {
            var trgt = (0, $3EnZW.isNullOrUndefined)(e) ? this.element : (0, $4ZDHT.closest)(e.target, "." + $b0f7c8984d47d037$var$ITEM);
            var offsetEle = (0, $4ZDHT.select)(".e-hscroll-bar", wrapper);
            if (offsetEle.scrollLeft > trgt.offsetLeft) offsetEle.scrollLeft -= offsetEle.scrollLeft - trgt.offsetLeft;
            var offsetLeft = offsetEle.scrollLeft + offsetEle.offsetWidth;
            var offsetRight = trgt.offsetLeft + trgt.offsetWidth;
            if (offsetLeft < offsetRight) offsetEle.scrollLeft += offsetRight - offsetLeft;
        }
    };
    MenuBase.prototype.setPosition = function(li, ul, top, left) {
        var px = "px";
        this.toggleVisiblity(ul);
        if (ul === this.element || left > -1 && top > -1) {
            var collide = (0, $49u5W.isCollide)(ul, null, left, top);
            if (collide.indexOf("right") > -1) left = left - ul.offsetWidth;
            if (collide.indexOf("bottom") > -1) {
                var offset = this.callFit(ul, false, true, top, left);
                top = offset.top - 20;
                if (top < 0) {
                    var newTop = pageYOffset + document.documentElement.clientHeight - ul.getBoundingClientRect().height;
                    if (newTop > -1) top = newTop;
                }
            }
            collide = (0, $49u5W.isCollide)(ul, null, left, top);
            if (collide.indexOf("left") > -1) {
                var offset = this.callFit(ul, true, false, top, left);
                left = offset.left;
            }
        } else if ((0, $5q7BP.Browser).isDevice) {
            top = Number(this.element.style.top.replace(px, ""));
            left = Number(this.element.style.left.replace(px, ""));
        } else {
            var x = this.enableRtl ? "left" : "right";
            var offset = (0, $cWXlQ.calculatePosition)(li, x, "top");
            top = offset.top;
            left = offset.left;
            var collide = (0, $49u5W.isCollide)(ul, null, this.enableRtl ? left - ul.offsetWidth : left, top);
            var xCollision = collide.indexOf("left") > -1 || collide.indexOf("right") > -1;
            if (xCollision) {
                offset = (0, $cWXlQ.calculatePosition)(li, this.enableRtl ? "right" : "left", "top");
                left = offset.left;
            }
            if (this.enableRtl || xCollision) left = this.enableRtl && xCollision ? left : left - ul.offsetWidth;
            if (collide.indexOf("bottom") > -1) {
                offset = this.callFit(ul, false, true, top, left);
                top = offset.top;
            }
        }
        this.toggleVisiblity(ul, false);
        ul.style.top = top + px;
        ul.style.left = left + px;
    };
    MenuBase.prototype.toggleVisiblity = function(ul, isVisible) {
        if (isVisible === void 0) isVisible = true;
        ul.style.visibility = isVisible ? "hidden" : "";
        ul.style.display = isVisible ? "block" : "none";
    };
    MenuBase.prototype.createItems = function(items) {
        var _this = this;
        var level = this.navIdx ? this.navIdx.length : 0;
        var fields = this.getFields(level);
        var showIcon = this.hasField(items, this.getField("iconCss", level));
        var listBaseOptions = {
            showIcon: showIcon,
            moduleName: "menu",
            fields: fields,
            template: this.template,
            itemNavigable: true,
            itemCreating: function(args) {
                if (!args.curData[args.fields[fields.id]]) args.curData[args.fields[fields.id]] = (0, $3EnZW.getUniqueID)("menuitem");
                if ((0, $3EnZW.isNullOrUndefined)(args.curData.htmlAttributes)) args.curData.htmlAttributes = {};
                if ((0, $5q7BP.Browser).isIE) {
                    args.curData.htmlAttributes.role = "menuitem";
                    args.curData.htmlAttributes.tabindex = "-1";
                } else Object.assign(args.curData.htmlAttributes, {
                    role: "menuitem",
                    tabindex: "-1"
                });
                if (_this.isMenu && !args.curData[_this.getField("separator", level)]) args.curData.htmlAttributes["aria-label"] = args.curData[args.fields.text] ? args.curData[args.fields.text] : args.curData[args.fields.id];
                if (args.curData[args.fields[fields.iconCss]] === "") args.curData[args.fields[fields.iconCss]] = null;
            },
            itemCreated: function(args) {
                if (args.curData[_this.getField("separator", level)]) {
                    args.item.classList.add($b0f7c8984d47d037$var$SEPARATOR);
                    args.item.setAttribute("role", "separator");
                }
                if (showIcon && !args.curData[args.fields.iconCss] && !args.curData[_this.getField("separator", level)]) args.item.classList.add("e-blankicon");
                if (args.curData[args.fields.child] && args.curData[args.fields.child].length) {
                    var span = _this.createElement("span", {
                        className: $b0f7c8984d47d037$var$ICONS + " " + $b0f7c8984d47d037$var$CARET
                    });
                    args.item.appendChild(span);
                    args.item.setAttribute("aria-haspopup", "true");
                    args.item.setAttribute("aria-expanded", "false");
                    args.item.classList.add("e-menu-caret-icon");
                }
                if (_this.isMenu && _this.template) {
                    args.item.setAttribute("id", args.curData[args.fields.id].toString());
                    args.item.removeAttribute("data-uid");
                    if (args.item.classList.contains("e-level-1")) args.item.classList.remove("e-level-1");
                    if (args.item.classList.contains("e-has-child")) args.item.classList.remove("e-has-child");
                    args.item.removeAttribute("aria-level");
                }
                var eventArgs = {
                    item: args.curData,
                    element: args.item
                };
                _this.trigger("beforeItemRender", eventArgs);
            }
        };
        this.setProperties({
            "items": this.items
        }, true);
        if (this.isMenu) listBaseOptions.templateID = this.element.id + $b0f7c8984d47d037$var$TEMPLATE_PROPERTY;
        var ul = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, items, listBaseOptions, !this.template, this);
        ul.setAttribute("tabindex", "0");
        if (this.isMenu) ul.setAttribute("role", "menu");
        else ul.setAttribute("role", "menubar");
        return ul;
    };
    MenuBase.prototype.moverHandler = function(e) {
        var trgt = e.target;
        this.liTrgt = trgt;
        if (!this.isMenu) this.isCmenuHover = true;
        var cli = this.getLI(trgt);
        var wrapper = cli ? (0, $4ZDHT.closest)(cli, ".e-" + this.getModuleName() + "-wrapper") : this.getWrapper();
        var hdrWrapper = this.getWrapper();
        var regex = new RegExp("-ej2menu-(.*)-popup");
        var ulId;
        var isDifferentElem = false;
        if (!wrapper) return;
        if (wrapper.id !== "") ulId = regex.exec(wrapper.id)[1];
        else ulId = wrapper.querySelector("ul").id;
        if (ulId !== this.element.id) {
            this.removeLIStateByClass([
                $b0f7c8984d47d037$var$FOCUSED,
                $b0f7c8984d47d037$var$SELECTED
            ], [
                this.getWrapper()
            ]);
            if (this.navIdx.length) isDifferentElem = true;
            else return;
        }
        if (cli && (0, $4ZDHT.closest)(cli, ".e-" + this.getModuleName() + "-wrapper") && !isDifferentElem) {
            this.removeLIStateByClass([
                $b0f7c8984d47d037$var$FOCUSED
            ], this.isMenu ? [
                wrapper
            ].concat(this.getPopups()) : [
                wrapper
            ]);
            this.removeLIStateByClass([
                $b0f7c8984d47d037$var$FOCUSED
            ], this.isMenu ? [
                hdrWrapper
            ].concat(this.getPopups()) : [
                hdrWrapper
            ]);
            cli.classList.add($b0f7c8984d47d037$var$FOCUSED);
            if (!this.showItemOnClick) this.clickHandler(e);
        } else if (this.isMenu && this.showItemOnClick && !isDifferentElem) this.removeLIStateByClass([
            $b0f7c8984d47d037$var$FOCUSED
        ], [
            wrapper
        ].concat(this.getPopups()));
        if (this.isMenu) {
            if (!this.showItemOnClick && trgt.parentElement !== wrapper && !(0, $4ZDHT.closest)(trgt, ".e-" + this.getModuleName() + "-popup") && (!cli || cli && !this.getIndex(cli.id, true).length) && this.showSubMenuOn !== "Hover") {
                this.removeLIStateByClass([
                    $b0f7c8984d47d037$var$FOCUSED
                ], [
                    wrapper
                ]);
                if (this.navIdx.length) {
                    this.isClosed = true;
                    this.closeMenu(null, e);
                }
            } else if (isDifferentElem && !this.showItemOnClick) {
                if (this.navIdx.length) {
                    this.isClosed = true;
                    this.closeMenu(null, e);
                }
            }
            if (!this.isClosed) this.removeStateWrapper();
            this.isClosed = false;
        }
        if (!this.isMenu) this.isCmenuHover = false;
    };
    MenuBase.prototype.removeStateWrapper = function() {
        if (this.liTrgt) {
            var wrapper = (0, $4ZDHT.closest)(this.liTrgt, ".e-menu-vscroll");
            if (this.liTrgt.tagName === "DIV" && wrapper) this.removeLIStateByClass([
                $b0f7c8984d47d037$var$FOCUSED,
                $b0f7c8984d47d037$var$SELECTED
            ], [
                wrapper
            ]);
        }
    };
    MenuBase.prototype.removeLIStateByClass = function(classList, element) {
        var li;
        var _loop_1 = function(i) {
            classList.forEach(function(className) {
                li = (0, $4ZDHT.select)("." + className, element[i]);
                if (li) li.classList.remove(className);
            });
        };
        for(var i = 0; i < element.length; i++)_loop_1(i);
    };
    MenuBase.prototype.getField = function(propName, level) {
        if (level === void 0) level = 0;
        var fieldName = this.fields["" + propName];
        return typeof fieldName === "string" ? fieldName : !fieldName[level] ? fieldName[fieldName.length - 1].toString() : fieldName[level].toString();
    };
    MenuBase.prototype.getFields = function(level) {
        if (level === void 0) level = 0;
        return {
            id: this.getField("itemId", level),
            iconCss: this.getField("iconCss", level),
            text: this.getField("text", level),
            url: this.getField("url", level),
            child: this.getField("children", level),
            separator: this.getField("separator", level)
        };
    };
    MenuBase.prototype.hasField = function(items, field) {
        for(var i = 0, len = items.length; i < len; i++){
            if (items[i]["" + field]) return true;
        }
        return false;
    };
    MenuBase.prototype.menuHeaderClickHandler = function(e) {
        var menuWrapper = (0, $4ZDHT.closest)(e.target, ".e-menu-wrapper");
        if (menuWrapper && menuWrapper.querySelector("ul.e-menu-parent").id !== this.element.id) return;
        if (this.element.className.indexOf("e-hide-menu") > -1) this.openHamburgerMenu(e);
        else this.closeHamburgerMenu(e);
    };
    MenuBase.prototype.clickHandler = function(e) {
        this.isTapHold = this.isTapHold ? false : this.isTapHold;
        var wrapper = this.getWrapper();
        var trgt = e.target;
        var cli = this.cli = this.getLI(trgt);
        var regex = new RegExp("-ej2menu-(.*)-popup");
        var cliWrapper = cli ? (0, $4ZDHT.closest)(cli, ".e-" + this.getModuleName() + "-wrapper") : null;
        var isInstLI = cli && cliWrapper && (this.isMenu ? this.getIndex(cli.id, true).length > 0 : wrapper.firstElementChild.id === cliWrapper.firstElementChild.id);
        if ((0, $5q7BP.Browser).isDevice && this.isMenu) {
            this.removeLIStateByClass([
                $b0f7c8984d47d037$var$FOCUSED
            ], [
                wrapper
            ].concat(this.getPopups()));
            this.mouseDownHandler(e);
        }
        if (cli && cliWrapper && this.isMenu) {
            var cliWrapperId = cliWrapper.id ? regex.exec(cliWrapper.id)[1] : cliWrapper.querySelector(".e-menu-parent").id;
            if (this.element.id !== cliWrapperId) return;
        }
        if (isInstLI && e.type === "click" && !cli.classList.contains($b0f7c8984d47d037$var$HEADER)) {
            this.setLISelected(cli);
            var navIdx = this.getIndex(cli.id, true);
            var item = this.getItem(navIdx);
            var eventArgs = {
                element: cli,
                item: item,
                event: e
            };
            this.trigger("select", eventArgs);
        }
        if (isInstLI && (e.type === "mouseover" || (0, $5q7BP.Browser).isDevice || this.showItemOnClick)) {
            var ul = void 0;
            if (cli.classList.contains($b0f7c8984d47d037$var$HEADER)) {
                ul = wrapper.children[this.navIdx.length - 1];
                this.toggleAnimation(ul);
                var sli = this.getLIByClass(ul, $b0f7c8984d47d037$var$SELECTED);
                if (sli) sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
                (0, $4ZDHT.detach)(cli.parentNode);
                this.navIdx.pop();
            } else if (!cli.classList.contains($b0f7c8984d47d037$var$SEPARATOR)) {
                this.showSubMenu = true;
                var cul = cli.parentNode;
                if ((0, $3EnZW.isNullOrUndefined)(cul)) return;
                this.cliIdx = this.getIdx(cul, cli);
                if (this.isMenu || !(0, $5q7BP.Browser).isDevice) {
                    var culIdx = this.isMenu ? Array.prototype.indexOf.call([
                        wrapper
                    ].concat(this.getPopups()), (0, $4ZDHT.closest)(cul, ".e-" + this.getModuleName() + "-wrapper")) : this.getIdx(wrapper, cul);
                    if (this.navIdx[culIdx] === this.cliIdx) this.showSubMenu = false;
                    if (culIdx !== this.navIdx.length && (e.type !== "mouseover" || this.showSubMenu)) {
                        var sli = this.getLIByClass(cul, $b0f7c8984d47d037$var$SELECTED);
                        if (sli) sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
                        this.isClosed = true;
                        this.keyType = "click";
                        if (this.showItemOnClick) {
                            this.setLISelected(cli);
                            if (!this.isMenu) this.isCmenuHover = true;
                        }
                        this.closeMenu(culIdx + 1, e);
                        if (this.showItemOnClick) {
                            this.setLISelected(cli);
                            if (!this.isMenu) this.isCmenuHover = false;
                        }
                    }
                }
                if (!this.isClosed) this.afterCloseMenu(e);
                this.isClosed = false;
            }
        } else {
            if (this.isMenu && trgt.tagName === "DIV" && this.navIdx.length && (0, $4ZDHT.closest)(trgt, ".e-menu-vscroll")) {
                var popupEle = (0, $4ZDHT.closest)(trgt, "." + $b0f7c8984d47d037$var$POPUP);
                var cIdx = Array.prototype.indexOf.call(this.getPopups(), popupEle) + 1;
                if (cIdx < this.navIdx.length) {
                    this.closeMenu(cIdx + 1, e);
                    if (popupEle) this.removeLIStateByClass([
                        $b0f7c8984d47d037$var$FOCUSED,
                        $b0f7c8984d47d037$var$SELECTED
                    ], [
                        popupEle
                    ]);
                }
            } else if (this.isMenu && this.hamburgerMode && trgt.tagName === "SPAN" && trgt.classList.contains("e-menu-icon")) this.menuHeaderClickHandler(e);
            else if (trgt.tagName !== "UL" || (this.isMenu ? trgt.parentElement.classList.contains("e-menu-wrapper") && !this.getIndex(trgt.querySelector("." + $b0f7c8984d47d037$var$ITEM).id, true).length : trgt.parentElement !== wrapper)) {
                if (!cli) this.removeLIStateByClass([
                    $b0f7c8984d47d037$var$SELECTED
                ], [
                    wrapper
                ]);
                if (!this.isAnimationNone && !cli || cli && !cli.querySelector("." + $b0f7c8984d47d037$var$CARET)) {
                    if (navigator.platform.toUpperCase().indexOf("MAC") < 0 || navigator.platform.toUpperCase().indexOf("MAC") >= 0 && !e.ctrlKey) this.closeMenu(null, e);
                }
            }
        }
    };
    MenuBase.prototype.afterCloseMenu = function(e) {
        if ((0, $3EnZW.isNullOrUndefined)(e)) return;
        var isHeader;
        if (this.showSubMenu) {
            if (this.showItemOnClick && this.navIdx.length === 0) isHeader = (0, $4ZDHT.closest)(e.target, ".e-menu-parent.e-control");
            else isHeader = (0, $4ZDHT.closest)(this.element, ".e-menu-parent.e-control");
            var idx = this.navIdx.concat(this.cliIdx);
            var item = this.getItem(idx);
            if (item && item[this.getField("children", idx.length - 1)] && item[this.getField("children", idx.length - 1)].length) {
                if (e.type === "mouseover" || (0, $5q7BP.Browser).isDevice && this.isMenu) this.setLISelected(this.cli);
                if (!this.hamburgerMode && isHeader || this.hamburgerMode && this.cli.getAttribute("aria-expanded") === "false") {
                    this.cli.setAttribute("aria-expanded", "true");
                    this.navIdx.push(this.cliIdx);
                    this.openMenu(this.cli, item, null, null, e);
                }
            } else if (e.type !== "mouseover") this.closeMenu(null, e);
            if (!isHeader) {
                var cul = this.getUlByNavIdx();
                var sli = this.getLIByClass(cul, $b0f7c8984d47d037$var$SELECTED);
                if (sli) {
                    sli.setAttribute("aria-expanded", "false");
                    sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
                }
            }
        }
        this.keyType = "";
    };
    MenuBase.prototype.setLISelected = function(li) {
        var sli = this.getLIByClass(li.parentElement, $b0f7c8984d47d037$var$SELECTED);
        if (sli) sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
        if (!this.isMenu) li.classList.remove($b0f7c8984d47d037$var$FOCUSED);
        li.classList.add($b0f7c8984d47d037$var$SELECTED);
    };
    MenuBase.prototype.getLIByClass = function(ul, classname) {
        if (ul && ul.children) for(var i = 0, len = ul.children.length; i < len; i++){
            if (ul.children[i].classList.contains(classname)) return ul.children[i];
        }
        return null;
    };
    /**
     * This method is used to get the index of the menu item in the Menu based on the argument.
     *
     * @param {MenuItem | string} item - item be passed to get the index | id to be passed to get the item index.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.getItemIndex = function(item, isUniqueId) {
        var idx;
        if (typeof item === "string") idx = item;
        else idx = item.id;
        var isText = isUniqueId === false ? false : true;
        var navIdx = this.getIndex(idx, isText);
        return navIdx;
    };
    /**
     * This method is used to set the menu item in the Menu based on the argument.
     *
     * @param {MenuItem} item - item need to be updated.
     * @param {string} id - id / text to be passed to update the item.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.setItem = function(item, id, isUniqueId) {
        var idx;
        if (isUniqueId) idx = id ? id : item.id;
        else idx = id ? id : item.text;
        var navIdx = this.getIndex(idx, isUniqueId);
        var newItem = this.getItem(navIdx);
        Object.assign(newItem, item);
    };
    MenuBase.prototype.getItem = function(navIdx) {
        navIdx = navIdx.slice();
        var idx = navIdx.pop();
        var items = this.getItems(navIdx);
        return items[idx];
    };
    MenuBase.prototype.getItems = function(navIdx) {
        var items = this.items;
        for(var i = 0; i < navIdx.length; i++)items = items[navIdx[i]][this.getField("children", i)];
        return items;
    };
    MenuBase.prototype.setItems = function(newItems, navIdx) {
        var items = this.getItems(navIdx);
        items.splice(0, items.length);
        for(var i = 0; i < newItems.length; i++)items.splice(i, 0, newItems[i]);
    };
    MenuBase.prototype.getIdx = function(ul, li, skipHdr) {
        if (skipHdr === void 0) skipHdr = true;
        var idx = Array.prototype.indexOf.call(ul.children, li);
        if (skipHdr && ul.children[0].classList.contains($b0f7c8984d47d037$var$HEADER)) idx--;
        return idx;
    };
    MenuBase.prototype.getLI = function(elem) {
        if (elem.tagName === "LI" && elem.classList.contains("e-menu-item")) return elem;
        return (0, $4ZDHT.closest)(elem, "li.e-menu-item");
    };
    MenuBase.prototype.updateItemsByNavIdx = function() {
        var items = this.items;
        var count = 0;
        for(var index = 0; index < this.navIdx.length; index++){
            items = items[index].items;
            if (!items) break;
            count++;
            var ul = this.getUlByNavIdx(count);
            if (!ul) break;
            this.updateItem(ul, items);
        }
    };
    MenuBase.prototype.removeChildElement = function(elem) {
        while(elem.firstElementChild)elem.removeChild(elem.firstElementChild);
        return elem;
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {MenuBaseModel} newProp - Specifies the new properties
     * @param {MenuBaseModel} oldProp - Specifies the old properties
     * @returns {void}
     */ MenuBase.prototype.onPropertyChanged = function(newProp, oldProp) {
        var _this = this;
        var wrapper = this.getWrapper();
        var _loop_2 = function(prop) {
            switch(prop){
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        wrapper
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        wrapper
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "enableRtl":
                    if (this_1.enableRtl) wrapper.classList.add($b0f7c8984d47d037$var$RTL);
                    else wrapper.classList.remove($b0f7c8984d47d037$var$RTL);
                    break;
                case "showItemOnClick":
                    this_1.unWireEvents();
                    this_1.showItemOnClick = newProp.showItemOnClick;
                    this_1.wireEvents();
                    break;
                case "enableScrolling":
                    if (newProp.enableScrolling) {
                        var ul_2;
                        if (this_1.element.classList.contains("e-vertical")) (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this_1.createElement, wrapper, this_1.element, "vscroll", this_1.enableRtl);
                        else (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this_1.createElement, wrapper, this_1.element, "hscroll", this_1.enableRtl);
                        this_1.getPopups().forEach(function(wrapper) {
                            ul_2 = (0, $4ZDHT.select)(".e-ul", wrapper);
                            (0, $cd13d8ef6effb9e3$export$a45b277437001805)(_this.createElement, wrapper, ul_2, "vscroll", _this.enableRtl);
                        });
                    } else {
                        var ul_3 = wrapper.children[0];
                        if (this_1.element.classList.contains("e-vertical")) (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(ul_3, (0, $3471080cb1b09001$export$d9880af5395880d2)), ul_3);
                        else (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(ul_3, (0, $ffe4a1d7d733585d$export$49487f80cf9ca6b1)), ul_3);
                        wrapper.style.overflow = "";
                        wrapper.appendChild(this_1.element);
                        this_1.getPopups().forEach(function(wrapper) {
                            ul_3 = wrapper.children[0];
                            (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(ul_3, (0, $3471080cb1b09001$export$d9880af5395880d2)), ul_3);
                            wrapper.style.overflow = "";
                        });
                    }
                    break;
                case "items":
                    var idx = void 0;
                    var navIdx = void 0;
                    var item = void 0;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (this_1.isReact && this_1.template) this_1.clearTemplate([
                        "template"
                    ]);
                    if (!Object.keys(oldProp.items).length) {
                        this_1.updateItem(this_1.element, this_1.items);
                        if (this_1.enableScrolling && this_1.element.parentElement.classList.contains("e-custom-scroll")) {
                            if (this_1.element.classList.contains("e-vertical")) (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this_1.createElement, wrapper, this_1.element, "vscroll", this_1.enableRtl);
                            else (0, $cd13d8ef6effb9e3$export$a45b277437001805)(this_1.createElement, wrapper, this_1.element, "hscroll", this_1.enableRtl);
                        }
                        if (!this_1.hamburgerMode) for(var i = 1, count = wrapper.childElementCount; i < count; i++)(0, $4ZDHT.detach)(wrapper.lastElementChild);
                        this_1.navIdx = [];
                    } else {
                        var keys = Object.keys(newProp.items);
                        for(var i = 0; i < keys.length; i++){
                            navIdx = this_1.getChangedItemIndex(newProp, [], Number(keys[i]));
                            if (navIdx.length <= this_1.getWrapper().children.length) {
                                idx = navIdx.pop();
                                item = this_1.getItems(navIdx);
                                this_1.insertAfter([
                                    item[idx]
                                ], item[idx].text);
                                this_1.removeItem(item, navIdx, idx);
                                this_1.setItems(item, navIdx);
                            }
                            navIdx.length = 0;
                        }
                    }
                    break;
            }
        };
        var this_1 = this;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            _loop_2(prop);
        }
    };
    MenuBase.prototype.updateItem = function(ul, items) {
        if ((0, $3EnZW.isBlazor)() && !this.isMenu) ul = this.removeChildElement(ul);
        else {
            if (this.enableScrolling) {
                var wrapper1 = this.getWrapper();
                var ul1 = wrapper1.children[0];
                if (this.element.classList.contains("e-vertical")) (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(ul1, (0, $3471080cb1b09001$export$d9880af5395880d2)), ul1);
                else (0, $cd13d8ef6effb9e3$export$3f5ade24e7a444c3)((0, $3EnZW.getInstance)(ul1, (0, $ffe4a1d7d733585d$export$49487f80cf9ca6b1)), ul1);
            }
            ul.innerHTML = "";
        }
        var lis = [].slice.call(this.createItems(items).children);
        lis.forEach(function(li) {
            ul.appendChild(li);
        });
    };
    MenuBase.prototype.getChangedItemIndex = function(newProp, index, idx) {
        index.push(idx);
        var key = Object.keys(newProp.items[idx]).pop();
        if (key === "items") {
            var item = newProp.items[idx];
            var popStr = Object.keys(item.items).pop();
            if (popStr) this.getChangedItemIndex(item, index, Number(popStr));
        } else if (key === "isParentArray" && index.length > 1) index.pop();
        return index;
    };
    MenuBase.prototype.removeItem = function(item, navIdx, idx) {
        item.splice(idx, 1);
        var uls = this.getWrapper().children;
        if (navIdx.length < uls.length) (0, $4ZDHT.detach)(uls[navIdx.length].children[idx]);
    };
    /**
     * Used to unwire the bind events.
     *
     * @private
     * @param {string} targetSelctor - Specifies the target selector
     * @returns {void}
     */ MenuBase.prototype.unWireEvents = function(targetSelctor) {
        if (targetSelctor === void 0) targetSelctor = this.target;
        var wrapper = this.getWrapper();
        if (targetSelctor) {
            var target = void 0;
            var touchModule = void 0;
            var targetElems = (0, $4ZDHT.selectAll)(targetSelctor);
            for(var i = 0, len = targetElems.length; i < len; i++){
                target = targetElems[i];
                if (this.isMenu) (0, $aqzbR.EventHandler).remove(target, "click", this.menuHeaderClickHandler);
                else if ((0, $5q7BP.Browser).isIos) {
                    touchModule = (0, $3EnZW.getInstance)(target, (0, $i528u.Touch));
                    if (touchModule) touchModule.destroy();
                } else (0, $aqzbR.EventHandler).remove(target, "contextmenu", this.cmenuHandler);
            }
            if (!this.isMenu) {
                (0, $aqzbR.EventHandler).remove(this.targetElement, "scroll", this.scrollHandler);
                for(var _i = 0, _a = (0, $2vAqh.getScrollableParent)(this.targetElement); _i < _a.length; _i++){
                    var parent_2 = _a[_i];
                    (0, $aqzbR.EventHandler).remove(parent_2, "scroll", this.scrollHandler);
                }
            }
        }
        if (!(0, $5q7BP.Browser).isDevice) {
            (0, $aqzbR.EventHandler).remove(this.isMenu ? document : wrapper, "mouseover", this.delegateMoverHandler);
            (0, $aqzbR.EventHandler).remove(document, "mousedown", this.delegateMouseDownHandler);
        }
        (0, $aqzbR.EventHandler).remove(document, "click", this.delegateClickHandler);
        this.unWireKeyboardEvent(wrapper);
        this.rippleFn();
    };
    MenuBase.prototype.unWireKeyboardEvent = function(element) {
        var keyboardModule = (0, $3EnZW.getInstance)(element, (0, $dyv7X.KeyboardEvents));
        if (keyboardModule) keyboardModule.destroy();
    };
    MenuBase.prototype.toggleAnimation = function(ul, isMenuOpen) {
        var _this = this;
        if (isMenuOpen === void 0) isMenuOpen = true;
        var pUlHeight;
        var pElement;
        if (this.animationSettings.effect === "None" || !isMenuOpen) {
            if (this.hamburgerMode && ul) ul.style.top = "0px";
            this.isAnimationNone = this.animationSettings.effect === "None";
            this.end(ul, isMenuOpen);
        } else this.animation.animate(ul, {
            name: this.animationSettings.effect,
            duration: this.animationSettings.duration,
            timingFunction: this.animationSettings.easing,
            begin: function(options) {
                if (_this.hamburgerMode) {
                    pElement = options.element.parentElement;
                    options.element.style.position = "absolute";
                    if (pElement) pUlHeight = pElement.offsetHeight;
                    options.element.style.maxHeight = options.element.offsetHeight + "px";
                    if (pElement) pElement.style.maxHeight = "";
                } else {
                    options.element.style.display = "block";
                    options.element.style.maxHeight = options.element.getBoundingClientRect().height + "px";
                }
            },
            progress: function(options) {
                if (_this.hamburgerMode && pElement) pElement.style.minHeight = pUlHeight + options.element.offsetHeight + "px";
            },
            end: function(options) {
                if (_this.hamburgerMode) {
                    options.element.style.position = "";
                    options.element.style.maxHeight = "";
                    if (pElement) pElement.style.minHeight = "";
                    options.element.style.top = "0px";
                    options.element.children[0].focus();
                    _this.triggerOpen(options.element.children[0]);
                } else _this.end(options.element, isMenuOpen);
            }
        });
    };
    MenuBase.prototype.triggerOpen = function(ul) {
        var item = this.navIdx.length ? this.getItem(this.navIdx) : null;
        var eventArgs = {
            element: ul,
            parentItem: item,
            items: item ? item.items : this.items
        };
        this.trigger("onOpen", eventArgs);
        if (!this.isMenu) (0, $aqzbR.EventHandler).add(ul, "keydown", this.keyHandler, this);
    };
    MenuBase.prototype.end = function(ul, isMenuOpen) {
        if (isMenuOpen && (this.isMenu || !this.isMenu && this.isContextMenuClosed)) {
            if (this.isMenu || !(0, $5q7BP.Browser).isDevice) ul.style.display = "block";
            ul.style.maxHeight = "";
            this.triggerOpen(ul);
            if (ul.querySelector("." + $b0f7c8984d47d037$var$FOCUSED)) ul.querySelector("." + $b0f7c8984d47d037$var$FOCUSED).focus();
            else {
                var ele = this.getWrapper().children[this.getIdx(this.getWrapper(), ul) - 1];
                if (this.currentTarget) {
                    if (!(this.currentTarget.classList.contains("e-numerictextbox") || this.currentTarget.classList.contains("e-textbox") || this.currentTarget.tagName === "INPUT")) {
                        if (ele) ele.querySelector("." + $b0f7c8984d47d037$var$SELECTED).focus();
                        else this.element.focus();
                    }
                } else if (ele) ele.querySelector("." + $b0f7c8984d47d037$var$SELECTED).focus();
                else this.element.focus();
            }
        } else if (ul === this.element) {
            var fli = this.getLIByClass(this.element, $b0f7c8984d47d037$var$FOCUSED);
            if (fli) fli.classList.remove($b0f7c8984d47d037$var$FOCUSED);
            var sli = this.getLIByClass(this.element, $b0f7c8984d47d037$var$SELECTED);
            if (sli) sli.classList.remove($b0f7c8984d47d037$var$SELECTED);
            ul.style.display = "none";
            this.isAnimationNone = false;
        } else (0, $4ZDHT.detach)(ul);
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */ MenuBase.prototype.getPersistData = function() {
        return "";
    };
    /**
     * Get wrapper element.
     *
     * @returns {Element} - Wrapper element
     * @private
     */ MenuBase.prototype.getWrapper = function() {
        return (0, $4ZDHT.closest)(this.element, ".e-" + this.getModuleName() + "-wrapper");
    };
    MenuBase.prototype.getIndex = function(data, isUniqueId, items, nIndex, isCallBack, level) {
        if (items === void 0) items = this.items;
        if (nIndex === void 0) nIndex = [];
        if (isCallBack === void 0) isCallBack = false;
        if (level === void 0) level = 0;
        var item;
        level = isCallBack ? level + 1 : 0;
        for(var i = 0, len = items.length; i < len; i++){
            item = items[i];
            if ((isUniqueId ? item[this.getField("itemId", level)] : item[this.getField("text", level)]) === data) {
                nIndex.push(i);
                break;
            } else if (item[this.getField("children", level)] && item[this.getField("children", level)].length) {
                nIndex = this.getIndex(data, isUniqueId, item[this.getField("children", level)], nIndex, true, level);
                if (nIndex[nIndex.length - 1] === -1) {
                    if (i !== len - 1) nIndex.pop();
                } else {
                    nIndex.unshift(i);
                    break;
                }
            } else if (i === len - 1) nIndex.push(-1);
        }
        return !isCallBack && nIndex[0] === -1 ? [] : nIndex;
    };
    /**
     * This method is used to enable or disable the menu items in the Menu based on the items and enable argument.
     *
     * @param {string[]} items - Text items that needs to be enabled/disabled.
     * @param {boolean} enable - Set `true`/`false` to enable/disable the list items.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.enableItems = function(items, enable, isUniqueId) {
        if (enable === void 0) enable = true;
        var ul;
        var idx;
        var navIdx;
        var disabled = $b0f7c8984d47d037$var$DISABLED;
        var skipItem;
        for(var i = 0; i < items.length; i++){
            navIdx = this.getIndex(items[i], isUniqueId);
            if (this.navIdx.length) {
                if (navIdx.length !== 1) {
                    skipItem = false;
                    for(var i_1 = 0, len = navIdx.length - 1; i_1 < len; i_1++)if (navIdx[i_1] !== this.navIdx[i_1]) {
                        skipItem = true;
                        break;
                    }
                    if (skipItem) continue;
                }
            } else {
                if (navIdx.length !== 1) continue;
            }
            idx = navIdx.pop();
            ul = this.getUlByNavIdx(navIdx.length);
            if (ul && !(0, $3EnZW.isNullOrUndefined)(idx)) {
                if (enable) {
                    if (this.isMenu) {
                        ul.children[idx].classList.remove(disabled);
                        ul.children[idx].removeAttribute("aria-disabled");
                    } else if ((0, $5q7BP.Browser).isDevice && !ul.classList.contains("e-contextmenu")) ul.children[idx + 1].classList.remove(disabled);
                    else ul.children[idx].classList.remove(disabled);
                } else {
                    if (this.isMenu) {
                        ul.children[idx].classList.add(disabled);
                        ul.children[idx].setAttribute("aria-disabled", "true");
                    } else if ((0, $5q7BP.Browser).isDevice && !ul.classList.contains("e-contextmenu")) ul.children[idx + 1].classList.add(disabled);
                    else ul.children[idx].classList.add(disabled);
                }
            }
        }
    };
    /**
     * This method is used to show the menu items in the Menu based on the items text.
     *
     * @param {string[]} items - Text items that needs to be shown.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.showItems = function(items, isUniqueId) {
        this.showHideItems(items, false, isUniqueId);
    };
    /**
     * This method is used to hide the menu items in the Menu based on the items text.
     *
     * @param {string[]} items - Text items that needs to be hidden.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.hideItems = function(items, isUniqueId) {
        this.showHideItems(items, true, isUniqueId);
    };
    MenuBase.prototype.showHideItems = function(items, ishide, isUniqueId) {
        var ul;
        var index;
        var navIdx;
        var item;
        for(var i = 0; i < items.length; i++){
            navIdx = this.getIndex(items[i], isUniqueId);
            index = navIdx.pop();
            ul = this.getUlByNavIdx(navIdx.length);
            item = this.getItems(navIdx);
            if (ul) {
                var validUl = isUniqueId ? ul.children[index].id : item[index].text.toString();
                if (ishide && validUl === items[i]) ul.children[index].classList.add($b0f7c8984d47d037$var$HIDE);
                else if (!ishide && validUl === items[i]) ul.children[index].classList.remove($b0f7c8984d47d037$var$HIDE);
            }
        }
    };
    /**
     * It is used to remove the menu items from the Menu based on the items text.
     *
     * @param {string[]} items Text items that needs to be removed.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.removeItems = function(items, isUniqueId) {
        var idx;
        var navIdx;
        var iitems;
        for(var i = 0; i < items.length; i++){
            navIdx = this.getIndex(items[i], isUniqueId);
            idx = navIdx.pop();
            iitems = this.getItems(navIdx);
            if (!(0, $3EnZW.isNullOrUndefined)(idx)) this.removeItem(iitems, navIdx, idx);
        }
    };
    /**
     * It is used to insert the menu items after the specified menu item text.
     *
     * @param {MenuItemModel[]} items - Items that needs to be inserted.
     * @param {string} text - Text item after that the element to be inserted.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.insertAfter = function(items, text, isUniqueId) {
        this.insertItems(items, text, isUniqueId);
    };
    /**
     * It is used to insert the menu items before the specified menu item text.
     *
     * @param {MenuItemModel[]} items - Items that needs to be inserted.
     * @param {string} text - Text item before that the element to be inserted.
     * @param  {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */ MenuBase.prototype.insertBefore = function(items, text, isUniqueId) {
        this.insertItems(items, text, isUniqueId, false);
    };
    MenuBase.prototype.insertItems = function(items, text, isUniqueId, isAfter) {
        if (isAfter === void 0) isAfter = true;
        var li;
        var idx;
        var navIdx;
        var iitems;
        var menuitem;
        for(var i = 0; i < items.length; i++){
            navIdx = this.getIndex(text, isUniqueId);
            idx = navIdx.pop();
            iitems = this.getItems(navIdx);
            menuitem = new $b0f7c8984d47d037$export$2ce376c2cc3355c8(iitems[0], "items", items[i], true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuitem.parentObj = iitems[0].parentObj;
            iitems.splice(isAfter ? idx + 1 : idx, 0, menuitem);
            var uls = this.isMenu ? [
                this.getWrapper()
            ].concat(this.getPopups()) : [].slice.call(this.getWrapper().children);
            if (!(0, $3EnZW.isNullOrUndefined)(idx) && navIdx.length < uls.length) {
                idx = isAfter ? idx + 1 : idx;
                li = this.createItems(iitems).children[idx];
                var ul = this.isMenu ? (0, $4ZDHT.select)(".e-menu-parent", uls[navIdx.length]) : uls[navIdx.length];
                ul.insertBefore(li, ul.children[idx]);
            }
        }
    };
    MenuBase.prototype.removeAttributes = function() {
        var _this = this;
        [
            "top",
            "left",
            "display",
            "z-index"
        ].forEach(function(key) {
            _this.element.style.removeProperty(key);
        });
        [
            "role",
            "tabindex",
            "class",
            "style"
        ].forEach(function(key) {
            if (key === "class" && _this.element.classList.contains("e-menu-parent")) _this.element.classList.remove("e-menu-parent");
            if ([
                "class",
                "style"
            ].indexOf(key) === -1 || !_this.element.getAttribute(key)) _this.element.removeAttribute(key);
            if (_this.isMenu && key === "class" && _this.element.classList.contains("e-vertical")) _this.element.classList.remove("e-vertical");
        });
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ MenuBase.prototype.destroy = function() {
        var wrapper = this.getWrapper();
        if (wrapper) {
            this.unWireEvents();
            if (!this.isMenu) {
                this.clonedElement.style.display = "";
                if (this.clonedElement.tagName === "EJS-CONTEXTMENU") {
                    (0, $4ZDHT.addClass)([
                        this.clonedElement
                    ], [
                        "e-control",
                        "e-lib",
                        "e-" + this.getModuleName()
                    ]);
                    this.element = this.clonedElement;
                } else {
                    if (this.refreshing && this.clonedElement.childElementCount && this.clonedElement.children[0].tagName === "LI") this.setProperties({
                        "items": []
                    }, true);
                    if (document.getElementById(this.clonedElement.id)) {
                        var refEle = this.clonedElement.nextElementSibling;
                        if (refEle && refEle !== wrapper) this.clonedElement.parentElement.insertBefore(this.element, refEle);
                        else this.clonedElement.parentElement.appendChild(this.element);
                        if ((0, $3EnZW.isBlazor)() && !this.isMenu) this.element = this.removeChildElement(this.element);
                        else this.element.innerHTML = "";
                        (0, $4ZDHT.append)([].slice.call(this.clonedElement.children), this.element);
                        (0, $4ZDHT.detach)(this.clonedElement);
                        this.removeAttributes();
                    }
                }
                this.clonedElement = null;
            } else {
                this.closeMenu();
                if ((0, $3EnZW.isBlazor)() && !this.isMenu) this.element = this.removeChildElement(this.element);
                else this.element.innerHTML = "";
                this.removeAttributes();
                wrapper.parentNode.insertBefore(this.element, wrapper);
                this.clonedElement = null;
            }
            (0, $4ZDHT.detach)(wrapper);
            _super.prototype.destroy.call(this);
            if (this.template) this.clearTemplate([
                "template"
            ]);
        }
        this.rippleFn = null;
    };
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "beforeItemRender", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "beforeOpen", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "onOpen", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "beforeClose", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "onClose", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "select", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Event)()
    ], MenuBase.prototype, "created", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuBase.prototype, "cssClass", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], MenuBase.prototype, "hoverDelay", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MenuBase.prototype, "showItemOnClick", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuBase.prototype, "target", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MenuBase.prototype, "filter", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MenuBase.prototype, "template", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MenuBase.prototype, "enableScrolling", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MenuBase.prototype, "enableHtmlSanitizer", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Complex)({
            itemId: "id",
            text: "text",
            parentId: "parentId",
            iconCss: "iconCss",
            url: "url",
            separator: "separator",
            children: "items"
        }, $b0f7c8984d47d037$export$47acbd07e937cc3e)
    ], MenuBase.prototype, "fields", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Collection)([], $b0f7c8984d47d037$export$2ce376c2cc3355c8)
    ], MenuBase.prototype, "items", void 0);
    $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.Complex)({
            duration: 400,
            easing: "ease",
            effect: "SlideDown"
        }, $b0f7c8984d47d037$export$b6114198c1e3ba8c)
    ], MenuBase.prototype, "animationSettings", void 0);
    MenuBase = $b0f7c8984d47d037$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], MenuBase);
    return MenuBase;
}((0, $hQxLN.Component));


var $4017afccb487b2c7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4017afccb487b2c7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * The ContextMenu is a graphical user interface that appears on the user right click/touch hold operation.
 * ```html
 * <div id = 'target'></div>
 * <ul id = 'contextmenu'></ul>
 * ```
 * ```typescript
 * <script>
 * var contextMenuObj = new ContextMenu({items: [{ text: 'Cut' }, { text: 'Copy' },{ text: 'Paste' }], target: '#target'});
 * </script>
 * ```
 */ var $4017afccb487b2c7$export$8dc6765e8be191c7 = /** @class */ function(_super) {
    $4017afccb487b2c7$var$__extends(ContextMenu, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     * @param {ContextMenuModel} options - Specifies the context menu model
     * @param {string} element - Specifies the element
     */ function ContextMenu(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * For internal use only - prerender processing.
     *
     * @private
     * @returns {void}
     */ ContextMenu.prototype.preRender = function() {
        this.isMenu = false;
        this.element.id = this.element.id || (0, $3EnZW.getUniqueID)("ej2-contextmenu");
        _super.prototype.preRender.call(this);
    };
    ContextMenu.prototype.initialize = function() {
        _super.prototype.initialize.call(this);
        (0, $4ZDHT.attributes)(this.element, {
            "role": "menubar",
            "tabindex": "0"
        });
        this.element.style.zIndex = (0, $2vAqh.getZindexPartial)(this.element).toString();
    };
    /**
     * This method is used to open the ContextMenu in specified position.
     *
     * @param {number} top - To specify ContextMenu vertical positioning.
     * @param {number} left - To specify ContextMenu horizontal positioning.
     * @param {HTMLElement} target - To calculate z-index for ContextMenu based upon the specified target.
     * @function open
     * @returns {void}
     */ ContextMenu.prototype.open = function(top, left, target) {
        _super.prototype.openMenu.call(this, null, null, top, left, null, target);
    };
    /**
     * Closes the ContextMenu if it is opened.
     *
     * @function close
     * @returns {void}
     */ ContextMenu.prototype.close = function() {
        _super.prototype.closeMenu.call(this);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {ContextMenuModel} newProp - Specifies new properties
     * @param {ContextMenuModel} oldProp - Specifies old properties
     * @returns {void}
     */ ContextMenu.prototype.onPropertyChanged = function(newProp, oldProp) {
        _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "filter":
                    this.close();
                    this.filter = newProp.filter;
                    break;
                case "target":
                    this.unWireEvents(oldProp.target);
                    this.wireEvents();
                    break;
            }
        }
    };
    /**
     * Get module name.
     *
     * @returns {string} - Module Name
     * @private
     */ ContextMenu.prototype.getModuleName = function() {
        return "contextmenu";
    };
    $4017afccb487b2c7$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ContextMenu.prototype, "target", void 0);
    $4017afccb487b2c7$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ContextMenu.prototype, "filter", void 0);
    $4017afccb487b2c7$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $b0f7c8984d47d037$export$2ce376c2cc3355c8))
    ], ContextMenu.prototype, "items", void 0);
    ContextMenu = $4017afccb487b2c7$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], ContextMenu);
    return ContextMenu;
}((0, $b0f7c8984d47d037$export$5118460d8209bf35));




var $0c3f24e0df11dbc6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @hidden
 * `ExcelFilter` module is used to handle filtering action.
 */ var $0c3f24e0df11dbc6$export$c0965c6f0513e6de = /** @class */ function(_super) {
    $0c3f24e0df11dbc6$var$__extends(ExcelFilterBase, _super);
    /**
     * Constructor for excel filtering module
     *
     * @param {IXLFilter} parent - parent details
     * @param {Object} customFltrOperators - operator details
     * @hidden
     */ function ExcelFilterBase(parent, customFltrOperators) {
        var _this = _super.call(this, parent) || this;
        _this.childRefs = [];
        _this.eventHandlers = {};
        _this.isDevice = false;
        _this.focusedMenuItem = null;
        _this.customFilterOperators = customFltrOperators;
        _this.isExcel = true;
        return _this;
    }
    ExcelFilterBase.prototype.getCMenuDS = function(type, operator) {
        var options = {
            number: [
                "Equal",
                "NotEqual",
                "",
                "LessThan",
                "LessThanOrEqual",
                "GreaterThan",
                "GreaterThanOrEqual",
                "Between",
                "",
                "CustomFilter"
            ],
            string: [
                "Equal",
                "NotEqual",
                "",
                "StartsWith",
                "EndsWith",
                "",
                "Contains",
                "NotContains",
                "",
                "CustomFilter"
            ]
        };
        options.date = options.number;
        options.datetime = options.number;
        options.dateonly = options.number;
        var model = [];
        for(var i = 0; i < options["" + type].length; i++)if (options["" + type][parseInt(i.toString(), 10)].length) {
            if (operator) model.push({
                text: this.getLocalizedLabel(options["" + type][parseInt(i.toString(), 10)]) + "...",
                iconCss: "e-icons e-icon-check " + (operator === options["" + type][parseInt(i.toString(), 10)].toLowerCase() ? "" : "e-emptyicon")
            });
            else model.push({
                text: this.getLocalizedLabel(options["" + type][parseInt(i.toString(), 10)]) + "..."
            });
        } else model.push({
            separator: true
        });
        return model;
    };
    /**
     * To destroy the filter bar.
     *
     * @returns {void}
     * @hidden
     */ ExcelFilterBase.prototype.destroy = function() {
        if (this.dlg) {
            this.unwireExEvents();
            _super.prototype.closeDialog.call(this);
        }
        if (!this.isDevice && this.menuObj) {
            var li = this.menuObj.element.querySelector("li.e-focused");
            if (!(li && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(li, "e-excel-menu"))) this.destroyCMenu();
        }
        if (this.dlgObj && !this.dlgObj.isDestroyed) this.removeDialog();
    };
    ExcelFilterBase.prototype.createMenu = function(type, isFiltered, isCheckIcon, eleOptions) {
        var options = {
            string: "TextFilter",
            date: "DateFilter",
            dateonly: "DateFilter",
            datetime: "DateTimeFilter",
            number: "NumberFilter"
        };
        this.menu = this.parent.createElement("div", {
            className: "e-contextmenu-wrapper"
        });
        if (this.parent.enableRtl) this.menu.classList.add("e-rtl");
        else this.menu.classList.remove("e-rtl");
        if (this.parent.cssClass) this.menu.classList.add(this.parent.cssClass);
        var ul = this.parent.createElement("ul");
        var icon = isFiltered ? "e-excl-filter-icon e-filtered" : "e-excl-filter-icon";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.parent.allowSorting && this.parent.getModuleName() === "grid" && !this.options.isResponsiveFilter) {
            var hdrele = this.parent.getColumnHeaderByUid(eleOptions.uid).getAttribute("aria-sort");
            var colIsSort = this.parent.getColumnByField(eleOptions.field).allowSorting;
            var isAsc = !colIsSort || hdrele === "ascending" ? "e-disabled e-excel-ascending" : "e-excel-ascending";
            var isDesc = !colIsSort || hdrele === "descending" ? "e-disabled e-excel-descending" : "e-excel-descending";
            var ascName = type === "string" ? this.getLocalizedLabel("SortAtoZ") : type === "datetime" || type === "date" ? this.getLocalizedLabel("SortByOldest") : this.getLocalizedLabel("SortSmallestToLargest");
            var descName = type === "string" ? this.getLocalizedLabel("SortZtoA") : type === "datetime" || type === "date" ? this.getLocalizedLabel("SortByNewest") : this.getLocalizedLabel("SortLargestToSmallest");
            ul.appendChild(this.createMenuElem(ascName, isAsc, "e-sortascending"));
            ul.appendChild(this.createMenuElem(descName, isDesc, "e-sortdescending"));
            var separator = this.parent.createElement("li", {
                className: "e-separator e-menu-item e-excel-separator"
            });
            ul.appendChild(separator);
        }
        if (!this.options.isResponsiveFilter) ul.appendChild(this.createMenuElem(this.getLocalizedLabel("ClearFilter"), isFiltered ? "" : "e-disabled", icon));
        if (type !== "boolean") ul.appendChild(this.createMenuElem(this.getLocalizedLabel(options["" + type]), "e-submenu", isCheckIcon && this.ensureTextFilter() ? "e-icon-check" : icon + " e-emptyicon", true));
        this.menu.appendChild(ul);
        this.parent.notify($17b89d3b1fc93cdb$export$5f4beafdf6c8c6a1, {
            element: this.menu
        });
        this.parent.notify($17b89d3b1fc93cdb$export$4f835fcb4bd1b58c, {
            isFiltered: isFiltered
        });
    };
    ExcelFilterBase.prototype.createMenuElem = function(val, className, iconName, isSubMenu) {
        var li = this.parent.createElement("li", {
            className: className + " e-menu-item"
        });
        li.innerHTML = val;
        li.tabIndex = li.classList.contains("e-disabled") ? -1 : 0;
        li.insertBefore(this.parent.createElement("span", {
            className: "e-menu-icon e-icons " + iconName,
            attrs: {
                "aria-hidden": "true"
            }
        }), li.firstChild);
        if (isSubMenu) li.appendChild(this.parent.createElement("span", {
            className: "e-icons e-caret"
        }));
        return li;
    };
    ExcelFilterBase.prototype.wireExEvents = function() {
        if (!(0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).add(this.dlg, "mouseover", this.hoverHandler, this);
        (0, $aqzbR.EventHandler).add(this.dlg, "click", this.clickExHandler, this);
        (0, $aqzbR.EventHandler).add(this.dlg, "keyup", this.keyUp, this);
        (0, $aqzbR.EventHandler).add(this.dlg, "keydown", this.keyDown, this);
    };
    ExcelFilterBase.prototype.unwireExEvents = function() {
        if (!(0, $5q7BP.Browser).isDevice) (0, $aqzbR.EventHandler).remove(this.dlg, "mouseover", this.hoverHandler);
        (0, $aqzbR.EventHandler).remove(this.dlg, "click", this.clickExHandler);
        (0, $aqzbR.EventHandler).remove(this.dlg, "keyup", this.keyUp);
        (0, $aqzbR.EventHandler).remove(this.dlg, "keydown", this.keyDown);
    };
    ExcelFilterBase.prototype.clickExHandler = function(e) {
        var options = {
            string: "TextFilter",
            date: "DateFilter",
            datetime: "DateTimeFilter",
            number: "NumberFilter"
        };
        var menuItem = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-menu-item");
        if (menuItem) {
            if (this.getLocalizedLabel("ClearFilter") === menuItem.innerText.trim()) {
                this.clearFilter();
                this.closeDialog();
            } else if ((this.options.isResponsiveFilter || (0, $5q7BP.Browser).isDevice) && this.getLocalizedLabel(options[this.options.type]) === menuItem.innerText.trim()) this.hoverHandler(e);
        }
    };
    ExcelFilterBase.prototype.focusNextOrPrevElement = function(e, focusableElements, focusClassName) {
        var nextIndex = e.key === "ArrowUp" || e.key === "Tab" && e.shiftKey ? focusableElements.indexOf(document.activeElement) - 1 : focusableElements.indexOf(document.activeElement) + 1;
        var nextElement = focusableElements[(nextIndex + focusableElements.length) % focusableElements.length];
        // Set focus on the next / previous element
        if (nextElement) {
            nextElement.focus();
            var focusClass = nextElement.classList.contains("e-chk-hidden") ? "e-chkfocus" : focusClassName;
            var target = nextElement.classList.contains("e-chk-hidden") ? (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(nextElement, "e-ftrchk") : (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(nextElement, "e-menu-item");
            this.excelSetFocus(target, focusClass);
        }
    };
    ExcelFilterBase.prototype.keyUp = function(e) {
        if (e.key === "Tab" && e.shiftKey || e.key === "Tab") {
            var focusClass = e.target.classList.contains("e-chk-hidden") ? "e-chkfocus" : "e-menufocus";
            var target = e.target.classList.contains("e-menu-item") ? (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-menu-item") : (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-ftrchk");
            this.excelSetFocus(target, focusClass);
        } else if ((e.key === "ArrowUp" || e.key === "ArrowDown") && !e.altKey) {
            e.preventDefault();
            var focusableElements = Array.from(this.dlg.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"]), .e-menu-item:not(.e-disabled):not(.e-separator)'));
            this.focusNextOrPrevElement(e, focusableElements, "e-menufocus");
        } else if ((e.key === "Enter" || e.code === "ArrowRight") && e.target.classList.contains("e-menu-item")) {
            e.preventDefault();
            e.target.click();
            if (e.target.classList.contains("e-submenu")) {
                this.hoverHandler(e);
                this.menuObj.element.querySelector(".e-menu-item").focus();
                this.excelSetFocus((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.menuObj.element.querySelector(".e-menu-item"), "e-menu-item"), "e-focused");
                this.focusedMenuItem = this.menuObj.element.querySelector(".e-menu-item");
            }
        }
    };
    ExcelFilterBase.prototype.keyDown = function(e) {
        //prevented up and down arrow key press default functionality to prevent the browser scroll when performing keyboard navigation in excel filter element.
        if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault();
    };
    ExcelFilterBase.prototype.excelSetFocus = function(elem, className) {
        var prevElem = this.cmenu.querySelector("." + className);
        if (prevElem) prevElem.classList.remove(className);
        if (elem) elem.classList.add(className);
    };
    ExcelFilterBase.prototype.destroyCMenu = function() {
        this.isCMenuOpen = false;
        if (this.menuObj && !this.menuObj.isDestroyed) {
            this.menuObj.destroy();
            (0, $aqzbR.EventHandler).remove(this.menuObj.element, "keydown", this.contextKeyDownHandler);
            (0, $4ZDHT.remove)(this.cmenu);
            this.parent.notify($17b89d3b1fc93cdb$export$9b39fce63b060dec, {
                target: null,
                header: "",
                isOpen: false,
                col: this.options.column
            });
        }
    };
    ExcelFilterBase.prototype.hoverHandler = function(e) {
        if (this.options.isResponsiveFilter && e.type === "mouseover") return;
        var target = e.target.querySelector(".e-contextmenu");
        var li = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-menu-item");
        var focused = this.menu.querySelector(".e-focused");
        var isSubMenu;
        if (focused) focused.classList.remove("e-focused");
        if (li) {
            li.classList.add("e-focused");
            isSubMenu = li.classList.contains("e-submenu");
        }
        if (target) return;
        if (!isSubMenu) {
            var submenu = this.menu.querySelector(".e-submenu");
            if (!(0, $3EnZW.isNullOrUndefined)(submenu)) submenu.classList.remove("e-selected");
            this.destroyCMenu();
        }
        var selectedMenu = this.ensureTextFilter();
        if (!this.isCMenuOpen && isSubMenu) {
            li.classList.add("e-selected");
            this.isCMenuOpen = true;
            var menuOptions = {
                items: this.getCMenuDS(this.options.type, selectedMenu ? selectedMenu.replace(/\s/g, "") : undefined),
                select: this.selectHandler.bind(this),
                onClose: this.destroyCMenu.bind(this),
                enableRtl: this.parent.enableRtl,
                animationSettings: {
                    effect: (0, $5q7BP.Browser).isDevice ? "ZoomIn" : "None"
                },
                beforeClose: this.preventClose.bind(this),
                cssClass: this.options.isResponsiveFilter && this.parent.cssClass ? "e-res-contextmenu-wrapper " + this.parent.cssClass : this.options.isResponsiveFilter ? "e-res-contextmenu-wrapper" : this.parent.cssClass ? this.parent.cssClass : ""
            };
            this.parent.element.appendChild(this.cmenu);
            this.menuObj = new (0, $4017afccb487b2c7$export$8dc6765e8be191c7)(menuOptions, this.cmenu);
            (0, $aqzbR.EventHandler).add(this.menuObj.element, "keydown", this.contextKeyDownHandler, this);
            var client = this.menu.querySelector(".e-submenu").getBoundingClientRect();
            var pos = {
                top: 0,
                left: 0
            };
            if (this.options.isResponsiveFilter) {
                var options = {
                    string: "TextFilter",
                    date: "DateFilter",
                    datetime: "DateTimeFilter",
                    number: "NumberFilter"
                };
                var content = document.querySelector(".e-responsive-dialog > .e-dlg-header-content");
                var height = content.offsetHeight + 4;
                this.menuObj.element.style.height = "calc(100% - " + height + "px)";
                this.menuObj["open"](height, 0, document.body);
                var header = this.getLocalizedLabel(options[this.options.type]);
                this.parent.notify($17b89d3b1fc93cdb$export$9b39fce63b060dec, {
                    target: this.menuObj.element.parentElement,
                    header: header,
                    isOpen: true
                });
            } else {
                if ((0, $5q7BP.Browser).isDevice) {
                    this.isDevice = true;
                    var contextRect = this.getContextBounds();
                    pos.top = (window.innerHeight - contextRect.height) / 2;
                    pos.left = (window.innerWidth - contextRect.width) / 2;
                    this.closeDialog();
                    this.isDevice = false;
                } else {
                    pos.top = (0, $5q7BP.Browser).isIE ? window.pageYOffset + client.top : window.scrollY + client.top;
                    pos.left = this.getCMenuYPosition(this.dlg);
                }
                this.menuObj["open"](pos.top, pos.left, e.target);
            }
            (0, $748c2240e597a9b7$export$b6c750d9a4b9bf2b)(this.parent.element, this.menuObj.element.parentElement);
        }
    };
    ExcelFilterBase.prototype.contextKeyDownHandler = function(e) {
        if (e.key === "Tab" && e.shiftKey || e.key === "Tab") {
            e.preventDefault();
            var focusableElements = Array.from(this.menuObj.element.querySelectorAll('[tabindex]:not([tabindex="-1"]), .e-menu-item:not(.e-disabled):not(.e-separator)'));
            // Focus the next / previous context menu item
            this.focusNextOrPrevElement(e, focusableElements, "e-focused");
        } else if (e.key === "ArrowLeft" || e.key === "Escape") {
            e.preventDefault();
            this.menuObj.close();
            this.focusedMenuItem = null;
            document.querySelector(".e-submenu.e-menu-item").classList.remove("e-selected");
            document.querySelector(".e-submenu.e-menu-item").focus();
        }
    };
    ExcelFilterBase.prototype.ensureTextFilter = function() {
        var selectedMenu;
        var predicates = this.existingPredicate[this.options.field];
        if (predicates && predicates.length === 2) {
            if (predicates[0].operator === "greaterthanorequal" && predicates[1].operator === "lessthanorequal") selectedMenu = "between";
            else selectedMenu = "customfilter";
        } else if (predicates && predicates.length === 1) {
            this.optrData = this.customFilterOperators[this.options.type + "Operator"];
            selectedMenu = predicates[0].operator;
        }
        return selectedMenu;
    };
    ExcelFilterBase.prototype.preventClose = function(args) {
        if (this.options && this.options.isResponsiveFilter && args.event) {
            var target = args.event.target;
            var isFilterBack = target.classList.contains("e-resfilterback") || target.classList.contains("e-res-back-btn") || target.classList.contains("e-menu-item");
            args.cancel = !isFilterBack;
        } else if (args.event instanceof MouseEvent && args.event.target.classList.contains("e-submenu")) args.cancel = true;
    };
    ExcelFilterBase.prototype.getContextBounds = function() {
        this.menuObj.element.style.display = "block";
        return this.menuObj.element.getBoundingClientRect();
    };
    ExcelFilterBase.prototype.getCMenuYPosition = function(target) {
        var contextWidth = this.getContextBounds().width;
        var targetPosition = target.getBoundingClientRect();
        var leftPos = targetPosition.right + contextWidth - this.parent.element.clientWidth;
        var targetBorder = target.offsetWidth - target.clientWidth;
        targetBorder = targetBorder ? targetBorder + 1 : 0;
        return leftPos < 1 ? targetPosition.right + 1 - targetBorder : targetPosition.left - contextWidth - 1 + targetBorder;
    };
    ExcelFilterBase.prototype.openDialog = function(options) {
        var _this = this;
        this.updateModel(options);
        this.getAndSetChkElem(options);
        this.showDialog(options);
        if (options.cancel) return;
        this.dialogObj.dataBind();
        var filterLength = this.existingPredicate[options.field] && this.existingPredicate[options.field].length || this.options.filteredColumns.filter(function(col) {
            return _this.options.field === col.field;
        }).length;
        this.createMenu(options.type, filterLength > 0, filterLength === 1 || filterLength === 2, options);
        this.dlg.insertBefore(this.menu, this.dlg.firstChild);
        this.dlg.classList.add("e-excelfilter");
        if (this.parent && !(0, $3EnZW.isNullOrUndefined)(this.parent.getContent) && this.parent.getContent() && this.parent.getContent().firstElementChild.offsetHeight < this.dlg.offsetHeight) (0, $748c2240e597a9b7$export$35819a1a44286094)(this.parent, this.dialogObj);
        if (this.parent.enableRtl) this.dlg.classList.add("e-rtl");
        this.dlg.classList.remove("e-checkboxfilter");
        this.cmenu = this.parent.createElement("ul", {
            className: "e-excel-menu"
        });
        var menuItems = this.dlg.querySelectorAll(".e-menu-item");
        menuItems.forEach(function(menuItem) {
            if (menuItem.scrollWidth > menuItem.clientWidth) menuItem.setAttribute("title", menuItem.textContent);
        });
        if (options.column.showColumnMenu) this.parent.notify($17b89d3b1fc93cdb$export$4cc1ec161750f031, {});
        this.wireExEvents();
    };
    ExcelFilterBase.prototype.closeDialog = function() {
        this.destroy();
    };
    ExcelFilterBase.prototype.selectHandler = function(e) {
        if (e.item) {
            this.parent.notify($17b89d3b1fc93cdb$export$fafad99bbd7983c0, {});
            this.menuItem = e.item;
            this.closeDialog();
            this.renderDialogue(e);
        }
    };
    /**
     * @hidden
     * @param {MenuEventArgs} e - event args
     * @returns {void}
     */ ExcelFilterBase.prototype.renderDialogue = function(e) {
        var _this = this;
        var target = e ? e.element : undefined;
        var column = this.options.field;
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
        var mainDiv = this.parent.createElement("div", {
            className: "e-xlfl-maindiv",
            id: isComplex ? complexFieldName + "-xlflmenu" : column + "-xlflmenu"
        });
        this.dlgDiv = this.parent.createElement("div", {
            className: "e-xlflmenu",
            id: isComplex ? complexFieldName + "-xlfldlg" : column + "-xlfldlg"
        });
        if (this.options.isResponsiveFilter) {
            var responsiveCnt = document.querySelector(".e-resfilter > .e-dlg-content > .e-xl-customfilterdiv");
            responsiveCnt.appendChild(this.dlgDiv);
        } else this.parent.element.appendChild(this.dlgDiv);
        this.dlgObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            header: this.getLocalizedLabel("CustomFilter"),
            isModal: true,
            overlayClick: this.removeDialog.bind(this),
            showCloseIcon: true,
            locale: this.parent.locale,
            closeOnEscape: true,
            target: document.body,
            // target: this.parent.element,
            visible: false,
            enableRtl: this.parent.enableRtl,
            open: function() {
                var rows = [].slice.call(_this.dlgObj.element.querySelectorAll("table.e-xlfl-table tr.e-xlfl-fields"));
                for(var i = 0; i < rows.length; i++){
                    var valInput = rows[i].children[1].querySelector(".e-control");
                    var dropDownList = rows[i].querySelector(".e-dropdownlist.e-control")["ej2_instances"][0];
                    if (dropDownList.value === "isempty" || dropDownList.value === "isnotempty" || dropDownList.value === "isnull" || dropDownList.value === "isnotnull") valInput["ej2_instances"][0]["enabled"] = false;
                    else if (valInput && !(0, $3EnZW.isNullOrUndefined)(valInput.getAttribute("disabled"))) valInput["ej2_instances"][0]["enabled"] = true;
                }
                var row = _this.dlgObj.element.querySelector("table.e-xlfl-table>tr");
                if (_this.options.column.filterTemplate) {
                    var templateField_1 = (0, $748c2240e597a9b7$export$9850823255bfa4ed)(_this.options.column.field) ? (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(_this.options.column.field) : _this.options.column.field;
                    var isReactCompiler = _this.parent.isReact && typeof _this.options.column.filterTemplate !== "string";
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var isReactChild = _this.parent.parentDetails && _this.parent.parentDetails.parentInstObj && // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this.parent.parentDetails.parentInstObj.isReact;
                    if (isReactCompiler || isReactChild) _this.parent.renderTemplates(function() {
                        row.querySelector("#" + templateField_1 + "-xlfl-frstvalue").focus();
                    });
                    else row.querySelector("#" + templateField_1 + "-xlfl-frstvalue").focus();
                }
            },
            close: this.removeDialog.bind(this),
            created: this.createdDialog.bind(this, target, column),
            buttons: [
                {
                    click: this.filterBtnClick.bind(this, column),
                    buttonModel: {
                        content: this.getLocalizedLabel("OKButton"),
                        isPrimary: true,
                        cssClass: this.parent.cssClass ? "e-xlfl-okbtn " + this.parent.cssClass : "e-xlfl-okbtn"
                    }
                },
                {
                    click: this.removeDialog.bind(this),
                    buttonModel: {
                        content: this.getLocalizedLabel("CancelButton"),
                        cssClass: this.parent.cssClass ? "e-xlfl-cancelbtn " + this.parent.cssClass : "e-xlfl-cancelbtn"
                    }
                }
            ],
            content: mainDiv,
            width: 430,
            animationSettings: {
                effect: "None"
            },
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        var isStringTemplate = "isStringTemplate";
        this.dlgObj["" + isStringTemplate] = true;
        this.renderResponsiveDialog();
        this.dlgDiv.setAttribute("aria-label", this.getLocalizedLabel("CustomFilterDialogARIA"));
        this.childRefs.unshift(this.dlgObj);
        this.dlgObj.appendTo(this.dlgDiv);
    };
    ExcelFilterBase.prototype.renderResponsiveDialog = function() {
        if (this.options.isResponsiveFilter) {
            var rowResponsiveDlg = document.querySelector(".e-row-responsive-filter");
            if (rowResponsiveDlg) rowResponsiveDlg.classList.remove("e-row-responsive-filter");
            this.dlgObj.buttons = [
                {}
            ];
            this.dlgObj.header = undefined;
            this.dlgObj.position = {
                X: "",
                Y: ""
            };
            this.dlgObj.target = document.querySelector(".e-resfilter > .e-dlg-content > .e-xl-customfilterdiv");
            this.dlgObj.width = "100%";
            this.dlgObj.isModal = false;
            this.dlgObj.showCloseIcon = false;
        }
    };
    /**
     * @hidden
     * @returns {void}
     */ ExcelFilterBase.prototype.removeDialog = function() {
        this.parent.notify($17b89d3b1fc93cdb$export$9cc49c8e691f8e1e, {});
        if ((this.parent.isReact || this.parent.isVue) && this.parent.destroyTemplate !== undefined) (0, $748c2240e597a9b7$export$d9aeb73a9e271813)(this.parent, [
            "filterTemplate"
        ]);
        this.removeObjects(this.childRefs);
        (0, $4ZDHT.remove)(this.dlgDiv);
        this.parent.notify($17b89d3b1fc93cdb$export$2542708340471a26, {});
    };
    ExcelFilterBase.prototype.createdDialog = function(target, column) {
        this.renderCustomFilter(target, column);
        this.dlgObj.element.style.left = "0px";
        if (!this.options.isResponsiveFilter) this.dlgObj.element.style.top = "0px";
        else {
            var content = document.querySelector(".e-responsive-dialog > .e-dlg-header-content");
            var height = content.offsetHeight + 4;
            this.dlgObj.element.style.top = height + "px";
        }
        if (!this.options.isResponsiveFilter && (0, $5q7BP.Browser).isDevice && window.innerWidth < 440) this.dlgObj.element.style.width = "90%";
        this.parent.notify($17b89d3b1fc93cdb$export$2f83bf8959673709, {
            column: column,
            dialog: this.dialogObj
        });
        this.dlgObj.show();
        (0, $748c2240e597a9b7$export$b6c750d9a4b9bf2b)(this.parent.element, this.dlgObj.element.parentElement);
    };
    ExcelFilterBase.prototype.renderCustomFilter = function(target, column) {
        var dlgConetntEle = this.dlgObj.element.querySelector(".e-xlfl-maindiv");
        var dlgFields = this.parent.createElement("div", {
            innerHTML: this.getLocalizedLabel("ShowRowsWhere"),
            className: "e-xlfl-dlgfields"
        });
        dlgConetntEle.appendChild(dlgFields);
        //column name
        var fieldSet = this.parent.createElement("div", {
            innerHTML: this.options.displayName,
            className: "e-xlfl-fieldset"
        });
        dlgConetntEle.appendChild(fieldSet);
        this.renderFilterUI(column, dlgConetntEle);
    };
    /**
     * @hidden
     * @param {string} col - Defines column details
     * @returns {void}
     */ ExcelFilterBase.prototype.filterBtnClick = function(col) {
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(col) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(col);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(col) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(col);
        var colValue = isComplex ? complexFieldName : col;
        var fValue = this.dlgDiv.querySelector("#" + colValue + "-xlfl-frstvalue").ej2_instances[0];
        var fOperator = this.dlgDiv.querySelector("#" + colValue + "-xlfl-frstoptr").ej2_instances[0];
        var sValue = this.dlgDiv.querySelector("#" + colValue + "-xlfl-secndvalue").ej2_instances[0];
        var sOperator = this.dlgDiv.querySelector("#" + colValue + "-xlfl-secndoptr").ej2_instances[0];
        var checkBoxValue;
        if (this.options.type === "string") {
            var checkBox = this.dlgDiv.querySelector("#" + colValue + "-xlflmtcase").ej2_instances[0];
            checkBoxValue = checkBox.checked;
        }
        var predicateSelector = this.dlgDiv.querySelector("#" + colValue + "e-xlfl-frstpredicate").ej2_instances[0];
        var predicate = predicateSelector.checked ? "and" : "or";
        this.filterByColumn(this.options.field, fOperator.value, fValue.value, predicate, checkBoxValue, this.options.ignoreAccent, sOperator.value, sValue.value);
        this.removeDialog();
    };
    /**
     * @hidden
     * Filters grid row by column name with given options.
     *
     * @param {string} fieldName - Defines the field name of the filter column.
     * @param {string} firstOperator - Defines the first operator by how to filter records.
     * @param {string | number | Date | boolean} firstValue - Defines the first value which is used to filter records.
     * @param  {string} predicate - Defines the relationship between one filter query with another by using AND or OR predicate.
     * @param {boolean} matchCase - If ignore case set to true, then filter records with exact match or else
     * filter records with case insensitive(uppercase and lowercase letters treated as same).
     * @param {boolean} ignoreAccent - If ignoreAccent set to true, then ignores the diacritic characters or accents when filtering.
     * @param {string} secondOperator - Defines the second operator by how to filter records.
     * @param {string | number | Date | boolean} secondValue - Defines the first value which is used to filter records.
     * @returns {void}
     */ ExcelFilterBase.prototype.filterByColumn = function(fieldName, firstOperator, firstValue, predicate, matchCase, ignoreAccent, secondOperator, secondValue) {
        var col = this.parent.getColumnByField ? this.parent.getColumnByField(fieldName) : this.options.column;
        var field = this.isForeignColumn(col) ? col.foreignKeyValue : fieldName;
        var fColl = [];
        var mPredicate;
        var arg = {
            instance: this,
            handler: this.filterByColumn,
            arg1: fieldName,
            arg2: firstOperator,
            arg3: firstValue,
            arg4: predicate,
            arg5: matchCase,
            arg6: ignoreAccent,
            arg7: secondOperator,
            arg8: secondValue,
            cancel: false
        };
        this.parent.notify($17b89d3b1fc93cdb$export$16e6cefe38bdd512, arg);
        if (arg.cancel) return;
        fColl.push({
            field: field,
            predicate: predicate,
            matchCase: matchCase,
            ignoreAccent: ignoreAccent,
            operator: firstOperator,
            value: arg.arg3,
            type: this.options.type
        });
        mPredicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, firstOperator.toLowerCase(), arg.arg3, !matchCase, ignoreAccent);
        if (!(0, $3EnZW.isNullOrUndefined)(secondOperator)) {
            fColl.push({
                field: field,
                predicate: predicate,
                matchCase: matchCase,
                ignoreAccent: ignoreAccent,
                operator: secondOperator,
                value: arg.arg8,
                type: this.options.type
            });
            mPredicate = mPredicate["" + predicate](field, secondOperator.toLowerCase(), secondValue, !matchCase, ignoreAccent);
        }
        var args = {
            action: "filtering",
            filterCollection: fColl,
            field: this.options.field,
            ejpredicate: mPredicate,
            actualPredicate: fColl
        };
        if (this.isForeignColumn(col)) this.foreignKeyFilter(args, fColl, mPredicate);
        else this.options.handler(args);
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderOperatorUI = function(column, table, elementID, predicates, isFirst) {
        var fieldElement = this.parent.createElement("tr", {
            className: "e-xlfl-fields",
            attrs: {
                role: "row"
            }
        });
        table.appendChild(fieldElement);
        var xlfloptr = this.parent.createElement("td", {
            className: "e-xlfl-optr"
        });
        fieldElement.appendChild(xlfloptr);
        var optrDiv = this.parent.createElement("div", {
            className: "e-xlfl-optrdiv"
        });
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
        var optrInput = this.parent.createElement("input", {
            id: isComplex ? complexFieldName + elementID : column + elementID
        });
        optrDiv.appendChild(optrInput);
        xlfloptr.appendChild(optrDiv);
        var optr = this.options.type + "Operator";
        var dropDatasource = this.customFilterOperators["" + optr];
        this.optrData = dropDatasource;
        var selectedValue = this.dropSelectedVal(this.options.column, predicates, isFirst);
        //Trailing three dots are sliced.
        var menuText = "";
        if (this.menuItem) {
            menuText = this.menuItem.text.slice(0, -3);
            if (menuText !== this.getLocalizedLabel("CustomFilter")) selectedValue = isFirst ? menuText : undefined;
            if (menuText === this.getLocalizedLabel("Between")) selectedValue = this.getLocalizedLabel(isFirst ? "GreaterThanOrEqual" : "LessThanOrEqual");
        }
        var col = this.options.column;
        var dropOptr = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)((0, $748c2240e597a9b7$export$8b58be045bf06082)({
            dataSource: dropDatasource,
            fields: {
                text: "text",
                value: "value"
            },
            text: selectedValue,
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.cssClass ? this.parent.cssClass : null
        }, col.filter.params));
        this.childRefs.unshift(dropOptr);
        var evt = {
            "open": this.dropDownOpen.bind(this),
            "change": this.dropDownValueChange.bind(this)
        };
        (0, $748c2240e597a9b7$export$5bbc0e5c6786f345)(optrInput.id, [
            $1b5568e76cdae6d4$export$3ce6949f20cea765,
            $1b5568e76cdae6d4$export$d8a7b8f475ec0161
        ], evt, this);
        dropOptr.addEventListener($1b5568e76cdae6d4$export$3ce6949f20cea765, this.eventHandlers[optrInput.id][$1b5568e76cdae6d4$export$3ce6949f20cea765]);
        dropOptr.addEventListener($1b5568e76cdae6d4$export$d8a7b8f475ec0161, this.eventHandlers[optrInput.id][$1b5568e76cdae6d4$export$d8a7b8f475ec0161]);
        dropOptr.appendTo(optrInput);
        var operator = this.getSelectedValue(selectedValue);
        return {
            fieldElement: fieldElement,
            operator: operator
        };
    };
    ExcelFilterBase.prototype.removeHandlersFromComponent = function(component) {
        if (component.element.classList.contains("e-dropdownlist")) (0, $748c2240e597a9b7$export$b318228c6d042f7c)(component, [
            $1b5568e76cdae6d4$export$3ce6949f20cea765,
            $1b5568e76cdae6d4$export$d8a7b8f475ec0161
        ], this);
        else if (component.element.classList.contains("e-autocomplete")) (0, $748c2240e597a9b7$export$b318228c6d042f7c)(component, [
            $17b89d3b1fc93cdb$export$830631a3cb598490,
            $1b5568e76cdae6d4$export$d7ddd398f22d79ef
        ], this);
    };
    ExcelFilterBase.prototype.dropDownOpen = function(args) {
        args.popup.element.style.zIndex = (this.dialogObj.zIndex + 1).toString();
    };
    ExcelFilterBase.prototype.dropDownValueChange = function(args) {
        if (args.element.id.includes("-xlfl-frstoptr")) this.firstOperator = args.value.toString();
        else this.secondOperator = args.value.toString();
        var valInput = args.element.closest(".e-xlfl-fields").children[1].querySelector(".e-control");
        var dropDownList = args.element["ej2_instances"][0];
        if (dropDownList.value === "isempty" || dropDownList.value === "isnotempty" || dropDownList.value === "isnull" || dropDownList.value === "isnotnull") valInput["ej2_instances"][0]["enabled"] = false;
        else if (!(0, $3EnZW.isNullOrUndefined)(valInput.getAttribute("disabled"))) valInput["ej2_instances"][0]["enabled"] = true;
    };
    /**
     * @hidden
     * @returns {FilterUI} returns filter UI
     */ ExcelFilterBase.prototype.getFilterUIInfo = function() {
        return {
            firstOperator: this.firstOperator,
            secondOperator: this.secondOperator,
            field: this.options.field
        };
    };
    ExcelFilterBase.prototype.getSelectedValue = function(text) {
        var selectedField = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.optrData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("text", "equal", text));
        return !(0, $3EnZW.isNullOrUndefined)(selectedField[0]) ? selectedField[0].value : "";
    };
    ExcelFilterBase.prototype.dropSelectedVal = function(col, predicates, isFirst) {
        var operator;
        if (predicates && predicates.length > 0) operator = predicates.length === 2 ? isFirst ? predicates[0].operator : predicates[1].operator : isFirst ? predicates[0].operator : undefined;
        else if (isFirst && col.type === "string" && !col.filter.operator) operator = "startswith";
        else operator = isFirst ? col.filter.operator || "equal" : undefined;
        return this.getSelectedText(operator);
    };
    ExcelFilterBase.prototype.getSelectedText = function(operator) {
        var selectedField = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.optrData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("value", "equal", operator));
        return !(0, $3EnZW.isNullOrUndefined)(selectedField[0]) ? selectedField[0].text : "";
    };
    ExcelFilterBase.prototype.renderFilterUI = function(column, dlgConetntEle) {
        var predicates = this.existingPredicate["" + column];
        var table = this.parent.createElement("table", {
            className: "e-xlfl-table",
            attrs: {
                role: "grid"
            }
        });
        dlgConetntEle.appendChild(table);
        var colGroup = this.parent.createElement($1b5568e76cdae6d4$export$f7c2e8f0e9310cd9);
        colGroup.innerHTML = '<col style="width: 50%"></col><col style="width: 50%"></col>';
        table.appendChild(colGroup);
        //Renders first dropdown
        var optr = this.renderOperatorUI(column, table, "-xlfl-frstoptr", predicates, true);
        this.firstOperator = optr.operator;
        //Renders first value
        this.renderFlValueUI(column, optr, "-xlfl-frstvalue", predicates, true);
        var predicate = this.parent.createElement("tr", {
            className: "e-xlfl-predicate",
            attrs: {
                role: "row"
            }
        });
        table.appendChild(predicate);
        //Renders first radion button
        this.renderRadioButton(column, predicate, predicates);
        //Renders second dropdown
        optr = this.renderOperatorUI(column, table, "-xlfl-secndoptr", predicates, false);
        this.secondOperator = optr.operator;
        //Renders second text box
        this.renderFlValueUI(column, optr, "-xlfl-secndvalue", predicates, false);
    };
    ExcelFilterBase.prototype.renderRadioButton = function(column, tr, predicates) {
        var td = this.parent.createElement("td", {
            className: "e-xlfl-radio",
            attrs: {
                "colSpan": "2"
            }
        });
        tr.appendChild(td);
        var radioDiv = this.parent.createElement("div", {
            className: "e-xlfl-radiodiv",
            attrs: {
                "style": "display: inline-block"
            }
        });
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
        var frstpredicate = this.parent.createElement("input", {
            id: isComplex ? complexFieldName + "e-xlfl-frstpredicate" : column + "e-xlfl-frstpredicate",
            attrs: {
                "type": "radio"
            }
        });
        var secndpredicate = this.parent.createElement("input", {
            id: isComplex ? complexFieldName + "e-xlfl-secndpredicate" : column + "e-xlfl-secndpredicate",
            attrs: {
                "type": "radio"
            }
        });
        //appends into div
        radioDiv.appendChild(frstpredicate);
        radioDiv.appendChild(secndpredicate);
        td.appendChild(radioDiv);
        if (this.options.type === "string") this.renderMatchCase(column, tr, td, "-xlflmtcase", predicates);
        // Initialize AND RadioButton component.
        var andRadio = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.getLocalizedLabel("AND"),
            name: "default",
            checked: true,
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        this.childRefs.unshift(andRadio);
        // Initialize OR RadioButton component.
        var orRadio = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.getLocalizedLabel("OR"),
            name: "default",
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        this.childRefs.unshift(orRadio);
        var flValue = predicates && predicates.length === 2 ? predicates[1].predicate : "and";
        if (flValue === "and") {
            andRadio.checked = true;
            orRadio.checked = false;
        } else {
            orRadio.checked = true;
            andRadio.checked = false;
        }
        // Render initialized RadioButton.
        andRadio.appendTo(frstpredicate);
        orRadio.appendTo(secndpredicate);
        andRadio.element.nextElementSibling.classList.add("e-xlfl-radio-and");
        orRadio.element.nextElementSibling.classList.add("e-xlfl-radio-or");
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ExcelFilterBase.prototype.removeObjects = function(elements) {
        for(var _i = 0, elements_1 = elements; _i < elements_1.length; _i++){
            var obj = elements_1[_i];
            if (obj && !obj.isDestroyed) {
                this.removeHandlersFromComponent(obj);
                obj.destroy();
            }
        }
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderFlValueUI = function(column, optr, elementId, predicates, isFirst) {
        var value = this.parent.createElement("td", {
            className: "e-xlfl-value"
        });
        optr.fieldElement.appendChild(value);
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
        var valueDiv = this.parent.createElement("div", {
            className: "e-xlfl-valuediv"
        });
        var isFilteredCol = this.options.filteredColumns.some(function(col) {
            return column === col.field;
        });
        var fltrPredicates = this.options.filteredColumns.filter(function(col) {
            return col.field === column;
        });
        if (this.options.column.filterTemplate) {
            var data = {};
            var columnObj = this.options.column;
            if (isFilteredCol && elementId) data = this.getExcelFilterData(elementId, data, columnObj, predicates, fltrPredicates);
            var isReactCompiler = this.parent.isReact && typeof this.options.column.filterTemplate !== "string";
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.parent.parentDetails.parentInstObj.isReact;
            var tempID = this.parent.element.id + columnObj.uid + "filterTemplate";
            if (isReactCompiler || isReactChild) this.options.column.getFilterTemplate()(data, this.parent, "filterTemplate", tempID, null, null, valueDiv);
            else {
                var element = this.options.column.getFilterTemplate()(data, this.parent, "filterTemplate", tempID, null, null, null, this.parent.root);
                (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(valueDiv, element);
            }
            if (isReactCompiler || isReactChild) this.parent.renderTemplates(function() {
                valueDiv.querySelector("input").id = isComplex ? complexFieldName + elementId : column + elementId;
                value.appendChild(valueDiv);
            });
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (this.parent.isAngular ? valueDiv.children[0] : valueDiv.querySelector("input")).id = isComplex ? complexFieldName + elementId : column + elementId;
                value.appendChild(valueDiv);
            }
        } else {
            var valueInput = this.parent.createElement("input", {
                id: isComplex ? complexFieldName + elementId : column + elementId
            });
            valueDiv.appendChild(valueInput);
            value.appendChild(valueDiv);
            var flValue = void 0;
            var predicate = void 0;
            if (predicates && predicates.length > 0) {
                predicate = predicates.length === 2 ? isFirst ? predicates[0] : predicates[1] : isFirst ? predicates[0] : undefined;
                flValue = predicate && predicate.operator === optr.operator ? predicate.value : undefined;
                if ((0, $3EnZW.isNullOrUndefined)(flValue)) flValue = undefined;
            }
            var types = {
                "string": this.renderAutoComplete.bind(this),
                "number": this.renderNumericTextBox.bind(this),
                "date": this.renderDate.bind(this),
                "dateonly": this.renderDate.bind(this),
                "datetime": this.renderDateTime.bind(this)
            };
            types[this.options.type](this.options, column, valueInput, flValue, this.parent.enableRtl);
        }
    };
    ExcelFilterBase.prototype.getExcelFilterData = function(elementId, data, columnObj, predicates, fltrPredicates) {
        var predIndex = elementId === "-xlfl-frstvalue" ? 0 : 1;
        if (elementId === "-xlfl-frstvalue" || fltrPredicates.length > 1) {
            data = {
                column: predicates instanceof Array ? predicates[parseInt(predIndex.toString(), 10)] : predicates
            };
            var indx = this.options.column.columnData && fltrPredicates.length > 1 ? this.options.column.columnData.length === 1 ? 0 : 1 : predIndex;
            data[this.options.field] = columnObj.foreignKeyValue ? this.options.column.columnData[parseInt(indx.toString(), 10)][columnObj.foreignKeyValue] : fltrPredicates[parseInt(indx.toString(), 10)].value;
            if (this.options.foreignKeyValue) data[this.options.foreignKeyValue] = this.options.column.columnData[parseInt(indx.toString(), 10)][columnObj.foreignKeyValue];
        }
        return data;
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderMatchCase = function(column, tr, matchCase, elementId, predicates) {
        var matchCaseDiv = this.parent.createElement("div", {
            className: "e-xlfl-matchcasediv",
            attrs: {
                "style": "display: inline-block"
            }
        });
        var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
        var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
        var matchCaseInput = this.parent.createElement("input", {
            id: isComplex ? complexFieldName + elementId : column + elementId,
            attrs: {
                "type": "checkbox"
            }
        });
        matchCaseDiv.appendChild(matchCaseInput);
        matchCase.appendChild(matchCaseDiv);
        var flValue = predicates && predicates.length > 0 ? predicates && predicates.length === 2 ? predicates[1].matchCase : predicates[0].matchCase : false;
        // Initialize Match Case check box.
        var checkbox = new (0, $1c7c93589ae50f14$export$ea5f704b89d806f6)({
            label: this.getLocalizedLabel("MatchCase"),
            enableRtl: this.parent.enableRtl,
            checked: flValue,
            cssClass: this.parent.cssClass ? this.parent.cssClass : ""
        });
        this.childRefs.unshift(checkbox);
        // Render initialized CheckBox.
        checkbox.appendTo(matchCaseInput);
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderDate = function(options, column, inputValue, fValue, isRtl) {
        var format = (0, $748c2240e597a9b7$export$cd23debbf9725d)(options.format, options.type) || options.format;
        var datePicker = new (0, $d5f6934cad42758d$export$5109c6dd95d8fb00)((0, $748c2240e597a9b7$export$8b58be045bf06082)({
            format: format,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            placeholder: this.getLocalizedLabel("CustomFilterDatePlaceHolder"),
            width: "100%",
            enableRtl: isRtl,
            value: new Date(fValue),
            locale: this.parent.locale
        }, options.column.filter.params));
        this.childRefs.unshift(datePicker);
        datePicker.appendTo(inputValue);
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderDateTime = function(options, column, inputValue, fValue, isRtl) {
        var format = (0, $748c2240e597a9b7$export$cd23debbf9725d)(options.format, options.type);
        var dateTimePicker = new (0, $3812471840bc0638$export$ccdfd7928785632e)((0, $748c2240e597a9b7$export$8b58be045bf06082)({
            format: format,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            placeholder: this.getLocalizedLabel("CustomFilterDatePlaceHolder"),
            width: "100%",
            enableRtl: isRtl,
            value: new Date(fValue),
            locale: this.parent.locale
        }, options.column.filter.params));
        this.childRefs.unshift(dateTimePicker);
        dateTimePicker.appendTo(inputValue);
    };
    ExcelFilterBase.prototype.completeAction = function(e) {
        e.result = (0, $748c2240e597a9b7$export$7f03ccbb98203610)(e.result);
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderNumericTextBox = function(options, column, inputValue, fValue, isRtl) {
        var numericTextBox = new (0, $75082a70d3498091$export$d910e4596d16bb81)((0, $748c2240e597a9b7$export$8b58be045bf06082)({
            format: options.format,
            placeholder: this.getLocalizedLabel("CustomFilterPlaceHolder"),
            enableRtl: isRtl,
            value: fValue,
            locale: this.parent.locale,
            cssClass: this.parent.cssClass ? this.parent.cssClass : null
        }, options.column.filter.params));
        this.childRefs.unshift(numericTextBox);
        numericTextBox.appendTo(inputValue);
    };
    // eslint-disable-next-line max-len
    ExcelFilterBase.prototype.renderAutoComplete = function(options, column, inputValue, fValue, isRtl) {
        var colObj = this.options.column;
        var isForeignColumn = this.isForeignColumn(colObj);
        var dataSource = isForeignColumn ? colObj.dataSource : options.dataSource;
        var fields = {
            value: isForeignColumn ? colObj.foreignKeyValue : column
        };
        var actObj = new (0, $1b6f3188acd1d256$export$6b41f50dc0c59fb3)((0, $748c2240e597a9b7$export$8b58be045bf06082)({
            dataSource: dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource),
            fields: fields,
            query: this.getQuery(),
            sortOrder: "Ascending",
            locale: this.parent.locale,
            cssClass: this.parent.cssClass ? "e-popup-flmenu " + this.parent.cssClass : "e-popup-flmenu",
            autofill: true,
            placeholder: this.getLocalizedLabel("CustomFilterPlaceHolder"),
            enableRtl: isRtl,
            text: fValue
        }, colObj.filter.params));
        if (dataSource && "result" in dataSource) {
            var defObj = (0, $748c2240e597a9b7$export$5bafd3a29592d203)({
                requestType: "stringfilterrequest"
            }, this.getQuery());
            this.parent.trigger($17b89d3b1fc93cdb$export$4727fff3327259ae, defObj.state);
            var def = defObj.deffered;
            def.promise.then(function(e) {
                actObj.dataSource = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(e);
            });
        }
        this.childRefs.unshift(actObj);
        var evt = {
            "actionComplete": this.acActionComplete(actObj, column),
            "focus": this.acFocus(actObj, column, options, inputValue)
        };
        (0, $748c2240e597a9b7$export$5bbc0e5c6786f345)(inputValue.id, [
            $17b89d3b1fc93cdb$export$830631a3cb598490,
            $1b5568e76cdae6d4$export$d7ddd398f22d79ef
        ], evt, this);
        actObj.addEventListener($1b5568e76cdae6d4$export$d7ddd398f22d79ef, this.eventHandlers[inputValue.id][$1b5568e76cdae6d4$export$d7ddd398f22d79ef]);
        actObj.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.eventHandlers[inputValue.id][$17b89d3b1fc93cdb$export$830631a3cb598490]);
        actObj.appendTo(inputValue);
    };
    ExcelFilterBase.prototype.acActionComplete = function(actObj, column) {
        return function(e) {
            var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
            e.result = e.result.filter(function(obj, index, arr) {
                return arr.map(function(mapObject) {
                    return isComplex ? (0, $748c2240e597a9b7$export$64e408221c1d245b)(actObj.fields.value, mapObject) : mapObject[actObj.fields.value];
                }).indexOf(isComplex ? (0, $748c2240e597a9b7$export$64e408221c1d245b)(actObj.fields.value, obj) : obj[actObj.fields.value]) === index;
            });
        };
    };
    ExcelFilterBase.prototype.acFocus = function(actObj, column, options, inputValue) {
        var _this = this;
        return function() {
            var isComplex = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$9850823255bfa4ed)(column);
            var complexFieldName = !(0, $3EnZW.isNullOrUndefined)(column) && (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(column);
            var columnvalue = isComplex ? complexFieldName : column;
            actObj.filterType = _this.dlgDiv.querySelector("#" + columnvalue + (inputValue.id === columnvalue + "-xlfl-frstvalue" ? "-xlfl-frstoptr" : "-xlfl-secndoptr")).ej2_instances[0].value;
            actObj.ignoreCase = options.type === "string" ? !_this.dlgDiv.querySelector("#" + columnvalue + "-xlflmtcase").ej2_instances[0].checked : true;
            actObj.filterType = !(0, $3EnZW.isNullOrUndefined)(actObj.filterType) ? actObj.filterType : "equal";
        };
    };
    return ExcelFilterBase;
}((0, $66db5ede9cdf4d76$export$325f55b6c744802a));




var $54ac35dc0f8487a8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @hidden
 * `ExcelFilter` module is used to handle filtering action.
 */ var $54ac35dc0f8487a8$export$d4696dc82bf44c04 = /** @class */ function(_super) {
    $54ac35dc0f8487a8$var$__extends(ExcelFilter, _super);
    /**
     * Constructor for excelbox filtering module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {FilterSettings} filterSettings - specifies the Filtersettings
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     * @param {object} customFltrOperators - specifies the customFltrOperators
     * @hidden
     */ function ExcelFilter(parent, filterSettings, serviceLocator, customFltrOperators) {
        var _this = _super.call(this, parent, filterSettings, serviceLocator) || this;
        _this.parent = parent;
        _this.isresetFocus = true;
        _this.excelFilterBase = new (0, $0c3f24e0df11dbc6$export$c0965c6f0513e6de)(parent, customFltrOperators);
        return _this;
    }
    /**
     * To destroy the excel filter.
     *
     * @returns {void}
     * @hidden
     */ ExcelFilter.prototype.destroy = function() {
        this.excelFilterBase.closeDialog();
    };
    ExcelFilter.prototype.openDialog = function(options) {
        this.excelFilterBase.openDialog(options);
    };
    ExcelFilter.prototype.closeDialog = function() {
        this.excelFilterBase.closeDialog();
        if (this.isresetFocus) this.parent.notify($17b89d3b1fc93cdb$export$2284e449d64b22d5, {});
    };
    ExcelFilter.prototype.clearCustomFilter = function(col) {
        this.excelFilterBase.clearFilter(col);
    };
    ExcelFilter.prototype.closeResponsiveDialog = function(isCustomFilter) {
        if (isCustomFilter) this.excelFilterBase.removeDialog();
        else this.closeDialog();
    };
    ExcelFilter.prototype.applyCustomFilter = function(args) {
        if (!args.isCustomFilter) {
            this.excelFilterBase.fltrBtnHandler();
            this.excelFilterBase.closeDialog();
        } else this.excelFilterBase.filterBtnClick(args.col.field);
    };
    ExcelFilter.prototype.filterByColumn = function(fieldName, firstOperator, firstValue, predicate, matchCase, ignoreAccent, secondOperator, secondValue) {
        this.excelFilterBase.filterByColumn(fieldName, firstOperator, firstValue, predicate, matchCase, ignoreAccent, secondOperator, secondValue);
    };
    /**
     * @returns {FilterUI} returns the filterUI
     * @hidden
     */ ExcelFilter.prototype.getFilterUIInfo = function() {
        return this.excelFilterBase.getFilterUIInfo();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ ExcelFilter.prototype.getModuleName = function() {
        return "excelFilter";
    };
    return ExcelFilter;
}((0, $99474349aa277ec7$export$b75a66120a90a757));




/**
 *
 * The `Filter` module is used to handle filtering action.
 */ var $d0beb9f5041cd55b$export$ec91da630f36d5ea = /** @class */ function() {
    /**
     * Constructor for Grid filtering module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {FilterSettings} filterSettings - specifies the filterSettings
     * @param {ServiceLocator} serviceLocator - specifes the serviceLocator
     * @hidden
     */ function Filter(parent, filterSettings, serviceLocator) {
        this.predicate = "and";
        this.contentRefresh = true;
        this.filterByMethod = true;
        this.refresh = true;
        this.values = {};
        this.operators = {};
        this.cellText = {};
        this.nextFlMenuOpen = "";
        this.type = {
            "Menu": (0, $f02efb0a243e5b6e$export$1a0e2f3e930f82cb),
            "CheckBox": (0, $99474349aa277ec7$export$b75a66120a90a757),
            "Excel": (0, $54ac35dc0f8487a8$export$d4696dc82bf44c04)
        };
        /** @hidden */ this.filterOperators = {
            contains: "contains",
            endsWith: "endswith",
            equal: "equal",
            greaterThan: "greaterthan",
            greaterThanOrEqual: "greaterthanorequal",
            lessThan: "lessthan",
            lessThanOrEqual: "lessthanorequal",
            notEqual: "notequal",
            startsWith: "startswith",
            wildCard: "wildcard",
            isNull: "isnull",
            notNull: "notnull",
            like: "like"
        };
        this.fltrDlgDetails = {
            field: "",
            isOpen: false
        };
        /** @hidden */ this.skipNumberInput = [
            "=",
            " ",
            "!"
        ];
        this.skipStringInput = [
            ">",
            "<",
            "="
        ];
        this.actualPredicate = {};
        /** @hidden */ this.inputList = [];
        this.parent = parent;
        this.filterSettings = filterSettings;
        this.serviceLocator = serviceLocator;
        this.addEventListener();
        this.setFullScreenDialog();
    }
    /**
     * To render filter bar when filtering enabled.
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Filter.prototype.render = function(e) {
        if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject("args.isFrozen", e)) return;
        var gObj = this.parent;
        this.l10n = this.serviceLocator.getService("localization");
        this.getLocalizedCustomOperators();
        if (this.parent.filterSettings.type === "FilterBar") {
            if (gObj.columns.length) {
                var fltrElem = this.parent.element.querySelector(".e-filterbar");
                if (fltrElem) (0, $4ZDHT.remove)(fltrElem);
                var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Filter, gObj);
                var cellrender = this.serviceLocator.getService("cellRendererFactory");
                cellrender.addCellRenderer((0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Filter, new (0, $13bc42b7d3ad33cb$export$5f9ad5ac1a77194)(this.parent, this.serviceLocator));
                this.valueFormatter = this.serviceLocator.getService("valueFormatter");
                rowRenderer.element = this.parent.createElement("tr", {
                    className: "e-filterbar",
                    attrs: {
                        role: "row"
                    }
                });
                var row = this.generateRow();
                row.data = this.values;
                this.parent.getHeaderContent().querySelector("thead:not(.e-masked-thead)").appendChild(rowRenderer.element);
                var rowdrag = this.parent.element.querySelector(".e-rowdragheader");
                this.element = rowRenderer.render(row, gObj.getColumns(), null, null, rowRenderer.element);
                if (this.element.querySelectorAll(".e-leftfreeze").length && (this.element.querySelectorAll(".e-indentcell").length || this.element.querySelectorAll(".e-grouptopleftcell").length)) {
                    var td = this.element.querySelectorAll(".e-indentcell, .e-grouptopleftcell");
                    for(var i = 0; i < td.length; i++){
                        td[parseInt(i.toString(), 10)].classList.add("e-leftfreeze");
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(td[parseInt(i.toString(), 10)], i * 30, this.parent.enableRtl, "Left");
                    }
                }
                (0, $748c2240e597a9b7$export$20c2eda854b6814a)(this.element);
                var detail = this.element.querySelector(".e-detailheadercell");
                if (detail) detail.className = "e-filterbarcell e-mastercell";
                if (rowdrag) {
                    if (rowdrag.classList.contains("e-leftfreeze")) rowdrag.className = "e-dragheadercell e-mastercell e-leftfreeze";
                    else rowdrag.className = "e-filterbarcell e-mastercell";
                }
                var gCells = [].slice.call(this.element.getElementsByClassName("e-grouptopleftcell"));
                if (gCells.length) gCells[gCells.length - 1].classList.add("e-lastgrouptopleftcell");
                this.wireEvents();
                this.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
                    case: "filter"
                });
            }
        }
    };
    /**
     * To show the responsive custom filter dialog
     *
     * @param {boolean} enable - specifes dialog open
     * @returns {void}
     * @hidden
     */ Filter.prototype.showCustomFilter = function(enable) {
        this.responsiveDialogRenderer.isCustomDialog = enable;
        this.responsiveDialogRenderer.showResponsiveDialog(this.column);
    };
    Filter.prototype.renderResponsiveChangeAction = function(args) {
        this.responsiveDialogRenderer.action = args.action;
    };
    /**
     * To create the filter module.
     *
     * @param {Column} col - specifies the filtering column name
     * @returns {void}
     * @hidden
     */ Filter.prototype.setFilterModel = function(col) {
        var type = col.filter.type || this.parent.filterSettings.type;
        this.filterModule = new this.type["" + type](this.parent, this.parent.filterSettings, this.serviceLocator, this.customOperators, this);
    };
    /**
     * To destroy the filter bar.
     *
     * @returns {void}
     * @hidden
     */ Filter.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        if (this.filterModule) this.filterModule.destroy();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.parent.refreshing && (this.parent.isDestroyed || !this.parent.allowFiltering)) this.filterSettings.columns = [];
        this.updateFilterMsg();
        this.removeEventListener();
        this.unWireEvents();
        if (this.filterSettings.type === "FilterBar" && !this.parent.isDestroyed) {
            if (this.filterSettings.showFilterBarOperator) {
                var dropdownlist = [].slice.call(this.element.getElementsByClassName("e-filterbaroperator"));
                for(var i = 0; i < dropdownlist.length; i++)if (dropdownlist[parseInt(i.toString(), 10)].ej2_instances[0]) dropdownlist[parseInt(i.toString(), 10)].ej2_instances[0].destroy();
            }
            this.parent.getColumns().map(function(column) {
                if (column.filterBarTemplate && !(0, $3EnZW.isNullOrUndefined)(column.filterBarTemplate.destroy)) {
                    var destroyFn = column.filterBarTemplate.destroy;
                    if (typeof destroyFn === "string") destroyFn = (0, $3EnZW.getValue)(destroyFn, window);
                    destroyFn();
                }
            });
        }
        if (this.element) {
            if (this.element.parentElement) {
                for(var i = 0; i < this.inputList.length; i++){
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy(this.inputList[parseInt(i.toString(), 10)], this.inputList[parseInt(i.toString(), 10)].element.nextElementSibling);
                    (0, $4ZDHT.remove)(this.inputList[parseInt(i.toString(), 10)].element);
                }
                this.inputList = [];
                (0, $4ZDHT.remove)(this.element);
                this.element = null;
            }
            var filterBarElement = this.parent.getHeaderContent().querySelector(".e-filterbar");
            if (filterBarElement) (0, $4ZDHT.remove)(filterBarElement);
        }
    };
    Filter.prototype.setFullScreenDialog = function() {
        if (this.serviceLocator) this.serviceLocator.registerAdaptiveService(this, this.parent.enableAdaptiveUI, (0, $6b76944ddf827cb7$export$b69201db7f59899c).isFilter);
    };
    Filter.prototype.generateRow = function() {
        var options = {};
        var row = new (0, $34f7b5fd578df3e1$export$b59bdbef9ce70de2)(options);
        row.cells = this.generateCells();
        return row;
    };
    Filter.prototype.generateCells = function() {
        //TODO: generate dummy column for group, detail, stacked row here for filtering;
        var cells = [];
        if (this.parent.allowGrouping) for(var c = 0, len = this.parent.groupSettings.columns.length; c < len; c++)cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent));
        if (this.parent.detailTemplate || this.parent.childGrid) cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailHeader));
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() !== "Right") cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragHIcon));
        for(var _i = 0, _a = this.parent.getColumns(); _i < _a.length; _i++){
            var dummy = _a[_i];
            cells.push(this.generateCell(dummy));
        }
        if (this.parent.isRowDragable() && this.parent.getFrozenMode() === "Right") cells.push(this.generateCell({}, (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).RowDragHIcon));
        return cells;
    };
    Filter.prototype.generateCell = function(column, cellType) {
        var opt = {
            "visible": column.visible,
            "isDataCell": false,
            "rowId": "",
            "column": column,
            "cellType": cellType ? cellType : (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Filter,
            "attributes": {
                title: this.l10n.getConstant("FilterbarTitle")
            }
        };
        return new (0, $6362359d69c4bb1e$export$f6f0c3fe4ec306ea)(opt);
    };
    /**
     * To update filterSettings when applying filter.
     *
     * @returns {void}
     * @hidden
     */ Filter.prototype.updateModel = function() {
        var col = this.column.isForeignColumn() ? this.parent.getColumnByUid(this.column.uid) : this.parent.getColumnByField(this.fieldName);
        this.filterObjIndex = this.getFilteredColsIndexByField(col);
        this.prevFilterObject = this.filterSettings.columns[this.filterObjIndex];
        var arrayVal = Array.isArray(this.value) ? this.value : [
            this.value
        ];
        var moduleName = this.parent.dataSource.adaptor && this.parent.dataSource.adaptor.getModuleName ? this.parent.dataSource.adaptor.getModuleName() : undefined;
        for(var i = 0, len = arrayVal.length; i < len; i++){
            var field = col.isForeignColumn() ? col.foreignKeyValue : this.fieldName;
            var isMenuNotEqual = this.operator === "notequal";
            this.currentFilterObject = {
                field: field,
                uid: col.uid,
                isForeignKey: col.isForeignColumn(),
                operator: this.operator,
                value: arrayVal[parseInt(i.toString(), 10)],
                predicate: this.predicate,
                matchCase: this.matchCase,
                ignoreAccent: this.ignoreAccent,
                actualFilterValue: {},
                actualOperator: {}
            };
            var index = this.getFilteredColsIndexByField(col);
            if (index > -1 && !Array.isArray(this.value)) this.filterSettings.columns[parseInt(index.toString(), 10)] = this.currentFilterObject;
            else this.filterSettings.columns.push(this.currentFilterObject);
            if (!this.column.isForeignColumn() && (0, $3EnZW.isNullOrUndefined)(this.value) && (this.operator === "equal" || this.operator === "notequal") && moduleName !== "ODataAdaptor" && moduleName !== "ODataV4Adaptor") {
                for(var i_1 = 0; i_1 < this.filterSettings.columns.length; i_1++)if (this.filterSettings.columns["" + i_1].field === field && (this.filterSettings.columns["" + i_1].operator === "equal" || this.filterSettings.columns["" + i_1].operator === "notequal") && (0, $3EnZW.isNullOrUndefined)(this.filterSettings.columns["" + i_1].value)) {
                    this.filterSettings.columns.splice(i_1, 1);
                    i_1 = i_1 - 1;
                }
                if (col.type === "string") this.filterSettings.columns.push({
                    field: field,
                    ignoreAccent: this.ignoreAccent,
                    matchCase: this.matchCase,
                    operator: this.operator,
                    predicate: isMenuNotEqual ? "and" : "or",
                    value: ""
                });
                this.filterSettings.columns.push({
                    field: field,
                    ignoreAccent: this.ignoreAccent,
                    matchCase: this.matchCase,
                    operator: this.operator,
                    predicate: isMenuNotEqual ? "and" : "or",
                    value: undefined
                });
                this.filterSettings.columns.push({
                    field: field,
                    ignoreAccent: this.ignoreAccent,
                    matchCase: this.matchCase,
                    operator: this.operator,
                    predicate: isMenuNotEqual ? "and" : "or",
                    value: null
                });
            }
        }
        // eslint-disable-next-line no-self-assign
        this.filterSettings.columns = this.filterSettings.columns;
        this.parent.dataBind();
    };
    Filter.prototype.getFilteredColsIndexByField = function(col) {
        var cols = this.filterSettings.columns;
        for(var i = 0, len = cols.length; i < len; i++){
            if (cols[parseInt(i.toString(), 10)].uid === col.uid || col.isForeignColumn() && this.parent.getColumnByUid(col.uid).field === col.foreignKeyValue) return i;
        }
        return -1;
    };
    /**
     * To trigger action complete event.
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Filter.prototype.onActionComplete = function(e) {
        var args = !this.isRemove ? {
            currentFilterObject: this.currentFilterObject,
            /* tslint:disable:no-string-literal */ currentFilteringColumn: !(0, $3EnZW.isNullOrUndefined)(this.column) ? this.column.field : undefined,
            /* tslint:enable:no-string-literal */ columns: this.filterSettings.columns,
            requestType: "filtering",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        } : {
            requestType: "filtering",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, args));
        this.isRemove = false;
    };
    Filter.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.parent.getHeaderContent(), "keyup", this.keyUpHandlerImmediate, this);
    };
    Filter.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), "keyup", this.keyUpHandlerImmediate);
    };
    Filter.prototype.enableAfterRender = function(e) {
        if (e.module === this.getModuleName() && e.enable) {
            this.parent.getHeaderTable().classList.add("e-sortfilter");
            this.render();
        }
    };
    Filter.prototype.refreshFilterValue = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.modelObserver.boundedEvents)) this.parent.removeEventListener($17b89d3b1fc93cdb$export$b59f29322b4450c6, this.refreshFilterValueFn);
        if (this.filterSettings.type === "FilterBar" && this.filterSettings.columns.length && !this.parent.getCurrentViewRecords().length) this.initialEnd();
    };
    Filter.prototype.initialEnd = function() {
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
        if (this.parent.getColumns().length && this.filterSettings.columns.length) {
            var gObj = this.parent;
            this.contentRefresh = false;
            this.initialLoad = true;
            for(var _i = 0, _a = gObj.filterSettings.columns; _i < _a.length; _i++){
                var col = _a[_i];
                this.filterByColumn(col.field, col.operator, col.value, col.predicate, col.matchCase, col.ignoreAccent, col.actualFilterValue, col.actualOperator, col.isForeignKey);
            }
            this.initialLoad = false;
            this.updateFilterMsg();
            this.contentRefresh = true;
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Filter.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$f66e9a7f793619a4, this.setFullScreenDialog, this);
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender, this);
        this.parent.on($17b89d3b1fc93cdb$export$cc6e6748dbb9bba9, this.onActionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyUpHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$cd2e9ca316e8efca, this.columnPositionChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.render, this);
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd, this);
        this.parent.on($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.filterMenuClose, this);
        this.parent.on($17b89d3b1fc93cdb$export$57e9c95e9e650443, this.renderResponsiveChangeAction, this);
        this.docClickHandler = this.clickHandler.bind(this);
        (0, $aqzbR.EventHandler).add(document, "click", this.docClickHandler, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "mousedown", this.refreshClearIcon, this);
        this.parent.on($17b89d3b1fc93cdb$export$bdff1bc700cd682b, this.columnMenuFilter, this);
        this.parent.on($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.filterIconClickHandler, this);
        this.parent.on("persist-data-changed", this.initialEnd, this);
        this.parent.on($17b89d3b1fc93cdb$export$992e182ea3a73b5d, this.clickHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.refreshFilterValueFn = this.refreshFilterValue.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$b59f29322b4450c6, this.refreshFilterValueFn);
    };
    /**
     * @returns {void}
     * @hidden
     */ Filter.prototype.removeEventListener = function() {
        (0, $aqzbR.EventHandler).remove(document, "click", this.docClickHandler);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "mousedown", this.refreshClearIcon);
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$f66e9a7f793619a4, this.setFullScreenDialog);
        this.parent.off($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender);
        this.parent.off($17b89d3b1fc93cdb$export$cc6e6748dbb9bba9, this.onActionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged);
        this.parent.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyUpHandler);
        this.parent.off($17b89d3b1fc93cdb$export$cd2e9ca316e8efca, this.columnPositionChanged);
        this.parent.off($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.render);
        this.parent.off($17b89d3b1fc93cdb$export$bdff1bc700cd682b, this.columnMenuFilter);
        this.parent.off($17b89d3b1fc93cdb$export$64f956c4dbd84d3b, this.filterMenuClose);
        this.parent.off($17b89d3b1fc93cdb$export$57e9c95e9e650443, this.renderResponsiveChangeAction);
        this.parent.off($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.filterIconClickHandler);
        this.parent.off($17b89d3b1fc93cdb$export$992e182ea3a73b5d, this.clickHandler);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    Filter.prototype.refreshClearIcon = function(e) {
        if (this.parent.allowFiltering && this.parent.filterSettings.type === "FilterBar" && e.target.closest("th") && e.target.closest("th").classList.contains("e-filterbarcell") && e.target.classList.contains("e-clear-icon")) {
            var targetText = e.target.previousElementSibling;
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(null, targetText, "Never", true);
            if (this.filterSettings.mode === "Immediate") this.removeFilteredColsByField(targetText.id.slice(0, -14)); //Length of _filterBarcell = 14
        }
    };
    Filter.prototype.filterMenuClose = function() {
        this.fltrDlgDetails.isOpen = false;
    };
    /**
     * Filters the Grid row by fieldName, filterOperator, and filterValue.
     *
     * @param  {string} fieldName - Defines the field name of the filter column.
     * @param  {string} filterOperator - Defines the operator to filter records.
     * @param  {string | number | Date | boolean} filterValue - Defines the value which is used to filter records.
     * @param  {string} predicate - Defines the relationship of one filter query with another by using AND or OR predicate.
     * @param  {boolean} matchCase - If match case is set to true, then the filter records
     * the exact match or <br> filters records that are case insensitive (uppercase and lowercase letters treated the same).
     * @param {boolean} ignoreAccent - If ignoreAccent set to true, then filter ignores the diacritic characters or accents while filtering.
     * @param  {string} actualFilterValue - Defines the actual filter value for the filter column.
     * @param  {string} actualOperator - Defines the actual filter operator for the filter column.
     * @param  {boolean} isForeignColumn - Defines whether it is a foreign key column.
     * @returns {void}
     */ Filter.prototype.filterByColumn = function(fieldName, filterOperator, filterValue, predicate, matchCase, ignoreAccent, actualFilterValue, actualOperator, isForeignColumn) {
        var _this = this;
        var gObj = this.parent;
        var filterCell;
        if (typeof filterValue === "string") filterValue = this.parent.sanitize(filterValue);
        this.column = gObj.grabColumnByFieldFromAllCols(fieldName, isForeignColumn);
        if (this.filterSettings.type === "FilterBar" && this.filterSettings.showFilterBarOperator && (0, $3EnZW.isNullOrUndefined)(this.column.filterBarTemplate) && (0, $3EnZW.isNullOrUndefined)(this.column.filterTemplate)) filterOperator = this.getOperatorName(fieldName);
        if (filterOperator === "like" && filterValue && filterValue.indexOf("%") === -1) filterValue = "%" + filterValue + "%";
        if (!this.column) return;
        if (this.filterSettings.type === "FilterBar") filterCell = gObj.getHeaderContent().querySelector("[id='" + this.column.field + "_filterBarcell']");
        if (!(0, $3EnZW.isNullOrUndefined)(this.column.allowFiltering) && !this.column.allowFiltering) {
            this.parent.log("action_disabled_column", {
                moduleName: this.getModuleName(),
                columnName: this.column.headerText
            });
            return;
        }
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj)) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.filterByColumn,
                arg1: fieldName,
                arg2: filterOperator,
                arg3: filterValue,
                arg4: predicate,
                arg5: matchCase,
                arg6: ignoreAccent,
                arg7: actualFilterValue,
                arg8: actualOperator
            });
            return;
        }
        this.predicate = predicate ? predicate : Array.isArray(filterValue) ? "or" : "and";
        this.value = filterValue;
        this.matchCase = matchCase || false;
        this.ignoreAccent = this.ignoreAccent = !(0, $3EnZW.isNullOrUndefined)(ignoreAccent) ? ignoreAccent : this.parent.filterSettings.ignoreAccent;
        this.fieldName = fieldName;
        this.operator = filterOperator;
        filterValue = !(0, $3EnZW.isNullOrUndefined)(filterValue) ? filterValue.toString() : filterValue;
        if (filterValue === "") filterValue = null;
        if (this.column.type === "number" || this.column.type === "date") this.matchCase = true;
        if (filterCell && this.filterSettings.type === "FilterBar") {
            if (filterValue && filterValue.length < 1 || !this.filterByMethod && this.checkForSkipInput(this.column, filterValue)) {
                this.filterStatusMsg = filterValue && filterValue.length < 1 ? "" : this.l10n.getConstant("InvalidFilterMessage");
                this.updateFilterMsg();
                return;
            }
            if (filterCell.value !== filterValue) filterCell.value = filterValue;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.column.format)) {
            this.applyColumnFormat(filterValue);
            if (this.initialLoad && this.filterSettings.type === "FilterBar") filterCell.value = this.values[this.column.field];
        } else this.values[this.column.field] = filterValue; //this line should be above updateModel
        var predObj = {
            field: this.fieldName,
            predicate: predicate,
            matchCase: matchCase,
            ignoreAccent: ignoreAccent,
            operator: this.operator,
            value: this.value,
            type: this.column.type
        };
        var filterColumn = this.parent.filterSettings.columns.filter(function(fColumn) {
            return fColumn.field === _this.fieldName;
        });
        if (filterColumn.length > 1 && !(0, $3EnZW.isNullOrUndefined)(this.actualPredicate[this.fieldName])) this.actualPredicate[this.fieldName].push(predObj);
        else this.actualPredicate[this.fieldName] = [
            predObj
        ];
        if (this.checkAlreadyColFiltered(this.column.field)) return;
        this.updateModel();
    };
    Filter.prototype.applyColumnFormat = function(filterValue) {
        var _this = this;
        var getFlvalue = this.column.type === "date" || this.column.type === "datetime" || this.column.type === "dateonly" ? new Date(filterValue) : parseFloat(filterValue);
        if ((this.column.type === "date" || this.column.type === "datetime" || this.column.type === "dateonly") && filterValue && Array.isArray(this.value) && filterValue.split(",").length > 1) this.values[this.column.field] = filterValue.split(",").map(function(val) {
            if (val === "") val = null;
            return _this.setFormatForFlColumn(new Date(val), _this.column);
        });
        else this.values[this.column.field] = this.setFormatForFlColumn(getFlvalue, this.column);
    };
    // To skip the second time request to server while applying initial filtering - EJ2-44361
    Filter.prototype.skipUid = function(col) {
        var flag = true;
        var colLen = Object.keys(col);
        for(var i = 0; i < colLen.length; i++){
            var key = Object.keys(col[colLen[parseInt(i.toString(), 10)]]);
            if (key.length === 1 && key[0] === "uid") flag = false;
        }
        return flag;
    };
    Filter.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        for(var _i = 0, _a = Object.keys(e.properties); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "columns":
                    // eslint-disable-next-line no-case-declarations
                    var col = "columns";
                    // eslint-disable-next-line no-case-declarations
                    var args = {
                        currentFilterObject: this.currentFilterObject,
                        currentFilteringColumn: this.column ? this.column.field : undefined,
                        action: "filter",
                        columns: this.filterSettings.columns,
                        requestType: "filtering",
                        type: $17b89d3b1fc93cdb$export$df204737a6131aab,
                        cancel: false
                    };
                    if (this.contentRefresh && this.skipUid(e.properties["" + col])) {
                        this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
                        if (args.cancel) {
                            if (this.filterSettings.type === "CheckBox" || this.filterSettings.type === "Excel") {
                                this.filterSettings.columns = this.actualData.length <= 1 ? this.checkboxPrevFilterObject : this.checkboxFilterObject;
                                this.actualPredicate[this.column.field] = this.filterSettings.columns;
                                var col_1 = this.parent.getColumnByField(this.column.field);
                                var iconClass = this.parent.showColumnMenu && col_1.showColumnMenu ? ".e-columnmenu" : ".e-icon-filter";
                                var filterIconElement = this.parent.getColumnHeaderByField(this.column.field).querySelector(iconClass);
                                if (this.checkboxPrevFilterObject.length === 0) filterIconElement.classList.remove("e-filtered");
                                else filterIconElement.classList.add("e-filtered");
                            } else if ((0, $3EnZW.isNullOrUndefined)(this.prevFilterObject)) this.filterSettings.columns.splice(this.filterSettings.columns.length - 1, 1);
                            else this.filterSettings.columns[this.filterObjIndex] = this.prevFilterObject;
                            return;
                        }
                        this.updateFilterIcon();
                        this.refreshFilterSettings();
                        this.updateFilterMsg();
                        this.updateFilter();
                    }
                    break;
                case "showFilterBarStatus":
                    if (e.properties["" + prop]) this.updateFilterMsg();
                    else if (this.parent.allowPaging) this.parent.updateExternalMessage("");
                    break;
                case "showFilterBarOperator":
                case "type":
                    this.parent.refreshHeader();
                    this.refreshFilterSettings();
                    if (this.parent.height === "100%") this.parent.scrollModule.refresh();
                    break;
            }
        }
    };
    Filter.prototype.refreshFilterSettings = function() {
        if (this.filterSettings.type === "FilterBar") {
            for(var i = 0; i < this.filterSettings.columns.length; i++){
                this.column = this.parent.grabColumnByUidFromAllCols(this.filterSettings.columns[parseInt(i.toString(), 10)].uid);
                var filterValue = this.filterSettings.columns[parseInt(i.toString(), 10)].value;
                filterValue = !(0, $3EnZW.isNullOrUndefined)(filterValue) && filterValue.toString();
                if (!(0, $3EnZW.isNullOrUndefined)(this.column.format)) this.applyColumnFormat(filterValue);
                else {
                    var key = this.filterSettings.columns[parseInt(i.toString(), 10)].field;
                    this.values["" + key] = this.filterSettings.columns[parseInt(i.toString(), 10)].value;
                }
                var filterElement = this.getFilterBarElement(this.column.field);
                if (filterElement) {
                    if (this.cellText[this.filterSettings.columns[parseInt(i.toString(), 10)].field] !== "" && !(0, $3EnZW.isNullOrUndefined)(this.cellText[this.filterSettings.columns[parseInt(i.toString(), 10)].field])) filterElement.value = this.cellText[this.column.field];
                    else filterElement.value = this.filterSettings.columns[parseInt(i.toString(), 10)].value;
                }
            }
            if (this.filterSettings.columns.length === 0) {
                var col = this.parent.getColumns();
                for(var i = 0; i < col.length; i++){
                    var filterElement = this.getFilterBarElement(col[parseInt(i.toString(), 10)].field);
                    if (filterElement && filterElement.value !== "") {
                        filterElement.value = "";
                        delete this.values[col[parseInt(i.toString(), 10)].field];
                    }
                }
            }
        }
    };
    Filter.prototype.updateFilterIcon = function() {
        if (this.filterSettings.columns.length === 0 && this.parent.element.querySelector(".e-filtered")) {
            var fltrIconElement = [].slice.call(this.parent.element.getElementsByClassName("e-filtered"));
            for(var i = 0, len = fltrIconElement.length; i < len; i++)fltrIconElement[parseInt(i.toString(), 10)].classList.remove("e-filtered");
        }
    };
    Filter.prototype.getFilterBarElement = function(col) {
        var selector = "[id='" + col + "_filterBarcell']";
        var filterElement;
        if (selector && !(0, $3EnZW.isNullOrUndefined)(this.element)) filterElement = this.element.querySelector(selector);
        return filterElement;
    };
    /**
     * @private
     * @returns {void}
     */ Filter.prototype.refreshFilter = function() {
        this.refreshFilterSettings();
        this.updateFilterMsg();
    };
    /**
     * Clears all the filtered rows of the Grid.
     *
     * @param {string[]} fields - returns the fields
     * @returns {void}
     */ Filter.prototype.clearFiltering = function(fields) {
        var _this = this;
        var cols = (0, $748c2240e597a9b7$export$3adc9e17a2947b53)(this.filterSettings.columns);
        if (!(0, $3EnZW.isNullOrUndefined)(fields)) {
            this.refresh = false;
            fields.forEach(function(field) {
                _this.removeFilteredColsByField(field, false);
            });
            this.parent.setProperties({
                filterSettings: {
                    columns: this.filterSettings.columns
                }
            }, true);
            this.parent.renderModule.refresh();
            this.refresh = true;
            return;
        }
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(this.parent)) {
            this.parent.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.clearFiltering
            });
            return;
        }
        for(var i = 0; i < cols.length; i++)cols[parseInt(i.toString(), 10)].uid = cols[parseInt(i.toString(), 10)].uid || this.parent.getColumnByField(cols[parseInt(i.toString(), 10)].field).uid;
        var colUid = cols.map(function(f) {
            return f.uid;
        });
        var filteredcols = colUid.filter(function(item, pos) {
            return colUid.indexOf(item) === pos;
        });
        this.refresh = false;
        for(var i = 0, len = filteredcols.length; i < len; i++)this.removeFilteredColsByField(this.parent.getColumnByUid(filteredcols[parseInt(i.toString(), 10)]).field, false);
        this.refresh = true;
        if (filteredcols.length) this.parent.renderModule.refresh();
        if (this.parent.filterSettings.columns.length === 0 && this.parent.element.querySelector(".e-filtered")) {
            var fltrElement = [].slice.call(this.parent.element.getElementsByClassName("e-filtered"));
            for(var i = 0, len = fltrElement.length; i < len; i++)fltrElement[0].classList.remove("e-filtered");
        }
        this.isRemove = true;
        this.filterStatusMsg = "";
        this.updateFilterMsg();
    };
    Filter.prototype.checkAlreadyColFiltered = function(field) {
        var columns = this.filterSettings.columns;
        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
            var col = columns_1[_i];
            if (col.field === field && this.parent.filterSettings.type === "Menu" && (col.type === "date" || col.type === "datetime")) return this.checkDateColumnValue(col.value, this.value) && col.operator === this.operator && col.predicate === this.predicate;
            else if (col.field === field && col.value === this.value && col.operator === this.operator && col.predicate === this.predicate) return true;
        }
        return false;
    };
    Filter.prototype.checkDateColumnValue = function(colDate, filterDate) {
        if ((0, $3EnZW.isNullOrUndefined)(colDate) && (0, $3EnZW.isNullOrUndefined)(filterDate)) return true;
        else if (colDate instanceof Date && filterDate instanceof Date) return colDate.getTime() === filterDate.getTime();
        return false;
    };
    Filter.prototype.columnMenuFilter = function(args) {
        this.column = args.col;
        var ele = (0, $4ZDHT.closest)(args.target, "#" + args.id);
        if (args.isClose && !ele) this.filterModule.closeDialog();
        else if (ele) this.filterDialogOpen(this.column, args.target);
    };
    Filter.prototype.filterDialogOpen = function(col, target, left, top) {
        if (this.filterModule) {
            this.filterModule.isresetFocus = false;
            this.filterModule.closeDialog();
        }
        this.setFilterModel(col);
        this.filterModule.openDialog(this.createOptions(col, target, left, top));
    };
    /**
     * Create filter dialog options
     *
     * @param  {Column} col - Filtering column detail.
     * @param  {Element} target -  Filter dialog target.
     * @param  {number} left -  Filter dialog left position.
     * @param  {number} top -  Filter dialog top position.
     * @returns {Object} returns the created dialog options
     * @hidden
     */ Filter.prototype.createOptions = function(col, target, left, top) {
        var gObj = this.parent;
        var dataSource = col.filter.dataSource || gObj.dataSource && "result" in gObj.dataSource ? gObj.dataSource : gObj.getDataModule().dataManager;
        var type = col.filter.type || this.parent.filterSettings.type;
        var options = {
            type: col.type,
            field: col.field,
            displayName: col.headerText,
            dataSource: dataSource,
            format: col.format,
            height: 800,
            columns: gObj.getColumns(),
            filteredColumns: gObj.filterSettings.columns,
            target: target,
            dataManager: gObj.getDataModule().dataManager,
            formatFn: col.getFormatter(),
            ignoreAccent: gObj.filterSettings.ignoreAccent,
            parserFn: col.getParser(),
            query: gObj.query,
            template: col.getFilterItemTemplate(),
            hideSearchbox: (0, $3EnZW.isNullOrUndefined)(col.filter.hideSearchbox) ? false : col.filter.hideSearchbox,
            handler: this.filterHandler.bind(this),
            localizedStrings: gObj.getLocaleConstants(),
            position: {
                X: left,
                Y: top
            },
            column: col,
            foreignKeyValue: col.foreignKeyValue,
            actualPredicate: this.actualPredicate,
            localeObj: gObj.localeObj,
            isRemote: gObj.getDataModule().isRemote(),
            allowCaseSensitive: this.filterSettings.enableCaseSensitivity,
            isResponsiveFilter: this.parent.enableAdaptiveUI,
            operator: this.actualPredicate[col.field] && type === "Menu" ? this.actualPredicate[col.field][0].operator : "equal",
            parentTotalDataCount: gObj.getDataModule().isRemote() && gObj.allowPaging ? gObj.pagerModule.pagerObj.totalRecordsCount : gObj.getDataModule().isRemote() ? gObj.totalDataRecordsCount : gObj.getFilteredRecords().length,
            parentCurrentViewDataCount: gObj.currentViewData.length,
            parentFilteredLocalRecords: !gObj.getDataModule().isRemote() ? gObj.getFilteredRecords() : []
        };
        return options;
    };
    /**
     * Removes filtered column by field name.
     *
     * @param  {string} field - Defines column field name to remove filter.
     * @param  {boolean} isClearFilterBar - Specifies whether the filter bar value needs to be cleared.
     * @returns {void}
     * @hidden
     */ Filter.prototype.removeFilteredColsByField = function(field, isClearFilterBar) {
        var fCell;
        var cols = this.filterSettings.columns;
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(this.parent)) {
            var args = {
                instance: this,
                handler: this.removeFilteredColsByField,
                arg1: field,
                arg2: isClearFilterBar
            };
            this.parent.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, args);
            return;
        }
        var colUid = cols.map(function(f) {
            return f.uid;
        });
        var filteredColsUid = colUid.filter(function(item, pos) {
            return colUid.indexOf(item) === pos;
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.column)) {
            var col = this.column.isForeignColumn() ? this.parent.getColumnByUid(this.column.uid) : this.parent.getColumnByField(field);
            this.filterObjIndex = this.getFilteredColsIndexByField(col);
            this.prevFilterObject = this.filterSettings.columns[this.filterObjIndex];
        }
        var _loop_1 = function(i, len) {
            cols[parseInt(i.toString(), 10)].uid = cols[parseInt(i.toString(), 10)].uid || this_1.parent.getColumnByField(cols[parseInt(i.toString(), 10)].field).uid;
            var len_1 = cols.length;
            var column = this_1.parent.grabColumnByUidFromAllCols(filteredColsUid[parseInt(i.toString(), 10)]);
            if (column.field === field || column.field === column.foreignKeyValue && column.isForeignColumn()) {
                var currentPred = this_1.filterSettings.columns.filter(function(e) {
                    return e.uid === column.uid;
                })[0];
                if (this_1.filterSettings.type === "FilterBar" && !isClearFilterBar) {
                    var selector = "[id='" + column.field + "_filterBarcell']";
                    fCell = this_1.parent.getHeaderContent().querySelector(selector);
                    if (fCell) {
                        fCell.value = "";
                        delete this_1.values["" + field];
                    }
                }
                while(len_1--)if (cols[parseInt(len_1.toString(), 10)].uid === column.uid) cols.splice(len_1, 1);
                var fltrElement = this_1.parent.getColumnHeaderByField(column.field);
                if (this_1.filterSettings.type !== "FilterBar" || this_1.parent.showColumnMenu) {
                    var iconClass = this_1.parent.showColumnMenu && column.showColumnMenu ? ".e-columnmenu" : ".e-icon-filter";
                    fltrElement.querySelector(iconClass).classList.remove("e-filtered");
                }
                this_1.isRemove = true;
                if (this_1.actualPredicate["" + field]) delete this_1.actualPredicate["" + field];
                if (this_1.values["" + field]) delete this_1.values["" + field];
                if (this_1.refresh) this_1.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, {
                    requestType: "filtering",
                    type: $17b89d3b1fc93cdb$export$df204737a6131aab,
                    currentFilterObject: currentPred,
                    currentFilterColumn: column,
                    action: "clearFilter"
                });
                return "break";
            }
        };
        var this_1 = this;
        for(var i = 0, len = filteredColsUid.length; i < len; i++){
            var state_1 = _loop_1(i, len);
            if (state_1 === "break") break;
        }
        this.updateFilterMsg();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Filter.prototype.getModuleName = function() {
        return "filter";
    };
    Filter.prototype.keyUpHandlerImmediate = function(e) {
        if (e.keyCode !== 13) this.keyUpHandler(e);
    };
    Filter.prototype.keyUpHandler = function(e) {
        var gObj = this.parent;
        var target = e.target;
        if (target && (0, $4ZDHT.matches)(target, ".e-filterbar input")) {
            var closeHeaderEle = (0, $4ZDHT.closest)(target, "th.e-filterbarcell");
            this.column = gObj.getColumnByUid(closeHeaderEle.getAttribute("e-mappinguid"));
            if (!this.column) return;
            if (e.action === "altDownArrow" && this.parent.filterSettings.showFilterBarOperator) {
                var dropDownListInput = (0, $4ZDHT.closest)(target, "span").querySelector(".e-filterbaroperator");
                dropDownListInput.ej2_instances[0].showPopup();
                dropDownListInput.focus();
            }
            if ((this.filterSettings.mode === "Immediate" || e.keyCode === 13 && !e.target.classList.contains("e-filterbaroperator")) && e.keyCode !== 9 && !this.column.filterTemplate) {
                this.value = target.value.trim();
                this.processFilter(e);
            }
        }
        if (e.action === "altDownArrow" && this.filterSettings.type !== "FilterBar" && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar") && (0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector(".e-filter-popup")) && !this.parent.enableAdaptiveUI) {
            var element = gObj.focusModule.currentInfo.element;
            if (element && element.classList.contains("e-headercell") && !element.classList.contains("e-stackedheadercell")) {
                var column = gObj.getColumnByUid(element.firstElementChild.getAttribute("e-mappinguid"));
                this.openMenuByField(column.field);
                this.parent.focusModule.clearIndicator();
            }
        }
        if (e.action === "escape" && this.filterSettings.type === "Menu" && this.filterModule) {
            this.filterModule.closeDialog();
            gObj.notify($17b89d3b1fc93cdb$export$2284e449d64b22d5, {});
        }
    };
    Filter.prototype.updateCrossIcon = function(element) {
        if (element.value.length) element.nextElementSibling.classList.remove("e-hide");
    };
    Filter.prototype.updateFilterMsg = function() {
        if (this.filterSettings.type === "FilterBar") {
            var gObj = this.parent;
            var getFormatFlValue = void 0;
            var columns = this.filterSettings.columns;
            var column = void 0;
            if (!this.filterSettings.showFilterBarStatus) return;
            if (columns.length > 0 && this.filterStatusMsg !== this.l10n.getConstant("InvalidFilterMessage")) {
                this.filterStatusMsg = "";
                for(var index = 0; index < columns.length; index++){
                    column = gObj.grabColumnByUidFromAllCols(columns[parseInt(index.toString(), 10)].uid) || gObj.grabColumnByFieldFromAllCols(columns[parseInt(index.toString(), 10)].field, columns[parseInt(index.toString(), 10)].isForeignKey);
                    if (index) this.filterStatusMsg += " && ";
                    if (!(0, $3EnZW.isNullOrUndefined)(column.format)) {
                        var flValue = column.type === "date" || column.type === "datetime" || column.type === "dateonly" ? this.valueFormatter.fromView(this.values[column.field], column.getParser(), column.type === "dateonly" ? "date" : column.type) : this.values[column.field];
                        if (!(column.type === "date" || column.type === "datetime" || column.type === "dateonly")) {
                            var formater = this.serviceLocator.getService("valueFormatter");
                            getFormatFlValue = formater.toView(flValue, column.getParser()).toString();
                        } else getFormatFlValue = this.setFormatForFlColumn(flValue, column);
                        this.filterStatusMsg += column.headerText + ": " + getFormatFlValue;
                    } else this.filterStatusMsg += column.headerText + ": " + this.values[column.field];
                }
            }
            if (gObj.allowPaging) {
                gObj.updateExternalMessage(this.filterStatusMsg);
                if (this.parent.height === "100%") this.parent.scrollModule.refresh();
            }
            //TODO: virtual paging
            this.filterStatusMsg = "";
        }
    };
    Filter.prototype.setFormatForFlColumn = function(value, column) {
        var formater = this.serviceLocator.getService("valueFormatter");
        return formater.toView(value, column.getFormatter()).toString();
    };
    Filter.prototype.checkForSkipInput = function(column, value) {
        var isSkip;
        if (column.type === "number") {
            if ((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).operatorSymbols["" + value] || this.skipNumberInput.indexOf(value) > -1) isSkip = true;
        } else if (column.type === "string") for(var _i = 0, value_1 = value; _i < value_1.length; _i++){
            var val = value_1[_i];
            if (this.skipStringInput.indexOf(val) > -1) isSkip = true;
        }
        return isSkip;
    };
    Filter.prototype.processFilter = function(e) {
        this.stopTimer();
        this.startTimer(e);
    };
    Filter.prototype.startTimer = function(e) {
        var _this = this;
        this.timer = window.setInterval(function() {
            _this.onTimerTick();
        }, e.keyCode === 13 ? 0 : this.filterSettings.immediateModeDelay);
    };
    Filter.prototype.stopTimer = function() {
        window.clearInterval(this.timer);
    };
    Filter.prototype.onTimerTick = function() {
        var selector = "[id='" + this.column.field + "_filterBarcell']";
        var filterElement = this.element.querySelector(selector);
        if (!filterElement) filterElement = this.parent.getHeaderContent().querySelector(selector);
        var filterValue;
        this.cellText[this.column.field] = filterElement.value;
        this.stopTimer();
        if (!(0, $3EnZW.isNullOrUndefined)(this.column.filterBarTemplate)) {
            var templateRead = this.column.filterBarTemplate.read;
            if (typeof templateRead === "string") templateRead = (0, $3EnZW.getValue)(templateRead, window);
            if (!(0, $3EnZW.isNullOrUndefined)(templateRead)) this.value = templateRead.call(this, filterElement);
        } else filterValue = JSON.parse(JSON.stringify(filterElement.value));
        if ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value === "") {
            this.removeFilteredColsByField(this.column.field);
            return;
        }
        this.validateFilterValue(this.value);
        this.filterByMethod = false;
        this.filterByColumn(this.column.field, this.operator, this.value, this.predicate, this.filterSettings.enableCaseSensitivity, this.ignoreAccent, this.column.isForeignColumn());
        this.filterByMethod = true;
        filterElement.value = filterValue;
        this.updateFilterMsg();
    };
    Filter.prototype.validateFilterValue = function(value) {
        var skipInput;
        var index;
        this.matchCase = this.filterSettings.enableCaseSensitivity;
        switch(this.column.type){
            case "number":
                if (this.column.filter.operator) this.operator = this.column.filter.operator;
                else this.operator = this.filterOperators.equal;
                skipInput = [
                    ">",
                    "<",
                    "=",
                    "!"
                ];
                for(var i = 0; i < value.length; i++)if (skipInput.indexOf(value[parseInt(i.toString(), 10)]) > -1) {
                    index = i;
                    break;
                }
                this.getOperator(value.substring(index));
                if (index !== 0) this.value = value.substring(0, index);
                if (this.value !== "" && value.length >= 1) this.value = this.valueFormatter.fromView(this.value, this.column.getParser(), this.column.type);
                if (isNaN(this.value)) this.filterStatusMsg = this.l10n.getConstant("InvalidFilterMessage");
                break;
            case "date":
            case "datetime":
                this.operator = this.filterOperators.equal;
                if (this.value !== "" && !(this.value instanceof Date)) {
                    this.getOperator(value);
                    this.value = this.valueFormatter.fromView(this.value, this.column.getParser(), this.column.type);
                    if ((0, $3EnZW.isNullOrUndefined)(this.value)) this.filterStatusMsg = this.l10n.getConstant("InvalidFilterMessage");
                }
                break;
            case "string":
                this.matchCase = false;
                if (this.column.filter.operator) this.operator = this.column.filter.operator;
                else {
                    if (value.indexOf("*") !== -1 || value.indexOf("?") !== -1 || value.indexOf("%3f") !== -1) this.operator = this.filterOperators.wildCard;
                    else if (value.indexOf("%") !== -1) this.operator = this.filterOperators.like;
                    else this.operator = this.filterOperators.startsWith;
                }
                break;
            case "boolean":
                if (value.toLowerCase() === "true" || value === "1") this.value = true;
                else if (value.toLowerCase() === "false" || value === "0") this.value = false;
                else if (value.length) this.filterStatusMsg = this.l10n.getConstant("InvalidFilterMessage");
                this.operator = this.filterOperators.equal;
                break;
            default:
                if (this.column.filter.operator) this.operator = this.column.filter.operator;
                else this.operator = this.filterOperators.equal;
        }
    };
    Filter.prototype.getOperator = function(value) {
        var singleOp = value.charAt(0);
        var multipleOp = value.slice(0, 2);
        var operators = (0, $3EnZW.extend)({
            "=": this.filterOperators.equal,
            "!": this.filterOperators.notEqual
        }, (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).operatorSymbols);
        // eslint-disable-next-line no-prototype-builtins
        if (operators.hasOwnProperty(singleOp) || operators.hasOwnProperty(multipleOp)) {
            this.operator = operators["" + singleOp];
            this.value = value.substring(1);
            if (!this.operator) {
                this.operator = operators["" + multipleOp];
                this.value = value.substring(2);
            }
        }
        if (this.operator === this.filterOperators.lessThan || this.operator === this.filterOperators.greaterThan) {
            if (this.value.charAt(0) === "=") {
                this.operator = this.operator + "orequal";
                this.value = this.value.substring(1);
            }
        }
    };
    Filter.prototype.columnPositionChanged = function() {
        if (this.parent.filterSettings.type !== "FilterBar") return;
    };
    Filter.prototype.getLocalizedCustomOperators = function() {
        var numOptr = [
            {
                value: "equal",
                text: this.l10n.getConstant("Equal")
            },
            {
                value: "greaterthan",
                text: this.l10n.getConstant("GreaterThan")
            },
            {
                value: "greaterthanorequal",
                text: this.l10n.getConstant("GreaterThanOrEqual")
            },
            {
                value: "lessthan",
                text: this.l10n.getConstant("LessThan")
            },
            {
                value: "lessthanorequal",
                text: this.l10n.getConstant("LessThanOrEqual")
            },
            {
                value: "notequal",
                text: this.l10n.getConstant("NotEqual")
            },
            {
                value: "isnull",
                text: this.l10n.getConstant("IsNull")
            },
            {
                value: "isnotnull",
                text: this.l10n.getConstant("NotNull")
            }
        ];
        this.customOperators = {
            stringOperator: [
                {
                    value: "startswith",
                    text: this.l10n.getConstant("StartsWith")
                },
                {
                    value: "endswith",
                    text: this.l10n.getConstant("EndsWith")
                },
                {
                    value: "contains",
                    text: this.l10n.getConstant("Contains")
                },
                {
                    value: "equal",
                    text: this.l10n.getConstant("Equal")
                },
                {
                    value: "isempty",
                    text: this.l10n.getConstant("IsEmpty")
                },
                {
                    value: "doesnotstartwith",
                    text: this.l10n.getConstant("NotStartsWith")
                },
                {
                    value: "doesnotendwith",
                    text: this.l10n.getConstant("NotEndsWith")
                },
                {
                    value: "doesnotcontain",
                    text: this.l10n.getConstant("NotContains")
                },
                {
                    value: "notequal",
                    text: this.l10n.getConstant("NotEqual")
                },
                {
                    value: "isnotempty",
                    text: this.l10n.getConstant("IsNotEmpty")
                },
                {
                    value: "like",
                    text: this.l10n.getConstant("Like")
                }
            ],
            numberOperator: numOptr,
            dateOperator: numOptr,
            datetimeOperator: numOptr,
            dateonlyOperator: numOptr,
            booleanOperator: [
                {
                    value: "equal",
                    text: this.l10n.getConstant("Equal")
                },
                {
                    value: "notequal",
                    text: this.l10n.getConstant("NotEqual")
                }
            ]
        };
    };
    /**
     * @param {string} field - specifies the field name
     * @returns {void}
     * @hidden
     */ Filter.prototype.openMenuByField = function(field) {
        var gObj = this.parent;
        if (gObj.enableAdaptiveUI) {
            this.showCustomFilter(false);
            return;
        }
        var column = gObj.getColumnByField(field);
        var header = gObj.getColumnHeaderByField(field);
        var target = header.querySelector(".e-filtermenudiv");
        if (!target) return;
        var gClient = gObj.element.getBoundingClientRect();
        var fClient = target.getBoundingClientRect();
        this.filterDialogOpen(column, target, fClient.right - gClient.left, fClient.bottom - gClient.top);
    };
    Filter.prototype.filterIconClickHandler = function(e) {
        var target = e.target;
        if (target.classList.contains("e-filtermenudiv") && (this.parent.filterSettings.type === "Menu" || this.parent.filterSettings.type === "CheckBox" || this.parent.filterSettings.type === "Excel")) {
            var gObj = this.parent;
            var col = gObj.getColumnByUid((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headercell").firstElementChild.getAttribute("e-mappinguid"));
            this.column = col;
            if (this.fltrDlgDetails.field === col.field && this.fltrDlgDetails.isOpen) return;
            if (this.filterModule) this.filterModule.closeDialog();
            this.fltrDlgDetails = {
                field: col.field,
                isOpen: true
            };
            this.openMenuByField(col.field);
        }
    };
    Filter.prototype.clickHandler = function(e) {
        if (this.filterSettings.type === "FilterBar" && this.filterSettings.showFilterBarOperator) {
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-filterbarcell") && e.target.classList.contains("e-input-group-icon")) {
                var filterOperatorElement = (0, $4ZDHT.closest)(e.target, "div").querySelector(".e-filterbaroperator");
                if (filterOperatorElement) filterOperatorElement.focus();
                else e.target.focus();
            }
            if (e.target.classList.contains("e-list-item")) {
                var inputId = document.querySelector(".e-popup-open").getAttribute("id").replace("_popup", "");
                if (inputId.indexOf("grid-column") !== -1) (0, $4ZDHT.closest)(document.getElementById(inputId), "div").querySelector(".e-filtertext").focus();
            }
        }
        if (this.filterSettings.mode === "Immediate" || this.parent.filterSettings.type === "Menu" || this.parent.filterSettings.type === "CheckBox" || this.parent.filterSettings.type === "Excel") {
            var target = e.target;
            var datepickerEle = target.classList.contains("e-day"); // due to datepicker popup cause
            var dialog = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.parent.element, "e-dialog");
            var hasDialog = false;
            var popupEle = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-popup");
            var hasDialogClosed = this.parent.element.classList.contains("e-device") ? document.querySelector(".e-filter-popup") : document.getElementById(this.parent.element.id + "_e-popup") ? document.getElementById(this.parent.element.id + "_e-popup").querySelector(".e-filter-popup") : this.parent.element.querySelector(".e-filter-popup");
            if (dialog && popupEle) hasDialog = dialog.id === popupEle.id;
            if (this.filterModule && hasDialogClosed && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-excel-ascending") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-excel-descending"))) this.filterModule.closeDialog(target);
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-filter-popup") || target.classList.contains("e-filtermenudiv")) return;
            else if (this.filterModule && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-date-overflow") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-popup-wrapper") && !(0, $4ZDHT.closest)(target, ".e-filter-item.e-menu-item") && !datepickerEle && !((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-search-wrapper") && !hasDialogClosed)) {
                if (hasDialog && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-filter-popup") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-popup-flmenu") || !popupEle && hasDialogClosed) {
                    this.filterModule.isresetFocus = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-grid") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-grid").id === this.parent.element.id && !((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-search-wrapper") && hasDialogClosed);
                    this.filterModule.closeDialog(target);
                }
            }
        }
    };
    Filter.prototype.filterHandler = function(args) {
        this.actualPredicate[args.field] = args.actualPredicate;
        this.actualData = Object.keys(this.actualPredicate);
        var dataManager = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.filterSettings.columns);
        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)().where("field", this.filterOperators.equal, args.field);
        this.checkboxFilterObject = dataManager.dataSource.json;
        this.checkboxPrevFilterObject = dataManager.executeLocal(query);
        for(var i = 0; i < this.checkboxPrevFilterObject.length; i++){
            var index = -1;
            for(var j = 0; j < this.filterSettings.columns.length; j++)if (this.checkboxPrevFilterObject[parseInt(i.toString(), 10)].field === this.filterSettings.columns[parseInt(j.toString(), 10)].field) {
                index = j;
                break;
            }
            if (index !== -1) this.filterSettings.columns.splice(index, 1);
        }
        if (this.values[args.field]) delete this.values[args.field];
        var col = this.parent.getColumnByField(args.field);
        var iconClass = this.parent.showColumnMenu && col.showColumnMenu ? ".e-columnmenu" : ".e-icon-filter";
        var filterIconElement = this.parent.getColumnHeaderByField(args.field).querySelector(iconClass);
        if (args.action === "filtering") {
            this.filterSettings.columns = this.filterSettings.columns.concat(args.filterCollection);
            if (this.filterSettings.columns.length && filterIconElement) filterIconElement.classList.add("e-filtered");
        } else {
            if (filterIconElement) filterIconElement.classList.remove("e-filtered");
            args.requestType = "filtering";
            this.parent.renderModule.refresh(args); //hot-fix onpropertychanged not working for object { array }
        }
        this.parent.dataBind();
    };
    Filter.prototype.updateFilter = function() {
        var cols = this.filterSettings.columns;
        this.actualPredicate = {};
        for(var i = 0; i < cols.length; i++){
            this.column = this.parent.getColumnByField(cols[parseInt(i.toString(), 10)].field) || (0, $748c2240e597a9b7$export$e0d896ad751b9ff7)(cols[parseInt(i.toString(), 10)].field, this.parent.getForeignKeyColumns());
            var fieldName = cols[parseInt(i.toString(), 10)].field;
            if (!this.parent.getColumnByField(cols[parseInt(i.toString(), 10)].field)) fieldName = (0, $748c2240e597a9b7$export$e0d896ad751b9ff7)(cols[parseInt(i.toString(), 10)].field, this.parent.getForeignKeyColumns()).field;
            this.refreshFilterIcon(fieldName, cols[parseInt(i.toString(), 10)].operator, cols[parseInt(i.toString(), 10)].value, cols[parseInt(i.toString(), 10)].type, cols[parseInt(i.toString(), 10)].predicate, cols[parseInt(i.toString(), 10)].matchCase, cols[parseInt(i.toString(), 10)].ignoreAccent, cols[parseInt(i.toString(), 10)].uid);
        }
    };
    Filter.prototype.refreshFilterIcon = function(fieldName, operator, value, type, predicate, matchCase, ignoreAccent, uid) {
        var obj = {
            field: fieldName,
            predicate: predicate,
            matchCase: matchCase,
            ignoreAccent: ignoreAccent,
            operator: operator,
            value: value,
            type: type
        };
        if (this.actualPredicate["" + fieldName]) this.actualPredicate["" + fieldName].push(obj);
        else this.actualPredicate["" + fieldName] = [
            obj
        ];
        var field = uid ? this.parent.grabColumnByUidFromAllCols(uid).field : fieldName;
        this.addFilteredClass(field);
    };
    Filter.prototype.addFilteredClass = function(fieldName) {
        var filterIconElement;
        var col = this.parent.getColumnByField(fieldName);
        if (this.parent.showColumnMenu && col.showColumnMenu) filterIconElement = this.parent.getColumnHeaderByField(fieldName).querySelector(".e-columnmenu");
        else if (col) filterIconElement = this.parent.getColumnHeaderByField(fieldName).querySelector(".e-icon-filter");
        if (filterIconElement) filterIconElement.classList.add("e-filtered");
    };
    /**
     * @hidden
     * @returns {FilterUI} returns the FilterUI
     */ Filter.prototype.getFilterUIInfo = function() {
        return this.filterModule ? this.filterModule.getFilterUIInfo() : {};
    };
    /**
     * @param {string} field - specifies the field name
     * @returns {string} returns the operator name
     * @hidden
     */ Filter.prototype.getOperatorName = function(field) {
        return document.getElementById(this.parent.getColumnByField(field).uid).ej2_instances[0].value;
    };
    /**
     * Renders checkbox items in Menu filter dialog.
     *
     * @returns {void}
     */ Filter.prototype.renderCheckboxOnFilterMenu = function() {
        return this.filterModule.renderCheckBoxMenu();
    };
    return Filter;
}();

parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");





/**
 * Infinite Scrolling class
 *
 * @hidden
 */ var $ed66721474bb02be$export$c5295390d6167a3e = /** @class */ function() {
    /**
     * Constructor for the Grid infinite scrolling.
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} serviceLocator - specifies the ServiceLocator
     * @hidden
     */ function InfiniteScroll(parent, serviceLocator) {
        this.infiniteCache = {};
        this.infiniteCurrentViewData = {};
        this.isDownScroll = false;
        this.isUpScroll = false;
        this.isScroll = true;
        this.enableContinuousScroll = false;
        this.initialRender = true;
        this.isRemove = false;
        this.isInitialCollapse = false;
        this.prevScrollTop = 0;
        this.actions = [
            "filtering",
            "searching",
            "grouping",
            "ungrouping",
            "reorder",
            "sorting",
            "refresh"
        ];
        this.keys = [
            $1b5568e76cdae6d4$export$d81610064893988e,
            $1b5568e76cdae6d4$export$d12bbdaa0e5320e2,
            $1b5568e76cdae6d4$export$e668df1bcd81e4d2,
            $1b5568e76cdae6d4$export$9f99fe2ed5bb7a29
        ];
        this.rowTop = 0;
        this.virtualInfiniteData = {};
        this.isCancel = false;
        this.emptyRowData = {};
        this.isNormaledit = false;
        this.isInfiniteScroll = false;
        this.isLastPage = false;
        this.isInitialRender = true;
        this.isFocusScroll = false;
        this.isGroupCollapse = false;
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.isNormaledit = this.parent.editSettings.mode === "Normal";
        this.addEventListener();
        this.widthService = serviceLocator.getService("widthService");
        this.rowModelGenerator = new (0, $7ddfd3da489c240b$export$2cf41885b7ecbd06)(this.parent);
    }
    InfiniteScroll.prototype.getModuleName = function() {
        return "infiniteScroll";
    };
    /**
     * @returns {void}
     * @hidden
     */ InfiniteScroll.prototype.addEventListener = function() {
        this.parent.on($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.onDataReady, this);
        this.parent.on($17b89d3b1fc93cdb$export$a8ad22510e401e59, this.dataSourceModified, this);
        this.parent.on($17b89d3b1fc93cdb$export$e8809d2928c13994, this.infinitePageQuery, this);
        this.parent.on($17b89d3b1fc93cdb$export$d2df54dc266fa920, this.infiniteScrollHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0, this.infiniteCellFocus, this);
        this.parent.on($17b89d3b1fc93cdb$export$d1d974c345b7e95, this.appendInfiniteRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$d74111ea55be118d, this.removeInfiniteCacheRows, this);
        this.parent.on($17b89d3b1fc93cdb$export$795a13a52b6b60d3, this.resetInfiniteBlocks, this);
        this.parent.on($17b89d3b1fc93cdb$export$54948f7b626812fe, this.setCache, this);
        this.parent.on($17b89d3b1fc93cdb$export$21f05f465c475796, this.ensureIntialCollapse, this);
        this.parent.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.infiniteCellFocus, this);
        this.parent.on($17b89d3b1fc93cdb$export$acf275d6bf7c2a3, this.setDisplayNone, this);
        this.parent.on($17b89d3b1fc93cdb$export$6d303e5560d57498, this.editActionBegin, this);
        this.parent.on($17b89d3b1fc93cdb$export$a1aad2683385fb49, this.getVirtualInfiniteData, this);
        this.parent.on($17b89d3b1fc93cdb$export$82a793dcb3807178, this.resetInfiniteEdit, this);
        this.parent.on($17b89d3b1fc93cdb$export$d2863c79b905c4cd, this.infiniteEditSuccess, this);
        this.parent.on($17b89d3b1fc93cdb$export$a715e34adf8189a2, this.refreshInfiniteCache, this);
        this.parent.on($17b89d3b1fc93cdb$export$97df389aeb32c2d5, this.refreshInfiniteEditrowindex, this);
        this.parent.on($17b89d3b1fc93cdb$export$b3a2f7adafd2c20, this.infiniteEditHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$25a0d5e14cd34614, this.infiniteAddActionBegin, this);
        this.parent.on($17b89d3b1fc93cdb$export$80cded91831c5507, this.modelChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$26c30b44f2e7f30d, this.refreshInfiniteCurrentViewData, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.selectNewRow, this);
        this.parent.on($17b89d3b1fc93cdb$export$f4e4d2b069f96288, this.captionActionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$d51281e311b00699, this.setGroupCollapsePageQuery, this);
        this.parent.on($17b89d3b1fc93cdb$export$a257d8735e2aaa37, this.onActionComplete, this);
        this.actionBeginFunction = this.actionBegin.bind(this);
        this.actionCompleteFunction = this.actionComplete.bind(this);
        this.dataBoundFunction = this.dataBound.bind(this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunction);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.dataBoundFunction);
    };
    /**
     * @returns {void}
     * @hidden
     */ InfiniteScroll.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$32ed53e78850bc76, this.onDataReady);
        this.parent.off($17b89d3b1fc93cdb$export$a8ad22510e401e59, this.dataSourceModified);
        this.parent.off($17b89d3b1fc93cdb$export$e8809d2928c13994, this.infinitePageQuery);
        this.parent.off($17b89d3b1fc93cdb$export$d2df54dc266fa920, this.infiniteScrollHandler);
        this.parent.off($17b89d3b1fc93cdb$export$3a2b9dbbfa0f5b0, this.infiniteCellFocus);
        this.parent.off($17b89d3b1fc93cdb$export$d1d974c345b7e95, this.appendInfiniteRows);
        this.parent.off($17b89d3b1fc93cdb$export$d74111ea55be118d, this.removeInfiniteCacheRows);
        this.parent.off($17b89d3b1fc93cdb$export$795a13a52b6b60d3, this.resetInfiniteBlocks);
        this.parent.off($17b89d3b1fc93cdb$export$54948f7b626812fe, this.setCache);
        this.parent.off($17b89d3b1fc93cdb$export$21f05f465c475796, this.ensureIntialCollapse);
        this.parent.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.infiniteCellFocus);
        this.parent.off($17b89d3b1fc93cdb$export$acf275d6bf7c2a3, this.setDisplayNone);
        this.parent.off($17b89d3b1fc93cdb$export$6d303e5560d57498, this.editActionBegin);
        this.parent.off($17b89d3b1fc93cdb$export$a1aad2683385fb49, this.getVirtualInfiniteData);
        this.parent.off($17b89d3b1fc93cdb$export$82a793dcb3807178, this.resetInfiniteEdit);
        this.parent.off($17b89d3b1fc93cdb$export$d2863c79b905c4cd, this.infiniteEditSuccess);
        this.parent.off($17b89d3b1fc93cdb$export$a715e34adf8189a2, this.refreshInfiniteCache);
        this.parent.on($17b89d3b1fc93cdb$export$97df389aeb32c2d5, this.refreshInfiniteEditrowindex);
        this.parent.off($17b89d3b1fc93cdb$export$b3a2f7adafd2c20, this.infiniteEditHandler);
        this.parent.off($17b89d3b1fc93cdb$export$25a0d5e14cd34614, this.infiniteAddActionBegin);
        this.parent.off($17b89d3b1fc93cdb$export$80cded91831c5507, this.modelChanged);
        this.parent.off($17b89d3b1fc93cdb$export$26c30b44f2e7f30d, this.refreshInfiniteCurrentViewData);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.selectNewRow);
        this.parent.off($17b89d3b1fc93cdb$export$f4e4d2b069f96288, this.captionActionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$d51281e311b00699, this.setGroupCollapsePageQuery);
        this.parent.off($17b89d3b1fc93cdb$export$a257d8735e2aaa37, this.onActionComplete);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBeginFunction);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionCompleteFunction);
        this.parent.removeEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.dataBoundFunction);
    };
    InfiniteScroll.prototype.dataBound = function() {
        if (this.groupCaptionAction === "collapse") {
            this.groupCaptionAction = "refresh";
            this.makeGroupCollapseRequest();
        } else if (this.groupCaptionAction === "refresh") {
            this.parent.hideSpinner();
            this.groupCaptionAction = this.empty;
        }
    };
    InfiniteScroll.prototype.setGroupCollapsePageQuery = function(args) {
        var gObj = this.parent;
        if (!gObj.infiniteScrollSettings.enableCache && this.isGroupCollapse) {
            args.skipPage = true;
            this.isGroupCollapse = false;
            if (this.groupCaptionAction === "collapse") {
                var captionRow = gObj.getRowObjectFromUID(this.parentCapUid);
                var rowObjs = gObj.getRowsObject();
                var childCount = 0;
                for(var i = rowObjs.length - 1; i >= 0; i--){
                    if (rowObjs[parseInt(i.toString(), 10)].indent === captionRow.indent) break;
                    if (rowObjs[parseInt(i.toString(), 10)].isDataRow) childCount++;
                }
                var key = (0, $748c2240e597a9b7$export$bc3365938ce5a51a)(rowObjs.indexOf(captionRow), rowObjs);
                var pred = (0, $748c2240e597a9b7$export$78fdc30439dd7cde)(key.fields, key.keys, this);
                var predicateList = (0, $748c2240e597a9b7$export$365f0bc04eed0222)(pred);
                pred = predicateList[predicateList.length - 1];
                for(var i = predicateList.length - 2; i >= 0; i--)pred = pred.and(predicateList[parseInt(i.toString(), 10)]);
                args.query.where(pred);
                args.query.skip(childCount);
                this.parentCapUid = this.empty;
            } else {
                var rows = gObj.getRows();
                var size = gObj.pageSettings.pageSize;
                var skip = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[rows.length - 1]) + 1;
                var additionalCnt = skip - skip % size + size - skip;
                if (skip % size === 0) additionalCnt = 0;
                args.query.skip(skip);
                args.query.take(gObj.infiniteScrollSettings.initialBlocks * gObj.pageSettings.pageSize + additionalCnt);
            }
        }
    };
    InfiniteScroll.prototype.captionActionComplete = function(args) {
        var gObj = this.parent;
        if (!gObj.infiniteScrollSettings.enableCache && args.isCollapse) {
            var contetRect = gObj.getContent().firstElementChild.getBoundingClientRect();
            var tableReact = gObj.contentModule.getTable().getBoundingClientRect();
            if (Math.round(tableReact.bottom - gObj.getRowHeight()) <= Math.round(contetRect.bottom)) {
                this.parentCapUid = args.parentUid;
                this.groupCaptionAction = "collapse";
                gObj.showSpinner();
                var caption = gObj.getRowObjectFromUID(args.parentUid);
                var childCount = this.getCaptionChildCount(caption);
                if (!childCount) {
                    this.groupCaptionAction = "refresh";
                    this.makeGroupCollapseRequest();
                } else this.makeGroupCollapseRequest(args.parentUid);
            }
        }
    };
    InfiniteScroll.prototype.makeGroupCollapseRequest = function(parentUid) {
        var gObj = this.parent;
        var captionRows = [].slice.call(gObj.getContentTable().querySelectorAll("tr"));
        var rows = gObj.groupSettings.enableLazyLoading ? captionRows : gObj.getRows();
        var index = !gObj.groupSettings.enableLazyLoading ? (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[rows.length - 1]) : gObj.contentModule["visibleRows"].length - 1;
        var prevPage = this.parent.pageSettings.currentPage;
        var nextPage = Math.ceil(index / this.parent.pageSettings.pageSize) + 1;
        if (prevPage >= this.maxPage || nextPage > this.maxPage) {
            gObj.hideSpinner();
            return;
        }
        this.parent.pageSettings.currentPage = nextPage;
        var scrollArg = {
            requestType: "infiniteScroll",
            currentPage: this.parent.pageSettings.currentPage,
            prevPage: prevPage,
            startIndex: index + 1,
            direction: "down",
            isCaptionCollapse: true,
            parentUid: parentUid
        };
        this.isGroupCollapse = true;
        this.parent.notify("model-changed", scrollArg);
    };
    InfiniteScroll.prototype.getCaptionChildCount = function(caption) {
        var rowObj = this.parent.getRowsObject();
        var index = rowObj.indexOf(caption);
        var make = false;
        for(var i = index; i < rowObj.length; i++){
            if ((rowObj[parseInt(i.toString(), 10)].indent === caption.indent || rowObj[parseInt(i.toString(), 10)].indent < caption.indent) && rowObj[parseInt(i.toString(), 10)].data.key !== caption.data.key) break;
            if (rowObj[parseInt(i.toString(), 10)].isCaptionRow && !this.childCheck(rowObj, rowObj[parseInt(i.toString(), 10)], i)) {
                make = true;
                break;
            }
        }
        return make;
    };
    InfiniteScroll.prototype.childCheck = function(rowObj, row, index) {
        var childCount = 0;
        for(var i = index + 1; i < rowObj.length; i++){
            if (rowObj[parseInt(i.toString(), 10)].indent === row.indent) break;
            if (rowObj[parseInt(i.toString(), 10)].indent === row.indent + 1 && rowObj[parseInt(i.toString(), 10)].parentUid === row.uid) childCount++;
        }
        return row.data.count === childCount;
    };
    InfiniteScroll.prototype.updateCurrentViewData = function() {
        var gObj = this.parent;
        if (gObj.groupSettings.columns.length) return;
        var keys = Object.keys(this.infiniteCurrentViewData);
        gObj.currentViewData = [];
        var page = gObj.pageSettings.currentPage;
        var isCache = gObj.infiniteScrollSettings.enableCache;
        var blocks = gObj.infiniteScrollSettings.maxBlocks;
        var isMiddlePage = isCache && (page > blocks || this.isUpScroll && page > 1);
        var start = isMiddlePage ? this.isUpScroll ? page : page - blocks + 1 : 1;
        var end = isMiddlePage ? start + blocks - 1 : isCache ? blocks : keys.length;
        for(var i = start; i <= end; i++)if (this.infiniteCurrentViewData[parseInt(i.toString(), 10)]) gObj.currentViewData = gObj.currentViewData.concat(this.infiniteCurrentViewData[parseInt(i.toString(), 10)]);
    };
    InfiniteScroll.prototype.refreshInfiniteCurrentViewData = function(e) {
        if (e.args.action === "add" && e.args.requestType === "save") this.parent.pageSettings.currentPage = Math.ceil(e.args["index"] / this.parent.pageSettings.pageSize) ? Math.ceil(e.args["index"] / this.parent.pageSettings.pageSize) : 1;
        var page = this.parent.pageSettings.currentPage;
        var size = this.parent.pageSettings.pageSize;
        var blocks = this.parent.infiniteScrollSettings.initialBlocks;
        var keys = Object.keys(this.infiniteCurrentViewData);
        var cache = this.parent.infiniteScrollSettings.enableCache;
        if (!this.parent.groupSettings.columns.length) {
            var isAdd = e.args.requestType === "save" && !(this.parent.sortSettings.columns.length || this.parent.filterSettings.columns.length || this.parent.groupSettings.columns.length || this.parent.searchSettings.key);
            var isDelete = e.args.requestType === "delete";
            if (!cache && (isAdd || isDelete)) {
                if (isAdd) {
                    var indexCount = 0;
                    for(var i = 1; i <= keys.length; i++){
                        indexCount += this.infiniteCurrentViewData[parseInt(i.toString(), 10)].length - 1;
                        if (e.args.index <= indexCount) {
                            this.resetCurrentViewData(i);
                            this.infiniteCurrentViewData[parseInt(i.toString(), 10)].splice(e.args.index, 0, e.args.data);
                            break;
                        }
                    }
                } else this.infiniteCurrentViewData[keys[keys.length - 1]].push(e.data[0]);
            } else if (blocks > 1 && e.data.length === blocks * size) this.setInitialCache(e.data.slice(), {}, cache && e.args.requestType === "delete", true);
            else this.infiniteCurrentViewData[parseInt(page.toString(), 10)] = e.data.slice();
        }
    };
    InfiniteScroll.prototype.resetCurrentViewData = function(startIndex) {
        var keys = Object.keys(this.infiniteCurrentViewData);
        for(var i = startIndex; i <= keys.length; i++){
            var lastViewData = this.infiniteCurrentViewData[parseInt(i.toString(), 10)][this.infiniteCurrentViewData[parseInt(i.toString(), 10)].length - 1];
            if (this.infiniteCurrentViewData[i + 1]) this.infiniteCurrentViewData[i + 1].splice(0, 0, lastViewData);
            this.infiniteCurrentViewData[parseInt(i.toString(), 10)].pop();
        }
    };
    InfiniteScroll.prototype.modelChanged = function(args) {
        var rows = this.parent.getRows();
        if (args.requestType === "save" && args.index && args.data) this.addRowIndex = args.index;
        if (rows && rows.length && args.requestType !== "infiniteScroll" && (args.requestType === "delete" || this.requestType === "add")) {
            this.firstIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[0]);
            this.firstBlock = Math.ceil((this.firstIndex + 1) / this.parent.pageSettings.pageSize);
            this.lastIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[rows.length - 1]);
            if (args.requestType === "delete") {
                var rowObj = this.parent.getRowsObject();
                args.startIndex = this.parent.infiniteScrollSettings.enableCache ? (this.firstBlock - 1) * this.parent.pageSettings.pageSize : rowObj[rowObj.length - 1].index;
            } else args.startIndex = this.firstIndex;
            if (!this.parent.infiniteScrollSettings.enableCache && this.parent.pageSettings.currentPage === this.maxPage && args.requestType === "delete") {
                this.isLastPage = true;
                this.lastIndex = this.lastIndex - 1;
            }
        }
    };
    InfiniteScroll.prototype.infiniteAddActionBegin = function(args) {
        if (this.isNormaledit) {
            this.isAdd = true;
            if (this.parent.infiniteScrollSettings.enableCache) {
                if (!Object.keys(this.emptyRowData).length) this.createEmptyRowdata();
                if (this.parent.pageSettings.currentPage > 1) {
                    args.startEdit = false;
                    this.resetInfiniteBlocks({}, true);
                    this.makeRequest({
                        currentPage: 1
                    });
                }
            }
        }
    };
    InfiniteScroll.prototype.infiniteEditHandler = function(args) {
        if (!this.parent.infiniteScrollSettings.enableCache && (args.e.requestType === "delete" || args.e.requestType === "save" && this.requestType === "add")) {
            var rowElms = this.parent.getRows();
            var rows = this.parent.getRowsObject();
            if (this.ensureRowAvailability(rows, args.result[0])) {
                if (rowElms.length && !(this.addRowIndex && this.addRowIndex >= rowElms.length)) this.resetRowIndex(rows, args.e, rowElms, this.requestType === "add", true);
                if (!this.isLastPage) this.createRow(rows, args);
                else {
                    this.isLastPage = false;
                    this.parent.pageSettings.currentPage = this.maxPage;
                    if (this.parent.selectionModule.index < this.parent.frozenRows) {
                        (0, $4ZDHT.remove)(rowElms[this.parent.frozenRows - 1]);
                        this.createRow([
                            rows[this.parent.frozenRows - 1]
                        ], args, false, true);
                        (0, $748c2240e597a9b7$export$ef806be2fa1b9130)(this.parent);
                    }
                }
            }
            this.parent.hideSpinner();
            this.parent.notify($17b89d3b1fc93cdb$export$50807bf602c28512, {});
            if (this.requestType === "delete") this.parent.notify($17b89d3b1fc93cdb$export$a7f69ca3248694c5, args.e);
            else this.parent.notify($17b89d3b1fc93cdb$export$628350d303d1eea6, args.e);
        }
        this.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
            case: "refreshHeight"
        });
    };
    InfiniteScroll.prototype.createRow = function(rows, args, isMovable, isFrozenRows, isFrozenRight) {
        var row = !isFrozenRows ? this.generateRows(args.result, args.e) : rows;
        var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, this.parent);
        this.parent.removeMaskRow();
        if (args.e.requestType === "save" && args.e.index && args.e.data) {
            row[0].index = this.addRowIndex;
            this.addRowIndex = null;
            if (row[0].index >= rows.length) return;
        }
        var tbody;
        tbody = this.parent.getContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        if (this.parent.frozenRows) tbody = isFrozenRows && this.requestType !== "add" || !isFrozenRows && this.requestType === "add" ? this.parent.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c) : tbody;
        var notifyArgs = {
            rows: rows,
            cancel: false,
            args: args,
            isMovable: isMovable,
            isFrozenRows: isFrozenRows,
            isFrozenRight: isFrozenRows,
            row: row
        };
        this.parent.notify($17b89d3b1fc93cdb$export$b38d92d450e1c729, notifyArgs);
        if (!notifyArgs.cancel) {
            for(var i = row.length - 1; i >= 0; i--)if (this.requestType === "delete") tbody.appendChild(rowRenderer.render(row[parseInt(i.toString(), 10)], this.parent.getColumns()));
            else tbody.insertBefore(rowRenderer.render(row[parseInt(i.toString(), 10)], this.parent.getColumns()), tbody.rows[args.e.index]);
        }
        if (!isFrozenRows && this.parent.frozenRows && (this.parent.selectionModule.index < this.parent.frozenRows || this.requestType === "add")) {
            var rowElems = this.parent.getRows();
            var index = (isMovable || isFrozenRight) && this.requestType === "add" ? this.parent.frozenRows : this.parent.frozenRows - 1;
            (0, $4ZDHT.remove)(rowElems[parseInt(index.toString(), 10)]);
            this.createRow([
                rows[this.parent.frozenRows - 1]
            ], args, false, true, false);
        }
        if (!this.parent.infiniteScrollSettings.enableCache && !isFrozenRows) {
            (0, $748c2240e597a9b7$export$ef806be2fa1b9130)(this.parent);
            this.parent.contentModule.visibleRows = this.requestType === "add" ? row.concat(rows) : rows.concat(row);
        }
    };
    InfiniteScroll.prototype.ensureRowAvailability = function(rows, data) {
        var resume = true;
        if (this.parent.frozenRows && !this.parent.infiniteScrollSettings.enableCache && this.parent.sortSettings.columns && this.requestType === "add") {
            var key = this.parent.getPrimaryKeyFieldNames()[0];
            for(var i = 0; i < rows.length; i++)if (rows[parseInt(i.toString(), 10)].data["" + key] === data["" + key]) {
                resume = false;
                break;
            }
        }
        return resume;
    };
    InfiniteScroll.prototype.generateRows = function(data, args) {
        return this.rowModelGenerator.generateRows(data, args);
    };
    InfiniteScroll.prototype.resetRowIndex = function(rows, args, rowElms, isAdd, isFrozen) {
        var _this = this;
        var keyField = this.parent.getPrimaryKeyFieldNames()[0];
        var isRemove = !(rowElms.length % this.parent.pageSettings.pageSize);
        if (isAdd) {
            if (isRemove) {
                if (isFrozen && !this.parent.groupSettings.columns.length) this.swapCurrentViewData(1, true);
                (0, $4ZDHT.remove)(rowElms[rows.length - 1]);
                rowElms.splice(rows.length - 1, 1);
                rows.splice(rows.length - 1, 1);
            }
        } else rows.filter(function(e, index) {
            if (e.data["" + keyField] === args.data[0]["" + keyField]) {
                if (isFrozen && !_this.parent.groupSettings.columns.length) {
                    var page = Math.ceil((index + 1) / _this.parent.pageSettings.pageSize);
                    _this.resetInfiniteCurrentViewData(page, index);
                }
                rows.splice(index, 1);
                var rowElement = _this.parent.getRowElementByUID(e.uid);
                if (rowElement) {
                    var rowElementIndex = rowElms.indexOf(rowElement);
                    (0, $4ZDHT.remove)(rowElement);
                    rowElms.splice(rowElementIndex, 1);
                }
            }
        });
        var startIndex = isAdd ? this.addRowIndex ? this.addRowIndex + 1 : 1 : 0;
        (0, $748c2240e597a9b7$export$ba639a32ffcf7814)(this.parent, rows, rowElms, startIndex, this.addRowIndex ? this.addRowIndex : 0);
    };
    InfiniteScroll.prototype.resetInfiniteCurrentViewData = function(page, index) {
        index = index - (page - 1) * this.parent.pageSettings.pageSize;
        this.infiniteCurrentViewData[parseInt(page.toString(), 10)].splice(index, 1);
        this.swapCurrentViewData(page, false);
    };
    InfiniteScroll.prototype.swapCurrentViewData = function(page, isAdd) {
        var keys = Object.keys(this.infiniteCurrentViewData);
        var end = isAdd ? keys.length + 1 : keys.length;
        for(var i = page; i < end; i++)if (this.infiniteCurrentViewData[i + 1]) {
            var pageIndex = isAdd ? i : i + 1;
            var index = isAdd ? this.infiniteCurrentViewData[parseInt(i.toString(), 10)].length - 1 : 0;
            var data = this.infiniteCurrentViewData[parseInt(pageIndex.toString(), 10)].splice(index, 1);
            if (isAdd) {
                this.infiniteCurrentViewData[i + 1] = data.concat(this.infiniteCurrentViewData[i + 1]);
                if (i + 1 === end - 1) this.infiniteCurrentViewData[i + 1].splice(this.infiniteCurrentViewData[i + 1].length - 1, 1);
            } else this.infiniteCurrentViewData[parseInt(i.toString(), 10)].push(data[0]);
        }
        this.updateCurrentViewData();
    };
    InfiniteScroll.prototype.setDisplayNone = function(args) {
        if (this.parent.infiniteScrollSettings.enableCache) {
            var keys = Object.keys(this.infiniteCache);
            for(var i = 1; i <= keys.length; i++){
                var cache = this.infiniteCache[parseInt(i.toString(), 10)];
                cache.filter(function(e) {
                    e.cells[args.index].visible = args.visible === "";
                });
            }
            this.resetContentModuleCache(this.infiniteCache);
        }
    };
    InfiniteScroll.prototype.refreshInfiniteCache = function(args) {
        this.getEditedRowObject().data = args.data;
    };
    InfiniteScroll.prototype.refreshInfiniteCacheRowVisibleLength = function(args, currentPage) {
        var cPageRowArray = args[parseInt(currentPage.toString(), 10)];
        if (this.parent.enableInfiniteScrolling && this.parent.infiniteScrollSettings.enableCache) {
            var length_1 = 0;
            var vRowLen = 0;
            var hRowLen = 0;
            for(var i = 0; i < cPageRowArray.length; i++)if (cPageRowArray[parseInt(i.toString(), 10)].visible || (0, $3EnZW.isNullOrUndefined)(cPageRowArray[parseInt(i.toString(), 10)].visible)) vRowLen++;
            else hRowLen++;
            if (hRowLen > vRowLen) {
                length_1 = hRowLen - vRowLen;
                if (length_1 > vRowLen) length_1 = vRowLen;
            } else {
                length_1 = vRowLen - hRowLen;
                if (length_1 > hRowLen) length_1 = hRowLen;
            }
            if (length_1 === 0) length_1 = 1;
            return length_1;
        } else return cPageRowArray.length;
    };
    InfiniteScroll.prototype.refreshInfiniteEditrowindex = function(args) {
        this.editRowIndex = args.index;
    };
    InfiniteScroll.prototype.getEditedRowObject = function() {
        var rowObjects = this.parent.getRowsObject();
        var editedrow;
        for(var i = 0; i < rowObjects.length; i++)if (rowObjects[parseInt(i.toString(), 10)].index === this.editRowIndex) editedrow = rowObjects[parseInt(i.toString(), 10)];
        return editedrow;
    };
    InfiniteScroll.prototype.infiniteEditSuccess = function(args) {
        if (this.isNormaledit) {
            if (!this.isAdd && args.data) this.updateCurrentViewRecords(args.data);
            this.isAdd = (0, this.parent.editSettings.showAddNewRow);
        }
    };
    InfiniteScroll.prototype.updateCurrentViewRecords = function(data) {
        var index = (0, $748c2240e597a9b7$export$b52dd6069dba6e03)(this.parent, data);
        if (!(0, $3EnZW.isNullOrUndefined)(index)) this.parent.getCurrentViewRecords()[parseInt(index.toString(), 10)] = data;
    };
    InfiniteScroll.prototype.actionBegin = function(args) {
        if (args.requestType === "add" || args.requestType === "delete") this.requestType = args.requestType;
        else if (args.action === "add" && args.requestType === "save") this.requestType = args.action;
        if (this.parent.isFrozenGrid() && !args.cancel && args.requestType === "searching" || args.requestType === "sorting" || args.requestType === "filtering") this.isInitialRender = true;
    };
    InfiniteScroll.prototype.actionComplete = function(args) {
        if (args.requestType === "delete" || args.requestType === "save" || args.requestType === "cancel") {
            this.requestType = this.empty;
            this.isCancel = args.requestType === "cancel" || args.requestType === "save";
            this.isAdd = this.isEdit = (0, this.parent.editSettings.showAddNewRow);
            if (this.isNormaledit) {
                this.editRowIndex = this.empty;
                this.virtualInfiniteData = {};
                this.parent.editModule.previousVirtualData = {};
            }
        }
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ InfiniteScroll.prototype.onActionComplete = function(e) {
        var args = {
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, args));
    };
    InfiniteScroll.prototype.resetInfiniteEdit = function() {
        if (this.parent.enableInfiniteScrolling && this.isNormaledit) {
            if (this.parent.editSettings.allowEditing && this.isEdit || this.parent.editSettings.allowAdding && this.isAdd) this.parent.isEdit = true;
        }
    };
    InfiniteScroll.prototype.getVirtualInfiniteData = function(data) {
        this.getVirtualInfiniteEditedData();
        data.virtualData = this.parent.enableColumnVirtualization && !this.parent.infiniteScrollSettings.enableCache ? data.virtualData : this.virtualInfiniteData;
        data.isAdd = this.isAdd;
        data.isCancel = this.isCancel;
    };
    InfiniteScroll.prototype.editActionBegin = function(e) {
        this.isEdit = true;
        this.editRowIndex = e.index;
        var rowObject = (0, $3EnZW.extend)({}, this.getEditedRowObject().data);
        e.data = Object.keys(this.virtualInfiniteData).length ? this.virtualInfiniteData : rowObject;
    };
    InfiniteScroll.prototype.dataSourceModified = function() {
        this.resetInfiniteBlocks({
            requestType: this.empty
        }, true);
    };
    InfiniteScroll.prototype.onDataReady = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.count) && e.requestType !== "infiniteScroll") this.maxPage = Math.ceil(e.count / this.parent.pageSettings.pageSize);
    };
    InfiniteScroll.prototype.ensureIntialCollapse = function(isExpand) {
        this.isInitialCollapse = !isExpand;
    };
    InfiniteScroll.prototype.infiniteScrollHandler = function(e) {
        this.restoreInfiniteEdit();
        this.restoreInfiniteAdd();
        var targetEle = e.target;
        var isInfinite = targetEle.classList.contains($1b5568e76cdae6d4$export$a7db06668cad9adb);
        if (isInfinite && this.parent.enableInfiniteScrolling && !e.isLeft) {
            var scrollEle = this.parent.getContent().firstElementChild;
            var captionRows = [].slice.call(this.parent.getContentTable().querySelectorAll("tr"));
            this.prevScrollTop = scrollEle.scrollTop;
            var rows = this.parent.groupSettings.enableLazyLoading ? captionRows : this.parent.getRows();
            if (!rows.length) return;
            var index = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[rows.length - 1]) + 1;
            var prevPage = this.parent.pageSettings.currentPage;
            var args = void 0;
            var offset = targetEle.scrollHeight - targetEle.scrollTop;
            var round = Math.round(targetEle.scrollHeight - targetEle.scrollTop);
            var floor = offset < targetEle.clientHeight ? Math.ceil(offset) : Math.floor(offset);
            if (floor > targetEle.clientHeight) floor = floor - 1;
            var isBottom = floor === targetEle.clientHeight || round === targetEle.clientHeight;
            if (!(0, $3EnZW.isNullOrUndefined)(this.groupCaptionAction)) return;
            if (this.isScroll && isBottom && (this.parent.pageSettings.currentPage <= this.maxPage - 1 || this.enableContinuousScroll)) {
                if (this.parent.infiniteScrollSettings.enableCache) {
                    this.isUpScroll = false;
                    this.isDownScroll = true;
                }
                var rows_1 = [].slice.call(scrollEle.querySelectorAll(".e-row:not(.e-addedrow)"));
                var row = rows_1[rows_1.length - 1];
                var rowIndex = !(this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length) ? (0, $748c2240e597a9b7$export$cc75f426469dab70)(row) : this.parent.contentModule["visibleRows"].length - 1;
                this.parent.pageSettings.currentPage = Math.ceil(rowIndex / this.parent.pageSettings.pageSize) + 1;
                args = {
                    requestType: "infiniteScroll",
                    currentPage: this.parent.pageSettings.currentPage,
                    prevPage: prevPage,
                    startIndex: index,
                    direction: "down"
                };
                this.makeRequest(args);
            }
            if (this.isScroll && this.parent.infiniteScrollSettings.enableCache && targetEle.scrollTop === 0 && this.parent.pageSettings.currentPage !== 1) {
                if (this.parent.infiniteScrollSettings.enableCache) {
                    this.isDownScroll = false;
                    this.isUpScroll = true;
                }
                var row = [].slice.call(scrollEle.getElementsByClassName($1b5568e76cdae6d4$export$120ff0929b202a6d));
                var rowIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(row[this.parent.pageSettings.pageSize - 1]);
                var startIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(row[0]) - this.parent.pageSettings.pageSize;
                this.parent.pageSettings.currentPage = Math.ceil(rowIndex / this.parent.pageSettings.pageSize) - 1;
                if (this.parent.pageSettings.currentPage) {
                    args = {
                        requestType: "infiniteScroll",
                        currentPage: this.parent.pageSettings.currentPage,
                        prevPage: prevPage,
                        startIndex: startIndex,
                        direction: "up"
                    };
                    this.makeRequest(args);
                }
            }
            if (this.parent.infiniteScrollSettings.enableCache && !this.isScroll && (0, $3EnZW.isNullOrUndefined)(args)) {
                if (this.isDownScroll || this.isUpScroll) scrollEle.scrollTop = this.top;
            }
        }
    };
    InfiniteScroll.prototype.makeRequest = function(args) {
        var _this = this;
        if (this.parent.pageSettings.currentPage !== args.prevPage) {
            var initBlocks = this.parent.infiniteScrollSettings.initialBlocks;
            if (initBlocks < this.maxPage && this.parent.pageSettings.currentPage <= this.maxPage) {
                this.isInfiniteScroll = true;
                if ((0, $3EnZW.isNullOrUndefined)(this.infiniteCache[args.currentPage])) setTimeout(function() {
                    _this.getVirtualInfiniteEditedData();
                    _this.parent.notify("model-changed", args);
                }, 100);
                else setTimeout(function() {
                    _this.getVirtualInfiniteEditedData();
                    _this.parent.notify($17b89d3b1fc93cdb$export$c2efdb1b36d9fb1f, args);
                }, 100);
            } else this.parent.pageSettings.currentPage = this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && initBlocks >= this.maxPage ? 1 : this.maxPage;
        }
    };
    InfiniteScroll.prototype.infinitePageQuery = function(query) {
        if (this.initialRender) {
            this.initialRender = false;
            this.intialPageQuery(query);
        } else if (this.requestType === "delete" || this.requestType === "add") {
            if (!this.isInfiniteScroll && !this.parent.groupSettings.enableLazyLoading) this.editPageQuery(query);
            else if (this.parent.groupSettings.enableLazyLoading && !this.parent.infiniteScrollSettings.enableCache) {
                if (this.parent.infiniteScrollSettings.initialBlocks < this.parent.pageSettings.currentPage) query.page(1, this.parent.pageSettings.pageSize * this.parent.pageSettings.currentPage);
                else query.page(1, this.parent.pageSettings.pageSize * this.parent.infiniteScrollSettings.initialBlocks);
            } else query.page(this.parent.pageSettings.currentPage, this.parent.pageSettings.pageSize);
        } else query.page(this.parent.pageSettings.currentPage, this.parent.pageSettings.pageSize);
    };
    InfiniteScroll.prototype.editPageQuery = function(query) {
        var initialBlocks = this.parent.infiniteScrollSettings.initialBlocks;
        var isCache = this.parent.infiniteScrollSettings.enableCache;
        if (isCache) {
            this.infiniteCache = {};
            this.infiniteCurrentViewData = {};
            query.skip(this.firstIndex);
            query.take(initialBlocks * this.parent.pageSettings.pageSize);
        } else {
            if (this.parent.editSettings.mode === "Dialog") this.parent.clearSelection();
            var index = this.requestType === "delete" ? this.lastIndex : this.addRowIndex ? this.addRowIndex : this.firstIndex;
            query.skip(index);
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getDataModule().dataManager.dataSource.url) && this.parent.getDataModule().dataManager.dataSource.url !== "" && (this.requestType === "delete" || this.requestType === "add")) query.take(initialBlocks * this.parent.pageSettings.pageSize);
            else query.take(1);
        }
    };
    InfiniteScroll.prototype.intialPageQuery = function(query) {
        if (this.parent.infiniteScrollSettings.enableCache && this.parent.infiniteScrollSettings.initialBlocks > this.parent.infiniteScrollSettings.maxBlocks) this.parent.infiniteScrollSettings.initialBlocks = this.parent.infiniteScrollSettings.maxBlocks;
        var pageSize = this.parent.pageSettings.pageSize * this.parent.infiniteScrollSettings.initialBlocks;
        query.page(1, pageSize);
    };
    InfiniteScroll.prototype.scrollToLastFocusedCell = function(e) {
        var gObj = this.parent;
        var rowIdx = this.lastFocusInfo.rowIdx + (e.keyArgs.action === $1b5568e76cdae6d4$export$d12bbdaa0e5320e2 ? -1 : 1);
        var cellIdx = this.lastFocusInfo.cellIdx;
        var row = gObj.getRowByIndex(rowIdx);
        if (!row) {
            var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.serviceLocator, null, this.parent);
            var page = Math.floor(rowIdx / this.parent.pageSettings.pageSize) + 1;
            gObj.pageSettings.currentPage = page;
            var cols = gObj.getColumns();
            (0, $4ZDHT.remove)(gObj.getContent().querySelector("tbody"));
            gObj.getContent().querySelector("table").appendChild(gObj.createElement("tbody", {
                attrs: {
                    "role": "rowgroup"
                }
            }));
            var focusRows = [];
            // eslint-disable-next-line @typescript-eslint/tslint/config
            for(var i = page === 1 || this.maxPage === page ? 0 : -1, k = 0; k < gObj.infiniteScrollSettings.maxBlocks; this.maxPage === page ? i-- : i++, k++){
                var rows = this.infiniteCache[page + i];
                if (rows) {
                    focusRows = focusRows.concat(rows);
                    for(var j = 0; j < rows.length; j++)gObj.getContent().querySelector("tbody").appendChild(rowRenderer.render(rows[parseInt(j.toString(), 10)], cols));
                }
            }
            gObj.notify($17b89d3b1fc93cdb$export$f44d9209b353bf3e, {
                rows: focusRows,
                args: {}
            });
            (0, $748c2240e597a9b7$export$ef806be2fa1b9130)(gObj);
        }
        row = gObj.getRowByIndex(rowIdx);
        var target = row.cells[parseInt(cellIdx.toString(), 10)];
        gObj.focusModule.isInfiniteScroll = true;
        gObj.focusModule.onClick({
            target: target
        }, true);
        gObj.selectRow(rowIdx);
        target.focus();
        this.isFocusScroll = false;
        e.cancel = true;
    };
    InfiniteScroll.prototype.setLastCellFocusInfo = function(e) {
        var cell = e.byClick && e.clickArgs.target || e.byKey && e.keyArgs.target || (!this.isFocusScroll && e).target;
        if (cell && cell.classList.contains("e-rowcell")) {
            var cellIdx = parseInt(cell.getAttribute("data-colindex"), 10);
            var rowIdx = parseInt(cell.parentElement.getAttribute("data-rowindex"), 10);
            this.lastFocusInfo = {
                rowIdx: rowIdx,
                cellIdx: cellIdx
            };
        }
    };
    InfiniteScroll.prototype.infiniteCellFocus = function(e) {
        var gObj = this.parent;
        var cache = gObj.infiniteScrollSettings.enableCache;
        if (e.byKey) {
            if (cache && this.isFocusScroll) {
                this.scrollToLastFocusedCell(e);
                return;
            }
            var cell = document.activeElement;
            var rowIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(cell.parentElement);
            this.cellIndex = parseInt(cell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
            var content = gObj.getContent().firstElementChild;
            var totalRowsCount = this.maxPage * gObj.pageSettings.pageSize - 1;
            var visibleRowCount = Math.floor(content.offsetHeight / this.parent.getRowHeight());
            var contentRect = content.getBoundingClientRect();
            if (!isNaN(rowIndex)) {
                if (e.keyArgs.action === $1b5568e76cdae6d4$export$d81610064893988e || e.keyArgs.action === $1b5568e76cdae6d4$export$e668df1bcd81e4d2) {
                    this.rowIndex = rowIndex += 1;
                    var row = gObj.getRowByIndex(rowIndex);
                    var rowRect = row && row.getBoundingClientRect();
                    if (cache) rowIndex = cell.parentElement.rowIndex + 1;
                    if (this.isFocusScroll || !row && rowIndex < totalRowsCount || rowRect && rowRect.bottom >= contentRect.bottom) {
                        if (!this.isFocusScroll) this.pressedKey = e.keyArgs.action;
                        this.isFocusScroll = false;
                        content.scrollTop = (rowIndex - visibleRowCount + 1) * this.parent.getRowHeight();
                    } else if (!cache && row) {
                        if (rowRect && (rowRect.bottom >= contentRect.bottom || rowRect.top < contentRect.top)) row.cells[this.cellIndex].scrollIntoView();
                    }
                } else if (e.keyArgs.action === $1b5568e76cdae6d4$export$d12bbdaa0e5320e2 || e.keyArgs.action === $1b5568e76cdae6d4$export$9f99fe2ed5bb7a29) {
                    this.rowIndex = rowIndex -= 1;
                    var row = gObj.getRowByIndex(rowIndex);
                    var rowRect = row && row.getBoundingClientRect();
                    if (cache) rowIndex = cell.parentElement.rowIndex - 1;
                    if (!row || rowRect.top <= contentRect.top) {
                        this.pressedKey = e.keyArgs.action;
                        content.scrollTop = rowIndex * this.parent.getRowHeight();
                    }
                }
            }
        } else if (e.key === "PageDown" || e.key === "PageUp") this.pressedKey = e.key;
        this.setLastCellFocusInfo(e);
    };
    InfiniteScroll.prototype.createEmptyRowdata = function() {
        var _this = this;
        this.parent.getColumns().filter(function(e) {
            _this.emptyRowData[e.field] = _this.empty;
        });
    };
    InfiniteScroll.prototype.getVirtualInfiniteEditedData = function() {
        var editForm = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$76a2698a7195dbfe);
        var addForm = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2);
        var gridForm = this.parent.element.querySelector(".e-gridform");
        if (this.parent.infiniteScrollSettings.enableCache && (editForm || addForm)) {
            var rowData = editForm ? (0, $3EnZW.extend)({}, this.getEditedRowObject().data) : (0, $3EnZW.extend)({}, this.emptyRowData);
            this.virtualInfiniteData = this.parent.editModule.getCurrentEditedData(gridForm, rowData);
            var hiddenColumn = this.parent.getHiddenColumns();
            for(var i = 0; i < hiddenColumn.length; i++)if (hiddenColumn[parseInt(i.toString(), 10)].defaultValue) this.virtualInfiniteData[hiddenColumn[parseInt(i.toString(), 10)].field] = hiddenColumn[parseInt(i.toString(), 10)].defaultValue;
        }
    };
    InfiniteScroll.prototype.restoreInfiniteEdit = function() {
        var content = this.parent.getContent().firstElementChild;
        var frozenEdit = this.parent.frozenRows ? this.editRowIndex >= this.parent.frozenRows : true;
        if (this.isNormaledit && this.parent.infiniteScrollSettings.enableCache && frozenEdit) {
            if (this.parent.editSettings.allowEditing && !(0, $3EnZW.isNullOrUndefined)(this.editRowIndex)) {
                var row = this.parent.getRowByIndex(this.editRowIndex);
                if (Object.keys(this.virtualInfiniteData).length && row && !this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$76a2698a7195dbfe)) {
                    var top_1 = row.getBoundingClientRect().top;
                    if (top_1 < content.offsetHeight && top_1 > this.parent.getRowHeight()) {
                        this.parent.isEdit = false;
                        this.parent.editModule.startEdit(row);
                    }
                }
            }
        }
    };
    InfiniteScroll.prototype.restoreInfiniteAdd = function() {
        var content = this.parent.getContent().firstElementChild;
        if (this.parent.getCurrentViewRecords().length && this.parent.getRowByIndex(0) && this.isNormaledit && this.parent.infiniteScrollSettings.enableCache && this.isAdd && !content.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2)) {
            var isTop = content.scrollTop < this.parent.getRowHeight();
            if (isTop) {
                this.parent.isEdit = false;
                this.parent.addRecord();
            }
        }
    };
    InfiniteScroll.prototype.appendInfiniteRows = function(e) {
        var scrollEle = this.parent.getContent().firstElementChild;
        var isInfiniteScroll = this.parent.enableInfiniteScrolling && e.args.requestType === "infiniteScroll";
        if ((this.parent.isAngular || this.parent.isReact || this.parent.isVue || this.parent.isVue3) && isInfiniteScroll && !e.args.isFrozen && this.parent.infiniteScrollSettings.enableCache) {
            var isChildGrid = this.parent.childGrid && this.parent.element.querySelectorAll(".e-childgrid").length ? true : false;
            var rows = this.parent.getDataRows();
            this.parent.refreshReactTemplateTD(rows, isChildGrid);
        }
        if (isInfiniteScroll && !e.args.isFrozen || !isInfiniteScroll) {
            if (isInfiniteScroll && e.args.direction === "up") e.tbody.insertBefore(e.frag, e.tbody.firstElementChild);
            else e.tbody.appendChild(e.frag);
        }
        this.parent.contentModule.getTable().appendChild(e.tbody);
        this.updateCurrentViewData();
        if (this.isInitialRender && !e.args.isFrozen) {
            this.isInitialRender = false;
            this.parent.scrollModule.setHeight();
        }
        if (!e.args.isFrozen) {
            this.rowTop = !this.rowTop ? this.parent.getRows()[0].getBoundingClientRect().top : this.rowTop;
            if (isInfiniteScroll) {
                if (this.parent.infiniteScrollSettings.enableCache && this.isRemove) scrollEle.scrollTop = this.top;
                (0, $748c2240e597a9b7$export$ef806be2fa1b9130)(this.parent);
            }
            this.restoreInfiniteAdd();
            this.isScroll = true;
        }
        this.isInfiniteScroll = false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    InfiniteScroll.prototype.selectNewRow = function(args) {
        var _this = this;
        var gObj = this.parent;
        var row = gObj.getRowByIndex(this.rowIndex);
        var cache = gObj.infiniteScrollSettings.enableCache;
        if (row && this.keys.some(function(value) {
            return value === _this.pressedKey;
        })) {
            var content = gObj.getContent().firstElementChild;
            var rowHeight = gObj.getRowHeight();
            var target = row.cells[this.cellIndex];
            if (this.pressedKey === $1b5568e76cdae6d4$export$d81610064893988e || this.pressedKey === $1b5568e76cdae6d4$export$e668df1bcd81e4d2 || cache && (this.pressedKey === $1b5568e76cdae6d4$export$d12bbdaa0e5320e2 || this.pressedKey === $1b5568e76cdae6d4$export$9f99fe2ed5bb7a29)) {
                if (!cache && this.pressedKey !== $1b5568e76cdae6d4$export$d12bbdaa0e5320e2 && this.pressedKey !== $1b5568e76cdae6d4$export$9f99fe2ed5bb7a29) content.scrollTop = content.scrollTop + rowHeight;
                gObj.focusModule.isInfiniteScroll = true;
                gObj.focusModule.onClick({
                    target: target
                }, true);
                gObj.selectRow(this.rowIndex);
            }
        } else if (this.lastFocusInfo && (this.pressedKey === $1b5568e76cdae6d4$export$12fe17f871ef6d2a || this.pressedKey === $1b5568e76cdae6d4$export$f5b94b14e1c1cc2a)) {
            var idx = cache ? 0 : this.lastFocusInfo.rowIdx;
            if (gObj.getRowByIndex(idx)) {
                var target = gObj.getCellFromIndex(idx, this.lastFocusInfo.cellIdx);
                if (target) {
                    this.isFocusScroll = true;
                    if (!cache) {
                        gObj.focusModule.isInfiniteScroll = true;
                        gObj.focusModule.onClick({
                            target: target
                        }, true);
                    } else target.focus({
                        preventScroll: true
                    });
                }
            }
        }
        this.pressedKey = undefined;
    };
    InfiniteScroll.prototype.removeInfiniteCacheRows = function(e) {
        var isInfiniteScroll = this.parent.enableInfiniteScrolling && e.args.requestType === "infiniteScroll";
        if (!e.args.isFrozen && isInfiniteScroll && this.parent.infiniteScrollSettings.enableCache && this.isRemove) {
            var rows = [].slice.call(this.parent.getContentTable().getElementsByClassName($1b5568e76cdae6d4$export$120ff0929b202a6d));
            if (e.args.direction === "down") {
                if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
                    var captionRows = [].slice.call(this.parent.getContentTable().querySelectorAll("tr"));
                    this.removeCaptionRows(captionRows, e.args);
                }
                var addRowCount = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2) ? 0 : 1;
                this.removeTopRows(rows, this.parent.pageSettings.pageSize - addRowCount);
            }
            if (e.args.direction === "up") {
                if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
                    var captionRows = [].slice.call(this.parent.getContentTable().querySelectorAll("tr"));
                    this.removeCaptionRows(captionRows, e.args);
                } else this.removeBottomRows(rows, rows.length - 1, e.args);
            }
            this.isScroll = false;
            this.top = this.calculateScrollTop(e.args);
        }
    };
    InfiniteScroll.prototype.calculateScrollTop = function(args) {
        var top = 0;
        var scrollCnt = this.parent.getContent().firstElementChild;
        if (args.direction === "down") {
            if (this.parent.allowGrouping && this.parent.groupSettings.columns.length && !this.isInitialCollapse) top = this.captionRowHeight();
            var captionRows = [].slice.call(this.parent.getContent().firstElementChild.querySelectorAll("tr:not(.e-row)"));
            var captionCount = 0;
            if (this.isInitialCollapse && !(0, $3EnZW.isNullOrUndefined)(captionRows)) captionCount = Math.round((captionRows.length - 1) / this.parent.groupSettings.columns.length);
            var value = captionCount ? captionCount : this.parent.pageSettings.pageSize * (this.parent.infiniteScrollSettings.maxBlocks - 1);
            var currentViewRowCount = 0;
            var i = 0;
            while(currentViewRowCount < scrollCnt.clientHeight){
                i++;
                currentViewRowCount = i * this.parent.getRowHeight();
            }
            i = i - 1;
            top += (value - i) * this.parent.getRowHeight();
        }
        if (args.direction === "up") {
            if (this.parent.allowGrouping && this.parent.groupSettings.columns.length && !this.isInitialCollapse) {
                var len = this.refreshInfiniteCacheRowVisibleLength(this.infiniteCache, this.parent.pageSettings.currentPage);
                top = len * this.parent.getRowHeight();
            } else if (this.isInitialCollapse) {
                var groupedData = this.infiniteCache[this.parent.pageSettings.currentPage];
                var count = 0;
                for(var i = 0; i < groupedData.length; i++)if (groupedData[parseInt(i.toString(), 10)].isCaptionRow) count++;
                top += Math.round(count / this.parent.groupSettings.columns.length) * this.parent.getRowHeight();
            } else top += this.parent.pageSettings.pageSize * this.parent.getRowHeight() + (0, $748c2240e597a9b7$export$1df2a1438d36fb55)();
        }
        return top;
    };
    InfiniteScroll.prototype.captionRowHeight = function() {
        var rows = [].slice.call(this.parent.getContent().querySelectorAll("tr:not(.e-row)"));
        return rows.length * this.parent.getRowHeight();
    };
    InfiniteScroll.prototype.removeTopRows = function(rows, maxIndx) {
        for(var i = 0; i <= maxIndx; i++){
            if (this.parent.frozenRows && this.parent.pageSettings.currentPage === this.parent.infiniteScrollSettings.maxBlocks + 1 && i > maxIndx - this.parent.frozenRows) continue;
            (0, $4ZDHT.remove)(rows[parseInt(i.toString(), 10)]);
        }
    };
    InfiniteScroll.prototype.removeBottomRows = function(rows, maxIndx, args) {
        var cnt = 0;
        var pageSize = this.parent.pageSettings.pageSize;
        if (this.infiniteCache[args.prevPage].length < pageSize) cnt = this.parent.pageSettings.pageSize - this.infiniteCache[args.prevPage].length;
        for(var i = maxIndx; cnt < pageSize; i--){
            cnt++;
            (0, $4ZDHT.remove)(rows[parseInt(i.toString(), 10)]);
        }
    };
    InfiniteScroll.prototype.removeCaptionRows = function(rows, args) {
        var rowElements = [].slice.call(this.parent.getContent().getElementsByClassName($1b5568e76cdae6d4$export$120ff0929b202a6d));
        if (args.direction === "down") {
            var lastRow = rowElements[this.parent.pageSettings.pageSize - 1];
            var lastRowIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(lastRow) - 1;
            var k = 0;
            for(var i = 0; k < lastRowIndex; i++)if (!rows[parseInt(i.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d)) (0, $4ZDHT.remove)(rows[parseInt(i.toString(), 10)]);
            else k = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rows[parseInt(i.toString(), 10)]);
        }
        if (args.direction === "up") {
            var lastIndex = (0, $748c2240e597a9b7$export$cc75f426469dab70)(rowElements[rowElements.length - 1]);
            var page = Math.ceil(lastIndex / this.parent.pageSettings.pageSize);
            var startIndex = 0;
            for(var i = this.parent.pageSettings.currentPage + 1; i < page; i++)startIndex += this.infiniteCache[parseInt(i.toString(), 10)].length;
            for(var i = startIndex; i < rows.length; i++)(0, $4ZDHT.remove)(rows[parseInt(i.toString(), 10)]);
        }
    };
    InfiniteScroll.prototype.resetInfiniteBlocks = function(args, isDataModified) {
        var isInfiniteScroll = this.parent.enableInfiniteScrolling && args.requestType !== "infiniteScroll";
        if (!this.initialRender && !(0, $3EnZW.isNullOrUndefined)(this.parent.infiniteScrollModule) && isInfiniteScroll) {
            if (this.actions.some(function(value) {
                return value === args.requestType;
            }) || isDataModified || args.requestType === "save" && (this.parent.sortSettings.columns.length || this.parent.filterSettings.columns.length || this.parent.groupSettings.columns.length || this.parent.searchSettings.key)) {
                var scrollEle = this.parent.getContent().firstElementChild;
                this.initialRender = true;
                scrollEle.scrollTop = 0;
                this.parent.pageSettings.currentPage = 1;
                this.infiniteCache = {};
                this.infiniteCurrentViewData = {};
                this.resetContentModuleCache({});
                this.isRemove = false;
                this.top = 0;
                this.isInitialCollapse = false;
                this.parent.contentModule.isRemove = this.isRemove;
                this.parent.contentModule.isAddRows = this.isRemove;
                this.parent.contentModule.visibleRows = [];
                this.parent.contentModule.visibleFrozenRows = [];
            }
        }
    };
    InfiniteScroll.prototype.setCache = function(e) {
        if (this.parent.enableInfiniteScrolling && this.parent.infiniteScrollSettings.enableCache) {
            var isEdit = e.args.requestType !== "infiniteScroll" && (this.requestType === "delete" || this.requestType === "add");
            var currentPage = this.parent.pageSettings.currentPage;
            if (!Object.keys(this.infiniteCache).length || isEdit) this.setInitialCache(e.modelData, e.args, isEdit);
            if ((0, $3EnZW.isNullOrUndefined)(this.infiniteCache[this.parent.pageSettings.currentPage])) {
                this.infiniteCache[this.parent.pageSettings.currentPage] = e.modelData;
                this.resetContentModuleCache(this.infiniteCache);
            }
            if (e.isInfiniteScroll && !this.isRemove) {
                this.isRemove = (currentPage - 1) % this.parent.infiniteScrollSettings.maxBlocks === 0;
                this.parent.contentModule.isRemove = this.isRemove;
            }
        }
    };
    InfiniteScroll.prototype.setInitialCache = function(data, args, isEdit, isCurrentViewData) {
        var k = !isEdit ? 1 : (0, $3EnZW.isNullOrUndefined)(this.firstBlock) ? 1 : this.firstBlock;
        for(var i = 1; i <= this.parent.infiniteScrollSettings.initialBlocks; i++){
            var startIndex = (i - 1) * this.parent.pageSettings.pageSize;
            var endIndex = i * this.parent.pageSettings.pageSize;
            if (this.parent.allowGrouping && this.parent.groupSettings.columns.length && !isCurrentViewData) this.setInitialGroupCache(data, k, startIndex, endIndex);
            else if (isCurrentViewData) this.infiniteCurrentViewData[parseInt(k.toString(), 10)] = data.slice(startIndex, endIndex);
            else {
                this.infiniteCache[parseInt(k.toString(), 10)] = data.slice(startIndex, endIndex);
                this.resetContentModuleCache(this.infiniteCache);
            }
            k++;
        }
    };
    InfiniteScroll.prototype.setInitialGroupCache = function(data, index, sIndex, eIndex) {
        var pageData = [];
        var startIndex = 0;
        for(var i = 1; i <= Object.keys(this.infiniteCache).length; i++)startIndex += this.infiniteCache[parseInt(i.toString(), 10)].length;
        var k = sIndex;
        for(var i = startIndex; i < data.length && k < eIndex; i++){
            if (data[parseInt(i.toString(), 10)].index < eIndex || data[parseInt(i.toString(), 10)].isCaptionRow) {
                k = data[parseInt(i.toString(), 10)].isCaptionRow ? k : data[parseInt(i.toString(), 10)].index;
                pageData.push(data[parseInt(i.toString(), 10)]);
            }
            if (data[parseInt(i.toString(), 10)].index >= eIndex || data[parseInt(i.toString(), 10)].index === eIndex - 1) break;
        }
        this.infiniteCache[parseInt(index.toString(), 10)] = pageData;
        this.resetContentModuleCache(this.infiniteCache);
    };
    InfiniteScroll.prototype.resetContentModuleCache = function(data) {
        this.parent.contentModule.infiniteCache = data;
    };
    /**
     * @param {Row<Column>[]} rowObjects - Defines the grid's row objects
     * @returns {void}
     * @hidden
     */ InfiniteScroll.prototype.resetInfiniteCache = function(rowObjects) {
        var blockLength = Object.keys(this.infiniteCache).length;
        this.infiniteCache = {};
        for(var i = 1; i <= blockLength; i++){
            var startIndex = (i - 1) * this.parent.pageSettings.pageSize;
            var endIndex = i * this.parent.pageSettings.pageSize;
            if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) this.setInitialGroupCache(rowObjects, i, startIndex, endIndex);
            else {
                this.infiniteCache[parseInt(i.toString(), 10)] = rowObjects.slice(startIndex, endIndex);
                this.resetContentModuleCache(this.infiniteCache);
            }
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ InfiniteScroll.prototype.destroy = function() {
        this.removeEventListener();
    };
    return InfiniteScroll;
}();

parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
/**
 * `NumericContainer` module handles rendering and refreshing numeric container.
 */ var $3ac836c631fad313$export$a17ac95785d25579 = /** @class */ function() {
    /**
     * Constructor for numericContainer module
     *
     * @param {Pager} pagerModule - specifies the pagerModule
     * @hidden
     */ function NumericContainer(pagerModule) {
        this.pagerModule = pagerModule;
    }
    /**
     * The function is used to render numericContainer
     *
     * @returns {void}
     * @hidden
     */ NumericContainer.prototype.render = function() {
        this.pagerElement = this.pagerModule.element;
        this.renderNumericContainer();
        this.refreshNumericLinks();
        this.wireEvents();
    };
    /**
     * Refreshes the numeric container of Pager.
     *
     * @returns {void}
     */ NumericContainer.prototype.refresh = function() {
        this.pagerModule.updateTotalPages();
        if (this.links.length) this.updateLinksHtml();
        this.refreshAriaAttrLabel();
        this.updateStyles();
    };
    /**
     * The function is used to refresh refreshNumericLinks
     *
     * @returns {void}
     * @hidden
     */ NumericContainer.prototype.refreshNumericLinks = function() {
        var link;
        var pagerObj = this.pagerModule;
        var div = pagerObj.element.querySelector(".e-numericcontainer");
        var frag = document.createDocumentFragment();
        div.innerHTML = "";
        for(var i = 1; i <= pagerObj.pageCount; i++){
            link = (0, $4ZDHT.createElement)("a", {
                className: "e-link e-numericitem e-spacing e-pager-default",
                attrs: {
                    tabindex: "-1",
                    "aria-label": pagerObj.getLocalizedLabel("Page") + i + pagerObj.getLocalizedLabel("Of") + pagerObj.totalPages + pagerObj.getLocalizedLabel("Pages"),
                    href: "#"
                }
            });
            if (pagerObj.currentPage === i) {
                (0, $4ZDHT.classList)(link, [
                    "e-currentitem",
                    "e-active"
                ], [
                    "e-pager-default"
                ]);
                link.setAttribute("aria-current", "page");
            }
            frag.appendChild(link);
        }
        div.appendChild(frag);
        this.links = [].slice.call(div.childNodes);
    };
    /**
     * Binding events to the element while component creation
     *
     * @returns {void}
     * @hidden
     */ NumericContainer.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.pagerElement, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.pagerElement, "auxclick", this.auxiliaryClickHandler, this);
    };
    /**
     * Unbinding events from the element while component destroy
     *
     * @returns {void}
     * @hidden
     */ NumericContainer.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.pagerModule.element, "click", this.clickHandler);
        (0, $aqzbR.EventHandler).remove(this.pagerModule.element, "auxclick", this.auxiliaryClickHandler);
    };
    /**
     * To destroy the PagerMessage
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ NumericContainer.prototype.destroy = function() {
        this.unwireEvents();
    };
    NumericContainer.prototype.refreshAriaAttrLabel = function() {
        var pagerObj = this.pagerModule;
        var numericContainer = pagerObj.element.querySelector(".e-numericcontainer");
        var links = numericContainer.querySelectorAll("a");
        for(var i = 0; i < links.length; i++)if (links[parseInt(i.toString(), 10)].hasAttribute("aria-label") && links[parseInt(i.toString(), 10)].hasAttribute("index")) links[parseInt(i.toString(), 10)].setAttribute("aria-label", pagerObj.getLocalizedLabel("Page") + links[parseInt(i.toString(), 10)].getAttribute("index") + pagerObj.getLocalizedLabel("Of") + pagerObj.totalPages + pagerObj.getLocalizedLabel("Pages"));
    };
    NumericContainer.prototype.renderNumericContainer = function() {
        this.element = (0, $4ZDHT.createElement)("div", {
            className: "e-pagercontainer",
            attrs: {
                "role": "navigation"
            }
        });
        this.renderFirstNPrev(this.element);
        this.renderPrevPagerSet(this.element);
        this.element.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-numericcontainer"
        }));
        this.renderNextPagerSet(this.element);
        this.renderNextNLast(this.element);
        this.pagerModule.element.appendChild(this.element);
    };
    NumericContainer.prototype.renderFirstNPrev = function(pagerContainer) {
        this.first = (0, $4ZDHT.createElement)("div", {
            className: "e-first e-icons e-icon-first",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("firstPageTooltip"),
                tabindex: "-1",
                role: "button"
            }
        });
        this.prev = (0, $4ZDHT.createElement)("div", {
            className: "e-prev e-icons e-icon-prev",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("previousPageTooltip"),
                tabindex: "-1",
                role: "button"
            }
        });
        (0, $4ZDHT.append)([
            this.first,
            this.prev
        ], pagerContainer);
    };
    NumericContainer.prototype.renderPrevPagerSet = function(pagerContainer) {
        var prevPager = (0, $4ZDHT.createElement)("div");
        this.PP = (0, $4ZDHT.createElement)("a", {
            className: "e-link e-pp e-spacing",
            innerHTML: "...",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("previousPagerTooltip"),
                "aria-label": this.pagerModule.getLocalizedLabel("previousPagerTooltip"),
                tabindex: "-1",
                href: "#"
            }
        });
        prevPager.appendChild(this.PP);
        pagerContainer.appendChild(prevPager);
    };
    NumericContainer.prototype.renderNextPagerSet = function(pagerContainer) {
        var nextPager = (0, $4ZDHT.createElement)("div");
        this.NP = (0, $4ZDHT.createElement)("a", {
            className: "e-link e-np e-spacing",
            innerHTML: "...",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("nextPagerTooltip"),
                "aria-label": this.pagerModule.getLocalizedLabel("nextPagerTooltip"),
                tabindex: "-1",
                href: "#"
            }
        });
        nextPager.appendChild(this.NP);
        pagerContainer.appendChild(nextPager);
    };
    NumericContainer.prototype.renderNextNLast = function(pagerContainer) {
        this.next = (0, $4ZDHT.createElement)("div", {
            className: "e-next e-icons e-icon-next",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("nextPageTooltip"),
                tabindex: "-1",
                role: "button"
            }
        });
        this.last = (0, $4ZDHT.createElement)("div", {
            className: "e-last e-icons e-icon-last",
            attrs: {
                title: this.pagerModule.getLocalizedLabel("lastPageTooltip"),
                tabindex: "-1",
                role: "button"
            }
        });
        (0, $4ZDHT.append)([
            this.next,
            this.last
        ], pagerContainer);
    };
    NumericContainer.prototype.clickHandler = function(e) {
        var pagerObj = this.pagerModule;
        this.target = e.target;
        if (this.target.classList.contains("e-numericitem")) e.preventDefault();
        pagerObj.previousPageNo = pagerObj.currentPage;
        if (!this.target.classList.contains("e-disable") && !(0, $3EnZW.isNullOrUndefined)(this.target.getAttribute("index"))) {
            pagerObj.currentPage = parseInt(this.target.getAttribute("index"), 10);
            this.pagerModule.isInteracted = true;
            pagerObj.dataBind();
        }
        return false;
    };
    NumericContainer.prototype.auxiliaryClickHandler = function(e) {
        this.target = e.target;
        if (this.target.classList.contains("e-numericitem") && e.button === 1) e.preventDefault();
    };
    NumericContainer.prototype.updateLinksHtml = function() {
        var pagerObj = this.pagerModule;
        var currentPageSet;
        var isLastSet;
        var pageNo;
        var numItems = this.pagerElement.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
        pagerObj.currentPage = pagerObj.totalPages === 1 ? 1 : pagerObj.currentPage;
        if (pagerObj.currentPage > pagerObj.totalPages && pagerObj.totalPages) pagerObj.currentPage = pagerObj.totalPages;
        currentPageSet = parseInt((pagerObj.currentPage / pagerObj.pageCount).toString(), 10);
        if (pagerObj.currentPage % pagerObj.pageCount === 0 && currentPageSet > 0) currentPageSet = currentPageSet - 1;
        for(var i = 0; i < pagerObj.pageCount; i++){
            if (pagerObj.isPagerResized) {
                var focusedItem = this.pagerElement.querySelector(".e-focus");
                var focusedorTarget = this.target ? this.target : focusedItem ? focusedItem : null;
                var prevFocused = false;
                var nextFocused = false;
                var firstFocused = false;
                var lastFocused = false;
                var numItemFocused = false;
                var npFocused = false;
                var ppFocused = false;
                if (focusedorTarget) {
                    var classList_1 = focusedorTarget.classList;
                    if (classList_1.contains("e-icons")) switch(true){
                        case classList_1.contains("e-prev"):
                            prevFocused = true;
                            break;
                        case classList_1.contains("e-next"):
                            nextFocused = true;
                            break;
                        case classList_1.contains("e-first"):
                            firstFocused = true;
                            break;
                        case classList_1.contains("e-last"):
                            lastFocused = true;
                            break;
                    }
                    else if (classList_1.contains("e-numericitem")) switch(true){
                        case classList_1.contains("e-np"):
                            npFocused = true;
                            break;
                        case classList_1.contains("e-pp"):
                            ppFocused = true;
                            break;
                        default:
                            numItemFocused = classList_1.contains("e-numericitem");
                            break;
                    }
                }
                isLastSet = lastFocused || this.pagerModule.keyAction === "End";
                numItems = this.pagerElement.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
                var isPageAvailable = Array.from(numItems).some(function(item) {
                    return parseInt(item.getAttribute("index"), 10) === pagerObj.currentPage;
                });
                //Setting pageNo to render based on key action or click action.
                if (firstFocused || this.pagerModule.keyAction === "Home") pageNo = 1 + i;
                else if (lastFocused || this.pagerModule.keyAction === "End") pageNo = currentPageSet * pagerObj.pageCount + 1 + i;
                else if (nextFocused || this.pagerModule.keyAction === "ArrowRight" || prevFocused || this.pagerModule.keyAction === "ArrowLeft") {
                    if (isPageAvailable) pageNo = parseInt(numItems[0].getAttribute("index"), 10) + i;
                    else if (prevFocused || this.pagerModule.keyAction === "ArrowLeft") pageNo = parseInt(this.PP.getAttribute("index"), 10) + i;
                    else pageNo = pagerObj.currentPage + i;
                } else if (npFocused || ppFocused) pageNo = pagerObj.currentPage + i;
                else if (numItemFocused) pageNo = parseInt(numItems[0].getAttribute("index"), 10) + i;
                else pageNo = currentPageSet * pagerObj.pageCount + 1 + i;
            } else pageNo = currentPageSet * pagerObj.pageCount + 1 + i;
            if (pageNo <= pagerObj.totalPages) {
                this.links[parseInt(i.toString(), 10)].classList.remove("e-hide");
                this.links[parseInt(i.toString(), 10)].style.display = "";
                this.links[parseInt(i.toString(), 10)].setAttribute("index", pageNo.toString());
                this.links[parseInt(i.toString(), 10)].innerHTML = !pagerObj.customText ? pageNo.toString() : pagerObj.customText + pageNo;
                if (pagerObj.currentPage !== pageNo) this.links[parseInt(i.toString(), 10)].classList.add("e-pager-default");
                else this.links[parseInt(i.toString(), 10)].classList.remove("e-pager-default");
            } else {
                this.links[parseInt(i.toString(), 10)].innerHTML = !pagerObj.customText ? pageNo.toString() : pagerObj.customText + pageNo;
                this.links[parseInt(i.toString(), 10)].style.display = "none";
            }
            (0, $4ZDHT.classList)(this.links[parseInt(i.toString(), 10)], [], [
                "e-currentitem",
                "e-active"
            ]);
            this.links[parseInt(i.toString(), 10)].removeAttribute("aria-current");
        }
        (0, $4ZDHT.attributes)(this.first, {
            "index": "1",
            "title": this.pagerModule.getLocalizedLabel("firstPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.pagerElement.querySelector(".e-mfirst"), {
            "index": "1",
            "title": this.pagerModule.getLocalizedLabel("firstPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.last, {
            "index": pagerObj.totalPages.toString(),
            "title": this.pagerModule.getLocalizedLabel("lastPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.pagerElement.querySelector(".e-mlast"), {
            "index": pagerObj.totalPages.toString(),
            "title": this.pagerModule.getLocalizedLabel("lastPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.prev, {
            "index": (pagerObj.currentPage - 1).toString(),
            "title": this.pagerModule.getLocalizedLabel("previousPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.pagerElement.querySelector(".e-mprev"), {
            "index": (pagerObj.currentPage - 1).toString(),
            "title": this.pagerModule.getLocalizedLabel("previousPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.next, {
            "index": (pagerObj.currentPage + 1).toString(),
            "title": this.pagerModule.getLocalizedLabel("nextPageTooltip")
        });
        (0, $4ZDHT.attributes)(this.pagerElement.querySelector(".e-mnext"), {
            "index": (pagerObj.currentPage + 1).toString(),
            "title": this.pagerModule.getLocalizedLabel("nextPageTooltip")
        });
        var ppIndex = this.pagerModule.isPagerResized && numItems.length ? isLastSet ? parseInt(numItems[0].getAttribute("index"), 10) - pagerObj.avgNumItems : parseInt(numItems[0].getAttribute("index"), 10) - numItems.length : parseInt(this.links[0].getAttribute("index"), 10) - pagerObj.pageCount;
        (0, $4ZDHT.attributes)(this.PP, {
            "index": ppIndex < 1 ? "1" : ppIndex.toString(),
            "title": this.pagerModule.getLocalizedLabel("previousPagerTooltip"),
            "aria-label": this.pagerModule.getLocalizedLabel("previousPagerTooltip")
        });
        var NPIndex = this.pagerModule.isPagerResized && numItems.length ? parseInt(numItems[numItems.length - 1].getAttribute("index"), 10) : parseInt(this.links[this.links.length - 1].getAttribute("index"), 10);
        (0, $4ZDHT.attributes)(this.NP, {
            "index": (NPIndex + 1).toString(),
            "title": this.pagerModule.getLocalizedLabel("nextPagerTooltip"),
            "aria-label": this.pagerModule.getLocalizedLabel("nextPagerTooltip")
        });
        this.target = undefined;
    };
    NumericContainer.prototype.updateStyles = function() {
        var _this = this;
        this.updateFirstNPrevStyles();
        this.updatePrevPagerSetStyles();
        this.updateNextPagerSetStyles();
        this.updateNextNLastStyles();
        if (this.links.length) {
            var currentPageIndex = this.links.findIndex(function(link) {
                return link.getAttribute("index") === _this.pagerModule.currentPage.toString();
            });
            var currentPage = this.pagerModule.isPagerResized && currentPageIndex !== -1 ? currentPageIndex : (this.pagerModule.currentPage - 1) % this.pagerModule.pageCount;
            (0, $4ZDHT.classList)(this.links[parseInt(currentPage.toString(), 10)], [
                "e-currentitem",
                "e-active"
            ], []);
            this.links[parseInt(currentPage.toString(), 10)].setAttribute("aria-current", "page");
        }
    };
    NumericContainer.prototype.updateFirstNPrevStyles = function() {
        var firstPage = [
            "e-firstpage",
            "e-pager-default"
        ];
        var firstPageDisabled = [
            "e-firstpagedisabled",
            "e-disable"
        ];
        var prevPage = [
            "e-prevpage",
            "e-pager-default"
        ];
        var prevPageDisabled = [
            "e-prevpagedisabled",
            "e-disable"
        ];
        if (this.pagerModule.totalPages > 0 && this.pagerModule.currentPage > 1) {
            (0, $4ZDHT.classList)(this.prev, prevPage, prevPageDisabled);
            (0, $4ZDHT.classList)(this.first, firstPage, firstPageDisabled);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mfirst"), firstPage, firstPageDisabled);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mprev"), prevPage, prevPageDisabled);
        } else {
            (0, $4ZDHT.classList)(this.prev, prevPageDisabled, prevPage);
            (0, $4ZDHT.classList)(this.first, firstPageDisabled, firstPage);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mprev"), prevPageDisabled, prevPage);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mfirst"), firstPageDisabled, firstPage);
        }
    };
    NumericContainer.prototype.updatePrevPagerSetStyles = function() {
        if (this.pagerModule.currentPage > this.pagerModule.pageCount || this.pagerModule.isPagerResized && this.links.findIndex(function(link) {
            return parseInt(link.getAttribute("index"), 10) === 1;
        })) (0, $4ZDHT.classList)(this.PP, [
            "e-numericitem",
            "e-pager-default"
        ], [
            "e-nextprevitemdisabled",
            "e-disable"
        ]);
        else (0, $4ZDHT.classList)(this.PP, [
            "e-nextprevitemdisabled",
            "e-disable"
        ], [
            "e-numericitem",
            "e-pager-default"
        ]);
    };
    NumericContainer.prototype.updateNextPagerSetStyles = function() {
        var pagerObj = this.pagerModule;
        var firstPage = this.links[0].innerHTML.replace(pagerObj.customText, "");
        var numItems = this.pagerElement.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
        if (!firstPage.length || !this.links.length || parseInt(firstPage, 10) + pagerObj.pageCount > pagerObj.totalPages || pagerObj.isPagerResized && Array.from(numItems).some(function(item) {
            return parseInt(item.getAttribute("index"), 10) === pagerObj.totalPages;
        })) (0, $4ZDHT.classList)(this.NP, [
            "e-nextprevitemdisabled",
            "e-disable"
        ], [
            "e-numericitem",
            "e-pager-default"
        ]);
        else (0, $4ZDHT.classList)(this.NP, [
            "e-numericitem",
            "e-pager-default"
        ], [
            "e-nextprevitemdisabled",
            "e-disable"
        ]);
    };
    NumericContainer.prototype.updateNextNLastStyles = function() {
        var lastPage = [
            "e-lastpage",
            "e-pager-default"
        ];
        var lastPageDisabled = [
            "e-lastpagedisabled",
            "e-disable"
        ];
        var nextPage = [
            "e-nextpage",
            "e-pager-default"
        ];
        var nextPageDisabled = [
            "e-nextpagedisabled",
            "e-disable"
        ];
        var pagerObj = this.pagerModule;
        if (pagerObj.currentPage === pagerObj.totalPages || pagerObj.totalRecordsCount === 0) {
            (0, $4ZDHT.classList)(this.last, lastPageDisabled, lastPage);
            (0, $4ZDHT.classList)(this.next, nextPageDisabled, nextPage);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mlast"), lastPageDisabled, lastPage);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mnext"), nextPageDisabled, nextPage);
        } else {
            (0, $4ZDHT.classList)(this.last, lastPage, lastPageDisabled);
            (0, $4ZDHT.classList)(this.next, nextPage, nextPageDisabled);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mlast"), lastPage, lastPageDisabled);
            (0, $4ZDHT.classList)(this.pagerElement.querySelector(".e-mnext"), nextPage, nextPageDisabled);
        }
    };
    return NumericContainer;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
/**
 * `PagerMessage` module is used to display pager information.
 */ var $36137f2b5ca58c4f$export$123095dfb8c6853e = /** @class */ function() {
    /**
     * Constructor for externalMessage module
     *
     * @param {Pager} pagerModule - specifies the pager Module
     * @hidden
     */ function PagerMessage(pagerModule) {
        this.pagerModule = pagerModule;
    }
    /**
     * The function is used to render pager message
     *
     * @returns {void}
     * @hidden
     */ PagerMessage.prototype.render = function() {
        var div = (0, $4ZDHT.createElement)("div", {
            className: "e-parentmsgbar"
        });
        this.pageNoMsgElem = (0, $4ZDHT.createElement)("span", {
            className: "e-pagenomsg",
            styles: "textalign:right"
        });
        this.pageCountMsgElem = (0, $4ZDHT.createElement)("span", {
            className: "e-pagecountmsg",
            styles: "textalign:right"
        });
        (0, $4ZDHT.append)([
            this.pageNoMsgElem,
            this.pageCountMsgElem
        ], div);
        this.pagerModule.element.appendChild(div);
        this.refresh();
    };
    /**
     * Refreshes the pager information.
     *
     * @returns {void}
     */ PagerMessage.prototype.refresh = function() {
        var pagerObj = this.pagerModule;
        this.pageNoMsgElem.textContent = this.format(pagerObj.getLocalizedLabel("currentPageInfo"), [
            pagerObj.totalRecordsCount === 0 ? 0 : pagerObj.currentPage,
            pagerObj.totalPages || 0,
            pagerObj.totalRecordsCount || 0
        ]) + " ";
        this.pageCountMsgElem.textContent = this.format(pagerObj.getLocalizedLabel(pagerObj.totalRecordsCount <= 1 ? "totalItemInfo" : "totalItemsInfo"), [
            pagerObj.totalRecordsCount || 0,
            pagerObj.totalRecordsCount ? pagerObj.pageSize * (pagerObj.currentPage - 1) + 1 : 0,
            pagerObj.pageSize * pagerObj.currentPage > pagerObj.totalRecordsCount ? pagerObj.totalRecordsCount : pagerObj.pageSize * pagerObj.currentPage
        ]);
        this.pageNoMsgElem.parentElement.classList.remove("e-hide");
    };
    /**
     * Hides the Pager information.
     *
     * @returns {void}
     */ PagerMessage.prototype.hideMessage = function() {
        if (this.pageNoMsgElem) this.pageNoMsgElem.style.display = "none";
        if (this.pageCountMsgElem) this.pageCountMsgElem.style.display = "none";
    };
    /**
     * Shows the Pager information.
     *
     * @returns {void}
     */ PagerMessage.prototype.showMessage = function() {
        if (!this.pageNoMsgElem) this.render();
        this.pageNoMsgElem.style.display = "";
        this.pageCountMsgElem.style.display = "";
    };
    /**
     * To destroy the PagerMessage
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ PagerMessage.prototype.destroy = function() {
    //destroy
    };
    /**
     * To format the PagerMessage
     *
     * @function format
     * @param {string} str - specifies the string
     * @param {number[]} args - specifies the argument
     * @returns {string} returns the format string
     * @hidden
     */ PagerMessage.prototype.format = function(str, args) {
        var regx;
        var regExp = RegExp;
        for(var i = 0; i < args.length; i++){
            regx = new regExp("\\{" + i + "\\}", "gm");
            str = str.replace(regx, args[parseInt(i.toString(), 10)].toLocaleString(this.pagerModule.locale));
        }
        return str;
    };
    return PagerMessage;
}();




var $d9db24a736894064$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d9db24a736894064$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Represents the `Pager` component.
 * ```html
 * <div id="pager"/>
 * ```
 * ```typescript
 * <script>
 *   var pagerObj = new Pager({ totalRecordsCount: 50, pageSize:10 });
 *   pagerObj.appendTo("#pager");
 * </script>
 * ```
 */ var $d9db24a736894064$export$57625d62e5386b09 = /** @class */ function(_super) {
    $d9db24a736894064$var$__extends(Pager, _super);
    /**
     * Constructor for creating the component.
     *
     * @param {PagerModel} options - specifies the options
     * @param {string} element - specifies the element
     * @param {string} parent - specifies the pager parent
     * @hidden
     */ function Pager(options, element, parent) {
        var _this = _super.call(this, options, element) || this;
        /** @hidden */ _this.hasParent = false;
        _this.checkAll = true;
        _this.pageRefresh = "pager-refresh";
        _this.firstPagerFocus = false;
        /** @hidden */ _this.isCancel = false;
        /** @hidden */ _this.isInteracted = false;
        _this.parent = parent;
        return _this;
    }
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} returns the modules declaration
     * @hidden
     */ Pager.prototype.requiredModules = function() {
        var modules = [];
        if (this.enableExternalMessage) modules.push({
            member: "externalMessage",
            args: [
                this
            ],
            name: "ExternalMessage"
        });
        if (this.checkpagesizes()) modules.push({
            member: "pagerdropdown",
            args: [
                this
            ],
            name: "PagerDropDown"
        });
        return modules;
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @hidden
     */ Pager.prototype.preRender = function() {
        //preRender
        this.defaultConstants = {
            currentPageInfo: "{0} of {1} pages",
            totalItemsInfo: "({0} items)",
            totalItemInfo: "({0} item)",
            firstPageTooltip: "Go to first page",
            lastPageTooltip: "Go to last page",
            nextPageTooltip: "Go to next page",
            previousPageTooltip: "Go to previous page",
            nextPagerTooltip: "Go to next pager items",
            previousPagerTooltip: "Go to previous pager items",
            pagerDropDown: "Items per page",
            pagerAllDropDown: "Items",
            CurrentPageInfo: "{0} of {1} pages",
            TotalItemsInfo: "({0} items)",
            FirstPageTooltip: "Go to first page",
            LastPageTooltip: "Go to last page",
            NextPageTooltip: "Go to next page",
            PreviousPageTooltip: "Go to previous page",
            NextPagerTooltip: "Go to next pager items",
            PreviousPagerTooltip: "Go to previous pager items",
            PagerDropDown: "Items per page",
            PagerAllDropDown: "Items",
            All: "All",
            Container: "Pager Container",
            Information: "Pager Information",
            ExternalMsg: "Pager external message",
            Page: "Page ",
            Of: " of ",
            Pages: " Pages"
        };
        this.containerModule = new (0, $3ac836c631fad313$export$a17ac95785d25579)(this);
        this.pagerMessageModule = new (0, $36137f2b5ca58c4f$export$123095dfb8c6853e)(this);
    };
    /**
     * To Initialize the component rendering
     *
     * @returns {void}
     */ Pager.prototype.render = function() {
        this.element.setAttribute("data-role", "pager");
        this.element.setAttribute("tabindex", "-1");
        this.initLocalization();
        if (this.cssClass) {
            if (this.cssClass.indexOf(" ") !== -1) (0, $4ZDHT.addClass)([
                this.element
            ], this.cssClass.split(" "));
            else (0, $4ZDHT.addClass)([
                this.element
            ], [
                this.cssClass
            ]);
        }
        if (!this.hasParent) this.element.setAttribute("tabindex", "0");
        if (this.enableQueryString) {
            var pageValue = new URL(window.location.href).searchParams.get("page");
            if (!(0, $3EnZW.isNullOrUndefined)(pageValue) && window.location.href.indexOf("?page=") > 0) {
                var currentPageValue = parseInt(pageValue, 10);
                if (this.hasParent) this.parent.setProperties({
                    pageSettings: {
                        currentPage: currentPageValue
                    }
                }, true);
                this.currentPage = currentPageValue;
            }
        }
        if (this.template) {
            if (this.isReactTemplate()) {
                this.on(this.pageRefresh, this.pagerTemplate, this);
                this.notify(this.pageRefresh, {});
            } else this.pagerTemplate();
        } else {
            this.updateRTL();
            this.totalRecordsCount = this.totalRecordsCount || 0;
            this.renderFirstPrevDivForDevice();
            this.containerModule.render();
            if (this.enablePagerMessage) this.pagerMessageModule.render();
            this.renderNextLastDivForDevice();
            if (this.checkpagesizes() && this.pagerdropdownModule) this.pagerdropdownModule.render();
            this.addAriaLabel();
            if (this.enableExternalMessage && this.externalMessageModule) this.externalMessageModule.render();
            this.refresh();
            this.trigger("created", {
                "currentPage": this.currentPage,
                "totalRecordsCount": this.totalRecordsCount
            });
        }
        this.wireEvents();
        this.addListener();
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} returns the persist data
     * @hidden
     */ Pager.prototype.getPersistData = function() {
        var keyEntity = [
            "currentPage",
            "pageSize"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * To destroy the Pager component.
     *
     * @method destroy
     * @returns {void}
     */ Pager.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.isReactTemplate()) {
            this.off(this.pageRefresh, this.pagerTemplate);
            if (!this.hasParent) this.destroyTemplate([
                "pagerTemplate"
            ]);
        }
        this.removeListener();
        this.unwireEvents();
        _super.prototype.destroy.call(this);
        this.containerModule.destroy();
        this.pagerMessageModule.destroy();
        if (!this.isReactTemplate()) this.element.innerHTML = "";
    };
    /**
     * Destroys the given template reference.
     *
     * @param {string[]} propertyNames - Defines the collection of template name.
     * @param {any} index - Defines the index
     */ // eslint-disable-next-line
    Pager.prototype.destroyTemplate = function(propertyNames, index) {
        this.clearTemplate(propertyNames, index);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Pager.prototype.getModuleName = function() {
        return "pager";
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {PagerModel} newProp - specifies the new property
     * @param {PagerModel} oldProp - specifies the old propety
     * @returns {void}
     * @hidden
     */ Pager.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (this.isDestroyed) return;
        if (newProp.pageSize === this.getLocalizedLabel("All") && oldProp.pageSize === this.totalRecordsCount) {
            this.pageSize = this.totalRecordsCount;
            return;
        }
        if (newProp.pageCount !== oldProp.pageCount) {
            this.containerModule.refreshNumericLinks();
            this.containerModule.refresh();
        }
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "currentPage":
                    if (this.checkGoToPage(newProp.currentPage, oldProp.currentPage)) this.currentPageChanged(newProp, oldProp);
                    break;
                case "pageSize":
                case "totalRecordsCount":
                case "customText":
                    if (this.checkpagesizes() && this.pagerdropdownModule) {
                        if (oldProp.pageSize !== newProp.pageSize) this.currentPage = 1;
                        this.pagerdropdownModule.setDropDownValue("value", this.pageSize);
                    }
                    if (newProp.pageSize !== oldProp.pageSize) {
                        this.pageSize = newProp.pageSize;
                        this.currentPageChanged(newProp, oldProp);
                        if (this.isCancel && this.hasParent) this.parent.setProperties({
                            pageSettings: {
                                pageSize: oldProp.pageSize
                            }
                        }, true);
                    } else this.refresh();
                    break;
                case "pageSizes":
                    if (this.checkpagesizes() && this.pagerdropdownModule) {
                        this.pagerdropdownModule.destroy();
                        this.pagerdropdownModule.render();
                    }
                    this.refresh();
                    break;
                case "template":
                    this.templateFn = this.compile(this.template);
                    this.refresh();
                    break;
                case "locale":
                    this.initLocalization();
                    this.refresh();
                    break;
                case "enableExternalMessage":
                    if (this.enableExternalMessage && this.externalMessageModule) this.externalMessageModule.render();
                    break;
                case "externalMessage":
                    if (this.externalMessageModule) this.externalMessageModule.refresh();
                    break;
                case "enableRtl":
                    this.updateRTL();
                    break;
                case "enablePagerMessage":
                    if (this.enablePagerMessage) this.pagerMessageModule.showMessage();
                    else this.pagerMessageModule.hideMessage();
                    break;
            }
        }
        this.resizePager();
    };
    Pager.prototype.wireEvents = function() {
        if (!this.hasParent) {
            (0, $aqzbR.EventHandler).add(this.element, "keydown", this.keyPressHandler, this);
            (0, $aqzbR.EventHandler).add(document.body, "keydown", this.keyDownHandler, this);
        }
        (0, $aqzbR.EventHandler).add(this.element, "focusin", this.onFocusIn, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.onFocusOut, this);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).add(window, "resize", this.resizePager, this);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).add(window, "load", this.resizePager, this);
    };
    Pager.prototype.unwireEvents = function() {
        if (!this.hasParent) {
            (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.keyPressHandler);
            (0, $aqzbR.EventHandler).remove(document.body, "keydown", this.keyDownHandler);
        }
        (0, $aqzbR.EventHandler).remove(this.element, "focusin", this.onFocusIn);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.onFocusOut);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).remove(window, "resize", this.resizePager);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).remove(window, "load", this.resizePager);
    };
    Pager.prototype.onFocusIn = function(e) {
        var focusedTabIndexElement = this.getFocusedTabindexElement();
        if ((0, $3EnZW.isNullOrUndefined)(focusedTabIndexElement)) {
            var target = e.target;
            var dropDownPage = this.getDropDownPage();
            if (!this.hasParent) this.element.tabIndex = -1;
            if (target === this.element && !this.hasParent) {
                var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
                this.addFocus(focusablePagerElements[0], true);
                return;
            }
            if (target === this.element) {
                this.element.tabIndex = 0;
                return;
            }
            if (target !== dropDownPage && !target.classList.contains("e-disable")) this.addFocus(target, true);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Pager.prototype.onFocusOut = function(e) {
        var focusedElement = this.getFocusedElement();
        var dropDownPage = this.getDropDownPage();
        if (!(0, $3EnZW.isNullOrUndefined)(focusedElement)) this.removeFocus(focusedElement, true);
        if (this.pageSizes && dropDownPage && dropDownPage.classList.contains("e-input-focus")) this.removeFocus(dropDownPage, true);
        this.setTabIndexForFocusLastElement();
        if (!this.hasParent) this.element.tabIndex = 0;
        if (this.hasParent) this.element.tabIndex = -1;
    };
    Pager.prototype.keyDownHandler = function(e) {
        if (e.altKey) {
            if (e.keyCode === 74) {
                var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
                if (focusablePagerElements.length > 0) focusablePagerElements[0].focus();
            }
        }
    };
    Pager.prototype.keyPressHandler = function(e) {
        var presskey = (0, $3EnZW.extend)(e, {
            cancel: false
        });
        this.notify($17b89d3b1fc93cdb$export$e09b512eecac7579, presskey);
        if (presskey.cancel === true) e.stopImmediatePropagation();
    };
    Pager.prototype.addListener = function() {
        if (this.isDestroyed) return;
        if (!this.hasParent) this.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.onKeyPress, this);
    };
    Pager.prototype.removeListener = function() {
        if (this.isDestroyed) return;
        if (!this.hasParent) this.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.onKeyPress);
    };
    Pager.prototype.onKeyPress = function(e) {
        if (!this.hasParent) {
            if (this.checkPagerHasFocus()) this.changePagerFocus(e);
            else {
                e.preventDefault();
                this.setPagerFocus();
            }
        }
    };
    /**
     * @returns {boolean} - Return the true value if pager has focus
     * @hidden */ Pager.prototype.checkPagerHasFocus = function() {
        return this.getFocusedTabindexElement() ? true : false;
    };
    /**
     * @returns {void}
     * @hidden */ Pager.prototype.setPagerContainerFocus = function() {
        this.element.focus();
    };
    /**
     * @returns {void}
     * @hidden */ Pager.prototype.setPagerFocus = function() {
        var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
        if (focusablePagerElements.length > 0) focusablePagerElements[0].focus();
    };
    Pager.prototype.setPagerFocusForActiveElement = function() {
        var currentActivePage = this.getActiveElement();
        if (currentActivePage) currentActivePage.focus();
    };
    Pager.prototype.setTabIndexForFocusLastElement = function() {
        var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
        var dropDownPage = this.getDropDownPage();
        if (this.pageSizes && dropDownPage && !(0, $3EnZW.isNullOrUndefined)(dropDownPage.offsetParent)) dropDownPage.tabIndex = 0;
        else if (focusablePagerElements.length > 0) focusablePagerElements[focusablePagerElements.length - 1].tabIndex = 0;
    };
    /**
     * @param {KeyboardEventArgs} e - Keyboard Event Args
     * @returns {void}
     * @hidden */ Pager.prototype.changePagerFocus = function(e) {
        this.keyAction = e.key;
        if (e.shiftKey && e.keyCode === 9) this.changeFocusByShiftTab(e);
        else if (e.keyCode === 9) this.changeFocusByTab(e);
        else if (e.keyCode === 13 || e.keyCode === 32) this.navigateToPageByEnterOrSpace(e);
        else if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 35 || e.keyCode === 36) this.navigateToPageByKey(e);
        this.keyAction = "";
    };
    Pager.prototype.getFocusedTabindexElement = function() {
        var focusedTabIndexElement;
        var tabindexElements = this.element.querySelectorAll('[tabindex]:not([tabindex="-1"])');
        for(var i = 0; i < tabindexElements.length; i++){
            var element = tabindexElements[parseInt(i.toString(), 10)];
            if (element && (element.classList.contains("e-focused") || element.classList.contains("e-input-focus"))) {
                focusedTabIndexElement = element;
                break;
            }
        }
        return focusedTabIndexElement;
    };
    Pager.prototype.changeFocusByTab = function(e) {
        var currentItemPagerFocus = this.getFocusedTabindexElement();
        var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
        var dropDownPage = this.getDropDownPage();
        if (focusablePagerElements.length > 0) {
            if (this.pageSizes && dropDownPage && currentItemPagerFocus === focusablePagerElements[focusablePagerElements.length - 1]) dropDownPage.tabIndex = 0;
            else {
                for(var i = 0; i < focusablePagerElements.length; i++)if (currentItemPagerFocus === focusablePagerElements[parseInt(i.toString(), 10)]) {
                    var incrementNumber = i + 1;
                    if (incrementNumber < focusablePagerElements.length) {
                        e.preventDefault();
                        focusablePagerElements[parseInt(incrementNumber.toString(), 10)].focus();
                    }
                    break;
                }
            }
        }
    };
    Pager.prototype.changeFocusByShiftTab = function(e) {
        var currentItemPagerFocus = this.getFocusedTabindexElement();
        var focusablePagerElements = this.getFocusablePagerElements(this.element, []);
        var dropDownPage = this.getDropDownPage();
        if (this.pageSizes && dropDownPage && dropDownPage.classList.contains("e-input-focus")) {
            dropDownPage.tabIndex = -1;
            this.addFocus(focusablePagerElements[focusablePagerElements.length - 1], true);
        } else if (focusablePagerElements.length > 0) {
            for(var i = 0; i < focusablePagerElements.length; i++)if (currentItemPagerFocus === focusablePagerElements[parseInt(i.toString(), 10)]) {
                var decrementNumber = i - 1;
                if (decrementNumber >= 0) {
                    e.preventDefault();
                    focusablePagerElements[parseInt(decrementNumber.toString(), 10)].focus();
                } else if (this.hasParent) {
                    var rows = this.parent.getRows();
                    var lastRow = rows[rows.length - 1];
                    var lastCell = lastRow.lastChild;
                    e.preventDefault();
                    lastCell.focus();
                    this.firstPagerFocus = true;
                }
                break;
            }
        }
    };
    /**
     * @returns {void}
     * @hidden */ Pager.prototype.checkFirstPagerFocus = function() {
        if (this.firstPagerFocus) {
            this.firstPagerFocus = false;
            return true;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Pager.prototype.navigateToPageByEnterOrSpace = function(e) {
        var currentItemPagerFocus = this.getFocusedElement();
        if (currentItemPagerFocus) {
            this.goToPage(parseInt(currentItemPagerFocus.getAttribute("index"), 10));
            var currentActivePage = this.getActiveElement();
            var selectedClass = this.getClass(currentItemPagerFocus);
            var classElement = this.getElementByClass(selectedClass);
            if ((selectedClass === "e-first" || selectedClass === "e-prev" || selectedClass === "e-next" || selectedClass === "e-last" || selectedClass === "e-pp" || selectedClass === "e-np") && classElement && !classElement.classList.contains("e-disable")) classElement.focus();
            else if (this.checkFocusInAdaptiveMode(currentItemPagerFocus)) this.changeFocusInAdaptiveMode(currentItemPagerFocus);
            else if (currentActivePage) currentActivePage.focus();
        }
    };
    Pager.prototype.navigateToPageByKey = function(e) {
        var actionClass = e.keyCode === 37 ? ".e-prev" : e.keyCode === 39 ? ".e-next" : e.keyCode === 35 ? ".e-last" : e.keyCode === 36 ? ".e-first" : "";
        var pagingItem = this.element.querySelector(actionClass);
        var currentItemPagerFocus = this.getFocusedElement();
        if (!(0, $3EnZW.isNullOrUndefined)(pagingItem) && pagingItem.hasAttribute("index") && !isNaN(parseInt(pagingItem.getAttribute("index"), 10))) {
            this.goToPage(parseInt(pagingItem.getAttribute("index"), 10));
            var currentActivePage = this.getActiveElement();
            if (this.checkFocusInAdaptiveMode(currentItemPagerFocus)) this.changeFocusInAdaptiveMode(currentItemPagerFocus);
            else if (currentActivePage) currentActivePage.focus();
        }
    };
    Pager.prototype.checkFocusInAdaptiveMode = function(element) {
        var selectedClass = this.getClass(element);
        return selectedClass === "e-mfirst" || selectedClass === "e-mprev" || selectedClass === "e-mnext" || selectedClass === "e-mlast" ? true : false;
    };
    Pager.prototype.changeFocusInAdaptiveMode = function(element) {
        var selectedClass = this.getClass(element);
        var classElement = this.getElementByClass(selectedClass);
        if (classElement && classElement.classList.contains("e-disable")) {
            if (selectedClass === "e-mnext" || selectedClass === "e-mlast") {
                var mPrev = this.element.querySelector(".e-mprev");
                mPrev.focus();
            } else this.setPagerFocus();
        }
    };
    Pager.prototype.removeTabindexLastElements = function() {
        var tabIndexElements = this.element.querySelectorAll('[tabindex]:not([tabindex="-1"])');
        if (tabIndexElements.length > 1) for(var i = 1; i < tabIndexElements.length; i++){
            var element = tabIndexElements[parseInt(i.toString(), 10)];
            if (element) element.tabIndex = -1;
        }
    };
    Pager.prototype.getActiveElement = function() {
        return this.element.querySelector(".e-active");
    };
    /**
     * @returns {Element} - Returns DropDown Page
     * @hidden */ Pager.prototype.getDropDownPage = function() {
        var dropDownPageHolder = this.element.querySelector(".e-pagerdropdown");
        var dropDownPage;
        if (dropDownPageHolder) dropDownPage = dropDownPageHolder.children[0];
        return dropDownPage;
    };
    Pager.prototype.getFocusedElement = function() {
        return this.element.querySelector(".e-focused");
    };
    Pager.prototype.getClass = function(element) {
        var currentClass;
        var classList = [
            "e-mfirst",
            "e-mprev",
            "e-first",
            "e-prev",
            "e-pp",
            "e-np",
            "e-next",
            "e-last",
            "e-mnext",
            "e-mlast"
        ];
        for(var i = 0; i < classList.length; i++)if (element && element.classList.contains(classList[parseInt(i.toString(), 10)])) {
            currentClass = classList[parseInt(i.toString(), 10)];
            return currentClass;
        }
        return currentClass;
    };
    Pager.prototype.getElementByClass = function(className) {
        return this.element.querySelector("." + className);
    };
    /**
     * @param {Element} element - Pager element
     * @param {Element[]} previousElements - Iterating pager element
     * @returns {Element[]} - Returns focusable pager element
     * @hidden */ Pager.prototype.getFocusablePagerElements = function(element, previousElements) {
        var target = element;
        var targetChildrens = target.children;
        var pagerElements = previousElements;
        for(var i = 0; i < targetChildrens.length; i++){
            var element_1 = targetChildrens[parseInt(i.toString(), 10)];
            if (element_1.children.length > 0 && !element_1.classList.contains("e-pagesizes")) pagerElements = this.getFocusablePagerElements(element_1, pagerElements);
            else {
                var tabindexElement = targetChildrens[parseInt(i.toString(), 10)];
                if (tabindexElement.hasAttribute("tabindex") && !element_1.classList.contains("e-disable") && element_1.style.display !== "none" && !(0, $3EnZW.isNullOrUndefined)(element_1.offsetParent)) pagerElements.push(tabindexElement);
            }
        }
        return pagerElements;
    };
    Pager.prototype.addFocus = function(element, addFocusClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            if (addFocusClass) (0, $4ZDHT.addClass)([
                element
            ], [
                "e-focused",
                "e-focus"
            ]);
            element.tabIndex = 0;
        }
    };
    Pager.prototype.removeFocus = function(element, removeFocusClass) {
        if (removeFocusClass) (0, $4ZDHT.removeClass)([
            element
        ], [
            "e-focused",
            "e-focus"
        ]);
        element.tabIndex = -1;
    };
    /**
     * Gets the localized label by locale keyword.
     *
     * @param  {string} key - specifies the key
     * @returns {string} returns the localized label
     */ Pager.prototype.getLocalizedLabel = function(key) {
        return this.localeObj.getConstant(key);
    };
    /**
     * Navigate to target page by given number.
     *
     * @param  {number} pageNo - Defines page number.
     * @returns {void}
     */ Pager.prototype.goToPage = function(pageNo) {
        if (this.checkGoToPage(pageNo)) {
            this.currentPage = pageNo;
            this.isInteracted = false;
            this.dataBind();
        }
    };
    /**
     * @param {number} pageSize - specifies the pagesize
     * @returns {void}
     * @hidden
     */ Pager.prototype.setPageSize = function(pageSize) {
        this.pageSize = pageSize;
        this.dataBind();
    };
    Pager.prototype.checkpagesizes = function() {
        if (this.pageSizes === true || this.pageSizes.length) return true;
        return false;
    };
    Pager.prototype.checkGoToPage = function(newPageNo, oldPageNo) {
        if (newPageNo !== this.currentPage) this.previousPageNo = this.currentPage;
        if (!(0, $3EnZW.isNullOrUndefined)(oldPageNo)) this.previousPageNo = oldPageNo;
        if (this.previousPageNo !== newPageNo && newPageNo >= 1 && newPageNo <= this.totalPages) return true;
        return false;
    };
    Pager.prototype.currentPageChanged = function(newProp, oldProp) {
        if (this.enableQueryString) this.updateQueryString(this.currentPage);
        if (newProp.currentPage !== oldProp.currentPage || newProp.pageSize !== oldProp.pageSize) {
            var args = {
                currentPage: this.currentPage,
                newProp: newProp,
                oldProp: oldProp,
                cancel: false,
                isInteracted: this.isInteracted
            };
            this.trigger("click", args);
            if (!args.cancel) {
                this.isCancel = false;
                this.refresh();
            } else {
                this.isCancel = true;
                if (oldProp && oldProp.pageSize) {
                    this.setProperties({
                        pageSize: oldProp.pageSize
                    }, true);
                    if (this.pagerdropdownModule) {
                        this.pagerdropdownModule.setDropDownValue("value", oldProp.pageSize);
                        this.pagerdropdownModule["dropDownListObject"].text = oldProp.pageSize + "";
                    }
                }
            }
        }
    };
    Pager.prototype.pagerTemplate = function() {
        if (this.isReactTemplate() && this.hasParent) return;
        var result;
        this.element.classList.add("e-pagertemplate");
        this.compile(this.template);
        var data = {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            pageCount: this.pageCount,
            totalRecordsCount: this.totalRecordsCount,
            totalPages: this.totalPages
        };
        var tempId = this.element.parentElement.id + "_template";
        if (this.isReactTemplate() && !this.isVue) {
            this.getPagerTemplate()(data, this, "pagerTemplate", tempId, null, null, this.element);
            this.renderReactTemplates();
        } else {
            result = this.isVue ? this.getPagerTemplate()(data, this, "pagerTemplate", null, null, null, null, this.root) : this.getPagerTemplate()(data);
            (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.element, result);
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Pager.prototype.updateTotalPages = function() {
        this.totalPages = this.isAllPage ? 1 : this.totalRecordsCount % this.pageSize === 0 ? this.totalRecordsCount / this.pageSize : parseInt((this.totalRecordsCount / this.pageSize).toString(), 10) + 1;
    };
    /**
     * @returns {Function} returns the function
     * @hidden
     */ Pager.prototype.getPagerTemplate = function() {
        return this.templateFn;
    };
    /**
     * @param {string | Function} template - specifies the template
     * @returns {Function} returns the function
     * @hidden
     */ Pager.prototype.compile = function(template) {
        if (template) try {
            if (typeof template === "function") this.templateFn = (0, $c2qqN.compile)(template);
            else if (document.querySelectorAll(template).length) this.templateFn = (0, $c2qqN.compile)(document.querySelector(template).innerHTML.trim());
            else this.templateFn = (0, $c2qqN.compile)(template);
        } catch (e) {
            this.templateFn = (0, $c2qqN.compile)(template);
        }
        return undefined;
    };
    /**
     * Refreshes page count, pager information and external message.
     *
     * @returns {void}
     */ Pager.prototype.refresh = function() {
        if (this.template) {
            if (this.isReactTemplate()) {
                this.updateTotalPages();
                this.notify(this.pageRefresh, {});
            } else {
                this.element.innerHTML = "";
                this.updateTotalPages();
                this.pagerTemplate();
            }
        } else {
            this.updateRTL();
            var focusedTabIndexElement = this.getFocusedTabindexElement();
            this.containerModule.refresh();
            this.removeTabindexLastElements();
            if (focusedTabIndexElement && focusedTabIndexElement.classList.contains("e-disable")) {
                if (this.checkFocusInAdaptiveMode(focusedTabIndexElement)) this.changeFocusInAdaptiveMode(focusedTabIndexElement);
                else this.setPagerFocusForActiveElement();
            }
            if (this.enablePagerMessage) this.pagerMessageModule.refresh();
            if (this.pagerdropdownModule) this.pagerdropdownModule.refresh();
            if (this.enableExternalMessage && this.externalMessageModule) this.externalMessageModule.refresh();
            this.setTabIndexForFocusLastElement();
            this.resizePager();
        }
    };
    Pager.prototype.updateRTL = function() {
        if (this.enableRtl) this.element.classList.add("e-rtl");
        else this.element.classList.remove("e-rtl");
    };
    Pager.prototype.initLocalization = function() {
        this.localeObj = new (0, $e7i2H.L10n)(this.getModuleName(), this.defaultConstants, this.locale);
    };
    Pager.prototype.updateQueryString = function(value) {
        var updatedUrl = this.getUpdatedURL(window.location.href, "page", value.toString());
        window.history.pushState({
            path: updatedUrl
        }, "", updatedUrl);
    };
    Pager.prototype.getUpdatedURL = function(uri, key, value) {
        var regExp = RegExp;
        var regx = new regExp("([?|&])" + key + "=.*?(&|#|$)", "i");
        if (uri.match(regx)) return uri.replace(regx, "$1" + key + "=" + value + "$2");
        else {
            var hash = "";
            if (uri.indexOf("#") !== -1) {
                hash = uri.replace(/.*#/, "#");
                uri = uri.replace(/#.*/, "");
            }
            return uri + (uri.indexOf("?") !== -1 ? "&" : "?") + key + "=" + value + hash;
        }
    };
    Pager.prototype.renderFirstPrevDivForDevice = function() {
        this.element.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-mfirst e-icons e-icon-first",
            attrs: {
                title: this.getLocalizedLabel("firstPageTooltip"),
                tabindex: "-1"
            }
        }));
        this.element.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-mprev e-icons e-icon-prev",
            attrs: {
                title: this.getLocalizedLabel("previousPageTooltip"),
                tabindex: "-1"
            }
        }));
    };
    Pager.prototype.renderNextLastDivForDevice = function() {
        this.element.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-mnext e-icons e-icon-next",
            attrs: {
                title: this.getLocalizedLabel("nextPageTooltip"),
                tabindex: "-1"
            }
        }));
        this.element.appendChild((0, $4ZDHT.createElement)("div", {
            className: "e-mlast e-icons e-icon-last",
            attrs: {
                title: this.getLocalizedLabel("lastPageTooltip"),
                tabindex: "-1"
            }
        }));
    };
    Pager.prototype.addAriaLabel = function() {
        var classList = [
            ".e-mfirst",
            ".e-mprev",
            ".e-mnext",
            ".e-mlast"
        ];
        if (!(0, $5q7BP.Browser).isDevice) for(var i = 0; i < classList.length; i++){
            var element = this.element.querySelector(classList[parseInt(i.toString(), 10)]);
            element.setAttribute("aria-label", element.getAttribute("title"));
        }
    };
    Pager.prototype.isReactTemplate = function() {
        return (this.isReact || this.isVue) && this.template && typeof this.template !== "string";
    };
    /**
     * Loop through all the inner elements of pager to calculate the required width for pager child elements.
     *
     * @returns {number} returns the actual width occupied by pager elements.
     */ Pager.prototype.calculateActualWidth = function() {
        var pagerElements = this.element.querySelectorAll(/* tslint:disable-next-line:max-line-length */ ".e-mfirst, .e-mprev, .e-icon-first, .e-icon-prev, .e-pp:not(.e-disable), .e-numericitem:not(.e-hide), .e-numericitem.e-active.e-hide, .e-np:not(.e-disable), .e-icon-next, .e-icon-last, .e-parentmsgbar, .e-mnext, .e-mlast, .e-pagerdropdown, .e-pagerconstant");
        var actualWidth = 0;
        for(var i = 0; i < pagerElements.length; i++)if (getComputedStyle(pagerElements[parseInt(i.toString(), 10)]).display !== "none") actualWidth += pagerElements[parseInt(i.toString(), 10)].offsetWidth + parseFloat(getComputedStyle(pagerElements[parseInt(i.toString(), 10)]).marginLeft) + parseFloat(getComputedStyle(pagerElements[parseInt(i.toString(), 10)]).marginRight);
        var pagerContainer = this.element.querySelector(".e-pagercontainer");
        actualWidth += parseFloat(getComputedStyle(pagerContainer).marginLeft) + parseFloat(getComputedStyle(pagerContainer).marginRight);
        return actualWidth;
    };
    /**
     * Resize pager component by hiding pager component's numeric items based on total width available for pager.
     *
     * @returns {void}
     */ Pager.prototype.resizePager = function() {
        var _this = this;
        var isStyleApplied = this.element.classList.contains("e-pager") ? getComputedStyle(this.element).getPropertyValue("border-style").includes("solid") : null;
        if (!this.template && isStyleApplied) {
            var pagerContainer = this.element.querySelector(".e-pagercontainer");
            var actualWidth = this.calculateActualWidth();
            var pagerWidth = this.element.clientWidth - parseFloat(getComputedStyle(this.element).paddingLeft) - parseFloat(getComputedStyle(this.element).paddingRight) - parseFloat(getComputedStyle(this.element).marginLeft) - parseFloat(getComputedStyle(this.element).marginRight);
            var numItems = pagerContainer.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
            var hiddenNumItems = pagerContainer.querySelectorAll('.e-numericitem.e-hide:not([style*="display: none"])');
            var hideFrom = numItems.length;
            var showFrom = 1;
            var bufferWidth = !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.element, "e-bigger")) ? 10 : 5;
            var NP = pagerContainer.querySelector(".e-np");
            var PP = pagerContainer.querySelector(".e-pp");
            var detailItems = this.element.querySelectorAll('.e-parentmsgbar:not(.e-hide):not([style*="display: none"]), .e-pagesizes:not(.e-hide):not([style*="display: none"])');
            var totDetailWidth_1 = 0;
            if (detailItems.length) {
                detailItems.forEach(function(item) {
                    totDetailWidth_1 += item.offsetWidth;
                });
                this.averageDetailWidth = totDetailWidth_1 / detailItems.length;
            }
            var totalWidth = 0;
            /**
             * Loop to calculate average width of numeric item.
             */ for(var i = 0; i < numItems.length; i++)totalWidth += numItems[parseInt(i.toString(), 10)].offsetWidth + parseFloat(getComputedStyle(numItems[parseInt(i.toString(), 10)]).marginLeft) + parseFloat(getComputedStyle(numItems[parseInt(i.toString(), 10)]).marginRight);
            var numericItemWidth = totalWidth / numItems.length;
            /**
             * Condition to hide numeric items when calculated actual width exceeds available pager space.
             */ if (pagerWidth > 0 && actualWidth >= pagerWidth - (numericItemWidth ? numericItemWidth : 0)) {
                this.isPagerResized = true;
                if (this.currentPage !== this.totalPages) (0, $4ZDHT.classList)(NP, [
                    "e-numericitem",
                    "e-pager-default"
                ], [
                    "e-nextprevitemdisabled",
                    "e-disable"
                ]);
                actualWidth = this.calculateActualWidth();
                var diff = Math.abs(actualWidth - pagerWidth);
                // To calculate number of numeric items need to be hidden.
                var numToHide = Math.ceil(diff / numericItemWidth);
                numToHide = numToHide === 0 ? 1 : numToHide > numItems.length ? numItems.length - 1 : numToHide;
                for(var i = 1; i <= numToHide; i++){
                    var hideIndex = hideFrom - parseInt(i.toString(), 10);
                    numItems = pagerContainer.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
                    if (this.currentPage !== 1 && (parseInt(numItems[Math.abs(hideIndex)].getAttribute("index"), 10) === this.currentPage || parseInt(numItems[numItems.length - 1].getAttribute("index"), 10) === this.currentPage)) {
                        hideIndex = 0;
                        (0, $4ZDHT.classList)(PP, [
                            "e-numericitem",
                            "e-pager-default"
                        ], [
                            "e-nextprevitemdisabled",
                            "e-disable"
                        ]);
                    }
                    if (numItems[Math.abs(hideIndex)] && !numItems[Math.abs(hideIndex)].classList.contains("e-currentitem")) numItems[Math.abs(hideIndex)].classList.add("e-hide");
                }
                numItems = pagerContainer.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
                // To hide Pager message elements when no more numeric items available to hide.
                if (numItems.length <= 1 && detailItems.length && window.innerWidth >= 768) {
                    var pagerDetailItemsWidth = this.calculateActualWidth();
                    if (pagerDetailItemsWidth > pagerWidth - bufferWidth) {
                        var detailtoHide = Math.floor((pagerWidth - (pagerDetailItemsWidth - totDetailWidth_1)) / this.averageDetailWidth);
                        detailtoHide = detailItems.length - detailtoHide;
                        for(var i = 0; i < (detailtoHide > detailItems.length ? detailItems.length : detailtoHide); i++)detailItems[parseInt(i.toString(), 10)].classList.add("e-hide");
                    }
                }
            } else if (actualWidth < pagerWidth && hiddenNumItems.length) {
                var diff = Math.abs(pagerWidth - actualWidth);
                var hiddenDetailItems = this.element.querySelectorAll(".e-parentmsgbar.e-hide, .e-pagesizes.e-hide");
                // To show Pager message elements.
                if (hiddenDetailItems.length && diff > this.averageDetailWidth + this.averageDetailWidth / 4) hiddenDetailItems[hiddenDetailItems.length - 1].classList.remove("e-hide");
                if (diff > numericItemWidth * 2 && !hiddenDetailItems.length && window.innerWidth >= 768) {
                    // To calculate number of numeric items need to be shown.
                    var numToShow = Math.floor(diff / (numericItemWidth + bufferWidth));
                    numToShow = numToShow > hiddenNumItems.length ? hiddenNumItems.length : numToShow - 1;
                    //Seggregating hidden num items as less index and greater index values than current page value.
                    var lesserIndexItems = Array.from(hiddenNumItems).filter(function(item) {
                        return parseInt(item.getAttribute("index"), 10) < _this.currentPage;
                    }).sort(function(a, b) {
                        return parseInt(b.getAttribute("index"), 10) - parseInt(a.getAttribute("index"), 10);
                    });
                    var greaterIndexItems = Array.from(hiddenNumItems).filter(function(item) {
                        return parseInt(item.getAttribute("index"), 10) > _this.currentPage;
                    });
                    var showItems = lesserIndexItems.length && lesserIndexItems || greaterIndexItems.length && greaterIndexItems;
                    for(var i = 1; i <= numToShow; i++){
                        var showItem = showItems && showItems[Math.abs(showFrom - i)];
                        if (showItem) {
                            showItem.classList.remove("e-hide");
                            if (showItem === showItems[showItems.length - 1]) showItems = null;
                        }
                    }
                }
            }
            numItems = pagerContainer.querySelectorAll('.e-numericitem:not(.e-hide):not([style*="display: none"]):not(.e-np):not(.e-pp)');
            if (numItems.length) {
                if (parseInt(numItems[numItems.length - 1].getAttribute("index"), 10) === this.totalPages) (0, $4ZDHT.classList)(NP, [
                    "e-nextprevitemdisabled",
                    "e-disable"
                ], [
                    "e-numericitem",
                    "e-pager-default"
                ]);
                if (parseInt(numItems[0].getAttribute("index"), 10) === 1) (0, $4ZDHT.classList)(PP, [
                    "e-nextprevitemdisabled",
                    "e-disable"
                ], [
                    "e-numericitem",
                    "e-pager-default"
                ]);
                var isLastSet = Array.from(numItems).some(function(item) {
                    return parseInt(item.getAttribute("index"), 10) === _this.totalPages;
                });
                var ppIndex = parseInt(numItems[0].getAttribute("index"), 10) - (isLastSet ? this.avgNumItems : numItems.length);
                PP.setAttribute("index", ppIndex < 1 ? "1" : ppIndex.toString());
                NP.setAttribute("index", (parseInt(numItems[numItems.length - 1].getAttribute("index"), 10) + 1).toString());
                this.avgNumItems = isLastSet ? this.avgNumItems : numItems.length;
            }
            /**
             * Condition to add adaptive class name and set pagermessage content with "/" when media query css has been applied.
             */ if (this.element.offsetWidth < 769 && window.getComputedStyle(this.element.querySelector(".e-mfirst")).getPropertyValue("display") !== "none" && this.pageSizes) {
                this.element.querySelector(".e-pagesizes").classList.remove("e-hide");
                this.element.querySelector(".e-parentmsgbar").classList.remove("e-hide");
                this.element.classList.add("e-adaptive");
                this.element.querySelector(".e-pagenomsg").innerHTML = this.element.offsetWidth < 481 ? this.currentPage + " / " + this.totalPages : this.pagerMessageModule.format(this.getLocalizedLabel("currentPageInfo"), [
                    this.totalRecordsCount === 0 ? 0 : this.currentPage,
                    this.totalPages || 0,
                    this.totalRecordsCount || 0
                ]) + " ";
            } else {
                this.element.classList.remove("e-adaptive");
                this.element.querySelector(".e-pagenomsg").innerHTML = this.pagerMessageModule.format(this.getLocalizedLabel("currentPageInfo"), [
                    this.totalRecordsCount === 0 ? 0 : this.currentPage,
                    this.totalPages || 0,
                    this.totalRecordsCount || 0
                ]) + " ";
            }
        }
    };
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Pager.prototype, "enableQueryString", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Pager.prototype, "enableExternalMessage", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Pager.prototype, "enablePagerMessage", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(12)
    ], Pager.prototype, "pageSize", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], Pager.prototype, "pageCount", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Pager.prototype, "currentPage", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)()
    ], Pager.prototype, "totalRecordsCount", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)()
    ], Pager.prototype, "externalMessage", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Pager.prototype, "pageSizes", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)()
    ], Pager.prototype, "template", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Pager.prototype, "customText", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Event)()
    ], Pager.prototype, "click", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Pager.prototype, "cssClass", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Event)()
    ], Pager.prototype, "dropDownChanged", void 0);
    $d9db24a736894064$var$__decorate([
        (0, $5rsSz.Event)()
    ], Pager.prototype, "created", void 0);
    Pager = $d9db24a736894064$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Pager);
    return Pager;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");

/**
 * `PagerDropDown` module handles selected pageSize from DropDownList.
 */ var $ff0d46110b802754$export$bfb95601d9e54d32 = /** @class */ function() {
    /**
     * Constructor for pager module
     *
     * @param {Pager} pagerModule - specifies the pagermodule
     * @hidden
     */ function PagerDropDown(pagerModule) {
        this.pagerModule = pagerModule;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     * @hidden
     */ PagerDropDown.prototype.getModuleName = function() {
        return "pagerdropdown";
    };
    /**
     * The function is used to render pager dropdown
     *
     * @returns {void}
     * @hidden
     */ PagerDropDown.prototype.render = function() {
        var pagerObj = this.pagerModule;
        this.pagerDropDownDiv = (0, $4ZDHT.createElement)("div", {
            className: "e-pagesizes"
        });
        var dropDownDiv = (0, $4ZDHT.createElement)("div", {
            className: "e-pagerdropdown"
        });
        var defaultTextDiv = (0, $4ZDHT.createElement)("div", {
            className: "e-pagerconstant"
        });
        var input = (0, $4ZDHT.createElement)("input", {
            attrs: {
                type: "text",
                tabindex: "-1"
            }
        });
        this.pagerCons = (0, $4ZDHT.createElement)("span", {
            className: "e-constant",
            innerHTML: this.pagerModule.getLocalizedLabel("pagerDropDown")
        });
        dropDownDiv.appendChild(input);
        defaultTextDiv.appendChild(this.pagerCons);
        this.pagerDropDownDiv.appendChild(dropDownDiv);
        this.pagerDropDownDiv.appendChild(defaultTextDiv);
        this.pagerModule.element.appendChild(this.pagerDropDownDiv);
        var pageSizesModule = this.pagerModule.pageSizes;
        var pageSizesArray = pageSizesModule.length ? this.convertValue(pageSizesModule) : [
            this.pagerModule.getLocalizedLabel("All"),
            "5",
            "10",
            "12",
            "20"
        ];
        var defaultValue = this.pagerModule.pageSize;
        this.dropDownListObject = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)({
            dataSource: pageSizesArray,
            value: defaultValue.toString(),
            change: this.onChange.bind(this),
            placeholder: this.pagerModule.getLocalizedLabel("pagerDropDown"),
            cssClass: this.pagerModule.cssClass ? "e-alldrop " + this.pagerModule.cssClass : "e-alldrop"
        });
        this.dropDownListObject.appendTo(input);
        if (pageSizesModule.length) this.dropDownListObject.element.value = this.pagerModule.pageSize.toString();
        pagerObj.pageSize = defaultValue;
        pagerObj.dataBind();
        pagerObj.trigger("dropDownChanged", {
            pageSize: defaultValue
        });
        this.addEventListener();
    };
    /**
     * For internal use only - Get the pagesize.
     *
     * @param {ChangeEventArgs} e - specifies the changeeventargs
     * @returns {void}
     * @private
     * @hidden
     */ PagerDropDown.prototype.onChange = function(e) {
        if (this.dropDownListObject.value === this.pagerModule.getLocalizedLabel("All")) {
            this.pagerModule.pageSize = this.pagerModule.totalRecordsCount;
            this.pagerModule.isAllPage = true;
            this.refresh();
            e.value = this.pagerModule.pageSize;
            if (document.getElementsByClassName("e-popup-open e-alldrop").length) document.getElementsByClassName("e-popup-open e-alldrop")[0].style.display = "none";
        } else {
            this.pagerModule.pageSize = parseInt(this.dropDownListObject.value, 10);
            this.pagerModule.isAllPage = false;
            if (this.pagerCons.innerHTML !== this.pagerModule.getLocalizedLabel("pagerDropDown")) this.refresh();
        }
        this.pagerModule.dataBind();
        if (!this.pagerModule.isCancel) this.pagerModule.trigger("dropDownChanged", {
            pageSize: this.pagerModule.isAllPage || this.pagerModule.isAllPage === undefined && this.dropDownListObject.value === this.pagerModule.getLocalizedLabel("All") ? this.pagerModule.totalRecordsCount : parseInt(this.dropDownListObject.value, 10)
        });
    };
    PagerDropDown.prototype.refresh = function() {
        if (this.pagerCons) {
            if (this.isPageSizeAll(this.pagerModule.pageSize)) {
                this.pagerCons.innerHTML = this.pagerModule.getLocalizedLabel("pagerAllDropDown");
                this.pagerCons.parentElement.classList.add("e-page-all");
            } else {
                this.pagerCons.innerHTML = this.pagerModule.getLocalizedLabel("pagerDropDown");
                this.pagerCons.parentElement.classList.remove("e-page-all");
            }
            this.pagerDropDownDiv.classList.remove("e-hide");
        }
    };
    PagerDropDown.prototype.beforeValueChange = function(prop) {
        if (typeof prop.newProp.value === "number") {
            var val = prop.newProp.value.toString();
            prop.newProp.value = val;
        }
    };
    PagerDropDown.prototype.convertValue = function(pageSizeValue) {
        var item = pageSizeValue;
        for(var i = 0; i < item.length; i++)item[parseInt(i.toString(), 10)] = parseInt(item[parseInt(i.toString(), 10)], 10) ? item[parseInt(i.toString(), 10)].toString() : this.pagerModule.getLocalizedLabel(item[parseInt(i.toString(), 10)]) !== "" ? this.pagerModule.getLocalizedLabel(item[parseInt(i.toString(), 10)]) : item[parseInt(i.toString(), 10)];
        return item;
    };
    PagerDropDown.prototype.isPageSizeAll = function(value) {
        var pageSizeNum = typeof value === "string" && value !== this.pagerModule.getLocalizedLabel("All") ? parseInt(value, 10) : value;
        if (pageSizeNum === this.pagerModule.totalRecordsCount || value === this.pagerModule.getLocalizedLabel("All")) return true;
        else return false;
    };
    PagerDropDown.prototype.setDropDownValue = function(prop, value) {
        if (this.dropDownListObject) {
            var isbeforeAll = this.pagerModule.isAllPage;
            this.pagerModule.isAllPage = this.isPageSizeAll(value);
            this.pagerModule.checkAll = isbeforeAll && this.pagerModule.isAllPage ? true : false;
            this.dropDownListObject["" + prop] = this.pagerModule.isAllPage ? this.pagerModule.getLocalizedLabel("All") : value;
        }
    };
    PagerDropDown.prototype.addEventListener = function() {
        this.dropDownListObject.on("beforeValueChange", this.beforeValueChange, this);
    };
    PagerDropDown.prototype.removeEventListener = function() {
        this.dropDownListObject.off("beforeValueChange", this.beforeValueChange);
    };
    /**
     * To destroy the Pagerdropdown
     *
     * @param {string} args - specifies the arguments
     * @param {string} args.requestType - specfies the request type
     * @returns {void}
     * @hidden
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PagerDropDown.prototype.destroy = function(args) {
        if (this.dropDownListObject && !this.dropDownListObject.isDestroyed) {
            this.removeEventListener();
            this.dropDownListObject.destroy();
            (0, $4ZDHT.remove)(this.pagerDropDownDiv);
        }
    };
    return PagerDropDown;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
/**
 * `ExternalMessage` module is used to display user provided message.
 */ var $814b7820bc5da712$export$bc23ef590a3b9d6d = /** @class */ function() {
    /**
     * Constructor for externalMessage module
     *
     * @param {Pager} pagerModule - specifies the pagermodule
     * @hidden
     */ function ExternalMessage(pagerModule) {
        this.pagerModule = pagerModule;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ ExternalMessage.prototype.getModuleName = function() {
        return "externalMessage";
    };
    /**
     * The function is used to render pager externalMessage
     *
     * @returns {void}
     * @hidden
     */ ExternalMessage.prototype.render = function() {
        this.element = (0, $4ZDHT.createElement)("div", {
            className: "e-pagerexternalmsg",
            attrs: {
                "aria-label": this.pagerModule.getLocalizedLabel("ExternalMsg")
            }
        });
        this.pagerModule.element.appendChild(this.element);
        this.refresh();
    };
    /**
     * Refreshes the external message of Pager.
     *
     * @returns {void}
     */ ExternalMessage.prototype.refresh = function() {
        if (this.pagerModule.externalMessage && this.pagerModule.externalMessage.toString().length) {
            this.showMessage();
            this.element.innerHTML = this.pagerModule.externalMessage;
        } else this.hideMessage();
    };
    /**
     * Hides the external message of Pager.
     *
     * @returns {void}
     */ ExternalMessage.prototype.hideMessage = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.element)) this.element.style.display = "none";
    };
    /**
     * Shows the external message of the Pager.
     *
     * @returns {void}s
     */ ExternalMessage.prototype.showMessage = function() {
        this.element.style.display = "";
    };
    /**
     * To destroy the PagerMessage
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ ExternalMessage.prototype.destroy = function() {
        if (this.element && this.element.parentElement) (0, $4ZDHT.remove)(this.element);
    };
    return ExternalMessage;
}();





/**
 * The `Page` module is used to render pager and handle paging action.
 */ var $5d65e63dd7eec2c1$export$6955bcca4cd3539f = /** @class */ function() {
    /**
     * Constructor for the Grid paging module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {PageSettingsModel} pageSettings - specifies the PageSettingsModel
     * @hidden
     */ function Page(parent, pageSettings) {
        this.isInitialRender = true;
        /** @hidden */ this.isCancel = false;
        (0, $d9db24a736894064$export$57625d62e5386b09).Inject((0, $814b7820bc5da712$export$bc23ef590a3b9d6d), (0, $ff0d46110b802754$export$bfb95601d9e54d32));
        this.parent = parent;
        this.pageSettings = pageSettings;
        this.addEventListener();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Page.prototype.getModuleName = function() {
        return "pager";
    };
    /**
     * The function used to render pager from grid pageSettings
     *
     * @returns {void}
     * @hidden
     */ Page.prototype.render = function() {
        var gObj = this.parent;
        this.pagerDestroy();
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.pagerTemplate)) {
            this.pageSettings.template = this.parent.pagerTemplate;
            this.parent.pageTemplateChange = true;
        }
        this.element = this.parent.createElement("div", {
            className: "e-gridpager"
        });
        var pagerObj = (0, $748c2240e597a9b7$export$8b58be045bf06082)({}, (0, $3EnZW.extend)({}, (0, $748c2240e597a9b7$export$8d71c07056cfde24)(this.pageSettings)), {
            click: this.clickHandler.bind(this),
            dropDownChanged: this.onSelect.bind(this),
            enableRtl: gObj.enableRtl,
            locale: gObj.locale,
            created: this.addAriaAttr.bind(this)
        }, [
            "parentObj",
            "propName"
        ]);
        pagerObj.cssClass = this.parent.cssClass ? this.parent.cssClass : "";
        this.pagerObj = new (0, $d9db24a736894064$export$57625d62e5386b09)(pagerObj, undefined, this.parent);
        this.pagerObj.root = gObj.root ? gObj.root : gObj;
        this.pagerObj.hasParent = true;
        this.pagerObj.on($17b89d3b1fc93cdb$export$40d5e22137cfb455, this.renderReactPagerTemplate, this);
        this.pagerObj.allowServerDataBinding = false;
    };
    Page.prototype.onSelect = function(e) {
        this.pageSettings.pageSize = e.pageSize;
        if (!this.isInitialLoad) this.pageSettings.currentPage = 1;
    };
    Page.prototype.addAriaAttr = function() {
        if (!this.pageSettings.template) {
            var numericContainerNew = this.parent.createElement("div", {
                className: "e-numericcontainer"
            });
            var pagerContainer = this.element.querySelector(".e-pagercontainer");
            var frag = document.createDocumentFragment();
            var numericContainer = this.element.querySelector(".e-numericcontainer");
            var links = numericContainer.querySelectorAll("a");
            for(var i = 0; i < links.length; i++){
                if (this.parent.getContentTable()) links[parseInt(i.toString(), 10)].setAttribute("aria-owns", this.parent.getContentTable().id + " " + (i + 1));
                else links[parseInt(i.toString(), 10)].setAttribute("aria-owns", this.parent.element.getAttribute("id") + "_content_table" + " " + (i + 1));
                var numericContainerDiv = this.parent.createElement("div");
                numericContainerDiv.appendChild(links[parseInt(i.toString(), 10)]);
                frag.appendChild(numericContainerDiv);
            }
            numericContainerNew.appendChild(frag);
            pagerContainer.replaceChild(numericContainerNew, numericContainer);
            var classList = [
                ".e-mfirst",
                ".e-mprev",
                ".e-first",
                ".e-prev",
                ".e-next",
                ".e-last",
                ".e-mnext",
                ".e-mlast"
            ];
            for(var j = 0; j < classList.length; j++){
                var element = this.element.querySelector(classList[parseInt(j.toString(), 10)]);
                if (this.parent.getContentTable()) element.setAttribute("aria-owns", this.parent.getContentTable().id + classList[parseInt(j.toString(), 10)].replace(".e-", " "));
            }
        }
    };
    Page.prototype.dataReady = function(e) {
        this.updateModel(e);
    };
    /**
     * Refreshes the page count, pager information, and external message.
     *
     * @returns {void}
     */ Page.prototype.refresh = function() {
        this.pagerObj.refresh();
    };
    /**
     * Navigates to the target page according to the given number.
     *
     * @param  {number} pageNo - Defines the page number to navigate.
     * @returns {void}
     */ Page.prototype.goToPage = function(pageNo) {
        this.pagerObj.goToPage(pageNo);
    };
    /**
     * @param {number} pageSize - specifies the page size
     * @returns {void}
     * @hidden
     */ Page.prototype.setPageSize = function(pageSize) {
        this.pagerObj.setPageSize(pageSize);
    };
    /**
     * The function used to update pageSettings model
     *
     * @param {NotifyArgs} e - specfies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Page.prototype.updateModel = function(e) {
        this.parent.pageSettings.totalRecordsCount = e.count;
        var isAddAction = e.action === "add" && e.requestType === "save" || e.requestType === "batchsave";
        if (this.pagerObj.isAllPage && !isAddAction) this.parent.pageSettings.pageSize = this.parent.pageSettings.totalRecordsCount;
        if (isAddAction) {
            if (this.pagerObj.isAllPage && e.count === this.pageSettings.pageSize) this.pagerObj.setProperties({
                pageSize: e.count
            }, true);
        }
        this.parent.dataBind();
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Page.prototype.onActionComplete = function(e) {
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, {
            currentPage: this.parent.pageSettings.currentPage,
            requestType: "paging",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        }));
    };
    /**
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Page.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        var newProp = e.properties;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            this.pagerObj["" + prop] = newProp["" + prop];
        }
        this.pagerObj.dataBind();
    };
    Page.prototype.clickHandler = function(e) {
        var gObj = this.parent;
        if (this.isForceCancel || (0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj) && !gObj.prevPageMoving && !this.isCancel) {
            if (!this.isForceCancel) {
                if (!(0, $3EnZW.isNullOrUndefined)(e.newProp) && !(0, $3EnZW.isNullOrUndefined)(e.newProp.pageSize)) {
                    gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                        instance: this,
                        handler: this.setPageSize,
                        arg1: e.newProp.pageSize
                    });
                    this.pagerObj.setProperties({
                        pageSize: e.oldProp.pageSize
                    }, true);
                    this.parent.setProperties({
                        pageSettings: {
                            pageSize: e.oldProp.pageSize
                        }
                    }, true);
                    this.pagerObj.setProperties({
                        currentPage: gObj.pageSettings.currentPage === this.pagerObj.currentPage ? this.pagerObj.previousPageNo : gObj.pageSettings.currentPage
                    }, true);
                } else if (e.currentPage) {
                    gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                        instance: this,
                        handler: this.goToPage,
                        arg1: e.currentPage
                    });
                    this.pagerObj.currentPage = gObj.pageSettings.currentPage === this.pagerObj.currentPage ? this.pagerObj.previousPageNo : gObj.pageSettings.currentPage;
                }
                this.isForceCancel = true;
                this.pagerObj.dataBind();
            } else this.isForceCancel = false;
            e.cancel = true;
            return;
        }
        gObj.pageSettings.pageSize = this.pagerObj.pageSize;
        gObj.prevPageMoving = false;
        var prevPage = this.pageSettings.currentPage;
        var args = {
            cancel: false,
            requestType: "paging",
            previousPage: prevPage,
            currentPage: e.currentPage,
            pageSize: gObj.pageSettings.pageSize,
            type: $17b89d3b1fc93cdb$export$df204737a6131aab
        };
        if (!this.isCancel) {
            this.pageSettings.currentPage = e.currentPage;
            this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
            gObj.pageRequireRefresh = false;
        }
        if (args.cancel) {
            e.cancel = true;
            this.parent.setProperties({
                pageSettings: {
                    currentPage: prevPage
                }
            }, true);
            this.pagerObj.setProperties({
                currentPage: prevPage
            }, true);
            this.isCancel = true;
            return;
        }
        this.isCancel = false;
        this.parent.requestTypeAction = "paging";
    };
    Page.prototype.keyPressHandler = function(e) {
        if (e.action in $5d65e63dd7eec2c1$var$keyActions) {
            e.preventDefault();
            this.element.querySelector($5d65e63dd7eec2c1$var$keyActions[e.action]).click();
        }
    };
    /**
     * Defines the text of the external message.
     *
     * @param  {string} message - Defines the message to update.
     * @returns {void}
     */ Page.prototype.updateExternalMessage = function(message) {
        if (!this.pagerObj.enableExternalMessage) {
            this.pagerObj.enableExternalMessage = true;
            this.pagerObj.dataBind();
        }
        this.pagerObj.externalMessage = message;
        this.pagerObj.dataBind();
    };
    Page.prototype.appendToElement = function() {
        this.isInitialLoad = true;
        this.parent.element.appendChild(this.element);
        this.parent.setGridPager(this.element);
        this.pagerObj.isReact = this.parent.isReact;
        this.pagerObj.isVue = this.parent.isVue || this.parent.parentDetails && this.parent.parentDetails.parentInstObj && this.parent.parentDetails.parentInstObj.isVue;
        this.pagerObj.appendTo(this.element);
        this.isInitialLoad = false;
    };
    Page.prototype.enableAfterRender = function(e) {
        if (e.module === this.getModuleName() && e.enable) {
            this.render();
            this.appendToElement();
            if (this.isReactTemplate()) {
                this.pagerObj.updateTotalPages();
                this.created();
            }
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Page.prototype.addEventListener = function() {
        this.handlers = {
            load: this.render,
            end: this.appendToElement,
            ready: this.dataReady,
            complete: this.onActionComplete,
            updateLayout: this.enableAfterRender,
            inboundChange: this.onPropertyChanged,
            keyPress: this.keyPressHandler,
            created: this.created
        };
        if (this.parent.isDestroyed) return;
        if (this.parent.isReact || this.parent.isVue) this.parent.addEventListener($1b5568e76cdae6d4$export$185802fd694ee1f5, this.handlers.created.bind(this));
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$b70fe0c8c3456154,
                handler: this.handlers.load
            },
            {
                event: $17b89d3b1fc93cdb$export$5d4840440f592fca,
                handler: this.handlers.end
            },
            {
                event: $17b89d3b1fc93cdb$export$32ed53e78850bc76,
                handler: this.handlers.ready
            },
            {
                event: $17b89d3b1fc93cdb$export$f8b3c4e59d5a531a,
                handler: this.handlers.complete
            },
            {
                event: $17b89d3b1fc93cdb$export$27ad5926bed65d9,
                handler: this.handlers.updateLayout
            },
            {
                event: $17b89d3b1fc93cdb$export$f4000f83c4e293d0,
                handler: this.handlers.inboundChange
            },
            {
                event: $17b89d3b1fc93cdb$export$e09b512eecac7579,
                handler: this.handlers.keyPress
            },
            {
                event: $17b89d3b1fc93cdb$export$b1fb4cac938035f7,
                handler: this.destroy
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
    };
    Page.prototype.created = function() {
        if (this.isInitialRender && this.isReactTemplate()) {
            this.isInitialRender = false;
            this.renderReactPagerTemplate();
        }
    };
    Page.prototype.isReactTemplate = function() {
        return (this.parent.isReact || this.parent.isVue) && this.pagerObj.template && typeof this.pagerObj.template !== "string";
    };
    Page.prototype.renderReactPagerTemplate = function() {
        if (!this.isInitialRender && this.isReactTemplate()) {
            var result = void 0;
            this.parent.destroyTemplate([
                "pagerTemplate"
            ]);
            this.element.classList.add("e-pagertemplate");
            this.pagerObj.compile(this.pagerObj.template);
            var page = this.parent.pageSettings;
            var data = {
                currentPage: page.currentPage,
                pageSize: page.pageSize,
                pageCount: page.pageCount,
                totalRecordsCount: page.totalRecordsCount,
                totalPages: this.pagerObj.totalPages
            };
            var tempId = this.parent.id + "_pagertemplate";
            if (this.parent.isReact) {
                this.pagerObj.templateFn(data, this.parent, "pagerTemplate", tempId, null, null, this.pagerObj.element);
                this.parent.renderTemplates();
            } else {
                result = this.pagerObj.templateFn(data, this.parent, "pagerTemplate");
                (0, $748c2240e597a9b7$export$6dfa4c34d2d32617)(this.pagerObj.element, result);
            }
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Page.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        if (this.parent.isReact || this.parent.isVue) this.parent.removeEventListener($1b5568e76cdae6d4$export$185802fd694ee1f5, this.handlers.created);
        this.parent.off($17b89d3b1fc93cdb$export$40d5e22137cfb455, this.renderReactPagerTemplate);
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, false);
    };
    /**
     * To destroy the pager
     *
     * @returns {void}
     * @hidden
     */ Page.prototype.destroy = function() {
        this.removeEventListener();
        if (this.isReactTemplate()) this.parent.destroyTemplate([
            "pagerTemplate"
        ]);
        this.pagerObj.destroy();
    };
    Page.prototype.pagerDestroy = function() {
        if (this.pagerObj && !this.pagerObj.isDestroyed) {
            this.pagerObj.destroy();
            (0, $4ZDHT.remove)(this.element);
        }
    };
    return Page;
}();
/**
 * @hidden
 */ var $5d65e63dd7eec2c1$var$keyActions = {
    pageUp: ".e-prev",
    pageDown: ".e-next",
    ctrlAltPageDown: ".e-last",
    ctrlAltPageUp: ".e-first",
    altPageUp: ".e-pp",
    altPageDown: ".e-np"
};

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



/**
 *
 * The `Reorder` module is used for reordering columns.
 */ var $3bf4dd04897d8ed7$export$335fca4219867448 = /** @class */ function() {
    /**
     * Constructor for the Grid reorder module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function Reorder(parent) {
        this.idx = 0;
        this.parent = parent;
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$b0a9271d3fcee092, this.headerDrop, this);
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender, this);
        this.parent.on($17b89d3b1fc93cdb$export$82efde204a1957f2, this.onActionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, this.drag, this);
        this.parent.on($17b89d3b1fc93cdb$export$e7b0ce279c912385, this.dragStart, this);
        this.parent.on($17b89d3b1fc93cdb$export$d8cb7828e3a46f05, this.dragStop, this);
        this.parent.on($17b89d3b1fc93cdb$export$b0a9271d3fcee092, this.headerDrop, this);
        this.parent.on($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.createReorderElement, this);
        this.parent.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyPressHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
    }
    Reorder.prototype.chkDropPosition = function(srcElem, destElem) {
        var col = this.parent.getColumnByUid(destElem.firstElementChild.getAttribute("e-mappinguid"));
        var bool = col ? !col.lockColumn : true;
        return (srcElem.parentElement.isEqualNode(destElem.parentElement) || this.parent.enableColumnVirtualization || this.parent.isFrozenGrid() && Array.prototype.indexOf.call((0, $4ZDHT.closest)(srcElem, "thead").children, srcElem.parentElement) === Array.prototype.indexOf.call((0, $4ZDHT.closest)(destElem, "thead").children, destElem.parentElement)) && this.targetParentContainerIndex(srcElem, destElem) > -1 && bool;
    };
    Reorder.prototype.chkDropAllCols = function(srcElem, destElem) {
        var isFound;
        var headers = this.getHeaderCells();
        var header;
        while(!isFound && headers.length > 0){
            header = headers.pop();
            isFound = srcElem !== header && this.targetParentContainerIndex(srcElem, destElem) > -1;
        }
        return isFound;
    };
    Reorder.prototype.findColParent = function(col, cols, parent) {
        // eslint-disable-next-line no-self-assign
        parent;
        for(var i = 0, len = cols.length; i < len; i++){
            if (col === cols[parseInt(i.toString(), 10)]) return true;
            else if (cols[parseInt(i.toString(), 10)].columns) {
                var cnt = parent.length;
                parent.push(cols[parseInt(i.toString(), 10)]);
                if (!this.findColParent(col, cols[parseInt(i.toString(), 10)].columns, parent)) parent.splice(cnt, parent.length - cnt);
                else return true;
            }
        }
        return false;
    };
    Reorder.prototype.getColumnsModel = function(cols, isNotStackedHeader) {
        var columnModel = [];
        var subCols = [];
        for(var i = 0, len = cols.length; i < len; i++)if (!(0, $3EnZW.isNullOrUndefined)(cols[parseInt(i.toString(), 10)])) {
            if (cols[parseInt(i.toString(), 10)].visible) columnModel.push(cols[parseInt(i.toString(), 10)]);
            else if (isNotStackedHeader) columnModel.push(cols[parseInt(i.toString(), 10)]);
            if (cols[parseInt(i.toString(), 10)].columns) subCols = subCols.concat(cols[parseInt(i.toString(), 10)].columns);
        }
        if (subCols.length) columnModel = columnModel.concat(this.getColumnsModel(subCols));
        return columnModel;
    };
    Reorder.prototype.headerDrop = function(e) {
        var gObj = this.parent;
        var dropElement = this.element.querySelector(".e-headercelldiv") || this.element.querySelector(".e-stackedheadercelldiv");
        var uId = dropElement.getAttribute("e-mappinguid");
        var column = gObj.getColumnByUid(uId);
        if (!(0, $4ZDHT.closest)(e.target, "th") || !(0, $3EnZW.isNullOrUndefined)(column) && (!column.allowReordering || column.lockColumn)) {
            this.parent.log("action_disabled_column", {
                moduleName: this.getModuleName(),
                column: column
            });
            return;
        }
        var destElem = (0, $4ZDHT.closest)(e.target, ".e-headercell");
        var destElemDiv = destElem.querySelector(".e-headercelldiv") || destElem.querySelector(".e-stackedheadercelldiv");
        var destElemUid = destElemDiv.getAttribute("e-mappinguid");
        if (!(0, $3EnZW.isNullOrUndefined)(destElemUid)) {
            var destColumn = gObj.getColumnByUid(destElemUid);
            if ((0, $3EnZW.isNullOrUndefined)(destColumn) || !destColumn.allowReordering || destColumn.lockColumn) {
                this.parent.log("action_disabled_column", {
                    moduleName: this.getModuleName(),
                    column: column,
                    destColumn: destColumn
                });
                return;
            }
        }
        if (destElem && !(!this.chkDropPosition(this.element, destElem) || !this.chkDropAllCols(this.element, destElem))) {
            if (this.parent.enableColumnVirtualization) {
                var columns = this.parent.columns;
                var sourceUid_1 = this.element.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");
                var col = this.parent.columns.filter(function(col) {
                    return col.uid === sourceUid_1;
                });
                var colMatchIndex_1 = null;
                var column_1 = col[0];
                var destUid_1 = destElem.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");
                columns.some(function(col, index) {
                    if (col.uid === destUid_1) {
                        colMatchIndex_1 = index;
                        return col.uid === destUid_1;
                    }
                    return false;
                });
                if (!(0, $3EnZW.isNullOrUndefined)(colMatchIndex_1)) this.moveColumns(colMatchIndex_1, column_1);
            } else {
                var newIndex = this.targetParentContainerIndex(this.element, destElem);
                var uid = this.element.firstElementChild.getAttribute("e-mappinguid");
                this.destElement = destElem;
                this.parent.notify($17b89d3b1fc93cdb$export$f74f9215dc0c5d14, {
                    ele: destElem
                });
                if (uid) this.moveColumns(newIndex, this.parent.getColumnByUid(uid));
                else {
                    var headers = this.getHeaderCells();
                    var oldIdx = (0, $748c2240e597a9b7$export$54176e6d71b37692)(this.element, headers);
                    var columns = this.getColumnsModel(this.parent.columns);
                    this.moveColumns(newIndex, columns[parseInt(oldIdx.toString(), 10)]);
                }
            }
        }
    };
    Reorder.prototype.isActionPrevent = function(gObj) {
        return (0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj);
    };
    Reorder.prototype.moveColumns = function(destIndex, column, reorderByColumn, preventRefresh) {
        var gObj = this.parent;
        if (this.isActionPrevent(gObj)) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.moveColumns,
                arg1: destIndex,
                arg2: column
            });
            return;
        }
        var parent = this.getColParent(column, this.parent.columns);
        var cols = parent ? parent.columns : this.parent.columns;
        var srcIdx = (0, $748c2240e597a9b7$export$6632823c2c02cb2c)(column, cols);
        if ((parent || this.parent.lockcolPositionCount) && !reorderByColumn && !this.parent.enableColumnVirtualization) {
            for(var i = 0; i < cols.length; i++)if (cols[parseInt(i.toString(), 10)].field === column.field) {
                srcIdx = i;
                break;
            }
            var col = this.parent.getColumnByUid(this.destElement.firstElementChild.getAttribute("e-mappinguid"));
            if (col) {
                for(var i = 0; i < cols.length; i++)if (cols[parseInt(i.toString(), 10)].field === col.field) {
                    destIndex = i;
                    break;
                }
            } else {
                for(var i = 0; i < cols.length; i++)if (cols[parseInt(i.toString(), 10)].headerText === this.destElement.innerText.trim()) destIndex = i;
            }
        }
        if (!gObj.allowReordering || srcIdx === destIndex || srcIdx === -1 || destIndex === -1) return;
        cols.splice(destIndex, 0, cols.splice(srcIdx, 1)[0]);
        var args = {
            column: column,
            destIndex: destIndex,
            columns: cols,
            parent: parent,
            cancel: false
        };
        gObj.notify($17b89d3b1fc93cdb$export$4d730823cc408798, args);
        if (args.cancel) return;
        if (this.parent.isFrozenGrid()) {
            if (this.parent.frozenColumns) {
                for(var i = 0; i < cols.length; i++)if (cols[parseInt(i.toString(), 10)].freeze === "Left") cols[parseInt(i.toString(), 10)].freeze = undefined;
            } else if (!(parent && parent.columns)) {
                if (this.parent.getFrozenLeftCount() > destIndex) column.freeze = "Left";
                else if (cols.length - this.parent.getFrozenRightColumnsCount() <= destIndex) column.freeze = "Right";
                else column.freeze = column.freeze === "Fixed" ? "Fixed" : undefined;
            }
        }
        gObj.getColumns(true);
        gObj.notify($17b89d3b1fc93cdb$export$cd2e9ca316e8efca, {
            fromIndex: destIndex,
            toIndex: srcIdx
        });
        if (preventRefresh !== false) gObj.notify($17b89d3b1fc93cdb$export$80cded91831c5507, {
            type: $17b89d3b1fc93cdb$export$df204737a6131aab,
            requestType: "reorder",
            fromIndex: destIndex,
            toIndex: srcIdx,
            toColumnUid: column.uid
        });
        if (this.parent.isFrozenGrid()) {
            var cols_1 = this.parent.columns;
            this.idx = 0;
            this.refreshColumnIndex(cols_1);
            this.parent.notify($17b89d3b1fc93cdb$export$cdacb1a8abdadeeb, {});
        }
    };
    Reorder.prototype.refreshColumnIndex = function(cols) {
        for(var i = 0; i < cols.length; i++){
            cols[parseInt(i.toString(), 10)].index = this.idx;
            this.idx++;
            if (cols[parseInt(i.toString(), 10)].columns && cols[parseInt(i.toString(), 10)].columns.length) this.refreshColumnIndex(cols[parseInt(i.toString(), 10)].columns);
        }
    };
    Reorder.prototype.targetParentContainerIndex = function(srcElem, destElem) {
        var cols = this.parent.columns;
        var headers = this.getHeaderCells();
        var stackedHdrColumn = this.parent.getStackedColumns(cols);
        var stackedCols = [];
        if (stackedHdrColumn.length) stackedCols = this.getAllStackedheaderParentColumns(headers);
        var flatColumns = stackedHdrColumn.length && stackedCols.length ? this.getColumnsModel(stackedCols) : this.getColumnsModel(cols, true);
        var parent = this.getColParent(flatColumns[(0, $748c2240e597a9b7$export$54176e6d71b37692)(srcElem, headers)], cols);
        cols = parent ? parent.columns : cols;
        return (0, $748c2240e597a9b7$export$6632823c2c02cb2c)(flatColumns[(0, $748c2240e597a9b7$export$54176e6d71b37692)(destElem, headers)], cols);
    };
    Reorder.prototype.getAllStackedheaderParentColumns = function(headers) {
        var stackedCols = [];
        for(var i = 0; i < headers.length; i++){
            if (headers[parseInt(i.toString(), 10)].classList.contains("e-hide")) {
                headers.splice(i, 1);
                i--;
            } else if (headers[parseInt(i.toString(), 10)].closest("thead").firstChild === headers[parseInt(i.toString(), 10)].parentElement) stackedCols.push(this.parent.getColumnByUid(headers[parseInt(i.toString(), 10)].firstElementChild.getAttribute("e-mappinguid")));
        }
        return stackedCols;
    };
    Reorder.prototype.getHeaderCells = function() {
        return [].slice.call(this.parent.element.getElementsByClassName("e-headercell"));
    };
    Reorder.prototype.getColParent = function(column, columns) {
        var parents = [];
        this.findColParent(column, columns, parents);
        return parents[parents.length - 1];
    };
    Reorder.prototype.reorderSingleColumn = function(fromFName, toFName) {
        var fColumn = this.parent.enableColumnVirtualization ? this.parent.columns.filter(function(col) {
            return col.field === fromFName;
        })[0] : this.parent.getColumnByField(fromFName);
        var toColumn = this.parent.enableColumnVirtualization ? this.parent.columns.filter(function(col) {
            return col.field === toFName;
        })[0] : this.parent.getColumnByField(toFName);
        if (!(0, $3EnZW.isNullOrUndefined)(fColumn) && (!fColumn.allowReordering || fColumn.lockColumn) || !(0, $3EnZW.isNullOrUndefined)(toColumn) && (!toColumn.allowReordering || toColumn.lockColumn)) {
            this.parent.log("action_disabled_column", {
                moduleName: this.getModuleName(),
                column: fColumn,
                destColumn: toColumn
            });
            return;
        }
        var column = toColumn;
        var parent = this.getColParent(column, this.parent.columns);
        var columns = parent ? parent.columns : this.parent.columns;
        var destIndex = (0, $748c2240e597a9b7$export$6632823c2c02cb2c)(column, columns);
        if (destIndex > -1) this.moveColumns(destIndex, fColumn, true);
    };
    Reorder.prototype.reorderMultipleColumns = function(fromFNames, toFName) {
        var toIndex = this.parent.getColumnIndexByField(toFName);
        var toColumn = this.parent.getColumnByField(toFName);
        if (toIndex < 0 || !(0, $3EnZW.isNullOrUndefined)(toColumn) && (!toColumn.allowReordering || toColumn.lockColumn)) return;
        for(var i = 0; i < fromFNames.length; i++){
            var column = this.parent.getColumnByField(fromFNames[parseInt(i.toString(), 10)]);
            if (!(0, $3EnZW.isNullOrUndefined)(column) && (!column.allowReordering || column.lockColumn)) return;
        }
        for(var i = 0; i < fromFNames.length; i++){
            var column = this.parent.getColumnByIndex(toIndex);
            var parent_1 = this.getColParent(column, this.parent.columns);
            var columns = parent_1 ? parent_1.columns : this.parent.columns;
            var destIndex = (0, $748c2240e597a9b7$export$6632823c2c02cb2c)(column, columns);
            if (destIndex > -1) this.moveColumns(destIndex, this.parent.getColumnByField(fromFNames[parseInt(i.toString(), 10)]), true, true);
            if (this.parent.getColumnIndexByField(fromFNames[i + 1]) >= destIndex) toIndex++; //R to L
        }
    };
    Reorder.prototype.moveTargetColumn = function(column, toIndex) {
        if (toIndex > -1) this.moveColumns(toIndex, column, true);
    };
    Reorder.prototype.reorderSingleColumnByTarget = function(fieldName, toIndex) {
        this.moveTargetColumn(this.parent.getColumnByField(fieldName), toIndex);
    };
    Reorder.prototype.reorderMultipleColumnByTarget = function(fieldName, toIndex) {
        for(var i = 0; i < fieldName.length; i++)this.reorderSingleColumnByTarget(fieldName[parseInt(i.toString(), 10)], toIndex);
    };
    /**
     * Changes the position of the Grid columns by field names.
     *
     * @param  {string | string[]} fromFName - Defines the origin field names.
     * @param  {string} toFName - Defines the destination field name.
     * @returns {void}
     */ Reorder.prototype.reorderColumns = function(fromFName, toFName) {
        if (typeof fromFName === "string") {
            this.reorderSingleColumn(fromFName, toFName);
            this.fromCol = fromFName;
        } else {
            this.reorderMultipleColumns(fromFName, toFName);
            this.fromCol = fromFName[0];
        }
    };
    /**
     * Changes the position of the Grid columns by field index.
     *
     * @param  {number} fromIndex - Defines the origin field index.
     * @param  {number} toIndex - Defines the destination field index.
     * @returns {void}
     */ Reorder.prototype.reorderColumnByIndex = function(fromIndex, toIndex) {
        this.moveTargetColumn(this.parent.getColumnByIndex(fromIndex), toIndex);
    };
    /**
     * Changes the position of the Grid columns by field index.
     *
     * @param  {string | string[]} fieldName - Defines the field name.
     * @param  {number} toIndex - Defines the destination field index.
     * @returns {void}
     */ Reorder.prototype.reorderColumnByTargetIndex = function(fieldName, toIndex) {
        if (typeof fieldName === "string") this.reorderSingleColumnByTarget(fieldName, toIndex);
        else this.reorderMultipleColumnByTarget(fieldName, toIndex);
    };
    Reorder.prototype.enableAfterRender = function(e) {
        if (e.module === this.getModuleName() && e.enable) this.createReorderElement();
    };
    Reorder.prototype.createReorderElement = function(e) {
        if (e && e.args && e.args.isXaxis) this.setDisplay("none");
        var header = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
        this.upArrow = header.appendChild(this.parent.createElement("div", {
            className: "e-icons e-icon-reorderuparrow e-reorderuparrow",
            attrs: {
                style: "display:none"
            }
        }));
        this.downArrow = header.appendChild(this.parent.createElement("div", {
            className: "e-icons e-icon-reorderdownarrow e-reorderdownarrow",
            attrs: {
                style: "display:none"
            }
        }));
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specified the NotifyArgs
     * @returns {void}
     * @hidden
     */ Reorder.prototype.onActionComplete = function(e) {
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, {
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        }));
        var target = this.fromCol && this.parent.getColumnHeaderByField(this.fromCol);
        if (target) this.parent.focusModule.onClick({
            target: target
        }, true);
    };
    /**
     * To destroy the reorder
     *
     * @returns {void}
     * @hidden
     */ Reorder.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (this.parent.isDestroyed || !gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        if (this.upArrow.parentNode) (0, $4ZDHT.remove)(this.upArrow);
        if (this.downArrow.parentNode) (0, $4ZDHT.remove)(this.downArrow);
        this.parent.off($17b89d3b1fc93cdb$export$b0a9271d3fcee092, this.headerDrop);
        this.parent.off($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender);
        this.parent.off($17b89d3b1fc93cdb$export$82efde204a1957f2, this.onActionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, this.drag);
        this.parent.off($17b89d3b1fc93cdb$export$e7b0ce279c912385, this.dragStart);
        this.parent.off($17b89d3b1fc93cdb$export$d8cb7828e3a46f05, this.dragStop);
        this.parent.off($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.createReorderElement);
        this.parent.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyPressHandler);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    //call ejdrag and drop destroy
    };
    Reorder.prototype.keyPressHandler = function(e) {
        var gObj = this.parent;
        var isMacLike = /(Mac)/i.test(navigator.platform);
        if (isMacLike && e.metaKey) {
            if (e.action === "leftArrow") e.action = "ctrlLeftArrow";
            else if (e.action === "rightArrow") e.action = "ctrlRightArrow";
        }
        switch(e.action){
            case "ctrlLeftArrow":
            case "ctrlRightArrow":
                // eslint-disable-next-line no-case-declarations
                var element = gObj.focusModule.currentInfo.element;
                if (element && element.classList.contains("e-headercell")) {
                    var column = gObj.getColumnByUid(element.firstElementChild.getAttribute("e-mappinguid"));
                    var visibleCols = gObj.getVisibleColumns();
                    var index = visibleCols.indexOf(column);
                    var toCol = e.action === "ctrlLeftArrow" ? visibleCols[index - 1] : visibleCols[index + 1];
                    if (toCol && toCol.field && column.field) this.reorderColumns(column.field, toCol.field);
                }
                break;
        }
    };
    Reorder.prototype.drag = function(e) {
        var gObj = this.parent;
        var target = e.target;
        var closest = (0, $4ZDHT.closest)(target, ".e-headercell:not(.e-stackedHeaderCell)");
        var cloneElement = gObj.element.querySelector(".e-cloneproperties");
        var content = gObj.getContent().firstElementChild;
        var isLeft = this.x > (0, $748c2240e597a9b7$export$1690e12b840569b9)(e.event).x + content.scrollLeft;
        (0, $4ZDHT.removeClass)([].slice.call(gObj.getHeaderTable().getElementsByClassName("e-reorderindicate")), [
            "e-reorderindicate"
        ]);
        this.setDisplay("none");
        this.stopTimer();
        (0, $4ZDHT.classList)(cloneElement, [
            "e-defaultcur"
        ], [
            "e-notallowedcur"
        ]);
        this.updateScrollPostion(e.event);
        if (closest && !closest.isEqualNode(this.element)) {
            target = closest;
            //consider stacked, detail header cell
            var uid = target.querySelector(".e-headercelldiv, .e-stackedheadercelldiv").getAttribute("e-mappinguid");
            if (!(!this.chkDropPosition(this.element, target) || !this.chkDropAllCols(this.element, target)) && gObj.getColumnByUid(uid).allowReordering && e.column.allowReordering) {
                this.updateArrowPosition(target, isLeft);
                (0, $4ZDHT.classList)(target, [
                    "e-allowDrop",
                    "e-reorderindicate"
                ], []);
            } else if (!(gObj.allowGrouping && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea"))) (0, $4ZDHT.classList)(cloneElement, [
                "e-notallowedcur"
            ], [
                "e-defaultcur"
            ]);
        } else {
            if (closest && closest.isEqualNode(this.element) && !(gObj.allowGrouping && e.column.allowGrouping || e.column.allowReordering)) (0, $4ZDHT.classList)(cloneElement, [
                "e-notallowedcur"
            ], [
                "e-defaultcur"
            ]);
            else if (!closest && !(gObj.allowGrouping && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea"))) (0, $4ZDHT.classList)(cloneElement, [
                "e-notallowedcur"
            ], [
                "e-defaultcur"
            ]);
        }
        if (!e.column.allowReordering || e.column.lockColumn) return;
        gObj.trigger($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, {
            target: target,
            draggableType: "headercell",
            column: e.column
        });
    };
    Reorder.prototype.updateScrollPostion = function(e) {
        var _this = this;
        var x = (0, $748c2240e597a9b7$export$1690e12b840569b9)(e).x;
        var cliRect = this.parent.element.getBoundingClientRect();
        var cliRectBaseRight = cliRect.right;
        var cliRectBaseLeft = cliRect.left;
        var scrollElem = this.parent.getContent().firstElementChild;
        if (x > cliRectBaseLeft && x < cliRectBaseLeft + 35) this.timer = window.setInterval(function() {
            _this.setScrollLeft(scrollElem, true);
        }, 50);
        else if (x < cliRectBaseRight && x > cliRectBaseRight - 35) this.timer = window.setInterval(function() {
            _this.setScrollLeft(scrollElem, false);
        }, 50);
    };
    Reorder.prototype.setScrollLeft = function(scrollElem, isLeft) {
        var scrollLeft = scrollElem.scrollLeft;
        scrollElem.scrollLeft = scrollElem.scrollLeft + (isLeft ? -5 : 5);
        if (scrollLeft !== scrollElem.scrollLeft) this.setDisplay("none");
    };
    Reorder.prototype.stopTimer = function() {
        window.clearInterval(this.timer);
    };
    Reorder.prototype.updateArrowPosition = function(target, isLeft) {
        var cliRect = target.getBoundingClientRect();
        var cliRectBase = this.parent.element.getBoundingClientRect();
        if (isLeft && cliRect.left < cliRectBase.left || !isLeft && cliRect.right > cliRectBase.right) return;
        var isSticky = this.parent.getHeaderContent().classList.contains("e-sticky");
        this.upArrow.style.top = isSticky ? cliRect.top + cliRect.height + "px" : cliRect.top + cliRect.height - cliRectBase.top + "px";
        this.downArrow.style.top = isSticky ? cliRect.top - 7 + "px" : cliRect.top - cliRectBase.top - 7 + "px";
        this.upArrow.style.left = this.downArrow.style.left = isSticky ? (isLeft ? cliRect.left : cliRect.right) - 4 + "px" : (isLeft ? cliRect.left : cliRect.right) - cliRectBase.left - 4 + "px";
        this.setDisplay("");
    };
    Reorder.prototype.dragStart = function(e) {
        var gObj = this.parent;
        var target = e.target;
        this.element = target.classList.contains("e-headercell") ? target : (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headercell");
        if (!e.column.allowReordering || e.column.lockColumn) return;
        var content = gObj.getContent().firstElementChild;
        this.x = (0, $748c2240e597a9b7$export$1690e12b840569b9)(e.event).x + content.scrollLeft;
        gObj.trigger($17b89d3b1fc93cdb$export$e7b0ce279c912385, {
            target: target,
            draggableType: "headercell",
            column: e.column
        });
    };
    Reorder.prototype.dragStop = function(e) {
        var gObj = this.parent;
        this.setDisplay("none");
        this.stopTimer();
        if (!e.cancel) gObj.trigger($17b89d3b1fc93cdb$export$553a7dc8a546fa4c, {
            target: e.target,
            draggableType: "headercell",
            column: e.column
        });
        (0, $4ZDHT.removeClass)([].slice.call(gObj.getHeaderTable().getElementsByClassName("e-reorderindicate")), [
            "e-reorderindicate"
        ]);
    };
    Reorder.prototype.setDisplay = function(display) {
        this.upArrow.style.display = display;
        this.downArrow.style.display = display;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} return the module name
     * @private
     */ Reorder.prototype.getModuleName = function() {
        return "reorder";
    };
    return Reorder;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");





var $6807bc11aae112a3$export$45bbfe8bacf3179b = {
    root: "e-rhandler",
    suppress: "e-rsuppress",
    icon: "e-ricon",
    helper: "e-rhelper",
    header: "th.e-headercell",
    cursor: "e-rcursor"
};
/**
 * `Resize` module is used to handle Resize to fit for columns.
 *
 * @hidden
 * @private
 */ var $6807bc11aae112a3$export$76856258f71db1ea = /** @class */ function() {
    /**
     * Constructor for the Grid resize module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function Resize(parent) {
        this.tapped = false;
        this.isDblClk = true;
        /** @hidden */ this.resizeProcess = false;
        this.isCancelAutoFit = false;
        this.parent = parent;
        if (this.parent.isDestroyed) return;
        this.widthService = new (0, $95d0259945049a0f$export$96000d5616e57e96)(parent);
        this.addEventListener();
    }
    /**
     * Resize by field names.
     *
     * @param  {string|string[]} fName - Defines the field name.
     * @param  {number} startRowIndex - Specifies the start row index.
     * @param  {number} endRowIndex - Specifies the end row index.
     * @returns {void}
     */ Resize.prototype.autoFitColumns = function(fName, startRowIndex, endRowIndex) {
        var _this = this;
        var columnName = fName === undefined || fName === null || fName.length <= 0 ? this.parent.getColumns().map(function(x) {
            x.autoFit = true;
            return x.field;
        }) : typeof fName === "string" ? [
            fName
        ] : fName;
        this.parent.isAutoFitColumns = true;
        if (!(0, $3EnZW.isNullOrUndefined)(fName) && typeof fName === "object" && fName.length !== 0) fName.forEach(function(field) {
            if (_this.parent.getColumnByField(field)) _this.parent.getColumnByField(field).autoFit = true;
        });
        else if (typeof fName === "string" && fName.trim() !== "") this.parent.getColumnByField(fName).autoFit = true;
        if (this.parent.enableAdaptiveUI) this.parent.element.classList.add("e-grid-autofit");
        this.findColumn(columnName, startRowIndex, endRowIndex);
    };
    Resize.prototype.autoFit = function() {
        var cols = this.parent.getColumns();
        var isMaxWidthCount = 0;
        var newarray = cols.filter(function(c) {
            if (!(0, $3EnZW.isNullOrUndefined)(c.maxWidth)) isMaxWidthCount++;
            return c.autoFit === true;
        }).map(function(c) {
            return c.field || c.headerText;
        });
        if (newarray.length > 0) this.autoFitColumns(newarray);
        var contentTable = this.parent.getContentTable();
        if (this.parent.allowResizing && isMaxWidthCount && (this.parent.resizeSettings.mode === "Auto" || this.parent.resizeSettings.mode === "Normal" && !this.parent.autoFit && newarray.length === 0)) this.widthService.setWidthToTable(contentTable.style.width.indexOf("px") === -1);
        else if (this.parent.autoFit && this.parent.resizeSettings.mode === "Auto") this.widthService.setWidthToTable();
        if (contentTable.style.width.indexOf("px") !== -1 && contentTable.getBoundingClientRect().width < contentTable.parentElement.clientWidth) (0, $4ZDHT.addClass)([
            this.parent.getHeaderTable(),
            contentTable
        ], [
            "e-tableborder"
        ]);
    };
    Resize.prototype.getCellElementsByColumnIndex = function(columnIndex) {
        if (this.parent.frozenRows) return [].slice.call(this.parent.getHeaderTable().querySelectorAll("td.e-rowcell:nth-child(" + (columnIndex + 1) + "):not(.e-groupcaption):not(.e-detailcell)")).concat([].slice.call(this.parent.getContentTable().querySelectorAll("td.e-rowcell:nth-child(" + (columnIndex + 1) + "):not(.e-groupcaption):not(.e-detailcell)")));
        else return [].slice.call(this.parent.getContentTable().querySelectorAll("td.e-rowcell:nth-child(" + (columnIndex + 1) + "):not(.e-groupcaption):not(.e-detailcell)"));
    };
    Resize.prototype.resizeColumn = function(fName, index, id, startRowIndex, endRowIndex) {
        var gObj = this.parent;
        var tWidth = 0;
        var headerTable = gObj.getHeaderTable();
        var contentTable = gObj.getContentTable();
        var footerTable;
        var headerDivTag = "e-gridheader";
        var contentDivTag = $1b5568e76cdae6d4$export$ee5f1442ff7df474;
        var footerDivTag = $1b5568e76cdae6d4$export$71ae40cd68e383eb;
        var indentWidth = 0;
        var uid = id ? id : this.parent.getUidByColumnField(fName);
        var columnIndex = this.parent.getNormalizedColumnIndex(uid);
        var headerTextClone = headerTable.querySelector('[e-mappinguid="' + uid + '"]').parentElement.cloneNode(true);
        var contentTextClone = this.getCellElementsByColumnIndex(columnIndex);
        var footerTextClone;
        var columnIndexByField = this.parent.getColumnIndexByField(fName);
        if (!(0, $3EnZW.isNullOrUndefined)(gObj.getFooterContent())) footerTable = gObj.getFooterContentTable();
        if (footerTable) footerTextClone = footerTable.querySelectorAll("td:nth-child(" + (columnIndex + 1) + "):not(.e-groupcaption)");
        var indentWidthClone = [].slice.call(headerTable.querySelector("tr").getElementsByClassName("e-grouptopleftcell"));
        if (indentWidthClone.length > 0) for(var i = 0; i < indentWidthClone.length; i++)indentWidth += indentWidthClone[parseInt(i.toString(), 10)].offsetWidth;
        var detailsElement = contentTable.querySelector(".e-detailrowcollapse") || contentTable.querySelector(".e-detailrowexpand");
        if ((this.parent.detailTemplate || this.parent.childGrid) && detailsElement) indentWidth += detailsElement.offsetWidth;
        var headerText = [
            headerTextClone
        ];
        var contentText = [];
        var footerText = [];
        if (footerTable) for(var i = 0; i < footerTextClone.length; i++)footerText[parseInt(i.toString(), 10)] = footerTextClone[parseInt(i.toString(), 10)].cloneNode(true);
        for(var i = 0; i < contentTextClone.length; i++)contentText[parseInt(i.toString(), 10)] = contentTextClone[parseInt(i.toString(), 10)].cloneNode(true);
        var wHeader = this.createTable(headerTable, headerText, headerDivTag);
        var wFooter = null;
        var wContent = null;
        if (gObj.getCurrentViewRecords().length) wContent = this.createTable(contentTable, contentText, contentDivTag, startRowIndex, endRowIndex);
        if (footerText.length) wFooter = this.createTable(footerTable, footerText, footerDivTag);
        var columnbyindex = gObj.getColumns()[parseInt(columnIndexByField.toString(), 10)];
        var width = columnbyindex.width = (0, $3EnZW.formatUnit)(Math.max(wHeader, wContent, wFooter));
        var colMaxWidth = columnbyindex.maxWidth && parseFloat(columnbyindex.maxWidth.toString());
        if (parseInt(width, 10) > colMaxWidth) columnbyindex.width = colMaxWidth;
        this.widthService.setColumnWidth(gObj.getColumns()[parseInt(columnIndexByField.toString(), 10)]);
        var result = gObj.getColumns().some(function(x) {
            return (x.visible || gObj.groupSettings.columns.length) && (x.width === null || x.width === undefined || x.width.length <= 0);
        });
        if (result === false) {
            var element = gObj.getColumns();
            for(var i = 0; i < element.length; i++)if (element[parseInt(i.toString(), 10)].visible) tWidth = tWidth + parseFloat(element[parseInt(i.toString(), 10)].width);
        }
        var calcTableWidth = tWidth + indentWidth;
        if (tWidth > 0) {
            if (this.parent.detailTemplate || this.parent.childGrid) this.widthService.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                width: "30px"
            }));
            if (this.parent.resizeSettings.mode === "Auto") calcTableWidth = "100%";
            headerTable.style.width = (0, $3EnZW.formatUnit)(calcTableWidth);
            contentTable.style.width = (0, $3EnZW.formatUnit)(calcTableWidth);
            if (!(0, $3EnZW.isNullOrUndefined)(footerTable)) footerTable.style.width = (0, $3EnZW.formatUnit)(calcTableWidth);
        }
        if (gObj.isFrozenGrid() && gObj.enableColumnVirtualization) this.widthService.refreshFrozenScrollbar();
        var tableWidth = headerTable.offsetWidth;
        var contentwidth = contentTable.parentElement.scrollWidth;
        if (contentwidth > tableWidth) {
            if (!(0, $3EnZW.isNullOrUndefined)(contentTable.querySelector(".e-emptyrow"))) {
                (0, $4ZDHT.addClass)([
                    headerTable
                ], [
                    "e-tableborder"
                ]);
                (0, $4ZDHT.removeClass)([
                    contentTable
                ], [
                    "e-tableborder"
                ]);
            } else (0, $4ZDHT.addClass)([
                headerTable,
                contentTable
            ], [
                "e-tableborder"
            ]);
            (0, $4ZDHT.removeClass)([
                gObj.element
            ], [
                "e-left-shadow",
                "e-right-shadow"
            ]);
        } else {
            (0, $4ZDHT.removeClass)([
                headerTable,
                contentTable
            ], [
                "e-tableborder"
            ]);
            if (gObj.getVisibleFrozenRightCount()) (0, $4ZDHT.addClass)([
                gObj.element
            ], "e-right-shadow");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(footerTable)) footerTable.classList.add("e-tableborder");
    };
    /**
     * To destroy the resize
     *
     * @returns {void}
     * @hidden
     */ Resize.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        this.widthService = null;
        this.unwireEvents();
        this.removeEventListener();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Resize.prototype.getModuleName = function() {
        return "resize";
    };
    Resize.prototype.findColumn = function(fName, startRowIndex, endRowIndex) {
        for(var i = 0; i < fName.length; i++){
            var fieldName = fName[parseInt(i.toString(), 10)];
            var columnIndex = this.parent.getColumnIndexByField(fieldName);
            var column = this.parent.getColumns()[parseInt(columnIndex.toString(), 10)];
            if (columnIndex > -1 && !(0, $3EnZW.isNullOrUndefined)(column) && column.visible === true) this.resizeColumn(fieldName, columnIndex, null, startRowIndex, endRowIndex);
        }
        if (this.parent.allowTextWrap) this.parent.notify($17b89d3b1fc93cdb$export$5f16ec1d7f7bf943, {
            case: "refreshHeight",
            isModeChg: true
        });
        if (this.parent.isFrozenGrid()) this.refreshResizefrzCols(true, true);
    };
    /**
     * To create table for autofit
     *
     * @param {Element} table - specifies the table
     * @param {Element[]} text - specifies the text
     * @param {string} tag - specifies the tag name
     * @param  {number} startRowIndex - Specifies the start row index.
     * @param  {number} endRowIndex - Specifies the end row index.
     * @returns {number} returns the number
     * @hidden
     */ Resize.prototype.createTable = function(table, text, tag, startRowIndex, endRowIndex) {
        if (startRowIndex === void 0) startRowIndex = 1;
        if (endRowIndex === void 0) endRowIndex = text.length;
        if (startRowIndex > endRowIndex) {
            startRowIndex ^= endRowIndex;
            endRowIndex ^= startRowIndex;
            startRowIndex ^= endRowIndex;
        }
        var myTableDiv = this.parent.createElement("div");
        var adaptiveClass = this.parent.enableAdaptiveUI ? " e-bigger" : "";
        myTableDiv.className = this.parent.element.className + adaptiveClass;
        myTableDiv.style.cssText = "display: inline-block;visibility:hidden;position:absolute";
        var mySubDiv = this.parent.createElement("div");
        mySubDiv.className = tag;
        var myTable = this.parent.createElement("table", {
            attrs: {
                role: "grid"
            }
        });
        myTable.className = table.className;
        myTable.classList.add("e-resizetable");
        myTable.style.cssText = "table-layout: auto;width: auto";
        var myTr = this.parent.createElement("tr");
        for(var i = startRowIndex <= 0 ? 1 : startRowIndex; i <= (endRowIndex > text.length ? text.length : endRowIndex); i++){
            var tr = myTr.cloneNode();
            tr.className = table.querySelector("tr").className;
            tr.appendChild(text[parseInt((i - 1).toString(), 10)]);
            myTable.appendChild(tr);
        }
        mySubDiv.appendChild(myTable);
        myTableDiv.appendChild(mySubDiv);
        document.body.appendChild(myTableDiv);
        var offsetWidthValue = myTable.getBoundingClientRect().width;
        document.body.removeChild(myTableDiv);
        return Math.ceil(offsetWidthValue);
    };
    /**
     * @returns {void}
     * @hidden
     */ Resize.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.refreshHeight, this);
        this.parent.on($17b89d3b1fc93cdb$export$35c81900237a8009, this.refreshResizePosition, this);
        this.parent.on($17b89d3b1fc93cdb$export$5d4840440f592fca, this.wireEvents, this);
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.autoFit, this);
        this.parent.on($17b89d3b1fc93cdb$export$d5e4329e23182602, this.refreshHeight, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Resize.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.refreshHeight);
        this.parent.off($17b89d3b1fc93cdb$export$35c81900237a8009, this.refreshResizePosition);
        this.parent.off($17b89d3b1fc93cdb$export$5d4840440f592fca, this.wireEvents);
        this.parent.off($17b89d3b1fc93cdb$export$d5e4329e23182602, this.refreshHeight);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    /**
     * @returns {void}
     * @hidden
     */ Resize.prototype.render = function() {
        this.unwireEvents();
        this.wireEvents();
        this.setHandlerHeight();
    };
    Resize.prototype.refreshHeight = function() {
        if (this.parent.getHeaderTable()) {
            var element = this.getResizeHandlers();
            for(var i = 0; i < element.length; i++)if (element[parseInt(i.toString(), 10)].parentElement.offsetHeight > 0) element[parseInt(i.toString(), 10)].style.height = element[parseInt(i.toString(), 10)].parentElement.offsetHeight + "px";
            this.setHandlerHeight();
        }
    };
    Resize.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.parent.getHeaderContent(), (0, $5q7BP.Browser).touchStartEvent, this.touchResizeStart, this);
        (0, $aqzbR.EventHandler).add(this.parent.getHeaderContent(), $17b89d3b1fc93cdb$export$efb8dd8d61939266, this.callAutoFit, this);
    };
    Resize.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), (0, $5q7BP.Browser).touchStartEvent, this.touchResizeStart);
        (0, $aqzbR.EventHandler).remove(this.parent.getHeaderContent(), $17b89d3b1fc93cdb$export$efb8dd8d61939266, this.callAutoFit);
    };
    Resize.prototype.getResizeHandlers = function() {
        return [].slice.call(this.parent.getHeaderTable().getElementsByClassName($6807bc11aae112a3$export$45bbfe8bacf3179b.root));
    };
    Resize.prototype.setHandlerHeight = function() {
        var element = [].slice.call(this.parent.getHeaderTable().getElementsByClassName($6807bc11aae112a3$export$45bbfe8bacf3179b.suppress));
        for(var i = 0; i < element.length; i++)element[parseInt(i.toString(), 10)].style.height = element[parseInt(i.toString(), 10)].parentElement.offsetHeight + "px";
    };
    Resize.prototype.callAutoFit = function(e) {
        if (e.target.classList.contains("e-rhandler") && !this.isCancelAutoFit) {
            var col = this.getTargetColumn(e);
            if (col.columns) return;
            this.resizeColumn(col.field, this.parent.getNormalizedColumnIndex(col.uid), col.uid);
            if (this.parent.isFrozenGrid()) this.refreshResizefrzCols(true, true);
            var header = (0, $4ZDHT.closest)(e.target, $6807bc11aae112a3$export$45bbfe8bacf3179b.header);
            header.classList.add("e-resized");
        }
    };
    Resize.prototype.touchResizeStart = function(e) {
        if (!(0, $748c2240e597a9b7$export$98f03c5d19621d70).timer) {
            (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = setTimeout(function() {
                (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = null;
            }, 300);
            return this.resizeStart(e);
        } else {
            clearTimeout((0, $748c2240e597a9b7$export$98f03c5d19621d70).timer);
            (0, $748c2240e597a9b7$export$98f03c5d19621d70).timer = null;
            this.callAutoFit(e);
        }
    };
    Resize.prototype.resizeStart = function(e) {
        var _this = this;
        if (e.target.classList.contains("e-rhandler")) {
            this.isCancelAutoFit = false;
            var args = {
                e: e,
                column: this.getTargetColumn(e)
            };
            this.parent.trigger($17b89d3b1fc93cdb$export$6aff6a45c0c4e7c4, args, function(args) {
                if (args.cancel || _this.parent.isEdit) {
                    _this.cancelResizeAction();
                    _this.isCancelAutoFit = true;
                    return;
                }
            });
            if (!this.isCancelAutoFit) {
                if (!this.helper) {
                    if (this.getScrollBarWidth() === 0) {
                        this.resizeProcess = true;
                        if (this.parent.allowGrouping) for(var i = 0; i < this.parent.groupSettings.columns.length; i++)this.widthService.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                            width: "30px"
                        }), i);
                        if (this.parent.isRowDragable()) this.widthService.setColumnWidth(new (0, $0cb66def079b19f9$export$816b5d811295e6bc)({
                            width: "30px"
                        }));
                        for(var _i = 0, _a = this.refreshColumnWidth(); _i < _a.length; _i++){
                            var col = _a[_i];
                            this.widthService.setColumnWidth(col);
                        }
                        this.widthService.setWidthToTable();
                        this.resizeProcess = false;
                    }
                    this.refreshStackedColumnWidth();
                    this.element = e.target;
                    this.parentElementWidth = this.parent.element.getBoundingClientRect().width;
                    this.appendHelper();
                    this.column = this.getTargetColumn(e);
                    this.pageX = this.getPointX(e);
                    if (this.column.getFreezeTableName() === $1b5568e76cdae6d4$export$b86d31d94d6c8026) {
                        if (this.parent.enableRtl) this.minMove = (this.column.minWidth ? parseFloat(this.column.minWidth.toString()) : 0) - parseFloat((0, $3EnZW.isNullOrUndefined)(this.column.width) ? "" : this.column.width.toString());
                        else this.minMove = parseFloat((0, $3EnZW.isNullOrUndefined)(this.column.width) ? "" : this.column.width.toString()) - (this.column.minWidth ? parseFloat(this.column.minWidth.toString()) : 0);
                    } else if (this.parent.enableRtl) this.minMove = parseFloat(this.column.width.toString()) - (this.column.minWidth ? parseFloat(this.column.minWidth.toString()) : 0);
                    else this.minMove = (this.column.minWidth ? parseFloat(this.column.minWidth.toString()) : 0) - parseFloat((0, $3EnZW.isNullOrUndefined)(this.column.width) ? "" : this.column.width.toString());
                    this.minMove += this.pageX;
                }
                if ((0, $5q7BP.Browser).isDevice && !this.helper.classList.contains($6807bc11aae112a3$export$45bbfe8bacf3179b.icon)) {
                    this.helper.classList.add($6807bc11aae112a3$export$45bbfe8bacf3179b.icon);
                    (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).touchStartEvent, this.removeHelper, this);
                    (0, $aqzbR.EventHandler).add(this.helper, (0, $5q7BP.Browser).touchStartEvent, this.resizeStart, this);
                } else {
                    (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd, this);
                    (0, $aqzbR.EventHandler).add(this.parent.element, (0, $5q7BP.Browser).touchMoveEvent, this.resizing, this);
                    this.updateCursor("add");
                }
            }
        }
    };
    Resize.prototype.cancelResizeAction = function(removeEvents) {
        if (removeEvents) {
            (0, $aqzbR.EventHandler).remove(this.parent.element, (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
            this.updateCursor("remove");
        }
        if ((0, $5q7BP.Browser).isDevice && !(0, $3EnZW.isNullOrUndefined)(this.helper)) {
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).touchStartEvent, this.removeHelper);
            (0, $aqzbR.EventHandler).remove(this.helper, (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.helper)) (0, $4ZDHT.detach)(this.helper);
        this.refresh();
    };
    Resize.prototype.getWidth = function(width, minWidth, maxWidth) {
        if (minWidth && width < minWidth) return minWidth;
        else if (maxWidth && width > maxWidth) return maxWidth;
        else return width;
    };
    Resize.prototype.updateResizeEleHeight = function() {
        var elements = [].slice.call(this.parent.getHeaderContent().getElementsByClassName("e-rhandler"));
        for(var i = 0; i < elements.length; i++)elements[parseInt(i.toString(), 10)].style.height = this.element.parentElement.offsetHeight + "px";
    };
    Resize.prototype.getColData = function(column, mousemove) {
        return {
            width: parseFloat((0, $3EnZW.isNullOrUndefined)(this.widthService.getWidth(column)) || this.widthService.getWidth(column) === "auto" ? "0" : this.widthService.getWidth(column).toString()) + mousemove,
            minWidth: column.minWidth ? parseFloat(column.minWidth.toString()) : null,
            maxWidth: column.maxWidth ? parseFloat(column.maxWidth.toString()) : null
        };
    };
    Resize.prototype.refreshResizeFixedCols = function(pos) {
        var cols = this.parent.getColumns();
        var translateX = this.parent.enableColumnVirtualization ? this.parent.translateX : 0;
        var th = [].slice.call(this.parent.getHeaderContent().querySelector("tbody").querySelectorAll(".e-fixedfreeze")).concat([].slice.call(this.parent.getContent().querySelectorAll(".e-fixedfreeze")));
        for(var i = 0; i < th.length; i++){
            var node = th[parseInt(i.toString(), 10)];
            var column = void 0;
            if (node.classList.contains("e-summarycell")) {
                var uid = node.getAttribute("e-mappinguid");
                column = this.parent.getColumnByUid(uid);
            } else {
                var index = parseInt(node.getAttribute("data-colindex"), 10);
                column = cols[parseInt(index.toString(), 10)];
            }
            var width = 0;
            if (pos === "Left") {
                if (this.parent.getVisibleFrozenLeftCount()) width = this.parent.getIndentCount() * 30;
                else if (this.parent.getFrozenMode() === "Right") width = this.parent.groupSettings.columns.length * 30;
                for(var j = 0; j < cols.length; j++)if (column.index > cols[parseInt(j.toString(), 10)].index) {
                    if (column.uid === cols[parseInt(j.toString(), 10)].uid) break;
                    if (cols[parseInt(j.toString(), 10)].freeze === "Left" || cols[parseInt(j.toString(), 10)].isFrozen || cols[parseInt(j.toString(), 10)].freeze === "Fixed") {
                        if (cols[parseInt(j.toString(), 10)].visible) width += parseFloat(cols[parseInt(j.toString(), 10)].width.toString());
                    }
                }
                (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, (width === 0 ? width : width - 1) - translateX, this.parent.enableRtl, "Left");
            }
            if (pos === "Right") {
                width = this.parent.getFrozenMode() === "Right" && this.parent.isRowDragable() ? 30 : 0;
                for(var j = cols.length - 1; j >= 0; j--){
                    if (column.uid === cols[parseInt(j.toString(), 10)].uid) break;
                    if (cols[parseInt(j.toString(), 10)].freeze === "Right" || cols[parseInt(j.toString(), 10)].freeze === "Fixed") {
                        if (cols[parseInt(j.toString(), 10)].visible) width += parseFloat(cols[parseInt(j.toString(), 10)].width.toString());
                    }
                }
                var colSpanwidth = 0;
                if (node.colSpan > 1) colSpanwidth = this.calculateColspanWidth(cols, node, column.index);
                (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width - colSpanwidth + translateX, this.parent.enableRtl, "Right");
            }
        }
    };
    Resize.prototype.calculateColspanWidth = function(cols, node, index) {
        var width = 0;
        for(var j = index + 1; j < index + node.colSpan; j++)width += parseInt(cols[parseInt(j.toString(), 10)].width.toString(), 10);
        return width;
    };
    Resize.prototype.refreshResizePosition = function() {
        this.refreshResizefrzCols(true);
    };
    Resize.prototype.refreshResizefrzCols = function(freezeRefresh, isAutoFitCol) {
        var _this = this;
        var translateX = this.parent.enableColumnVirtualization ? this.parent.translateX : 0;
        if (freezeRefresh || this.column.freeze === "Left" || this.column.isFrozen || this.column.columns && (0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(this.column) === "Left") {
            var width_1 = this.parent.getIndentCount() * 30;
            var columns = this.parent.getColumns().filter(function(col) {
                return col.freeze === "Left" || col.isFrozen;
            });
            if (!freezeRefresh || isAutoFitCol) this.frzHdrRefresh("Left");
            for(var i = 0; i < columns.length; i++){
                if (freezeRefresh || columns[parseInt(i.toString(), 10)].index > this.column.index) {
                    var elements = [];
                    if (this.parent.frozenRows) elements = [].slice.call(this.parent.getHeaderContent().querySelectorAll('td[data-colindex="' + i + '"]')).concat([].slice.call(this.parent.getContent().querySelectorAll('td[data-colindex="' + i + '"]')));
                    else elements = [].slice.call(this.parent.getContent().querySelectorAll('td[data-colindex="' + i + '"]'));
                    elements.filter(function(cell) {
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width_1 - translateX, _this.parent.enableRtl, "Left");
                    });
                    if (this.parent.enableColumnVirtualization) columns[parseInt(i.toString(), 10)].valueX = width_1;
                }
                if (columns[parseInt(i.toString(), 10)].visible) width_1 += parseFloat(columns[parseInt(i.toString(), 10)].width.toString());
            }
            this.refreshResizeFixedCols("Left");
        }
        if (freezeRefresh || this.column.freeze === "Right" || this.column.columns && (0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(this.column) === "Right") {
            var width_2 = this.parent.getFrozenMode() === "Right" && this.parent.isRowDragable() ? 30 : 0;
            var columns_1 = this.parent.getColumns();
            if (!freezeRefresh || isAutoFitCol) this.frzHdrRefresh("Right");
            var columnsRight = columns_1.filter(function(col) {
                return col.freeze === "Right";
            });
            var _loop_1 = function(i) {
                var elements = [];
                if (this_1.parent.frozenRows) elements = [].slice.call(this_1.parent.getHeaderContent().querySelectorAll('td[data-colindex="' + i + '"]')).concat([].slice.call(this_1.parent.getContent().querySelectorAll('td[data-colindex="' + i + '"]')));
                else elements = [].slice.call(this_1.parent.getContent().querySelectorAll('td[data-colindex="' + i + '"]'));
                elements.filter(function(cell) {
                    var colSpanwidth = 0;
                    if (cell.colSpan > 1) colSpanwidth = _this.calculateColspanWidth(columns_1, cell, columns_1[parseInt(i.toString(), 10)].index);
                    (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width_2 - colSpanwidth + translateX, _this.parent.enableRtl, "Right");
                });
                if (this_1.parent.enableColumnVirtualization) columns_1[parseInt(i.toString(), 10)].valueX = width_2;
                if (columns_1[parseInt(i.toString(), 10)].visible) width_2 = width_2 + parseFloat(columns_1[parseInt(i.toString(), 10)].width.toString());
            };
            var this_1 = this;
            for(var i = columns_1.length - 1; i >= columns_1.length - columnsRight.length; i--)_loop_1(i);
            this.refreshResizeFixedCols("Right");
        }
        if (this.column && (this.column.freeze === "Fixed" || this.column.columns && (0, $748c2240e597a9b7$export$1463b8a6e6d02d19)(this.column) === "Fixed")) {
            this.refreshResizeFixedCols("Left");
            this.refreshResizeFixedCols("Right");
            this.frzHdrRefresh("Left");
            this.frzHdrRefresh("Right");
        }
        if (this.parent.groupSettings.columns.length && this.parent.aggregates.length && this.parent.getContent().querySelector(".e-groupcaptionrow")) this.refreshGroupCaptionRow();
    };
    Resize.prototype.refreshGroupCaptionRow = function() {
        var capRow = [].slice.call(this.parent.getContent().querySelectorAll(".e-groupcaptionrow"));
        for(var i = 0; i < capRow.length; i++){
            var tr = capRow[parseInt(i.toString(), 10)];
            if (tr.querySelector(".e-summarycell")) (0, $748c2240e597a9b7$export$27d8d7d7d18b4954)(tr, this.parent);
        }
    };
    Resize.prototype.frzHdrRefresh = function(pos) {
        var _this = this;
        var translateX = this.parent.enableColumnVirtualization ? this.parent.translateX : 0;
        if (pos === "Left") {
            var tr = [].slice.call(this.parent.getHeaderContent().querySelector("thead").querySelectorAll("tr"));
            for(var i = 0; i < tr.length; i++){
                var th = [].slice.call(tr[parseInt(i.toString(), 10)].querySelectorAll(".e-leftfreeze,.e-fixedfreeze"));
                var _loop_2 = function(j) {
                    var node = th[parseInt(j.toString(), 10)];
                    if (node.classList.contains("e-rowdragheader") || node.classList.contains("e-dragheadercell") || node.classList.contains("e-grouptopleftcell")) return "continue";
                    var column = this_2.getParticularCol(node);
                    var cols = this_2.parent.getColumns();
                    var width = 0;
                    var summarycell = [];
                    if (this_2.parent.aggregates.length && this_2.parent.getFooterContent()) {
                        if (this_2.parent.getContent().querySelectorAll(".e-summaryrow").length) {
                            var summaryRows = [].slice.call(this_2.parent.getContent().querySelectorAll(".e-summaryrow"));
                            summaryRows.filter(function(row) {
                                summarycell.push(row.querySelector('[e-mappinguid="' + column.uid + '"]'));
                            });
                        }
                        summarycell = summarycell.concat([].slice.call(this_2.parent.getFooterContent().querySelectorAll('[e-mappinguid="' + column.uid + '"]')));
                    }
                    if (node.classList.contains("e-fixedfreeze")) {
                        if (this_2.parent.getVisibleFrozenLeftCount()) width = this_2.parent.getIndentCount() * 30;
                        else if (this_2.parent.getFrozenMode() === "Right") width = this_2.parent.groupSettings.columns.length * 30;
                        for(var w = 0; w < cols.length; w++)if (column.index > cols[parseInt(w.toString(), 10)].index) {
                            if (column.uid === cols[parseInt(w.toString(), 10)].uid) break;
                            if (cols[parseInt(w.toString(), 10)].freeze === "Left" || cols[parseInt(w.toString(), 10)].isFrozen || cols[parseInt(w.toString(), 10)].freeze === "Fixed") {
                                if (cols[parseInt(w.toString(), 10)].visible) width += parseInt(cols[parseInt(w.toString(), 10)].width.toString(), 10);
                            }
                        }
                        if (summarycell && summarycell.length) summarycell.filter(function(cell) {
                            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width - translateX, _this.parent.enableRtl, "Left");
                        });
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, (width === 0 ? width : width - 1) - translateX, this_2.parent.enableRtl, "Left");
                    } else {
                        width = this_2.parent.getIndentCount() * 30;
                        if (column.index === 0) {
                            if (summarycell && summarycell.length) summarycell.filter(function(cell) {
                                (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width - translateX, _this.parent.enableRtl, "Left");
                            });
                            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width - translateX, this_2.parent.enableRtl, "Left");
                            if (this_2.parent.enableColumnVirtualization) column.valueX = width;
                        } else {
                            for(var k = 0; k < cols.length; k++){
                                if (column.index < cols[parseInt(k.toString(), 10)].index || column.uid === cols[parseInt(k.toString(), 10)].uid) break;
                                if (cols[parseInt(k.toString(), 10)].visible) width += parseInt(cols[parseInt(k.toString(), 10)].width.toString(), 10);
                            }
                            if (summarycell && summarycell.length) summarycell.filter(function(cell) {
                                (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width - translateX, _this.parent.enableRtl, "Left");
                            });
                            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width - translateX, this_2.parent.enableRtl, "Left");
                            if (this_2.parent.enableColumnVirtualization) column.valueX = width;
                        }
                    }
                };
                var this_2 = this;
                for(var j = 0; j < th.length; j++)_loop_2(j);
            }
        }
        if (pos === "Right") {
            var tr = [].slice.call(this.parent.getHeaderContent().querySelector("thead").querySelectorAll("tr"));
            for(var i = 0; i < tr.length; i++){
                var th = [].slice.call(tr[parseInt(i.toString(), 10)].querySelectorAll(".e-rightfreeze, .e-fixedfreeze"));
                var _loop_3 = function(j) {
                    var node = th[parseInt(j.toString(), 10)];
                    var column = this_3.getParticularCol(node);
                    var cols = this_3.parent.getColumns();
                    var width = 0;
                    var summarycell = [];
                    if (this_3.parent.aggregates.length && this_3.parent.getFooterContent()) {
                        if (this_3.parent.getContent().querySelectorAll(".e-summaryrow").length) {
                            var summaryRows = [].slice.call(this_3.parent.getContent().querySelectorAll(".e-summaryrow"));
                            summaryRows.filter(function(row) {
                                summarycell.push(row.querySelector('[e-mappinguid="' + column.uid + '"]'));
                            });
                        }
                        summarycell = summarycell.concat([].slice.call(this_3.parent.getFooterContent().querySelectorAll('[e-mappinguid="' + column.uid + '"]')));
                    }
                    if (node.classList.contains("e-fixedfreeze")) {
                        width = this_3.parent.getFrozenMode() === "Right" && this_3.parent.isRowDragable() ? 30 : 0;
                        for(var w = cols.length - 1; w >= 0; w--)if (column.index < cols[parseInt(w.toString(), 10)].index) {
                            if (column.columns && (0, $748c2240e597a9b7$export$3289971ebd775b18)(column, cols[parseInt(w.toString(), 10)].uid) || column.index > cols[parseInt(w.toString(), 10)].index) break;
                            if (cols[parseInt(w.toString(), 10)].freeze === "Right" || cols[parseInt(w.toString(), 10)].freeze === "Fixed") {
                                if (cols[parseInt(w.toString(), 10)].visible) width += parseFloat(cols[parseInt(w.toString(), 10)].width.toString());
                            }
                        }
                        if (summarycell.length) summarycell.filter(function(cell) {
                            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width + translateX, _this.parent.enableRtl, "Right");
                        });
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width + translateX, this_3.parent.enableRtl, "Right");
                    } else {
                        width = this_3.parent.getFrozenMode() === "Right" && this_3.parent.isRowDragable() ? 30 : 0;
                        for(var k = cols.length - 1; k >= 0; k--){
                            if (column.columns && (0, $748c2240e597a9b7$export$3289971ebd775b18)(column, cols[parseInt(k.toString(), 10)].uid) || column.index > cols[parseInt(k.toString(), 10)].index || column.uid === cols[parseInt(k.toString(), 10)].uid) break;
                            if (cols[parseInt(k.toString(), 10)].visible) width += parseInt(cols[parseInt(k.toString(), 10)].width.toString(), 10);
                        }
                        if (summarycell.length) summarycell.filter(function(cell) {
                            (0, $748c2240e597a9b7$export$45a1adeafba636b0)(cell, width + translateX, _this.parent.enableRtl, "Right");
                        });
                        (0, $748c2240e597a9b7$export$45a1adeafba636b0)(node, width + translateX, this_3.parent.enableRtl, "Right");
                        if (this_3.parent.enableColumnVirtualization) column.valueX = width;
                    }
                };
                var this_3 = this;
                for(var j = th.length - 1; j >= 0; j--)_loop_3(j);
            }
        }
    };
    Resize.prototype.getParticularCol = function(node) {
        var uid = node.classList.contains("e-filterbarcell") ? node.getAttribute("e-mappinguid") : node.querySelector("[e-mappinguid]").getAttribute("e-mappinguid");
        return this.parent.getColumnByUid(uid);
    };
    Resize.prototype.resizing = function(e) {
        if ((0, $3EnZW.isNullOrUndefined)(this.column)) return;
        if (this.parent.isFrozenGrid()) this.refreshResizefrzCols();
        var offsetWidth = 0;
        if ((0, $3EnZW.isNullOrUndefined)(this.column)) offsetWidth = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(this.element, "th").offsetWidth;
        if (this.parent.allowTextWrap) {
            this.updateResizeEleHeight();
            this.setHelperHeight();
        }
        var pageX = this.getPointX(e);
        var mousemove = this.parent.enableRtl ? -(pageX - this.pageX) : pageX - this.pageX;
        var colData = this.getColData(this.column, mousemove);
        if (!colData.width) colData.width = (0, $4ZDHT.closest)(this.element, "th").offsetWidth;
        var width = this.getWidth(colData.width, colData.minWidth, colData.maxWidth);
        this.parent.log("resize_min_max", {
            column: this.column,
            width: width
        });
        if (!this.parent.enableRtl && this.minMove >= pageX || this.parent.enableRtl && this.minMove <= pageX) {
            width = this.column.minWidth ? parseFloat(this.column.minWidth.toString()) : 10;
            this.pageX = pageX = this.minMove;
        }
        if (width !== parseFloat((0, $3EnZW.isNullOrUndefined)(this.column.width) || this.column.width === "auto" ? offsetWidth.toString() : this.column.width.toString())) {
            this.pageX = pageX;
            this.column.width = (0, $3EnZW.formatUnit)(width);
            var args = {
                e: e,
                column: this.column
            };
            this.parent.trigger($17b89d3b1fc93cdb$export$45b39e67d4ce4921, args);
            if (args.cancel) {
                this.cancelResizeAction(true);
                return;
            }
            var columns = [
                this.column
            ];
            var finalColumns = [
                this.column
            ];
            if (this.column.columns) {
                columns = this.getSubColumns(this.column, []);
                columns = this.calulateColumnsWidth(columns, false, mousemove);
                finalColumns = this.calulateColumnsWidth(columns, true, mousemove);
            }
            this.resizeProcess = true;
            for(var _i = 0, finalColumns_1 = finalColumns; _i < finalColumns_1.length; _i++){
                var col = finalColumns_1[_i];
                this.widthService.setColumnWidth(col, null, "resize");
            }
            this.resizeProcess = false;
            this.updateHelper();
        }
        this.isDblClk = false;
    };
    Resize.prototype.calulateColumnsWidth = function(columns, isUpdate, mousemove) {
        var finalColumns = [];
        for(var _i = 0, columns_2 = columns; _i < columns_2.length; _i++){
            var col = columns_2[_i];
            var totalWidth = 0;
            for(var i = 0; i < columns.length; i++)totalWidth += parseFloat(columns[parseInt(i.toString(), 10)].width.toString());
            var colData = this.getColData(col, parseFloat(col.width) * mousemove / totalWidth);
            var colWidth = this.getWidth(colData.width, colData.minWidth, colData.maxWidth);
            if (colWidth !== parseFloat(col.width.toString())) {
                if (isUpdate) col.width = (0, $3EnZW.formatUnit)(colWidth < 1 ? 1 : colWidth);
                finalColumns.push(col);
            }
        }
        return finalColumns;
    };
    Resize.prototype.getSubColumns = function(column, subColumns) {
        for(var _i = 0, _a = column.columns; _i < _a.length; _i++){
            var col = _a[_i];
            if (col.visible !== false && col.allowResizing) {
                if (col.columns) this.getSubColumns(col, subColumns);
                else subColumns.push(col);
            }
        }
        return subColumns;
    };
    Resize.prototype.resizeEnd = function(e) {
        if (!this.helper || this.parent.isDestroyed) return;
        var gObj = this.parent;
        (0, $aqzbR.EventHandler).remove(this.parent.element, (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        this.updateCursor("remove");
        (0, $4ZDHT.detach)(this.helper);
        var args = {
            e: e,
            column: this.column
        };
        var content = this.parent.getContent().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
        var cTable = content;
        if (cTable.scrollHeight > cTable.clientHeight) {
            this.parent.scrollModule.setPadding();
            cTable.style.overflowY = "scroll";
        }
        this.parent.trigger($17b89d3b1fc93cdb$export$8c4d3b559babc6db, args);
        (0, $4ZDHT.closest)(this.element, ".e-headercell").classList.add("e-resized");
        this.isFrozenColResized = false;
        if (this.parent.allowTextWrap) {
            this.updateResizeEleHeight();
            this.parent.notify($17b89d3b1fc93cdb$export$2c01e4c7592b4497, {
                case: "textwrap"
            });
        }
        var headerTable = gObj.getHeaderTable();
        var contentTable = gObj.getContentTable();
        var footerTable;
        if (!(0, $3EnZW.isNullOrUndefined)(gObj.getFooterContent())) footerTable = gObj.getFooterContentTable();
        var tableWidth = headerTable.offsetWidth;
        var contentwidth = gObj.getContent().scrollWidth;
        if (contentwidth > tableWidth) {
            if (!(0, $3EnZW.isNullOrUndefined)(contentTable.querySelector(".e-emptyrow"))) {
                (0, $4ZDHT.addClass)([
                    headerTable
                ], [
                    "e-tableborder"
                ]);
                (0, $4ZDHT.removeClass)([
                    contentTable
                ], [
                    "e-tableborder"
                ]);
            } else (0, $4ZDHT.addClass)([
                headerTable,
                contentTable
            ], [
                "e-tableborder"
            ]);
            (0, $4ZDHT.removeClass)([
                gObj.element
            ], [
                "e-left-shadow",
                "e-right-shadow"
            ]);
        } else {
            (0, $4ZDHT.removeClass)([
                headerTable,
                contentTable
            ], [
                "e-tableborder"
            ]);
            if (gObj.getVisibleFrozenRightCount()) (0, $4ZDHT.addClass)([
                gObj.element
            ], "e-right-shadow");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(footerTable)) footerTable.classList.add("e-tableborder");
        this.refresh();
        this.doubleTapEvent(e);
        this.isDblClk = true;
    };
    Resize.prototype.getPointX = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageX;
        else return e.pageX;
    };
    Resize.prototype.refreshColumnWidth = function() {
        var columns = this.parent.getColumns();
        for(var _i = 0, _a = [].slice.apply(this.parent.getHeaderContent().querySelectorAll("th.e-headercell")); _i < _a.length; _i++){
            var ele = _a[_i];
            for(var _b = 0, columns_3 = columns; _b < columns_3.length; _b++){
                var column = columns_3[_b];
                if (ele.querySelector("[e-mappinguid]") && ele.querySelector("[e-mappinguid]").getAttribute("e-mappinguid") === column.uid && column.visible) {
                    column.width = ele.getBoundingClientRect().width;
                    break;
                }
            }
        }
        return columns;
    };
    Resize.prototype.refreshStackedColumnWidth = function() {
        for(var _i = 0, _a = this.parent.getStackedColumns(this.parent.columns); _i < _a.length; _i++){
            var stackedColumn = _a[_i];
            stackedColumn.width = this.getStackedWidth(stackedColumn, 0);
        }
    };
    Resize.prototype.getStackedWidth = function(column, width) {
        for(var _i = 0, _a = column.columns; _i < _a.length; _i++){
            var col = _a[_i];
            if (col.visible !== false) {
                if (col.columns) width = this.getStackedWidth(col, width);
                else width += parseFloat(col.width.toString());
            }
        }
        return width;
    };
    Resize.prototype.getTargetColumn = function(e) {
        var cell = (0, $4ZDHT.closest)(e.target, $6807bc11aae112a3$export$45bbfe8bacf3179b.header);
        cell = cell.querySelector(".e-headercelldiv") || cell.querySelector(".e-stackedheadercelldiv");
        var uid = cell.getAttribute("e-mappinguid");
        return this.parent.getColumnByUid(uid);
    };
    Resize.prototype.updateCursor = function(action) {
        var headerRows = [].slice.call(this.parent.getHeaderContent().querySelectorAll("th"));
        headerRows.push(this.parent.element);
        for(var _i = 0, headerRows_1 = headerRows; _i < headerRows_1.length; _i++){
            var row = headerRows_1[_i];
            row.classList["" + action]($6807bc11aae112a3$export$45bbfe8bacf3179b.cursor);
        }
    };
    Resize.prototype.refresh = function() {
        this.column = null;
        this.pageX = null;
        this.element = null;
        this.helper = null;
    };
    Resize.prototype.appendHelper = function() {
        this.helper = this.parent.createElement("div", {
            className: $6807bc11aae112a3$export$45bbfe8bacf3179b.helper
        });
        this.parent.element.appendChild(this.helper);
        this.setHelperHeight();
    };
    Resize.prototype.setHelperHeight = function() {
        var height = this.parent.getContent().offsetHeight - this.getScrollBarWidth();
        var rect = (0, $4ZDHT.closest)(this.element, $6807bc11aae112a3$export$45bbfe8bacf3179b.header);
        var tr = [].slice.call(this.parent.getHeaderContent().querySelectorAll("tr"));
        for(var i = tr.indexOf(rect.parentElement); i < tr.length && i > -1; i++)height += tr[parseInt(i.toString(), 10)].offsetHeight;
        var pos = this.calcPos(rect);
        pos.left += this.parent.enableRtl ? -1 : rect.offsetWidth - 2;
        this.helper.style.cssText = "height: " + height + "px; top: " + pos.top + "px; left:" + Math.floor(pos.left) + "px;";
        if (this.parent.enableVirtualization) this.helper.classList.add("e-virtual-rhandler");
    };
    Resize.prototype.getScrollBarWidth = function(height) {
        var ele = this.parent.getContent().firstChild;
        return ele.scrollHeight > ele.clientHeight && height || ele.scrollWidth > ele.clientWidth ? (0, $748c2240e597a9b7$export$1df2a1438d36fb55)() : 0;
    };
    Resize.prototype.removeHelper = function(e) {
        var cls = e.target.classList;
        if (!(cls.contains($6807bc11aae112a3$export$45bbfe8bacf3179b.root) || cls.contains($6807bc11aae112a3$export$45bbfe8bacf3179b.icon)) && this.helper) {
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).touchStartEvent, this.removeHelper);
            (0, $aqzbR.EventHandler).remove(this.helper, (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
            (0, $4ZDHT.detach)(this.helper);
            this.refresh();
        }
    };
    Resize.prototype.updateHelper = function() {
        var rect = (0, $4ZDHT.closest)(this.element, $6807bc11aae112a3$export$45bbfe8bacf3179b.header);
        var left;
        left = Math.floor(this.calcPos(rect).left + (this.parent.enableRtl ? -1 : rect.offsetWidth - 2));
        var borderWidth = 2; // to maintain the helper inside of grid element.
        if (left > this.parentElementWidth) left = this.parentElementWidth - borderWidth;
        this.helper.style.left = left + "px";
    };
    Resize.prototype.calcPos = function(elem) {
        var parentOffset = {
            top: 0,
            left: 0
        };
        var offset = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var offsetParent = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(elem, "e-grid") || doc.documentElement;
        while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && offsetParent.style.position === "static")offsetParent = offsetParent.parentNode;
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) parentOffset = offsetParent.getBoundingClientRect();
        return {
            top: offset.top - parentOffset.top,
            left: offset.left - parentOffset.left
        };
    };
    Resize.prototype.doubleTapEvent = function(e) {
        var _this = this;
        if (this.getUserAgent() && this.isDblClk) {
            if (!this.tapped) this.tapped = setTimeout(function() {
                _this.tapped = null;
            }, 300);
            else {
                clearTimeout(this.tapped);
                this.callAutoFit(e);
                this.tapped = null;
            }
        }
    };
    Resize.prototype.getUserAgent = function() {
        var userAgent = (0, $5q7BP.Browser).userAgent.toLowerCase();
        return /iphone|ipod|ipad/.test(userAgent);
    };
    Resize.prototype.timeoutHandler = function() {
        this.tapped = null;
    };
    return Resize;
}();

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");





/**
 *
 * The `Sort` module is used to handle sorting action.
 */ var $e02f22598f2cfb09$export$d43f91ac58cde147 = /** @class */ function() {
    /**
     * Constructor for Grid sorting module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {SortSettings} sortSettings - specifies the SortSettings
     * @param {string[]} sortedColumns - specifies the string
     * @param {ServiceLocator} locator - specifies the ServiceLocator
     * @hidden
     */ function Sort(parent, sortSettings, sortedColumns, locator) {
        this.contentRefresh = true;
        this.isModelChanged = true;
        this.aria = new (0, $93af6f2061a6f920$export$aaeab4162651d364)();
        this.currentTarget = null;
        this.parent = parent;
        this.sortSettings = sortSettings;
        this.sortedColumns = sortedColumns;
        this.serviceLocator = locator;
        this.focus = locator.getService("focus");
        this.addEventListener();
        this.setFullScreenDialog();
    }
    /**
     * The function used to update sortSettings
     *
     * @returns {void}
     * @hidden
     */ Sort.prototype.updateModel = function() {
        var sortedColumn = {
            field: this.columnName,
            direction: this.direction
        };
        var index;
        var gCols = this.parent.groupSettings.columns;
        var flag = false;
        if (!this.isMultiSort) {
            if (!gCols.length) this.sortSettings.columns = [
                sortedColumn
            ];
            else {
                var sortedCols = [];
                for(var i = 0, len = gCols.length; i < len; i++){
                    index = this.getSortedColsIndexByField(gCols[parseInt(i.toString(), 10)], sortedCols);
                    if (this.columnName === gCols[parseInt(i.toString(), 10)]) {
                        flag = true;
                        sortedCols.push(sortedColumn);
                    } else {
                        var sCol = this.getSortColumnFromField(gCols[parseInt(i.toString(), 10)]);
                        sortedCols.push({
                            field: sCol.field,
                            direction: sCol.direction,
                            isFromGroup: sCol.isFromGroup
                        });
                    }
                }
                if (!flag) sortedCols.push(sortedColumn);
                this.sortSettings.columns = sortedCols;
            }
        } else {
            index = this.getSortedColsIndexByField(this.columnName);
            if (index > -1) this.sortSettings.columns.splice(index, 1);
            this.sortSettings.columns.push(sortedColumn);
            // eslint-disable-next-line no-self-assign
            this.sortSettings.columns = this.sortSettings.columns;
        }
        this.parent.dataBind();
        this.lastSortedCol = this.columnName;
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Sort.prototype.onActionComplete = function(e) {
        var args = !this.isRemove ? {
            columnName: this.columnName,
            direction: this.direction,
            requestType: "sorting",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        } : {
            requestType: "sorting",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        };
        this.isRemove = false;
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, args));
    };
    /**
     * Sorts a column with the given options.
     *
     * @param {string} columnName - Defines the column name to sort.
     * @param {SortDirection} direction - Defines the direction of sorting field.
     * @param {boolean} isMultiSort - Specifies whether the previously sorted columns are to be maintained.
     * @returns {void}
     */ Sort.prototype.sortColumn = function(columnName, direction, isMultiSort) {
        var gObj = this.parent;
        if (this.parent.getColumnByField(columnName).allowSorting === false || this.parent.isContextMenuOpen()) {
            this.parent.log("action_disabled_column", {
                moduleName: this.getModuleName(),
                columnName: columnName
            });
            return;
        }
        if (!gObj.allowMultiSorting) isMultiSort = gObj.allowMultiSorting;
        if (this.isActionPrevent()) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.sortColumn,
                arg1: columnName,
                arg2: direction,
                arg3: isMultiSort
            });
            return;
        }
        this.backupSettings();
        this.columnName = columnName;
        this.direction = direction;
        this.isMultiSort = isMultiSort;
        this.removeSortIcons();
        this.updateSortedCols(columnName, isMultiSort);
        this.updateModel();
    };
    Sort.prototype.setFullScreenDialog = function() {
        if (this.serviceLocator) this.serviceLocator.registerAdaptiveService(this, this.parent.enableAdaptiveUI, (0, $6b76944ddf827cb7$export$b69201db7f59899c).isSort);
    };
    Sort.prototype.backupSettings = function() {
        this.lastSortedCols = (0, $748c2240e597a9b7$export$5788824bee325a29)(this.sortSettings.columns);
        this.lastCols = this.sortedColumns;
    };
    Sort.prototype.restoreSettings = function() {
        this.isModelChanged = false;
        this.isMultiSort = true;
        this.parent.setProperties({
            sortSettings: {
                columns: this.lastSortedCols
            }
        }, true);
        //this.parent.sortSettings.columns =  this.lastSortedCols;
        this.sortedColumns = this.lastCols;
        this.isModelChanged = true;
    };
    Sort.prototype.updateSortedCols = function(columnName, isMultiSort) {
        if (!isMultiSort) {
            if (this.parent.allowGrouping) {
                for(var i = 0, len = this.sortedColumns.length; i < len; i++)if (this.parent.groupSettings.columns.indexOf(this.sortedColumns[parseInt(i.toString(), 10)]) < 0) {
                    this.sortedColumns.splice(i, 1);
                    len--;
                    i--;
                }
            } else this.sortedColumns.splice(0, this.sortedColumns.length);
        }
        if (this.sortedColumns.indexOf(columnName) < 0) this.sortedColumns.push(columnName);
    };
    /**
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Sort.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        if (this.contentRefresh) {
            var args = this.sortSettings.columns.length ? {
                columnName: this.columnName,
                direction: this.direction,
                requestType: "sorting",
                type: $17b89d3b1fc93cdb$export$df204737a6131aab,
                target: this.currentTarget,
                cancel: false
            } : {
                requestType: "sorting",
                type: $17b89d3b1fc93cdb$export$df204737a6131aab,
                cancel: false,
                target: this.currentTarget
            };
            this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
        }
        this.refreshSortSettings();
        this.removeSortIcons();
        this.addSortIcons();
    };
    Sort.prototype.refreshSortSettings = function() {
        this.sortedColumns.length = 0;
        var sortColumns = this.sortSettings.columns;
        for(var i = 0; i < sortColumns.length; i++)if (!sortColumns[parseInt(i.toString(), 10)].isFromGroup) this.sortedColumns.push(sortColumns[parseInt(i.toString(), 10)].field);
    };
    /**
     * Clears all the sorted columns of the Grid.
     *
     * @returns {void}
     */ Sort.prototype.clearSorting = function() {
        var cols = (0, $748c2240e597a9b7$export$3adc9e17a2947b53)(this.sortSettings.columns);
        if (this.isActionPrevent()) {
            this.parent.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.clearSorting
            });
            return;
        }
        for(var i = 0, len = cols.length; i < len; i++)this.removeSortColumn(cols[parseInt(i.toString(), 10)].field);
    };
    Sort.prototype.isActionPrevent = function() {
        return (0, $748c2240e597a9b7$export$fbf5228cd2134af7)(this.parent);
    };
    /**
     * Remove sorted column by field name.
     *
     * @param {string} field - Defines the column field name to remove sort.
     * @returns {void}
     * @hidden
     */ Sort.prototype.removeSortColumn = function(field) {
        var gObj = this.parent;
        var cols = this.sortSettings.columns;
        if (cols.length === 0 && this.sortedColumns.indexOf(field) < 0) return;
        if (this.isActionPrevent()) {
            this.parent.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.removeSortColumn,
                arg1: field
            });
            return;
        }
        this.backupSettings();
        this.removeSortIcons();
        var args = {
            requestType: "sorting",
            type: $17b89d3b1fc93cdb$export$df204737a6131aab,
            target: this.currentTarget
        };
        for(var i = 0, len = cols.length; i < len; i++)if (cols[parseInt(i.toString(), 10)].field === field) {
            if (gObj.allowGrouping && gObj.groupSettings.columns.indexOf(cols[parseInt(i.toString(), 10)].field) > -1) continue;
            this.sortedColumns.splice(this.sortedColumns.indexOf(cols[parseInt(i.toString(), 10)].field), 1);
            cols.splice(i, 1);
            this.isRemove = true;
            if (this.isModelChanged) this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
            break;
        }
        if (!args.cancel) this.addSortIcons();
    };
    Sort.prototype.getSortedColsIndexByField = function(field, sortedColumns) {
        var cols = sortedColumns ? sortedColumns : this.sortSettings.columns;
        for(var i = 0, len = cols.length; i < len; i++){
            if (cols[parseInt(i.toString(), 10)].field === field) return i;
        }
        return -1;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Sort.prototype.getModuleName = function() {
        return "sort";
    };
    Sort.prototype.initialEnd = function() {
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
        if (this.parent.getColumns().length && this.sortSettings.columns.length) {
            var gObj = this.parent;
            this.contentRefresh = false;
            this.isMultiSort = this.sortSettings.columns.length > 1;
            for(var _i = 0, _a = gObj.sortSettings.columns.slice(); _i < _a.length; _i++){
                var col = _a[_i];
                if (this.sortedColumns.indexOf(col.field) > -1) this.sortColumn(col.field, col.direction, true);
            }
            this.isMultiSort = false;
            this.contentRefresh = true;
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Sort.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.evtHandlers = [
            {
                event: $17b89d3b1fc93cdb$export$f66e9a7f793619a4,
                handler: this.setFullScreenDialog
            },
            {
                event: $17b89d3b1fc93cdb$export$57e9c95e9e650443,
                handler: this.renderResponsiveChangeAction
            },
            {
                event: $17b89d3b1fc93cdb$export$f44d9209b353bf3e,
                handler: this.initialEnd
            },
            {
                event: $17b89d3b1fc93cdb$export$157fcb0735825622,
                handler: this.onActionComplete
            },
            {
                event: $17b89d3b1fc93cdb$export$f4000f83c4e293d0,
                handler: this.onPropertyChanged
            },
            {
                event: $17b89d3b1fc93cdb$export$64ef1bee2b9504c1,
                handler: this.clickHandler
            },
            {
                event: $17b89d3b1fc93cdb$export$265a66bcae9d11dd,
                handler: this.refreshSortIcons
            },
            {
                event: $17b89d3b1fc93cdb$export$e09b512eecac7579,
                handler: this.keyPressed
            },
            {
                event: $17b89d3b1fc93cdb$export$13b99c0e226e6ca4,
                handler: this.cancelBeginEvent
            },
            {
                event: $17b89d3b1fc93cdb$export$b1fb4cac938035f7,
                handler: this.destroy
            }
        ];
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, true, this);
        (0, $aqzbR.EventHandler).add(document.body, "click", this.excelFilterSortAction, this);
        (0, $aqzbR.EventHandler).add(document.body, "touchend", this.excelFilterSortAction, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Sort.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        (0, $748c2240e597a9b7$export$1f4003be8e1e6b7c)(this.parent, this.evtHandlers, false);
        (0, $aqzbR.EventHandler).remove(document.body, "click", this.excelFilterSortAction);
        (0, $aqzbR.EventHandler).remove(document.body, "touchend", this.excelFilterSortAction);
    };
    Sort.prototype.excelFilterSortAction = function(e) {
        var popUp = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-grid-popup");
        var gridID = this.parent.element.id + "_e-popup";
        if (popUp && popUp.id === gridID && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-excelfilter")) this.excelFilterSortActionHandler(e);
    };
    /**
     * To destroy the sorting
     *
     * @returns {void}
     * @hidden
     */ Sort.prototype.destroy = function() {
        this.isModelChanged = false;
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        if (this.parent.element.querySelector(".e-gridpopup").getElementsByClassName("e-sortdirect").length) this.parent.element.querySelector(".e-gridpopup").style.display = "none";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.parent.refreshing && (this.parent.isDestroyed || !this.parent.allowSorting)) this.clearSorting();
        this.isModelChanged = true;
        this.removeEventListener();
    };
    Sort.prototype.cancelBeginEvent = function(e) {
        if (e.requestType === "sorting") {
            this.restoreSettings();
            this.refreshSortIcons();
            this.isMultiSort = true;
        }
    };
    Sort.prototype.clickHandler = function(e) {
        var gObj = this.parent;
        this.currentTarget = null;
        this.popUpClickHandler(e);
        var target = (0, $4ZDHT.closest)(e.target, ".e-headercell");
        if (target && !e.target.classList.contains("e-grptogglebtn") && !target.classList.contains("e-resized") && !e.target.classList.contains("e-rhandler") && !e.target.classList.contains("e-columnmenu") && !e.target.classList.contains("e-filtermenudiv") && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-stackedheadercell") && !(gObj.allowSelection && gObj.selectionSettings.allowColumnSelection && e.target.classList.contains("e-headercell"))) {
            var gObj_1 = this.parent;
            var colObj = gObj_1.getColumnByUid(target.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));
            if (colObj.type !== "checkbox") {
                this.initiateSort(target, e, colObj);
                if ((0, $5q7BP.Browser).isDevice) this.showPopUp(e);
            }
        }
        if (target) target.classList.remove("e-resized");
        this.excelFilterSortActionHandler(e);
    };
    Sort.prototype.excelFilterSortActionHandler = function(e) {
        if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-excel-ascending") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-excel-descending")) {
            var colUid = (0, $4ZDHT.closest)(e.target, ".e-filter-popup").getAttribute("uid");
            var direction = (0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-excel-descending")) ? "Ascending" : "Descending";
            this.sortColumn(this.parent.getColumnByUid(colUid).field, direction, false);
        }
    };
    Sort.prototype.keyPressed = function(e) {
        var ele = e.target;
        if (!this.parent.isEdit && (e.action === "enter" || e.action === "ctrlEnter" || e.action === "shiftEnter") && (0, $4ZDHT.closest)(ele, ".e-headercell")) {
            var target = this.focus.getFocusedElement();
            if ((0, $3EnZW.isNullOrUndefined)(target) || !target.classList.contains("e-headercell") || !target.querySelector(".e-headercelldiv")) return;
            var col = this.parent.getColumnByUid(target.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));
            this.initiateSort(target, e, col);
        }
    };
    Sort.prototype.initiateSort = function(target, e, column) {
        var gObj = this.parent;
        var field = column.field;
        this.currentTarget = e.target;
        var direction = !target.getElementsByClassName("e-ascending").length ? "Ascending" : "Descending";
        this.isMultiSort = e.ctrlKey || this.enableSortMultiTouch || navigator.userAgent.indexOf("Mac OS") !== -1 && e.metaKey;
        if (e.shiftKey || this.sortSettings.allowUnsort && target.getElementsByClassName("e-descending").length && !(gObj.groupSettings.columns.indexOf(field) > -1)) this.removeSortColumn(field);
        else this.sortColumn(field, direction, this.isMultiSort);
    };
    Sort.prototype.showPopUp = function(e) {
        var target = (0, $4ZDHT.closest)(e.target, ".e-headercell");
        if (this.parent.allowMultiSorting && (!(0, $3EnZW.isNullOrUndefined)(target) || this.parent.isContextMenuOpen())) (0, $748c2240e597a9b7$export$7ad8741a0e3edfbb)(this.parent.element.querySelector(".e-gridpopup"), e, "e-sortdirect e-icons e-icon-sortdirect" + (this.sortedColumns.length > 1 ? " e-spanclicked" : ""));
    };
    Sort.prototype.popUpClickHandler = function(e) {
        var target = e.target;
        if ((0, $4ZDHT.closest)(target, ".e-headercell") || e.target.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) || (0, $4ZDHT.closest)(target, ".e-gridpopup")) {
            if (target.classList.contains("e-sortdirect")) {
                if (!target.classList.contains("e-spanclicked")) {
                    target.classList.add("e-spanclicked");
                    this.enableSortMultiTouch = true;
                } else {
                    target.classList.remove("e-spanclicked");
                    this.enableSortMultiTouch = false;
                    this.parent.element.querySelector(".e-gridpopup").style.display = "none";
                }
            }
        } else this.parent.element.querySelector(".e-gridpopup").style.display = "none";
    };
    Sort.prototype.addSortIcons = function() {
        var gObj = this.parent;
        var header;
        var filterElement;
        var cols = this.sortSettings.columns;
        var fieldNames = this.parent.getColumns().map(function(c) {
            return c.field;
        });
        for(var i = 0, len = cols.length; i < len; i++){
            header = gObj.getColumnHeaderByField(cols[parseInt(i.toString(), 10)].field);
            if (fieldNames.indexOf(cols[parseInt(i.toString(), 10)].field) === -1 || (0, $3EnZW.isNullOrUndefined)(header)) continue;
            this.aria.setSort(header, cols[parseInt(i.toString(), 10)].direction.toLowerCase());
            if (cols.length > 1) header.querySelector(".e-headercelldiv").insertBefore(this.parent.createElement("span", {
                className: "e-sortnumber",
                innerHTML: (i + 1).toString()
            }), header.querySelector(".e-headertext"));
            filterElement = header.querySelector(".e-sortfilterdiv");
            if (cols[parseInt(i.toString(), 10)].direction === "Ascending") (0, $4ZDHT.classList)(filterElement, [
                "e-ascending",
                "e-icon-ascending"
            ], []);
            else (0, $4ZDHT.classList)(filterElement, [
                "e-descending",
                "e-icon-descending"
            ], []);
        }
    };
    Sort.prototype.removeSortIcons = function(position) {
        var gObj = this.parent;
        var header;
        var cols = this.sortSettings.columns;
        var fieldNames = this.parent.getColumns().map(function(c) {
            return c.field;
        });
        for(var i = position ? position : 0, len = !(0, $3EnZW.isNullOrUndefined)(position) ? position + 1 : cols.length; i < len; i++){
            header = gObj.getColumnHeaderByField(cols[parseInt(i.toString(), 10)].field);
            if ((0, $3EnZW.isNullOrUndefined)(header) || gObj.allowGrouping && gObj.groupSettings.columns.indexOf(cols[parseInt(i.toString(), 10)].field) > -1 && !header.querySelector(".e-sortfilterdiv")) continue;
            if (fieldNames.indexOf(cols[parseInt(i.toString(), 10)].field) === -1) continue;
            this.aria.setSort(header, "none");
            (0, $4ZDHT.classList)(header.querySelector(".e-sortfilterdiv"), [], [
                "e-descending",
                "e-icon-descending",
                "e-ascending",
                "e-icon-ascending"
            ]);
            if (header.querySelector(".e-sortnumber")) header.querySelector(".e-headercelldiv").removeChild(header.querySelector(".e-sortnumber"));
        }
    };
    Sort.prototype.getSortColumnFromField = function(field) {
        for(var i = 0, len = this.sortSettings.columns.length; i < len; i++){
            if (this.sortSettings.columns[parseInt(i.toString(), 10)].field === field) return this.sortSettings.columns[parseInt(i.toString(), 10)];
        }
        return false;
    };
    Sort.prototype.updateAriaAttr = function() {
        var fieldNames = this.parent.getColumns().map(function(c) {
            return c.field;
        });
        for(var _i = 0, _a = this.sortedColumns; _i < _a.length; _i++){
            var col = _a[_i];
            if (fieldNames.indexOf(col) === -1) continue;
            var header = this.parent.getColumnHeaderByField(col);
            this.aria.setSort(header, this.getSortColumnFromField(col).direction);
        }
    };
    Sort.prototype.refreshSortIcons = function() {
        this.removeSortIcons();
        this.isMultiSort = true;
        this.removeSortIcons();
        this.addSortIcons();
        this.isMultiSort = false;
        this.updateAriaAttr();
    };
    Sort.prototype.renderResponsiveChangeAction = function(args) {
        this.responsiveDialogRenderer.action = args.action;
    };
    /**
     * To show the responsive custom sort dialog
     *
     * @param {boolean} enable - specifes dialog open
     * @returns {void}
     * @hidden
     */ Sort.prototype.showCustomSort = function(enable) {
        this.responsiveDialogRenderer.isCustomDialog = enable;
        this.responsiveDialogRenderer.showResponsiveDialog();
    };
    return Sort;
}();


var $428fcb2015744f49$exports = {};
(function(global, factory) {
    $428fcb2015744f49$exports = factory();
})($428fcb2015744f49$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});



const $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a = {
    COOKIE_CONSENT: {
        name: "pf_cookieConsent",
        slidingExpirationDays: 90,
        clearOnSignOut: false
    },
    DEVICE_ID: {
        name: "pf_deviceId",
        slidingExpirationDays: 90,
        clearOnSignOut: false
    },
    EXISTING_USER: {
        name: "pf_existingUser",
        slidingExpirationDays: 90,
        clearOnSignOut: false
    },
    DASHBOARD_VIEW: {
        name: "pf_dashboardView",
        slidingExpirationDays: 7,
        clearOnSignOut: false
    },
    DEFAULT_DASHBOARD_VIEW: {
        name: "pf_defaultDashboardView",
        slidingExpirationDays: 7,
        clearOnSignOut: false
    },
    USER_ID_FILTER: {
        name: "pf_userIdFilter",
        slidingExpirationDays: 7,
        clearOnSignOut: true
    }
};




const $a4990d2aafe232be$export$98b7e9af4eeecc18 = (condition)=>{
    // Template doesn't seem to interpret value === null or value === undefined correctly, test for falsiness intead
    if (condition.value === null || condition.value === undefined) return `${condition.negate ? "" : "!"}${condition.field}`;
    else if (typeof condition.value === "boolean") return `${condition.value && !condition.negate ? "" : "!"}${condition.field}`;
    else {
        const toggleIfValue = typeof condition.value === "string" ? `"${condition.value.replace('"', '\\"')}"` : condition.value;
        return `${condition.field} ${condition.negate ? "!" : "="}== ${toggleIfValue}`;
    }
};


const $536115221eb2ad16$export$21fe5488f05bf4cb = (options)=>{
    const { uid: uid, field: field, header: header, overrideDisplayField: overrideDisplayField, emptyText: emptyText = "Not set", emptyClass: emptyClass = "text-more-muted", due: due, dueIf: dueIf, allowFiltering: allowFiltering, allowSorting: allowSorting, visible: visible, extra: extra } = options ?? {};
    let format = (0, $d47525176c3f6cd7$export$ed2e8365f2474b3);
    let formatter = "formatDayMonthYear";
    if (options?.format === "date") {
        format = (0, $d47525176c3f6cd7$export$4e4cb19dd88cd821);
        formatter = "formatDate";
    } else if (options?.format === "dayMonth") {
        format = (0, $d47525176c3f6cd7$export$fee663b01e39c429);
        formatter = "formatDayMonth";
    } else if (options?.format === "dayMonthYear") {
        format = (0, $d47525176c3f6cd7$export$ed2e8365f2474b3);
        formatter = "formatDayMonthYear";
    } else if (options?.format === "dayLongMonth") {
        format = (0, $d47525176c3f6cd7$export$43a266027343dd39);
        formatter = "formatDayLongMonth";
    } else if (options?.format === "time") {
        format = (0, $d47525176c3f6cd7$export$94f4d87fad5dcf9a);
        formatter = "formatTime";
    } else if (options?.format === "dayMonthYearTime") {
        format = (0, $d47525176c3f6cd7$export$65691f9e1b09bbf7);
        formatter = "formatDayMonthYearTime";
    }
    const dueCondition = dueIf ? (0, $a4990d2aafe232be$export$98b7e9af4eeecc18)(dueIf) : undefined;
    let valueTemplate = `\${window.formatters.${formatter}(${field})}`;
    if (overrideDisplayField) valueTemplate = `\${if(${overrideDisplayField})}\${window.formatters.${formatter}(${overrideDisplayField})}\${else}${valueTemplate}\${/if}`;
    let template = emptyText ? `\${if(${field})}${valueTemplate}\${else}<span class="${emptyClass ?? ""}">${emptyText}</span>\${/if}` : valueTemplate;
    if (due || dueIf) template = `\${if(${field})}${dueIf ? `<span class="\${if(${dueCondition})}\${window.formatters.dueDateClass(${field})}\${else}text-more-muted text-decoration-line-through\${/if}">${template}</span>` : `<span class="\${window.formatters.dueDateClass(${field})}">${template}</span>`}\${else}${template}\${/if}`;
    return {
        uid: uid ?? field,
        field: field,
        headerText: header,
        type: "date",
        format: format,
        template: template,
        allowFiltering: allowFiltering ?? true,
        allowSorting: allowSorting ?? true,
        width: 150,
        visible: visible ?? true,
        extra: extra
    };
};


const $8425acb746879d03$export$108c17e5c52b7df8 = ()=>{
    return {
        uid: "id",
        field: "id",
        isPrimaryKey: true,
        visible: false,
        showInColumnChooser: false,
        allowSorting: false,
        allowFiltering: false
    };
};



const $1bffc48b1ad750b0$export$a3730b14818decf5 = (options)=>{
    const { uid: uid, field: field, header: header, linkUrl: linkUrl, positiveClass: positiveClass, positiveSuffix: positiveSuffix, zeroClass: zeroClass = "text-more-muted", zeroText: zeroText = "", allowFiltering: allowFiltering, allowSorting: allowSorting, width: width, visible: visible } = options ?? {};
    let classTemplate;
    if (positiveClass || zeroClass) classTemplate = `\${if(${field})}${positiveClass}\${else}\${if(${field} === 0)}${zeroClass}\${/if}\${/if}`;
    const valueTemplate = positiveSuffix ? `\${if(${field} > 0)}\${${field}}${positiveSuffix}\${else}<span class="${zeroClass}">${zeroText}</span>\${/if}` : `\${if(${field} === 0 || ${field})}\${${field}}\${/if}`;
    let template;
    if (linkUrl) template = `<a href="${linkUrl.replace("{id}", `\${if(id === '${(0, $e56e694ede576bd9$export$3b6bf62ab04cab53)}')}isnull\${else}\${id}\${/if}`)}"${classTemplate ? ` class="${classTemplate}"` : ""}>${valueTemplate}</a>`;
    else if (classTemplate) template = `<span class="${classTemplate}">${valueTemplate}</span>`;
    return {
        uid: uid ?? field,
        field: field,
        headerText: header,
        type: "number",
        template: template,
        allowFiltering: allowFiltering ?? true,
        allowSorting: allowSorting ?? true,
        width: width ?? 120,
        visible: visible ?? true
    };
};


const $f56b939cc3f4e537$export$37552c4c789a7634 = (options)=>{
    const { uid: uid, field: field, header: header, headerTemplate: headerTemplate, emptyText: emptyText = "Not set", emptyClass: emptyClass = "text-more-muted", template: template, textAlign: textAlign, minWidth: minWidth, allowFiltering: allowFiltering, allowSorting: allowSorting, width: width, visible: visible, showInColumnChooser: showInColumnChooser, extra: extra } = options ?? {};
    const displayField = extra?.displayField ?? field;
    return {
        uid: uid ?? field,
        field: field,
        headerText: header ?? "",
        headerTemplate: headerTemplate,
        type: "string",
        clipMode: "EllipsisWithTooltip",
        textAlign: textAlign,
        minWidth: minWidth,
        ...emptyText ? {
            template: `\${if(${field} === 0 || ${field})}\${${displayField}}\${else}<span class="${emptyClass ?? ""}">${emptyText}</span>\${/if}`
        } : {
            template: `\${${displayField}}`
        },
        ...template ? {
            template: template
        } : {},
        allowFiltering: allowFiltering ?? true,
        allowSorting: allowSorting ?? true,
        width: width ?? 150,
        visible: visible ?? true,
        showInColumnChooser: showInColumnChooser ?? true,
        toolTip: "",
        extra: extra
    };
};




const $2ca9fcd86dc38755$export$188d75d71883854a = (...names)=>names.filter((name)=>typeof name === "string").map((name)=>name.trim()).filter((name)=>name).join(" ");
const $2ca9fcd86dc38755$export$5277d48d12c46899 = (due)=>{
    if (due) {
        if (typeof due === "string") due = (0, $fb0301734e2a6838$export$489a569037cfef1b)(due);
        if (due) {
            const days = (0, $9f9ac9f3de351425$export$c9458bb7d024b650)(due, (0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)());
            if (days <= 0) return "due";
            else if (days <= 30) return "due-soon";
        }
    }
    return "";
};


const $3439533c92dac9bf$export$2634c0ca80eb1d43 = {
    defaultSort: {
        name: "asc"
    },
    extraSelect: [
        "disabled"
    ],
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Account",
            field: "name",
            width: 200,
            template: (account)=>`<span class="${(0, $2ca9fcd86dc38755$export$188d75d71883854a)(account.disabled && "text-more-muted text-decoration-line-through")}">${account.name}</span>`
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Owner",
            field: "ownerName"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Owner First Name",
            field: "ownerFirstName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Owner Last Name",
            field: "ownerLastName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Owner Email",
            field: "ownerEmail",
            visible: true,
            template: `<a href="https://secure.helpscout.net/mailbox/7609c22d0de816ac/new-ticket/?email=\${ownerEmail}" target="_blank">\${ownerEmail}</a>`
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            uid: "lastSeenDate",
            header: "Last Seen",
            field: "lastSeenTime",
            format: "dayMonthYear",
            emptyText: "Never"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            uid: "lastSeenTime",
            header: "At",
            field: "lastSeenTime",
            format: "time",
            emptyText: "Never",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Trial Expires",
            field: "trialExpiresTime",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Trial Days",
            field: "trialDaysLeft"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Last Follow Up",
            field: "lastTrialFollowUpCode",
            emptyText: "None",
            template: (account)=>{
                const { lastTrialFollowUpCode: lastTrialFollowUpCode, trialDaysLeft: trialDaysLeft } = account;
                let cssClass;
                if (trialDaysLeft === null || trialDaysLeft < -14) cssClass = "text-more-muted";
                else if (!lastTrialFollowUpCode) cssClass = "text-danger";
                else if (lastTrialFollowUpCode === "Skip") cssClass = "text-more-muted";
                else {
                    const lastTrialFollowUpDay = parseInt(lastTrialFollowUpCode);
                    const nextTrialFollowUpDay = (0, $e56e694ede576bd9$export$e6d857db2421f697).find((day)=>day < lastTrialFollowUpDay);
                    cssClass = nextTrialFollowUpDay !== undefined && trialDaysLeft <= nextTrialFollowUpDay ? "text-danger" : "text-success";
                }
                return `<span class="${cssClass}">${lastTrialFollowUpCode ?? "None"}</span>`;
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Plan",
            field: "planName",
            emptyText: "None"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Features",
            field: "features",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Fee",
            field: "subscriptionFee"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Sub Created",
            field: "subscriptionCreatedAt",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Sub Expires",
            field: "subscriptionExpiresTime",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Sub Days",
            field: "subscriptionDaysLeft"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Sub Cancelled",
            field: "subscriptionCancelledTime",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Users",
            field: "userCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Active (30D)",
            field: "activeUserCount",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "User Limit",
            field: "userLimit",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Clients",
            field: "clientCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Client Limit",
            field: "companyLimit",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Individuals",
            field: "individualCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Individual Limit",
            field: "individualLimit",
            visible: false
        }),
        // numberColumn({
        //   header: 'Tasks',
        //   field: 'taskCount',
        //   visible: false,
        // }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Tasks",
            field: "currentTaskCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Recurring",
            field: "recurringTaskCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Smart",
            field: "smartTaskCount"
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Created (30D)",
            field: "recentlyCreatedTaskCount",
            visible: false
        }),
        (0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
            header: "Completed (30D)",
            field: "recentlyCompletedTaskCount"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Created",
            field: "createdTime",
            visible: false
        })
    ]
};




const $83d058ef140bebbb$export$cdd53db044208a32 = (options)=>{
    const { uid: uid, field: field } = options;
    return {
        uid: uid ?? field,
        field: field,
        visible: false,
        showInColumnChooser: false
    };
};




const $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5 = (options)=>{
    const { uid: uid, field: field } = options;
    return (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
        uid: uid,
        field: field,
        header: "Notes (First Line)",
        template: `\${if(notesExcerpt)}\${notesExcerpt}\${else}<span class="text-more-muted">No notes</span>\${/if}`,
        width: 200,
        visible: false
    });
};


const $65433cb4b68c5b0a$export$602816eaf52dbb18 = (options)=>{
    const { uid: uid, field: field } = options;
    return {
        uid: uid ?? field,
        field: field,
        type: "boolean",
        headerText: "",
        headerTemplate: `<i class="grid-tooltip fa-regular fa-note-sticky text-more-muted" title="Notes (First Line)" data-bs-placement="top"></i>`,
        template: `\${if(${options.field})}<i class="grid-tooltip fa-regular fa-note-sticky text-primary" title="\${notesExcerpt}" data-bs-placement="right"></i>\${/if}`,
        clipMode: "Clip",
        headerTextAlign: "Center",
        textAlign: "Center",
        allowReordering: false,
        allowFiltering: false,
        showInColumnChooser: false,
        width: 30
    };
};




const $68e797964c39e346$export$4e79f2aa7e2d0b76 = (options)=>{
    const { uid: uid, field: field } = options;
    return (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
        uid: uid,
        field: field,
        header: "Reg Number",
        template: `\${if(${field})}<a href="${(0, $55576f0fdfdeec43$export$9db65ea1b5d08a0)(`\${${field}}`)}" target="_blank" class="grid-link">\${${field}}</a>\${else}<span class="text-more-muted">Not set</span>\${/if}`
    });
};





const $65dcae3035447216$var$width = 150;
const $65dcae3035447216$export$db0046d1be090325 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "taskCount",
        header: "Tasks",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}"
        }),
        positiveSuffix: $65dcae3035447216$var$pluralSuffix(" task", "taskCount"),
        zeroText: "No tasks",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$6b00c52339025bd1 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "scheduledTaskCount",
        header: "Scheduled",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Scheduled
        }),
        positiveSuffix: " scheduled",
        zeroText: "None scheduled",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$8f037f50e459efae = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "unscheduledTaskCount",
        header: "Unscheduled",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Unscheduled
        }),
        positiveSuffix: " to schedule",
        zeroText: "None to schedule",
        allowFiltering: false,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$e604e26fea1668aa = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "recordsRequiredTaskCount",
        header: "Records Required",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            recordsStatus: (0, $19ee14db620c232e$export$63d378a8b71e6d2a).Required
        }),
        positiveSuffix: " required",
        zeroText: "None required",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$bd9e6a27ff0ce04c = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "recordsReceivedTaskCount",
        header: "Records Received",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            recordsStatus: (0, $19ee14db620c232e$export$63d378a8b71e6d2a).Received
        }),
        positiveSuffix: " received",
        zeroText: "None received",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$480eb5d68fcbe = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "startDueTaskCount",
        header: "Start Due",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).StartDue
        }),
        positiveClass: "text-warning",
        positiveSuffix: " due to start",
        zeroText: "None to start",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$f2a71455b7fe4533 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "startedTaskCount",
        header: "Started",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Started
        }),
        positiveClass: "text-success",
        positiveSuffix: " started",
        zeroText: "None started",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$d8475228fdf74160 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "completionDueTaskCount",
        header: "Completion Due",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).CompletionDue
        }),
        positiveClass: "text-warning",
        positiveSuffix: " due to complete",
        zeroText: "None to complete",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$a58f2453e60a49a6 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "completedTaskCount",
        header: "Completed (All Time)",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed
        }),
        positiveClass: "text-success",
        positiveSuffix: " completed",
        zeroText: "None completed",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$52b05f2ea124e661 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "completed30DaysTaskCount",
        header: "Completed (30 Days)",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            preset: "completed30Days"
        }),
        positiveClass: "text-success",
        positiveSuffix: " completed",
        zeroText: "None completed",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$97afba8f9bc39287 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "deadlineDateDueTaskCount",
        header: "Deadline Due",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).DeadlineDue
        }),
        positiveClass: "text-danger",
        positiveSuffix: " due",
        zeroText: "None due",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$76b8850a478800c7 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "uncompletedTaskCount",
        header: "Tasks",
        linkUrl: (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
            [options.linkIdField]: "{id}",
            preset: "uncompleted"
        }),
        positiveSuffix: $65dcae3035447216$var$pluralSuffix(" task", "uncompletedTaskCount"),
        zeroText: "No tasks",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$65e6f4f214c24446 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "recurringTaskCount",
        header: "Recurring",
        linkUrl: (0, $55576f0fdfdeec43$export$d7220ab4bc91d854)({
            [options.linkIdField]: "{id}"
        }),
        positiveSuffix: " recurring",
        zeroText: "No recurring",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$399f37c6b8692e70 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "scheduledRecurringTaskCount",
        header: "Recurring",
        linkUrl: (0, $55576f0fdfdeec43$export$d7220ab4bc91d854)({
            [options.linkIdField]: "{id}",
            status: (0, $19ee14db620c232e$export$8969cfa1402e2c52).Scheduled
        }),
        positiveSuffix: " recurring",
        zeroText: "No recurring",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? true
    });
const $65dcae3035447216$export$fff5367f57209c41 = (options)=>(0, $1bffc48b1ad750b0$export$a3730b14818decf5)({
        uid: options.uid,
        field: "smartTaskCount",
        header: "Smart Tasks",
        linkUrl: (0, $55576f0fdfdeec43$export$6c686320cc2a12f9)({
            [options.linkIdField]: "{id}"
        }),
        positiveSuffix: $65dcae3035447216$var$pluralSuffix(" Smart Task", "smartTaskCount"),
        zeroText: "No Smart Tasks",
        allowFiltering: false,
        width: $65dcae3035447216$var$width,
        visible: options.visible ?? false
    });
const $65dcae3035447216$var$pluralSuffix = (suffix, field)=>`${suffix}\${if(${field} > 1)}s\${/if}`;





const $4d1a1429aadffbcd$export$e7d514cbd9e339fe = {
    defaultSort: {
        name: "asc"
    },
    columns: [
        // Hidden columns
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "serviceIds"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "dueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "accountsDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "amlCheckDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "bookkeepingDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "cisReturnDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "confirmationStatementDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "payrollDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "taxReturnDueTimeFrames"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "vatReturnDueTimeFrames"
        }),
        // Visible columns
        (0, $65433cb4b68c5b0a$export$602816eaf52dbb18)({
            field: "hasNotes"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Reference",
            field: "internalReference",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Name",
            field: "name",
            width: 300,
            emptyText: "Importing..."
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Type",
            field: "companyType",
            template: "${window.formatters.formatCompanyType(companyType)}",
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$97fd21cceb1e64f3))
                }
            }
        }),
        (0, $68e797964c39e346$export$4e79f2aa7e2d0b76)({
            field: "registrationNumber"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Date of Incorporation",
            field: "incorporationDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Trading Start Date",
            field: "tradingStartDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Year End",
            field: "yearEndDate",
            format: "dayLongMonth",
            extra: {
                filter: {
                    minDate: (0, $e56e694ede576bd9$export$f5cf78abc0513307),
                    maxDate: (0, $e56e694ede576bd9$export$7ebe3995293fd6a4)
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "UTR Number",
            field: "utr",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Contact First Name",
            field: "principalContactFirstName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Contact Last Name",
            field: "principalContactLastName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Contact Phone",
            field: "contactTelephoneNumber",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Contact Email",
            field: "principalContactEmail",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Accounts Last Made Up To",
            field: "accountsLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Accounts Period End",
            field: "accountsPeriodEndDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Accounts Due",
            field: "accountsDueDate",
            due: true
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Confirmation Statement Last Date",
            field: "confirmationStatementLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Confirmation Statement Next Date",
            field: "confirmationStatementNextMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Confirmation Statement Due",
            field: "confirmationStatementDueDate",
            due: true
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Registered as Tax Agent",
            field: "registeredAsTaxAgentDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Last Made Up To",
            field: "taxReturnLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Period End",
            field: "taxPeriodEndDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Due",
            field: "taxReturnDueDate",
            due: true,
            visible: true
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Payment Last Made Up To",
            field: "taxPaymentLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Payment Due",
            field: "taxPaymentDueDate",
            due: true,
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "VAT Number",
            field: "vatHmrcRegistrationNumber",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Registered as Agent",
            field: "registeredAsVatAgentDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Registration Date",
            field: "vatRegistrationDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Deregistration Date",
            field: "vatDeregistrationDate",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "VAT Quarters",
            field: "vatQuarters",
            extra: {
                displayField: "vatQuartersName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$b32b5fd24133a029), "/")
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Last Made Up To",
            field: "vatLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Period End",
            field: "vatPeriodEndDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "VAT Return Due",
            field: "vatReturnDueDate",
            due: true
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "PAYE Reference",
            field: "payeReference",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "PAYE Accounts Office Reference",
            field: "payeAccountsOfficeReferenceNumber",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "PAYE Registered as Agent",
            field: "registeredAsPayeAgentDate",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Payroll Frequency",
            field: "payrollFrequency",
            visible: false,
            extra: {
                displayField: "payrollFrequencyName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$dea1348d86434c4a))
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Payroll Start",
            field: "payrollStartDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Payroll Last Made Up To",
            field: "payrollLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Payroll Due",
            field: "payrollDueDate",
            due: true,
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Payroll Payment Due",
            field: "payrollPaymentDueDate",
            due: true,
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "CIS Registered as Agent",
            field: "registeredAsCisAgentDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "CIS Start",
            field: "cisStartDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "CIS Last Made Up To",
            field: "cisLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "CIS Period End",
            field: "cisPeriodEndDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "CIS Return Due",
            field: "cisReturnDueDate",
            due: true,
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Bookkeeping Frequency",
            field: "bookkeepingFrequency",
            visible: false,
            extra: {
                displayField: "bookkeepingFrequencyName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$6753c3448f1fa548))
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Bookkeeping Start",
            field: "bookkeepingStartDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Bookkeeping Last Made Up To",
            field: "bookkeepingLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Bookkeeping Due",
            field: "bookkeepingDueDate",
            due: true,
            visible: false
        }),
        (0, $65dcae3035447216$export$76b8850a478800c7)({
            linkIdField: "clientId"
        }),
        (0, $65dcae3035447216$export$480eb5d68fcbe)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $65dcae3035447216$export$d8475228fdf74160)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $65dcae3035447216$export$97afba8f9bc39287)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Added",
            field: "createdTime",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Engagement Signed",
            field: "engagementSignedDate",
            visible: false,
            emptyText: "Not signed",
            emptyClass: "text-danger"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "AML Last Checked",
            field: "amlLastCheckedDate",
            visible: false,
            emptyText: "Never checked",
            emptyClass: "text-danger"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "AML Check Due",
            field: "amlCheckDueDate",
            visible: false,
            due: true,
            emptyText: "Never checked",
            emptyClass: "text-danger"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Account Manager",
            field: "accountManagerId",
            extra: {
                displayField: "accountManagerName",
                sortField: "accountManagerName",
                filter: {
                    lookup: "MemberView"
                }
            },
            width: 200
        }),
        (0, $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5)({
            field: "notesExcerpt"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Archived",
            field: "archivedTime",
            visible: false
        })
    ]
};


const $6c2fd6a8807d5057$export$77e762fdc582c7c3 = (options)=>{
    const { uid: uid, field: field, header: header, iconClass: iconClass, allowFiltering: allowFiltering, allowSorting: allowSorting, visible: visible } = options ?? {};
    return {
        uid: uid ?? field,
        field: field,
        headerText: header,
        headerTemplate: iconClass ? `<i class="${iconClass} text-more-muted" title="${header}"></i>` : undefined,
        type: "boolean",
        headerTextAlign: "Center",
        textAlign: "Center",
        template: `\${if(${field})}<i class="fa-solid fa-circle-check text-primary"></i>\${/if}`,
        allowFiltering: allowFiltering ?? true,
        allowSorting: allowSorting ?? true,
        width: 100,
        visible: visible ?? true,
        extra: {
            filter: {
                options: [
                    {
                        text: "True",
                        value: true
                    },
                    {
                        text: "False",
                        value: false
                    }
                ]
            }
        }
    };
};









const $91d84dc792a8621e$export$a5ac544e5fe594be = {
    defaultSort: {
        name: "asc"
    },
    columns: [
        // Hidden columns
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "serviceIds"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "dueTimeFrames"
        }),
        // Visible columns
        (0, $65433cb4b68c5b0a$export$602816eaf52dbb18)({
            field: "hasNotes"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Reference",
            field: "internalReference",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "First Name",
            field: "givenName"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Last Name",
            field: "surname"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "DOB",
            field: "birthDate",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "UTR Number",
            field: "utr",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "NI Number",
            field: "nationalInsuranceNumber",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Passport Number",
            field: "passportNumber",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Phone",
            field: "contactTelephoneNumber"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Email",
            field: "emailAddress"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Registered as Tax Agent",
            field: "registeredAsTaxAgentDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Trading Start Date",
            field: "tradingStartDate",
            visible: false
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "Tax Return Required",
            field: "taxReturnRequired"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Last Made Up To",
            field: "taxReturnLastMadeUpToDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Period End",
            field: "taxReturnPeriodEndDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Tax Return Due",
            field: "taxReturnDueDate",
            due: true
        }),
        (0, $65dcae3035447216$export$76b8850a478800c7)({
            linkIdField: "clientId"
        }),
        (0, $65dcae3035447216$export$480eb5d68fcbe)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $65dcae3035447216$export$d8475228fdf74160)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $65dcae3035447216$export$97afba8f9bc39287)({
            linkIdField: "clientId",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Added",
            field: "createdTime",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Engagement Signed",
            field: "engagementSignedDate",
            visible: false,
            emptyText: "Not signed",
            emptyClass: "text-danger"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "AML Last Checked",
            field: "amlLastCheckedDate",
            visible: false,
            emptyText: "Never checked",
            emptyClass: "text-danger"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "AML Check Due",
            field: "amlCheckDueDate",
            visible: false,
            due: true,
            emptyText: "Never checked",
            emptyClass: "text-danger"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Account Manager",
            field: "accountManagerId",
            extra: {
                displayField: "accountManagerName",
                sortField: "accountManagerName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5)({
            field: "notesExcerpt"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Archived",
            field: "archivedTime",
            visible: false
        })
    ]
};








const $cc9f20dc33f767da$export$3c6633f5adaefd12 = {
    defaultSort: {
        name: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Name",
            field: "name"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Email",
            field: "email"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Role",
            field: "role",
            extra: {
                displayField: "roleName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$8829c45006c81633))
                }
            }
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "2FA",
            field: "mfaEnabled",
            allowFiltering: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Invited",
            field: "createdTime",
            format: "dayMonthYearTime",
            allowFiltering: false,
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Last Seen",
            field: "lastSeenTime",
            format: "dayMonthYearTime",
            emptyText: "Never",
            allowFiltering: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Archived",
            field: "archivedTime",
            visible: false
        })
    ]
};









var $fae5a78d0cec85ca$export$1427b738abd061e2;
(function(ScheduleFrequency) {
    ScheduleFrequency["Days"] = "Days";
    ScheduleFrequency["Weeks"] = "Weeks";
    ScheduleFrequency["Months"] = "Months";
    ScheduleFrequency["Years"] = "Years";
})($fae5a78d0cec85ca$export$1427b738abd061e2 || ($fae5a78d0cec85ca$export$1427b738abd061e2 = {}));
var $fae5a78d0cec85ca$export$98e691221729c2;
(function(ScheduleDayOfWeek) {
    ScheduleDayOfWeek[ScheduleDayOfWeek["Mon"] = 1] = "Mon";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Tue"] = 2] = "Tue";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Wed"] = 3] = "Wed";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Thu"] = 4] = "Thu";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Fri"] = 5] = "Fri";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Sat"] = 6] = "Sat";
    ScheduleDayOfWeek[ScheduleDayOfWeek["Sun"] = 7] = "Sun";
})($fae5a78d0cec85ca$export$98e691221729c2 || ($fae5a78d0cec85ca$export$98e691221729c2 = {}));
var $fae5a78d0cec85ca$export$5095f2a4b0c6c015;
(function(ScheduleDayOfMonth) {
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stMon"] = 101] = "1stMon";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stTue"] = 102] = "1stTue";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stWed"] = 103] = "1stWed";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stThu"] = 104] = "1stThu";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stFri"] = 105] = "1stFri";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stSat"] = 106] = "1stSat";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1stSun"] = 107] = "1stSun";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndMon"] = 108] = "2ndMon";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndTue"] = 109] = "2ndTue";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndWed"] = 110] = "2ndWed";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndThu"] = 111] = "2ndThu";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndFri"] = 112] = "2ndFri";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndSat"] = 113] = "2ndSat";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2ndSun"] = 114] = "2ndSun";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdMon"] = 115] = "3rdMon";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdTue"] = 116] = "3rdTue";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdWed"] = 117] = "3rdWed";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdThu"] = 118] = "3rdThu";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdFri"] = 119] = "3rdFri";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdSat"] = 120] = "3rdSat";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rdSun"] = 121] = "3rdSun";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thMon"] = 122] = "4thMon";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thTue"] = 123] = "4thTue";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thWed"] = 124] = "4thWed";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thThu"] = 125] = "4thThu";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thFri"] = 126] = "4thFri";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thSat"] = 127] = "4thSat";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4thSun"] = 128] = "4thSun";
    ScheduleDayOfMonth[ScheduleDayOfMonth["1st"] = 201] = "1st";
    ScheduleDayOfMonth[ScheduleDayOfMonth["2nd"] = 202] = "2nd";
    ScheduleDayOfMonth[ScheduleDayOfMonth["3rd"] = 203] = "3rd";
    ScheduleDayOfMonth[ScheduleDayOfMonth["4th"] = 204] = "4th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["5th"] = 205] = "5th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["6th"] = 206] = "6th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["7th"] = 207] = "7th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["8th"] = 208] = "8th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["9th"] = 209] = "9th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["10th"] = 210] = "10th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["11th"] = 211] = "11th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["12th"] = 212] = "12th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["13th"] = 213] = "13th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["14th"] = 214] = "14th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["15th"] = 215] = "15th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["16th"] = 216] = "16th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["17th"] = 217] = "17th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["18th"] = 218] = "18th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["19th"] = 219] = "19th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["20th"] = 220] = "20th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["21st"] = 221] = "21st";
    ScheduleDayOfMonth[ScheduleDayOfMonth["22nd"] = 222] = "22nd";
    ScheduleDayOfMonth[ScheduleDayOfMonth["23rd"] = 223] = "23rd";
    ScheduleDayOfMonth[ScheduleDayOfMonth["24th"] = 224] = "24th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["25th"] = 225] = "25th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["26th"] = 226] = "26th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["27th"] = 227] = "27th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["28th"] = 228] = "28th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["29th"] = 229] = "29th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["30th"] = 230] = "30th";
    ScheduleDayOfMonth[ScheduleDayOfMonth["31st"] = 231] = "31st";
    ScheduleDayOfMonth[ScheduleDayOfMonth["LastDay"] = -1] = "LastDay";
})($fae5a78d0cec85ca$export$5095f2a4b0c6c015 || ($fae5a78d0cec85ca$export$5095f2a4b0c6c015 = {}));
const $fae5a78d0cec85ca$export$2c8ffd96ed1a6a77 = {
    ...$fae5a78d0cec85ca$export$98e691221729c2,
    ...$fae5a78d0cec85ca$export$5095f2a4b0c6c015
};
var $fae5a78d0cec85ca$export$9dbfea4fd6aa89f7;
(function(ScheduleOffsetType) {
    ScheduleOffsetType["Days"] = "d";
    ScheduleOffsetType["BusinessDays"] = "b";
    ScheduleOffsetType["Weeks"] = "w";
    ScheduleOffsetType["Months"] = "m";
    ScheduleOffsetType["Years"] = "y";
    ScheduleOffsetType["StartsOfWeek"] = "s";
    ScheduleOffsetType["StartsOfMonth"] = "t";
    ScheduleOffsetType["StartsOfYear"] = "u";
    ScheduleOffsetType["EndsOfWeek"] = "n";
    ScheduleOffsetType["EndsOfMonth"] = "e";
    ScheduleOffsetType["EndsOfYear"] = "z";
})($fae5a78d0cec85ca$export$9dbfea4fd6aa89f7 || ($fae5a78d0cec85ca$export$9dbfea4fd6aa89f7 = {}));
var $fae5a78d0cec85ca$export$db515022acd1f7e9;
(function(ScheduleOffsetDirection) {
    ScheduleOffsetDirection["Before"] = "-";
    ScheduleOffsetDirection["After"] = "+";
})($fae5a78d0cec85ca$export$db515022acd1f7e9 || ($fae5a78d0cec85ca$export$db515022acd1f7e9 = {}));




const $a81a9d6843a451e9$export$6a67099e11fa6cb9 = {
    extraSelect: [
        "scheduleDay"
    ],
    adapter: (task)=>{
        if (task.scheduleDay) task.scheduleDaysDescription = (0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $fae5a78d0cec85ca$export$2c8ffd96ed1a6a77), task.scheduleDay);
    },
    defaultFilters: {
        status: {
            operator: "notequal",
            value: (0, $19ee14db620c232e$export$8969cfa1402e2c52).Completed
        }
    },
    defaultSort: {
        task: "asc"
    },
    extraSort: {
        clientName: "asc",
        task: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $65433cb4b68c5b0a$export$602816eaf52dbb18)({
            field: "hasNotes"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Task",
            field: "task",
            width: 300
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Service",
            field: "serviceId",
            width: 200,
            extra: {
                displayField: "serviceName",
                sortField: "serviceName",
                filter: {
                    lookup: "Service"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client Type",
            field: "clientType",
            visible: false,
            extra: {
                displayField: "clientTypeName",
                sortField: "clientTypeName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$4cd8cc03ec8c034a))
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client",
            field: "clientId",
            width: 300,
            extra: {
                displayField: "clientName",
                sortField: "clientName",
                filter: {
                    lookup: "ClientView"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "First Name",
            field: "clientFirstName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Last Name",
            field: "clientLastName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Registration Number",
            field: "clientCompanyRegistrationNo",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "UTR",
            field: "clientUtr",
            visible: false
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "Records Required",
            field: "recordsRequired",
            iconClass: "fa-solid fa-folder-closed"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Schedule",
            field: "scheduleDescription",
            emptyText: "One Off",
            emptyClass: "text-more-muted",
            width: 120
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Day",
            field: "scheduleDaysDescription",
            emptyText: "Any",
            allowFiltering: false,
            allowSorting: false,
            width: 100
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "From",
            field: "startFromDate"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Until",
            field: "continueUntilDate",
            emptyText: "Ongoing"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Added",
            field: "createdTime",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Added By",
            field: "createdByUserId",
            visible: false,
            extra: {
                displayField: "createdByUserName",
                sortField: "createdByUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Assigned To",
            field: "assignedToUserId",
            emptyText: "Not assigned",
            extra: {
                displayField: "assignedToUserName",
                sortField: "assignedToUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5)({
            field: "notesExcerpt"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Status",
            field: "status",
            textAlign: "Center",
            template: `<span class="task-status task-status-\${window.formatters.formatClassName(status)}">\${status}</span>`,
            visible: false,
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$8969cfa1402e2c52))
                }
            }
        })
    ]
};






const $807176c17020e2af$export$57f07472755a6548 = {
    defaultSort: {
        name: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Service",
            field: "name"
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "Show Tab in Tasks",
            field: "showInNav"
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Archived",
            field: "archivedTime",
            visible: false
        })
    ]
};










const $30cbbec02012bf66$export$fb3547d4a9c288d3 = {
    defaultSort: {
        task: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $65433cb4b68c5b0a$export$602816eaf52dbb18)({
            field: "hasNotes"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Task",
            field: "task",
            width: 300
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Service",
            field: "serviceId",
            width: 200,
            extra: {
                displayField: "serviceName",
                sortField: "serviceName",
                filter: {
                    lookup: "Service"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client Type",
            field: "clientTypeName",
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$4cd8cc03ec8c034a))
                }
            }
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "Records Required",
            field: "recordsRequired",
            iconClass: "fa-solid fa-folder-closed"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Type",
            field: "smartTaskType",
            template: `\${window.formatters.formatSmartTaskType(smartTaskType)}`,
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$565e37f6a005bc8))
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Update",
            field: "updateOnCompletion",
            template: `\${if(updateOnCompletion)}\${window.formatters.formatUpdateOnCompletion(updateOnCompletion)}\${else}<span class="text-more-muted">Not set</span>\${/if}`,
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$a2d5e26d840f3aaf))
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Added",
            field: "createdTime",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Added By",
            field: "createdByUserId",
            visible: false,
            extra: {
                displayField: "createdByUserName",
                sortField: "createdByUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5)({
            field: "notesExcerpt"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Assign To",
            field: "assignedToUserId",
            emptyText: "Account Manager",
            extra: {
                displayField: "assignedToUserName",
                sortField: "assignedToUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        })
    ]
};






const $79bc64c1a56d5e7a$export$59f9efadaf652264 = (options)=>{
    const { uid: uid, field: field, header: header, type: type, action: action, text: text, class: cls, iconClass: iconClass, toggleIf: toggleIf, hideIf: hideIf, visible: visible } = options ?? {};
    const toggleCondition = toggleIf ? (0, $a4990d2aafe232be$export$98b7e9af4eeecc18)(toggleIf) : undefined;
    const hideCondition = hideIf ? (0, $a4990d2aafe232be$export$98b7e9af4eeecc18)(hideIf) : undefined;
    const template = `
  <button class="${(0, $2ca9fcd86dc38755$export$188d75d71883854a)("button", "grid-button", "btn", "btn-sm", cls ?? "btn-outline-primary")}" data-id="\${id}" data-field="${field}" data-action="${action}" ${toggleIf ? `data-toggled="\${if(${toggleCondition})}true\${else}false\${/if}"` : ""} ${hideIf ? `data-hide="\${if(${hideCondition})}true\${else}false\${/if}"` : ""}>
      ${iconClass ? `<i class="${(0, $2ca9fcd86dc38755$export$188d75d71883854a)(iconClass, text && " me-2")}"></i>` : ""}
      ${text ? `<span>${text}</span>` : ""} 
  </button>`;
    return {
        uid: uid ?? field,
        // Always set to id as we don't need to sort and filter button columns and if we set to a column we do
        // want to be able to sort and filter on then if the button column appears before the filter column it
        // will prevent the filter from working (seems EJ2 grid only allows one column to filter a given field)
        field: "id",
        headerText: header,
        headerTemplate: iconClass ? `<i class="grid-tooltip ${iconClass} text-more-muted" title="${header}" data-bs-placement="top"></i>` : undefined,
        type: type,
        template: template,
        headerTextAlign: "Center",
        textAlign: "Center",
        allowSorting: false,
        allowFiltering: false,
        width: 50,
        visible: visible ?? true
    };
};













const $64236c7731d2b476$export$2b6ebc5cafa58b49 = {
    extraSelect: [
        "scheduleDay",
        "smartTaskId",
        "startable",
        "completable",
        "currentSubTaskIndex",
        "subTaskCount",
        "subTaskCompleteCount"
    ],
    adapter: (task)=>{
        if (task.scheduleDay) task.scheduleDaysDescription = (0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $fae5a78d0cec85ca$export$2c8ffd96ed1a6a77), task.scheduleDay);
    },
    defaultFilters: {
        status: {
            operator: "notequal",
            value: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed
        }
    },
    defaultSort: {
        deadlineDate: "asc"
    },
    extraSort: {
        clientName: "asc",
        task: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "recordsStatus"
        }),
        (0, $83d058ef140bebbb$export$cdd53db044208a32)({
            field: "dueTimeFrames"
        }),
        (0, $65433cb4b68c5b0a$export$602816eaf52dbb18)({
            field: "hasNotes"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Task",
            field: "task",
            width: 300
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Service",
            field: "serviceId",
            width: 150,
            extra: {
                displayField: "serviceName",
                sortField: "serviceName",
                filter: {
                    lookup: "Service"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client Type",
            field: "clientType",
            visible: false,
            extra: {
                displayField: "clientTypeName",
                sortField: "clientTypeName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$4cd8cc03ec8c034a))
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client Reference",
            field: "clientInternalReference",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client",
            field: "clientId",
            width: 300,
            extra: {
                displayField: "clientName",
                sortField: "clientName",
                filter: {
                    lookup: "ClientView"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "First Name",
            field: "clientFirstName",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Last Name",
            field: "clientLastName",
            visible: false
        }),
        (0, $68e797964c39e346$export$4e79f2aa7e2d0b76)({
            field: "clientCompanyRegistrationNumber"
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "UTR",
            field: "clientUtr",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Year End",
            field: "clientYearEnd",
            format: "dayLongMonth",
            visible: false,
            extra: {
                filter: {
                    minDate: (0, $e56e694ede576bd9$export$f5cf78abc0513307),
                    maxDate: (0, $e56e694ede576bd9$export$7ebe3995293fd6a4)
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "VAT Quarters",
            field: "clientVatQuarters",
            visible: false,
            extra: {
                displayField: "clientVatQuartersName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$b32b5fd24133a029), "/")
                }
            }
        }),
        (0, $6c2fd6a8807d5057$export$77e762fdc582c7c3)({
            header: "Records Required",
            field: "recordsRequired",
            visible: false
        }),
        (0, $79bc64c1a56d5e7a$export$59f9efadaf652264)({
            uid: "recordsReceivedButton",
            header: "Records Received",
            field: "recordsReceivedDate",
            type: "date",
            action: "setDateToToday",
            iconClass: "fa-solid fa-folder-closed",
            class: "btn-primary",
            toggleIf: {
                field: "recordsReceivedDate",
                value: null,
                negate: true
            },
            hideIf: {
                field: "recordsRequired",
                value: null
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Records Received On",
            field: "recordsReceivedDate",
            emptyText: "${if(recordsRequired)}Not received${else}Not required${/if}",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Start",
            field: "plannedStartDate",
            overrideDisplayField: "startedDate",
            dueIf: {
                field: "startable",
                value: true
            }
        }),
        (0, $79bc64c1a56d5e7a$export$59f9efadaf652264)({
            uid: "startedButton",
            header: "Started",
            field: "startedDate",
            type: "date",
            action: "setDateToToday",
            iconClass: "fa-solid fa-play",
            class: "btn-warning",
            toggleIf: {
                field: "startedDate",
                value: null,
                negate: true
            },
            hideIf: {
                field: "completedDate",
                value: null,
                negate: true
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Started On",
            field: "startedDate",
            emptyText: "Not started",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Started By",
            field: "startedByUserId",
            visible: false,
            extra: {
                displayField: "startedByUserName",
                sortField: "startedByUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Complete",
            field: "plannedCompletionDate",
            dueIf: {
                field: "completable",
                value: true
            }
        }),
        (0, $79bc64c1a56d5e7a$export$59f9efadaf652264)({
            uid: "completedButton",
            header: "Completed",
            field: "completedDate",
            type: "date",
            action: "setDateToToday",
            iconClass: "fa-solid fa-check",
            class: "btn-success",
            toggleIf: {
                field: "completedDate",
                value: null,
                negate: true
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Completed On",
            field: "completedDate",
            emptyText: "Not completed",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Completed By",
            field: "completedByUserId",
            visible: false,
            extra: {
                displayField: "completedByUserName",
                sortField: "completedByUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Deadline",
            field: "deadlineDate",
            dueIf: {
                field: "completable",
                value: true
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Schedule",
            field: "scheduleDescription",
            allowFiltering: false,
            allowSorting: false,
            emptyText: "${if(smartTaskId)}Smart Task${else}One Off${/if}",
            width: 150
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Day",
            field: "scheduleDaysDescription",
            allowFiltering: false,
            allowSorting: false,
            emptyText: "Any",
            width: 100,
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "From",
            field: "scheduleStartFromDate",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Until",
            field: "scheduleContinueUntilDate",
            emptyText: "${if(recurringTaskId)}Ongoing${else}Not set${/if}",
            visible: false
        }),
        (0, $536115221eb2ad16$export$21fe5488f05bf4cb)({
            header: "Added",
            field: "createdTime",
            visible: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Added By",
            field: "createdByUserId",
            visible: false,
            extra: {
                displayField: "createdByUserName",
                sortField: "createdByUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Assigned To",
            field: "assignedToUserId",
            width: 150,
            emptyText: "Not assigned",
            extra: {
                displayField: "assignedToUserName",
                sortField: "assignedToUserName",
                filter: {
                    lookup: "MemberView"
                }
            }
        }),
        (0, $6d197ad9ea4c9f3b$export$4c29dbfa6cab9fc5)({
            field: "notesExcerpt"
        }),
        (0, $79bc64c1a56d5e7a$export$59f9efadaf652264)({
            uid: "subTaskCompletedButton",
            header: "Checklist Item Completed",
            field: "currentSubTaskCompletedDate",
            type: "date",
            action: "setDateToToday",
            iconClass: "fa-solid fa-check",
            class: "btn-success",
            visible: false,
            toggleIf: {
                field: "currentSubTaskCompletedDate",
                value: null,
                negate: true
            },
            hideIf: {
                field: "subTaskCount",
                value: null
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Checklist",
            field: "currentSubTask",
            template: '${if(subTaskCount && subTaskCount === subTaskCompleteCount)}<span class="text-success">Complete</span>${else}${if(currentSubTask)}${currentSubTask}<span class="float-end text-more-muted">(${currentSubTaskIndex}/${subTaskCount})</span>${else}<span class="text-more-muted">No checklist</span>${/if}${/if}',
            // '${if(subTaskCount)}${if(subTaskCount === subTaskCompleteCount)}<span class="text-success">Complete</span>${else}${currentSubTask}${/if}<span class="float-end text-more-muted">(${currentSubTaskIndex || subTaskCount}/${subTaskCount})</span>${else}<span class="text-more-muted">No checklist</span>${/if}',
            width: 200,
            visible: false,
            extra: {
                sortField: "currentSubTaskIndex",
                filter: {
                    lookup: true
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Status",
            field: "status",
            textAlign: "Center",
            template: '<span class="task-status task-status-${window.formatters.formatClassName(status)}">${window.formatters.formatTaskStatus(status)}</span>',
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$61db76a97f26b7e1))
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Priority",
            field: "priority",
            textAlign: "Center",
            template: '<span class="priority priority-${priority}">${window.formatters.formatPriority(priority)}</span>',
            extra: {
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$300334f671c43555))
                }
            }
        })
    ]
};






const $17b7e487ed557f24$export$fc7b11b7b188354 = {
    defaultSort: {
        name: "asc"
    },
    columns: [
        (0, $8425acb746879d03$export$108c17e5c52b7df8)(),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Template",
            field: "name",
            width: 300,
            allowFiltering: false
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Service",
            field: "serviceId",
            width: 200,
            allowFiltering: false,
            extra: {
                displayField: "serviceName",
                sortField: "serviceName",
                filter: {
                    lookup: "Service"
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Client Type",
            field: "clientType",
            allowFiltering: false,
            extra: {
                displayField: "clientTypeName",
                sortField: "clientTypeName",
                filter: {
                    options: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$4cd8cc03ec8c034a))
                }
            }
        }),
        (0, $f56b939cc3f4e537$export$37552c4c789a7634)({
            header: "Subject",
            field: "subject",
            width: 1000,
            allowFiltering: false
        })
    ]
};


const $c32bcf77a46d9b1a$export$44afbce30f6a42e5 = {
    AccountView: (0, $3439533c92dac9bf$export$2634c0ca80eb1d43),
    CompanyView: (0, $4d1a1429aadffbcd$export$e7d514cbd9e339fe),
    IndividualView: (0, $91d84dc792a8621e$export$a5ac544e5fe594be),
    MemberView: (0, $cc9f20dc33f767da$export$3c6633f5adaefd12),
    RecurringTaskView: (0, $a81a9d6843a451e9$export$6a67099e11fa6cb9),
    ServiceView: (0, $807176c17020e2af$export$57f07472755a6548),
    SmartTaskView: (0, $30cbbec02012bf66$export$fb3547d4a9c288d3),
    TaskView: (0, $64236c7731d2b476$export$2b6ebc5cafa58b49),
    TemplateView: (0, $17b7e487ed557f24$export$fc7b11b7b188354)
};







const $e625b333c39c8463$export$635e15bbd66f01ea = (type)=>{
    document.dispatchEvent(new Event(type));
};
const $e625b333c39c8463$export$63174c828edd6ff8 = (type, handler)=>{
    document.addEventListener(type, handler);
};




(0, $e7i2H.L10n).load({
    [(0, $d47525176c3f6cd7$export$1af4c7e47ad72f44).code]: {
        grid: {
            EmptyRecord: "",
            Columnchooser: '<i class="fa-solid fa-table-columns"></i>',
            ChooseColumns: "Choose columns",
            SelectAll: "Show all columns"
        }
    }
});
// <gridId, grid>
const $2fb2c27c9772a1c5$var$grids = {};
// <gridId, userGridSettings>
const $2fb2c27c9772a1c5$var$userGridSettings = {};
// <gridId, <field, value>>
const $2fb2c27c9772a1c5$var$filters = {};
const $2fb2c27c9772a1c5$var$scrollLefts = {};
(0, $503c118799028775$export$ef2184bd89960b14).Inject((0, $6df371599d7d9c78$export$83e0e5d4eae2b8ed), (0, $0f7a73cd92e9f074$export$9860ff607cfdeed8), (0, $d0beb9f5041cd55b$export$ec91da630f36d5ea), (0, $ed66721474bb02be$export$c5295390d6167a3e), (0, $5d65e63dd7eec2c1$export$6955bcca4cd3539f), (0, $6807bc11aae112a3$export$76856258f71db1ea), (0, $3bf4dd04897d8ed7$export$335fca4219867448), (0, $f156c0a94af14ffc$export$52baac22726c72bf), (0, $e02f22598f2cfb09$export$d43f91ac58cde147));
const $2fb2c27c9772a1c5$var$resizeGrid = ()=>{
    const ids = (0, $81088ee9a0e19312$export$ed97f33186d4b816)($2fb2c27c9772a1c5$var$grids);
    if (ids.length === 1) {
        const gridElement = document.getElementById(ids[0]);
        const grid = $2fb2c27c9772a1c5$var$grids[ids[0]];
        grid.height = window.innerHeight - grid.element.offsetTop - gridElement.querySelector(".e-gridheader").clientHeight - 20;
    }
};
window.addEventListener("resize", (0, $cdd05a6aa3de24f9$exports.debounce)($2fb2c27c9772a1c5$var$resizeGrid), true);
window.addEventListener("refreshGrids", ()=>{
    $2fb2c27c9772a1c5$export$2b7261532f749c9();
});
document.addEventListener("DOMContentLoaded", async ()=>{
    for (const element of [
        ...document.querySelectorAll(".grid")
    ])await $2fb2c27c9772a1c5$var$initGrid(element);
    for (const element of [
        ...document.querySelectorAll(".grid-column-picker")
    ])$2fb2c27c9772a1c5$var$initGridColumnPicker(element);
    for (const element of [
        ...document.querySelectorAll(".grid-view-picker")
    ])$2fb2c27c9772a1c5$var$initGridViewPicker(element);
    for (const element of [
        ...document.querySelectorAll("[data-grid-action]")
    ])$2fb2c27c9772a1c5$var$initGridAction(element);
    for (const element of [
        ...document.querySelectorAll(".grid-filter-picker")
    ])$2fb2c27c9772a1c5$var$initGridFilter(element);
    for (const element of [
        ...document.querySelectorAll(".grid")
    ])await $2fb2c27c9772a1c5$var$bindGrid(element);
    (0, $e625b333c39c8463$export$635e15bbd66f01ea)("gridsReady");
});
const $2fb2c27c9772a1c5$var$initGrid = async (element)=>{
    const gridId = element.id;
    const modelName = element.dataset.model;
    const view = element.dataset.view;
    const allowEditColumns = element.dataset.allowEditColumns === "true";
    const allowExport = element.dataset.allowExport === "true";
    const disabledColumns = (element.dataset.disabledColumns ?? "").split(",");
    const settings = (0, $c32bcf77a46d9b1a$export$44afbce30f6a42e5)[modelName];
    if (!settings) throw `Grid settings not found for model: ${modelName}`;
    const userSettings = await $2fb2c27c9772a1c5$var$loadGridSettings(gridId, view);
    const columns = (0, $81088ee9a0e19312$export$784d13d8ee351f07)(settings.columns).filter((column)=>!disabledColumns.includes(column.uid));
    const columnUids = [];
    for(let i = 0; i < columns.length; i++){
        const column = columns[i];
        if (!column.uid) column.uid = column.field;
        if (!columnUids.includes(column.uid)) columnUids.push(column.uid);
        else throw `Duplicate column UID: ${column.uid}`;
        // copy() doesn't copy template functions as uses JSON.stringify/parse
        if (typeof settings.columns[i].template === "function") column.template = settings.columns[i].template;
    }
    // Apply column filter settings before creating grid
    $2fb2c27c9772a1c5$var$applyGridColumnFilterSettings(gridId, columns);
    // Apply column settings before creating grid
    $2fb2c27c9772a1c5$var$applyUserGridColumnSettings(columns, userSettings);
    const grid = new (0, $503c118799028775$export$ef2184bd89960b14)({
        locale: (0, $d47525176c3f6cd7$export$1af4c7e47ad72f44).code,
        columns: columns.map((column)=>(0, $81088ee9a0e19312$export$30a06c8d3562193f)(column, "extra")),
        columnQueryMode: "All",
        showColumnChooser: allowEditColumns,
        clipMode: "Clip",
        allowResizing: allowEditColumns,
        allowReordering: allowEditColumns,
        allowSorting: true,
        allowFiltering: true,
        filterSettings: {
            type: "Menu"
        },
        allowExcelExport: allowExport,
        pageSettings: {
            pageSize: 100
        },
        enableInfiniteScrolling: true,
        infiniteScrollSettings: {
            initialBlocks: 1
        },
        // Best estimate - avoids big jump on initial resize (can't do relative resize until grid rendered)
        // 50 = navbar height, 34 = grid header height, 20 = bottom margin
        height: window.innerHeight - (50 + element.offsetTop + 34 + 20),
        dataBound: $2fb2c27c9772a1c5$var$gridDataBound(gridId),
        actionBegin: $2fb2c27c9772a1c5$var$gridActionBegin(gridId, settings),
        actionComplete: $2fb2c27c9772a1c5$var$gridActionComplete(gridId),
        recordClick: $2fb2c27c9772a1c5$var$gridRecordClick,
        resizeStop: $2fb2c27c9772a1c5$var$gridColumnResize(gridId),
        excelQueryCellInfo: $2fb2c27c9772a1c5$export$a6f097ae6a430bee(settings)
    });
    $2fb2c27c9772a1c5$var$grids[gridId] = grid;
    grid.appendTo(element);
};
const $2fb2c27c9772a1c5$var$bindGrid = async (element)=>{
    const gridId = element.id;
    const modelName = element.dataset.model;
    const view = element.dataset.view;
    const settings = (0, $c32bcf77a46d9b1a$export$44afbce30f6a42e5)[modelName];
    if (!settings) throw `Grid settings not found for model: ${modelName}`;
    const userSettings = await $2fb2c27c9772a1c5$var$loadGridSettings(gridId, view);
    const grid = $2fb2c27c9772a1c5$var$grids[gridId];
    // Apply sort settings after appending grid
    $2fb2c27c9772a1c5$var$applyUserGridSortSettings(gridId, userSettings);
    // e.g. ?f_someId=123&f_someField=lessthanorequal|456
    // i.e. operator is optional and defaults to equal
    const query = new URLSearchParams(location.search);
    const filterKeys = [
        ...query.keys()
    ].filter((key)=>key.startsWith("f_"));
    if (filterKeys.length > 0) for (const filterKey of filterKeys){
        const field = filterKey.substring(2); // Skip 'f_'
        const column = settings.columns.find((column)=>column.field === field);
        if (column) {
            const parts = query.get(filterKey).split("|");
            // TODO greater than
            if ([
                "isnull",
                "isnotnull"
            ].includes(parts[0])) grid.filterByColumn(field, parts[0], null);
            else {
                const operator = parts.length > 1 ? parts[0] : "equal";
                let value = parts.length > 1 ? parts[1] : parts[0];
                if (column.type === "boolean") value = value === "true";
                else if (column.type === "date") value = new Date(Date.parse(value));
                else if (column.type === "number") value = parseFloat(value);
                grid.filterByColumn(field, operator, value, undefined, $2fb2c27c9772a1c5$var$matchCase(column, operator));
            }
        }
    }
    else if (settings.defaultFilters) for (const fieldName of Object.keys(settings.defaultFilters)){
        const filter = settings.defaultFilters[fieldName];
        if (grid.getColumnByField(fieldName)) grid.filterByColumn(fieldName, filter.operator ?? "equal", filter.value, undefined, true);
    }
    setTimeout(()=>{
        $2fb2c27c9772a1c5$var$resizeGrid();
        grid.dataSource = $2fb2c27c9772a1c5$var$gridDataSource({
            gridId: gridId
        });
    }, 100);
};
const $2fb2c27c9772a1c5$var$initGridButtons = ()=>{
    document.querySelectorAll(".grid-button").forEach((element)=>$2fb2c27c9772a1c5$var$initGridButton(element));
    document.querySelectorAll(".grid-tooltip").forEach((element)=>$2fb2c27c9772a1c5$export$353372104066311a(element));
};
const $2fb2c27c9772a1c5$var$initGridButton = (element)=>{
    element.addEventListener("click", $2fb2c27c9772a1c5$var$gridButtonClick);
};
const $2fb2c27c9772a1c5$var$initGridLinks = ()=>{
    document.querySelectorAll(".grid-link").forEach((element)=>$2fb2c27c9772a1c5$var$initGridLink(element));
};
const $2fb2c27c9772a1c5$var$initGridLink = (element)=>{
    element.addEventListener("click", (event)=>{
        event.stopPropagation();
    });
};
const $2fb2c27c9772a1c5$export$353372104066311a = (element)=>{
    new (0, $91ca15859685b28b$export$28c660c63b792dea)(element);
};
const $2fb2c27c9772a1c5$var$gridColumnResize = (gridId)=>async ()=>{
        await $2fb2c27c9772a1c5$var$saveGridSettings(gridId);
    };
const $2fb2c27c9772a1c5$export$a6f097ae6a430bee = (settings)=>(args)=>{
        const { columns: columns } = settings;
        const { value: value, data: data } = args;
        const column = args.column.uid ? columns.find((column)=>column.uid === args.column.uid) ?? columns.find((column)=>column.field === args.column.uid) : undefined;
        if (column && data && value !== undefined) {
            const { format: format, template: template } = column;
            if (value instanceof Date) {
                if (format === undefined || typeof format === "string") {
                    let numberFormat;
                    if (format === undefined || [
                        (0, $d47525176c3f6cd7$export$4e4cb19dd88cd821),
                        (0, $d47525176c3f6cd7$export$fee663b01e39c429),
                        (0, $d47525176c3f6cd7$export$43a266027343dd39),
                        (0, $d47525176c3f6cd7$export$ed2e8365f2474b3)
                    ].includes(format)) {
                        args.value = new Date(value.toDateString()); // Strip time
                        numberFormat = (0, $d47525176c3f6cd7$export$3fddef0e5f877d32);
                    } else if ([
                        (0, $d47525176c3f6cd7$export$94f4d87fad5dcf9a),
                        (0, $d47525176c3f6cd7$export$b434509d4a847712),
                        (0, $d47525176c3f6cd7$export$65691f9e1b09bbf7)
                    ].includes(format)) numberFormat = (0, $d47525176c3f6cd7$export$8d512aaeb4a90c4e);
                    if (numberFormat) args.style = {
                        ...args.style,
                        numberFormat: numberFormat
                    };
                }
            } else if (typeof value === "number") args.value = value;
            else if (typeof value === "boolean") args.value = value ? "TRUE" : "FALSE";
            else if (template) args.value = [
                ...(0, $c2qqN.compile)(template)(data)
            ].map((node)=>node.textContent).join(" ");
        } else args.value = "";
    };
const $2fb2c27c9772a1c5$var$gridActionBegin = (gridId, settings)=>async (args)=>{
        const { requestType: requestType } = args;
        const content = $2fb2c27c9772a1c5$var$grids[gridId].getRootElement().querySelector(".e-content");
        if (content) // Maintain scroll left position (filtering resets)
        $2fb2c27c9772a1c5$var$scrollLefts[gridId] = content.scrollLeft;
        if (requestType === "sorting") {
            const { columnName: columnName, direction: direction } = args;
            await $2fb2c27c9772a1c5$var$saveGridSettings(gridId, {
                sort: columnName ? {
                    field: columnName,
                    direction: direction
                } : {}
            });
        } else if (requestType === "reorder") await $2fb2c27c9772a1c5$var$saveGridSettings(gridId);
        else if (requestType?.toLowerCase() === "filterbeforeopen") {
            const { filterModel: filterModel } = args;
            if (filterModel) {
                // BUG: filterModel should be typed as FilterMenuRenderer not CheckBoxFilterBase
                // https://www.syncfusion.com/forums/181415/setting-operators-for-custom-filter-ui
                // https://www.syncfusion.com/feedback/42873/need-to-set-typing-for-menu-filterbeforeopen-event
                const untypedFilterModel = filterModel;
                const column = settings.columns.find((column)=>column.uid === untypedFilterModel.col.uid);
                $2fb2c27c9772a1c5$var$initFilterOperators(untypedFilterModel);
                const field = column?.field;
                const { lookup: lookup, options: options } = column?.extra?.filter ?? {};
                if (field && (lookup || options)) {
                    if (field.endsWith("Ids")) untypedFilterModel.customFilterOperators.stringOperator = [
                        {
                            value: "contains",
                            text: "Contains"
                        }
                    ];
                    else untypedFilterModel.customFilterOperators.stringOperator = [
                        {
                            value: "equal",
                            text: "Equal"
                        },
                        {
                            value: "notequal",
                            text: "Not Equal"
                        },
                        {
                            value: "isnull",
                            text: "Empty"
                        },
                        {
                            value: "isnotnull",
                            text: "Not Empty"
                        }
                    ];
                }
            }
        }
    };
const $2fb2c27c9772a1c5$var$gridActionComplete = (gridId)=>()=>{
        const content = $2fb2c27c9772a1c5$var$grids[gridId].getRootElement().querySelector(".e-content");
        if (content) // Maintain scroll left position (filtering resets)
        // (wait 10ms for other actions to complete)
        setTimeout(()=>{
            content.scrollLeft = $2fb2c27c9772a1c5$var$scrollLefts[gridId];
        }, 10);
    };
const $2fb2c27c9772a1c5$var$gridDataBound = (gridId)=>()=>{
        const grid = $2fb2c27c9772a1c5$var$grids[gridId];
        if (grid) {
            $2fb2c27c9772a1c5$var$initGridButtons();
            $2fb2c27c9772a1c5$var$initGridLinks();
            const countElementId = grid.getRootElement().dataset.countElementId;
            if (countElementId) {
                const countElement = document.getElementById(countElementId);
                if (countElement) countElement.innerHTML = // totalDataRecordsCount returns previous count when filtered row count is 0, so check getRows().length as well
                grid.totalDataRecordsCount === 0 || grid.getRows().length === 0 ? "" : grid.totalDataRecordsCount.toString();
            }
        }
    };
const $2fb2c27c9772a1c5$var$gridRecordClick = (args)=>{
    const { id: id } = args.rowData;
    if (id !== (0, $e56e694ede576bd9$export$3b6bf62ab04cab53)) {
        const rowElement = args.row;
        const gridElement = rowElement.closest(".grid");
        const grid = $2fb2c27c9772a1c5$var$grids[gridElement.id];
        let path = location.pathname;
        // HACK
        if (path.endsWith("/archived")) path = path.substring(0, path.length - 9);
        (0, $82c899c22fad1693$export$bf853798236fc2fa)({
            url: `${path}/${id}`,
            onHide: ()=>$2fb2c27c9772a1c5$var$refreshGridRow(grid, id, rowElement)
        });
    }
};
const $2fb2c27c9772a1c5$var$gridButtonClick = async (event)=>{
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    const gridElement = button.closest(".grid");
    const rowElement = button.closest("tr");
    const grid = $2fb2c27c9772a1c5$var$grids[gridElement.id];
    const modelName = gridElement.dataset.model;
    const settings = (0, $c32bcf77a46d9b1a$export$44afbce30f6a42e5)[modelName];
    if (!settings) throw `Grid settings not found for model: ${modelName}`;
    const props = button.dataset;
    const { id: id, field: field, action: action, toggled: toggled } = props;
    if (action === "setDateToToday") {
        const value = toggled === "false";
        const editableReqBody = {
            params: {
                name: field,
                primaryKey: id,
                value: value
            }
        };
        await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.editable({
            model: modelName
        }), editableReqBody);
        await $2fb2c27c9772a1c5$var$refreshGridRow(grid, id, rowElement);
    }
};
const $2fb2c27c9772a1c5$export$2b7261532f749c9 = ()=>{
    for (const grid of Object.values($2fb2c27c9772a1c5$var$grids))grid.refresh();
};
const $2fb2c27c9772a1c5$var$refreshGridRow = async (grid, id, row)=>{
    const gridElement = grid.getRootElement();
    const modelName = gridElement.dataset.model;
    const archived = gridElement.dataset.archived === "true";
    const filters = grid.filterModule.actualPredicate;
    const gridReqBody = {
        where: [
            {
                field: "id",
                operator: "equal",
                value: id,
                isComplex: false,
                ignoreAccent: false,
                ignoreCase: false
            },
            // Include active filters to improve performance and ensure correct row is returned
            ...filters ? Object.keys(filters)// HACK don't apply status filter (tasks) as this prevents refresh/display of completed task
            .filter((field)=>field !== "status").flatMap((field)=>filters[field].map((filter)=>filter)) : []
        ],
        take: 1
    };
    const gridResponse = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.grid({
        modelName: modelName,
        archived: archived
    }), gridReqBody);
    const gridResBody = await gridResponse.json();
    const { result: result } = gridResBody;
    // Updated
    if (result.length > 0) {
        grid.setRowData(id, result[0]);
        $2fb2c27c9772a1c5$var$initGridButtons();
    } else row.remove();
};
const $2fb2c27c9772a1c5$var$initGridColumnPicker = (element)=>{
    const id = element.dataset.gridId;
    const grid = $2fb2c27c9772a1c5$var$grids[id];
    const gridElement = document.getElementById(id);
    element.addEventListener("click", (e)=>{
        e.preventDefault();
        // const x = gridElement.clientWidth / 2 - 125; // Column chooser is 250px wide
        grid.columnChooserModule.openColumnChooser(-1, 0);
    });
    const okButton = gridElement.querySelector(".e-ccdlg .e-cc_okbtn");
    okButton.addEventListener("click", async ()=>await $2fb2c27c9772a1c5$var$saveGridSettings(id));
    const resetButton = document.createElement("button");
    resetButton.innerHTML = "Reset";
    resetButton.className = "e-cc e-control e-btn e-lib e-secondary e-flat";
    resetButton.addEventListener("click", async ()=>await $2fb2c27c9772a1c5$var$resetGridSettings(id));
    okButton.after(resetButton);
};
const $2fb2c27c9772a1c5$var$initGridViewPicker = (element)=>{
    const props = JSON.parse(element.dataset.props);
    const { gridId: gridId } = props;
    const input = element.querySelector("input");
    if (gridId && input) {
        // const grid = grids[gridId];
        const comboBox = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
            dataSource: [
                {
                    value: "archived",
                    text: "Archived"
                }
            ],
            // lookup
            //   ? new DataManager({
            //       url: routes.data.lookup.list({ model: lookup as ModelName }),
            //       adaptor: new UrlAdaptor(),
            //     })
            //   : options,
            fields: {
                value: "value",
                text: "text"
            },
            // value,
            placeholder: "Default View",
            allowCustom: false,
            allowFiltering: true,
            popupHeight: 600,
            change: ()=>{
                const value = comboBox.value;
                if (value === "archived") location.href = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).companies.list({
                    archived: true
                });
            }
        });
        comboBox.appendTo(input);
    }
};
const $2fb2c27c9772a1c5$var$initGridAction = (element)=>{
    const id = element.dataset.gridId;
    const action = element.dataset.gridAction;
    const grid = $2fb2c27c9772a1c5$var$grids[id];
    const modelName = grid.element.dataset.model;
    const settings = (0, $c32bcf77a46d9b1a$export$44afbce30f6a42e5)[modelName];
    const { columns: columns } = settings;
    element.addEventListener("click", (e)=>{
        e.preventDefault();
        if (action === "refresh") grid.refresh();
        else if (action === "export") {
            const filename = document.title.split("-")[0].trim();
            const excludedGridColumns = [];
            for (const column of columns.filter((column)=>!(column.showInColumnChooser == undefined ? true : column.showInColumnChooser))){
                const gridColumn = grid.columns[columns.indexOf(column)];
                if (gridColumn.visible) {
                    gridColumn.visible = false;
                    excludedGridColumns.push(gridColumn);
                }
            }
            grid.excelExportComplete = ()=>{
                for (const gridColumn of excludedGridColumns)gridColumn.visible = true;
            };
            grid.excelExport({
                fileName: `${filename}.xlsx`
            });
        }
    });
};
const $2fb2c27c9772a1c5$var$initGridFilter = (element)=>{
    const props = JSON.parse(element.dataset.props);
    const { gridId: gridId, field: field, operator: operator, lookup: lookup, options: options, emptyValue: emptyValue, persistCookie: persistCookie, placeholder: placeholder } = props;
    let value = props.value;
    const operators = [
        "equal",
        "contains"
    ];
    const input = element.querySelector("input");
    if (gridId && field && (lookup || options) && input) {
        const grid = $2fb2c27c9772a1c5$var$grids[gridId];
        const gridFilterValue = ()=>{
            const predicate = grid.filterModule.actualPredicate[field];
            if (predicate) {
                // Ignore non-equal operators as filter dropdowns are only for equal filters
                if (operators.includes(predicate[0].operator)) return grid.filterModule.values[field];
            }
        };
        if (persistCookie) {
            const persistedValue = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a)[persistCookie].name);
            if (persistedValue !== undefined) value = persistedValue;
        } else if (value === undefined) value = gridFilterValue();
        let focused = false;
        const filter = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
            dataSource: lookup ? $2fb2c27c9772a1c5$var$lookupDataSource({
                gridId: gridId,
                field: field,
                lookup: lookup
            }) : options,
            fields: {
                value: "value",
                text: "text"
            },
            sortOrder: lookup ? "Ascending" : undefined,
            value: value,
            placeholder: placeholder ?? "Select a value",
            allowCustom: false,
            allowFiltering: true,
            popupHeight: 600,
            focus: ()=>{
                focused = true;
            },
            blur: ()=>{
                focused = false;
            },
            change: ()=>{
                // Only apply filter when focused as value can be changed on grid actionComplete and we don't want to duplicate the request
                if (focused) {
                    $2fb2c27c9772a1c5$var$filterGrid(gridId, field, operator, filter.value, emptyValue);
                    if (persistCookie) {
                        if (filter.value || filter.value === 0 || filter.value === false) (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a)[persistCookie].name, filter.value.toString());
                        else (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).remove((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a)[persistCookie].name);
                    }
                }
            }
        });
        filter.appendTo(input);
        $2fb2c27c9772a1c5$var$filterGrid(gridId, field, operator, value, emptyValue);
        // When grid is filtered, update value of this dropdown as well
        grid.addEventListener("actionComplete", (args)=>{
            if (args.action === "filter") filter.value = gridFilterValue();
        });
    }
};
const $2fb2c27c9772a1c5$var$saveGridSettings = async (gridId, data)=>{
    const grid = $2fb2c27c9772a1c5$var$grids[gridId];
    const view = grid.element.dataset.view;
    const settings = {
        columns: grid.getColumns().map((column, index)=>{
            return {
                [column.uid]: {
                    index: index,
                    visible: column.visible,
                    width: column.width
                }
            };
        }).reduce((0, $81088ee9a0e19312$export$4950aa0f605343fb)),
        ...data
    };
    await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).settings.grid({
        id: gridId,
        view: view
    }), settings);
    $2fb2c27c9772a1c5$var$userGridSettings[gridId] = settings;
};
const $2fb2c27c9772a1c5$var$loadGridSettings = async (gridId, view)=>{
    if (!$2fb2c27c9772a1c5$var$userGridSettings[gridId]) {
        const res = await (0, $0690cfee00fb4cf1$export$1bb358554aac31c1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).settings.grid({
            id: gridId,
            view: view
        }));
        $2fb2c27c9772a1c5$var$userGridSettings[gridId] = await res.json();
    }
    return $2fb2c27c9772a1c5$var$userGridSettings[gridId];
};
const $2fb2c27c9772a1c5$var$resetGridSettings = async (gridId)=>{
    const grid = $2fb2c27c9772a1c5$var$grids[gridId];
    const view = grid.element.dataset.view;
    await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).settings.grid({
        id: gridId,
        view: view
    }));
    delete $2fb2c27c9772a1c5$var$userGridSettings[gridId];
    location.reload();
};
const $2fb2c27c9772a1c5$var$applyGridColumnFilterSettings = (gridId, columns)=>{
    for (const column of columns.filter((column)=>column.extra?.filter)){
        const { field: field } = column;
        const { lookup: lookup, options: options, minDate: minDate, maxDate: maxDate } = column.extra.filter;
        if (lookup || options) {
            const getContext = (args)=>args.column.filter;
            column.filter = {
                operator: "equal",
                ui: {
                    create: (args)=>{
                        const context = getContext(args);
                        const input = (0, $4ZDHT.createElement)("input", {
                            className: "flm-input"
                        });
                        args.target.appendChild(input);
                        context.dropDownList = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)({
                            dataSource: lookup ? $2fb2c27c9772a1c5$var$lookupDataSource({
                                gridId: gridId,
                                field: field,
                                lookup: lookup
                            }) : options,
                            fields: {
                                text: "text",
                                value: "value"
                            },
                            allowFiltering: !!lookup,
                            placeholder: "Select a value",
                            popupHeight: "600px"
                        });
                        context.dropDownList.appendTo(input);
                    },
                    write: (args)=>{
                        const context = getContext(args);
                        context.dropDownList.value = args.filteredValue;
                    },
                    read: (args)=>{
                        const context = getContext(args);
                        args.fltrObj.filterByColumn(args.column.field, args.operator, context.dropDownList.value, undefined, $2fb2c27c9772a1c5$var$matchCase(args.column, args.operator));
                    }
                }
            };
        } else if (minDate || maxDate) {
            const getContext = (args)=>args.column.filter;
            column.filter = {
                ui: {
                    create: (args)=>{
                        const context = getContext(args);
                        const input = (0, $4ZDHT.createElement)("input", {
                            className: "flm-input"
                        });
                        args.target.appendChild(input);
                        context.datePicker = new (0, $d5f6934cad42758d$export$5109c6dd95d8fb00)({
                            locale: (0, $d47525176c3f6cd7$export$1af4c7e47ad72f44).code,
                            format: column.format,
                            min: minDate,
                            max: maxDate,
                            placeholder: "Choose a Date",
                            showTodayButton: !(minDate || maxDate),
                            showClearButton: false
                        });
                        context.datePicker.appendTo(input);
                    },
                    write: (args)=>{
                        const context = getContext(args);
                        context.datePicker.value = new Date(Date.parse(args.filteredValue));
                    },
                    read: (args)=>{
                        const context = getContext(args);
                        args.fltrObj.filterByColumn(args.column.field, args.operator, context.datePicker.value, undefined, $2fb2c27c9772a1c5$var$matchCase(args.column, args.operator));
                    }
                }
            };
        }
    }
};
const $2fb2c27c9772a1c5$var$applyUserGridColumnSettings = (columns, settings)=>{
    const allColumnSettings = settings?.columns;
    if (allColumnSettings) {
        const columnIndex = (column)=>column.uid ? allColumnSettings[column.uid]?.index ?? 0 : 0;
        columns.sort((columnA, columnB)=>{
            const columnAIndex = columnIndex(columnA);
            const columnBIndex = columnIndex(columnB);
            return columnAIndex < columnBIndex ? -1 : columnAIndex > columnBIndex ? 1 : 0;
        });
        const uids = (0, $81088ee9a0e19312$export$ed97f33186d4b816)(allColumnSettings);
        // Hide any new columns and push to end
        for (const newColumn of columns.filter((column)=>column.uid && !uids.includes(column.uid))){
            newColumn.visible = false;
            columns.push(columns.splice(columns.indexOf(newColumn), 1)[0]);
        }
        for (const uid of uids){
            const columnSettings = allColumnSettings[uid];
            const column = columns.find((column)=>column.uid === uid);
            if (columnSettings && column) {
                column.visible = !!columnSettings.visible;
                if (columnSettings.width) column.width = columnSettings.width;
            }
        }
    }
};
const $2fb2c27c9772a1c5$var$applyUserGridSortSettings = (gridId, settings)=>{
    if (settings?.sort?.field) {
        const grid = $2fb2c27c9772a1c5$var$grids[gridId];
        if (grid.getColumnByField(settings.sort.field)) grid.sortColumn(settings.sort.field, settings.sort.direction ?? "Ascending");
    }
};
const $2fb2c27c9772a1c5$var$filterGrid = (gridId, field, operator, value, emptyValue)=>{
    const grid = $2fb2c27c9772a1c5$var$grids[gridId];
    const column = grid.getColumnByField(field);
    if (column) {
        if (emptyValue && (value === null || value === undefined)) value = emptyValue;
        if (value === null || value === undefined) grid.clearFiltering([
            field
        ]);
        else grid.filterByColumn(field, operator, value, undefined, $2fb2c27c9772a1c5$var$matchCase(column, operator));
        $2fb2c27c9772a1c5$var$filters[gridId] = {
            ...$2fb2c27c9772a1c5$var$filters[gridId],
            [field]: value
        };
    }
};
const $2fb2c27c9772a1c5$export$ab7d11c4acea194f = ()=>{
    const gridIds = (0, $81088ee9a0e19312$export$ed97f33186d4b816)($2fb2c27c9772a1c5$var$grids);
    if (gridIds.length === 1) {
        const f = $2fb2c27c9772a1c5$var$filters[gridIds[0]];
        if (f) {
            const setFilters = Object.keys(f).filter((field)=>(0, $23645516f0d2c47e$export$71fc1ee3e76bc1fe)(f[field])).map((field)=>{
                return {
                    [field]: f[field]
                };
            });
            if (setFilters.length) return setFilters.reduce((0, $81088ee9a0e19312$export$4950aa0f605343fb));
        }
    }
};
const $2fb2c27c9772a1c5$var$initFilterOperators = (filterModel)=>{
    // https://ej2.syncfusion.com/aspnetmvc/documentation/grid/filtering/filtering#filter-operators
    // eslint-disable-next-line  @typescript-eslint/no-unused-expressions
    filterModel.customFilterOperators.booleanOperator = [
        {
            value: "equal",
            text: "Equal"
        },
        {
            value: "notequal",
            text: "Not Equal"
        }
    ], filterModel.customFilterOperators.dateOperator = [
        {
            value: "greaterthan",
            text: "Greater Than"
        },
        {
            value: "greaterthanorequal",
            text: "Greater Than or Equal"
        },
        {
            value: "lessthan",
            text: "Less Than"
        },
        {
            value: "lessthanorequal",
            text: "Less Than or Equal"
        },
        {
            value: "equal",
            text: "Equal"
        },
        {
            value: "notequal",
            text: "Not Equal"
        },
        {
            value: "isnull",
            text: "Empty"
        },
        {
            value: "isnotnull",
            text: "Not Empty"
        }
    ], filterModel.customFilterOperators.numberOperator = [
        {
            value: "greaterthan",
            text: "Greater Than"
        },
        {
            value: "greaterthanorequal",
            text: "Greater Than or Equal"
        },
        {
            value: "lessthan",
            text: "Less Than"
        },
        {
            value: "lessthanorequal",
            text: "Less Than or Equal"
        },
        {
            value: "equal",
            text: "Equal"
        },
        {
            value: "notequal",
            text: "Not Equal"
        },
        {
            value: "isnull",
            text: "Empty"
        },
        {
            value: "isnotnull",
            text: "Not Empty"
        }
    ], filterModel.customFilterOperators.stringOperator = [
        {
            value: "startswith",
            text: "Starts With"
        },
        {
            value: "endswith",
            text: "Ends With"
        },
        {
            value: "contains",
            text: "Contains"
        },
        {
            value: "equal",
            text: "Equal"
        },
        {
            value: "notequal",
            text: "Not Equal"
        },
        {
            value: "isnull",
            text: "Empty"
        },
        {
            value: "isnotnull",
            text: "Not Empty"
        }
    ];
};
const $2fb2c27c9772a1c5$var$lookupDataSource = (props)=>{
    const { gridId: gridId, field: field, lookup: lookup } = props;
    return lookup === true ? $2fb2c27c9772a1c5$var$gridDataSource({
        gridId: gridId,
        lookup: field
    }) : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
        url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.list({
            model: lookup
        }),
        adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
    });
};
const $2fb2c27c9772a1c5$var$gridDataSource = (props)=>{
    const { gridId: gridId, lookup: lookup } = props;
    const grid = $2fb2c27c9772a1c5$var$grids[gridId];
    const modelName = grid.element.dataset.model;
    const archived = grid.element.dataset.archived === "true";
    return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
        url: (0, $55576f0fdfdeec43$export$8fa1eaeb4700701e)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.grid({
            modelName: modelName,
            archived: archived
        }), {
            lookup: lookup
        }),
        adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
    });
};
const $2fb2c27c9772a1c5$var$matchCase = (column, operator)=>column.type === "string" ? ![
        "contains",
        "startswith",
        "endswith"
    ].includes(operator) : undefined;



window.addEventListener("expandOffCanvas", ()=>{
    $82c899c22fad1693$export$34a7fb21035f9189();
});
window.addEventListener("keydown", (e)=>{
    if (e.key === "Escape") window.parent.dispatchEvent(new CustomEvent("escape"));
});
window.addEventListener("escape", ()=>{
    $82c899c22fad1693$export$a683c3df7cdb4871();
});
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll('a[data-offcanvas="true"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            let url = link.getAttribute("href");
            if (url) {
                e.preventDefault();
                // HACK Grab any grid filter values and tack onto the URL to pre-populate (bit of a hack)
                const gridFilters = (0, $2fb2c27c9772a1c5$export$ab7d11c4acea194f)();
                if (gridFilters) url = (0, $55576f0fdfdeec43$export$8fa1eaeb4700701e)(url, gridFilters);
                // TODO Only refresh grids that have changed
                $82c899c22fad1693$export$bf853798236fc2fa({
                    url: url,
                    onHide: (0, $2fb2c27c9772a1c5$export$2b7261532f749c9)
                });
            }
        });
    });
});
const $82c899c22fad1693$export$bf853798236fc2fa = (params)=>{
    const { url: url, onHide: onHide } = params;
    (0, $4f23fd74a1ec3f74$export$2a7a135fa1ec651f)();
    const offcanvasElement = document.getElementById("offcanvas");
    const offcanvas = (0, $91ca15859685b28b$export$591ca0244c9dfcd4).getOrCreateInstance(offcanvasElement);
    const iframe = offcanvasElement.querySelector("iframe");
    // TODO allow for incoming URL with query string
    iframe.setAttribute("src", (0, $55576f0fdfdeec43$export$99644c5386245dec)(url));
    iframe.addEventListener("load", ()=>{
        (0, $4f23fd74a1ec3f74$export$95fec50f68454318)();
        offcanvas.show();
    }, {
        once: true
    });
    const addHideEventListener = ()=>{
        offcanvasElement.addEventListener("hide.bs.offcanvas", (e)=>{
            const iframe = offcanvasElement.querySelector("iframe");
            const dirtyForm = iframe?.contentWindow?.document.querySelector('form[data-dirty="true"]');
            if (!dirtyForm || confirm("Are you sure you want to close this record without saving changes?")) {
                if (onHide) onHide();
            } else {
                e.preventDefault();
                // Re-add listener if cancelled (only fires successfully once)
                addHideEventListener();
            }
        }, {
            once: true
        });
    };
    addHideEventListener();
};
const $82c899c22fad1693$export$34a7fb21035f9189 = ()=>{
    const offcanvasElement = document.getElementById("offcanvas");
    if (offcanvasElement) offcanvasElement.classList.toggle("expanded");
    else window.parent.dispatchEvent(new CustomEvent("expandOffCanvas"));
};
const $82c899c22fad1693$export$a683c3df7cdb4871 = (params)=>{
    const { refreshGrids: refreshGrids } = params ?? {};
    const offcanvasElement = document.getElementById("offcanvas");
    if (offcanvasElement) {
        const offcanvas = (0, $91ca15859685b28b$export$591ca0244c9dfcd4).getInstance(offcanvasElement);
        offcanvasElement.classList.remove("expanded");
        if (offcanvas) offcanvas.hide();
    } else {
        window.parent.dispatchEvent(new CustomEvent("escape"));
        if (refreshGrids) window.parent.dispatchEvent(new CustomEvent("refreshGrids"));
    }
};


const $e68843d575be3a15$var$validators = {};
const $e68843d575be3a15$var$editorsById = {};
const $e68843d575be3a15$var$controlsById = {};
const $e68843d575be3a15$var$propsById = {};
const $e68843d575be3a15$var$fieldsById = {};
const $e68843d575be3a15$export$56a40825678f1b4b = (id, editor)=>$e68843d575be3a15$var$editorsById[id] = editor;
const $e68843d575be3a15$export$d193da8733a2af56 = (id)=>$e68843d575be3a15$var$editorsById[id];
const $e68843d575be3a15$export$82af9bc734d9e5bb = (id, control)=>$e68843d575be3a15$var$controlsById[id] = control;
const $e68843d575be3a15$export$caf8f8b20e380f6e = (id)=>$e68843d575be3a15$var$controlsById[id];
const $e68843d575be3a15$export$938ca3893886de06 = (id, props)=>$e68843d575be3a15$var$propsById[id] = props;
const $e68843d575be3a15$export$75fe5f91d452f94b = (id)=>$e68843d575be3a15$var$propsById[id];
const $e68843d575be3a15$export$829cd59ad97f6102 = (id, value)=>$e68843d575be3a15$var$fieldsById[id] = value;
const $e68843d575be3a15$export$2c9b3f539cb25b05 = (id)=>$e68843d575be3a15$var$fieldsById[id];
const $e68843d575be3a15$export$c470fcda89530fcd = (p, e)=>{
    if (p.validation) {
        const form = e.closest("form");
        if (form?.id) {
            let validator = $e68843d575be3a15$var$validators[form.id];
            if (!validator) {
                validator = new (0, $37c994a07eb13072$export$7c385359179c028a)(form);
                $e68843d575be3a15$var$validators[form.id] = validator;
                // HACK: What if no controls have validation - this won't get called?
                // TODO: Move this logic to form component?
                form.addEventListener("save", async ()=>{
                    if (validator.validate()) {
                        const data = $e68843d575be3a15$export$9643fd7297feaaf5(form);
                        const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(form.action, data);
                        let options;
                        try {
                            options = await res.json();
                        } catch (error) {
                            // No options - ignore
                            console.info(error);
                        }
                        if (options?.message) alert(options.message);
                        delete form.dataset.dirty;
                        if (options?.redirectUrl) window.location.href = options.redirectUrl;
                        else // HACK: Assumes we're in offcanvas - might not be?
                        // HACK: Assume there are grids = might not be?
                        // NOTE: Needed for refreshing after task copied as onHide()
                        // refreshes row that was copied but we need to show the new
                        // row as well
                        (0, $82c899c22fad1693$export$a683c3df7cdb4871)({
                            refreshGrids: true
                        });
                    }
                });
            }
            validator.addRules(p.field, p.validation);
        }
    }
};
const $e68843d575be3a15$export$9643fd7297feaaf5 = (form)=>{
    let data = Object.keys($e68843d575be3a15$var$controlsById).filter((id)=>form.contains($e68843d575be3a15$var$controlsById[id].element)).map((id)=>{
        const control = $e68843d575be3a15$var$controlsById[id];
        const props = $e68843d575be3a15$var$propsById[id];
        let value;
        let enabled;
        if ((0, $0529b7a83755f1dd$export$d1df3c7859befd08)(control)) {
            value = $e68843d575be3a15$export$c6a3502e38927635(props, control.checked);
            enabled = !control.disabled;
        } else {
            value = control.value;
            enabled = control.enabled;
        }
        if (!enabled) return {};
        const { type: type, defaultValue: defaultValue } = $e68843d575be3a15$var$propsById[id];
        if (typeof value === "string") value = value.trim() || null;
        if (((0, $23645516f0d2c47e$export$813e94b17b81f345)(value) || (0, $23645516f0d2c47e$export$b57b2a4fc103e949)(value)) && defaultValue !== undefined) value = defaultValue;
        else if (type === "Integer") {
            value = parseInt(value);
            if (isNaN(value)) value = undefined;
        } else if (type === "Float") {
            value = parseFloat(value);
            if (isNaN(value)) value = undefined;
        } else if (type === "Date") {
            if (value) value = (0, $fb0301734e2a6838$export$e3c952f8edd3566f)(value);
        }
        return {
            [$e68843d575be3a15$var$fieldsById[id]]: value
        };
    }).reduce((0, $81088ee9a0e19312$export$4950aa0f605343fb));
    // Add any additional input values in form (excluding within editables)
    [
        ...form.querySelectorAll("input,textarea,select")
    ].map((element)=>element).filter((input)=>input.name && !Object.values($e68843d575be3a15$var$fieldsById).includes(input.name) && (input.dataset.save ?? "true").toLowerCase() !== "false").forEach((input)=>{
        const isArray = input.name.endsWith("[]");
        const name = isArray ? input.name.substring(0, input.name.length - 2) : input.name;
        let value = input.value;
        if ([
            "checkbox",
            "radio"
        ].includes(input.type)) {
            const checked = input.checked;
            if (input.type === "checkbox") value = checked;
            else value = checked ? input.value : undefined;
        } else value = input.value;
        if (value !== undefined) data = (0, $81088ee9a0e19312$export$4950aa0f605343fb)(data, {
            [name]: isArray ? [
                ...data[name] ?? [],
                value
            ] : value
        });
    });
    return data;
};
const $e68843d575be3a15$export$18f2ef1f3de9bc1c = async (id, value)=>{
    const element = $e68843d575be3a15$var$editorsById[id].getRootElement();
    $e68843d575be3a15$var$editorsById[id].value = value;
    element.setAttribute("data-empty", (0, $23645516f0d2c47e$export$813e94b17b81f345)(value) || (0, $23645516f0d2c47e$export$b57b2a4fc103e949)(value) ? "true" : "false");
    const { modelId: modelId, modelName: modelName, field: field } = $e68843d575be3a15$var$propsById[id];
    const url = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.editable({
        model: modelName
    });
    const body = {
        params: {
            name: field,
            primaryKey: modelId,
            value: value
        }
    };
    await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(url, body);
};
const $e68843d575be3a15$export$1cd6cc6498bc6c62 = async (id, value)=>{
    const editor = $e68843d575be3a15$var$editorsById[id];
    if (editor) await $e68843d575be3a15$export$18f2ef1f3de9bc1c(id, value);
};
const $e68843d575be3a15$export$c6a3502e38927635 = (p, value)=>!p.negate === !!value;





var $f99f090cb185e2bb$exports = {};
/* global define */ (function(root, pluralize) {
    // Node.
    $f99f090cb185e2bb$exports = pluralize();
})($f99f090cb185e2bb$exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === "string") return new RegExp("^" + rule + "$", "i");
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || "";
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === "") return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === "string") {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, "$0");
        pluralize.addSingularRule(word, "$0");
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            "I",
            "we"
        ],
        [
            "me",
            "us"
        ],
        [
            "he",
            "they"
        ],
        [
            "she",
            "they"
        ],
        [
            "them",
            "them"
        ],
        [
            "myself",
            "ourselves"
        ],
        [
            "yourself",
            "yourselves"
        ],
        [
            "itself",
            "themselves"
        ],
        [
            "herself",
            "themselves"
        ],
        [
            "himself",
            "themselves"
        ],
        [
            "themself",
            "themselves"
        ],
        [
            "is",
            "are"
        ],
        [
            "was",
            "were"
        ],
        [
            "has",
            "have"
        ],
        [
            "this",
            "these"
        ],
        [
            "that",
            "those"
        ],
        // Words ending in with a consonant and `o`.
        [
            "echo",
            "echoes"
        ],
        [
            "dingo",
            "dingoes"
        ],
        [
            "volcano",
            "volcanoes"
        ],
        [
            "tornado",
            "tornadoes"
        ],
        [
            "torpedo",
            "torpedoes"
        ],
        // Ends with `us`.
        [
            "genus",
            "genera"
        ],
        [
            "viscus",
            "viscera"
        ],
        // Ends with `ma`.
        [
            "stigma",
            "stigmata"
        ],
        [
            "stoma",
            "stomata"
        ],
        [
            "dogma",
            "dogmata"
        ],
        [
            "lemma",
            "lemmata"
        ],
        [
            "schema",
            "schemata"
        ],
        [
            "anathema",
            "anathemata"
        ],
        // Other irregular rules.
        [
            "ox",
            "oxen"
        ],
        [
            "axe",
            "axes"
        ],
        [
            "die",
            "dice"
        ],
        [
            "yes",
            "yeses"
        ],
        [
            "foot",
            "feet"
        ],
        [
            "eave",
            "eaves"
        ],
        [
            "goose",
            "geese"
        ],
        [
            "tooth",
            "teeth"
        ],
        [
            "quiz",
            "quizzes"
        ],
        [
            "human",
            "humans"
        ],
        [
            "proof",
            "proofs"
        ],
        [
            "carve",
            "carves"
        ],
        [
            "valve",
            "valves"
        ],
        [
            "looey",
            "looies"
        ],
        [
            "thief",
            "thieves"
        ],
        [
            "groove",
            "grooves"
        ],
        [
            "pickaxe",
            "pickaxes"
        ],
        [
            "passerby",
            "passersby"
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            "s"
        ],
        [
            /[^\u0000-\u007F]$/i,
            "$0"
        ],
        [
            /([^aeiou]ese)$/i,
            "$1"
        ],
        [
            /(ax|test)is$/i,
            "$1es"
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            "$1es"
        ],
        [
            /(e[mn]u)s?$/i,
            "$1s"
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            "$1"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1i"
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            "$1ae"
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            "$1im"
        ],
        [
            /(her|at|gr)o$/i,
            "$1oes"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            "$1a"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            "$1a"
        ],
        [
            /sis$/i,
            "ses"
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            "$1$2ves"
        ],
        [
            /([^aeiouy]|qu)y$/i,
            "$1ies"
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            "$1ies"
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            "$1es"
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            "$1ices"
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            "$1ice"
        ],
        [
            /(pe)(?:rson|ople)$/i,
            "$1ople"
        ],
        [
            /(child)(?:ren)?$/i,
            "$1ren"
        ],
        [
            /eaux$/i,
            "$0"
        ],
        [
            /m[ae]n$/i,
            "men"
        ],
        [
            "thou",
            "you"
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ""
        ],
        [
            /(ss)$/i,
            "$1"
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            "$1fe"
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            "$1f"
        ],
        [
            /ies$/i,
            "y"
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            "$1ie"
        ],
        [
            /\b(mon|smil)ies$/i,
            "$1ey"
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            "$1ouse"
        ],
        [
            /(seraph|cherub)im$/i,
            "$1"
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            "$1"
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            "$1sis"
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            "$1"
        ],
        [
            /(test)(?:is|es)$/i,
            "$1is"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1us"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            "$1um"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            "$1on"
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            "$1a"
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            "$1ex"
        ],
        [
            /(matr|append)ices$/i,
            "$1ix"
        ],
        [
            /(pe)(rson|ople)$/i,
            "$1rson"
        ],
        [
            /(child)ren$/i,
            "$1"
        ],
        [
            /(eau)x?$/i,
            "$1"
        ],
        [
            /men$/i,
            "man"
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});



const $b3c77961ceea21a2$var$lookupPickers = {};
document.addEventListener("DOMContentLoaded", ()=>{
    [
        ...document.querySelectorAll(".lookup-picker")
    ].map((element)=>element).forEach((input)=>{
        const model = input.dataset.model;
        const { placeholder: placeholder, width: width } = input.dataset;
        if (model) {
            const lookupPicker = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
                dataSource: new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                    url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.list({
                        model: model
                    }),
                    adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
                }),
                fields: {
                    value: "value",
                    text: "text"
                },
                placeholder: placeholder ?? `Search ${(0, (/*@__PURE__*/$parcel$interopDefault($f99f090cb185e2bb$exports)))(model)}`,
                sortOrder: "Ascending",
                value: input.dataset.value ?? undefined,
                allowCustom: false,
                allowFiltering: true,
                width: width
            });
            lookupPicker.appendTo(input);
            if (input.id) $b3c77961ceea21a2$var$lookupPickers[input.id] = lookupPicker;
        }
    });
});
const $b3c77961ceea21a2$export$475dfb2b50fe6412 = (id)=>$b3c77961ceea21a2$var$lookupPickers[id];



const $c104550478c564ce$export$d7e8d4d4450c819c = (options)=>{
    const modalElement = document.getElementById("modal");
    if (modalElement) {
        const modalDialogElement = modalElement.querySelector(".modal-dialog");
        const modalTitleElement = modalElement.querySelector(".modal-title");
        const modalBodyElement = modalElement.querySelector(".modal-body");
        modalDialogElement.classList.toggle("modal-fullscreen", !!options?.fullScreen);
        modalTitleElement.innerHTML = options.title;
        modalBodyElement.innerHTML = options.body;
        new (0, $91ca15859685b28b$export$2b77a92f1a5ad772)(modalElement).show();
    }
};



document.addEventListener("DOMContentLoaded", ()=>$f3eecde3376fb915$var$initButtons());
const $f3eecde3376fb915$var$initButtons = ()=>{
    [
        ...document.querySelectorAll("a[data-action], button[data-action]")
    ].map((button)=>button).forEach(function(button) {
        button.addEventListener("click", async (event)=>{
            event.preventDefault();
            const enabled = (button.dataset.enabled ?? "true") === "true";
            const confirmMessage = button.dataset.confirmMessage;
            if (enabled && (!confirmMessage || confirm(confirmMessage))) {
                // Prevent double-click
                button.dataset.enabled = "false";
                const action = button.dataset.action;
                if (action === "submit") $f3eecde3376fb915$var$submit(button);
                else if (action === "post") await $f3eecde3376fb915$var$postForm(button);
                else if (action === "save") $f3eecde3376fb915$var$save(button);
                else if (action === "delete") $f3eecde3376fb915$var$del();
                else if (action === "expand") $f3eecde3376fb915$var$expand();
                else if (action === "close") $f3eecde3376fb915$var$close();
                else if (action === "resendInvite") await $f3eecde3376fb915$var$resendInvite(button);
                else if (action === "resetPassword") await $f3eecde3376fb915$var$resetPassword(button);
                else if (action === "enableMfa") await $f3eecde3376fb915$var$enableMfa(button);
                else if (action === "disableMfa") await $f3eecde3376fb915$var$disableMfa(button);
                else if (action === "importCompany") $f3eecde3376fb915$var$importCompany(button);
                else if (action === "toggleSetDate") await $f3eecde3376fb915$var$toggleSetDate(button);
                else if (action === "archive") await $f3eecde3376fb915$var$archive(button, true);
                else if (action === "unarchive") await $f3eecde3376fb915$var$archive(button, false);
                else if (action === "createSmartTasks") await $f3eecde3376fb915$var$createSmartTasks(button);
                else if (action === "createCompanyServiceManager") await $f3eecde3376fb915$var$createServiceManager((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Company, button);
                else if (action === "createIndividualServiceManager") await $f3eecde3376fb915$var$createServiceManager((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Individual, button);
                else if (action === "deleteServiceManager") await $f3eecde3376fb915$var$deleteServiceManager(button);
                else if (action === "createCompanyAssociation") await $f3eecde3376fb915$var$createCompanyAssociation(button);
                else if (action === "createIndividualAssociation") await $f3eecde3376fb915$var$createIndividualAssociation(button);
                else if (action === "deleteAssociation") await $f3eecde3376fb915$var$deleteAssociation(button);
                else if (action === "undoCompanyImport") await $f3eecde3376fb915$var$undoCompanyImport(button);
                else if (action === "undoIndividualImport") await $f3eecde3376fb915$var$undoIndividualImport(button);
                else if (action === "previewTemplate") await $f3eecde3376fb915$var$previewTemplate(button);
                $f3eecde3376fb915$var$toggleIcon(button);
                // Prevent double-click
                button.dataset.enabled = "true";
            }
        });
    });
};
const $f3eecde3376fb915$var$modelId = ()=>document.getElementById("modelId")?.value;
const $f3eecde3376fb915$var$submit = async (button)=>{
    const form = button.closest("form");
    if (form && form.dataset.submitted !== "true") {
        form.dataset.submitted = "true";
        form.submit();
    }
};
const $f3eecde3376fb915$var$postForm = async (button)=>{
    const form = button.closest("form");
    if (form) {
        const data = Object.fromEntries(new FormData(form));
        const { res: res, status: status } = await $f3eecde3376fb915$var$post(form.action, data);
        delete form.dataset.dirty;
        if (res.ok) {
            if (status?.redirectUrl) window.location.href = status?.redirectUrl;
            else // HACK: Assumes we're in offcanvas - might not be?
            // HACK: Assume there are grids = might not be?
            (0, $82c899c22fad1693$export$a683c3df7cdb4871)({
                refreshGrids: true
            });
        }
    }
};
const $f3eecde3376fb915$var$post = async (action, data)=>{
    const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(action, data);
    let status;
    try {
        status = await res.json();
    } catch (error) {
        // No options - ignore
        console.info(error);
    }
    if (status?.message) alert(status.message);
    return {
        res: res,
        status: status
    };
};
const $f3eecde3376fb915$var$save = (button)=>{
    const form = button.closest("form");
    if (form) form.dispatchEvent(new Event("save"));
};
const $f3eecde3376fb915$var$del = async ()=>{
    await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)(window.location.href);
    $f3eecde3376fb915$var$close();
};
const $f3eecde3376fb915$var$expand = ()=>{
    (0, $82c899c22fad1693$export$34a7fb21035f9189)();
};
const $f3eecde3376fb915$var$close = ()=>{
    (0, $82c899c22fad1693$export$a683c3df7cdb4871)();
};
const $f3eecde3376fb915$var$resendInvite = async (button)=>{
    const memberId = button.dataset.value;
    if (memberId) await $f3eecde3376fb915$var$post((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).members.resendInvite({
        id: memberId
    }));
};
const $f3eecde3376fb915$var$resetPassword = async (button)=>{
    const memberId = button.dataset.value;
    if (memberId) await $f3eecde3376fb915$var$post((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).members.resetPassword({
        id: memberId
    }));
};
const $f3eecde3376fb915$var$enableMfa = async (button)=>{
    const memberId = button.dataset.value;
    if (memberId) {
        const modalDiv = document.getElementById("mfa-modal");
        const qrImg = document.getElementById("mfa-qr");
        const codeInput = document.getElementById("mfa-code");
        const confirmButton = document.getElementById("mfa-confirm");
        const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).members.enableMfa({
            id: memberId
        }));
        const { qrUrl: qrUrl } = await res.json();
        qrImg.src = qrUrl;
        const modal = new (0, $91ca15859685b28b$export$2b77a92f1a5ad772)(modalDiv);
        confirmButton.addEventListener("click", async ()=>{
            const code = codeInput.value;
            if (!(0, $423e37bedf14916e$export$7ef8f6e91d2e77dd).test(code)) {
                alert("Invalid code");
                return;
            }
            const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).members.confirmMfa({
                id: memberId
            }), {
                code: code
            });
            const { success: success } = await res.json();
            if (success) {
                modal.hide();
                window.location.reload();
            } else {
                codeInput.value = "";
                alert("Invalid code, please try again");
            }
        });
        modal.show();
    }
};
const $f3eecde3376fb915$var$disableMfa = async (button)=>{
    const memberId = button.dataset.value;
    if (memberId) {
        if (confirm("Are you sure you want to disable two-factor authentication?")) {
            await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).members.disableMfa({
                id: memberId
            }));
            window.location.reload();
        }
    }
};
const $f3eecde3376fb915$var$importCompany = (button)=>{
    const form = button.closest("form");
    const input = form?.querySelector('[name="registrationNumber"]');
    const registrationNumber = input?.value;
    if (registrationNumber && (0, $423e37bedf14916e$export$6496ef4bebcdbe61)(registrationNumber)) {
        const url = new URL(window.location.href);
        url.searchParams.set("registrationNumber", registrationNumber);
        window.location.replace(url.toString());
    }
};
const $f3eecde3376fb915$var$toggleSetDate = async (button)=>{
    const { editableId: editableId, value: value, toggled: toggled } = button.dataset;
    if (editableId) {
        const date = value ? new Date(Date.parse(value)) : new Date();
        await (0, $e68843d575be3a15$export$1cd6cc6498bc6c62)(editableId, toggled !== "true" ? date : null);
        button.dataset.toggled = toggled !== "true" ? "true" : "false";
    }
};
const $f3eecde3376fb915$var$toggleIcon = (button)=>{
    const toggleIcon = button.dataset.toggleIcon;
    const icon = button.querySelector("i");
    if (icon && toggleIcon) {
        const currentIcon = icon.className;
        icon.className = toggleIcon;
        button.dataset.toggleIcon = currentIcon;
    }
};
const $f3eecde3376fb915$var$archive = async (button, archive)=>{
    const modelName = button.dataset.model;
    const id = button.dataset.value;
    if (confirm(`Are you sure you want to ${archive ? "archive" : "unarchive"} this record?`)) {
        if (modelName && id) {
            const body = {
                params: {
                    name: "archivedTime",
                    primaryKey: id,
                    value: archive ? true : false
                }
            };
            await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.editable({
                model: modelName
            }), body);
            location.reload();
        }
    }
};
const $f3eecde3376fb915$var$createSmartTasks = async (button)=>{
    const accountId = button.dataset.value;
    if (accountId) {
        const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).admin.accounts.createSmartTasks({
            id: accountId
        }));
        const message = await res.text();
        if (message) alert(message);
    }
};
const $f3eecde3376fb915$var$createServiceManager = async (type, button)=>{
    const servicePicker = (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("serviceManagerServicePicker");
    const userPicker = (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("serviceManagerUserPicker");
    if (servicePicker && userPicker) {
        const companyId = type === (0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Company ? $f3eecde3376fb915$var$modelId() : undefined;
        const individualId = type === (0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Individual ? $f3eecde3376fb915$var$modelId() : undefined;
        const serviceId = servicePicker?.value;
        const userId = userPicker?.value;
        if ((companyId || individualId) && serviceId && userId) {
            const serviceManager = {
                companyId: companyId,
                individualId: individualId,
                serviceId: serviceId,
                userId: userId
            };
            const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).serviceManagers.create(), serviceManager);
            if (res.ok) {
                button.closest(".table-like-row")?.insertAdjacentHTML("beforebegin", await res.text());
                $f3eecde3376fb915$var$initButtons();
                servicePicker.value = "";
                userPicker.value = "";
            }
        }
    }
};
const $f3eecde3376fb915$var$deleteServiceManager = async (button)=>{
    const id = button.dataset.value;
    if (id) {
        const res = await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).serviceManagers.edit({
            id: id
        }));
        if (res.ok) button.closest(".table-like-row")?.remove();
        (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("serviceManagerServicePicker")?.refresh();
        (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("serviceManagerUserPicker")?.refresh();
    }
};
const $f3eecde3376fb915$var$createIndividualAssociation = async (button)=>{
    const picker = (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("individualPicker");
    if (picker) {
        const companyId = $f3eecde3376fb915$var$modelId();
        const individualId = picker?.value;
        if (companyId && individualId) {
            const association = {
                companyId: companyId,
                individualId: individualId
            };
            const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(`${(0, $bc9d09886380ca07$export$66b32f6f30eb4b4).associations.create()}?view=Company`, association);
            if (res.ok) {
                button.closest("tr")?.insertAdjacentHTML("beforebegin", await res.text());
                $f3eecde3376fb915$var$initButtons();
                picker.value = "";
            }
        }
    }
};
const $f3eecde3376fb915$var$createCompanyAssociation = async (button)=>{
    const picker = (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("companyPicker");
    if (picker) {
        const individualId = $f3eecde3376fb915$var$modelId();
        const companyId = picker.value;
        if (individualId && companyId) {
            const association = {
                individualId: individualId,
                companyId: companyId
            };
            const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(`${(0, $bc9d09886380ca07$export$66b32f6f30eb4b4).associations.create()}?view=Individual`, association);
            if (res.ok) {
                button.closest("tr")?.insertAdjacentHTML("beforebegin", await res.text());
                $f3eecde3376fb915$var$initButtons();
                picker.value = "";
            }
        }
    }
};
const $f3eecde3376fb915$var$deleteAssociation = async (button)=>{
    const id = button.dataset.value;
    if (id) {
        const res = await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).associations.edit({
            id: id
        }));
        if (res.ok) {
            button.closest("tr")?.remove();
            (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("companyPicker")?.refresh();
            (0, $b3c77961ceea21a2$export$475dfb2b50fe6412)("individualPicker")?.refresh();
        }
    }
};
const $f3eecde3376fb915$var$undoCompanyImport = async (button)=>{
    const id = button.dataset.value;
    if (id) {
        if (confirm("Are you sure you want to undo your last import? This action can NOT be reversed.")) {
            await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).companies.import.delete({
                id: id
            }));
            $f3eecde3376fb915$var$close();
        }
    }
};
const $f3eecde3376fb915$var$undoIndividualImport = async (button)=>{
    const id = button.dataset.value;
    if (id) {
        if (confirm("Are you sure you want to undo your last import? This action can NOT be reversed.")) {
            await (0, $0690cfee00fb4cf1$export$4bd2facc4a3e6aa1)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).individuals.import.delete({
                id: id
            }));
            $f3eecde3376fb915$var$close();
        }
    }
};
const $f3eecde3376fb915$var$previewTemplate = async (button)=>{
    const form = button.closest("form");
    if (form) {
        const data = (0, $81088ee9a0e19312$export$357523c63a2253b9)((0, $e68843d575be3a15$export$9643fd7297feaaf5)(form), "subject", "content");
        const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).templates.preview(), data);
        const { subject: subject, content: content, signature: signature } = await res.json();
        (0, $c104550478c564ce$export$d7e8d4d4450c819c)({
            title: subject,
            body: content ? `${content}${signature ?? ""}` : signature,
            fullScreen: true
        });
    }
};





(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="bookkeepingFrequency"]')
    ].map((editableElement)=>editableElement).forEach((editableElement)=>{
        const form = editableElement.closest("form");
        const dropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editableElement.id);
        const editor = (0, $e68843d575be3a15$export$d193da8733a2af56)(editableElement.id);
        const control = dropDownList ?? editor;
        if (control) {
            const refresh = (bookkeepingFrequency, options)=>{
                const { save: save } = options ?? {};
                const selected = control.value === bookkeepingFrequency;
                const dayTr = form.querySelector(`tr[data-bookkeeping-frequency="${bookkeepingFrequency}"]`);
                dayTr.classList.toggle("d-none", !selected);
                const dayEditable = dayTr.querySelector('.editable[data-field="bookkeepingDay"]');
                if (dayEditable) {
                    const dayEditableProps = (0, $e68843d575be3a15$export$75fe5f91d452f94b)(dayEditable.id);
                    const dayDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(dayEditable.id);
                    const dayEditor = (0, $e68843d575be3a15$export$d193da8733a2af56)(dayEditable.id);
                    const disabled = !selected || !!dayEditableProps?.readOnly;
                    if (dayDropDownList) dayDropDownList.enabled = !disabled;
                    else if (dayEditor) {
                        dayEditor.disabled = disabled;
                        if (selected && save) (0, $e68843d575be3a15$export$18f2ef1f3de9bc1c)(dayEditable.id, null);
                    }
                }
            };
            refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Weekly);
            refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Monthly);
            refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Quarterly);
            if (dropDownList) dropDownList.addEventListener("change", ()=>{
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Weekly);
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Monthly);
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Quarterly);
            });
            else if (editor) editor.addEventListener("actionSuccess", ()=>{
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Weekly, {
                    save: true
                });
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Monthly, {
                    save: true
                });
                refresh((0, $19ee14db620c232e$export$6753c3448f1fa548).Quarterly, {
                    save: true
                });
            });
        }
    });
});





(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="companyType"]')
    ].map((editable)=>editable).forEach((editable)=>{
        const form = editable.closest("form");
        const companyTypeDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editable.id);
        const refresh = (...companyTypes)=>{
            const selected = companyTypes.includes(companyTypeDropDownList.value);
            [
                ...form.querySelectorAll(`[data-company-types="${companyTypes.join(",")}"]`)
            ].map((childContainer)=>childContainer).forEach((childContainer)=>{
                childContainer.classList.toggle("d-none", !selected);
                const childEditable = childContainer.querySelector(".editable");
                if (childEditable) (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(childEditable.id).enabled = selected;
            });
        };
        if (companyTypeDropDownList) {
            refresh((0, $19ee14db620c232e$export$97fd21cceb1e64f3).LimitedCompany, (0, $19ee14db620c232e$export$97fd21cceb1e64f3).LimitedLiabilityPartnership);
            refresh((0, $19ee14db620c232e$export$97fd21cceb1e64f3).SoleTrader, (0, $19ee14db620c232e$export$97fd21cceb1e64f3).Partnership);
            companyTypeDropDownList.addEventListener("change", ()=>{
                refresh((0, $19ee14db620c232e$export$97fd21cceb1e64f3).LimitedCompany, (0, $19ee14db620c232e$export$97fd21cceb1e64f3).LimitedLiabilityPartnership);
                refresh((0, $19ee14db620c232e$export$97fd21cceb1e64f3).SoleTrader, (0, $19ee14db620c232e$export$97fd21cceb1e64f3).Partnership);
            });
        }
    });
});


var $cb71ca56f6b2d601$exports = {};
$parcel$export($cb71ca56f6b2d601$exports, "BarSeries", () => $2786904b7ad446ea$export$2db55af16212ab81);
$parcel$export($cb71ca56f6b2d601$exports, "Category", () => $5a5b2b40af1980fd$export$3a8840c5b2ecf003);
$parcel$export($cb71ca56f6b2d601$exports, "Chart", () => $7c7d40c195159aeb$export$acaa6426d77a227e);
$parcel$export($cb71ca56f6b2d601$exports, "ColumnSeries", () => $16363daad46d2025$export$2d315e625d1b73ef);
$parcel$export($cb71ca56f6b2d601$exports, "DataLabel", () => $7bcacb0842c8c01a$export$2b4a904504ac8010);
$parcel$export($cb71ca56f6b2d601$exports, "Legend", () => $331409338e08b18d$export$ed247974535929c7);
$parcel$export($cb71ca56f6b2d601$exports, "StackingBarSeries", () => $3d9da221882eb0c6$export$876b8bd838c9945c);
$parcel$export($cb71ca56f6b2d601$exports, "StackingColumnSeries", () => $4484456d62ae4fe7$export$7cb365a371b161cd);
$parcel$export($cb71ca56f6b2d601$exports, "Tooltip", () => $58b0bf815360f2fc$export$28c660c63b792dea);
$parcel$export($cb71ca56f6b2d601$exports, "BarSeries", () => $2786904b7ad446ea$export$2db55af16212ab81);
$parcel$export($cb71ca56f6b2d601$exports, "Category", () => $5a5b2b40af1980fd$export$3a8840c5b2ecf003);
$parcel$export($cb71ca56f6b2d601$exports, "Chart", () => $7c7d40c195159aeb$export$acaa6426d77a227e);
$parcel$export($cb71ca56f6b2d601$exports, "ColumnSeries", () => $16363daad46d2025$export$2d315e625d1b73ef);
$parcel$export($cb71ca56f6b2d601$exports, "DataLabel", () => $7bcacb0842c8c01a$export$2b4a904504ac8010);
$parcel$export($cb71ca56f6b2d601$exports, "Legend", () => $331409338e08b18d$export$ed247974535929c7);
$parcel$export($cb71ca56f6b2d601$exports, "StackingBarSeries", () => $3d9da221882eb0c6$export$876b8bd838c9945c);
$parcel$export($cb71ca56f6b2d601$exports, "StackingColumnSeries", () => $4484456d62ae4fe7$export$7cb365a371b161cd);
$parcel$export($cb71ca56f6b2d601$exports, "Tooltip", () => $58b0bf815360f2fc$export$28c660c63b792dea);
/**
 * Chart components exported.
 */ parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $2ae44f835da15a47$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2ae44f835da15a47$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * The `Connector` class configures the appearance and properties of connectors in chart controls.
 */ var $2ae44f835da15a47$export$b2278035370d6017 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Connector, _super);
    function Connector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Line")
    ], Connector.prototype, "type", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Connector.prototype, "color", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Connector.prototype, "width", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Connector.prototype, "length", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Connector.prototype, "dashArray", void 0);
    return Connector;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the location for the legend and tooltip in the chart.
 */ var $2ae44f835da15a47$export$18a2be9195644f38 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Location, _super);
    function Location() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Location.prototype, "x", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Location.prototype, "y", void 0);
    return Location;
}((0, $3fcxu.ChildProperty));
/**
 * The `Font` class provides configuration options for customizing the fonts used in the charts.
 */ var $2ae44f835da15a47$export$89abf52a030e56ee = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Font, _super);
    function Font() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], Font.prototype, "fontStyle", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("16px")
    ], Font.prototype, "size", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], Font.prototype, "fontWeight", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Font.prototype, "color", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], Font.prototype, "textAlignment", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Segoe UI")
    ], Font.prototype, "fontFamily", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Font.prototype, "opacity", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Wrap")
    ], Font.prototype, "textOverflow", void 0);
    return Font;
}((0, $3fcxu.ChildProperty));
/**
 * Options to customize the center label of the Pie and Donut charts.
 *
 * @default {}
 */ var $2ae44f835da15a47$export$a465ba5c5f571984 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(CenterLabel, _super);
    function CenterLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CenterLabel.prototype, "text", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: "16px",
            fontStyle: "Normal",
            fontWeight: "600",
            color: null
        }, $2ae44f835da15a47$export$89abf52a030e56ee)
    ], CenterLabel.prototype, "textStyle", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CenterLabel.prototype, "hoverTextFormat", void 0);
    return CenterLabel;
}((0, $3fcxu.ChildProperty));
/**
 * The `Border` class provides configuration options for setting the borders in a chart.
 */ var $2ae44f835da15a47$export$d8e9c9d63e86d41e = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Border, _super);
    function Border() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Border.prototype, "color", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Border.prototype, "width", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Border.prototype, "dashArray", void 0);
    return Border;
}((0, $3fcxu.ChildProperty));
/**
 * The `Offset` class provides options to adjust the position of the marker relative to its default location.
 */ var $2ae44f835da15a47$export$8caee09accd95d7f = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Offset, _super);
    function Offset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Offset.prototype, "x", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Offset.prototype, "y", void 0);
    return Offset;
}((0, $3fcxu.ChildProperty));
/**
 * The `Margin` class enables configuration of the space around the chart's content.
 */ var $2ae44f835da15a47$export$e717bcf55e1dfb40 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Margin, _super);
    function Margin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)((0, $5q7BP.Browser).isDevice ? 5 : 10)
    ], Margin.prototype, "left", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)((0, $5q7BP.Browser).isDevice ? 5 : 10)
    ], Margin.prototype, "right", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)((0, $5q7BP.Browser).isDevice ? 5 : 10)
    ], Margin.prototype, "top", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)((0, $5q7BP.Browser).isDevice ? 5 : 10)
    ], Margin.prototype, "bottom", void 0);
    return Margin;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the animation behavior for the chart series.
 */ var $2ae44f835da15a47$export$c35d437ae5945fcd = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Animation.prototype, "enable", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], Animation.prototype, "duration", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Animation.prototype, "delay", void 0);
    return Animation;
}((0, $3fcxu.ChildProperty));
var $2ae44f835da15a47$export$d4a9de031ac0108 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(TooltipSettings, _super);
    function TooltipSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TooltipSettings.prototype, "enable", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TooltipSettings.prototype, "enableMarker", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TooltipSettings.prototype, "shared", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipSettings.prototype, "fill", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipSettings.prototype, "header", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipSettings.prototype, "opacity", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: "Normal",
            fontWeight: null,
            color: null
        }, $2ae44f835da15a47$export$89abf52a030e56ee)
    ], TooltipSettings.prototype, "textStyle", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipSettings.prototype, "format", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipSettings.prototype, "template", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TooltipSettings.prototype, "enableAnimation", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(300)
    ], TooltipSettings.prototype, "duration", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], TooltipSettings.prototype, "fadeOutDuration", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Move")
    ], TooltipSettings.prototype, "fadeOutMode", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TooltipSettings.prototype, "enableTextWrap", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TooltipSettings.prototype, "showNearestPoint", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: null
        }, $2ae44f835da15a47$export$d8e9c9d63e86d41e)
    ], TooltipSettings.prototype, "border", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            x: null,
            y: null
        }, $2ae44f835da15a47$export$18a2be9195644f38)
    ], TooltipSettings.prototype, "location", void 0);
    return TooltipSettings;
}((0, $3fcxu.ChildProperty));
/**
 * This class configures the appearance and behavior of points with empty data in the series.
 */ var $2ae44f835da15a47$export$83e1c8b12fd66dd2 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(EmptyPointSettings, _super);
    function EmptyPointSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], EmptyPointSettings.prototype, "fill", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "transparent",
            width: 0
        }, $2ae44f835da15a47$export$d8e9c9d63e86d41e)
    ], EmptyPointSettings.prototype, "border", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Gap")
    ], EmptyPointSettings.prototype, "mode", void 0);
    return EmptyPointSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Specifies the indexes for the series and data points.
 *
 * @public
 */ var $2ae44f835da15a47$export$697be589595ff0ae = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Indexes, _super);
    function Indexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Indexes.prototype, "series", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Indexes.prototype, "point", void 0);
    return Indexes;
}((0, $3fcxu.ChildProperty));
/**
 * The `CornerRadius` class provides options to customize the rounding of the corners for columns in the column series.
 */ var $2ae44f835da15a47$export$c00d35911f9e8312 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(CornerRadius, _super);
    function CornerRadius() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], CornerRadius.prototype, "topLeft", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], CornerRadius.prototype, "topRight", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], CornerRadius.prototype, "bottomLeft", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], CornerRadius.prototype, "bottomRight", void 0);
    return CornerRadius;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the padding around the chart legend container.
 */ var $2ae44f835da15a47$export$be26d33269c1ea81 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(ContainerPadding, _super);
    function ContainerPadding() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ContainerPadding.prototype, "left", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ContainerPadding.prototype, "right", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ContainerPadding.prototype, "top", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ContainerPadding.prototype, "bottom", void 0);
    return ContainerPadding;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the borders of the chart title and subtitle.
 */ var $2ae44f835da15a47$export$3830850a69a628fa = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(titleBorder, _super);
    function titleBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("transparent")
    ], titleBorder.prototype, "color", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], titleBorder.prototype, "width", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0.8)
    ], titleBorder.prototype, "cornerRadius", void 0);
    return titleBorder;
}((0, $3fcxu.ChildProperty));
/**
 * The `titleSettings` class provides options to customize the title and subtitle displayed in the chart.
 */ var $2ae44f835da15a47$export$237baa79a0592c9a = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(titleSettings, _super);
    function titleSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], titleSettings.prototype, "fontStyle", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("15px")
    ], titleSettings.prototype, "size", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("500")
    ], titleSettings.prototype, "fontWeight", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("")
    ], titleSettings.prototype, "color", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], titleSettings.prototype, "textAlignment", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Segoe UI")
    ], titleSettings.prototype, "fontFamily", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], titleSettings.prototype, "opacity", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Wrap")
    ], titleSettings.prototype, "textOverflow", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Top")
    ], titleSettings.prototype, "position", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], titleSettings.prototype, "x", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], titleSettings.prototype, "y", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("transparent")
    ], titleSettings.prototype, "background", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({}, $2ae44f835da15a47$export$3830850a69a628fa)
    ], titleSettings.prototype, "border", void 0);
    return titleSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The `ChartArea` class provides properties to customize the appearance and layout of the chart's display area.
 */ var $2ae44f835da15a47$export$2d13e9563b23a413 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(ChartArea, _super);
    function ChartArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({}, $2ae44f835da15a47$export$d8e9c9d63e86d41e)
    ], ChartArea.prototype, "border", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("transparent")
    ], ChartArea.prototype, "background", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ChartArea.prototype, "opacity", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartArea.prototype, "backgroundImage", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartArea.prototype, "width", void 0);
    return ChartArea;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the drag settings for series in the chart.
 */ var $2ae44f835da15a47$export$7f0d187f4d142ae0 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(DragSettings, _super);
    function DragSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DragSettings.prototype, "enable", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DragSettings.prototype, "minY", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DragSettings.prototype, "maxY", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DragSettings.prototype, "fill", void 0);
    return DragSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the button settings in period selector.
 */ var $2ae44f835da15a47$export$2be98a1249103ab1 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(Periods, _super);
    function Periods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Years")
    ], Periods.prototype, "intervalType", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Periods.prototype, "interval", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Periods.prototype, "text", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Periods.prototype, "selected", void 0);
    return Periods;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the period selector settings.
 */ var $2ae44f835da15a47$export$34713105ec05d367 = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(PeriodSelectorSettings, _super);
    function PeriodSelectorSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(43)
    ], PeriodSelectorSettings.prototype, "height", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Bottom")
    ], PeriodSelectorSettings.prototype, "position", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Collection)([], $2ae44f835da15a47$export$2be98a1249103ab1)
    ], PeriodSelectorSettings.prototype, "periods", void 0);
    return PeriodSelectorSettings;
}((0, $3fcxu.ChildProperty));
var $2ae44f835da15a47$export$7bd5a57f2f1845ae = /** @class */ function(_super) {
    $2ae44f835da15a47$var$__extends(StockTooltipSettings, _super);
    function StockTooltipSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StockTooltipSettings.prototype, "enable", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], StockTooltipSettings.prototype, "enableMarker", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StockTooltipSettings.prototype, "shared", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StockTooltipSettings.prototype, "fill", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StockTooltipSettings.prototype, "header", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(0.75)
    ], StockTooltipSettings.prototype, "opacity", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: "12px",
            fontStyle: "Normal",
            fontWeight: null,
            color: null
        }, $2ae44f835da15a47$export$89abf52a030e56ee)
    ], StockTooltipSettings.prototype, "textStyle", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StockTooltipSettings.prototype, "format", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StockTooltipSettings.prototype, "template", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], StockTooltipSettings.prototype, "enableAnimation", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(300)
    ], StockTooltipSettings.prototype, "duration", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], StockTooltipSettings.prototype, "fadeOutDuration", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Move")
    ], StockTooltipSettings.prototype, "fadeOutMode", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StockTooltipSettings.prototype, "enableTextWrap", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], StockTooltipSettings.prototype, "showNearestPoint", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: null
        }, $2ae44f835da15a47$export$d8e9c9d63e86d41e)
    ], StockTooltipSettings.prototype, "border", void 0);
    $2ae44f835da15a47$var$__decorate([
        (0, $5rsSz.Property)("Fixed")
    ], StockTooltipSettings.prototype, "position", void 0);
    return StockTooltipSettings;
}((0, $3fcxu.ChildProperty));
/**
 * @private
 */ var $2ae44f835da15a47$export$cf17b003b6192af3 = /** @class */ function() {
    function Index(seriesIndex, pointIndex) {
        this.series = seriesIndex;
        this.point = pointIndex;
    }
    return Index;
}();


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $3EnZW = parcelRequire("3EnZW");


/**
 * index
 */ /**
 * Chart components exported.
 */ /**
 * Chart component exported items
 */ parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Base modules
 */ /* eslint-disable jsdoc/require-returns */ /* eslint-disable valid-jsdoc */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * To import utils
 */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $aa3074f243277ee7$export$5ff52eac0871021a = /** @class */ function() {
    /* End-Properties */ function SvgRenderer(rootID) {
        //Internal Variables
        this.svgLink = "http://www.w3.org/2000/svg";
        this.rootId = rootID;
    }
    // method to get the attributes value
    // tslint:disable-next-line:no-any
    SvgRenderer.prototype.getOptionValue = function(options, key) {
        return options[key];
    }; /* tslint:enable */ 
    /**
     * To create a Html5 SVG element
     *
     * @param {SVGAttributes} options - Options to create SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createSvg = function(options) {
        if ((0, $3EnZW.isNullOrUndefined)(options.id)) options.id = this.rootId + "_svg";
        this.svgObj = document.getElementById(options.id);
        if ((0, $3EnZW.isNullOrUndefined)(document.getElementById(options.id))) this.svgObj = document.createElementNS(this.svgLink, "svg");
        this.svgObj = this.setElementAttributes(options, this.svgObj);
        this.setSVGSize(options.width, options.height);
        return this.svgObj;
    };
    // method to set the height and width for the SVG element
    SvgRenderer.prototype.setSVGSize = function(width, height) {
        var element = document.getElementById(this.rootId);
        var size = !(0, $3EnZW.isNullOrUndefined)(element) ? element.getBoundingClientRect() : null;
        if ((0, $3EnZW.isNullOrUndefined)(this.width) || this.width <= 0) this.svgObj.setAttribute("width", width ? width.toString() : size.width.toString());
        else this.svgObj.setAttribute("width", this.width.toString());
        if ((0, $3EnZW.isNullOrUndefined)(this.height) || this.height <= 0) this.svgObj.setAttribute("height", height ? height.toString() : "450");
        else this.svgObj.setAttribute("height", this.height.toString());
    };
    /**
     * To draw a path
     *
     * @param {PathAttributes} options - Options to draw a path in SVG
     * @returns {Element} It returns a appropriate path
     */ SvgRenderer.prototype.drawPath = function(options) {
        var path = document.getElementById(options.id);
        if (path === null) path = document.createElementNS(this.svgLink, "path");
        path = this.setElementAttributes(options, path);
        return path;
    };
    /**
     * To draw a line
     *
     * @param {LineAttributes} options - Options to draw a line in SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawLine = function(options) {
        var line = document.getElementById(options.id);
        if (line === null) line = document.createElementNS(this.svgLink, "line");
        line = this.setElementAttributes(options, line);
        return line;
    };
    /**
     * To draw a rectangle
     *
     * @param {BaseAttibutes} options - Required options to draw a rectangle in SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawRectangle = function(options) {
        var rectangle = document.getElementById(options.id);
        if (rectangle === null) rectangle = document.createElementNS(this.svgLink, "rect");
        rectangle = this.setElementAttributes(options, rectangle);
        return rectangle;
    };
    /**
     * To draw a circle
     *
     * @param {CircleAttributes} options - Required options to draw a circle in SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawCircle = function(options) {
        var circle = document.getElementById(options.id);
        if (circle === null) circle = document.createElementNS(this.svgLink, "circle");
        circle = this.setElementAttributes(options, circle);
        return circle;
    };
    /**
     * To draw a polyline
     *
     * @param {PolylineAttributes} options - Options required to draw a polyline
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawPolyline = function(options) {
        var polyline = document.getElementById(options.id);
        if (polyline === null) polyline = document.createElementNS(this.svgLink, "polyline");
        polyline = this.setElementAttributes(options, polyline);
        return polyline;
    };
    /**
     * To draw an ellipse
     *
     * @param {EllipseAttributes} options - Options required to draw an ellipse
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawEllipse = function(options) {
        var ellipse = document.getElementById(options.id);
        if (ellipse === null) ellipse = document.createElementNS(this.svgLink, "ellipse");
        ellipse = this.setElementAttributes(options, ellipse);
        return ellipse;
    };
    /**
     * To draw a polygon
     *
     * @param {PolylineAttributes} options - Options needed to draw a polygon in SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawPolygon = function(options) {
        var polygon = document.getElementById(options.id);
        if (polygon === null) polygon = document.createElementNS(this.svgLink, "polygon");
        polygon = this.setElementAttributes(options, polygon);
        return polygon;
    };
    /**
     * To draw an image
     *
     * @param {ImageAttributes} options - Required options to draw an image in SVG
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawImage = function(options) {
        var img = document.createElementNS(this.svgLink, "image");
        img.setAttributeNS(null, "height", options.height.toString());
        img.setAttributeNS(null, "width", options.width.toString());
        img.setAttributeNS("http://www.w3.org/1999/xlink", "href", options.href);
        img.setAttributeNS(null, "x", options.x.toString());
        img.setAttributeNS(null, "y", options.y.toString());
        img.setAttributeNS(null, "id", options.id);
        img.setAttributeNS(null, "visibility", options.visibility);
        if (!(0, $3EnZW.isNullOrUndefined)(this.getOptionValue(options, "clip-path"))) img.setAttributeNS(null, "clip-path", this.getOptionValue(options, "clip-path"));
        if (!(0, $3EnZW.isNullOrUndefined)(options.preserveAspectRatio)) img.setAttributeNS(null, "preserveAspectRatio", options.preserveAspectRatio);
        return img;
    };
    /**
     * To draw a text
     *
     * @param {TextAttributes} options - Options needed to draw a text in SVG
     * @param {string} label - Label of the text
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createText = function(options, label) {
        var text = document.createElementNS(this.svgLink, "text");
        text = this.setElementAttributes(options, text);
        if (!(0, $3EnZW.isNullOrUndefined)(label)) text.textContent = label;
        return text;
    };
    /**
     * To create a tSpan
     *
     * @param {TextAttributes} options - Options to create tSpan
     * @param {string} label - The text content which is to be rendered in the tSpan
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createTSpan = function(options, label) {
        var tSpan = document.createElementNS(this.svgLink, "tspan");
        tSpan = this.setElementAttributes(options, tSpan);
        if (!(0, $3EnZW.isNullOrUndefined)(label)) tSpan.textContent = label;
        return tSpan;
    };
    /**
     * To create a title
     *
     * @param {string} text - The text content which is to be rendered in the title
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createTitle = function(text) {
        var title = document.createElementNS(this.svgLink, "title");
        title.textContent = text;
        return title;
    };
    /**
     * To create defs element in SVG
     *
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createDefs = function() {
        var defs = document.createElementNS(this.svgLink, "defs");
        return defs;
    };
    /**
     * To create clip path in SVG
     *
     * @param {BaseAttibutes} options - Options needed to create clip path
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createClipPath = function(options) {
        var clipPath = document.createElementNS(this.svgLink, "clipPath");
        clipPath = this.setElementAttributes(options, clipPath);
        return clipPath;
    };
    /**
     * To create foreign object in SVG
     *
     * @param {BaseAttibutes} options - Options needed to create foreign object
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createForeignObject = function(options) {
        var foreignObject = document.createElementNS(this.svgLink, "foreignObject");
        foreignObject = this.setElementAttributes(options, foreignObject);
        return foreignObject;
    };
    /**
     * To create group element in SVG
     *
     * @param {BaseAttibutes} options - Options needed to create group
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createGroup = function(options) {
        var group = document.createElementNS(this.svgLink, "g");
        group = this.setElementAttributes(options, group);
        return group;
    };
    /**
     * To create pattern in SVG
     *
     * @param {PatternAttributes} options - Required options to create pattern in SVG
     * @param {string} element - Specifies the name of the pattern
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.createPattern = function(options, element) {
        var pattern = document.createElementNS(this.svgLink, element);
        pattern = this.setElementAttributes(options, pattern);
        return pattern;
    };
    /**
     * To create radial gradient in SVG
     *
     * @param {string[]} colors - Specifies the colors required to create radial gradient
     * @param {string} name - Specifies the name of the gradient
     * @param {RadialGradient} options - value for radial gradient
     * @returns {string} It returns color name
     */ SvgRenderer.prototype.createRadialGradient = function(colors, name, options) {
        var colorName;
        if (!(0, $3EnZW.isNullOrUndefined)(colors[0].colorStop)) {
            var newOptions = {
                "id": this.rootId + "_" + name + "radialGradient",
                "cx": options.cx + "%",
                "cy": options.cy + "%",
                "r": options.r + "%",
                "fx": options.fx + "%",
                "fy": options.fy + "%"
            };
            this.drawGradient("radialGradient", newOptions, colors);
            colorName = "url(#" + this.rootId + "_" + name + "radialGradient)";
        } else colorName = colors[0].color.toString();
        return colorName;
    };
    /**
     * To create linear gradient in SVG
     *
     * @param {GradientColor[]} colors - Array of string specifies the values for color
     * @param {string} name - Specifies the name of the gradient
     * @param {LinearGradient} options - Specifies the options for gradient
     * @returns {string} It returns color name
     */ SvgRenderer.prototype.createLinearGradient = function(colors, name, options) {
        var colorName;
        if (!(0, $3EnZW.isNullOrUndefined)(colors[0].colorStop)) {
            var newOptions = {
                "id": this.rootId + "_" + name + "linearGradient",
                "x1": options.x1 + "%",
                "y1": options.y1 + "%",
                "x2": options.x2 + "%",
                "y2": options.y2 + "%"
            };
            this.drawGradient("linearGradient", newOptions, colors);
            colorName = "url(#" + this.rootId + "_" + name + "linearGradient)";
        } else colorName = colors[0].color.toString();
        return colorName;
    };
    /**
     * To render the gradient element in SVG
     *
     * @param {string} gradientType - Specifies the type of the gradient
     * @param {RadialGradient | LinearGradient} options - Options required to render a gradient
     * @param {string[]} colors - Array of string specifies the values for color
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawGradient = function(gradientType, options, colors) {
        var defs = this.createDefs();
        var gradient = document.createElementNS(this.svgLink, gradientType);
        gradient = this.setElementAttributes(options, gradient);
        for(var i = 0; i < colors.length; i++){
            var stop_1 = document.createElementNS(this.svgLink, "stop");
            stop_1.setAttribute("offset", colors[i].colorStop);
            stop_1.setAttribute("stop-color", colors[i].color);
            stop_1.setAttribute("stop-opacity", colors[i].opacity ? colors[i].opacity : "1");
            if (!(0, $3EnZW.isNullOrUndefined)(colors[i].style)) stop_1.style.cssText = colors[i].style;
            gradient.appendChild(stop_1);
        }
        defs.appendChild(gradient);
        return defs;
    };
    /**
     * To render a clip path
     *
     * @param {BaseAttibutes} options - Options required to render a clip path
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawClipPath = function(options) {
        var defs = this.createDefs();
        var clipPath = this.createClipPath({
            "id": options.id
        });
        options.id = options.id + "_Rect";
        var rect = this.drawRectangle(options);
        clipPath.appendChild(rect);
        defs.appendChild(clipPath);
        return defs;
    };
    /**
     * To create circular clip path in SVG
     *
     * @param {CircleAttributes} options - Options required to create circular clip path
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.drawCircularClipPath = function(options) {
        var defs = this.createDefs();
        var clipPath = this.createClipPath({
            "id": options.id
        });
        options.id = options.id + "_Circle";
        var circle = this.drawCircle(options);
        clipPath.appendChild(circle);
        defs.appendChild(clipPath);
        return defs;
    };
    /**
     * To set the attributes to the element
     *
     * @param {SVGCanvasAttributes} options - Attributes to set for the element
     * @param {Element} element - The element to which the attributes need to be set
     * @returns {Element} It returns a appropriate element
     */ SvgRenderer.prototype.setElementAttributes = function(options, element) {
        var keys = Object.keys(options);
        for(var i = 0; i < keys.length; i++)if (keys[i] === "style") element.style.cssText = options[keys[i]];
        else element.setAttribute(keys[i], options[keys[i]]);
        return element;
    };
    /**
     * To create a Html5 canvas element
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ SvgRenderer.prototype.createCanvas = function() {
        return null;
    };
    return SvgRenderer;
}();


/* eslint-disable no-case-declarations */ /* eslint-disable jsdoc/require-returns */ /* eslint-disable valid-jsdoc */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * To import utils.
 */ parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * @private
 */ var $be4148c2a6d179c7$export$7adc20298958481a = /** @class */ function() {
    /* End-Properties */ function CanvasRenderer(rootID) {
        this.rootId = rootID;
    }
    // method to get the attributes value
    // tslint:disable-next-line:no-any
    CanvasRenderer.prototype.getOptionValue = function(options, key) {
        return options[key];
    };
    /* tslint:enable */ /**
     * To create a Html5 canvas element
     *
     * @param {BaseAttibutes} options - Options to create canvas
     * @returns {HTMLCanvasElement} Creating a canvas
     */ CanvasRenderer.prototype.createCanvas = function(options) {
        var canvasObj = document.createElement("canvas");
        canvasObj.setAttribute("id", this.rootId + "_canvas");
        this.ctx = canvasObj.getContext("2d");
        this.canvasObj = canvasObj;
        this.setCanvasSize(options.width, options.height);
        return this.canvasObj;
    };
    /**
     * To set the width and height for the Html5 canvas element
     *
     * @param {number} width - width of the canvas
     * @param {number} height - height of the canvas
     * @returns {void} Setting canvas size
     */ CanvasRenderer.prototype.setCanvasSize = function(width, height) {
        var element = document.getElementById(this.rootId);
        var size = !(0, $3EnZW.isNullOrUndefined)(element) ? element.getBoundingClientRect() : null;
        if ((0, $3EnZW.isNullOrUndefined)(this.width)) this.canvasObj.setAttribute("width", width ? width.toString() : size.width.toString());
        else this.canvasObj.setAttribute("width", this.width.toString());
        if ((0, $3EnZW.isNullOrUndefined)(this.height)) this.canvasObj.setAttribute("height", height ? height.toString() : "450");
        else this.canvasObj.setAttribute("height", this.height.toString());
    };
    // To set the values to the attributes
    CanvasRenderer.prototype.setAttributes = function(options) {
        this.ctx.lineWidth = this.getOptionValue(options, "stroke-width");
        var dashArray = this.getOptionValue(options, "stroke-dasharray");
        if (!(0, $3EnZW.isNullOrUndefined)(dashArray)) {
            var dashArrayString = dashArray.split(",");
            this.ctx.setLineDash([
                parseInt(dashArrayString[0], 10),
                parseInt(dashArrayString[1], 10)
            ]);
        }
        this.ctx.strokeStyle = this.getOptionValue(options, "stroke");
    };
    /**
     * To draw a line
     *
     * @param {LineAttributes} options - required options to draw a line on the canvas
     * @returns {void} To draw a line
     */ CanvasRenderer.prototype.drawLine = function(options) {
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.lineWidth = this.getOptionValue(options, "stroke-width");
        this.ctx.strokeStyle = options.stroke;
        this.ctx.moveTo(options.x1, options.y1);
        this.ctx.lineTo(options.x2, options.y2);
        this.ctx.stroke();
        this.ctx.restore();
    };
    /**
     * To draw a rectangle
     *
     * @param {RectAttributes} options - required options to draw a rectangle on the canvas.
     * @param {Int32Array} canvasTranslate TO get a translate value of canvas.
     * @returns {void} To draw rectangle.
     */ CanvasRenderer.prototype.drawRectangle = function(options, canvasTranslate) {
        var canvasCtx = this.ctx;
        var cornerRadius = options.rx;
        this.ctx.save();
        this.ctx.beginPath();
        if (canvasTranslate) this.ctx.translate(canvasTranslate[0], canvasTranslate[1]);
        this.ctx.globalAlpha = this.getOptionValue(options, "opacity");
        this.setAttributes(options);
        this.ctx.rect(options.x, options.y, options.width, options.height);
        if (cornerRadius !== null && cornerRadius >= 0) this.drawCornerRadius(options);
        else {
            if (options.fill === "none") options.fill = "transparent";
            this.ctx.fillStyle = options.fill;
            this.ctx.fillRect(options.x, options.y, options.width, options.height);
            this.ctx.stroke();
        }
        this.ctx.restore();
        this.ctx = canvasCtx;
        return this.canvasObj;
    };
    // To draw the corner of a rectangle
    CanvasRenderer.prototype.drawCornerRadius = function(options) {
        var cornerRadius = options.rx;
        var x = options.x;
        var y = options.y;
        var width = options.width;
        var height = options.height;
        if (options.fill === "none") options.fill = "transparent";
        this.ctx.fillStyle = options.fill;
        if (width < 2 * cornerRadius) cornerRadius = width / 2;
        if (height < 2 * cornerRadius) cornerRadius = height / 2;
        this.ctx.beginPath();
        this.ctx.moveTo(x + width - cornerRadius, y);
        this.ctx.arcTo(x + width, y, x + width, y + height, cornerRadius);
        this.ctx.arcTo(x + width, y + height, x, y + height, cornerRadius);
        this.ctx.arcTo(x, y + height, x, y, cornerRadius);
        this.ctx.arcTo(x, y, x + width, y, cornerRadius);
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.stroke();
    };
    /**
     * To draw a path on the canvas
     *
     * @param {PathAttributes} options - options needed to draw path.
     * @param {Int32Array} canvasTranslate - Array of numbers to translate the canvas.
     * @returns {Element} To draw a path.
     */ CanvasRenderer.prototype.drawPath = function(options, canvasTranslate) {
        var path = options.d;
        var dataSplit = path.split(" ");
        var borderWidth = this.getOptionValue(options, "stroke-width");
        var canvasCtx = this.ctx;
        var flag = true;
        this.ctx.save();
        this.ctx.beginPath();
        if (canvasTranslate) this.ctx.translate(canvasTranslate[0], canvasTranslate[1]);
        this.ctx.globalAlpha = options.opacity ? options.opacity : this.getOptionValue(options, "fill-opacity");
        this.setAttributes(options);
        for(var i = 0; i < dataSplit.length; i = i + 3){
            var x1 = parseFloat(dataSplit[i + 1]);
            var y1 = parseFloat(dataSplit[i + 2]);
            switch(dataSplit[i]){
                case "M":
                    if (!options.innerR && !options.cx) this.ctx.moveTo(x1, y1);
                    break;
                case "L":
                    if (!options.innerR) this.ctx.lineTo(x1, y1);
                    break;
                case "Q":
                    var q1 = parseFloat(dataSplit[i + 3]);
                    var q2 = parseFloat(dataSplit[i + 4]);
                    this.ctx.quadraticCurveTo(x1, y1, q1, q2);
                    i = i + 2;
                    break;
                case "C":
                    var c1 = parseFloat(dataSplit[i + 3]);
                    var c2 = parseFloat(dataSplit[i + 4]);
                    var c3 = parseFloat(dataSplit[i + 5]);
                    var c4 = parseFloat(dataSplit[i + 6]);
                    this.ctx.bezierCurveTo(x1, y1, c1, c2, c3, c4);
                    i = i + 4;
                    break;
                case "A":
                    if (!options.innerR) {
                        if (options.cx) this.ctx.arc(options.cx, options.cy, options.radius, 0, 2 * Math.PI, options.counterClockWise);
                        else {
                            this.ctx.moveTo(options.x, options.y);
                            this.ctx.arc(options.x, options.y, options.radius, options.start, options.end, options.counterClockWise);
                            this.ctx.lineTo(options.x, options.y);
                        }
                    } else if (flag) {
                        this.ctx.arc(options.x, options.y, options.radius, options.start, options.end, options.counterClockWise);
                        this.ctx.arc(options.x, options.y, options.innerR, options.end, options.start, !options.counterClockWise);
                        flag = false;
                    }
                    i = i + 5;
                    break;
                case "z":
                case "Z":
                    this.ctx.closePath();
                    //since for loop is incremented by 3, to get next value after 'z' i is decremented for 2.
                    i = i - 2;
                    break;
            }
        }
        if (options.fill !== "none" && options.fill !== undefined) {
            this.ctx.fillStyle = options.fill;
            this.ctx.fill();
        }
        if (borderWidth > 0) this.ctx.stroke();
        this.ctx.restore();
        this.ctx = canvasCtx;
        return this.canvasObj;
    };
    /**
     * To draw a text
     *
     * @param {TextAttributes} options - options required to draw text
     * @param {string} label - Specifies the text which has to be drawn on the canvas
     * @param {number} transX - Specifies the text of translate X
     * @param {number} transY - Specifies the text of translate Y
     * @param {number} dy - Specifies the text of translate dy
     * @param {boolean} isTSpan - Specifies the boolean value of span value
     * @returns {void}
     */ CanvasRenderer.prototype.createText = function(options, label, transX, transY, dy, isTSpan) {
        var fontWeight = this.getOptionValue(options, "font-weight");
        if (!(0, $3EnZW.isNullOrUndefined)(fontWeight) && fontWeight.toLowerCase() === "regular") fontWeight = "normal";
        var fontSize = this.getOptionValue(options, "font-size");
        var fontFamily = this.getOptionValue(options, "font-family");
        var fontStyle = this.getOptionValue(options, "font-style").toLowerCase();
        var font = fontStyle + " " + fontWeight + " " + fontSize + " " + fontFamily;
        var anchor = this.getOptionValue(options, "text-anchor");
        var opacity = options.opacity !== undefined ? options.opacity : 1;
        if (anchor === "middle") anchor = "center";
        this.ctx.save();
        this.ctx.fillStyle = options.fill;
        this.ctx.font = font;
        this.ctx.textAlign = anchor;
        this.ctx.globalAlpha = opacity;
        if (options.baseline) this.ctx.textBaseline = options.baseline;
        if (!isTSpan) {
            var txtlngth = 0;
            this.ctx.translate(options.x + txtlngth / 2 + (transX ? transX : 0), options.y + (transY ? transY : 0));
            this.ctx.rotate(options.labelRotation * Math.PI / 180);
        }
        this.ctx.fillText(label, isTSpan ? options.x : 0, isTSpan ? dy : 0);
        this.ctx.restore();
        return this.canvasObj;
    };
    /**
     * To draw circle on the canvas
     *
     * @param {CircleAttributes} options - required options to draw the circle
     * @param {Int32Array} canvasTranslate Translate value of canvas
     * @returns {void}
     */ CanvasRenderer.prototype.drawCircle = function(options, canvasTranslate) {
        var canvasCtx = this.ctx;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(options.cx, options.cy, options.r, 0, 2 * Math.PI);
        this.ctx.fillStyle = options.fill;
        this.ctx.globalAlpha = options.opacity;
        this.ctx.fill();
        if (canvasTranslate) this.ctx.translate(canvasTranslate[0], canvasTranslate[1]);
        this.setAttributes(options);
        this.ctx.stroke();
        this.ctx.restore();
        this.ctx = canvasCtx;
        return this.canvasObj;
    };
    /**
     * To draw polyline
     *
     * @param {PolylineAttributes} options - options needed to draw polyline
     * @returns {void}
     */ CanvasRenderer.prototype.drawPolyline = function(options) {
        this.ctx.save();
        this.ctx.beginPath();
        var points = options.points.split(" ");
        for(var i = 0; i < points.length - 1; i++){
            var point = points[i].split(",");
            var x = parseFloat(point[0]);
            var y = parseFloat(point[1]);
            if (i === 0) this.ctx.moveTo(x, y);
            else this.ctx.lineTo(x, y);
        }
        this.ctx.lineWidth = this.getOptionValue(options, "stroke-width");
        this.ctx.strokeStyle = options.stroke;
        this.ctx.stroke();
        this.ctx.restore();
    };
    /**
     * To draw an ellipse on the canvas
     *
     * @param {EllipseAttributes} options - options needed to draw ellipse
     * @param {Int32Array} canvasTranslate Translate value of canvas
     * @returns {void}
     */ CanvasRenderer.prototype.drawEllipse = function(options, canvasTranslate) {
        var canvasCtx = this.ctx;
        var circumference = Math.max(options.rx, options.ry);
        var scaleX = options.rx / circumference;
        var scaleY = options.ry / circumference;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.translate(options.cx, options.cy);
        if (canvasTranslate) this.ctx.translate(canvasTranslate[0], canvasTranslate[1]);
        this.ctx.save();
        this.ctx.scale(scaleX, scaleY);
        this.ctx.arc(0, 0, circumference, 0, 2 * Math.PI, false);
        this.ctx.fillStyle = options.fill;
        this.ctx.fill();
        this.ctx.restore();
        this.ctx.lineWidth = this.getOptionValue(options, "stroke-width");
        this.ctx.strokeStyle = options.stroke;
        this.ctx.stroke();
        this.ctx.restore();
        this.ctx = canvasCtx;
    };
    /**
     * To draw an image
     *
     * @param {ImageAttributes} options - options required to draw an image on the canvas
     * @returns {void}
     */ CanvasRenderer.prototype.drawImage = function(options) {
        this.ctx.save();
        var imageObj = new Image();
        if (!(0, $3EnZW.isNullOrUndefined)(options.href)) {
            imageObj.src = options.href;
            this.ctx.drawImage(imageObj, options.x, options.y, options.width, options.height);
        }
        this.ctx.restore();
    };
    /**
     * To create a linear gradient
     *
     * @param {string[]} colors - Specifies the colors required to create linear gradient
     * @returns {string} It returns color
     */ CanvasRenderer.prototype.createLinearGradient = function(colors) {
        var myGradient;
        if (!(0, $3EnZW.isNullOrUndefined)(colors[0].colorStop)) myGradient = this.ctx.createLinearGradient(0, 0, 0, this.canvasObj.height);
        var color = this.setGradientValues(colors, myGradient);
        return color;
    };
    /**
     * To create a radial gradient
     *
     * @param {string[]} colors - Specifies the colors required to create linear gradient
     * @returns {string} It returns gradient color
     */ CanvasRenderer.prototype.createRadialGradient = function(colors) {
        var myGradient;
        if (!(0, $3EnZW.isNullOrUndefined)(colors[0].colorStop)) myGradient = this.ctx.createRadialGradient(0, 0, 0, 0, 0, this.canvasObj.height);
        var colorName = this.setGradientValues(colors, myGradient);
        return colorName;
    };
    // To set the gradient values
    CanvasRenderer.prototype.setGradientValues = function(colors, myGradient) {
        var colorName;
        if (!(0, $3EnZW.isNullOrUndefined)(colors[0].colorStop)) {
            for(var i = 0; i <= colors.length - 1; i++){
                var color = colors[i].color;
                var newColorStop = colors[i].colorStop.slice(0, -1);
                var stopColor = parseInt(newColorStop, 10) / 100;
                myGradient.addColorStop(stopColor, color);
            }
            colorName = myGradient.toString();
        } else colorName = colors[0].color.toString();
        return colorName;
    };
    /**
     * To set the attributes to the element
     *
     * @param {SVGCanvasAttributes} options - Attributes to set for the element
     * @param {HTMLElement} element - The element to which the attributes need to be set
     * @returns {HTMLElement} It returns null value
     */ CanvasRenderer.prototype.setElementAttributes = function(options, element) {
        var keys = Object.keys(options);
        var values = Object.keys(options).map(function(key) {
            return options[key];
        });
        for(var i = 0; i < keys.length; i++)element.setAttribute(keys[i], values[i]);
        return null;
    };
    /**
     * To update the values of the canvas element attributes
     *
     * @param {SVGCanvasAttributes} options - Specifies the colors required to create gradient
     * @returns {void}
     */ CanvasRenderer.prototype.updateCanvasAttributes = function(options) {
        this.setElementAttributes(options, this.canvasObj);
        var ctx = this.ctx;
        if (!(0, $3EnZW.isNullOrUndefined)(this.dataUrl)) {
            var img_1 = new Image;
            img_1.onload = function() {
                ctx.drawImage(img_1, 0, 0);
            };
            img_1.src = this.dataUrl;
        }
    };
    /**
     * This method clears the given rectangle region
     *
     * @param {Rect} rect The rect parameter as passed
     */ CanvasRenderer.prototype.clearRect = function(rect) {
        this.ctx.restore();
        this.ctx.clearRect(rect.x, rect.y, rect.width, rect.height);
    };
    /**
     * For canvas rendering in chart
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ CanvasRenderer.prototype.createGroup = function() {
        return null;
    };
    /**
     * To render a clip path
     *
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ CanvasRenderer.prototype.drawClipPath = function() {
        return null;
    };
    /**
     * To render a Circular clip path
     *
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ CanvasRenderer.prototype.drawCircularClipPath = function() {
        return null;
    };
    /**
     * Clip method to perform clip in canvas mode
     *
     * @param {BaseAttibutes} options The canvas clip of options
     */ CanvasRenderer.prototype.canvasClip = function(options) {
        this.ctx.save();
        this.ctx.fillStyle = "transparent";
        this.ctx.rect(options.x, options.y, options.width, options.height);
        this.ctx.fill();
        this.ctx.clip();
    };
    /**
     * Tp restore the canvas
     */ CanvasRenderer.prototype.canvasRestore = function() {
        this.ctx.restore();
    };
    /**
     * To draw a polygon
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ CanvasRenderer.prototype.drawPolygon = function() {
        return null;
    };
    /**
     * To create defs element in SVG
     * Dummy method for using canvas/svg render in the same variable name in chart control
     *
     * @returns {Element} It returns null
     */ CanvasRenderer.prototype.createDefs = function() {
        return null;
    };
    /**
     * To create clip path in SVG
     * Dummy method for using canvas/svg render in the same variable name in chart control
     */ CanvasRenderer.prototype.createClipPath = function() {
        return null;
    };
    /**
     * To create a Html5 SVG element
     * Dummy method for using canvas/svg render in the same variable name in chart control
     *
     * @returns {Element} It returns null
     */ CanvasRenderer.prototype.createSvg = function() {
        return null;
    };
    return CanvasRenderer;
}();




/** @private */ function $c68f2eb9b3b2178c$export$f3d7188648e27489(theme) {
    var style;
    switch(theme){
        case "Highcontrast":
        case "HighContrast":
            style = {
                tooltipFill: "#ffffff",
                tooltipBoldLabel: "#000000",
                tooltipLightLabel: "#000000",
                tooltipHeaderLine: "#969696",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#000000",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "MaterialDark":
        case "FabricDark":
        case "BootstrapDark":
            style = {
                tooltipFill: theme === "MaterialDark" ? "#F4F4F4" : theme === "FabricDark" ? "#A19F9D" : "#F0F0F0",
                tooltipBoldLabel: theme === "MaterialDark" ? "rgba(18, 18, 18, 1)" : theme === "FabricDark" ? "#DADADA" : "#1A1A1A",
                tooltipLightLabel: theme === "MaterialDark" ? "rgba(18, 18, 18, 1)" : theme === "FabricDark" ? "#DADADA" : "#1A1A1A",
                tooltipHeaderLine: "#9A9A9A",
                textStyle: theme === "MaterialDark" ? {
                    fontFamily: "Roboto",
                    color: "rgba(18, 18, 18, 1)",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                } : theme === "FabricDark" ? {
                    fontFamily: "Segoe UI",
                    color: "#DADADA",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                } : {
                    fontFamily: "Helvetica",
                    color: "#1A1A1A",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Bootstrap4":
            style = {
                tooltipFill: "#212529",
                tooltipBoldLabel: "#F9FAFB",
                tooltipLightLabel: "#F9FAFB",
                tooltipHeaderLine: "rgba(255, 255, 255, 0.2)",
                textStyle: {
                    fontFamily: "Helvetica",
                    color: "#F9FAFB",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Tailwind":
            style = {
                tooltipFill: "#111827",
                tooltipBoldLabel: "#F9FAFB",
                tooltipLightLabel: "#F9FAFB",
                tooltipHeaderLine: "#6B7280",
                textStyle: {
                    fontFamily: "Inter",
                    color: "#F9FAFB",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "TailwindDark":
            style = {
                tooltipFill: "#E9ECEF",
                tooltipBoldLabel: "#1F2937",
                tooltipLightLabel: "#1F2937",
                tooltipHeaderLine: "#9CA3AF",
                textStyle: {
                    fontFamily: "Inter",
                    color: "#1F2937",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Bootstrap5":
            style = {
                tooltipFill: "#000000E5",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#FFFFFF",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#FFFFFF",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "16px",
                    boldTextSize: "14px"
                }
            };
            break;
        case "Bootstrap5Dark":
            style = {
                tooltipFill: "#FFFFFFE5",
                tooltipBoldLabel: "#212529",
                tooltipLightLabel: "#212529",
                tooltipHeaderLine: "#212529",
                textStyle: {
                    fontFamily: "Helvetica",
                    color: "#212529",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "16px",
                    boldTextSize: "14px"
                }
            };
            break;
        case "Fluent":
            style = {
                tooltipFill: "#FFFFFF",
                tooltipBoldLabel: "#323130",
                tooltipLightLabel: "#323130",
                tooltipHeaderLine: "#D2D0CE",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#323130",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "FluentDark":
            style = {
                tooltipFill: "#323130",
                tooltipBoldLabel: "#F3F2F2",
                tooltipLightLabel: "#F3F2F1",
                tooltipHeaderLine: "#3B3A39",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#F3F2F1",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Fluent2":
            style = {
                tooltipFill: "#FFFFFF",
                tooltipBoldLabel: "#242424",
                tooltipLightLabel: "#242424",
                tooltipHeaderLine: "#D2D0CE",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#242424",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Fluent2Dark":
            style = {
                tooltipFill: "#292929",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#3B3A39",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#FFFFFF",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Fluent2HighContrast":
            style = {
                tooltipFill: "#000000",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#3B3A39",
                textStyle: {
                    fontFamily: "Segoe UI",
                    color: "#FFFFFF",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Material3":
            style = {
                tooltipFill: "#313033",
                tooltipBoldLabel: "#F4EFF4",
                tooltipLightLabel: "#F4EFF4",
                tooltipHeaderLine: "#F4EFF4",
                textStyle: {
                    fontFamily: "Roboto",
                    color: "#F4EFF4",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        case "Material3Dark":
            style = {
                tooltipFill: "#E6E1E5",
                tooltipBoldLabel: "#313033",
                tooltipLightLabel: "#313033",
                tooltipHeaderLine: "#313033",
                textStyle: {
                    fontFamily: "Roboto",
                    color: "#313033",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
        default:
            style = {
                tooltipFill: theme === "Material" ? "#000816" : theme === "Fabric" ? "#FFFFFF" : "#212529",
                tooltipBoldLabel: theme === "Material" ? "rgba(249, 250, 251, 1)" : theme === "Fabric" ? "#333333" : "#F9FAFB",
                tooltipLightLabel: theme === "Material" ? "rgba(249, 250, 251, 1)" : theme === "Fabric" ? "#333333" : "#F9FAFB",
                tooltipHeaderLine: theme === "Fabric" ? "#D2D0CE" : "#ffffff",
                textStyle: theme === "Material" ? {
                    fontFamily: "Roboto",
                    color: "rgba(249, 250, 251, 1)",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                } : theme === "Fabric" ? {
                    fontFamily: "Segoe UI",
                    color: "#333333",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                } : {
                    fontFamily: "Helvetica",
                    color: "#F9FAFB",
                    fontWeight: null,
                    size: "12px",
                    headerTextSize: "12px",
                    boldTextSize: "12px"
                }
            };
            break;
    }
    return style;
}



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $5d5f50c62a40f4c7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5d5f50c62a40f4c7$export$866cc30a33805630(text, font, themeFontStyle, isHeader) {
    var breakText = text || ""; // For avoid NuLL value
    var htmlObject = document.getElementById("chartmeasuretext");
    if (htmlObject === null) {
        htmlObject = (0, $4ZDHT.createElement)("text", {
            id: "chartmeasuretext"
        });
        document.body.appendChild(htmlObject);
    }
    if (typeof text === "string" && (text.indexOf("<") > -1 || text.indexOf(">") > -1)) {
        var textArray = text.split(" ");
        for(var i = 0; i < textArray.length; i++)if (textArray[i].indexOf("<br/>") === -1) textArray[i] = textArray[i].replace(/[<>]/g, "&");
        text = textArray.join(" ");
    }
    htmlObject.innerHTML = breakText.indexOf("<br>") > -1 || breakText.indexOf("<br/>") > -1 ? breakText : text;
    htmlObject.style.position = "fixed";
    htmlObject.style.fontSize = font.size || (isHeader ? themeFontStyle.headerTextSize : themeFontStyle.size);
    htmlObject.style.fontStyle = font.fontStyle || themeFontStyle.fontStyle;
    htmlObject.style.fontFamily = font.fontFamily || themeFontStyle.fontFamily;
    htmlObject.style.visibility = "hidden";
    htmlObject.style.top = "-100";
    htmlObject.style.left = "0";
    htmlObject.style.whiteSpace = "nowrap";
    // For bootstrap line height issue
    htmlObject.style.lineHeight = "normal";
    var fontWidth = htmlObject.clientWidth;
    var fontHeight = htmlObject.clientHeight;
    var fontWeight = htmlObject.style.fontWeight;
    htmlObject.style.fontWeight = font.fontWeight || themeFontStyle.fontWeight;
    return new $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec(htmlObject.style.fontWeight === "bold" && fontWeight === "normal" ? Math.max(fontWidth, htmlObject.clientWidth) : htmlObject.clientWidth, htmlObject.style.fontWeight === "bold" && fontWeight === "normal" ? Math.max(fontHeight, htmlObject.clientHeight) : htmlObject.clientHeight);
}
function $5d5f50c62a40f4c7$export$36ff3fc94bf1d502(x, y, areaBounds, width, height) {
    if (width === void 0) width = 0;
    if (height === void 0) height = 0;
    return x >= areaBounds.x - width && x <= areaBounds.x + areaBounds.width + width && y >= areaBounds.y - height && y <= areaBounds.y + areaBounds.height + height;
}
function $5d5f50c62a40f4c7$export$d557588388ad8d6c(rX, rY, rect, arrowLocation, arrowPadding, top, bottom, left, tipX, tipY, controlName) {
    if (controlName === void 0) controlName = "";
    var direction = "";
    var startX = rect.x;
    var startY = rect.y;
    var width = rect.x + rect.width;
    var height = rect.y + rect.height;
    if (top) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY + " " + " L" + " " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + (startY + rY));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height);
        if (arrowPadding !== 0) {
            if (controlName === "RangeNavigator") {
                if (arrowLocation.x - arrowPadding > width / 2) {
                    direction = direction.concat(" L " + (arrowLocation.x + arrowPadding) + " " + height);
                    direction = direction.concat(" L " + (tipX + arrowPadding) + " " + (height + arrowPadding) + " L" + " " + arrowLocation.x + " " + height);
                } else {
                    direction = direction.concat(" L " + arrowLocation.x + " " + height);
                    direction = direction.concat(" L " + (tipX - arrowPadding) + " " + (height + arrowPadding) + " L" + " " + (arrowLocation.x - arrowPadding) + " " + height);
                }
            } else {
                direction = direction.concat(" L " + (arrowLocation.x + arrowPadding) + " " + height);
                direction = direction.concat(" L " + tipX + " " + (height + arrowPadding) + " L" + " " + (arrowLocation.x - arrowPadding) + " " + height);
            }
        }
        if (arrowLocation.x - arrowPadding > startX) direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
        else if (arrowPadding === 0) direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
        else direction = direction.concat(" L " + startX + " " + (height + rY) + " z");
    } else if (bottom) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY + " L" + " " + (arrowLocation.x - arrowPadding) + " " + startY);
        direction = direction.concat(" L " + tipX + " " + arrowLocation.y);
        direction = direction.concat(" L " + (arrowLocation.x + arrowPadding) + " " + startY);
        direction = direction.concat(" L " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + (startY + rY));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height + " L" + " " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
    } else if (left) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY);
        direction = direction.concat(" L " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + ((controlName === "RangeNavigator" ? 0 : startY + rY) + " L" + " " + width + " " + (controlName === "RangeNavigator" ? 0 : arrowLocation.y - arrowPadding)));
        direction = controlName === "RangeNavigator" ? direction.concat(" L " + (width + arrowPadding) + " " + 0) : direction.concat(" L " + (width + arrowPadding) + " " + tipY);
        direction = controlName === "RangeNavigator" ? direction.concat(" L " + width + " " + (arrowLocation.y - rY)) : direction.concat(" L " + width + " " + (arrowLocation.y + arrowPadding));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height);
        direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
    } else {
        direction = direction.concat("M " + (startX + rX) + " " + startY + " Q " + startX + " " + startY + " " + startX + " " + ((controlName === "RangeNavigator" ? 0 : startY + rY) + " L" + " " + startX + " " + (controlName === "RangeNavigator" ? 0 : arrowLocation.y - arrowPadding)));
        direction = controlName === "RangeNavigator" ? direction.concat(" L " + (startX - arrowPadding) + " " + 0) : direction.concat(" L " + (startX - arrowPadding) + " " + tipY);
        direction = controlName === "RangeNavigator" ? direction.concat(" L " + startX + " " + (arrowLocation.y - rY)) : direction.concat(" L " + startX + " " + (arrowLocation.y + arrowPadding));
        direction = direction.concat(" L " + startX + " " + (height - rY) + " Q " + startX + " " + height + " " + (startX + rX) + " " + height);
        direction = direction.concat(" L " + (width - rX) + " " + height + " Q " + width + " " + height + " " + width + " " + (height - rY) + " L" + " " + width + " " + (startY + rY) + " Q " + width + " " + startY + " " + (width - rX) + " " + startY + " z");
    }
    return direction;
}
/** @private */ var $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec = /** @class */ function() {
    function Size(width, height) {
        this.width = width;
        this.height = height;
    }
    return Size;
}();
/** @private */ var $5d5f50c62a40f4c7$export$c79fc6492f3af13d = /** @class */ function() {
    function Rect(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    return Rect;
}();
var $5d5f50c62a40f4c7$export$80a00690bda7f17e = /** @class */ function() {
    function Side(bottom, right) {
        this.isRight = right;
        this.isBottom = bottom;
    }
    return Side;
}();
/** @private */ var $5d5f50c62a40f4c7$export$dba1cb618530fbb4 = /** @class */ function() {
    function CustomizeOption(id) {
        this.id = id;
    }
    return CustomizeOption;
}();
/** @private */ var $5d5f50c62a40f4c7$export$4705393ca26c9086 = /** @class */ function(_super) {
    $5d5f50c62a40f4c7$var$__extends(TextOption, _super);
    function TextOption(id, x, y, anchor, text, transform, baseLine, labelRotation) {
        if (transform === void 0) transform = "";
        var _this = _super.call(this, id) || this;
        _this.transform = "";
        _this.baseLine = "auto";
        _this.labelRotation = 0;
        _this.x = x;
        _this.y = y;
        _this.anchor = anchor;
        _this.text = text;
        _this.transform = transform;
        _this.baseLine = baseLine;
        _this.labelRotation = labelRotation;
        return _this;
    }
    return TextOption;
}($5d5f50c62a40f4c7$export$dba1cb618530fbb4);
function $5d5f50c62a40f4c7$export$d16800b7e59a8051(id) {
    return document.getElementById(id);
}
function $5d5f50c62a40f4c7$export$f883456a56996078(id) {
    var element = $5d5f50c62a40f4c7$export$d16800b7e59a8051(id);
    if (element) (0, $4ZDHT.remove)(element);
}
function $5d5f50c62a40f4c7$export$49ec94bba13b5c07(location, shape, size, url, options, role, label) {
    var renderer = new (0, $aa3074f243277ee7$export$5ff52eac0871021a)("");
    var temp = $5d5f50c62a40f4c7$export$4dc1a8917bf18661(location, size, shape, options, url);
    var htmlObject = renderer["draw" + temp.functionName](temp.renderOption);
    htmlObject.setAttribute("role", role);
    htmlObject.setAttribute("aria-label", label);
    return htmlObject;
}
function $5d5f50c62a40f4c7$export$4dc1a8917bf18661(location, size, shape, options, url) {
    var path;
    var functionName = "Path";
    var width = size.width;
    var height = size.height;
    var locX = location.x;
    var locY = location.y;
    var x = location.x + -width / 2;
    var y = location.y + -height / 2;
    switch(shape){
        case "Circle":
        case "Bubble":
            functionName = "Ellipse";
            (0, $3EnZW.merge)(options, {
                "rx": width / 2,
                "ry": height / 2,
                "cx": locX,
                "cy": locY
            });
            break;
        case "Plus":
            path = "M " + x + " " + locY + " " + "L" + " " + (locX + width / 2) + " " + locY + " " + "M" + " " + locX + " " + (locY + height / 2) + " " + "L" + " " + locX + " " + (locY + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": path,
                stroke: options.fill
            });
            break;
        case "Cross":
            path = "M " + x + " " + (locY + -height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY + height / 2) + " " + "M" + " " + x + " " + (locY + height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": path,
                stroke: options.fill
            });
            break;
        case "HorizontalLine":
            path = "M " + x + " " + locY + " " + "L" + " " + (locX + width / 2) + " " + locY;
            (0, $3EnZW.merge)(options, {
                "d": path,
                stroke: options.fill
            });
            break;
        case "VerticalLine":
            path = "M " + locX + " " + (locY + height / 2) + " " + "L" + " " + locX + " " + (locY + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": path,
                stroke: options.fill
            });
            break;
        case "Diamond":
            path = "M " + x + " " + locY + " " + "L" + " " + locX + " " + (locY + -height / 2) + " " + "L" + " " + (locX + width / 2) + " " + locY + " " + "L" + " " + locX + " " + (locY + height / 2) + " " + "L" + " " + x + " " + locY + " z";
            (0, $3EnZW.merge)(options, {
                "d": path
            });
            break;
        case "Rectangle":
            path = "M " + x + " " + (locY + -height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY + -height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY + height / 2) + " " + "L" + " " + x + " " + (locY + height / 2) + " " + "L" + " " + x + " " + (locY + -height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": path
            });
            break;
        case "Triangle":
            path = "M " + x + " " + (locY + height / 2) + " " + "L" + " " + locX + " " + (locY + -height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY + height / 2) + " " + "L" + " " + x + " " + (locY + height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": path
            });
            break;
        case "InvertedTriangle":
            path = "M " + (locX + width / 2) + " " + (locY - height / 2) + " " + "L" + " " + locX + " " + (locY + height / 2) + " " + "L" + " " + (locX - width / 2) + " " + (locY - height / 2) + " " + "L" + " " + (locX + width / 2) + " " + (locY - height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": path
            });
            break;
        case "Pentagon":
            var eq = 72;
            var xValue = void 0;
            var yValue = void 0;
            for(var i = 0; i <= 5; i++){
                xValue = width / 2 * Math.cos(Math.PI / 180 * (i * eq));
                yValue = height / 2 * Math.sin(Math.PI / 180 * (i * eq));
                if (i === 0) path = "M " + (locX + xValue) + " " + (locY + yValue) + " ";
                else path = path.concat("L " + (locX + xValue) + " " + (locY + yValue) + " ");
            }
            path = path.concat("Z");
            (0, $3EnZW.merge)(options, {
                "d": path
            });
            break;
        case "Image":
            functionName = "Image";
            (0, $3EnZW.merge)(options, {
                "href": url,
                "height": height,
                "width": width,
                x: x,
                y: y
            });
            break;
        case "Star":
            var cornerPoints = 5;
            var outerRadius = Math.min(width, height) / 2;
            var innerRadius = outerRadius / 2;
            var angle = Math.PI / cornerPoints;
            var starPath = "";
            for(var i = 0; i < 2 * cornerPoints; i++){
                var radius = i % 2 === 0 ? outerRadius : innerRadius;
                var currentX = locX + radius * Math.cos(i * angle - Math.PI / 2);
                var currentY = locY + radius * Math.sin(i * angle - Math.PI / 2);
                starPath += (i === 0 ? "M" : "L") + currentX + "," + currentY;
            }
            starPath += "Z";
            (0, $3EnZW.merge)(options, {
                "d": starPath
            });
            break;
    }
    return {
        renderOption: options,
        functionName: functionName
    };
}
/** @private */ var $5d5f50c62a40f4c7$export$cd3012645815980 = /** @class */ function(_super) {
    $5d5f50c62a40f4c7$var$__extends(PathOption, _super);
    function PathOption(id, fill, width, color, opacity, dashArray, d) {
        var _this = _super.call(this, id) || this;
        _this.opacity = opacity;
        _this.fill = fill;
        _this.stroke = color;
        _this["stroke-width"] = width;
        _this["stroke-dasharray"] = dashArray;
        _this.d = d;
        return _this;
    }
    return PathOption;
}($5d5f50c62a40f4c7$export$dba1cb618530fbb4);
function $5d5f50c62a40f4c7$export$a06ce713d4aea371(options, font, color, parent, themeStyle) {
    var renderOptions = {};
    var renderer = new (0, $aa3074f243277ee7$export$5ff52eac0871021a)("");
    renderOptions = {
        "id": options.id,
        "x": options.x,
        "y": options.y,
        "fill": color,
        "font-size": font.size || themeStyle.size,
        "font-style": font.fontStyle || themeStyle.fontStyle,
        "font-family": font.fontFamily || themeStyle.fontFamily,
        "font-weight": font.fontWeight || themeStyle.fontWeight,
        "text-anchor": options.anchor,
        "transform": options.transform,
        "opacity": font.opacity,
        "dominant-baseline": options.baseLine
    };
    var text = typeof options.text === "string" ? options.text : options.text[0];
    var htmlObject = renderer.createText(renderOptions, text);
    if (parent) parent.appendChild(htmlObject);
    return htmlObject;
}
var $5d5f50c62a40f4c7$export$8b037c9273513f65 = /** @class */ function() {
    function TooltipLocation(x, y) {
        this.x = x;
        this.y = y;
    }
    return TooltipLocation;
}();


var $aeafe7e2f4093d9a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aeafe7e2f4093d9a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the fonts in charts.
 *
 * @private
 */ var $aeafe7e2f4093d9a$export$1df879243bf2e42d = /** @class */ function(_super) {
    $aeafe7e2f4093d9a$var$__extends(TextStyle, _super);
    function TextStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextStyle.prototype, "size", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TextStyle.prototype, "color", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("Segoe UI")
    ], TextStyle.prototype, "fontFamily", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], TextStyle.prototype, "fontWeight", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], TextStyle.prototype, "fontStyle", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], TextStyle.prototype, "opacity", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextStyle.prototype, "headerTextSize", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextStyle.prototype, "boldTextSize", void 0);
    return TextStyle;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the borders in the chart.
 *
 * @private
 */ var $aeafe7e2f4093d9a$export$42c6045406cd285 = /** @class */ function(_super) {
    $aeafe7e2f4093d9a$var$__extends(TooltipBorder, _super);
    function TooltipBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TooltipBorder.prototype, "color", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], TooltipBorder.prototype, "width", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TooltipBorder.prototype, "dashArray", void 0);
    return TooltipBorder;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the borders in the chart.
 *
 * @private
 */ var $aeafe7e2f4093d9a$export$39b461c45b98972a = /** @class */ function(_super) {
    $aeafe7e2f4093d9a$var$__extends(AreaBounds, _super);
    function AreaBounds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AreaBounds.prototype, "x", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AreaBounds.prototype, "y", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AreaBounds.prototype, "width", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AreaBounds.prototype, "height", void 0);
    return AreaBounds;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the borders in the chart.
 *
 * @private
 */ var $aeafe7e2f4093d9a$export$6df032dc53af18ad = /** @class */ function(_super) {
    $aeafe7e2f4093d9a$var$__extends(ToolLocation, _super);
    function ToolLocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ToolLocation.prototype, "x", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ToolLocation.prototype, "y", void 0);
    return ToolLocation;
}((0, $3fcxu.ChildProperty));
/**
 * Represents the Tooltip control.
 * ```html
 * <div id="tooltip"/>
 * <script>
 *   var tooltipObj = new Tooltip({ isResponsive : true });
 *   tooltipObj.appendTo("#tooltip");
 * </script>
 * ```
 *
 * @private
 */ var $aeafe7e2f4093d9a$export$28c660c63b792dea = /** @class */ function(_super) {
    $aeafe7e2f4093d9a$var$__extends(Tooltip, _super);
    /**
     * Constructor for creating the widget
     *
     * @hidden
     */ function Tooltip(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler.
     *
     * @private
     */ Tooltip.prototype.preRender = function() {
        this.allowServerDataBinding = false;
        this.initPrivateVariable();
        if (!this.isCanvas) this.removeSVG();
        this.createTooltipElement();
    };
    Tooltip.prototype.initPrivateVariable = function() {
        this.renderer = new (0, $aa3074f243277ee7$export$5ff52eac0871021a)(this.element.id);
        this.themeStyle = (0, $c68f2eb9b3b2178c$export$f3d7188648e27489)(this.theme);
        this.formattedText = [];
        this.padding = 5;
        this.highlightPadding = 3;
        this.areaMargin = 10;
        this.isFirst = true;
        this.markerPoint = [];
    };
    Tooltip.prototype.removeSVG = function() {
        var svgObject = document.getElementById(this.element.id + "_svg");
        var templateObject = document.getElementById(this.element.id + "parent_template");
        if (this.blazorTemplate) (0, $c2qqN.resetBlazorTemplate)(this.element.id + "parent_template" + "_blazorTemplate");
        if (svgObject && svgObject.parentNode) (0, $4ZDHT.remove)(svgObject);
        if (templateObject && templateObject.parentNode) (0, $4ZDHT.remove)(templateObject);
    };
    /**
     * To Initialize the control rendering.
     */ Tooltip.prototype.render = function() {
        this.fadeOuted = false;
        if (!this.template) {
            this.renderText(this.isFirst);
            var argsData = {
                cancel: false,
                name: "tooltipRender",
                tooltip: this
            };
            this.trigger("tooltipRender", argsData);
            var markerSide = this.renderTooltipElement(this.areaBounds, this.location);
            this.drawMarker(markerSide.isBottom, markerSide.isRight, this.markerSize);
        } else {
            this.updateTemplateFn();
            this.createTemplate(this.areaBounds, this.location);
        }
        this.trigger("loaded", {
            tooltip: this
        });
        var element = document.getElementById("chartmeasuretext");
        if (element) (0, $4ZDHT.remove)(element);
        this.allowServerDataBinding = true;
    };
    Tooltip.prototype.createTooltipElement = function() {
        this.textElements = [];
        if (!this.template || this.shared) {
            // SVG element for tooltip
            if (this.enableRTL) this.element.setAttribute("dir", "ltr");
            var svgObject = this.renderer.createSvg({
                id: this.element.id + "_svg"
            });
            this.element.appendChild(svgObject);
            // Group to hold text and path.
            var groupElement = document.getElementById(this.element.id + "_group");
            if (!groupElement) {
                groupElement = this.renderer.createGroup({
                    id: this.element.id + "_group"
                });
                groupElement.setAttribute("transform", "translate(0,0)");
            }
            svgObject.appendChild(groupElement);
            var pathElement = this.renderer.drawPath({
                "id": this.element.id + "_path",
                "stroke-width": (this.theme === "Fabric" || this.theme === "Fluent" || this.theme === "Fluent2" || this.theme === "Fluent2HighContrast") && !this.border.width ? 1 : this.border.width,
                "fill": this.fill || this.themeStyle.tooltipFill,
                "opacity": (this.theme === "TailwindDark" || this.theme === "Tailwind" || this.theme === "Bootstrap5" || this.theme === "Bootstrap5Dark" || this.theme.indexOf("Fluent2") > -1) && this.opacity === 0.75 ? 1 : this.opacity,
                "stroke": this.border.color || (this.theme === "Fabric" || this.theme === "Fluent" || this.theme === "Fluent2" ? "#D2D0CE" : this.border.color)
            });
            groupElement.appendChild(pathElement);
        }
    };
    Tooltip.prototype.drawMarker = function(isBottom, isRight, size) {
        if (this.shapes.length <= 0) return null;
        var shapeOption;
        var count = 0;
        var markerGroup = this.renderer.createGroup({
            id: this.element.id + "_trackball_group"
        });
        var groupElement = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_group");
        if (!groupElement) return null;
        var x = (this.enableRTL ? this.elementSize.width - size / 2 : this.marginX * 2 + size / 2) + (isRight ? this.arrowPadding : 0);
        for(var _i = 0, _a = this.shapes; _i < _a.length; _i++){
            var shape = _a[_i];
            if (shape !== "None") {
                shapeOption = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(this.element.id + "_Trackball_" + count, this.palette[count], 1, "#cccccc", 1, null);
                if (this.markerPoint[count]) {
                    var padding = 0;
                    if (this.header.indexOf("<br") > -1) padding = this.header.split(/<br.*?>/g).length + count;
                    var tooltipContent = this.formattedText && this.formattedText.length >= 2 ? this.getTooltipTextContent(this.formattedText[1]) + ", " + this.getTooltipTextContent(this.formattedText[0]) : "";
                    markerGroup.appendChild((0, $5d5f50c62a40f4c7$export$49ec94bba13b5c07)(new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(x, this.markerPoint[count] - this.padding + (isBottom ? this.arrowPadding : padding)), shape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(size, size), "", shapeOption, "img", tooltipContent));
                }
                count++;
            }
        }
        groupElement.appendChild(markerGroup);
    };
    Tooltip.prototype.renderTooltipElement = function(areaBounds, location) {
        var tooltipDiv = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id);
        var arrowLocation = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0);
        var tipLocation = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0);
        var svgObject = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_svg");
        var groupElement = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_group");
        var pathElement = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_path");
        var rect;
        var isTop = false;
        var isLeft = false;
        var isBottom = false;
        var x = 0;
        var y = 0;
        if (!(0, $3EnZW.isNullOrUndefined)(groupElement)) {
            if (this.header !== "") this.elementSize.height += this.marginY;
            if (this.isFixed) {
                var width = this.elementSize.width + 2 * this.marginX;
                var height = this.elementSize.height + 2 * this.marginY;
                rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(location.x, location.y, width, height);
            } else if (this.content.length > 1) {
                rect = this.sharedTooltipLocation(areaBounds, this.location.x, this.location.y);
                isTop = true;
            } else {
                rect = this.tooltipLocation(areaBounds, location, arrowLocation, tipLocation);
                if (!this.inverted) {
                    isTop = rect.y < location.y + this.clipBounds.y;
                    isBottom = !isTop;
                    y = isTop ? 0 : this.arrowPadding;
                } else {
                    isLeft = rect.x < location.x + this.clipBounds.x;
                    x = isLeft ? 0 : this.arrowPadding;
                    if (this.allowHighlight) rect.x += isLeft ? this.highlightPadding : -(2 * this.highlightPadding);
                }
            }
            if (this.header !== "") {
                var wrapPadding = 2;
                var padding = 0;
                var wrapHeader = this.isWrap ? this.wrappedText : this.header;
                if (this.isWrap && typeof wrapHeader === "string" && (wrapHeader.indexOf("<") > -1 || wrapHeader.indexOf(">") > -1)) {
                    var textArray = wrapHeader.split("<br>");
                    wrapPadding = textArray.length;
                }
                if (this.header.indexOf("<br") > -1) padding = 5 * (this.header.split(/<br.*?>/g).length - 1);
                var key = "properties";
                var font = (0, $3EnZW.extend)({}, this.textStyle, null, true)[key];
                var headerSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.isWrap ? this.wrappedText : this.header, font, this.themeStyle.textStyle).height + this.marginY * wrapPadding + (isBottom ? this.arrowPadding : 0) + (this.isWrap ? 5 : padding); //header padding;
                var xLength = this.marginX * 3 + (!isLeft && !isTop && !isBottom ? this.arrowPadding : 0);
                var direction = "M " + xLength + " " + headerSize + "L " + (rect.width + (!isLeft && !isTop && !isBottom ? this.arrowPadding : 0) - this.marginX * 2) + " " + headerSize;
                var pathElement_1 = this.renderer.drawPath({
                    "id": this.element.id + "_header_path",
                    "stroke-width": 1,
                    "fill": null,
                    "opacity": this.theme === "Material3" || this.theme === "Material3Dark" ? 0.2 : 0.8,
                    "stroke": this.themeStyle.tooltipHeaderLine,
                    "d": direction
                });
                groupElement.appendChild(pathElement_1);
            }
            var start = this.border.width / 2;
            var pointRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(start + x, start + y, rect.width - start, rect.height - start);
            groupElement.setAttribute("opacity", "1");
            if (this.enableAnimation && !this.isFirst && !this.crosshair) this.animateTooltipDiv(tooltipDiv, rect);
            else this.updateDiv(tooltipDiv, rect.x, rect.y);
            // eslint-disable-next-line no-extra-boolean-cast
            svgObject.setAttribute("height", (rect.height + this.border.width + (!!this.inverted ? 0 : this.arrowPadding) + 5).toString());
            svgObject.setAttribute("width", (rect.width + this.border.width + (!this.inverted ? 0 : this.arrowPadding) + 5).toString());
            svgObject.setAttribute("opacity", "1");
            if (!(0, $3EnZW.isNullOrUndefined)(this.tooltipPlacement)) {
                isTop = this.tooltipPlacement.indexOf("Top") > -1;
                isBottom = this.tooltipPlacement.indexOf("Bottom") > -1;
                isLeft = this.tooltipPlacement.indexOf("Left") > -1;
            }
            pathElement.setAttribute("d", (0, $5d5f50c62a40f4c7$export$d557588388ad8d6c)(this.rx, this.ry, pointRect, arrowLocation, this.arrowPadding, isTop, isBottom, isLeft, tipLocation.x, tipLocation.y, this.controlName));
            if (this.enableShadow && this.theme !== "Bootstrap4" || this.theme.indexOf("Fluent2") > -1) {
                // To fix next chart initial tooltip opacity issue in tab control
                var shadowId = this.element.id + "_shadow";
                if (this.theme === "Tailwind" || this.theme === "TailwindDark" || this.theme === "Bootstrap5" || this.theme === "Bootstrap5Dark") pathElement.setAttribute("box-shadow", "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)");
                else pathElement.setAttribute("filter", (0, $5q7BP.Browser).isIE ? "" : "url(#" + shadowId + ")");
                var shadow = '<filter id="' + shadowId + '" height="130%"><feGaussianBlur in="SourceAlpha" stdDeviation="3"/>';
                if (this.theme.indexOf("Fluent2") > -1) shadow += '<feOffset dx="-1" dy="3.6" result="offsetblur"/><feComponentTransfer><feFuncA type="linear" slope="0.2"/>';
                else shadow += '<feOffset dx="3" dy="3" result="offsetblur"/><feComponentTransfer><feFuncA type="linear" slope="0.5"/>';
                shadow += '</feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter>';
                var defElement = this.renderer.createDefs();
                defElement.setAttribute("id", this.element.id + "SVG_tooltip_definition");
                groupElement.appendChild(defElement);
                defElement.innerHTML = shadow;
            }
            var borderColor = (this.theme === "Fabric" || this.theme === "Fluent" || this.theme === "Fluent2") && !this.border.color ? "#D2D0CE" : this.theme === "Fluent2HighContrast" ? "#FFFFFF" : this.border.color;
            pathElement.setAttribute("stroke", borderColor);
            if (!(0, $3EnZW.isNullOrUndefined)(this.border.dashArray)) pathElement.setAttribute("stroke-dasharray", this.border.dashArray);
            this.changeText(new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(x, y), isBottom, !isLeft && !isTop && !isBottom);
            if (this.revert) {
                this.inverted = !this.inverted;
                this.revert = false;
            }
        }
        return new (0, $5d5f50c62a40f4c7$export$80a00690bda7f17e)(isBottom, !isLeft && !isTop && !isBottom);
    };
    Tooltip.prototype.changeText = function(point, isBottom, isRight) {
        var element = document.getElementById(this.element.id + "_text");
        if (isBottom) element.setAttribute("transform", "translate(0," + this.arrowPadding + ")");
        if (isRight) element.setAttribute("transform", "translate(" + this.arrowPadding + " 0)");
    };
    Tooltip.prototype.findFormattedText = function() {
        this.formattedText = [];
        if (this.header.replace(/<b>/g, "").replace(/<\/b>/g, "").trim() !== "") this.formattedText = this.formattedText.concat(this.header);
        this.formattedText = this.formattedText.concat(this.content);
    };
    // tslint:disable-next-line:max-func-body-length
    Tooltip.prototype.renderText = function(isRender) {
        var height = 0;
        var width = 0; // Padding for text;
        var subWidth = 0;
        var lines;
        var key = "properties";
        var font = (0, $3EnZW.extend)({}, this.textStyle, null, true)[key];
        var groupElement = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_group");
        var tspanElement;
        var textCollection;
        var tspanStyle = "";
        var line;
        var tspanOption;
        this.findFormattedText();
        this.isWrap = false;
        var isRtlEnabled = document.body.getAttribute("dir") === "rtl";
        var anchor = isRtlEnabled && !this.enableRTL ? "end" : "start";
        this.leftSpace = this.areaBounds.x + this.location.x;
        this.rightSpace = this.areaBounds.x + this.areaBounds.width - this.leftSpace;
        var headerContent = this.header.replace(/<b>/g, "").replace(/<\/b>/g, "").trim();
        var isBoldTag = this.header.indexOf("<b>") > -1 && this.header.indexOf("</b>") > -1;
        var headerWidth = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.formattedText[0], font, this.themeStyle.textStyle).width + 2 * this.marginX + this.arrowPadding;
        var isLeftSpace = this.location.x - headerWidth < this.location.x;
        var isRightSpace = this.areaBounds.x + this.areaBounds.width < this.location.x + headerWidth;
        var header;
        var headerSpace = headerContent !== "" ? this.marginY : 0;
        var isRow = true;
        var isColumn = true;
        this.markerPoint = [];
        var markerSize = this.shapes.length > 0 ? 10 : 0;
        var markerPadding = this.shapes.length > 0 ? 5 : 0;
        var spaceWidth = 4;
        var subStringLength;
        var fontSize = "12px";
        var fontWeight = "400";
        var labelColor = this.themeStyle.tooltipLightLabel;
        var dy = 22 / parseFloat(fontSize) * parseFloat(font.size || this.themeStyle.textStyle.size);
        var contentWidth = [];
        var textHeight = 0;
        if (!isRender || this.isCanvas) {
            (0, $5d5f50c62a40f4c7$export$f883456a56996078)(this.element.id + "_text");
            (0, $5d5f50c62a40f4c7$export$f883456a56996078)(this.element.id + "_header_path");
            (0, $5d5f50c62a40f4c7$export$f883456a56996078)(this.element.id + "_trackball_group");
            (0, $5d5f50c62a40f4c7$export$f883456a56996078)(this.element.id + "SVG_tooltip_definition");
        }
        // Condition to resolve the text size issue only in chart.
        if (this.controlName === "Chart" && parseFloat(fontSize) < parseFloat(font.size || this.themeStyle.textStyle.headerTextSize)) textHeight = parseFloat(font.size || this.themeStyle.textStyle.size) - parseFloat(fontSize);
        var options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(this.element.id + "_text", this.marginX * 2, textHeight + this.marginY * 2 + this.padding * 2 + (this.marginY === 2 ? this.controlName === "RangeNavigator" ? 5 : 3 : 0), anchor, "");
        var parentElement = (0, $5d5f50c62a40f4c7$export$a06ce713d4aea371)(options, font, font.color || this.themeStyle.tooltipBoldLabel, groupElement, this.themeStyle.textStyle);
        var withoutHeader = this.formattedText.length === 1 && this.formattedText[0].indexOf(" : <b>") > -1;
        var isHeader = this.header !== "";
        var size = isHeader && isBoldTag ? 16 : 13;
        for(var k = 0, pointsLength = this.formattedText.length; k < pointsLength; k++){
            textCollection = this.formattedText[k].replace(/<(b|strong)>/g, "<b>").replace(/<\/(b|strong)>/g, "</b>").split(/<br.*?>/g);
            if (this.isTextWrap && this.header !== this.formattedText[k] && this.formattedText[k].indexOf("<br") === -1) {
                subStringLength = Math.round(this.leftSpace > this.rightSpace ? this.leftSpace / size : this.rightSpace / size);
                textCollection = this.formattedText[k].match(new RegExp(".{1," + subStringLength + "}", "g"));
            }
            if (k === 0 && !withoutHeader && this.isTextWrap && (this.leftSpace < headerWidth || isLeftSpace) && (this.rightSpace < headerWidth || isRightSpace)) {
                subStringLength = Math.round(this.leftSpace > this.rightSpace ? this.leftSpace / size : this.rightSpace / size);
                header = headerContent !== "" ? headerContent : this.formattedText[k];
                textCollection = header.match(new RegExp(".{1," + subStringLength + "}", "g"));
                this.wrappedText = isBoldTag ? "<b>" + textCollection.join("<br>") + "</b>" : textCollection.join("<br>");
                this.isWrap = textCollection.length > 1;
            }
            if (textCollection[0] === "") continue;
            if (k !== 0 || headerContent === "") this.markerPoint.push((headerContent !== "" ? this.marginY : 0) + options.y + height - (textHeight !== 0 ? textHeight / this.markerSize * (parseFloat(font.size || this.themeStyle.textStyle.headerTextSize) / this.markerSize) : 0));
            for(var i = 0, len = textCollection.length; i < len; i++){
                lines = textCollection[i].replace(/<b>/g, "<br><b>").replace(/<\/b>/g, "</b><br>").replace(/:/g, this.enableRTL ? "<br>\u200E: <br>" : "<br>\u200E:<br>").split("<br>");
                if (this.enableRTL && lines.length > 0 && textCollection[i].match(/:/g)) {
                    lines[0] = lines[0].trim();
                    lines.reverse();
                }
                subWidth = 0;
                isColumn = true;
                height += dy;
                for(var j = 0, len_1 = lines.length; j < len_1; j++){
                    line = lines[j];
                    if (this.enableRTL && line !== "" && this.isRTLText(line)) line = line.concat("\u200E");
                    if (!/\S/.test(line) && line !== "") line = " "; //to trim multiple white spaces to single white space
                    if (!isColumn && line === " " || line.replace(/<b>/g, "").replace(/<\/b>/g, "").trim() !== "") {
                        subWidth += line !== " " ? spaceWidth : 0;
                        if (isColumn && !isRow) {
                            if (this.header.indexOf("<br") > -1 && k !== 0) headerSpace += this.header.split(/<br.*?>/g).length;
                            tspanOption = {
                                x: this.marginX * 2 + (markerSize + markerPadding),
                                dy: dy + (isColumn ? headerSpace : 0),
                                fill: ""
                            };
                            headerSpace = null;
                        } else if (isRow && isColumn) tspanOption = {
                            x: headerContent === "" ? this.marginX * 2 + (markerSize + markerPadding) : this.marginX * 2 + (this.isWrap ? markerSize + markerPadding : 0)
                        };
                        else tspanOption = {};
                        isColumn = false;
                        tspanElement = this.renderer.createTSpan(tspanOption, "");
                        parentElement.appendChild(tspanElement);
                        if (line.indexOf("<b>") > -1 || isBoldTag && j === 0 && k === 0 && (isHeader || this.isWrap)) {
                            fontWeight = "600";
                            labelColor = this.themeStyle.tooltipBoldLabel;
                            tspanStyle = "font-weight:" + fontWeight;
                            font.fontWeight = fontWeight;
                            tspanElement.setAttribute("fill", this.textStyle.color || labelColor);
                        } else {
                            tspanStyle = fontWeight === "600" ? "font-weight:" + fontWeight : "";
                            font.fontWeight = fontWeight;
                            tspanElement.setAttribute("fill", this.textStyle.color || labelColor);
                        }
                        if (line.indexOf("</b>") > -1 || isBoldTag && j === len_1 - 1 && k === 0 && (isHeader || this.isWrap)) {
                            fontWeight = "Normal";
                            labelColor = this.themeStyle.tooltipLightLabel;
                        }
                        // eslint-disable-next-line no-useless-escape
                        if (tspanStyle !== "") {
                            tspanElement.style.fontWeight = tspanStyle.split("font-weight:")[1];
                            tspanElement.style.color = tspanElement.getAttribute("fill");
                        }
                        // 'inherit' will apply css style from parent element.
                        tspanElement.style.fontFamily = "inherit";
                        tspanElement.style.fontStyle = "inherit";
                        tspanElement.style.fontSize = this.header === this.formattedText[k] ? font.size || this.themeStyle.textStyle.headerTextSize : line.indexOf("<b>") > -1 || line.indexOf("</b>") > -1 ? font.size || this.themeStyle.textStyle.boldTextSize : font.size || this.themeStyle.textStyle.size;
                        tspanElement.style.fontWeight = this.header === this.formattedText[k] && (this.header.indexOf("<b>") || this.header.indexOf("</b>")) === -1 ? this.textStyle.fontWeight || "600" : line.indexOf("<b>") > -1 || line.indexOf("</b>") > -1 ? this.theme.indexOf("Bootstrap5") > -1 ? this.textStyle.fontWeight || "600" : "bold" : (line.indexOf("<b>") === -1 || line.indexOf("</b>") === -1) && this.theme.indexOf("Bootstrap5") > -1 ? this.textStyle.fontWeight || "600" : this.textStyle.fontWeight || font.fontWeight;
                        var textFont = (0, $3EnZW.extend)({}, this.textStyle, null, true)[key];
                        textFont.fontWeight = tspanElement.style.fontWeight;
                        textFont.size = tspanElement.style.fontSize;
                        isRow = false;
                        tspanElement.textContent = line = this.getTooltipTextContent(line);
                        subWidth += (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(line, textFont, this.themeStyle.textStyle).width;
                    }
                }
                subWidth -= spaceWidth;
                width = Math.max(width, subWidth);
                contentWidth.push(subWidth);
            }
        }
        this.elementSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(width + (width > 0 ? 2 * this.marginX : 0), height);
        this.elementSize.width += markerSize + markerPadding; // marker size + marker Spacing
        var element = parentElement.childNodes[0];
        if (headerContent !== "" && element && !this.isWrap) {
            font.fontWeight = "600";
            var width_1 = (this.elementSize.width + 2 * this.padding) / 2 - (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(headerContent, font, this.themeStyle.textStyle, true).width / 2;
            element.setAttribute("x", width_1.toString());
        }
        this.renderContentRTL(parentElement, isHeader, markerSize + markerPadding, contentWidth);
    };
    Tooltip.prototype.renderContentRTL = function(textElement, isHeader, markerSize, contentWidth) {
        if (this.enableRTL) {
            var tspanElement = void 0;
            var contentWidthIndex = isHeader ? 1 : 0;
            for(var i = 0; i < textElement.childNodes.length; i++){
                tspanElement = textElement.childNodes[i];
                if ((!isHeader || i > 0) && !(0, $3EnZW.isNullOrUndefined)(tspanElement.getAttribute("x"))) {
                    tspanElement.setAttribute("x", (this.elementSize.width - (markerSize + contentWidth[contentWidthIndex])).toString());
                    contentWidthIndex++;
                }
            }
        }
    };
    Tooltip.prototype.getTooltipTextContent = function(tooltipText) {
        var characterCollection = tooltipText.match(/<[a-zA-Z\/](.|\n)*?>/g);
        if ((0, $3EnZW.isNullOrUndefined)(characterCollection)) return tooltipText;
        var isRtlText = this.isRTLText(tooltipText);
        for(var i = 0; i < characterCollection.length; i++)if (this.isValidHTMLElement(characterCollection[i].replace("<", "").replace("/", "").replace(">", "").trim())) tooltipText = tooltipText.replace(characterCollection[i], isRtlText ? "\u200E" : "");
        return tooltipText;
    };
    Tooltip.prototype.isValidHTMLElement = function(element) {
        return document.createElement(element).toString() !== "[object HTMLUnknownElement]";
    };
    Tooltip.prototype.isRTLText = function(tooltipContent) {
        return /[\u0590-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(tooltipContent);
    };
    Tooltip.prototype.createTemplate = function(areaBounds, location) {
        var argsData = {
            cancel: false,
            name: "tooltipRender",
            tooltip: this
        };
        this.trigger("tooltipRender", argsData);
        var parent = document.getElementById(this.element.id);
        if (this.isCanvas) this.removeSVG();
        var firstElement = parent.firstElementChild;
        if (firstElement) (0, $4ZDHT.remove)(firstElement);
        if (!argsData.cancel) {
            var elem = (0, $4ZDHT.createElement)("div", {
                id: this.element.id + "parent_template"
            });
            var templateElement = void 0;
            if (this.controlName === "Chart" && this.shared) for(var i = 0; i < this.data.length; i++){
                var sharedTemplateElement = this.templateFn(this.data[i], this.controlInstance, elem.id, elem.id + "_blazorTemplate", "");
                if (i === 0) templateElement = sharedTemplateElement;
                else if (sharedTemplateElement.length > 1) templateElement[i].outerHTML = sharedTemplateElement[i].outerHTML || sharedTemplateElement[i].textContent;
                else templateElement[templateElement.length - 1].outerHTML += sharedTemplateElement[0].outerHTML;
            }
            else templateElement = this.templateFn(this.data, this.controlInstance, elem.id, elem.id + "_blazorTemplate", "");
            while(templateElement && templateElement.length > 0)if ((0, $3EnZW.isBlazor)() || templateElement.length === 1) {
                elem.appendChild(templateElement[0]);
                templateElement = null;
            } else elem.appendChild(templateElement[0]);
            parent.appendChild(elem);
            var element = this.isCanvas ? elem : this.element;
            var rect = element.getBoundingClientRect();
            this.padding = 0;
            this.elementSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(rect.width, rect.height);
            var tooltipRect = this.shared ? this.sharedTooltipLocation(areaBounds, this.location.x, this.location.y) : this.tooltipLocation(areaBounds, location, new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0), new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0));
            if (this.enableAnimation && !this.isFirst && !this.crosshair) this.animateTooltipDiv(this.element, tooltipRect);
            else this.updateDiv(element, tooltipRect.x, tooltipRect.y);
            if (this.blazorTemplate) {
                //Customer issue - F149037  Call back function to handle the blazor tooltip alignment issues
                var tooltipRendered = function() {
                    var rect1 = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(thisObject_1.element.id).getBoundingClientRect();
                    thisObject_1.elementSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(rect1.width, rect1.height);
                    var tooltipRect1 = thisObject_1.tooltipLocation(areaBounds, location, new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0), new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(0, 0));
                    thisObject_1.updateDiv((0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(thisObject_1.element.id), tooltipRect1.x, tooltipRect1.y);
                };
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var thisObject_1 = this;
                tooltipRendered.bind(thisObject_1, areaBounds, location);
                (0, $c2qqN.updateBlazorTemplate)(this.element.id + "parent_template" + "_blazorTemplate", this.blazorTemplate.name, this.blazorTemplate.parent, undefined, tooltipRendered);
            }
        } else (0, $4ZDHT.remove)((0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_tooltip"));
    };
    Tooltip.prototype.sharedTooltipLocation = function(bounds, x, y) {
        var width = this.elementSize.width + 2 * this.marginX;
        var height = this.elementSize.height + 2 * this.marginY;
        var tooltipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x + 2 * this.padding, y - height - this.padding, width, height);
        if (tooltipRect.y < bounds.y) tooltipRect.y += tooltipRect.height + 2 * this.padding;
        if (tooltipRect.y + tooltipRect.height > bounds.y + bounds.height) tooltipRect.y = Math.max(bounds.y + bounds.height - (tooltipRect.height + 2 * this.padding), bounds.y);
        if (tooltipRect.x + tooltipRect.width > bounds.x + bounds.width) tooltipRect.x = bounds.x + this.location.x - (tooltipRect.width + 4 * this.padding);
        if (tooltipRect.x < bounds.x) tooltipRect.x = bounds.x;
        return tooltipRect;
    };
    /** @private */ Tooltip.prototype.getCurrentPosition = function(bounds, symbolLocation, arrowLocation, tipLocation) {
        var position = this.tooltipPlacement;
        var clipX = this.clipBounds.x;
        var clipY = this.clipBounds.y;
        var markerHeight = this.offset;
        var width = this.elementSize.width + 2 * this.marginX;
        var height = this.elementSize.height + 2 * this.marginY;
        var location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(symbolLocation.x, symbolLocation.y);
        if (position === "Top" || position === "Bottom") {
            location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(location.x + clipX - this.elementSize.width / 2 - this.padding, location.y + clipY - this.elementSize.height - 2 * this.padding - this.arrowPadding - markerHeight);
            arrowLocation.x = tipLocation.x = width / 2;
            if (position === "Bottom") location.y = symbolLocation.y + clipY + markerHeight;
            if (bounds.x + bounds.width < location.x + width) {
                location.x = bounds.width > width ? bounds.x + bounds.width - width + 6 : bounds.x;
                arrowLocation.x = tipLocation.x = bounds.width > width ? bounds.x + symbolLocation.x - location.x : symbolLocation.x;
            } else if (bounds.x > location.x) {
                location.x = bounds.x;
                arrowLocation.x = tipLocation.x = symbolLocation.x;
            }
        } else {
            location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(location.x + clipX + markerHeight, location.y + clipY - this.elementSize.height / 2 - this.padding);
            arrowLocation.y = tipLocation.y = height / 2;
            if (position === "Left") location.x = symbolLocation.x + clipX - markerHeight - (width + this.arrowPadding);
            if (bounds.y + bounds.height < location.y + height) {
                location.y = bounds.height > height ? bounds.y + bounds.height - height + 6 : bounds.y;
                arrowLocation.y = tipLocation.y = bounds.height > height ? bounds.y + symbolLocation.y - location.y : symbolLocation.y;
            } else if (bounds.y > location.y) {
                location.y = bounds.y;
                arrowLocation.y = tipLocation.y = symbolLocation.y;
            }
        }
        return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(location.x, location.y, width, height);
    };
    // tslint:disable-next-line:max-func-body-length
    /** @private */ Tooltip.prototype.tooltipLocation = function(bounds, symbolLocation, arrowLocation, tipLocation) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.tooltipPlacement)) {
            var tooltipRect = this.getCurrentPosition(bounds, symbolLocation, arrowLocation, tipLocation);
            return tooltipRect;
        }
        var location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(symbolLocation.x, symbolLocation.y);
        var width = this.elementSize.width + 2 * this.marginX;
        var height = this.elementSize.height + 2 * this.marginY;
        var markerHeight = this.offset;
        var clipX = this.clipBounds.x;
        var clipY = this.clipBounds.y;
        var boundsX = bounds.x;
        var boundsY = bounds.y;
        this.outOfBounds = false;
        if (!this.inverted) {
            location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(location.x + clipX - this.elementSize.width / 2 - this.padding, location.y + clipY - this.elementSize.height - 2 * (this.allowHighlight ? this.highlightPadding : this.padding) - this.arrowPadding - markerHeight);
            arrowLocation.x = tipLocation.x = width / 2;
            if ((location.y < boundsY || this.isNegative) && !(this.controlName === "Progressbar")) location.y = (symbolLocation.y < 0 ? 0 : symbolLocation.y) + clipY + markerHeight;
            if (location.y + height + this.arrowPadding > boundsY + bounds.height) location.y = Math.min(symbolLocation.y, boundsY + bounds.height) + clipY - this.elementSize.height - 2 * this.padding - this.arrowPadding - markerHeight;
            if ((location.x + width > boundsX + bounds.width && location.y < boundsY || this.isNegative) && !(this.controlName === "Progressbar")) location.y = (symbolLocation.y < 0 ? 0 : symbolLocation.y) + clipY + markerHeight;
            tipLocation.x = width / 2;
            if (location.x < boundsX && !(this.controlName === "Progressbar")) {
                arrowLocation.x -= boundsX - location.x;
                tipLocation.x -= boundsX - location.x;
                location.x = boundsX;
            }
            if (location.x + width > boundsX + bounds.width && !(this.controlName === "Progressbar")) {
                arrowLocation.x += location.x + width - (boundsX + bounds.width);
                tipLocation.x += location.x + width - (boundsX + bounds.width);
                location.x -= location.x + width - (boundsX + bounds.width);
            }
            if (location.x < boundsX && !(this.controlName === "Progressbar")) {
                arrowLocation.x -= boundsX - location.x;
                tipLocation.x -= boundsX - location.x;
                location.x = boundsX;
            }
            if (arrowLocation.x + this.arrowPadding > width - this.rx) {
                arrowLocation.x = width - this.rx - this.arrowPadding;
                tipLocation.x = width - this.rx - this.arrowPadding;
            }
            if (arrowLocation.x - this.arrowPadding < this.rx) arrowLocation.x = tipLocation.x = this.rx + this.arrowPadding;
            if (this.controlName === "Chart") {
                if (bounds.x + bounds.width - (location.x + arrowLocation.x) < this.areaMargin + this.arrowPadding || location.x + arrowLocation.x < this.areaMargin + this.arrowPadding) this.outOfBounds = true;
                if (this.template && location.y < 0) location.y = symbolLocation.y + clipY + markerHeight;
                if (!(0, $5d5f50c62a40f4c7$export$36ff3fc94bf1d502)(location.x, location.y, bounds) || this.outOfBounds) {
                    this.inverted = !this.inverted;
                    this.revert = true;
                    location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(symbolLocation.x + markerHeight + clipX, symbolLocation.y + clipY - this.elementSize.height / 2 - this.padding);
                    tipLocation.x = arrowLocation.x = 0;
                    tipLocation.y = arrowLocation.y = height / 2;
                    if (location.x + this.arrowPadding + width > boundsX + bounds.width || this.isNegative) location.x = (symbolLocation.x > boundsX + bounds.width ? bounds.width : symbolLocation.x) + clipX - markerHeight - (this.arrowPadding + width);
                    if (location.x < boundsX) location.x = (symbolLocation.x < 0 ? 0 : symbolLocation.x) + markerHeight + clipX;
                    if (location.y <= boundsY) {
                        tipLocation.y -= boundsY - location.y;
                        arrowLocation.y -= boundsY - location.y;
                        location.y = boundsY;
                    }
                    if (location.y + height >= bounds.height + boundsY) {
                        arrowLocation.y += location.y + height - (bounds.height + boundsY);
                        tipLocation.y += location.y + height - (bounds.height + boundsY);
                        location.y -= location.y + height - (bounds.height + boundsY);
                    }
                    if (this.arrowPadding + arrowLocation.y > height - this.ry) {
                        arrowLocation.y = height - this.arrowPadding - this.ry;
                        tipLocation.y = height;
                    }
                    if (arrowLocation.y - this.arrowPadding < this.ry) {
                        arrowLocation.y = this.arrowPadding + this.ry;
                        tipLocation.y = 0;
                    }
                }
            }
        } else {
            location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(location.x + clipX + markerHeight, location.y + clipY - this.elementSize.height / 2 - this.padding);
            arrowLocation.y = tipLocation.y = height / 2;
            if (location.x + width + this.arrowPadding > boundsX + bounds.width || this.isNegative) location.x = (symbolLocation.x > bounds.width + bounds.x ? bounds.width : symbolLocation.x) + clipX - markerHeight - (width + this.arrowPadding);
            if (location.x < boundsX) location.x = (symbolLocation.x < 0 ? 0 : symbolLocation.x) + clipX + markerHeight;
            if (location.x + width + this.arrowPadding > boundsX + bounds.width) location.x = (symbolLocation.x > bounds.width + bounds.x ? bounds.width : symbolLocation.x) + clipX - markerHeight - (width + this.arrowPadding);
            if (location.y <= boundsY) {
                arrowLocation.y -= boundsY - location.y;
                tipLocation.y -= boundsY - location.y;
                location.y = boundsY;
            }
            if (location.y + height >= boundsY + bounds.height) {
                arrowLocation.y += location.y + height - (boundsY + bounds.height);
                tipLocation.y += location.y + height - (boundsY + bounds.height);
                location.y -= location.y + height - (boundsY + bounds.height);
            }
            if (arrowLocation.y + this.arrowPadding > height - this.ry) {
                arrowLocation.y = height - this.ry - this.arrowPadding;
                tipLocation.y = height;
            }
            if (arrowLocation.y - this.arrowPadding < this.ry) arrowLocation.y = tipLocation.y = this.ry + this.arrowPadding;
            if (this.controlName === "Chart") {
                if (location.y + arrowLocation.y < this.areaMargin + this.arrowPadding || bounds.y + bounds.height - (location.y + arrowLocation.y) < this.areaMargin + this.arrowPadding) this.outOfBounds = true;
                if (!(0, $5d5f50c62a40f4c7$export$36ff3fc94bf1d502)(location.x, location.y, bounds) || this.outOfBounds) {
                    this.inverted = !this.inverted;
                    location = new (0, $5d5f50c62a40f4c7$export$8b037c9273513f65)(symbolLocation.x + clipX - this.padding - this.elementSize.width / 2, symbolLocation.y + clipY - this.elementSize.height - 2 * this.padding - markerHeight - this.arrowPadding);
                    this.revert = true;
                    tipLocation.x = arrowLocation.x = width / 2;
                    tipLocation.y = arrowLocation.y = 0;
                    if (location.y < boundsY || this.isNegative) location.y = (symbolLocation.y < 0 ? 0 : symbolLocation.y) + markerHeight + clipY;
                    if (location.y + this.arrowPadding + height > boundsY + bounds.height) location.y = Math.min(symbolLocation.y, boundsY + bounds.height) + clipY - this.elementSize.height - 2 * this.padding - markerHeight - this.arrowPadding;
                    tipLocation.x = width / 2;
                    if (location.x < boundsX) {
                        tipLocation.x -= boundsX - location.x;
                        arrowLocation.x -= boundsX - location.x;
                        location.x = boundsX;
                    }
                    if (location.x + width > bounds.width + boundsX) {
                        arrowLocation.x += location.x + width - (bounds.width + boundsX);
                        tipLocation.x += location.x + width - (bounds.width + boundsX);
                        location.x -= location.x + width - (bounds.width + boundsX);
                    }
                    if (this.arrowPadding + arrowLocation.x > width - this.rx) {
                        tipLocation.x = width - this.rx - this.arrowPadding;
                        arrowLocation.x = width - this.rx - this.arrowPadding;
                    }
                    if (arrowLocation.x - this.arrowPadding < this.rx) arrowLocation.x = tipLocation.x = this.rx + this.arrowPadding;
                }
            }
        }
        return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(location.x, location.y, width, height);
    };
    Tooltip.prototype.animateTooltipDiv = function(tooltipDiv, rect) {
        var _this = this;
        var x = parseFloat(tooltipDiv.style.left);
        var y = parseFloat(tooltipDiv.style.top);
        var currenDiff;
        new (0, $kj1BR.Animation)({}).animate(tooltipDiv, {
            duration: this.duration === 0 && (0, $kj1BR.animationMode) === "Enable" ? 300 : this.duration,
            progress: function(args) {
                currenDiff = args.timeStamp / args.duration;
                tooltipDiv.style.animation = null;
                if (_this.controlName === "Chart" && _this.shared && !_this.enableRTL) {
                    tooltipDiv.style.transition = "transform 0.3s";
                    tooltipDiv.style.transform = "translate(" + (x + currenDiff * (rect.x - x)) + "px," + (y + currenDiff * (rect.y - y)) + "px)";
                    tooltipDiv.style.left = "";
                    tooltipDiv.style.top = "";
                } else {
                    tooltipDiv.style.left = x + currenDiff * (rect.x - x) + "px";
                    tooltipDiv.style.top = y + currenDiff * (rect.y - y) + "px";
                    tooltipDiv.style.transform = _this.controlName === "RangeNavigator" ? tooltipDiv.style.transform : "";
                }
            },
            end: function(model) {
                _this.updateDiv(tooltipDiv, rect.x, rect.y);
                _this.trigger("animationComplete", {
                    tooltip: _this
                });
            }
        });
    };
    Tooltip.prototype.updateDiv = function(tooltipDiv, x, y) {
        if (this.controlName === "Chart" && this.shared && !this.crosshair && !this.enableRTL) {
            tooltipDiv.style.transform = "translate(" + x + "px," + y + "px)";
            tooltipDiv.style.left = "";
            tooltipDiv.style.top = "";
        } else {
            tooltipDiv.style.left = x + "px";
            tooltipDiv.style.top = y + "px";
            tooltipDiv.style.transform = this.controlName === "RangeNavigator" ? tooltipDiv.style.transform : "";
        }
    };
    Tooltip.prototype.updateTemplateFn = function() {
        if (this.template) try {
            if (typeof this.template !== "function" && document.querySelectorAll(this.template).length) this.templateFn = (0, $c2qqN.compile)(document.querySelector(this.template).innerHTML.trim());
            else this.templateFn = (0, $c2qqN.compile)(this.template);
        } catch (e) {
            this.templateFn = (0, $c2qqN.compile)(this.template);
        }
    };
    /** @private */ Tooltip.prototype.fadeOut = function() {
        var _this = this;
        var tooltipElement = this.isCanvas && !this.template ? (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id + "_svg") : (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id);
        var tooltipDiv = (0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(this.element.id);
        if (tooltipElement) {
            var tooltipGroup_1 = tooltipElement.firstChild;
            if (tooltipGroup_1.nodeType !== Node.ELEMENT_NODE) tooltipGroup_1 = tooltipElement.firstElementChild;
            if (this.isCanvas && !this.template) tooltipGroup_1 = document.getElementById(this.element.id + "_group") ? document.getElementById(this.element.id + "_group") : tooltipGroup_1;
            if (!tooltipGroup_1) return null;
            var opacity_1 = parseFloat(tooltipGroup_1.getAttribute("opacity"));
            opacity_1 = !(0, $3EnZW.isNullOrUndefined)(opacity_1) ? opacity_1 : 1;
            new (0, $kj1BR.Animation)({}).animate(tooltipGroup_1, {
                duration: 200,
                progress: function(args) {
                    //  tooltipGroup.removeAttribute('e-animate');
                    _this.progressAnimation(tooltipGroup_1, opacity_1, args.timeStamp / args.duration);
                },
                end: function() {
                    _this.fadeOuted = true;
                    _this.endAnimation(tooltipGroup_1);
                    tooltipDiv.style.transition = "";
                }
            });
        }
    };
    Tooltip.prototype.progressAnimation = function(tooltipGroup, opacity, timeStamp) {
        tooltipGroup.style.animation = "";
        tooltipGroup.setAttribute("opacity", (opacity - timeStamp).toString());
    };
    /*
     * @hidden
     */ Tooltip.prototype.endAnimation = function(tooltipGroup) {
        tooltipGroup.setAttribute("opacity", "0");
        if (this.template) tooltipGroup.style.display = "none";
        this.trigger("animationComplete", {
            tooltip: this
        });
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @private
     */ Tooltip.prototype.getPersistData = function() {
        var keyEntity = [];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Get component name
     *
     *  @private
     */ Tooltip.prototype.getModuleName = function() {
        return "tooltip";
    };
    /**
     * To destroy the accumulationcharts
     *
     * @private
     */ Tooltip.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.element.classList.remove("e-tooltip");
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @returns {void}
     * @private
     */ Tooltip.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (this.blazorTemplate) (0, $c2qqN.resetBlazorTemplate)(this.element.id + "parent_template" + "_blazorTemplate");
        this.isFirst = false;
        this.render();
    };
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "enable", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "shared", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "crosshair", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "enableShadow", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "fill", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Tooltip.prototype, "header", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0.75)
    ], Tooltip.prototype, "opacity", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Complex)({
            size: "12px",
            fontWeight: null,
            color: null,
            fontStyle: "Normal",
            fontFamily: null
        }, $aeafe7e2f4093d9a$export$1df879243bf2e42d)
    ], Tooltip.prototype, "textStyle", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "template", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Tooltip.prototype, "enableAnimation", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(300)
    ], Tooltip.prototype, "duration", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "inverted", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "isNegative", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: null
        }, $aeafe7e2f4093d9a$export$42c6045406cd285)
    ], Tooltip.prototype, "border", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Tooltip.prototype, "content", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], Tooltip.prototype, "markerSize", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Complex)({
            x: 0,
            y: 0
        }, $aeafe7e2f4093d9a$export$6df032dc53af18ad)
    ], Tooltip.prototype, "clipBounds", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Tooltip.prototype, "palette", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Tooltip.prototype, "shapes", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Complex)({
            x: 0,
            y: 0
        }, $aeafe7e2f4093d9a$export$6df032dc53af18ad)
    ], Tooltip.prototype, "location", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Tooltip.prototype, "offset", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(4)
    ], Tooltip.prototype, "rx", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(4)
    ], Tooltip.prototype, "ry", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], Tooltip.prototype, "marginX", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], Tooltip.prototype, "marginY", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(7)
    ], Tooltip.prototype, "arrowPadding", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "data", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("Material")
    ], Tooltip.prototype, "theme", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Complex)({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }, $aeafe7e2f4093d9a$export$39b461c45b98972a)
    ], Tooltip.prototype, "areaBounds", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "availableSize", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)()
    ], Tooltip.prototype, "blazorTemplate", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "isCanvas", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "isTextWrap", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "isFixed", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "tooltipPlacement", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Tooltip.prototype, "controlInstance", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Tooltip.prototype, "controlName", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "tooltipRender", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "loaded", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Event)()
    ], Tooltip.prototype, "animationComplete", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "enableRTL", void 0);
    $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Tooltip.prototype, "allowHighlight", void 0);
    Tooltip = $aeafe7e2f4093d9a$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Tooltip);
    return Tooltip;
}((0, $hQxLN.Component));











/**
 * The `DoubleRange` class represents a numeric range with minimum and maximum values.
 *
 * @private
 */ var $b583e56aa322bfca$export$6bc42eb49cfbe353 = /** @class */ function() {
    function DoubleRange(start, end) {
        /*
          if (!isNaN(start) && !isNaN(end)) {
           this.mIsEmpty = true;
          } else {
              this.mIsEmpty = false;
          }*/ if (start < end) {
            this.mStart = start;
            this.mEnd = end;
        } else {
            this.mStart = end;
            this.mEnd = start;
        }
    }
    Object.defineProperty(DoubleRange.prototype, "start", {
        //private mIsEmpty: boolean;
        /**
         * Gets the start value.
         *
         * @returns {number} - The start value.
         * @private
         */ get: function() {
            return this.mStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DoubleRange.prototype, "end", {
        /**
         * Gets the end value.
         *
         * @returns {number} - The end value.
         * @private
         */ get: function() {
            return this.mEnd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DoubleRange.prototype, "delta", {
        /*
          get isEmpty(): boolean {
             return this.mIsEmpty;
         }*/ /**
         * Gets the delta value.
         *
         * @returns {number} - The delta value.
         * @private
         */ get: function() {
            return this.mEnd - this.mStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DoubleRange.prototype, "median", {
        /**
         * Gets the median value.
         *
         * @returns {number} - The median value.
         * @private
         */ get: function() {
            return this.mStart + (this.mEnd - this.mStart) / 2;
        },
        enumerable: true,
        configurable: true
    });
    return DoubleRange;
}();




parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * The `Double` module is used to render the numeric axis in charts.
 */ var $5e1e0b5d807dfa70$export$340e583a64e26663 = /** @class */ function() {
    /**
     * Constructor for the dateTime module.
     *
     * @private
     * @param {Chart} chart - Specifies the chart.
     */ function Double(chart) {
        this.isColumn = 0;
        this.isStacking = false;
        this.chart = chart;
    }
    /**
     * Numeric Nice Interval for the axis.
     *
     * @private
     * @param {Axis} axis - The axis.
     * @param {number} delta - The delta value.
     * @param {Size} size - The size.
     * @returns {number} - The calculated nice interval.
     */ Double.prototype.calculateNumericNiceInterval = function(axis, delta, size) {
        var actualDesiredIntervalsCount = (0, $11815a21a80ae2b7$export$4e4203e7203e8f7b)(size, axis);
        var niceInterval = delta / actualDesiredIntervalsCount;
        if (!(0, $3EnZW.isNullOrUndefined)(axis.desiredIntervals)) {
            if (this.isAutoIntervalOnBothAxis(axis)) return niceInterval;
        }
        var minInterval = Math.pow(10, Math.floor((0, $11815a21a80ae2b7$export$2aa080c37938b627)(niceInterval, 10)));
        for(var _i = 0, _a = axis.intervalDivs; _i < _a.length; _i++){
            var interval = _a[_i];
            var currentInterval = minInterval * interval;
            if (actualDesiredIntervalsCount < delta / currentInterval) break;
            niceInterval = currentInterval;
        }
        return niceInterval;
    };
    /**
     * Determines whether auto interval is enabled on both axes.
     *
     * @private
     * @param {Axis} axis - The axis.
     * @returns {boolean} - The boolean value indicating if auto interval is enabled on both axes.
     */ Double.prototype.isAutoIntervalOnBothAxis = function(axis) {
        if ((axis.zoomFactor < 1 || axis.zoomPosition > 0) && axis.enableAutoIntervalOnZooming) return false;
        else return true;
    };
    Double.prototype.getActualRange = function(axis, size) {
        this.initializeDoubleRange(axis);
        if (!axis.startFromZero && this.isColumn > 0) {
            axis.actualRange.interval = axis.interval || this.calculateNumericNiceInterval(axis, axis.doubleRange.delta, size);
            axis.actualRange.max = axis.doubleRange.end + axis.actualRange.interval;
            if (axis.doubleRange.start - axis.actualRange.interval < 0 && axis.doubleRange.start > 0) axis.actualRange.min = 0;
            else axis.actualRange.min = axis.doubleRange.start - (this.isStacking ? 0 : axis.actualRange.interval);
        } else {
            axis.actualRange.interval = axis.interval || this.calculateNumericNiceInterval(axis, axis.doubleRange.delta, size);
            axis.actualRange.min = axis.doubleRange.start;
            axis.actualRange.max = axis.doubleRange.end;
        }
    };
    /**
     * Range for the axis.
     *
     * @private
     * @param {Axis} axis - The axis.
     * @returns {void}
     */ Double.prototype.initializeDoubleRange = function(axis) {
        //Axis Min
        if (axis.minimum !== null) this.min = axis.minimum;
        else if (this.min === null || this.min === Number.POSITIVE_INFINITY) this.min = 0;
        // Axis Max
        if (axis.maximum !== null) this.max = axis.maximum;
        else if (this.max === null || this.max === Number.NEGATIVE_INFINITY) this.max = 5;
        if (this.min === this.max) this.max = axis.valueType.indexOf("Category") > -1 ? this.max : this.min + 1;
        axis.doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(this.min, this.max);
        axis.actualRange = {};
    };
    /**
     * The function to calculate the range and labels for the axis.
     *
     * @returns {void}
     * @private
     */ Double.prototype.calculateRangeAndInterval = function(size, axis) {
        this.calculateRange(axis);
        this.getActualRange(axis, size);
        this.applyRangePadding(axis, size);
        this.calculateVisibleLabels(axis, this.chart);
    };
    /**
     * Calculate Range for the axis.
     *
     * @private
     */ Double.prototype.calculateRange = function(axis) {
        /** Generate axis range */ this.min = null;
        this.max = null;
        if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(axis)) for(var _i = 0, _a = axis.series; _i < _a.length; _i++){
            var series = _a[_i];
            if (!series.visible) continue;
            this.paddingInterval = 0;
            if (!(0, $3EnZW.isNullOrUndefined)(series.points)) axis.maxPointLength = series.points.length;
            axis.maxPointLength = series.points.length;
            if ((series.type.indexOf("Column") > -1 || series.type.indexOf("Histogram") > -1) && axis.orientation === "Horizontal" || series.type.indexOf("Bar") > -1 && axis.orientation === "Vertical") {
                if ((series.xAxis.valueType === "Double" || series.xAxis.valueType === "DateTime") && series.xAxis.rangePadding === "Auto") this.paddingInterval = (0, $11815a21a80ae2b7$export$c50b663dcfb9c16f)(series.xAxis, axis.series) * 0.5;
            }
            //For xRange
            if (axis.orientation === "Horizontal") {
                if (this.chart.requireInvertedAxis) this.yAxisRange(axis, series);
                else this.findMinMax(series.xMin - this.paddingInterval, series.xMax + this.paddingInterval);
            }
            // For yRange
            if (axis.orientation === "Vertical") {
                this.isColumn += series.type.indexOf("Column") !== -1 || series.type.indexOf("Bar") !== -1 || series.drawType === "Column" ? 1 : 0;
                this.isStacking = series.type.indexOf("Stacking") !== -1;
                if (this.chart.requireInvertedAxis) this.findMinMax(series.xMin - this.paddingInterval, series.xMax + this.paddingInterval);
                else this.yAxisRange(axis, series);
            }
        }
    };
    Double.prototype.yAxisRange = function(axis, series) {
        if (series.dragSettings.enable && this.chart.dragY) {
            if (this.chart.dragY >= axis.visibleRange.max) series.yMax = this.chart.dragY + axis.visibleRange.interval;
            if (this.chart.dragY <= axis.visibleRange.min) series.yMin = this.chart.dragY - axis.visibleRange.interval;
        }
        if (series.type === "Waterfall") {
            var cumulativeMax = 0;
            var cumulativeValue = 0;
            for(var i = 0; i < series.yData.length; i++){
                if (!(series.intermediateSumIndexes && series.intermediateSumIndexes.indexOf(i) !== -1) && !(series.sumIndexes && series.sumIndexes.indexOf(i) !== -1)) cumulativeValue += series.yData[i];
                if (cumulativeValue > cumulativeMax) cumulativeMax = cumulativeValue;
            }
            this.findMinMax(series.yMin, cumulativeMax);
        } else this.findMinMax(series.yMin, series.yMax);
    };
    Double.prototype.findMinMax = function(min, max) {
        if (this.min === null || this.min > min) this.min = min;
        if (this.max === null || this.max < max) this.max = max;
        if (this.max === this.min && this.max < 0 && this.min < 0) this.max = 0;
    };
    /**
     * Apply padding for the range.
     *
     * @private
     * @param {Axis} axis - The axis for which padding is applied.
     * @param {Size} size - The size used for padding calculation.
     * @returns {void}
     */ Double.prototype.applyRangePadding = function(axis, size) {
        var start = axis.actualRange.min;
        var end = axis.actualRange.max;
        if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(axis)) {
            var interval = axis.actualRange.interval;
            var padding = axis.getRangePadding(this.chart);
            if (padding === "Additional" || padding === "Round") this.findAdditional(axis, start, end, interval, size);
            else if (padding === "Normal") this.findNormal(axis, start, end, interval, size);
            else this.updateActualRange(axis, start, end, interval);
        }
        axis.actualRange.delta = axis.actualRange.max - axis.actualRange.min;
        this.calculateVisibleRange(size, axis);
    };
    Double.prototype.updateActualRange = function(axis, minimum, maximum, interval) {
        axis.actualRange = {
            min: axis.minimum != null ? axis.minimum : minimum,
            max: axis.maximum != null ? axis.maximum : maximum,
            interval: axis.interval != null ? axis.interval : interval,
            delta: axis.actualRange.delta
        };
    };
    Double.prototype.findAdditional = function(axis, start, end, interval, size) {
        var minimum;
        var maximum;
        minimum = Math.floor(start / interval) * interval;
        maximum = Math.ceil(end / interval) * interval;
        if (axis.rangePadding === "Additional") {
            minimum -= interval;
            maximum += interval;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(axis.desiredIntervals)) {
            var delta = maximum - minimum;
            interval = this.calculateNumericNiceInterval(axis, delta, size);
        }
        this.updateActualRange(axis, minimum, maximum, interval);
    };
    Double.prototype.findNormal = function(axis, start, end, interval, size) {
        var remaining;
        var minimum;
        var maximum;
        var startValue = start;
        if (start < 0) {
            startValue = 0;
            minimum = start + start * 0.05;
            remaining = interval + minimum % interval;
            if (0.365 * interval >= remaining) minimum -= interval;
            if (minimum % interval < 0) minimum = minimum - interval - minimum % interval;
        } else {
            minimum = start < 5.0 / 6.0 * end ? 0 : start - (end - start) * 0.5;
            if (minimum % interval > 0) minimum -= minimum % interval;
        }
        maximum = end > 0 ? end + (end - startValue) * 0.05 : end - (end - startValue) * 0.05;
        remaining = interval - maximum % interval;
        if (0.365 * interval >= remaining) maximum += interval;
        if (maximum % interval > 0) maximum = maximum + interval - maximum % interval;
        axis.doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(minimum, maximum);
        if (minimum === 0 || minimum < 0 && maximum < 0) {
            interval = this.calculateNumericNiceInterval(axis, axis.doubleRange.delta, size);
            maximum = Math.ceil(maximum / interval) * interval;
        }
        this.updateActualRange(axis, minimum, maximum, interval);
    };
    /**
     * Calculate visible range for axis.
     *
     * @private
     * @param {Size} size - The size used for calculation.
     * @param {Axis} axis - The axis for which the visible range is calculated.
     * @returns {void}
     */ Double.prototype.calculateVisibleRange = function(size, axis) {
        axis.visibleRange = {
            max: axis.actualRange.max,
            min: axis.actualRange.min,
            delta: axis.actualRange.delta,
            interval: axis.actualRange.interval
        };
        if (this.chart.chartAreaType === "Cartesian") {
            var isLazyLoad = (0, $3EnZW.isNullOrUndefined)(axis.zoomingScrollBar) ? false : axis.zoomingScrollBar.isLazyLoad;
            if ((axis.zoomFactor < 1 || axis.zoomPosition > 0) && !isLazyLoad) {
                axis.calculateVisibleRangeOnZooming();
                axis.visibleRange.interval = axis.enableAutoIntervalOnZooming ? this.calculateNumericNiceInterval(axis, axis.doubleRange.delta, size) : axis.visibleRange.interval;
            }
        }
        if ((axis.visibleRange.max - axis.visibleRange.min) % axis.visibleRange.interval !== 0 && axis.valueType === "Double" && axis.orientation === "Vertical" && axis.rangePadding === "Auto") {
            var duplicateTempInterval = void 0;
            var tempInterval = axis.visibleRange.min;
            for(; tempInterval <= axis.visibleRange.max && duplicateTempInterval !== tempInterval; tempInterval += axis.visibleRange.interval)duplicateTempInterval = tempInterval;
            if (duplicateTempInterval < axis.visibleRange.max) axis.visibleRange.max = duplicateTempInterval + axis.visibleRange.interval;
        }
        axis.triggerRangeRender(this.chart, axis.visibleRange.min, axis.visibleRange.max, axis.visibleRange.interval);
    };
    /**
     * Calculate label for the axis.
     *
     * @private
     */ Double.prototype.calculateVisibleLabels = function(axis, chart) {
        /** Generate axis labels */ axis.visibleLabels = [];
        var tempInterval = axis.visibleRange.min;
        var labelStyle;
        var controlName = chart.getModuleName();
        var isPolarRadar = controlName === "chart" && chart.chartAreaType === "PolarRadar";
        if (!isPolarRadar && (axis.zoomFactor < 1 || axis.zoomPosition > 0 || this.paddingInterval)) tempInterval = axis.visibleRange.min - axis.visibleRange.min % axis.visibleRange.interval;
        var format = this.getFormat(axis);
        var isCustom = format.match("{value}") !== null;
        var intervalDigits = 0;
        var formatDigits = 0;
        if (axis.labelFormat && axis.labelFormat.indexOf("n") > -1) formatDigits = parseInt(axis.labelFormat.substring(1, axis.labelFormat.length), 10);
        axis.format = chart.intl.getNumberFormat({
            format: isCustom ? "" : format,
            useGrouping: chart.useGroupingSeparator
        });
        axis.startLabel = axis.format(axis.visibleRange.min);
        axis.endLabel = axis.format(axis.visibleRange.max);
        if (axis.visibleRange.interval && (axis.visibleRange.interval + "").indexOf(".") >= 0) intervalDigits = (axis.visibleRange.interval + "").split(".")[1].length;
        var duplicateTempInterval;
        for(; tempInterval <= axis.visibleRange.max && duplicateTempInterval !== tempInterval; tempInterval += axis.visibleRange.interval){
            duplicateTempInterval = tempInterval;
            labelStyle = (0, $3EnZW.extend)({}, (0, $3EnZW.getValue)("properties", axis.labelStyle), null, true);
            if ((0, $11815a21a80ae2b7$export$ee35c16ea07b4b7f)(tempInterval, axis.visibleRange)) (0, $11815a21a80ae2b7$export$3354c8a0fc977929)(chart, tempInterval, this.formatValue(axis, isCustom, format, tempInterval), labelStyle, axis);
        }
        if (tempInterval && (tempInterval + "").indexOf(".") >= 0 && (tempInterval + "").split(".")[1].length > 10) {
            tempInterval = (tempInterval + "").split(".")[1].length > (formatDigits || intervalDigits) ? +tempInterval.toFixed(formatDigits || intervalDigits) : tempInterval;
            if (tempInterval <= axis.visibleRange.max) (0, $11815a21a80ae2b7$export$3354c8a0fc977929)(chart, tempInterval, this.formatValue(axis, isCustom, format, tempInterval), labelStyle, axis);
        }
        if (axis.getMaxLabelWidth) axis.getMaxLabelWidth(this.chart);
    };
    /**
     * Format of the axis label.
     *
     * @private
     */ Double.prototype.getFormat = function(axis) {
        if (axis.labelFormat) {
            if (axis.labelFormat.indexOf("p") === 0 && axis.labelFormat.indexOf("{value}") === -1 && axis.isStack100) return "{value}%";
            return axis.labelFormat;
        }
        return axis.isStack100 ? "{value}%" : "";
    };
    /**
     * Formatted the axis label.
     *
     * @private
     */ Double.prototype.formatValue = function(axis, isCustom, format, tempInterval) {
        /*The toLocaleString method is used to adjust the decimal points for this ticket, specifically for ticket numbers I481747 and I541484.*/ var labelValue = !(tempInterval % 1) ? tempInterval : Number(tempInterval.toLocaleString("en-US").split(",").join(""));
        return isCustom ? format.replace("{value}", axis.format(labelValue)) : format ? axis.format(tempInterval) : axis.format(labelValue);
    };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ Double.prototype.getModuleName = function() {
        /**
         * Returns the module name
         */ return "Double";
    };
    /**
     * To destroy the double axis.
     *
     * @returns {void}
     * @private
     */ Double.prototype.destroy = function() {
    /**
         * Destroy method performed here.
         */ };
    return Double;
}();


/**
 * Specifies the chart constant value
 */ /** @private */ var $9415fc5f023d8fac$export$b40fc69c4a2927a1 = "loaded";
var $9415fc5f023d8fac$export$af8636ce5f93a3af = "legendClick";
var $9415fc5f023d8fac$export$11e63f7b0f3d9900 = "load";
var $9415fc5f023d8fac$export$ceb5ab28ca4b7fa0 = "animationComplete";
var $9415fc5f023d8fac$export$b6a2e1cc1d89ccd0 = "legendRender";
var $9415fc5f023d8fac$export$7a9478098c73def8 = "textRender";
var $9415fc5f023d8fac$export$9f10d5daf06d56ca = "pointRender";
var $9415fc5f023d8fac$export$ec1dd2c0eeecad0c = "sharedTooltipRender";
var $9415fc5f023d8fac$export$f3b9d552d8efcc74 = "seriesRender";
var $9415fc5f023d8fac$export$e632e6555cc607e4 = "axisLabelRender";
var $9415fc5f023d8fac$export$478ba8b8d1838c4b = "axisLabelClick";
var $9415fc5f023d8fac$export$1155f7ba6d87aa87 = "axisRangeCalculated";
var $9415fc5f023d8fac$export$39ef685c6c528892 = "axisMultiLabelRender";
var $9415fc5f023d8fac$export$9387be9b28ea8206 = "tooltipRender";
var $9415fc5f023d8fac$export$9680c713d196e3fe = "chartMouseMove";
var $9415fc5f023d8fac$export$32aac92eb1966452 = "chartMouseClick";
var $9415fc5f023d8fac$export$24e08cbb55c3a531 = "chartDoubleClick";
var $9415fc5f023d8fac$export$56c0b6612edfacb9 = "pointClick";
var $9415fc5f023d8fac$export$df325cbc6a85cce1 = "pointDoubleClick";
var $9415fc5f023d8fac$export$303d93c98be934b1 = "pointMove";
var $9415fc5f023d8fac$export$3023b2be6c49e1fa = "chartMouseLeave";
var $9415fc5f023d8fac$export$54283ad48bed80cb = "chartMouseDown";
var $9415fc5f023d8fac$export$656b3fce824ebc9b = "chartMouseUp";
var $9415fc5f023d8fac$export$d9866eadbbddd804 = "zoomComplete";
var $9415fc5f023d8fac$export$d80851d2adc417a9 = "dragComplete";
var $9415fc5f023d8fac$export$351f4a09b483df06 = "selectionComplete";
var $9415fc5f023d8fac$export$e3cf9934ceac4daa = "resized";
var $9415fc5f023d8fac$export$b440912c9c16a935 = "beforeResize";
var $9415fc5f023d8fac$export$239eb85392ed959a = "beforePrint";
var $9415fc5f023d8fac$export$a760154eb6bc3563 = "annotationRender";
var $9415fc5f023d8fac$export$6cf496cf990fb77a = "scrollStart";
var $9415fc5f023d8fac$export$985b29f73547087b = "scrollEnd";
var $9415fc5f023d8fac$export$7cf2b68d33f2b217 = "scrollChanged";
var $9415fc5f023d8fac$export$38e9d4064cf30308 = "stockEventRender";
var $9415fc5f023d8fac$export$f4416d0adb0f42c6 = "multiLevelLabelClick";
var $9415fc5f023d8fac$export$c34730c351bf3a09 = "dragStart";
var $9415fc5f023d8fac$export$d7d5d435647ed5a0 = "drag";
var $9415fc5f023d8fac$export$5d38b0bd4bef40ba = "dragEnd";
var $9415fc5f023d8fac$export$a5e18b86421f9fee = /~\d+~/g;
var $9415fc5f023d8fac$export$d5c2e0e790d2d526 = /\^\d+\^/g;
var $9415fc5f023d8fac$export$d635f9705534f5a0 = "beforeExport";
var $9415fc5f023d8fac$export$6ae42986d07a8eb8 = "afterExport";
var $9415fc5f023d8fac$export$8f2c627a11e95627 = "bulletChartMouseClick";
var $9415fc5f023d8fac$export$398f50d89951b649 = "onZooming";


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");

var $7109450e102533b6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7109450e102533b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the annotation settings for a chart to highlight or provide additional information about specific points or regions.
 */ var $7109450e102533b6$export$e77a45b056cef7cb = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(ChartAnnotationSettings, _super);
    function ChartAnnotationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("0")
    ], ChartAnnotationSettings.prototype, "x", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("0")
    ], ChartAnnotationSettings.prototype, "y", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartAnnotationSettings.prototype, "content", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], ChartAnnotationSettings.prototype, "horizontalAlignment", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Pixel")
    ], ChartAnnotationSettings.prototype, "coordinateUnits", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Chart")
    ], ChartAnnotationSettings.prototype, "region", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Middle")
    ], ChartAnnotationSettings.prototype, "verticalAlignment", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartAnnotationSettings.prototype, "xAxisName", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartAnnotationSettings.prototype, "yAxisName", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartAnnotationSettings.prototype, "description", void 0);
    return ChartAnnotationSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The `LabelBorder` class provides options to customize the border settings for chart labels.
 */ var $7109450e102533b6$export$b11d60099392c19c = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(LabelBorder, _super);
    function LabelBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("")
    ], LabelBorder.prototype, "color", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], LabelBorder.prototype, "width", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Rectangle")
    ], LabelBorder.prototype, "type", void 0);
    return LabelBorder;
}((0, $3fcxu.ChildProperty));
/**
 * The `MultiLevelCategories` class allows defining and customizing the categories used in multi-level labels.
 * This is particularly useful when there is a need to display hierarchical or grouped data labels on the chart axis.
 */ var $7109450e102533b6$export$60da9e8a05e72044 = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(MultiLevelCategories, _super);
    function MultiLevelCategories() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiLevelCategories.prototype, "start", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiLevelCategories.prototype, "end", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MultiLevelCategories.prototype, "text", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiLevelCategories.prototype, "maximumTextWidth", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiLevelCategories.prototype, "customAttributes", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MultiLevelCategories.prototype, "type", void 0);
    return MultiLevelCategories;
}((0, $3fcxu.ChildProperty));
/**
 * The `StripLineSettings` class provides configuration options for strip lines in a chart.
 */ var $7109450e102533b6$export$18935046c099a1f2 = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(StripLineSettings, _super);
    function StripLineSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], StripLineSettings.prototype, "visible", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StripLineSettings.prototype, "startFromAxis", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "start", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "end", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "size", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("#808080")
    ], StripLineSettings.prototype, "color", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "dashArray", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], StripLineSettings.prototype, "sizeType", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StripLineSettings.prototype, "isRepeat", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "repeatEvery", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "repeatUntil", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], StripLineSettings.prototype, "isSegmented", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "segmentStart", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "segmentEnd", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "segmentAxisName", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "transparent",
            width: 1
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], StripLineSettings.prototype, "border", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("")
    ], StripLineSettings.prototype, "text", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], StripLineSettings.prototype, "rotation", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Middle")
    ], StripLineSettings.prototype, "horizontalAlignment", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Middle")
    ], StripLineSettings.prototype, "verticalAlignment", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Complex)({
            size: "12px",
            color: null,
            fontStyle: "Normal",
            fontWeight: "400",
            fontFamily: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], StripLineSettings.prototype, "textStyle", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Behind")
    ], StripLineSettings.prototype, "zIndex", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], StripLineSettings.prototype, "opacity", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("")
    ], StripLineSettings.prototype, "imageUrl", void 0);
    return StripLineSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The `MultiLevelLabels` class is used to customize the appearance and behavior of multi-level labels in charts.
 */ var $7109450e102533b6$export$ebf2b710e93882e4 = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(MultiLevelLabels, _super);
    function MultiLevelLabels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], MultiLevelLabels.prototype, "alignment", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)("Wrap")
    ], MultiLevelLabels.prototype, "overflow", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: "12px",
            fontStyle: "Normal",
            fontWeight: "400",
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], MultiLevelLabels.prototype, "textStyle", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: 1,
            type: "Rectangle"
        }, $7109450e102533b6$export$b11d60099392c19c)
    ], MultiLevelLabels.prototype, "border", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Collection)([], $7109450e102533b6$export$60da9e8a05e72044)
    ], MultiLevelLabels.prototype, "categories", void 0);
    return MultiLevelLabels;
}((0, $3fcxu.ChildProperty));
/**
 * The `ScrollbarSettingsRange` class allows defining the start and end values for the scrollbar range in a chart.
 *
 * @public
 */ var $7109450e102533b6$export$2f0195a8768a94dc = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(ScrollbarSettingsRange, _super);
    function ScrollbarSettingsRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettingsRange.prototype, "minimum", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettingsRange.prototype, "maximum", void 0);
    return ScrollbarSettingsRange;
}((0, $3fcxu.ChildProperty));
/**
 * Specifies properties for customizing the scrollbar settings in lazy loading.
 */ var $7109450e102533b6$export$a91fff02467d5657 = /** @class */ function(_super) {
    $7109450e102533b6$var$__extends(ScrollbarSettings, _super);
    function ScrollbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ScrollbarSettings.prototype, "enable", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettings.prototype, "pointsLength", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Complex)({}, $7109450e102533b6$export$2f0195a8768a94dc)
    ], ScrollbarSettings.prototype, "range", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettings.prototype, "trackColor", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ScrollbarSettings.prototype, "scrollbarRadius", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettings.prototype, "scrollbarColor", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ScrollbarSettings.prototype, "trackRadius", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ScrollbarSettings.prototype, "gripColor", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(16)
    ], ScrollbarSettings.prototype, "height", void 0);
    $7109450e102533b6$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ScrollbarSettings.prototype, "enableZoom", void 0);
    return ScrollbarSettings;
}((0, $3fcxu.ChildProperty));


var $691dde0edd52f9f0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $691dde0edd52f9f0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the `rows` of the chart to create multiple vertical rows within the chart area.
 */ var $691dde0edd52f9f0$export$b59bdbef9ce70de2 = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(Row, _super);
    function Row() {
        /**
         * The height of the row as a string accepts input both as '100px' and '100%'.
         * If specified as '100%', the row renders to the full height of its chart.
         *
         * @default '100%'
         */ var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @private */ _this.axes = [];
        /** @private */ _this.nearSizes = [];
        /** @private */ _this.farSizes = [];
        /** @private */ _this.insideFarSizes = [];
        /** @private */ _this.insideNearSizes = [];
        return _this;
    }
    /**
     * Measure the row size.
     *
     * @param {Axis} axis - The axis for which to measure the row size.
     * @param {number} scrollBarHeight - The height of the scrollbar.
     * @param {Row | Column} definition - The definition of the row or column.
     * @param {Chart} chart - The chart instance.
     * @returns {void}
     * @private
     */ Row.prototype.computeSize = function(axis, scrollBarHeight, definition, chart) {
        var width = 0;
        var innerPadding = axis.labelPosition === "Inside" && chart.axes.indexOf(axis) > -1 ? -5 : 5;
        if (axis.visible && axis.internalVisibility) width += axis.findTickSize(axis.crossInAxis) + scrollBarHeight + axis.findLabelSize(axis.crossInAxis, innerPadding, definition, chart) + axis.lineStyle.width * 0.5;
        if (axis.isAxisOpposedPosition) this.farSizes.push(width);
        else this.nearSizes.push(width);
    };
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], Row.prototype, "height", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], Row.prototype, "border", void 0);
    return Row;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the `columns` of the chart to create multiple horizontal columns within the chart area.
 */ var $691dde0edd52f9f0$export$816b5d811295e6bc = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(Column, _super);
    function Column() {
        /**
         * The width of the column as a string accepts input both as '100px' and '100%'.
         * If specified as '100%', the column renders to the full width of its chart.
         *
         * @default '100%'
         */ var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @private */ _this.axes = [];
        /** @private */ _this.nearSizes = [];
        /** @private */ _this.farSizes = [];
        /** @private */ _this.insideFarSizes = [];
        /** @private */ _this.insideNearSizes = [];
        /** @private */ _this.padding = 0;
        return _this;
    }
    /**
     * Measure the column size
     *
     * @returns {void}
     * @private
     */ Column.prototype.computeSize = function(axis, scrollBarHeight, definition, chart) {
        var height = 0;
        var innerPadding = 5;
        if (axis.visible && axis.internalVisibility) height += axis.findTickSize(axis.crossInAxis) + scrollBarHeight + axis.findLabelSize(axis.crossInAxis, innerPadding, definition, chart) + axis.lineStyle.width * 0.5;
        if (axis.isAxisOpposedPosition) this.farSizes.push(height);
        else this.nearSizes.push(height);
    };
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], Column.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], Column.prototype, "border", void 0);
    return Column;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the major grid lines in the axis, allowing for the setting of properties such as color, width, and dashArray to define how the grid lines appear on the chart.
 */ var $691dde0edd52f9f0$export$1bc3b102d489d993 = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(MajorGridLines, _super);
    function MajorGridLines() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], MajorGridLines.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MajorGridLines.prototype, "dashArray", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MajorGridLines.prototype, "color", void 0);
    return MajorGridLines;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the minor grid lines in the axis, allowing for the setting of properties such as color, width, and dashArray to define how the grid lines appear on the chart.
 */ var $691dde0edd52f9f0$export$4cd1fa87376d595a = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(MinorGridLines, _super);
    function MinorGridLines() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0.7)
    ], MinorGridLines.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MinorGridLines.prototype, "dashArray", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MinorGridLines.prototype, "color", void 0);
    return MinorGridLines;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the axis line of a chart, allowing customization of the line's appearance, including its color, width, and dashArray.
 */ var $691dde0edd52f9f0$export$6b38ce563ca3e26b = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(AxisLine, _super);
    function AxisLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], AxisLine.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], AxisLine.prototype, "dashArray", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AxisLine.prototype, "color", void 0);
    return AxisLine;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the major tick lines in the axis, allowing for the setting of properties such as color, width, and height to define how the tick lines appear on the chart.
 */ var $691dde0edd52f9f0$export$e8bfb5a4d62ecff = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(MajorTickLines, _super);
    function MajorTickLines() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], MajorTickLines.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], MajorTickLines.prototype, "height", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MajorTickLines.prototype, "color", void 0);
    return MajorTickLines;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the minor tick lines in the axis, allowing for the setting of properties such as color, width, and height to define how the tick lines appear on the chart.
 */ var $691dde0edd52f9f0$export$79bf2c1495a8c00c = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(MinorTickLines, _super);
    function MinorTickLines() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0.7)
    ], MinorTickLines.prototype, "width", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], MinorTickLines.prototype, "height", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MinorTickLines.prototype, "color", void 0);
    return MinorTickLines;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the crosshair tooltip for the chart, allowing customization of the tooltip's appearance and content during crosshair interactions.
 */ var $691dde0edd52f9f0$export$c5ce366f8107473b = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(CrosshairTooltip, _super);
    function CrosshairTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CrosshairTooltip.prototype, "enable", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], CrosshairTooltip.prototype, "fill", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], CrosshairTooltip.prototype, "textStyle", void 0);
    return CrosshairTooltip;
}((0, $3fcxu.ChildProperty));
/**
 * The Axis class configures the axes in the chart. It provides various properties to customize the appearance and behavior of chart axes, including settings for labels, grid lines, ticks, and more.
 *
 * @public
 */ var $691dde0edd52f9f0$export$d06866a9fb0606da = /** @class */ function(_super) {
    $691dde0edd52f9f0$var$__extends(Axis, _super);
    function Axis(parent, propName, defaultValue, isArray) {
        var _this = _super.call(this, parent, propName, defaultValue, isArray) || this;
        /** @private */ _this.visibleLabels = [];
        /** @private */ _this.series = [];
        /** @private */ _this.rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(undefined, undefined, 0, 0);
        /** @private */ _this.axisBottomLine = null;
        /** @private */ _this.intervalDivs = [
            10,
            5,
            2,
            1
        ];
        /** @private */ _this.isStack100 = false;
        /** @private */ _this.crossAt = null;
        /** @private */ _this.updatedRect = null;
        /** @private */ _this.multiLevelLabelHeight = 0;
        /** @private */ _this.isChart = true;
        /** @private */ _this.isIntervalInDecimal = true;
        /** @private */ _this.titleCollection = [];
        /** @private */ _this.titleSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
        /**
         * Task: BLAZ-2044
         * This property used to hide the axis when series hide from legend click
         *
         * @private
         */ _this.internalVisibility = true;
        /**
         * This property is used to place the vertical axis in opposed position and horizontal axis in inversed
         * when RTL is enabled in chart
         *
         * @private */ _this.isRTLEnabled = false;
        _this.angle = _this.labelRotation;
        return _this;
    }
    /**
     * The function used to find tick size.
     *
     * @param {Axis} crossAxis - The cross axis for which to find the tick size.
     * @returns {number} - The tick line size.
     * @private
     */ Axis.prototype.findTickSize = function(crossAxis) {
        if (this.tickPosition === "Inside") return 0;
        if (crossAxis && (!crossAxis.visibleRange || this.isInside(crossAxis.visibleRange))) return 0;
        return this.majorTickLines.height;
    };
    /**
     * The function used to find axis position.
     *
     * @returns {number}
     * @private
     */ Axis.prototype.isInside = function(range) {
        return (0, $11815a21a80ae2b7$export$245b06b49bc2b810)(this.crossAt, range) || !this.isAxisOpposedPosition && this.crossAt >= range.max || this.isAxisOpposedPosition && this.crossAt <= range.min;
    };
    /**
     * The function used to find label Size.
     *
     * @param {Axis} crossAxis - The cross axis for which to find the label size.
     * @param {number} innerPadding - The inner padding.
     * @param {Row | Column} definition - The row or column definition.
     * @param {Chart} chart - The chart instance.
     * @returns {number} - The label size.
     * @private
     */ Axis.prototype.findLabelSize = function(crossAxis, innerPadding, definition, chart) {
        var titleSize = 0;
        var isHorizontal = this.orientation === "Horizontal";
        if (this.title) {
            var angle = this.titleRotation;
            if ((0, $3EnZW.isNullOrUndefined)(angle)) {
                this.titleSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.title, this.titleStyle, chart.themeStyle.axisTitleFont);
                titleSize = this.titleSize.height + innerPadding;
            } else {
                this.titleSize = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(this.titleStyle, this.title, angle, chart, chart.themeStyle.axisTitleFont);
                titleSize = (this.orientation === "Vertical" ? this.titleSize.width : this.titleSize.height) + innerPadding;
            }
            if (this.rect.width || this.rect.height) {
                var length_1 = isHorizontal ? this.rect.width : this.rect.height;
                this.titleCollection = (0, $11815a21a80ae2b7$export$70d1bf7729efff40)(this.title, this.titleStyle, length_1, chart.enableRtl, chart.themeStyle.axisTitleFont);
                titleSize = titleSize * this.titleCollection.length;
            }
        }
        var diff;
        var value;
        var labelSize = titleSize + innerPadding + this.titlePadding + this.labelPadding + (this.orientation === "Vertical" ? this.maxLabelSize.width : this.maxLabelSize.height) + this.multiLevelLabelHeight;
        if (crossAxis && this.placeNextToAxisLine) {
            var range = crossAxis.visibleRange;
            var size = crossAxis.orientation === "Horizontal" ? crossAxis.rect.width : crossAxis.rect.height;
            if (!range || !size) return 0;
            else if (this.isInside(range)) {
                value = this.findDifference(crossAxis);
                diff = value * (size / range.delta);
                diff = value * ((size - (diff < labelSize ? labelSize - diff : 0)) / range.delta);
                labelSize = diff < labelSize ? labelSize - diff : 0;
            }
        }
        if (this.isAxisOpposedPosition) definition.insideFarSizes.push(labelSize);
        else definition.insideNearSizes.push(labelSize);
        if (this.labelPosition === "Inside") return titleSize + innerPadding;
        return labelSize;
    };
    /**
     * The function used to find axis position.
     *
     * @returns {void}
     * @private
     */ Axis.prototype.updateCrossValue = function() {
        var value = this.crossAt;
        if (value === null || !this.isInside(this.crossInAxis.visibleRange)) {
            this.updatedRect = this.rect;
            return null;
        }
        var range = this.crossInAxis.visibleRange;
        if (!this.isAxisOpposedPosition) {
            if (this.crossAt > range.max) value = range.max;
        } else if (this.crossAt < range.min) value = range.min;
        this.updatedRect = (0, $3EnZW.extend)({}, this.rect, null, true);
        if (this.orientation === "Horizontal") {
            value = this.crossInAxis.rect.height - (0, $11815a21a80ae2b7$export$f83186674b8cab09)(value, this.crossInAxis) * this.crossInAxis.rect.height;
            this.updatedRect.y = this.crossInAxis.rect.y + value;
        } else {
            value = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(value, this.crossInAxis) * this.crossInAxis.rect.width;
            this.updatedRect.x = this.crossInAxis.rect.x + value;
        }
    };
    Axis.prototype.findDifference = function(crossAxis) {
        var value = 0;
        if (this.isAxisOpposedPosition) value = crossAxis.isAxisInverse ? crossAxis.visibleRange.min : crossAxis.visibleRange.max;
        else value = crossAxis.isAxisInverse ? crossAxis.visibleRange.max : crossAxis.visibleRange.min;
        return Math.abs(this.crossAt - value);
    };
    /**
     * Calculate the visible range for the axis.
     *
     * @returns {void}
     * @private
     */ Axis.prototype.calculateVisibleRangeOnZooming = function() {
        if ((0, $11815a21a80ae2b7$export$a34692dfee195c82)(this)) {
            var baseRange = this.actualRange;
            var start = void 0;
            var end = void 0;
            if (!this.isAxisInverse) {
                start = this.actualRange.min + this.zoomPosition * this.actualRange.delta;
                end = start + this.zoomFactor * this.actualRange.delta;
            } else {
                start = this.actualRange.max - this.zoomPosition * this.actualRange.delta;
                end = start - this.zoomFactor * this.actualRange.delta;
            }
            if (start < baseRange.min) {
                end = end + (baseRange.min - start);
                start = baseRange.min;
            }
            if (end > baseRange.max) {
                start = start - (end - baseRange.max);
                end = baseRange.max;
            }
            this.doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(start, end);
            this.visibleRange = {
                min: this.doubleRange.start,
                max: this.doubleRange.end,
                delta: this.doubleRange.delta,
                interval: this.visibleRange.interval
            };
        }
    };
    /**
     * Triggers the event.
     *
     * @returns {void}
     * @private
     */ Axis.prototype.triggerRangeRender = function(chart, minimum, maximum, interval) {
        var argsData = {
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$1155f7ba6d87aa87),
            axis: this,
            minimum: minimum,
            maximum: maximum,
            interval: interval
        };
        chart.trigger((0, $9415fc5f023d8fac$export$1155f7ba6d87aa87), argsData);
        if (!argsData.cancel) this.visibleRange = {
            min: argsData.minimum,
            max: argsData.maximum,
            interval: argsData.interval,
            delta: argsData.maximum - argsData.minimum
        };
    };
    /**
     * Calculate padding for the axis.
     *
     * @returns {string}
     * @private
     */ Axis.prototype.getRangePadding = function(chart) {
        var padding = this.rangePadding;
        if (padding !== "Auto") return padding;
        switch(this.orientation){
            case "Horizontal":
                if (chart.requireInvertedAxis) padding = this.isStack100 || this.baseModule.chart.stockChart ? "Round" : "Normal";
                else padding = "None";
                break;
            case "Vertical":
                if (!chart.requireInvertedAxis) padding = this.isStack100 || this.baseModule.chart.stockChart ? "Round" : "Normal";
                else padding = "None";
                break;
        }
        return padding;
    };
    /**
     * Calculate maximum label width for the axis.
     *
     * @param {Chart} chart - The chart for which to calculate the maximum label width.
     * @returns {void}
     * @private
     */ Axis.prototype.getMaxLabelWidth = function(chart) {
        var pointX;
        var previousEnd = 0;
        var isIntersect = false;
        var isAxisLabelBreak;
        this.angle = this.labelRotation;
        this.maxLabelSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
        var action = this.labelIntersectAction;
        var label;
        for(var i = 0, len = this.visibleLabels.length; i < len; i++){
            label = this.visibleLabels[i];
            isAxisLabelBreak = (0, $11815a21a80ae2b7$export$1930212191838fe4)(label.originalText);
            if (isAxisLabelBreak) {
                label.size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label.originalText.replace(/<br>/g, " "), this.labelStyle, chart.themeStyle.axisLabelFont);
                label.breakLabelSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.enableTrim ? label.text.join("<br>") : label.originalText, this.labelStyle, chart.themeStyle.axisLabelFont);
            } else if ((this.angle === -90 || this.angle === 90 || this.angle === 270 || this.angle === -270) && this.orientation === "Vertical") label.size = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(this.labelStyle, label.text, this.angle, chart, chart.themeStyle.axisLabelFont);
            else label.size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label.text, this.labelStyle, chart.themeStyle.axisLabelFont);
            var width = isAxisLabelBreak ? label.breakLabelSize.width : label.size.width;
            if (width > this.maxLabelSize.width) {
                this.maxLabelSize.width = width;
                this.rotatedLabel = label.text;
            }
            var height = isAxisLabelBreak ? label.breakLabelSize.height : label.size.height;
            if (height > this.maxLabelSize.height) this.maxLabelSize.height = height;
            if (isAxisLabelBreak) label.text = this.enableTrim ? label.text : label.originalText.split("<br>");
            if (action === "None" || action === "Hide" || action === "Trim") continue;
            if ((action !== "None" || this.angle % 360 === 0) && this.orientation === "Horizontal" && this.rect.width > 0 && !isIntersect) {
                var width1 = isAxisLabelBreak ? label.breakLabelSize.width : label.size.width;
                pointX = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(label.value, this) * this.rect.width + this.rect.x;
                pointX -= width1 / 2;
                if (this.edgeLabelPlacement === "Shift") {
                    if (i === 0 && pointX < this.rect.x) pointX = this.rect.x;
                    if (i === this.visibleLabels.length - 1 && pointX + width1 > this.rect.x + this.rect.width) pointX = this.rect.x + this.rect.width - width1;
                }
                switch(action){
                    case "MultipleRows":
                        if (i > 0) this.findMultiRows(i, pointX, label, isAxisLabelBreak);
                        break;
                    case "Rotate45":
                    case "Rotate90":
                        if (i > 0 && (!this.isAxisInverse ? pointX <= previousEnd : pointX + width1 >= previousEnd)) {
                            this.angle = action === "Rotate45" ? 45 : 90;
                            isIntersect = true;
                        }
                        break;
                    default:
                        if (isAxisLabelBreak) {
                            var result = void 0;
                            var result1 = [];
                            var str = void 0;
                            for(var index = 0; index < label.text.length; index++){
                                result = (0, $11815a21a80ae2b7$export$cd75915cb4ef7473)(label.text[index], this.rect.width / this.visibleLabels.length, this.labelStyle, chart.enableRtl, null, null, chart.themeStyle.axisLabelFont);
                                if (result.length > 1) for(var j = 0; j < result.length; j++){
                                    str = result[j];
                                    result1.push(str);
                                }
                                else result1.push(result[0]);
                            }
                            label.text = result1;
                        } else label.text = (0, $11815a21a80ae2b7$export$cd75915cb4ef7473)(label.text, this.rect.width / this.visibleLabels.length, this.labelStyle, chart.enableRtl, null, null, chart.themeStyle.axisLabelFont);
                        var height_1 = label.size.height * label.text.length;
                        if (height_1 > this.maxLabelSize.height) this.maxLabelSize.height = height_1;
                        break;
                }
                previousEnd = this.isAxisInverse ? pointX : pointX + width1;
            }
        }
        if (this.angle !== 0 && this.orientation === "Horizontal") {
            //I264474: Fix for datasource bind im mounted console error ocurred
            this.rotatedLabel = (0, $3EnZW.isNullOrUndefined)(this.rotatedLabel) ? "" : this.rotatedLabel;
            var isHorizontalAngle = this.angle === -360 || this.angle === 0 || this.angle === -180 || this.angle === 180 || this.angle === 360;
            // To avoid overlap axis label with chart title or chart legend when it is outside.
            if (this.labelPosition === "Outside" && !isHorizontalAngle && (0, $11815a21a80ae2b7$export$1930212191838fe4)(this.rotatedLabel)) this.maxLabelSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.maxLabelSize.height, this.maxLabelSize.width);
            else this.maxLabelSize = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(this.labelStyle, this.rotatedLabel, this.angle, chart, chart.themeStyle.axisLabelFont);
        } else if (this.angle !== 0 && this.orientation === "Vertical") {
            //I264474: Fix for datasource bind im mounted console error ocurred
            this.rotatedLabel = (0, $3EnZW.isNullOrUndefined)(this.rotatedLabel) ? "" : this.rotatedLabel;
            var isHorizontalAngle = this.angle === -360 || this.angle === 0 || this.angle === -180 || this.angle === 180 || this.angle === 360;
            // To avoid overlap axis label with chart title or chart legend when it is outside.
            if (this.labelPosition === "Outside" && !isHorizontalAngle && (0, $11815a21a80ae2b7$export$1930212191838fe4)(this.rotatedLabel)) this.maxLabelSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.maxLabelSize.height, this.maxLabelSize.width);
            else this.maxLabelSize = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(this.labelStyle, this.rotatedLabel, this.angle, chart, chart.themeStyle.axisLabelFont);
        }
        if (chart.multiLevelLabelModule && this.multiLevelLabels.length > 0) chart.multiLevelLabelModule.getMultilevelLabelsHeight(this);
    };
    /**
     * Finds the multiple rows for axis.
     *
     * @returns {void}
     */ Axis.prototype.findMultiRows = function(length, currentX, currentLabel, isBreakLabels) {
        var label;
        var pointX;
        var width2;
        var store = [];
        var isMultiRows;
        for(var i = length - 1; i >= 0; i--){
            label = this.visibleLabels[i];
            width2 = isBreakLabels ? label.breakLabelSize.width : label.size.width;
            pointX = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(label.value, this) * this.rect.width + this.rect.x;
            isMultiRows = !this.isAxisInverse ? currentX < pointX + width2 * 0.5 : currentX + currentLabel.size.width > pointX - width2 * 0.5;
            if (isMultiRows) {
                store.push(label.index);
                currentLabel.index = currentLabel.index > label.index ? currentLabel.index : label.index + 1;
            } else currentLabel.index = store.indexOf(label.index) > -1 ? currentLabel.index : label.index;
        }
        var height = (isBreakLabels ? currentLabel.breakLabelSize.height : currentLabel.size.height) * currentLabel.index + 5 * (currentLabel.index - 1);
        if (height > this.maxLabelSize.height) this.maxLabelSize.height = height;
    };
    /**
     * Finds the default module for axis.
     *
     * @returns {void}
     * @private
     */ Axis.prototype.getModule = function(chart) {
        if (this.valueType === "Double") this.baseModule = new (0, $5e1e0b5d807dfa70$export$340e583a64e26663)(chart);
        else this.baseModule = chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.valueType) + "Module"];
    };
    /**
     * Set the axis `opposedPosition` and `isInversed` properties.
     *
     * @param {boolean} isPolar - Indicates whether the axis is polar or not.
     * @returns {void}
     * @private
     */ Axis.prototype.setIsInversedAndOpposedPosition = function(isPolar) {
        if (isPolar === void 0) isPolar = false;
        this.isAxisOpposedPosition = this.opposedPosition || !isPolar && this.isRTLEnabled && this.orientation === "Vertical";
        if (this.opposedPosition && !isPolar && this.isRTLEnabled && this.orientation === "Vertical") this.isAxisOpposedPosition = false;
        this.isAxisInverse = this.isInversed || this.isRTLEnabled && this.orientation === "Horizontal";
        if (this.isInversed && !isPolar && this.isRTLEnabled && this.orientation === "Horizontal") this.isAxisInverse = false;
    };
    /**
     * Updates the axis within the chart.
     *
     * @returns {void}
     * @private
     */ Axis.prototype.updateAxis = function() {
        var chart = this.baseModule.chart;
        var chartAxisLayoutPanel = chart.chartAxisLayoutPanel;
        var index = chart.axisCollections.indexOf(this);
        var axisElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisInsideCollection");
        var axisLineElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisOutsideCollection");
        chartAxisLayoutPanel.element = chart.renderer.createGroup({
            id: chart.element.id + "AxisGroup" + index + "Inside"
        });
        var outsideElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisGroup" + index + "Outside"
        });
        var isInside = chartAxisLayoutPanel.findAxisPosition(this);
        chartAxisLayoutPanel.drawAxis(this, index, isInside, outsideElement, axisElement, axisLineElement);
        if (!chart.enableCanvas) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, axisElement, chartAxisLayoutPanel.element, chart.redraw);
    };
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: "12px",
            fontStyle: "Normal",
            fontWeight: "400",
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], Axis.prototype, "labelStyle", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$c5ce366f8107473b)
    ], Axis.prototype, "crosshairTooltip", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Axis.prototype, "title", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], Axis.prototype, "titleStyle", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Axis.prototype, "labelFormat", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Axis.prototype, "skeleton", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("DateTime")
    ], Axis.prototype, "skeletonType", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], Axis.prototype, "lineBreakAlignment", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "plotOffset", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "plotOffsetLeft", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "plotOffsetTop", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "plotOffsetRight", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "plotOffsetBottom", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Axis.prototype, "isIndexed", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], Axis.prototype, "logBase", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "columnIndex", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "rowIndex", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Axis.prototype, "span", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "desiredIntervals", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], Axis.prototype, "maximumLabels", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Axis.prototype, "zoomFactor", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "zoomPosition", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Axis.prototype, "enableScrollbarOnZooming", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Axis.prototype, "opposedPosition", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Axis.prototype, "enableAutoIntervalOnZooming", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], Axis.prototype, "rangePadding", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Double")
    ], Axis.prototype, "valueType", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Axis.prototype, "edgeLabelPlacement", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], Axis.prototype, "intervalType", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("BetweenTicks")
    ], Axis.prototype, "labelPlacement", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Outside")
    ], Axis.prototype, "tickPosition", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("Outside")
    ], Axis.prototype, "labelPosition", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Axis.prototype, "name", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Axis.prototype, "visible", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "minorTicksPerInterval", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "labelRotation", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "titleRotation", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "crossesAt", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Axis.prototype, "placeNextToAxisLine", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "crossesInAxis", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "minimum", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "maximum", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "interval", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(34)
    ], Axis.prototype, "maximumLabelWidth", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Axis.prototype, "enableTrim", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], Axis.prototype, "labelPadding", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], Axis.prototype, "titlePadding", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$e8bfb5a4d62ecff)
    ], Axis.prototype, "majorTickLines", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$79bf2c1495a8c00c)
    ], Axis.prototype, "minorTickLines", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$1bc3b102d489d993)
    ], Axis.prototype, "majorGridLines", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$4cd1fa87376d595a)
    ], Axis.prototype, "minorGridLines", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, $691dde0edd52f9f0$export$6b38ce563ca3e26b)
    ], Axis.prototype, "lineStyle", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)((0, $5q7BP.Browser).isDevice ? "Rotate45" : "Trim")
    ], Axis.prototype, "labelIntersectAction", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Axis.prototype, "isInversed", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(100)
    ], Axis.prototype, "coefficient", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Axis.prototype, "startAngle", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Axis.prototype, "startFromZero", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Axis.prototype, "description", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Property)(2)
    ], Axis.prototype, "tabIndex", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $7109450e102533b6$export$18935046c099a1f2))
    ], Axis.prototype, "stripLines", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $7109450e102533b6$export$ebf2b710e93882e4))
    ], Axis.prototype, "multiLevelLabels", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: 0,
            type: "Rectangle"
        }, (0, $7109450e102533b6$export$b11d60099392c19c))
    ], Axis.prototype, "border", void 0);
    $691dde0edd52f9f0$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7109450e102533b6$export$a91fff02467d5657))
    ], Axis.prototype, "scrollbarSettings", void 0);
    return Axis;
}((0, $3fcxu.ChildProperty));
/** @private */ var $691dde0edd52f9f0$export$b9a24df2ac045f1 = /** @class */ function() {
    function VisibleLabels(text, value, labelStyle, originalText, size, breakLabelSize, index) {
        if (size === void 0) size = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
        if (breakLabelSize === void 0) breakLabelSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
        if (index === void 0) index = 1;
        this.text = text;
        this.originalText = originalText;
        this.value = value;
        this.labelStyle = labelStyle;
        this.size = size;
        this.breakLabelSize = breakLabelSize;
        this.index = index;
    }
    return VisibleLabels;
}();




var $11815a21a80ae2b7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $11815a21a80ae2b7$export$97db5808d8f88186(data, fields, isDescending) {
    var sortData = (0, $3EnZW.extend)([], data, null);
    for(var i = 0; i < sortData.length; i++){
        for(var j = 0; j < fields.length; j++)if (sortData[i][fields[j]] instanceof Date) sortData[i][fields[j]] = sortData[i][fields[j]].getTime();
    }
    sortData.sort(function(a, b) {
        var first = 0;
        var second = 0;
        for(var i = 0; i < fields.length; i++){
            first += a[fields[i]];
            second += b[fields[i]];
        }
        if (!isDescending && first < second || isDescending && first > second) return -1;
        else if (first === second) return 0;
        return 1;
    });
    return sortData;
}
function $11815a21a80ae2b7$export$1930212191838fe4(label) {
    return label.indexOf("<br>") !== -1;
}
function $11815a21a80ae2b7$export$a38b34983c6f6ba1(series) {
    var points = (0, $3EnZW.extend)([], series.points, null, true);
    var tempPoints = [];
    var tempPoint;
    var pointIndex = 0;
    for(var i = 0; i < points.length; i++){
        tempPoint = points[i];
        if ((0, $3EnZW.isNullOrUndefined)(tempPoint.x)) continue;
        else {
            tempPoint.index = pointIndex++;
            tempPoints.push(tempPoint);
        }
    }
    return tempPoints;
}
function $11815a21a80ae2b7$export$70d1a4386da2e9e5(font, text, angle, chart, themeFontStyle) {
    var transformValue = chart.element.style.transform;
    if (transformValue) chart.element.style.transform = "";
    var renderer = new (0, $aa3074f243277ee7$export$5ff52eac0871021a)(chart.element.id);
    var labelText;
    var textCollection = [];
    var height;
    var dy;
    var label;
    var tspanElement;
    var options = {
        id: "rotate_text",
        x: chart.initialClipRect.x,
        y: chart.initialClipRect.y,
        "font-size": font.size || themeFontStyle.size,
        "font-style": font.fontStyle || themeFontStyle.fontStyle,
        "font-family": font.fontFamily,
        "font-weight": font.fontWeight || themeFontStyle.fontWeight,
        "transform": "rotate(" + angle + ", 0, 0)",
        "text-anchor": "middle"
    };
    if ($11815a21a80ae2b7$export$1930212191838fe4(text)) {
        textCollection = text.split("<br>");
        labelText = textCollection[0];
    } else labelText = text;
    var htmlObject = renderer.createText(options, labelText);
    if (!chart.delayRedraw && !chart.redraw && !chart.stockChart) chart.element.appendChild(chart.svgObject);
    // for line break label
    if (typeof textCollection !== "string" && textCollection.length > 1) for(var i = 1, len = textCollection.length; i < len; i++){
        height = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(textCollection[i], font, chart.themeStyle.axisLabelFont).height;
        dy = options.y + i * height;
        label = textCollection[i];
        tspanElement = renderer.createTSpan({
            "x": options.x,
            "id": options.id,
            "y": dy
        }, label);
        htmlObject.appendChild(tspanElement);
    }
    var axisSvgObject = chart.svgRenderer.createSvg({
        id: "AxisLabelMax_svg"
    });
    document.body.appendChild(axisSvgObject);
    axisSvgObject.appendChild(htmlObject);
    var box = htmlObject.getBoundingClientRect();
    if (transformValue) chart.element.style.transform = transformValue;
    (0, $4ZDHT.remove)(axisSvgObject);
    if (!chart.delayRedraw && !chart.redraw && !chart.stockChart && !chart.pointsAdded) (0, $4ZDHT.remove)(chart.svgObject);
    if (chart.enableCanvas) {
        var textWidth = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, font, chart.themeStyle.axisLabelFont).width;
        var textHeight = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, font, chart.themeStyle.axisLabelFont).height;
        var angleInRadians = angle * Math.PI / 180; // Convert the rotation angle to radians
        var rotatedTextWidth = Math.abs(Math.cos(angleInRadians) * textWidth) + Math.abs(Math.sin(angleInRadians) * textHeight);
        var rotatedTextHeight = Math.abs(Math.sin(angleInRadians) * textWidth) + Math.abs(Math.cos(angleInRadians) * textHeight);
        return new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(rotatedTextWidth, rotatedTextHeight);
    }
    return new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(box.right - box.left, box.bottom - box.top);
}
function $11815a21a80ae2b7$export$f883456a56996078(id) {
    if (!id) return null;
    var element = typeof id === "string" ? $11815a21a80ae2b7$export$d16800b7e59a8051(id) : id;
    if (element) (0, $4ZDHT.remove)(element);
}
function $11815a21a80ae2b7$export$2aa080c37938b627(value, base) {
    return Math.log(value) / Math.log(base);
}
function $11815a21a80ae2b7$export$dba11b50e1aa3c12(text, x, y, areaWidth, id, element, isTouch, isTitleOrLegendEnabled, bound) {
    //let id1: string = 'EJ2_legend_tooltip';
    var tooltip = document.getElementById(id);
    var size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, {
        fontFamily: "Segoe UI",
        size: "12px",
        fontStyle: "Normal",
        fontWeight: "Regular"
    });
    var width = size.width + 5;
    x = x + width > areaWidth ? x - (width + 15) : x;
    if (bound && x < bound.x) x = bound.x;
    y = isTitleOrLegendEnabled ? y - size.height / 2 : y + 15;
    if (!tooltip) {
        tooltip = (0, $4ZDHT.createElement)("div", {
            id: id,
            styles: "top:" + y.toString() + "px;left:" + (x + 15).toString() + "px;background-color: rgb(255, 255, 255) !important; color:black !important; " + "position:absolute;border:1px solid rgb(112, 112, 112); padding-left : 3px; padding-right : 2px;" + 'padding-bottom : 2px; padding-top : 2px; font-size:12px; font-family: "Segoe UI"'
        });
        tooltip.innerText = text;
        element.appendChild(tooltip);
        var left = parseInt(tooltip.style.left.replace("px", ""), 10);
        if (left < 0) tooltip.style.left = "0px";
    } else {
        tooltip.innerText = text;
        tooltip.style.top = y.toString() + "px";
        tooltip.style.left = (x + 15).toString() + "px";
    }
    if (isTouch) setTimeout(function() {
        $11815a21a80ae2b7$export$f883456a56996078(id);
    }, 1500);
}
function $11815a21a80ae2b7$export$245b06b49bc2b810(value, range) {
    return value < range.max && value > range.min;
}
function $11815a21a80ae2b7$export$ee35c16ea07b4b7f(value, range) {
    return value <= range.max && value >= range.min;
}
function $11815a21a80ae2b7$export$e4b998ae4102dcc2(value, axis) {
    return axis.valueType === "Logarithmic" ? $11815a21a80ae2b7$export$2aa080c37938b627(value, axis.logBase) : value;
}
function $11815a21a80ae2b7$export$812e0073c6ac0cb6(previousPoint, currentPoint, nextPoint, series) {
    if (series.chart.zoomModule && series.chart.zoomSettings.enableAnimation) return true;
    var mX2 = $11815a21a80ae2b7$export$e4b998ae4102dcc2(currentPoint.xValue, series.xAxis);
    var mX1 = previousPoint ? $11815a21a80ae2b7$export$e4b998ae4102dcc2(previousPoint.xValue, series.xAxis) : mX2;
    var mX3 = nextPoint ? $11815a21a80ae2b7$export$e4b998ae4102dcc2(nextPoint.xValue, series.xAxis) : mX2;
    var xStart = Math.floor(series.xAxis.visibleRange.min);
    var xEnd = Math.ceil(series.xAxis.visibleRange.max);
    return mX1 >= xStart && mX1 <= xEnd || mX2 >= xStart && mX2 <= xEnd || mX3 >= xStart && mX3 <= xEnd || xStart >= mX1 && xStart <= mX3;
}
function $11815a21a80ae2b7$export$8a63f25cc62965f1(values) {
    var sum = 0;
    for(var _i = 0, values_1 = values; _i < values_1.length; _i++){
        var value = values_1[_i];
        sum += value;
    }
    return sum;
}
function $11815a21a80ae2b7$export$5cc138fc7c1e350c(values, first, last, index, series) {
    var sum = 0;
    if (index !== null) {
        for(var i = first + 1; i < last; i++)if (index.indexOf(i) === -1) sum += values[i][series.yName];
    } else {
        for(var i = first + 1; i < last; i++)if (!(0, $3EnZW.isNullOrUndefined)(values[i][series.yName])) sum += values[i][series.yName];
    }
    return sum;
}
function $11815a21a80ae2b7$export$5c988984aa8de60d(rect, thickness) {
    rect.x += thickness.left;
    rect.y += thickness.top;
    rect.width -= thickness.left + thickness.right;
    rect.height -= thickness.top + thickness.bottom;
    return rect;
}
function $11815a21a80ae2b7$export$426b51932e4e74a8(rect, thickness) {
    rect.x += thickness.x;
    rect.y += thickness.y;
    rect.width -= thickness.x + thickness.width;
    rect.height -= thickness.y + thickness.height;
    return rect;
}
function $11815a21a80ae2b7$export$699d66646903a8d7(degree, radius, center) {
    var radian = degree * Math.PI / 180;
    return new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(Math.cos(radian) * radius + center.x, Math.sin(radian) * radius + center.y);
}
function $11815a21a80ae2b7$export$4f2c4f194778dcbb(degree) {
    return degree * (Math.PI / 180);
}
function $11815a21a80ae2b7$export$ca09d5b31a43d465(actualPoints, centerX, centerY, angle) {
    var coordinatesAfterRotation = [];
    for(var i = 0; i < 4; i++){
        var point = actualPoints[i];
        // translate point to origin
        var tempX = point.x - centerX;
        var tempY = point.y - centerY;
        // now apply rotation
        var rotatedX = tempX * Math.cos($11815a21a80ae2b7$export$4f2c4f194778dcbb(angle)) - tempY * Math.sin($11815a21a80ae2b7$export$4f2c4f194778dcbb(angle));
        var rotatedY = tempX * Math.sin($11815a21a80ae2b7$export$4f2c4f194778dcbb(angle)) + tempY * Math.cos($11815a21a80ae2b7$export$4f2c4f194778dcbb(angle));
        // translate back
        point.x = rotatedX + centerX;
        point.y = rotatedY + centerY;
        coordinatesAfterRotation.push(new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(point.x, point.y));
    }
    return coordinatesAfterRotation;
}
function $11815a21a80ae2b7$export$1ecdad0cdc9457ed(a, b) {
    var polygons = [
        a,
        b
    ];
    var minA;
    var maxA;
    var projected;
    var i;
    var i1;
    var j;
    var minB;
    var maxB;
    for(i = 0; i < polygons.length; i++){
        // for each polygon, look at each edge of the polygon, and determine if it separates
        // the two shapes
        var polygon = polygons[i];
        for(i1 = 0; i1 < polygon.length; i1++){
            // grab 2 vertices to create an edge
            var i2 = (i1 + 1) % polygon.length;
            var p1 = polygon[i1];
            var p2 = polygon[i2];
            // find the line perpendicular to this edge
            var normal = new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(p2.y - p1.y, p1.x - p2.x);
            minA = maxA = undefined;
            // for each vertex in the first shape, project it onto the line perpendicular to the edge
            // and keep track of the min and max of these values
            for(j = 0; j < a.length; j++){
                projected = normal.x * a[j].x + normal.y * a[j].y;
                if ((0, $3EnZW.isNullOrUndefined)(minA) || projected < minA) minA = projected;
                if ((0, $3EnZW.isNullOrUndefined)(maxA) || projected > maxA) maxA = projected;
            }
            // for each vertex in the second shape, project it onto the line perpendicular to the edge
            // and keep track of the min and max of these values
            minB = maxB = undefined;
            for(j = 0; j < b.length; j++){
                projected = normal.x * b[j].x + normal.y * b[j].y;
                if ((0, $3EnZW.isNullOrUndefined)(minB) || projected < minB) minB = projected;
                if ((0, $3EnZW.isNullOrUndefined)(maxB) || projected > maxB) maxB = projected;
            }
            // if there is no overlap between the projects, the edge we are looking at separates the two
            // polygons, and we know there is no overlap
            if (maxA < minB || maxB < minA) return false;
        }
    }
    return true;
}
/**
 * Generates the legend for accumulation chart.
 *
 * @param {number} locX - The x-coordinate of the legend position.
 * @param {number} locY - The y-coordinate of the legend position.
 * @param {number} r - The radius of the chart.
 * @param {number} height - The height of the legend.
 * @param {number} width - The width of the legend.
 * @returns {string} - The generated legend.
 */ function $11815a21a80ae2b7$var$getAccumulationLegend(locX, locY, r, height, width) {
    var cartesianlarge = $11815a21a80ae2b7$export$699d66646903a8d7(270, r, new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(locX, locY));
    var cartesiansmall = $11815a21a80ae2b7$export$699d66646903a8d7(270, r, new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(locX + width / 10, locY));
    return "M " + locX + " " + locY + " " + "L" + " " + (locX + r) + " " + locY + " " + "A" + " " + r + " " + r + " " + 0 + " " + 1 + " " + 1 + " " + cartesianlarge.x + " " + cartesianlarge.y + " " + "Z" + " " + "M" + " " + (locX + width / 10) + " " + (locY - height / 10) + " " + "L" + (locX + r) + " " + (locY - height / 10) + " " + "A" + " " + r + " " + r + " " + 0 + " " + 0 + " " + 0 + " " + cartesiansmall.x + " " + cartesiansmall.y + " " + "Z";
}
function $11815a21a80ae2b7$export$b363da9ded343252(center, point) {
    var angle = Math.atan2(point.y - center.y, point.x - center.x);
    angle = angle < 0 ? 6.283 + angle : angle;
    return angle * (180 / Math.PI);
}
function $11815a21a80ae2b7$export$ae151e2e9253af88(values, index) {
    var subArray = [];
    for(var i = 0; i <= index - 1; i++)subArray.push(values[i]);
    return subArray;
}
function $11815a21a80ae2b7$export$f83186674b8cab09(value, axis) {
    var range = axis.visibleRange;
    var result = (value - range.min) / range.delta;
    var isInverse = axis.isChart ? axis.isAxisInverse : axis.isInversed;
    return isInverse ? 1 - result : result;
}
function $11815a21a80ae2b7$export$1408f188e711568d(x, y, xAxis, yAxis, isInverted, series) {
    x = xAxis.valueType === "Logarithmic" ? $11815a21a80ae2b7$export$2aa080c37938b627(x > 1 ? x : 1, xAxis.logBase) : x;
    y = yAxis.valueType === "Logarithmic" ? $11815a21a80ae2b7$export$2aa080c37938b627(y > 1 ? y : 1, yAxis.logBase) : y;
    x += xAxis.valueType === "Category" && xAxis.labelPlacement === "BetweenTicks" && series.type !== "Radar" ? 0.5 : 0;
    var radius = series.chart.radius * $11815a21a80ae2b7$export$f83186674b8cab09(y, yAxis);
    var point = $11815a21a80ae2b7$export$c35b79e7cffe8e04($11815a21a80ae2b7$export$2a79ca78387ac323(x, xAxis), series.chart.primaryXAxis.startAngle);
    return {
        x: series.clipRect.width / 2 + series.clipRect.x + radius * point.x,
        y: series.clipRect.height / 2 + series.clipRect.y + radius * point.y
    };
}
function $11815a21a80ae2b7$export$838a848b241b0e52(id, isPoint) {
    if (isPoint === void 0) isPoint = false;
    var ids = [
        "NaN",
        "NaN"
    ];
    if (id.indexOf("_Point_") > -1) ids = id.split("_Series_")[1].split("_Point_");
    else if (id.indexOf("_shape_") > -1 && (!isPoint || isPoint && id.indexOf("_legend_") === -1)) {
        ids = id.split("_shape_");
        ids[0] = "0";
    } else if (id.indexOf("_text_") > -1 && (!isPoint || isPoint && id.indexOf("_legend_") === -1)) {
        ids = id.split("_text_");
        ids[0] = "0";
    }
    return new (0, $2ae44f835da15a47$export$cf17b003b6192af3)(parseInt(ids[0], 10), parseInt(ids[1], 10));
}
function $11815a21a80ae2b7$export$c35b79e7cffe8e04(coefficient, startAngle) {
    startAngle = startAngle < 0 ? startAngle + 360 : startAngle;
    var angle = Math.PI * (1.5 - 2 * coefficient);
    angle = angle + startAngle * Math.PI / 180;
    return {
        x: Math.cos(angle),
        y: Math.sin(angle)
    };
}
function $11815a21a80ae2b7$export$2a79ca78387ac323(value, axis) {
    var range = axis.visibleRange;
    var delta;
    var length;
    if (axis.valueType !== "Category") {
        delta = range.max - (axis.valueType === "DateTime" ? axis.dateTimeInterval : range.interval) - range.min;
        length = axis.visibleLabels.length - 1;
        delta = delta === 0 ? 1 : delta;
    } else {
        // To split an interval equally based on visible labels count
        delta = axis.visibleLabels.length === 1 ? 1 : axis.visibleLabels[axis.visibleLabels.length - 1].value - axis.visibleLabels[0].value;
        length = axis.visibleLabels.length;
    }
    return axis.isAxisInverse ? (value - range.min) / delta * (1 - 1 / length) : 1 - (value - range.min) / delta * (1 - 1 / length);
}
/** @private */ var $11815a21a80ae2b7$export$1c2d59c4b681fbd8 = /** @class */ function() {
    function Mean(verticalStandardMean, verticalSquareRoot, horizontalStandardMean, horizontalSquareRoot, verticalMean, horizontalMean) {
        this.verticalStandardMean = verticalStandardMean;
        this.horizontalStandardMean = horizontalStandardMean;
        this.verticalSquareRoot = verticalSquareRoot;
        this.horizontalSquareRoot = horizontalSquareRoot;
        this.verticalMean = verticalMean;
        this.horizontalMean = horizontalMean;
    }
    return Mean;
}();
/** @private */ var $11815a21a80ae2b7$export$bc8860e9007b882e = /** @class */ function() {
    function PolarArc(startAngle, endAngle, innerRadius, radius, currentXPosition) {
        this.startAngle = startAngle;
        this.endAngle = endAngle;
        this.innerRadius = innerRadius;
        this.radius = radius;
        this.currentXPosition = currentXPosition;
    }
    return PolarArc;
}();
function $11815a21a80ae2b7$export$c16a9a598ac2ae39(id, text, top, left, fontSize) {
    var tooltip = $11815a21a80ae2b7$export$d16800b7e59a8051(id);
    var style = "top:" + top.toString() + "px;" + "left:" + left.toString() + "px;" + "color:black !important; " + "background:#FFFFFF !important; " + "position:absolute;border:1px solid #707070;font-size:" + fontSize + ";border-radius:2px; z-index:1";
    if (!tooltip) {
        tooltip = (0, $4ZDHT.createElement)("div", {
            id: id,
            innerHTML: "&nbsp;" + text + "&nbsp;",
            styles: style
        });
        document.body.appendChild(tooltip);
    } else {
        tooltip.setAttribute("innerHTML", "&nbsp;" + text + "&nbsp;");
        tooltip.setAttribute("styles", style);
    }
}
function $11815a21a80ae2b7$export$2050bc1784e25c08(chart, axis, parent, index, isVertical, rect) {
    var margin = 5;
    var opposedPosition = axis.isAxisOpposedPosition;
    var anchor = chart.enableRtl ? "end" : isVertical ? "start" : "auto";
    var size;
    var chartRect = chart.availableSize.width;
    var pathElement;
    var x;
    var y;
    var rx = 3;
    var arrowLocation;
    var direction;
    var scrollBarHeight = axis.scrollbarSettings.enable || axis.zoomingScrollBar && axis.zoomingScrollBar.svgObject ? axis.scrollBarHeight : 0;
    var isRtlEnabled = chart.enableRtl && !isVertical && !axis.isInversed || axis.isInversed && !(chart.enableRtl && !isVertical);
    for(var i = 0; i < 2; i++){
        size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(i ? isRtlEnabled ? axis.startLabel : axis.endLabel : isRtlEnabled ? axis.endLabel : axis.startLabel, axis.labelStyle, chart.themeStyle.axisLabelFont);
        if (isVertical) {
            arrowLocation = i ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(rect.x - scrollBarHeight, rect.y + rx) : new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(axis.rect.x - scrollBarHeight, rect.y + rect.height - rx);
            x = rect.x + (opposedPosition ? rect.width + margin + scrollBarHeight : -(size.width + margin + margin + scrollBarHeight));
            y = rect.y + (i ? 0 : rect.height - size.height - margin);
            x += x < 0 || chartRect < x + size.width + margin ? opposedPosition ? -(size.width / 2) : size.width / 2 : 0;
            direction = $11815a21a80ae2b7$export$c791d5d8a216c099(rx, rx, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x, y, size.width + margin, size.height + margin), arrowLocation, margin, false, false, !opposedPosition, arrowLocation.x, arrowLocation.y + (i ? -rx : rx));
        } else {
            arrowLocation = i ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(rect.x + rect.width - rx, rect.y + rect.height + scrollBarHeight) : new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(rect.x + rx, rect.y + rect.height + scrollBarHeight);
            x = rect.x + (i ? rect.width - size.width - margin : 0);
            y = opposedPosition ? rect.y - size.height - 10 - scrollBarHeight : rect.y + rect.height + margin + scrollBarHeight;
            direction = $11815a21a80ae2b7$export$c791d5d8a216c099(rx, rx, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x, y, size.width + margin, size.height + margin), arrowLocation, margin, opposedPosition, !opposedPosition, false, arrowLocation.x + (i ? rx : -rx), arrowLocation.y);
        }
        x = x + margin / 2;
        y = y + 3 * (size.height / 4) + margin / 2;
        pathElement = chart.renderer.drawPath({
            "id": chart.element.id + "_Zoom_" + index + "_AxisLabel_Shape_" + i,
            "fill": chart.themeStyle.crosshairFill,
            "width": 2,
            "color": chart.themeStyle.crosshairFill,
            "opacity": 1,
            "stroke-dasharray": null,
            "d": direction
        }, null);
        parent.appendChild(pathElement);
        if (chart.theme === "Fluent" || chart.theme === "FluentDark") {
            var shadowId = chart.element.id + "_shadow";
            pathElement.setAttribute("filter", (0, $5q7BP.Browser).isIE ? "" : "url(#" + shadowId + ")");
            var shadow = '<filter id="' + shadowId + '" height="130%"><feGaussianBlur in="SourceAlpha" stdDeviation="3"/>';
            shadow += '<feOffset dx="3" dy="3" result="offsetblur"/><feComponentTransfer><feFuncA type="linear" slope="0.5"/>';
            shadow += '</feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter>';
            var defElement = chart.renderer.createDefs();
            defElement.setAttribute("id", chart.element.id + "SVG_tooltip_definition");
            parent.appendChild(defElement);
            defElement.innerHTML = shadow;
            pathElement.setAttribute("stroke", "#cccccc");
            pathElement.setAttribute("stroke-width", "0.5");
        }
        $11815a21a80ae2b7$export$a06ce713d4aea371(chart.renderer, new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(chart.element.id + "_Zoom_" + index + "_AxisLabel_" + i, x, y, anchor, i ? isRtlEnabled ? axis.startLabel : axis.endLabel : isRtlEnabled ? axis.endLabel : axis.startLabel), {
            color: chart.themeStyle.crosshairLabelFont.color,
            fontFamily: "Segoe UI",
            fontWeight: "Regular",
            size: "11px"
        }, chart.themeStyle.crosshairLabelFont.color, parent, null, null, null, null, null, null, null, null, null, null, chart.themeStyle.crosshairLabelFont);
    }
    return parent;
}
function $11815a21a80ae2b7$export$c791d5d8a216c099(rX, rY, rect, arrowLocation, arrowPadding, top, bottom, left, tipX, tipY) {
    var direction = "";
    var startX = rect.x;
    var startY = rect.y;
    var width = rect.x + rect.width;
    var height = rect.y + rect.height;
    if (top) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY);
        direction = direction.concat(" L " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + (startY + rY));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height);
        if (arrowPadding !== 0) {
            direction = direction.concat(" L " + (arrowLocation.x + arrowPadding / 2) + " " + height);
            direction = direction.concat(" L " + tipX + " " + (height + arrowPadding) + " L" + " " + (arrowLocation.x - arrowPadding / 2) + " " + height);
        }
        if (arrowLocation.x - arrowPadding / 2 > startX) direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
        else if (arrowPadding === 0) direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
        else direction = direction.concat(" L " + startX + " " + (height + rY) + " z");
    } else if (bottom) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY + " L" + " " + (arrowLocation.x - arrowPadding / 2) + " " + startY);
        direction = direction.concat(" L " + tipX + " " + arrowLocation.y);
        direction = direction.concat(" L " + (arrowLocation.x + arrowPadding / 2) + " " + startY);
        direction = direction.concat(" L " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + (startY + rY));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height);
        direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
    } else if (left) {
        direction = direction.concat("M " + startX + " " + (startY + rY) + " Q " + startX + " " + startY + " " + (startX + rX) + " " + startY);
        direction = direction.concat(" L " + (width - rX) + " " + startY + " Q " + width + " " + startY + " " + width + " " + (startY + rY) + " L" + " " + width + " " + (arrowLocation.y - arrowPadding / 2));
        direction = direction.concat(" L " + (width + arrowPadding) + " " + tipY);
        direction = direction.concat(" L " + width + " " + (arrowLocation.y + arrowPadding / 2));
        direction = direction.concat(" L " + width + " " + (height - rY) + " Q " + width + " " + height + " " + (width - rX) + " " + height);
        direction = direction.concat(" L " + (startX + rX) + " " + height + " Q " + startX + " " + height + " " + startX + " " + (height - rY) + " z");
    } else {
        direction = direction.concat("M " + (startX + rX) + " " + startY + " Q " + startX + " " + startY + " " + startX + " " + (startY + rY) + " L" + " " + startX + " " + (arrowLocation.y - arrowPadding / 2));
        direction = direction.concat(" L " + (startX - arrowPadding) + " " + tipY);
        direction = direction.concat(" L " + startX + " " + (arrowLocation.y + arrowPadding / 2));
        direction = direction.concat(" L " + startX + " " + (height - rY) + " Q " + startX + " " + height + " " + (startX + rX) + " " + height);
        direction = direction.concat(" L " + (width - rX) + " " + height + " Q " + width + " " + height + " " + width + " " + (height - rY));
        direction = direction.concat(" L " + width + " " + (startY + rY) + " Q " + width + " " + startY + " " + (width - rX) + " " + startY + " z");
    }
    return direction;
}
function $11815a21a80ae2b7$export$2b0fe4f3565d7670(x, y, bounds, width, height) {
    if (width === void 0) width = 0;
    if (height === void 0) height = 0;
    return x >= bounds.x - width && x <= bounds.x + bounds.width + width && y >= bounds.y - height && y <= bounds.y + bounds.height + height;
}
function $11815a21a80ae2b7$export$4e11abe7cdeb4cc9(value, size, axis) {
    var actualValue = !axis.isAxisInverse ? value / size : 1 - value / size;
    return actualValue * axis.visibleRange.delta + axis.visibleRange.min;
}
function $11815a21a80ae2b7$export$bb7437ba7758bec8(value, size, axis) {
    var actualValue = axis.isAxisInverse ? value / size : 1 - value / size;
    return actualValue * axis.visibleRange.delta + axis.visibleRange.min;
}
function $11815a21a80ae2b7$export$eb71090255ea483d(series, isCanvas) {
    if (isCanvas === void 0) isCanvas = false;
    var rect = series.clipRect;
    if (isCanvas && (series.type === "Polar" || series.type === "Radar")) {
        if (series.drawType === "Scatter") {
            rect.x = series.xAxis.rect.x;
            rect.y = series.yAxis.rect.y;
            rect.width = series.xAxis.rect.width;
            rect.height = series.yAxis.rect.height;
        } else {
            rect.x = series.xAxis.rect.x / 2;
            rect.y = series.yAxis.rect.y / 2;
            rect.width = series.xAxis.rect.width;
            rect.height = series.yAxis.rect.height;
        }
    } else if (series.chart.requireInvertedAxis) {
        rect.x = series.yAxis.rect.x;
        rect.y = series.xAxis.rect.y;
        rect.width = series.yAxis.rect.width;
        rect.height = series.xAxis.rect.height;
    } else {
        rect.x = series.xAxis.rect.x;
        rect.y = series.yAxis.rect.y;
        rect.width = series.xAxis.rect.width;
        rect.height = series.yAxis.rect.height;
    }
}
function $11815a21a80ae2b7$export$d238e91bd4ec1248(str) {
    return str.substr(0, 1).toLowerCase() + str.substr(1);
}
function $11815a21a80ae2b7$export$fce0c6cfca85ed96(xAxis, yAxis, invertedAxis) {
    var x;
    var y;
    var width;
    var height;
    if (invertedAxis) {
        x = yAxis.rect.x;
        y = xAxis.rect.y;
        width = yAxis.rect.width;
        height = xAxis.rect.height;
    } else {
        x = xAxis.rect.x;
        y = yAxis.rect.y;
        width = xAxis.rect.width;
        height = yAxis.rect.height;
    }
    return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x, y, width, height);
}
function $11815a21a80ae2b7$export$c50b663dcfb9c16f(axis, seriesCollection) {
    var minDelta = Number.MAX_VALUE;
    var xValues;
    var minVal;
    var seriesMin;
    var stackingGroups = [];
    for(var index = 0; index < seriesCollection.length; index++){
        var series = seriesCollection[index];
        xValues = [];
        if (series.visible && (axis.name === series.xAxisName || axis.name === "primaryXAxis" && series.xAxisName === null || axis.name === series.chart.primaryXAxis.name && !series.xAxisName)) {
            if (series.type.indexOf("Stacking") > -1 && stackingGroups.indexOf(series.stackingGroup) === -1) stackingGroups.push(series.stackingGroup);
            xValues = series.points.map(function(point) {
                return point.xValue;
            });
            xValues.sort(function(first, second) {
                return first - second;
            });
            if (xValues.length === 1) {
                var timeOffset = seriesCollection.length === 1 ? 25920000 : 2592000000;
                seriesMin = axis.valueType === "DateTime" && series.xMin === series.xMax ? series.xMin - timeOffset : series.xMin;
                minVal = xValues[0] - (!(0, $3EnZW.isNullOrUndefined)(seriesMin) ? seriesMin : axis.visibleRange.min);
                if (minVal !== 0) minDelta = Math.min(minDelta, minVal);
            } else for(var index_1 = 0; index_1 < xValues.length; index_1++){
                var value = xValues[index_1];
                if (index_1 > 0 && value) {
                    minVal = series.type.indexOf("Stacking") > -1 && axis.valueType === "Category" ? stackingGroups.length : value - xValues[index_1 - 1];
                    if (minVal !== 0) minDelta = Math.min(minDelta, minVal);
                }
            }
        }
    }
    if (minDelta === Number.MAX_VALUE) minDelta = 1;
    return minDelta;
}
function $11815a21a80ae2b7$export$622b8dea40f28ece(effect) {
    var functionName;
    switch(effect){
        case "Linear":
            functionName = $11815a21a80ae2b7$export$45db2fc2f15997e7;
            break;
    }
    return functionName;
}
function $11815a21a80ae2b7$export$45db2fc2f15997e7(currentTime, startValue, endValue, duration) {
    return -endValue * Math.cos(currentTime / duration * (Math.PI / 2)) + endValue + startValue;
}
function $11815a21a80ae2b7$export$9546e7ee31d90feb(element, delay, duration, series, pointIndex, point, isLabel) {
    element.style.visibility = "hidden";
    var transform = element.getAttribute("transform");
    new (0, $kj1BR.Animation)({}).animate(element, {
        duration: duration,
        delay: delay,
        progress: function(args) {
            if (args.timeStamp > args.delay) args.element.style.visibility = "visible";
        },
        end: function() {
            var annotations = document.getElementById(series.chart.element.id + "_Annotation_Collections");
            if (annotations && series.type !== "Line") annotations.style.visibility = "visible";
            element.style.visibility = "";
            element.setAttribute("transform", transform ? transform : "");
            if ((series.type === "Scatter" || series.type === "Bubble") && !isLabel && pointIndex === series.points.length - 1) series.chart.trigger("animationComplete", {
                series: series.chart.isBlazor ? {} : series
            });
        }
    });
}
function $11815a21a80ae2b7$export$df3d92c7b7b7c83f(element, delay, duration, currentRect, previousRect) {
    var setStyle = function(rect) {
        element.setAttribute("x", rect.x + "");
        element.setAttribute("y", rect.y + "");
        element.setAttribute("width", rect.width + "");
        element.setAttribute("height", rect.height + "");
    };
    new (0, $kj1BR.Animation)({}).animate((0, $4ZDHT.createElement)("div"), {
        duration: duration,
        delay: delay,
        //name: name,
        progress: function(args) {
            setStyle(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)($11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousRect.x, currentRect.x - previousRect.x, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousRect.y, currentRect.y - previousRect.y, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousRect.width, currentRect.width - previousRect.width, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousRect.height, currentRect.height - previousRect.height, args.duration)));
        },
        end: function() {
            setStyle(currentRect);
        }
    });
}
function $11815a21a80ae2b7$export$55386e7bcaf82653(element, direction, redraw, previousDirection, animateDuration) {
    if (!redraw || !previousDirection && !element) return null;
    var duration = 300;
    if (!(0, $3EnZW.isNullOrUndefined)(animateDuration)) duration = animateDuration;
    var startDirections = previousDirection || element.getAttribute("d");
    var splitDirections = startDirections.split(/(?=[LMCZAQ])/);
    var endDirections = direction.split(/(?=[LMCZAQ])/);
    var currentDireciton;
    var startPath = [];
    var endPath = [];
    var c;
    var end;
    element.setAttribute("d", startDirections);
    new (0, $kj1BR.Animation)({}).animate((0, $4ZDHT.createElement)("div"), {
        duration: duration,
        progress: function(args) {
            currentDireciton = "";
            splitDirections.map(function(directions, index) {
                startPath = directions.split(" ");
                endPath = endDirections[index] ? endDirections[index].split(" ") : startPath;
                if (startPath[0] === "Z") currentDireciton += "Z ";
                else if (startPath[0] === "") currentDireciton = "";
                else currentDireciton += startPath[0] + " " + $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[1], +endPath[1] - +startPath[1], args.duration) + " " + $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[2], +endPath[2] - +startPath[2], args.duration) + " ";
                if (startPath[0] === "C" || startPath[0] === "Q") {
                    c = 3;
                    end = startPath[0] === "Q" ? 4 : 6;
                    while(c < end){
                        currentDireciton += $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[c], +endPath[c] - +startPath[c], args.duration) + " " + $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[++c], +endPath[c] - +startPath[c], args.duration) + " ";
                        ++c;
                    }
                }
                if (startPath[0] === "A") currentDireciton += "0 0 1 " + $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[6], +endPath[6] - +startPath[6], args.duration) + " " + $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, +startPath[7], +endPath[7] - +startPath[7], args.duration) + " ";
            });
            element.setAttribute("d", currentDireciton);
        },
        end: function() {
            element.setAttribute("d", direction);
        }
    });
}
function $11815a21a80ae2b7$export$6831629c0ce976ff(element, direction, redraw, previousDirection, animateDuration, removeDirection) {
    if (!redraw || !previousDirection && !element) return null;
    var duration = 300;
    if (!(0, $3EnZW.isNullOrUndefined)(animateDuration)) duration = animateDuration;
    var startDirections = previousDirection || element.getAttribute("d");
    var endDirections = direction;
    var currentDirection = "";
    element.setAttribute("d", startDirections);
    new (0, $kj1BR.Animation)({}).animate((0, $4ZDHT.createElement)("div"), {
        duration: duration,
        progress: function(args) {
            currentDirection = "";
            var startPathCommands = startDirections.match(/[MLHVCSQTAZ][^MLHVCSQTAZ]*/g);
            var endPathCommands = endDirections.match(/[MLHVCSQTAZ][^MLHVCSQTAZ]*/g);
            var maxLength = Math.max(startPathCommands.length, endPathCommands.length);
            for(var i = 0; i < maxLength; i++){
                var startPathCommand = startPathCommands[i] || "";
                var endPathCommand = endPathCommands[i] || "";
                var startCoords = startPathCommand.trim().split(/\s+/);
                var endCoords = endPathCommand.trim().split(/\s+/);
                var interpolatedCoords = [];
                for(var j = 1; j < startCoords.length; j++){
                    var startCoord = parseFloat(startCoords[j]);
                    var endCoord = parseFloat(endCoords[j]);
                    if (!isNaN(startCoord) && !isNaN(endCoord) && startCoords.length === endCoords.length) {
                        var interpolatedValue = $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, startCoord, endCoord - startCoord, duration);
                        if (i === maxLength - 1) interpolatedCoords.push(interpolatedValue);
                        else interpolatedCoords.push(interpolatedValue);
                    }
                }
                if (startCoords.length !== endCoords.length) currentDirection += "L";
                else currentDirection += startCoords[0];
                currentDirection += " " + interpolatedCoords.join(" ");
                currentDirection += " ";
            }
            element.setAttribute("d", currentDirection);
        },
        end: function() {
            element.setAttribute("d", removeDirection || direction);
        }
    });
}
function $11815a21a80ae2b7$export$c7ca2732e2882d39(redraw, options, renderer, clipPath) {
    if (clipPath === void 0) clipPath = "drawClipPath";
    var clipElement = $11815a21a80ae2b7$export$8b065989b2d63753(redraw, options.id, options, renderer);
    if (clipElement) {
        var def = renderer.createDefs();
        def.appendChild(clipElement);
        return def;
    } else return renderer[clipPath](options);
}
function $11815a21a80ae2b7$export$3354c8a0fc977929(chart, tempInterval, text, labelStyle, axis) {
    var argsData = {
        cancel: false,
        name: (0, $9415fc5f023d8fac$export$e632e6555cc607e4),
        axis: axis,
        text: text,
        value: tempInterval,
        labelStyle: labelStyle
    };
    chart.trigger((0, $9415fc5f023d8fac$export$e632e6555cc607e4), argsData);
    if (!argsData.cancel) {
        var isLineBreakLabels = argsData.text.indexOf("<br>") !== -1;
        var text_1 = axis.enableTrim ? isLineBreakLabels ? $11815a21a80ae2b7$export$da2951920eb3f191(axis.maximumLabelWidth, argsData.text, axis.labelStyle, chart.themeStyle.axisLabelFont) : $11815a21a80ae2b7$export$fb7a751b3bd7efd3(axis.maximumLabelWidth, argsData.text, axis.labelStyle, chart.enableRtl, chart.themeStyle.axisLabelFont) : argsData.text;
        axis.visibleLabels.push(new (0, $691dde0edd52f9f0$export$b9a24df2ac045f1)(text_1, argsData.value, argsData.labelStyle, argsData.text));
    }
}
function $11815a21a80ae2b7$export$9644c4f5061d3b67(axis) {
    return axis.minimum != null && axis.maximum != null;
}
function $11815a21a80ae2b7$export$a34692dfee195c82(axis) {
    return axis.zoomFactor < 1 && axis.zoomPosition >= 0;
}
function $11815a21a80ae2b7$export$4e4203e7203e8f7b(availableSize, axis) {
    var size = axis.orientation === "Horizontal" ? availableSize.width : availableSize.height;
    if ((0, $3EnZW.isNullOrUndefined)(axis.desiredIntervals)) {
        var desiredIntervalsCount = (axis.orientation === "Horizontal" ? 0.533 : 1) * axis.maximumLabels;
        desiredIntervalsCount = Math.max(size * (desiredIntervalsCount / 100), 1);
        return desiredIntervalsCount;
    } else return axis.desiredIntervals;
}
function $11815a21a80ae2b7$export$99679b46ac0f2167(element, delay, duration, name, isRemove) {
    new (0, $kj1BR.Animation)({}).animate(element, {
        duration: duration,
        delay: delay,
        name: name,
        progress: function(args) {
            args.element.style.visibility = "visible";
        },
        end: function(args) {
            if (isRemove) (0, $4ZDHT.remove)(args.element);
            else args.element.style.visibility = "visible";
        }
    });
}
function $11815a21a80ae2b7$export$49ec94bba13b5c07(location, shape, size, url, options, label, renderer, clipRect, isChartControl, control) {
    var chartRenderer = renderer ? renderer : new (0, $aa3074f243277ee7$export$5ff52eac0871021a)("");
    var shapeOption = $11815a21a80ae2b7$export$4dc1a8917bf18661(location, size, shape, options, url, isChartControl, control);
    var drawElement = chartRenderer["draw" + shapeOption.functionName](shapeOption.renderOption, clipRect ? new Int32Array([
        clipRect.x,
        clipRect.y
    ]) : null);
    //drawElement.setAttribute('aria-label', label);
    return drawElement;
}
function $11815a21a80ae2b7$export$4dc1a8917bf18661(location, size, shape, options, url, isChart, control) {
    var dir;
    var functionName = "Path";
    var isBulletChart = isChart;
    var width = isBulletChart && shape === "Circle" ? size.width - 2 : size.width;
    var height = isBulletChart && shape === "Circle" ? size.height - 2 : size.height;
    var sizeBullet = isBulletChart ? control.targetWidth : 0;
    var lx = location.x;
    var ly = location.y;
    var y = location.y + -height / 2;
    var x = location.x + -width / 2;
    var eq = 72;
    var xVal;
    var yVal;
    switch(shape){
        case "Bubble":
        case "Circle":
            functionName = "Ellipse";
            (0, $3EnZW.merge)(options, {
                "rx": width / 2,
                "ry": height / 2,
                "cx": lx,
                "cy": ly
            });
            break;
        case "Plus":
            dir = "M " + x + " " + ly + " " + "L" + " " + (lx + width / 2) + " " + ly + " " + "M" + " " + lx + " " + (ly + height / 2) + " " + "L" + " " + lx + " " + (ly + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Cross":
            dir = "M " + x + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + "M" + " " + x + " " + (ly + height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Multiply":
            dir = "M " + (lx - sizeBullet) + " " + (ly - sizeBullet) + " L " + (lx + sizeBullet) + " " + (ly + sizeBullet) + " M " + (lx - sizeBullet) + " " + (ly + sizeBullet) + " L " + (lx + sizeBullet) + " " + (ly - sizeBullet);
            (0, $3EnZW.merge)(options, {
                "d": dir,
                stroke: options.fill
            });
            break;
        case "HorizontalLine":
            dir = "M " + x + " " + ly + " " + "L" + " " + (lx + width / 2) + " " + ly;
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "VerticalLine":
            dir = "M " + lx + " " + (ly + height / 2) + " " + "L" + " " + lx + " " + (ly + -height / 2);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Diamond":
            dir = "M " + x + " " + ly + " " + "L" + " " + lx + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + ly + " " + "L" + " " + lx + " " + (ly + height / 2) + " " + "L" + " " + x + " " + ly + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "ActualRect":
            dir = "M " + x + " " + (ly + -height / 8) + " " + "L" + " " + (lx + sizeBullet) + " " + (ly + -height / 8) + " " + "L" + " " + (lx + sizeBullet) + " " + (ly + height / 8) + " " + "L" + " " + x + " " + (ly + height / 8) + " " + "L" + " " + x + " " + (ly + -height / 8) + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "TargetRect":
            dir = "M " + (x + sizeBullet) + " " + (ly + -height / 2) + " " + "L" + " " + (lx + sizeBullet / 2) + " " + (ly + -height / 2) + " " + "L" + " " + (lx + sizeBullet / 2) + " " + (ly + height / 2) + " " + "L" + " " + (x + sizeBullet) + " " + (ly + height / 2) + " " + "L" + " " + (x + sizeBullet) + " " + (ly + -height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Rectangle":
        case "Hilo":
        case "HiloOpenClose":
        case "Candle":
        case "Waterfall":
        case "BoxAndWhisker":
        case "StepArea":
        case "RangeStepArea":
        case "StackingStepArea":
        case "Square":
        case "Flag":
            dir = "M " + x + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + "L" + " " + x + " " + (ly + height / 2) + " " + "L" + " " + x + " " + (ly + -height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Pyramid":
        case "Triangle":
            dir = "M " + x + " " + (ly + height / 2) + " " + "L" + " " + lx + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + "L" + " " + x + " " + (ly + height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Funnel":
        case "InvertedTriangle":
            dir = "M " + (lx + width / 2) + " " + (ly - height / 2) + " " + "L" + " " + lx + " " + (ly + height / 2) + " " + "L" + " " + (lx - width / 2) + " " + (ly - height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly - height / 2) + " z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Pentagon":
            for(var i = 0; i <= 5; i++){
                xVal = width / 2 * Math.cos(Math.PI / 180 * (i * eq));
                yVal = height / 2 * Math.sin(Math.PI / 180 * (i * eq));
                if (i === 0) dir = "M " + (lx + xVal) + " " + (ly + yVal) + " ";
                else dir = dir.concat("L " + (lx + xVal) + " " + (ly + yVal) + " ");
            }
            dir = dir.concat("Z");
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Image":
            functionName = "Image";
            (0, $3EnZW.merge)(options, {
                "href": url,
                "height": height,
                "width": width,
                x: x,
                y: y
            });
            break;
        case "Star":
            var cornerPoints = 5;
            var outerRadius = Math.min(width, height) / 2;
            var innerRadius = outerRadius / 2;
            var angle = Math.PI / cornerPoints;
            var starPath = "";
            for(var i = 0; i < 2 * cornerPoints; i++){
                var radius = i % 2 === 0 ? outerRadius : innerRadius;
                var currentX = lx + radius * Math.cos(i * angle - Math.PI / 2);
                var currentY = ly + radius * Math.sin(i * angle - Math.PI / 2);
                starPath += (i === 0 ? "M" : "L") + currentX + "," + currentY;
            }
            starPath += "Z";
            (0, $3EnZW.merge)(options, {
                "d": starPath
            });
            break;
    }
    options = $11815a21a80ae2b7$export$717a3a0101b6ed6a(location, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(width, height), shape, options).renderOption;
    return {
        renderOption: options,
        functionName: functionName
    };
}
function $11815a21a80ae2b7$export$f3af7121955b87fd(startLocation, endLocation, outerRect) {
    var x = endLocation.x < outerRect.x ? outerRect.x : endLocation.x > outerRect.x + outerRect.width ? outerRect.x + outerRect.width : endLocation.x;
    var y = endLocation.y < outerRect.y ? outerRect.y : endLocation.y > outerRect.y + outerRect.height ? outerRect.y + outerRect.height : endLocation.y;
    return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x > startLocation.x ? startLocation.x : x, y > startLocation.y ? startLocation.y : y, Math.abs(x - startLocation.x), Math.abs(y - startLocation.y));
}
function $11815a21a80ae2b7$export$6fb785c609d82593(value, min, max) {
    return value > max ? max : value < min ? min : value;
}
function $11815a21a80ae2b7$export$d16800b7e59a8051(id) {
    return document.getElementById(id);
}
function $11815a21a80ae2b7$export$f0a47b3df9b5c9d(template) {
    var templateFn = null;
    try {
        if (typeof template !== "function" && document.querySelectorAll(template).length) templateFn = (0, $c2qqN.compile)(document.querySelector(template).innerHTML.trim());
        else templateFn = (0, $c2qqN.compile)(template);
    } catch (e) {
        templateFn = (0, $c2qqN.compile)(template);
    }
    return templateFn;
}
function $11815a21a80ae2b7$export$5e1859bf1c040c6(childElement, chart, isTemplate, points, argsData, point, datalabelGroup, id, dataLabel, redraw) {
    var clientRect = childElement.getBoundingClientRect();
    chart.accumulationDataLabelModule.calculateLabelSize(isTemplate, childElement, point, points, argsData, datalabelGroup, id, dataLabel, redraw, clientRect, true);
}
function $11815a21a80ae2b7$export$eb5f67ae13948fb(childElement, chart, point, series, labelIndex, redraw) {
    var parentElement = document.getElementById(chart.element.id + "_Series_" + (series.index === undefined ? series.category : series.index) + "_DataLabelCollections");
    if (parentElement) {
        if (point.index === 0) chart.dataLabelCollections = []; // clear old datalabel bounds for react callback
        chart.dataLabelModule.calculateTemplateLabelSize(parentElement, childElement, point, series, series.marker.dataLabel, labelIndex, series.clipRect, redraw, true);
    }
}
function $11815a21a80ae2b7$export$7b7ae612b60e1630(childElement, pointIndex, content, chart, point, series, dataLabelId, labelIndex, argsData, isTemplate, points, datalabelGroup, id, dataLabel, redraw) {
    var templateFn = $11815a21a80ae2b7$export$f0a47b3df9b5c9d(content);
    var templateElement;
    try {
        var blazor = "Blazor";
        var tempObject = window[blazor] ? dataLabelId ? point : {
            point: point
        } : {
            chart: chart,
            series: series,
            point: point
        };
        var templateId = dataLabelId ? dataLabelId + "_template" : "template";
        var elementData = templateFn ? templateFn(tempObject, chart, templateId, dataLabelId || childElement.id.replace(/[^a-zA-Z0-9]/g, "")) : [];
        if (elementData.length) {
            templateElement = Array.prototype.slice.call(elementData);
            var len = templateElement.length;
            for(var i = 0; i < len; i++)childElement.appendChild(templateElement[i]);
        }
        var reactCallback = void 0;
        if (chart.getModuleName() === "accumulationchart") {
            reactCallback = $11815a21a80ae2b7$export$5e1859bf1c040c6.bind(this, childElement, chart, isTemplate, points, argsData, points[pointIndex], datalabelGroup, id, dataLabel, redraw);
            if (chart.isReact) chart.renderReactTemplates(reactCallback);
        } else if (chart.getModuleName() === "chart") {
            reactCallback = point && series ? $11815a21a80ae2b7$export$eb5f67ae13948fb.bind(this, childElement, chart, point, series, labelIndex, redraw) : reactCallback;
            if (chart.isReact) chart.renderReactTemplates(reactCallback);
        }
    } catch (e) {
        return childElement;
    }
    return childElement;
}
function $11815a21a80ae2b7$export$ca3136ef47261d85(font, themeFontStyle) {
    var style = "";
    style = "font-size:" + (font.size || themeFontStyle.size) + "; font-style:" + (font.fontStyle || themeFontStyle.fontStyle) + "; font-weight:" + (font.fontWeight || themeFontStyle.fontWeight) + "; font-family:" + font.fontFamily + ";opacity:" + font.opacity + "; color:" + font.color + ";";
    return style;
}
function $11815a21a80ae2b7$export$29256cccc5181fff(element, redraw, isReactCallback) {
    if (redraw === void 0) redraw = false;
    if (!isReactCallback) document.body.appendChild(element);
    var bounds = element.getBoundingClientRect();
    if (redraw) (0, $4ZDHT.remove)(element);
    else if (!isReactCallback) $11815a21a80ae2b7$export$f883456a56996078(element.id);
    return bounds;
}
function $11815a21a80ae2b7$export$ab9141129abf58a5(elements, id) {
    var element;
    for(var i = 0, length_1 = elements.length; i < length_1; i++)if (elements[i].id.indexOf(id) > -1) {
        element = elements[i];
        continue;
    }
    return element;
}
function $11815a21a80ae2b7$export$92d53b972f97f55a(x, y, xAxis, yAxis, isInverted) {
    x = xAxis.valueType === "Logarithmic" ? $11815a21a80ae2b7$export$2aa080c37938b627(x > 0 ? x : Math.pow(xAxis.logBase, xAxis.visibleRange.min), xAxis.logBase) : x;
    y = yAxis.valueType === "Logarithmic" ? $11815a21a80ae2b7$export$2aa080c37938b627(y > 0 ? y : Math.pow(yAxis.logBase, yAxis.visibleRange.min), yAxis.logBase) : y;
    x = $11815a21a80ae2b7$export$f83186674b8cab09(x, xAxis);
    y = $11815a21a80ae2b7$export$f83186674b8cab09(y, yAxis);
    var xLength = isInverted ? xAxis.rect.height : xAxis.rect.width;
    var yLength = isInverted ? yAxis.rect.width : yAxis.rect.height;
    var locationX = isInverted ? y * yLength : x * xLength;
    var locationY = isInverted ? (1 - x) * xLength : (1 - y) * yLength;
    return new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(locationX, locationY);
}
function $11815a21a80ae2b7$export$33e13bbfe889ab45(child, parent, redraw, animate, x, y, duration) {
    if (redraw === void 0) redraw = false;
    if (animate === void 0) animate = false;
    if (x === void 0) x = "x";
    if (y === void 0) y = "y";
    if (child && child.hasChildNodes() && parent) $11815a21a80ae2b7$export$a63bfedb1bdc5984(false, parent, child, redraw, animate, x, y, undefined, undefined, undefined, undefined, undefined, duration);
    else return null;
}
function $11815a21a80ae2b7$export$a63bfedb1bdc5984(isCanvas, parent, childElement, redraw, isAnimate, x, y, start, direction, forceAnimate, isRect, previousRect, animateDuration, scatterElement, angle, currentTransform, previousTranslate) {
    if (isAnimate === void 0) isAnimate = false;
    if (x === void 0) x = "x";
    if (y === void 0) y = "y";
    if (forceAnimate === void 0) forceAnimate = false;
    if (isRect === void 0) isRect = false;
    if (previousRect === void 0) previousRect = null;
    if (scatterElement === void 0) scatterElement = false;
    if (angle === void 0) angle = 0;
    if (isCanvas) return null;
    var existChild = scatterElement ? null : parent.querySelector("#" + childElement.id);
    var element = existChild || $11815a21a80ae2b7$export$d16800b7e59a8051(childElement.id);
    var child = childElement;
    var duration = !(0, $3EnZW.isNullOrUndefined)(animateDuration) ? animateDuration : 300;
    if (redraw && isAnimate && element) {
        start = start || (element.tagName === "DIV" ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(+element.style[x].split("px")[0], +element.style[y].split("px")[0]) : new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(+element.getAttribute(x), +element.getAttribute(y)));
        if (direction && direction !== "undefined") $11815a21a80ae2b7$export$55386e7bcaf82653(childElement, childElement.getAttribute("d"), redraw, direction, duration);
        else if (isRect && previousRect) $11815a21a80ae2b7$export$df3d92c7b7b7c83f(child, 0, duration, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(+element.getAttribute("x"), +element.getAttribute("y"), +element.getAttribute("width"), +element.getAttribute("height")), previousRect);
        else {
            var end = child.tagName === "DIV" ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(+child.style[x].split("px")[0], +child.style[y].split("px")[0]) : new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(+child.getAttribute(x), +child.getAttribute(y));
            var previousTranform = element.getAttribute("transform");
            $11815a21a80ae2b7$export$473faaca3d2ec308(child, duration, start, end, x, y, angle, currentTransform, previousTranslate !== undefined ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(previousTranslate.match(/\d+/g).map(Number)[0], previousTranslate.match(/\d+/g).map(Number)[1]) : previousTranform ? new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(parseFloat(previousTranform.split(",")[1]), parseFloat(previousTranform.split(",")[2])) : new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(0, 0), previousTranslate !== undefined);
        }
    } else if (redraw && isAnimate && !element && forceAnimate) $11815a21a80ae2b7$export$99679b46ac0f2167(child, 0, 600, "FadeIn");
    if (existChild) parent.replaceChild(child, element);
    else parent.appendChild(child);
}
function $11815a21a80ae2b7$export$68455d0cd63a689b(x1, y1, x2, y2, outerRect) {
    var width = Math.abs(x1 - x2);
    var height = Math.abs(y1 - y2);
    var x = Math.max($11815a21a80ae2b7$export$9448a5ef7e8c831a(Math.min(x1, x2), width, outerRect.x, outerRect.width), outerRect.x);
    var y = Math.max($11815a21a80ae2b7$export$9448a5ef7e8c831a(Math.min(y1, y2), height, outerRect.y, outerRect.height), outerRect.y);
    return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x, y, Math.min(width, outerRect.width), Math.min(height, outerRect.height));
}
function $11815a21a80ae2b7$export$9448a5ef7e8c831a(start, size, min, max) {
    if (start < min) start = min;
    else if (start + size > max + min) start = max + min - size;
    return start;
}
function $11815a21a80ae2b7$export$d3b1c00e68c3b170(currentPoint, series, chart) {
    var labelFormat = series.marker.dataLabel.format ? series.marker.dataLabel.format : series.yAxis.labelFormat;
    var text = [];
    var customLabelFormat = labelFormat.match("{value}") !== null;
    switch(series.seriesType){
        case "XY":
            /**
             * I255790
             * For Polar radar series, the dataLabel appears out of range when axis range is given for yaxis
             * Cause: Since symbol location for the points which did not lies in within range, lies outside of seriesRect.
             * Fix: DataLabel rendered after checking WithIn for the points
             */ if (series.chart.chartAreaType === "PolarRadar") {
                if (series.drawType.indexOf("Stacking") !== -1) {
                    if (series.yAxis.valueType === "Logarithmic" && $11815a21a80ae2b7$export$e4b998ae4102dcc2(series.stackedValues.endValues[currentPoint.index], series.yAxis) || $11815a21a80ae2b7$export$ee35c16ea07b4b7f(series.stackedValues.endValues[currentPoint.index], series.yAxis.visibleRange)) text.push(currentPoint.text || currentPoint.yValue.toString());
                } else if (series.yAxis.valueType === "Logarithmic" && $11815a21a80ae2b7$export$e4b998ae4102dcc2(currentPoint.yValue, series.yAxis) || $11815a21a80ae2b7$export$ee35c16ea07b4b7f(currentPoint.yValue, series.yAxis.visibleRange)) text.push(currentPoint.text || currentPoint.yValue.toString());
            } else text.push(currentPoint.text || currentPoint.yValue.toString());
            break;
        case "HighLow":
            text.push(currentPoint.text || Math.max(currentPoint.high, currentPoint.low).toString());
            text.push(currentPoint.text || Math.min(currentPoint.high, currentPoint.low).toString());
            break;
        case "HighLowOpenClose":
            text.push(currentPoint.text || Math.max(currentPoint.high, currentPoint.low).toString());
            text.push(currentPoint.text || Math.min(currentPoint.high, currentPoint.low).toString());
            text.push(currentPoint.text || Math.max(currentPoint.open, currentPoint.close).toString());
            text.push(currentPoint.text || Math.min(currentPoint.open, currentPoint.close).toString());
            break;
        case "BoxPlot":
            text.push(currentPoint.text || currentPoint.median.toString());
            text.push(currentPoint.text || currentPoint.maximum.toString());
            text.push(currentPoint.text || currentPoint.minimum.toString());
            text.push(currentPoint.text || currentPoint.upperQuartile.toString());
            text.push(currentPoint.text || currentPoint.lowerQuartile.toString());
            for(var _i = 0, _a = currentPoint.outliers; _i < _a.length; _i++){
                var liers = _a[_i];
                text.push(currentPoint.text || liers.toString());
            }
            break;
    }
    if ((labelFormat || chart.useGroupingSeparator) && !currentPoint.text) {
        series.yAxis.format = chart.intl.getNumberFormat({
            format: customLabelFormat ? "" : labelFormat,
            useGrouping: chart.useGroupingSeparator
        });
        for(var i = 0; i < text.length; i++)text[i] = customLabelFormat ? labelFormat.replace("{value}", series.yAxis.format(parseFloat(text[i]))) : series.yAxis.format(parseFloat(text[i]));
    }
    return text;
}
function $11815a21a80ae2b7$export$4d41f7386211339a(timer) {
    window.clearInterval(timer);
}
function $11815a21a80ae2b7$export$1af046d323e2551a(rect, collections, clipRect) {
    var currentRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x + clipRect.x, rect.y + clipRect.y, rect.width, rect.height);
    var isCollide = collections.some(function(rect) {
        return currentRect.x < rect.x + rect.width && currentRect.x + currentRect.width > rect.x && currentRect.y < rect.y + rect.height && currentRect.height + currentRect.y > rect.y;
    });
    return isCollide;
}
function $11815a21a80ae2b7$export$b3a64cebab6a8ebb(currentRect, rect) {
    return currentRect.x < rect.x + rect.width && currentRect.x + currentRect.width > rect.x && currentRect.y < rect.y + rect.height && currentRect.height + currentRect.y > rect.y;
}
function $11815a21a80ae2b7$export$6bbbfd8eda6d4f5(currentRect, rect) {
    return currentRect.x <= rect.x && currentRect.x + currentRect.width >= rect.x + rect.width && currentRect.y <= rect.y && currentRect.height + currentRect.y >= rect.y + rect.height;
}
function $11815a21a80ae2b7$export$90651d8f023649aa(location, textSize, margin) {
    return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(location.x - textSize.width / 2 - margin.left, location.y - textSize.height / 2 - margin.top, textSize.width + margin.left + margin.right, textSize.height + margin.top + margin.bottom);
}
function $11815a21a80ae2b7$export$ec7c6e33a69682f1(value) {
    return "#" + $11815a21a80ae2b7$export$485e52e0e5409cea(value.r) + $11815a21a80ae2b7$export$485e52e0e5409cea(value.g) + $11815a21a80ae2b7$export$485e52e0e5409cea(value.b);
}
function $11815a21a80ae2b7$export$485e52e0e5409cea(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $11815a21a80ae2b7$export$41b2247054c0b0ce(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? new $11815a21a80ae2b7$export$5c51317210f18433(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : new $11815a21a80ae2b7$export$5c51317210f18433(255, 255, 255);
}
function $11815a21a80ae2b7$export$71af4efcc3018b59(color) {
    color = color === "transparent" ? "white" : color;
    document.body.appendChild((0, $4ZDHT.createElement)("text", {
        id: "chartmeasuretext"
    }));
    var element = document.getElementById("chartmeasuretext");
    element.style.color = color;
    color = window.getComputedStyle(element).color;
    (0, $4ZDHT.remove)(element);
    var isRGBValue;
    if (color.indexOf("rgb") === 0 || color.indexOf("hsl") === 0) {
        color = color.replace(/\s/g, "").replace(/[()]/g, "");
        isRGBValue = color.slice(3).split(",");
    }
    return $11815a21a80ae2b7$export$ec7c6e33a69682f1(new $11815a21a80ae2b7$export$5c51317210f18433(parseInt(isRGBValue[0], 10), parseInt(isRGBValue[1], 10), parseInt(isRGBValue[2], 10)));
}
function $11815a21a80ae2b7$export$1e974c34d45d7398(color) {
    if (color.indexOf("rgba(") === 0 || color.indexOf("rgb(") === 0) {
        var rgbaValues = color.substring(color.indexOf("(") + 1, color.lastIndexOf(")")).split(",");
        if (rgbaValues.length === 3 || rgbaValues.length === 4) return rgbaValues.every(function(val) {
            var num = parseFloat(val);
            return !isNaN(num) && num >= 0 && num <= 255;
        });
    } else if (color.indexOf("#") === 0) {
        var hex = color.substring(1);
        return (hex.length === 3 || hex.length === 6) && /^[0-9A-Fa-f]{3,6}$/.test(hex);
    }
    return false;
}
function $11815a21a80ae2b7$export$9e452847ef3efd94(color, factor) {
    color = $11815a21a80ae2b7$export$71af4efcc3018b59(color);
    color = color.replace(/[^0-9a-f]/gi, "");
    if (color.length < 6) color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
    factor = factor || 0;
    // convert to decimal and change luminosity
    var rgb = "#";
    var colorCode;
    for(var i = 0; i < 3; i++){
        colorCode = parseInt(color.substr(i * 2, 2), 16);
        colorCode = Math.round(Math.min(Math.max(0, colorCode + colorCode * factor), 255));
        rgb += ("00" + colorCode.toString(16)).substr(colorCode.toString(16).length);
    }
    return rgb;
}
function $11815a21a80ae2b7$export$7b9df7fa774b5ca3(color, value) {
    var RGB = $11815a21a80ae2b7$export$41b2247054c0b0ce(color);
    RGB.r = parseInt(Math.floor(RGB.r * value).toString(), 10);
    RGB.g = parseInt(Math.floor(RGB.g * value).toString(), 10);
    RGB.b = parseInt(Math.floor(RGB.b * value).toString(), 10);
    return "#" + $11815a21a80ae2b7$export$485e52e0e5409cea(RGB.r).toUpperCase() + $11815a21a80ae2b7$export$485e52e0e5409cea(RGB.g).toUpperCase() + $11815a21a80ae2b7$export$485e52e0e5409cea(RGB.b).toUpperCase();
}
function $11815a21a80ae2b7$export$90c14aba0f5ae3b(values) {
    var half = Math.floor(values.length / 2);
    return values.length % 2 ? values[half] : (values[half - 1] + values[half]) / 2.0;
}
function $11815a21a80ae2b7$export$717a3a0101b6ed6a(location, size, shape, options) {
    var padding = 10;
    var dir = "";
    var space = 2;
    var height = size.height;
    var width = size.width;
    var lx = location.x;
    var ly = location.y;
    switch(shape){
        case "MultiColoredLine":
        case "Line":
        case "StackingLine":
        case "StackingLine100":
            dir = "M " + (lx + -width * (3 / 4)) + " " + ly + " " + "L" + " " + (lx + width * (3 / 4)) + " " + ly;
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "StepLine":
            options.fill = "transparent";
            dir = "M " + (lx + -width / 2 - padding / 4) + " " + (ly + height / 2) + " " + "L" + " " + (lx + -width / 2 + width / 10) + " " + (ly + height / 2) + " " + "L" + " " + (lx + -width / 2 + width / 10) + " " + ly + " " + "L" + " " + (lx + -width / 10) + " " + ly + " " + "L" + " " + (lx + -width / 10) + " " + (ly + height / 2) + " " + "L" + " " + (lx + width / 5) + " " + (ly + height / 2) + " " + "L" + " " + (lx + width / 5) + " " + (ly + -height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + -height / 2) + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + "L" + "" + (lx + width / 2 + padding / 4) + " " + (ly + height / 2);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "UpArrow":
            options.fill = options.stroke;
            options.stroke = "transparent";
            dir = "M " + (lx + -width / 2) + " " + (ly + height / 2) + " " + "L" + " " + lx + " " + (ly - height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + "L" + " " + (lx + width / 2 - space) + " " + (ly + height / 2) + " " + "L" + " " + lx + " " + (ly - height / 2 + 2 * space) + "L" + (lx - width / 2 + space) + " " + (ly + height / 2) + " Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "DownArrow":
            dir = "M " + (lx - width / 2) + " " + (ly - height / 2) + " " + "L" + " " + lx + " " + (ly + height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly - height / 2) + "L" + " " + (lx + width / 2 - space) + " " + (ly - height / 2) + " " + "L" + " " + lx + " " + (ly + height / 2 - 2 * space) + "L" + (lx - width / 2 + space) + " " + (ly - height / 2) + " Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "RightArrow":
            dir = "M " + (lx + -width / 2) + " " + (ly - height / 2) + " " + "L" + " " + (lx + width / 2) + " " + ly + " " + "L" + " " + (lx + -width / 2) + " " + (ly + height / 2) + " L" + " " + (lx + -width / 2) + " " + (ly + height / 2 - space) + " " + "L" + " " + (lx + width / 2 - 2 * space) + " " + ly + " L" + (lx + -width / 2) + " " + (ly - height / 2 + space) + " Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "LeftArrow":
            options.fill = options.stroke;
            options.stroke = "transparent";
            dir = "M " + (lx + width / 2) + " " + (ly - height / 2) + " " + "L" + " " + (lx + -width / 2) + " " + ly + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + "L" + " " + (lx + width / 2) + " " + (ly + height / 2 - space) + " L" + " " + (lx + -width / 2 + 2 * space) + " " + ly + " L" + (lx + width / 2) + " " + (ly - height / 2 + space) + " Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Column":
        case "Pareto":
        case "StackingColumn":
        case "StackingColumn100":
        case "RangeColumn":
        case "Histogram":
            dir = "M " + (lx - 3 * (width / 5)) + " " + (ly - height / 5) + " " + "L" + " " + (lx + 3 * (-width / 10)) + " " + (ly - height / 5) + " " + "L" + " " + (lx + 3 * (-width / 10)) + " " + (ly + height / 2) + " " + "L" + " " + (lx - 3 * (width / 5)) + " " + (ly + height / 2) + " " + "Z" + " " + "M" + " " + (lx + -width / 10 - width / 20) + " " + (ly - height / 4 - padding / 2) + " " + "L" + " " + (lx + width / 10 + width / 20) + " " + (ly - height / 4 - padding / 2) + " " + "L" + " " + (lx + width / 10 + width / 20) + " " + (ly + height / 2) + " " + "L" + " " + (lx + -width / 10 - width / 20) + " " + (ly + height / 2) + " " + "Z" + " " + "M" + " " + (lx + 3 * (width / 10)) + " " + ly + " " + "L" + " " + (lx + 3 * (width / 5)) + " " + ly + " " + "L" + " " + (lx + 3 * (width / 5)) + " " + (ly + height / 2) + " " + "L" + " " + (lx + 3 * (width / 10)) + " " + (ly + height / 2) + " " + "Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Bar":
        case "StackingBar":
        case "StackingBar100":
            dir = "M " + (lx + -width / 2 + -padding / 4) + " " + (ly - 3 * (height / 5)) + " " + "L" + " " + (lx + 3 * (width / 10)) + " " + (ly - 3 * (height / 5)) + " " + "L" + " " + (lx + 3 * (width / 10)) + " " + (ly - 3 * (height / 10)) + " " + "L" + " " + (lx - width / 2 + -padding / 4) + " " + (ly - 3 * (height / 10)) + " " + "Z" + " " + "M" + " " + (lx + -width / 2 + -padding / 4) + " " + (ly - height / 5 + padding / 20) + " " + "L" + " " + (lx + width / 2 + padding / 4) + " " + (ly - height / 5 + padding / 20) + " " + "L" + " " + (lx + width / 2 + padding / 4) + " " + (ly + height / 10 + padding / 20) + " " + "L" + " " + (lx - width / 2 + -padding / 4) + " " + (ly + height / 10 + padding / 20) + " " + "Z" + " " + "M" + " " + (lx - width / 2 + -padding / 4) + " " + (ly + height / 5 + padding / 10) + " " + "L" + " " + (lx + -width / 4) + " " + (ly + height / 5 + padding / 10) + " " + "L" + " " + (lx + -width / 4) + " " + (ly + height / 2 + padding / 10) + " " + "L" + " " + (lx - width / 2 + -padding / 4) + " " + (ly + height / 2 + padding / 10) + " " + "Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Spline":
            options.fill = "transparent";
            dir = "M " + (lx - width / 2) + " " + (ly + height / 5) + " " + "Q" + " " + lx + " " + (ly - height) + " " + lx + " " + (ly + height / 5) + " " + "M" + " " + lx + " " + (ly + height / 5) + " " + "Q" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + (lx + width / 2) + " " + (ly - height / 2);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Area":
        case "MultiColoredArea":
        case "RangeArea":
        case "StackingArea":
        case "StackingArea100":
            dir = "M " + (lx - width / 2 - padding / 4) + " " + (ly + height / 2) + " " + "L" + " " + (lx + -width / 4 + -padding / 8) + " " + (ly - height / 2) + " " + "L" + " " + lx + " " + (ly + height / 4) + " " + "L" + " " + (lx + width / 4 + padding / 8) + " " + (ly + -height / 2 + height / 4) + " " + "L" + " " + (lx + height / 2 + padding / 4) + " " + (ly + height / 2) + " " + "Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "SplineArea":
        case "SplineRangeArea":
            dir = "M " + (lx - width / 2) + " " + (ly + height / 5) + " " + "Q" + " " + lx + " " + (ly - height) + " " + lx + " " + (ly + height / 5) + " " + "Z" + " " + "M" + " " + lx + " " + (ly + height / 5) + " " + "Q" + " " + (lx + width / 2) + " " + (ly + height / 2) + " " + (lx + width / 2) + " " + (ly - height / 2) + " " + " Z";
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
        case "Pie":
        case "Doughnut":
            options.stroke = "transparent";
            var r = Math.min(height, width) / 2;
            dir = $11815a21a80ae2b7$var$getAccumulationLegend(lx, ly, r, height, width);
            (0, $3EnZW.merge)(options, {
                "d": dir
            });
            break;
    }
    return {
        renderOption: options
    };
}
function $11815a21a80ae2b7$export$fb7a751b3bd7efd3(maxWidth, text, font, isRtlEnabled, themeFontStyle) {
    var label = text;
    var size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, font, themeFontStyle).width;
    if (size > maxWidth) {
        var textLength = text.length;
        for(var i = textLength - 1; i >= 0; --i){
            label = isRtlEnabled ? "..." + text.substring(0, i) : text.substring(0, i) + "...";
            size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label, font, themeFontStyle).width;
            if (size <= maxWidth) return label;
        }
    }
    return label;
}
function $11815a21a80ae2b7$export$da2951920eb3f191(maxWidth, text, font, themeFontStyle) {
    var labelCollection = [];
    var breakLabels = text.split("<br>");
    for(var i = 0; i < breakLabels.length; i++){
        text = breakLabels[i];
        var size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, font, themeFontStyle).width;
        if (size > maxWidth) {
            var textLength = text.length;
            for(var i_1 = textLength - 1; i_1 >= 0; --i_1){
                text = text.substring(0, i_1) + "...";
                size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, font, themeFontStyle).width;
                if (size <= maxWidth) {
                    labelCollection.push(text);
                    break;
                }
            }
        } else labelCollection.push(text);
    }
    return labelCollection;
}
function $11815a21a80ae2b7$export$391a4509611a1b09(value, containerSize) {
    if (value !== null && value !== undefined) return value.indexOf("%") !== -1 ? containerSize / 100 * parseInt(value, 10) : parseInt(value, 10);
    return null;
}
function $11815a21a80ae2b7$export$8b065989b2d63753(redraw, id, options, renderer) {
    if (!redraw) return null;
    var element = $11815a21a80ae2b7$export$d16800b7e59a8051(id);
    if (element && options) renderer.setElementAttributes(options, element.tagName === "clipPath" ? element.childNodes[0] : element);
    return element;
}
function $11815a21a80ae2b7$export$473faaca3d2ec308(element, duration, start, end, x, y, angle, newTransform, previousTransform, pointAnimation) {
    if (x === void 0) x = "x";
    if (y === void 0) y = "y";
    if (angle === void 0) angle = 0;
    if (newTransform === void 0) newTransform = new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(0, 0);
    if (previousTransform === void 0) previousTransform = new $11815a21a80ae2b7$export$5ee9ad52a250f7ed(0, 0);
    var isDiv = element.tagName === "DIV";
    var setStyle = function(xValue, yValue, rotateX, rotateY) {
        if (isDiv) {
            element.style[x] = xValue + "px";
            element.style[y] = yValue + "px";
        } else {
            element.setAttribute(x, xValue + "");
            element.setAttribute(y, yValue + "");
            if (angle && newTransform.x && newTransform.y && previousTransform.x && previousTransform.y && rotateX && rotateY) element.setAttribute("transform", "rotate(" + angle + "," + rotateX + "," + rotateY + ")");
            if (pointAnimation) element.setAttribute("transform", "translate(" + rotateX + "," + rotateY + ")");
        }
    };
    setStyle(start.x, start.y, previousTransform.x, previousTransform.y);
    new (0, $kj1BR.Animation)({}).animate((0, $4ZDHT.createElement)("div"), {
        duration: duration,
        progress: function(args) {
            setStyle($11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, start.x, end.x - start.x, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, start.y, end.y - start.y, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousTransform.x, newTransform.x - previousTransform.x, args.duration), $11815a21a80ae2b7$export$45db2fc2f15997e7(args.timeStamp, previousTransform.y, newTransform.y - previousTransform.y, args.duration));
        },
        end: function() {
            setStyle(end.x, end.y, newTransform.x, newTransform.y);
        }
    });
}
function $11815a21a80ae2b7$export$d603b961dd4ef0f4(element, duration, start, end, customLabelFormat) {
    if (element && start && end) {
        var formatText_1 = function(value) {
            return customLabelFormat ? customLabelFormat.replace("{value}", value.toString()) : value.toString();
        };
        new (0, $kj1BR.Animation)({}).animate((0, $4ZDHT.createElement)("div"), {
            duration: duration,
            progress: function(args) {
                element.style.animation = "";
                var progress = args.timeStamp / args.duration;
                var currentValue = start + (end - start) * progress;
                if (start % 1 !== 0 || end % 1 !== 0) currentValue = parseFloat(currentValue.toFixed(1));
                else currentValue = Math.round(currentValue);
                element.textContent = formatText_1(currentValue);
            },
            end: function() {
                element.textContent = formatText_1(end);
            }
        });
    }
}
function $11815a21a80ae2b7$export$a06ce713d4aea371(renderer, option, font, color, parent, isMinus, redraw, isAnimate, forceAnimate, animateDuration, seriesClipRect, labelSize, isRotatedLabelIntersect, isCanvas, isDataLabelWrap, themeFontStyle, transform, previousTransform) {
    if (isMinus === void 0) isMinus = false;
    if (forceAnimate === void 0) forceAnimate = false;
    var renderOptions = {};
    var tspanElement;
    //let renderer: SvgRenderer = new SvgRenderer('');
    var height;
    var dy;
    var label;
    var width = 0;
    var dx;
    var maxWidth = 0;
    if (option.text.length > 1 && isDataLabelWrap) {
        for(var i = 0, len = option.text.length; i < len; i++)maxWidth = Math.max(maxWidth, (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(option.text[i], font, themeFontStyle).width);
        width = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(option.text[0], font, themeFontStyle).width;
    }
    dx = option.text.length > 1 && isDataLabelWrap ? option.x + maxWidth / 2 - width / 2 : option.x;
    renderOptions = {
        "id": option.id,
        "x": dx,
        "y": option.y,
        "fill": color ? color : "black",
        "font-size": font.size || themeFontStyle.size,
        "font-style": font.fontStyle || themeFontStyle.fontStyle,
        "font-family": font.fontFamily || themeFontStyle.fontFamily,
        "font-weight": font.fontWeight || themeFontStyle.fontWeight,
        "text-anchor": option.anchor,
        "labelRotation": option.labelRotation,
        "transform": option.transform,
        "opacity": font.opacity,
        "dominant-baseline": option.baseLine
    };
    var text = typeof option.text === "string" ? option.text : isMinus ? option.text[option.text.length - 1] : option.text[0];
    var transX = seriesClipRect ? seriesClipRect.x : 0;
    var transY = seriesClipRect ? seriesClipRect.y : 0;
    var htmlObject = renderer.createText(renderOptions, text, transX, transY);
    if (typeof option.text !== "string" && option.text.length > 1) for(var i = 1, len = option.text.length; i < len; i++){
        height = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(option.text[i], font, themeFontStyle).height;
        width = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(option.text[i], font, themeFontStyle).width;
        dy = option.y + (isMinus ? -(i * height) : i * height);
        dx = isDataLabelWrap ? option.x + maxWidth / 2 - width / 2 : option.x;
        label = isMinus ? option.text[option.text.length - (i + 1)] : option.text[i];
        if (isCanvas) tspanElement = renderer.createText(renderOptions, label, null, null, dy, true);
        else {
            tspanElement = renderer.createTSpan({
                "x": dx,
                "id": option.id,
                "y": dy
            }, label);
            htmlObject.appendChild(tspanElement);
        }
    }
    if (!isRotatedLabelIntersect) $11815a21a80ae2b7$export$a63bfedb1bdc5984(renderer instanceof (0, $be4148c2a6d179c7$export$7adc20298958481a), parent, htmlObject, redraw, isAnimate, "x", "y", null, null, forceAnimate, false, null, animateDuration, false, option.labelRotation, transform, previousTransform);
    return htmlObject;
}
function $11815a21a80ae2b7$export$907c7b8171f13ef1(chart) {
    // fix for Chart rendered with default width in IE issue
    var containerWidth = chart.element.clientWidth || chart.element.offsetWidth;
    var containerHeight = chart.element.clientHeight;
    if (chart.stockChart) {
        containerWidth = chart.stockChart.availableSize.width;
        containerHeight = chart.stockChart.availableSize.height;
    }
    var height = 450;
    var marginHeight;
    if (chart.getModuleName() === "rangeNavigator") {
        var range = chart;
        var tooltipSpace = range.tooltip.enable ? 35 : 0;
        var periodHeight = range.periodSelectorSettings.periods.length ? range.periodSelectorSettings.height : 0;
        marginHeight = range.margin.top + range.margin.bottom + tooltipSpace;
        var labelSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)("tempString", range.labelStyle, range.themeStyle.axisLabelFont).height;
        var labelPadding = 15;
        height = (chart.series.length ? (0, $5q7BP.Browser).isDevice ? 80 : 120 : (range.enableGrouping ? 40 + labelPadding + labelSize : 40) + marginHeight) + periodHeight;
        if (range.disableRangeSelector) height = periodHeight;
        if (chart.stockChart && chart.stockChart.chart.axisCollections[1].labelPosition === "Outside") {
            var padding = chart.stockChart.chart.axisCollections[1].labelPadding + chart.stockChart.chart.axisCollections[1].lineStyle.width * 0.5;
            chart.width = (chart.stockChart.availableSize.width - (chart.stockChart.chart.axisCollections[1].maxLabelSize.width + padding)).toString();
        }
    }
    chart.availableSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)($11815a21a80ae2b7$export$391a4509611a1b09(chart.width, containerWidth) || containerWidth || 600, $11815a21a80ae2b7$export$391a4509611a1b09(chart.height, containerHeight || height) || containerHeight || height);
    if (chart.getModuleName() === "chart") {
        chart.scaleX = 1;
        chart.scaleY = 1;
    }
}
function $11815a21a80ae2b7$export$c54fe3b9ecaa84cf(chart) {
    chart.canvasRender = new (0, $be4148c2a6d179c7$export$7adc20298958481a)(chart.element.id);
    chart.renderer = chart.enableCanvas ? chart.canvasRender : new (0, $aa3074f243277ee7$export$5ff52eac0871021a)(chart.element.id);
    $11815a21a80ae2b7$export$907c7b8171f13ef1(chart);
    if (chart.stockChart && chart.getModuleName() === "chart") chart.svgObject = chart.stockChart.chartObject;
    else if (chart.stockChart && chart.getModuleName() === "rangeNavigator") chart.svgObject = chart.stockChart.selectorObject;
    else if (chart.enableCanvas) chart.svgObject = chart.renderer.createCanvas({
        id: chart.element.id + "_canvas",
        width: chart.availableSize.width,
        height: chart.availableSize.height
    });
    else chart.svgObject = chart.renderer.createSvg({
        id: chart.element.id + "_svg",
        width: chart.availableSize.width,
        height: chart.availableSize.height
    });
    if (chart.enableCanvas) chart.renderer.ctx.direction = chart.enableRtl ? "rtl" : "ltr";
}
function $11815a21a80ae2b7$export$70d1bf7729efff40(title, style, width, isRtlEnabled, themeFontStyle) {
    var titleCollection = [];
    switch(style.textOverflow){
        case "Wrap":
            titleCollection = $11815a21a80ae2b7$export$cd75915cb4ef7473(title, width, style, isRtlEnabled, title.indexOf(" ") < 0 ? true : null, null, themeFontStyle);
            break;
        case "Trim":
            titleCollection.push($11815a21a80ae2b7$export$fb7a751b3bd7efd3(width, title, style, isRtlEnabled, themeFontStyle));
            break;
        default:
            titleCollection.push(title);
            break;
    }
    return titleCollection;
}
function $11815a21a80ae2b7$export$c12580d46760c769(rect, titleStyle) {
    var positionX;
    if (titleStyle.textAlignment === "Near") positionX = rect.x;
    else if (titleStyle.textAlignment === "Center") positionX = rect.x + rect.width / 2;
    else positionX = rect.x + rect.width;
    return positionX;
}
function $11815a21a80ae2b7$export$cd75915cb4ef7473(currentLabel, maximumWidth, font, isRtlEnabled, wrapAnyWhere, clip, themeFontStyle) {
    if (wrapAnyWhere) return $11815a21a80ae2b7$export$8deaab4e76bb10c1(currentLabel, maximumWidth, font, themeFontStyle);
    else {
        var textCollection = currentLabel.split(" ");
        var label = "";
        var labelCollection = [];
        var text = void 0;
        for(var i = 0, len = textCollection.length; i < len; i++){
            text = textCollection[i];
            if ((0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label.concat(label === "" ? "" : " " + text), font, themeFontStyle).width < maximumWidth) label = label.concat((label === "" ? "" : " ") + text);
            else if (label !== "") {
                labelCollection.push(clip ? label : $11815a21a80ae2b7$export$fb7a751b3bd7efd3(maximumWidth, label, font, isRtlEnabled, themeFontStyle));
                label = text;
            } else {
                labelCollection.push(clip ? text : $11815a21a80ae2b7$export$fb7a751b3bd7efd3(maximumWidth, text, font, isRtlEnabled, themeFontStyle));
                text = "";
            }
            if (label && i === len - 1) labelCollection.push(clip ? label : $11815a21a80ae2b7$export$fb7a751b3bd7efd3(maximumWidth, label, font, isRtlEnabled, themeFontStyle));
        }
        return labelCollection;
    }
}
function $11815a21a80ae2b7$export$8deaab4e76bb10c1(currentLabel, maximumWidth, font, themeFontStyle) {
    var size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(currentLabel, font, themeFontStyle).width;
    var labelCollection = [];
    if (size > maximumWidth) {
        var label = "";
        var startIndex = 0;
        var labelIndex = 1;
        while(labelIndex < currentLabel.length){
            label = currentLabel.substring(startIndex, labelIndex);
            size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label, font, themeFontStyle).width;
            if (size < maximumWidth) labelIndex++;
            else if (size === maximumWidth) {
                startIndex = labelIndex;
                labelCollection.push(label);
                labelIndex++;
                label = "";
            } else if (size > maximumWidth) {
                label = label.slice(0, -1);
                startIndex = labelIndex - 1;
                labelCollection.push(label);
                label = "";
            }
        }
        if (label.length > 0) labelCollection.push(label);
    } else labelCollection.push(currentLabel);
    return labelCollection;
}
function $11815a21a80ae2b7$export$e6b929b8e4bc3801(text, regexp) {
    var title = text.replace(regexp, " ");
    var digit = text.match(regexp);
    var digitSpecific = " ";
    var convertedText = " ";
    var k = 0;
    var unicodeSub = {
        "0": "\u2080",
        "1": "\u2081",
        "2": "\u2082",
        "3": "\u2083",
        "4": "\u2084",
        "5": "\u2085",
        "6": "\u2086",
        "7": "\u2087",
        "8": "\u2088",
        "9": "\u2089"
    };
    var unicodeSup = {
        "0": "\u2070",
        "1": "\xb9",
        "2": "\xb2",
        "3": "\xb3",
        "4": "\u2074",
        "5": "\u2075",
        "6": "\u2076",
        "7": "\u2077",
        "8": "\u2078",
        "9": "\u2079"
    };
    for(var i = 0; i <= title.length - 1; i++)if (title[i] === " ") {
        digitSpecific = regexp === (0, $9415fc5f023d8fac$export$a5e18b86421f9fee) ? digit[k].replace(/~/g, "") : digit[k].replace(/\^/g, "");
        for(var j = 0; j < digitSpecific.length; j++)convertedText += regexp === (0, $9415fc5f023d8fac$export$a5e18b86421f9fee) ? unicodeSub[digitSpecific[j]] : unicodeSup[digitSpecific[j]];
        k++;
    } else convertedText += title[i];
    return convertedText.trim();
}
function $11815a21a80ae2b7$export$d275276aef283641(control) {
    for(var i = 0; i < control.annotations.length; i++)(0, $c2qqN.resetBlazorTemplate)((control.element.id + "_Annotation_" + i).replace(/[^a-zA-Z0-9]/g, ""), "ContentTemplate");
    //This reset the tooltip templates
    (0, $c2qqN.resetBlazorTemplate)(control.element.id + "_tooltipparent_template" + "_blazorTemplate", "Template");
    //Datalabel templates reset
    (0, $c2qqN.resetBlazorTemplate)(control.element.id + "_DataLabel");
}
/** @private */ var $11815a21a80ae2b7$export$dba1cb618530fbb4 = /** @class */ function() {
    function CustomizeOption(id) {
        this.id = id;
    }
    return CustomizeOption;
}();
/** @private */ var $11815a21a80ae2b7$export$cb68e0e5fb7c5c3a = /** @class */ function() {
    function StackValues(startValue, endValue) {
        this.startValues = startValue;
        this.endValues = endValue;
    }
    return StackValues;
}();
/** @private */ var $11815a21a80ae2b7$export$871e154ae03dc77d = /** @class */ function(_super) {
    $11815a21a80ae2b7$var$__extends(RectOption, _super);
    function RectOption(id, fill, border, opacity, rect, rx, ry, transform, dashArray) {
        var _this = _super.call(this, id, fill, border.width, border.color, opacity, dashArray) || this;
        _this.y = rect.y;
        _this.x = rect.x;
        _this.height = rect.height;
        _this.width = rect.width;
        _this.rx = rx ? rx : 0;
        _this.ry = ry ? ry : 0;
        _this.transform = transform ? transform : "";
        _this.stroke = border.width !== 0 && _this.stroke !== "" ? border.color === null ? "" : border.color : "transparent";
        return _this;
    }
    return RectOption;
}((0, $5d5f50c62a40f4c7$export$cd3012645815980));
/** @private */ var $11815a21a80ae2b7$export$5435ab62ca6c218c = /** @class */ function() {
    function ImageOption(height, width, href, x, y, id, visibility, preserveAspectRatio) {
        this.height = height;
        this.width = width;
        this.href = href;
        this.x = x;
        this.y = y;
        this.id = id;
        this.visibility = visibility;
        this.preserveAspectRatio = preserveAspectRatio;
    }
    return ImageOption;
}();
/** @private */ var $11815a21a80ae2b7$export$abcc25cb43492e33 = /** @class */ function(_super) {
    $11815a21a80ae2b7$var$__extends(CircleOption, _super);
    function CircleOption(id, fill, border, opacity, cx, cy, r) {
        var _this = _super.call(this, id, fill, border.width, border.color, opacity) || this;
        _this.cy = cy;
        _this.cx = cx;
        _this.r = r;
        return _this;
    }
    return CircleOption;
}((0, $5d5f50c62a40f4c7$export$cd3012645815980));
/** @private */ var $11815a21a80ae2b7$export$34d71c619b60dc1e = /** @class */ function() {
    function PolygonOption(id, points, fill) {
        this.id = id;
        this.points = points;
        this.fill = fill;
    }
    return PolygonOption;
}();
/** @private */ var $11815a21a80ae2b7$export$5ee9ad52a250f7ed = /** @class */ function() {
    function ChartLocation(x, y) {
        this.x = x;
        this.y = y;
    }
    return ChartLocation;
}();
/** @private */ var $11815a21a80ae2b7$export$5cf87d8e2b8d9c93 = /** @class */ function() {
    function LabelLocation(x, y) {
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    return LabelLocation;
}();
/** @private */ var $11815a21a80ae2b7$export$2bc8736e5a9baa90 = /** @class */ function() {
    function Thickness(left, right, top, bottom) {
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
    }
    return Thickness;
}();
/** @private */ var $11815a21a80ae2b7$export$5c51317210f18433 = /** @class */ function() {
    function ColorValue(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
    }
    return ColorValue;
}();
/** @private */ var $11815a21a80ae2b7$export$8b02a874d977053f = /** @class */ function() {
    function PointData(point, series, index) {
        if (index === void 0) index = 0;
        this.point = point;
        this.series = series;
        this.lierIndex = index;
    }
    return PointData;
}();
/** @private */ var $11815a21a80ae2b7$export$21b2b4e0bf93b906 = /** @class */ function() {
    function AccPointData(point, series, index) {
        if (index === void 0) index = 0;
        this.point = point;
        this.series = series;
        this.index = index;
    }
    return AccPointData;
}();
/** @private */ var $11815a21a80ae2b7$export$91a5d271df793a0 = /** @class */ function() {
    /**
     * Initializes a new instance of the Chart3DData class.
     *
     * @param {Chart3DPoint} point - The 3D point object.
     * @param {Chart3DSeries} series - The 3D series object.
     * @private
     */ function Point3D(point, series) {
        this.point = point;
        this.series = series;
    }
    return Point3D;
}();
/** @private */ var $11815a21a80ae2b7$export$795e6c8902d13ef4 = /** @class */ function() {
    function ControlPoints(controlPoint1, controlPoint2) {
        this.controlPoint1 = controlPoint1;
        this.controlPoint2 = controlPoint2;
    }
    return ControlPoints;
}();
function $11815a21a80ae2b7$export$f663f23222699c31(colorMap, value) {
    var color = "";
    var rbgColorValue;
    if (Number(value) === colorMap.start) color = colorMap.colors[0];
    else if (Number(value) === colorMap.end) color = colorMap.colors[colorMap.colors.length - 1];
    else {
        rbgColorValue = $11815a21a80ae2b7$export$ba4475dcfbcca768(Number(value), colorMap);
        color = $11815a21a80ae2b7$export$ec7c6e33a69682f1(rbgColorValue);
    }
    return color;
}
function $11815a21a80ae2b7$export$ba4475dcfbcca768(value, colorMap) {
    var previousOffset = colorMap.start;
    var nextOffset = colorMap.end;
    var percent = 0;
    var full = nextOffset - previousOffset;
    var midColor;
    percent = (value - previousOffset) / full;
    var previousColor;
    var nextColor;
    if (colorMap.colors.length <= 2) {
        previousColor = colorMap.colors[0].charAt(0) === "#" ? colorMap.colors[0] : $11815a21a80ae2b7$export$71af4efcc3018b59(colorMap.colors[0]);
        nextColor = colorMap.colors[colorMap.colors.length - 1].charAt(0) === "#" ? colorMap.colors[colorMap.colors.length - 1] : $11815a21a80ae2b7$export$71af4efcc3018b59(colorMap.colors[colorMap.colors.length - 1]);
    } else {
        previousColor = colorMap.colors[0].charAt(0) === "#" ? colorMap.colors[0] : $11815a21a80ae2b7$export$71af4efcc3018b59(colorMap.colors[0]);
        nextColor = colorMap.colors[colorMap.colors.length - 1].charAt(0) === "#" ? colorMap.colors[colorMap.colors.length - 1] : $11815a21a80ae2b7$export$71af4efcc3018b59(colorMap.colors[colorMap.colors.length - 1]);
        var a = full / (colorMap.colors.length - 1);
        var b = void 0;
        var c = void 0;
        var length_2 = colorMap.colors.length - 1;
        var splitColorValueOffset = [];
        var splitColor = {};
        for(var j = 1; j < length_2; j++){
            c = j * a;
            b = previousOffset + c;
            splitColor = {
                b: b,
                color: colorMap.colors[j]
            };
            splitColorValueOffset.push(splitColor);
        }
        for(var i = 0; i < splitColorValueOffset.length; i++){
            if (previousOffset <= value && value <= splitColorValueOffset[i]["b"] && i === 0) {
                midColor = splitColorValueOffset[i]["color"].charAt(0) === "#" ? splitColorValueOffset[i]["color"] : $11815a21a80ae2b7$export$71af4efcc3018b59(splitColorValueOffset[i]["color"]);
                nextColor = midColor;
                percent = value <= splitColorValueOffset[i]["b"] ? 1 - Math.abs((value - splitColorValueOffset[i]["b"]) / a) : (value - splitColorValueOffset[i]["b"]) / a;
            } else if (splitColorValueOffset[i]["b"] <= value && value <= nextOffset && i === splitColorValueOffset.length - 1) {
                midColor = splitColorValueOffset[i]["color"].charAt(0) === "#" ? splitColorValueOffset[i]["color"] : $11815a21a80ae2b7$export$71af4efcc3018b59(splitColorValueOffset[i]["color"]);
                previousColor = midColor;
                percent = value < splitColorValueOffset[i]["b"] ? 1 - Math.abs((value - splitColorValueOffset[i]["b"]) / a) : (value - splitColorValueOffset[i]["b"]) / a;
            }
            if (i !== splitColorValueOffset.length - 1 && i < splitColorValueOffset.length) {
                if (splitColorValueOffset[i]["b"] <= value && value <= splitColorValueOffset[i + 1]["b"]) {
                    midColor = splitColorValueOffset[i]["color"].charAt(0) === "#" ? splitColorValueOffset[i]["color"] : $11815a21a80ae2b7$export$71af4efcc3018b59(splitColorValueOffset[i]["color"]);
                    previousColor = midColor;
                    nextColor = splitColorValueOffset[i + 1]["color"].charAt(0) === "#" ? splitColorValueOffset[i + 1]["color"] : $11815a21a80ae2b7$export$71af4efcc3018b59(splitColorValueOffset[i + 1]["color"]);
                    percent = Math.abs(value - splitColorValueOffset[i + 1]["b"]) / a;
                }
            }
        }
    }
    return $11815a21a80ae2b7$export$83d55c71ab0b604b(percent, previousColor, nextColor);
}
function $11815a21a80ae2b7$export$83d55c71ab0b604b(percent, previous, next) {
    var nextColor = next.split("#")[1];
    var prevColor = previous.split("#")[1];
    var r = $11815a21a80ae2b7$export$6712e0f6cd0ea03(percent, parseInt(prevColor.substr(0, 2), 16), parseInt(nextColor.substr(0, 2), 16));
    var g = $11815a21a80ae2b7$export$6712e0f6cd0ea03(percent, parseInt(prevColor.substr(2, 2), 16), parseInt(nextColor.substr(2, 2), 16));
    var b = $11815a21a80ae2b7$export$6712e0f6cd0ea03(percent, parseInt(prevColor.substr(4, 2), 16), parseInt(nextColor.substr(4, 2), 16));
    return new $11815a21a80ae2b7$export$5c51317210f18433(r, g, b);
}
function $11815a21a80ae2b7$export$6712e0f6cd0ea03(percent, previous, next) {
    var full = next - previous;
    return Math.round(previous + full * percent);
}
function $11815a21a80ae2b7$export$c2f41ec8f9331264(alignment, enableRtl) {
    switch(alignment){
        case "Near":
            return enableRtl ? "end" : "start";
        case "Far":
            return enableRtl ? "start" : "end";
        default:
            return "middle";
    }
}


parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");




/**
 * Base class for column series.
 * This class provides common properties and methods for column series in the chart.
 *
 * @private
 */ var $7517da37aebd6aac$export$c1c08c4b2dec0f8e = /** @class */ function() {
    function ColumnBase() {}
    ColumnBase.prototype.getSideBySideInfo = function(series) {
        if (series.chart.enableSideBySidePlacement && !series.position) this.getSideBySidePositions(series);
        if (series.columnWidthInPixel) return new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(0, 0);
        var position = series.type === "Histogram" || !series.chart.enableSideBySidePlacement ? 0 : series.position;
        var rectCount = series.type === "Histogram" || !series.chart.enableSideBySidePlacement ? 1 : series.rectCount;
        series.isRectSeries = true;
        var visibleSeries = series.chart.visibleSeries;
        var seriesSpacing = series.chart.enableSideBySidePlacement ? series.columnSpacing : 0; // Column Spacing
        var pointSpacing = series.columnWidth === null || isNaN(+series.columnWidth) ? series.type === "Histogram" ? 1 : 0.7 : Math.min(series.columnWidth, 1); // Column width
        var minimumPointDelta = (0, $11815a21a80ae2b7$export$c50b663dcfb9c16f)(series.xAxis, visibleSeries);
        var width = minimumPointDelta * pointSpacing;
        var radius;
        var location = position / rectCount - 0.5;
        var doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(location, location + 1 / rectCount);
        if (!(isNaN(doubleRange.start) || isNaN(doubleRange.end))) {
            if (series.groupName && series.type.indexOf("Stacking") === -1) {
                var mainColumnWidth_1 = 0.7;
                series.chart.series.filter(function(series) {
                    if (series.columnWidth > mainColumnWidth_1) mainColumnWidth_1 = series.columnWidth;
                });
                var mainWidth = minimumPointDelta * mainColumnWidth_1;
                var mainDoubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(doubleRange.start * mainWidth, doubleRange.end * mainWidth);
                var difference = (mainDoubleRange.delta - (doubleRange.end * width - doubleRange.start * width)) / 2;
                doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(mainDoubleRange.start + difference, mainDoubleRange.end - difference);
            } else doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(doubleRange.start * width, doubleRange.end * width);
            radius = seriesSpacing * doubleRange.delta;
            doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(doubleRange.start + radius / 2, doubleRange.end - radius / 2);
        }
        return doubleRange;
    };
    /**
     * Gets the rectangle bounds based on two points.
     *
     * @param {number} x1 - The x-coordinate of the first point.
     * @param {number} y1 - The y-coordinate of the first point.
     * @param {number} x2 - The x-coordinate of the second point.
     * @param {number} y2 - The y-coordinate of the second point.
     * @param {Series} series - The series associated with the rectangle.
     * @returns {Rect} - The rectangle bounds.
     */ ColumnBase.prototype.getRectangle = function(x1, y1, x2, y2, series) {
        var point1 = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(x1, y1, series.xAxis, series.yAxis, series.chart.requireInvertedAxis);
        var point2 = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(x2, y2, series.xAxis, series.yAxis, series.chart.requireInvertedAxis);
        return new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(Math.min(point1.x, point2.x), Math.min(point1.y, point2.y), Math.abs(point2.x - point1.x), Math.abs(point2.y - point1.y));
    };
    /**
     * Draws a cylinder using the provided options and element.
     *
     * @param {PathOption} options - The path options for drawing the cylinder.
     * @param {HTMLElement} element - The HTML element to which the cylinder is drawn.
     * @param {CylinderSeriesOption} cylinderSeriesOption - The options specific to the cylinder series.
     * @param {Rect} rect - The rectangle bounds within which the cylinder is drawn.
     * @param {Series} series - The series associated with the cylinder.
     * @returns {void}
     */ ColumnBase.prototype.drawCylinder = function(options, element, cylinderSeriesOption, rect, series) {
        var width = rect.width;
        var height = rect.height;
        if (series.chart.enableCanvas) {
            var ctx = series.chart.canvasRender.ctx;
            var canvasCtx = ctx;
            ctx.save();
            var gradientColor = (0, $11815a21a80ae2b7$export$71af4efcc3018b59)(options.fill);
            var x = rect.x + series.clipRect.x;
            var y = rect.y + series.clipRect.y;
            var arc = 2 * Math.PI + 0.1;
            var rx = void 0;
            var ry = void 0;
            var cx1 = void 0;
            var cx2 = void 0;
            var cy1 = void 0;
            var cy2 = void 0;
            var x1 = void 0;
            var x2 = void 0;
            var y1 = void 0;
            var y2 = void 0;
            var cx = void 0;
            var cy = void 0;
            var xl = void 0;
            var yl = void 0;
            var xPos = void 0;
            var yPos = void 0;
            var step = void 0;
            var rxt = void 0;
            var ryt = void 0;
            var gx1 = 0;
            var gx2 = 0;
            var gy1 = 0;
            var gy2 = 0;
            var ini = 0;
            ctx.fillStyle = (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.9);
            ctx.lineWidth = 0;
            ctx.strokeStyle = (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.9);
            ctx.globalAlpha = options.opacity;
            if (cylinderSeriesOption.isColumn) {
                gx1 = x;
                gx2 = width + x;
                rx = width / 2;
                ry = rx / 4;
                cx2 = cx1 = x + rx;
                y2 = cy1 = y - ry;
                x2 = x;
                x1 = x + width;
                cy2 = y1 = y + height - ry;
                step = Math.PI;
                rxt = -rx;
                ryt = ry;
                if (cylinderSeriesOption.stacking) {
                    if (!cylinderSeriesOption.isLastSeries) y2 = cy1 = y + ry;
                }
            } else {
                gy2 = height + y;
                gy1 = y;
                ry = height / 2;
                rx = ry / 4;
                x2 = cx1 = x + rx;
                x1 = cx2 = x + width + rx;
                y1 = y + height;
                y2 = y;
                cy2 = cy1 = y + ry;
                ini = Math.PI / 2;
                step = Math.PI * 1.5;
                if (cylinderSeriesOption.stacking) {
                    if (!cylinderSeriesOption.isLastSeries) x1 = cx2 = x + width - rx;
                }
                ry = -ry;
                rx = -rx;
                rxt = rx;
                ryt = -ry;
            }
            var color = (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.7);
            var gradient = ctx.createLinearGradient(gx1, gy1, gx2, gy2);
            gradient.addColorStop(0, gradientColor);
            gradient.addColorStop(0.3, color);
            gradient.addColorStop(0.7, color);
            gradient.addColorStop(1, gradientColor);
            for(var j = 1; j <= 4; j++){
                var i = 0;
                if (j < 4) ctx.beginPath();
                if (j % 2 === 0) {
                    cx = cx2;
                    cy = cy2;
                    xl = x2;
                    yl = y2;
                } else {
                    cx = cx1;
                    cy = cy1;
                    xl = x1;
                    yl = y1;
                }
                if (j === 4) {
                    rx = rxt;
                    ry = ryt;
                    ctx.fillStyle = gradient;
                }
                if (j > 2) {
                    i = ini;
                    arc = step;
                }
                for(; i <= arc; i += 0.1){
                    xPos = cx - rx * Math.cos(i);
                    yPos = cy + ry * Math.sin(i);
                    if (i === 0) ctx.moveTo(xPos, yPos);
                    else ctx.lineTo(xPos, yPos);
                }
                if (j > 2) ctx.lineTo(xl, yl);
                if (j !== 3) {
                    ctx.stroke();
                    ctx.fill();
                }
            }
            if (options.id.indexOf("Series") >= 0) {
                ctx.clip();
                ctx.restore();
                ctx = canvasCtx;
            }
        } else {
            var chart = series.chart;
            var x = rect.x;
            var y = rect.y;
            var id = options.id;
            var gradientColor = options.fill;
            var fillColor = gradientColor;
            var format = (0, $11815a21a80ae2b7$export$1e974c34d45d7398)(gradientColor);
            if (!format) gradientColor = (0, $11815a21a80ae2b7$export$71af4efcc3018b59)(gradientColor);
            var AEx = 0;
            var AEy = 0;
            var LX = 0;
            var LY = 0;
            var GX = 0;
            var GY = 0;
            var X = void 0;
            var Y = void 0;
            var X1 = void 0;
            var Y1 = void 0;
            var X2 = void 0;
            var Y2 = void 0;
            var rx = void 0;
            var ry = void 0;
            var i = 2;
            if (cylinderSeriesOption.isColumn) {
                rx = width / 2;
                ry = rx / 4;
                X = X1 = x;
                Y = ry < y ? y - ry : cylinderSeriesOption.stacking ? y + ry : y - ry;
                Y1 = Y;
                AEx = 2 * rx;
                LY = ry < y ? height : height < 2 * ry ? height : cylinderSeriesOption.stacking ? height - 2 * ry : height;
                X2 = X;
                Y2 = ry < y ? Y + height : height < Y ? height + Y : cylinderSeriesOption.stacking ? height + (y - ry) : height + Y;
                GX = 100;
                if (cylinderSeriesOption.stacking) {
                    if (!cylinderSeriesOption.isLastSeries) {
                        Y = Y1 = y + ry;
                        LY = height < rx / 2 ? height : height - rx / 2;
                    }
                }
            } else {
                ry = height / 2;
                rx = ry / 4;
                Y = Y1 = y;
                X = X1 = Math.abs(x - rx);
                AEy = 2 * ry;
                LX = width;
                X2 = X + width;
                Y2 = Y;
                GY = 100;
                if (cylinderSeriesOption.stacking) {
                    if (!cylinderSeriesOption.isLastSeries) {
                        X2 = X + width - rx * 2;
                        LX = width - rx * 2;
                    }
                }
            }
            (0, $4ZDHT.remove)(this.element);
            while(i--){
                options.d = "M" + X.toString() + "," + Y.toString() + "a" + rx.toString() + "," + ry.toString() + " 0 1,0 " + AEx.toString() + "," + AEy.toString() + "a" + rx.toString() + "," + ry.toString() + " 0 1,0 " + (-1 * AEx).toString() + "," + (-1 * AEy).toString();
                options.id = id + "_" + "Region_" + i;
                options.fill = (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.9);
                if (i % 2 === 0 && series.type !== "StackingBar100" && series.type !== "StackingBar" && series.type !== "Bar") options.fill = options.fill + "10";
                this.element = chart.renderer.drawPath(this.options, new Int32Array([
                    series.clipRect.x,
                    series.clipRect.y
                ]));
                (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.seriesElement, this.element, chart.redraw);
                X = X2;
                Y = Y2;
            }
            options.d = "M" + X1.toString() + "," + Y1.toString() + "a" + rx.toString() + "," + ry.toString() + " 0 1,0 " + AEx.toString() + "," + AEy.toString() + "l" + LX.toString() + " " + LY.toString() + "a" + rx.toString() + "," + ry.toString() + " 0 1,1 " + (-1 * AEx).toString() + "," + (-1 * AEy).toString() + " z";
            options.id = id + "_" + "Region_2";
            options.fill = (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.7);
            var optiong = void 0;
            if (fillColor.indexOf("url") === -1) {
                if (!document.getElementById(id)) {
                    optiong = {
                        "id": id,
                        x1: "0%",
                        y1: "0%",
                        x2: GX.toString() + "%",
                        y2: GY.toString() + "%"
                    };
                    var gradientElement = [
                        {
                            colorStop: "0%",
                            color: gradientColor
                        },
                        {
                            colorStop: "30%",
                            color: (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.7)
                        },
                        {
                            colorStop: "70%",
                            color: (0, $11815a21a80ae2b7$export$7b9df7fa774b5ca3)(gradientColor, 0.7)
                        },
                        {
                            colorStop: "100%",
                            color: gradientColor
                        }
                    ];
                    this.drawGradient(optiong, gradientElement, series);
                }
                options.fill = "url(#" + optiong.id + ")";
            }
            this.element = chart.renderer.drawPath(this.options, new Int32Array([
                series.clipRect.x,
                series.clipRect.y
            ]));
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.seriesElement, this.element, chart.redraw);
        }
    };
    /**
     * Draws a gradient using the provided options and gradient element.
     *
     * @param {OptionGradient} optiong - The gradient options for drawing the gradient.
     * @param {Object} gradientElement - The gradient element to which the gradient is applied.
     * @param {Series} series - The series associated with the gradient.
     * @returns {void}
     */ ColumnBase.prototype.drawGradient = function(optiong, gradientElement, series) {
        var chart = series.chart;
        var defElement = chart.renderer.createDefs();
        var xmlns = "http://www.w3.org/2000/svg";
        var linearGradientElement = document.createElementNS(xmlns, "linearGradient");
        linearGradientElement.setAttribute("id", optiong.id);
        linearGradientElement.setAttribute("x1", optiong.x1);
        linearGradientElement.setAttribute("y1", optiong.y1);
        linearGradientElement.setAttribute("x2", optiong.x2);
        linearGradientElement.setAttribute("y2", optiong.y2);
        for(var i = 0; i < gradientElement.length; i++){
            var stopElement = document.createElementNS(xmlns, "stop");
            stopElement.setAttribute("offset", gradientElement[i].colorStop);
            stopElement.setAttribute("stop-color", gradientElement[i].color);
            stopElement.setAttribute("stop-opacity", "1");
            linearGradientElement.appendChild(stopElement);
        }
        series.seriesElement.appendChild(defElement);
        defElement.appendChild(linearGradientElement);
    };
    /**
     * To get the position of each series.
     *
     * @param {Series} series - The series for which side-by-side positions are calculated.
     * @returns {void}
     * @private
     */ ColumnBase.prototype.getSideBySidePositions = function(series) {
        var chart = series.chart;
        for(var _i = 0, _a = chart.columns; _i < _a.length; _i++){
            var columnItem = _a[_i];
            for(var _b = 0, _c = chart.rows; _b < _c.length; _b++){
                var item = _c[_b];
                this.findRectPosition(series.findSeriesCollection(columnItem, item, false));
            }
        }
    };
    ColumnBase.prototype.findRectPosition = function(seriesCollection) {
        var groupingValues = [];
        var vSeries = {
            rectCount: 0,
            position: null
        };
        for(var i = 0; i < seriesCollection.length; i++){
            var value = seriesCollection[i];
            if (value.type.indexOf("Stacking") !== -1 || value.groupName !== "") {
                var groupName = value.type.indexOf("Stacking") !== -1 ? value.stackingGroup : value.type + value.groupName;
                if (groupName) {
                    if (groupingValues[groupName] === undefined) {
                        value.position = vSeries.rectCount;
                        groupingValues[groupName] = vSeries.rectCount++;
                    } else value.position = groupingValues[groupName];
                } else if (vSeries.position === null) {
                    value.position = vSeries.rectCount;
                    vSeries.position = vSeries.rectCount++;
                } else value.position = vSeries.position;
            } else value.position = vSeries.rectCount++;
        }
        for(var i = 0; i < seriesCollection.length; i++){
            var value = seriesCollection[i];
            value.rectCount = vSeries.rectCount;
        }
    };
    /**
     * Updates the location of the symbol based on the point and rect coordinates.
     *
     * @param {Points} point - The point for which the symbol location is updated.
     * @param {Rect} rect - The rect representing the symbol location.
     * @param {Series} series - The series to which the point belongs.
     * @returns {void}
     */ ColumnBase.prototype.updateSymbolLocation = function(point, rect, series) {
        if (!series.chart.requireInvertedAxis) this.updateXRegion(point, rect, series);
        else this.updateYRegion(point, rect, series);
        if (series.type === "Histogram") {
            point.minimum = +point.x - series.histogramValues.binWidth / 2;
            point.maximum = +point.x + series.histogramValues.binWidth / 2;
        }
    };
    /**
     * Updates the x-region of the symbol based on the point and rect coordinates.
     *
     * @param {Points} point - The point for which the x-region is updated.
     * @param {Rect} rect - The rect representing the x-region.
     * @param {Series} series - The series to which the point belongs.
     * @returns {void}
     */ ColumnBase.prototype.updateXRegion = function(point, rect, series) {
        point.symbolLocations.push({
            x: rect.x + rect.width / 2,
            y: series.seriesType === "BoxPlot" || series.seriesType.indexOf("HighLow") !== -1 || point.yValue >= 0 === !series.yAxis.isAxisInverse ? rect.y : rect.y + rect.height
        });
        this.getRegion(point, rect, series);
        if (series.type === "RangeColumn") point.symbolLocations.push({
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height
        });
    };
    /**
     * Updates the y-region of the symbol based on the point and rect coordinates.
     *
     * @param {Points} point - The point for which the y-region is updated.
     * @param {Rect} rect - The rect representing the y-region.
     * @param {Series} series - The series to which the point belongs.
     * @returns {void}
     */ ColumnBase.prototype.updateYRegion = function(point, rect, series) {
        point.symbolLocations.push({
            x: series.seriesType === "BoxPlot" || series.seriesType.indexOf("HighLow") !== -1 || point.yValue >= 0 === !series.yAxis.isAxisInverse ? rect.x + rect.width : rect.x,
            y: rect.y + rect.height / 2
        });
        this.getRegion(point, rect, series);
        if (series.type === "RangeColumn") point.symbolLocations.push({
            x: rect.x,
            y: rect.y + rect.height / 2
        });
    };
    /**
     * To render the marker for the series.
     *
     * @param {Series} series - The series for which markers are rendered.
     * @returns {void}
     * @private
     */ ColumnBase.prototype.renderMarker = function(series) {
        if (series.marker && series.marker.visible) series.chart.markerRender.render(series);
    };
    /**
     * To get the marker region when Y value is 0
     *
     * @param {Points} point point
     * @param {rect} rect rect
     * @param {Series} series series
     * @returns {void}
     */ ColumnBase.prototype.getRegion = function(point, rect, series) {
        if (point.y === 0) {
            var markerWidth = series.marker && series.marker.width ? series.marker.width : 0;
            var markerHeight = series.marker && series.marker.height ? series.marker.height : 0;
            point.regions.push(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(point.symbolLocations[0].x - markerWidth, point.symbolLocations[0].y - markerHeight, 2 * markerWidth, 2 * markerHeight));
        } else point.regions.push(rect);
    };
    /**
     * Triggers the point render event.
     *
     * @param {Series} series - The series associated with the point.
     * @param {Points} point - The data point for which the event is triggered.
     * @param {string} fill - The fill color of the point.
     * @param {BorderModel} border - The border settings of the point.
     * @returns {IPointRenderEventArgs} - The event arguments.
     */ ColumnBase.prototype.triggerEvent = function(series, point, fill, border) {
        var argsData = {
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$9f10d5daf06d56ca),
            series: series,
            point: point,
            fill: series.setPointColor(point, fill),
            border: series.setBorderColor(point, border)
        };
        series.chart.trigger((0, $9415fc5f023d8fac$export$9f10d5daf06d56ca), argsData);
        point.color = argsData.fill;
        return argsData;
    };
    /**
     * Draws a rectangle for the data point.
     *
     * @param {Series} series - The series associated with the point.
     * @param {Points} point - The data point for which the rectangle is drawn.
     * @param {Rect} rect - The rect bounds.
     * @param {IPointRenderEventArgs} argsData - The event arguments.
     * @returns {void}
     */ ColumnBase.prototype.drawRectangle = function(series, point, rect, argsData) {
        var chart = series.chart;
        var check = chart.requireInvertedAxis ? rect.height : rect.width;
        if (check <= 0) return null;
        var direction;
        if (point.y === 0) // For 0 values corner radius will not calculate
        direction = this.calculateRoundedRectPath(rect, 0, 0, 0, 0);
        else direction = this.calculateRoundedRectPath(rect, series.cornerRadius.topLeft, series.cornerRadius.topRight, series.cornerRadius.bottomLeft, series.cornerRadius.bottomRight, chart.requireInvertedAxis);
        var name = series.category === "Indicator" ? chart.element.id + "_Indicator_" + series.index + "_" + series.name + "_Point_" + point.index : chart.element.id + "_Series_" + series.index + "_Point_" + (series.removedPointIndex !== null && series.removedPointIndex <= point.index ? point.index + 1 : point.index);
        var previousElement = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(chart.redraw, name);
        var previousDirection = previousElement ? previousElement.getAttribute("d") : "";
        this.options = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(name, argsData.fill, argsData.border.width, argsData.border.color, series.opacity, series.border.dashArray, series.columnFacet === "Cylinder" ? "" : direction);
        this.element = chart.renderer.drawPath(this.options, new Int32Array([
            series.clipRect.x,
            series.clipRect.y
        ]));
        if (series.removedPointIndex !== null && series.removedPointIndex <= point.index) this.element.id = chart.element.id + "_Series_" + series.index + "_Point_" + point.index;
        switch(series.seriesType){
            case "XY":
                this.element.setAttribute("role", "img");
                this.element.setAttribute("aria-label", point.x + ":" + point.yValue + ", " + series.name);
                break;
            case "HighLow":
                this.element.setAttribute("role", "img");
                this.element.setAttribute("aria-label", point.x + ":" + point.high + ", " + point.low + ", " + series.name);
                break;
        }
        if (!(series.columnFacet === "Cylinder" && (chart.redraw || !chart.enableAnimation) && series.seriesElement.querySelector("#" + this.element.id))) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.seriesElement, this.element, chart.redraw);
        if (!series.chart.enableCanvas) (0, $11815a21a80ae2b7$export$55386e7bcaf82653)(this.element, series.columnFacet === "Cylinder" ? "" : direction, chart.redraw, previousDirection, chart.duration);
    };
    /**
     * To animate the series.
     *
     * @param {Series} series - The series to be animated.
     * @returns {void}
     * @private
     */ ColumnBase.prototype.animate = function(series) {
        var rectElements = series.seriesElement.childNodes;
        var count = series.category === "Indicator" ? 0 : 1;
        var visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(series);
        for(var _i = 0, visiblePoints_1 = visiblePoints; _i < visiblePoints_1.length; _i++){
            var point = visiblePoints_1[_i];
            if (!point.symbolLocations.length && !(series.type === "BoxAndWhisker" && point.regions.length)) continue;
            if ((series.type === "Column" || series.type === "Bar" || series.type === "StackingColumn" || series.type === "StackingColumn100" || series.type === "StackingBar" || series.type === "StackingBar100") && series.columnFacet === "Cylinder") for(var j = 0; j < rectElements.length; j++)this.animateRect(rectElements[j], series, point);
            else {
                this.animateRect(rectElements[count], series, point);
                count++;
            }
        }
    };
    /**
     * Animates the rect element.
     *
     * @param {HTMLElement} element - The rect element to be animated.
     * @param {Series} series - The series associated with the rect.
     * @param {Points} point - The data point associated with the rect.
     * @returns {void}
     */ ColumnBase.prototype.animateRect = function(element, series, point) {
        var option = series.animation;
        var duration = series.chart.animated ? series.chart.duration : option.duration;
        var effect = (0, $11815a21a80ae2b7$export$622b8dea40f28ece)("Linear");
        var isPlot = point.yValue < 0;
        var x;
        var y;
        var elementHeight = +point.regions[0].height;
        var elementWidth = +point.regions[0].width;
        var centerX;
        var centerY;
        if (!series.chart.requireInvertedAxis) {
            x = +point.regions[0].x;
            if (series.type.indexOf("Stacking") > -1) {
                y = (1 - (0, $11815a21a80ae2b7$export$f83186674b8cab09)(0, series.yAxis)) * series.yAxis.rect.height;
                centerX = x;
                centerY = y;
            } else {
                y = +point.regions[0].y;
                centerY = series.seriesType.indexOf("HighLow") !== -1 || series.type.indexOf("Waterfall") !== -1 ? y + elementHeight / 2 : isPlot !== series.yAxis.isAxisInverse ? y : y + elementHeight;
                centerX = isPlot ? x : x + elementWidth;
            }
        } else {
            y = +point.regions[0].y;
            if (series.type.indexOf("Stacking") > -1) {
                x = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(0, series.yAxis) * series.yAxis.rect.width;
                centerX = x;
                centerY = y;
            } else {
                x = +point.regions[0].x;
                centerY = isPlot ? y : y + elementHeight;
                centerX = series.seriesType.indexOf("HighLow") !== -1 || series.type.indexOf("Waterfall") !== -1 ? x + elementWidth / 2 : isPlot !== series.yAxis.isAxisInverse ? x + elementWidth : x;
            }
        }
        var value;
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            element.style.visibility = "hidden";
            new (0, $kj1BR.Animation)({}).animate(element, {
                duration: duration === 0 && (0, $kj1BR.animationMode) === "Enable" ? 1000 : duration,
                delay: option.delay,
                progress: function(args) {
                    if (args.timeStamp >= args.delay) {
                        element.style.visibility = "visible";
                        if (!series.chart.requireInvertedAxis) {
                            elementHeight = elementHeight ? elementHeight : 1;
                            value = effect(args.timeStamp - args.delay, 0, elementHeight, args.duration);
                            element.setAttribute("transform", "translate(" + centerX + " " + centerY + ") scale(1," + value / elementHeight + ") translate(" + -centerX + " " + -centerY + ")");
                        } else {
                            elementWidth = elementWidth ? elementWidth : 1;
                            value = effect(args.timeStamp - args.delay, 0, elementWidth, args.duration);
                            element.setAttribute("transform", "translate(" + centerX + " " + centerY + ") scale(" + value / elementWidth + ", 1) translate(" + -centerX + " " + -centerY + ")");
                        }
                    }
                },
                end: function() {
                    var annotations = document.getElementById(series.chart.element.id + "_Annotation_Collections");
                    if (annotations) annotations.style.visibility = "visible";
                    element.setAttribute("transform", "translate(0,0)");
                    var seriesElement = series.seriesElement;
                    if (element === seriesElement.lastElementChild || point.index === series.points.length - 1 || series.type === "Waterfall" && element === seriesElement.children[seriesElement.childElementCount - 2]) {
                        series.chart.trigger("animationComplete", {
                            series: series.chart.isBlazor ? {} : series
                        });
                        if (series.type === "Waterfall") {
                            var rectElements = seriesElement.childNodes;
                            for(var i = 0; i < rectElements.length; i++)if (rectElements[i].id.indexOf("Connector") !== -1) {
                                rectElements[i].style.visibility = "visible";
                                rectElements[i].setAttribute("transform", "translate(0,0)");
                            }
                        }
                    }
                }
            });
        }
    };
    /**
     * Calculates the path for a rounded rectangle.
     *
     * @param {Rect} rect - The bounding rectangle.
     * @param {number} topLeft - The radius of the top-left corner.
     * @param {number} topRight - The radius of the top-right corner.
     * @param {number} bottomLeft - The radius of the bottom-left corner.
     * @param {number} bottomRight - The radius of the bottom-right corner.
     * @param {boolean} inverted - Indicates whether the rectangle is inverted.
     * @returns {string} The SVG path string representing the rounded rectangle.
     */ ColumnBase.prototype.calculateRoundedRectPath = function(rect, topLeft, topRight, bottomLeft, bottomRight, inverted) {
        if (inverted === void 0) inverted = false;
        var halfValue = inverted ? rect.width / 2 : rect.height / 2;
        topLeft = Math.min(topLeft, halfValue);
        topRight = Math.min(topRight, halfValue);
        bottomLeft = Math.min(bottomLeft, halfValue);
        bottomRight = Math.min(bottomRight, halfValue);
        return "M " + rect.x + " " + (topLeft + rect.y) + " Q " + rect.x + " " + rect.y + " " + (rect.x + topLeft) + " " + rect.y + " " + "L" + " " + (rect.x + rect.width - topRight) + " " + rect.y + " Q " + (rect.x + rect.width) + " " + rect.y + " " + (rect.x + rect.width) + " " + (rect.y + topRight) + " " + "L " + (rect.x + rect.width) + " " + (rect.y + rect.height - bottomRight) + " Q " + (rect.x + rect.width) + " " + (rect.y + rect.height) + " " + (rect.x + rect.width - bottomRight) + " " + (rect.y + rect.height) + " " + "L " + (rect.x + bottomLeft) + " " + (rect.y + rect.height) + " Q " + rect.x + " " + (rect.y + rect.height) + " " + rect.x + " " + (rect.y + rect.height - bottomLeft) + " " + "L" + " " + rect.x + " " + (topLeft + rect.y) + " " + "Z";
    };
    return ColumnBase;
}();


var $2786904b7ad446ea$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `BarSeries` module is used to render the bar series.
 */ var $2786904b7ad446ea$export$2db55af16212ab81 = /** @class */ function(_super) {
    $2786904b7ad446ea$var$__extends(BarSeries, _super);
    function BarSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sideBySideInfo = [];
        return _this;
    }
    /**
     * Render Bar series.
     *
     * @param {Series} series - Defines the series.
     * @returns {void}
     * @private
     */ BarSeries.prototype.render = function(series) {
        var origin = Math.max(series.yAxis.visibleRange.min, 0);
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var pointBar = _a[_i];
            this.renderPoint(series, pointBar, this.sideBySideInfo[series.index], origin);
        }
        this.renderMarker(series);
    };
    BarSeries.prototype.renderPoint = function(series, pointBar, sideBySideInfo, origin) {
        pointBar.symbolLocations = [];
        pointBar.regions = [];
        if (pointBar.visible && (0, $11815a21a80ae2b7$export$812e0073c6ac0cb6)(series.points[pointBar.index - 1], pointBar, series.points[pointBar.index + 1], series)) {
            this.rect = this.getRectangle(pointBar.xValue + sideBySideInfo.start, pointBar.yValue, pointBar.xValue + sideBySideInfo.end, origin, series);
            this.rect.height = series.columnWidthInPixel ? series.columnWidthInPixel : this.rect.height;
            this.rect.y = series.columnWidthInPixel ? this.rect.y - (series.columnWidthInPixel / 2 * series.rectCount - series.columnWidthInPixel * series.index) : this.rect.y;
            var argsData = this.triggerEvent(series, pointBar, series.interior, {
                width: series.border.width,
                color: series.border.color
            });
            if (!argsData.cancel) {
                this.updateSymbolLocation(pointBar, this.rect, series);
                this.drawRectangle(series, pointBar, this.rect, argsData);
                if (series.columnFacet === "Cylinder") {
                    var cylinderSeriesOption = {
                        "isColumn": false,
                        "stacking": false,
                        "isLastSeries": true
                    };
                    this.drawCylinder(this.options, this.element, cylinderSeriesOption, this.rect, series);
                }
            }
        }
    };
    BarSeries.prototype.updateDirection = function(series, point) {
        var origin = Math.max(series.yAxis.visibleRange.min, 0);
        for(var i = 0; i < point.length; i++){
            this.renderPoint(series, series.points[point[i]], this.sideBySideInfo[series.index], origin);
            if (series.marker && series.marker.visible) series.chart.markerRender.renderMarker(series, series.points[point[i]], series.points[point[i]].symbolLocations[0], null, true);
            if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                series.chart.dataLabelModule.commonId = series.chart.element.id + "_Series_" + series.index + "_Point_";
                series.chart.dataLabelModule.renderDataLabel(series, series.points[point[i]], null, series.marker.dataLabel);
            }
        }
    };
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */ BarSeries.prototype.doAnimation = function(series) {
        this.animate(series);
    };
    /**
     * To destroy the bar series.
     *
     * @returns {void}
     * @private
     */ BarSeries.prototype.destroy = function() {
    /**
         * Destroy method performed here.
         */ };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ BarSeries.prototype.getModuleName = function() {
        return "BarSeries";
    };
    return BarSeries;
}((0, $7517da37aebd6aac$export$c1c08c4b2dec0f8e));



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

var $19313fc5261e264e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Common axis classes
 *
 * @private
 */ var $19313fc5261e264e$export$9e27a64763f4e143 = /** @class */ function(_super) {
    $19313fc5261e264e$var$__extends(NiceInterval, _super);
    function NiceInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Method to calculate numeric datetime interval.
     *
     * @param {Axis} axis - The axis for which to calculate the interval.
     * @param {Size} size - The size of the axis.
     * @param {number} start - The start value of the axis.
     * @param {number} end - The end value of the axis.
     * @param {boolean} [isChart=true] - Indicating whether it's a chart. Defaults to true.
     * @returns {number} - The calculated numeric datetime interval.
     */ NiceInterval.prototype.calculateDateTimeNiceInterval = function(axis, size, start, end, isChart) {
        if (isChart === void 0) isChart = true;
        var oneDay = 86400000;
        var startDate = new Date(start);
        var endDate = new Date(end);
        //var axisInterval ;
        var totalDays = Math.abs((startDate.getTime() - endDate.getTime()) / oneDay);
        var interval;
        axis.actualIntervalType = axis.intervalType;
        var type = axis.intervalType;
        switch(type){
            case "Years":
                interval = this.calculateNumericNiceInterval(axis, totalDays / 365, size);
                break;
            case "Quarter":
                interval = this.calculateNumericNiceInterval(axis, totalDays / 365 * 4, size);
                break;
            case "Months":
                interval = this.calculateNumericNiceInterval(axis, totalDays / 30, size);
                break;
            case "Weeks":
                interval = this.calculateNumericNiceInterval(axis, totalDays / 7, size);
                break;
            case "Days":
                interval = this.calculateNumericNiceInterval(axis, totalDays, size);
                break;
            case "Hours":
                interval = this.calculateNumericNiceInterval(axis, totalDays * 24, size);
                break;
            case "Minutes":
                interval = this.calculateNumericNiceInterval(axis, totalDays * 1440, size);
                break;
            case "Seconds":
                interval = this.calculateNumericNiceInterval(axis, totalDays * 86400, size);
                break;
            case "Auto":
                interval = this.calculateNumericNiceInterval(axis, totalDays / 365, size);
                if (interval >= 1) {
                    axis.actualIntervalType = "Years";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays / 30, size);
                if (interval >= 1) {
                    axis.actualIntervalType = "Months";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays / 7, size);
                if (interval >= 1 && !isChart) {
                    axis.actualIntervalType = "Weeks";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays, size);
                if (interval >= 1) {
                    axis.actualIntervalType = "Days";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays * 24, size);
                if (interval >= 1) {
                    axis.actualIntervalType = "Hours";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays * 1440, size);
                if (interval >= 1) {
                    axis.actualIntervalType = "Minutes";
                    return interval;
                }
                interval = this.calculateNumericNiceInterval(axis, totalDays * 86400, size);
                axis.actualIntervalType = "Seconds";
                return interval;
        }
        return interval;
    };
    /**
     * To get the skeleton for the DateTime axis.
     *
     * @param {Axis} axis - The DateTime axis for which to get the skeleton.
     * @param {number} currentValue - The current value.
     * @param {number} previousValue - The previous value.
     * @param {boolean} isBlazor - Indicates whether it's for Blazor.
     * @returns {string} - The skeleton for the DateTime axis.
     * @private
     */ NiceInterval.prototype.getSkeleton = function(axis, currentValue, previousValue, isBlazor) {
        var skeleton;
        var intervalType = axis.actualIntervalType;
        if (axis.skeleton) return axis.skeleton;
        if (intervalType === "Years") {
            if (isBlazor) skeleton = axis.isChart ? axis.valueType === "DateTime" ? "y" : "y" : "y";
            else skeleton = axis.isChart ? axis.valueType === "DateTime" && axis.isIntervalInDecimal ? "y" : "yMMM" : "y";
        } else if (intervalType === "Quarter") skeleton = isBlazor ? "y" : "yMMM";
        else if (intervalType === "Months") {
            if (isBlazor) skeleton = axis.isChart ? "m" : "m";
            else skeleton = axis.isChart ? "MMMd" : "MMM";
        } else if (intervalType === "Weeks") skeleton = isBlazor ? "m" : "MEd";
        else if (intervalType === "Days") {
            if (isBlazor) skeleton = "d";
            else skeleton = axis.isChart ? axis.valueType === "DateTime" ? "MMMd" : "yMd" : "MMMd";
        } else if (intervalType === "Hours") {
            if (isBlazor) skeleton = "t";
            else skeleton = axis.isChart ? axis.valueType === "DateTime" ? "Hm" : "EHm" : "h";
        } else if (intervalType === "Minutes") {
            if (isBlazor) skeleton = "T";
            else skeleton = axis.isChart ? "Hms" : "hm";
        } else if (isBlazor) skeleton = "T";
        else skeleton = axis.isChart ? "Hms" : "hms";
        return skeleton;
    };
    /**
     * Find label format for axis
     *
     * @param {Axis} axis - axis
     * @returns {string} - Returns the label format.
     * @private
     */ NiceInterval.prototype.findCustomFormats = function(axis) {
        var labelFormat = axis.labelFormat ? axis.labelFormat : "";
        if (axis.isChart && !axis.skeleton && axis.actualIntervalType === "Months" && !labelFormat) labelFormat = axis.valueType === "DateTime" ? "MMM yyyy" : "yMMM";
        return labelFormat;
    };
    return NiceInterval;
}((0, $5e1e0b5d807dfa70$export$340e583a64e26663));


var $5a5b2b40af1980fd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `Category` module is used to render the category axis in charts.
 *
 * @private
 */ var $5a5b2b40af1980fd$export$3a8840c5b2ecf003 = /** @class */ function(_super) {
    $5a5b2b40af1980fd$var$__extends(Category, _super);
    /**
     * Constructor for the category module.
     *
     * @private
     * @param {Chart} chart - Specifies the chart.
     */ function Category(chart) {
        return _super.call(this, chart) || this;
    }
    /**
     * The function to calculate the range and labels for the axis.
     *
     * @private
     * @returns {void}
     */ Category.prototype.calculateRangeAndInterval = function(size, axis) {
        this.calculateRange(axis);
        this.getActualRange(axis, size);
        this.applyRangePadding(axis, size);
        this.calculateVisibleLabels(axis);
    };
    /**
     * Actual Range for the axis.
     *
     * @private
     */ Category.prototype.getActualRange = function(axis, size) {
        this.initializeDoubleRange(axis);
        // axis.doubleRange = new DoubleRange(<number>this.min, <number>this.max);
        axis.actualRange = {};
        if (!axis.interval) axis.actualRange.interval = Math.max(1, Math.floor(axis.doubleRange.delta / (0, $11815a21a80ae2b7$export$4e4203e7203e8f7b)(size, axis)));
        else axis.actualRange.interval = Math.ceil(axis.interval);
        axis.actualRange.min = axis.doubleRange.start;
        axis.actualRange.max = axis.doubleRange.end;
        axis.actualRange.delta = axis.doubleRange.delta;
    };
    /**
     * Padding for the axis.
     *
     * @private
     * @param {Axis} axis - The axis for which padding is applied.
     * @param {Size} size - The size for padding.
     * @returns {void}
     */ Category.prototype.applyRangePadding = function(axis, size) {
        var isColumn;
        axis.series.forEach(function(element) {
            if (!isColumn) isColumn = (element.type.indexOf("Column") > -1 || element.type.indexOf("Bar") > -1) && !(axis.zoomFactor < 1 || axis.zoomPosition > 0) && (0, $3EnZW.isNullOrUndefined)(axis.minimum) && (0, $3EnZW.isNullOrUndefined)(axis.maximum);
        });
        var ticks = (axis.labelPlacement === "BetweenTicks" || isColumn) && !this.chart.stockChart && this.chart.chartAreaType !== "PolarRadar" ? 0.5 : 0;
        if (ticks > 0) {
            axis.actualRange.min -= ticks;
            axis.actualRange.max += ticks;
        } else axis.actualRange.max += axis.actualRange.max ? 0 : 0.5;
        axis.doubleRange = new (0, $b583e56aa322bfca$export$6bc42eb49cfbe353)(axis.actualRange.min, axis.actualRange.max);
        axis.actualRange.delta = axis.doubleRange.delta;
        this.calculateVisibleRange(size, axis);
    };
    /**
     * Calculate label for the axis.
     *
     * @private
     */ Category.prototype.calculateVisibleLabels = function(axis) {
        /** Generate axis labels */ axis.visibleLabels = [];
        axis.visibleRange.interval = axis.visibleRange.interval < 1 ? 1 : axis.visibleRange.interval;
        var tempInterval = Math.ceil(axis.visibleRange.min);
        var labelStyle;
        if (axis.zoomFactor < 1 || axis.zoomPosition > 0) tempInterval = axis.visibleRange.min - axis.visibleRange.min % axis.visibleRange.interval;
        var position;
        axis.startLabel = axis.labels[Math.round(axis.visibleRange.min)];
        axis.endLabel = axis.labels[Math.floor(axis.visibleRange.max)];
        for(; tempInterval <= axis.visibleRange.max; tempInterval += axis.visibleRange.interval){
            labelStyle = (0, $3EnZW.extend)({}, (0, $3EnZW.getValue)("properties", axis.labelStyle), null, true);
            if ((0, $11815a21a80ae2b7$export$ee35c16ea07b4b7f)(tempInterval, axis.visibleRange) && axis.labels.length > 0) {
                position = Math.round(tempInterval);
                (0, $11815a21a80ae2b7$export$3354c8a0fc977929)(this.chart, position, axis.labels[position] ? axis.labels[position].toString() : "", labelStyle, axis);
            }
        }
        if (axis.getMaxLabelWidth) axis.getMaxLabelWidth(this.chart);
    };
    /**
     * Get module name
     */ Category.prototype.getModuleName = function() {
        /**
         * Returns the module name
         */ return "Category";
    };
    /**
     * To destroy the category axis.
     *
     * @returns {void}
     * @private
     */ Category.prototype.destroy = function() {
    /**
         * Destroy method performed here
         */ };
    return Category;
}((0, $19313fc5261e264e$export$9e27a64763f4e143));

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");
var $e7i2H = parcelRequire("e7i2H");
var $4ZDHT = parcelRequire("4ZDHT");
var $i528u = parcelRequire("i528u");
var $c2qqN = parcelRequire("c2qqN");


var $11b41024b246dc37$export$d8193b87c12692b4 = {
    size: "13px",
    fontWeight: "400",
    color: null,
    fontStyle: "Normal",
    fontFamily: "Segoe UI"
};
function $11b41024b246dc37$export$658435d9066c1b51(theme) {
    var palette;
    switch(theme){
        case "Fabric":
            palette = [
                "#4472c4",
                "#ed7d31",
                "#ffc000",
                "#70ad47",
                "#5b9bd5",
                "#c1c1c1",
                "#6f6fe2",
                "#e269ae",
                "#9e480e",
                "#997300"
            ];
            break;
        case "Bootstrap4":
            palette = [
                "#a16ee5",
                "#f7ce69",
                "#55a5c2",
                "#7ddf1e",
                "#ff6ea6",
                "#7953ac",
                "#b99b4f",
                "#407c92",
                "#5ea716",
                "#b91c52"
            ];
            break;
        case "Bootstrap":
            palette = [
                "#a16ee5",
                "#f7ce69",
                "#55a5c2",
                "#7ddf1e",
                "#ff6ea6",
                "#7953ac",
                "#b99b4f",
                "#407c92",
                "#5ea716",
                "#b91c52"
            ];
            break;
        case "HighContrastLight":
        case "HighContrast":
            palette = [
                "#79ECE4",
                "#E98272",
                "#DFE6B6",
                "#C6E773",
                "#BA98FF",
                "#FA83C3",
                "#00C27A",
                "#43ACEF",
                "#D681EF",
                "#D8BC6E"
            ];
            break;
        case "MaterialDark":
            palette = [
                "#9ECB08",
                "#56AEFF",
                "#C57AFF",
                "#61EAA9",
                "#EBBB3E",
                "#F45C5C",
                "#8A77FF",
                "#63C7FF",
                "#FF84B0",
                "#F7C928"
            ];
            break;
        case "FabricDark":
            palette = [
                "#4472c4",
                "#ed7d31",
                "#ffc000",
                "#70ad47",
                "#5b9bd5",
                "#c1c1c1",
                "#6f6fe2",
                "#e269ae",
                "#9e480e",
                "#997300"
            ];
            break;
        case "BootstrapDark":
            palette = [
                "#a16ee5",
                "#f7ce69",
                "#55a5c2",
                "#7ddf1e",
                "#ff6ea6",
                "#7953ac",
                "#b99b4f",
                "#407c92",
                "#5ea716",
                "#b91c52"
            ];
            break;
        case "Tailwind":
            palette = [
                "#5A61F6",
                "#65A30D",
                "#334155",
                "#14B8A6",
                "#8B5CF6",
                "#0369A1",
                "#F97316",
                "#9333EA",
                "#F59E0B",
                "#15803D"
            ];
            break;
        case "TailwindDark":
            palette = [
                "#8B5CF6",
                "#22D3EE",
                "#F87171",
                "#4ADE80",
                "#E879F9",
                "#FCD34D",
                "#F97316",
                "#2DD4BF",
                "#F472B6",
                "#10B981"
            ];
            break;
        case "Bootstrap5Dark":
        case "Bootstrap5":
            palette = [
                "#FD7E14",
                "#6610F2",
                "#6F42C1",
                "#D63384",
                "#DC3545",
                "#FFC107",
                "#198754",
                "#0DCAF0"
            ];
            break;
        case "FluentDark":
            palette = [
                "#1AC9E6",
                "#DA4CB2",
                "#EDBB40",
                "#AF4BCF",
                "#FF7266",
                "#1BD565",
                "#EE993D",
                "#5887FF",
                "#EC548D",
                "#7D39C0"
            ];
            break;
        case "Fluent":
            palette = [
                "#1AC9E6",
                "#DA4CB2",
                "#EDBB40",
                "#AF4BCF",
                "#FF7266",
                "#1BD565",
                "#EE993D",
                "#5887FF",
                "#EC548D",
                "#7D39C0"
            ];
            break;
        case "Fluent2":
            palette = [
                "#6200EE",
                "#09AF74",
                "#0076E5",
                "#CB3587",
                "#E7910F",
                "#0364DE",
                "#66CD15",
                "#F3A93C",
                "#107C10",
                "#C19C00"
            ];
            break;
        case "Fluent2Dark":
            palette = [
                "#9BB449",
                "#2A72D5",
                "#43B786",
                "#3F579A",
                "#584EC6",
                "#E85F9C",
                "#6E7A89",
                "#EA6266",
                "#0B6A0B",
                "#C19C00"
            ];
            break;
        case "Fluent2HighContrast":
            palette = [
                "#9BB449",
                "#2A72D5",
                "#43B786",
                "#3F579A",
                "#584EC6",
                "#E85F9C",
                "#6E7A89",
                "#EA6266",
                "#0B6A0B",
                "#C19C00"
            ];
            break;
        case "Material3":
            palette = [
                "#6355C7",
                "#00AEE0",
                "#FFB400",
                "#F7523F",
                "#963C70",
                "#FD7400",
                "#4BE0BC",
                "#2196F5",
                "#DE3D8A",
                "#162F88"
            ];
            break;
        case "Material3Dark":
            palette = [
                "#4EAAFF",
                "#FA4EAB",
                "#FFF500",
                "#17EA58",
                "#38FFE7",
                "#FF9E45",
                "#B3F32F",
                "#B93CE4",
                "#FC5664",
                "#9B55FF"
            ];
            break;
        default:
            palette = [
                "#00bdae",
                "#404041",
                "#357cd2",
                "#e56590",
                "#f8b883",
                "#70ad47",
                "#dd8abd",
                "#7f84e8",
                "#7bb4eb",
                "#ea7a57"
            ];
            break;
    }
    return palette;
}
function $11b41024b246dc37$export$e22c5d06d177c3fa(theme, canvas, chart) {
    var style;
    var darkBackground = theme === "MaterialDark" ? "#383838" : theme === "FabricDark" ? "#242424" : "#1b1b1b";
    switch(theme){
        case "HighContrastLight":
        case "HighContrast":
            style = {
                axisLabel: "#ffffff",
                axisTitle: "#ffffff",
                axisLine: "#ffffff",
                majorGridLine: "#BFBFBF",
                minorGridLine: "#969696",
                majorTickLine: "#BFBFBF",
                minorTickLine: "#969696",
                chartTitle: "#ffffff",
                legendLabel: "#ffffff",
                background: canvas ? "#000000" : "transparent",
                areaBorder: "#ffffff",
                errorBar: "#ffffff",
                crosshairLine: "#ffffff",
                crosshairFill: "#ffffff",
                crosshairLabel: "#000000",
                tooltipFill: "#ffffff",
                tooltipBoldLabel: "#000000",
                tooltipLightLabel: "#000000",
                tooltipHeaderLine: "#969696",
                markerShadow: "#BFBFBF",
                selectionRectFill: "rgba(255, 217, 57, 0.3)",
                selectionRectStroke: "#ffffff",
                selectionCircleStroke: "#FFD939",
                tabColor: "#FFD939",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#FFD939",
                toolkitFill: "#737373",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#969696",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#969696",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#000000",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#969696",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#000000",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#969696",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "MaterialDark":
        case "FabricDark":
        case "BootstrapDark":
            style = {
                axisLabel: "#DADADA",
                axisTitle: "#ffffff",
                axisLine: " #6F6C6C",
                majorGridLine: "#414040",
                minorGridLine: "#514F4F",
                majorTickLine: "#414040",
                minorTickLine: " #4A4848",
                chartTitle: "#ffffff",
                legendLabel: "#DADADA",
                background: canvas ? darkBackground : "transparent",
                areaBorder: " #9A9A9A",
                errorBar: "#ffffff",
                crosshairLine: "#F4F4F4",
                crosshairFill: theme === "MaterialDark" ? "#F4F4F4" : theme === "FabricDark" ? "#A19F9D" : "#F0F0F0",
                crosshairLabel: "#282727",
                tooltipFill: "#F4F4F4",
                tooltipBoldLabel: "#282727",
                tooltipLightLabel: "#333232",
                tooltipHeaderLine: "#9A9A9A",
                markerShadow: null,
                selectionRectFill: "rgba(56,169,255, 0.1)",
                selectionRectStroke: "#38A9FF",
                selectionCircleStroke: "#282727",
                tabColor: theme === "MaterialDark" ? "#00B0FF" : theme === "FabricDark" ? "#0074CC" : "#0070F0",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: theme === "MaterialDark" ? "#00B0FF" : theme === "FabricDark" ? "#0074CC" : "#0070F0",
                toolkitFill: "#737373",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.87)" : theme === "FabricDark" ? "#DADADA" : "#FFFFFF",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.6)" : theme === "FabricDark" ? "#A19F9D" : "#CED4DA",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.87)" : theme === "FabricDark" ? "#DADADA" : "#FFFFFF",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.6)" : theme === "FabricDark" ? "#A19F9D" : "#676767",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: theme === "MaterialDark" ? "rgba(18, 18, 18, 1)" : theme === "FabricDark" ? "#DADADA" : "#1A1A1A",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.87)" : theme === "FabricDark" ? "#DADADA" : "#FFFFFF",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.6)" : theme === "FabricDark" ? "#A19F9D" : "#676767",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.87)" : theme === "FabricDark" ? "#DADADA" : "#FFFFFF",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: theme === "MaterialDark" ? "rgba(18, 18, 18, 1)" : theme === "FabricDark" ? "#DADADA" : "#1A1A1A",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: theme === "MaterialDark" ? "rgba(255, 255, 255, 0.24)" : theme === "FabricDark" ? "#6F6C6C" : "#414141",
                    fontFamily: theme === "MaterialDark" ? "Roboto" : theme === "FabricDark" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Bootstrap4":
            style = {
                axisLabel: "#212529",
                axisTitle: "#212529",
                axisLine: "#CED4DA",
                majorGridLine: "#CED4DA",
                minorGridLine: "#DEE2E6",
                majorTickLine: "#ADB5BD",
                minorTickLine: "#CED4DA",
                chartTitle: "#212529",
                legendLabel: "#212529",
                background: canvas ? "#FFFFFF" : "transparent",
                areaBorder: "#DEE2E6",
                errorBar: "#000000",
                crosshairLine: "#6C757D",
                crosshairFill: "#212529",
                crosshairLabel: "#FFFFFF",
                tooltipFill: "#020202",
                tooltipBoldLabel: "rgba(255,255,255)",
                tooltipLightLabel: "rgba(255,255,255, 0.9)",
                tooltipHeaderLine: "rgba(255,255,255, 0.2)",
                markerShadow: null,
                selectionRectFill: "rgba(255,255,255, 0.1)",
                selectionRectStroke: "rgba(0, 123, 255)",
                selectionCircleStroke: "#495057",
                tabColor: "#007BFF",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#007BFF",
                toolkitFill: "#495057",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-5, -5, 26, 26),
                chartTitleFont: {
                    color: "#212529",
                    fontFamily: "Helvetica",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#495057",
                    fontFamily: "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#212529",
                    fontFamily: "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#666666",
                    fontFamily: "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#F9FAFB",
                    fontFamily: "Helvetica",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#212529",
                    fontFamily: "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#495057",
                    fontFamily: "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#212529",
                    fontFamily: "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#F9FAFB",
                    fontFamily: "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#6C757D",
                    fontFamily: "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Tailwind":
            style = {
                axisLabel: "#6B728",
                axisTitle: "#374151",
                axisLine: " #D1D5DB",
                majorGridLine: "#E5E7EB",
                minorGridLine: "#E5E7EB",
                majorTickLine: "#D1D5DB",
                minorTickLine: " #D1D5DB",
                chartTitle: "#374151",
                legendLabel: "#374151",
                background: canvas ? "rgba(255,255,255, 0.0)" : "transparent",
                areaBorder: " #E5E7EB",
                errorBar: "#374151",
                crosshairLine: "#1F2937",
                crosshairFill: "#111827",
                crosshairLabel: "#F9FAFB",
                tooltipFill: "#111827",
                tooltipBoldLabel: "#D1D5DB",
                tooltipLightLabel: "#F9FAFB",
                tooltipHeaderLine: "#6B7280",
                markerShadow: null,
                selectionRectFill: "rgba(79,70,229, 0.1)",
                selectionRectStroke: "#4F46E5",
                selectionCircleStroke: "#6B7280",
                tabColor: "#4F46E5",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#4F46E5",
                toolkitFill: "#6B7280",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: "#374151",
                    fontFamily: "Inter",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#6B7280",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#374151",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#374151",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#F9FAFB",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#374151",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#6B7280",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#374151",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#F9FAFB",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "TailwindDark":
            style = {
                axisLabel: "#9CA3AF",
                axisTitle: "#9CA3AF",
                axisLine: " #4B5563",
                majorGridLine: "#374151",
                minorGridLine: "#374151",
                majorTickLine: "#4B5563",
                minorTickLine: " #4B5563",
                chartTitle: "#D1D5DB",
                legendLabel: "#D1D5DB",
                background: canvas ? "#1f2937" : "transparent",
                areaBorder: " #374151",
                errorBar: "#ffffff",
                crosshairLine: "#9CA3AF",
                crosshairFill: "#F9FAFB",
                crosshairLabel: "#1F2937",
                tooltipFill: "#F9FAFB",
                tooltipBoldLabel: "#6B7280",
                tooltipLightLabel: "#1F2937",
                tooltipHeaderLine: "#9CA3AF",
                markerShadow: null,
                selectionRectFill: "rgba(34,211,238, 0.1)",
                selectionRectStroke: "#22D3EE",
                selectionCircleStroke: "#282727",
                tabColor: "#22D3EE",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#22D3EE",
                toolkitFill: "#D1D5DB",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#9CA3AF",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#1F2937",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#9CA3AF",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#D1D5DB",
                    fontFamily: "Inter",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#1F2937",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#6B7280",
                    fontFamily: "Inter",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Bootstrap5":
            style = {
                axisLabel: "#212529",
                axisTitle: "#212529",
                axisLine: "#DEE2E6",
                majorGridLine: "#E9ECEF",
                minorGridLine: "#E9ECEF",
                majorTickLine: "#DEE2E6",
                minorTickLine: "#E9ECEF",
                chartTitle: "#212529",
                legendLabel: "#212529",
                background: canvas ? "#212529" : "transparent",
                areaBorder: "#E9ECEF",
                errorBar: "#343A40",
                crosshairLine: "#343A40",
                crosshairFill: "#000000",
                crosshairLabel: "#FFFFFF",
                tooltipFill: "#E9ECEF",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#FFFFFF",
                markerShadow: null,
                selectionRectFill: "rgba(134,183,254, 0.1)",
                selectionRectStroke: "#0D6EFD",
                selectionCircleStroke: "#6B7280",
                tabColor: "#0D6EFD",
                bearFillColor: "#DC3545",
                bullFillColor: "#6F42C1",
                toolkitSelectionColor: "#6E757D",
                toolkitFill: "#6E757D",
                toolkitIconRectOverFill: "#F8F9FA",
                toolkitIconRectSelectionFill: "#F8F9FA",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-6, -8, 32, 32),
                chartTitleFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "16px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: chart.getModuleName() === "accumulationchart" ? "#21252980" : "#212529",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "14px" : "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                crosshairLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                stripLineLabelFont: {
                    color: "#6C757D",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Bootstrap5Dark":
            style = {
                axisLabel: "#DEE2E6",
                axisTitle: "#DEE2E6",
                axisLine: "#495057",
                majorGridLine: "#343A40",
                minorGridLine: "#343A40",
                majorTickLine: "#495057",
                minorTickLine: "#343A40",
                chartTitle: "#DEE2E6",
                legendLabel: "#DEE2E6",
                background: canvas ? "#212529" : "transparent",
                areaBorder: "#343A40",
                errorBar: "#ADB5BD",
                crosshairLine: "#ADB5BD",
                crosshairFill: "#FFFFFF",
                crosshairLabel: "#212529",
                tooltipFill: "#FFFFFF",
                tooltipBoldLabel: "#212529",
                tooltipLightLabel: "#212529",
                tooltipHeaderLine: "#212529",
                markerShadow: null,
                selectionRectFill: "rgba(134,183,254, 0.25)",
                selectionRectStroke: "#0D6EFD",
                selectionCircleStroke: "#0D6EFD",
                tabColor: "#0D6EFD",
                bearFillColor: "#DC3545",
                bullFillColor: "#6F42C1",
                toolkitSelectionColor: "#F8F9FA",
                toolkitFill: "#ADB5BD",
                toolkitIconRectOverFill: "#2B3035",
                toolkitIconRectSelectionFill: "#343A40",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-6, -8, 32, 32),
                chartTitleFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "16px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: chart.getModuleName() === "accumulationchart" ? "#DEE2E680" : "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "14px" : "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                crosshairLabelFont: {
                    color: "#212529",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                stripLineLabelFont: {
                    color: "#DEE2E6",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Fluent":
            style = {
                axisLabel: "#3B3A39",
                axisTitle: "#201F1E",
                axisLine: "#D2D0CE",
                majorGridLine: "#EDEBE9",
                minorGridLine: "#EDEBE9",
                majorTickLine: "#D2D0CE",
                minorTickLine: " #D2D0CE",
                chartTitle: "#201F1E",
                legendLabel: "#323130",
                background: canvas ? "#FFFFFF" : "transparent",
                areaBorder: "#EDEBE9",
                errorBar: "#A19F9D",
                crosshairLine: "#A19F9D",
                crosshairFill: "#FFFFFF",
                crosshairLabel: "#323130",
                tooltipFill: "#FFFFFF",
                tooltipBoldLabel: "#323130",
                tooltipLightLabel: "#323130",
                tooltipHeaderLine: "#D2D0CE",
                markerShadow: null,
                selectionRectFill: "rgba(79,70,229, 0.1)",
                selectionRectStroke: "#4F46E5",
                selectionCircleStroke: "#6B7280",
                tabColor: "#0078D4",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#0078D4",
                toolkitFill: "#A19F9D",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: "#201F1E",
                    fontFamily: "Segoe UI",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#3B3A39",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#201F1E",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#49454E",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#323130",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#201F1E",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#3B3A39",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#323129",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#323130",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#A19F9D",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "FluentDark":
            style = {
                axisLabel: "#C8C6C4",
                axisTitle: "#F3F2F1",
                axisLine: "#3B3A39",
                majorGridLine: "#414040",
                minorGridLine: "#414040",
                majorTickLine: "#3B3A39",
                minorTickLine: "#3B3A39",
                chartTitle: "#F3F2F1",
                legendLabel: "#D2D0CE",
                background: canvas ? "#383838" : "transparent",
                areaBorder: "#414040",
                errorBar: "#D2D0CE",
                crosshairLine: "#D2D0CE",
                crosshairFill: "#323130",
                crosshairLabel: "#F3F2F1",
                tooltipFill: "#252423",
                tooltipBoldLabel: "#F3F2F1",
                tooltipLightLabel: "#F3F2F1",
                tooltipHeaderLine: "#3B3A39",
                markerShadow: null,
                selectionRectFill: "rgba(79,70,229, 0.1)",
                selectionRectStroke: "#4F46E5",
                selectionCircleStroke: "#6B7280",
                tabColor: "#0078D4",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: "#0078D4",
                toolkitFill: "#484644",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: "#C8C6C4",
                    fontFamily: "Segoe UI",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#C8C6C4",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#F3F2F1",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#D2D0CE",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#F3F2F1",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#F3F2F2",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#D2D0CE",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#F3F2F1",
                    fontFamily: "Segoe UI",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#F3F2F1",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#484644",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Fluent2":
            style = {
                axisLabel: "#616161",
                axisTitle: "#242424",
                axisLine: "#D2D0CE",
                majorGridLine: "#EDEBE9",
                minorGridLine: "#EDEBE9",
                majorTickLine: "#D2D0CE",
                minorTickLine: "#D2D0CE",
                chartTitle: "#242424",
                legendLabel: "#242424",
                background: canvas ? "#383838" : "transparent",
                areaBorder: "#EDEBE9",
                errorBar: "#A19F9D",
                crosshairLine: "#A19F9D",
                crosshairFill: "#FFFFFF",
                crosshairLabel: "#242424",
                tooltipFill: "#FFFFFF",
                tooltipBoldLabel: "#242424",
                tooltipLightLabel: "#242424",
                tooltipHeaderLine: "#D2D0CE",
                markerShadow: null,
                selectionRectFill: "rgba(180, 214, 250, 0.1)",
                selectionRectStroke: "#0F6CBD",
                selectionCircleStroke: "#0F6CBD",
                tabColor: "#0078D4",
                bearFillColor: "#E7910F",
                bullFillColor: "#0076E5",
                toolkitSelectionColor: "#424242",
                toolkitFill: "#424242",
                toolkitIconRectOverFill: "#E6E6E6",
                toolkitIconRectSelectionFill: "#E6E6E6",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-6, -8, 32, 32),
                chartTitleFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "16px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#616161",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#616161",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "chart" ? "12px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                crosshairLabelFont: {
                    color: "#242424",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "700"
                },
                stripLineLabelFont: {
                    color: "#616161",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Fluent2HighContrast":
            style = {
                axisLabel: "#FFFFFF",
                axisTitle: "#FFFFFF",
                axisLine: "#3B3A39",
                majorGridLine: "#292827",
                minorGridLine: "#3B3A39",
                majorTickLine: "#292827",
                minorTickLine: "#292827",
                chartTitle: "#FFFFFF",
                legendLabel: "#FFFFFF",
                background: canvas ? "#383838" : "transparent",
                areaBorder: "#292827",
                errorBar: "#8A8886",
                crosshairLine: "#8A8886",
                crosshairFill: "#000000",
                crosshairLabel: "#FFFFFF",
                tooltipFill: "#292929",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#3B3A39",
                markerShadow: null,
                selectionRectFill: "rgba(26, 235, 255, 0.2)",
                selectionRectStroke: "#1AEBFF",
                selectionCircleStroke: "#1AEBFF",
                tabColor: "#0078D4",
                bearFillColor: "#584EC6",
                bullFillColor: "#43B786",
                toolkitSelectionColor: "#FFFFFF",
                toolkitFill: "#FFFFFF",
                toolkitIconRectOverFill: "#1AEBFF",
                toolkitIconRectSelectionFill: "#1AEBFF",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-6, -8, 32, 32),
                chartTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "16px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "chart" ? "12px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                crosshairLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "700"
                },
                stripLineLabelFont: {
                    color: "#ADADAD",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Fluent2Dark":
            style = {
                axisLabel: "#ADADAD",
                axisTitle: "#FFFFFF",
                axisLine: "#3B3A39",
                majorGridLine: "#3B3A39",
                minorGridLine: "#3B3A39",
                majorTickLine: "#292827",
                minorTickLine: "#292827",
                chartTitle: "#FFFFFF",
                legendLabel: "#FFFFFF",
                background: canvas ? "#383838" : "transparent",
                areaBorder: "#292827",
                errorBar: "#8A8886",
                crosshairLine: "#8A8886",
                crosshairFill: "#292929",
                crosshairLabel: "#FFFFFF",
                tooltipFill: "#292929",
                tooltipBoldLabel: "#FFFFFF",
                tooltipLightLabel: "#FFFFFF",
                tooltipHeaderLine: "#3B3A39",
                markerShadow: null,
                selectionRectFill: "rgba(14, 71, 117, 0.1)",
                selectionRectStroke: "#115EA3",
                selectionCircleStroke: "#115EA3",
                tabColor: "#0078D4",
                bearFillColor: "#584EC6",
                bullFillColor: "#43B786",
                toolkitSelectionColor: "#D6D6D6",
                toolkitFill: "#D6D6D6",
                toolkitIconRectOverFill: "#333333",
                toolkitIconRectSelectionFill: "#333333",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-6, -8, 32, 32),
                chartTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "accumulationchart" ? "16px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#ADADAD",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#ADADAD",
                    fontFamily: "Segoe UI",
                    size: chart.getModuleName() === "chart" ? "12px" : "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                crosshairLabelFont: {
                    color: "#FFFFFF",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "700"
                },
                stripLineLabelFont: {
                    color: "#ADADAD",
                    fontFamily: "Segoe UI",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Material3":
            style = {
                axisLabel: "#1E192B",
                axisTitle: "#1C1B1F",
                axisLine: "#C4C7C5",
                majorGridLine: "#C4C7C5",
                minorGridLine: "#C4C7C5",
                majorTickLine: "#C4C7C5",
                minorTickLine: " #C4C7C5",
                chartTitle: "#1C1B1F",
                legendLabel: "#49454E",
                background: canvas ? "#FFFFFF" : "transparent",
                areaBorder: "#E7E0EC",
                errorBar: "#79747E",
                crosshairLine: "#49454E",
                crosshairFill: "#313033",
                crosshairLabel: "#F4EFF4",
                tooltipFill: "#313033",
                tooltipBoldLabel: "#F4EFF4",
                tooltipLightLabel: "#F4EFF4",
                tooltipHeaderLine: "#F4EFF4",
                markerShadow: null,
                selectionRectFill: "rgb(98, 0, 238, 0.06)",
                selectionRectStroke: "#6200EE",
                selectionCircleStroke: "#79747E",
                tabColor: "#49454E",
                bearFillColor: "#5887FF",
                bullFillColor: "#F7523F",
                toolkitSelectionColor: "#49454E",
                toolkitFill: "#49454E",
                toolkitIconRectOverFill: "#EADDFF",
                toolkitIconRectSelectionFill: "#EADDFF",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-4, -5, 26, 26),
                histogram: "#D21020",
                chartTitleFont: {
                    color: "#1C1B1F",
                    fontFamily: "Roboto",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#1E192B",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#1C1B1F",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#49454E",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#F4EFF4",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#1C1B1F",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#49454E",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#49454E",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#F4EFF4",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#79747E",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        case "Material3Dark":
            style = {
                axisLabel: "#E6E1E5",
                axisTitle: "#E6E1E5",
                axisLine: "#49454F",
                majorGridLine: "#444746",
                minorGridLine: "#444746",
                majorTickLine: "#444746",
                minorTickLine: " #444746",
                chartTitle: "#E6E1E5",
                legendLabel: "#CAC4D0",
                background: canvas ? "#FFFFFF" : "transparent",
                areaBorder: "#49454F",
                errorBar: "#938F99",
                crosshairLine: "#CAC4D0",
                crosshairFill: "#E6E1E5",
                crosshairLabel: "#313033",
                tooltipFill: "#E6E1E5",
                tooltipBoldLabel: "#313033",
                tooltipLightLabel: "#313033",
                tooltipHeaderLine: "#313033",
                markerShadow: null,
                selectionRectFill: "rgba(78, 170, 255, 0.06)",
                selectionRectStroke: "#4EAAFF",
                selectionCircleStroke: "#938F99",
                tabColor: "#CAC4D0",
                bearFillColor: "#B3F32F",
                bullFillColor: "#FF9E45",
                toolkitSelectionColor: "#CAC4D0",
                toolkitFill: "#CAC4D0",
                toolkitIconRectOverFill: "#4F378B",
                toolkitIconRectSelectionFill: "#4F378B",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(-4, -5, 26, 26),
                histogram: "#FF9E45",
                chartTitleFont: {
                    color: "#E6E1E5",
                    fontFamily: "Roboto",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: "#CAC4D0",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: "#E6E1E5",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: "#CAC4D0",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: "#313033",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: "#E6E1E5",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: "#CAC4D0",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: "#CAC4D0",
                    fontFamily: "Roboto",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: "#313033",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: "#938F99",
                    fontFamily: "Roboto",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
        default:
            style = {
                axisLabel: "#686868",
                axisTitle: "#424242",
                axisLine: "#b5b5b5",
                majorGridLine: "#dbdbdb",
                minorGridLine: "#eaeaea",
                majorTickLine: "#b5b5b5",
                minorTickLine: "#d6d6d6",
                chartTitle: "#424242",
                legendLabel: "#353535",
                background: canvas ? "#FFFFFF" : "transparent",
                areaBorder: "Gray",
                errorBar: "#000000",
                crosshairLine: "#4f4f4f",
                crosshairFill: theme === "Material" ? "#000816" : theme === "Fabric" ? "#FFFFFF" : "#212529",
                crosshairLabel: "#e5e5e5",
                tooltipFill: "#000816",
                tooltipBoldLabel: "#ffffff",
                tooltipLightLabel: "#dbdbdb",
                tooltipHeaderLine: "#ffffff",
                markerShadow: null,
                selectionRectFill: "rgba(41, 171, 226, 0.1)",
                selectionRectStroke: "#29abe2",
                selectionCircleStroke: "#29abe2",
                tabColor: theme === "Material" ? "#ff4081" : theme === "Fabric" ? "#0078D6" : "#317AB9",
                bearFillColor: "#2ecd71",
                bullFillColor: "#e74c3d",
                toolkitSelectionColor: theme === "Material" ? "#ff4081" : theme === "Fabric" ? "#0078D6" : "#317AB9",
                toolkitFill: "#737373",
                toolkitIconRectOverFill: "transparent",
                toolkitIconRectSelectionFill: "transparent",
                toolkitIconRect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 16, 16),
                chartTitleFont: {
                    color: theme === "Material" ? "rgba(0, 0, 0, 1)" : theme === "Fabric" ? "#333333" : "#212529",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "16px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                axisLabelFont: {
                    color: theme === "Material" ? "rgba(97, 97, 97, 1)" : theme === "Fabric" ? "#666666" : "#676767",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                legendTitleFont: {
                    color: theme === "Material" ? "rgba(0, 0, 0, 1)" : theme === "Fabric" ? "#333333" : "#212529",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                legendLabelFont: {
                    color: theme === "Material" ? "rgba(97, 97, 97, 1)" : theme === "Fabric" ? "#666666" : "#666666",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                tooltipLabelFont: {
                    color: theme === "Material" ? "rgba(249, 250, 251, 1)" : theme === "Fabric" ? "#333333" : "#F9FAFB",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal"
                },
                axisTitleFont: {
                    color: theme === "Material" ? "rgba(0, 0, 0, 1)" : theme === "Fabric" ? "#333333" : "#212529",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "600"
                },
                datalabelFont: {
                    color: theme === "Material" ? "rgba(97, 97, 97, 1)" : theme === "Fabric" ? "#666666" : "#676767",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                chartSubTitleFont: {
                    color: theme === "Material" ? "rgba(0, 0, 0, 1)" : theme === "Fabric" ? "#333333" : "#212529",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "14px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                crosshairLabelFont: {
                    color: theme === "Material" ? "rgba(249, 250, 251, 1)" : theme === "Fabric" ? "#333333" : "#F9FAFB",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                },
                stripLineLabelFont: {
                    color: theme === "Material" ? "rgba(158, 158, 158, 1)" : theme === "Fabric" ? "#A6A6A6" : "#676767",
                    fontFamily: theme === "Material" ? "Roboto" : theme === "Fabric" ? "Segoe UI" : "Helvetica",
                    size: "12px",
                    fontStyle: "Normal",
                    fontWeight: "400"
                }
            };
            break;
    }
    return style;
}
function $11b41024b246dc37$export$8d7670fb7659e955(theme) {
    var scrollStyle;
    switch(theme){
        case "HighContrastLight":
            scrollStyle = {
                backRect: "#333",
                thumb: "#bfbfbf",
                circle: "#fff",
                circleHover: "#685708",
                arrow: "#333",
                grip: "#333",
                arrowHover: "#fff",
                backRectBorder: "#969696"
            };
            break;
        case "Bootstrap":
            scrollStyle = {
                backRect: "#f5f5f5",
                thumb: "#e6e6e6",
                circle: "#fff",
                circleHover: "#eee",
                arrow: "#8c8c8c",
                grip: "#8c8c8c"
            };
            break;
        case "Fabric":
            scrollStyle = {
                backRect: "#f8f8f8",
                thumb: "#eaeaea",
                circle: "#fff",
                circleHover: "#eaeaea",
                arrow: "#a6a6a6",
                grip: "#a6a6a6"
            };
            break;
        case "MaterialDark":
            scrollStyle = {
                backRect: "#424242",
                thumb: "#616161",
                circle: "#757575",
                circleHover: "#616161",
                arrow: "#BDBDBD",
                grip: "#BDBDBD"
            };
            break;
        case "FabricDark":
            scrollStyle = {
                backRect: "#282727",
                thumb: "#333232",
                circle: "#4A4848",
                circleHover: "#514F4F",
                arrow: "#ADB5BD",
                grip: "#DADADA"
            };
            break;
        case "BootstrapDark":
            scrollStyle = {
                backRect: "#2A2A2A",
                thumb: "#313131",
                circle: "#414141",
                circleHover: "#484848",
                arrow: "#DADADA",
                grip: "#FFFFFF"
            };
            break;
        case "Bootstrap5":
            scrollStyle = {
                backRect: "#E9ECEF",
                thumb: "#ADB5BD",
                circle: "#F8F9FA",
                circleHover: "#F8F9FA",
                arrow: "#6E757D",
                grip: "#6E757D"
            };
            break;
        case "Bootstrap5Dark":
            scrollStyle = {
                backRect: "#343A40",
                thumb: "#ADB5BD",
                circle: "#2B3035",
                circleHover: "#2B3035",
                arrow: "#ADB5BD",
                grip: "#ADB5BD"
            };
            break;
        case "HighContrast":
            scrollStyle = {
                backRect: "#757575",
                thumb: "#BFBFBF",
                circle: "#FFFFFF",
                circleHover: "#FFFFFF",
                arrow: "#ADB5BD",
                grip: "#969696"
            };
            break;
        case "TailwindDark":
            scrollStyle = {
                backRect: "#6B7280",
                thumb: "#374151",
                circle: "#4B5563",
                circleHover: "#4B5563",
                arrow: "#ADB5BD",
                grip: "#D1D5DB"
            };
            break;
        case "Fluent":
            scrollStyle = {
                backRect: "#F3F2F1",
                thumb: "#E1DFDD",
                circle: "#FFFFFF",
                circleHover: "#E1DFDD",
                arrow: "#605E5C",
                grip: "#605E5C"
            };
            break;
        case "FluentDark":
            scrollStyle = {
                backRect: "#252423",
                thumb: "#323130",
                circle: "#3B3A39",
                circleHover: "#3B3A39",
                arrow: "#ADB5BD",
                grip: "#A19F9D"
            };
            break;
        case "Fluent2":
            scrollStyle = {
                backRect: "#F5F5F5",
                thumb: "#F0F0F0",
                circle: "#FAFAFA",
                circleHover: "#FAFAFA",
                arrow: "#424242",
                grip: "#424242"
            };
            break;
        case "Fluent2Dark":
            scrollStyle = {
                thumb: "#0A0A0A",
                backRect: "#141414",
                circle: "#1F1F1F",
                circleHover: "#1F1F1F",
                arrow: "#D6D6D6",
                grip: "#D6D6D6"
            };
            break;
        case "Fluent2HighContrast":
            scrollStyle = {
                thumb: "#333333",
                backRect: "#000000",
                circle: "#000000",
                circleHover: "#000000",
                arrow: "#FFFFFF",
                grip: "#FFFFFF"
            };
            break;
        case "Material3":
            scrollStyle = {
                backRect: "rgba(103, 80, 164, 0.05)",
                thumb: " rgba(103, 80, 164, 0.14)",
                circle: "#FFFFFF",
                circleHover: "#E1DFDD",
                arrow: "#49454E",
                grip: "#49454E"
            };
            break;
        case "Material3Dark":
            scrollStyle = {
                backRect: "rgba(208, 188, 255, 0.05)",
                thumb: "rgba(208, 188, 255, 0.14)",
                circle: "#FFFFFF",
                circleHover: "#E1DFDD",
                arrow: "#CAC4D0",
                grip: "#CAC4D0"
            };
            break;
        default:
            scrollStyle = {
                backRect: "#f5f5f5",
                thumb: "#e0e0e0",
                circle: "#fff",
                circleHover: "#eee",
                arrow: "#9e9e9e",
                grip: "#9e9e9e"
            };
            break;
    }
    return scrollStyle;
}




parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



/**
 * Specifies the Cartesian Axis Layout.
 */ var $bf0167721456a91c$var$axisPadding = 10;
var $bf0167721456a91c$export$796b14441ba1ebe8 = /** @class */ function() {
    /** @private */ /**
     * Constructor for creating the chart.
     *
     * @param {Chart} chartModule - Specifies the Chart model.
     * @private */ function CartesianAxisLayoutPanel(chartModule) {
        this.chart = chartModule;
        this.padding = 5;
    }
    /**
     * Measure the axis size.
     *
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.measureAxis = function(rect) {
        var chart = this.chart;
        var chartAreaWidth = chart.chartArea.width ? (0, $11815a21a80ae2b7$export$391a4509611a1b09)(chart.chartArea.width, chart.availableSize.width) : null;
        this.crossAt(chart);
        this.seriesClipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x, rect.y, rect.width, rect.height);
        this.initialClipRect = rect;
        this.leftSize = 0;
        this.rightSize = 0;
        this.topSize = 0;
        this.bottomSize = 0;
        //Measure Axis size with initial Rect
        this.measureRowAxis(chart, this.initialClipRect);
        this.initialClipRect = (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(this.initialClipRect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(this.leftSize, this.rightSize, 0, 0));
        this.measureColumnAxis(chart, this.initialClipRect);
        this.initialClipRect = (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(this.initialClipRect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, 0, this.topSize, this.bottomSize));
        if (!this.chart.delayRedraw) this.calculateAxisSize(this.initialClipRect);
        this.leftSize = 0;
        this.rightSize = 0;
        this.topSize = 0;
        this.bottomSize = 0;
        //Measure Axis size with series Rect
        this.measureRowAxis(chart, this.initialClipRect);
        this.seriesClipRect = (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(this.seriesClipRect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(this.leftSize, this.rightSize, 0, 0));
        this.measureColumnAxis(chart, this.initialClipRect);
        this.seriesClipRect = (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(this.seriesClipRect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, 0, this.topSize, this.bottomSize));
        if (chartAreaWidth) this.calculateFixedChartArea(chart, chartAreaWidth);
        if (!this.chart.delayRedraw) {
            chart.refreshAxis();
            this.calculateAxisSize(this.seriesClipRect);
        }
    };
    CartesianAxisLayoutPanel.prototype.calculateFixedChartArea = function(chart, chartAreaWidth) {
        this.seriesClipRect.width = chartAreaWidth;
        this.seriesClipRect.x = chart.availableSize.width - chart.margin.right - chartAreaWidth - (chart.legendSettings.position === "Right" ? chart.legendModule.legendBounds.width : 0);
        for(var _i = 0, _a = chart.rows; _i < _a.length; _i++){
            var item = _a[_i];
            this.seriesClipRect.x -= (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(item.farSizes);
        }
    };
    CartesianAxisLayoutPanel.prototype.measureRowAxis = function(chart, rect) {
        var row;
        this.calculateRowSize(rect);
        for(var _i = 0, _a = chart.rows; _i < _a.length; _i++){
            var item = _a[_i];
            row = item;
            row.nearSizes = [];
            row.farSizes = [];
            row.insideNearSizes = [];
            row.insideFarSizes = [];
            this.arrangeAxis(row);
            this.measureDefinition(row, chart, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(chart.availableSize.width, row.computedHeight));
            if (this.leftSize < (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(row.nearSizes)) this.leftSize = (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(row.nearSizes);
            if (this.rightSize < (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(row.farSizes)) this.rightSize = (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(row.farSizes);
        }
    };
    CartesianAxisLayoutPanel.prototype.measureColumnAxis = function(chart, rect) {
        var column;
        this.calculateColumnSize(rect);
        for(var _i = 0, _a = chart.columns; _i < _a.length; _i++){
            var item = _a[_i];
            column = item;
            column.farSizes = [];
            column.nearSizes = [];
            column.insideNearSizes = [];
            column.insideFarSizes = [];
            this.arrangeAxis(column);
            this.measureDefinition(column, chart, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(column.computedWidth, chart.availableSize.height));
            if (this.bottomSize < (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(column.nearSizes)) this.bottomSize = (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(column.nearSizes);
            if (this.topSize < (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(column.farSizes)) this.topSize = (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)(column.farSizes);
        }
    };
    /**
     * Measure the column and row in chart.
     *
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.measureDefinition = function(definition, chart, size) {
        var ele;
        for(var _i = 0, _a = definition.axes; _i < _a.length; _i++){
            var axis = _a[_i];
            ele = axis.scrollbarSettings.height;
            axis.scrollBarHeight = chart.scrollBarModule && chart.zoomModule && chart.zoomSettings.enableScrollbar && axis.enableScrollbarOnZooming && chart.zoomModule.isZoomed && (axis.zoomFactor < 1 || axis.zoomPosition > 0) ? ele : 0;
            axis.scrollBarHeight = chart.scrollBarModule && (chart.zoomModule && chart.zoomSettings.enableScrollbar && axis.enableScrollbarOnZooming && chart.zoomModule.isZoomed && (axis.zoomFactor < 1 || axis.zoomPosition > 0) || axis.scrollbarSettings.enable) ? ele : 0;
            axis.getModule(chart);
            axis.baseModule.calculateRangeAndInterval(size, axis);
            definition.computeSize(axis, axis.scrollBarHeight, definition, chart);
        }
        if (definition.farSizes.length > 0) definition.farSizes[definition.farSizes.length - 1] -= $bf0167721456a91c$var$axisPadding;
        if (definition.nearSizes.length > 0) definition.nearSizes[definition.nearSizes.length - 1] -= $bf0167721456a91c$var$axisPadding;
    };
    /**
     * Measure the axis.
     *
     * @param {Rect} rect - The rect for measuring the axis.
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.calculateAxisSize = function(rect) {
        var chart = this.chart;
        var row;
        var column;
        var definition;
        var axis;
        var nearCount = 0;
        var farCount = 0;
        var size = 0;
        var x;
        var y;
        var axisOffset;
        this.calculateRowSize(rect);
        for(var i = 0, len = chart.rows.length; i < len; i++){
            row = chart.rows[i];
            nearCount = 0;
            farCount = 0;
            for(var j = 0, len_1 = row.axes.length; j < len_1; j++){
                axis = row.axes[j];
                axisOffset = axis.plotOffset;
                if (axis.rect.height === 0) {
                    axis.rect.height = row.computedHeight;
                    size = 0;
                    for(var k = i + 1, len_2 = i + axis.span; k < len_2; k++){
                        definition = chart.rows[k];
                        size += definition.computedHeight;
                    }
                    axis.rect.y = row.computedTop - size + (axis.plotOffsetTop ? axis.plotOffsetTop : axisOffset);
                    axis.rect.height = axis.rect.height + size - this.getAxisOffsetValue(axis.plotOffsetTop, axis.plotOffsetBottom, axis.plotOffset);
                    axis.rect.width = 0;
                }
                if (axis.isAxisOpposedPosition) {
                    if (axis.labelPosition === "Inside" && axis.orientation === "Vertical") x = rect.x + rect.width - (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(row.insideFarSizes, farCount));
                    else x = rect.x + rect.width + (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(row.farSizes, farCount));
                    axis.rect.x = axis.rect.x >= x ? axis.rect.x : x;
                    farCount++;
                } else {
                    if (axis.labelPosition === "Inside" && axis.orientation === "Vertical") x = rect.x + (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(row.insideNearSizes, nearCount));
                    else x = rect.x - (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(row.nearSizes, nearCount));
                    axis.rect.x = axis.rect.x <= x ? axis.rect.x : x;
                    nearCount++;
                }
            }
        }
        this.calculateColumnSize(rect);
        for(var i = 0, len = chart.columns.length; i < len; i++){
            column = chart.columns[i];
            nearCount = 0;
            farCount = 0;
            for(var j = 0, len_3 = column.axes.length; j < len_3; j++){
                axis = column.axes[j];
                axisOffset = axis.plotOffset;
                if (axis.rect.width === 0) {
                    for(var k = i, len_4 = i + axis.span; k < len_4; k++){
                        definition = chart.columns[k];
                        axis.rect.width += definition.computedWidth;
                    }
                    axis.rect.x = column.computedLeft + (axis.plotOffsetLeft ? axis.plotOffsetLeft : axisOffset);
                    axis.rect.width -= this.getAxisOffsetValue(axis.plotOffsetLeft, axis.plotOffsetRight, axis.plotOffset);
                    axis.rect.height = 0;
                }
                if (axis.isAxisOpposedPosition) {
                    if (axis.labelPosition === "Inside" && axis.orientation === "Horizontal") y = rect.y + (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(column.insideFarSizes, farCount));
                    else y = rect.y - (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(column.farSizes, farCount));
                    axis.rect.y = axis.rect.y <= y ? axis.rect.y : y;
                    farCount++;
                } else {
                    if (axis.labelPosition === "Inside" && axis.orientation === "Horizontal") y = rect.y + rect.height - (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(column.insideNearSizes, nearCount));
                    else y = rect.y + rect.height + (0, $11815a21a80ae2b7$export$8a63f25cc62965f1)((0, $11815a21a80ae2b7$export$ae151e2e9253af88)(column.nearSizes, nearCount));
                    axis.rect.y = axis.rect.y >= y ? axis.rect.y : y;
                    nearCount++;
                }
            }
        }
    };
    /**
     * Measure the axis.
     *
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.measure = function() {
        var chart = this.chart;
        var row;
        var column;
        var definition;
        var actualIndex;
        var span;
        for(var _i = 0, _a = chart.axisCollections; _i < _a.length; _i++){
            var axis = _a[_i];
            //definition.Axes = axis;
            if (axis.orientation === "Vertical") {
                chart.verticalAxes.push(axis);
                actualIndex = this.getActualRow(axis);
                row = chart.rows[actualIndex];
                this.pushAxis(row, axis);
                span = actualIndex + axis.span > chart.rows.length ? chart.rows.length : actualIndex + axis.span;
                for(var j = actualIndex + 1; j < span; j++){
                    definition = chart.rows[j];
                    definition.axes[row.axes.length - 1] = axis;
                    chart.rows[j] = definition;
                }
                chart.rows[actualIndex] = row;
            } else {
                chart.horizontalAxes.push(axis);
                actualIndex = this.getActualColumn(axis);
                column = chart.columns[actualIndex];
                this.pushAxis(column, axis);
                span = actualIndex + axis.span > chart.columns.length ? chart.columns.length : actualIndex + axis.span;
                for(var j = actualIndex + 1; j < span; j++){
                    definition = chart.columns[j];
                    definition.axes[column.axes.length - 1] = axis;
                    chart.columns[j] = definition;
                }
                chart.columns[actualIndex] = column;
            }
            axis.isRTLEnabled = chart.enableRtl;
            axis.setIsInversedAndOpposedPosition();
        }
    };
    CartesianAxisLayoutPanel.prototype.getAxisOffsetValue = function(position1, position2, plotOffset) {
        var rangeOffset = position1 ? position1 + (position2 ? position2 : plotOffset) : position2 ? position2 + plotOffset : 2 * plotOffset;
        return rangeOffset;
    };
    CartesianAxisLayoutPanel.prototype.crossAt = function(chart) {
        for(var _i = 0, _a = chart.axisCollections; _i < _a.length; _i++){
            var axis = _a[_i];
            if (axis.crossesAt === null) continue;
            if (!axis.crossesInAxis) {
                if (chart.requireInvertedAxis) axis.crossInAxis = axis.orientation === "Horizontal" ? chart.primaryXAxis : chart.primaryYAxis;
                else axis.crossInAxis = axis.orientation === "Horizontal" ? chart.primaryYAxis : chart.primaryXAxis;
                axis.crossAt = this.updateCrossAt(axis.crossInAxis, axis.crossesAt);
                continue;
            } else {
                for(var i = 2, len = chart.axisCollections.length; i < len; i++)if (axis.crossesInAxis === chart.axisCollections[i].name) {
                    axis.crossInAxis = chart.axisCollections[i];
                    axis.crossAt = this.updateCrossAt(axis.crossInAxis, axis.crossesAt);
                    continue;
                }
            }
        }
    };
    CartesianAxisLayoutPanel.prototype.updateCrossAt = function(axis, crossAt) {
        switch(axis.valueType){
            case "DateTime":
                var option = {
                    skeleton: "full",
                    type: "dateTime"
                };
                var dateParser = this.chart.intl.getDateParser(option);
                var dateFormatter = this.chart.intl.getDateFormat(option);
                return Date.parse(dateParser(dateFormatter(new Date((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson({
                    val: crossAt
                }).val))));
            case "Category":
                return parseFloat(crossAt) ? parseFloat(crossAt) : axis.labels.indexOf(crossAt);
            case "Logarithmic":
                return (0, $11815a21a80ae2b7$export$2aa080c37938b627)(crossAt, axis.logBase);
            default:
                return crossAt;
        }
    };
    CartesianAxisLayoutPanel.prototype.pushAxis = function(definition, axis) {
        for(var i = 0, len = definition.axes.length; i <= len; i++)if (!definition.axes[i]) {
            definition.axes[i] = axis;
            break;
        }
    };
    CartesianAxisLayoutPanel.prototype.arrangeAxis = function(definition) {
        var axisCollection = [];
        for(var i = 0, len = definition.axes.length; i <= len; i++)if (definition.axes[i]) axisCollection.push(definition.axes[i]);
        definition.axes = axisCollection;
    };
    CartesianAxisLayoutPanel.prototype.getActualColumn = function(axis) {
        var actualLength = this.chart.columns.length;
        var pos = axis.columnIndex;
        var result = pos >= actualLength ? actualLength - 1 : pos < 0 ? 0 : pos;
        return result;
    };
    CartesianAxisLayoutPanel.prototype.getActualRow = function(axis) {
        var actualLength = this.chart.rows.length;
        var pos = axis.rowIndex;
        var result = pos >= actualLength ? actualLength - 1 : pos < 0 ? 0 : pos;
        return result;
    };
    /**
     * Measure the row size.
     *
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.calculateRowSize = function(rect) {
        /** Calculate row size */ var chart = this.chart;
        var row;
        var rowTop = rect.y + rect.height;
        var height = 0;
        var remainingHeight = Math.max(0, rect.height);
        for(var i = 0, len = chart.rows.length; i < len; i++){
            row = chart.rows[i];
            if (row.height.indexOf("%") !== -1) height = Math.min(remainingHeight, rect.height * parseInt(row.height, 10) / 100);
            else height = Math.min(remainingHeight, parseInt(row.height, 10));
            height = i !== len - 1 ? height : remainingHeight;
            row.computedHeight = height;
            rowTop -= height;
            row.computedTop = rowTop;
            remainingHeight -= height;
        }
    };
    /**
     * Measure the row size.
     *
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.calculateColumnSize = function(rect) {
        /** Calculate column size */ var chart = this.chart;
        var column;
        var columnLeft = rect.x;
        var width = 0;
        var remainingWidth = Math.max(0, rect.width);
        for(var i = 0, len = chart.columns.length; i < len; i++){
            column = chart.columns[i];
            if (column.width.indexOf("%") !== -1) width = Math.min(remainingWidth, rect.width * parseInt(column.width, 10) / 100);
            else width = Math.min(remainingWidth, parseInt(column.width, 10));
            width = i !== len - 1 ? width : remainingWidth;
            column.computedWidth = width;
            column.computedLeft = columnLeft;
            columnLeft += width;
            remainingWidth -= width;
        }
    };
    /**
     * To render the axis element.
     *
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.renderAxes = function() {
        var chart = this.chart;
        var axis;
        var axisElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisInsideCollection"
        });
        var axisLineElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisOutsideCollection"
        });
        if (axisLineElement) axisLineElement.setAttribute("aria-hidden", "true");
        var outsideElement;
        var isInside;
        for(var i = 0, len = chart.axisCollections.length; i < len; i++){
            var axisVisibility = true;
            axis = chart.axisCollections[i];
            this.element = chart.renderer.createGroup({
                id: chart.element.id + "AxisGroup" + i + "Inside"
            });
            if (this.element) this.element.setAttribute("aria-hidden", "true");
            outsideElement = chart.renderer.createGroup({
                id: chart.element.id + "AxisGroup" + i + "Outside"
            });
            if (outsideElement) outsideElement.setAttribute("aria-hidden", "true");
            for(var _i = 0, _a = axis.series; _i < _a.length; _i++){
                var series = _a[_i];
                if (axis.name === series.yAxisName || axis.name === series.xAxisName) {
                    axisVisibility = series.visible;
                    if (series.category === "Pareto" && !series.paretoOptions.showAxis && series.type === "Line") axisVisibility = false;
                    if (!axisVisibility) continue;
                    else break;
                }
            }
            if (!axisVisibility) continue;
            isInside = this.findAxisPosition(axis);
            this.drawAxis(axis, i, isInside, outsideElement, axisElement, axisLineElement);
        }
        this.drawPaneLines(chart, axisElement);
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.svgObject, axisElement, chart.redraw);
        return axisLineElement;
    };
    /**
     * To render the axis scrollbar
     *
     * @param {Chart} chart chart
     * @param {Axis} axis axis
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.renderScrollbar = function(chart, axis) {
        var isZoomed = (0, $3EnZW.isNullOrUndefined)(chart.zoomModule) ? false : chart.zoomModule.isZoomed;
        if ((isZoomed && (axis.zoomFactor < 1 || axis.zoomPosition > 0) || axis.scrollbarSettings.enable && (axis.zoomFactor <= 1 || axis.zoomPosition >= 0)) && !axis.zoomingScrollBar.isScrollUI) {
            if (!chart.scrollElement) chart.scrollElement = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(chart.redraw, chart.element.id + "_scrollElement") || (0, $4ZDHT.createElement)("div", {
                id: chart.element.id + "_scrollElement"
            });
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(false, chart.scrollElement, axis.zoomingScrollBar.render(true), true);
        } else if (axis.zoomFactor === 1 && axis.zoomPosition === 0 && axis.zoomingScrollBar.svgObject && !axis.scrollbarSettings.enable) axis.zoomingScrollBar.destroy();
        else if (axis.zoomingScrollBar.svgObject) {
            axis.zoomingScrollBar.svgObject.style.top = (axis.isAxisOpposedPosition && axis.orientation === "Horizontal" ? -16 : 0) + axis.rect.y + Math.max(0.5, axis.lineStyle.width / 2) + "px";
            axis.zoomingScrollBar.svgObject.style.left = (axis.isAxisOpposedPosition && axis.orientation !== "Horizontal" ? 16 : 0) + axis.rect.x - (axis.orientation === "Vertical" ? axis.scrollbarSettings.height : 0) + "px";
        }
        if (axis.zoomingScrollBar.isScrollUI) axis.zoomingScrollBar.isScrollUI = false;
    };
    /**
     * Draws pane lines for the specified chart.
     *
     * @param {Chart} chart -The chart for which pane lines are to be drawn.
     * @param {Element} [axisElement] -Optional. The axis element to which the pane lines are associated.
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.drawPaneLines = function(chart, axisElement) {
        this.element = chart.renderer.createGroup({
            id: chart.element.id + "DefinitionLine"
        });
        for(var j = 0, len = chart.rows.length; j < len; j++){
            var row = chart.rows[j];
            if (row.border.color) this.drawBottomLine(row, j, true);
        }
        for(var j = 0, len = chart.columns.length; j < len; j++){
            var column = chart.columns[j];
            if (column.border.color) this.drawBottomLine(column, j, false);
        }
        axisElement = axisElement ? axisElement : (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisInsideCollection");
        if (!this.chart.enableCanvas) axisElement.appendChild(this.element);
    };
    /**
     * Draws an axis for the specified axis configuration.
     *
     * @private
     * @param {Axis} axis -The axis configuration to be drawn.
     * @param {number} index -The index of the axis.
     * @param {boolean} isInside -Indicates whether the axis is inside or outside the plot area.
     * @param {Element} outsideElement -The element where the axis should be drawn if it's outside the plot area.
     * @param {Element} axisElement -The element representing the axis.
     * @param {Element} axisLineElement -The element representing the axis line.
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawAxis = function(axis, index, isInside, outsideElement, axisElement, axisLineElement) {
        axis.updateCrossValue();
        var axisName = "";
        if (axis.orientation === "Horizontal") {
            if (axis.visible && axis.internalVisibility && axis.lineStyle.width > 0) this.drawAxisLine(axis, index, axis.plotOffset, 0, 0, 0, axis.plotOffsetLeft, axis.plotOffsetRight, isInside ? outsideElement : this.element, axis.updatedRect);
            axisName = "X";
        } else {
            if (axis.visible && axis.internalVisibility && axis.lineStyle.width > 0) this.drawAxisLine(axis, index, 0, axis.plotOffset, axis.plotOffsetBottom, axis.plotOffsetTop, 0, 0, isInside ? outsideElement : this.element, axis.updatedRect);
            axisName = "Y";
        }
        if (axis.majorGridLines.width > 0 || axis.majorTickLines.width > 0 || axis.minorTickLines.width > 0 || axis.minorGridLines.width > 0) this["draw" + axisName + "AxisGridLine"](axis, index, isInside || axis.tickPosition === "Inside" ? outsideElement : this.element, axis.updatedRect);
        if (axis.visible && axis.internalVisibility) {
            this["draw" + axisName + "AxisLabels"](axis, index, isInside || axis.labelPosition === "Inside" ? outsideElement : this.element, axis.placeNextToAxisLine ? axis.updatedRect : axis.rect);
            this["draw" + axisName + "AxisBorder"](axis, index, isInside || axis.labelPosition === "Inside" ? outsideElement : this.element, axis.placeNextToAxisLine ? axis.updatedRect : axis.rect);
            this["draw" + axisName + "AxisTitle"](axis, index, isInside ? outsideElement : this.element, axis.placeNextToAxisLine ? axis.updatedRect : axis.rect);
        }
        if (!this.chart.enableCanvas) {
            axisElement.appendChild(this.element);
            if (outsideElement && outsideElement.childNodes.length > 0) axisLineElement.appendChild(outsideElement);
        }
        if (this.chart.scrollBarModule && (this.chart.zoomSettings.enableScrollbar && axis.enableScrollbarOnZooming || axis.scrollbarSettings.enable)) this.renderScrollbar(this.chart, axis);
    };
    /**
     * To find the axis position
     *
     * @param {Axis} axis axis
     * @returns {boolean} axis position
     * @private
     */ CartesianAxisLayoutPanel.prototype.findAxisPosition = function(axis) {
        return axis.crossAt !== null && axis.isInside(axis.crossInAxis.visibleRange);
    };
    /**
     * To render the bootom line of the columns and rows
     *
     * @param {Row | Column} definition definition
     * @param {number} index index
     * @param {boolean} isRow isRow
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawBottomLine = function(definition, index, isRow) {
        var chart = this.chart;
        var optionsLine = {};
        var x1;
        var x2;
        var y1;
        var y2;
        var definitionName;
        if (isRow) {
            definition;
            y1 = y2 = definition.computedTop + definition.computedHeight;
            x1 = this.seriesClipRect.x;
            x2 = x1 + this.seriesClipRect.width;
            definitionName = "Row";
        } else {
            definition;
            x1 = x2 = definition.computedLeft;
            y1 = this.seriesClipRect.y;
            y2 = y1 + this.seriesClipRect.height;
            definitionName = "Column";
        }
        optionsLine = {
            "id": chart.element.id + "_AxisBottom_" + definitionName + index,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            "stroke-width": definition.border.width,
            "stroke": definition.border.color
        };
        this.htmlObject = chart.renderer.drawLine(optionsLine);
        this.element.appendChild(this.htmlObject);
    };
    /**
     * To render the axis line
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {number} plotX plotX
     * @param {number} plotY plotY
     * @param {number} plotBottom plotBottom
     * @param {number} plotTop plotTop
     * @param {number} plotLeft plotLeft
     * @param {number} plotRight plotRight
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawAxisLine = function(axis, index, plotX, plotY, plotBottom, plotTop, plotLeft, plotRight, parent, rect) {
        var chart = this.chart;
        var optionsLine = {};
        var element = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisLine_" + index);
        var direction = element ? element.getAttribute("d") : "";
        element = null;
        optionsLine = {
            "id": chart.element.id + "AxisLine_" + index,
            "d": "M " + (rect.x - plotX - plotLeft) + " " + (rect.y - plotY - plotTop) + " L " + (rect.x + rect.width + plotX + plotRight) + " " + (rect.y + rect.height + plotY + plotBottom),
            "stroke-dasharray": axis.lineStyle.dashArray,
            "stroke-width": axis.lineStyle.width,
            "stroke": axis.lineStyle.color || chart.themeStyle.axisLine
        };
        this.htmlObject = chart.renderer.drawPath(optionsLine);
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, parent, this.htmlObject, chart.redraw, true, "x", "y", null, direction, null, null, null, chart.duration);
    };
    /**
     * To render the yAxis grid line
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawYAxisGridLine = function(axis, index, parent, rect) {
        var isLogAxis = axis.valueType === "Logarithmic";
        var isCategoryAxis = axis.valueType.indexOf("Category") > -1;
        var tempInterval;
        var pointY = 0;
        var majorGrid = "";
        var majorTick = "";
        var minorGridDirection;
        var isOpposed = axis.isAxisOpposedPosition;
        var tickSize = isOpposed ? axis.majorTickLines.height : -axis.majorTickLines.height;
        var axisLineSize = isOpposed ? axis.lineStyle.width * 0.5 : -axis.lineStyle.width * 0.5;
        var ticksbwtLabel = axis.valueType === "Category" && axis.labelPlacement === "BetweenTicks" ? 0.5 : 0;
        var scrollBarHeight = (0, $3EnZW.isNullOrUndefined)(axis.crossesAt) ? isOpposed ? axis.scrollBarHeight : -axis.scrollBarHeight : 0;
        var isTickInside = axis.tickPosition === "Inside";
        var ticks = isTickInside ? rect.x - tickSize - axisLineSize : rect.x + tickSize + axisLineSize + scrollBarHeight;
        var length = axis.visibleLabels.length;
        var chartThemeStyle = this.chart.themeStyle;
        var count = 1;
        if (axis.valueType.indexOf("Category") > -1 && axis.labelPlacement === "BetweenTicks" && length > 0 && !this.chart.stockChart) length += 1;
        var minorGridLines = axis.minorGridLines;
        var minorTickLines = axis.minorTickLines;
        //Gridlines
        for(var i = 0; i < length; i++){
            tempInterval = !axis.visibleLabels[i] ? axis.visibleLabels[i - 1].value + axis.visibleRange.interval - ticksbwtLabel : axis.visibleLabels[i].value - ticksbwtLabel;
            pointY = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(tempInterval, axis) * rect.height;
            pointY = pointY * -1 + (rect.y + rect.height);
            if (pointY >= rect.y && rect.y + rect.height >= pointY) {
                if (this.chart.redraw && !this.chart.enableCanvas && this.chart.zoomRedraw && axis.visible && axis.majorGridLines.width && i !== 0 && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_MajorGridLine_" + index + "_" + i)) {
                    majorGrid = "M " + this.seriesClipRect.x + " " + (this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / (i ? i : 1) * count : -(this.seriesClipRect.height / (i ? i : 1) * count))) + " L " + (this.seriesClipRect.x + this.seriesClipRect.width) + " " + (this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / (i ? i : 1) * count : -(this.seriesClipRect.height / (i ? i : 1) * count)));
                    this.updateAxisElement(axis, index, majorGrid, i, "_MajorGridLine_", this.element, false);
                    (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(parent.id).appendChild(this.element.childNodes[this.element.childNodes.length - 1]);
                }
                if ((0, $11815a21a80ae2b7$export$245b06b49bc2b810)(tempInterval, axis.visibleRange) || this.isBorder(axis, i, pointY)) {
                    majorGrid = "M " + this.seriesClipRect.x + " " + pointY + " L " + (this.seriesClipRect.x + this.seriesClipRect.width) + " " + pointY;
                    this.renderGridLine(axis, index, majorGrid, axis.majorGridLines, "_MajorGridLine_", i, this.element, chartThemeStyle.majorGridLine, axis.majorGridLines.dashArray);
                }
                if (this.chart.redraw && this.chart.zoomRedraw && axis.majorTickLines.width && i !== 0 && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_MajorTickLine_" + index + "_" + i) && !this.chart.enableCanvas && axis.visible) {
                    majorTick = "M " + this.seriesClipRect.x + " " + (this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / (i ? i : 1) * count : -(this.seriesClipRect.height / (i ? i : 1) * count))) + " L " + ticks + " " + (this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / (i ? i : 1) * count : -(this.seriesClipRect.height / (i ? i : 1) * count)));
                    this.updateAxisElement(axis, index, majorTick, i, "_MajorTickLine_", parent, false);
                    (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(parent.id).appendChild(this.element.childNodes[this.element.childNodes.length - 1]);
                    count += 1;
                }
                majorTick = "M " + (rect.x + axisLineSize + (isTickInside ? scrollBarHeight : 0)) + " " + pointY + " L " + ticks + " " + pointY;
                this.renderGridLine(axis, index, majorTick, axis.majorTickLines, "_MajorTickLine_", i, parent, chartThemeStyle.majorTickLine);
                if ((minorGridLines.width > 0 || minorTickLines.width > 0) && axis.minorTicksPerInterval > 0) {
                    if (i === 0 && (0, $11815a21a80ae2b7$export$a34692dfee195c82)(axis) && !isLogAxis && !isCategoryAxis) this.renderMinorGridOnZooming(axis, tempInterval, rect, i, index, chartThemeStyle, parent);
                    minorGridDirection = this.drawAxisMinorLine(axis, tempInterval, rect, i);
                    this.renderGridLine(axis, index, minorGridDirection[0], minorGridLines, "_MinorGridLine_", i, this.element, chartThemeStyle.minorGridLine, minorGridLines.dashArray);
                    this.renderGridLine(axis, index, minorGridDirection[1], minorTickLines, "_MinorTickLine_", i, parent, chartThemeStyle.minorTickLine);
                    if (i === length - 1 && (0, $11815a21a80ae2b7$export$a34692dfee195c82)(axis) && isLogAxis && !isCategoryAxis) this.renderMinorGridOnZooming(axis, tempInterval + axis.visibleRange.interval, rect, i, index, chartThemeStyle, parent);
                }
            }
        }
        if (length && this.previousYLabel > length && !this.chart.enableCanvas && axis.visible && this.chart.zoomRedraw && this.chart.redraw) for(var i = length; i < this.previousYLabel; i++){
            var pointYValue = this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height / length * (i - length + 1) + this.seriesClipRect.height : -(this.seriesClipRect.height / length * (i - length + 1)));
            if (axis.majorGridLines.width) {
                majorGrid = "M " + this.seriesClipRect.x + " " + +pointYValue + " L " + (this.seriesClipRect.x + this.seriesClipRect.width) + " " + pointYValue;
                this.updateAxisElement(axis, index, majorGrid, i, "_MajorGridLine_", this.element, true);
            }
            if (axis.majorTickLines.width) {
                majorTick = "M " + this.seriesClipRect.x + " " + pointYValue + " L " + ticks + " " + pointYValue;
                this.updateAxisElement(axis, index, majorTick, i, "_MajorTickLine_", parent, true);
            }
        }
    };
    /**
     * To check the border of the axis
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {number} value value
     * @returns {boolean} check the border of the axis
     */ CartesianAxisLayoutPanel.prototype.isBorder = function(axis, index, value) {
        var border = this.chart.chartArea.border;
        var rect = this.seriesClipRect;
        var orientation = axis.orientation;
        var start = orientation === "Horizontal" ? rect.x : rect.y;
        var size = orientation === "Horizontal" ? rect.width : rect.height;
        var startIndex = orientation === "Horizontal" ? 0 : axis.visibleLabels.length - 1;
        var endIndex = orientation === "Horizontal" ? axis.visibleLabels.length - 1 : 0;
        if (axis.plotOffset > 0) return true;
        else if ((value === start || value === start + size) && (border.width <= 0 || border.color === "transparent")) return true;
        else if (value !== start && index === startIndex || value !== start + size && index === endIndex) return true;
        return false;
    };
    /**
     * To render the yAxis label
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.drawYAxisLabels = function(axis, index, parent, rect) {
        var chart = this.chart;
        var label;
        var pointX = 0;
        var pointY = 0;
        var elementSize;
        var labelSpace = axis.labelPadding;
        var options;
        var isAxisBreakLabel;
        var isLabelInside = axis.labelPosition === "Inside";
        var isOpposed = axis.isAxisOpposedPosition;
        var RotatedWidth;
        var tickSpace = axis.labelPosition === axis.tickPosition ? axis.majorTickLines.height : 0;
        var padding = tickSpace + labelSpace + axis.lineStyle.width * 0.5;
        var angle = axis.angle % 360;
        var isVerticalAngle = angle === -90 || angle === 90 || angle === 270 || angle === -270;
        padding += isVerticalAngle ? isLabelInside ? 5 : -5 : 0;
        padding = isOpposed ? padding : -padding;
        var labelElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisLabels" + index
        });
        var scrollBarHeight = (0, $3EnZW.isNullOrUndefined)(axis.crossesAt) ? axis.scrollBarHeight * (isOpposed ? 1 : -1) : 0;
        var textHeight;
        var textPadding;
        var maxLineWidth;
        var pixel = 10;
        var isInverse = axis.isAxisInverse;
        var count = 1;
        var previousEnd = isInverse ? rect.y : rect.y + rect.height;
        var labelPadding;
        var intervalLength;
        var labelHeight;
        var yAxisLabelX;
        var isLabelOnAxisLineLeft = !isOpposed && !isLabelInside || isOpposed && isLabelInside;
        if (isLabelInside) labelPadding = !isLabelOnAxisLineLeft ? -padding : padding;
        else labelPadding = !isLabelOnAxisLineLeft ? -padding + (chart.enableRtl ? -scrollBarHeight : scrollBarHeight) : padding + (chart.enableRtl ? -scrollBarHeight : scrollBarHeight);
        var sizeWidth = [];
        var breakLabelSizeWidth = [];
        axis.visibleLabels.map(function(item) {
            sizeWidth.push(item.size["width"]);
            breakLabelSizeWidth.push(item.breakLabelSize["width"]);
        });
        var LabelMaxWidth = Math.max.apply(Math, sizeWidth);
        var breakLabelMaxWidth = Math.max.apply(Math, breakLabelSizeWidth);
        RotatedWidth = LabelMaxWidth;
        if (angle >= -45 && angle <= 45 && angle !== 0) {
            RotatedWidth = LabelMaxWidth * Math.cos(angle * Math.PI / 180);
            if (RotatedWidth < 0) RotatedWidth = -RotatedWidth;
        }
        for(var i = 0, len = axis.visibleLabels.length; i < len; i++){
            label = axis.visibleLabels[i];
            isAxisBreakLabel = (0, $11815a21a80ae2b7$export$1930212191838fe4)(axis.visibleLabels[i].originalText);
            elementSize = isAxisBreakLabel ? axis.visibleLabels[i].breakLabelSize : axis.visibleLabels[i].size;
            pointY = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(axis.visibleLabels[i].value, axis) * rect.height + (chart.stockChart ? 7 : 0);
            pointY = Math.floor(pointY * -1 + (rect.y + rect.height));
            textHeight = elementSize.height / 8 * axis.visibleLabels[i].text.length / 2;
            textPadding = chart.requireInvertedAxis && axis.labelPosition === "Inside" ? 0 : elementSize.height / 4 * 3 + 3;
            intervalLength = rect.height / axis.visibleLabels.length;
            labelHeight = (axis.labelIntersectAction === "Trim" || axis.labelIntersectAction === "Wrap") && angle !== 0 && elementSize.width > intervalLength ? intervalLength : elementSize.width;
            pointY = isAxisBreakLabel ? axis.labelPosition === "Inside" ? pointY - elementSize.height / 2 - textHeight + textPadding : pointY - textHeight : axis.labelPosition === "Inside" ? pointY + textPadding : pointY;
            if (axis.labelPosition === "Inside" && (i === 0 && !axis.isInversed || i === len - 1 && axis.isInversed)) {
                if (chart.stockChart) pointY -= textPadding;
                else pointY -= textPadding - (chart.requireInvertedAxis && axis.labelPosition === "Inside" ? 0 : axis.opposedPosition ? -padding : padding);
            }
            if (axis.majorGridLines.width > axis.majorTickLines.width) maxLineWidth = axis.majorGridLines.width;
            else maxLineWidth = axis.majorTickLines.width;
            if (axis.labelStyle.textAlignment === "Far") pointY = pointY - maxLineWidth - pixel;
            else if (axis.labelStyle.textAlignment === "Near") pointY = pointY + maxLineWidth + pixel;
            // label X value adjustment (Start)
            if (isLabelInside) yAxisLabelX = labelPadding + (angle === 0 ? elementSize.width : isAxisBreakLabel ? breakLabelMaxWidth : LabelMaxWidth) / 2;
            else yAxisLabelX = labelPadding - (angle === 0 ? elementSize.width : isAxisBreakLabel ? breakLabelMaxWidth : RotatedWidth) / 2;
            pointX = isOpposed ? axis.scrollBarHeight !== 0 ? rect.x + axis.scrollBarHeight + padding - yAxisLabelX : rect.x - yAxisLabelX : rect.x + yAxisLabelX;
            if (isVerticalAngle) pointX += isOpposed ? 5 : -5;
            yAxisLabelX = labelPadding;
            options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(chart.element.id + index + "_AxisLabel_" + i, pointX, pointY, "middle", label.text, "", "middle", angle);
            switch(axis.edgeLabelPlacement){
                case "None":
                    break;
                case "Hide":
                    if ((i === 0 || isInverse && i === len - 1) && options.y > rect.y || (i === len - 1 || isInverse && i === 0) && options.y - elementSize.height * 0.5 < rect.y) options.text = "";
                    break;
                case "Shift":
                    if ((i === 0 || isInverse && i === len - 1) && options.y > rect.y + rect.height) options.y = pointY = rect.y + rect.height;
                    else if ((i === len - 1 || isInverse && i === 0) && (options.y < rect.y || options.y - elementSize.height * 0.5 <= 0)) options.y = pointY = rect.y + elementSize.height * 0.5;
                    break;
            }
            // ------- Hide Calculation (Start) -------------
            var previousYValue = options.y;
            var currentYValue = options.y - labelHeight;
            if (isAxisBreakLabel) {
                previousYValue = options.y - labelHeight / 2;
                currentYValue = options.y + labelHeight / 2;
            }
            if ((angle === 90 || angle === 270) && axis.labelIntersectAction === "Hide" && i !== 0 && (!isInverse ? previousYValue >= previousEnd : currentYValue <= previousEnd)) continue;
            previousEnd = isInverse ? previousYValue : currentYValue;
            // ------- Hide Calculation (End) -------------
            options.transform = "rotate(" + angle + "," + pointX + "," + pointY + ")";
            if (this.chart.redraw && this.chart.zoomRedraw && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(options.id) && !this.chart.enableCanvas && axis.visible) {
                var optionsY = options.y;
                options.y = this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / (i ? i : 1) * count : -(this.seriesClipRect.height / (i ? i : 1) * count));
                this.updateAxisElement(axis, index, "", i, "_AxisLabel_", labelElement, false, options, label);
                options.y = optionsY;
                count += 1;
            }
            (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, options, label.labelStyle, label.labelStyle.color || chart.themeStyle.axisLabelFont.color, labelElement, false, chart.redraw, true, true, chart.duration, null, null, null, chart.enableCanvas, null, chart.themeStyle.axisLabelFont, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(pointX, pointY));
        }
        if (this.previousYLabel && axis.visibleLabels.length && this.previousYLabel > axis.visibleLabels.length && !this.chart.enableCanvas && axis.visible && this.chart.zoomRedraw && chart.redraw && options.text) for(var i = axis.visibleLabels.length; i < this.previousYLabel; i++){
            options.y = this.seriesClipRect.y + (axis.isInversed ? this.seriesClipRect.height + this.seriesClipRect.height / axis.visibleLabels.length * (i - axis.visibleLabels.length + 1) : -(this.seriesClipRect.height / axis.visibleLabels.length * (i - axis.visibleLabels.length + 1)));
            options.id = chart.element.id + index + "_AxisLabel_" + i;
            this.updateAxisElement(axis, index, "", i, "_AxisLabel_", labelElement, true, options, label);
        }
        else this.previousYLabel = axis.visibleLabels.length;
        if (!this.chart.enableCanvas) {
            if (!chart.delayRedraw) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, parent, labelElement, chart.redraw);
            else if (axis.visible && axis.internalVisibility) this.createZoomingLabel(this.chart, labelElement, axis, index, rect);
        }
    };
    /**
     * Animates the template element.
     *
     * @param {Axis} axis axis
     * @param {Element} element - The element to animate.
     * @param {number} duration - The duration of the animation.
     * @param {boolean} label - Label.
     * @param {Rect} bounds - The bounding rectangle.
     * @param {boolean} isRemove isRemoved
     * @param {number} i index of the element
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.rangeAnimate = function(axis, element, duration, label, bounds, isRemove, i) {
        var _this = this;
        if (element) new (0, $kj1BR.Animation)({}).animate(element, {
            duration: duration,
            progress: function() {
                var animateElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(element.id);
                animateElement.style.animation = "";
                if (label) {
                    if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(parseFloat(animateElement.getAttribute("x")), parseFloat(animateElement.getAttribute("y")), bounds)) animateElement.style.visibility = "visible";
                    else animateElement.style.visibility = "hidden";
                } else {
                    var direction = animateElement.getAttribute("d").split(" ");
                    if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(parseFloat(direction[1]), parseFloat(direction[2]), bounds)) animateElement.style.visibility = "visible";
                    else animateElement.style.visibility = "hidden";
                }
            },
            end: function() {
                var animateElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(element.id);
                animateElement.style.visibility = "";
                if (isRemove && i >= axis.visibleLabels.length) {
                    (0, $11815a21a80ae2b7$export$f883456a56996078)(animateElement);
                    if (label) {
                        if (axis.orientation === "Vertical") _this.previousYLabel = axis.visibleLabels.length;
                        else _this.previousXLabel = axis.visibleLabels.length;
                    }
                }
            }
        });
    };
    /**
     * To get X value based on lineBreakAlignment for Y axis line break labels only.
     *
     * @param {number} x text x position
     * @param {Axis} axis y axis values
     * @param {number} textWidth axis label width
     * @returns {number} returns suitable axis label x position
     */ CartesianAxisLayoutPanel.prototype.getAxisLabelXvalue = function(x, axis, textWidth) {
        var anchor = axis.lineBreakAlignment;
        var isLabelInside = axis.labelPosition === "Inside";
        var isOpposed = axis.isAxisOpposedPosition;
        if (isOpposed && isLabelInside || !isOpposed && !isLabelInside) return anchor === "Right" ? x : anchor === "Center" ? x - textWidth / 2 : x - textWidth;
        else return anchor === "Left" ? x : anchor === "Center" ? x + textWidth / 2 : x + textWidth;
    };
    /**
     * To render the yAxis label border.
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawYAxisBorder = function(axis, index, parent, rect) {
        if (axis.border.width > 0) {
            var startY = void 0;
            var pointY = void 0;
            var scrollBarHeight = axis.labelPosition === "Outside" ? axis.scrollBarHeight : 0;
            var isOpposed = axis.isAxisOpposedPosition;
            scrollBarHeight = (isOpposed ? 1 : -1) * scrollBarHeight;
            var gap = rect.height / axis.visibleRange.delta * (axis.valueType === "DateTime" ? axis.dateTimeInterval : axis.visibleRange.interval);
            var endY = void 0;
            var length_1 = axis.maxLabelSize.width + 10 + (axis.tickPosition === axis.labelPosition ? axis.majorTickLines.height : 0);
            var labelBorder = "";
            var ticksbwtLabel = axis.valueType === "Category" && axis.labelPlacement === "BetweenTicks" ? -0.5 : 0;
            var endX = isOpposed && axis.labelPosition === "Inside" || !isOpposed && axis.labelPosition === "Outside" ? rect.x - length_1 + scrollBarHeight : rect.x + length_1 + scrollBarHeight;
            for(var i = 0, len = axis.visibleLabels.length; i < len; i++){
                pointY = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(axis.visibleLabels[i].value + ticksbwtLabel, axis);
                pointY = (axis.isAxisInverse ? 1 - pointY : pointY) * rect.height;
                if (axis.valueType === "Category" && axis.labelPlacement === "BetweenTicks") {
                    startY = pointY * -1 + (rect.y + rect.height);
                    endY = pointY * -1 - gap + (rect.y + rect.height);
                } else {
                    startY = pointY * -1 + gap / 2 + (rect.y + rect.height);
                    endY = pointY * -1 - gap / 2 + (rect.y + rect.height);
                }
                switch(axis.border.type){
                    case "Rectangle":
                    case "WithoutTopBorder":
                        if (startY > rect.y + rect.height) labelBorder += "M " + endX + " " + (rect.y + rect.height) + " " + "L" + " " + endX + " " + endY + " ";
                        else if (Math.floor(rect.y) > endY) labelBorder += "M " + (rect.x + scrollBarHeight) + " " + startY + " " + "L" + " " + endX + " " + startY + " " + "L" + " " + endX + " " + rect.y + " ";
                        else {
                            labelBorder += "M " + (rect.x + scrollBarHeight) + " " + startY + " " + "L" + " " + endX + " " + startY + " " + "L" + " " + endX + " " + endY + " ";
                            if (i === axis.visibleLabels.length - 1) labelBorder += "M " + (rect.x + scrollBarHeight) + " " + endY + " " + "L" + " " + endX + " " + endY + " ";
                        }
                        break;
                    case "WithoutTopandBottomBorder":
                        if (!(startY > rect.y + rect.height) && !(endY < Math.floor(rect.y))) labelBorder += "M " + (rect.x + scrollBarHeight) + " " + startY + " " + "L" + " " + endX + " " + startY + " " + "M" + " " + endX + " " + endY + " " + "L" + " " + (rect.x + scrollBarHeight) + " " + endY;
                        break;
                }
            }
            labelBorder += axis.border.type === "Rectangle" ? "M " + (rect.x + scrollBarHeight) + " " + rect.y + " " + "L" + " " + (rect.x + scrollBarHeight) + " " + (rect.y + rect.height) + " " : "";
            if (labelBorder !== "") this.createAxisBorderElement(axis, index, labelBorder, parent);
        }
        for(var i = 0; i < this.chart.visibleSeries.length; i++)if (axis.multiLevelLabels.length > 0 && this.chart.multiLevelLabelModule && this.chart.visibleSeries[i].visible) {
            this.chart.multiLevelLabelModule.renderYAxisMultiLevelLabels(axis, index, parent, rect);
            break;
        }
    };
    /**
     * To render the yAxis title
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawYAxisTitle = function(axis, index, parent, rect) {
        if (axis.title) {
            var chart = this.chart;
            var isRotated = false;
            var isOpposed = axis.isAxisOpposedPosition;
            var labelRotation = (axis.titleRotation == null ? isOpposed ? 90 : -90 : axis.titleRotation) % 360;
            var padding = (axis.tickPosition === "Inside" ? 0 : axis.majorTickLines.height + axis.titlePadding) + (axis.labelPosition === "Inside" ? 0 : axis.maxLabelSize.width + axis.multiLevelLabelHeight + this.padding);
            padding = isOpposed ? padding + axis.scrollBarHeight : -padding - axis.scrollBarHeight;
            if (labelRotation !== -90 && !isOpposed || labelRotation !== 90 && isOpposed) {
                padding += axis.isAxisOpposedPosition ? axis.titleSize.width / 2 + axis.labelPadding : -axis.titleSize.width / 2 - axis.labelPadding;
                isRotated = true;
            }
            var x = rect.x + padding;
            var y = void 0;
            var anchor = void 0;
            if (axis.titleStyle.textAlignment === "Center") {
                anchor = "middle";
                y = rect.y + rect.height * 0.5;
            } else if (axis.titleStyle.textAlignment === "Near") {
                anchor = axis.opposedPosition ? "end" : "start";
                y = rect.height + rect.y;
            } else {
                anchor = axis.opposedPosition ? "start" : "end";
                y = rect.y;
            }
            var titleSize = axis.titleSize.height * (axis.titleCollection.length - 1);
            var options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(chart.element.id + "_AxisTitle_" + index, x, y + (isRotated ? -titleSize : -axis.labelPadding - titleSize), anchor, axis.titleCollection, "rotate(" + labelRotation + "," + x + "," + y + ")", null, labelRotation);
            var element = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, options, axis.titleStyle, axis.titleStyle.color || chart.themeStyle.axisTitleFont.color, parent, null, null, null, null, null, null, null, null, chart.enableCanvas, null, chart.themeStyle.axisTitleFont, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(x, y));
            element.setAttribute("aria-hidden", "true");
        }
    };
    /**
     * xAxis grid line calculation performed here
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawXAxisGridLine = function(axis, index, parent, rect) {
        var isLogAxis = axis.valueType === "Logarithmic";
        var isCategoryAxis = axis.valueType.indexOf("Category") > -1;
        var tempInterval;
        var pointX = 0;
        var majorGrid = "";
        var majorTick = "";
        var minorDirection;
        var count = 1;
        var isOpposed = axis.isAxisOpposedPosition;
        var tickSize = isOpposed ? -axis.majorTickLines.height : axis.majorTickLines.height;
        var axisLineSize = isOpposed ? -axis.lineStyle.width * 0.5 : axis.lineStyle.width * 0.5;
        var scrollBarHeight = (0, $3EnZW.isNullOrUndefined)(axis.crossesAt) ? isOpposed ? -axis.scrollBarHeight : axis.scrollBarHeight : 0;
        var ticksbwtLabel = axis.valueType.indexOf("Category") > -1 && axis.labelPlacement === "BetweenTicks" && !this.chart.stockChart ? 0.5 : 0;
        var length = axis.visibleLabels.length;
        var isTickInside = axis.tickPosition === "Inside";
        var ticks = isTickInside ? rect.y - tickSize - axisLineSize : rect.y + tickSize + axisLineSize + scrollBarHeight;
        var chartThemeStyle = this.chart.themeStyle;
        if (axis.valueType.indexOf("Category") > -1 && length > 0 && axis.labelPlacement === "BetweenTicks" && !this.chart.stockChart) length += 1;
        var numericIDs = this.calculateGridLineId(parent, length);
        for(var i = 0; i < length; i++){
            if (axis.valueType !== "DateTimeCategory") tempInterval = axis.visibleLabels[i] ? axis.visibleLabels[i].value - ticksbwtLabel : axis.visibleLabels[i - 1].value + axis.visibleRange.interval - ticksbwtLabel;
            else tempInterval = axis.visibleLabels[i] ? axis.visibleLabels[i].value - ticksbwtLabel : axis.visibleRange.max;
            pointX = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(tempInterval, axis) * rect.width + rect.x;
            if (pointX >= rect.x && rect.x + rect.width >= pointX) {
                if ((0, $11815a21a80ae2b7$export$245b06b49bc2b810)(tempInterval, axis.visibleRange) || this.isBorder(axis, i, pointX)) {
                    if (this.chart.redraw && (this.chart.pointsAdded && !this.chart.pointsRemoved || this.chart.zoomRedraw) && axis.majorGridLines.width && i !== 0 && axis.visible && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_MajorGridLine_" + index + "_" + i) && !this.chart.enableCanvas) {
                        var pointXValue = this.seriesClipRect.x + (this.chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / length * count) : this.seriesClipRect.width + this.seriesClipRect.width / (i ? i : 1) * count);
                        majorGrid = "M " + pointXValue + " " + (this.seriesClipRect.y + this.seriesClipRect.height) + " L " + pointXValue + " " + this.seriesClipRect.y;
                        this.renderGridLine(axis, index, majorGrid, axis.majorGridLines, "_MajorGridLine_", i, this.element, chartThemeStyle.majorGridLine, axis.majorGridLines.dashArray, numericIDs["MajorGridLine"] && numericIDs["MajorGridLine"].ids ? numericIDs["MajorGridLine"].ids[i] : null, numericIDs["MajorGridLine"] ? numericIDs["MajorGridLine"].isPointRemoved : false);
                        this.rangeAnimate(axis, this.element.childNodes[this.element.childNodes.length - 1], this.chart.duration, false, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(this.seriesClipRect.x, axis.rect.y, this.seriesClipRect.x + this.seriesClipRect.width, this.chart.availableSize.height), false, i);
                        (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(parent.id).appendChild(this.element.childNodes[this.element.childNodes.length - 1]);
                    }
                    majorGrid = "M " + pointX + " " + (this.seriesClipRect.y + this.seriesClipRect.height) + " L " + pointX + " " + this.seriesClipRect.y;
                    this.renderGridLine(axis, index, majorGrid, axis.majorGridLines, "_MajorGridLine_", i, this.element, chartThemeStyle.majorGridLine, axis.majorGridLines.dashArray, numericIDs["MajorGridLine"] && numericIDs["MajorGridLine"].ids ? numericIDs["MajorGridLine"].ids[i] : null, numericIDs["MajorGridLine"] ? numericIDs["MajorGridLine"].isPointRemoved : false);
                }
                if (this.chart.redraw && this.chart.zoomRedraw && axis.majorTickLines.width && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_MajorTickLine_" + index + "_" + i) && !this.chart.enableCanvas && axis.visible) {
                    majorTick = "M " + (this.seriesClipRect.x + (this.chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / length * count) : this.seriesClipRect.width + this.seriesClipRect.width / (i ? i : 1) * count)) + " " + (rect.y + axisLineSize + (isTickInside ? scrollBarHeight : 0)) + " L " + (this.seriesClipRect.x + (this.chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / length * count) : this.seriesClipRect.width + this.seriesClipRect.width / (i ? i : 1) * count)) + " " + ticks;
                    this.updateAxisElement(axis, index, majorTick, i, "_MajorTickLine_", parent, false);
                    (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(parent.id).appendChild(this.element.childNodes[this.element.childNodes.length - 1]);
                    count += 1;
                }
                majorTick = "M " + pointX + " " + (rect.y + axisLineSize + (isTickInside ? scrollBarHeight : 0)) + " L " + pointX + " " + ticks;
                this.renderGridLine(axis, index, majorTick, axis.majorTickLines, "_MajorTickLine_", i, parent, chartThemeStyle.majorTickLine, null, numericIDs["MajorTickLine"] && numericIDs["MajorTickLine"].ids ? numericIDs["MajorTickLine"].ids[i] : null, numericIDs["MajorTickLine"] ? numericIDs["MajorTickLine"].isPointRemoved : false);
                if (axis.minorTicksPerInterval > 0 && (axis.minorGridLines.width > 0 || axis.minorTickLines.width > 0)) {
                    if (i === 0 && (0, $11815a21a80ae2b7$export$a34692dfee195c82)(axis) && !isLogAxis && !isCategoryAxis) this.renderMinorGridOnZooming(axis, tempInterval, rect, i, index, chartThemeStyle, parent);
                    minorDirection = this.drawAxisMinorLine(axis, tempInterval, rect, i);
                    this.renderGridLine(axis, index, minorDirection[0], axis.minorGridLines, "_MinorGridLine_", i, this.element, chartThemeStyle.minorGridLine, axis.minorGridLines.dashArray, numericIDs["MinorGridLine"] && numericIDs["MinorGridLine"].ids ? numericIDs["MinorGridLine"].ids[i] : null, numericIDs["MinorGridLine"] ? numericIDs["MinorGridLine"].isPointRemoved : false);
                    this.renderGridLine(axis, index, minorDirection[1], axis.minorTickLines, "_MinorTickLine_", i, parent, chartThemeStyle.minorTickLine, null, numericIDs["MinorTickLine"] && numericIDs["MinorTickLine"].ids ? numericIDs["MinorTickLine"].ids[i] : null, numericIDs["MinorTickLine"] ? numericIDs["MinorTickLine"].isPointRemoved : false);
                    if (i === length - 1 && (0, $11815a21a80ae2b7$export$a34692dfee195c82)(axis) && isLogAxis && !isCategoryAxis) this.renderMinorGridOnZooming(axis, tempInterval + axis.visibleRange.interval, rect, i, index, chartThemeStyle, parent);
                }
            }
        }
        if (length && this.previousXLabel > length && !this.chart.enableCanvas && axis.visible && this.chart.zoomRedraw && this.chart.redraw) for(var i = length; i < this.previousXLabel; i++){
            var pointXValue = this.seriesClipRect.x + (this.chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / length * (i - length + 1)) : this.seriesClipRect.width + this.seriesClipRect.width / length * (i - length + 1));
            if (axis.majorGridLines.width) {
                majorGrid = "M " + pointXValue + " " + (this.seriesClipRect.y + this.seriesClipRect.height) + " L " + pointXValue + " " + this.seriesClipRect.y;
                this.updateAxisElement(axis, index, majorGrid, i, "_MajorGridLine_", this.element, true);
            }
            if (axis.majorTickLines.width) {
                majorTick = "M " + pointXValue + " " + (rect.y + axisLineSize + (isTickInside ? scrollBarHeight : 0)) + " L " + pointXValue + " " + ticks;
                this.updateAxisElement(axis, index, majorTick, i, "_MajorTickLine_", parent, true);
            }
        }
    };
    CartesianAxisLayoutPanel.prototype.calculateGridLineId = function(parent, length) {
        var _this = this;
        var numericIDs = {};
        if (this.chart.pointsRemoved) {
            var elementTypes = [
                "MajorGridLine",
                "MajorTickLine",
                "MinorGridLine",
                "MinorTickLine"
            ];
            elementTypes.forEach(function(type) {
                var parentElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(parent.id);
                var elements = parentElement.querySelectorAll('[id*="_' + type + '_"]');
                var elementArray = [];
                for(var i = 0; i < elements.length; i++)elementArray.push(elements[i]);
                var len = type === "MajorGridLine" && _this.chart.chartArea.border.width ? length - 2 : length;
                len = type === "MinorGridLine" || type === "MinorTickLine" ? length - 1 : len;
                if (elementArray.length > 0 && elementArray.length > len) {
                    var elementsLength = elementArray.length;
                    for(var k = 0; k < elementsLength - len; k++){
                        if (elementArray[k]) parentElement.removeChild(elementArray[k]);
                        elementArray.shift();
                    }
                    var numericIds = elementArray.map(function(element) {
                        var parts = element.id.split("_");
                        return parseInt(parts[parts.length - 1], 10);
                    });
                    numericIDs[type] = {
                        ids: numericIds,
                        isPointRemoved: true
                    };
                }
            });
        }
        return numericIDs;
    };
    /**
     * To render missing minor grid lines while zooming
     *
     * @param {Axis} axis axis
     * @param {number} tempInterval tempInterval
     * @param {Rect} rect rect
     * @param {number} i i
     * @param {number} index index
     * @param {IThemeStyle} chartThemeStyle chartThemeStyle
     * @param {Element} parent parent
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.renderMinorGridOnZooming = function(axis, tempInterval, rect, i, index, chartThemeStyle, parent) {
        var minorDirection = this.drawAxisMinorLine(axis, tempInterval, rect, i, true);
        this.renderGridLine(axis, index, minorDirection[0], axis.minorGridLines, "_MinorGridLine_", -1, this.element, chartThemeStyle.minorGridLine, axis.minorGridLines.dashArray);
        this.renderGridLine(axis, index, minorDirection[1], axis.minorTickLines, "_MinorTickLine_", -1, parent, chartThemeStyle.minorTickLine);
    };
    /**
     * To calcualte the axis minor line
     *
     * @param {Axis} axis axis
     * @param {number} tempInterval tempInterval
     * @param {Rect} rect rect
     * @param {number} labelIndex labelIndex
     * @param {boolean} isFirstLabel isFirstLabel
     * @returns {string[]} axis minor line path
     */ CartesianAxisLayoutPanel.prototype.drawAxisMinorLine = function(axis, tempInterval, rect, labelIndex, isFirstLabel) {
        var value = tempInterval;
        var coor = 0;
        var position = 0;
        var range = axis.visibleRange;
        var isTickInside = axis.tickPosition === "Inside";
        var direction = [];
        var tickSize = axis.isAxisOpposedPosition ? -axis.minorTickLines.height : axis.minorTickLines.height;
        var logStart;
        var logEnd;
        var logInterval = 1;
        var logPosition = 1;
        var ticksX = isTickInside ? rect.y - tickSize : rect.y + tickSize;
        var ticksY = isTickInside ? rect.x + tickSize : rect.x - tickSize;
        var minorGird = "";
        var minorTick = "";
        var isInverse = axis.isAxisInverse;
        if (axis.valueType === "Logarithmic") {
            logStart = Math.pow(axis.logBase, value - range.interval);
            logEnd = Math.pow(axis.logBase, value);
            logInterval = (logEnd - logStart) / (axis.minorTicksPerInterval + 1);
            logPosition = logStart + logInterval;
        }
        if (axis.orientation === "Horizontal") for(var j = 0; j < axis.minorTicksPerInterval; j++){
            value = this.findLogNumeric(axis, logPosition, value, labelIndex, isFirstLabel);
            logPosition += logInterval;
            if ((0, $11815a21a80ae2b7$export$245b06b49bc2b810)(value, range)) {
                position = (value - range.min) / (range.max - range.min);
                position = Math.ceil((isInverse ? 1 - position : position) * rect.width);
                coor = Math.floor(position + rect.x);
                minorGird = minorGird.concat("M " + coor + " " + this.seriesClipRect.y + "L " + coor + " " + (this.seriesClipRect.y + this.seriesClipRect.height));
                coor = Math.floor(position + rect.x);
                minorTick = minorTick.concat("M " + coor + " " + rect.y + "L " + coor + " " + (ticksX + axis.scrollBarHeight));
            }
        }
        else for(var j = 0; j < axis.minorTicksPerInterval; j++){
            value = this.findLogNumeric(axis, logPosition, value, labelIndex, isFirstLabel);
            if ((0, $11815a21a80ae2b7$export$245b06b49bc2b810)(value, range)) {
                position = (value - range.min) / (range.max - range.min);
                position = Math.ceil((isInverse ? 1 - position : position) * rect.height) * -1; // For inversed axis
                coor = Math.floor(position + rect.y + rect.height);
                minorGird = minorGird.concat("M " + this.seriesClipRect.x + " " + coor + "L " + (this.seriesClipRect.x + this.seriesClipRect.width) + " " + coor + " ");
                coor = Math.floor(position + rect.y + rect.height);
                minorTick = minorTick.concat("M " + rect.x + " " + coor + "L " + (ticksY - axis.scrollBarHeight) + " " + coor + " ");
            }
            logPosition += logInterval;
        }
        direction.push(minorGird);
        direction.push(minorTick);
        return direction;
    };
    /**
     * To find the numeric value of the log
     *
     * @param {Axis} axis axis
     * @param {number} logPosition logPosition
     * @param {number} value value
     * @param {number} labelIndex labelIndex
     * @param {boolean} isFirstLabel isFirstLabel
     * @returns {number} value
     */ CartesianAxisLayoutPanel.prototype.findLogNumeric = function(axis, logPosition, value, labelIndex, isFirstLabel) {
        var range = axis.visibleRange;
        var tempValue;
        if (axis.valueType === "Logarithmic") value = (0, $11815a21a80ae2b7$export$2aa080c37938b627)(logPosition, axis.logBase);
        else if (axis.valueType === "DateTime") {
            tempValue = axis.dateTimeInterval / (axis.minorTicksPerInterval + 1);
            value = isFirstLabel ? value - tempValue : value + tempValue;
        } else if (axis.valueType === "DateTimeCategory") {
            var padding = axis.labelPlacement === "BetweenTicks" ? 0.5 : 0;
            value += ((axis.visibleLabels[labelIndex + 1] ? axis.visibleLabels[labelIndex + 1].value - padding : axis.visibleRange.max) - (axis.visibleLabels[labelIndex] ? axis.visibleLabels[labelIndex].value - padding : axis.visibleRange.min)) / (axis.minorTicksPerInterval + 1);
        } else {
            tempValue = range.interval / (axis.minorTicksPerInterval + 1);
            value = isFirstLabel ? value - tempValue : value + tempValue;
        }
        return value;
    };
    /**
     * To render the xAxis Labels
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     * @private
     */ CartesianAxisLayoutPanel.prototype.drawXAxisLabels = function(axis, index, parent, rect) {
        var chart = this.chart;
        var pointX = 0;
        var pointY = 0;
        var labelSpace = axis.labelPadding;
        var labelHeight;
        var elementSize;
        var labelPadding;
        var anchor;
        var pixel = 10;
        var labelElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisLabels" + index
        });
        var islabelInside = axis.labelPosition === "Inside";
        var isOpposed = axis.isAxisOpposedPosition;
        var tickSpace = axis.labelPosition === axis.tickPosition ? axis.majorTickLines.height : 0;
        var padding = tickSpace + labelSpace + axis.lineStyle.width * 0.5;
        var angle = axis.angle % 360;
        var isHorizontalAngle = angle === 0 || angle === -180 || angle === 180;
        var options;
        var labelWidth;
        var isInverse = axis.isAxisInverse;
        var isLeft;
        var count = 1;
        var previousEnd = isInverse ? rect.x + rect.width : rect.x;
        var width = 0;
        var length = axis.visibleLabels.length;
        var intervalLength;
        var label;
        var isAxisBreakLabel;
        var scrollBarHeight = axis.scrollbarSettings.enable || !islabelInside && (0, $3EnZW.isNullOrUndefined)(axis.crossesAt) && (axis.zoomFactor < 1 || axis.zoomPosition > 0) ? axis.scrollBarHeight : 0;
        var newPoints = [];
        var isRotatedLabelIntersect = false;
        var textPoints = [];
        var rotatedLabelSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
        padding += angle === 90 || angle === 270 || angle === -90 || angle === -270 ? islabelInside ? 5 : -5 : 0;
        var isLabelUnderAxisLine = !isOpposed && !islabelInside || isOpposed && islabelInside;
        var axislabelElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisLabels" + index);
        var pointsRemoved = this.removeAxisLabelElements(axis, axislabelElement);
        var isEndAnchor = isLabelUnderAxisLine ? 360 >= angle && angle >= 180 || -1 >= angle && angle >= -180 : 1 <= angle && angle <= 180 || -181 >= angle && angle >= -360;
        for(var i = 0, len = length; i < len; i++){
            label = axis.visibleLabels[i];
            isAxisBreakLabel = (0, $11815a21a80ae2b7$export$1930212191838fe4)(label.originalText) || axis.labelIntersectAction === "Wrap" && label.text.length > 1;
            pointX = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(label.value, axis) * rect.width + rect.x;
            elementSize = label.size;
            intervalLength = rect.width / length;
            labelWidth = isAxisBreakLabel ? label.breakLabelSize.width : elementSize.width;
            width = (axis.labelIntersectAction === "Trim" || axis.labelIntersectAction === "Wrap") && angle === 0 && labelWidth > intervalLength ? intervalLength : labelWidth;
            labelHeight = elementSize.height / 4;
            pointX -= isAxisBreakLabel || angle !== 0 ? 0 : width / 2;
            // label X value adjustment for label rotation (Start)
            if (angle !== 0) {
                if (isAxisBreakLabel) pointX -= axis.lineBreakAlignment === "Left" ? label.breakLabelSize.width / 2 : axis.lineBreakAlignment === "Right" ? -(label.breakLabelSize.width / 2) : 0;
                else pointX -= angle === -90 || angle === 270 ? -labelHeight : angle === 90 || angle === -270 ? labelHeight : 0;
            }
            // label X value adjustment for label rotation (End)
            if (axis.labelStyle.textAlignment === "Far") pointX = pointX + width - pixel;
            else if (axis.labelStyle.textAlignment === "Near") pointX = pointX - width + pixel;
            // For line break label alignment like left, right & center in angle 0
            if (isAxisBreakLabel && axis.lineBreakAlignment !== "Center" && angle === 0) pointX += axis.lineBreakAlignment === "Left" ? -(width / 2) : width / 2;
            var paddingForBreakLabel = isAxisBreakLabel ? isHorizontalAngle ? axis.opposedPosition || islabelInside ? 0 : elementSize.height : label.breakLabelSize.width / 2 : 0;
            padding = isAxisBreakLabel ? tickSpace + labelSpace + axis.lineStyle.width * 0.5 : padding;
            // label Y value adjustment (Start)
            if (islabelInside && angle) {
                if (isAxisBreakLabel) pointY = isOpposed ? rect.y + padding + paddingForBreakLabel : rect.y - padding - paddingForBreakLabel;
                else pointY = isOpposed ? rect.y + padding + labelHeight : rect.y - padding - labelHeight;
            } else {
                if (isAxisBreakLabel) labelPadding = !isLabelUnderAxisLine ? -(padding + scrollBarHeight + paddingForBreakLabel) : padding + scrollBarHeight + (angle ? paddingForBreakLabel : 3 * labelHeight);
                else labelPadding = !isLabelUnderAxisLine ? -(padding + scrollBarHeight + (angle ? labelHeight : label.index > 1 ? 2 * labelHeight : 0)) : padding + scrollBarHeight + (angle ? 1 : 3) * labelHeight;
                pointY = rect.y + labelPadding * label.index;
            }
            // label Y value adjustment (End)
            if (isAxisBreakLabel) anchor = this.getAnchor(axis); // for break label self alignment
            else anchor = chart.enableRtl ? isEndAnchor ? "" : "end" : chart.isRtlEnabled || isEndAnchor ? "end" : "";
            options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(chart.element.id + index + "_AxisLabel_" + i, pointX, pointY, anchor);
            options.id = pointsRemoved && axislabelElement && axislabelElement.children[i] ? axislabelElement.children[i].id : options.id;
            if (angle !== 0) {
                rotatedLabelSize = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(label.labelStyle, label.originalText, angle, chart, chart.themeStyle.axisLabelFont);
                isLeft = angle < 0 && angle > -90 || angle < -180 && angle > -270 || angle > 90 && angle < 180 || angle > 270 && angle < 360;
            }
            if (axis.edgeLabelPlacement) switch(axis.edgeLabelPlacement){
                case "None":
                    break;
                case "Hide":
                    if ((i === 0 || isInverse && i === len - 1) && options.x < rect.x || (i === len - 1 || isInverse && i === 0) && options.x + (angle === 0 ? width : rotatedLabelSize.width) > rect.x + rect.width) continue;
                    break;
                case "Shift":
                    if ((i === 0 || isInverse && i === len - 1) && (options.x < rect.x || angle !== 0 && isLeft && options.x - rotatedLabelSize.width <= rect.x || axis.lineBreakAlignment === "Center" && options.x - label.size.width / label.text.length / 2 < rect.x && angle === 0)) {
                        intervalLength -= rect.x - options.x;
                        if (anchor === "" && !isInverse && angle === 0) {
                            if (options.x <= 0) pointX = options.x = 0;
                            else pointX = options.x;
                            intervalLength = rect.width / length;
                        } else if (isLeft && angle !== 0) {
                            intervalLength = rect.width / length;
                            if (rect.x + intervalLength > options.x + rotatedLabelSize.width) options.x = pointX = rect.x + padding;
                            else options.x = pointX = rect.x + intervalLength - padding;
                        } else if (isAxisBreakLabel && axis.lineBreakAlignment === "Center" && axis.labelPlacement === "OnTicks" && angle === 0) {
                            var maxWidth = 0;
                            for(var i_1 = 0; i_1 < label.text.length; i_1++){
                                var breakLabelWidth = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(label.text[i_1], axis.labelStyle, chart.themeStyle.axisLabelFont).width;
                                if (breakLabelWidth > maxWidth) maxWidth = breakLabelWidth;
                            }
                            options.x = pointX = rect.x + maxWidth / 2;
                        } else if (!(anchor === "start" && options.x > 0)) options.x = pointX = !isHorizontalAngle ? rect.x + padding : rect.x;
                    } else if ((i === len - 1 || isInverse && i === 0) && (options.x + width > rect.x + rect.width && anchor !== "end" && angle === 0 || angle !== 0 && !isLeft && options.x + rotatedLabelSize.width > rect.x + rect.width || anchor === "end" && options.x > rect.x + rect.width)) {
                        if (elementSize.width > intervalLength && axis.labelIntersectAction === "Trim" && angle === 0) intervalLength -= options.x + width - (rect.x + rect.width);
                        else if (angle !== 0) {
                            if (rotatedLabelSize.width < intervalLength) intervalLength = rotatedLabelSize.width;
                        } else intervalLength = width;
                        if (angle !== 0) options.x = pointX = rect.x + rect.width - intervalLength + padding;
                        else options.x = pointX = !isHorizontalAngle ? rect.x + rect.width - intervalLength / 2 : rect.x + rect.width - intervalLength;
                    }
                    break;
            }
            options.text = this.getLabelText(label, axis, intervalLength);
            options.labelRotation = angle;
            // ------- Hide Calculation (Start) -------------
            // Currect label actual start value (Start)
            var xValue = void 0;
            var xValue2 = void 0;
            if (isAxisBreakLabel && angle === 0) {
                if (axis.lineBreakAlignment === "Right") {
                    xValue = options.x - width;
                    xValue2 = options.x;
                } else if (axis.lineBreakAlignment === "Center") {
                    xValue = options.x - width / 2;
                    xValue2 = options.x + width / 2;
                } else {
                    xValue = options.x;
                    xValue2 = options.x + width;
                }
            } else {
                xValue = options.x;
                xValue2 = options.x + width;
            }
            // Currect label actual start value (End)
            if (angle === 0 && axis.labelIntersectAction === "Hide" && i !== 0 && (!isInverse ? xValue <= previousEnd : xValue2 >= previousEnd)) continue;
            // Previous label actual end value (Start)
            if (isAxisBreakLabel) {
                if (axis.lineBreakAlignment === "Right") previousEnd = isInverse ? options.x - width : options.x;
                else if (axis.lineBreakAlignment === "Center") previousEnd = isInverse ? options.x - width / 2 : options.x + width / 2;
                else previousEnd = isInverse ? options.x : options.x + width;
            } else previousEnd = isInverse ? options.x : options.x + width;
            // Previous label actual end value (End)
            // ------- Hide Calculation (End) -------------
            // label Rotataion calculation (Start)
            if (angle !== 0) {
                var height = void 0;
                var rect_1 = void 0;
                if (isAxisBreakLabel) {
                    var xAdjustment = 0;
                    var yAdjustment = 0;
                    height = label.breakLabelSize.height;
                    yAdjustment = label.breakLabelSize.height - 4; // 4 for label bound correction
                    // xAdjustment (Start)
                    if (axis.lineBreakAlignment === "Center") xAdjustment = -(label.breakLabelSize.width / 2);
                    else if (axis.lineBreakAlignment === "Right") xAdjustment = -label.breakLabelSize.width;
                    // xAdjustment (End)
                    if (isLabelUnderAxisLine) yAdjustment = label.breakLabelSize.height / (options.text.length + 1);
                    rect_1 = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(options.x + xAdjustment, options.y - yAdjustment, label.breakLabelSize.width, height);
                } else {
                    height = pointY - (options.y - label.size.height / 2);
                    rect_1 = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(options.x, options.y - (label.size.height / 2 - 5), label.size.width, height);
                }
                var rectCoordinates = this.getRectanglePoints(rect_1);
                var rectCenterX = isAxisBreakLabel ? rect_1.x + rect_1.width / 2 : pointX;
                var rectCenterY = isAxisBreakLabel ? rect_1.y + rect_1.height / 2 : pointY - height / 2;
                if (isAxisBreakLabel) options.transform = "rotate(" + angle + "," + rectCenterX + "," + rectCenterY + ")";
                else options.transform = "rotate(" + angle + "," + pointX + "," + pointY + ")";
                newPoints.push((0, $11815a21a80ae2b7$export$ca09d5b31a43d465)(rectCoordinates, rectCenterX, rectCenterY, angle));
                isRotatedLabelIntersect = false;
                if (axis.labelIntersectAction !== "None") {
                    for(var index_1 = i; index_1 > 0; index_1--)if (newPoints[i] && newPoints[index_1 - 1] && (0, $11815a21a80ae2b7$export$1ecdad0cdc9457ed)(newPoints[i], newPoints[index_1 - 1])) {
                        isRotatedLabelIntersect = true;
                        newPoints[i] = null;
                        break;
                    }
                }
                var rotateAngle = angle > 0 && angle < 90 || angle > 180 && angle < 270 || angle < -90 && angle > -180 || angle < -270 && angle > -360;
                var textRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(options.x, options.y - (elementSize.height / 2 + padding / 2), label.size.width, height);
                var textRectCoordinates = this.getRectanglePoints(textRect);
                var rectPoints = [];
                rectPoints.push(new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rotateAngle ? this.chart.availableSize.width : this.padding, axis.rect.y));
                rectPoints.push(new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rotateAngle ? this.chart.availableSize.width : this.padding, axis.rect.y + axis.maxLabelSize.height));
                textPoints.push((0, $11815a21a80ae2b7$export$ca09d5b31a43d465)(textRectCoordinates, rectCenterX, rectCenterY, angle));
                var newRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, axis.rect.y, this.chart.availableSize.width, axis.maxLabelSize.height * 2);
                for(var k = 0; k < textPoints[i].length; k++)if (!axis.opposedPosition && !(0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(textPoints[i][k].x, textPoints[i][k].y, newRect) && typeof options.text === "string") {
                    var interSectPoint = this.calculateIntersection(textPoints[i][0], textPoints[i][1], rectPoints[0], rectPoints[1]);
                    var rectPoint1 = rotateAngle ? this.chart.availableSize.width - pointX : pointX;
                    var rectPoint2 = interSectPoint.y - axis.rect.y;
                    var trimValue = Math.sqrt(rectPoint1 * rectPoint1 + rectPoint2 * rectPoint2);
                    options.text = (0, $11815a21a80ae2b7$export$fb7a751b3bd7efd3)(trimValue, label.text, label.labelStyle, chart.enableRtl, chart.themeStyle.axisLabelFont);
                }
            }
            if (this.chart.redraw && (chart.pointsAdded && !chart.pointsRemoved || this.chart.zoomRedraw) && !(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(options.id) && i !== 0 && !this.chart.enableCanvas && axis.visible) {
                var optionsX = options.x;
                options.x = this.seriesClipRect.x + (chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / (i ? i : 1) * count) : this.seriesClipRect.width + this.seriesClipRect.width / (i ? i : 1) * count);
                var transform = options.transform;
                options.transform = angle ? "rotate(" + angle + "," + options.x + "," + parseFloat(options.transform.split(",")[2]) + ")" : "";
                var element_1 = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, options, label.labelStyle, label.labelStyle.color || chart.themeStyle.axisLabelFont.color, labelElement, axis.isAxisOpposedPosition !== (axis.labelPosition === "Inside"), chart.redraw, true, null, chart.duration, null, label.size, isRotatedLabelIntersect, chart.enableCanvas, null, chart.themeStyle.axisLabelFont);
                this.rangeAnimate(axis, element_1, this.chart.duration, true, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(this.seriesClipRect.x, axis.rect.y, this.seriesClipRect.x + this.seriesClipRect.width, this.chart.availableSize.height), false, i);
                options.x = optionsX;
                options.transform = transform;
                count += 1;
            }
            // label Rotataion calculation (End)
            var element = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, options, label.labelStyle, label.labelStyle.color || chart.themeStyle.axisLabelFont.color, labelElement, axis.isAxisOpposedPosition !== (axis.labelPosition === "Inside"), chart.redraw, true, null, chart.duration, null, label.size, isRotatedLabelIntersect, chart.enableCanvas, null, chart.themeStyle.axisLabelFont, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(parseFloat(options.transform.split(",")[1]), parseFloat(options.transform.split(",")[2])));
            if (pointsRemoved) element.id = chart.element.id + index + "_AxisLabel_" + i;
        }
        if (this.previousXLabel && length && this.previousXLabel > length && !this.chart.enableCanvas && axis.visible && this.chart.zoomRedraw && this.chart.redraw && options.text) for(var i = length; i < this.previousXLabel; i++){
            options.x = this.seriesClipRect.x + (chart.enableRtl !== axis.isInversed ? -(this.seriesClipRect.width / length * (i - length + 1)) : this.seriesClipRect.width + this.seriesClipRect.width / length * (i - length + 1));
            options.id = chart.element.id + index + "_AxisLabel_" + i;
            options.transform = angle ? "rotate(" + angle + "," + options.x + "," + parseFloat(options.transform.split(",")[2]) + ")" : "";
            this.updateAxisElement(axis, index, "", i, "_AxisLabel_", labelElement, true, options, label);
        }
        else this.previousXLabel = length;
        if (!this.chart.enableCanvas) {
            if (!chart.delayRedraw) parent.appendChild(labelElement);
            else if (axis.visible && axis.internalVisibility) this.createZoomingLabel(this.chart, labelElement, axis, index, rect);
        }
    };
    /**
     * To render the axis grid, tick lines and label
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {string} gridDirection gridDirection
     * @param {number} i index of the element
     * @param {string} elementId elementId
     * @param {Element} parentElement parent
     * @param {boolean} isRemove isRemoved
     * @param {TextOption} option - The options for the text element.
     * @param {VisibleLabels} label - Label.
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.updateAxisElement = function(axis, index, gridDirection, i, elementId, parentElement, isRemove, option, label) {
        var element;
        var isGrid = elementId.indexOf("Grid") > -1;
        var isLabel = elementId.indexOf("Label") > -1;
        if (isLabel) element = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(this.chart.renderer, option, label.labelStyle, label.labelStyle.color || this.chart.themeStyle.axisLabelFont.color, parentElement, axis.isAxisOpposedPosition !== (axis.labelPosition === "Inside"), this.chart.redraw, true, null, this.chart.duration, null, null, null, this.chart.enableCanvas, null, this.chart.themeStyle.axisLabelFont);
        else {
            this.renderGridLine(axis, index, gridDirection, isGrid ? axis.majorGridLines : axis.majorTickLines, elementId, i, this.element, isGrid ? this.chart.themeStyle.majorGridLine : this.chart.themeStyle.majorTickLine, isGrid ? axis.majorGridLines.dashArray : null);
            if (this.element && parentElement.childNodes) element = this.element.childNodes[parentElement.childNodes.length - 1];
        }
        this.rangeAnimate(axis, element, this.chart.duration, isLabel, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(axis.orientation === "Vertical" ? 0 : this.seriesClipRect.x, axis.orientation === "Vertical" ? this.seriesClipRect.y : axis.rect.y, this.seriesClipRect.width, this.seriesClipRect.height), isRemove, i);
    };
    CartesianAxisLayoutPanel.prototype.removeAxisLabelElements = function(axis, axislabelElement) {
        if (this.chart.pointsRemoved && axislabelElement && axislabelElement.childNodes.length) {
            var pointsRemoved = false;
            if (axis.valueType.indexOf("Category") > -1) {
                var visibleLabelTexts_1 = [];
                axis.visibleLabels.map(function(label) {
                    if (typeof label.text !== "string") visibleLabelTexts_1.push(label.text.join(""));
                    else visibleLabelTexts_1.push(label.text);
                });
                for(var i = axislabelElement.childNodes.length - 1; i >= 0; i--){
                    var childNode = axislabelElement.childNodes[i];
                    if (visibleLabelTexts_1.indexOf(childNode.textContent.trim()) === -1) {
                        axislabelElement.removeChild(childNode);
                        pointsRemoved = true;
                    }
                }
            } else if (axislabelElement.childNodes.length > axis.visibleLabels.length) for(var j = 0; j < axislabelElement.childNodes.length - axis.visibleLabels.length; j++){
                axislabelElement.removeChild(axislabelElement.childNodes[j]);
                pointsRemoved = true;
            }
            return pointsRemoved;
        }
        return false;
    };
    CartesianAxisLayoutPanel.prototype.calculateIntersection = function(p1, p2, p3, p4) {
        var c2x = p3.x - p4.x;
        var c3x = p1.x - p2.x;
        var c2y = p3.y - p4.y;
        var c3y = p1.y - p2.y;
        var d = c3x * c2y - c3y * c2x;
        var u1 = p1.x * p2.y - p1.y * p2.x;
        var u4 = p3.x * p4.y - p3.y * p4.x;
        var px = (u1 * c2x - c3x * u4) / d;
        var py = (u1 * c2y - c3y * u4) / d;
        var p = {
            x: px,
            y: py
        };
        return p;
    };
    /**
     * To get text anchor value for line break labels.
     *
     * @param {Axis} axis axis model
     * @returns {string} returns text anchor
     */ CartesianAxisLayoutPanel.prototype.getAnchor = function(axis) {
        return axis.lineBreakAlignment === "Center" ? "middle" : this.chart.enableRtl ? axis.lineBreakAlignment === "Left" ? "end" : "start" : axis.lineBreakAlignment === "Left" ? "start" : "end";
    };
    /**
     * Get rect coordinates
     *
     * @param {Rect} rect rect
     * @returns {ChartLocation[]} rectangle points
     */ CartesianAxisLayoutPanel.prototype.getRectanglePoints = function(rect) {
        var point1 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x, rect.y);
        var point2 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x + rect.width, rect.y);
        var point3 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x + rect.width, rect.y + rect.height);
        var point4 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x, rect.y + rect.height);
        return [
            point1,
            point2,
            point3,
            point4
        ];
    };
    /**
     * To get axis label text
     *
     * @param {VisibleLabels} label label
     * @param {Axis} axis axis
     * @param {number} intervalLength intervalLength
     * @returns {string | string[]} label or label collection
     */ CartesianAxisLayoutPanel.prototype.getLabelText = function(label, axis, intervalLength) {
        if ((0, $11815a21a80ae2b7$export$1930212191838fe4)(label.originalText)) {
            var result = [];
            var str = void 0;
            for(var index = 0; index < label.text.length; index++){
                str = this.findAxisLabel(axis, label.text[index], intervalLength);
                result.push(str);
            }
            return result;
        } else return this.findAxisLabel(axis, label.text, intervalLength);
    };
    /**
     * To render the x-axis label border.
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} axisRect axisRect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawXAxisBorder = function(axis, index, parent, axisRect) {
        if (axis.border.width > 0) {
            var scrollBarHeight = axis.labelPosition === "Outside" ? axis.scrollBarHeight : 0;
            var isOpposed = axis.isAxisOpposedPosition;
            var startX = void 0;
            var startY = axisRect.y + (isOpposed ? -1 : 1) * scrollBarHeight;
            var padding = 10;
            var pointX = void 0;
            var gap = axisRect.width / axis.visibleRange.delta * (axis.valueType === "DateTime" ? axis.dateTimeInterval : axis.visibleRange.interval);
            var endX = void 0;
            var length_2 = axis.maxLabelSize.height + (axis.tickPosition === axis.labelPosition ? axis.majorTickLines.height : 0);
            var labelBorder = "";
            var ticksbwtLabel = axis.valueType === "Category" && axis.labelPlacement === "BetweenTicks" ? -0.5 : 0;
            var endY = isOpposed && axis.labelPosition === "Inside" || !isOpposed && axis.labelPosition === "Outside" ? axisRect.y + length_2 + padding + scrollBarHeight : axisRect.y - length_2 - padding - scrollBarHeight;
            for(var i = 0, len = axis.visibleLabels.length; i < len; i++){
                pointX = (0, $11815a21a80ae2b7$export$f83186674b8cab09)(axis.visibleLabels[i].value + ticksbwtLabel, axis);
                pointX = (axis.isAxisInverse ? 1 - pointX : pointX) * axisRect.width;
                if (axis.valueType === "Category" && axis.labelPlacement === "BetweenTicks") {
                    startX = pointX + axisRect.x;
                    endX = pointX + gap + axisRect.x;
                } else {
                    startX = pointX - gap * 0.5 + axisRect.x;
                    endX = pointX + gap * 0.5 + axisRect.x;
                }
                switch(axis.border.type){
                    case "Rectangle":
                    case "WithoutTopBorder":
                        if (startX < axisRect.x && axis.labelPlacement !== "OnTicks") labelBorder += "M " + axisRect.x + " " + endY + " " + "L" + " " + endX + " " + endY + " ";
                        else if (Math.floor(endX) > axisRect.width + axisRect.x && !(axis.visibleLabels.length === 1) && !(i === axis.visibleLabels.length - 1)) labelBorder += "M " + startX + " " + startY + " " + "L" + " " + startX + " " + endY + " " + "L" + " " + (axisRect.width + axisRect.x) + " " + endY + " ";
                        else {
                            startX = i === 0 && axis.labelPlacement === "OnTicks" ? axisRect.x : startX;
                            endX = i === axis.visibleLabels.length - 1 && axis.labelPlacement === "OnTicks" ? endX - gap * 0.5 : endX;
                            labelBorder += "M " + startX + " " + startY + " " + "L" + " " + startX + " " + endY + " " + "L" + " " + endX + " " + endY + " ";
                            if (i === 0) labelBorder += "M " + startX + " " + startY + " " + "L" + " " + startX + " " + endY + " " + "M " + startX + " " + endY + " L " + axisRect.x + " " + endY;
                            if (i === axis.visibleLabels.length - 1) labelBorder += "M " + endX + " " + startY + " " + "L" + " " + endX + " " + endY + " " + "M " + endX + " " + endY + " L " + (axisRect.width + axisRect.x) + " " + endY;
                        }
                        break;
                    case "WithoutTopandBottomBorder":
                        if (!(startX < axisRect.x) && !(Math.floor(endX) > axisRect.width + axisRect.x)) labelBorder += "M " + startX + " " + startY + " " + "L" + " " + startX + " " + endY + " " + "M " + endX + " " + startY + " L " + endX + " " + endY;
                        break;
                }
            }
            labelBorder += axis.border.type === "Rectangle" ? "M  " + axisRect.x + " " + startY + "L" + " " + (axisRect.x + axisRect.width) + " " + startY : "";
            if (labelBorder !== "") this.createAxisBorderElement(axis, index, labelBorder, parent);
        }
        for(var i = 0; i < this.chart.visibleSeries.length; i++)if (this.chart.multiLevelLabelModule && axis.multiLevelLabels.length > 0 && this.chart.visibleSeries[i].visible) {
            this.chart.multiLevelLabelModule.renderXAxisMultiLevelLabels(axis, index, parent, axisRect);
            break;
        }
    };
    /**
     * To create border element of the axis
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {string} labelBorder labelBorder
     * @param {Element} parent parent
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.createAxisBorderElement = function(axis, index, labelBorder, parent) {
        var element = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_BorderLine_" + index);
        var direction = element ? element.getAttribute("d") : "";
        var borderElement = this.chart.renderer.drawPath(new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(this.chart.element.id + "_BorderLine_" + index, "transparent", axis.border.width, axis.border.color || this.chart.themeStyle.axisLine, 1, "", labelBorder));
        borderElement.style.pointerEvents = "none";
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.chart.enableCanvas, parent, borderElement, this.chart.redraw, false, "x", "y", null, direction, true, null, null, this.chart.duration);
    };
    /**
     * To find the axis label of the intersect action
     *
     * @param {Axis} axis axis
     * @param {string} label label
     * @param {number} width width
     * @returns {string} label
     */ CartesianAxisLayoutPanel.prototype.findAxisLabel = function(axis, label, width) {
        return axis.labelIntersectAction === "Trim" ? axis.angle % 360 === 0 && !axis.enableTrim ? (0, $11815a21a80ae2b7$export$fb7a751b3bd7efd3)(width, label, axis.labelStyle, this.chart.enableRtl, this.chart.themeStyle.axisLabelFont) : label : label;
    };
    /**
     * X-Axis Title function performed
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Element} parent parent
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.drawXAxisTitle = function(axis, index, parent, rect) {
        if (axis.title) {
            var chart = this.chart;
            var elementSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(axis.title, axis.titleStyle, this.chart.themeStyle.axisTitleFont);
            var scrollBarHeight = (0, $3EnZW.isNullOrUndefined)(axis.crossesAt) ? axis.scrollBarHeight : 0;
            var padding = (axis.tickPosition === "Inside" ? 0 : axis.majorTickLines.height + axis.titlePadding) + (axis.labelPosition === "Inside" ? 0 : axis.maxLabelSize.height + axis.multiLevelLabelHeight + axis.labelPadding);
            var titleSize = axis.titleSize.height * (axis.titleCollection.length - 1);
            padding = axis.isAxisOpposedPosition ? -(padding + elementSize.height / 4 + scrollBarHeight + titleSize) : padding + 3 * elementSize.height / 4 + scrollBarHeight;
            var labelRotation = axis.titleRotation ? axis.titleRotation : 0;
            var x = void 0;
            var y = rect.y + padding;
            var anchor = void 0;
            if (axis.titleStyle.textAlignment === "Center") {
                anchor = "middle";
                x = rect.x + rect.width * 0.5;
            } else if (axis.titleStyle.textAlignment === "Near") {
                anchor = "start";
                x = rect.x;
            } else {
                anchor = "end";
                x = rect.x + rect.width;
            }
            if (labelRotation !== 0) y += axis.opposedPosition ? -(axis.titleSize.height / 2 + elementSize.height / 4) : axis.titleSize.height / 2 - elementSize.height / 4;
            var options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(chart.element.id + "_AxisTitle_" + index, x, y, anchor, axis.titleCollection, "rotate(" + labelRotation + "," + x + "," + y + ")", null, labelRotation);
            var element = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, options, axis.titleStyle, axis.titleStyle.color || chart.themeStyle.axisTitleFont.color, parent, null, chart.redraw, chart.redraw, null, null, null, null, null, chart.enableCanvas, null, chart.themeStyle.axisTitleFont, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(x, y));
            element.setAttribute("aria-hidden", "true");
        }
    };
    /**
     * To render the axis grid and tick lines(Both Major and Minor)
     *
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {string} gridDirection gridDirection
     * @param {MajorTickLinesModel | MinorTickLinesModel | MajorGridLinesModel | MinorGridLinesModel} gridModel gridModel
     * @param {string} gridId gridId
     * @param {number} gridIndex gridIndex
     * @param {Element} parent parent
     * @param {string} themeColor themeColor
     * @param {string} dashArray dashArray
     * @param {number} removeIndex removeIndex
     * @param {boolean} isRemoved isRemoved
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.renderGridLine = function(axis, index, gridDirection, gridModel, gridId, gridIndex, parent, themeColor, dashArray, removeIndex, isRemoved) {
        if (dashArray === void 0) dashArray = null;
        if (removeIndex === void 0) removeIndex = null;
        if (isRemoved === void 0) isRemoved = false;
        var chart = this.chart;
        var direction;
        var element;
        if (gridModel.width > 0 && axis.visible && axis.internalVisibility && gridDirection) {
            element = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + gridId + index + "_" + (isRemoved ? removeIndex : gridIndex));
            direction = element ? element.getAttribute("d") : null;
            element = null;
            this.htmlObject = chart.renderer.drawPath(new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(chart.element.id + gridId + index + "_" + (isRemoved ? removeIndex : gridIndex), "transparent", gridModel.width, gridModel.color || themeColor, null, dashArray, gridDirection));
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, parent, this.htmlObject, chart.redraw, true, "x", "y", null, direction, true, null, null, chart.duration);
            if (isRemoved) this.htmlObject.id = chart.element.id + gridId + index + "_" + gridIndex;
        }
    };
    /**
     * To Find the parent node of the axis
     *
     * @param {string} elementId elementId
     * @param {Element} label label
     * @param {number} index index
     * @returns {Element} parent node of the axis
     */ CartesianAxisLayoutPanel.prototype.findParentNode = function(elementId, label, index) {
        if (document.getElementById(elementId + "AxisGroup" + index + "Inside").contains(document.getElementById(label.id))) return document.getElementById(elementId + "AxisGroup" + index + "Inside");
        else return document.getElementById(elementId + "AxisGroup" + index + "Outside");
    };
    /**
     * Create Zooming Labels Function Called here
     *
     * @param {Chart} chart chart
     * @param {Element} labelElement labelElement
     * @param {Axis} axis axis
     * @param {number} index index
     * @param {Rect} rect rect
     * @returns {void}
     */ CartesianAxisLayoutPanel.prototype.createZoomingLabel = function(chart, labelElement, axis, index, rect) {
        var parentNode = this.findParentNode(chart.element.id, labelElement, index);
        labelElement.setAttribute("opacity", "0.3");
        var zoomElement = chart.renderer.createGroup({
            id: chart.element.id + "AxisLabels_Zoom" + index
        });
        zoomElement = (0, $11815a21a80ae2b7$export$2050bc1784e25c08)(chart, axis, zoomElement, index, axis.orientation === "Vertical", rect);
        parentNode.replaceChild(labelElement, document.getElementById(labelElement.id));
        if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "AxisLabels_Zoom" + index)) parentNode.replaceChild(zoomElement, document.getElementById(zoomElement.id));
        else parentNode.appendChild(zoomElement);
    };
    return CartesianAxisLayoutPanel;
}();





/**
 * The `ChartData` class is used to retrieve data on mouse move events in a chart.
 *
 * @private
 */ var $05077795990f958e$export$c23acf85d5f173c3 = /** @class */ function() {
    /**
     * Constructor for the data.
     *
     * @private
     */ function ChartData(chart) {
        /** @private */ this.currentPoints = [];
        /** @private */ this.previousPoints = [];
        this.insideRegion = false;
        this.commonXvalues = [];
        this.chart = chart;
        this.lierIndex = 0;
    }
    /**
     * Method to get the Data.
     *
     * @private
     */ ChartData.prototype.getData = function() {
        var chart = this.chart;
        var point = null;
        var series = null;
        var width;
        var height;
        var mouseX;
        var mouseY;
        for(var len = chart.visibleSeries.length, i = len - 1; i >= 0; i--){
            series = chart.visibleSeries[i];
            width = series.type === "Scatter" || series.drawType === "Scatter" || series.marker.visible ? (series.marker.height + 5) / 2 : 0;
            height = series.type === "Scatter" || series.drawType === "Scatter" || series.marker.visible ? (series.marker.width + 5) / 2 : 0;
            mouseX = chart.mouseX;
            mouseY = chart.mouseY;
            if (series.dragSettings.enable && series.isRectSeries) {
                if (!(series.type === "Bar" && chart.isTransposed) && (chart.isTransposed || series.type === "Bar")) {
                    var markerWidth = series.marker.width / 2;
                    mouseX = series.yAxis.isAxisInverse ? mouseX + markerWidth : mouseX - markerWidth;
                } else {
                    var markerHeight = series.marker.height / 2;
                    mouseY = series.yAxis.isAxisInverse ? mouseY - markerHeight : mouseY + markerHeight;
                }
            }
            if (series.visible && (0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(mouseX, mouseY, series.clipRect, width, height)) point = this.getRectPoint(series, series.clipRect, mouseX, mouseY);
            if (point) return new (0, $11815a21a80ae2b7$export$8b02a874d977053f)(point, series);
        }
        return new (0, $11815a21a80ae2b7$export$8b02a874d977053f)(point, series);
    };
    ChartData.prototype.isSelected = function(chart) {
        return (chart.selectionMode.indexOf("Drag") > -1 || chart.selectionMode.indexOf("Lasso") > -1) && chart.selectionModule && chart.selectionModule.rectPoints !== null;
    };
    ChartData.prototype.getRectPoint = function(series, rect, x, y) {
        var chart = this.chart;
        var fromCenterX;
        var fromCenterY;
        var clickAngle;
        var arcAngle = 0;
        var startAngle;
        var endAngle;
        var distanceFromCenter;
        if (chart.isScrolling) return null;
        for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var point = _a[_i];
            if (!point.regionData) {
                if (!point.regions || !point.regions.length) continue;
            }
            if (point.regionData && this.chart.chartAreaType === "PolarRadar" && series.drawType.indexOf("Column") > -1) {
                fromCenterX = x - (series.clipRect.width / 2 + series.clipRect.x);
                fromCenterY = y - (series.clipRect.height / 2 + series.clipRect.y);
                arcAngle = 2 * Math.PI * (point.regionData.currentXPosition < 0 ? 1 + point.regionData.currentXPosition : point.regionData.currentXPosition);
                clickAngle = (Math.atan2(fromCenterY, fromCenterX) + 0.5 * Math.PI - arcAngle) % (2 * Math.PI);
                clickAngle = clickAngle < 0 ? 2 * Math.PI + clickAngle : clickAngle;
                clickAngle = clickAngle + 2 * Math.PI * series.chart.primaryXAxis.startAngle;
                startAngle = point.regionData.startAngle;
                startAngle -= arcAngle;
                startAngle = startAngle < 0 ? 2 * Math.PI + startAngle : startAngle;
                endAngle = point.regionData.endAngle;
                endAngle -= arcAngle;
                endAngle = endAngle < 0 ? 2 * Math.PI + endAngle : endAngle;
                distanceFromCenter = Math.sqrt(Math.pow(Math.abs(fromCenterX), 2) + Math.pow(Math.abs(fromCenterY), 2));
                if (clickAngle >= startAngle && clickAngle <= endAngle && (distanceFromCenter >= point.regionData.innerRadius && distanceFromCenter <= point.regionData.radius || distanceFromCenter <= point.regionData.innerRadius && distanceFromCenter >= point.regionData.radius) && distanceFromCenter <= series.chart.radius) return point;
            }
            if (series.dragSettings.enable && series.isRectSeries || series.isRectSeries && series.marker.visible && this.chart.chartAreaType !== "PolarRadar") {
                if (this.isPointInThresholdRegion(x, y, point, rect, series)) {
                    this.insideRegion = true;
                    return point;
                }
            }
            if (!this.insideRegion && this.checkRegionContainsPoint(point.regions, rect, x, y)) return point;
            else if (this.insideRegion && this.checkRegionContainsPoint(point.regions, rect, x, y)) return point;
        }
        return null;
    };
    /**
     * Checks if the given point is contained within any of the regions defined by the array of rectangles.
     *
     * @param {Rect[]} regionRect - The array of rectangles defining the regions.
     * @param {Rect} rect - The rectangle to check against the regions.
     * @param {number} x - The x-coordinate of the point.
     * @param {number} y - The y-coordinate of the point.
     * @returns {boolean} - True if the point is contained within any of the regions, otherwise false.
     */ ChartData.prototype.checkRegionContainsPoint = function(regionRect, rect, x, y) {
        var _this = this;
        return regionRect.some(function(region, index) {
            _this.lierIndex = index;
            return (0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(x, y, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)((_this.chart.chartAreaType === "Cartesian" ? rect.x : 0) + region.x, (_this.chart.chartAreaType === "Cartesian" ? rect.y : 0) + region.y, region.width, region.height));
        });
    };
    /**
     * Checks if the given point is within the threshold region of a data point.
     *
     * @param {number} x - The x-coordinate of the point to check.
     * @param {number} y - The y-coordinate of the point to check.
     * @param {Points} point - The data point.
     * @param {Rect} rect - The rectangle representing the threshold region.
     * @param {Series} series - The series to which the data point belongs.
     * @returns {boolean} - True if the point is within the threshold region, otherwise false.
     */ ChartData.prototype.isPointInThresholdRegion = function(x, y, point, rect, series) {
        var _this = this;
        var isBar = series.type === "Bar";
        var isInversed = series.yAxis.isAxisInverse;
        var isTransposed = series.chart.isTransposed;
        var heightValue = 10;
        var yValue = 0;
        var xValue = 0;
        var width;
        var height = width = 2 * heightValue;
        if (isInversed && isTransposed) {
            if (isBar) {
                yValue = point.regions[0].height - heightValue;
                width = point.regions[0].width;
            } else {
                xValue = -heightValue;
                height = point.regions[0].height;
            }
        } else if (isInversed || point.yValue < 0) {
            if (isBar) {
                xValue = -heightValue;
                height = point.regions[0].height;
            } else {
                yValue = point.regions[0].height - heightValue;
                width = point.regions[0].width;
            }
        } else if (isTransposed) {
            if (isBar) {
                yValue = -heightValue;
                width = point.regions[0].width;
            } else {
                xValue = point.regions[0].width - heightValue;
                height = point.regions[0].height;
            }
        } else if (isBar) {
            xValue = point.regions[0].width - heightValue;
            height = point.regions[0].height;
        } else {
            yValue = -heightValue;
            width = point.regions[0].width;
        }
        return point.regions.some(function(region) {
            return (0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(x, y, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)((_this.chart.chartAreaType === "Cartesian" ? rect.x : 0) + region.x + xValue, (_this.chart.chartAreaType === "Cartesian" ? rect.y : 0) + region.y + yValue, width, height));
        });
    };
    /**
     * Gets the index of the closest data point to the given value in the series.
     *
     * @param {Series} series - The series.
     * @param {number} value - The value to which the closest data point is sought.
     * @param {number[]} [xvalues] - The x-values of the data points.
     * @returns {number} - The index of the closest data point.
     * @private
     */ ChartData.prototype.getClosest = function(series, value, xvalues) {
        var closest;
        var data;
        var xData = xvalues ? xvalues : series.xData;
        var xLength = xData.length;
        var leftSideNearest = 0.5;
        var rightSideNearest = 0.5;
        if (series.xAxis.valueType === "DateTime" && series.points.length === 1) {
            leftSideNearest = series.xAxis.visibleRange.min;
            rightSideNearest = series.xAxis.visibleRange.max;
            for(var index = 0; index < series.chart.visibleSeries.length; index++){
                var visibleSeries = series.chart.visibleSeries[index];
                if (visibleSeries.xMin >= leftSideNearest && visibleSeries.xMin < series.xMin) leftSideNearest = visibleSeries.xMin + 0.1;
                if (visibleSeries.xMax <= rightSideNearest && visibleSeries.xMax > series.xMax) rightSideNearest = visibleSeries.xMax - 0.1;
                if (visibleSeries.visible && visibleSeries.points.length > 1) {
                    if (visibleSeries.xMax >= leftSideNearest && visibleSeries.xMax < series.xMin) leftSideNearest = visibleSeries.xMax + 0.1;
                    if (visibleSeries.xMin <= rightSideNearest && visibleSeries.xMin > series.xMax) rightSideNearest = visibleSeries.xMin - 0.1;
                }
            }
            if (leftSideNearest !== series.xAxis.visibleRange.min) leftSideNearest = Math.abs(series.xMin - leftSideNearest) / 2;
            if (rightSideNearest !== series.xAxis.visibleRange.max) rightSideNearest = Math.abs(series.xMax - rightSideNearest) / 2;
        }
        if (value >= series.xMin - leftSideNearest && value <= series.xMax + rightSideNearest) for(var i = 0; i < xLength; i++){
            data = xData[i];
            if (closest == null || Math.abs(data - value) < Math.abs(closest - value)) closest = data;
        }
        var isDataExist = series.xData.indexOf(closest) !== -1;
        if (isDataExist) return closest;
        else return null;
    };
    ChartData.prototype.binarySearch = function(target, list) {
        var first = 0;
        var last = list.length;
        var position = -1;
        var found = false;
        var middle;
        while(found === false && first <= last){
            middle = Math.floor((first + last) / 2);
            if (list[middle].xValue === target) {
                found = true;
                position = middle;
            } else if (list[middle].xValue > target) last = middle - 1;
            else first = middle + 1;
        }
        return position !== -1 ? list[position] : null;
    };
    ChartData.prototype.getClosestX = function(chart, series, xvalues) {
        var value;
        var rect = series.clipRect;
        if (chart.mouseX <= rect.x + rect.width && chart.mouseX >= rect.x) {
            if (!chart.requireInvertedAxis) value = (0, $11815a21a80ae2b7$export$4e11abe7cdeb4cc9)(chart.mouseX - rect.x, rect.width, series.xAxis);
            else value = (0, $11815a21a80ae2b7$export$bb7437ba7758bec8)(chart.mouseY - rect.y, rect.height, series.xAxis);
        }
        var closest = this.getClosest(series, value, xvalues);
        var point = (closest || closest === 0) && series.points.length > 0 ? this.binarySearch(closest, (0, $11815a21a80ae2b7$export$97db5808d8f88186)(series.points, [
            "xValue"
        ])) : null;
        if (point && point.visible) {
            if (!(this.chart.chartAreaType === "Cartesian" && (series.category === "Indicator" && series.name === "Histogram" || point.symbolLocations && point.symbolLocations.length > 0 && point.symbolLocations[0].x >= 0 && point.symbolLocations[0].x <= rect.width))) return null;
            return new (0, $11815a21a80ae2b7$export$8b02a874d977053f)(point, series);
        }
        return null;
    };
    /**
     * Merges the x-values of the data points from multiple series into a single array.
     *
     * @param {Series[]} visibleSeries - The array of visible series.
     * @returns {number[]} - The merged array of x-values.
     * @private
     */ ChartData.prototype.mergeXvalues = function(visibleSeries) {
        if (visibleSeries.length && (!this.commonXvalues.length || this.commonXvalues.length !== visibleSeries[0].xData.length)) {
            this.commonXvalues = visibleSeries[0].xData;
            for(var index = 1; index < visibleSeries.length; index++)this.commonXvalues = this.getDistinctValues(this.commonXvalues, visibleSeries[index].xData);
        }
        return this.commonXvalues;
    };
    ChartData.prototype.commonXValue = function(visibleSeries) {
        var commonXValues = [];
        for(var j = 0; j < visibleSeries.length; j++)for(var i = 0; visibleSeries[j].points && i < visibleSeries[j].points.length; i++){
            var point = visibleSeries[j].points[i];
            if (point && (point.index === 0 || point.index === visibleSeries[j].points.length - 1 || point.symbolLocations && point.symbolLocations.length > 0)) commonXValues.push(point.xValue);
        }
        return commonXValues;
    };
    ChartData.prototype.getDistinctValues = function(first, second) {
        if (first === void 0) first = [];
        if (second === void 0) second = [];
        var intial = {};
        var result = [];
        var index;
        for(index = 0; index < first.length; index++){
            var temp = first[index];
            if (!intial[temp]) {
                intial[temp] = true;
                result.push(temp);
            }
        }
        for(index = 0; index < second.length; index++){
            var temp = second[index];
            if (!intial[temp]) {
                intial[temp] = true;
                result.push(temp);
            }
        }
        return result;
    };
    return ChartData;
}();


parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $3EnZW = parcelRequire("3EnZW");





var $54f817a374cfcee1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $54f817a374cfcee1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * This class provides options to customize the appearance and behavior of data labels within a series.
 */ var $54f817a374cfcee1$export$1af07f45ec1d8404 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(DataLabelSettings, _super);
    function DataLabelSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DataLabelSettings.prototype, "visible", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DataLabelSettings.prototype, "showZero", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DataLabelSettings.prototype, "name", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("transparent")
    ], DataLabelSettings.prototype, "fill", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DataLabelSettings.prototype, "format", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], DataLabelSettings.prototype, "opacity", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], DataLabelSettings.prototype, "angle", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DataLabelSettings.prototype, "enableRotation", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], DataLabelSettings.prototype, "position", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], DataLabelSettings.prototype, "rx", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], DataLabelSettings.prototype, "ry", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], DataLabelSettings.prototype, "alignment", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            width: null,
            color: null
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], DataLabelSettings.prototype, "border", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
        }, (0, $2ae44f835da15a47$export$e717bcf55e1dfb40))
    ], DataLabelSettings.prototype, "margin", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            size: null,
            color: null,
            fontStyle: null,
            fontWeight: null,
            fontFamily: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], DataLabelSettings.prototype, "font", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], DataLabelSettings.prototype, "template", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Hide")
    ], DataLabelSettings.prototype, "labelIntersectAction", void 0);
    return DataLabelSettings;
}((0, $3fcxu.ChildProperty));
/**
 * This class is used to define the appearance and behavior of the series markers.
 */ var $54f817a374cfcee1$export$71b5a5b5100933c5 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(MarkerSettings, _super);
    function MarkerSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MarkerSettings.prototype, "visible", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MarkerSettings.prototype, "shape", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], MarkerSettings.prototype, "imageUrl", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], MarkerSettings.prototype, "height", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MarkerSettings.prototype, "isFilled", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(5)
    ], MarkerSettings.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            width: 2,
            color: null
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], MarkerSettings.prototype, "border", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            x: 0,
            y: 0
        }, (0, $2ae44f835da15a47$export$8caee09accd95d7f))
    ], MarkerSettings.prototype, "offset", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MarkerSettings.prototype, "fill", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MarkerSettings.prototype, "allowHighlight", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], MarkerSettings.prototype, "opacity", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({}, $54f817a374cfcee1$export$1af07f45ec1d8404)
    ], MarkerSettings.prototype, "dataLabel", void 0);
    return MarkerSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The `ParetoOptions` class provides a set of properties for configuring the Pareto series.
 */ var $54f817a374cfcee1$export$ef8be8fbb2880234 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(ParetoOptions, _super);
    function ParetoOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ParetoOptions.prototype, "fill", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ParetoOptions.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("0")
    ], ParetoOptions.prototype, "dashArray", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, $54f817a374cfcee1$export$71b5a5b5100933c5)
    ], ParetoOptions.prototype, "marker", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ParetoOptions.prototype, "showAxis", void 0);
    return ParetoOptions;
}((0, $3fcxu.ChildProperty));
/**
 * The model that represents how the points in a series are configured and displayed.
 *
 * @public
 */ var $54f817a374cfcee1$export$1c787534cb11aa3e = /** @class */ function() {
    function Points() {
        /** Specifies the locations of symbols associated with the point. */ this.symbolLocations = null;
        /** Specifies the regions associated with the point. */ this.regions = null;
        /** Specifies the percentage value of the point. */ this.percentage = null;
        /** Specifies the region data of the point. */ this.regionData = null;
        /** Indicates whether the point is selected. */ this.isSelect = false;
        /** Specifies the marker settings for the point. */ this.marker = {
            visible: false
        };
        /**
         * Indicates whether the point is within the specified range.
         *
         * @private
         */ this.isPointInRange = true;
        /** Specifies the vertical error value for the point. */ this.verticalError = null;
        /** Specifies the vertical negative error value for the point. */ this.verticalNegativeError = null;
        /** Specifies the horizontal error value for the point. */ this.horizontalError = null;
        /** Specifies the horizontal negative error value for the point. */ this.horizontalNegativeError = null;
        /** Specifies the vertical positive error value for the point. */ this.verticalPositiveError = null;
        /** Specifies the horizontal positive error value for the point. */ this.horizontalPositiveError = null;
    }
    return Points;
}();
/**
 * Configures the behavior and appearance of trendlines in a chart series.
 * Trendlines indicate trends and the rate of price changes over a period.
 */ var $54f817a374cfcee1$export$197a570748ce7b7e = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(Trendline, _super);
    function Trendline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @private */ _this.clipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0);
        return _this;
    }
    /**
     * Sets the data source for the specified series in the provided chart.
     *
     * @private
     * @param {Series} series - The series for which the data source is set.
     * @param {Chart} chart - The chart in which the data source is set.
     * @returns {void}
     */ Trendline.prototype.setDataSource = function(series, chart) {
        if (series) this.points = series.points;
        chart.trendLineModule.initDataSource(this);
        chart.visibleSeriesCount++;
    };
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Trendline.prototype, "name", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Trendline.prototype, "dashArray", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Trendline.prototype, "visible", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Linear")
    ], Trendline.prototype, "type", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(2)
    ], Trendline.prototype, "period", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(2)
    ], Trendline.prototype, "polynomialOrder", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Trendline.prototype, "backwardForecast", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Trendline.prototype, "forwardForecast", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$c35d437ae5945fcd))
    ], Trendline.prototype, "animation", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({}, $54f817a374cfcee1$export$71b5a5b5100933c5)
    ], Trendline.prototype, "marker", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Trendline.prototype, "enableTooltip", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Trendline.prototype, "intercept", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Trendline.prototype, "fill", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Trendline.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("SeriesType")
    ], Trendline.prototype, "legendShape", void 0);
    return Trendline;
}((0, $3fcxu.ChildProperty));
/**
 * The `ErrorBarCapSettings` class provides options to customize the appearance and behavior of error bars in a series.
 */ var $54f817a374cfcee1$export$eeb7a23c2fde2274 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(ErrorBarCapSettings, _super);
    function ErrorBarCapSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarCapSettings.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], ErrorBarCapSettings.prototype, "length", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ErrorBarCapSettings.prototype, "color", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarCapSettings.prototype, "opacity", void 0);
    return ErrorBarCapSettings;
}((0, $3fcxu.ChildProperty));
var $54f817a374cfcee1$export$ada58b95d4636649 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(ChartSegment, _super);
    function ChartSegment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartSegment.prototype, "value", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ChartSegment.prototype, "color", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("0")
    ], ChartSegment.prototype, "dashArray", void 0);
    return ChartSegment;
}((0, $3fcxu.ChildProperty));
/**
 * The `ErrorBarSettings` class provides options to customize the appearance and behavior of error bars in a series.
 *
 * @public
 */ var $54f817a374cfcee1$export$3e6744115f9f5631 = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(ErrorBarSettings, _super);
    function ErrorBarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ErrorBarSettings.prototype, "visible", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Fixed")
    ], ErrorBarSettings.prototype, "type", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], ErrorBarSettings.prototype, "direction", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Vertical")
    ], ErrorBarSettings.prototype, "mode", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ErrorBarSettings.prototype, "color", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarSettings.prototype, "verticalError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarSettings.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarSettings.prototype, "horizontalError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], ErrorBarSettings.prototype, "verticalPositiveError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], ErrorBarSettings.prototype, "verticalNegativeError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarSettings.prototype, "horizontalPositiveError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], ErrorBarSettings.prototype, "horizontalNegativeError", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, $54f817a374cfcee1$export$eeb7a23c2fde2274)
    ], ErrorBarSettings.prototype, "errorBarCap", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ErrorBarSettings.prototype, "errorBarColorMapping", void 0);
    return ErrorBarSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Defines the common behavior for series and technical indicators.
 */ var $54f817a374cfcee1$export$44db626655395dec = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(SeriesBase, _super);
    function SeriesBase() {
        /**
         * The data source field that contains the x value.
         * It is applicable to both series and technical indicators.
         *
         * @default ''
         */ var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rangeColorPoints = [];
        _this.isAdvancedColor = undefined;
        /** @private */ _this.currentViewData = [];
        /** @private */ _this.clipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0);
        /** @private */ _this.seriesType = "XY";
        _this.isRectTypeSeries = false;
        _this.removedPointIndex = null;
        /** @private */ _this.isLegendClicked = false;
        return _this;
    }
    /**
     * Process data for the series.
     *
     * @hidden
     * @returns {void}
     */ SeriesBase.prototype.processJsonData = function() {
        var i = 0;
        var point = new $54f817a374cfcee1$export$1c787534cb11aa3e();
        var xName = this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && this.type === "Histogram" ? "x" : this.xName;
        var textMappingName = this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && this.marker.dataLabel.name ? this.marker.dataLabel.name : "";
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) {
            if (this.type === "Waterfall" || this.type === "Histogram") this.currentViewData = this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type) + "SeriesModule"].processInternalData((0, $3EnZW.extend)([], this.currentViewData, null, true), this);
            if (this.category === "Pareto") {
                this.currentViewData = (0, $3EnZW.extend)([], this.currentViewData, null, true);
                if (this.type === "Line") this.currentViewData = this.chart.paretoSeriesModule.performCumulativeCalculation(this.currentViewData, this);
            }
            this.isRectTypeSeries = this.type.indexOf("Column") > -1 || this.type.indexOf("Bar") > -1 || this.type.indexOf("Histogram") > -1;
        }
        var len = (this.currentViewData || []).length;
        this.points = [];
        this.xMin = Infinity;
        this.xMax = -Infinity;
        this.yMin = Infinity;
        this.yMax = -Infinity;
        this.sizeMax = -Infinity;
        this.getSeriesType();
        if (this.xAxis.valueType === "Category") while(i < len){
            this.pushCategoryPoint(point, i, textMappingName, xName);
            i++;
        }
        else if (this.xAxis.valueType.indexOf("DateTime") > -1) {
            var option = {
                skeleton: "full",
                type: "dateTime"
            };
            var dateParser = this.chart.intl.getDateParser(option);
            var dateFormatter = this.chart.intl.getDateFormat(option);
            while(i < len){
                this.pushDateTimePoint(point, i, textMappingName, xName, dateParser, dateFormatter);
                i++;
            }
        } else while(i < len){
            this.pushDoublePoint(point, i, textMappingName, xName);
            i++;
        }
        this.updateSplineValue();
    };
    /**
     * Pushes a category point to the data collection.
     *
     * @param {Points} point -The point to be pushed.
     * @param {number} index -The index of the point.
     * @param {string} textMappingName -The name of the text mapping.
     * @param {string} xName -The name of the x-coordinate.
     * @returns {void}
     * @private
     */ SeriesBase.prototype.pushCategoryPoint = function(point, index, textMappingName, xName) {
        point = this.dataPoint(index, textMappingName, xName);
        this.pushCategoryData(point, index, point.x);
        this.pushData(point, index);
        this.setEmptyPoint(point, index);
        this.rangeColorsInterior(point);
    };
    /**
     * Pushes a double point to the data collection.
     *
     * @param {Points} point -The point to be pushed.
     * @param {number} index -The index of the point.
     * @param {string} textMappingName -The name of the text mapping.
     * @param {string} xName -The name of the x-coordinate.
     * @returns {void}
     * @private
     */ SeriesBase.prototype.pushDoublePoint = function(point, index, textMappingName, xName) {
        point = this.dataPoint(index, textMappingName, xName);
        point.xValue = point.x;
        this.pushData(point, index);
        this.setEmptyPoint(point, index);
    };
    /**
     * Pushes a DateTime point to the data collection.
     *
     * @param {Points} point -The point to be pushed.
     * @param {number} index -The index of the point.
     * @param {string} textMappingName -The name of the text mapping.
     * @param {string} xName -The name of the x-coordinate.
     * @param {Function} dateParser -The date parser function.
     * @param {Function} dateFormatter -The date formatter function.
     * @returns {void}
     * @private
     */ SeriesBase.prototype.pushDateTimePoint = function(point, index, textMappingName, xName, dateParser, dateFormatter) {
        point = this.dataPoint(index, textMappingName, xName);
        if (!(0, $3EnZW.isNullOrUndefined)(point.x) && point.x !== "") {
            point.x = new Date((0, $fc77c1cdc02c8be7$export$de67910a89dbf741).parse.parseJson({
                val: point.x
            }).val);
            if (this.xAxis.valueType === "DateTime") point.xValue = Date.parse(point.x.toString());
            else if (this.chart.isBlazor) this.pushCategoryData(point, index, Date.parse(point.x.toString()).toString());
            else this.pushCategoryData(point, index, Date.parse(dateParser(dateFormatter(point.x))).toString());
            this.pushData(point, index);
            this.setEmptyPoint(point, index);
        } else point.visible = false;
    };
    SeriesBase.prototype.updateSplineValue = function() {
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && !(this.chart.stockChart && this.xAxis.valueType === "DateTimeCategory")) {
            if (this.type.indexOf("Spline") > -1 || this.drawType.indexOf("Spline") > -1 && this.chart.chartAreaType === "PolarRadar") {
                var isArea = this.type.indexOf("Area") > -1 || this.drawType.indexOf("Area") > -1;
                var isRange = this.type.indexOf("Range") > -1;
                this.chart["spline" + (isArea ? isRange ? "RangeArea" : "Area" : "") + "SeriesModule"].findSplinePoint(this);
            } else if (this.type.indexOf("Histogram") > -1 && (this.xAxis.maximum || this.xAxis.minimum)) this.chart["histogramSeriesModule"].calculateBinValues(this);
            if (this.type.indexOf("Histogram") > -1 && this.points.length === 1) {
                this.xMin = this.xMin - this.histogramValues.binWidth;
                this.xMax = this.xMax + this.histogramValues.binWidth;
            }
        }
    };
    SeriesBase.prototype.rangeColorsInterior = function(point) {
        if (this.chart.rangeColorSettings && this.chart.rangeColorSettings.length > 0 && this.chart.visibleSeries.length === 1 && (this.chart.series[0].type === "Column" || this.chart.series[0].type === "Bar" || this.chart.series[0].type === "Scatter" || this.chart.series[0].type === "Bubble")) {
            if (!this.rangeColorPoints[point.interior]) this.rangeColorPoints[point.interior] = [];
            else if (this.rangeColorPoints[point.interior] !== undefined) this.rangeColorPoints[point.interior].push(point);
        }
    };
    /**
     * Sets the empty point values.
     *
     * @param {Points} point - The point to be set.
     * @param {number} i - The index of the point.
     * @private
     * @returns {void}
     */ SeriesBase.prototype.pushData = function(point, i) {
        point.index = i;
        point.yValue = point.y;
        point.series = this;
        // To find the min, max for the axis range.
        this.xMin = Math.min(this.xMin, point.xValue);
        this.xMax = Math.max(this.xMax, point.xValue);
        this.xData.push(point.xValue);
    };
    /**
     * Retrieves the data point at the specified index with the given text mapping name and x-name.
     *
     * @param {number} i - The index of the data point to retrieve.
     * @param {string} textMappingName - The name used to map text data.
     * @param {string} xName - The name used for the x-axis.
     * @returns {Points} - The data point at the specified index.
     * @private
     */ SeriesBase.prototype.dataPoint = function(i, textMappingName, xName) {
        this.points[i] = new $54f817a374cfcee1$export$1c787534cb11aa3e();
        var point = this.points[i];
        var currentViewData = this.currentViewData[i];
        var getObjectValueByMappingString = this.enableComplexProperty ? (0, $3EnZW.getValue) : this.getObjectValue;
        point.x = getObjectValueByMappingString(xName, currentViewData);
        point.high = getObjectValueByMappingString(this.high, currentViewData);
        point.low = getObjectValueByMappingString(this.low, currentViewData);
        point.open = getObjectValueByMappingString(this.open, currentViewData);
        point.close = getObjectValueByMappingString(this.close, currentViewData);
        point.volume = getObjectValueByMappingString(this.volume, currentViewData);
        point.interior = getObjectValueByMappingString(this.pointColorMapping, currentViewData);
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) {
            if (this.errorBar.visible) {
                point.errorBarColor = getObjectValueByMappingString(this.errorBar.errorBarColorMapping, currentViewData);
                point.verticalError = typeof this.errorBar.verticalError == "string" ? getObjectValueByMappingString(this.errorBar.verticalError, currentViewData) : this.errorBar.verticalError;
                point.horizontalError = typeof this.errorBar.horizontalError == "string" ? getObjectValueByMappingString(this.errorBar.horizontalError, currentViewData) : this.errorBar.horizontalError;
                point.verticalNegativeError = typeof this.errorBar.verticalNegativeError == "string" ? getObjectValueByMappingString(this.errorBar.verticalNegativeError, currentViewData) : this.errorBar.verticalNegativeError;
                point.verticalPositiveError = typeof this.errorBar.verticalPositiveError == "string" ? getObjectValueByMappingString(this.errorBar.verticalPositiveError, currentViewData) : this.errorBar.verticalPositiveError;
                point.horizontalNegativeError = typeof this.errorBar.horizontalNegativeError == "string" ? getObjectValueByMappingString(this.errorBar.horizontalNegativeError, currentViewData) : this.errorBar.horizontalNegativeError;
                point.horizontalPositiveError = typeof this.errorBar.horizontalPositiveError == "string" ? getObjectValueByMappingString(this.errorBar.horizontalPositiveError, currentViewData) : this.errorBar.horizontalPositiveError;
            }
            point.y = getObjectValueByMappingString(this.yName, currentViewData);
            point.size = getObjectValueByMappingString(this.size, currentViewData);
            point.text = getObjectValueByMappingString(textMappingName, currentViewData);
            point.tooltip = getObjectValueByMappingString(this.tooltipMappingName, currentViewData);
            if (this.isAdvancedColorSupported()) {
                this.rangeColorName = this.colorName.length > 0 ? this.colorName : this.yName;
                point.colorValue = getObjectValueByMappingString(this.rangeColorName, currentViewData);
                point.interior = this.getPointFillColor(point.interior, point.colorValue);
            }
        }
        return point;
    };
    SeriesBase.prototype.isAdvancedColorSupported = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.isAdvancedColor)) {
            if (this.chart.rangeColorSettings && this.chart.rangeColorSettings.length > 0 && (this.chart.series[0].type === "Column" || this.chart.series[0].type === "Bar" || this.chart.series[0].type === "Scatter" || this.chart.series[0].type === "Bubble")) this.isAdvancedColor = true;
            else this.isAdvancedColor = false;
        }
        return this.isAdvancedColor;
    };
    SeriesBase.prototype.getPointFillColor = function(pointFill, value) {
        var color = pointFill;
        if (value && this.chart.rangeColorSettings && this.chart.rangeColorSettings.length > 0) for(var _i = 0, _a = this.chart.rangeColorSettings; _i < _a.length; _i++){
            var rangeMap = _a[_i];
            if (value >= rangeMap.start && value <= rangeMap.end) {
                if (rangeMap.colors.length > 1) color = (0, $11815a21a80ae2b7$export$f663f23222699c31)(rangeMap, value);
                else color = rangeMap.colors[0];
            }
        }
        return color;
    };
    /**
     * Pushes a category point to the data collection.
     *
     * @param {string} mappingName - The name of the mapping.
     * @param {Object} data - The data to be pushed.
     * @returns {Object} - The data point at the specified index.
     * @private
     */ SeriesBase.prototype.getObjectValue = function(mappingName, data) {
        return data[mappingName];
    };
    /**
     * Sets the specified data point as an empty point at the given index.
     *
     * @private
     * @param {Points} point - The data point to set as empty.
     * @param {number} i - The index of the data point.
     * @returns {void}
     */ SeriesBase.prototype.setEmptyPoint = function(point, i) {
        if (!this.findVisibility(point)) {
            point.visible = true;
            return null;
        }
        point.isEmpty = true;
        var mode = this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && point.isPointInRange ? this.emptyPointSettings.mode : "Drop";
        switch(mode){
            case "Zero":
                point.visible = true;
                if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && this.seriesType.indexOf("HighLow") > -1) {
                    point.high = point.low = 0;
                    if (this.seriesType.indexOf("HighLowOpenClose") > -1) point.open = point.close = 0;
                } else point.y = point.yValue = this.yData[i] = 0;
                break;
            case "Average":
                if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) {
                    if (this.seriesType.indexOf("HighLow") > -1) {
                        point.high = (0, $3EnZW.isNullOrUndefined)(point.high) || isNaN(+point.high) ? this.getAverage(this.high, i) : point.high;
                        point.low = (0, $3EnZW.isNullOrUndefined)(point.low) || isNaN(+point.low) ? this.getAverage(this.low, i) : point.low;
                        if (this.seriesType.indexOf("HighLowOpenClose") > -1) {
                            point.open = (0, $3EnZW.isNullOrUndefined)(point.open) || isNaN(+point.open) ? this.getAverage(this.open, i) : point.open;
                            point.close = (0, $3EnZW.isNullOrUndefined)(point.close) || isNaN(+point.close) ? this.getAverage(this.close, i) : point.close;
                        }
                    } else point.y = point.yValue = this.yData[i] = this.getAverage(this.yName, i);
                }
                point.visible = true;
                break;
            case "Drop":
            case "Gap":
                this.yData[i] = null;
                point.visible = false;
                break;
        }
    };
    SeriesBase.prototype.findVisibility = function(point) {
        var type = this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf ? this.seriesType : "HighLowOpenClose";
        var yValues;
        var yAxisMin = this.yAxis.minimum;
        var yAxisMax = this.yAxis.maximum;
        switch(type){
            case "XY":
                if (this.chart.chartAreaType === "PolarRadar" && (!(0, $3EnZW.isNullOrUndefined)(yAxisMin) && point.yValue < yAxisMin || !(0, $3EnZW.isNullOrUndefined)(yAxisMax) && point.yValue > yAxisMax)) {
                    point.isPointInRange = false;
                    return true;
                }
                this.setXYMinMax(point.yValue);
                this.yData.push(point.yValue);
                if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && this.type === "Bubble") this.sizeMax = Math.max(this.sizeMax, (0, $3EnZW.isNullOrUndefined)(point.size) || isNaN(+point.size) ? this.sizeMax : point.size);
                return (0, $3EnZW.isNullOrUndefined)(point.x) || (0, $3EnZW.isNullOrUndefined)(point.y) || isNaN(+point.y);
            case "HighLow":
                this.setHiloMinMax(point.high, point.low);
                return (0, $3EnZW.isNullOrUndefined)(point.x) || (0, $3EnZW.isNullOrUndefined)(point.low) || isNaN(+point.low) || (0, $3EnZW.isNullOrUndefined)(point.high) || isNaN(+point.high);
            case "HighLowOpenClose":
                this.setHiloMinMax(point.high, point.low);
                return (0, $3EnZW.isNullOrUndefined)(point.x) || (0, $3EnZW.isNullOrUndefined)(point.low) || isNaN(+point.low) || (0, $3EnZW.isNullOrUndefined)(point.open) || isNaN(+point.open) || (0, $3EnZW.isNullOrUndefined)(point.close) || isNaN(+point.close) || (0, $3EnZW.isNullOrUndefined)(point.high) || isNaN(+point.high);
            case "BoxPlot":
                yValues = (point.y || [
                    null
                ]).filter(function(value) {
                    return !(0, $3EnZW.isNullOrUndefined)(value) && !isNaN(value);
                }).sort(function(a, b) {
                    return a - b;
                });
                point.y = yValues;
                this.yMin = Math.min(this.yMin, Math.min.apply(Math, yValues));
                this.yMax = Math.max(this.yMax, Math.max.apply(Math, yValues));
                return !yValues.length;
        }
    };
    /**
     * To get Y min max for the provided point seriesType XY.
     *
     * @param {number} yValue - The y value used to determine the minimum and maximum values for the x and y coordinates.
     * @returns {void}
     */ SeriesBase.prototype.setXYMinMax = function(yValue) {
        var isLogAxis = this.yAxis.valueType === "Logarithmic" || this.xAxis.valueType === "Logarithmic";
        var isNegativeValue = yValue < 0 || this.yAxis.rangePadding === "None";
        var seriesMinY;
        if (this.isRectTypeSeries && !(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.yAxis)) seriesMinY = isLogAxis ? yValue : isNegativeValue ? yValue : 0;
        else seriesMinY = yValue;
        this.yMin = isLogAxis ? Math.min(this.yMin, (0, $3EnZW.isNullOrUndefined)(seriesMinY) || isNaN(seriesMinY) || seriesMinY === 0 || seriesMinY.toString() === "0" || seriesMinY.toString() === "" ? this.yMin : seriesMinY) : Math.min(this.yMin, (0, $3EnZW.isNullOrUndefined)(seriesMinY) || isNaN(seriesMinY) ? this.yMin : seriesMinY);
        this.yMax = Math.max(this.yMax, (0, $3EnZW.isNullOrUndefined)(yValue) || isNaN(yValue) ? this.yMax : yValue);
    };
    /**
     * Sets the minimum and maximum values for the high and low values.
     *
     * @private
     * @param {number} high - The high value used to determine the maximum value.
     * @param {number} low - The low value used to determine the minimum value.
     * @returns {void}
     */ SeriesBase.prototype.setHiloMinMax = function(high, low) {
        this.yMin = Math.min(this.yMin, Math.min((0, $3EnZW.isNullOrUndefined)(low) || isNaN(low) ? this.yMin : low, (0, $3EnZW.isNullOrUndefined)(high) || isNaN(high) ? this.yMin : high));
        this.yMax = Math.max(this.yMax, Math.max((0, $3EnZW.isNullOrUndefined)(low) || isNaN(low) ? this.yMax : low, (0, $3EnZW.isNullOrUndefined)(high) || isNaN(high) ? this.yMax : high));
    };
    /**
     * Finds the type of the series.
     *
     * @private
     * @returns {void}
     */ SeriesBase.prototype.getSeriesType = function() {
        var type;
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) {
            var seriesType = this.chart.chartAreaType === "PolarRadar" ? this.drawType : this.type;
            if (seriesType) switch(seriesType){
                case "RangeColumn":
                case "RangeArea":
                case "RangeStepArea":
                case "SplineRangeArea":
                case "Hilo":
                    type = "HighLow";
                    break;
                case "HiloOpenClose":
                case "Candle":
                    type = "HighLowOpenClose";
                    break;
                case "BoxAndWhisker":
                    type = "BoxPlot";
                    break;
                default:
                    type = "XY";
            }
        }
        this.seriesType = type;
    };
    /**
     * Pushes category data into the series points.
     *
     * @param {Points} point - The point to which category data will be pushed.
     * @param {number} index - The index of the data point.
     * @param {string} pointX - The x-value of the point.
     * @returns {void}
     * @private
     */ SeriesBase.prototype.pushCategoryData = function(point, index, pointX) {
        if (!this.chart.tooltip.shared) {
            if (!this.visible) return null;
        }
        if (!this.xAxis.isIndexed) {
            if (this.xAxis.indexLabels[pointX] === undefined) {
                this.xAxis.indexLabels[pointX] = this.xAxis.labels.length;
                this.xAxis.labels.push(pointX);
            }
            point.xValue = this.xAxis.indexLabels[pointX];
        } else {
            if (this.xAxis.labels[index]) this.xAxis.labels[index] += ", " + pointX;
            else this.xAxis.labels.push(pointX);
            // this.xAxis.labels[index as number] ? this.xAxis.labels[index as number] += ', ' + pointX :
            //     this.xAxis.labels.push(pointX);
            point.xValue = index;
        }
    };
    /**
     * Gets the average value of a member in the specified data array or current view data.
     *
     * @param {string} member - The member whose average is to be calculated.
     * @param {number} i - The index of the data point.
     * @param {Object} data - The data array from which to calculate the average. Defaults to the current view data.
     * @returns {number} - The average value of the specified member.
     */ SeriesBase.prototype.getAverage = function(member, i, data) {
        if (data === void 0) data = this.currentViewData;
        var previous = data[i - 1] ? data[i - 1][member] || 0 : 0;
        var next = data[i + 1] ? data[i + 1][member] || 0 : 0;
        return (previous + next) / 2;
    };
    /**
     * Refreshes the data manager for the provided chart.
     *
     * @param {Chart} chart - The chart whose data manager is to be refreshed.
     * @returns {void}
     * @private
     */ SeriesBase.prototype.refreshDataManager = function(chart) {
        var _this = this;
        this.chart = chart;
        var dataSource;
        var isAngular = "isAngular";
        if (chart[isAngular]) dataSource = Object.keys(this.dataSource).length ? this.dataSource : chart.dataSource;
        else dataSource = this.dataSource || chart.dataSource;
        if (!(dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && (0, $3EnZW.isNullOrUndefined)(this.query)) {
            this.dataManagerSuccess({
                result: dataSource,
                count: dataSource.length
            }, false);
            return;
        }
        var dataManager = this.dataModule.getData(this.dataModule.generateQuery().requiresCount());
        dataManager.then(function(e) {
            return _this.dataManagerSuccess(e);
        });
    };
    SeriesBase.prototype.dataManagerSuccess = function(e, isRemoteData) {
        if (isRemoteData === void 0) isRemoteData = true;
        this.currentViewData = e.count ? e.result : [];
        this.chart.allowServerDataBinding = false;
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) {
            if (this.chart.stockChart) this.chart.stockChart.series[this.index].localData = this.currentViewData;
            var argsData = {
                name: (0, $9415fc5f023d8fac$export$f3b9d552d8efcc74),
                series: this,
                data: this.currentViewData,
                fill: this.interior
            };
            this.chart.trigger((0, $9415fc5f023d8fac$export$f3b9d552d8efcc74), argsData);
            this.interior = argsData.fill;
            this.currentViewData = argsData.data;
        }
        if (this.chart.stockChart && !(this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf)) this.currentViewData = this.chart.stockChart.findCurrentData(this.chart.stockChart.series[0].localData, this.chart.stockChart.series[0].xName);
        this.processJsonData();
        this.recordsCount = e.count;
        this.refreshChart(isRemoteData);
        this.currentViewData = null;
    };
    SeriesBase.prototype.refreshChart = function(isRemoteData) {
        var chart = this.chart;
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) chart.visibleSeriesCount += isRemoteData ? 1 : 0;
        chart.refreshTechnicalIndicator(this);
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf && this.category !== "TrendLine") for(var _i = 0, _a = this.trendlines; _i < _a.length; _i++){
            var trendline = _a[_i];
            trendline.setDataSource(this, chart);
        }
        //if (chart.visibleSeries.length === (chart.visibleSeriesCount - chart.indicators.length)) {
        if (chart.visibleSeries.length === chart.visibleSeriesCount) {
            chart.refreshBound();
            chart.trigger("loaded", {
                chart: chart.isBlazor ? {} : chart
            });
            if (this.chart.stockChart && this.chart.stockChart.initialRender) {
                this.chart.stockChart.initialRender = false;
                this.chart.stockChart.stockChartDataManagerSuccess();
            }
        }
        if (this instanceof $54f817a374cfcee1$export$ed28a77b2a3badcf) chart.visibleSeriesCount += isRemoteData ? 0 : 1;
    };
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "xName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "colorName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "high", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "low", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "open", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "close", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "volume", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "pointColorMapping", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SeriesBase.prototype, "visible", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], SeriesBase.prototype, "xAxisName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], SeriesBase.prototype, "yAxisName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, (0, $2ae44f835da15a47$export$c35d437ae5945fcd))
    ], SeriesBase.prototype, "animation", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], SeriesBase.prototype, "fill", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], SeriesBase.prototype, "width", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "dashArray", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SeriesBase.prototype, "dataSource", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)()
    ], SeriesBase.prototype, "query", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Collection)([], $54f817a374cfcee1$export$ada58b95d4636649)
    ], SeriesBase.prototype, "segments", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("X")
    ], SeriesBase.prototype, "segmentAxis", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SeriesBase.prototype, "enableComplexProperty", void 0);
    return SeriesBase;
}((0, $3fcxu.ChildProperty));
/**
 * The `Series` class is used to configure individual series in a chart.
 *
 * @public
 */ var $54f817a374cfcee1$export$ed28a77b2a3badcf = /** @class */ function(_super) {
    $54f817a374cfcee1$var$__extends(Series, _super);
    function Series(parent, propName, defaultValue, isArray) {
        var _this = _super.call(this, parent, propName, defaultValue, isArray) || this;
        _this.visibleSeriesCount = 0;
        /** @private */ _this.category = "Series";
        /** @private */ _this.isRectSeries = false;
        /** @private */ _this.drawPoints = [];
        /** @private */ _this.lowDrawPoints = [];
        /** @private */ _this.delayedAnimation = false;
        /** @private */ _this.rangeColorName = _this.colorName.length > 0 ? _this.colorName : _this.yName;
        /** @private */ _this.currentData = [];
        return _this;
    }
    /**
     * Refresh the axis label.
     *
     * @returns {void}
     * @private
     */ Series.prototype.refreshAxisLabel = function() {
        if (this.xAxis.valueType.indexOf("Category") === -1) return null;
        this.xAxis.labels = [];
        this.xAxis.indexLabels = {};
        var option = {
            skeleton: "full",
            type: "dateTime"
        };
        var dateParser = this.chart.intl.getDateParser(option);
        var dateFormatter = this.chart.intl.getDateFormat(option);
        for(var _i = 0, _a = this.xAxis.series; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.visible && item.category !== "TrendLine") {
                item.xMin = Infinity;
                item.xMax = -Infinity;
                for(var _b = 0, _c = item.points; _b < _c.length; _b++){
                    var point = _c[_b];
                    item.pushCategoryData(point, point.index, this.xAxis.valueType === "DateTimeCategory" ? Date.parse(dateParser(dateFormatter(point.x))).toString() : point.x);
                    item.xMin = Math.min(item.xMin, point.xValue);
                    item.xMax = Math.max(item.xMax, point.xValue);
                }
            }
        }
    };
    /**
     * To get the series collection.
     *
     * @returns {void}
     * @private
     */ Series.prototype.findSeriesCollection = function(column, row, isStack) {
        var seriesCollection = [];
        for(var _i = 0, _a = row.axes; _i < _a.length; _i++){
            var rowAxis = _a[_i];
            for(var _b = 0, _c = rowAxis.series; _b < _c.length; _b++){
                var rowSeries = _c[_b];
                for(var _d = 0, _e = column.axes; _d < _e.length; _d++){
                    var axis = _e[_d];
                    for(var _f = 0, _g = axis.series; _f < _g.length; _f++){
                        var series = _g[_f];
                        if (series === rowSeries && series.visible && this.rectSeriesInChart(series, isStack)) seriesCollection.push(series);
                    }
                }
            }
        }
        return seriesCollection;
    };
    /**
     * Checks if the series in the chart are rectangular.
     *
     * @param {Series} series - The series to be checked.
     * @param {boolean} isStack - Specifies whether the series are stacked.
     * @returns {boolean} - Returns true if the series in the chart are rectangular, otherwise false.
     */ Series.prototype.rectSeriesInChart = function(series, isStack) {
        var type = series.type.toLowerCase();
        return type.indexOf("column") !== -1 || type.indexOf("bar") !== -1 || type.indexOf("histogram") !== -1 || type.indexOf("hiloopenclose") !== -1 || type.indexOf("candle") !== -1 || type.indexOf("pareto") !== -1 || type.indexOf("hilo") !== -1 || series.drawType.indexOf("Column") !== -1 || type.indexOf("waterfall") !== -1 || type.indexOf("boxandwhisker") !== -1 || isStack;
    };
    /**
     * Calculates the stacked value for the chart.
     *
     * @param {boolean} isStacking100 - Specifies whether the stacking is 100%.
     * @param {Chart} chart - The chart for which the stacked value is calculated.
     * @returns {void}
     * @private
     */ Series.prototype.calculateStackedValue = function(isStacking100, chart) {
        for(var _i = 0, _a = chart.columns; _i < _a.length; _i++){
            var columnItem = _a[_i];
            for(var _b = 0, _c = chart.rows; _b < _c.length; _b++){
                var item = _c[_b];
                this.calculateStackingValues(this.findSeriesCollection(columnItem, item, true), isStacking100);
            }
        }
    };
    Series.prototype.calculateStackingValues = function(seriesCollection, isStacking100) {
        var startValues;
        var endValues;
        var yValues = [];
        var lastPositive = [];
        var lastNegative = [];
        var stackingGroup;
        var lastValue;
        var value;
        var frequencies = [];
        if (isStacking100) frequencies = this.findFrequencies(seriesCollection);
        var groupingValues = [];
        var visiblePoints = [];
        for(var i = 0; i < seriesCollection.length; i++){
            var series = seriesCollection[i];
            if (!groupingValues[series.stackingGroup]) {
                groupingValues[series.stackingGroup] = [];
                groupingValues[series.stackingGroup].push(series);
            } else if (groupingValues[series.stackingGroup] !== undefined) groupingValues[series.stackingGroup].push(series);
        }
        var keys = Object.keys(groupingValues);
        for(var k = 0; k < keys.length; k++){
            var stackingSeies = [];
            var stackedValues = [];
            var seriesCollection_2 = groupingValues[keys[k]];
            for(var _i = 0, seriesCollection_1 = seriesCollection_2; _i < seriesCollection_1.length; _i++){
                var series = seriesCollection_1[_i];
                if (series.type.indexOf("Stacking") !== -1 || series.drawType.indexOf("Stacking") !== -1 && series.chart.chartAreaType === "PolarRadar") {
                    stackingGroup = series.type.indexOf("StackingArea") !== -1 ? "StackingArea100" : series.type.indexOf("StackingLine") !== -1 ? "StackingLine100" : series.stackingGroup;
                    if (!lastPositive[stackingGroup]) {
                        lastPositive[stackingGroup] = [];
                        lastNegative[stackingGroup] = [];
                    }
                    yValues = series.yData;
                    startValues = [];
                    endValues = [];
                    stackingSeies.push(series);
                    visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(series);
                    for(var j = 0, pointsLength = visiblePoints.length; j < pointsLength; j++){
                        lastValue = 0;
                        value = +yValues[j]; // Fix for chart not rendering while y value is given as string issue
                        if (lastPositive[stackingGroup][visiblePoints[j].xValue] === undefined) lastPositive[stackingGroup][visiblePoints[j].xValue] = 0;
                        if (lastNegative[stackingGroup][visiblePoints[j].xValue] === undefined) lastNegative[stackingGroup][visiblePoints[j].xValue] = 0;
                        if (isStacking100) {
                            value = value / frequencies[stackingGroup][visiblePoints[j].xValue] * 100;
                            value = !isNaN(value) ? value : 0;
                            visiblePoints[j].percentage = +value.toFixed(2);
                        } else stackedValues[j] = stackedValues[j] ? stackedValues[j] + Math.abs(value) : Math.abs(value);
                        if (value >= 0) {
                            lastValue = lastPositive[stackingGroup][visiblePoints[j].xValue];
                            lastPositive[stackingGroup][visiblePoints[j].xValue] += value;
                        } else {
                            lastValue = lastNegative[stackingGroup][visiblePoints[j].xValue];
                            lastNegative[stackingGroup][visiblePoints[j].xValue] += value;
                        }
                        startValues.push(lastValue);
                        endValues.push(value + lastValue);
                        if (isStacking100 && endValues[j] > 100) endValues[j] = 100;
                    }
                    series.stackedValues = new (0, $11815a21a80ae2b7$export$cb68e0e5fb7c5c3a)(startValues, endValues);
                    var isLogAxis = series.yAxis.valueType === "Logarithmic";
                    var isColumnBarType = series.type.indexOf("Column") !== -1 || series.type.indexOf("Bar") !== -1;
                    series.yMin = isLogAxis && isColumnBarType && series.yMin < 1 ? series.yMin : series.yAxis.startFromZero && series.yAxis.rangePadding === "Auto" && series.yMin >= 0 ? 0 : parseFloat(Math.min.apply(0, isStacking100 ? startValues : endValues).toFixed(10));
                    series.yMax = Math.max.apply(0, endValues);
                    if (series.yMin > Math.min.apply(0, endValues)) series.yMin = isStacking100 ? -100 : isLogAxis && isColumnBarType && series.yMin < 1 ? series.yMin : Math.min.apply(0, endValues);
                    if (series.yMax < Math.max.apply(0, startValues)) series.yMax = 0;
                }
            }
            this.findPercentageOfStacking(stackingSeies, stackedValues, isStacking100);
        }
    };
    Series.prototype.findPercentageOfStacking = function(stackingSeies, values, isStacking100) {
        for(var _i = 0, stackingSeies_1 = stackingSeies; _i < stackingSeies_1.length; _i++){
            var item = stackingSeies_1[_i];
            if (isStacking100) return null;
            for(var _a = 0, _b = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(item); _a < _b.length; _a++){
                var point = _b[_a];
                point.percentage = Math.abs(+(point.y / values[point.index] * 100).toFixed(2));
            }
        }
    };
    Series.prototype.findFrequencies = function(seriesCollection) {
        var frequencies = [];
        var stackingGroup;
        var visiblePoints = [];
        for(var _i = 0, seriesCollection_3 = seriesCollection; _i < seriesCollection_3.length; _i++){
            var series = seriesCollection_3[_i];
            series.yAxis.isStack100 = series.type.indexOf("100") !== -1 ? true : false;
            visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(series);
            if (series.type.indexOf("Stacking") !== -1) {
                stackingGroup = series.type.indexOf("StackingArea") !== -1 ? "StackingArea100" : series.type.indexOf("StackingLine") !== -1 ? "StackingLine100" : series.stackingGroup;
                if (!frequencies[stackingGroup]) frequencies[stackingGroup] = [];
                for(var j = 0, pointsLength = visiblePoints.length; j < pointsLength; j++){
                    if (frequencies[stackingGroup][visiblePoints[j].xValue] === undefined) frequencies[stackingGroup][visiblePoints[j].xValue] = 0;
                    if (series.yData[j] > 0) frequencies[stackingGroup][visiblePoints[j].xValue] += series.yData[j];
                    else frequencies[stackingGroup][visiblePoints[j].xValue] -= series.yData[j];
                }
            }
        }
        return frequencies;
    };
    /* private dataManagerFailure(e: { result: Object[] }): void {
         this.currentViewData = [];
         this.refreshChart();
     }*/ /**
     * Renders the series on the chart.
     *
     * @param {Chart} chart - The chart on which the series is rendered.
     * @returns {void}
     * @private
     */ Series.prototype.renderSeries = function(chart) {
        if (this.chart.stockChart && this.xAxis.valueType === "DateTimeCategory") {
            for(var i = 0; i < this.points.length; i++){
                var index = this.xAxis.labels.indexOf(Date.parse(this.points[i].x.toString()).toString());
                this.points[i].xValue = index;
                if (chart.series.length > 1) {
                    this.xData[i] = index;
                    this.xMin = this.xMin > index ? index : this.xMin;
                    this.xMax = this.xMax < index ? index : this.xMax;
                }
            }
            if (this instanceof Series && this.type.indexOf("Spline") > -1) {
                var isArea = this.type.indexOf("Area") > -1;
                var isRange = this.type.indexOf("Range") > -1;
                this.chart["spline" + (isArea ? isRange ? "RangeArea" : "Area" : "") + "SeriesModule"].findSplinePoint(this);
            }
        }
        var seriesType = (0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type);
        seriesType = seriesType.replace("100", "");
        if (chart[seriesType + "SeriesModule"]) {
            if (this.category !== "Indicator" && this.category !== "TrendLine") this.createSeriesElements(chart);
            this.visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(this);
            chart[seriesType + "SeriesModule"].render(this, this.xAxis, this.yAxis, chart.requireInvertedAxis);
            if (this.category !== "Indicator") {
                if (this.errorBar.visible) this.chart.errorBarModule.render(this);
                if (this.marker.dataLabel.visible) chart.dataLabelModule.render(this, this.chart, this.marker.dataLabel);
                this.appendSeriesElement(chart.seriesElements, chart);
            }
            if (!this.chart.enableCanvas) this.performAnimation(chart, seriesType, this.errorBar, this.marker, this.marker.dataLabel);
        }
    };
    /**
     * Creates elements for the series on the chart.
     *
     * @param {Chart} chart - The chart for which series elements are created.
     * @returns {void}
     * @private
     */ Series.prototype.createSeriesElements = function(chart) {
        if (this.category !== "Indicator") {
            var elementId = chart.element.id;
            // 8 for extend border value 5 for extend size value
            var explodeValue = this.marker.border.width + 8 + 5;
            var render = this.type === "Bubble" || !this.marker.visible && chart.tooltip.shared && chart.enableCanvas ? chart.svgRenderer : chart.renderer;
            var index = this.index === undefined ? this.category : this.index;
            var markerHeight = void 0;
            var markerWidth = void 0;
            var options = void 0;
            if (this.type === "Scatter" || this.drawType === "Scatter") {
                markerHeight = (this.marker.height + explodeValue) / 2;
                markerWidth = (this.marker.width + explodeValue) / 2;
            } else {
                markerHeight = 0;
                markerWidth = 0;
            }
            if (chart.chartAreaType === "PolarRadar") {
                var markerMaxValue = this.drawType === "Scatter" ? Math.max(this.marker.width, this.marker.height) : 0;
                options = new (0, $11815a21a80ae2b7$export$abcc25cb43492e33)(elementId + "_ChartSeriesClipRect_" + index, "transparent", {
                    width: 1,
                    color: "Gray"
                }, 1, this.clipRect.width / 2 + this.clipRect.x, this.clipRect.height / 2 + this.clipRect.y, chart.radius + markerMaxValue);
                this.clipRectElement = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(chart.redraw, options, render, "drawCircularClipPath");
            } else {
                options = new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(elementId + "_ChartSeriesClipRect_" + index, "transparent", {
                    width: 1,
                    color: "Gray"
                }, 1, {
                    x: this.xAxis.columnIndex === 0 ? -markerWidth : 0,
                    y: this.yAxis.rowIndex === chart.rows.length - 1 ? -markerHeight : 0,
                    width: this.clipRect.width + (this.xAxis.columnIndex === chart.columns.length - 1 ? markerWidth * 2 : markerWidth),
                    height: this.clipRect.height + (this.yAxis.rowIndex === 0 ? markerHeight * 2 : markerHeight)
                });
                this.clipRectElement = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(chart.redraw, options, render);
            }
            var transform = chart.chartAreaType === "Cartesian" ? "translate(" + this.clipRect.x + "," + this.clipRect.y + ")" : "";
            this.symbolElement = null;
            this.seriesElement = render.createGroup({
                "id": elementId + "SeriesGroup" + index,
                "transform": transform,
                "clip-path": "url(#" + elementId + "_ChartSeriesClipRect_" + index + ")"
            });
            if (this.seriesElement) {
                this.seriesElement.setAttribute("role", "region");
                this.seriesElement.setAttribute("aria-label", this.name + "," + this.type + " series with " + this.points.length + " data points");
                this.seriesElement.setAttribute("aria-hidden", "false");
            }
            if (!this.chart.enableCanvas || this.type === "Bubble") {
                this.seriesElement.setAttribute("tabindex", index === 0 ? "0" : !this.checkTabindex(chart.visibleSeries, index) ? "0" : "");
                this.seriesElement.setAttribute("style", "outline: none");
                this.seriesElement.appendChild(this.clipRectElement);
            }
        }
    };
    Series.prototype.checkTabindex = function(visibleSeries, index) {
        for(var i = 0; i < index; i++){
            if (visibleSeries[i].visible) return true;
        }
        return false;
    };
    /**
     * Appends a series element to the chart.
     *
     * @param {Element} element - The series element to append.
     * @param {Chart} chart - The chart to which the series element will be appended.
     * @returns {void}
     * @private
     */ Series.prototype.appendSeriesElement = function(element, chart) {
        var marker = this.marker;
        var dataLabel = marker.dataLabel;
        var redraw = chart.redraw;
        if (this.category !== "TrendLine") {
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.seriesElements, this.seriesElement, redraw);
            var errorBar = this.errorBar;
            if (errorBar.visible) {
                if (chart.chartAreaType === "PolarRadar") (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.seriesElements, this.seriesElement, redraw);
                else (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.seriesElements, this.errorBarElement, redraw);
            }
        }
        if (marker.visible && (chart.chartAreaType === "Cartesian" || this.drawType !== "Scatter" && chart.chartAreaType === "PolarRadar") && this.type !== "Scatter" && this.type !== "Bubble" && this.type !== "Candle" && this.type !== "Hilo" && this.type !== "HiloOpenClose" && this.symbolElement) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.seriesElements, this.symbolElement, redraw);
        if (dataLabel.visible && this.textElement) {
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.dataLabelElements, this.shapeElement, redraw);
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.dataLabelElements, this.textElement, redraw);
        }
        if (!chart.enableCanvas && chart.dataLabelElements.hasChildNodes()) chart.seriesElements.appendChild(chart.dataLabelElements);
    };
    /**
     * Performs animation for the specified chart elements.
     *
     * @param {Chart} chart - The chart for which animation is performed.
     * @param {string} type - The type of animation to be performed.
     * @param {ErrorBarSettingsModel} errorBar - The error bar settings for the animation.
     * @param {MarkerSettingsModel} marker - The marker settings for the animation.
     * @param {DataLabelSettingsModel} dataLabel - The data label settings for the animation.
     * @returns {void}
     * @private
     */ Series.prototype.performAnimation = function(chart, type, errorBar, marker, dataLabel) {
        if ((this.animation.enable && (0, $kj1BR.animationMode) !== "Disable" || (0, $kj1BR.animationMode) === "Enable") && chart.animateSeries && (!chart.stockChart || !chart.stockChart.isStockChartRendered)) {
            chart[type + "SeriesModule"].doAnimation(this);
            if (errorBar.visible) chart.errorBarModule.doErrorBarAnimation(this);
            if (marker.visible && (this.isRectSeries || this.type === "Line" || this.type === "Polar" || this.type === "Radar")) chart.markerRender.doMarkerAnimation(this);
            //to datalabel animation disabled for edge and IE
            if (dataLabel.visible && (0, $5q7BP.Browser).info.name !== "edge" && !(0, $5q7BP.Browser).isIE) chart.dataLabelModule.doDataLabelAnimation(this);
        }
    };
    /**
     * Sets the color of a data point.
     *
     * @param {Points} point - The data point.
     * @param {string} color - The color to set.
     * @returns {string} - The updated color.
     * @private
     */ Series.prototype.setPointColor = function(point, color) {
        color = point.interior || color;
        return point.isEmpty ? this.emptyPointSettings.fill || color : color;
    };
    /**
     * Sets the border color of a data point.
     *
     * @param {Points} point - The data point.
     * @param {BorderModel} border - The border color to set.
     * @returns {BorderModel} - The updated border color.
     * @private
     */ Series.prototype.setBorderColor = function(point, border) {
        border.width = point.isEmpty ? this.emptyPointSettings.border.width || border.width : border.width;
        border.color = point.isEmpty ? this.emptyPointSettings.border.color || border.color : border.color;
        return border;
    };
    /**
     * Adds a data point to the data source.
     *
     * @function addPoint
     * @param {Object} dataPoint - The data point to be added.
     * @param {number} duration - The duration for the animation.
     * @returns {void}
     */ Series.prototype.addPoint = function(dataPoint, duration) {
        var yMin = this.yMin;
        var yMax = this.yMax;
        this.removeTrackballElements();
        this.dataSource.push(dataPoint);
        if (this.type === "Radar" || this.type === "Polar") return this.chart.refresh();
        if (this.type === "Histogram") {
            this.currentViewData = this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type) + "SeriesModule"].processInternalData((0, $3EnZW.extend)([], this.dataSource, null, true), this);
            for(var i = 0; i < this.currentViewData.length; i++)this.updatePoint(i);
        } else {
            this.currentViewData = this.dataSource;
            var pointIndex = this.points.length === 0 ? 0 : this.points[this.points.length - 1].index + 1;
            this.updatePoint(pointIndex);
        }
        if (this.category === "Pareto") {
            var dataSource = (0, $3EnZW.extend)([], this.dataSource, null, true);
            var series = this.chart.visibleSeries[this.index + this.chart.series.length];
            series.currentViewData = this.chart.paretoSeriesModule.performCumulativeCalculation(dataSource, this);
            for(var i = 0; i < series.currentViewData.length; i++){
                if (!series.points[i]) series.updatePoint(i);
                series.points[i].y = series.points[i].yValue = series.currentViewData[i][series.yName];
            }
        }
        this.updateSplineValue();
        this.chart.calculateStackValues();
        this.chart.redraw = this.chart.enableAnimation;
        var chartDuration = this.chart.duration;
        this.chart.duration = (0, $3EnZW.isNullOrUndefined)(duration) ? 500 : duration;
        this.chart.animateSeries = false;
        this.chart.pointsAdded = true;
        if (this.chart.enableAnimation && !(this.isRectSeries || this.type === "Bubble" || this.type === "Scatter") && this.type.indexOf("step") === -1) {
            if (this.marker && this.marker.visible && this.visible) {
                for(var i = this.points.length - 2; i >= 0; i--)if (this.points[i] && this.points[i].symbolLocations[0] !== undefined) {
                    this.chart.markerRender.renderMarker(this, this.points[this.points.length - 2], this.points[i].symbolLocations[0], null, true);
                    break;
                }
            }
        }
        if (this.yMin >= yMin && this.yMax <= yMax) {
            if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis)) {
                this.xAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.xAxis.rect.width, this.chart.availableSize.height), this.xAxis);
                this.xAxis.updateAxis();
            }
            this.chart.pointsAdded = false;
            this.updateSeries(true, false);
        }
        if (this.yMin < yMin || this.yMax > yMax) {
            this.updateChartAxis();
            this.chart.pointsAdded = false;
            this.updateSeries(true, true);
        }
        this.chart.redraw = false;
        this.chart.duration = chartDuration;
    };
    /**
     * Removes a data point from the series data source at the specified index.
     *
     * @function removePoint
     * @param {number} index - The index of the data point to be removed.
     * @param {number} duration - The duration for the animation.
     * @returns {void}
     */ Series.prototype.removePoint = function(index, duration) {
        var dataSource = (0, $3EnZW.extend)([], this.dataSource, null, true);
        var chartDuration = this.chart.duration;
        if (dataSource.length > 0 && index >= 0 && index < dataSource.length) {
            dataSource.splice(index, 1);
            this.dataSource.splice(index, 1);
            this.removeTrackballElements(index);
            if (this.type === "Radar" || this.type === "Polar") return this.chart.refresh();
            this.chart.redraw = this.chart.enableAnimation;
            this.chart.animateSeries = false;
            this.chart.pointsAdded = true;
            this.chart.duration = (0, $3EnZW.isNullOrUndefined)(duration) ? 500 : duration;
            if (this.type === "Histogram") {
                var length_1 = this.points.length;
                this.points = [];
                this.visiblePoints = [];
                this.currentViewData = this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type) + "SeriesModule"].processInternalData((0, $3EnZW.extend)([], this.dataSource, null, true), this);
                for(var i = 0; i < this.currentViewData.length; i++)this.updatePoint(i);
                if (length_1 > this.points.length) this.removedPointIndex = index;
            } else {
                this.removedPointIndex = index;
                this.points.splice(index, 1);
                this.visiblePoints.splice(index, 1);
            }
            this.yData = [];
            this.xData = [];
            var yMin = this.yMin;
            var yMax = this.yMax;
            this.yMin = Infinity;
            this.xMin = Infinity;
            this.yMax = -Infinity;
            this.xMax = -Infinity;
            if (this.xAxis.valueType.indexOf("Category") > -1 && this.chart.series.length === 1) {
                this.xAxis.labels = [];
                this.xAxis.indexLabels = {};
            }
            if (index === 0) this.chart.pointsRemoved = this.chart.enableAnimation;
            for(var i = 0; i < this.points.length; i++)this.updatePointsAfterRemoval(i);
            if (this.category === "Pareto") {
                var series = this.chart.visibleSeries[this.index + this.chart.series.length];
                series.yMin = Infinity;
                series.xMin = Infinity;
                series.yMax = -Infinity;
                series.xMax = -Infinity;
                series.points.splice(index, 1);
                series.visiblePoints.splice(index, 1);
                series.currentViewData = this.chart.paretoSeriesModule.performCumulativeCalculation(this.dataSource, this);
                for(var i = 0; i < series.currentViewData.length; i++){
                    series.points[i].y = series.points[i].yValue = series.currentViewData[i][series.yName];
                    series.updatePointsAfterRemoval(i);
                }
            }
            this.updateSplineValue();
            this.chart.calculateStackValues();
            if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis) && yMax === this.yMax && yMin === this.yMin) {
                this.xAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.xAxis.rect.width, this.chart.availableSize.height), this.xAxis);
                this.xAxis.updateAxis();
                this.createSeriesElements(this.chart);
                this.chart.pointsAdded = false;
                this.updateSeries(true, false);
            } else if (yMax < this.yMax || yMin > this.yMin || yMax > this.yMax || yMin < this.yMin) {
                this.updateChartAxis();
                this.createSeriesElements(this.chart);
                this.chart.pointsAdded = false;
                this.updateSeries(true, true);
            }
        }
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.chart.enableCanvas, this.chart.seriesElements, this.seriesElement, true);
        this.chart.redraw = false;
        this.chart.duration = chartDuration;
        this.chart.pointsRemoved = false;
        this.removedPointIndex = null;
    };
    Series.prototype.updatePointsAfterRemoval = function(index) {
        var point = this.points[index];
        var option = {
            skeleton: "full",
            type: "dateTime"
        };
        var dateParser = this.chart.intl.getDateParser(option);
        var dateFormatter = this.chart.intl.getDateFormat(option);
        if (this.xAxis.valueType === "Category" && this.chart.series.length === 1) this.pushCategoryData(point, index, point.x);
        else if (this.xAxis.valueType === "DateTimeCategory" && this.chart.series.length === 1) this.pushCategoryData(point, index, Date.parse(dateParser(dateFormatter(point.x))).toString());
        this.pushData(point, index);
        this.setEmptyPoint(this.points[index], index);
    };
    /**
     * Removes trackball elements from the series.
     *
     * @param {number} index - The index of the data point.
     * @returns {void}
     */ Series.prototype.removeTrackballElements = function(index) {
        if (this.marker.visible) {
            if (index !== undefined) {
                var baseId = this.chart.element.id + "_Series_" + this.index + "_Point_" + index + "_Trackball_";
                var trackball0 = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(baseId + "0");
                if (trackball0) trackball0.remove();
                var trackball1 = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(baseId + "1");
                if (trackball1) trackball1.remove();
                var symbolElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_Series_" + this.index + "_Point_" + index + "_Symbol");
                if (symbolElement) symbolElement.setAttribute("visibility", "visible");
            } else {
                var baseClassPattern = this.chart.element.id + "_EJ2-Trackball_Series_" + this.index + "_Point_";
                var elements = document.querySelectorAll('[class*="' + baseClassPattern + '"]');
                if (elements[0]) {
                    var pointIndexMatch = elements[0].id.match(/_Point_(\d+)_/);
                    var pointIndex = pointIndexMatch ? parseInt(pointIndexMatch[1], 10) : null;
                    elements[0].remove();
                    var symbolElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_Series_" + this.index + "_Point_" + pointIndex + "_Symbol");
                    if (symbolElement) symbolElement.setAttribute("visibility", "visible");
                }
                if (elements[1]) elements[1].remove();
            }
        }
        if (this.chart.tooltip.enable) {
            this.chart.tooltipModule.previousPoints = [];
            var tooltipElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_tooltip");
            if (tooltipElement) tooltipElement.remove();
        }
    };
    /**
     * Sets the data source with the provided data.
     *
     * @function setData
     * @param {Object[]} data - An array of objects representing the data points.
     * @param {number} duration - The duration for the animation.
     * @returns {void}
     */ Series.prototype.setData = function(data, duration) {
        var _this = this;
        if (!data) return null;
        var updatedData = [];
        if (this.dataSource.length === data.length) for(var i = 0; i < data.length; i++){
            if (data[i][this.xName] instanceof Date) updatedData.push(data[i][this.xName].getTime());
            else updatedData.push(data[i][this.xName]);
            if (this.currentData.length < this.dataSource.length) {
                var dataSource = (0, $3EnZW.extend)([], this.dataSource, null, true);
                if (dataSource[i][this.xName] instanceof Date) this.currentData.push(dataSource[i][this.xName].getTime());
                else this.currentData.push(dataSource[i][this.xName]);
            }
        }
        var isSameData = updatedData.every(function(element) {
            return _this.currentData.indexOf(element) !== -1;
        });
        if (this.currentViewData) isSameData = true;
        var isXAxisChanged = false;
        var yMin = this.yMin;
        var yMax = this.yMax;
        this.yMin = Infinity;
        this.yMax = -Infinity;
        var points = [];
        this.chart.dataLabelCollections = [];
        this.chart.rotatedDataLabelCollections = [];
        var samePoints = false;
        var index = null;
        if (this.dataSource.length === data.length && !(this.type === "Radar" || this.type === "Polar") && isSameData) {
            samePoints = true;
            this.yData = [];
            if (this.type === "Histogram" && this.dataSource.length === data.length) {
                var newHistogramData = this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type) + "SeriesModule"].processInternalData((0, $3EnZW.extend)([], data, null, true), this);
                this.currentViewData = newHistogramData;
                for(var j = 0; j < newHistogramData.length; j++)this.updatePoint(j);
            } else for(var i = 0; i < data.length; i++){
                var newData = data[i][this.xName];
                var existingData = this.dataSource[i][this.xName];
                if (data[i][this.xName] instanceof Date) {
                    newData = data[i][this.xName].getTime();
                    existingData = this.dataSource[i][this.xName].getTime();
                }
                if (this.currentData[i] !== newData) isXAxisChanged = true;
                var point = this.points[i];
                var getObjectValueByMappingString = this.enableComplexProperty ? (0, $3EnZW.getValue) : this.getObjectValue;
                var existingPoint = this.dataSource[i];
                var newPoint = data[i];
                if (this.seriesType === "XY" || this.seriesType === "BoxPlot") {
                    point.y = getObjectValueByMappingString(this.yName, newPoint);
                    if (this.type === "Bubble" && existingPoint[this.size] !== newPoint[this.size]) point.size = getObjectValueByMappingString(this.size, newPoint);
                    points.push(i);
                } else if (existingPoint[this.high] !== newPoint[this.high] || existingPoint[this.low] !== newPoint[this.low] || existingPoint[this.open] !== newPoint[this.open] || existingPoint[this.close] !== newPoint[this.close] || existingPoint[this.volume] !== newPoint[this.volume]) {
                    point.high = getObjectValueByMappingString(this.high, newPoint);
                    point.low = getObjectValueByMappingString(this.low, newPoint);
                    point.open = getObjectValueByMappingString(this.open, newPoint);
                    point.close = getObjectValueByMappingString(this.close, newPoint);
                    point.volume = getObjectValueByMappingString(this.volume, newPoint);
                    points.push(i);
                }
                point.yValue = point.y;
                point.x = getObjectValueByMappingString(this.xName, newPoint);
                if (!this.currentViewData) point.index = this.xAxis.valueType === "DateTime" && typeof point.x !== "number" ? this.currentData.indexOf(point.x.getTime()) : this.currentData.indexOf(point.x);
                if ((this.xAxis.valueType === "Category" || this.xAxis.valueType === "DateTimeCategory") && i < this.xAxis.visibleLabels.length) {
                    this.xAxis.visibleLabels[i].value = updatedData.indexOf(this.currentData[i * this.xAxis.visibleRange.interval]);
                    this.xAxis.labels[i] = String(updatedData[i]);
                }
                this.setEmptyPoint(point, i);
                this.dataSource[i] = data[i];
            }
        }
        if (!samePoints) this.dataSource = data;
        else {
            this.chart.redraw = this.chart.enableAnimation;
            this.chart.animateSeries = false;
            this.chart.pointsAdded = true;
            var chartDuration = this.chart.duration;
            this.chart.duration = (0, $3EnZW.isNullOrUndefined)(duration) ? 500 : duration;
            if (this.type.indexOf("Stacking") !== -1) this.chart.calculateStackValues();
            this.updateSplineValue();
            if (yMax === this.yMax && yMin === this.yMin && this.visible) {
                this.chart.pointsAdded = false;
                this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.category === "Pareto" ? "Column" : this.type.replace("100", "")) + "SeriesModule"].updateDirection(this, points, this.chart.requireInvertedAxis);
                if (this.chart.annotationModule) this.chart.annotationModule.renderAnnotations((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_Secondary_Element"));
                if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis) && isXAxisChanged) this.xAxis.updateAxis();
            } else if ((yMax < this.yMax || yMin > this.yMin || yMax > this.yMax || yMin < this.yMin) && this.visible) {
                var maximumLabelWidth = this.yAxis.maxLabelSize.width;
                this.yAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.chart.availableSize.width, this.yAxis.rect.height), this.yAxis);
                if (maximumLabelWidth < this.yAxis.maxLabelSize.width) {
                    this.chart.calculateBounds();
                    this.chart.axisCollections.forEach(function(axis) {
                        if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(axis)) axis.updateAxis();
                    });
                    this.chart.chartAxisLayoutPanel.drawPaneLines(this.chart);
                    this.chart.renderAreaBorder();
                } else {
                    if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.yAxis)) this.yAxis.updateAxis();
                    if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis) && isXAxisChanged) this.xAxis.updateAxis();
                    if (this.type === "Histogram" && !(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis)) {
                        this.xAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.xAxis.rect.width, this.chart.availableSize.height), this.xAxis);
                        this.xAxis.updateAxis();
                    }
                }
                this.chart.pointsAdded = false;
                if (isXAxisChanged) {
                    this.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.category === "Pareto" ? "Column" : this.type.replace("100", "")) + "SeriesModule"].updateDirection(this, points, this.chart.requireInvertedAxis);
                    index = this.index;
                }
                this.updateSeries(false, true, index);
                if (this.chart.stripLineModule) this.chart.stripLineModule.renderStripLine(this.chart, "Behind", this.chart.axisCollections);
            }
            this.chart.redraw = false;
            this.chart.pointsRemoved = false;
            this.chart.duration = chartDuration;
        }
    };
    /**
     * Updates the chart axes based on current data and axis bounds.
     *
     * @returns {void}
     */ Series.prototype.updateChartAxis = function() {
        var maximumLabelWidth = this.yAxis.maxLabelSize.width;
        this.yAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.chart.availableSize.width, this.yAxis.rect.height), this.yAxis);
        if (maximumLabelWidth < this.yAxis.maxLabelSize.width) {
            this.chart.calculateBounds();
            this.chart.axisCollections.forEach(function(axis) {
                if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(axis)) axis.updateAxis();
            });
            this.chart.chartAxisLayoutPanel.drawPaneLines(this.chart);
            this.chart.renderAreaBorder();
        } else {
            if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.xAxis)) {
                this.xAxis.baseModule.calculateRangeAndInterval(new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.xAxis.rect.width, this.chart.availableSize.height), this.xAxis);
                this.xAxis.updateAxis();
            }
            if (!(0, $11815a21a80ae2b7$export$9644c4f5061d3b67)(this.yAxis)) this.yAxis.updateAxis();
        }
        if (this.chart.stripLineModule) this.chart.stripLineModule.renderStripLine(this.chart, "Behind", this.chart.axisCollections);
    };
    Series.prototype.updateSeries = function(xAxis, yAxis, index) {
        var seriesCollection = [];
        if (xAxis && yAxis) {
            var set = new Set(this.xAxis.series.concat(this.yAxis.series));
            set.forEach(function(series) {
                seriesCollection.push(series);
            });
        } else seriesCollection = xAxis ? this.xAxis.series.slice() : this.yAxis.series.slice();
        for(var _i = 0, seriesCollection_4 = seriesCollection; _i < seriesCollection_4.length; _i++){
            var series = seriesCollection_4[_i];
            if (series.visible && series.index !== index) {
                (0, $11815a21a80ae2b7$export$eb71090255ea483d)(series, this.chart.enableCanvas);
                var transform = "translate(" + this.clipRect.x + "," + this.clipRect.y + ")";
                series.seriesElement.setAttribute("transform", transform);
                series.chart[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(series.type.replace("100", "")) + "SeriesModule"].render(series, series.xAxis, series.yAxis, series.chart.requireInvertedAxis, series.chart.enableAnimation);
                if (series.marker.visible && series.chart.chartAreaType === "Cartesian" && series.type !== "Scatter" && series.type !== "Bubble" && series.type !== "Candle" && series.type !== "Hilo" && series.type !== "HiloOpenClose" && series.symbolElement) {
                    series.symbolElement.setAttribute("transform", transform);
                    (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.chart.seriesElements, series.symbolElement, true);
                }
                if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                    series.chart.dataLabelCollections = [];
                    series.chart.dataLabelModule.render(series, series.chart, series.marker.dataLabel);
                    if (series.textElement) {
                        if (series.shapeElement) series.shapeElement.setAttribute("transform", transform);
                        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.chart.dataLabelElements, series.shapeElement, true);
                        series.textElement.setAttribute("transform", transform);
                        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(series.chart.enableCanvas, series.chart.dataLabelElements, series.textElement, true);
                    }
                }
                if (series.chart.annotationModule) series.chart.annotationModule.renderAnnotations((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(series.chart.element.id + "_Secondary_Element"));
            }
        }
    };
    Series.prototype.updatePoint = function(index) {
        var point = new $54f817a374cfcee1$export$1c787534cb11aa3e();
        var textMappingName = this instanceof Series && this.marker.dataLabel.name ? this.marker.dataLabel.name : "";
        var xName = this instanceof Series && this.type === "Histogram" ? "x" : this.xName;
        if (this.xAxis.valueType === "Category") this.pushCategoryPoint(point, index, textMappingName, xName);
        else if (this.xAxis.valueType.indexOf("DateTime") > -1) {
            var point_1 = this.points[index];
            var option = {
                skeleton: "full",
                type: "dateTime"
            };
            var dateParser = this.chart.intl.getDateParser(option);
            var dateFormatter = this.chart.intl.getDateFormat(option);
            this.pushDateTimePoint(point_1, index, textMappingName, xName, dateParser, dateFormatter);
        } else this.pushDoublePoint(point, index, textMappingName, xName);
    };
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "name", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "yName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Line")
    ], Series.prototype, "drawType", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Series.prototype, "isClosed", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "bearFillColor", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "bullFillColor", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Series.prototype, "enableSolidCandles", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "size", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "binInterval", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Series.prototype, "showNormalDistribution", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "stackingGroup", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: 0
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], Series.prototype, "border", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Series.prototype, "opacity", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Series.prototype, "zOrder", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "groupName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Line")
    ], Series.prototype, "type", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, $54f817a374cfcee1$export$3e6744115f9f5631)
    ], Series.prototype, "errorBar", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, $54f817a374cfcee1$export$71b5a5b5100933c5)
    ], Series.prototype, "marker", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, $54f817a374cfcee1$export$ef8be8fbb2880234)
    ], Series.prototype, "paretoOptions", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$7f0d187f4d142ae0))
    ], Series.prototype, "dragSettings", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Collection)([], $54f817a374cfcee1$export$197a570748ce7b7e)
    ], Series.prototype, "trendlines", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Series.prototype, "enableTooltip", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "tooltipFormat", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "tooltipMappingName", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("SeriesType")
    ], Series.prototype, "legendShape", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Series.prototype, "legendImageUrl", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "selectionStyle", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "unSelectedStyle", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "nonHighlightStyle", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Series.prototype, "minRadius", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], Series.prototype, "maxRadius", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Natural")
    ], Series.prototype, "splineType", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0.5)
    ], Series.prototype, "cardinalSplineTension", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, (0, $2ae44f835da15a47$export$83e1c8b12fd66dd2))
    ], Series.prototype, "emptyPointSettings", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Series.prototype, "showMean", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], Series.prototype, "boxPlotMode", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "columnWidth", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Series.prototype, "columnWidthInPixel", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Rectangle")
    ], Series.prototype, "columnFacet", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Series.prototype, "columnSpacing", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("#C64E4A")
    ], Series.prototype, "negativeFillColor", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("#4E81BC")
    ], Series.prototype, "summaryFillColor", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)()
    ], Series.prototype, "intermediateSumIndexes", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)()
    ], Series.prototype, "sumIndexes", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], Series.prototype, "step", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Series.prototype, "noRisers", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "black",
            width: 2
        }, (0, $2ae44f835da15a47$export$b2278035370d6017))
    ], Series.prototype, "connector", void 0);
    $54f817a374cfcee1$var$__decorate([
        (0, $5rsSz.Complex)(null, (0, $2ae44f835da15a47$export$c00d35911f9e8312))
    ], Series.prototype, "cornerRadius", void 0);
    return Series;
}($54f817a374cfcee1$export$44db626655395dec);



/**
 * data module is used to generate query and dataSource
 */ var $f2551c5eaeb23533$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructor for data module
     *
     * @param dataSource
     * @param query
     * @param dataSource
     * @param query
     * @private
     */ function Data(dataSource, query) {
        this.initDataManager(dataSource, query);
    }
    /**
     * The function used to initialize dataManager and query
     *
     * @param dataSource
     * @param query
     * @param dataSource
     * @param query
     * @returns {void}
     * @private
     */ Data.prototype.initDataManager = function(dataSource, query) {
        this.dataManager = dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(dataSource);
        this.query = query instanceof (0, $56262f229d1cff45$export$62297b13309008b2) ? query : new (0, $56262f229d1cff45$export$62297b13309008b2)();
    };
    /**
     * The function used to generate updated Query from chart model
     *
     * @returns {void}
     * @private
     */ Data.prototype.generateQuery = function() {
        var query = this.query.clone();
        return query;
    };
    /**
     * The function used to get dataSource by executing given Query
     *
     * @param  {Query} query - A Query that specifies to generate dataSource
     * @returns {void}
     * @private
     */ Data.prototype.getData = function(dataQuery) {
        var _this = this;
        if (this.dataManager.ready) {
            var dataManagerDeferred_1 = new (0, $a4fc1b4c34afe464$export$85f6557964517f1a)();
            var ready = this.dataManager.ready;
            ready.then(function() {
                _this.dataManager.executeQuery(dataQuery).then(function(result) {
                    dataManagerDeferred_1.resolve(result);
                });
            }).catch(function(e) {
                dataManagerDeferred_1.reject(e);
            });
            return dataManagerDeferred_1.promise;
        } else return this.dataManager.executeQuery(dataQuery);
    };
    return Data;
}();




parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $3EnZW = parcelRequire("3EnZW");



parcelRequire("j7YE8");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");

var $14cdfd9e1cbe3bae$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `Marker` module is used to render markers for line-type series.
 *
 * @private
 */ var $14cdfd9e1cbe3bae$export$896c5e81720b190d = /** @class */ function(_super) {
    $14cdfd9e1cbe3bae$var$__extends(MarkerExplode, _super);
    /**
     * Constructor for the marker module.
     *
     * @private
     */ function MarkerExplode(chart) {
        var _this = _super.call(this, chart) || this;
        _this.elementId = chart.element.id;
        _this.commonXvalues = [];
        return _this;
    }
    /**
     * Adds event listeners for the series.
     *
     * @returns {void}
     * @private
     */ MarkerExplode.prototype.addEventListener = function() {
        if (this.chart.isDestroyed) return;
        this.chart.on((0, $5q7BP.Browser).touchMoveEvent, this.mouseMoveHandler, this);
        this.chart.on((0, $5q7BP.Browser).touchEndEvent, this.mouseUpHandler, this);
    };
    /**
     * Removes event listeners for the series.
     *
     * @private
     *
     * @returns {void}
     */ MarkerExplode.prototype.removeEventListener = function() {
        if (this.chart.isDestroyed) return;
        this.chart.off((0, $5q7BP.Browser).touchMoveEvent, this.mouseMoveHandler);
        this.chart.off((0, $5q7BP.Browser).touchEndEvent, this.mouseUpHandler);
    };
    /**
     * Handles the mouse up event.
     *
     * @returns {void}
     */ MarkerExplode.prototype.mouseUpHandler = function() {
        var chart = this.chart;
        if (chart.isTouch && !chart.crosshair.enable && !this.isSelected(chart) && !(this.chart.zoomModule && (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.elementId + "_ZoomArea"))) this.markerMove(true);
    };
    /**
     * Handles the mouse move event.
     *
     * @returns {void}
     * @private
     */ MarkerExplode.prototype.mouseMoveHandler = function() {
        var chart = this.chart;
        if ((chart.highlightMode !== "None" || chart.tooltip.enable) && (!chart.isTouch || chart.startMove) && !this.isSelected(chart) && !(this.chart.zoomModule && (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.elementId + "_ZoomArea"))) this.markerMove(false);
    };
    MarkerExplode.prototype.markerMove = function(remove) {
        var _this = this;
        var chart = this.chart;
        this.currentPoints = [];
        var data;
        var previous;
        var explodeSeries;
        var series;
        if (!chart.tooltip.shared || !chart.tooltip.enable) {
            data = this.getData();
            series = data.series;
            previous = this.previousPoints[0];
            explodeSeries = series && (series.type === "Bubble" || series.drawType === "Scatter" || series.type === "Scatter" || series.type !== "Candle" && series.type !== "Hilo" && series.type !== "HiloOpenClose" && series.marker.visible && series.marker.width !== 0 && series.marker.height !== 0);
            data.lierIndex = this.lierIndex;
            if (data.point && explodeSeries && (!previous || previous.point !== data.point || previous && previous.lierIndex > 3 && previous.lierIndex !== this.lierIndex)) this.currentPoints.push(data);
            if (data.point && explodeSeries && chart.isPointMouseDown) this.currentPoints.push(data);
        } else {
            if (!(0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect)) return null;
            if (chart.tooltip.enable) {
                var pointData = chart.chartAreaType === "PolarRadar" ? this.getData() : null;
                if (!this.chart.tooltip.showNearestPoint) this.currentPoints = this.chart.tooltipModule.currentPoints;
                else for(var _i = 0, _a = chart.visibleSeries; _i < _a.length; _i++){
                    var chartSeries = _a[_i];
                    if (!chartSeries.enableTooltip || chartSeries.category === "Indicator") continue;
                    if (chart.chartAreaType === "Cartesian" && chartSeries.visible) data = this.getClosestX(chart, chartSeries, this.commonXValue(this.chart.visibleSeries));
                    else if (chart.chartAreaType === "PolarRadar" && chartSeries.visible && pointData.point !== null) data = new (0, $11815a21a80ae2b7$export$8b02a874d977053f)(chartSeries.points[pointData.point.index], chartSeries);
                    if (data) {
                        this.currentPoints.push(data);
                        data = null;
                    }
                }
            }
        }
        var length = this.previousPoints.length;
        if (this.currentPoints.length > 0 || length > 0 && chart.tooltip.shared) {
            if (length === 0 || chart.isPointMouseDown || length > 0 && (this.currentPoints.length === 0 || this.previousPoints[0].point !== this.currentPoints[0].point)) {
                if (length > 0) for(var _b = 0, _c = this.previousPoints; _b < _c.length; _b++){
                    var previousPoint = _c[_b];
                    if (!(0, $3EnZW.isNullOrUndefined)(previousPoint)) this.removeHighlightedMarker(previousPoint.series, previousPoint.point);
                }
                var _loop_1 = function(data_1) {
                    if (data_1 && data_1.point || series.type !== "Candle" && series.type !== "Hilo" && series.type !== "HiloOpenClose") {
                        (0, $11815a21a80ae2b7$export$4d41f7386211339a)(this_1.markerExplode);
                        this_1.isRemove = true;
                        data_1.point.symbolLocations.map(function(location, index) {
                            if (data_1.series.marker.allowHighlight && (!data_1.series.isRectSeries || data_1.point.marker.visible)) _this.drawTrackBall(data_1.series, data_1.point, location, index);
                        });
                    }
                };
                var this_1 = this;
                for(var _d = 0, _e = this.currentPoints; _d < _e.length; _d++){
                    var data_1 = _e[_d];
                    _loop_1(data_1);
                }
                this.previousPoints = (0, $3EnZW.extend)([], this.currentPoints, null, true);
            }
        }
        if (!chart.tooltip.enable && (this.currentPoints.length === 0 && this.isRemove || remove && this.isRemove || !(0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect))) {
            this.isRemove = false;
            if (!(0, $3EnZW.isNullOrUndefined)(this.previousPoints[0])) this.markerExplode = +setTimeout(function() {
                if (_this.previousPoints[0]) _this.removeHighlightedMarker(_this.previousPoints[0].series, _this.previousPoints[0].point);
            }, 2000);
        }
        this.currentPoints = [];
    };
    MarkerExplode.prototype.animationDuration = function() {
        var duration = 200;
        if (this.chart.maxPointCount > 100) duration = 10;
        else if (this.chart.maxPointCount > 50) duration = 100;
        return duration;
    };
    MarkerExplode.prototype.drawTrackBall = function(series, point, location, index) {
        var marker = point.marker;
        var seriesMarker = series.marker;
        var shape = marker.shape || seriesMarker.shape || "Circle";
        var svg;
        if (shape === "None" || shape === "Image") return null;
        var element = series.symbolElement || series.seriesElement;
        var className;
        if (this.chart.highlightModule && this.chart.highlightMode !== "None") className = this.chart.highlightModule.generateStyle(series);
        if (this.chart.selectionModule && this.chart.selectionMode !== "None") className = this.chart.selectionModule.generateStyle(series);
        var symbolId = this.elementId + "_Series_" + series.index + "_Point_" + point.index + "_Trackball" + (index ? index : "");
        var size = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)((marker.width || seriesMarker.width) + 3, (marker.height || seriesMarker.height) + 3);
        var border = marker.border || series.border;
        var explodeSeries = series.type === "BoxAndWhisker" || series.type === "Bubble" || series.type === "Scatter";
        var borderColor = border.color && border.color !== "transparent" ? border.color : marker.fill || point.interior || (explodeSeries ? point.color : series.interior);
        var colorValue = (0, $11815a21a80ae2b7$export$41b2247054c0b0ce)((0, $11815a21a80ae2b7$export$71af4efcc3018b59)(borderColor));
        var borderWidth = marker.border ? marker.border.width : seriesMarker.border.width;
        var markerShadow = series.chart.themeStyle.markerShadow || "rgba(" + colorValue.r + "," + colorValue.g + "," + colorValue.b + ",0.2)";
        var markerElement = document.getElementById(this.elementId + "_Series_" + series.index + "_Point_" + point.index + "_Symbol");
        if (!(0, $3EnZW.isNullOrUndefined)(markerElement)) markerElement.setAttribute("visibility", "hidden");
        if (this.chart.enableCanvas) {
            var trackElement = document.getElementById(this.chart.element.id + "_Secondary_Element");
            svg = this.chart.svgRenderer.createSvg({
                id: this.chart.element.id + "_trackball_svg",
                width: this.chart.availableSize.width,
                height: this.chart.availableSize.height
            });
            svg.style.cssText = "position: absolute; display:block; pointer-events: none";
            trackElement.appendChild(svg);
        }
        for(var i = 0; i < 2; i++){
            var options = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(symbolId + "_" + i, i ? marker.fill || point.color || (explodeSeries ? series.interior : "#ffffff") : "transparent", borderWidth + (i ? 0 : 8), i ? borderColor : markerShadow, marker.opacity || seriesMarker.opacity, series.marker.border.dashArray, "");
            var symbol = (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)(location, shape, size, marker.imageUrl, options, "", this.chart.svgRenderer, series.clipRect);
            // incident: 252450 point click selection not working while maker explode
            //symbol.setAttribute('style', 'pointer-events:none');
            symbol.setAttribute("class", this.elementId + "_EJ2-Trackball_Series_" + series.index + "_Point_" + point.index);
            var selectionId = element.id.indexOf("Symbol") !== -1 ? "_Symbol" : "";
            var seletionElem = document.getElementById(this.elementId + "_Series_" + series.index + "_Point_" + point.index + selectionId);
            if (className !== "" && !(0, $3EnZW.isNullOrUndefined)(className) && !(0, $3EnZW.isNullOrUndefined)(seletionElem) && seletionElem.hasAttribute("class") && className === seletionElem.getAttribute("class")) symbol.classList.add(className);
            symbol.setAttribute("clip-path", element.getAttribute("clip-path"));
            symbol.setAttribute("transform", element.getAttribute("transform"));
            if (this.chart.enableCanvas) svg.appendChild(symbol);
            else this.chart.svgObject.appendChild(symbol);
        }
        this.doAnimation(series, point, false);
    };
    /**
     * Perform animation for the series.
     *
     * @param {Series} series - The series to animate.
     * @param {Points} point - The point to animate.
     * @param {boolean} [endAnimate=false] - Flag to indicate if the animation is ending.
     * @returns {void}
     * @private
     */ MarkerExplode.prototype.doAnimation = function(series, point, endAnimate) {
        if (endAnimate === void 0) endAnimate = false;
        var duration = this.animationDuration();
        var delay = 0;
        var rectElements = document.getElementsByClassName(this.elementId + "_EJ2-Trackball_Series_" + series.index + "_Point_" + point.index);
        for(var i = 0, len = rectElements.length; i < len; i++)this.trackballAnimate(rectElements[i], delay, duration, series, point.index, point.symbolLocations[0], false, endAnimate);
    };
    /**
     * Perform animation for the trackball.
     *
     * @param {Element} elements - The elements to animate.
     * @param {number} delays - The delay duration for the animation.
     * @param {number} durations - The duration of the animation.
     * @param {Series} series - The series associated with the trackball.
     * @param {number} pointIndex - The index of the point to animate.
     * @param {ChartLocation} point - The location of the point to animate.
     * @param {boolean} isLabel - Flag to indicate if the animated element is a label.
     * @param {boolean} [endAnimate=false] - Flag to indicate if the animation is ending.
     * @returns {void}
     * @private
     */ MarkerExplode.prototype.trackballAnimate = function(elements, delays, durations, series, pointIndex, point, isLabel, endAnimate) {
        var centerX = point.x;
        var centerY = point.y;
        var clipX = series.type !== "Polar" && series.type !== "Radar" ? series.clipRect.x : 0;
        var clipY = series.type !== "Polar" && series.type !== "Radar" ? series.clipRect.y : 0;
        // let height: number = 0;
        //(<HTMLElement>elements).style.visibility = 'hidden';
        var transform = elements.getAttribute("transform");
        new (0, $kj1BR.Animation)({}).animate(elements, {
            duration: durations,
            delay: delays,
            progress: function(args) {
                if (args.timeStamp > args.delay) {
                    args.element.style.visibility = "visible";
                    // height = ((args.timeStamp - args.delay) / args.duration);
                    elements.setAttribute("transform", "translate(" + (centerX + clipX) + " " + (centerY + clipY) + ") scale(1) translate(" + -centerX + " " + -centerY + ")");
                }
            },
            end: function() {
                elements.style.visibility = "";
                elements.setAttribute("transform", transform);
                if (!isLabel && pointIndex === series.points.length - 1) series.chart.trigger("animationComplete", {
                    series: series.chart.isBlazor ? {} : series
                });
                if (endAnimate) (0, $4ZDHT.remove)(elements);
            }
        });
    };
    /**
     * Remove the highlighted marker.
     *
     * @param {Series} [series=null] - The series associated with the marker to remove. Defaults to null.
     * @param {Points} [point=null] - The point associated with the marker to remove. Defaults to null.
     * @param {boolean} [fadeOut=false] - Flag to indicate if the removal should be faded out. Defaults to false.
     * @returns {void}
     * @private
     */ MarkerExplode.prototype.removeHighlightedMarker = function(series, point, fadeOut) {
        if (series === void 0) series = null;
        if (point === void 0) point = null;
        if (fadeOut === void 0) fadeOut = false;
        if (!(0, $3EnZW.isNullOrUndefined)(series) && !(0, $3EnZW.isNullOrUndefined)(point)) {
            var markerElement = document.getElementById(this.elementId + "_Series_" + series.index + "_Point_" + point.index + "_Symbol");
            var trackballElements = document.getElementsByClassName(this.elementId + "_EJ2-Trackball_Series_" + series.index + "_Point_" + point.index);
            if (trackballElements.length === 0) {
                var elements = document.querySelectorAll('[class*="' + (this.elementId + "_EJ2-Trackball_Series_" + series.index + "_Point_" + point.index) + '"]');
                if (elements[1]) elements[1].remove();
                if (elements[0]) elements[0].remove();
            }
            for(var i = 0, len = trackballElements.length; i < len; i++)(0, $4ZDHT.remove)(trackballElements[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(markerElement)) markerElement.setAttribute("visibility", "visible");
        } else for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var point_1 = _a[_i];
            var elements = document.getElementsByClassName(this.elementId + "_EJ2-Trackball_Series_" + series.index + "_Point_" + point_1.index);
            var markerElement = document.getElementById(this.elementId + "_Series_" + series.index + "_Point_" + point_1.index + "_Symbol");
            for(var i = 0, len = elements.length; i < len; i++){
                if (!(0, $3EnZW.isNullOrUndefined)(markerElement)) markerElement.setAttribute("visibility", "visible");
                (0, $4ZDHT.remove)(elements[0]);
            }
        }
        if (fadeOut) this.previousPoints = [];
    };
    return MarkerExplode;
}((0, $05077795990f958e$export$c23acf85d5f173c3));


var $c2211974543f8fbf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c2211974543f8fbf$export$eb57c60e13745871 = [
    "Circle",
    "Triangle",
    "Diamond",
    "Rectangle",
    "Pentagon",
    "InvertedTriangle",
    "VerticalLine",
    "Cross",
    "Plus",
    "HorizontalLine",
    "Star"
];
/**
 * The `Marker` module is used to render markers for line-type series.
 */ var $c2211974543f8fbf$export$e98856a975cab58e = /** @class */ function(_super) {
    $c2211974543f8fbf$var$__extends(Marker, _super);
    /**
     * Constructor for the marker module.
     *
     * @private
     */ function Marker(chart) {
        var _this = _super.call(this, chart) || this;
        _this.addEventListener();
        return _this;
    }
    /**
     * Render the marker for series.
     *
     * @returns {void}
     * @private
     */ Marker.prototype.render = function(series) {
        var _this = this;
        var redraw = series.chart.redraw;
        this.createElement(series, redraw);
        var _loop_1 = function(point) {
            if (point.visible && point.symbolLocations && point.symbolLocations.length) point.symbolLocations.map(function(location, index) {
                if (series.marker.shape !== "None") _this.renderMarker(series, point, location, index, redraw);
            });
        };
        for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var point = _a[_i];
            _loop_1(point);
        }
    };
    Marker.prototype.renderMarker = function(series, point, location, index, redraw) {
        var seriesIndex = series.index === undefined ? series.category : series.index;
        var marker = series.marker;
        series.marker.shape = series.marker.shape ? series.marker.shape : $c2211974543f8fbf$export$eb57c60e13745871[seriesIndex % 10];
        var border = {
            color: marker.border.color,
            width: marker.border.width
        };
        var borderColor = marker.border.color;
        var previousLocation;
        var previousPath;
        var circlePath;
        var shapeOption;
        location.x = location.x + marker.offset.x;
        location.y = location.y - marker.offset.y;
        var isBoxPlot = series.type === "BoxAndWhisker";
        var fill = marker.fill || (isBoxPlot || series.marker.isFilled ? point.interior || series.interior : "#ffffff");
        var markerElement;
        var parentElement = isBoxPlot && !this.chart.enableCanvas ? (0, $11815a21a80ae2b7$export$ab9141129abf58a5)(series.seriesElement.childNodes, "Series_" + series.index + "_Point_" + point.index) : series.symbolElement;
        border.color = borderColor || series.setPointColor(point, series.interior);
        var symbolId = this.elementId + "_Series_" + seriesIndex + "_Point_" + (series.removedPointIndex !== null && series.removedPointIndex <= point.index || this.chart.pointsAdded ? point.index + 1 : point.index) + "_Symbol" + (index ? index : "");
        var argsData = {
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$9f10d5daf06d56ca),
            series: series,
            point: point,
            fill: point.isEmpty ? series.emptyPointSettings.fill || fill : fill,
            border: {
                color: series.type === "BoxAndWhisker" ? !(0, $3EnZW.isNullOrUndefined)(borderColor) && borderColor !== "transparent" ? borderColor : (0, $11815a21a80ae2b7$export$9e452847ef3efd94)(fill, -0.6) : border.color,
                width: border.width
            },
            height: marker.height,
            width: marker.width,
            shape: marker.shape
        };
        argsData.border = series.setBorderColor(point, {
            width: argsData.border.width,
            color: argsData.border.color
        });
        if (!series.isRectSeries || series.type === "BoxAndWhisker") {
            this.chart.trigger((0, $9415fc5f023d8fac$export$9f10d5daf06d56ca), argsData);
            point.color = argsData.fill;
        }
        point.color = argsData.fill;
        if (!argsData.cancel) {
            var y = void 0;
            if (series.type === "RangeArea" || series.type === "RangeColumn" || series.drawType === "RangeColumn" || series.type === "SplineRangeArea" || series.type === "RangeStepArea") y = index ? point.low : point.high;
            else if (isBoxPlot) y = point.outliers[index];
            else y = point.y;
            var markerFill = argsData.point.marker.fill || argsData.fill;
            var markerBorder = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(argsData.point.marker.border)) markerBorder = {
                color: argsData.point.marker.border.color || argsData.border.color,
                width: argsData.point.marker.border.width || argsData.border.width
            };
            else markerBorder = {
                color: argsData.border.color,
                width: argsData.border.width
            };
            var markerWidth = argsData.point.marker.width || argsData.width;
            var markerHeight = argsData.point.marker.height || argsData.height;
            var markerOpacity = argsData.point.marker.opacity || marker.opacity;
            var markerShape = argsData.point.marker.shape || argsData.shape;
            var imageURL = argsData.point.marker.imageUrl || marker.imageUrl;
            shapeOption = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(symbolId, markerFill, markerBorder.width, markerBorder.color, markerOpacity, series.marker.border.dashArray);
            if (parentElement !== undefined && parentElement !== null || this.chart.enableCanvas) {
                if (redraw && (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(shapeOption.id)) {
                    markerElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(shapeOption.id);
                    circlePath = markerShape === "Circle" ? "c" : "";
                    previousLocation = {
                        x: +markerElement.getAttribute(circlePath + "x"),
                        y: +markerElement.getAttribute(circlePath + "y")
                    };
                    previousPath = markerElement.getAttribute("d");
                }
                markerElement = (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)(location, markerShape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(markerWidth, markerHeight), imageURL, shapeOption, point.x.toString() + ":" + y.toString(), this.chart.renderer, series.clipRect);
                if (markerElement) {
                    markerElement.setAttribute("role", "img");
                    markerElement.setAttribute("aria-label", point.x + ": " + point.y + ", " + series.name);
                }
                (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.chart.enableCanvas, parentElement, markerElement, redraw, true, circlePath + "x", circlePath + "y", previousLocation, previousPath, false, false, null, series.chart.duration);
                if (series.removedPointIndex !== null && series.removedPointIndex <= point.index) parentElement.lastChild.id = this.elementId + "_Series_" + seriesIndex + "_Point_" + point.index + "_Symbol" + (index ? index : "");
            }
            point.marker = {
                border: markerBorder,
                fill: markerFill,
                height: markerHeight,
                visible: true,
                shape: markerShape,
                width: markerWidth,
                imageUrl: imageURL
            };
        } else {
            location = null;
            point.marker = {
                visible: false
            };
        }
    };
    Marker.prototype.createElement = function(series, redraw) {
        var markerClipRect;
        var marker = series.marker;
        // 8 for extend border value 5 for extend size value
        var explodeValue = marker.border.width + 8 + 5;
        var render = series.chart.svgRenderer;
        var index = series.index === undefined ? series.category : series.index;
        var options;
        var transform = series.chart.chartAreaType === "Cartesian" ? "translate(" + series.clipRect.x + "," + series.clipRect.y + ")" : "";
        if (marker.visible) {
            var markerHeight = (marker.height + explodeValue) / 2;
            var markerWidth = (marker.width + explodeValue) / 2;
            if (series.chart.chartAreaType === "Cartesian") {
                options = new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(this.elementId + "_ChartMarkerClipRect_" + index, "transparent", {
                    width: 1,
                    color: "Gray"
                }, 1, {
                    x: -markerWidth,
                    y: -markerHeight,
                    width: series.clipRect.width + markerWidth * 2,
                    height: series.clipRect.height + markerHeight * 2
                }, 0, 0, "", series.marker.border.dashArray);
                markerClipRect = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(redraw, options, render);
            } else {
                options = new (0, $11815a21a80ae2b7$export$abcc25cb43492e33)(this.elementId + "_ChartMarkerClipRect_" + index, "transparent", {
                    width: 1,
                    color: "Gray"
                }, 1, series.clipRect.width / 2 + series.clipRect.x, series.clipRect.height / 2 + series.clipRect.y, series.chart.radius + Math.max(markerHeight, markerWidth));
                markerClipRect = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(redraw, options, render, "drawCircularClipPath");
            }
            options = {
                "id": this.elementId + "SymbolGroup" + index,
                "transform": transform,
                "clip-path": "url(#" + this.elementId + "_ChartMarkerClipRect_" + index + ")"
            };
            series.symbolElement = render.createGroup(options);
            series.symbolElement.appendChild(markerClipRect);
            if (this.chart.enableCanvas) {
                var element = document.getElementById(this.chart.element.id + "_tooltip_svg");
                element.appendChild(series.symbolElement);
            }
        }
    };
    Marker.prototype.getRangeLowPoint = function(region, series) {
        var x = region.x;
        var y = region.y;
        if (series.chart.requireInvertedAxis) {
            y += region.height / 2;
            x += series.yAxis.isAxisInverse ? region.width : 0;
        } else {
            y += series.yAxis.isAxisInverse ? 0 : region.height;
            x += region.width / 2;
        }
        return {
            x: x,
            y: y
        };
    };
    /**
     * Calculates the distance between two points in a chart.
     *
     * @param {ChartLocation} startPoint - The starting point with x and y coordinates.
     * @param {ChartLocation} endPoint - The ending point with x and y coordinates.
     * @returns {number} - The distance between the startPoint and endPoint.
     */ Marker.prototype.calculateDistance = function(startPoint, endPoint) {
        var dx = endPoint.x - startPoint.x;
        var dy = endPoint.y - startPoint.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    /**
     * Perform marker animation for the given series.
     *
     * @param {Series} series - The series for which marker animation needs to be performed.
     * @returns {void}
     * @private
     */ Marker.prototype.doMarkerAnimation = function(series) {
        if (!(series.type === "Scatter" || series.type === "Bubble" || series.type === "Candle" || series.type === "Hilo" || series.type === "HiloOpenClose" || series.chart.chartAreaType === "PolarRadar" && series.drawType === "Scatter")) {
            var markerElements = series.symbolElement.childNodes;
            var delay = series.animation.delay + (series.animation.duration === 0 && (0, $kj1BR.animationMode) === "Enable" ? 1000 : series.animation.duration);
            var duration = series.chart.animated ? series.chart.duration : 200;
            var markerDelay = delay;
            var pathLength = series.pathElement ? series.pathElement.getTotalLength() : 0;
            var distances = [];
            for(var i = 1; series.type === "Line" && i < series.points.length; i++)if (series.points[i - 1].symbolLocations[0] && series.points[i].symbolLocations[0]) {
                var distance = this.calculateDistance(series.points[i - 1].symbolLocations[0], series.points[i].symbolLocations[0]);
                distances.push(distance);
            }
            var j = 1;
            var incFactor = series.type === "RangeArea" || series.type === "RangeColumn" || series.type === "SplineRangeArea" || series.type === "RangeStepArea" ? 2 : 1;
            for(var i = 0; i < series.points.length; i++)if (series.points[i].symbolLocations) {
                if (!series.points[i].symbolLocations.length || !markerElements[j]) continue;
                if (series.type === "Line") {
                    if (i === 0) markerDelay = 0;
                    if (i > 0) {
                        markerDelay += distances[i - 1] / pathLength * delay;
                        duration = 0;
                    }
                }
                (0, $11815a21a80ae2b7$export$9546e7ee31d90feb)(markerElements[j], markerDelay, duration, series, i, series.points[i].symbolLocations[0], false);
                if (incFactor === 2) {
                    var lowPoint = this.getRangeLowPoint(series.points[i].regions[0], series);
                    (0, $11815a21a80ae2b7$export$9546e7ee31d90feb)(markerElements[j + 1], markerDelay, duration, series, i, lowPoint, false);
                }
                j += incFactor;
            }
        }
    };
    return Marker;
}((0, $14cdfd9e1cbe3bae$export$896c5e81720b190d));


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");



var $1edae0c111fe0a45$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1edae0c111fe0a45$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the appearance and behavior of legends in charts.
 */ var $1edae0c111fe0a45$export$4096e946a56437be = /** @class */ function(_super) {
    $1edae0c111fe0a45$var$__extends(LegendSettings, _super);
    function LegendSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], LegendSettings.prototype, "visible", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "height", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "width", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({
            x: 0,
            y: 0
        }, (0, $2ae44f835da15a47$export$18a2be9195644f38))
    ], LegendSettings.prototype, "location", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], LegendSettings.prototype, "position", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Series")
    ], LegendSettings.prototype, "mode", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(8)
    ], LegendSettings.prototype, "padding", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "itemPadding", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Center")
    ], LegendSettings.prototype, "alignment", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], LegendSettings.prototype, "textStyle", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], LegendSettings.prototype, "shapeHeight", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], LegendSettings.prototype, "shapeWidth", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], LegendSettings.prototype, "border", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, (0, $2ae44f835da15a47$export$e717bcf55e1dfb40))
    ], LegendSettings.prototype, "margin", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, (0, $2ae44f835da15a47$export$be26d33269c1ea81))
    ], LegendSettings.prototype, "containerPadding", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(8)
    ], LegendSettings.prototype, "shapePadding", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("transparent")
    ], LegendSettings.prototype, "background", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], LegendSettings.prototype, "opacity", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], LegendSettings.prototype, "toggleVisibility", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LegendSettings.prototype, "enableHighlight", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "description", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], LegendSettings.prototype, "tabIndex", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "title", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$89abf52a030e56ee))
    ], LegendSettings.prototype, "titleStyle", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Top")
    ], LegendSettings.prototype, "titlePosition", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Normal")
    ], LegendSettings.prototype, "textWrap", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)("Ellipsis")
    ], LegendSettings.prototype, "textOverflow", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(100)
    ], LegendSettings.prototype, "maximumTitleWidth", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LegendSettings.prototype, "maximumLabelWidth", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], LegendSettings.prototype, "enablePages", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LegendSettings.prototype, "isInversed", void 0);
    $1edae0c111fe0a45$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LegendSettings.prototype, "reverse", void 0);
    return LegendSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Legend base class for Chart and Accumulation chart.
 *
 * @private
 */ var $1edae0c111fe0a45$export$7be7d9bc933b30ca = /** @class */ function() {
    /**
     * Constructor for the dateTime module.
     *
     * @private
     */ function BaseLegend(chart) {
        this.maxItemHeight = 0;
        this.rowHeights = [];
        this.pageHeights = [];
        this.columnHeights = [];
        this.pageXCollections = []; // pages of x locations
        this.chartRowCount = 1;
        this.legendTitleCollections = [];
        this.legendRegions = [];
        this.pagingRegions = [];
        this.chart = chart;
        this.legend = chart.legendSettings;
        this.legendID = chart.element.id + "_chart_legend";
        this.isChartControl = chart.getModuleName() === "chart" || chart.getModuleName() === "chart3d";
        this.isAccChartControl = chart.getModuleName() === "accumulationchart" || chart.getModuleName() === "circularchart3d";
        this.isBulletChartControl = chart.getModuleName() === "bulletChart";
        this.isStockChartControl = chart.getModuleName() === "stockChart";
        this.bulletChart = this.chart;
        this.fivePixel = 5;
        this.rowCount = 0;
        this.pageButtonSize = 8;
        this.maxColumns = 0;
        this.maxWidth = 0;
        this.currentPage = 1;
        this.backwardArrowOpacity = 0;
        this.forwardArrowOpacity = 1;
        this.arrowWidth = 2 * (this.fivePixel + this.pageButtonSize + this.fivePixel);
        this.arrowHeight = this.arrowWidth;
        this.isTop = false;
        this.isTitle = false;
        this.currentPageNumber = 1;
    }
    /**
     * Calculate the bounds for the legends.
     *
     * @returns {void}
     * @private
     */ BaseLegend.prototype.calculateLegendBounds = function(rect, availableSize, maxLabelSize, previousLegendBounds, pointAnimation) {
        var legend = this.legend;
        var defaultValue = this.isBulletChartControl ? "40%" : "20%";
        this.getPosition(legend.position, availableSize);
        this.legendBounds = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x, rect.y, 0, 0);
        this.isVertical = this.position === "Left" || this.position === "Right";
        this.itemPadding = this.legend.itemPadding ? this.legend.itemPadding : this.isVertical ? this.legend.padding : 20;
        if (this.isVertical) {
            this.legendBounds.height = (0, $11815a21a80ae2b7$export$391a4509611a1b09)(legend.height, availableSize.height - (rect.y - this.chart.margin.top)) || rect.height;
            this.legendBounds.width = (0, $11815a21a80ae2b7$export$391a4509611a1b09)(legend.width || defaultValue, availableSize.width);
        } else {
            this.legendBounds.width = (0, $11815a21a80ae2b7$export$391a4509611a1b09)(legend.width, availableSize.width) || rect.width;
            this.legendBounds.height = (0, $11815a21a80ae2b7$export$391a4509611a1b09)(legend.height || defaultValue, availableSize.height);
        }
        if (this.chart.getModuleName() === "chart3d") this.library.get3DLegendBounds(availableSize, this.legendBounds, legend);
        else this.library.getLegendBounds(availableSize, this.legendBounds, legend);
        if (!this.isBulletChartControl) {
            this.legendBounds.width += this.legend.containerPadding.left + this.legend.containerPadding.right;
            this.legendBounds.height += this.legend.containerPadding.top + this.legend.containerPadding.bottom;
        }
        this.getLocation(this.position, legend.alignment, this.legendBounds, rect, availableSize, maxLabelSize, previousLegendBounds, pointAnimation);
    };
    /**
     * To find legend position based on available size for chart and accumulation chart
     *
     * @param position
     * @param availableSize
     * @param position
     * @param availableSize
     * @returns {void}
     */ BaseLegend.prototype.getPosition = function(position, availableSize) {
        var chart = this.chart;
        var accumulation = this.chart;
        if (this.isChartControl || this.isBulletChartControl || this.isStockChartControl) this.position = position !== "Auto" ? position : "Bottom";
        else {
            if (position === "Auto" && ((chart || accumulation).visibleSeries && (chart || accumulation).visibleSeries[0].type === "Funnel" || (chart || accumulation).visibleSeries[0].type === "Pyramid")) position = "Top";
            this.position = position !== "Auto" ? position : availableSize.width > availableSize.height ? "Right" : "Bottom";
        }
    };
    /**
     * To set bounds for chart and accumulation chart
     *
     * @param computedWidth
     * @param computedHeight
     * @param legend
     * @param legendBounds
     * @param computedWidth
     * @param computedHeight
     * @param legend
     * @param legendBounds
     * @param computedWidth
     * @param computedHeight
     * @param legend
     * @param legendBounds
     * @param computedWidth
     * @param computedHeight
     * @param legend
     * @param legendBounds
     * @returns {void}
     */ BaseLegend.prototype.setBounds = function(computedWidth, computedHeight, legend, legendBounds) {
        var titleHeight = legend.title && legend.titlePosition === "Top" ? this.legendTitleSize.height + this.fivePixel : 0;
        if (this.isVertical && this.isPaging && !legend.enablePages && !this.isBulletChartControl) {
            titleHeight = legend.title && legend.titlePosition === "Top" ? this.legendTitleSize.height + this.fivePixel : 0;
            titleHeight += this.pageButtonSize + this.fivePixel;
        }
        computedWidth = Math.min(computedWidth, legendBounds.width);
        computedHeight = Math.min(computedHeight, legendBounds.height);
        if (legend.mode === "Gradient") {
            legendBounds.width = legend.width ? legendBounds.width : this.isVertical ? computedWidth : 0.75 * legendBounds.width;
            legendBounds.height = legend.height ? legendBounds.height : this.isVertical ? 0.75 * legendBounds.height : computedHeight;
        } else {
            legendBounds.width = !legend.width ? computedWidth : legendBounds.width;
            legendBounds.height = !legend.height ? computedHeight : legendBounds.height;
        }
        if (!this.isBulletChartControl) {
            if (this.isTop && legend.titleStyle.textOverflow !== "None") {
                this.calculateLegendTitle(legend, legendBounds);
                legendBounds.height += legend.titleStyle.textOverflow === "Wrap" && this.legendTitleCollections.length > 1 ? this.legendTitleSize.height - this.legendTitleSize.height / this.legendTitleCollections.length : 0;
            }
        }
        this.rowCount = Math.max(1, Math.ceil((legendBounds.height - legend.padding - titleHeight) / (this.maxItemHeight + legend.padding)));
    };
    /**
     * To find legend location based on position, alignment for chart and accumulation chart
     *
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     * @param position
     * @param alignment
     * @param legendBounds
     * @param rect
     * @param availableSize
     * @param maxLabelSize
     */ BaseLegend.prototype.getLocation = function(position, alignment, legendBounds, rect, availableSize, maxLabelSize, previousLegendBounds, pointAnimation) {
        var padding = this.legend.border.width;
        var isBulletChart = this.isBulletChartControl;
        var bulletChart = this.bulletChart;
        var labelIns = bulletChart.labelPosition === "Inside";
        var ticklIns = bulletChart.tickPosition === "Inside";
        var isVertical = bulletChart.orientation === "Vertical";
        var categoryFieldValue = isBulletChart && bulletChart.categoryField !== "" ? maxLabelSize.width + this.chart.border.width + padding * 3 : 0;
        var marginBottom = this.chart.margin.bottom;
        var legendHeight = legendBounds.height + padding + this.legend.margin.top + this.legend.margin.bottom;
        var legendWidth = legendBounds.width + padding + this.legend.margin.left + this.legend.margin.right;
        if (position === "Bottom") {
            legendBounds.x = this.alignLegend(legendBounds.x, availableSize.width, legendBounds.width, alignment);
            legendBounds.y = previousLegendBounds && (legendBounds.height === previousLegendBounds.height || this.chart.series[0].type !== "Pie") ? previousLegendBounds.y : rect.y + (rect.height - legendHeight) + padding + this.legend.margin.top;
            legendBounds.y += isBulletChart && !bulletChart.opposedPosition && !labelIns && !ticklIns && !isVertical ? bulletChart.majorTickLines.height + marginBottom + this.legend.border.width + padding * 2 : isVertical && bulletChart.categoryField !== "" ? maxLabelSize.height + padding * 2 : 0;
            if (!pointAnimation || legendBounds.height !== previousLegendBounds.height) (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(rect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, 0, 0, legendHeight));
        } else if (position === "Top") {
            var axisTextSize = void 0;
            if (this.isChartControl) axisTextSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)("100", this.chart.verticalAxes[0].labelStyle, this.chart.themeStyle.legendLabelFont);
            legendBounds.x = this.alignLegend(legendBounds.x, availableSize.width, legendBounds.width, alignment);
            legendBounds.y = previousLegendBounds && (legendBounds.height === previousLegendBounds.height || this.chart.series[0].type !== "Pie") ? previousLegendBounds.y : rect.y + padding + this.legend.margin.top;
            legendBounds.y -= isBulletChart && bulletChart.opposedPosition && !labelIns && !ticklIns && !isVertical ? bulletChart.majorTickLines.height + this.chart.margin.top : 0;
            legendHeight -= isBulletChart ? -padding * 2 : this.isChartControl ? -padding * 2 - axisTextSize.height / 2 : 0;
            if (!pointAnimation || legendBounds.height !== previousLegendBounds.height) (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(rect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, 0, legendHeight, 0));
        } else if (position === "Right") {
            legendBounds.x = previousLegendBounds && (legendBounds.width === previousLegendBounds.width || this.chart.series[0].type !== "Pie") ? previousLegendBounds.x : rect.x + (rect.width - legendBounds.width) - this.legend.margin.right;
            legendBounds.y = rect.y + this.alignLegend(0, availableSize.height - (rect.y + marginBottom), legendBounds.height, alignment);
            legendWidth += isBulletChart && bulletChart.opposedPosition && !labelIns && !ticklIns && isVertical ? this.chart.margin.left + this.chart.margin.right + bulletChart.majorTickLines.height : 0;
            if (!pointAnimation || legendBounds.width !== previousLegendBounds.width) (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(rect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, legendWidth, 0, 0));
        } else if (position === "Left") {
            legendBounds.x = previousLegendBounds && (legendBounds.width === previousLegendBounds.width || this.chart.series[0].type !== "Pie") ? previousLegendBounds.x : legendBounds.x + this.legend.margin.left;
            legendBounds.y = rect.y + this.alignLegend(0, availableSize.height - (rect.y + marginBottom), legendBounds.height, alignment);
            legendWidth += isBulletChart && !bulletChart.opposedPosition && !labelIns && !ticklIns && isVertical ? legendBounds.x - this.chart.margin.left + padding + bulletChart.majorTickLines.height : bulletChart.orientation !== "Vertical" && bulletChart.categoryField !== "" ? categoryFieldValue : 0;
            if (!pointAnimation || legendBounds.width !== previousLegendBounds.width) (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(rect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(legendWidth, 0, 0, 0));
        } else {
            legendBounds.x = this.legend.location.x;
            legendBounds.y = this.legend.location.y;
            (0, $11815a21a80ae2b7$export$5c988984aa8de60d)(rect, new (0, $11815a21a80ae2b7$export$2bc8736e5a9baa90)(0, 0, 0, 0));
        }
    };
    /**
     * To find legend alignment for chart and accumulation chart
     *
     * @param start
     * @param size
     * @param legendSize
     * @param alignment
     * @param start
     * @param size
     * @param legendSize
     * @param alignment
     * @param start
     * @param size
     * @param legendSize
     * @param alignment
     * @param start
     * @param size
     * @param legendSize
     * @param alignment
     */ BaseLegend.prototype.alignLegend = function(start, size, legendSize, alignment) {
        switch(alignment){
            case "Far":
                start = size - legendSize - start;
                break;
            case "Center":
                start = (size - legendSize) / 2;
                break;
        }
        return start;
    };
    /**
     * Renders the legend.
     *
     * @param chart
     * @param legend
     * @param legendBounds
     * @param redraw
     * @param chart
     * @param legend
     * @param legendBounds
     * @param redraw
     * @param chart
     * @param legend
     * @param legendBounds
     * @param redraw
     * @param chart
     * @param legend
     * @param legendBounds
     * @param redraw
     * @returns {void}
     * @private
     */ BaseLegend.prototype.renderLegend = function(chart, legend, legendBounds, redraw, pointAnimation) {
        var titleHeight = 0;
        var titlePlusArrowWidth = 0;
        var pagingLegendBounds = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0);
        var requireLegendBounds = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0);
        var xValue;
        var yValue;
        if (pointAnimation) {
            xValue = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.legendID + "_element").getAttribute("x");
            yValue = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.legendID + "_element").getAttribute("y");
        }
        var firstLegend = this.findFirstLegendPosition(this.legendCollections);
        var padding = legend.padding;
        this.itemPadding = this.isBulletChartControl ? legend.padding : this.itemPadding;
        var isPaging = legend.enablePages;
        var titlePosition = legend.titlePosition;
        var upArrowHeight = this.isPaging && !legend.enablePages && this.isVertical ? this.pageButtonSize : 0;
        var legendGroup = chart.renderer.createGroup({
            id: this.legendID + "_g"
        });
        var legendTranslateGroup = this.createLegendElements(chart, legendBounds, legendGroup, legend, this.legendID, redraw);
        this.legendRegions = [];
        this.chartRowCount = 1;
        var maxHeight = 0;
        titleHeight = !this.isTitle ? 0 : this.isTop || this.isVertical ? this.legendTitleSize.height : 0;
        if (this.isChartControl || this.isAccChartControl && !this.isVertical) {
            var pageCount = 1;
            var rowHeights = this.rowHeights[0] + padding;
            for(var i = 1; i < this.rowHeights.length; i++){
                if (rowHeights + this.rowHeights[i] + padding > this.legendBounds.height - this.pageButtonSize - this.maxItemHeight / 2) {
                    this.pageHeights[pageCount - 1] = rowHeights + titleHeight;
                    pageCount++;
                    rowHeights = 0;
                }
                rowHeights += this.rowHeights[i] + (this.isVertical ? this.itemPadding : padding);
            }
            this.pageHeights[pageCount - 1] = rowHeights + titleHeight;
            this.totalPages = pageCount;
        }
        for(var i = 0; i < this.legendCollections.length; i++){
            if (this.legendCollections[i].text !== "") {
                maxHeight = Math.max(this.legendCollections[i].textSize.height, maxHeight);
                break;
            } else continue;
        }
        if (!this.isChartControl && !this.isAccChartControl) this.maxItemHeight = Math.max(maxHeight, legend.shapeHeight);
        // For new legend navigation
        if (!isPaging && this.isPaging && !this.isVertical) {
            titlePlusArrowWidth = !this.isTitle ? 0 : titlePosition === "Left" ? this.legendTitleSize.width : 0;
            titlePlusArrowWidth += this.pageButtonSize + 2 * this.fivePixel;
        } else if (this.isTitle && !this.isPaging && !this.isVertical) titlePlusArrowWidth = titlePosition === (!this.isRtlEnable ? "Left" : "Right") ? this.fivePixel + this.legendTitleSize.width : 0;
        if (chart.legendSettings.mode === "Gradient" && this.legendCollections.length > 1) {
            this.getLinearLegend(legendBounds, chart, legend, legendTranslateGroup);
            this.totalPages = 1;
        } else if (firstLegend !== this.legendCollections.length) {
            var legendSeriesGroup = void 0; // legendItem group for each series group element
            var count = 0;
            var previousLegend = this.legendCollections[firstLegend];
            // starting shape center x,y position && to resolve lint error used new line for declaration
            var startPadding = this.isBulletChartControl ? padding : titlePlusArrowWidth + padding + legend.shapeWidth / 2 + legend.containerPadding.left;
            var xLocation = this.isBulletChartControl && !this.isRtlEnable ? legendBounds.x + titlePlusArrowWidth + padding + legend.shapeWidth / 2 : !this.isRtlEnable ? legendBounds.x + startPadding : legendBounds.x + (this.chart.getModuleName() === "accumulationchart" && this.isVertical ? this.maxWidth : legendBounds.width) - startPadding;
            var start = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(xLocation, this.isBulletChartControl ? legendBounds.y + titleHeight + upArrowHeight + padding + this.maxItemHeight / 2 : legendBounds.y + titleHeight + upArrowHeight + padding + this.maxItemHeight / 2 + legend.containerPadding.top);
            var anchor = chart.isRtlEnabled || chart.enableRtl ? "end" : "start";
            var textOptions = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)("", start.x, start.y, anchor);
            var textPadding = legend.shapePadding + this.itemPadding + legend.shapeWidth;
            //  initialization for totalPages legend click totalpage again calculate
            this.totalPages = this.totalPages = this.isAccChartControl || this.isChartControl || this.isBulletChartControl || this.isStockChartControl ? this.totalPages : 0;
            this.pageXCollections = [];
            this.legendCollections[firstLegend].location = start;
            var legendIndex = void 0;
            if (!legend.enablePages && this.isPaging) {
                var x = start.x - this.fivePixel;
                var y = start.y - this.fivePixel;
                var leftSpace = this.isTitle && !this.isVertical && titlePosition === "Left" ? this.legendTitleSize.width + this.fivePixel : 0;
                var bottomSapce = this.isVertical ? this.pageButtonSize + Math.abs(y - legendBounds.y) : 0;
                var rightSpace = this.isTitle && !this.isVertical && titlePosition === "Right" ? this.legendTitleSize.width + this.fivePixel : 0;
                rightSpace += this.isVertical ? 0 : this.fivePixel + this.pageButtonSize + this.fivePixel;
                pagingLegendBounds = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(x, y, legendBounds.width - rightSpace - leftSpace, legendBounds.height - bottomSapce);
                requireLegendBounds = pagingLegendBounds;
            } else requireLegendBounds = legendBounds;
            var legendOption = void 0;
            for(var i = 0; i < this.legendCollections.length; i++){
                legendOption = this.legendCollections[i];
                legendIndex = !this.isReverse ? count : this.legendCollections.length - 1 - count;
                if (this.chart.getModuleName() === "accumulationchart") legendOption.fill = (this.chart || this.chart || this.chart || this.chart).visibleSeries[0].points[legendOption.pointIndex].color;
                if (this.chart.getModuleName() === "stockChart") legendOption.type = this.chart.visibleSeries[count].type;
                this.accessbilityText = this.isBulletChartControl ? "Legend of bullet chart" + legendOption.text : "Click to show or hide the " + legendOption.text + " series";
                if (legendOption.render && legendOption.text && legendOption.text !== "") {
                    legendSeriesGroup = chart.renderer.createGroup({
                        id: this.legendID + this.generateId(legendOption, "_g_", legendIndex)
                    });
                    if (legendSeriesGroup) {
                        legendSeriesGroup.setAttribute("tabindex", i === 0 ? "0" : "");
                        legendSeriesGroup.setAttribute("aria-label", legend.description || legendOption.text + " series is " + (legendOption.visible ? "showing, press enter to hide the " : "hidden, press enter to show the ") + legendOption.text + " series");
                        legendSeriesGroup.setAttribute("role", "button");
                        legendSeriesGroup.setAttribute("aria-pressed", legendOption.visible ? "true" : "false");
                    }
                    this.library.getRenderPoint(legendOption, start, textPadding, previousLegend, requireLegendBounds, count, firstLegend);
                    this.renderSymbol(legendOption, legendSeriesGroup, legendIndex);
                    this.renderText(chart, legendOption, legendSeriesGroup, textOptions, count, legendIndex);
                    if (legendSeriesGroup) legendSeriesGroup.style.cssText = "pointer-events: bounding-box; cursor: " + (!legend.toggleVisibility && (chart.selectionMode === "None" || chart.highlightMode === "None" || chart.selectionMode === "None") || this.isBulletChartControl ? "auto" : "pointer");
                    if (legendTranslateGroup) legendTranslateGroup.appendChild(legendSeriesGroup);
                    previousLegend = legendOption;
                }
                count++;
            }
            this.totalPages = this.isPaging && !this.isBulletChartControl && !this.legend.enablePages && !this.isVertical && this.totalPages > this.chartRowCount ? this.chartRowCount : this.totalPages;
            if (this.isPaging && this.totalPages > 1) this.renderPagingElements(chart, legendBounds, textOptions, legendGroup);
            else this.totalPages = 1;
        }
        if (pointAnimation) {
            var translateX = "translate(" + (this.rowCount > 1 ? 0 : Math.round(Number(xValue)) - Math.round(this.legendBounds.x)) + " \n              + ',' + " + (Math.round(Number(yValue)) - Math.round(this.legendBounds.y)) + ")";
            var translateY = "translate(" + (Math.round(Number(xValue)) - Math.round(this.legendBounds.x)) + ", " + (Math.round(Number(yValue)) - Math.round(this.legendBounds.y)) + ")";
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.svgObject, legendGroup, redraw, true, "x", "y", undefined, undefined, undefined, undefined, undefined, chart.duration, undefined, undefined, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(0, 0), this.position === "Top" || this.position === "Bottom" ? translateX : translateY);
        } else (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, chart.svgObject, legendGroup, redraw);
    };
    /**
     * To get linear legend.
     *
     * @param {Rect} legendBounds - The bounds of the legend.
     * @param {Chart | AccumulationChart | BulletChart | StockChart | Chart3D | CircularChart3D} chart - The chart instance.
     * @param {LegendSettingsModel} legend - The legend settings.
     * @param {Element} legendTranslateGroup - The group element to translate the legend.
     * @returns {void}
     * @private
     */ BaseLegend.prototype.getLinearLegend = function(legendBounds, chart, legend, legendTranslateGroup) {
        var xmlns = "http://www.w3.org/2000/svg";
        var previousLegend = this.legendCollections[0];
        var nextLegend = this.legendCollections[1];
        var defElement = this.chart.renderer.createDefs();
        var gradientLegendCount = 0;
        var linerGradientEle = document.createElementNS(xmlns, "linearGradient");
        var opacity = 1;
        var fillColors = [];
        var numberItems = [];
        if (legend.title) {
            if (!this.isVertical) {
                if (legend.titlePosition === "Left") {
                    legendBounds.x += this.legendTitleSize.width;
                    legendBounds.width -= this.legendTitleSize.width;
                } else if (legend.titlePosition === "Right") legendBounds.width -= this.legendTitleSize.width;
                else if (legend.titlePosition === "Top") {
                    legendBounds.y += this.legendTitleSize.height;
                    legendBounds.height -= this.legendTitleSize.height;
                }
            } else {
                legendBounds.y += this.legendTitleSize.height;
                legendBounds.height -= this.legendTitleSize.height;
            }
        }
        for(var _i = 0, _a = this.chart.rangeColorSettings; _i < _a.length; _i++){
            var colorMap = _a[_i];
            if (numberItems.indexOf(colorMap.start) < 0) numberItems.push(colorMap.start);
            if (colorMap.colors.length > 2) {
                var diffValue = colorMap.end - colorMap.start;
                var colorsLength = colorMap.colors.length - 1;
                if (diffValue > 0) {
                    diffValue = diffValue / colorsLength;
                    for(var index = 1; index < colorsLength; index++){
                        var calculatedValue = colorMap.start + diffValue * index;
                        numberItems.push(calculatedValue);
                    }
                } else for(var index = 1; index < colorsLength; index++)numberItems.push(colorMap.start);
            }
            if (numberItems.indexOf(colorMap.end) < 0) numberItems.push(colorMap.end);
            for(var _b = 0, _c = colorMap.colors; _b < _c.length; _b++){
                var fillColor = _c[_b];
                if (fillColors.indexOf(fillColor) < 0) fillColors.push(fillColor);
            }
            if (colorMap.colors.length > 0 && colorMap.colors.length < 2) fillColors.push(colorMap.colors[0]);
        }
        var x1 = this.isRtlEnable && !this.isVertical ? "100%" : "0%";
        var x2 = this.isVertical || this.isRtlEnable ? "0%" : "100%";
        var y2 = this.isVertical ? "100%" : "0%";
        linerGradientEle.setAttribute("id", this.generateId(previousLegend, "linearGradient", gradientLegendCount));
        linerGradientEle.setAttribute("x1", x1);
        linerGradientEle.setAttribute("y1", "0%");
        linerGradientEle.setAttribute("x2", x2);
        linerGradientEle.setAttribute("y2", y2);
        var full = numberItems[numberItems.length - 1] - numberItems[0];
        for(var b = 0; b < fillColors.length; b++){
            var offsetValue = numberItems[b] - numberItems[0];
            offsetValue = offsetValue / full;
            var stopEle = document.createElementNS(xmlns, "stop");
            stopEle.setAttribute("offset", offsetValue.toString());
            stopEle.setAttribute("stop-color", fillColors[b]);
            stopEle.setAttribute("stop-opacity", opacity.toString());
            linerGradientEle.appendChild(stopEle);
        }
        var startLabel = previousLegend.text.toString();
        var endLabel = nextLegend.text.toString();
        var startTextSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(startLabel, legend.textStyle, this.chart.themeStyle.legendLabelFont);
        var endTextSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(endLabel, legend.textStyle, this.chart.themeStyle.legendLabelFont);
        var textWidth = startTextSize.width > endTextSize.width ? startTextSize.width : endTextSize.width;
        var textHeight = startTextSize.height > endTextSize.height ? startTextSize.height : endTextSize.height;
        var otherSpaces = 2 * textWidth + 4 * legend.padding;
        var linearBarWidth = legendBounds.width;
        var linearBarHeight = legendBounds.height;
        var xValue = legendBounds.x + textWidth + 2 * legend.padding;
        var yValue = legendBounds.y + legend.padding;
        var startLabelY;
        var endLabelY;
        var startLabelX;
        var endLabelX;
        if (this.isVertical) {
            otherSpaces = 2 * textHeight + 4 * legend.padding;
            linearBarWidth = legendBounds.width - 2 * legend.padding;
            linearBarHeight = legendBounds.height - otherSpaces;
            xValue = legendBounds.x + legend.padding;
            yValue = legendBounds.y + textHeight + 2 * legend.padding;
            startLabelY = legendBounds.y + legend.padding + textHeight;
            endLabelY = yValue + linearBarHeight + textHeight;
            startLabelX = legendBounds.x + legendBounds.width * 0.5 - textWidth * 0.5;
            endLabelX = startLabelX;
            if (linearBarWidth > 30) {
                var diffWidth = linearBarWidth - 30;
                linearBarWidth = 30;
                xValue = xValue + diffWidth / 2;
            }
        } else {
            linearBarWidth = legendBounds.width - otherSpaces;
            linearBarHeight = legendBounds.height - 2 * legend.padding;
            startLabelX = legendBounds.x + (!this.isRtlEnable ? legend.padding + (textWidth - startTextSize.width) : linearBarWidth + 3 * legend.padding + textWidth);
            endLabelX = legendBounds.x + (!this.isRtlEnable ? linearBarWidth + 3 * legend.padding + textWidth : legend.padding + (textWidth - endTextSize.width));
            startLabelY = legendBounds.y + legendBounds.height * 0.5 + textHeight * 0.25;
            endLabelY = startLabelY;
            if (linearBarHeight > 30) {
                var diffHeight = linearBarHeight - 30;
                linearBarHeight = 30;
                yValue = yValue + diffHeight / 2;
            }
        }
        var anchor = chart.enableRtl ? "end" : "";
        var textOptions = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)("", startLabelX, startLabelY, anchor, startLabel);
        var hiddenColor = "#D3D3D3";
        textOptions.id = this.legendID + this.generateId(previousLegend, "_text_", 1);
        var fontcolor = previousLegend.visible ? legend.textStyle.color || chart.themeStyle.legendLabelFont.color : hiddenColor;
        var isCanvas = this.isStockChartControl ? false : this.chart.enableCanvas;
        (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, textOptions, legend.textStyle, fontcolor, legendTranslateGroup, false, false, false, false, null, this.currentPageNumber && isCanvas ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, -this.translatePage(isCanvas, null, this.currentPageNumber - 1, this.currentPageNumber), 0, 0) : null, null, null, null, null, this.chart.themeStyle.legendLabelFont);
        textOptions = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)("", endLabelX, endLabelY, anchor, endLabel);
        textOptions.id = this.legendID + this.generateId(previousLegend, "_text_", 2);
        (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, textOptions, legend.textStyle, fontcolor, legendTranslateGroup, false, false, false, false, null, this.currentPageNumber && isCanvas ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, -this.translatePage(isCanvas, null, this.currentPageNumber - 1, this.currentPageNumber), 0, 0) : null, null, null, null, null, this.chart.themeStyle.legendLabelFont);
        var gradientLegend = chart.renderer.drawRectangle({
            width: linearBarWidth,
            height: linearBarHeight,
            x: xValue,
            y: yValue,
            fill: "url(#" + this.generateId(previousLegend, "linearGradient", gradientLegendCount) + ")"
        });
        defElement.appendChild(linerGradientEle);
        legendTranslateGroup.appendChild(defElement);
        legendTranslateGroup.appendChild(gradientLegend);
    };
    /**
     * To find first valid legend text index for chart and accumulation chart
     *
     * @param legendCollection
     * @returns {number}
     * @private
     */ BaseLegend.prototype.findFirstLegendPosition = function(legendCollection) {
        var count = 0;
        for(var _i = 0, legendCollection_1 = legendCollection; _i < legendCollection_1.length; _i++){
            var legend = legendCollection_1[_i];
            if (legend.render && legend.text && legend.text !== "") break;
            count++;
        }
        return count;
    };
    /**
     * To get the legend title text width and height.
     *
     * @param legend
     * @param legendBounds
     */ BaseLegend.prototype.calculateLegendTitle = function(legend, legendBounds) {
        if (legend.title) {
            this.isTop = legend.titlePosition === "Top";
            var padding = legend.titleStyle.textOverflow === "Trim" ? 2 * legend.padding : 0;
            if (this.isTop || this.isVertical) this.legendTitleCollections = (0, $11815a21a80ae2b7$export$70d1bf7729efff40)(legend.title, legend.titleStyle, legendBounds.width - padding, this.chart.enableRtl, this.chart.themeStyle.legendTitleFont);
            else this.legendTitleCollections[0] = (0, $11815a21a80ae2b7$export$fb7a751b3bd7efd3)(legend.maximumTitleWidth, legend.title, legend.titleStyle, this.chart.enableRtl, this.chart.themeStyle.legendTitleFont);
            var text = this.isTop ? legend.title : this.legendTitleCollections[0];
            this.legendTitleSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(text, legend.titleStyle, this.chart.themeStyle.legendTitleFont);
            this.legendTitleSize.height *= this.legendTitleCollections.length;
        } else this.legendTitleSize = new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0);
    };
    /**
     * Render the legend title
     *
     * @param chart
     * @param legend
     * @param legendBounds
     * @param legendGroup
     */ BaseLegend.prototype.renderLegendTitle = function(chart, legend, legendBounds, legendGroup) {
        var padding = legend.padding;
        var alignment = legend.titleStyle.textAlignment;
        this.isTop = legend.titlePosition === "Top";
        var anchor = (0, $11815a21a80ae2b7$export$c2f41ec8f9331264)(legend.titleStyle.textAlignment, chart.enableRtl);
        var x = (0, $11815a21a80ae2b7$export$c12580d46760c769)(legendBounds, legend.titleStyle);
        anchor = this.isTop || this.isVertical ? anchor : chart.enableRtl ? "end" : "";
        x = alignment === "Near" ? x + padding : alignment === "Far" ? x - padding : x;
        x = this.isTop || this.isVertical ? x : legendBounds.x + (legend.titlePosition === "Left" ? 5 : legendBounds.width - this.legendTitleSize.width - 5);
        var topPadding = legendBounds.height / 2 + this.legendTitleSize.height / 4;
        var y = legendBounds.y + (!this.isTop && !this.isVertical ? topPadding : this.legendTitleSize.height / this.legendTitleCollections.length);
        var legendTitleTextOptions = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(this.legendID + "_title", x, y, anchor, this.legendTitleCollections);
        (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, legendTitleTextOptions, legend.titleStyle, legend.titleStyle.color || this.chart.themeStyle.legendTitleFont.color, legendGroup, null, null, null, null, null, null, null, null, null, null, this.chart.themeStyle.legendTitleFont);
    };
    /**
     * To create legend rendering elements for chart and accumulation chart
     *
     * @param chart
     * @param legendBounds
     * @param legendGroup
     * @param legend
     * @param id
     * @param redraw
     */ BaseLegend.prototype.createLegendElements = function(chart, legendBounds, legendGroup, legend, id, redraw) {
        var padding = legend.padding;
        var options = new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(id + "_element", legend.background, legend.border, legend.opacity, legendBounds, 0, 0, "", this.legend.border.dashArray);
        var legendItemsGroup = chart.renderer.createGroup({
            id: id + "_collections"
        });
        var isCanvas = this.isStockChartControl ? false : chart.enableCanvas;
        var clippath = chart.renderer.createClipPath({
            id: id + "_clipPath"
        });
        options.width = this.isRtlEnable && this.chart.getModuleName() === "accumulationchart" && this.isVertical ? this.maxWidth : legendBounds.width;
        if (legendGroup) legendGroup.appendChild(chart.renderer.drawRectangle(options));
        else chart.renderer.drawRectangle(options);
        if (legend.title) this.renderLegendTitle(chart, legend, legendBounds, legendGroup);
        if (!isCanvas) legendGroup.appendChild(legendItemsGroup);
        this.legendTranslateGroup = chart.renderer.createGroup({
            id: id + "_translate_g"
        });
        if (!isCanvas) legendItemsGroup.appendChild(this.legendTranslateGroup);
        options.y += this.isTop ? this.legendTitleSize.height : 0;
        options.id += "_clipPath_rect";
        options.width = !this.isChartControl && chart.getModuleName() !== "bulletChart" && !this.isStockChartControl && this.isVertical ? this.maxWidth - padding + legend.containerPadding.left + legend.containerPadding.right : legendBounds.width;
        if (!isCanvas) {
            this.clipRect = chart.renderer.drawRectangle(options);
            clippath.appendChild(this.clipRect);
        } else this.pagingClipRect = options;
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(isCanvas, chart.svgObject, clippath, redraw);
        if (!isCanvas) legendItemsGroup.style.cssText = "clip-path:url(#" + clippath.id + ")";
        return this.legendTranslateGroup;
    };
    /**
     * To render legend symbols for chart and accumulation chart
     *
     * @param legendOption
     * @param group
     * @param i
     * @param legendOption
     * @param group
     * @param i
     * @param legendOption
     * @param group
     * @param i
     */ BaseLegend.prototype.renderSymbol = function(legendOption, group, legendIndex) {
        var control = this.isBulletChartControl ? this.chart : null;
        var symbolColor = legendOption.visible ? legendOption.fill : "#D3D3D3";
        var isStrokeWidth = (this.chart.getModuleName() === "chart" || this.chart.getModuleName() === "stockChart") && (legendOption.shape === "SeriesType" && legendOption.type.toLowerCase().indexOf("line") > -1 && legendOption.type.toLowerCase().indexOf("area") === -1 || legendOption.shape === "HorizontalLine" || legendOption.shape === "VerticalLine" || legendOption.shape === "Cross");
        var isCustomBorder = (this.chart.getModuleName() === "chart" || this.chart.getModuleName() === "stockChart") && (legendOption.type === "Scatter" || legendOption.type === "Bubble");
        var isCanvas = this.isStockChartControl ? false : this.chart.enableCanvas;
        var borderColor;
        var shape = legendOption.shape === "SeriesType" ? legendOption.type : legendOption.shape;
        var strokewidth = isStrokeWidth ? this.legend.mode === "Series" ? this.chart.visibleSeries[legendIndex].width : this.chart.visibleSeries[0].width : this.isBulletChartControl && legendOption.shape === "Multiply" ? 4 : 1;
        var regionPadding;
        shape = shape === "Scatter" ? legendOption.markerShape : shape;
        if (isCustomBorder && legendIndex < this.chart.visibleSeries.length) {
            var series = this.chart.visibleSeries[legendIndex];
            var seriesBorder = series.border;
            var isLineShapemarker = shape === "HorizontalLine" || shape === "VerticalLine";
            borderColor = isLineShapemarker ? symbolColor : seriesBorder.color ? seriesBorder.color : symbolColor;
            strokewidth = isLineShapemarker ? series.width : seriesBorder.width ? seriesBorder.width : 1;
        }
        var symbolOption = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(this.legendID + this.generateId(legendOption, "_shape_", legendIndex), symbolColor, strokewidth, isCustomBorder ? borderColor : symbolColor, this.legend.opacity, legendOption.dashArray, "");
        var textSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(legendOption.text, this.legend.textStyle, this.chart.themeStyle.legendLabelFont);
        var x = this.legend.isInversed && !this.isRtlEnable ? legendOption.location.x + textSize.width + this.legend.shapePadding : legendOption.location.x;
        var y = legendOption.location.y;
        if (!isCanvas) group.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
            x: x,
            y: y
        }, shape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.legend.shapeWidth, this.legend.shapeHeight), legendOption.url, symbolOption, this.accessbilityText, this.chart.renderer, null, this.isBulletChartControl, control));
        else {
            regionPadding = -this.translatePage(isCanvas, null, this.currentPageNumber - 1, this.currentPageNumber);
            (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                x: x,
                y: y
            }, shape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.legend.shapeWidth, this.legend.shapeHeight), "", symbolOption, this.accessbilityText, this.chart.renderer, this.currentPageNumber ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, regionPadding, 0, 0) : null, this.isBulletChartControl, control);
            this.legendRegions.push({
                rect: new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(legendOption.location.x - this.legend.shapeWidth, legendOption.location.y, this.legend.shapeWidth + this.legend.shapePadding, this.legend.shapeHeight + regionPadding),
                index: legendIndex
            });
        }
        if (shape === "Line" && legendOption.markerVisibility && legendOption.markerShape !== "Image" || legendOption.type === "Doughnut" && shape === "Doughnut") {
            symbolOption.id = this.legendID + this.generateId(legendOption, "_shape_marker_", legendIndex);
            shape = legendOption.type === "Doughnut" ? "Circle" : legendOption.markerShape;
            symbolOption.fill = legendOption.type === "Doughnut" ? "#FFFFFF" : symbolOption.fill;
            if (!isCanvas) group.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                x: x,
                y: y
            }, shape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.legend.shapeWidth / 2, this.legend.shapeHeight / 2), "", symbolOption, this.accessbilityText, null, null, this.isBulletChartControl, control));
            else (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                x: x,
                y: y
            }, shape, new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.legend.shapeWidth / 2, this.legend.shapeHeight / 2), "", symbolOption, this.accessbilityText, this.chart.renderer, this.currentPageNumber ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, -this.translatePage(isCanvas, null, this.currentPageNumber - 1, this.currentPageNumber), 0, 0) : null, this.isBulletChartControl, control);
        }
    };
    /**
     * To render legend text for chart and accumulation chart
     *
     * @param chart
     * @param legendOption
     * @param group
     * @param textOptions
     * @param i
     * @param chart
     * @param legendOption
     * @param group
     * @param textOptions
     * @param i
     * @param chart
     * @param legendOption
     * @param group
     * @param textOptions
     * @param i
     * @param chart
     * @param legendOption
     * @param group
     * @param textOptions
     * @param i
     * @param chart
     * @param legendOption
     * @param group
     * @param textOptions
     * @param i
     */ BaseLegend.prototype.renderText = function(chart, legendOption, group, textOptions, i, legendIndex) {
        var legend = chart.legendSettings;
        var hiddenColor = "#D3D3D3";
        var fontcolor = legendOption.visible ? legend.textStyle.color || chart.themeStyle.legendLabelFont.color : hiddenColor;
        var isCanvas = this.isStockChartControl ? false : this.chart.enableCanvas;
        textOptions.id = this.legendID + this.generateId(legendOption, "_text_", legendIndex);
        textOptions.text = legendOption.textCollection.length > 0 ? legendOption.textCollection : legendOption.text;
        if (legend.isInversed && !this.isRtlEnable) textOptions.x = legendOption.location.x - legend.shapeWidth / 2;
        else if (this.isRtlEnable) {
            var textWidth = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(legendOption.text, legend.textStyle, this.chart.themeStyle.legendLabelFont).width;
            textOptions.x = this.chart.getModuleName() === "bulletChart" ? legendOption.location.x - legend.shapeWidth : legendOption.location.x - ((legendOption.textCollection.length > 1 ? textWidth / legendOption.textCollection.length : textWidth) + legend.shapeWidth / 2 + legend.shapePadding);
        } else textOptions.x = legendOption.location.x + legend.shapeWidth / 2 + legend.shapePadding;
        textOptions.y = legendOption.location.y + this.maxItemHeight / 4;
        (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, textOptions, legend.textStyle, fontcolor, group, false, false, false, false, null, this.currentPageNumber && isCanvas ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, -this.translatePage(isCanvas, null, this.currentPageNumber - 1, this.currentPageNumber), 0, 0) : null, null, null, null, null, this.chart.themeStyle.legendLabelFont);
        if (isCanvas) {
            var textSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(legendOption.text, legend.textStyle, this.chart.themeStyle.legendLabelFont);
            var region = void 0;
            for(var j = 0; j < this.legendRegions.length; j++)if (this.legendRegions[j].index === i) {
                region = this.legendRegions[j];
                break;
            }
            region.rect.y = textOptions.y < region.rect.y ? textOptions.y : region.rect.y;
            region.rect.width += textSize.width;
            region.rect.height = textSize.height;
            region.rect.y -= textSize.height * 0.5;
            region.rect.x -= this.isRtlEnable ? region.rect.width : 0;
        }
    };
    /**
     * To render legend paging elements for chart and accumulation chart
     *
     * @param chart
     * @param bounds
     * @param textOption
     * @param legendGroup
     * @param chart
     * @param bounds
     * @param textOption
     * @param legendGroup
     * @param chart
     * @param bounds
     * @param textOption
     * @param legendGroup
     * @param chart
     * @param bounds
     * @param textOption
     * @param legendGroup
     */ BaseLegend.prototype.renderPagingElements = function(chart, bounds, textOption, legendGroup) {
        var paginggroup = chart.renderer.createGroup({
            id: this.legendID + "_navigation"
        });
        var isCanvas = this.isStockChartControl ? false : chart.enableCanvas;
        var titleHeight = this.isBulletChartControl ? 0 : this.legendTitleSize.height;
        var grayColor = this.chart.theme.indexOf("Dark") > -1 || this.chart.theme.indexOf("Contrast") > -1 ? "#FFFFFF" : "#545454";
        var legend = chart.legendSettings; // to solve parameter lint error, legend declaration is here
        var padding = 8; // const padding for paging elements
        var pageUp = this.legendID + (!this.isRtlEnable ? "_pageup" : "_pagedown");
        var pageDown = this.legendID + (!this.isRtlEnable ? "_pagedown" : "_pageup");
        var symbolOption = new (0, $5d5f50c62a40f4c7$export$cd3012645815980)(pageUp, "transparent", 5, grayColor, 1, "", "");
        var iconSize = chart.availableSize.width < 110 || chart.availableSize.height < 190 ? 4 : this.pageButtonSize;
        // Page left arrow drawing calculation started here
        var rowCount = !legend.enablePages && this.isPaging && !this.isVertical && !this.isBulletChartControl ? 1 : this.rowCount - 1;
        var titleWidth = this.isTitle && legend.titlePosition === "Left" ? this.legendTitleSize.width : 0;
        this.pagingRegions = [];
        this.backwardArrowOpacity = this.currentPage !== 1 ? 1 : 0;
        this.forwardArrowOpacity = this.currentPage === this.totalPages ? 0 : 1;
        if (!isCanvas) legendGroup.appendChild(paginggroup);
        if (!this.isChartControl && !this.isAccChartControl) {
            if (this.isBulletChartControl || this.isStockChartControl || !this.isVertical) this.totalPages = Math.ceil(this.totalPages / Math.max(1, this.rowCount - 1));
            else this.totalPages = Math.ceil(this.totalPages / this.maxColumns);
        }
        if (paginggroup) paginggroup.style.cursor = "pointer";
        if ((this.isChartControl || this.isAccChartControl) && !(!legend.enablePages && this.isPaging)) this.clipPathHeight = this.pageHeights[0];
        else this.clipPathHeight = rowCount * (this.maxItemHeight + legend.padding);
        //this.clipPathHeight = !(this.isChartControl) ? (rowCount * (this.maxItemHeight + legend.padding)) : this.columnHeights[0];
        if (!isCanvas) this.clipRect.setAttribute("height", this.clipPathHeight.toString());
        else {
            //paging clipRect only for canvas mode
            this.pagingClipRect.height = this.legendBounds.height - this.clipPathHeight - (this.pagingClipRect.y - this.legendBounds.y) - legend.border.width;
            this.pagingClipRect.y = this.pagingClipRect.y + this.clipPathHeight;
            this.pagingClipRect.x += legend.border.width;
            this.pagingClipRect.width -= legend.border.width + legend.border.width / 2;
            this.chart.renderer.clearRect(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(this.pagingClipRect.x, this.pagingClipRect.y, this.pagingClipRect.width, this.pagingClipRect.height));
        }
        var pageTextElement;
        var x = bounds.x + iconSize / 2;
        var y = bounds.y + this.clipPathHeight + (titleHeight + bounds.height - this.clipPathHeight) / 2;
        if (this.isPaging && !legend.enablePages && !this.isVertical && !this.isBulletChartControl) {
            x = bounds.x + this.pageButtonSize + titleWidth;
            y = legend.title && this.isTop ? bounds.y + padding + titleHeight + iconSize / 1 + 0.5 : bounds.y + padding + iconSize + 0.5;
        }
        var size = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.totalPages + "/" + this.totalPages, legend.textStyle, this.chart.themeStyle.legendLabelFont);
        var translateX = this.isRtlEnable ? legend.border.width + iconSize / 2 : bounds.width - (2 * (iconSize + padding) + padding + size.width);
        if (!isCanvas) {
            if (this.isVertical && !legend.enablePages && !this.isBulletChartControl) {
                x = bounds.x + bounds.width / 2;
                y = bounds.y + iconSize / 2 + padding / 2 + titleHeight;
                symbolOption.opacity = this.backwardArrowOpacity;
                paginggroup.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                    x: x,
                    y: y
                }, "UpArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "UpArrow"));
            } else {
                symbolOption.opacity = this.isBulletChartControl ? symbolOption.opacity : legend.enablePages ? 1 : !this.isRtlEnable ? this.backwardArrowOpacity : this.forwardArrowOpacity;
                paginggroup.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                    x: x,
                    y: y
                }, "LeftArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "LeftArrow"));
            }
        } else (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
            x: x,
            y: y
        }, "LeftArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "LeftArrow", this.chart.renderer, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(translateX, 0, 0, 0));
        this.pagingRegions.push(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(!this.isRtlEnable ? x + bounds.width - (2 * (iconSize + padding) + padding + size.width) - iconSize * 0.5 : x, y - iconSize * 0.5, iconSize, iconSize));
        // Page numbering rendering calculation started here
        textOption.x = x + iconSize / 2 + padding;
        textOption.y = y + size.height / 4;
        textOption.id = this.legendID + "_pagenumber";
        textOption.text = !this.isRtlEnable ? "1/" + this.totalPages : this.totalPages + "/1";
        var color = this.chart.theme.indexOf("Dark") > -1 || this.chart.theme.indexOf("Contrast") > -1 ? "#FFFFFF" : legend.textStyle.color || this.chart.themeStyle.legendLabelFont.color;
        if (isCanvas && this.totalNoOfPages) textOption.text = !this.isRtlEnable ? this.currentPageNumber + "/" + this.totalNoOfPages : this.totalNoOfPages + "/" + this.currentPageNumber;
        if (legend.enablePages || this.isBulletChartControl) {
            legend.textStyle.size = chart.availableSize.width < 110 || chart.availableSize.height < 190 && !this.isBulletChartControl ? "8px" : legend.textStyle.size;
            pageTextElement = (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(chart.renderer, textOption, legend.textStyle, color, paginggroup, false, false, false, false, null, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(translateX, 0, 0, 0), null, null, null, null, this.chart.themeStyle.legendLabelFont);
        }
        // Page right arrow rendering calculation started here
        x = textOption.x + padding + iconSize / 2 + size.width;
        if (this.isPaging && !legend.enablePages && !this.isVertical) x = bounds.x + bounds.width - (this.isBulletChartControl ? this.fivePixel : 0) - this.pageButtonSize - (legend.title && legend.titlePosition === "Right" ? this.legendTitleSize.width + this.fivePixel : 0);
        symbolOption.id = pageDown;
        symbolOption.opacity = !legend.enablePages ? !this.isRtlEnable ? this.forwardArrowOpacity : this.backwardArrowOpacity : 1;
        if (!isCanvas) {
            if (this.isVertical && !legend.enablePages && !this.isBulletChartControl) {
                x = bounds.x + bounds.width / 2;
                y = bounds.y + bounds.height - iconSize / 2;
                paginggroup.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                    x: x,
                    y: y
                }, "DownArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "DownArrow"));
            } else paginggroup.appendChild((0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
                x: x,
                y: y
            }, "RightArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "RightArrow"));
        } else (0, $11815a21a80ae2b7$export$49ec94bba13b5c07)({
            x: x,
            y: y
        }, "RightArrow", new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(iconSize, iconSize), "", symbolOption, "RightArrow", this.chart.renderer, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(translateX, 0, 0, 0));
        this.pagingRegions.push(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(!this.isRtlEnable ? x + (bounds.width - (2 * (iconSize + padding) + padding + size.width) - iconSize * 0.5) : x, y - iconSize * 0.5, iconSize, iconSize));
        if (!isCanvas && (legend.enablePages || this.isBulletChartControl)) //placing the navigation buttons and page numbering in legend right corner
        paginggroup.setAttribute("transform", "translate(" + translateX + ", " + 0 + ")");
        else {
            if (this.currentPageNumber === 1 && this.calTotalPage && (legend.enablePages || this.isBulletChartControl)) {
                this.totalNoOfPages = this.totalPages;
                this.calTotalPage = false;
            }
            if (!legend.enablePages && !this.isBulletChartControl) this.translatePage(isCanvas, null, this.currentPage - 1, this.currentPage, legend);
        }
        if (legend.enablePages || this.isBulletChartControl) this.translatePage(isCanvas, pageTextElement, this.currentPage - 1, this.currentPage, legend);
    };
    BaseLegend.prototype.getPageHeight = function(pageHeights, pageCount) {
        var sum = 0;
        for(var i = 0; i < pageCount; i++)sum += pageHeights[i];
        return sum;
    };
    /**
     * To translate legend pages for chart and accumulation chart
     *
     * @param pagingText
     * @param page
     * @param pageNumber
     * @param legend
     * @param pagingText
     * @param page
     * @param pageNumber
     * @param legend
     * @param pagingText
     * @param page
     * @param pageNumber
     * @param legend
     * @param pagingText
     * @param page
     * @param pageNumber
     * @param legend
     */ BaseLegend.prototype.translatePage = function(isCanvas, pagingText, page, pageNumber, legend) {
        var size = this.isChartControl || this.isAccChartControl ? page ? this.getPageHeight(this.pageHeights, page) : 0 : this.clipPathHeight * page;
        if (!isCanvas && (this.isChartControl || this.isAccChartControl)) {
            this.clipRect.setAttribute("height", this.pageHeights[page].toString());
            if (this.isAccChartControl && this.isPaging && !legend.enablePages && this.isVertical) this.clipRect.setAttribute("height", this.legendBounds.height.toString());
        }
        var translate = "translate(0,-" + size + ")";
        if (!this.isChartControl && !this.isBulletChartControl && !this.isStockChartControl && this.isVertical) {
            var pageX = this.pageXCollections[page * this.maxColumns];
            size = !this.isRtlEnable ? pageX - this.legendBounds.x : this.legendBounds.x + this.maxWidth - pageX;
            size = size < 0 ? 0 : size; // to avoid small pixel variation
            translate = (!this.isRtlEnable ? "translate(-" : "translate(") + size + ",0)";
        }
        if (!this.chart.enableCanvas) this.legendTranslateGroup.setAttribute("transform", translate);
        if (!this.chart.enableCanvas && (legend.enablePages || this.isBulletChartControl)) pagingText.textContent = pageNumber + "/" + this.totalPages;
        this.currentPage = pageNumber;
        return size;
    };
    /**
     * To change legend pages for chart and accumulation chart
     *
     * @param event
     * @param pageUp
     * @param event
     * @param pageUp
     */ BaseLegend.prototype.changePage = function(event, pageUp) {
        var legend = this.chart.legendSettings;
        var backwardArrow = document.getElementById(this.legendID + "_pageup");
        var forwardArrow = document.getElementById(this.legendID + "_pagedown");
        var isCanvas = this.isStockChartControl ? false : this.chart.enableCanvas;
        var pageText = legend.enablePages || this.isBulletChartControl ? document.getElementById(this.legendID + "_pagenumber") : null;
        var page = legend.enablePages || this.isBulletChartControl ? parseInt(pageText.textContent.split("/")[0], 10) : this.currentPage;
        if (pageUp && page > 1) this.translatePage(isCanvas, pageText, page - 2, page - 1, legend);
        else if (!pageUp && page < this.totalPages) this.translatePage(isCanvas, pageText, page, page + 1, legend);
        if (this.isPaging && !legend.enablePages && !this.isBulletChartControl) {
            if (this.currentPage === this.totalPages) this.hideArrow(forwardArrow);
            else this.showArrow(forwardArrow);
            if (this.currentPage === 1) this.hideArrow(backwardArrow);
            else this.showArrow(backwardArrow);
        // this.currentPage === this.totalPages ? this.hideArrow(forwardArrow) : this.showArrow(forwardArrow);
        // this.currentPage === 1 ? this.hideArrow(backwardArrow) : this.showArrow(backwardArrow);
        }
    };
    /**
     * To hide the backward and forward arrow
     *
     * @param arrowElement
     */ BaseLegend.prototype.hideArrow = function(arrowElement) {
        arrowElement.setAttribute("opacity", "0");
    };
    /**
     * To show the  backward and forward arrow
     *
     * @param arrowElement
     */ BaseLegend.prototype.showArrow = function(arrowElement) {
        arrowElement.setAttribute("opacity", "1");
    };
    /**
     * To find legend elements id based on chart or accumulation chart
     *
     * @param option
     * @param prefix
     * @param count
     * @param option
     * @param prefix
     * @param count
     * @param option
     * @param prefix
     * @param count
     * @private
     */ BaseLegend.prototype.generateId = function(option, prefix, count) {
        if (this.isChartControl || this.isStockChartControl) return prefix + count;
        else return prefix + option.pointIndex;
    };
    /**
     * To show or hide trimmed text tooltip for legend.
     *
     * @param event
     * @returns {void}
     * @private
     */ BaseLegend.prototype.move = function(event) {
        var _this = this;
        var x = this.chart.mouseX;
        var y = this.chart.mouseY;
        if (event.target.textContent.indexOf("...") > -1) {
            var targetId = event.target.id.split(this.legendID + "_text_");
            if (targetId.length === 2) {
                var index = parseInt(targetId[1], 10);
                var element = this.chart.element;
                if (!isNaN(index)) {
                    if (this.chart.isTouch) (0, $11815a21a80ae2b7$export$f883456a56996078)(this.chart.element.id + "_EJ2_Legend_Tooltip");
                    if (this.isChartControl) (0, $11815a21a80ae2b7$export$dba11b50e1aa3c12)(this.chart.series[index].name, x, y, element.offsetWidth, element.id + "_EJ2_Legend_Tooltip", (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_Secondary_Element"));
                    else (0, $11815a21a80ae2b7$export$dba11b50e1aa3c12)(this.chart.visibleSeries[0].points[index].x.toString(), x + 10, y + 10, element.offsetWidth, element.id + "_EJ2_Legend_Tooltip", (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.chart.element.id + "_Secondary_Element"));
                }
            }
        } else (0, $11815a21a80ae2b7$export$f883456a56996078)(this.chart.element.id + "_EJ2_Legend_Tooltip");
        if (this.chart.isTouch) {
            clearTimeout(this.clearTooltip);
            this.clearTooltip = +setTimeout(function() {
                (0, $11815a21a80ae2b7$export$f883456a56996078)(_this.chart.element.id + "_EJ2_Legend_Tooltip");
            }, 1000);
        }
    };
    return BaseLegend;
}();
/**
 * Class for legend options
 *
 * @private
 */ var $1edae0c111fe0a45$export$90e29b0c950a66b = /** @class */ function() {
    function LegendOptions(text, fill, shape, visible, type, url, markerShape, markerVisibility, pointIndex, seriesIndex, dashArray) {
        this.location = {
            x: 0,
            y: 0
        };
        this.textCollection = [];
        this.text = text;
        this.fill = fill;
        this.shape = shape;
        this.url = url;
        this.visible = visible;
        this.type = type;
        this.markerVisibility = markerVisibility;
        this.markerShape = markerShape;
        this.pointIndex = pointIndex;
        this.seriesIndex = seriesIndex;
        this.dashArray = dashArray;
    }
    return LegendOptions;
}();


parcelRequire("j7YE8");
var $5rsSz = parcelRequire("5rsSz");




var $7abe8d19c400d6d4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7abe8d19c400d6d4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Defines how to represent the market trend using technical indicators.
 */ var $7abe8d19c400d6d4$export$afdd85645f5afc67 = /** @class */ function(_super) {
    $7abe8d19c400d6d4$var$__extends(TechnicalIndicator, _super);
    function TechnicalIndicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @private */ _this.clipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0);
        return _this;
    }
    /**
     * Sets the data source for the series in the chart.
     *
     * @private
     * @param {Series} series - The series for which the data source is being set.
     * @param {Chart} chart - The chart instance.
     * @returns {void}
     */ TechnicalIndicator.prototype.setDataSource = function(series, chart) {
        if (series) {
            this.xData = series.xData;
            this.yData = series.yData;
            this.points = series.points;
        }
        var type = (0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(this.type);
        if (this.visible) chart[type + "IndicatorModule"].initDataSource(this, chart);
        chart.visibleSeriesCount += this.targetSeries.length;
    };
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("Sma")
    ], TechnicalIndicator.prototype, "type", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(14)
    ], TechnicalIndicator.prototype, "period", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(14)
    ], TechnicalIndicator.prototype, "kPeriod", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], TechnicalIndicator.prototype, "dPeriod", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(80)
    ], TechnicalIndicator.prototype, "overBought", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(20)
    ], TechnicalIndicator.prototype, "overSold", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(2)
    ], TechnicalIndicator.prototype, "standardDeviation", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("Close")
    ], TechnicalIndicator.prototype, "field", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(12)
    ], TechnicalIndicator.prototype, "slowPeriod", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(26)
    ], TechnicalIndicator.prototype, "fastPeriod", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TechnicalIndicator.prototype, "showZones", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "#ff9933",
            width: 2
        }, (0, $2ae44f835da15a47$export$b2278035370d6017))
    ], TechnicalIndicator.prototype, "macdLine", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], TechnicalIndicator.prototype, "macdType", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("#2ecd71")
    ], TechnicalIndicator.prototype, "macdPositiveColor", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("#e74c3d")
    ], TechnicalIndicator.prototype, "macdNegativeColor", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("rgba(211,211,211,0.25)")
    ], TechnicalIndicator.prototype, "bandColor", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "#ffb735",
            width: 1
        }, (0, $2ae44f835da15a47$export$b2278035370d6017))
    ], TechnicalIndicator.prototype, "upperLine", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "#f2ec2f",
            width: 1
        }, (0, $2ae44f835da15a47$export$b2278035370d6017))
    ], TechnicalIndicator.prototype, "lowerLine", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "#f2ec2f",
            width: 1
        }, (0, $2ae44f835da15a47$export$b2278035370d6017))
    ], TechnicalIndicator.prototype, "periodLine", void 0);
    $7abe8d19c400d6d4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TechnicalIndicator.prototype, "seriesName", void 0);
    return TechnicalIndicator;
}((0, $54f817a374cfcee1$export$44db626655395dec));




parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


var $09cfe3d07a100f05$export$aba05cf1a7229db5 = /** @class */ function() {
    /**
     * Constructor for chart and accumulation annotation
     *
     * @param control
     */ function PrintUtils(control) {
        this.control = control;
    }
    /**
     * To print the accumulation and chart elements.
     *
     * @param elements
     */ PrintUtils.prototype.print = function(elements) {
        this.printWindow = window.open("", "print", "height=" + window.outerHeight + ",width=" + window.outerWidth + ",tabbar=no");
        this.printWindow.moveTo(0, 0);
        this.printWindow.resizeTo(screen.availWidth, screen.availHeight);
        var argsData = {
            cancel: false,
            htmlContent: this.getHTMLContent(elements),
            name: (0, $9415fc5f023d8fac$export$239eb85392ed959a)
        };
        this.control.trigger((0, $9415fc5f023d8fac$export$239eb85392ed959a), argsData);
        if (!argsData.cancel) (0, $3EnZW.print)(argsData.htmlContent, this.printWindow);
    };
    /**
     * To get the html string of the chart and accumulation
     *
     * @param elements
     * @private
     */ PrintUtils.prototype.getHTMLContent = function(elements) {
        var div = (0, $4ZDHT.createElement)("div");
        if (elements) {
            if (elements instanceof Array) for(var j = 0; j < elements.length; j++){
                var value = elements[j];
                div.appendChild((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(value).cloneNode(true));
            }
            else if (elements instanceof Element) div.appendChild(elements.cloneNode(true));
            else div.appendChild((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(elements).cloneNode(true));
        } else div.appendChild(this.control.element.cloneNode(true));
        for(var index = 0; index < div.children.length; index++){
            var backgroundColor = this.control.theme.indexOf("Dark") > -1 || this.control.theme.indexOf("HighContrast") > -1 ? "rgba(0, 0, 0, 1)" : "rgba(255, 255, 255, 1)";
            var svg = div.children[index];
            for(var childIndex = 0; childIndex < svg.children.length; childIndex++){
                var actualBackgroundColor = void 0;
                var isSVG = false;
                if (svg.id.indexOf("_stockChart_svg") > -1) {
                    actualBackgroundColor = svg.children[0].getAttribute("fill");
                    isSVG = true;
                } else if (svg.children[childIndex].id.indexOf("_svg") > -1) {
                    actualBackgroundColor = svg.children[childIndex].children[0].getAttribute("fill");
                    isSVG = true;
                }
                if (isSVG) {
                    actualBackgroundColor = actualBackgroundColor === "transparent" ? backgroundColor : actualBackgroundColor;
                    svg.children[childIndex].children[0].setAttribute("fill", actualBackgroundColor);
                }
            }
            div[index] = svg;
        }
        return div;
    };
    return PrintUtils;
}();


var $7c7d40c195159aeb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7c7d40c195159aeb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the range color settings in the chart.
 */ var $7c7d40c195159aeb$export$443b77f0cd295ca9 = /** @class */ function(_super) {
    $7c7d40c195159aeb$var$__extends(RangeColorSetting, _super);
    function RangeColorSetting() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)()
    ], RangeColorSetting.prototype, "start", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)()
    ], RangeColorSetting.prototype, "end", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)([])
    ], RangeColorSetting.prototype, "colors", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], RangeColorSetting.prototype, "label", void 0);
    return RangeColorSetting;
}((0, $3fcxu.ChildProperty));
/**
 * Options to configure the crosshair on the chart, which displays lines that follow the mouse cursor and show the axis values of the data points.
 */ var $7c7d40c195159aeb$export$3be2ec09daf24c31 = /** @class */ function(_super) {
    $7c7d40c195159aeb$var$__extends(CrosshairSettings, _super);
    function CrosshairSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], CrosshairSettings.prototype, "enable", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CrosshairSettings.prototype, "dashArray", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            color: null,
            width: 1
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], CrosshairSettings.prototype, "line", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], CrosshairSettings.prototype, "lineType", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CrosshairSettings.prototype, "verticalLineColor", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], CrosshairSettings.prototype, "horizontalLineColor", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], CrosshairSettings.prototype, "opacity", void 0);
    return CrosshairSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the zooming behavior for the chart.
 */ var $7c7d40c195159aeb$export$b2f0cac14cc88576 = /** @class */ function(_super) {
    $7c7d40c195159aeb$var$__extends(ZoomSettings, _super);
    function ZoomSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enableSelectionZooming", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enablePinchZooming", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "showToolbar", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enableMouseWheelZooming", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ZoomSettings.prototype, "enableDeferredZooming", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("XY")
    ], ZoomSettings.prototype, "mode", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)([
            "Zoom",
            "ZoomIn",
            "ZoomOut",
            "Pan",
            "Reset"
        ])
    ], ZoomSettings.prototype, "toolbarItems", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enablePan", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enableScrollbar", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ZoomSettings.prototype, "enableAnimation", void 0);
    return ZoomSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Represents the chart control.
 * ```html
 * <div id="chart"/>
 * <script>
 *   var chartObj = new Chart({});
 *   chartObj.appendTo("#chart");
 * </script>
 * ```
 *
 * @public
 */ var $7c7d40c195159aeb$export$acaa6426d77a227e = /** @class */ function(_super) {
    $7c7d40c195159aeb$var$__extends(Chart, _super);
    /**
     * Constructor for the chart component.
     *
     * @param {ChartModel} [options] - The chart model options.
     * @param {string | HTMLElement} [element] - The element ID or instance where the chart needs to be rendered.
     * @private
     */ function Chart(options, element) {
        var _this = _super.call(this, options, element) || this;
        /** @private */ _this.rotatedDataLabelCollections = [];
        /** @public */ _this.animated = false;
        /** @private */ _this.isPointMouseDown = false;
        /** @private */ _this.isScrolling = false;
        /** @private */ _this.checkResize = 0;
        /** @private */ _this.visible = 0;
        /** @private */ _this.clickCount = 0;
        /** @private */ _this.maxPointCount = 0;
        /** @private */ _this.singleClickTimer = 0;
        /** @private */ _this.chartAreaType = "Cartesian";
        /** @private */ _this.isRtlEnabled = false;
        _this.isCrosshair = true;
        _this.chartid = 57723;
        /** @private */ _this.isLegendClicked = false;
        _this.isZoomed = false;
        _this.previousTargetId = "";
        _this.currentPointIndex = 0;
        _this.currentSeriesIndex = 0;
        _this.currentLegendIndex = 0;
        _this.previousPageX = null;
        _this.previousPageY = null;
        _this.allowPan = false;
        /** @private */ _this.pointsRemoved = false;
        /** @private */ _this.pointsAdded = false;
        /** @private */ _this.zoomRedraw = false;
        (0, $3EnZW.setValue)("mergePersistData", _this.mergePersistChartData, _this);
        return _this;
    }
    /**
     * To manage persist chart data.
     *
     * @returns {void}
     */ Chart.prototype.mergePersistChartData = function() {
        var data = window.localStorage.getItem(this.getModuleName() + this.element.id);
        if (!((0, $3EnZW.isNullOrUndefined)(data) || data === "")) {
            var dataObj = JSON.parse(data);
            var keys = Object.keys(dataObj);
            this.isProtectedOnChange = true;
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                if (typeof this[key] === "object" && !(0, $3EnZW.isNullOrUndefined)(this[key])) (0, $3EnZW.extend)(this[key], dataObj[key]);
                else this[key] = dataObj[key];
            }
            this.isProtectedOnChange = false;
        }
    };
    /**
     * Checks if the element ID contains special characters.
     *
     * @param {string} elementId - The ID of the element.
     * @returns {string} - The modified ID without special characters.
     */ Chart.prototype.isIdHasSpecialCharacter = function(elementId) {
        var regex = /^[A-Za-z ]+$/;
        var numberRegex = /^[0-9 ]+$/;
        var childElementId = "";
        if (!regex.test(elementId)) {
            var start = 0;
            if (numberRegex.test(elementId[0])) {
                childElementId += "\\3" + elementId[0];
                start = 1;
            }
            for(var i = start; i < elementId.length; i++)if (!regex.test(elementId[i]) && elementId.indexOf("-") === -1 && elementId.indexOf("_") === -1 && elementId.indexOf("\\") === -1 && !numberRegex.test(elementId[i])) childElementId += "\\" + elementId[i];
            else childElementId += elementId[i];
            return childElementId;
        } else return elementId;
    };
    /**
     * Initialize the event handler.
     */ Chart.prototype.preRender = function() {
        this.element.id = this.isIdHasSpecialCharacter(this.element.id);
        // It is used for checking blazor framework or not.
        var blazor = "Blazor";
        this.isBlazor = window[blazor];
        this.allowServerDataBinding = false;
        this.markerIndex = 0;
        this.unWireEvents();
        this.initPrivateVariable();
        this.setCulture();
        this.wireEvents();
        if (this.stockChart) {
            if (this.stockChart.tooltip.header === null) this.tooltip.header = "<b>${point.x}</b>";
            if (this.stockChart.tooltip.format === null) this.tooltip.format = "High : <b>${point.high}</b><br/>Low : <b>${point.low}</b><br/>Open : <b>${point.open}</b><br/>Close : <b>${point.close}</b>";
        }
        this.element.setAttribute("dir", this.enableRtl ? "rtl" : "ltr");
    };
    Chart.prototype.initPrivateVariable = function() {
        this.animateSeries = true;
        this.delayRedraw = false;
        this.dragY = null;
        this.horizontalAxes = [];
        this.verticalAxes = [];
        this.refreshAxis();
        this.refreshDefinition(this.rows);
        this.refreshDefinition(this.columns);
        if (this.tooltipModule) this.tooltipModule.previousPoints = [];
        this.element.setAttribute("role", "region");
        this.element.setAttribute("tabindex", "0");
        this.element.setAttribute("aria-label", this.description || this.title + ". Syncfusion interactive chart.");
        if (!this.element.classList.contains("e-chart-focused")) this.element.setAttribute("class", this.element.getAttribute("class") + " e-chart-focused");
        if (this.element.id === "") {
            var collection = document.getElementsByClassName("e-chart").length;
            var elementid = "chart_" + this.chartid + "_" + collection;
            while(document.getElementById(elementid)){
                collection++;
                elementid = "chart_" + this.chartid + "_" + collection;
            }
            this.element.id = "chart_" + this.chartid + "_" + collection;
        }
        //seperate ID to differentiate chart and stock chart
        this.svgId = this.stockChart ? this.stockChart.element.id + "_stockChart_chart" : this.element.id + (this.enableCanvas ? "_canvas" : "_svg");
    };
    /**
     * To Initialize the control rendering.
     */ Chart.prototype.render = function() {
        var _this = this;
        this.svgRenderer = new (0, $aa3074f243277ee7$export$5ff52eac0871021a)(this.element.id);
        var loadEventData = {
            chart: this.isBlazor ? {} : this,
            theme: this.theme,
            name: (0, $9415fc5f023d8fac$export$11e63f7b0f3d9900),
            cancel: false
        };
        if (!this.stockChart) /**
             * Load event for the chart will be triggered only chart componet, if this is stock chart, load event did not triggered.
             */ this.trigger((0, $9415fc5f023d8fac$export$11e63f7b0f3d9900), loadEventData, function() {
            if (!loadEventData.cancel) _this.cartesianChartRendering(loadEventData);
        });
        else {
            // The fix is specific for nextjs app, as window is set as not defined for server side application like nextjs.
            this.isRtlEnabled = window.getComputedStyle(document.querySelector("body")).direction === "rtl";
            this.cartesianChartRendering(loadEventData);
        }
        this.applyZoomkit();
    };
    Chart.prototype.cartesianChartRendering = function(beforeRenderData) {
        this.theme = this.isBlazor ? beforeRenderData.theme : this.theme;
        this.setTheme();
        this.createChartSvg();
        this.markerRender = new (0, $c2211974543f8fbf$export$e98856a975cab58e)(this);
        this.calculateAreaType();
        this.calculateVisibleSeries();
        this.initTechnicalIndicators();
        this.initTrendLines();
        this.calculateVisibleAxis();
        this.processData();
        this.renderComplete();
        this.mouseMoveEvent();
        this.allowServerDataBinding = true;
    };
    /**
     * Gets the localized label by locale keyword.
     *
     * @param  {string} key key
     * @returns {string} localized label
     */ Chart.prototype.getLocalizedLabel = function(key) {
        return this.localeObject.getConstant(key);
    };
    /**
     * Initiates animation for the chart.
     *
     * @param {number} [duration] - The duration of the animation in milliseconds.
     * @returns {void}
     * @private
     */ Chart.prototype.animate = function(duration) {
        this.redraw = true;
        this.animated = true; //used to set duration as 1000 for animation at default 300
        this.duration = duration ? duration : 1000;
        if (this.tooltipModule) this.tooltipModule.removeHighlightedMarker(this.tooltipModule.previousPoints, true);
        else if (this.markerRender.previousPoints) for(var previousPoint = 0; previousPoint < this.markerRender.previousPoints.length; previousPoint++)this.markerRender.removeHighlightedMarker(this.markerRender.previousPoints[previousPoint].series, this.markerRender.previousPoints[previousPoint].point);
    };
    /**
     * Refresh the chart bounds.
     *
     * @private
     */ Chart.prototype.refreshBound = function() {
        this.rotatedDataLabelCollections = [];
        if (this.legendModule && this.legendSettings.visible) this.legendModule.getLegendOptions(this.visibleSeries, this);
        /**
         * I264230, EJ2-36761
         * Issue: Tooltip doesnot appears after zooming and hovering on same point
         * Root cause: While performing zoom, previous points in tooltip restore.
         * Fix: previous points set to empty array
         */ if (this.tooltip.enable && this.tooltipModule) this.tooltipModule.previousPoints = [];
        this.calculateStackValues();
        this.calculateBounds();
        //this prevents the initial rendering of stock chart
        if (this.stockChart && !this.stockChart.rangeFound) {
            if (this.stockChart.enablePeriodSelector || this.stockChart.enableSelector) return null;
        }
        this.renderElements();
        (0, $11815a21a80ae2b7$export$f883456a56996078)("chartmeasuretext");
        this.removeSelection();
        if (this.markerRender) this.markerRender.mergeXvalues(this.visibleSeries);
    };
    /**
     * To calcualte the stack values.
     *
     * @returns {void}
     * @private
     */ Chart.prototype.calculateStackValues = function() {
        var series;
        var isCalculateStacking = false;
        for(var i = 0, len = this.visibleSeries.length; i < len; i++){
            series = this.visibleSeries[i];
            if (series.visible) series.position = series.rectCount = undefined;
            if ((series.type.indexOf("Stacking") !== -1 || series.drawType.indexOf("Stacking") !== -1 && this.chartAreaType === "PolarRadar") && !isCalculateStacking) {
                series.calculateStackedValue(series.type.indexOf("100") > -1, this);
                isCalculateStacking = true;
            }
        }
    };
    Chart.prototype.removeSelection = function() {
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            if (series.visible) for(var _b = 0, _c = series.points; _b < _c.length; _b++){
                var point = _c[_b];
                point.isSelect = false;
            }
        }
        if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_ej2_drag_multi_group")) {
            if (this.selectionMode.indexOf("Drag") > -1) this.selectionModule.filterArray = [];
            (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_ej2_drag_multi_group");
            this.selectionModule.calculateDragSelectedElements(this, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0), true);
        } else if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_ej2_drag_group")) {
            if (this.selectionMode !== "Lasso") this.selectionModule.filterArray = [];
            (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_ej2_drag_group");
            this.selectionModule.calculateDragSelectedElements(this, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, 0, 0), true);
        }
    };
    Chart.prototype.renderElements = function() {
        this.renderBorder();
        this.renderTitle();
        this.renderAreaBorder();
        this.renderSeriesElements(this.renderAxes());
        this.renderLegend();
        this.applyZoomkit();
        this.performSelection();
        this.setSecondaryElementPosition();
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var value = _a[_i];
            (0, $c2qqN.updateBlazorTemplate)(this.element.id + "_DataLabel", "Template", value.marker.dataLabel);
        }
        this.renderAnnotation();
    };
    /**
     * To render the legend
     *
     * @private
     */ Chart.prototype.renderAxes = function() {
        this.yAxisElements = this.renderer.createGroup({
            id: this.element.id + "yAxisCollection"
        });
        var axisElement;
        if (this.rows.length > 0 && this.columns.length > 0) axisElement = this.chartAxisLayoutPanel.renderAxes();
        if (this.stripLineModule) this.stripLineModule.renderStripLine(this, "Behind", this.axisCollections);
        return axisElement;
    };
    /**
     * To render the legend
     */ Chart.prototype.renderLegend = function() {
        if (this.legendModule && this.legendModule.legendCollections.length && this.legendSettings.visible) {
            this.legendModule.calTotalPage = true;
            var borderWidth = this.legendSettings.border.width;
            var bounds = this.legendModule.legendBounds;
            var rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(bounds.x, bounds.y, bounds.width, bounds.height);
            if (this.enableCanvas) {
                rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x - borderWidth / 2, rect.y - borderWidth / 2, rect.width + borderWidth, rect.height + borderWidth);
                this.renderer.canvasClip(rect);
            }
            this.legendModule.renderLegend(this, this.legendSettings, bounds);
            if (this.enableCanvas) this.renderer.canvasRestore();
        }
        if (!this.redraw) {
            if (!this.stockChart) this.element.appendChild(this.svgObject);
            else if (!(0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.stockChart.chartObject.id)) this.stockChart.mainObject.appendChild(this.svgObject);
        }
    };
    /**
     * To set the left and top position for data label template for center aligned chart.
     *
     * @returns {void}
     */ Chart.prototype.setSecondaryElementPosition = function() {
        var element = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Secondary_Element");
        if (!element) return;
        var rect = this.element.getBoundingClientRect();
        var svgRect = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.svgId).getBoundingClientRect();
        element.style.left = Math.max((svgRect.left - rect.left) / this.scaleX, 0) + "px";
        element.style.top = Math.max((svgRect.top - rect.top) / this.scaleY, 0) + "px";
    };
    Chart.prototype.initializeModuleElements = function() {
        this.dataLabelCollections = [];
        var elementId = this.element.id;
        if (this.series.length) this.seriesElements = this.svgRenderer.createGroup({
            id: elementId + "SeriesCollection"
        });
        if (this.indicators.length) this.indicatorElements = this.renderer.createGroup({
            id: elementId + "IndicatorCollection"
        });
        if (this.hasTrendlines()) this.trendLineElements = this.renderer.createGroup({
            id: elementId + "TrendLineCollection"
        });
        this.dataLabelElements = this.renderer.createGroup({
            id: elementId + "DataLabelCollection"
        });
    };
    Chart.prototype.hasTrendlines = function() {
        var isTrendline;
        for(var _i = 0, _a = this.series; _i < _a.length; _i++){
            var series = _a[_i];
            isTrendline = series.trendlines.length ? true : false;
            if (isTrendline) break;
        }
        return isTrendline;
    };
    Chart.prototype.renderSeriesElements = function(axisElement) {
        // Initialize the series elements values
        this.initializeModuleElements();
        var elementId = this.element.id;
        if (this.element.tagName !== "g") {
            var tooltipDiv = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, elementId + "_Secondary_Element") || this.createElement("div");
            tooltipDiv.id = elementId + "_Secondary_Element";
            tooltipDiv.style.cssText = "position: relative";
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(false, this.element, tooltipDiv, this.redraw);
        }
        // For canvas
        if (this.enableCanvas) {
            var tooltipdiv = document.getElementById(elementId + "_Secondary_Element");
            tooltipdiv = !tooltipdiv ? this.createElement("div", {
                id: elementId + "_Secondary_Element",
                attrs: {
                    "style": "position: relative; left:0px; top:0px"
                }
            }) : tooltipdiv;
            var svg = this.svgRenderer.createSvg({
                id: elementId + "_tooltip_svg",
                width: this.availableSize.width,
                height: this.availableSize.height
            });
            svg.style.cssText = "position: absolute; pointer-events: none";
            tooltipdiv.appendChild(svg);
        }
        // For userInteraction
        if (this.tooltip.enable && !this.stockChart) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.renderer.createGroup({
            id: elementId + "_UserInteraction",
            style: "pointer-events:none;"
        }), this.redraw);
        if (this.rows.length > 0 && this.columns.length > 0) {
            this.initializeIndicator();
            this.initializeTrendLine();
            this.renderSeries();
            // Trendline is append to DOM after the series
            if (this.trendLineElements) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.trendLineElements, this.redraw);
            this.appendElementsAfterSeries(axisElement);
        }
    };
    /**
     * Renders the series on the chart.
     *
     * @private
     * @returns {void}
     */ Chart.prototype.renderSeries = function() {
        var visibility;
        if (this.enableCanvas) // To clip the series rect for canvas
        this.renderer.canvasClip(this.chartAxisLayoutPanel.seriesClipRect);
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.category === "TrendLine") visibility = this.series[item.sourceIndex].trendlines[item.index].visible;
            else visibility = item.visible;
            if (visibility) {
                this.visible++;
                (0, $11815a21a80ae2b7$export$eb71090255ea483d)(item, this.enableCanvas);
                if (this.enableCanvas) // To render scatter and bubble series in canvas
                this.renderCanvasSeries();
                item.renderSeries(this);
            } else if (item.isLegendClicked && (item.type.indexOf("StackingArea") > -1 || item.type.indexOf("StackingBar") > -1 || item.type.indexOf("StackingColumn") > -1)) {
                (0, $11815a21a80ae2b7$export$eb71090255ea483d)(item, this.enableCanvas);
                item.renderSeries(this);
            }
        }
        if (this.enableCanvas) this.renderer.canvasRestore();
        this.visible = 0;
        var options = {
            "id": this.element.id + "_ChartAreaClipRect_",
            "x": this.chartAxisLayoutPanel.seriesClipRect.x,
            "y": this.chartAxisLayoutPanel.seriesClipRect.y,
            "width": this.chartAxisLayoutPanel.seriesClipRect.width,
            "height": this.chartAxisLayoutPanel.seriesClipRect.height,
            "fill": "transparent",
            "stroke-width": 1,
            "stroke": "Gray"
        };
        if (!this.seriesElements || options.height < 0 || options.width < 0) return;
        var clipRectElement;
        if (this.chartAreaType === "PolarRadar") clipRectElement = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(this.redraw, options, this.renderer, "drawCircularClipPath");
        else clipRectElement = (0, $11815a21a80ae2b7$export$c7ca2732e2882d39)(this.redraw, options, this.renderer);
        if (!this.enableCanvas) this.seriesElements.appendChild(clipRectElement);
        var seriesSvg = document.getElementById(this.element.id + "_series_svg");
        if (seriesSvg) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(false, seriesSvg, this.seriesElements, this.redraw);
        else (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.seriesElements, this.redraw);
    };
    Chart.prototype.renderCanvasSeries = function() {
        // const svgElement: Element;
        // svgElement = (this.enableCanvas) ?
        //     svgElement : this.svgObject;
        // const canvas: boolean = (this.enableCanvas) ?
        //     false : this.enableCanvas;
        var svgElement;
        // let canvas: boolean;
        if (this.enableCanvas) {
            var tempSvgElement = svgElement;
            svgElement = tempSvgElement;
        // canvas = false;
        } else svgElement = this.svgObject;
    };
    Chart.prototype.initializeIndicator = function() {
        for(var _i = 0, _a = this.indicators; _i < _a.length; _i++){
            var indicator = _a[_i];
            if (this[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(indicator.type) + "IndicatorModule"]) this[(0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(indicator.type) + "IndicatorModule"].createIndicatorElements(this, indicator, indicator.index);
        }
        if (this.indicatorElements) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.indicatorElements, this.redraw);
    };
    Chart.prototype.initializeTrendLine = function() {
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            if (series.trendlines.length) this.trendLineModule.getTrendLineElements(series, this);
        }
    };
    Chart.prototype.appendElementsAfterSeries = function(axisElement) {
        if (this.chartAreaType === "PolarRadar") (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.yAxisElements, this.redraw);
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, axisElement, this.redraw);
        if (this.zoomModule && this.zoomSettings.enableScrollbar && this.scrollElement.childElementCount || this.scrollElement && this.scrollElement.childElementCount) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(false, (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Secondary_Element"), this.scrollElement, this.redraw);
        if (this.stripLineModule) this.stripLineModule.renderStripLine(this, "Over", this.axisCollections);
        if (!this.tooltip.enable || this.stockChart) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.renderer.createGroup({
            id: this.element.id + "_UserInteraction",
            style: "pointer-events:none;"
        }), this.redraw);
        if (this.stockChart) this.stockChart.calculateStockEvents();
    };
    Chart.prototype.applyZoomkit = function() {
        /**
         * Issue: Zoomkit not visible after performing refresh()
         * Fix: this method called without checking `zoomModule.isZoomed`
         */ if (this.chartAreaType === "PolarRadar") return;
        if ((!this.redraw || this.zoomRedraw) && this.zoomModule && (!this.zoomSettings.enablePan || this.zoomModule.performedUI || this.zoomSettings.showToolbar)) this.zoomModule.applyZoomToolkit(this, this.axisCollections);
    };
    /**
     * Render annotation perform here.
     *
     * @private
     * @returns {void}
     */ Chart.prototype.renderAnnotation = function() {
        if (this.annotationModule) //for stock chart, stock chart's id is added to render the annotations
        this.annotationModule.renderAnnotations((0, $11815a21a80ae2b7$export$d16800b7e59a8051)((this.stockChart ? this.stockChart.element.id : this.element.id) + "_Secondary_Element"));
    };
    Chart.prototype.performSelection = function() {
        var selectedDataIndexes = [];
        if (this.selectionModule) {
            selectedDataIndexes = (0, $3EnZW.extend)([], this.selectionModule.selectedDataIndexes, null, true);
            this.selectionModule.invokeSelection(this);
        }
        if (this.highlightModule) this.highlightModule.invokeHighlight(this);
        if (selectedDataIndexes.length > 0) {
            this.selectionModule.selectedDataIndexes = selectedDataIndexes;
            this.selectionModule.redrawSelection(this, this.selectionMode);
        }
    };
    Chart.prototype.processData = function(render) {
        if (render === void 0) render = true;
        this.visibleSeriesCount = 0;
        var check = true;
        var prevPointCount = 0;
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            if (!series.visible && !this.legendSettings.visible) {
                this.visibleSeriesCount++;
                continue;
            }
            if (series.category !== "Indicator" && series.category !== "TrendLine") this.initializeDataModule(series);
        }
        for(var _b = 0, _c = this.indicators; _b < _c.length; _b++){
            var indicator = _c[_b];
            if (indicator.dataSource) {
                var techIndicator = indicator;
                this.initializeDataModule(techIndicator);
                check = false;
            }
        }
        if (render && (!this.visibleSeries.length || this.visibleSeriesCount === this.visibleSeries.length && check)) {
            this.refreshBound();
            this.trigger("loaded", {
                chart: this.isBlazor ? {} : this
            });
        }
        if (!this.stockChart && this.visibleSeries.length > 0) for(var _d = 0, _e = this.visibleSeries; _d < _e.length; _d++){
            var series = _e[_d];
            if (!(0, $3EnZW.isNullOrUndefined)(series.points)) {
                this.maxPointCount = Math.max(prevPointCount, series.points.length);
                prevPointCount = series.points.length;
            }
        }
    };
    Chart.prototype.initializeDataModule = function(series) {
        series.xData = [];
        series.yData = [];
        var dataSource;
        var isAngular = "isAngular";
        if (this[isAngular]) dataSource = Object.keys(series.dataSource).length ? series.dataSource : this.dataSource;
        else dataSource = series.dataSource || this.dataSource;
        series.dataModule = new (0, $f2551c5eaeb23533$export$2d0294657ab35f1b)(dataSource, series.query);
        series.points = [];
        series.refreshDataManager(this);
    };
    /**
     * To provide the array of modules needed for control rendering.
     *
     * @returns {void} - To provide the array of modules needed for control rendering.
     * @private
     */ Chart.prototype.calculateBounds = function() {
        var margin = this.margin;
        // Title Height;
        var titleHeight = 0;
        var subTitleHeight = 0;
        var padding = this.titleStyle.position === "Top" || this.titleStyle.position === "Bottom" && !this.legendSettings.visible ? 15 : 5;
        var left = margin.left + this.border.width;
        var width = this.availableSize.width - left - margin.right - this.border.width;
        var elementSpacing = 0;
        this.titleCollection = [];
        this.subTitleCollection = [];
        if (this.title) {
            this.titleCollection = (0, $11815a21a80ae2b7$export$70d1bf7729efff40)(this.title, this.titleStyle, width, this.enableRtl, this.themeStyle.chartTitleFont);
            titleHeight = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.title, this.titleStyle, this.themeStyle.chartTitleFont).height * this.titleCollection.length + padding;
            if (this.subTitle) {
                this.subTitleCollection = (0, $11815a21a80ae2b7$export$70d1bf7729efff40)(this.subTitle, this.subTitleStyle, width, this.enableRtl, this.themeStyle.chartSubTitleFont);
                subTitleHeight = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.subTitle, this.subTitleStyle, this.themeStyle.chartSubTitleFont).height * this.subTitleCollection.length + padding;
            }
        } else if (this.legendSettings.position !== "Top" && this.border.width) elementSpacing = 10;
        var top = margin.top + elementSpacing + this.border.width + this.chartArea.border.width * 0.5;
        var height = this.availableSize.height - top - this.border.width - margin.bottom;
        var marginTotal = subTitleHeight + titleHeight + this.titleStyle.border.width + this.subTitleStyle.border.width;
        switch(this.titleStyle.position){
            case "Top":
                top += marginTotal;
                height -= marginTotal;
                break;
            case "Bottom":
                height -= marginTotal;
                break;
            case "Left":
                left += marginTotal;
                width -= marginTotal;
                break;
            case "Right":
                left -= this.titleStyle.border.width + this.subTitleStyle.border.width;
                width -= marginTotal;
                break;
        }
        if (this.stockChart && this.stockChart.legendSettings.visible && this.stockChart.stockLegendModule) {
            if (this.stockChart.legendSettings.position === "Top") top += this.stockChart.stockLegendModule.legendBounds.height;
            else if (this.stockChart.legendSettings.position === "Left") left += this.stockChart.stockLegendModule.legendBounds.width;
        }
        this.initialClipRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(left, top, width, height);
        if (this.legendModule && this.legendSettings.visible) this.legendModule.calculateLegendBounds(this.initialClipRect, this.availableSize, null);
        this.chartAxisLayoutPanel.measureAxis(this.initialClipRect);
    };
    /**
     * Prints the chart or specified element.
     *
     * @param {string[] | string | Element} id - The ID or array of IDs of the elements to print.
     * @returns {void}
     */ Chart.prototype.print = function(id) {
        var exportChart = new (0, $09cfe3d07a100f05$export$aba05cf1a7229db5)(this);
        var width = this.width;
        if (this.getModuleName() === "chart" && parseInt(this.width, 10) >= 80 && this.width.indexOf("%") > -1) {
            this.width = "80%";
            this.dataBind();
        }
        exportChart.print(id);
        if (this.getModuleName() === "chart" && parseInt(this.width, 10) >= 80 && this.width.indexOf("%") > -1) {
            this.width = width;
            this.dataBind();
        }
    };
    /**
     * Defines the trendline initialization.
     *
     * @returns {void}
     */ Chart.prototype.initTrendLines = function() {
        this.isProtectedOnChange = true;
        for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            var trendIndex = 0;
            for(var _b = 0, _c = series.trendlines; _b < _c.length; _b++){
                var trendline = _c[_b];
                var trendLine = trendline;
                if (this.trendLineModule) {
                    trendLine.index = trendIndex;
                    trendLine.sourceIndex = series.index;
                    this.trendLineModule.initSeriesCollection(trendLine, this);
                    if (trendLine.targetSeries) {
                        trendLine.targetSeries.xAxisName = series.xAxisName;
                        trendLine.targetSeries.yAxisName = series.yAxisName;
                        this.visibleSeries.push(trendLine.targetSeries);
                    }
                }
                trendIndex++;
            }
        }
        this.isProtectedOnChange = false;
    };
    Chart.prototype.calculateAreaType = function() {
        var series = this.series[0];
        this.chartArea.border.width = this.stockChart ? 0 : this.chartArea.border.width;
        if (series) this.requireInvertedAxis = series.type.indexOf("Bar") !== -1 && !this.isTransposed || series.type.indexOf("Bar") === -1 && this.isTransposed && this.chartAreaType !== "PolarRadar";
        this.chartAxisLayoutPanel = this.chartAreaType === "PolarRadar" ? this.polarSeriesModule || this.radarSeriesModule : new (0, $bf0167721456a91c$export$796b14441ba1ebe8)(this);
    };
    /**
     * Calculate the visible axis.
     *
     * @private
     * @returns {void}
     */ Chart.prototype.calculateVisibleAxis = function() {
        var axis;
        var axes = [
            this.primaryXAxis,
            this.primaryYAxis
        ];
        axes = this.chartAreaType === "Cartesian" ? axes.concat(this.axes) : axes;
        if (this.paretoSeriesModule && this.series[0].type === "Pareto") axes = axes.concat(this.paretoSeriesModule.paretoAxes);
        this.axisCollections = [];
        if (this.zoomModule) {
            this.zoomModule.isPanning = this.zoomModule.isAxisZoomed(axes) && this.zoomSettings.enablePan;
            this.svgObject.setAttribute("cursor", this.zoomModule.isPanning ? "pointer" : "auto");
            if (this.scrollBarModule) this.scrollBarModule.axes = axes;
        }
        if (this.scrollSettingEnabled) {
            if (this.scrollBarModule) this.scrollBarModule.axes = axes;
        }
        for(var i = 0, len = axes.length; i < len; i++){
            axis = axes[i];
            axis.series = [];
            axis.labels = [];
            axis.indexLabels = {};
            axis.orientation = i === 0 ? this.requireInvertedAxis ? "Vertical" : "Horizontal" : i === 1 ? this.requireInvertedAxis ? "Horizontal" : "Vertical" : axis.orientation;
            for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
                var series = _a[_i];
                this.initAxis(series, axis, true);
                if (series.category === "Pareto" && series.type === "Line" && series.yAxis) series.yAxis.internalVisibility = series.paretoOptions.showAxis;
            }
            for(var _b = 0, _c = this.indicators; _b < _c.length; _b++){
                var indicator = _c[_b];
                this.initAxis(indicator, axis, false);
            }
            if (this.scrollBarModule && !axis.zoomingScrollBar) this.scrollBarModule.injectTo(axis, this);
            if (axis.orientation != null) this.axisCollections.push(axis);
        }
        if (this.rows.length > 0 && this.columns.length > 0) this.chartAxisLayoutPanel.measure();
    };
    Chart.prototype.initAxis = function(series, axis, isSeries) {
        if (series.xAxisName === axis.name || series.xAxisName == null && axis.name === "primaryXAxis") {
            axis.orientation = this.requireInvertedAxis ? "Vertical" : "Horizontal";
            series.xAxis = axis;
            if (isSeries) axis.series.push(series);
        } else if (series.yAxisName === axis.name || series.yAxisName == null && axis.name === "primaryYAxis") {
            axis.orientation = this.requireInvertedAxis ? "Horizontal" : "Vertical";
            series.yAxis = axis;
            if (isSeries) axis.series.push(series);
        }
    };
    Chart.prototype.initTechnicalIndicators = function() {
        var i = 0;
        for(var _i = 0, _a = this.indicators; _i < _a.length; _i++){
            var indicator = _a[_i];
            var techIndicator = indicator;
            var type = (0, $11815a21a80ae2b7$export$d238e91bd4ec1248)(techIndicator.type);
            if (this[type + "IndicatorModule"]) {
                techIndicator.index = i;
                this[type + "IndicatorModule"].initSeriesCollection(techIndicator, this);
                for(var _b = 0, _c = techIndicator.targetSeries; _b < _c.length; _b++){
                    var targetSeries = _c[_b];
                    if (indicator.seriesName || indicator.dataSource) this.visibleSeries.push(targetSeries);
                }
            }
            i++;
        }
    };
    /**
     * Refreshes the technical indicator for the specified series.
     *
     * @param {SeriesBase} series - The series for which to refresh the technical indicator.
     * @returns {void}
     * @private
     */ Chart.prototype.refreshTechnicalIndicator = function(series) {
        if (this.indicators.length) {
            var targetIndicator = null;
            if (series instanceof (0, $54f817a374cfcee1$export$ed28a77b2a3badcf) && series.category !== "Indicator") for(var _i = 0, _a = this.indicators; _i < _a.length; _i++){
                var indicator = _a[_i];
                if (indicator.seriesName === series.name && !indicator.dataSource) {
                    targetIndicator = indicator;
                    targetIndicator.setDataSource(series, this);
                }
            }
            else if (series instanceof (0, $7abe8d19c400d6d4$export$afdd85645f5afc67)) {
                targetIndicator = series;
                targetIndicator.setDataSource(series instanceof (0, $54f817a374cfcee1$export$ed28a77b2a3badcf) ? series : null, this);
            }
        }
    };
    Chart.prototype.calculateVisibleSeries = function() {
        var series;
        this.visibleSeries = [];
        var colors = this.palettes.length ? this.palettes : (0, $11b41024b246dc37$export$658435d9066c1b51)(this.theme);
        var count = colors.length;
        var seriesCollection = this.series.sort(function(a, b) {
            return a.zOrder - b.zOrder;
        });
        for(var i = 0, len = seriesCollection.length; i < len; i++){
            series = seriesCollection[i];
            // for y axis label issue during chart navigation
            series.category = seriesCollection[0].type === "Pareto" ? "Pareto" : "Series";
            series.index = i;
            series.interior = series.fill || colors[i % count];
            if (!series.marker.shape && (series.marker.visible || series.type === "Scatter" || series.drawType === "Scatter")) {
                series.marker.shape = (0, $c2211974543f8fbf$export$eb57c60e13745871)[this.markerIndex % 10];
                this.markerIndex++;
            }
            if (this.isSecondaryAxis(series.xAxis)) series.xAxis.internalVisibility = series.xAxis.series.some(function(value) {
                return value.visible;
            });
            if (this.isSecondaryAxis(series.yAxis)) series.yAxis.internalVisibility = series.yAxis.series.some(function(value) {
                return value.visible;
            });
            switch(series.type){
                case "Bar":
                case "StackingBar":
                case "StackingBar100":
                    if (seriesCollection[0].type.indexOf("Bar") === -1) continue;
                    break;
                case "Polar":
                case "Radar":
                    if (this.chartAreaType !== "PolarRadar") continue;
                    if (this.chartAreaType === "PolarRadar" && (series.xAxisName !== null && this.primaryXAxis.name !== series.xAxisName || series.yAxisName !== null && this.primaryYAxis.name !== series.yAxisName)) continue;
                    break;
                case "Pareto":
                    this.visibleSeries.push(series);
                    this.paretoSeriesModule.initSeries(series, this);
                    continue;
                default:
                    if (this.chartAreaType === "PolarRadar" || seriesCollection[0].type.indexOf("Bar") > -1) continue;
                    break;
            }
            this.visibleSeries.push(series);
            seriesCollection[i] = series;
        }
    };
    Chart.prototype.isSecondaryAxis = function(axis) {
        return this.axes.indexOf(axis) > -1;
    };
    Chart.prototype.renderTitle = function() {
        var rect;
        var margin = this.margin;
        var elementSpacing = 5;
        if (this.title) {
            var getAnchor = (0, $11815a21a80ae2b7$export$c2f41ec8f9331264)(this.titleStyle.textAlignment, this.enableRtl);
            var elementSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.title, this.titleStyle, this.themeStyle.chartTitleFont);
            rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(margin.left, 0, this.availableSize.width - margin.left - margin.right, 0);
            var borderWidth = this.titleStyle.border.width;
            var positionY = this.margin.top + elementSize.height * 3 / 4;
            var positionX = (0, $11815a21a80ae2b7$export$c12580d46760c769)(rect, this.titleStyle || this.themeStyle.chartTitleFont) + borderWidth;
            var rotation = void 0;
            var alignment = this.titleStyle.textAlignment;
            var subtitleSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.subTitle, this.subTitleStyle, this.themeStyle.chartSubTitleFont);
            switch(this.titleStyle.position){
                case "Top":
                    positionY += borderWidth * 0.5;
                    positionX += getAnchor === "start" ? borderWidth * 0.5 + this.border.width : getAnchor === "end" ? -borderWidth * 2 - this.border.width : 0;
                    break;
                case "Bottom":
                    positionX += getAnchor === "start" ? borderWidth * 0.5 + this.border.width : getAnchor === "end" ? -borderWidth * 2 - this.border.width : 0;
                    positionY = this.availableSize.height - this.margin.bottom - subtitleSize.height - elementSize.height / 2 - borderWidth * 0.5 - this.subTitleStyle.border.width * 0.5;
                    break;
                case "Left":
                    positionX = this.margin.left + elementSize.height * 3 / 4 + borderWidth * 0.5;
                    positionY = alignment === "Near" ? margin.bottom + borderWidth * 0.5 + this.border.width : alignment === "Far" ? this.availableSize.height - margin.bottom - borderWidth * 0.5 - this.border.width : this.availableSize.height / 2;
                    getAnchor = alignment === "Near" ? "end" : alignment === "Far" ? "start" : "middle";
                    getAnchor = this.enableRtl ? getAnchor === "end" ? "start" : getAnchor === "start" ? "end" : getAnchor : getAnchor;
                    rotation = "rotate(-90," + positionX + "," + positionY + ")";
                    break;
                case "Right":
                    positionX = this.availableSize.width - this.margin.right - elementSize.height * 3 / 4 - borderWidth * 0.5;
                    positionY = alignment === "Near" ? margin.bottom + borderWidth * 0.5 + this.border.width : alignment === "Far" ? this.availableSize.height - margin.bottom - borderWidth * 0.5 - this.border.width : this.availableSize.height / 2;
                    getAnchor = alignment === "Near" ? "start" : alignment === "Far" ? "end" : "middle";
                    getAnchor = this.enableRtl ? getAnchor === "end" ? "start" : getAnchor === "start" ? "end" : getAnchor : getAnchor;
                    rotation = "rotate(90," + positionX + "," + positionY + ")";
                    break;
                case "Custom":
                    positionX = this.titleStyle.x;
                    positionY = this.titleStyle.y;
                    getAnchor = "middle";
                    break;
            }
            var borderOptions = {
                "id": this.element.id + "_ChartTitleBorder",
                "x": positionX - (getAnchor === "middle" ? elementSize.width / 2 + elementSpacing : getAnchor === "end" ? elementSize.width + elementSpacing : elementSpacing),
                "y": positionY - elementSize.height + elementSize.height / 4,
                "rx": this.titleStyle.border.cornerRadius,
                "ry": this.titleStyle.border.cornerRadius,
                "width": elementSize.width + elementSpacing * 2,
                "height": elementSize.height * this.titleCollection.length,
                "fill": this.titleStyle.background,
                "stroke-width": borderWidth,
                "stroke": this.titleStyle.border.color,
                "transform": rotation ? rotation : "",
                "d": ""
            };
            var htmlObject = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartTitleBorder", borderOptions, this.renderer) || this.renderer.drawRectangle(borderOptions);
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, htmlObject, this.redraw);
            var options = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(this.element.id + "_ChartTitle", positionX, positionY, getAnchor, this.titleCollection, rotation, "auto");
            var element = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartTitle", options, this.renderer) || (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(this.renderer, options, this.titleStyle, this.titleStyle.color || this.themeStyle.chartTitleFont.color, this.svgObject, null, null, null, null, null, null, null, null, this.enableCanvas, null, this.themeStyle.chartTitleFont);
            if (element) {
                element.setAttribute("tabindex", "0");
                element.setAttribute("class", "e-chart-focused");
            }
            if (this.subTitle) this.renderSubTitle(options);
        }
    };
    Chart.prototype.renderSubTitle = function(options) {
        var maxWidth = 0;
        var titleWidth = 0;
        var padding = 10;
        var alignment = this.titleStyle.textAlignment;
        for(var _i = 0, _a = this.titleCollection; _i < _a.length; _i++){
            var titleText = _a[_i];
            titleWidth = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(titleText, this.titleStyle, this.themeStyle.chartTitleFont).width;
            maxWidth = titleWidth > maxWidth ? titleWidth : maxWidth;
        }
        var subTitleElementSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.subTitleCollection.reduce(function(a, b) {
            return a.length > b.length ? a : b;
        }), this.subTitleStyle, this.themeStyle.chartSubTitleFont);
        var getAnchor = (0, $11815a21a80ae2b7$export$c2f41ec8f9331264)(this.subTitleStyle.textAlignment, this.enableRtl);
        var rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(alignment === "Center" ? options.x - maxWidth * 0.5 : alignment === "Far" ? options.x - maxWidth : options.x, 0, maxWidth, 0);
        if (this.titleStyle.position === "Left") rect.x = alignment === "Center" ? options.x - maxWidth * 0.5 : alignment === "Far" ? this.margin.left + subTitleElementSize.height * 3 / 4 : options.x - maxWidth;
        var elementSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.title, this.titleStyle, this.themeStyle.chartTitleFont);
        var positionY = options.y * options.text.length + subTitleElementSize.height + padding / 2 + this.titleStyle.border.width + this.subTitleStyle.border.width * 0.5;
        if (this.titleStyle.position === "Bottom") positionY = options.y * options.text.length + padding / 2 + elementSize.height / 2 + subTitleElementSize.height / 2;
        var borderOptions = {
            "id": this.element.id + "_ChartSubTitleBorder",
            "x": (0, $11815a21a80ae2b7$export$c12580d46760c769)(rect, this.subTitleStyle) - (getAnchor === "middle" ? subTitleElementSize.width / 2 + padding / 2 : getAnchor === "end" ? subTitleElementSize.width + padding / 2 : padding / 2),
            "y": positionY - subTitleElementSize.height + subTitleElementSize.height / 4,
            "rx": this.subTitleStyle.border.cornerRadius,
            "ry": this.subTitleStyle.border.cornerRadius,
            "width": subTitleElementSize.width + padding,
            "height": subTitleElementSize.height * this.subTitleCollection.length,
            "fill": this.subTitleStyle.background,
            "stroke-width": this.subTitleStyle.border.width,
            "stroke": this.subTitleStyle.border.color,
            "transform": options.transform,
            "d": ""
        };
        var htmlObject = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartSubTitleBorder", borderOptions, this.renderer) || this.renderer.drawRectangle(borderOptions);
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, htmlObject, this.redraw);
        var subTitleOptions = new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(this.element.id + "_ChartSubTitle", (0, $11815a21a80ae2b7$export$c12580d46760c769)(rect, this.subTitleStyle), positionY, (0, $11815a21a80ae2b7$export$c2f41ec8f9331264)(this.subTitleStyle.textAlignment, this.enableRtl), this.subTitleCollection, options.transform, "auto");
        var element = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartSubTitle", subTitleOptions, this.renderer) || (0, $11815a21a80ae2b7$export$a06ce713d4aea371)(this.renderer, subTitleOptions, this.subTitleStyle, this.subTitleStyle.color || this.themeStyle.chartSubTitleFont.color, this.svgObject, null, null, null, null, null, null, null, null, this.enableCanvas, null, this.themeStyle.chartSubTitleFont);
    };
    Chart.prototype.renderBorder = function() {
        var x = 0;
        var y = 0;
        var width = this.border.width;
        var backGroundImage = this.backgroundImage;
        var fillColor = backGroundImage ? "transparent" : this.background || this.themeStyle.background;
        if (this.stockChart && this.stockChart.legendSettings.visible && this.stockChart.stockLegendModule) {
            if (this.stockChart.legendSettings.position === "Top") y += this.stockChart.stockLegendModule.legendBounds.height;
            else if (this.stockChart.legendSettings.position === "Left") x += this.stockChart.stockLegendModule.legendBounds.width;
        }
        var rect = new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(this.element.id + "_ChartBorder", fillColor, this.border, 1, new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(width * 0.5 + x, width * 0.5 + y, this.availableSize.width - width, this.availableSize.height - width), 0, 0, "", this.border.dashArray);
        this.htmlObject = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartBorder", rect, this.renderer) || this.renderer.drawRectangle(rect);
        this.htmlObject.setAttribute("aria-hidden", "true");
        (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.htmlObject, this.redraw);
        // to draw back ground image for chart
        if (backGroundImage) {
            var image = new (0, $11815a21a80ae2b7$export$5435ab62ca6c218c)(this.availableSize.height - width, this.availableSize.width - width, backGroundImage, 0, 0, this.element.id + "_ChartBackground", "visible", "none");
            this.htmlObject = (0, $11815a21a80ae2b7$export$8b065989b2d63753)(this.redraw, this.element.id + "_ChartBackground", image, this.renderer) || this.renderer.drawImage(image);
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.htmlObject, this.redraw);
        }
    };
    /**
     * Renders the border for the area.
     *
     * @returns {void}
     * @private
     */ Chart.prototype.renderAreaBorder = function() {
        if (this.chartAreaType === "PolarRadar") return null;
        else {
            var element = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_ChartAreaBorder");
            var previousRect = element ? new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(+element.getAttribute("x"), +element.getAttribute("y"), +element.getAttribute("width"), +element.getAttribute("height")) : null;
            var rect = new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(this.element.id + "_ChartAreaBorder", this.chartArea.background, {
                width: this.chartArea.border.width,
                color: this.chartArea.border.color || this.themeStyle.areaBorder
            }, this.chartArea.opacity, this.chartAxisLayoutPanel.seriesClipRect, 0, 0, "", this.chartArea.border.dashArray);
            if (rect.height < 0 || rect.width < 0) return null;
            this.htmlObject = this.renderer.drawRectangle(rect);
            this.htmlObject.setAttribute("aria-hidden", "true");
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.htmlObject, this.redraw, true, "x", "y", null, null, true, true, previousRect);
            this.htmlObject = null;
        }
        // to draw back ground image for chart area
        var backGroundImage = this.chartArea.backgroundImage;
        if (backGroundImage) {
            var width = this.chartArea.border.width;
            var image = new (0, $11815a21a80ae2b7$export$5435ab62ca6c218c)(this.initialClipRect.height - width, this.initialClipRect.width - width, backGroundImage, this.initialClipRect.x, this.initialClipRect.y, this.element.id + "_ChartAreaBackground", "visible", "none");
            this.htmlObject = this.renderer.drawImage(image);
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.enableCanvas, this.svgObject, this.htmlObject, this.redraw, true, "x", "y", null, null, true, true);
        }
    };
    /**
     * To add series for the chart
     *
     * @param {SeriesModel[]} seriesCollection - Defines the series collection to be added in chart.
     * @returns {void}.
     */ Chart.prototype.addSeries = function(seriesCollection) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        for(var _i = 0, seriesCollection_1 = seriesCollection; _i < seriesCollection_1.length; _i++){
            var series = seriesCollection_1[_i];
            series = new (0, $54f817a374cfcee1$export$ed28a77b2a3badcf)(this, "series", series);
            this.series.push(series);
        }
        this.refresh();
        window.scrollTo(0, scrollTop);
    };
    /**
     * To Remove series for the chart
     *
     * @param {number} index - Defines the series index to be remove in chart series
     * @returns {void}
     */ Chart.prototype.removeSeries = function(index) {
        this.redraw = false; //fix for remove svg not working when use animatemethod.
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.visibleSeries[index]) {
            this.visibleSeries[index].xAxis.orientation = null;
            this.visibleSeries[index].yAxis.orientation = null;
        }
        for(var i = 0; i < this.axes.length; i++)if (this.axes[i].orientation === null) this.axes.splice(i, 1);
        this.series.splice(index, 1);
        this.refresh();
        window.scrollTo(0, scrollTop);
    };
    /**
     * Clear all series from the chart.
     *
     * @returns {void}.
     */ Chart.prototype.clearSeries = function() {
        this.series = [];
        this.refresh();
    };
    /**
     * To add secondary axis for the chart
     *
     * @param {AxisModel[]} axisCollection - Defines the axis collection to be added in chart.
     * @returns {void}.
     */ Chart.prototype.addAxes = function(axisCollection) {
        for(var _i = 0, axisCollection_1 = axisCollection; _i < axisCollection_1.length; _i++){
            var axis = axisCollection_1[_i];
            axis = new (0, $691dde0edd52f9f0$export$d06866a9fb0606da)(this, "axes", axis);
            if (this.isBlazor) {
                axis.interval = isNaN(axis.interval) ? null : axis.interval;
                axis.desiredIntervals = isNaN(axis.desiredIntervals) ? null : axis.desiredIntervals;
            }
            this.axes.push(axis);
        }
        this.refresh();
    };
    /**
     * To remove secondary axis for the chart.
     *
     * @param {number} index - Defines the axis collection to be removed in chart.
     * @returns {void}
     * @private
     */ Chart.prototype.removeAxis = function(index) {
        this.redraw = false;
        this.axes.splice(index, 1);
        this.refresh();
    };
    /**
     * To destroy the widget
     *
     * @function destroy
     * @returns {void}.
     * @member of Chart
     */ Chart.prototype.destroy = function() {
        if (this.scrollBarModule) this.scrollBarModule.destroy();
        if (this.markerRender) {
            this.markerRender.removeEventListener();
            this.markerRender = null;
        }
        this.horizontalAxes = [];
        this.verticalAxes = [];
        this.visibleSeries = [];
        this.axisCollections = [];
        this.rotatedDataLabelCollections = [];
        this.seriesElements = null;
        this.chartAxisLayoutPanel = null;
        this.dataLabelCollections = null;
        this.dataLabelElements = null;
        this.yAxisElements = null;
        var element = document.getElementById(this.element.id + "Keyboard_chart_focus");
        if (element) element.remove();
        var highlightElement = document.getElementById(this.element.id + "_ej2_chart_highlight");
        if (highlightElement) highlightElement.remove();
        (0, $11815a21a80ae2b7$export$f883456a56996078)("chartmeasuretext");
        /**
         * To fix react timeout destroy issue.
         */ if (this.element) {
            this.unWireEvents();
            if (this.isReact) this.clearTemplate();
            _super.prototype.destroy.call(this);
            if (!this.enableCanvas) {
                this.removeSvg();
                this.svgObject = null;
            }
        }
    };
    /**
     * Get component name
     */ Chart.prototype.getModuleName = function() {
        return "chart";
    };
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @private
     * @returns {string} - The persisted data.
     */ Chart.prototype.getPersistData = function() {
        var keyEntity = [
            "loaded",
            "animationComplete",
            "primaryXAxis",
            "primaryYAxis"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Method to create SVG element.
     *
     * @private
     */ Chart.prototype.createChartSvg = function() {
        this.removeSvg();
        (0, $11815a21a80ae2b7$export$c54fe3b9ecaa84cf)(this);
    };
    /**
     * Method to bind events for chart
     */ Chart.prototype.unWireEvents = function() {
        var startEvent = (0, $5q7BP.Browser).touchStartEvent;
        var moveEvent = (0, $5q7BP.Browser).touchMoveEvent;
        var stopEvent = (0, $5q7BP.Browser).touchEndEvent;
        var cancelEvent = (0, $5q7BP.Browser).isPointer ? "pointerleave" : "mouseleave";
        /** UnBind the Event handler */ (0, $aqzbR.EventHandler).remove(this.element, startEvent, this.chartOnMouseDown);
        (0, $aqzbR.EventHandler).remove(this.element, moveEvent, this.mouseMove);
        (0, $aqzbR.EventHandler).remove(this.element, stopEvent, this.mouseEnd);
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.chartOnMouseClick);
        (0, $aqzbR.EventHandler).remove(this.element, "dblclick", this.chartOnDoubleClick);
        (0, $aqzbR.EventHandler).remove(this.element, "contextmenu", this.chartRightClick);
        (0, $aqzbR.EventHandler).remove(this.element, cancelEvent, this.mouseLeave);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.chartKeyDown);
        (0, $aqzbR.EventHandler).remove(document.body, "keydown", this.documentKeyHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keyup", this.chartKeyUp);
        window.removeEventListener((0, $5q7BP.Browser).isTouch && "orientation" in window && "onorientationchange" in window ? "orientationchange" : "resize", this.resizeBound);
        /**
         * To fix memory issue
         */ if (this.touchObject) {
            this.touchObject.destroy();
            this.touchObject = null;
        }
    };
    Chart.prototype.wireEvents = function() {
        /**
         * To fix react timeout destroy issue.
         */ if (!this.element) return;
        /** Find the Events type */ var cancelEvent = (0, $5q7BP.Browser).isPointer ? "pointerleave" : "mouseleave";
        /** Bind the Event handler */ (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchStartEvent, this.chartOnMouseDown, this);
        (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchMoveEvent, this.mouseMove, this);
        (0, $aqzbR.EventHandler).add(this.element, (0, $5q7BP.Browser).touchEndEvent, this.mouseEnd, this);
        (0, $aqzbR.EventHandler).add(this.element, "click", this.chartOnMouseClick, this);
        (0, $aqzbR.EventHandler).add(this.element, "dblclick", this.chartOnDoubleClick, this);
        (0, $aqzbR.EventHandler).add(this.element, "contextmenu", this.chartRightClick, this);
        (0, $aqzbR.EventHandler).add(this.element, cancelEvent, this.mouseLeave, this);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.chartKeyDown, this);
        (0, $aqzbR.EventHandler).add(document.body, "keydown", this.documentKeyHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keyup", this.chartKeyUp, this);
        this.resizeBound = this.chartResize.bind(this);
        window.addEventListener((0, $5q7BP.Browser).isTouch && "orientation" in window && "onorientationchange" in window ? "orientationchange" : "resize", this.resizeBound);
        this.longPressBound = this.longPress.bind(this);
        this.touchObject = new (0, $i528u.Touch)(this.element, {
            tapHold: this.longPressBound,
            tapHoldThreshold: 500
        });
        /** Apply the style for chart */ this.setStyle(this.element);
    };
    Chart.prototype.chartRightClick = function(event) {
        if (this.crosshair.enable && this.crosshairModule && (event.buttons === 2 || event.which === 0 || event.pointerType === "touch")) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        return true;
    };
    Chart.prototype.setStyle = function(element) {
        var zooming = this.zoomSettings;
        var disableScroll = zooming.enableSelectionZooming || zooming.enablePinchZooming || this.selectionMode !== "None" || this.highlightMode !== "None";
        element.style.touchAction = disableScroll ? "none" : "element";
        element.style.msTouchAction = disableScroll ? "none" : "element";
        element.style.msContentZooming = "none";
        element.style.msUserSelect = "none";
        element.style.webkitUserSelect = "none";
        element.style.position = "relative";
        element.style.display = "block";
        // To fix angular and react tooltip div scrollbar issue
        element.style.overflow = "hidden";
        element.style.height = element.style.height || this.height && this.height.indexOf("%") === -1 ? element.style.height : "inherit";
    };
    /**
     * Determines the orientation.
     *
     * @private
     * @returns {boolean} - True if the orientation is found, otherwise false.
     */ Chart.prototype.isOrientation = function() {
        return "orientation" in window && "onorientationchange" in window;
    };
    /**
     * Handles the long press on the chart.
     *
     * @param {TapEventArgs} [e] - The event arguments for the long press.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.longPress = function(e) {
        this.mouseX = e && e.originalEvent.changedTouches ? e.originalEvent.changedTouches[0].clientX : 0;
        this.mouseY = e && e.originalEvent.changedTouches ? e.originalEvent.changedTouches[0].clientY : 0;
        this.startMove = true;
        this.allowPan = this.stockChart ? false : this.allowPan;
        this.setMouseXY(this.mouseX, this.mouseY);
        this.notify("tapHold", e);
        return false;
    };
    /**
     * Sets the mouse x and y coordinates for the aligned chart element SVG position.
     *
     * @param {number} pageX - The x-coordinate of the mouse pointer.
     * @param {number} pageY - The y-coordinate of the mouse pointer.
     * @returns {void}
     * @private
     */ Chart.prototype.setMouseXY = function(pageX, pageY) {
        if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.svgId)) {
            var svgRect = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.svgId).getBoundingClientRect();
            var rect = this.element.getBoundingClientRect();
            this.scaleX = svgRect.width / this.availableSize.width;
            this.scaleY = svgRect.height / this.availableSize.height;
            this.mouseY = (pageY - rect.top - Math.max(svgRect.top - rect.top, 0)) / this.scaleY;
            this.mouseX = (pageX - rect.left - Math.max(svgRect.left - rect.left, 0)) / this.scaleX;
            if (this.stockChart) {
                this.mouseX += this.stockChart.legendSettings.position === "Left" ? this.stockChart.stockLegendModule.legendBounds.width : 0;
                this.mouseY += this.stockChart.legendSettings.position === "Top" ? this.stockChart.stockLegendModule.legendBounds.height : 0;
            }
        }
    };
    /**
     * Exports the chart in the specified format.
     *
     * @param {ExportType} type - The file format for the export. Available options are PNG, JPEG, PDF, and SVG.
     * @param {string} fileName - The name of the file to be saved.
     * @returns {void}
     */ Chart.prototype.export = function(type, fileName) {
        if (this.exportModule) {
            this.exportModule.export(type, fileName);
            if (this.afterExport) this.exportModule.getDataUrl(this);
        }
    };
    /**
     * Handles the chart resize.
     *
     * @returns {boolean} false
     * @private
     */ Chart.prototype.chartResize = function() {
        var _this = this;
        this.animateSeries = false;
        var arg = {
            chart: this,
            name: (0, $9415fc5f023d8fac$export$e3cf9934ceac4daa),
            currentSize: new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(0, 0),
            previousSize: new (0, $5d5f50c62a40f4c7$export$cb6da89c6af1a8ec)(this.availableSize.width, this.availableSize.height)
        };
        var beforeResizeArgs = {
            name: "beforeResize",
            cancelResizedEvent: false
        };
        if (this.resizeTo) clearTimeout(this.resizeTo);
        this.trigger((0, $9415fc5f023d8fac$export$b440912c9c16a935), beforeResizeArgs);
        if (!beforeResizeArgs.cancelResizedEvent) this.resizeTo = +setTimeout(function() {
            if (_this.isDestroyed || _this.stockChart) {
                clearTimeout(_this.resizeTo);
                return;
            }
            _this.createChartSvg();
            arg.currentSize = _this.availableSize;
            _this.trigger((0, $9415fc5f023d8fac$export$e3cf9934ceac4daa), arg);
            _this.refreshAxis();
            _this.refreshBound();
            _this.trigger("loaded", {
                chart: _this.isBlazor ? {} : _this
            });
        }, 500);
        return false;
    };
    /**
     * Handles the mouse movement event on the chart.
     *
     * @param {PointerEvent} e - The mouse event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.mouseMove = function(e) {
        var pageX;
        var pageY;
        var touchArg;
        if (this.allowPan) return false;
        if (e.type === "touchmove") {
            this.isTouch = true;
            touchArg = e;
            pageX = touchArg.changedTouches[0].clientX;
            pageY = touchArg.changedTouches[0].clientY;
        } else {
            this.isTouch = e.pointerType === "touch" || e.pointerType === "2" || this.isTouch;
            pageX = e.clientX;
            pageY = e.clientY;
        }
        this.previousPageX = pageX;
        this.previousPageY = pageY;
        if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.svgId)) {
            this.setMouseXY(pageX, pageY);
            this.chartOnMouseMove(e);
        }
        return false;
    };
    /**
     * Handles the mouse leave event on the chart.
     *
     * @param {PointerEvent} e - The mouse event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.mouseLeave = function(e) {
        var pageX;
        var pageY;
        var touchArg;
        if (this.stockChart && this.stockChart.onPanning) return false;
        if (e.type === "touchleave") {
            this.isTouch = true;
            touchArg = e;
            pageX = touchArg.changedTouches[0].clientX;
            pageY = touchArg.changedTouches[0].clientY;
        } else {
            this.isTouch = e.pointerType === "touch" || e.pointerType === "2";
            pageX = e.clientX;
            pageY = e.clientY;
        }
        this.previousPageX = null;
        this.previousPageY = null;
        this.setMouseXY(pageX, pageY);
        this.chartOnMouseLeave(e);
        return false;
    };
    /**
     * Handles the mouse leave event on the chart.
     *
     * @param {PointerEvent | TouchEvent} e - The mouse or touch event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.chartOnMouseLeave = function(e) {
        var element = e.target;
        var cancelEvent = (0, $5q7BP.Browser).isPointer ? "pointerleave" : "mouseleave";
        this.trigger((0, $9415fc5f023d8fac$export$3023b2be6c49e1fa), {
            target: element.id,
            x: this.mouseX,
            y: this.mouseY
        });
        (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_EJ2_AxisLabel_Tooltip");
        this.isChartDrag = this.isPointMouseDown = false;
        this.notify(cancelEvent, e);
        return false;
    };
    /**
     * Handles the double click event on the chart.
     *
     * @param {PointerEvent | TouchEvent} e - The mouse or touch event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.chartOnDoubleClick = function(e) {
        var element = e.target;
        this.trigger((0, $9415fc5f023d8fac$export$24e08cbb55c3a531), {
            target: element.id,
            x: this.mouseX,
            y: this.mouseY
        });
        return false;
    };
    /**
     * Handles the key down event on the chart.
     *
     * @param {KeyboardEvent} e - The keyboard event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.chartKeyDown = function(e) {
        var actionKey = "";
        if (this.isZoomed && e.code === "Tab" || e.code === "Space") e.preventDefault();
        if (this.tooltip.enable && (e.code === "Tab" && this.previousTargetId.indexOf("Series") > -1 || e.code === "Escape")) actionKey = "ESC";
        if (this.highlightMode !== "None" && e.code === "Tab" && this.previousTargetId.indexOf("_chart_legend_") > -1) {
            if (this.highlightModule) this.highlightModule.removeLegendHighlightStyles();
        }
        if (e.ctrlKey && (e.key === "+" || e.code === "Equal" || e.key === "-" || e.code === "Minus")) {
            e.preventDefault();
            this.isZoomed = this.zoomModule && (this.zoomSettings.enableDeferredZooming || this.zoomSettings.enableSelectionZooming || this.zoomSettings.enablePinchZooming || this.zoomSettings.enableMouseWheelZooming);
            //this.tooltipModule.fadeOut(this.element);
            actionKey = this.isZoomed ? e.code : "";
        } else if (e["keyCode"] === 82 && this.isZoomed) {
            e.preventDefault();
            this.isZoomed = false;
            actionKey = "R";
        } else if (e.code.indexOf("Arrow") > -1) {
            e.preventDefault();
            actionKey = this.isZoomed ? e.code : "";
        }
        if (e.ctrlKey && e.key === "p") {
            e.preventDefault();
            actionKey = "CtrlP";
        }
        if (actionKey !== "") this.chartKeyboardNavigations(e, e.target.id, actionKey);
        return false;
    };
    /**
     * Handles the key up event on the chart.
     *
     * @param {KeyboardEvent} e - The keyboard event.
     * @returns {boolean} - Returns false.
     * @private
     */ Chart.prototype.chartKeyUp = function(e) {
        var actionKey = "";
        var targetId = e.target["id"];
        var groupElement;
        var markerGroup;
        var targetElement = e.target;
        var titleElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_ChartTitle");
        var seriesElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SeriesCollection");
        var legendElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_translate_g");
        var pagingElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pageup");
        if (titleElement) titleElement.setAttribute("class", "e-chart-focused");
        if (seriesElement && seriesElement.firstElementChild && seriesElement.firstElementChild.children[1]) {
            var firstChild = seriesElement.firstElementChild.children[1];
            var className = firstChild.getAttribute("class");
            if (className && className.indexOf("e-chart-focused") === -1) className = className + " e-chart-focused";
            else if (!className) className = "e-chart-focused";
            firstChild.setAttribute("class", className);
        }
        if (legendElement) {
            var firstChild = legendElement.firstElementChild;
            var className = firstChild.getAttribute("class");
            if (className && className.indexOf("e-chart-focused") === -1) className = className + " e-chart-focused";
            else if (!className) className = "e-chart-focused";
            firstChild.setAttribute("class", className);
        }
        if (pagingElement) pagingElement.setAttribute("class", "e-chart-focused");
        if (e.code === "Tab") {
            if (this.previousTargetId !== "") {
                if (this.previousTargetId.indexOf("_Series_") > -1 && targetId.indexOf("_Series_") === -1) {
                    groupElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SeriesCollection");
                    var previousElement = this.previousTargetId.indexOf("_Symbol") > -1 ? (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SymbolGroup" + this.currentSeriesIndex).children[this.currentPointIndex + 1] : this.previousTargetId.indexOf("_Point_") > -1 ? groupElement.children[this.currentSeriesIndex].children[this.currentPointIndex + 1] : groupElement.children[this.currentSeriesIndex];
                    this.setTabIndex(previousElement, groupElement.firstElementChild);
                    this.currentPointIndex = 0;
                    this.currentSeriesIndex = 0;
                } else if (this.previousTargetId.indexOf("_chart_legend_page") > -1 && targetId.indexOf("_chart_legend_page") === -1 && targetId.indexOf("_chart_legend_g_") === -1) this.setTabIndex(e.target, (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pageup"));
                else if (this.previousTargetId.indexOf("_chart_legend_g_") > -1 && targetId.indexOf("_chart_legend_g_") === -1) {
                    groupElement = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_translate_g");
                    this.setTabIndex(groupElement.children[this.currentLegendIndex], groupElement.firstElementChild);
                }
            }
            this.previousTargetId = targetId;
            if (targetId.indexOf("SeriesGroup") > -1) {
                this.currentSeriesIndex = +targetId.split("SeriesGroup")[1];
                targetElement.removeAttribute("tabindex");
                targetElement.blur();
                if (targetElement.children[1].id.indexOf("_Point_") === -1) markerGroup = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SymbolGroup" + targetId.split("SeriesGroup")[1]);
                targetId = this.focusChild(markerGroup != null ? markerGroup.children[1] : targetElement.children[1]);
            }
            actionKey = this.highlightMode !== "None" || this.tooltip.enable ? "Tab" : "";
        } else if (e.code.indexOf("Arrow") > -1) {
            e.preventDefault();
            this.previousTargetId = targetId;
            if (targetId.indexOf("_chart_legend_page") > -1) {
                if (e.code === "ArrowLeft") {
                    (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pagedown").removeAttribute("tabindex");
                    this.focusChild((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pageup"));
                } else if (e.code === "ArrowRight") {
                    (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pageup").removeAttribute("tabindex");
                    this.focusChild((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_chart_legend_pagedown"));
                }
            } else if (targetId.indexOf("_chart_legend_") > -1) {
                var legendElement_1 = targetElement.parentElement.children;
                legendElement_1[this.currentLegendIndex].removeAttribute("tabindex");
                this.currentLegendIndex += e.code === "ArrowUp" || e.code === "ArrowRight" ? 1 : -1;
                this.currentLegendIndex = this.getActualIndex(this.currentLegendIndex, legendElement_1.length);
                var currentLegend = legendElement_1[this.currentLegendIndex];
                this.focusChild(currentLegend);
                targetId = currentLegend.children[1].id;
                actionKey = this.highlightMode !== "None" ? "ArrowMove" : "";
            } else if (targetId.indexOf("_Series_") > -1) {
                groupElement = targetElement.parentElement.parentElement;
                var currentPoint = e.target;
                targetElement.removeAttribute("tabindex");
                targetElement.blur();
                if (e.code === "ArrowRight" || e.code === "ArrowLeft") {
                    var seriesIndexes = [];
                    for(var i = 0; i < groupElement.children.length; i++)if (groupElement.children[i].id.indexOf("SeriesGroup") > -1) seriesIndexes.push(+groupElement.children[i].id.split("SeriesGroup")[1]);
                    this.currentSeriesIndex = seriesIndexes.indexOf(this.currentSeriesIndex) + (e.code === "ArrowRight" ? 1 : -1);
                    this.currentSeriesIndex = seriesIndexes[this.getActualIndex(this.currentSeriesIndex, seriesIndexes.length)];
                } else this.currentPointIndex += e.code === "ArrowUp" ? 1 : -1;
                if (targetId.indexOf("_Symbol") > -1) {
                    this.currentPointIndex = this.getActualIndex(this.currentPointIndex, (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SymbolGroup" + this.currentSeriesIndex).childElementCount - 1);
                    currentPoint = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Series_" + this.currentSeriesIndex + "_Point_" + this.currentPointIndex + "_Symbol");
                } else if (targetId.indexOf("_Point_") > -1) {
                    this.currentPointIndex = this.getActualIndex(this.currentPointIndex, (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "SeriesGroup" + this.currentSeriesIndex).childElementCount - 1);
                    currentPoint = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Series_" + this.currentSeriesIndex + "_Point_" + this.currentPointIndex);
                }
                targetId = this.focusChild(currentPoint);
                actionKey = this.tooltip.enable || this.highlightMode !== "None" ? "ArrowMove" : "";
            }
        } else if ((e.code === "Enter" || e.code === "Space") && (targetId.indexOf("_chart_legend_") > -1 || targetId.indexOf("_Point_") > -1)) {
            targetId = targetId.indexOf("_chart_legend_page") > -1 ? targetId : targetId.indexOf("_chart_legend_") > -1 ? targetElement.children[1].id : targetId;
            actionKey = "Enter";
        }
        if (actionKey !== "") this.chartKeyboardNavigations(e, targetId, actionKey);
        return false;
    };
    /**
     * Sets the tab index for the specified elements.
     *
     * @param {HTMLElement} previousElement - The previous element whose tab index needs to be removed.
     * @param {HTMLElement} currentElement - The current element to which the tab index needs to be set.
     * @returns {void}
     * @private
     */ Chart.prototype.setTabIndex = function(previousElement, currentElement) {
        if (previousElement) previousElement.removeAttribute("tabindex");
        if (currentElement) currentElement.setAttribute("tabindex", "0");
    };
    Chart.prototype.getActualIndex = function(index, totalLength) {
        return index > totalLength - 1 ? 0 : index < 0 ? totalLength - 1 : index;
    };
    Chart.prototype.focusChild = function(element) {
        element.setAttribute("tabindex", "0");
        var className = element.getAttribute("class");
        element.setAttribute("tabindex", "0");
        if (className && className.indexOf("e-chart-focused") === -1) className = "e-chart-focused " + className;
        else if (!className) className = "e-chart-focused";
        element.setAttribute("class", className);
        element.focus();
        return element.id;
    };
    /**
     * Handles the key event on the document.
     *
     * @param {KeyboardEvent} e - The keyboard event.
     * @returns {void}
     * @private
     */ Chart.prototype.documentKeyHandler = function(e) {
        // 74 - J
        if (e.altKey && e.keyCode === 74 && !(0, $3EnZW.isNullOrUndefined)(this.element)) this.element.focus();
    };
    /**
     * Handles keyboard navigation on the chart.
     *
     * @param {KeyboardEvent} e - The keyboard event.
     * @param {string} targetId - The ID of the target element.
     * @param {string} actionKey - The key that determines the action to be taken.
     * @returns {void}
     * @private
     */ Chart.prototype.chartKeyboardNavigations = function(e, targetId, actionKey) {
        this.isLegendClicked = false;
        switch(actionKey){
            case "Tab":
            case "ArrowMove":
                if (this.highlightModule) this.highlightModule.removeLegendHighlightStyles();
                if (targetId.indexOf("_Point_") > -1) {
                    var seriesIndex = +targetId.split("_Series_")[1].split("_Point_")[0];
                    var pointIndex = +targetId.split("_Series_")[1].replace("_Symbol", "").split("_Point_")[1];
                    var pointRegion = this.visibleSeries[seriesIndex].points[pointIndex].symbolLocations[0];
                    this.mouseX = pointRegion.x + this.initialClipRect.x;
                    this.mouseY = pointRegion.y + this.initialClipRect.y;
                    if (this.highlightModule) {
                        this.highlightModule.highlightChart(document.getElementById(targetId), "mousemove");
                        this.highlightModule.completeSelection(document.getElementById(targetId), "mousemove");
                    }
                    if (this.tooltipModule) this.tooltipModule.tooltip();
                }
                if (this.highlightModule && this.highlightMode !== "None") {
                    targetId = targetId.indexOf("_chart_legend_g_") > -1 ? document.getElementById(targetId).firstChild["id"] : targetId;
                    var legendID = this.element.id + "_chart_legend";
                    var legendItemsId = [
                        legendID + "_text_",
                        legendID + "_shape_marker_",
                        legendID + "_shape_"
                    ];
                    for(var i = 0; i < legendItemsId.length; i++){
                        var id = legendItemsId[i];
                        if (targetId.indexOf(id) > -1) {
                            document.getElementById(targetId).setAttribute("class", "");
                            this.highlightModule.legendSelection(this, parseInt(targetId.split(id)[1], 10), document.getElementById(targetId), "mousemove");
                            break;
                        }
                    }
                }
                break;
            case "Enter":
            case "Space":
                if (targetId.indexOf("_chart_legend_") > -1) {
                    this.isLegendClicked = true;
                    this.legendModule.click(e);
                    this.focusChild(document.getElementById(targetId).parentElement);
                } else this.selectionModule.calculateSelectedElements(document.getElementById(targetId), "click");
                break;
            case "CtrlP":
                this.print();
                break;
            case "ESC":
                this.tooltipModule.removeTooltip(1);
                break;
            case "Equal":
            case "Minus":
                this.zoomModule.isZoomed = this.zoomModule.performedUI = true;
                this.zoomModule.isPanning = this.isChartDrag = false;
                if (actionKey === "Equal") this.zoomModule.toolkit.zoomInOutCalculation(1, this, this.axisCollections, this.zoomSettings.mode);
                else this.zoomModule.toolkit.zoomInOutCalculation(-1, this, this.axisCollections, this.zoomSettings.mode);
                this.zoomModule.performZoomRedraw(this);
                this.element.focus();
                break;
            case "ArrowUp":
            case "ArrowDown":
            case "ArrowLeft":
            case "ArrowRight":
                var yArrowPadding = actionKey === "ArrowUp" ? 10 : actionKey === "ArrowDown" ? -10 : 0;
                var xArrowPadding = actionKey === "ArrowLeft" ? -10 : actionKey === "ArrowRight" ? 10 : 0;
                this.zoomModule.isPanning = this.isChartDrag = true;
                this.zoomModule.doPan(this, this.axisCollections, xArrowPadding, yArrowPadding);
                this.zoomModule.performZoomRedraw(this);
                this.element.focus();
                break;
            case "R":
                this.zoomModule.toolkit.reset(e);
                break;
        }
    };
    /**
     * Handles the mouse click on the chart.
     *
     * @param {PointerEvent | TouchEvent} e - The mouse or touch event.
     * @returns {boolean} -  Return false.
     * @private
     */ Chart.prototype.chartOnMouseClick = function(e) {
        var _this = this;
        var element = e.target;
        var chart = this;
        this.clickCount++;
        var XYvalues = this.FindXYPointValue(chart.mouseX, chart.mouseY);
        var timeInterval = 400;
        if (this.clickCount === 1) this.singleClickTimer = +setTimeout(function() {
            chart.clickCount = 0;
            chart.trigger((0, $9415fc5f023d8fac$export$32aac92eb1966452), {
                target: element.id,
                x: chart.mouseX,
                y: chart.mouseY,
                axisData: XYvalues
            });
        }, timeInterval);
        else if (this.clickCount === 2 && !this.pointDoubleClick) {
            clearTimeout(this.singleClickTimer);
            this.clickCount = 0;
        }
        var isAngular = "isAngular";
        if (this[isAngular]) {
            var observers = "observers";
            timeInterval = this.pointDoubleClick[observers].length > 0 ? 400 : 0;
        } else timeInterval = this.pointDoubleClick ? 400 : 0;
        if (this.clickCount === 1 && this.pointClick) this.singleClickTimer = +setTimeout(function() {
            _this.clickCount = 0;
            _this.triggerPointEvent((0, $9415fc5f023d8fac$export$56c0b6612edfacb9), e);
        }, timeInterval);
        else if (this.clickCount === 2 && this.pointDoubleClick) {
            clearTimeout(this.singleClickTimer);
            this.clickCount = 0;
            this.triggerPointEvent((0, $9415fc5f023d8fac$export$df325cbc6a85cce1), e);
        }
        if (this.axisLabelClick) this.triggerAxisLabelClickEvent((0, $9415fc5f023d8fac$export$478ba8b8d1838c4b), e);
        this.notify("click", e);
        return false;
    };
    Chart.prototype.FindXYPointValue = function(mouseX, mouseY) {
        if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(mouseX, mouseY, this.chartAxisLayoutPanel.seriesClipRect) && this.series.some(function(series) {
            return series.visible;
        })) {
            var axis = void 0;
            var Xvalue = void 0;
            var Yvalue = void 0;
            var axisData = {};
            for(var k = 0, length_1 = this.axisCollections.length; k < length_1; k++){
                axis = this.axisCollections[k];
                if (axis.orientation === "Horizontal") {
                    Xvalue = (0, $11815a21a80ae2b7$export$4e11abe7cdeb4cc9)(Math.abs(mouseX - axis.rect.x), axis.rect.width, axis);
                    axisData[this.axisCollections[k].name] = Xvalue;
                } else {
                    Yvalue = (0, $11815a21a80ae2b7$export$bb7437ba7758bec8)(Math.abs(mouseY - axis.rect.y), axis.rect.height, axis);
                    axisData[this.axisCollections[k].name] = Yvalue;
                }
            }
            return axisData;
        }
        return null;
    };
    Chart.prototype.triggerPointEvent = function(event, e) {
        var evt = e;
        var data = new (0, $05077795990f958e$export$c23acf85d5f173c3)(this);
        var pointData = data.getData();
        if (pointData.series && pointData.point) this.trigger(event, {
            series: this.isBlazor ? {} : pointData.series,
            point: pointData.point,
            seriesIndex: pointData.series.index,
            pointIndex: pointData.point.index,
            x: this.mouseX,
            y: this.mouseY,
            pageX: evt.pageX,
            pageY: evt.pageY
        });
    };
    Chart.prototype.triggerAxisLabelClickEvent = function(event, e) {
        var targetElement = e.target;
        var clickEvt = e;
        if (targetElement.id.indexOf("_AxisLabel_") !== -1) {
            var index = targetElement.id.split("_AxisLabel_");
            var axisIndex = +index[0].slice(-1);
            var labelIndex = +index[1];
            var currentAxis = this.axisCollections[axisIndex];
            if (currentAxis.visible && (axisIndex === 0 || axisIndex === 1)) this.trigger(event, {
                chart: this,
                axis: currentAxis,
                text: currentAxis.visibleLabels[labelIndex].text,
                labelID: targetElement.id,
                index: labelIndex,
                location: new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(clickEvt.pageX, clickEvt.pageY),
                value: currentAxis.visibleLabels[labelIndex].value
            });
        }
    };
    /**
     * Handles the mouse move on the chart.
     *
     * @param {PointerEvent | TouchEvent} e - The mouse or touch event.
     * @returns {boolean} - False.
     * @private
     */ Chart.prototype.chartOnMouseMove = function(e) {
        var element = e.target;
        var XYvalues = this.FindXYPointValue(this.mouseX, this.mouseY);
        this.trigger((0, $9415fc5f023d8fac$export$9680c713d196e3fe), {
            target: element.id,
            x: this.mouseX,
            y: this.mouseY,
            axisData: XYvalues
        });
        if (this.pointMove) this.triggerPointEvent((0, $9415fc5f023d8fac$export$303d93c98be934b1), e);
        // Tooltip for chart series.
        if (!this.isTouch) {
            this.titleTooltip(e, this.mouseX, this.mouseY);
            this.axisTooltip(e, this.mouseX, this.mouseY);
        }
        if (this.dataEditingModule) this.dataEditingModule.pointMouseMove(e);
        if (this.crosshair.enable && this.startMove) e.preventDefault();
        this.notify((0, $5q7BP.Browser).touchMoveEvent, e);
        this.isTouch = false;
        return false;
    };
    Chart.prototype.titleTooltip = function(event, x, y, isTouch) {
        var targetId = event.target.id;
        var id = targetId === this.element.id + "_ChartTitle" || targetId === this.element.id + "_ChartSubTitle" || targetId.indexOf("_AxisTitle") > -1 || targetId.indexOf("_legend_title") > -1;
        var index = 0;
        if (targetId.indexOf("_AxisTitle") > -1) index = parseInt(targetId.replace(this.element.id, "").replace("AxisLabel_", "").split("_")[2], 10);
        if (id && event.target.textContent.indexOf("...") > -1) {
            var title = targetId === this.element.id + "_ChartTitle" ? this.title : targetId.indexOf("_AxisTitle") > -1 ? this.axisCollections[index].title : targetId.indexOf("_ChartSubTitle") > -1 ? this.subTitle : this.legendSettings.title;
            (0, $11815a21a80ae2b7$export$dba11b50e1aa3c12)(title, x, y, this.element.offsetWidth, this.element.id + "_EJ2_Title_Tooltip", (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Secondary_Element"), isTouch);
        } else (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_EJ2_Title_Tooltip");
    };
    Chart.prototype.axisTooltip = function(event, x, y, isTouch) {
        var targetId = event.target.id;
        if ((targetId.indexOf("AxisLabel") > -1 || targetId.indexOf("Axis_MultiLevelLabel") > -1) && event.target.textContent.indexOf("...") > -1) {
            var isTitleOrLegendEnabled = this.legendSettings.visible || this.primaryXAxis.title === "";
            (0, $11815a21a80ae2b7$export$dba11b50e1aa3c12)(this.findAxisLabel(targetId), x, y, this.element.offsetWidth, this.element.id + "_EJ2_AxisLabel_Tooltip", (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Secondary_Element"), isTouch, isTitleOrLegendEnabled);
        } else (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_EJ2_AxisLabel_Tooltip");
    };
    Chart.prototype.findAxisLabel = function(text) {
        var texts;
        if (text.indexOf("AxisLabel") > -1) {
            texts = text.replace(this.element.id, "").replace("AxisLabel_", "").split("_");
            return this.axisCollections[parseInt(texts[0], 10)].visibleLabels[parseInt(texts[1], 10)].originalText;
        } else {
            texts = text.replace(this.element.id, "").replace("Axis_MultiLevelLabel_Level_", "").replace("Text_", "").split("_");
            return this.axisCollections[parseInt(texts[0], 10)].multiLevelLabels[parseInt(texts[1], 10)].categories[parseInt(texts[2], 10)].text;
        }
    };
    /**
     * Handles the mouse down on the chart.
     *
     * @param {PointerEvent} e - The mouse event.
     * @returns {boolean} - False.
     * @private
     */ Chart.prototype.chartOnMouseDown = function(e) {
        var pageX;
        var pageY;
        var target;
        var touchArg;
        var XYvalues = this.FindXYPointValue(this.mouseX, this.mouseY);
        var offset = (0, $5q7BP.Browser).isDevice ? 20 : 30;
        var rect = this.element.getBoundingClientRect();
        var element = e.target;
        if (this.stockChart && this.stockChart.zoomSettings.enablePan) this.allowPan = true;
        this.trigger((0, $9415fc5f023d8fac$export$54283ad48bed80cb), {
            target: element.id,
            x: this.mouseX,
            y: this.mouseY,
            axisData: XYvalues
        });
        if (e.type === "touchstart") {
            this.isTouch = true;
            touchArg = e;
            pageX = touchArg.changedTouches[0].clientX;
            pageY = touchArg.changedTouches[0].clientY;
            target = touchArg.target;
        } else {
            this.isTouch = e.pointerType === "touch";
            pageX = e.clientX;
            pageY = e.clientY;
            target = e.target;
        }
        var svgRect = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.svgId).getBoundingClientRect();
        this.mouseDownX = this.previousMouseMoveX = pageX - rect.left - Math.max(svgRect.left - rect.left, 0);
        this.mouseDownY = this.previousMouseMoveY = pageY - rect.top - Math.max(svgRect.top - rect.top, 0);
        if (this.isTouch) this.isDoubleTap = new Date().getTime() < this.threshold && target.id.indexOf(this.element.id + "_Zooming_") === -1 && (this.mouseDownX - offset >= this.mouseX || this.mouseDownX + offset >= this.mouseX) && (this.mouseDownY - offset >= this.mouseY || this.mouseDownY + offset >= this.mouseY) && (this.mouseX - offset >= this.mouseDownX || this.mouseX + offset >= this.mouseDownX) && (this.mouseY - offset >= this.mouseDownY || this.mouseY + offset >= this.mouseDownY);
        if (this.dataEditingModule) this.dataEditingModule.pointMouseDown();
        this.notify((0, $5q7BP.Browser).touchStartEvent, e);
        return false;
    };
    /**
     * Handles the mouse up on the chart.
     *
     * @param {PointerEvent} e - The mouse event.
     * @returns {boolean} - False.
     * @private
     */ Chart.prototype.mouseEnd = function(e) {
        var pageY;
        var pageX;
        var touchArg;
        if (e.type === "touchend") {
            touchArg = e;
            pageX = touchArg.changedTouches[0].clientX;
            this.isTouch = true;
            pageY = touchArg.changedTouches[0].clientY;
        } else {
            pageY = e.clientY;
            pageX = e.clientX;
            this.isTouch = e.pointerType === "touch" || e.pointerType === "2";
        }
        this.setMouseXY(pageX, pageY);
        this.chartOnMouseUp(e);
        return false;
    };
    /**
     * Handles the mouse up on the chart.
     *
     * @param {PointerEvent | TouchEvent} e - The mouse or touch event.
     * @returns {boolean} - False.
     * @private
     */ Chart.prototype.chartOnMouseUp = function(e) {
        var element = e.target;
        var XYvalues = this.FindXYPointValue(this.mouseX, this.mouseY);
        this.trigger((0, $9415fc5f023d8fac$export$656b3fce824ebc9b), {
            target: element.id,
            x: this.mouseX,
            y: this.mouseY,
            axisData: XYvalues
        });
        this.isChartDrag = false;
        this.allowPan = false;
        if (this.isTouch) {
            this.titleTooltip(e, this.mouseX, this.mouseY, this.isTouch);
            this.axisTooltip(e, this.mouseX, this.mouseY, this.isTouch);
            this.threshold = new Date().getTime() + 300;
        }
        if (this.dataEditingModule) this.dataEditingModule.pointMouseUp();
        if (!this.enableCanvas && this.seriesElements) this.seriesElements.removeAttribute("clip-path");
        this.notify((0, $5q7BP.Browser).touchEndEvent, e);
        return false;
    };
    /**
     * Method to set culture for chart.
     *
     * @returns {void}
     */ Chart.prototype.setCulture = function() {
        this.intl = new (0, $bWDaN.Internationalization)();
        this.setLocaleConstants();
        this.localeObject = new (0, $e7i2H.L10n)(this.getModuleName(), this.defaultLocalConstants, this.locale);
    };
    /**
     * Sets the content of the annotation dynamically for the chart.
     *
     * @param {number} annotationIndex - The index of the annotation.
     * @param {string} content - The content to set for the annotation.
     * @returns {void}
     */ Chart.prototype.setAnnotationValue = function(annotationIndex, content) {
        var parentNode = (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Annotation_Collections");
        var annotation = this.annotations[annotationIndex];
        var element;
        if (content !== null) {
            annotation.content = content;
            if (parentNode) {
                (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_Annotation_" + annotationIndex);
                element = this.createElement("div");
                this.annotationModule.processAnnotation(annotation, annotationIndex, element);
                parentNode.appendChild(element.children[0]);
            } else this.annotationModule.renderAnnotations((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.element.id + "_Secondary_Element"));
        }
    };
    /**
     * Method to set locale constants.
     *
     * @returns {void}
     */ Chart.prototype.setLocaleConstants = function() {
        this.defaultLocalConstants = {
            ZoomIn: "Zoom in",
            Zoom: "Zoom",
            ZoomOut: "Zoom out",
            Pan: "Pan",
            Reset: "Reset",
            ResetZoom: "Reset Zoom"
        };
    };
    /**
     * Theming for chart.
     *
     * @returns {void}
     */ Chart.prototype.setTheme = function() {
        /** Set theme */ this.themeStyle = (0, $11b41024b246dc37$export$e22c5d06d177c3fa)(this.theme, this.enableCanvas, this);
        if (!document.getElementById(this.element.id + "Keyboard_chart_focus")) {
            var style = document.createElement("style");
            style.setAttribute("id", this.element.id + "Keyboard_chart_focus");
            style.innerText = ".e-chart-focused:focus, path[class*=_ej2_chart_selection_series]:focus,path[id*=_Point_]:focus, text[id*=_ChartTitle]:focus {outline: none } .e-chart-focused:focus-visible, path[class*=_ej2_chart_selection_series]:focus-visible,path[id*=_Point_]:focus-visible, text[id*=_ChartTitle]:focus-visible {outline: 1.5px " + this.themeStyle.tabColor + " solid}";
            document.body.appendChild(style);
        }
    };
    /**
     * Provides the array of modules needed for control rendering.
     *
     * @returns {ModuleDeclaration[]} - The array of module declarations.
     * @private
     */ Chart.prototype.requiredModules = function() {
        var _this = this;
        var modules = [];
        var series = this.series;
        var enableAnnotation = false;
        var moduleName;
        var errorBarVisible = false;
        var isPointDrag = false;
        var dataLabelEnable = false;
        var zooming = this.zoomSettings;
        this.chartAreaType = series.length > 0 && (series[0].type === "Polar" || series[0].type === "Radar") ? "PolarRadar" : "Cartesian";
        if (this.tooltip.enable) modules.push({
            member: "Tooltip",
            args: [
                this
            ]
        });
        series.map(function(value) {
            _this.isLegend = _this.legendSettings.visible && (value.name !== "" || !!_this.isLegend);
            moduleName = value.type.indexOf("100") !== -1 ? value.type.replace("100", "") + "Series" : value.type + "Series";
            errorBarVisible = value.errorBar.visible || errorBarVisible;
            dataLabelEnable = value.marker.dataLabel.visible || dataLabelEnable || value.type === "Pareto" && value.paretoOptions.marker.dataLabel.visible;
            isPointDrag = value.dragSettings.enable || isPointDrag;
            if (!modules.some(function(currentModule) {
                return currentModule.member === moduleName;
            })) modules.push({
                member: moduleName,
                args: [
                    _this,
                    series
                ]
            });
            if (_this.chartAreaType === "PolarRadar") modules.push({
                member: value.drawType + "Series",
                args: [
                    _this,
                    series
                ]
            });
            if (value.type === "Pareto") {
                modules.push({
                    member: "ColumnSeries",
                    args: [
                        _this,
                        series
                    ]
                });
                modules.push({
                    member: "LineSeries",
                    args: [
                        _this,
                        series
                    ]
                });
            }
        });
        this.findIndicatorModules(modules);
        this.findTrendLineModules(modules);
        modules = this.findAxisModule(modules);
        enableAnnotation = this.annotations.some(function(value) {
            return value.content !== null;
        });
        if (errorBarVisible) modules.push({
            member: "ErrorBar",
            args: [
                this,
                series
            ]
        });
        if (this.isLegend) modules.push({
            member: "Legend",
            args: [
                this
            ]
        });
        if (this.enableExport || this.allowExport) modules.push({
            member: "Export",
            args: [
                this
            ]
        });
        if (this.chartAreaType !== "PolarRadar" && this.crosshair.enable) modules.push({
            member: "Crosshair",
            args: [
                this
            ]
        });
        if (this.chartAreaType !== "PolarRadar" && !this.scrollSettingEnabled && (zooming.enableSelectionZooming || zooming.enableMouseWheelZooming || zooming.enablePinchZooming || zooming.enablePan || zooming.enableScrollbar || zooming.showToolbar)) {
            modules.push({
                member: "Zoom",
                args: [
                    this,
                    this.zoomSettings
                ]
            });
            if (zooming.enableScrollbar) modules.push({
                member: "ScrollBar",
                args: [
                    this
                ]
            });
        }
        if (this.selectionMode !== "None" && !(this.chartAreaType === "PolarRadar" && this.selectionMode.indexOf("Drag") > -1)) modules.push({
            member: "Selection",
            args: [
                this
            ]
        });
        if (this.highlightMode !== "None" || this.legendSettings.enableHighlight) modules.push({
            member: "Highlight",
            args: [
                this
            ]
        });
        if (dataLabelEnable) modules.push({
            member: "DataLabel",
            args: [
                this,
                series
            ]
        });
        if (isPointDrag) modules.push({
            member: "DataEditing",
            args: [
                this
            ]
        });
        if (enableAnnotation) modules.push({
            member: "Annotation",
            args: [
                this
            ]
        });
        return modules;
    };
    Chart.prototype.findAxisModule = function(modules) {
        var axisCollections = [];
        axisCollections.push(this.primaryXAxis);
        axisCollections.push(this.primaryYAxis);
        axisCollections = axisCollections.concat(this.axes);
        var datetimeEnabled = false;
        var categoryEnabled = false;
        var logarithmicEnabled = false;
        var striplineEnabled = false;
        var dateTimeCategoryEnabled = false;
        var multiLevelEnabled = false;
        for(var _i = 0, axisCollections_1 = axisCollections; _i < axisCollections_1.length; _i++){
            var axis = axisCollections_1[_i];
            datetimeEnabled = axis.valueType === "DateTime" || datetimeEnabled;
            categoryEnabled = axis.valueType === "Category" || categoryEnabled;
            logarithmicEnabled = axis.valueType === "Logarithmic" || logarithmicEnabled;
            dateTimeCategoryEnabled = axis.valueType === "DateTimeCategory" || dateTimeCategoryEnabled;
            striplineEnabled = this.findStriplineVisibility(axis.stripLines) || striplineEnabled;
            multiLevelEnabled = axis.multiLevelLabels.length > 0 || multiLevelEnabled;
            this.scrollSettingEnabled = axis.scrollbarSettings.enable ? true : this.scrollSettingEnabled;
        }
        if (datetimeEnabled) modules.push({
            member: "DateTime",
            args: [
                this
            ]
        });
        if (categoryEnabled) modules.push({
            member: "Category",
            args: [
                this
            ]
        });
        if (logarithmicEnabled) modules.push({
            member: "Logarithmic",
            args: [
                this
            ]
        });
        if (striplineEnabled) modules.push({
            member: "StripLine",
            args: [
                this
            ]
        });
        if (multiLevelEnabled) modules.push({
            member: "MultiLevelLabel",
            args: [
                this
            ]
        });
        if (dateTimeCategoryEnabled) modules.push({
            member: "DateTimeCategory",
            args: [
                this
            ]
        });
        if (this.scrollSettingEnabled) modules.push({
            member: "ScrollBar",
            args: [
                this
            ]
        });
        return modules;
    };
    Chart.prototype.findIndicatorModules = function(modules) {
        var macdEnable;
        var bandEnable;
        var indicators = this.indicators;
        if (this.indicators.length) {
            modules.push({
                member: "LineSeries",
                args: [
                    this
                ]
            });
            indicators.map(function(indicator) {
                macdEnable = macdEnable || indicator.type === "Macd";
                bandEnable = bandEnable || indicator.type === "BollingerBands";
            });
            if (macdEnable) modules.push({
                member: "ColumnSeries",
                args: [
                    this
                ]
            });
            if (bandEnable) modules.push({
                member: "RangeAreaSeries",
                args: [
                    this
                ]
            });
            if (bandEnable) modules.push({
                member: "SplineRangeAreaSeries",
                args: [
                    this
                ]
            });
            for(var _i = 0, _a = this.indicators; _i < _a.length; _i++){
                var indicator = _a[_i];
                modules.push({
                    member: indicator.type + "Indicator",
                    args: [
                        this
                    ]
                });
            }
        }
    };
    Chart.prototype.findTrendLineModules = function(modules) {
        var isLine;
        var isSpline;
        var _loop_1 = function(series) {
            var markerEnable;
            series.trendlines.map(function(trendline) {
                markerEnable = markerEnable || trendline.marker.visible;
                isLine = isLine || trendline.type === "Linear" || trendline.type === "MovingAverage" ? true : false;
                isSpline = isSpline || !isLine || trendline.type === "Exponential" || trendline.type === "Logarithmic" || trendline.type === "Power" || trendline.type === "Polynomial" ? true : false;
            });
            if (markerEnable) modules.push({
                member: "Marker",
                args: [
                    this_1,
                    series
                ]
            });
        };
        var this_1 = this;
        for(var _i = 0, _a = this.series; _i < _a.length; _i++){
            var series = _a[_i];
            _loop_1(series);
        }
        if (isLine || isSpline) modules.push({
            member: "TrendLine",
            args: [
                this
            ]
        });
        if (isLine) modules.push({
            member: "LineSeries",
            args: [
                this
            ]
        });
        if (isSpline) modules.push({
            member: "SplineSeries",
            args: [
                this
            ]
        });
    };
    Chart.prototype.findStriplineVisibility = function(striplines) {
        var visible = false;
        for(var _i = 0, striplines_1 = striplines; _i < striplines_1.length; _i++){
            var stripline = striplines_1[_i];
            if (stripline.visible) {
                visible = true;
                break;
            }
        }
        return visible;
    };
    /**
     * To Remove the SVG.
     *
     * @returns {void}
     * @private
     */ Chart.prototype.removeSvg = function() {
        if (this.redraw) return null;
        (0, $11815a21a80ae2b7$export$d275276aef283641)(this);
        if (this.enableCanvas && this.svgObject && this.svgObject.tagName === "CANVAS") {
            this.renderer.clearRect(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(0, 0, this.availableSize.width, this.availableSize.height));
            if (this.svgObject.parentNode) (0, $4ZDHT.remove)(this.svgObject);
            return null;
        }
        (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_Secondary_Element");
        if (this.isReact) this.clearTemplate();
        var removeLength = 0;
        if (this.zoomModule && this.zoomModule.pinchTarget) {
            this.zoomModule.pinchTarget.id = "";
            this.zoomModule.pinchTarget.setAttribute("opacity", "0");
            this.svgObject.appendChild(this.zoomModule.pinchTarget);
            removeLength = 1;
        }
        // Fix for blazor resize issue
        if (!(0, $3EnZW.isNullOrUndefined)(this.resizeTo)) {
            if (this.resizeTo !== this.checkResize && this.isBlazor && this.element.childElementCount) {
                var containerCollection = document.querySelectorAll(".e-chart");
                for(var index = 0; index < containerCollection.length; index++){
                    var container = containerCollection[index];
                    while(container.firstChild)(0, $4ZDHT.remove)(container.firstChild);
                }
            }
            this.checkResize = this.resizeTo;
        }
        if (this.svgObject) {
            while(this.svgObject.childNodes.length > removeLength)this.svgObject.removeChild(this.svgObject.firstChild);
            if (!this.svgObject.hasChildNodes() && this.svgObject.parentNode && !this.stockChart) (0, $4ZDHT.remove)(this.svgObject);
        }
    };
    Chart.prototype.refreshDefinition = function(definitions) {
        for(var _i = 0, definitions_1 = definitions; _i < definitions_1.length; _i++){
            var item = definitions_1[_i];
            item.axes = [];
        }
    };
    /**
     * Refresh the axis default value.
     *
     * @returns {void}
     * @private
     */ Chart.prototype.refreshAxis = function() {
        var axis = this.primaryXAxis;
        axis.rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(undefined, undefined, 0, 0);
        axis = this.primaryYAxis;
        axis.isStack100 = false;
        axis.rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(undefined, undefined, 0, 0);
        for(var _i = 0, _a = this.axes; _i < _a.length; _i++){
            var item = _a[_i];
            axis = item;
            axis.rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(undefined, undefined, 0, 0);
            axis.isStack100 = false;
        }
        if (this.paretoSeriesModule && this.series[0].type === "Pareto") for(var _b = 0, _c = this.paretoSeriesModule.paretoAxes; _b < _c.length; _b++){
            var item = _c[_b];
            axis = item;
            axis.rect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(undefined, undefined, 0, 0);
            axis.isStack100 = false;
        }
    };
    Chart.prototype.axisChange = function(axis) {
        if (!axis.name && !axis.valueType) return false;
        this.refreshDefinition(this.columns);
        this.refreshDefinition(this.rows);
        this.calculateVisibleAxis();
        this.processData();
        return true;
    };
    /**
     * Gets the visible series by index.
     *
     * @param {Series[]} visibleSeries - The array of visible series.
     * @param {number} index - The index of the series to retrieve.
     * @returns {Series} - The visible series at the specified index.
     * @private
     */ Chart.prototype.getVisibleSeries = function(visibleSeries, index) {
        for(var _i = 0, visibleSeries_1 = visibleSeries; _i < visibleSeries_1.length; _i++){
            var series = visibleSeries_1[_i];
            if (index === series.index) return series;
        }
        return null;
    };
    /**
     * Refresh the chart for live data updates.
     *
     * @returns {void}
     */ Chart.prototype.refreshLiveData = function() {
        this.calculateVisibleSeries();
        this.initTechnicalIndicators();
        this.initTrendLines();
        this.refreshDefinition(this.columns);
        this.refreshDefinition(this.rows);
        this.calculateVisibleAxis();
        this.processData(false);
        if (!this.isBlazor) {
            if (this.enableCanvas) this.createChartSvg();
            else this.removeSvg();
            // this.enableCanvas ? this.createChartSvg() : this.removeSvg();
            this.refreshAxis();
            this.refreshBound();
            this.trigger("loaded", {
                chart: this.isBlazor ? {} : this
            });
        }
    };
    /**
     * To remove style element.
     *
     * @returns {void}
     */ Chart.prototype.removeStyles = function() {
        (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_ej2_chart_selection");
        (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_ej2_chart_highlight");
    };
    /**
     * To trigger the manual mouse move event for live chart tooltip.
     *
     * @returns {void}
     */ Chart.prototype.mouseMoveEvent = function() {
        if (this.tooltip.enable && this.previousPageX !== null && this.previousPageY !== null) {
            var mousemove = document.createEvent("MouseEvent");
            mousemove.initMouseEvent("mousemove", true, false, window, 1, 100, 100, this.previousPageX, this.previousPageY, false, false, false, false, 0, null);
            this.element.dispatchEvent(mousemove);
        }
    };
    /**
     * Displays a tooltip for the data points.
     *
     * @param {number | string | Date} x - Specifies the x value of the point or x coordinate.
     * @param {number} y - Specifies the x value of the point or y coordinate.
     * @param {boolean} isPoint - Specifies whether x and y are data point or chart coordinates.
     * @returns {void}
     */ Chart.prototype.showTooltip = function(x, y, isPoint) {
        if (isPoint === void 0) isPoint = false;
        if (isPoint) for(var _i = 0, _a = this.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            for(var _b = 0, _c = series.points; _b < _c.length; _b++){
                var point = _c[_b];
                var pointX = series.xAxis.valueType === "DateTime" ? point.xValue : point.x;
                var xValue = x;
                if (series.xAxis.valueType === "DateTime") xValue = new Date(xValue).getTime();
                if (x === pointX && y === point.yValue) {
                    this.mouseX = point.regions[0].x + this.chartAxisLayoutPanel.seriesClipRect.x;
                    this.mouseY = point.regions[0].y + this.chartAxisLayoutPanel.seriesClipRect.y;
                    this.tooltipModule.tooltip();
                    this.markerRender.mouseMoveHandler();
                    break;
                }
            }
        }
        else {
            if (this.isTouch) this.startMove = true;
            this.mouseX = x;
            this.mouseY = y;
            this.tooltipModule.mouseMoveHandler();
            this.markerRender.mouseMoveHandler();
        }
    };
    /**
     * Hides a tooltip in the chart.
     *
     * @returns {void}
     */ Chart.prototype.hideTooltip = function() {
        this.tooltipModule.removeTooltip((0, $5q7BP.Browser).isDevice ? 2000 : 1000);
    };
    /**
     * Displays a crosshair for the chart.
     *
     * @param {number} x - Specifies the x value of the point or x coordinate.
     * @param {number} y - Specifies the x value of the point or y coordinate.
     * @returns {void}
     */ Chart.prototype.showCrosshair = function(x, y) {
        this.mouseX = x;
        this.mouseY = y;
        this.isCrosshair = false;
        if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(this.mouseX, this.mouseY, this.chartAxisLayoutPanel.seriesClipRect)) this.crosshairModule.crosshair();
        else this.hideCrosshair();
        this.isCrosshair = true;
    };
    /**
     * Hides a tooltip in the chart.
     *
     * @returns {void}
     */ Chart.prototype.hideCrosshair = function() {
        this.crosshairModule.removeCrosshair((0, $5q7BP.Browser).isDevice ? 2000 : 1000);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {ChartModel} newProp - The new ChartModel.
     * @param {ChartModel} oldProp - The new ChartModel.
     * @returns {void}
     */ Chart.prototype.onPropertyChanged = function(newProp, oldProp) {
        var renderer = false;
        var refreshBounds = false;
        this.animateSeries = false;
        var axis;
        if (!this.delayRedraw && !this.zoomRedraw) {
            for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
                var prop = _a[_i];
                switch(prop){
                    case "primaryXAxis":
                        axis = newProp.primaryXAxis;
                        refreshBounds = this.axisChange(axis);
                        if (newProp.primaryXAxis.edgeLabelPlacement) renderer = true;
                        if (!newProp.primaryXAxis.crosshairTooltip) refreshBounds = true;
                        if (!(0, $3EnZW.isNullOrUndefined)(axis.isInversed) || !(0, $3EnZW.isNullOrUndefined)(axis.opposedPosition)) this.primaryXAxis.setIsInversedAndOpposedPosition();
                        break;
                    case "primaryYAxis":
                        axis = newProp.primaryYAxis;
                        refreshBounds = this.axisChange(axis);
                        if (newProp.primaryYAxis.edgeLabelPlacement) renderer = true;
                        if (!newProp.primaryYAxis.crosshairTooltip) refreshBounds = true;
                        if (!(0, $3EnZW.isNullOrUndefined)(axis.isInversed) || !(0, $3EnZW.isNullOrUndefined)(axis.opposedPosition)) this.primaryYAxis.setIsInversedAndOpposedPosition();
                        break;
                    case "axes":
                        for(var _b = 0, _c = Object.keys(newProp.axes); _b < _c.length; _b++){
                            var index = _c[_b];
                            axis = newProp.axes[index];
                            refreshBounds = refreshBounds || this.axisChange(axis);
                            if (!axis.crosshairTooltip) refreshBounds = true;
                            if (!(0, $3EnZW.isNullOrUndefined)(axis.isInversed) || !(0, $3EnZW.isNullOrUndefined)(axis.opposedPosition)) this.axes[index].setIsInversedAndOpposedPosition();
                        }
                        break;
                    case "height":
                    case "width":
                        this.createChartSvg();
                        refreshBounds = true;
                        break;
                    case "subTitle":
                    case "title":
                        refreshBounds = true;
                        break;
                    case "titleStyle":
                        if (newProp.titleStyle && (newProp.titleStyle.size || newProp.titleStyle.textOverflow)) refreshBounds = true;
                        else renderer = true;
                        break;
                    case "subTitleStyle":
                        if (newProp.subTitleStyle && (newProp.subTitleStyle.size || newProp.subTitleStyle.textOverflow)) refreshBounds = true;
                        else renderer = true;
                        break;
                    case "border":
                        renderer = true;
                        break;
                    case "dataSource":
                        this.processData(false);
                        refreshBounds = true;
                        break;
                    case "enableCanvas":
                        this.refresh();
                        break;
                    case "series":
                        var len = this.series.length;
                        var seriesRefresh = false;
                        var series = void 0;
                        var blazorProp = void 0;
                        for(var i = 0; i < len; i++){
                            series = newProp.series[i];
                            // I264774 blazor series visible property binding not working issue fixed.
                            if (this.isBlazor && series && (series.visible !== oldProp.series[i].visible || series.isClosed || series.marker || series.emptyPointSettings || series.type || series.boxPlotMode || series.showMean)) blazorProp = true;
                            if (!(0, $3EnZW.isNullOrUndefined)(series) && (series.dataSource || series.query || series.errorBar || series.xName || series.yName || series.size || series.high || series.low || series.open || series.close || series.trendlines || series.fill || series.name || series.marker || series.width || series.binInterval || series.type || series.visible !== oldProp.series[i].visible || blazorProp)) {
                                (0, $3EnZW.extend)(this.getVisibleSeries(this.visibleSeries, i), series, null, true);
                                seriesRefresh = true;
                            }
                        }
                        if (seriesRefresh) {
                            this.calculateVisibleSeries();
                            this.initTechnicalIndicators();
                            this.initTrendLines();
                            this.refreshDefinition(this.columns);
                            this.refreshDefinition(this.rows);
                            this.calculateVisibleAxis();
                            this.processData(false);
                            refreshBounds = true;
                        }
                        break;
                    case "indicators":
                        refreshBounds = true;
                        break;
                    case "zoomSettings":
                        if (newProp.zoomSettings.enableScrollbar || oldProp.zoomSettings.enableScrollbar) refreshBounds = true;
                        renderer = true;
                        break;
                    case "background":
                        renderer = true;
                        break;
                    case "chartArea":
                        if (newProp.chartArea.border && newProp.chartArea.border.width) refreshBounds = true;
                        renderer = true;
                        break;
                    case "legendSettings":
                        if (!newProp.legendSettings.background || !newProp.legendSettings.opacity) refreshBounds = true;
                        renderer = true;
                        break;
                    case "palettes":
                        this.calculateVisibleSeries();
                        renderer = true;
                        break;
                    case "selectedDataIndexes":
                        if (this.selectionModule) {
                            this.selectionModule.currentMode = this.selectionMode;
                            this.selectionModule.selectedDataIndexes = this.selectedDataIndexes;
                            this.selectionModule.styleId = this.element.id + "_ej2_chart_selection";
                            this.selectionModule.redrawSelection(this, oldProp.selectionMode, true);
                        } else if (this.highlightModule) {
                            this.highlightModule.currentMode = this.highlightMode;
                            this.highlightModule.highlightDataIndexes = this.selectedDataIndexes;
                            this.highlightModule.styleId = this.element.id + "_ej2_chart_highlight";
                            this.highlightModule.redrawSelection(this, oldProp.selectionMode, true);
                        }
                        break;
                    case "selectionMode":
                        if (this.selectionModule && newProp.selectionMode && newProp.selectionMode.indexOf("Drag") === -1) {
                            this.selectionModule.currentMode = this.selectionMode;
                            this.selectionModule.styleId = this.element.id + "_ej2_chart_selection";
                            this.selectionModule.redrawSelection(this, oldProp.selectionMode, true);
                        }
                        break;
                    case "isMultiSelect":
                        if (this.selectionModule && !newProp.isMultiSelect && this.selectionModule.selectedDataIndexes.length > 1) {
                            this.selectionModule.currentMode = this.selectionMode;
                            this.selectionModule.styleId = this.element.id + "_ej2_chart_selection";
                            this.selectionModule.redrawSelection(this, oldProp.selectionMode);
                        }
                        break;
                    case "highlightMode":
                    case "selectionPattern":
                    case "highlightPattern":
                        this.removeStyles();
                        renderer = true;
                        break;
                    case "theme":
                        this.animateSeries = true;
                        break;
                    case "enableRtl":
                    case "locale":
                    case "currencyCode":
                        if (this.isBlazor) {
                            this.setCulture();
                            renderer = true;
                        } else this.refresh();
                        break;
                    case "tooltip":
                        if (this.tooltipModule) {
                            this.tooltipModule.previousPoints = [];
                            if (this.tooltip.template) this.tooltipModule.template = this.tooltip.template;
                        }
                        break;
                }
            }
            if (!refreshBounds && renderer) {
                this.rotatedDataLabelCollections = [];
                this.removeSvg();
                this.renderElements();
                this.trigger("loaded", {
                    chart: this.isBlazor ? {} : this
                });
            }
            if (refreshBounds) {
                if (this.enableCanvas) this.createChartSvg();
                else this.removeSvg();
                // this.enableCanvas ? this.createChartSvg() : this.removeSvg();
                if (this.isReact) this.clearTemplate();
                this.dragY = null;
                this.refreshAxis();
                this.refreshBound();
                this.trigger("loaded", {
                    chart: this.isBlazor ? {} : this
                });
                this.redraw = false;
                this.animated = false;
            }
        }
        this.zoomRedraw = false;
    };
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Chart.prototype, "width", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Chart.prototype, "height", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Chart.prototype, "title", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Chart.prototype, "dataSource", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$237baa79a0592c9a))
    ], Chart.prototype, "titleStyle", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Chart.prototype, "subTitle", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            fontFamily: null,
            size: null,
            fontStyle: null,
            fontWeight: null,
            color: null
        }, (0, $2ae44f835da15a47$export$237baa79a0592c9a))
    ], Chart.prototype, "subTitleStyle", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$e717bcf55e1dfb40))
    ], Chart.prototype, "margin", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            color: "#DDDDDD",
            width: 0
        }, (0, $2ae44f835da15a47$export$d8e9c9d63e86d41e))
    ], Chart.prototype, "border", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Chart.prototype, "background", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            border: {
                color: null,
                width: 0.5
            },
            background: "transparent"
        }, (0, $2ae44f835da15a47$export$2d13e9563b23a413))
    ], Chart.prototype, "chartArea", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            name: "primaryXAxis"
        }, (0, $691dde0edd52f9f0$export$d06866a9fb0606da))
    ], Chart.prototype, "primaryXAxis", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({
            name: "primaryYAxis"
        }, (0, $691dde0edd52f9f0$export$d06866a9fb0606da))
    ], Chart.prototype, "primaryYAxis", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], (0, $691dde0edd52f9f0$export$b59bdbef9ce70de2))
    ], Chart.prototype, "rows", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], (0, $691dde0edd52f9f0$export$816b5d811295e6bc))
    ], Chart.prototype, "columns", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], (0, $691dde0edd52f9f0$export$d06866a9fb0606da))
    ], Chart.prototype, "axes", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], (0, $54f817a374cfcee1$export$ed28a77b2a3badcf))
    ], Chart.prototype, "series", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], (0, $7109450e102533b6$export$e77a45b056cef7cb))
    ], Chart.prototype, "annotations", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Chart.prototype, "palettes", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("Material")
    ], Chart.prototype, "theme", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2ae44f835da15a47$export$d4a9de031ac0108))
    ], Chart.prototype, "tooltip", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({}, $7c7d40c195159aeb$export$3be2ec09daf24c31)
    ], Chart.prototype, "crosshair", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $1edae0c111fe0a45$export$4096e946a56437be))
    ], Chart.prototype, "legendSettings", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], $7c7d40c195159aeb$export$443b77f0cd295ca9)
    ], Chart.prototype, "rangeColorSettings", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Complex)({}, $7c7d40c195159aeb$export$b2f0cac14cc88576)
    ], Chart.prototype, "zoomSettings", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Chart.prototype, "highlightColor", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Chart.prototype, "selectionMode", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Chart.prototype, "highlightMode", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Chart.prototype, "selectionPattern", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Chart.prototype, "highlightPattern", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "isMultiSelect", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "allowMultiSelection", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Chart.prototype, "enableExport", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "allowExport", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $2ae44f835da15a47$export$697be589595ff0ae))
    ], Chart.prototype, "selectedDataIndexes", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "useGroupingSeparator", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "enableAutoIntervalOnBothAxis", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "isTransposed", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Chart.prototype, "enableCanvas", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Chart.prototype, "backgroundImage", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $7abe8d19c400d6d4$export$afdd85645f5afc67))
    ], Chart.prototype, "indicators", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Chart.prototype, "enableAnimation", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Chart.prototype, "description", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Chart.prototype, "tabIndex", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Chart.prototype, "enableSideBySidePlacement", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "resized", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "beforeResize", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "annotationRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "beforePrint", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "loaded", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "beforeExport", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "afterExport", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "load", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "animationComplete", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "legendRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "textRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "pointRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "seriesRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "axisLabelRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "axisLabelClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "axisRangeCalculated", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "axisMultiLabelRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "legendClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "multiLevelLabelClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "tooltipRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "sharedTooltipRender", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartMouseMove", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartMouseClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartDoubleClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "pointClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "pointDoubleClick", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "pointMove", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartMouseLeave", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartMouseDown", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "chartMouseUp", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "dragComplete", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "selectionComplete", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "zoomComplete", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "onZooming", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "scrollStart", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "scrollEnd", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "scrollChanged", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "dragStart", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "drag", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Event)()
    ], Chart.prototype, "dragEnd", void 0);
    $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.Property)("USD")
    ], Chart.prototype, "currencyCode", void 0);
    Chart = $7c7d40c195159aeb$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Chart);
    return Chart;
}((0, $hQxLN.Component));



var $16363daad46d2025$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `ColumnSeries` module is used to render the column series.
 */ var $16363daad46d2025$export$2d315e625d1b73ef = /** @class */ function(_super) {
    $16363daad46d2025$var$__extends(ColumnSeries, _super);
    function ColumnSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sideBySideInfo = [];
        return _this;
    }
    ColumnSeries.prototype.render = function(series) {
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        var origin = Math.max(series.yAxis.visibleRange.min, 0);
        for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var pointColumn = _a[_i];
            this.renderPoint(series, pointColumn, this.sideBySideInfo[series.index], origin);
        }
        this.renderMarker(series);
    };
    ColumnSeries.prototype.renderPoint = function(series, pointColumn, sideBySideInfo, origin) {
        pointColumn.symbolLocations = [];
        pointColumn.regions = [];
        if (pointColumn.visible && (0, $11815a21a80ae2b7$export$812e0073c6ac0cb6)(series.points[pointColumn.index - 1], pointColumn, series.points[pointColumn.index + 1], series)) {
            this.rect = this.getRectangle(pointColumn.xValue + sideBySideInfo.start, pointColumn.yValue, pointColumn.xValue + sideBySideInfo.end, origin, series);
            this.rect.width = series.columnWidthInPixel ? series.columnWidthInPixel - (series.chart.enableSideBySidePlacement ? series.columnWidthInPixel * series.columnSpacing : 0) : this.rect.width;
            this.rect.x = series.columnWidthInPixel ? this.rect.x - (series.columnWidthInPixel / 2 * series.rectCount - series.columnWidthInPixel * series.index) : this.rect.x;
            var color = series.category === "Indicator" ? pointColumn.color : series.interior;
            var argsData = this.triggerEvent(series, pointColumn, color, {
                width: series.border.width,
                color: series.border.color
            });
            if (!argsData.cancel) {
                this.updateSymbolLocation(pointColumn, this.rect, series);
                this.drawRectangle(series, pointColumn, this.rect, argsData);
                if (series.columnFacet === "Cylinder") {
                    var cylinderSeriesOption = {
                        "isColumn": true,
                        "stacking": false,
                        "isLastSeries": true
                    };
                    this.drawCylinder(this.options, this.element, cylinderSeriesOption, this.rect, series);
                }
            }
        }
    };
    ColumnSeries.prototype.updateDirection = function(series, point) {
        var origin = Math.max(series.yAxis.visibleRange.min, 0);
        for(var i = 0; i < point.length; i++){
            this.renderPoint(series, series.points[point[i]], this.sideBySideInfo[series.index], origin);
            if (series.marker && series.marker.visible) series.chart.markerRender.renderMarker(series, series.points[point[i]], series.points[point[i]].symbolLocations[0], null, true);
            if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                series.chart.dataLabelModule.commonId = series.chart.element.id + "_Series_" + series.index + "_Point_";
                series.chart.dataLabelModule.renderDataLabel(series, series.points[point[i]], null, series.marker.dataLabel);
            }
        }
    };
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */ ColumnSeries.prototype.doAnimation = function(series) {
        this.animate(series);
    };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ ColumnSeries.prototype.getModuleName = function() {
        return "ColumnSeries";
    /**
         * return the module name.
         */ };
    /**
     * To destroy the column series.
     *
     * @returns {void}
     * @private
     */ ColumnSeries.prototype.destroy = function() {
    /**
         * Destroy method performed here.
         */ };
    return ColumnSeries;
}((0, $7517da37aebd6aac$export$c1c08c4b2dec0f8e));




parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
/**
 * The `DataLabel` module is used to render data labels for data points.
 */ var $7bcacb0842c8c01a$export$2b4a904504ac8010 = /** @class */ function() {
    /**
     * Constructor for the data label module.
     *
     * @private
     */ function DataLabel(chart) {
        this.errorHeight = 0;
        this.chart = chart;
    }
    DataLabel.prototype.initPrivateVariables = function(series, marker) {
        var transform = "";
        var clipPath = "";
        var render = series.chart.renderer;
        var index = series.index === undefined ? series.category : series.index;
        if (series.chart.chartAreaType === "Cartesian") {
            transform = "translate(" + series.clipRect.x + "," + series.clipRect.y + ")";
            clipPath = "url(#" + this.chart.element.id + "_ChartSeriesClipRect_" + index + ")";
        }
        if (marker.dataLabel.visible && !this.chart.enableCanvas) {
            series.shapeElement = render.createGroup({
                "id": this.chart.element.id + "ShapeGroup" + index,
                "transform": transform,
                "clip-path": "url(#" + this.chart.element.id + "_ChartSeriesClipRect_" + index + ")"
            });
            series.textElement = render.createGroup({
                "id": this.chart.element.id + "TextGroup" + index,
                "transform": transform,
                "clip-path": clipPath
            });
            series.textElement.setAttribute("aria-hidden", "true");
        }
        this.markerHeight = series.type === "Scatter" || marker.visible ? marker.height / 2 : 0;
        this.commonId = this.chart.element.id + "_Series_" + index + "_Point_";
        this.calculateErrorHeight(series, series.marker.dataLabel.position);
        this.chartBackground = this.chart.chartArea.background === "transparent" ? this.chart.background || this.chart.themeStyle.background : this.chart.chartArea.background;
    };
    DataLabel.prototype.calculateErrorHeight = function(series, position) {
        if (!series.errorBar.visible) return null;
        else if (series.errorBar.visible && this.chart.chartAreaType !== "PolarRadar") {
            var direction = series.errorBar.direction;
            var positiveHeight = this.chart.errorBarModule.positiveHeight;
            var negativeHeight = this.chart.errorBarModule.negativeHeight;
            if (this.isRectSeries(series)) {
                if (position === "Top" || position === "Auto") {
                    if (direction === "Both" || direction === "Minus") this.errorHeight = negativeHeight;
                    else this.errorHeight = 0;
                }
                if (position === "Outer" || position === "Auto") {
                    if (direction === "Both" || direction === "Plus") this.errorHeight = positiveHeight;
                    else this.errorHeight = 0;
                }
            } else {
                if (position === "Top" || position === "Outer" || position === "Auto") {
                    if ((direction === "Both" || direction === "Plus") && !series.chart.isTransposed) this.errorHeight = positiveHeight;
                    else this.errorHeight = 0;
                }
                if (position === "Bottom" || position === "Auto") {
                    if (direction === "Both" || direction === "Minus") this.errorHeight = negativeHeight;
                    else this.errorHeight = 0;
                }
            }
        } else this.errorHeight = 0;
    };
    DataLabel.prototype.isRectSeries = function(series) {
        return series.isRectSeries || series.type === "RangeArea" || series.type === "SplineRangeArea" || series.type === "RangeStepArea";
    };
    /**
     * Render the data label for series.
     *
     * @param {Series} series - The series to render.
     * @param {Chart} chart - The parent chart.
     * @param {DataLabelSettingsModel} dataLabel - The settings for data labels.
     * @returns {void}
     * @private
     */ DataLabel.prototype.render = function(series, chart, dataLabel) {
        // initialize the private variable
        this.initPrivateVariables(series, series.marker);
        this.inverted = chart.requireInvertedAxis;
        this.yAxisInversed = series.yAxis.isAxisInverse;
        var templateId = chart.element.id + "_Series_" + (series.index === undefined ? series.category : series.index) + "_DataLabelCollections";
        var element = (0, $4ZDHT.createElement)("div", {
            id: templateId
        });
        var visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(series);
        // Data label point iteration started
        if (series.visible) for(var i = 0; i < visiblePoints.length; i++)this.renderDataLabel(series, visiblePoints[i], element, dataLabel);
        if (element.childElementCount) {
            if (!chart.enableCanvas) (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(chart.enableCanvas, (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "_Secondary_Element"), element, chart.redraw, false, "x", "y", null, "", false, false, null, chart.duration);
            else (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(chart.element.id + "_Secondary_Element").appendChild(element);
        }
    };
    DataLabel.prototype.renderDataLabel = function(series, point, element, dataLabel) {
        if (!dataLabel.showZero && (point.y === 0 || point.y === 0 && series.emptyPointSettings.mode === "Zero")) return null;
        this.margin = dataLabel.margin;
        var labelText = [];
        var labelLength;
        var xPos;
        var yPos;
        var xValue;
        var yValue;
        var degree;
        var isRender = true;
        var rectCenterX;
        var rectCenterY;
        var labelLocation = {
            x: 0,
            y: 0
        };
        var textSize;
        var clip = series.clipRect;
        var shapeRect;
        var isDataLabelOverlap = false;
        var dataLabelElement = [];
        dataLabel.angle = dataLabel.labelIntersectAction === "Rotate90" ? 90 : dataLabel.angle;
        dataLabel.enableRotation = dataLabel.labelIntersectAction === "Rotate90" ? true : dataLabel.enableRotation;
        var angle = degree = dataLabel.angle;
        var border = {
            width: dataLabel.border.width,
            color: dataLabel.border.color
        };
        var argsFont = (0, $3EnZW.extend)({}, (0, $3EnZW.getValue)("properties", dataLabel.font), null, true);
        if (point.symbolLocations.length && point.symbolLocations[0] || series.type === "BoxAndWhisker" && point.regions.length) {
            labelText = point.text !== null ? (0, $11815a21a80ae2b7$export$d3b1c00e68c3b170)(point, series, this.chart) : [];
            labelLength = labelText.length;
            for(var i = 0; i < labelLength; i++){
                var argsData = {
                    cancel: false,
                    name: (0, $9415fc5f023d8fac$export$7a9478098c73def8),
                    series: series,
                    point: point,
                    text: labelText[i],
                    border: border,
                    color: dataLabel.fill,
                    template: dataLabel.template,
                    font: argsFont,
                    location: labelLocation,
                    textSize: (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(labelText[i], dataLabel.font, this.chart.themeStyle.datalabelFont)
                };
                this.chart.trigger((0, $9415fc5f023d8fac$export$7a9478098c73def8), argsData);
                if (!argsData.cancel) {
                    this.fontBackground = argsData.color;
                    this.isDataLabelShape(argsData);
                    this.markerHeight = series.type === "Bubble" ? point.regions[0].height / 2 : this.markerHeight;
                    if (argsData.template !== null) this.createDataLabelTemplate(element, series, dataLabel, point, argsData, i, this.chart.redraw);
                    else {
                        if (dataLabel.enableRotation) textSize = (0, $11815a21a80ae2b7$export$70d1a4386da2e9e5)(dataLabel.font, argsData.text, dataLabel.angle, this.chart, this.chart.themeStyle.datalabelFont);
                        else textSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(argsData.text, dataLabel.font, this.chart.themeStyle.datalabelFont);
                        var rect = this.calculateTextPosition(point, series, textSize, dataLabel, i);
                        // To check whether the polar radar chart datalabel intersects the axis label or not
                        if (this.chart.chartAreaType === "PolarRadar") for(var _i = 0, _a = this.chart.chartAxisLayoutPanel.visibleAxisLabelRect; _i < _a.length; _i++){
                            var rectRegion = _a[_i];
                            if ((0, $11815a21a80ae2b7$export$b3a64cebab6a8ebb)(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x, rect.y, rect.width, rect.height), rectRegion)) {
                                isRender = false;
                                break;
                            }
                        }
                        var actualRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x + clip.x, rect.y + clip.y, rect.width, rect.height);
                        //let notOverlapping: boolean;
                        if (dataLabel.enableRotation) {
                            var rectCoordinates = this.getRectanglePoints(rect);
                            rectCenterX = rect.x + rect.width / 2;
                            rectCenterY = rect.y + rect.height / 2;
                            isDataLabelOverlap = dataLabel.labelIntersectAction === "Rotate90" || angle === -90 ? false : this.isDataLabelOverlapWithChartBound(rectCoordinates, this.chart, clip);
                            if (!isDataLabelOverlap) {
                                this.chart.rotatedDataLabelCollections.push(rectCoordinates);
                                var currentPointIndex = this.chart.rotatedDataLabelCollections.length - 1;
                                for(var index = currentPointIndex; index >= 0; index--)if (this.chart.rotatedDataLabelCollections[currentPointIndex] && this.chart.rotatedDataLabelCollections[index - 1] && (0, $11815a21a80ae2b7$export$1ecdad0cdc9457ed)(this.chart.rotatedDataLabelCollections[currentPointIndex], this.chart.rotatedDataLabelCollections[index - 1])) {
                                    isDataLabelOverlap = true;
                                    this.chart.rotatedDataLabelCollections[currentPointIndex] = null;
                                    break;
                                }
                            }
                        } else isDataLabelOverlap = (0, $11815a21a80ae2b7$export$1af046d323e2551a)(rect, this.chart.dataLabelCollections, clip);
                        if ((!isDataLabelOverlap || dataLabel.labelIntersectAction === "None") && isRender) {
                            this.chart.dataLabelCollections.push(actualRect);
                            if (this.isShape) {
                                shapeRect = this.chart.renderer.drawRectangle(new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)(this.commonId + point.index + "_TextShape_" + i, argsData.color, argsData.border, dataLabel.opacity, rect, dataLabel.rx, dataLabel.ry, "", dataLabel.border.dashArray), new Int32Array([
                                    clip.x,
                                    clip.y
                                ]));
                                if (series.shapeElement) series.shapeElement.appendChild(shapeRect);
                            }
                            // Checking the font color
                            var backgroundColor = this.fontBackground === "transparent" ? this.chart.theme.indexOf("Dark") > -1 || this.chart.theme.indexOf("HighContrast") > -1 ? "black" : "white" : this.fontBackground;
                            var rgbValue = (0, $11815a21a80ae2b7$export$41b2247054c0b0ce)((0, $11815a21a80ae2b7$export$71af4efcc3018b59)(backgroundColor));
                            var contrast = Math.round((rgbValue.r * 299 + rgbValue.g * 587 + rgbValue.b * 114) / 1000);
                            xPos = rect.x + this.margin.left + textSize.width / 2 + labelLocation.x;
                            yPos = dataLabel.enableRotation && this.chart.chartAreaType !== "PolarRadar" ? rect.y + this.margin.top + textSize.height / 2 + textSize.width / 4 + (dataLabel.position === "Auto" ? point.regions[0].width / 10 : 0) + labelLocation.y : rect.y + this.margin.top + textSize.height * 3 / 4 + labelLocation.y;
                            labelLocation = {
                                x: 0,
                                y: 0
                            };
                            if (angle !== 0 && dataLabel.enableRotation) {
                                // xValue = xPos - (dataLabel.margin.left) / 2 + (dataLabel.margin.right / 2);
                                xValue = rectCenterX;
                                //yValue = yPos - (dataLabel.margin.top) / 2 - (textSize.height / dataLabel.margin.top) +
                                // (dataLabel.margin.bottom) / 2;
                                yValue = rectCenterY;
                                degree = angle > 360 ? angle - 360 : angle < -360 ? angle + 360 : angle;
                            } else {
                                degree = 0;
                                xValue = rect.x;
                                yValue = rect.y;
                                xPos -= this.chart.chartAreaType === "Cartesian" && xPos + textSize.width / 2 > clip.width ? !this.chart.requireInvertedAxis && xPos > clip.width ? 0 : xPos + textSize.width / 2 - clip.width : 0;
                                yPos -= yPos + textSize.height > clip.y + clip.height && !(series.type.indexOf("Bar") > -1) ? yPos + textSize.height - (clip.y + clip.height) : 0;
                            }
                            var textAnchor = dataLabel.labelIntersectAction === "Rotate90" ? dataLabel.position === "Top" ? "start" : dataLabel.position === "Middle" ? "middle" : "end" : angle === -90 && dataLabel.enableRotation ? dataLabel.position === "Top" ? "end" : dataLabel.position === "Middle" ? "middle" : "start" : "middle";
                            var oldText = void 0;
                            if (this.chart.redraw && document.getElementById(this.commonId + point.index + "_Text_" + i)) oldText = document.getElementById(this.commonId + point.index + "_Text_" + i).textContent;
                            dataLabelElement.push((0, $11815a21a80ae2b7$export$a06ce713d4aea371)(this.chart.renderer, new (0, $5d5f50c62a40f4c7$export$4705393ca26c9086)(this.commonId + (series.removedPointIndex !== null && series.removedPointIndex <= point.index ? point.index + 1 : point.index) + "_Text_" + i, xPos, yPos, textAnchor, argsData.text, "rotate(" + degree + "," + xValue + "," + yValue + ")", "auto", degree), argsData.font, argsData.font.color || (this.chart.theme === "Bootstrap5" ? "#212529" : this.chart.theme === "Bootstrap5Dark" ? "#DEE2E6" : contrast >= 128 || series.type === "Hilo" || series.type === "HiloOpenClose" ? "black" : "white"), series.textElement, false, this.chart.redraw, true, false, series.chart.duration, series.clipRect, null, null, this.chart.enableCanvas, null, this.chart.themeStyle.datalabelFont, new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(xValue, yValue)));
                            if (series.removedPointIndex !== null && series.removedPointIndex <= point.index) series.textElement.lastChild.id = this.commonId + point.index + "_Text_" + i;
                            if (this.chart.redraw && oldText !== argsData.text) (0, $11815a21a80ae2b7$export$d603b961dd4ef0f4)(series.textElement.querySelector("#" + this.commonId + point.index + "_Text_" + i), this.chart.duration, parseFloat(oldText), parseFloat(argsData.text), series.marker.dataLabel.format || series.yAxis.labelFormat);
                        } else if ((0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.commonId + point.index + "_Text_0") && series.chart.redraw && series.currentData) (0, $11815a21a80ae2b7$export$d16800b7e59a8051)(this.commonId + point.index + "_Text_0").remove();
                    }
                }
            }
        }
        return dataLabelElement;
    };
    /**
     * Retrieves the points of a rectangle.
     *
     * @param {Rect} rect - The rectangle whose points are to be retrieved.
     * @returns {ChartLocation[]} - The points of the rectangle.
     */ DataLabel.prototype.getRectanglePoints = function(rect) {
        var loc1 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x, rect.y);
        var loc2 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x + rect.width, rect.y);
        var loc3 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x + rect.width, rect.y + rect.height);
        var loc4 = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(rect.x, rect.y + rect.height);
        return [
            loc1,
            loc2,
            loc3,
            loc4
        ];
    };
    DataLabel.prototype.isDataLabelOverlapWithChartBound = function(rectCoordinates, chart, clip) {
        for(var index = 0; index < rectCoordinates.length; index++){
            if (!(0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(rectCoordinates[index].x + clip.x, rectCoordinates[index].y + clip.y, chart.initialClipRect)) return true;
        }
        return false;
    };
    /**
     * Creates a template for data labels.
     *
     * @param {HTMLElement} parentElement - The parent element to which the template will be appended.
     * @param {Series} series - The series associated with the data label.
     * @param {DataLabelSettingsModel} dataLabel - The settings for the data label.
     * @param {Points} point - The data point to which the data label is associated.
     * @param {ITextRenderEventArgs} data - The event data associated with rendering the data label.
     * @param {number} labelIndex - The index of the data label.
     * @param {boolean} redraw - Specifies whether to redraw the template.
     * @returns {void}
     */ DataLabel.prototype.createDataLabelTemplate = function(parentElement, series, dataLabel, point, data, labelIndex, redraw) {
        this.margin = {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0
        };
        var clip = series.clipRect;
        var childElement = (0, $11815a21a80ae2b7$export$7b7ae612b60e1630)((0, $4ZDHT.createElement)("div", {
            id: this.chart.element.id + "_Series_" + (series.index === undefined ? series.category : series.index) + "_DataLabel_" + point.index + (labelIndex ? "_" + labelIndex : ""),
            styles: "position: absolute;background-color:" + data.color + ";" + (0, $11815a21a80ae2b7$export$ca3136ef47261d85)(dataLabel.font, this.chart.themeStyle.datalabelFont) + ";border:" + data.border.width + "px solid " + data.border.color + ";"
        }), point.index, data.template, this.chart, point, series, this.chart.element.id + "_DataLabel", labelIndex);
        this.calculateTemplateLabelSize(parentElement, childElement, point, series, dataLabel, labelIndex, clip, redraw);
    };
    DataLabel.prototype.calculateTemplateLabelSize = function(parentElement, childElement, point, series, dataLabel, labelIndex, clip, redraw, isReactCallback) {
        var elementRect = (0, $11815a21a80ae2b7$export$29256cccc5181fff)(childElement, redraw, isReactCallback);
        var rect = this.calculateTextPosition(point, series, {
            width: elementRect.width,
            height: elementRect.height
        }, dataLabel, labelIndex);
        var clipWidth = 0;
        var clipHeight = 0;
        var isOverlap = false;
        if (isReactCallback) isOverlap = elementRect.width === 0 || elementRect.height === 0; // To check the data label already overlap before react callback call
        childElement.style.left = (this.chart.chartAreaType === "PolarRadar" ? 0 : series.clipRect.x) + rect.x - clipWidth + "px";
        childElement.style.top = (this.chart.chartAreaType === "PolarRadar" ? 0 : series.clipRect.y) + rect.y + clipHeight + "px";
        var backgroundColor = this.fontBackground === "transparent" ? this.chart.theme.indexOf("Dark") > -1 ? "black" : "white" : this.fontBackground;
        var rgbValue = (0, $11815a21a80ae2b7$export$41b2247054c0b0ce)((0, $11815a21a80ae2b7$export$71af4efcc3018b59)(backgroundColor));
        var vAxis = series.chart.requireInvertedAxis ? series.xAxis : series.yAxis;
        var hAxis = series.chart.requireInvertedAxis ? series.yAxis : series.xAxis;
        childElement.style.color = dataLabel.font.color || (this.chart.theme === "Bootstrap5" ? "#212529" : this.chart.theme === "Bootstrap5Dark" ? "#DEE2E6" : Math.round((rgbValue.r * 299 + rgbValue.g * 587 + rgbValue.b * 114) / 1000) >= 128 ? "black" : "white");
        if (childElement.childElementCount && !isOverlap && (!(0, $11815a21a80ae2b7$export$1af046d323e2551a)(rect, this.chart.dataLabelCollections, clip) || dataLabel.labelIntersectAction === "None") && (series.seriesType !== "XY" || point.yValue === undefined || (0, $11815a21a80ae2b7$export$ee35c16ea07b4b7f)(point.yValue, series.yAxis.visibleRange) || series.type.indexOf("Stacking") > -1 || series.type.indexOf("100") > -1 && (0, $11815a21a80ae2b7$export$ee35c16ea07b4b7f)(series.stackedValues.endValues[point.index], series.yAxis.visibleRange)) && (0, $11815a21a80ae2b7$export$ee35c16ea07b4b7f)(point.xValue, series.xAxis.visibleRange) && parseFloat(childElement.style.top) >= vAxis.rect.y && parseFloat(childElement.style.left) >= hAxis.rect.x && parseFloat(childElement.style.top) <= vAxis.rect.y + vAxis.rect.height && parseFloat(childElement.style.left) <= hAxis.rect.x + hAxis.rect.width) {
            this.chart.dataLabelCollections.push(new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(rect.x + clip.x, rect.y + clip.y, rect.width, rect.height));
            (0, $11815a21a80ae2b7$export$a63bfedb1bdc5984)(this.chart.enableCanvas, parentElement, childElement, redraw, true, "left", "top");
            if (series.animation.enable && this.chart.animateSeries && !this.chart.enableCanvas) this.doDataLabelAnimation(series, childElement);
            else if (this.chart.enableCanvas) parentElement.appendChild(childElement);
        }
    };
    DataLabel.prototype.calculateTextPosition = function(point, series, textSize, dataLabel, labelIndex) {
        var labelRegion = labelIndex > 1 ? series.type === "Candle" ? point.regions[1] : point.regions[0] : point.regions[0];
        if (labelIndex > 1 && series.type === "HiloOpenClose") labelRegion = labelIndex === 2 ? point.regions[1] : point.regions[2];
        var location;
        location = this.getLabelLocation(point, series, textSize, labelIndex);
        var padding = 5;
        var clipRect = series.clipRect;
        // calculating alignment
        if (!this.chart.requireInvertedAxis || !this.isRectSeries(series) || series.type === "BoxAndWhisker") {
            this.locationX = location.x;
            var alignmentValue = textSize.height + this.borderWidth * 2 + this.markerHeight + this.margin.bottom + this.margin.top + padding;
            location.x = dataLabel.position === "Auto" ? location.x : this.calculateAlignment(alignmentValue, location.x, dataLabel.alignment, this.isRectSeries(series) ? point.yValue < 0 : false);
            // calculating position
            location.y = !this.isRectSeries(series) || series.type === "BoxAndWhisker" ? this.calculatePathPosition(location.y, dataLabel.position, series, point, textSize, labelIndex) : this.calculateRectPosition(location.y, labelRegion, point.yValue < 0 !== this.yAxisInversed, dataLabel.position, series, textSize, labelIndex, point);
            if (this.isRectSeries(series) && this.chart.chartAreaType === "PolarRadar") location = this.calculatePolarRectPosition(location, dataLabel.position, series, point, textSize, labelIndex, dataLabel.alignment, alignmentValue);
        } else {
            this.locationY = location.y;
            var alignmentValue = textSize.width + this.borderWidth + this.margin.left + this.margin.right - padding;
            location.x = dataLabel.position === "Auto" ? location.x : this.calculateAlignment(alignmentValue, location.x, dataLabel.alignment, point.yValue < 0);
            location.x = this.calculateRectPosition(location.x, labelRegion, point.yValue < 0 !== this.yAxisInversed, dataLabel.position, series, textSize, labelIndex, point);
        }
        var rect = (0, $11815a21a80ae2b7$export$90651d8f023649aa)(location, textSize, this.margin);
        // Checking the condition whether data Label has been exist the clip rect
        if (!(dataLabel.enableRotation === true && dataLabel.angle !== 0) && !(rect.y > clipRect.y + clipRect.height || rect.x > clipRect.x + clipRect.width || rect.x + rect.width < 0 || rect.y + rect.height < 0)) {
            rect.x = rect.x < 0 ? padding : rect.x;
            rect.y = rect.y < 0 && !(dataLabel.labelIntersectAction === "None") ? padding : rect.y;
            rect.x -= rect.x + rect.width > clipRect.x + clipRect.width ? rect.x + rect.width - (clipRect.x + clipRect.width) + padding : 0;
            rect.y -= rect.y + rect.height > clipRect.y + clipRect.height ? rect.y + rect.height - (clipRect.y + clipRect.height) + padding : 0;
            this.fontBackground = this.fontBackground === "transparent" ? this.chartBackground : this.fontBackground;
        }
        var dataLabelOutRegion;
        if (this.inverted && series.isRectSeries && rect.x + rect.width > labelRegion.x + labelRegion.width) dataLabelOutRegion = true;
        this.fontBackground = dataLabelOutRegion ? this.chartBackground : this.fontBackground;
        return rect;
    };
    // Calculation label location for polar column draw types
    DataLabel.prototype.calculatePolarRectPosition = function(location, position, series, point, size, labelIndex, alignment, alignmentValue) {
        var padding = 5;
        var columnRadius;
        var chartWidth = this.chart.availableSize.width;
        var alignmentSign = alignment === "Center" ? 0 : alignment === "Far" ? 1 : -1;
        var angle = point.regionData.startAngle - 0.5 * Math.PI + (point.regionData.endAngle - point.regionData.startAngle) / 2;
        if (labelIndex === 0) columnRadius = point.regionData.radius < point.regionData.innerRadius ? point.regionData.innerRadius : point.regionData.radius;
        else columnRadius = point.regionData.radius > point.regionData.innerRadius ? point.regionData.innerRadius : point.regionData.radius;
        this.fontBackground = this.fontBackground === "transparent" ? this.chartBackground : this.fontBackground;
        if (series.drawType.indexOf("Stacking") > -1) position = position === "Outer" ? "Top" : position;
        else if (series.drawType.indexOf("Range") > -1) position = position === "Outer" || position === "Top" ? position : "Auto";
        if (position === "Outer") columnRadius = labelIndex === 0 ? columnRadius + 2 * padding + this.markerHeight : columnRadius - 2 * padding - this.markerHeight;
        else if (position === "Middle") {
            columnRadius = columnRadius / 2 + padding;
            if (series.drawType === "StackingColumn") columnRadius = point.regionData.innerRadius + (point.regionData.radius - point.regionData.innerRadius) / 2 + padding - size.height / 2;
        } else if (position === "Top") columnRadius = labelIndex === 0 ? columnRadius - 2 * padding - this.markerHeight : columnRadius + 2 * padding + this.markerHeight;
        else if (position === "Bottom") {
            columnRadius = 2 * padding;
            columnRadius += series.drawType === "StackingColumn" ? point.regionData.innerRadius + this.markerHeight : 0;
        } else if (labelIndex === 0) columnRadius = columnRadius >= series.chart.radius ? columnRadius - padding : series.drawType === "StackingColumn" ? columnRadius - 2 * padding : columnRadius + 2 * padding;
        else columnRadius = columnRadius >= series.chart.radius ? columnRadius + padding : columnRadius - 2 * padding;
        columnRadius += alignmentValue * alignmentSign;
        location.x = series.clipRect.width / 2 + series.clipRect.x + columnRadius * Math.cos(angle);
        // To change x location based on text anchor for column and stackingcolumn chart
        if (series.drawType === "StackingColumn") location.x = location.x < chartWidth / 2 ? location.x + size.width / 2 : location.x > chartWidth / 2 ? location.x - size.width / 2 : location.x;
        else if (series.drawType === "Column") location.x = location.x < chartWidth / 2 ? location.x - size.width / 2 : location.x > chartWidth / 2 ? location.x + size.width / 2 : location.x;
        location.y = series.clipRect.height / 2 + series.clipRect.y + columnRadius * Math.sin(angle);
        return location;
    };
    /**
     * Gets the location for the data label.
     *
     * @param {Points} point - The data point associated with the label.
     * @param {Series} series - The series associated with the data label.
     * @param {Size} textSize - The size of the text to be displayed in the data label.
     * @param {number} labelIndex - The index of the data label.
     * @returns {ChartLocation} - The location for the data label.
     */ DataLabel.prototype.getLabelLocation = function(point, series, textSize, labelIndex) {
        var location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(0, 0);
        var labelRegion = series.type === "Candle" && labelIndex > 1 ? point.regions[1] : point.regions[0];
        if (series.type === "HiloOpenClose") labelRegion = labelIndex === 2 ? point.regions[1] : point.regions[2];
        var xAxis = series.xAxis;
        var yAxis = series.yAxis;
        var isInverted = series.chart.requireInvertedAxis;
        if (series.type === "BoxAndWhisker") {
            this.markerHeight = 0;
            switch(labelIndex){
                case 0:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.median, xAxis, yAxis, isInverted);
                    break;
                case 1:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.maximum, xAxis, yAxis, isInverted);
                    break;
                case 2:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.minimum, xAxis, yAxis, isInverted);
                    break;
                case 3:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.upperQuartile, xAxis, yAxis, isInverted);
                    break;
                case 4:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.lowerQuartile, xAxis, yAxis, isInverted);
                    break;
                default:
                    location = (0, $11815a21a80ae2b7$export$92d53b972f97f55a)(point.xValue, point.outliers[labelIndex - 5], xAxis, yAxis, isInverted);
                    this.markerHeight = series.marker.height / 2;
                    break;
            }
            if (isInverted) location.y = point.regions[0].y + point.regions[0].height / 2;
            else location.x = point.regions[0].x + point.regions[0].width / 2;
        } else if (labelIndex === 0 || labelIndex === 1) location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(point.symbolLocations[0].x, point.symbolLocations[0].y);
        else if ((labelIndex === 2 || labelIndex === 3) && series.type === "Candle") location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(point.symbolLocations[1].x, point.symbolLocations[1].y);
        else if (isInverted) location = {
            x: labelRegion.x + labelRegion.width / 2,
            y: labelRegion.y
        };
        else location = {
            x: labelRegion.x + labelRegion.width,
            y: labelRegion.y + labelRegion.height / 2
        };
        //Aligning the label at the beginning of the tick, when tick size is less than text size
        if (labelIndex > 1 && series.type === "HiloOpenClose") {
            if (series.chart.requireInvertedAxis) {
                var height = labelRegion.height;
                location.y = labelRegion.y + height / 2 + 2 * (labelIndex === 2 ? 1 : -1);
            } else {
                var width = labelRegion.width;
                location.x = labelRegion.x + width / 2 + 2 * (labelIndex === 2 ? 1 : -1);
            }
        }
        return location;
    };
    DataLabel.prototype.calculateRectPosition = function(labelLocation, rect, isMinus, position, series, textSize, labelIndex, point) {
        if (series.chart.chartAreaType === "PolarRadar") return null;
        var padding = 5;
        var margin = this.margin;
        var textLength = series.marker.dataLabel.enableRotation ? textSize.width : !this.inverted ? textSize.height : textSize.width;
        this.extraSpace = this.borderWidth + textLength / 2 + (position !== "Outer" && series.type.indexOf("Column") > -1 && Math.abs(rect.height - textSize.height) < padding ? 0 : padding);
        if (series.type === "StackingColumn100" || series.type === "StackingBar100") position = position === "Outer" ? "Top" : position;
        else if (series.type.indexOf("Range") > -1) position = position === "Outer" || position === "Top" ? position : "Auto";
        else if (series.type === "Waterfall") position = position === "Auto" ? "Middle" : position;
        switch(position){
            case "Bottom":
                labelLocation = !this.inverted ? isMinus ? labelLocation + (series.type === "Waterfall" ? -this.extraSpace - margin.top - this.markerHeight : -rect.height + this.extraSpace + margin.top) : labelLocation + rect.height - this.extraSpace - margin.bottom : isMinus ? labelLocation + (series.type === "Waterfall" ? +this.extraSpace + margin.left + this.markerHeight : +rect.width - this.extraSpace - margin.left) : labelLocation - rect.width + this.extraSpace + margin.right;
                break;
            case "Middle":
                labelLocation = labelLocation = !this.inverted ? isMinus ? labelLocation - rect.height / 2 : labelLocation + rect.height / 2 : isMinus ? labelLocation + rect.width / 2 : labelLocation - rect.width / 2;
                break;
            case "Auto":
                labelLocation = this.calculateRectActualPosition(labelLocation, rect, isMinus, series, textSize, labelIndex, point);
                break;
            default:
                this.extraSpace += this.errorHeight;
                labelLocation = this.calculateTopAndOuterPosition(labelLocation, rect, position, series, labelIndex, this.extraSpace, isMinus, point);
                break;
        }
        var check = !this.inverted ? labelLocation < rect.y || labelLocation > rect.y + rect.height : labelLocation < rect.x || labelLocation > rect.x + rect.width;
        this.fontBackground = check ? this.fontBackground === "transparent" ? this.chartBackground : this.fontBackground : this.fontBackground === "transparent" ? point.color || series.interior : this.fontBackground;
        var seriesLength = series.chart.series.length;
        if (position === "Outer" && series.type.indexOf("Stacking") > -1 && seriesLength - 1 > series.index) {
            var nextSeries = void 0;
            var nextSeriesPoint = void 0;
            for(var i = series.index + 1; i < seriesLength; i++){
                nextSeries = series.chart.series[i];
                nextSeriesPoint = nextSeries.points[point.index];
                if (nextSeries.type.indexOf("Stacking") > -1 && nextSeries.type.indexOf("100") === -1) {
                    this.fontBackground = nextSeriesPoint && (nextSeriesPoint.yValue < 0 && point.yValue < 0 || nextSeriesPoint.yValue > 0 && point.yValue > 0) ? nextSeriesPoint ? nextSeriesPoint.color : nextSeries.interior : this.fontBackground;
                    break;
                }
            }
        }
        return labelLocation;
    };
    DataLabel.prototype.calculatePathPosition = function(labelLocation, position, series, point, size, labelIndex) {
        var padding = 5;
        if (series.type.indexOf("Area") > -1 && series.type !== "RangeArea" && series.type !== "SplineRangeArea" && series.type !== "RangeStepArea" && this.yAxisInversed && series.marker.dataLabel.position !== "Auto") position = position === "Top" ? "Bottom" : position === "Bottom" ? "Top" : position;
        this.fontBackground = this.fontBackground === "transparent" ? this.chartBackground : this.fontBackground;
        switch(position){
            case "Top":
            case "Outer":
                labelLocation = labelLocation - this.markerHeight - this.borderWidth - size.height / 2 - this.margin.bottom - padding - this.errorHeight;
                break;
            case "Bottom":
                labelLocation = labelLocation + this.markerHeight + this.borderWidth + size.height / 2 + this.margin.top + padding + this.errorHeight;
                break;
            case "Auto":
                labelLocation = this.calculatePathActualPosition(labelLocation, this.markerHeight, series, point, size, labelIndex);
                break;
        }
        return labelLocation;
    };
    DataLabel.prototype.isDataLabelShape = function(style) {
        this.isShape = style.color !== "transparent" || style.border.width > 0;
        this.borderWidth = style.border.width;
        if (!this.isShape) this.margin = {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0
        };
    };
    DataLabel.prototype.calculateRectActualPosition = function(labelLocation, rect, isMinus, series, size, labelIndex, point) {
        var location;
        var labelRect;
        var isOverLap = true;
        var position = 0;
        var collection = this.chart.dataLabelCollections;
        var finalPosition = series.type.indexOf("Range") !== -1 || series.type === "Hilo" ? 2 : 4;
        while(isOverLap && position < finalPosition){
            var actualPosition = this.getPosition(position);
            this.fontBackground = series.marker.dataLabel.fill;
            if (series.type.indexOf("Stacking") > -1 && actualPosition === "Outer") {
                actualPosition = "Top";
                position++;
            }
            location = this.calculateRectPosition(labelLocation, rect, isMinus, actualPosition, series, size, labelIndex, point);
            if (!this.inverted) {
                if (series.marker.dataLabel.enableRotation) size.width = size.width - point.regions[0].width / 10;
                labelRect = (0, $11815a21a80ae2b7$export$90651d8f023649aa)(new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(this.locationX, location), size, this.margin);
                isOverLap = labelRect.y < 0 || (0, $11815a21a80ae2b7$export$1af046d323e2551a)(labelRect, collection, series.clipRect) || labelRect.y > series.clipRect.height;
                if (series.marker.dataLabel.template === null && isOverLap !== true) isOverLap = labelRect.y / 2 + size.height + (actualPosition === "Outer" ? point.regions[0].height + this.extraSpace : point.regions[0].height - 2 * this.extraSpace) > series.clipRect.height;
            } else {
                labelRect = (0, $11815a21a80ae2b7$export$90651d8f023649aa)(new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(location, this.locationY), size, this.margin);
                isOverLap = labelRect.x < 0 || (0, $11815a21a80ae2b7$export$1af046d323e2551a)(labelRect, collection, series.clipRect) || labelRect.x + labelRect.width > series.clipRect.width;
            }
            position++;
        }
        return location;
    };
    // alignment calculation assigned here
    DataLabel.prototype.calculateAlignment = function(value, labelLocation, alignment, isMinus) {
        switch(alignment){
            case "Far":
                labelLocation = !this.inverted ? isMinus ? labelLocation + value : labelLocation - value : isMinus ? labelLocation - value : labelLocation + value;
                break;
            case "Near":
                labelLocation = !this.inverted ? isMinus ? labelLocation - value : labelLocation + value : isMinus ? labelLocation + value : labelLocation - value;
                break;
        }
        return labelLocation;
    };
    //calculation for top and outer position of datalabel for rect series
    DataLabel.prototype.calculateTopAndOuterPosition = function(location, rect, position, series, index, extraSpace, isMinus, point) {
        var margin = this.margin;
        var top;
        switch(series.type){
            case "RangeColumn":
            case "RangeArea":
            case "RangeStepArea":
            case "SplineRangeArea":
            case "Hilo":
                top = index === 0 && !this.yAxisInversed || index === 1 && this.yAxisInversed;
                location = this.updateLabelLocation(position, location, extraSpace, margin, rect, top);
                break;
            case "Candle":
                top = (index === 0 || index === 2) && !this.yAxisInversed || (index === 1 || index === 3) && this.yAxisInversed;
                location = this.updateLabelLocation(position, location, extraSpace, margin, rect, top, index > 1);
                break;
            case "HiloOpenClose":
                if (index <= 1) {
                    top = index === 0 && !this.yAxisInversed || index === 1 && this.yAxisInversed;
                    location = this.updateLabelLocation(position, location, extraSpace, margin, rect, top);
                } else if (this.yAxisInversed) location = !this.inverted ? location + extraSpace + margin.top : location - extraSpace - margin.right;
                else location = !this.inverted ? location - extraSpace - margin.bottom : location + extraSpace + margin.left;
                break;
            default:
                if (isMinus && position === "Top" || !isMinus && position === "Outer" || position === "Top" && series.visiblePoints[point.index].yValue === 0) location = !this.inverted ? location + (isMinus && series.type === "Waterfall" ? -rect.height + extraSpace + margin.bottom : -extraSpace - margin.bottom - this.markerHeight) : location + (isMinus && series.type === "Waterfall" ? +rect.width - extraSpace - margin.left : +extraSpace + margin.left + this.markerHeight);
                else location = !this.inverted ? location + (isMinus && series.type === "Waterfall" ? -rect.height - extraSpace - margin.top : +extraSpace + margin.top + this.markerHeight) : location + (isMinus && series.type === "Waterfall" ? +rect.width + extraSpace + margin.top : -extraSpace - margin.right - this.markerHeight);
                break;
        }
        return location;
    };
    /**
     * Updates the location of the data label.
     *
     * @param {LabelPosition} position - The position of the data label.
     * @param {number} location - The initial location of the data label.
     * @param {number} extraSpace - Extra space to adjust the label position.
     * @param {MarginModel} margin - The margin for the chart.
     * @param {Rect} rect - The rectangle associated with the data label.
     * @param {boolean} top - Indicates whether the label is positioned at the top.
     * @param {boolean} inside - Indicates whether the label is inside the chart area.
     * @returns {number} The updated location of the data label.
     */ DataLabel.prototype.updateLabelLocation = function(position, location, extraSpace, margin, rect, top, inside) {
        if (inside === void 0) inside = false;
        if (!this.inverted) {
            if (top) location = position === "Outer" && !inside ? location - extraSpace - margin.bottom - this.markerHeight : location + extraSpace + margin.top + this.markerHeight;
            else location = position === "Outer" && !inside ? location + rect.height + extraSpace + margin.top + this.markerHeight : location + rect.height - extraSpace - margin.bottom - this.markerHeight;
        } else if (top) location = position === "Outer" && !inside ? location + extraSpace + margin.left + this.markerHeight : location - extraSpace - margin.right - this.markerHeight;
        else location = position === "Outer" && !inside ? location - rect.width - extraSpace - margin.right - this.markerHeight : location - rect.width + extraSpace + margin.left + this.markerHeight;
        return location;
    };
    DataLabel.prototype.calculatePathActualPosition = function(y, markerSize, series, point, size, labelIndex) {
        var points = series.points;
        var index = point.index;
        var yValue = points[index].yValue;
        var position;
        var nextPoint = points.length - 1 > index ? points[index + 1] : null;
        var previousPoint = index > 0 ? points[index - 1] : null;
        var yLocation;
        var isOverLap = true;
        var labelRect;
        var isBottom;
        var positionIndex;
        var collection = this.chart.dataLabelCollections;
        if (series.type === "Bubble") position = "Top";
        else if (series.type.indexOf("Step") > -1) {
            position = "Top";
            if (index) position = !previousPoint || !previousPoint.visible || yValue > previousPoint.yValue !== this.yAxisInversed || yValue === previousPoint.yValue ? "Top" : "Bottom";
        } else if (series.type === "BoxAndWhisker") {
            if (labelIndex === 1 || labelIndex === 3 || labelIndex > 4) position = series.yAxis.isAxisInverse ? "Bottom" : "Top";
            else if (labelIndex === 2 || labelIndex === 4) position = series.yAxis.isAxisInverse ? "Top" : "Bottom";
            else {
                isOverLap = false;
                position = "Middle";
                yLocation = this.calculatePathPosition(y, position, series, point, size, labelIndex);
            }
        } else {
            if (index === 0) position = !nextPoint || !nextPoint.visible || yValue > nextPoint.yValue || yValue < nextPoint.yValue && this.yAxisInversed ? "Top" : "Bottom";
            else if (index === points.length - 1) position = !previousPoint || !previousPoint.visible || yValue > previousPoint.yValue || yValue < previousPoint.yValue && this.yAxisInversed ? "Top" : "Bottom";
            else {
                if (!nextPoint.visible && !(previousPoint && previousPoint.visible)) position = "Top";
                else if (!nextPoint.visible || !previousPoint) position = nextPoint.yValue > yValue || previousPoint && previousPoint.yValue > yValue ? "Bottom" : "Top";
                else {
                    var slope = (nextPoint.yValue - previousPoint.yValue) / 2;
                    var intersectY = slope * index + (nextPoint.yValue - slope * (index + 1));
                    position = !this.yAxisInversed ? intersectY < yValue ? "Top" : "Bottom" : intersectY < yValue ? "Bottom" : "Top";
                }
            }
        }
        isBottom = position === "Bottom";
        positionIndex = [
            "Outer",
            "Top",
            "Bottom",
            "Middle",
            "Auto"
        ].indexOf(position);
        while(isOverLap && positionIndex < 4){
            yLocation = this.calculatePathPosition(y, this.getPosition(positionIndex), series, point, size, labelIndex);
            labelRect = (0, $11815a21a80ae2b7$export$90651d8f023649aa)(new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(this.locationX, yLocation), size, this.margin);
            isOverLap = labelRect.y < 0 || (0, $11815a21a80ae2b7$export$1af046d323e2551a)(labelRect, collection, series.clipRect) || labelRect.y + labelRect.height > series.clipRect.height;
            positionIndex = isBottom ? positionIndex - 1 : positionIndex + 1;
            isBottom = false;
        }
        return yLocation;
    };
    /**
     * Initiates the animation for data labels.
     *
     * @param {Series} series - The series associated with the data labels.
     * @param {Element} [element] - The element to animate.
     * @returns {void}
     * @private
     */ DataLabel.prototype.doDataLabelAnimation = function(series, element) {
        var shapeElements = series.shapeElement.childNodes;
        var textNode = series.textElement.childNodes;
        var delay = series.animation.delay + series.animation.duration;
        var duration = series.chart.animated ? series.chart.duration : 200;
        var location;
        var length = element ? 1 : textNode.length;
        var tempElement;
        for(var i = 0; i < length; i++){
            tempElement = textNode[i];
            if (element) {
                element.style.visibility = "hidden";
                (0, $11815a21a80ae2b7$export$99679b46ac0f2167)(element, delay, duration, "ZoomIn");
            } else {
                location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(+tempElement.getAttribute("x") + +tempElement.getAttribute("width") / 2, +tempElement.getAttribute("y") + +tempElement.getAttribute("height") / 2);
                (0, $11815a21a80ae2b7$export$9546e7ee31d90feb)(tempElement, delay, duration, series, null, location, true);
                if (shapeElements[i]) {
                    tempElement = shapeElements[i];
                    location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(+tempElement.getAttribute("x") + +tempElement.getAttribute("width") / 2, +tempElement.getAttribute("y") + +tempElement.getAttribute("height") / 2);
                    (0, $11815a21a80ae2b7$export$9546e7ee31d90feb)(tempElement, delay, duration, series, null, location, true);
                }
            }
        }
    };
    DataLabel.prototype.getPosition = function(index) {
        return [
            "Outer",
            "Top",
            "Bottom",
            "Middle",
            "Auto"
        ][index];
    };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ DataLabel.prototype.getModuleName = function() {
        // Returns the module name
        return "DataLabel";
    };
    /**
     * To destroy the dataLabel for series.
     *
     * @returns {void}
     * @private
     */ DataLabel.prototype.destroy = function() {
    // Destroy method performed here
    };
    return DataLabel;
}();

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");




var $331409338e08b18d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `Legend` module is used to render the legend for the chart.
 */ var $331409338e08b18d$export$ed247974535929c7 = /** @class */ function(_super) {
    $331409338e08b18d$var$__extends(Legend, _super);
    function Legend(chart) {
        var _this = _super.call(this, chart) || this;
        _this.library = _this;
        _this.addEventListener();
        return _this;
    }
    /**
     * Binding events for legend module.
     *
     * @returns {void}
     */ Legend.prototype.addEventListener = function() {
        if (this.chart.isDestroyed) return;
        this.chart.on((0, $5q7BP.Browser).touchMoveEvent, this.mouseMove, this);
        this.chart.on("click", this.click, this);
        this.chart.on((0, $5q7BP.Browser).touchEndEvent, this.mouseEnd, this);
    };
    /**
     * UnBinding events for legend module.
     *
     * @returns {void}
     */ Legend.prototype.removeEventListener = function() {
        if (this.chart.isDestroyed) return;
        this.chart.off((0, $5q7BP.Browser).touchMoveEvent, this.mouseMove);
        this.chart.off("click", this.click);
        this.chart.off((0, $5q7BP.Browser).touchEndEvent, this.mouseEnd);
    };
    /**
     * To handle mosue move for legend module.
     *
     * @param {MouseEvent} e - The mouse event.
     * @returns {void}
     */ Legend.prototype.mouseMove = function(e) {
        if (this.chart.legendSettings.visible && !this.chart.isTouch) {
            this.move(e);
            if (this.chart.highlightModule && (this.chart.highlightMode !== "None" || this.chart.legendSettings.enableHighlight)) {
                var legendItemsId = [
                    this.legendID + "_text_",
                    this.legendID + "_shape_marker_",
                    this.legendID + "_shape_",
                    this.legendID + "_g_"
                ];
                var targetId = e.target.id;
                var index = void 0;
                for(var _i = 0, legendItemsId_1 = legendItemsId; _i < legendItemsId_1.length; _i++){
                    var id = legendItemsId_1[_i];
                    if (targetId.indexOf(id) > -1) {
                        index = parseInt(targetId.split(id)[1], 10);
                        this.chart.highlightModule.legendSelection(this.chart, index, e.target, e.type);
                        break;
                    }
                }
            // this.click(e);
            }
        }
    };
    /**
     * To handle mosue end for legend module.
     *
     * @param {MouseEvent} e - The mouse event.
     * @returns {void}
     */ Legend.prototype.mouseEnd = function(e) {
        if (this.chart.legendSettings.visible && this.chart.isTouch) this.move(e);
    };
    /**
     * Retrieves the legend options based on the visible series collection and chart.
     *
     * @param {Series[]} visibleSeriesCollection - The collection of visible series.
     * @param {Chart} chart - The chart instance.
     * @returns {void}
     * @private
     */ Legend.prototype.getLegendOptions = function(visibleSeriesCollection, chart) {
        this.legendCollections = [];
        var seriesType;
        var fill;
        var dashArray;
        var colors = [];
        this.isRtlEnable = chart.enableRtl;
        this.isReverse = !this.isRtlEnable && chart.legendSettings.reverse;
        if (visibleSeriesCollection.length > 1) this.legend.mode = "Series";
        for(var _i = 0, visibleSeriesCollection_1 = visibleSeriesCollection; _i < visibleSeriesCollection_1.length; _i++){
            var series = visibleSeriesCollection_1[_i];
            if (this.legend.mode === "Series") {
                if (series.category !== "Indicator") {
                    seriesType = chart.chartAreaType === "PolarRadar" ? series.drawType : series.type;
                    dashArray = !series.marker.visible && seriesType.indexOf("Line") > -1 && seriesType.indexOf("Area") === -1 ? series.dashArray : "";
                    // To set legend color when use pointColorMapping
                    fill = series.pointColorMapping && series.points.length > 0 ? series.points[0].interior ? series.points[0].interior : series.interior : series.interior;
                    this.legendCollections.push(new (0, $1edae0c111fe0a45$export$90e29b0c950a66b)(series.name, fill, series.legendShape, series.category === "TrendLine" ? this.chart.series[series.sourceIndex].trendlines[series.index].visible : series.visible, seriesType, series.legendImageUrl ? series.legendImageUrl : series.type === "Scatter" && series.marker.shape === "Image" ? series.marker.imageUrl : "", series.marker.shape, series.marker.visible, null, null, dashArray));
                }
            } else if (this.legend.mode === "Point") for(var _a = 0, _b = series.points; _a < _b.length; _a++){
                var points = _b[_a];
                seriesType = chart.chartAreaType === "PolarRadar" ? series.drawType : series.type;
                fill = points.interior ? points.interior : series.interior;
                this.legendCollections.push(new (0, $1edae0c111fe0a45$export$90e29b0c950a66b)(points.x.toString(), fill, series.legendShape, series.category === "TrendLine" ? this.chart.series[series.sourceIndex].trendlines[series.index].visible : points.visible, seriesType, series.type === "Scatter" && series.marker.shape === "Image" ? series.marker.imageUrl : "", series.marker.shape, series.marker.visible));
            }
            else if (this.legend.mode === "Range") for(var _c = 0, _d = series.points; _c < _d.length; _c++){
                var points = _d[_c];
                seriesType = chart.chartAreaType === "PolarRadar" ? series.drawType : series.type;
                fill = points.interior ? points.interior : series.interior;
                var legendLabel = "Others";
                if (colors.indexOf(fill) < 0) {
                    colors.push(fill);
                    if (chart.rangeColorSettings.length >= 1 && chart.rangeColorSettings[0].colors.length === 1) {
                        for(var _e = 0, _f = chart.rangeColorSettings; _e < _f.length; _e++){
                            var rangeMap = _f[_e];
                            if (rangeMap.colors[0] === fill) legendLabel = rangeMap.label;
                        }
                        this.legendCollections.push(new (0, $1edae0c111fe0a45$export$90e29b0c950a66b)(legendLabel, fill, series.legendShape, series.category === "TrendLine" ? this.chart.series[series.sourceIndex].trendlines[series.index].visible : points.visible, seriesType, series.type === "Scatter" && series.marker.shape === "Image" ? series.marker.imageUrl : "", series.marker.shape, series.marker.visible));
                    }
                }
            }
            else if (this.legendCollections.length === 0 && chart.rangeColorSettings.length > 0) {
                var startLabel = chart.rangeColorSettings[0].start.toString();
                var endLabel = chart.rangeColorSettings[chart.rangeColorSettings.length - 1].end.toString();
                this.legendCollections.push(new (0, $1edae0c111fe0a45$export$90e29b0c950a66b)(startLabel, series.interior, "Rectangle", true, seriesType, "", series.marker.shape, series.marker.visible));
                this.legendCollections.push(new (0, $1edae0c111fe0a45$export$90e29b0c950a66b)(endLabel, series.interior, "Rectangle", true, seriesType, "", series.marker.shape, series.marker.visible));
            }
        }
        if (this.isReverse && chart.legendSettings.mode !== "Gradient") this.legendCollections.reverse();
    };
    /**
     * Calculates the legend bounds based on the available size and legend settings.
     *
     * @param {Size} availableSize - The available size for the legend.
     * @param {Rect} legendBounds - The current bounds of the legend.
     * @param {LegendSettingsModel} legend - The legend settings.
     * @returns {void}
     * @private
     */ Legend.prototype.getLegendBounds = function(availableSize, legendBounds, legend) {
        this.calculateLegendTitle(legend, legendBounds);
        this.isTitle = legend.title ? true : false;
        this.chartRowCount = 1;
        this.rowHeights = [];
        this.columnHeights = [];
        this.pageHeights = [];
        var padding = legend.padding;
        var titlePosition = legend.titlePosition;
        var extraHeight = 0;
        var legendOption;
        var extraWidth = 0;
        var arrowWidth = this.arrowWidth;
        var arrowHeight = this.arrowHeight;
        var verticalArrowSpace = this.isVertical && !legend.enablePages ? arrowHeight : 0;
        var titleSpace = this.isTitle && titlePosition === "Top" ? this.legendTitleSize.height + this.fivePixel : 0;
        titleSpace = this.isTitle && this.isVertical && titlePosition !== "Top" ? this.legendTitleSize.height + this.fivePixel : titleSpace;
        if (!this.isVertical) extraHeight = !legend.height ? availableSize.height / 100 * 5 : 0;
        else extraWidth = !legend.width ? availableSize.width / 100 * 5 : 0;
        legendBounds.height += extraHeight;
        legendBounds.width += extraWidth;
        var shapeWidth = legend.shapeWidth;
        var shapePadding = legend.shapePadding;
        var maximumWidth = 0;
        var rowWidth = 0;
        var legendWidth = 0;
        var columnHeight = 0;
        var columnCount = 0;
        var rowCount = 0;
        var titlePlusArrowSpace = 0;
        var legendEventArgs;
        var render = false;
        this.maxItemHeight = Math.max((0, $5d5f50c62a40f4c7$export$866cc30a33805630)("MeasureText", legend.textStyle, this.chart.themeStyle.legendLabelFont).height, legend.shapeHeight);
        for(var i = 0; i < this.legendCollections.length; i++){
            legendOption = this.legendCollections[i];
            if ((0, $9415fc5f023d8fac$export$a5e18b86421f9fee).test(legendOption.text)) legendOption.text = (0, $11815a21a80ae2b7$export$e6b929b8e4bc3801)(legendOption.text, (0, $9415fc5f023d8fac$export$a5e18b86421f9fee));
            if ((0, $9415fc5f023d8fac$export$d5c2e0e790d2d526).test(legendOption.text)) legendOption.text = (0, $11815a21a80ae2b7$export$e6b929b8e4bc3801)(legendOption.text, (0, $9415fc5f023d8fac$export$d5c2e0e790d2d526));
            legendEventArgs = {
                fill: legendOption.fill,
                text: legendOption.text,
                shape: legendOption.shape,
                markerShape: legendOption.markerShape,
                name: (0, $9415fc5f023d8fac$export$b6a2e1cc1d89ccd0),
                cancel: false
            };
            this.chart.trigger((0, $9415fc5f023d8fac$export$b6a2e1cc1d89ccd0), legendEventArgs);
            legendOption.render = !legendEventArgs.cancel;
            legendOption.text = legendEventArgs.text;
            legendOption.fill = legendEventArgs.fill;
            legendOption.shape = legendEventArgs.shape;
            legendOption.markerShape = legendEventArgs.markerShape;
            legendOption.textSize = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(legendOption.text, legend.textStyle, this.chart.themeStyle.legendLabelFont);
            shapeWidth = legendOption.text ? legend.shapeWidth : 0;
            shapePadding = legendOption.text ? legend.shapePadding : 0;
            if (legendOption.render && legendOption.text) {
                render = true;
                legendWidth = shapeWidth + shapePadding + (legend.maximumLabelWidth ? legend.maximumLabelWidth : legendOption.textSize.width) + (!this.isVertical ? i === 0 ? padding : this.itemPadding : padding);
                rowWidth = rowWidth + legendWidth;
                if (!legend.enablePages && !this.isVertical) {
                    titlePlusArrowSpace = this.isTitle && titlePosition !== "Top" ? this.legendTitleSize.width + this.fivePixel : 0;
                    titlePlusArrowSpace += arrowWidth;
                }
                this.getLegendHeight(legendOption, legend, legendBounds, rowWidth, this.maxItemHeight, padding);
                if (legendBounds.width < padding + rowWidth + titlePlusArrowSpace || this.isVertical) {
                    maximumWidth = Math.max(maximumWidth, rowWidth + padding + titlePlusArrowSpace - (this.isVertical ? 0 : legendWidth));
                    if (rowCount === 0 && legendWidth !== rowWidth) rowCount = 1;
                    rowWidth = this.isVertical ? 0 : legendWidth;
                    rowCount++;
                    columnCount = 0;
                    columnHeight = verticalArrowSpace;
                //columnHeight = (rowCount * (this.maxItemHeight + padding)) + padding + titleSpace + verticalArrowSpace;
                }
                var len = rowCount > 0 ? rowCount - 1 : 0;
                this.rowHeights[len] = Math.max(this.rowHeights[len] ? this.rowHeights[len] : 0, legendOption.textSize.height);
                // this.maxItemHeight = Math.max(this.maxItemHeight, legendOption.textSize.height);
                this.columnHeights[columnCount] = (this.columnHeights[columnCount] ? this.columnHeights[columnCount] : 0) + legendOption.textSize.height + (this.isVertical ? i === 0 ? padding : this.itemPadding : padding);
                columnCount++;
            }
        }
        columnHeight = Math.max.apply(null, this.columnHeights) + padding + titleSpace;
        columnHeight = Math.max(columnHeight, this.maxItemHeight + padding + padding + titleSpace);
        this.isPaging = legendBounds.height < columnHeight;
        if (this.isPaging && !legend.enablePages) {
            if (!this.isVertical) columnHeight = this.maxItemHeight + padding + padding + (titlePosition === "Top" ? titleSpace : 0);
        }
        this.totalPages = rowCount;
        if (!this.isPaging && !this.isVertical) rowWidth += this.isTitle && titlePosition !== "Top" ? this.fivePixel + this.legendTitleSize.width + this.fivePixel : 0;
        if (render) this.setBounds(Math.max(rowWidth + padding, maximumWidth), columnHeight, legend, legendBounds);
        else this.setBounds(0, 0, legend, legendBounds);
    };
    /**
     * Calculates the height of the legend based on the legend options, settings, and available space.
     *
     * @param {LegendOptions} legendOption - The legend options.
     * @param {LegendSettingsModel} legend - The legend settings.
     * @param {Rect} legendBounds - The current bounds of the legend.
     * @param {number} rowWidth - The width of the legend rows.
     * @param {number} legendHeight - The current height of the legend.
     * @param {number} padding - The padding around the legend items.
     * @returns {void}
     * @private
     */ Legend.prototype.getLegendHeight = function(legendOption, legend, legendBounds, rowWidth, legendHeight, padding) {
        var legendWidth = legendOption.textSize.width;
        var textPadding = legend.shapePadding + padding * 2 + legend.shapeWidth;
        switch(legend.textWrap){
            case "Wrap":
            case "AnyWhere":
                if (legendWidth > legend.maximumLabelWidth || legendWidth + rowWidth > legendBounds.width) legendOption.textCollection = (0, $11815a21a80ae2b7$export$cd75915cb4ef7473)(legendOption.text, legend.maximumLabelWidth ? Math.min(legend.maximumLabelWidth, legendBounds.width - textPadding) : legendBounds.width - textPadding, legend.textStyle, this.chart.enableRtl, null, null, this.chart.themeStyle.legendLabelFont);
                else legendOption.textCollection.push(legendOption.text);
                legendOption.textSize.height = legendHeight * legendOption.textCollection.length;
                break;
        }
    };
    /**
     * Calculates the rendering point for the legend item based on various parameters.
     *
     * @param {LegendOptions} legendOption - The legend options.
     * @param {ChartLocation} start - The starting location for the legend.
     * @param {number} textPadding - The padding around the legend text.
     * @param {LegendOptions} previousLegend - The options of the previous legend item.
     * @param {Rect} rect - The bounding rectangle for the legend.
     * @param {number} count - The count of legend items.
     * @param {number} firstLegend - The index of the first legend item.
     * @returns {void}
     * @private
     */ Legend.prototype.getRenderPoint = function(legendOption, start, textPadding, previousLegend, rect, count, firstLegend) {
        var padding = this.legend.padding;
        var textWidth = textPadding + (this.legend.maximumLabelWidth ? this.legend.maximumLabelWidth : previousLegend.textSize.width);
        var previousBound = previousLegend.location.x + (!this.isRtlEnable ? textWidth : -textWidth);
        if (this.isWithinBounds(previousBound, (this.legend.maximumLabelWidth ? this.legend.maximumLabelWidth : legendOption.textSize.width) + textPadding - this.itemPadding, rect) || this.isVertical) {
            legendOption.location.x = start.x;
            if (count !== firstLegend) this.chartRowCount++;
            legendOption.location.y = count === firstLegend ? previousLegend.location.y : previousLegend.location.y + (this.isVertical ? previousLegend.textSize.height : this.rowHeights[this.chartRowCount - 2]) + (this.isVertical ? this.itemPadding : padding);
        } else {
            legendOption.location.x = count === firstLegend ? previousLegend.location.x : previousBound;
            legendOption.location.y = previousLegend.location.y;
        }
        var availwidth = !this.isRtlEnable ? this.legendBounds.x + this.legendBounds.width - (legendOption.location.x + textPadding - this.itemPadding - this.legend.shapeWidth / 2) : legendOption.location.x - textPadding + this.itemPadding + this.legend.shapeWidth / 2 - this.legendBounds.x;
        if (!this.isVertical && this.isPaging && !this.legend.enablePages) availwidth = this.legendBounds.width - legendOption.location.x - this.fivePixel;
        availwidth = this.legend.maximumLabelWidth ? Math.min(this.legend.maximumLabelWidth, availwidth) : availwidth;
        if (this.legend.textOverflow === "Ellipsis" && this.legend.textWrap === "Normal") legendOption.text = (0, $11815a21a80ae2b7$export$fb7a751b3bd7efd3)(+availwidth.toFixed(4), legendOption.text, this.legend.textStyle, this.chart.enableRtl, this.chart.themeStyle.legendLabelFont);
    };
    Legend.prototype.isWithinBounds = function(previousBound, textWidth, rect) {
        if (!this.isRtlEnable) return previousBound + textWidth > rect.x + rect.width + this.legend.shapeWidth / 2;
        else return previousBound - textWidth < rect.x - this.legend.shapeWidth / 2;
    };
    /**
     * Handles the click event for a legend item.
     *
     * @param {number} index - The index of the clicked legend item.
     * @param {Event | PointerEvent} event - The click event.
     * @returns {void}
     * @private
     */ Legend.prototype.LegendClick = function(index, event) {
        var chart = this.chart;
        var seriesIndex = chart.legendSettings.mode === "Series" ? index : 0;
        var legendIndex = !this.isReverse ? index : this.legendCollections.length - 1 - index;
        var series = chart.visibleSeries[seriesIndex];
        var legend = this.legendCollections[legendIndex];
        var changeDetection = "isProtectedOnChange";
        if (chart.legendSettings.mode === "Series") {
            var legendClickArgs = {
                legendText: legend.text,
                legendShape: legend.shape,
                chart: chart.isBlazor ? {} : chart,
                series: series,
                points: series.points,
                name: (0, $9415fc5f023d8fac$export$af8636ce5f93a3af),
                cancel: false
            };
            this.chart.trigger((0, $9415fc5f023d8fac$export$af8636ce5f93a3af), legendClickArgs);
            series.legendShape = legendClickArgs.legendShape;
            if (!legendClickArgs.cancel) {
                if (series.fill !== null) chart.visibleSeries[index].interior = series.fill;
                if (chart.legendSettings.toggleVisibility) {
                    series.chart[changeDetection] = true;
                    if (series.category === "TrendLine") {
                        if (!chart.series[series.sourceIndex].trendlines[series.index].visible && chart.series[series.sourceIndex].visible) chart.series[series.sourceIndex].trendlines[series.index].visible = true;
                        else chart.series[series.sourceIndex].trendlines[series.index].visible = false;
                    } else this.changeSeriesVisiblity(series, series.visible);
                    legend.visible = series.category === "TrendLine" ? chart.series[series.sourceIndex].trendlines[series.index].visible : series.visible;
                    this.refreshLegendToggle(chart, series);
                    if (chart.highlightModule && chart.legendSettings.enableHighlight) chart.highlightModule.legendSelection(chart, index, event.target, "mousemove");
                } else if (chart.highlightModule) chart.highlightModule.legendSelection(chart, index, event.target, event.type);
                else if (chart.selectionModule) chart.selectionModule.legendSelection(chart, index, event.target, event.type);
                series.chart[changeDetection] = false;
            }
        } else if (chart.legendSettings.mode === "Point") {
            var point = series.points[index];
            var legendClickArgs = {
                legendText: legend.text,
                legendShape: legend.shape,
                chart: chart.isBlazor ? {} : chart,
                series: series,
                points: [
                    point
                ],
                name: (0, $9415fc5f023d8fac$export$af8636ce5f93a3af),
                cancel: false
            };
            this.chart.trigger((0, $9415fc5f023d8fac$export$af8636ce5f93a3af), legendClickArgs);
            if (chart.legendSettings.toggleVisibility && !legendClickArgs.cancel) {
                point.visible = !point.visible;
                var legendOption = this.legendCollections[index];
                legendOption.visible = point.visible;
                this.refreshLegendToggle(chart, series);
            }
        } else if (chart.legendSettings.mode === "Range") {
            var points = [];
            var legendOption = this.legendCollections[index];
            for(var _i = 0, _a = series.points; _i < _a.length; _i++){
                var point = _a[_i];
                if (legendOption.fill === (point.interior || series.interior)) points.push(point);
            }
            var legendClickArgs = {
                legendText: legend.text,
                legendShape: legend.shape,
                chart: chart.isBlazor ? {} : chart,
                series: series,
                points: points,
                name: (0, $9415fc5f023d8fac$export$af8636ce5f93a3af),
                cancel: false
            };
            this.chart.trigger((0, $9415fc5f023d8fac$export$af8636ce5f93a3af), legendClickArgs);
            if (chart.legendSettings.toggleVisibility && !legendClickArgs.cancel) {
                legendOption.visible = !legendOption.visible;
                for(var _b = 0, points_1 = points; _b < points_1.length; _b++){
                    var point = points_1[_b];
                    point.visible = !point.visible;
                }
                this.refreshLegendToggle(chart, series);
            }
        }
    };
    Legend.prototype.refreshLegendToggle = function(chart, series) {
        var selectedDataIndexes = [];
        if (chart.selectionModule) selectedDataIndexes = (0, $3EnZW.extend)([], chart.selectionModule.selectedDataIndexes, null, true);
        if (chart.svgObject.childNodes.length > 0 && !chart.enableAnimation && !chart.enableCanvas) {
            while(chart.svgObject.lastChild)chart.svgObject.removeChild(chart.svgObject.lastChild);
            (0, $4ZDHT.remove)(chart.svgObject);
        }
        chart.animateSeries = false;
        chart.redraw = chart.enableAnimation;
        series.isLegendClicked = true;
        chart.rotatedDataLabelCollections = [];
        (0, $11815a21a80ae2b7$export$f883456a56996078)((0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(chart.element.id + "_Secondary_Element").querySelectorAll(".ejSVGTooltip")[0]);
        (0, $11815a21a80ae2b7$export$d275276aef283641)(chart);
        this.redrawSeriesElements(series, chart);
        chart.removeSvg();
        chart.refreshAxis();
        series.refreshAxisLabel();
        this.refreshSeries(chart.visibleSeries);
        for(var _i = 0, _a = chart.visibleSeries; _i < _a.length; _i++){
            var series_1 = _a[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(series_1)) chart.markerRender.removeHighlightedMarker(series_1, null, true);
        }
        chart.refreshBound();
        chart.trigger("loaded", {
            chart: chart
        });
        if (selectedDataIndexes.length > 0) {
            chart.selectionModule.selectedDataIndexes = selectedDataIndexes;
            chart.selectionModule.redrawSelection(chart, chart.selectionMode);
        }
        if (!chart.enableCanvas && chart.highlightModule && (chart.highlightMode !== "None" || chart.legendSettings.enableHighlight)) chart.highlightModule.redrawSelection(chart, chart.highlightMode);
        chart.redraw = false;
        series.isLegendClicked = false;
    };
    Legend.prototype.changeSeriesVisiblity = function(series, visibility) {
        series.visible = !visibility;
        if (this.isSecondaryAxis(series.xAxis)) series.xAxis.internalVisibility = series.xAxis.series.some(function(value) {
            return value.visible;
        });
        if (this.isSecondaryAxis(series.yAxis) || series.category === "Pareto" && series.type === "Line") series.yAxis.internalVisibility = series.yAxis.series.some(function(value) {
            return value.visible;
        });
        if (series.trendlines.length && series.visible) series.trendlines.forEach(function(trendline) {
            trendline.visible = true;
        });
    };
    Legend.prototype.isSecondaryAxis = function(axis) {
        return this.chart.axes.indexOf(axis) > -1;
    };
    Legend.prototype.redrawSeriesElements = function(series, chart) {
        if (!chart.redraw) return null;
        (0, $11815a21a80ae2b7$export$f883456a56996078)(chart.element.id + "_Series_" + (series.index === undefined ? series.category : series.index) + "_DataLabelCollections");
    };
    Legend.prototype.refreshSeries = function(seriesCollection) {
        for(var _i = 0, seriesCollection_1 = seriesCollection; _i < seriesCollection_1.length; _i++){
            var series = seriesCollection_1[_i];
            if (series.type.indexOf("Spline") > -1) {
                var isArea = series.type.indexOf("Area") > -1 || series.drawType.indexOf("Area") > -1;
                var isRange = series.type.indexOf("Range") > -1;
                this.chart["spline" + (isArea ? isRange ? "RangeArea" : "Area" : "") + "SeriesModule"].findSplinePoint(series);
            }
            if (series.visible) series.position = undefined;
        }
    };
    /**
     * Handles the click event for showing tooltip on trimmed text in legend.
     *
     * @param {Event | PointerEvent} event - The click event.
     * @returns {void}
     * @private
     */ Legend.prototype.click = function(event) {
        var _this = this;
        if (!this.chart.legendSettings.visible) return;
        var pageX = this.chart.mouseX;
        var pageY = this.chart.mouseY;
        var legendRegion = [];
        var targetId = event.target.id.indexOf("_chart_legend_g_") > -1 ? event.target.firstChild["id"] : event.target.id;
        var legendItemsId = [
            this.legendID + "_text_",
            this.legendID + "_shape_marker_",
            this.legendID + "_shape_"
        ];
        var seriesIndex;
        for(var _i = 0, legendItemsId_2 = legendItemsId; _i < legendItemsId_2.length; _i++){
            var id = legendItemsId_2[_i];
            if (targetId.indexOf(id) > -1) {
                seriesIndex = parseInt(targetId.split(id)[1], 10);
                this.LegendClick(seriesIndex, event);
                break;
            }
        }
        if (targetId.indexOf(this.legendID + "_pageup") > -1) this.changePage(event, true);
        else if (targetId.indexOf(this.legendID + "_pagedown") > -1) this.changePage(event, false);
        if (this.chart.enableCanvas && this.pagingRegions.length) this.checkWithinBounds(pageX, pageY);
        legendRegion = this.legendRegions.filter(function(region) {
            return (0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(pageX, pageY + (_this.isPaging ? (_this.currentPageNumber - 1) * _this.translatePage(_this.chart.enableCanvas, null, 1, 2) : 0), region.rect);
        });
        if (legendRegion.length && this.chart.enableCanvas) this.LegendClick(legendRegion[0].index, event);
    };
    /**
     * Checks whether the provided coordinates are within the bounds.
     *
     * @param {number} pageX - The x-coordinate of the mouse pointer.
     * @param {number} pageY - The y-coordinate of the mouse pointer.
     * @returns {void}
     * @protected
     */ Legend.prototype.checkWithinBounds = function(pageX, pageY) {
        var cRender = this.chart.renderer;
        var bounds = this.legendBounds;
        var borderWidth = this.chart.legendSettings.border.width;
        var canvasRect = new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(bounds.x, bounds.y, bounds.width, bounds.height);
        canvasRect.x = canvasRect.x - borderWidth / 2;
        canvasRect.y = canvasRect.y - borderWidth / 2;
        canvasRect.width = canvasRect.width + borderWidth;
        canvasRect.height = canvasRect.height + borderWidth;
        if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(pageX, pageY, this.pagingRegions[0])) {
            // pageDown calculations are performing here
            if (!this.isRtlEnable) this.canvasPageDown(cRender, canvasRect, bounds);
            else this.canvasPageUp(cRender, canvasRect, bounds);
            return null;
        }
        if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(pageX, pageY, this.pagingRegions[1])) {
            // pageUp calculations are performing here
            if (!this.isRtlEnable) this.canvasPageUp(cRender, canvasRect, bounds);
            else this.canvasPageDown(cRender, canvasRect, bounds);
            return null;
        }
    };
    Legend.prototype.canvasPageDown = function(cRender, canvasRect, bounds) {
        if (--this.currentPageNumber > 0) {
            this.legendRegions = [];
            cRender.clearRect(canvasRect);
            cRender.canvasClip(new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)("legendClipPath", "transparent", {
                width: 0,
                color: ""
            }, null, canvasRect));
            this.renderLegend(this.chart, this.legend, bounds);
            cRender.canvasRestore();
        } else ++this.currentPageNumber;
    };
    Legend.prototype.canvasPageUp = function(cRender, canvasRect, bounds) {
        if (++this.currentPageNumber > 0 && this.currentPageNumber <= this.totalNoOfPages) {
            this.legendRegions = [];
            cRender.clearRect(canvasRect);
            cRender.canvasClip(new (0, $11815a21a80ae2b7$export$871e154ae03dc77d)("legendClipPath", "transpaent", {
                width: 0,
                color: ""
            }, null, canvasRect));
            this.renderLegend(this.chart, this.legend, bounds);
            cRender.canvasRestore();
        } else --this.currentPageNumber;
    };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ Legend.prototype.getModuleName = function() {
        return "Legend";
    };
    /**
     * To destroy the Legend.
     *
     * @returns {void}
     * @private
     */ Legend.prototype.destroy = function() {
        this.removeEventListener();
    };
    return Legend;
}((0, $1edae0c111fe0a45$export$7be7d9bc933b30ca));



var $3d9da221882eb0c6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `StackingBarSeries` module is used to render the stacking bar series.
 */ var $3d9da221882eb0c6$export$876b8bd838c9945c = /** @class */ function(_super) {
    $3d9da221882eb0c6$var$__extends(StackingBarSeries, _super);
    function StackingBarSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sideBySideInfo = [];
        return _this;
    }
    StackingBarSeries.prototype.render = function(series) {
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        var stackedValue = series.stackedValues;
        for(var _i = 0, _a = series.points; _i < _a.length; _i++){
            var pointStack = _a[_i];
            this.renderPoint(series, pointStack, this.sideBySideInfo[series.index], stackedValue);
        }
        if (series.visible) this.renderMarker(series);
    };
    StackingBarSeries.prototype.renderPoint = function(series, pointStack, sideBySideInfo, stackedValue) {
        pointStack.symbolLocations = [];
        pointStack.regions = [];
        if (pointStack.visible && (0, $11815a21a80ae2b7$export$812e0073c6ac0cb6)(series.points[pointStack.index - 1], pointStack, series.points[pointStack.index + 1], series)) {
            var index = void 0;
            var startvalue = void 0;
            if (!series.visible && series.isLegendClicked) {
                for(var i = series.index; i >= 0; i--)if (series.chart.visibleSeries[i].visible) {
                    index = series.chart.visibleSeries[i].index;
                    break;
                }
                startvalue = series.index > 0 && index !== undefined ? series.chart.visibleSeries[index].stackedValues.endValues[pointStack.index] : series.stackedValues.startValues[pointStack.index];
            }
            this.rect = this.getRectangle(pointStack.xValue + sideBySideInfo.start, !series.visible && series.isLegendClicked ? startvalue : stackedValue.endValues[pointStack.index], pointStack.xValue + sideBySideInfo.end, !series.visible && series.isLegendClicked ? startvalue : stackedValue.startValues[pointStack.index], series);
            this.rect.height = series.columnWidthInPixel ? series.columnWidthInPixel : this.rect.height;
            this.rect.y = series.columnWidthInPixel ? this.rect.y - series.columnWidthInPixel / 2 : this.rect.y;
            var argsData = this.triggerEvent(series, pointStack, series.interior, {
                width: series.visible ? series.border.width : 0,
                color: series.visible ? series.border.color : ""
            });
            if (!argsData.cancel) {
                this.drawRectangle(series, pointStack, this.rect, argsData);
                this.updateSymbolLocation(pointStack, this.rect, series);
                if (series.columnFacet === "Cylinder") {
                    var cylinderSeriesOption = {
                        "isColumn": false,
                        "stacking": series.type === "StackingBar100",
                        "isLastSeries": true
                    };
                    this.drawCylinder(this.options, this.element, cylinderSeriesOption, this.rect, series);
                }
            }
        }
    };
    StackingBarSeries.prototype.updateDirection = function(series, point) {
        var seriesCollection = [];
        for(var i = 0; i < series.yAxis.series.length; i++){
            var stackSeries = series.yAxis.series[i];
            if (stackSeries.stackingGroup === series.stackingGroup) seriesCollection.push(stackSeries);
        }
        for(var j = 0; j < seriesCollection.length; j++)for(var i = 0; i < point.length; i++){
            this.renderPoint(seriesCollection[j], seriesCollection[j].points[point[i]], this.sideBySideInfo[series.index], seriesCollection[j].stackedValues);
            if (series.marker && series.marker.visible) seriesCollection[j].chart.markerRender.renderMarker(seriesCollection[j], seriesCollection[j].points[point[i]], seriesCollection[j].points[point[i]].symbolLocations[0], null, true);
            if (seriesCollection[j].marker.dataLabel.visible && seriesCollection[j].chart.dataLabelModule) {
                seriesCollection[j].chart.dataLabelModule.commonId = seriesCollection[j].chart.element.id + "_Series_" + seriesCollection[j].index + "_Point_";
                seriesCollection[j].chart.dataLabelModule.renderDataLabel(seriesCollection[j], seriesCollection[j].points[point[i]], null, seriesCollection[j].marker.dataLabel);
            }
        }
    };
    /**
     * To destroy the stacking bar.
     *
     * @returns {void}
     * @private
     */ StackingBarSeries.prototype.destroy = function() {
    /**
         * Destroy method performed here.
         */ };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ StackingBarSeries.prototype.getModuleName = function() {
        return "StackingBarSeries";
    };
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */ StackingBarSeries.prototype.doAnimation = function(series) {
        this.animate(series);
    };
    return StackingBarSeries;
}((0, $7517da37aebd6aac$export$c1c08c4b2dec0f8e));



var $4484456d62ae4fe7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `StackingColumnSeries` module is used to render the stacking column series.
 */ var $4484456d62ae4fe7$export$7cb365a371b161cd = /** @class */ function(_super) {
    $4484456d62ae4fe7$var$__extends(StackingColumnSeries, _super);
    function StackingColumnSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sideBySideInfo = [];
        return _this;
    }
    StackingColumnSeries.prototype.render = function(series) {
        series.isRectSeries = true;
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        var stackedValue = series.stackedValues;
        var visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(series);
        for(var _i = 0, visiblePoints_1 = visiblePoints; _i < visiblePoints_1.length; _i++){
            var point = visiblePoints_1[_i];
            this.renderPoint(series, point, this.sideBySideInfo[series.index], stackedValue, visiblePoints);
        }
        if (series.visible) this.renderMarker(series);
    };
    StackingColumnSeries.prototype.renderPoint = function(series, point, sideBySideInfo, stackedValue, visiblePoints) {
        point.symbolLocations = [];
        point.regions = [];
        if (point.visible && (0, $11815a21a80ae2b7$export$812e0073c6ac0cb6)(visiblePoints[point.index - 1], point, visiblePoints[point.index + 1], series)) {
            var index = void 0;
            var startvalue = void 0;
            if (!series.visible && series.isLegendClicked) {
                for(var i = series.index; i >= 0; i--)if (series.chart.visibleSeries[i].visible) {
                    index = series.chart.visibleSeries[i].index;
                    break;
                }
                startvalue = series.index > 0 && index !== undefined ? series.chart.visibleSeries[index].stackedValues.endValues[point.index] : series.stackedValues.startValues[point.index];
            }
            this.rect = this.getRectangle(point.xValue + sideBySideInfo.start, !series.visible && series.isLegendClicked ? startvalue : stackedValue.endValues[point.index], point.xValue + sideBySideInfo.end, !series.visible && series.isLegendClicked ? startvalue : stackedValue.startValues[point.index], series);
            this.rect.width = series.columnWidthInPixel ? series.columnWidthInPixel : this.rect.width;
            this.rect.x = series.columnWidthInPixel ? this.rect.x - (series.columnWidthInPixel / 2 * series.rectCount - series.columnWidthInPixel * series.position) : this.rect.x;
            var argsData = this.triggerEvent(series, point, series.interior, {
                width: series.visible ? series.border.width : 0,
                color: series.visible ? series.border.color : ""
            });
            if (!argsData.cancel) {
                this.drawRectangle(series, point, this.rect, argsData);
                this.updateSymbolLocation(point, this.rect, series);
                if (series.columnFacet === "Cylinder") {
                    var cylinderSeriesOption = {
                        "isColumn": true,
                        "stacking": series.type === "StackingColumn100",
                        "isLastSeries": true
                    };
                    this.drawCylinder(this.options, this.element, cylinderSeriesOption, this.rect, series);
                }
            }
        }
    };
    StackingColumnSeries.prototype.updateDirection = function(series, point) {
        var seriesCollection = [];
        for(var i = 0; i < series.xAxis.series.length; i++){
            var stackSeries = series.xAxis.series[i];
            if (stackSeries.stackingGroup === series.stackingGroup) seriesCollection.push(stackSeries);
        }
        for(var j = 0; j < seriesCollection.length; j++){
            var visiblePoints = (0, $11815a21a80ae2b7$export$a38b34983c6f6ba1)(seriesCollection[j]);
            for(var i = 0; i < point.length; i++){
                this.renderPoint(seriesCollection[j], seriesCollection[j].points[point[i]], this.sideBySideInfo[series.index], seriesCollection[j].stackedValues, visiblePoints);
                if (series.marker && series.marker.visible) seriesCollection[j].chart.markerRender.renderMarker(seriesCollection[j], seriesCollection[j].points[point[i]], seriesCollection[j].points[point[i]].symbolLocations[0], null, true);
                if (seriesCollection[j].marker.dataLabel.visible && seriesCollection[j].chart.dataLabelModule) {
                    seriesCollection[j].chart.dataLabelModule.commonId = seriesCollection[j].chart.element.id + "_Series_" + seriesCollection[j].index + "_Point_";
                    seriesCollection[j].chart.dataLabelModule.renderDataLabel(seriesCollection[j], seriesCollection[j].points[point[i]], null, seriesCollection[j].marker.dataLabel);
                }
            }
        }
    };
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */ StackingColumnSeries.prototype.doAnimation = function(series) {
        this.animate(series);
    };
    /**
     * To destroy the stacking column.
     *
     * @returns {void}
     * @private
     */ StackingColumnSeries.prototype.destroy = function() {
    /**
         * Destroy method performed here.
         */ };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ StackingColumnSeries.prototype.getModuleName = function() {
        return "StackingColumnSeries";
    };
    return StackingColumnSeries;
}((0, $7517da37aebd6aac$export$c1c08c4b2dec0f8e));

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");



var $43ef68bd5efcefa0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `Tooltip` module is used to render the tooltip for series.
 */ var $43ef68bd5efcefa0$export$ba0102162f9e195c = /** @class */ function(_super) {
    $43ef68bd5efcefa0$var$__extends(BaseTooltip, _super);
    /**
     * Constructor for tooltip module.
     *
     * @private
     */ function BaseTooltip(chart) {
        var _this = _super.call(this, chart) || this;
        _this.element = _this.chart.element;
        _this.textStyle = chart.tooltip.textStyle;
        _this.control = chart;
        _this.template = chart.tooltip.template;
        return _this;
    }
    BaseTooltip.prototype.getElement = function(id) {
        return document.getElementById(id);
    };
    /**
     * Renders the tooltip.
     *
     * @returns {void}
     * @private
     */ BaseTooltip.prototype.getTooltipElement = function(isTooltip) {
        this.inverted = this.chart.requireInvertedAxis;
        this.header = this.control.tooltip.header === null ? this.control.tooltip.shared ? "${point.x}" : "${series.name}" : this.control.tooltip.header;
        this.formattedText = [];
        var tooltipDiv = document.getElementById(this.chart.element.id + "_tooltip");
        var isStockChart = this.chart.element.id.indexOf("stockChart") > -1;
        if (!isTooltip && !tooltipDiv || isStockChart) return this.createElement();
        return null;
    };
    BaseTooltip.prototype.createElement = function() {
        var tooltipDiv = document.createElement("div");
        tooltipDiv.id = this.element.id + "_tooltip";
        tooltipDiv.className = "ejSVGTooltip";
        tooltipDiv.style.pointerEvents = "none";
        tooltipDiv.style.position = "absolute";
        tooltipDiv.style.zIndex = "1";
        return tooltipDiv;
    };
    BaseTooltip.prototype.pushData = function(data, isFirst, tooltipDiv, isChart, enable3D) {
        if (data.series.enableTooltip) {
            if (enable3D) this.currentPoints.push(data);
            else if (isChart) this.currentPoints.push(data);
            else this.currentPoints.push(data);
            this.stopAnimation();
            if (tooltipDiv && !document.getElementById(tooltipDiv.id)) {
                if (!this.chart.stockChart) document.getElementById(this.element.id + "_Secondary_Element").appendChild(tooltipDiv);
                else document.getElementById(this.chart.stockChart.element.id + "_Secondary_Element").appendChild(tooltipDiv);
            }
            return true;
        }
        return false;
    };
    BaseTooltip.prototype.removeHighlight = function() {
        var item;
        // let series: Series;
        for(var i = 0, len = this.previousPoints.length; i < len; i++){
            item = this.previousPoints[i];
            if (item.series.isRectSeries) {
                if (item.series.visible) this.highlightPoint(item.series, item.point.index, false);
                continue;
            }
        // series = item.series as Series;
        }
    };
    BaseTooltip.prototype.highlightPoint = function(series, pointIndex, highlight) {
        var element = this.getElement(this.element.id + "_Series_" + series.index + "_Point_" + pointIndex);
        var selectionModule = this.control.accumulationSelectionModule;
        var isSelectedElement = selectionModule && selectionModule.selectedDataIndexes.length > 0 ? true : false;
        if (element) {
            if (!isSelectedElement || isSelectedElement && element.getAttribute("class") && element.getAttribute("class").indexOf("_ej2_chart_selection_series_") === -1) {
                if (this.chart.highlightColor !== "" && !(0, $3EnZW.isNullOrUndefined)(this.chart.highlightColor)) element.setAttribute("fill", highlight && this.chart.highlightColor !== "transparent" ? this.chart.highlightColor : series.pointColorMapping !== "" ? series.points[0].color : series.points[pointIndex].color || series.interior);
                else element.setAttribute("opacity", (highlight && this.chart.highlightColor !== "transparent" ? series.opacity / 2 : series.opacity).toString());
            } else element.setAttribute("opacity", series.opacity.toString());
        }
    };
    BaseTooltip.prototype.highlightPoints = function() {
        for(var _i = 0, _a = this.currentPoints; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.series.isRectSeries && item.series.category === "Series") this.highlightPoint(item.series, item.point.index, true);
        }
    };
    BaseTooltip.prototype.createTooltip = function(chart, isFirst, location, clipLocation, point, shapes, offset, bounds, crosshairEnabled, extraPoints, templatePoint, customTemplate) {
        if (crosshairEnabled === void 0) crosshairEnabled = false;
        if (extraPoints === void 0) extraPoints = null;
        if (templatePoint === void 0) templatePoint = null;
        var series = this.currentPoints[0].series;
        var tooltipModule = chart.tooltipModule || chart.tooltip3DModule || chart.accumulationTooltipModule;
        if (!tooltipModule || location === null) {
            (0, $11815a21a80ae2b7$export$f883456a56996078)(this.chart.element.id + "_tooltip");
            return;
        }
        if (isFirst) {
            this.svgTooltip = new (0, $aeafe7e2f4093d9a$export$28c660c63b792dea)({
                opacity: chart.tooltip.opacity ? chart.tooltip.opacity : this.chart.theme === "Material3" || this.chart.theme === "Material3Dark" || this.chart.theme.indexOf("Bootstrap5") > -1 ? 1 : 0.75,
                header: this.headerText,
                content: this.text,
                fill: chart.tooltip.fill,
                border: chart.tooltip.border,
                enableAnimation: chart.tooltip.enableAnimation,
                location: location,
                shared: this.control.tooltip.shared,
                crosshair: crosshairEnabled,
                shapes: shapes,
                clipBounds: this.chart.chartAreaType === "PolarRadar" ? new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(0, 0) : clipLocation,
                areaBounds: bounds,
                palette: this.findPalette(),
                template: customTemplate || this.template,
                data: templatePoint,
                theme: chart.theme,
                offset: offset,
                textStyle: chart.tooltip.textStyle,
                isNegative: series.isRectSeries && series.type !== "Waterfall" && point && point.y < 0,
                inverted: this.chart.requireInvertedAxis && series.isRectSeries,
                arrowPadding: this.text.length > 1 || this.chart.stockChart || this.chart.tooltip.location.x !== null || this.chart.tooltip.location.y !== null ? 0 : 7,
                availableSize: chart.availableSize,
                duration: this.chart.tooltip.duration,
                isCanvas: this.chart.enableCanvas,
                isFixed: this.chart.tooltip.location.x !== null || this.chart.tooltip.location.y !== null,
                isTextWrap: chart.tooltip.enableTextWrap && chart.getModuleName() === "chart",
                blazorTemplate: {
                    name: "Template",
                    parent: this.chart.tooltip
                },
                controlInstance: this.chart,
                enableRTL: chart.enableRtl,
                controlName: "Chart",
                allowHighlight: chart.getModuleName() === "chart" && !series.marker.allowHighlight,
                tooltipRender: function() {
                    tooltipModule.removeHighlight();
                    tooltipModule.highlightPoints();
                    tooltipModule.updatePreviousPoint(extraPoints);
                },
                animationComplete: function(args) {
                    if (args.tooltip.fadeOuted) tooltipModule.fadeOut(tooltipModule.previousPoints);
                }
            });
            this.svgTooltip.appendTo(this.getElement(this.element.id + "_tooltip"));
        } else if (this.svgTooltip) {
            this.svgTooltip.location = location;
            this.svgTooltip.content = this.text;
            this.svgTooltip.header = this.headerText;
            this.svgTooltip.offset = offset;
            this.svgTooltip.palette = this.findPalette();
            this.svgTooltip.shapes = shapes;
            this.svgTooltip.data = templatePoint;
            this.svgTooltip.template = this.template;
            this.svgTooltip.controlName = "Chart";
            this.svgTooltip.crosshair = crosshairEnabled;
            this.svgTooltip.textStyle = chart.tooltip.textStyle;
            this.svgTooltip.isNegative = series.isRectSeries && series.type !== "Waterfall" && point && point.y < 0;
            this.svgTooltip.clipBounds = this.chart.chartAreaType === "PolarRadar" ? new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(0, 0) : clipLocation;
            this.svgTooltip.arrowPadding = this.text.length > 1 || this.chart.stockChart || this.chart.tooltip.location.x !== null || this.chart.tooltip.location.y !== null ? 0 : 7;
            this.svgTooltip.allowHighlight = chart.getModuleName() === "chart" && !series.marker.allowHighlight;
            this.svgTooltip.dataBind();
        }
        if (this.chart.isReact) this.chart.renderReactTemplates();
    };
    BaseTooltip.prototype.findPalette = function() {
        var colors = [];
        for(var _i = 0, _a = this.currentPoints; _i < _a.length; _i++){
            var data = _a[_i];
            colors.push(this.findColor(data, data.series));
        }
        return colors;
    };
    BaseTooltip.prototype.findColor = function(data, series) {
        if (series.isRectSeries && (series.type === "Candle" || series.type === "Hilo" || series.type === "HiloOpenClose")) return data.point.color;
        else return (data.point.color && data.point.color !== "#ffffff" ? data.point.color : data.point.interior) || series.marker.fill || series.interior;
    };
    BaseTooltip.prototype.updatePreviousPoint = function(extraPoints) {
        if (extraPoints) this.currentPoints = this.currentPoints.concat(extraPoints);
        this.previousPoints = (0, $3EnZW.extend)([], this.currentPoints, null, true);
    };
    BaseTooltip.prototype.fadeOut = function(data) {
        var svgElement = this.chart.enableCanvas ? this.getElement(this.element.id + "_tooltip_group") : this.getElement(this.element.id + "_tooltip_svg");
        var isTooltip = svgElement && parseInt(svgElement.getAttribute("opacity"), 10) > 0;
        if (!isTooltip) {
            this.valueX = null;
            this.valueY = null;
            this.currentPoints = [];
            this.removeHighlight();
            this.removeHighlightedMarker(data, true);
            this.svgTooltip = null;
            this.control.trigger("animationComplete", {});
        }
    };
    /*
    * @hidden
    */ BaseTooltip.prototype.removeHighlightedMarker = function(data, fadeOut) {
        if (this.chart.markerRender) for(var _i = 0, data_1 = data; _i < data_1.length; _i++){
            var item = data_1[_i];
            (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_Series_" + item.series.index + "_Point_" + item.point.index + "_Trackball");
            this.chart.markerRender.removeHighlightedMarker(item.series, item.point, fadeOut);
        }
        this.previousPoints = [];
    };
    // public triggerEvent(point: PointData | AccPointData, isFirst: boolean, textCollection: string, firstText: boolean = true): boolean {
    //     let argsData: ITooltipRenderEventArgs = {
    //         cancel: false, name: tooltipRender, text: textCollection,
    //         point: point.point, series: point.series, textStyle: this.textStyle
    //     };
    //     this.chart.trigger(tooltipRender, argsData);
    //     if (!argsData.cancel) {
    //         if (point.series.type === 'BoxAndWhisker') {
    //             this.removeText();
    //             isFirst = true;
    //         }
    //         this.formattedText = this.formattedText.concat(argsData.text);
    //         this.text = this.formattedText;
    //     }
    //     return !argsData.cancel;
    // }
    BaseTooltip.prototype.removeText = function() {
        this.textElements = [];
        var element = this.getElement(this.element.id + "_tooltip_group");
        if (element && element.childNodes.length > 0) while(element.lastChild && element.childNodes.length !== 1)element.removeChild(element.lastChild);
    };
    BaseTooltip.prototype.stopAnimation = function() {
        (0, $11815a21a80ae2b7$export$4d41f7386211339a)(this.toolTipInterval);
    };
    /**
     * Removes the tooltip on mouse leave.
     *
     * @returns {void}
     * @private
     */ BaseTooltip.prototype.removeTooltip = function(duration) {
        var _this = this;
        var tooltipElement = this.getElement(this.element.id + "_tooltip");
        // const tooltipTemplate: HTMLElement = tooltipElement ? this.getElement(tooltipElement.id + 'parent_template') : null;
        // const isTemplateRendered: boolean = tooltipTemplate && tooltipTemplate.innerText !== '<div></div>';
        this.stopAnimation();
        if (tooltipElement && this.previousPoints.length > 0) this.toolTipInterval = +setTimeout(function() {
            if (_this.svgTooltip) _this.svgTooltip.fadeOut();
        }, duration);
    };
    return BaseTooltip;
}((0, $05077795990f958e$export$c23acf85d5f173c3));



var $58b0bf815360f2fc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The `Tooltip` module is used to render tooltips for chart series.
 */ var $58b0bf815360f2fc$export$28c660c63b792dea = /** @class */ function(_super) {
    $58b0bf815360f2fc$var$__extends(Tooltip, _super);
    /**
     * Constructor for the Touch module.
     *
     * @param {Chart} chart - The chart instance.
     */ function Tooltip(chart) {
        var _this = _super.call(this, chart) || this;
        _this.commonXvalues = [];
        _this.addEventListener();
        return _this;
    }
    /**
     * Adds event listeners for the chart.
     *
     * @returns {void}
     */ Tooltip.prototype.addEventListener = function() {
        if (this.chart.isDestroyed) return;
        var cancelEvent = (0, $5q7BP.Browser).isPointer ? "pointerleave" : "mouseleave";
        this.chart.on(cancelEvent, this.mouseLeaveHandler, this);
        this.chart.on("tapHold", this.longPress, this);
        this.chart.on((0, $5q7BP.Browser).touchMoveEvent, this.mouseMoveHandler, this);
        this.chart.on((0, $5q7BP.Browser).touchEndEvent, this.mouseUpHandler, this);
    };
    Tooltip.prototype.mouseUpHandler = function() {
        var chart = this.control;
        var data = this.getData();
        data.lierIndex = this.lierIndex;
        if (chart.isTouch && !this.isSelected(chart) && ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect) && chart.tooltip.shared || !chart.tooltip.shared)) {
            if (!chart.crosshair.enable) {
                this.tooltip();
                if (chart.tooltip.fadeOutMode === "Move") this.removeTooltip(chart.tooltip.fadeOutDuration);
            } else if (chart.startMove && chart.tooltip.fadeOutMode === "Move") this.removeTooltip(2000);
        } else if (!this.findData(data, this.previousPoints[0]) && chart.tooltip.fadeOutMode === "Click") this.removeTooltip(0);
    };
    Tooltip.prototype.mouseLeaveHandler = function() {
        this.removeTooltip(this.chart.tooltip.fadeOutDuration);
    };
    Tooltip.prototype.mouseMoveHandler = function() {
        var chart = this.chart;
        if (chart.stockChart && chart.stockChart.onPanning) {
            if (chart.mouseY < chart.chartAxisLayoutPanel.seriesClipRect.y) chart.mouseY = chart.chartAxisLayoutPanel.seriesClipRect.y;
            else if (chart.mouseY > chart.chartAxisLayoutPanel.seriesClipRect.y + chart.chartAxisLayoutPanel.seriesClipRect.height) chart.mouseY = chart.chartAxisLayoutPanel.seriesClipRect.y + chart.chartAxisLayoutPanel.seriesClipRect.height;
        }
        // Tooltip for chart series.
        if (!chart.disableTrackTooltip && !this.isSelected(chart)) {
            if (!chart.tooltip.shared && (!chart.isTouch || chart.startMove)) this.tooltip();
            if ((0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect)) {
                if (chart.tooltip.shared && (!chart.isTouch || chart.startMove)) this.tooltip();
            } else if (chart.tooltip.shared && chart.tooltip.fadeOutMode === "Move") this.removeTooltip(this.chart.tooltip.fadeOutDuration);
        }
    };
    /**
     * Handles the long press on chart.
     *
     * @returns {boolean} false
     * @private
     */ Tooltip.prototype.longPress = function() {
        var chart = this.chart;
        if (chart.crosshair.enable && (0, $11815a21a80ae2b7$export$2b0fe4f3565d7670)(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect)) {
            this.tooltip();
            chart.markerRender.markerMove(false);
        }
        return false;
    };
    /**
     * Renders the tooltip.
     *
     * @returns {void}
     * @private
     */ Tooltip.prototype.tooltip = function() {
        var elementId = this.chart.enableCanvas ? this.element.id + "_tooltip_group" : this.element.id + "_tooltip_svg";
        var svgElement = this.getElement(elementId);
        // To prevent the disappearance of the tooltip, while resize the stock chart.
        var isStockSvg = this.chart.stockChart && svgElement && svgElement.firstChild.childNodes.length > 1;
        var isTooltip = svgElement && parseInt(svgElement.getAttribute("opacity"), 10) > 0 && !isStockSvg;
        var tooltipDiv = this.getTooltipElement(isTooltip);
        if (this.chart.enableCanvas && tooltipDiv) {
            document.getElementById(this.chart.element.id + "_Secondary_Element").appendChild(tooltipDiv);
            tooltipDiv.appendChild(document.getElementById(this.chart.element.id + "_tooltip_svg"));
        }
        if (!this.chart.tooltip.shared) this.renderSeriesTooltip(this.chart, !isTooltip, tooltipDiv);
        else this.renderGroupedTooltip(this.chart, !isTooltip, tooltipDiv);
    };
    Tooltip.prototype.findHeader = function(data) {
        if (this.header === "") return "";
        this.header = this.parseTemplate(data.point, data.series, this.header, data.series.xAxis, data.series.yAxis);
        if (this.header.replace(/<b>/g, "").replace(/<\/b>/g, "").trim() !== "") return this.header;
        return "";
    };
    Tooltip.prototype.findShapes = function() {
        if (!this.chart.tooltip.enableMarker) return [];
        var marker = [];
        for(var _i = 0, _a = this.currentPoints; _i < _a.length; _i++){
            var data = _a[_i];
            marker.push(data.point.marker.shape || data.series.marker.shape || "Circle");
        }
        return marker;
    };
    Tooltip.prototype.renderSeriesTooltip = function(chart, isFirst, tooltipDiv) {
        var data = this.getData();
        data.lierIndex = this.lierIndex;
        this.currentPoints = [];
        if (this.findData(data, this.previousPoints[0])) {
            if (!(chart.dataEditingModule && chart.dataEditingModule.isPointDragging) && this.previousPoints[0] && data.point.index === this.previousPoints[0].point.index && data.series.index === this.previousPoints[0].series.index) return null;
            if (this.pushData(data, isFirst, tooltipDiv, true)) this.triggerTooltipRender(data, isFirst, this.getTooltipText(data), this.findHeader(data));
        } else if (!data.point && this.isRemove && chart.tooltip.fadeOutMode === "Move") {
            this.removeTooltip(this.chart.tooltip.fadeOutDuration);
            this.isRemove = false;
        } else {
            var commonXvalues = this.mergeXvalues(this.chart.visibleSeries);
            for(var _i = 0, _a = chart.visibleSeries; _i < _a.length; _i++){
                var series = _a[_i];
                if (series.visible && !(series.category === "TrendLine")) data = this.getClosestX(chart, series, commonXvalues) || data;
            }
        }
        if (data && data.point) this.findMouseValue(data, chart);
    };
    Tooltip.prototype.triggerTooltipRender = function(point, isFirst, textCollection, headerText) {
        var _this = this;
        var tooltipTemplate;
        var argsData = {
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$9387be9b28ea8206),
            text: textCollection,
            headerText: headerText,
            template: tooltipTemplate,
            series: this.chart.isBlazor ? {} : point.series,
            textStyle: this.textStyle,
            point: point.point,
            data: {
                pointX: point.point.x,
                pointY: point.point.y,
                seriesIndex: point.series.index,
                seriesName: point.series.name,
                pointIndex: point.point.index,
                pointText: point.point.text
            }
        };
        var borderWidth = this.chart.border.width;
        var padding = 3;
        var tooltip = this.chart.tooltip;
        var chartTooltipSuccess = function(argsData) {
            if (!argsData.cancel) {
                if (point.series.type === "BoxAndWhisker") {
                    _this.removeText();
                    isFirst = true;
                }
                _this.headerText = argsData.headerText;
                _this.formattedText = _this.formattedText.concat(argsData.text);
                _this.text = _this.formattedText;
                var location_1 = _this.getSymbolLocation(point);
                location_1 = location_1 ? location_1 : new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(null, null);
                location_1.x = tooltip.location.x !== null ? tooltip.location.x : location_1.x;
                location_1.y = tooltip.location.y !== null ? tooltip.location.y : location_1.y;
                location_1 = location_1.x === null && location_1.y === null ? null : location_1;
                _this.createTooltip(_this.chart, isFirst, location_1, point.series.clipRect, point.point, _this.findShapes(), _this.findMarkerHeight(_this.currentPoints[0]), new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(borderWidth, borderWidth, _this.chart.availableSize.width - padding - borderWidth * 2, _this.chart.availableSize.height - padding - borderWidth * 2), _this.chart.crosshair.enable, null, _this.getTemplateText(point), _this.template ? argsData.template : "");
            } else {
                _this.removeHighlight();
                (0, $4ZDHT.remove)(_this.getElement(_this.element.id + "_tooltip"));
            }
            _this.isRemove = true;
        };
        chartTooltipSuccess.bind(this, point);
        this.chart.trigger((0, $9415fc5f023d8fac$export$9387be9b28ea8206), argsData, chartTooltipSuccess);
    };
    Tooltip.prototype.findMarkerHeight = function(pointData) {
        var markerHeight = 0;
        var series = pointData.series;
        markerHeight = (series.marker.visible || this.chart.tooltip.shared && (!series.isRectSeries || series.marker.visible) || series.type === "Scatter" || series.drawType === "Scatter") && !(series.type === "Candle" || series.type === "Hilo" || series.type === "HiloOpenClose") ? (series.marker.height + 2) / 2 + 2 * series.marker.border.width : 0;
        return markerHeight;
    };
    Tooltip.prototype.findData = function(data, previous) {
        return data.point && (!previous || previous.point !== data.point || previous && previous.lierIndex > 3 && previous.lierIndex !== this.lierIndex || previous.point === data.point);
    };
    Tooltip.prototype.getSymbolLocation = function(data) {
        var location;
        if (data.series.type !== "BoxAndWhisker") {
            if (!data.point.symbolLocations[0]) return null;
            location = new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(data.point.symbolLocations[0].x, data.point.symbolLocations[0].y);
        }
        switch(data.series.type){
            case "BoxAndWhisker":
                return this.getBoxLocation(data);
            case "Waterfall":
                return this.getWaterfallRegion(data, location);
            case "RangeArea":
            case "RangeStepArea":
            case "SplineRangeArea":
            case "RangeColumn":
                return this.getRangeArea(data, location);
            default:
                return location;
        }
    };
    Tooltip.prototype.getRangeArea = function(data, location) {
        if (data.point.regions[0]) {
            if (!this.inverted) location.y = data.point.regions[0].y + data.point.regions[0].height / 2;
            else location.x = data.point.regions[0].x + data.point.regions[0].width / 2;
            if (data.series.type === "RangeStepArea") location.y = data.point.regions[0].y + data.point.regions[0].height / 2 + data.point.regions[0].width;
        }
        return location;
    };
    Tooltip.prototype.getWaterfallRegion = function(data, location) {
        if (!this.inverted) location.y = data.point.y < 0 ? location.y - data.point.regions[0].height : location.y;
        else location.x = data.point.y < 0 ? location.x + (this.chart.enableRtl ? -data.point.regions[0].width : data.point.regions[0].width) : location.x;
        return location;
    };
    Tooltip.prototype.getTooltipText = function(pointData) {
        var series = pointData.series;
        return this.parseTemplate(pointData.point, series, this.getFormat(this.chart, series), series.xAxis, series.yAxis);
    };
    Tooltip.prototype.getTemplateText = function(data) {
        if (this.template && this.chart.tooltip.shared) {
            var point = [];
            for(var i = 0; i < data.length; i++){
                point[i] = (0, $3EnZW.extend)({}, data[i].point);
                point[i].x = this.formatPointValue(data[i].point, data[i].series.xAxis, "x", true, false);
                if (data[i].series.seriesType === "XY") point[i].y = this.formatPointValue(data[i].point, data[i].series.yAxis, "y", false, true);
                else {
                    point[i].low = this.formatPointValue(data[i].point, data[i].series.yAxis, "low", false, true);
                    point[i].high = this.formatPointValue(data[i].point, data[i].series.yAxis, "high", false, true);
                }
            }
            return point;
        } else if (this.template) {
            var point = (0, $3EnZW.extend)({}, data.point);
            point.x = this.formatPointValue(data.point, data.series.xAxis, "x", true, false);
            if (data.series.seriesType === "XY") point.y = this.formatPointValue(data.point, data.series.yAxis, "y", false, true);
            else {
                point.low = this.formatPointValue(data.point, data.series.yAxis, "low", false, true);
                point.high = this.formatPointValue(data.point, data.series.yAxis, "high", false, true);
            }
            return point;
        } else return data.point;
    };
    Tooltip.prototype.findMouseValue = function(data, chart) {
        if (!chart.requireInvertedAxis) {
            if (chart.chartAreaType === "PolarRadar") this.valueX = (0, $11815a21a80ae2b7$export$2a79ca78387ac323)(data.point.xValue, data.series.xAxis) * data.series.xAxis.rect.width + data.series.xAxis.rect.x;
            else this.valueX = data.series.category === "TrendLine" && chart.tooltip.shared ? this.valueX : (0, $11815a21a80ae2b7$export$f83186674b8cab09)(data.point.xValue, data.series.xAxis) * data.series.xAxis.rect.width + data.series.xAxis.rect.x;
            this.valueY = chart.mouseY;
        } else {
            this.valueY = (1 - (0, $11815a21a80ae2b7$export$f83186674b8cab09)(data.point.xValue, data.series.xAxis)) * data.series.xAxis.rect.height + data.series.xAxis.rect.y;
            this.valueX = chart.mouseX;
        }
    };
    Tooltip.prototype.renderGroupedTooltip = function(chart, isFirst, tooltipDiv) {
        var data;
        var dataCollection = [];
        var lastData;
        var pointData = chart.chartAreaType === "PolarRadar" ? this.getData() : null;
        this.stopAnimation();
        this.removeHighlight();
        this.currentPoints = [];
        var extraPoints = [];
        var closestXValue = Number.MAX_VALUE;
        var closetYValue = Number.MAX_VALUE;
        var pointXValue;
        var pointYValue;
        var tempData;
        //let headerContent : string = '';
        if (isFirst) {
            if (!chart.stockChart) {
                if (tooltipDiv) document.getElementById(this.element.id + "_Secondary_Element").appendChild(tooltipDiv);
            } else if (tooltipDiv && !(0, $5d5f50c62a40f4c7$export$d16800b7e59a8051)(tooltipDiv.id)) document.getElementById(chart.stockChart.element.id + "_Secondary_Element").appendChild(tooltipDiv);
        }
        this.removeText();
        var argument = {
            text: [],
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$ec1dd2c0eeecad0c),
            data: [],
            point: [],
            series: [],
            headerText: "",
            textStyle: this.textStyle,
            template: []
        };
        var i = 0;
        for(var _i = 0, _a = chart.visibleSeries; _i < _a.length; _i++){
            var series = _a[_i];
            if (!series.enableTooltip || !series.visible) continue;
            if (chart.chartAreaType === "Cartesian" && series.visible) data = this.getClosestX(chart, series, this.commonXValue(this.chart.visibleSeries));
            else if (chart.chartAreaType === "PolarRadar" && series.visible && pointData.point !== null) data = new (0, $11815a21a80ae2b7$export$8b02a874d977053f)(series.points[pointData.point.index], series);
            // if (data && this.header !== '' && this.currentPoints.length === 0) {
            //     headerContent = this.findHeader(data);
            // }
            if (chart.tooltip.showNearestPoint && !data) data = this.getClosestX(chart, series, this.commonXValue([
                series
            ]));
            if (data) {
                argument.data.push({
                    pointX: data.point.x,
                    pointY: data.point.y,
                    seriesIndex: data.series.index,
                    seriesName: data.series.name,
                    pointIndex: data.point.index,
                    pointText: data.point.text
                });
                argument.series[i] = data.series;
                argument.point[i] = data.point;
                argument.headerText = this.findHeader(data);
                this.currentPoints.push(data);
                if (this.template != null) argument.template.push(this.template.toString());
                argument.text.push(this.getTooltipText(data));
                pointXValue = !chart.requireInvertedAxis ? chart.mouseX - data.series.clipRect.x : chart.mouseY - data.series.clipRect.y;
                pointYValue = chart.mouseY - data.series.clipRect.y;
                if (data.point.symbolLocations && data.point.symbolLocations.length && Math.abs(pointXValue - data.point.symbolLocations[0].x) <= closestXValue && Math.abs(data.point.symbolLocations[0].y - pointYValue) < Math.abs(closetYValue - pointYValue)) {
                    closestXValue = Math.abs(pointXValue - data.point.symbolLocations[0].x);
                    closetYValue = data.point.symbolLocations[0].y;
                    tempData = data;
                }
                lastData = data.series.category === "TrendLine" && chart.tooltip.shared ? lastData : tempData || data;
                dataCollection.push(data);
            }
            // if (data && this.triggerEvent(data, isFirst, this.getTooltipText(data)), this.findHeader(data)) {
            //     this.findMouseValue(data, chart);
            //     (<PointData[]>this.currentPoints).push(data);
            //     data = null;
            // } else if (data) {
            //     extraPoints.push(data);
            // }
            i++;
        }
        if (!chart.tooltip.showNearestPoint) {
            var collection = [];
            this.currentPoints = [];
            argument.point = [];
            argument.series = [];
            argument.data = [];
            argument.text = [];
            for(var _b = 0, dataCollection_1 = dataCollection; _b < dataCollection_1.length; _b++){
                var data_1 = dataCollection_1[_b];
                if (data_1.point.symbolLocations[0].x === lastData.point.symbolLocations[0].x || (data_1.series.type.indexOf("Column") !== -1 || lastData.series.type.indexOf("Column") !== -1) && data_1.point.xValue === lastData.point.xValue) {
                    argument.point.push(data_1.point);
                    argument.series.push(data_1.series);
                    argument.text.push(this.getTooltipText(data_1));
                    argument.headerText = this.findHeader(data_1);
                    collection.push(data_1);
                    argument.data.push({
                        pointX: data_1.point.x,
                        pointY: data_1.point.y,
                        seriesIndex: data_1.series.index,
                        seriesName: data_1.series.name,
                        pointIndex: data_1.point.index,
                        pointText: data_1.point.text
                    });
                }
            }
            dataCollection = collection;
            this.currentPoints = collection;
        }
        if (dataCollection.length > 0 && this.currentPoints.length > 0) this.triggerSharedTooltip(argument, lastData, extraPoints, chart, isFirst, dataCollection);
        else if (this.getElement(this.element.id + "_tooltip_path")) this.getElement(this.element.id + "_tooltip_path").setAttribute("d", "");
    };
    Tooltip.prototype.triggerSharedTooltip = function(argument, point, extraPoints, chart, isFirst, dataCollection) {
        var _this = this;
        var tooltipTemplate = argument.template;
        var argsData = {
            cancel: false,
            name: (0, $9415fc5f023d8fac$export$ec1dd2c0eeecad0c),
            text: argument.text,
            headerText: argument.headerText,
            textStyle: argument.textStyle,
            template: tooltipTemplate,
            point: argument.point,
            series: argument.series,
            data: argument.data
        };
        var borderWidth = this.chart.border.width;
        var padding = 3;
        var toolbarHeight;
        var titleHeight;
        var currentPoints = [];
        if (chart.stockChart) {
            toolbarHeight = chart.stockChart.enablePeriodSelector ? chart.stockChart.toolbarHeight : 0;
            titleHeight = (0, $5d5f50c62a40f4c7$export$866cc30a33805630)(this.chart.stockChart.title, this.chart.stockChart.titleStyle, this.chart.themeStyle.tooltipLabelFont).height + 10;
        }
        var sharedTooltip = function(argsData) {
            if (!argsData.cancel) {
                if (point.series.type === "BoxAndWhisker") {
                    _this.removeText();
                    isFirst = true;
                }
                for(var i = 0; i < argsData.text.length; i++)if (argsData.text[i]) currentPoints.push(_this.currentPoints[i]);
                _this.currentPoints = currentPoints;
                _this.formattedText = _this.formattedText.concat(argsData.text);
                _this.text = argsData.text;
                _this.headerText = argsData.headerText;
                if (typeof argsData.template != "object") {
                    argsData.template = argsData.template.split(",");
                    if (argsData.template.length > currentPoints.length) argsData.template = argsData.template.splice(argsData.template.length - 1);
                } else if (argsData.template.length > currentPoints.length) argsData.template.splice(argsData.template.length - 1);
                var tooltip = _this.chart.tooltip;
                _this.findMouseValue(point, _this.chart);
                var location_2 = _this.findSharedLocation();
                location_2 = location_2 ? location_2 : new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(null, null);
                location_2.x = tooltip.location.x !== null ? tooltip.location.x : location_2.x;
                location_2.y = tooltip.location.y !== null ? tooltip.location.y : location_2.y;
                location_2 = location_2.x === null && location_2.y === null ? null : location_2;
                _this.createTooltip(chart, isFirst, location_2, _this.currentPoints.length === 1 ? _this.currentPoints[0].series.clipRect : null, dataCollection.length === 1 ? dataCollection[0].point : null, _this.findShapes(), _this.findMarkerHeight(_this.currentPoints[0]), new (0, $5d5f50c62a40f4c7$export$c79fc6492f3af13d)(borderWidth, chart.stockChart ? toolbarHeight + titleHeight + borderWidth : borderWidth, _this.chart.availableSize.width - padding - borderWidth * 2, _this.chart.availableSize.height - padding - borderWidth * 2), _this.chart.crosshair.enable, extraPoints, _this.template ? _this.getTemplateText(dataCollection) : null, _this.template ? argsData.template.join("") : "");
                point = null;
            } else {
                (0, $11815a21a80ae2b7$export$f883456a56996078)(_this.element.id + "_tooltip");
                extraPoints.push(point);
            }
        };
        sharedTooltip.bind(this, point, extraPoints);
        this.chart.trigger((0, $9415fc5f023d8fac$export$ec1dd2c0eeecad0c), argsData, sharedTooltip);
    };
    Tooltip.prototype.findSharedLocation = function() {
        var stockChart = this.chart.stockChart;
        if (stockChart) {
            if (this.text.length === 1) this.text.push("");
            var toolbarHeight = stockChart.enablePeriodSelector ? stockChart.toolbarHeight : 0;
            var element = document.getElementById(stockChart.element.id + "_ChartTitle");
            var titleHeight = stockChart.title !== "" ? element.getBoundingClientRect().height + 10 : 0;
            if (stockChart.tooltip.position === "Nearest") return new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(this.valueX, this.valueY + toolbarHeight + titleHeight);
            return new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(this.chart.chartAxisLayoutPanel.seriesClipRect.x + 5, this.chart.chartAxisLayoutPanel.seriesClipRect.y + toolbarHeight + 5 + titleHeight);
        } else {
            if (this.currentPoints.length > 1) return new (0, $11815a21a80ae2b7$export$5ee9ad52a250f7ed)(this.valueX, this.valueY);
            else return this.getSymbolLocation(this.currentPoints[0]);
        }
    };
    Tooltip.prototype.getBoxLocation = function(data) {
        var location = this.lierIndex > 3 ? data.point.outliers.length > 0 ? data.point.symbolLocations[this.lierIndex - 4] : null : {
            x: data.point.regions[0].x + data.point.regions[0].width / 2,
            y: data.point.regions[0].y + data.point.regions[0].height / 2
        };
        return location;
    };
    Tooltip.prototype.parseTemplate = function(point, series, format, xAxis, yAxis) {
        var val;
        var textValue;
        var regExp = RegExp;
        for(var _i = 0, _a = Object.keys(point); _i < _a.length; _i++){
            var dataValue = _a[_i];
            val = new regExp("${point." + dataValue + "}", "gm");
            format = format.replace(val.source, this.formatPointValue(point, val.source === "${point.x}" ? xAxis : yAxis, dataValue, val.source === "${point.x}", val.source === "${point.high}" || val.source === "${point.open}" || val.source === "${point.close}" || val.source === "${point.low}" || val.source === "${point.y}" || val.source === "${point.minimum}" || val.source === "${point.maximum}" || val.source === "${point.outliers}" || val.source === "${point.upperQuartile}" || val.source === "${point.lowerQuartile}" || val.source === "${point.median}"));
        }
        for(var _b = 0, _c = Object.keys(Object.getPrototypeOf(series)); _b < _c.length; _b++){
            var dataValue = _c[_b];
            val = new regExp("${series." + dataValue + "}", "gm");
            textValue = series[dataValue];
            format = format.replace(val.source, textValue);
        }
        return format;
    };
    Tooltip.prototype.formatPointValue = function(point, axis, dataValue, isXPoint, isYPoint) {
        var textValue;
        var customLabelFormat;
        var value;
        if (axis.valueType !== "Category" && isXPoint) {
            customLabelFormat = axis.labelFormat && axis.labelFormat.match("{value}") !== null;
            textValue = customLabelFormat ? axis.labelFormat.replace("{value}", axis.format(point[dataValue])) : axis.format(point[dataValue]);
        } else if (isYPoint && !(0, $3EnZW.isNullOrUndefined)(point[dataValue])) {
            customLabelFormat = axis.labelFormat && axis.labelFormat.match("{value}") !== null;
            value = dataValue === "outliers" ? axis.format(point[dataValue][this.lierIndex - 4]) : axis.format(+point[dataValue]);
            textValue = customLabelFormat ? axis.labelFormat.replace("{value}", value) : value;
        } else if (dataValue === "size") {
            var format = this.chart.intl.getNumberFormat({
                format: "",
                useGrouping: this.chart.useGroupingSeparator
            });
            textValue = typeof point[dataValue] === "number" ? format(point[dataValue]) : point[dataValue];
        } else textValue = point[dataValue];
        return textValue;
    };
    Tooltip.prototype.getFormat = function(chart, series) {
        if (series.tooltipFormat) {
            if (series.seriesType === "XY" && series.category === "Indicator") return this.getIndicatorTooltipFormat(series, chart, chart.tooltip.format);
            return series.tooltipFormat;
        }
        if (!series.tooltipFormat && chart.tooltip.format) {
            if (series.seriesType === "XY" && series.category === "Indicator") return this.getIndicatorTooltipFormat(series, chart, chart.tooltip.format);
            return chart.tooltip.format;
        }
        var textX = series.type === "Histogram" ? "${point.minimum}-${point.maximum}" : "${point.x}";
        var format = !chart.tooltip.shared ? textX : "${series.name}";
        switch(series.seriesType){
            case "XY":
                if (series.category === "Indicator") this.getIndicatorTooltipFormat(series, chart, chart.tooltip.format);
                return format + " : " + (series.type === "Bubble" ? "<b>${point.y}</b>  Size : <b>${point.size}</b>" : "<b>${point.y}</b>");
            case "HighLow":
                return format + "<br/>High : <b>${point.high}</b><br/>Low : <b>${point.low}</b>";
            case "HighLowOpenClose":
                return format + "<br/>High : <b>${point.high}</b><br/>Low : <b>${point.low}</b><br/>Open : <b>${point.open}</b><br/>Close : <b>${point.close}</b>";
            case "BoxPlot":
                return format + "<br/>" + (this.lierIndex > 3 ? "Outliers : <b>${point.outliers}</b>" : "Maximum : <b>${point.maximum}</b><br/>Q3 : <b>${point.upperQuartile}</b><br/>Median : <b>${point.median}</b><br/>Q1 : <b>${point.lowerQuartile}</b><br/>Minimum : <b>${point.minimum}</b>");
        }
    };
    Tooltip.prototype.getIndicatorTooltipFormat = function(series, chart, format) {
        var toolTip;
        if (series.seriesType === "XY") toolTip = series.name + " : <b>${point.y}</b>";
        else toolTip = format;
        return toolTip;
    };
    /*
    * @hidden
    */ Tooltip.prototype.removeHighlightedMarker = function(data, fadeOut) {
        for(var _i = 0, data_2 = data; _i < data_2.length; _i++){
            var item = data_2[_i];
            (0, $11815a21a80ae2b7$export$f883456a56996078)(this.element.id + "_Series_" + item.series.index + "_Point_" + item.point.index + "_Trackball");
            if (this.chart.markerRender) this.chart.markerRender.removeHighlightedMarker(item.series, item.point, fadeOut);
        }
        this.previousPoints = [];
    };
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */ Tooltip.prototype.getModuleName = function() {
        /**
         * Returns the module name
         */ return "Tooltip";
    };
    /**
     * To destroy the tooltip.
     *
     * @returns {void}
     * @private
     */ Tooltip.prototype.destroy = function() {
    /**
         * Destroy method performed here
         */ };
    return Tooltip;
}((0, $43ef68bd5efcefa0$export$ba0102162f9e195c));
























(0, $7c7d40c195159aeb$export$acaa6426d77a227e).Inject((0, $16363daad46d2025$export$2d315e625d1b73ef), (0, $4484456d62ae4fe7$export$7cb365a371b161cd), (0, $2786904b7ad446ea$export$2db55af16212ab81), (0, $3d9da221882eb0c6$export$876b8bd838c9945c), (0, $5a5b2b40af1980fd$export$3a8840c5b2ecf003), (0, $7bcacb0842c8c01a$export$2b4a904504ac8010), (0, $331409338e08b18d$export$ed247974535929c7), (0, $58b0bf815360f2fc$export$28c660c63b792dea));
document.addEventListener("DOMContentLoaded", ()=>{
    if (document.getElementById("dashboard")) {
        $a91c6ece34c5f26d$var$initViewPicker();
        $a91c6ece34c5f26d$var$initUserPicker();
        const view = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DASHBOARD_VIEW.name) ?? (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DEFAULT_DASHBOARD_VIEW.name);
        if (view === (0, $19ee14db620c232e$export$33312d3da85d8994).CompanyDeadlines) {
            $a91c6ece34c5f26d$var$initCompanyDeadlineChart();
            $a91c6ece34c5f26d$var$initCompanyDeadlineMonthlyChart();
        } else if (view === (0, $19ee14db620c232e$export$33312d3da85d8994).TaskDeadlines) {
            $a91c6ece34c5f26d$var$initTaskDeadlineChart();
            $a91c6ece34c5f26d$var$initTaskDeadlineMonthlyChart();
        }
    }
});
const $a91c6ece34c5f26d$var$initViewPicker = ()=>{
    const input = document.getElementById("view-picker");
    const viewPicker = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
        dataSource: (0, $8f1a5b17b2b7f2a2$export$1b3bd537b0bce4b3)((0, $19ee14db620c232e$export$33312d3da85d8994)),
        fields: {
            value: "value",
            text: "text"
        },
        value: (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DASHBOARD_VIEW.name) ?? (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DEFAULT_DASHBOARD_VIEW.name),
        allowCustom: false,
        showClearButton: false,
        change: ()=>{
            const view = viewPicker.value;
            (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DASHBOARD_VIEW.name, view);
            location.reload();
        }
    });
    viewPicker.appendTo(input);
};
const $a91c6ece34c5f26d$var$initUserPicker = ()=>{
    const input = document.getElementById("user-picker");
    const userPicker = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
        dataSource: new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
            url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.list({
                model: "MemberView"
            }),
            adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
        }),
        fields: {
            value: "value",
            text: "text"
        },
        placeholder: "All Users",
        sortOrder: "Ascending",
        value: (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).USER_ID_FILTER.name),
        allowCustom: false,
        change: ()=>{
            const userId = userPicker.value;
            if (userId) (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).USER_ID_FILTER.name, userId);
            else (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).remove((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).USER_ID_FILTER.name);
            location.reload();
        }
    });
    userPicker.appendTo(input);
};
const $a91c6ece34c5f26d$var$initCompanyDeadlineChart = ()=>{
    const element = document.getElementById("deadline-chart");
    const companyDeadlineViews = JSON.parse(element.dataset.data);
    if (companyDeadlineViews.length > 0) {
        const font = {
            fontFamily: (0, $e56e694ede576bd9$export$530097e879f93363),
            size: "0.875rem"
        };
        const companyDeadlineViewSeries = (props)=>{
            return {
                ...props,
                type: "StackingBar100",
                dataSource: companyDeadlineViews,
                marker: {
                    dataLabel: {
                        visible: true,
                        format: "n",
                        position: "Middle",
                        font: {
                            ...font,
                            color: "#FFF"
                        }
                    }
                },
                border: {
                    width: 0
                },
                animation: {
                    duration: 300
                }
            };
        };
        const series = [
            companyDeadlineViewSeries({
                name: "Due to start",
                xName: "type",
                yName: "due30To60Days"
            }),
            companyDeadlineViewSeries({
                name: "Due to complete",
                xName: "type",
                yName: "due30Days"
            }),
            companyDeadlineViewSeries({
                name: "Completed (30 days)",
                xName: "type",
                yName: "due"
            })
        ];
        const chart = new (0, $7c7d40c195159aeb$export$acaa6426d77a227e)({
            titleStyle: font,
            chartArea: {
                border: {
                    width: 0
                }
            },
            series: series,
            primaryXAxis: {
                valueType: "Category",
                majorGridLines: {
                    width: 0
                },
                majorTickLines: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font
            },
            primaryYAxis: {
                edgeLabelPlacement: "Shift",
                majorTickLines: {
                    width: 0
                },
                lineStyle: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font,
                visible: false
            },
            palettes: [
                "#01CBCD",
                "#FF8C00",
                "#DC3545"
            ],
            legendSettings: {
                visible: false
            },
            height: `${companyDeadlineViews.length * 50}px`,
            axisLabelRender: (args)=>{
                args.text = (0, $d47525176c3f6cd7$export$5850a84d4d68b1b5)(args.text);
            },
            textRender: (args)=>{
                args.cancel = args.point.y === 0;
            },
            pointClick: (args)=>{
                const dueTimeFrameType = args.point.x;
                const { yName: dueTimeFrame } = args.series;
                if (dueTimeFrame === "due30To60Days") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueWithin30To60Days,
                    dueTimeFrameType: dueTimeFrameType
                });
                else if (dueTimeFrame === "due30Days") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueWithin30Days,
                    dueTimeFrameType: dueTimeFrameType
                });
                else if (dueTimeFrame === "due") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).Due,
                    dueTimeFrameType: dueTimeFrameType
                });
            }
        });
        chart.appendTo(element);
    } else {
        const placeholder = element.querySelector(".chart-placeholder");
        placeholder.classList.remove("d-none");
        placeholder.classList.add("d-block");
    }
};
const $a91c6ece34c5f26d$var$initCompanyDeadlineMonthlyChart = ()=>{
    const element = document.getElementById("monthly-deadline-chart");
    const items = JSON.parse(element.dataset.data);
    if (items.length > 0) {
        const font = {
            fontFamily: (0, $e56e694ede576bd9$export$530097e879f93363),
            size: "0.875rem"
        };
        const serviceViewSeries = (props)=>{
            return {
                ...props,
                type: "Column",
                dataSource: items,
                marker: {
                    dataLabel: {
                        visible: true,
                        format: "n",
                        position: "Middle",
                        font: {
                            ...font,
                            color: "#FFF"
                        }
                    }
                },
                border: {
                    width: 0
                },
                animation: {
                    duration: 300
                },
                enableTooltip: true
            };
        };
        const series = [
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)()),
                xName: "type",
                yName: "month1DueCount",
                groupName: "month1"
            }),
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 1)),
                xName: "type",
                yName: "month2DueCount",
                groupName: "month2"
            }),
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 2)),
                xName: "type",
                yName: "month3DueCount",
                groupName: "month3"
            })
        ];
        const chart = new (0, $7c7d40c195159aeb$export$acaa6426d77a227e)({
            titleStyle: font,
            chartArea: {
                border: {
                    width: 0
                }
            },
            series: series,
            primaryXAxis: {
                valueType: "Category",
                majorGridLines: {
                    width: 1
                },
                majorTickLines: {
                    width: 1
                },
                titleStyle: font,
                labelStyle: font
            },
            primaryYAxis: {
                majorTickLines: {
                    width: 0
                },
                lineStyle: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font,
                visible: false
            },
            palettes: [
                "#01CBCD",
                "#0A415C",
                "#5C636A"
            ],
            legendSettings: {
                textStyle: font,
                padding: 20,
                toggleVisibility: false
            },
            legendClick: (args)=>{
                const { yName: countName } = args.series;
                if (countName === "month1DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueThisMonth
                });
                else if (countName === "month2DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueNextMonth
                });
                else if (countName === "month3DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueMonthAfterNext
                });
            },
            height: "500px",
            axisLabelRender: (args)=>{
                args.text = (0, $d47525176c3f6cd7$export$5850a84d4d68b1b5)(args.text);
            },
            textRender: (args)=>{
                args.cancel = args.point.y === 0;
            },
            pointClick: (args)=>{
                const dueTimeFrameType = args.point.x;
                const { yName: countName } = args.series;
                if (countName === "month1DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueThisMonth,
                    dueTimeFrameType: dueTimeFrameType
                });
                else if (countName === "month2DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueNextMonth,
                    dueTimeFrameType: dueTimeFrameType
                });
                else if (countName === "month3DueCount") location.href = (0, $55576f0fdfdeec43$export$49840abff869cea)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueMonthAfterNext,
                    dueTimeFrameType: dueTimeFrameType
                });
            }
        });
        chart.appendTo(element);
    } else {
        const placeholder = element.querySelector(".chart-placeholder");
        placeholder.classList.remove("d-none");
        placeholder.classList.add("d-block");
    }
};
const $a91c6ece34c5f26d$var$initTaskDeadlineChart = ()=>{
    const element = document.getElementById("deadline-chart");
    const serviceViews = JSON.parse(element.dataset.data);
    if (serviceViews.length > 0) {
        const font = {
            fontFamily: (0, $e56e694ede576bd9$export$530097e879f93363),
            size: "0.875rem"
        };
        const serviceViewSeries = (props)=>{
            return {
                ...props,
                type: "StackingBar100",
                dataSource: serviceViews,
                marker: {
                    dataLabel: {
                        visible: true,
                        format: "n",
                        position: "Middle",
                        font: {
                            ...font,
                            color: "#FFF"
                        }
                    }
                },
                border: {
                    width: 0
                },
                animation: {
                    duration: 300
                }
            };
        };
        const series = [
            serviceViewSeries({
                name: "Due to start",
                xName: "name",
                yName: "startDueTaskCount"
            }),
            serviceViewSeries({
                name: "Started",
                xName: "name",
                yName: "startedTaskCount"
            }),
            serviceViewSeries({
                name: "Due to complete",
                xName: "name",
                yName: "completionDueTaskCount"
            }),
            serviceViewSeries({
                name: "Overdue",
                xName: "name",
                yName: "deadlineDateDueTaskCount"
            }),
            serviceViewSeries({
                name: "Completed (30 days)",
                xName: "name",
                yName: "completed30DaysTaskCount"
            })
        ];
        const chart = new (0, $7c7d40c195159aeb$export$acaa6426d77a227e)({
            titleStyle: font,
            chartArea: {
                border: {
                    width: 0
                }
            },
            series: series,
            primaryXAxis: {
                valueType: "Category",
                majorGridLines: {
                    width: 0
                },
                majorTickLines: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font
            },
            primaryYAxis: {
                edgeLabelPlacement: "Shift",
                majorTickLines: {
                    width: 0
                },
                lineStyle: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font,
                visible: false
            },
            palettes: [
                "#01CBCD",
                "#FFC107",
                "#FF8C00",
                "#DC3545",
                "#198754"
            ],
            legendSettings: {
                visible: false
            },
            height: `${serviceViews.length * 50}px`,
            axisLabelRender: (args)=>{
                if (args.text === "(No Service)") args.labelStyle.color = "#adb5bd";
            },
            textRender: (args)=>{
                args.cancel = args.point.y === 0;
            },
            axisLabelClick: (args)=>{
                const { text: serviceName } = args;
                const { id: serviceId } = serviceViews.filter((serviceView)=>serviceView.name === serviceName)[0];
                location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    preset: "uncompleted"
                });
            },
            pointClick: (args)=>{
                const { x: serviceName } = args.point;
                const { yName: countName } = args.series;
                const { id: serviceId } = serviceViews.filter((serviceView)=>serviceView.name === serviceName)[0];
                if (countName === "startDueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).StartDue
                });
                else if (countName === "startedTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Started
                });
                else if (countName === "completionDueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).CompletionDue
                });
                else if (countName === "deadlineDateDueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).DeadlineDue
                });
                else if (countName === "completed30DaysTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    preset: "completed30Days"
                });
            }
        });
        chart.appendTo(element);
    } else {
        const placeholder = element.querySelector(".chart-placeholder");
        placeholder.classList.remove("d-none");
        placeholder.classList.add("d-block");
    }
};
const $a91c6ece34c5f26d$var$initTaskDeadlineMonthlyChart = ()=>{
    const element = document.getElementById("monthly-deadline-chart");
    const items = JSON.parse(element.dataset.data);
    if (items.length > 0) {
        const font = {
            fontFamily: (0, $e56e694ede576bd9$export$530097e879f93363),
            size: "0.875rem"
        };
        const serviceViewSeries = (props)=>{
            return {
                ...props,
                type: "StackingColumn",
                dataSource: items,
                marker: {
                    dataLabel: {
                        visible: true,
                        format: "n",
                        position: "Middle",
                        font: {
                            ...font,
                            color: "#FFF"
                        }
                    }
                },
                border: {
                    width: 0
                },
                animation: {
                    duration: 300
                },
                enableTooltip: true
            };
        };
        const series = [
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)()),
                xName: "name",
                yName: "month1DueTaskCount",
                groupName: "month1",
                stackingGroup: "month1"
            }),
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 1)),
                xName: "name",
                yName: "month2DueTaskCount",
                groupName: "month2",
                stackingGroup: "month2"
            }),
            serviceViewSeries({
                name: (0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 2)),
                xName: "name",
                yName: "month3DueTaskCount",
                groupName: "month3",
                stackingGroup: "month3"
            }),
            serviceViewSeries({
                name: `${(0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)())} (completed)`,
                xName: "name",
                yName: "month1CompletedTaskCount",
                groupName: "month1",
                stackingGroup: "month1",
                opacity: 0.2
            }),
            serviceViewSeries({
                name: `${(0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 1))} (completed)`,
                xName: "name",
                yName: "month2CompletedTaskCount",
                groupName: "month2",
                stackingGroup: "month2",
                opacity: 0.2
            }),
            serviceViewSeries({
                name: `${(0, $d47525176c3f6cd7$export$8bc66d1bb2943e6e)((0, $9f9ac9f3de351425$export$1a67e3bf22830960)((0, $9f9ac9f3de351425$export$6e9f82d5020ebbe1)(), 2))} (completed)`,
                xName: "name",
                yName: "month3CompletedTaskCount",
                groupName: "month3",
                stackingGroup: "month3",
                opacity: 0.2
            })
        ];
        const chart = new (0, $7c7d40c195159aeb$export$acaa6426d77a227e)({
            titleStyle: font,
            chartArea: {
                border: {
                    width: 0
                }
            },
            series: series,
            primaryXAxis: {
                valueType: "Category",
                majorGridLines: {
                    width: 1
                },
                majorTickLines: {
                    width: 1
                },
                titleStyle: font,
                labelStyle: font
            },
            primaryYAxis: {
                majorTickLines: {
                    width: 0
                },
                lineStyle: {
                    width: 0
                },
                titleStyle: font,
                labelStyle: font,
                visible: false
            },
            palettes: [
                "#01CBCD",
                "#0A415C",
                "#5C636A"
            ],
            legendSettings: {
                textStyle: font,
                padding: 20,
                toggleVisibility: false
            },
            height: "500px",
            legendRender: (args)=>{
                if (args.text.endsWith("(completed)")) args.cancel = true;
            },
            legendClick: (args)=>{
                const { yName: countName } = args.series;
                if (countName === "month1DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueThisMonth,
                    preset: "uncompleted"
                });
                else if (countName === "month2DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueNextMonth,
                    preset: "uncompleted"
                });
                else if (countName === "month3DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueMonthAfterNext,
                    preset: "uncompleted"
                });
            },
            axisLabelRender: (args)=>{
                if (args.text === "(No Service)") args.labelStyle.color = "#adb5bd";
            },
            textRender: (args)=>{
                args.cancel = args.point.y === 0;
            },
            pointClick: (args)=>{
                const { x: serviceName } = args.point;
                const { yName: countName } = args.series;
                const { id: serviceId } = items.filter((item)=>item.name === serviceName)[0];
                if (countName === "month1DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueThisMonth,
                    preset: "uncompleted"
                });
                else if (countName === "month2DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueNextMonth,
                    preset: "uncompleted"
                });
                else if (countName === "month3DueTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueMonthAfterNext,
                    preset: "uncompleted"
                });
                else if (countName === "month1CompletedTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueThisMonth,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed
                });
                else if (countName === "month2CompletedTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueNextMonth,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed
                });
                else if (countName === "month3CompletedTaskCount") location.href = (0, $55576f0fdfdeec43$export$77b11bc1d67f694f)({
                    serviceId: serviceId,
                    dueTimeFrame: (0, $19ee14db620c232e$export$c3dc51c8ec50c91b).DueMonthAfterNext,
                    status: (0, $19ee14db620c232e$export$61db76a97f26b7e1).Completed
                });
            }
        });
        chart.appendTo(element);
    } else {
        const placeholder = element.querySelector(".chart-placeholder");
        placeholder.classList.remove("d-none");
        placeholder.classList.add("d-block");
    }
};



var $b488569ebaeb416e$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $d0da4566d2fd20fe$var$getRandomValues;
var $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === "string" && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8fb7ad22aed8f433$var$byteToHex = [];
for(var $8fb7ad22aed8f433$var$i = 0; $8fb7ad22aed8f433$var$i < 256; ++$8fb7ad22aed8f433$var$i)$8fb7ad22aed8f433$var$byteToHex.push(($8fb7ad22aed8f433$var$i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    var uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$8fb373d660548968)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;



const $054ea8408f8aeb09$export$674c05fa57e365a9 = ()=>{
    const deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DEVICE_ID.name);
    if (!deviceId) (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set((0, $776cb5c3f0fbb5bc$export$9e98cacf66dcab6a).DEVICE_ID.name, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
};



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");
var $3P3ke = parcelRequire("3P3ke");
var $i528u = parcelRequire("i528u");




parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $3EnZW = parcelRequire("3EnZW");

/* eslint-disable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */ /**
 * MaskedTextBox base module
 */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");

var $6a5d336953e9198b$var$ERROR = "e-error";
var $6a5d336953e9198b$var$INPUTGROUP = "e-input-group";
var $6a5d336953e9198b$var$FLOATINPUT = "e-float-input";
var $6a5d336953e9198b$var$UTILMASK = "e-utility-mask";
var $6a5d336953e9198b$var$TOPLABEL = "e-label-top";
var $6a5d336953e9198b$var$BOTTOMLABEL = "e-label-bottom";
var $6a5d336953e9198b$export$4b10ab455aed8214 = {
    "0": "[0-9]",
    "9": "[0-9 ]",
    "#": "[0-9 +-]",
    "L": "[A-Za-z]",
    "?": "[A-Za-z ]",
    "&": "[^\x7f ]+",
    "C": "[^\x7f]+",
    "A": "[A-Za-z0-9]",
    "a": "[A-Za-z0-9 ]"
};
function $6a5d336953e9198b$export$d086c3c83b5d30c4() {
    (0, $4ZDHT.attributes)(this.element, {
        "role": "textbox",
        "autocomplete": "off",
        "autocapitalize": "off",
        "spellcheck": "false",
        "aria-live": "assertive"
    });
    if (this.mask) {
        var splitMask = this.mask.split("]");
        for(var i = 0; i < splitMask.length; i++)if (splitMask[i][splitMask[i].length - 1] === "\\") {
            splitMask[i] = splitMask[i] + "]";
            var splitInnerMask = splitMask[i].split("[");
            for(var j = 0; j < splitInnerMask.length; j++){
                if (splitInnerMask[j][splitInnerMask[j].length - 1] === "\\") splitInnerMask[j] = splitInnerMask[j] + "[";
                $6a5d336953e9198b$var$pushIntoRegExpCollec.call(this, splitInnerMask[j]);
            }
        } else {
            var splitInnerMask = splitMask[i].split("[");
            if (splitInnerMask.length > 1) {
                var chkSpace = false;
                for(var j = 0; j < splitInnerMask.length; j++){
                    if (splitInnerMask[j] === "\\") {
                        this.customRegExpCollec.push("[");
                        this.hiddenMask += splitInnerMask[j] + "[";
                    } else if (splitInnerMask[j] === "") chkSpace = true;
                    else if (splitInnerMask[j] !== "" && chkSpace || j === splitInnerMask.length - 1) {
                        this.customRegExpCollec.push("[" + splitInnerMask[j] + "]");
                        this.hiddenMask += this.promptChar;
                        chkSpace = false;
                    } else $6a5d336953e9198b$var$pushIntoRegExpCollec.call(this, splitInnerMask[j]);
                }
            } else $6a5d336953e9198b$var$pushIntoRegExpCollec.call(this, splitInnerMask[0]);
        }
        this.escapeMaskValue = this.hiddenMask;
        this.promptMask = this.hiddenMask.replace(/[09?LCAa#&]/g, this.promptChar);
        if (!(0, $3EnZW.isNullOrUndefined)(this.customCharacters)) {
            for(var i = 0; i < this.promptMask.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(this.customCharacters[this.promptMask[i]])) /* eslint-disable-next-line security/detect-non-literal-regexp */ this.promptMask = this.promptMask.replace(new RegExp(this.promptMask[i], "g"), this.promptChar);
        }
        var escapeNumber = 0;
        if (this.hiddenMask.match(new RegExp(/\\/))) for(var i = 0; i < this.hiddenMask.length; i++){
            var j = 0;
            if (i >= 1) j = i;
            escapeNumber = this.hiddenMask.length - this.promptMask.length;
            j = j - escapeNumber;
            if (i > 0 && this.hiddenMask[i - 1] !== "\\" && (this.hiddenMask[i] === ">" || this.hiddenMask[i] === "<" || this.hiddenMask[i] === "|")) {
                this.promptMask = this.promptMask.substring(0, j) + this.promptMask.substring(i + 1 - escapeNumber, this.promptMask.length);
                this.escapeMaskValue = this.escapeMaskValue.substring(0, j) + this.escapeMaskValue.substring(i + 1 - escapeNumber, this.escapeMaskValue.length);
            }
            if (this.hiddenMask[i] === "\\") {
                this.promptMask = this.promptMask.substring(0, j) + this.hiddenMask[i + 1] + this.promptMask.substring(i + 2 - escapeNumber, this.promptMask.length);
                this.escapeMaskValue = this.escapeMaskValue.substring(0, j) + this.escapeMaskValue[i + 1] + this.escapeMaskValue.substring(i + 2 - escapeNumber, this.escapeMaskValue.length);
            }
        }
        else {
            this.promptMask = this.promptMask.replace(/[>|<]/g, "");
            this.escapeMaskValue = this.hiddenMask.replace(/[>|<]/g, "");
        }
        (0, $4ZDHT.attributes)(this.element, {
            "aria-invalid": "false"
        });
    }
}
function $6a5d336953e9198b$export$a1c9aa9c0e8ba394() {
    $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
    $6a5d336953e9198b$export$8a23d08effb90d01.call(this, this.value);
}
function $6a5d336953e9198b$export$6470dec3e2ff9874() {
    (0, $aqzbR.EventHandler).add(this.element, "keydown", $6a5d336953e9198b$var$maskInputKeyDownHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "keypress", $6a5d336953e9198b$var$maskInputKeyPressHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "keyup", $6a5d336953e9198b$var$maskInputKeyUpHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "input", $6a5d336953e9198b$var$maskInputHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "focus", $6a5d336953e9198b$export$23e0fd9387527395, this);
    (0, $aqzbR.EventHandler).add(this.element, "blur", $6a5d336953e9198b$export$2e49bbe533eed1cf, this);
    (0, $aqzbR.EventHandler).add(this.element, "paste", $6a5d336953e9198b$var$maskInputPasteHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "cut", $6a5d336953e9198b$var$maskInputCutHandler, this);
    (0, $aqzbR.EventHandler).add(this.element, "drop", $6a5d336953e9198b$export$aa389c3341c4ff67, this);
    (0, $aqzbR.EventHandler).add(this.element, "mousedown", $6a5d336953e9198b$export$483e0fb0250cc873, this);
    (0, $aqzbR.EventHandler).add(this.element, "mouseup", $6a5d336953e9198b$export$99abd87c7a8c840f, this);
    if (this.enabled) {
        $6a5d336953e9198b$export$6f0baecdf675c3b.call(this);
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", $6a5d336953e9198b$var$resetFormHandler, this);
    }
}
function $6a5d336953e9198b$export$5a8105d882fc3d97() {
    (0, $aqzbR.EventHandler).remove(this.element, "keydown", $6a5d336953e9198b$var$maskInputKeyDownHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "keypress", $6a5d336953e9198b$var$maskInputKeyPressHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "keyup", $6a5d336953e9198b$var$maskInputKeyUpHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "input", $6a5d336953e9198b$var$maskInputHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "focus", $6a5d336953e9198b$export$23e0fd9387527395);
    (0, $aqzbR.EventHandler).remove(this.element, "blur", $6a5d336953e9198b$export$2e49bbe533eed1cf);
    (0, $aqzbR.EventHandler).remove(this.element, "paste", $6a5d336953e9198b$var$maskInputPasteHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "cut", $6a5d336953e9198b$var$maskInputCutHandler);
    (0, $aqzbR.EventHandler).remove(this.element, "drop", $6a5d336953e9198b$export$aa389c3341c4ff67);
    (0, $aqzbR.EventHandler).remove(this.element, "mousedown", $6a5d336953e9198b$export$483e0fb0250cc873);
    (0, $aqzbR.EventHandler).remove(this.element, "mouseup", $6a5d336953e9198b$export$99abd87c7a8c840f);
    if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", $6a5d336953e9198b$var$resetFormHandler);
}
function $6a5d336953e9198b$export$6f0baecdf675c3b() {
    if (this.showClearButton) (0, $aqzbR.EventHandler).add(this.inputObj.clearButton, "mousedown touchstart", $6a5d336953e9198b$var$resetHandler, this);
}
function $6a5d336953e9198b$var$resetHandler(e) {
    e.preventDefault();
    if (!this.inputObj.clearButton.classList.contains("e-clear-icon-hide") || this.inputObj.container.classList.contains("e-static-clear")) {
        $6a5d336953e9198b$var$clear.call(this, e);
        this.value = "";
    }
}
function $6a5d336953e9198b$var$clear(event) {
    var value = this.element.value;
    $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
    this.redoCollec.unshift({
        value: this.promptMask,
        startIndex: this.element.selectionStart,
        endIndex: this.element.selectionEnd
    });
    $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event, value);
    this.element.setSelectionRange(0, 0);
}
function $6a5d336953e9198b$var$resetFormHandler() {
    if (this.element.tagName === "EJS-MASKEDTEXTBOX") $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
    else this.value = this.initInputValue;
}
function $6a5d336953e9198b$export$4bd2f9486ed80321(element) {
    return element.value;
}
function $6a5d336953e9198b$export$9d8f108b071126e3(element, maskValues) {
    var value = "";
    var k = 0;
    var checkMask = false;
    var maskValue = !(0, $3EnZW.isNullOrUndefined)(maskValues) ? maskValues : !(0, $3EnZW.isNullOrUndefined)(element) && !(0, $3EnZW.isNullOrUndefined)(this) ? element.value : maskValues;
    if (maskValue !== this.promptMask) for(var i = 0; i < this.customRegExpCollec.length; i++){
        if (checkMask) checkMask = false;
        if (this.customRegExpCollec[k] === ">" || this.customRegExpCollec[k] === "<" || this.customRegExpCollec[k] === "|" || this.customRegExpCollec[k] === "\\") {
            --i;
            checkMask = true;
        }
        if (!checkMask) {
            if (maskValue[i] !== this.promptChar && !(0, $3EnZW.isNullOrUndefined)(this.customRegExpCollec[k]) && (this._callPasteHandler || !(0, $3EnZW.isNullOrUndefined)(this.regExpCollec[this.customRegExpCollec[k]]) && !this.maskedRegExp.includes(this.customRegExpCollec[k]) || this.customRegExpCollec[k].length > 2 && this.customRegExpCollec[k][0] === "[" && this.customRegExpCollec[k][this.customRegExpCollec[k].length - 1] === "]" || !(0, $3EnZW.isNullOrUndefined)(this.customCharacters) && !(0, $3EnZW.isNullOrUndefined)(this.customCharacters[this.customRegExpCollec[k]])) && maskValue !== "") value += maskValue[i];
        }
        ++k;
    }
    if (this.mask === null || this.mask === "" && this.value !== undefined) value = maskValue;
    return value;
}
function $6a5d336953e9198b$var$pushIntoRegExpCollec(value) {
    for(var k = 0; k < value.length; k++){
        this.hiddenMask += value[k];
        if (value[k] !== "\\") this.customRegExpCollec.push(value[k]);
        else if (value[k] === "\\" && !(0, $3EnZW.isNullOrUndefined)(this.regExpCollec[value[k + 1]])) this.maskedRegExp.push(value[k + 1]);
    }
}
function $6a5d336953e9198b$export$483e0fb0250cc873() {
    this.isClicked = true;
}
function $6a5d336953e9198b$export$99abd87c7a8c840f() {
    this.isClicked = false;
}
function $6a5d336953e9198b$export$23e0fd9387527395(event) {
    var _this = this;
    var inputElement = this.element;
    var startIndex = 0;
    var modelValue = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, inputElement);
    var toAllowForward = false;
    var toAllowBackward = false;
    var eventArgs = {
        selectionStart: inputElement.selectionStart,
        event: event,
        value: this.value,
        maskedValue: inputElement.value,
        container: !(0, $3EnZW.isNullOrUndefined)(this.inputObj) ? this.inputObj.container : this.inputObj,
        selectionEnd: inputElement.selectionEnd
    };
    if (!this.isClicked) $6a5d336953e9198b$export$2b92016deb0b7aad.call(this, eventArgs, inputElement);
    if (this.mask) {
        if (!(!(modelValue === null || modelValue === "") || this.floatLabelType === "Always" || this.placeholder === null || this.placeholder === "")) inputElement.value = this.promptMask;
        setTimeout(function() {
            if (inputElement.selectionStart === _this.promptMask.length || inputElement.value[inputElement.selectionStart] === _this.promptChar) toAllowForward = true;
            else for(var i = inputElement.selectionStart; i < _this.promptMask.length; i++){
                if (inputElement.value[i] !== _this.promptChar) {
                    if (inputElement.value[i] !== _this.promptMask[i]) {
                        toAllowForward = false;
                        break;
                    }
                } else {
                    toAllowForward = true;
                    break;
                }
            }
        });
        setTimeout(function() {
            var backSelectionStart = inputElement.selectionStart - 1;
            if (backSelectionStart === _this.promptMask.length - 1 || inputElement.value[backSelectionStart] === _this.promptChar) toAllowBackward = true;
            else for(var i = backSelectionStart; i >= 0; i--){
                if (inputElement.value[i] !== _this.promptChar) {
                    if (inputElement.value[i] !== _this.promptMask[i]) {
                        toAllowBackward = false;
                        break;
                    }
                } else {
                    toAllowBackward = true;
                    break;
                }
            }
        });
        if (this.isClicked || this.floatLabelType !== "Always" && (modelValue === null || modelValue === "") && this.placeholder !== null && this.placeholder !== "") {
            for(startIndex = 0; startIndex < this.promptMask.length; startIndex++)if (inputElement.value[startIndex] === this.promptChar) {
                setTimeout(function() {
                    if (toAllowForward || toAllowBackward) {
                        inputElement.selectionEnd = startIndex;
                        inputElement.selectionStart = startIndex;
                    }
                    eventArgs = {
                        selectionStart: inputElement.selectionStart,
                        event: event,
                        value: _this.value,
                        maskedValue: inputElement.value,
                        container: !(0, $3EnZW.isNullOrUndefined)(_this.inputObj) ? _this.inputObj.container : _this.inputObj,
                        selectionEnd: inputElement.selectionEnd
                    };
                    $6a5d336953e9198b$export$2b92016deb0b7aad.call(_this, eventArgs, inputElement);
                }, 110);
                break;
            }
            if ((0, $3EnZW.isNullOrUndefined)(inputElement.value.match($6a5d336953e9198b$export$7c57da42ce8e346f(this.promptChar)))) {
                eventArgs = {
                    selectionStart: inputElement.selectionStart,
                    event: event,
                    value: this.value,
                    maskedValue: inputElement.value,
                    container: !(0, $3EnZW.isNullOrUndefined)(this.inputObj) ? this.inputObj.container : this.inputObj,
                    selectionEnd: inputElement.selectionEnd
                };
                $6a5d336953e9198b$export$2b92016deb0b7aad.call(this, eventArgs, inputElement);
            }
            this.isClicked = false;
        }
    }
}
function $6a5d336953e9198b$export$2b92016deb0b7aad(eventArgs, inputElement) {
    this.trigger("focus", eventArgs, function(eventArgs) {
        inputElement.selectionStart = eventArgs.selectionStart;
        inputElement.selectionEnd = eventArgs.selectionEnd;
    });
}
function $6a5d336953e9198b$export$7c57da42ce8e346f(text) {
    return !(0, $3EnZW.isNullOrUndefined)(text) ? text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : text;
}
function $6a5d336953e9198b$export$2e49bbe533eed1cf(event) {
    this.blurEventArgs = {
        event: event,
        value: this.value,
        maskedValue: this.element.value,
        container: !(0, $3EnZW.isNullOrUndefined)(this.inputObj) ? this.inputObj.container : this.inputObj
    };
    this.trigger("blur", this.blurEventArgs);
    if (this.mask) {
        this.isFocus = false;
        if (this.placeholder && this.element.value === this.promptMask && this.floatLabelType !== "Always") {
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, "");
            var labelElement = this.element.parentNode.querySelector(".e-float-text");
            if (this.floatLabelType === "Auto" && !(0, $3EnZW.isNullOrUndefined)(labelElement) && labelElement.classList.contains($6a5d336953e9198b$var$TOPLABEL)) (0, $4ZDHT.removeClass)([
                labelElement
            ], $6a5d336953e9198b$var$TOPLABEL);
        }
    }
}
function $6a5d336953e9198b$var$maskInputPasteHandler(event) {
    var _this = this;
    if (this.mask && !this.readonly) {
        var sIndex_1 = this.element.selectionStart;
        var eIndex_1 = this.element.selectionEnd;
        var oldValue_1 = this.element.value;
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, "");
        this._callPasteHandler = true;
        setTimeout(function() {
            var value = _this.element.value.replace(/ /g, "");
            if (_this.redoCollec.length > 0 && _this.redoCollec[0].value === _this.element.value) value = $6a5d336953e9198b$export$9d8f108b071126e3.call(_this, _this.element);
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(_this, oldValue_1);
            _this.element.selectionStart = sIndex_1;
            _this.element.selectionEnd = eIndex_1;
            var i = 0;
            _this.maskKeyPress = true;
            do {
                $6a5d336953e9198b$var$validateValue.call(_this, value[i], false, null);
                ++i;
            }while (i < value.length);
            _this.maskKeyPress = false;
            _this._callPasteHandler = false;
            if (_this.element.value === oldValue_1) {
                var i_1 = 0;
                _this.maskKeyPress = true;
                do {
                    $6a5d336953e9198b$var$validateValue.call(_this, value[i_1], false, null);
                    ++i_1;
                }while (i_1 < value.length);
                _this.maskKeyPress = false;
            } else $6a5d336953e9198b$var$triggerMaskChangeEvent.call(_this, event, oldValue_1);
        }, 1);
    }
}
function $6a5d336953e9198b$var$maskInputCutHandler(event) {
    var _this = this;
    if (this.mask && !this.readonly) {
        var preValue_1 = this.element.value;
        var sIndex_2 = this.element.selectionStart;
        var eIndex = this.element.selectionEnd;
        this.undoCollec.push({
            value: this.element.value,
            startIndex: this.element.selectionStart,
            endIndex: this.element.selectionEnd
        });
        var value_1 = this.element.value.substring(0, sIndex_2) + this.promptMask.substring(sIndex_2, eIndex) + this.element.value.substring(eIndex);
        setTimeout(function() {
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(_this, value_1);
            _this.element.selectionStart = _this.element.selectionEnd = sIndex_2;
            if (_this.element.value !== preValue_1) $6a5d336953e9198b$var$triggerMaskChangeEvent.call(_this, event, null);
        }, 0);
    }
}
function $6a5d336953e9198b$export$aa389c3341c4ff67(event) {
    event.preventDefault();
}
function $6a5d336953e9198b$var$maskInputHandler(event) {
    if ((0, $5q7BP.Browser).isIE === true && this.element.value === "" && this.floatLabelType === "Never") return;
    var eventArgs = {
        ctrlKey: false,
        keyCode: 229
    };
    (0, $3EnZW.extend)(event, eventArgs);
    if (this.mask) {
        if (this.element.value === "") this.redoCollec.unshift({
            value: this.promptMask,
            startIndex: this.element.selectionStart,
            endIndex: this.element.selectionEnd
        });
        if (this.element.value.length === 1) {
            this.element.value = this.element.value + this.promptMask;
            this.element.setSelectionRange(1, 1);
        }
        if (!this._callPasteHandler) $6a5d336953e9198b$var$removeMaskInputValues.call(this, event);
        if (this.element.value.length > this.promptMask.length) {
            var startIndex = this.element.selectionStart;
            var addedValues = this.element.value.length - this.promptMask.length;
            var value = this.element.value.substring(startIndex - addedValues, startIndex);
            this.maskKeyPress = false;
            var i = 0;
            do {
                $6a5d336953e9198b$var$validateValue.call(this, value[i], event.ctrlKey, event);
                ++i;
            }while (i < value.length);
            if (this.element.value !== this.preEleVal) $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event, null);
        }
        var val = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
        this.prevValue = val;
        this.value = val;
        if (val === "") {
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
            this.element.setSelectionRange(0, 0);
        }
    }
}
function $6a5d336953e9198b$var$maskInputKeyDownHandler(event) {
    if (this.mask && !this.readonly) {
        if (event.keyCode !== 229) {
            if (event.ctrlKey && (event.keyCode === 89 || event.keyCode === 90)) event.preventDefault();
            $6a5d336953e9198b$var$removeMaskInputValues.call(this, event);
        }
        var startValue = this.element.value;
        if (event.ctrlKey && (event.keyCode === 89 || event.keyCode === 90)) {
            var collec = void 0;
            if (event.keyCode === 90 && this.undoCollec.length > 0 && startValue !== this.undoCollec[this.undoCollec.length - 1].value) {
                collec = this.undoCollec[this.undoCollec.length - 1];
                this.redoCollec.unshift({
                    value: this.element.value,
                    startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
                $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, collec.value);
                this.element.selectionStart = collec.startIndex;
                this.element.selectionEnd = collec.endIndex;
                this.undoCollec.splice(this.undoCollec.length - 1, 1);
            } else if (event.keyCode === 89 && this.redoCollec.length > 0 && startValue !== this.redoCollec[0].value) {
                collec = this.redoCollec[0];
                this.undoCollec.push({
                    value: this.element.value,
                    startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
                $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, collec.value);
                this.element.selectionStart = collec.startIndex;
                this.element.selectionEnd = collec.endIndex;
                this.redoCollec.splice(0, 1);
            }
        }
    }
}
function $6a5d336953e9198b$export$b5647ea22177446e() {
    var collec;
    var sIndex = this.element.selectionStart;
    var eIndex = this.element.selectionEnd;
    if (this.redoCollec.length > 0) {
        collec = this.redoCollec[0];
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, collec.value);
        if (collec.startIndex - sIndex === 1) {
            this.element.selectionStart = collec.startIndex;
            this.element.selectionEnd = collec.endIndex;
        } else {
            this.element.selectionStart = sIndex + 1;
            this.element.selectionEnd = eIndex + 1;
        }
    } else {
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
        this.element.selectionStart = this.element.selectionEnd = sIndex;
    }
}
function $6a5d336953e9198b$var$autoFillMaskInputValues(isRemove, oldEventVal, event) {
    if (event.type === "input") {
        isRemove = false;
        oldEventVal = this.element.value;
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
        $6a5d336953e9198b$export$8a23d08effb90d01.call(this, oldEventVal);
    }
    return isRemove;
}
function $6a5d336953e9198b$var$removeMaskInputValues(event) {
    var isRemove = false;
    var oldEventVal;
    var isDeleted = false;
    if (this.element.value.length < this.promptMask.length) {
        isRemove = true;
        oldEventVal = this.element.value;
        isRemove = $6a5d336953e9198b$var$autoFillMaskInputValues.call(this, isRemove, oldEventVal, event);
        $6a5d336953e9198b$export$b5647ea22177446e.call(this);
    }
    if (this.element.value.length >= this.promptMask.length && event.type === "input") isRemove = $6a5d336953e9198b$var$autoFillMaskInputValues.call(this, isRemove, oldEventVal, event);
    var initStartIndex = this.element.selectionStart;
    var initEndIndex = this.element.selectionEnd;
    var startIndex = this.element.selectionStart;
    var endIndex = this.element.selectionEnd;
    var maskValue = this.hiddenMask.replace(/[>|\\<]/g, "");
    var curMask = maskValue[startIndex - 1];
    var deleteEndIndex = this.element.selectionEnd;
    if (isRemove || event.keyCode === 8 || event.keyCode === 46) {
        this.undoCollec.push({
            value: this.element.value,
            startIndex: this.element.selectionStart,
            endIndex: endIndex
        });
        var multipleDel = false;
        var preValue = this.element.value;
        if (startIndex > 0 || (event.keyCode === 8 || event.keyCode === 46) && startIndex < this.element.value.length && this.element.selectionEnd - startIndex !== this.element.value.length) {
            var index = startIndex;
            if (startIndex !== endIndex) {
                startIndex = endIndex;
                if (event.keyCode === 46) multipleDel = true;
            } else if (event.keyCode === 46) ++index;
            else --index;
            for(var k = startIndex; event.keyCode === 8 || isRemove || multipleDel ? k > index : k < index; event.keyCode === 8 || isRemove || multipleDel ? k-- : k++)for(var i = startIndex; event.keyCode === 8 || isRemove || multipleDel ? i > 0 : i < this.element.value.length; event.keyCode === 8 || isRemove || multipleDel ? i-- : i++){
                var sIndex = void 0;
                if ((event.keyCode === 8 || multipleDel) && (initStartIndex !== initEndIndex && initStartIndex !== startIndex || initStartIndex === initEndIndex) || isRemove) {
                    curMask = maskValue[i - 1];
                    sIndex = startIndex - 1;
                } else {
                    curMask = maskValue[i];
                    sIndex = startIndex;
                    ++startIndex;
                }
                var oldValue = this.element.value[sIndex];
                if ((0, $3EnZW.isNullOrUndefined)(this.regExpCollec["" + curMask]) && !(0, $3EnZW.isNullOrUndefined)(this.customCharacters) && (0, $3EnZW.isNullOrUndefined)(this.customCharacters["" + curMask]) && this.hiddenMask[sIndex] !== this.promptChar && this.customRegExpCollec[sIndex][0] !== "[" && this.customRegExpCollec[sIndex][this.customRegExpCollec[sIndex].length - 1] !== "]" || this.promptMask[sIndex] !== this.promptChar && (0, $3EnZW.isNullOrUndefined)(this.customCharacters)) {
                    this.element.selectionStart = this.element.selectionEnd = sIndex;
                    event.preventDefault();
                    if (event.keyCode === 46 && !multipleDel) ++this.element.selectionStart;
                } else {
                    var value = this.element.value;
                    var prompt_1 = this.promptChar;
                    var elementValue = value.substring(0, sIndex) + prompt_1 + value.substring(startIndex, value.length);
                    $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, elementValue);
                    event.preventDefault();
                    if (event.keyCode === 46 && !multipleDel) sIndex++;
                    this.element.selectionStart = this.element.selectionEnd = sIndex;
                    isDeleted = true;
                }
                startIndex = this.element.selectionStart;
                if (!isDeleted && event.keyCode === 8 || multipleDel || !isDeleted && !(event.keyCode === 46)) sIndex = startIndex - 1;
                else {
                    sIndex = startIndex;
                    isDeleted = false;
                }
                oldValue = this.element.value[sIndex];
                if (initStartIndex !== initEndIndex && this.element.selectionStart === initStartIndex || this.promptMask[sIndex] === this.promptChar || oldValue !== this.promptMask[sIndex] && this.promptMask[sIndex] !== this.promptChar && !(0, $3EnZW.isNullOrUndefined)(this.customCharacters)) break;
            }
        }
        if (event.keyCode === 46 && multipleDel && isDeleted) this.element.selectionStart = this.element.selectionEnd = deleteEndIndex;
        if (this.element.selectionStart === 0 && this.element.selectionEnd === this.element.value.length) {
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
            event.preventDefault();
            this.element.selectionStart = this.element.selectionEnd = startIndex;
        }
        this.redoCollec.unshift({
            value: this.element.value,
            startIndex: this.element.selectionStart,
            endIndex: this.element.selectionEnd
        });
        if (this.element.value !== preValue) $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event, oldEventVal);
    }
}
function $6a5d336953e9198b$var$maskInputKeyPressHandler(event) {
    if (this.mask && !this.readonly) {
        var oldValue = this.element.value;
        if (!(event.ctrlKey || event.metaKey) || (event.ctrlKey || event.metaKey) && event.code !== "KeyA" && event.code !== "KeyY" && event.code !== "KeyZ" && event.code !== "KeyX" && event.code !== "KeyC" && event.code !== "KeyV") {
            this.maskKeyPress = true;
            var key = event.key;
            if (key === "Spacebar") key = String.fromCharCode(event.keyCode);
            if (!key) {
                this.isIosInvalid = true;
                $6a5d336953e9198b$var$validateValue.call(this, String.fromCharCode(event.keyCode), event.ctrlKey, event);
                event.preventDefault();
                this.isIosInvalid = false;
            } else if (key && key.length === 1) {
                $6a5d336953e9198b$var$validateValue.call(this, key, event.ctrlKey, event);
                event.preventDefault();
            }
            if (event.keyCode === 32 && key === " " && this.promptChar === " ") this.element.selectionStart = this.element.selectionEnd = this.element.selectionStart - key.length;
        }
        if (this.element.value !== oldValue) $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event, oldValue);
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6a5d336953e9198b$var$triggerMaskChangeEvent(event, oldValue) {
    var prevOnChange = this.isProtectedOnChange;
    if (!(0, $3EnZW.isNullOrUndefined)(this.changeEventArgs) && !this.isInitial) {
        var eventArgs = {};
        this.changeEventArgs = {
            value: this.element.value,
            maskedValue: this.element.value,
            isInteraction: false,
            isInteracted: false
        };
        if (this.mask) this.changeEventArgs.value = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
        if (!(0, $3EnZW.isNullOrUndefined)(event)) {
            this.changeEventArgs.isInteracted = true;
            this.changeEventArgs.isInteraction = true;
            this.changeEventArgs.event = event;
        }
        this.isProtectedOnChange = true;
        this.value = this.changeEventArgs.value;
        this.isProtectedOnChange = prevOnChange;
        (0, $3EnZW.merge)(eventArgs, this.changeEventArgs);
        /* istanbul ignore next */ if (this.isAngular && this.preventChange) this.preventChange = false;
        else this.trigger("change", eventArgs);
    }
    this.preEleVal = this.element.value;
    this.prevValue = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
}
function $6a5d336953e9198b$var$maskInputKeyUpHandler(event) {
    if (this.mask && !this.readonly) {
        var collec = void 0;
        if (!this.maskKeyPress && event.keyCode === 229) {
            var oldEventVal = void 0;
            if (this.element.value.length === 1) {
                this.element.value = this.element.value + this.promptMask;
                this.element.setSelectionRange(1, 1);
            }
            if (this.element.value.length > this.promptMask.length) {
                var startIndex = this.element.selectionStart;
                var addedValues = this.element.value.length - this.promptMask.length;
                var val_1 = this.element.value.substring(startIndex - addedValues, startIndex);
                if (this.undoCollec.length > 0) {
                    collec = this.undoCollec[this.undoCollec.length - 1];
                    var startIndex_1 = this.element.selectionStart;
                    oldEventVal = collec.value;
                    var oldVal = collec.value.substring(startIndex_1 - addedValues, startIndex_1);
                    collec = this.redoCollec[0];
                    val_1 = val_1.trim();
                    var isSpace = (0, $5q7BP.Browser).isAndroid && val_1 === "";
                    if (!isSpace && oldVal !== val_1 && collec.value.substring(startIndex_1 - addedValues, startIndex_1) !== val_1) $6a5d336953e9198b$var$validateValue.call(this, val_1, event.ctrlKey, event);
                    else if (isSpace) $6a5d336953e9198b$var$preventUnsupportedValues.call(this, event, startIndex_1 - 1, this.element.selectionEnd - 1, val_1, event.ctrlKey, false);
                } else {
                    oldEventVal = this.promptMask;
                    $6a5d336953e9198b$var$validateValue.call(this, val_1, event.ctrlKey, event);
                }
                this.maskKeyPress = false;
                $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event, oldEventVal);
            }
        } else $6a5d336953e9198b$var$removeMaskError.call(this);
        var val = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
        if (!(this.element.selectionStart === 0 && this.promptMask === this.element.value && val === "") || val === "" && this.value !== val) {
            this.prevValue = val;
            this.value = val;
        }
    } else $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, event);
    if (this.element.selectionStart === 0 && this.element.selectionEnd === 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var temp_1 = this.element;
        setTimeout(function() {
            temp_1.setSelectionRange(0, 0);
        }, 0);
    }
}
function $6a5d336953e9198b$var$mobileSwipeCheck(key) {
    if (key.length > 1 && this.promptMask.length + key.length < this.element.value.length) {
        var elementValue = this.redoCollec[0].value.substring(0, this.redoCollec[0].startIndex) + key + this.redoCollec[0].value.substring(this.redoCollec[0].startIndex, this.redoCollec[0].value.length);
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, elementValue);
        this.element.selectionStart = this.element.selectionEnd = this.redoCollec[0].startIndex + key.length;
    }
    this.element.selectionStart = this.element.selectionStart - key.length;
    this.element.selectionEnd = this.element.selectionEnd - key.length;
}
function $6a5d336953e9198b$var$mobileValidation(key) {
    if (!this.maskKeyPress) $6a5d336953e9198b$var$mobileSwipeCheck.call(this, key);
}
function $6a5d336953e9198b$var$validateValue(key, isCtrlKey, event) {
    $6a5d336953e9198b$var$mobileValidation.call(this, key);
    if ((0, $3EnZW.isNullOrUndefined)(this) || (0, $3EnZW.isNullOrUndefined)(key)) return;
    var startIndex = this.element.selectionStart;
    var initStartIndex = startIndex;
    var curMask;
    var allowText = false;
    var value = this.element.value;
    var eventOldVal;
    var prevSupport = false;
    var isEqualVal = false;
    for(var k = 0; k < key.length; k++){
        var keyValue = key[k];
        startIndex = this.element.selectionStart;
        if (!this.maskKeyPress && initStartIndex === startIndex) startIndex = startIndex + k;
        if (!this.maskKeyPress || startIndex < this.promptMask.length) {
            for(var i = startIndex; i < this.promptMask.length; i++){
                var maskValue = this.escapeMaskValue;
                curMask = maskValue[startIndex];
                if (this.hiddenMask[startIndex] === "\\" && this.hiddenMask[startIndex + 1] === key) isEqualVal = true;
                if ((0, $3EnZW.isNullOrUndefined)(this.regExpCollec["" + curMask]) && ((0, $3EnZW.isNullOrUndefined)(this.customCharacters) || !(0, $3EnZW.isNullOrUndefined)(this.customCharacters) && (0, $3EnZW.isNullOrUndefined)(this.customCharacters["" + curMask])) && this.hiddenMask[startIndex] !== this.promptChar && this.customRegExpCollec[startIndex][0] !== "[" && this.customRegExpCollec[startIndex][this.customRegExpCollec[startIndex].length - 1] !== "]" || this.promptMask[startIndex] !== this.promptChar && (0, $3EnZW.isNullOrUndefined)(this.customCharacters) || this.promptChar === curMask && this.escapeMaskValue === this.mask) {
                    this.element.selectionStart = this.element.selectionEnd = startIndex + 1;
                    startIndex = this.element.selectionStart;
                    curMask = this.hiddenMask[startIndex];
                }
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.customCharacters) && !(0, $3EnZW.isNullOrUndefined)(this.customCharacters["" + curMask])) {
                var customValStr = this.customCharacters["" + curMask];
                var customValArr = customValStr.split(",");
                for(var i = 0; i < customValArr.length; i++)/* eslint-disable-next-line security/detect-non-literal-regexp */ if (keyValue.match(new RegExp("[" + customValArr[i] + "]"))) {
                    allowText = true;
                    break;
                }
            /* eslint-disable-next-line security/detect-non-literal-regexp */ } else if (!(0, $3EnZW.isNullOrUndefined)(this.regExpCollec["" + curMask]) && keyValue.match(new RegExp(this.regExpCollec["" + curMask])) && this.promptMask[startIndex] === this.promptChar) allowText = true;
            else if (this.promptMask[startIndex] === this.promptChar && this.customRegExpCollec[startIndex][0] === "[" && this.customRegExpCollec[startIndex][this.customRegExpCollec[startIndex].length - 1] === "]" && keyValue.match(new RegExp(this.customRegExpCollec[startIndex]))) allowText = true;
            if ((!this.maskKeyPress || startIndex < this.hiddenMask.length) && allowText) {
                if (k === 0) {
                    if (this.maskKeyPress) this.undoCollec.push({
                        value: value,
                        startIndex: startIndex,
                        endIndex: startIndex
                    });
                    else {
                        var sIndex = this.element.selectionStart;
                        var eIndex = this.element.selectionEnd;
                        if (this.redoCollec.length > 0) {
                            eventOldVal = this.redoCollec[0].value;
                            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, eventOldVal);
                            this.undoCollec.push(this.redoCollec[0]);
                        } else {
                            this.undoCollec.push({
                                value: this.promptMask,
                                startIndex: startIndex,
                                endIndex: startIndex
                            });
                            eventOldVal = this.promptMask;
                            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, eventOldVal);
                        }
                        this.element.selectionStart = sIndex;
                        this.element.selectionEnd = eIndex;
                    }
                }
                startIndex = this.element.selectionStart;
                $6a5d336953e9198b$var$applySupportedValues.call(this, event, startIndex, keyValue, eventOldVal, isEqualVal);
                prevSupport = true;
                if (k === key.length - 1) this.redoCollec.unshift({
                    value: this.element.value,
                    startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
                allowText = false;
            } else {
                startIndex = this.element.selectionStart;
                $6a5d336953e9198b$var$preventUnsupportedValues.call(this, event, startIndex, initStartIndex, key, isCtrlKey, prevSupport);
            }
            if (k === key.length - 1 && !allowText) {
                if (!(0, $5q7BP.Browser).isAndroid || (0, $5q7BP.Browser).isAndroid && startIndex < this.promptMask.length) this.redoCollec.unshift({
                    value: this.element.value,
                    startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
            }
        } else if (key.length === 1 && !isCtrlKey && !(0, $3EnZW.isNullOrUndefined)(event)) $6a5d336953e9198b$var$addMaskErrorClass.call(this);
    }
}
function $6a5d336953e9198b$var$applySupportedValues(event, startIndex, keyValue, eventOldVal, isEqualVal) {
    if (this.hiddenMask.length > this.promptMask.length) keyValue = $6a5d336953e9198b$var$changeToLowerUpperCase.call(this, keyValue, this.element.value);
    if (!isEqualVal) {
        var value = this.element.value;
        var elementValue = value.substring(0, startIndex) + keyValue + value.substring(startIndex + 1, value.length);
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, elementValue);
        this.element.selectionStart = this.element.selectionEnd = startIndex + 1;
    }
}
function $6a5d336953e9198b$var$preventUnsupportedValues(event, sIdx, idx, key, ctrl, chkSupport) {
    if (!this.maskKeyPress) {
        var value = this.element.value;
        if (sIdx >= this.promptMask.length) $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, value.substring(0, sIdx));
        else {
            if (idx === sIdx) $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, value.substring(0, sIdx) + value.substring(sIdx + 1, value.length));
            else if (this.promptMask.length === this.element.value.length) $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, value.substring(0, sIdx) + value.substring(sIdx, value.length));
            else $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, value.substring(0, idx) + value.substring(idx + 1, value.length));
            this.element.selectionStart = this.element.selectionEnd = chkSupport || this.element.value[idx] !== this.promptChar ? sIdx : idx;
        }
        $6a5d336953e9198b$var$addMaskErrorClass.call(this);
    }
    if (key.length === 1 && !ctrl && !(0, $3EnZW.isNullOrUndefined)(event)) $6a5d336953e9198b$var$addMaskErrorClass.call(this);
}
function $6a5d336953e9198b$var$addMaskErrorClass() {
    var _this = this;
    var parentElement = this.element.parentNode;
    var timer = 200;
    if (parentElement.classList.contains($6a5d336953e9198b$var$INPUTGROUP) || parentElement.classList.contains($6a5d336953e9198b$var$FLOATINPUT)) (0, $4ZDHT.addClass)([
        parentElement
    ], $6a5d336953e9198b$var$ERROR);
    else (0, $4ZDHT.addClass)([
        this.element
    ], $6a5d336953e9198b$var$ERROR);
    if (this.isIosInvalid === true) timer = 400;
    (0, $4ZDHT.attributes)(this.element, {
        "aria-invalid": "true"
    });
    setTimeout(function() {
        if (!_this.maskKeyPress) $6a5d336953e9198b$var$removeMaskError.call(_this);
    }, timer);
}
function $6a5d336953e9198b$var$removeMaskError() {
    var parentElement = this.element.parentNode;
    if (!(0, $3EnZW.isNullOrUndefined)(parentElement)) (0, $4ZDHT.removeClass)([
        parentElement
    ], $6a5d336953e9198b$var$ERROR);
    (0, $4ZDHT.removeClass)([
        this.element
    ], $6a5d336953e9198b$var$ERROR);
    (0, $4ZDHT.attributes)(this.element, {
        "aria-invalid": "false"
    });
}
/**
 * Validates user input using masking elements '<' , '>' and '|'.
 *
 * @hidden
 */ function $6a5d336953e9198b$var$changeToLowerUpperCase(key, value) {
    var promptMask;
    var i;
    var curVal = value;
    var caseCount = 0;
    for(i = 0; i < this.hiddenMask.length; i++){
        if (this.hiddenMask[i] === "\\") promptMask = curVal.substring(0, i) + "\\" + curVal.substring(i, curVal.length);
        if (this.hiddenMask[i] === ">" || this.hiddenMask[i] === "<" || this.hiddenMask[i] === "|") {
            if (this.hiddenMask[i] !== curVal[i]) promptMask = curVal.substring(0, i) + this.hiddenMask[i] + curVal.substring(i, curVal.length);
            ++caseCount;
        }
        if (promptMask) {
            if (promptMask[i] === this.promptChar && i > this.element.selectionStart || this.element.value.indexOf(this.promptChar) < 0 && this.element.selectionStart + caseCount === i) {
                caseCount = 0;
                break;
            }
            curVal = promptMask;
        }
    }
    while(i >= 0 && promptMask){
        if (i === 0 || promptMask[i - 1] !== "\\") {
            if (promptMask[i] === ">") {
                key = key.toUpperCase();
                break;
            } else if (promptMask[i] === "<") {
                key = key.toLowerCase();
                break;
            } else if (promptMask[i] === "|") break;
        }
        --i;
    }
    return key;
}
function $6a5d336953e9198b$export$8a23d08effb90d01(val) {
    if (this.mask && val !== undefined && (this.prevValue === undefined || this.prevValue !== val)) {
        this.maskKeyPress = true;
        $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.promptMask);
        if (val !== "" && !(val === null && this.floatLabelType === "Never" && this.placeholder)) {
            this.element.selectionStart = 0;
            this.element.selectionEnd = 0;
        }
        if (val !== null) for(var i = 0; i < val.length; i++)$6a5d336953e9198b$var$validateValue.call(this, val[i], false, null);
        var newVal = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
        this.prevValue = newVal;
        this.value = newVal;
        $6a5d336953e9198b$var$triggerMaskChangeEvent.call(this, null, null);
        this.maskKeyPress = false;
        var labelElement = this.element.parentNode.querySelector(".e-float-text");
        if (this.element.value === this.promptMask && this.floatLabelType === "Auto" && this.placeholder && !(0, $3EnZW.isNullOrUndefined)(labelElement) && labelElement.classList.contains($6a5d336953e9198b$var$TOPLABEL) && !this.isFocus) {
            (0, $4ZDHT.removeClass)([
                labelElement
            ], $6a5d336953e9198b$var$TOPLABEL);
            (0, $4ZDHT.addClass)([
                labelElement
            ], $6a5d336953e9198b$var$BOTTOMLABEL);
            $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, "");
        }
    }
    if (this.mask === null || this.mask === "" && this.value !== undefined) $6a5d336953e9198b$export$c2c7fef809f2f8ef.call(this, this.value);
}
function $6a5d336953e9198b$export$c2c7fef809f2f8ef(val, element) {
    if (!this.isFocus && this.floatLabelType === "Auto" && this.placeholder && (0, $3EnZW.isNullOrUndefined)(this.value)) val = "";
    var value = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, element ? element : this.element, val);
    if (value === null || value === "") {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(val, element ? element : this.element, this.floatLabelType, false);
        if (this.showClearButton) this.inputObj.clearButton.classList.add("e-clear-icon-hide");
    } else (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(val, element ? element : this.element, this.floatLabelType, this.showClearButton);
}
function $6a5d336953e9198b$export$94f7f1ff14f2a515(args) {
    var inputEle = $6a5d336953e9198b$var$getMaskInput(args);
    $6a5d336953e9198b$export$a1c9aa9c0e8ba394.call(inputEle);
    var val = $6a5d336953e9198b$export$9d8f108b071126e3.call(this, this.element);
    this.prevValue = val;
    this.value = val;
    if (args.mask) {
        $6a5d336953e9198b$export$5a8105d882fc3d97.call(inputEle);
        $6a5d336953e9198b$export$6470dec3e2ff9874.call(inputEle);
    }
}
function $6a5d336953e9198b$var$getMaskInput(args) {
    (0, $4ZDHT.addClass)([
        args.element
    ], $6a5d336953e9198b$var$UTILMASK);
    var inputEle = {
        element: args.element,
        mask: args.mask,
        promptMask: "",
        hiddenMask: "",
        escapeMaskValue: "",
        promptChar: args.promptChar ? args.promptChar.length > 1 ? args.promptChar = args.promptChar[0] : args.promptChar : "_",
        value: args.value ? args.value : null,
        regExpCollec: $6a5d336953e9198b$export$4b10ab455aed8214,
        customRegExpCollec: [],
        customCharacters: args.customCharacters,
        undoCollec: [],
        redoCollec: [],
        maskKeyPress: false,
        prevValue: ""
    };
    $6a5d336953e9198b$export$d086c3c83b5d30c4.call(inputEle);
    return inputEle;
}
function $6a5d336953e9198b$export$e694d6a6686e61ff(args) {
    return $6a5d336953e9198b$export$9d8f108b071126e3.call($6a5d336953e9198b$var$getUtilMaskEle(args), args.element);
}
function $6a5d336953e9198b$export$bc7cdb94060f7b72(args) {
    return $6a5d336953e9198b$export$4bd2f9486ed80321.call($6a5d336953e9198b$var$getUtilMaskEle(args), args.element);
}
function $6a5d336953e9198b$var$getUtilMaskEle(args) {
    var inputEle;
    if (!(0, $3EnZW.isNullOrUndefined)(args) && args.element.classList.contains($6a5d336953e9198b$var$UTILMASK)) inputEle = $6a5d336953e9198b$var$getMaskInput(args);
    return inputEle;
}
/**
 * Arguments to perform undo and redo functionalities.
 *
 * @hidden
 */ var $6a5d336953e9198b$export$c95eb98582711934 = /** @class */ function() {
    function MaskUndo() {}
    return MaskUndo;
}();
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $6a5d336953e9198b$var$maskUndo = new $6a5d336953e9198b$export$c95eb98582711934(); /* eslint-enable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */ 


var $5ee2f58e8ba745bf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5ee2f58e8ba745bf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5ee2f58e8ba745bf$var$ROOT = "e-control-wrapper e-mask";
var $5ee2f58e8ba745bf$var$INPUT = "e-input";
var $5ee2f58e8ba745bf$var$COMPONENT = "e-maskedtextbox";
var $5ee2f58e8ba745bf$var$CONTROL = "e-control";
var $5ee2f58e8ba745bf$var$MASKINPUT_FOCUS = "e-input-focus";
var $5ee2f58e8ba745bf$var$wrapperAttr = [
    "title",
    "style",
    "class"
];
/**
 * The MaskedTextBox allows the user to enter the valid input only based on the provided mask.
 * ```html
 * <input id="mask" type="text" />
 * ```
 * ```typescript
 * <script>
 * var maskObj = new MaskedTextBox({ mask: "(999) 9999-999" });
 * maskObj.appendTo('#mask');
 * </script>
 * ```
 */ var $5ee2f58e8ba745bf$export$1e2d3cc3dbd650f8 = /** @class */ function(_super) {
    $5ee2f58e8ba745bf$var$__extends(MaskedTextBox, _super);
    /**
     *
     * @param {MaskedTextBoxModel} options - Specifies the MaskedTextBox model.
     * @param {string | HTMLElement | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function MaskedTextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.initInputValue = "";
        _this.preventChange = false;
        _this.isClicked = false;
        _this.maskOptions = options;
        return _this;
    }
    /**
     * Gets the component name.
     *
     * @returns {string} Returns the component name.
     * @private
     */ MaskedTextBox.prototype.getModuleName = function() {
        return "maskedtextbox";
    };
    /**
     * Initializes the event handler
     *
     * @returns {void}
     * @private
     */ MaskedTextBox.prototype.preRender = function() {
        this.promptMask = "";
        this.hiddenMask = "";
        this.escapeMaskValue = "";
        this.regExpCollec = (0, $6a5d336953e9198b$export$4b10ab455aed8214);
        this.customRegExpCollec = [];
        this.maskedRegExp = [];
        this.undoCollec = [];
        this.redoCollec = [];
        this.changeEventArgs = {};
        this.focusEventArgs = {};
        this.blurEventArgs = {};
        this.maskKeyPress = false;
        this.isFocus = false;
        this.isInitial = false;
        this.isIosInvalid = false;
        var ejInstance = (0, $3EnZW.getValue)("ej2_instances", this.element);
        this.cloneElement = this.element.cloneNode(true);
        (0, $4ZDHT.removeClass)([
            this.cloneElement
        ], [
            $5ee2f58e8ba745bf$var$CONTROL,
            $5ee2f58e8ba745bf$var$COMPONENT,
            "e-lib"
        ]);
        this.angularTagName = null;
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (this.element.tagName === "EJS-MASKEDTEXTBOX") {
            this.angularTagName = this.element.tagName;
            var input = this.createElement("input");
            for(var i = 0; i < this.element.attributes.length; i++){
                input.setAttribute(this.element.attributes[i].nodeName, this.element.attributes[i].nodeValue);
                input.innerHTML = this.element.innerHTML;
            }
            if (this.element.hasAttribute("id")) this.element.removeAttribute("id");
            if (this.element.hasAttribute("name")) this.element.removeAttribute("name");
            this.element.classList.remove("e-control", "e-maskedtextbox");
            this.element.classList.add("e-mask-container");
            this.element.appendChild(input);
            this.element = input;
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, this.element);
        }
        this.updateHTMLAttrToElement();
        this.checkHtmlAttributes(false);
        if (this.formElement) this.initInputValue = this.value;
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string}
     */ MaskedTextBox.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Initializes the component rendering.
     *
     * @returns {void}
     * @private
     */ MaskedTextBox.prototype.render = function() {
        if (this.element.tagName.toLowerCase() === "input") {
            if (this.floatLabelType === "Never") (0, $4ZDHT.addClass)([
                this.element
            ], $5ee2f58e8ba745bf$var$INPUT);
            this.createWrapper();
            this.updateHTMLAttrToWrapper();
            if (this.element.name === "") this.element.setAttribute("name", this.element.id);
            this.isInitial = true;
            this.resetMaskedTextBox();
            this.isInitial = false;
            this.setMaskPlaceholder(true, false);
            this.setWidth(this.width);
            this.preEleVal = this.element.value;
            if (!(0, $5q7BP.Browser).isDevice && ((0, $5q7BP.Browser).info.version === "11.0" || (0, $5q7BP.Browser).info.name === "edge")) this.element.blur();
            if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos) this.element.blur();
            if (this.element.getAttribute("value") || this.value) this.element.setAttribute("value", this.element.value);
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
            if (!this.element.hasAttribute("aria-labelledby") && !this.element.hasAttribute("placeholder") && !this.element.hasAttribute("aria-label")) this.element.setAttribute("aria-label", "maskedtextbox");
            this.renderComplete();
        }
    };
    MaskedTextBox.prototype.updateHTMLAttrToElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($5ee2f58e8ba745bf$var$wrapperAttr.indexOf(key) < 0) this.element.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    MaskedTextBox.prototype.updateCssClass = function(newClass, oldClass) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setCssClass(this.getValidClassList(newClass), [
            this.inputObj.container
        ], this.getValidClassList(oldClass));
    };
    MaskedTextBox.prototype.getValidClassList = function(maskClassName) {
        var result = maskClassName;
        if (!(0, $3EnZW.isNullOrUndefined)(maskClassName) && maskClassName !== "") result = maskClassName.replace(/\s+/g, " ").trim();
        return result;
    };
    MaskedTextBox.prototype.updateHTMLAttrToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            if ($5ee2f58e8ba745bf$var$wrapperAttr.indexOf(key) > -1) {
                if (key === "class") {
                    var updatedClassValues = this.htmlAttributes["" + key].replace(/\s+/g, " ").trim();
                    if (updatedClassValues !== "") (0, $4ZDHT.addClass)([
                        this.inputObj.container
                    ], updatedClassValues.split(" "));
                } else if (key === "style") {
                    var maskStyle = this.inputObj.container.getAttribute(key);
                    maskStyle = !(0, $3EnZW.isNullOrUndefined)(maskStyle) ? maskStyle + this.htmlAttributes["" + key] : this.htmlAttributes["" + key];
                    this.inputObj.container.setAttribute(key, maskStyle);
                } else this.inputObj.container.setAttribute(key, this.htmlAttributes["" + key]);
            }
        }
    };
    MaskedTextBox.prototype.resetMaskedTextBox = function() {
        this.promptMask = "";
        this.hiddenMask = "";
        this.escapeMaskValue = "";
        this.customRegExpCollec = [];
        this.undoCollec = [];
        this.redoCollec = [];
        if (this.promptChar && this.promptChar.length > 1) this.promptChar = this.promptChar[0];
        (0, $6a5d336953e9198b$export$d086c3c83b5d30c4).call(this);
        (0, $6a5d336953e9198b$export$a1c9aa9c0e8ba394).call(this);
        if (this.mask === null || this.mask === "" && this.value !== undefined) (0, $6a5d336953e9198b$export$c2c7fef809f2f8ef).call(this, this.value);
        var val = (0, $6a5d336953e9198b$export$9d8f108b071126e3).call(this, this.element);
        this.prevValue = val;
        this.value = val;
        if (!this.isInitial) (0, $6a5d336953e9198b$export$5a8105d882fc3d97).call(this);
        (0, $6a5d336953e9198b$export$6470dec3e2ff9874).call(this);
    };
    MaskedTextBox.prototype.setMaskPlaceholder = function(setVal, dynamicPlaceholder) {
        if (dynamicPlaceholder || this.placeholder) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.element);
            if (this.element.value === this.promptMask && setVal && this.floatLabelType !== "Always" || this.element.value === this.promptMask && this.floatLabelType === "Never") (0, $6a5d336953e9198b$export$c2c7fef809f2f8ef).call(this, "");
        }
    };
    MaskedTextBox.prototype.setWidth = function(width) {
        if (!(0, $3EnZW.isNullOrUndefined)(width)) {
            if (typeof width === "number") {
                this.inputObj.container.style.width = (0, $3EnZW.formatUnit)(width);
                this.element.style.width = (0, $3EnZW.formatUnit)(width);
            } else if (typeof width === "string") {
                var elementWidth = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
                this.inputObj.container.style.width = elementWidth;
                this.element.style.width = elementWidth;
            }
        }
    };
    MaskedTextBox.prototype.checkHtmlAttributes = function(isDynamic) {
        var attributes = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "placeholder",
            "disabled",
            "value",
            "readonly"
        ];
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var key = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.getAttribute(key))) switch(key){
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.maskOptions) || this.maskOptions["placeholder"] === undefined || isDynamic) this.setProperties({
                        placeholder: this.element.placeholder
                    }, !isDynamic);
                    break;
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.maskOptions) || this.maskOptions["enabled"] === undefined || isDynamic) {
                        var isEnabled = this.element.getAttribute(key) === "disabled" || this.element.getAttribute(key) === "" || this.element.getAttribute(key) === "true" ? false : true;
                        this.setProperties({
                            enabled: isEnabled
                        }, !isDynamic);
                    }
                    break;
                case "value":
                    if ((0, $3EnZW.isNullOrUndefined)(this.maskOptions) || this.maskOptions["value"] === undefined || isDynamic) this.setProperties({
                        value: this.element.value
                    }, !isDynamic);
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.maskOptions) || this.maskOptions["readonly"] === undefined || isDynamic) {
                        var isReadonly = this.element.getAttribute(key) === "readonly" || this.element.getAttribute(key) === "" || this.element.getAttribute(key) === "true" ? true : false;
                        this.setProperties({
                            readonly: isReadonly
                        }, !isDynamic);
                    }
                    break;
            }
        }
    };
    MaskedTextBox.prototype.createWrapper = function() {
        var updatedCssClassValues = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValues = this.getValidClassList(this.cssClass);
        this.inputObj = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: {
                enableRtl: this.enableRtl,
                cssClass: updatedCssClassValues,
                enabled: this.enabled,
                readonly: this.readonly,
                placeholder: this.placeholder,
                showClearButton: this.showClearButton
            }
        }, this.createElement);
        this.inputObj.container.setAttribute("class", $5ee2f58e8ba745bf$var$ROOT + " " + this.inputObj.container.getAttribute("class"));
    };
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {MaskedTextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {MaskedTextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @hidden
     */ MaskedTextBox.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "value":
                    (0, $6a5d336953e9198b$export$8a23d08effb90d01).call(this, this.value);
                    if (this.placeholder && !this.isFocus) this.setMaskPlaceholder(false, false);
                    if (this.value === "" && oldProp.value != null) {
                        this.element.selectionStart = 0;
                        this.element.selectionEnd = 0;
                    }
                    break;
                case "placeholder":
                    this.setMaskPlaceholder(true, true);
                    break;
                case "width":
                    this.setWidth(newProp.width);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.element, this.inputObj.container);
                    break;
                case "cssClass":
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case "enabled":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(newProp.enabled, this.element, this.floatLabelType, this.inputObj.container);
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(newProp.readonly, this.element);
                    break;
                case "enableRtl":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(newProp.enableRtl, [
                        this.inputObj.container
                    ]);
                    break;
                case "customCharacters":
                    this.customCharacters = newProp.customCharacters;
                    this.resetMaskedTextBox();
                    break;
                case "showClearButton":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(newProp.showClearButton, this.element, this.inputObj, undefined, this.createElement);
                    (0, $6a5d336953e9198b$export$6f0baecdf675c3b).call(this);
                    break;
                case "floatLabelType":
                    this.floatLabelType = newProp.floatLabelType;
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.inputObj);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.element, this.floatLabelType, this.placeholder, this.createElement);
                    break;
                case "htmlAttributes":
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.checkHtmlAttributes(true);
                    break;
                case "mask":
                    var strippedValue_1 = this.value;
                    this.mask = newProp.mask;
                    this.maskedRegExp = [];
                    this.updateValue(strippedValue_1);
                    break;
                case "promptChar":
                    if (newProp.promptChar.length > 1) newProp.promptChar = newProp.promptChar[0];
                    if (newProp.promptChar) this.promptChar = newProp.promptChar;
                    else this.promptChar = "_";
                    /* eslint-disable-next-line security/detect-non-literal-regexp */ var value = this.element.value.replace(new RegExp("[" + oldProp.promptChar + "]", "g"), this.promptChar);
                    if (this.promptMask === this.element.value) /* eslint-disable-next-line security/detect-non-literal-regexp */ value = this.promptMask.replace(new RegExp("[" + oldProp.promptChar + "]", "g"), this.promptChar);
                    /* eslint-disable-next-line security/detect-non-literal-regexp */ this.promptMask = this.promptMask.replace(new RegExp("[" + oldProp.promptChar + "]", "g"), this.promptChar);
                    this.undoCollec = this.redoCollec = [];
                    (0, $6a5d336953e9198b$export$c2c7fef809f2f8ef).call(this, value);
                    break;
            }
        }
        this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
    };
    MaskedTextBox.prototype.updateValue = function(strippedVal) {
        this.resetMaskedTextBox();
        (0, $6a5d336953e9198b$export$8a23d08effb90d01).call(this, strippedVal);
    };
    /**
     * Gets the value of the MaskedTextBox with the masked format.
     * By using `value` property, you can get the raw value of maskedtextbox without literals and prompt characters.
     *
     * @returns {string} Returns the value with the masked format.
     */ MaskedTextBox.prototype.getMaskedValue = function() {
        return (0, $6a5d336953e9198b$export$4bd2f9486ed80321).call(this, this.element);
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ MaskedTextBox.prototype.focusIn = function() {
        if (document.activeElement !== this.element && this.enabled) {
            this.isFocus = true;
            this.element.focus();
            (0, $4ZDHT.addClass)([
                this.inputObj.container
            ], [
                $5ee2f58e8ba745bf$var$MASKINPUT_FOCUS
            ]);
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ MaskedTextBox.prototype.focusOut = function() {
        if (document.activeElement === this.element && this.enabled) {
            this.isFocus = false;
            this.element.blur();
            (0, $4ZDHT.removeClass)([
                this.inputObj.container
            ], [
                $5ee2f58e8ba745bf$var$MASKINPUT_FOCUS
            ]);
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */ MaskedTextBox.prototype.destroy = function() {
        (0, $6a5d336953e9198b$export$5a8105d882fc3d97).call(this);
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        var attrArray = [
            "aria-labelledby",
            "role",
            "autocomplete",
            "aria-readonly",
            "aria-disabled",
            "autocapitalize",
            "spellcheck",
            "aria-autocomplete",
            "aria-live",
            "aria-invalid"
        ];
        for(var i = 0; i < attrArray.length; i++)this.element.removeAttribute(attrArray[i]);
        this.element.classList.remove("e-input");
        if (this.inputObj) {
            this.inputObj.container.insertAdjacentElement("afterend", this.element);
            (0, $4ZDHT.detach)(this.inputObj.container);
        }
        this.blurEventArgs = null;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        this.changeEventArgs = null;
        this.inputObj = null;
        _super.prototype.destroy.call(this);
    };
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "cssClass", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "width", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "placeholder", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], MaskedTextBox.prototype, "floatLabelType", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)({})
    ], MaskedTextBox.prototype, "htmlAttributes", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MaskedTextBox.prototype, "enabled", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MaskedTextBox.prototype, "readonly", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MaskedTextBox.prototype, "showClearButton", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MaskedTextBox.prototype, "enablePersistence", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "mask", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)("_")
    ], MaskedTextBox.prototype, "promptChar", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "value", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MaskedTextBox.prototype, "customCharacters", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Event)()
    ], MaskedTextBox.prototype, "created", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Event)()
    ], MaskedTextBox.prototype, "destroyed", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Event)()
    ], MaskedTextBox.prototype, "change", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Event)()
    ], MaskedTextBox.prototype, "focus", void 0);
    $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.Event)()
    ], MaskedTextBox.prototype, "blur", void 0);
    MaskedTextBox = $5ee2f58e8ba745bf$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], MaskedTextBox);
    return MaskedTextBox;
}((0, $hQxLN.Component));

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");
var $e7i2H = parcelRequire("e7i2H");

var $6d46db6d177db8e2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6d46db6d177db8e2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6d46db6d177db8e2$var$HIDE_CLEAR = "e-clear-icon-hide";
/**
 * Represents the TextBox component that allows the user to enter the values based on it's type.
 * ```html
 * <input name='images' id='textbox'/>
 * ```
 * ```typescript
 * <script>
 *   var textboxObj = new TextBox();
 *   textboxObj.appendTo('#textbox');
 * </script>
 * ```
 */ var $6d46db6d177db8e2$export$10e6f4f66014ee2d = /** @class */ function(_super) {
    $6d46db6d177db8e2$var$__extends(TextBox, _super);
    /**
     *
     * @param {TextBoxModel} options - Specifies the TextBox model.
     * @param {string | HTMLInputElement | HTMLTextAreaElement} element - Specifies the element to render as component.
     * @private
     */ function TextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.previousValue = null;
        _this.isHiddenInput = false;
        _this.isForm = false;
        _this.inputPreviousValue = null;
        _this.textboxOptions = options;
        return _this;
    }
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {TextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {TextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ TextBox.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "floatLabelType":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).removeFloating(this.textboxWrapper);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).addFloating(this.respectiveElement, this.floatLabelType, this.placeholder);
                    break;
                case "enabled":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
                    this.bindClearEvent();
                    break;
                case "width":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setWidth(newProp.width, this.textboxWrapper.container);
                    break;
                case "value":
                    var prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    if (!(0, $168e4e125732cd26$export$f5b8910cec6cf069).isBlank(this.value)) this.value = this.value.toString();
                    this.isProtectedOnChange = prevOnChange;
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.value, this.respectiveElement, this.floatLabelType, this.showClearButton);
                    if (this.isHiddenInput) this.element.value = this.respectiveElement.value;
                    this.inputPreviousValue = this.respectiveElement.value;
                    /* istanbul ignore next */ if ((this.isAngular || this.isVue) && this.preventChange === true) {
                        this.previousValue = this.isAngular ? this.value : this.previousValue;
                        this.preventChange = false;
                    } else if ((0, $3EnZW.isNullOrUndefined)(this.isAngular) || !this.isAngular || this.isAngular && !this.preventChange || this.isAngular && (0, $3EnZW.isNullOrUndefined)(this.preventChange)) this.raiseChangeEvent();
                    break;
                case "htmlAttributes":
                    this.updateHTMLAttributesToElement();
                    this.updateHTMLAttributesToWrapper();
                    this.checkAttributes(true);
                    if (this.multiline && !(0, $3EnZW.isNullOrUndefined)(this.textarea)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).validateInputType(this.textboxWrapper.container, this.textarea);
                    else (0, $168e4e125732cd26$export$f5b8910cec6cf069).validateInputType(this.textboxWrapper.container, this.element);
                    break;
                case "readonly":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.respectiveElement);
                    break;
                case "type":
                    if (this.respectiveElement.tagName !== "TEXTAREA") {
                        this.respectiveElement.setAttribute("type", this.type);
                        (0, $168e4e125732cd26$export$f5b8910cec6cf069).validateInputType(this.textboxWrapper.container, this.element);
                        this.raiseChangeEvent();
                    }
                    break;
                case "showClearButton":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setClearButton(this.showClearButton, this.respectiveElement, this.textboxWrapper);
                    this.bindClearEvent();
                    break;
                case "enableRtl":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnableRtl(this.enableRtl, [
                        this.textboxWrapper.container
                    ]);
                    break;
                case "placeholder":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.respectiveElement);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(this.respectiveElement, this.textboxWrapper.container);
                    break;
                case "autocomplete":
                    if (this.autocomplete !== "on" && this.autocomplete !== "") this.respectiveElement.autocomplete = this.autocomplete;
                    else this.removeAttributes([
                        "autocomplete"
                    ]);
                    break;
                case "cssClass":
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).updateCssClass(newProp.cssClass, oldProp.cssClass, this.textboxWrapper.container);
                    break;
                case "locale":
                    this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
                    this.l10n.setLocale(this.locale);
                    this.setProperties({
                        placeholder: this.l10n.getConstant("placeholder")
                    }, true);
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.respectiveElement);
                    break;
            }
        }
    };
    /**
     * Gets the component name
     *
     * @returns {string} Returns the component name.
     * @private
     */ TextBox.prototype.getModuleName = function() {
        return "textbox";
    };
    TextBox.prototype.preRender = function() {
        this.cloneElement = this.element.cloneNode(true);
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (!(0, $3EnZW.isNullOrUndefined)(this.formElement)) this.isForm = true;
        /* istanbul ignore next */ if (this.element.tagName === "EJS-TEXTBOX") {
            var ejInstance = (0, $3EnZW.getValue)("ej2_instances", this.element);
            var inputElement = this.multiline ? this.createElement("textarea") : this.createElement("input");
            var index = 0;
            for(index; index < this.element.attributes.length; index++){
                var attributeName = this.element.attributes[index].nodeName;
                if (attributeName !== "id" && attributeName !== "class") {
                    inputElement.setAttribute(attributeName, this.element.attributes[index].nodeValue);
                    inputElement.innerHTML = this.element.innerHTML;
                    if (attributeName === "name") this.element.removeAttribute("name");
                } else if (attributeName === "class") inputElement.setAttribute(attributeName, this.element.className.split(" ").filter(function(item) {
                    return item.indexOf("ng-") !== 0;
                }).join(" "));
            }
            this.element.appendChild(inputElement);
            this.element = inputElement;
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, this.element);
        }
        this.updateHTMLAttributesToElement();
        this.checkAttributes(false);
        if (((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["value"] === undefined) && this.element.value !== "") this.setProperties({
            value: this.element.value
        }, true);
        if (this.element.tagName !== "TEXTAREA") this.element.setAttribute("type", this.type);
        if (this.type === "text" || this.element.tagName === "INPUT" && this.multiline && this.isReact) this.element.setAttribute("role", "textbox");
        this.globalize = new (0, $bWDaN.Internationalization)(this.locale);
        var localeText = {
            placeholder: this.placeholder
        };
        this.l10n = new (0, $e7i2H.L10n)("textbox", localeText, this.locale);
        if (this.l10n.getConstant("placeholder") !== "") this.setProperties({
            placeholder: this.placeholder || this.l10n.getConstant("placeholder")
        }, true);
        if (!this.element.hasAttribute("id")) this.element.setAttribute("id", (0, $3EnZW.getUniqueID)("textbox"));
        if (!this.element.hasAttribute("name")) this.element.setAttribute("name", this.element.getAttribute("id"));
        if (this.element.tagName === "INPUT" && this.multiline) {
            this.isHiddenInput = true;
            this.textarea = this.createElement("textarea");
            this.element.parentNode.insertBefore(this.textarea, this.element);
            this.element.setAttribute("type", "hidden");
            this.textarea.setAttribute("name", this.element.getAttribute("name"));
            this.element.removeAttribute("name");
            this.textarea.setAttribute("role", this.element.getAttribute("role"));
            this.element.removeAttribute("role");
            this.textarea.setAttribute("id", (0, $3EnZW.getUniqueID)("textarea"));
            var apiAttributes = [
                "placeholder",
                "disabled",
                "value",
                "readonly",
                "type",
                "autocomplete"
            ];
            for(var index = 0; index < this.element.attributes.length; index++){
                var attributeName = this.element.attributes[index].nodeName;
                if (this.element.hasAttribute(attributeName) && (0, $168e4e125732cd26$export$32cda1f66e0b465f).indexOf(attributeName) < 0 && !(attributeName === "id" || attributeName === "type" || attributeName === "e-mappinguid")) {
                    // e-mappinguid attribute is handled for Grid component.
                    this.textarea.setAttribute(attributeName, this.element.attributes[index].nodeValue);
                    if (apiAttributes.indexOf(attributeName) < 0) {
                        this.element.removeAttribute(attributeName);
                        index--;
                    }
                }
            }
        }
    };
    TextBox.prototype.checkAttributes = function(isDynamic) {
        var attrs = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "placeholder",
            "disabled",
            "value",
            "readonly",
            "type",
            "autocomplete"
        ];
        for(var _i = 0, attrs_1 = attrs; _i < attrs_1.length; _i++){
            var key = attrs_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.getAttribute(key))) switch(key){
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["enabled"] === undefined || isDynamic) {
                        var enabled = this.element.getAttribute(key) === "disabled" || this.element.getAttribute(key) === "" || this.element.getAttribute(key) === "true" ? false : true;
                        this.setProperties({
                            enabled: enabled
                        }, !isDynamic);
                    }
                    break;
                case "readonly":
                    if ((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["readonly"] === undefined || isDynamic) {
                        var readonly = this.element.getAttribute(key) === "readonly" || this.element.getAttribute(key) === "" || this.element.getAttribute(key) === "true" ? true : false;
                        this.setProperties({
                            readonly: readonly
                        }, !isDynamic);
                    }
                    break;
                case "placeholder":
                    if ((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["placeholder"] === undefined || isDynamic) this.setProperties({
                        placeholder: this.element.placeholder
                    }, !isDynamic);
                    break;
                case "autocomplete":
                    if ((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["autocomplete"] === undefined || isDynamic) {
                        var autoCompleteTxt = this.element.autocomplete === "off" ? "off" : "on";
                        this.setProperties({
                            autocomplete: autoCompleteTxt
                        }, !isDynamic);
                    }
                    break;
                case "value":
                    if (((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["value"] === undefined || isDynamic) && this.element.value !== "") this.setProperties({
                        value: this.element.value
                    }, !isDynamic);
                    break;
                case "type":
                    if ((0, $3EnZW.isNullOrUndefined)(this.textboxOptions) || this.textboxOptions["type"] === undefined || isDynamic) this.setProperties({
                        type: this.element.type
                    }, !isDynamic);
                    break;
            }
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ TextBox.prototype.render = function() {
        var updatedCssClassValue = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValue = (0, $168e4e125732cd26$export$f5b8910cec6cf069).getInputValidClassList(this.cssClass);
        this.respectiveElement = this.isHiddenInput ? this.textarea : this.element;
        this.textboxWrapper = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: this.respectiveElement,
            floatLabelType: this.floatLabelType,
            properties: {
                enabled: this.enabled,
                enableRtl: this.enableRtl,
                cssClass: updatedCssClassValue,
                readonly: this.readonly,
                placeholder: this.placeholder,
                showClearButton: this.showClearButton
            }
        });
        this.updateHTMLAttributesToWrapper();
        if (this.isHiddenInput) this.respectiveElement.parentNode.insertBefore(this.element, this.respectiveElement);
        this.wireEvents();
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.value, this.respectiveElement, this.floatLabelType, this.showClearButton);
            if (this.isHiddenInput) this.element.value = this.respectiveElement.value;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.initialValue = this.value;
            this.setInitialValue();
        }
        if (this.autocomplete !== "on" && this.autocomplete !== "") this.respectiveElement.autocomplete = this.autocomplete;
        else if (!(0, $3EnZW.isNullOrUndefined)(this.textboxOptions) && this.textboxOptions["autocomplete"] !== undefined) this.removeAttributes([
            "autocomplete"
        ]);
        this.previousValue = this.value;
        this.inputPreviousValue = this.value;
        this.respectiveElement.defaultValue = this.respectiveElement.value;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).setWidth(this.width, this.textboxWrapper.container);
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        if (!this.element.hasAttribute("aria-labelledby") && !this.element.hasAttribute("placeholder") && !this.element.hasAttribute("aria-label")) this.element.setAttribute("aria-label", "textbox");
        this.renderComplete();
    };
    TextBox.prototype.updateHTMLAttributesToWrapper = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).updateHTMLAttributesToWrapper(this.htmlAttributes, this.textboxWrapper.container);
    };
    TextBox.prototype.updateHTMLAttributesToElement = function() {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).updateHTMLAttributesToElement(this.htmlAttributes, this.respectiveElement ? this.respectiveElement : this.multiline && !(0, $3EnZW.isNullOrUndefined)(this.textarea) ? this.textarea : this.element);
    };
    TextBox.prototype.setInitialValue = function() {
        if (!this.isAngular) this.respectiveElement.setAttribute("value", this.initialValue);
    };
    TextBox.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.respectiveElement, "focus", this.focusHandler, this);
        (0, $aqzbR.EventHandler).add(this.respectiveElement, "blur", this.focusOutHandler, this);
        (0, $aqzbR.EventHandler).add(this.respectiveElement, "keydown", this.keydownHandler, this);
        (0, $aqzbR.EventHandler).add(this.respectiveElement, "input", this.inputHandler, this);
        (0, $aqzbR.EventHandler).add(this.respectiveElement, "change", this.changeHandler, this);
        if (this.isForm) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.resetForm, this);
        this.bindClearEvent();
        if (!(0, $3EnZW.isNullOrUndefined)(this.textboxWrapper.container.querySelector(".e-float-text")) && this.floatLabelType === "Auto" && this.textboxWrapper.container.classList.contains("e-autofill") && this.textboxWrapper.container.classList.contains("e-outline")) (0, $aqzbR.EventHandler).add(this.textboxWrapper.container.querySelector(".e-float-text"), "animationstart", this.animationHandler, this);
    };
    TextBox.prototype.animationHandler = function() {
        this.textboxWrapper.container.classList.add("e-valid-input");
        var label = this.textboxWrapper.container.querySelector(".e-float-text");
        if (!(0, $3EnZW.isNullOrUndefined)(label)) {
            label.classList.add("e-label-top");
            if (label.classList.contains("e-label-bottom")) label.classList.remove("e-label-bottom");
        }
    };
    TextBox.prototype.resetValue = function(value) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.value = value;
        if (value == null && this.textboxWrapper.container.classList.contains("e-valid-input")) this.textboxWrapper.container.classList.remove("e-valid-input");
        this.isProtectedOnChange = prevOnChange;
    };
    TextBox.prototype.resetForm = function() {
        if (this.isAngular) this.resetValue("");
        else this.resetValue(this.initialValue);
        if (!(0, $3EnZW.isNullOrUndefined)(this.textboxWrapper)) {
            var label = this.textboxWrapper.container.querySelector(".e-float-text");
            if (!(0, $3EnZW.isNullOrUndefined)(label) && this.floatLabelType !== "Always") {
                if ((0, $3EnZW.isNullOrUndefined)(this.initialValue) || this.initialValue === "") {
                    label.classList.add("e-label-bottom");
                    label.classList.remove("e-label-top");
                } else if (this.initialValue !== "") {
                    label.classList.add("e-label-top");
                    label.classList.remove("e-label-bottom");
                }
            }
        }
    };
    TextBox.prototype.focusHandler = function(args) {
        var eventArgs = {
            container: this.textboxWrapper.container,
            event: args,
            value: this.value
        };
        this.trigger("focus", eventArgs);
    };
    TextBox.prototype.focusOutHandler = function(args) {
        if (!(this.previousValue === null && this.value === null && this.respectiveElement.value === "") && this.previousValue !== this.value) this.raiseChangeEvent(args, true);
        var eventArgs = {
            container: this.textboxWrapper.container,
            event: args,
            value: this.value
        };
        this.trigger("blur", eventArgs);
    };
    TextBox.prototype.keydownHandler = function(args) {
        if ((args.keyCode === 13 || args.keyCode === 9) && !((this.previousValue === null || this.previousValue === "") && (this.value === null || this.value === "") && this.respectiveElement.value === "")) this.setProperties({
            value: this.respectiveElement.value
        }, true);
    };
    TextBox.prototype.inputHandler = function(args) {
        var textboxObj = this;
        var eventArgs = {
            event: args,
            value: this.respectiveElement.value,
            previousValue: this.inputPreviousValue,
            container: this.textboxWrapper.container
        };
        this.inputPreviousValue = this.respectiveElement.value;
        /* istanbul ignore next */ if (this.isAngular) {
            textboxObj.localChange({
                value: this.respectiveElement.value
            });
            this.preventChange = true;
        }
        if (this.isVue) this.preventChange = true;
        this.trigger("input", eventArgs);
        args.stopPropagation();
    };
    TextBox.prototype.changeHandler = function(args) {
        this.setProperties({
            value: this.respectiveElement.value
        }, true);
        if (this.previousValue !== this.value) this.raiseChangeEvent(args, true);
        args.stopPropagation();
    };
    TextBox.prototype.raiseChangeEvent = function(event, interaction) {
        var eventArgs = {
            event: event,
            value: this.value,
            previousValue: this.previousValue,
            container: this.textboxWrapper.container,
            isInteraction: interaction ? interaction : false,
            isInteracted: interaction ? interaction : false
        };
        this.preventChange = false;
        this.trigger("change", eventArgs);
        this.previousValue = this.value;
        //EJ2CORE-738:For this task we update the textarea value to the input when input tag with multiline is present
        if (this.element.tagName === "INPUT" && this.multiline && (0, $5q7BP.Browser).info.name === "mozilla") this.element.value = this.respectiveElement.value;
    };
    TextBox.prototype.bindClearEvent = function() {
        if (this.showClearButton) {
            if (this.enabled) (0, $aqzbR.EventHandler).add(this.textboxWrapper.clearButton, "mousedown touchstart", this.resetInputHandler, this);
            else (0, $aqzbR.EventHandler).remove(this.textboxWrapper.clearButton, "mousedown touchstart", this.resetInputHandler);
        }
    };
    TextBox.prototype.resetInputHandler = function(event) {
        event.preventDefault();
        if (!this.textboxWrapper.clearButton.classList.contains($6d46db6d177db8e2$var$HIDE_CLEAR) || this.textboxWrapper.container.classList.contains("e-static-clear")) {
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue("", this.respectiveElement, this.floatLabelType, this.showClearButton);
            if (this.isHiddenInput) this.element.value = this.respectiveElement.value;
            this.setProperties({
                value: this.respectiveElement.value
            }, true);
            var eventArgs = {
                event: event,
                value: this.respectiveElement.value,
                previousValue: this.inputPreviousValue,
                container: this.textboxWrapper.container
            };
            this.trigger("input", eventArgs);
            this.inputPreviousValue = this.respectiveElement.value;
            this.raiseChangeEvent(event, true);
            if ((0, $4ZDHT.closest)(this.element, "form")) {
                var element = this.element;
                var keyupEvent = document.createEvent("KeyboardEvent");
                keyupEvent.initEvent("keyup", false, true);
                element.dispatchEvent(keyupEvent);
            }
        }
    };
    TextBox.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.respectiveElement, "focus", this.focusHandler);
        (0, $aqzbR.EventHandler).remove(this.respectiveElement, "blur", this.focusOutHandler);
        (0, $aqzbR.EventHandler).remove(this.respectiveElement, "keydown", this.keydownHandler);
        (0, $aqzbR.EventHandler).remove(this.respectiveElement, "input", this.inputHandler);
        (0, $aqzbR.EventHandler).remove(this.respectiveElement, "change", this.changeHandler);
        if (this.isForm) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.resetForm);
        if (!(0, $3EnZW.isNullOrUndefined)(this.textboxWrapper.container.querySelector(".e-float-text")) && this.floatLabelType === "Auto" && this.textboxWrapper.container.classList.contains("e-outline") && this.textboxWrapper.container.classList.contains("e-autofill")) (0, $aqzbR.EventHandler).remove(this.textboxWrapper.container.querySelector(".e-float-text"), "animationstart", this.animationHandler);
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also, it maintains the initial TextBox element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */ TextBox.prototype.destroy = function() {
        this.unWireEvents();
        if (this.showClearButton) this.clearButton = document.getElementsByClassName("e-clear-icon")[0];
        if (this.element.tagName === "INPUT" && this.multiline) {
            (0, $4ZDHT.detach)(this.textboxWrapper.container.getElementsByTagName("textarea")[0]);
            this.respectiveElement = this.element;
            this.element.removeAttribute("type");
        }
        this.respectiveElement.value = this.respectiveElement.defaultValue;
        this.respectiveElement.classList.remove("e-input");
        this.removeAttributes([
            "aria-disabled",
            "aria-readonly",
            "aria-labelledby"
        ]);
        if (!(0, $3EnZW.isNullOrUndefined)(this.textboxWrapper)) {
            this.textboxWrapper.container.insertAdjacentElement("afterend", this.respectiveElement);
            (0, $4ZDHT.detach)(this.textboxWrapper.container);
        }
        this.textboxWrapper = null;
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: this.respectiveElement,
            floatLabelType: this.floatLabelType,
            properties: this.properties
        }, this.clearButton);
        _super.prototype.destroy.call(this);
    };
    /**
     * Adding the icons to the TextBox component.
     *
     * @param { string } position - Specify the icon placement on the TextBox. Possible values are append and prepend.
     * @param { string | string[] } icons - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for TextBox.
     * @returns {void}
     */ TextBox.prototype.addIcon = function(position, icons) {
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).addIcon(position, icons, this.textboxWrapper.container, this.respectiveElement, this.createElement);
    };
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string} Returns the persisted data.
     */ TextBox.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Adding the multiple attributes as key-value pair to the TextBox element.
     *
     * @param {string} attributes - Specifies the attributes to be add to TextBox element.
     * @returns {void}
     */ TextBox.prototype.addAttributes = function(attributes) {
        for(var _i = 0, _a = Object.keys(attributes); _i < _a.length; _i++){
            var key = _a[_i];
            if (key === "disabled") {
                this.setProperties({
                    enabled: false
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
            } else if (key === "readonly") {
                this.setProperties({
                    readonly: true
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.respectiveElement);
            } else if (key === "class") this.respectiveElement.classList.add(attributes["" + key]);
            else if (key === "placeholder") {
                this.setProperties({
                    placeholder: attributes["" + key]
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.respectiveElement);
            } else if (key === "rows" && this.respectiveElement.tagName === "TEXTAREA") this.respectiveElement.setAttribute(key, attributes["" + key]);
            else this.respectiveElement.setAttribute(key, attributes["" + key]);
        }
    };
    /**
     * Removing the multiple attributes as key-value pair to the TextBox element.
     *
     * @param { string[] } attributes - Specifies the attributes name to be removed from TextBox element.
     * @returns {void}
     */ TextBox.prototype.removeAttributes = function(attributes) {
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var key = attributes_1[_i];
            if (key === "disabled") {
                this.setProperties({
                    enabled: true
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
            } else if (key === "readonly") {
                this.setProperties({
                    readonly: false
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setReadonly(this.readonly, this.respectiveElement);
            } else if (key === "placeholder") {
                this.setProperties({
                    placeholder: null
                }, true);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setPlaceholder(this.placeholder, this.respectiveElement);
            } else this.respectiveElement.removeAttribute(key);
        }
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ TextBox.prototype.focusIn = function() {
        if (document.activeElement !== this.respectiveElement && this.enabled) {
            this.respectiveElement.focus();
            if (this.textboxWrapper.container.classList.contains("e-input-group") || this.textboxWrapper.container.classList.contains("e-outline") || this.textboxWrapper.container.classList.contains("e-filled")) (0, $4ZDHT.addClass)([
                this.textboxWrapper.container
            ], [
                (0, $168e4e125732cd26$export$a88d92a7bdb59b3e)
            ]);
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ TextBox.prototype.focusOut = function() {
        if (document.activeElement === this.respectiveElement && this.enabled) {
            this.respectiveElement.blur();
            if (this.textboxWrapper.container.classList.contains("e-input-group") || this.textboxWrapper.container.classList.contains("e-outline") || this.textboxWrapper.container.classList.contains("e-filled")) (0, $4ZDHT.removeClass)([
                this.textboxWrapper.container
            ], [
                (0, $168e4e125732cd26$export$a88d92a7bdb59b3e)
            ]);
        }
    };
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)("text")
    ], TextBox.prototype, "type", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TextBox.prototype, "readonly", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextBox.prototype, "value", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], TextBox.prototype, "floatLabelType", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TextBox.prototype, "cssClass", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextBox.prototype, "placeholder", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)("on")
    ], TextBox.prototype, "autocomplete", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)({})
    ], TextBox.prototype, "htmlAttributes", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TextBox.prototype, "multiline", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TextBox.prototype, "enabled", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TextBox.prototype, "showClearButton", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TextBox.prototype, "enablePersistence", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TextBox.prototype, "width", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "created", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "destroyed", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "change", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "blur", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "focus", void 0);
    $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.Event)()
    ], TextBox.prototype, "input", void 0);
    TextBox = $6d46db6d177db8e2$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], TextBox);
    return TextBox;
}((0, $hQxLN.Component));



/**
 * In-place Editor events defined here.
 */ /** @hidden */ var $40348da204e6a693$export$b3890eb0ae9dca99 = "render";
var $40348da204e6a693$export$722fbec263ad908a = "update";
var $40348da204e6a693$export$b1fb4cac938035f7 = "destroy";
var $40348da204e6a693$export$f06c444b0336b5d5 = "set-focus";
var $40348da204e6a693$export$a0fcb8a4617a63a1 = "access-value";
var $40348da204e6a693$export$5098e90bbeb5a2b4 = "destroy-modules";
var $40348da204e6a693$export$348d584e223bdf1b = "show-popup";


/**
 * In-place Editor classes defined here.
 */ /** @hidden */ var $b15746da8dc0a709$export$fbea82a1c0574ef4 = "e-inplaceeditor";
var $b15746da8dc0a709$export$b9fccf621889576c = "e-inplaceeditor-tip";
var $b15746da8dc0a709$export$9bbeb56dbf42510f = "e-editable-value-wrapper";
var $b15746da8dc0a709$export$764bd63f4c2043a2 = "e-editable-value";
var $b15746da8dc0a709$export$31684b991da737ee = "e-editable-overlay-icon";
var $b15746da8dc0a709$export$883e33b7441bcda7 = "e-editable-tip-title";
var $b15746da8dc0a709$export$f1e53f710478ceb4 = "e-editable-title";
var $b15746da8dc0a709$export$1ff9623b26415f8 = "e-editable-inline";
var $b15746da8dc0a709$export$48547bf02afe9eb8 = "e-editable-popup";
var $b15746da8dc0a709$export$20b8431be300f03e = "e-editable-wrapper";
var $b15746da8dc0a709$export$26d55645375ca9a = "e-editable-loading";
var $b15746da8dc0a709$export$b252bb901a2de2f0 = "e-editable-form";
var $b15746da8dc0a709$export$52141c2edb6ee44d = "e-component-group";
var $b15746da8dc0a709$export$9ea760072c364d49 = "e-editable-component";
var $b15746da8dc0a709$export$e01aea21bc2dabea = "e-editable-action-buttons";
var $b15746da8dc0a709$export$58deb822de2b8ad8 = "e-editable-error";
var $b15746da8dc0a709$export$a6d18b072e3b7ccb = "e-editable-elements";
var $b15746da8dc0a709$export$bb29a81b503a982c = "e-editable-open";
var $b15746da8dc0a709$export$50f3568e212d4078 = "e-btn-save";
var $b15746da8dc0a709$export$2f411ae65effe84b = "e-btn-cancel";
var $b15746da8dc0a709$export$63ff4c79abfe65e4 = "e-rte-spin-wrap";
var $b15746da8dc0a709$export$349c12bacbc9903a = "e-control-overlay";
var $b15746da8dc0a709$export$ef8adfdd925d3e83 = "e-disable";
var $b15746da8dc0a709$export$fde44257752a9f60 = "e-icons";
var $b15746da8dc0a709$export$fd2a60be71b279b3 = "e-primary";
var $b15746da8dc0a709$export$9d04158a25ce4cd = "e-show";
var $b15746da8dc0a709$export$7a302b3efb32a64b = "e-hide";
var $b15746da8dc0a709$export$850f7749a2909601 = "e-rtl";
var $b15746da8dc0a709$export$103bedf43ba882db = "e-error";
var $b15746da8dc0a709$export$50c885a21bfec48c = "e-loading";


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $72c33a44f7d6f2bc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $72c33a44f7d6f2bc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the popup settings of the In-place editor.
 */ var $72c33a44f7d6f2bc$export$3193c38af1d734b = /** @class */ function(_super) {
    $72c33a44f7d6f2bc$var$__extends(PopupSettings, _super);
    function PopupSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $72c33a44f7d6f2bc$var$__decorate([
        (0, $5rsSz.Property)("")
    ], PopupSettings.prototype, "title", void 0);
    $72c33a44f7d6f2bc$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PopupSettings.prototype, "model", void 0);
    return PopupSettings;
}((0, $3fcxu.ChildProperty));
var $72c33a44f7d6f2bc$export$5e4dd3837967b63b = {
    "AutoComplete": "auto-complete",
    "Color": "color-picker",
    "ComboBox": "combo-box",
    "DateRange": "date-range-picker",
    "MultiSelect": "multi-select",
    "RTE": "rte",
    "Slider": "slider",
    "Time": "time-picker"
};
var $72c33a44f7d6f2bc$export$cbc139f9d9bf76f7 = {
    "Click": {
        "editAreaClick": "Click to edit"
    },
    "DblClick": {
        "editAreaDoubleClick": "Double click to edit"
    },
    "EditIconClick": {
        "editAreaClick": "Click to edit"
    }
};


parcelRequire("j7YE8");
var $bWDaN = parcelRequire("bWDaN");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Exports util methods used by In-place editor.
 */ var $d5eca6dd2d68c3de$var$intl = new (0, $bWDaN.Internationalization)();
function $d5eca6dd2d68c3de$export$5303528d1070ff6f(type, val, model) {
    if ((0, $3EnZW.isNullOrUndefined)(val) || val === "") return "";
    var result;
    var tempFormat;
    switch(type){
        case "Color":
            var hex = val;
            result = hex.length > 7 ? hex.slice(0, -2) : hex;
            break;
        case "Date":
            tempFormat = model.format;
            result = $d5eca6dd2d68c3de$var$intl.formatDate(val, {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "d" : "yMd"
            });
            break;
        case "DateRange":
            tempFormat = model.format;
            var date = val;
            result = $d5eca6dd2d68c3de$var$intl.formatDate(date[0], {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "d" : "yMd"
            }) + " - " + $d5eca6dd2d68c3de$var$intl.formatDate(date[1], {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "d" : "yMd"
            });
            break;
        case "DateTime":
            tempFormat = model.format;
            if ((0, $3EnZW.isNullOrUndefined)(tempFormat) || tempFormat === "") result = $d5eca6dd2d68c3de$var$intl.formatDate(val, {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "d" : "yMd"
            }) + " " + $d5eca6dd2d68c3de$var$intl.formatDate(val, {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "t" : "hm"
            });
            else result = $d5eca6dd2d68c3de$var$intl.formatDate(val, {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "d" : "yMd"
            });
            break;
        case "Time":
            tempFormat = model.format;
            result = $d5eca6dd2d68c3de$var$intl.formatDate(val, {
                format: tempFormat,
                type: type,
                skeleton: (0, $3EnZW.isBlazor)() ? "t" : "hm"
            });
            break;
        case "Numeric":
            tempFormat = (0, $3EnZW.isNullOrUndefined)(model.format) ? "n2" : model.format;
            var tempVal = (0, $3EnZW.isNullOrUndefined)(val) ? null : typeof val === "number" ? val : $d5eca6dd2d68c3de$var$intl.parseNumber(val);
            result = $d5eca6dd2d68c3de$var$intl.formatNumber(tempVal, {
                format: tempFormat
            });
            break;
        default:
            result = val.toString();
            break;
    }
    return result;
}
function $d5eca6dd2d68c3de$export$8d1f44203073223(type, val) {
    if ((0, $3EnZW.isNullOrUndefined)(val) || val === "") return val;
    if ((type === "Date" || type === "Time" || type === "DateTime") && typeof val === "string") val = new Date(val);
    else if (type === "DateRange") {
        if (typeof val === "object" && typeof val[0] === "string") val = [
            new Date(val[0]),
            new Date(val[1])
        ];
        else if (typeof val === "string") {
            var temp = val.split("-");
            val = [
                new Date(temp[0]),
                new Date(temp[1])
            ];
        }
    }
    return val;
}
function $d5eca6dd2d68c3de$export$c564cdbbe6da493(value) {
    var data = [];
    for(var i = value.length - 1; i >= 0; i--)data.unshift([
        "&#",
        value[i].charCodeAt(0),
        ";"
    ].join(""));
    return data.join("");
}


var $6c3b84be4fdf3a18$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6c3b84be4fdf3a18$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * ```html
 * * The In-place editor control is used to edit an element in a place and to update the value in server.
 * <div id='element' />
 * <script>
 *   var editorObj = new InPlaceEditor();
 *   editorObj.appendTo('#element');
 * </script>
 * ```
 */ var $6c3b84be4fdf3a18$export$9c6622dfc8cb539f = /** @class */ function(_super) {
    $6c3b84be4fdf3a18$var$__extends(InPlaceEditor, _super);
    /**
     * Initializes a new instance of the In-place editor class.
     *
     * @param {InPlaceEditorModel} options  - Specifies In-place editor model properties as options.
     * @param {string} element  - Specifies the element for which In-place editor applies.
     */ function InPlaceEditor(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.needsID = true;
        return _this;
    }
    InPlaceEditor.prototype.initializeValue = function() {
        this.initRender = true;
        this.isTemplate = false;
        this.isVue = false;
        this.isExtModule = false;
        this.submitBtn = undefined;
        this.cancelBtn = undefined;
        this.isClearTarget = false;
        this.btnElements = undefined;
        this.dataManager = undefined;
        this.oldValue = undefined;
        this.divComponents = [
            "RTE",
            "Slider"
        ];
        this.clearComponents = [
            "AutoComplete",
            "Mask",
            "Text"
        ];
        this.dateType = [
            "Date",
            "DateTime",
            "Time"
        ];
        this.inputDataEle = [
            "Date",
            "DateTime",
            "DateRange",
            "Time",
            "Numeric"
        ];
        this.dropDownEle = [
            "AutoComplete",
            "ComboBox",
            "DropDownList",
            "MultiSelect"
        ];
        this.moduleList = [
            "AutoComplete",
            "Color",
            "ComboBox",
            "DateRange",
            "MultiSelect",
            "RTE",
            "Slider",
            "Time"
        ];
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */ InPlaceEditor.prototype.preRender = function() {
        this.initializeValue();
        this.onScrollResizeHandler = this.scrollResizeHandler.bind(this);
        if ((0, $3EnZW.isNullOrUndefined)(this.model)) this.setProperties({
            model: {}
        }, true);
        this.titleEle = this.createElement("div", {
            className: $b15746da8dc0a709$export$f1e53f710478ceb4
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupSettings.model) && this.popupSettings.model.afterOpen) this.afterOpenEvent = this.popupSettings.model.afterOpen;
    };
    /**
     * To Initialize the In-place editor rendering
     *
     * @returns {void}
     * @private
     */ InPlaceEditor.prototype.render = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.element.getAttribute("tabindex"))) this.disabled ? this.element.setAttribute("tabindex", "-1") : this.element.setAttribute("tabindex", "0");
        this.checkIsTemplate();
        this.disable(this.disabled);
        this.updateAdaptor();
        this.appendValueElement();
        this.updateValue();
        this.textOption === "Never" ? this.renderValue(this.checkValue((0, $d5eca6dd2d68c3de$export$5303528d1070ff6f)(this.type, this.value, this.model))) : this.renderInitialValue();
        this.wireEvents();
        this.setRtl(this.enableRtl);
        this.enableEditor(this.enableEditMode, true);
        this.setClass("add", this.cssClass);
        this.renderComplete();
    };
    InPlaceEditor.prototype.setClass = function(action, val) {
        if (!this.isEmpty(val)) {
            var allClassName = val.split(" ");
            for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") action === "add" ? (0, $4ZDHT.addClass)([
                this.element
            ], [
                allClassName[i]
            ]) : (0, $4ZDHT.removeClass)([
                this.element
            ], [
                allClassName[i]
            ]);
        }
    };
    InPlaceEditor.prototype.appendValueElement = function() {
        this.valueWrap = this.createElement("div", {
            id: this.element.id + "_wrap",
            className: $b15746da8dc0a709$export$9bbeb56dbf42510f
        });
        if (!(0, $3EnZW.isBlazor)()) this.element.innerHTML = "";
        this.valueEle = this.createElement("span", {
            className: $b15746da8dc0a709$export$764bd63f4c2043a2
        });
        this.editIcon = this.createElement("span", {
            className: $b15746da8dc0a709$export$31684b991da737ee + " " + $b15746da8dc0a709$export$fde44257752a9f60,
            attrs: {
                "title": this.getLocale({
                    editIcon: "Click to edit"
                }, "editIcon")
            }
        });
        this.valueWrap.appendChild(this.valueEle);
        this.valueWrap.appendChild(this.editIcon);
        this.element.appendChild(this.valueWrap);
    };
    InPlaceEditor.prototype.renderInitialValue = function() {
        if ([
            "AutoComplete",
            "ComboBox",
            "DropDownList",
            "MultiSelect"
        ].indexOf(this.type) > -1 && !(0, $3EnZW.isNullOrUndefined)(this.value) && !this.isEmpty(this.value.toString()) && !(0, $3EnZW.isNullOrUndefined)(this.model.fields) && !(0, $3EnZW.isNullOrUndefined)(this.model.dataSource)) {
            this.renderValue(this.getLocale({
                loadingText: "Loading..."
            }, "loadingText"));
            this.valueWrap.classList.add($b15746da8dc0a709$export$50c885a21bfec48c);
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.valueWrap,
                width: 10
            });
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.valueWrap);
            this.getInitFieldMapValue();
        } else this.renderValue(this.checkValue((0, $d5eca6dd2d68c3de$export$5303528d1070ff6f)(this.type, this.value, this.model)));
    };
    InPlaceEditor.prototype.getInitFieldMapValue = function() {
        var _this = this;
        var model = this.model;
        var mText = model.fields.text;
        var mVal = model.fields.value;
        var query = (0, $3EnZW.isNullOrUndefined)(model.query) ? new (0, $56262f229d1cff45$export$62297b13309008b2)() : model.query;
        if (model.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) model.dataSource.executeQuery(this.getInitQuery(model, query)).then(function(e) {
            _this.updateInitValue(mText, mVal, e.result);
        });
        else this.updateInitValue(mText, mVal, new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(model.dataSource).executeLocal(this.getInitQuery(model, query)));
    };
    InPlaceEditor.prototype.getInitQuery = function(model, query) {
        var predicate;
        var mVal = model.fields.value;
        var value = this.value;
        if (this.type !== "MultiSelect" || typeof this.value !== "object") predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(mVal, "equal", this.value);
        else {
            var i = 0;
            for(var _i = 0, value_1 = value; _i < value_1.length; _i++){
                var val = value_1[_i];
                predicate = i === 0 ? predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(mVal, "equal", val) : predicate.or(mVal, "equal", val);
                i++;
            }
        }
        return query.where(predicate);
    };
    InPlaceEditor.prototype.updateInitValue = function(mText, mVal, result) {
        if (result.length <= 0) return;
        if (result.length === 1) this.valueEle.innerHTML = this.checkValue((0, $3EnZW.getValue)((0, $3EnZW.isNullOrUndefined)(mText) ? mVal : mText, result[0]));
        else {
            var val = [];
            for(var _i = 0, result_1 = result; _i < result_1.length; _i++){
                var obj = result_1[_i];
                val.push((0, $3EnZW.getValue)((0, $3EnZW.isNullOrUndefined)(mText) ? mVal : mText, obj));
            }
            this.valueEle.innerHTML = this.checkValue(val.toString());
        }
        (0, $d4834c37f505aa74$export$95fec50f68454318)(this.valueWrap);
        this.valueWrap.classList.remove($b15746da8dc0a709$export$50c885a21bfec48c);
    };
    InPlaceEditor.prototype.renderValue = function(val) {
        this.enableHtmlSanitizer && this.type !== "RTE" && this.type !== "MultiSelect" ? this.valueEle.innerText = val : this.valueEle.innerHTML = this.enableHtmlParse ? val : (0, $d5eca6dd2d68c3de$export$c564cdbbe6da493)(val);
        if (this.type === "Color") (0, $4ZDHT.setStyleAttribute)(this.valueEle, {
            "color": val
        });
        if (this.mode === "Inline") {
            if (this.isEditorOpen()) (0, $4ZDHT.removeClass)([
                this.valueWrap
            ], [
                $b15746da8dc0a709$export$7a302b3efb32a64b
            ]);
        }
    };
    InPlaceEditor.prototype.isEditorOpen = function() {
        if (this.isVue && (this.enableEditMode || !(0, $3EnZW.isNullOrUndefined)(this.valueWrap) && !(this.valueWrap.classList.contains($b15746da8dc0a709$export$7a302b3efb32a64b) || this.valueWrap.classList.contains("e-tooltip")))) return false;
        else return true;
    };
    InPlaceEditor.prototype.renderEditor = function() {
        this.prevValue = this.value;
        this.beginEditArgs = {
            mode: this.mode,
            cancelFocus: false,
            cancel: false
        };
        this.trigger("beginEdit", this.beginEditArgs);
        if (this.beginEditArgs.cancel) return;
        var tipOptions = undefined;
        var target = (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$9bbeb56dbf42510f, this.element);
        if (this.editableOn !== "EditIconClick") target.parentElement.removeAttribute("title");
        if (this.valueWrap.classList.contains($b15746da8dc0a709$export$bb29a81b503a982c)) return;
        if (this.mode === "Inline") {
            (0, $4ZDHT.addClass)([
                this.valueWrap
            ], [
                $b15746da8dc0a709$export$7a302b3efb32a64b
            ]);
            this.inlineWrapper = this.createElement("div", {
                className: $b15746da8dc0a709$export$1ff9623b26415f8
            });
            this.element.appendChild(this.inlineWrapper);
            if ([
                "AutoComplete",
                "ComboBox",
                "DropDownList",
                "MultiSelect"
            ].indexOf(this.type) > -1) this.checkRemoteData(this.model);
            else this.renderAndOpen();
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(this.popupSettings.model) && this.popupSettings.model.afterOpen) this.popupSettings.model.afterOpen = this.afterOpenHandler.bind(this);
            var content = this.createElement("div", {
                className: $b15746da8dc0a709$export$48547bf02afe9eb8
            });
            if (!this.isEmpty(this.popupSettings.title)) {
                this.titleEle.innerHTML = this.popupSettings.title;
                content.appendChild(this.titleEle);
            }
            tipOptions = {
                content: content,
                opensOn: "Custom",
                enableRtl: this.enableRtl,
                cssClass: $b15746da8dc0a709$export$b9fccf621889576c,
                afterOpen: this.afterOpenHandler.bind(this)
            };
            content.appendChild(this.renderControl(document.body));
            (0, $3EnZW.extend)(tipOptions, this.popupSettings.model, tipOptions, true);
            this.tipObj = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)(tipOptions);
            this.tipObj.appendTo(target);
            this.tipObj.open(target);
        }
        if (this.actionOnBlur !== "Ignore") this.wireDocEvent();
        (0, $4ZDHT.addClass)([
            this.valueWrap
        ], [
            $b15746da8dc0a709$export$bb29a81b503a982c
        ]);
        this.setProperties({
            enableEditMode: true
        }, true);
        if (this.isReact) this.renderReactTemplates();
    };
    InPlaceEditor.prototype.renderAndOpen = function() {
        this.renderControl(this.inlineWrapper);
        this.afterOpenHandler(null);
    };
    InPlaceEditor.prototype.checkRemoteData = function(model) {
        var _this = this;
        if (model.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            model.dataBound = function() {
                _this.afterOpenHandler(null);
            };
            this.renderControl(this.inlineWrapper);
            if ((0, $3EnZW.isNullOrUndefined)(model.value) && (0, $3EnZW.isNullOrUndefined)(this.value) || model.value === this.value && !(0, $3EnZW.isNullOrUndefined)(model.value) && model.value.length === 0) this.showDropDownPopup();
        } else this.renderAndOpen();
    };
    InPlaceEditor.prototype.showDropDownPopup = function() {
        if (this.type === "DropDownList") {
            if (!this.model.allowFiltering) this.componentObj.focusIn();
            this.componentObj.showPopup();
        } else if (this.isExtModule) this.notify(this.type === "MultiSelect" ? $40348da204e6a693$export$f06c444b0336b5d5 : $40348da204e6a693$export$348d584e223bdf1b, {});
    };
    InPlaceEditor.prototype.setAttribute = function(ele, attr) {
        var value = this.name && this.name.length !== 0 ? this.name : this.element.id;
        attr.forEach(function(val) {
            ele.setAttribute(val, val === "id" ? value + "_editor" : value);
        });
    };
    InPlaceEditor.prototype.renderControl = function(target) {
        var ele;
        this.containerEle = this.createElement("div", {
            className: $b15746da8dc0a709$export$20b8431be300f03e
        });
        this.loader = this.createElement("div", {
            className: $b15746da8dc0a709$export$26d55645375ca9a
        });
        this.formEle = this.createElement("form", {
            className: $b15746da8dc0a709$export$b252bb901a2de2f0
        });
        var ctrlGroupEle = this.createElement("div", {
            className: $b15746da8dc0a709$export$52141c2edb6ee44d
        });
        var inputWrap = this.createElement("div", {
            className: $b15746da8dc0a709$export$9ea760072c364d49
        });
        target.appendChild(this.containerEle);
        this.loadSpinner();
        this.containerEle.appendChild(this.formEle);
        this.formEle.appendChild(ctrlGroupEle);
        if (this.isTemplate) this.appendTemplate(inputWrap, this.template);
        else {
            if (Array.prototype.indexOf.call(this.divComponents, this.type) > -1) {
                ele = this.createElement("div");
                this.setAttribute(ele, [
                    "id"
                ]);
            } else {
                ele = this.createElement("input");
                this.setAttribute(ele, [
                    "id",
                    "name"
                ]);
            }
            this.componentRoot = ele;
            inputWrap.appendChild(ele);
            inputWrap.appendChild(this.loader);
        }
        ctrlGroupEle.appendChild(inputWrap);
        ctrlGroupEle.appendChild(this.createElement("div", {
            className: $b15746da8dc0a709$export$58deb822de2b8ad8
        }));
        this.appendButtons(this.formEle);
        if (!this.isTemplate) this.renderComponent(ele);
        this.removeSpinner();
        if (this.submitOnEnter) this.wireEditorKeyDownEvent(this.containerEle);
        return this.containerEle;
    };
    InPlaceEditor.prototype.appendButtons = function(trg) {
        if (this.showButtons && trg) {
            this.btnElements = this.renderButtons();
            trg.appendChild(this.btnElements);
            this.wireBtnEvents();
        }
    };
    InPlaceEditor.prototype.renderButtons = function() {
        var btnWrap = this.createElement("div", {
            className: $b15746da8dc0a709$export$e01aea21bc2dabea
        });
        var primary = !(0, $3EnZW.isNullOrUndefined)(this.saveButton.content) && this.saveButton.content.length !== 0 ? " " + $b15746da8dc0a709$export$fd2a60be71b279b3 : "";
        this.submitBtn = this.createButtons({
            constant: "save",
            type: "submit",
            container: btnWrap,
            title: {
                save: "Save"
            },
            model: this.saveButton,
            className: $b15746da8dc0a709$export$50f3568e212d4078 + primary
        });
        this.cancelBtn = this.createButtons({
            type: "button",
            constant: "cancel",
            title: {
                cancel: "Cancel"
            },
            container: btnWrap,
            model: this.cancelButton,
            className: $b15746da8dc0a709$export$2f411ae65effe84b
        });
        return btnWrap;
    };
    InPlaceEditor.prototype.createButtons = function(args) {
        var btnObj = undefined;
        if (Object.keys(args.model).length > 0) {
            var btnEle = this.createElement("button", {
                className: args.className,
                attrs: {
                    "type": args.type,
                    "title": args.constant == "save" ? (0, $3EnZW.isNullOrUndefined)(this.saveButton.content) ? this.getLocale(args.title, args.constant) : this.saveButton.content : (0, $3EnZW.isNullOrUndefined)(this.cancelButton.content) ? this.getLocale(args.title, args.constant) : this.cancelButton.content
                }
            });
            args.container.appendChild(btnEle);
            btnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)(args.model, btnEle);
        }
        return btnObj;
    };
    InPlaceEditor.prototype.renderComponent = function(ele) {
        this.isExtModule = Array.prototype.indexOf.call(this.moduleList, this.type) > -1 ? true : false;
        var classProp;
        if (!(0, $3EnZW.isNullOrUndefined)(this.model.cssClass)) classProp = this.model.cssClass.indexOf($b15746da8dc0a709$export$a6d18b072e3b7ccb) < 0 ? this.model.cssClass === "" ? $b15746da8dc0a709$export$a6d18b072e3b7ccb : this.model.cssClass + " " + $b15746da8dc0a709$export$a6d18b072e3b7ccb : this.model.cssClass;
        else classProp = $b15746da8dc0a709$export$a6d18b072e3b7ccb;
        (0, $3EnZW.extend)(this.model, this.model, {
            cssClass: classProp,
            enableRtl: this.enableRtl,
            locale: this.locale,
            change: this.changeHandler.bind(this)
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) this.updateModelValue(false);
        if (this.isExtModule) this.notify($40348da204e6a693$export$b3890eb0ae9dca99, {
            module: (0, $72c33a44f7d6f2bc$export$5e4dd3837967b63b)[this.type],
            target: ele,
            type: this.type
        });
        else {
            if ((0, $3EnZW.isNullOrUndefined)(this.model.showClearButton) && !(0, $3EnZW.isBlazor)()) this.model.showClearButton = true;
            switch(this.type){
                case "Date":
                    this.componentObj = new (0, $d5f6934cad42758d$export$5109c6dd95d8fb00)(this.model);
                    break;
                case "DateTime":
                    this.componentObj = new (0, $3812471840bc0638$export$ccdfd7928785632e)(this.model);
                    break;
                case "DropDownList":
                    this.componentObj = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)(this.model);
                    break;
                case "Mask":
                    this.componentObj = new (0, $5ee2f58e8ba745bf$export$1e2d3cc3dbd650f8)(this.model);
                    break;
                case "Numeric":
                    if (this.model.value) {
                        var expRegex = new RegExp("[eE][-+]?([0-9]+)");
                        if (expRegex.test(this.model.value)) this.model.value = this.model.value;
                        else this.model.value = this.model.value.toString().replace(/[`~!@#$%^&*()_|\=?;:'",<>\{\}\[\]\\\/]/gi, "");
                    }
                    this.componentObj = new (0, $75082a70d3498091$export$d910e4596d16bb81)(this.model);
                    break;
                case "Text":
                    this.componentObj = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)(this.model);
                    break;
            }
            this.componentObj.appendTo(ele);
        }
    };
    InPlaceEditor.prototype.updateAdaptor = function() {
        switch(this.adaptor){
            case "UrlAdaptor":
                this.dataAdaptor = new (0, $e1170102ff02b3b7$export$b011aea473980a2d);
                break;
            case "WebApiAdaptor":
                this.dataAdaptor = new (0, $e1170102ff02b3b7$export$9e9267b141a15a32);
                break;
            case "ODataV4Adaptor":
                this.dataAdaptor = new (0, $e1170102ff02b3b7$export$9f728b00627a401e);
                break;
        }
    };
    InPlaceEditor.prototype.loadSpinner = function(callType) {
        (0, $4ZDHT.addClass)([
            this.loader
        ], [
            $b15746da8dc0a709$export$9d04158a25ce4cd
        ]);
        if (callType === "validate" && (this.type === "RTE" || this.type === "Color" || this.type === "Slider")) {
            (0, $4ZDHT.addClass)([
                this.loader
            ], [
                $b15746da8dc0a709$export$63ff4c79abfe65e4
            ]);
            (0, $4ZDHT.addClass)([
                this.getEditElement()
            ], [
                $b15746da8dc0a709$export$349c12bacbc9903a
            ]);
            this.spinObj = {
                target: this.loader
            };
        } else this.spinObj = {
            target: this.loader,
            width: (0, $5q7BP.Browser).isDevice ? "16px" : "14px"
        };
        if (this.formEle) (0, $4ZDHT.addClass)([
            this.formEle
        ], [
            $b15746da8dc0a709$export$50c885a21bfec48c
        ]);
        if (this.btnElements) (0, $4ZDHT.addClass)([
            this.btnElements
        ], [
            $b15746da8dc0a709$export$7a302b3efb32a64b
        ]);
        (0, $4ZDHT.setStyleAttribute)(this.loader, {
            "width": "100%"
        });
        (0, $d4834c37f505aa74$export$2342b8d835c798ac)(this.spinObj);
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinObj.target);
    };
    InPlaceEditor.prototype.removeSpinner = function(callType) {
        this.loader.removeAttribute("style");
        (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinObj.target);
        (0, $4ZDHT.detach)(this.spinObj.target.firstChild);
        if (callType === "submit" && (this.type === "RTE" || this.type === "Color" || this.type === "Slider")) {
            (0, $4ZDHT.removeClass)([
                this.loader
            ], [
                $b15746da8dc0a709$export$63ff4c79abfe65e4
            ]);
            (0, $4ZDHT.removeClass)([
                this.getEditElement()
            ], [
                $b15746da8dc0a709$export$349c12bacbc9903a
            ]);
        }
        if (this.formEle) (0, $4ZDHT.removeClass)([
            this.formEle
        ], [
            $b15746da8dc0a709$export$50c885a21bfec48c
        ]);
        if (this.btnElements) (0, $4ZDHT.removeClass)([
            this.btnElements
        ], [
            $b15746da8dc0a709$export$7a302b3efb32a64b
        ]);
        (0, $4ZDHT.removeClass)([
            this.loader
        ], [
            $b15746da8dc0a709$export$9d04158a25ce4cd
        ]);
    };
    InPlaceEditor.prototype.getEditElement = function() {
        return (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$a6d18b072e3b7ccb, this.formEle);
    };
    InPlaceEditor.prototype.getLocale = function(prop, val) {
        return new (0, $e7i2H.L10n)("inplace-editor", prop, this.locale).getConstant(val);
    };
    InPlaceEditor.prototype.checkValue = function(val) {
        return !this.isEmpty(val) ? val : this.emptyText;
    };
    InPlaceEditor.prototype.extendModelValue = function(val) {
        var model = this.model;
        (0, $3EnZW.extend)(model, {
            value: val
        });
        this.setProperties({
            model: model
        }, true);
    };
    InPlaceEditor.prototype.updateValue = function() {
        this.oldValue = this.value;
        if (this.enableHtmlSanitizer && typeof this.value === "string") this.oldValue = this.sanitizeHelper(this.value);
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.setProperties({
                value: (0, $d5eca6dd2d68c3de$export$8d1f44203073223)(this.type, this.oldValue)
            }, true);
            this.extendModelValue((0, $d5eca6dd2d68c3de$export$8d1f44203073223)(this.type, this.oldValue));
        }
    };
    InPlaceEditor.prototype.updateModelValue = function(updateOldValue) {
        if (this.type === "MultiSelect" && !this.isEmpty(this.value)) this.model.value = !updateOldValue ? this.value.slice() : this.oldValue.slice();
        else this.model.value = !updateOldValue ? this.value : this.oldValue;
    };
    InPlaceEditor.prototype.setValue = function() {
        if (this.isExtModule) this.notify($40348da204e6a693$export$722fbec263ad908a, {
            type: this.type
        });
        else if (this.componentObj) {
            if (this.type === "Numeric" && this.componentObj.value === null) this.componentObj.setProperties({
                value: null
            }, true);
            this.setProperties({
                value: this.componentObj.value
            }, true);
            this.extendModelValue(this.componentObj.value);
        }
    };
    InPlaceEditor.prototype.getDropDownsValue = function(display) {
        var value;
        if (Array.prototype.indexOf.call(this.dropDownEle, this.type) > -1 && this.type !== "MultiSelect") value = display ? (0, $4ZDHT.select)(".e-" + this.type.toLocaleLowerCase(), this.containerEle).value : this.value.toString();
        else if (this.type === "MultiSelect") {
            this.notify($40348da204e6a693$export$a0fcb8a4617a63a1, {
                type: this.type
            });
            value = display ? this.printValue : this.value.join();
        }
        return value;
    };
    InPlaceEditor.prototype.getSendValue = function() {
        if (this.isEmpty(this.value)) return "";
        if (Array.prototype.indexOf.call(this.dropDownEle, this.type) > -1) return this.getDropDownsValue(false);
        else if (Array.prototype.indexOf.call(this.dateType, this.type) > -1) return this.value.toISOString();
        else if (this.type === "DateRange") return this.value[0].toISOString() + " - " + this.value[1].toISOString();
        else return this.value.toString();
    };
    InPlaceEditor.prototype.getRenderValue = function() {
        if (this.type === "Mask" && this.componentObj.value.length !== 0) return this.componentObj.getMaskedValue();
        else if (Array.prototype.indexOf.call(this.inputDataEle, this.type) > -1) return this.componentRoot.value;
        else if (Array.prototype.indexOf.call(this.dropDownEle, this.type) > -1) return this.getDropDownsValue(true);
        else return (0, $d5eca6dd2d68c3de$export$5303528d1070ff6f)(this.type, this.value, this.model);
    };
    InPlaceEditor.prototype.setRtl = function(value) {
        value ? (0, $4ZDHT.addClass)([
            this.element
        ], [
            $b15746da8dc0a709$export$850f7749a2909601
        ]) : (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $b15746da8dc0a709$export$850f7749a2909601
        ]);
    };
    InPlaceEditor.prototype.setFocus = function() {
        if (this.isTemplate) return;
        this.isExtModule ? this.notify($40348da204e6a693$export$f06c444b0336b5d5, {}) : this.componentObj.getModuleName() === "dropdownlist" ? this.componentObj.focusIn() : this.componentObj.element.focus();
    };
    InPlaceEditor.prototype.removeEditor = function(isBlazorDestroy) {
        var blazorContain = Object.keys(window);
        if ((0, $3EnZW.isBlazor)() && !this.isStringTemplate) (0, $c2qqN.resetBlazorTemplate)(this.element.id + "template", "Template");
        var tipEle;
        if (this.tipObj && this.formEle) {
            tipEle = (0, $4ZDHT.closest)(this.formEle, "." + $b15746da8dc0a709$export$b9fccf621889576c);
            tipEle.classList.add($b15746da8dc0a709$export$7a302b3efb32a64b);
        }
        this.unWireDocEvent();
        this.destroyComponents();
        this.formEle = undefined;
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("." + $b15746da8dc0a709$export$1ff9623b26415f8, this.element))) {
            (0, $4ZDHT.detach)(this.inlineWrapper);
            this.inlineWrapper = undefined;
        } else if (this.tipObj) {
            if (this.type === "MultiSelect") {
                (0, $aqzbR.EventHandler).remove(this.containerEle, "mousedown", this.popMouseDown);
                (0, $aqzbR.EventHandler).remove(this.containerEle, "click", this.popClickHandler);
            }
            this.tipObj.close();
            this.tipObj.destroy();
            this.tipObj = undefined;
        }
        this.containerEle = undefined;
        (0, $4ZDHT.removeClass)([
            this.valueWrap
        ], [
            $b15746da8dc0a709$export$bb29a81b503a982c,
            $b15746da8dc0a709$export$7a302b3efb32a64b
        ]);
        if (!isBlazorDestroy) this.setProperties({
            enableEditMode: false
        }, true);
        if (!(0, $3EnZW.isNullOrUndefined)(this.editableOn) && this.editableOn !== "EditIconClick") {
            var titleConstant = this.editableOn === "DblClick" ? "editAreaDoubleClick" : "editAreaClick";
            if (!(0, $3EnZW.isNullOrUndefined)(this.valueWrap.parentElement)) this.valueWrap.parentElement.setAttribute("title", this.getLocale((0, $72c33a44f7d6f2bc$export$cbc139f9d9bf76f7)[this.editableOn], titleConstant));
        }
        if (this.isReact) this.clearTemplate();
    };
    InPlaceEditor.prototype.destroyComponents = function() {
        if (this.showButtons) this.destroyButtons();
        if (this.isExtModule) this.notify($40348da204e6a693$export$5098e90bbeb5a2b4, {});
        else {
            if (this.templateEle) {
                document.body.appendChild(this.templateEle);
                this.templateEle.style.display = "none";
                this.templateEle = undefined;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.componentObj)) {
                this.componentObj.destroy();
                this.componentObj = undefined;
            }
        }
        if (this.formValidate) this.formValidate = undefined;
        if (this.submitOnEnter && this.containerEle) this.unWireEditorKeyDownEvent(this.containerEle);
    };
    InPlaceEditor.prototype.destroyButtons = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.submitBtn)) {
            (0, $aqzbR.EventHandler).remove(this.submitBtn.element, "mousedown", this.submitHandler);
            (0, $aqzbR.EventHandler).remove(this.submitBtn.element, "click", this.submitPrevent);
            (0, $aqzbR.EventHandler).remove(this.submitBtn.element, "keydown", this.btnKeyDownHandler);
            this.submitBtn.destroy();
            this.submitBtn = undefined;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.cancelBtn)) {
            (0, $aqzbR.EventHandler).remove(this.cancelBtn.element, "mousedown", this.cancelBtnClick);
            (0, $aqzbR.EventHandler).remove(this.cancelBtn.element, "keydown", this.btnKeyDownHandler);
            this.cancelBtn.destroy();
            this.cancelBtn = undefined;
        }
        this.btnElements = undefined;
    };
    InPlaceEditor.prototype.getQuery = function(params) {
        var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
        Object.keys(params).forEach(function(key) {
            query.addParams(key, params[key]);
        });
        return query;
    };
    InPlaceEditor.prototype.sendValue = function() {
        var _this = this;
        var eventArgs = {
            data: {
                name: this.name,
                primaryKey: this.primaryKey,
                value: this.getSendValue()
            }
        };
        this.trigger("actionBegin", eventArgs, function(actionBeginArgs) {
            if (actionBeginArgs.cancel) {
                _this.removeSpinner("submit");
                if (_this.mode === "Popup") _this.updateArrow();
            } else {
                if (!_this.isEmpty(_this.url) && !_this.isEmpty(_this.primaryKey) && (_this.initRender || !_this.initRender && _this.prevValue !== _this.value)) {
                    _this.dataManager = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                        url: _this.url,
                        adaptor: _this.dataAdaptor
                    });
                    if (_this.adaptor === "UrlAdaptor") _this.dataManager.executeQuery(_this.getQuery(actionBeginArgs.data), _this.successHandler.bind(_this), _this.failureHandler.bind(_this));
                    else {
                        var crud = _this.dataManager.insert(actionBeginArgs.data);
                        crud.then(function(e) {
                            return _this.successHandler(e);
                        }).catch(function(e) {
                            return _this.failureHandler(e);
                        });
                    }
                } else {
                    var eventArg = {
                        data: {},
                        value: actionBeginArgs.data.value
                    };
                    _this.triggerSuccess(eventArg);
                }
                _this.dataManager = undefined;
            }
        });
    };
    InPlaceEditor.prototype.isEmpty = function(value) {
        return !(0, $3EnZW.isNullOrUndefined)(value) && value.length !== 0 ? false : true;
    };
    InPlaceEditor.prototype.checkIsTemplate = function() {
        this.isTemplate = !(0, $3EnZW.isNullOrUndefined)(this.template) && this.template !== "" ? true : false;
    };
    InPlaceEditor.prototype.templateCompile = function(trgEle, tempStr) {
        var tempEle;
        var blazorContain = Object.keys(window);
        if (typeof tempStr === "string") tempStr = tempStr.trim();
        var compiler = (0, $c2qqN.compile)(tempStr);
        if (!(0, $3EnZW.isNullOrUndefined)(compiler)) {
            var isString = (0, $3EnZW.isBlazor)() && typeof tempStr !== "function" && !this.isStringTemplate && tempStr.indexOf("<div>Blazor") === 0 ? this.isStringTemplate : true;
            tempEle = compiler({}, this, "template", this.element.id + "template", isString);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(compiler) && tempEle.length > 0) {
            [].slice.call(tempEle).forEach(function(el) {
                trgEle.appendChild(el);
            });
            if ((0, $3EnZW.isBlazor)() && !this.isStringTemplate && typeof tempStr !== "function" && tempStr.indexOf("<div>Blazor") === 0) (0, $c2qqN.updateBlazorTemplate)(this.element.id + "template", "Template", this);
        }
    };
    /**
     * @param {string} value - specifies the string value
     * @returns {string} - returns the string
     * @hidden
     */ InPlaceEditor.prototype.sanitizeHelper = function(value) {
        if (this.enableHtmlSanitizer) {
            var item_1 = (0, $3P3ke.SanitizeHtmlHelper).beforeSanitize();
            var beforeEvent = {
                cancel: false,
                helper: null
            };
            (0, $3EnZW.extend)(item_1, item_1, beforeEvent);
            this.trigger("beforeSanitizeHtml", item_1, function(args) {
                if (item_1.cancel && !(0, $3EnZW.isNullOrUndefined)(item_1.helper)) value = item_1.helper(value);
                else if (!item_1.cancel) value = (0, $3P3ke.SanitizeHtmlHelper).serializeValue(item_1, value);
            });
        }
        return value;
    };
    InPlaceEditor.prototype.appendTemplate = function(trgEle, tempStr) {
        tempStr = typeof tempStr === "string" ? this.sanitizeHelper(tempStr) : tempStr;
        this.setProperties({
            template: tempStr
        }, true);
        if (typeof tempStr === "function") this.templateCompile(trgEle, tempStr);
        else if (typeof tempStr === "string" || (0, $3EnZW.isNullOrUndefined)(tempStr.innerHTML)) {
            if (tempStr[0] === "." || tempStr[0] === "#") {
                if (document.querySelectorAll(tempStr).length) {
                    this.templateEle = document.querySelector(tempStr);
                    trgEle.appendChild(this.templateEle);
                    this.templateEle.style.display = "";
                } else this.templateCompile(trgEle, tempStr);
            } else this.templateCompile(trgEle, tempStr);
        } else {
            this.templateEle = tempStr;
            trgEle.appendChild(this.templateEle);
        }
    };
    InPlaceEditor.prototype.disable = function(value) {
        value ? (0, $4ZDHT.addClass)([
            this.element
        ], [
            $b15746da8dc0a709$export$ef8adfdd925d3e83
        ]) : (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $b15746da8dc0a709$export$ef8adfdd925d3e83
        ]);
    };
    InPlaceEditor.prototype.enableEditor = function(val, isInit) {
        if (isInit && !val) return;
        val ? this.renderEditor() : this.cancelHandler("cancel");
    };
    InPlaceEditor.prototype.checkValidation = function(fromSubmit, isValidate) {
        var _this = this;
        var args;
        if (this.validationRules) {
            var rules = Object.keys(this.validationRules);
            var validationLength_1 = Object.keys(this.validationRules[rules[0]]).length;
            validationLength_1 = "validateHidden" in this.validationRules[rules[0]] ? validationLength_1 - 1 : validationLength_1;
            var count_1 = 0;
            this.formValidate = new (0, $37c994a07eb13072$export$7c385359179c028a)(this.formEle, {
                rules: this.validationRules,
                validationBegin: function(e) {
                    if (_this.type === "RTE") {
                        var ele = document.createElement("div");
                        ele.innerHTML = e.value;
                        e.value = ele.innerText;
                    }
                },
                validationComplete: function(e) {
                    count_1 = count_1 + 1;
                    args = {
                        errorMessage: e.message,
                        data: {
                            name: _this.name,
                            primaryKey: _this.primaryKey,
                            value: _this.checkValue(_this.getSendValue())
                        }
                    };
                    _this.trigger("validating", args, function(validateArgs) {
                        if (e.status === "failure") {
                            e.errorElement.innerText = validateArgs.errorMessage;
                            _this.toggleErrorClass(true);
                        } else _this.toggleErrorClass(false);
                        if (!(0, $3EnZW.isNullOrUndefined)(fromSubmit) && fromSubmit && (validationLength_1 === count_1 || e.status === "failure")) {
                            fromSubmit = false;
                            _this.afterValidation(isValidate);
                            count_1 = 0;
                        }
                    });
                },
                customPlacement: function(inputElement, errorElement) {
                    if (_this.formEle) (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$58deb822de2b8ad8, _this.formEle).appendChild(errorElement);
                }
            });
            count_1 = 0;
            this.formValidate.validate();
        } else if (this.template !== "") {
            args = {
                errorMessage: "",
                data: {
                    name: this.name,
                    primaryKey: this.primaryKey,
                    value: this.checkValue(this.getSendValue())
                }
            };
            this.trigger("validating", args, function(validateArgs) {
                if (validateArgs.errorMessage) {
                    (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$58deb822de2b8ad8, _this.formEle).innerHTML = validateArgs.errorMessage;
                    _this.toggleErrorClass(true);
                } else _this.toggleErrorClass(false);
                _this.afterValidation(isValidate);
            });
        } else this.afterValidation(isValidate);
    };
    InPlaceEditor.prototype.afterValidation = function(isValidate) {
        if (!this.formEle.classList.contains($b15746da8dc0a709$export$103bedf43ba882db) && isValidate) {
            this.loadSpinner("validate");
            if (this.mode === "Popup") this.updateArrow();
            this.sendValue();
        }
    };
    InPlaceEditor.prototype.toggleErrorClass = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(this.formEle)) return;
        var inputEle = (0, $4ZDHT.select)(".e-input-group", this.formEle);
        var errorClass = function(element, val, action) {
            [].slice.call(element).forEach(function(ele) {
                if (ele) action === "add" ? (0, $4ZDHT.addClass)([
                    ele
                ], [
                    val
                ]) : (0, $4ZDHT.removeClass)([
                    ele
                ], [
                    val
                ]);
            });
        };
        errorClass([
            this.formEle,
            inputEle
        ], $b15746da8dc0a709$export$103bedf43ba882db, value ? "add" : "remove");
    };
    InPlaceEditor.prototype.updateArrow = function() {
        var pos = this.tipObj.tipPointerPosition;
        this.tipObj.tipPointerPosition = pos === "Middle" ? "Auto" : "Middle";
        this.tipObj.tipPointerPosition = pos;
        this.tipObj.dataBind();
    };
    InPlaceEditor.prototype.triggerSuccess = function(args) {
        var _this = this;
        var val = args.value;
        this.trigger("actionSuccess", args, function(actionArgs) {
            _this.oldValue = val;
            _this.removeSpinner("submit");
            if (!actionArgs.cancel) _this.renderValue(_this.checkValue(actionArgs.value !== val ? actionArgs.value : _this.getRenderValue()));
            if (actionArgs.cancel && _this.mode === "Inline") (0, $4ZDHT.removeClass)([
                _this.valueWrap
            ], [
                $b15746da8dc0a709$export$7a302b3efb32a64b
            ]);
            _this.removeEditor();
        });
    };
    InPlaceEditor.prototype.triggerEndEdit = function(closeBeginBy) {
        var _this = this;
        var endEditArgs = {
            cancel: false,
            mode: this.mode,
            action: closeBeginBy
        };
        this.trigger("endEdit", endEditArgs, function(args) {
            if (!args.cancel) {
                if (_this.formEle && _this.formEle.classList.contains($b15746da8dc0a709$export$103bedf43ba882db)) {
                    _this.updateModelValue(true);
                    _this.setProperties({
                        value: _this.oldValue
                    }, true);
                }
                _this.removeEditor();
            }
        });
    };
    InPlaceEditor.prototype.wireEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.editableOn)) this.wireEditEvent(this.editableOn);
        (0, $aqzbR.EventHandler).add(this.editIcon, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.valueKeyDownHandler, this);
        document.addEventListener("scroll", this.onScrollResizeHandler);
        window.addEventListener("resize", this.onScrollResizeHandler);
        if (Array.prototype.indexOf.call(this.clearComponents, this.type) > -1) (0, $aqzbR.EventHandler).add(this.element, "mousedown", this.mouseDownHandler, this);
    };
    InPlaceEditor.prototype.wireDocEvent = function() {
        (0, $aqzbR.EventHandler).add(document, "mousedown", this.docClickHandler, this);
    };
    InPlaceEditor.prototype.wireEditEvent = function(event) {
        if (event === "EditIconClick") return;
        var titleConstant = event === "Click" ? "editAreaClick" : "editAreaDoubleClick";
        this.element.setAttribute("title", this.getLocale((0, $72c33a44f7d6f2bc$export$cbc139f9d9bf76f7)[event], titleConstant));
        if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos && event === "DblClick") this.touchModule = new (0, $i528u.Touch)(this.valueWrap, {
            tap: this.doubleTapHandler.bind(this)
        });
        else (0, $aqzbR.EventHandler).add(this.valueWrap, event.toLowerCase(), this.clickHandler, this);
    };
    InPlaceEditor.prototype.wireEditorKeyDownEvent = function(ele) {
        (0, $aqzbR.EventHandler).add(ele, "keydown", this.enterKeyDownHandler, this);
    };
    InPlaceEditor.prototype.wireBtnEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.submitBtn)) {
            (0, $aqzbR.EventHandler).add(this.submitBtn.element, "mousedown", this.submitHandler, this);
            (0, $aqzbR.EventHandler).add(this.submitBtn.element, "click", this.submitPrevent, this);
            (0, $aqzbR.EventHandler).add(this.submitBtn.element, "keydown", this.btnKeyDownHandler, this);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.cancelBtn)) {
            (0, $aqzbR.EventHandler).add(this.cancelBtn.element, "mousedown", this.cancelBtnClick, this);
            (0, $aqzbR.EventHandler).add(this.cancelBtn.element, "keydown", this.btnKeyDownHandler, this);
        }
    };
    InPlaceEditor.prototype.cancelBtnClick = function(e) {
        this.cancelHandler("cancel");
        this.trigger("cancelClick", e);
    };
    InPlaceEditor.prototype.unWireEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.editableOn)) this.unWireEditEvent(this.editableOn);
        (0, $aqzbR.EventHandler).remove(this.editIcon, "click", this.clickHandler);
        document.removeEventListener("scroll", this.onScrollResizeHandler);
        window.removeEventListener("resize", this.onScrollResizeHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.valueKeyDownHandler);
        if (Array.prototype.indexOf.call(this.clearComponents, this.type) > -1) (0, $aqzbR.EventHandler).remove(this.element, "mousedown", this.mouseDownHandler);
    };
    InPlaceEditor.prototype.unWireDocEvent = function() {
        (0, $aqzbR.EventHandler).remove(document, "mousedown", this.docClickHandler);
    };
    InPlaceEditor.prototype.unWireEditEvent = function(event) {
        if (event === "EditIconClick") return;
        this.element.removeAttribute("title");
        if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos && event === "DblClick") {
            this.touchModule.destroy();
            this.touchModule = undefined;
        } else (0, $aqzbR.EventHandler).remove(this.valueWrap, event.toLowerCase(), this.clickHandler);
    };
    InPlaceEditor.prototype.unWireEditorKeyDownEvent = function(ele) {
        (0, $aqzbR.EventHandler).remove(ele, "keydown", this.enterKeyDownHandler);
    };
    InPlaceEditor.prototype.submitPrevent = function(e) {
        e.preventDefault();
    };
    InPlaceEditor.prototype.btnKeyDownHandler = function(e) {
        var trg = e.target;
        if (e.keyCode === 13 && e.which === 13 || e.keyCode === 32 && e.which === 32) {
            if (trg.classList.contains($b15746da8dc0a709$export$50f3568e212d4078)) this.save();
            else if (trg.classList.contains($b15746da8dc0a709$export$2f411ae65effe84b)) this.cancelHandler("cancel");
        }
        if (e.keyCode === 9 && e.shiftKey === false && ((0, $3EnZW.isNullOrUndefined)(e.target.nextElementSibling) || e.target.nextElementSibling.tagName !== "BUTTON")) {
            if (this.actionOnBlur === "Submit") this.save();
            else if (this.actionOnBlur === "Cancel") this.cancelHandler("cancel");
        }
    };
    InPlaceEditor.prototype.afterOpenHandler = function(e) {
        if (this.mode === "Popup" && this.type === "MultiSelect") {
            (0, $aqzbR.EventHandler).add(this.containerEle, "mousedown", this.popMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.containerEle, "click", this.popClickHandler, this);
        }
        if (this.mode === "Popup" && !this.isEmpty(this.titleEle.innerHTML)) e.element.classList.add($b15746da8dc0a709$export$883e33b7441bcda7);
        if (this.type === "RTE") {
            this.rteModule.refresh();
            this.setAttribute((0, $4ZDHT.select)(".e-richtexteditor textarea", this.containerEle), [
                "name"
            ]);
        } else if (this.type === "Slider") {
            this.sliderModule.refresh();
            this.setAttribute((0, $4ZDHT.select)(".e-slider-input", this.containerEle), [
                "name"
            ]);
        }
        if (!this.beginEditArgs.cancelFocus) {
            if (this.mode === "Inline" && [
                "AutoComplete",
                "ComboBox",
                "DropDownList",
                "MultiSelect"
            ].indexOf(this.type) > -1 && this.model.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.showDropDownPopup();
            else this.setFocus();
        }
        if (this.afterOpenEvent) {
            this.tipObj.setProperties({
                afterOpen: this.afterOpenEvent
            }, true);
            this.tipObj.trigger("afterOpen", e);
        }
    };
    InPlaceEditor.prototype.popMouseDown = function(e) {
        var trgClass = e.target.classList;
        if (trgClass.contains("e-chips-close") && !trgClass.contains("e-close-hooker")) this.updateArrow();
    };
    InPlaceEditor.prototype.doubleTapHandler = function(e) {
        if (e.tapCount > 1) this.clickHandler(e.originalEvent);
    };
    InPlaceEditor.prototype.clickHandler = function(e) {
        if (this.editableOn !== "EditIconClick") e.stopPropagation();
        this.renderEditor();
    };
    InPlaceEditor.prototype.submitHandler = function(e) {
        e.preventDefault();
        this.save();
        this.trigger("submitClick", e);
    };
    InPlaceEditor.prototype.cancelHandler = function(action) {
        this.triggerEndEdit(action);
    };
    InPlaceEditor.prototype.popClickHandler = function(e) {
        var tipTarget = (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$9bbeb56dbf42510f, this.element);
        if (e.target.classList.contains("e-chips-close")) this.tipObj.refresh(tipTarget);
    };
    InPlaceEditor.prototype.successHandler = function(e) {
        this.initRender = false;
        var eventArgs = {
            data: e,
            value: this.getSendValue()
        };
        this.triggerSuccess(eventArgs);
    };
    InPlaceEditor.prototype.failureHandler = function(e) {
        var _this = this;
        var eventArgs = {
            data: e,
            value: this.getSendValue()
        };
        this.trigger("actionFailure", eventArgs, function(args) {
            _this.removeSpinner("submit");
            if (_this.mode === "Popup") _this.updateArrow();
        });
    };
    InPlaceEditor.prototype.enterKeyDownHandler = function(e) {
        if (!(0, $4ZDHT.closest)(e.target, "." + $b15746da8dc0a709$export$9ea760072c364d49 + " .e-richtexteditor") && !e.currentTarget.getElementsByTagName("textarea")[0]) {
            if (e.keyCode === 13 && e.which === 13 && (0, $4ZDHT.closest)(e.target, "." + $b15746da8dc0a709$export$9ea760072c364d49)) {
                this.save();
                this.trigger("submitClick", e);
            } else if (e.keyCode === 27 && e.which === 27) this.cancelHandler("cancel");
        }
    };
    InPlaceEditor.prototype.valueKeyDownHandler = function(e) {
        if (e.keyCode === 9 && e.shiftKey === true && e.target.tagName !== "BUTTON") {
            if (this.actionOnBlur === "Submit") this.save();
            else if (this.actionOnBlur === "Cancel") this.cancelHandler("cancel");
        }
        if (e.keyCode === 13 && e.which === 13 && e.target.classList.contains($b15746da8dc0a709$export$fbea82a1c0574ef4) && !this.valueWrap.classList.contains($b15746da8dc0a709$export$bb29a81b503a982c) && !this.element.classList.contains($b15746da8dc0a709$export$ef8adfdd925d3e83)) {
            e.preventDefault();
            this.renderEditor();
        }
    };
    InPlaceEditor.prototype.mouseDownHandler = function(e) {
        if (e.target.classList.contains("e-clear-icon")) this.isClearTarget = true;
    };
    InPlaceEditor.prototype.scrollResizeHandler = function() {
        if (this.mode === "Popup" && this.tipObj && !(0, $5q7BP.Browser).isDevice) this.triggerEndEdit("cancel");
    };
    InPlaceEditor.prototype.docClickHandler = function(e) {
        var trg = e.target;
        if (this.isClearTarget) {
            this.isClearTarget = false;
            return;
        }
        var relateRoot = (0, $4ZDHT.closest)(trg, "." + $b15746da8dc0a709$export$fbea82a1c0574ef4);
        var relateTipRoot = (0, $4ZDHT.closest)(trg, "." + $b15746da8dc0a709$export$b9fccf621889576c);
        var relateElements = (0, $4ZDHT.closest)(trg, "." + $b15746da8dc0a709$export$a6d18b072e3b7ccb);
        var relateRTEElements = (0, $4ZDHT.closest)(trg, ".e-rte-elements");
        if (!(0, $3EnZW.isNullOrUndefined)(relateRoot) && relateRoot.isEqualNode(this.element) || !(0, $3EnZW.isNullOrUndefined)(relateTipRoot) && this.tipObj && relateTipRoot.id.indexOf(this.valueWrap.id) > -1 || !(0, $3EnZW.isNullOrUndefined)(relateElements) || !(0, $3EnZW.isNullOrUndefined)(relateRTEElements) || trg.classList.contains("e-chips-close")) return;
        else {
            if (this.actionOnBlur === "Submit") this.save();
            else if (this.actionOnBlur === "Cancel") this.cancelHandler("cancel");
        }
    };
    InPlaceEditor.prototype.changeHandler = function(e) {
        var eventArgs = {
            previousValue: this.compPrevValue === undefined ? this.value : this.compPrevValue,
            value: e.value
        };
        if (this.type === "AutoComplete" || this.type === "ComboBox" || this.type === "DropDownList") {
            eventArgs.itemData = e.itemData;
            eventArgs.previousItemData = e.previousItemData;
        }
        this.compPrevValue = eventArgs.value;
        this.trigger("change", eventArgs);
    };
    /**
     * Validate current editor value.
     *
     * @returns {void}
     */ InPlaceEditor.prototype.validate = function() {
        this.checkValidation(true, false);
    };
    /**
     * Submit the edited input value to the server.
     *
     * @returns {void}
     */ InPlaceEditor.prototype.save = function() {
        var _this = this;
        if (!this.formEle) return;
        this.element.focus();
        this.editEle = (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$9ea760072c364d49, this.formEle);
        var errEle = null;
        errEle = (0, $4ZDHT.select)("." + $b15746da8dc0a709$export$103bedf43ba882db, this.editEle);
        if (!this.isTemplate) this.setValue();
        var endEditArgs = {
            cancel: false,
            mode: this.mode,
            action: "submit"
        };
        this.trigger("endEdit", endEditArgs, function(args) {
            if (!args.cancel) _this.checkValidation(true, true);
        });
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */ InPlaceEditor.prototype.destroy = function() {
        var _this = this;
        this.removeEditor((0, $3EnZW.isBlazor)());
        if (this.isExtModule) this.notify($40348da204e6a693$export$b1fb4cac938035f7, {});
        this.unWireEvents();
        var classList = [
            $b15746da8dc0a709$export$ef8adfdd925d3e83,
            $b15746da8dc0a709$export$850f7749a2909601
        ];
        classList.forEach(function(val) {
            (0, $4ZDHT.removeClass)([
                _this.element
            ], [
                val
            ]);
        });
        while(this.element.firstElementChild)this.element.removeChild(this.element.firstElementChild);
        if (!((0, $3EnZW.isBlazor)() && this.isServerRendered)) _super.prototype.destroy.call(this);
        if (this.isReact) this.clearTemplate();
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - returns the string
     */ InPlaceEditor.prototype.getPersistData = function() {
        return this.addOnPersist([
            "value"
        ]);
    };
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} - returns the module declaration
     * @hidden
     */ InPlaceEditor.prototype.requiredModules = function() {
        var modules = [];
        if (Array.prototype.indexOf.call(this.moduleList, this.type) > -1) modules.push({
            member: (0, $72c33a44f7d6f2bc$export$5e4dd3837967b63b)[this.type],
            args: [
                this
            ]
        });
        return modules;
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - returrns the string
     * @private
     */ InPlaceEditor.prototype.getModuleName = function() {
        return "inplaceeditor";
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of property that changed.
     *
     * @param  {InPlaceEditorModel} newProp - specifies the new property
     * @param  {InPlaceEditorModel} oldProp - specifies the old property
     * @returns {void}
     * @private
     */ InPlaceEditor.prototype.onPropertyChanged = function(newProp, oldProp) {
        var checkValidation = this.validationRules ? !(0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll("." + $b15746da8dc0a709$export$103bedf43ba882db)) && this.element.querySelectorAll("." + $b15746da8dc0a709$export$103bedf43ba882db).length > 0 ? false : true : true;
        if (checkValidation) {
            if (this.isEditorOpen()) {
                var editModeChanged = "enableEditMode" in newProp;
                if (editModeChanged && oldProp.enableEditMode && !newProp.enableEditMode || !editModeChanged && this.enableEditMode) this.triggerEndEdit("cancel");
                else this.removeEditor();
            }
            for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
                var prop = _a[_i];
                switch(prop){
                    case "showButtons":
                        newProp.showButtons ? this.appendButtons(this.formEle) : this.destroyButtons();
                        break;
                    case "value":
                        this.updateValue();
                        this.textOption === "Never" ? this.renderValue(this.checkValue((0, $d5eca6dd2d68c3de$export$5303528d1070ff6f)(this.type, this.value, this.model))) : this.renderInitialValue();
                        break;
                    case "emptyText":
                        this.textOption === "Never" ? this.renderValue(this.checkValue((0, $d5eca6dd2d68c3de$export$5303528d1070ff6f)(this.type, this.value, this.model))) : this.renderInitialValue();
                        break;
                    case "template":
                        this.checkIsTemplate();
                        break;
                    case "disabled":
                        this.disable(newProp.disabled);
                        newProp.disabled ? this.element.tabIndex = -1 : this.element.tabIndex = 0;
                        break;
                    case "enableRtl":
                        this.setRtl(newProp.enableRtl);
                        break;
                    case "cssClass":
                        this.setClass("remove", oldProp.cssClass);
                        this.setClass("add", newProp.cssClass);
                        break;
                    case "mode":
                        this.enableEditor(this.enableEditMode);
                        break;
                    case "enableEditMode":
                        this.enableEditor(newProp.enableEditMode);
                        break;
                    case "editableOn":
                        this.unWireEditEvent(oldProp.editableOn);
                        if (newProp.editableOn !== "EditIconClick") this.wireEditEvent(newProp.editableOn);
                        break;
                }
            }
        }
    };
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("")
    ], InPlaceEditor.prototype, "name", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], InPlaceEditor.prototype, "value", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("")
    ], InPlaceEditor.prototype, "template", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], InPlaceEditor.prototype, "enableHtmlSanitizer", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], InPlaceEditor.prototype, "enableHtmlParse", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("")
    ], InPlaceEditor.prototype, "cssClass", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("")
    ], InPlaceEditor.prototype, "primaryKey", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Empty")
    ], InPlaceEditor.prototype, "emptyText", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("")
    ], InPlaceEditor.prototype, "url", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Popup")
    ], InPlaceEditor.prototype, "mode", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("UrlAdaptor")
    ], InPlaceEditor.prototype, "adaptor", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Text")
    ], InPlaceEditor.prototype, "type", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Click")
    ], InPlaceEditor.prototype, "editableOn", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], InPlaceEditor.prototype, "textOption", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)("Submit")
    ], InPlaceEditor.prototype, "actionOnBlur", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], InPlaceEditor.prototype, "enablePersistence", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], InPlaceEditor.prototype, "disabled", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], InPlaceEditor.prototype, "showButtons", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], InPlaceEditor.prototype, "enableEditMode", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], InPlaceEditor.prototype, "submitOnEnter", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $72c33a44f7d6f2bc$export$3193c38af1d734b))
    ], InPlaceEditor.prototype, "popupSettings", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], InPlaceEditor.prototype, "model", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)({
            iconCss: "e-icons e-save-icon"
        })
    ], InPlaceEditor.prototype, "saveButton", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)({
            iconCss: "e-icons e-cancel-icon"
        })
    ], InPlaceEditor.prototype, "cancelButton", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], InPlaceEditor.prototype, "validationRules", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "created", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "beforeSanitizeHtml", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "actionBegin", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "actionSuccess", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "actionFailure", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "validating", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "beginEdit", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "endEdit", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "change", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "submitClick", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "cancelClick", void 0);
    $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.Event)()
    ], InPlaceEditor.prototype, "destroyed", void 0);
    InPlaceEditor = $6c3b84be4fdf3a18$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], InPlaceEditor);
    return InPlaceEditor;
}((0, $hQxLN.Component));

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");


var $49u5W = parcelRequire("49u5W");
var $2vAqh = parcelRequire("2vAqh");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");


/**
 * FloatLable Moduel
 * Specifies whether to display the floating label above the input element.
 */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $805d2bf384e771bd$var$FLOATLINE = "e-float-line";
var $805d2bf384e771bd$var$FLOATTEXT = "e-float-text";
var $805d2bf384e771bd$var$LABELTOP = "e-label-top";
var $805d2bf384e771bd$var$LABELBOTTOM = "e-label-bottom";
function $805d2bf384e771bd$export$39117a5c98660d83(overAllWrapper, searchWrapper, element, inputElement, value, floatLabelType, placeholder) {
    var floatLinelement = (0, $4ZDHT.createElement)("span", {
        className: $805d2bf384e771bd$var$FLOATLINE
    });
    var floatLabelElement = (0, $4ZDHT.createElement)("label", {
        className: $805d2bf384e771bd$var$FLOATTEXT
    });
    var id = element.getAttribute("id") ? element.getAttribute("id") : (0, $3EnZW.getUniqueID)("ej2_multiselect");
    element.id = id;
    if (!(0, $3EnZW.isNullOrUndefined)(element.id) && element.id !== "") {
        floatLabelElement.id = "label_" + element.id.replace(/ /g, "_");
        floatLabelElement.setAttribute("for", element.id);
        (0, $4ZDHT.attributes)(inputElement, {
            "aria-labelledby": floatLabelElement.id
        });
    }
    if (!(0, $3EnZW.isNullOrUndefined)(inputElement.placeholder) && inputElement.placeholder !== "") {
        floatLabelElement.innerText = $805d2bf384e771bd$export$65d5c6c8b7a6e5d7(inputElement.placeholder);
        inputElement.removeAttribute("placeholder");
    }
    floatLabelElement.innerText = $805d2bf384e771bd$export$65d5c6c8b7a6e5d7(placeholder);
    searchWrapper.appendChild(floatLinelement);
    searchWrapper.appendChild(floatLabelElement);
    overAllWrapper.classList.add("e-float-input");
    $805d2bf384e771bd$export$e8497549f565dd64(value, floatLabelElement);
    if (floatLabelType === "Always") {
        if (floatLabelElement.classList.contains($805d2bf384e771bd$var$LABELBOTTOM)) (0, $4ZDHT.removeClass)([
            floatLabelElement
        ], $805d2bf384e771bd$var$LABELBOTTOM);
        (0, $4ZDHT.addClass)([
            floatLabelElement
        ], $805d2bf384e771bd$var$LABELTOP);
    }
}
function $805d2bf384e771bd$export$e8497549f565dd64(value, label) {
    if (value && value.length > 0) {
        (0, $4ZDHT.addClass)([
            label
        ], $805d2bf384e771bd$var$LABELTOP);
        (0, $4ZDHT.removeClass)([
            label
        ], $805d2bf384e771bd$var$LABELBOTTOM);
    } else {
        (0, $4ZDHT.removeClass)([
            label
        ], $805d2bf384e771bd$var$LABELTOP);
        (0, $4ZDHT.addClass)([
            label
        ], $805d2bf384e771bd$var$LABELBOTTOM);
    }
}
function $805d2bf384e771bd$export$28e15b1a5c8da10e(overAllWrapper, componentWrapper, searchWrapper, inputElement, value, floatLabelType, placeholder) {
    var placeholderElement = componentWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATTEXT);
    var floatLine = componentWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATLINE);
    var placeholderText;
    if (!(0, $3EnZW.isNullOrUndefined)(placeholderElement)) {
        placeholderText = placeholderElement.innerText;
        (0, $4ZDHT.detach)(searchWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATTEXT));
        $805d2bf384e771bd$export$d0caf6b4fc3d0f63(value, inputElement, placeholderText);
        if (!(0, $3EnZW.isNullOrUndefined)(floatLine)) (0, $4ZDHT.detach)(searchWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATLINE));
    } else {
        placeholderText = placeholder !== null ? placeholder : "";
        $805d2bf384e771bd$export$d0caf6b4fc3d0f63(value, inputElement, placeholderText);
    }
    overAllWrapper.classList.remove("e-float-input");
}
function $805d2bf384e771bd$export$d0caf6b4fc3d0f63(value, inputElement, placeholder) {
    if (value && value.length) inputElement.placeholder = "";
    else inputElement.placeholder = placeholder;
}
function $805d2bf384e771bd$export$18f5ba2d232c99b5(overAllWrapper, componentWrapper) {
    overAllWrapper.classList.add("e-input-focus");
    var label = componentWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATTEXT);
    if (!(0, $3EnZW.isNullOrUndefined)(label)) {
        (0, $4ZDHT.addClass)([
            label
        ], $805d2bf384e771bd$var$LABELTOP);
        if (label.classList.contains($805d2bf384e771bd$var$LABELBOTTOM)) (0, $4ZDHT.removeClass)([
            label
        ], $805d2bf384e771bd$var$LABELBOTTOM);
    }
}
function $805d2bf384e771bd$export$f1eeb56039ab052a(overAllWrapper, componentWrapper, value, floatLabelType, placeholder) {
    /* eslint-enable @typescript-eslint/no-unused-vars */ overAllWrapper.classList.remove("e-input-focus");
    var label = componentWrapper.querySelector("." + $805d2bf384e771bd$var$FLOATTEXT);
    if (value && value.length <= 0 && floatLabelType === "Auto" && !(0, $3EnZW.isNullOrUndefined)(label)) {
        if (label.classList.contains($805d2bf384e771bd$var$LABELTOP)) (0, $4ZDHT.removeClass)([
            label
        ], $805d2bf384e771bd$var$LABELTOP);
        (0, $4ZDHT.addClass)([
            label
        ], $805d2bf384e771bd$var$LABELBOTTOM);
    }
}
function $805d2bf384e771bd$export$65d5c6c8b7a6e5d7(placeholder) {
    var result = "";
    if (!(0, $3EnZW.isNullOrUndefined)(placeholder) && placeholder !== "") {
        var spanElement = document.createElement("span");
        spanElement.innerHTML = '<input  placeholder="' + placeholder + '"/>';
        var hiddenInput = spanElement.children[0];
        result = hiddenInput.placeholder;
    }
    return result;
} /* eslint-enable valid-jsdoc */ 


var $717505a12e9203b8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $717505a12e9203b8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $717505a12e9203b8$var$FOCUS = "e-input-focus";
var $717505a12e9203b8$var$DISABLED = "e-disabled";
var $717505a12e9203b8$var$OVER_ALL_WRAPPER = "e-multiselect e-input-group e-control-wrapper";
var $717505a12e9203b8$var$ELEMENT_WRAPPER = "e-multi-select-wrapper";
var $717505a12e9203b8$var$ELEMENT_MOBILE_WRAPPER = "e-mob-wrapper";
var $717505a12e9203b8$var$HIDE_LIST = "e-hide-listitem";
var $717505a12e9203b8$var$DELIMITER_VIEW = "e-delim-view";
var $717505a12e9203b8$var$CHIP_WRAPPER = "e-chips-collection";
var $717505a12e9203b8$var$CHIP = "e-chips";
var $717505a12e9203b8$var$CHIP_CONTENT = "e-chipcontent";
var $717505a12e9203b8$var$CHIP_CLOSE = "e-chips-close";
var $717505a12e9203b8$var$CHIP_SELECTED = "e-chip-selected";
var $717505a12e9203b8$var$SEARCHBOX_WRAPPER = "e-searcher";
var $717505a12e9203b8$var$DELIMITER_VIEW_WRAPPER = "e-delimiter";
var $717505a12e9203b8$var$ZERO_SIZE = "e-zero-size";
var $717505a12e9203b8$var$REMAIN_WRAPPER = "e-remain";
var $717505a12e9203b8$var$CLOSEICON_CLASS = "e-chips-close e-close-hooker";
var $717505a12e9203b8$var$DELIMITER_WRAPPER = "e-delim-values";
var $717505a12e9203b8$var$POPUP_WRAPPER = "e-ddl e-popup e-multi-select-list-wrapper";
var $717505a12e9203b8$var$INPUT_ELEMENT = "e-dropdownbase";
var $717505a12e9203b8$var$RTL_CLASS = "e-rtl";
var $717505a12e9203b8$var$CLOSE_ICON_HIDE = "e-close-icon-hide";
var $717505a12e9203b8$var$MOBILE_CHIP = "e-mob-chip";
var $717505a12e9203b8$var$FOOTER = "e-ddl-footer";
var $717505a12e9203b8$var$HEADER = "e-ddl-header";
var $717505a12e9203b8$var$DISABLE_ICON = "e-ddl-disable-icon";
var $717505a12e9203b8$var$SPINNER_CLASS = "e-ms-spinner-icon";
var $717505a12e9203b8$var$HIDDEN_ELEMENT = "e-multi-hidden";
var $717505a12e9203b8$var$destroy = "destroy";
var $717505a12e9203b8$var$dropdownIcon = "e-input-group-icon e-ddl-icon";
var $717505a12e9203b8$var$iconAnimation = "e-icon-anim";
var $717505a12e9203b8$var$TOTAL_COUNT_WRAPPER = "e-delim-total";
var $717505a12e9203b8$var$BOX_ELEMENT = "e-multiselect-box";
var $717505a12e9203b8$var$FILTERPARENT = "e-filter-parent";
var $717505a12e9203b8$var$CUSTOM_WIDTH = "e-search-custom-width";
var $717505a12e9203b8$var$FILTERINPUT = "e-input-filter";
/**
 * The Multiselect allows the user to pick a more than one value from list of predefined values.
 * ```html
 * <select id="list">
 *      <option value='1'>Badminton</option>
 *      <option value='2'>Basketball</option>
 *      <option value='3'>Cricket</option>
 *      <option value='4'>Football</option>
 *      <option value='5'>Tennis</option>
 * </select>
 * ```
 * ```typescript
 * <script>
 *   var multiselectObj = new Multiselect();
 *   multiselectObj.appendTo("#list");
 * </script>
 * ```
 */ var $717505a12e9203b8$export$1e7dfd31545b5809 = /** @class */ function(_super) {
    $717505a12e9203b8$var$__extends(MultiSelect, _super);
    /**
     * Constructor for creating the DropDownList widget.
     *
     * @param {MultiSelectModel} option - Specifies the MultiSelect model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function MultiSelect(option, element) {
        var _this = _super.call(this, option, element) || this;
        _this.clearIconWidth = 0;
        _this.previousFilterText = "";
        _this.isValidKey = false;
        _this.selectAllEventData = [];
        _this.selectAllEventEle = [];
        _this.resetMainList = null;
        _this.resetFilteredData = false;
        _this.preventSetCurrentData = false;
        _this.isSelectAllLoop = false;
        _this.scrollFocusStatus = false;
        _this.keyDownStatus = false;
        return _this;
    }
    MultiSelect.prototype.enableRTL = function(state) {
        if (state) this.overAllWrapper.classList.add($717505a12e9203b8$var$RTL_CLASS);
        else this.overAllWrapper.classList.remove($717505a12e9203b8$var$RTL_CLASS);
        if (this.popupObj) {
            this.popupObj.enableRtl = state;
            this.popupObj.dataBind();
        }
    };
    MultiSelect.prototype.requiredModules = function() {
        var modules = [];
        if (this.enableVirtualization) modules.push({
            args: [
                this
            ],
            member: "VirtualScroll"
        });
        if (this.mode === "CheckBox") {
            this.isGroupChecking = this.enableGroupCheckBox;
            if (this.enableGroupCheckBox) {
                var prevOnChange = this.isProtectedOnChange;
                this.isProtectedOnChange = true;
                this.enableSelectionOrder = false;
                this.isProtectedOnChange = prevOnChange;
            }
            this.allowCustomValue = false;
            this.hideSelectedItem = false;
            this.closePopupOnSelect = false;
            modules.push({
                member: "CheckBoxSelection",
                args: [
                    this
                ]
            });
        }
        return modules;
    };
    MultiSelect.prototype.updateHTMLAttribute = function() {
        if (Object.keys(this.htmlAttributes).length) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var htmlAttr = _a[_i];
            switch(htmlAttr){
                case "class":
                    var updatedClassValue = this.htmlAttributes["" + htmlAttr].replace(/\s+/g, " ").trim();
                    if (updatedClassValue !== "") {
                        (0, $4ZDHT.addClass)([
                            this.overAllWrapper
                        ], updatedClassValue.split(" "));
                        (0, $4ZDHT.addClass)([
                            this.popupWrapper
                        ], updatedClassValue.split(" "));
                    }
                    break;
                case "disabled":
                    this.enable(false);
                    break;
                case "placeholder":
                    if (!this.placeholder) {
                        this.inputElement.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                        this.setProperties({
                            placeholder: this.inputElement.placeholder
                        }, true);
                        this.refreshPlaceHolder();
                    }
                    break;
                default:
                    var defaultAttr = [
                        "id"
                    ];
                    var validateAttr = [
                        "name",
                        "required",
                        "aria-required",
                        "form"
                    ];
                    var containerAttr = [
                        "title",
                        "role",
                        "style",
                        "class"
                    ];
                    if (defaultAttr.indexOf(htmlAttr) > -1) this.element.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                    else if (htmlAttr.indexOf("data") === 0 || validateAttr.indexOf(htmlAttr) > -1) this.hiddenElement.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                    else if (containerAttr.indexOf(htmlAttr) > -1) this.overAllWrapper.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                    else if (htmlAttr !== "size" && !(0, $3EnZW.isNullOrUndefined)(this.inputElement)) this.inputElement.setAttribute(htmlAttr, this.htmlAttributes["" + htmlAttr]);
                    break;
            }
        }
    };
    MultiSelect.prototype.updateReadonly = function(state) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) {
            if (state || this.mode === "CheckBox") this.inputElement.setAttribute("readonly", "true");
            else this.inputElement.removeAttribute("readonly");
        }
    };
    MultiSelect.prototype.updateClearButton = function(state) {
        if (state) {
            if (this.overAllClear.parentNode) this.overAllClear.style.display = "";
            else this.componentWrapper.appendChild(this.overAllClear);
            this.componentWrapper.classList.remove($717505a12e9203b8$var$CLOSE_ICON_HIDE);
        } else {
            this.overAllClear.style.display = "none";
            this.componentWrapper.classList.add($717505a12e9203b8$var$CLOSE_ICON_HIDE);
        }
    };
    MultiSelect.prototype.updateCssClass = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") {
            var updatedCssClassValues = this.cssClass;
            updatedCssClassValues = this.cssClass.replace(/\s+/g, " ").trim();
            if (updatedCssClassValues !== "") {
                (0, $4ZDHT.addClass)([
                    this.overAllWrapper
                ], updatedCssClassValues.split(" "));
                (0, $4ZDHT.addClass)([
                    this.popupWrapper
                ], updatedCssClassValues.split(" "));
            }
        }
    };
    MultiSelect.prototype.updateOldPropCssClass = function(oldClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass) && oldClass !== "") {
            oldClass = oldClass.replace(/\s+/g, " ").trim();
            if (oldClass !== "") {
                (0, $4ZDHT.removeClass)([
                    this.overAllWrapper
                ], oldClass.split(" "));
                (0, $4ZDHT.removeClass)([
                    this.popupWrapper
                ], oldClass.split(" "));
            }
        }
    };
    MultiSelect.prototype.onPopupShown = function(e) {
        var _this = this;
        if ((0, $5q7BP.Browser).isDevice && this.mode === "CheckBox" && this.allowFiltering) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var proxy_1 = this;
            window.onpopstate = function() {
                proxy_1.hidePopup();
                proxy_1.inputElement.focus();
            };
            history.pushState({}, "");
        }
        var animModel = {
            name: "FadeIn",
            duration: 100
        };
        var eventArgs = {
            popup: this.popupObj,
            event: e,
            cancel: false,
            animation: animModel
        };
        this.trigger("open", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel) {
                _this.focusAtFirstListItem();
                if (_this.popupObj) document.body.appendChild(_this.popupObj.element);
                if (_this.mode === "CheckBox" && _this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(_this.fields.groupBy)) _this.updateListItems(_this.list.querySelectorAll("li.e-list-item"), _this.mainList.querySelectorAll("li.e-list-item"));
                if (_this.mode === "CheckBox" || _this.showDropDownIcon) (0, $4ZDHT.addClass)([
                    _this.overAllWrapper
                ], [
                    $717505a12e9203b8$var$iconAnimation
                ]);
                _this.refreshPopup();
                _this.renderReactTemplates();
                if (_this.popupObj) _this.popupObj.show(eventArgs.animation, _this.zIndex === 1000 ? _this.element : null);
                (0, $4ZDHT.attributes)(_this.inputElement, {
                    "aria-expanded": "true",
                    "aria-owns": _this.element.id + "_popup",
                    "aria-controls": _this.element.id
                });
                _this.updateAriaActiveDescendant();
                if (_this.isFirstClick) {
                    if (!_this.enableVirtualization) _this.loadTemplate();
                }
                if (_this.mode === "CheckBox" && _this.showSelectAll) (0, $aqzbR.EventHandler).add(_this.popupObj.element, "click", _this.clickHandler, _this);
            }
        });
    };
    MultiSelect.prototype.updateVirtualReOrderList = function(isCheckBoxUpdate) {
        var query = this.getForQuery(this.value, true).clone();
        if (this.enableVirtualization && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.resetList(this.selectedListData, this.fields, query);
        else this.resetList(this.dataSource, this.fields, query);
        this.UpdateSkeleton();
        this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        this.virtualItemCount = this.itemCount;
        if (this.mode !== "CheckBox") this.totalItemCount = this.value && this.value.length ? this.totalItemCount - this.value.length : this.totalItemCount;
        if (!this.list.querySelector(".e-virtual-ddl")) {
            var virualElement = this.createElement("div", {
                id: this.element.id + "_popup",
                className: "e-virtual-ddl",
                styles: this.GetVirtualTrackHeight()
            });
            this.popupWrapper.querySelector(".e-dropdownbase").appendChild(virualElement);
        } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
        if (this.list.querySelector(".e-virtual-ddl-content")) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
        if (isCheckBoxUpdate) this.loadTemplate();
    };
    MultiSelect.prototype.updateListItems = function(listItems, mainListItems) {
        for(var i = 0; i < listItems.length; i++){
            this.findGroupStart(listItems[i]);
            this.findGroupStart(mainListItems[i]);
        }
        this.deselectHeader();
    };
    MultiSelect.prototype.loadTemplate = function() {
        this.refreshListItems(null);
        if (this.enableVirtualization && this.list && this.mode === "CheckBox") {
            var reOrderList = this.list.querySelectorAll(".e-reorder")[0];
            if (this.list.querySelector(".e-virtual-ddl-content") && reOrderList) this.list.querySelector(".e-virtual-ddl-content").removeChild(reOrderList);
        }
        if (this.mode === "CheckBox") this.removeFocus();
        this.notify("reOrder", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            e: this
        });
        this.isPreventScrollAction = true;
    };
    MultiSelect.prototype.setScrollPosition = function() {
        if ((!this.hideSelectedItem && this.mode !== "CheckBox" || this.mode === "CheckBox" && !this.enableSelectionOrder) && !(0, $3EnZW.isNullOrUndefined)(this.value) && this.value.length > 0) {
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[this.value.length - 1]) : this.value[this.value.length - 1];
            var valueEle = this.findListElement(this.hideSelectedItem ? this.ulElement : this.list, "li", "data-value", value);
            if (!(0, $3EnZW.isNullOrUndefined)(valueEle)) this.scrollBottom(valueEle);
        }
        if (this.enableVirtualization) {
            var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            this.isKeyBoardAction = false;
            this.scrollBottom(focusedItem);
        }
    };
    MultiSelect.prototype.focusAtFirstListItem = function() {
        if (this.ulElement && this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li)) {
            var element = void 0;
            if (this.mode === "CheckBox") {
                this.removeFocus();
                return;
            } else {
                if (this.enableVirtualization) {
                    if (this.fields.disabled) element = this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-virtual-list)" + ":not(.e-hide-listitem)" + ":not(." + $717505a12e9203b8$var$DISABLED + ")");
                    else element = this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-virtual-list)" + ":not(.e-hide-listitem)");
                } else if (this.fields.disabled) element = this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(." + $717505a12e9203b8$var$DISABLED + ")");
                else element = this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")");
            }
            if (element !== null) {
                this.removeFocus();
                this.addListFocus(element);
            }
        }
    };
    MultiSelect.prototype.focusAtLastListItem = function(data) {
        var activeElement;
        if (data) activeElement = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(data, this.liCollections, "StartsWith", this.ignoreCase);
        else if (this.value && this.value.length) {
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[this.value.length - 1]) : this.value[this.value.length - 1];
            (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(value, this.liCollections, "StartsWith", this.ignoreCase);
        } else activeElement = null;
        if (activeElement && activeElement.item !== null) {
            this.addListFocus(activeElement.item);
            if ((this.allowCustomValue || this.allowFiltering) && this.isPopupOpen() && this.closePopupOnSelect && !this.enableVirtualization || this.closePopupOnSelect && !this.enableVirtualization) this.scrollBottom(activeElement.item, activeElement.index);
        }
    };
    MultiSelect.prototype.getAriaAttributes = function() {
        var ariaAttributes = {
            "aria-disabled": "false",
            "role": "combobox",
            "aria-expanded": "false"
        };
        return ariaAttributes;
    };
    MultiSelect.prototype.updateListARIA = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement)) (0, $4ZDHT.attributes)(this.ulElement, {
            "id": this.element.id + "_options",
            "role": "listbox",
            "aria-hidden": "false",
            "aria-label": "list"
        });
        var disableStatus = !(0, $3EnZW.isNullOrUndefined)(this.inputElement) && this.inputElement.disabled ? true : false;
        if (!this.isPopupOpen() && !(0, $3EnZW.isNullOrUndefined)(this.inputElement)) (0, $4ZDHT.attributes)(this.inputElement, this.getAriaAttributes());
        if (disableStatus) (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-disabled": "true"
        });
        this.ensureAriaDisabled(disableStatus ? "true" : "false");
    };
    MultiSelect.prototype.ensureAriaDisabled = function(status) {
        if (this.htmlAttributes && this.htmlAttributes["aria-disabled"]) {
            var attr = this.htmlAttributes;
            (0, $3EnZW.extend)(attr, {
                "aria-disabled": status
            }, attr);
            this.setProperties({
                htmlAttributes: attr
            }, true);
        }
    };
    MultiSelect.prototype.removelastSelection = function(e) {
        var selectedElem = this.chipCollectionWrapper.querySelector("span." + $717505a12e9203b8$var$CHIP_SELECTED);
        if (selectedElem !== null) {
            this.removeSelectedChip(e);
            return;
        }
        var elements = this.chipCollectionWrapper.querySelectorAll("span." + $717505a12e9203b8$var$CHIP);
        var value = elements[elements.length - 1].getAttribute("data-value");
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) this.tempValues = this.allowObjectBinding ? this.value.slice() : this.value.slice();
        var customValue = this.allowObjectBinding ? this.getDataByValue(this.getFormattedValue(value)) : this.getFormattedValue(value);
        if (this.allowCustomValue && (value !== "false" && customValue === false || !(0, $3EnZW.isNullOrUndefined)(customValue) && customValue.toString() === "NaN")) customValue = value;
        this.removeValue(customValue, e);
        this.removeChipSelection();
        this.updateDelimeter(this.delimiterChar, e);
        this.makeTextBoxEmpty();
        if (this.mainList && this.listData) this.refreshSelection();
        this.checkPlaceholderSize();
    };
    MultiSelect.prototype.onActionFailure = function(e) {
        _super.prototype.onActionFailure.call(this, e);
        this.renderPopup();
        this.onPopupShown();
    };
    MultiSelect.prototype.targetElement = function() {
        this.targetInputElement = this.inputElement;
        if (this.mode === "CheckBox" && this.allowFiltering) this.notify("targetElement", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox"
        });
        return this.targetInputElement.value;
    };
    MultiSelect.prototype.getForQuery = function(valuecheck, isCheckbox) {
        var predicate;
        var field = (0, $3EnZW.isNullOrUndefined)(this.fields.value) ? this.fields.text : this.fields.value;
        if (this.enableVirtualization && valuecheck) {
            if (isCheckbox) {
                for(var i = 0; i < valuecheck.length; i++){
                    var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", valuecheck[i]) : valuecheck[i];
                    if (i === 0) predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, "equal", value);
                    else predicate = predicate.or(field, "equal", value);
                }
                return new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate);
            } else {
                for(var i = 0; i < valuecheck.length; i++){
                    var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", valuecheck[i]) : valuecheck[i];
                    if (i === 0) predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, "notequal", value);
                    else predicate = predicate.and(field, "notequal", value);
                }
                return new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate);
            }
        } else {
            for(var i = 0; i < valuecheck.length; i++)if (i === 0) predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(field, "equal", valuecheck[i]);
            else predicate = predicate.or(field, "equal", valuecheck[i]);
        }
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.dataSource.adaptor instanceof (0, $e1170102ff02b3b7$export$650eb66a1d9d6599)) return new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate);
        else return this.getQuery(this.query).clone().where(predicate);
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ MultiSelect.prototype.onActionComplete = function(ulElement, list, e, isUpdated) {
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)(e) && !this.virtualGroupDataSource) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = e.count;
        /* eslint-enable @typescript-eslint/no-unused-vars */ _super.prototype.onActionComplete.call(this, ulElement, list, e);
        this.skeletonCount = this.totalItemCount !== 0 && this.totalItemCount < this.itemCount * 2 && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.totalItemCount <= this.itemCount) ? 0 : this.skeletonCount;
        this.updateSelectElementData(this.allowFiltering);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && !this.allowCustomValue && !this.enableVirtualization && this.listData && this.listData.length > 0) for(var i = 0; i < this.value.length; i++){
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", proxy.value[i]) : proxy.value[i];
            var checkEle = this.findListElement(this.allowFiltering && !(0, $3EnZW.isNullOrUndefined)(this.mainList) ? this.mainList : ulElement, "li", "data-value", value);
            if (!checkEle && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
                this.value.splice(i, 1);
                i -= 1;
            }
        }
        var valuecheck = [];
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) valuecheck = this.presentItemValue(this.ulElement);
        if (valuecheck.length > 0 && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)(this.value) && this.listData != null && !this.enableVirtualization) this.addNonPresentItems(valuecheck, this.ulElement, this.listData);
        else this.updateActionList(ulElement, list, e);
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.allowCustomValue && !this.isCustomRendered && this.inputElement.value && this.inputElement.value !== "") {
            var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
            query = this.allowFiltering ? query.where(this.fields.text, "startswith", this.inputElement.value, this.ignoreCase, this.ignoreAccent) : query;
            this.checkForCustomValue(query, this.fields);
            this.isCustomRendered = true;
            this.remoteCustomValue = this.enableVirtualization ? false : this.remoteCustomValue;
        }
        if (this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy) && !(0, $3EnZW.isNullOrUndefined)(this.fields.disabled)) this.disableGroupHeader();
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.mode === "CheckBox" && this.allowFiltering) this.removeFocus();
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ MultiSelect.prototype.updateActionList = function(ulElement, list, e, isUpdated) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ if (this.mode === "CheckBox" && this.showSelectAll) this.notify("selectAll", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox"
        });
        if (!this.mainList && !this.mainData) {
            this.mainList = ulElement.cloneNode ? ulElement.cloneNode(true) : ulElement;
            this.mainData = list;
            this.mainListCollection = this.liCollections;
        } else if ((0, $3EnZW.isNullOrUndefined)(this.mainData) || this.mainData.length === 0) this.mainData = list;
        if ((this.remoteCustomValue || list.length <= 0) && this.allowCustomValue && this.inputFocus && this.allowFiltering && this.inputElement.value && this.inputElement.value !== "") {
            this.checkForCustomValue(this.tempQuery, this.fields);
            if (this.isCustomRendered) return;
        }
        if (this.value && this.value.length && (this.mode !== "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.inputElement) && this.inputElement.value.trim() !== "" || this.mode === "CheckBox" || (this.keyCode === 8 || this.keyCode === 46) && this.allowFiltering && this.allowCustomValue && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.inputElement.value === "")) this.refreshSelection();
        this.updateListARIA();
        this.unwireListEvents();
        this.wireListEvents();
        if (!(0, $3EnZW.isNullOrUndefined)(this.setInitialValue)) this.setInitialValue();
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectAllAction)) this.selectAllAction();
        if (this.setDynValue) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.text) && ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0)) this.initialTextUpdate();
            if (!this.enableVirtualization || this.enableVirtualization && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) this.initialValueUpdate();
            this.initialUpdate();
            this.refreshPlaceHolder();
            if (this.mode !== "CheckBox" && this.changeOnBlur) this.updateValueState(null, this.value, null);
        }
        this.renderPopup();
        if (this.beforePopupOpen) {
            this.beforePopupOpen = false;
            this.onPopupShown(e);
        }
    };
    MultiSelect.prototype.refreshSelection = function() {
        var value;
        var element;
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) for(var index = 0; !(0, $3EnZW.isNullOrUndefined)(this.value[index]); index++){
            value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[index]) : this.value[index];
            element = this.findListElement(this.list, "li", "data-value", value);
            if (element) {
                (0, $4ZDHT.addClass)([
                    element
                ], className);
                if (this.hideSelectedItem && element.previousSibling && element.previousElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group) && (!element.nextElementSibling || element.nextElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group))) (0, $4ZDHT.addClass)([
                    element.previousElementSibling
                ], className);
                if (this.hideSelectedItem && this.fields.groupBy && !element.previousElementSibling.classList.contains($717505a12e9203b8$var$HIDE_LIST)) this.hideGroupItem(value);
                if (this.hideSelectedItem && element.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus)) {
                    (0, $4ZDHT.removeClass)([
                        element
                    ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
                    var listEle = element.parentElement.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")");
                    if (listEle.length > 0) {
                        (0, $4ZDHT.addClass)([
                            listEle[0]
                        ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
                        this.updateAriaActiveDescendant();
                    } else //EJ2-57588 - for this task, we prevent the ul element cloning ( this.ulElement = this.ulElement.cloneNode ? <HTMLElement>this.ulElement.cloneNode(true) : this.ulElement;)
                    if (!(this.list && this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li).length > 0)) {
                        this.l10nUpdate();
                        (0, $4ZDHT.addClass)([
                            this.list
                        ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData);
                    }
                }
                element.setAttribute("aria-selected", "true");
                if (this.mode === "CheckBox" && element.classList.contains("e-active")) {
                    var ariaValue = element.getElementsByClassName("e-check").length;
                    if (ariaValue === 0) {
                        var args = {
                            module: "CheckBoxSelection",
                            enable: this.mode === "CheckBox",
                            li: element,
                            e: null
                        };
                        this.notify("updatelist", args);
                    }
                }
            }
        }
        this.checkSelectAll();
        this.checkMaxSelection();
    };
    MultiSelect.prototype.hideGroupItem = function(value) {
        var element;
        var element1;
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        element1 = element = this.findListElement(this.ulElement, "li", "data-value", value);
        var i = 0;
        var j = 0;
        var temp = true;
        var temp1 = true;
        do {
            if (element && element.previousElementSibling && !element.previousElementSibling.classList.contains($717505a12e9203b8$var$HIDE_LIST) && element.previousElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li)) temp = false;
            if (!temp || !element || element.previousElementSibling && element.previousElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group)) i = 10;
            else element = element.previousElementSibling;
            if (element1 && element1.nextElementSibling && !element1.nextElementSibling.classList.contains($717505a12e9203b8$var$HIDE_LIST) && element1.nextElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li)) temp1 = false;
            if (!temp1 || !element1 || element1.nextElementSibling && element1.nextElementSibling.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group)) j = 10;
            else element1 = element1.nextElementSibling;
        }while (i < 10 || j < 10);
        if (temp && temp1 && !element.previousElementSibling.classList.contains($717505a12e9203b8$var$HIDE_LIST)) (0, $4ZDHT.addClass)([
            element.previousElementSibling
        ], className);
        else if (temp && temp1 && element.previousElementSibling.classList.contains($717505a12e9203b8$var$HIDE_LIST)) (0, $4ZDHT.removeClass)([
            element.previousElementSibling
        ], className);
    };
    MultiSelect.prototype.getValidLi = function() {
        var liElement = this.ulElement.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")");
        return !(0, $3EnZW.isNullOrUndefined)(liElement) ? liElement : this.liCollections[0];
    };
    MultiSelect.prototype.checkSelectAll = function() {
        var groupItemLength = !(0, $3EnZW.isNullOrUndefined)(this.fields.disabled) ? this.list.querySelectorAll("li.e-list-group-item.e-active:not(.e-disabled)").length : this.list.querySelectorAll("li.e-list-group-item.e-active").length;
        var listItem = this.list.querySelectorAll("li.e-list-item");
        var searchCount = this.enableVirtualization ? this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-virtual-list)").length : !(0, $3EnZW.isNullOrUndefined)(this.fields.disabled) ? this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-disabled)").length : this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li).length;
        var searchActiveCount = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected).length;
        if (this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) searchActiveCount = searchActiveCount - groupItemLength;
        if (!this.enableVirtualization && (searchCount === searchActiveCount || searchActiveCount === this.maximumSelectionLength) && this.mode === "CheckBox" && this.showSelectAll || this.enableVirtualization && this.mode === "CheckBox" && this.showSelectAll && this.virtualSelectAll && this.value && this.value.length === this.totalItemCount) this.notify("checkSelectAll", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            value: "check"
        });
        else if (searchCount !== searchActiveCount && this.mode === "CheckBox" && this.showSelectAll && (!this.enableVirtualization || this.enableVirtualization && !this.virtualSelectAll)) this.notify("checkSelectAll", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            value: "uncheck"
        });
        if (this.enableGroupCheckBox && this.fields.groupBy && !this.enableSelectionOrder) {
            for(var i = 0; i < listItem.length; i++)this.findGroupStart(listItem[i]);
            this.deselectHeader();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MultiSelect.prototype.openClick = function(e) {
        if (!this.openOnClick && this.mode !== "CheckBox" && !this.isPopupOpen()) {
            if (this.targetElement() !== "") this.showPopup();
            else this.hidePopup(e);
        } else if (!this.openOnClick && this.mode === "CheckBox" && !this.isPopupOpen()) this.showPopup();
    };
    MultiSelect.prototype.keyUp = function(e) {
        if (this.mode === "CheckBox" && !this.openOnClick) {
            var char = String.fromCharCode(e.keyCode);
            var isWordCharacter = char.match(/\w/);
            if (!(0, $3EnZW.isNullOrUndefined)(isWordCharacter)) this.isValidKey = true;
        }
        this.isValidKey = this.isPopupOpen() && e.keyCode === 8 || this.isValidKey;
        this.isValidKey = e.ctrlKey && e.keyCode === 86 ? false : this.isValidKey;
        if (this.isValidKey && this.inputElement) {
            this.isValidKey = false;
            this.expandTextbox();
            this.showOverAllClear();
            e.keyCode;
            // For filtering works in mobile firefox
            this.search(e);
        }
    };
    /**
     * To filter the multiselect data from given data source by using query
     *
     * @param {Object[] | DataManager } dataSource - Set the data source to filter.
     * @param {Query} query - Specify the query to filter the data.
     * @param {FieldSettingsModel} fields - Specify the fields to map the column in the data table.
     * @returns {void}
     */ MultiSelect.prototype.filter = function(dataSource, query, fields) {
        this.isFiltered = true;
        this.remoteFilterAction = true;
        this.dataUpdater(dataSource, query, fields);
    };
    MultiSelect.prototype.getQuery = function(query) {
        var filterQuery = query ? query.clone() : this.query ? this.query.clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if (this.isFiltered) {
            if (this.enableVirtualization && !(0, $3EnZW.isNullOrUndefined)(this.customFilterQuery)) filterQuery = this.customFilterQuery.clone();
            else if (!this.enableVirtualization) return filterQuery;
        }
        if (this.filterAction) {
            if (this.targetElement() !== null && !this.enableVirtualization || this.enableVirtualization && this.targetElement() !== null && this.targetElement().trim() !== "") {
                var dataType = this.typeOfData(this.dataSource).typeof;
                if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && dataType === "string" || dataType === "number") filterQuery.where("", this.filterType, this.targetElement(), this.ignoreCase, this.ignoreAccent);
                else if (this.enableVirtualization && this.targetElement() !== "" || !this.enableVirtualization) {
                    var fields = this.fields;
                    filterQuery.where(!(0, $3EnZW.isNullOrUndefined)(fields.text) ? fields.text : "", this.filterType, this.targetElement(), this.ignoreCase, this.ignoreAccent);
                }
            }
            if (this.enableVirtualization && this.viewPortInfo.endIndex !== 0 && !this.virtualSelectAll) return this.virtualFilterQuery(filterQuery);
            return filterQuery;
        } else {
            if (this.enableVirtualization && this.viewPortInfo.endIndex !== 0 && !this.virtualSelectAll) return this.virtualFilterQuery(filterQuery);
            if (this.virtualSelectAll) return query ? query.take(this.maximumSelectionLength).requiresCount() : this.query ? this.query.take(this.maximumSelectionLength).requiresCount() : new (0, $56262f229d1cff45$export$62297b13309008b2)().take(this.maximumSelectionLength).requiresCount();
            return query ? query : this.query ? this.query : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        }
    };
    MultiSelect.prototype.virtualFilterQuery = function(filterQuery) {
        var takeValue = this.getTakeValue();
        var isReOrder = true;
        var isSkip = true;
        var isTake = true;
        for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++){
            if (this.getModuleName() === "multiselect" && (filterQuery.queries[queryElements].e && filterQuery.queries[queryElements].e.condition === "or" || filterQuery.queries[queryElements].e && filterQuery.queries[queryElements].e.operator === "equal")) isReOrder = false;
            if (filterQuery.queries[queryElements].fn === "onSkip") isSkip = false;
            if (filterQuery.queries[queryElements].fn === "onTake") isTake = false;
        }
        var queryTakeValue = 0;
        if (filterQuery && filterQuery.queries.length > 0) {
            for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++)if (filterQuery.queries[queryElements].fn === "onTake") queryTakeValue = takeValue <= filterQuery.queries[queryElements].e.nos ? filterQuery.queries[queryElements].e.nos : takeValue;
        }
        if (queryTakeValue <= 0 && this.query && this.query.queries.length > 0) {
            for(var queryElements = 0; queryElements < this.query.queries.length; queryElements++)if (this.query.queries[queryElements].fn === "onTake") queryTakeValue = takeValue <= this.query.queries[queryElements].e.nos ? this.query.queries[queryElements].e.nos : takeValue;
        }
        if (filterQuery && filterQuery.queries.length > 0) {
            for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++)if (filterQuery.queries[queryElements].fn === "onTake") {
                queryTakeValue = filterQuery.queries[queryElements].e.nos <= queryTakeValue ? queryTakeValue : filterQuery.queries[queryElements].e.nos;
                filterQuery.queries.splice(queryElements, 1);
                --queryElements;
            }
        }
        if (this.allowFiltering && isSkip || !isReOrder || !this.allowFiltering && isSkip) {
            if (!isReOrder) filterQuery.skip(this.viewPortInfo.startIndex);
            else filterQuery.skip(this.virtualItemStartIndex);
        }
        if (this.isIncrementalRequest) filterQuery.take(this.incrementalEndIndex);
        else if (queryTakeValue > 0) filterQuery.take(queryTakeValue);
        else filterQuery.take(takeValue);
        filterQuery.requiresCount();
        return filterQuery;
    };
    MultiSelect.prototype.getTakeValue = function() {
        return this.allowFiltering && (0, $5q7BP.Browser).isDevice ? Math.round(window.outerHeight / this.listItemHeight) : this.itemCount;
    };
    MultiSelect.prototype.dataUpdater = function(dataSource, query, fields) {
        this.isDataFetched = false;
        var isNoData = this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData);
        if (this.targetElement().trim() === "") {
            var list = this.enableVirtualization ? this.list.cloneNode(true) : this.mainList.cloneNode ? this.mainList.cloneNode(true) : this.mainList;
            if (this.backCommand) {
                this.remoteCustomValue = false;
                if (this.allowCustomValue && list.querySelectorAll("li").length === 0 && this.mainData.length > 0) this.mainData = [];
                if (this.enableVirtualization) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.totalItemCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
                    this.resetList(dataSource, fields, query);
                    if (this.mode !== "CheckBox") this.totalItemCount = this.value && this.value.length ? this.totalItemCount - this.value.length : this.totalItemCount;
                    this.UpdateSkeleton();
                    if ((isNoData || this.allowCustomValue) && !this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                        if (!this.list.querySelector(".e-virtual-ddl-content")) this.list.appendChild(this.createElement("div", {
                            className: "e-virtual-ddl-content",
                            styles: this.getTransformValues()
                        })).appendChild(this.list.querySelector(".e-list-parent"));
                        if (!this.list.querySelector(".e-virtual-ddl")) {
                            var virualElement = this.createElement("div", {
                                id: this.element.id + "_popup",
                                className: "e-virtual-ddl",
                                styles: this.GetVirtualTrackHeight()
                            });
                            document.getElementsByClassName("e-multi-select-list-wrapper")[0].querySelector(".e-dropdownbase").appendChild(virualElement);
                        }
                    }
                }
                this.onActionComplete(list, this.mainData);
                if (this.value && this.value.length) this.refreshSelection();
                if (this.keyCode !== 8) this.focusAtFirstListItem();
                this.notify("reOrder", {
                    module: "CheckBoxSelection",
                    enable: this.mode === "CheckBox",
                    e: this
                });
            }
        } else {
            if (this.enableVirtualization && this.allowFiltering) {
                this.isPreventScrollAction = true;
                this.list.scrollTop = 0;
                this.previousStartIndex = 0;
                this.virtualListInfo = null;
            }
            this.resetList(dataSource, fields, query);
            if (this.enableVirtualization && (isNoData || this.allowCustomValue) && !this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                if (!this.list.querySelector(".e-virtual-ddl-content")) this.list.appendChild(this.createElement("div", {
                    className: "e-virtual-ddl-content",
                    styles: this.getTransformValues()
                })).appendChild(this.list.querySelector(".e-list-parent"));
                if (this.mode !== "CheckBox") this.totalItemCount = this.value && this.value.length ? this.totalItemCount - this.value.length : this.totalItemCount;
                if (!this.list.querySelector(".e-virtual-ddl")) {
                    var virualElement = this.createElement("div", {
                        id: this.element.id + "_popup",
                        className: "e-virtual-ddl",
                        styles: this.GetVirtualTrackHeight()
                    });
                    document.getElementsByClassName("e-multi-select-list-wrapper")[0].querySelector(".e-dropdownbase").appendChild(virualElement);
                }
            }
            if (this.allowCustomValue) {
                if (!(dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) this.checkForCustomValue(query, fields);
                else {
                    this.remoteCustomValue = true;
                    this.tempQuery = query;
                }
            }
        }
        if (this.enableVirtualization && this.allowFiltering) this.getFilteringSkeletonCount();
        this.refreshPopup();
        if (this.mode === "CheckBox") this.removeFocus();
    };
    MultiSelect.prototype.checkForCustomValue = function(query, fields) {
        var dataChecks = !this.getValueByText(this.inputElement.value, this.ignoreCase);
        var field = fields ? fields : this.fields;
        if (this.allowCustomValue && dataChecks) {
            var value = this.inputElement.value;
            var customData = !(0, $3EnZW.isNullOrUndefined)(this.mainData) && this.mainData.length > 0 ? this.mainData[0] : this.mainData;
            if (customData && typeof customData !== "string" && typeof customData !== "number" && typeof customData !== "boolean") {
                var dataItem_1 = {};
                (0, $3EnZW.setValue)(field.text, value, dataItem_1);
                if (typeof (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", customData) === "number" && this.fields.value !== this.fields.text) (0, $3EnZW.setValue)(field.value, Math.random(), dataItem_1);
                else (0, $3EnZW.setValue)(field.value, value, dataItem_1);
                var emptyObject_1 = {};
                if (this.allowObjectBinding) {
                    var keys = this.listData && this.listData.length > 0 ? Object.keys(this.listData[0]) : this.firstItem ? Object.keys(this.firstItem) : Object.keys(dataItem_1);
                    // Create an empty object with predefined keys
                    keys.forEach(function(key) {
                        emptyObject_1[key] = key === fields.value || key === fields.text ? (0, $3EnZW.getValue)(fields.value, dataItem_1) : null;
                    });
                }
                dataItem_1 = this.allowObjectBinding ? emptyObject_1 : dataItem_1;
                if (this.enableVirtualization) {
                    this.virtualCustomData = dataItem_1;
                    var tempData = this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? JSON.parse(JSON.stringify(this.listData)) : JSON.parse(JSON.stringify(this.dataSource));
                    var totalData = [];
                    if (this.virtualCustomSelectData && this.virtualCustomSelectData.length > 0) totalData = tempData.concat(this.virtualCustomSelectData);
                    tempData.splice(0, 0, dataItem_1);
                    this.isCustomDataUpdated = true;
                    var tempCount = this.totalItemCount;
                    this.viewPortInfo.startIndex = this.virtualItemStartIndex = 0;
                    this.viewPortInfo.endIndex = this.virtualItemEndIndex = this.itemCount;
                    this.resetList(tempData, field, query);
                    this.isCustomDataUpdated = false;
                    this.totalItemCount = this.enableVirtualization && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? tempCount : this.totalItemCount;
                } else {
                    if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.allowCustomValue && this.allowFiltering) this.remoteCustomValue = false;
                    var tempData = JSON.parse(JSON.stringify(this.listData));
                    tempData.splice(0, 0, dataItem_1);
                    this.resetList(tempData, field, query);
                }
            } else if (this.listData) {
                var tempData = JSON.parse(JSON.stringify(this.listData));
                tempData.splice(0, 0, this.inputElement.value);
                tempData[0] = typeof customData === "number" && !isNaN(parseFloat(tempData[0])) ? parseFloat(tempData[0]) : tempData[0];
                tempData[0] = typeof customData === "boolean" ? tempData[0] === "true" ? true : tempData[0] === "false" ? false : tempData[0] : tempData[0];
                this.resetList(tempData, field);
            }
        } else if (this.listData && this.mainData && !dataChecks && this.allowCustomValue) {
            if (this.allowFiltering && this.isRemoteSelection && this.remoteCustomValue) {
                this.isRemoteSelection = false;
                if (!this.enableVirtualization) this.resetList(this.listData, field, query);
            } else if (!this.allowFiltering && this.list) {
                var liCollections = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-hide-listitem)");
                var activeElement = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.targetElement(), liCollections, "StartsWith", this.ignoreCase);
                if (activeElement && activeElement.item !== null) this.addListFocus(activeElement.item);
            }
        }
        if (this.value && this.value.length) this.refreshSelection();
    };
    MultiSelect.prototype.getNgDirective = function() {
        return "EJS-MULTISELECT";
    };
    MultiSelect.prototype.wrapperClick = function(e) {
        this.setDynValue = false;
        this.keyboardEvent = null;
        this.isKeyBoardAction = false;
        if (!this.enabled) return;
        if (e.target === this.overAllClear) {
            e.preventDefault();
            return;
        }
        if (!this.inputFocus) this.inputElement.focus();
        if (!this.readonly) {
            if (e.target && e.target.classList.toString().indexOf($717505a12e9203b8$var$CHIP_CLOSE) !== -1) {
                if (this.isPopupOpen()) this.refreshPopup();
                return;
            }
            if (!this.isPopupOpen() && (this.openOnClick || this.showDropDownIcon && e.target && e.target.className === $717505a12e9203b8$var$dropdownIcon)) this.showPopup(e);
            else {
                this.hidePopup(e);
                if (this.mode === "CheckBox") {
                    this.showOverAllClear();
                    this.inputFocus = true;
                    if (!this.overAllWrapper.classList.contains($717505a12e9203b8$var$FOCUS)) this.overAllWrapper.classList.add($717505a12e9203b8$var$FOCUS);
                }
            }
        }
        if (!(this.targetElement() && this.targetElement() !== "")) e.preventDefault();
    };
    MultiSelect.prototype.enable = function(state) {
        if (state) {
            this.overAllWrapper.classList.remove($717505a12e9203b8$var$DISABLED);
            this.inputElement.removeAttribute("disabled");
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-disabled": "false"
            });
            this.ensureAriaDisabled("false");
        } else {
            this.overAllWrapper.classList.add($717505a12e9203b8$var$DISABLED);
            this.inputElement.setAttribute("disabled", "true");
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-disabled": "true"
            });
            this.ensureAriaDisabled("true");
        }
        if (this.enabled !== state) this.enabled = state;
        this.hidePopup();
    };
    MultiSelect.prototype.onBlurHandler = function(eve, isDocClickFromCheck) {
        var target;
        if (!(0, $3EnZW.isNullOrUndefined)(eve)) target = eve.relatedTarget;
        if (this.popupObj && document.body.contains(this.popupObj.element) && this.popupObj.element.contains(target)) {
            if (this.mode !== "CheckBox") this.inputElement.focus();
            else if (this.floatLabelType === "Auto" && (this.overAllWrapper.classList.contains("e-outline") || this.overAllWrapper.classList.contains("e-filled"))) (0, $4ZDHT.addClass)([
                this.overAllWrapper
            ], "e-valid-input");
            return;
        }
        if (this.floatLabelType === "Auto" && this.overAllWrapper.classList.contains("e-outline") && this.mode === "CheckBox" && ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0)) (0, $4ZDHT.removeClass)([
            this.overAllWrapper
        ], "e-valid-input");
        if (this.mode === "CheckBox" && (0, $5q7BP.Browser).isIE && !(0, $3EnZW.isNullOrUndefined)(eve) && !isDocClickFromCheck) {
            this.inputFocus = false;
            this.overAllWrapper.classList.remove($717505a12e9203b8$var$FOCUS);
            return;
        }
        if (this.scrollFocusStatus) {
            if (!(0, $3EnZW.isNullOrUndefined)(eve)) eve.preventDefault();
            this.inputElement.focus();
            this.scrollFocusStatus = false;
            return;
        }
        this.inputFocus = false;
        this.overAllWrapper.classList.remove($717505a12e9203b8$var$FOCUS);
        if (this.addTagOnBlur) {
            var dataChecks = this.getValueByText(this.inputElement.value, this.ignoreCase, this.ignoreAccent);
            var listLiElement = this.findListElement(this.list, "li", "data-value", dataChecks);
            var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
            var allowChipAddition = listLiElement && !listLiElement.classList.contains(className) ? true : false;
            if (allowChipAddition) {
                this.updateListSelection(listLiElement, eve);
                if (this.mode === "Delimiter") this.updateDelimeter(this.delimiterChar);
            }
        }
        this.updateDataList();
        if (this.resetMainList) {
            this.mainList = this.resetMainList;
            this.resetMainList = null;
        }
        this.refreshListItems(null);
        if (this.mode !== "Box" && this.mode !== "CheckBox") this.updateDelimView();
        if (this.changeOnBlur) {
            this.updateValueState(eve, this.value, this.tempValues);
            this.dispatchEvent(this.hiddenElement, "change");
        }
        this.overAllClear.style.display = "none";
        if (this.isPopupOpen()) this.hidePopup(eve);
        this.makeTextBoxEmpty();
        this.trigger("blur");
        this.focused = true;
        if ((0, $5q7BP.Browser).isDevice && this.mode !== "Delimiter" && this.mode !== "CheckBox") this.removeChipFocus();
        this.removeChipSelection();
        this.refreshInputHight();
        (0, $805d2bf384e771bd$export$f1eeb56039ab052a)(this.overAllWrapper, this.componentWrapper, this.value, this.floatLabelType, this.placeholder);
        this.refreshPlaceHolder();
        if ((this.allowFiltering || this.enableSelectionOrder === true && this.mode === "CheckBox") && !(0, $3EnZW.isNullOrUndefined)(this.mainList)) this.ulElement = this.mainList;
        this.checkPlaceholderSize();
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).createSpanElement(this.overAllWrapper, this.createElement);
        this.calculateWidth();
        if (!(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper) && !(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper.getElementsByClassName("e-ddl-icon")[0] && this.overAllWrapper.getElementsByClassName("e-float-text-content")[0] && this.floatLabelType !== "Never")) this.overAllWrapper.getElementsByClassName("e-float-text-content")[0].classList.add("e-icon");
    };
    MultiSelect.prototype.calculateWidth = function() {
        var elementWidth;
        if (this.overAllWrapper) {
            if (!this.showDropDownIcon || this.overAllWrapper.querySelector(".e-label-top")) elementWidth = this.overAllWrapper.clientWidth - 2 * parseInt(getComputedStyle(this.inputElement).paddingRight, 10);
            else {
                var downIconWidth = this.dropIcon.offsetWidth + parseInt(getComputedStyle(this.dropIcon).marginRight, 10);
                elementWidth = this.overAllWrapper.clientWidth - (downIconWidth + 2 * parseInt(getComputedStyle(this.inputElement).paddingRight, 10));
            }
            if (this.floatLabelType !== "Never") (0, $168e4e125732cd26$export$f5b8910cec6cf069).calculateWidth(elementWidth, this.overAllWrapper, this.getModuleName());
        }
    };
    MultiSelect.prototype.checkPlaceholderSize = function() {
        if (this.showDropDownIcon) {
            var downIconWidth = this.dropIcon.offsetWidth + parseInt(window.getComputedStyle(this.dropIcon).marginRight, 10);
            this.setPlaceholderSize(downIconWidth);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.dropIcon)) this.setPlaceholderSize(this.showDropDownIcon ? this.dropIcon.offsetWidth : 0);
    };
    MultiSelect.prototype.setPlaceholderSize = function(downIconWidth) {
        if ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0) {
            if (this.dropIcon.offsetWidth !== 0) this.searchWrapper.style.width = "calc(100% - " + (downIconWidth + 10) + "px";
            else (0, $4ZDHT.addClass)([
                this.searchWrapper
            ], $717505a12e9203b8$var$CUSTOM_WIDTH);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            this.searchWrapper.removeAttribute("style");
            (0, $4ZDHT.removeClass)([
                this.searchWrapper
            ], $717505a12e9203b8$var$CUSTOM_WIDTH);
        }
    };
    MultiSelect.prototype.refreshInputHight = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.searchWrapper)) {
            if ((!this.value || !this.value.length) && ((0, $3EnZW.isNullOrUndefined)(this.text) || this.text === "")) this.searchWrapper.classList.remove($717505a12e9203b8$var$ZERO_SIZE);
            else this.searchWrapper.classList.add($717505a12e9203b8$var$ZERO_SIZE);
        }
    };
    MultiSelect.prototype.validateValues = function(newValue, oldValue) {
        return JSON.stringify(newValue.slice().sort()) !== JSON.stringify(oldValue.slice().sort());
    };
    MultiSelect.prototype.updateValueState = function(event, newVal, oldVal) {
        var newValue = newVal ? newVal : [];
        var oldValue = oldVal ? oldVal : [];
        if (this.initStatus && this.validateValues(newValue, oldValue)) {
            var eventArgs = {
                e: event,
                oldValue: this.allowObjectBinding ? oldVal : oldVal,
                value: this.allowObjectBinding ? newVal : newVal,
                isInteracted: event ? true : false,
                element: this.element,
                event: event
            };
            if (this.isAngular && this.preventChange) this.preventChange = false;
            else this.trigger("change", eventArgs);
            this.updateTempValue();
            if (!this.changeOnBlur) this.dispatchEvent(this.hiddenElement, "change");
        }
        this.selectedValueInfo = this.viewPortInfo;
    };
    MultiSelect.prototype.updateTempValue = function() {
        if (!this.value) this.tempValues = this.value;
        else this.tempValues = this.allowObjectBinding ? this.value.slice() : this.value.slice();
    };
    MultiSelect.prototype.updateAriaActiveDescendant = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.ulElement) && !(0, $3EnZW.isNullOrUndefined)(this.ulElement.getElementsByClassName("e-item-focus")[0])) (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-activedescendant": this.ulElement.getElementsByClassName("e-item-focus")[0].id
        });
    };
    MultiSelect.prototype.pageUpSelection = function(steps, isVirtualKeyAction) {
        var collection = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
        var previousItem = steps >= 0 ? collection[steps + 1] : collection[0];
        if (this.enableVirtualization && isVirtualKeyAction) previousItem = this.liCollections.length >= steps && steps >= 0 ? this.liCollections[steps] : this.liCollections[this.skeletonCount];
        if (!(0, $3EnZW.isNullOrUndefined)(previousItem) && previousItem.classList.contains("e-virtual-list")) previousItem = this.liCollections[this.skeletonCount];
        if (this.enableVirtualization) {
            if (!(0, $3EnZW.isNullOrUndefined)(previousItem) && !previousItem.classList.contains("e-item-focus")) {
                this.isKeyBoardAction = true;
                this.addListFocus(previousItem);
                this.scrollTop(previousItem, this.getIndexByValue(previousItem.getAttribute("data-value")), this.keyboardEvent.keyCode);
            } else if (this.viewPortInfo.startIndex === 0) {
                this.isKeyBoardAction = true;
                this.scrollTop(previousItem, this.getIndexByValue(previousItem.getAttribute("data-value")), this.keyboardEvent.keyCode);
            }
            this.previousFocusItem = previousItem;
        } else {
            this.isKeyBoardAction = true;
            this.addListFocus(previousItem);
            this.scrollTop(previousItem, this.getIndexByValue(previousItem.getAttribute("data-value")), this.keyboardEvent.keyCode);
        }
    };
    MultiSelect.prototype.pageDownSelection = function(steps, isVirtualKeyAction) {
        var list = this.getItems();
        var collection = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
        var previousItem = steps <= collection.length ? collection[steps - 1] : collection[collection.length - 1];
        if (this.enableVirtualization && this.skeletonCount > 0) previousItem = steps < list.length ? this.liCollections[steps] : this.liCollections[list.length - 1];
        if (this.enableVirtualization && isVirtualKeyAction) previousItem = steps <= list.length ? this.liCollections[steps] : this.liCollections[list.length - 1];
        this.isKeyBoardAction = true;
        this.addListFocus(previousItem);
        this.previousFocusItem = previousItem;
        this.scrollBottom(previousItem, this.getIndexByValue(previousItem.getAttribute("data-value")), false, this.keyboardEvent.keyCode);
    };
    MultiSelect.prototype.getItems = function() {
        if (!this.list) _super.prototype.render.call(this);
        return this.ulElement && this.ulElement.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li).length > 0 ? this.ulElement.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")") : [];
    };
    MultiSelect.prototype.focusInHandler = function(e) {
        var _this = this;
        if (this.enabled) {
            this.showOverAllClear();
            this.inputFocus = true;
            if (this.value && this.value.length) {
                if (this.mode !== "Delimiter" && this.mode !== "CheckBox") this.chipCollectionWrapper.style.display = "";
                else this.showDelimWrapper();
                if (this.mode !== "CheckBox") this.viewWrapper.style.display = "none";
            }
            if (this.mode !== "CheckBox") this.searchWrapper.classList.remove($717505a12e9203b8$var$ZERO_SIZE);
            this.checkPlaceholderSize();
            if (this.focused) {
                var args = {
                    isInteracted: e ? true : false,
                    event: e
                };
                this.trigger("focus", args);
                this.focused = false;
            }
            if (!this.overAllWrapper.classList.contains($717505a12e9203b8$var$FOCUS)) this.overAllWrapper.classList.add($717505a12e9203b8$var$FOCUS);
            (0, $805d2bf384e771bd$export$18f5ba2d232c99b5)(this.overAllWrapper, this.componentWrapper);
            if (this.isPopupOpen()) this.refreshPopup();
            setTimeout(function() {
                _this.calculateWidth();
            }, 150);
            return true;
        } else return false;
    };
    MultiSelect.prototype.showDelimWrapper = function() {
        if (this.mode === "CheckBox") this.viewWrapper.style.display = "";
        else this.delimiterWrapper.style.display = "";
        this.componentWrapper.classList.add($717505a12e9203b8$var$DELIMITER_VIEW_WRAPPER);
    };
    MultiSelect.prototype.hideDelimWrapper = function() {
        this.delimiterWrapper.style.display = "none";
        this.componentWrapper.classList.remove($717505a12e9203b8$var$DELIMITER_VIEW_WRAPPER);
    };
    MultiSelect.prototype.expandTextbox = function() {
        var size = 5;
        if (this.placeholder) {
            var codePoint = this.placeholder.charCodeAt(0);
            var sizeMultiplier = 0xAC00 <= codePoint && codePoint <= 0xD7AF ? 1.5 : 0x4E00 <= codePoint && codePoint <= 0x9FFF ? 2 : 1;
            size = size > this.inputElement.placeholder.length ? size : this.inputElement.placeholder.length * sizeMultiplier;
        }
        if (this.inputElement.value.length > size) this.inputElement.size = this.inputElement.value.length;
        else this.inputElement.size = size;
    };
    MultiSelect.prototype.isPopupOpen = function() {
        return this.popupWrapper !== null && this.popupWrapper.parentElement !== null;
    };
    MultiSelect.prototype.refreshPopup = function() {
        if (this.popupObj && this.mobFilter) {
            this.popupObj.setProperties({
                width: this.calcPopupWidth()
            });
            this.popupObj.refreshPosition(this.overAllWrapper);
            this.popupObj.resolveCollision();
        }
    };
    MultiSelect.prototype.checkTextLength = function() {
        return this.targetElement().length < 1;
    };
    MultiSelect.prototype.popupKeyActions = function(e) {
        switch(e.keyCode){
            case 38:
                this.hidePopup(e);
                if (this.mode === "CheckBox") this.inputElement.focus();
                e.preventDefault();
                break;
            case 40:
                if (!this.isPopupOpen()) {
                    this.showPopup(e);
                    e.preventDefault();
                }
                break;
        }
    };
    MultiSelect.prototype.updateAriaAttribute = function() {
        var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (!(0, $3EnZW.isNullOrUndefined)(focusedItem)) {
            this.inputElement.setAttribute("aria-activedescendant", focusedItem.id);
            if (this.allowFiltering) {
                var filterInput = this.popupWrapper.querySelector("." + $717505a12e9203b8$var$FILTERINPUT);
                if (filterInput) filterInput.setAttribute("aria-activedescendant", focusedItem.id);
            } else if (this.mode === "CheckBox") this.overAllWrapper.setAttribute("aria-activedescendant", focusedItem.id);
        }
    };
    MultiSelect.prototype.homeNavigation = function(isHome, isVirtualKeyAction) {
        this.removeFocus();
        if (this.enableVirtualization) {
            if (isHome) {
                if (this.enableVirtualization && this.viewPortInfo.startIndex !== 0) {
                    this.viewPortInfo.startIndex = 0;
                    this.viewPortInfo.endIndex = this.itemCount;
                    this.updateVirtualItemIndex();
                    this.resetList(this.dataSource, this.fields, this.query);
                }
            } else if (this.enableVirtualization && (!this.value && this.viewPortInfo.endIndex !== this.totalItemCount || this.value && this.value.length > 0 && this.viewPortInfo.endIndex !== this.totalItemCount + this.value.length)) {
                this.viewPortInfo.startIndex = this.totalItemCount - this.itemCount;
                this.viewPortInfo.endIndex = this.totalItemCount;
                this.updateVirtualItemIndex();
                var query = new (0, $56262f229d1cff45$export$62297b13309008b2)().clone();
                if (this.value && this.value.length > 0) {
                    query = this.getForQuery(this.value).clone();
                    query = query.skip(this.totalItemCount - this.itemCount);
                }
                this.resetList(this.dataSource, this.fields, query);
            }
        }
        this.UpdateSkeleton();
        var scrollEle = this.ulElement.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
        if (scrollEle.length > 0) {
            var element = scrollEle[isHome ? 0 : scrollEle.length - 1];
            if (this.enableVirtualization && isHome) element = scrollEle[this.skeletonCount];
            this.removeFocus();
            element.classList.add((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            if (this.enableVirtualization && isHome) this.scrollTop(element, undefined, this.keyboardEvent.keyCode);
            else if (!isVirtualKeyAction) this.scrollBottom(element, undefined, false, this.keyboardEvent.keyCode);
            this.updateAriaActiveDescendant();
        }
    };
    MultiSelect.prototype.updateSelectionList = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value.length) for(var index = 0; index < this.value.length; index++){
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[index]) : this.value[index];
            var selectedItem = this.getElementByValue(value);
            if (selectedItem && !selectedItem.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected)) selectedItem.classList.add("e-active");
        }
    };
    MultiSelect.prototype.handleVirtualKeyboardActions = function(e, pageCount) {
        var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        var activeIndex;
        this.isKeyBoardAction = true;
        switch(e.keyCode){
            case 40:
                this.arrowDown(e, true);
                break;
            case 38:
                this.arrowUp(e, true);
                break;
            case 33:
                e.preventDefault();
                if (focusedItem) {
                    activeIndex = this.getIndexByValue(this.previousFocusItem.getAttribute("data-value")) - 1;
                    this.pageUpSelection(activeIndex, true);
                    this.updateAriaAttribute();
                }
                break;
            case 34:
                e.preventDefault();
                if (focusedItem) {
                    activeIndex = this.getIndexByValue(this.previousFocusItem.getAttribute("data-value"));
                    this.pageDownSelection(activeIndex, true);
                    this.updateAriaAttribute();
                }
                break;
            case 35:
            case 36:
                this.isMouseScrollAction = true;
                this.homeNavigation(e.keyCode === 36 ? true : false, true);
                this.isPreventScrollAction = true;
                break;
        }
        this.keyboardEvent = null;
        this.isScrollChanged = true;
        this.isKeyBoardAction = false;
    };
    MultiSelect.prototype.onKeyDown = function(e) {
        if (this.readonly || !this.enabled && this.mode !== "CheckBox") return;
        this.preventSetCurrentData = false;
        this.keyboardEvent = e;
        if (this.isPreventKeyAction && this.enableVirtualization) e.preventDefault();
        this.keyCode = e.keyCode;
        this.keyDownStatus = true;
        if (e.keyCode > 111 && e.keyCode < 124) return;
        if (e.altKey) {
            this.popupKeyActions(e);
            return;
        } else if (this.isPopupOpen()) {
            var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            var activeIndex = void 0;
            switch(e.keyCode){
                case 36:
                case 35:
                    this.isMouseScrollAction = true;
                    this.isKeyBoardAction = true;
                    this.homeNavigation(e.keyCode === 36 ? true : false);
                    break;
                case 33:
                    e.preventDefault();
                    if (focusedItem) {
                        activeIndex = this.getIndexByValue(focusedItem.getAttribute("data-value"));
                        this.pageUpSelection(activeIndex - this.getPageCount() - 1);
                        this.updateAriaAttribute();
                    }
                    return;
                case 34:
                    e.preventDefault();
                    if (focusedItem) {
                        activeIndex = this.getIndexByValue(focusedItem.getAttribute("data-value"));
                        this.pageDownSelection(activeIndex + this.getPageCount());
                        this.updateAriaAttribute();
                    }
                    return;
                case 38:
                    this.isKeyBoardAction = true;
                    this.arrowUp(e);
                    break;
                case 40:
                    this.isKeyBoardAction = true;
                    this.arrowDown(e);
                    break;
                case 27:
                    e.preventDefault();
                    this.isKeyBoardAction = true;
                    this.hidePopup(e);
                    if (this.mode === "CheckBox") this.inputElement.focus();
                    return;
                case 13:
                    e.preventDefault();
                    this.isKeyBoardAction = true;
                    if (this.mode !== "CheckBox") this.selectByKey(e);
                    this.checkPlaceholderSize();
                    return;
                case 32:
                    this.isKeyBoardAction = true;
                    this.spaceKeySelection(e);
                    return;
                case 9:
                    e.preventDefault();
                    this.isKeyBoardAction = true;
                    this.hidePopup(e);
                    this.inputElement.focus();
                    this.overAllWrapper.classList.add($717505a12e9203b8$var$FOCUS);
            }
        } else switch(e.keyCode){
            case 13:
            case 9:
            case 16:
            case 17:
            case 20:
                return;
            case 40:
                if (this.openOnClick) this.showPopup();
                break;
            case 27:
                e.preventDefault();
                this.escapeAction();
                return;
        }
        if (this.checkTextLength()) this.keyNavigation(e);
        if (this.mode === "CheckBox" && this.enableSelectionOrder) {
            if (this.allowFiltering) this.previousFilterText = this.targetElement();
            this.checkBackCommand(e);
        }
        this.expandTextbox();
        if (!(this.mode === "CheckBox" && this.showSelectAll)) this.refreshPopup();
        this.isKeyBoardAction = false;
    };
    MultiSelect.prototype.arrowDown = function(e, isVirtualKeyAction) {
        e.preventDefault();
        this.moveByList(1, isVirtualKeyAction);
        this.keyAction = true;
        if (document.activeElement.classList.contains($717505a12e9203b8$var$FILTERINPUT) || this.mode === "CheckBox" && !this.allowFiltering && document.activeElement !== this.list) (0, $aqzbR.EventHandler).add(this.list, "keydown", this.onKeyDown, this);
        this.updateAriaAttribute();
    };
    MultiSelect.prototype.arrowUp = function(e, isVirtualKeyAction) {
        e.preventDefault();
        this.keyAction = true;
        var list = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
        if (this.enableGroupCheckBox && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) list = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ",li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
        var focuseElem = this.list.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        this.focusFirstListItem = !(0, $3EnZW.isNullOrUndefined)(this.liCollections[0]) ? this.liCollections[0].classList.contains("e-item-focus") : false;
        var index = Array.prototype.slice.call(list).indexOf(focuseElem);
        if (index <= 0 && this.mode === "CheckBox" && this.allowFiltering) {
            this.keyAction = false;
            this.notify("inputFocus", {
                module: "CheckBoxSelection",
                enable: this.mode === "CheckBox",
                value: "focus"
            });
        }
        this.moveByList(-1, isVirtualKeyAction);
        this.updateAriaAttribute();
    };
    MultiSelect.prototype.spaceKeySelection = function(e) {
        if (this.mode === "CheckBox") {
            var li = this.list.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
            if (!(0, $3EnZW.isNullOrUndefined)(li) || selectAllParent && selectAllParent.classList.contains("e-item-focus")) {
                e.preventDefault();
                this.keyAction = true;
            }
            this.selectByKey(e);
            if (this.keyAction) {
                var li_1 = this.list.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
                if (!(0, $3EnZW.isNullOrUndefined)(li_1) && selectAllParent && selectAllParent.classList.contains("e-item-focus")) li_1.classList.remove("e-item-focus");
            }
        }
        this.checkPlaceholderSize();
    };
    MultiSelect.prototype.checkBackCommand = function(e) {
        if (e.keyCode === 8 && this.allowFiltering ? this.targetElement() !== this.previousFilterText : this.targetElement() === "") this.backCommand = false;
        else this.backCommand = true;
    };
    MultiSelect.prototype.keyNavigation = function(e) {
        if (this.mode !== "Delimiter" && this.mode !== "CheckBox" && this.value && this.value.length) switch(e.keyCode){
            case 37:
                e.preventDefault();
                this.moveBy(-1, e);
                break;
            case 39:
                e.preventDefault();
                this.moveBy(1, e);
                break;
            case 8:
                this.removelastSelection(e);
                break;
            case 46:
                this.removeSelectedChip(e);
                break;
        }
        else if (e.keyCode === 8 && this.mode === "Delimiter") {
            if (this.value && this.value.length) {
                e.preventDefault();
                var temp = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[this.value.length - 1]) : this.value[this.value.length - 1];
                this.removeValue(this.value[this.value.length - 1], e);
                this.updateDelimeter(this.delimiterChar, e);
                this.focusAtLastListItem(temp);
            }
        }
    };
    MultiSelect.prototype.selectByKey = function(e) {
        this.removeChipSelection();
        this.selectListByKey(e);
        if (this.hideSelectedItem) this.focusAtFirstListItem();
    };
    MultiSelect.prototype.escapeAction = function() {
        var temp = this.tempValues ? this.tempValues.slice() : [];
        if (this.allowObjectBinding) temp = this.tempValues ? this.tempValues.slice() : [];
        if (this.value && this.validateValues(this.value, temp)) {
            if (this.mode !== "CheckBox") {
                this.value = temp;
                this.initialValueUpdate();
            }
            if (this.mode !== "Delimiter" && this.mode !== "CheckBox") this.chipCollectionWrapper.style.display = "";
            else this.showDelimWrapper();
            this.refreshPlaceHolder();
            if (this.value.length) this.showOverAllClear();
            else this.hideOverAllClear();
        }
        this.makeTextBoxEmpty();
    };
    MultiSelect.prototype.scrollBottom = function(selectedLI, activeIndex, isInitialSelection, keyCode) {
        if (isInitialSelection === void 0) isInitialSelection = false;
        if (keyCode === void 0) keyCode = null;
        if (!(0, $3EnZW.isNullOrUndefined)(selectedLI) && selectedLI.classList.contains("e-virtual-list") || this.enableVirtualization && (0, $3EnZW.isNullOrUndefined)(selectedLI)) selectedLI = this.liCollections[this.skeletonCount];
        var selectedListMargin = selectedLI && !isNaN(parseInt(window.getComputedStyle(selectedLI).marginBottom, 10)) ? parseInt(window.getComputedStyle(selectedLI).marginBottom, 10) : 0;
        this.isUpwardScrolling = false;
        var virtualListCount = this.list.querySelectorAll(".e-virtual-list").length;
        var lastElementValue = this.list.querySelector("li:last-of-type") ? this.list.querySelector("li:last-of-type").getAttribute("data-value") : null;
        var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? selectedLI.offsetTop + this.virtualListInfo.startIndex * (selectedLI.offsetHeight + selectedListMargin) : selectedLI.offsetTop;
        var currentOffset = this.list.offsetHeight;
        var nextBottom = selectedLiOffsetTop - virtualListCount * (selectedLI.offsetHeight + selectedListMargin) + (selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
        var nextOffset = this.list.scrollTop + nextBottom - currentOffset;
        var isScrollerCHanged = false;
        var isScrollTopChanged = false;
        var boxRange = selectedLiOffsetTop - virtualListCount * (selectedLI.offsetHeight + selectedListMargin) + (selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
        boxRange = this.fields.groupBy && !(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? boxRange - this.fixedHeaderElement.offsetHeight : boxRange;
        if (activeIndex === 0 && !this.enableVirtualization) this.list.scrollTop = 0;
        else if (nextBottom > currentOffset || !(boxRange > 0 && this.list.offsetHeight > boxRange)) {
            var currentElementValue = selectedLI ? selectedLI.getAttribute("data-value") : null;
            var liCount = keyCode === 34 ? this.getPageCount() - 1 : 1;
            if (!this.enableVirtualization || this.isKeyBoardAction || isInitialSelection) {
                if (this.isKeyBoardAction && this.enableVirtualization && lastElementValue && currentElementValue === lastElementValue && keyCode !== 35 && !this.isVirtualScrolling) {
                    this.isPreventKeyAction = true;
                    this.list.scrollTop += (selectedLI.offsetHeight + selectedListMargin) * liCount;
                    this.isPreventKeyAction = this.isScrollerAtEnd() ? false : this.isPreventKeyAction;
                    this.isKeyBoardAction = false;
                    this.isPreventScrollAction = false;
                } else if (this.enableVirtualization && keyCode === 35) {
                    this.isPreventKeyAction = false;
                    this.isKeyBoardAction = false;
                    this.isPreventScrollAction = false;
                    this.list.scrollTop = this.list.scrollHeight;
                } else {
                    if (keyCode === 34 && this.enableVirtualization && !this.isVirtualScrolling) {
                        this.isPreventKeyAction = false;
                        this.isKeyBoardAction = false;
                        this.isPreventScrollAction = false;
                    }
                    this.list.scrollTop = nextOffset;
                }
            } else this.list.scrollTop = this.virtualListInfo && this.virtualListInfo.startIndex ? this.virtualListInfo.startIndex * this.listItemHeight : 0;
            isScrollerCHanged = this.isKeyBoardAction;
            isScrollTopChanged = true;
        }
        this.isKeyBoardAction = isScrollerCHanged;
    };
    MultiSelect.prototype.scrollTop = function(selectedLI, activeIndex, keyCode) {
        if (keyCode === void 0) keyCode = null;
        var virtualListCount = this.list.querySelectorAll(".e-virtual-list").length;
        var selectedListMargin = selectedLI && !isNaN(parseInt(window.getComputedStyle(selectedLI).marginBottom, 10)) ? parseInt(window.getComputedStyle(selectedLI).marginBottom, 10) : 0;
        var selectedLiOffsetTop = this.virtualListInfo && this.virtualListInfo.startIndex ? selectedLI.offsetTop + this.virtualListInfo.startIndex * (selectedLI.offsetHeight + selectedListMargin) : selectedLI.offsetTop;
        var nextOffset = selectedLiOffsetTop - virtualListCount * (selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
        var firstElementValue = this.list.querySelector("li.e-list-item:not(.e-virtual-list)") ? this.list.querySelector("li.e-list-item:not(.e-virtual-list)").getAttribute("data-value") : null;
        nextOffset = this.fields.groupBy && !(0, $3EnZW.isUndefined)(this.fixedHeaderElement) ? nextOffset - this.fixedHeaderElement.offsetHeight : nextOffset;
        var boxRange = selectedLiOffsetTop - virtualListCount * (selectedLI.offsetHeight + selectedListMargin) + (selectedLI.offsetHeight + selectedListMargin) - this.list.scrollTop;
        var isPageUpKeyAction = this.enableVirtualization && this.getModuleName() === "autocomplete" && nextOffset <= 0;
        if (activeIndex === 0 && !this.enableVirtualization) this.list.scrollTop = 0;
        else if (nextOffset < 0 || isPageUpKeyAction) {
            var currentElementValue = selectedLI ? selectedLI.getAttribute("data-value") : null;
            var liCount = keyCode === 33 ? this.getPageCount() - 2 : 1;
            if (this.enableVirtualization && this.isKeyBoardAction && firstElementValue && currentElementValue === firstElementValue && keyCode !== 36 && !this.isVirtualScrolling) {
                this.isUpwardScrolling = true;
                this.isPreventKeyAction = true;
                this.isKeyBoardAction = false;
                this.list.scrollTop -= (selectedLI.offsetHeight + selectedListMargin) * liCount;
                this.isPreventKeyAction = this.list.scrollTop !== 0 ? this.isPreventKeyAction : false;
                this.isPreventScrollAction = false;
            } else if (this.enableVirtualization && keyCode === 36) {
                this.isPreventScrollAction = false;
                this.isPreventKeyAction = true;
                this.isKeyBoardAction = false;
                this.list.scrollTo(0, 0);
            } else {
                if (keyCode === 33 && this.enableVirtualization && !this.isVirtualScrolling) {
                    this.isPreventKeyAction = false;
                    this.isKeyBoardAction = false;
                    this.isPreventScrollAction = false;
                }
                this.list.scrollTop = this.list.scrollTop + nextOffset;
            }
        } else if (!(boxRange > 0 && this.list.offsetHeight > boxRange)) this.list.scrollTop = selectedLI.offsetTop - (this.fields.groupBy && !(0, $3EnZW.isNullOrUndefined)(this.fixedHeaderElement) ? this.fixedHeaderElement.offsetHeight : 0);
    };
    MultiSelect.prototype.isScrollerAtEnd = function() {
        return this.list && this.list.scrollTop + this.list.clientHeight >= this.list.scrollHeight;
    };
    MultiSelect.prototype.selectListByKey = function(e) {
        var li = this.list.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        var limit = this.value && this.value.length ? this.value.length : 0;
        var target;
        if (li !== null) {
            e.preventDefault();
            if (li.classList.contains("e-active")) limit = limit - 1;
            if (this.isValidLI(li) && limit < this.maximumSelectionLength) {
                this.updateListSelection(li, e);
                this.addListFocus(li);
                if (this.mode === "CheckBox") {
                    this.updateDelimView();
                    this.updateDelimeter(this.delimiterChar, e);
                    this.refreshInputHight();
                    this.checkPlaceholderSize();
                    if (this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
                        target = li.firstElementChild.lastElementChild;
                        this.findGroupStart(target);
                        this.deselectHeader();
                    }
                } else this.updateDelimeter(this.delimiterChar, e);
                this.makeTextBoxEmpty();
                if (this.mode !== "CheckBox") this.refreshListItems(li.textContent);
                if (!this.changeOnBlur) this.updateValueState(e, this.value, this.tempValues);
                this.refreshPopup();
            } else if (!this.isValidLI(li) && limit < this.maximumSelectionLength) {
                target = li.firstElementChild.lastElementChild;
                if (target.classList.contains("e-check")) this.selectAllItem(false, e, li);
                else this.selectAllItem(true, e, li);
            }
            this.refreshSelection();
            if (this.closePopupOnSelect) this.hidePopup(e);
        }
        var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
        if (selectAllParent && selectAllParent.classList.contains("e-item-focus")) {
            var selectAllCheckBox = selectAllParent.childNodes[0];
            if (!selectAllCheckBox.classList.contains("e-check")) {
                selectAllCheckBox.classList.add("e-check");
                var args = {
                    module: "CheckBoxSelection",
                    enable: this.mode === "CheckBox",
                    value: "check",
                    name: "checkSelectAll"
                };
                this.notify("checkSelectAll", args);
                this.selectAllItem(true, e, li);
            } else {
                selectAllCheckBox.classList.remove("e-check");
                var args = {
                    module: "CheckBoxSelection",
                    enable: this.mode === "CheckBox",
                    value: "check",
                    name: "checkSelectAll"
                };
                this.notify("checkSelectAll", args);
                this.selectAllItem(false, e, li);
            }
        }
        this.refreshPlaceHolder();
    };
    MultiSelect.prototype.refreshListItems = function(data) {
        if ((this.allowFiltering || this.mode === "CheckBox" && this.enableSelectionOrder === true || this.allowCustomValue) && this.mainList && this.listData) {
            var list = this.mainList.cloneNode ? this.mainList.cloneNode(true) : this.mainList;
            if (this.enableVirtualization) {
                if (this.allowCustomValue && this.virtualCustomData && data == null && this.virtualCustomData && this.viewPortInfo && this.viewPortInfo.startIndex === 0 && this.viewPortInfo.endIndex === this.itemCount) {
                    this.virtualCustomData = null;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.renderItems(this.mainData, this.fields);
                } else this.onActionComplete(this.list, this.listData);
            } else this.onActionComplete(list, this.mainData);
            this.focusAtLastListItem(data);
            if (this.value && this.value.length) this.refreshSelection();
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy) && this.value && this.value.length) this.refreshSelection();
    };
    MultiSelect.prototype.removeSelectedChip = function(e) {
        var selectedElem = this.chipCollectionWrapper.querySelector("span." + $717505a12e9203b8$var$CHIP_SELECTED);
        var temp;
        if (selectedElem !== null) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.value)) this.tempValues = this.allowObjectBinding ? this.value.slice() : this.value.slice();
            temp = selectedElem.nextElementSibling;
            if (temp !== null) {
                this.removeChipSelection();
                this.addChipSelection(temp, e);
            }
            var currentChip = this.allowObjectBinding ? this.getDataByValue(this.getFormattedValue(selectedElem.getAttribute("data-value"))) : selectedElem.getAttribute("data-value");
            this.removeValue(currentChip, e);
            this.makeTextBoxEmpty();
        }
        if (this.closePopupOnSelect) this.hidePopup(e);
        this.checkPlaceholderSize();
    };
    MultiSelect.prototype.moveByTop = function(state) {
        var elements = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        var index;
        if (elements.length > 1) {
            this.removeFocus();
            index = state ? 0 : elements.length - 1;
            this.addListFocus(elements[index]);
            this.scrollBottom(elements[index], index);
        }
        this.updateAriaAttribute();
    };
    MultiSelect.prototype.clickHandler = function(e) {
        var targetElement = e.target;
        var filterInputClassName = targetElement.className;
        var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
        if ((filterInputClassName === "e-input-filter e-input" || filterInputClassName === "e-input-group e-control-wrapper e-input-focus") && selectAllParent.classList.contains("e-item-focus")) selectAllParent.classList.remove("e-item-focus");
    };
    MultiSelect.prototype.moveByList = function(position, isVirtualKeyAction) {
        if (this.list) {
            var elements = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
            if (this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) elements = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ",li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)");
            var selectedElem = this.list.querySelector("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            if (this.enableVirtualization && isVirtualKeyAction && !(0, $3EnZW.isNullOrUndefined)(this.currentFocuedListElement)) selectedElem = this.getElementByValue(this.getFormattedValue(this.currentFocuedListElement.getAttribute("data-value")));
            var temp = -1;
            var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
            if (this.mode === "CheckBox" && this.showSelectAll && position === 1 && !(0, $3EnZW.isNullOrUndefined)(selectAllParent) && !selectAllParent.classList.contains("e-item-focus") && this.list.getElementsByClassName("e-item-focus").length === 0 && this.liCollections.length > 1) {
                if (!this.focusFirstListItem && selectAllParent.classList.contains("e-item-focus")) selectAllParent.classList.remove("e-item-focus");
                else if (!selectAllParent.classList.contains("e-item-focus")) selectAllParent.classList.add("e-item-focus");
            } else if (elements.length) {
                if (this.mode === "CheckBox" && this.showSelectAll && !(0, $3EnZW.isNullOrUndefined)(selectAllParent && position === -1)) {
                    if (!this.focusFirstListItem && selectAllParent.classList.contains("e-item-focus")) selectAllParent.classList.remove("e-item-focus");
                    else if (this.focusFirstListItem && !selectAllParent.classList.contains("e-item-focus")) selectAllParent.classList.add("e-item-focus");
                }
                for(var index = 0; index < elements.length; index++)if (elements[index] === selectedElem) {
                    temp = index;
                    break;
                }
                if (position > 0) {
                    if (temp < elements.length - 1) {
                        this.removeFocus();
                        if (this.enableVirtualization && isVirtualKeyAction) this.addListFocus(elements[temp]);
                        else if (this.enableVirtualization && elements[temp + 1].classList.contains("e-virtual-list")) this.addListFocus(elements[this.skeletonCount]);
                        else this.addListFocus(elements[++temp]);
                        if (temp > -1) {
                            this.updateCheck(elements[temp]);
                            this.scrollBottom(elements[temp], temp);
                            this.currentFocuedListElement = elements[temp];
                        }
                    }
                } else if (temp > 0) {
                    if (this.enableVirtualization) {
                        var isVirtualElement = elements[temp - 1].classList.contains("e-virtual-list");
                        var elementIndex = isVirtualKeyAction ? temp : temp - 1;
                        if (isVirtualKeyAction || !isVirtualElement) this.removeFocus();
                        if (isVirtualKeyAction || !isVirtualElement) {
                            this.addListFocus(elements[elementIndex]);
                            this.updateCheck(elements[elementIndex]);
                            this.scrollTop(elements[elementIndex], temp);
                            this.currentFocuedListElement = elements[elementIndex];
                        }
                    } else {
                        this.removeFocus();
                        this.addListFocus(elements[--temp]);
                        this.updateCheck(elements[temp]);
                        this.scrollTop(elements[temp], temp);
                    }
                }
            }
        }
        var focusedLi = this.list ? this.list.querySelector(".e-item-focus") : null;
        if (this.isDisabledElement(focusedLi)) {
            if (this.list.querySelectorAll(".e-list-item:not(.e-hide-listitem):not(.e-disabled)").length === 0 || this.keyCode === 38 && this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy) && focusedLi === this.list.querySelector("li.e-list-group-item")) {
                this.removeFocus();
                return;
            }
            var index = this.getIndexByValue(focusedLi.getAttribute("data-value"));
            if (index === 0 && this.mode !== "CheckBox") position = 1;
            if (index === this.list.querySelectorAll(".e-list-item:not(.e-hide-listitem)").length - 1) position = -1;
            this.moveByList(position);
        }
    };
    MultiSelect.prototype.getElementByValue = function(value) {
        var item;
        var listItems = this.getItems();
        for(var _i = 0, listItems_1 = listItems; _i < listItems_1.length; _i++){
            var liItem = listItems_1[_i];
            if (this.getFormattedValue(liItem.getAttribute("data-value")) === value) {
                item = liItem;
                break;
            }
        }
        return item;
    };
    MultiSelect.prototype.updateCheck = function(element) {
        if (this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
            var checkElement = element.firstElementChild.lastElementChild;
            if (checkElement.classList.contains("e-check")) element.classList.add("e-active");
            else element.classList.remove("e-active");
        }
    };
    MultiSelect.prototype.moveBy = function(position, e) {
        var temp;
        var elements = this.chipCollectionWrapper.querySelectorAll("span." + $717505a12e9203b8$var$CHIP);
        var selectedElem = this.chipCollectionWrapper.querySelector("span." + $717505a12e9203b8$var$CHIP_SELECTED);
        if (selectedElem === null) {
            if (position < 0) this.addChipSelection(elements[elements.length - 1], e);
        } else if (position < 0) {
            temp = selectedElem.previousElementSibling;
            if (temp !== null) {
                this.removeChipSelection();
                this.addChipSelection(temp, e);
            }
        } else {
            temp = selectedElem.nextElementSibling;
            this.removeChipSelection();
            if (temp !== null) this.addChipSelection(temp, e);
        }
    };
    MultiSelect.prototype.chipClick = function(e) {
        if (this.enabled) {
            var elem = (0, $4ZDHT.closest)(e.target, "." + $717505a12e9203b8$var$CHIP);
            this.removeChipSelection();
            this.addChipSelection(elem, e);
        }
    };
    MultiSelect.prototype.removeChipSelection = function() {
        if (this.chipCollectionWrapper) this.removeChipFocus();
    };
    MultiSelect.prototype.addChipSelection = function(element, e) {
        (0, $4ZDHT.addClass)([
            element
        ], $717505a12e9203b8$var$CHIP_SELECTED);
        this.trigger("chipSelection", e);
    };
    MultiSelect.prototype.onChipRemove = function(e) {
        if (e.which === 3 || e.button === 2) return;
        if (this.enabled && !this.readonly) {
            var element = e.target.parentElement;
            var customVal = element.getAttribute("data-value");
            var value = this.allowObjectBinding ? this.getDataByValue(this.getFormattedValue(customVal)) : this.getFormattedValue(customVal);
            if (this.allowCustomValue && (customVal !== "false" && value === false || !(0, $3EnZW.isNullOrUndefined)(value) && value.toString() === "NaN")) value = customVal;
            if (this.isPopupOpen() && this.mode !== "CheckBox") this.hidePopup(e);
            if (!this.inputFocus) this.inputElement.focus();
            this.removeValue(value, e);
            value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
            if ((0, $3EnZW.isNullOrUndefined)(this.findListElement(this.list, "li", "data-value", value)) && this.mainList && this.listData) {
                var list = this.mainList.cloneNode ? this.mainList.cloneNode(true) : this.mainList;
                this.onActionComplete(list, this.mainData);
            }
            this.updateDelimeter(this.delimiterChar, e);
            if (this.placeholder && this.floatLabelType === "Never") {
                this.makeTextBoxEmpty();
                this.checkPlaceholderSize();
            } else this.inputElement.value = "";
            e.preventDefault();
        }
    };
    MultiSelect.prototype.makeTextBoxEmpty = function() {
        this.inputElement.value = "";
        this.refreshPlaceHolder();
    };
    MultiSelect.prototype.refreshPlaceHolder = function() {
        if (this.placeholder && this.floatLabelType === "Never") {
            if (this.value && this.value.length || !(0, $3EnZW.isNullOrUndefined)(this.text) && this.text !== "") this.inputElement.placeholder = "";
            else this.inputElement.placeholder = (0, $805d2bf384e771bd$export$65d5c6c8b7a6e5d7)(this.placeholder);
        } else this.setFloatLabelType();
        this.expandTextbox();
    };
    MultiSelect.prototype.removeAllItems = function(value, eve, isClearAll, element, mainElement) {
        var index = this.allowObjectBinding ? this.indexOfObjectInArray(value, this.value) : this.value.indexOf(value);
        var removeVal = this.value.slice(0);
        removeVal.splice(index, 1);
        this.setProperties({
            value: [].concat([], removeVal)
        }, true);
        element.setAttribute("aria-selected", "false");
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        (0, $4ZDHT.removeClass)([
            element
        ], className);
        this.notify("activeList", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            li: element,
            e: this,
            index: index
        });
        this.invokeCheckboxSelection(element, eve, isClearAll);
        var currentValue = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
        this.updateMainList(true, currentValue, mainElement);
        this.updateChipStatus();
    };
    MultiSelect.prototype.invokeCheckboxSelection = function(element, eve, isClearAll) {
        this.notify("updatelist", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            li: element,
            e: eve
        });
        this.updateAriaActiveDescendant();
        if (this.value && this.value.length !== this.mainData.length && this.mode === "CheckBox" && this.showSelectAll && !(this.isSelectAll || isClearAll)) this.notify("checkSelectAll", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            value: "uncheck"
        });
    };
    MultiSelect.prototype.removeValue = function(value, eve, length, isClearAll) {
        var _this = this;
        var index = this.allowObjectBinding ? this.indexOfObjectInArray(value, this.value) : this.value.indexOf(this.getFormattedValue(value));
        if (index === -1 && this.allowCustomValue && !(0, $3EnZW.isNullOrUndefined)(value)) index = this.allowObjectBinding ? this.indexOfObjectInArray(value, this.value) : this.value.indexOf(value.toString());
        var targetEle = eve && eve.target;
        isClearAll = isClearAll || targetEle && targetEle.classList.contains("e-close-hooker") ? true : null;
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        if (index !== -1) {
            var currentValue = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
            var element_1 = this.virtualSelectAll ? null : this.findListElement(this.list, "li", "data-value", currentValue);
            var val_1 = this.allowObjectBinding ? value : this.getDataByValue(value);
            var eventArgs = {
                e: eve,
                item: element_1,
                itemData: val_1,
                isInteracted: eve ? true : false,
                cancel: false
            };
            this.trigger("removing", eventArgs, function(eventArgs) {
                if (eventArgs.cancel) _this.removeIndex++;
                else {
                    _this.isRemoveSelection = true;
                    _this.currentRemoveValue = _this.allowObjectBinding ? (0, $3EnZW.getValue)(_this.fields.value ? _this.fields.value : "", value) : value;
                    _this.virtualSelectAll = false;
                    var removeVal = _this.value.slice(0);
                    removeVal.splice(index, 1);
                    if (_this.enableVirtualization && _this.mode === "CheckBox") _this.selectedListData.splice(index, 1);
                    _this.setProperties({
                        value: [].concat([], removeVal)
                    }, true);
                    if (_this.enableVirtualization) {
                        var currentText = index === 0 && _this.text.split(_this.delimiterChar) && _this.text.split(_this.delimiterChar).length === 1 ? _this.text.replace(_this.text.split(_this.delimiterChar)[index], "") : index === 0 ? _this.text.replace(_this.text.split(_this.delimiterChar)[index] + _this.delimiterChar, "") : _this.text.replace(_this.delimiterChar + _this.text.split(_this.delimiterChar)[index], "");
                        _this.setProperties({
                            text: currentText.toString()
                        }, true);
                    }
                    if (element_1 !== null) {
                        var currentValue_1 = _this.allowObjectBinding ? (0, $3EnZW.getValue)(_this.fields.value ? _this.fields.value : "", value) : value;
                        var hideElement = _this.findListElement(_this.mainList, "li", "data-value", currentValue_1);
                        element_1.setAttribute("aria-selected", "false");
                        (0, $4ZDHT.removeClass)([
                            element_1
                        ], className);
                        if (hideElement) {
                            hideElement.setAttribute("aria-selected", "false");
                            (0, $4ZDHT.removeClass)([
                                element_1,
                                hideElement
                            ], className);
                        }
                        _this.notify("activeList", {
                            module: "CheckBoxSelection",
                            enable: _this.mode === "CheckBox",
                            li: element_1,
                            e: _this,
                            index: index
                        });
                        _this.invokeCheckboxSelection(element_1, eve, isClearAll);
                    }
                    var currentValue_2 = _this.allowObjectBinding ? (0, $3EnZW.getValue)(_this.fields.value ? _this.fields.value : "", value) : value;
                    if (_this.hideSelectedItem && _this.fields.groupBy && element_1) _this.hideGroupItem(currentValue_2);
                    if (_this.hideSelectedItem && _this.fixedHeaderElement && _this.fields.groupBy && _this.mode !== "CheckBox" && _this.isPopupOpen()) _super.prototype.scrollStop.call(_this);
                    _this.updateMainList(true, currentValue_2);
                    _this.removeChip(currentValue_2, isClearAll);
                    _this.updateChipStatus();
                    var limit = _this.value && _this.value.length ? _this.value.length : 0;
                    if (limit < _this.maximumSelectionLength) {
                        var collection = _this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-active)");
                        (0, $4ZDHT.removeClass)(collection, "e-disable");
                    }
                    _this.trigger("removed", eventArgs);
                    var targetEle_1 = eve && eve.currentTarget;
                    var isSelectAll = targetEle_1 && targetEle_1.classList.contains("e-selectall-parent") ? true : null;
                    if (!_this.changeOnBlur && !isClearAll && eve && length && !isSelectAll && _this.isSelectAllTarget) _this.updateValueState(eve, _this.value, _this.tempValues);
                    if (length) {
                        _this.selectAllEventData.push(val_1);
                        _this.selectAllEventEle.push(element_1);
                    }
                    if (length === 1) {
                        if (!_this.changeOnBlur) _this.updateValueState(eve, _this.value, _this.tempValues);
                        var args = {
                            event: eve,
                            items: _this.selectAllEventEle,
                            itemData: _this.selectAllEventData,
                            isInteracted: eve ? true : false,
                            isChecked: false
                        };
                        _this.trigger("selectedAll", args);
                        _this.selectAllEventData = [];
                        _this.selectAllEventEle = [];
                    }
                    if (isClearAll && (length === 1 || length === null)) _this.clearAllCallback(eve, isClearAll);
                    if (_this.isPopupOpen() && element_1 && element_1.parentElement.classList.contains("e-reorder")) {
                        if (_this.hideSelectedItem && _this.value && Array.isArray(_this.value) && _this.value.length > 0) _this.totalItemsCount();
                        _this.notify("setCurrentViewDataAsync", {
                            module: "VirtualScroll"
                        });
                    }
                }
            });
        }
    };
    MultiSelect.prototype.updateMainList = function(state, value, mainElement) {
        if (this.allowFiltering || this.mode === "CheckBox") {
            var element2 = mainElement ? mainElement : this.findListElement(this.mainList, "li", "data-value", value);
            if (element2) {
                if (state) {
                    element2.setAttribute("aria-selected", "false");
                    (0, $4ZDHT.removeClass)([
                        element2
                    ], this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                    if (this.mode === "CheckBox") (0, $4ZDHT.removeClass)([
                        element2.firstElementChild.lastElementChild
                    ], "e-check");
                } else {
                    element2.setAttribute("aria-selected", "true");
                    (0, $4ZDHT.addClass)([
                        element2
                    ], this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                    if (this.mode === "CheckBox") (0, $4ZDHT.addClass)([
                        element2.firstElementChild.lastElementChild
                    ], "e-check");
                }
            }
        }
    };
    MultiSelect.prototype.removeChip = function(value, isClearAll) {
        if (this.chipCollectionWrapper) {
            if (!(this.enableVirtualization && isClearAll)) {
                var element = this.findListElement(this.chipCollectionWrapper, "span", "data-value", value);
                if (element) (0, $4ZDHT.remove)(element);
            }
        }
    };
    MultiSelect.prototype.setWidth = function(width) {
        if (!(0, $3EnZW.isNullOrUndefined)(width)) {
            if (typeof width === "number") this.overAllWrapper.style.width = (0, $3EnZW.formatUnit)(width);
            else if (typeof width === "string") this.overAllWrapper.style.width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        }
    };
    MultiSelect.prototype.updateChipStatus = function() {
        if (this.value && this.value.length) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.chipCollectionWrapper)) this.chipCollectionWrapper.style.display = "";
            if (this.mode === "Delimiter" || this.mode === "CheckBox") this.showDelimWrapper();
            this.showOverAllClear();
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(this.chipCollectionWrapper)) this.chipCollectionWrapper.style.display = "none";
            if (!(0, $3EnZW.isNullOrUndefined)(this.delimiterWrapper)) this.delimiterWrapper.style.display = "none";
            this.hideOverAllClear();
        }
    };
    MultiSelect.prototype.indexOfObjectInArray = function(objectToFind, array) {
        var _loop_1 = function(i) {
            var item = array[i];
            // eslint-disable-next-line no-prototype-builtins
            if (Object.keys(objectToFind).every(function(key) {
                return item.hasOwnProperty(key) && item[key] === objectToFind[key];
            })) return {
                value: i
            };
        };
        for(var i = 0; i < array.length; i++){
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object") return state_1.value;
        }
        return -1; // Return -1 if the object is not found
    };
    MultiSelect.prototype.addValue = function(value, text, eve) {
        if (!this.value) this.value = [];
        var currentValue = this.allowObjectBinding ? this.getDataByValue(value) : value;
        if (this.allowObjectBinding && !this.isObjectInArray(this.getDataByValue(value), this.value) || !this.allowObjectBinding && this.value.indexOf(currentValue) < 0) {
            this.setProperties({
                value: [].concat([], this.value, [
                    currentValue
                ])
            }, true);
            if (this.enableVirtualization && !this.isSelectAllLoop) {
                var data = this.viewWrapper.innerHTML;
                var temp = void 0;
                data += this.value.length === 1 ? "" : this.delimiterChar + " ";
                temp = this.getOverflowVal(this.value.length - 1);
                data += temp;
                temp = this.viewWrapper.innerHTML;
                this.updateWrapperText(this.viewWrapper, data);
            }
            if (this.enableVirtualization && this.mode === "CheckBox") {
                var currentText = [];
                var value_1 = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[this.value.length - 1]) : this.value[this.value.length - 1];
                var temp = text;
                var textValues = this.text != null && this.text !== "" ? this.text + "," + temp : temp;
                currentText.push(textValues);
                this.setProperties({
                    text: currentText.toString()
                }, true);
            }
        }
        var element = this.findListElement(this.list, "li", "data-value", value);
        this.removeFocus();
        if (element) {
            this.addListFocus(element);
            this.addListSelection(element);
        }
        if (this.mode !== "Delimiter" && this.mode !== "CheckBox") this.addChip(text, value, eve);
        if (this.hideSelectedItem && this.fields.groupBy) this.hideGroupItem(value);
        this.updateChipStatus();
        this.checkMaxSelection();
    };
    MultiSelect.prototype.checkMaxSelection = function() {
        var limit = this.value && this.value.length ? this.value.length : 0;
        if (limit === this.maximumSelectionLength) {
            var activeItems = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ".e-active");
            (0, $4ZDHT.removeClass)(activeItems, "e-disable");
            var inactiveItems = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-active)");
            (0, $4ZDHT.addClass)(inactiveItems, "e-disable");
        }
        if (limit < this.maximumSelectionLength) {
            var collection = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
            (0, $4ZDHT.removeClass)(collection, "e-disable");
        }
    };
    MultiSelect.prototype.dispatchSelect = function(value, eve, element, isNotTrigger, length, dataValue, text) {
        var _this = this;
        var list = this.listData;
        if (this.initStatus && !isNotTrigger) {
            value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
            var val_2 = dataValue ? dataValue : this.getDataByValue(value);
            var eventArgs = {
                e: eve,
                item: element,
                itemData: val_2,
                isInteracted: eve ? true : false,
                cancel: false
            };
            this.trigger("select", eventArgs, function(eventArgs) {
                if (!eventArgs.cancel) {
                    if (length) {
                        _this.selectAllEventData.push(val_2);
                        _this.selectAllEventEle.push(element);
                    }
                    if (length === 1) {
                        var args = {
                            event: eve,
                            items: _this.selectAllEventEle,
                            itemData: _this.selectAllEventData,
                            isInteracted: eve ? true : false,
                            isChecked: true
                        };
                        _this.trigger("selectedAll", args);
                        _this.selectAllEventData = [];
                    }
                    if (_this.allowCustomValue && _this.isServerRendered && _this.listData !== list) _this.listData = list;
                    value = _this.allowObjectBinding ? _this.getDataByValue(value) : value;
                    if (_this.enableVirtualization) {
                        if ((0, $3EnZW.isNullOrUndefined)(_this.selectedListData)) _this.selectedListData = [
                            _this.getDataByValue(value)
                        ];
                        else {
                            if (dataValue) {
                                if (Array.isArray(_this.selectedListData)) _this.selectedListData.push(dataValue);
                                else _this.selectedListData = [
                                    _this.selectedListData,
                                    dataValue
                                ];
                            } else if (Array.isArray(_this.selectedListData)) _this.selectedListData.push(_this.getDataByValue(value));
                            else _this.selectedListData = [
                                _this.selectedListData,
                                _this.getDataByValue(value)
                            ];
                        }
                    }
                    if (_this.enableVirtualization && value || !_this.enableVirtualization) _this.updateListSelectEventCallback(value, element, eve, text);
                    if (_this.hideSelectedItem && _this.fixedHeaderElement && _this.fields.groupBy && _this.mode !== "CheckBox") _super.prototype.scrollStop.call(_this);
                }
            });
        }
    };
    MultiSelect.prototype.addChip = function(text, value, e) {
        if (this.chipCollectionWrapper) this.getChip(text, value, e);
    };
    MultiSelect.prototype.removeChipFocus = function() {
        var elements = this.chipCollectionWrapper.querySelectorAll("span." + $717505a12e9203b8$var$CHIP + "." + $717505a12e9203b8$var$CHIP_SELECTED);
        (0, $4ZDHT.removeClass)(elements, $717505a12e9203b8$var$CHIP_SELECTED);
        if ((0, $5q7BP.Browser).isDevice) {
            var closeElements = this.chipCollectionWrapper.querySelectorAll("span." + $717505a12e9203b8$var$CHIP_CLOSE.split(" ")[0]);
            for(var index = 0; index < closeElements.length; index++)closeElements[index].style.display = "none";
        }
    };
    MultiSelect.prototype.onMobileChipInteraction = function(e) {
        var chipElem = (0, $4ZDHT.closest)(e.target, "." + $717505a12e9203b8$var$CHIP);
        var chipClose = chipElem.querySelector("span." + $717505a12e9203b8$var$CHIP_CLOSE.split(" ")[0]);
        if (this.enabled && !this.readonly) {
            if (!chipElem.classList.contains($717505a12e9203b8$var$CHIP_SELECTED)) {
                this.removeChipFocus();
                chipClose.style.display = "";
                chipElem.classList.add($717505a12e9203b8$var$CHIP_SELECTED);
            }
            this.refreshPopup();
            e.preventDefault();
        }
    };
    MultiSelect.prototype.multiCompiler = function(multiselectTemplate) {
        var checkTemplate = false;
        if (typeof multiselectTemplate !== "function" && multiselectTemplate) try {
            checkTemplate = (0, $4ZDHT.selectAll)(multiselectTemplate, document).length ? true : false;
        } catch (exception) {
            checkTemplate = false;
        }
        return checkTemplate;
    };
    MultiSelect.prototype.encodeHtmlEntities = function(input) {
        return input.replace(/[\u00A0-\u9999<>&]/g, function(match) {
            return "&#" + match.charCodeAt(0) + ";";
        });
    };
    MultiSelect.prototype.getChip = function(data, value, e) {
        var _this = this;
        var itemData = {
            text: value,
            value: value
        };
        var chip = this.createElement("span", {
            className: $717505a12e9203b8$var$CHIP,
            attrs: {
                "data-value": value,
                "title": data
            }
        });
        var compiledString;
        var chipContent = this.createElement("span", {
            className: $717505a12e9203b8$var$CHIP_CONTENT
        });
        var chipClose = this.createElement("span", {
            className: $717505a12e9203b8$var$CHIP_CLOSE
        });
        if (this.mainData) itemData = this.getDataByValue(value);
        if (this.valueTemplate && !(0, $3EnZW.isNullOrUndefined)(itemData)) {
            var valuecheck = this.multiCompiler(this.valueTemplate);
            if (typeof this.valueTemplate !== "function" && valuecheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(this.valueTemplate, document).innerHTML.trim());
            else compiledString = (0, $c2qqN.compile)(this.valueTemplate);
            var valueCompTemp = compiledString(itemData, this, "valueTemplate", this.valueTemplateId, this.isStringTemplate, null, chipContent);
            if (valueCompTemp && valueCompTemp.length > 0) (0, $4ZDHT.append)(valueCompTemp, chipContent);
            this.renderReactTemplates();
        } else if (this.enableHtmlSanitizer) chipContent.innerText = data;
        else chipContent.innerHTML = this.encodeHtmlEntities(data.toString());
        chip.appendChild(chipContent);
        var eventArgs = {
            isInteracted: e ? true : false,
            itemData: itemData,
            e: e,
            setClass: function(classes) {
                (0, $4ZDHT.addClass)([
                    chip
                ], classes);
            },
            cancel: false
        };
        this.isPreventChange = this.isAngular && this.preventChange;
        this.trigger("tagging", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel) {
                if ((0, $5q7BP.Browser).isDevice) {
                    chip.classList.add($717505a12e9203b8$var$MOBILE_CHIP);
                    (0, $4ZDHT.append)([
                        chipClose
                    ], chip);
                    chipClose.style.display = "none";
                    (0, $aqzbR.EventHandler).add(chip, "click", _this.onMobileChipInteraction, _this);
                } else {
                    (0, $aqzbR.EventHandler).add(chip, "mousedown", _this.chipClick, _this);
                    if (_this.showClearButton) chip.appendChild(chipClose);
                }
                (0, $aqzbR.EventHandler).add(chipClose, "mousedown", _this.onChipRemove, _this);
                _this.chipCollectionWrapper.appendChild(chip);
                if (!_this.changeOnBlur && e) _this.updateValueState(e, _this.value, _this.tempValues);
            }
        });
    };
    MultiSelect.prototype.calcPopupWidth = function() {
        var width = (0, $3EnZW.formatUnit)(this.popupWidth);
        if (width.indexOf("%") > -1) {
            var inputWidth = this.componentWrapper.offsetWidth * parseFloat(width) / 100;
            width = inputWidth.toString() + "px";
        }
        return width;
    };
    MultiSelect.prototype.mouseIn = function() {
        if (this.enabled && !this.readonly) this.showOverAllClear();
    };
    MultiSelect.prototype.mouseOut = function() {
        if (!this.inputFocus) this.overAllClear.style.display = "none";
    };
    MultiSelect.prototype.listOption = function(dataSource, fields) {
        var iconCss = (0, $3EnZW.isNullOrUndefined)(fields.iconCss) ? false : true;
        var fieldProperty = (0, $3EnZW.isNullOrUndefined)(fields.properties) ? fields : fields.properties;
        this.listCurrentOptions = fields.text !== null || fields.value !== null ? {
            fields: fieldProperty,
            showIcon: iconCss,
            ariaAttributes: {
                groupItemRole: "presentation"
            }
        } : {
            fields: {
                value: "text"
            }
        };
        (0, $3EnZW.extend)(this.listCurrentOptions, this.listCurrentOptions, fields, true);
        if (this.mode === "CheckBox") this.notify("listoption", {
            module: "CheckBoxSelection",
            enable: this.mode === "CheckBox",
            dataSource: dataSource,
            fieldProperty: fieldProperty
        });
        return this.listCurrentOptions;
    };
    MultiSelect.prototype.renderPopup = function() {
        var _this = this;
        if (!this.list) _super.prototype.render.call(this);
        if (!this.popupObj) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.popupWrapper)) {
                document.body.appendChild(this.popupWrapper);
                var checkboxFilter = this.popupWrapper.querySelector("." + $717505a12e9203b8$var$FILTERPARENT);
                if (this.mode === "CheckBox" && !this.allowFiltering && checkboxFilter && this.filterParent) {
                    checkboxFilter.remove();
                    this.filterParent = null;
                }
                var overAllHeight = parseInt(this.popupHeight, 10);
                this.popupWrapper.style.visibility = "hidden";
                if (this.headerTemplate) {
                    this.setHeaderTemplate();
                    overAllHeight -= this.header.offsetHeight;
                }
                (0, $4ZDHT.append)([
                    this.list
                ], this.popupWrapper);
                if (!this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData) && this.getItems()[1]) this.listItemHeight = this.getItems()[1].offsetHeight + parseInt(window.getComputedStyle(this.getItems()[1]).marginBottom, 10);
                if (this.enableVirtualization && !this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData)) {
                    if (!this.list.querySelector(".e-virtual-ddl-content") && this.list.querySelector(".e-list-parent")) this.list.appendChild(this.createElement("div", {
                        className: "e-virtual-ddl-content",
                        styles: this.getTransformValues()
                    })).appendChild(this.list.querySelector(".e-list-parent"));
                    else if (this.list.querySelector(".e-virtual-ddl-content")) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                    this.UpdateSkeleton();
                    this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                    this.virtualItemCount = this.itemCount;
                    if (this.mode !== "CheckBox") this.totalItemsCount();
                    if (!this.list.querySelector(".e-virtual-ddl")) {
                        var virualElement = this.createElement("div", {
                            id: this.element.id + "_popup",
                            className: "e-virtual-ddl",
                            styles: this.GetVirtualTrackHeight()
                        });
                        this.popupWrapper.querySelector(".e-dropdownbase").appendChild(virualElement);
                    } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
                }
                if (this.footerTemplate) {
                    this.setFooterTemplate();
                    overAllHeight -= this.footer.offsetHeight;
                }
                if (this.mode === "CheckBox" && this.showSelectAll) {
                    this.notify("selectAll", {
                        module: "CheckBoxSelection",
                        enable: this.mode === "CheckBox"
                    });
                    overAllHeight -= this.selectAllHeight;
                } else if (this.mode === "CheckBox" && !this.showSelectAll && !this.headerTemplate && !this.footerTemplate) {
                    this.notify("selectAll", {
                        module: "CheckBoxSelection",
                        enable: this.mode === "CheckBox"
                    });
                    overAllHeight = parseInt(this.popupHeight, 10);
                } else if (this.mode === "CheckBox" && !this.showSelectAll) {
                    this.notify("selectAll", {
                        module: "CheckBoxSelection",
                        enable: this.mode === "CheckBox"
                    });
                    overAllHeight = parseInt(this.popupHeight, 10);
                    if (this.headerTemplate && this.header) overAllHeight -= this.header.offsetHeight;
                    if (this.footerTemplate && this.footer) overAllHeight -= this.footer.offsetHeight;
                }
                if (this.mode === "CheckBox") {
                    var args = {
                        module: "CheckBoxSelection",
                        enable: this.mode === "CheckBox",
                        popupElement: this.popupWrapper
                    };
                    if (this.allowFiltering) {
                        this.notify("searchBox", args);
                        overAllHeight -= this.searchBoxHeight;
                    }
                    (0, $4ZDHT.addClass)([
                        this.popupWrapper
                    ], "e-checkbox");
                }
                if (this.popupHeight !== "auto") {
                    this.list.style.maxHeight = (0, $3EnZW.formatUnit)(overAllHeight);
                    this.popupWrapper.style.maxHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
                } else this.list.style.maxHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
                this.popupObj = new (0, $2vAqh.Popup)(this.popupWrapper, {
                    width: this.calcPopupWidth(),
                    targetType: "relative",
                    position: this.enableRtl ? {
                        X: "right",
                        Y: "bottom"
                    } : {
                        X: "left",
                        Y: "bottom"
                    },
                    relateTo: this.overAllWrapper,
                    collision: this.enableRtl ? {
                        X: "fit",
                        Y: "flip"
                    } : {
                        X: "flip",
                        Y: "flip"
                    },
                    offsetY: 1,
                    enableRtl: this.enableRtl,
                    zIndex: this.zIndex,
                    close: function() {
                        if (_this.popupObj.element.parentElement) {
                            _this.popupObj.unwireScrollEvents();
                            // For restrict the page scrolling in safari browser
                            var checkboxFilterInput = _this.popupWrapper.querySelector("." + $717505a12e9203b8$var$FILTERINPUT);
                            if (_this.mode === "CheckBox" && checkboxFilterInput && document.activeElement === checkboxFilterInput) checkboxFilterInput.blur();
                            (0, $4ZDHT.detach)(_this.popupObj.element);
                        }
                    },
                    open: function() {
                        _this.popupObj.resolveCollision();
                        if (!_this.isFirstClick) {
                            var ulElement = _this.list.querySelector("ul");
                            if (ulElement) {
                                if (!(_this.mode !== "CheckBox" && (_this.allowFiltering || _this.allowCustomValue) && _this.targetElement().trim() !== "")) _this.mainList = ulElement.cloneNode ? ulElement.cloneNode(true) : ulElement;
                            }
                            _this.isFirstClick = true;
                        }
                        _this.popupObj.wireScrollEvents();
                        if (!(_this.mode !== "CheckBox" && (_this.allowFiltering || _this.allowCustomValue) && _this.targetElement().trim() !== "") && !_this.enableVirtualization) {
                            _this.loadTemplate();
                            if (_this.enableVirtualization && _this.mode === "CheckBox") _this.UpdateSkeleton();
                        }
                        _this.isPreventScrollAction = true;
                        _this.setScrollPosition();
                        if (!_this.list.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData) && _this.getItems()[1] && _this.getItems()[1].offsetHeight !== 0) {
                            _this.listItemHeight = _this.getItems()[1].offsetHeight + parseInt(window.getComputedStyle(_this.getItems()[1]).marginBottom, 10);
                            if (_this.list.getElementsByClassName("e-virtual-ddl-content")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            _this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = _this.getTransformValues();
                        }
                        if (_this.allowFiltering) _this.notify("inputFocus", {
                            module: "CheckBoxSelection",
                            enable: _this.mode === "CheckBox",
                            value: "focus"
                        });
                        if (_this.enableVirtualization) {
                            _this.notify("bindScrollEvent", {
                                module: "VirtualScroll",
                                component: _this.getModuleName(),
                                enable: _this.enableVirtualization
                            });
                            setTimeout(function() {
                                if (_this.value) _this.updateSelectionList();
                                else if (_this.viewPortInfo && _this.viewPortInfo.offsets.top) _this.list.scrollTop = _this.viewPortInfo.offsets.top;
                            }, 5);
                        }
                    },
                    targetExitViewport: function() {
                        if (!(0, $5q7BP.Browser).isDevice) _this.hidePopup();
                    }
                });
                this.checkCollision(this.popupWrapper);
                this.popupContentElement = this.popupObj.element.querySelector(".e-content");
                if (this.mode === "CheckBox" && (0, $5q7BP.Browser).isDevice && this.allowFiltering && this.isDeviceFullScreen) this.notify("deviceSearchBox", {
                    module: "CheckBoxSelection",
                    enable: this.mode === "CheckBox"
                });
                this.popupObj.close();
                this.popupWrapper.style.visibility = "";
            }
        }
    };
    MultiSelect.prototype.checkCollision = function(popupEle) {
        if (!(this.mode === "CheckBox" && (0, $5q7BP.Browser).isDevice && this.allowFiltering && this.isDeviceFullScreen)) {
            var collision = (0, $49u5W.isCollide)(popupEle);
            if (collision.length > 0) popupEle.style.marginTop = -parseInt(getComputedStyle(popupEle).marginTop, 10) + "px";
            this.popupObj.resolveCollision();
        }
    };
    MultiSelect.prototype.setHeaderTemplate = function() {
        var compiledString;
        if (this.header) this.header.remove();
        this.header = this.createElement("div");
        (0, $4ZDHT.addClass)([
            this.header
        ], $717505a12e9203b8$var$HEADER);
        var headercheck = this.multiCompiler(this.headerTemplate);
        if (typeof this.headerTemplate !== "function" && headercheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(this.headerTemplate, document).innerHTML.trim());
        else compiledString = (0, $c2qqN.compile)(this.headerTemplate);
        // eslint-disable-next-line
        var elements = compiledString({}, this, "headerTemplate", this.headerTemplateId, this.isStringTemplate, null, this.header);
        if (elements && elements.length > 0) (0, $4ZDHT.append)(elements, this.header);
        if (this.mode === "CheckBox" && this.showSelectAll) (0, $4ZDHT.prepend)([
            this.header
        ], this.popupWrapper);
        else (0, $4ZDHT.append)([
            this.header
        ], this.popupWrapper);
        (0, $aqzbR.EventHandler).add(this.header, "mousedown", this.onListMouseDown, this);
    };
    MultiSelect.prototype.setFooterTemplate = function() {
        var compiledString;
        if (this.footer) this.footer.remove();
        this.footer = this.createElement("div");
        (0, $4ZDHT.addClass)([
            this.footer
        ], $717505a12e9203b8$var$FOOTER);
        var footercheck = this.multiCompiler(this.footerTemplate);
        if (typeof this.footerTemplate !== "function" && footercheck) compiledString = (0, $c2qqN.compile)((0, $4ZDHT.select)(this.footerTemplate, document).innerHTML.trim());
        else compiledString = (0, $c2qqN.compile)(this.footerTemplate);
        // eslint-disable-next-line
        var elements = compiledString({}, this, "footerTemplate", this.footerTemplateId, this.isStringTemplate, null, this.footer);
        if (elements && elements.length > 0) (0, $4ZDHT.append)(elements, this.footer);
        (0, $4ZDHT.append)([
            this.footer
        ], this.popupWrapper);
        (0, $aqzbR.EventHandler).add(this.footer, "mousedown", this.onListMouseDown, this);
    };
    MultiSelect.prototype.updateInitialData = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var currentData = this.selectData;
        var ulElement = this.renderItems(currentData, this.fields);
        this.list.scrollTop = 0;
        this.virtualListInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: this.itemCount
        };
        this.previousStartIndex = 0;
        this.previousEndIndex = 0;
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            if (this.remoteDataCount >= 0) this.totalItemCount = this.dataCount = this.remoteDataCount;
            else this.resetList(this.dataSource);
        } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = this.dataCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        if (this.mode !== "CheckBox") this.totalItemCount = this.value && this.value.length ? this.totalItemCount - this.value.length : this.totalItemCount;
        this.getSkeletonCount();
        this.UpdateSkeleton();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.list.getElementsByClassName("e-virtual-ddl")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
        else if (!this.list.querySelector(".e-virtual-ddl") && this.skeletonCount > 0) {
            var virualElement = this.createElement("div", {
                id: this.element.id + "_popup",
                className: "e-virtual-ddl",
                styles: this.GetVirtualTrackHeight()
            });
            this.popupWrapper.querySelector(".e-dropdownbase").appendChild(virualElement);
        }
        this.listData = currentData;
        this.liCollections = this.list.querySelectorAll(".e-list-item");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.list.getElementsByClassName("e-virtual-ddl-content")[0]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
        if (this.enableVirtualization) this.notify("setGeneratedData", {
            module: "VirtualScroll"
        });
    };
    MultiSelect.prototype.clearAll = function(e) {
        if (this.enabled && !this.readonly) {
            var temp = void 0;
            if (this.value && this.value.length > 0) {
                if (this.allowFiltering) {
                    this.refreshListItems(null);
                    if (this.mode === "CheckBox" && this.targetInputElement) this.targetInputElement.value = "";
                }
                var liElement = this.list && this.list.querySelectorAll("li.e-list-item");
                if (liElement && liElement.length > 0) this.selectAllItems(false, e);
                else {
                    this.removeIndex = 0;
                    for(temp = this.value[this.removeIndex]; this.removeIndex < this.value.length; temp = this.value[this.removeIndex])this.removeValue(temp, e, null, true);
                }
                this.selectedElementID = null;
                this.inputElement.removeAttribute("aria-activedescendant");
            } else this.clearAllCallback(e);
            this.checkAndResetCache();
            (0, $168e4e125732cd26$export$f5b8910cec6cf069).createSpanElement(this.overAllWrapper, this.createElement);
            this.calculateWidth();
            if (!(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper) && !(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper.getElementsByClassName("e-ddl-icon")[0] && this.overAllWrapper.getElementsByClassName("e-float-text-content")[0] && this.floatLabelType !== "Never")) this.overAllWrapper.getElementsByClassName("e-float-text-content")[0].classList.add("e-icon");
            if (this.enableVirtualization) {
                this.updateInitialData();
                if (this.chipCollectionWrapper) this.chipCollectionWrapper.innerHTML = "";
                if (!this.isCustomDataUpdated) this.notify("setGeneratedData", {
                    module: "VirtualScroll"
                });
            }
            if (this.enableVirtualization) {
                this.list.scrollTop = 0;
                this.virtualListInfo = null;
                this.previousStartIndex = 0;
                this.previousEndIndex = 0;
            }
        }
    };
    MultiSelect.prototype.clearAllCallback = function(e, isClearAll) {
        var tempValues = this.value ? this.value.slice() : [];
        if (this.mainList && this.listData && (this.allowFiltering && this.mode !== "CheckBox" || this.allowCustomValue)) {
            var list = this.mainList.cloneNode ? this.mainList.cloneNode(true) : this.mainList;
            this.onActionComplete(list, this.mainData);
        }
        this.focusAtFirstListItem();
        this.updateDelimeter(this.delimiterChar, e);
        if (this.mode !== "Box" && (!this.inputFocus || this.mode === "CheckBox")) this.updateDelimView();
        if (this.inputElement.value !== "") {
            this.makeTextBoxEmpty();
            this.search(null);
        }
        this.checkPlaceholderSize();
        if (this.isPopupOpen()) this.refreshPopup();
        if (!this.inputFocus) {
            if (this.changeOnBlur) this.updateValueState(e, this.value, tempValues);
            if (this.mode !== "CheckBox") this.inputElement.focus();
        }
        if (this.mode === "CheckBox") {
            this.refreshPlaceHolder();
            this.refreshInputHight();
            if (this.changeOnBlur && isClearAll && ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0)) this.updateValueState(e, this.value, this.tempValues);
        }
        if (!this.changeOnBlur && isClearAll && ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0)) this.updateValueState(e, this.value, this.tempValues);
        if (this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) this.updateListItems(this.list.querySelectorAll("li.e-list-item"), this.mainList.querySelectorAll("li.e-list-item"));
        e.preventDefault();
    };
    MultiSelect.prototype.windowResize = function() {
        this.refreshPopup();
        if ((!this.inputFocus || this.mode === "CheckBox") && this.viewWrapper && this.viewWrapper.parentElement) this.updateDelimView();
    };
    MultiSelect.prototype.resetValueHandler = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) {
            var formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
            if (formElement && e.target === formElement) {
                var textVal = this.element.tagName === this.getNgDirective() ? null : this.element.getAttribute("data-initial-value");
                this.text = textVal;
            }
        }
    };
    MultiSelect.prototype.wireEvent = function() {
        (0, $aqzbR.EventHandler).add(this.componentWrapper, "mousedown", this.wrapperClick, this);
        (0, $aqzbR.EventHandler).add(window, "resize", this.windowResize, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "focus", this.focusInHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "keydown", this.onKeyDown, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.keyUp, this);
        if (this.mode !== "CheckBox") (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.onInput, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "blur", this.onBlurHandler, this);
        (0, $aqzbR.EventHandler).add(this.componentWrapper, "mouseover", this.mouseIn, this);
        var formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
        if (formElement) (0, $aqzbR.EventHandler).add(formElement, "reset", this.resetValueHandler, this);
        (0, $aqzbR.EventHandler).add(this.componentWrapper, "mouseout", this.mouseOut, this);
        (0, $aqzbR.EventHandler).add(this.overAllClear, "mousedown", this.clearAll, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "paste", this.pasteHandler, this);
    };
    MultiSelect.prototype.onInput = function(e) {
        if (this.keyDownStatus) this.isValidKey = true;
        else this.isValidKey = false;
        this.keyDownStatus = false;
        // For Filtering works in mobile firefox
        if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).info.name === "mozilla") this.search(e);
    };
    MultiSelect.prototype.pasteHandler = function(event) {
        var _this = this;
        setTimeout(function() {
            _this.expandTextbox();
            _this.search(event);
        });
    };
    MultiSelect.prototype.search = function(e) {
        var _this = this;
        this.resetFilteredData = true;
        this.preventSetCurrentData = false;
        this.firstItem = this.dataSource && this.dataSource.length > 0 ? this.dataSource[0] : null;
        if (!(0, $3EnZW.isNullOrUndefined)(e)) this.keyCode = e.keyCode;
        if (!this.isPopupOpen() && this.openOnClick) this.showPopup(e);
        this.openClick(e);
        if (this.checkTextLength() && !this.allowFiltering && !(0, $3EnZW.isNullOrUndefined)(e) && e.keyCode !== 8) this.focusAtFirstListItem();
        else {
            var text = this.targetElement();
            if (this.allowFiltering) {
                if (this.allowCustomValue) this.isRemoteSelection = true;
                this.checkAndResetCache();
                this.isRequesting = false;
                var eventArgs_1 = {
                    preventDefaultAction: false,
                    text: this.targetElement(),
                    updateData: function(dataSource, query, fields) {
                        if (eventArgs_1.cancel) return;
                        _this.isFiltered = true;
                        _this.customFilterQuery = query;
                        _this.remoteFilterAction = true;
                        _this.dataUpdater(dataSource, query, fields);
                    },
                    event: e,
                    cancel: false
                };
                this.trigger("filtering", eventArgs_1, function(eventArgs) {
                    if (!eventArgs.cancel) {
                        if (!_this.isFiltered && !eventArgs.preventDefaultAction) {
                            _this.filterAction = true;
                            if (_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && _this.allowCustomValue) _this.isCustomRendered = false;
                            _this.dataUpdater(_this.dataSource, null, _this.fields);
                        }
                    }
                });
            } else if (this.allowCustomValue) {
                var query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
                query = this.allowFiltering && text !== "" ? query.where(this.fields.text, "startswith", text, this.ignoreCase, this.ignoreAccent) : query;
                if (this.enableVirtualization) this.dataUpdater(this.dataSource, query, this.fields);
                else this.dataUpdater(this.mainData, query, this.fields);
                this.UpdateSkeleton();
            } else {
                var liCollections = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-hide-listitem)");
                var type = this.typeOfData(this.listData).typeof;
                var activeElement = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.targetElement(), liCollections, "StartsWith", this.ignoreCase);
                if (this.enableVirtualization && this.targetElement().trim() !== "" && !this.allowFiltering) {
                    var updatingincrementalindex = false;
                    if (this.viewPortInfo.endIndex >= this.incrementalEndIndex && this.incrementalEndIndex <= this.totalItemCount || this.incrementalEndIndex === 0) {
                        updatingincrementalindex = true;
                        this.incrementalStartIndex = 0;
                        this.incrementalEndIndex = 100 > this.totalItemCount ? this.totalItemCount : 100;
                        this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                        updatingincrementalindex = false;
                    }
                    if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                    activeElement = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.targetElement(), this.incrementalLiCollections, this.filterType, true, this.listData, this.fields, type);
                    while((0, $3EnZW.isNullOrUndefined)(activeElement) && this.incrementalEndIndex < this.totalItemCount){
                        this.incrementalStartIndex = this.incrementalEndIndex;
                        this.incrementalEndIndex = this.incrementalEndIndex + 100 > this.totalItemCount ? this.totalItemCount : this.incrementalEndIndex + 100;
                        this.updateIncrementalInfo(this.incrementalStartIndex, this.incrementalEndIndex);
                        updatingincrementalindex = true;
                        if (this.viewPortInfo.startIndex !== 0 || updatingincrementalindex) this.updateIncrementalView(0, this.itemCount);
                        activeElement = (0, $2b58887f1686dbd7$export$4b85d3515bd863a5)(this.targetElement(), this.incrementalLiCollections, this.filterType, true, this.listData, this.fields, type);
                        if (!(0, $3EnZW.isNullOrUndefined)(activeElement)) break;
                        if ((0, $3EnZW.isNullOrUndefined)(activeElement) && this.incrementalEndIndex >= this.totalItemCount) {
                            this.incrementalStartIndex = 0;
                            this.incrementalEndIndex = 100 > this.totalItemCount ? this.totalItemCount : 100;
                            break;
                        }
                    }
                    if (activeElement.index) {
                        if (!(this.viewPortInfo.startIndex >= activeElement.index) || !(activeElement.index >= this.viewPortInfo.endIndex)) {
                            var startIndex = activeElement.index - (this.itemCount / 2 - 2) > 0 ? activeElement.index - (this.itemCount / 2 - 2) : 0;
                            var endIndex = startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : startIndex + this.itemCount;
                            if (startIndex !== this.viewPortInfo.startIndex) this.updateIncrementalView(startIndex, endIndex);
                        }
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(activeElement.item)) {
                        var index1 = this.getIndexByValue(activeElement.item.getAttribute("data-value")) - this.skeletonCount;
                        if (index1 > this.itemCount / 2) {
                            var startIndex = this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) < this.totalItemCount ? this.viewPortInfo.startIndex + (this.itemCount / 2 - 2) : this.totalItemCount;
                            var endIndex = this.viewPortInfo.startIndex + this.itemCount > this.totalItemCount ? this.totalItemCount : this.viewPortInfo.startIndex + this.itemCount;
                            this.updateIncrementalView(startIndex, endIndex);
                        }
                        activeElement.item = this.getElementByValue(activeElement.item.getAttribute("data-value"));
                    } else {
                        this.updateIncrementalView(0, this.itemCount);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                        this.list.scrollTop = 0;
                    }
                    if (activeElement && activeElement.item) activeElement.item = this.getElementByValue(activeElement.item.getAttribute("data-value"));
                }
                if (activeElement && activeElement.item) {
                    this.addListFocus(activeElement.item);
                    this.list.scrollTop = activeElement.item.offsetHeight * activeElement.index;
                } else if (this.targetElement() !== "") this.removeFocus();
                else this.focusAtFirstListItem();
            }
        }
        if (this.enableVirtualization && this.allowFiltering) this.getFilteringSkeletonCount();
    };
    MultiSelect.prototype.preRender = function() {
        if (this.allowFiltering === null) this.allowFiltering = this.mode === "CheckBox" ? true : false;
        this.preventSetCurrentData = false;
        this.initializeData();
        this.updateDataAttribute(this.htmlAttributes);
        _super.prototype.preRender.call(this);
    };
    MultiSelect.prototype.getLocaleName = function() {
        return "multi-select";
    };
    MultiSelect.prototype.initializeData = function() {
        this.mainListCollection = [];
        this.beforePopupOpen = false;
        this.filterAction = false;
        this.remoteFilterAction = false;
        this.isFirstClick = false;
        this.mobFilter = true;
        this.isFiltered = false;
        this.focused = true;
        this.initial = true;
        this.backCommand = true;
        this.isCustomRendered = false;
        this.isRemoteSelection = false;
        this.isSelectAllTarget = true;
        this.viewPortInfo = {
            currentPageNumber: null,
            direction: null,
            sentinelInfo: {},
            offsets: {},
            startIndex: 0,
            endIndex: this.itemCount
        };
    };
    MultiSelect.prototype.updateData = function(delimiterChar, e) {
        var data = "";
        var delim = this.mode === "Delimiter" || this.mode === "CheckBox";
        var text = [];
        var temp;
        var tempData = this.listData;
        if (!this.enableVirtualization) this.listData = this.mainData;
        if (!(0, $3EnZW.isNullOrUndefined)(this.hiddenElement) && !this.enableVirtualization) this.hiddenElement.innerHTML = "";
        if (!(0, $3EnZW.isNullOrUndefined)(this.value)) {
            var valueLength = this.value.length;
            var hiddenElementContent = "";
            var _loop_2 = function(index) {
                var valueItem = this_1.allowObjectBinding ? (0, $3EnZW.getValue)(this_1.fields.value ? this_1.fields.value : "", this_1.value[index]) : this_1.value[index];
                var listValue = this_1.findListElement(!(0, $3EnZW.isNullOrUndefined)(this_1.mainList) ? this_1.mainList : this_1.ulElement, "li", "data-value", valueItem);
                if (this_1.enableVirtualization) listValue = this_1.findListElement(!(0, $3EnZW.isNullOrUndefined)(this_1.list) ? this_1.list : this_1.ulElement, "li", "data-value", valueItem);
                if ((0, $3EnZW.isNullOrUndefined)(listValue) && !this_1.allowCustomValue && !this_1.enableVirtualization && this_1.listData && this_1.listData.length > 0) {
                    this_1.value.splice(index, 1);
                    index -= 1;
                    valueLength -= 1;
                } else {
                    if (this_1.listData) {
                        if (this_1.enableVirtualization) {
                            if (delim) data = this_1.delimiterWrapper && this_1.delimiterWrapper.innerHTML === "" ? data : this_1.delimiterWrapper.innerHTML;
                            var value = this_1.allowObjectBinding ? (0, $3EnZW.getValue)(this_1.fields.value ? this_1.fields.value : "", this_1.value[this_1.value.length - 1]) : this_1.value[this_1.value.length - 1];
                            if (this_1.isRemoveSelection) {
                                data = this_1.text.replace(/,/g, delimiterChar + " ") + delimiterChar + " ";
                                text = this_1.text.split(delimiterChar);
                            } else {
                                temp = this_1.getTextByValue(value);
                                var textValues = this_1.text != null && this_1.text !== "" ? this_1.text + "," + temp : temp;
                                data += temp + delimiterChar + " ";
                                text.push(textValues);
                                hiddenElementContent = this_1.hiddenElement.innerHTML;
                            }
                            if (e && e.currentTarget && e.currentTarget.classList.contains("e-chips-close") || e && e.key === "Backspace") {
                                var item_1 = e.target.parentElement.getAttribute("data-value");
                                if (e.key === "Backspace") {
                                    var lastChild = this_1.hiddenElement.lastChild;
                                    if (lastChild) this_1.hiddenElement.removeChild(lastChild);
                                } else this_1.hiddenElement.childNodes.forEach(function(option) {
                                    if (option.value === item_1) option.parentNode.removeChild(option);
                                });
                                hiddenElementContent = this_1.hiddenElement.innerHTML;
                            } else hiddenElementContent += "<option selected value='" + value + "'>" + index + "</option>";
                            return out_index_1 = index, "break";
                        } else temp = this_1.getTextByValue(valueItem);
                    } else temp = valueItem;
                    data += temp + delimiterChar + " ";
                    text.push(temp);
                }
                hiddenElementContent += '<option selected value="' + valueItem + '">' + index + "</option>";
                out_index_1 = index;
            };
            var this_1 = this, out_index_1;
            for(var index = 0; index < valueLength; index++){
                var state_2 = _loop_2(index);
                index = out_index_1;
                if (state_2 === "break") break;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.hiddenElement)) {
                if (this.isRemoveSelection) {
                    if (this.findListElement(this.hiddenElement, "option", "value", this.currentRemoveValue)) this.hiddenElement.removeChild(this.findListElement(this.hiddenElement, "option", "value", this.currentRemoveValue));
                    this.isRemoveSelection = false;
                } else this.hiddenElement.innerHTML = hiddenElementContent;
            }
        }
        var isChipRemove = e && e.target && e.target.classList.contains("e-chips-close");
        if (!this.enableVirtualization || this.enableVirtualization && this.mode !== "CheckBox" && !isChipRemove) this.setProperties({
            text: text.toString()
        }, true);
        if (delim) {
            this.updateWrapperText(this.delimiterWrapper, data);
            this.delimiterWrapper.setAttribute("id", (0, $3EnZW.getUniqueID)("delim_val"));
            this.inputElement.setAttribute("aria-describedby", this.delimiterWrapper.id);
        }
        var targetEle = e && e.target;
        var isClearAll = targetEle && targetEle.classList.contains("e-close-hooker") ? true : null;
        if (!this.changeOnBlur && e && !isClearAll || this.isSelectAll) {
            this.isSelectAll = false;
            this.updateValueState(e, this.value, this.tempValues);
        }
        this.listData = tempData;
        this.addValidInputClass();
    };
    MultiSelect.prototype.initialTextUpdate = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.text)) {
            var textArr = this.text.split(this.delimiterChar);
            var textVal = [];
            for(var index = 0; textArr.length > index; index++){
                var val = this.getValueByText(textArr[index]);
                if (!(0, $3EnZW.isNullOrUndefined)(val)) textVal.push(val);
                else if (this.allowCustomValue) textVal.push(textArr[index]);
            }
            if (textVal && textVal.length) {
                var value = this.allowObjectBinding ? this.getDataByValue(textVal) : textVal;
                this.setProperties({
                    value: value
                }, true);
            }
        } else this.setProperties({
            value: null
        }, true);
    };
    MultiSelect.prototype.renderList = function(isEmptyData) {
        if (!isEmptyData && this.allowCustomValue && this.list && (this.list.textContent === this.noRecordsTemplate || this.list.querySelector(".e-ul") && this.list.querySelector(".e-ul").childElementCount === 0)) isEmptyData = true;
        _super.prototype.render.call(this, null, isEmptyData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.totalItemCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        this.unwireListEvents();
        this.wireListEvents();
    };
    MultiSelect.prototype.initialValueUpdate = function(listItems, isInitialVirtualData) {
        if (this.list) {
            var text = void 0;
            var element = void 0;
            var value = void 0;
            if (this.chipCollectionWrapper) this.chipCollectionWrapper.innerHTML = "";
            this.removeListSelection();
            if (!(0, $3EnZW.isNullOrUndefined)(this.value)) for(var index = 0; !(0, $3EnZW.isNullOrUndefined)(this.value[index]); index++){
                value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[index]) : this.value[index];
                element = this.findListElement(this.hideSelectedItem ? this.ulElement : this.list, "li", "data-value", value);
                var isCustomData = false;
                if (this.enableVirtualization) {
                    text = null;
                    if (listItems != null && listItems.length > 0) {
                        for(var i = 0; i < listItems.length; i++)if ((0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "value", listItems[i]) === value) {
                            text = (0, $3EnZW.getValue)(this.fields.text, listItems[i]);
                            if (this.enableVirtualization) {
                                if ((0, $3EnZW.isNullOrUndefined)(this.selectedListData)) this.selectedListData = [
                                    listItems[i]
                                ];
                                else if (Array.isArray(this.selectedListData)) this.selectedListData.push(listItems[i]);
                                else this.selectedListData = [
                                    this.selectedListData,
                                    listItems[i]
                                ];
                            }
                            break;
                        }
                    }
                    if ((0, $3EnZW.isNullOrUndefined)(text) && this.allowCustomValue && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && isInitialVirtualData)) {
                        text = this.getTextByValue(value);
                        isCustomData = true;
                    }
                } else text = this.getTextByValue(value);
                if (element && element.getAttribute("aria-selected") !== "true" || element && element.getAttribute("aria-selected") === "true" && this.hideSelectedItem && (this.mode === "Box" || this.mode === "Default") || this.enableVirtualization && value != null && text != null && !isCustomData) {
                    var currentText = [];
                    var textValues = this.text != null && this.text !== "" ? this.text + "," + text : text;
                    currentText.push(textValues);
                    this.setProperties({
                        text: currentText.toString()
                    }, true);
                    this.addChip(text, value);
                    this.addListSelection(element);
                } else if (!this.enableVirtualization && value && this.allowCustomValue || this.enableVirtualization && value && this.allowCustomValue && (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && isInitialVirtualData)) {
                    var indexItem = this.listData.length;
                    var newValue = {};
                    (0, $3EnZW.setValue)(this.fields.text, value, newValue);
                    (0, $3EnZW.setValue)(this.fields.value, value, newValue);
                    var noDataEle = this.popupWrapper.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData);
                    if (!this.enableVirtualization) this.addItem(newValue, indexItem);
                    if (this.enableVirtualization) {
                        if (this.virtualCustomSelectData && this.virtualCustomSelectData.length >= 0) this.virtualCustomSelectData.push(newValue);
                        else this.virtualCustomSelectData = [
                            newValue
                        ];
                    }
                    element = element ? element : this.findListElement(this.hideSelectedItem ? this.ulElement : this.list, "li", "data-value", value);
                    if (this.popupWrapper.contains(noDataEle)) {
                        this.list.setAttribute("style", noDataEle.getAttribute("style"));
                        this.popupWrapper.replaceChild(this.list, noDataEle);
                        this.wireListEvents();
                    }
                    var currentText = [];
                    var textValues = this.text != null && this.text !== "" ? this.text + "," + text : text;
                    currentText.push(textValues);
                    this.setProperties({
                        text: currentText.toString()
                    }, true);
                    this.addChip(text, value);
                    this.addListSelection(element);
                }
            }
            if (this.mode === "CheckBox") {
                this.updateDelimView();
                if (this.changeOnBlur) this.updateValueState(null, this.value, this.tempValues);
                this.updateDelimeter(this.delimiterChar);
                this.refreshInputHight();
            } else this.updateDelimeter(this.delimiterChar);
            if (this.mode === "CheckBox" && this.showSelectAll && ((0, $3EnZW.isNullOrUndefined)(this.value) || !this.value.length)) this.notify("checkSelectAll", {
                module: "CheckBoxSelection",
                enable: this.mode === "CheckBox",
                value: "uncheck"
            });
            if (this.mode === "Box" || this.mode === "Default" && this.inputFocus) this.chipCollectionWrapper.style.display = "";
            else if (this.mode === "Delimiter" || this.mode === "CheckBox") this.showDelimWrapper();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MultiSelect.prototype.updateActionCompleteData = function(li, item) {
        if (this.value && (!this.allowObjectBinding && this.value.indexOf(li.getAttribute("data-value")) > -1 || this.allowObjectBinding && this.isObjectInArray(this.getDataByValue(li.getAttribute("data-value")), this.value))) {
            this.mainList = this.ulElement;
            if (this.hideSelectedItem) (0, $4ZDHT.addClass)([
                li
            ], $717505a12e9203b8$var$HIDE_LIST);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MultiSelect.prototype.updateAddItemList = function(list, itemCount) {
        if (this.popupObj && this.popupObj.element && this.popupObj.element.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).noData) && list) {
            this.list = list;
            this.mainList = this.ulElement = list.querySelector("ul");
            (0, $4ZDHT.remove)(this.popupWrapper.querySelector(".e-content"));
            this.popupObj = null;
            this.renderPopup();
        } else if (this.allowCustomValue) {
            this.list = list;
            this.mainList = this.ulElement = list.querySelector("ul");
        }
    };
    MultiSelect.prototype.updateDataList = function() {
        if (this.mainList && this.ulElement && !(this.isFiltered || this.filterAction || this.targetElement().trim())) {
            var isDynamicGroupItemUpdate = this.mainList.childElementCount < this.ulElement.childElementCount;
            var isReactTemplateUpdate = this.ulElement.childElementCount > 0 && this.ulElement.children[0].childElementCount > 0 && this.mainList.children[0] && this.mainList.children[0].childElementCount < this.ulElement.children[0].childElementCount;
            var isAngularTemplateUpdate = this.itemTemplate && this.ulElement.childElementCount > 0 && !(this.ulElement.childElementCount < this.mainList.childElementCount) && (this.ulElement.children[0].childElementCount > 0 || this.fields.groupBy && this.ulElement.children[1] && this.ulElement.children[1].childElementCount > 0);
            if (isDynamicGroupItemUpdate || isReactTemplateUpdate || isAngularTemplateUpdate) //EJ2-57748 - for this task, we prevent the ul element cloning ( this.mainList = this.ulElement.cloneNode ? <HTMLElement>this.ulElement.cloneNode(true) : this.ulElement;)
            this.mainList = this.ulElement;
        }
    };
    MultiSelect.prototype.isValidLI = function(li) {
        return li && !li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).disabled) && !li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group) && li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
    };
    MultiSelect.prototype.updateListSelection = function(li, e, length) {
        var customVal = li.getAttribute("data-value");
        var value = this.allowObjectBinding ? this.getDataByValue(this.getFormattedValue(customVal)) : this.getFormattedValue(customVal);
        if (this.allowCustomValue && (customVal !== "false" && value === false || !(0, $3EnZW.isNullOrUndefined)(value) && value.toString() === "NaN")) value = customVal;
        this.removeHover();
        if (!this.value || !this.allowObjectBinding && this.value.indexOf(value) === -1 || this.allowObjectBinding && this.indexOfObjectInArray(value, this.value) === -1) this.dispatchSelect(value, e, li, li.getAttribute("aria-selected") === "true", length);
        else this.removeValue(value, e, length);
    };
    MultiSelect.prototype.updateListSelectEventCallback = function(value, li, e, currentText) {
        var _this = this;
        value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
        var text = currentText ? currentText : this.getTextByValue(value);
        if ((this.allowCustomValue || this.allowFiltering) && !this.findListElement(this.mainList, "li", "data-value", value) && (!this.enableVirtualization || this.enableVirtualization && this.virtualCustomData)) {
            var temp_1 = li ? li.cloneNode(true) : li;
            var fieldValue = this.fields.value ? this.fields.value : "value";
            if (this.allowCustomValue && this.mainData.length && typeof (0, $3EnZW.getValue)(fieldValue, this.mainData[0]) === "number") value = !isNaN(parseFloat(value.toString())) ? parseFloat(value.toString()) : value;
            var data_1 = this.getDataByValue(value);
            var eventArgs = {
                newData: data_1,
                cancel: false
            };
            this.trigger("customValueSelection", eventArgs, function(eventArgs) {
                if (!eventArgs.cancel) {
                    if (_this.enableVirtualization && _this.virtualCustomData) {
                        if (_this.virtualCustomSelectData && _this.virtualCustomSelectData.length >= 0) _this.virtualCustomSelectData.push(data_1);
                        else _this.virtualCustomSelectData = [
                            data_1
                        ];
                        _this.remoteCustomValue = false;
                        _this.addValue(value, text, e);
                    } else {
                        (0, $4ZDHT.append)([
                            temp_1
                        ], _this.mainList);
                        _this.mainData.push(data_1);
                        _this.remoteCustomValue = false;
                        _this.addValue(value, text, e);
                    }
                }
            });
        } else {
            this.remoteCustomValue = false;
            this.addValue(value, text, e);
        }
    };
    MultiSelect.prototype.removeListSelection = function() {
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        var selectedItems = this.list.querySelectorAll("." + className);
        var temp = selectedItems.length;
        if (selectedItems && selectedItems.length) {
            (0, $4ZDHT.removeClass)(selectedItems, className);
            while(temp > 0){
                selectedItems[temp - 1].setAttribute("aria-selected", "false");
                temp--;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.mainList)) {
            var selectItems = this.mainList.querySelectorAll("." + className);
            var temp1 = selectItems.length;
            if (selectItems && selectItems.length) {
                (0, $4ZDHT.removeClass)(selectItems, className);
                while(temp1 > 0){
                    selectItems[temp1 - 1].setAttribute("aria-selected", "false");
                    if (this.mode === "CheckBox") {
                        if (selectedItems && selectedItems.length > temp1 - 1) (0, $4ZDHT.removeClass)([
                            selectedItems[temp1 - 1].firstElementChild.lastElementChild
                        ], "e-check");
                        (0, $4ZDHT.removeClass)([
                            selectItems[temp1 - 1].firstElementChild.lastElementChild
                        ], "e-check");
                    }
                    temp1--;
                }
            }
        }
    };
    MultiSelect.prototype.removeHover = function() {
        var hoveredItem = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        if (hoveredItem && hoveredItem.length) (0, $4ZDHT.removeClass)(hoveredItem, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
    };
    MultiSelect.prototype.removeFocus = function() {
        if (this.list && this.mainList) {
            var hoveredItem = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            var mainlist = this.mainList.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            if (hoveredItem && hoveredItem.length) {
                (0, $4ZDHT.removeClass)(hoveredItem, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
                (0, $4ZDHT.removeClass)(mainlist, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            }
        }
    };
    MultiSelect.prototype.addListHover = function(li) {
        if (this.enabled && this.isValidLI(li)) {
            this.removeHover();
            (0, $4ZDHT.addClass)([
                li
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        } else if (li !== null && li.classList.contains("e-list-group-item") && this.enableGroupCheckBox && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
            this.removeHover();
            (0, $4ZDHT.addClass)([
                li
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        }
    };
    MultiSelect.prototype.addListFocus = function(element) {
        if (this.enabled && (this.isValidLI(element) || this.fields.disabled && this.isDisabledElement(element))) {
            this.removeFocus();
            (0, $4ZDHT.addClass)([
                element
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            this.updateAriaActiveDescendant();
        } else if (this.enableGroupCheckBox && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
            (0, $4ZDHT.addClass)([
                element
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
            this.updateAriaActiveDescendant();
        }
    };
    MultiSelect.prototype.addListSelection = function(element, mainElement) {
        var className = this.hideSelectedItem ? $717505a12e9203b8$var$HIDE_LIST : (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected;
        if (this.isValidLI(element) && !element.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover)) {
            (0, $4ZDHT.addClass)([
                element
            ], className);
            this.updateMainList(false, element.getAttribute("data-value"), mainElement);
            element.setAttribute("aria-selected", "true");
            if (this.mode === "CheckBox" && element.classList.contains("e-active")) {
                var ariaCheck = element.getElementsByClassName("e-check").length;
                if (ariaCheck === 0) this.notify("updatelist", {
                    module: "CheckBoxSelection",
                    enable: this.mode === "CheckBox",
                    li: element,
                    e: this
                });
            }
            this.notify("activeList", {
                module: "CheckBoxSelection",
                enable: this.mode === "CheckBox",
                li: element,
                e: this
            });
            if (this.chipCollectionWrapper) this.removeChipSelection();
            this.selectedElementID = element.id;
        }
    };
    MultiSelect.prototype.updateDelimeter = function(delimChar, e) {
        this.updateData(delimChar, e);
    };
    MultiSelect.prototype.onMouseClick = function(e) {
        var _this = this;
        this.keyCode = null;
        this.scrollFocusStatus = false;
        this.keyboardEvent = null;
        var target = e.target;
        var li = (0, $4ZDHT.closest)(target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        if (this.enableVirtualization && li && li.classList.contains("e-virtual-list")) return;
        var headerLi = (0, $4ZDHT.closest)(target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group);
        if (headerLi && this.enableGroupCheckBox && this.mode === "CheckBox" && this.fields.groupBy) {
            target = target.classList.contains("e-list-group-item") ? target.firstElementChild.lastElementChild : e.target;
            if (target.classList.contains("e-check")) {
                this.selectAllItem(false, e);
                target.classList.remove("e-check");
                target.classList.remove("e-stop");
                (0, $4ZDHT.closest)(target, ".e-list-group-item").classList.remove("e-active");
                target.setAttribute("aria-selected", "false");
            } else {
                this.selectAllItem(true, e);
                target.classList.remove("e-stop");
                target.classList.add("e-check");
                (0, $4ZDHT.closest)(target, ".e-list-group-item").classList.add("e-active");
                target.setAttribute("aria-selected", "true");
            }
            this.refreshSelection();
            this.checkSelectAll();
        } else {
            if (this.isValidLI(li)) {
                var limit = this.value && this.value.length ? this.value.length : 0;
                if (li.classList.contains("e-active")) limit = limit - 1;
                if (limit < this.maximumSelectionLength) {
                    this.updateListSelection(li, e);
                    this.checkPlaceholderSize();
                    this.addListFocus(li);
                    if ((this.allowCustomValue || this.allowFiltering) && this.mainList && this.listData) {
                        if (this.mode !== "CheckBox") {
                            this.focusAtLastListItem(li.getAttribute("data-value"));
                            this.refreshSelection();
                        }
                    } else this.makeTextBoxEmpty();
                }
                if (this.mode === "CheckBox") {
                    this.updateDelimView();
                    if (this.value && this.value.length > 50) setTimeout(function() {
                        _this.updateDelimeter(_this.delimiterChar, e);
                    }, 0);
                    else this.updateDelimeter(this.delimiterChar, e);
                    this.refreshInputHight();
                } else this.updateDelimeter(this.delimiterChar, e);
                this.checkSelectAll();
                this.refreshPopup();
                if (this.hideSelectedItem) this.focusAtFirstListItem();
                if (this.closePopupOnSelect) this.hidePopup(e);
                else e.preventDefault();
                this.makeTextBoxEmpty();
                this.findGroupStart(target);
                if (this.mode !== "CheckBox") this.refreshListItems((0, $3EnZW.isNullOrUndefined)(li) ? null : li.textContent);
            } else e.preventDefault();
            if (this.enableVirtualization && this.hideSelectedItem) {
                var visibleListElements = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)" + ":not(.e-virtual-list)");
                if (visibleListElements.length) {
                    var actualCount = this.virtualListHeight > 0 ? Math.floor(this.virtualListHeight / this.listItemHeight) : 0;
                    if (visibleListElements.length < actualCount + 2) {
                        var query = this.getForQuery(this.value).clone();
                        query = query.skip(this.virtualItemStartIndex);
                        this.resetList(this.dataSource, this.fields, query);
                        this.UpdateSkeleton();
                        this.liCollections = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
                        this.virtualItemCount = this.itemCount;
                        if (this.mode !== "CheckBox") this.totalItemCount = this.value && this.value.length ? this.totalItemCount - this.value.length : this.totalItemCount;
                        if (!this.list.querySelector(".e-virtual-ddl")) {
                            var virualElement = this.createElement("div", {
                                id: this.element.id + "_popup",
                                className: "e-virtual-ddl",
                                styles: this.GetVirtualTrackHeight()
                            });
                            this.popupWrapper.querySelector(".e-dropdownbase").appendChild(virualElement);
                        } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        this.list.getElementsByClassName("e-virtual-ddl")[0].style = this.GetVirtualTrackHeight();
                        if (this.list.querySelector(".e-virtual-ddl-content")) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        this.list.getElementsByClassName("e-virtual-ddl-content")[0].style = this.getTransformValues();
                    }
                }
            }
            this.refreshPlaceHolder();
            this.deselectHeader();
        }
    };
    MultiSelect.prototype.findGroupStart = function(target) {
        if (this.enableGroupCheckBox && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
            var count = 0;
            var liChecked = 0;
            var liUnchecked = 0;
            var groupValues = void 0;
            if (this.itemTemplate && !target.getElementsByClassName("e-frame").length) while(!target.getElementsByClassName("e-frame").length)target = target.parentElement;
            if (target.classList.contains("e-frame")) target = target.parentElement.parentElement;
            groupValues = this.findGroupAttrtibutes(target, liChecked, liUnchecked, count, 0);
            groupValues = this.findGroupAttrtibutes(target, groupValues[0], groupValues[1], groupValues[2], 1);
            while(!target.classList.contains("e-list-group-item")){
                if (target.classList.contains("e-list-icon")) target = target.parentElement;
                target = target.previousElementSibling;
                if (target == null) break;
            }
            this.updateCheckBox(target, groupValues[0], groupValues[1], groupValues[2]);
        }
    };
    MultiSelect.prototype.findGroupAttrtibutes = function(listElement, checked, unChecked, count, position) {
        while(!listElement.classList.contains("e-list-group-item")){
            if (!(this.fields.disabled && this.isDisabledElement(listElement))) {
                if (listElement.classList.contains("e-list-icon")) listElement = listElement.parentElement;
                if (listElement.getElementsByClassName("e-frame")[0].classList.contains("e-check") && listElement.classList.contains("e-list-item")) checked++;
                else if (listElement.classList.contains("e-list-item")) unChecked++;
                count++;
            }
            listElement = position ? listElement.nextElementSibling : listElement.previousElementSibling;
            if (listElement == null) break;
        }
        return [
            checked,
            unChecked,
            count
        ];
    };
    MultiSelect.prototype.updateCheckBox = function(groupHeader, checked, unChecked, count) {
        if (groupHeader === null || !(0, $3EnZW.isNullOrUndefined)(this.fields.disabled) && count === 0) return;
        var checkBoxElement = groupHeader.getElementsByClassName("e-frame")[0];
        if (count === checked) {
            checkBoxElement.classList.remove("e-stop");
            checkBoxElement.classList.add("e-check");
            (0, $4ZDHT.closest)(checkBoxElement, ".e-list-group-item").classList.add("e-active");
            groupHeader.setAttribute("aria-selected", "true");
        } else if (count === unChecked) {
            checkBoxElement.classList.remove("e-check");
            checkBoxElement.classList.remove("e-stop");
            (0, $4ZDHT.closest)(checkBoxElement, ".e-list-group-item").classList.remove("e-active");
            groupHeader.setAttribute("aria-selected", "false");
        } else if (this.maximumSelectionLength === checked - 1) {
            checkBoxElement.classList.remove("e-stop");
            groupHeader.setAttribute("aria-selected", "true");
            (0, $4ZDHT.closest)(checkBoxElement, ".e-list-group-item").classList.add("e-active");
            checkBoxElement.classList.add("e-check");
        } else {
            checkBoxElement.classList.remove("e-check");
            checkBoxElement.classList.add("e-stop");
            (0, $4ZDHT.closest)(checkBoxElement, ".e-list-group-item").classList.add("e-active");
            groupHeader.setAttribute("aria-selected", "false");
        }
    };
    MultiSelect.prototype.disableGroupHeader = function() {
        var collection = this.list.querySelectorAll("li.e-list-group-item");
        if (collection) for(var index = 0; index < collection.length; index++){
            var isDisabled = true;
            var target = collection[index].nextElementSibling;
            while(!target.classList.contains("e-list-group-item")){
                if (!this.isDisabledElement(target)) {
                    isDisabled = false;
                    break;
                }
                target = target.nextElementSibling;
                if (target == null) break;
            }
            if (isDisabled) this.disableListItem(collection[index]);
        }
    };
    MultiSelect.prototype.deselectHeader = function() {
        var limit = this.value && this.value.length ? this.value.length : 0;
        var collection = this.list.querySelectorAll("li.e-list-group-item:not(.e-active)");
        if (limit < this.maximumSelectionLength) (0, $4ZDHT.removeClass)(collection, "e-disable");
        if (limit === this.maximumSelectionLength) (0, $4ZDHT.addClass)(collection, "e-disable");
    };
    MultiSelect.prototype.onMouseOver = function(e) {
        var currentLi = (0, $4ZDHT.closest)(e.target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        if (currentLi === null && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy) && this.enableGroupCheckBox) currentLi = (0, $4ZDHT.closest)(e.target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).group);
        this.addListHover(currentLi);
    };
    MultiSelect.prototype.onMouseLeave = function() {
        this.removeHover();
    };
    MultiSelect.prototype.onListMouseDown = function(e) {
        e.preventDefault();
        this.scrollFocusStatus = true;
    };
    MultiSelect.prototype.onDocumentClick = function(e) {
        if (this.mode !== "CheckBox") {
            var target = e.target;
            if (!(!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && (0, $4ZDHT.closest)(target, '[id="' + this.popupObj.element.id + '"]')) && !this.overAllWrapper.contains(e.target)) this.scrollFocusStatus = false;
            else this.scrollFocusStatus = ((0, $5q7BP.Browser).isIE || (0, $5q7BP.Browser).info.name === "edge") && document.activeElement === this.inputElement;
        }
    };
    MultiSelect.prototype.wireListEvents = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) {
            (0, $aqzbR.EventHandler).add(document, "mousedown", this.onDocumentClick, this);
            (0, $aqzbR.EventHandler).add(this.list, "mousedown", this.onListMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.list, "mouseup", this.onMouseClick, this);
            (0, $aqzbR.EventHandler).add(this.list, "mouseover", this.onMouseOver, this);
            (0, $aqzbR.EventHandler).add(this.list, "mouseout", this.onMouseLeave, this);
        }
    };
    MultiSelect.prototype.unwireListEvents = function() {
        (0, $aqzbR.EventHandler).remove(document, "mousedown", this.onDocumentClick);
        if (this.list) {
            (0, $aqzbR.EventHandler).remove(this.list, "mousedown", this.onListMouseDown);
            (0, $aqzbR.EventHandler).remove(this.list, "mouseup", this.onMouseClick);
            (0, $aqzbR.EventHandler).remove(this.list, "mouseover", this.onMouseOver);
            (0, $aqzbR.EventHandler).remove(this.list, "mouseout", this.onMouseLeave);
        }
    };
    MultiSelect.prototype.hideOverAllClear = function() {
        if (!this.value || !this.value.length || this.inputElement.value === "") this.overAllClear.style.display = "none";
    };
    MultiSelect.prototype.showOverAllClear = function() {
        if ((this.value && this.value.length || this.inputElement.value !== "") && this.showClearButton && this.readonly !== true) this.overAllClear.style.display = "";
        else this.overAllClear.style.display = "none";
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */ MultiSelect.prototype.focusIn = function() {
        if (document.activeElement !== this.inputElement && this.enabled) this.inputElement.focus();
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */ MultiSelect.prototype.focusOut = function() {
        if (document.activeElement === this.inputElement && this.enabled) this.inputElement.blur();
    };
    /**
     * Shows the spinner loader.
     *
     * @returns {void}
     */ MultiSelect.prototype.showSpinner = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            var filterClear = this.filterParent && this.filterParent.querySelector(".e-clear-icon.e-icons");
            if (this.overAllClear.style.display !== "none" || filterClear) this.spinnerElement = filterClear ? filterClear : this.overAllClear;
            else {
                this.spinnerElement = this.createElement("span", {
                    className: $717505a12e9203b8$var$CLOSEICON_CLASS + " " + $717505a12e9203b8$var$SPINNER_CLASS
                });
                this.componentWrapper.appendChild(this.spinnerElement);
            }
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: this.spinnerElement,
                width: (0, $5q7BP.Browser).isDevice ? "16px" : "14px"
            }, this.createElement);
            (0, $4ZDHT.addClass)([
                this.spinnerElement
            ], $717505a12e9203b8$var$DISABLE_ICON);
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinnerElement);
        }
    };
    /**
     * Hides the spinner loader.
     *
     * @returns {void}
     */ MultiSelect.prototype.hideSpinner = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
            (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinnerElement);
            (0, $4ZDHT.removeClass)([
                this.spinnerElement
            ], $717505a12e9203b8$var$DISABLE_ICON);
            if (this.spinnerElement.classList.contains($717505a12e9203b8$var$SPINNER_CLASS)) (0, $4ZDHT.detach)(this.spinnerElement);
            else this.spinnerElement.innerHTML = "";
            this.spinnerElement = null;
        }
    };
    MultiSelect.prototype.updateWrapperText = function(wrapperType, wrapperData) {
        if (this.valueTemplate || !this.enableHtmlSanitizer) wrapperType.innerHTML = this.encodeHtmlEntities(wrapperData);
        else wrapperType.innerText = wrapperData;
    };
    MultiSelect.prototype.updateDelimView = function() {
        if (this.delimiterWrapper) this.hideDelimWrapper();
        if (this.chipCollectionWrapper) this.chipCollectionWrapper.style.display = "none";
        if (!(0, $3EnZW.isNullOrUndefined)(this.viewWrapper)) {
            this.viewWrapper.style.display = "";
            this.viewWrapper.style.width = "";
            this.viewWrapper.classList.remove($717505a12e9203b8$var$TOTAL_COUNT_WRAPPER);
        }
        if (this.value && this.value.length) {
            var data = "";
            var temp = void 0;
            var tempData = void 0;
            var tempIndex = 1;
            var wrapperleng = void 0;
            var remaining = void 0;
            var downIconWidth = 0;
            var overAllContainer = void 0;
            if (!this.enableVirtualization) this.updateWrapperText(this.viewWrapper, data);
            var l10nLocale = {
                noRecordsTemplate: "No records found",
                actionFailureTemplate: "Request failed",
                overflowCountTemplate: "+${count} more..",
                totalCountTemplate: "${count} selected"
            };
            var l10n = new (0, $e7i2H.L10n)(this.getLocaleName(), l10nLocale, this.locale);
            if (l10n.getConstant("actionFailureTemplate") === "") l10n = new (0, $e7i2H.L10n)("dropdowns", l10nLocale, this.locale);
            if (l10n.getConstant("noRecordsTemplate") === "") l10n = new (0, $e7i2H.L10n)("dropdowns", l10nLocale, this.locale);
            var remainContent = l10n.getConstant("overflowCountTemplate");
            var totalContent = l10n.getConstant("totalCountTemplate");
            var raminElement = this.createElement("span", {
                className: $717505a12e9203b8$var$REMAIN_WRAPPER
            });
            var remainCompildTemp = remainContent.replace("${count}", this.value.length.toString());
            raminElement.innerText = remainCompildTemp;
            this.viewWrapper.appendChild(raminElement);
            this.renderReactTemplates();
            var remainSize = raminElement.offsetWidth;
            (0, $4ZDHT.remove)(raminElement);
            if (this.showDropDownIcon) downIconWidth = this.dropIcon.offsetWidth + parseInt(window.getComputedStyle(this.dropIcon).marginRight, 10);
            this.checkClearIconWidth();
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && (this.allowCustomValue || this.listData && this.listData.length > 0)) for(var index = 0; !(0, $3EnZW.isNullOrUndefined)(this.value[index]); index++){
                var items = this.text && this.text.split(this.delimiterChar);
                if (!this.enableVirtualization) {
                    data += index === 0 ? "" : this.delimiterChar + " ";
                    temp = this.getOverflowVal(index);
                    data += temp;
                    temp = this.viewWrapper.innerHTML;
                    this.updateWrapperText(this.viewWrapper, data);
                } else if (items) {
                    data += index === 0 ? "" : this.delimiterChar + " ";
                    temp = items[index];
                    data += temp;
                    temp = this.viewWrapper.innerHTML;
                    this.updateWrapperText(this.viewWrapper, data);
                }
                wrapperleng = this.viewWrapper.offsetWidth + parseInt(window.getComputedStyle(this.viewWrapper).paddingRight, 10);
                overAllContainer = this.componentWrapper.offsetWidth - parseInt(window.getComputedStyle(this.componentWrapper).paddingLeft, 10) - parseInt(window.getComputedStyle(this.componentWrapper).paddingRight, 10);
                if (wrapperleng + downIconWidth + this.clearIconWidth > overAllContainer) {
                    if (tempData !== undefined && tempData !== "") {
                        temp = tempData;
                        index = tempIndex + 1;
                    }
                    this.updateWrapperText(this.viewWrapper, temp);
                    remaining = this.value.length - index;
                    wrapperleng = this.viewWrapper.offsetWidth + parseInt(window.getComputedStyle(this.viewWrapper).paddingRight, 10);
                    while(wrapperleng + remainSize + downIconWidth + this.clearIconWidth > overAllContainer && wrapperleng !== 0 && this.viewWrapper.innerHTML !== ""){
                        var textArr = [];
                        this.viewWrapper.innerHTML = textArr.join(this.delimiterChar);
                        remaining = this.value.length;
                        wrapperleng = this.viewWrapper.offsetWidth + parseInt(window.getComputedStyle(this.viewWrapper).paddingRight, 10);
                    }
                    break;
                } else if (wrapperleng + remainSize + downIconWidth + this.clearIconWidth <= overAllContainer) {
                    tempData = data;
                    tempIndex = index;
                } else if (index === 0) {
                    tempData = "";
                    tempIndex = -1;
                }
            }
            if (remaining > 0) {
                var totalWidth = overAllContainer - downIconWidth - this.clearIconWidth;
                this.viewWrapper.appendChild(this.updateRemainTemplate(raminElement, this.viewWrapper, remaining, remainContent, totalContent, totalWidth));
                this.updateRemainWidth(this.viewWrapper, totalWidth);
                this.updateRemainingText(raminElement, downIconWidth, remaining, remainContent, totalContent);
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.viewWrapper)) {
            this.viewWrapper.innerHTML = "";
            this.viewWrapper.style.display = "none";
        }
    };
    MultiSelect.prototype.checkClearIconWidth = function() {
        if (this.showClearButton) this.clearIconWidth = this.overAllClear.offsetWidth;
    };
    MultiSelect.prototype.updateRemainWidth = function(viewWrapper, totalWidth) {
        if (viewWrapper.classList.contains($717505a12e9203b8$var$TOTAL_COUNT_WRAPPER) && totalWidth < viewWrapper.offsetWidth + parseInt(window.getComputedStyle(viewWrapper).paddingLeft, 10) + parseInt(window.getComputedStyle(viewWrapper).paddingLeft, 10)) viewWrapper.style.width = totalWidth + "px";
    };
    MultiSelect.prototype.updateRemainTemplate = function(raminElement, viewWrapper, remaining, remainContent, totalContent, totalWidth) {
        if (viewWrapper.firstChild && viewWrapper.firstChild.nodeType === 3 && viewWrapper.firstChild.nodeValue === "") viewWrapper.removeChild(viewWrapper.firstChild);
        raminElement.innerHTML = "";
        var remainTemp = remainContent.replace("${count}", remaining.toString());
        var totalTemp = totalContent.replace("${count}", remaining.toString());
        raminElement.innerText = viewWrapper.firstChild && viewWrapper.firstChild.nodeType === 3 ? remainTemp : totalTemp;
        if (viewWrapper.firstChild && viewWrapper.firstChild.nodeType === 3) viewWrapper.classList.remove($717505a12e9203b8$var$TOTAL_COUNT_WRAPPER);
        else {
            viewWrapper.classList.add($717505a12e9203b8$var$TOTAL_COUNT_WRAPPER);
            this.updateRemainWidth(viewWrapper, totalWidth);
        }
        return raminElement;
    };
    MultiSelect.prototype.updateRemainingText = function(raminElement, downIconWidth, remaining, remainContent, totalContent) {
        var overAllContainer = this.componentWrapper.offsetWidth - parseInt(window.getComputedStyle(this.componentWrapper).paddingLeft, 10) - parseInt(window.getComputedStyle(this.componentWrapper).paddingRight, 10);
        var wrapperleng = this.viewWrapper.offsetWidth + parseInt(window.getComputedStyle(this.viewWrapper).paddingRight, 10);
        if (wrapperleng + downIconWidth >= overAllContainer && wrapperleng !== 0 && this.viewWrapper.firstChild && this.viewWrapper.firstChild.nodeType === 3) {
            while(wrapperleng + downIconWidth > overAllContainer && wrapperleng !== 0 && this.viewWrapper.firstChild && this.viewWrapper.firstChild.nodeType === 3){
                var textArr = this.viewWrapper.firstChild.nodeValue.split(this.delimiterChar);
                textArr.pop();
                this.viewWrapper.firstChild.nodeValue = textArr.join(this.delimiterChar);
                if (this.viewWrapper.firstChild.nodeValue === "") this.viewWrapper.removeChild(this.viewWrapper.firstChild);
                remaining++;
                wrapperleng = this.viewWrapper.offsetWidth;
            }
            var totalWidth = overAllContainer - downIconWidth;
            this.updateRemainTemplate(raminElement, this.viewWrapper, remaining, remainContent, totalContent, totalWidth);
        }
    };
    MultiSelect.prototype.getOverflowVal = function(index) {
        var temp;
        if (this.mainData && this.mainData.length) {
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[index]) : this.value[index];
            if (this.mode === "CheckBox") {
                var newTemp = this.listData;
                this.listData = this.mainData;
                temp = this.getTextByValue(value);
                this.listData = newTemp;
            } else temp = this.getTextByValue(value);
        } else temp = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[index]) : this.value[index];
        return temp;
    };
    MultiSelect.prototype.unWireEvent = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.componentWrapper)) (0, $aqzbR.EventHandler).remove(this.componentWrapper, "mousedown", this.wrapperClick);
        (0, $aqzbR.EventHandler).remove(window, "resize", this.windowResize);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) {
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focus", this.focusInHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "keydown", this.onKeyDown);
            if (this.mode !== "CheckBox") (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.onInput);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.keyUp);
            var formElement = (0, $4ZDHT.closest)(this.inputElement, "form");
            if (formElement) (0, $aqzbR.EventHandler).remove(formElement, "reset", this.resetValueHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "blur", this.onBlurHandler);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.componentWrapper)) {
            (0, $aqzbR.EventHandler).remove(this.componentWrapper, "mouseover", this.mouseIn);
            (0, $aqzbR.EventHandler).remove(this.componentWrapper, "mouseout", this.mouseOut);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.overAllClear)) (0, $aqzbR.EventHandler).remove(this.overAllClear, "mousedown", this.clearAll);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) (0, $aqzbR.EventHandler).remove(this.inputElement, "paste", this.pasteHandler);
    };
    MultiSelect.prototype.selectAllItem = function(state, event, list) {
        var li;
        if (!(0, $3EnZW.isNullOrUndefined)(this.list)) li = this.list.querySelectorAll(state ? 'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide):not(.e-disabled):not(.e-virtual-list)' : 'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide):not(.e-disabled):not(.e-virtual-list)');
        if (this.value && this.value.length && event && event.target && (0, $4ZDHT.closest)(event.target, ".e-close-hooker") && this.allowFiltering) li = this.mainList.querySelectorAll(state ? 'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide):not(.e-disabled):not(.e-virtual-list)' : 'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide):not(.e-disabled):not(.e-virtual-list)');
        if (this.enableGroupCheckBox && this.mode === "CheckBox" && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) {
            var target = event ? this.groupTemplate ? (0, $4ZDHT.closest)(event.target, ".e-list-group-item") : event.target : null;
            target = event && event.keyCode === 32 ? list : target;
            target = target && target.classList.contains("e-frame") ? target.parentElement.parentElement : target;
            if (target && target.classList.contains("e-list-group-item")) {
                var listElement = target.nextElementSibling;
                if ((0, $3EnZW.isNullOrUndefined)(listElement)) return;
                while(listElement.classList.contains("e-list-item")){
                    if (!(this.fields.disabled && this.isDisabledElement(listElement))) {
                        if (state) {
                            if (!listElement.firstElementChild.lastElementChild.classList.contains("e-check")) {
                                var selectionLimit = this.value && this.value.length ? this.value.length : 0;
                                if (listElement.classList.contains("e-active")) selectionLimit -= 1;
                                if (selectionLimit < this.maximumSelectionLength) this.updateListSelection(listElement, event);
                            }
                        } else if (listElement.firstElementChild.lastElementChild.classList.contains("e-check")) this.updateListSelection(listElement, event);
                    }
                    listElement = listElement.nextElementSibling;
                    if (listElement == null) break;
                }
                if (target.classList.contains("e-list-group-item")) {
                    var focusedElement = this.list.getElementsByClassName("e-item-focus")[0];
                    if (focusedElement) focusedElement.classList.remove("e-item-focus");
                    if (state) target.classList.add("e-active");
                    else target.classList.remove("e-active");
                    target.classList.add("e-item-focus");
                    this.updateAriaActiveDescendant();
                }
                this.textboxValueUpdate();
                this.checkPlaceholderSize();
                if (!this.changeOnBlur && event) this.updateValueState(event, this.value, this.tempValues);
            } else this.updateValue(event, li, state);
        } else this.updateValue(event, li, state);
        this.addValidInputClass();
    };
    MultiSelect.prototype.virtualSelectionAll = function(state, li, event) {
        var _this = this;
        var index = 0;
        var length = li.length;
        var count = this.maximumSelectionLength;
        if (state) {
            this.virtualSelectAll = true;
            length = this.virtualSelectAllData && this.virtualSelectAllData.length !== 0 ? this.virtualSelectAllData.length : length;
            this.listData = this.virtualSelectAllData;
            var ulElement = this.createListItems(this.virtualSelectAllData.slice(0, 30), this.fields);
            var firstItems = ulElement.querySelectorAll("li");
            var fragment_1 = document.createDocumentFragment();
            firstItems.forEach(function(node) {
                fragment_1.appendChild(node.cloneNode(true));
            });
            li.forEach(function(node) {
                fragment_1.appendChild(node.cloneNode(true));
            });
            var concatenatedNodeList = fragment_1.childNodes;
            if (this.virtualSelectAllData instanceof Array) {
                while(index < length && index <= 50 && index < count){
                    this.isSelectAllTarget = length === index + 1;
                    if (concatenatedNodeList[index]) {
                        var value = this.allowObjectBinding ? this.getDataByValue(concatenatedNodeList[index].getAttribute("data-value")) : this.getFormattedValue(concatenatedNodeList[index].getAttribute("data-value"));
                        if (!this.allowObjectBinding && this.value && this.value.indexOf(value) >= 0 || this.allowObjectBinding && this.indexOfObjectInArray(value, this.value) >= 0) {
                            index++;
                            continue;
                        }
                        this.updateListSelection(concatenatedNodeList[index], event, length - index);
                    } else {
                        var value = (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.virtualSelectAllData[index]);
                        value = this.allowObjectBinding ? this.getDataByValue(value) : value;
                        if (!this.allowObjectBinding && this.value && this.value.indexOf(value) >= 0 || this.allowObjectBinding && this.indexOfObjectInArray(value, this.value) >= 0) {
                            index++;
                            continue;
                        }
                        if (this.value && value != null && Array.isArray(this.value) && (!this.allowObjectBinding && this.value.indexOf(value) < 0 || this.allowObjectBinding && !this.isObjectInArray(value, this.value))) this.dispatchSelect(value, event, null, false, length);
                    }
                    index++;
                }
                if (length > 50) setTimeout(function() {
                    if (_this.virtualSelectAllData && _this.virtualSelectAllData.length > 0) _this.virtualSelectAllData.map(function(obj) {
                        if (_this.value && obj[_this.fields.value] != null && Array.isArray(_this.value) && (!_this.allowObjectBinding && _this.value.indexOf(obj[_this.fields.value]) < 0 || _this.allowObjectBinding && !_this.isObjectInArray(obj[_this.fields.value], _this.value))) {
                            var value = obj[_this.fields.value];
                            var text = obj[_this.fields.text].toString();
                            _this.dispatchSelect(value, event, null, false, length, obj, text);
                        }
                    });
                    _this.updatedataValueItems(event);
                    _this.isSelectAllLoop = false;
                    if (!_this.changeOnBlur) {
                        _this.updateValueState(event, _this.value, _this.tempValues);
                        _this.isSelectAll = _this.isSelectAll ? !_this.isSelectAll : _this.isSelectAll;
                    }
                    _this.updateHiddenElement(true);
                    if (_this.popupWrapper && li[index - 1] && li[index - 1].classList.contains("e-item-focus")) {
                        var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
                        if (selectAllParent && selectAllParent.classList.contains("e-item-focus")) li[index - 1].classList.remove("e-item-focus");
                    }
                }, 0);
            }
        } else {
            if (this.virtualSelectAllData && this.virtualSelectAllData.length > 0) this.virtualSelectAllData.map(function(obj) {
                _this.virtualSelectAll = true;
                _this.removeValue(_this.value[index], event, _this.value.length - index);
            });
            this.updatedataValueItems(event);
            if (!this.changeOnBlur) {
                this.updateValueState(event, this.value, this.tempValues);
                this.isSelectAll = this.isSelectAll ? !this.isSelectAll : this.isSelectAll;
            }
            this.updateHiddenElement();
            this.setProperties({
                value: []
            }, true);
            this.virtualSelectAll = false;
            if (!(0, $3EnZW.isNullOrUndefined)(this.viewPortInfo.startIndex) && !(0, $3EnZW.isNullOrUndefined)(this.viewPortInfo.endIndex)) this.notify("setCurrentViewDataAsync", {
                component: this.getModuleName(),
                module: "VirtualScroll"
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var virtualTrackElement = this.list.getElementsByClassName("e-virtual-ddl")[0];
        if (virtualTrackElement) virtualTrackElement.style = this.GetVirtualTrackHeight();
        this.UpdateSkeleton();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var virtualContentElement = this.list.getElementsByClassName("e-virtual-ddl-content")[0];
        if (virtualContentElement) virtualContentElement.style = this.getTransformValues();
    };
    MultiSelect.prototype.updateValue = function(event, li, state) {
        var _this = this;
        var length = li.length;
        var beforeSelectArgs = {
            event: event,
            items: state ? li : [],
            itemData: state ? this.listData : [],
            isInteracted: event ? true : false,
            isChecked: state,
            preventSelectEvent: false
        };
        this.trigger("beforeSelectAll", beforeSelectArgs);
        if (li && li.length || this.enableVirtualization && !state) {
            var index_1 = 0;
            var count_1 = 0;
            if (this.enableGroupCheckBox) count_1 = state ? this.maximumSelectionLength - (this.value ? this.value.length : 0) : li.length;
            else count_1 = state ? this.maximumSelectionLength - (this.value ? this.value.length : 0) : this.maximumSelectionLength;
            if (!beforeSelectArgs.preventSelectEvent) {
                if (this.enableVirtualization) {
                    this.virtualSelectAllState = state;
                    this.virtualSelectAll = true;
                    this.CurrentEvent = event;
                    if (!this.virtualSelectAllData) this.resetList(this.dataSource, this.fields, new (0, $56262f229d1cff45$export$62297b13309008b2)());
                    if (this.virtualSelectAllData) this.virtualSelectionAll(state, li, event);
                } else {
                    while(index_1 < length && index_1 <= 50 && index_1 < count_1){
                        this.isSelectAllTarget = length === index_1 + 1;
                        this.updateListSelection(li[index_1], event, length - index_1);
                        if (this.enableGroupCheckBox) this.findGroupStart(li[index_1]);
                        index_1++;
                    }
                    if (length > 50) setTimeout(function() {
                        while(index_1 < length && index_1 < count_1){
                            _this.isSelectAllTarget = length === index_1 + 1;
                            _this.updateListSelection(li[index_1], event, length - index_1);
                            if (_this.enableGroupCheckBox) _this.findGroupStart(li[index_1]);
                            index_1++;
                        }
                        _this.updatedataValueItems(event);
                        if (!_this.changeOnBlur) {
                            _this.updateValueState(event, _this.value, _this.tempValues);
                            _this.isSelectAll = _this.isSelectAll ? !_this.isSelectAll : _this.isSelectAll;
                        }
                        _this.updateHiddenElement();
                        if (_this.popupWrapper && li[index_1 - 1].classList.contains("e-item-focus")) {
                            var selectAllParent = document.getElementsByClassName("e-selectall-parent")[0];
                            if (selectAllParent && selectAllParent.classList.contains("e-item-focus")) li[index_1 - 1].classList.remove("e-item-focus");
                        }
                    }, 0);
                }
            } else {
                for(var i = 0; i < li.length && i < count_1; i++){
                    this.removeHover();
                    var customVal = li[i].getAttribute("data-value");
                    var value = this.getFormattedValue(customVal);
                    value = this.allowObjectBinding ? this.getDataByValue(value) : value;
                    var mainElement = this.mainList ? this.mainList.querySelectorAll(state ? 'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide)' : 'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide)')[i] : null;
                    if (state) {
                        this.value = !this.value ? [] : this.value;
                        if (!this.allowObjectBinding && this.value.indexOf(value) < 0 || this.allowObjectBinding && !this.isObjectInArray(value, this.value)) this.setProperties({
                            value: [].concat([], this.value, [
                                value
                            ])
                        }, true);
                        this.removeFocus();
                        this.addListSelection(li[i], mainElement);
                        this.updateChipStatus();
                        this.checkMaxSelection();
                    } else this.removeAllItems(value, event, false, li[i], mainElement);
                    if (this.enableGroupCheckBox) this.findGroupStart(li[i]);
                }
                if (!state) {
                    var limit = this.value && this.value.length ? this.value.length : 0;
                    if (limit < this.maximumSelectionLength) {
                        var collection = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-active)");
                        (0, $4ZDHT.removeClass)(collection, "e-disable");
                    }
                }
                var args = {
                    event: event,
                    items: state ? li : [],
                    itemData: state ? this.listData : [],
                    isInteracted: event ? true : false,
                    isChecked: state
                };
                this.trigger("selectedAll", args);
            }
        }
        this.updatedataValueItems(event);
        this.checkPlaceholderSize();
        if (length <= 50 && !beforeSelectArgs.preventSelectEvent) {
            if (!this.changeOnBlur) {
                this.updateValueState(event, this.value, this.tempValues);
                this.isSelectAll = this.isSelectAll ? !this.isSelectAll : this.isSelectAll;
            }
            if (this.enableVirtualization && this.value && this.value.length > 0 || !this.enableVirtualization) this.updateHiddenElement();
        }
    };
    MultiSelect.prototype.updateHiddenElement = function(isVirtualSelectAll) {
        var _this = this;
        var hiddenValue = "";
        var wrapperText = "";
        var data = "";
        var text = [];
        if (this.mode === "CheckBox") {
            this.value.map(function(value, index) {
                hiddenValue += '<option selected value ="' + value + '">' + index + "</option>";
                if (!isVirtualSelectAll) {
                    if (_this.listData) data = _this.getTextByValue(value);
                    else data = value;
                    wrapperText += data + _this.delimiterChar + " ";
                    text.push(data);
                }
            });
            this.hiddenElement.innerHTML = hiddenValue;
            if (!isVirtualSelectAll) {
                this.updateWrapperText(this.delimiterWrapper, wrapperText);
                this.setProperties({
                    text: text.toString()
                }, true);
            }
            this.delimiterWrapper.setAttribute("id", (0, $3EnZW.getUniqueID)("delim_val"));
            this.inputElement.setAttribute("aria-describedby", this.delimiterWrapper.id);
            this.refreshInputHight();
            this.refreshPlaceHolder();
        }
    };
    MultiSelect.prototype.updatedataValueItems = function(event) {
        this.deselectHeader();
        this.textboxValueUpdate(event);
    };
    MultiSelect.prototype.textboxValueUpdate = function(event) {
        var isRemoveAll = event && event.target && ((0, $4ZDHT.closest)(event.target, ".e-selectall-parent") || (0, $4ZDHT.closest)(event.target, ".e-close-hooker"));
        if (this.mode !== "Box" && !this.isPopupOpen() && !(this.mode === "CheckBox" && (this.isSelectAll || isRemoveAll))) this.updateDelimView();
        else this.searchWrapper.classList.remove($717505a12e9203b8$var$ZERO_SIZE);
        if (this.mode === "CheckBox") {
            this.updateDelimView();
            if (!(isRemoveAll || this.isSelectAll) && this.isSelectAllTarget || this.isSelectAll && this.isSelectAllTarget) this.updateDelimeter(this.delimiterChar, event);
            this.refreshInputHight();
        } else this.updateDelimeter(this.delimiterChar, event);
        this.refreshPlaceHolder();
    };
    MultiSelect.prototype.setZIndex = function() {
        if (this.popupObj) this.popupObj.setProperties({
            "zIndex": this.zIndex
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MultiSelect.prototype.updateDataSource = function(prop) {
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) this.renderPopup();
        else this.resetList(this.dataSource);
        if (this.value && this.value.length) {
            this.setProperties({
                "value": this.value
            });
            this.refreshSelection();
        }
    };
    MultiSelect.prototype.onLoadSelect = function() {
        this.setDynValue = true;
        this.renderPopup();
    };
    MultiSelect.prototype.selectAllItems = function(state, event) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) {
            this.selectAllAction = function() {
                if (_this.mode === "CheckBox" && _this.showSelectAll) {
                    var args = {
                        module: "CheckBoxSelection",
                        enable: _this.mode === "CheckBox",
                        value: state ? "check" : "uncheck"
                    };
                    _this.notify("checkSelectAll", args);
                }
                _this.selectAllItem(state, event);
                _this.selectAllAction = null;
            };
            _super.prototype.render.call(this);
        } else {
            this.selectAllAction = null;
            if (this.mode === "CheckBox" && this.showSelectAll) {
                var args = {
                    value: state ? "check" : "uncheck",
                    enable: this.mode === "CheckBox",
                    module: "CheckBoxSelection"
                };
                this.notify("checkSelectAll", args);
            }
            this.selectAllItem(state, event);
        }
        if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) || this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.virtualSelectAllData) this.virtualSelectAll = false;
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} Returns the persisted data of the component.
     */ MultiSelect.prototype.getPersistData = function() {
        return this.addOnPersist([
            "value"
        ]);
    };
    /**
     * Dynamically change the value of properties.
     *
     * @param {MultiSelectModel} newProp - Returns the dynamic property value of the component.
     * @param {MultiSelectModel} oldProp - Returns the previous property value of the component.
     * @private
     * @returns {void}
     */ MultiSelect.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (newProp.dataSource && !(0, $3EnZW.isNullOrUndefined)(Object.keys(newProp.dataSource)) || newProp.query && !(0, $3EnZW.isNullOrUndefined)(Object.keys(newProp.query))) {
            if (this.resetFilteredData) {
                // The filtered data is not being reset in the component after the user focuses out.
                this.resetMainList = !this.resetMainList ? this.mainList : this.resetMainList;
                this.resetFilteredData = false;
            }
            this.mainList = null;
            this.mainData = null;
            this.isFirstClick = false;
            this.isDynamicDataChange = true;
        }
        if (this.getModuleName() === "multiselect") {
            this.filterAction = false;
            this.setUpdateInitial([
                "fields",
                "query",
                "dataSource"
            ], newProp);
        }
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "query":
                case "dataSource":
                    if (this.mode === "CheckBox" && this.showSelectAll) {
                        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj)) {
                            this.popupObj.destroy();
                            this.popupObj = null;
                        }
                        this.renderPopup();
                    }
                    break;
                case "htmlAttributes":
                    this.updateHTMLAttribute();
                    break;
                case "showClearButton":
                    this.updateClearButton(newProp.showClearButton);
                    break;
                case "text":
                    if (this.fields.disabled) this.text = this.text && !this.isDisabledItemByIndex(this.getIndexByValue(this.getValueByText(this.text))) ? this.text : null;
                    this.updateVal(this.value, this.value, "text");
                    break;
                case "value":
                    if (this.fields.disabled) this.removeDisabledItemsValue(this.value);
                    this.updateVal(this.value, oldProp.value, "value");
                    this.addValidInputClass();
                    if (!this.closePopupOnSelect && this.isPopupOpen()) this.refreshPopup();
                    if (this.isPopupOpen() && this.mode === "CheckBox" && this.list && this.list.querySelector(".e-active.e-disable")) {
                        var activeItems = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ".e-active" + ".e-disable");
                        (0, $4ZDHT.removeClass)(activeItems, "e-disable");
                    }
                    this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
                    break;
                case "width":
                    this.setWidth(newProp.width);
                    this.popupObj.setProperties({
                        width: this.calcPopupWidth()
                    });
                    break;
                case "placeholder":
                    this.refreshPlaceHolder();
                    break;
                case "filterBarPlaceholder":
                    if (this.allowFiltering) this.notify("filterBarPlaceholder", {
                        filterBarPlaceholder: newProp.filterBarPlaceholder
                    });
                    break;
                case "delimiterChar":
                    if (this.mode !== "Box") this.updateDelimView();
                    this.updateData(newProp.delimiterChar);
                    break;
                case "cssClass":
                    this.updateOldPropCssClass(oldProp.cssClass);
                    this.updateCssClass();
                    this.calculateWidth();
                    break;
                case "enableRtl":
                    this.enableRTL(newProp.enableRtl);
                    _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
                    break;
                case "readonly":
                    this.updateReadonly(newProp.readonly);
                    this.hidePopup();
                    break;
                case "enabled":
                    this.hidePopup();
                    this.enable(newProp.enabled);
                    break;
                case "showSelectAll":
                    if (this.popupObj) {
                        this.popupObj.destroy();
                        this.popupObj = null;
                    }
                    this.renderPopup();
                    break;
                case "showDropDownIcon":
                    this.dropDownIcon();
                    break;
                case "floatLabelType":
                    this.setFloatLabelType();
                    this.addValidInputClass();
                    (0, $168e4e125732cd26$export$f5b8910cec6cf069).createSpanElement(this.overAllWrapper, this.createElement);
                    this.calculateWidth();
                    if (!(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper) && !(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper.getElementsByClassName("e-ddl-icon")[0] && this.overAllWrapper.getElementsByClassName("e-float-text-content")[0] && this.floatLabelType !== "Never")) this.overAllWrapper.getElementsByClassName("e-float-text-content")[0].classList.add("e-icon");
                    break;
                case "enableSelectionOrder":
                    break;
                case "selectAllText":
                    this.notify("selectAllText", false);
                    break;
                case "popupHeight":
                    if (this.popupObj) {
                        var overAllHeight = parseInt(this.popupHeight, 10);
                        if (this.popupHeight !== "auto") {
                            this.list.style.maxHeight = (0, $3EnZW.formatUnit)(overAllHeight);
                            this.popupWrapper.style.maxHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
                        } else this.list.style.maxHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
                    }
                    break;
                case "headerTemplate":
                case "footerTemplate":
                    this.reInitializePoup();
                    break;
                case "allowFiltering":
                    if (this.mode === "CheckBox" && this.popupObj) this.reInitializePoup();
                    this.updateSelectElementData(this.allowFiltering);
                    break;
                case "fields":
                    if ((0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) this.removeScrollEvent();
                    break;
                default:
                    var msProps = this.getPropObject(prop, newProp, oldProp);
                    _super.prototype.onPropertyChanged.call(this, msProps.newProperty, msProps.oldProperty);
                    break;
            }
        }
    };
    MultiSelect.prototype.reInitializePoup = function() {
        if (this.popupObj) {
            this.popupObj.destroy();
            this.popupObj = null;
        }
        this.renderPopup();
    };
    MultiSelect.prototype.totalItemsCount = function() {
        var dataSourceCount;
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            if (this.remoteDataCount >= 0) dataSourceCount = this.totalItemCount = this.dataCount = this.remoteDataCount;
            else this.resetList(this.dataSource);
        } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataSourceCount = this.dataSource && this.dataSource.length ? this.dataSource.length : 0;
        if (this.mode === "CheckBox") this.totalItemCount = dataSourceCount !== 0 ? dataSourceCount : this.totalItemCount;
        else if (this.hideSelectedItem) {
            this.totalItemCount = dataSourceCount !== 0 && this.value ? dataSourceCount - this.value.length : this.totalItemCount;
            if (this.allowCustomValue && this.virtualCustomSelectData && this.virtualCustomSelectData.length > 0) {
                for(var i = 0; i < this.virtualCustomSelectData.length; i++)for(var j = 0; j < this.value.length; j++){
                    var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[j]) : this.value[j];
                    var customValue = (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.virtualCustomSelectData[i]);
                    if (value === customValue) this.totalItemCount += 1;
                }
            }
        } else {
            this.totalItemCount = dataSourceCount !== 0 ? dataSourceCount : this.totalItemCount;
            if (this.allowCustomValue && this.virtualCustomSelectData && this.virtualCustomSelectData.length > 0) this.totalItemCount += this.virtualCustomSelectData.length;
        }
    };
    MultiSelect.prototype.presentItemValue = function(ulElement) {
        var valuecheck = [];
        for(var i = 0; i < this.value.length; i++){
            var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[i]) : this.value[i];
            var checkEle = this.findListElement(this.allowFiltering && !(0, $3EnZW.isNullOrUndefined)(this.mainList) ? this.mainList : ulElement, "li", "data-value", value);
            if (!checkEle) {
                var checkvalue = this.allowObjectBinding ? this.getDataByValue(this.value[i]) : this.value[i];
                valuecheck.push(checkvalue);
            }
        }
        return valuecheck;
    };
    MultiSelect.prototype.addNonPresentItems = function(valuecheck, ulElement, list, event) {
        var _this = this;
        this.dataSource.executeQuery(this.getForQuery(valuecheck)).then(function(e) {
            if (e.result.length > 0) _this.addItem(e.result, list.length);
            _this.updateActionList(ulElement, list, event);
        });
    };
    MultiSelect.prototype.updateVal = function(newProp, oldProp, prop) {
        if (!this.list) this.onLoadSelect();
        else if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && (!this.listData || !(this.mainList && this.mainData))) this.onLoadSelect();
        else {
            var valuecheck = [];
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && !this.allowCustomValue) valuecheck = this.presentItemValue(this.ulElement);
            if (prop === "value" && valuecheck.length > 0 && this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)(this.value) && this.listData != null && !this.enableVirtualization) {
                this.mainData = null;
                this.setDynValue = true;
                this.addNonPresentItems(valuecheck, this.ulElement, this.listData);
            } else {
                if (prop === "text") {
                    this.initialTextUpdate();
                    newProp = this.value;
                }
                if ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0) this.tempValues = oldProp;
                // eslint-disable-next-line
                if (this.allowCustomValue && (this.mode === "Default" || this.mode === "Box") && this.isReact && this.inputFocus && this.isPopupOpen() && this.mainData !== this.listData) {
                    var list = this.mainList.cloneNode ? this.mainList.cloneNode(true) : this.mainList;
                    this.onActionComplete(list, this.mainData);
                }
                if (!this.enableVirtualization || this.enableVirtualization && !(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) this.initialValueUpdate();
                if (this.mode !== "Box" && !this.inputFocus) this.updateDelimView();
                if (!this.inputFocus) this.refreshInputHight();
                this.refreshPlaceHolder();
                if (this.mode !== "CheckBox" && this.changeOnBlur) this.updateValueState(null, newProp, oldProp);
                this.checkPlaceholderSize();
            }
        }
        if (!this.changeOnBlur) this.updateValueState(null, newProp, oldProp);
    };
    /**
     * Adds a new item to the multiselect popup list. By default, new item appends to the list as the last item,
     * but you can insert based on the index parameter.
     *
     * @param { Object[] } items - Specifies an array of JSON data or a JSON data.
     * @param { number } itemIndex - Specifies the index to place the newly added item in the popup list.
     * @returns {void}
     */ MultiSelect.prototype.addItem = function(items, itemIndex) {
        _super.prototype.addItem.call(this, items, itemIndex);
    };
    /**
     * Hides the popup, if the popup in a open state.
     *
     * @param {MouseEvent | KeyboardEventArgs} e - Specifies the mouse event or keyboard event.
     * @returns {void}
     */ MultiSelect.prototype.hidePopup = function(e) {
        var _this = this;
        var delay = 100;
        if (this.isPopupOpen()) {
            var animModel = {
                name: "FadeOut",
                duration: 100,
                delay: delay ? delay : 0
            };
            this.customFilterQuery = null;
            var eventArgs = {
                popup: this.popupObj,
                cancel: false,
                animation: animModel,
                event: e || null
            };
            this.trigger("close", eventArgs, function(eventArgs) {
                if (!eventArgs.cancel) {
                    if (_this.fields.groupBy && _this.mode !== "CheckBox" && _this.fixedHeaderElement) {
                        (0, $4ZDHT.remove)(_this.fixedHeaderElement);
                        _this.fixedHeaderElement = null;
                    }
                    _this.beforePopupOpen = false;
                    _this.overAllWrapper.classList.remove($717505a12e9203b8$var$iconAnimation);
                    var typedValue = _this.mode === "CheckBox" ? _this.targetElement() : null;
                    _this.popupObj.hide(new (0, $kj1BR.Animation)(eventArgs.animation));
                    (0, $4ZDHT.attributes)(_this.inputElement, {
                        "aria-expanded": "false"
                    });
                    _this.inputElement.removeAttribute("aria-owns");
                    _this.inputElement.removeAttribute("aria-activedescendant");
                    if (_this.allowFiltering) _this.notify("inputFocus", {
                        module: "CheckBoxSelection",
                        enable: _this.mode === "CheckBox",
                        value: "clear"
                    });
                    _this.popupObj.hide();
                    (0, $4ZDHT.removeClass)([
                        document.body,
                        _this.popupObj.element
                    ], "e-popup-full-page");
                    (0, $aqzbR.EventHandler).remove(_this.list, "keydown", _this.onKeyDown);
                    if (_this.mode === "CheckBox" && _this.showSelectAll) (0, $aqzbR.EventHandler).remove(_this.popupObj.element, "click", _this.clickHandler);
                    if (_this.enableVirtualization && _this.mode === "CheckBox" && _this.value && _this.value.length > 0 && _this.enableSelectionOrder) {
                        _this.viewPortInfo.startIndex = _this.virtualItemStartIndex = 0;
                        _this.viewPortInfo.endIndex = _this.virtualItemEndIndex = _this.viewPortInfo.startIndex > 0 ? _this.viewPortInfo.endIndex : _this.itemCount;
                        _this.virtualListInfo = _this.viewPortInfo;
                        _this.previousStartIndex = 0;
                        _this.previousEndIndex = 0;
                    }
                    var dataSourceCount = void 0;
                    if (_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
                        if (_this.remoteDataCount >= 0) _this.totalItemCount = _this.dataCount = _this.remoteDataCount;
                        else _this.resetList(_this.dataSource);
                    } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    dataSourceCount = _this.dataSource && _this.dataSource.length ? _this.dataSource.length : 0;
                    if (_this.enableVirtualization && (_this.allowFiltering || _this.allowCustomValue) && (_this.targetElement() || typedValue) && _this.totalItemCount !== dataSourceCount) {
                        _this.checkAndResetCache();
                        _this.updateInitialData();
                    }
                    if (_this.virtualCustomData && _this.viewPortInfo && _this.viewPortInfo.startIndex === 0 && _this.viewPortInfo.endIndex === _this.itemCount) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this.renderItems(_this.mainData, _this.fields);
                    _this.virtualCustomData = null;
                    _this.isVirtualTrackHeight = false;
                }
            });
        }
    };
    /**
     * Shows the popup, if the popup in a closed state.
     *
     * @param {MouseEvent | KeyboardEventArgs} e - Specifies the mouse event or keyboard event.
     * @returns {void}
     */ MultiSelect.prototype.showPopup = function(e) {
        var _this = this;
        if (!this.enabled) return;
        this.firstItem = this.dataSource && this.dataSource.length > 0 ? this.dataSource[0] : null;
        var args = {
            cancel: false
        };
        this.trigger("beforeOpen", args, function(args) {
            if (!args.cancel) {
                if (!_this.ulElement) {
                    _this.beforePopupOpen = true;
                    if (_this.mode === "CheckBox" && (0, $5q7BP.Browser).isDevice && _this.allowFiltering && _this.isDeviceFullScreen) _this.notify("popupFullScreen", {
                        module: "CheckBoxSelection",
                        enable: _this.mode === "CheckBox"
                    });
                    _super.prototype.render.call(_this, e);
                    return;
                }
                if (_this.mode === "CheckBox" && (0, $5q7BP.Browser).isDevice && _this.allowFiltering && _this.isDeviceFullScreen) _this.notify("popupFullScreen", {
                    module: "CheckBoxSelection",
                    enable: _this.mode === "CheckBox"
                });
                var mainLiLength = _this.ulElement.querySelectorAll("li.e-list-item").length;
                var liLength = _this.ulElement.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + "." + $717505a12e9203b8$var$HIDE_LIST).length;
                if (mainLiLength > 0 && mainLiLength === liLength && liLength === _this.mainData.length && !(_this.targetElement() !== "" && _this.allowCustomValue)) {
                    _this.beforePopupOpen = false;
                    return;
                }
                _this.onPopupShown(e);
                if (_this.enableVirtualization && _this.listData && _this.listData.length) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.value) && (_this.getModuleName() === "dropdownlist" || _this.getModuleName() === "combobox")) _this.removeHover();
                    if (!_this.beforePopupOpen) {
                        if (_this.hideSelectedItem && _this.value && Array.isArray(_this.value) && _this.value.length > 0) _this.totalItemsCount();
                        if (!_this.preventSetCurrentData && !(0, $3EnZW.isNullOrUndefined)(_this.viewPortInfo.startIndex) && !(0, $3EnZW.isNullOrUndefined)(_this.viewPortInfo.endIndex)) _this.notify("setCurrentViewDataAsync", {
                            component: _this.getModuleName(),
                            module: "VirtualScroll"
                        });
                    }
                }
                if (_this.enableVirtualization && !_this.allowFiltering && _this.selectedValueInfo != null && _this.selectedValueInfo.startIndex > 0 && _this.value != null) _this.notify("dataProcessAsync", {
                    module: "VirtualScroll",
                    isOpen: true
                });
                if (_this.enableVirtualization) _this.updatevirtualizationList();
                else if (_this.value && _this.value.length) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var element = void 0;
                    var listItems = _this.getItems();
                    for(var _i = 0, _a = _this.value; _i < _a.length; _i++){
                        var value = _a[_i];
                        var checkValue = _this.allowObjectBinding ? (0, $3EnZW.getValue)(_this.fields.value ? _this.fields.value : "", value) : value;
                        element = _this.getElementByValue(checkValue);
                        if (element) _this.addListSelection(element);
                    }
                }
                _this.preventSetCurrentData = true;
            }
        });
    };
    /**
     * Based on the state parameter, entire list item will be selected/deselected.
     * parameter
     * `true`   - Selects entire list items.
     * `false`  - Un Selects entire list items.
     *
     * @param {boolean} state - if it’s true then Selects the entire list items. If it’s false the Unselects entire list items.
     * @returns {void}
     */ MultiSelect.prototype.selectAll = function(state) {
        this.isSelectAll = true;
        this.selectAllItems(state);
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ MultiSelect.prototype.getModuleName = function() {
        return "multiselect";
    };
    /**
     * Allows you to clear the selected values from the Multiselect component.
     *
     * @returns {void}
     */ MultiSelect.prototype.clear = function() {
        var _this = this;
        this.selectAll(false);
        if (this.value && this.value.length) setTimeout(function() {
            _this.setProperties({
                value: null
            }, true);
        }, 0);
        else this.setProperties({
            value: null
        }, true);
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ MultiSelect.prototype.render = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value.length > 0) // eslint-disable-next-line
        this.value = this.value.slice();
        this.setDynValue = this.initStatus = false;
        this.isSelectAll = false;
        this.selectAllEventEle = [];
        this.searchWrapper = this.createElement("span", {
            className: $717505a12e9203b8$var$SEARCHBOX_WRAPPER + " " + (this.mode === "Box" ? $717505a12e9203b8$var$BOX_ELEMENT : "")
        });
        this.viewWrapper = this.createElement("span", {
            className: $717505a12e9203b8$var$DELIMITER_VIEW + " " + $717505a12e9203b8$var$DELIMITER_WRAPPER,
            styles: "display:none;"
        });
        this.overAllClear = this.createElement("span", {
            className: $717505a12e9203b8$var$CLOSEICON_CLASS,
            styles: "display:none;"
        });
        this.componentWrapper = this.createElement("div", {
            className: $717505a12e9203b8$var$ELEMENT_WRAPPER
        });
        this.overAllWrapper = this.createElement("div", {
            className: $717505a12e9203b8$var$OVER_ALL_WRAPPER
        });
        if (this.mode === "CheckBox") (0, $4ZDHT.addClass)([
            this.overAllWrapper
        ], "e-checkbox");
        if ((0, $5q7BP.Browser).isDevice) this.componentWrapper.classList.add($717505a12e9203b8$var$ELEMENT_MOBILE_WRAPPER);
        this.setWidth(this.width);
        this.overAllWrapper.appendChild(this.componentWrapper);
        this.popupWrapper = this.createElement("div", {
            id: this.element.id + "_popup",
            className: $717505a12e9203b8$var$POPUP_WRAPPER
        });
        this.popupWrapper.setAttribute("aria-label", this.element.id);
        this.popupWrapper.setAttribute("role", "dialog");
        if (this.mode === "Delimiter" || this.mode === "CheckBox") {
            this.delimiterWrapper = this.createElement("span", {
                className: $717505a12e9203b8$var$DELIMITER_WRAPPER,
                styles: "display:none"
            });
            this.componentWrapper.appendChild(this.delimiterWrapper);
        } else {
            this.chipCollectionWrapper = this.createElement("span", {
                className: $717505a12e9203b8$var$CHIP_WRAPPER,
                styles: "display:none"
            });
            if (this.mode === "Default") this.chipCollectionWrapper.setAttribute("id", (0, $3EnZW.getUniqueID)("chip_default"));
            else if (this.mode === "Box") this.chipCollectionWrapper.setAttribute("id", (0, $3EnZW.getUniqueID)("chip_box"));
            this.componentWrapper.appendChild(this.chipCollectionWrapper);
        }
        if (this.mode !== "Box") this.componentWrapper.appendChild(this.viewWrapper);
        this.componentWrapper.appendChild(this.searchWrapper);
        if (this.showClearButton && !(0, $5q7BP.Browser).isDevice) this.componentWrapper.appendChild(this.overAllClear);
        else this.componentWrapper.classList.add($717505a12e9203b8$var$CLOSE_ICON_HIDE);
        this.dropDownIcon();
        this.inputElement = this.createElement("input", {
            className: $717505a12e9203b8$var$INPUT_ELEMENT,
            attrs: {
                spellcheck: "false",
                type: "text",
                autocomplete: "off",
                tabindex: "0",
                role: "combobox"
            }
        });
        if (this.mode === "Default" || this.mode === "Box") this.inputElement.setAttribute("aria-describedby", this.chipCollectionWrapper.id);
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) {
            (0, $4ZDHT.attributes)(this.inputElement, {
                "aria-expanded": "false"
            });
            if (!this.inputElement.hasAttribute("aria-label")) this.inputElement.setAttribute("aria-label", this.getModuleName());
        }
        if (this.element.tagName !== this.getNgDirective()) this.element.style.display = "none";
        if (this.element.tagName === this.getNgDirective()) {
            this.element.appendChild(this.overAllWrapper);
            this.searchWrapper.appendChild(this.inputElement);
        } else {
            this.element.parentElement.insertBefore(this.overAllWrapper, this.element);
            this.searchWrapper.appendChild(this.inputElement);
            this.searchWrapper.appendChild(this.element);
            this.element.removeAttribute("tabindex");
        }
        if (this.floatLabelType !== "Never") (0, $805d2bf384e771bd$export$39117a5c98660d83)(this.overAllWrapper, this.searchWrapper, this.element, this.inputElement, this.value, this.floatLabelType, this.placeholder);
        else if (this.floatLabelType === "Never") this.refreshPlaceHolder();
        this.addValidInputClass();
        this.element.style.opacity = "";
        var id = this.element.getAttribute("id") ? this.element.getAttribute("id") : (0, $3EnZW.getUniqueID)("ej2_dropdownlist");
        this.element.id = id;
        this.hiddenElement = this.createElement("select", {
            attrs: {
                "aria-hidden": "true",
                "class": $717505a12e9203b8$var$HIDDEN_ELEMENT,
                "tabindex": "-1",
                "multiple": ""
            }
        });
        this.componentWrapper.appendChild(this.hiddenElement);
        this.validationAttribute(this.element, this.hiddenElement);
        if (this.mode !== "CheckBox") this.hideOverAllClear();
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.element, "fieldset")) && (0, $4ZDHT.closest)(this.element, "fieldset").disabled) this.enabled = false;
        this.wireEvent();
        this.enable(this.enabled);
        this.enableRTL(this.enableRtl);
        if (this.enableVirtualization) this.updateVirtualizationProperties(this.itemCount, this.allowFiltering, this.mode === "CheckBox");
        this.listItemHeight = this.getListHeight();
        this.getSkeletonCount();
        this.viewPortInfo.startIndex = this.virtualItemStartIndex = 0;
        this.viewPortInfo.endIndex = this.virtualItemEndIndex = this.viewPortInfo.startIndex > 0 ? this.viewPortInfo.endIndex : this.itemCount;
        this.checkInitialValue();
        if (this.element.hasAttribute("data-val")) this.element.setAttribute("data-val", "false");
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).createSpanElement(this.overAllWrapper, this.createElement);
        this.calculateWidth();
        if (!(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper) && !(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper.getElementsByClassName("e-ddl-icon")[0] && this.overAllWrapper.getElementsByClassName("e-float-text-content")[0] && this.floatLabelType !== "Never")) this.overAllWrapper.getElementsByClassName("e-float-text-content")[0].classList.add("e-icon");
        this.renderComplete();
    };
    MultiSelect.prototype.getListHeight = function() {
        var listParent = this.createElement("div", {
            className: "e-dropdownbase"
        });
        var item = this.createElement("li", {
            className: "e-list-item"
        });
        var listParentHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
        listParent.style.height = parseInt(listParentHeight, 10).toString() + "px";
        listParent.appendChild(item);
        document.body.appendChild(listParent);
        this.virtualListHeight = listParent.getBoundingClientRect().height;
        var listItemHeight = Math.ceil(item.getBoundingClientRect().height) + parseInt(window.getComputedStyle(item).marginBottom, 10);
        listParent.remove();
        return listItemHeight;
    };
    /**
     * Removes disabled values from the given array.
     *
     * @param { number[] | string[] | boolean[] | object[] } value - The array to check.
     * @returns {void}
     */ MultiSelect.prototype.removeDisabledItemsValue = function(value) {
        if (value) {
            var data = [];
            var dataIndex = 0;
            for(var index = 0; index < value.length; index++){
                var indexValue = value[index];
                if (typeof indexValue === "object") indexValue = JSON.parse(JSON.stringify(indexValue))[this.fields.value];
                if (indexValue != null && !this.isDisabledItemByIndex(this.getIndexByValue(indexValue))) data[dataIndex++] = value[index];
            }
            this.value = data.length > 0 ? data : null;
        }
    };
    MultiSelect.prototype.checkInitialValue = function() {
        var _this = this;
        if (this.fields.disabled) this.removeDisabledItemsValue(this.value);
        var isData = this.dataSource instanceof Array ? this.dataSource.length > 0 : !(0, $3EnZW.isNullOrUndefined)(this.dataSource);
        if (!(this.value && this.value.length) && (0, $3EnZW.isNullOrUndefined)(this.text) && !isData && this.element.tagName === "SELECT" && this.element.options.length > 0) {
            var optionsElement = this.element.options;
            var valueCol = [];
            var textCol = "";
            for(var index = 0, optionsLen = optionsElement.length; index < optionsLen; index++){
                var opt = optionsElement[index];
                if (!(0, $3EnZW.isNullOrUndefined)(opt.getAttribute("selected"))) {
                    if (opt.getAttribute("value")) {
                        var value = this.allowObjectBinding ? this.getDataByValue(opt.getAttribute("value")) : opt.getAttribute("value");
                        valueCol.push(value);
                    } else textCol += opt.text + this.delimiterChar;
                }
            }
            if (valueCol.length > 0) this.setProperties({
                value: valueCol
            }, true);
            else if (textCol !== "") this.setProperties({
                text: textCol
            }, true);
            if (valueCol.length > 0 || textCol !== "") {
                this.refreshInputHight();
                this.refreshPlaceHolder();
            }
        }
        if (this.value && this.value.length || !(0, $3EnZW.isNullOrUndefined)(this.text)) {
            if (!this.list) _super.prototype.render.call(this);
        }
        if (this.fields.disabled) this.text = this.text && !this.isDisabledItemByIndex(this.getIndexByValue(this.getValueByText(this.text))) ? this.text : null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.text) && ((0, $3EnZW.isNullOrUndefined)(this.value) || this.value.length === 0)) this.initialTextUpdate();
        if (this.value && this.value.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var listItems_2;
            if (this.enableVirtualization) {
                var fields = this.fields.value ? this.fields.value : "";
                var predicate = void 0;
                for(var i = 0; i < this.value.length; i++){
                    var value = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", this.value[i]) : this.value[i];
                    if (i === 0) predicate = new (0, $56262f229d1cff45$export$7ce636318c5a9f17)(fields, "equal", value);
                    else predicate = predicate.or(fields, "equal", value);
                }
                if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.dataSource.executeQuery(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate)).then(function(e) {
                    if (e.result.length > 0) {
                        listItems_2 = e.result;
                        _this.initStatus = false;
                        setTimeout(function() {
                            _this.initialValueUpdate(listItems_2, true);
                            _this.initialUpdate();
                        }, 100);
                        _this.initStatus = true;
                    }
                });
                else listItems_2 = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.dataSource).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(predicate));
            }
            if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
                this.initialValueUpdate(listItems_2);
                this.initialUpdate();
            } else this.setInitialValue = function() {
                _this.initStatus = false;
                if (!_this.enableVirtualization || _this.enableVirtualization && !(_this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) _this.initialValueUpdate(listItems_2);
                _this.initialUpdate();
                _this.setInitialValue = null;
                _this.initStatus = true;
            };
            this.updateTempValue();
        } else this.initialUpdate();
        this.initStatus = true;
        this.checkAutoFocus();
        if (!(0, $3EnZW.isNullOrUndefined)(this.text)) this.element.setAttribute("data-initial-value", this.text);
    };
    MultiSelect.prototype.checkAutoFocus = function() {
        if (this.element.hasAttribute("autofocus")) this.inputElement.focus();
    };
    MultiSelect.prototype.updatevirtualizationList = function() {
        if (this.value && this.value.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var element = void 0;
            for(var _i = 0, _a = this.value; _i < _a.length; _i++){
                var value = _a[_i];
                var checkValue = this.allowObjectBinding ? (0, $3EnZW.getValue)(this.fields.value ? this.fields.value : "", value) : value;
                element = this.getElementByValue(checkValue);
                if (element) this.addListSelection(element);
            }
            if (this.enableVirtualization && this.hideSelectedItem) {
                var visibleListElements = this.list.querySelectorAll("li." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(." + $717505a12e9203b8$var$HIDE_LIST + ")" + ":not(.e-reorder-hide)" + ":not(.e-virtual-list)");
                if (visibleListElements.length) {
                    var actualCount = this.virtualListHeight > 0 ? Math.floor(this.virtualListHeight / this.listItemHeight) : 0;
                    if (visibleListElements.length < actualCount + 2) {
                        var query = this.getForQuery(this.value).clone();
                        query = query.skip(this.viewPortInfo.startIndex);
                        this.resetList(this.dataSource, this.fields, query);
                    }
                }
            }
        }
    };
    MultiSelect.prototype.setFloatLabelType = function() {
        (0, $805d2bf384e771bd$export$28e15b1a5c8da10e)(this.overAllWrapper, this.componentWrapper, this.searchWrapper, this.inputElement, this.value, this.floatLabelType, this.placeholder);
        if (this.floatLabelType !== "Never") (0, $805d2bf384e771bd$export$39117a5c98660d83)(this.overAllWrapper, this.searchWrapper, this.element, this.inputElement, this.value, this.floatLabelType, this.placeholder);
    };
    MultiSelect.prototype.addValidInputClass = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.overAllWrapper)) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.value) && this.value.length || this.floatLabelType === "Always") (0, $4ZDHT.addClass)([
                this.overAllWrapper
            ], "e-valid-input");
            else (0, $4ZDHT.removeClass)([
                this.overAllWrapper
            ], "e-valid-input");
        }
    };
    MultiSelect.prototype.dropDownIcon = function() {
        if (this.showDropDownIcon) {
            this.dropIcon = this.createElement("span", {
                className: $717505a12e9203b8$var$dropdownIcon
            });
            this.componentWrapper.appendChild(this.dropIcon);
            (0, $4ZDHT.addClass)([
                this.componentWrapper
            ], [
                "e-down-icon"
            ]);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.dropIcon)) {
            this.dropIcon.parentElement.removeChild(this.dropIcon);
            (0, $4ZDHT.removeClass)([
                this.componentWrapper
            ], [
                "e-down-icon"
            ]);
        }
    };
    MultiSelect.prototype.initialUpdate = function() {
        if (this.mode !== "Box" && !(this.setDynValue && this.mode === "Default" && this.inputFocus)) this.updateDelimView();
        this.viewPortInfo.startIndex = this.virtualItemStartIndex = 0;
        this.viewPortInfo.endIndex = this.virtualItemEndIndex = this.itemCount;
        this.updateCssClass();
        this.updateHTMLAttribute();
        this.updateReadonly(this.readonly);
        this.refreshInputHight();
        this.checkPlaceholderSize();
    };
    /**
     * Method to disable specific item in the popup.
     *
     * @param {string | number | object | HTMLLIElement} item - Specifies the item to be disabled.
     * @returns {void}

     */ MultiSelect.prototype.disableItem = function(item) {
        if (this.fields.disabled) {
            if (!this.list) this.renderList();
            var itemIndex = -1;
            if (this.liCollections && this.liCollections.length > 0 && this.listData && this.fields.disabled) {
                if (typeof item === "string") itemIndex = this.getIndexByValue(item);
                else if (typeof item === "object") {
                    if (item instanceof HTMLLIElement) {
                        for(var index = 0; index < this.liCollections.length; index++)if (this.liCollections[index] === item) {
                            itemIndex = this.getIndexByValue(item.getAttribute("data-value"));
                            break;
                        }
                    } else {
                        var value = JSON.parse(JSON.stringify(item))[this.fields.value];
                        for(var index = 0; index < this.listData.length; index++)if (JSON.parse(JSON.stringify(this.listData[index]))[this.fields.value] === value) {
                            itemIndex = this.getIndexByValue(value);
                            break;
                        }
                    }
                } else itemIndex = item;
                var isValidIndex = itemIndex < this.liCollections.length && itemIndex > -1;
                if (isValidIndex && !JSON.parse(JSON.stringify(this.listData[itemIndex]))[this.fields.disabled]) {
                    var li = this.liCollections[itemIndex];
                    if (li) {
                        this.disableListItem(li);
                        var parsedData = JSON.parse(JSON.stringify(this.listData[itemIndex]));
                        parsedData[this.fields.disabled] = true;
                        this.listData[itemIndex] = parsedData;
                        if (li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus)) this.removeFocus();
                        if (li.classList.contains($717505a12e9203b8$var$HIDE_LIST) || li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected)) {
                            var oldValue = this.value;
                            this.removeDisabledItemsValue(this.value);
                            this.updateVal(this.value, oldValue, "value");
                        }
                        if (this.mode === "CheckBox" && this.enableGroupCheckBox && !(0, $3EnZW.isNullOrUndefined)(this.fields.groupBy)) this.disableGroupHeader();
                    }
                }
            }
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ MultiSelect.prototype.destroy = function() {
        // eslint-disable-next-line
        if (this.isReact) this.clearTemplate();
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj)) {
            this.popupObj.hide();
            this.popupObj.destroy();
        }
        this.notify($717505a12e9203b8$var$destroy, {});
        this.unwireListEvents();
        this.unWireEvent();
        var temp = [
            "readonly",
            "aria-disabled",
            "placeholder",
            "aria-label",
            "aria-expanded"
        ];
        var length = temp.length;
        if (!(0, $3EnZW.isNullOrUndefined)(this.inputElement)) while(length > 0){
            this.inputElement.removeAttribute(temp[length - 1]);
            length--;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.element)) {
            this.element.removeAttribute("data-initial-value");
            this.element.style.display = "block";
        }
        if (this.overAllWrapper && this.overAllWrapper.parentElement) {
            if (this.overAllWrapper.parentElement.tagName === this.getNgDirective()) (0, $4ZDHT.remove)(this.overAllWrapper);
            else {
                this.overAllWrapper.parentElement.insertBefore(this.element, this.overAllWrapper);
                (0, $4ZDHT.remove)(this.overAllWrapper);
            }
        }
        if (this.popupWrapper && this.popupWrapper.parentElement) this.popupWrapper.parentElement.remove();
        while(this.searchWrapper && this.searchWrapper.firstChild)this.searchWrapper.removeChild(this.searchWrapper.firstChild);
        if (this.searchWrapper && this.searchWrapper.parentElement) this.searchWrapper.parentElement.remove();
        if (this.viewWrapper && this.viewWrapper.parentElement) this.viewWrapper.parentElement.remove();
        if (this.overAllClear && this.overAllClear.parentElement) this.overAllClear.parentElement.remove();
        if (this.delimiterWrapper && this.delimiterWrapper.parentElement) this.delimiterWrapper.parentElement.remove();
        // Remove the select element if it exists
        var selectElement = this.overAllWrapper.querySelector("select.e-multi-hidden");
        if (selectElement && selectElement.parentElement) selectElement.parentElement.remove();
        while(this.componentWrapper && this.componentWrapper.firstChild)this.componentWrapper.removeChild(this.componentWrapper.firstChild);
        if (this.componentWrapper && this.componentWrapper.parentElement) {
            this.componentWrapper.removeAttribute("class");
            this.componentWrapper.parentElement.remove();
        }
        while(this.popupWrapper && this.popupWrapper.firstChild)this.popupWrapper.removeChild(this.popupWrapper.firstChild);
        if (this.inputElement) {
            var attrArray = [
                "readonly",
                "aria-disabled",
                "placeholder",
                "aria-labelledby",
                "aria-expanded",
                "autocomplete",
                "aria-readonly",
                "autocapitalize",
                "spellcheck",
                "aria-autocomplete",
                "aria-live",
                "aria-label",
                "aria-hidden",
                "tabindex",
                "aria-controls",
                "aria-describedby",
                "size",
                "role",
                "type",
                "class"
            ];
            for(var i = 0; i < attrArray.length; i++)this.inputElement.removeAttribute(attrArray[i]);
        }
        if (this.inputElement) this.inputElement.remove();
        this.list = null;
        this.popupObj = null;
        this.mainData = null;
        this.filterParent = null;
        this.ulElement = null;
        this.componentWrapper = null;
        this.overAllClear = null;
        this.overAllWrapper = null;
        this.hiddenElement = null;
        this.searchWrapper = null;
        this.viewWrapper = null;
        this.chipCollectionWrapper = null;
        this.targetInputElement = null;
        this.popupWrapper = null;
        this.inputElement = null;
        this.delimiterWrapper = null;
        this.liCollections = null;
        this.header = null;
        this.mainList = null;
        this.mainListCollection = null;
        this.footer = null;
        this.selectAllEventEle = null;
        _super.prototype.destroy.call(this);
    };
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Complex)({
            text: null,
            value: null,
            iconCss: null,
            groupBy: null,
            disabled: null
        }, (0, $8333a85b68b3ebf8$export$47acbd07e937cc3e))
    ], MultiSelect.prototype, "fields", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "enablePersistence", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "groupTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("No records found")
    ], MultiSelect.prototype, "noRecordsTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("Request failed")
    ], MultiSelect.prototype, "actionFailureTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], MultiSelect.prototype, "sortOrder", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "enabled", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "enableHtmlSanitizer", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "enableVirtualization", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)([])
    ], MultiSelect.prototype, "dataSource", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "query", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("StartsWith")
    ], MultiSelect.prototype, "filterType", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], MultiSelect.prototype, "zIndex", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "ignoreAccent", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)()
    ], MultiSelect.prototype, "locale", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "enableGroupCheckBox", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "cssClass", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], MultiSelect.prototype, "width", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("300px")
    ], MultiSelect.prototype, "popupHeight", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], MultiSelect.prototype, "popupWidth", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "placeholder", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "filterBarPlaceholder", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)({})
    ], MultiSelect.prototype, "htmlAttributes", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "valueTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "headerTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "footerTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "itemTemplate", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "allowFiltering", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "isDeviceFullScreen", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "changeOnBlur", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "allowCustomValue", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "showClearButton", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(1000)
    ], MultiSelect.prototype, "maximumSelectionLength", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "readonly", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "text", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], MultiSelect.prototype, "value", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "allowObjectBinding", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "hideSelectedItem", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "closePopupOnSelect", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("Default")
    ], MultiSelect.prototype, "mode", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(",")
    ], MultiSelect.prototype, "delimiterChar", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "ignoreCase", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "showDropDownIcon", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("Never")
    ], MultiSelect.prototype, "floatLabelType", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "showSelectAll", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("Select All")
    ], MultiSelect.prototype, "selectAllText", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)("Unselect All")
    ], MultiSelect.prototype, "unSelectAllText", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "enableSelectionOrder", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], MultiSelect.prototype, "openOnClick", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], MultiSelect.prototype, "addTagOnBlur", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "change", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "removing", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "removed", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "beforeSelectAll", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "selectedAll", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "beforeOpen", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "open", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "close", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "blur", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "focus", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "chipSelection", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "filtering", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "tagging", void 0);
    $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.Event)()
    ], MultiSelect.prototype, "customValueSelection", void 0);
    MultiSelect = $717505a12e9203b8$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], MultiSelect);
    return MultiSelect;
}((0, $8333a85b68b3ebf8$export$7dc99c6c1af7b42));


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * The `Base` module.
 */ var $f9046be79aeff00b$export$ef88aa0d34c34520 = /** @class */ function() {
    function Base(parent, module) {
        this.parent = parent;
        this.module = module;
        this.addEventListener();
    }
    Base.prototype.render = function(e) {
        this.module.render(e);
    };
    Base.prototype.showPopup = function() {
        this.module.showPopup();
    };
    Base.prototype.focus = function() {
        this.module.focus();
    };
    Base.prototype.update = function(e) {
        this.module.updateValue(e);
    };
    Base.prototype.getValue = function() {
        this.module.getRenderValue();
    };
    Base.prototype.destroyComponent = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.module.compObj)) return;
        this.module.compObj.destroy();
        this.module.compObj = undefined;
    };
    Base.prototype.destroy = function() {
        this.destroyComponent();
        this.removeEventListener();
    };
    Base.prototype.addEventListener = function() {
        this.parent.on($40348da204e6a693$export$b3890eb0ae9dca99, this.render, this);
        this.parent.on($40348da204e6a693$export$f06c444b0336b5d5, this.focus, this);
        this.parent.on($40348da204e6a693$export$348d584e223bdf1b, this.showPopup, this);
        this.parent.on($40348da204e6a693$export$722fbec263ad908a, this.update, this);
        this.parent.on($40348da204e6a693$export$a0fcb8a4617a63a1, this.getValue, this);
        this.parent.on($40348da204e6a693$export$5098e90bbeb5a2b4, this.destroyComponent, this);
        this.parent.on($40348da204e6a693$export$b1fb4cac938035f7, this.destroy, this);
    };
    Base.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($40348da204e6a693$export$b3890eb0ae9dca99, this.render);
        this.parent.off($40348da204e6a693$export$f06c444b0336b5d5, this.focus);
        this.parent.off($40348da204e6a693$export$348d584e223bdf1b, this.showPopup);
        this.parent.off($40348da204e6a693$export$722fbec263ad908a, this.update);
        this.parent.off($40348da204e6a693$export$a0fcb8a4617a63a1, this.getValue);
        this.parent.off($40348da204e6a693$export$5098e90bbeb5a2b4, this.destroyComponent);
        this.parent.off($40348da204e6a693$export$b1fb4cac938035f7, this.destroy);
    };
    return Base;
}();


var $8eb1bb0c25d9a770$var$__assign = undefined && undefined.__assign || function() {
    $8eb1bb0c25d9a770$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8eb1bb0c25d9a770$var$__assign.apply(this, arguments);
};
/**
 * The `MultiSelect` module is used configure the properties of Multi select type editor.
 */ var $8eb1bb0c25d9a770$export$1e7dfd31545b5809 = /** @class */ function() {
    function MultiSelect(parent) {
        this.isPopOpen = false;
        this.compObj = undefined;
        this.parent = parent;
        this.parent.multiSelectModule = this;
        this.base = new (0, $f9046be79aeff00b$export$ef88aa0d34c34520)(this.parent, this);
    }
    MultiSelect.prototype.render = function(e) {
        var compModel = $8eb1bb0c25d9a770$var$__assign({}, this.parent.model);
        this.openEvent = compModel.open;
        this.closeEvent = compModel.close;
        compModel.open = this.openHandler.bind(this);
        compModel.close = this.closeHandler.bind(this);
        this.compObj = new (0, $717505a12e9203b8$export$1e7dfd31545b5809)(compModel);
        this.compObj.appendTo(e.target);
    };
    MultiSelect.prototype.openHandler = function(e) {
        this.isPopOpen = true;
        if (this.openEvent) {
            this.compObj.setProperties({
                open: this.openEvent
            }, true);
            this.compObj.trigger("open", e);
        }
    };
    MultiSelect.prototype.closeHandler = function(e) {
        this.isPopOpen = false;
        if (this.closeEvent) {
            this.compObj.setProperties({
                close: this.closeEvent
            }, true);
            this.compObj.trigger("close", e);
        }
    };
    MultiSelect.prototype.focus = function() {
        if (!this.isPopOpen) {
            var evt = document.createEvent("MouseEvent");
            evt.initEvent("mousedown", true, true);
            (0, $4ZDHT.closest)(this.compObj.element, ".e-multi-select-wrapper").dispatchEvent(evt);
        }
    };
    MultiSelect.prototype.updateValue = function(e) {
        if (this.compObj && e.type === "MultiSelect") {
            this.parent.setProperties({
                value: this.compObj.value
            }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    };
    MultiSelect.prototype.getRenderValue = function() {
        this.parent.printValue = this.compObj.text;
    };
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ MultiSelect.prototype.destroy = function() {
        this.base.destroy();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */ MultiSelect.prototype.getModuleName = function() {
        return "multi-select";
    };
    return MultiSelect;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $cfGuF = parcelRequire("cfGuF");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
/**
 * @hidden

 */ var $947a002e9a697770$export$2e3d29103780bd37 = "create";
var $947a002e9a697770$export$ee16d7cb334f2c25 = "destroy";
var $947a002e9a697770$export$5dbeb4561f6544b7 = "tableclass";
var $947a002e9a697770$export$11e63f7b0f3d9900 = "load";
var $947a002e9a697770$export$b70fe0c8c3456154 = "initial-load";
var $947a002e9a697770$export$a2ef9682a059097c = "content-changed";
var $947a002e9a697770$export$5d4840440f592fca = "initial-end";
var $947a002e9a697770$export$b23f8993ab731614 = "iframe-click";
var $947a002e9a697770$export$b1fb4cac938035f7 = "destroy";
var $947a002e9a697770$export$56b876c24dda3084 = "toolbarClick";
var $947a002e9a697770$export$6a017cfaa3b33c68 = "toolbar-refresh";
var $947a002e9a697770$export$8502058ba5fe50a0 = "refresh-begin";
var $947a002e9a697770$export$209bc394f8eec6dc = "toolbar-updated";
var $947a002e9a697770$export$c909ec3b151c9e0e = "bind-on-end";
var $947a002e9a697770$export$d3e2e39ad7d15e6d = "html-toolbar-click";
var $947a002e9a697770$export$2a6b3606af0895e8 = "markdown-toolbar-click";
var $947a002e9a697770$export$80cded91831c5507 = "model-changed";
var $947a002e9a697770$export$9e83668a3bc32ff2 = "tableModulekeyUp";
var $947a002e9a697770$export$2bfa26ed2a709c52 = "keyUp";
var $947a002e9a697770$export$d081dc64f99d208b = "keyDown";
var $947a002e9a697770$export$9d60f25f506de572 = "onImport";
var $947a002e9a697770$export$386d6cd834630df8 = "onExport";
var $947a002e9a697770$export$9ac49ece09f002f8 = "mouseUp";
var $947a002e9a697770$export$e07a9422bd2a0dce = "toolbarCreated";
var $947a002e9a697770$export$4598c5c2283d3ecd = "toolbarRenderComplete";
var $947a002e9a697770$export$6b5a35c4a823eab1 = "enableFullScreen";
var $947a002e9a697770$export$7f96353fc4f89f6b = "disableFullScreen";
var $947a002e9a697770$export$55eface7583121e7 = "dropDownSelect";
var $947a002e9a697770$export$9c270263992f2055 = "beforeDropDownItemRender";
var $947a002e9a697770$export$4e0a4553c5a3311d = "execCommandCallBack";
var $947a002e9a697770$export$af013f327a7c9f36 = "image-toolbar-action";
var $947a002e9a697770$export$14e4186604d20036 = "audio-toolbar-action";
var $947a002e9a697770$export$5f8f11a2ec9ad852 = "video-toolbar-action";
var $947a002e9a697770$export$977b0775e5db06ed = "link-toolbar-action";
var $947a002e9a697770$export$bad6189f4d27c01f = "resize";
var $947a002e9a697770$export$6aff6a45c0c4e7c4 = "resizeStart";
var $947a002e9a697770$export$45b39e67d4ce4921 = "resizing";
var $947a002e9a697770$export$8c4d3b559babc6db = "resizeStop";
var $947a002e9a697770$export$21f930c44940fd98 = "undo";
var $947a002e9a697770$export$1688e416fee0a49e = "redo";
var $947a002e9a697770$export$c13c4fbf8f656592 = "insertLink";
var $947a002e9a697770$export$85ed0bdd39881c2c = "unLink";
var $947a002e9a697770$export$f32208a27284df67 = "editLink";
var $947a002e9a697770$export$95185d699e05d4d7 = "openLink";
var $947a002e9a697770$export$df204737a6131aab = "actionBegin";
var $947a002e9a697770$export$830631a3cb598490 = "actionComplete";
var $947a002e9a697770$export$2e0e26484d7e9fc5 = "updatedToolbarStatus";
var $947a002e9a697770$export$b8bdf8945930e196 = "actionSuccess";
var $947a002e9a697770$export$d928e346d13acf9b = "updateToolbarItem";
var $947a002e9a697770$export$5ae819692184d2fb = "insertImage";
var $947a002e9a697770$export$b71d7033796fa5cc = "insertAudio";
var $947a002e9a697770$export$73a289ac38fc1ec = "insertVideo";
var $947a002e9a697770$export$ac0f8621e12395a0 = "insertCompleted";
var $947a002e9a697770$export$c272ae7c645a733b = "justifyLeft";
var $947a002e9a697770$export$633aae32229bcb80 = "justifyRight";
var $947a002e9a697770$export$d14a4bf972099fdd = "justifyCenter";
var $947a002e9a697770$export$c1ec55746e8a6f68 = "break";
var $947a002e9a697770$export$8955ea40f503e248 = "inline";
var $947a002e9a697770$export$d5e570a5ba3c39ae = "insertImgLink";
var $947a002e9a697770$export$da137bcb4d9a1f5c = "imgAltText";
var $947a002e9a697770$export$bf265c1f5581a919 = "delete";
var $947a002e9a697770$export$3fbb519abc8109bb = "delete";
var $947a002e9a697770$export$9aa8e6dd9bc07056 = "delete";
var $947a002e9a697770$export$d1a88e38890bde53 = "caption";
var $947a002e9a697770$export$da6ba7b3a8f90d94 = "imageSize";
var $947a002e9a697770$export$383e1e0225d28d1e = "videoSize";
var $947a002e9a697770$export$a03f62af6e933a3 = "sourceCode";
var $947a002e9a697770$export$328b0edc9fda3a36 = "updateSource";
var $947a002e9a697770$export$fa1f2da170a69871 = "toolbarOpen";
var $947a002e9a697770$export$3582505bf03a41c5 = "beforeDropDownOpen";
var $947a002e9a697770$export$dd9b49d5e9b25abd = "selection-save";
var $947a002e9a697770$export$ae80d5dbf349b0b4 = "selection-restore";
var $947a002e9a697770$export$fde8cb54e4b80f09 = "expandPopupClick";
var $947a002e9a697770$export$85b9a36db797e02b = "count";
var $947a002e9a697770$export$566f3fe6978b30a8 = "contentFocus";
var $947a002e9a697770$export$eecadfaf1a38b7ad = "contentBlur";
var $947a002e9a697770$export$ea32a7693b83cfdb = "mouseDown";
var $947a002e9a697770$export$20d87a998eb21859 = "sourceCodeMouseDown";
var $947a002e9a697770$export$faf30c817b12eec0 = "editAreaClick";
var $947a002e9a697770$export$209876d7b1ac8f3 = "scroll";
var $947a002e9a697770$export$55df3e903573f90b = "contentscroll";
var $947a002e9a697770$export$be0ed384f2f95da8 = "colorPickerChanged";
var $947a002e9a697770$export$417c038e951e7489 = "tableColorPickerChanged";
var $947a002e9a697770$export$ceb2354ae09b6ff = "focusChange";
var $947a002e9a697770$export$90aca4adda6ff0f5 = "selectAll";
var $947a002e9a697770$export$86be68e1224a0620 = "selectRange";
var $947a002e9a697770$export$76d3c88e0e217d4e = "getSelectedHtml";
var $947a002e9a697770$export$242492f0a40e77d2 = "renderInlineToolbar";
var $947a002e9a697770$export$9b6706c8686cfc8e = "paste-content";
var $947a002e9a697770$export$7dd2d17ac3c49ea1 = "imageModule";
var $947a002e9a697770$export$9dcaf34b3cdca414 = "rtl-mode";
var $947a002e9a697770$export$33bbb3ec7652e187 = "createTable";
var $947a002e9a697770$export$49aaf87a462f3eb3 = "docClick";
var $947a002e9a697770$export$fc73c017dfcf29c9 = "table-toolbar-action";
var $947a002e9a697770$export$b2d123672bfdbe32 = "checkUndoStack";
var $947a002e9a697770$export$ff4edde773b9bda2 = "readOnlyMode";
var $947a002e9a697770$export$32f783c04cad0a05 = "pasteClean";
var $947a002e9a697770$export$606c1792086c85f2 = "enterHandler";
var $947a002e9a697770$export$9d4d8791559c7809 = "beforeDialogOpen";
var $947a002e9a697770$export$7b0b04da5bd57800 = "clearDialogObj";
var $947a002e9a697770$export$a85fefe9f9398bfb = "dialogOpen";
var $947a002e9a697770$export$ff4b54f54b38aea1 = "beforeDialogClose";
var $947a002e9a697770$export$910a35e3fa4f9af = "dialogClose";
var $947a002e9a697770$export$322c57d724d0f89c = "beforeQuickToolbarOpen";
var $947a002e9a697770$export$17b18cd22953de37 = "quickToolbarOpen";
var $947a002e9a697770$export$40fde4e3940a7c90 = "quickToolbarClose";
var $947a002e9a697770$export$28e85c7e5d7fd305 = "popupHide";
var $947a002e9a697770$export$ca9dc16f801d1711 = "imageSelected";
var $947a002e9a697770$export$fce94e5d515bb6fa = "imageUploading";
var $947a002e9a697770$export$3d5930a2bedfca4f = "imageUploadSuccess";
var $947a002e9a697770$export$e3f6ff7da8c3e03f = "imageUploadFailed";
var $947a002e9a697770$export$2004dcd6614347a = "imageRemoving";
var $947a002e9a697770$export$cd4c780a3205848c = "fileSelected";
var $947a002e9a697770$export$ea51d7451bf2a8d8 = "fileUploading";
var $947a002e9a697770$export$765cb3120ada5f48 = "fileUploadSuccess";
var $947a002e9a697770$export$f32e611c2450ce56 = "fileUploadFailed";
var $947a002e9a697770$export$af6060fcb094c173 = "fileRemoving";
var $947a002e9a697770$export$61590b3a6f2109b = "afterImageDelete";
var $947a002e9a697770$export$bd12237ad996f402 = "afterMediaDelete";
var $947a002e9a697770$export$663103110d94aac9 = "drop";
var $947a002e9a697770$export$76028e63d5b7a5cc = "xhtmlValidation";
var $947a002e9a697770$export$21462d42bdb4e9c = "beforeImageUpload";
var $947a002e9a697770$export$cc40225aa9b0a067 = "beforeFileUpload";
var $947a002e9a697770$export$89dafc2f17510148 = "resizeInitialized";
var $947a002e9a697770$export$82523cb97e033732 = "renderFileManager";
var $947a002e9a697770$export$ccd2477faa5965e8 = "beforeImageDrop";
var $947a002e9a697770$export$446aef6294af7f8b = "dynamicModule";
var $947a002e9a697770$export$b3d75de79ba96fb7 = "beforePasteCleanup";
var $947a002e9a697770$export$66c84204ad5d6049 = "afterPasteCleanup";
var $947a002e9a697770$export$4755fca075b63809 = "updateTbItemsStatus";
var $947a002e9a697770$export$133203a753e0e8c5 = "showLinkDialog";
var $947a002e9a697770$export$1183608103c7fad2 = "closeLinkDialog";
var $947a002e9a697770$export$5617ef57439be2b = "showImageDialog";
var $947a002e9a697770$export$86f139d5d20038ff = "showAudioDialog";
var $947a002e9a697770$export$747747cd285e0bb9 = "showVideoDialog";
var $947a002e9a697770$export$5884d34c82a0825a = "closeImageDialog";
var $947a002e9a697770$export$68bf2f47fab9348f = "closeAudioDialog";
var $947a002e9a697770$export$2b859288d6d27b84 = "closeVideoDialog";
var $947a002e9a697770$export$815a79e2a317fc9 = "showTableDialog";
var $947a002e9a697770$export$4301237dfe1688e2 = "closeTableDialog";
var $947a002e9a697770$export$3195fd95fc6395d5 = "bindCssClass";
var $947a002e9a697770$export$499fb5841cd4be09 = "formatPainterClick";
var $947a002e9a697770$export$e26301c11948181c = "formatPainterDoubleClick";
var $947a002e9a697770$export$4d7e4d3283b3fc57 = "emojiPicker";
var $947a002e9a697770$export$121c0465ebbf863b = "destroyTooltip";
var $947a002e9a697770$export$bba5038aab73375b = "hidePopup";
var $947a002e9a697770$export$9da6da25c8aa3ca9 = "cleanupResizeElements";
var $947a002e9a697770$export$a4836fff3a9f5351 = "afterKeyDown";
var $947a002e9a697770$export$7a1b1fa1df219330 = "updateValueOnIdle";
var $947a002e9a697770$export$4895f32c534ef936 = "documentClickClosedBy";
var $947a002e9a697770$export$8c46940ff642b0df = "showColorPicker";
var $947a002e9a697770$export$6108d95d641a81fb = "closeTooltip";
var $947a002e9a697770$export$c1294d1049dd22e8 = "autoResize";
var $947a002e9a697770$export$91469607ee8f30a1 = "address:empty, article:empty, aside:empty, blockquote:empty,\n details:empty, dd:empty, div:empty, dl:empty, dt:empty, fieldset:empty, footer:empty,form:empty, h1:empty,\n h2:empty, h3:empty, h4:empty, h5:empty, h6:empty, header:empty, hgroup:empty, li:empty, main:empty, nav:empty,\n noscript:empty, output:empty, p:empty, pre:empty, section:empty, td:empty, th:empty";
var $947a002e9a697770$export$f29525ac8b889ffd = "a:empty, abbr:empty, acronym:empty, b:empty, bdi:empty, bdo:empty, big:empty, button:empty,\ncanvas:empty, cite:empty, code:empty, data:empty, datalist:empty, del:empty, dfn:empty, em:empty, font:empty, i:empty, iframe:empty,\nins:empty, kbd:empty, label:empty, map:empty, mark:empty, meter:empty, noscript:empty, object:empty, output:empty, picture:empty, progress:empty,\nq:empty, ruby:empty, s:empty, samp:empty, script:empty, select:empty, slot:empty, small:empty, span:empty, strong:empty, strike:empty, sub:empty, sup:empty, svg:empty,\ntemplate:empty, textarea:empty, time:empty, u:empty, tt:empty, var:empty, wbr:empty";
var $947a002e9a697770$export$75a6c7326da01ed3 = [
    "px",
    "em",
    "rem",
    "pt",
    "cm",
    "mm",
    "in",
    "pc",
    "vw",
    "vh",
    "vmin",
    "vmax"
];
var $947a002e9a697770$export$7b5604ec01e659a3 = {
    "px": {
        "px": 1,
        "em": 0.0625,
        "rem": 0.0625,
        "pt": 0.75,
        "cm": 0.0264583,
        "mm": 0.0026458,
        "in": 0.0104167,
        "pc": 0.0625,
        "vw": 0.00625,
        "vh": 0.00625,
        "vmin": 0.00625,
        "vmax": 0.00625
    },
    "em": {
        "px": 16,
        "em": 1,
        "rem": 1,
        "pt": 12,
        "cm": 0.423333,
        "mm": 0.0423333,
        "in": 0.166667,
        "pc": 0.0625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    },
    "rem": {
        "px": 16,
        "em": 1,
        "rem": 1,
        "pt": 12,
        "cm": 0.423333,
        "mm": 0.0423333,
        "in": 0.166667,
        "pc": 0.0625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    },
    "pt": {
        "px": 1.33333,
        "em": 0.0833333,
        "rem": 0.0833333,
        "pt": 1,
        "cm": 0.0352778,
        "mm": 0.0035278,
        "in": 0.0138889,
        "pc": 0.0416667,
        "vw": 0.00416667,
        "vh": 0.00416667,
        "vmin": 0.00416667,
        "vmax": 0.00416667
    },
    "cm": {
        "px": 37.7953,
        "em": 2.3622,
        "rem": 2.3622,
        "pt": 28.3465,
        "cm": 1,
        "mm": 0.1,
        "in": 0.393701,
        "pc": 0.148148,
        "vw": 0.0377953,
        "vh": 0.0377953,
        "vmin": 0.0377953,
        "vmax": 0.0377953
    },
    "mm": {
        "px": 3.77953,
        "em": 0.23622,
        "rem": 0.23622,
        "pt": 2.83465,
        "cm": 10,
        "mm": 1,
        "in": 0.0393701,
        "pc": 0.0148148,
        "vw": 0.00377953,
        "vh": 0.00377953,
        "vmin": 0.00377953,
        "vmax": 0.00377953
    },
    "in": {
        "px": 96,
        "em": 6,
        "rem": 6,
        "pt": 72,
        "cm": 2.54,
        "mm": 25.4,
        "in": 1,
        "pc": 0.375,
        "vw": 0.09375,
        "vh": 0.09375,
        "vmin": 0.09375,
        "vmax": 0.09375
    },
    "pc": {
        "px": 16,
        "em": 1,
        "rem": 1,
        "pt": 12,
        "cm": 0.423333,
        "mm": 0.0423333,
        "in": 0.166667,
        "pc": 1,
        "vw": 0.0625,
        "vh": 0.0625,
        "vmin": 0.0625,
        "vmax": 0.0625
    },
    "vw": {
        "px": 160,
        "em": 10,
        "rem": 10,
        "pt": 120,
        "cm": 4.23333,
        "mm": 0.423333,
        "in": 1.66667,
        "pc": 0.625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    },
    "vh": {
        "px": 160,
        "em": 10,
        "rem": 10,
        "pt": 120,
        "cm": 4.23333,
        "mm": 0.423333,
        "in": 1.66667,
        "pc": 0.625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    },
    "vmin": {
        "px": 160,
        "em": 10,
        "rem": 10,
        "pt": 120,
        "cm": 4.23333,
        "mm": 0.423333,
        "in": 1.66667,
        "pc": 0.625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    },
    "vmax": {
        "px": 160,
        "em": 10,
        "rem": 10,
        "pt": 120,
        "cm": 4.23333,
        "mm": 0.423333,
        "in": 1.66667,
        "pc": 0.625,
        "vw": 1,
        "vh": 1,
        "vmin": 1,
        "vmax": 1
    }
};
var $947a002e9a697770$export$6f23f8d8c684bbf3 = "onHandleFontsizeChange";


/**
 * Rich Text Editor classes defined here.
 */ /**
 * @hidden

 */ var $afc560df281b588d$export$1961a0ca09d720a9 = "e-richtexteditor";
var $afc560df281b588d$export$634124fb33d6a503 = "e-rtl";
var $afc560df281b588d$export$1c0af67b2296ec6f = "e-content";
var $afc560df281b588d$export$a0040262df92c03 = "e-disabled";
var $afc560df281b588d$export$fa864e52883d32eb = "rte-iframe-script-sheet";
var $afc560df281b588d$export$29177b1f49d99421 = "rte-iframe-style-sheet";
var $afc560df281b588d$export$b8cca86ae4c54cb3 = "e-rte-container";
var $afc560df281b588d$export$c944507d642a4701 = "e-rte-toolbar";
var $afc560df281b588d$export$fd53f820baeb149a = "e-rte-tb-fixed";
var $afc560df281b588d$export$b46c3eca2c4f8c25 = "e-rte-tb-float";
var $afc560df281b588d$export$6693fa5cc8580ada = "e-rte-inline";
var $afc560df281b588d$export$51f54e677db9b928 = "e-rte-tb-inline";
var $afc560df281b588d$export$cb3f7a6ad383a6c6 = "e-rte-tb-expand";
var $afc560df281b588d$export$f43b8d11ae23b9a = "e-rte-full-screen";
var $afc560df281b588d$export$1af4006d1f8f8239 = "e-rte-quick-toolbar";
var $afc560df281b588d$export$a46bb09fc4657cb4 = "e-rte-text-quicktoolbar";
var $afc560df281b588d$export$d5575e9771aeb97e = "e-rte-pop";
var $afc560df281b588d$export$9f76c1757d135a93 = "e-tb-static";
var $afc560df281b588d$export$530d3eb0a8cca61c = "e-rte-quick-popup";
var $afc560df281b588d$export$ee37e714e6bdefff = "e-quick-dropdown";
var $afc560df281b588d$export$b34e1d1e0c3f7110 = "e-rte-image-popup";
var $afc560df281b588d$export$76164a13d58bec6 = "e-rte-text-popup";
var $afc560df281b588d$export$757b82a79a74806a = "e-rte-inline-popup";
var $afc560df281b588d$export$de9fd411a461238e = "e-rte-inline-dropdown";
var $afc560df281b588d$export$e87b94e3426d0cad = "e-rte-dropdown-popup";
var $afc560df281b588d$export$64945f631d1fe0d8 = "e-rte-dropdown-icons";
var $afc560df281b588d$export$363cb49e8d5ce21c = "e-rte-dropdown-items";
var $afc560df281b588d$export$a16280636ed97757 = "e-rte-dropdown-btn";
var $afc560df281b588d$export$603c56dc2061d555 = "e-rte-content";
var $afc560df281b588d$export$43195ed9dfb35649 = "e-toolbar-item";
var $afc560df281b588d$export$b172abd9be2305fd = "e-toolbar-extended";
var $afc560df281b588d$export$8b3fa306a1b76ad1 = "e-toolbar-wrapper";
var $afc560df281b588d$export$c9c070bb0f38e4d2 = "e-popup";
var $afc560df281b588d$export$a74784b9beea2cad = "e-separator";
var $afc560df281b588d$export$4924c75862d82fd5 = "e-minimize";
var $afc560df281b588d$export$5336b91abcde500a = "e-maximize";
var $afc560df281b588d$export$7a3dc294fb33a6e = "e-back";
var $afc560df281b588d$export$e9b981d6ef5e24ab = "e-show";
var $afc560df281b588d$export$e5db7105a59c014a = "e-hide";
var $afc560df281b588d$export$1e3d54316c24cb7e = "e-visible";
var $afc560df281b588d$export$f6dd9c0812bc4312 = "e-focused";
var $afc560df281b588d$export$2e33093ebe88b75b = "e-remove-white-space";
var $afc560df281b588d$export$d04b9cba559647e = "e-imgright";
var $afc560df281b588d$export$3d22da888fd4da4c = "e-imgleft";
var $afc560df281b588d$export$6001aa7dff3449a3 = "e-imgcenter";
var $afc560df281b588d$export$c6e979ddaa53685e = "e-imgbreak";
var $afc560df281b588d$export$4a726e255dce0eee = "e-audio-break";
var $afc560df281b588d$export$a13f0f97539de275 = "e-clickelem";
var $afc560df281b588d$export$8dfb598a1fc054c7 = "e-video-clickelem";
var $afc560df281b588d$export$89572e2cf0e0f6e9 = "e-audio-wrap";
var $afc560df281b588d$export$fea5ac7fbfdd17f0 = "e-video-wrap";
var $afc560df281b588d$export$871b6a3cec24584d = "e-video-break";
var $afc560df281b588d$export$8cc8187364c14638 = "e-img-caption";
var $afc560df281b588d$export$f23065c8d5ed6b8d = "e-rte-img-caption";
var $afc560df281b588d$export$dcd8f689ae4af23c = "e-caption-inline";
var $afc560df281b588d$export$650bb6ed56b4642 = "e-imginline";
var $afc560df281b588d$export$aa04ae99872a701a = "e-audio-inline";
var $afc560df281b588d$export$3137cd114e7b0358 = "e-video-inline";
var $afc560df281b588d$export$e8557914480abfcd = "e-rte-character-count";
var $afc560df281b588d$export$fcbb96fdfda8178b = "e-warning";
var $afc560df281b588d$export$c72e8d6e86fd4559 = "e-error";
var $afc560df281b588d$export$dca6c13941d1c7e = "e-icons";
var $afc560df281b588d$export$79952d4ba2101dd4 = "e-active";
var $afc560df281b588d$export$c024b26acaa71d78 = "e-expand-open";
var $afc560df281b588d$export$d3f61cb93957903e = "e-rte-elements";
var $afc560df281b588d$export$7446a6f3c13dcc36 = "e-tbar-btn";
var $afc560df281b588d$export$1814cae66e425659 = "e-rte-horizontal-separator";
var $afc560df281b588d$export$22126b7681996770 = "e-tbar-ios-fixed";
var $afc560df281b588d$export$b7c856c7a2548da8 = "e-rte-list-primary-content";
var $afc560df281b588d$export$ecbbc31b8a8bb45c = "e-rte-numberformatlist-dropdown";
var $afc560df281b588d$export$2a6a4b5d454c6efc = "e-rte-bulletformatlist-dropdown";
var $afc560df281b588d$export$322d1188ce2fb80b = "e-formats-tbar-btn";
var $afc560df281b588d$export$26e46de3c028f9ab = "e-font-name-tbar-btn";
var $afc560df281b588d$export$efeebb5e697869be = "e-font-size-tbar-btn";
var $afc560df281b588d$export$731568aba8c683a = "e-alignment-tbar-btn";
var $afc560df281b588d$export$a58de53b69ab3ae1 = "e-rte-fontcolor-element";
var $afc560df281b588d$export$a8e816139edb38c7 = "e-rte-backgroundcolor-element";
var $afc560df281b588d$export$7a2bf3ea134093f0 = "e-rte-color-content";
var $afc560df281b588d$export$9c7ffbe575933c12 = "e-rte-fontcolor-dropdown";
var $afc560df281b588d$export$ea10f5b2db4abd9e = "e-rte-backgroundcolor-dropdown";
var $afc560df281b588d$export$cfaef651d407891e = "e-rte-square-palette";
var $afc560df281b588d$export$39c6a5301555ae46 = "e-rte-fontcolor-colorpicker";
var $afc560df281b588d$export$c914a9c929148d63 = "e-rte-backgroundcolor-colorpicker";
var $afc560df281b588d$export$f53692bf3792d5c = "e-rte-readonly";
var $afc560df281b588d$export$e959d74fe932d9e5 = "e-cell-select";
var $afc560df281b588d$export$fb3f256521ea2317 = "e-cell-select-end";
var $afc560df281b588d$export$4a8550b2cafbc9fc = "e-multi-cells-select";
var $afc560df281b588d$export$f93d07ccbf22a6e = "e-dashed-border";
var $afc560df281b588d$export$a5705c5793875560 = "e-alternate-border";
var $afc560df281b588d$export$97001d3d2f729a40 = "e-column-resize";
var $afc560df281b588d$export$f3e568bf9fb0b3e0 = "e-row-resize";
var $afc560df281b588d$export$d56486b0aa3bd575 = "e-table-box";
var $afc560df281b588d$export$c7f23d620ab4e862 = "e-rte-hidden";
var $afc560df281b588d$export$d7d05b723fc9e7ff = "e-rte-keepformat";
var $afc560df281b588d$export$87cd0d9d8e507a26 = "e-rte-removeformat";
var $afc560df281b588d$export$a19a2e43f10bbf59 = "e-rte-plainformat";
var $afc560df281b588d$export$cff6ea0e0f2bf1ea = "e-rte-pasteok";
var $afc560df281b588d$export$e332cd1ae50c0315 = "e-rte-pastecancel";
var $afc560df281b588d$export$d8ca6c8d9715ac5b = "e-rte-dialog-minheight";
var $afc560df281b588d$export$448eab0cd22871a = "e-resize-handle";
var $afc560df281b588d$export$e575b6326a544f16 = "e-south-east";
var $afc560df281b588d$export$43b7526f3bcf1c7d = "e-rte-image";
var $afc560df281b588d$export$905c13406078d997 = "e-resize";
var $afc560df281b588d$export$cab1e7d690401761 = "e-img-focus";
var $afc560df281b588d$export$6ca4282c3a1d5fa5 = "e-audio-focus";
var $afc560df281b588d$export$2dd5c5a90215b6c1 = "e-video-focus";
var $afc560df281b588d$export$93c5e02e280495b6 = "e-rte-drag-image";
var $afc560df281b588d$export$d9076b806c6d0f7b = "e-rte-upload-popup";
var $afc560df281b588d$export$22ab25c53e8ff6fa = "e-popup-open";
var $afc560df281b588d$export$47b7482a512fac11 = "e-img-resize";
var $afc560df281b588d$export$e6b14ab7328f4f39 = "e-droparea";
var $afc560df281b588d$export$4d0524c27ed8c0b1 = "e-img-inner";
var $afc560df281b588d$export$fe30c7e405c723d0 = "e-upload-files";
var $afc560df281b588d$export$a464db1be8da8ef9 = "e-rte-dialog-upload";
var $afc560df281b588d$export$33ae2c753df0589f = "e-rte-resize";
var $afc560df281b588d$export$7773d35a37f81fdf = "e-custom-tile";
var $afc560df281b588d$export$5dc99c196bef170f = "e-nocolor-item";
var $afc560df281b588d$export$17612b10568eb2b6 = "e-rte-table";
var $afc560df281b588d$export$b3b0ed3df2845e37 = "e-rte-table-border";
var $afc560df281b588d$export$55d7db1e6ef8e042 = "e-rte-table-resize";
var $afc560df281b588d$export$1e22aeee795e25a7 = "e-rte-fixed-tb-expand";
var $afc560df281b588d$export$beeb26fe5b494f20 = "e-rte-toolbar-enabled";
var $afc560df281b588d$export$3fdfeb13d846bc2f = "e-south-west";
var $afc560df281b588d$export$97efb1fe9920382d = "e-rte-srctextarea";
var $afc560df281b588d$export$860510861cf23e40 = [
    "Enter",
    "ArrowRight",
    "ArrowLeft"
];


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $cfGuF = parcelRequire("cfGuF");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $c2qqN = parcelRequire("c2qqN");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");
var $3P3ke = parcelRequire("3P3ke");

var $f606c23990200287$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f606c23990200287$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f606c23990200287$var$CONTROL_WRAPPER = "e-upload e-control-wrapper";
var $f606c23990200287$var$INPUT_WRAPPER = "e-file-select";
var $f606c23990200287$var$DROP_AREA = "e-file-drop";
var $f606c23990200287$var$DROP_WRAPPER = "e-file-select-wrap";
var $f606c23990200287$var$LIST_PARENT = "e-upload-files";
var $f606c23990200287$var$FILE = "e-upload-file-list";
var $f606c23990200287$var$STATUS = "e-file-status";
var $f606c23990200287$var$ACTION_BUTTONS = "e-upload-actions";
var $f606c23990200287$var$UPLOAD_BUTTONS = "e-file-upload-btn e-css e-btn e-flat e-primary";
var $f606c23990200287$var$CLEAR_BUTTONS = "e-file-clear-btn e-css e-btn e-flat";
var $f606c23990200287$var$FILE_NAME = "e-file-name";
var $f606c23990200287$var$FILE_TYPE = "e-file-type";
var $f606c23990200287$var$FILE_SIZE = "e-file-size";
var $f606c23990200287$var$REMOVE_ICON = "e-file-remove-btn";
var $f606c23990200287$var$DELETE_ICON = "e-file-delete-btn";
var $f606c23990200287$var$SPINNER_PANE = "e-spinner-pane";
var $f606c23990200287$var$ABORT_ICON = "e-file-abort-btn";
var $f606c23990200287$var$RETRY_ICON = "e-file-reload-btn";
var $f606c23990200287$var$DRAG_HOVER = "e-upload-drag-hover";
var $f606c23990200287$var$PROGRESS_WRAPPER = "e-upload-progress-wrap";
var $f606c23990200287$var$PROGRESSBAR = "e-upload-progress-bar";
var $f606c23990200287$var$PROGRESSBAR_TEXT = "e-progress-bar-text";
var $f606c23990200287$var$UPLOAD_INPROGRESS = "e-upload-progress";
var $f606c23990200287$var$UPLOAD_SUCCESS = "e-upload-success";
var $f606c23990200287$var$UPLOAD_FAILED = "e-upload-fails";
var $f606c23990200287$var$TEXT_CONTAINER = "e-file-container";
var $f606c23990200287$var$VALIDATION_FAILS = "e-validation-fails";
var $f606c23990200287$var$RTL = "e-rtl";
var $f606c23990200287$var$DISABLED = "e-disabled";
var $f606c23990200287$var$RTL_CONTAINER = "e-rtl-container";
var $f606c23990200287$var$ICON_FOCUSED = "e-clear-icon-focus";
var $f606c23990200287$var$PROGRESS_INNER_WRAPPER = "e-progress-inner-wrap";
var $f606c23990200287$var$PAUSE_UPLOAD = "e-file-pause-btn";
var $f606c23990200287$var$RESUME_UPLOAD = "e-file-play-btn";
var $f606c23990200287$var$RESTRICT_RETRY = "e-restrict-retry";
var $f606c23990200287$var$wrapperAttr = [
    "title",
    "style",
    "class"
];
var $f606c23990200287$var$FORM_UPLOAD = "e-form-upload";
var $f606c23990200287$var$HIDDEN_INPUT = "e-hidden-file-input";
var $f606c23990200287$var$INVALID_FILE = "e-file-invalid";
var $f606c23990200287$var$INFORMATION = "e-file-information";
var $f606c23990200287$export$7fb9d20f1c3d3d91 = /** @class */ function(_super) {
    $f606c23990200287$var$__extends(FilesProp, _super);
    function FilesProp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], FilesProp.prototype, "name", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FilesProp.prototype, "size", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], FilesProp.prototype, "type", void 0);
    return FilesProp;
}((0, $3fcxu.ChildProperty));
var $f606c23990200287$export$580730e47dd9c4cc = /** @class */ function(_super) {
    $f606c23990200287$var$__extends(ButtonsProps, _super);
    function ButtonsProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("Browse...")
    ], ButtonsProps.prototype, "browse", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("Upload")
    ], ButtonsProps.prototype, "upload", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("Clear")
    ], ButtonsProps.prototype, "clear", void 0);
    return ButtonsProps;
}((0, $3fcxu.ChildProperty));
var $f606c23990200287$export$10a5207dbbf1d28f = /** @class */ function(_super) {
    $f606c23990200287$var$__extends(AsyncSettings, _super);
    function AsyncSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], AsyncSettings.prototype, "saveUrl", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], AsyncSettings.prototype, "removeUrl", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], AsyncSettings.prototype, "chunkSize", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(3)
    ], AsyncSettings.prototype, "retryCount", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(500)
    ], AsyncSettings.prototype, "retryAfterDelay", void 0);
    return AsyncSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The uploader component allows to upload images, documents, and other files from local to server.
 * ```html
 * <input type='file' name='images[]' id='upload'/>
 * ```
 * ```typescript
 * <script>
 *   var uploadObj = new Uploader();
 *   uploadObj.appendTo('#upload');
 * </script>
 * ```
 */ var $f606c23990200287$export$b4ba47569ccac746 = /** @class */ function(_super) {
    $f606c23990200287$var$__extends(Uploader, _super);
    /**
     * Triggers when change the Uploader value.
     *
     * @param {UploaderModel} options - Specifies the Uploader model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */ function Uploader(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.initialAttr = {
            accept: null,
            multiple: false,
            disabled: false
        };
        _this.uploadedFilesData = [];
        _this.base64String = [];
        _this.isForm = false;
        _this.allTypes = false;
        _this.pausedData = [];
        _this.uploadMetaData = [];
        _this.tabIndex = "0";
        _this.btnTabIndex = "0";
        _this.disableKeyboardNavigation = false;
        _this.count = -1;
        _this.actionCompleteCount = 0;
        _this.flag = true;
        _this.selectedFiles = [];
        _this.uploaderName = "UploadFiles";
        _this.fileStreams = [];
        _this.newFileRef = 0;
        _this.isFirstFileOnSelection = false;
        _this.dragCounter = 0;
        /**
         * Get the file item(li) which are shown in file list.
         *
         * @private
         */ _this.fileList = [];
        /**
         * Get the data of files which are shown in file list.
         *
         * @private
         */ _this.filesData = [];
        _this.uploaderOptions = options;
        return _this;
    }
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {UploaderModel} newProp - Returns the dynamic property value of the component.
     * @param {UploaderModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */ Uploader.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "allowedExtensions":
                    this.setExtensions(this.allowedExtensions);
                    this.clearAll();
                    break;
                case "enabled":
                    this.setControlStatus();
                    break;
                case "multiple":
                    this.setMultipleSelection();
                    break;
                case "enableRtl":
                    this.setRTL();
                    this.reRenderFileList();
                    break;
                case "buttons":
                    this.buttons.browse = (0, $3EnZW.isNullOrUndefined)(this.buttons.browse) ? "" : this.buttons.browse;
                    this.buttons.clear = (0, $3EnZW.isNullOrUndefined)(this.buttons.clear) ? "" : this.buttons.clear;
                    this.buttons.upload = (0, $3EnZW.isNullOrUndefined)(this.buttons.upload) ? "" : this.buttons.upload;
                    this.renderButtonTemplates();
                    break;
                case "dropArea":
                    this.unBindDropEvents();
                    this.updateDropArea();
                    break;
                case "htmlAttributes":
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.checkHTMLAttributes(true);
                    break;
                case "files":
                    this.renderPreLoadFiles();
                    break;
                case "directoryUpload":
                    this.updateDirectoryAttributes();
                    break;
                case "template":
                    if (this.isReact) this.reRenderFileList();
                    else this.clearAll();
                    break;
                case "minFileSize":
                case "maxFileSize":
                case "autoUpload":
                    this.clearAll();
                    break;
                case "sequentialUpload":
                    this.clearAll();
                    break;
                case "locale":
                    this.l10n.setLocale(this.locale);
                    this.setLocalizedTexts();
                    this.preLocaleObj = (0, $3EnZW.getValue)("currentLocale", this.l10n);
                    break;
                case "cssClass":
                    this.setCSSClass(oldProp.cssClass);
                    break;
            }
        }
    };
    Uploader.prototype.setLocalizedTexts = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.template)) {
            if (typeof this.buttons.browse === "string") {
                this.browseButton.innerText = this.buttons.browse === "Browse..." ? this.localizedTexts("Browse") : this.buttons.browse;
                this.browseButton.setAttribute("title", this.browseButton.innerText);
                if (this.uploadWrapper && !(0, $3EnZW.isNullOrUndefined)(this.uploadWrapper.querySelector("." + $f606c23990200287$var$DROP_AREA))) this.uploadWrapper.querySelector("." + $f606c23990200287$var$DROP_AREA).innerHTML = this.localizedTexts("dropFilesHint");
            }
            this.updateFileList();
        }
    };
    Uploader.prototype.getKeyValue = function(val) {
        var keyValue;
        for(var _i = 0, _a = Object.keys(this.preLocaleObj); _i < _a.length; _i++){
            var key = _a[_i];
            if (this.preLocaleObj["" + key] === val) keyValue = key;
        }
        return keyValue;
    };
    Uploader.prototype.updateFileList = function() {
        var element;
        /* istanbul ignore next */ if (this.fileList.length > 0 && !(0, $3EnZW.isNullOrUndefined)(this.uploadWrapper.querySelector("." + $f606c23990200287$var$LIST_PARENT))) for(var i = 0; i < this.fileList.length; i++){
            element = this.fileList[i].querySelector(".e-file-status");
            element.innerHTML = this.localizedTexts(this.getKeyValue(this.filesData[i].status));
            this.filesData[i].status = this.localizedTexts(this.getKeyValue(this.filesData[i].status));
            if (this.fileList[i].classList.contains($f606c23990200287$var$UPLOAD_SUCCESS)) this.fileList[i].querySelector(".e-icons").setAttribute("title", this.localizedTexts("delete"));
            if (this.fileList[i].querySelector(".e-file-play-btn")) this.fileList[i].querySelector(".e-icons").setAttribute("title", this.localizedTexts("resume"));
            if (this.fileList[i].querySelector(".e-file-remove-btn")) this.fileList[i].querySelector(".e-icons").setAttribute("title", this.localizedTexts("remove"));
            if (this.fileList[i].querySelector(".e-file-reload-btn")) this.fileList[i].querySelector(".e-icons").setAttribute("title", this.localizedTexts("retry"));
            if (!this.autoUpload) {
                this.uploadButton.innerText = this.buttons.upload === "Upload" ? this.localizedTexts("Upload") : this.buttons.upload;
                this.uploadButton.setAttribute("title", this.localizedTexts("Upload"));
                this.clearButton.innerText = this.buttons.clear === "Clear" ? this.localizedTexts("Clear") : this.buttons.clear;
                this.clearButton.setAttribute("title", this.localizedTexts("Clear"));
            }
        }
    };
    Uploader.prototype.reRenderFileList = function() {
        if (this.listParent) {
            (0, $4ZDHT.detach)(this.listParent);
            this.listParent = null;
            this.fileList = [];
            this.internalCreateFileList(this.filesData);
            if (this.actionButtons) {
                this.removeActionButtons();
                this.renderActionButtons();
                this.checkActionButtonStatus();
            }
        }
    };
    Uploader.prototype.preRender = function() {
        this.localeText = {
            Browse: "Browse...",
            Clear: "Clear",
            Upload: "Upload",
            invalidFileName: "File Name is not allowed",
            dropFilesHint: "Or drop files here",
            invalidMaxFileSize: "File size is too large",
            invalidMinFileSize: "File size is too small",
            invalidFileType: "File type is not allowed",
            uploadFailedMessage: "File failed to upload",
            uploadSuccessMessage: "File uploaded successfully",
            removedSuccessMessage: "File removed successfully",
            removedFailedMessage: "Unable to remove file",
            inProgress: "Uploading",
            readyToUploadMessage: "Ready to upload",
            abort: "Abort",
            remove: "Remove",
            cancel: "Cancel",
            delete: "Delete file",
            pauseUpload: "File upload paused",
            pause: "Pause",
            resume: "Resume",
            retry: "Retry",
            fileUploadCancel: "File upload canceled",
            invalidFileSelection: "Invalid files selected",
            totalFiles: "Total files",
            size: "Size"
        };
        this.l10n = new (0, $e7i2H.L10n)("uploader", this.localeText, this.locale);
        this.preLocaleObj = (0, $3EnZW.getValue)("currentLocale", this.l10n);
        this.formRendered();
        this.updateHTMLAttrToElement();
        this.checkHTMLAttributes(false);
        var ejInstance = (0, $3EnZW.getValue)("ej2_instances", this.element);
        /* istanbul ignore next */ if (this.element.tagName === "EJS-UPLOADER") {
            var inputElement = this.createElement("input", {
                attrs: {
                    type: "file"
                }
            });
            var index = 0;
            for(index; index < this.element.attributes.length; index++){
                if (this.element.attributes[index].nodeName !== "id") inputElement.setAttribute(this.element.attributes[index].nodeName, this.element.attributes[index].nodeValue);
                else if (this.element.attributes[index].nodeName === "id") inputElement.setAttribute(this.element.attributes[index].nodeName, (0, $3EnZW.getUniqueID)("uploader"));
                inputElement.innerHTML = this.element.innerHTML;
            }
            if (!inputElement.hasAttribute("name")) inputElement.setAttribute("name", "UploadFiles");
            this.element.appendChild(inputElement);
            this.element = inputElement;
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, this.element);
        }
        /* istanbul ignore next */ if (ejInstance[0].isPureReactComponent) {
            if (!(0, $3EnZW.isNullOrUndefined)(ejInstance[0].props.name)) this.element.setAttribute("name", ejInstance[0].props.name);
            else if (!(0, $3EnZW.isNullOrUndefined)(ejInstance[0].props.id) && (0, $3EnZW.isNullOrUndefined)(ejInstance[0].props.name)) this.element.setAttribute("name", ejInstance[0].props.id);
            else this.element.setAttribute("name", "UploadFiles");
        }
        if ((0, $3EnZW.isNullOrUndefined)(this.element.getAttribute("name"))) this.element.setAttribute("name", this.element.getAttribute("id"));
        if (!this.element.hasAttribute("type")) this.element.setAttribute("type", "file");
        this.updateDirectoryAttributes();
        this.keyConfigs = {
            enter: "enter"
        };
        if (this.element.hasAttribute("tabindex")) this.tabIndex = this.element.getAttribute("tabindex");
        this.browserName = (0, $5q7BP.Browser).info.name;
        this.uploaderName = this.element.getAttribute("name");
    };
    Uploader.prototype.formRendered = function() {
        var parentEle = (0, $4ZDHT.closest)(this.element, "form");
        if (!(0, $3EnZW.isNullOrUndefined)(parentEle)) {
            for(; parentEle && parentEle !== document.documentElement; parentEle = parentEle.parentElement)if (parentEle.tagName === "FORM") {
                this.isForm = true;
                this.formElement = parentEle;
                parentEle.setAttribute("enctype", "multipart/form-data");
                parentEle.setAttribute("encoding", "multipart/form-data");
            }
        }
    };
    Uploader.prototype.getPersistData = function() {
        return this.addOnPersist([
            "filesData"
        ]);
    };
    /**
     * Return the module name of the component.
     *
     * @returns {string} Returns the component name.
     */ Uploader.prototype.getModuleName = function() {
        return "uploader";
    };
    Uploader.prototype.updateDirectoryAttributes = function() {
        if (this.directoryUpload) {
            this.element.setAttribute("directory", "true");
            this.element.setAttribute("webkitdirectory", "true");
        } else {
            this.element.removeAttribute("directory");
            this.element.removeAttribute("webkitdirectory");
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ Uploader.prototype.render = function() {
        this.renderBrowseButton();
        this.initializeUpload();
        this.updateHTMLAttrToWrapper();
        this.wireEvents();
        this.setMultipleSelection();
        this.setExtensions(this.allowedExtensions);
        this.setRTL();
        this.renderPreLoadFiles();
        this.setControlStatus();
        this.setCSSClass();
    };
    Uploader.prototype.renderBrowseButton = function() {
        this.browseButton = this.createElement("button", {
            className: "e-css e-btn",
            attrs: {
                "type": "button"
            }
        });
        this.browseButton.setAttribute("tabindex", this.tabIndex);
        if (typeof this.buttons.browse === "string") {
            this.browseButton.textContent = this.buttons.browse === "Browse..." ? this.localizedTexts("Browse") : this.buttons.browse;
            this.browseButton.setAttribute("title", this.browseButton.innerText);
        } else this.browseButton.appendChild(this.buttons.browse);
        this.element.setAttribute("aria-label", "Uploader");
    };
    Uploader.prototype.renderActionButtons = function() {
        this.element.setAttribute("tabindex", "-1");
        this.actionButtons = this.createElement("div", {
            className: $f606c23990200287$var$ACTION_BUTTONS
        });
        this.uploadButton = this.createElement("button", {
            className: $f606c23990200287$var$UPLOAD_BUTTONS,
            attrs: {
                "type": "button",
                "tabindex": this.btnTabIndex,
                "aria-label": this.localizedTexts("Upload")
            }
        });
        this.clearButton = this.createElement("button", {
            className: $f606c23990200287$var$CLEAR_BUTTONS,
            attrs: {
                "type": "button",
                "tabindex": this.btnTabIndex,
                "aria-label": this.localizedTexts("Clear")
            }
        });
        this.actionButtons.appendChild(this.clearButton);
        this.actionButtons.appendChild(this.uploadButton);
        this.renderButtonTemplates();
        this.uploadWrapper.appendChild(this.actionButtons);
        this.browseButton.blur();
        if (!this.isPreloadFiles) this.uploadButton.focus();
        this.wireActionButtonEvents();
    };
    /* istanbul ignore next */ Uploader.prototype.serverActionButtonsEventBind = function(element) {
        if (element && !this.isForm) {
            this.browseButton.blur();
            this.actionButtons = element;
            this.uploadButton = this.actionButtons.querySelector(".e-file-upload-btn");
            this.clearButton = this.actionButtons.querySelector(".e-file-clear-btn");
            this.uploadButton.focus();
            this.unwireActionButtonEvents();
            this.wireActionButtonEvents();
            this.checkActionButtonStatus();
        }
    };
    Uploader.prototype.wireActionButtonEvents = function() {
        (0, $aqzbR.EventHandler).add(this.uploadButton, "click", this.uploadButtonClick, this);
        (0, $aqzbR.EventHandler).add(this.clearButton, "click", this.clearButtonClick, this);
    };
    Uploader.prototype.unwireActionButtonEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.uploadButton, "click", this.uploadButtonClick);
        (0, $aqzbR.EventHandler).remove(this.clearButton, "click", this.clearButtonClick);
    };
    Uploader.prototype.removeActionButtons = function() {
        if (this.actionButtons) {
            this.unwireActionButtonEvents();
            (0, $4ZDHT.detach)(this.actionButtons);
            this.actionButtons = null;
        }
    };
    Uploader.prototype.renderButtonTemplates = function() {
        if (typeof this.buttons.browse === "string") {
            this.browseButton.textContent = this.buttons.browse === "Browse..." ? this.localizedTexts("Browse") : this.buttons.browse;
            this.browseButton.setAttribute("title", this.browseButton.textContent);
        } else {
            this.browseButton.innerHTML = "";
            this.browseButton.appendChild(this.buttons.browse);
        }
        if (this.uploadButton) {
            var uploadText = (0, $3EnZW.isNullOrUndefined)(this.buttons.upload) ? "Upload" : this.buttons.upload;
            this.buttons.upload = uploadText;
            if (typeof this.buttons.upload === "string") {
                this.uploadButton.textContent = this.buttons.upload === "Upload" ? this.localizedTexts("Upload") : this.buttons.upload;
                this.uploadButton.setAttribute("title", this.uploadButton.textContent);
            } else {
                this.uploadButton.innerHTML = "";
                this.uploadButton.appendChild(this.buttons.upload);
            }
        }
        if (this.clearButton) {
            var clearText = (0, $3EnZW.isNullOrUndefined)(this.buttons.clear) ? "Clear" : this.buttons.clear;
            this.buttons.clear = clearText;
            if (typeof this.buttons.clear === "string") {
                this.clearButton.textContent = this.buttons.clear === "Clear" ? this.localizedTexts("Clear") : this.buttons.clear;
                this.clearButton.setAttribute("title", this.clearButton.textContent);
            } else {
                this.clearButton.innerHTML = "";
                this.clearButton.appendChild(this.buttons.clear);
            }
        }
    };
    Uploader.prototype.initializeUpload = function() {
        this.element.setAttribute("tabindex", "-1");
        var inputWrapper = this.createElement("span", {
            className: $f606c23990200287$var$INPUT_WRAPPER
        });
        this.element.parentElement.insertBefore(inputWrapper, this.element);
        this.dropAreaWrapper = this.createElement("div", {
            className: $f606c23990200287$var$DROP_WRAPPER
        });
        this.element.parentElement.insertBefore(this.dropAreaWrapper, this.element);
        inputWrapper.appendChild(this.element);
        this.dropAreaWrapper.appendChild(this.browseButton);
        this.dropAreaWrapper.appendChild(inputWrapper);
        this.uploadWrapper = this.createElement("div", {
            className: $f606c23990200287$var$CONTROL_WRAPPER
        });
        this.dropAreaWrapper.parentElement.insertBefore(this.uploadWrapper, this.dropAreaWrapper);
        this.uploadWrapper.appendChild(this.dropAreaWrapper);
        this.setDropArea();
    };
    Uploader.prototype.renderPreLoadFiles = function() {
        if (this.files.length) {
            if (this.enablePersistence && this.filesData.length) {
                this.internalCreateFileList(this.filesData);
                return;
            }
            if ((0, $3EnZW.isNullOrUndefined)(this.files[0].size)) return;
            this.isPreloadFiles = true;
            var files = [].slice.call(this.files);
            var filesData = [];
            if (!this.multiple) {
                this.clearData();
                files = [
                    files[0]
                ];
            }
            for(var _i = 0, files_1 = files; _i < files_1.length; _i++){
                var data = files_1[_i];
                var fileData = {
                    name: data.name + "." + data.type.split(".")[data.type.split(".").length - 1],
                    rawFile: "",
                    size: data.size,
                    status: this.localizedTexts("uploadSuccessMessage"),
                    type: data.type,
                    validationMessages: {
                        minSize: "",
                        maxSize: ""
                    },
                    statusCode: "2"
                };
                filesData.push(fileData);
                this.filesData.push(fileData);
            }
            this.internalCreateFileList(filesData);
            if (!this.autoUpload && this.listParent && !this.actionButtons && (!this.isForm || this.allowUpload()) && this.showFileList) this.renderActionButtons();
            this.checkActionButtonStatus();
            if (this.sequentialUpload) this.count = this.filesData.length - 1;
            this.isPreloadFiles = false;
        }
    };
    Uploader.prototype.checkActionButtonStatus = function() {
        if (this.actionButtons) {
            var length_1 = this.uploadWrapper.querySelectorAll("." + $f606c23990200287$var$VALIDATION_FAILS).length + this.uploadWrapper.querySelectorAll(".e-upload-fails:not(.e-upload-progress)").length + this.uploadWrapper.querySelectorAll("span." + $f606c23990200287$var$UPLOAD_SUCCESS).length + this.uploadWrapper.querySelectorAll("span." + $f606c23990200287$var$UPLOAD_INPROGRESS).length;
            if (length_1 > 0 && length_1 === this.uploadWrapper.querySelectorAll("li").length) this.uploadButton.setAttribute("disabled", "disabled");
            else this.uploadButton.removeAttribute("disabled");
        }
    };
    Uploader.prototype.setDropArea = function() {
        var dropTextArea = this.dropAreaWrapper.querySelector(".e-file-drop");
        if (this.dropArea) {
            this.dropZoneElement = typeof this.dropArea !== "string" ? this.dropArea : (0, $4ZDHT.select)(this.dropArea, document);
            var element = this.element;
            var enableDropText = false;
            while(element.parentNode){
                element = element.parentNode;
                if (element === this.dropZoneElement) {
                    enableDropText = true;
                    if (!dropTextArea) this.createDropTextHint();
                    else dropTextArea.innerHTML = this.localizedTexts("dropFilesHint");
                }
            }
            if (!enableDropText && dropTextArea) (0, $4ZDHT.remove)(dropTextArea);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.uploaderOptions) && this.uploaderOptions.dropArea === undefined) {
            this.createDropTextHint();
            this.dropZoneElement = this.uploadWrapper;
            this.setProperties({
                dropArea: this.uploadWrapper
            }, true);
        }
        this.bindDropEvents();
    };
    Uploader.prototype.updateDropArea = function() {
        if (this.dropArea) this.setDropArea();
        else {
            this.dropZoneElement = null;
            var dropTextArea = this.dropAreaWrapper.querySelector(".e-file-drop");
            if (dropTextArea) (0, $4ZDHT.remove)(dropTextArea);
        }
    };
    Uploader.prototype.createDropTextHint = function() {
        var fileDropArea = this.createElement("span", {
            className: $f606c23990200287$var$DROP_AREA
        });
        fileDropArea.innerHTML = this.localizedTexts("dropFilesHint");
        this.dropAreaWrapper.appendChild(fileDropArea);
    };
    Uploader.prototype.updateHTMLAttrToElement = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var pro = _a[_i];
            if ($f606c23990200287$var$wrapperAttr.indexOf(pro) < 0) this.element.setAttribute(pro, this.htmlAttributes["" + pro]);
        }
    };
    Uploader.prototype.updateHTMLAttrToWrapper = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var pro = _a[_i];
            if ($f606c23990200287$var$wrapperAttr.indexOf(pro) > -1) {
                if (pro === "class") {
                    var updatedClassValues = this.htmlAttributes["" + pro].replace(/\s+/g, " ").trim();
                    if (updatedClassValues !== "") (0, $4ZDHT.addClass)([
                        this.uploadWrapper
                    ], updatedClassValues.split(" "));
                } else if (pro === "style") {
                    var uploadStyle = this.uploadWrapper.getAttribute(pro);
                    uploadStyle = !(0, $3EnZW.isNullOrUndefined)(uploadStyle) ? uploadStyle + this.htmlAttributes["" + pro] : this.htmlAttributes["" + pro];
                    this.uploadWrapper.setAttribute(pro, uploadStyle);
                } else this.uploadWrapper.setAttribute(pro, this.htmlAttributes["" + pro]);
            }
        }
    };
    Uploader.prototype.setMultipleSelection = function() {
        if (this.multiple && !this.element.hasAttribute("multiple")) {
            var newAttr = document.createAttribute("multiple");
            newAttr.value = "multiple";
            this.element.setAttributeNode(newAttr);
        } else if (!this.multiple) this.element.removeAttribute("multiple");
    };
    Uploader.prototype.checkAutoUpload = function(fileData) {
        if (this.autoUpload) {
            if (this.sequentialUpload) /* istanbul ignore next */ this.sequenceUpload(fileData);
            else this.upload(fileData);
            this.removeActionButtons();
        } else if (!this.actionButtons) this.renderActionButtons();
        this.checkActionButtonStatus();
    };
    Uploader.prototype.sequenceUpload = function(fileData) {
        if (this.filesData.length - fileData.length === 0 || this.filesData[this.filesData.length - fileData.length - 1].statusCode !== "1") {
            if (this.multiple || this.count < 0) ++this.count;
            var isFileListCreated = this.showFileList ? false : true;
            if (typeof this.filesData[this.count] === "object") {
                this.isFirstFileOnSelection = false;
                this.upload(this.filesData[this.count], isFileListCreated);
                if (this.filesData[this.count].statusCode === "0") this.sequenceUpload(fileData);
            } else --this.count;
        }
    };
    Uploader.prototype.setCSSClass = function(oldCSSClass) {
        var updatedOldCssClass = oldCSSClass;
        if (!(0, $3EnZW.isNullOrUndefined)(oldCSSClass)) updatedOldCssClass = oldCSSClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(oldCSSClass) && updatedOldCssClass !== "") (0, $4ZDHT.removeClass)([
            this.uploadWrapper
        ], updatedOldCssClass.split(" "));
        var updatedCssClassValue = this.cssClass;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && this.cssClass !== "") updatedCssClassValue = this.cssClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass) && updatedCssClassValue !== "") (0, $4ZDHT.addClass)([
            this.uploadWrapper
        ], updatedCssClassValue.split(updatedCssClassValue.indexOf(",") > -1 ? "," : " "));
    };
    Uploader.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.browseButton, "click", this.browseButtonClick, this);
        (0, $aqzbR.EventHandler).add(this.element, "change", this.onSelectFiles, this);
        (0, $aqzbR.EventHandler).add(document, "click", this.removeFocus, this);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.uploadWrapper, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
        if (this.isForm) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.resetForm, this);
    };
    Uploader.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.browseButton, "click", this.browseButtonClick);
        (0, $aqzbR.EventHandler).remove(this.element, "change", this.onSelectFiles);
        (0, $aqzbR.EventHandler).remove(document, "click", this.removeFocus);
        if (this.isForm) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.resetForm);
        if (this.keyboardModule) this.keyboardModule.destroy();
    };
    Uploader.prototype.resetForm = function() {
        this.clearAll();
    };
    Uploader.prototype.keyActionHandler = function(e) {
        var targetElement = e.target;
        switch(e.action){
            case "enter":
                if (e.target === this.clearButton) this.clearButtonClick();
                else if (e.target === this.uploadButton) this.uploadButtonClick();
                else if (e.target === this.browseButton) this.browseButtonClick();
                else if (targetElement.classList.contains($f606c23990200287$var$PAUSE_UPLOAD)) {
                    var metaData = this.getCurrentMetaData(null, e);
                    metaData.file.statusCode = "4";
                    metaData.file.status = this.localizedTexts("pauseUpload");
                    this.abortUpload(metaData, false);
                } else if (targetElement.classList.contains($f606c23990200287$var$RESUME_UPLOAD)) this.resumeUpload(this.getCurrentMetaData(null, e), e);
                else if (targetElement.classList.contains($f606c23990200287$var$RETRY_ICON)) {
                    var metaData = this.getCurrentMetaData(null, e);
                    if (!(0, $3EnZW.isNullOrUndefined)(metaData)) {
                        metaData.file.statusCode = "1";
                        metaData.file.status = this.localizedTexts("readyToUploadMessage");
                        this.chunkUpload(metaData.file);
                    } else {
                        var target = e.target.parentElement;
                        var fileData = this.filesData[this.fileList.indexOf(target)];
                        this.retry(fileData);
                    }
                } else {
                    this.removeFiles(e);
                    if (!targetElement.classList.contains($f606c23990200287$var$ABORT_ICON)) this.browseButton.focus();
                }
                e.preventDefault();
                e.stopPropagation();
                break;
        }
    };
    Uploader.prototype.getCurrentMetaData = function(fileInfo, e) {
        var fileData;
        var targetMetaData;
        if ((0, $3EnZW.isNullOrUndefined)(fileInfo)) {
            var target = e.target.parentElement;
            fileData = this.filesData[this.fileList.indexOf(target)];
        } else fileData = fileInfo;
        for(var i = 0; i < this.uploadMetaData.length; i++)if (this.uploadMetaData[i].file.name === fileData.name) targetMetaData = this.uploadMetaData[i];
        return targetMetaData;
    };
    Uploader.prototype.removeFocus = function() {
        if (this.uploadWrapper && this.listParent && this.listParent.querySelector("." + $f606c23990200287$var$ICON_FOCUSED)) {
            document.activeElement.blur();
            this.listParent.querySelector("." + $f606c23990200287$var$ICON_FOCUSED).classList.remove($f606c23990200287$var$ICON_FOCUSED);
        }
    };
    Uploader.prototype.browseButtonClick = function() {
        this.element.click();
    };
    Uploader.prototype.uploadButtonClick = function() {
        if (this.sequentialUpload) this.sequenceUpload(this.filesData);
        else this.upload(this.filesData);
    };
    Uploader.prototype.clearButtonClick = function() {
        this.clearAll();
        /* istanbul ignore next */ if (this.sequentialUpload) this.count = -1;
        this.actionCompleteCount = 0;
    };
    Uploader.prototype.bindDropEvents = function() {
        if (this.dropZoneElement) {
            (0, $aqzbR.EventHandler).add(this.dropZoneElement, "drop", this.dropElement, this);
            (0, $aqzbR.EventHandler).add(this.dropZoneElement, "dragover", this.dragHover, this);
            (0, $aqzbR.EventHandler).add(this.dropZoneElement, "dragleave", this.onDragLeave, this);
            (0, $aqzbR.EventHandler).add(this.dropZoneElement, "paste", this.onPasteFile, this);
            (0, $aqzbR.EventHandler).add(this.dropZoneElement, "dragenter", this.onDragEnter, this);
        }
    };
    Uploader.prototype.unBindDropEvents = function() {
        if (this.dropZoneElement) {
            (0, $aqzbR.EventHandler).remove(this.dropZoneElement, "drop", this.dropElement);
            (0, $aqzbR.EventHandler).remove(this.dropZoneElement, "dragover", this.dragHover);
            (0, $aqzbR.EventHandler).remove(this.dropZoneElement, "dragleave", this.onDragLeave);
            (0, $aqzbR.EventHandler).remove(this.dropZoneElement, "dragenter", this.onDragEnter);
        }
    };
    Uploader.prototype.onDragEnter = function(e) {
        if (!this.enabled) return;
        this.dropZoneElement.classList.add($f606c23990200287$var$DRAG_HOVER);
        this.dragCounter = this.dragCounter + 1;
        e.preventDefault();
        e.stopPropagation();
    };
    Uploader.prototype.onDragLeave = function() {
        if (!this.enabled) return;
        this.dragCounter = this.dragCounter - 1;
        if (!this.dragCounter) this.dropZoneElement.classList.remove($f606c23990200287$var$DRAG_HOVER);
    };
    Uploader.prototype.dragHover = function(e) {
        if (!this.enabled) return;
        if (this.dropEffect !== "Default") e.dataTransfer.dropEffect = this.dropEffect.toLowerCase();
        e.preventDefault();
        e.stopPropagation();
    };
    /* istanbul ignore next */ Uploader.prototype.dropElement = function(e) {
        this.dragCounter = 0;
        this.dropZoneElement.classList.remove($f606c23990200287$var$DRAG_HOVER);
        this.onSelectFiles(e);
        e.preventDefault();
        e.stopPropagation();
    };
    /* istanbul ignore next */ Uploader.prototype.onPasteFile = function(event) {
        var item = event.clipboardData.items;
        if (event.type === "paste" && this.browserName !== "msie" && this.browserName !== "edge" && this.browserName !== "safari") this.element.files = event.clipboardData.files;
        if (item.length !== 1 && !this.multiple) return;
        for(var file = 0; file < item.length; file++){
            var pasteFile = [].slice.call(item)[file];
            if (pasteFile.kind === "file" || pasteFile.type.match("^image/")) this.renderSelectedFiles(event, [
                pasteFile.getAsFile()
            ], false, true);
        }
    };
    Uploader.prototype.getSelectedFiles = function(index) {
        var data = [];
        var liElement = this.fileList[index];
        var allFiles = this.getFilesData();
        var nameElements = +liElement.getAttribute("data-files-count");
        var startIndex = 0;
        for(var i = 0; i < index; i++)startIndex += +this.fileList[i].getAttribute("data-files-count");
        for(var j = startIndex; j < startIndex + nameElements; j++)data.push(allFiles[j]);
        return data;
    };
    Uploader.prototype.removeFiles = function(args) {
        if (!this.enabled) return;
        var selectedElement = args.target.parentElement;
        var index = this.fileList.indexOf(selectedElement);
        var liElement = this.fileList[index];
        var formUpload = this.isFormUpload();
        var fileData = formUpload ? this.getSelectedFiles(index) : this.getFilesInArray(this.filesData[index]);
        if ((0, $3EnZW.isNullOrUndefined)(fileData)) return;
        if (args.target.classList.contains($f606c23990200287$var$ABORT_ICON) && !formUpload) {
            fileData[0].statusCode = "5";
            if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
                var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
                (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                    target: spinnerTarget,
                    width: "20px"
                });
                (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(spinnerTarget);
            }
            if (this.sequentialUpload) /* istanbul ignore next */ this.uploadSequential();
            if (!liElement.classList.contains($f606c23990200287$var$RESTRICT_RETRY)) this.checkActionComplete(true);
        } else if (!(0, $4ZDHT.closest)(args.target, "." + $f606c23990200287$var$SPINNER_PANE)) this.remove(fileData, false, false, true, args);
        if (this.isForm && liElement && liElement.classList.contains($f606c23990200287$var$INVALID_FILE)) this.element.value = "";
        this.checkActionButtonStatus();
    };
    Uploader.prototype.removeFilesData = function(file, customTemplate) {
        var index;
        if (customTemplate) {
            if (!this.showFileList) {
                index = this.filesData.indexOf(file);
                this.filesData.splice(index, 1);
            }
            return;
        }
        var selectedElement = this.getLiElement(file);
        if ((0, $3EnZW.isNullOrUndefined)(selectedElement)) return;
        this.element.value = "";
        (0, $4ZDHT.detach)(selectedElement);
        index = this.fileList.indexOf(selectedElement);
        this.fileList.splice(index, 1);
        this.filesData.splice(index, 1);
        if (this.fileList.length === 0 && !(0, $3EnZW.isNullOrUndefined)(this.listParent)) {
            (0, $4ZDHT.detach)(this.listParent);
            this.listParent = null;
            this.removeActionButtons();
        }
        if (this.sequentialUpload) /* istanbul ignore next */ {
            if (index <= this.count) --this.count;
        }
    };
    Uploader.prototype.removeUploadedFile = function(file, eventArgs, removeDirectly, custom) {
        var _this = this;
        var selectedFiles = file;
        var ajax = new (0, $cfGuF.Ajax)(this.asyncSettings.removeUrl, "POST", true, null);
        ajax.emitError = false;
        var formData = new FormData();
        ajax.beforeSend = function(e) {
            eventArgs.currentRequest = ajax.httpRequest;
            if (!removeDirectly) _this.trigger("removing", eventArgs, function(eventArgs) {
                if (eventArgs.cancel) e.cancel = true;
                else _this.removingEventCallback(eventArgs, formData, selectedFiles, file);
            });
            else _this.removingEventCallback(eventArgs, formData, selectedFiles, file);
        };
        ajax.onLoad = function(e) {
            _this.removeCompleted(e, selectedFiles, custom);
            return {};
        };
        /* istanbul ignore next */ ajax.onError = function(e) {
            _this.removeFailed(e, selectedFiles, custom);
            return {};
        };
        ajax.send(formData);
    };
    Uploader.prototype.removingEventCallback = function(eventArgs, formData, selectedFiles, file) {
        /* istanbul ignore next */ var name = this.element.getAttribute("name");
        var liElement = this.getLiElement(file);
        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON)) || !(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON)))) {
            var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON) ? liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON) : liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON);
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: spinnerTarget,
                width: "20px"
            });
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(spinnerTarget);
        }
        if (eventArgs.postRawFile && !(0, $3EnZW.isNullOrUndefined)(selectedFiles.rawFile) && selectedFiles.rawFile !== "") formData.append(name, selectedFiles.rawFile, selectedFiles.name);
        else formData.append(name, selectedFiles.name);
        this.updateFormData(formData, eventArgs.customFormData);
    };
    /* istanbul ignore next */ Uploader.prototype.updateFormData = function(formData, customData) {
        if (customData.length > 0 && customData[0]) {
            var _loop_1 = function(i) {
                var data = customData[i];
                // eslint-disable-next-line @typescript-eslint/tslint/config
                var value = Object.keys(data).map(function(e) {
                    return data["" + e];
                });
                formData.append(Object.keys(data)[0], value);
            };
            for(var i = 0; i < customData.length; i++)_loop_1(i);
        }
    };
    /* istanbul ignore next */ Uploader.prototype.updateCustomheader = function(request, currentRequest) {
        if (currentRequest.length > 0 && currentRequest[0]) {
            var _loop_2 = function(i) {
                var data = currentRequest[i];
                // eslint-disable-next-line @typescript-eslint/tslint/config
                var value = Object.keys(data).map(function(e) {
                    return data["" + e];
                });
                request.setRequestHeader(Object.keys(data)[0], value);
            };
            for(var i = 0; i < currentRequest.length; i++)_loop_2(i);
        }
    };
    Uploader.prototype.removeCompleted = function(e, files, customTemplate) {
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var status = e.target;
        if (status.readyState === 4 && status.status >= 200 && status.status <= 299) {
            var args = {
                e: e,
                response: response,
                operation: "remove",
                file: this.updateStatus(files, this.localizedTexts("removedSuccessMessage"), "2")
            };
            this.trigger("success", args);
            this.removeFilesData(files, customTemplate);
            var index = this.uploadedFilesData.indexOf(files);
            this.uploadedFilesData.splice(index, 1);
            this.trigger("change", {
                files: this.uploadedFilesData
            });
        } else this.removeFailed(e, files, customTemplate);
    };
    Uploader.prototype.removeFailed = function(e, files, customTemplate) {
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var args = {
            e: e,
            response: response,
            operation: "remove",
            file: this.updateStatus(files, this.localizedTexts("removedFailedMessage"), "0")
        };
        if (!customTemplate) {
            var index = this.filesData.indexOf(files);
            var rootElement = this.fileList[index];
            if (rootElement) {
                rootElement.classList.remove($f606c23990200287$var$UPLOAD_SUCCESS);
                rootElement.classList.add($f606c23990200287$var$UPLOAD_FAILED);
                var statusElement = rootElement.querySelector("." + $f606c23990200287$var$STATUS);
                if (statusElement) {
                    statusElement.classList.remove($f606c23990200287$var$UPLOAD_SUCCESS);
                    statusElement.classList.add($f606c23990200287$var$UPLOAD_FAILED);
                }
            }
            this.checkActionButtonStatus();
        }
        this.trigger("failure", args);
        var liElement = this.getLiElement(files);
        /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(liElement) && !(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON))) {
            var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON);
            (0, $d4834c37f505aa74$export$95fec50f68454318)(spinnerTarget);
            (0, $4ZDHT.detach)(liElement.querySelector(".e-spinner-pane"));
        }
    };
    /* istanbul ignore next */ Uploader.prototype.getFilesFromFolder = function(event) {
        this.filesEntries = [];
        var items = this.multiple ? event.dataTransfer.items : [
            event.dataTransfer.items[0]
        ];
        var validDirectoryUpload = this.checkDirectoryUpload(items);
        if (!validDirectoryUpload) return;
        var _loop_3 = function(i) {
            var item = items[i].webkitGetAsEntry();
            if (item.isFile) {
                var files_2 = [];
                item.file(function(fileObj) {
                    var path = item.fullPath;
                    files_2.push({
                        "path": path,
                        "file": fileObj
                    });
                });
                this_1.renderSelectedFiles(event, files_2, true);
            } else if (item.isDirectory) this_1.traverseFileTree(item, event);
        };
        var this_1 = this;
        for(var i = 0; i < items.length; i++)_loop_3(i);
    };
    /* istanbul ignore next */ Uploader.prototype.checkDirectoryUpload = function(items) {
        for(var i = 0; items && i < items.length; i++){
            var item = items[i].webkitGetAsEntry();
            if (item.isDirectory) return true;
        }
        return false;
    };
    /* istanbul ignore next */ Uploader.prototype.traverseFileTree = function(item, event) {
        if (item.isFile) this.filesEntries.push(item);
        else if (item.isDirectory) {
            var directoryReader = item.createReader();
            this.readFileFromDirectory(directoryReader, event);
        }
    };
    /* istanbul ignore next */ Uploader.prototype.readFileFromDirectory = function(directoryReader, event) {
        var _this = this;
        directoryReader.readEntries(function(entries) {
            for(var i = 0; i < entries.length; i++)_this.traverseFileTree(entries[i], event);
            _this.pushFilesEntries(event);
            if (entries.length) _this.readFileFromDirectory(directoryReader);
        });
    };
    Uploader.prototype.pushFilesEntries = function(event) {
        var _this = this;
        var files = [];
        var _loop_4 = function(i) {
            this_2.filesEntries[i].file(function(fileObj) {
                if (_this.filesEntries.length) {
                    var path = _this.filesEntries[i].fullPath;
                    files.push({
                        "path": path,
                        "file": fileObj
                    });
                    if (i === _this.filesEntries.length - 1) {
                        _this.filesEntries = [];
                        _this.renderSelectedFiles(event, files, true);
                    }
                }
            });
        };
        var this_2 = this;
        for(var i = 0; i < this.filesEntries.length; i++)_loop_4(i);
    };
    Uploader.prototype.onSelectFiles = function(args) {
        if (!this.enabled) return;
        var targetFiles;
        /* istanbul ignore next */ if (args.type === "drop") {
            if (this.directoryUpload) this.getFilesFromFolder(args);
            else {
                var files = this.sortFilesList = args.dataTransfer.files;
                if (this.browserName !== "msie" && this.browserName !== "edge" && this.browserName !== "safari") this.element.files = files;
                if (files.length > 0) {
                    targetFiles = this.multiple ? this.sortFileList(files) : [
                        files[0]
                    ];
                    this.renderSelectedFiles(args, targetFiles);
                }
            }
        } else {
            targetFiles = [].slice.call(args.target.files);
            this.renderSelectedFiles(args, targetFiles);
        }
        if (this.isAngular || this.isReact) args.stopPropagation();
    };
    /* istanbul ignore next */ Uploader.prototype.getBase64 = function(file) {
        return new Promise(function(resolve, reject) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function() {
                return resolve(fileReader.result);
            };
            fileReader.onerror = function(error) {
                return reject(error);
            };
        });
    };
    /* istanbul ignore next */ /* tslint:ignore */ Uploader.prototype.renderSelectedFiles = function(args, targetFiles, directory, paste) {
        var _this = this;
        this.base64String = [];
        var eventArgs = {
            event: args,
            cancel: false,
            filesData: [],
            isModified: false,
            modifiedFilesData: [],
            progressInterval: "",
            isCanceled: false,
            currentRequest: null,
            customFormData: null
        };
        /* istanbul ignore next */ if (targetFiles.length < 1) {
            eventArgs.isCanceled = true;
            this.trigger("selected", eventArgs);
            return;
        }
        this.flag = true;
        var fileData = [];
        if (!this.multiple) {
            this.clearData(true);
            this.actionCompleteCount = 0;
            targetFiles = [
                targetFiles[0]
            ];
        }
        for(var i = 0; i < targetFiles.length; i++){
            var file = directory ? targetFiles[i].file : targetFiles[i];
            this.updateInitialFileDetails(args, targetFiles, file, i, fileData, directory, paste);
        }
        eventArgs.filesData = fileData;
        if (this.allowedExtensions.indexOf("*") > -1) this.allTypes = true;
        if (this.enableHtmlSanitizer) for(var i = 0; i < fileData.length; i++){
            var sanitizeFile = (0, $3P3ke.SanitizeHtmlHelper).beforeSanitize();
            var sanitizeFileName = (0, $3P3ke.SanitizeHtmlHelper).serializeValue(sanitizeFile, fileData[parseInt(i.toString(), 10)].name);
            var currentFileName = fileData[parseInt(i.toString(), 10)].name;
            var isUTF8 = false;
            for(var i_1 = 0; i_1 < currentFileName.length; i_1++)if (currentFileName.charCodeAt(i_1) > 127) {
                isUTF8 = true;
                break;
            }
            var htmlTagRegex = /<([a-z][a-z0-9]*)\b[^>]*>(.*?)<\/\1>/i;
            var hasHTMLString = htmlTagRegex.test(currentFileName);
            if (sanitizeFileName !== fileData[parseInt(i.toString(), 10)].name && !(isUTF8 && !hasHTMLString)) {
                var encodedFileName = targetFiles[parseInt(i.toString(), 10)].name.replace(/[\u00A0-\u9999<>\\&]/g, function(i) {
                    return "&#" + i.charCodeAt(0) + ";";
                });
                fileData[parseInt(i.toString(), 10)].name = encodedFileName;
                fileData[parseInt(i.toString(), 10)].status = this.localizedTexts("invalidFileName");
                fileData[parseInt(i.toString(), 10)].statusCode = "0";
            }
        }
        if (!this.allTypes) fileData = this.checkExtension(fileData);
        this.trigger("selected", eventArgs, function(eventArgs) {
            _this._internalRenderSelect(eventArgs, fileData);
        });
    };
    Uploader.prototype.updateInitialFileDetails = function(args, targetFiles, file, i, fileData, directory, paste) {
        var fileName = directory ? targetFiles[i].path.substring(1, targetFiles[i].path.length) : paste ? (0, $3EnZW.getUniqueID)(file.name.substring(0, file.name.lastIndexOf("."))) + "." + this.getFileType(file.name) : this.directoryUpload ? targetFiles[i].webkitRelativePath : file.name;
        var fileDetails = {
            name: fileName,
            rawFile: file,
            size: file.size,
            status: this.localizedTexts("readyToUploadMessage"),
            type: this.getFileType(file.name),
            validationMessages: this.validatedFileSize(file.size),
            statusCode: "1",
            id: (0, $3EnZW.getUniqueID)(file.name.substring(0, file.name.lastIndexOf("."))) + "." + this.getFileType(file.name)
        };
        /* istanbul ignore next */ if (paste) fileDetails.fileSource = "paste";
        fileDetails.status = fileDetails.validationMessages.minSize !== "" ? this.localizedTexts("invalidMinFileSize") : fileDetails.validationMessages.maxSize !== "" ? this.localizedTexts("invalidMaxFileSize") : fileDetails.status;
        if (fileDetails.validationMessages.minSize !== "" || fileDetails.validationMessages.maxSize !== "") {
            fileDetails.statusCode = "0";
            this.checkActionComplete(true);
        }
        fileData.push(fileDetails);
    };
    Uploader.prototype._internalRenderSelect = function(eventArgs, fileData) {
        if (!eventArgs.cancel) {
            /* istanbul ignore next */ this.selectedFiles = this.selectedFiles.concat(fileData);
            this.btnTabIndex = this.disableKeyboardNavigation ? "-1" : "0";
            if (this.showFileList) {
                if (eventArgs.isModified && eventArgs.modifiedFilesData.length > 0) {
                    for(var j = 0; j < eventArgs.modifiedFilesData.length; j++){
                        for(var k = 0; k < fileData.length; k++)if (eventArgs.modifiedFilesData[j].id === fileData[k].id) eventArgs.modifiedFilesData[j].rawFile = fileData[k].rawFile;
                    }
                    var dataFiles = this.allTypes ? eventArgs.modifiedFilesData : this.checkExtension(eventArgs.modifiedFilesData);
                    this.updateSortedFileList(dataFiles);
                    this.filesData = this.filesData.concat(dataFiles);
                    if (!this.isForm || this.allowUpload()) this.checkAutoUpload(dataFiles);
                } else {
                    this.internalCreateFileList(fileData);
                    if (this.autoUpload && this.sequenceUpload && this.sequentialUpload && this.filesData.length > 0 && this.filesData[this.filesData.length - 1].statusCode !== "2" && this.filesData[this.filesData.length - 1].statusCode !== "0") {
                        this.filesData = this.filesData.concat(fileData);
                        return;
                    }
                    this.filesData = this.filesData.concat(fileData);
                    if (!this.isForm || this.allowUpload()) this.checkAutoUpload(fileData);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(eventArgs.progressInterval) && eventArgs.progressInterval !== "") this.progressInterval = eventArgs.progressInterval;
            } else {
                this.filesData = this.filesData.concat(fileData);
                if (this.autoUpload) this.upload(this.filesData, true);
            }
            this.raiseActionComplete();
            this.isFirstFileOnSelection = true;
        }
    };
    Uploader.prototype.allowUpload = function() {
        var allowFormUpload = false;
        if (this.isForm && !(0, $3EnZW.isNullOrUndefined)(this.asyncSettings.saveUrl) && this.asyncSettings.saveUrl !== "") allowFormUpload = true;
        return allowFormUpload;
    };
    Uploader.prototype.isFormUpload = function() {
        var isFormUpload = false;
        if (this.isForm && ((0, $3EnZW.isNullOrUndefined)(this.asyncSettings.saveUrl) || this.asyncSettings.saveUrl === "") && ((0, $3EnZW.isNullOrUndefined)(this.asyncSettings.removeUrl) || this.asyncSettings.removeUrl === "")) isFormUpload = true;
        return isFormUpload;
    };
    Uploader.prototype.clearData = function(singleUpload) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.listParent)) {
            (0, $4ZDHT.detach)(this.listParent);
            this.listParent = null;
        }
        if (this.browserName !== "msie" && !singleUpload) this.element.value = "";
        this.fileList = [];
        this.filesData = [];
        this.removeActionButtons();
    };
    Uploader.prototype.updateSortedFileList = function(filesData) {
        var previousListClone = this.createElement("div", {
            id: "clonewrapper"
        });
        var added = -1;
        if (this.listParent) {
            for(var i = 0; i < this.listParent.querySelectorAll("li").length; i++){
                var liElement = this.listParent.querySelectorAll("li")[i];
                previousListClone.appendChild(liElement.cloneNode(true));
            }
            this.removeActionButtons();
            var oldList = [].slice.call(previousListClone.childNodes);
            this.createParentUL();
            for(var index = 0; index < filesData.length; index++){
                for(var j = 0; j < this.filesData.length; j++)if (this.filesData[j].name === filesData[index].name) {
                    this.listParent.appendChild(oldList[j]);
                    (0, $aqzbR.EventHandler).add(oldList[j].querySelector(".e-icons"), "click", this.removeFiles, this);
                    this.fileList.push(oldList[j]);
                    added = index;
                }
                if (added !== index) this.internalCreateFileList([
                    filesData[index]
                ]);
            }
        } else this.internalCreateFileList(filesData);
    };
    Uploader.prototype.isBlank = function(str) {
        return !str || /^\s*$/.test(str);
    };
    Uploader.prototype.checkExtension = function(files) {
        var dropFiles = files;
        if (!this.isBlank(this.allowedExtensions)) {
            var allowedExtensions = [];
            var extensions = this.allowedExtensions.split(",");
            for(var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++){
                var extension = extensions_1[_i];
                allowedExtensions.push(extension.trim().toLocaleLowerCase());
            }
            for(var i = 0; i < files.length; i++){
                var checkFileType = files[i].type.indexOf(".") !== -1 ? files[i].type.replace(".", "") : files[i].type;
                if (allowedExtensions.indexOf(("." + checkFileType).toLocaleLowerCase()) === -1) {
                    files[i].status = this.localizedTexts("invalidFileType");
                    files[i].statusCode = "0";
                }
            }
        }
        return dropFiles;
    };
    Uploader.prototype.validatedFileSize = function(fileSize) {
        var minSizeError = "";
        var maxSizeError = "";
        if (fileSize < this.minFileSize) minSizeError = this.localizedTexts("invalidMinFileSize");
        else if (fileSize > this.maxFileSize) maxSizeError = this.localizedTexts("invalidMaxFileSize");
        else {
            minSizeError = "";
            maxSizeError = "";
        }
        var errorMessage = {
            minSize: minSizeError,
            maxSize: maxSizeError
        };
        return errorMessage;
    };
    Uploader.prototype.isPreLoadFile = function(fileData) {
        var isPreload = false;
        for(var i = 0; i < this.files.length; i++)if (this.files[i].name === fileData.name.slice(0, fileData.name.lastIndexOf(".")) && this.files[i].type === fileData.type) isPreload = true;
        return isPreload;
    };
    Uploader.prototype.createCustomfileList = function(fileData) {
        this.createParentUL();
        for(var _i = 0, fileData_1 = fileData; _i < fileData_1.length; _i++){
            var listItem = fileData_1[_i];
            var listElement = this.createElement("li", {
                className: $f606c23990200287$var$FILE,
                attrs: {
                    "data-file-name": listItem.name
                }
            });
            this.uploadTemplateFn = this.templateComplier(this.template);
            var liTempCompiler = this.uploadTemplateFn(listItem, this, "template", this.element.id + "Template", this.isStringTemplate, null, listElement);
            if (liTempCompiler) {
                var fromElements = [].slice.call(liTempCompiler);
                (0, $4ZDHT.append)(fromElements, listElement);
            }
            var index = fileData.indexOf(listItem);
            var eventArgs = {
                element: listElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            var eventsArgs = {
                element: listElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            this.trigger("rendering", eventArgs);
            this.trigger("fileListRendering", eventsArgs);
            this.listParent.appendChild(listElement);
            this.fileList.push(listElement);
        }
        this.renderReactTemplates();
    };
    Uploader.prototype.createParentUL = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.listParent)) {
            this.listParent = this.createElement("ul", {
                className: $f606c23990200287$var$LIST_PARENT
            });
            this.uploadWrapper.appendChild(this.listParent);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.formFileList = function(fileData, files) {
        var fileList = this.createElement("li", {
            className: $f606c23990200287$var$FILE
        });
        fileList.setAttribute("data-files-count", fileData.length + "");
        var fileContainer = this.createElement("span", {
            className: $f606c23990200287$var$TEXT_CONTAINER
        });
        var statusMessage;
        for(var _i = 0, fileData_2 = fileData; _i < fileData_2.length; _i++){
            var listItem = fileData_2[_i];
            var fileNameEle = this.createElement("span", {
                className: $f606c23990200287$var$FILE_NAME
            });
            fileNameEle.innerHTML = this.getFileNameOnly(listItem.name);
            var fileTypeEle = this.createElement("span", {
                className: $f606c23990200287$var$FILE_TYPE
            });
            var fileType = this.getFileType(listItem.name);
            fileTypeEle.innerHTML = "." + fileType;
            if (!fileType) fileTypeEle.classList.add("e-hidden");
            if (!this.enableRtl) {
                fileContainer.appendChild(fileNameEle);
                fileContainer.appendChild(fileTypeEle);
            } else {
                var rtlContainer = this.createElement("span", {
                    className: $f606c23990200287$var$RTL_CONTAINER
                });
                rtlContainer.appendChild(fileTypeEle);
                rtlContainer.appendChild(fileNameEle);
                fileContainer.appendChild(rtlContainer);
            }
            this.truncateName(fileNameEle);
            statusMessage = this.formValidateFileInfo(listItem, fileList);
        }
        fileList.appendChild(fileContainer);
        this.setListToFileInfo(fileData, fileList);
        var index = this.listParent.querySelectorAll("li").length;
        var infoEle = this.createElement("span");
        if (fileList.classList.contains($f606c23990200287$var$INVALID_FILE)) {
            infoEle.classList.add($f606c23990200287$var$STATUS);
            infoEle.classList.add($f606c23990200287$var$INVALID_FILE);
            infoEle.innerText = fileData.length > 1 ? this.localizedTexts("invalidFileSelection") : statusMessage;
        } else {
            infoEle.classList.add(fileData.length > 1 ? $f606c23990200287$var$INFORMATION : $f606c23990200287$var$FILE_SIZE);
            infoEle.innerText = fileData.length > 1 ? this.localizedTexts("totalFiles") + ": " + fileData.length + " , " + this.localizedTexts("size") + ": " + this.bytesToSize(this.getFileSize(fileData)) : this.bytesToSize(fileData[0].size);
            this.createFormInput(fileData);
        }
        fileContainer.appendChild(infoEle);
        if ((0, $3EnZW.isNullOrUndefined)(fileList.querySelector(".e-icons"))) {
            var iconElement = this.createElement("span", {
                className: "e-icons",
                attrs: {
                    "tabindex": this.btnTabIndex
                }
            });
            /* istanbul ignore next */ if (this.browserName === "msie") iconElement.classList.add("e-msie");
            iconElement.setAttribute("title", this.localizedTexts("remove"));
            fileList.appendChild(fileContainer);
            fileList.appendChild(iconElement);
            (0, $aqzbR.EventHandler).add(iconElement, "click", this.removeFiles, this);
            iconElement.classList.add($f606c23990200287$var$REMOVE_ICON);
        }
        var eventArgs = {
            element: fileList,
            fileInfo: this.mergeFileInfo(fileData, fileList),
            index: index,
            isPreload: this.isPreLoadFile(this.mergeFileInfo(fileData, fileList))
        };
        var eventsArgs = {
            element: fileList,
            fileInfo: this.mergeFileInfo(fileData, fileList),
            index: index,
            isPreload: this.isPreLoadFile(this.mergeFileInfo(fileData, fileList))
        };
        this.trigger("rendering", eventArgs);
        this.trigger("fileListRendering", eventsArgs);
        this.listParent.appendChild(fileList);
        this.fileList.push(fileList);
    };
    Uploader.prototype.formValidateFileInfo = function(listItem, fileList) {
        var statusMessage = listItem.status;
        var validationMessages = this.validatedFileSize(listItem.size);
        if (validationMessages.minSize !== "" || validationMessages.maxSize !== "") {
            this.addInvalidClass(fileList);
            statusMessage = validationMessages.minSize !== "" ? this.localizedTexts("invalidMinFileSize") : validationMessages.maxSize !== "" ? this.localizedTexts("invalidMaxFileSize") : statusMessage;
        }
        var typeValidationMessage = this.checkExtension(this.getFilesInArray(listItem))[0].status;
        if (typeValidationMessage === this.localizedTexts("invalidFileType")) {
            this.addInvalidClass(fileList);
            statusMessage = typeValidationMessage;
        }
        return statusMessage;
    };
    Uploader.prototype.addInvalidClass = function(fileList) {
        fileList.classList.add($f606c23990200287$var$INVALID_FILE);
    };
    Uploader.prototype.createFormInput = function(fileData) {
        if (this.browserName !== "safari") {
            var inputElement = this.element.cloneNode(true);
            inputElement.classList.add($f606c23990200287$var$HIDDEN_INPUT);
            for(var _i = 0, fileData_3 = fileData; _i < fileData_3.length; _i++){
                var listItem = fileData_3[_i];
                listItem.input = inputElement;
            }
            inputElement.setAttribute("id", (0, $3EnZW.getUniqueID)("hiddenUploader"));
            inputElement.setAttribute("name", this.uploaderName);
            this.uploadWrapper.querySelector("." + $f606c23990200287$var$INPUT_WRAPPER).appendChild(inputElement);
            if (this.browserName !== "msie" && this.browserName !== "edge") this.element.value = "";
        }
    };
    Uploader.prototype.getFileSize = function(fileData) {
        var fileSize = 0;
        for(var _i = 0, fileData_4 = fileData; _i < fileData_4.length; _i++){
            var file = fileData_4[_i];
            fileSize += file.size;
        }
        return fileSize;
    };
    Uploader.prototype.mergeFileInfo = function(fileData, fileList) {
        var result = {
            name: "",
            rawFile: "",
            size: 0,
            status: "",
            type: "",
            validationMessages: {
                minSize: "",
                maxSize: ""
            },
            statusCode: "1",
            list: fileList
        };
        var fileNames = [];
        var type = "";
        for(var _i = 0, fileData_5 = fileData; _i < fileData_5.length; _i++){
            var listItem = fileData_5[_i];
            fileNames.push(listItem.name);
            type = listItem.type;
        }
        result.name = fileNames.join(", ");
        result.size = this.getFileSize(fileData);
        result.type = type;
        result.status = this.statusForFormUpload(fileData, fileList);
        return result;
    };
    Uploader.prototype.statusForFormUpload = function(fileData, fileList) {
        var isValid = true;
        var statusMessage;
        for(var _i = 0, fileData_6 = fileData; _i < fileData_6.length; _i++){
            var listItem = fileData_6[_i];
            statusMessage = listItem.status;
            var validationMessages = this.validatedFileSize(listItem.size);
            if (validationMessages.minSize !== "" || validationMessages.maxSize !== "") {
                isValid = false;
                statusMessage = validationMessages.minSize !== "" ? this.localizedTexts("invalidMinFileSize") : validationMessages.maxSize !== "" ? this.localizedTexts("invalidMaxFileSize") : statusMessage;
            }
            var typeValidationMessage = this.checkExtension(this.getFilesInArray(listItem))[0].status;
            if (typeValidationMessage === this.localizedTexts("invalidFileType")) {
                isValid = false;
                statusMessage = typeValidationMessage;
            }
        }
        if (!isValid) {
            fileList.classList.add($f606c23990200287$var$INVALID_FILE);
            statusMessage = fileData.length > 1 ? this.localizedTexts("invalidFileSelection") : statusMessage;
        } else statusMessage = this.localizedTexts("totalFiles") + ": " + fileData.length + " , " + this.localizedTexts("size") + ": " + this.bytesToSize(this.getFileSize(fileData));
        return statusMessage;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.formCustomFileList = function(fileData, files) {
        this.createParentUL();
        var fileList = this.createElement("li", {
            className: $f606c23990200287$var$FILE
        });
        fileList.setAttribute("data-files-count", fileData.length + "");
        this.setListToFileInfo(fileData, fileList);
        var result = this.mergeFileInfo(fileData, fileList);
        fileList.setAttribute("data-file-name", result.name);
        this.uploadTemplateFn = this.templateComplier(this.template);
        var liTempCompiler = this.uploadTemplateFn(result, this, "template", this.element.id + "Template", this.isStringTemplate, null, fileList);
        if (liTempCompiler) {
            var fromElements = [].slice.call(liTempCompiler);
            (0, $4ZDHT.append)(fromElements, fileList);
        }
        var index = this.listParent.querySelectorAll("li").length;
        if (!fileList.classList.contains($f606c23990200287$var$INVALID_FILE)) this.createFormInput(fileData);
        var eventArgs = {
            element: fileList,
            fileInfo: result,
            index: index,
            isPreload: this.isPreLoadFile(result)
        };
        var eventsArgs = {
            element: fileList,
            fileInfo: result,
            index: index,
            isPreload: this.isPreLoadFile(result)
        };
        this.trigger("rendering", eventArgs);
        this.trigger("fileListRendering", eventsArgs);
        this.listParent.appendChild(fileList);
        this.fileList.push(fileList);
        this.renderReactTemplates();
    };
    /**
     * Create the file list for specified files data.
     *
     * @param { FileInfo[] } fileData - Specifies the files data for file list creation.
     * @returns {void}
     */ Uploader.prototype.createFileList = function(fileData) {
        this.filesData = this.filesData && this.filesData.length > 0 ? this.filesData.concat(fileData) : fileData;
        this.internalCreateFileList(fileData);
    };
    Uploader.prototype.internalCreateFileList = function(fileData) {
        this.createParentUL();
        if (this.template !== "" && !(0, $3EnZW.isNullOrUndefined)(this.template)) {
            if (this.isFormUpload()) {
                this.uploadWrapper.classList.add($f606c23990200287$var$FORM_UPLOAD);
                this.formCustomFileList(fileData, this.element.files);
            } else this.createCustomfileList(fileData);
        } else if (this.isFormUpload()) {
            this.uploadWrapper.classList.add($f606c23990200287$var$FORM_UPLOAD);
            this.formFileList(fileData, this.element.files);
        } else for(var _i = 0, fileData_7 = fileData; _i < fileData_7.length; _i++){
            var listItem = fileData_7[_i];
            var liElement = this.createElement("li", {
                className: $f606c23990200287$var$FILE,
                attrs: {
                    "data-file-name": listItem.name,
                    "data-files-count": "1"
                }
            });
            var textContainer = this.createElement("span", {
                className: $f606c23990200287$var$TEXT_CONTAINER
            });
            var textElement = this.createElement("span", {
                className: $f606c23990200287$var$FILE_NAME,
                attrs: {
                    "title": listItem.name
                }
            });
            textElement.innerHTML = this.getFileNameOnly(listItem.name);
            var fileExtension = this.createElement("span", {
                className: $f606c23990200287$var$FILE_TYPE
            });
            var fileType = this.getFileType(listItem.name);
            fileExtension.innerHTML = "." + fileType;
            if (!fileType) fileExtension.classList.add("e-hidden");
            if (!this.enableRtl) {
                textContainer.appendChild(textElement);
                textContainer.appendChild(fileExtension);
            } else {
                var rtlContainer = this.createElement("span", {
                    className: $f606c23990200287$var$RTL_CONTAINER
                });
                rtlContainer.appendChild(fileExtension);
                rtlContainer.appendChild(textElement);
                textContainer.appendChild(rtlContainer);
            }
            var fileSize = this.createElement("span", {
                className: $f606c23990200287$var$FILE_SIZE
            });
            fileSize.innerHTML = this.bytesToSize(listItem.size);
            textContainer.appendChild(fileSize);
            var statusElement = this.createElement("span", {
                className: $f606c23990200287$var$STATUS
            });
            textContainer.appendChild(statusElement);
            statusElement.innerHTML = listItem.status;
            liElement.appendChild(textContainer);
            var iconElement = this.createElement("span", {
                className: " e-icons",
                attrs: {
                    "tabindex": this.btnTabIndex
                }
            });
            /* istanbul ignore next */ if (this.browserName === "msie") iconElement.classList.add("e-msie");
            iconElement.setAttribute("title", this.localizedTexts("remove"));
            liElement.appendChild(iconElement);
            (0, $aqzbR.EventHandler).add(iconElement, "click", this.removeFiles, this);
            if (listItem.statusCode === "2") {
                statusElement.classList.add($f606c23990200287$var$UPLOAD_SUCCESS);
                iconElement.classList.add($f606c23990200287$var$DELETE_ICON);
                iconElement.setAttribute("title", this.localizedTexts("delete"));
                iconElement.setAttribute("aria-label", this.localizedTexts("delete"));
            } else if (listItem.statusCode !== "1") {
                statusElement.classList.remove($f606c23990200287$var$UPLOAD_SUCCESS);
                statusElement.classList.add($f606c23990200287$var$VALIDATION_FAILS);
            }
            if (this.autoUpload && listItem.statusCode === "1" && this.asyncSettings.saveUrl !== "") statusElement.innerHTML = "";
            if (!iconElement.classList.contains($f606c23990200287$var$DELETE_ICON)) {
                iconElement.classList.add($f606c23990200287$var$REMOVE_ICON);
                iconElement.setAttribute("aria-label", this.localizedTexts("remove"));
            }
            var index = fileData.indexOf(listItem);
            var eventArgs = {
                element: liElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            var eventsArgs = {
                element: liElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            this.trigger("rendering", eventArgs);
            this.trigger("fileListRendering", eventsArgs);
            this.listParent.appendChild(liElement);
            this.fileList.push(liElement);
            this.truncateName(textElement);
            var preventActionComplete = this.flag;
            if (this.isPreLoadFile(listItem)) {
                this.flag = false;
                this.checkActionComplete(true);
                this.flag = preventActionComplete;
            }
        }
    };
    Uploader.prototype.getSlicedName = function(nameElement) {
        var text = nameElement.textContent;
        nameElement.dataset.tail = text.slice(text.length - 10);
    };
    Uploader.prototype.setListToFileInfo = function(fileData, fileList) {
        for(var _i = 0, fileData_8 = fileData; _i < fileData_8.length; _i++){
            var listItem = fileData_8[_i];
            listItem.list = fileList;
        }
    };
    Uploader.prototype.truncateName = function(name) {
        var nameElement = name;
        if (this.browserName !== "edge" && nameElement.offsetWidth < nameElement.scrollWidth) this.getSlicedName(nameElement);
        else if (nameElement.offsetWidth + 1 < nameElement.scrollWidth) this.getSlicedName(nameElement);
    };
    Uploader.prototype.getFileType = function(name) {
        var extension;
        var index = name.lastIndexOf(".");
        if (index >= 0) extension = name.substring(index + 1);
        return extension ? extension : "";
    };
    Uploader.prototype.getFileNameOnly = function(name) {
        var type = this.getFileType(name);
        var names = name.split("." + type);
        return type = names[0];
    };
    Uploader.prototype.setInitialAttributes = function() {
        if (this.initialAttr.accept) this.element.setAttribute("accept", this.initialAttr.accept);
        if (this.initialAttr.disabled) this.element.setAttribute("disabled", "disabled");
        if (this.initialAttr.multiple) {
            var newAttr = document.createAttribute("multiple");
            this.element.setAttributeNode(newAttr);
        }
    };
    Uploader.prototype.filterfileList = function(files) {
        var filterFiles = [];
        var li;
        for(var i = 0; i < files.length; i++){
            li = this.getLiElement(files[i]);
            if (!(0, $3EnZW.isNullOrUndefined)(li) && !li.classList.contains($f606c23990200287$var$UPLOAD_SUCCESS)) filterFiles.push(files[i]);
            else if (!this.showFileList && files[i].status !== "File uploaded successfully") filterFiles.push(files[i]);
        }
        return filterFiles;
    };
    Uploader.prototype.updateStatus = function(files, status, statusCode, updateLiStatus) {
        if (updateLiStatus === void 0) updateLiStatus = true;
        if (!(status === "" || (0, $3EnZW.isNullOrUndefined)(status)) && !(statusCode === "" || (0, $3EnZW.isNullOrUndefined)(statusCode))) {
            files.status = status;
            files.statusCode = statusCode;
        }
        if (updateLiStatus) {
            var li = this.getLiElement(files);
            if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                if (!(0, $3EnZW.isNullOrUndefined)(li.querySelector("." + $f606c23990200287$var$STATUS)) && !(status === "" || (0, $3EnZW.isNullOrUndefined)(status))) li.querySelector("." + $f606c23990200287$var$STATUS).textContent = status;
            }
        }
        return files;
    };
    Uploader.prototype.getLiElement = function(files) {
        var index;
        for(var i = 0; i < this.filesData.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(files) && (!(0, $3EnZW.isNullOrUndefined)(this.filesData[i].id) && !(0, $3EnZW.isNullOrUndefined)(files.id) ? this.filesData[i].name === files.name && this.filesData[i].id === files.id : this.filesData[i].name === files.name)) index = i;
        return this.fileList[index];
    };
    Uploader.prototype.createProgressBar = function(liElement) {
        var progressbarWrapper = this.createElement("span", {
            className: $f606c23990200287$var$PROGRESS_WRAPPER
        });
        var progressBar = this.createElement("progressbar", {
            className: $f606c23990200287$var$PROGRESSBAR,
            attrs: {
                value: "0",
                max: "100"
            }
        });
        var progressbarInnerWrapper = this.createElement("span", {
            className: $f606c23990200287$var$PROGRESS_INNER_WRAPPER
        });
        progressBar.setAttribute("style", "width: 0%");
        var progressbarText = this.createElement("span", {
            className: $f606c23990200287$var$PROGRESSBAR_TEXT
        });
        progressbarText.textContent = "0%";
        progressbarInnerWrapper.appendChild(progressBar);
        progressbarWrapper.appendChild(progressbarInnerWrapper);
        progressbarWrapper.appendChild(progressbarText);
        liElement.querySelector("." + $f606c23990200287$var$TEXT_CONTAINER).appendChild(progressbarWrapper);
    };
    /* istanbul ignore next */ Uploader.prototype.updateProgressbar = function(e, li) {
        if (!isNaN(Math.round(e.loaded / e.total * 100)) && !(0, $3EnZW.isNullOrUndefined)(li.querySelector("." + $f606c23990200287$var$PROGRESSBAR))) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.progressInterval) && this.progressInterval !== "") {
                var value = Math.round(e.loaded / e.total * 100) % parseInt(this.progressInterval, 10);
                if (value === 0 || value === 100) this.changeProgressValue(li, Math.round(e.loaded / e.total * 100).toString() + "%");
            } else this.changeProgressValue(li, Math.round(e.loaded / e.total * 100).toString() + "%");
        }
    };
    Uploader.prototype.changeProgressValue = function(li, progressValue) {
        li.querySelector("." + $f606c23990200287$var$PROGRESSBAR).setAttribute("style", "width:" + progressValue);
        li.querySelector("." + $f606c23990200287$var$PROGRESSBAR_TEXT).textContent = progressValue;
    };
    Uploader.prototype.uploadInProgress = function(e, files, customUI, request) {
        var li = this.getLiElement(files);
        if ((0, $3EnZW.isNullOrUndefined)(li) && !customUI) return;
        if (!(0, $3EnZW.isNullOrUndefined)(li)) {
            /* istanbul ignore next */ if (files.statusCode === "5") this.cancelUploadingFile(files, e, request, li);
            if (!(li.querySelectorAll("." + $f606c23990200287$var$PROGRESS_WRAPPER).length > 0) && li.querySelector("." + $f606c23990200287$var$STATUS)) {
                li.querySelector("." + $f606c23990200287$var$STATUS).classList.add($f606c23990200287$var$UPLOAD_INPROGRESS);
                this.createProgressBar(li);
                this.updateProgressBarClasses(li, $f606c23990200287$var$UPLOAD_INPROGRESS);
                li.querySelector("." + $f606c23990200287$var$STATUS).classList.remove($f606c23990200287$var$UPLOAD_FAILED);
            }
            this.updateProgressbar(e, li);
            var iconEle = li.querySelector("." + $f606c23990200287$var$REMOVE_ICON);
            if (!(0, $3EnZW.isNullOrUndefined)(iconEle)) {
                iconEle.classList.add($f606c23990200287$var$ABORT_ICON, $f606c23990200287$var$UPLOAD_INPROGRESS);
                iconEle.setAttribute("title", this.localizedTexts("abort"));
                iconEle.classList.remove($f606c23990200287$var$REMOVE_ICON);
            }
        } else this.cancelUploadingFile(files, e, request);
        var args = {
            e: e,
            operation: "upload",
            file: this.updateStatus(files, this.localizedTexts("inProgress"), "3")
        };
        this.trigger("progress", args);
    };
    /* istanbul ignore next */ Uploader.prototype.cancelUploadingFile = function(files, e, request, li) {
        var _this = this;
        if (files.statusCode === "5") {
            var eventArgs = {
                event: e,
                fileData: files,
                cancel: false,
                customFormData: [],
                currentRequest: null
            };
            this.trigger("canceling", eventArgs, function(eventArgs) {
                if (eventArgs.cancel) {
                    files.statusCode = "3";
                    if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                        var spinnerTarget = li.querySelector("." + $f606c23990200287$var$ABORT_ICON);
                        if (!(0, $3EnZW.isNullOrUndefined)(spinnerTarget)) {
                            (0, $d4834c37f505aa74$export$95fec50f68454318)(spinnerTarget);
                            (0, $4ZDHT.detach)(li.querySelector(".e-spinner-pane"));
                        }
                    }
                } else {
                    request.emitError = false;
                    request.httpRequest.abort();
                    var formData = new FormData();
                    if (files.statusCode === "5") {
                        var name_1 = _this.element.getAttribute("name");
                        formData.append(name_1, files.name);
                        formData.append("cancel-uploading", files.name);
                        _this.updateFormData(formData, eventArgs.customFormData);
                        var ajax_1 = new (0, $cfGuF.Ajax)(_this.asyncSettings.removeUrl, "POST", true, null);
                        ajax_1.emitError = false;
                        ajax_1.beforeSend = function(e) {
                            if (eventArgs.currentRequest) _this.updateCustomheader(ajax_1.httpRequest, eventArgs.currentRequest);
                        };
                        ajax_1.onLoad = function(e) {
                            _this.removecanceledFile(e, files);
                            return {};
                        };
                        ajax_1.send(formData);
                    }
                }
            });
        }
    };
    Uploader.prototype.removecanceledFile = function(e, file) {
        var liElement = this.getLiElement(file);
        if ((0, $3EnZW.isNullOrUndefined)(liElement) || liElement.querySelector("." + $f606c23990200287$var$RETRY_ICON) || (0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON))) return;
        this.updateStatus(file, this.localizedTexts("fileUploadCancel"), "5");
        this.renderFailureState(e, file, liElement);
        var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON);
        if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
            (0, $d4834c37f505aa74$export$95fec50f68454318)(spinnerTarget);
            if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector(".e-spinner-pane"))) (0, $4ZDHT.detach)(liElement.querySelector(".e-spinner-pane"));
        }
        var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
        var args = {
            event: e,
            response: requestResponse,
            operation: "cancel",
            file: file
        };
        this.trigger("success", args);
    };
    Uploader.prototype.renderFailureState = function(e, file, liElement) {
        var _this = this;
        this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_FAILED);
        this.removeProgressbar(liElement, "failure");
        if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector(".e-file-status"))) liElement.querySelector(".e-file-status").classList.add($f606c23990200287$var$UPLOAD_FAILED);
        var deleteIcon = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
        if ((0, $3EnZW.isNullOrUndefined)(deleteIcon)) return;
        deleteIcon.classList.remove($f606c23990200287$var$ABORT_ICON, $f606c23990200287$var$UPLOAD_INPROGRESS);
        deleteIcon.classList.add($f606c23990200287$var$REMOVE_ICON);
        deleteIcon.setAttribute("title", this.localizedTexts("remove"));
        this.pauseButton = this.createElement("span", {
            className: "e-icons e-file-reload-btn",
            attrs: {
                "tabindex": this.btnTabIndex
            }
        });
        deleteIcon.parentElement.insertBefore(this.pauseButton, deleteIcon);
        this.pauseButton.setAttribute("title", this.localizedTexts("retry"));
        this.pauseButton.setAttribute("aria-label", this.localizedTexts("retry"));
        var retryElement = liElement.querySelector("." + $f606c23990200287$var$RETRY_ICON);
        /* istanbul ignore next */ retryElement.addEventListener("click", function(e) {
            _this.reloadcanceledFile(e, file, liElement, false);
        }, false);
    };
    Uploader.prototype.reloadcanceledFile = function(e, file, liElement, custom) {
        file.statusCode = "1";
        file.status = this.localizedTexts("readyToUploadMessage");
        if (!custom) {
            if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$STATUS))) liElement.querySelector("." + $f606c23990200287$var$STATUS).classList.remove($f606c23990200287$var$UPLOAD_FAILED);
            if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$RETRY_ICON))) (0, $4ZDHT.detach)(liElement.querySelector("." + $f606c23990200287$var$RETRY_ICON));
            this.pauseButton = null;
        }
        /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(liElement)) liElement.classList.add($f606c23990200287$var$RESTRICT_RETRY);
        this.upload([
            file
        ]);
    };
    /* istanbul ignore next */ Uploader.prototype.uploadComplete = function(e, file, customUI) {
        var status = e.target;
        if (status.readyState === 4 && status.status >= 200 && status.status <= 299) {
            var li = this.getLiElement(file);
            if ((0, $3EnZW.isNullOrUndefined)(li) && (!customUI || (0, $3EnZW.isNullOrUndefined)(customUI)) && this.showFileList) return;
            if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                this.updateProgressBarClasses(li, $f606c23990200287$var$UPLOAD_SUCCESS);
                this.removeProgressbar(li, "success");
                var iconEle = li.querySelector("." + $f606c23990200287$var$ABORT_ICON);
                if (!(0, $3EnZW.isNullOrUndefined)(iconEle)) {
                    iconEle.classList.add($f606c23990200287$var$DELETE_ICON);
                    iconEle.setAttribute("title", this.localizedTexts("delete"));
                    iconEle.setAttribute("aria-label", this.localizedTexts("delete"));
                    iconEle.classList.remove($f606c23990200287$var$ABORT_ICON);
                    iconEle.classList.remove($f606c23990200287$var$UPLOAD_INPROGRESS);
                }
            }
            this.raiseSuccessEvent(e, file);
        } else this.uploadFailed(e, file);
    };
    Uploader.prototype.getResponse = function(e) {
        var target = e.currentTarget;
        var response = {
            readyState: target.readyState,
            statusCode: target.status,
            statusText: target.statusText,
            headers: target.getAllResponseHeaders(),
            withCredentials: target.withCredentials
        };
        return response;
    };
    Uploader.prototype.raiseSuccessEvent = function(e, file) {
        var _this = this;
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var statusMessage = this.localizedTexts("uploadSuccessMessage");
        var args = {
            e: e,
            response: response,
            operation: "upload",
            file: this.updateStatus(file, statusMessage, "2", false),
            statusText: statusMessage
        };
        var liElement = this.getLiElement(file);
        if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
            var spinnerEle = liElement.querySelector("." + $f606c23990200287$var$SPINNER_PANE);
            if (!(0, $3EnZW.isNullOrUndefined)(spinnerEle)) {
                (0, $d4834c37f505aa74$export$95fec50f68454318)(liElement);
                (0, $4ZDHT.detach)(spinnerEle);
            }
        }
        this.trigger("success", args, function(args) {
            _this.updateStatus(file, args.statusText, "2");
            if (_this.multiple) _this.uploadedFilesData.push(file);
            else _this.uploadedFilesData = [
                file
            ];
            _this.trigger("change", {
                file: _this.uploadedFilesData
            });
            _this.checkActionButtonStatus();
            if (_this.fileList.length > 0) {
                if (!_this.getLiElement(file).classList.contains($f606c23990200287$var$RESTRICT_RETRY)) {
                    _this.uploadSequential();
                    _this.checkActionComplete(true);
                } else /* istanbul ignore next */ _this.getLiElement(file).classList.remove($f606c23990200287$var$RESTRICT_RETRY);
            } else if (!_this.showFileList) _this.checkActionComplete(true);
        });
    };
    Uploader.prototype.uploadFailed = function(e, file) {
        var _this = this;
        var li = this.getLiElement(file);
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var statusMessage = this.localizedTexts("uploadFailedMessage");
        var args = {
            e: e,
            response: response,
            operation: "upload",
            file: this.updateStatus(file, statusMessage, "0", false),
            statusText: statusMessage
        };
        if (!(0, $3EnZW.isNullOrUndefined)(li)) this.renderFailureState(e, file, li);
        this.trigger("failure", args, function(args) {
            _this.updateStatus(file, args.statusText, "0");
            _this.checkActionButtonStatus();
            _this.uploadSequential();
            _this.checkActionComplete(true);
        });
    };
    Uploader.prototype.uploadSequential = function() {
        if (this.sequentialUpload) {
            if (this.autoUpload) /* istanbul ignore next */ this.checkAutoUpload(this.filesData);
            else this.uploadButtonClick();
        }
    };
    Uploader.prototype.checkActionComplete = function(increment) {
        if (increment) ++this.actionCompleteCount;
        else --this.actionCompleteCount;
        this.raiseActionComplete();
    };
    Uploader.prototype.raiseActionComplete = function() {
        if (this.filesData.length === this.actionCompleteCount && this.flag) {
            this.flag = false;
            var eventArgs = {
                fileData: []
            };
            eventArgs.fileData = this.getSelectedFileStatus(this.selectedFiles);
            this.trigger("actionComplete", eventArgs);
        }
    };
    Uploader.prototype.getSelectedFileStatus = function(selectedFiles) {
        var matchFiles = [];
        var matchFilesIndex = 0;
        for(var selectFileIndex = 0; selectFileIndex < selectedFiles.length; selectFileIndex++){
            var selectedFileData = selectedFiles[selectFileIndex];
            for(var fileDataIndex = 0; fileDataIndex < this.filesData.length; fileDataIndex++)if (this.filesData[fileDataIndex].name === selectedFileData.name && this.filesData[fileDataIndex].status === selectedFileData.status) {
                matchFiles[matchFilesIndex] = this.filesData[fileDataIndex];
                ++matchFilesIndex;
                break;
            }
        }
        return matchFiles;
    };
    Uploader.prototype.updateProgressBarClasses = function(li, className) {
        var progressBar = li.querySelector("." + $f606c23990200287$var$PROGRESSBAR);
        if (!(0, $3EnZW.isNullOrUndefined)(progressBar)) progressBar.classList.add(className);
    };
    Uploader.prototype.removeProgressbar = function(li, callType) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(li.querySelector("." + $f606c23990200287$var$PROGRESS_WRAPPER))) {
            this.progressAnimation = new (0, $kj1BR.Animation)({
                duration: 1250
            });
            this.progressAnimation.animate(li.querySelector("." + $f606c23990200287$var$PROGRESS_WRAPPER), {
                name: "FadeOut"
            });
            this.progressAnimation.animate(li.querySelector("." + $f606c23990200287$var$PROGRESSBAR_TEXT), {
                name: "FadeOut"
            });
            setTimeout(function() {
                _this.animateProgressBar(li, callType);
            }, 750);
        }
    };
    /* istanbul ignore next */ Uploader.prototype.animateProgressBar = function(li, callType) {
        if (callType === "success") {
            li.classList.add($f606c23990200287$var$UPLOAD_SUCCESS);
            if (!(0, $3EnZW.isNullOrUndefined)(li.querySelector("." + $f606c23990200287$var$STATUS))) {
                li.querySelector("." + $f606c23990200287$var$STATUS).classList.remove($f606c23990200287$var$UPLOAD_INPROGRESS);
                this.progressAnimation.animate(li.querySelector("." + $f606c23990200287$var$STATUS), {
                    name: "FadeIn"
                });
                li.querySelector("." + $f606c23990200287$var$STATUS).classList.add($f606c23990200287$var$UPLOAD_SUCCESS);
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(li.querySelector("." + $f606c23990200287$var$STATUS))) {
            li.querySelector("." + $f606c23990200287$var$STATUS).classList.remove($f606c23990200287$var$UPLOAD_INPROGRESS);
            this.progressAnimation.animate(li.querySelector("." + $f606c23990200287$var$STATUS), {
                name: "FadeIn"
            });
            li.querySelector("." + $f606c23990200287$var$STATUS).classList.add($f606c23990200287$var$UPLOAD_FAILED);
        }
        if (li.querySelector("." + $f606c23990200287$var$PROGRESS_WRAPPER)) (0, $4ZDHT.detach)(li.querySelector("." + $f606c23990200287$var$PROGRESS_WRAPPER));
    };
    Uploader.prototype.setExtensions = function(extensions) {
        if (extensions !== "" && !(0, $3EnZW.isNullOrUndefined)(extensions)) this.element.setAttribute("accept", extensions);
        else this.element.removeAttribute("accept");
    };
    Uploader.prototype.templateComplier = function(uploadTemplate) {
        if (uploadTemplate) try {
            if (typeof uploadTemplate !== "function" && (0, $4ZDHT.selectAll)(uploadTemplate, document).length) return (0, $c2qqN.compile)((0, $4ZDHT.select)(uploadTemplate, document).innerHTML.trim());
            else return (0, $c2qqN.compile)(uploadTemplate);
        } catch (exception) {
            return (0, $c2qqN.compile)(uploadTemplate);
        }
        return undefined;
    };
    Uploader.prototype.setRTL = function() {
        if (this.enableRtl) (0, $4ZDHT.addClass)([
            this.uploadWrapper
        ], $f606c23990200287$var$RTL);
        else (0, $4ZDHT.removeClass)([
            this.uploadWrapper
        ], $f606c23990200287$var$RTL);
    };
    Uploader.prototype.localizedTexts = function(localeText) {
        this.l10n.setLocale(this.locale);
        return this.l10n.getConstant(localeText);
    };
    Uploader.prototype.setControlStatus = function() {
        if (!this.enabled) {
            this.uploadWrapper.classList.add($f606c23990200287$var$DISABLED);
            this.element.setAttribute("disabled", "disabled");
            this.browseButton.setAttribute("disabled", "disabled");
            if (!(0, $3EnZW.isNullOrUndefined)(this.clearButton)) this.clearButton.setAttribute("disabled", "disabled");
            if (!(0, $3EnZW.isNullOrUndefined)(this.uploadButton)) this.uploadButton.setAttribute("disabled", "disabled");
        } else {
            if (this.uploadWrapper.classList.contains($f606c23990200287$var$DISABLED)) this.uploadWrapper.classList.remove($f606c23990200287$var$DISABLED);
            if (!(0, $3EnZW.isNullOrUndefined)(this.browseButton) && this.element.hasAttribute("disabled")) {
                this.element.removeAttribute("disabled");
                this.browseButton.removeAttribute("disabled");
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.clearButton) && this.clearButton.hasAttribute("disabled")) this.clearButton.removeAttribute("disabled");
            if (!(0, $3EnZW.isNullOrUndefined)(this.uploadButton) && this.uploadButton.hasAttribute("disabled")) this.uploadButton.hasAttribute("disabled");
        }
    };
    Uploader.prototype.checkHTMLAttributes = function(isDynamic) {
        var attributes = isDynamic ? (0, $3EnZW.isNullOrUndefined)(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) : [
            "accept",
            "multiple",
            "disabled"
        ];
        for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
            var prop = attributes_1[_i];
            if (!(0, $3EnZW.isNullOrUndefined)(this.element.getAttribute(prop))) switch(prop){
                case "accept":
                    if ((0, $3EnZW.isNullOrUndefined)(this.uploaderOptions) || this.uploaderOptions["allowedExtensions"] === undefined || isDynamic) {
                        this.setProperties({
                            allowedExtensions: this.element.getAttribute("accept")
                        }, !isDynamic);
                        this.initialAttr.accept = this.allowedExtensions;
                    }
                    break;
                case "multiple":
                    if ((0, $3EnZW.isNullOrUndefined)(this.uploaderOptions) || this.uploaderOptions["multiple"] === undefined || isDynamic) {
                        var isMutiple = this.element.getAttribute(prop) === "multiple" || this.element.getAttribute(prop) === "" || this.element.getAttribute(prop) === "true" ? true : false;
                        this.setProperties({
                            multiple: isMutiple
                        }, !isDynamic);
                        this.initialAttr.multiple = true;
                    }
                    break;
                case "disabled":
                    if ((0, $3EnZW.isNullOrUndefined)(this.uploaderOptions) || this.uploaderOptions["enabled"] === undefined || isDynamic) {
                        var isDisabled = this.element.getAttribute(prop) === "disabled" || this.element.getAttribute(prop) === "" || this.element.getAttribute(prop) === "true" ? false : true;
                        this.setProperties({
                            enabled: isDisabled
                        }, !isDynamic);
                        this.initialAttr.disabled = true;
                    }
            }
        }
    };
    Uploader.prototype.chunkUpload = function(file, custom, fileIndex) {
        var start = 0;
        var end = Math.min(this.asyncSettings.chunkSize, file.size);
        var index = 0;
        var blob = file.rawFile.slice(start, end);
        var metaData = {
            chunkIndex: index,
            blob: blob,
            file: file,
            start: start,
            end: end,
            retryCount: 0,
            request: null
        };
        this.sendRequest(file, metaData, custom, fileIndex);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.sendRequest = function(file, metaData, custom, fileIndex) {
        var _this = this;
        var formData = new FormData();
        var blob = file.rawFile.slice(metaData.start, metaData.end);
        formData.append(this.uploaderName, blob, file.name);
        formData.append("chunk-index", metaData.chunkIndex.toString());
        formData.append("chunkIndex", metaData.chunkIndex.toString());
        var totalChunk = Math.max(Math.ceil(file.size / this.asyncSettings.chunkSize), 1);
        formData.append("total-chunk", totalChunk.toString());
        formData.append("totalChunk", totalChunk.toString());
        var ajax = new (0, $cfGuF.Ajax)({
            url: this.asyncSettings.saveUrl,
            type: "POST",
            async: true,
            contentType: null
        });
        ajax.emitError = false;
        ajax.onLoad = function(e) {
            _this.chunkUploadComplete(e, metaData, custom);
            return {};
        };
        ajax.onUploadProgress = function(e) {
            _this.chunkUploadInProgress(e, metaData, custom);
            return {};
        };
        var eventArgs = {
            fileData: file,
            customFormData: [],
            cancel: false,
            chunkSize: this.asyncSettings.chunkSize === 0 ? null : this.asyncSettings.chunkSize
        };
        ajax.beforeSend = function(e) {
            eventArgs.currentRequest = ajax.httpRequest;
            eventArgs.currentChunkIndex = metaData.chunkIndex;
            if (eventArgs.currentChunkIndex === 0) // This event is currently not required but to avoid breaking changes for previous customer, we have included.
            _this.trigger("uploading", eventArgs, function(eventArgs) {
                _this.uploadingEventCallback(formData, eventArgs, e, file);
            });
            else _this.trigger("chunkUploading", eventArgs, function(eventArgs) {
                _this.uploadingEventCallback(formData, eventArgs, e, file);
            });
        };
        /* istanbul ignore next */ ajax.onError = function(e) {
            _this.chunkUploadFailed(e, metaData, custom);
            return {};
        };
        ajax.send(formData);
        metaData.request = ajax;
    };
    Uploader.prototype.uploadingEventCallback = function(formData, eventArgs, e, file) {
        if (eventArgs.cancel) this.eventCancelByArgs(e, eventArgs, file);
        else this.updateFormData(formData, eventArgs.customFormData);
    };
    Uploader.prototype.eventCancelByArgs = function(e, eventArgs, file) {
        var _this = this;
        e.cancel = true;
        if (eventArgs.fileData.statusCode === "5") return;
        eventArgs.fileData.statusCode = "5";
        eventArgs.fileData.status = this.localizedTexts("fileUploadCancel");
        var liElement = this.getLiElement(eventArgs.fileData);
        if (liElement) {
            if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$STATUS))) {
                liElement.querySelector("." + $f606c23990200287$var$STATUS).innerHTML = this.localizedTexts("fileUploadCancel");
                liElement.querySelector("." + $f606c23990200287$var$STATUS).classList.add($f606c23990200287$var$UPLOAD_FAILED);
            }
            this.pauseButton = this.createElement("span", {
                className: "e-icons e-file-reload-btn",
                attrs: {
                    "tabindex": this.btnTabIndex
                }
            });
            var removeIcon = liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON);
            if (removeIcon) removeIcon.parentElement.insertBefore(this.pauseButton, removeIcon);
            this.pauseButton.setAttribute("title", this.localizedTexts("retry"));
            /* istanbul ignore next */ this.pauseButton.addEventListener("click", function(e) {
                _this.reloadcanceledFile(e, file, liElement);
            }, false);
            this.checkActionButtonStatus();
        }
    };
    Uploader.prototype.checkChunkUpload = function() {
        return this.asyncSettings.chunkSize <= 0 || (0, $3EnZW.isNullOrUndefined)(this.asyncSettings.chunkSize) ? false : true;
    };
    Uploader.prototype.chunkUploadComplete = function(e, metaData, custom) {
        var _this = this;
        var response = e.target;
        var liElement;
        if (response.readyState === 4 && response.status >= 200 && response.status < 300) {
            var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
            var totalChunk = Math.max(Math.ceil(metaData.file.size / this.asyncSettings.chunkSize), 1);
            var eventArgs = {
                event: e,
                file: metaData.file,
                chunkIndex: metaData.chunkIndex,
                totalChunk: totalChunk,
                chunkSize: this.asyncSettings.chunkSize,
                response: requestResponse
            };
            this.trigger("chunkSuccess", eventArgs);
            if ((0, $3EnZW.isNullOrUndefined)(custom) || !custom) liElement = this.getLiElement(metaData.file);
            this.updateMetaData(metaData);
            if (metaData.end === metaData.file.size) metaData.file.statusCode = "3";
            if (metaData.file.statusCode === "5") {
                var eventArgs_1 = {
                    event: e,
                    fileData: metaData.file,
                    cancel: false,
                    customFormData: []
                };
                this.trigger("canceling", eventArgs_1, function(eventArgs) {
                    /* istanbul ignore next */ if (eventArgs.cancel) {
                        metaData.file.statusCode = "3";
                        var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
                        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && !(0, $3EnZW.isNullOrUndefined)(spinnerTarget)) {
                            (0, $d4834c37f505aa74$export$95fec50f68454318)(spinnerTarget);
                            (0, $4ZDHT.detach)(liElement.querySelector(".e-spinner-pane"));
                        }
                        _this.sendNextRequest(metaData);
                    } else {
                        metaData.request.emitError = false;
                        response.abort();
                        var formData = new FormData();
                        var name_2 = _this.element.getAttribute("name");
                        formData.append(name_2, metaData.file.name);
                        formData.append("cancel-uploading", metaData.file.name);
                        formData.append("cancelUploading", metaData.file.name);
                        _this.updateFormData(formData, eventArgs.customFormData);
                        var ajax = new (0, $cfGuF.Ajax)(_this.asyncSettings.removeUrl, "POST", true, null);
                        ajax.emitError = false;
                        ajax.onLoad = function(e) {
                            _this.removeChunkFile(e, metaData, custom);
                            return {};
                        };
                        ajax.send(formData);
                    }
                });
            } else {
                if (totalChunk - 1 === metaData.chunkIndex && totalChunk > metaData.chunkIndex) {
                    var index = this.pausedData.indexOf(metaData);
                    if (index >= 0) this.pausedData.splice(index, 1);
                    if ((0, $3EnZW.isNullOrUndefined)(this.template) && ((0, $3EnZW.isNullOrUndefined)(custom) || !custom) && liElement) {
                        if (liElement && !(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD))) (0, $4ZDHT.detach)(liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD));
                        this.removeChunkProgressBar(metaData);
                    }
                    this.raiseSuccessEvent(e, metaData.file);
                    return;
                }
                if (metaData.file.statusCode !== "4") this.sendNextRequest(metaData);
            }
        } else this.chunkUploadFailed(e, metaData);
    };
    Uploader.prototype.sendNextRequest = function(metaData) {
        metaData.start = metaData.end;
        metaData.end += this.asyncSettings.chunkSize;
        metaData.end = Math.min(metaData.end, metaData.file.size);
        metaData.chunkIndex += 1;
        this.sendRequest(metaData.file, metaData);
    };
    Uploader.prototype.removeChunkFile = function(e, metaData, custom) {
        if ((0, $3EnZW.isNullOrUndefined)(this.template) && (0, $3EnZW.isNullOrUndefined)(custom) && !custom) {
            var liElement = this.getLiElement(metaData.file);
            var deleteIcon = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
            var spinnerTarget = deleteIcon;
            this.updateStatus(metaData.file, this.localizedTexts("fileUploadCancel"), "5");
            this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_FAILED);
            this.removeProgressbar(liElement, "failure");
            if (deleteIcon) {
                deleteIcon.classList.remove($f606c23990200287$var$ABORT_ICON);
                deleteIcon.classList.add($f606c23990200287$var$REMOVE_ICON);
                deleteIcon.setAttribute("title", this.localizedTexts("remove"));
            }
            var pauseIcon = liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD);
            if (pauseIcon) {
                pauseIcon.classList.add($f606c23990200287$var$RETRY_ICON);
                pauseIcon.classList.remove($f606c23990200287$var$PAUSE_UPLOAD);
                pauseIcon.setAttribute("title", this.localizedTexts("retry"));
            }
            if (!(0, $3EnZW.isNullOrUndefined)(liElement) && !(0, $3EnZW.isNullOrUndefined)(deleteIcon) && !(0, $3EnZW.isNullOrUndefined)(liElement.querySelector(".e-spinner-pane"))) {
                (0, $d4834c37f505aa74$export$95fec50f68454318)(spinnerTarget);
                (0, $4ZDHT.detach)(liElement.querySelector(".e-spinner-pane"));
            }
        }
    };
    Uploader.prototype.pauseUpload = function(metaData, e, custom) {
        metaData.file.statusCode = "4";
        metaData.file.status = this.localizedTexts("pause");
        this.updateMetaData(metaData);
        var eventArgs = {
            event: e ? e : null,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            chunkCount: Math.round(metaData.file.size / this.asyncSettings.chunkSize),
            chunkSize: this.asyncSettings.chunkSize
        };
        this.abortUpload(metaData, custom, eventArgs);
    };
    Uploader.prototype.abortUpload = function(metaData, custom, eventArgs) {
        if (metaData.file.statusCode !== "4") {
            metaData.request.emitError = false;
            metaData.request.httpRequest.abort();
        }
        var liElement = this.getLiElement(metaData.file);
        if ((0, $3EnZW.isNullOrUndefined)(this.template) && ((0, $3EnZW.isNullOrUndefined)(custom) || !custom)) {
            var targetElement = liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD);
            targetElement.classList.remove($f606c23990200287$var$PAUSE_UPLOAD);
            targetElement.classList.add($f606c23990200287$var$RESUME_UPLOAD);
            targetElement.setAttribute("title", this.localizedTexts("resume"));
            targetElement.nextElementSibling.classList.add($f606c23990200287$var$REMOVE_ICON);
            targetElement.nextElementSibling.classList.remove($f606c23990200287$var$ABORT_ICON);
            targetElement.nextElementSibling.setAttribute("title", this.localizedTexts("remove"));
        }
        for(var i = 0; i < this.pausedData.length; i++)if (this.pausedData[i].file.name === metaData.file.name) this.pausedData.splice(i, 1);
        this.pausedData.push(metaData);
        this.trigger("pausing", eventArgs);
    };
    Uploader.prototype.resumeUpload = function(metaData, e, custom) {
        var liElement = this.getLiElement(metaData.file);
        var targetElement;
        if (!(0, $3EnZW.isNullOrUndefined)(liElement)) targetElement = liElement.querySelector("." + $f606c23990200287$var$RESUME_UPLOAD);
        if (!(0, $3EnZW.isNullOrUndefined)(targetElement) && ((0, $3EnZW.isNullOrUndefined)(custom) || !custom)) {
            targetElement.classList.remove($f606c23990200287$var$RESUME_UPLOAD);
            targetElement.classList.add($f606c23990200287$var$PAUSE_UPLOAD);
            targetElement.setAttribute("title", this.localizedTexts("pause"));
            targetElement.nextElementSibling.classList.remove($f606c23990200287$var$REMOVE_ICON);
            targetElement.nextElementSibling.classList.add($f606c23990200287$var$ABORT_ICON);
            targetElement.nextElementSibling.setAttribute("title", this.localizedTexts("abort"));
        }
        metaData.file.status = this.localizedTexts("inProgress");
        metaData.file.statusCode = "3";
        this.updateMetaData(metaData);
        var eventArgs = {
            event: e ? e : null,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            chunkCount: Math.round(metaData.file.size / this.asyncSettings.chunkSize),
            chunkSize: this.asyncSettings.chunkSize
        };
        this.trigger("resuming", eventArgs);
        for(var i = 0; i < this.pausedData.length; i++){
            if (this.pausedData[i].end === this.pausedData[i].file.size) this.chunkUploadComplete(e, metaData, custom);
            else if (this.pausedData[i].file.name === metaData.file.name) {
                this.pausedData[i].start = this.pausedData[i].end;
                this.pausedData[i].end = this.pausedData[i].end + this.asyncSettings.chunkSize;
                this.pausedData[i].end = Math.min(this.pausedData[i].end, this.pausedData[i].file.size);
                this.pausedData[i].chunkIndex = this.pausedData[i].chunkIndex + 1;
                this.sendRequest(this.pausedData[i].file, this.pausedData[i], custom);
            }
        }
    };
    Uploader.prototype.updateMetaData = function(metaData) {
        if (this.uploadMetaData.indexOf(metaData) === -1) this.uploadMetaData.push(metaData);
        else {
            this.uploadMetaData.splice(this.uploadMetaData.indexOf(metaData), 1);
            this.uploadMetaData.push(metaData);
        }
    };
    Uploader.prototype.removeChunkProgressBar = function(metaData) {
        var liElement = this.getLiElement(metaData.file);
        if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
            this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_SUCCESS);
            this.removeProgressbar(liElement, "success");
            var cancelButton = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
            if (!(0, $3EnZW.isNullOrUndefined)(cancelButton)) {
                cancelButton.classList.add($f606c23990200287$var$DELETE_ICON);
                cancelButton.setAttribute("title", this.localizedTexts("delete"));
                cancelButton.classList.remove($f606c23990200287$var$ABORT_ICON, $f606c23990200287$var$UPLOAD_INPROGRESS);
            }
        }
    };
    Uploader.prototype.chunkUploadFailed = function(e, metaData, custom) {
        var _this = this;
        var chunkCount = Math.max(Math.ceil(metaData.file.size / this.asyncSettings.chunkSize), 1);
        var liElement;
        if ((0, $3EnZW.isNullOrUndefined)(this.template) && ((0, $3EnZW.isNullOrUndefined)(custom) || !custom)) liElement = this.getLiElement(metaData.file);
        var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
        var eventArgs = {
            event: e,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            totalChunk: chunkCount,
            chunkSize: this.asyncSettings.chunkSize,
            cancel: false,
            response: requestResponse
        };
        this.trigger("chunkFailure", eventArgs, function(eventArgs) {
            // To prevent triggering of failure event
            if (!eventArgs.cancel) {
                if (metaData.retryCount < _this.asyncSettings.retryCount) setTimeout(function() {
                    _this.retryRequest(liElement, metaData, custom);
                }, _this.asyncSettings.retryAfterDelay);
                else {
                    if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
                        var pauseButton = liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD) ? liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD) : liElement.querySelector("." + $f606c23990200287$var$RESUME_UPLOAD);
                        if (!(0, $3EnZW.isNullOrUndefined)(pauseButton)) {
                            pauseButton.classList.add($f606c23990200287$var$RETRY_ICON);
                            pauseButton.classList.remove($f606c23990200287$var$PAUSE_UPLOAD, $f606c23990200287$var$RESUME_UPLOAD);
                        }
                        _this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_FAILED);
                        _this.removeProgressbar(liElement, "failure");
                        liElement.querySelector(".e-icons").classList.remove($f606c23990200287$var$UPLOAD_INPROGRESS);
                        var iconElement = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON) ? liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON) : liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON);
                        iconElement.classList.remove($f606c23990200287$var$ABORT_ICON);
                        if (!(0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD))) (0, $4ZDHT.detach)(liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD));
                        if (metaData.start > 0) {
                            iconElement.classList.add($f606c23990200287$var$DELETE_ICON);
                            iconElement.setAttribute("title", _this.localizedTexts("delete"));
                        } else {
                            iconElement.classList.add($f606c23990200287$var$REMOVE_ICON);
                            iconElement.setAttribute("title", _this.localizedTexts("remove"));
                        }
                    }
                    metaData.retryCount = 0;
                    var file_1 = metaData.file;
                    var failureMessage = _this.localizedTexts("uploadFailedMessage");
                    var args = {
                        e: e,
                        response: requestResponse,
                        operation: "upload",
                        file: _this.updateStatus(file_1, failureMessage, "0", false),
                        statusText: failureMessage
                    };
                    _this.trigger("failure", args, function(args) {
                        _this.updateStatus(file_1, args.statusText, "0");
                        _this.uploadSequential();
                        _this.checkActionComplete(true);
                    });
                }
            }
        });
    };
    Uploader.prototype.retryRequest = function(liElement, metaData, custom) {
        if ((0, $3EnZW.isNullOrUndefined)(this.template) && ((0, $3EnZW.isNullOrUndefined)(custom) || !custom) && liElement) this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_FAILED);
        metaData.retryCount += 1;
        this.sendRequest(metaData.file, metaData);
    };
    Uploader.prototype.checkPausePlayAction = function(e) {
        var targetElement = e.target;
        var selectedElement = e.target.parentElement;
        var index = this.fileList.indexOf(selectedElement);
        var fileData = this.filesData[index];
        var metaData = this.getCurrentMetaData(fileData);
        if (targetElement.classList.contains($f606c23990200287$var$PAUSE_UPLOAD)) /* istanbul ignore next */ this.pauseUpload(metaData, e);
        else if (targetElement.classList.contains($f606c23990200287$var$RESUME_UPLOAD)) /* istanbul ignore next */ this.resumeUpload(metaData, e);
        else if (targetElement.classList.contains($f606c23990200287$var$RETRY_ICON)) {
            if (metaData.file.status === this.localizedTexts("fileUploadCancel")) this.retryUpload(metaData, false);
            else this.retryUpload(metaData, true);
        }
    };
    Uploader.prototype.retryUpload = function(metaData, fromcanceledStage) {
        if (fromcanceledStage) {
            metaData.end = metaData.end + this.asyncSettings.chunkSize;
            metaData.start = metaData.start + this.asyncSettings.chunkSize;
            this.sendRequest(metaData.file, metaData);
        } else {
            metaData.file.statusCode = "1";
            metaData.file.status = this.localizedTexts("readyToUploadMessage");
            this.chunkUpload(metaData.file);
        }
        /* istanbul ignore next */ this.getLiElement(metaData.file).classList.add($f606c23990200287$var$RESTRICT_RETRY);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.chunkUploadInProgress = function(e, metaData, custom) {
        var _this = this;
        if (metaData.file.statusCode === "4") return;
        if (metaData.file.statusCode !== "4" && metaData.file.statusCode !== "5") {
            metaData.file.statusCode = "3";
            metaData.file.status = this.localizedTexts("inProgress");
        }
        this.updateMetaData(metaData);
        var liElement = this.getLiElement(metaData.file);
        if ((0, $3EnZW.isNullOrUndefined)(liElement)) return;
        var retryElement = liElement.querySelector("." + $f606c23990200287$var$RETRY_ICON);
        if (!(0, $3EnZW.isNullOrUndefined)(retryElement)) {
            retryElement.classList.add($f606c23990200287$var$PAUSE_UPLOAD);
            retryElement.setAttribute("title", this.localizedTexts("pause"));
            retryElement.classList.remove($f606c23990200287$var$RETRY_ICON);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
            if (!(liElement.querySelectorAll("." + $f606c23990200287$var$PROGRESS_WRAPPER).length > 0)) {
                var statusElement = liElement.querySelector("." + $f606c23990200287$var$STATUS);
                if ((0, $3EnZW.isNullOrUndefined)(this.template)) {
                    statusElement.classList.add($f606c23990200287$var$UPLOAD_INPROGRESS);
                    statusElement.classList.remove($f606c23990200287$var$UPLOAD_FAILED);
                    this.createProgressBar(liElement);
                    this.updateProgressBarClasses(liElement, $f606c23990200287$var$UPLOAD_INPROGRESS);
                }
                var clearIcon = liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON) ? liElement.querySelector("." + $f606c23990200287$var$REMOVE_ICON) : liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON);
                if (!(0, $3EnZW.isNullOrUndefined)(clearIcon)) {
                    clearIcon.classList.add($f606c23990200287$var$ABORT_ICON);
                    clearIcon.setAttribute("title", this.localizedTexts("abort"));
                    clearIcon.classList.remove($f606c23990200287$var$REMOVE_ICON);
                }
            }
            if (!isNaN(Math.round(e.loaded / e.total * 100)) && (0, $3EnZW.isNullOrUndefined)(this.template) && metaData.file.statusCode !== "4") {
                var progressVal = void 0;
                var totalChunks = Math.ceil(metaData.file.size / this.asyncSettings.chunkSize) - 1;
                if (this.asyncSettings.chunkSize && totalChunks) {
                    progressVal = Math.round(metaData.chunkIndex / totalChunks * 100);
                    this.changeProgressValue(liElement, progressVal.toString() + "%");
                }
            }
            if (metaData.chunkIndex === 0) this.checkActionButtonStatus();
        }
        if ((0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$PAUSE_UPLOAD)) && (0, $3EnZW.isNullOrUndefined)(this.template) && (0, $3EnZW.isNullOrUndefined)(liElement.querySelector("." + $f606c23990200287$var$DELETE_ICON))) {
            this.pauseButton = this.createElement("span", {
                className: "e-icons e-file-pause-btn",
                attrs: {
                    "tabindex": this.btnTabIndex
                }
            });
            if (this.browserName === "msie") this.pauseButton.classList.add("e-msie");
            var abortIcon = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
            abortIcon.parentElement.insertBefore(this.pauseButton, abortIcon);
            this.pauseButton.setAttribute("title", this.localizedTexts("pause"));
            this.pauseButton.addEventListener("click", function(e) {
                _this.checkPausePlayAction(e);
            }, false);
        }
    };
    /**
     * It is used to convert bytes value into kilobytes or megabytes depending on the size based
     * on [binary prefix](https://en.wikipedia.org/wiki/Binary_prefix).
     *
     * @param { number } bytes - Specifies the file size in bytes.
     * @returns {string} - Returns the file size.
     */ Uploader.prototype.bytesToSize = function(bytes) {
        var i = -1;
        if (!bytes) return "0.0 KB";
        do {
            bytes = bytes / 1024;
            i++;
        }while (bytes > 99);
        if (i >= 2) {
            bytes = bytes * 1024;
            i = 1;
        }
        return Math.max(bytes, 0).toFixed(1) + " " + [
            "KB",
            "MB"
        ][i];
    };
    /**
     * Allows you to sort the file data alphabetically based on its file name clearly.
     *
     * @param { FileList } filesData - specifies the files data for upload.
     * @returns {File[]}
     */ /* istanbul ignore next */ Uploader.prototype.sortFileList = function(filesData) {
        filesData = filesData ? filesData : this.sortFilesList;
        var files = filesData;
        var fileNames = [];
        for(var i = 0; i < files.length; i++)fileNames.push(files[i].name);
        var sortedFileNames = fileNames.sort();
        var sortedFilesData = [];
        for(var _i = 0, sortedFileNames_1 = sortedFileNames; _i < sortedFileNames_1.length; _i++){
            var name_3 = sortedFileNames_1[_i];
            for(var i = 0; i < files.length; i++)if (name_3 === files[i].name) sortedFilesData.push(files[i]);
        }
        return sortedFilesData;
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ Uploader.prototype.destroy = function() {
        this.element.value = null;
        this.clearTemplate();
        this.clearAll();
        this.unWireEvents();
        this.unBindDropEvents();
        if (this.multiple) this.element.removeAttribute("multiple");
        if (!this.enabled) this.element.removeAttribute("disabled");
        this.element.removeAttribute("accept");
        this.setInitialAttributes();
        var attributes = [
            "aria-label",
            "directory",
            "webkitdirectory",
            "tabindex"
        ];
        for(var _i = 0, attributes_2 = attributes; _i < attributes_2.length; _i++){
            var key = attributes_2[_i];
            this.element.removeAttribute(key);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.uploadWrapper)) {
            this.uploadWrapper.parentElement.appendChild(this.element);
            (0, $4ZDHT.detach)(this.uploadWrapper);
        }
        this.uploadWrapper = null;
        this.uploadWrapper = null;
        this.browseButton = null;
        this.dropAreaWrapper = null;
        this.dropZoneElement = null;
        this.dropArea = null;
        this.keyboardModule = null;
        this.clearButton = null;
        this.uploadButton = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Allows you to call the upload process manually by calling save URL action.
     * To process the selected files (added in upload queue), pass an empty argument otherwise
     * upload the specific file based on its argument.
     *
     * @param { FileInfo | FileInfo[] } files - Specifies the files data for upload.
     * @param {boolean} custom - Specifies whether the uploader is rendered with custom file list.
     * @returns {void}
     */ Uploader.prototype.upload = function(files, custom) {
        var _this = this;
        files = files ? files : this.filesData;
        if (this.sequentialUpload && (this.isFirstFileOnSelection || custom)) this.sequenceUpload(files);
        else {
            var uploadFiles_1 = this.getFilesInArray(files);
            var eventArgs = {
                customFormData: [],
                currentRequest: null,
                cancel: false
            };
            this.trigger("beforeUpload", eventArgs, function(eventArgs) {
                if (!eventArgs.cancel) _this.uploadFiles(uploadFiles_1, custom);
            });
        }
    };
    Uploader.prototype.getFilesInArray = function(files) {
        var uploadFiles = [];
        if (files instanceof Array) uploadFiles = files;
        else uploadFiles.push(files);
        return uploadFiles;
    };
    /* istanbul ignore next */ Uploader.prototype.serverReadFileBase64 = function(fileIndex, position, totalCount) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var file = _this.fileStreams[fileIndex].rawFile;
            try {
                var reader = new FileReader();
                reader.onload = function(args) {
                    return function() {
                        try {
                            var contents = args.result;
                            var data = contents ? contents.split(";base64,")[1] : null;
                            resolve(data);
                        } catch (e) {
                            reject(e);
                        }
                    };
                }(reader);
                reader.readAsDataURL(file.slice(position, position + totalCount));
            } catch (e) {
                reject(e);
            }
        });
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ /* istanbul ignore next */ Uploader.prototype.uploadFileCount = function(ele) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ var files = this.filesData;
        if (!files || files.length === 0) return -1;
        var result = files.length;
        return result;
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */ /* istanbul ignore next */ Uploader.prototype.getFileRead = function(index, ele) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ var files = this.filesData;
        if (!files || files.length === 0) return -1;
        var file = files[index];
        var fileCount = this.newFileRef++;
        this.fileStreams[fileCount] = file;
        return fileCount;
    };
    Uploader.prototype.uploadFiles = function(files, custom) {
        var selectedFiles = [];
        if (this.asyncSettings.saveUrl === "" || (0, $3EnZW.isNullOrUndefined)(this.asyncSettings.saveUrl)) return;
        if (!custom || (0, $3EnZW.isNullOrUndefined)(custom)) {
            if (!this.multiple) {
                var file = [];
                file.push(files[0]);
                selectedFiles = this.filterfileList(file);
            } else selectedFiles = this.filterfileList(files);
        } else selectedFiles = files;
        for(var i = 0; i < selectedFiles.length; i++)this.uploadFilesRequest(selectedFiles, i, custom);
    };
    Uploader.prototype.uploadFilesRequest = function(selectedFiles, i, custom) {
        var _this = this;
        var chunkEnabled = this.checkChunkUpload();
        var ajax = new (0, $cfGuF.Ajax)(this.asyncSettings.saveUrl, "POST", true, null);
        ajax.emitError = false;
        var eventArgs = {
            fileData: selectedFiles[i],
            customFormData: [],
            cancel: false
        };
        var formData = new FormData();
        ajax.beforeSend = function(e) {
            eventArgs.currentRequest = ajax.httpRequest;
            _this.trigger("uploading", eventArgs, function(eventArgs) {
                /* istanbul ignore next */ if (eventArgs.cancel) _this.eventCancelByArgs(e, eventArgs, selectedFiles[i]);
                _this.updateFormData(formData, eventArgs.customFormData);
            });
        };
        if (selectedFiles[i].statusCode === "1") {
            var name_4 = this.element.getAttribute("name");
            formData.append(name_4, selectedFiles[i].rawFile, selectedFiles[i].name);
            if (chunkEnabled && selectedFiles[i].size > this.asyncSettings.chunkSize) this.chunkUpload(selectedFiles[i], custom, i);
            else {
                ajax.onLoad = function(e) {
                    if (eventArgs.cancel) return {};
                    else {
                        _this.uploadComplete(e, selectedFiles[i], custom);
                        return {};
                    }
                };
                ajax.onUploadProgress = function(e) {
                    if (eventArgs.cancel) return {};
                    else {
                        _this.uploadInProgress(e, selectedFiles[i], custom, ajax);
                        return {};
                    }
                };
                /* istanbul ignore next */ ajax.onError = function(e) {
                    _this.uploadFailed(e, selectedFiles[i]);
                    return {};
                };
                ajax.send(formData);
            }
        }
    };
    Uploader.prototype.spliceFiles = function(liIndex) {
        var liElement = this.fileList[liIndex];
        var allFiles = this.getFilesData();
        var nameElements = +liElement.getAttribute("data-files-count");
        var startIndex = 0;
        for(var i = 0; i < liIndex; i++)startIndex += +this.fileList[i].getAttribute("data-files-count");
        var endIndex = startIndex + nameElements - 1;
        for(var j = endIndex; j >= startIndex; j--)allFiles.splice(j, 1);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Remove the uploaded file from server manually by calling the remove URL action.
     * If you pass an empty argument to this method, the complete file list can be cleared,
     * otherwise remove the specific file based on its argument (“file_data”).
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to remove from file list/server.
     * @param { boolean } customTemplate - Set true if the component rendering with customize template.
     * @param { boolean } removeDirectly - Set true if files remove without removing event.
     * @param { boolean } postRawFile - Set false, to post file name only to the remove action.
     * @returns {void}
     */ Uploader.prototype.remove = function(fileData, customTemplate, removeDirectly, postRawFile, args) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(postRawFile)) postRawFile = true;
        var eventArgs = {
            event: args,
            cancel: false,
            filesData: [],
            customFormData: [],
            postRawFile: postRawFile,
            currentRequest: null
        };
        var beforeEventArgs = {
            cancel: false,
            customFormData: [],
            currentRequest: null
        };
        this.trigger("beforeRemove", beforeEventArgs, function(beforeEventArgs) {
            if (!beforeEventArgs.cancel) {
                if (_this.isFormUpload()) {
                    eventArgs.filesData = fileData;
                    _this.trigger("removing", eventArgs, function(eventArgs) {
                        if (!eventArgs.cancel) {
                            var removingFiles = _this.getFilesInArray(fileData);
                            var isLiRemoved = false;
                            var liIndex = void 0;
                            for(var _i = 0, removingFiles_1 = removingFiles; _i < removingFiles_1.length; _i++){
                                var data = removingFiles_1[_i];
                                if (!isLiRemoved) liIndex = _this.fileList.indexOf(data.list);
                                if (liIndex > -1) {
                                    var inputElement = !(0, $3EnZW.isNullOrUndefined)(data.input) ? data.input : null;
                                    if (inputElement) (0, $4ZDHT.detach)(inputElement);
                                    _this.spliceFiles(liIndex);
                                    (0, $4ZDHT.detach)(_this.fileList[liIndex]);
                                    _this.fileList.splice(liIndex, 1);
                                    isLiRemoved = true;
                                    liIndex = -1;
                                }
                            }
                        }
                    });
                } else if (_this.isForm && ((0, $3EnZW.isNullOrUndefined)(_this.asyncSettings.removeUrl) || _this.asyncSettings.removeUrl === "")) {
                    eventArgs.filesData = _this.getFilesData();
                    _this.trigger("removing", eventArgs, function(eventArgs) {
                        if (!eventArgs.cancel) _this.clearAll();
                    });
                } else {
                    var removeFiles = [];
                    fileData = !(0, $3EnZW.isNullOrUndefined)(fileData) ? fileData : _this.filesData;
                    if (fileData instanceof Array) removeFiles = fileData;
                    else removeFiles.push(fileData);
                    eventArgs.filesData = removeFiles;
                    var removeUrl = _this.asyncSettings.removeUrl;
                    var validUrl = removeUrl === "" || (0, $3EnZW.isNullOrUndefined)(removeUrl) ? false : true;
                    var _loop_5 = function(files) {
                        var fileUploadedIndex = _this.uploadedFilesData.indexOf(files);
                        if ((files.statusCode === "2" || files.statusCode === "4" || files.statusCode === "0" && fileUploadedIndex !== -1) && validUrl) _this.removeUploadedFile(files, eventArgs, removeDirectly, customTemplate);
                        else if (!removeDirectly) _this.trigger("removing", eventArgs, function(eventArgs) {
                            if (!eventArgs.cancel) _this.removeFilesData(files, customTemplate);
                        });
                        else _this.removeFilesData(files, customTemplate);
                        if (args && !args.target.classList.contains($f606c23990200287$var$REMOVE_ICON)) _this.checkActionComplete(false);
                    };
                    for(var _i = 0, removeFiles_1 = removeFiles; _i < removeFiles_1.length; _i++){
                        var files = removeFiles_1[_i];
                        _loop_5(files);
                    }
                }
            }
        });
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-param */ /**
     * Clear all the file entries from list that can be uploaded files or added in upload queue.
     *
     * @returns {void}
     */ Uploader.prototype.clearAll = function() {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(this.listParent)) {
            if (this.browserName !== "msie") this.element.value = "";
            this.filesData = [];
            return;
        }
        var eventArgs = {
            cancel: false,
            filesData: this.filesData
        };
        this.trigger("clearing", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel) {
                _this.clearData();
                _this.actionCompleteCount = 0;
                _this.count = -1;
            }
        });
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Get the data of files which are shown in file list.
     *
     * @param { number } index - specifies the file list item(li) index.
     * @returns {FileInfo[]}
     */ Uploader.prototype.getFilesData = function(index) {
        if ((0, $3EnZW.isNullOrUndefined)(index)) return this.filesData;
        else return this.getSelectedFiles(index);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */ /**
     * Pauses the in-progress chunked upload based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to pause from uploading.
     * @param { boolean } custom - Set true if used custom UI.
     * @returns {void}
     */ Uploader.prototype.pause = function(fileData, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        this.pauseUploading(fileDataFiles, custom);
    };
    Uploader.prototype.pauseUploading = function(fileData, custom) {
        var files = this.getFiles(fileData);
        for(var i = 0; i < files.length; i++)if (files[i].statusCode === "3") this.pauseUpload(this.getCurrentMetaData(files[i], null), null, custom);
    };
    Uploader.prototype.getFiles = function(fileData) {
        var files = [];
        if (!(0, $3EnZW.isNullOrUndefined)(fileData) && !(fileData instanceof Array)) files.push(fileData);
        else files = fileData;
        return files;
    };
    /**
     * Resumes the chunked upload that is previously paused based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to resume the paused file.
     * @param { boolean } custom - Set true if used custom UI.
     * @returns {void}
     */ Uploader.prototype.resume = function(fileData, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        this.resumeFiles(fileDataFiles, custom);
    };
    Uploader.prototype.resumeFiles = function(fileData, custom) {
        var files = this.getFiles(fileData);
        for(var i = 0; i < files.length; i++)if (files[i].statusCode === "4") this.resumeUpload(this.getCurrentMetaData(files[i], null), null, custom);
    };
    /**
     * Retries the canceled or failed file upload based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to retry the canceled or failed file.
     * @param { boolean } fromcanceledStage - Set true to retry from canceled stage and set false to retry from initial stage.
     * @param {boolean} custom -Specifies whether the uploader is rendered with custom file list.
     * @returns {void}
     */ Uploader.prototype.retry = function(fileData, fromcanceledStage, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        if (this.sequentialUpload && this.isFirstFileOnSelection) this.isFirstFileOnSelection = false;
        this.retryFailedFiles(fileDataFiles, fromcanceledStage, custom);
    };
    Uploader.prototype.retryFailedFiles = function(fileData, fromcanceledStage, custom) {
        var files = this.getFiles(fileData);
        for(var i = 0; i < files.length; i++)if (files[i].statusCode === "5" || files[i].statusCode === "0") {
            if (this.asyncSettings.chunkSize > 0 && this.getCurrentMetaData(files[i], null)) this.retryUpload(this.getCurrentMetaData(files[i], null), fromcanceledStage);
            else {
                var liElement = void 0;
                if (!custom) liElement = this.fileList[this.filesData.indexOf(files[i])];
                this.reloadcanceledFile(null, files[i], liElement, custom);
            }
        }
    };
    /**
     * Stops the in-progress chunked upload based on the file data.
     * When the file upload is canceled, the partially uploaded file is removed from server.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to cancel the progressing file.
     * @returns {void}
     */ Uploader.prototype.cancel = function(fileData) {
        fileData = fileData ? fileData : this.filesData;
        var cancelingFiles = this.getFilesInArray(fileData);
        this.cancelUpload(cancelingFiles);
    };
    Uploader.prototype.cancelUpload = function(fileData) {
        var files = this.getFiles(fileData);
        if (this.asyncSettings.chunkSize > 0) {
            for(var i = 0; i < files.length; i++)if (files[i].statusCode === "3") {
                var metaData = this.getCurrentMetaData(files[i], null);
                metaData.file.statusCode = "5";
                metaData.file.status = this.localizedTexts("fileUploadCancel");
                this.updateMetaData(metaData);
                this.showHideUploadSpinner(files[i]);
            }
        } else {
            for(var i = 0; i < files.length; i++)if (files[i].statusCode === "3") {
                files[i].statusCode = "5";
                files[i].status = this.localizedTexts("fileUploadCancel");
                this.showHideUploadSpinner(files[i]);
            }
        }
    };
    Uploader.prototype.showHideUploadSpinner = function(files) {
        var liElement = this.getLiElement(files);
        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && (0, $3EnZW.isNullOrUndefined)(this.template)) {
            var spinnerTarget = liElement.querySelector("." + $f606c23990200287$var$ABORT_ICON);
            (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                target: spinnerTarget,
                width: "20px"
            });
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(spinnerTarget);
        }
    };
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Complex)({
            saveUrl: "",
            removeUrl: ""
        }, $f606c23990200287$export$10a5207dbbf1d28f)
    ], Uploader.prototype, "asyncSettings", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Uploader.prototype, "sequentialUpload", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)({})
    ], Uploader.prototype, "htmlAttributes", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Uploader.prototype, "cssClass", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Uploader.prototype, "enabled", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Uploader.prototype, "template", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Uploader.prototype, "multiple", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Uploader.prototype, "autoUpload", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Uploader.prototype, "enableHtmlSanitizer", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Complex)({}, $f606c23990200287$export$580730e47dd9c4cc)
    ], Uploader.prototype, "buttons", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Uploader.prototype, "allowedExtensions", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Uploader.prototype, "minFileSize", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(30000000)
    ], Uploader.prototype, "maxFileSize", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Uploader.prototype, "dropArea", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], $f606c23990200287$export$7fb9d20f1c3d3d91)
    ], Uploader.prototype, "files", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Uploader.prototype, "showFileList", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Uploader.prototype, "directoryUpload", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Property)("Default")
    ], Uploader.prototype, "dropEffect", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "created", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "actionComplete", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "rendering", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "beforeUpload", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "fileListRendering", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "selected", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "uploading", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "success", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "failure", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "removing", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "beforeRemove", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "clearing", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "progress", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "change", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "chunkSuccess", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "chunkFailure", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "chunkUploading", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "canceling", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "pausing", void 0);
    $f606c23990200287$var$__decorate([
        (0, $5rsSz.Event)()
    ], Uploader.prototype, "resuming", void 0);
    Uploader = $f606c23990200287$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Uploader);
    return Uploader;
}((0, $hQxLN.Component));
 /* eslint-enable @typescript-eslint/no-explicit-any */ 


/**
 * Defines types of Render
 *
 * @hidden

 */ var $2eaa618655f536c2$export$ed706b0a66efb05c;
(function(RenderType) {
    /* eslint-disable */ /** Defines RenderType as Toolbar */ RenderType[RenderType["Toolbar"] = 0] = "Toolbar";
    /** Defines RenderType as Content */ RenderType[RenderType["Content"] = 1] = "Content";
    /** Defines RenderType as Popup */ RenderType[RenderType["Popup"] = 2] = "Popup";
    /** Defines RenderType as LinkToolbar */ RenderType[RenderType["LinkToolbar"] = 3] = "LinkToolbar";
    /** Defines RenderType as TextToolbar */ RenderType[RenderType["TextToolbar"] = 4] = "TextToolbar";
    /** Defines RenderType as ImageToolbar */ RenderType[RenderType["ImageToolbar"] = 5] = "ImageToolbar";
    /** Defines RenderType as AudioToolbar */ RenderType[RenderType["AudioToolbar"] = 6] = "AudioToolbar";
    /** Defines RenderType as AudioToolbar */ RenderType[RenderType["VideoToolbar"] = 7] = "VideoToolbar";
    /** Defines RenderType as InlineToolbar */ RenderType[RenderType["InlineToolbar"] = 8] = "InlineToolbar";
    /** Defines RenderType as TableToolbar */ RenderType[RenderType["TableToolbar"] = 9] = "TableToolbar";
/* eslint-enable */ })($2eaa618655f536c2$export$ed706b0a66efb05c || ($2eaa618655f536c2$export$ed706b0a66efb05c = {}));
var $2eaa618655f536c2$export$a5d11b3163e4b1a5;
(function(ToolbarType) {
    /* eslint-disable */ /** Defines ToolbarType as Standard */ ToolbarType["Expand"] = "Expand";
    /** Defines ToolbarType as MultiRow */ ToolbarType["MultiRow"] = "MultiRow";
    /** Defines ToolbarType as Scrollable */ ToolbarType["Scrollable"] = "Scrollable";
/* eslint-enable */ })($2eaa618655f536c2$export$a5d11b3163e4b1a5 || ($2eaa618655f536c2$export$a5d11b3163e4b1a5 = {}));
var $2eaa618655f536c2$export$290cb7291ee58b61;
(function(DialogType) {
    /* eslint-disable */ /** Defines ToolbarType as Standard */ DialogType["InsertLink"] = "InsertLink";
    /** Defines ToolbarType as MultiRow */ DialogType["InsertImage"] = "InsertImage";
    /** Defines DialogType as Audio*/ DialogType["InsertAudio"] = "InsertAudio";
    /** Defines DialogType as Video*/ DialogType["InsertVideo"] = "InsertVideo";
    /** Defines ToolbarType as Scrollable */ DialogType["InsertTable"] = "InsertTable";
/* eslint-enable */ })($2eaa618655f536c2$export$290cb7291ee58b61 || ($2eaa618655f536c2$export$290cb7291ee58b61 = {}));
var $2eaa618655f536c2$export$857a3989d2b808cc;
(function(ImageInputSource) {
    /** Defines ImageInputSource as Uploaded */ ImageInputSource["Uploaded"] = "Uploaded";
    /** Defines ImageInputSource as Dropped */ ImageInputSource["Dropped"] = "Dropped";
    /** Defines ImageInputSource as Pasted */ ImageInputSource["Pasted"] = "Pasted";
})($2eaa618655f536c2$export$857a3989d2b808cc || ($2eaa618655f536c2$export$857a3989d2b808cc = {}));


/**
 * Defines util methods used by Rich Text Editor.
 */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $3P3ke = parcelRequire("3P3ke");


/* eslint-disable */ /**
 * Export items model
 */ var $228f7f224d55f07b$export$eb8062f5486943a9 = [
    "alignments",
    "formats",
    "fontname",
    "fontsize",
    "fontcolor",
    "backgroundcolor",
    "align",
    "display",
    "audiolayoutoption",
    "videolayoutoption",
    "videoalign",
    "tablerows",
    "tablecolumns",
    "tablecell",
    "tablecellhorizontalalign",
    "tablecellverticalalign",
    "styles",
    "numberformatlist",
    "bulletformatlist"
];
var $228f7f224d55f07b$export$904054328df186b = {
    "alignments": {
        "id": "Alignments",
        "icon": "e-alignments",
        "tooltip": "Alignments",
        "command": "Alignments",
        "subCommand": "Alignments"
    },
    "justifyleft": {
        "id": "JustifyLeft",
        "icon": "e-justify-left",
        "tooltip": "JustifyLeft",
        "command": "Alignments",
        "subCommand": "JustifyLeft"
    },
    "justifycenter": {
        "id": "JustifyCenter",
        "icon": "e-justify-center",
        "tooltip": "JustifyCenter",
        "command": "Alignments",
        "subCommand": "JustifyCenter"
    },
    "justifyright": {
        "id": "JustifyRight",
        "icon": "e-justify-right",
        "tooltip": "JustifyRight",
        "command": "Alignments",
        "subCommand": "JustifyRight"
    },
    "justifyfull": {
        "id": "JustifyFull",
        "icon": "e-justify-full",
        "tooltip": "JustifyFull",
        "command": "Alignments",
        "subCommand": "JustifyFull"
    },
    "fontname": {
        "id": "FontName",
        "icon": "e-font-name",
        "tooltip": "Font Name",
        "command": "Font",
        "subCommand": "FontName"
    },
    "fontsize": {
        "id": "FontSize",
        "icon": "e-font-size",
        "tooltip": "Font Size",
        "command": "Font",
        "subCommand": "FontSize"
    },
    "fontcolor": {
        "id": "FontColor",
        "icon": "e-rte-font-color",
        "tooltip": "Font Color",
        "command": "Font",
        "subCommand": "FontColor",
        "value": "#ff0000ff"
    },
    "backgroundcolor": {
        "id": "BackgroundColor",
        "icon": "e-background-color",
        "tooltip": "Background Color",
        "command": "Font",
        "subCommand": "BackgroundColor",
        "value": "#ffff00ff"
    },
    "importword": {
        "id": "ImportWord",
        "icon": "e-rte-import-doc",
        "tooltip": "Import from Word",
        "command": "Import",
        "subCommand": "ImportWord"
    },
    "exportword": {
        "id": "ExportWord",
        "icon": "e-rte-export-doc",
        "tooltip": "Export to Word",
        "command": "Export",
        "subCommand": "ExportWord"
    },
    "exportpdf": {
        "id": "ExportPdf",
        "icon": "e-rte-export-pdf",
        "tooltip": "Export to PDF",
        "command": "Export",
        "subCommand": "ExportPdf"
    },
    "bold": {
        "id": "Bold",
        "icon": "e-bold",
        "tooltip": "Bold",
        "command": "Style",
        "subCommand": "Bold"
    },
    "italic": {
        "id": "Italic",
        "icon": "e-italic",
        "tooltip": "Italic",
        "command": "Style",
        "subCommand": "Italic"
    },
    "underline": {
        "id": "Underline",
        "icon": "e-underline",
        "tooltip": "Underline",
        "command": "Style",
        "subCommand": "Underline"
    },
    "strikethrough": {
        "id": "StrikeThrough",
        "icon": "e-strike-through",
        "tooltip": "StrikeThrough",
        "command": "Style",
        "subCommand": "StrikeThrough"
    },
    "clearformat": {
        "id": "ClearFormat",
        "icon": "e-clear-format",
        "tooltip": "Clear Format",
        "command": "Clear",
        "subCommand": "ClearFormat"
    },
    "clearall": {
        "id": "ClearAll",
        "icon": "e-clear-all",
        "tooltip": "Clear All",
        "command": "Clear",
        "subCommand": "ClearAll"
    },
    "cut": {
        "id": "Cut",
        "icon": "e-cut",
        "tooltip": "Cut",
        "command": "ClipBoard",
        "subCommand": "Cut"
    },
    "copy": {
        "id": "Copy",
        "icon": "e-copy",
        "tooltip": "Copy",
        "command": "ClipBoard",
        "subCommand": "Copy"
    },
    "paste": {
        "id": "Paste",
        "icon": "e-paste",
        "tooltip": "Paste",
        "command": "ClipBoard",
        "subCommand": "Paste"
    },
    "unorderedlist": {
        "id": "UnorderedList",
        "icon": "e-unorder-list",
        "tooltip": "Bulleted List",
        "command": "Lists",
        "subCommand": "UL"
    },
    "orderedlist": {
        "id": "OrderedList",
        "icon": "e-order-list",
        "tooltip": "Numbered List",
        "command": "Lists",
        "subCommand": "OL"
    },
    "numberformatlist": {
        "id": "NumberFormatList",
        "icon": "e-order-list",
        "tooltip": "Number Format List",
        "command": "NumberFormatList",
        "subCommand": "NumberFormatList"
    },
    "bulletformatlist": {
        "id": "BulletFormatList",
        "icon": "e-unorder-list",
        "tooltip": "Bullet Format List",
        "command": "BulletFormatList",
        "subCommand": "BulletFormatList"
    },
    "indent": {
        "id": "Indent",
        "icon": "e-indent",
        "tooltip": "Increase Indent",
        "command": "Indents",
        "subCommand": "Indent"
    },
    "outdent": {
        "id": "Outdent",
        "icon": "e-outdent",
        "tooltip": "Decrease Indent",
        "command": "Indents",
        "subCommand": "Outdent"
    },
    "undo": {
        "id": "Undo",
        "icon": "e-undo",
        "tooltip": "Undo",
        "command": "Actions",
        "subCommand": "Undo"
    },
    "redo": {
        "id": "Redo",
        "icon": "e-redo",
        "tooltip": "Redo",
        "command": "Actions",
        "subCommand": "Redo"
    },
    "superscript": {
        "id": "SuperScript",
        "icon": "e-super-script",
        "tooltip": "Superscript",
        "command": "Effects",
        "subCommand": "SuperScript"
    },
    "subscript": {
        "id": "SubScript",
        "icon": "e-sub-script",
        "tooltip": "Subscript",
        "command": "Effects",
        "subCommand": "SubScript"
    },
    "createlink": {
        "id": "CreateLink",
        "icon": "e-create-link",
        "tooltip": "Insert Hyperlink",
        "command": "Links",
        "subCommand": "CreateLink"
    },
    "openlink": {
        "id": "OpenLink",
        "icon": "e-open-link",
        "tooltip": "Open Link",
        "command": "Links",
        "subCommand": "OpenLink"
    },
    "editlink": {
        "id": "EditLink",
        "icon": "e-edit-link",
        "tooltip": "Edit Link",
        "command": "Links",
        "subCommand": "EditLink"
    },
    "removelink": {
        "id": "RemoveLink",
        "icon": "e-remove-link",
        "tooltip": "Remove Link",
        "command": "Links",
        "subCommand": "RemoveLink"
    },
    "image": {
        "id": "Image",
        "icon": "e-image",
        "tooltip": "Insert Image",
        "command": "Images",
        "subCommand": "Image"
    },
    "audio": {
        "id": "Audio",
        "icon": "e-audio",
        "tooltip": "Insert Audio",
        "command": "Audios",
        "subCommand": "Audio"
    },
    "video": {
        "id": "Video",
        "icon": "e-video",
        "tooltip": "Insert Video",
        "command": "Videos",
        "subCommand": "Video"
    },
    "filemanager": {
        "id": "FileManager",
        "icon": "e-rte-file-manager",
        "tooltip": "File Manager",
        "command": "Files",
        "subCommand": "File"
    },
    "createtable": {
        "id": "CreateTable",
        "icon": "e-create-table",
        "tooltip": "Create Table",
        "command": "Table",
        "subCommand": "CreateTable"
    },
    "removetable": {
        "id": "removeTable",
        "icon": "e-remove-table",
        "tooltip": "Remove Table",
        "command": "removeTable",
        "subCommand": "removeTable"
    },
    "replace": {
        "id": "Replace",
        "icon": "e-replace",
        "tooltip": "Replace",
        "command": "Images",
        "subCommand": "Replace"
    },
    "audioreplace": {
        "id": "AudioReplace",
        "icon": "e-audio-replace",
        "tooltip": "Audio Replace",
        "command": "Audios",
        "subCommand": "AudioReplace"
    },
    "audioremove": {
        "id": "AudioRemove",
        "icon": "e-audio-remove",
        "tooltip": "Audio Remove",
        "command": "Audios",
        "subCommand": "AudioRemove"
    },
    "audiolayoutoption": {
        "id": "AudioLayoutOption",
        "icon": "e-audio-display",
        "tooltip": "Audio LayoutOption",
        "command": "Audios",
        "subCommand": "AudioLayoutOption"
    },
    "videoreplace": {
        "id": "VideoReplace",
        "icon": "e-video-replace",
        "tooltip": "Video Replace",
        "command": "Videos",
        "subCommand": "VideoReplace"
    },
    "videoalign": {
        "id": "VideoAlign",
        "icon": "e-video-align",
        "tooltip": "Video Align",
        "command": "Videos",
        "subCommand": "VideoAlign"
    },
    "videoremove": {
        "id": "VideoRemove",
        "icon": "e-video-remove",
        "tooltip": "Video Remove",
        "command": "Videos",
        "subCommand": "VideoRemove"
    },
    "videolayoutoption": {
        "id": "VideoLayoutOption",
        "icon": "e-video-display",
        "tooltip": "Video LayoutOption",
        "command": "Videos",
        "subCommand": "VideoLayoutOption"
    },
    "videodimension": {
        "id": "VideoDimension",
        "icon": "e-video-dimension",
        "tooltip": "Video Dimension",
        "command": "Videos",
        "subCommand": "VideoDimension"
    },
    "align": {
        "id": "Align",
        "icon": "e-align",
        "tooltip": "Align",
        "command": "Images",
        "subCommand": "Align"
    },
    "caption": {
        "id": "Caption",
        "icon": "e-caption",
        "tooltip": "Image Caption",
        "command": "Images",
        "subCommand": "Caption"
    },
    "remove": {
        "id": "Remove",
        "icon": "e-remove",
        "tooltip": "Remove",
        "command": "Images",
        "subCommand": "Remove"
    },
    "openimagelink": {
        "id": "OpenImageLink",
        "icon": "e-open-link",
        "tooltip": "Open Link",
        "command": "Images",
        "subCommand": "OpenImageLink"
    },
    "editimagelink": {
        "id": "EditImageLink",
        "icon": "e-edit-link",
        "tooltip": "Edit Link",
        "command": "Images",
        "subCommand": "EditImageLink"
    },
    "removeimagelink": {
        "id": "RemoveImageLink",
        "icon": "e-remove-link",
        "tooltip": "Remove Link",
        "command": "Images",
        "subCommand": "RemoveImageLink"
    },
    "insertlink": {
        "id": "InsertLink",
        "icon": "e-insert-link",
        "tooltip": "Insert Link",
        "command": "Images",
        "subCommand": "InsertLink"
    },
    "display": {
        "id": "Display",
        "icon": "e-display",
        "tooltip": "Display",
        "command": "Images",
        "subCommand": "Display"
    },
    "alttext": {
        "id": "AltText",
        "icon": "e-alt-text",
        "tooltip": "Alternative Text",
        "command": "Images",
        "subCommand": "AltText"
    },
    "dimension": {
        "id": "Dimension",
        "icon": "e-img-dimension",
        "tooltip": "Change Size",
        "command": "Images",
        "subCommand": "Dimension"
    },
    "fullscreen": {
        "id": "Maximize",
        "icon": "e-maximize",
        "tooltip": "Maximize",
        "command": "View",
        "subCommand": "Maximize"
    },
    "maximize": {
        "id": "Maximize",
        "icon": "e-maximize",
        "tooltip": "Maximize",
        "command": "FullScreen",
        "subCommand": "Maximize"
    },
    "minimize": {
        "id": "Minimize",
        "icon": "e-minimize",
        "tooltip": "Minimize",
        "command": "FullScreen",
        "subCommand": "Minimize"
    },
    "lowercase": {
        "id": "LowerCase",
        "icon": "e-lower-case",
        "tooltip": "Lower Case",
        "command": "Casing",
        "subCommand": "LowerCase"
    },
    "uppercase": {
        "id": "UpperCase",
        "icon": "e-upper-case",
        "tooltip": "Upper Case",
        "command": "Casing",
        "subCommand": "UpperCase"
    },
    "print": {
        "id": "Print",
        "icon": "e-print",
        "tooltip": "Print",
        "command": "Print",
        "subCommand": "Print"
    },
    "formats": {
        "id": "Formats",
        "icon": "e-formats",
        "tooltip": "Formats",
        "command": "Formats",
        "subCommand": "Formats"
    },
    "sourcecode": {
        "id": "SourceCode",
        "icon": "e-source-code",
        "tooltip": "Code View (Ctrl+Shift+H)",
        "command": "SourceCode",
        "subCommand": "SourceCode"
    },
    "preview": {
        "id": "Preview",
        "icon": "e-preview",
        "tooltip": "Preview (Ctrl+Shift+H)",
        "command": "Preview",
        "subCommand": "Preview"
    },
    "viewside": {
        "id": "ViewSide",
        "icon": "e-view-side",
        "tooltip": "ViewSide",
        "command": "ViewSide",
        "subCommand": "ViewSide"
    },
    "insertcode": {
        "id": "InsertCode",
        "icon": "e-preformat-code",
        "tooltip": "Insert Code",
        "command": "Formats",
        "subCommand": "Pre"
    },
    "blockquote": {
        "id": "Blockquote",
        "icon": "e-blockquote",
        "tooltip": "Blockquote",
        "command": "Formats",
        "subCommand": "blockquote"
    },
    "tableheader": {
        "id": "TableHeader",
        "icon": "e-table-header",
        "tooltip": "Table Header",
        "command": "Table",
        "subCommand": "TableHeader"
    },
    "tableremove": {
        "id": "TableRemove",
        "icon": "e-table-remove",
        "tooltip": "Table Remove",
        "command": "Table",
        "subCommand": "TableRemove"
    },
    "tablerows": {
        "id": "TableRows",
        "icon": "e-table-rows",
        "tooltip": "Table Rows",
        "command": "Table",
        "subCommand": "TableRows"
    },
    "tablecolumns": {
        "id": "TableColumns",
        "icon": "e-table-columns",
        "tooltip": "Table Columns",
        "command": "Table",
        "subCommand": "TableColumns"
    },
    "tablecell": {
        "id": "TableCell",
        "icon": "e-table-cell",
        "tooltip": "Table Cell",
        "command": "Table",
        "subCommand": "TableCell"
    },
    "tablecellbackground": {
        "id": "TableCellBackground",
        "icon": "e-table-cell-background",
        "tooltip": "Table Cell Background",
        "command": "Table",
        "subCommand": "TableCellBackground"
    },
    "tablecellhorizontalalign": {
        "id": "TableCellHorizontalAlign",
        "icon": "e-table-cell-horizontalAlign",
        "tooltip": "Table Cell HorizontalAlign",
        "command": "Table",
        "subCommand": "TableCellHorizontalAlign"
    },
    "tablecellverticalalign": {
        "id": "TableCellVerticalAlign",
        "icon": "e-table-cell-verticalAlign",
        "tooltip": "Table Cell VerticalAlign",
        "command": "Table",
        "subCommand": "TableCellVerticalAlign"
    },
    "tableeditproperties": {
        "id": "TableEditProperties",
        "icon": "e-table-edit-properties",
        "tooltip": "Table Edit Properties",
        "command": "Table",
        "subCommand": "TableEditProperties"
    },
    "styles": {
        "id": "Styles",
        "icon": "e-table-styles",
        "tooltip": "Styles",
        "command": "Table",
        "subCommand": "Styles"
    },
    "formatpainter": {
        "id": "FormatPainter",
        "icon": "e-rte-format-painter",
        "tooltip": "Format Painter",
        "command": "FormatPainter",
        "subCommand": "FormatPainter"
    },
    "emojipicker": {
        "id": "EmojiPicker",
        "icon": "e-emoji",
        "tooltip": "Emoji Icon",
        "command": "EmojiPicker",
        "subCommand": "EmojiPicker"
    },
    "inlinecode": {
        "id": "inlineCode",
        "icon": "e-inline-code",
        "tooltip": "inlineCode",
        "command": "Style",
        "subCommand": "InlineCode"
    }
};
var $228f7f224d55f07b$var$alignmentLocale = [
    {
        locale: "alignmentsDropDownLeft",
        value: "JustifyLeft"
    },
    {
        locale: "alignmentsDropDownCenter",
        value: "JustifyCenter"
    },
    {
        locale: "alignmentsDropDownRight",
        value: "JustifyRight"
    },
    {
        locale: "alignmentsDropDownJustify",
        value: "JustifyFull"
    }
];
var $228f7f224d55f07b$export$37fac68e48a6e8a1 = [
    {
        iconCss: "e-icons e-justify-left",
        text: "Align Left",
        command: "Alignments",
        subCommand: "JustifyLeft"
    },
    {
        iconCss: "e-icons e-justify-center",
        text: "Align Center",
        command: "Alignments",
        subCommand: "JustifyCenter"
    },
    {
        iconCss: "e-icons e-justify-right",
        text: "Align Right",
        command: "Alignments",
        subCommand: "JustifyRight"
    },
    {
        iconCss: "e-icons e-justify-full",
        text: "Align Justify",
        command: "Alignments",
        subCommand: "JustifyFull"
    }
];
var $228f7f224d55f07b$export$30dade541bdbdfa6 = [
    {
        iconCss: "e-icons e-justify-left",
        command: "Images",
        subCommand: "JustifyLeft"
    },
    {
        iconCss: "e-icons e-justify-center",
        command: "Images",
        subCommand: "JustifyCenter"
    },
    {
        iconCss: "e-icons e-justify-right",
        command: "Images",
        subCommand: "JustifyRight"
    }
];
var $228f7f224d55f07b$export$c6055797c8a0da23 = [
    {
        iconCss: "e-icons e-justify-left",
        command: "Videos",
        subCommand: "JustifyLeft"
    },
    {
        iconCss: "e-icons e-justify-center",
        command: "Videos",
        subCommand: "JustifyCenter"
    },
    {
        iconCss: "e-icons e-justify-right",
        command: "Videos",
        subCommand: "JustifyRight"
    }
];
var $228f7f224d55f07b$var$displayLocale = [
    {
        locale: "imageDisplayDropDownInline",
        value: "Inline"
    },
    {
        locale: "imageDisplayDropDownBreak",
        value: "Break"
    }
];
var $228f7f224d55f07b$var$audioLayoutOptionLocale = [
    {
        locale: "audioLayoutOptionDropDownInline",
        value: "Inline"
    },
    {
        locale: "audioLayoutOptionDropDownBreak",
        value: "Break"
    }
];
var $228f7f224d55f07b$var$videoLayoutOptionLocale = [
    {
        locale: "videoLayoutOptionDropDownInline",
        value: "Inline"
    },
    {
        locale: "videoLayoutOptionDropDownBreak",
        value: "Break"
    }
];
var $228f7f224d55f07b$export$7fa25053523b3bbf = [
    {
        text: "Inline",
        cssClass: "e-inline",
        command: "Images",
        subCommand: "Inline"
    },
    {
        text: "Break",
        cssClass: "e-break",
        command: "Images",
        subCommand: "Break"
    }
];
var $228f7f224d55f07b$export$7f774eaa2938202e = [
    {
        text: "Inline",
        cssClass: "e-audio-inline",
        command: "Audios",
        subCommand: "Inline"
    },
    {
        text: "Break",
        cssClass: "e-audio-break",
        command: "Audios",
        subCommand: "Break"
    }
];
var $228f7f224d55f07b$export$a2ea5be81b76fd04 = [
    {
        text: "Inline",
        cssClass: "e-video-inline",
        command: "Videos",
        subCommand: "Inline"
    },
    {
        text: "Break",
        cssClass: "e-video-break",
        command: "Videos",
        subCommand: "Break"
    }
];
var $228f7f224d55f07b$export$405c7eefcc675146 = [
    {
        iconCss: "e-icons e-cell-merge",
        text: "Merge cells",
        command: "Table",
        subCommand: "Merge"
    },
    {
        iconCss: "e-icons e-cell-horizontal-split",
        text: "Horizontal split",
        command: "Table",
        subCommand: "HorizontalSplit"
    },
    {
        iconCss: "e-icons e-cell-vertical-split",
        text: "Vertical split",
        command: "Table",
        subCommand: "VerticalSplit"
    }
];
var $228f7f224d55f07b$var$tableRowLocale = [
    {
        locale: "tableInsertRowDropDownBefore",
        value: "InsertRowBefore"
    },
    {
        locale: "tableInsertRowDropDownAfter",
        value: "InsertRowAfter"
    },
    {
        locale: "tableInsertRowDropDownDelete",
        value: "DeleteRow"
    }
];
var $228f7f224d55f07b$export$c29ed6326cb3f73b = [
    {
        iconCss: "e-icons e-insert-row-before",
        text: "Insert row before",
        command: "Table",
        subCommand: "InsertRowBefore"
    },
    {
        iconCss: "e-icons e-insert-row-after",
        text: "Insert row after",
        command: "Table",
        subCommand: "InsertRowAfter"
    },
    {
        iconCss: "e-icons e-delete-row",
        text: "Delete row",
        command: "Table",
        subCommand: "DeleteRow"
    }
];
var $228f7f224d55f07b$var$tableColumnLocale = [
    {
        locale: "tableInsertColumnDropDownLeft",
        value: "InsertColumnLeft"
    },
    {
        locale: "tableInsertColumnDropDownRight",
        value: "InsertColumnRight"
    },
    {
        locale: "tableInsertColumnDropDownDelete",
        value: "DeleteColumn"
    }
];
var $228f7f224d55f07b$export$9e05ef73d8495ced = [
    {
        iconCss: "e-icons e-insert-column-left",
        text: "Insert column left",
        command: "Table",
        subCommand: "InsertColumnLeft"
    },
    {
        iconCss: "e-icons e-insert-column-right",
        text: "Insert column right",
        command: "Table",
        subCommand: "InsertColumnRight"
    },
    {
        iconCss: "e-icons e-delete-column",
        text: "Delete column",
        command: "Table",
        subCommand: "DeleteColumn"
    }
];
var $228f7f224d55f07b$var$tableVerticalLocale = [
    {
        locale: "tableVerticalAlignDropDownTop",
        value: "AlignTop"
    },
    {
        locale: "tableVerticalAlignDropDownMiddle",
        value: "AlignMiddle"
    },
    {
        locale: "tableVerticalAlignDropDownBottom",
        value: "AlignBottom"
    }
];
var $228f7f224d55f07b$export$a713f1d7939b8be7 = [
    {
        iconCss: "e-icons e-align-top",
        text: "Align Top",
        command: "Table",
        subCommand: "AlignTop"
    },
    {
        iconCss: "e-icons e-align-middle",
        text: "Align Middle",
        command: "Table",
        subCommand: "AlignMiddle"
    },
    {
        iconCss: "e-icons e-align-bottom",
        text: "Align Bottom",
        command: "Table",
        subCommand: "AlignBottom"
    }
];
var $228f7f224d55f07b$var$tableStyleLocale = [
    {
        locale: "tableStylesDropDownDashedBorder",
        value: "Dashed"
    },
    {
        locale: "tableStylesDropDownAlternateRows",
        value: "Alternate"
    }
];
var $228f7f224d55f07b$export$e54eddff3c69b4c9 = [
    {
        text: "Dashed Borders",
        cssClass: "e-dashed-borders",
        command: "Table",
        subCommand: "Dashed"
    },
    {
        text: "Alternate Rows",
        cssClass: "e-alternate-rows",
        command: "Table",
        subCommand: "Alternate"
    }
];
var $228f7f224d55f07b$export$964474d73666b47f = [
    "Bold",
    "Italic",
    "Underline",
    "|",
    "Formats",
    "Alignments",
    "Blockquote",
    "OrderedList",
    "UnorderedList",
    "|",
    "CreateLink",
    "Image",
    "|",
    "SourceCode",
    "Undo",
    "Redo"
];
var $228f7f224d55f07b$export$a5975749f0374264 = [
    {
        cssClass: "e-default",
        text: "Default",
        command: "Font",
        subCommand: "FontName",
        value: ""
    },
    {
        cssClass: "e-segoe-ui",
        text: "Segoe UI",
        command: "Font",
        subCommand: "FontName",
        value: "Segoe UI"
    },
    {
        cssClass: "e-arial",
        text: "Arial",
        command: "Font",
        subCommand: "FontName",
        value: "Arial,Helvetica,sans-serif"
    },
    {
        cssClass: "e-georgia",
        text: "Georgia",
        command: "Font",
        subCommand: "FontName",
        value: "Georgia,serif"
    },
    {
        cssClass: "e-impact",
        text: "Impact",
        command: "Font",
        subCommand: "FontName",
        value: "Impact,Charcoal,sans-serif"
    },
    {
        cssClass: "e-tahoma",
        text: "Tahoma",
        command: "Font",
        subCommand: "FontName",
        value: "Tahoma,Geneva,sans-serif"
    },
    {
        cssClass: "e-times-new-roman",
        text: "Times New Roman",
        command: "Font",
        subCommand: "FontName",
        value: "Times New Roman,Times,serif"
    },
    {
        cssClass: "e-verdana",
        text: "Verdana",
        command: "Font",
        subCommand: "FontName",
        value: "Verdana,Geneva,sans-serif"
    }
];
var $228f7f224d55f07b$export$85e3c3ca0c6fb93 = [
    {
        text: "Default",
        value: ""
    },
    {
        text: "8 pt",
        value: "8pt"
    },
    {
        text: "10 pt",
        value: "10pt"
    },
    {
        text: "12 pt",
        value: "12pt"
    },
    {
        text: "14 pt",
        value: "14pt"
    },
    {
        text: "18 pt",
        value: "18pt"
    },
    {
        text: "24 pt",
        value: "24pt"
    },
    {
        text: "36 pt",
        value: "36pt"
    }
];
var $228f7f224d55f07b$export$62d86b02caf22d22 = [
    {
        cssClass: "e-paragraph",
        text: "Paragraph",
        command: "Formats",
        subCommand: "P",
        value: "P"
    },
    {
        cssClass: "e-h1",
        text: "Heading 1",
        command: "Formats",
        subCommand: "H1",
        value: "H1"
    },
    {
        cssClass: "e-h2",
        text: "Heading 2",
        command: "Formats",
        subCommand: "H2",
        value: "H2"
    },
    {
        cssClass: "e-h3",
        text: "Heading 3",
        command: "Formats",
        subCommand: "H3",
        value: "H3"
    },
    {
        cssClass: "e-h4",
        text: "Heading 4",
        command: "Formats",
        subCommand: "H4",
        value: "H4"
    },
    {
        cssClass: "e-code",
        text: "preformatted",
        command: "Formats",
        subCommand: "Pre",
        value: "Pre"
    }
];
var $228f7f224d55f07b$export$6cd2abafd8582497 = {
    "Custom": [
        "",
        "#000000",
        "#e7e6e6",
        "#44546a",
        "#4472c4",
        "#ed7d31",
        "#a5a5a5",
        "#ffc000",
        "#70ad47",
        "#ff0000",
        "#f2f2f2",
        "#808080",
        "#cfcdcd",
        "#d5dce4",
        "#d9e2f3",
        "#fbe4d5",
        "#ededed",
        "#fff2cc",
        "#e2efd9",
        "#ffcccc",
        "#d9d9d9",
        "#595959",
        "#aeaaaa",
        "#acb9ca",
        "#b4c6e7",
        "#f7caac",
        "#dbdbdb",
        "#ffe599",
        "#c5e0b3",
        "#ff8080",
        "#bfbfbf",
        "#404040",
        "#747070",
        "#8496b0",
        "#8eaadb",
        "#f4b083",
        "#c9c9c9",
        "#ffd966",
        "#a8d08d",
        "#ff3333",
        "#a6a6a6",
        "#262626",
        "#3b3838",
        "#323e4f",
        "#2f5496",
        "#c45911",
        "#7b7b7b",
        "#bf8f00",
        "#538135",
        "#b30000",
        "#7f7f7f",
        "#0d0d0d",
        "#161616",
        "#212934",
        "#1f3763",
        "#823b0b",
        "#525252",
        "#7f5f00",
        "#375623",
        "#660000"
    ]
};
var $228f7f224d55f07b$export$8c5a050822fd698c = {
    "Custom": [
        "",
        "#000000",
        "#ffff00",
        "#00ff00",
        "#00ffff",
        "#0000ff",
        "#ff0000",
        "#000080",
        "#800080",
        "#996633",
        "#f2f2f2",
        "#808080",
        "#ffffcc",
        "#b3ffb3",
        "#ccffff",
        "#ccccff",
        "#ffcccc",
        "#ccccff",
        "#ff80ff",
        "#f2e6d9",
        "#d9d9d9",
        "#595959",
        "#ffff80",
        "#80ff80",
        "#b3ffff",
        "#8080ff",
        "#ff8080",
        "#8080ff",
        "#ff00ff",
        "#dfbf9f",
        "#bfbfbf",
        "#404040",
        "#ffff33",
        "#33ff33",
        "#33ffff",
        "#3333ff",
        "#ff3333",
        "#0000b3",
        "#b300b3",
        "#c68c53",
        "#a6a6a6",
        "#262626",
        "#e6e600",
        "#00b300",
        "#009999",
        "#000099",
        "#b30000",
        "#000066",
        "#660066",
        "#86592d",
        "#7f7f7f",
        "#0d0d0d",
        "#999900",
        "#006600",
        "#006666",
        "#000066",
        "#660000",
        "#00004d",
        "#4d004d",
        "#734d26"
    ]
};
var $228f7f224d55f07b$export$28e1c0f2ef643da3 = [
    {
        text: "None",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "none"
    },
    {
        text: "Number",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "decimal"
    },
    {
        text: "Lower Greek",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "lowerGreek"
    },
    {
        text: "Lower Roman",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "lowerRoman"
    },
    {
        text: "Upper Alpha",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "upperAlpha"
    },
    {
        text: "Lower Alpha",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "lowerAlpha"
    },
    {
        text: "Upper Roman",
        command: "Lists",
        subCommand: "NumberFormatList",
        value: "upperRoman"
    }
];
var $228f7f224d55f07b$export$27d4548ab8fb9ed = [
    {
        text: "None",
        command: "Lists",
        subCommand: "BulletFormatList",
        value: "none"
    },
    {
        text: "Disc",
        command: "Lists",
        subCommand: "BulletFormatList",
        value: "disc"
    },
    {
        text: "Circle",
        command: "Lists",
        subCommand: "BulletFormatList",
        value: "circle"
    },
    {
        text: "Square",
        command: "Lists",
        subCommand: "BulletFormatList",
        value: "square"
    }
];
function $228f7f224d55f07b$var$getLocale(self, localeItems, item) {
    for(var i = 0; localeItems.length > i; i++){
        if (localeItems[i].value === item.subCommand) return self.localeObj.getConstant(localeItems[i].locale);
    }
    return item.text;
}
function $228f7f224d55f07b$export$52b58d6351f526e0(self) {
    $228f7f224d55f07b$export$37fac68e48a6e8a1.forEach(function(item, i) {
        $228f7f224d55f07b$export$37fac68e48a6e8a1[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$alignmentLocale, $228f7f224d55f07b$export$37fac68e48a6e8a1[i]);
    });
    $228f7f224d55f07b$export$7fa25053523b3bbf.forEach(function(item, i) {
        $228f7f224d55f07b$export$7fa25053523b3bbf[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$displayLocale, $228f7f224d55f07b$export$7fa25053523b3bbf[i]);
    });
    $228f7f224d55f07b$export$7f774eaa2938202e.forEach(function(item, i) {
        $228f7f224d55f07b$export$7f774eaa2938202e[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$audioLayoutOptionLocale, $228f7f224d55f07b$export$7f774eaa2938202e[i]);
    });
    $228f7f224d55f07b$export$a2ea5be81b76fd04.forEach(function(item, i) {
        $228f7f224d55f07b$export$a2ea5be81b76fd04[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$videoLayoutOptionLocale, $228f7f224d55f07b$export$a2ea5be81b76fd04[i]);
    });
    $228f7f224d55f07b$export$c29ed6326cb3f73b.forEach(function(item, i) {
        $228f7f224d55f07b$export$c29ed6326cb3f73b[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$tableRowLocale, $228f7f224d55f07b$export$c29ed6326cb3f73b[i]);
    });
    $228f7f224d55f07b$export$9e05ef73d8495ced.forEach(function(item, i) {
        $228f7f224d55f07b$export$9e05ef73d8495ced[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$tableColumnLocale, $228f7f224d55f07b$export$9e05ef73d8495ced[i]);
    });
    $228f7f224d55f07b$export$a713f1d7939b8be7.forEach(function(item, i) {
        $228f7f224d55f07b$export$a713f1d7939b8be7[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$tableVerticalLocale, $228f7f224d55f07b$export$a713f1d7939b8be7[i]);
    });
    $228f7f224d55f07b$export$e54eddff3c69b4c9.forEach(function(item, i) {
        $228f7f224d55f07b$export$e54eddff3c69b4c9[i].text = $228f7f224d55f07b$var$getLocale(self, $228f7f224d55f07b$var$tableStyleLocale, $228f7f224d55f07b$export$e54eddff3c69b4c9[i]);
    });
}
var $228f7f224d55f07b$export$82ec818572629db6 = {
    "Insert Link": "Ctrl+K",
    "Insert Image": "Ctrl+Shift+I",
    "Create Table": "Ctrl+Shift+E",
    "Undo": "Ctrl+Z",
    "Redo": "Ctrl+Y",
    "Copy": "Ctrl+C",
    "Cut": "Ctrl+X",
    "Paste": "Ctrl+V",
    "Bold": "Ctrl+B",
    "Italic": "Ctrl+I",
    "Underline": "Ctrl+U",
    "Strikethrough": "Ctrl+Shift+S",
    "Upper Case": "Ctrl+Shift+U",
    "Lower Case": "Ctrl+Shift+L",
    "Superscript": "Ctrl+Shift+=",
    "Subscript": "Ctrl+=",
    "Code View": "Ctrl+Shift+H",
    "Maximize": "Ctrl+Shift+F",
    "Minimize": "Esc",
    "Clear Format": "Ctrl+Shift+R",
    "Numbered List": "Ctrl+Shift+O",
    "Bulleted List": "Ctrl+Alt+O",
    "Number Format List": "Ctrl+Shift+O",
    "Bullet Format List": "Ctrl+Alt+O",
    "Insert Audio": "Ctrl+Shift+A",
    "Insert Video": "Ctrl+Alt+V",
    "Increase Indent": "Ctrl+]",
    "Decrease Indent": "Ctrl+[",
    "Decrease Fontsize": "Ctrl+Shift+<",
    "Increase Fontsize": "Ctrl+Shift+>",
    "Justify Center": "Ctrl+E",
    "Justify Full": "Ctrl+J",
    "Justify Left": "Ctrl+L",
    "Justify Right": "Ctrl+R",
    "Format Painter": "Alt+Shift+C, Alt+Shift+V",
    "inlineCode": "ctrl+`"
};
var $228f7f224d55f07b$export$afb1f184b9ed8947 = [
    {
        name: "Smilies & People",
        code: "1F600",
        iconCss: "e-emoji",
        icons: [
            {
                code: "1F600",
                desc: "Grinning face"
            },
            {
                code: "1F603",
                desc: "Grinning face with big eyes"
            },
            {
                code: "1F604",
                desc: "Grinning face with smiling eyes"
            },
            {
                code: "1F606",
                desc: "Grinning squinting face"
            },
            {
                code: "1F605",
                desc: "Grinning face with sweat"
            },
            {
                code: "1F602",
                desc: "Face with tears of joy"
            },
            {
                code: "1F923",
                desc: "Rolling on the floor laughing"
            },
            {
                code: "1F60A",
                desc: "Smiling face with smiling eyes"
            },
            {
                code: "1F607",
                desc: "Smiling face with halo"
            },
            {
                code: "1F642",
                desc: "Slightly smiling face"
            },
            {
                code: "1F643",
                desc: "Upside-down face"
            },
            {
                code: "1F60D",
                desc: "Smiling face with heart-eyes"
            },
            {
                code: "1F618",
                desc: "Face blowing a kiss"
            },
            {
                code: "1F61B",
                desc: "Face with tongue"
            },
            {
                code: "1F61C",
                desc: "Winking face with tongue"
            },
            {
                code: "1F604",
                desc: "Grinning face with smiling eyes"
            },
            {
                code: "1F469",
                desc: "Woman"
            },
            {
                code: "1F468",
                desc: "Man"
            },
            {
                code: "1F467",
                desc: "Girl"
            },
            {
                code: "1F466",
                desc: "Boy"
            },
            {
                code: "1F476",
                desc: "Baby"
            },
            {
                code: "1F475",
                desc: "Old woman"
            },
            {
                code: "1F474",
                desc: "Old man"
            },
            {
                code: "1F46E",
                desc: "Police officer"
            },
            {
                code: "1F477",
                desc: "Construction worker"
            },
            {
                code: "1F482",
                desc: "Guard"
            },
            {
                code: "1F575",
                desc: "Detective"
            },
            {
                code: "1F9D1",
                desc: "Cook"
            }
        ]
    },
    {
        name: "Animals & Nature",
        code: "1F435",
        iconCss: "e-animals",
        icons: [
            {
                code: "1F436",
                desc: "Dog face"
            },
            {
                code: "1F431",
                desc: "Cat face"
            },
            {
                code: "1F42D",
                desc: "Mouse face"
            },
            {
                code: "1F439",
                desc: "Hamster face"
            },
            {
                code: "1F430",
                desc: "Rabbit face"
            },
            {
                code: "1F98A",
                desc: "Fox face"
            },
            {
                code: "1F43B",
                desc: "Bear face"
            },
            {
                code: "1F43C",
                desc: "Panda face"
            },
            {
                code: "1F428",
                desc: "Koala"
            },
            {
                code: "1F42F",
                desc: "Tiger face"
            },
            {
                code: "1F981",
                desc: "Lion face"
            },
            {
                code: "1F42E",
                desc: "Cow face"
            },
            {
                code: "1F437",
                desc: "Pig face"
            },
            {
                code: "1F43D",
                desc: "Pig nose"
            },
            {
                code: "1F438",
                desc: "Frog face"
            },
            {
                code: "1F435",
                desc: "Monkey face"
            },
            {
                code: "1F649",
                desc: "Hear-no-evil monkey"
            },
            {
                code: "1F64A",
                desc: "Speak-no-evil monkey"
            },
            {
                code: "1F412",
                desc: "Monkey"
            },
            {
                code: "1F414",
                desc: "Chicken"
            },
            {
                code: "1F427",
                desc: "Penguin"
            },
            {
                code: "1F426",
                desc: "Bird"
            },
            {
                code: "1F424",
                desc: "Baby chick"
            },
            {
                code: "1F986",
                desc: "Duck"
            },
            {
                code: "1F985",
                desc: "Eagle"
            }
        ]
    },
    {
        name: "Food & Drink",
        code: "1F347",
        iconCss: "e-food-and-drinks",
        icons: [
            {
                code: "1F34E",
                desc: "Red apple"
            },
            {
                code: "1F34C",
                desc: "Banana"
            },
            {
                code: "1F347",
                desc: "Grapes"
            },
            {
                code: "1F353",
                desc: "Strawberry"
            },
            {
                code: "1F35E",
                desc: "Bread"
            },
            {
                code: "1F950",
                desc: "Croissant"
            },
            {
                code: "1F955",
                desc: "Carrot"
            },
            {
                code: "1F354",
                desc: "Hamburger"
            },
            {
                code: "1F355",
                desc: "Pizza"
            },
            {
                code: "1F32D",
                desc: "Hot dog"
            },
            {
                code: "1F35F",
                desc: "French fries"
            },
            {
                code: "1F37F",
                desc: "Popcorn"
            },
            {
                code: "1F366",
                desc: "Soft ice cream"
            },
            {
                code: "1F367",
                desc: "Shaved ice"
            },
            {
                code: "1F36A",
                desc: "Cookie"
            },
            {
                code: "1F382",
                desc: "Birthday cake"
            },
            {
                code: "1F370",
                desc: "Shortcake"
            },
            {
                code: "1F36B",
                desc: "Chocolate bar"
            },
            {
                code: "1F369",
                desc: "Donut"
            },
            {
                code: "1F36E",
                desc: "Custard"
            },
            {
                code: "1F36D",
                desc: "Lollipop"
            },
            {
                code: "1F36C",
                desc: "Candy"
            },
            {
                code: "1F377",
                desc: "Wine glass"
            },
            {
                code: "1F37A",
                desc: "Beer mug"
            },
            {
                code: "1F37E",
                desc: "Bottle with popping cork"
            }
        ]
    },
    {
        name: "Activities",
        code: "1F383",
        iconCss: "e-activities",
        icons: [
            {
                code: "26BD",
                desc: "Soccer ball"
            },
            {
                code: "1F3C0",
                desc: "Basketball"
            },
            {
                code: "1F3C8",
                desc: "American football"
            },
            {
                code: "26BE",
                desc: "Baseball"
            },
            {
                code: "1F3BE",
                desc: "Tennis"
            },
            {
                code: "1F3D0",
                desc: "Volleyball"
            },
            {
                code: "1F3C9",
                desc: "Rugby football"
            },
            {
                code: "1F3B1",
                desc: "Pool 8 ball"
            },
            {
                code: "1F3D3",
                desc: "Ping pong"
            },
            {
                code: "1F3F8",
                desc: "Badminton"
            },
            {
                code: "1F94A",
                desc: "Boxing glove"
            },
            {
                code: "1F3CA",
                desc: "Swimmer"
            },
            {
                code: "1F3CB",
                desc: "Weightlifter"
            },
            {
                code: "1F6B4",
                desc: "Bicyclist"
            },
            {
                code: "1F6F9",
                desc: "Skateboard"
            },
            {
                code: "1F3AE",
                desc: "Video game"
            },
            {
                code: "1F579",
                desc: "Joystick"
            },
            {
                code: "1F3CF",
                desc: "Cricket"
            },
            {
                code: "1F3C7",
                desc: "Horse racing"
            },
            {
                code: "1F3AF",
                desc: "Direct hit"
            },
            {
                code: "1F3D1",
                desc: "Field hockey"
            },
            {
                code: "1F3B0",
                desc: "Slot machine"
            },
            {
                code: "1F3B3",
                desc: "Bowling"
            },
            {
                code: "1F3B2",
                desc: "Game die"
            },
            {
                code: "265F",
                desc: "Chess pawn"
            }
        ]
    },
    {
        name: "Travel & Places",
        code: "1F30D",
        iconCss: "e-travel-and-places",
        icons: [
            {
                code: "2708",
                desc: "Airplane"
            },
            {
                code: "1F697",
                desc: "Automobile"
            },
            {
                code: "1F695",
                desc: "Taxi"
            },
            {
                code: "1F6B2",
                desc: "Bicycle"
            },
            {
                code: "1F68C",
                desc: "Bus"
            },
            {
                code: "1F682",
                desc: "Locomotive"
            },
            {
                code: "1F6F3",
                desc: "Passenger ship"
            },
            {
                code: "1F680",
                desc: "Rocket"
            },
            {
                code: "1F681",
                desc: "Helicopter"
            },
            {
                code: "1F6A2",
                desc: "Ship"
            },
            {
                code: "1F3DF",
                desc: "Stadium"
            },
            {
                code: "1F54C",
                desc: "Mosque"
            },
            {
                code: "26EA",
                desc: "Church"
            },
            {
                code: "1F6D5",
                desc: "Hindu Temple"
            },
            {
                code: "1F3D4",
                desc: "Snow-capped mountain"
            },
            {
                code: "1F3EB",
                desc: "School"
            },
            {
                code: "1F30B",
                desc: "Volcano"
            },
            {
                code: "1F3D6",
                desc: "Beach with umbrella"
            },
            {
                code: "1F3DD",
                desc: "Desert island"
            },
            {
                code: "1F3DE",
                desc: "National park"
            },
            {
                code: "1F3F0",
                desc: "Castle"
            },
            {
                code: "1F5FC",
                desc: "Tokyo tower"
            },
            {
                code: "1F5FD",
                desc: "Statue of liberty"
            },
            {
                code: "26E9",
                desc: "Shinto shrine"
            },
            {
                code: "1F3EF",
                desc: "Japanese castle"
            },
            {
                code: "1F3A2",
                desc: "Roller coaster"
            }
        ]
    },
    {
        name: "Objects",
        code: "1F507",
        iconCss: "e-objects",
        icons: [
            {
                code: "1F4A1",
                desc: "Light bulb"
            },
            {
                code: "1F526",
                desc: "Flashlight"
            },
            {
                code: "1F4BB",
                desc: "Laptop computer"
            },
            {
                code: "1F5A5",
                desc: "Desktop computer"
            },
            {
                code: "1F5A8",
                desc: "Printer"
            },
            {
                code: "1F4F7",
                desc: "Camera"
            },
            {
                code: "1F4F8",
                desc: "Camera with flash"
            },
            {
                code: "1F4FD",
                desc: "Film projector"
            },
            {
                code: "1F3A5",
                desc: "Movie camera"
            },
            {
                code: "1F4FA",
                desc: "Television"
            },
            {
                code: "1F4FB",
                desc: "Radio"
            },
            {
                code: "1F50B",
                desc: "Battery"
            },
            {
                code: "231A",
                desc: "Watch"
            },
            {
                code: "1F4F1",
                desc: "Mobile phone"
            },
            {
                code: "260E",
                desc: "Telephone"
            },
            {
                code: "1F4BE",
                desc: "Floppy disk"
            },
            {
                code: "1F4BF",
                desc: "Optical disk"
            },
            {
                code: "1F4C0",
                desc: "Digital versatile disc"
            },
            {
                code: "1F4BD",
                desc: "Computer disk"
            },
            {
                code: "1F3A7",
                desc: "Headphone"
            },
            {
                code: "1F3A4",
                desc: "Microphone"
            },
            {
                code: "1F3B6",
                desc: "Multiple musical notes"
            },
            {
                code: "1F4DA",
                desc: "Books"
            }
        ]
    },
    {
        name: "Symbols",
        code: "1F3E7",
        iconCss: "e-symbols",
        icons: [
            {
                code: "274C",
                desc: "Cross mark"
            },
            {
                code: "2714",
                desc: "Check mark"
            },
            {
                code: "26A0",
                desc: "Warning sign"
            },
            {
                code: "1F6AB",
                desc: "Prohibited"
            },
            {
                code: "2139",
                desc: "Information"
            },
            {
                code: "267B",
                desc: "Recycling symbol"
            },
            {
                code: "1F6AD",
                desc: "No smoking"
            },
            {
                code: "1F4F5",
                desc: "No mobile phones"
            },
            {
                code: "1F6AF",
                desc: "No littering"
            },
            {
                code: "1F6B3",
                desc: "No bicycles"
            },
            {
                code: "1F6B7",
                desc: "No pedestrians"
            },
            {
                code: "2795",
                desc: "Plus"
            },
            {
                code: "2796",
                desc: "Minus"
            },
            {
                code: "2797",
                desc: "Divide"
            },
            {
                code: "2716",
                desc: "Multiplication"
            },
            {
                code: "1F4B2",
                desc: "Dollar banknote"
            },
            {
                code: "1F4AC",
                desc: "Speech balloon"
            },
            {
                code: "2755",
                desc: "White exclamation mark"
            },
            {
                code: "2754",
                desc: "White question mark"
            },
            {
                code: "2764",
                desc: "Heart"
            }
        ]
    }
];


/* eslint-disable */ /**
 * Export default locale
 */ var $ecad6f2eecfabe7c$export$d7f512c98c859244 = {
    "alignments": "Alignments",
    "justifyLeft": "Align Left",
    "justifyCenter": "Align Center",
    "justifyRight": "Align Right",
    "justifyFull": "Align Justify",
    "fontName": "Font Name",
    "fontSize": "Font Size",
    "fontColor": "Font Color",
    "backgroundColor": "Background Color",
    "importWord": "Import from Word",
    "exportWord": "Export to Word",
    "exportPdf": "Export to PDF",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strikethrough": "Strikethrough",
    "clearFormat": "Clear Format",
    "clearAll": "Clear All",
    "cut": "Cut",
    "copy": "Copy",
    "paste": "Paste",
    "unorderedList": "Bulleted List",
    "orderedList": "Numbered List",
    "indent": "Increase Indent",
    "outdent": "Decrease Indent",
    "undo": "Undo",
    "redo": "Redo",
    "superscript": "Superscript",
    "subscript": "Subscript",
    "createLink": "Insert Link",
    "openLink": "Open Link",
    "editLink": "Edit Link",
    "removeLink": "Remove Link",
    "image": "Insert Image",
    "audio": "Insert Audio",
    "video": "Insert Video",
    "replace": "Replace",
    "numberFormatList": "Number Format List",
    "bulletFormatList": "Bullet Format List",
    "audioReplace": "Replace",
    "videoReplace": "Replace",
    "videoAlign": "Align",
    "videoDimension": "Dimension",
    "audioRemove": "Remove",
    "videoRemove": "Remove",
    "audioLayoutOption": "Layout option",
    "videoLayoutOption": "Layout option",
    "align": "Align",
    "caption": "Caption",
    "remove": "Remove",
    "insertLink": "Insert Link",
    "display": "Display",
    "altText": "Alternative text",
    "dimension": "Change Size",
    "fullscreen": "Maximize",
    "maximize": "Maximize",
    "minimize": "Minimize",
    "lowerCase": "Lower Case",
    "upperCase": "Upper Case",
    "print": "Print",
    "formats": "Formats",
    "sourcecode": "Code View",
    "preview": "Preview",
    "viewside": "ViewSide",
    "insertCode": "Insert Code",
    "blockquote": "Blockquote",
    "linkText": "Display text",
    "linkTooltipLabel": "Title",
    "linkWebUrl": "Web address",
    "linkTitle": "Enter a title",
    "linkurl": "https://example.com",
    "linkOpenInNewWindow": "Open link in new window",
    "linkHeader": "Insert Link",
    "dialogInsert": "Insert",
    "dialogCancel": "Cancel",
    "dialogUpdate": "Update",
    "imageHeader": "Insert Image",
    "audioHeader": "Insert Audio",
    "videoHeader": "Insert Video",
    "imageLinkHeader": "You can also provide a link from the web",
    "audioLinkHeader": "You can also provide a link from the web",
    "videoLinkHeader": "Web URL",
    "embedVideoLinkHeader": "Media Embed URL",
    "mdimageLink": "Please provide a URL for your image",
    "imageUploadMessage": "Drop image here or browse to upload",
    "audioUploadMessage": "Drop an audio file or browse to upload",
    "videoUploadMessage": "Drop a video file or browse to upload",
    "imageDeviceUploadMessage": "Click here to upload",
    "audioDeviceUploadMessage": "Click here to upload",
    "videoDeviceUploadMessage": "Click here to upload",
    "imageAlternateText": "Alternate Text",
    "alternateHeader": "Alternative Text",
    "browse": "Browse",
    "imageUrl": "https://example.com/image.png",
    "audioUrl": "https://example.com/audio.mp3",
    "videoUrl": "https://example.com/video.mp4",
    "webUrl": "Web URL",
    "embedUrl": "Embed Code",
    "imageCaption": "Caption",
    "imageSizeHeader": "Image Size",
    "videoSizeHeader": "Video Size",
    "imageHeight": "Height",
    "imageWidth": "Width",
    "videoHeight": "Height",
    "videoWidth": "Width",
    "textPlaceholder": "Enter text",
    "inserttablebtn": "Insert Table",
    "tabledialogHeader": "Insert Table",
    "tableWidth": "Width",
    "cellpadding": "Cell Padding",
    "cellspacing": "Cell Spacing",
    "columns": "Number of columns",
    "rows": "Number of rows",
    "tableRows": "Row",
    "tableColumns": "Column",
    "tableCellHorizontalAlign": "Table Cell Horizontal Align",
    "tableCellVerticalAlign": "Vertical Align",
    "createTable": "Create Table",
    "removeTable": "Remove Table",
    "tableHeader": "Header Row",
    "tableRemove": "Delete Table",
    "tableCellBackground": "Table Cell Background",
    "tableEditProperties": "Table Edit Properties",
    "styles": "Styles",
    "insertColumnLeft": "Insert Column Left",
    "insertColumnRight": "Insert Column Right",
    "deleteColumn": "Delete Column",
    "insertRowBefore": "Insert Row Before",
    "insertRowAfter": "Insert Row After",
    "deleteRow": "Delete Row",
    "tableEditHeader": "Edit Table",
    "TableHeadingText": "Heading",
    "TableColText": "Col",
    "imageInsertLinkHeader": "Insert Link",
    "editImageHeader": "Edit Image",
    "editAudioHeader": "Edit Audio",
    "editVideoHeader": "Edit Video",
    "alignmentsDropDownLeft": "Align Left",
    "alignmentsDropDownCenter": "Align Center",
    "alignmentsDropDownRight": "Align Right",
    "alignmentsDropDownJustify": "Align Justify",
    "imageDisplayDropDownInline": "Inline",
    "imageDisplayDropDownBreak": "Break",
    "audioLayoutOptionDropDownInline": "Inline",
    "audioLayoutOptionDropDownBreak": "Break",
    "videoLayoutOptionDropDownInline": "Inline",
    "videoLayoutOptionDropDownBreak": "Break",
    "tableInsertRowDropDownBefore": "Insert row before",
    "tableInsertRowDropDownAfter": "Insert row after",
    "tableInsertRowDropDownDelete": "Delete row",
    "tableInsertColumnDropDownLeft": "Insert column left",
    "tableInsertColumnDropDownRight": "Insert column right",
    "tableInsertColumnDropDownDelete": "Delete column",
    "tableVerticalAlignDropDownTop": "Align Top",
    "tableVerticalAlignDropDownMiddle": "Align Middle",
    "tableVerticalAlignDropDownBottom": "Align Bottom",
    "tableStylesDropDownDashedBorder": "Dashed Borders",
    "tableStylesDropDownAlternateRows": "Alternate Rows",
    "pasteFormat": "Paste Format",
    "pasteFormatContent": "Choose the formatting action",
    "plainText": "Plain Text",
    "cleanFormat": "Clean",
    "keepFormat": "Keep",
    "pasteDialogOk": "OK",
    "pasteDialogCancel": "Cancel",
    "fileManager": "File Manager",
    "fileDialogHeader": "File Browser",
    "formatsDropDownParagraph": "Paragraph",
    "formatsDropDownCode": "Preformatted",
    "formatsDropDownQuotation": "Blockquote",
    "formatsDropDownHeading1": "Heading 1",
    "formatsDropDownHeading2": "Heading 2",
    "formatsDropDownHeading3": "Heading 3",
    "formatsDropDownHeading4": "Heading 4",
    "fontNameSegoeUI": "Segoe UI",
    "fontNameArial": "Arial",
    "fontNameGeorgia": "Georgia",
    "fontNameImpact": "Impact",
    "fontNameTahoma": "Tahoma",
    "fontNameTimesNewRoman": "Times New Roman",
    "fontNameVerdana": "Verdana",
    "numberFormatListNumber": "Number",
    "numberFormatListLowerAlpha": "Lower Alpha",
    "numberFormatListUpperAlpha": "Upper Alpha",
    "numberFormatListLowerRoman": "Lower Roman",
    "numberFormatListUpperRoman": "Upper Roman",
    "numberFormatListLowerGreek": "Lower Greek",
    "bulletFormatListDisc": "Disc",
    "bulletFormatListCircle": "Circle",
    "bulletFormatListSquare": "Square",
    "numberFormatListNone": "None",
    "bulletFormatListNone": "None",
    "formatPainter": "Format Painter",
    "emojiPicker": "Emoji Picker",
    "embeddedCode": "Embedded code",
    "pasteEmbeddedCodeHere": "Paste embedded code here",
    "emojiPickerTypeToFind": "Type to find",
    "emojiPickerNoResultFound": "No results found",
    "emojiPickerTrySomethingElse": "Try something else",
    "linkAriaLabel": "Open in new window",
    "unsupportedImage": "Unsupported file format",
    "mergecells": "Merge cells",
    "verticalsplit": "Vertical split",
    "horizontalsplit": "Horizontal split",
    "inlinecode": "Inline Code",
    "slashMenuItemHeadingOneText": "Heading 1",
    "slashMenuItemHeadingOneDescription": "Use this for a top level heading or title.",
    "slashMenuItemHeadingTwoText": "Heading 2",
    "slashMenuItemHeadingTwoDescription": "Use this for key sections.",
    "slashMenuItemHeadingThreeText": "Heading 3",
    "slashMenuItemHeadingThreeDescription": "Use this for sub sections and group headings.",
    "slashMenuItemHeadingFourText": "Heading 4",
    "slashMenuItemHeadingFourDescription": "Use this for the key points of the sub topics.",
    "slashMenuItemParagraphText": "Paragraph",
    "slashMenuItemParagraphDescription": "Writing with paragraphs.",
    "slashMenuItemBlockquoteText": "Blockquote",
    "slashMenuItemBlockquoteDescription": "Create a quote or citation.",
    "slashMenuItemOrderedListText": "Ordered List",
    "slashMenuItemOrderedListDescription": "Create an ordered list.",
    "slashMenuItemUnorderedListText": "Unordered List",
    "slashMenuItemUnorderedListDescription": "Create an unordered list.",
    "slashMenuItemCodeText": "CodeBlock",
    "slashMenuItemCodeDescription": "Create a preformatted code block.",
    "slashMenuItemTableText": "Table",
    "slashMenuItemTableDescription": "Insert a table.",
    "slashMenuItemLinkText": "Link",
    "slashMenuItemLinkDescription": "Insert a link.",
    "slashMenuItemImageText": "Image",
    "slashMenuItemImageDescription": "Insert an image.",
    "slashMenuItemAudioText": "Audio",
    "slashMenuItemAudioDescription": "Insert an audio.",
    "slashMenuItemVideoText": "Video",
    "slashMenuItemVideoDescription": "Insert a video.",
    "slashMenuItemEmojiText": "Emojipicker",
    "slashMenuItemEmojiDescription": "Use emojis to express ideas and emoticons."
};
var $ecad6f2eecfabe7c$export$932b6eb2c0573764 = {
    "alignments": "alignments",
    "justifyleft": "justifyLeft",
    "justifycenter": "justifyCenter",
    "justifyright": "justifyRight",
    "justifyfull": "justifyFull",
    "fontname": "fontName",
    "fontsize": "fontSize",
    "fontcolor": "fontColor",
    "backgroundcolor": "backgroundColor",
    "importword": "importWord",
    "exportword": "exportWord",
    "exportpdf": "exportPdf",
    "bold": "bold",
    "italic": "italic",
    "underline": "underline",
    "strikethrough": "strikethrough",
    "clearformat": "clearFormat",
    "clearall": "clearAll",
    "cut": "cut",
    "copy": "copy",
    "paste": "paste",
    "unorderedlist": "unorderedList",
    "orderedlist": "orderedList",
    "indent": "indent",
    "outdent": "outdent",
    "numberformatlist": "numberFormatList",
    "bulletformatlist": "bulletFormatList",
    "undo": "undo",
    "redo": "redo",
    "filemanager": "fileManager",
    "superscript": "superscript",
    "subscript": "subscript",
    "createlink": "createLink",
    "openlink": "openLink",
    "editlink": "editLink",
    "removelink": "removeLink",
    "openimagelink": "openLink",
    "editimagelink": "editLink",
    "removeimagelink": "removeLink",
    "image": "image",
    "audio": "audio",
    "video": "video",
    "replace": "replace",
    "audioreplace": "audioReplace",
    "videoreplace": "videoReplace",
    "videoalign": "videoAlign",
    "videodimension": "videoDimension",
    "audioremove": "audioRemove",
    "videoremove": "videoRemove",
    "audiolayoutoption": "audioLayoutOption",
    "videolayoutoption": "videoLayoutOption",
    "align": "align",
    "caption": "caption",
    "remove": "remove",
    "insertlink": "insertLink",
    "display": "display",
    "alttext": "imageAlternateText",
    "dimension": "dimension",
    "fullscreen": "fullscreen",
    "maximize": "maximize",
    "minimize": "minimize",
    "lowercase": "lowerCase",
    "uppercase": "upperCase",
    "print": "print",
    "formats": "formats",
    "sourcecode": "sourcecode",
    "preview": "preview",
    "viewside": "viewside",
    "insertcode": "insertCode",
    "blockquote": "blockquote",
    "tablerows": "tableRows",
    "tablecolumns": "tableColumns",
    "tablecellhorizontalalign": "tableCellHorizontalAlign",
    "tablecellverticalalign": "tableCellVerticalAlign",
    "createtable": "createTable",
    "removetable": "removeTable",
    "tableheader": "tableHeader",
    "tableremove": "tableRemove",
    "tablecellbackground": "tableCellBackground",
    "tableeditproperties": "tableEditProperties",
    "styles": "styles",
    "insertcolumnleft": "insertColumnLeft",
    "insertcolumnright": "insertColumnRight",
    "deletecolumn": "deleteColumn",
    "aligntop": "AlignTop",
    "alignmiddle": "AlignMiddle",
    "alignbottom": "AlignBottom",
    "insertrowbefore": "insertRowBefore",
    "insertrowafter": "insertRowAfter",
    "deleterow": "deleteRow",
    "formatpainter": "formatPainter",
    "emojipicker": "emojiPicker",
    "embeddedCode": "Embedded code",
    "pasteEmbeddedCodeHere": "Paste embedded code here",
    "emojiPickerTypeToFind": "Type to find",
    "emojiPickerNoResultFound": "No results found",
    "emojiPickerTrySomethingElse": "Try something else",
    "imageLinkAriaLabel": "Open in new window",
    "inlinecode": "inlinecode"
};
var $ecad6f2eecfabe7c$export$1e441b56673e2de8 = [
    {
        locale: "fontNameSegoeUI",
        value: "Segoe UI"
    },
    {
        locale: "fontNameArial",
        value: "Arial,Helvetica,sans-serif"
    },
    {
        locale: "fontNameGeorgia",
        value: "Georgia,serif"
    },
    {
        locale: "fontNameImpact",
        value: "Impact,Charcoal,sans-serif"
    },
    {
        locale: "fontNameTahoma",
        value: "Tahoma,Geneva,sans-serif"
    },
    {
        locale: "fontNameTimesNewRoman",
        value: "Times New Roman,Times,serif"
    },
    {
        locale: "fontNameVerdana",
        value: "Verdana,Geneva,sans-serif"
    }
];
var $ecad6f2eecfabe7c$export$3e4b60b653f4cf0e = [
    {
        locale: "formatsDropDownParagraph",
        value: "P"
    },
    {
        locale: "formatsDropDownCode",
        value: "Pre"
    },
    {
        locale: "formatsDropDownHeading1",
        value: "H1"
    },
    {
        locale: "formatsDropDownHeading2",
        value: "H2"
    },
    {
        locale: "formatsDropDownHeading3",
        value: "H3"
    },
    {
        locale: "formatsDropDownHeading4",
        value: "H4"
    }
];
var $ecad6f2eecfabe7c$export$85b7d004ae67b71e = [
    {
        locale: "numberFormatListNone",
        value: "none"
    },
    {
        locale: "numberFormatListNumber",
        value: "decimal"
    },
    {
        locale: "numberFormatListLowerAlpha",
        value: "lower-alpha"
    },
    {
        locale: "numberFormatListUpperAlpha",
        value: "upper-alpha"
    },
    {
        locale: "numberFormatListLowerRoman",
        value: "lower-roman"
    },
    {
        locale: "numberFormatListUpperRoman",
        value: "upper-roman"
    },
    {
        locale: "numberFormatListLowerGreek",
        value: "lower-greek"
    }
];
var $ecad6f2eecfabe7c$export$43abf35d750404f5 = [
    {
        locale: "bulletFormatListNone",
        value: "none"
    },
    {
        locale: "bulletFormatListDisc",
        value: "disc"
    },
    {
        locale: "bulletFormatListCircle",
        value: "circle"
    },
    {
        locale: "bulletFormatListSquare",
        value: "square"
    }
];
var $ecad6f2eecfabe7c$export$e60f19fb209f63b0 = new Map([
    [
        "Heading 1",
        {
            text: "slashMenuItemHeadingOneText",
            description: "slashMenuItemHeadingOneDescription"
        }
    ],
    [
        "Heading 2",
        {
            text: "slashMenuItemHeadingTwoText",
            description: "slashMenuItemHeadingTwoDescription"
        }
    ],
    [
        "Heading 3",
        {
            text: "slashMenuItemHeadingThreeText",
            description: "slashMenuItemHeadingThreeDescription"
        }
    ],
    [
        "Heading 4",
        {
            text: "slashMenuItemHeadingFourText",
            description: "slashMenuItemHeadingFourDescription"
        }
    ],
    [
        "Paragraph",
        {
            text: "slashMenuItemParagraphText",
            description: "slashMenuItemParagraphDescription"
        }
    ],
    [
        "Blockquote",
        {
            text: "slashMenuItemBlockquoteText",
            description: "slashMenuItemBlockquoteDescription"
        }
    ],
    [
        "OrderedList",
        {
            text: "slashMenuItemOrderedListText",
            description: "slashMenuItemOrderedListDescription"
        }
    ],
    [
        "UnorderedList",
        {
            text: "slashMenuItemUnorderedListText",
            description: "slashMenuItemUnorderedListDescription"
        }
    ],
    [
        "CodeBlock",
        {
            text: "slashMenuItemCodeText",
            description: "slashMenuItemCodeDescription"
        }
    ],
    [
        "Table",
        {
            text: "slashMenuItemTableText",
            description: "slashMenuItemTableDescription"
        }
    ],
    [
        "Link",
        {
            text: "slashMenuItemLinkText",
            description: "slashMenuItemLinkDescription"
        }
    ],
    [
        "Image",
        {
            text: "slashMenuItemImageText",
            description: "slashMenuItemImageDescription"
        }
    ],
    [
        "Audio",
        {
            text: "slashMenuItemAudioText",
            description: "slashMenuItemAudioDescription"
        }
    ],
    [
        "Video",
        {
            text: "slashMenuItemVideoText",
            description: "slashMenuItemVideoDescription"
        }
    ],
    [
        "Emojipicker",
        {
            text: "slashMenuItemEmojiText",
            description: "slashMenuItemEmojiDescription"
        }
    ]
]);


var $c77ecbfae9b8c035$var$undoRedoItems = [
    "Undo",
    "Redo"
];
var $c77ecbfae9b8c035$var$inlineNode = [
    "a",
    "abbr",
    "acronym",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "br",
    "button",
    "canvas",
    "cite",
    "code",
    "data",
    "datalist",
    "del",
    "dfn",
    "em",
    "embed",
    "font",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "map",
    "mark",
    "meter",
    "noscript",
    "object",
    "output",
    "picture",
    "progress",
    "q",
    "ruby",
    "s",
    "samp",
    "script",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "strike",
    "sub",
    "sup",
    "svg",
    "template",
    "textarea",
    "time",
    "u",
    "tt",
    "var",
    "video",
    "wbr"
];
function $c77ecbfae9b8c035$export$ddfa24987dade61b(val, items) {
    var index = -1;
    items.some(function(item, i) {
        if (typeof item === "string" && val === item.toLocaleLowerCase()) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $c77ecbfae9b8c035$export$4ea3d958472af68f(element, className) {
    var hasClass = false;
    if (element.classList.contains(className)) hasClass = true;
    return hasClass;
}
function $c77ecbfae9b8c035$export$ac59afca8e35227f(items, value, type, returnType) {
    var data;
    var result;
    for(var k = 0; k < items.length; k++){
        if (type === "value" && items[k].value.toLocaleLowerCase() === value.toLocaleLowerCase()) {
            data = items[k];
            break;
        } else if (type === "text" && items[k].text.toLocaleLowerCase() === value.toLocaleLowerCase()) {
            data = items[k];
            break;
        } else if (type === "subCommand" && items[k].subCommand.toLocaleLowerCase() === value.toLocaleLowerCase()) {
            data = items[k];
            break;
        }
    }
    if (!(0, $3EnZW.isNullOrUndefined)(data)) switch(returnType){
        case "text":
            result = data.text;
            break;
        case "value":
            result = data.value;
            break;
        case "iconCss":
            result = data.iconCss;
            break;
    }
    return result;
}
function $c77ecbfae9b8c035$export$80ca177350c4af26() {
    var result = false;
    if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos) result = true;
    return result;
}
function $c77ecbfae9b8c035$export$7c77dc956338b76(value) {
    if ((0, $3EnZW.isNullOrUndefined)(value)) return "";
    return value;
}
function $c77ecbfae9b8c035$export$fd39c00f94741b03(e, parentElement, isIFrame) {
    var y = 0;
    if (isIFrame) y = window.pageYOffset + parentElement.getBoundingClientRect().top + e.clientY;
    else y = e.pageY;
    return y;
}
function $c77ecbfae9b8c035$export$3c8120d2b233073c(item, serviceLocator) {
    var i10n = serviceLocator.getService("rteLocale");
    var itemLocale = (0, $ecad6f2eecfabe7c$export$932b6eb2c0573764)["" + item];
    var tooltipText = i10n.getConstant(itemLocale);
    return tooltipText;
}
function $c77ecbfae9b8c035$export$a169408aecd38f56(e, isPopToolbar, self) {
    $c77ecbfae9b8c035$export$e2abd0ade91628fe(self);
    var dropDown = e.dropDownModule;
    var data = e.args;
    var keys = Object.keys(e.args);
    for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var key = keys_1[_i];
        for(var j = 0; j < e.tbItems.length; j++){
            var item = e.tbItems[j].subCommand;
            var itemStr = item && item.toLocaleLowerCase();
            if (item && itemStr === key || item === "UL" && key === "unorderedlist" || item === "OL" && key === "orderedlist" || itemStr === "pre" && key === "insertcode" || item === "NumberFormatList" && key === "numberFormatList" || item === "BulletFormatList" && key === "bulletFormatList") {
                if (typeof data["" + key] === "boolean") {
                    if (data["" + key] === true) (0, $4ZDHT.addClass)([
                        e.tbElements[j]
                    ], [
                        $afc560df281b588d$export$79952d4ba2101dd4
                    ]);
                    else (0, $4ZDHT.removeClass)([
                        e.tbElements[j]
                    ], [
                        $afc560df281b588d$export$79952d4ba2101dd4
                    ]);
                } else if ((typeof data["" + key] === "string" || data["" + key] === null) && $c77ecbfae9b8c035$export$ddfa24987dade61b(key, e.parent.toolbarSettings.items) >= -1) {
                    var value = data["" + key] ? data["" + key] : "";
                    var result = "";
                    switch(key){
                        case "formats":
                            if ((0, $3EnZW.isNullOrUndefined)(dropDown.formatDropDown) || isPopToolbar || !(0, $3EnZW.isNullOrUndefined)(dropDown.formatDropDown) && dropDown.formatDropDown.isDestroyed) break;
                            var formatItems = e.parent.format.types;
                            var formatContent = (0, $3EnZW.isNullOrUndefined)(e.parent.format.default) ? formatItems[0].text : e.parent.format.default;
                            result = value === "empty" ? "" : $c77ecbfae9b8c035$export$ac59afca8e35227f(formatItems, value, "subCommand", "text");
                            dropDown.formatDropDown.content = '<span style="display: inline-flex;width:' + e.parent.format.width + '" >' + '<span class="e-rte-dropdown-btn-text' + ((0, $3EnZW.isNullOrUndefined)(e.parent.cssClass) ? "" : " " + e.parent.cssClass) + '">' + ((0, $3EnZW.isNullOrUndefined)(result) ? formatContent : result) + "</span></span>";
                            dropDown.formatDropDown.dataBind();
                            break;
                        case "alignments":
                            if ((0, $3EnZW.isNullOrUndefined)(dropDown.alignDropDown) || !(0, $3EnZW.isNullOrUndefined)(dropDown.alignDropDown) && dropDown.alignDropDown.isDestroyed) break;
                            var alignItems = $228f7f224d55f07b$export$37fac68e48a6e8a1;
                            result = $c77ecbfae9b8c035$export$ac59afca8e35227f(alignItems, value, "subCommand", "iconCss");
                            dropDown.alignDropDown.iconCss = (0, $3EnZW.isNullOrUndefined)(result) ? "e-icons e-justify-left" : result;
                            dropDown.alignDropDown.dataBind();
                            break;
                        case "fontname":
                            if ((0, $3EnZW.isNullOrUndefined)(dropDown.fontNameDropDown) || isPopToolbar || !(0, $3EnZW.isNullOrUndefined)(dropDown.fontNameDropDown) && dropDown.fontNameDropDown.isDestroyed) break;
                            var fontNameItems = e.parent.fontFamily.items;
                            result = value === "empty" ? "" : $c77ecbfae9b8c035$export$ac59afca8e35227f(fontNameItems, value, "value", "text");
                            var fontNameContent = (0, $3EnZW.isNullOrUndefined)(e.parent.fontFamily.default) ? fontNameItems[0].text : e.parent.fontFamily.default;
                            var name_1 = ((0, $3EnZW.isNullOrUndefined)(result) ? fontNameContent : result) === "Default" ? self.serviceLocator.getService("rteLocale").getConstant("fontName") : (0, $3EnZW.isNullOrUndefined)(result) ? fontNameContent : result;
                            dropDown.fontNameDropDown.content = '<span style="display: inline-flex;width:' + e.parent.fontFamily.width + '" >' + '<span class="e-rte-dropdown-btn-text' + ((0, $3EnZW.isNullOrUndefined)(e.parent.cssClass) ? "" : " " + e.parent.cssClass) + '">' + name_1 + "</span></span>";
                            dropDown.fontNameDropDown.dataBind();
                            break;
                        case "fontsize":
                            if ((0, $3EnZW.isNullOrUndefined)(dropDown.fontSizeDropDown) || !(0, $3EnZW.isNullOrUndefined)(dropDown.fontSizeDropDown) && dropDown.fontSizeDropDown.isDestroyed) break;
                            var fontSizeItems = e.parent.fontSize.items;
                            var fontSizeContent = (0, $3EnZW.isNullOrUndefined)(e.parent.fontSize.default) ? fontSizeItems[0].text : e.parent.fontSize.default;
                            var fontSizeToolbarText = $c77ecbfae9b8c035$export$ac59afca8e35227f(fontSizeItems, value === "" ? fontSizeContent.replace(/\s/g, "") : value, fontSizeContent.replace(/\s/g, "") === fontSizeItems[0].text && value === "" ? "text" : "value", "text");
                            result = value === "empty" ? "" : fontSizeToolbarText === "Default" ? self.serviceLocator.getService("rteLocale").getConstant("fontSize") : fontSizeToolbarText;
                            dropDown.fontSizeDropDown.content = '<span style="display: inline-flex;width:' + e.parent.fontSize.width + '" >' + '<span class="e-rte-dropdown-btn-text' + ((0, $3EnZW.isNullOrUndefined)(e.parent.cssClass) ? "" : " " + e.parent.cssClass) + '">' + $c77ecbfae9b8c035$export$7c77dc956338b76(result) + "</span></span>";
                            dropDown.fontSizeDropDown.dataBind();
                            break;
                        case "bulletFormatList":
                        case "numberFormatList":
                            if (value !== "") (0, $4ZDHT.addClass)([
                                e.tbElements[j]
                            ], [
                                $afc560df281b588d$export$79952d4ba2101dd4
                            ]);
                            else (0, $4ZDHT.removeClass)([
                                e.tbElements[j]
                            ], [
                                $afc560df281b588d$export$79952d4ba2101dd4
                            ]);
                    }
                }
            }
        }
    }
}
function $c77ecbfae9b8c035$export$2716f3327981be5(items) {
    if (typeof items === "object") return items;
    else return [
        items
    ];
}
function $c77ecbfae9b8c035$export$e3859ff097a28f2c(items, toolbarItems) {
    var itemsIndex = [];
    for(var i = 0; i < items.length; i++)for(var j = 0; j < toolbarItems.length; j++){
        if (toolbarItems[j].type === "Separator") continue;
        else {
            if ((items[i] === "OrderedList" || items[i] === "NumberFormatList") && toolbarItems[j].subCommand === "OL") {
                itemsIndex.push(j);
                break;
            } else if ((items[i] === "UnorderedList" || items[i] === "BulletFormatList") && toolbarItems[j].subCommand === "UL") {
                itemsIndex.push(j);
                break;
            } else if (items[i] === "InsertCode" && toolbarItems[j].subCommand === "Pre") {
                itemsIndex.push(j);
                break;
            } else if (items[i] === "Blockquote" && toolbarItems[j].subCommand === "blockquote") {
                itemsIndex.push(j);
                break;
            } else if (items[i] === "FileManager" && toolbarItems[j].subCommand === "File") {
                itemsIndex.push(j);
                break;
            } else if (typeof items[i] === "object" && items[i].command === "Custom") {
                itemsIndex.push(i);
                break;
            } else if (items[i] === toolbarItems[j].subCommand) {
                itemsIndex.push(j);
                break;
            }
        }
    }
    return itemsIndex;
}
function $c77ecbfae9b8c035$export$c584fa307b6d1ee0(baseToolbar, undoRedoStatus) {
    var i = 0;
    var trgItems = $c77ecbfae9b8c035$export$e3859ff097a28f2c($c77ecbfae9b8c035$export$2716f3327981be5($c77ecbfae9b8c035$var$undoRedoItems), baseToolbar.toolbarObj.items);
    var tbItems = (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, baseToolbar.toolbarObj.element);
    var keys = Object.keys(undoRedoStatus);
    for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
        var key = keys_2[_i];
        var target = tbItems[trgItems[i]];
        if (target) baseToolbar.toolbarObj.enableItems(target, undoRedoStatus["" + key]);
        i++;
    }
}
function $c77ecbfae9b8c035$export$716a11175c03fb4e(element, type) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent(type, false, true);
    element.dispatchEvent(evt);
}
function $c77ecbfae9b8c035$export$ffae2e31416920bc(value) {
    var tempNode = (0, $4ZDHT.createElement)("template");
    tempNode.innerHTML = value;
    if (tempNode.content instanceof DocumentFragment) return tempNode.content;
    else return document.createRange().createContextualFragment(value);
}
function $c77ecbfae9b8c035$export$583075c8d044926c(docElement, node) {
    var nodes = [];
    for(node = node.firstChild; node; node = node.nextSibling)if (node.nodeType === 3) nodes.push(node);
    else nodes = nodes.concat($c77ecbfae9b8c035$export$583075c8d044926c(docElement, node));
    return nodes;
}
function $c77ecbfae9b8c035$export$422955f13ff9f307(obj) {
    var convertedValue = {};
    var keys = Object.keys(obj);
    for(var i = 0; i < Object.keys(obj).length; i++)convertedValue[keys[i].toLocaleLowerCase()] = obj[keys[i]];
    return convertedValue;
}
function $c77ecbfae9b8c035$export$4649c1610e50ca8d(value, rteObj) {
    var val;
    if (value !== null && value !== "") {
        val = rteObj.enableHtmlEncode ? $c77ecbfae9b8c035$export$cce115c473292573($c77ecbfae9b8c035$export$2f872c0f2117be69(value), rteObj) : $c77ecbfae9b8c035$export$cce115c473292573(value, rteObj);
        rteObj.setProperties({
            value: val
        }, true);
    } else {
        if (rteObj.enterKey === "DIV") val = rteObj.enableHtmlEncode ? "&lt;div&gt;&lt;br/&gt;&lt;/div&gt;" : "<div><br/></div>";
        else if (rteObj.enterKey === "BR") val = rteObj.enableHtmlEncode ? "&lt;br/&gt;" : "<br/>";
        else val = rteObj.enableHtmlEncode ? "&lt;p&gt;&lt;br/&gt;&lt;/p&gt;" : "<p><br/></p>";
    }
    return val;
}
function $c77ecbfae9b8c035$export$cce115c473292573(value, rteObj) {
    var tempNode = document.createElement("div");
    var resultElm = document.createElement("div");
    var childNodes = tempNode.childNodes;
    tempNode.innerHTML = value;
    tempNode.setAttribute("class", "tempDiv");
    if (childNodes.length > 0) {
        var isPreviousInlineElem = void 0;
        var previousParent = void 0;
        var insertElem = void 0;
        while(tempNode.firstChild){
            var emptyBlockElem = tempNode.querySelectorAll($947a002e9a697770$export$91469607ee8f30a1);
            for(var i = 0; i < emptyBlockElem.length; i++)emptyBlockElem[i].innerHTML = "<br>";
            // To handle the Empty block node with \n
            var allPNodes = tempNode.querySelectorAll("p");
            for(var i = 0; i < allPNodes.length; i++)if (allPNodes[i].textContent.trim().length === 0 && allPNodes[i].childNodes.length === 1 && allPNodes[i].childNodes[0].nodeName === "#text" && (0, $3EnZW.isNullOrUndefined)(allPNodes[i].childNodes[0].textContent.match(/\u00a0/g))) allPNodes[i].innerHTML = "<br>";
            var emptyInlineElem = tempNode.querySelectorAll($947a002e9a697770$export$f29525ac8b889ffd);
            for(var i = 0; i < emptyInlineElem.length; i++)emptyInlineElem[i].innerHTML = "&ZeroWidthSpace;";
            if (rteObj.enterKey !== "BR" && (tempNode.firstChild.nodeName === "#text" && (tempNode.firstChild.textContent.indexOf("\n") < 0 || tempNode.firstChild.textContent.trim() !== "") || $c77ecbfae9b8c035$var$inlineNode.indexOf(tempNode.firstChild.nodeName.toLocaleLowerCase()) >= 0)) {
                if (!isPreviousInlineElem) {
                    if (rteObj.enterKey === "DIV") insertElem = (0, $4ZDHT.createElement)("div");
                    else insertElem = (0, $4ZDHT.createElement)("p");
                    resultElm.appendChild(insertElem);
                    insertElem.appendChild(tempNode.firstChild);
                } else previousParent.appendChild(tempNode.firstChild);
                previousParent = insertElem;
                isPreviousInlineElem = true;
            } else if (tempNode.firstChild.nodeName === "#text" && (tempNode.firstChild.textContent === "\n" || tempNode.firstChild.textContent.indexOf("\n") >= 0 && tempNode.firstChild.textContent.trim() === "")) (0, $4ZDHT.detach)(tempNode.firstChild);
            else {
                resultElm.appendChild(tempNode.firstChild);
                isPreviousInlineElem = false;
            }
        }
        var imageElm = resultElm.querySelectorAll("img");
        for(var i = 0; i < imageElm.length; i++){
            if (imageElm[i].classList.contains("e-rte-image-unsupported")) continue; // Should not add the class if the image is Broken.
            if (!imageElm[i].classList.contains($afc560df281b588d$export$43b7526f3bcf1c7d)) imageElm[i].classList.add($afc560df281b588d$export$43b7526f3bcf1c7d);
            if (!(imageElm[i].classList.contains($afc560df281b588d$export$650bb6ed56b4642) || imageElm[i].classList.contains($afc560df281b588d$export$c6e979ddaa53685e)) && !(imageElm[i].classList.contains("e-imgleft") || imageElm[i].classList.contains("e-imgright") || imageElm[i].classList.contains("e-imgcenter"))) imageElm[i].classList.add($afc560df281b588d$export$650bb6ed56b4642);
        }
    }
    return resultElm.innerHTML;
}
function $c77ecbfae9b8c035$export$9f15c5f175f17548(rteObj) {
    var currentVal;
    if (rteObj.enterKey === "DIV") currentVal = rteObj.enableHtmlEncode ? "&lt;div&gt;&lt;br/&gt;&lt;/div&gt;" : "<div><br/></div>";
    else if (rteObj.enterKey === "BR") currentVal = rteObj.enableHtmlEncode ? "&lt;br/&gt;" : "<br/>";
    else currentVal = rteObj.enableHtmlEncode ? "&lt;p&gt;&lt;br/&gt;&lt;/p&gt;" : "<p><br/></p>";
    return currentVal;
}
function $c77ecbfae9b8c035$export$16ed3812c70f8aa3(value) {
    return value === "<p><br></p>" || value === "&lt;p&gt;&lt;br&gt;&lt;/p&gt;" || value === "<div><br></div>" || value === "&lt;div&gt;&lt;br&gt;&lt;/div&gt;" || value === "<br>" || value === "&lt;br&gt;" || value === "" ? true : false;
}
function $c77ecbfae9b8c035$export$2f872c0f2117be69(value) {
    return value.replace(/&amp;/g, "&").replace(/&amp;lt;/g, "<").replace(/&lt;/g, "<").replace(/&amp;gt;/g, ">").replace(/&gt;/g, ">").replace(/&nbsp;/g, " ").replace(/&amp;nbsp;/g, " ").replace(/&quot;/g, "");
}
function $c77ecbfae9b8c035$export$b868d07f1dfe5080(value, parent) {
    if (parent.enableHtmlSanitizer) {
        var item = (0, $3P3ke.SanitizeHtmlHelper).beforeSanitize();
        if (item.selectors.tags[2] && item.selectors.tags[2].indexOf("iframe") > -1) item.selectors.tags[2] = "iframe:not(.e-rte-embed-url)";
        var beforeEvent = {
            cancel: false,
            helper: null
        };
        (0, $3EnZW.extend)(item, item, beforeEvent);
        parent.trigger("beforeSanitizeHtml", item);
        if (item.cancel && !(0, $3EnZW.isNullOrUndefined)(item.helper)) value = item.helper(value);
        else if (!item.cancel) value = (0, $3P3ke.SanitizeHtmlHelper).serializeValue(item, value);
    }
    return value;
}
function $c77ecbfae9b8c035$export$cf4191ff74926367(dataUrl) {
    var arr = dataUrl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while(n--)u8arr[n] = bstr.charCodeAt(n);
    return new Blob([
        u8arr
    ], {
        type: mime
    });
}
function $c77ecbfae9b8c035$export$8225a5186030458e(self, localeItems, item) {
    for(var i = 0; localeItems.length > i; i++){
        if (localeItems[i].value === item.value || localeItems[i].value === item.subCommand) return self.localeObj.getConstant(localeItems[i].locale);
    }
    return item.text;
}
function $c77ecbfae9b8c035$export$e2abd0ade91628fe(self) {
    $228f7f224d55f07b$export$a5975749f0374264.forEach(function(item, i) {
        $228f7f224d55f07b$export$a5975749f0374264[i].text = $c77ecbfae9b8c035$export$8225a5186030458e(self, (0, $ecad6f2eecfabe7c$export$1e441b56673e2de8), $228f7f224d55f07b$export$a5975749f0374264[i]);
    });
    $228f7f224d55f07b$export$62d86b02caf22d22.forEach(function(item, i) {
        $228f7f224d55f07b$export$62d86b02caf22d22[i].text = $c77ecbfae9b8c035$export$8225a5186030458e(self, (0, $ecad6f2eecfabe7c$export$3e4b60b653f4cf0e), $228f7f224d55f07b$export$62d86b02caf22d22[i]);
    });
    $228f7f224d55f07b$export$28e1c0f2ef643da3.forEach(function(item, i) {
        $228f7f224d55f07b$export$28e1c0f2ef643da3[i].text = $c77ecbfae9b8c035$export$8225a5186030458e(self, (0, $ecad6f2eecfabe7c$export$85b7d004ae67b71e), $228f7f224d55f07b$export$28e1c0f2ef643da3[i]);
    });
    $228f7f224d55f07b$export$27d4548ab8fb9ed.forEach(function(item, i) {
        $228f7f224d55f07b$export$27d4548ab8fb9ed[i].text = $c77ecbfae9b8c035$export$8225a5186030458e(self, (0, $ecad6f2eecfabe7c$export$43abf35d750404f5), $228f7f224d55f07b$export$27d4548ab8fb9ed[i]);
    });
}


/**
 * Defines common util methods used by Rich Text Editor.
 */ parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $259257662ca103fc$var$inlineNode = [
    "a",
    "abbr",
    "acronym",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "br",
    "button",
    "canvas",
    "cite",
    "code",
    "data",
    "datalist",
    "del",
    "dfn",
    "em",
    "embed",
    "font",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "map",
    "mark",
    "meter",
    "noscript",
    "object",
    "output",
    "picture",
    "progress",
    "q",
    "ruby",
    "s",
    "samp",
    "script",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "strike",
    "sub",
    "sup",
    "svg",
    "template",
    "textarea",
    "time",
    "u",
    "tt",
    "var",
    "video",
    "wbr"
];
function $259257662ca103fc$export$80ca177350c4af26() {
    var result = false;
    if ((0, $5q7BP.Browser).isDevice && (0, $5q7BP.Browser).isIos) result = true;
    return result;
}
function $259257662ca103fc$export$9f8b84040f122328(editableElement, selector) {
    if (editableElement.nodeName === "BODY" && !(0, $3EnZW.isNullOrUndefined)(selector)) {
        var iframe = top.window.document.querySelector(selector);
        if (!(0, $3EnZW.isNullOrUndefined)(iframe)) iframe.contentWindow.focus();
    }
}
function $259257662ca103fc$export$cce115c473292573(value, enterAction) {
    var tempNode = document.createElement("div");
    tempNode.innerHTML = value;
    tempNode.setAttribute("class", "tempDiv");
    var resultElm = document.createElement("div");
    var childNodes = tempNode.childNodes;
    if (childNodes.length > 0) {
        var isPreviousInlineElem = void 0;
        var previousParent = void 0;
        var paraElm = void 0;
        while(tempNode.firstChild){
            if (tempNode.firstChild.nodeName === "#text" && (tempNode.firstChild.textContent.indexOf("\n") < 0 || tempNode.firstChild.textContent.trim() !== "") || $259257662ca103fc$var$inlineNode.indexOf(tempNode.firstChild.nodeName.toLocaleLowerCase()) >= 0) {
                if (!isPreviousInlineElem) {
                    if (enterAction === "BR") {
                        resultElm.appendChild(tempNode.firstChild);
                        previousParent = resultElm;
                    } else {
                        paraElm = (0, $4ZDHT.createElement)("p");
                        resultElm.appendChild(paraElm);
                        paraElm.appendChild(tempNode.firstChild);
                        previousParent = paraElm;
                        isPreviousInlineElem = true;
                    }
                } else {
                    previousParent.appendChild(tempNode.firstChild);
                    previousParent = paraElm;
                    isPreviousInlineElem = true;
                }
            } else if (tempNode.firstChild.nodeName === "#text" && (tempNode.firstChild.textContent === "\n" || tempNode.firstChild.textContent.indexOf("\n") >= 0 && tempNode.firstChild.textContent.trim() === "")) (0, $4ZDHT.detach)(tempNode.firstChild);
            else {
                resultElm.appendChild(tempNode.firstChild);
                isPreviousInlineElem = false;
            }
        }
        var tableElm = resultElm.querySelectorAll("table");
        for(var i = 0; i < tableElm.length; i++)if (tableElm[i].classList.length > 0 && !tableElm[i].classList.contains("e-rte-table")) {
            tableElm[i].classList.add("e-rte-paste-table");
            if (tableElm[i].classList.contains("e-rte-paste-word-table")) {
                tableElm[i].classList.remove("e-rte-paste-word-table");
                continue; // Skiping the removal of the border if the source is from word.
            } else if (tableElm[i].classList.contains("e-rte-paste-excel-table")) {
                tableElm[i].classList.remove("e-rte-paste-excel-table");
                if (tableElm[i].getAttribute("border") === "0") tableElm[i].removeAttribute("border");
                var tdElm = tableElm[i].querySelectorAll("td");
                for(var j = 0; j < tdElm.length; j++){
                    if (tdElm[j].style.borderLeft === "none") tdElm[j].style.removeProperty("border-left");
                    if (tdElm[j].style.borderRight === "none") tdElm[j].style.removeProperty("border-right");
                    if (tdElm[j].style.borderBottom === "none") tdElm[j].style.removeProperty("border-bottom");
                    if (tdElm[j].style.borderTop === "none") tdElm[j].style.removeProperty("border-top");
                    if (tdElm[j].style.border === "none") tdElm[j].style.removeProperty("border");
                }
            } else if (tableElm[i].classList.contains("e-rte-paste-onenote-table")) {
                tableElm[i].classList.remove("e-rte-paste-onenote-table");
                continue;
            } else if (tableElm[i].classList.contains("e-rte-paste-html-table")) {
                tableElm[i].classList.remove("e-rte-paste-html-table");
                continue;
            }
        }
        var imageElm = resultElm.querySelectorAll("img");
        for(var i = 0; i < imageElm.length; i++){
            if (imageElm[i].classList.contains("e-rte-image-unsupported")) continue; // Should not add the class if the image is Broken.
            if (!imageElm[i].classList.contains("e-rte-image")) imageElm[i].classList.add("e-rte-image");
            if (!(imageElm[i].classList.contains("e-imginline") || imageElm[i].classList.contains("e-imgbreak"))) imageElm[i].classList.add("e-imginline");
        }
    }
    return resultElm.innerHTML;
}
function $259257662ca103fc$export$ed8d42d2d9cfe830(startChildNodes) {
    var finalNode = startChildNodes;
    do if (finalNode.childNodes.length > 0) finalNode = finalNode.childNodes[0];
    while (finalNode.childNodes.length > 0);
    return finalNode;
}
function $259257662ca103fc$export$9f385661c3e974c1() {
    return {
        bold: false,
        italic: false,
        subscript: false,
        superscript: false,
        strikethrough: false,
        orderedlist: false,
        unorderedlist: false,
        numberFormatList: false,
        bulletFormatList: false,
        underline: false,
        alignments: null,
        backgroundcolor: null,
        fontcolor: null,
        fontname: null,
        fontsize: null,
        formats: null,
        createlink: false,
        insertcode: false,
        blockquote: false,
        inlinecode: false
    };
}
function $259257662ca103fc$export$34ca5c1b18eb2015() {
    return {
        bold: false,
        italic: false,
        subscript: false,
        superscript: false,
        strikethrough: false,
        orderedlist: false,
        uppercase: false,
        lowercase: false,
        inlinecode: false,
        unorderedlist: false,
        formats: null
    };
}
function $259257662ca103fc$export$1370d694ef0c2923(range) {
    if (range.startContainer.parentElement.closest("ol,ul") !== null && range.endContainer.parentElement.closest("ol,ul") !== null) {
        range.extractContents();
        while((range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer).querySelectorAll("li :empty").length > 0 || (range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer).querySelectorAll("ol :empty").length > 0){
            var emptyLI = (range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer).querySelectorAll("li :empty");
            if (emptyLI.length > 0) emptyLI.forEach(function(item) {
                item.remove();
            });
            else break;
        }
        var liElem = (range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer).querySelectorAll("li");
        if (liElem.length > 0) liElem.forEach(function(item) {
            if (!(0, $3EnZW.isNullOrUndefined)(item.firstChild) && (item.firstChild.nodeName === "OL" || item.firstChild.nodeName === "UL")) item.style.listStyleType = "none";
        });
    }
}
function $259257662ca103fc$export$7e1ec7538889cd1(document1, inputElement) {
    var rootElement = inputElement.nodeName === "BODY" ? inputElement.ownerDocument.defaultView.frameElement.closest(".e-richtexteditor") : inputElement.closest(".e-richtexteditor");
    var height = rootElement.style.height;
    if (document1.getSelection().rangeCount === 0) return;
    var range = document1.getSelection().getRangeAt(0);
    var finalFocusElement = range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer;
    var rect = finalFocusElement.getBoundingClientRect();
    var cursorTop = rect.top;
    var cursorBottom = rect.bottom;
    var rootRect = rootElement.getBoundingClientRect();
    var hasMargin = rootElement.querySelectorAll(".e-count-enabled, .e-resize-enabled").length > 0;
    if (inputElement.nodeName === "BODY") {
        if (height === "auto") {
            if (window.innerHeight < cursorTop) finalFocusElement.scrollIntoView(false);
        } else if (cursorTop > inputElement.getBoundingClientRect().height) finalFocusElement.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
    } else {
        if (height === "auto") {
            if (window.innerHeight < cursorTop) finalFocusElement.scrollIntoView({
                block: "end",
                inline: "nearest"
            });
        } else if (cursorBottom > rootRect.bottom) rootElement.querySelector(".e-rte-content").scrollTop += cursorBottom - rootRect.bottom + (hasMargin ? 20 : 0);
    }
    var scrollVal = inputElement.closest('div[style*="overflow-y: scroll"]');
    if (!(0, $3EnZW.isNullOrUndefined)(scrollVal)) {
        var parentRect = scrollVal.getBoundingClientRect();
        if (cursorBottom > parentRect.bottom) scrollVal.scrollTop += cursorBottom - parentRect.bottom;
    }
}
function $259257662ca103fc$export$262596b10371f908(oldArray, newArray, indexToInsert) {
    // This is a work around for ES6 ...spread operator usage.
    // Usecase: When a new array is inserted into an existing array at a specific index.
    for(var i = 0; i < newArray.length; i++)if (i === 0) oldArray.splice(indexToInsert + i, 1, newArray[i]);
    else oldArray.splice(indexToInsert + i, 0, newArray[i]);
    return oldArray;
}
function $259257662ca103fc$export$7e42d760c0740ccc(elements, classes) {
    (0, $4ZDHT.removeClass)(elements, classes);
    for(var i = 0; i < elements.length; i++)if (elements[i].classList.length === 0 && elements[i].getAttribute("class")) elements[i].removeAttribute("class");
    return elements;
}


/**
 * `Audio` module is used to handle audio actions.
 */ var $4c68d77f91fb8b84$export$153755f98d9861de = /** @class */ function() {
    function Audio(parent, serviceLocator) {
        this.isAudioUploaded = false;
        this.isAllowedTypes = true;
        this.deletedAudio = [];
        this.parent = parent;
        this.rteID = parent.element.id;
        this.i10n = serviceLocator.getService("rteLocale");
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.addEventListener();
        this.docClick = this.onDocumentClick.bind(this);
        this.isDestroyed = false;
    }
    Audio.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp, this);
        this.parent.on($947a002e9a697770$export$b71d7033796fa5cc, this.insertingAudio, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$446aef6294af7f8b, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$86f139d5d20038ff, this.showDialog, this);
        this.parent.on($947a002e9a697770$export$68bf2f47fab9348f, this.closeDialog, this);
        this.parent.on($947a002e9a697770$export$14e4186604d20036, this.onToolbarAction, this);
        this.parent.on($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect, this);
        this.parent.on($947a002e9a697770$export$3fbb519abc8109bb, this.deleteAudio, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler, this);
        this.parent.on($947a002e9a697770$export$ac0f8621e12395a0, this.showAudioQuickToolbar, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.closeDialog, this);
    };
    Audio.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp);
        this.parent.off($947a002e9a697770$export$b71d7033796fa5cc, this.insertingAudio);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.afterRender);
        this.parent.off($947a002e9a697770$export$446aef6294af7f8b, this.afterRender);
        this.parent.off($947a002e9a697770$export$86f139d5d20038ff, this.showDialog);
        this.parent.off($947a002e9a697770$export$68bf2f47fab9348f, this.closeDialog);
        this.parent.off($947a002e9a697770$export$14e4186604d20036, this.onToolbarAction);
        this.parent.off($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect);
        this.parent.off($947a002e9a697770$export$3fbb519abc8109bb, this.deleteAudio);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler);
        this.parent.off($947a002e9a697770$export$ac0f8621e12395a0, this.showAudioQuickToolbar);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.closeDialog);
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule)) {
            (0, $aqzbR.EventHandler).remove(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.touchStart);
            (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.audioClick);
            this.parent.element.ownerDocument.removeEventListener("mousedown", this.docClick);
            this.docClick = null;
        }
    };
    Audio.prototype.afterRender = function() {
        this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        (0, $aqzbR.EventHandler).add(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.touchStart, this);
        (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.audioClick, this);
        this.parent.element.ownerDocument.addEventListener("mousedown", this.docClick);
    };
    Audio.prototype.checkAudioBack = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === 0 && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.previousSibling) && this.isAudioElem(range.startContainer.previousSibling)) this.deletedAudio.push(range.startContainer.previousSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset - 1]) && this.isAudioElem(range.startContainer.childNodes[range.startOffset - 1])) this.deletedAudio.push(range.startContainer.childNodes[range.startOffset - 1]);
    };
    Audio.prototype.checkAudioDel = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === range.startContainer.textContent.length && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.nextSibling) && range.startContainer.nextSibling.nodeName === "AUDIO") this.deletedAudio.push(range.startContainer.nextSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset]) && this.isAudioElem(range.startContainer.childNodes[range.startOffset])) this.deletedAudio.push(range.startContainer.childNodes[range.startOffset]);
    };
    Audio.prototype.undoStack = function(args) {
        if ((args.subCommand.toLowerCase() === "undo" || args.subCommand.toLowerCase() === "redo") && this.parent.editorMode === "HTML") for(var i = 0; i < this.parent.formatter.getUndoRedoStack().length; i++){
            var temp = this.parent.createElement("div");
            var contentElem = this.parent.formatter.getUndoRedoStack()[i].text;
            temp.appendChild(contentElem.cloneNode(true));
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Audio.prototype.touchStart = function(e, ele) {
        if (this.parent.readonly) return;
        this.prevSelectedAudEle = this.audEle;
    };
    Audio.prototype.onToolbarAction = function(args) {
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
        var item = args.args.item;
        switch(item.subCommand){
            case "AudioReplace":
                this.parent.notify($947a002e9a697770$export$b71d7033796fa5cc, args);
                break;
            case "AudioRemove":
                this.parent.notify($947a002e9a697770$export$3fbb519abc8109bb, args);
                break;
        }
    };
    // eslint-disable-next-line
    Audio.prototype.onKeyUp = function(event) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.deletedAudio) && this.deletedAudio.length > 0) for(var i = 0; i < this.deletedAudio.length; i++){
            var args = {
                element: this.deletedAudio[i].querySelector("audio"),
                src: this.deletedAudio[i].querySelector("source").getAttribute("src")
            };
            this.parent.trigger($947a002e9a697770$export$bd12237ad996f402, args);
        }
    };
    Audio.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        this.deletedAudio = [];
        var isCursor;
        var keyCodeValues = [
            27,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            44,
            45,
            9,
            16,
            17,
            18,
            19,
            20,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            91,
            92,
            93,
            144,
            145,
            182,
            183
        ];
        if (this.parent.editorMode === "HTML") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            isCursor = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
        }
        if (!isCursor && this.parent.editorMode === "HTML" && keyCodeValues.indexOf(originalEvent.which) < 0) {
            var nodes = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            for(var i = 0; i < nodes.length; i++)if (this.isAudioElem(nodes[i])) this.deletedAudio.push(nodes[i]);
        }
        if (this.parent.editorMode === "HTML" && (originalEvent.which === 8 && originalEvent.code === "Backspace" || originalEvent.which === 46 && originalEvent.code === "Delete")) {
            var isCursor_1 = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (originalEvent.which === 8 && originalEvent.code === "Backspace" && isCursor_1) this.checkAudioBack(range);
            else if (originalEvent.which === 46 && originalEvent.code === "Delete" && isCursor_1) this.checkAudioDel(range);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && originalEvent.code !== "KeyK") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            if (!originalEvent.ctrlKey && originalEvent.key && (originalEvent.key.length === 1 || originalEvent.action === "enter") && this.isAudioElem(selectParentEle[0]) && selectParentEle[0].parentElement) {
                var prev = selectParentEle[0].parentElement.childNodes[0];
                this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), prev, prev, prev.textContent.length, prev.textContent.length);
                (0, $4ZDHT.removeClass)([
                    selectParentEle[0]
                ], $afc560df281b588d$export$6ca4282c3a1d5fa5);
                this.quickToolObj.audioQTBar.hidePopup();
            }
        }
        if (originalEvent.ctrlKey && (originalEvent.keyCode === 89 || originalEvent.keyCode === 90)) this.undoStack({
            subCommand: originalEvent.keyCode === 90 ? "undo" : "redo"
        });
        if (originalEvent.keyCode === 8 || originalEvent.keyCode === 46) {
            if (selectNodeEle && this.isAudioElem(selectNodeEle[0]) && selectNodeEle.length < 1) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                originalEvent.preventDefault();
                var event_1 = {
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle,
                    args: {
                        item: {
                            command: "Audios",
                            subCommand: "AudioRemove"
                        },
                        originalEvent: originalEvent
                    }
                };
                this.deleteAudio(event_1, originalEvent.keyCode);
            }
        }
        switch(originalEvent.action){
            case "escape":
                if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) this.dialogObj.close();
                break;
            case "backspace":
            case "delete":
                for(var i = 0; i < this.deletedAudio.length; i++){
                    var src = this.deletedAudio[i].src;
                    this.audioRemovePost(src);
                }
                if (this.parent.editorMode !== "Markdown") {
                    if (range.startContainer.nodeType === 3) {
                        if (originalEvent.code === "Backspace") {
                            if (range.startContainer.previousElementSibling && range.startOffset === 0 && range.startContainer.previousElementSibling.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9)) (0, $4ZDHT.detach)(range.startContainer.previousElementSibling);
                        } else if (range.startContainer.nextElementSibling && range.endContainer.textContent.length === range.endOffset && range.startContainer.nextElementSibling.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9)) (0, $4ZDHT.detach)(range.startContainer.nextElementSibling);
                    } else if (range.startContainer.nodeType === 1 && range.startContainer.classList && (range.startContainer.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) || range.startContainer.classList.contains($afc560df281b588d$export$a13f0f97539de275) || range.startContainer.classList.contains($afc560df281b588d$export$8dfb598a1fc054c7))) (0, $4ZDHT.detach)(range.startContainer);
                }
                break;
            case "insert-audio":
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                this.openDialog(true, originalEvent, save, selectNodeEle, selectParentEle);
                originalEvent.preventDefault();
                break;
        }
        if (originalEvent.ctrlKey && originalEvent.key === "a") this.handleSelectAll();
    };
    Audio.prototype.handleSelectAll = function() {
        var audioFocusNodes = this.parent.inputElement.querySelectorAll("." + $afc560df281b588d$export$6ca4282c3a1d5fa5);
        (0, $4ZDHT.removeClass)(audioFocusNodes, $afc560df281b588d$export$6ca4282c3a1d5fa5);
    };
    Audio.prototype.openDialog = function(isInternal, event, selection, ele, parentEle) {
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        if (!isInternal && !(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = selection;
            selectNodeEle = ele;
            selectParentEle = parentEle;
        }
        if (this.parent.editorMode === "HTML") this.insertAudio({
            args: {
                item: {
                    command: "Audios",
                    subCommand: "Audio"
                },
                originalEvent: event,
                name: !isInternal ? "showDialog" : null
            },
            selectNode: selectNodeEle,
            selection: save,
            selectParent: selectParentEle
        });
    };
    Audio.prototype.showDialog = function() {
        this.openDialog(false);
    };
    Audio.prototype.closeDialog = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Audio.prototype.deleteAudio = function(e, keyCode) {
        if (!this.isAudioElem(e.selectNode[0])) return;
        if (this.audEle) {
            if (e.selectNode[0].nodeType === 3) e.selectNode[0] = this.audEle;
            else if (this.isAudioElem(e.selectNode[0])) e.selectNode[0] = e.selectNode[0].classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) ? e.selectNode[0] : e.selectNode[0].parentElement;
        }
        var args = {
            element: e.selectNode[0].querySelector("audio"),
            src: e.selectNode[0].querySelector("source").getAttribute("src")
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        e.selection.restore();
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
        this.audioRemovePost(args.src);
        if (this.quickToolObj && document.body.contains(this.quickToolObj.audioQTBar.element)) this.quickToolObj.audioQTBar.hidePopup();
        if ((0, $3EnZW.isNullOrUndefined)(keyCode)) this.parent.trigger($947a002e9a697770$export$bd12237ad996f402, args);
    };
    Audio.prototype.audioRemovePost = function(src) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var absoluteUrl = "";
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.insertAudioSettings.removeUrl) || this.parent.insertAudioSettings.removeUrl === "") return;
        if (src.indexOf("http://") > -1 || src.indexOf("https://") > -1) absoluteUrl = src;
        else absoluteUrl = new URL(src, document.baseURI).href;
        this.removingAudioName = absoluteUrl.replace(/^.*[\\/]/, "");
        var xhr = new XMLHttpRequest();
        // eslint-disable-next-line @typescript-eslint/tslint/config
        xhr.addEventListener("readystatechange", function() {
            if (this.readyState === 4 && this.status === 200) proxy.triggerPost(this.response);
        });
        xhr.open("GET", absoluteUrl);
        xhr.responseType = "blob";
        xhr.send();
    };
    Audio.prototype.triggerPost = function(response) {
        var removeUrl = this.parent.insertAudioSettings.removeUrl;
        if ((0, $3EnZW.isNullOrUndefined)(removeUrl) || removeUrl === "") return;
        var file = new File([
            response
        ], this.removingAudioName);
        var ajax = new (0, $cfGuF.Ajax)(removeUrl, "POST", true, null);
        var formData = new FormData();
        formData.append("UploadFiles", file);
        ajax.send(formData);
    };
    Audio.prototype.audioClick = function(e) {
        if ((0, $5q7BP.Browser).isDevice) {
            if (this.isAudioElem(e.target)) {
                this.contentModule.getEditPanel().setAttribute("contenteditable", "false");
                e.target.focus();
            } else if (!this.parent.readonly) this.contentModule.getEditPanel().setAttribute("contenteditable", "true");
        }
        if (this.isAudioElem(e.target)) {
            this.audEle = e.target.querySelector("audio");
            e.preventDefault();
        }
    };
    Audio.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if ((0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel())) return;
        if (this.isAudioElem(target)) this.audEle = target.querySelector("audio");
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj) && (// eslint-disable-next-line
        !(0, $4ZDHT.closest)(target, "[id='" + this.dialogObj.element.id + "'" + "]") && this.parent.toolbarSettings.enable && this.parent.getToolbarElement() && !this.parent.getToolbarElement().contains(e.target) || this.parent.getToolbarElement() && this.parent.getToolbarElement().contains(e.target) && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_toolbar_Audio") && !target.querySelector("#" + this.parent.getID() + "_toolbar_Audio"))) {
            /* eslint-disable */ if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) ;
            else {
                this.parent.notify($947a002e9a697770$export$4895f32c534ef936, {
                    closedBy: "outside click"
                });
                this.dialogObj.hide({
                    returnValue: true
                });
                this.parent.isBlur = true;
                (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
            }
        /* eslint-enable */ }
        if (this.contentModule.getEditPanel().querySelector("." + $afc560df281b588d$export$6ca4282c3a1d5fa5)) {
            if (!this.isAudioElem(e.target) && !(0, $3EnZW.isNullOrUndefined)(this.audEle)) this.audEle.style.outline = "";
            else if (!(0, $3EnZW.isNullOrUndefined)(this.prevSelectedAudEle) && this.prevSelectedAudEle !== target) this.prevSelectedAudEle.style.outline = "";
        }
        if (this.parent.inlineMode.enable && target && this.dialogObj && !(0, $4ZDHT.closest)(target, "#" + this.dialogObj.element.id)) this.dialogObj.hide();
    };
    Audio.prototype.alignmentSelect = function(e) {
        var item = e.item;
        if (!document.body.contains(document.body.querySelector(".e-rte-quick-toolbar")) || item.command !== "Audios") return;
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
        selectNodeEle = [
            this.audEle
        ];
        var args = {
            args: e,
            selectNode: selectNodeEle
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        switch(item.subCommand){
            case "Inline":
                this.inline(args);
                break;
            case "Break":
                this.break(args);
                break;
        }
        if (this.quickToolObj && document.body.contains(this.quickToolObj.audioQTBar.element)) {
            this.quickToolObj.audioQTBar.hidePopup();
            (0, $4ZDHT.removeClass)([
                selectNodeEle[0]
            ], $afc560df281b588d$export$6ca4282c3a1d5fa5);
        }
    };
    Audio.prototype.break = function(e) {
        if (e.selectNode[0].nodeName !== "AUDIO") return;
        var subCommand = e.args.item && e.args.item.subCommand ? e.args.item.subCommand : "Break";
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Audio.prototype.inline = function(e) {
        if (e.selectNode[0].nodeName !== "AUDIO") return;
        var subCommand = e.args.item && e.args.item.subCommand ? e.args.item.subCommand : "Inline";
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Audio.prototype.editAreaClickHandler = function(e) {
        if (this.parent.readonly) {
            this.hideAudioQuickToolbar();
            return;
        }
        var args = e.args;
        var showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (args.which === 2 || showOnRightClick && args.which === 1 || !showOnRightClick && args.which === 3) {
            if (showOnRightClick && args.which === 1 && !(0, $3EnZW.isNullOrUndefined)(args.target) && this.isAudioElem(args.target)) {
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), args.target);
            }
            return;
        }
        if (this.parent.editorMode === "HTML" && this.parent.quickToolbarModule && this.parent.quickToolbarModule.audioQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
            var target = args.target;
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var isPopupOpen = this.quickToolObj.audioQTBar.element.classList.contains("e-rte-pop");
            if (this.isAudioElem(target) && this.parent.quickToolbarModule) {
                if (isPopupOpen) return;
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
                if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, e);
                target.querySelector("audio").style.outline = "2px solid #4a90e2";
                this.showAudioQuickToolbar({
                    args: args,
                    type: "Audios",
                    elements: [
                        args.target
                    ]
                });
            } else this.hideAudioQuickToolbar();
        }
    };
    Audio.prototype.isAudioElem = function(target) {
        if (target && target.nodeType !== 3 && target.nodeName !== "BR" && target.classList && (target.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) || target.classList.contains($afc560df281b588d$export$a13f0f97539de275))) return true;
        else return false;
    };
    Audio.prototype.showAudioQuickToolbar = function(e) {
        var _this = this;
        if (e.type !== "Audios" || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule) || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule.audioQTBar) || (0, $3EnZW.isNullOrUndefined)(e.args)) return;
        this.quickToolObj = this.parent.quickToolbarModule;
        var args = e.args;
        var target = e.elements;
        [].forEach.call(e.elements, function(element, index) {
            if (index === 0) target = element;
        });
        if (this.isAudioElem(target)) {
            (0, $4ZDHT.addClass)([
                target.querySelector("audio")
            ], [
                $afc560df281b588d$export$6ca4282c3a1d5fa5
            ]);
            target.querySelector("audio").style.outline = "2px solid #4a90e2";
        }
        if (this.parent.quickToolbarModule.audioQTBar) {
            if (e.isNotify) this.showPopupTime = setTimeout(function() {
                _this.parent.formatter.editorManager.nodeSelection.Clear(_this.contentModule.getDocument());
                _this.parent.formatter.editorManager.nodeSelection.setSelectionContents(_this.contentModule.getDocument(), target);
                _this.quickToolObj.audioQTBar.showPopup(args.pageX - 50, target.getBoundingClientRect().top + 34, target);
            }, 400);
            else this.quickToolObj.audioQTBar.showPopup(args.pageX - 50, target.getBoundingClientRect().top + 34, target);
        }
    };
    Audio.prototype.hideAudioQuickToolbar = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector("." + $afc560df281b588d$export$6ca4282c3a1d5fa5))) {
            (0, $4ZDHT.removeClass)([
                this.contentModule.getEditPanel().querySelector("." + $afc560df281b588d$export$6ca4282c3a1d5fa5)
            ], $afc560df281b588d$export$6ca4282c3a1d5fa5);
            if (!(0, $3EnZW.isNullOrUndefined)(this.audEle)) this.audEle.style.outline = "";
            if (this.quickToolObj && this.quickToolObj.audioQTBar && document.body.contains(this.quickToolObj.audioQTBar.element)) this.quickToolObj.audioQTBar.hidePopup();
        }
    };
    Audio.prototype.insertingAudio = function(e) {
        this.insertAudio(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            this.dialogObj.element.style.maxHeight = "inherit";
            var dialogContent = this.dialogObj.element.querySelector(".e-audio-content");
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertAudioSettings.path) || this.parent.editorMode === "HTML") document.getElementById(this.rteID + "_insertAudio").focus();
            else dialogContent.querySelector(".e-audio-url").focus();
        }
    };
    Audio.prototype.clearDialogObj = function() {
        if (this.uploadObj && !this.uploadObj.isDestroyed) {
            this.uploadObj.destroy();
            (0, $4ZDHT.detach)(this.uploadObj.element);
            this.uploadObj = null;
        }
        if (this.button && !this.button.isDestroyed) {
            this.button.destroy();
            (0, $4ZDHT.detach)(this.button.element);
            this.button = null;
        }
        if (this.dialogObj && !this.dialogObj.isDestroyed) {
            this.dialogObj.destroy();
            (0, $4ZDHT.detach)(this.dialogObj.element);
            this.dialogObj = null;
        }
    };
    Audio.prototype.insertAudio = function(e) {
        var _this = this;
        if (this.dialogObj) {
            this.dialogObj.hide({
                returnValue: true
            });
            return;
        }
        var audioDialog = this.parent.createElement("div", {
            className: "e-rte-audio-dialog",
            id: this.rteID + "_audio"
        });
        this.parent.rootContainer.appendChild(audioDialog);
        var audioInsert = this.i10n.getConstant("dialogInsert");
        var audiolinkCancel = this.i10n.getConstant("dialogCancel");
        var audioHeader = this.i10n.getConstant("audioHeader");
        var selection = e.selection;
        var selectObj = {
            selfAudio: this,
            selection: e.selection,
            args: e.args,
            selectParent: e.selectParent
        };
        var dialogModel = {
            header: audioHeader,
            cssClass: $afc560df281b588d$export$d3f61cb93957903e,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true,
            closeOnEscape: true,
            width: (0, $5q7BP.Browser).isDevice ? "290px" : "340px",
            isModal: (0, $5q7BP.Browser).isDevice,
            buttons: [
                {
                    click: this.insertAudioUrl.bind(selectObj),
                    buttonModel: {
                        content: audioInsert,
                        cssClass: "e-flat e-insertAudio",
                        isPrimary: true,
                        disabled: true
                    }
                },
                {
                    click: function(e) {
                        _this.cancelDialog(e);
                    },
                    buttonModel: {
                        cssClass: "e-flat e-cancel",
                        content: audiolinkCancel
                    }
                }
            ],
            target: (0, $5q7BP.Browser).isDevice ? document.body : this.parent.element,
            animationSettings: {
                effect: "None"
            },
            close: function(event) {
                if (_this.isAudioUploaded) {
                    if (_this.dialogObj.element.querySelector(".e-file-abort-btn")) _this.dialogObj.element.querySelector(".e-file-abort-btn").click();
                    else _this.uploadObj.remove();
                }
                _this.parent.isBlur = false;
                if (event && !(0, $3EnZW.isNullOrUndefined)(event.event) && event.event.returnValue) {
                    if (_this.parent.editorMode === "HTML") selection.restore();
                }
                _this.clearDialogObj();
                _this.dialogRenderObj.close(event);
            }
        };
        var dialogContent = this.parent.createElement("div", {
            className: "e-audio-content"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertAudioSettings.path) || this.parent.editorMode === "HTML") dialogContent.appendChild(this.audioUpload(e));
        var linkHeader = this.parent.createElement("div", {
            className: "e-audioheader"
        });
        var linkHeaderText = this.i10n.getConstant("audioLinkHeader");
        if (this.parent.editorMode === "HTML") linkHeader.innerHTML = linkHeaderText;
        dialogContent.appendChild(linkHeader);
        dialogContent.appendChild(this.audioUrlPopup(e));
        if (e.selectNode && e.selectNode[0].nodeType === 1 && this.isAudioElem(e.selectNode[0])) {
            dialogModel.header = this.parent.localeObj.getConstant("editAudioHeader");
            dialogModel.content = dialogContent;
        } else dialogModel.content = dialogContent;
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(audioDialog);
        if (e.selectNode && e.selectNode[0].nodeType === 1 && this.isAudioElem(e.selectNode[0]) && e.name === "insertAudio") this.dialogObj.element.querySelector(".e-insertAudio").textContent = this.parent.localeObj.getConstant("dialogUpdate");
        audioDialog.style.maxHeight = "inherit";
        if (this.quickToolObj) {
            if (this.quickToolObj.audioQTBar && document.body.contains(this.quickToolObj.audioQTBar.element)) this.quickToolObj.audioQTBar.hidePopup();
            if (this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) this.quickToolObj.inlineQTBar.hidePopup();
            if (this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) this.quickToolObj.textQTBar.hidePopup();
        }
    };
    Audio.prototype.audioUrlPopup = function(e) {
        var _this = this;
        var audioUrl = this.parent.createElement("div", {
            className: "audioUrl"
        });
        var placeUrl = this.i10n.getConstant("audioUrl");
        this.inputUrl = this.parent.createElement("input", {
            className: "e-input e-audio-url",
            attrs: {
                placeholder: placeUrl,
                spellcheck: "false",
                "aria-label": this.i10n.getConstant("audioLinkHeader")
            }
        });
        this.inputUrl.addEventListener("input", function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.inputUrl)) {
                if (_this.inputUrl.value.length === 0) _this.dialogObj.getButtons(0).element.disabled = true;
                else _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
            }
        });
        if (e.selectNode && this.isAudioElem(e.selectNode[0])) {
            var regex = new RegExp(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi);
            var sourceElement = e.selectNode[0].querySelector("source");
            this.inputUrl.value = sourceElement.src.match(regex) ? sourceElement.src : "";
        }
        audioUrl.appendChild(this.inputUrl);
        return audioUrl;
    };
    Audio.prototype.audioUpload = function(e) {
        var _this = this;
        var save;
        var selectParent;
        // eslint-disable-next-line
        var proxy = this;
        var iframe = proxy.parent.iframeSettings.enable;
        if (proxy.parent.editorMode === "HTML" && (!iframe && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.selection.range.startContainer.parentNode, "[id='" + this.parent.contentModule.getPanel().id + "'" + "]")) || iframe && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(e.selection.range.startContainer.parentNode.ownerDocument.querySelector("body"), "e-lib"))) {
            this.contentModule.getEditPanel().focus();
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = e.selection;
            selectParent = e.selectParent;
        }
        var uploadParentEle = this.parent.createElement("div", {
            className: "e-aud-uploadwrap e-droparea"
        });
        var deviceAudioUpMsg = this.i10n.getConstant("audioDeviceUploadMessage");
        var audioUpMsg = this.i10n.getConstant("audioUploadMessage");
        var span = this.parent.createElement("span", {
            className: "e-droptext"
        });
        var spanMsg = this.parent.createElement("span", {
            className: "e-rte-upload-text",
            innerHTML: (0, $5q7BP.Browser).isDevice ? deviceAudioUpMsg : audioUpMsg
        });
        span.appendChild(spanMsg);
        var btnEle = this.parent.createElement("button", {
            className: "e-browsebtn",
            id: this.rteID + "_insertAudio",
            attrs: {
                autofocus: "true",
                type: "button"
            }
        });
        span.appendChild(btnEle);
        uploadParentEle.appendChild(span);
        var browserMsg = this.i10n.getConstant("browse");
        this.button = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            content: browserMsg,
            enableRtl: this.parent.enableRtl
        });
        this.button.isStringTemplate = true;
        this.button.createElement = this.parent.createElement;
        this.button.appendTo(btnEle);
        var btnClick = (0, $5q7BP.Browser).isDevice ? span : btnEle;
        (0, $aqzbR.EventHandler).add(btnClick, "click", this.fileSelect, this);
        var uploadEle = this.parent.createElement("input", {
            id: this.rteID + "_upload",
            attrs: {
                type: "File",
                name: "UploadFiles"
            }
        });
        uploadParentEle.appendChild(uploadEle);
        var fileName;
        var selectArgs;
        var filesData;
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            asyncSettings: {
                saveUrl: this.parent.insertAudioSettings.saveUrl,
                removeUrl: this.parent.insertAudioSettings.removeUrl
            },
            dropArea: span,
            multiple: false,
            enableRtl: this.parent.enableRtl,
            allowedExtensions: this.parent.insertAudioSettings.allowedTypes.toString(),
            selected: function(e) {
                proxy.isAudioUploaded = true;
                selectArgs = e;
                // eslint-disable-next-line
                filesData = e.filesData;
                _this.parent.trigger($947a002e9a697770$export$cd4c780a3205848c, selectArgs, function(selectArgs) {
                    if (!selectArgs.cancel) {
                        _this.checkExtension(selectArgs.filesData[0]);
                        fileName = selectArgs.filesData[0].name;
                        if (_this.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)(_this.parent.insertAudioSettings.path)) {
                            var reader_1 = new FileReader();
                            // eslint-disable-next-line
                            reader_1.addEventListener("load", function(e) {
                                var url = _this.parent.insertAudioSettings.saveFormat === "Base64" ? reader_1.result : URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(reader_1.result));
                                proxy.uploadUrl = {
                                    url: url,
                                    selection: save,
                                    fileName: fileName,
                                    selectParent: selectParent
                                };
                                proxy.inputUrl.setAttribute("disabled", "true");
                                if ((0, $3EnZW.isNullOrUndefined)(proxy.parent.insertAudioSettings.saveUrl) && _this.isAllowedTypes && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj)) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                            });
                            reader_1.readAsDataURL(selectArgs.filesData[0].rawFile);
                        }
                    }
                });
            },
            beforeUpload: function(args) {
                _this.parent.trigger($947a002e9a697770$export$cc40225aa9b0a067, args);
            },
            uploading: function(e) {
                if (!_this.parent.isServerRendered) _this.parent.trigger($947a002e9a697770$export$ea51d7451bf2a8d8, e);
            },
            success: function(e) {
                _this.parent.trigger($947a002e9a697770$export$765cb3120ada5f48, e, function(e) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.insertAudioSettings.path)) {
                        var url = _this.parent.insertAudioSettings.path + e.file.name;
                        // eslint-disable-next-line
                        var value = {
                            url: url,
                            selection: save
                        };
                        proxy.uploadUrl = {
                            url: url,
                            selection: save,
                            fileName: fileName,
                            selectParent: selectParent
                        };
                        proxy.inputUrl.setAttribute("disabled", "true");
                    }
                    if (e.operation === "upload" && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj)) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                });
            },
            failure: function(e) {
                _this.parent.trigger($947a002e9a697770$export$f32e611c2450ce56, e);
            },
            removing: function() {
                // eslint-disable-next-line
                _this.parent.trigger($947a002e9a697770$export$af6060fcb094c173, e, function(e) {
                    proxy.isAudioUploaded = false;
                    _this.dialogObj.getButtons(0).element.disabled = true;
                    proxy.inputUrl.removeAttribute("disabled");
                    if (proxy.uploadUrl) proxy.uploadUrl.url = "";
                });
            }
        });
        this.uploadObj.isStringTemplate = true;
        this.uploadObj.createElement = this.parent.createElement;
        this.uploadObj.appendTo(uploadEle);
        return uploadParentEle;
    };
    Audio.prototype.checkExtension = function(e) {
        if (this.uploadObj.allowedExtensions) {
            if (this.uploadObj.allowedExtensions.toLocaleLowerCase().indexOf(("." + e.type).toLocaleLowerCase()) === -1) {
                this.dialogObj.getButtons(0).element.setAttribute("disabled", "disabled");
                this.isAllowedTypes = false;
            } else this.isAllowedTypes = true;
        }
    };
    Audio.prototype.fileSelect = function() {
        this.dialogObj.element.getElementsByClassName("e-file-select-wrap")[0].querySelector("button").click();
        return false;
    };
    // eslint-disable-next-line
    Audio.prototype.cancelDialog = function(e) {
        this.parent.isBlur = false;
        this.dialogObj.hide({
            returnValue: true
        });
        if (this.isAudioUploaded) this.uploadObj.removing();
    };
    // eslint-disable-next-line
    Audio.prototype.insertAudioUrl = function(e) {
        var proxy = this.selfAudio;
        //let audioSelectParent: Node = proxy.uploadUrl.selectParent[0];
        proxy.isAudioUploaded = false;
        var url = proxy.inputUrl.value;
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        if (!(0, $3EnZW.isNullOrUndefined)(proxy.uploadUrl) && proxy.uploadUrl.url !== "") {
            proxy.uploadUrl.cssClass = proxy.parent.insertAudioSettings.layoutOption === "Inline" ? $afc560df281b588d$export$aa04ae99872a701a : $afc560df281b588d$export$4a726e255dce0eee;
            proxy.dialogObj.hide({
                returnValue: false
            });
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, proxy.uploadUrl);
            proxy.uploadUrl.url = "";
        } else if (url !== "") {
            if (proxy.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(// eslint-disable-next-line
            this.selection.range.startContainer.parentNode, "[id='" + proxy.contentModule.getPanel().id + "'" + "]"))) {
                proxy.contentModule.getEditPanel().focus();
                var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.contentModule.getDocument());
                this.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.contentModule.getDocument());
                this.selectParent = proxy.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            }
            var name_1 = proxy.parent.editorMode === "HTML" ? url.split("/")[url.split("/").length - 1] : "";
            var value = {
                cssClass: proxy.parent.insertAudioSettings.layoutOption === "Inline" ? $afc560df281b588d$export$aa04ae99872a701a : $afc560df281b588d$export$4a726e255dce0eee,
                url: url,
                selection: this.selection,
                fileName: name_1,
                selectParent: this.selectParent
            };
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, value);
            proxy.dialogObj.hide({
                returnValue: false
            });
        }
    };
    /* eslint-disable */ /**
     * Destroys the ToolBar.
     *
     * @method destroy
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ Audio.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.prevSelectedAudEle = undefined;
        if (this.showPopupTime) {
            clearTimeout(this.showPopupTime);
            this.showPopupTime = null;
        }
        this.removeEventListener();
        this.clearDialogObj();
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ Audio.prototype.getModuleName = function() {
        return "audio";
    };
    return Audio;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



/**
 * `Count` module is used to handle Count actions.
 */ var $c0eb54371c63e3e0$export$5c31959b0a6b6e24 = /** @class */ function() {
    function Count(parent, serviceLocator) {
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
        this.isDestroyed = false;
    }
    Count.prototype.initializeInstance = function() {
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        this.editPanel = this.contentRenderer.getEditPanel();
        this.addEventListener();
    };
    /**
     * renderCount method
     *
     * @returns {void}
     * @hidden

     */ Count.prototype.renderCount = function() {
        this.initializeInstance();
        this.element = this.parent.createElement("span", {
            className: (0, $afc560df281b588d$export$e8557914480abfcd)
        });
        this.parent.rootContainer.appendChild(this.element);
        this.parent.rootContainer.classList.add("e-count-enabled");
        if (this.parent.iframeSettings.enable) this.parent.inputElement.classList.add("e-count-enabled");
        this.appendCount();
        if (this.parent.maxLength !== -1) this.charCountBackground(this.htmlLength);
    };
    Count.prototype.appendCount = function() {
        var htmlText = this.parent.editorMode === "Markdown" ? this.editPanel.value : this.parent.getText().replace(/(\r\n|\n|\r|\t)/gm, "");
        if (this.parent.editorMode !== "Markdown" && htmlText.indexOf("\u200B") !== -1) this.htmlLength = htmlText.replace(/\u200B/g, "").length;
        else this.htmlLength = htmlText.length;
        var string = this.parent.maxLength === -1 ? this.htmlLength : this.htmlLength + " / " + this.parent.maxLength;
        this.element.innerHTML = string;
    };
    Count.prototype.charCountBackground = function(htmlLength) {
        var percentage = htmlLength / this.parent.maxLength * 100;
        if (percentage < 85) {
            this.element.classList.remove((0, $afc560df281b588d$export$fcbb96fdfda8178b));
            this.element.classList.remove((0, $afc560df281b588d$export$c72e8d6e86fd4559));
        } else if (percentage > 85 && percentage <= 90) {
            this.element.classList.remove((0, $afc560df281b588d$export$c72e8d6e86fd4559));
            this.element.classList.add((0, $afc560df281b588d$export$fcbb96fdfda8178b));
        } else if (percentage > 90) {
            this.element.classList.remove((0, $afc560df281b588d$export$fcbb96fdfda8178b));
            this.element.classList.add((0, $afc560df281b588d$export$c72e8d6e86fd4559));
        }
    };
    /**
     * @returns {void}
     * @hidden

     */ Count.prototype.refresh = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.editPanel)) {
            this.appendCount();
            if (this.parent.maxLength !== -1) this.charCountBackground(this.htmlLength);
        }
    };
    /**
     * Destroys the Count.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ Count.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.parent && this.parent.rootContainer && this.parent.rootContainer.classList.contains("e-count-enabled")) this.parent.rootContainer.classList.remove("e-count-enabled");
        if (this.parent.iframeSettings.enable && !(0, $3EnZW.isNullOrUndefined)(this.parent.inputElement)) this.parent.inputElement.classList.remove("e-count-enabled");
        if (this.element && !(0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector("." + (0, $afc560df281b588d$export$e8557914480abfcd)))) (0, $4ZDHT.detach)(this.element);
        this.removeEventListener();
        if (this.editPanel) this.editPanel = null;
        if (this.element) {
            (0, $4ZDHT.detach)(this.element);
            this.element = null;
        }
        this.isDestroyed = true;
    };
    Count.prototype.toggle = function(e) {
        this.element.style.display = e.member === "viewSource" ? "none" : "block";
    };
    Count.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.renderCount, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.refresh, this);
        this.parent.on($947a002e9a697770$export$85b9a36db797e02b, this.refresh, this);
        this.parent.on($947a002e9a697770$export$8502058ba5fe50a0, this.refresh, this);
        this.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, this.refresh, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$a03f62af6e933a3, this.toggle, this);
        this.parent.on($947a002e9a697770$export$328b0edc9fda3a36, this.toggle, this);
    };
    Count.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.renderCount);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.refresh);
        this.parent.off($947a002e9a697770$export$8502058ba5fe50a0, this.refresh);
        this.parent.off($947a002e9a697770$export$85b9a36db797e02b, this.refresh);
        this.parent.off($947a002e9a697770$export$ea32a7693b83cfdb, this.refresh);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$a03f62af6e933a3, this.toggle);
        this.parent.off($947a002e9a697770$export$328b0edc9fda3a36, this.toggle);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string value
     */ Count.prototype.getModuleName = function() {
        return "count";
    };
    return Count;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $jmffE = parcelRequire("jmffE");
var $3EnZW = parcelRequire("3EnZW");

var $2vAqh = parcelRequire("2vAqh");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $c2qqN = parcelRequire("c2qqN");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $3P3ke = parcelRequire("3P3ke");

var $cWXlQ = parcelRequire("cWXlQ");
var $2vAqh = parcelRequire("2vAqh");



var $6e0c0888b69d6c4c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e0c0888b69d6c4c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6e0c0888b69d6c4c$var$CLS_VERTICAL = "e-vertical";
var $6e0c0888b69d6c4c$var$CLS_ITEMS = "e-toolbar-items";
var $6e0c0888b69d6c4c$var$CLS_ITEM = "e-toolbar-item";
var $6e0c0888b69d6c4c$var$CLS_RTL = "e-rtl";
var $6e0c0888b69d6c4c$var$CLS_SEPARATOR = "e-separator";
var $6e0c0888b69d6c4c$var$CLS_POPUPICON = "e-popup-up-icon";
var $6e0c0888b69d6c4c$var$CLS_POPUPDOWN = "e-popup-down-icon";
var $6e0c0888b69d6c4c$var$CLS_POPUPOPEN = "e-popup-open";
var $6e0c0888b69d6c4c$var$CLS_TEMPLATE = "e-template";
var $6e0c0888b69d6c4c$var$CLS_DISABLE = "e-overlay";
var $6e0c0888b69d6c4c$var$CLS_POPUPTEXT = "e-toolbar-text";
var $6e0c0888b69d6c4c$var$CLS_TBARTEXT = "e-popup-text";
var $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW = "e-overflow-show";
var $6e0c0888b69d6c4c$var$CLS_POPOVERFLOW = "e-overflow-hide";
var $6e0c0888b69d6c4c$var$CLS_TBARBTN = "e-tbar-btn";
var $6e0c0888b69d6c4c$var$CLS_TBARNAV = "e-hor-nav";
var $6e0c0888b69d6c4c$var$CLS_TBARSCRLNAV = "e-scroll-nav";
var $6e0c0888b69d6c4c$var$CLS_TBARRIGHT = "e-toolbar-right";
var $6e0c0888b69d6c4c$var$CLS_TBARLEFT = "e-toolbar-left";
var $6e0c0888b69d6c4c$var$CLS_TBARCENTER = "e-toolbar-center";
var $6e0c0888b69d6c4c$var$CLS_TBARPOS = "e-tbar-pos";
var $6e0c0888b69d6c4c$var$CLS_HSCROLLCNT = "e-hscroll-content";
var $6e0c0888b69d6c4c$var$CLS_VSCROLLCNT = "e-vscroll-content";
var $6e0c0888b69d6c4c$var$CLS_HSCROLLBAR = "e-hscroll-bar";
var $6e0c0888b69d6c4c$var$CLS_POPUPNAV = "e-hor-nav";
var $6e0c0888b69d6c4c$var$CLS_POPUPCLASS = "e-toolbar-pop";
var $6e0c0888b69d6c4c$var$CLS_POPUP = "e-toolbar-popup";
var $6e0c0888b69d6c4c$var$CLS_TBARBTNTEXT = "e-tbar-btn-text";
var $6e0c0888b69d6c4c$var$CLS_TBARNAVACT = "e-nav-active";
var $6e0c0888b69d6c4c$var$CLS_TBARIGNORE = "e-ignore";
var $6e0c0888b69d6c4c$var$CLS_POPPRI = "e-popup-alone";
var $6e0c0888b69d6c4c$var$CLS_HIDDEN = "e-hidden";
var $6e0c0888b69d6c4c$var$CLS_MULTIROW = "e-toolbar-multirow";
var $6e0c0888b69d6c4c$var$CLS_MULTIROWPOS = "e-multirow-pos";
var $6e0c0888b69d6c4c$var$CLS_MULTIROW_SEPARATOR = "e-multirow-separator";
var $6e0c0888b69d6c4c$var$CLS_EXTENDABLE_SEPARATOR = "e-extended-separator";
var $6e0c0888b69d6c4c$var$CLS_EXTEANDABLE_TOOLBAR = "e-extended-toolbar";
var $6e0c0888b69d6c4c$var$CLS_EXTENDABLECLASS = "e-toolbar-extended";
var $6e0c0888b69d6c4c$var$CLS_EXTENDPOPUP = "e-expended-nav";
var $6e0c0888b69d6c4c$var$CLS_EXTENDEDPOPOPEN = "e-tbar-extended";
/**
 * An item object that is used to configure Toolbar commands.
 */ var $6e0c0888b69d6c4c$export$6d08773d2e66f8f2 = /** @class */ function(_super) {
    $6e0c0888b69d6c4c$var$__extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "id", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "text", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Item.prototype, "width", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "cssClass", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Item.prototype, "showAlwaysInPopup", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Item.prototype, "disabled", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "prefixIcon", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "suffixIcon", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Item.prototype, "visible", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Item.prototype, "overflow", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "template", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("Button")
    ], Item.prototype, "type", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], Item.prototype, "showTextOn", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Item.prototype, "htmlAttributes", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "tooltipText", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], Item.prototype, "align", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Event)()
    ], Item.prototype, "click", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(-1)
    ], Item.prototype, "tabIndex", void 0);
    return Item;
}((0, $3fcxu.ChildProperty));
/**
 * The Toolbar control contains a group of commands that are aligned horizontally.
 * ```html
 * <div id="toolbar"/>
 * <script>
 *   var toolbarObj = new Toolbar();
 *   toolbarObj.appendTo("#toolbar");
 * </script>
 * ```
 */ var $6e0c0888b69d6c4c$export$4c260019440d418f = /** @class */ function(_super) {
    $6e0c0888b69d6c4c$var$__extends(Toolbar, _super);
    /**
     * Initializes a new instance of the Toolbar class.
     *
     * @param {ToolbarModel} options  - Specifies Toolbar model properties as options.
     * @param { string | HTMLElement} element  - Specifies the element that is rendered as a Toolbar.
     */ function Toolbar(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.resizeContext = _this.resize.bind(_this);
        _this.orientationChangeContext = _this.orientationChange.bind(_this);
        /**
         * Contains the keyboard configuration of the Toolbar.
         */ _this.keyConfigs = {
            moveLeft: "leftarrow",
            moveRight: "rightarrow",
            moveUp: "uparrow",
            moveDown: "downarrow",
            popupOpen: "enter",
            popupClose: "escape",
            tab: "tab",
            home: "home",
            end: "end"
        };
        return _this;
    }
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}.
     */ Toolbar.prototype.destroy = function() {
        var _this = this;
        if (this.isReact || this.isAngular) this.clearTemplate();
        var btnItems = this.element.querySelectorAll(".e-control.e-btn");
        [].slice.call(btnItems).forEach(function(el) {
            if (!(0, $3EnZW.isNullOrUndefined)(el) && !(0, $3EnZW.isNullOrUndefined)(el.ej2_instances) && !(0, $3EnZW.isNullOrUndefined)(el.ej2_instances[0]) && !el.ej2_instances[0].isDestroyed) el.ej2_instances[0].destroy();
        });
        this.unwireEvents();
        this.tempId.forEach(function(ele) {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.element.querySelector(ele))) document.body.appendChild(_this.element.querySelector(ele)).style.display = "none";
        });
        this.destroyItems();
        while(this.element.lastElementChild)this.element.removeChild(this.element.lastElementChild);
        if (this.trgtEle) {
            this.element.appendChild(this.ctrlTem);
            this.trgtEle = null;
            this.ctrlTem = null;
        }
        if (this.popObj) {
            this.popObj.destroy();
            (0, $4ZDHT.detach)(this.popObj.element);
        }
        if (this.activeEle) this.activeEle = null;
        this.popObj = null;
        this.tbarAlign = null;
        this.tbarItemsCol = [];
        this.remove(this.element, "e-toolpop");
        if (this.cssClass) (0, $4ZDHT.removeClass)([
            this.element
        ], this.cssClass.split(" "));
        this.element.removeAttribute("style");
        [
            "aria-disabled",
            "aria-orientation",
            "role"
        ].forEach(function(attrb) {
            return _this.element.removeAttribute(attrb);
        });
        _super.prototype.destroy.call(this);
    };
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */ Toolbar.prototype.preRender = function() {
        var eventArgs = {
            enableCollision: this.enableCollision,
            scrollStep: this.scrollStep
        };
        this.trigger("beforeCreate", eventArgs);
        this.enableCollision = eventArgs.enableCollision;
        this.scrollStep = eventArgs.scrollStep;
        this.scrollModule = null;
        this.popObj = null;
        this.tempId = [];
        this.tbarItemsCol = this.items;
        this.isVertical = this.element.classList.contains($6e0c0888b69d6c4c$var$CLS_VERTICAL) ? true : false;
        this.isExtendedOpen = false;
        this.popupPriCount = 0;
        if (this.enableRtl) this.add(this.element, $6e0c0888b69d6c4c$var$CLS_RTL);
    };
    Toolbar.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, "click", this.clickHandler, this);
        window.addEventListener("resize", this.resizeContext);
        window.addEventListener("orientationchange", this.orientationChangeContext);
        if (this.allowKeyboard) this.wireKeyboardEvent();
    };
    Toolbar.prototype.wireKeyboardEvent = function() {
        this.keyModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs
        });
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.docKeyDown, this);
        this.updateTabIndex("0");
    };
    Toolbar.prototype.updateTabIndex = function(tabIndex) {
        var ele = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_DISABLE + " ):not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + " ):not(." + $6e0c0888b69d6c4c$var$CLS_HIDDEN + " )");
        if (!(0, $3EnZW.isNullOrUndefined)(ele) && !(0, $3EnZW.isNullOrUndefined)(ele.firstElementChild)) {
            var dataTabIndex = ele.firstElementChild.getAttribute("data-tabindex");
            if (dataTabIndex && dataTabIndex === "-1" && ele.firstElementChild.tagName !== "INPUT") ele.firstElementChild.setAttribute("tabindex", tabIndex);
        }
    };
    Toolbar.prototype.unwireKeyboardEvent = function() {
        if (this.keyModule) {
            (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.docKeyDown);
            this.keyModule.destroy();
            this.keyModule = null;
        }
    };
    Toolbar.prototype.docKeyDown = function(e) {
        if (e.target.tagName === "INPUT") return;
        var popCheck = !(0, $3EnZW.isNullOrUndefined)(this.popObj) && (0, $4ZDHT.isVisible)(this.popObj.element) && this.overflowMode !== "Extended";
        if (e.keyCode === 9 && e.target.classList.contains("e-hor-nav") === true && popCheck) this.popObj.hide({
            name: "FadeOut",
            duration: 100
        });
        var keyCheck = e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 35 || e.keyCode === 36;
        if (keyCheck) e.preventDefault();
    };
    Toolbar.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.clickHandler);
        this.destroyScroll();
        this.unwireKeyboardEvent();
        window.removeEventListener("resize", this.resizeContext);
        window.removeEventListener("orientationchange", this.orientationChangeContext);
        document.removeEventListener("scroll", this.clickEvent);
        document.removeEventListener("click", this.scrollEvent);
        this.scrollEvent = null;
        this.clickEvent = null;
    };
    Toolbar.prototype.clearProperty = function() {
        this.tbarEle = [];
        this.tbarAlgEle = {
            lefts: [],
            centers: [],
            rights: []
        };
    };
    Toolbar.prototype.docEvent = function(e) {
        var popEle = (0, $4ZDHT.closest)(e.target, ".e-popup");
        if (this.popObj && (0, $4ZDHT.isVisible)(this.popObj.element) && !popEle && this.overflowMode === "Popup") this.popObj.hide({
            name: "FadeOut",
            duration: 100
        });
    };
    Toolbar.prototype.destroyScroll = function() {
        if (this.scrollModule) {
            if (this.tbarAlign) this.add(this.scrollModule.element, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
            this.scrollModule.destroy();
            this.scrollModule = null;
        }
    };
    Toolbar.prototype.destroyItems = function() {
        if (this.element) [].slice.call(this.element.querySelectorAll("." + $6e0c0888b69d6c4c$var$CLS_ITEM)).forEach(function(el) {
            (0, $4ZDHT.detach)(el);
        });
        if (this.tbarAlign) {
            var tbarItems = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
            [].slice.call(tbarItems.children).forEach(function(el) {
                (0, $4ZDHT.detach)(el);
            });
            this.tbarAlign = false;
            this.remove(tbarItems, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
        }
        this.clearProperty();
    };
    Toolbar.prototype.destroyMode = function() {
        if (this.scrollModule) {
            this.remove(this.scrollModule.element, $6e0c0888b69d6c4c$var$CLS_RTL);
            this.destroyScroll();
        }
        this.remove(this.element, $6e0c0888b69d6c4c$var$CLS_EXTENDEDPOPOPEN);
        this.remove(this.element, $6e0c0888b69d6c4c$var$CLS_EXTEANDABLE_TOOLBAR);
        var tempEle = this.element.querySelector(".e-toolbar-multirow");
        if (tempEle) this.remove(tempEle, $6e0c0888b69d6c4c$var$CLS_MULTIROW);
        if (this.popObj) this.popupRefresh(this.popObj.element, true);
    };
    Toolbar.prototype.add = function(ele, val) {
        ele.classList.add(val);
    };
    Toolbar.prototype.remove = function(ele, val) {
        ele.classList.remove(val);
    };
    Toolbar.prototype.elementFocus = function(ele) {
        var fChild = ele.firstElementChild;
        if (fChild) {
            fChild.focus();
            this.activeEleSwitch(ele);
        } else ele.focus();
    };
    Toolbar.prototype.clstElement = function(tbrNavChk, trgt) {
        var clst;
        if (tbrNavChk && this.popObj && (0, $4ZDHT.isVisible)(this.popObj.element)) clst = this.popObj.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM);
        else if (this.element === trgt || tbrNavChk) clst = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_DISABLE + " ):not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + " ):not(." + $6e0c0888b69d6c4c$var$CLS_HIDDEN + " )");
        else clst = (0, $4ZDHT.closest)(trgt, "." + $6e0c0888b69d6c4c$var$CLS_ITEM);
        return clst;
    };
    Toolbar.prototype.keyHandling = function(clst, e, trgt, navChk, scrollChk) {
        var popObj = this.popObj;
        var rootEle = this.element;
        var popAnimate = {
            name: "FadeOut",
            duration: 100
        };
        var value = e.action === "moveUp" ? "previous" : "next";
        var ele;
        var nodes;
        switch(e.action){
            case "moveRight":
                if (this.isVertical) return;
                if (rootEle === trgt) this.elementFocus(clst);
                else if (!navChk) this.eleFocus(clst, "next");
                break;
            case "moveLeft":
                if (this.isVertical) return;
                if (!navChk) this.eleFocus(clst, "previous");
                break;
            case "home":
            case "end":
                if (clst) {
                    var popupCheck = (0, $4ZDHT.closest)(clst, ".e-popup");
                    var extendedPopup = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_EXTENDABLECLASS);
                    if (this.overflowMode === "Extended" && extendedPopup && extendedPopup.classList.contains("e-popup-open")) popupCheck = e.action === "end" ? extendedPopup : null;
                    if (popupCheck) {
                        if ((0, $4ZDHT.isVisible)(this.popObj.element)) {
                            nodes = [].slice.call(popupCheck.children);
                            if (e.action === "home") ele = this.focusFirstVisibleEle(nodes);
                            else ele = this.focusLastVisibleEle(nodes);
                        }
                    } else {
                        nodes = this.element.querySelectorAll("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + ")");
                        if (e.action === "home") ele = this.focusFirstVisibleEle(nodes);
                        else ele = this.focusLastVisibleEle(nodes);
                    }
                    if (ele) this.elementFocus(ele);
                }
                break;
            case "moveUp":
            case "moveDown":
                if (!this.isVertical) {
                    if (popObj && (0, $4ZDHT.closest)(trgt, ".e-popup")) {
                        var popEle = popObj.element;
                        var popFrstEle = popEle.firstElementChild;
                        if (value === "previous" && popFrstEle === clst) popEle.lastElementChild.firstChild.focus();
                        else if (value === "next" && popEle.lastElementChild === clst) popFrstEle.firstChild.focus();
                        else this.eleFocus(clst, value);
                    } else if (e.action === "moveDown" && popObj && (0, $4ZDHT.isVisible)(popObj.element)) this.elementFocus(clst);
                } else if (e.action === "moveUp") this.eleFocus(clst, "previous");
                else this.eleFocus(clst, "next");
                break;
            case "tab":
                if (!scrollChk && !navChk) {
                    var ele_1 = clst.firstElementChild;
                    if (rootEle === trgt) {
                        if (this.activeEle) this.activeEle.focus();
                        else {
                            this.activeEleRemove(ele_1);
                            ele_1.focus();
                        }
                    }
                }
                break;
            case "popupClose":
                if (popObj && this.overflowMode !== "Extended") popObj.hide(popAnimate);
                break;
            case "popupOpen":
                if (!navChk) return;
                if (popObj && !(0, $4ZDHT.isVisible)(popObj.element)) {
                    popObj.element.style.top = rootEle.offsetHeight + "px";
                    popObj.show({
                        name: "FadeIn",
                        duration: 100
                    });
                } else popObj.hide(popAnimate);
                break;
        }
    };
    Toolbar.prototype.keyActionHandler = function(e) {
        var trgt = e.target;
        if (trgt.tagName === "INPUT" || trgt.tagName === "TEXTAREA" || this.element.classList.contains($6e0c0888b69d6c4c$var$CLS_DISABLE)) return;
        e.preventDefault();
        var tbrNavChk = trgt.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARNAV);
        var tbarScrollChk = trgt.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARSCRLNAV);
        var clst = this.clstElement(tbrNavChk, trgt);
        if (clst || tbarScrollChk) this.keyHandling(clst, e, trgt, tbrNavChk, tbarScrollChk);
    };
    /**
     * Specifies the value to disable/enable the Toolbar component.
     * When set to `true`, the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, Toolbar will be enabled (false) or disabled (true).
     * @returns {void}.
     */ Toolbar.prototype.disable = function(value) {
        var rootEle = this.element;
        if (value) rootEle.classList.add($6e0c0888b69d6c4c$var$CLS_DISABLE);
        else rootEle.classList.remove($6e0c0888b69d6c4c$var$CLS_DISABLE);
        if (this.activeEle) this.activeEle.setAttribute("tabindex", this.activeEle.getAttribute("data-tabindex"));
        if (this.scrollModule) this.scrollModule.disable(value);
        if (this.popObj) {
            if ((0, $4ZDHT.isVisible)(this.popObj.element) && this.overflowMode !== "Extended") this.popObj.hide();
            rootEle.querySelector("#" + rootEle.id + "_nav").setAttribute("tabindex", !value ? "0" : "-1");
        }
    };
    Toolbar.prototype.eleContains = function(el) {
        return el.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR) || el.classList.contains($6e0c0888b69d6c4c$var$CLS_DISABLE) || el.getAttribute("disabled") || el.classList.contains($6e0c0888b69d6c4c$var$CLS_HIDDEN) || !(0, $4ZDHT.isVisible)(el) || !el.classList.contains($6e0c0888b69d6c4c$var$CLS_ITEM);
    };
    Toolbar.prototype.focusFirstVisibleEle = function(nodes) {
        var element;
        var index = 0;
        while(index < nodes.length){
            var ele = nodes[parseInt(index.toString(), 10)];
            if (!ele.classList.contains($6e0c0888b69d6c4c$var$CLS_HIDDEN) && !ele.classList.contains($6e0c0888b69d6c4c$var$CLS_DISABLE)) return ele;
            index++;
        }
        return element;
    };
    Toolbar.prototype.focusLastVisibleEle = function(nodes) {
        var element;
        var index = nodes.length - 1;
        while(index >= 0){
            var ele = nodes[parseInt(index.toString(), 10)];
            if (!ele.classList.contains($6e0c0888b69d6c4c$var$CLS_HIDDEN) && !ele.classList.contains($6e0c0888b69d6c4c$var$CLS_DISABLE)) return ele;
            index--;
        }
        return element;
    };
    Toolbar.prototype.eleFocus = function(closest, pos) {
        var sib = Object(closest)[pos + "ElementSibling"];
        if (sib) {
            var skipEle = this.eleContains(sib);
            if (skipEle) {
                this.eleFocus(sib, pos);
                return;
            }
            this.elementFocus(sib);
        } else if (this.tbarAlign) {
            var elem = Object(closest.parentElement)[pos + "ElementSibling"];
            if (!(0, $3EnZW.isNullOrUndefined)(elem) && elem.children.length === 0) elem = Object(elem)[pos + "ElementSibling"];
            if (!(0, $3EnZW.isNullOrUndefined)(elem) && elem.children.length > 0) {
                if (pos === "next") {
                    var el = elem.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM);
                    if (this.eleContains(el)) this.eleFocus(el, pos);
                    else {
                        el.firstElementChild.focus();
                        this.activeEleSwitch(el);
                    }
                } else {
                    var el = elem.lastElementChild;
                    if (this.eleContains(el)) this.eleFocus(el, pos);
                    else this.elementFocus(el);
                }
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(closest)) {
            var tbrItems = this.element.querySelectorAll("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + ")" + ":not(." + $6e0c0888b69d6c4c$var$CLS_DISABLE + ")" + ":not(." + $6e0c0888b69d6c4c$var$CLS_HIDDEN + ")");
            if (pos === "next" && tbrItems) this.elementFocus(tbrItems[0]);
            else if (pos === "previous" && tbrItems) this.elementFocus(tbrItems[tbrItems.length - 1]);
        }
    };
    Toolbar.prototype.clickHandler = function(e) {
        var _this = this;
        var trgt = e.target;
        var ele = this.element;
        var isPopupElement = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(trgt, "." + $6e0c0888b69d6c4c$var$CLS_POPUPCLASS));
        var clsList = trgt.classList;
        var popupNav = (0, $4ZDHT.closest)(trgt, "." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        if (!popupNav) popupNav = trgt;
        if (!ele.children[0].classList.contains("e-hscroll") && !ele.children[0].classList.contains("e-vscroll") && clsList.contains($6e0c0888b69d6c4c$var$CLS_TBARNAV)) clsList = trgt.querySelector(".e-icons").classList;
        if (clsList.contains($6e0c0888b69d6c4c$var$CLS_POPUPICON) || clsList.contains($6e0c0888b69d6c4c$var$CLS_POPUPDOWN)) this.popupClickHandler(ele, popupNav, $6e0c0888b69d6c4c$var$CLS_RTL);
        var itemObj;
        var clst = (0, $4ZDHT.closest)(e.target, "." + $6e0c0888b69d6c4c$var$CLS_ITEM);
        if (((0, $3EnZW.isNullOrUndefined)(clst) || clst.classList.contains($6e0c0888b69d6c4c$var$CLS_DISABLE)) && !popupNav.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARNAV)) return;
        if (clst) {
            var tempItem = this.items[this.tbarEle.indexOf(clst)];
            itemObj = tempItem;
        }
        var eventArgs = {
            originalEvent: e,
            item: itemObj
        };
        var isClickBinded = itemObj && !(0, $3EnZW.isNullOrUndefined)(itemObj.click) && typeof itemObj.click == "object" ? !(0, $3EnZW.isNullOrUndefined)(itemObj.click.observers) && itemObj.click.observers.length > 0 : !(0, $3EnZW.isNullOrUndefined)(itemObj) && !(0, $3EnZW.isNullOrUndefined)(itemObj.click);
        if (isClickBinded) this.trigger("items[" + this.tbarEle.indexOf(clst) + "].click", eventArgs);
        if (!eventArgs.cancel) this.trigger("clicked", eventArgs, function(clickedArgs) {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.popObj) && isPopupElement && !clickedArgs.cancel && _this.overflowMode === "Popup" && clickedArgs.item && clickedArgs.item.type !== "Input") _this.popObj.hide({
                name: "FadeOut",
                duration: 100
            });
        });
    };
    Toolbar.prototype.popupClickHandler = function(ele, popupNav, CLS_RTL) {
        var popObj = this.popObj;
        if ((0, $4ZDHT.isVisible)(popObj.element)) {
            popupNav.classList.remove($6e0c0888b69d6c4c$var$CLS_TBARNAVACT);
            popObj.hide({
                name: "FadeOut",
                duration: 100
            });
        } else {
            if (ele.classList.contains(CLS_RTL)) {
                popObj.enableRtl = true;
                popObj.position = {
                    X: "left",
                    Y: "top"
                };
            }
            if (popObj.offsetX === 0 && !ele.classList.contains(CLS_RTL)) {
                popObj.enableRtl = false;
                popObj.position = {
                    X: "right",
                    Y: "top"
                };
            }
            if (this.overflowMode === "Extended") {
                popObj.element.style.minHeight = "0px";
                popObj.width = this.getToolbarPopupWidth(this.element);
            }
            popObj.dataBind();
            popObj.refreshPosition();
            popObj.element.style.top = this.getElementOffsetY() + "px";
            popupNav.classList.add($6e0c0888b69d6c4c$var$CLS_TBARNAVACT);
            popObj.show({
                name: "FadeIn",
                duration: 100
            });
        }
    };
    Toolbar.prototype.getToolbarPopupWidth = function(ele) {
        var eleStyles = window.getComputedStyle(ele);
        return parseFloat(eleStyles.width) + parseFloat(eleStyles.borderRightWidth) * 2;
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ Toolbar.prototype.render = function() {
        var _this = this;
        this.initialize();
        this.renderControl();
        this.wireEvents();
        this.clickEvent = this.docEvent.bind(this);
        this.scrollEvent = this.docEvent.bind(this);
        this.renderComplete();
        if (this.isReact && this.portals && this.portals.length > 0) this.renderReactTemplates(function() {
            _this.refreshOverflow();
        });
    };
    Toolbar.prototype.initialize = function() {
        var width = (0, $3EnZW.formatUnit)(this.width);
        var height = (0, $3EnZW.formatUnit)(this.height);
        if ((0, $5q7BP.Browser).info.name !== "msie" || this.height !== "auto" || this.overflowMode === "MultiRow") (0, $4ZDHT.setStyleAttribute)(this.element, {
            "height": height
        });
        (0, $4ZDHT.setStyleAttribute)(this.element, {
            "width": width
        });
        var ariaAttr = {
            "role": "toolbar",
            "aria-disabled": "false",
            "aria-orientation": !this.isVertical ? "horizontal" : "vertical"
        };
        (0, $4ZDHT.attributes)(this.element, ariaAttr);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.element
        ], this.cssClass.split(" "));
    };
    Toolbar.prototype.renderControl = function() {
        var ele = this.element;
        this.trgtEle = ele.children.length > 0 ? ele.querySelector("div") : null;
        this.tbarAlgEle = {
            lefts: [],
            centers: [],
            rights: []
        };
        this.renderItems();
        this.renderLayout();
    };
    Toolbar.prototype.renderLayout = function() {
        this.renderOverflowMode();
        if (this.tbarAlign) this.itemPositioning();
        if (this.popObj && this.popObj.element.childElementCount > 1 && this.checkPopupRefresh(this.element, this.popObj.element)) this.popupRefresh(this.popObj.element, false);
        this.separator();
    };
    Toolbar.prototype.itemsAlign = function(items, itemEleDom) {
        var innerItem;
        var innerPos;
        if (!this.tbarEle) this.tbarEle = [];
        for(var i = 0; i < items.length; i++){
            innerItem = this.renderSubComponent(items[parseInt(i.toString(), 10)], i);
            if (this.tbarEle.indexOf(innerItem) === -1) this.tbarEle.push(innerItem);
            if (!this.tbarAlign) this.tbarItemAlign(items[parseInt(i.toString(), 10)], itemEleDom, i);
            innerPos = itemEleDom.querySelector(".e-toolbar-" + items[parseInt(i.toString(), 10)].align.toLowerCase());
            if (innerPos) {
                if (!(items[parseInt(i.toString(), 10)].showAlwaysInPopup && items[parseInt(i.toString(), 10)].overflow !== "Show")) this.tbarAlgEle[(items[parseInt(i.toString(), 10)].align + "s").toLowerCase()].push(innerItem);
                innerPos.appendChild(innerItem);
            } else itemEleDom.appendChild(innerItem);
        }
        if (this.isReact) {
            var portals = "portals";
            this.notify("render-react-toolbar-template", this["" + portals]);
            this.renderReactTemplates();
        }
    };
    /**
     * @hidden
     * @returns {void}
     */ Toolbar.prototype.changeOrientation = function() {
        var ele = this.element;
        if (this.isVertical) {
            ele.classList.remove($6e0c0888b69d6c4c$var$CLS_VERTICAL);
            this.isVertical = false;
            if (this.height === "auto" || this.height === "100%") ele.style.height = this.height;
            ele.setAttribute("aria-orientation", "horizontal");
        } else {
            ele.classList.add($6e0c0888b69d6c4c$var$CLS_VERTICAL);
            this.isVertical = true;
            ele.setAttribute("aria-orientation", "vertical");
            (0, $4ZDHT.setStyleAttribute)(this.element, {
                "height": (0, $3EnZW.formatUnit)(this.height),
                "width": (0, $3EnZW.formatUnit)(this.width)
            });
        }
        this.destroyMode();
        this.refreshOverflow();
    };
    Toolbar.prototype.initScroll = function(element, innerItems) {
        if (!this.scrollModule && this.checkOverflow(element, innerItems[0])) {
            if (this.tbarAlign) this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + $6e0c0888b69d6c4c$var$CLS_TBARCENTER).removeAttribute("style");
            if (this.isVertical) this.scrollModule = new (0, $3471080cb1b09001$export$d9880af5395880d2)({
                scrollStep: this.scrollStep,
                enableRtl: this.enableRtl
            }, innerItems[0]);
            else this.scrollModule = new (0, $ffe4a1d7d733585d$export$49487f80cf9ca6b1)({
                scrollStep: this.scrollStep,
                enableRtl: this.enableRtl
            }, innerItems[0]);
            if (this.cssClass) (0, $4ZDHT.addClass)([
                innerItems[0]
            ], this.cssClass.split(" "));
            var scrollEle = this.scrollModule.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_HSCROLLBAR + ", ." + "e-vscroll-bar");
            if (scrollEle) scrollEle.removeAttribute("tabindex");
            this.remove(this.scrollModule.element, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
            (0, $4ZDHT.setStyleAttribute)(this.element, {
                overflow: "hidden"
            });
        }
    };
    Toolbar.prototype.itemWidthCal = function(items) {
        var _this = this;
        var width = 0;
        var style;
        [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, items)).forEach(function(el) {
            if ((0, $4ZDHT.isVisible)(el)) {
                style = window.getComputedStyle(el);
                width += _this.isVertical ? el.offsetHeight : el.offsetWidth;
                width += parseFloat(_this.isVertical ? style.marginTop : style.marginRight);
                width += parseFloat(_this.isVertical ? style.marginBottom : style.marginLeft);
            }
        });
        return width;
    };
    Toolbar.prototype.getScrollCntEle = function(innerItem) {
        var trgClass = this.isVertical ? ".e-vscroll-content" : ".e-hscroll-content";
        return innerItem.querySelector(trgClass);
    };
    Toolbar.prototype.checkOverflow = function(element, innerItem) {
        if ((0, $3EnZW.isNullOrUndefined)(element) || (0, $3EnZW.isNullOrUndefined)(innerItem) || !(0, $4ZDHT.isVisible)(element)) return false;
        var eleWidth = this.isVertical ? element.offsetHeight : element.offsetWidth;
        var itemWidth = this.isVertical ? innerItem.offsetHeight : innerItem.offsetWidth;
        if (this.tbarAlign || this.scrollModule || eleWidth === itemWidth) itemWidth = this.itemWidthCal(this.scrollModule ? this.getScrollCntEle(innerItem) : innerItem);
        var popNav = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        var scrollNav = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARSCRLNAV);
        var navEleWidth = 0;
        if (popNav) navEleWidth = this.isVertical ? popNav.offsetHeight : popNav.offsetWidth;
        else if (scrollNav) navEleWidth = this.isVertical ? scrollNav.offsetHeight * 2 : scrollNav.offsetWidth * 2;
        if (itemWidth > eleWidth - navEleWidth) return true;
        else return false;
    };
    /**
     * Refresh the whole Toolbar component without re-rendering.
     * - It is used to manually refresh the Toolbar overflow modes such as scrollable, popup, multi row, and extended.
     * - It will refresh the Toolbar component after loading items dynamically.
     *
     * @returns {void}.
     */ Toolbar.prototype.refreshOverflow = function() {
        this.resize();
    };
    Toolbar.prototype.toolbarAlign = function(innerItems) {
        if (this.tbarAlign) {
            this.add(innerItems, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
            this.itemPositioning();
        }
    };
    Toolbar.prototype.renderOverflowMode = function() {
        var ele = this.element;
        var innerItems = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        var priorityCheck = this.popupPriCount > 0;
        if (ele && ele.children.length > 0) {
            this.offsetWid = ele.offsetWidth;
            this.remove(this.element, "e-toolpop");
            if ((0, $5q7BP.Browser).info.name === "msie" && this.height === "auto") ele.style.height = "";
            switch(this.overflowMode){
                case "Scrollable":
                    if ((0, $3EnZW.isNullOrUndefined)(this.scrollModule)) this.initScroll(ele, [].slice.call(ele.getElementsByClassName($6e0c0888b69d6c4c$var$CLS_ITEMS)));
                    break;
                case "Popup":
                    this.add(this.element, "e-toolpop");
                    if (this.tbarAlign) this.removePositioning();
                    if (this.checkOverflow(ele, innerItems) || priorityCheck) this.setOverflowAttributes(ele);
                    this.toolbarAlign(innerItems);
                    break;
                case "MultiRow":
                    this.add(innerItems, $6e0c0888b69d6c4c$var$CLS_MULTIROW);
                    if (this.checkOverflow(ele, innerItems) && this.tbarAlign) {
                        this.removePositioning();
                        this.add(innerItems, $6e0c0888b69d6c4c$var$CLS_MULTIROWPOS);
                    }
                    if (ele.style.overflow === "hidden") ele.style.overflow = "";
                    if ((0, $5q7BP.Browser).info.name === "msie" || ele.style.height !== "auto") ele.style.height = "auto";
                    break;
                case "Extended":
                    this.add(this.element, $6e0c0888b69d6c4c$var$CLS_EXTEANDABLE_TOOLBAR);
                    if (this.checkOverflow(ele, innerItems) || priorityCheck) {
                        if (this.tbarAlign) this.removePositioning();
                        this.setOverflowAttributes(ele);
                    }
                    this.toolbarAlign(innerItems);
            }
        }
    };
    Toolbar.prototype.setOverflowAttributes = function(ele) {
        this.createPopupEle(ele, [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + $6e0c0888b69d6c4c$var$CLS_ITEM, ele)));
        var ariaAttr = {
            "tabindex": "0",
            "role": "button",
            "aria-haspopup": "true",
            "aria-label": "overflow"
        };
        (0, $4ZDHT.attributes)(this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV), ariaAttr);
    };
    Toolbar.prototype.separator = function() {
        var element = this.element;
        var eleItem = [].slice.call(element.querySelectorAll("." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR));
        var multiVar = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_MULTIROW_SEPARATOR);
        var extendVar = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_EXTENDABLE_SEPARATOR);
        var eleInlineItem = this.overflowMode === "MultiRow" ? multiVar : extendVar;
        if (eleInlineItem !== null) {
            if (this.overflowMode === "MultiRow") eleInlineItem.classList.remove($6e0c0888b69d6c4c$var$CLS_MULTIROW_SEPARATOR);
            else if (this.overflowMode === "Extended") eleInlineItem.classList.remove($6e0c0888b69d6c4c$var$CLS_EXTENDABLE_SEPARATOR);
        }
        for(var i = 0; i <= eleItem.length - 1; i++)if (eleItem[parseInt(i.toString(), 10)].offsetLeft < 30 && eleItem[parseInt(i.toString(), 10)].offsetLeft !== 0) {
            if (this.overflowMode === "MultiRow") eleItem[parseInt(i.toString(), 10)].classList.add($6e0c0888b69d6c4c$var$CLS_MULTIROW_SEPARATOR);
            else if (this.overflowMode === "Extended") eleItem[parseInt(i.toString(), 10)].classList.add($6e0c0888b69d6c4c$var$CLS_EXTENDABLE_SEPARATOR);
        }
    };
    Toolbar.prototype.createPopupEle = function(ele, innerEle) {
        var innerNav = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        var vertical = this.isVertical;
        if (!innerNav) this.createPopupIcon(ele);
        innerNav = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        var innerNavDom = vertical ? innerNav.offsetHeight : innerNav.offsetWidth;
        var eleWidth = (vertical ? ele.offsetHeight : ele.offsetWidth) - innerNavDom;
        this.element.classList.remove("e-rtl");
        (0, $4ZDHT.setStyleAttribute)(this.element, {
            direction: "initial"
        });
        this.checkPriority(ele, innerEle, eleWidth, true);
        if (this.enableRtl) this.element.classList.add("e-rtl");
        this.element.style.removeProperty("direction");
        this.createPopup();
    };
    Toolbar.prototype.pushingPoppedEle = function(tbarObj, popupPri, ele, eleHeight, sepHeight) {
        var element = tbarObj.element;
        var poppedEle = [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_POPUP, element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS)));
        var nodes = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW, ele);
        var nodeIndex = 0;
        var nodePri = 0;
        poppedEle.forEach(function(el, index) {
            nodes = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW, ele);
            if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW) && nodes.length > 0) {
                if (tbarObj.tbResize && nodes.length > index) {
                    ele.insertBefore(el, nodes[parseInt(index.toString(), 10)]);
                    ++nodePri;
                } else {
                    ele.insertBefore(el, ele.children[nodes.length]);
                    ++nodePri;
                }
            } else if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW)) {
                ele.insertBefore(el, ele.firstChild);
                ++nodePri;
            } else if (tbarObj.tbResize && el.classList.contains($6e0c0888b69d6c4c$var$CLS_POPOVERFLOW) && ele.children.length > 0 && nodes.length === 0) {
                ele.insertBefore(el, ele.firstChild);
                ++nodePri;
            } else if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_POPOVERFLOW)) popupPri.push(el);
            else if (tbarObj.tbResize) {
                ele.insertBefore(el, ele.childNodes[nodeIndex + nodePri]);
                ++nodeIndex;
            } else ele.appendChild(el);
            if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) (0, $4ZDHT.setStyleAttribute)(el, {
                display: "",
                height: sepHeight + "px"
            });
            else (0, $4ZDHT.setStyleAttribute)(el, {
                display: "",
                height: eleHeight + "px"
            });
        });
        popupPri.forEach(function(el) {
            ele.appendChild(el);
        });
        var tbarEle = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS));
        for(var i = tbarEle.length - 1; i >= 0; i--){
            var tbarElement = tbarEle[parseInt(i.toString(), 10)];
            if (tbarElement.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR) && this.overflowMode !== "Extended") (0, $4ZDHT.setStyleAttribute)(tbarElement, {
                display: "none"
            });
            else break;
        }
    };
    Toolbar.prototype.createPopup = function() {
        var element = this.element;
        var sepHeight;
        var sepItem;
        if (this.overflowMode === "Extended") {
            sepItem = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR);
            sepHeight = element.style.height === "auto" || element.style.height === "" ? null : sepItem && sepItem.offsetHeight;
        }
        var eleItem = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + "):not(." + $6e0c0888b69d6c4c$var$CLS_POPUP + ")");
        var eleHeight = element.style.height === "auto" || element.style.height === "" ? null : eleItem && eleItem.offsetHeight;
        var ele;
        var popupPri = [];
        if ((0, $4ZDHT.select)("#" + element.id + "_popup." + $6e0c0888b69d6c4c$var$CLS_POPUPCLASS, element)) ele = (0, $4ZDHT.select)("#" + element.id + "_popup." + $6e0c0888b69d6c4c$var$CLS_POPUPCLASS, element);
        else {
            var extendEle = this.createElement("div", {
                id: element.id + "_popup",
                className: $6e0c0888b69d6c4c$var$CLS_POPUPCLASS + " " + $6e0c0888b69d6c4c$var$CLS_EXTENDABLECLASS
            });
            var popupEle = this.createElement("div", {
                id: element.id + "_popup",
                className: $6e0c0888b69d6c4c$var$CLS_POPUPCLASS
            });
            ele = this.overflowMode === "Extended" ? extendEle : popupEle;
        }
        this.pushingPoppedEle(this, popupPri, ele, eleHeight, sepHeight);
        this.popupInit(element, ele);
    };
    Toolbar.prototype.getElementOffsetY = function() {
        return this.overflowMode === "Extended" && window.getComputedStyle(this.element).getPropertyValue("box-sizing") === "border-box" ? this.element.clientHeight : this.element.offsetHeight;
    };
    Toolbar.prototype.popupInit = function(element, ele) {
        if (!this.popObj) {
            element.appendChild(ele);
            if (this.cssClass) (0, $4ZDHT.addClass)([
                ele
            ], this.cssClass.split(" "));
            (0, $4ZDHT.setStyleAttribute)(this.element, {
                overflow: ""
            });
            var popup = new (0, $2vAqh.Popup)(null, {
                relateTo: this.element,
                offsetY: this.isVertical ? 0 : this.getElementOffsetY(),
                enableRtl: this.enableRtl,
                open: this.popupOpen.bind(this),
                close: this.popupClose.bind(this),
                collision: {
                    Y: this.enableCollision ? "flip" : "none"
                },
                position: this.enableRtl ? {
                    X: "left",
                    Y: "top"
                } : {
                    X: "right",
                    Y: "top"
                }
            });
            if (this.overflowMode === "Extended") {
                popup.width = this.getToolbarPopupWidth(this.element);
                popup.offsetX = 0;
            }
            popup.appendTo(ele);
            document.addEventListener("scroll", this.clickEvent);
            document.addEventListener("click", this.scrollEvent);
            if (this.overflowMode !== "Extended") popup.element.style.maxHeight = popup.element.offsetHeight + "px";
            if (this.isVertical) popup.element.style.visibility = "hidden";
            if (this.isExtendedOpen) {
                var popupNav = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
                popupNav.classList.add($6e0c0888b69d6c4c$var$CLS_TBARNAVACT);
                (0, $4ZDHT.classList)(popupNav.firstElementChild, [
                    $6e0c0888b69d6c4c$var$CLS_POPUPICON
                ], [
                    $6e0c0888b69d6c4c$var$CLS_POPUPDOWN
                ]);
                this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_EXTENDABLECLASS).classList.add($6e0c0888b69d6c4c$var$CLS_POPUPOPEN);
            } else popup.hide();
            this.popObj = popup;
        } else if (this.overflowMode !== "Extended") {
            var popupEle = this.popObj.element;
            (0, $4ZDHT.setStyleAttribute)(popupEle, {
                maxHeight: "",
                display: "block"
            });
            (0, $4ZDHT.setStyleAttribute)(popupEle, {
                maxHeight: popupEle.offsetHeight + "px",
                display: ""
            });
        }
    };
    Toolbar.prototype.tbarPopupHandler = function(isOpen) {
        if (this.overflowMode === "Extended") {
            if (isOpen) this.add(this.element, $6e0c0888b69d6c4c$var$CLS_EXTENDEDPOPOPEN);
            else this.remove(this.element, $6e0c0888b69d6c4c$var$CLS_EXTENDEDPOPOPEN);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Toolbar.prototype.popupOpen = function(e) {
        var popObj = this.popObj;
        if (!this.isVertical) {
            popObj.offsetY = this.getElementOffsetY();
            popObj.dataBind();
        }
        var popupEle = this.popObj.element;
        var toolEle = this.popObj.element.parentElement;
        var popupNav = toolEle.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        popupNav.setAttribute("aria-expanded", "true");
        if (this.overflowMode === "Extended") popObj.element.style.minHeight = "";
        else {
            (0, $4ZDHT.setStyleAttribute)(popObj.element, {
                height: "auto",
                maxHeight: ""
            });
            popObj.element.style.maxHeight = popObj.element.offsetHeight + "px";
        }
        var popupElePos = popupEle.offsetTop + popupEle.offsetHeight + (0, $cWXlQ.calculatePosition)(toolEle).top;
        var popIcon = popupNav.firstElementChild;
        popupNav.classList.add($6e0c0888b69d6c4c$var$CLS_TBARNAVACT);
        (0, $4ZDHT.classList)(popIcon, [
            $6e0c0888b69d6c4c$var$CLS_POPUPICON
        ], [
            $6e0c0888b69d6c4c$var$CLS_POPUPDOWN
        ]);
        this.tbarPopupHandler(true);
        var scrollVal = (0, $3EnZW.isNullOrUndefined)(window.scrollY) ? 0 : window.scrollY;
        if (!this.isVertical && window.innerHeight + scrollVal < popupElePos && this.element.offsetTop < popupEle.offsetHeight) {
            var overflowHeight = popupEle.offsetHeight - (popupElePos - window.innerHeight - scrollVal + 5);
            popObj.height = overflowHeight + "px";
            for(var i = 0; i <= popupEle.childElementCount; i++){
                var ele = popupEle.children[parseInt(i.toString(), 10)];
                if (ele.offsetTop + ele.offsetHeight > overflowHeight) {
                    overflowHeight = ele.offsetTop;
                    break;
                }
            }
            if (this.overflowMode !== "Extended") (0, $4ZDHT.setStyleAttribute)(popObj.element, {
                maxHeight: overflowHeight + "px"
            });
        } else if (this.isVertical && this.overflowMode !== "Extended") {
            var tbEleData = this.element.getBoundingClientRect();
            (0, $4ZDHT.setStyleAttribute)(popObj.element, {
                maxHeight: tbEleData.top + this.element.offsetHeight + "px",
                bottom: 0,
                visibility: ""
            });
        }
        if (popObj) {
            var popupOffset = popupEle.getBoundingClientRect();
            if (popupOffset.right > document.documentElement.clientWidth && popupOffset.width > toolEle.getBoundingClientRect().width) {
                popObj.collision = {
                    Y: "none"
                };
                popObj.dataBind();
            }
            popObj.refreshPosition();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Toolbar.prototype.popupClose = function(e) {
        var element = this.element;
        var popupNav = element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        popupNav.setAttribute("aria-expanded", "false");
        var popIcon = popupNav.firstElementChild;
        popupNav.classList.remove($6e0c0888b69d6c4c$var$CLS_TBARNAVACT);
        (0, $4ZDHT.classList)(popIcon, [
            $6e0c0888b69d6c4c$var$CLS_POPUPDOWN
        ], [
            $6e0c0888b69d6c4c$var$CLS_POPUPICON
        ]);
        this.tbarPopupHandler(false);
    };
    Toolbar.prototype.checkPriority = function(ele, inEle, eleWidth, pre) {
        var popPriority = this.popupPriCount > 0;
        var len = inEle.length;
        var eleWid = eleWidth;
        var eleOffset;
        var checkoffset;
        var sepCheck = 0;
        var itemCount = 0;
        var itemPopCount = 0;
        var checkClass = function(ele, val) {
            var rVal = false;
            val.forEach(function(cls) {
                if (ele.classList.contains(cls)) rVal = true;
            });
            return rVal;
        };
        for(var i = len - 1; i >= 0; i--){
            var mrgn = void 0;
            var compuStyle = window.getComputedStyle(inEle[parseInt(i.toString(), 10)]);
            if (this.isVertical) {
                mrgn = parseFloat(compuStyle.marginTop);
                mrgn += parseFloat(compuStyle.marginBottom);
            } else {
                mrgn = parseFloat(compuStyle.marginRight);
                mrgn += parseFloat(compuStyle.marginLeft);
            }
            var fstEleCheck = inEle[parseInt(i.toString(), 10)] === this.tbarEle[0];
            if (fstEleCheck) this.tbarEleMrgn = mrgn;
            eleOffset = this.isVertical ? inEle[parseInt(i.toString(), 10)].offsetHeight : inEle[parseInt(i.toString(), 10)].offsetWidth;
            var eleWid_1 = fstEleCheck ? eleOffset + mrgn : eleOffset;
            if (checkClass(inEle[parseInt(i.toString(), 10)], [
                $6e0c0888b69d6c4c$var$CLS_POPPRI
            ]) && popPriority) {
                inEle[parseInt(i.toString(), 10)].classList.add($6e0c0888b69d6c4c$var$CLS_POPUP);
                if (this.isVertical) (0, $4ZDHT.setStyleAttribute)(inEle[parseInt(i.toString(), 10)], {
                    display: "none",
                    minHeight: eleWid_1 + "px"
                });
                else (0, $4ZDHT.setStyleAttribute)(inEle[parseInt(i.toString(), 10)], {
                    display: "none",
                    minWidth: eleWid_1 + "px"
                });
                itemPopCount++;
            }
            if (this.isVertical) checkoffset = inEle[parseInt(i.toString(), 10)].offsetTop + inEle[parseInt(i.toString(), 10)].offsetHeight + mrgn > eleWidth;
            else checkoffset = inEle[parseInt(i.toString(), 10)].offsetLeft + inEle[parseInt(i.toString(), 10)].offsetWidth + mrgn > eleWidth;
            if (checkoffset) {
                if (inEle[parseInt(i.toString(), 10)].classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) {
                    if (this.overflowMode === "Extended") {
                        var sepEle = inEle[parseInt(i.toString(), 10)];
                        if (checkClass(sepEle, [
                            $6e0c0888b69d6c4c$var$CLS_SEPARATOR,
                            $6e0c0888b69d6c4c$var$CLS_TBARIGNORE
                        ])) {
                            inEle[parseInt(i.toString(), 10)].classList.add($6e0c0888b69d6c4c$var$CLS_POPUP);
                            itemPopCount++;
                        }
                        itemCount++;
                    } else if (this.overflowMode === "Popup") {
                        if (sepCheck > 0 && itemCount === itemPopCount) {
                            var sepEle = inEle[i + itemCount + (sepCheck - 1)];
                            if (checkClass(sepEle, [
                                $6e0c0888b69d6c4c$var$CLS_SEPARATOR,
                                $6e0c0888b69d6c4c$var$CLS_TBARIGNORE
                            ])) (0, $4ZDHT.setStyleAttribute)(sepEle, {
                                display: "none"
                            });
                        }
                        sepCheck++;
                        itemCount = 0;
                        itemPopCount = 0;
                    }
                } else itemCount++;
                if (inEle[parseInt(i.toString(), 10)].classList.contains($6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW) && pre) eleWidth -= (this.isVertical ? inEle[parseInt(i.toString(), 10)].offsetHeight : inEle[parseInt(i.toString(), 10)].offsetWidth) + mrgn;
                else if (!checkClass(inEle[parseInt(i.toString(), 10)], [
                    $6e0c0888b69d6c4c$var$CLS_SEPARATOR,
                    $6e0c0888b69d6c4c$var$CLS_TBARIGNORE
                ])) {
                    inEle[parseInt(i.toString(), 10)].classList.add($6e0c0888b69d6c4c$var$CLS_POPUP);
                    if (this.isVertical) (0, $4ZDHT.setStyleAttribute)(inEle[parseInt(i.toString(), 10)], {
                        display: "none",
                        minHeight: eleWid_1 + "px"
                    });
                    else (0, $4ZDHT.setStyleAttribute)(inEle[parseInt(i.toString(), 10)], {
                        display: "none",
                        minWidth: eleWid_1 + "px"
                    });
                    itemPopCount++;
                } else eleWidth -= (this.isVertical ? inEle[parseInt(i.toString(), 10)].offsetHeight : inEle[parseInt(i.toString(), 10)].offsetWidth) + mrgn;
            }
        }
        if (pre) {
            var popedEle = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_POPUP + ")", this.element);
            this.checkPriority(ele, popedEle, eleWid, false);
        }
    };
    Toolbar.prototype.createPopupIcon = function(element) {
        var id = element.id.concat("_nav");
        var className = "e-" + element.id.concat("_nav " + $6e0c0888b69d6c4c$var$CLS_POPUPNAV);
        className = this.overflowMode === "Extended" ? className + " " + $6e0c0888b69d6c4c$var$CLS_EXTENDPOPUP : className;
        var nav = this.createElement("div", {
            id: id,
            className: className
        });
        if ((0, $5q7BP.Browser).info.name === "msie" || (0, $5q7BP.Browser).info.name === "edge") nav.classList.add("e-ie-align");
        var navItem = this.createElement("div", {
            className: $6e0c0888b69d6c4c$var$CLS_POPUPDOWN + " e-icons"
        });
        nav.appendChild(navItem);
        nav.setAttribute("tabindex", "0");
        nav.setAttribute("role", "button");
        element.appendChild(nav);
    };
    // eslint-disable-next-line max-len
    Toolbar.prototype.tbarPriRef = function(inEle, indx, sepPri, el, des, elWid, wid, ig, eleStyles) {
        var ignoreCount = ig;
        var popEle = this.popObj.element;
        var query = "." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + "):not(." + $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW + ")";
        var priEleCnt = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_POPUP + ":not(." + $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW + ")", popEle).length;
        var checkClass = function(ele, val) {
            return ele.classList.contains(val);
        };
        if ((0, $4ZDHT.selectAll)(query, inEle).length === 0) {
            var eleSep = inEle.children[indx - (indx - sepPri) - 1];
            var ignoreCheck = !(0, $3EnZW.isNullOrUndefined)(eleSep) && checkClass(eleSep, $6e0c0888b69d6c4c$var$CLS_TBARIGNORE);
            if (!(0, $3EnZW.isNullOrUndefined)(eleSep) && checkClass(eleSep, $6e0c0888b69d6c4c$var$CLS_SEPARATOR) && !(0, $4ZDHT.isVisible)(eleSep) || ignoreCheck) {
                eleSep.style.display = "unset";
                var eleSepWidth = eleSep.offsetWidth + parseFloat(window.getComputedStyle(eleSep).marginRight) * 2;
                var prevSep = eleSep.previousElementSibling;
                if (elWid + eleSepWidth < wid || des) {
                    inEle.insertBefore(el, inEle.children[indx + ignoreCount - (indx - sepPri)]);
                    if (!(0, $3EnZW.isNullOrUndefined)(prevSep)) prevSep.style.display = "";
                } else {
                    (0, $4ZDHT.setStyleAttribute)(el, eleStyles);
                    if (prevSep.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) prevSep.style.display = "none";
                }
                eleSep.style.display = "";
            } else inEle.insertBefore(el, inEle.children[indx + ignoreCount - (indx - sepPri)]);
        } else inEle.insertBefore(el, inEle.children[indx + ignoreCount - priEleCnt]);
    };
    Toolbar.prototype.popupRefresh = function(popupEle, destroy) {
        var _this = this;
        var ele = this.element;
        var isVer = this.isVertical;
        var innerEle = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        var popNav = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        if ((0, $3EnZW.isNullOrUndefined)(popNav)) return;
        innerEle.removeAttribute("style");
        popupEle.style.display = "block";
        var dimension;
        if (isVer) dimension = ele.offsetHeight - (popNav.offsetHeight + innerEle.offsetHeight);
        else dimension = ele.offsetWidth - (popNav.offsetWidth + innerEle.offsetWidth);
        var popupEleWidth = 0;
        [].slice.call(popupEle.children).forEach(function(el) {
            popupEleWidth += _this.popupEleWidth(el);
            (0, $4ZDHT.setStyleAttribute)(el, {
                "position": ""
            });
        });
        if (dimension + (isVer ? popNav.offsetHeight : popNav.offsetWidth) > popupEleWidth && this.popupPriCount === 0) destroy = true;
        this.popupEleRefresh(dimension, popupEle, destroy);
        popupEle.style.display = "";
        if (popupEle.children.length === 0 && popNav && this.popObj) {
            (0, $4ZDHT.detach)(popNav);
            popNav = null;
            this.popObj.destroy();
            (0, $4ZDHT.detach)(this.popObj.element);
            this.popObj = null;
        }
    };
    Toolbar.prototype.ignoreEleFetch = function(index, innerEle) {
        var ignoreEle = [].slice.call(innerEle.querySelectorAll("." + $6e0c0888b69d6c4c$var$CLS_TBARIGNORE));
        var ignoreInx = [];
        var count = 0;
        if (ignoreEle.length > 0) ignoreEle.forEach(function(ele) {
            ignoreInx.push([].slice.call(innerEle.children).indexOf(ele));
        });
        else return 0;
        ignoreInx.forEach(function(val) {
            if (val <= index) count++;
        });
        return count;
    };
    Toolbar.prototype.checkPopupRefresh = function(root, popEle) {
        popEle.style.display = "block";
        var elWid = this.popupEleWidth(popEle.firstElementChild);
        popEle.firstElementChild.style.removeProperty("Position");
        var tbarWidth = root.offsetWidth - root.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV).offsetWidth;
        var tbarItemsWid = root.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS).offsetWidth;
        popEle.style.removeProperty("display");
        if (tbarWidth > elWid + tbarItemsWid) return true;
        return false;
    };
    Toolbar.prototype.popupEleWidth = function(el) {
        el.style.position = "absolute";
        var elWidth = this.isVertical ? el.offsetHeight : el.offsetWidth;
        var btnText = el.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARBTNTEXT);
        if (el.classList.contains("e-tbtn-align") || el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARTEXT)) {
            var btn = el.children[0];
            if (!(0, $3EnZW.isNullOrUndefined)(btnText) && el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARTEXT)) btnText.style.display = "none";
            else if (!(0, $3EnZW.isNullOrUndefined)(btnText) && el.classList.contains($6e0c0888b69d6c4c$var$CLS_POPUPTEXT)) btnText.style.display = "block";
            btn.style.minWidth = "0%";
            elWidth = parseFloat(!this.isVertical ? el.style.minWidth : el.style.minHeight);
            btn.style.minWidth = "";
            btn.style.minHeight = "";
            if (!(0, $3EnZW.isNullOrUndefined)(btnText)) btnText.style.display = "";
        }
        return elWidth;
    };
    Toolbar.prototype.popupEleRefresh = function(width, popupEle, destroy) {
        var popPriority = this.popupPriCount > 0;
        var eleSplice = this.tbarEle;
        var priEleCnt;
        var index;
        var innerEle = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        var ignoreCount = 0;
        var _loop_1 = function(el) {
            if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_POPPRI) && popPriority && !destroy) return "continue";
            var elWidth = this_1.popupEleWidth(el);
            if (el === this_1.tbarEle[0]) elWidth += this_1.tbarEleMrgn;
            el.style.position = "";
            if (elWidth < width || destroy) {
                var inlineStyles = {
                    minWidth: el.style.minWidth,
                    height: el.style.height,
                    minHeight: el.style.minHeight
                };
                (0, $4ZDHT.setStyleAttribute)(el, {
                    minWidth: "",
                    height: "",
                    minHeight: ""
                });
                if (!el.classList.contains($6e0c0888b69d6c4c$var$CLS_POPOVERFLOW)) el.classList.remove($6e0c0888b69d6c4c$var$CLS_POPUP);
                index = this_1.tbarEle.indexOf(el);
                if (this_1.tbarAlign) {
                    var pos = this_1.items[parseInt(index.toString(), 10)].align;
                    index = this_1.tbarAlgEle[(pos + "s").toLowerCase()].indexOf(el);
                    eleSplice = this_1.tbarAlgEle[(pos + "s").toLowerCase()];
                    innerEle = this_1.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + "e-toolbar-" + pos.toLowerCase());
                }
                var sepBeforePri_1 = 0;
                if (this_1.overflowMode !== "Extended") eleSplice.slice(0, index).forEach(function(el) {
                    if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW) || el.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) {
                        if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) {
                            el.style.display = "";
                            width -= el.offsetWidth;
                        }
                        sepBeforePri_1++;
                    }
                });
                ignoreCount = this_1.ignoreEleFetch(index, innerEle);
                if (el.classList.contains($6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW)) {
                    this_1.tbarPriRef(innerEle, index, sepBeforePri_1, el, destroy, elWidth, width, ignoreCount, inlineStyles);
                    width -= el.offsetWidth;
                } else if (index === 0) {
                    innerEle.insertBefore(el, innerEle.firstChild);
                    width -= el.offsetWidth;
                } else {
                    priEleCnt = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW, this_1.popObj.element).length;
                    innerEle.insertBefore(el, innerEle.children[index + ignoreCount - priEleCnt]);
                    width -= el.offsetWidth;
                }
                el.style.height = "";
            } else return "break";
        };
        var this_1 = this;
        for(var _i = 0, _a = [].slice.call(popupEle.children); _i < _a.length; _i++){
            var el = _a[_i];
            var state_1 = _loop_1(el);
            if (state_1 === "break") break;
        }
        var checkOverflow = this.checkOverflow(this.element, this.element.getElementsByClassName($6e0c0888b69d6c4c$var$CLS_ITEMS)[0]);
        if (checkOverflow && !destroy) this.renderOverflowMode();
    };
    Toolbar.prototype.removePositioning = function() {
        var item = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        if ((0, $3EnZW.isNullOrUndefined)(item) || !item.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARPOS)) return;
        this.remove(item, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
        var innerItem = [].slice.call(item.childNodes);
        innerItem[1].removeAttribute("style");
        innerItem[2].removeAttribute("style");
    };
    Toolbar.prototype.refreshPositioning = function() {
        var item = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        this.add(item, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
        this.itemPositioning();
    };
    Toolbar.prototype.itemPositioning = function() {
        var item = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        var margin;
        if ((0, $3EnZW.isNullOrUndefined)(item) || !item.classList.contains($6e0c0888b69d6c4c$var$CLS_TBARPOS)) return;
        var popupNav = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_TBARNAV);
        var innerItem;
        if (this.scrollModule) {
            var trgClass = this.isVertical ? $6e0c0888b69d6c4c$var$CLS_VSCROLLCNT : $6e0c0888b69d6c4c$var$CLS_HSCROLLCNT;
            innerItem = [].slice.call(item.querySelector("." + trgClass).children);
        } else innerItem = [].slice.call(item.childNodes);
        if (this.isVertical) margin = innerItem[0].offsetHeight + innerItem[2].offsetHeight;
        else margin = innerItem[0].offsetWidth + innerItem[2].offsetWidth;
        var tbarWid = this.isVertical ? this.element.offsetHeight : this.element.offsetWidth;
        if (popupNav) {
            tbarWid -= this.isVertical ? popupNav.offsetHeight : popupNav.offsetWidth;
            var popWid = (this.isVertical ? popupNav.offsetHeight : popupNav.offsetWidth) + "px";
            innerItem[2].removeAttribute("style");
            if (this.isVertical) {
                if (this.enableRtl) innerItem[2].style.top = popWid;
                else innerItem[2].style.bottom = popWid;
            } else if (this.enableRtl) innerItem[2].style.left = popWid;
            else innerItem[2].style.right = popWid;
        }
        if (tbarWid <= margin) return;
        var value = (tbarWid - margin - (!this.isVertical ? innerItem[1].offsetWidth : innerItem[1].offsetHeight)) / 2;
        innerItem[1].removeAttribute("style");
        var mrgn = (!this.isVertical ? innerItem[0].offsetWidth : innerItem[0].offsetHeight) + value + "px";
        if (this.isVertical) {
            if (this.enableRtl) innerItem[1].style.marginBottom = mrgn;
            else innerItem[1].style.marginTop = mrgn;
        } else if (this.enableRtl) innerItem[1].style.marginRight = mrgn;
        else innerItem[1].style.marginLeft = mrgn;
    };
    Toolbar.prototype.tbarItemAlign = function(item, itemEle, pos) {
        var _this = this;
        if (item.showAlwaysInPopup && item.overflow !== "Show") return;
        var alignDiv = [];
        alignDiv.push(this.createElement("div", {
            className: $6e0c0888b69d6c4c$var$CLS_TBARLEFT
        }));
        alignDiv.push(this.createElement("div", {
            className: $6e0c0888b69d6c4c$var$CLS_TBARCENTER
        }));
        alignDiv.push(this.createElement("div", {
            className: $6e0c0888b69d6c4c$var$CLS_TBARRIGHT
        }));
        if (pos === 0 && item.align !== "Left") {
            alignDiv.forEach(function(ele) {
                itemEle.appendChild(ele);
            });
            this.tbarAlign = true;
            this.add(itemEle, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
        } else if (item.align !== "Left") {
            var alignEle = itemEle.childNodes;
            var leftAlign_1 = alignDiv[0];
            [].slice.call(alignEle).forEach(function(el) {
                _this.tbarAlgEle.lefts.push(el);
                leftAlign_1.appendChild(el);
            });
            itemEle.appendChild(leftAlign_1);
            itemEle.appendChild(alignDiv[1]);
            itemEle.appendChild(alignDiv[2]);
            this.tbarAlign = true;
            this.add(itemEle, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
        }
    };
    Toolbar.prototype.ctrlTemplate = function() {
        var _this = this;
        this.ctrlTem = this.trgtEle.cloneNode(true);
        this.add(this.trgtEle, $6e0c0888b69d6c4c$var$CLS_ITEMS);
        this.tbarEle = [];
        var innerEle = [].slice.call(this.trgtEle.children);
        innerEle.forEach(function(ele) {
            if (ele.tagName === "DIV") {
                _this.tbarEle.push(ele);
                if (!(0, $3EnZW.isNullOrUndefined)(ele.firstElementChild)) ele.firstElementChild.setAttribute("aria-disabled", "false");
                _this.add(ele, $6e0c0888b69d6c4c$var$CLS_ITEM);
            }
        });
    };
    Toolbar.prototype.renderItems = function() {
        var ele = this.element;
        var items = this.items;
        if (this.trgtEle != null) this.ctrlTemplate();
        else if (ele && items.length > 0) {
            var itemEleDom = void 0;
            if (ele && ele.children.length > 0) itemEleDom = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
            if (!itemEleDom) itemEleDom = this.createElement("div", {
                className: $6e0c0888b69d6c4c$var$CLS_ITEMS
            });
            this.itemsAlign(items, itemEleDom);
            ele.appendChild(itemEleDom);
        }
    };
    Toolbar.prototype.setAttr = function(attr, element) {
        var key = Object.keys(attr);
        var keyVal;
        for(var i = 0; i < key.length; i++){
            keyVal = key[parseInt(i.toString(), 10)];
            if (keyVal === "class") this.add(element, attr["" + keyVal]);
            else element.setAttribute(keyVal, attr["" + keyVal]);
        }
    };
    /**
     * Enables or disables the specified Toolbar item.
     *
     * @param  {number|HTMLElement|NodeList} items - DOM element or an array of items to be enabled or disabled.
     * @param  {boolean} isEnable  - Boolean value that determines whether the command should be enabled or disabled.
     * By default, `isEnable` is set to true.
     * @returns {void}.
     */ Toolbar.prototype.enableItems = function(items, isEnable) {
        var elements = items;
        var len = elements.length;
        var ele;
        if ((0, $3EnZW.isNullOrUndefined)(isEnable)) isEnable = true;
        var enable = function(isEnable, ele) {
            if (isEnable) {
                ele.classList.remove($6e0c0888b69d6c4c$var$CLS_DISABLE);
                if (!(0, $3EnZW.isNullOrUndefined)(ele.firstElementChild)) ele.firstElementChild.setAttribute("aria-disabled", "false");
            } else {
                ele.classList.add($6e0c0888b69d6c4c$var$CLS_DISABLE);
                if (!(0, $3EnZW.isNullOrUndefined)(ele.firstElementChild)) ele.firstElementChild.setAttribute("aria-disabled", "true");
            }
        };
        if (!(0, $3EnZW.isNullOrUndefined)(len) && len >= 1) {
            for(var a = 0, element = [].slice.call(elements); a < len; a++){
                var itemElement = element[parseInt(a.toString(), 10)];
                if (typeof itemElement === "number") {
                    ele = this.getElementByIndex(itemElement);
                    if ((0, $3EnZW.isNullOrUndefined)(ele)) return;
                    else elements[parseInt(a.toString(), 10)] = ele;
                } else ele = itemElement;
                enable(isEnable, ele);
            }
            if (isEnable) (0, $4ZDHT.removeClass)(elements, $6e0c0888b69d6c4c$var$CLS_DISABLE);
            else (0, $4ZDHT.addClass)(elements, $6e0c0888b69d6c4c$var$CLS_DISABLE);
        } else {
            if (typeof elements === "number") {
                ele = this.getElementByIndex(elements);
                if ((0, $3EnZW.isNullOrUndefined)(ele)) return;
            } else ele = items;
            enable(isEnable, ele);
        }
    };
    Toolbar.prototype.getElementByIndex = function(index) {
        if (this.tbarEle[parseInt(index.toString(), 10)]) return this.tbarEle[parseInt(index.toString(), 10)];
        return null;
    };
    /**
     * Adds new items to the Toolbar that accepts an array as Toolbar items.
     *
     * @param  {ItemModel[]} items - DOM element or an array of items to be added to the Toolbar.
     * @param  {number} index - Number value that determines where the command is to be added. By default, index is 0.
     * @returns {void}.
     */ Toolbar.prototype.addItems = function(items, index) {
        var innerItems;
        this.extendedOpen();
        var itemsDiv = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
        if ((0, $3EnZW.isNullOrUndefined)(itemsDiv)) {
            this.itemsRerender(items);
            return;
        }
        var innerEle;
        var itemAgn = "Left";
        if ((0, $3EnZW.isNullOrUndefined)(index)) index = 0;
        items.forEach(function(e) {
            if (!(0, $3EnZW.isNullOrUndefined)(e.align) && e.align !== "Left" && itemAgn === "Left") itemAgn = e.align;
        });
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            if ((0, $3EnZW.isNullOrUndefined)(item.type)) item.type = "Button";
            innerItems = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, this.element);
            item.align = itemAgn;
            innerEle = this.renderSubComponent(item, index);
            if (this.tbarEle.length >= index && innerItems.length >= 0) {
                if ((0, $3EnZW.isNullOrUndefined)(this.scrollModule)) this.destroyMode();
                var algIndex = item.align[0] === "L" ? 0 : item.align[0] === "C" ? 1 : 2;
                var ele = void 0;
                if (!this.tbarAlign && itemAgn !== "Left") {
                    this.tbarItemAlign(item, itemsDiv, 1);
                    this.tbarAlign = true;
                    ele = (0, $4ZDHT.closest)(innerItems[0], "." + $6e0c0888b69d6c4c$var$CLS_ITEMS).children[parseInt(algIndex.toString(), 10)];
                    ele.appendChild(innerEle);
                    this.tbarAlgEle[(item.align + "s").toLowerCase()].push(innerEle);
                    this.refreshPositioning();
                } else if (this.tbarAlign) {
                    ele = (0, $4ZDHT.closest)(innerItems[0], "." + $6e0c0888b69d6c4c$var$CLS_ITEMS).children[parseInt(algIndex.toString(), 10)];
                    ele.insertBefore(innerEle, ele.children[parseInt(index.toString(), 10)]);
                    this.tbarAlgEle[(item.align + "s").toLowerCase()].splice(index, 0, innerEle);
                    this.refreshPositioning();
                } else if (innerItems.length === 0) {
                    innerItems = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEMS, this.element);
                    innerItems[0].appendChild(innerEle);
                } else innerItems[0].parentNode.insertBefore(innerEle, innerItems[parseInt(index.toString(), 10)]);
                this.items.splice(index, 0, item);
                if (item.template) this.tbarEle.splice(this.tbarEle.length - 1, 1);
                this.tbarEle.splice(index, 0, innerEle);
                index++;
                this.offsetWid = itemsDiv.offsetWidth;
            }
        }
        itemsDiv.style.width = "";
        this.renderOverflowMode();
        if (this.isReact) this.renderReactTemplates();
    };
    /**
     * Removes the items from the Toolbar. Acceptable arguments are index of item/HTMLElement/node list.
     *
     * @param  {number|HTMLElement|NodeList|HTMLElement[]} args
     * Index or DOM element or an Array of item which is to be removed from the Toolbar.
     * @returns {void}.
     */ Toolbar.prototype.removeItems = function(args) {
        var elements = args;
        var index;
        var innerItems = [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, this.element));
        if (typeof elements === "number") {
            index = parseInt(args.toString(), 10);
            this.removeItemByIndex(index, innerItems);
        } else {
            if (elements && elements.length > 1) for(var _i = 0, _a = [].slice.call(elements); _i < _a.length; _i++){
                var ele = _a[_i];
                index = this.tbarEle.indexOf(ele);
                this.removeItemByIndex(index, innerItems);
                innerItems = (0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, this.element);
            }
            else {
                var ele = elements && elements.length && elements.length === 1 ? elements[0] : args;
                index = innerItems.indexOf(ele);
                this.removeItemByIndex(index, innerItems);
            }
        }
        this.resize();
    };
    Toolbar.prototype.removeItemByIndex = function(index, innerItems) {
        if (this.tbarEle[parseInt(index.toString(), 10)] && innerItems[parseInt(index.toString(), 10)]) {
            var eleIdx = this.tbarEle.indexOf(innerItems[parseInt(index.toString(), 10)]);
            if (this.tbarAlign) {
                var indexAgn = this.tbarAlgEle[(this.items[parseInt(eleIdx.toString(), 10)].align + "s").toLowerCase()].indexOf(this.tbarEle[parseInt(eleIdx.toString(), 10)]);
                this.tbarAlgEle[(this.items[parseInt(eleIdx.toString(), 10)].align + "s").toLowerCase()].splice(parseInt(indexAgn.toString(), 10), 1);
            }
            if (this.isReact) this.clearToolbarTemplate(innerItems[parseInt(index.toString(), 10)]);
            var btnItem = innerItems[parseInt(index.toString(), 10)].querySelector(".e-control.e-btn");
            if (!(0, $3EnZW.isNullOrUndefined)(btnItem) && !(0, $3EnZW.isNullOrUndefined)(btnItem.ej2_instances[0]) && !btnItem.ej2_instances[0].isDestroyed) btnItem.ej2_instances[0].destroy();
            (0, $4ZDHT.detach)(innerItems[parseInt(index.toString(), 10)]);
            this.items.splice(eleIdx, 1);
            this.tbarEle.splice(eleIdx, 1);
        }
    };
    Toolbar.prototype.templateRender = function(templateProp, innerEle, item, index) {
        var itemType = item.type;
        var eleObj = templateProp;
        var isComponent;
        if (typeof templateProp === "object") isComponent = typeof eleObj.appendTo === "function";
        if (typeof templateProp === "string" || !isComponent) {
            var templateFn = void 0;
            var val = templateProp;
            var regEx = new RegExp(/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i);
            val = typeof templateProp === "string" ? templateProp.trim() : templateProp;
            try {
                if (typeof templateProp === "object" && !(0, $3EnZW.isNullOrUndefined)(templateProp.tagName)) innerEle.appendChild(templateProp);
                else if (typeof templateProp === "string" && regEx.test(val)) innerEle.innerHTML = val;
                else if (document.querySelectorAll(val).length) {
                    var ele = document.querySelector(val);
                    var tempStr = ele.outerHTML.trim();
                    innerEle.appendChild(ele);
                    ele.style.display = "";
                    if (!(0, $3EnZW.isNullOrUndefined)(tempStr)) this.tempId.push(val);
                } else templateFn = (0, $c2qqN.compile)(val);
            } catch (e) {
                templateFn = (0, $c2qqN.compile)(val);
            }
            var tempArray = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(templateFn)) {
                var toolbarTemplateID = this.element.id + index + "_template";
                tempArray = templateFn({}, this, "template", toolbarTemplateID, this.isStringTemplate, undefined, undefined, this.root);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(tempArray) && tempArray.length > 0) [].slice.call(tempArray).forEach(function(ele) {
                if (!(0, $3EnZW.isNullOrUndefined)(ele.tagName)) ele.style.display = "";
                innerEle.appendChild(ele);
            });
        } else if (itemType === "Input") {
            var ele = this.createElement("input");
            if (item.id) ele.id = item.id;
            else ele.id = (0, $3EnZW.getUniqueID)("tbr-ipt");
            innerEle.appendChild(ele);
            eleObj.appendTo(ele);
        }
        this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_TEMPLATE);
        var firstChild = innerEle.firstElementChild;
        if (!(0, $3EnZW.isNullOrUndefined)(firstChild)) {
            firstChild.setAttribute("tabindex", (0, $3EnZW.isNullOrUndefined)(firstChild.getAttribute("tabIndex")) ? "-1" : this.getDataTabindex(firstChild));
            firstChild.setAttribute("data-tabindex", (0, $3EnZW.isNullOrUndefined)(firstChild.getAttribute("tabIndex")) ? "-1" : this.getDataTabindex(firstChild));
        }
        this.tbarEle.push(innerEle);
    };
    Toolbar.prototype.buttonRendering = function(item, innerEle) {
        var dom = this.createElement("button", {
            className: $6e0c0888b69d6c4c$var$CLS_TBARBTN
        });
        dom.setAttribute("type", "button");
        var textStr = item.text;
        var iconCss;
        var iconPos;
        if (item.id) dom.id = item.id;
        else dom.id = (0, $3EnZW.getUniqueID)("e-tbr-btn");
        var btnTxt = this.createElement("span", {
            className: "e-tbar-btn-text"
        });
        if (textStr) {
            btnTxt.innerHTML = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(textStr) : textStr;
            dom.appendChild(btnTxt);
            dom.classList.add("e-tbtn-txt");
        } else this.add(innerEle, "e-tbtn-align");
        if (item.prefixIcon || item.suffixIcon) {
            if (item.prefixIcon && item.suffixIcon || item.prefixIcon) {
                iconCss = item.prefixIcon + " e-icons";
                iconPos = "Left";
            } else {
                iconCss = item.suffixIcon + " e-icons";
                iconPos = "Right";
            }
        }
        var btnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            iconCss: iconCss,
            iconPosition: iconPos
        });
        btnObj.createElement = this.createElement;
        btnObj.appendTo(dom);
        if (item.width) (0, $4ZDHT.setStyleAttribute)(dom, {
            "width": (0, $3EnZW.formatUnit)(item.width)
        });
        return dom;
    };
    Toolbar.prototype.renderSubComponent = function(item, index) {
        var dom;
        var innerEle = this.createElement("div", {
            className: $6e0c0888b69d6c4c$var$CLS_ITEM
        });
        var tempDom = this.createElement("div", {
            innerHTML: this.enableHtmlSanitizer && !(0, $3EnZW.isNullOrUndefined)(item.tooltipText) ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(item.tooltipText) : item.tooltipText
        });
        if (!this.tbarEle) this.tbarEle = [];
        if (item.htmlAttributes) this.setAttr(item.htmlAttributes, innerEle);
        if (item.tooltipText) innerEle.setAttribute("title", tempDom.textContent);
        if (item.cssClass) innerEle.className = innerEle.className + " " + item.cssClass;
        if (item.template) this.templateRender(item.template, innerEle, item, index);
        else switch(item.type){
            case "Button":
                dom = this.buttonRendering(item, innerEle);
                dom.setAttribute("tabindex", (0, $3EnZW.isNullOrUndefined)(item.tabIndex) ? "-1" : item.tabIndex.toString());
                dom.setAttribute("data-tabindex", (0, $3EnZW.isNullOrUndefined)(item.tabIndex) ? "-1" : item.tabIndex.toString());
                dom.setAttribute("aria-label", item.text || item.tooltipText);
                dom.setAttribute("aria-disabled", "false");
                innerEle.appendChild(dom);
                innerEle.addEventListener("click", this.itemClick.bind(this));
                break;
            case "Separator":
                this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_SEPARATOR);
                break;
        }
        if (item.showTextOn) {
            var sTxt = item.showTextOn;
            if (sTxt === "Toolbar") {
                this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_POPUPTEXT);
                this.add(innerEle, "e-tbtn-align");
            } else if (sTxt === "Overflow") this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_TBARTEXT);
        }
        if (item.overflow) {
            var overflow = item.overflow;
            if (overflow === "Show") this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_TBAROVERFLOW);
            else if (overflow === "Hide") {
                if (!innerEle.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_POPOVERFLOW);
            }
        }
        if (item.overflow !== "Show" && item.showAlwaysInPopup && !innerEle.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) {
            this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_POPPRI);
            this.popupPriCount++;
        }
        if (item.disabled) this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_DISABLE);
        if (item.visible === false) this.add(innerEle, $6e0c0888b69d6c4c$var$CLS_HIDDEN);
        return innerEle;
    };
    Toolbar.prototype.getDataTabindex = function(ele) {
        return (0, $3EnZW.isNullOrUndefined)(ele.getAttribute("data-tabindex")) ? "-1" : ele.getAttribute("data-tabindex");
    };
    Toolbar.prototype.itemClick = function(e) {
        this.activeEleSwitch(e.currentTarget);
    };
    Toolbar.prototype.activeEleSwitch = function(ele) {
        this.activeEleRemove(ele.firstElementChild);
        this.activeEle.focus();
    };
    Toolbar.prototype.activeEleRemove = function(curEle) {
        var previousEle = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEM + ":not(." + $6e0c0888b69d6c4c$var$CLS_DISABLE + " ):not(." + $6e0c0888b69d6c4c$var$CLS_SEPARATOR + " ):not(." + $6e0c0888b69d6c4c$var$CLS_HIDDEN + " )");
        if (!(0, $3EnZW.isNullOrUndefined)(this.activeEle)) {
            this.activeEle.setAttribute("tabindex", this.getDataTabindex(this.activeEle));
            if (previousEle) previousEle.removeAttribute("tabindex");
            previousEle = this.activeEle;
        }
        this.activeEle = curEle;
        if (this.getDataTabindex(this.activeEle) === "-1") {
            if ((0, $3EnZW.isNullOrUndefined)(this.trgtEle) && !curEle.parentElement.classList.contains($6e0c0888b69d6c4c$var$CLS_TEMPLATE)) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelector(".e-hor-nav")) && this.element.querySelector(".e-hor-nav").classList.contains("e-nav-active")) {
                    this.updateTabIndex("0");
                    var tabindexValue = this.getDataTabindex(previousEle) === "-1" ? "0" : this.getDataTabindex(previousEle);
                    previousEle.setAttribute("tabindex", tabindexValue);
                } else this.updateTabIndex("-1");
                curEle.removeAttribute("tabindex");
            } else {
                var tabIndex = parseInt(this.getDataTabindex(this.activeEle), 10) + 1;
                this.activeEle.setAttribute("tabindex", tabIndex.toString());
            }
        }
    };
    Toolbar.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - Returns the module name as string.
     * @private
     */ Toolbar.prototype.getModuleName = function() {
        return "toolbar";
    };
    Toolbar.prototype.itemsRerender = function(newProp) {
        this.items = this.tbarItemsCol;
        if (this.isReact || this.isAngular) this.clearTemplate();
        this.destroyMode();
        this.destroyItems();
        this.items = newProp;
        this.tbarItemsCol = this.items;
        this.renderItems();
        this.renderOverflowMode();
        if (this.isReact) this.renderReactTemplates();
    };
    Toolbar.prototype.resize = function() {
        var ele = this.element;
        this.tbResize = true;
        if (this.tbarAlign) this.itemPositioning();
        if (this.popObj && this.overflowMode === "Popup") this.popObj.hide();
        var checkOverflow = this.checkOverflow(ele, ele.getElementsByClassName($6e0c0888b69d6c4c$var$CLS_ITEMS)[0]);
        if (!checkOverflow) {
            this.destroyScroll();
            var multirowele = ele.querySelector("." + $6e0c0888b69d6c4c$var$CLS_ITEMS);
            if (!(0, $3EnZW.isNullOrUndefined)(multirowele)) {
                this.remove(multirowele, $6e0c0888b69d6c4c$var$CLS_MULTIROWPOS);
                if (this.tbarAlign) this.add(multirowele, $6e0c0888b69d6c4c$var$CLS_TBARPOS);
            }
        }
        if (checkOverflow && this.scrollModule && this.offsetWid === ele.offsetWidth) return;
        if (this.offsetWid > ele.offsetWidth || checkOverflow) this.renderOverflowMode();
        if (this.popObj) {
            if (this.overflowMode === "Extended") this.popObj.width = this.getToolbarPopupWidth(this.element);
            if (this.tbarAlign) this.removePositioning();
            this.popupRefresh(this.popObj.element, false);
            if (this.tbarAlign) this.refreshPositioning();
        }
        if (this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_HSCROLLBAR)) this.scrollStep = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_HSCROLLBAR).offsetWidth;
        this.offsetWid = ele.offsetWidth;
        this.tbResize = false;
        this.separator();
    };
    Toolbar.prototype.orientationChange = function() {
        var _this = this;
        setTimeout(function() {
            _this.resize();
        }, 500);
    };
    Toolbar.prototype.extendedOpen = function() {
        var sib = this.element.querySelector("." + $6e0c0888b69d6c4c$var$CLS_EXTENDABLECLASS);
        if (this.overflowMode === "Extended" && sib) this.isExtendedOpen = sib.classList.contains($6e0c0888b69d6c4c$var$CLS_POPUPOPEN);
    };
    Toolbar.prototype.updateHideEleTabIndex = function(ele, isHidden, isElement, eleIndex, innerItems) {
        if (isElement) eleIndex = innerItems.indexOf(ele);
        var nextEle = innerItems[++eleIndex];
        while(nextEle){
            var skipEle = this.eleContains(nextEle);
            if (!skipEle) {
                var dataTabIndex = nextEle.firstElementChild.getAttribute("data-tabindex");
                if (isHidden && dataTabIndex === "-1") nextEle.firstElementChild.setAttribute("tabindex", "0");
                else if (dataTabIndex !== nextEle.firstElementChild.getAttribute("tabindex")) nextEle.firstElementChild.setAttribute("tabindex", dataTabIndex);
                break;
            }
            nextEle = innerItems[++eleIndex];
        }
    };
    Toolbar.prototype.clearToolbarTemplate = function(templateEle) {
        if (this.registeredTemplate && this.registeredTemplate["template"]) {
            var registeredTemplates = this.registeredTemplate;
            for(var index = 0; index < registeredTemplates["template"].length; index++){
                var registeredItem = registeredTemplates["template"][parseInt(index.toString(), 10)].rootNodes[0];
                var closestItem = (0, $4ZDHT.closest)(registeredItem, "." + $6e0c0888b69d6c4c$var$CLS_ITEM);
                if (!(0, $3EnZW.isNullOrUndefined)(closestItem) && closestItem === templateEle) {
                    this.clearTemplate([
                        "template"
                    ], [
                        registeredTemplates["template"][parseInt(index.toString(), 10)]
                    ]);
                    break;
                }
            }
        } else if (this.portals && this.portals.length > 0) {
            var portals = this.portals;
            for(var index = 0; index < portals.length; index++){
                var portalItem = portals[parseInt(index.toString(), 10)];
                var closestItem = (0, $4ZDHT.closest)(portalItem.containerInfo, "." + $6e0c0888b69d6c4c$var$CLS_ITEM);
                if (!(0, $3EnZW.isNullOrUndefined)(closestItem) && closestItem === templateEle) {
                    this.clearTemplate([
                        "template"
                    ], index);
                    break;
                }
            }
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of the property that changed.
     *
     * @param  {ToolbarModel} newProp - It contains new value of the data.
     * @param  {ToolbarModel} oldProp - It contains old value of the data.
     * @returns {void}
     * @private
     */ Toolbar.prototype.onPropertyChanged = function(newProp, oldProp) {
        var tEle = this.element;
        this.extendedOpen();
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "items":
                    if (!(newProp.items instanceof Array && oldProp.items instanceof Array)) {
                        var changedProb = Object.keys(newProp.items);
                        for(var i = 0; i < changedProb.length; i++){
                            var index = parseInt(Object.keys(newProp.items)[parseInt(i.toString(), 10)], 10);
                            var property = Object.keys(newProp.items[parseInt(index.toString(), 10)])[0];
                            var newProperty = Object(newProp.items[parseInt(index.toString(), 10)])["" + property];
                            if (this.tbarAlign || property === "align") {
                                this.refresh();
                                this.trigger("created");
                                break;
                            }
                            var popupPriCheck = property === "showAlwaysInPopup" && !newProperty;
                            var booleanCheck = property === "overflow" && this.popupPriCount !== 0;
                            if (popupPriCheck || this.items[parseInt(index.toString(), 10)].showAlwaysInPopup && booleanCheck) --this.popupPriCount;
                            if ((0, $3EnZW.isNullOrUndefined)(this.scrollModule)) this.destroyMode();
                            var itemCol = [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEMS + " ." + $6e0c0888b69d6c4c$var$CLS_ITEM, tEle));
                            if (this.isReact && this.items[parseInt(index.toString(), 10)].template) this.clearToolbarTemplate(itemCol[parseInt(index.toString(), 10)]);
                            (0, $4ZDHT.detach)(itemCol[parseInt(index.toString(), 10)]);
                            this.tbarEle.splice(index, 1);
                            this.addItems([
                                this.items[parseInt(index.toString(), 10)]
                            ], index);
                            this.items.splice(index, 1);
                            if (this.items[parseInt(index.toString(), 10)].template) this.tbarEle.splice(this.items.length, 1);
                        }
                    } else this.itemsRerender(newProp.items);
                    break;
                case "width":
                    (0, $4ZDHT.setStyleAttribute)(tEle, {
                        "width": (0, $3EnZW.formatUnit)(newProp.width)
                    });
                    this.refreshOverflow();
                    break;
                case "height":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "height": (0, $3EnZW.formatUnit)(newProp.height)
                    });
                    break;
                case "overflowMode":
                    this.destroyMode();
                    this.renderOverflowMode();
                    if (this.enableRtl) this.add(tEle, $6e0c0888b69d6c4c$var$CLS_RTL);
                    this.refreshOverflow();
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) this.add(tEle, $6e0c0888b69d6c4c$var$CLS_RTL);
                    else this.remove(tEle, $6e0c0888b69d6c4c$var$CLS_RTL);
                    if (!(0, $3EnZW.isNullOrUndefined)(this.scrollModule)) {
                        if (newProp.enableRtl) this.add(this.scrollModule.element, $6e0c0888b69d6c4c$var$CLS_RTL);
                        else this.remove(this.scrollModule.element, $6e0c0888b69d6c4c$var$CLS_RTL);
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(this.popObj)) {
                        if (newProp.enableRtl) this.add(this.popObj.element, $6e0c0888b69d6c4c$var$CLS_RTL);
                        else this.remove(this.popObj.element, $6e0c0888b69d6c4c$var$CLS_RTL);
                    }
                    if (this.tbarAlign) this.itemPositioning();
                    break;
                case "scrollStep":
                    if (this.scrollModule) this.scrollModule.scrollStep = this.scrollStep;
                    break;
                case "enableCollision":
                    if (this.popObj) this.popObj.collision = {
                        Y: this.enableCollision ? "flip" : "none"
                    };
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        this.element
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        this.element
                    ], newProp.cssClass.split(" "));
                    break;
                case "allowKeyboard":
                    this.unwireKeyboardEvent();
                    if (newProp.allowKeyboard) this.wireKeyboardEvent();
                    break;
            }
        }
    };
    /**
     * Shows or hides the Toolbar item that is in the specified index.
     *
     * @param  {number | HTMLElement} index - Index value of target item or DOM element  of items to be hidden or shown.
     * @param  {boolean} value - Based on this Boolean value, item will be hide (true) or show (false). By default, value is false.
     * @returns {void}.
     */ Toolbar.prototype.hideItem = function(index, value) {
        var isElement = typeof index === "object" ? true : false;
        var eleIndex = index;
        var ele;
        if (!isElement && (0, $3EnZW.isNullOrUndefined)(eleIndex)) return;
        var innerItems = [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, this.element));
        if (isElement) ele = index;
        else if (this.tbarEle[parseInt(eleIndex.toString(), 10)]) {
            var innerItems_1 = [].slice.call((0, $4ZDHT.selectAll)("." + $6e0c0888b69d6c4c$var$CLS_ITEM, this.element));
            ele = innerItems_1[parseInt(eleIndex.toString(), 10)];
        }
        if (ele) {
            if (value) {
                ele.classList.add($6e0c0888b69d6c4c$var$CLS_HIDDEN);
                if (!ele.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) {
                    if ((0, $3EnZW.isNullOrUndefined)(ele.firstElementChild.getAttribute("tabindex")) || ele.firstElementChild.getAttribute("tabindex") !== "-1") this.updateHideEleTabIndex(ele, value, isElement, eleIndex, innerItems);
                }
            } else {
                ele.classList.remove($6e0c0888b69d6c4c$var$CLS_HIDDEN);
                if (!ele.classList.contains($6e0c0888b69d6c4c$var$CLS_SEPARATOR)) this.updateHideEleTabIndex(ele, value, isElement, eleIndex, innerItems);
            }
            this.refreshOverflow();
        }
    };
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Collection)([], $6e0c0888b69d6c4c$export$6d08773d2e66f8f2)
    ], Toolbar.prototype, "items", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Toolbar.prototype, "width", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Toolbar.prototype, "height", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Toolbar.prototype, "cssClass", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)("Scrollable")
    ], Toolbar.prototype, "overflowMode", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)()
    ], Toolbar.prototype, "scrollStep", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Toolbar.prototype, "enableCollision", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Toolbar.prototype, "enableHtmlSanitizer", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Toolbar.prototype, "allowKeyboard", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Event)()
    ], Toolbar.prototype, "clicked", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Event)()
    ], Toolbar.prototype, "created", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Event)()
    ], Toolbar.prototype, "destroyed", void 0);
    $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.Event)()
    ], Toolbar.prototype, "beforeCreate", void 0);
    Toolbar = $6e0c0888b69d6c4c$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Toolbar);
    return Toolbar;
}((0, $hQxLN.Component));



var $a7928f640563b10d$export$6335145236247192 = /** @class */ function() {
    function EmojiPicker(parent, serviceLocator) {
        this.parent = parent;
        this.locator = serviceLocator;
        this.i10n = serviceLocator.getService("rteLocale");
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
        this.isDestroyed = false;
        this.isPopupDestroyed = false;
    }
    /**
     * Destroys the Count.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ EmojiPicker.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.removeEventListener();
        this.isDestroyed = true;
    };
    EmojiPicker.prototype.childDestroy = function() {
        if (this.isPopupDestroyed) return;
        if (this.popupObj && !this.popupObj.isDestroyed) {
            if (this.popupObj.element && this.popupObj.element.querySelector(".e-rte-emoji-search")) {
                var textBox = (0, $jmffE.getComponent)(this.popupObj.element.querySelector(".e-rte-emoji-search"), "textbox");
                if (textBox && !textBox.isDestroyed) textBox.destroy();
            }
            if (this.popupObj.element && this.popupObj.element.querySelector(".e-rte-emojipicker-toolbar")) {
                var toolbar_1 = (0, $jmffE.getComponent)(this.popupObj.element.querySelector(".e-rte-emojipicker-toolbar"), "toolbar");
                if (toolbar_1 && !toolbar_1.isDestroyed) toolbar_1.destroy();
            }
            var closeIcon = this.popupObj.element.querySelector(".e-clear-icon");
            if (!(0, $3EnZW.isNullOrUndefined)(closeIcon)) (0, $aqzbR.EventHandler).remove(closeIcon, "mousedown", this.searchFilter);
            this.popupObj.destroy();
            this.isPopupDestroyed = true;
        }
        if (this.popDiv) {
            (0, $aqzbR.EventHandler).remove(this.popDiv, "keydown", this.onKeyDown);
            (0, $aqzbR.EventHandler).remove(this.popDiv, "keyup", this.searchFilter);
            if (this.popDiv.querySelector(".e-rte-emojipicker-btn")) {
                var btn = this.popDiv.querySelector(".e-rte-emojipicker-btn");
                (0, $aqzbR.EventHandler).remove(btn, "scroll", this.scrollEvent);
                (0, $aqzbR.EventHandler).remove(btn, "click", this.emojiBtnClick);
            }
        }
    };
    EmojiPicker.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$4d7e4d3283b3fc57, this.toolbarClick, this);
        this.parent.on($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onkeyPress, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.onkeyUp, this);
        this.parent.on($947a002e9a697770$export$55df3e903573f90b, this.contentscroll, this);
        this.parent.on($947a002e9a697770$export$209876d7b1ac8f3, this.contentscroll, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    // eslint-disable-next-line
    EmojiPicker.prototype.toolbarClick = function(args) {
        var _this = this;
        var _a, _b;
        var spanElement;
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector(".e-emoji"))) spanElement = this.parent.element.querySelector(".e-emoji");
        else if (this.parent.inlineMode.enable) spanElement = this.parent.element.ownerDocument.querySelector(".e-emoji");
        this.divElement = spanElement.closest("div");
        if (!this.parent.inputElement.contains(this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()).startContainer)) this.parent.contentModule.getEditPanel().focus();
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        this.save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
        this.clickEvent = args.args;
        var emojiPicker = this.parent.emojiPickerSettings.iconsSet;
        if (this.popupObj) {
            (0, $4ZDHT.removeClass)([
                this.divElement
            ], "e-active");
            if (this.popupObj.element.querySelector(".e-rte-emoji-search") || !this.parent.emojiPickerSettings.showSearchBox) {
                this.popupObj.hide();
                return;
            }
            this.popupObj.hide();
        }
        this.popDiv = this.parent.createElement("div", {
            className: "e-rte-emojipicker-popup",
            id: this.parent.getID() + "_emojiPicker"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getToolbar()) && !this.parent.inlineMode.enable) this.parent.getToolbar().parentElement.appendChild(this.popDiv);
        else if (this.parent.inlineMode.enable) this.parent.rootContainer.appendChild(this.popDiv);
        (0, $aqzbR.EventHandler).add(this.popDiv, "keydown", this.onKeyDown, this);
        (0, $aqzbR.EventHandler).add(this.popDiv, "keyup", this.searchFilter, this);
        var extendEle = this.parent.element.querySelector(".e-toolbar-extended");
        var zIndex;
        if (!(0, $3EnZW.isNullOrUndefined)(extendEle)) {
            var computedStyle = window.getComputedStyle(extendEle);
            zIndex = computedStyle.getPropertyValue("z-index");
        } else zIndex = "10001";
        var target;
        var xValue;
        var yValue;
        if (!(0, $3EnZW.isNullOrUndefined)(args.args) && !this.parent.inlineMode.enable && (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text)) {
            target = args.args.originalEvent.target;
            target = target.classList.contains("e-toolbar-item") ? target.firstChild : target.parentElement;
            xValue = "left";
            yValue = "bottom";
        } else if ((0, $3EnZW.isNullOrUndefined)(args.x) && (0, $3EnZW.isNullOrUndefined)(args.y) && !this.parent.inlineMode.enable && (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text)) {
            target = this.parent.inputElement;
            if (this.parent.contentModule.getDocument().getSelection().rangeCount > 0) {
                var coordinates = this.getCoordinates();
                xValue = coordinates.left;
                yValue = coordinates.top;
            }
        } else if ((0, $3EnZW.isNullOrUndefined)(args.x) && (0, $3EnZW.isNullOrUndefined)(args.y) && (this.parent.inlineMode.enable || !(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text))) {
            this.parent.notify($947a002e9a697770$export$bba5038aab73375b, {});
            if (this.parent.contentModule.getDocument().getSelection().rangeCount > 0) {
                var coordinates = this.getCoordinates();
                xValue = coordinates.left;
                yValue = coordinates.top;
            }
        } else {
            target = this.parent.inputElement;
            xValue = args.x;
            yValue = args.y;
        }
        this.popupObj = new (0, $2vAqh.Popup)(this.popDiv, {
            targetType: "relative",
            relateTo: target,
            collision: {
                X: "fit",
                Y: "none"
            },
            offsetY: 8,
            viewPortElement: this.parent.element,
            position: {
                X: xValue,
                Y: yValue
            },
            enableRtl: this.parent.enableRtl,
            zIndex: parseInt(zIndex, 10) + 1,
            actionOnScroll: "hide",
            close: function() {
                _this.parent.isBlur = false;
                _this.childDestroy();
                (0, $4ZDHT.detach)(_this.popupObj.element);
                _this.popupObj = null;
            }
        });
        this.isPopupDestroyed = false;
        (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], "e-popup-open");
        this.popupObj.refreshPosition(target);
        // header search element
        if ((!(0, $3EnZW.isNullOrUndefined)(args.args) || (0, $3EnZW.isNullOrUndefined)(args.x) && (0, $3EnZW.isNullOrUndefined)(args.y)) && this.parent.emojiPickerSettings.showSearchBox) {
            var inputEle = (0, $4ZDHT.createElement)("input", {
                id: "e-rte-emoji-search",
                className: "e-rte-emoji-search"
            });
            this.popDiv.append(inputEle);
            var inputobj = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
                placeholder: this.i10n.getConstant("emojiPickerTypeToFind"),
                showClearButton: true
            });
            inputobj.appendTo(inputEle);
            inputEle.focus();
        }
        var closeIcon = this.popupObj.element.querySelector(".e-clear-icon");
        if (!(0, $3EnZW.isNullOrUndefined)(closeIcon)) (0, $aqzbR.EventHandler).add(closeIcon, "mousedown", this.searchFilter, this);
        // Header emoji toolbar div
        var emojiToolBar = this.parent.createElement("div", {
            className: "e-rte-emojipicker-toolbar"
        });
        this.popDiv.appendChild(emojiToolBar);
        var pushToolBar = [];
        for(var i = 0; i < this.parent.emojiPickerSettings.iconsSet.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(this.parent.emojiPickerSettings.iconsSet[i].iconCss)) pushToolBar.push({
            prefixIcon: this.parent.emojiPickerSettings.iconsSet[i].iconCss,
            htmlAttributes: (_a = {}, _a["title"] = this.parent.emojiPickerSettings.iconsSet[i].name, _a)
        });
        else pushToolBar.push({
            text: "&#x" + this.parent.emojiPickerSettings.iconsSet[i].code + ";",
            htmlAttributes: (_b = {}, _b["title"] = this.parent.emojiPickerSettings.iconsSet[i].name, _b)
        });
        var toolbarObj = new (0, $6e0c0888b69d6c4c$export$4c260019440d418f)({
            items: pushToolBar,
            clicked: this.emojiToolbarClick.bind(this)
        });
        toolbarObj.appendTo(emojiToolBar);
        // emoji btn div
        var emojiBtnDiv = this.parent.createElement("div", {
            className: "e-rte-emojipicker-btn"
        });
        this.popDiv.appendChild(emojiBtnDiv);
        var height;
        var popupBorder = window.getComputedStyle(this.popDiv);
        if ((0, $3EnZW.isNullOrUndefined)(args.args) && !((0, $3EnZW.isNullOrUndefined)(args.x) && (0, $3EnZW.isNullOrUndefined)(args.y)) || !this.parent.emojiPickerSettings.showSearchBox) {
            height = this.popDiv.getBoundingClientRect().height - emojiToolBar.getBoundingClientRect().height - 2 * parseFloat(popupBorder.borderWidth) + "px";
            emojiBtnDiv.style.setProperty("height", height, "important");
        } else {
            var inputELe = this.parent.element.querySelector(".e-rte-emoji-search").parentElement;
            var getComputedStyle_1 = window.getComputedStyle(inputELe);
            height = this.popDiv.getBoundingClientRect().height - emojiToolBar.getBoundingClientRect().height - inputELe.getBoundingClientRect().height - parseFloat(getComputedStyle_1.marginTop) - parseFloat(getComputedStyle_1.marginBottom) - 2 * parseFloat(popupBorder.borderWidth) + "px";
            emojiBtnDiv.style.setProperty("height", height, "important");
        }
        for(var i = 0; i < emojiPicker.length; i++){
            var emojiGroupDiv = this.parent.createElement("div", {
                className: "e-rte-emojipicker-group"
            });
            emojiBtnDiv.appendChild(emojiGroupDiv);
            var emojiName = this.parent.createElement("div", {
                className: "e-rte-emojipicker-name"
            });
            emojiName.innerText = this.parent.emojiPickerSettings.iconsSet[i].name;
            emojiName.setAttribute("aria-label", this.parent.emojiPickerSettings.iconsSet[i].name);
            emojiGroupDiv.appendChild(emojiName);
            var emojiBtn = this.parent.createElement("div", {
                className: "e-rte-emojipickerbtn-group"
            });
            emojiGroupDiv.appendChild(emojiBtn);
            for(var j = 0; j < emojiPicker[i].icons.length; j++){
                var button = this.parent.createElement("button", {
                    className: "e-btn  e-control"
                });
                button.innerHTML = this.buttoncode(this.parent.emojiPickerSettings.iconsSet[i].icons[j].code);
                button.setAttribute("aria-label", this.parent.emojiPickerSettings.iconsSet[i].icons[j].desc);
                button.setAttribute("title", this.parent.emojiPickerSettings.iconsSet[i].icons[j].desc);
                emojiBtn.appendChild(button);
                if (button.innerHTML.length > 2) button.style.fontSize = "17px";
            }
        }
        (0, $aqzbR.EventHandler).add(emojiBtnDiv, "scroll", this.scrollEvent, this);
        (0, $aqzbR.EventHandler).add(emojiBtnDiv, "click", this.emojiBtnClick, this);
        var emojiButtons = this.parent.element.querySelectorAll(".e-rte-emojipicker-btn button");
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector(".e-rte-emoji-search")) && !(0, $3EnZW.isNullOrUndefined)(args.args)) {
            emojiButtons[0].focus();
            (0, $4ZDHT.addClass)([
                emojiButtons[0]
            ], "e-focus");
        }
        var popup = this.parent.element.querySelector(".e-rte-emojipicker-btn");
        var toolbarName = this.parent.element.querySelectorAll(".e-rte-emojipicker-toolbar button");
        var scrollTop;
        if (!(0, $3EnZW.isNullOrUndefined)(popup)) scrollTop = Math.round(popup.scrollTop);
        if (scrollTop < toolbarName[0].offsetHeight) (0, $4ZDHT.addClass)([
            toolbarName[0]
        ], "e-selected");
        if (this.popupObj) (0, $4ZDHT.addClass)([
            this.divElement
        ], "e-active");
    };
    EmojiPicker.prototype.buttoncode = function(value) {
        var valueLength = value.split("-");
        // eslint-disable-next-line
        var joinedEmoji = valueLength.map(function(cp) {
            return String.fromCodePoint(parseInt(cp, 16));
        }).join("\u200D");
        return joinedEmoji;
    };
    EmojiPicker.prototype.docClick = function(e) {
        var target = e.args.target;
        if (target && target.classList && this.popupObj && !(0, $4ZDHT.closest)(target, "[id='" + this.popupObj.element.id + "'" + "]") && !target.classList.contains("e-emoji") && !target.classList.contains("e-toolbar-item")) {
            if (this.popupObj) {
                (0, $4ZDHT.removeClass)([
                    this.divElement
                ], "e-active");
                this.popupObj.hide();
            }
        }
    };
    EmojiPicker.prototype.scrollEvent = function() {
        var popup = this.parent.element.querySelector(".e-rte-emojipicker-btn");
        var emojiSet = this.parent.element.querySelectorAll(".e-rte-emojipicker-group");
        var toolbarName = this.parent.element.querySelectorAll(".e-rte-emojipicker-toolbar button");
        var scrollTop;
        if (!(0, $3EnZW.isNullOrUndefined)(popup)) scrollTop = Math.round(popup.scrollTop);
        var firstSetWidth = 0;
        for(var j = 0; j < toolbarName.length; j++)if (scrollTop < toolbarName[0].offsetHeight) {
            if (!(0, $3EnZW.isNullOrUndefined)(toolbarName[j + 1])) (0, $4ZDHT.removeClass)([
                toolbarName[j + 1]
            ], "e-selected");
            (0, $4ZDHT.addClass)([
                toolbarName[0]
            ], "e-selected");
        }
        for(var i = 0; i < emojiSet.length; i++){
            firstSetWidth += Math.round(emojiSet[i].offsetHeight);
            if (scrollTop >= firstSetWidth) {
                for(var k = 0; k < toolbarName.length; k++)if (toolbarName[k].classList.contains("e-selected")) (0, $4ZDHT.removeClass)([
                    toolbarName[k]
                ], "e-selected");
                if (!(0, $3EnZW.isNullOrUndefined)(toolbarName[i + 1])) (0, $4ZDHT.addClass)([
                    toolbarName[i + 1]
                ], "e-selected");
            }
        }
    };
    EmojiPicker.prototype.contentscroll = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.clickEvent) && this.popupObj) {
            (0, $4ZDHT.removeClass)([
                this.divElement
            ], "e-active");
            this.popupObj.hide();
            return;
        }
    };
    EmojiPicker.prototype.emojiToolbarClick = function(e) {
        var args = {
            // eslint-disable-next-line
            text: e.item.htmlAttributes.title
        };
        var currentEleName = args.text;
        var emojiGroups = this.parent.element.querySelectorAll(".e-rte-emojipicker-group");
        var emojiButtons = this.parent.element.querySelectorAll(".e-rte-emojipicker-btn button");
        var toolbarName = this.parent.element.querySelectorAll(".e-rte-emojipicker-toolbar button");
        for(var i = 0; i < toolbarName.length; i++)if (toolbarName[i].classList.contains("e-selected")) (0, $4ZDHT.removeClass)([
            toolbarName[i]
        ], "e-selected");
        for(var i = 0; i < emojiButtons.length; i++)if (emojiButtons[i].classList.contains("e-focus")) (0, $4ZDHT.removeClass)([
            emojiButtons[i]
        ], "e-focus");
        // Loop through the selected elements and perform the same operation on each element
        var emojiGroupsheight = this.parent.element.querySelector(".e-rte-emojipicker-btn");
        var emojiHeight = 0;
        // eslint-disable-next-line
        emojiGroups.forEach(function(group) {
            var childNodes = group.childNodes[0];
            var focusBtn = group.childNodes[1].childNodes[0];
            var ariaLabel = childNodes.getAttribute("aria-label");
            if (currentEleName === ariaLabel) {
                if (childNodes) {
                    emojiGroupsheight.scrollTop = emojiHeight + 10;
                    (0, $4ZDHT.addClass)([
                        focusBtn
                    ], "e-focus");
                    focusBtn.focus();
                }
            } else {
                emojiHeight += group.scrollHeight;
                (0, $4ZDHT.removeClass)([
                    focusBtn
                ], "e-focus");
            }
        });
    };
    EmojiPicker.prototype.onKeyDown = function(e) {
        // Select all emoji buttons
        var emojiButtons = this.parent.element.querySelectorAll(".e-rte-emojipicker-btn button");
        var emojiGroups = this.parent.element.querySelectorAll(".e-rte-emojipickerbtn-group");
        var searchKeyHandler = this.parent.element.querySelector(".e-rte-emojisearch-btn button");
        if (e.keyCode === 27) {
            if (this.popupObj) {
                (0, $4ZDHT.removeClass)([
                    this.divElement
                ], "e-active");
                this.popupObj.hide();
            }
        }
        if (e.keyCode === 13) {
            var activeEle = document.activeElement;
            if (activeEle.classList.contains("e-btn")) {
                this.emojiBtnClick(e);
                e.preventDefault();
            }
        }
        var srcElement = e.srcElement;
        if (!(0, $3EnZW.isNullOrUndefined)(srcElement)) {
            if (srcElement.classList.contains("e-rte-emoji-search") && e.keyCode === 40) {
                for(var i = 0; i < emojiButtons.length; i++)if (emojiButtons[i].classList.contains("e-focus")) (0, $4ZDHT.removeClass)([
                    emojiButtons[i]
                ], "e-focus");
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(searchKeyHandler)) this.filterKeyHandler(e);
        else for(var i = 0; i < emojiButtons.length; i++){
            var focusIndex = i;
            if (emojiButtons[i].classList.contains("e-focus")) {
                if (e.keyCode === 40) // Move focus to next row if there is one
                {
                    if (emojiButtons.length - 4 > i) {
                        var count = 0;
                        for(var j = 0; j < emojiGroups.length; j++)for(var k = 0; k < emojiGroups[j].childNodes.length; k++){
                            // eslint-disable-next-line
                            var childNodes = emojiGroups[j].childNodes[k];
                            if (childNodes.classList.contains("e-focus") && count !== 1) {
                                var currentIndex = k;
                                var lastChild = emojiGroups[j].lastChild;
                                var lastRowIndex = Math.floor(k % 6);
                                var lastEleLength = emojiGroups[j].childNodes.length - 1;
                                var lastEleIndex = Math.floor(lastEleLength % 6);
                                if (currentIndex !== -1) {
                                    var nextRowIndex = currentIndex + 6;
                                    if (!(0, $3EnZW.isNullOrUndefined)(emojiGroups[j].childNodes[nextRowIndex])) {
                                        // next row has six buttons
                                        // handle focus change here
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiButtons[focusIndex += 6];
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        break;
                                    } else if ((0, $3EnZW.isNullOrUndefined)(emojiGroups[j].childNodes[nextRowIndex]) && !lastChild.classList.contains("e-focus") && lastEleIndex < lastRowIndex) {
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiGroups[j].lastChild;
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        count = 1;
                                        break;
                                    } else {
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiGroups[j + 1].childNodes[lastRowIndex];
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        count = 1;
                                        break;
                                    }
                                }
                            }
                        }
                        break;
                    }
                } else if (e.keyCode === 38) {
                    // Move focus to previous row if there is one
                    if (i >= 6) {
                        var count = 0;
                        for(var j = 0; j < emojiGroups.length; j++)for(var k = 0; k < emojiGroups[j].childNodes.length; k++){
                            var childNodes = emojiGroups[j].childNodes[k];
                            if (childNodes.classList.contains("e-focus") && count !== 1) {
                                // eslint-disable-next-line
                                var currentIndex = k;
                                var previousRowLength = (0, $3EnZW.isNullOrUndefined)(emojiGroups[j - 1]) ? null : emojiGroups[j - 1].childNodes.length % 6 || 6;
                                if (currentIndex !== -1) {
                                    var previousRowIndex = currentIndex - 6;
                                    if (!(0, $3EnZW.isNullOrUndefined)(emojiGroups[j].childNodes[previousRowIndex])) {
                                        // previous row has six buttons
                                        // handle focus change here
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiButtons[focusIndex -= 6];
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        break;
                                    } else if ((0, $3EnZW.isNullOrUndefined)(emojiGroups[j - 1].childNodes[emojiGroups[j - 1].childNodes.length - (previousRowLength - k)])) {
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiGroups[j - 1].lastChild;
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        count = 1;
                                        break;
                                    } else {
                                        // previous row has less than six buttons
                                        // handle focus change here
                                        var firstFocusEle = emojiButtons[i];
                                        (0, $4ZDHT.removeClass)([
                                            firstFocusEle
                                        ], "e-focus");
                                        var focusEle = emojiGroups[j - 1].childNodes[emojiGroups[j - 1].childNodes.length - (previousRowLength - k)];
                                        (0, $4ZDHT.addClass)([
                                            focusEle
                                        ], "e-focus");
                                        focusEle.focus();
                                        count = 1;
                                        break;
                                    }
                                }
                            }
                        }
                    } else {
                        var firstFocusEle = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex -= 1];
                        var inputELe = this.popupObj.element.querySelector(".e-rte-emoji-search");
                        if ((0, $3EnZW.isNullOrUndefined)(focusEle) && !(0, $3EnZW.isNullOrUndefined)(inputELe)) {
                            inputELe.focus();
                            break;
                        }
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        focusEle.focus();
                    }
                    break;
                } else if (e.keyCode === 39) {
                    // Move focus to next button in current row
                    if (emojiButtons.length !== i + 1) {
                        var firstFocusEle = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex += 1];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        emojiButtons[focusIndex].focus();
                    }
                    break;
                } else if (e.keyCode === 37) {
                    // Move focus to previous button in current row
                    if (i > 0) {
                        var firstFocusEle = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex -= 1];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        emojiButtons[focusIndex].focus();
                    }
                    break;
                }
            }
        }
        if (e.keyCode === 40) {
            var firstFocusEle = this.parent.element.querySelector(".e-focus");
            if ((0, $3EnZW.isNullOrUndefined)(firstFocusEle)) {
                var focusEle = emojiButtons[0];
                (0, $4ZDHT.addClass)([
                    focusEle
                ], "e-focus");
                emojiButtons[0].focus();
            }
        }
    };
    EmojiPicker.prototype.filterKeyHandler = function(e) {
        var emojiButtons = this.parent.element.querySelectorAll(".e-rte-emojisearch-btn button");
        var firstFocusEle = this.parent.element.querySelector(".e-focus");
        if ((0, $3EnZW.isNullOrUndefined)(firstFocusEle) && e.keyCode === 40) {
            var focusEle = emojiButtons[0];
            (0, $4ZDHT.addClass)([
                focusEle
            ], "e-focus");
            emojiButtons[0].focus();
        } else for(var i = 0; i < emojiButtons.length; i++){
            var focusIndex = i;
            var childNodes = emojiButtons[i];
            if (childNodes.classList.contains("e-focus")) {
                if (e.keyCode === 38) {
                    if (i >= 6) {
                        var firstFocusEle_1 = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle_1
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex -= 6];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        focusEle.focus();
                        break;
                    } else {
                        var firstFocusEle_2 = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle_2
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex -= 1];
                        var inputELe = this.popupObj.element.querySelector(".e-rte-emoji-search");
                        if ((0, $3EnZW.isNullOrUndefined)(focusEle) && !(0, $3EnZW.isNullOrUndefined)(inputELe)) {
                            inputELe.focus();
                            break;
                        }
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        focusEle.focus();
                    }
                } else if (e.keyCode === 40) {
                    if (emojiButtons.length - 6 > i) {
                        var firstFocusEle_3 = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle_3
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex += 6];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        focusEle.focus();
                        break;
                    }
                } else if (e.keyCode === 39) {
                    if (emojiButtons.length !== i + 1) {
                        var firstFocusEle_4 = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle_4
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex += 1];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        emojiButtons[focusIndex].focus();
                    }
                    break;
                } else if (e.keyCode === 37) {
                    if (i > 0) {
                        var firstFocusEle_5 = emojiButtons[i];
                        (0, $4ZDHT.removeClass)([
                            firstFocusEle_5
                        ], "e-focus");
                        var focusEle = emojiButtons[focusIndex -= 1];
                        (0, $4ZDHT.addClass)([
                            focusEle
                        ], "e-focus");
                        emojiButtons[focusIndex].focus();
                        break;
                    }
                }
            }
        }
    };
    EmojiPicker.prototype.searchFilter = function(e, value) {
        var inputElement = this.parent.element.querySelector(".e-rte-emoji-search");
        var contentELe = this.parent.element.querySelector(".e-content");
        if (document.activeElement === inputElement || document.activeElement === contentELe) {
            var trimmedStr = void 0;
            if (value !== ":" && !(0, $3EnZW.isNullOrUndefined)(value)) trimmedStr = value.replace(/^:/, "");
            else if (!(0, $3EnZW.isNullOrUndefined)(value)) trimmedStr = value;
            var inputValue = (0, $3EnZW.isNullOrUndefined)(inputElement) ? trimmedStr : inputElement.value;
            var emojiButtons = this.parent.element.querySelectorAll(".e-rte-emojipicker-btn button");
            var emojipickerAll = this.parent.element.querySelector(".e-rte-emojipicker-btn");
            var emojiGroups = this.parent.element.querySelectorAll(".e-rte-emojipicker-group");
            var toolbarGroup = this.parent.element.querySelector(".e-rte-emojipicker-toolbar");
            var excludedDiv_1 = this.parent.element.querySelector(".e-rte-emojisearch-btn");
            var firstChild = this.popDiv.childNodes[0];
            var getComputedStyle_2 = window.getComputedStyle(firstChild);
            var inputHeight = firstChild.nodeName === "SPAN" ? firstChild.getBoundingClientRect().height + parseFloat(getComputedStyle_2.marginTop) + parseFloat(getComputedStyle_2.marginBottom) : 0;
            var popupBorder = window.getComputedStyle(this.popDiv);
            // eslint-disable-next-line @typescript-eslint/tslint/config
            var filteredButtons = (0, $3EnZW.isNullOrUndefined)(excludedDiv_1) ? emojiButtons : // eslint-disable-next-line @typescript-eslint/tslint/config
            Array.from(emojiButtons).filter(function(button) {
                return !excludedDiv_1.contains(button);
            });
            if (inputValue === "" || value === ":") {
                toolbarGroup.style.display = "";
                emojipickerAll.style.height = this.popDiv.getBoundingClientRect().height - toolbarGroup.getBoundingClientRect().height - inputHeight - 2 * parseFloat(popupBorder.borderWidth) + "px";
                // eslint-disable-next-line @typescript-eslint/tslint/config
                emojiGroups.forEach(function(element) {
                    element.style.display = "";
                });
            } else {
                // eslint-disable-next-line @typescript-eslint/tslint/config
                emojiGroups.forEach(function(element) {
                    element.style.display = "none";
                });
                toolbarGroup.style.display = "none";
                emojipickerAll.style.height = this.popDiv.getBoundingClientRect().height - inputHeight - 2 * parseFloat(popupBorder.borderWidth) + "px";
            }
            var emojiBtnDiv = this.parent.createElement("div", {
                className: "e-rte-emojisearch-btn"
            });
            var emojis = this.parent.element.querySelector(".e-rte-emojisearch-btn");
            if (emojis) emojis.remove();
            var noEmojiObj = this.parent.createElement("div", {
                className: "e-rte-emojiSearch-noEmoji"
            });
            var noEMoji = true;
            for(var i = 0; i < filteredButtons.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(filteredButtons[i].getAttribute("title"))) {
                var title = filteredButtons[i].getAttribute("title").toLowerCase();
                var titleLength = title.split(" ");
                for(var j = 0; j < titleLength.length; j++)if (titleLength[j].startsWith(inputValue.toLowerCase()) && inputValue !== "") {
                    var emoji = filteredButtons[i].cloneNode(true);
                    emojiBtnDiv.appendChild(emoji);
                    noEMoji = false;
                    break;
                }
            }
            if (noEMoji && !this.parent.element.querySelector(".e-rte-emojiSearch-noEmoji") && inputValue !== "" && value !== ":" && value !== ": :") {
                noEmojiObj.innerHTML = '<span style="color: rgba(0, 0, 0, 0.75); font-weight: 500; font-size: 16px;">' + this.i10n.getConstant("emojiPickerNoResultFound") + " \uD83D\uDE25 </span>" + "<br>" + '<span style="color: rgba(0, 0, 0, 0.75);"> ' + this.i10n.getConstant("emojiPickerTrySomethingElse") + " ? </span>";
                noEmojiObj.style.margin = "55px";
                emojipickerAll.appendChild(noEmojiObj);
            } else if (!noEMoji && this.parent.element.querySelector(".e-rte-emojiSearch-noEmoji") || inputValue === "" && value === ":" || inputValue === "" && this.parent.element.querySelector(".e-rte-emojiSearch-noEmoji")) emojipickerAll.removeChild(this.parent.element.querySelector(".e-rte-emojiSearch-noEmoji"));
            emojipickerAll.appendChild(emojiBtnDiv);
        } else return;
    };
    EmojiPicker.prototype.emojiBtnClick = function(e) {
        var event1 = new MouseEvent("mouseleave", {
            bubbles: true,
            cancelable: true
        });
        // Includes the emote button element tooltip and toolbar tooltip
        var emotePickerTooltips = this.parent.element.querySelectorAll(".e-rte-emojipicker-popup [data-tooltip-id]");
        for(var i = 0; i < emotePickerTooltips.length; i++)emotePickerTooltips[i].dispatchEvent(event1);
        var targetEle = e.target;
        if (targetEle.tagName !== "BUTTON") return;
        targetEle.focus();
        var startOffset = this.save.startOffset;
        var textContent = this.save.range.startContainer.textContent;
        var previousText = textContent.substring(startOffset, startOffset + 1);
        // When toolbar action is clicked then only restore the range.
        if (!(0, $3EnZW.isNullOrUndefined)(this.clickEvent) || previousText !== ":") this.save.restore();
        if (this.popupObj) {
            (0, $4ZDHT.removeClass)([
                this.divElement
            ], "e-active");
            this.popupObj.hide();
        }
        var originalEvent = e;
        this.parent.formatter.process(this.parent, {
            item: {
                "command": "EmojiPicker",
                "subCommand": "EmojiPicker",
                value: targetEle.innerHTML
            }
        }, e, originalEvent);
    };
    EmojiPicker.prototype.onkeyPress = function(e) {
        var originalEvent = e.args;
        var selection = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().contentWindow.getSelection() : this.parent.contentModule.getDocument().getSelection();
        if (selection.rangeCount <= 0) return;
        var range = selection.getRangeAt(0);
        var cursorPos = range.startOffset;
        var prevChar = selection.focusNode.textContent.substring(cursorPos - 1, cursorPos);
        var isPrevSpace = /\s/.test(prevChar);
        var isPrevColon = selection.focusNode.textContent.substring(cursorPos - 1, cursorPos) === ":";
        var colon = selection.focusNode.textContent.charAt(cursorPos - 1) === ":";
        if (originalEvent.keyCode === 186 && originalEvent.shiftKey && (isPrevSpace || selection.focusOffset === 0)) {
            var coordinates = this.getCoordinates();
            this.parent.showEmojiPicker(coordinates.left, coordinates.top);
        }
        if (originalEvent.keyCode === 8 && colon && this.popupObj) {
            (0, $4ZDHT.removeClass)([
                this.divElement
            ], "e-active");
            this.popupObj.hide();
        }
        if (originalEvent.keyCode === 32 && isPrevColon && this.popupObj) {
            (0, $4ZDHT.removeClass)([
                this.divElement
            ], "e-active");
            var currentDocument = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().ownerDocument : this.parent.contentModule.getDocument();
            if (this.parent.showTooltip && !(0, $3EnZW.isNullOrUndefined)(currentDocument.querySelector(".e-tooltip-wrap"))) this.parent.notify($947a002e9a697770$export$121c0465ebbf863b, {
                args: event
            });
            this.popupObj.hide();
        }
        if (this.popupObj && (originalEvent.keyCode === 37 || originalEvent.keyCode === 38 || originalEvent.keyCode === 39 || originalEvent.keyCode === 27 || originalEvent.keyCode === 40)) {
            this.onKeyDown(originalEvent);
            originalEvent.preventDefault();
        }
    };
    EmojiPicker.prototype.onkeyUp = function(e) {
        var originalEvent = e.args;
        var selection = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().contentWindow.getSelection() : this.parent.contentModule.getDocument().getSelection();
        if (selection.rangeCount <= 0) return;
        var range = selection.getRangeAt(0);
        var cursorPos = range.startOffset;
        // eslint-disable-next-line
        var selectedValue;
        var count = 0;
        for(var i = cursorPos - 1; i >= cursorPos - 15; i--){
            var prevChar = selection.focusNode.textContent.substring(i - 1, i);
            var isPrevSpace = /:$/.test(prevChar);
            if (isPrevSpace && !(0, $3EnZW.isNullOrUndefined)(this.popDiv) && count === 0) {
                selectedValue = range.startContainer.textContent.substring(i - 1, cursorPos);
                this.searchFilter(originalEvent, selectedValue);
                count = 1;
            }
        }
        var colon = selection.focusNode.textContent.substring(cursorPos - 1, cursorPos);
        if (colon === ":" && !(0, $3EnZW.isNullOrUndefined)(this.popupObj)) {
            selectedValue = colon;
            this.searchFilter(originalEvent, selectedValue);
        }
    };
    EmojiPicker.prototype.getCoordinates = function() {
        var coordinates;
        var selection = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().contentWindow.getSelection() : window.getSelection();
        var range = selection.getRangeAt(0);
        var firstChild;
        if (range.startContainer.nodeName === "P" || range.startContainer.nodeName === "DIV") {
            if (range.startContainer.childNodes[0].nodeName !== "#text") firstChild = range.startContainer.childNodes[0];
        }
        // eslint-disable-next-line
        var rect = (0, $3EnZW.isNullOrUndefined)(firstChild) ? range.getBoundingClientRect() : firstChild.getBoundingClientRect();
        var rteContent = this.parent.element.querySelector(".e-rte-content");
        var rteEle = this.parent.element;
        var toolbarHeight = rteEle.offsetHeight - rteContent.offsetHeight;
        var cursorTop = rect.top - this.parent.inputElement.getBoundingClientRect().top;
        var cursorLeft = rect.left - this.parent.inputElement.getBoundingClientRect().left;
        var screenHeight = window.innerHeight;
        var popupHeight = 330;
        var popupTop = cursorTop;
        var popupLeft = cursorLeft + rect.width;
        if (rteEle.getBoundingClientRect().top < 0 && !this.parent.inlineMode.enable) popupTop = popupTop + rteContent.getBoundingClientRect().top - toolbarHeight;
        if (rect.top < popupHeight) // eslint-disable-next-line
        popupTop;
        else if (rect.top + popupHeight > screenHeight) popupTop -= popupHeight + 20;
        if (this.parent.inputElement) coordinates = {
            top: popupTop + 60,
            left: popupLeft + 8
        };
        return coordinates;
    };
    EmojiPicker.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$4d7e4d3283b3fc57, this.toolbarClick);
        this.parent.off($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onkeyPress);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.onkeyUp);
        this.parent.off($947a002e9a697770$export$55df3e903573f90b, this.contentscroll);
        this.parent.off($947a002e9a697770$export$209876d7b1ac8f3, this.contentscroll);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string value
     */ EmojiPicker.prototype.getModuleName = function() {
        return "emojiPicker";
    };
    return EmojiPicker;
}();

parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
parcelRequire("j7YE8");
var $cfGuF = parcelRequire("cfGuF");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $1MTdI = parcelRequire("1MTdI");
var $bWDaN = parcelRequire("bWDaN");
/**
 * Specifies the File Manager internal variables
 */ /** @hidden */ var $f592513f3f17ead8$export$be78b3111c50efdd = "isFile";
var $f592513f3f17ead8$export$80cded91831c5507 = "model-changed";
var $f592513f3f17ead8$export$5d4840440f592fca = "initial-end";
var $f592513f3f17ead8$export$30adba19178942b3 = "finalize-end";
var $f592513f3f17ead8$export$870f71f756707ad0 = "create-end";
var $f592513f3f17ead8$export$cd2e3b33990298ee = "filter-end";
var $f592513f3f17ead8$export$8b4af279b77730d2 = "before-delete";
var $f592513f3f17ead8$export$c1264df8455e40f0 = "path-drag";
var $f592513f3f17ead8$export$6c22e1520513dd53 = "delete-init";
var $f592513f3f17ead8$export$ce97bad2aef2d46a = "delete-end";
var $f592513f3f17ead8$export$102918c6556d57bd = "refresh-end";
var $f592513f3f17ead8$export$4ee2cc9ab61ebd89 = "resize-end";
var $f592513f3f17ead8$export$d8057c29295b3f97 = "splitter-resize";
var $f592513f3f17ead8$export$f012f19194778278 = "path-changed";
var $f592513f3f17ead8$export$b1fb4cac938035f7 = "destroy";
var $f592513f3f17ead8$export$efdf6d98d39d3b1a = "before-request";
var $f592513f3f17ead8$export$a3c8e1472dc2ed84 = "upload";
var $f592513f3f17ead8$export$4ba81805392dbd9 = "skip-upload";
var $f592513f3f17ead8$export$5af90369d26bf4d0 = "after-request";
var $f592513f3f17ead8$export$24422be91ad4011f = "download";
var $f592513f3f17ead8$export$c8a5c97778a58170 = "layout-refresh";
var $f592513f3f17ead8$export$6df5a05f342711e3 = "actionFailure";
var $f592513f3f17ead8$export$d76128d007d19019 = "search";
var $f592513f3f17ead8$export$c2e8e8195b50c1cd = "open-init";
var $f592513f3f17ead8$export$d9e8b42c77102776 = "open-end";
var $f592513f3f17ead8$export$6abf7ade54df8039 = "selection-changed";
var $f592513f3f17ead8$export$8c0e181e1fb07b6c = "select-all-init";
var $f592513f3f17ead8$export$846f4c514484a0e8 = "clear-all-init";
var $f592513f3f17ead8$export$167b6548d992c399 = "clear-path-init";
var $f592513f3f17ead8$export$3b302e9dbb0aad19 = "layout-change";
var $f592513f3f17ead8$export$ebb59e6780002d23 = "sort-by-change";
var $f592513f3f17ead8$export$c71f547a81ce4daa = "node-expand";
var $f592513f3f17ead8$export$d41cfdb8d87b5bef = "details-init";
var $f592513f3f17ead8$export$8f25f467acbd067b = "menu-item-data";
var $f592513f3f17ead8$export$8192f7ae2d5b7044 = "rename-init";
var $f592513f3f17ead8$export$fdf3aa211c42164c = "rename-end-parent";
var $f592513f3f17ead8$export$a6dd9c7789352fcb = "rename-end";
var $f592513f3f17ead8$export$dd3932d6faae8783 = "show-paste";
var $f592513f3f17ead8$export$e4ef78b2d2708441 = "hide-paste";
var $f592513f3f17ead8$export$1bab5b85a1c363d3 = "selected-data";
var $f592513f3f17ead8$export$8d0c229d5a5bfdc1 = "cut-copy-init";
var $f592513f3f17ead8$export$df482b6a24e5bccf = "paste-init";
var $f592513f3f17ead8$export$e936e35532731338 = "paste-end";
var $f592513f3f17ead8$export$85f3ebc828366994 = "cut-end";
var $f592513f3f17ead8$export$2aa63067005154ea = "hide-layout";
var $f592513f3f17ead8$export$faa80f63dbb892e4 = "update-tree-selection";
var $f592513f3f17ead8$export$23dd3f8e1c610924 = "select-node";
var $f592513f3f17ead8$export$18b54396d5a039c5 = "sort-column";
var $f592513f3f17ead8$export$40ce9a35c05f873f = "path-column";
var $f592513f3f17ead8$export$4faa0c3c173303f6 = "search-change";
var $f592513f3f17ead8$export$bb9790347e7761d3 = "before-download";
var $f592513f3f17ead8$export$996119a35335562f = "download-init";
var $f592513f3f17ead8$export$80d4b84b534c2942 = "drop-init";
var $f592513f3f17ead8$export$5d38b0bd4bef40ba = "drag-end";
var $f592513f3f17ead8$export$950f16bb18c1805d = "drop-path";
var $f592513f3f17ead8$export$c9aa969138a0d6fa = "drag-helper";
var $f592513f3f17ead8$export$8e6c816465ea7419 = "dragging";
var $f592513f3f17ead8$export$ed7f9366d0aedd6a = "update-selection-data";
var $f592513f3f17ead8$export$5cd299b993c9e318 = "method-call";
var $f592513f3f17ead8$export$826a768f8295bc53 = "read";
var $f592513f3f17ead8$export$95ed0b4b15a415e8 = "write";
var $f592513f3f17ead8$export$7f45bb9cb17642db = "writeContents";
var $f592513f3f17ead8$export$af89a87407dcc862 = "copy";
var $f592513f3f17ead8$export$8dc6cd422363cdbc = "upload";
var $f592513f3f17ead8$export$1812abec3897779e = "download";



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
var $bWDaN = parcelRequire("bWDaN");

/**
 * Specifies the File Manager internal ID's
 */ /** @hidden */ var $15a2a1ec4804cfd7$export$4b2454a32e09a33d = "_toolbar";
var $15a2a1ec4804cfd7$export$2adadcb5e010c2b8 = "_layout";
var $15a2a1ec4804cfd7$export$38ee3afa2b45a08 = "_navigation";
var $15a2a1ec4804cfd7$export$5fedb72465b4ade3 = "_tree";
var $15a2a1ec4804cfd7$export$7e576f6604f42645 = "_grid";
var $15a2a1ec4804cfd7$export$f558f378488ddc5d = "_largeicons";
var $15a2a1ec4804cfd7$export$59dec0612bc7a4af = "_dialog";
var $15a2a1ec4804cfd7$export$91469e9d1a97f8e2 = "_alt_dialog";
var $15a2a1ec4804cfd7$export$e6b68dc330b66d31 = "_img_dialog";
var $15a2a1ec4804cfd7$export$5b7b4899d6625112 = "_extn_dialog";
var $15a2a1ec4804cfd7$export$d18d566614d39740 = "_upload_dialog";
var $15a2a1ec4804cfd7$export$ec088227d5d4ab0e = "_retry_dialog";
var $15a2a1ec4804cfd7$export$4010213931ead79d = "_contextmenu";
var $15a2a1ec4804cfd7$export$1ed159e39ef7964a = "_sortby";
var $15a2a1ec4804cfd7$export$5303554c2245161d = "_view";
var $15a2a1ec4804cfd7$export$c0afe252303253e2 = "_splitter";
var $15a2a1ec4804cfd7$export$1d72a157e3e556f6 = "_content";
var $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a = "_breadcrumbbar";
var $15a2a1ec4804cfd7$export$c84f804ae34d414b = "_upload";
var $15a2a1ec4804cfd7$export$a9b366e05c431226 = "_retry";
var $15a2a1ec4804cfd7$export$cb7313172c50f93c = "_search";
var $15a2a1ec4804cfd7$export$fbea82a1c0574ef4 = "e-filemanager";
var $15a2a1ec4804cfd7$export$43f367b3e957f219 = "e-control";
var $15a2a1ec4804cfd7$export$8324798886b7308c = "e-fe-cb-select";
var $15a2a1ec4804cfd7$export$ee3777be229b6eef = "e-fe-popup";
var $15a2a1ec4804cfd7$export$10d133fc283ac2c8 = "e-fe-mobile";
var $15a2a1ec4804cfd7$export$2f2a984ccbc6a639 = "e-fe-popup e-fe-mobile";
var $15a2a1ec4804cfd7$export$8efc9eeb05d66b6 = "e-fe-m-select";
var $15a2a1ec4804cfd7$export$c1c49903035a02df = "e-fe-m-filter";
var $15a2a1ec4804cfd7$export$78ca07932ec5b059 = "e-layout";
var $15a2a1ec4804cfd7$export$f52dcf7131a7f04 = "e-navigation";
var $15a2a1ec4804cfd7$export$5cf3c525b7cf1403 = "e-layout-content";
var $15a2a1ec4804cfd7$export$aec2fde68eb32201 = "e-large-icons";
var $15a2a1ec4804cfd7$export$d7715306c67126ab = "e-toolbar-item";
var $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13 = "e-list-item";
var $15a2a1ec4804cfd7$export$7080f700b8701d5a = "e-list-text";
var $15a2a1ec4804cfd7$export$ff283a997e6ca548 = "e-list-parent";
var $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 = "e-icons e-fe-tick";
var $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd = "e-icons e-fe-dot";
var $15a2a1ec4804cfd7$export$565566e3df4dad53 = "e-blur";
var $15a2a1ec4804cfd7$export$2b35adb71b3f6143 = "e-active";
var $15a2a1ec4804cfd7$export$9d358706ccac3727 = "e-hover";
var $15a2a1ec4804cfd7$export$82de3c1c31c751e2 = "e-focus";
var $15a2a1ec4804cfd7$export$f5d61d2df1985dc7 = "e-focused";
var $15a2a1ec4804cfd7$export$c953d1cd180adfae = "e-check";
var $15a2a1ec4804cfd7$export$42d32ecba327b593 = "e-frame";
var $15a2a1ec4804cfd7$export$fb41b8a6ed371c7d = "e-checkbox-wrapper";
var $15a2a1ec4804cfd7$export$7d8b172d5f206b6c = "e-row";
var $15a2a1ec4804cfd7$export$3d4b0ddd3cab0a72 = "e-rowcell";
var $15a2a1ec4804cfd7$export$ccb33e29d92c9a58 = "e-empty";
var $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3 = "e-empty-content";
var $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0 = "e-empty-inner-content";
var $15a2a1ec4804cfd7$export$c07b68c109124fe2 = "e-fe-clone";
var $15a2a1ec4804cfd7$export$4109cb617b030b1e = "e-fe-drop-folder";
var $15a2a1ec4804cfd7$export$9fd81f8aee7214cc = "e-fe-drop-file";
var $15a2a1ec4804cfd7$export$d31d8fac97169a4b = "e-fe-folder";
var $15a2a1ec4804cfd7$export$a3f7f90e20dcc8e7 = "e-fe-image";
var $15a2a1ec4804cfd7$export$5983770876beb637 = "e-fe-music";
var $15a2a1ec4804cfd7$export$f9ef686bd51c9c05 = "e-fe-video";
var $15a2a1ec4804cfd7$export$b74755a023d92165 = "e-large-icon";
var $15a2a1ec4804cfd7$export$4b2ad1b4303a207 = "e-empty-icon e-fe-folder";
var $15a2a1ec4804cfd7$export$54743893e645da27 = "e-empty-icon.e-fe-folder";
var $15a2a1ec4804cfd7$export$f3f33a6d3ff78bec = "e-fe-folder";
var $15a2a1ec4804cfd7$export$80fb943452f54f74 = "e-items";
var $15a2a1ec4804cfd7$export$ebd7fdd609e3bc32 = "e-text-content";
var $15a2a1ec4804cfd7$export$be6b1c5f4806b375 = "e-gridheader";
var $15a2a1ec4804cfd7$export$a593ae13b9e744b9 = "e-templatecell";
var $15a2a1ec4804cfd7$export$978b95bc13897273 = "e-treeview";
var $15a2a1ec4804cfd7$export$fec55ff920461811 = "e-menu-item";
var $15a2a1ec4804cfd7$export$3a5f55a56dfc3645 = "e-menu-icon";
var $15a2a1ec4804cfd7$export$f52e1910c5a0ddcd = "e-caret";
var $15a2a1ec4804cfd7$export$3556ea5f805d5290 = "e-content";
var $15a2a1ec4804cfd7$export$2ce331f22aaee532 = "e-gridcontent";
var $15a2a1ec4804cfd7$export$77fa21b8fd9f8f76 = "e-list-parent";
var $15a2a1ec4804cfd7$export$4ed45c65d0a1d78c = "e-icons e-fe-open";
var $15a2a1ec4804cfd7$export$668107712639d3c1 = "e-icons e-fe-upload";
var $15a2a1ec4804cfd7$export$59600ec56318ce2e = "e-icons e-fe-cut";
var $15a2a1ec4804cfd7$export$e08ef55150a91249 = "e-icons e-fe-copy";
var $15a2a1ec4804cfd7$export$b61aa7a218246ebb = "e-icons e-fe-paste";
var $15a2a1ec4804cfd7$export$e5b93bb6e343631c = "e-icons e-fe-delete";
var $15a2a1ec4804cfd7$export$f1d4ae5347f9c581 = "e-icons e-fe-rename";
var $15a2a1ec4804cfd7$export$57ae219d1e034dc1 = "e-icons e-fe-newfolder";
var $15a2a1ec4804cfd7$export$de358f4807ef8cba = "e-icons e-fe-details";
var $15a2a1ec4804cfd7$export$7e533dc0afd7438d = "e-icons e-fe-sort";
var $15a2a1ec4804cfd7$export$885ce83a8b956470 = "e-icons e-fe-refresh";
var $15a2a1ec4804cfd7$export$c7cf3941a3f8df35 = "e-icons e-fe-select";
var $15a2a1ec4804cfd7$export$41f3da434144936c = "e-icons e-fe-download";
var $15a2a1ec4804cfd7$export$1b0c9d59e78ac5f5 = "e-icons e-fe-options";
var $15a2a1ec4804cfd7$export$aad553f955d4f5af = "e-icons e-fe-grid";
var $15a2a1ec4804cfd7$export$ef62356806fa9c5a = "e-icons e-fe-large";
var $15a2a1ec4804cfd7$export$c1566f536bc98e1c = "e-icons e-fe-breadcrumb";
var $15a2a1ec4804cfd7$export$de94d784588986a1 = "e-icons e-fe-clear";
var $15a2a1ec4804cfd7$export$77078bf9d2950a30 = "e-icons e-fe-drop-in";
var $15a2a1ec4804cfd7$export$d6c8d1734b08c7ed = "e-icons e-fe-drop-out";
var $15a2a1ec4804cfd7$export$49500fe0d33b7c10 = "e-icons e-fe-no-drop";
var $15a2a1ec4804cfd7$export$fde44257752a9f60 = "e-icons";
var $15a2a1ec4804cfd7$export$6fe36d251e1cc93a = "e-detailslabel";
var $15a2a1ec4804cfd7$export$36d139578736755 = "e-fe-errorcontent";
var $15a2a1ec4804cfd7$export$e50006273435e7d4 = "e-status";
var $15a2a1ec4804cfd7$export$c3619772211b515b = "e-address";
var $15a2a1ec4804cfd7$export$850f7749a2909601 = "e-rtl";
var $15a2a1ec4804cfd7$export$acfd27c680995d44 = "e-display-none";
var $15a2a1ec4804cfd7$export$253c43e051777c46 = "e-node-collapsed";
var $15a2a1ec4804cfd7$export$c025b5389024f4d2 = "e-fullrow";
var $15a2a1ec4804cfd7$export$ed7aa555383bd98 = "e-icon-collapsible";
var $15a2a1ec4804cfd7$export$bec757eb9b4095e5 = "e-split-bar";
var $15a2a1ec4804cfd7$export$a6e1934effcfc9b9 = "e-headercheck";
var $15a2a1ec4804cfd7$export$abec5a3e0b81aaba = "e-fe-overlay";
var $15a2a1ec4804cfd7$export$764bd63f4c2043a2 = "e-fe-value";






parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


function $a3d9eadd9d99207c$export$8e49660bf2acff45(reference, comparer) {
    // Check if reference and comparer are files or folders
    var referenceIsFile = /\.\S+/.test(reference);
    var comparerIsFile = /\.\S+/.test(comparer);
    // If one is a file and the other is a folder, the folder should come first
    if (referenceIsFile && !comparerIsFile) return 1;
    if (!referenceIsFile && comparerIsFile) return -1;
    var referenceParts = [];
    var comparerParts = [];
    (reference + "").replace(/(\d+)|(\D+)/g, function(_, $1, $2) {
        referenceParts.push([
            $1 || Infinity,
            $2 || ""
        ]);
        return "";
    });
    (comparer + "").replace(/(\d+)|(\D+)/g, function(_, $1, $2) {
        comparerParts.push([
            $1 || Infinity,
            $2 || ""
        ]);
        return "";
    });
    // Compare each part of reference and comparer
    while(referenceParts.length && comparerParts.length){
        var referencePart = referenceParts.shift();
        var comparerPart = comparerParts.shift();
        if (referencePart && comparerPart) {
            var comparisonResult = referencePart[0] - comparerPart[0] || referencePart[1].localeCompare(comparerPart[1]);
            if (comparisonResult) return comparisonResult;
        }
    }
    return referenceParts.length - comparerParts.length;
}
function $a3d9eadd9d99207c$export$a2c7f654da2cad11(node, data, instance) {
    var text = (0, $3EnZW.getValue)("name", data);
    var id = node.getAttribute("data-id");
    var newText = (0, $3EnZW.isNullOrUndefined)(id) ? text : id;
    instance.setProperties({
        path: $a3d9eadd9d99207c$export$2aa3fd96c49a84a8(node, newText, instance.hasId)
    }, true);
    instance.pathId = $a3d9eadd9d99207c$export$f33e5fa5d190a2a9(node);
    instance.pathNames = $a3d9eadd9d99207c$export$775b67e7903d7abd(node, text);
}
function $a3d9eadd9d99207c$export$2aa3fd96c49a84a8(element, text, hasId) {
    var matched = $a3d9eadd9d99207c$export$85488b7eb1e4976f(element, text, false, hasId);
    var path = "/";
    var len = matched.length - 2;
    for(var i = len; i >= 0; i--)path += matched[i] + "/";
    return path;
}
function $a3d9eadd9d99207c$export$f33e5fa5d190a2a9(node) {
    var matched = $a3d9eadd9d99207c$export$85488b7eb1e4976f(node, node.getAttribute("data-uid"), true);
    var ids = [];
    for(var i = matched.length - 1; i >= 0; i--)ids.push(matched[i]);
    return ids;
}
function $a3d9eadd9d99207c$export$775b67e7903d7abd(element, text) {
    var matched = $a3d9eadd9d99207c$export$85488b7eb1e4976f(element, text, false);
    var names = [];
    for(var i = matched.length - 1; i >= 0; i--)names.push(matched[i]);
    return names;
}
function $a3d9eadd9d99207c$export$85488b7eb1e4976f(element, text, isId, hasId) {
    var matched = [
        text
    ];
    var el = element.parentNode;
    while(!(0, $3EnZW.isNullOrUndefined)(el)){
        if ((0, $4ZDHT.matches)(el, "." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13)) {
            var parentText = isId ? el.getAttribute("data-uid") : hasId ? el.getAttribute("data-id") : (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$7080f700b8701d5a, el).textContent;
            matched.push(parentText);
        }
        el = el.parentNode;
        if (el.classList.contains($15a2a1ec4804cfd7$export$978b95bc13897273)) break;
    }
    return matched;
}
function $a3d9eadd9d99207c$export$82476f982757e71e(parent) {
    var key = parent.hasId ? "id" : "name";
    var newPath = "/";
    var i = 1;
    for(i; i < parent.pathId.length; i++){
        var data = (0, $3EnZW.getValue)(parent.pathId[parseInt(i.toString(), 10)], parent.feParent);
        newPath += (0, $3EnZW.getValue)(key, data) + "/";
    }
    parent.setProperties({
        path: newPath
    }, true);
}
function $a3d9eadd9d99207c$export$931affad7351dd89(parent) {
    if (parent.isCut) {
        $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
        parent.selectedNodes = [];
        parent.actionRecords = [];
        parent.enablePaste = false;
        parent.notify($f592513f3f17ead8$export$e4ef78b2d2708441, {});
    }
}
function $a3d9eadd9d99207c$export$da980962bd2147a4(action, parent) {
    parent.isSearchCut = false;
    parent.actionRecords = [];
    parent.activeElements = [];
    parent.notify($f592513f3f17ead8$export$8d0c229d5a5bfdc1, {});
    if (parent.activeElements.length === 0) return false;
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
    var blurEle = parent.activeElements;
    if (parent.activeModule !== "navigationpane") parent.targetPath = parent.path;
    else parent.targetPath = $a3d9eadd9d99207c$export$5a4b9be52684123a(parent.path);
    var i = 0;
    if (blurEle) {
        $a3d9eadd9d99207c$export$90835e7e06f4e75b(parent, blurEle[0]);
        if (action === "cut") while(i < blurEle.length){
            $a3d9eadd9d99207c$export$7f40c4cb15687f80(blurEle[i]);
            i++;
        }
    }
    i = 0;
    parent.selectedNodes = [];
    parent.enablePaste = true;
    parent.notify($f592513f3f17ead8$export$dd3932d6faae8783, {});
    while(i < parent.activeRecords.length){
        parent.actionRecords.push(parent.activeRecords[i]);
        parent.selectedNodes.push((0, $3EnZW.getValue)("name", parent.activeRecords[i]));
        i++;
    }
    if ((parent.breadcrumbbarModule.searchObj.element.value !== "" || parent.isFiltered) && parent.activeModule !== "navigationpane") {
        parent.selectedNodes = [];
        parent.isSearchCut = true;
        var i_1 = 0;
        while(i_1 < parent.selectedItems.length){
            parent.selectedNodes.push(parent.selectedItems[i_1]);
            i_1++;
        }
    }
    return true;
}
function $a3d9eadd9d99207c$export$7f40c4cb15687f80(nodes) {
    nodes.classList.add($15a2a1ec4804cfd7$export$565566e3df4dad53);
}
function $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent, hover) {
    var blurEle = !hover ? parent.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$565566e3df4dad53) : parent.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$9d358706ccac3727);
    var i = 0;
    while(i < blurEle.length){
        blurEle[i].classList.remove(!hover ? $15a2a1ec4804cfd7$export$565566e3df4dad53 : $15a2a1ec4804cfd7$export$9d358706ccac3727);
        i++;
    }
}
function $a3d9eadd9d99207c$export$90835e7e06f4e75b(parent, element) {
    if (element) {
        if (element.classList.contains($15a2a1ec4804cfd7$export$7d8b172d5f206b6c)) parent.activeModule = "detailsview";
        else if ((0, $4ZDHT.closest)(element, "." + $15a2a1ec4804cfd7$export$b74755a023d92165)) parent.activeModule = "largeiconsview";
        else parent.activeModule = "navigationpane";
    }
}
function $a3d9eadd9d99207c$export$dbc315476b554bdb(parent, value, isLayoutChange) {
    var searchWord;
    if (value.length === 0 && !parent.isFiltered) parent.notify($f592513f3f17ead8$export$40ce9a35c05f873f, {
        args: parent
    });
    if ((0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent)) {
        if (value === "") {
            parent.itemData = parent.fileSystemData;
            (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, $f592513f3f17ead8$export$3b302e9dbb0aad19, parent.path);
        } else {
            parent.searchSettings.filterType = (0, $3EnZW.isNullOrUndefined)(parent.searchSettings.filterType) ? "contains" : parent.searchSettings.filterType;
            var filteredData = parent.fileSystemData.filter(function(obj) {
                return obj.parentId !== null;
            });
            var data = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(filteredData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("name", parent.searchSettings.filterType, value, parent.searchSettings.ignoreCase));
            var searchValue = parent.searchSettings.ignoreCase ? value.toLowerCase() : value;
            parent.itemData = data;
            (0, $5703c0df24e3a120$export$4b85d3515bd863a5)(parent, isLayoutChange ? $f592513f3f17ead8$export$3b302e9dbb0aad19 : $f592513f3f17ead8$export$d76128d007d19019, parent.path, searchValue, parent.showHiddenItems, !parent.searchSettings.ignoreCase);
        }
        return;
    }
    if (parent.searchSettings.filterType === "startsWith") searchWord = value + "*";
    else if (parent.searchSettings.filterType === "endsWith") searchWord = "*" + value;
    else searchWord = "*" + value + "*";
    parent.searchWord = searchWord;
    parent.itemData = [
        $a3d9eadd9d99207c$export$c578b88ebf312dbd(parent)
    ];
    if (value.length > 0) {
        var caseSensitive = parent.searchSettings.ignoreCase;
        var hiddenItems = parent.showHiddenItems;
        (0, $5703c0df24e3a120$export$4b85d3515bd863a5)(parent, isLayoutChange ? $f592513f3f17ead8$export$3b302e9dbb0aad19 : $f592513f3f17ead8$export$d76128d007d19019, parent.path, searchWord, hiddenItems, !caseSensitive);
    } else if (!parent.isFiltered) {
        if (parent.isSortByClicked) {
            parent.notify($f592513f3f17ead8$export$3b302e9dbb0aad19, {
                files: parent.oldView === "Details" ? parent.detailsviewModule.gridObj.dataSource : parent.largeiconsviewModule.allItems
            });
            parent.isSortByClicked = false;
        } else (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, isLayoutChange ? $f592513f3f17ead8$export$3b302e9dbb0aad19 : $f592513f3f17ead8$export$d76128d007d19019, parent.path);
    } else (0, $5703c0df24e3a120$export$3dea766d36a8935f)(parent, $f592513f3f17ead8$export$3b302e9dbb0aad19);
}
function $a3d9eadd9d99207c$export$16101e34a0df23af(parent, view) {
    parent.oldView = parent.view;
    parent.setProperties({
        view: view
    }, true);
    if (parent.breadcrumbbarModule.searchObj.element.value !== "" || parent.isFiltered) parent.layoutSelectedItems = parent.selectedItems;
    var searchWord = "";
    if (parent.breadcrumbbarModule.searchObj.element.value) searchWord = parent.breadcrumbbarModule.searchObj.element.value;
    parent.isLayoutChange = true;
    $a3d9eadd9d99207c$export$dbc315476b554bdb(parent, searchWord, true);
}
function $a3d9eadd9d99207c$export$8db89c6e3bd21eb5(parent, element) {
    var tartgetModule = "";
    if (element) {
        if ((0, $4ZDHT.closest)(element, "." + $15a2a1ec4804cfd7$export$fbea82a1c0574ef4 + "." + $15a2a1ec4804cfd7$export$43f367b3e957f219 + " ." + $15a2a1ec4804cfd7$export$2ce331f22aaee532)) tartgetModule = "detailsview";
        else if ((0, $4ZDHT.closest)(element, "." + $15a2a1ec4804cfd7$export$aec2fde68eb32201)) tartgetModule = "largeiconsview";
        else if (element.classList.contains("e-fullrow") || element.classList.contains("e-icon-expandable")) tartgetModule = "navigationpane";
        else if ((0, $4ZDHT.closest)(element, ".e-address-list-item")) tartgetModule = "breadcrumbbar";
        else tartgetModule = "";
    }
    parent.targetModule = tartgetModule;
}
function $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8(parent) {
    parent.itemData = [
        $a3d9eadd9d99207c$export$c578b88ebf312dbd(parent)
    ];
    if (!$a3d9eadd9d99207c$export$7121632912d0e323(parent.itemData[0])) $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, parent.itemData[0], $f592513f3f17ead8$export$826a768f8295bc53);
    else (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, $f592513f3f17ead8$export$102918c6556d57bd, parent.path);
}
function $a3d9eadd9d99207c$export$d42fb38e7fbe6740(parent) {
    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, $f592513f3f17ead8$export$d9e8b42c77102776, parent.path);
}
function $a3d9eadd9d99207c$export$c578b88ebf312dbd(parent) {
    return (0, $3EnZW.getValue)(parent.pathId[parent.pathId.length - 1], parent.feParent);
}
function $a3d9eadd9d99207c$export$6738b3634be42910(parent) {
    if (!$a3d9eadd9d99207c$export$da980962bd2147a4("copy", parent)) return;
    else parent.fileAction = "copy";
}
function $a3d9eadd9d99207c$export$3e9460fe0b724f5e(parent) {
    if (!$a3d9eadd9d99207c$export$da980962bd2147a4("cut", parent)) return;
    else {
        parent.isCut = true;
        parent.fileAction = "move";
    }
}
function $a3d9eadd9d99207c$export$e40fbc04d72f5340(file) {
    var isFile = (0, $3EnZW.getValue)("isFile", file);
    if (!isFile) return $15a2a1ec4804cfd7$export$d31d8fac97169a4b;
    var imageFormat = [
        "bmp",
        "dib",
        "jpg",
        "jpeg",
        "jpe",
        "jfif",
        "gif",
        "tif",
        "tiff",
        "png",
        "ico"
    ];
    var audioFormat = [
        "mp3",
        "wav",
        "aac",
        "ogg",
        "wma",
        "aif",
        "fla",
        "m4a"
    ];
    var videoFormat = [
        "webm",
        "mkv",
        "flv",
        "vob",
        "ogv",
        "ogg",
        "avi",
        "wmv",
        "mp4",
        "3gp"
    ];
    var knownFormat = [
        "css",
        "exe",
        "html",
        "js",
        "msi",
        "pdf",
        "pptx",
        "ppt",
        "rar",
        "zip",
        "txt",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "xml",
        "rtf",
        "php"
    ];
    var filetype = (0, $3EnZW.getValue)("type", file);
    filetype = filetype.toLowerCase();
    if (filetype.indexOf(".") !== -1) filetype = filetype.split(".").join("");
    var iconType;
    if (imageFormat.indexOf(filetype) !== -1) iconType = $15a2a1ec4804cfd7$export$a3f7f90e20dcc8e7;
    else if (audioFormat.indexOf(filetype) !== -1) iconType = $15a2a1ec4804cfd7$export$5983770876beb637;
    else if (videoFormat.indexOf(filetype) !== -1) iconType = $15a2a1ec4804cfd7$export$f9ef686bd51c9c05;
    else if (knownFormat.indexOf(filetype) !== -1) iconType = "e-fe-" + filetype;
    else iconType = "e-fe-unknown e-fe-" + filetype;
    return iconType;
}
function $a3d9eadd9d99207c$export$492f76f65bf1bced(parent, item) {
    var imgUrl = (0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent) ? (0, $3EnZW.getValue)("imageUrl", item) : "";
    if ((0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent)) {
        var eventArgs_1 = {
            fileDetails: [
                item
            ],
            imageUrl: imgUrl
        };
        parent.trigger("beforeImageLoad", eventArgs_1);
        return eventArgs_1.imageUrl;
    }
    var baseUrl = parent.ajaxSettings.getImageUrl ? parent.ajaxSettings.getImageUrl : parent.ajaxSettings.url;
    var pathUrl = baseUrl.indexOf("?") !== -1 ? "&path=" : "?path=";
    var fileName = encodeURIComponent((0, $3EnZW.getValue)("name", item));
    var fPath = (0, $3EnZW.getValue)("filterPath", item);
    if (parent.hasId) {
        var imgId = (0, $3EnZW.getValue)("id", item);
        imgUrl = baseUrl + pathUrl + parent.path + "&id=" + imgId;
    } else if (!(0, $3EnZW.isNullOrUndefined)(fPath)) imgUrl = baseUrl + pathUrl + encodeURIComponent(fPath.replace(/\\/g, "/")) + fileName;
    else imgUrl = baseUrl + pathUrl + parent.path + fileName;
    imgUrl = imgUrl + "&time=" + new Date().getTime().toString();
    var eventArgs = {
        fileDetails: [
            item
        ],
        imageUrl: imgUrl
    };
    parent.trigger("beforeImageLoad", eventArgs);
    return eventArgs.imageUrl;
}
function $a3d9eadd9d99207c$export$ce41aaed7504a4ce(parent, data, path) {
    var filePath = (0, $3EnZW.getValue)(parent.hasId ? "id" : "name", data) + "/";
    var fPath = (0, $3EnZW.getValue)(parent.hasId ? "filterId" : "filterPath", data);
    if (!(0, $3EnZW.isNullOrUndefined)(fPath)) return fPath.replace(/\\/g, "/") + filePath;
    else return path + filePath;
}
function $a3d9eadd9d99207c$export$7d9f7e9c1c02b41e(parent, data) {
    var name = (0, $3EnZW.getValue)("name", data);
    var fPath = (0, $3EnZW.getValue)("filterPath", data);
    if ((parent.breadcrumbbarModule.searchObj.element.value !== "" || parent.isFiltered) && !(0, $3EnZW.isNullOrUndefined)(fPath)) {
        fPath = fPath.replace(/\\/g, "/");
        name = fPath.replace(parent.path, "") + name;
    }
    return name;
}
function $a3d9eadd9d99207c$export$78086a13d87d987d(parent, items) {
    if (items.length === 0) return items;
    var query;
    if (parent.sortOrder !== "None" && !(0, $3EnZW.isNullOrUndefined)(parent.sortOrder)) query = new (0, $56262f229d1cff45$export$62297b13309008b2)().sortBy(parent.sortBy, parent.sortOrder.toLowerCase(), true).group("isFile");
    else query = new (0, $56262f229d1cff45$export$62297b13309008b2)().group("isFile");
    var lists = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(items).executeLocal(query);
    return (0, $3EnZW.getValue)("records", lists);
}
function $a3d9eadd9d99207c$export$93534728ecb2e7b9(parent, key, value) {
    var currFiles = (0, $3EnZW.getValue)(parent.pathId[parent.pathId.length - 1], parent.feFiles);
    var result = currFiles.filter(function(data) {
        return data[key].toString() === value;
    });
    return result.length > 0 ? result[0] : null;
}
function $a3d9eadd9d99207c$export$b7ca5bd2fd689a12(parent, element, args) {
    var top;
    var layoutElement = (0, $4ZDHT.select)("#" + parent.element.id + $15a2a1ec4804cfd7$export$2adadcb5e010c2b8, parent.element);
    var addressBarHeight = (0, $4ZDHT.select)("#" + parent.element.id + $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a, layoutElement).offsetHeight;
    top = layoutElement.offsetHeight - addressBarHeight;
    if (parent.view === "Details") top = top - (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$be6b1c5f4806b375, layoutElement).offsetHeight;
    if ((0, $3EnZW.isNullOrUndefined)(element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58))) {
        var emptyDiv = (0, $4ZDHT.createElement)("div", {
            className: $15a2a1ec4804cfd7$export$ccb33e29d92c9a58
        });
        var emptyFolder = (0, $4ZDHT.createElement)("div", {
            className: $15a2a1ec4804cfd7$export$4b2ad1b4303a207
        });
        var emptyEle = (0, $4ZDHT.createElement)("div", {
            className: $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3
        });
        var dragFile = (0, $4ZDHT.createElement)("div", {
            className: $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0
        });
        if (parent.view === "Details") element.querySelector("." + $15a2a1ec4804cfd7$export$3556ea5f805d5290).appendChild(emptyDiv);
        else element.appendChild(emptyDiv);
        emptyDiv.appendChild(emptyFolder);
        emptyDiv.appendChild(emptyEle);
        emptyDiv.appendChild(dragFile);
    }
    if (element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58)) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.error)) {
            element.querySelector("." + $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Access-Denied");
            element.querySelector("." + $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Access-Details");
        } else if (parent.isFiltered) {
            element.querySelector("." + $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Filter-Empty");
            element.querySelector("." + $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Filter-Key");
        } else if (parent.breadcrumbbarModule.searchObj.element.value !== "") {
            element.querySelector("." + $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Search-Empty");
            element.querySelector("." + $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Search-Key");
        } else {
            element.querySelector("." + $15a2a1ec4804cfd7$export$7d2ba3f61c670ba3).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Folder-Empty");
            element.querySelector("." + $15a2a1ec4804cfd7$export$e2b129c24c9fd8a0).innerHTML = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "File-Upload");
        }
    }
    var eDiv = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58, element);
    top = (top - eDiv.offsetHeight) / 2;
    eDiv.style.marginTop = top + "px";
}
function $a3d9eadd9d99207c$export$f29bab63f8b0973c(files) {
    return new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(files).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where($f592513f3f17ead8$export$be78b3111c50efdd, "equal", false, false));
}
function $a3d9eadd9d99207c$export$2a9c1530768ed4e2(result, rootId) {
    var dirs = $a3d9eadd9d99207c$export$f29bab63f8b0973c(result.files);
    for(var i = 0, len = dirs.length; i < len; i++)(0, $3EnZW.setValue)("_fm_id", rootId + "_" + i, dirs[i]);
}
function $a3d9eadd9d99207c$export$9e2d02f4778015c5(args, localeString, dateFormat) {
    for(var i = 0; i < args.length; i++){
        var createdDate = new Date((0, $3EnZW.getValue)("dateCreated", args[i]));
        var modifiedDate = new Date((0, $3EnZW.getValue)("dateModified", args[i]));
        if ((0, $3EnZW.isNullOrUndefined)(dateFormat)) dateFormat = "MM/dd/yyyy";
        (0, $3EnZW.setValue)("_fm_created", localeString.formatDate(createdDate, {
            format: dateFormat
        }), args[i]);
        (0, $3EnZW.setValue)("_fm_modified", localeString.formatDate(modifiedDate, {
            format: dateFormat
        }), args[i]);
    }
}
function $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, text) {
    var locale = parent.localeObj.getConstant(text);
    return locale === "" ? text : locale;
}
function $a3d9eadd9d99207c$export$1840124d43c97419(parent, css) {
    var cssClass = parent.cssClass;
    cssClass = (0, $3EnZW.isNullOrUndefined)(cssClass) || cssClass === "" ? css : cssClass + " " + css;
    return cssClass;
}
function $a3d9eadd9d99207c$export$3378c763463f8b33(parent, args) {
    var tick;
    parent.isSortByClicked = true;
    if (args.item.id.indexOf("ascending") !== -1 || args.item.id.indexOf("descending") !== -1 || args.item.id.indexOf("none") !== -1) tick = true;
    else tick = false;
    if (!tick) parent.sortBy = $a3d9eadd9d99207c$export$9b753af5a9fb5911(args.item.id, parent);
    else parent.sortOrder = $a3d9eadd9d99207c$export$9b753af5a9fb5911(args.item.id);
    parent.itemData = [
        $a3d9eadd9d99207c$export$c578b88ebf312dbd(parent)
    ];
    if (parent.view === "Details") {
        if (parent.isMobile) $a3d9eadd9d99207c$export$16101e34a0df23af(parent, "Details");
        else {
            parent.notify($f592513f3f17ead8$export$18b54396d5a039c5, {
                module: "detailsview"
            });
            parent.isSortByClicked = false;
        }
    }
    if (parent.view === "LargeIcons") $a3d9eadd9d99207c$export$16101e34a0df23af(parent, "LargeIcons");
    parent.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
}
function $a3d9eadd9d99207c$export$9b753af5a9fb5911(id, parent) {
    var text = id.substring(id.lastIndexOf("_") + 1);
    var field = text;
    var column;
    if (parent) column = parent.detailsViewSettings.columns;
    switch(text){
        case "date":
            for(var i = 0, len = column.length; i < len; i++)if (column[i].field === "dateModified" || column[i].field === "dateCreated") {
                field = column[i].field;
                break;
            } else field = "_fm_modified";
            break;
        case "ascending":
            field = "Ascending";
            break;
        case "descending":
            field = "Descending";
            break;
        case "none":
            field = "None";
            break;
    }
    return field;
}
function $a3d9eadd9d99207c$export$5c336ffc984a639f(parent, path) {
    var currfolders = path.split("/");
    var folders = parent.originalPath.split("/");
    var root = (0, $3EnZW.getValue)(parent.pathId[0], parent.feParent);
    var key = (0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("id", root)) ? "name" : "id";
    for(var i = currfolders.length - 1, len = folders.length - 1; i < len; i++){
        var eventName = folders[i + 1] === "" ? $f592513f3f17ead8$export$30adba19178942b3 : $f592513f3f17ead8$export$5d4840440f592fca;
        var newPath = folders[i] === "" ? "/" : parent.path + folders[i] + "/";
        var data = $a3d9eadd9d99207c$export$93534728ecb2e7b9(parent, key, folders[parseInt(i.toString(), 10)]);
        if (!(0, $3EnZW.isNullOrUndefined)(data)) {
            var id = (0, $3EnZW.getValue)("_fm_id", data);
            parent.setProperties({
                path: newPath
            }, true);
            parent.pathId.push(id);
            parent.itemData = [
                data
            ];
            parent.pathNames.push((0, $3EnZW.getValue)("name", data));
        } else parent.originalPath = newPath;
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, eventName, parent.path);
        break;
    }
}
function $a3d9eadd9d99207c$export$d60e3393d26bdbb4(parent, data) {
    parent.originalPath = $a3d9eadd9d99207c$export$ce41aaed7504a4ce(parent, data, parent.path);
    var root = (0, $3EnZW.getValue)(parent.pathId[0], parent.feParent);
    var isRoot = (0, $3EnZW.getValue)("_fm_id", parent.itemData[0]) === "fe_tree";
    var key = (0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("id", root)) ? "name" : "id";
    var searchData = $a3d9eadd9d99207c$export$93534728ecb2e7b9(parent, key, (0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent) ? (0, $3EnZW.getValue)("id", data) : (0, $3EnZW.getValue)("name", data));
    if ((0, $3EnZW.isNullOrUndefined)(searchData)) {
        if (!isRoot) parent.notify($f592513f3f17ead8$export$167b6548d992c399, {
            selectedNode: parent.pathId[parent.pathId.length - 1]
        });
        else {
            $a3d9eadd9d99207c$export$5c336ffc984a639f(parent, parent.path);
            return;
        }
    } else {
        var id = (0, $3EnZW.getValue)("_fm_id", searchData);
        parent.setProperties({
            path: parent.originalPath
        }, true);
        parent.pathId.push(id);
        parent.itemData = [
            searchData
        ];
        parent.pathNames.push((0, $3EnZW.getValue)("name", searchData));
    }
    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, parent.path !== parent.originalPath ? $f592513f3f17ead8$export$5d4840440f592fca : $f592513f3f17ead8$export$30adba19178942b3, parent.path);
}
function $a3d9eadd9d99207c$export$5b201a757191240e(parent) {
    parent.isDragDrop = false;
    if (parent.selectedNodes.length !== 0 && parent.enablePaste) {
        var path = parent.folderPath === "" ? parent.path : parent.folderPath;
        if (parent.activeModule === "navigationpane" && !parent.selectedNodes[0].includes("/")) parent.targetPath = (0, $3EnZW.getValue)("filterPath", parent.actionRecords[0]).replace(/\\/g, "/");
        var subFolder = $a3d9eadd9d99207c$export$ef67620a66ef2806(parent, parent.actionRecords, path, parent.path);
        if (!subFolder) {
            if (parent.fileAction === "move" && parent.targetPath !== path || parent.fileAction === "copy") {
                parent.notify($f592513f3f17ead8$export$df482b6a24e5bccf, {});
                (0, $5703c0df24e3a120$export$9b6706c8686cfc8e)(parent, parent.targetPath, parent.selectedNodes, path, parent.fileAction, [], parent.actionRecords);
            } else {
                parent.enablePaste = false;
                parent.notify($f592513f3f17ead8$export$e4ef78b2d2708441, {});
                $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
                var result = {
                    files: null,
                    error: {
                        code: "402",
                        message: $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Same-Folder-Error"),
                        fileExists: null
                    }
                };
                (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
            }
        }
    }
}
function $a3d9eadd9d99207c$export$ef67620a66ef2806(parent, data, dropPath, dragPath) {
    var subFolder = false;
    for(var i = 0; i < data.length; i++)if (!(0, $3EnZW.getValue)("isFile", data[i])) {
        var tempTarget = $a3d9eadd9d99207c$export$ce41aaed7504a4ce(parent, data[i], dragPath);
        if (dropPath.indexOf(tempTarget) === 0) {
            var result = {
                files: null,
                error: {
                    code: "402",
                    message: $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Sub-Folder-Error"),
                    fileExists: null
                }
            };
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
            subFolder = true;
            break;
        }
    } else {
        var name_1 = parent.dragData[i] ? parent.dragData[i].name : null;
        var srcData = (0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent) ? name_1 : parent.dragNodes[i];
        var len = 0;
        if (srcData) len = srcData.lastIndexOf("/");
        var path = "";
        if (len > 0) path = dragPath + srcData.substring(0, len + 1);
        if (path === dropPath) {
            var result = {
                files: null,
                error: {
                    code: "402",
                    message: $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Same-Folder-Error"),
                    fileExists: null
                }
            };
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
            subFolder = true;
            break;
        }
    }
    return subFolder;
}
function $a3d9eadd9d99207c$export$afe40c41f16233cf(parent) {
    parent.isDragDrop = true;
    if (parent.dragData.length !== 0) {
        parent.dragPath = parent.dragPath.replace(/\\/g, "/");
        parent.dropPath = parent.dropPath.replace(/\\/g, "/");
        var subFolder = $a3d9eadd9d99207c$export$ef67620a66ef2806(parent, parent.dragData, parent.dropPath, parent.dragPath);
        if (!subFolder && parent.dragPath !== parent.dropPath) {
            parent.itemData = [
                parent.dropData
            ];
            (0, $5703c0df24e3a120$export$9b6706c8686cfc8e)(parent, parent.dragPath, parent.dragNodes, parent.dropPath, "move", [], parent.dragData);
            parent.notify($f592513f3f17ead8$export$df482b6a24e5bccf, {});
        }
    }
}
function $a3d9eadd9d99207c$export$5a4b9be52684123a(oldPath) {
    var path = oldPath.split("/");
    var newPath = path[0] + "/";
    for(var i = 1; i < path.length - 2; i++)newPath += path[i] + "/";
    return newPath;
}
function $a3d9eadd9d99207c$export$386ecaf3f3c304a2(parent, args) {
    var filePath = (0, $3EnZW.getValue)(parent.hasId ? "id" : "name", args.cwd) + "/";
    var fPath = (0, $3EnZW.getValue)(parent.hasId && !(0, $3EnZW.isNullOrUndefined)(parent.ajaxSettings.url) ? "filterId" : "filterPath", args.cwd);
    if (!(0, $3EnZW.isNullOrUndefined)(fPath)) {
        if (fPath === "") return parent.hasId && !(0, $3EnZW.isNullOrUndefined)(parent.ajaxSettings.url) ? filePath : "/";
        return fPath.replace(/\\/g, "/") + filePath;
    } else return (0, $5703c0df24e3a120$export$ff708c1db2088d11)(parent) ? filePath : parent.path + filePath;
}
function $a3d9eadd9d99207c$export$bf862042e040347a(parent, operation, result) {
    if (operation === "move") {
        if (!parent.isDragDrop) {
            parent.enablePaste = false;
            parent.notify($f592513f3f17ead8$export$e4ef78b2d2708441, {});
            parent.notify($f592513f3f17ead8$export$85f3ebc828366994, result);
        } else parent.notify($f592513f3f17ead8$export$5d38b0bd4bef40ba, result);
    }
    if (parent.duplicateItems.length === 0) parent.pasteNodes = [];
    var flag = false;
    for(var count = 0; count < result.files.length && !flag; count++){
        parent.pasteNodes.push(result.files[count][parent.hasId ? "id" : "name"]);
        if (parent.isDragDrop) parent.droppedObjects.push(result.files[count]);
    }
    parent.duplicateItems = [];
    parent.duplicateRecords = [];
    if (parent.isDragDrop && !parent.isPasteError) parent.isDropEnd = true;
    else parent.isDropEnd = false;
    if (!parent.isDragDrop || parent.path === parent.dragPath || parent.path === parent.dropPath || parent.isSearchDrag) {
        parent.isPathDrag = false;
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, $f592513f3f17ead8$export$e936e35532731338, parent.path);
    } else $a3d9eadd9d99207c$export$81da05fc5b680ef7(parent);
    parent.trigger("success", {
        action: operation,
        result: result
    });
}
function $a3d9eadd9d99207c$export$81da05fc5b680ef7(parent) {
    var pathId = (0, $3EnZW.getValue)("_fm_id", parent.dropData);
    parent.expandedId = pathId;
    parent.itemData = [
        parent.dropData
    ];
    if (parent.isPathDrag) parent.notify($f592513f3f17ead8$export$c1264df8455e40f0, parent.itemData);
    else {
        if (parent.navigationpaneModule) {
            var node = (0, $4ZDHT.select)('[data-uid="' + pathId + '"]', parent.navigationpaneModule.treeObj.element);
            if (!node) {
                var liElement = document.querySelector('[data-id = "' + (0, $3EnZW.getValue)("id", parent.dropData) + '"]');
                pathId = liElement.getAttribute("data-uid");
                node = (0, $4ZDHT.select)('[data-uid="' + pathId + '"]', parent.navigationpaneModule.treeObj.element);
            }
            $a3d9eadd9d99207c$export$a2c7f654da2cad11(node, parent.dropData, parent);
        }
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(parent, $f592513f3f17ead8$export$950f16bb18c1805d, parent.dropPath);
    }
}
function $a3d9eadd9d99207c$export$c7dce5a08d23ecd(parent, name) {
    var data = null;
    var records = parent.isDragDrop ? parent.dragData : parent.actionRecords;
    for(var i = 0; i < records.length; i++)if ((0, $3EnZW.getValue)("name", records[i]) === name) {
        data = records[i];
        break;
    }
    return data;
}
function $a3d9eadd9d99207c$export$fda104f371357c1e(parent) {
    parent.isSearchDrag = false;
    if (parent.breadcrumbbarModule.searchObj.element.value !== "") parent.isSearchDrag = true;
    if (parent.activeModule !== "navigationpane") {
        parent.dragNodes = [];
        var i = 0;
        while(i < parent.selectedItems.length){
            parent.dragNodes.push(parent.selectedItems[i]);
            i++;
        }
        if (parent.selectedItems.length === 0 && parent.dragData && parent.dragData.length === 1) parent.dragNodes.push($a3d9eadd9d99207c$export$31330438f6059b08(parent, parent.dragData[0]));
    }
    var cloneIcon = parent.createElement("div", {
        className: "e-fe-icon " + $a3d9eadd9d99207c$export$e40fbc04d72f5340(parent.dragData[0])
    });
    var cloneName = parent.createElement("div", {
        className: "e-fe-name",
        innerHTML: parent.dragData[0].name
    });
    var virtualEle = parent.createElement("div", {
        className: "e-fe-content"
    });
    virtualEle.appendChild(cloneIcon);
    virtualEle.appendChild(cloneName);
    var ele = parent.createElement("div", {
        className: $15a2a1ec4804cfd7$export$c07b68c109124fe2
    });
    ele.appendChild(virtualEle);
    if (parent.dragNodes.length > 1) {
        var badge = parent.createElement("span", {
            className: "e-fe-count",
            innerHTML: parent.dragNodes.length.toString(10)
        });
        ele.appendChild(badge);
    }
    parent.virtualDragElement = ele;
    parent.element.appendChild(parent.virtualDragElement);
}
function $a3d9eadd9d99207c$export$202f08d3a6bd576(parent, args) {
    var dragArgs = args;
    dragArgs.cancel = false;
    if (parent.treeExpandTimer != null) {
        window.clearTimeout(parent.treeExpandTimer);
        parent.treeExpandTimer = null;
    }
    $a3d9eadd9d99207c$export$e1dbe7adbd52a3f1(parent);
    parent.element.classList.remove("e-fe-drop", "e-no-drop");
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
    parent.uploadObj.dropArea = (0, $4ZDHT.select)("#" + parent.element.id + $15a2a1ec4804cfd7$export$1d72a157e3e556f6, parent.element);
    var virtualEle = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$c07b68c109124fe2, parent.element);
    if (virtualEle) (0, $4ZDHT.detach)(virtualEle);
    $a3d9eadd9d99207c$export$8db89c6e3bd21eb5(parent, args.target);
    parent.notify($f592513f3f17ead8$export$80d4b84b534c2942, args);
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent, "hover");
    dragArgs.fileDetails = parent.dragData;
    parent.trigger("fileDragStop", dragArgs, function(dragArgs) {
        if (!dragArgs.cancel && !(0, $3EnZW.isNullOrUndefined)(parent.targetModule) && parent.targetModule !== "" && parent.dragCount > 2) $a3d9eadd9d99207c$export$afe40c41f16233cf(parent);
        parent.dragCount = 0;
    });
}
function $a3d9eadd9d99207c$export$db131b841f9f6440(parent, args, dragObj) {
    var dragArgs = args;
    dragArgs.cancel = false;
    dragArgs.fileDetails = parent.dragData;
    parent.dragCount = 0;
    parent.droppedObjects = [];
    if (!parent.allowDragAndDrop || parent.activeModule === "navigationpane" && (0, $4ZDHT.closest)(args.element, "li").getAttribute("data-uid") === parent.pathId[0]) dragArgs.cancel = true;
    if (parent.activeModule === "navigationpane" && parent.pathId.indexOf((0, $4ZDHT.closest)(args.element, "li").getAttribute("data-uid")) !== -1) parent.isPathDrag = true;
    else parent.isPathDrag = false;
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
    if (dragArgs.cancel) {
        dragObj.intDestroy(args.event);
        $a3d9eadd9d99207c$export$232dab2e7ec94e79(parent);
    } else if (!dragArgs.cancel) {
        var i = 0;
        while(i < parent.activeElements.length){
            $a3d9eadd9d99207c$export$7f40c4cb15687f80(parent.activeElements[i]);
            i++;
        }
        parent.trigger("fileDragStart", dragArgs, function(dragArgs) {
            if (dragArgs.cancel) {
                dragObj.intDestroy(args.event);
                $a3d9eadd9d99207c$export$232dab2e7ec94e79(parent);
            } else parent.uploadObj.dropArea = null;
        });
    }
}
function $a3d9eadd9d99207c$export$232dab2e7ec94e79(parent) {
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent);
    var virtualEle = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$c07b68c109124fe2, parent.element);
    if (virtualEle) (0, $4ZDHT.detach)(virtualEle);
}
function $a3d9eadd9d99207c$export$e1dbe7adbd52a3f1(parent) {
    $a3d9eadd9d99207c$export$1edfdb119638a43a(parent, $15a2a1ec4804cfd7$export$4109cb617b030b1e);
    $a3d9eadd9d99207c$export$1edfdb119638a43a(parent, $15a2a1ec4804cfd7$export$9fd81f8aee7214cc);
}
function $a3d9eadd9d99207c$export$1edfdb119638a43a(parent, value) {
    var ele = parent.element.querySelectorAll("." + value);
    for(var i = 0; i < ele.length; i++)ele[i].classList.remove(value);
}
function $a3d9eadd9d99207c$export$f43482f3c394e174(scrollParent, parent, nodeClass, clientY) {
    var position;
    var elementData = scrollParent.getBoundingClientRect();
    var node = (0, $4ZDHT.select)("." + nodeClass, scrollParent);
    if (clientY >= elementData.top + scrollParent.clientHeight - 30 && !(0, $3EnZW.isNullOrUndefined)(node)) {
        position = parent.targetModule === "navigationpane" || parent.targetModule === "detailsview" ? node.offsetHeight / 2.5 : node.offsetHeight / 4.5;
        scrollParent.scrollBy(0, position);
    }
    if (!(0, $3EnZW.isNullOrUndefined)(node) && clientY <= elementData.top + 30) {
        position = parent.targetModule === "navigationpane" || parent.targetModule === "detailsview" ? node.offsetHeight / 2.5 : node.offsetHeight / 4.5;
        scrollParent.scrollBy(0, -position);
    }
}
function $a3d9eadd9d99207c$export$f293f44a7af9215d(parent, args) {
    var dragArgs = args;
    dragArgs.fileDetails = parent.dragData;
    var canDrop = false;
    $a3d9eadd9d99207c$export$8db89c6e3bd21eb5(parent, args.target);
    $a3d9eadd9d99207c$export$e1dbe7adbd52a3f1(parent);
    if (parent.treeExpandTimer != null) {
        window.clearTimeout(parent.treeExpandTimer);
        parent.treeExpandTimer = null;
    }
    $a3d9eadd9d99207c$export$f9525c32dad03cf2(parent, "hover");
    var node = null;
    var scrollParent;
    if (parent.targetModule === "navigationpane") {
        node = (0, $4ZDHT.closest)(args.target, "li");
        node.classList.add($15a2a1ec4804cfd7$export$9d358706ccac3727, $15a2a1ec4804cfd7$export$4109cb617b030b1e);
        canDrop = true;
        /* istanbul ignore next */ parent.treeExpandTimer = window.setTimeout(function() {
            parent.notify($f592513f3f17ead8$export$8e6c816465ea7419, args);
        }, 800);
        scrollParent = parent.navigationpaneModule.treeObj.element.parentElement;
        $a3d9eadd9d99207c$export$f43482f3c394e174(scrollParent, parent, "e-level-2", args.event.y);
    } else if (parent.targetModule === "detailsview") {
        node = (0, $4ZDHT.closest)(args.target, "tr");
        if (node && node.querySelector("." + $15a2a1ec4804cfd7$export$d31d8fac97169a4b) && !node.classList.contains($15a2a1ec4804cfd7$export$565566e3df4dad53)) node.classList.add($15a2a1ec4804cfd7$export$4109cb617b030b1e);
        else if (node && !node.querySelector("." + $15a2a1ec4804cfd7$export$d31d8fac97169a4b) && !node.classList.contains($15a2a1ec4804cfd7$export$565566e3df4dad53)) node.classList.add($15a2a1ec4804cfd7$export$9fd81f8aee7214cc);
        canDrop = true;
        scrollParent = parent.detailsviewModule.gridObj.element.querySelector(".e-content");
        $a3d9eadd9d99207c$export$f43482f3c394e174(scrollParent, parent, "e-row", args.event.y);
    } else if (parent.targetModule === "largeiconsview") {
        node = (0, $4ZDHT.closest)(args.target, "li");
        if (node && node.querySelector("." + $15a2a1ec4804cfd7$export$d31d8fac97169a4b) && !node.classList.contains($15a2a1ec4804cfd7$export$565566e3df4dad53)) node.classList.add($15a2a1ec4804cfd7$export$9d358706ccac3727, $15a2a1ec4804cfd7$export$4109cb617b030b1e);
        canDrop = true;
        scrollParent = parent.largeiconsviewModule.element.firstElementChild;
        $a3d9eadd9d99207c$export$f43482f3c394e174(scrollParent, parent, "e-large-icon", args.event.y);
    /* istanbul ignore next */ } else if (parent.targetModule === "breadcrumbbar") canDrop = true;
    parent.element.classList.remove("e-fe-drop", "e-no-drop");
    parent.element.classList.add(canDrop ? "e-fe-drop" : "e-no-drop");
    parent.dragCount = parent.dragCount + 1;
    parent.trigger("fileDragging", dragArgs);
}
function $a3d9eadd9d99207c$export$830c053460e5ddf6(data) {
    var str = "";
    var keys = Object.keys(data);
    for(var i = 0; i < keys.length; i++)if (keys[i] !== "message") str += (i === 0 ? "" : ", ") + keys[i] + ": " + (0, $3EnZW.getValue)(keys[i], data);
    return str;
}
function $a3d9eadd9d99207c$export$31330438f6059b08(parent, data) {
    if (parent.hasId) return (0, $3EnZW.getValue)("id", data);
    return $a3d9eadd9d99207c$export$7d9f7e9c1c02b41e(parent, data);
}
function $a3d9eadd9d99207c$export$f3fb02da958b835d(parent, data) {
    parent.itemData = [
        data
    ];
    parent.currentItemText = (0, $3EnZW.getValue)("name", data);
    parent.isFile = (0, $3EnZW.getValue)("isFile", data);
    parent.filterPath = (0, $3EnZW.getValue)("filterPath", data);
}
function $a3d9eadd9d99207c$export$d52c45268ea880af(parent) {
    if (!$a3d9eadd9d99207c$export$35caa3cd1e53fb8d(parent.itemData[0])) $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, parent.itemData[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
    else (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Rename");
}
function $a3d9eadd9d99207c$export$c986efa34c53294(parent) {
    var items = parent.itemData;
    for(var i = 0; i < items.length; i++)if (!$a3d9eadd9d99207c$export$afe83600fb70ac59(items[i])) {
        $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, items[i], $f592513f3f17ead8$export$1812abec3897779e);
        return;
    }
    if (parent.selectedItems.length > 0) (0, $5703c0df24e3a120$export$a7aaed3e118dd255)(parent, parent.path, parent.selectedItems);
}
function $a3d9eadd9d99207c$export$c0b03dfe5656b20c(parent, data, newIds) {
    for(var i = 0; i < data.length; i++)if (!$a3d9eadd9d99207c$export$35caa3cd1e53fb8d(data[i])) {
        $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, data[i], $f592513f3f17ead8$export$95ed0b4b15a415e8);
        return;
    }
    parent.itemData = data;
    (0, $5703c0df24e3a120$export$bfadae053a633538)(parent, newIds, parent.path, "delete");
}
function $a3d9eadd9d99207c$export$5ff022e5f248fa5e(parent, data, newIds) {
    for(var i = 0; i < data.length; i++)if (!$a3d9eadd9d99207c$export$afe83600fb70ac59(data[i])) {
        $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, data[i], $f592513f3f17ead8$export$1812abec3897779e);
        return;
    }
    parent.itemData = data;
    if (newIds.length > 0) (0, $5703c0df24e3a120$export$a7aaed3e118dd255)(parent, parent.path, newIds);
}
function $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, data, action) {
    var message = (0, $3EnZW.getValue)("message", (0, $3EnZW.getValue)("permission", data));
    if (message === "") message = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Access-Message").replace("{0}", (0, $3EnZW.getValue)("name", data)).replace("{1}", action);
    var response = {
        error: {
            code: "401",
            fileExists: null,
            message: message
        }
    };
    (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", response);
}
function $a3d9eadd9d99207c$export$e4c8c20b1ca0ec47(data) {
    return !$a3d9eadd9d99207c$export$7121632912d0e323(data) ? "e-fe-locked e-fe-hidden" : "e-fe-locked";
}
function $a3d9eadd9d99207c$export$7121632912d0e323(data) {
    var permission = (0, $3EnZW.getValue)("permission", data);
    return permission && !(0, $3EnZW.getValue)("read", permission) ? false : true;
}
function $a3d9eadd9d99207c$export$35caa3cd1e53fb8d(data) {
    var permission = (0, $3EnZW.getValue)("permission", data);
    return permission ? (0, $3EnZW.getValue)("read", permission) && (0, $3EnZW.getValue)("write", permission) : true;
}
function $a3d9eadd9d99207c$export$68aea2408366db21(data) {
    var permission = (0, $3EnZW.getValue)("permission", data);
    return permission ? (0, $3EnZW.getValue)("read", permission) && (0, $3EnZW.getValue)("writeContents", permission) : true;
}
function $a3d9eadd9d99207c$export$b8fc31a54b49d5cc(data) {
    var permission = (0, $3EnZW.getValue)("permission", data);
    return permission ? (0, $3EnZW.getValue)("read", permission) && (0, $3EnZW.getValue)("upload", permission) : true;
}
function $a3d9eadd9d99207c$export$afe83600fb70ac59(data) {
    var permission = (0, $3EnZW.getValue)("permission", data);
    return permission ? (0, $3EnZW.getValue)("read", permission) && (0, $3EnZW.getValue)("download", permission) : true;
}
function $a3d9eadd9d99207c$export$a7450cfe784d304d(parent) {
    var details = parent.itemData[0];
    if (!$a3d9eadd9d99207c$export$68aea2408366db21(details)) $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, details, $f592513f3f17ead8$export$7f45bb9cb17642db);
    else (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "NewFolder");
}
function $a3d9eadd9d99207c$export$e5277fc94f47f9c6(parent) {
    var details = parent.itemData[0];
    if (!$a3d9eadd9d99207c$export$b8fc31a54b49d5cc(details)) $a3d9eadd9d99207c$export$8f59902e1ae078e6(parent, details, $f592513f3f17ead8$export$8dc6cd422363cdbc);
    else {
        var eleId = "#" + parent.element.id + $15a2a1ec4804cfd7$export$c84f804ae34d414b;
        var uploadEle = document.querySelector(eleId);
        uploadEle.click();
    }
}
function $a3d9eadd9d99207c$export$e6889fb0929ccf91(parent) {
    if (!(0, $3EnZW.isNullOrUndefined)(parent.dialogObj)) parent.dialogObj.hide();
}
function $a3d9eadd9d99207c$export$112df09c74edf3c9(parent, itemData, action, isPathPermision) {
    var accessMessage = "";
    for(var i = 0; i < itemData.length; i++){
        var permission = (0, $3EnZW.getValue)("permission", itemData[i]);
        if (permission == null) permission = undefined;
        if (isPathPermision) {
            if (permission && (!(0, $3EnZW.getValue)("read", permission) || !(0, $3EnZW.getValue)("writeContents", permission))) {
                accessMessage = (0, $3EnZW.getValue)("message", (0, $3EnZW.getValue)("permission", itemData[i]));
                if (accessMessage === "") accessMessage = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Access-Message").replace("{0}", (0, $3EnZW.getValue)("name", itemData[i])).replace("{1}", "writeContents");
            }
        } else {
            var copyOrMovePermission = action === "copy" ? (0, $3EnZW.getValue)("copy", permission) : (0, $3EnZW.getValue)("write", permission);
            if (permission && (!(0, $3EnZW.getValue)("read", permission) || !copyOrMovePermission)) {
                accessMessage = (0, $3EnZW.getValue)("message", (0, $3EnZW.getValue)("permission", itemData[i]));
                if (accessMessage === "") accessMessage = $a3d9eadd9d99207c$export$6ed696cdb1a60da9(parent, "Access-Message").replace("{0}", (0, $3EnZW.getValue)("name", itemData[i])).replace("{1}", action);
            }
        }
        if (accessMessage !== "") {
            parent.responseData = {
                cwd: null,
                details: null,
                error: {
                    code: "401",
                    message: accessMessage,
                    fileExists: null
                },
                files: null
            };
            break;
        }
    }
    return accessMessage;
}




function $1ded0ca663b14865$export$3f449967ffb2f4b2(parent, text, e, details) {
    var options = $1ded0ca663b14865$var$getOptions(parent, text, e, details);
    if ((0, $3EnZW.isNullOrUndefined)(parent.dialogObj)) {
        parent.dialogObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            beforeOpen: $1ded0ca663b14865$var$keydownAction.bind(this, parent, options.dialogName),
            beforeClose: function(args) {
                $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, parent.dialogObj, args, options.dialogName);
            },
            header: options.header,
            content: options.content,
            buttons: options.buttons,
            animationSettings: {
                effect: "None"
            },
            showCloseIcon: true,
            closeOnEscape: true,
            visible: true,
            allowDragging: true,
            isModal: true,
            target: parent.popupTarget ? parent.popupTarget : "#" + parent.element.id,
            cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(parent, parent.isMobile ? $15a2a1ec4804cfd7$export$2f2a984ccbc6a639 : $15a2a1ec4804cfd7$export$ee3777be229b6eef),
            width: "350px",
            open: options.open,
            close: options.close,
            enableRtl: parent.enableRtl,
            enableHtmlSanitizer: parent.enableHtmlSanitizer,
            locale: parent.locale
        });
        parent.dialogObj.isStringTemplate = true;
        parent.dialogObj.appendTo("#" + parent.element.id + $15a2a1ec4804cfd7$export$59dec0612bc7a4af);
    } else $1ded0ca663b14865$var$changeOptions(parent, options);
}
function $1ded0ca663b14865$export$2d7e4f57882298f(parent, text, replaceItems, newPath) {
    var extOptions = $1ded0ca663b14865$var$getExtOptions(parent, text, replaceItems, newPath);
    parent.isApplySame = false;
    if ((0, $3EnZW.isNullOrUndefined)(parent.extDialogObj)) {
        parent.extDialogObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            beforeOpen: $1ded0ca663b14865$var$beforeExtOpen.bind(this, parent, extOptions.dialogName),
            beforeClose: function(args) {
                $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, parent.extDialogObj, args, extOptions.dialogName);
            },
            content: extOptions.content,
            header: extOptions.header,
            closeOnEscape: true,
            allowDragging: true,
            animationSettings: {
                effect: "None"
            },
            target: parent.popupTarget ? parent.popupTarget : "#" + parent.element.id,
            cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(parent, parent.isMobile ? $15a2a1ec4804cfd7$export$2f2a984ccbc6a639 : $15a2a1ec4804cfd7$export$ee3777be229b6eef),
            enableRtl: parent.enableRtl,
            showCloseIcon: true,
            isModal: true,
            width: 350,
            buttons: extOptions.buttons,
            open: extOptions.open,
            close: extOptions.close,
            enableHtmlSanitizer: parent.enableHtmlSanitizer,
            locale: parent.locale
        });
        parent.extDialogObj.isStringTemplate = true;
        parent.extDialogObj.appendTo("#" + parent.element.id + $15a2a1ec4804cfd7$export$5b7b4899d6625112);
    } else {
        parent.extDialogObj.header = extOptions.header;
        parent.extDialogObj.close = extOptions.close;
        parent.extDialogObj.open = extOptions.open;
        parent.extDialogObj.close = extOptions.close;
        parent.extDialogObj.content = extOptions.content;
        parent.extDialogObj.buttons = extOptions.buttons;
        parent.extDialogObj.enableRtl = parent.enableRtl;
        parent.extDialogObj.locale = parent.locale;
        parent.extDialogObj.beforeOpen = $1ded0ca663b14865$var$beforeExtOpen.bind(this, parent, extOptions.dialogName);
        parent.extDialogObj.beforeClose = function(args) {
            $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, parent.extDialogObj, args, extOptions.dialogName);
        };
        parent.extDialogObj.dataBind();
        parent.extDialogObj.show();
    }
}
/**
 *
 * @param {IFileManager} parent - Specifies the parent element.
 * @param {Dialog} dlgModule - Specifies the dialog module.
 * @param {BeforeOpenEventArgs} args - specifies the before open arguements.
 * @param {string} dialogName - specifies the dialog name.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$triggerPopupBeforeOpen(parent, dlgModule, args, dialogName) {
    var eventArgs = {
        cancel: args.cancel,
        popupName: dialogName,
        popupModule: dlgModule
    };
    parent.trigger("beforePopupOpen", eventArgs, function(eventargs) {
        args.cancel = eventargs.cancel;
    });
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Dialog} dlgModule - specifies the dialog module.
 * @param {BeforeCloseEventArgs} args - specifies the before close event arguements.
 * @param {string} dialogName - specifies the dialog name.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, dlgModule, args, dialogName) {
    var eventArgs = {
        cancel: args.cancel,
        popupModule: dlgModule,
        popupName: dialogName
    };
    parent.trigger("beforePopupClose", eventArgs, function(eventargs) {
        args.cancel = eventargs.cancel;
        if (!args.cancel && args.isInteracted && (dialogName === "Rename" || dialogName === "Create Folder")) parent.trigger($f592513f3f17ead8$export$6df5a05f342711e3, {});
    });
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Dialog} dlgModule - specifies the dialog module.
 * @param {string} dialogName - specifies the dialog name.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$triggerPopupOpen(parent, dlgModule, dialogName) {
    var args = {
        popupModule: dlgModule,
        element: dlgModule.element,
        popupName: dialogName
    };
    parent.trigger("popupOpen", args);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Dialog} dlgModule - specifies the dialog module.
 * @param {string} dialogName - specifies the dialog name.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$triggerPopupClose(parent, dlgModule, dialogName) {
    var args = {
        popupModule: dlgModule,
        element: dlgModule.element,
        popupName: dialogName
    };
    parent.trigger("popupClose", args);
}
/**
 *
 * @param {IFileManager} parent - Specifies the parent element.
 * @param {string} text - specifies the text string.
 * @param {string[]} replaceItems - specifies the replacement items.
 * @param {string} newPath - specifies the new path.
 * @returns {DialogOptions} - returns the dialog options.
 * @private
 */ function $1ded0ca663b14865$var$getExtOptions(parent, text, replaceItems, newPath) {
    var options = {
        header: "",
        content: "",
        buttons: [],
        dialogName: ""
    };
    var duplicateContent;
    var item;
    var index;
    options.open = function() {
        $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.extDialogObj, options.dialogName);
    };
    options.close = function() {
        $1ded0ca663b14865$var$triggerPopupClose(parent, parent.extDialogObj, options.dialogName);
    };
    switch(text){
        case "Extension":
            options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-Rename-Confirmation");
            options.content = "<div>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-Rename-Confirmation") + "</div>";
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Yes")
                    },
                    click: function() {
                        parent.extDialogObj.hide();
                        (0, $5703c0df24e3a120$export$7ac989ec0c9c279)(parent, newPath, parent.renameText);
                    }
                },
                {
                    buttonModel: {
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-No")
                    },
                    click: function() {
                        parent.extDialogObj.hide();
                        parent.dialogObj.hide();
                    }
                }
            ];
            options.dialogName = "Extension Change";
            break;
        case "DuplicateItems":
            options.dialogName = "Duplicate Items";
            parent.replaceItems = replaceItems;
            item = parent.replaceItems[parent.fileLength];
            index = item.lastIndexOf("/");
            item = index === -1 ? item : item.substring(index);
            options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-Duplicate");
            duplicateContent = "<div>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-Duplicate") + "</div>";
            options.content = duplicateContent.replace("{0}", item);
            options.close = function() {
                if (!parent.isDropEnd && parent.duplicateItems.length === 0) {
                    var args = {
                        fileDetails: parent.droppedObjects
                    };
                    parent.trigger("fileDropped", args);
                    parent.isDropEnd = parent.isDragDrop = false;
                }
                $1ded0ca663b14865$var$triggerPopupClose(parent, parent.extDialogObj, options.dialogName);
            };
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Yes")
                    },
                    click: function() {
                        parent.duplicateItems.push(parent.replaceItems[parent.fileLength]);
                        parent.duplicateRecords.push((0, $a3d9eadd9d99207c$export$c7dce5a08d23ecd)(parent, parent.replaceItems[parent.fileLength]));
                        parent.fileLength++;
                        if (replaceItems[parent.fileLength]) {
                            var item_1 = parent.replaceItems[parent.fileLength];
                            var indexval = item_1.lastIndexOf("/");
                            item_1 = indexval === -1 ? item_1 : item_1.substring(indexval);
                            parent.extDialogObj.content = duplicateContent.replace("{0}", item_1);
                            parent.extDialogObj.show();
                        } else {
                            parent.extDialogObj.hide();
                            var targetPath = parent.isDragDrop ? parent.dragPath : parent.targetPath;
                            var path = parent.isDragDrop ? parent.dropPath : parent.folderPath === "" ? parent.path : parent.folderPath;
                            var action = parent.isDragDrop ? "move" : parent.fileAction;
                            (0, $5703c0df24e3a120$export$9b6706c8686cfc8e)(parent, targetPath, parent.duplicateItems, path, action, parent.duplicateItems, parent.duplicateRecords);
                        }
                    }
                },
                {
                    buttonModel: {
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-No")
                    },
                    click: function() {
                        parent.fileLength++;
                        if (replaceItems[parent.fileLength]) {
                            var item_2 = parent.replaceItems[parent.fileLength];
                            var ind = item_2.lastIndexOf("/");
                            item_2 = ind === -1 ? item_2 : item_2.substring(ind);
                            parent.extDialogObj.content = duplicateContent.replace("{0}", item_2);
                            parent.extDialogObj.show();
                        } else {
                            parent.extDialogObj.hide();
                            if (parent.duplicateItems.length !== 0) {
                                var action = parent.isDragDrop ? "move" : parent.fileAction;
                                var targetPath = parent.isDragDrop ? parent.dragPath : parent.targetPath;
                                var path = parent.isDragDrop ? parent.dropPath : parent.folderPath === "" ? parent.path : parent.folderPath;
                                (0, $5703c0df24e3a120$export$9b6706c8686cfc8e)(parent, targetPath, parent.duplicateItems, path, action, parent.duplicateItems, parent.duplicateRecords);
                            }
                        }
                    }
                }
            ];
            break;
        case "UploadRetry":
            options.dialogName = "Retry Upload";
            options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-Retry");
            options.content = parent.retryFiles[0].name + '<div class="e-fe-retrycontent">' + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-Retry") + "</div>";
            options.open = $1ded0ca663b14865$var$onRetryOpen.bind(this, parent);
            options.close = function() {
                parent.isRetryOpened = false;
                $1ded0ca663b14865$var$retryDlgClose(parent);
                $1ded0ca663b14865$var$triggerPopupClose(parent, parent.extDialogObj, options.dialogName);
            };
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Keep-Both")
                    },
                    click: function() {
                        $1ded0ca663b14865$var$retryDlgUpdate(parent, true);
                    }
                },
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Replace")
                    },
                    click: function() {
                        $1ded0ca663b14865$var$retryDlgUpdate(parent, false);
                    }
                },
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Skip")
                    },
                    click: function() {
                        var count = 0;
                        if (parent.isApplySame) {
                            count = parent.retryFiles.length;
                            parent.retryFiles = [];
                            $1ded0ca663b14865$var$retryDlgClose(parent);
                        } else {
                            count = 1;
                            parent.retryFiles.splice(0, 1);
                            if (parent.retryFiles.length !== 0) $1ded0ca663b14865$export$2d7e4f57882298f(parent, "UploadRetry");
                            else $1ded0ca663b14865$var$retryDlgClose(parent);
                        }
                        parent.notify($f592513f3f17ead8$export$4ba81805392dbd9, {
                            count: count
                        });
                    }
                }
            ];
            break;
    }
    return options;
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {boolean} isKeepBoth - checks the arguement to keep both.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$retryDlgUpdate(parent, isKeepBoth) {
    if (parent.isApplySame) {
        if (isKeepBoth) $1ded0ca663b14865$var$onKeepBothAll(parent);
        else $1ded0ca663b14865$var$onReplaceAll(parent);
        $1ded0ca663b14865$var$retryDlgClose(parent);
    } else {
        parent.retryArgs.push({
            action: isKeepBoth ? "keepboth" : "replace",
            file: parent.retryFiles[0]
        });
        parent.uploadObj.retry(parent.retryFiles[0]);
        parent.retryFiles.splice(0, 1);
        if (parent.retryFiles.length !== 0) $1ded0ca663b14865$export$2d7e4f57882298f(parent, "UploadRetry");
        else $1ded0ca663b14865$var$retryDlgClose(parent);
    }
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$retryDlgClose(parent) {
    var flag = true;
    if (parent.isRetryOpened) parent.isRetryOpened = false;
    else flag = false;
    var ele = (0, $4ZDHT.select)(".e-dlg-checkbox", parent.extDialogObj.element);
    if (ele) (0, $4ZDHT.remove)(ele);
    if (flag) parent.extDialogObj.hide();
    else parent.retryFiles = [];
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {object} args - specifies the arguements.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onRetryOpen(parent, args) {
    parent.isRetryOpened = true;
    var dialogEle = (0, $3EnZW.getValue)("element", args);
    var container = (0, $4ZDHT.select)(".e-dlg-content", dialogEle);
    var checkContainer = parent.createElement("div", {
        className: "e-dlg-checkbox"
    });
    var checkbox = parent.createElement("input", {
        id: parent.element.id + "_applyall"
    });
    checkContainer.appendChild(checkbox);
    container.appendChild(checkContainer);
    var checkBoxObj = new (0, $1c7c93589ae50f14$export$ea5f704b89d806f6)({
        label: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "ApplyAll-Label"),
        change: function(args) {
            parent.isApplySame = args.checked;
        }
    });
    checkBoxObj.appendTo("#" + parent.element.id + "_applyall");
    $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.extDialogObj, "Retry Upload");
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onKeepBothAll(parent) {
    while(parent.retryFiles.length !== 0){
        parent.retryArgs.push({
            action: "keepboth",
            file: parent.retryFiles[0]
        });
        parent.uploadObj.retry(parent.retryFiles[0]);
        parent.retryFiles.splice(0, 1);
    }
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onReplaceAll(parent) {
    while(parent.retryFiles.length !== 0){
        parent.retryArgs.push({
            action: "replace",
            file: parent.retryFiles[0]
        });
        parent.uploadObj.retry(parent.retryFiles[0]);
        parent.retryFiles.splice(0, 1);
    }
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$focusInput(parent) {
    var ele = (0, $4ZDHT.select)("#newname", parent.dialogObj.element);
    ele.focus();
    ele.value = "";
    var len = ele.value.length;
    ele.setSelectionRange(0, len);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onFolderDialogOpen(parent) {
    var ele = (0, $4ZDHT.select)("#newname", parent.dialogObj.element);
    if (!ele.parentElement.classList.contains("e-control-wrapper")) $1ded0ca663b14865$var$createInput(ele, (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-NewFolder"));
    ele.parentElement.nextElementSibling.innerHTML = "";
    ele.oninput = function() {
        $1ded0ca663b14865$var$onValidate(parent, ele);
    };
    ele.onkeyup = function(e) {
        var code = $1ded0ca663b14865$var$getKeyCode(e);
        if (code === 13) $1ded0ca663b14865$var$onSubmit(parent);
    };
    $1ded0ca663b14865$var$focusInput(parent);
    $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.dialogObj, "Create Folder");
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onRenameDialogOpen(parent) {
    var inputEle = (0, $4ZDHT.select)("#rename", parent.dialogObj.element);
    if (!inputEle.parentElement.classList.contains("e-control-wrapper")) $1ded0ca663b14865$var$createInput(inputEle, (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-Rename"));
    inputEle.parentElement.nextElementSibling.innerHTML = "";
    inputEle.oninput = function() {
        $1ded0ca663b14865$var$onValidate(parent, inputEle);
    };
    inputEle.onkeyup = function(e) {
        var code = $1ded0ca663b14865$var$getKeyCode(e);
        if (code === 13) $1ded0ca663b14865$var$onReSubmit(parent);
    };
    $1ded0ca663b14865$var$onFocusRenameInput(parent, inputEle);
    $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.dialogObj, "Rename");
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {HTMLInputElement} inputEle - specifies the input element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onFocusRenameInput(parent, inputEle) {
    inputEle.focus();
    var txt = "";
    if (parent.isFile && !parent.showFileExtension) {
        var index = parent.currentItemText.lastIndexOf(".");
        txt = index === -1 ? parent.currentItemText : parent.currentItemText.substring(0, index);
    } else txt = parent.currentItemText;
    inputEle.value = txt;
    if (parent.isFile && parent.showFileExtension && inputEle.value.indexOf(".") !== -1) inputEle.setSelectionRange(0, inputEle.value.lastIndexOf("."));
    else inputEle.setSelectionRange(0, inputEle.value.length);
}
/**
 *
 * @param {HTMLInputElement} ele - specifies the element.
 * @param {string} placeholder - specifies the place holder.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$createInput(ele, placeholder) {
    (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
        element: ele,
        properties: {
            placeholder: placeholder
        }
    });
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {string} text - specifies the text string.
 * @param {ReadArgs | SelectedEventArgs} e - specifies the event arguements.
 * @param {FileDetails} details - specifies the file details.
 * @returns {DialogOptions} - specifies the dialog options.
 * @private
 */ function $1ded0ca663b14865$var$getOptions(parent, text, e, details) {
    var options = {
        header: "",
        content: "",
        buttons: [],
        dialogName: ""
    };
    var permission;
    var formattedString;
    var intl;
    var strArr;
    var fileType;
    var location;
    options.open = function() {
        $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.dialogObj, options.dialogName);
    };
    options.close = function() {
        $1ded0ca663b14865$var$triggerPopupClose(parent, parent.dialogObj, options.dialogName);
    };
    text = details && details.multipleFiles === true ? "MultipleFileDetails" : text;
    var index;
    switch(text){
        case "NewFolder":
            options.dialogName = "Create Folder";
            options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-NewFolder");
            options.content = '<input type="text" value="New folder" id="newname"><div class="e-fe-error"></div>';
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Create")
                    },
                    click: function(e) {
                        if (e.type === "keydown") return;
                        $1ded0ca663b14865$var$onSubmit(parent);
                    }
                }
            ];
            options.open = $1ded0ca663b14865$var$onFolderDialogOpen.bind(this, parent);
            break;
        case "Delete":
            options.dialogName = "Delete";
            if (parent.selectedItems.length > 1) {
                options.content = ("<div>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Content-Multiple-Delete") + "</div>").replace("{0}", parent.selectedItems.length.toString());
                options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-Multiple-Delete");
            } else {
                options.content = "<div>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, parent.isFile ? "Content-Delete" : "Content-Folder-Delete") + "</div>";
                options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, parent.isFile ? "Header-Delete" : "Header-Folder-Delete");
            }
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Yes")
                    },
                    click: function() {
                        $1ded0ca663b14865$var$onDeleteSubmit(parent);
                    }
                },
                {
                    buttonModel: {
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-No")
                    },
                    click: function() {
                        parent.dialogObj.hide();
                    }
                }
            ];
            break;
        case "Rename":
            options.dialogName = "Rename";
            options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Header-Rename");
            options.content = '<input type="text" class="e-input" id="rename"><div class="e-fe-error"></div>';
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Save")
                    },
                    click: function(e) {
                        if (e.type === "keydown") return;
                        $1ded0ca663b14865$var$onReSubmit(parent);
                    }
                }
            ];
            options.open = $1ded0ca663b14865$var$onRenameDialogOpen.bind(this, parent);
            break;
        case "details":
            options.dialogName = "File Details";
            intl = new (0, $bWDaN.Internationalization)(parent.locale);
            formattedString = intl.formatDate(new Date(details.modified), {
                format: "MMMM dd, yyyy HH:mm:ss"
            });
            permission = "";
            if (!(0, $3EnZW.isNullOrUndefined)(details.permission)) permission = "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Permission") + '</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" >' + (0, $a3d9eadd9d99207c$export$830c053460e5ddf6)(details.permission) + "</td></tr>";
            options.header = details.name;
            options.content = "<table><tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Type") + '</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" title="' + (details.isFile ? "File" : "Folder") + '">' + (details.isFile ? "File" : "Folder") + "</td></tr>" + "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Size") + '</td><td><span class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" title ="' + details.size + '">' + details.size + "</span></td></tr>" + "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Location") + '</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" title="' + details.location + '">' + details.location + "</td></tr>" + "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Modified") + '</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" >' + formattedString + "</td></tr>" + permission + "</table>";
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Ok")
                    },
                    click: function() {
                        parent.dialogObj.hide();
                    }
                }
            ];
            break;
        case "MultipleFileDetails":
            options.dialogName = "File Details";
            strArr = parent.itemData.map(function(val) {
                index = val.name.indexOf(".") + 1;
                return index === 0 && !val.isFile ? "Folder" : index !== 0 ? val.name.substr(index).replace(" ", "") : "undetermined";
            });
            if (strArr[0] === undefined) strArr = details.name.split(",").map(function(val) {
                index = val.indexOf(".") + 1;
                return index === 0 ? "Folder" : val.substr(index).replace(" ", "");
            });
            fileType = strArr.every(function(val, i, arr) {
                return val === arr[0];
            }) ? strArr[0] === "Folder" ? "Folder" : strArr[0].toLocaleUpperCase() + " Type" : "Multiple Types";
            location = details.location;
            options.header = details.name;
            options.content = "<table><tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Type") + ':</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '">' + fileType + "</td></tr>" + "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Size") + ":</td><td>" + details.size + '<span class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" title ="' + details.size + '"></span></td></tr>' + "<tr><td>" + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Location") + ':</td><td class="' + $15a2a1ec4804cfd7$export$764bd63f4c2043a2 + '" title="' + location + '">' + location + "</td></tr>" + "</table>";
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Ok")
                    },
                    click: function(e) {
                        if (e.type === "keydown") return;
                        parent.dialogObj.hide();
                    }
                }
            ];
            break;
        case "Error":
            parent.notify($f592513f3f17ead8$export$6df5a05f342711e3, {});
            options.dialogName = "Error";
            if (e.error.code === "401") options.header = '<span class="e-fe-icon e-fe-access-error"></span><div class="e-fe-access-header">' + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Access-Denied") + "</div>";
            else options.header = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Error");
            options.content = '<div class="' + $15a2a1ec4804cfd7$export$36d139578736755 + '">' + e.error.message + "</div>";
            options.buttons = [
                {
                    buttonModel: {
                        isPrimary: true,
                        content: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Button-Ok")
                    },
                    click: function() {
                        parent.dialogObj.hide();
                    }
                }
            ];
            break;
    }
    return options;
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {string} dialogName - specifies the dialog name.
 * @param {BeforeOpenEventArgs} args - specifies the before open event arguements.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$keydownAction(parent, dialogName, args) {
    var btnElement = (0, $4ZDHT.selectAll)(".e-btn", parent.dialogObj.element);
    $1ded0ca663b14865$var$preventKeydown(btnElement);
    $1ded0ca663b14865$var$triggerPopupBeforeOpen(parent, parent.dialogObj, args, dialogName);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {string} dlgName - specifies the dialog name.
 * @param {BeforeOpenEventArgs} args - specifies the before open event arguements.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$beforeExtOpen(parent, dlgName, args) {
    var btnElement = (0, $4ZDHT.selectAll)(".e-btn", parent.extDialogObj.element);
    $1ded0ca663b14865$var$preventKeydown(btnElement);
    $1ded0ca663b14865$var$triggerPopupBeforeOpen(parent, parent.extDialogObj, args, dlgName);
}
/**
 *
 * @param {HTMLInputElement[]} btnElement - specifies the button element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$preventKeydown(btnElement) {
    var _loop_1 = function(btnCount) {
        btnElement[btnCount].onkeydown = function(e) {
            if (e.keyCode === 13) e.preventDefault();
        };
        btnElement[btnCount].onkeyup = function(e) {
            if (e.keyCode === 13) btnElement[btnCount].click();
        };
    };
    for(var btnCount = 0; btnCount < btnElement.length; btnCount++)_loop_1(btnCount);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {DialogOptions} options - specifies the dialog options.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$changeOptions(parent, options) {
    parent.dialogObj.header = options.header;
    parent.dialogObj.content = options.content;
    parent.dialogObj.buttons = options.buttons;
    parent.dialogObj.enableRtl = parent.enableRtl;
    parent.dialogObj.open = options.open;
    parent.dialogObj.close = options.close;
    parent.dialogObj.beforeOpen = $1ded0ca663b14865$var$keydownAction.bind(this, parent, options.dialogName);
    parent.dialogObj.beforeClose = function(args) {
        $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, parent.dialogObj, args, options.dialogName);
    };
    parent.dialogObj.dataBind();
    parent.dialogObj.show();
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onSubmit(parent) {
    var ele = (0, $4ZDHT.select)("#newname", parent.dialogObj.element);
    $1ded0ca663b14865$var$onSubmitValidate(parent, ele);
    if (ele.parentElement.nextElementSibling.innerHTML !== "") return;
    (0, $5703c0df24e3a120$export$b385cd416acc7fdd)(parent, ele.value);
}
/* istanbul ignore next */ /**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onReSubmit(parent) {
    var ele = (0, $4ZDHT.select)("#rename", parent.dialogObj.element);
    $1ded0ca663b14865$var$onSubmitValidate(parent, ele);
    if (ele.parentElement.nextElementSibling.innerHTML !== "") return;
    var text = ele.value;
    var oIndex = parent.currentItemText.lastIndexOf(".");
    if (parent.isFile && !parent.showFileExtension) {
        var extn = oIndex === -1 ? "" : parent.currentItemText.substr(oIndex);
        text += extn;
    }
    parent.renameText = text;
    if (parent.currentItemText === text) {
        parent.dialogObj.hide();
        return;
    }
    var newPath = parent.activeModule === "navigationpane" ? (0, $3EnZW.getValue)("filterPath", parent.itemData[0]).replace(/\\/g, "/") : parent.path;
    parent.renamedId = (0, $3EnZW.getValue)("id", parent.itemData[0]);
    if (parent.isFile) {
        var oldExtension = oIndex === -1 ? "" : parent.currentItemText.substr(oIndex);
        var nIndex = text.lastIndexOf(".");
        var newExtension = nIndex === -1 ? "" : text.substr(nIndex);
        if (parent.showFileExtension && oldExtension !== newExtension) $1ded0ca663b14865$export$2d7e4f57882298f(parent, "Extension", null, newPath);
        else (0, $5703c0df24e3a120$export$7ac989ec0c9c279)(parent, newPath, text);
    } else (0, $5703c0df24e3a120$export$7ac989ec0c9c279)(parent, newPath, text);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onDeleteSubmit(parent) {
    parent.dialogObj.hide();
    parent.notify($f592513f3f17ead8$export$6c22e1520513dd53, {});
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {HTMLInputElement} ele - specifies the input element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onValidate(parent, ele) {
    if (/[/\\|*?"<>:]/.test(ele.value)) $1ded0ca663b14865$var$addInvalid(parent, ele);
    else if (ele.value === "") ele.parentElement.nextElementSibling.innerHTML = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Validation-Empty");
    else ele.parentElement.nextElementSibling.innerHTML = "";
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {HTMLInputElement} ele - specifies the input element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$onSubmitValidate(parent, ele) {
    $1ded0ca663b14865$var$onValidate(parent, ele);
    var len = ele.value.length - 1;
    if (ele.value !== "" && (ele.value.lastIndexOf(".") === len || ele.value.lastIndexOf(" ") === len) && (parent.showFileExtension || ele.value.lastIndexOf(".") === -1 || ele.value.substring(ele.value.indexOf(".") + 1).length === 0)) $1ded0ca663b14865$var$addInvalid(parent, ele);
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {HTMLInputElement} ele - specifies the input element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$addInvalid(parent, ele) {
    var error = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Validation-Invalid").replace("{0}", '"' + ele.value + '"');
    if (parent.enableHtmlSanitizer) ele.parentElement.nextElementSibling.textContent = error;
    else ele.parentElement.nextElementSibling.innerHTML = error;
}
/**
 *
 * @param {KeyboardEvent} e - specifies the keyboard event.
 * @returns {number} - returns the key code.
 * @private
 */ function $1ded0ca663b14865$var$getKeyCode(e) {
    var code;
    if (e.keyCode) code = e.keyCode;
    else if (e.which) code = e.which;
    else code = e.charCode;
    return code;
}
function $1ded0ca663b14865$export$a5bbeff43904cfce(parent, header, imageUrl) {
    var content = (0, $4ZDHT.createElement)("div", {
        className: "e-image-wrap"
    });
    var image = (0, $4ZDHT.createElement)("img", {
        className: "e-image",
        attrs: {
            src: imageUrl,
            alt: header
        }
    });
    content.appendChild(image);
    if ((0, $3EnZW.isNullOrUndefined)(parent.viewerObj)) {
        parent.viewerObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            header: header,
            content: content,
            animationSettings: {
                effect: "None"
            },
            showCloseIcon: true,
            closeOnEscape: true,
            visible: true,
            isModal: true,
            width: "350px",
            height: "350px",
            target: parent.popupTarget ? parent.popupTarget : "#" + parent.element.id,
            cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(parent, parent.isMobile ? $15a2a1ec4804cfd7$export$2f2a984ccbc6a639 : $15a2a1ec4804cfd7$export$ee3777be229b6eef),
            locale: parent.locale,
            enableResize: true,
            allowDragging: true,
            enableHtmlSanitizer: parent.enableHtmlSanitizer,
            position: {
                X: "center",
                Y: "center"
            },
            enableRtl: parent.enableRtl,
            open: $1ded0ca663b14865$var$openImage.bind(this, parent),
            close: function() {
                $1ded0ca663b14865$var$triggerPopupClose(parent, parent.viewerObj, "Image Preview");
            },
            beforeOpen: function(args) {
                $1ded0ca663b14865$var$triggerPopupBeforeOpen(parent, parent.viewerObj, args, "Image Preview");
            },
            beforeClose: function(args) {
                $1ded0ca663b14865$var$triggerPopupBeforeClose(parent, parent.viewerObj, args, "Image Preview");
            },
            resizing: $1ded0ca663b14865$var$updateImage.bind(this, parent),
            resizeStop: $1ded0ca663b14865$var$updateImage.bind(this, parent)
        });
        parent.viewerObj.isStringTemplate = true;
        parent.viewerObj.appendTo("#" + parent.element.id + $15a2a1ec4804cfd7$export$e6b68dc330b66d31);
    } else {
        parent.viewerObj.refresh();
        parent.viewerObj.header = header;
        parent.viewerObj.content = content;
        parent.viewerObj.enableRtl = parent.enableRtl;
        parent.viewerObj.dataBind();
        parent.viewerObj.show();
    }
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$openImage(parent) {
    setTimeout(function() {
        if (parent.viewerObj) parent.viewerObj.element.focus();
    });
    $1ded0ca663b14865$var$updateImage(parent);
    $1ded0ca663b14865$var$triggerPopupOpen(parent, parent.viewerObj, "Image Preview");
}
/**
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $1ded0ca663b14865$var$updateImage(parent) {
    var content = (0, $4ZDHT.select)(".e-dlg-content", parent.viewerObj.element);
    var imgWrap = (0, $4ZDHT.select)(".e-image-wrap", parent.viewerObj.element);
    var cssObj = window.getComputedStyle(content, null);
    var paddingWidth = cssObj ? 2 * parseFloat(cssObj.paddingRight) : 36;
    var paddingHeight = cssObj ? 2 * parseFloat(cssObj.paddingBottom) : 20;
    imgWrap.style.width = content.offsetWidth - paddingWidth + "px";
    imgWrap.style.height = content.offsetHeight - paddingHeight + "px";
}




function $5703c0df24e3a120$export$aafa59e2e03f2942(parent, event, path) {
    var itemData = parent.itemData;
    for(var i = 0; i < itemData.length; i++)if ((0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("hasChild", itemData[i]))) (0, $3EnZW.setValue)("hasChild", false, itemData[i]);
    var data = {
        action: "read",
        path: path,
        showHiddenItems: parent.showHiddenItems,
        data: itemData
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$readSuccess, event);
}
function $5703c0df24e3a120$export$b385cd416acc7fdd(parent, itemName) {
    var data = {
        action: "create",
        path: parent.path,
        name: itemName,
        data: parent.itemData
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$createSuccess, itemName);
}
function $5703c0df24e3a120$export$3dea766d36a8935f(parent, event) {
    var data = {
        action: "filter",
        path: parent.path,
        showHiddenItems: parent.showHiddenItems,
        data: [
            (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(parent)
        ]
    };
    var filterData;
    var filterDataVal = parent.filterData ? (0, $3EnZW.extend)(filterData, data, parent.filterData) : data;
    $5703c0df24e3a120$var$createAjax(parent, filterDataVal, $5703c0df24e3a120$var$filterSuccess, event, (0, $3EnZW.getValue)("action", filterDataVal));
}
function $5703c0df24e3a120$export$7ac989ec0c9c279(parent, path, itemNewName) {
    var name;
    var newName;
    if (parent.breadcrumbbarModule.searchObj.element.value === "" && !parent.isFiltered) {
        name = parent.currentItemText;
        newName = itemNewName;
    } else {
        var fPath = parent.filterPath;
        if (parent.hasId) {
            name = parent.currentItemText;
            newName = itemNewName;
        } else {
            fPath = fPath.replace(/\\/g, "/");
            name = fPath.replace(path, "") + parent.currentItemText;
            newName = fPath.replace(path, "") + itemNewName;
        }
    }
    var data = {
        action: "rename",
        path: path,
        name: name,
        newName: newName,
        data: parent.itemData,
        showFileExtension: parent.showFileExtension
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$renameSuccess, path);
}
function $5703c0df24e3a120$export$9b6706c8686cfc8e(parent, path, names, targetPath, pasteOperation, renameItems, actionRecords) {
    var data = {
        action: pasteOperation,
        path: path,
        targetData: parent.itemData[0],
        targetPath: targetPath,
        names: names,
        renameFiles: renameItems,
        data: actionRecords
    };
    parent.destinationPath = targetPath;
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$pasteSuccess, path, pasteOperation, targetPath);
}
function $5703c0df24e3a120$export$bfadae053a633538(parent, items, path, operation) {
    var data = {
        action: operation,
        path: path,
        names: items,
        data: parent.itemData
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$deleteSuccess, path);
}
function $5703c0df24e3a120$export$1b969bdfbc184d40(parent, names, path, operation) {
    var data = {
        action: operation,
        path: path,
        names: names,
        data: parent.itemData
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$detailsSuccess, path, operation);
}
/**
 * Function for getDateFormat in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$getDateFormat(parent) {
    var columns = parent.detailsViewSettings.columns;
    var dateFormat;
    if (!columns) return null;
    for(var i = 0; i < columns.length; i++)if (columns[i].field === "_fm_modified") {
        if (!(0, $3EnZW.isNullOrUndefined)(columns[i].format)) dateFormat = columns[i].format.toString();
        break;
    }
    return dateFormat;
}
function $5703c0df24e3a120$export$ff708c1db2088d11(parent) {
    var isFileSystemData = parent.fileSystemData.length >= 0 && (0, $3EnZW.isNullOrUndefined)(parent.ajaxSettings.url);
    return isFileSystemData;
}
/**
 * Function to check whether file already exist or not.
 *
 * @param {Record<string, any>} fileSystemData - specifies the file data.
 * @param {string} name - specifies the name.
 * @returns {boolean} - returns the boolean value.
 * @private
 */ function $5703c0df24e3a120$var$isFileExists(fileSystemData, name) {
    var isExists = fileSystemData.some(function(item) {
        return item.name === name;
    });
    return isExists;
}
/**
 * Function to find the index value of a file or folder.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {number} id - specifies the id.
 * @returns {number} - returns the index value.
 * @private
 */ function $5703c0df24e3a120$var$findIndexById(parent, id) {
    var index = parent.fileSystemData.findIndex(function(item) {
        return String(item.id) === String(id);
    });
    return index;
}
/**
 * Function to get the entire data of a file or folder using id value.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {number | string} id - specifies the id.
 * @returns {Object} - returns the data.
 * @private
 */ function $5703c0df24e3a120$var$filterById(parent, id) {
    var data = parent.fileSystemData.filter(function(item) {
        return String(item.id) === String(id);
    })[0];
    return data;
}
/**
 * Function to get the entire data of a file or folder for a parent.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {number | string} parentId - specifies the parent id.
 * @returns {Object[]} - returns the data.
 * @private
 */ function $5703c0df24e3a120$var$filterByParent(parent, parentId) {
    var data = parent.fileSystemData.filter(function(item) {
        return String(item.parentId) === String(parentId);
    });
    return data;
}
/**
 * Function to create a new copied file or folder.
 *
 * @param {Record<string, any>} data - specifies the file or folder data.
 * @param {Record<string, any>} target - specifies the target data.
 * @param {string} itemName - specifies the item name.
 * @param {boolean} isCopy - specifies the copy operation.
 * @returns {Record<string, Object>} - returns the data.
 * @private
 */ function $5703c0df24e3a120$var$createNewItem(data, target, itemName, isCopy) {
    var newItem = {};
    //Construct the new folder details.
    for(var key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newItem[key] = null;
    var currentDate = new Date();
    var folderPath = target.id !== 0 ? target.filterPath + target.name : "\\";
    Object.assign(newItem, {
        dateCreated: currentDate,
        dateModified: currentDate,
        filterPath: folderPath,
        hasChild: isCopy ? data.hasChild : false,
        id: (0, $748c2240e597a9b7$export$5e82334337e0f204)(itemName === null ? data.name : itemName),
        isFile: isCopy ? data.isFile : false,
        name: itemName === null ? data.name : itemName,
        parentId: target.id,
        size: isCopy ? data.size : 0,
        type: isCopy ? data.type : ""
    });
    return newItem;
}
/**
 * Function to create an error response.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {string} message - specifies the error message.
 * @param {string} code - specifies the error code.
 * @param {Object[]} fileName - specifies the file name.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$createErrorObject(parent, message, code, fileName) {
    parent.responseData = {
        cwd: null,
        details: null,
        error: {
            code: code,
            message: message,
            fileExists: fileName != null ? fileName : null
        },
        files: null
    };
}
/**
 * Function to trigger folder creation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerFolderCreation(parent, data, eventArgs) {
    var createEventArgs = {
        folderName: (0, $3EnZW.getValue)("name", data),
        cancel: false,
        path: (0, $3EnZW.getValue)("path", data),
        parentFolder: (0, $3EnZW.getValue)("data", data)
    };
    parent.trigger("beforeFolderCreate", createEventArgs, function(args) {
        if (args.cancel) {
            eventArgs.cancel = true;
            return;
        }
        if ($5703c0df24e3a120$export$ff708c1db2088d11(parent)) {
            if (!$5703c0df24e3a120$var$isFileExists(parent.fileSystemData, args.folderName)) {
                var data_1 = args.parentFolder[0];
                var newObject = $5703c0df24e3a120$var$createNewItem(data_1, data_1, args.folderName, false);
                parent.fileSystemData.push(newObject);
            } else {
                var message = "A file or folder with the name " + args.folderName + " already exists.";
                $5703c0df24e3a120$var$createErrorObject(parent, message, "400", null);
            }
        }
    });
}
/**
 * Function to trigger delete operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerDeleteOperation(parent, data, eventArgs) {
    var deleteEventArgs = {
        cancel: false,
        itemData: (0, $3EnZW.getValue)("data", data),
        path: (0, $3EnZW.getValue)("path", data)
    };
    parent.trigger("beforeDelete", deleteEventArgs, function(args) {
        if (args.cancel) {
            eventArgs.cancel = true;
            return;
        }
        if ($5703c0df24e3a120$export$ff708c1db2088d11(parent)) args.itemData.forEach(function(itemData) {
            var index = $5703c0df24e3a120$var$findIndexById(parent, itemData.id);
            if (index !== -1) parent.fileSystemData.splice(index, 1);
            if (!itemData.isFile) {
                var subItems = parent.fileSystemData.filter(function(obj) {
                    return obj.filterPath.includes(itemData.name);
                });
                subItems.forEach(function(subItem) {
                    var index = $5703c0df24e3a120$var$findIndexById(parent, subItem.id);
                    if (index !== -1) parent.fileSystemData.splice(index, 1);
                });
            }
        });
    });
}
/**
 * Function to trigger rename operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerRenameOperation(parent, data, eventArgs) {
    var renameEventArgs = {
        cancel: false,
        newName: (0, $3EnZW.getValue)("newName", data),
        itemData: (0, $3EnZW.getValue)("data", data),
        path: (0, $3EnZW.getValue)("path", data)
    };
    parent.trigger("beforeRename", renameEventArgs, function(args) {
        if (args.cancel) {
            eventArgs.cancel = true;
            return;
        }
        if ($5703c0df24e3a120$export$ff708c1db2088d11(parent)) {
            if (!$5703c0df24e3a120$var$isFileExists(parent.fileSystemData, args.newName)) {
                var fileData = $5703c0df24e3a120$var$filterById(parent, args.itemData[0].id);
                fileData.name = args.newName;
            } else {
                var message = "Cannot rename" + args.itemData[0].name + "to" + args.newName + ": destination already exists.";
                $5703c0df24e3a120$var$createErrorObject(parent, message, "400", null);
            }
        }
    });
}
/**
 * Function to trigger move or copy operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerMoveOrCopyOperation(parent, data, eventArgs) {
    var moveEventArgs = {
        cancel: false,
        itemData: (0, $3EnZW.getValue)("data", data),
        isCopy: (0, $3EnZW.getValue)("action", data) === "copy" ? true : false,
        path: (0, $3EnZW.getValue)("path", data),
        targetData: (0, $3EnZW.getValue)("targetData", data),
        targetPath: (0, $3EnZW.getValue)("targetPath", data)
    };
    parent.trigger("beforeMove", moveEventArgs, function(args) {
        if (args.cancel) {
            eventArgs.cancel = true;
            return;
        }
        if ($5703c0df24e3a120$export$ff708c1db2088d11(parent)) {
            var message = "File Already Exists";
            var action = (0, $3EnZW.getValue)("action", data);
            var itemPermission = (0, $a3d9eadd9d99207c$export$112df09c74edf3c9)(parent, args.itemData, action, false);
            var pathPermission = (0, $a3d9eadd9d99207c$export$112df09c74edf3c9)(parent, [
                args.targetData
            ], action, true);
            var file_1 = [];
            parent.pasteNodes = [];
            if (itemPermission === "" && pathPermission === "") {
                if (args.isCopy) {
                    var folderSubItems_1 = $5703c0df24e3a120$var$filterByParent(parent, args.targetData.id);
                    var copiedFolders = args.itemData;
                    copiedFolders.forEach(function(itemData) {
                        if (!$5703c0df24e3a120$var$isFileExists(folderSubItems_1, itemData.name) || (0, $3EnZW.getValue)("renameFiles", data).length > 0) {
                            if ((0, $3EnZW.getValue)("renameFiles", data).length > 0) {
                                var names = itemData.name.split(".");
                                var name_1 = itemData.name.includes(".") ? names[0] + "(" + parent.existingFileCount + ")." + names[1] : names[0] + "(" + parent.existingFileCount + ")";
                                $5703c0df24e3a120$var$copyFolderItems(parent, itemData, args.targetData, name_1);
                                parent.responseData.error = null;
                                parent.existingFileCount++;
                                return;
                            }
                            $5703c0df24e3a120$var$copyFolderItems(parent, itemData, args.targetData, null);
                        } else file_1.push(itemData.name);
                    });
                    if (file_1.length > 0) $5703c0df24e3a120$var$createErrorObject(parent, message, "400", file_1);
                    return;
                }
                var target = args.targetData;
                var getTargetFiles = $5703c0df24e3a120$var$filterByParent(parent, target.id);
                for(var i = 0; i < args.itemData.length; i++){
                    var currItem = args.itemData[i];
                    if (!$5703c0df24e3a120$var$isFileExists(getTargetFiles, currItem.name) || (0, $3EnZW.getValue)("renameFiles", data).length > 0) {
                        if (!target.hasChild) target.hasChild = !currItem.isFile;
                        if (!currItem.isFile) {
                            //Check whether the source folder include other sub folders or not.
                            var subItems = currItem.parentId !== 0 ? $5703c0df24e3a120$var$filterByParent(parent, currItem.parentID) : [];
                            var itemData = $5703c0df24e3a120$var$filterById(parent, currItem.parentId);
                            itemData.hasChild = subItems.length > 1 ? true : false;
                        }
                        var fileData = $5703c0df24e3a120$var$filterById(parent, currItem.id);
                        if ((0, $3EnZW.getValue)("renameFiles", data).length > 0) {
                            var names = currItem.name.split(".");
                            currItem.name = currItem.name.includes(".") ? names[0] + "(" + parent.existingFileCount + ")." + names[1] : names[0] + "(" + parent.existingFileCount + ")";
                            fileData.name = currItem.name;
                            parent.responseData.error = null;
                            parent.existingFileCount++;
                            parent.dropData = target;
                            parent.dropPath = args.path;
                            var pathArray = args.targetPath.replace(/^\/|\/$/g, "").split("/");
                            target = $5703c0df24e3a120$var$filterById(parent, pathArray[pathArray.length - 1]);
                        }
                        fileData.parentId = target.id;
                        fileData.filterPath = target.id === 0 ? "\\" : target.filterPath + target.name + "\\";
                    } else file_1.push(currItem.name);
                }
                if (file_1.length > 0) $5703c0df24e3a120$var$createErrorObject(parent, message, "400", file_1);
            }
        }
    });
}
/**
 * Function to trigger search operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerSearchOperation(parent, data, eventArgs) {
    var searchEventArgs = {
        searchResults: (0, $3EnZW.getValue)("data", data),
        cancel: false,
        path: (0, $3EnZW.getValue)("path", data),
        searchText: (0, $3EnZW.getValue)("searchString", data),
        caseSensitive: (0, $3EnZW.getValue)("caseSensitive", data),
        showHiddenItems: (0, $3EnZW.getValue)("showHiddenItems", data)
    };
    parent.trigger("search", searchEventArgs, function(args) {
        (0, $3EnZW.setValue)("data", args.searchResults, data);
        if (args.cancel) eventArgs.cancel = true;
    });
}
/**
 * Function to trigger client side events.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {BeforeSendEventArgs} eventArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerClientEvents(parent, data, eventArgs) {
    switch((0, $3EnZW.getValue)("action", data)){
        case "create":
            $5703c0df24e3a120$var$triggerFolderCreation(parent, data, eventArgs);
            break;
        case "delete":
            $5703c0df24e3a120$var$triggerDeleteOperation(parent, data, eventArgs);
            break;
        case "rename":
            $5703c0df24e3a120$var$triggerRenameOperation(parent, data, eventArgs);
            break;
        case "move":
        case "copy":
            $5703c0df24e3a120$var$triggerMoveOrCopyOperation(parent, data, eventArgs);
            break;
        case "search":
            $5703c0df24e3a120$var$triggerSearchOperation(parent, data, eventArgs);
            break;
    }
}
/**
 * Creates an AJAX request for the file manager.
 *
 * @param {IFileManager} parent - The parent file manager instance.
 * @param {Object} data - The data object for the AJAX request.
 * @param {Function} fn - The callback function to be executed after the AJAX request.
 * @param {string} [event] - The event type for the AJAX request.
 * @param {string} [operation] - The operation type for the AJAX request.
 * @param {string} [targetPath] - The target path for the AJAX request.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$createAjax(parent, data, fn, event, operation, targetPath) {
    var ajaxSettings = {
        url: parent.ajaxSettings.url,
        type: "POST",
        mode: true,
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
        onSuccess: null,
        onFailure: null,
        beforeSend: null
    };
    var eventArgs = {
        action: (0, $3EnZW.getValue)("action", data),
        ajaxSettings: ajaxSettings,
        cancel: false
    };
    $5703c0df24e3a120$var$triggerClientEvents(parent, data, eventArgs);
    parent.trigger("beforeSend", eventArgs, function(beforeSendArgs) {
        if (!beforeSendArgs.cancel) {
            parent.notify($f592513f3f17ead8$export$efdf6d98d39d3b1a, {});
            if ($5703c0df24e3a120$export$ff708c1db2088d11(parent)) {
                var filePath = event === "node-expand" || event === "finalize-end" ? (0, $3EnZW.getValue)("path", data) : parent.path;
                var pathArray = filePath.replace(/^\/|\/$/g, "").split("/");
                var idValue = event === "rename-end-parent" || event === "path-changed" && (0, $3EnZW.getValue)("data", data).length !== 0 || event === "paste-end" && (parent.targetModule === "largeiconsview" || parent.targetModule === "detailsview") ? (0, $3EnZW.getValue)("data", data)[0].id : pathArray[pathArray.length - 1];
                var action = (0, $3EnZW.getValue)("action", data);
                var isFileOperation = (action === "move" || action === "rename" || action === "copy" || action === "delete" || action === "search") && event !== "rename-end";
                if (action === "read" || action === "create" || event === "rename-end") {
                    var rootId = parent.fileSystemData.filter(function(item) {
                        return (0, $3EnZW.isNullOrUndefined)(item.parentId);
                    }).length > 0 ? parent.fileSystemData.filter(function(item) {
                        return (0, $3EnZW.isNullOrUndefined)(item.parentId);
                    })[0].id : 0;
                    parent.responseData = {
                        cwd: $5703c0df24e3a120$var$filterById(parent, parent.path === "/" && event !== "node-expand" && event !== "rename-end-parent" ? rootId : idValue),
                        details: null,
                        error: null,
                        files: $5703c0df24e3a120$var$filterByParent(parent, parent.path === "/" && event !== "node-expand" && event !== "rename-end-parent" ? rootId : idValue)
                    };
                    if ((0, $3EnZW.isNullOrUndefined)(parent.responseData.cwd)) {
                        var message = "Cannot load empty data within the File Manager.";
                        $5703c0df24e3a120$var$createErrorObject(parent, message, "400", null);
                    }
                } else if (isFileOperation && parent.responseData.error === null) {
                    var itemData = action === "search" || action === "delete" ? (0, $3EnZW.getValue)("data", data) : [];
                    if (itemData.length === 0) itemData = (0, $3EnZW.getValue)("data", data).map(function(item) {
                        return $5703c0df24e3a120$var$filterById(parent, item.id);
                    });
                    parent.responseData = {
                        cwd: null,
                        details: null,
                        error: null,
                        files: itemData
                    };
                } else if ((0, $3EnZW.getValue)("action", data) === "details") {
                    var itemData = (0, $3EnZW.getValue)("data", data);
                    var details = itemData[0];
                    var isMultipleFiles = itemData.length > 1;
                    var itemNames = itemData.map(function(item) {
                        return item.name;
                    });
                    var totalSize = isMultipleFiles ? $5703c0df24e3a120$var$getSize(itemData.reduce(function(accumulator, currentObject) {
                        return accumulator + (currentObject.size || 0);
                    }, 0)) : $5703c0df24e3a120$var$getSize(details.size);
                    var path = parent.pathNames.includes(details.name) ? parent.pathNames.join("/") : parent.pathNames.join("/") + "/" + details.name;
                    parent.responseData.details = Object.assign({
                        location: isMultipleFiles ? null : path,
                        multipleFiles: isMultipleFiles,
                        name: itemNames.join(", "),
                        size: totalSize
                    }, isMultipleFiles ? {} : {
                        created: details.dateCreated,
                        isFile: details.isFile,
                        modified: details.dateModified,
                        permission: details.permission
                    });
                }
                $5703c0df24e3a120$var$performReadOperation(parent, parent.responseData, fn, data, event, operation, targetPath, beforeSendArgs);
                return;
            }
            var ajax = new (0, $cfGuF.Ajax)({
                url: (0, $3EnZW.getValue)("url", beforeSendArgs.ajaxSettings),
                type: (0, $3EnZW.getValue)("type", beforeSendArgs.ajaxSettings),
                mode: (0, $3EnZW.getValue)("mode", beforeSendArgs.ajaxSettings),
                dataType: (0, $3EnZW.getValue)("dataType", beforeSendArgs.ajaxSettings),
                contentType: (0, $3EnZW.getValue)("contentType", beforeSendArgs.ajaxSettings),
                data: (0, $3EnZW.getValue)("data", beforeSendArgs.ajaxSettings),
                beforeSend: (0, $3EnZW.getValue)("beforeSend", beforeSendArgs.ajaxSettings),
                onSuccess: function(result) {
                    if ((0, $3EnZW.isNullOrUndefined)(result)) {
                        var result_1 = {
                            error: {
                                fileExists: null,
                                message: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Server-Error") + " " + parent.ajaxSettings.url,
                                code: "406"
                            },
                            files: null
                        };
                        $5703c0df24e3a120$var$triggerAjaxFailure(parent, beforeSendArgs, fn, result_1, event, operation, targetPath);
                        return;
                    }
                    if (typeof result === "string") result = JSON.parse(result);
                    $5703c0df24e3a120$var$performReadOperation(parent, result, fn, data, event, operation, targetPath, beforeSendArgs);
                },
                onFailure: function() {
                    var result = {
                        files: null,
                        error: {
                            code: "404",
                            message: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Network-Error") + " " + parent.ajaxSettings.url,
                            fileExists: null
                        }
                    };
                    $5703c0df24e3a120$var$triggerAjaxFailure(parent, beforeSendArgs, fn, result, event, operation, targetPath);
                }
            });
            ajax.send();
        }
    });
}
/**
 * Function to get file size.
 *
 * @param {number} size - specifies the size.
 * @returns {string} - returns the size.
 * @private
 */ function $5703c0df24e3a120$var$getSize(size) {
    var hz;
    if (size < 1024) hz = size + " B";
    else if (size < 1048576) hz = (size / 1024).toFixed(2) + " KB";
    else if (size < 1073741824) hz = (size / 1024 / 1024).toFixed(2) + " MB";
    else hz = (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
    return hz;
}
/**
 * Function to perform read operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {Function} fn - specifies the function.
 * @param {Object} data - specifies the data.
 * @param {string} event - specifies the event.
 * @param {string} operation - specifies the operation.
 * @param {string} targetPath - specifies the targetPath.
 * @param {BeforeSendEventArgs} beforeSendArgs - specifies the eventArgs.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$performReadOperation(parent, result, fn, data, event, operation, targetPath, beforeSendArgs) {
    parent.notify($f592513f3f17ead8$export$5af90369d26bf4d0, {
        action: "success"
    });
    var id = parent.expandedId ? parent.expandedId : parent.pathId[parent.pathId.length - 1];
    if (!(0, $3EnZW.isNullOrUndefined)(result.cwd) && (0, $3EnZW.getValue)("action", data) === "read") {
        result.cwd.name = parent.pathId.length === 1 ? parent.rootAliasName || result.cwd.name : result.cwd.name;
        (0, $3EnZW.setValue)("_fm_id", id, result.cwd);
        (0, $3EnZW.setValue)(id, result.cwd, parent.feParent);
        if (!(0, $3EnZW.isNullOrUndefined)(result.files) || result.error.code === "401") {
            if ((event === "finalize-end" || event === "initial-end") && parent.pathNames.length === 0) {
                var root = (0, $3EnZW.getValue)(parent.pathId[0], parent.feParent);
                parent.pathNames[0] = (0, $3EnZW.getValue)("name", root);
                parent.hasId = !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("id", root));
            }
            if (event === "finalize-end") (0, $a3d9eadd9d99207c$export$82476f982757e71e)(parent);
        }
    }
    var intl = new (0, $bWDaN.Internationalization)(parent.locale);
    if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
        (0, $a3d9eadd9d99207c$export$9e2d02f4778015c5)(result.files, intl, $5703c0df24e3a120$var$getDateFormat(parent));
        for(var i = 0, len = result.files.length; i < len; i++){
            var item = result.files[i];
            (0, $3EnZW.setValue)("_fm_iconClass", (0, $a3d9eadd9d99207c$export$e40fbc04d72f5340)(item), item);
        }
        if ((0, $3EnZW.getValue)("action", data) === "read" || $5703c0df24e3a120$export$ff708c1db2088d11(parent) && (0, $3EnZW.getValue)("action", data) === "search") {
            (0, $a3d9eadd9d99207c$export$2a9c1530768ed4e2)(result, id);
            (0, $3EnZW.setValue)(id, result.files, parent.feFiles);
        }
    }
    if (!(0, $3EnZW.isNullOrUndefined)(result.details) && !(0, $3EnZW.isNullOrUndefined)(parent.rootAliasName)) {
        var rootName = parent.rootAliasName || (0, $3EnZW.getValue)("name", result.details);
        var location_1 = (0, $3EnZW.getValue)("location", result.details).replace(new RegExp("/", "g"), "\\");
        if ((0, $3EnZW.getValue)("path", data) === "/" || parent.hasId && (0, $3EnZW.getValue)("path", data).match(/[/]/g).length === 1) {
            if ((0, $3EnZW.getValue)("names", data).length === 0) {
                (0, $3EnZW.setValue)("name", rootName, result.details);
                location_1 = rootName;
            } else location_1 = location_1.replace(location_1.substring(0, location_1.indexOf("\\")), rootName);
        } else location_1 = location_1.replace(location_1.substring(0, location_1.indexOf("\\")), rootName);
        (0, $3EnZW.setValue)("location", location_1, result.details);
    }
    fn(parent, result, event, operation, targetPath);
    if (!(0, $3EnZW.isNullOrUndefined)(result.files) && (event === "path-changed" || event === "finalize-end" || event === "open-end" || event === "drop-path")) parent.notify($f592513f3f17ead8$export$4faa0c3c173303f6, result);
    if (typeof (0, $3EnZW.getValue)("onSuccess", beforeSendArgs.ajaxSettings) === "function") (0, $3EnZW.getValue)("onSuccess", beforeSendArgs.ajaxSettings)();
}
/**
 * Function to copy operation.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {Object} data - specifies the data.
 * @param {string} target - specifies the target.
 * @param {string} itemName - specifies the item name.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$copyFolderItems(parent, data, target, itemName) {
    var newObject = $5703c0df24e3a120$var$createNewItem(data, target, itemName, true);
    parent.fileSystemData.push(newObject);
    parent.pasteNodes.push(newObject.id);
    var copiedItems = $5703c0df24e3a120$var$filterByParent(parent, data.id);
    for(var i = 0; i < copiedItems.length; i++)$5703c0df24e3a120$var$copyFolderItems(parent, copiedItems[i], newObject, null);
}
/**
 * Function for trigger Ajax failure in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {BeforeSendEventArgs} beforeSendArgs - specifies the beforeSendArgs.
 * @param {Function} fn - specifies the function.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} event - specifies the event.
 * @param {string} operation - specifies the operation.
 * @param {string} targetPath - specifies the targetPath.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$triggerAjaxFailure(parent, beforeSendArgs, fn, result, event, operation, targetPath) {
    parent.notify($f592513f3f17ead8$export$5af90369d26bf4d0, {
        action: "failure"
    });
    fn(parent, result, event, operation, targetPath);
    if (typeof (0, $3EnZW.getValue)("onFailure", beforeSendArgs.ajaxSettings) === "function") (0, $3EnZW.getValue)("onFailure", beforeSendArgs.ajaxSettings)();
}
/**
 * Function for read success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} event - specifies the event.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$readSuccess(parent, result, event) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.notify(event, result);
            parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
            var args = {
                action: "read",
                result: result
            };
            parent.trigger("success", args);
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(result.error) && result.error.code === "401") {
                result.files = [];
                parent.notify(event, result);
                parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
            }
            $5703c0df24e3a120$var$onFailure(parent, result, "read");
            parent.setProperties({
                path: parent.oldPath
            }, true);
            parent.pathNames.pop();
        }
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, "read");
        parent.setProperties({
            path: parent.oldPath
        }, true);
        parent.pathNames.pop();
    }
    if (parent.isDragDrop && parent.isDropEnd) {
        if (parent.droppedObjects.length !== 0) {
            var args = {
                fileDetails: parent.droppedObjects
            };
            parent.trigger("fileDropped", args);
        }
        parent.isDropEnd = parent.isDragDrop = false;
    }
}
/**
 * Function for filter success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} event - specifies the event.
 * @param {string} action - specifies the action.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$filterSuccess(parent, result, event, action) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.notify(event, result);
            var args = {
                action: action,
                result: result
            };
            parent.trigger("success", args);
        } else $5703c0df24e3a120$var$onFailure(parent, result, action);
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, action);
    }
}
/* istanbul ignore next */ /**
 * Function for create success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} itemName - specifies the item name.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$createSuccess(parent, result, itemName) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            if (parent.dialogObj && parent.dialogObj.visible) parent.dialogObj.hide();
            parent.createdItem = $5703c0df24e3a120$export$ff708c1db2088d11(parent) ? result.files[result.files.length - 1] : result.files[0];
            parent.breadcrumbbarModule.searchObj.value = "";
            var createEventArgs = {
                folderName: itemName,
                path: parent.path,
                parentFolder: parent.itemData
            };
            parent.trigger("folderCreate", createEventArgs);
            var args = {
                action: "create",
                result: result
            };
            parent.trigger("success", args);
            parent.itemData = [
                (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(parent)
            ];
            $5703c0df24e3a120$export$aafa59e2e03f2942(parent, $f592513f3f17ead8$export$870f71f756707ad0, parent.path);
        } else if (result.error.code === "400") {
            if (parent.dialogObj && parent.dialogObj.visible) {
                var ele = (0, $4ZDHT.select)("#newname", parent.dialogObj.element);
                var error = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Validation-NewFolder-Exists").replace("{0}", '"' + ele.value + '"');
                ele.parentElement.nextElementSibling.innerHTML = error;
            } else {
                var result_2 = {
                    files: null,
                    error: {
                        code: "400",
                        message: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Validation-NewFolder-Exists").replace("{0}", '"' + itemName + '"'),
                        fileExists: null
                    }
                };
                (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result_2);
            }
            var args = {
                action: "create",
                error: result.error
            };
            parent.trigger("failure", args);
        } else {
            if (parent.dialogObj && parent.dialogObj.visible) parent.dialogObj.hide();
            $5703c0df24e3a120$var$onFailure(parent, result, "create");
        }
    } catch (error) {
        if (parent.dialogObj && parent.dialogObj.visible) parent.dialogObj.hide();
        $5703c0df24e3a120$var$handleCatchError(parent, error, "create");
    }
}
/* istanbul ignore next */ /**
 * Function to rename the folder/file in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$renameSuccess(parent, result) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            if (!(0, $3EnZW.isNullOrUndefined)(parent.dialogObj)) parent.dialogObj.hide();
            var args = {
                action: "rename",
                result: result
            };
            parent.trigger("success", args);
            parent.renamedItem = Array.isArray(result.files) ? result.files[0] : result.files;
            var renameEventArgs = {
                newName: parent.renamedItem.name,
                itemData: parent.renamedItem,
                path: parent.path
            };
            parent.trigger("rename", renameEventArgs);
            if (parent.activeModule === "navigationpane") {
                parent.pathId.pop();
                parent.itemData = [
                    (0, $3EnZW.getValue)(parent.pathId[parent.pathId.length - 1], parent.feParent)
                ];
                $5703c0df24e3a120$export$aafa59e2e03f2942(parent, $f592513f3f17ead8$export$fdf3aa211c42164c, (0, $3EnZW.getValue)("filterPath", parent.renamedItem).replace(/\\/g, "/"));
                parent.itemData[0] = parent.renamedItem;
                if ((0, $3EnZW.getValue)("filterPath", parent.renamedItem) === (0, $3EnZW.getValue)("filterPath", parent.itemData[0]) && parent.pathNames.length > 1) parent.pathNames[parent.pathNames.length - 1] = parent.renameText;
                $5703c0df24e3a120$export$aafa59e2e03f2942(parent, $f592513f3f17ead8$export$f012f19194778278, parent.path === "/" ? parent.path : (0, $3EnZW.getValue)("filterPath", parent.renamedItem).replace(/\\/g, "/") + parent.renamedItem.name + "/");
                parent.renamedItem = null;
            } else {
                parent.itemData = [
                    (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(parent)
                ];
                if (parent.breadcrumbbarModule.searchObj.value !== "") $5703c0df24e3a120$export$4b85d3515bd863a5(parent, $f592513f3f17ead8$export$a6dd9c7789352fcb, parent.path, parent.searchWord, parent.showHiddenItems, !parent.searchSettings.ignoreCase);
                else if (parent.isFiltered) $5703c0df24e3a120$export$3dea766d36a8935f(parent, $f592513f3f17ead8$export$a6dd9c7789352fcb);
                else $5703c0df24e3a120$export$aafa59e2e03f2942(parent, $f592513f3f17ead8$export$a6dd9c7789352fcb, parent.path);
            }
        } else if (result.error.code === "400" && parent.dialogObj && parent.dialogObj.visible) {
            var ele = (0, $4ZDHT.select)("#rename", parent.dialogObj.element);
            var error = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Validation-Rename-Exists").replace("{0}", '"' + parent.currentItemText + '"');
            error = error.replace("{1}", '"' + ele.value + '"');
            ele.parentElement.nextElementSibling.innerHTML = error;
            var args = {
                action: "rename",
                error: result.error
            };
            parent.trigger("failure", args);
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(parent.dialogObj)) parent.dialogObj.hide();
            $5703c0df24e3a120$var$onFailure(parent, result, "rename");
        }
    } catch (error) {
        if (!(0, $3EnZW.isNullOrUndefined)(parent.dialogObj)) parent.dialogObj.hide();
        $5703c0df24e3a120$var$handleCatchError(parent, error, "rename");
    }
}
/* istanbul ignore next */ /**
 * Function to create new folder in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} path - specifies the path.
 * @param {string} operation - specifies the operation.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$pasteSuccess(parent, result, path, operation) {
    try {
        var moveorcopyEventArgs = {
            itemData: result.files,
            isCopy: operation === "copy" ? true : false,
            path: path,
            targetData: parent.itemData[0],
            targetPath: parent.path
        };
        parent.trigger("move", moveorcopyEventArgs);
        if (result.error && result.error.fileExists) {
            parent.fileLength = 0;
            if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
                parent.isPasteError = true;
                (0, $a3d9eadd9d99207c$export$bf862042e040347a)(parent, operation, result);
            }
            (0, $1ded0ca663b14865$export$2d7e4f57882298f)(parent, "DuplicateItems", result.error.fileExists);
            if (result.error.code === "404") (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
        } else if (!result.error && !(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.isPasteError = false;
            (0, $a3d9eadd9d99207c$export$bf862042e040347a)(parent, operation, result);
        } else if (result.error && !(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.isPasteError = true;
            (0, $a3d9eadd9d99207c$export$bf862042e040347a)(parent, operation, result);
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
        } else $5703c0df24e3a120$var$onFailure(parent, result, operation);
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, operation);
    }
}
/**
 * Function to delete success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} path - specifies the path.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$deleteSuccess(parent, result, path) {
    try {
        var deleteEventArgs = {
            itemData: result.files,
            path: path
        };
        parent.trigger("delete", deleteEventArgs);
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.setProperties({
                path: path
            }, true);
            parent.itemData = [
                (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(parent)
            ];
            $5703c0df24e3a120$export$aafa59e2e03f2942(parent, $f592513f3f17ead8$export$ce97bad2aef2d46a, parent.path);
            if (result.error) $5703c0df24e3a120$var$onFailure(parent, result, "delete");
            else {
                var args = {
                    action: "delete",
                    result: result
                };
                parent.trigger("success", args);
            }
        } else $5703c0df24e3a120$var$onFailure(parent, result, "delete");
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, "delete");
    }
}
/**
 * Function for details success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} path - specifies the path.
 * @param {string} operation - specifies the operation.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$detailsSuccess(// eslint:disable-next-line
parent, result, path, operation) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.details)) {
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, operation, null, result.details);
            var args = {
                action: "details",
                result: result
            };
            parent.trigger("success", args);
        } else $5703c0df24e3a120$var$onFailure(parent, result, "details");
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, "details");
    }
}
/**
 * Function for on failure event in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} action - specifies the action.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$onFailure(parent, result, action) {
    (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
    var args = {
        action: action,
        error: result.error
    };
    parent.trigger("failure", args);
}
function $5703c0df24e3a120$export$4b85d3515bd863a5(parent, event, path, searchString, showHiddenItems, caseSensitive) {
    var data = {
        action: "search",
        path: path,
        searchString: searchString,
        showHiddenItems: showHiddenItems,
        caseSensitive: caseSensitive,
        data: parent.itemData
    };
    $5703c0df24e3a120$var$createAjax(parent, data, $5703c0df24e3a120$var$searchSuccess, event);
}
/* istanbul ignore next */ /**
 * Function for search success in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {ReadArgs} result - specifies the result.
 * @param {string} event - specifies the event.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$searchSuccess(parent, result, event) {
    try {
        if (!(0, $3EnZW.isNullOrUndefined)(result.files)) {
            parent.notify(event, result);
            var args = {
                action: "search",
                result: result
            };
            parent.trigger("success", args);
        } else $5703c0df24e3a120$var$onFailure(parent, result, "search");
    } catch (error) {
        $5703c0df24e3a120$var$handleCatchError(parent, error, "search");
    }
}
function $5703c0df24e3a120$export$a7aaed3e118dd255(parent, path, items) {
    var downloadUrl = parent.ajaxSettings.downloadUrl ? parent.ajaxSettings.downloadUrl : parent.ajaxSettings.url;
    var data = {
        "action": "download",
        "path": path,
        "names": items,
        "data": parent.itemData
    };
    var ajaxSettings = {
        url: downloadUrl,
        type: "POST",
        contentType: "application/json",
        responseType: "blob",
        data: JSON.stringify(data),
        onSuccess: null,
        onFailure: null,
        beforeSend: null
    };
    var eventArgs = {
        data: data,
        cancel: false,
        useFormPost: true,
        ajaxSettings: ajaxSettings
    };
    parent.trigger("beforeDownload", eventArgs, function(downloadArgs) {
        if (!downloadArgs.cancel) {
            if (downloadArgs.useFormPost) {
                var form = (0, $4ZDHT.createElement)("form", {
                    id: parent.element.id + "_downloadForm",
                    attrs: {
                        action: downloadUrl,
                        method: "post",
                        name: "downloadForm",
                        "download": ""
                    }
                });
                var input = (0, $4ZDHT.createElement)("input", {
                    id: parent.element.id + "_hiddenForm",
                    attrs: {
                        name: "downloadInput",
                        value: JSON.stringify(downloadArgs.data),
                        type: "hidden"
                    }
                });
                form.appendChild(input);
                parent.element.appendChild(form);
                document.forms.namedItem("downloadForm").submit();
                parent.element.removeChild(form);
            } else try {
                var contentDisposition_1;
                var fileName_1;
                var fetch_1 = new (0, $1MTdI.Fetch)({
                    url: (0, $3EnZW.getValue)("url", downloadArgs.ajaxSettings),
                    type: (0, $3EnZW.getValue)("type", downloadArgs.ajaxSettings),
                    contentType: (0, $3EnZW.getValue)("contentType", downloadArgs.ajaxSettings),
                    responseType: (0, $3EnZW.getValue)("responseType", downloadArgs.ajaxSettings),
                    beforeSend: (0, $3EnZW.getValue)("beforeSend", downloadArgs.ajaxSettings),
                    onLoad: function(e) {
                        contentDisposition_1 = e.headers.get("Content-Disposition");
                        if (contentDisposition_1) {
                            var filenameMatch = contentDisposition_1.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                            var extractedFilename = filenameMatch && filenameMatch[1];
                            fileName_1 = extractedFilename ? extractedFilename.replace(/['"]/g, "") : fileName_1;
                        } else fileName_1 = parent.itemData.length > 1 ? "files.zip" : (0, $3EnZW.getValue)("isFile", parent.itemData[0]) ? (0, $3EnZW.getValue)("name", parent.itemData[0]) : (0, $3EnZW.getValue)("name", parent.itemData[0]) + ".zip";
                    },
                    onSuccess: function(e) {
                        parent.trigger("success", downloadArgs);
                        var blob = e;
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = fileName_1;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    },
                    onFailure: function(e) {
                        var result = {
                            error: {
                                code: e.status.toString(),
                                message: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(parent, "Network-Error") + " " + parent.ajaxSettings.downloadUrl
                            }
                        };
                        (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(parent, "Error", result);
                        parent.trigger("failure", downloadArgs);
                    }
                });
                fetch_1.send(JSON.stringify(downloadArgs.data));
            } catch (error) {
                $5703c0df24e3a120$var$handleCatchError(parent, error, "download");
            }
        }
    });
}
/**
 * Function for on catch handler in File Manager.
 *
 * @param {IFileManager} parent - specifies the parent element.
 * @param {any} error - specifies the catch error.
 * @param {string} action - specifies the action.
 * @returns {void}
 * @private
 */ function $5703c0df24e3a120$var$handleCatchError(parent, error, action) {
    var errorResult = {
        files: null,
        error: {
            message: error.message,
            fileExists: null
        }
    };
    $5703c0df24e3a120$var$onFailure(parent, errorResult, action);
}






/**
 * ContextMenu module
 */ var $761ef639f2f64957$export$8dc6765e8be191c7 = /** @class */ function() {
    /**
     * Constructor for the ContextMenu module
     *
     * @param {IFileManager} parent - Specifies the parent element.
     * @hidden
     */ function ContextMenu(parent) {
        this.isMenuItemClicked = false;
        this.currentItems = [];
        this.currentElement = null;
        this.disabledItems = [];
        this.parent = parent;
        this.render();
    }
    ContextMenu.prototype.render = function() {
        this.keyConfigs = {
            downarrow: "downarrow",
            uparrow: "uparrown"
        };
        this.contextMenu = new (0, $4017afccb487b2c7$export$8dc6765e8be191c7)({
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            target: "#" + this.parent.element.id,
            enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
            beforeItemRender: this.onBeforeItemRender.bind(this),
            select: this.onSelect.bind(this),
            beforeOpen: this.onBeforeOpen.bind(this),
            beforeClose: this.onBeforeClose.bind(this),
            cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, $15a2a1ec4804cfd7$export$ee3777be229b6eef)
        });
        this.contextMenu.isStringTemplate = true;
        this.contextMenu.appendTo("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$4010213931ead79d);
        this.addEventListener();
    };
    /* istanbul ignore next */ ContextMenu.prototype.onBeforeItemRender = function(args) {
        if (args.item.id === this.getMenuId("largeiconsview")) {
            var iconSpan = (0, $4ZDHT.createElement)("span");
            var element = args.element;
            element.insertBefore(iconSpan, this.parent.view === "LargeIcons" ? element.childNodes[1] : element.childNodes[0]);
            iconSpan.setAttribute("class", $15a2a1ec4804cfd7$export$ef62356806fa9c5a + " " + $15a2a1ec4804cfd7$export$3a5f55a56dfc3645);
        }
        if (args.item.id === this.getMenuId("detailsview")) {
            var iconSpan = (0, $4ZDHT.createElement)("span");
            var element = args.element;
            element.insertBefore(iconSpan, this.parent.view === "Details" ? element.childNodes[1] : element.childNodes[0]);
            iconSpan.setAttribute("class", $15a2a1ec4804cfd7$export$aad553f955d4f5af + " " + $15a2a1ec4804cfd7$export$3a5f55a56dfc3645);
        }
    };
    ContextMenu.prototype.onBeforeClose = function(args) {
        var eventArgs = {
            cancel: false,
            element: args.element,
            event: args.event,
            isFocused: args.isFocused,
            fileDetails: [
                this.menuItemData
            ],
            items: args.items,
            parentItem: args.parentItem,
            menuType: this.menuType
        };
        this.parent.trigger("menuClose", eventArgs, function(menuCloseArgs) {
            if (menuCloseArgs.cancel) {
                args.cancel = menuCloseArgs.cancel;
                return;
            }
        });
        this.menuTarget = null;
        if (!this.isMenuItemClicked && this.parent.pathId.length > 1 && this.parent.activeModule === "navigationpane") {
            this.parent.pathId.pop();
            var parentKey = [];
            var itemKeys = Object.keys(this.parent.feParent);
            for(var _i = 0, itemKeys_1 = itemKeys; _i < itemKeys_1.length; _i++){
                var item = itemKeys_1[_i];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var itemData = (0, $3EnZW.getValue)(item, this.parent.feParent);
                if (this.parent.pathNames.indexOf(itemData.name) !== -1) parentKey.push(itemData._fm_id);
            }
            this.parent.pathId.push(parentKey[parentKey.length - 1]);
            this.parent.navigationpaneModule.treeObj.selectedNodes = [
                this.parent.pathId[this.parent.pathId.length - 1]
            ];
        }
        this.isMenuItemClicked = false;
    };
    /* istanbul ignore next */ ContextMenu.prototype.onBeforeOpen = function(args) {
        var _this = this;
        var selected = false;
        var uid;
        var data;
        var treeFolder = false;
        var target = args.event.target;
        this.menuTarget = this.targetNodeElement = target;
        this.currentElement = args.element;
        if (target.classList.contains("e-spinner-pane")) {
            target = this.parent.navigationpaneModule.activeNode.getElementsByClassName($15a2a1ec4804cfd7$export$c025b5389024f4d2)[0];
            this.menuTarget = this.targetNodeElement = target;
        }
        this.targetElement = this.parent.view === "Details" ? (0, $4ZDHT.closest)(target, "tr.e-row") : target;
        if (this.parent.enableVirtualization && (target.classList.contains("e-virtual-bottom") || target.classList.contains("e-virtualtable"))) target = target.parentElement.closest("div");
        var view = this.getTargetView(target);
        this.updateActiveModule();
        /* istanbul ignore next */ if (target.classList.contains($15a2a1ec4804cfd7$export$978b95bc13897273) || (0, $4ZDHT.closest)(target, "th") || (0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a) || (0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$4b2454a32e09a33d)) args.cancel = true;
        else if (!(this.parent.view === "LargeIcons") && this.targetElement && this.targetElement.classList.contains("e-emptyrow")) this.setLayoutItem(target);
        else if ((0, $4ZDHT.closest)(target, "." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58)) this.setLayoutItem(target);
        else if (!target.classList.contains($15a2a1ec4804cfd7$export$fec55ff920461811) && !target.classList.contains($15a2a1ec4804cfd7$export$3a5f55a56dfc3645) && !target.classList.contains($15a2a1ec4804cfd7$export$f52e1910c5a0ddcd)) {
            /* istanbul ignore next */ if (this.parent.view === "LargeIcons" && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "li")) && !(0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$5fedb72465b4ade3)) {
                var eveArgs = {
                    ctrlKey: true,
                    shiftKey: true
                };
                if (!(0, $4ZDHT.closest)(target, "li").classList.contains("e-active")) this.parent.largeiconsviewModule.doSelection(target, eveArgs);
                data = this.parent.visitedData;
                selected = true;
            } else if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "tr.e-row"))) {
                uid = this.targetElement.getAttribute("data-uid");
                data = this.parent.detailsviewModule.gridObj.getRowObjectFromUID(uid).data;
                if ((0, $3EnZW.isNullOrUndefined)(this.targetElement.getAttribute("aria-selected"))) /* istanbul ignore next */ this.parent.detailsviewModule.gridObj.selectRows([
                    parseInt(this.targetElement.getAttribute("data-rowindex"), 10)
                ]);
                selected = true;
            /* istanbul ignore next */ } else if ((0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$5fedb72465b4ade3)) {
                uid = (0, $4ZDHT.closest)(target, "li").getAttribute("data-uid");
                if (!(0, $3EnZW.isNullOrUndefined)(uid)) this.parent.navigationpaneModule.treeObj.selectedNodes = [
                    uid
                ];
                treeFolder = true;
            }
            /* istanbul ignore next */ if (selected) {
                if ((0, $3EnZW.getValue)("isFile", data) === true) this.setFileItem();
                else this.setFolderItem(false);
            } else if (treeFolder) {
                this.setFolderItem(true);
                if (uid === this.parent.pathId[0]) this.disabledItems.push("Delete", "Rename", "Cut", "Copy");
                else {
                    var itemsToRemove = [
                        "Delete",
                        "Rename",
                        "Cut",
                        "Copy"
                    ];
                    for(var i = 0; i < this.disabledItems.length; i++){
                        var item = this.disabledItems[i];
                        if (itemsToRemove.indexOf(item) !== -1) {
                            this.disabledItems.splice(i, 1);
                            i--;
                        }
                    }
                }
            /* istanbul ignore next */ } else if (view === "TreeView" || view === "GridView" || view === "LargeIcon") this.setLayoutItem(target);
            else args.cancel = true;
        }
        var pasteEle = (0, $4ZDHT.select)("#" + this.getMenuId("Paste"), this.contextMenu.element);
        if (!args.cancel && !this.parent.enablePaste && pasteEle && !pasteEle.classList.contains("e-disabled")) {
            if (this.disabledItems.indexOf("Paste") === -1) this.disabledItems.push("Paste");
        } else {
            var pasteIndex = this.disabledItems.indexOf("Paste");
            if (pasteIndex !== -1) this.disabledItems.splice(pasteIndex, 1);
        }
        if (args.cancel) {
            this.menuTarget = this.currentElement = null;
            return;
        }
        this.contextMenu.dataBind();
        var isSubMenu = false;
        if (target.classList.contains($15a2a1ec4804cfd7$export$fec55ff920461811) || target.classList.contains($15a2a1ec4804cfd7$export$3a5f55a56dfc3645) || target.classList.contains($15a2a1ec4804cfd7$export$f52e1910c5a0ddcd)) isSubMenu = true;
        this.menuItemData = isSubMenu ? this.menuItemData : this.getMenuItemData();
        var eventArgs = {
            fileDetails: [
                this.menuItemData
            ],
            element: args.element,
            target: target,
            items: isSubMenu ? args.items : this.contextMenu.items,
            menuModule: this.contextMenu,
            cancel: false,
            menuType: this.menuType,
            isSubMenu: isSubMenu
        };
        this.currentItems = eventArgs.items;
        this.parent.trigger("menuOpen", eventArgs, function(menuOpenArgs) {
            if (!isSubMenu) {
                _this.contextMenu.dataBind();
                _this.contextMenu.items = menuOpenArgs.items;
                _this.contextMenu.dataBind();
            }
            _this.enableItems(_this.disabledItems, false, true);
            args.cancel = menuOpenArgs.cancel;
            if (menuOpenArgs.cancel) _this.menuTarget = _this.targetNodeElement = _this.currentElement = null;
        });
    };
    ContextMenu.prototype.updateActiveModule = function() {
        this.parent.activeModule = (0, $4ZDHT.closest)(this.menuTarget, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$5fedb72465b4ade3) ? "navigationpane" : (0, $4ZDHT.closest)(this.menuTarget, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$7e576f6604f42645) ? "detailsview" : (0, $4ZDHT.closest)(this.menuTarget, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$f558f378488ddc5d) ? "largeiconsview" : this.parent.activeModule;
    };
    /* istanbul ignore next */ /**
     *
     * @param {Element} target - specifies the target element.
     * @returns {string} -returns the target view.
     * @hidden
     */ ContextMenu.prototype.getTargetView = function(target) {
        return target.classList.contains($15a2a1ec4804cfd7$export$978b95bc13897273) ? "TreeView" : target.classList.contains($15a2a1ec4804cfd7$export$3556ea5f805d5290) ? "GridView" : target.classList.contains($15a2a1ec4804cfd7$export$77fa21b8fd9f8f76) ? "LargeIcon" : target.classList.contains($15a2a1ec4804cfd7$export$aec2fde68eb32201) ? "LargeIcon" : "";
    };
    ContextMenu.prototype.getItemIndex = function(item) {
        var itemId = this.getMenuId(item);
        for(var i = 0; i < this.currentItems.length; i++){
            if (this.currentItems[i].id === itemId || this.currentItems[i].id === item) return i;
        }
        return -1;
    };
    ContextMenu.prototype.disableItem = function(items) {
        if (items.length !== 0) this.disabledItems = this.disabledItems.concat(items);
    };
    ContextMenu.prototype.enableItems = function(items, enable, isUniqueId) {
        for(var i = 0; i < items.length; i++){
            if (this.checkValidItem(items[i]) === 1) this.contextMenu.enableItems([
                this.getMenuId(items[i])
            ], enable, isUniqueId);
            else if (this.checkValidItem(items[i]) === 2) this.contextMenu.enableItems([
                items[i]
            ], enable, isUniqueId);
        }
    };
    ContextMenu.prototype.setFolderItem = function(isTree) {
        this.menuType = "folder";
        this.contextMenu.items = this.getItemData(this.parent.contextMenuSettings.folder.map(function(item) {
            return item.trim();
        }));
        this.contextMenu.dataBind();
        if (isTree) {
            var selectedTreeNode = (0, $4ZDHT.select)('[data-uid="' + this.parent.navigationpaneModule.treeObj.selectedNodes[0] + '"]', this.parent.navigationpaneModule.treeObj.element);
            if (this.parent.pathNames[this.parent.pathNames.length - 1] === selectedTreeNode.querySelector(".e-list-text").innerHTML && this.parent.activeModule === "navigationpane") this.disabledItems.push("Open");
            else {
                var indexToRemove = this.disabledItems.indexOf("Open");
                if (indexToRemove !== -1) this.disabledItems.splice(indexToRemove, 1);
            }
            if (this.parent.selectedItems.length === 0) {
                var renameIndex = this.disabledItems.indexOf("Rename");
                if (renameIndex !== -1) this.disabledItems.splice(renameIndex, 1);
            }
        } else if (this.parent.activeModule !== "navigationpane") {
            if (this.parent.selectedItems.length === 1) {
                var renameIndex = this.disabledItems.indexOf("Rename");
                if (renameIndex !== -1) this.disabledItems.splice(renameIndex, 1);
            } else this.disabledItems.push("Rename", "Paste");
        }
    };
    ContextMenu.prototype.setFileItem = function() {
        this.menuType = "file";
        this.contextMenu.items = this.getItemData(this.parent.contextMenuSettings.file.map(function(item) {
            return item.trim();
        }));
        this.contextMenu.dataBind();
        if (this.parent.selectedItems.length === 1) {
            var renameIndex = this.disabledItems.indexOf("Rename");
            if (renameIndex !== -1) this.disabledItems.splice(renameIndex, 1);
        } else this.disabledItems.push("Rename");
    };
    ContextMenu.prototype.setLayoutItem = function(target) {
        this.menuType = "layout";
        this.contextMenu.items = this.getItemData(this.parent.contextMenuSettings.layout.map(function(item) {
            return item.trim();
        }));
        this.contextMenu.dataBind();
        if (!this.parent.allowMultiSelection || this.parent.view === "LargeIcons" && (0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$f558f378488ddc5d).getElementsByClassName($15a2a1ec4804cfd7$export$ccb33e29d92c9a58).length !== 0 || this.parent.view === "Details" && (0, $4ZDHT.closest)(target, "#" + this.parent.element.id + $15a2a1ec4804cfd7$export$7e576f6604f42645).getElementsByClassName($15a2a1ec4804cfd7$export$ccb33e29d92c9a58).length !== 0) this.disabledItems.push("SelectAll");
        else this.disabledItems = this.disabledItems.filter(function(item) {
            return item !== "SelectAll";
        });
        if (this.parent.selectedNodes.length === 0) {
            if (this.disabledItems.indexOf("Paste") === -1) this.disabledItems.push("Paste");
        }
        this.contextMenu.dataBind();
    };
    ContextMenu.prototype.checkValidItem = function(nameEle) {
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("#" + this.getMenuId(nameEle), this.currentElement))) return 1;
        else if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("#" + nameEle, this.currentElement))) return 2;
        else return -1;
    };
    ContextMenu.prototype.getMenuItemData = function() {
        if (this.menuType === "layout") return (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this.parent);
        else {
            var args = {
                target: this.menuTarget
            };
            this.parent.notify($f592513f3f17ead8$export$8f25f467acbd067b, args);
            return this.parent.itemData[0];
        }
    };
    /* istanbul ignore next */ ContextMenu.prototype.onSelect = function(args) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(args.item) || !args.item.id) return;
        var itemText = args.item.id.substr((this.parent.element.id + "_cm_").length);
        var details;
        if (itemText === "refresh" || itemText === "newfolder" || itemText === "upload") {
            details = [
                (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this.parent)
            ];
            this.parent.itemData = details;
        } else {
            this.parent.notify($f592513f3f17ead8$export$1bab5b85a1c363d3, {});
            if (this.parent.activeModule === "navigationpane" && itemText === "open") details = [
                this.menuItemData
            ];
            else details = this.parent.itemData;
        }
        var eventArgs = {
            cancel: false,
            element: args.element,
            fileDetails: details,
            item: args.item
        };
        this.parent.trigger("menuClick", eventArgs, function(menuClickArgs) {
            var sItems;
            if (!menuClickArgs.cancel) {
                _this.isMenuItemClicked = true;
                switch(itemText){
                    case "cut":
                        (0, $a3d9eadd9d99207c$export$3e9460fe0b724f5e)(_this.parent);
                        break;
                    case "copy":
                        (0, $a3d9eadd9d99207c$export$6738b3634be42910)(_this.parent);
                        break;
                    case "paste":
                        if (_this.menuType === "folder") {
                            if (_this.parent.activeModule === "navigationpane") {
                                _this.parent.navigationpaneModule.openFileOnContextMenuClick((0, $4ZDHT.closest)(_this.targetNodeElement, "li"));
                                _this.parent.folderPath = _this.parent.path;
                            } else _this.parent.folderPath = (0, $a3d9eadd9d99207c$export$ce41aaed7504a4ce)(_this.parent, _this.menuItemData, _this.parent.path);
                        } else _this.parent.folderPath = "";
                        (0, $a3d9eadd9d99207c$export$5b201a757191240e)(_this.parent);
                        break;
                    case "delete":
                        for(var j = 0; j < details.length; j++)if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(details[j])) {
                            (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(_this.parent, details[j], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                            return;
                        }
                        (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(_this.parent, "Delete");
                        break;
                    /* istanbul ignore next */ case "download":
                        for(var i = 0; i < details.length; i++)if (!(0, $a3d9eadd9d99207c$export$afe83600fb70ac59)(details[i])) {
                            (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(_this.parent, details[i], $f592513f3f17ead8$export$1812abec3897779e);
                            return;
                        }
                        if (_this.parent.activeModule === "navigationpane") _this.parent.notify($f592513f3f17ead8$export$996119a35335562f, {});
                        else if (_this.parent.selectedItems.length > 0) (0, $5703c0df24e3a120$export$a7aaed3e118dd255)(_this.parent, _this.parent.path, _this.parent.selectedItems);
                        break;
                    case "rename":
                        if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(details[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(_this.parent, details[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                        else {
                            _this.parent.notify($f592513f3f17ead8$export$8192f7ae2d5b7044, {});
                            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(_this.parent, "Rename");
                        }
                        break;
                    case "selectall":
                        /* istanbul ignore next */ _this.parent.notify($f592513f3f17ead8$export$8c0e181e1fb07b6c, {});
                        break;
                    case "refresh":
                        (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(_this.parent);
                        break;
                    case "open":
                        if (_this.parent.visitedItem && _this.parent.activeModule !== "navigationpane") _this.parent.notify($f592513f3f17ead8$export$c2e8e8195b50c1cd, {
                            target: _this.parent.visitedItem
                        });
                        else if (_this.parent.activeModule === "navigationpane") {
                            if (_this.parent.visitedItem) _this.parent.notify($f592513f3f17ead8$export$c2e8e8195b50c1cd, {
                                target: _this.parent.visitedItem
                            });
                            _this.parent.navigationpaneModule.openFileOnContextMenuClick((0, $4ZDHT.closest)(_this.targetNodeElement, "li"));
                        }
                        break;
                    case "details":
                        _this.parent.notify($f592513f3f17ead8$export$d41cfdb8d87b5bef, {});
                        sItems = _this.parent.selectedItems;
                        if (_this.parent.activeModule === "navigationpane") {
                            sItems = [];
                            _this.parent.navigationpaneModule.openFileOnContextMenuClick((0, $4ZDHT.closest)(_this.targetNodeElement, "li"));
                        }
                        (0, $5703c0df24e3a120$export$1b969bdfbc184d40)(_this.parent, sItems, _this.parent.path, "details");
                        break;
                    case "newfolder":
                        (0, $a3d9eadd9d99207c$export$a7450cfe784d304d)(_this.parent);
                        break;
                    case "upload":
                        (0, $a3d9eadd9d99207c$export$e5277fc94f47f9c6)(_this.parent);
                        break;
                    case "name":
                    case "size":
                    case "date":
                    case "ascending":
                    case "descending":
                        /* istanbul ignore next */ (0, $a3d9eadd9d99207c$export$3378c763463f8b33)(_this.parent, args);
                        break;
                    /* istanbul ignore next */ case "none":
                        /* istanbul ignore next */ (0, $a3d9eadd9d99207c$export$3378c763463f8b33)(_this.parent, args);
                        break;
                    /* istanbul ignore next */ case "largeiconsview":
                        (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(_this.parent, "LargeIcons");
                        break;
                    /* istanbul ignore next */ case "detailsview":
                        (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(_this.parent, "Details");
                        break;
                }
            }
        });
    };
    ContextMenu.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName() && e.module !== "common") /* istanbul ignore next */ return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "cssClass":
                    this.contextMenu.cssClass = (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, $15a2a1ec4804cfd7$export$ee3777be229b6eef);
                    break;
            }
        }
    };
    ContextMenu.prototype.addEventListener = function() {
        this.parent.on($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.contextMenu.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
    };
    ContextMenu.prototype.removeEventListener = function() {
        this.parent.off($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged);
        this.keyboardModule.destroy();
    };
    ContextMenu.prototype.keyActionHandler = function(e) {
        switch(e.action){
            case "uparrow":
            case "downarrow":
                e.preventDefault();
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the module name.
     * @private
     */ ContextMenu.prototype.getModuleName = function() {
        return "contextmenu";
    };
    ContextMenu.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        this.contextMenu.destroy();
        this.targetElement = null;
    };
    /* istanbul ignore next */ ContextMenu.prototype.getItemData = function(data) {
        var items = [];
        for(var i = 0; i < data.length; i++){
            var item = void 0;
            var itemId = this.getMenuId(data[i]);
            var itemText = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, data[i]);
            switch(data[i]){
                case "|":
                    item = {
                        separator: true
                    };
                    break;
                case "Open":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$4ed45c65d0a1d78c
                    };
                    break;
                case "Upload":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$668107712639d3c1
                    };
                    break;
                case "Cut":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$59600ec56318ce2e
                    };
                    break;
                case "Copy":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$e08ef55150a91249
                    };
                    break;
                case "Paste":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$b61aa7a218246ebb
                    };
                    break;
                case "Delete":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$e5b93bb6e343631c
                    };
                    break;
                case "Rename":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$f1d4ae5347f9c581
                    };
                    break;
                case "NewFolder":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$57ae219d1e034dc1
                    };
                    break;
                case "Details":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$de358f4807ef8cba
                    };
                    break;
                case "SortBy":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$7e533dc0afd7438d,
                        items: [
                            {
                                id: this.getMenuId("Name"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Name"),
                                iconCss: this.parent.sortBy === "name" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : null
                            },
                            {
                                id: this.getMenuId("Size"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Size"),
                                iconCss: this.parent.sortBy === "size" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : null
                            },
                            {
                                id: this.getMenuId("Date"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "DateModified"),
                                iconCss: this.parent.sortBy === "_fm_modified" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : null
                            },
                            {
                                separator: true
                            },
                            {
                                id: this.getMenuId("Ascending"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Ascending"),
                                iconCss: this.parent.sortOrder === "Ascending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : null
                            },
                            {
                                id: this.getMenuId("Descending"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Descending"),
                                iconCss: this.parent.sortOrder === "Descending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : null
                            },
                            {
                                id: this.getMenuId("None"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "None"),
                                iconCss: this.parent.sortOrder === "None" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : null
                            }
                        ]
                    };
                    break;
                /* istanbul ignore next */ case "View":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$aad553f955d4f5af : $15a2a1ec4804cfd7$export$ef62356806fa9c5a,
                        items: [
                            {
                                id: this.getMenuId("largeiconsview"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View-LargeIcons"),
                                iconCss: this.parent.view === "Details" ? null : $15a2a1ec4804cfd7$export$7c3c1a4030f052e2
                            },
                            {
                                id: this.getMenuId("detailsview"),
                                text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View-Details"),
                                iconCss: this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : null
                            }
                        ]
                    };
                    break;
                case "Refresh":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$885ce83a8b956470
                    };
                    break;
                case "SelectAll":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$c7cf3941a3f8df35
                    };
                    break;
                /* istanbul ignore next */ case "Download":
                    item = {
                        id: itemId,
                        text: itemText,
                        iconCss: $15a2a1ec4804cfd7$export$41f3da434144936c
                    };
                    break;
                /* istanbul ignore next */ default:
                    item = {
                        id: itemId,
                        text: itemText
                    };
                    break;
            }
            items.push(item);
        }
        return items;
    };
    ContextMenu.prototype.getMenuId = function(id) {
        return this.parent.element.id + "_cm_" + id.split(" ").join("").toLowerCase();
    };
    return ContextMenu;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");





parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $eAUyT = parcelRequire("eAUyT");
var $g9Ic7 = parcelRequire("g9Ic7");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");







// eslint-disable-next-line valid-jsdoc, jsdoc/require-param, jsdoc/require-returns
/**
 *
 * The `Group` module is used to handle group action.
 */ var $59e0e5762e06e953$export$eb2fcfdbd7ba97d4 = /** @class */ function() {
    /**
     * Constructor for Grid group module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {GroupSettingsModel} groupSettings - specifies the GroupSettingsModel
     * @param {string[]} sortedColumns - specifies the sortedColumns
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     * @hidden
     */ function Group(parent, groupSettings, sortedColumns, serviceLocator) {
        var _this = this;
        //Internal variables
        this.sortRequired = true;
        /** @hidden */ this.groupSortFocus = false;
        /** @hidden */ this.groupTextFocus = false;
        /** @hidden */ this.groupCancelFocus = false;
        this.isAppliedGroup = false;
        this.isAppliedUnGroup = false;
        this.isAppliedCaptionRowBorder = false;
        this.reorderingColumns = [];
        this.visualElement = (0, $4ZDHT.createElement)("div", {
            className: "e-cloneproperties e-dragclone e-gdclone",
            styles: "line-height:23px",
            attrs: {
                action: "grouping"
            }
        });
        this.helper = function(e) {
            var gObj = _this.parent;
            var target = e.sender.target;
            var element = target.classList.contains("e-groupheadercell") ? target : (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-groupheadercell");
            if (!element || !target.classList.contains("e-drag") && _this.groupSettings.allowReordering) return false;
            _this.column = gObj.getColumnByField(element.firstElementChild.getAttribute("ej-mappingname"));
            _this.visualElement.textContent = element.textContent;
            _this.visualElement.style.width = element.offsetWidth + 2 + "px";
            _this.visualElement.style.height = element.offsetHeight + 2 + "px";
            _this.visualElement.setAttribute("e-mappinguid", _this.column.uid);
            gObj.element.appendChild(_this.visualElement);
            return _this.visualElement;
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.dragStart = function(e) {
            _this.parent.element.classList.add("e-ungroupdrag");
        };
        this.drag = function(e) {
            if (_this.groupSettings.allowReordering) _this.animateDropper(e);
            var target = e.target;
            var cloneElement = _this.parent.element.querySelector(".e-cloneproperties");
            _this.parent.trigger($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, {
                target: target,
                draggableType: "headercell",
                column: _this.column
            });
            if (!_this.groupSettings.allowReordering) {
                (0, $4ZDHT.classList)(cloneElement, [
                    "e-defaultcur"
                ], [
                    "e-notallowedcur"
                ]);
                if (!((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, $1b5568e76cdae6d4$export$ee5f1442ff7df474) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-headercell"))) (0, $4ZDHT.classList)(cloneElement, [
                    "e-notallowedcur"
                ], [
                    "e-defaultcur"
                ]);
            }
        };
        this.dragStop = function(e) {
            _this.parent.element.classList.remove("e-ungroupdrag");
            var preventDrop = !((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, $1b5568e76cdae6d4$export$ee5f1442ff7df474) || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridheader"));
            if (_this.groupSettings.allowReordering && preventDrop) {
                (0, $4ZDHT.remove)(e.helper);
                if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea")) _this.rearrangeGroup();
                else if (!(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-grid")) {
                    var field = _this.parent.getColumnByUid(e.helper.getAttribute("e-mappinguid")).field;
                    if (_this.groupSettings.columns.indexOf(field) !== -1) _this.ungroupColumn(field);
                }
                return;
            } else if (preventDrop) {
                (0, $4ZDHT.remove)(e.helper);
                return;
            }
        };
        this.animateDropper = function(e) {
            var uid = _this.parent.element.querySelector(".e-cloneproperties").getAttribute("e-mappinguid");
            var dragField = _this.parent.getColumnByUid(uid).field;
            var parent = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea");
            var dropTarget = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-group-animator");
            var grouped = [].slice.call(_this.element.getElementsByClassName("e-groupheadercell")).map(function(e) {
                return e.querySelector("div").getAttribute("ej-mappingname");
            });
            var cols = JSON.parse(JSON.stringify(grouped));
            if (dropTarget || parent) {
                if (dropTarget) {
                    var dropField = dropTarget.querySelector("div[ej-mappingname]").getAttribute("ej-mappingname");
                    var dropIndex = +dropTarget.getAttribute("index");
                    if (dropField !== dragField) {
                        var dragIndex = cols.indexOf(dragField);
                        if (dragIndex !== -1) cols.splice(dragIndex, 1);
                        var flag = dropIndex !== -1 && dragIndex === dropIndex;
                        cols.splice(dropIndex + (flag ? 1 : 0), 0, dragField);
                    }
                } else if (parent && cols.indexOf(dragField) === -1) cols.push(dragField);
                _this.element.innerHTML = "";
                if (cols.length && !_this.element.classList.contains("e-grouped")) _this.element.classList.add("e-grouped");
                _this.reorderingColumns = cols;
                for(var c = 0; c < cols.length; c++)_this.addColToGroupDrop(cols[parseInt(c.toString(), 10)]);
            } else {
                _this.addLabel();
                _this.removeColFromGroupDrop(dragField);
            }
        };
        this.drop = function(e) {
            var gObj = _this.parent;
            var column = gObj.getColumnByUid(e.droppedElement.getAttribute("e-mappinguid"));
            _this.element.classList.remove("e-hover");
            (0, $4ZDHT.remove)(e.droppedElement);
            _this.aria.setDropTarget(_this.parent.element.querySelector(".e-groupdroparea"), false);
            _this.aria.setGrabbed(_this.parent.getHeaderTable().querySelector("[aria-grabbed=true]"), false);
            if ((0, $3EnZW.isNullOrUndefined)(column) || column.allowGrouping === false || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(gObj.getColumnHeaderByUid(column.uid), "e-grid").getAttribute("id") !== gObj.element.getAttribute("id")) {
                _this.parent.log("action_disabled_column", {
                    moduleName: _this.getModuleName(),
                    columnName: column ? column.headerText : undefined
                });
                return;
            }
            _this.groupColumn(column.field);
        };
        this.contentRefresh = true;
        this.aria = new (0, $93af6f2061a6f920$export$aaeab4162651d364)();
        this.parent = parent;
        this.groupSettings = groupSettings;
        this.serviceLocator = serviceLocator;
        this.sortedColumns = sortedColumns;
        this.focus = serviceLocator.getService("focus");
        this.addEventListener();
        this.groupGenerator = new (0, $00f5ac64cc4c9276$export$e121011a4bc11d9e)(this.parent);
    }
    Group.prototype.addLabel = function() {
        if (!this.element.getElementsByClassName("e-group-animator").length) {
            var dragLabel = this.l10n.getConstant("GroupDropArea");
            this.element.innerHTML = dragLabel;
            this.element.classList.remove("e-grouped");
        }
    };
    Group.prototype.rearrangeGroup = function() {
        this.sortRequired = false;
        this.updateModel();
    };
    Group.prototype.columnDrag = function(e) {
        if (this.groupSettings.allowReordering && e.column.allowGrouping) this.animateDropper(e);
        var cloneElement = this.parent.element.querySelector(".e-cloneproperties");
        if (!this.parent.allowReordering) (0, $4ZDHT.classList)(cloneElement, [
            "e-defaultcur"
        ], [
            "e-notallowedcur"
        ]);
        if (!(e.column.allowGrouping && ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupdroparea") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell") && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell").isEqualNode(this.parent.getColumnHeaderByField(e.column.field)))) && !(this.parent.allowReordering && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell"))) (0, $4ZDHT.classList)(cloneElement, [
            "e-notallowedcur"
        ], [
            "e-defaultcur"
        ]);
        if (e.target.classList.contains("e-groupdroparea")) this.element.classList.add("e-hover");
        else this.element.classList.remove("e-hover");
    };
    Group.prototype.columnDragStart = function(e) {
        if (e.target.classList.contains("e-stackedheadercell")) return;
        var dropArea = this.parent.element.querySelector(".e-groupdroparea");
        this.aria.setDropTarget(dropArea, e.column.allowGrouping);
        var element = e.target.classList.contains("e-headercell") ? e.target : (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-headercell");
        this.aria.setGrabbed(element, true, !e.column.allowGrouping);
    };
    Group.prototype.columnDrop = function(e) {
        var gObj = this.parent;
        if (e.droppedElement.getAttribute("action") === "grouping") {
            var column = gObj.getColumnByUid(e.droppedElement.getAttribute("e-mappinguid"));
            if ((0, $3EnZW.isNullOrUndefined)(column) || column.allowGrouping === false || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(gObj.getColumnHeaderByUid(column.uid), "e-grid").getAttribute("id") !== gObj.element.getAttribute("id")) return;
            this.ungroupColumn(column.field);
        }
    };
    /**
     * @returns {void}
     * @hidden
     */ Group.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender, this);
        this.parent.on($17b89d3b1fc93cdb$export$45acafeece38b8a2, this.onActionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$9bcde1a530e0aaf1, this.onActionComplete, this);
        this.parent.on($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged, this);
        this.parent.on($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, this.columnDrag, this);
        this.parent.on($17b89d3b1fc93cdb$export$e7b0ce279c912385, this.columnDragStart, this);
        this.parent.on($17b89d3b1fc93cdb$export$b0a9271d3fcee092, this.columnDrop, this);
        this.parent.on($17b89d3b1fc93cdb$export$553a7dc8a546fa4c, this.columnDrop, this);
        this.parent.on($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.refreshSortIcons, this);
        this.parent.on($17b89d3b1fc93cdb$export$157fcb0735825622, this.refreshSortIcons, this);
        this.parent.on($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyPressHandler, this);
        this.parent.on($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd, this);
        this.parent.on($17b89d3b1fc93cdb$export$63287e93462800a4, this.initialEnd, this);
        this.parent.on($17b89d3b1fc93cdb$export$5d4840440f592fca, this.render, this);
        this.parent.on($17b89d3b1fc93cdb$export$7102324ec21b2ea7, this.onGroupAggregates, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on("group-expand-collapse", this.updateExpand, this);
        this.parent.on("persist-data-changed", this.initialEnd, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ Group.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$5d4840440f592fca, this.render);
        this.parent.off($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRender);
        this.parent.off($17b89d3b1fc93cdb$export$45acafeece38b8a2, this.onActionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$9bcde1a530e0aaf1, this.onActionComplete);
        this.parent.off($17b89d3b1fc93cdb$export$f4000f83c4e293d0, this.onPropertyChanged);
        this.parent.off($17b89d3b1fc93cdb$export$64ef1bee2b9504c1, this.clickHandler);
        this.parent.off($17b89d3b1fc93cdb$export$ccfabd9386eb4ea2, this.columnDrag);
        this.parent.off($17b89d3b1fc93cdb$export$e7b0ce279c912385, this.columnDragStart);
        this.parent.off($17b89d3b1fc93cdb$export$553a7dc8a546fa4c, this.columnDrop);
        this.parent.off($17b89d3b1fc93cdb$export$b0a9271d3fcee092, this.columnDrop);
        this.parent.off($17b89d3b1fc93cdb$export$265a66bcae9d11dd, this.refreshSortIcons);
        this.parent.off($17b89d3b1fc93cdb$export$157fcb0735825622, this.refreshSortIcons);
        this.parent.off($17b89d3b1fc93cdb$export$e09b512eecac7579, this.keyPressHandler);
        this.parent.off($17b89d3b1fc93cdb$export$7102324ec21b2ea7, this.onGroupAggregates);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        this.parent.off("group-expand-collapse", this.updateExpand);
    };
    Group.prototype.initialEnd = function() {
        var gObj = this.parent;
        this.parent.off($17b89d3b1fc93cdb$export$f44d9209b353bf3e, this.initialEnd);
        this.parent.off($17b89d3b1fc93cdb$export$63287e93462800a4, this.initialEnd);
        if (this.parent.getColumns().length && this.groupSettings.columns.length) {
            this.contentRefresh = false;
            for(var _i = 0, _a = gObj.groupSettings.columns; _i < _a.length; _i++){
                var col = _a[_i];
                this.groupColumn(col);
            }
            this.contentRefresh = true;
        }
    };
    Group.prototype.keyPressHandler = function(e) {
        var gObj = this.parent;
        if (e.target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-groupheadercell") && (e.action === "tab" || e.action === "shiftTab")) {
            var focusableGroupedItems = this.getFocusableGroupedItems();
            if (e.action === "tab" && e.target === focusableGroupedItems[focusableGroupedItems.length - 1] || e.action === "shiftTab" && e.target === focusableGroupedItems[0]) return;
            for(var i = 0; i < focusableGroupedItems.length; i++)if (e.target === focusableGroupedItems[parseInt(i.toString(), 10)]) {
                e.preventDefault();
                var index = e.action === "tab" ? i + 1 : i - 1;
                focusableGroupedItems[parseInt(index.toString(), 10)].focus();
                return;
            }
        }
        var isMacLike = /(Mac)/i.test(navigator.platform);
        if (isMacLike && e.metaKey) {
            if (e.action === "downArrow") e.action = "ctrlDownArrow";
            else if (e.action === "upArrow") e.action = "ctrlUpArrow";
        }
        if (e.action !== "ctrlSpace" && (!this.groupSettings.columns.length || [
            "altDownArrow",
            "altUpArrow",
            "ctrlDownArrow",
            "ctrlUpArrow",
            "enter"
        ].indexOf(e.action) === -1) || this.parent.groupSettings.enableLazyLoading && this.groupSettings.columns.length && (e.action === "ctrlUpArrow" || e.action === "ctrlDownArrow")) return;
        switch(e.action){
            case "altDownArrow":
            case "altUpArrow":
                // eslint-disable-next-line no-case-declarations
                var selected = gObj.allowSelection ? gObj.getSelectedRowIndexes() : [];
                if (selected.length) {
                    e.preventDefault();
                    var rows = gObj.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children;
                    var dataRow = gObj.getDataRows()[selected[selected.length - 1]];
                    var grpRow = void 0;
                    for(var i = dataRow.rowIndex; i >= 0; i--)if (!rows[parseInt(i.toString(), 10)].classList.contains($1b5568e76cdae6d4$export$120ff0929b202a6d) && !rows[parseInt(i.toString(), 10)].classList.contains("e-detailrow")) {
                        grpRow = rows[parseInt(i.toString(), 10)];
                        break;
                    }
                    this.expandCollapseRows(grpRow.querySelector(e.action === "altUpArrow" ? ".e-recordplusexpand" : ".e-recordpluscollapse"));
                }
                break;
            case "ctrlDownArrow":
                e.preventDefault();
                this.expandAll();
                break;
            case "ctrlUpArrow":
                e.preventDefault();
                this.collapseAll();
                break;
            case "enter":
                if (e.target.classList.contains("e-groupsort")) {
                    this.groupSortFocus = true;
                    e.preventDefault();
                    this.applySortFromTarget(e.target);
                    break;
                } else if (e.target.classList.contains("e-ungroupbutton")) {
                    this.groupCancelFocus = true;
                    e.preventDefault();
                    this.unGroupFromTarget(e.target);
                    break;
                }
                if (this.parent.isEdit || (0, $4ZDHT.closest)(e.target, "#" + this.parent.element.id + "_searchbar") !== null || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-pager") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-toolbar")) return;
                // eslint-disable-next-line no-case-declarations
                var element = this.focus.getFocusedElement();
                if (element && (element.classList.contains("e-icon-grightarrow") || element.classList.contains("e-icon-gdownarrow"))) element = element.parentElement;
                // eslint-disable-next-line no-case-declarations
                var row = element ? element.parentElement.querySelector('[class^="e-record"]') : null;
                if (!row) break;
                if (element.children.length && (element.children[0].classList.contains("e-icon-grightarrow") || element.children[0].classList.contains("e-icon-gdownarrow"))) {
                    e.preventDefault();
                    this.expandCollapseRows(row);
                }
                break;
            case "ctrlSpace":
                // eslint-disable-next-line no-case-declarations
                var elem = gObj.focusModule.currentInfo.element;
                if (elem && elem.classList.contains("e-headercell")) {
                    e.preventDefault();
                    var column = gObj.getColumnByUid(elem.firstElementChild.getAttribute("e-mappinguid"));
                    if (column.field && gObj.groupSettings.columns.indexOf(column.field) < 0) this.groupColumn(column.field);
                    else this.ungroupColumn(column.field);
                }
                break;
        }
    };
    /**
     * @returns {Element[]} - Return the focusable grouping items
     * @hidden */ Group.prototype.getFocusableGroupedItems = function() {
        var focusableGroupedItems = [];
        if (this.groupSettings.columns.length) {
            var focusableGroupedHeaderItems = this.element.querySelectorAll(".e-groupheadercell");
            for(var i = 0; i < focusableGroupedHeaderItems.length; i++){
                focusableGroupedItems.push(focusableGroupedHeaderItems[parseInt(i.toString(), 10)].querySelector(".e-grouptext"));
                focusableGroupedItems.push(focusableGroupedHeaderItems[parseInt(i.toString(), 10)].querySelector(".e-groupsort"));
                focusableGroupedItems.push(focusableGroupedHeaderItems[parseInt(i.toString(), 10)].querySelector(".e-ungroupbutton"));
            }
        }
        return focusableGroupedItems;
    };
    Group.prototype.wireEvent = function() {
        (0, $aqzbR.EventHandler).add(this.element, "focusin", this.onFocusIn, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.onFocusOut, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "auxclick", this.auxilaryclickHandler, this);
    };
    Group.prototype.unWireEvent = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "focusin", this.onFocusIn);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.onFocusOut);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "auxclick", this.auxilaryclickHandler);
    };
    Group.prototype.onFocusIn = function(e) {
        if (this.parent.focusModule.currentInfo && this.parent.focusModule.currentInfo.element) {
            (0, $4ZDHT.removeClass)([
                this.parent.focusModule.currentInfo.element,
                this.parent.focusModule.currentInfo.elementToFocus
            ], [
                "e-focused",
                "e-focus"
            ]);
            this.parent.focusModule.currentInfo.element.tabIndex = -1;
        }
        this.addOrRemoveFocus(e);
    };
    Group.prototype.onFocusOut = function(e) {
        this.addOrRemoveFocus(e);
    };
    Group.prototype.addOrRemoveFocus = function(e) {
        if (e.target.classList.contains("e-groupdroparea") || e.target.classList.contains("e-grouptext") || e.target.classList.contains("e-groupsort") || e.target.classList.contains("e-ungroupbutton")) {
            var target = e.target.classList.contains("e-grouptext") ? e.target.parentElement.parentElement : e.target;
            if (e.type === "focusin") {
                this.parent.focusModule.currentInfo.element = e.target;
                this.parent.focusModule.currentInfo.elementToFocus = e.target;
                (0, $4ZDHT.addClass)([
                    target
                ], [
                    "e-focused",
                    "e-focus"
                ]);
                e.target.tabIndex = 0;
            } else {
                (0, $4ZDHT.removeClass)([
                    target
                ], [
                    "e-focused",
                    "e-focus"
                ]);
                e.target.tabIndex = -1;
            }
        }
    };
    Group.prototype.clickHandler = function(e) {
        if (e.target.classList.contains("e-grouptext")) this.groupTextFocus = true;
        if (e.target.classList.contains("e-groupsort")) this.groupSortFocus = true;
        if (e.target.classList.contains("e-ungroupbutton")) this.groupCancelFocus = true;
        if (e.target.classList.contains("e-icon-grightarrow") || e.target.classList.contains("e-icon-gdownarrow")) e.preventDefault();
        var trgtEle = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-recordplusexpand") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-recordpluscollapse");
        if (trgtEle && (trgtEle.children[0].classList.contains("e-icon-gdownarrow") || trgtEle.children[0].classList.contains("e-icon-grightarrow"))) this.expandCollapseRows(e.target);
        this.applySortFromTarget(e.target);
        this.unGroupFromTarget(e.target);
        this.toogleGroupFromHeader(e.target);
    };
    Group.prototype.auxilaryclickHandler = function(e) {
        if (e.target.classList.contains("e-icon-grightarrow") || e.target.classList.contains("e-icon-gdownarrow") && e.button === 1) e.preventDefault();
    };
    Group.prototype.unGroupFromTarget = function(target) {
        if (target.classList.contains("e-ungroupbutton")) this.ungroupColumn(target.parentElement.getAttribute("ej-mappingname"));
    };
    Group.prototype.toogleGroupFromHeader = function(target) {
        if (this.groupSettings.showToggleButton) {
            if (target.classList.contains("e-grptogglebtn")) {
                if (target.classList.contains("e-toggleungroup")) this.ungroupColumn(this.parent.getColumnByUid(target.parentElement.getAttribute("e-mappinguid")).field);
                else this.groupColumn(this.parent.getColumnByUid(target.parentElement.getAttribute("e-mappinguid")).field);
            } else if (target.classList.contains("e-toggleungroup")) this.ungroupColumn(target.parentElement.getAttribute("ej-mappingname"));
        }
    };
    Group.prototype.applySortFromTarget = function(target) {
        var gObj = this.parent;
        var gHeader = (0, $4ZDHT.closest)(target, ".e-groupheadercell");
        if (gObj.allowSorting && gHeader && !target.classList.contains("e-ungroupbutton") && !target.classList.contains("e-toggleungroup")) {
            var field = gHeader.firstElementChild.getAttribute("ej-mappingname");
            if (gObj.getColumnHeaderByField(field).getElementsByClassName("e-ascending").length) gObj.sortColumn(field, "Descending", true);
            else gObj.sortColumn(field, "Ascending", true);
        }
    };
    /**
     * Expands or collapses grouped rows by target element.
     *
     * @param  {Element} target - Defines the target element of the grouped row.
     * @returns {void}
     */ Group.prototype.expandCollapseRows = function(target) {
        var trgt = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-recordplusexpand") || (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-recordpluscollapse");
        if (trgt) {
            var rowNodes = [].slice.call(this.parent.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children);
            if (this.parent.editSettings.showAddNewRow) {
                if (rowNodes[0].classList.contains("e-addedrow")) rowNodes.shift();
                else if (rowNodes[rowNodes.length - 1].classList.contains("e-addedrow")) rowNodes.pop();
            }
            var isHide = void 0;
            var dataManager = void 0;
            var query = void 0;
            var gObj = this.parent;
            var indent = trgt.parentElement.getElementsByClassName("e-indentcell").length;
            var uid = trgt.parentElement.getAttribute("data-uid");
            var captionRow = gObj.getRowObjectFromUID(uid);
            var expand = false;
            if (trgt.classList.contains("e-recordpluscollapse")) {
                (0, $4ZDHT.addClass)([
                    trgt
                ], "e-recordplusexpand");
                (0, $4ZDHT.removeClass)([
                    trgt
                ], "e-recordpluscollapse");
                trgt.firstElementChild.className = "e-icons e-gdiagonaldown e-icon-gdownarrow";
                trgt.firstElementChild.setAttribute("title", this.l10n.getConstant("Expanded"));
                expand = true;
                captionRow.isExpand = true;
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) this.updateVirtualRows(gObj, target, expand, query, dataManager);
                if (this.parent.groupSettings.enableLazyLoading) {
                    if ((this.parent.filterSettings.columns.length || this.parent.sortSettings.columns.length || this.parent.searchSettings.key.length) && this.parent.getContent().firstElementChild.scrollTop === 0) this.parent.contentModule.isTop = true;
                    (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).captionExpand(trgt.parentElement);
                }
            } else {
                isHide = true;
                captionRow.isExpand = false;
                (0, $4ZDHT.removeClass)([
                    trgt
                ], "e-recordplusexpand");
                (0, $4ZDHT.addClass)([
                    trgt
                ], "e-recordpluscollapse");
                trgt.firstElementChild.className = "e-icons e-gnextforward e-icon-grightarrow";
                trgt.firstElementChild.setAttribute("title", this.l10n.getConstant("Collapsed"));
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj)) this.updateVirtualRows(gObj, target, !isHide, query, dataManager);
                if (this.parent.groupSettings.enableLazyLoading) (this.parent.enableVirtualization ? this.parent.lazyLoadRender : this.parent.contentModule).captionCollapse(trgt.parentElement);
            }
            this.aria.setExpand(trgt, expand);
            if (!(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(gObj) && !this.parent.groupSettings.enableLazyLoading) {
                var rowObjs = gObj.getRowsObject();
                var startIdx = rowObjs.indexOf(captionRow);
                var rowsState = {};
                var cacheStartIdx = gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings && gObj.infiniteScrollSettings.enableCache && rowObjs.length !== rowNodes.length ? Array.from(rowNodes).indexOf(trgt.parentElement) : undefined;
                for(var i = startIdx; i < rowObjs.length; i++){
                    if (i > startIdx && rowObjs[parseInt(i.toString(), 10)].indent === indent) break;
                    if (rowObjs[parseInt(i.toString(), 10)].isDetailRow) {
                        var visible = rowObjs[i - 1].isExpand && rowObjs[i - 1].visible;
                        if (cacheStartIdx && cacheStartIdx > 0 && cacheStartIdx < rowNodes.length) rowNodes[parseInt(cacheStartIdx.toString(), 10)].style.display = visible ? "" : "none";
                        else if ((0, $3EnZW.isNullOrUndefined)(cacheStartIdx)) rowNodes[parseInt(i.toString(), 10)].style.display = visible ? "" : "none";
                    } else if (rowsState[rowObjs[parseInt(i.toString(), 10)].parentUid] === false) {
                        rowObjs[parseInt(i.toString(), 10)].visible = false;
                        if (cacheStartIdx && cacheStartIdx > 0 && cacheStartIdx < rowNodes.length) rowNodes[parseInt(cacheStartIdx.toString(), 10)].style.display = "none";
                        else if ((0, $3EnZW.isNullOrUndefined)(cacheStartIdx)) rowNodes[parseInt(i.toString(), 10)].style.display = "none";
                    } else {
                        if (!(rowObjs[parseInt(i.toString(), 10)].isDataRow || rowObjs[parseInt(i.toString(), 10)].isCaptionRow || rowObjs[parseInt(i.toString(), 10)].isDetailRow || rowObjs[parseInt(i.toString(), 10)].isAggregateRow)) {
                            var visible = rowObjs[parseInt(i.toString(), 10)].cells.some(function(cell) {
                                return cell.isDataCell && cell.visible;
                            });
                            if (visible === rowObjs[parseInt(i.toString(), 10)].visible) continue;
                        }
                        rowObjs[parseInt(i.toString(), 10)].visible = true;
                        if (cacheStartIdx && cacheStartIdx > 0 && cacheStartIdx < rowNodes.length) {
                            rowNodes[parseInt(cacheStartIdx.toString(), 10)].style.display = "";
                            rowNodes[parseInt(cacheStartIdx.toString(), 10)].classList.remove("e-hide");
                        } else if ((0, $3EnZW.isNullOrUndefined)(cacheStartIdx)) {
                            rowNodes[parseInt(i.toString(), 10)].style.display = "";
                            rowNodes[parseInt(i.toString(), 10)].classList.remove("e-hide");
                        }
                    }
                    if (rowObjs[parseInt(i.toString(), 10)].isCaptionRow) rowsState[rowObjs[parseInt(i.toString(), 10)].uid] = rowObjs[parseInt(i.toString(), 10)].isExpand && rowObjs[parseInt(i.toString(), 10)].visible;
                    if (!(0, $3EnZW.isNullOrUndefined)(cacheStartIdx)) cacheStartIdx++;
                }
                this.lastCaptionRowBorder();
                this.parent.notify($17b89d3b1fc93cdb$export$c70b4b413518c03b, {
                    rows: this.parent.getRowsObject()
                });
            }
            if (!this.parent.enableInfiniteScrolling || !this.parent.groupSettings.enableLazyLoading) this.parent.notify($17b89d3b1fc93cdb$export$f4e4d2b069f96288, {
                isCollapse: isHide,
                parentUid: uid
            });
        }
    };
    /**
     * The function is used to set border in last row
     *
     * @returns { void }
     * @hidden
     */ Group.prototype.lastCaptionRowBorder = function() {
        var table = this.parent.getContentTable();
        var clientHeight = this.parent.getContent().clientHeight;
        if (!this.parent.enableVirtualization && !this.parent.enableInfiniteScrolling || this.parent.groupSettings.enableLazyLoading) {
            if (table.scrollHeight < clientHeight || this.isAppliedCaptionRowBorder) {
                if (this.isAppliedCaptionRowBorder || table.querySelector(".e-lastrowcell")) {
                    var borderCells = table.querySelectorAll(".e-lastrowcell");
                    for(var i = 0, len = borderCells.length; i < len; i++)(0, $4ZDHT.removeClass)([
                        borderCells[parseInt(i.toString(), 10)]
                    ], "e-lastrowcell");
                    this.isAppliedCaptionRowBorder = false;
                }
                var rowNodes = this.parent.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children;
                var lastRow = rowNodes[rowNodes.length - 1];
                if (lastRow.style.display !== "none" && !lastRow.classList.contains("e-groupcaptionrow")) {
                    if (table.scrollHeight < clientHeight) {
                        (0, $4ZDHT.addClass)(table.querySelectorAll("tr:last-child td"), "e-lastrowcell");
                        this.isAppliedCaptionRowBorder = true;
                    }
                } else for(var i = rowNodes.length - 1, len = 0; i > len; i--){
                    if (rowNodes[parseInt(i.toString(), 10)].style.display !== "none" && rowNodes[parseInt(i.toString(), 10)].classList.contains("e-groupcaptionrow")) {
                        if (rowNodes[parseInt(i.toString(), 10)].querySelector(".e-recordpluscollapse")) {
                            (0, $4ZDHT.addClass)(rowNodes[parseInt(i.toString(), 10)].childNodes, "e-lastrowcell");
                            this.isAppliedCaptionRowBorder = true;
                            break;
                        }
                    }
                }
            }
        }
    };
    Group.prototype.updateVirtualRows = function(gObj, target, isExpand, query, dataManager) {
        var rObj = gObj.getRowObjectFromUID(target.closest("tr").getAttribute("data-uid"));
        rObj.isExpand = isExpand;
        (0, $748c2240e597a9b7$export$a16bd681357a4a59)(gObj);
        this.parent.notify($17b89d3b1fc93cdb$export$8fcd90c21e6d64a3, {});
        query = gObj.getDataModule().generateQuery(false);
        query.queries = gObj.getDataModule().aggregateQuery(gObj.getQuery().clone()).queries;
        var args = {
            requestType: "virtualscroll",
            rowObject: rObj
        };
        if (gObj.contentModule) args.virtualInfo = gObj.contentModule.prevInfo;
        dataManager = gObj.getDataModule().getData(args, query.requiresCount());
        dataManager.then(function(e) {
            return gObj.renderModule.dataManagerSuccess(e, args);
        });
    };
    Group.prototype.expandCollapse = function(isExpand) {
        if (!this.parent.groupSettings.columns.length) return;
        if (!isExpand) this.parent.notify($17b89d3b1fc93cdb$export$21f05f465c475796, isExpand);
        var rowNodes = this.parent.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).children;
        var rowObjs = this.parent.getRowsObject();
        var row;
        for(var i = 0, len = rowNodes.length; i < len; i++){
            if (rowNodes[parseInt(i.toString(), 10)].querySelectorAll(".e-recordplusexpand, .e-recordpluscollapse").length) {
                row = rowNodes[parseInt(i.toString(), 10)].querySelector(isExpand ? ".e-recordpluscollapse" : ".e-recordplusexpand");
                if (row) {
                    if (isExpand) {
                        row.className = "e-recordplusexpand";
                        row.firstElementChild.className = "e-icons e-gdiagonaldown e-icon-gdownarrow";
                        row.setAttribute("aria-expanded", "true");
                        row.firstElementChild.setAttribute("title", this.l10n.getConstant("Expanded"));
                    } else {
                        row.className = "e-recordpluscollapse";
                        row.firstElementChild.className = "e-icons e-gnextforward e-icon-grightarrow";
                        row.setAttribute("aria-expanded", "false");
                        row.firstElementChild.setAttribute("title", this.l10n.getConstant("Collapsed"));
                    }
                }
                if (!(rowNodes[parseInt(i.toString(), 10)].firstElementChild.classList.contains("e-recordplusexpand") || rowNodes[parseInt(i.toString(), 10)].firstElementChild.classList.contains("e-recordpluscollapse"))) rowNodes[parseInt(i.toString(), 10)].style.display = isExpand ? "" : "none";
            } else rowNodes[parseInt(i.toString(), 10)].style.display = isExpand ? "" : "none";
            if (rowObjs[parseInt(i.toString(), 10)].isCaptionRow) rowObjs[parseInt(i.toString(), 10)].isExpand = isExpand ? true : false;
        }
        this.parent.updateVisibleExpandCollapseRows();
        this.lastCaptionRowBorder();
        this.parent.notify($17b89d3b1fc93cdb$export$c70b4b413518c03b, {
            rows: this.parent.getRowsObject()
        });
    };
    /**
     * Expands all the grouped rows of the Grid.
     *
     * @returns {void}
     */ Group.prototype.expandAll = function() {
        this.expandCollapse(true);
    };
    /**
     * Collapses all the grouped rows of the Grid.
     *
     * @returns {void}
     */ Group.prototype.collapseAll = function() {
        this.expandCollapse(false);
    };
    /**
     * The function is used to render grouping
     *
     * @returns {void}
     * @hidden
     */ Group.prototype.render = function() {
        this.l10n = this.serviceLocator.getService("localization");
        this.renderGroupDropArea();
        this.initDragAndDrop();
        this.refreshToggleBtn();
        this.wireEvent();
    };
    Group.prototype.renderGroupDropArea = function() {
        var groupElem = this.parent.element.querySelector(".e-groupdroparea");
        if (groupElem) (0, $4ZDHT.remove)(groupElem);
        this.element = this.parent.createElement("div", {
            className: "e-groupdroparea",
            attrs: {
                "tabindex": "-1"
            }
        });
        if (this.groupSettings.allowReordering) this.element.classList.add("e-group-animate");
        this.updateGroupDropArea();
        this.parent.element.insertBefore(this.element, this.parent.element.firstChild);
        if (!this.groupSettings.showDropArea || this.parent.rowRenderingMode === "Vertical") this.element.style.display = "none";
    };
    Group.prototype.updateGroupDropArea = function(clear) {
        if (this.groupSettings.showDropArea && !this.groupSettings.columns.length) {
            var dragLabel = this.l10n.getConstant("GroupDropArea");
            this.element.innerHTML = dragLabel;
            this.element.classList.remove("e-grouped");
        } else {
            if (this.element.innerHTML === this.l10n.getConstant("GroupDropArea") && (this.groupSettings.columns.length === 1 || !this.isAppliedGroup && !this.isAppliedUnGroup) || clear) this.element.innerHTML = "";
            this.element.classList.add("e-grouped");
        }
    };
    Group.prototype.initDragAndDrop = function() {
        this.initializeGHeaderDrop();
        this.initializeGHeaderDrag();
    };
    Group.prototype.initializeGHeaderDrag = function() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var drag = new (0, $eAUyT.Draggable)(this.element, {
            dragTarget: this.groupSettings.allowReordering ? ".e-drag" : ".e-groupheadercell",
            distance: this.groupSettings.allowReordering ? -10 : 5,
            helper: this.helper,
            dragStart: this.dragStart,
            drag: this.drag,
            dragStop: this.dragStop
        });
    };
    Group.prototype.initializeGHeaderDrop = function() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var drop = new (0, $g9Ic7.Droppable)(this.element, {
            accept: ".e-dragclone",
            drop: this.drop
        });
    };
    /**
     * Groups a column by column name.
     *
     * @param  {string} columnName - Defines the column name to group.
     * @returns {void}
     */ Group.prototype.groupColumn = function(columnName) {
        var gObj = this.parent;
        var column = gObj.getColumnByField(columnName);
        if ((0, $3EnZW.isNullOrUndefined)(column) || column.allowGrouping === false || this.contentRefresh && this.groupSettings.columns.indexOf(columnName) > -1) {
            this.parent.log("action_disabled_column", {
                moduleName: this.getModuleName(),
                columnName: column.headerText
            });
            return;
        }
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj)) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.groupColumn,
                arg1: columnName
            });
            return;
        }
        column.visible = gObj.groupSettings.showGroupedColumn;
        this.colName = columnName;
        this.isAppliedGroup = true;
        if (this.contentRefresh) this.updateModel();
        else this.addColToGroupDrop(columnName);
        this.updateGroupDropArea();
        this.isAppliedGroup = false;
    };
    /**
     * Ungroups a column by column name.
     *
     * @param  {string} columnName - Defines the column name to ungroup.
     * @returns {void}
     */ Group.prototype.ungroupColumn = function(columnName) {
        var gObj = this.parent;
        var column = this.parent.enableColumnVirtualization ? this.parent.columns.filter(function(c) {
            return c.field === columnName;
        })[0] : gObj.getColumnByField(columnName);
        if ((0, $3EnZW.isNullOrUndefined)(column) || column.allowGrouping === false || this.groupSettings.columns.indexOf(columnName) < 0) return;
        if ((0, $748c2240e597a9b7$export$fbf5228cd2134af7)(gObj)) {
            gObj.notify($17b89d3b1fc93cdb$export$df7abab87e90ad9b, {
                instance: this,
                handler: this.ungroupColumn,
                arg1: columnName
            });
            return;
        }
        column.visible = true;
        this.colName = column.field;
        var columns = JSON.parse(JSON.stringify(this.groupSettings.columns));
        columns.splice(columns.indexOf(this.colName), 1);
        if (this.sortedColumns.indexOf(columnName) < 0) {
            for(var i = 0, len = gObj.sortSettings.columns.length; i < len; i++)if (columnName === gObj.sortSettings.columns[parseInt(i.toString(), 10)].field) {
                gObj.sortSettings.columns.splice(i, 1);
                break;
            }
        }
        if (this.groupSettings.allowReordering) this.reorderingColumns = columns;
        this.groupSettings.columns = columns;
        if (gObj.allowGrouping) {
            this.isAppliedUnGroup = true;
            this.parent.dataBind();
        }
    };
    /**
     * The function used to update groupSettings
     *
     * @returns {void}
     * @hidden
     */ Group.prototype.updateModel = function() {
        var columns = JSON.parse(JSON.stringify(this.groupSettings.columns));
        columns = this.reorderingColumns.length ? JSON.parse(JSON.stringify(this.reorderingColumns)) : columns;
        if (this.sortRequired) {
            if (columns.indexOf(this.colName) === -1) columns.push(this.colName);
            this.groupAddSortingQuery(this.colName);
        }
        this.sortRequired = true;
        this.parent.groupSettings.columns = columns;
        this.parent.dataBind();
    };
    /**
     * The function used to trigger onActionComplete
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */ Group.prototype.onActionComplete = function(e) {
        if (e.requestType === "grouping") this.addColToGroupDrop(this.colName);
        else this.removeColFromGroupDrop(this.colName);
        if (this.groupSettings.showDropArea && this.parent.height === "100%") this.parent.scrollModule.refresh();
        var args = this.groupSettings.columns.indexOf(this.colName) > -1 ? {
            columnName: this.colName,
            requestType: "grouping",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        } : {
            requestType: "ungrouping",
            type: $17b89d3b1fc93cdb$export$830631a3cb598490
        };
        this.parent.trigger($17b89d3b1fc93cdb$export$830631a3cb598490, (0, $3EnZW.extend)(e, args));
        this.colName = null;
    };
    Group.prototype.groupAddSortingQuery = function(colName) {
        var i = 0;
        while(i < this.parent.sortSettings.columns.length){
            if (this.parent.sortSettings.columns[parseInt(i.toString(), 10)].field === colName) break;
            i++;
        }
        if (this.parent.sortSettings.columns.length === i) this.parent.sortSettings.columns.push({
            field: colName,
            direction: "Ascending",
            isFromGroup: true
        });
        else if (!this.parent.allowSorting) this.parent.sortSettings.columns[parseInt(i.toString(), 10)].direction = "Ascending";
    };
    Group.prototype.createElement = function(field) {
        var gObj = this.parent;
        var direction = "Ascending";
        var animator = this.parent.createElement("div", {
            className: "e-grid-icon e-group-animator"
        });
        var groupedColumn = this.parent.createElement("div", {
            className: "e-grid-icon e-groupheadercell"
        });
        var childDiv = this.parent.createElement("div", {
            attrs: {
                "ej-mappingname": field
            }
        });
        if ((0, $748c2240e597a9b7$export$9850823255bfa4ed)(field)) childDiv.setAttribute("ej-complexname", (0, $748c2240e597a9b7$export$d0c60e9a423ac807)(field));
        var column = this.parent.getColumnByField(field);
        //Todo headerTemplateID for grouped column, disableHtmlEncode
        var headerCell = gObj.getColumnHeaderByUid(column.uid);
        // if (!isNullOrUndefined(column.headerTemplate)) {
        //     if (column.headerTemplate.indexOf('#') !== -1) {
        //         childDiv.innerHTML = document.querySelector(column.headerTemplate).innerHTML.trim();
        //     } else {
        //         childDiv.innerHTML = column.headerTemplate;
        //     }
        //     childDiv.firstElementChild.classList.add('e-grouptext');
        // } else {
        if (this.groupSettings.allowReordering) childDiv.appendChild(this.parent.createElement("span", {
            className: "e-drag e-icons e-icon-drag",
            innerHTML: "&nbsp;",
            attrs: {
                title: "Drag",
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("GroupedDrag")
            }
        }));
        childDiv.appendChild(this.parent.createElement("span", {
            className: "e-grouptext",
            innerHTML: column.headerText,
            attrs: {
                tabindex: "-1"
            }
        }));
        // }
        if (this.groupSettings.showToggleButton) childDiv.appendChild(this.parent.createElement("span", {
            className: "e-togglegroupbutton e-icons e-icon-ungroup e-toggleungroup",
            innerHTML: "&nbsp;",
            attrs: {
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("UnGroupAria")
            }
        }));
        if (headerCell.querySelectorAll(".e-ascending,.e-descending").length) direction = headerCell.querySelector(".e-ascending") ? "Ascending" : "Descending";
        childDiv.appendChild(this.parent.createElement("span", {
            className: "e-groupsort e-icons " + ("e-" + direction.toLowerCase() + " e-icon-" + direction.toLowerCase()),
            innerHTML: "&nbsp;",
            attrs: {
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("GroupedSortIcon") + column.headerText,
                role: "button"
            }
        }));
        childDiv.appendChild(this.parent.createElement("span", {
            className: "e-ungroupbutton e-icons e-icon-hide",
            innerHTML: "&nbsp;",
            attrs: {
                title: this.l10n.getConstant("UnGroup"),
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("UnGroupIcon") + column.headerText,
                role: "button"
            },
            styles: this.groupSettings.showUngroupButton ? "" : "display:none"
        }));
        groupedColumn.appendChild(childDiv);
        if (this.groupSettings.allowReordering) {
            animator.appendChild(groupedColumn);
            animator.appendChild(this.createSeparator());
            groupedColumn = animator;
        }
        return groupedColumn;
    };
    Group.prototype.addColToGroupDrop = function(field) {
        var groupElem = (0, $748c2240e597a9b7$export$9850823255bfa4ed)(field) ? this.parent.element.querySelector(".e-groupdroparea div[ej-complexname=" + (0, $748c2240e597a9b7$export$bd555f260694987a)((0, $748c2240e597a9b7$export$d0c60e9a423ac807)(field)) + "]") : this.parent.element.querySelector(".e-groupdroparea div[ej-mappingname=" + (0, $748c2240e597a9b7$export$bd555f260694987a)(field) + "]");
        if (this.groupSettings.allowReordering && groupElem) return;
        var column = this.parent.getColumnByField(field);
        if ((0, $3EnZW.isNullOrUndefined)(column)) return;
        var groupedColumn = this.createElement(field);
        if (this.groupSettings.allowReordering) {
            var index = this.element.getElementsByClassName("e-group-animator").length;
            groupedColumn.setAttribute("index", index.toString());
        }
        this.element.appendChild(groupedColumn);
        var focusModule = this.parent.focusModule;
        focusModule.setActive(true);
        var firstContentCellIndex = [
            0,
            0
        ];
        if (focusModule.active.matrix.matrix[firstContentCellIndex[0]][firstContentCellIndex[1]] === 0) firstContentCellIndex = (0, $748c2240e597a9b7$export$375d9927fa4cce82)(focusModule.active.matrix.matrix, firstContentCellIndex, true);
        focusModule.active.matrix.current = firstContentCellIndex;
        if (this.parent.editSettings.showAddNewRow) this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
        else if (this.parent.isInitialLoad) focusModule.focus();
    //Todo:  rtl
    };
    Group.prototype.createSeparator = function() {
        return this.parent.createElement("span", {
            className: "e-nextgroup e-icons e-icon-next",
            innerHTML: "&nbsp;",
            attrs: {
                tabindex: "-1",
                "aria-label": this.l10n.getConstant("GroupSeperator")
            },
            styles: this.groupSettings.showUngroupButton ? "" : "display:none"
        });
    };
    Group.prototype.refreshToggleBtn = function(isRemove) {
        if (this.groupSettings.showToggleButton) {
            var headers = [].slice.call(this.parent.getHeaderTable().getElementsByClassName("e-headercelldiv"));
            for(var i = 0, len = headers.length; i < len; i++)if (!(headers[parseInt(i.toString(), 10)].classList.contains("e-emptycell") || headers[parseInt(i.toString(), 10)].classList.contains("e-headerchkcelldiv"))) {
                var column = this.parent.getColumnByUid(headers[parseInt(i.toString(), 10)].getAttribute("e-mappinguid"));
                if (!this.parent.showColumnMenu || this.parent.showColumnMenu && !column.showColumnMenu) {
                    if (headers[parseInt(i.toString(), 10)].getElementsByClassName("e-grptogglebtn").length) (0, $4ZDHT.remove)(headers[parseInt(i.toString(), 10)].querySelectorAll(".e-grptogglebtn")[0]);
                    if (!isRemove) headers[parseInt(i.toString(), 10)].appendChild(this.parent.createElement("span", {
                        className: "e-grptogglebtn e-icons " + (this.groupSettings.columns.indexOf(column.field) > -1 ? "e-toggleungroup e-icon-ungroup" : "e-togglegroup e-icon-group"),
                        attrs: {
                            tabindex: "-1",
                            "aria-label": (0, $3EnZW.isNullOrUndefined)(this.l10n) ? this.parent.localeObj.getConstant("GroupButton") : this.l10n.getConstant("GroupButton")
                        }
                    }));
                }
            }
        }
    };
    Group.prototype.removeColFromGroupDrop = function(field) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.getGHeaderCell(field))) {
            var elem = this.getGHeaderCell(field);
            if (this.groupSettings.allowReordering) {
                var parent_1 = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(elem, "e-group-animator");
                (0, $4ZDHT.remove)(parent_1);
            } else (0, $4ZDHT.remove)(elem);
            this.updateGroupDropArea();
            if (this.parent.editSettings.showAddNewRow) this.parent.notify($17b89d3b1fc93cdb$export$68dd90c72fa20ca, {});
        }
        this.isAppliedUnGroup = false;
    };
    Group.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName()) return;
        for(var _i = 0, _a = Object.keys(e.properties); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "columns":
                    // eslint-disable-next-line no-case-declarations
                    var args = void 0;
                    if (this.contentRefresh) {
                        if (!this.isAppliedUnGroup) {
                            if (!this.isAppliedGroup) {
                                this.updateGroupDropArea(true);
                                for(var j = 0; j < this.parent.sortSettings.columns.length; j++)if (this.parent.sortSettings.columns[parseInt(j.toString(), 10)].isFromGroup) {
                                    this.parent.sortSettings.columns.splice(j, 1);
                                    j--;
                                }
                                for(var i = 0; i < this.groupSettings.columns.length; i++){
                                    this.colName = this.groupSettings.columns[parseInt(i.toString(), 10)];
                                    var col = this.parent.getColumnByField(this.colName);
                                    col.visible = this.parent.groupSettings.showGroupedColumn;
                                    this.groupAddSortingQuery(this.colName);
                                    if (i < this.groupSettings.columns.length - 1) this.addColToGroupDrop(this.groupSettings.columns[parseInt(i.toString(), 10)]);
                                }
                            }
                            args = {
                                columnName: this.colName,
                                requestType: e.properties["" + prop].length ? "grouping" : "ungrouping",
                                type: $17b89d3b1fc93cdb$export$df204737a6131aab
                            };
                        } else args = {
                            columnName: this.colName,
                            requestType: "ungrouping",
                            type: $17b89d3b1fc93cdb$export$df204737a6131aab
                        };
                        if (!this.groupSettings.showGroupedColumn) {
                            var columns = e.oldProperties["" + prop];
                            for(var i = 0; i < columns.length; i++)if (e.properties["" + prop].indexOf(columns[parseInt(i.toString(), 10)]) === -1) this.parent.getColumnByField(columns[parseInt(i.toString(), 10)]).visible = true;
                        }
                        this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, args);
                    }
                    break;
                case "showDropArea":
                    this.updateGroupDropArea();
                    if (this.groupSettings.showDropArea) {
                        this.element.style.display = "";
                        this.parent.headerModule.refreshUI();
                    } else this.element.style.display = "none";
                    if (this.parent.height === "100%") this.parent.scrollModule.refresh();
                    break;
                case "showGroupedColumn":
                    this.updateGroupedColumn(this.groupSettings.showGroupedColumn);
                    this.parent.notify($17b89d3b1fc93cdb$export$80cded91831c5507, {
                        requestType: "refresh"
                    });
                    break;
                case "showUngroupButton":
                    this.updateButtonVisibility(this.groupSettings.showUngroupButton, "e-ungroupbutton");
                    break;
                case "showToggleButton":
                    this.updateButtonVisibility(this.groupSettings.showToggleButton, "e-togglegroupbutton ");
                    this.parent.refreshHeader();
                    break;
                case "enableLazyLoading":
                    this.parent.freezeRefresh();
                    break;
            }
        }
    };
    Group.prototype.updateGroupedColumn = function(isVisible) {
        for(var i = 0; i < this.groupSettings.columns.length; i++)this.parent.getColumnByField(this.groupSettings.columns[parseInt(i.toString(), 10)]).visible = isVisible;
    };
    Group.prototype.updateButtonVisibility = function(isVisible, className) {
        var gHeader = [].slice.call(this.element.getElementsByClassName(className));
        for(var i = 0; i < gHeader.length; i++)gHeader[parseInt(i.toString(), 10)].style.display = isVisible ? "" : "none";
    };
    Group.prototype.enableAfterRender = function(e) {
        if (e.module === this.getModuleName() && e.enable) this.render();
    };
    /**
     * To destroy the reorder
     *
     * @returns {void}
     * @hidden
     */ Group.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this.parent.isDestroyed || !this.parent.allowGrouping) && !this.parent.refreshing) this.clearGrouping();
        this.unWireEvent();
        this.removeEventListener();
        this.refreshToggleBtn(true);
        if (this.element.parentNode) (0, $4ZDHT.remove)(this.element);
    //call ejdrag and drop destroy
    };
    /**
     * Clears all the grouped columns of the Grid.
     *
     * @returns {void}
     */ Group.prototype.clearGrouping = function() {
        var cols = JSON.parse(JSON.stringify(this.groupSettings.columns));
        this.contentRefresh = false;
        for(var i = 0, len = cols.length; i < len; i++){
            if (i === len - 1) this.contentRefresh = true;
            this.ungroupColumn(cols[parseInt(i.toString(), 10)]);
        }
        this.contentRefresh = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */ Group.prototype.getModuleName = function() {
        return "group";
    };
    Group.prototype.refreshSortIcons = function() {
        var gObj = this.parent;
        var header;
        var cols = gObj.sortSettings.columns;
        var gCols = gObj.groupSettings.columns;
        var fieldNames = this.parent.getColumns().map(function(c) {
            return c.field;
        });
        this.refreshToggleBtn();
        for(var i = 0, len = cols.length; i < len; i++){
            if (fieldNames.indexOf(cols[parseInt(i.toString(), 10)].field) === -1) continue;
            header = gObj.getColumnHeaderByField(cols[parseInt(i.toString(), 10)].field);
            if (!gObj.allowSorting && (this.sortedColumns.indexOf(cols[parseInt(i.toString(), 10)].field) > -1 || this.groupSettings.columns.indexOf(cols[parseInt(i.toString(), 10)].field) > -1)) {
                (0, $4ZDHT.classList)(header.querySelector(".e-sortfilterdiv"), [
                    "e-ascending",
                    "e-icon-ascending"
                ], []);
                if (cols.length > 1) header.querySelector(".e-headercelldiv").appendChild(this.parent.createElement("span", {
                    className: "e-sortnumber",
                    innerHTML: (i + 1).toString()
                }));
            } else if (this.getGHeaderCell(cols[parseInt(i.toString(), 10)].field) && this.getGHeaderCell(cols[parseInt(i.toString(), 10)].field).getElementsByClassName("e-groupsort").length) {
                if (cols[parseInt(i.toString(), 10)].direction === "Ascending") (0, $4ZDHT.classList)(this.getGHeaderCell(cols[parseInt(i.toString(), 10)].field).querySelector(".e-groupsort"), [
                    "e-ascending",
                    "e-icon-ascending"
                ], [
                    "e-descending",
                    "e-icon-descending"
                ]);
                else (0, $4ZDHT.classList)(this.getGHeaderCell(cols[parseInt(i.toString(), 10)].field).querySelector(".e-groupsort"), [
                    "e-descending",
                    "e-icon-descending"
                ], [
                    "e-ascending",
                    "e-icon-ascending"
                ]);
            }
        }
        for(var i = 0, len = gCols.length; i < len; i++){
            if (fieldNames.indexOf(gCols[parseInt(i.toString(), 10)]) === -1) continue;
            gObj.getColumnHeaderByField(gCols[parseInt(i.toString(), 10)]).setAttribute("aria-grouped", "true");
        }
    };
    Group.prototype.getGHeaderCell = function(field) {
        if (this.element && this.element.querySelector('[ej-mappingname="' + field + '"]')) return this.element.querySelector('[ej-mappingname="' + field + '"]').parentElement;
        return null;
    };
    Group.prototype.onGroupAggregates = function(editedData) {
        if (this.parent.groupSettings.enableLazyLoading) {
            if (this.parent.editSettings.mode !== "Batch") this.updateLazyLoadGroupAggregates(editedData);
            return;
        }
        var aggregates = this.iterateGroupAggregates(editedData);
        var rowData = this.groupGenerator.generateRows(aggregates, {});
        var summaryRows = this.parent.getRowsObject().filter(function(row) {
            return !row.isDataRow;
        });
        var updateSummaryRows = rowData.filter(function(data) {
            return !data.isDataRow;
        });
        if (this.parent.isReact || this.parent.isVue) this.parent.destroyTemplate([
            "groupFooterTemplate",
            "groupCaptionTemplate",
            "footerTemplate"
        ]);
        for(var i = 0; i < updateSummaryRows.length; i++){
            var row = updateSummaryRows[parseInt(i.toString(), 10)];
            var cells = row.cells.filter(function(cell) {
                return cell.isDataCell;
            });
            var args = {
                cells: cells,
                data: row.data,
                dataUid: summaryRows[parseInt(i.toString(), 10)] ? summaryRows[parseInt(i.toString(), 10)].uid : ""
            };
            this.parent.notify($17b89d3b1fc93cdb$export$195df17369c093a1, args);
        }
    };
    Group.prototype.updateLazyLoadGroupAggregates = function(data, remoteResult) {
        var _this = this;
        var groupCaptionTemplates = this.getGroupAggregateTemplates(true);
        var groupFooterTemplates = this.getGroupAggregateTemplates(false);
        if (!groupCaptionTemplates.length && !groupFooterTemplates.length) return;
        var gObj = this.parent;
        var isRemote = gObj.getDataModule().isRemote();
        var updatedData = data[0];
        var editedRow = data.row;
        var groupedCols = gObj.groupSettings.columns;
        var groupLazyLoadRenderer = gObj.contentModule;
        var groupCache = groupLazyLoadRenderer.getGroupCache();
        var currentPageGroupCache = groupCache[gObj.pageSettings.currentPage];
        var result = remoteResult ? remoteResult : [];
        var _loop_1 = function(i) {
            var groupField = groupedCols[parseInt(i.toString(), 10)];
            var groupKey = updatedData["" + groupField];
            var groupCaptionRowObject = this_1.getGroupCaptionRowObject(editedRow, groupedCols.length - i);
            if (isRemote && result.length) {
                if (i !== 0) {
                    var prevGroupField = groupedCols[i - 1];
                    var prevGroupKey_1 = updatedData["" + prevGroupField];
                    result = result.find(function(data) {
                        return data.key === prevGroupKey_1;
                    }).items;
                }
                this_1.updateLazyLoadGroupAggregatesRow(result, groupKey, groupCaptionRowObject, currentPageGroupCache, groupCaptionTemplates, groupFooterTemplates);
            } else {
                var query = gObj.renderModule.data.generateQuery();
                if (i !== 0) {
                    var currentLevelCaptionRowObjects = currentPageGroupCache.filter(function(data) {
                        return data.isCaptionRow && data.parentUid === groupCaptionRowObject.parentUid;
                    });
                    var index = currentLevelCaptionRowObjects.indexOf(groupCaptionRowObject);
                    var fields = gObj.groupSettings.columns.slice(0, i).reverse();
                    var keys = fields.map(function(data) {
                        return updatedData["" + data];
                    });
                    var pred = (0, $748c2240e597a9b7$export$78fdc30439dd7cde)(fields, keys, groupLazyLoadRenderer);
                    var predicateList = (0, $748c2240e597a9b7$export$365f0bc04eed0222)(pred);
                    var lazyLoad = {
                        level: i,
                        skip: index,
                        take: 1,
                        where: predicateList
                    };
                    query.lazyLoad.push({
                        key: "onDemandGroupInfo",
                        value: lazyLoad
                    });
                }
                gObj.renderModule.data.getData({}, query).then(function(e) {
                    if (isRemote) _this.updateLazyLoadGroupAggregates(data, e.result);
                    else _this.updateLazyLoadGroupAggregatesRow(e.result, groupKey, groupCaptionRowObject, currentPageGroupCache, groupCaptionTemplates, groupFooterTemplates);
                    if (i === groupedCols.length - 1 || isRemote) _this.destroyRefreshGroupCaptionFooterTemplate();
                }).catch(function(e) {
                    return gObj.renderModule.dataManagerFailure(e, {
                        requestType: "grouping"
                    });
                });
                if (isRemote) return "break";
            }
        };
        var this_1 = this;
        for(var i = 0; i < groupedCols.length; i++){
            var state_1 = _loop_1(i);
            if (state_1 === "break") break;
        }
    };
    Group.prototype.destroyRefreshGroupCaptionFooterTemplate = function() {
        var gObj = this.parent;
        if (gObj.isAngular || gObj.isReact || gObj.isVue) gObj.destroyTemplate([
            "groupCaptionTemplate",
            "groupFooterTemplate"
        ]);
        gObj.refreshGroupCaptionFooterTemplate();
        gObj.removeMaskRow();
        gObj.hideSpinner();
    };
    Group.prototype.updateLazyLoadGroupAggregatesRow = function(result, groupKey, groupCaptionRowObject, currentPageGroupCache, groupCaptionTemplates, groupFooterTemplates) {
        var updatedGroupCaptionData = result.find(function(data) {
            return data.key === groupKey;
        });
        if (groupCaptionTemplates.length) this.updateLazyLoadGroupAggregatesCell(updatedGroupCaptionData, groupCaptionRowObject, groupCaptionTemplates);
        if (groupFooterTemplates.length) {
            var groupFooterRowObject = currentPageGroupCache.find(function(data) {
                return data.isAggregateRow && data.parentUid === groupCaptionRowObject.uid;
            });
            this.updateLazyLoadGroupAggregatesCell(updatedGroupCaptionData, groupFooterRowObject, groupFooterTemplates);
        }
    };
    Group.prototype.updateLazyLoadGroupAggregatesCell = function(updatedGroupCaptionData, captionFooterRowObject, captionFooterTemplates) {
        var prevCaptionFooterData = captionFooterRowObject.data;
        var updatedGroupCaptionDataAggregates = updatedGroupCaptionData.aggregates;
        if (captionFooterRowObject.isCaptionRow) prevCaptionFooterData.aggregates = updatedGroupCaptionDataAggregates;
        for(var i = 0; i < captionFooterTemplates.length; i++){
            var template = captionFooterTemplates[parseInt(i.toString(), 10)];
            var key = template.field + " - " + template.type;
            var fieldData = prevCaptionFooterData[template.field];
            fieldData["" + key] = updatedGroupCaptionDataAggregates["" + key];
            fieldData[(0, $748c2240e597a9b7$export$d07f57595c356899)(template.type)] = updatedGroupCaptionDataAggregates["" + key];
            if (fieldData[template.type]) fieldData[template.type] = updatedGroupCaptionDataAggregates["" + key];
        }
    };
    Group.prototype.getGroupCaptionRowObject = function(element, groupCaptionIndex) {
        var gObj = this.parent;
        var uid = element.getAttribute("data-uid");
        var parentCaptionRowObject = gObj.getRowObjectFromUID(uid);
        for(var i = 0; i < groupCaptionIndex; i++)parentCaptionRowObject = gObj.getRowObjectFromUID(parentCaptionRowObject.parentUid);
        return parentCaptionRowObject;
    };
    /**
     * @param { boolean } groupCaptionTemplate - Defines template either group caption or footer
     * @returns { Object[] } - Returns template array
     * @hidden
     */ Group.prototype.getGroupAggregateTemplates = function(groupCaptionTemplate) {
        var aggregates = [];
        var aggregateRows = this.parent.aggregates;
        for(var j = 0; j < aggregateRows.length; j++){
            var row = aggregateRows[parseInt(j.toString(), 10)];
            for(var k = 0; k < row.columns.length; k++)if (groupCaptionTemplate && row.columns[parseInt(k.toString(), 10)].groupCaptionTemplate || !groupCaptionTemplate && row.columns[parseInt(k.toString(), 10)].groupFooterTemplate) {
                var aggr = {};
                var type = row.columns[parseInt(k.toString(), 10)].type.toString();
                aggr = {
                    type: type.toLowerCase(),
                    field: row.columns[parseInt(k.toString(), 10)].field
                };
                aggregates.push(aggr);
            }
        }
        return aggregates;
    };
    /**
     * @param { Row<Column> } fromRowObj - Defines group key changed Data row object.
     * @param { Row<Column> } toRowObj - Defines group key setting reference Data row object.
     * @returns { void }
     * @hidden
     */ Group.prototype.groupedRowReorder = function(fromRowObj, toRowObj) {
        var dragRow = this.parent.getRowElementByUID(fromRowObj.uid);
        var dropRow = this.parent.getRowElementByUID(toRowObj.uid);
        var dropArgs = {
            rows: [
                dragRow
            ],
            target: dropRow,
            fromIndex: fromRowObj.index,
            dropIndex: toRowObj.index
        };
        if (!(0, $3EnZW.isNullOrUndefined)(fromRowObj) && !(0, $3EnZW.isNullOrUndefined)(toRowObj) && fromRowObj.parentUid !== toRowObj.parentUid) {
            if (dropRow) {
                if (dropRow["style"].display === "none") dragRow["style"].display = "none";
                if (dropArgs.fromIndex > dropArgs.dropIndex) this.parent.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).insertBefore(dragRow, dropRow);
                else this.parent.getContentTable().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).insertBefore(dragRow, dropRow.nextSibling);
            } else (0, $4ZDHT.remove)(dragRow);
            this.groupReorderHandler(fromRowObj, toRowObj);
            var tr = [].slice.call(this.parent.getContentTable().getElementsByClassName($1b5568e76cdae6d4$export$120ff0929b202a6d));
            (0, $748c2240e597a9b7$export$5f6b78a41ee2e2e8)(this.parent, dropArgs, tr, toRowObj);
            if (this.parent.enableVirtualization) (0, $748c2240e597a9b7$export$34d0271fbe106b75)(this.parent);
            else (0, $748c2240e597a9b7$export$ba639a32ffcf7814)(this.parent, this.parent.getRowsObject().filter(function(data) {
                return data.isDataRow;
            }), tr);
            this.parent.notify($17b89d3b1fc93cdb$export$c70b4b413518c03b, {
                rows: this.parent.getRowsObject()
            });
        }
    };
    Group.prototype.groupReorderHandler = function(dragRowObject, dropRowObject) {
        var gObj = this.parent;
        var dragRowObjectData = dragRowObject.data;
        var dropRowObjectData = dropRowObject.data;
        var groupAggregateTemplate = gObj["groupModule"].getGroupAggregateTemplates(false);
        var dropParentRowObject = gObj.getRowObjectFromUID(dropRowObject.parentUid);
        var dragParentRowObject = gObj.getRowObjectFromUID(dragRowObject.parentUid);
        var dropRootParentRowObjects = [
            dropParentRowObject
        ];
        var dragRootParentRowObjects = [
            dragParentRowObject
        ];
        var groupColumns = gObj.groupSettings.columns;
        for(var j = 0; j < groupColumns.length; j++){
            dragRowObjectData[groupColumns[parseInt(j.toString(), 10)]] = dropRowObjectData[groupColumns[parseInt(j.toString(), 10)]];
            if (j > 0) {
                dropRootParentRowObjects.push(gObj.getRowObjectFromUID(dropRootParentRowObjects[j - 1].parentUid));
                dragRootParentRowObjects.push(gObj.getRowObjectFromUID(dragRootParentRowObjects[j - 1].parentUid));
            }
        }
        dragRowObject.parentUid = dropRowObject.parentUid;
        dragRowObject.visible = dropRowObject.visible;
        dragRowObject["parentGid"] = dropRowObject["parentGid"];
        if (dragRowObject.changes !== dragRowObjectData) dragRowObject.changes = dragRowObjectData;
        var updatedCurrentViewData = this.iterateGroupAggregates([
            {
                dragRowObjects: dragRootParentRowObjects,
                dropRowObjects: dropRootParentRowObjects
            }
        ]);
        var updatedDragCurrentViewData = updatedCurrentViewData.filter(function(object) {
            return object["key"] === dragRootParentRowObjects[dragRootParentRowObjects.length - 1].data["key"] || object["key"] instanceof Date && object["key"].toString() === dragRootParentRowObjects[dragRootParentRowObjects.length - 1].data["key"].toString();
        });
        var updatedDropCurrentViewData = updatedCurrentViewData.filter(function(object) {
            return object["key"] === dropRootParentRowObjects[dropRootParentRowObjects.length - 1].data["key"] || object["key"] instanceof Date && object["key"].toString() === dropRootParentRowObjects[dropRootParentRowObjects.length - 1].data["key"].toString();
        });
        updatedCurrentViewData = [];
        if (!(0, $3EnZW.isNullOrUndefined)(updatedDragCurrentViewData[0])) updatedCurrentViewData.push(updatedDragCurrentViewData[0]);
        if (!(0, $3EnZW.isNullOrUndefined)(updatedDropCurrentViewData[0])) updatedCurrentViewData.push(updatedDropCurrentViewData[0]);
        var currentViewData = gObj.currentViewData;
        for(var i = 0; i < currentViewData.length; i++){
            if ((0, $3EnZW.isNullOrUndefined)(updatedDragCurrentViewData[0]) && currentViewData[parseInt(i.toString(), 10)]["key"] === dragRootParentRowObjects[dragRootParentRowObjects.length - 1].data["key"]) {
                currentViewData.splice(i, 1);
                i--;
            } else if ((0, $3EnZW.isNullOrUndefined)(updatedDropCurrentViewData[0]) && currentViewData[parseInt(i.toString(), 10)]["key"] === dropRootParentRowObjects[dropRootParentRowObjects.length - 1].data["key"]) {
                currentViewData.splice(i, 1);
                i--;
            } else if (!(0, $3EnZW.isNullOrUndefined)(updatedDragCurrentViewData[0]) && currentViewData[parseInt(i.toString(), 10)]["key"] === updatedDragCurrentViewData[0]["key"]) currentViewData[parseInt(i.toString(), 10)] = updatedDragCurrentViewData[0];
            else if (!(0, $3EnZW.isNullOrUndefined)(updatedDropCurrentViewData[0]) && currentViewData[parseInt(i.toString(), 10)]["key"] === updatedDropCurrentViewData[0]["key"]) currentViewData[parseInt(i.toString(), 10)] = updatedDropCurrentViewData[0];
        }
        var updatedRowObject = this.groupGenerator.generateRows(updatedCurrentViewData, {});
        var dragRootParentAggregateRowObject = [];
        var dropRootParentAggregateRowObject = [];
        for(var i = 0; i < dragRootParentRowObjects.length; i++)dragRootParentAggregateRowObject.push.apply(dragRootParentAggregateRowObject, this.getGroupParentFooterAggregateRowObject(dragRootParentRowObjects[parseInt(i.toString(), 10)].uid));
        for(var i = 0; i < dropRootParentRowObjects.length; i++)dropRootParentAggregateRowObject.push.apply(dropRootParentAggregateRowObject, this.getGroupParentFooterAggregateRowObject(dropRootParentRowObjects[parseInt(i.toString(), 10)].uid));
        dragRootParentRowObjects.push.apply(dragRootParentRowObjects, dragRootParentAggregateRowObject);
        dropRootParentRowObjects.push.apply(dropRootParentRowObjects, dropRootParentAggregateRowObject);
        this.updatedRowObjChange(dragRootParentRowObjects, updatedRowObject, groupAggregateTemplate, true);
        this.updatedRowObjChange(dropRootParentRowObjects, updatedRowObject, groupAggregateTemplate);
        this.groupReorderRefreshHandler(dragRootParentRowObjects);
        this.groupReorderRefreshHandler(dropRootParentRowObjects);
    };
    Group.prototype.updatedRowObjChange = function(rootParentRowObjects, updatedRowObjects, groupAggregateTemplate, isDraggedRow) {
        var gObj = this.parent;
        var rowObjects = gObj.getRowsObject();
        var cache = {};
        var virtualCacheRowObjects = [];
        if (gObj.enableVirtualization) {
            cache = gObj.contentModule["vgenerator"].cache;
            virtualCacheRowObjects = gObj.vcRows;
        }
        for(var i = 0; i < rootParentRowObjects.length; i++){
            var keyPresent = false;
            var parentRowObject = rootParentRowObjects[parseInt(i.toString(), 10)];
            for(var j = 0; j < updatedRowObjects.length; j++){
                var updatedRowObject = updatedRowObjects[parseInt(j.toString(), 10)];
                if (!(0, $3EnZW.isNullOrUndefined)(updatedRowObject) && !(0, $3EnZW.isNullOrUndefined)(parentRowObject.data["key"]) && !(0, $3EnZW.isNullOrUndefined)(updatedRowObject.data["key"]) && (parentRowObject.data["key"] === updatedRowObject.data["key"] || parentRowObject.data["key"] instanceof Date && parentRowObject.data["key"].toString() === updatedRowObject.data["key"].toString())) {
                    var isParentKeyPresent = true;
                    var nextParentObject = rootParentRowObjects[parseInt((i + 1).toString(), 10)];
                    if (isDraggedRow && nextParentObject && !nextParentObject.isAggregateRow) {
                        var key = nextParentObject.data["key"].toString();
                        var field = nextParentObject.data["field"];
                        var groupedData = updatedRowObject.data["items"].records ? updatedRowObject.data["items"].records : updatedRowObject.data["items"];
                        if (groupedData && groupedData.length && groupedData[0]["" + field] && groupedData[0]["" + field].toString() !== key) isParentKeyPresent = false;
                    }
                    if (!isParentKeyPresent && isDraggedRow) continue;
                    var index = rowObjects.indexOf(parentRowObject);
                    if (index !== -1) {
                        rowObjects[parseInt(index.toString(), 10)].data = updatedRowObject.data;
                        rowObjects[parseInt(index.toString(), 10)]["gSummary"] = updatedRowObject["gSummary"];
                    }
                    if (gObj.enableVirtualization) {
                        var vIndex = virtualCacheRowObjects.indexOf(parentRowObject);
                        if (vIndex !== -1) {
                            virtualCacheRowObjects[parseInt(vIndex.toString(), 10)].data = updatedRowObject.data;
                            virtualCacheRowObjects[parseInt(vIndex.toString(), 10)]["gSummary"] = updatedRowObject["gSummary"];
                        }
                    }
                    parentRowObject.data = updatedRowObject.data;
                    parentRowObject["gSummary"] = [
                        "gSummary"
                    ];
                    updatedRowObjects.splice(j, 1);
                    j--;
                    keyPresent = true;
                    break;
                } else if (parentRowObject.isAggregateRow && updatedRowObject.isAggregateRow) {
                    for(var l = 0; l < groupAggregateTemplate.length; l++)if (this.evaluateGroupAggregateValueChange(parentRowObject, updatedRowObject, groupAggregateTemplate[parseInt(l.toString(), 10)])) {
                        var index = rowObjects.indexOf(parentRowObject);
                        if (index !== -1) {
                            rowObjects[parseInt(index.toString(), 10)].data = updatedRowObject.data;
                            rowObjects[parseInt(index.toString(), 10)]["gSummary"] = updatedRowObject["gSummary"];
                        }
                        if (gObj.enableVirtualization) {
                            var vIndex = virtualCacheRowObjects.indexOf(parentRowObject);
                            if (vIndex !== -1) {
                                virtualCacheRowObjects[parseInt(vIndex.toString(), 10)].data = updatedRowObject.data;
                                virtualCacheRowObjects[parseInt(vIndex.toString(), 10)]["gSummary"] = updatedRowObject["gSummary"];
                            }
                        }
                        parentRowObject.data = updatedRowObject.data;
                        parentRowObject["gSummary"] = updatedRowObject["gSummary"];
                        keyPresent = true;
                        break;
                    }
                    if (keyPresent) break;
                }
            }
            if (!keyPresent) {
                var removeElem = gObj.getRowElementByUID(parentRowObject.uid);
                if (!(0, $3EnZW.isNullOrUndefined)(removeElem)) (0, $4ZDHT.remove)(removeElem);
                rowObjects.splice(rowObjects.indexOf(parentRowObject), 1);
                if (gObj.enableVirtualization) {
                    virtualCacheRowObjects.splice(virtualCacheRowObjects.indexOf(parentRowObject), 1);
                    for(var k = 1; k <= Object.keys(cache).length; k++){
                        var vcIndex = cache[parseInt(k.toString(), 10)].indexOf(parentRowObject);
                        if (vcIndex !== -1) cache[parseInt(k.toString(), 10)].splice([
                            parseInt(vcIndex.toString(), 10)
                        ], 1);
                    }
                }
                if (gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings.enableCache) gObj.infiniteScrollModule.resetInfiniteCache(rowObjects);
            }
        }
    };
    Group.prototype.groupReorderRefreshHandler = function(parentRowObjects) {
        var gObj = this.parent;
        var row = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(gObj["serviceLocator"], null, gObj);
        var columns = gObj.getColumns();
        for(var j = 0; j < parentRowObjects.length; j++){
            var rowObject = parentRowObjects[parseInt(j.toString(), 10)];
            if (!(0, $3EnZW.isNullOrUndefined)(rowObject.uid) && !(0, $3EnZW.isNullOrUndefined)(gObj.getRowElementByUID(rowObject.uid))) row.refresh(rowObject, columns, false);
        }
    };
    Group.prototype.getGroupParentFooterAggregateRowObject = function(parentUid) {
        var rowObjects = this.parent.enableInfiniteScrolling && this.parent.infiniteScrollSettings.enableCache && this.parent.groupSettings.columns.length ? this.parent.contentModule["rows"] : this.parent.getRowsObject();
        var parentFooterAggregates = [];
        for(var i = 0; i < rowObjects.length; i++){
            var rowObject = rowObjects[parseInt(i.toString(), 10)];
            if (rowObject.parentUid === parentUid && rowObject.isAggregateRow) parentFooterAggregates.push(rowObject);
        }
        return parentFooterAggregates;
    };
    Group.prototype.evaluateGroupAggregateValueChange = function(rowObjects, updatedRowObject, groupAggregateTemplate) {
        var change = false;
        if (rowObjects.data[groupAggregateTemplate["field"]]["field"] === updatedRowObject.data[groupAggregateTemplate["field"]]["field"] && rowObjects.data[groupAggregateTemplate["field"]]["key"] === updatedRowObject.data[groupAggregateTemplate["field"]]["key"] && rowObjects.data[groupAggregateTemplate["field"]]// eslint-disable-next-line no-prototype-builtins
        .hasOwnProperty(groupAggregateTemplate["field"] + " - " + groupAggregateTemplate["type"]) && updatedRowObject.data[groupAggregateTemplate["field"]]// eslint-disable-next-line no-prototype-builtins
        .hasOwnProperty(groupAggregateTemplate["field"] + " - " + groupAggregateTemplate["type"])) change = true;
        return change;
    };
    Group.prototype.gettingVirtualData = function(parentRowObjs, curViewRec, pK) {
        var datas = [];
        var _loop_2 = function(i) {
            if (curViewRec.indexOf(parentRowObjs[parseInt(i.toString(), 10)].data) === -1) datas.push(parentRowObjs[parseInt(i.toString(), 10)].data);
            if (parentRowObjs[parseInt(i.toString(), 10)].data["field"] === this_2.parent.groupSettings.columns[0]) {
                var draggedData_1 = parentRowObjs[parseInt(i.toString(), 10)].data["items"];
                if (!(0, $3EnZW.isNullOrUndefined)(draggedData_1["records"])) draggedData_1 = draggedData_1["records"];
                var _loop_3 = function(j) {
                    if (pK && curViewRec.findIndex(function(data) {
                        return data[pK.toString()] === draggedData_1[parseInt(j.toString(), 10)][pK.toString()];
                    }) === -1) datas.push(draggedData_1[parseInt(j.toString(), 10)]);
                };
                for(var j = 0; j < draggedData_1.length; j++)_loop_3(j);
            }
        };
        var this_2 = this;
        for(var i = 0; i < parentRowObjs.length; i++)_loop_2(i);
        return datas;
    };
    Group.prototype.iterateGroupAggregates = function(editedData) {
        var _this = this;
        var updatedData = editedData instanceof Array ? editedData : [];
        var rows = this.parent.getRowsObject();
        var initData = this.parent.getCurrentViewRecords().slice();
        var field = this.parent.getPrimaryKeyFieldNames()[0];
        var dragParentRowObjects = editedData && editedData.length ? editedData[0] && editedData[0]["dragRowObjects"] : null;
        var dropParentRowObjects = editedData && editedData.length ? editedData[0] && editedData[0]["dropRowObjects"] : null;
        var dropRootKey = null;
        var dragRootKey = null;
        if (this.parent.enableVirtualization && this.parent.allowGrouping && this.parent.groupSettings.columns.length && (!(0, $3EnZW.isNullOrUndefined)(dragParentRowObjects) || !(0, $3EnZW.isNullOrUndefined)(dropParentRowObjects))) {
            if (dragParentRowObjects) initData.push.apply(initData, this.gettingVirtualData(dragParentRowObjects, initData, field));
            if (dropParentRowObjects) initData.push.apply(initData, this.gettingVirtualData(dropParentRowObjects, initData, field));
        }
        var isInfiniteGroup = this.parent.enableInfiniteScrolling && this.parent.allowGrouping && editedData.length && this.parent.groupSettings.columns.length && !(0, $3EnZW.isNullOrUndefined)(dragParentRowObjects) && !(0, $3EnZW.isNullOrUndefined)(dropParentRowObjects);
        if (isInfiniteGroup) {
            initData = [];
            dropRootKey = dropParentRowObjects[dropParentRowObjects.length - 1].data["key"];
            dragRootKey = dragParentRowObjects[dragParentRowObjects.length - 1].data["key"];
            this.parent.getRowsObject().map(function(row) {
                var groupKey = row.data[_this.parent.groupSettings.columns[0]];
                if (row.isDataRow && (groupKey === dropRootKey || groupKey === dragRootKey || groupKey instanceof Date && (groupKey.toString() === dropRootKey.toString() || groupKey.toString() === dragRootKey.toString()))) initData.push(row.data);
            });
        }
        var deletedCols = [];
        var changeds = rows.map(function(row) {
            if (row.edit === "delete") deletedCols.push(row.data);
            return row.changes instanceof Object ? row.changes : row.data;
        });
        changeds = updatedData.length === 0 ? changeds : updatedData;
        var mergeData = initData.map(function(item) {
            var pKeyVal = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(field, item);
            var value;
            var hasVal = changeds.some(function(cItem) {
                value = cItem;
                return pKeyVal === (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).getObject(field, cItem);
            });
            return hasVal ? value : item;
        });
        var eData = editedData;
        if (!(eData.type && eData.type === "cancel") && deletedCols.length > 0) for(var i = 0; i < deletedCols.length; i++){
            var index = mergeData.indexOf(deletedCols[parseInt(i.toString(), 10)]);
            mergeData.splice(index, 1);
        }
        var aggregates = [];
        var aggregateRows = this.parent.aggregates;
        for(var j = 0; j < aggregateRows.length; j++){
            var row = aggregateRows[parseInt(j.toString(), 10)];
            for(var k = 0; k < row.columns.length; k++){
                var aggr = {};
                var type = row.columns[parseInt(k.toString(), 10)].type.toString();
                var types = type.split(",").map(function(t) {
                    return t.trim();
                });
                for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
                    var aggregateType = types_1[_i];
                    aggr = {
                        type: aggregateType.toLowerCase(),
                        field: row.columns[parseInt(k.toString(), 10)].field
                    };
                    aggregates.push(aggr);
                }
            }
        }
        var result;
        var aggrds;
        var groupedCols = this.parent.groupSettings.columns;
        for(var l = 0; l < groupedCols.length; l++){
            aggrds = result ? result : mergeData;
            result = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).group(aggrds, groupedCols[parseInt(l.toString(), 10)], aggregates, null, null);
        }
        if (isInfiniteGroup) {
            var lastGroupKey = this.parent.currentViewData[this.parent.currentViewData.length - 1]["key"];
            if (lastGroupKey instanceof Date && (lastGroupKey.toString() === dropRootKey.toString() || lastGroupKey.toString() === dragRootKey.toString()) || lastGroupKey === dropRootKey || lastGroupKey === dragRootKey) {
                var groups_1 = [];
                for(var i = 0; i < result.length; i++)groups_1.push(result[parseInt(i.toString(), 10)]);
                var predicate_1 = [];
                var addWhere = function(input) {
                    for(var i = 0; i < groups_1.length; i++)predicate_1.push(new (0, $56262f229d1cff45$export$7ce636318c5a9f17)("field", "==", groups_1[parseInt(i.toString(), 10)].field).and(_this.parent.renderModule.getPredicate("key", "equal", groups_1[parseInt(i.toString(), 10)].key)));
                    input.where((0, $56262f229d1cff45$export$7ce636318c5a9f17).or(predicate_1));
                };
                var newQuery = this.parent.getDataModule().generateQuery(true);
                addWhere(newQuery);
                var updatedGroupData = this.parent.getDataModule().dataManager.executeLocal(newQuery);
                this.parent.renderModule.updateGroupInfo(result, updatedGroupData);
            }
        }
        return result;
    };
    Group.prototype.updateExpand = function(args) {
        var uid = args.uid;
        var isExpand = args.isExpand;
        var rows = this.parent.getRowsObject();
        for(var i = 0; i < rows.length; i++){
            var row = rows[parseInt(i.toString(), 10)];
            if (row.uid === uid || (0, $3EnZW.isNullOrUndefined)(uid)) {
                row.isExpand = isExpand;
                var _loop_4 = function(j) {
                    var childRow = rows[parseInt(j.toString(), 10)];
                    var closestParent = void 0;
                    if (childRow.parentUid !== row.uid) closestParent = rows.filter(function(x) {
                        return x.uid === childRow.parentUid;
                    })[0];
                    if (childRow.parentUid === row.uid) childRow.visible = row.isExpand;
                    else if (!(0, $3EnZW.isNullOrUndefined)(closestParent) && childRow.parentUid === closestParent.uid) {
                        if (closestParent.isExpand && closestParent.visible === true) childRow.visible = true;
                        else if (closestParent.isExpand && closestParent.visible === false) childRow.visible = false;
                    }
                    if ((0, $3EnZW.isNullOrUndefined)(uid)) return "break";
                };
                for(var j = i + 1; j < rows.length; j++){
                    var state_2 = _loop_4(j);
                    if (state_2 === "break") break;
                }
            }
        }
        this.parent.notify($17b89d3b1fc93cdb$export$f44d9209b353bf3e, {
            rows: rows,
            args: {
                isFrozen: false,
                rows: rows
            }
        });
    };
    return Group;
}();




/**
 * ImageDecoder class
 */ /**
 * ByteArray class
 * Used to keep information about image stream as byte array.
 * @private
 */ var $72b64e0afda10076$export$a963f15d59b126e1 = /** @class */ function() {
    /**
     * Initialize the new instance for `byte-array` class
     * @hidden
     * @private
     */ function ByteArray(length) {
        /**
         * Current stream `position`.
         * @default 0
         * @private
         */ this.mPosition = 0;
        this.buffer = new Uint8Array(length);
        this.dataView = new DataView(this.buffer.buffer);
    }
    Object.defineProperty(ByteArray.prototype, "position", {
        /**
         * Gets and Sets a current `position` of byte array.
         * @hidden
         * @private
         */ get: function() {
            return this.mPosition;
        },
        set: function(value) {
            this.mPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Read` from current stream position.
     * @default 0
     * @hidden
     * @private
     */ ByteArray.prototype.read = function(buffer, offset, count) {
        for(var index = offset; index < count; index++){
            var position = this.position;
            buffer.buffer[index] = this.readByte(position);
            this.position++;
        }
    };
    /**
     * @hidden
     */ ByteArray.prototype.getBuffer = function(index) {
        return this.buffer[index];
    };
    /**
     * @hidden
     */ ByteArray.prototype.writeFromBase64String = function(base64) {
        var arr = this.encodedString(base64);
        this.buffer = arr;
    };
    /**
     * @hidden
     */ ByteArray.prototype.encodedString = function(input) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var chr1;
        var chr2;
        var chr3;
        var enc1;
        var enc2;
        var enc3;
        var enc4;
        var i = 0;
        var resultIndex = 0;
        var dataUrlPrefix = "data:";
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        var totalLength = input.length * 3 / 4;
        if (input.charAt(input.length - 1) === keyStr.charAt(64)) totalLength--;
        var output = new Uint8Array(totalLength | 0);
        while(i < input.length){
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output[resultIndex++] = chr1;
            output[resultIndex++] = chr2;
            output[resultIndex++] = chr3;
        }
        return output;
    };
    /**
     * @hidden
     */ ByteArray.prototype.readByte = function(offset) {
        return this.buffer[offset];
    };
    Object.defineProperty(ByteArray.prototype, "internalBuffer", {
        /**
         * @hidden
         */ get: function() {
            return this.buffer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ByteArray.prototype, "count", {
        /**
         * @hidden
         */ get: function() {
            return this.buffer.byteLength;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 'readNextTwoBytes' stream
     * @hidden
     * @private
     */ ByteArray.prototype.readNextTwoBytes = function(stream) {
        var data = stream.readByte(this.position);
        this.position++;
        data <<= 8;
        data |= stream.readByte(this.position);
        this.position++;
        return data;
    };
    return ByteArray;
}();


/**
 * Dictionary.ts class for EJ2-PDF
 * @private
 * @hidden
 */ /**
 * @private
 * @hidden
 */ function $54554df5d21f247f$export$ae78f4343db4f3a1(item) {
    // if (item === null) {
    //     return 'COLLECTION_NULL';
    // } else if (typeof item === 'undefined') {
    //     return 'COLLECTION_UNDEFINED';
    // } else if (Object.prototype.toString.call(item) === '[object String]') {
    if (Object.prototype.toString.call(item) === "[object String]") return "$s" + item;
    else return "$o" + item.toString();
}


/**
 * @private
 * @hidden
 */ var $19695c1d6738aaeb$export$4ee70ab773570fb9 = /** @class */ function() {
    /**
     * @private
     * @hidden
     */ function Dictionary(toStringFunction) {
        this.table = {};
        this.nElements = 0;
        this.toStr = toStringFunction || (0, $54554df5d21f247f$export$ae78f4343db4f3a1);
    }
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.getValue = function(key) {
        var pair = this.table["$" + this.toStr(key)];
        if (typeof pair === "undefined") return undefined;
        return pair.value;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.setValue = function(key, value) {
        // if (typeof key === 'undefined' || typeof value === 'undefined') {
        //     return undefined;
        // }
        var ret;
        var k = "$" + this.toStr(key);
        var previousElement = this.table[k];
        // if (typeof previousElement === 'undefined') {
        this.nElements++;
        ret = undefined;
        // }
        this.table[k] = {
            key: key,
            value: value
        };
        return ret;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.remove = function(key) {
        var k = "$" + this.toStr(key);
        var previousElement = this.table[k];
        // if (typeof previousElement !== 'undefined') {
        delete this.table[k];
        this.nElements--;
        return previousElement.value;
    // }
    // return undefined;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.keys = function() {
        var keysArray = [];
        var namesOfKeys = Object.keys(this.table);
        for(var index1 = 0; index1 < namesOfKeys.length; index1++){
            // if (Object.prototype.hasOwnProperty.call(this.table, namesOfKeys[index1])) {
            var pair1 = this.table[namesOfKeys[index1]];
            keysArray.push(pair1.key);
        // }
        }
        return keysArray;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.values = function() {
        var valuesArray = [];
        var namesOfValues = Object.keys(this.table);
        for(var index2 = 0; index2 < namesOfValues.length; index2++){
            // if (Object.prototype.hasOwnProperty.call(this.table, namesOfValues[index2])) {
            var pair2 = this.table[namesOfValues[index2]];
            valuesArray.push(pair2.value);
        // }
        }
        return valuesArray;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.containsKey = function(key) {
        var retutnValue = true;
        if (typeof this.getValue(key) === "undefined") retutnValue = true;
        else retutnValue = false;
        return !retutnValue;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.clear = function() {
        this.table = {};
        this.nElements = 0;
    };
    /**
     * @private
     * @hidden
     */ Dictionary.prototype.size = function() {
        return this.nElements;
    };
    return Dictionary;
}(); // End of dictionary


/**
 * `PdfName` class is used to perform name (element names) related primitive operations.
 * @private
 */ var $93a92e6ea67161be$export$b440601b3bfe4454 = /** @class */ function() {
    function PdfName(value) {
        /**
         * `Start symbol` of the name object.
         * @default /
         * @private
         */ this.stringStartMark = "/";
        /**
         * `Value` of the element.
         * @private
         */ this.internalValue = "";
        /**
         * Indicates if the object is currently in `saving state or not`.
         * @default false
         * @private
         */ this.isSaving6 = false;
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position6 = -1;
        this.internalValue = this.normalizeValue(value);
    }
    Object.defineProperty(PdfName.prototype, "status", {
        //property
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status6;
        },
        set: function(value) {
            this.status6 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfName.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving6;
        },
        set: function(value) {
            this.isSaving6 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfName.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index6;
        },
        set: function(value) {
            this.index6 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfName.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position6;
        },
        set: function(value) {
            this.position6 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfName.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfName.prototype, "value", {
        /**
         * Gets or sets the `value` of the object.
         * @private
         */ get: function() {
            return this.internalValue;
        },
        set: function(value) {
            // if (value !== this.value) {
            var val = value;
            if (value !== null && value.length > 0) {
                // val = (value.substring(0, 1) === this.stringStartMark) ? value.substring(1) : value;
                val = value;
                this.internalValue = this.normalizeValue(val);
            } else this.internalValue = val;
        // }
        },
        enumerable: true,
        configurable: true
    });
    //public methods
    /**
     * `Saves` the name using the specified writer.
     * @private
     */ PdfName.prototype.save = function(writer) {
        // if (writer === null) {
        //     throw new Error('ArgumentNullException : writer');
        // }
        writer.write(this.toString());
    };
    /**
     * Gets `string` representation of the primitive.
     * @private
     */ PdfName.prototype.toString = function() {
        return this.stringStartMark + this.escapeString(this.value);
    };
    /**
     * Creates a `copy of PdfName`.
     * @private
     */ PdfName.prototype.clone = function(crossTable) {
        var newName = new PdfName();
        newName.value = this.internalValue;
        return newName;
    };
    /**
     * Replace some characters with its `escape sequences`.
     * @private
     */ PdfName.prototype.escapeString = function(stringValue) {
        // if (str === null) {
        //     throw new Error('ArgumentNullException : str');
        // }
        // if (str === '') {
        //     return str;
        // }
        var result = "";
        var len = 0;
        for(var i = 0, len_1 = stringValue.length; i < len_1; i++){
            var ch = stringValue[i];
            var index = PdfName.delimiters.indexOf(ch);
            // switch (ch) {
            //     case '\r' :
            //         result = result + '\\r';
            //         break;
            //     case '\n' :
            //         result = result + '\n';
            //         break;
            //     case '(' :
            //     case ')' :
            //     case '\\' :
            //         //result.Append( '\\' ).Append( ch );
            //         result = result + ch;
            //         break;
            //     default :
            //         result = result + ch;
            //         break;
            // }
            result = result + ch;
        }
        return result;
    };
    //methiods
    /**
     * Replace a symbol with its code with the precedence of the `sharp sign`.
     * @private
     */ PdfName.prototype.normalizeValue = function(value, c) {
        // if (typeof c === undefined) {
        //     let str : string = value;
        //     for (let i : number = 0; i < PdfName.replacements.length; i++) {
        //         str = this.normalizeValue(str, c);
        //     }
        //     return str;
        // } else {
        var strFormat = "#{0:X}";
        //return value.replace(c.toString(),String.format(strFormat,c));
        return value;
    // }
    };
    /**
     * PDF `special characters`.
     * @private
     */ PdfName.delimiters = "()<>[]{}/%}";
    /**
     * The symbols that are not allowed in PDF names and `should be replaced`.
     * @private
     */ PdfName.replacements = [
        " ",
        "	",
        "\n",
        "\r"
    ];
    return PdfName;
}();


/**
 * PdfOperators.ts class for EJ2-PDF
 * Class of string PDF common operators.
 * @private
 */ var $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2 = /** @class */ function() {
    /**
     * Create an instance of `PdfOperator` class.
     * @private
     */ function Operators() {
        /**
         * Specifies the value of `test`.
         * @private
         */ this.forTest = "test";
        this.forTest = Operators.obj;
    }
    /**
     * Specifies the value of `obj`.
     * @private
     */ Operators.obj = "obj";
    /**
     * Specifies the value of `endObj`.
     * @private
     */ Operators.endObj = "endobj";
    /**
     * Specifies the value of `R`.
     * @private
     */ Operators.r = "R";
    /**
     * Specifies the value of ` `.
     * @private
     */ Operators.whiteSpace = " ";
    /**
     * Specifies the value of `/`.
     * @private
     */ Operators.slash = "/";
    /**
     * Specifies the value of `\r\n`.
     * @private
     */ Operators.newLine = "\r\n";
    /**
     * Specifies the value of `stream`.
     * @private
     */ Operators.stream = "stream";
    /**
     * Specifies the value of `endStream`.
     * @private
     */ Operators.endStream = "endstream";
    /**
     * Specifies the value of `xref`.
     * @private
     */ Operators.xref = "xref";
    /**
     * Specifies the value of `f`.
     * @private
     */ Operators.f = "f";
    /**
     * Specifies the value of `n`.
     * @private
     */ Operators.n = "n";
    /**
     * Specifies the value of `trailer`.
     * @private
     */ Operators.trailer = "trailer";
    /**
     * Specifies the value of `startxref`.
     * @private
     */ Operators.startxref = "startxref";
    /**
     * Specifies the value of `eof`.
     * @private
     */ Operators.eof = "%%EOF";
    /**
     * Specifies the value of `header`.
     * @private
     */ Operators.header = "%PDF-1.5";
    /**
     * Specifies the value of `beginText`.
     * @private
     */ Operators.beginText = "BT";
    /**
     * Specifies the value of `endText`.
     * @private
     */ Operators.endText = "ET";
    /**
     * Specifies the value of `m`.
     * @private
     */ Operators.beginPath = "m";
    /**
     * Specifies the value of `l`.
     * @private
     */ Operators.appendLineSegment = "l";
    /**
     * Specifies the value of `S`.
     * @private
     */ Operators.stroke = "S";
    /**
     * Specifies the value of `f`.
     * @private
     */ Operators.fill = "f";
    /**
     * Specifies the value of `f*`.
     * @private
     */ Operators.fillEvenOdd = "f*";
    /**
     * Specifies the value of `B`.
     * @private
     */ Operators.fillStroke = "B";
    /**
     * Specifies the value of `B*`.
     * @private
     */ Operators.fillStrokeEvenOdd = "B*";
    /**
     * Specifies the value of `c`.
     * @private
     */ Operators.appendbeziercurve = "c";
    /**
     * Specifies the value of `re`.
     * @private
     */ Operators.appendRectangle = "re";
    /**
     * Specifies the value of `q`.
     * @private
     */ Operators.saveState = "q";
    /**
     * Specifies the value of `Q`.
     * @private
     */ Operators.restoreState = "Q";
    /**
     * Specifies the value of `Do`.
     * @private
     */ Operators.paintXObject = "Do";
    /**
     * Specifies the value of `cm`.
     * @private
     */ Operators.modifyCtm = "cm";
    /**
     * Specifies the value of `Tm`.
     * @private
     */ Operators.modifyTM = "Tm";
    /**
     * Specifies the value of `w`.
     * @private
     */ Operators.setLineWidth = "w";
    /**
     * Specifies the value of `J`.
     * @private
     */ Operators.setLineCapStyle = "J";
    /**
     * Specifies the value of `j`.
     * @private
     */ Operators.setLineJoinStyle = "j";
    /**
     * Specifies the value of `d`.
     * @private
     */ Operators.setDashPattern = "d";
    /**
     * Specifies the value of `i`.
     * @private
     */ Operators.setFlatnessTolerance = "i";
    /**
     * Specifies the value of `h`.
     * @private
     */ Operators.closePath = "h";
    /**
     * Specifies the value of `s`.
     * @private
     */ Operators.closeStrokePath = "s";
    /**
     * Specifies the value of `b`.
     * @private
     */ Operators.closeFillStrokePath = "b";
    /**
     * Specifies the value of `setCharacterSpace`.
     * @private
     */ Operators.setCharacterSpace = "Tc";
    /**
     * Specifies the value of `setWordSpace`.
     * @private
     */ Operators.setWordSpace = "Tw";
    /**
     * Specifies the value of `setHorizontalScaling`.
     * @private
     */ Operators.setHorizontalScaling = "Tz";
    /**
     * Specifies the value of `setTextLeading`.
     * @private
     */ Operators.setTextLeading = "TL";
    /**
     * Specifies the value of `setFont`.
     * @private
     */ Operators.setFont = "Tf";
    /**
     * Specifies the value of `setRenderingMode`.
     * @private
     */ Operators.setRenderingMode = "Tr";
    /**
     * Specifies the value of `setTextRise`.
     * @private
     */ Operators.setTextRise = "Ts";
    /**
     * Specifies the value of `setTextScaling`.
     * @private
     */ Operators.setTextScaling = "Tz";
    /**
     * Specifies the value of `setCoords`.
     * @private
     */ Operators.setCoords = "Td";
    /**
     * Specifies the value of `goToNextLine`.
     * @private
     */ Operators.goToNextLine = "T*";
    /**
     * Specifies the value of `setText`.
     * @private
     */ Operators.setText = "Tj";
    /**
     * Specifies the value of `setTextWithFormatting`.
     * @private
     */ Operators.setTextWithFormatting = "TJ";
    /**
     * Specifies the value of `setTextOnNewLine`.
     * @private
     */ Operators.setTextOnNewLine = "'";
    /**
     * Specifies the value of `selectcolorspaceforstroking`.
     * @private
     */ Operators.selectcolorspaceforstroking = "CS";
    /**
     * Specifies the value of `selectcolorspacefornonstroking`.
     * @private
     */ Operators.selectcolorspacefornonstroking = "cs";
    /**
     * Specifies the value of `setrbgcolorforstroking`.
     * @private
     */ Operators.setrbgcolorforstroking = "RG";
    /**
     * Specifies the value of `setrbgcolorfornonstroking`.
     * @private
     */ Operators.setrbgcolorfornonstroking = "rg";
    /**
     * Specifies the value of `K`.
     * @private
     */ Operators.setcmykcolorforstroking = "K";
    /**
     * Specifies the value of `k`.
     * @private
     */ Operators.setcmykcolorfornonstroking = "k";
    /**
     * Specifies the value of `G`.
     * @private
     */ Operators.setgraycolorforstroking = "G";
    /**
     * Specifies the value of `g`.
     * @private
     */ Operators.setgraycolorfornonstroking = "g";
    /**
     * Specifies the value of `W`.
     * @private
     */ Operators.clipPath = "W";
    /**
     * Specifies the value of `clipPathEvenOdd`.
     * @private
     */ Operators.clipPathEvenOdd = "W*";
    /**
     * Specifies the value of `n`.
     * @private
     */ Operators.endPath = "n";
    /**
     * Specifies the value of `setGraphicsState`.
     * @private
     */ Operators.setGraphicsState = "gs";
    /**
     * Specifies the value of `%`.
     * @private
     */ Operators.comment = "%";
    /**
     * Specifies the value of `*`.
     * @private
     */ Operators.evenOdd = "*";
    /**
     * Specifies the value of `M`.
     * @private
     */ Operators.setMiterLimit = "M";
    /**
     * Same as SC, but also supports Pattern, Separation, DeviceN, and ICCBased color spaces. For non-stroking operations.
     * @public
     */ Operators.setColorAndPattern = "scn";
    /**
     * Same as SC, but also supports Pattern, Separation, DeviceN, and ICCBased color spaces. For stroking.
     */ Operators.setColorAndPatternStroking = "SCN";
    return Operators;
}();


/**
 * dictionaryProperties.ts class for EJ2-PDF
 * PDF dictionary properties.
 * @private
 */ var $06a5c2a1ab6ca508$export$1b5caccf55a43567 = /** @class */ function() {
    /**
     * Initialize an instance for `PdfDictionaryProperties` class.
     * @private
     */ function DictionaryProperties() {
        /**
         * Specifies the value of `Pages`.
         * @private
         */ this.pages = "Pages";
        /**
         * Specifies the value of `Kids`.
         * @private
         */ this.kids = "Kids";
        /**
         * Specifies the value of `Count`.
         * @private
         */ this.count = "Count";
        /**
         * Specifies the value of `Resources`.
         * @private
         */ this.resources = "Resources";
        /**
         * Specifies the value of `Type`.
         * @private
         */ this.type = "Type";
        /**
         * Specifies the value of `Size`.
         * @private
         */ this.size = "Size";
        /**
         * Specifies the value of `MediaBox`.
         * @private
         */ this.mediaBox = "MediaBox";
        /**
         * Specifies the value of `Parent`.
         * @private
         */ this.parent = "Parent";
        /**
         * Specifies the value of `Root`.
         * @private
         */ this.root = "Root";
        /**
         * Specifies the value of `DecodeParms`.
         * @private
         */ this.decodeParms = "DecodeParms";
        /**
         * Specifies the value of `Filter`.
         * @private
         */ this.filter = "Filter";
        /**
         * Specifies the value of `Font`.
         * @private
         */ this.font = "Font";
        /**
         * Specifies the value of `Type1`.
         * @private
         */ this.type1 = "Type1";
        /**
         * Specifies the value of `BaseFont`.
         * @private
         */ this.baseFont = "BaseFont";
        /**
         * Specifies the value of `Encoding`.
         * @private
         */ this.encoding = "Encoding";
        /**
         * Specifies the value of `Subtype`.
         * @private
         */ this.subtype = "Subtype";
        /**
         * Specifies the value of `Contents`.
         * @private
         */ this.contents = "Contents";
        /**
         * Specifies the value of `ProcSet`.
         * @private
         */ this.procset = "ProcSet";
        /**
         * Specifies the value of `ColorSpace`.
         * @private
         */ this.colorSpace = "ColorSpace";
        /**
         * Specifies the value of `ExtGState`.
         * @private
         */ this.extGState = "ExtGState";
        /**
         * Specifies the value of `Pattern`.
         * @private
         */ this.pattern = "Pattern";
        /**
         * Specifies the value of `XObject`.
         * @private
         */ this.xObject = "XObject";
        /**
         * Specifies the value of `Length`.
         * @private
         */ this.length = "Length";
        /**
         * Specifies the value of `Width`.
         * @private
         */ this.width = "Width";
        /**
         * Specifies the value of `Height`.
         * @private
         */ this.height = "Height";
        /**
         * Specifies the value of `BitsPerComponent`.
         * @private
         */ this.bitsPerComponent = "BitsPerComponent";
        /**
         * Specifies the value of `Image`.
         * @private
         */ this.image = "Image";
        /**
         * Specifies the value of `dctdecode`.
         * @private
         */ this.dctdecode = "DCTDecode";
        /**
         * Specifies the value of `Columns`.
         * @private
         */ this.columns = "Columns";
        /**
         * Specifies the value of `BlackIs1`.
         * @private
         */ this.blackIs1 = "BlackIs1";
        /**
         * Specifies the value of `K`.
         * @private
         */ this.k = "K";
        /**
         * Specifies the value of `S`.
         * @private
         */ this.s = "S";
        /**
         * Specifies the value of `Predictor`.
         * @private
         */ this.predictor = "Predictor";
        /**
         * Specifies the value of `DeviceRGB`.
         * @private
         */ this.deviceRgb = "DeviceRGB";
        /**
         * Specifies the value of `Next`.
         * @private
         */ this.next = "Next";
        /**
         * Specifies the value of `Action`.
         * @private
         */ this.action = "Action";
        /**
         * Specifies the value of `Link`.
         * @private
         */ this.link = "Link";
        /**
         *
         * Specifies the value of `A`.
         * @private
         */ this.a = "A";
        /**
         * Specifies the value of `Annot`.
         * @private
         */ this.annot = "Annot";
        /**
         * Specifies the value of `P`.
         * @private
         */ this.p = "P";
        /**
         * Specifies the value of `C`.
         * @private
         */ this.c = "C";
        /**
         * Specifies the value of `Rect`.
         * @private
         */ this.rect = "Rect";
        /**
         * Specifies the value of `URI`.
         * @private
         */ this.uri = "URI";
        /**
         * Specifies the value of `Annots`.
         * @private
         */ this.annots = "Annots";
        /**
         * Specifies the value of `ca`.
         * @private
         */ this.ca = "ca";
        /**
         * Specifies the value of `CA`.
         * @private
         */ this.CA = "CA";
        /**
         * Specifies the value of `XYZ`.
         * @private
         */ this.xyz = "XYZ";
        /**
         * Specifies the value of `Fit`.
         * @private
         */ this.fit = "Fit";
        /**
         * Specifies the value of `Dest`.
         * @private
         */ this.dest = "Dest";
        /**
         * Specifies the value of `BM`.
         * @private
         */ this.BM = "BM";
        /**
         * Specifies the value of `flatedecode`.
         * @private
         */ this.flatedecode = "FlateDecode";
        /**
         * Specifies the value of `Rotate`.
         * @private
         */ this.rotate = "Rotate";
        /**
         * Specifies the value of 'bBox'.
         * @private
         */ this.bBox = "BBox";
        /**
         * Specifies the value of 'form'.
         * @private
         */ this.form = "Form";
        /**
         * Specifies the value of 'w'.
         * @private
         */ this.w = "W";
        /**
         * Specifies the value of 'cIDFontType2'.
         * @private
         */ this.cIDFontType2 = "CIDFontType2";
        /**
         * Specifies the value of 'cIDToGIDMap'.
         * @private
         */ this.cIDToGIDMap = "CIDToGIDMap";
        /**
         * Specifies the value of 'identity'.
         * @private
         */ this.identity = "Identity";
        /**
         * Specifies the value of 'dw'.
         * @private
         */ this.dw = "DW";
        /**
         * Specifies the value of 'fontDescriptor'.
         * @private
         */ this.fontDescriptor = "FontDescriptor";
        /**
         * Specifies the value of 'cIDSystemInfo'.
         * @private
         */ this.cIDSystemInfo = "CIDSystemInfo";
        /**
         * Specifies the value of 'fontName'.
         * @private
         */ this.fontName = "FontName";
        /**
         * Specifies the value of 'flags'.
         * @private
         */ this.flags = "Flags";
        /**
         * Specifies the value of 'fontBBox'.
         * @private
         */ this.fontBBox = "FontBBox";
        /**
         * Specifies the value of 'missingWidth'.
         * @private
         */ this.missingWidth = "MissingWidth";
        /**
         * Specifies the value of 'stemV'.
         * @private
         */ this.stemV = "StemV";
        /**
         * Specifies the value of 'italicAngle'.
         * @private
         */ this.italicAngle = "ItalicAngle";
        /**
         * Specifies the value of 'capHeight'.
         * @private
         */ this.capHeight = "CapHeight";
        /**
         * Specifies the value of 'ascent'.
         * @private
         */ this.ascent = "Ascent";
        /**
         * Specifies the value of 'descent'.
         * @private
         */ this.descent = "Descent";
        /**
         * Specifies the value of 'leading'.
         * @private
         */ this.leading = "Leading";
        /**
         * Specifies the value of 'avgWidth'.
         * @private
         */ this.avgWidth = "AvgWidth";
        /**
         * Specifies the value of 'fontFile2'.
         * @private
         */ this.fontFile2 = "FontFile2";
        /**
         * Specifies the value of 'maxWidth'.
         * @private
         */ this.maxWidth = "MaxWidth";
        /**
         * Specifies the value of 'xHeight'.
         * @private
         */ this.xHeight = "XHeight";
        /**
         * Specifies the value of 'stemH'.
         * @private
         */ this.stemH = "StemH";
        /**
         * Specifies the value of 'registry'.
         * @private
         */ this.registry = "Registry";
        /**
         * Specifies the value of 'ordering'.
         * @private
         */ this.ordering = "Ordering";
        /**
         * Specifies the value of 'supplement'.
         * @private
         */ this.supplement = "Supplement";
        /**
         * Specifies the value of 'type0'.
         * @private
         */ this.type0 = "Type0";
        /**
         * Specifies the value of 'identityH'.
         * @private
         */ this.identityH = "Identity-H";
        /**
         * Specifies the value of 'toUnicode'.
         * @private
         */ this.toUnicode = "ToUnicode";
        /**
         * Specifies the value of 'descendantFonts'.
         * @private
         */ this.descendantFonts = "DescendantFonts";
        /**
         * Specifies the value of 'background'.
         * @private
         */ this.background = "Background";
        /**
         * Specifies the value of 'shading'.
         * @private
         */ this.shading = "Shading";
        /**
         * Specifies the value of 'matrix'.
         * @private
         */ this.matrix = "Matrix";
        /**
         * Specifies the value of 'antiAlias'.
         * @private
         */ this.antiAlias = "AntiAlias";
        /**
         * Specifies the value of 'function'.
         * @private
         */ this.function = "Function";
        /**
         * Specifies the value of 'extend'.
         * @private
         */ this.extend = "Extend";
        /**
         * Specifies the value of 'shadingType'.
         * @private
         */ this.shadingType = "ShadingType";
        /**
         * Specifies the value of 'coords'.
         * @private
         */ this.coords = "Coords";
        /**
         * Specifies the value of 'domain'.
         * @private
         */ this.domain = "Domain";
        /**
         * Specifies the value of 'range'.
         * @private
         */ this.range = "Range";
        /**
         * Specifies the value of 'functionType'.
         * @private
         */ this.functionType = "FunctionType";
        /**
         * Specifies the value of 'bitsPerSample'.
         * @private
         */ this.bitsPerSample = "BitsPerSample";
        /**
         * Specifies the value of 'patternType'.
         * @private
         */ this.patternType = "PatternType";
        /**
         * Specifies the value of 'paintType'.
         * @private
         */ this.paintType = "PaintType";
        /**
         * Specifies the value of 'tilingType'.
         * @private
         */ this.tilingType = "TilingType";
        /**
         * Specifies the value of 'xStep'.
         * @private
         */ this.xStep = "XStep";
        /**
         * Specifies the value of 'yStep'.
         * @private
         */ this.yStep = "YStep";
        /**
         * Specifies the value of viewer preferences.
         * @private
         */ this.viewerPreferences = "ViewerPreferences";
        /**
         * Specifies the value of center window.
         * @private
         */ this.centerWindow = "CenterWindow";
        /**
         * Specifies the value of display title.
         * @private
         */ this.displayTitle = "DisplayTitle";
        /**
         * Specifies the value of fit window.
         * @private
         */ this.fitWindow = "FitWindow";
        /**
         * Specifies the value of hide menu bar.
         * @private
         */ this.hideMenuBar = "HideMenubar";
        /**
         * Specifies the value of hide tool bar.
         * @private
         */ this.hideToolBar = "HideToolbar";
        /**
         * Specifies the value of hide window UI.
         * @private
         */ this.hideWindowUI = "HideWindowUI";
        /**
         * Specifies the value of page mode.
         * @private
         */ this.pageMode = "PageMode";
        /**
         * Specifies the value of page layout.
         * @private
         */ this.pageLayout = "PageLayout";
        /**
         * Specifies the value of duplex.
         * @private
         */ this.duplex = "Duplex";
        /**
         * Specifies the value of print scaling.
         * @private
         */ this.printScaling = "PrintScaling";
    //
    }
    return DictionaryProperties;
}();


/**
 * `PdfDictionary` class is used to perform primitive operations.
 * @private
 */ var $467b51a52206950c$export$f103d8ead0680780 = /** @class */ function() {
    function PdfDictionary(dictionary) {
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position7 = -1;
        /**
         * The `IPdfSavable` with the specified key.
         * @private
         */ this.primitiveItems = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        /**
         * `Start marker` for dictionary.
         * @private
         */ this.prefix = "<<";
        /**
         * `End marker` for dictionary.
         * @private
         */ this.suffix = ">>";
        /**
         * @hidden
         * @private
         */ this.resources = [];
        /**
         * Internal variable to hold `cloned object`.
         * @default null
         * @private
         */ this.object = null;
        /**
         * Flag for PDF file formar 1.5 is dictionary `archiving` needed.
         * @default true
         * @private
         */ this.archive = true;
        /**
         * Represents the Font dictionary.
         * @hidden
         * @private
         */ this.isResource = false;
        if (typeof dictionary === "undefined") {
            this.primitiveItems = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            this.encrypt = true;
            this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        } else {
            this.primitiveItems = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            var keys = dictionary.items.keys();
            var values = dictionary.items.values();
            for(var index = 0; index < dictionary.items.size(); index++)this.primitiveItems.setValue(keys[index], values[index]);
            this.status = dictionary.status;
            this.freezeChanges(this);
            this.encrypt = true;
            this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        }
    }
    Object.defineProperty(PdfDictionary.prototype, "items", {
        //Properties
        /**
         * Gets or sets the `IPdfSavable` with the specified key.
         * @private
         */ get: function() {
            return this.primitiveItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "status", {
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status7;
        },
        set: function(value) {
            this.status7 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving7;
        },
        set: function(value) {
            this.isSaving7 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index7;
        },
        set: function(value) {
            this.index7 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            return this.object;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position7;
        },
        set: function(value) {
            this.position7 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "Count", {
        /**
         * Gets the `count`.
         * @private
         */ get: function() {
            return this.primitiveItems.size();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDictionary.prototype, "Dictionary", {
        /**
         * Collection of `items` in the object.
         * @private
         */ get: function() {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get flag if need to `archive` dictionary.
     * @private
     */ PdfDictionary.prototype.getArchive = function() {
        return this.archive;
    };
    /**
     * Set flag if need to `archive` dictionary.
     * @private
     */ PdfDictionary.prototype.setArchive = function(value) {
        this.archive = value;
    };
    /**
     * Sets flag if `encryption` is needed.
     * @private
     */ PdfDictionary.prototype.setEncrypt = function(value) {
        this.encrypt = value;
        this.modify();
    };
    /**
     * Gets flag if `encryption` is needed.
     * @private
     */ PdfDictionary.prototype.getEncrypt = function() {
        return this.encrypt;
    };
    /**
     * `Freezes` the changes.
     * @private
     */ PdfDictionary.prototype.freezeChanges = function(freezer) {
        this.bChanged = false;
    };
    /**
     * Creates a `copy of PdfDictionary`.
     * @private
     */ PdfDictionary.prototype.clone = function(crossTable) {
        //Need to add more codings
        var newDict = new PdfDictionary();
        return newDict;
    };
    /**
     * `Mark` this instance modified.
     * @private
     */ PdfDictionary.prototype.modify = function() {
        this.bChanged = true;
    };
    /**
     * `Removes` the specified key.
     * @private
     */ PdfDictionary.prototype.remove = function(key) {
        if (typeof key !== "string") {
            this.primitiveItems.remove(key.value);
            this.modify();
        } else this.remove(new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(key));
    };
    /**
     * `Determines` whether the dictionary contains the key.
     * @private
     */ PdfDictionary.prototype.containsKey = function(key) {
        var returnValue = false;
        returnValue = this.primitiveItems.containsKey(key.toString());
        return returnValue;
    };
    /**
     * Raises event `BeginSave`.
     * @private
     */ PdfDictionary.prototype.onBeginSave = function() {
        this.beginSave.sender.beginSave();
    };
    /**
     * Raises event `Font Dictionary BeginSave`.
     * @private
     */ PdfDictionary.prototype.onFontDictionaryBeginSave = function() {
        this.fontDictionaryBeginSave.sender.fontDictionaryBeginSave();
    };
    /**
     * Raises event `Descendant Font BeginSave`.
     * @private
     */ PdfDictionary.prototype.onDescendantFontBeginSave = function() {
        this.descendantFontBeginSave.sender.descendantFontBeginSave();
    };
    /**
     * Raises event 'BeginSave'.
     * @private
     */ PdfDictionary.prototype.onTemplateBeginSave = function() {
        this.pageBeginDrawTemplate.sender.pageBeginSave();
    };
    /**
     * Raises event `BeginSave`.
     * @private
     */ PdfDictionary.prototype.onBeginAnnotationSave = function() {
        this.annotationBeginSave.sender.beginSave();
    };
    /**
     * Raises event `BeginSave`.
     * @private
     */ PdfDictionary.prototype.onSectionBeginSave = function(writer) {
        var saveEvent = this.sectionBeginSave;
        saveEvent.sender.beginSave(saveEvent.state, writer);
    };
    PdfDictionary.prototype.save = function(writer, bRaiseEvent) {
        if (typeof bRaiseEvent === "undefined") this.save(writer, true);
        else {
            writer.write(this.prefix);
            if (typeof this.beginSave !== "undefined") this.onBeginSave();
            if (typeof this.descendantFontBeginSave !== "undefined") this.onDescendantFontBeginSave();
            if (typeof this.fontDictionaryBeginSave !== "undefined") this.onFontDictionaryBeginSave();
            if (typeof this.annotationBeginSave !== "undefined") this.onBeginAnnotationSave();
            if (typeof this.sectionBeginSave !== "undefined") this.onSectionBeginSave(writer);
            if (typeof this.pageBeginDrawTemplate !== "undefined") this.onTemplateBeginSave();
            // }
            if (this.Count > 0) this.saveItems(writer);
            writer.write(this.suffix);
            writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        }
    };
    /**
     * `Save dictionary items`.
     * @private
     */ PdfDictionary.prototype.saveItems = function(writer) {
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        var keys = this.primitiveItems.keys();
        var values = this.primitiveItems.values();
        for(var index = 0; index < keys.length; index++){
            var key = keys[index];
            var name_1 = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(key);
            name_1.save(writer);
            writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            var resources = values[index];
            resources.save(writer);
            writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        }
    };
    return PdfDictionary;
}();
var $467b51a52206950c$export$6e00e39d26720792 = /** @class */ function() {
    /**
     * New instance for `save section collection event handler` class.
     * @private
     */ function SaveSectionCollectionEventHandler(sender) {
        this.sender = sender;
    }
    return SaveSectionCollectionEventHandler;
}();
var $467b51a52206950c$export$8958daefdc2ff = /** @class */ function() {
    /**
     * New instance for `save section collection event handler` class.
     * @private
     */ function SaveDescendantFontEventHandler(sender) {
        this.sender = sender;
    }
    return SaveDescendantFontEventHandler;
}();
var $467b51a52206950c$export$b8d69296544a79db = /** @class */ function() {
    /**
     * New instance for `save section collection event handler` class.
     * @private
     */ function SaveFontDictionaryEventHandler(sender) {
        this.sender = sender;
    }
    return SaveFontDictionaryEventHandler;
}();
var $467b51a52206950c$export$6073dc40a48caacd = /** @class */ function() {
    /**
     * New instance for `save annotation event handler` class.
     * @private
     */ function SaveAnnotationEventHandler(sender) {
        this.sender = sender;
    }
    return SaveAnnotationEventHandler;
}();
var $467b51a52206950c$export$ed84ec84144fcf26 = /** @class */ function() {
    // constructors
    /**
     * New instance for `save section event handler` class.
     * @private
     */ function SaveSectionEventHandler(sender, state) {
        this.sender = sender;
        this.state = state;
    }
    return SaveSectionEventHandler;
}();
/**
 * SaveTemplateEventHandler class used to store information about template elements.
 * @private
 * @hidden
 */ var $467b51a52206950c$export$374b0d08b3114f68 = /** @class */ function() {
    /**
     * New instance for save section collection event handler class.
     * @public
     */ function SaveTemplateEventHandler(sender) {
        this.sender = sender;
    }
    return SaveTemplateEventHandler;
}();


/**
 * `PdfNumber` class is used to perform number related primitive operations.
 * @private
 */ var $f982301cdcaba043$export$8883fe148ef336b4 = /** @class */ function() {
    /**
     * Initializes a new instance of the `PdfNumber` class.
     * @private
     */ function PdfNumber(value) {
        /**
         * Sotres the `position`.
         * @default -1
         * @private
         */ this.position5 = -1;
        this.value = value;
    }
    Object.defineProperty(PdfNumber.prototype, "intValue", {
        /**
         * Gets or sets the `integer` value.
         * @private
         */ get: function() {
            return this.value;
        },
        set: function(value) {
            this.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "isInteger", {
        /**
         * Gets or sets a value indicating whether this instance `is integer`.
         * @private
         */ get: function() {
            return this.integer;
        },
        set: function(value) {
            this.integer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "status", {
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status5;
        },
        set: function(value) {
            this.status5 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving5;
        },
        set: function(value) {
            this.isSaving5 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index5;
        },
        set: function(value) {
            this.index5 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position5;
        },
        set: function(value) {
            this.position5 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfNumber.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            var rValue = null;
            return rValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Saves the object`.
     * @private
     */ PdfNumber.prototype.save = function(writer) {
        writer.write(this.intValue.toString()); //tostring(CultureInfo.InletiantCulture)
    };
    /**
     * Creates a `copy of PdfNumber`.
     * @private
     */ PdfNumber.prototype.clone = function(crossTable) {
        var newNumber = new PdfNumber(this.value);
        return newNumber;
    };
    /**
     * Converts a `float value to a string` using Adobe PDF rules.
     * @private
     */ PdfNumber.floatToString = function(number) {
        // let tempString1 : string = number.toString();
        // let tempString2 : string = tempString1.indexOf('.') != -1 ? tempString1.substring(0, tempString1.indexOf('.')) : tempString1;
        var returnString = number.toFixed(2);
        if (returnString === "0.00") returnString = ".00";
        // let prefixLength : number = (22 - tempString2.length) >= 0 ? (22 - tempString2.length) : 0;
        // for (let index : number = 0; index < prefixLength; index++) {
        //     returnString += '0';
        // }
        // returnString += tempString2 + '.00';
        // returnString += (tempString3.length > 6) ? tempString3.substring(0,6) : tempString3;
        // let suffixLength : number = (6 - tempString3.length) >= 0 ? (6 - tempString3.length) : 0;
        // for (let index : number = 0; index < suffixLength; index++) {
        //     returnString += '0';
        // }
        return returnString;
    };
    /**
     * Determines the `minimum of the three values`.
     * @private
     */ PdfNumber.min = function(x, y, z) {
        var r = Math.min(x, y);
        return Math.min(z, r);
    };
    return PdfNumber;
}();






/**
 * `PdfArray` class is used to perform array related primitive operations.
 * @private
 */ var $e627fb2b0c05e4bc$export$348890a1cfbbd0ab = /** @class */ function() {
    function PdfArray(array) {
        //Fields
        /**
         * `startMark` - '['
         * @private
         */ this.startMark = "[";
        /**
         * `endMark` - ']'.
         * @private
         */ this.endMark = "]";
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position9 = -1;
        /**
         * Internal variable to hold `cloned object`.
         * @default null
         * @private
         */ this.clonedObject9 = null;
        /**
         * Represents the Font dictionary.
         * @hidden
         * @private
         */ this.isFont = false;
        if (typeof array === "undefined") this.internalElements = [];
        else if (typeof array !== "undefined" && !(array instanceof PdfArray)) {
            var tempNumberArray = array;
            for(var index = 0; index < tempNumberArray.length; index++){
                var pdfNumber = new (0, $f982301cdcaba043$export$8883fe148ef336b4)(tempNumberArray[index]);
                this.add(pdfNumber);
            }
        // } else if (typeof array !== 'undefined' && (array instanceof PdfArray)) {
        } else {
            var tempArray = array;
            // if (tempArray.Elements.length > 0) {
            this.internalElements = [];
            for(var index = 0; index < tempArray.elements.length; index++)this.internalElements.push(tempArray.elements[index]);
        // }
        }
    }
    //property
    /**
     * Gets the `IPdfSavable` at the specified index.
     * @private
     */ PdfArray.prototype.items = function(index) {
        // if (index < 0 || index >= this.Count) {
        //     throw new Error('ArgumentOutOfRangeException : index, The index can"t be less then zero or greater then Count.');
        // }
        return this.internalElements[index];
    };
    Object.defineProperty(PdfArray.prototype, "count", {
        /**
         * Gets the `count`.
         * @private
         */ get: function() {
            return this.internalElements.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "status", {
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status9;
        },
        set: function(value) {
            this.status9 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving9;
        },
        set: function(value) {
            this.isSaving9 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            return this.clonedObject9;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position9;
        },
        set: function(value) {
            this.position9 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index9;
        },
        set: function(value) {
            this.index9 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "CrossTable", {
        /**
         * Returns `PdfCrossTable` associated with the object.
         * @private
         */ get: function() {
            return this.pdfCrossTable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfArray.prototype, "elements", {
        /**
         * Gets the `elements` of the Pdf Array.
         * @private
         */ get: function() {
            return this.internalElements;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Adds` the specified element to the PDF array.
     * @private
     */ PdfArray.prototype.add = function(element) {
        // if (element === null) {
        //     throw new Error('ArgumentNullException : obj');
        // }
        if (typeof this.internalElements === "undefined") this.internalElements = [];
        this.internalElements.push(element);
        this.markedChange();
    };
    /**
     * `Marks` the object changed.
     * @private
     */ PdfArray.prototype.markedChange = function() {
        this.bChanged = true;
    };
    /**
     * `Determines` whether the specified element is within the array.
     * @private
     */ PdfArray.prototype.contains = function(element) {
        var returnValue = false;
        for(var index = 0; index < this.internalElements.length; index++){
            var tempElement = this.internalElements[index];
            var inputElement = element;
            if (tempElement != null && typeof tempElement !== "undefined" && inputElement != null && typeof inputElement !== "undefined") {
                if (tempElement.value === inputElement.value) return true;
            }
        // if (this.internalElements[index] === element) {
        //     returnValue = true;
        // }
        }
        return returnValue;
    };
    /**
     * Returns the `primitive object` of input index.
     * @private
     */ PdfArray.prototype.getItems = function(index) {
        // if (index < 0 || index >= this.Count) {
        //     throw new Error('ArgumentOutOfRangeException : index , The index can"t be less then zero or greater then Count.');
        // }
        return this.internalElements[index];
    };
    /**
     * `Saves` the object using the specified writer.
     * @private
     */ PdfArray.prototype.save = function(writer) {
        // if (writer === null) {
        //     throw new Error('ArgumentNullException : writer');
        // }
        writer.write(this.startMark);
        for(var i = 0, len = this.count; i < len; i++){
            this.getItems(i).save(writer);
            if (i + 1 !== len) writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        }
        writer.write(this.endMark);
    };
    /**
     * Creates a `copy of PdfArray`.
     * @private
     */ PdfArray.prototype.clone = function(crossTable) {
        // if (this.clonedObject9 !== null && this.clonedObject9.CrossTable === crossTable) {
        //     return this.clonedObject9;
        // } else {
        this.clonedObject9 = null;
        // Else clone the object.
        var newArray = new PdfArray();
        for(var index = 0; index < this.internalElements.length; index++){
            var obj = this.internalElements[index];
            newArray.add(obj.clone(crossTable));
        }
        newArray.pdfCrossTable = crossTable;
        this.clonedObject9 = newArray;
        return newArray;
    };
    /**
     * Creates filled PDF array `from the rectangle`.
     * @private
     */ PdfArray.fromRectangle = function(bounds) {
        var values = [
            bounds.x,
            bounds.y,
            bounds.width,
            bounds.height
        ];
        var array = new PdfArray(values);
        return array;
    };
    // /**
    //  * Creates the rectangle from filled PDF array.
    //  * @private
    //  */
    // public ToRectangle() : RectangleF {
    //     if (this.Count < 4) {
    //         throw Error('InvalidOperationException-Can not convert to rectangle.');
    //     }
    //     let x1 : number;
    //     let x2 : number;
    //     let y1 : number;
    //     let y2 : number;
    //     let num : PdfNumber = this.getItems(0) as PdfNumber;
    //     x1 = num.IntValue;
    //     num = this.getItems(1) as PdfNumber;
    //     y1 = num.IntValue;
    //     num = this.getItems(2) as PdfNumber;
    //     x2 = num.IntValue;
    //     num = this.getItems(3) as PdfNumber;
    //     y2 = num.IntValue;
    //     let x : number = Math.min(x1, x2);
    //     let y : number = Math.min(y1, y2);
    //     let width : number = Math.abs(x1 - x2);
    //     let height : number = Math.abs(y1 - y2);
    //     let rect : RectangleF = new RectangleF(new PointF(x, y), new SizeF(width, height));
    //     return rect;
    // }
    /**
     * `Inserts` the element into the array.
     * @private
     */ PdfArray.prototype.insert = function(index, element) {
        if (index < this.internalElements.length && index > 0) {
            var tempElements = [];
            for(var i = 0; i < index; i++)tempElements.push(this.internalElements[i]);
            tempElements.push(element);
            for(var i = index; i < this.internalElements.length; i++)tempElements.push(this.internalElements[i]);
            this.internalElements = tempElements;
        } else this.internalElements.push(element);
        this.markChanged();
    };
    /**
     * `Checks whether array contains the element`.
     * @private
     */ PdfArray.prototype.indexOf = function(element) {
        return this.internalElements.indexOf(element);
    };
    /**
     * `Removes` element from the array.
     * @private
     */ PdfArray.prototype.remove = function(element) {
        // if (element === null) {
        //     throw new Error('ArgumentNullException : element');
        // }
        var index = this.internalElements.indexOf(element);
        // if (index >= 0 && index < this.internalElements.length) {
        this.internalElements[index] = null;
        // }
        this.markChanged();
    };
    /**
     * `Remove` the element from the array by its index.
     * @private
     */ PdfArray.prototype.removeAt = function(index) {
        // this.internalElements.RemoveAt(index);
        if (this.internalElements.length > index) {
            var tempArray = [];
            for(var i = 0; i < index; i++)tempArray.push(this.internalElements[i]);
            for(var i = index + 1; i < this.internalElements.length; i++)tempArray.push(this.internalElements[i]);
            this.internalElements = tempArray;
        }
        this.markChanged();
    };
    /**
     * `Clear` the array.
     * @private
     */ PdfArray.prototype.clear = function() {
        this.internalElements = [];
        this.markChanged();
    };
    /**
     * `Marks` the object changed.
     * @private
     */ PdfArray.prototype.markChanged = function() {
        this.bChanged = true;
    };
    return PdfArray;
}();








/**
 * `PdfString` class is used to perform string related primitive operations.
 * @private
 */ var $e48c8fcac1e340e6$export$efbe7cbddf4d0360;
(function(InternalEnum) {
    //Internals
    /**
     * public Enum for `ForceEncoding`.
     * @private
     */ var ForceEncoding;
    (function(ForceEncoding) {
        /**
         * Specifies the type of `None`.
         * @private
         */ ForceEncoding[ForceEncoding["None"] = 0] = "None";
        /**
         * Specifies the type of `Ascii`.
         * @private
         */ ForceEncoding[ForceEncoding["Ascii"] = 1] = "Ascii";
        /**
         * Specifies the type of `Unicode`.
         * @private
         */ ForceEncoding[ForceEncoding["Unicode"] = 2] = "Unicode";
    })(ForceEncoding = InternalEnum.ForceEncoding || (InternalEnum.ForceEncoding = {}));
    /**
     * public Enum for `SourceType`.
     * @private
     */ var SourceType;
    (function(SourceType) {
        /**
         * Specifies the type of `StringValue`.
         * @private
         */ SourceType[SourceType["StringValue"] = 0] = "StringValue";
        /**
         * Specifies the type of `ByteBuffer`.
         * @private
         */ SourceType[SourceType["ByteBuffer"] = 1] = "ByteBuffer";
    })(SourceType || (SourceType = {}));
})($e48c8fcac1e340e6$export$efbe7cbddf4d0360 || ($e48c8fcac1e340e6$export$efbe7cbddf4d0360 = {}));
var $e48c8fcac1e340e6$export$46679d7eb18d0b83 = /** @class */ function() {
    function PdfString(value) {
        /**
         * Value indicating whether the string was converted to hex.
         * @default false
         * @private
         */ this.bHex = false;
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position1 = -1;
        /**
         * Internal variable to hold `cloned object`.
         * @default null
         * @private
         */ this.clonedObject1 = null;
        /**
         * `Shows` if the data of the stream was decrypted.
         * @default false
         * @private
         */ this.bDecrypted = false;
        /**
         * Shows if the data of the stream `was decrypted`.
         * @default false
         * @private
         */ this.isParentDecrypted = false;
        /**
         * Gets a value indicating whether the object is `packed or not`.
         * @default false
         * @private
         */ this.isPacked = false;
        /**
         * @hidden
         * @private
         */ this.isFormField = false;
        /**
         * @hidden
         * @private
         */ this.isColorSpace = false;
        /**
         * @hidden
         * @private
         */ this.isHexString = true;
        if (typeof value === "undefined") this.bHex = false;
        else if (!(value.length > 0 && value[0] === "0xfeff")) {
            this.stringValue = value;
            this.data = [];
            for(var i = 0; i < value.length; ++i)this.data.push(value.charCodeAt(i));
        }
    }
    Object.defineProperty(PdfString.prototype, "hex", {
        //Property
        /**
         * Gets a value indicating whether string is in `hex`.
         * @private
         */ get: function() {
            return this.bHex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "value", {
        /**
         * Gets or sets string `value` of the object.
         * @private
         */ get: function() {
            return this.stringValue;
        },
        set: function(value) {
            this.stringValue = value;
            this.data = null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "status", {
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status1;
        },
        set: function(value) {
            this.status1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving1;
        },
        set: function(value) {
            this.isSaving1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index1;
        },
        set: function(value) {
            this.index1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            return this.clonedObject1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position1;
        },
        set: function(value) {
            this.position1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "CrossTable", {
        /**
         * Returns `PdfCrossTable` associated with the object.
         * @private
         */ get: function() {
            return this.crossTable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "converted", {
        /**
         * Gets a value indicating whether to check if the value has unicode characters.
         * @private
         */ get: function() {
            return this.bConverted;
        },
        /**
         * sets a value indicating whether to check if the value has unicode characters.
         * @private
         */ set: function(value) {
            this.bConverted = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfString.prototype, "encode", {
        /**
         * Gets value indicating whether we should convert data to Unicode.
         */ get: function() {
            return this.bForceEncoding;
        },
        set: function(value) {
            this.bForceEncoding = value;
        },
        enumerable: true,
        configurable: true
    });
    //Methods
    /**
     * Converts `bytes to string using hex format` for representing string.
     * @private
     */ PdfString.bytesToHex = function(bytes) {
        if (bytes == null) return "";
        var builder = "";
        return builder;
    };
    /**
     * `Saves` the object using the specified writer.
     * @private
     */ PdfString.prototype.save = function(writer) {
        if (writer === null) throw new Error("ArgumentNullException : writer");
        if (this.encode !== undefined && this.encode === $e48c8fcac1e340e6$export$efbe7cbddf4d0360.ForceEncoding.Ascii) writer.write(this.pdfEncode());
        else writer.write(PdfString.stringMark[0] + this.value + PdfString.stringMark[1]);
    };
    PdfString.prototype.pdfEncode = function() {
        var result = "";
        if (this.encode !== undefined && this.encode === $e48c8fcac1e340e6$export$efbe7cbddf4d0360.ForceEncoding.Ascii) {
            var data = this.escapeSymbols(this.value);
            for(var i = 0; i < data.length; i++)result += String.fromCharCode(data[i]);
            result = PdfString.stringMark[0] + result + PdfString.stringMark[1];
        } else result = this.value;
        return result;
    };
    PdfString.prototype.escapeSymbols = function(value) {
        var data = [];
        for(var i = 0; i < value.length; i++){
            var currentData = value.charCodeAt(i);
            switch(currentData){
                case 40:
                case 41:
                    data.push(92);
                    data.push(currentData);
                    break;
                case 13:
                    data.push(92);
                    data.push(114);
                    break;
                case 92:
                    data.push(92);
                    data.push(currentData);
                    break;
                default:
                    data.push(currentData);
                    break;
            }
        }
        return data;
    };
    /**
     * Creates a `copy of PdfString`.
     * @private
     */ PdfString.prototype.clone = function(crossTable) {
        if (this.clonedObject1 !== null && this.clonedObject1.CrossTable === crossTable) return this.clonedObject1;
        else this.clonedObject1 = null;
        var newString = new PdfString(this.stringValue);
        newString.bHex = this.bHex;
        newString.crossTable = crossTable;
        newString.isColorSpace = this.isColorSpace;
        this.clonedObject1 = newString;
        return newString;
    };
    /**
     * Converts string to array of unicode symbols.
     */ PdfString.toUnicodeArray = function(value, bAddPrefix) {
        if (value == null) throw new Error("Argument Null Exception : value");
        var startIndex = 0;
        var output = [];
        for(var i = 0; i < value.length; i++){
            var code = value.charCodeAt(i);
            output.push(code / 256 >>> 0);
            output.push(code & 0xff);
        }
        return output;
    };
    /**
     * Converts byte data to string.
     */ PdfString.byteToString = function(data) {
        if (data == null) throw new Error("Argument Null Exception : stream");
        var result = "";
        for(var i = 0; i < data.length; ++i)result += String.fromCharCode(data[i]);
        return result;
    };
    //constants = ;
    /**
     * `General markers` for string.
     * @private
     */ PdfString.stringMark = "()";
    /**
     * `Hex markers` for string.
     * @private
     */ PdfString.hexStringMark = "<>";
    /**
     * Format of password data.
     * @private
     */ PdfString.hexFormatPattern = "{0:X2}";
    return PdfString;
}();


/**
 * `PdfReference` class is used to perform reference related primitive operations.
 * @private
 */ var $8f73ad8fb76d816c$export$8dbbc26be85c345a = /** @class */ function() {
    function PdfReference(objNumber, genNumber) {
        /**
         * Holds the `index` number of the object.
         * @default -1
         * @private
         */ this.index3 = -1;
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position3 = -1;
        /**
         * Holds the `object number`.
         * @default 0
         * @private
         */ this.objNumber = 0;
        /**
         * Holds the `generation number` of the object.
         * @default 0
         * @private
         */ this.genNumber = 0;
        if (typeof objNumber === "number" && typeof genNumber === "number") {
            this.objNumber = objNumber;
            this.genNumber = genNumber;
        // } else if (typeof objNum === 'string' && typeof genNum === 'string') {
        } else {
            this.objNumber = Number(objNumber);
            this.genNumber = Number(genNumber);
        }
    }
    Object.defineProperty(PdfReference.prototype, "status", {
        //Property
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status3;
        },
        set: function(value) {
            this.status3 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReference.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving3;
        },
        set: function(value) {
            this.isSaving3 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReference.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index3;
        },
        set: function(value) {
            this.index3 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReference.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position3;
        },
        set: function(value) {
            this.position3 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReference.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            var returnObject3 = null;
            return returnObject3;
        },
        enumerable: true,
        configurable: true
    });
    //IPdfPrimitives methods
    /**
     * `Saves` the object.
     * @private
     */ PdfReference.prototype.save = function(writer) {
        writer.write(this.toString());
    };
    /**
     * Returns a `string` representing the object.
     * @private
     */ PdfReference.prototype.toString = function() {
        return this.objNumber.toString() + " " + this.genNumber.toString() + " R";
    };
    /**
     * Creates a `deep copy` of the IPdfPrimitive object.
     * @private
     */ PdfReference.prototype.clone = function(crossTable) {
        return null;
    };
    return PdfReference;
}();
/**
 * `PdfReferenceHolder` class is used to perform reference holder related primitive operations.
 * @private
 */ var $8f73ad8fb76d816c$export$9f625259dd339115 = /** @class */ function() {
    function PdfReferenceHolder(obj1, obj2) {
        /**
         * Holds the `index` number of the object.
         * @default -1
         * @private
         */ this.index4 = -1;
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.position4 = -1;
        /**
         * The `index` of the object within the object collection.
         * @default -1
         * @private
         */ this.objectIndex = -1;
        /**
         * @hidden
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        // if (typeof obj2 === 'undefined') {
        this.initialize(obj1);
    // }
    // else {
    //     if (obj2 === null) {
    //         throw new Error('ArgumentNullException : crossTable');
    //     }
    //     if (obj1 === null) {
    //         throw new Error('ArgumentNullException : reference');
    //     }
    //     this.crossTable = obj2;
    //     let tempObj1 : PdfReference = <PdfReference>obj1;
    //     this.reference = tempObj1;
    // }
    }
    Object.defineProperty(PdfReferenceHolder.prototype, "status", {
        //Properties
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.status4;
        },
        set: function(value) {
            this.status4 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.isSaving4;
        },
        set: function(value) {
            this.isSaving4 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index4;
        },
        set: function(value) {
            this.index4 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.position4;
        },
        set: function(value) {
            this.position4 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "object", {
        /**
         * Gets the `object` the reference is of.
         * @private
         */ get: function() {
            // if ((this.reference != null) || (this.object == null)) {
            //     this.object = this.GetterObject();
            // }
            return this.primitiveObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "reference", {
        /**
         * Gets the `reference`.
         * @private
         */ get: function() {
            return this.pdfReference;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "index", {
        /**
         * Gets the `index` of the object.
         * @private
         */ get: function() {
            // let items : PdfMainObjectCollection = this.crossTable.PdfObjects;
            // this.objectIndex = items.GetObjectIndex(this.reference);
            // if (this.objectIndex < 0) {
            //     let obj : IPdfPrimitive = this.crossTable.GetObject(this.reference);
            //     this.objectIndex = items.Count - 1;
            // }
            return this.objectIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfReferenceHolder.prototype, "element", {
        /**
         * Gets the `element`.
         * @private
         */ get: function() {
            return this.primitiveObject;
        },
        enumerable: true,
        configurable: true
    });
    PdfReferenceHolder.prototype.initialize = function(obj1) {
        if (obj1 instanceof (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab) || obj1 instanceof (0, $467b51a52206950c$export$f103d8ead0680780) || obj1 instanceof (0, $93a92e6ea67161be$export$b440601b3bfe4454) || obj1 instanceof (0, $f982301cdcaba043$export$8883fe148ef336b4) || obj1 instanceof (0, $15c367619ceaca0d$export$4d7493161880398c) || obj1 instanceof $8f73ad8fb76d816c$export$8dbbc26be85c345a || obj1 instanceof (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)) this.primitiveObject = obj1;
        else {
            var tempObj = obj1;
            this.initialize(tempObj.element);
        }
    };
    /**
     * `Writes` a reference into a PDF document.
     * @private
     */ PdfReferenceHolder.prototype.save = function(writer) {
        // if (writer == null) {
        //     throw new Error('ArgumentNullException : writer');
        // }
        var position = writer.position;
        var cTable = writer.document.crossTable;
        // if (cTable.Document instanceof PdfDocument) {
        this.object.isSaving = true;
        // }
        var reference = null;
        // if (writer.Document.FileStructure.IncrementalUpdate === true && writer.Document.isStreamCopied === true) {
        //     if (this.reference === null) {
        //         reference = cTable.GetReference(this.Object);
        //     } else {
        //         reference = this.reference;
        //     }
        // } else {
        //     reference = cTable.GetReference(this.Object);
        // }
        // if (!(writer.Document.FileStructure.IncrementalUpdate === true && writer.Document.isStreamCopied === true)) {
        reference = cTable.getReference(this.object);
        // }
        // if (writer.Position !== position) {
        //     writer.Position = position;
        // }
        reference.save(writer);
    };
    /**
     * Creates a `copy of PdfReferenceHolder`.
     * @private
     */ PdfReferenceHolder.prototype.clone = function(crossTable) {
        var refHolder = null;
        var temp = null;
        var refNum = "";
        var reference = null;
        // Restricts addition of same object multiple time.
        /* if (this.Reference != null && this.crossTable != null && this.crossTable.PageCorrespondance.containsKey(this.Reference)) {
            refHolder = new PdfReferenceHolder(this.crossTable.PageCorrespondance.getValue(this.Reference) as PdfReference, crossTable);
            return refHolder;
        }
        if (Object instanceof PdfNumber) {
            return new PdfNumber((Object as PdfNumber).IntValue);
        }
        */ // if (Object instanceof PdfDictionary) {
        //     // Meaning the referenced page is not available for import.
        //     let type : PdfName = new PdfName(this.dictionaryProperties.type);
        //     let dict : PdfDictionary = Object as PdfDictionary;
        //     if (dict.ContainsKey(type)) {
        //         let pageName : PdfName = dict.Items.getValue(type.Value) as PdfName;
        //         if (pageName !== null) {
        //             if (pageName.Value === 'Page') {
        //                 return new PdfNull();
        //             }
        //         }
        //     }
        // }
        /* if (Object instanceof PdfName) {
            return new PdfName ((Object as PdfName ).Value);
        }
        */ // Resolves circular references.
        // if (crossTable.PrevReference !== null && (crossTable.PrevReference.indexOf(this.Reference) !== -1)) {
        //     let obj : IPdfPrimitive = this.crossTable.GetObject(this.Reference).ClonedObject;
        //     if (obj !== null) {
        //         reference = crossTable.GetReference(obj);
        //         return new PdfReferenceHolder(reference, crossTable);
        //     } else {
        //         return new PdfNull();
        //     }
        // }
        /*if (this.Reference !== null) {
            crossTable.PrevReference.push(this.Reference);
        }
        reference = crossTable.GetReference(temp);
        refHolder = new PdfReferenceHolder(reference, crossTable);
        return refHolder;
        */ return null;
    };
    return PdfReferenceHolder;
}();



var $15c367619ceaca0d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfStream` class is used to perform stream related primitive operations.
 * @private
 */ var $15c367619ceaca0d$export$4d7493161880398c = /** @class */ function(_super) {
    $15c367619ceaca0d$var$__extends(PdfStream, _super);
    function PdfStream(dictionary, data) {
        var _this = _super.call(this, dictionary) || this;
        //Constants
        /**
         * @hidden
         * @private
         */ _this.dicPrefix = "stream";
        /**
         * @hidden
         * @private
         */ _this.dicSuffix = "endstream";
        /**
         * Internal variable to hold `cloned object`.
         * @private
         */ _this.clonedObject2 = null;
        /**
         * @hidden
         * @private
         */ _this.bCompress = true;
        if (typeof dictionary !== "undefined" || typeof data !== "undefined") {
            _this.dataStream2 = [];
            _this.dataStream2 = data;
            _this.bCompress2 = false;
        } else {
            _this.dataStream2 = [];
            _this.bCompress2 = true;
        //Pending
        }
        return _this;
    }
    Object.defineProperty(PdfStream.prototype, "internalStream", {
        /**
         * Gets the `internal` stream.
         * @private
         */ get: function() {
            return this.dataStream2;
        },
        set: function(value) {
            this.dataStream2 = [];
            this.dataStream2 = value;
            this.modify();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStream.prototype, "compress", {
        /**
         * Gets or sets `compression` flag.
         * @private
         */ get: function() {
            return this.bCompress;
        },
        set: function(value) {
            this.bCompress = value;
            this.modify();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStream.prototype, "data", {
        /**
         * Gets or sets the `data`.
         * @private
         */ get: function() {
            return this.dataStream2;
        },
        set: function(value) {
            this.dataStream2 = [];
            this.dataStream2 = value;
            this.modify();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Clear` the internal stream.
     * @private
     */ PdfStream.prototype.clearStream = function() {
        this.internalStream = [];
        if (this.items.containsKey(this.dictionaryProperties.filter)) this.remove(this.dictionaryProperties.filter);
        this.bCompress = true;
        this.modify();
    };
    /**
     * `Writes` the specified string.
     * @private
     */ PdfStream.prototype.write = function(text) {
        if (text == null) throw new Error("ArgumentNullException:text");
        if (text.length <= 0) throw new Error("ArgumentException: Can not write an empty string, text");
        this.dataStream2.push(text);
        this.modify();
    };
    /**
     * `Writes` the specified bytes.
     * @private
     */ PdfStream.prototype.writeBytes = function(data) {
        if (data === null) throw new Error("ArgumentNullException:data");
        if (data.length <= 0) throw new Error("ArgumentException: Can not write an empty bytes, data");
        var text = "";
        for(var i = 0; i < data.length; i++)text += String.fromCharCode(data[i]);
        this.dataStream2.push(text);
        this.modify();
    };
    /**
     * Raises event `Cmap BeginSave`.
     * @private
     */ PdfStream.prototype.onCmapBeginSave = function() {
        this.cmapBeginSave.sender.cmapBeginSave();
    };
    /**
     * Raises event `Font Program BeginSave`.
     * @private
     */ PdfStream.prototype.onFontProgramBeginSave = function() {
        this.fontProgramBeginSave.sender.fontProgramBeginSave();
    };
    /**
     * `Compresses the content` if it's required.
     * @private
     */ PdfStream.prototype.compressContent = function(data, writer) {
        if (this.bCompress) {
            var byteArray = [];
            for(var i = 0; i < data.length; i++)byteArray.push(data.charCodeAt(i));
            var dataArray = new Uint8Array(byteArray);
            var sw = new (0, $74aa42b3315e6e4b$export$c79d5db3b1b174f2)();
            // data = 'Hello World!!!';
            sw.write(dataArray, 0, dataArray.length);
            sw.close();
            data = sw.getCompressedString;
            this.addFilter(this.dictionaryProperties.flatedecode);
        }
        return data;
    };
    /**
     * `Adds a filter` to the filter array.
     * @private
     */ PdfStream.prototype.addFilter = function(filterName) {
        var obj = this.items.getValue(this.dictionaryProperties.filter);
        if (obj instanceof (0, $8f73ad8fb76d816c$export$9f625259dd339115)) {
            var rh = obj;
            obj = rh.object;
        }
        var array = obj;
        var name = obj;
        if (name != null) {
            array = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
            array.insert(0, name);
            this.items.setValue(this.dictionaryProperties.filter, array);
        }
        name = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(filterName);
        if (array == null) this.items.setValue(this.dictionaryProperties.filter, name);
        else array.insert(0, name);
    };
    /**
     * `Saves` the object using the specified writer.
     * @private
     */ PdfStream.prototype.save = function(writer) {
        if (typeof this.cmapBeginSave !== "undefined") this.onCmapBeginSave();
        if (typeof this.fontProgramBeginSave !== "undefined") this.onFontProgramBeginSave();
        var data = "";
        for(var i = 0; i < this.data.length; i++)data = data + this.data[i];
        if (data.length > 1 && !this.isResource) data = "q\r\n" + data + "Q\r\n";
        data = this.compressContent(data, writer);
        var length = data.length;
        this.items.setValue(this.dictionaryProperties.length, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(length));
        _super.prototype.save.call(this, writer, false);
        writer.write(this.dicPrefix);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        if (data.length > 0) writer.write(data);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        writer.write(this.dicSuffix);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * Converts `bytes to string`.
     * @private
     */ PdfStream.bytesToString = function(byteArray) {
        var output = "";
        for(var i = 0; i < byteArray.length; i++)output = output + String.fromCharCode(byteArray[i]);
        return output;
    };
    return PdfStream;
}((0, $467b51a52206950c$export$f103d8ead0680780));
var $15c367619ceaca0d$export$dd3025ce91a23ff5 = /** @class */ function() {
    /**
     * New instance for `save section collection event handler` class.
     * @private
     */ function SaveCmapEventHandler(sender) {
        this.sender = sender;
    }
    return SaveCmapEventHandler;
}();
var $15c367619ceaca0d$export$56a09a2087b8457a = /** @class */ function() {
    /**
     * New instance for `save section collection event handler` class.
     * @private
     */ function SaveFontProgramEventHandler(sender) {
        this.sender = sender;
    }
    return SaveFontProgramEventHandler;
}();





/**
 * `PdfBoolean` class is used to perform boolean related primitive operations.
 * @private
 */ var $502bea31c0cd284e$export$9101e1382351029d = /** @class */ function() {
    //constructor
    /**
     * Initializes a new instance of the `PdfBoolean` class.
     * @private
     */ function PdfBoolean(value) {
        /**
         * Internal variable to store the `position`.
         * @default -1
         * @private
         */ this.currentPosition = -1;
        this.value = value;
    }
    Object.defineProperty(PdfBoolean.prototype, "status", {
        //Properties
        /**
         * Gets or sets the `Status` of the specified object.
         * @private
         */ get: function() {
            return this.objectStatus;
        },
        set: function(value) {
            this.objectStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBoolean.prototype, "isSaving", {
        /**
         * Gets or sets a value indicating whether this document `is saving` or not.
         * @private
         */ get: function() {
            return this.saving;
        },
        set: function(value) {
            this.saving = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBoolean.prototype, "objectCollectionIndex", {
        /**
         * Gets or sets the `index` value of the specified object.
         * @private
         */ get: function() {
            return this.index;
        },
        set: function(value) {
            this.index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBoolean.prototype, "position", {
        /**
         * Gets or sets the `position` of the object.
         * @private
         */ get: function() {
            return this.currentPosition;
        },
        set: function(value) {
            this.currentPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBoolean.prototype, "clonedObject", {
        /**
         * Returns `cloned object`.
         * @private
         */ get: function() {
            var rValue = null;
            return rValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Saves` the object using the specified writer.
     * @private
     */ PdfBoolean.prototype.save = function(writer) {
        writer.write(this.boolToStr(this.value));
    };
    /**
     * Creates a `copy of PdfBoolean`.
     * @private
     */ PdfBoolean.prototype.clone = function(crossTable) {
        var newNumber = new PdfBoolean(this.value);
        return newNumber;
    };
    // Implementation
    /**
     * Converts `boolean to string` - 0/1 'true'/'false'.
     * @private
     */ PdfBoolean.prototype.boolToStr = function(value) {
        return value ? "true" : "false";
    };
    return PdfBoolean;
}();



var $62c521254d9ede6b$export$2176deede4b7eeaf;
(function(ImageFormat) {
    /**
     * Specifies the type of `Unknown`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Unknown"] = 0] = "Unknown";
    /**
     * Specifies the type of `Bmp`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Bmp"] = 1] = "Bmp";
    /**
     * Specifies the type of `Emf`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Emf"] = 2] = "Emf";
    /**
     * Specifies the type of `Gif`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Gif"] = 3] = "Gif";
    /**
     * Specifies the type of `Jpeg`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Jpeg"] = 4] = "Jpeg";
    /**
     * Specifies the type of `Png`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Png"] = 5] = "Png";
    /**
     * Specifies the type of `Wmf`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Wmf"] = 6] = "Wmf";
    /**
     * Specifies the type of `Icon`.
     * @hidden
     * @private
     */ ImageFormat[ImageFormat["Icon"] = 7] = "Icon";
})($62c521254d9ede6b$export$2176deede4b7eeaf || ($62c521254d9ede6b$export$2176deede4b7eeaf = {}));
/**
 * `Decode the image stream`.
 * @private
 */ var $62c521254d9ede6b$export$e6116f64ca24c416 = /** @class */ function() {
    /**
     * Initialize the new instance for `image-decoder` class.
     * @private
     */ function ImageDecoder(stream) {
        /**
         * Start of file markers.
         * @hidden
         * @private
         */ this.sof1Marker = 0x00C1;
        this.sof2Marker = 0x00C2;
        this.sof3Marker = 0x00C3;
        this.sof5Marker = 0x00C5;
        this.sof6Marker = 0x00C6;
        this.sof7Marker = 0x00C7;
        this.sof9Marker = 0x00C9;
        this.sof10Marker = 0x00CA;
        this.sof11Marker = 0x00CB;
        this.sof13Marker = 0x00CD;
        this.sof14Marker = 0x00CE;
        this.sof15Marker = 0x00CF;
        /**
         * Specifies `format` of image.
         * @hidden
         * @private
         */ this.mFormat = $62c521254d9ede6b$export$2176deede4b7eeaf.Unknown;
        /**
         * `Bits per component`.
         * @default 8
         * @hidden
         * @private
         */ this.mbitsPerComponent = 8;
        /**
         * Internal variable for accessing fields from `DictionryProperties` class.
         * @hidden
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        this.mStream = stream;
        this.initialize();
    }
    Object.defineProperty(ImageDecoder.prototype, "height", {
        /**
         * Gets the `height` of image.
         * @hidden
         * @private
         */ get: function() {
            return this.mHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageDecoder.prototype, "width", {
        /**
         * Gets the `width` of image.
         * @hidden
         * @private
         */ get: function() {
            return this.mWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageDecoder.prototype, "bitsPerComponent", {
        /**
         * Gets `bits per component`.
         * @hidden
         * @private
         */ get: function() {
            return this.mbitsPerComponent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageDecoder.prototype, "size", {
        /**
         * Gets the `size` of an image data.
         * @hidden
         * @private
         */ get: function() {
            return this.mImageData.count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageDecoder.prototype, "imageData", {
        /**
         * Gets the value of an `image data`.
         * @hidden
         * @private
         */ get: function() {
            return this.mImageData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageDecoder.prototype, "imageDataAsNumberArray", {
        /**
         * Gets the value of an `image data as number array`.
         * @hidden
         * @private
         */ get: function() {
            return this.mImageData.internalBuffer.buffer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Initialize` image data and image stream.
     * @hidden
     * @private
     */ ImageDecoder.prototype.initialize = function() {
        if (this.mFormat === $62c521254d9ede6b$export$2176deede4b7eeaf.Unknown && this.checkIfJpeg()) {
            this.mFormat = $62c521254d9ede6b$export$2176deede4b7eeaf.Jpeg;
            this.parseJpegImage();
        } else throw new TypeError("Only the JPEG format is supported");
        this.reset();
        this.mImageData = new (0, $72b64e0afda10076$export$a963f15d59b126e1)(this.mStream.count);
        this.mStream.read(this.mImageData, 0, this.mImageData.count);
    };
    /**
     * `Reset` stream position into 0.
     * @hidden
     * @private
     */ ImageDecoder.prototype.reset = function() {
        this.mStream.position = 0;
    };
    /**
     * `Parse` Jpeg image.
     * @hidden
     * @private
     */ ImageDecoder.prototype.parseJpegImage = function() {
        this.reset();
        var imgData = new (0, $72b64e0afda10076$export$a963f15d59b126e1)(this.mStream.count);
        this.mStream.read(imgData, 0, imgData.count);
        var i = 4;
        var isLengthExceed = false;
        /* tslint:disable */ var length = imgData.getBuffer(i) * 256 + imgData.getBuffer(i + 1);
        while(i < imgData.count){
            i += length;
            if (i < imgData.count) {
                if (imgData.getBuffer(i + 1) === 192) {
                    this.mHeight = imgData.getBuffer(i + 5) * 256 + imgData.getBuffer(i + 6);
                    this.mWidth = imgData.getBuffer(i + 7) * 256 + imgData.getBuffer(i + 8);
                    return;
                } else {
                    i += 2;
                    length = imgData.getBuffer(i) * 256 + imgData.getBuffer(i + 1);
                }
            } else {
                isLengthExceed = true;
                break;
            }
        }
        if (isLengthExceed) {
            this.mStream.position = 0;
            this.skip(this.mStream, 2);
            this.readExceededJPGImage(this.mStream);
        }
    /* tslint:enable */ };
    Object.defineProperty(ImageDecoder.prototype, "format", {
        /**
         * Gets the image `format`.
         * @private
         * @hidden
         */ get: function() {
            return this.mFormat;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Checks if JPG`.
     * @private
     * @hidden
     */ ImageDecoder.prototype.checkIfJpeg = function() {
        this.reset();
        for(var i = 0; i < ImageDecoder.mJpegHeader.length; i++){
            if (ImageDecoder.mJpegHeader[i] !== this.mStream.readByte(i)) return false;
            this.mStream.position++;
        }
        return true;
    };
    /**
     * Return image `dictionary`.
     * @hidden
     * @private
     */ ImageDecoder.prototype.getImageDictionary = function() {
        if (this.mFormat === $62c521254d9ede6b$export$2176deede4b7eeaf.Jpeg) {
            var tempArrayBuffer = this.imageData.internalBuffer.length;
            this.imageStream = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
            this.imageStream.isResource = true;
            var tempString = "";
            var decodedString = "";
            for(var i = 0; i < this.imageDataAsNumberArray.byteLength; i++)tempString += String.fromCharCode(null, this.mStream.readByte(i));
            for(var i = 0; i < tempString.length; i++)if (i % 2 !== 0) decodedString += tempString[i];
            this.imageStream.data = [
                decodedString
            ];
            this.imageStream.compress = false;
            this.imageStream.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.xObject));
            this.imageStream.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.image));
            this.imageStream.items.setValue(this.dictionaryProperties.width, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.width));
            this.imageStream.items.setValue(this.dictionaryProperties.height, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.height));
            this.imageStream.items.setValue(this.dictionaryProperties.bitsPerComponent, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.bitsPerComponent));
            this.imageStream.items.setValue(this.dictionaryProperties.filter, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.dctdecode));
            this.imageStream.items.setValue(this.dictionaryProperties.colorSpace, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.getColorSpace()));
            this.imageStream.items.setValue(this.dictionaryProperties.decodeParms, this.getDecodeParams());
            return this.imageStream;
        } else return this.imageStream;
    };
    /**
     * Return `colorSpace` of an image.
     * @hidden
     * @private
     */ ImageDecoder.prototype.getColorSpace = function() {
        return this.dictionaryProperties.deviceRgb;
    };
    /**
     * Return `decode parameters` of an image.
     * @hidden
     * @private
     */ ImageDecoder.prototype.getDecodeParams = function() {
        var decodeParams = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        decodeParams.items.setValue(this.dictionaryProperties.columns, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.width));
        decodeParams.items.setValue(this.dictionaryProperties.blackIs1, new (0, $502bea31c0cd284e$export$9101e1382351029d)(true));
        decodeParams.items.setValue(this.dictionaryProperties.k, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(-1));
        decodeParams.items.setValue(this.dictionaryProperties.predictor, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(15));
        decodeParams.items.setValue(this.dictionaryProperties.bitsPerComponent, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.bitsPerComponent));
        return decodeParams;
    };
    /**
     * 'readExceededJPGImage' stream
     * @hidden
     * @private
     */ ImageDecoder.prototype.readExceededJPGImage = function(stream) {
        this.mStream = stream;
        var isContinueReading = true;
        while(isContinueReading){
            var marker = this.getMarker(stream);
            switch(marker){
                case this.sof1Marker:
                case this.sof2Marker:
                case this.sof3Marker:
                case this.sof5Marker:
                case this.sof6Marker:
                case this.sof7Marker:
                case this.sof9Marker:
                case this.sof10Marker:
                case this.sof11Marker:
                case this.sof13Marker:
                case this.sof14Marker:
                case this.sof15Marker:
                    stream.position += 3;
                    this.mHeight = this.mStream.readNextTwoBytes(stream);
                    this.mWidth = this.mStream.readNextTwoBytes(stream);
                    isContinueReading = false;
                    break;
                default:
                    this.skipStream(stream);
                    break;
            }
        }
    };
    /**
     * 'skip' stream
     * @hidden
     * @private
     */ ImageDecoder.prototype.skip = function(stream, noOfBytes) {
        this.mStream = stream;
        var temp = new (0, $72b64e0afda10076$export$a963f15d59b126e1)(noOfBytes);
        this.mStream.read(temp, 0, temp.count);
    };
    /**
     * 'getMarker' stream
     * @hidden
     * @private
     */ ImageDecoder.prototype.getMarker = function(stream) {
        var skippedByte = 0;
        var marker = 32;
        marker = stream.readByte(this.mStream.position);
        stream.position++;
        while(marker !== 255){
            skippedByte++;
            marker = stream.readByte(this.mStream.position);
            stream.position++;
        }
        do {
            marker = stream.readByte(this.mStream.position);
            stream.position++;
        }while (marker === 255);
        return marker;
    };
    /**
     * 'skipStream' stream
     * @hidden
     * @private
     */ ImageDecoder.prototype.skipStream = function(stream) {
        var markerLength = this.mStream.readNextTwoBytes(stream) - 2;
        if (markerLength > 0) stream.position += markerLength;
    };
    /**
     * Number array for `png header`.
     * @hidden
     * @private
     */ ImageDecoder.mPngHeader = [
        137,
        80,
        78,
        71,
        13,
        10,
        26,
        10
    ];
    /**
     * Number Array for `jpeg header`.
     * @hidden
     * @private
     */ ImageDecoder.mJpegHeader = [
        255,
        216
    ];
    /**
     * Number array for `gif header`.
     * @hidden
     * @private
     */ ImageDecoder.GIF_HEADER = "G,I,F,8";
    /**
     * Number array for `bmp header.`
     * @hidden
     * @private
     */ ImageDecoder.BMP_HEADER = "B,M";
    return ImageDecoder;
}();




/**
 * Coordinates of Position for `PointF`.
 * @private
 */ var $e1df9a3657e111f3$export$a878d5fce7d721a5 = /** @class */ function() {
    function PointF(x, y) {
        if (typeof x === "undefined") {
            this.x = 0;
            this.y = 0;
        } else {
            if (x !== null) this.x = x;
            else this.x = 0;
            if (y !== null) this.y = y;
            else this.y = 0;
        }
    }
    return PointF;
}();
/**
 * Width and Height as `Size`.
 * @private
 */ var $e1df9a3657e111f3$export$81f866bb912d8821 = /** @class */ function() {
    function SizeF(width, height) {
        if (typeof height === "undefined") {
            this.height = 0;
            this.width = 0;
        } else {
            if (height !== null) this.height = height;
            else this.height = 0;
            if (width !== null) this.width = width;
            else this.width = 0;
        }
    }
    return SizeF;
}();
/**
 * `RectangleF` with Position and size.
 * @private
 */ var $e1df9a3657e111f3$export$6543fe32ba958b02 = /** @class */ function() {
    function RectangleF(arg1, arg2, arg3, arg4) {
        if (typeof arg1 === "undefined") {
            this.x = 0;
            this.y = 0;
            this.height = 0;
            this.width = 0;
        } else if (arg1 instanceof $e1df9a3657e111f3$export$a878d5fce7d721a5 && arg2 instanceof $e1df9a3657e111f3$export$81f866bb912d8821 && typeof arg3 === "undefined") {
            var pointf = arg1;
            this.x = pointf.x;
            this.y = pointf.y;
            var sizef = arg2;
            this.height = sizef.height;
            this.width = sizef.width;
        } else {
            var x = arg1;
            var y = arg2;
            var width = arg3;
            var height = arg4;
            this.x = x;
            this.y = y;
            this.height = height;
            this.width = width;
        }
    }
    return RectangleF;
}();
/**
 * `Rectangle` with left, right, top and bottom.
 * @private
 */ var $e1df9a3657e111f3$export$4617fb02663045ef = /** @class */ function() {
    /**
     * Instance of `RectangleF` class with X, Y, Width and Height.
     * @private
     */ function Rectangle(left, top, right, bottom) {
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
    Object.defineProperty(Rectangle.prototype, "width", {
        /**
         * Gets a value of width
         */ get: function() {
            return this.right - this.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "height", {
        /**
         * Gets a value of height
         */ get: function() {
            return this.bottom - this.top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "topLeft", {
        /**
         * Gets a value of Top and Left
         */ get: function() {
            return new $e1df9a3657e111f3$export$a878d5fce7d721a5(this.left, this.top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "size", {
        /**
         * Gets a value of size
         */ get: function() {
            return new $e1df9a3657e111f3$export$81f866bb912d8821(this.width, this.height);
        },
        enumerable: true,
        configurable: true
    });
    Rectangle.prototype.toString = function() {
        return this.topLeft + "x" + this.size;
    };
    return Rectangle;
}();


/**
 * public Enum for `PdfHorizontalAlignment`.
 * @private
 */ var $d174213b46afc09a$export$a860fbb574df8714;
(function(PdfHorizontalAlignment) {
    /**
     * Specifies the type of `Left`.
     * @private
     */ PdfHorizontalAlignment[PdfHorizontalAlignment["Left"] = 0] = "Left";
    /**
     * Specifies the type of `Center`.
     * @private
     */ PdfHorizontalAlignment[PdfHorizontalAlignment["Center"] = 1] = "Center";
    /**
     * Specifies the type of `Right`.
     * @private
     */ PdfHorizontalAlignment[PdfHorizontalAlignment["Right"] = 2] = "Right";
})($d174213b46afc09a$export$a860fbb574df8714 || ($d174213b46afc09a$export$a860fbb574df8714 = {}));
var $d174213b46afc09a$export$2692e69612b4a9e9;
(function(PdfVerticalAlignment) {
    /**
     * Specifies the type of `Top`.
     * @private
     */ PdfVerticalAlignment[PdfVerticalAlignment["Top"] = 0] = "Top";
    /**
     * Specifies the type of `Middle`.
     * @private
     */ PdfVerticalAlignment[PdfVerticalAlignment["Middle"] = 1] = "Middle";
    /**
     * Specifies the type of `Bottom`.
     * @private
     */ PdfVerticalAlignment[PdfVerticalAlignment["Bottom"] = 2] = "Bottom";
})($d174213b46afc09a$export$2692e69612b4a9e9 || ($d174213b46afc09a$export$2692e69612b4a9e9 = {}));
var $d174213b46afc09a$export$ff2ffbe66a522e26;
(function(PdfTextAlignment) {
    /**
     * Specifies the type of `Left`.
     * @private
     */ PdfTextAlignment[PdfTextAlignment["Left"] = 0] = "Left";
    /**
     * Specifies the type of `Center`.
     * @private
     */ PdfTextAlignment[PdfTextAlignment["Center"] = 1] = "Center";
    /**
     * Specifies the type of `Right`.
     * @private
     */ PdfTextAlignment[PdfTextAlignment["Right"] = 2] = "Right";
    /**
     * Specifies the type of `Justify`.
     * @private
     */ PdfTextAlignment[PdfTextAlignment["Justify"] = 3] = "Justify";
})($d174213b46afc09a$export$ff2ffbe66a522e26 || ($d174213b46afc09a$export$ff2ffbe66a522e26 = {}));
var $d174213b46afc09a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    /**
     * Specifies the type of `Fill`.
     * @private
     */ TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    /**
     * Specifies the type of `Stroke`.
     * @private
     */ TextRenderingMode[TextRenderingMode["Stroke"] = 1] = "Stroke";
    /**
     * Specifies the type of `FillStroke`.
     * @private
     */ TextRenderingMode[TextRenderingMode["FillStroke"] = 2] = "FillStroke";
    /**
     * Specifies the type of `None`.
     * @private
     */ TextRenderingMode[TextRenderingMode["None"] = 3] = "None";
    /**
     * Specifies the type of `ClipFlag`.
     * @private
     */ TextRenderingMode[TextRenderingMode["ClipFlag"] = 4] = "ClipFlag";
    /**
     * Specifies the type of `ClipFill`.
     * @private
     */ TextRenderingMode[TextRenderingMode["ClipFill"] = 4] = "ClipFill";
    /**
     * Specifies the type of `ClipStroke`.
     * @private
     */ TextRenderingMode[TextRenderingMode["ClipStroke"] = 5] = "ClipStroke";
    /**
     * Specifies the type of `ClipFillStroke`.
     * @private
     */ TextRenderingMode[TextRenderingMode["ClipFillStroke"] = 6] = "ClipFillStroke";
    /**
     * Specifies the type of `Clip`.
     * @private
     */ TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($d174213b46afc09a$export$ca45e4ab114d4814 || ($d174213b46afc09a$export$ca45e4ab114d4814 = {}));
var $d174213b46afc09a$export$1cac681868817383;
(function(PdfLineJoin) {
    /**
     * Specifies the type of `Miter`.
     * @private
     */ PdfLineJoin[PdfLineJoin["Miter"] = 0] = "Miter";
    /**
     * Specifies the type of `Round`.
     * @private
     */ PdfLineJoin[PdfLineJoin["Round"] = 1] = "Round";
    /**
     * Specifies the type of `Bevel`.
     * @private
     */ PdfLineJoin[PdfLineJoin["Bevel"] = 2] = "Bevel";
})($d174213b46afc09a$export$1cac681868817383 || ($d174213b46afc09a$export$1cac681868817383 = {}));
var $d174213b46afc09a$export$7c913101b81a8134;
(function(PdfLineCap) {
    /**
     * Specifies the type of `Flat`.
     * @private
     */ PdfLineCap[PdfLineCap["Flat"] = 0] = "Flat";
    /**
     * Specifies the type of `Round`.
     * @private
     */ PdfLineCap[PdfLineCap["Round"] = 1] = "Round";
    /**
     * Specifies the type of `Square`.
     * @private
     */ PdfLineCap[PdfLineCap["Square"] = 2] = "Square";
})($d174213b46afc09a$export$7c913101b81a8134 || ($d174213b46afc09a$export$7c913101b81a8134 = {}));
var $d174213b46afc09a$export$a8fd4dfaf26dd3eb;
(function(PdfDashStyle) {
    /**
     * Specifies the type of `Solid`.
     * @private
     */ PdfDashStyle[PdfDashStyle["Solid"] = 0] = "Solid";
    /**
     * Specifies the type of `Dash`.
     * @private
     */ PdfDashStyle[PdfDashStyle["Dash"] = 1] = "Dash";
    /**
     * Specifies the type of `Dot`.
     * @private
     */ PdfDashStyle[PdfDashStyle["Dot"] = 2] = "Dot";
    /**
     * Specifies the type of `DashDot`.
     * @private
     */ PdfDashStyle[PdfDashStyle["DashDot"] = 3] = "DashDot";
    /**
     * Specifies the type of `DashDotDot`.
     * @private
     */ PdfDashStyle[PdfDashStyle["DashDotDot"] = 4] = "DashDotDot";
    /**
     * Specifies the type of `Custom`.
     * @private
     */ PdfDashStyle[PdfDashStyle["Custom"] = 5] = "Custom";
})($d174213b46afc09a$export$a8fd4dfaf26dd3eb || ($d174213b46afc09a$export$a8fd4dfaf26dd3eb = {}));
var $d174213b46afc09a$export$6a8bdcdc458c5885;
(function(PdfFillMode) {
    /**
     * Specifies the type of `Winding`.
     * @private
     */ PdfFillMode[PdfFillMode["Winding"] = 0] = "Winding";
    /**
     * Specifies the type of `Alternate`.
     * @private
     */ PdfFillMode[PdfFillMode["Alternate"] = 1] = "Alternate";
})($d174213b46afc09a$export$6a8bdcdc458c5885 || ($d174213b46afc09a$export$6a8bdcdc458c5885 = {}));
var $d174213b46afc09a$export$3c2d1c75bca6b8d3;
(function(PdfColorSpace) {
    /**
     * Specifies the type of `Rgb`.
     * @private
     */ PdfColorSpace[PdfColorSpace["Rgb"] = 0] = "Rgb";
    /**
     * Specifies the type of `Cmyk`.
     * @private
     */ PdfColorSpace[PdfColorSpace["Cmyk"] = 1] = "Cmyk";
    /**
     * Specifies the type of `GrayScale`.
     * @private
     */ PdfColorSpace[PdfColorSpace["GrayScale"] = 2] = "GrayScale";
    /**
     * Specifies the type of `Indexed`.
     * @private
     */ PdfColorSpace[PdfColorSpace["Indexed"] = 3] = "Indexed";
})($d174213b46afc09a$export$3c2d1c75bca6b8d3 || ($d174213b46afc09a$export$3c2d1c75bca6b8d3 = {}));
var $d174213b46afc09a$export$69caf60bba815dab;
(function(PdfBlendMode) {
    /**
     * Specifies the type of `Normal`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Normal"] = 0] = "Normal";
    /**
     * Specifies the type of `Multiply`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Multiply"] = 1] = "Multiply";
    /**
     * Specifies the type of `Screen`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Screen"] = 2] = "Screen";
    /**
     * Specifies the type of `Overlay`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Overlay"] = 3] = "Overlay";
    /**
     * Specifies the type of `Darken`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Darken"] = 4] = "Darken";
    /**
     * Specifies the type of `Lighten`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Lighten"] = 5] = "Lighten";
    /**
     * Specifies the type of `ColorDodge`.
     * @private
     */ PdfBlendMode[PdfBlendMode["ColorDodge"] = 6] = "ColorDodge";
    /**
     * Specifies the type of `ColorBurn`.
     * @private
     */ PdfBlendMode[PdfBlendMode["ColorBurn"] = 7] = "ColorBurn";
    /**
     * Specifies the type of `HardLight`.
     * @private
     */ PdfBlendMode[PdfBlendMode["HardLight"] = 8] = "HardLight";
    /**
     * Specifies the type of `SoftLight`.
     * @private
     */ PdfBlendMode[PdfBlendMode["SoftLight"] = 9] = "SoftLight";
    /**
     * Specifies the type of `Difference`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Difference"] = 10] = "Difference";
    /**
     * Specifies the type of `Exclusion`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Exclusion"] = 11] = "Exclusion";
    /**
     * Specifies the type of `Hue`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Hue"] = 12] = "Hue";
    /**
     * Specifies the type of `Saturation`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Saturation"] = 13] = "Saturation";
    /**
     * Specifies the type of `Color`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Color"] = 14] = "Color";
    /**
     * Specifies the type of `Luminosity`.
     * @private
     */ PdfBlendMode[PdfBlendMode["Luminosity"] = 15] = "Luminosity";
})($d174213b46afc09a$export$69caf60bba815dab || ($d174213b46afc09a$export$69caf60bba815dab = {}));
var $d174213b46afc09a$export$974c8f70aaa706fb;
(function(PdfGraphicsUnit) {
    /**
     * Specifies the type of `Centimeter`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Centimeter"] = 0] = "Centimeter";
    /**
     * Specifies the type of `Pica`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Pica"] = 1] = "Pica";
    /**
     * Specifies the type of `Pixel`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Pixel"] = 2] = "Pixel";
    /**
     * Specifies the type of `Point`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Point"] = 3] = "Point";
    /**
     * Specifies the type of `Inch`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Inch"] = 4] = "Inch";
    /**
     * Specifies the type of `Document`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Document"] = 5] = "Document";
    /**
     * Specifies the type of `Millimeter`.
     * @private
     */ PdfGraphicsUnit[PdfGraphicsUnit["Millimeter"] = 6] = "Millimeter";
})($d174213b46afc09a$export$974c8f70aaa706fb || ($d174213b46afc09a$export$974c8f70aaa706fb = {}));
var $d174213b46afc09a$export$cc85e6b19246b510;
(function(PdfGridImagePosition) {
    /**
     * Specifies the type of `Fit`.
     * @private
     */ PdfGridImagePosition[PdfGridImagePosition["Fit"] = 0] = "Fit";
    /**
     * Specifies the type of `Center`.
     * @private
     */ PdfGridImagePosition[PdfGridImagePosition["Center"] = 1] = "Center";
    /**
     * Specifies the type of `Stretch`.
     * @private
     */ PdfGridImagePosition[PdfGridImagePosition["Stretch"] = 2] = "Stretch";
    /**
     * Specifies the type of `Tile`.
     * @private
     */ PdfGridImagePosition[PdfGridImagePosition["Tile"] = 3] = "Tile";
})($d174213b46afc09a$export$cc85e6b19246b510 || ($d174213b46afc09a$export$cc85e6b19246b510 = {}));
var $d174213b46afc09a$export$96fe374e3268ced4;
(function(PdfTextDirection) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfTextDirection[PdfTextDirection["None"] = 0] = "None";
    /**
     * Specifies the type of `LeftToRight`.
     * @private
     */ PdfTextDirection[PdfTextDirection["LeftToRight"] = 1] = "LeftToRight";
    /**
     * Specifies the type of `RightToLeft`.
     * @private
     */ PdfTextDirection[PdfTextDirection["RightToLeft"] = 2] = "RightToLeft";
})($d174213b46afc09a$export$96fe374e3268ced4 || ($d174213b46afc09a$export$96fe374e3268ced4 = {}));


/**
 * Used to perform `convertion between pixels and points`.
 * @private
 */ var $b9b65a21308d53b7$export$17a6eabe6043f9d7 = /** @class */ function() {
    //constructors
    /**
     * Initializes a new instance of the `UnitConvertor` class with DPI value.
     * @private
     */ function PdfUnitConverter(dpi) {
        this.updateProportionsHelper(dpi);
    }
    /**
     * `Converts` the value, from one graphics unit to another graphics unit.
     * @private
     */ PdfUnitConverter.prototype.convertUnits = function(value, from, to) {
        return this.convertFromPixels(this.convertToPixels(value, from), to);
    };
    /**
     * Converts the value `to pixel` from specified graphics unit.
     * @private
     */ PdfUnitConverter.prototype.convertToPixels = function(value, from) {
        var index = from;
        var result = value * this.proportions[index];
        return result;
    };
    /**
     * Converts value, to specified graphics unit `from Pixel`.
     * @private
     */ PdfUnitConverter.prototype.convertFromPixels = function(value, to) {
        var index = to;
        var result = value / this.proportions[index];
        return result;
    };
    /**
     * `Update proportions` matrix according to Graphics settings.
     * @private
     */ PdfUnitConverter.prototype.updateProportionsHelper = function(pixelPerInch) {
        this.proportions = [
            pixelPerInch / 2.54,
            pixelPerInch / 6.0,
            1,
            pixelPerInch / 72.0,
            pixelPerInch,
            pixelPerInch / 300.0,
            pixelPerInch / 25.4 // Millimeter
        ];
    };
    //Fields
    /**
     * Indicates default `horizontal resolution`.
     * @default 96
     * @private
     */ PdfUnitConverter.horizontalResolution = 96;
    /**
     * Indicates default `vertical resolution`.
     * @default 96
     * @private
     */ PdfUnitConverter.verticalResolution = 96;
    return PdfUnitConverter;
}();


/**
 * `PdfImage` class represents the base class for images and provides functionality for the 'PdfBitmap' class.
 * @private
 */ var $722331ec33bd9a93$export$ee8313b7edf5feab = /** @class */ function() {
    function PdfImage() {}
    Object.defineProperty(PdfImage.prototype, "width", {
        /**
         * Gets and Sets the `width` of an image.
         * @private
         */ get: function() {
            return this.imageWidth;
        },
        set: function(value) {
            this.imageWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfImage.prototype, "height", {
        /**
         * Gets and Sets the `height` of an image.
         * @private
         */ get: function() {
            return this.imageHeight;
        },
        set: function(value) {
            this.imageHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfImage.prototype, "size", {
        /**
         * Gets or sets the size of the image.
         * @private
         */ set: function(value) {
            this.width = value.width;
            this.height = value.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfImage.prototype, "physicalDimension", {
        /**
         * Gets the `physical dimension` of an image.
         * @private
         */ get: function() {
            this.imagePhysicalDimension = this.getPointSize(this.width, this.height, this.horizontalResolution, this.verticalResolution);
            return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.width, this.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfImage.prototype, "element", {
        // /**
        //  * Gets the `image stream as string`.
        //  * @private
        //  */
        // public static fromString(string : string) : PdfImage {
        //     let image : PdfImage = new PdfBitmap(string);
        //     return image;
        // }
        /**
         * Gets the `element` image stream.
         * @private
         */ get: function() {
            return this.imageStream;
        },
        enumerable: true,
        configurable: true
    });
    PdfImage.prototype.getPointSize = function(width, height, horizontalResolution, verticalResolution) {
        if (typeof horizontalResolution === "undefined") {
            var dpiX = (0, $b9b65a21308d53b7$export$17a6eabe6043f9d7).horizontalResolution;
            var dpiY = (0, $b9b65a21308d53b7$export$17a6eabe6043f9d7).verticalResolution;
            var size = this.getPointSize(width, height, dpiX, dpiY);
            return size;
        } else {
            var ucX = new (0, $b9b65a21308d53b7$export$17a6eabe6043f9d7)(horizontalResolution);
            var ucY = new (0, $b9b65a21308d53b7$export$17a6eabe6043f9d7)(verticalResolution);
            var ptWidth = ucX.convertUnits(width, (0, $d174213b46afc09a$export$974c8f70aaa706fb).Pixel, (0, $d174213b46afc09a$export$974c8f70aaa706fb).Point);
            var ptHeight = ucY.convertUnits(height, (0, $d174213b46afc09a$export$974c8f70aaa706fb).Pixel, (0, $d174213b46afc09a$export$974c8f70aaa706fb).Point);
            var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(ptWidth, ptHeight);
            return size;
        }
    };
    return PdfImage;
}();


var $c987c917f397d328$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The 'PdfBitmap' contains methods and properties to handle the Bitmap images.
 * ```typescript
 * // create a new PDF document.
 * let document : PdfDocument = new PdfDocument();
 * // add a page to the document.
 * let page1 : PdfPage = document.pages.add();
 * // base64 string of an image
 * let imageString : string = '/9j/3+2w7em7HzY/KiijFw … 1OEYRUYrQ45yc5OUtz/9k=';
 * // load the image from the base64 string of original image.
 * let image : PdfBitmap = new PdfBitmap(imageString);
 * // draw the image
 * page1.graphics.drawImage(image, new RectangleF({x : 10, y : 10}, {width : 200, height : 200}));
 * // save the document.
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $c987c917f397d328$export$a738614a0b6b3b5a = /** @class */ function(_super) {
    $c987c917f397d328$var$__extends(PdfBitmap, _super);
    /**
     * Create an instance for `PdfBitmap` class.
     * @param encodedString Base64 string of an image.
     * ```typescript
     * // create a new PDF document.
     * let document : PdfDocument = new PdfDocument();
     * // add a page to the document.
     * let page1 : PdfPage = document.pages.add();
     * // base64 string of an image
     * let imageString : string = '/9j/3+2w7em7HzY/KiijFw … 1OEYRUYrQ45yc5OUtz/9k=';
     * //
     * // load the image from the base64 string of original image.
     * let image : PdfBitmap = new PdfBitmap(imageString);
     * //
     * // draw the image
     * page1.graphics.drawImage(image, new RectangleF({x : 10, y : 10}, {width : 200, height : 200}));
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     */ function PdfBitmap(encodedString) {
        var _this = _super.call(this) || this;
        //Fields
        /**
         * Specifies the `status` of an image.
         * @default true.
         * @hidden
         * @private
         */ _this.imageStatus = true;
        /**
         * Internal variable for accessing fields from `DictionryProperties` class.
         * @hidden
         * @private
         */ _this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        _this.loadImage(encodedString);
        return _this;
    }
    /**
     * `Load image`.
     * @hidden
     * @private
     */ PdfBitmap.prototype.loadImage = function(encodedString) {
        var task = this.initializeAsync(encodedString);
    };
    /**
     * `Initialize` image parameters.
     * @private
     */ PdfBitmap.prototype.initializeAsync = function(encodedString) {
        var byteArray = new (0, $72b64e0afda10076$export$a963f15d59b126e1)(encodedString.length);
        byteArray.writeFromBase64String(encodedString);
        this.decoder = new (0, $62c521254d9ede6b$export$e6116f64ca24c416)(byteArray);
        this.height = this.decoder.height;
        this.width = this.decoder.width;
        // FrameCount = BitmapImageDecoder.FrameCount;
        this.bitsPerComponent = this.decoder.bitsPerComponent;
    };
    /**
     * `Saves` the image into stream.
     * @private
     */ PdfBitmap.prototype.save = function() {
        this.imageStatus = true;
        this.imageStream = this.decoder.getImageDictionary();
    };
    return PdfBitmap;
}((0, $722331ec33bd9a93$export$ee8313b7edf5feab));

/**
 * PdfBorders.ts class for EJ2-PDF
 */ /**
 * PdfPen.ts class for EJ2-PDF
 */ 




/**
 * Implements structures and routines working with `color`.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a new page to the document
 * let page1 : PdfPage = document.pages.add();
 * // set the font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * //
 * // set color
 * let brushColor : PdfColor = new PdfColor(0, 0, 0);
 * //
 * // create black brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(brushColor);
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 * @default black color
 */ var $e81c483e1287b796$export$4eb81a4e8d53d55d = /** @class */ function() {
    function PdfColor(color1, color2, color3, color4) {
        if (typeof color1 === "undefined") {
            if (typeof color2 !== "undefined" && typeof color3 !== "undefined" && typeof color4 !== "undefined") this.assignRGB(color2, color3, color4);
            else this.filled = false;
        } else if (color1 instanceof PdfColor) {
            this.redColor = color1.r;
            this.greenColor = color1.g;
            this.blueColor = color1.b;
            this.grayColor = color1.gray;
            this.alpha = color1.alpha;
            this.filled = this.alpha !== 0;
        /* tslint:disable-next-line:max-line-length */ } else if (typeof color1 === "number" && typeof color2 === "undefined" && typeof color3 === "undefined" && typeof color4 === "undefined") {
            if (color1 < 0) color1 = 0;
            if (color1 > 1) color1 = 1;
            this.redColor = color1 * PdfColor.maxColourChannelValue;
            this.greenColor = color1 * PdfColor.maxColourChannelValue;
            this.blueColor = color1 * PdfColor.maxColourChannelValue;
            this.cyanColor = color1;
            this.magentaColor = color1;
            this.yellowColor = color1;
            this.blackColor = color1;
            this.grayColor = color1;
            this.alpha = PdfColor.maxColourChannelValue;
            this.filled = true;
        } else if (typeof color4 === "undefined") this.assignRGB(color1, color2, color3);
        else this.assignRGB(color2, color3, color4, color1);
    }
    /**
     * `Assign` red, green, blue colors with alpha value..
     * @private
     */ PdfColor.prototype.assignRGB = function(r, g, b, a) {
        if (typeof r === "undefined" || typeof g === "undefined" || typeof b === "undefined") this.filled = false;
        else {
            this.cyanColor = 0;
            this.magentaColor = 0;
            this.yellowColor = 0;
            this.blackColor = 0;
            this.grayColor = 0;
            this.redColor = r;
            this.greenColor = g;
            this.blueColor = b;
            if (typeof a === "undefined") this.alpha = PdfColor.maxColourChannelValue;
            else this.alpha = a;
            this.filled = true;
            this.assignCMYK(r, g, b);
        }
    };
    /**
     * `Calculate and assign` cyan, megenta, yellow colors from rgb values..
     * @private
     */ PdfColor.prototype.assignCMYK = function(r, g, b) {
        var red = r / PdfColor.maxColourChannelValue;
        var green = g / PdfColor.maxColourChannelValue;
        var blue = b / PdfColor.maxColourChannelValue;
        var black = (0, $f982301cdcaba043$export$8883fe148ef336b4).min(1 - red, 1 - green, 1 - blue);
        var cyan = black === 1.0 ? 0 : (1 - red - black) / (1 - black);
        var magenta = black === 1.0 ? 0 : (1 - green - black) / (1 - black);
        var yellow = black === 1.0 ? 0 : (1 - blue - black) / (1 - black);
        this.blackColor = black;
        this.cyanColor = cyan;
        this.magentaColor = magenta;
        this.yellowColor = yellow;
    };
    Object.defineProperty(PdfColor.prototype, "r", {
        //Properties
        // public static get Empty():PdfColor
        // {
        //     return this.s_emptyColor
        // }
        /**
         * Gets or sets `Red` channel value.
         * @private
         */ get: function() {
            return this.redColor;
        },
        set: function(value) {
            this.redColor = value;
            this.assignCMYK(this.redColor, this.greenColor, this.blueColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "red", {
        /**
         * Gets the `Red` color
         * @private
         */ get: function() {
            return this.r / PdfColor.maxColourChannelValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "b", {
        /**
         * Gets or sets `Blue` channel value.
         * @private
         */ get: function() {
            return this.blueColor;
        },
        set: function(value) {
            this.blueColor = value;
            this.assignCMYK(this.redColor, this.greenColor, this.blueColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "blue", {
        /**
         * Gets the `blue` color.
         * @private
         */ get: function() {
            return this.b / PdfColor.maxColourChannelValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "c", {
        /**
         * Gets or sets `Cyan` channel value.
         * @private
         */ get: function() {
            return this.cyanColor;
        },
        set: function(value) {
            if (value < 0) this.cyanColor = 0;
            else if (value > 1) this.cyanColor = 1;
            else this.cyanColor = value;
            this.assignRGB(this.cyanColor, this.magentaColor, this.yellowColor, this.blackColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "k", {
        /**
         * Gets or sets `Black` channel value.
         * @private
         */ get: function() {
            return this.blackColor;
        },
        set: function(value) {
            if (value < 0) this.blackColor = 0;
            else if (value > 1) this.blackColor = 1;
            else this.blackColor = value;
            this.assignRGB(this.cyanColor, this.magentaColor, this.yellowColor, this.blackColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "m", {
        /**
         * Gets or sets `Magenta` channel value.
         * @private
         */ get: function() {
            return this.magentaColor;
        },
        set: function(value) {
            if (value < 0) this.magentaColor = 0;
            else if (value > 1) this.magentaColor = 1;
            else this.magentaColor = value;
            this.assignRGB(this.cyanColor, this.magentaColor, this.yellowColor, this.blackColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "y", {
        /**
         * Gets or sets `Yellow` channel value.
         * @private
         */ get: function() {
            return this.yellowColor;
        },
        set: function(value) {
            if (value < 0) this.yellowColor = 0;
            else if (value > 1) this.yellowColor = 1;
            else this.yellowColor = value;
            this.assignRGB(this.cyanColor, this.magentaColor, this.yellowColor, this.blackColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "g", {
        /**
         *  Gets or sets `Green` channel value.
         * @private
         */ get: function() {
            return this.greenColor;
        },
        set: function(value) {
            this.greenColor = value;
            this.assignCMYK(this.redColor, this.greenColor, this.blueColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "green", {
        /**
         * Gets the `Green` color.
         * @private
         */ get: function() {
            return this.g / PdfColor.maxColourChannelValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "gray", {
        /**
         * Gets or sets `Gray` channel value.
         * @private
         */ get: function() {
            return (this.redColor + this.greenColor + this.blueColor) / (PdfColor.maxColourChannelValue * 3);
        },
        set: function(value) {
            if (value < 0) this.grayColor = 0;
            else if (value > 1) this.grayColor = 1;
            else this.grayColor = value;
            this.r = this.grayColor * PdfColor.maxColourChannelValue;
            this.g = this.grayColor * PdfColor.maxColourChannelValue;
            this.b = this.grayColor * PdfColor.maxColourChannelValue;
            this.assignCMYK(this.redColor, this.greenColor, this.blueColor);
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "isEmpty", {
        /**
         * Gets whether the PDFColor `is Empty` or not.
         * @private
         */ get: function() {
            return !this.filled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfColor.prototype, "a", {
        /**
         * Gets or sets `Alpha` channel value.
         * @private
         */ get: function() {
            return this.alpha;
        },
        set: function(value) {
            if (value < 0) this.alpha = 0;
            else // if (this.alpha !== value) {
            this.alpha = value;
            this.filled = true;
        },
        enumerable: true,
        configurable: true
    });
    //Public methods
    /**
     * Converts `PDFColor to PDF string` representation.
     * @private
     */ PdfColor.prototype.toString = function(colorSpace, stroke) {
        if (this.isEmpty) return "";
        var str = "";
        switch(colorSpace){
            case (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb:
                str = this.rgbToString(stroke);
                break;
            case (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).GrayScale:
                str = this.grayScaleToString(stroke);
                break;
            case (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Cmyk:
                str = this.cmykToString(stroke);
                break;
        }
        return str;
    };
    /**
     * Sets `GrayScale` color.
     * @private
     */ PdfColor.prototype.grayScaleToString = function(ifStroking) {
        var gray = this.gray;
        var colour = "";
        var obj = null;
        /* tslint:disable-next-line:max-line-length */ obj = ifStroking ? PdfColor.grayStringsSroke.containsKey(gray) ? PdfColor.grayStringsSroke.getValue(gray) : null : PdfColor.grayStringsFill.containsKey(gray) ? PdfColor.grayStringsFill.getValue(gray) : null;
        if (obj == null) {
            if (ifStroking) {
                colour = gray.toString() + " G";
                PdfColor.grayStringsSroke.setValue(gray, colour);
            }
        } else colour = obj.toString();
        return colour + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
    };
    /**
     * Sets `RGB` color.
     * @private
     */ PdfColor.prototype.rgbToString = function(ifStroking) {
        var r = this.r;
        var g = this.g;
        var b = this.b;
        var key = (r << 16) + (g << 8) + b;
        if (ifStroking) key += 16777216;
        var colour = "";
        var obj = null;
        if (PdfColor.rgbStrings.containsKey(key)) obj = PdfColor.rgbStrings.getValue(key);
        if (obj == null) {
            var red = r / PdfColor.maxColourChannelValue;
            var green = g / PdfColor.maxColourChannelValue;
            var blue = b / PdfColor.maxColourChannelValue;
            if (ifStroking) colour = red.toString() + " " + green.toString() + " " + blue.toString() + " RG";
            else colour = red.toString() + " " + green.toString() + " " + blue.toString() + " rg";
            PdfColor.rgbStrings.setValue(key, colour);
        } else colour = obj.toString();
        return colour + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
    };
    /***
     * Sets `CMYK` color.
     * @private
     */ PdfColor.prototype.cmykToString = function(ifStroking) {
        var cyan = this.c;
        var magenta = this.m;
        var yellow = this.y;
        var black = this.b;
        var colour = "";
        colour = cyan.toString() + " " + magenta.toString() + " " + yellow.toString() + " " + black.toString() + " K";
        return colour + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
    };
    /**
     * Converts `colour to a PDF array`.
     * @private
     */ PdfColor.prototype.toArray = function(colorSpace) {
        var array = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        switch(colorSpace){
            case (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb:
                array.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.red));
                array.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.green));
                array.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.blue));
                break;
        }
        return array;
    };
    //Fields
    /**
     * Holds `RGB colors` converted into strings.
     * @private
     */ PdfColor.rgbStrings = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    /**
     * Holds Gray scale colors converted into strings for `stroking`.
     * @private
     */ PdfColor.grayStringsSroke = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    /**
     * Holds Gray scale colors converted into strings for `filling`.
     * @private
     */ PdfColor.grayStringsFill = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    /**
     * `Max value` of color channel.
     * @private
     */ PdfColor.maxColourChannelValue = 255.0;
    return PdfColor;
}();




/**
 * `PdfBrush` class provides objects used to fill the interiors of graphical shapes such as rectangles,
 * ellipses, pies, polygons, and paths.
 * @private
 */ var $7e20ae7ea9857864$export$e91b732cd7775ec5 = /** @class */ function() {
    /**
     * Creates instanceof `PdfBrush` class.
     * @hidden
     * @private
     */ function PdfBrush() {
    //
    }
    //IClonable implementation
    PdfBrush.prototype.clone = function() {
        return this;
    };
    return PdfBrush;
}();


var $8d6e90cfe5409a69$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents a brush that fills any object with a solid color.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a pages to the document
 * let page1 : PdfPage = document.pages.add();
 * // set font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * // set brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10));
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $8d6e90cfe5409a69$export$b12f80b59b66a57e = /** @class */ function(_super) {
    $8d6e90cfe5409a69$var$__extends(PdfSolidBrush, _super);
    //Constructors
    /**
     * Initializes a new instance of the `PdfSolidBrush` class.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // add a pages to the document
     * let page1 : PdfPage = document.pages.add();
     * // set font
     * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
     * // set brush
     * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
     * // draw the text
     * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10));
     * // save the document
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param color color of the brush
     */ function PdfSolidBrush(color) {
        var _this = _super.call(this) || this;
        _this.pdfColor = color;
        return _this;
    }
    Object.defineProperty(PdfSolidBrush.prototype, "color", {
        //Properties
        /**
         * Gets or sets the `color` of the brush.
         * @private
         */ get: function() {
            return this.pdfColor;
        },
        set: function(value) {
            this.pdfColor = value;
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    /**
     * `Monitors` the changes of the brush and modify PDF state respectively.
     * @private
     */ PdfSolidBrush.prototype.monitorChanges = function(brush, streamWriter, getResources, saveChanges, currentColorSpace) {
        if (streamWriter == null) throw new Error("ArgumentNullException:streamWriter");
        var diff = false;
        if (brush == null) {
            diff = true;
            streamWriter.setColorAndSpace(this.pdfColor, currentColorSpace, false);
            return diff;
        } else {
            var sBrush = brush;
            diff = true;
            streamWriter.setColorAndSpace(this.pdfColor, currentColorSpace, false);
            return diff;
        }
    };
    /**
     * `Resets` the changes, which were made by the brush.
     * @private
     */ PdfSolidBrush.prototype.resetChanges = function(streamWriter) {
        streamWriter.setColorAndSpace(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0), (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb, false);
    };
    return PdfSolidBrush;
}((0, $7e20ae7ea9857864$export$e91b732cd7775ec5));




/**
 * `PdfPen` class defining settings for drawing operations, that determines the color,
 * width, and style of the drawing elements.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // create a new page
 * let page1 : PdfPage = document.pages.add();
 * // set pen
 * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
 * // draw rectangle
 * page1.graphics.drawRectangle(pen, new RectangleF({x : 0, y : 0}, {width : 100, height : 50}));
 * // save the document.
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $54efcdfb173c5ebf$export$c07084e815da81a4 = /** @class */ function() {
    function PdfPen(arg1, arg2) {
        //Fields
        /**
         * Specifies the `color of the pen`.
         * @default new PdfColor()
         * @private
         */ this.pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0);
        /**
         * Specifies the `dash offset of the pen`.
         * @default 0
         * @private
         */ this.dashOffsetValue = 0;
        /**
         * Specifies the `dash pattern of the pen`.
         * @default [0]
         * @private
         */ this.penDashPattern = [
            0
        ];
        /**
         * Specifies the `dash style of the pen`.
         * @default Solid
         * @private
         */ this.pdfDashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
        /**
         * Specifies the `line cap of the pen`.
         * @default 0
         * @private
         */ this.pdfLineCap = 0;
        /**
         * Specifies the `line join of the pen`.
         * @default 0
         * @private
         */ this.pdfLineJoin = 0;
        /**
         * Specifies the `width of the pen`.
         * @default 1.0
         * @private
         */ this.penWidth = 1.0;
        /**
         * Specifies the `mitter limit of the pen`.
         * @default 0.0
         * @private
         */ this.internalMiterLimit = 0.0;
        /**
         * Stores the `colorspace` value.
         * @default Rgb
         * @private
         */ this.colorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        if (arg1 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5)) this.setBrush(arg1);
        else if (arg1 instanceof (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)) this.color = arg1;
        if (typeof arg2 === "number") this.width = arg2;
    }
    Object.defineProperty(PdfPen.prototype, "color", {
        //Properties
        /**
         * Gets or sets the `color of the pen`.
         * @private
         */ get: function() {
            return this.pdfColor;
        },
        set: function(value) {
            this.pdfColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "dashOffset", {
        /**
         * Gets or sets the `dash offset of the pen`.
         * @private
         */ get: function() {
            if (typeof this.dashOffsetValue === "undefined" || this.dashOffsetValue == null) return 0;
            else return this.dashOffsetValue;
        },
        set: function(value) {
            this.dashOffsetValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "dashPattern", {
        /**
         * Gets or sets the `dash pattern of the pen`.
         * @private
         */ get: function() {
            return this.penDashPattern;
        },
        set: function(value) {
            this.penDashPattern = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "dashStyle", {
        /**
         * Gets or sets the `dash style of the pen`.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // create a new page
         * let page1 : PdfPage = document.pages.add();
         * // set pen
         * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
         * //
         * // set pen style
         * pen.dashStyle = PdfDashStyle.DashDot;
         * // get pen style
         * let style : PdfDashStyle = pen.dashStyle;
         * //
         * // draw rectangle
         * page1.graphics.drawRectangle(pen, new RectangleF({x : 0, y : 0}, {width : 100, height : 50}));
         * // save the document.
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.pdfDashStyle;
        },
        set: function(value) {
            if (this.pdfDashStyle !== value) {
                this.pdfDashStyle = value;
                switch(this.pdfDashStyle){
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Custom:
                        break;
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Dash:
                        this.penDashPattern = [
                            3,
                            1
                        ];
                        break;
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Dot:
                        this.penDashPattern = [
                            1,
                            1
                        ];
                        break;
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).DashDot:
                        this.penDashPattern = [
                            3,
                            1,
                            1,
                            1
                        ];
                        break;
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).DashDotDot:
                        this.penDashPattern = [
                            3,
                            1,
                            1,
                            1,
                            1,
                            1
                        ];
                        break;
                    case (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid:
                        break;
                    default:
                        this.pdfDashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
                        this.penDashPattern = [
                            0
                        ];
                        break;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "lineCap", {
        /**
         * Gets or sets the `line cap of the pen`.
         * @private
         */ get: function() {
            return this.pdfLineCap;
        },
        set: function(value) {
            this.pdfLineCap = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "lineJoin", {
        /**
         * Gets or sets the `line join style of the pen`.
         * @private
         */ get: function() {
            return this.pdfLineJoin;
        },
        set: function(value) {
            this.pdfLineJoin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "miterLimit", {
        /**
         * Gets or sets the `miter limit`.
         * @private
         */ get: function() {
            return this.internalMiterLimit;
        },
        set: function(value) {
            this.internalMiterLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPen.prototype, "width", {
        /**
         * Gets or sets the `width of the pen`.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // create a new page
         * let page1 : PdfPage = document.pages.add();
         * // set pen
         * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
         * //
         * // set pen width
         * pen.width = 2;
         * //
         * // draw rectangle
         * page1.graphics.drawRectangle(pen, new RectangleF({x : 0, y : 0}, {width : 100, height : 50}));
         * // save the document.
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.penWidth;
        },
        set: function(value) {
            this.penWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    //Helper
    /**
     * `Clones` this instance of PdfPen class.
     * @private
     */ PdfPen.prototype.clone = function() {
        var pen = this;
        return pen;
    };
    /**
     * `Sets the brush`.
     * @private
     */ PdfPen.prototype.setBrush = function(brush) {
        var sBrush = brush;
        if (sBrush != null && sBrush instanceof (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)) {
            this.color = sBrush.color;
            this.pdfBrush = sBrush;
        }
        this.color = sBrush.color;
        this.pdfBrush = sBrush;
    };
    /**
     * `Monitors the changes`.
     * @private
     */ PdfPen.prototype.monitorChanges = function(currentPen, streamWriter, getResources, saveState, currentColorSpace, matrix) {
        var diff = false;
        saveState = true;
        if (currentPen == null) diff = true;
        diff = this.dashControl(currentPen, saveState, streamWriter);
        streamWriter.setLineWidth(this.width);
        streamWriter.setLineJoin(this.lineJoin);
        streamWriter.setLineCap(this.lineCap);
        var miterLimit = this.miterLimit;
        if (miterLimit > 0) {
            streamWriter.setMiterLimit(miterLimit);
            diff = true;
        }
        var brush = this.pdfBrush;
        streamWriter.setColorAndSpace(this.color, currentColorSpace, true);
        diff = true;
        return diff;
    };
    /**
     * `Controls the dash style` and behaviour of each line.
     * @private
     */ PdfPen.prototype.dashControl = function(pen, saveState, streamWriter) {
        saveState = true;
        var lineWidth = this.width;
        var pattern = this.getPattern();
        streamWriter.setLineDashPattern(pattern, this.dashOffset * lineWidth);
        return saveState;
    };
    /**
     * `Gets the pattern` of PdfPen.
     * @private
     */ PdfPen.prototype.getPattern = function() {
        var pattern = this.dashPattern;
        for(var i = 0; i < pattern.length; ++i)pattern[i] *= this.width;
        return pattern;
    };
    return PdfPen;
}();




/**
 * `PdfBorders` class used represents the cell border of the PDF grid.
 */ var $446c769ec2cda75b$export$69818a9b64460535 = /** @class */ function() {
    // Constructor
    /**
     * Create a new instance for `PdfBorders` class.
     * @private
     */ function PdfBorders() {
        var defaultBorderPenLeft = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        defaultBorderPenLeft.dashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
        var defaultBorderPenRight = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        defaultBorderPenRight.dashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
        var defaultBorderPenTop = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        defaultBorderPenTop.dashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
        var defaultBorderPenBottom = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        defaultBorderPenBottom.dashStyle = (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid;
        this.leftPen = defaultBorderPenLeft;
        this.rightPen = defaultBorderPenRight;
        this.topPen = defaultBorderPenTop;
        this.bottomPen = defaultBorderPenBottom;
    }
    Object.defineProperty(PdfBorders.prototype, "left", {
        // Properties
        /**
         * Gets or sets the `Left`.
         * @private
         */ get: function() {
            return this.leftPen;
        },
        set: function(value) {
            this.leftPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders.prototype, "right", {
        /**
         * Gets or sets the `Right`.
         * @private
         */ get: function() {
            return this.rightPen;
        },
        set: function(value) {
            this.rightPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders.prototype, "top", {
        /**
         * Gets or sets the `Top`.
         * @private
         */ get: function() {
            return this.topPen;
        },
        set: function(value) {
            this.topPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders.prototype, "bottom", {
        /**
         * Gets or sets the `Bottom`.
         * @private
         */ get: function() {
            return this.bottomPen;
        },
        set: function(value) {
            this.bottomPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders.prototype, "all", {
        /**
         * sets the `All`.
         * @private
         */ set: function(value) {
            this.leftPen = this.rightPen = this.topPen = this.bottomPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders.prototype, "isAll", {
        /**
         * Gets a value indicating whether this instance `is all`.
         * @private
         */ get: function() {
            return this.leftPen === this.rightPen && this.leftPen === this.topPen && this.leftPen === this.bottomPen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBorders, "default", {
        /**
         * Gets the `default`.
         * @private
         */ get: function() {
            return new PdfBorders();
        },
        enumerable: true,
        configurable: true
    });
    return PdfBorders;
}();
var $446c769ec2cda75b$export$98e68eadb1bc5ba0 = /** @class */ function() {
    function PdfPaddings(left, right, top, bottom) {
        /**
         * The 'left' border padding set.
         * @private
         */ this.hasLeftPad = false;
        /**
         * The 'right' border padding set.
         * @private
         */ this.hasRightPad = false;
        /**
         * The 'top' border padding set.
         * @private
         */ this.hasTopPad = false;
        /**
         * The 'bottom' border padding set.
         * @private
         */ this.hasBottomPad = false;
        if (typeof left === "undefined") //0.5 is set for top and bottom by default.
        this.bottomPad = this.topPad = this.leftPad = this.rightPad = 0.5;
        else {
            this.leftPad = left;
            this.rightPad = right;
            this.topPad = top;
            this.bottomPad = bottom;
            this.hasLeftPad = true;
            this.hasRightPad = true;
            this.hasTopPad = true;
            this.hasBottomPad = true;
        }
    }
    Object.defineProperty(PdfPaddings.prototype, "left", {
        // Properties
        /**
         * Gets or sets the `left` value of the edge
         * @private
         */ get: function() {
            return this.leftPad;
        },
        set: function(value) {
            this.leftPad = value;
            this.hasLeftPad = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPaddings.prototype, "right", {
        /**
         * Gets or sets the `right` value of the edge.
         * @private
         */ get: function() {
            return this.rightPad;
        },
        set: function(value) {
            this.rightPad = value;
            this.hasRightPad = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPaddings.prototype, "top", {
        /**
         * Gets or sets the `top` value of the edge
         * @private
         */ get: function() {
            return this.topPad;
        },
        set: function(value) {
            this.topPad = value;
            this.hasTopPad = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPaddings.prototype, "bottom", {
        /**
         * Gets or sets the `bottom` value of the edge.
         * @private
         */ get: function() {
            return this.bottomPad;
        },
        set: function(value) {
            this.bottomPad = value;
            this.hasBottomPad = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPaddings.prototype, "all", {
        /**
         * Sets value to all sides `left,right,top and bottom`.s
         * @private
         */ set: function(value) {
            this.leftPad = this.rightPad = this.topPad = this.bottomPad = value;
            this.hasLeftPad = true;
            this.hasRightPad = true;
            this.hasTopPad = true;
            this.hasBottomPad = true;
        },
        enumerable: true,
        configurable: true
    });
    return PdfPaddings;
}();




/**
 * Used to `write a string` into output file.
 * @private
 */ var $4962a411bd3103d0$export$94ae96e4b9812ca4 = /** @class */ function() {
    /**
     * Initialize an instance of `PdfWriter` class.
     * @private
     */ function PdfWriter(stream) {
        this.streamWriter = stream;
    }
    Object.defineProperty(PdfWriter.prototype, "document", {
        //properties
        /**
         * Gets and Sets the `document`.
         * @private
         */ get: function() {
            return this.pdfDocument;
        },
        set: function(value) {
            this.pdfDocument = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfWriter.prototype, "position", {
        /**
         * Gets the `position`.
         * @private
         */ get: function() {
            return this.streamWriter.buffer.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfWriter.prototype, "length", {
        /**
         * Gets  the `length` of the stream'.
         * @private
         */ get: function() {
            return this.streamWriter.buffer.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfWriter.prototype, "stream", {
        /**
         * Gets the `stream`.
         * @private
         */ get: function() {
            var result = this.streamWriter;
            return result;
        },
        enumerable: true,
        configurable: true
    });
    //public Methods
    /**
     * `Writes the specified data`.
     * @private
     */ PdfWriter.prototype.write = function(overload) {
        var data = [];
        var tempOverload = overload;
        this.streamWriter.write(tempOverload);
    };
    return PdfWriter;
}();


/**
 * PdfMainObjectCollection.ts class for EJ2-PDF
 */ 
/**
 * public Enum for `CompositeFontType`.
 * @private
 */ var $02768fe98966b169$export$514cd0390d5ec73b;
(function(ObjectStatus) {
    /**
     * Specifies the type of `None`.
     * @private
     */ ObjectStatus[ObjectStatus["None"] = 0] = "None";
    /**
     * Specifies the type of `Registered`.
     * @private
     */ ObjectStatus[ObjectStatus["Registered"] = 1] = "Registered";
})($02768fe98966b169$export$514cd0390d5ec73b || ($02768fe98966b169$export$514cd0390d5ec73b = {}));


/**
 * The collection of all `objects` within a PDF document.
 * @private
 */ var $6f19eb0a6c25f093$export$2a7f345104069332 = /** @class */ function() {
    function PdfMainObjectCollection() {
        //Fields
        /**
         * The collection of the `indirect objects`.
         * @default []
         * @private
         */ this.objectCollections = [];
        /**
         * The collection of the `Indirect objects`.
         * @default new Dictionary<number, ObjectInfo>()
         * @private
         */ this.mainObjectCollection = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        /**
         * The collection of `primitive objects`.
         * @private
         */ this.primitiveObjectCollection = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    }
    Object.defineProperty(PdfMainObjectCollection.prototype, "count", {
        //Properties
        /**
         * Gets the `count`.
         * @private
         */ get: function() {
            return this.objectCollections.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the value of `ObjectInfo` from object collection.
     * @private
     */ PdfMainObjectCollection.prototype.items = function(index) {
        return this.objectCollections[index];
    };
    Object.defineProperty(PdfMainObjectCollection.prototype, "outIsNew", {
        //Methods
        /**
         * Specifies the value of `IsNew`.
         * @private
         */ get: function() {
            return this.isNew;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Adds` the specified element.
     * @private
     */ PdfMainObjectCollection.prototype.add = function(element) {
        var objInfo = new $6f19eb0a6c25f093$export$f088a8ef4c3b2f33(element);
        this.objectCollections.push(objInfo);
        if (!this.primitiveObjectCollection.containsKey(element)) this.primitiveObjectCollection.setValue(element, this.objectCollections.length - 1);
        element.position = this.index = this.objectCollections.length - 1;
        element.status = (0, $02768fe98966b169$export$514cd0390d5ec73b).Registered;
    };
    /**
     * `Looks` through the collection for the object specified.
     * @private
     */ PdfMainObjectCollection.prototype.lookFor = function(obj) {
        var index = -1;
        if (obj.position !== -1) return obj.position;
        if (this.primitiveObjectCollection.containsKey(obj) && this.count === this.primitiveObjectCollection.size()) index = this.primitiveObjectCollection.getValue(obj);
        else for(var i = this.count - 1; i >= 0; i--){
            var oi = this.objectCollections[i];
            if (oi.object === obj) {
                index = i;
                break;
            }
        }
        return index;
    };
    /**
     * Gets the `reference of the object`.
     * @private
     */ PdfMainObjectCollection.prototype.getReference = function(index, isNew) {
        this.index = this.lookFor(index);
        var reference;
        this.isNew = false;
        var oi = this.objectCollections[this.index];
        reference = oi.reference;
        var obj = {
            reference: reference,
            wasNew: isNew
        };
        return obj;
    };
    /**
     * Tries to set the `reference to the object`.
     * @private
     */ PdfMainObjectCollection.prototype.trySetReference = function(obj, reference, found) {
        var result = true;
        found = true;
        this.index = this.lookFor(obj);
        var oi = this.objectCollections[this.index];
        oi.setReference(reference);
        return result;
    };
    PdfMainObjectCollection.prototype.destroy = function() {
        for(var _i = 0, _a = this.objectCollections; _i < _a.length; _i++){
            var obj = _a[_i];
            if (obj !== undefined) {
                obj.pdfObject.position = -1;
                obj.pdfObject.isSaving = undefined;
                obj.pdfObject.objectCollectionIndex = undefined;
                obj.pdfObject.position = undefined;
            }
        }
        this.objectCollections = [];
        this.mainObjectCollection = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        this.primitiveObjectCollection = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    };
    return PdfMainObjectCollection;
}();
var $6f19eb0a6c25f093$export$f088a8ef4c3b2f33 = /** @class */ function() {
    function ObjectInfo(obj, reference) {
        this.pdfObject = obj;
        this.pdfReference = reference;
    }
    Object.defineProperty(ObjectInfo.prototype, "object", {
        //Properties
        /**
         * Gets the `object`.
         * @private
         */ get: function() {
            return this.pdfObject;
        },
        set: function(value) {
            this.pdfObject = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectInfo.prototype, "reference", {
        /**
         * Gets the `reference`.
         * @private
         */ get: function() {
            return this.pdfReference;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the `reference`.
     * @private
     */ ObjectInfo.prototype.setReference = function(reference) {
        this.pdfReference = reference;
    };
    return ObjectInfo;
}();




/**
 * StreamWriter class contains the implementation for writing characters to a file in a particular encoding
 * ```typescript
 * let writer = new StreamWriter();
 * writer.write('Hello World');
 * writer.save('Sample.txt');
 * writer.dispose();
 * ```
 */ var $425422db70c8935a$export$4fe5df31cd7ec096 = /** @class */ function() {
    /**
     * Initializes a new instance of the StreamWriter class by using the specified encoding.
     * @param  {Encoding} encoding?- The character encoding to use.
     */ function StreamWriter(encoding) {
        this.bufferBlob = new Blob([
            ""
        ]);
        this.bufferText = "";
        this.init(encoding);
        (0, $2da9a4aa9748e8c8$export$be11e187edb4cb0c).isMicrosoftBrowser = !!navigator.msSaveBlob;
    }
    Object.defineProperty(StreamWriter.prototype, "buffer", {
        /**
         * Gets the content written to the StreamWriter as Blob.
         * @returns Blob
         */ get: function() {
            this.flush();
            return this.bufferBlob;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreamWriter.prototype, "encoding", {
        /**
         * Gets the encoding.
         * @returns Encoding
         */ get: function() {
            return this.enc;
        },
        enumerable: true,
        configurable: true
    });
    StreamWriter.prototype.init = function(encoding) {
        if (encoding === null || encoding === undefined) {
            this.enc = new (0, $d16335ea6d5a8183$export$72958ca7c468c63b)(false);
            this.enc.type = "Utf8";
        } else {
            this.enc = encoding;
            this.setBomByte();
        }
    };
    /**
     * Private method to set Byte Order Mark(BOM) value based on EncodingType
     */ StreamWriter.prototype.setBomByte = function() {
        if (this.encoding.includeBom) switch(this.encoding.type){
            case "Unicode":
                var arrayUnicode = new ArrayBuffer(2);
                var uint8 = new Uint8Array(arrayUnicode);
                uint8[0] = 255;
                uint8[1] = 254;
                this.bufferBlob = new Blob([
                    arrayUnicode
                ]);
                break;
            case "Utf8":
                var arrayUtf8 = new ArrayBuffer(3);
                var utf8 = new Uint8Array(arrayUtf8);
                utf8[0] = 239;
                utf8[1] = 187;
                utf8[2] = 191;
                this.bufferBlob = new Blob([
                    arrayUtf8
                ]);
                break;
            default:
                this.bufferBlob = new Blob([
                    ""
                ]);
                break;
        }
    };
    /**
     * Saves the file with specified name and sends the file to client browser
     * @param  {string} fileName - The file name to save
     * @returns {void}
     */ StreamWriter.prototype.save = function(fileName) {
        if (this.bufferText !== "") this.flush();
        (0, $2da9a4aa9748e8c8$export$be11e187edb4cb0c).save(fileName, this.buffer);
    };
    /**
     * Writes the specified string.
     * @param  {string} value - The string to write. If value is null or undefined, nothing is written.
     * @returns {void}
     */ StreamWriter.prototype.write = function(value) {
        if (this.encoding === undefined) throw new Error("Object Disposed Exception: current writer is disposed");
        (0, $d16335ea6d5a8183$export$923fbdaad5ed00bc)(value, "string");
        this.bufferText += value;
        if (this.bufferText.length >= 10240) this.flush();
    };
    StreamWriter.prototype.flush = function() {
        if (this.bufferText === undefined || this.bufferText === null || this.bufferText.length === 0) return;
        var bufferArray = this.encoding.getBytes(this.bufferText, 0, this.bufferText.length);
        this.bufferText = "";
        this.bufferBlob = new Blob([
            this.bufferBlob,
            bufferArray
        ]);
    };
    /**
     * Writes the specified string followed by a line terminator
     * @param  {string} value - The string to write. If value is null or undefined, nothing is written
     * @returns {void}
     */ StreamWriter.prototype.writeLine = function(value) {
        if (this.encoding === undefined) throw new Error("Object Disposed Exception: current writer is disposed");
        (0, $d16335ea6d5a8183$export$923fbdaad5ed00bc)(value, "string");
        this.bufferText = this.bufferText + value + "\r\n";
        if (this.bufferText.length >= 10240) this.flush();
    };
    /**
     * Releases the resources used by the StreamWriter
     * @returns {void}
     */ StreamWriter.prototype.destroy = function() {
        this.bufferBlob = undefined;
        this.bufferText = undefined;
        if (this.enc instanceof (0, $d16335ea6d5a8183$export$72958ca7c468c63b)) this.enc.destroy();
        this.enc = undefined;
    };
    return StreamWriter;
}();



/**
 * `PdfDocumentBase` class represent common properties of PdfDocument classes.
 * @private
 */ var $8bdeb2916eaf3ca0$export$423f0e8d02c69ea3 = /** @class */ function() {
    function PdfDocumentBase(document) {
        /**
         * If the stream is copied,  then it specifies true.
         * @private
         */ this.isStreamCopied = false;
        if (document instanceof (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e)) this.document = document;
    }
    Object.defineProperty(PdfDocumentBase.prototype, "pdfObjects", {
        //Prpperties
        /**
         * Gets the `PDF objects` collection, which stores all objects and references to it..
         * @private
         */ get: function() {
            return this.objects;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentBase.prototype, "crossTable", {
        /**
         * Gets the `cross-reference` table.
         * @private
         */ get: function() {
            return this.pdfCrossTable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentBase.prototype, "currentSavingObj", {
        /**
         * Gets or sets the current saving `object number`.
         * @private
         */ get: function() {
            return this.currentSavingObject;
        },
        set: function(value) {
            this.currentSavingObject = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentBase.prototype, "catalog", {
        /**
         * Gets the PDF document `catalog`.
         * @private
         */ get: function() {
            return this.pdfCatalog;
        },
        set: function(value) {
            this.pdfCatalog = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentBase.prototype, "viewerPreferences", {
        /**
         * Gets viewer preferences for presenting the PDF document in a viewer.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets viewer preferences
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.pdfCatalog.viewerPreferences;
        },
        enumerable: true,
        configurable: true
    });
    //Public methods
    /**
     * Sets the `main object collection`.
     * @private
     */ PdfDocumentBase.prototype.setMainObjectCollection = function(mainObjectCollection) {
        this.objects = mainObjectCollection;
    };
    /**
     * Sets the `cross table`.
     * @private
     */ PdfDocumentBase.prototype.setCrossTable = function(cTable) {
        this.pdfCrossTable = cTable;
    };
    /**
     * Sets the `catalog`.
     * @private
     */ PdfDocumentBase.prototype.setCatalog = function(catalog) {
        this.pdfCatalog = catalog;
    };
    PdfDocumentBase.prototype.save = function(filename) {
        var _this = this;
        var encoding = new (0, $d16335ea6d5a8183$export$72958ca7c468c63b)(true);
        var SW = new (0, $425422db70c8935a$export$4fe5df31cd7ec096)(encoding);
        if (typeof filename === "undefined") {
            var encoding_1 = new (0, $d16335ea6d5a8183$export$72958ca7c468c63b)(true);
            var SW_1 = new (0, $425422db70c8935a$export$4fe5df31cd7ec096)(encoding_1);
            return new Promise(function(resolve, reject) {
                /* tslint:disable-next-line:no-any */ var obj = {};
                obj.blobData = new Blob([
                    _this.document.docSave(SW_1, true)
                ], {
                    type: "application/pdf"
                });
                resolve(obj);
            });
        } else this.document.docSave(SW, filename, true);
    };
    /**
     * `Clone` of parent object - PdfDocument.
     * @private
     */ PdfDocumentBase.prototype.clone = function() {
        return this.document;
    };
    return PdfDocumentBase;
}();








/**
 * public Enum for `ObjectType`.
 * @private
 */ var $6640501c19ed3dd0$export$53f0d9fcb05d9d1d;
(function(ObjectType) {
    /**
     * Specifies the type of `Free`.
     * @private
     */ ObjectType[ObjectType["Free"] = 0] = "Free";
    /**
     * Specifies the type of `Normal`.
     * @private
     */ ObjectType[ObjectType["Normal"] = 1] = "Normal";
    /**
     * Specifies the type of `Packed`.
     * @private
     */ ObjectType[ObjectType["Packed"] = 2] = "Packed";
})($6640501c19ed3dd0$export$53f0d9fcb05d9d1d || ($6640501c19ed3dd0$export$53f0d9fcb05d9d1d = {}));












/**
 * Defines the way the document is to be presented on the screen or in print.
 * ```typescript
 * // Create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // Gets viewer preferences
 * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
 * // Destroy the document
 * document.destroy();
 * ```
 */ var $534bc6c598ecff3c$export$f25d215107823603 = /** @class */ function() {
    /**
     * Initialize a new instance of `PdfViewerPreferences` class.
     *
     * @private
     * ```
    */ function PdfViewerPreferences(catalog) {
        this._dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        this._centerWindow = false;
        this._fitWindow = false;
        this._displayTitle = false;
        this._splitWindow = false;
        this._hideMenuBar = false;
        this._hideToolBar = false;
        this._hideWindowUI = false;
        this._pageMode = $534bc6c598ecff3c$export$5745fc7debd2aa42.UseNone;
        this._pageLayout = $534bc6c598ecff3c$export$22f9f17d130f88e.SinglePage;
        this._dictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        this._duplex = $534bc6c598ecff3c$export$7846ac822c2bec23.None;
        this._catalog = catalog;
    }
    Object.defineProperty(PdfViewerPreferences.prototype, "centerWindow", {
        /**
         * A flag specifying whether to position the document’s window in the center of the screen.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the center window
         * let centerWindow : boolean = viewerPreferences.centerWindow;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._centerWindow;
        },
        /**
         * A flag specifying whether to position the document’s window in the center of the screen.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the center window
         * viewerPreferences.centerWindow = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._centerWindow = value;
            this._dictionary.items.setValue(this._dictionaryProperties.centerWindow, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._centerWindow));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "displayTitle", {
        /**
         * A flag specifying whether the window’s title bar should display the document title taken
         * from the Title entry of the document information dictionary. If false, the title bar
         * should instead display the name of the PDF file containing the document.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the display title
         * let displayTitle : boolean = viewerPreferences.displayTitle;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._displayTitle;
        },
        /**
         * A flag specifying whether the window’s title bar should display the document title taken
         * from the Title entry of the document information dictionary. If false, the title bar
         * should instead display the name of the PDF file containing the document.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the display title
         * viewerPreferences.displayTitle = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._displayTitle = value;
            this._dictionary.items.setValue(this._dictionaryProperties.displayTitle, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._displayTitle));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "fitWindow", {
        /**
         * A flag specifying whether to resize the document’s window to fit the size of the first
         * displayed page.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the fit window
         * let fitWindow : boolean = viewerPreferences.fitWindow;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._fitWindow;
        },
        /**
         * A flag specifying whether to resize the document’s window to fit the size of the first
         * displayed page.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the fit window
         * viewerPreferences.fitWindow = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._fitWindow = value;
            this._dictionary.items.setValue(this._dictionaryProperties.fitWindow, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._fitWindow));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "hideMenuBar", {
        /**
         * A flag specifying whether to hide the viewer application’s menu bar when the
         * document is active.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the hide menu bar
         * let hideMenuBar: boolean = viewerPreferences.hideMenuBar;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._hideMenuBar;
        },
        /**
         * A flag specifying whether to hide the viewer application’s menu bar when the
         * document is active.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the hide menu bar
         * viewerPreferences.hideMenuBar = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._hideMenuBar = value;
            this._dictionary.items.setValue(this._dictionaryProperties.hideMenuBar, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._hideMenuBar));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "hideToolBar", {
        /**
         * A flag specifying whether to hide the viewer application’s tool bar when the
         * document is active.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the hide tool bar
         * let hideToolBar: boolean = viewerPreferences.hideToolBar;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._hideToolBar;
        },
        /**
         * A flag specifying whether to hide the viewer application’s tool bar when the
         * document is active.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the hide tool bar
         * viewerPreferences.hideToolbar = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._hideToolBar = value;
            this._dictionary.items.setValue(this._dictionaryProperties.hideToolBar, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._hideToolBar));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "hideWindowUI", {
        /**
         * A flag specifying whether to hide user interface elements in the document’s window
         * (such as scroll bars and navigation controls), leaving only the document’s contents displayed.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the hide window UI
         * let hideWindowUI: boolean = viewerPreferences.hideWindowUI;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._hideWindowUI;
        },
        /**
         * A flag specifying whether to hide user interface elements in the document’s window
         * (such as scroll bars and navigation controls), leaving only the document’s contents displayed.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the hide window UI
         * viewerPreferences.hideWindowUI = true;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._hideWindowUI = value;
            this._dictionary.items.setValue(this._dictionaryProperties.hideWindowUI, new (0, $502bea31c0cd284e$export$9101e1382351029d)(this._hideWindowUI));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "pageMode", {
        /**
         * A name object specifying how the document should be displayed when opened.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the page mode
         * let pageMode: PdfPageMode = viewerPreferences.pageMode;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._pageMode;
        },
        /**
         * A name object specifying how the document should be displayed when opened.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the page mode
         * viewerPreferences.pageMode = PdfPageMode.UseOutlines;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._pageMode = value;
            this._catalog.items.setValue(this._dictionaryProperties.pageMode, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this._mapPageMode(this._pageMode)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "duplex", {
        /**
         * Gets print duplex mode handling option to use when printing the file from the print dialog.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the duplex
         * let duplex : DuplexMode = viewerPreferences.duplex;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._duplex;
        },
        /**
         * Sets print duplex mode handling option to use when printing the file from the print dialog.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the duplex
         * viewerPreferences.duplex = DuplexMode.DuplexFlipLongEdge;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._duplex = value;
            this._catalog.items.setValue(this._dictionaryProperties.duplex, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this._mapDuplexMode(this._duplex)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "pageLayout", {
        /**
         * A name object specifying the page layout to be used when the document is opened.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the page layout
         * let pageLayout : PdfPageLayout = viewerPreferences.pageLayout;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._pageLayout;
        },
        /**
         * A name object specifying the page layout to be used when the document is opened.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the page layout
         * viewerPreferences.pageLayout = PdfPageLayout.TwoColumnLeft;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._pageLayout = value;
            this._catalog.items.setValue(this._dictionaryProperties.pageLayout, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this._mapPageLayout(this._pageLayout)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "pageScaling", {
        /**
         * Gets the page scaling option to be selected
         * when a print dialog is displayed for this document.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Gets the page scaling
         * let pageScaling : PageScalingMode = viewerPreferences.pageScaling;
         * // Destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this._pageScaling;
        },
        /**
         * Sets the page scaling option to be selected
         * when a print dialog is displayed for this document.
         * ```typescript
         * // Create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // Gets the viewer preferences of the document
         * let viewerPreferences : PdfViewerPreferences = document.viewerPreferences;
         * // Sets the page scaling
         * viewerPreferences.pageScaling = PageScalingMode.None;
         * // Destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this._pageScaling = value;
            if (this._pageScaling === $534bc6c598ecff3c$export$ba9576ee42f81246.AppDefault && this._dictionary.items.containsKey(this._dictionaryProperties.printScaling)) this._dictionary.items.remove(this._dictionaryProperties.printScaling);
            else if (this._pageScaling === $534bc6c598ecff3c$export$ba9576ee42f81246.None) this._dictionary.items.setValue(this._dictionaryProperties.printScaling, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)("None"));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfViewerPreferences.prototype, "element", {
        /**
         * Primivie element
         *
         * @private
         */ get: function() {
            return this._dictionary;
        },
        enumerable: true,
        configurable: true
    });
    PdfViewerPreferences.prototype._mapDuplexMode = function(mode) {
        switch(mode){
            case $534bc6c598ecff3c$export$7846ac822c2bec23.Simplex:
                return "Simplex";
            case $534bc6c598ecff3c$export$7846ac822c2bec23.DuplexFlipShortEdge:
                return "DuplexFlipShortEdge";
            case $534bc6c598ecff3c$export$7846ac822c2bec23.DuplexFlipLongEdge:
                return "DuplexFlipLongEdge";
            case $534bc6c598ecff3c$export$7846ac822c2bec23.None:
                return "None";
        }
    };
    PdfViewerPreferences.prototype._mapPageMode = function(mode) {
        switch(mode){
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.UseNone:
                return "UseNone";
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.UseOutlines:
                return "UseOutlines";
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.UseThumbs:
                return "UseThumbs";
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.FullScreen:
                return "FullScreen";
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.UseOC:
                return "UseOC";
            case $534bc6c598ecff3c$export$5745fc7debd2aa42.UseAttachments:
                return "UseAttachments";
        }
    };
    PdfViewerPreferences.prototype._mapPageLayout = function(layout) {
        switch(layout){
            case $534bc6c598ecff3c$export$22f9f17d130f88e.SinglePage:
                return "SinglePage";
            case $534bc6c598ecff3c$export$22f9f17d130f88e.OneColumn:
                return "OneColumn";
            case $534bc6c598ecff3c$export$22f9f17d130f88e.TwoColumnLeft:
                return "TwoColumnLeft";
            case $534bc6c598ecff3c$export$22f9f17d130f88e.TwoColumnRight:
                return "TwoColumnRight";
            case $534bc6c598ecff3c$export$22f9f17d130f88e.TwoPageLeft:
                return "TwoPageLeft";
            case $534bc6c598ecff3c$export$22f9f17d130f88e.TwoPageRight:
                return "TwoPageRight";
        }
    };
    return PdfViewerPreferences;
}();
var $534bc6c598ecff3c$export$5745fc7debd2aa42;
(function(PdfPageMode) {
    /**
     * Default value. Neither document outline nor thumbnail images visible.
     */ PdfPageMode[PdfPageMode["UseNone"] = 0] = "UseNone";
    /**
     * Document outline visible.
     */ PdfPageMode[PdfPageMode["UseOutlines"] = 1] = "UseOutlines";
    /**
     * Thumbnail images visible.
     */ PdfPageMode[PdfPageMode["UseThumbs"] = 2] = "UseThumbs";
    /**
     * Full-screen mode, with no menu bar, window controls, or any other window visible.
     */ PdfPageMode[PdfPageMode["FullScreen"] = 3] = "FullScreen";
    /**
     * Optional content group panel visible.
     */ PdfPageMode[PdfPageMode["UseOC"] = 4] = "UseOC";
    /**
     * Attachments are visible.
     */ PdfPageMode[PdfPageMode["UseAttachments"] = 5] = "UseAttachments";
})($534bc6c598ecff3c$export$5745fc7debd2aa42 || ($534bc6c598ecff3c$export$5745fc7debd2aa42 = {}));
var $534bc6c598ecff3c$export$22f9f17d130f88e;
(function(PdfPageLayout) {
    /**
     * Default Value. Display one page at a time.
     */ PdfPageLayout[PdfPageLayout["SinglePage"] = 0] = "SinglePage";
    /**
     * Display the pages in one column.
     */ PdfPageLayout[PdfPageLayout["OneColumn"] = 1] = "OneColumn";
    /**
     * Display the pages in two columns, with odd numbered
     * pages on the left.
     */ PdfPageLayout[PdfPageLayout["TwoColumnLeft"] = 2] = "TwoColumnLeft";
    /**
     * Display the pages in two columns, with odd numbered
     * pages on the right.
     */ PdfPageLayout[PdfPageLayout["TwoColumnRight"] = 3] = "TwoColumnRight";
    /**
     * Display the pages two at a time, with odd-numbered pages on the left.
     */ PdfPageLayout[PdfPageLayout["TwoPageLeft"] = 4] = "TwoPageLeft";
    /**
     * Display the pages two at a time, with odd-numbered pages on the right.
     */ PdfPageLayout[PdfPageLayout["TwoPageRight"] = 5] = "TwoPageRight";
})($534bc6c598ecff3c$export$22f9f17d130f88e || ($534bc6c598ecff3c$export$22f9f17d130f88e = {}));
var $534bc6c598ecff3c$export$7846ac822c2bec23;
(function(DuplexMode) {
    /**
     * Print single-sided.
     */ DuplexMode[DuplexMode["Simplex"] = 0] = "Simplex";
    /**
     * Duplex and flip on the short edge of the sheet.
     */ DuplexMode[DuplexMode["DuplexFlipShortEdge"] = 1] = "DuplexFlipShortEdge";
    /**
     * Duplex and flip on the long edge of the sheet.
     */ DuplexMode[DuplexMode["DuplexFlipLongEdge"] = 2] = "DuplexFlipLongEdge";
    /**
     * Default value.
     */ DuplexMode[DuplexMode["None"] = 3] = "None";
})($534bc6c598ecff3c$export$7846ac822c2bec23 || ($534bc6c598ecff3c$export$7846ac822c2bec23 = {}));
var $534bc6c598ecff3c$export$ba9576ee42f81246;
(function(PageScalingMode) {
    /**
     * Indicates the conforming reader’s default print scaling.
     */ PageScalingMode[PageScalingMode["AppDefault"] = 0] = "AppDefault";
    /**
     * Indicates no page scaling.
     */ PageScalingMode[PageScalingMode["None"] = 1] = "None";
})($534bc6c598ecff3c$export$ba9576ee42f81246 || ($534bc6c598ecff3c$export$ba9576ee42f81246 = {}));


var $bfda723cbb1176de$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfCatalog` class represents internal catalog of the Pdf document.
 * @private
 */ var $bfda723cbb1176de$export$44014050ffe2bb13 = /** @class */ function(_super) {
    $bfda723cbb1176de$var$__extends(PdfCatalog, _super);
    //constructor
    /**
     * Initializes a new instance of the `PdfCatalog` class.
     * @private
     */ function PdfCatalog() {
        var _this = _super.call(this) || this;
        //fields
        /**
         * Internal variable to store collection of `sections`.
         * @default null
         * @private
         */ _this.sections = null;
        /**
         * Internal variable for accessing fields from `DictionryProperties` class.
         * @private
         */ _this.tempDictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        _this.items.setValue(new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)().type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)("Catalog"));
        return _this;
    }
    Object.defineProperty(PdfCatalog.prototype, "pages", {
        //Properties
        /**
         * Gets or sets the sections, which contain `pages`.
         * @private
         */ get: function() {
            return this.sections;
        },
        set: function(value) {
            var dictionary = value.element;
            // if (this.sections !== value) {
            //     this.sections = value;
            //     this.Items.setValue(this.tempDictionaryProperties.pages, new PdfReferenceHolder(value));
            // }
            this.sections = value;
            this.items.setValue(this.tempDictionaryProperties.pages, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(value));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCatalog.prototype, "viewerPreferences", {
        /**
         * Gets the viewer preferences of the PDF document.
         * @private
         */ get: function() {
            if (this._viewerPreferences === null || typeof this._viewerPreferences === "undefined") {
                this._viewerPreferences = new (0, $534bc6c598ecff3c$export$f25d215107823603)(this);
                this.items.setValue(this.tempDictionaryProperties.viewerPreferences, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this._viewerPreferences.element));
            }
            return this._viewerPreferences;
        },
        enumerable: true,
        configurable: true
    });
    return PdfCatalog;
}((0, $467b51a52206950c$export$f103d8ead0680780));


/**
 * `PdfCrossTable` is responsible for intermediate level parsing
 * and savingof a PDF document.
 * @private
 */ var $8866b473e717b660$export$8c4e0ee04681847e = /** @class */ function() {
    function PdfCrossTable() {
        /**
         * The modified `objects` that should be saved.
         * @private
         */ this.objects = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        /**
         * Holds `maximal generation number` or offset to object.
         * @default 0
         * @private
         */ this.maxGenNumIndex = 0;
        /**
         * The `number of the objects`.
         * @default 0
         * @private
         */ this.objectCount = 0;
        /**
         * Internal variable for accessing fields from `DictionryProperties` class.
         * @default new PdfDictionaryProperties()
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
    }
    Object.defineProperty(PdfCrossTable.prototype, "isMerging", {
        //Properties
        /**
         * Gets or sets if the document `is merged`.
         * @private
         */ get: function() {
            return this.merging;
        },
        set: function(value) {
            this.merging = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "trailer", {
        /**
         * Gets the `trailer`.
         * @private
         */ get: function() {
            if (this.internalTrailer == null) this.internalTrailer = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
            return this.internalTrailer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "document", {
        /**
         * Gets or sets the main `PdfDocument` class instance.
         * @private
         */ get: function() {
            return this.pdfDocument;
        },
        set: function(value) {
            this.pdfDocument = value;
            this.items = this.pdfDocument.pdfObjects;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "pdfObjects", {
        /**
         * Gets the catched `PDF object` main collection.
         * @private
         */ get: function() {
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "objectCollection", {
        /**
         * Gets the `object collection`.
         * @private
         */ get: function() {
            return this.pdfDocument.pdfObjects;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "count", {
        /**
         * Gets or sets the `number of the objects` within the document.
         * @private
         */ get: function() {
            return this.objectCount;
        },
        set: function(value) {
            this.objectCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCrossTable.prototype, "nextObjNumber", {
        /**
         * Returns `next available object number`.
         * @private
         */ get: function() {
            this.count = this.count + 1;
            return this.count;
        },
        enumerable: true,
        configurable: true
    });
    PdfCrossTable.prototype.save = function(writer, filename) {
        this.saveHead(writer);
        var state = false;
        this.mappedReferences = null;
        this.objects.clear();
        this.markTrailerReferences();
        this.saveObjects(writer);
        var saveCount = this.count;
        var xrefPos = writer.position;
        this.registerObject(0, new (0, $8f73ad8fb76d816c$export$8dbbc26be85c345a)(0, -1), true);
        var prevXRef = 0;
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).xref);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        this.saveSections(writer);
        this.saveTrailer(writer, this.count, prevXRef);
        this.saveTheEndess(writer, xrefPos);
        this.count = saveCount;
        for(var i = 0; i < this.objectCollection.count; ++i){
            var oi = this.objectCollection.items(i);
            oi.object.isSaving = false;
        }
        if (typeof filename === "undefined") return writer.stream.buffer;
        else writer.stream.save(filename);
    };
    /**
     * `Saves the endess` of the file.
     * @private
     */ PdfCrossTable.prototype.saveTheEndess = function(writer, xrefPos) {
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).startxref + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        writer.write(xrefPos.toString() + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).eof + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Saves the new trailer` dictionary.
     * @private
     */ PdfCrossTable.prototype.saveTrailer = function(writer, count, prevXRef) {
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).trailer + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        // Save the dictionary.
        var trailer = this.trailer;
        trailer.items.setValue(this.dictionaryProperties.size, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.objectCount + 1));
        trailer = new (0, $467b51a52206950c$export$f103d8ead0680780)(trailer); // Make it real dictionary.
        trailer.setEncrypt(false);
        trailer.save(writer);
    };
    /**
     * `Saves the xref section`.
     * @private
     */ PdfCrossTable.prototype.saveSections = function(writer) {
        var objectNum = 0;
        var count = 0;
        do {
            count = this.prepareSubsection(objectNum);
            this.saveSubsection(writer, objectNum, count);
            objectNum += count;
        }while (count !== 0);
    };
    /**
     * `Saves a subsection`.
     * @private
     */ PdfCrossTable.prototype.saveSubsection = function(writer, objectNum, count) {
        if (count <= 0 || objectNum >= this.count) return;
        var subsectionHead = "{0} {1}{2}";
        writer.write(objectNum + " " + (count + 1) + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        for(var i = objectNum; i <= objectNum + count; ++i){
            var obj = this.objects.getValue(i);
            var str = "";
            if (obj.type === (0, $6640501c19ed3dd0$export$53f0d9fcb05d9d1d).Free) str = this.getItem(obj.offset, 65535, true);
            else str = this.getItem(obj.offset, obj.generation, false);
            writer.write(str);
        }
    };
    /**
     * Generates string for `xref table item`.
     * @private
     */ PdfCrossTable.prototype.getItem = function(offset, genNumber, isFree) {
        var returnString = "";
        var addOffsetLength = 10 - offset.toString().length;
        if (genNumber <= 0) genNumber = 0;
        var addGenNumberLength = 5 - genNumber.toString().length <= 0 ? 0 : 5 - genNumber.toString().length;
        for(var index = 0; index < addOffsetLength; index++)returnString = returnString + "0";
        returnString = returnString + offset.toString() + " ";
        for(var index = 0; index < addGenNumberLength; index++)returnString = returnString + "0";
        returnString = returnString + genNumber.toString() + " ";
        returnString = returnString + (isFree ? (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).f : (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).n) + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        return returnString;
    };
    /**
     * `Prepares a subsection` of the current section within the cross-reference table.
     * @private
     */ PdfCrossTable.prototype.prepareSubsection = function(objectNum) {
        var count = 0;
        var i;
        var total = this.count;
        for(var k = 0; k < this.document.pdfObjects.count; k++){
            var reference = this.document.pdfObjects.items(k).reference;
            var refString = reference.toString();
            var refArray = refString.split(" ");
        }
        if (objectNum >= total) return count;
        // search for first changed indirect object.
        for(i = objectNum; i < total; ++i)break;
        objectNum = i;
        // look up for all indirect objects in one subsection.
        for(; i < total; ++i)++count;
        return count;
    };
    /**
     * `Marks the trailer references` being saved.
     * @private
     */ PdfCrossTable.prototype.markTrailerReferences = function() {
        var tempArray;
        var keys = this.trailer.items.keys();
        var values = this.trailer.items.values();
    };
    /**
     * `Saves the head`.
     * @private
     */ PdfCrossTable.prototype.saveHead = function(writer) {
        var version = this.generateFileVersion(writer.document);
        writer.write("%PDF-" + version);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * Generates the `version` of the file.
     * @private
     */ PdfCrossTable.prototype.generateFileVersion = function(document) {
        var iVersion = 4;
        var version = "1." + iVersion.toString();
        return version;
    };
    PdfCrossTable.prototype.getReference = function(obj, bNew) {
        if (typeof bNew === "undefined") {
            var wasNew = false;
            return this.getReference(obj, wasNew);
        } else //code splitted for reducing lines of code exceeds 100.
        return this.getSubReference(obj, bNew);
    };
    /**
     * Retrieves the `reference` of the object given.
     * @private
     */ PdfCrossTable.prototype.getSubReference = function(obj, bNew) {
        var isNew = false;
        var wasNew;
        var reference = null;
        // if (obj.IsSaving) {
        if (this.items.count > 0 && obj.objectCollectionIndex > 0 && this.items.count > obj.objectCollectionIndex - 1) {
            var tempObj = this.document.pdfObjects.getReference(obj, wasNew);
            reference = tempObj.reference;
            wasNew = tempObj.wasNew;
        }
        if (reference == null) {
            if (obj.status === (0, $02768fe98966b169$export$514cd0390d5ec73b).Registered) wasNew = false;
            else wasNew = true;
        } else wasNew = false;
        // need to add mapped reference code
        if (reference == null) {
            var objnumber = this.nextObjNumber;
            reference = new (0, $8f73ad8fb76d816c$export$8dbbc26be85c345a)(objnumber, 0);
            var found = void 0;
            if (wasNew) {
                this.document.pdfObjects.add(obj);
                this.document.pdfObjects.trySetReference(obj, reference, found);
                var tempIndex = this.document.pdfObjects.count - 1;
                var tempkey = this.document.pdfObjects.objectCollections[tempIndex].reference.objNumber;
                var tempvalue = this.document.pdfObjects.objectCollections[this.document.pdfObjects.count - 1];
                this.document.pdfObjects.mainObjectCollection.setValue(tempkey, tempvalue);
                obj.position = -1;
            } else this.document.pdfObjects.trySetReference(obj, reference, found);
            obj.objectCollectionIndex = reference.objNumber;
            obj.status = (0, $02768fe98966b169$export$514cd0390d5ec73b).None;
            isNew = true;
        }
        bNew = isNew || this.bForceNew;
        return reference;
    };
    /**
     * `Saves all objects` in the collection.
     * @private
     */ PdfCrossTable.prototype.saveObjects = function(writer) {
        var objectCollection = this.objectCollection;
        for(var i = 0; i < objectCollection.count; ++i){
            var oi = objectCollection.items(i);
            var obj = oi.object;
            obj.isSaving = true;
            this.saveIndirectObject(obj, writer);
        }
    };
    /**
     * `Saves indirect object`.
     * @private
     */ PdfCrossTable.prototype.saveIndirectObject = function(obj, writer) {
        var reference = this.getReference(obj);
        if (obj instanceof (0, $bfda723cbb1176de$export$44014050ffe2bb13)) this.trailer.items.setValue(this.dictionaryProperties.root, reference);
        // NOTE :  This is needed for correct string objects encryption.
        this.pdfDocument.currentSavingObj = reference;
        var tempArchive = false;
        tempArchive = obj.getArchive();
        var allowedType = !(obj instanceof (0, $15c367619ceaca0d$export$4d7493161880398c) || !tempArchive || obj instanceof (0, $bfda723cbb1176de$export$44014050ffe2bb13));
        var sigFlag = false;
        this.registerObject(writer.position, reference);
        this.doSaveObject(obj, reference, writer);
    };
    /**
     * Performs `real saving` of the save object.
     * @private
     */ PdfCrossTable.prototype.doSaveObject = function(obj, reference, writer) {
        var correctPosition = writer.length;
        writer.write(reference.objNumber.toString());
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        writer.write(reference.genNumber.toString());
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).obj);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        obj.save(writer);
        var stream = writer.stream;
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).endObj);
        writer.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    PdfCrossTable.prototype.registerObject = function(offset, reference, free) {
        if (typeof free === "boolean") {
            // Register the object by its number.
            this.objects.setValue(reference.objNumber, new $8866b473e717b660$export$5ebcbd36ac1bf47c(offset, reference, free));
            this.maxGenNumIndex = Math.max(this.maxGenNumIndex, reference.genNumber);
        } else if (typeof free === "undefined") {
            // Register the object by its number.
            this.objects.setValue(reference.objNumber, new $8866b473e717b660$export$5ebcbd36ac1bf47c(offset, reference));
            this.maxGenNumIndex = Math.max(this.maxGenNumIndex, reference.genNumber);
        }
    };
    /**
     * `Dereferences` the specified primitive object.
     * @private
     */ PdfCrossTable.dereference = function(obj) {
        var rh = obj;
        if (rh != null) obj = rh.object;
        return obj;
    };
    return PdfCrossTable;
}();
var $8866b473e717b660$export$5ebcbd36ac1bf47c = /** @class */ function() {
    function RegisteredObject(offset, reference, free) {
        var tempOffset = offset;
        this.offsetNumber = tempOffset;
        var tempReference = reference;
        this.generation = tempReference.genNumber;
        this.object = tempReference.objNumber;
        if (typeof free === "undefined") this.type = (0, $6640501c19ed3dd0$export$53f0d9fcb05d9d1d).Normal;
        else this.type = (0, $6640501c19ed3dd0$export$53f0d9fcb05d9d1d).Free;
    }
    Object.defineProperty(RegisteredObject.prototype, "objectNumber", {
        //Properties
        /**
         * Gets the `object number`.
         * @private
         */ get: function() {
            return this.object;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegisteredObject.prototype, "offset", {
        /**
         * Gets the `offset`.
         * @private
         */ get: function() {
            var result;
            result = this.offsetNumber;
            return result;
        },
        enumerable: true,
        configurable: true
    });
    return RegisteredObject;
}();



/**
 * PdfPageSettings.ts class for EJ2-PDF
 */ 
/**
 * PdfPageSize.ts class for EJ2-PDF
 */ 
/**
 * Represents information about various predefined `page sizes`.
 */ var $b9f9db645ec8719b$export$c7fc9729f27cc7e5 = /** @class */ function() {
    //constructor
    /**
     * Initialize an instance for `PdfPageSize` class.
     * @private
     */ function PdfPageSize() {
    // 
    }
    /**
     * Specifies the size of `letter`.
     * @private
     */ PdfPageSize.letter = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 792);
    /**
     * Specifies the size of `note`.
     * @private
     */ PdfPageSize.note = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(540, 720);
    /**
     * Specifies the size of `legal`.
     * @private
     */ PdfPageSize.legal = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 1008);
    /**
     * Specifies the size of `a0`.
     * @private
     */ PdfPageSize.a0 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2380, 3368);
    /**
     * Specifies the size of `a1`.
     * @private
     */ PdfPageSize.a1 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1684, 2380);
    /**
     * Specifies the size of `a2`.
     * @private
     */ PdfPageSize.a2 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1190, 1684);
    /**
     * Specifies the size of `a3`.
     * @private
     */ PdfPageSize.a3 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(842, 1190);
    /**
     * Specifies the size of `a4`.
     * @private
     */ PdfPageSize.a4 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(595, 842);
    /**
     * Specifies the size of `a5`.
     * @private
     */ PdfPageSize.a5 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(421, 595);
    /**
     * Specifies the size of `a6`.
     * @private
     */ PdfPageSize.a6 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(297, 421);
    /**
     * Specifies the size of `a7`.
     * @private
     */ PdfPageSize.a7 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(210, 297);
    /**
     * Specifies the size of `a8`.
     * @private
     */ PdfPageSize.a8 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(148, 210);
    /**
     * Specifies the size of `a9`.
     * @private
     */ PdfPageSize.a9 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(105, 148);
    /**
     * Specifies the size of `a10`.
     * @private
     */ PdfPageSize.a10 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(74, 105);
    /**
     * Specifies the size of `b0`.
     * @private
     */ PdfPageSize.b0 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2836, 4008);
    /**
     * Specifies the size of `b1`.
     * @private
     */ PdfPageSize.b1 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2004, 2836);
    /**
     * Specifies the size of `b2`.
     * @private
     */ PdfPageSize.b2 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1418, 2004);
    /**
     * Specifies the size of `b3`.
     * @private
     */ PdfPageSize.b3 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1002, 1418);
    /**
     * Specifies the size of `b4`.
     * @private
     */ PdfPageSize.b4 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(709, 1002);
    /**
     * Specifies the size of `b5`.
     * @private
     */ PdfPageSize.b5 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(501, 709);
    /**
     * Specifies the size of `archE`.
     * @private
     */ PdfPageSize.archE = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2592, 3456);
    /**
     * Specifies the size of `archD`.
     * @private
     */ PdfPageSize.archD = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1728, 2592);
    /**
     * Specifies the size of `archC`.
     * @private
     */ PdfPageSize.archC = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1296, 1728);
    /**
     * Specifies the size of `archB`.
     * @private
     */ PdfPageSize.archB = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(864, 1296);
    /**
     * Specifies the size of `archA`.
     * @private
     */ PdfPageSize.archA = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(648, 864);
    /**
     * Specifies the size of `flsa`.
     * @private
     */ PdfPageSize.flsa = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 936);
    /**
     * Specifies the size of `halfLetter`.
     * @private
     */ PdfPageSize.halfLetter = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(396, 612);
    /**
     * Specifies the size of `letter11x17`.
     * @private
     */ PdfPageSize.letter11x17 = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(792, 1224);
    /**
     * Specifies the size of `ledger`.
     * @private
     */ PdfPageSize.ledger = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1224, 792);
    return PdfPageSize;
}();


/**
 * public Enum for `PdfPageOrientation`.
 * @private
 */ var $98f82adf1cbc5a19$export$242e5fa5b02fc46;
(function(PdfPageOrientation) {
    /**
     * Specifies the type of `Portrait`.
     * @private
     */ PdfPageOrientation[PdfPageOrientation["Portrait"] = 0] = "Portrait";
    /**
     * Specifies the type of `Landscape`.
     * @private
     */ PdfPageOrientation[PdfPageOrientation["Landscape"] = 1] = "Landscape";
})($98f82adf1cbc5a19$export$242e5fa5b02fc46 || ($98f82adf1cbc5a19$export$242e5fa5b02fc46 = {}));
var $98f82adf1cbc5a19$export$c4c722dc5594ef40;
(function(PdfPageRotateAngle) {
    /**
     * Specifies the type of `RotateAngle0`.
     * @private
     */ PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle0"] = 0] = "RotateAngle0";
    /**
     * Specifies the type of `RotateAngle90`.
     * @private
     */ PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle90"] = 1] = "RotateAngle90";
    /**
     * Specifies the type of `RotateAngle180`.
     * @private
     */ PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle180"] = 2] = "RotateAngle180";
    /**
     * Specifies the type of `RotateAngle270`.
     * @private
     */ PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle270"] = 3] = "RotateAngle270";
})($98f82adf1cbc5a19$export$c4c722dc5594ef40 || ($98f82adf1cbc5a19$export$c4c722dc5594ef40 = {}));
var $98f82adf1cbc5a19$export$67251fd30ad77;
(function(PdfNumberStyle) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["None"] = 0] = "None";
    /**
     * Specifies the type of `Numeric`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["Numeric"] = 1] = "Numeric";
    /**
     * Specifies the type of `LowerLatin`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["LowerLatin"] = 2] = "LowerLatin";
    /**
     * Specifies the type of `LowerRoman`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["LowerRoman"] = 3] = "LowerRoman";
    /**
     * Specifies the type of `UpperLatin`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["UpperLatin"] = 4] = "UpperLatin";
    /**
     * Specifies the type of `UpperRoman`.
     * @private
     */ PdfNumberStyle[PdfNumberStyle["UpperRoman"] = 5] = "UpperRoman";
})($98f82adf1cbc5a19$export$67251fd30ad77 || ($98f82adf1cbc5a19$export$67251fd30ad77 = {}));
var $98f82adf1cbc5a19$export$d7cd715375e0be52;
(function(PdfDockStyle) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfDockStyle[PdfDockStyle["None"] = 0] = "None";
    /**
     * Specifies the type of `Bottom`.
     * @private
     */ PdfDockStyle[PdfDockStyle["Bottom"] = 1] = "Bottom";
    /**
     * Specifies the type of `Top`.
     * @private
     */ PdfDockStyle[PdfDockStyle["Top"] = 2] = "Top";
    /**
     * Specifies the type of `Left`.
     * @private
     */ PdfDockStyle[PdfDockStyle["Left"] = 3] = "Left";
    /**
     * Specifies the type of `Right`.
     * @private
     */ PdfDockStyle[PdfDockStyle["Right"] = 4] = "Right";
    /**
     * Specifies the type of `Fill`.
     * @private
     */ PdfDockStyle[PdfDockStyle["Fill"] = 5] = "Fill";
})($98f82adf1cbc5a19$export$d7cd715375e0be52 || ($98f82adf1cbc5a19$export$d7cd715375e0be52 = {}));
var $98f82adf1cbc5a19$export$1899d10b8f4f2e5a;
(function(PdfAlignmentStyle) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["None"] = 0] = "None";
    /**
     * Specifies the type of `TopLeft`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["TopLeft"] = 1] = "TopLeft";
    /**
     * Specifies the type of `TopCenter`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["TopCenter"] = 2] = "TopCenter";
    /**
     * Specifies the type of `TopRight`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["TopRight"] = 3] = "TopRight";
    /**
     * Specifies the type of `MiddleLeft`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["MiddleLeft"] = 4] = "MiddleLeft";
    /**
     * Specifies the type of `MiddleCenter`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["MiddleCenter"] = 5] = "MiddleCenter";
    /**
     * Specifies the type of `MiddleRight`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["MiddleRight"] = 6] = "MiddleRight";
    /**
     * Specifies the type of `BottomLeft`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["BottomLeft"] = 7] = "BottomLeft";
    /**
     * Specifies the type of `BottomCenter`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["BottomCenter"] = 8] = "BottomCenter";
    /**
     * Specifies the type of `BottomRight`.
     * @private
     */ PdfAlignmentStyle[PdfAlignmentStyle["BottomRight"] = 9] = "BottomRight";
})($98f82adf1cbc5a19$export$1899d10b8f4f2e5a || ($98f82adf1cbc5a19$export$1899d10b8f4f2e5a = {}));
var $98f82adf1cbc5a19$export$fd0446c06165ed92;
(function(TemplateType) {
    /**
     * Specifies the type of `None`.
     * @private
     */ TemplateType[TemplateType["None"] = 0] = "None";
    /**
     * Specifies the type of `Top`.
     * @private
     */ TemplateType[TemplateType["Top"] = 1] = "Top";
    /**
     * Specifies the type of `Bottom`.
     * @private
     */ TemplateType[TemplateType["Bottom"] = 2] = "Bottom";
    /**
     * Specifies the type of `Left`.
     * @private
     */ TemplateType[TemplateType["Left"] = 3] = "Left";
    /**
     * Specifies the type of `Right`.
     * @private
     */ TemplateType[TemplateType["Right"] = 4] = "Right";
})($98f82adf1cbc5a19$export$fd0446c06165ed92 || ($98f82adf1cbc5a19$export$fd0446c06165ed92 = {}));


/**
 * PdfMargins.ts class for EJ2-PDF
 * A class representing PDF page margins.
 */ var $3ff89442e7f91200$export$ab3c4b1fe7f9c892 = /** @class */ function() {
    /**
     * Initializes a new instance of the `PdfMargins` class.
     * @private
     */ function PdfMargins() {
        /**
         * Represents the `Default Page Margin` value.
         * @default 0.0
         * @private
         */ this.pdfMargin = 40.0;
        this.setMargins(this.pdfMargin);
    }
    Object.defineProperty(PdfMargins.prototype, "left", {
        //Properties
        /**
         * Gets or sets the `left margin` size.
         * @private
         */ get: function() {
            return this.leftMargin;
        },
        set: function(value) {
            this.leftMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfMargins.prototype, "top", {
        /**
         * Gets or sets the `top margin` size.
         * @private
         */ get: function() {
            return this.topMargin;
        },
        set: function(value) {
            this.topMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfMargins.prototype, "right", {
        /**
         * Gets or sets the `right margin` size.
         * @private
         */ get: function() {
            return this.rightMargin;
        },
        set: function(value) {
            this.rightMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfMargins.prototype, "bottom", {
        /**
         * Gets or sets the `bottom margin` size.
         * @private
         */ get: function() {
            return this.bottomMargin;
        },
        set: function(value) {
            this.bottomMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfMargins.prototype, "all", {
        /**
         * Sets the `margins`.
         * @private
         */ set: function(value) {
            this.setMargins(value);
        },
        enumerable: true,
        configurable: true
    });
    PdfMargins.prototype.setMargins = function(margin1, margin2, margin3, margin4) {
        if (typeof margin2 === "undefined") this.leftMargin = this.topMargin = this.rightMargin = this.bottomMargin = margin1;
        else if (typeof margin3 === "undefined") {
            this.leftMargin = this.rightMargin = margin1;
            this.bottomMargin = this.topMargin = margin2;
        } else {
            this.leftMargin = margin1;
            this.topMargin = margin2;
            this.rightMargin = margin3;
            this.bottomMargin = margin4;
        }
    };
    /**
     * `Clones` the object.
     * @private
     */ PdfMargins.prototype.clone = function() {
        return this;
    };
    return PdfMargins;
}();


/**
 * The class provides various `setting` related with PDF pages.
 */ var $38437f6299029180$export$b29d0b05f007ad1b = /** @class */ function() {
    function PdfPageSettings(margins) {
        //Fields
        /**
         * The page `margins`.
         * @private
         */ this.pageMargins = new (0, $3ff89442e7f91200$export$ab3c4b1fe7f9c892)();
        /**
         * The page `size`.
         * @default a4
         * @private
         */ this.pageSize = (0, $b9f9db645ec8719b$export$c7fc9729f27cc7e5).a4;
        /**
         * The page `rotation angle`.
         * @default PdfPageRotateAngle.RotateAngle0
         * @private
         */ this.rotateAngle = (0, $98f82adf1cbc5a19$export$c4c722dc5594ef40).RotateAngle0;
        /**
         * The page `orientation`.
         * @default PdfPageOrientation.Portrait
         * @private
         */ this.pageOrientation = (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Portrait;
        /**
         * The page `origin`.
         * @default 0,0
         * @private
         */ this.pageOrigin = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
        /**
         * Checks the Whether the `rotation` is applied or not.
         * @default false
         * @private
         */ this.isRotation = false;
        if (typeof margins === "number") this.pageMargins.setMargins(margins);
    }
    Object.defineProperty(PdfPageSettings.prototype, "size", {
        //Properties
        /**
         * Gets or sets the `size` of the page.
         * @private
         */ get: function() {
            return this.pageSize;
        },
        set: function(value) {
            this.setSize(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "orientation", {
        /**
         * Gets or sets the page `orientation`.
         * @private
         */ get: function() {
            return this.pageOrientation;
        },
        set: function(orientation) {
            if (this.pageOrientation !== orientation) {
                this.pageOrientation = orientation;
                this.updateSize(orientation);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "margins", {
        /**
         * Gets or sets the `margins` of the page.
         * @private
         */ get: function() {
            return this.pageMargins;
        },
        set: function(value) {
            this.pageMargins = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "width", {
        /**
         * Gets or sets the `width` of the page.
         * @private
         */ get: function() {
            return this.pageSize.width;
        },
        set: function(value) {
            this.pageSize.width = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "height", {
        /**
         * Gets or sets the `height` of the page.
         * @private
         */ get: function() {
            return this.pageSize.height;
        },
        set: function(value) {
            this.pageSize.height = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "origin", {
        /**
         * Gets or sets the `origin` of the page.
         * @private
         */ get: function() {
            return this.pageOrigin;
        },
        set: function(value) {
            this.pageOrigin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageSettings.prototype, "rotate", {
        /**
         * Gets or sets the number of degrees by which the page should be `rotated` clockwise when displayed or printed.
         * @private
         */ get: function() {
            return this.rotateAngle;
        },
        set: function(value) {
            this.rotateAngle = value;
            this.isRotation = true;
        },
        enumerable: true,
        configurable: true
    });
    //Methods
    /**
     * `Update page size` depending on orientation.
     * @private
     */ PdfPageSettings.prototype.updateSize = function(orientation) {
        var min = Math.min(this.pageSize.width, this.pageSize.height);
        var max = Math.max(this.pageSize.width, this.pageSize.height);
        switch(orientation){
            case (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Portrait:
                this.pageSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(min, max);
                break;
            case (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Landscape:
                this.pageSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(max, min);
                break;
        }
    };
    /**
     * Creates a `clone` of the object.
     * @private
     */ PdfPageSettings.prototype.clone = function() {
        var settings = this;
        settings.pageMargins = this.pageMargins.clone();
        // if (GetTransition() != null)
        // {
        //     settings.Transition = (PdfPageTransition)Transition.clone();
        // }
        return settings;
    };
    /**
     * Returns `size`, shrinked by the margins.
     * @private
     */ PdfPageSettings.prototype.getActualSize = function() {
        var width = this.width - (this.margins.left + this.margins.right);
        var height = this.height - (this.margins.top + this.margins.bottom);
        var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, height);
        return size;
    };
    /**
     * Sets `size` to the page aaccording to the orientation.
     * @private
     */ PdfPageSettings.prototype.setSize = function(size) {
        var min = Math.min(size.width, size.height);
        var max = Math.max(size.width, size.height);
        if (this.orientation === (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Portrait) this.pageSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(min, max);
        else this.pageSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(max, min);
    };
    return PdfPageSettings;
}();












/**
 * PdfGraphics.ts class for EJ2-PDF
 */ 
/**
 * public Enum for `PdfFontStyle`.
 * @private
 */ var $32129651824bb502$export$80979869bc40ff1f;
(function(PdfFontStyle) {
    /**
     * Specifies the type of `Regular`.
     * @private
     */ PdfFontStyle[PdfFontStyle["Regular"] = 0] = "Regular";
    /**
     * Specifies the type of `Bold`.
     * @private
     */ PdfFontStyle[PdfFontStyle["Bold"] = 1] = "Bold";
    /**
     * Specifies the type of `Italic`.
     * @private
     */ PdfFontStyle[PdfFontStyle["Italic"] = 2] = "Italic";
    /**
     * Specifies the type of `Underline`.
     * @private
     */ PdfFontStyle[PdfFontStyle["Underline"] = 4] = "Underline";
    /**
     * Specifies the type of `Strikeout`.
     * @private
     */ PdfFontStyle[PdfFontStyle["Strikeout"] = 8] = "Strikeout";
})($32129651824bb502$export$80979869bc40ff1f || ($32129651824bb502$export$80979869bc40ff1f = {}));
var $32129651824bb502$export$be66ab191dea7a97;
(function(PdfFontFamily) {
    /**
     * Specifies the `Helvetica` font.
     */ PdfFontFamily[PdfFontFamily["Helvetica"] = 0] = "Helvetica";
    /**
     * Specifies the `Courier` font.
     */ PdfFontFamily[PdfFontFamily["Courier"] = 1] = "Courier";
    /**
     * Specifies the `TimesRoman` font.
     */ PdfFontFamily[PdfFontFamily["TimesRoman"] = 2] = "TimesRoman";
    /**
     * Specifies the `Symbol` font.
     */ PdfFontFamily[PdfFontFamily["Symbol"] = 3] = "Symbol";
    /**
     * Specifies the `ZapfDingbats` font.
     */ PdfFontFamily[PdfFontFamily["ZapfDingbats"] = 4] = "ZapfDingbats";
})($32129651824bb502$export$be66ab191dea7a97 || ($32129651824bb502$export$be66ab191dea7a97 = {}));
var $32129651824bb502$export$7d3928cbcc6ea1af;
(function(PdfFontType) {
    /**
     * Specifies the type of `Standard`.
     * @private
     */ PdfFontType[PdfFontType["Standard"] = 0] = "Standard";
    /**
     * Specifies the type of `TrueType`.
     * @private
     */ PdfFontType[PdfFontType["TrueType"] = 1] = "TrueType";
    /**
     * Specifies the type of `TrueTypeEmbedded`.
     * @private
     */ PdfFontType[PdfFontType["TrueTypeEmbedded"] = 2] = "TrueTypeEmbedded";
})($32129651824bb502$export$7d3928cbcc6ea1af || ($32129651824bb502$export$7d3928cbcc6ea1af = {}));
var $32129651824bb502$export$cc4af2cfe21903e;
(function(PdfWordWrapType) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfWordWrapType[PdfWordWrapType["None"] = 0] = "None";
    /**
     * Specifies the type of `Word`.
     * @private
     */ PdfWordWrapType[PdfWordWrapType["Word"] = 1] = "Word";
    /**
     * Specifies the type of `WordOnly`.
     * @private
     */ PdfWordWrapType[PdfWordWrapType["WordOnly"] = 2] = "WordOnly";
    /**
     * Specifies the type of `Character`.
     * @private
     */ PdfWordWrapType[PdfWordWrapType["Character"] = 3] = "Character";
})($32129651824bb502$export$cc4af2cfe21903e || ($32129651824bb502$export$cc4af2cfe21903e = {}));
var $32129651824bb502$export$72189ec4d9b4f960;
(function(PdfSubSuperScript) {
    /**
     * Specifies the type of `None`.
     * @private
     */ PdfSubSuperScript[PdfSubSuperScript["None"] = 0] = "None";
    /**
     * Specifies the type of `SuperScript`.
     * @private
     */ PdfSubSuperScript[PdfSubSuperScript["SuperScript"] = 1] = "SuperScript";
    /**
     * Specifies the type of `SubScript`.
     * @private
     */ PdfSubSuperScript[PdfSubSuperScript["SubScript"] = 2] = "SubScript";
})($32129651824bb502$export$72189ec4d9b4f960 || ($32129651824bb502$export$72189ec4d9b4f960 = {}));
var $32129651824bb502$export$98fe6dd79a4f2c0c;
(function(FontEncoding) {
    /**
     * Specifies the type of `Unknown`.
     * @private
     */ FontEncoding[FontEncoding["Unknown"] = 0] = "Unknown";
    /**
     * Specifies the type of `StandardEncoding`.
     * @private
     */ FontEncoding[FontEncoding["StandardEncoding"] = 1] = "StandardEncoding";
    /**
     * Specifies the type of `MacRomanEncoding`.
     * @private
     */ FontEncoding[FontEncoding["MacRomanEncoding"] = 2] = "MacRomanEncoding";
    /**
     * Specifies the type of `MacExpertEncoding`.
     * @private
     */ FontEncoding[FontEncoding["MacExpertEncoding"] = 3] = "MacExpertEncoding";
    /**
     * Specifies the type of `WinAnsiEncoding`.
     * @private
     */ FontEncoding[FontEncoding["WinAnsiEncoding"] = 4] = "WinAnsiEncoding";
    /**
     * Specifies the type of `PdfDocEncoding`.
     * @private
     */ FontEncoding[FontEncoding["PdfDocEncoding"] = 5] = "PdfDocEncoding";
    /**
     * Specifies the type of `IdentityH`.
     * @private
     */ FontEncoding[FontEncoding["IdentityH"] = 6] = "IdentityH";
})($32129651824bb502$export$98fe6dd79a4f2c0c || ($32129651824bb502$export$98fe6dd79a4f2c0c = {}));
var $32129651824bb502$export$18f1edb7e09345b2;
(function(TtfCmapFormat) {
    /**
     * This is the Apple standard character to glyph index mapping table.
     * @private
     */ TtfCmapFormat[TtfCmapFormat["Apple"] = 0] = "Apple";
    /**
     * This is the Microsoft standard character to glyph index mapping table.
     * @private
     */ TtfCmapFormat[TtfCmapFormat["Microsoft"] = 4] = "Microsoft";
    /**
     * Format 6: Trimmed table mapping.
     * @private
     */ TtfCmapFormat[TtfCmapFormat["Trimmed"] = 6] = "Trimmed";
})($32129651824bb502$export$18f1edb7e09345b2 || ($32129651824bb502$export$18f1edb7e09345b2 = {}));
var $32129651824bb502$export$5894ac961b177c22;
(function(TtfCmapEncoding) {
    /**
     * Unknown encoding.
     * @private
     */ TtfCmapEncoding[TtfCmapEncoding["Unknown"] = 0] = "Unknown";
    /**
     * When building a symbol font for Windows.
     * @private
     */ TtfCmapEncoding[TtfCmapEncoding["Symbol"] = 1] = "Symbol";
    /**
     * When building a Unicode font for Windows.
     * @private
     */ TtfCmapEncoding[TtfCmapEncoding["Unicode"] = 2] = "Unicode";
    /**
     * For font that will be used on a Macintosh.
     * @private
     */ TtfCmapEncoding[TtfCmapEncoding["Macintosh"] = 3] = "Macintosh";
})($32129651824bb502$export$5894ac961b177c22 || ($32129651824bb502$export$5894ac961b177c22 = {}));
var $32129651824bb502$export$bb3cfc97ef45f19a;
(function(TtfPlatformID) {
    /**
     * Apple platform.
     * @private
     */ TtfPlatformID[TtfPlatformID["AppleUnicode"] = 0] = "AppleUnicode";
    /**
     * Macintosh platform.
     * @private
     */ TtfPlatformID[TtfPlatformID["Macintosh"] = 1] = "Macintosh";
    /**
     * Iso platform.
     * @private
     */ TtfPlatformID[TtfPlatformID["Iso"] = 2] = "Iso";
    /**
     * Microsoft platform.
     * @private
     */ TtfPlatformID[TtfPlatformID["Microsoft"] = 3] = "Microsoft";
})($32129651824bb502$export$bb3cfc97ef45f19a || ($32129651824bb502$export$bb3cfc97ef45f19a = {}));
var $32129651824bb502$export$c7e834ce569513c8;
(function(TtfMicrosoftEncodingID) {
    /**
     * Undefined encoding.
     * @private
     */ TtfMicrosoftEncodingID[TtfMicrosoftEncodingID["Undefined"] = 0] = "Undefined";
    /**
     * Unicode encoding.
     * @private
     */ TtfMicrosoftEncodingID[TtfMicrosoftEncodingID["Unicode"] = 1] = "Unicode";
})($32129651824bb502$export$c7e834ce569513c8 || ($32129651824bb502$export$c7e834ce569513c8 = {}));
var $32129651824bb502$export$6dfeb707034057d3;
(function(TtfMacintoshEncodingID) {
    /**
     * Roman encoding.
     * @private
     */ TtfMacintoshEncodingID[TtfMacintoshEncodingID["Roman"] = 0] = "Roman";
    /**
     * Japanese encoding.
     * @private
     */ TtfMacintoshEncodingID[TtfMacintoshEncodingID["Japanese"] = 1] = "Japanese";
    /**
     * Chinese encoding.
     * @private
     */ TtfMacintoshEncodingID[TtfMacintoshEncodingID["Chinese"] = 2] = "Chinese";
})($32129651824bb502$export$6dfeb707034057d3 || ($32129651824bb502$export$6dfeb707034057d3 = {}));
var $32129651824bb502$export$d37c3ab05448369c;
(function(FontDescriptorFlags) {
    /**
     * All glyphs have the same width (as opposed to proportional or variable-pitch fonts, which have different widths).
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["FixedPitch"] = 1] = "FixedPitch";
    /**
     * Glyphs have serifs, which are short strokes drawn at an angle on the top and
     * bottom of glyph stems (as opposed to sans serif fonts, which do not).
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["Serif"] = 2] = "Serif";
    /**
     * Font contains glyphs outside the Adobe standard Latin character set. The
     * flag and the nonsymbolic flag cannot both be set or both be clear.
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["Symbolic"] = 4] = "Symbolic";
    /**
     * Glyphs resemble cursive handwriting.
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["Script"] = 8] = "Script";
    /**
     * Font uses the Adobe standard Latin character set or a subset of it.
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["Nonsymbolic"] = 32] = "Nonsymbolic";
    /**
     * Glyphs have dominant vertical strokes that are slanted.
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["Italic"] = 64] = "Italic";
    /**
     * Bold font.
     * @private
     */ FontDescriptorFlags[FontDescriptorFlags["ForceBold"] = 262144] = "ForceBold";
})($32129651824bb502$export$d37c3ab05448369c || ($32129651824bb502$export$d37c3ab05448369c = {}));
var $32129651824bb502$export$4f04ee1e3ea31dc5;
(function(TtfCompositeGlyphFlags) {
    /**
     * The Arg1And2AreWords.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["Arg1And2AreWords"] = 1] = "Arg1And2AreWords";
    /**
     * The ArgsAreXyValues.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["ArgsAreXyValues"] = 2] = "ArgsAreXyValues";
    /**
     * The RoundXyToGrid.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["RoundXyToGrid"] = 4] = "RoundXyToGrid";
    /**
     * The WeHaveScale.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["WeHaveScale"] = 8] = "WeHaveScale";
    /**
     * The Reserved.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["Reserved"] = 16] = "Reserved";
    /**
     * The MoreComponents.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["MoreComponents"] = 32] = "MoreComponents";
    /**
     * The WeHaveAnXyScale.
     * @private
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["WeHaveAnXyScale"] = 64] = "WeHaveAnXyScale";
    /**
     * The WeHaveTwoByTwo
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["WeHaveTwoByTwo"] = 128] = "WeHaveTwoByTwo";
    /**
     * The WeHaveInstructions.
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["WeHaveInstructions"] = 256] = "WeHaveInstructions";
    /**
     * The UseMyMetrics.
     */ TtfCompositeGlyphFlags[TtfCompositeGlyphFlags["UseMyMetrics"] = 512] = "UseMyMetrics";
})($32129651824bb502$export$4f04ee1e3ea31dc5 || ($32129651824bb502$export$4f04ee1e3ea31dc5 = {}));







/**
 * Helper class to `write PDF graphic streams` easily.
 * @private
 */ var $2475646aad2db433$export$a3a234703dae340f = /** @class */ function() {
    /**
     * Initialize an instance of `PdfStreamWriter` class.
     * @private
     */ function PdfStreamWriter(stream) {
        if (stream == null) throw new Error("ArgumentNullException:stream");
        this.stream = stream;
    }
    //Implementation
    /**
     * `Clear` the stream.
     * @public
     */ PdfStreamWriter.prototype.clear = function() {
        this.stream.clearStream();
    };
    PdfStreamWriter.prototype.setGraphicsState = function(dictionaryName) {
        if (dictionaryName instanceof (0, $93a92e6ea67161be$export$b440601b3bfe4454)) {
            this.stream.write(dictionaryName.toString());
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setGraphicsState);
        } else {
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).slash);
            this.stream.write(dictionaryName);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setGraphicsState);
        }
    };
    /**
     * `Executes the XObject`.
     * @private
     */ PdfStreamWriter.prototype.executeObject = function(name) {
        this.stream.write(name.toString());
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).paintXObject);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Closes path object`.
     * @private
     */ PdfStreamWriter.prototype.closePath = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).closePath);
    };
    /**
     * `Clips the path`.
     * @private
     */ PdfStreamWriter.prototype.clipPath = function(useEvenOddRule) {
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).clipPath);
        if (useEvenOddRule) this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).evenOdd);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).endPath);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Closes, then fills and strokes the path`.
     * @private
     */ PdfStreamWriter.prototype.closeFillStrokePath = function(useEvenOddRule) {
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).closeFillStrokePath);
        if (useEvenOddRule) {
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).evenOdd);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        } else this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Fills and strokes path`.
     * @private
     */ PdfStreamWriter.prototype.fillStrokePath = function(useEvenOddRule) {
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).fillStroke);
        if (useEvenOddRule) {
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).evenOdd);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        } else this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Fills path`.
     * @private
     */ PdfStreamWriter.prototype.fillPath = function(useEvenOddRule) {
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).fill);
        if (useEvenOddRule) {
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).evenOdd);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        } else this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Ends the path`.
     * @private
     */ PdfStreamWriter.prototype.endPath = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).n);
    };
    /**
     * `Closes and fills the path`.
     * @private
     */ PdfStreamWriter.prototype.closeFillPath = function(useEvenOddRule) {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).closePath);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).fill);
        if (useEvenOddRule) {
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).evenOdd);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        } else this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * `Closes and strokes the path`.
     * @private
     */ PdfStreamWriter.prototype.closeStrokePath = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).closeStrokePath);
    };
    /**
     * `Sets the text scaling`.
     * @private
     */ PdfStreamWriter.prototype.setTextScaling = function(textScaling) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(textScaling));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setTextScaling);
    };
    /**
     * `Strokes path`.
     * @private
     */ PdfStreamWriter.prototype.strokePath = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).stroke);
    };
    /**
     * `Restores` the graphics state.
     * @private
     */ PdfStreamWriter.prototype.restoreGraphicsState = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).restoreState);
    };
    /**
     * `Saves` the graphics state.
     * @private
     */ PdfStreamWriter.prototype.saveGraphicsState = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).saveState);
    };
    PdfStreamWriter.prototype.startNextLine = function(arg1, arg2) {
        if (typeof arg1 === "undefined") this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).goToNextLine);
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) {
            this.writePoint(arg1);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setCoords);
        } else {
            this.writePoint(arg1, arg2);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setCoords);
        }
    };
    /**
     * Shows the `text`.
     * @private
     */ PdfStreamWriter.prototype.showText = function(text) {
        this.checkTextParam(text);
        this.writeText(text);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setText);
    };
    /**
     * Sets `text leading`.
     * @private
     */ PdfStreamWriter.prototype.setLeading = function(leading) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(leading));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setTextLeading);
    };
    /**
     * `Begins the path`.
     * @private
     */ PdfStreamWriter.prototype.beginPath = function(x, y) {
        this.writePoint(x, y);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).beginPath);
    };
    /**
     * `Begins text`.
     * @private
     */ PdfStreamWriter.prototype.beginText = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).beginText);
    };
    /**
     * `Ends text`.
     * @private
     */ PdfStreamWriter.prototype.endText = function() {
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).endText);
    };
    PdfStreamWriter.prototype.appendRectangle = function(arg1, arg2, arg3, arg4) {
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02)) this.appendRectangle(arg1.x, arg1.y, arg1.width, arg1.height);
        else {
            this.writePoint(arg1, arg2);
            this.writePoint(arg3, arg4);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).appendRectangle);
        }
    };
    PdfStreamWriter.prototype.appendLineSegment = function(arg1, arg2) {
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) this.appendLineSegment(arg1.x, arg1.y);
        else {
            this.writePoint(arg1, arg2);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).appendLineSegment);
        }
    };
    /**
     * Sets the `text rendering mode`.
     * @private
     */ PdfStreamWriter.prototype.setTextRenderingMode = function(renderingMode) {
        this.stream.write(renderingMode.toString());
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setRenderingMode);
    };
    /**
     * Sets the `character spacing`.
     * @private
     */ PdfStreamWriter.prototype.setCharacterSpacing = function(charSpacing) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(charSpacing));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setCharacterSpace);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * Sets the `word spacing`.
     * @private
     */ PdfStreamWriter.prototype.setWordSpacing = function(wordSpacing) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(wordSpacing));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setWordSpace);
    };
    PdfStreamWriter.prototype.showNextLineText = function(arg1, arg2) {
        if (arg1 instanceof (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)) {
            this.checkTextParam(arg1);
            this.writeText(arg1);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setTextOnNewLine);
        } else {
            this.checkTextParam(arg1);
            this.writeText(arg1, arg2);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setTextOnNewLine);
        }
    };
    PdfStreamWriter.prototype.setColorSpace = function(arg1, arg2) {
        if (arg1 instanceof (0, $93a92e6ea67161be$export$b440601b3bfe4454) && typeof arg2 === "boolean") {
            var temparg1 = arg1;
            var temparg2 = arg2;
            // if (temparg1 == null) {
            //     throw new Error('ArgumentNullException:name');
            // }
            var op = temparg2 ? (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).selectcolorspaceforstroking : (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).selectcolorspacefornonstroking;
            this.stream.write(temparg1.toString());
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            this.stream.write(op);
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        } else {
            var temparg1 = arg1;
            var temparg2 = arg2;
            this.setColorSpace(new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(temparg1), temparg2);
        }
    };
    /**
     * Modifies current `transformation matrix`.
     * @private
     */ PdfStreamWriter.prototype.modifyCtm = function(matrix) {
        if (matrix == null) throw new Error("ArgumentNullException:matrix");
        this.stream.write(matrix.toString());
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).modifyCtm);
    };
    PdfStreamWriter.prototype.setFont = function(font, name, size) {
        if (typeof name === "string") this.setFont(font, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(name), size);
        else {
            if (font == null) throw new Error("ArgumentNullException:font");
            this.stream.write(name.toString());
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(size));
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setFont);
        }
    };
    /**
     * `Writes the operator`.
     * @private
     */ PdfStreamWriter.prototype.writeOperator = function(opcode) {
        this.stream.write(opcode);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    PdfStreamWriter.prototype.checkTextParam = function(text) {
        if (text == null) throw new Error("ArgumentNullException:text");
        if (typeof text === "string" && text === "") throw new Error("ArgumentException:The text can not be an empty string, text");
    };
    PdfStreamWriter.prototype.writeText = function(arg1, arg2) {
        if (arg1 instanceof (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83) && typeof arg2 === "undefined") this.stream.write(arg1.pdfEncode());
        else {
            var start = void 0;
            var end = void 0;
            if (arg2) {
                start = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).hexStringMark[0];
                end = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).hexStringMark[1];
            } else {
                start = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).stringMark[0];
                end = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).stringMark[1];
            }
            this.stream.write(start);
            this.stream.write(arg1);
            this.stream.write(end);
        }
    };
    PdfStreamWriter.prototype.writePoint = function(arg1, arg2) {
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg2 === "undefined") this.writePoint(arg1.x, arg1.y);
        else {
            var temparg1 = arg1;
            this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(temparg1));
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            // NOTE: Change Y co-ordinate because we shifted co-ordinate system only.
            arg2 = this.updateY(arg2);
            this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(arg2));
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        }
    };
    /**
     * `Updates y` co-ordinate.
     * @private
     */ PdfStreamWriter.prototype.updateY = function(arg) {
        return -arg;
    };
    /**
     * `Writes string` to the file.
     * @private
     */ PdfStreamWriter.prototype.write = function(string) {
        var builder = "";
        builder += string;
        builder += (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        this.writeOperator(builder);
    };
    /**
     * `Writes comment` to the file.
     * @private
     */ PdfStreamWriter.prototype.writeComment = function(comment) {
        if (comment != null && comment.length > 0) {
            var builder = "";
            builder += (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).comment;
            builder += (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace;
            builder += comment;
            //builder.Append( Operators.NewLine );
            this.writeOperator(builder);
        } else throw new Error("Invalid comment");
    };
    /**
     * Sets the `color and space`.
     * @private
     */ PdfStreamWriter.prototype.setColorAndSpace = function(color, colorSpace, forStroking) {
        if (!color.isEmpty) {
            // bool test = color is PdfExtendedColor;
            this.stream.write(color.toString(colorSpace, forStroking));
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
        }
    };
    // public setLineDashPattern(pattern : number[], patternOffset : number) : void
    // {
    //     let pat : PdfArray = new PdfArray(pattern);
    //     let off : PdfNumber = new PdfNumber(patternOffset);
    //     this.setLineDashPatternHelper(pat, off);
    // }
    // private setLineDashPatternHelper(pattern : PdfArray, patternOffset : PdfNumber) : void
    // {
    //     pattern.Save(this);
    //     this.m_stream.write(Operators.whiteSpace);
    //     patternOffset.Save(this);
    //     this.m_stream.write(Operators.whiteSpace);
    //     this.writeOperator(Operators.setDashPattern);
    // }
    /**
     * Sets the `line dash pattern`.
     * @private
     */ PdfStreamWriter.prototype.setLineDashPattern = function(pattern, patternOffset) {
        // let pat : PdfArray = new PdfArray(pattern);
        // let off : PdfNumber = new PdfNumber(patternOffset);
        // this.setLineDashPatternHelper(pat, off);
        this.setLineDashPatternHelper(pattern, patternOffset);
    };
    /**
     * Sets the `line dash pattern`.
     * @private
     */ PdfStreamWriter.prototype.setLineDashPatternHelper = function(pattern, patternOffset) {
        var tempPattern = "[";
        if (pattern.length > 1) {
            for(var index = 0; index < pattern.length; index++)if (index === pattern.length - 1) tempPattern += pattern[index].toString();
            else tempPattern += pattern[index].toString() + " ";
        }
        tempPattern += "] ";
        tempPattern += patternOffset.toString();
        tempPattern += " " + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setDashPattern;
        this.stream.write(tempPattern);
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
    };
    /**
     * Sets the `miter limit`.
     * @private
     */ PdfStreamWriter.prototype.setMiterLimit = function(miterLimit) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(miterLimit));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setMiterLimit);
    };
    /**
     * Sets the `width of the line`.
     * @private
     */ PdfStreamWriter.prototype.setLineWidth = function(width) {
        this.stream.write((0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(width));
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setLineWidth);
    };
    /**
     * Sets the `line cap`.
     * @private
     */ PdfStreamWriter.prototype.setLineCap = function(lineCapStyle) {
        this.stream.write(lineCapStyle.toString());
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setLineCapStyle);
    };
    /**
     * Sets the `line join`.
     * @private
     */ PdfStreamWriter.prototype.setLineJoin = function(lineJoinStyle) {
        this.stream.write(lineJoinStyle.toString());
        this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setLineJoinStyle);
    };
    Object.defineProperty(PdfStreamWriter.prototype, "position", {
        //IPdfWriter members
        /**
         * Gets or sets the current `position` within the stream.
         * @private
         */ get: function() {
            return this.stream.position;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStreamWriter.prototype, "length", {
        /**
         * Gets `stream length`.
         * @private
         */ get: function() {
            var returnValue = 0;
            if (this.stream.data.length !== 0 && this.stream.data.length !== -1) for(var index = 0; index < this.stream.data.length; index++)returnValue += this.stream.data[index].length;
            return returnValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStreamWriter.prototype, "document", {
        /**
         * Gets and Sets the `current document`.
         * @private
         */ get: function() {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    /* tslint:disable-next-line:max-line-length */ PdfStreamWriter.prototype.appendBezierSegment = function(arg1, arg2, arg3, arg4, arg5, arg6) {
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && arg3 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) {
            this.writePoint(arg1.x, arg1.y);
            this.writePoint(arg2.x, arg2.y);
            this.writePoint(arg3.x, arg3.y);
        } else {
            this.writePoint(arg1, arg2);
            this.writePoint(arg3, arg4);
            this.writePoint(arg5, arg6);
        }
        this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).appendbeziercurve);
    };
    PdfStreamWriter.prototype.setColourWithPattern = function(colours, patternName, forStroking) {
        if (colours != null) {
            var count = colours.length;
            var i = 0;
            for(i = 0; i < count; ++i){
                this.stream.write(colours[i].toString());
                this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
            }
        }
        if (patternName != null) {
            this.stream.write(patternName.toString());
            this.stream.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace);
        }
        if (forStroking) this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setColorAndPatternStroking);
        else this.writeOperator((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).setColorAndPattern);
    };
    return PdfStreamWriter;
}();





/**
 * PdfFont.ts class for EJ2-PDF
 */ 

/**
 * PdfStringFormat.ts class for EJ2-PDF
 */ 

/**
 * `PdfStringFormat` class represents the text layout information on PDF.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a pages to the document
 * let page1 : PdfPage = document.pages.add();
 * // set font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * // set brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * //
 * // set the format for string
 * let stringFormat : PdfStringFormat = new PdfStringFormat();
 * // set the text alignment
 * stringFormat.alignment = PdfTextAlignment.Center;
 * // set the vertical alignment
 * stringFormat.lineAlignment = PdfVerticalAlignment.Middle;
 * //
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10), stringFormat);
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $0a9de299d3bdc240$export$9e0870cc2541dcff = /** @class */ function() {
    function PdfStringFormat(arg1, arg2) {
        /**
         * The `scaling factor` of the text being drawn.
         * @private
         */ this.scalingFactor = 100.0;
        /**
         * Indicates text `wrapping` type.
         * @private
         */ this.wordWrapType = (0, $32129651824bb502$export$cc4af2cfe21903e).Word;
        this.internalLineLimit = true;
        this.wordWrapType = (0, $32129651824bb502$export$cc4af2cfe21903e).Word;
        if (typeof arg1 !== "undefined" && typeof arg1 !== "string") this.textAlignment = arg1;
        if (typeof arg2 !== "undefined") this.verticalAlignment = arg2;
    }
    Object.defineProperty(PdfStringFormat.prototype, "alignment", {
        //Properties
        /**
         * Gets or sets the `horizontal` text alignment
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * //
         * // set the format for string
         * let stringFormat : PdfStringFormat = new PdfStringFormat();
         * // set the text alignment
         * stringFormat.alignment = PdfTextAlignment.Center;
         * //
         * // draw the text
         * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10), stringFormat);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.textAlignment;
        },
        set: function(value) {
            this.textAlignment = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "textDirection", {
        get: function() {
            return this.direction;
        },
        set: function(value) {
            this.direction = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "lineAlignment", {
        /**
         * Gets or sets the `vertical` text alignment.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * //
         * // set the format for string
         * let stringFormat : PdfStringFormat = new PdfStringFormat();
         * // set the vertical alignment
         * stringFormat.lineAlignment = PdfVerticalAlignment.Middle;
         * //
         * // draw the text
         * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10), stringFormat);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            if (typeof this.verticalAlignment === "undefined" || this.verticalAlignment == null) return (0, $d174213b46afc09a$export$2692e69612b4a9e9).Top;
            else return this.verticalAlignment;
        },
        set: function(value) {
            this.verticalAlignment = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "rightToLeft", {
        /**
         * Gets or sets the value that indicates text `direction` mode.
         * @private
         */ get: function() {
            if (typeof this.isRightToLeft === "undefined" || this.isRightToLeft == null) return false;
            else return this.isRightToLeft;
        },
        set: function(value) {
            this.isRightToLeft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "characterSpacing", {
        /**
         * Gets or sets value that indicates a `size` among the characters in the text.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * //
         * // set the format for string
         * let stringFormat : PdfStringFormat = new PdfStringFormat();
         * // set character spacing
         * stringFormat.characterSpacing = 10;
         * //
         * // draw the text
         * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10), stringFormat);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            if (typeof this.internalCharacterSpacing === "undefined" || this.internalCharacterSpacing == null) return 0;
            else return this.internalCharacterSpacing;
        },
        set: function(value) {
            this.internalCharacterSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "wordSpacing", {
        /**
         * Gets or sets value that indicates a `size` among the words in the text.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * //
         * // set the format for string
         * let stringFormat : PdfStringFormat = new PdfStringFormat();
         * // set word spacing
         * stringFormat.wordSpacing = 10;
         * //
         * // draw the text
         * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(10, 10), stringFormat);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            if (typeof this.internalWordSpacing === "undefined" || this.internalWordSpacing == null) return 0;
            else return this.internalWordSpacing;
        },
        set: function(value) {
            this.internalWordSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "lineSpacing", {
        /**
         * Gets or sets value that indicates the `vertical distance` between the baselines of adjacent lines of text.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * // set string
         * let text : string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
         * incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitati';
         * // set rectangle bounds
         * let rectangle : RectangleF = new RectangleF({x : 0, y : 0}, {width : 300, height : 100})
         * //
         * // set the format for string
         * let stringFormat : PdfStringFormat = new PdfStringFormat();
         * // set line spacing
         * stringFormat.lineSpacing = 10;
         * //
         * // draw the text
         * page1.graphics.drawString(text, font, blackBrush, rectangle, stringFormat);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            if (typeof this.leading === "undefined" || this.leading == null) return 0;
            else return this.leading;
        },
        set: function(value) {
            this.leading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "clipPath", {
        /**
         * Gets or sets a value indicating whether the text is `clipped` or not.
         * @private
         */ get: function() {
            if (typeof this.clip === "undefined" || this.clip == null) return false;
            else return this.clip;
        },
        set: function(value) {
            this.clip = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "subSuperScript", {
        /**
         * Gets or sets value indicating whether the text is in `subscript or superscript` mode.
         * @private
         */ get: function() {
            if (typeof this.pdfSubSuperScript === "undefined" || this.pdfSubSuperScript == null) return (0, $32129651824bb502$export$72189ec4d9b4f960).None;
            else return this.pdfSubSuperScript;
        },
        set: function(value) {
            this.pdfSubSuperScript = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "paragraphIndent", {
        /**
         * Gets or sets the `indent` of the first line in the paragraph.
         * @private
         */ get: function() {
            if (typeof this.internalParagraphIndent === "undefined" || this.internalParagraphIndent == null) return 0;
            else return this.internalParagraphIndent;
        },
        set: function(value) {
            this.internalParagraphIndent = value;
            this.firstLineIndent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "lineLimit", {
        /**
         * Gets or sets a value indicating whether [`line limit`].
         * @private
         */ get: function() {
            return this.internalLineLimit;
        },
        set: function(value) {
            this.internalLineLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "measureTrailingSpaces", {
        /**
         * Gets or sets a value indicating whether [`measure trailing spaces`].
         * @private
         */ get: function() {
            if (typeof this.trailingSpaces === "undefined" || this.trailingSpaces == null) return false;
            else return this.trailingSpaces;
        },
        set: function(value) {
            this.trailingSpaces = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "noClip", {
        /**
         * Gets or sets a value indicating whether [`no clip`].
         * @private
         */ get: function() {
            if (typeof this.isNoClip === "undefined" || this.isNoClip == null) return false;
            else return this.isNoClip;
        },
        set: function(value) {
            this.isNoClip = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "wordWrap", {
        /**
         * Gets or sets value indicating type of the text `wrapping`.
         * @private
         */ get: function() {
            // if (typeof this.wrapType === 'undefined' || this.wrapType == null) {
            //     return PdfWordWrapType.Word;
            // } else {
            return this.wordWrapType;
        // }
        },
        set: function(value) {
            this.wordWrapType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "horizontalScalingFactor", {
        /**
         * Gets or sets the `scaling factor`.
         * @private
         */ get: function() {
            // if (typeof this.scalingFactor === 'undefined' || this.scalingFactor == null) {
            //     return 100;
            // } else {
            return this.scalingFactor;
        // }
        },
        set: function(value) {
            if (value <= 0) throw new Error("ArgumentOutOfRangeException:The scaling factor cant be less of equal to zero, ScalingFactor");
            this.scalingFactor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringFormat.prototype, "firstLineIndent", {
        /**
         * Gets or sets the `indent` of the first line in the text.
         * @private
         */ get: function() {
            if (typeof this.initialLineIndent === "undefined" || this.initialLineIndent == null) return 0;
            else return this.initialLineIndent;
        },
        set: function(value) {
            this.initialLineIndent = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Clones` the object.
     * @private
     */ //IClonable implementation
    PdfStringFormat.prototype.clone = function() {
        var format = this;
        return format;
    };
    return PdfStringFormat;
}();




/**
 * StringTokenizer.ts class for EJ2-PDF
 * Utility class for working with strings.
 * @private
 */ var $6d330c1e9d5e5065$export$c130daea5962048f = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `StringTokenizer` class.
     * @private
     */ function StringTokenizer(textValue) {
        /**
         * Current `position`.
         * @private
         */ this.currentPosition = 0;
        if (textValue == null) throw new Error("ArgumentNullException:text");
        this.text = textValue;
    }
    Object.defineProperty(StringTokenizer.prototype, "length", {
        // Properties
        /**
         * Gets text `length`.
         * @private
         */ get: function() {
            return this.text.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StringTokenizer.prototype, "end", {
        get: function() {
            return this.currentPosition === this.text.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StringTokenizer.prototype, "position", {
        /**
         * Gets or sets the position.
         * @private
         */ get: function() {
            return this.currentPosition;
        },
        set: function(value) {
            this.currentPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    StringTokenizer.getCharsCount = function(text, symbols) {
        if (typeof symbols === "string") {
            if (text == null) throw new Error("ArgumentNullException:wholeText");
            var numSymbols = 0;
            var curIndex = 0;
            for(;;){
                curIndex = text.indexOf(symbols, curIndex);
                if (curIndex === -1) break;
                else {
                    numSymbols++;
                    curIndex++;
                }
            }
            return numSymbols;
        } else {
            if (text == null) throw new Error("ArgumentNullException:text");
            if (symbols == null) throw new Error("ArgumentNullException:symbols");
            var count = 0;
            for(var i = 0, len = text.length; i < len; i++){
                var ch = text[i];
                if (this.contains(symbols, ch)) count++;
            }
            return count;
        }
    };
    /**
     * Reads line of the text.
     * @private
     */ StringTokenizer.prototype.readLine = function() {
        var pos = this.currentPosition;
        while(pos < this.length){
            var ch = this.text[pos];
            switch(ch){
                case "\r":
                case "\n":
                    var text = this.text.substr(this.currentPosition, pos - this.currentPosition);
                    this.currentPosition = pos + 1;
                    if (ch === "\r" && this.currentPosition < this.length && this.text[this.currentPosition] === "\n") this.currentPosition++;
                    return text;
            }
            pos++;
        }
        // The remaining text.
        if (pos > this.currentPosition) {
            var text2 = this.text.substr(this.currentPosition, pos - this.currentPosition);
            this.currentPosition = pos;
            return text2;
        }
        return null;
    };
    /**
     * Reads line of the text.
     * @private
     */ StringTokenizer.prototype.peekLine = function() {
        var pos = this.currentPosition;
        var line = this.readLine();
        this.currentPosition = pos;
        return line;
    };
    /**
     * Reads a word from the text.
     * @private
     */ StringTokenizer.prototype.readWord = function() {
        var pos = this.currentPosition;
        while(pos < this.length){
            var ch = this.text[pos];
            switch(ch){
                case "\r":
                case "\n":
                    var textValue = this.text.substr(this.currentPosition, pos - this.currentPosition);
                    this.currentPosition = pos + 1;
                    if (ch === "\r" && this.currentPosition < this.length && this.text[this.currentPosition] === "\n") this.currentPosition++;
                    return textValue;
                case " ":
                case "	":
                    if (pos === this.currentPosition) pos++;
                    var text = this.text.substr(this.currentPosition, pos - this.currentPosition);
                    this.currentPosition = pos;
                    return text;
            }
            pos++;
        }
        // The remaining text.
        if (pos > this.currentPosition) {
            var text2 = this.text.substr(this.currentPosition, pos - this.currentPosition);
            this.currentPosition = pos;
            return text2;
        }
        return null;
    };
    /**
     * Peeks a word from the text.
     * @private
     */ StringTokenizer.prototype.peekWord = function() {
        var pos = this.currentPosition;
        var word = this.readWord();
        this.currentPosition = pos;
        return word;
    };
    StringTokenizer.prototype.read = function(count) {
        if (typeof count === "undefined") {
            var ch = "0";
            if (!this.end) {
                ch = this.text[this.currentPosition];
                this.currentPosition++;
            }
            return ch;
        } else {
            var num = 0;
            var builder = "";
            while(!this.end && num < count){
                var ch = this.read();
                builder = builder + ch;
                num++;
            }
            return builder;
        }
    };
    /**
     * Peeks char form the data.
     * @private
     */ StringTokenizer.prototype.peek = function() {
        var ch = "0";
        if (!this.end) ch = this.text[this.currentPosition];
        return ch;
    };
    /**
     * Closes a reader.
     * @private
     */ StringTokenizer.prototype.close = function() {
        this.text = null;
    };
    StringTokenizer.prototype.readToEnd = function() {
        var text;
        if (this.currentPosition === 0) text = this.text;
        else text = this.text.substr(this.currentPosition, this.length - this.currentPosition);
        this.currentPosition = this.length;
        return text;
    };
    //Implementation
    /**
     * Checks whether array contains a symbol.
     * @private
     */ StringTokenizer.contains = function(array, symbol) {
        var contains = false;
        for(var i = 0; i < array.length; i++)if (array[i] === symbol) {
            contains = true;
            break;
        }
        return contains;
    };
    // Constants
    /**
     * `Whitespace` symbol.
     * @private
     */ StringTokenizer.whiteSpace = " ";
    /**
     * `tab` symbol.
     * @private
     */ StringTokenizer.tab = "	";
    /**
     * Array of `spaces`.
     * @private
     */ StringTokenizer.spaces = [
        StringTokenizer.whiteSpace,
        StringTokenizer.tab
    ];
    /**
     * `Pattern` for WhiteSpace.
     * @private
     */ StringTokenizer.whiteSpacePattern = "^[ 	]+$";
    return StringTokenizer;
}();


/**
 * Class `lay outing the text`.
 */ var $da0806e60b4d67c7$export$53b9c0a8035b9a38 = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `StringLayouter` class.
     * @private
     */ function PdfStringLayouter() {
        /**
         * Checks whether the x co-ordinate is need to set as client size or not.
         * @hidden
         * @private
         */ this.isOverloadWithPosition = false;
    //
    }
    PdfStringLayouter.prototype.layout = function(arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
        if (arg4 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02)) {
            this.initialize(arg1, arg2, arg3, arg4, arg5);
            this.isOverloadWithPosition = arg6;
            this.clientSize = arg7;
            var result = this.doLayout();
            this.clear();
            return result;
        } else {
            this.initialize(arg1, arg2, arg3, arg4);
            this.isOverloadWithPosition = arg5;
            this.clientSize = arg6;
            var result = this.doLayout();
            this.clear();
            return result;
        }
    };
    PdfStringLayouter.prototype.initialize = function(text, font, format, rectSize, pageHeight) {
        if (typeof pageHeight === "number") {
            if (text == null) throw new Error("ArgumentNullException:text");
            if (font == null) throw new Error("ArgumentNullException:font");
            this.text = text;
            this.font = font;
            this.format = format;
            this.size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(rectSize.width, rectSize.height);
            this.rectangle = rectSize;
            this.pageHeight = pageHeight;
            this.reader = new (0, $6d330c1e9d5e5065$export$c130daea5962048f)(text);
        } else this.initialize(text, font, format, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0), rectSize), 0);
    };
    /**
     * `Clear` all resources.
     * @private
     */ PdfStringLayouter.prototype.clear = function() {
        this.font = null;
        this.format = null;
        this.reader.close();
        this.reader = null;
        this.text = null;
    };
    /**
     * `Layouts` the text.
     * @private
     */ PdfStringLayouter.prototype.doLayout = function() {
        var result = new $da0806e60b4d67c7$export$87270e423e454f29();
        var lineResult = new $da0806e60b4d67c7$export$87270e423e454f29();
        var lines = [];
        var line = this.reader.peekLine();
        var lineIndent = this.getLineIndent(true);
        while(line != null){
            lineResult = this.layoutLine(line, lineIndent);
            if (lineResult !== null || typeof lineResult !== "undefined") {
                var numSymbolsInserted = 0;
                /* tslint:disable */ var returnedValue = this.copyToResult(result, lineResult, lines, /*out*/ numSymbolsInserted);
                /* tslint:enable */ var success = returnedValue.success;
                numSymbolsInserted = returnedValue.numInserted;
                if (!success) {
                    this.reader.read(numSymbolsInserted);
                    break;
                }
            }
            // if (lineResult.textRemainder != null && lineResult.textRemainder.length > 0 ) {
            //     break;
            // }
            this.reader.readLine();
            line = this.reader.peekLine();
            lineIndent = this.getLineIndent(false);
        }
        this.finalizeResult(result, lines);
        return result;
    };
    /**
     * Returns `line indent` for the line.
     * @private
     */ PdfStringLayouter.prototype.getLineIndent = function(firstLine) {
        var lineIndent = 0;
        if (this.format != null) {
            lineIndent = firstLine ? this.format.firstLineIndent : this.format.paragraphIndent;
            lineIndent = this.size.width > 0 ? Math.min(this.size.width, lineIndent) : lineIndent;
        }
        return lineIndent;
    };
    /**
     * Calculates `height` of the line.
     * @private
     */ PdfStringLayouter.prototype.getLineHeight = function() {
        var height = this.font.height;
        if (this.format != null && this.format.lineSpacing !== 0) height = this.format.lineSpacing + this.font.height;
        return height;
    };
    /**
     * Calculates `width` of the line.
     * @private
     */ PdfStringLayouter.prototype.getLineWidth = function(line) {
        var width = this.font.getLineWidth(line, this.format);
        return width;
    };
    // tslint:disable
    /**
     * `Layouts` line.
     * @private
     */ PdfStringLayouter.prototype.layoutLine = function(line, lineIndent) {
        var lineResult = new $da0806e60b4d67c7$export$87270e423e454f29();
        lineResult.layoutLineHeight = this.getLineHeight();
        var lines = [];
        var maxWidth = this.size.width;
        var lineWidth = this.getLineWidth(line) + lineIndent;
        var lineType = $da0806e60b4d67c7$export$aa318e0578993894.FirstParagraphLine;
        var readWord = true;
        // line is in bounds.
        if (maxWidth <= 0 || Math.round(lineWidth) <= Math.round(maxWidth)) this.addToLineResult(lineResult, lines, line, lineWidth, $da0806e60b4d67c7$export$aa318e0578993894.NewLineBreak | lineType);
        else {
            var builder = "";
            var curLine = "";
            lineWidth = lineIndent;
            var curIndent = lineIndent;
            var reader = new (0, $6d330c1e9d5e5065$export$c130daea5962048f)(line);
            var word = reader.peekWord();
            var isSingleWord = false;
            if (word.length !== reader.length) {
                if (word === " ") {
                    curLine = curLine + word;
                    builder = builder + word;
                    reader.position += 1;
                    word = reader.peekWord();
                }
            }
            while(word != null){
                curLine = curLine + word;
                var curLineWidth = this.getLineWidth(curLine.toString()) + curIndent /*)*/ ;
                if (curLine.toString() === " ") {
                    curLine = "";
                    curLineWidth = 0;
                }
                if (curLineWidth > maxWidth) {
                    if (this.getWrapType() === (0, $32129651824bb502$export$cc4af2cfe21903e).None) break;
                    if (curLine.length === word.length) {
                        //  Character wrap is disabled or one symbol is greater than bounds.
                        if (this.getWrapType() === (0, $32129651824bb502$export$cc4af2cfe21903e).WordOnly) {
                            lineResult.textRemainder = line.substring(reader.position);
                            break;
                        } else if (curLine.length === 1) {
                            builder = builder + word;
                            break;
                        } else {
                            readWord = false;
                            curLine = "";
                            word = reader.peek().toString();
                            continue;
                        }
                    } else {
                        if (this.getLineWidth(word.toString()) > maxWidth) this.format.wordWrap = (0, $32129651824bb502$export$cc4af2cfe21903e).Character;
                        else if (typeof this.format !== "undefined" && this.format !== null) this.format.wordWrap = (0, $32129651824bb502$export$cc4af2cfe21903e).Word;
                        if (this.getWrapType() !== (0, $32129651824bb502$export$cc4af2cfe21903e).Character || !readWord) {
                            var ln = builder.toString();
                            // if (ln.indexOf(' ') === -1) {
                            //     isSingleWord = true;
                            //     this.addToLineResult(lineResult, lines, curLine, lineWidth, LineType.LayoutBreak | lineType);
                            // } else {
                            //     this.addToLineResult(lineResult, lines, ln, lineWidth, LineType.LayoutBreak | lineType);
                            // }                          
                            if (ln !== " ") this.addToLineResult(lineResult, lines, ln, lineWidth, $da0806e60b4d67c7$export$aa318e0578993894.LayoutBreak | lineType);
                            if (this.isOverloadWithPosition) maxWidth = this.clientSize.width;
                            curLine = "";
                            builder = "";
                            lineWidth = 0;
                            curIndent = 0;
                            curLineWidth = 0;
                            lineType = $da0806e60b4d67c7$export$aa318e0578993894.None;
                            // if (isSingleWord) {
                            //     reader.readWord();
                            //     readWord = false;
                            // }
                            word = readWord ? word : reader.peekWord();
                            //isSingleWord = false;
                            readWord = true;
                        } else {
                            readWord = false;
                            curLine = "";
                            curLine = curLine + builder.toString();
                            word = reader.peek().toString();
                        }
                        continue;
                    }
                }
                /*tslint:disable:max-func-body-length */ builder = builder + word;
                lineWidth = curLineWidth;
                if (readWord) {
                    reader.readWord();
                    word = reader.peekWord();
                //isSingleWord = false;
                } else {
                    reader.read();
                    word = reader.peek().toString();
                }
            }
            if (builder.length > 0) {
                var ln = builder.toString();
                this.addToLineResult(lineResult, lines, ln, lineWidth, $da0806e60b4d67c7$export$aa318e0578993894.NewLineBreak | $da0806e60b4d67c7$export$aa318e0578993894.LastParagraphLine);
            }
            reader.close();
        }
        lineResult.layoutLines = [];
        for(var index = 0; index < lines.length; index++)lineResult.layoutLines.push(lines[index]);
        lines = [];
        return lineResult;
    };
    /**
     * `Adds` line to line result.
     * @private
     */ PdfStringLayouter.prototype.addToLineResult = function(lineResult, lines, line, lineWidth, breakType) {
        var info = new $da0806e60b4d67c7$export$3c1adf58630f431d();
        info.text = line;
        info.width = lineWidth;
        info.lineType = breakType;
        lines.push(info);
        var size = lineResult.actualSize;
        size.height += this.getLineHeight();
        size.width = Math.max(size.width, lineWidth);
        lineResult.size = size;
    };
    /**
     * `Copies` layout result from line result to entire result. Checks whether we can proceed lay outing or not.
     * @private
     */ PdfStringLayouter.prototype.copyToResult = function(result, lineResult, lines, /*out*/ numInserted) {
        var success = true;
        var allowPartialLines = this.format != null && !this.format.lineLimit;
        var height = result.actualSize.height;
        var maxHeight = this.size.height;
        if (this.pageHeight > 0 && maxHeight + this.rectangle.y > this.pageHeight) {
            maxHeight = this.rectangle.y - this.pageHeight;
            maxHeight = Math.max(maxHeight, -maxHeight);
        }
        numInserted = 0;
        if (lineResult.lines != null) for(var i = 0, len = lineResult.lines.length; i < len; i++){
            var expHeight = height + lineResult.lineHeight;
            if (expHeight <= maxHeight || maxHeight <= 0 || allowPartialLines) {
                var info = lineResult.lines[i];
                numInserted += info.text.length;
                info = this.trimLine(info, lines.length === 0);
                lines.push(info);
                // Update width.
                var size = result.actualSize;
                size.width = Math.max(size.width, info.width);
                result.size = size;
                // The part of the line fits only and it's allowed to use partial lines.
                // if (expHeight >= maxHeight && maxHeight > 0 && allowPartialLines)
                // {
                //     let shouldClip : boolean = (this.format == null || !this.format.noClip);
                //     if (shouldClip)
                //     {
                //         let exceededHeight : number = expHeight - maxHeight;
                //         let fitHeight : number  = /*Utils.Round(*/ lineResult.lineHeight - exceededHeight /*)*/;
                //         height = /*Utils.Round(*/ height + fitHeight /*)*/;
                //     }
                //     else
                //     {
                //         height = expHeight;
                //     }
                //     success = false;
                //     break;
                // } else {
                height = expHeight;
            // }
            } else {
                success = false;
                break;
            }
        }
        if (height != result.size.height) {
            var size1 = result.actualSize;
            size1.height = height;
            result.size = size1;
        }
        return {
            success: success,
            numInserted: numInserted
        };
    };
    /**
     * `Finalizes` final result.
     * @private
     */ PdfStringLayouter.prototype.finalizeResult = function(result, lines) {
        result.layoutLines = [];
        for(var index = 0; index < lines.length; index++)result.layoutLines.push(lines[index]);
        result.layoutLineHeight = this.getLineHeight();
        if (!this.reader.end) result.textRemainder = this.reader.readToEnd();
        lines = [];
    };
    /**
     * `Trims` whitespaces at the line.
     * @private
     */ PdfStringLayouter.prototype.trimLine = function(info, firstLine) {
        var line = info.text;
        var lineWidth = info.width;
        // Trim start whitespaces if the line is not a start of the paragraph only.
        var trimStartSpaces = (info.lineType & $da0806e60b4d67c7$export$aa318e0578993894.FirstParagraphLine) === 0;
        var start = this.format == null || !this.format.rightToLeft;
        var spaces = (0, $6d330c1e9d5e5065$export$c130daea5962048f).spaces;
        line = start ? line.trim() : line.trim();
        // Recalculate line width.
        if (line.length !== info.text.length) {
            lineWidth = this.getLineWidth(line);
            if ((info.lineType & $da0806e60b4d67c7$export$aa318e0578993894.FirstParagraphLine) > 0) lineWidth += this.getLineIndent(firstLine);
        }
        info.text = line;
        info.width = lineWidth;
        return info;
    };
    /**
     * Returns `wrap` type.
     * @private
     */ PdfStringLayouter.prototype.getWrapType = function() {
        var wrapType = this.format != null ? this.format.wordWrap : (0, $32129651824bb502$export$cc4af2cfe21903e).Word;
        return wrapType;
    };
    return PdfStringLayouter;
}();
//Internal declaration
var $da0806e60b4d67c7$export$87270e423e454f29 = /** @class */ function() {
    function PdfStringLayoutResult() {}
    Object.defineProperty(PdfStringLayoutResult.prototype, "remainder", {
        // Properties
        /**
         * Gets the `text` which is not lay outed.
         * @private
         */ get: function() {
            return this.textRemainder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringLayoutResult.prototype, "actualSize", {
        /**
         * Gets the actual layout text `bounds`.
         * @private
         */ get: function() {
            if (typeof this.size === "undefined") this.size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
            return this.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringLayoutResult.prototype, "lines", {
        /**
         * Gets layout `lines` information.
         * @private
         */ get: function() {
            return this.layoutLines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringLayoutResult.prototype, "lineHeight", {
        /**
         * Gets the `height` of the line.
         * @private
         */ get: function() {
            return this.layoutLineHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringLayoutResult.prototype, "empty", {
        /**
         * Gets value that indicates whether any layout text [`empty`].
         * @private
         */ get: function() {
            return this.layoutLines == null || this.layoutLines.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfStringLayoutResult.prototype, "lineCount", {
        /**
         * Gets `number of` the layout lines.
         * @private
         */ get: function() {
            var count = !this.empty ? this.layoutLines.length : 0;
            return count;
        },
        enumerable: true,
        configurable: true
    });
    return PdfStringLayoutResult;
}();
var $da0806e60b4d67c7$export$3c1adf58630f431d = /** @class */ function() {
    function LineInfo() {}
    Object.defineProperty(LineInfo.prototype, "lineType", {
        //Properties
        /**
         * Gets the `type` of the line text.
         * @private
         */ get: function() {
            return this.type;
        },
        set: function(value) {
            this.type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineInfo.prototype, "text", {
        /**
         * Gets the line `text`.
         * @private
         */ get: function() {
            return this.content;
        },
        set: function(value) {
            this.content = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineInfo.prototype, "width", {
        /**
         * Gets `width` of the line text.
         * @private
         */ get: function() {
            return this.lineWidth;
        },
        set: function(value) {
            this.lineWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    return LineInfo;
}();
var $da0806e60b4d67c7$export$aa318e0578993894;
(function(LineType) {
    /**
     * Specifies the type of `None`.
     * @private
     */ LineType[LineType["None"] = 0] = "None";
    /**
     * Specifies the type of `NewLineBreak`.
     * @private
     */ LineType[LineType["NewLineBreak"] = 1] = "NewLineBreak";
    /**
     * Specifies the type of `LayoutBreak`.
     * @private
     */ LineType[LineType["LayoutBreak"] = 2] = "LayoutBreak";
    /**
     * Specifies the type of `FirstParagraphLine`.
     * @private
     */ LineType[LineType["FirstParagraphLine"] = 4] = "FirstParagraphLine";
    /**
     * Specifies the type of `LastParagraphLine`.
     * @private
     */ LineType[LineType["LastParagraphLine"] = 8] = "LastParagraphLine";
})($da0806e60b4d67c7$export$aa318e0578993894 || ($da0806e60b4d67c7$export$aa318e0578993894 = {}));



/**
 * Defines a particular format for text, including font face, size, and style attributes.
 * @private
 */ var $ec27d251b6edcb44$export$60d73556588f648b = /** @class */ function() {
    function PdfFont(size, style) {
        /**
         * `Style` of the font.
         * @private
         */ this.fontStyle = (0, $32129651824bb502$export$80979869bc40ff1f).Regular;
        if (typeof size === "number" && typeof style === "undefined") this.fontSize = size;
        else {
            this.fontSize = size;
            this.setStyle(style);
        }
    }
    Object.defineProperty(PdfFont.prototype, "name", {
        //Properties
        /**
         * Gets the face name of this Font.
         * @private
         */ get: function() {
            return this.metrics.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "size", {
        /**
         * Gets the size of this font.
         * @private
         */ get: function() {
            return this.fontSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "height", {
        /**
         * Gets the height of the font in points.
         * @private
         */ get: function() {
            return this.metrics.getHeight(null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "style", {
        /**
         * Gets the style information for this font.
         * @private
         */ get: function() {
            return this.fontStyle;
        },
        set: function(value) {
            this.fontStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "bold", {
        /**
         * Gets a value indicating whether this `PdfFont` is `bold`.
         * @private
         */ get: function() {
            return (this.style & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "italic", {
        /**
         * Gets a value indicating whether this `PdfFont` has the `italic` style applied.
         * @private
         */ get: function() {
            return (this.style & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "strikeout", {
        /**
         * Gets a value indicating whether this `PdfFont` is `strikeout`.
         * @private
         */ get: function() {
            return (this.style & (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout) > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "underline", {
        /**
         * Gets a value indicating whether this `PdfFont` is `underline`.
         * @private
         */ get: function() {
            return (this.style & (0, $32129651824bb502$export$80979869bc40ff1f).Underline) > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "metrics", {
        /**
         * Gets or sets the `metrics` for this font.
         * @private
         */ get: function() {
            return this.fontMetrics;
        },
        set: function(value) {
            this.fontMetrics = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfFont.prototype, "element", {
        // /**
        //  * Gets and Sets the font `internals`.
        //  * @private
        //  */
        // public get fontInternal() : IPdfPrimitive {
        //     return this.pdfFontInternals;
        // }
        // public set fontInternal(value : IPdfPrimitive) {
        //     this.pdfFontInternals = value;
        // }
        //IPdfWrapper Members
        /**
         * Gets the `element` representing the font.
         * @private
         */ get: function() {
            return this.pdfFontInternals;
        },
        enumerable: true,
        configurable: true
    });
    PdfFont.prototype.measureString = function(text, arg2, arg3, arg4, arg5) {
        if (typeof text === "string" && typeof arg2 === "undefined") return this.measureString(text, null);
        else if (typeof text === "string" && (arg2 instanceof (0, $0a9de299d3bdc240$export$9e0870cc2541dcff) || arg2 == null) && typeof arg3 === "undefined" && typeof arg4 === "undefined") {
            var temparg2 = arg2;
            var charactersFitted = 0;
            var linesFilled = 0;
            return this.measureString(text, temparg2, charactersFitted, linesFilled);
        } else if (typeof text === "string" && (arg2 instanceof (0, $0a9de299d3bdc240$export$9e0870cc2541dcff) || arg2 == null) && typeof arg3 === "number" && typeof arg4 === "number") {
            var temparg2 = arg2;
            return this.measureString(text, 0, temparg2, arg3, arg4);
        // } else if (typeof text === 'string' && typeof arg2 === 'number' && typeof arg3 === 'undefined') {
        //     return this.measureString(text, arg2, null);
        // } else if (typeof text === 'string' && typeof arg2 === 'number' && (arg3 instanceof PdfStringFormat || arg3 == null) && typeof arg4 === 'undefined' && typeof arg5 === 'undefined') {
        //     let temparg3 : PdfStringFormat = arg3 as PdfStringFormat;
        //     let charactersFitted : number = 0;
        //     let linesFilled : number = 0;
        //     return this.measureString(text, arg2, temparg3, charactersFitted, linesFilled);
        } else if (typeof text === "string" && typeof arg2 === "number" && (arg3 instanceof (0, $0a9de299d3bdc240$export$9e0870cc2541dcff) || arg3 == null) && typeof arg4 === "number" && typeof arg5 === "number") {
            var layoutArea = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg2, 0);
            var temparg3 = arg3;
            return this.measureString(text, layoutArea, temparg3, arg4, arg5);
        // } else if (typeof text === 'string' && arg2 instanceof SizeF && typeof arg3 === 'undefined') {
        //     return this.measureString(text, arg2, null);
        // } else if (typeof text === 'string' && arg2 instanceof SizeF && (arg3 instanceof PdfStringFormat || arg3 == null) && typeof arg4 === 'undefined' && typeof arg5 === 'undefined') {
        //     let temparg3 : PdfStringFormat = arg3 as PdfStringFormat;
        //     let charactersFitted : number = 0;
        //     let linesFilled : number = 0;
        //     return this.measureString(text, arg2, temparg3, charactersFitted, linesFilled);
        } else {
            if (text == null) throw Error('ArgumentNullException("text")');
            var temparg2 = arg2;
            var temparg3 = arg3;
            var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
            var result = layouter.layout(text, this, temparg3, temparg2, false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            // arg4 = (result.Remainder == null) ? text.length : text.length - result.Remainder.length;
            arg4 = text.length;
            arg5 = result.empty ? 0 : result.lines.length;
            return result.actualSize;
        }
    };
    /* tslint:enable */ //IPdfCache Members
    /**
     * `Checks` whether the object is similar to another object.
     * @private
     */ PdfFont.prototype.equalsTo = function(obj) {
        var result = this.equalsToFont(obj);
        return result;
    };
    /**
     * Returns `internals` of the object.
     * @private
     */ PdfFont.prototype.getInternals = function() {
        return this.pdfFontInternals;
    };
    /**
     * Sets `internals` to the object.
     * @private
     */ PdfFont.prototype.setInternals = function(internals) {
        if (internals == null) throw new Error("ArgumentNullException:internals");
        this.pdfFontInternals = internals;
    };
    /**
     * Sets the `style` of the font.
     * @private
     */ PdfFont.prototype.setStyle = function(style) {
        this.fontStyle = style;
    };
    /**
     * Applies `settings` to the default line width.
     * @private
     */ PdfFont.prototype.applyFormatSettings = function(line, format, width) {
        // if (line == null) {
        //     throw new Error(`ArgumentNullException:line`);
        // }
        var realWidth = width;
        if (format != null && width > 0) {
            // Space among characters is not default.
            if (format.characterSpacing !== 0) realWidth += (line.length - 1) * format.characterSpacing;
            // Space among words is not default.
            if (format.wordSpacing !== 0) {
                var symbols = (0, $6d330c1e9d5e5065$export$c130daea5962048f).spaces;
                var whitespacesCount = (0, $6d330c1e9d5e5065$export$c130daea5962048f).getCharsCount(line, symbols);
                realWidth += whitespacesCount * format.wordSpacing;
            }
        }
        return realWidth;
    };
    //Constants
    /**
     * `Multiplier` of the symbol width.
     * @default 0.001
     * @private
     */ PdfFont.charSizeMultiplier = 0.001;
    /**
     * `Synchronization` object.
     * @private
     */ PdfFont.syncObject = new Object();
    return PdfFont;
}();


/**
 * PdfTransformationMatrix.ts class for EJ2-PDF
 */ 

/**
 * Class for representing Root `transformation matrix`.
 */ var $31933e0cf70afc95$export$ab1b31af38a0591e = /** @class */ function() {
    function PdfTransformationMatrix(value) {
        /**
         * Value for `angle converting`.
         * @default 180.0 / Math.PI
         * @private
         */ this.radDegFactor = 180.0 / Math.PI;
        if (typeof value === "undefined") this.transformationMatrix = new $31933e0cf70afc95$export$5b12bf1653c0dd85(1.00, 0.00, 0.00, 1.00, 0.00, 0.00);
        else this.transformationMatrix = new $31933e0cf70afc95$export$5b12bf1653c0dd85(1.00, 0.00, 0.00, -1, 0.00, 0.00);
    }
    Object.defineProperty(PdfTransformationMatrix.prototype, "matrix", {
        // Properties
        /**
         * Gets or sets the `internal matrix object`.
         * @private
         */ get: function() {
            return this.transformationMatrix;
        },
        set: function(value) {
            this.transformationMatrix = value;
        },
        enumerable: true,
        configurable: true
    });
    // Public methods
    /**
     * `Translates` coordinates by specified coordinates.
     * @private
     */ PdfTransformationMatrix.prototype.translate = function(offsetX, offsetY) {
        this.transformationMatrix.translate(offsetX, offsetY);
    };
    /**
     * `Scales` coordinates by specified coordinates.
     * @private
     */ PdfTransformationMatrix.prototype.scale = function(scaleX, scaleY) {
        this.transformationMatrix.elements[0] = scaleX;
        this.transformationMatrix.elements[3] = scaleY;
    };
    /**
     * `Rotates` coordinate system in counterclockwise direction.
     * @private
     */ PdfTransformationMatrix.prototype.rotate = function(angle) {
        //Convert from degree to radian 
        angle = angle * Math.PI / 180;
        //Rotation 
        this.transformationMatrix.elements[0] = Math.cos(angle);
        this.transformationMatrix.elements[1] = Math.sin(angle);
        this.transformationMatrix.elements[2] = -Math.sin(angle);
        this.transformationMatrix.elements[3] = Math.cos(angle);
    };
    // Overrides
    /**
     * Gets `PDF representation`.
     * @private
     */ PdfTransformationMatrix.prototype.toString = function() {
        var builder = "";
        var whitespace = " ";
        for(var i = 0, len = this.transformationMatrix.elements.length; i < len; i++){
            var temp = this.matrix.elements[i];
            builder += (0, $f982301cdcaba043$export$8883fe148ef336b4).floatToString(this.transformationMatrix.elements[i]);
            builder += whitespace;
        }
        return builder;
    };
    // Implementation
    /**
     * `Multiplies` matrices (changes coordinate system.)
     * @private
     */ PdfTransformationMatrix.prototype.multiply = function(matrix) {
        this.transformationMatrix.multiply(matrix.matrix);
    };
    /**
     * Converts `degrees to radians`.
     * @private
     */ PdfTransformationMatrix.degreesToRadians = function(degreesX) {
        return this.degRadFactor * degreesX;
    };
    /**
     * Converts `radians to degrees`.
     * @private
     */ PdfTransformationMatrix.prototype.radiansToDegrees = function(radians) {
        return this.radDegFactor * radians;
    };
    /**
     * `Clones` this instance of PdfTransformationMatrix.
     * @private
     */ PdfTransformationMatrix.prototype.clone = function() {
        return this;
    };
    // Constants
    /**
     * Value for `angle converting`.
     * @default Math.PI / 180.0
     * @private
     */ PdfTransformationMatrix.degRadFactor = Math.PI / 180.0;
    return PdfTransformationMatrix;
}();
var $31933e0cf70afc95$export$5b12bf1653c0dd85 = /** @class */ function() {
    function Matrix(arg1, arg2, arg3, arg4, arg5, arg6) {
        if (typeof arg1 === "undefined") this.metrixElements = [];
        else if (typeof arg1 === "number") {
            this.metrixElements = [];
            this.metrixElements.push(arg1);
            this.metrixElements.push(arg2);
            this.metrixElements.push(arg3);
            this.metrixElements.push(arg4);
            this.metrixElements.push(arg5);
            this.metrixElements.push(arg6);
        } else this.metrixElements = arg1;
    }
    Object.defineProperty(Matrix.prototype, "elements", {
        // Properties
        /**
         * Gets the `elements`.
         * @private
         */ get: function() {
            return this.metrixElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Matrix.prototype, "offsetX", {
        /**
         * Gets the off set `X`.
         * @private
         */ get: function() {
            return this.metrixElements[4];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Matrix.prototype, "offsetY", {
        /**
         * Gets the off set `Y`.
         * @private
         */ get: function() {
            return this.metrixElements[5];
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Translates` coordinates by specified coordinates.
     * @private
     */ Matrix.prototype.translate = function(offsetX, offsetY) {
        this.metrixElements[4] = offsetX;
        this.metrixElements[5] = offsetY;
    };
    /**
     * `Translates` the specified offset X.
     * @private
     */ Matrix.prototype.transform = function(point) {
        var x = point.x;
        var y = point.y;
        var x2 = x * this.elements[0] + y * this.elements[2] + this.offsetX;
        var y2 = x * this.elements[1] + y * this.elements[3] + this.offsetY;
        return new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(x2, y2);
    };
    /**
     * `Multiplies matrices` (changes coordinate system.)
     * @private
     */ Matrix.prototype.multiply = function(matrix) {
        var tempMatrix = [];
        tempMatrix.push(this.elements[0] * matrix.elements[0] + this.elements[1] * matrix.elements[2]);
        tempMatrix[1] = this.elements[0] * matrix.elements[1] + this.elements[1] * matrix.elements[3];
        tempMatrix[2] = this.elements[2] * matrix.elements[0] + this.elements[3] * matrix.elements[2];
        tempMatrix[3] = this.elements[2] * matrix.elements[1] + this.elements[3] * matrix.elements[3];
        tempMatrix[4] = this.offsetX * matrix.elements[0] + this.offsetY * matrix.elements[2] + matrix.offsetX;
        tempMatrix[5] = this.offsetX * matrix.elements[1] + this.offsetY * matrix.elements[3] + matrix.offsetY;
        for(var i = 0; i < tempMatrix.length; i++)this.elements[i] = tempMatrix[i];
    };
    // IDisposable Members
    /**
     * `Dispose` this instance of PdfTransformationMatrix class.
     * @private
     */ Matrix.prototype.dispose = function() {
        this.metrixElements = null;
    };
    // ICloneable Members
    /**
     * `Clones` this instance of PdfTransformationMatrix class.
     * @private
     */ Matrix.prototype.clone = function() {
        var m = new Matrix(this.metrixElements);
        return m;
    };
    return Matrix;
}();



/**
 * `constants.ts` class for EJ2-PDF
 * @private
 */ var $73ee494d7b86816e$export$6043bbbff85abf3c = /** @class */ function() {
    function ProcedureSets() {
        /**
         * Specifies the `PDF` procedure set.
         * @private
         */ this.pdf = "PDF";
        /**
         * Specifies the `Text` procedure set.
         * @private
         */ this.text = "Text";
        /**
         * Specifies the `ImageB` procedure set.
         * @private
         */ this.imageB = "ImageB";
        /**
         * Specifies the `ImageC` procedure set.
         * @private
         */ this.imageC = "ImageC";
        /**
         * Specifies the `ImageI` procedure set.
         * @private
         */ this.imageI = "ImageI";
    }
    return ProcedureSets;
}();




/**
 * Dictionary class
 * @private
 * @hidden
 */ var $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb = /** @class */ function() {
    function TemporaryDictionary() {
        /**
         * @hidden
         * @private
         */ this.mKeys = [];
        /**
         * @hidden
         * @private
         */ this.mValues = [];
    }
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.size = function() {
        return this.mKeys.length;
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.add = function(key, value) {
        if (key === undefined || key === null || value === undefined || value === null) throw new ReferenceError("Provided key or value is not valid.");
        var index = this.mKeys.indexOf(key);
        if (index < 0) {
            this.mKeys.push(key);
            this.mValues.push(value);
            return 1;
        } else throw new RangeError("An item with the same key has already been added.");
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.keys = function() {
        return this.mKeys;
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.values = function() {
        return this.mValues;
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.getValue = function(key) {
        if (key === undefined || key === null) throw new ReferenceError("Provided key is not valid.");
        var index = this.mKeys.indexOf(key);
        if (index < 0) throw new RangeError("No item with the specified key has been added.");
        else return this.mValues[index];
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.setValue = function(key, value) {
        if (key === undefined || key === null) throw new ReferenceError("Provided key is not valid.");
        var index = this.mKeys.indexOf(key);
        if (index < 0) {
            this.mKeys.push(key);
            this.mValues.push(value);
        } else this.mValues[index] = value;
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.remove = function(key) {
        if (key === undefined || key === null) throw new ReferenceError("Provided key is not valid.");
        var index = this.mKeys.indexOf(key);
        if (index < 0) throw new RangeError("No item with the specified key has been added.");
        else {
            this.mKeys.splice(index, 1);
            this.mValues.splice(index, 1);
            return true;
        }
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.containsKey = function(key) {
        if (key === undefined || key === null) throw new ReferenceError("Provided key is not valid.");
        var index = this.mKeys.indexOf(key);
        if (index < 0) return false;
        return true;
    };
    /**
     * @hidden
     * @private
     */ TemporaryDictionary.prototype.clear = function() {
        this.mKeys = [];
        this.mValues = [];
    };
    return TemporaryDictionary;
}();






/**
 * Represents a simple `transparency`.
 * @private
 */ var $0ede958bcf41280e$export$9ef1b6d3d933406c = /** @class */ function() {
    // Properties
    // /**
    //  * Gets the `stroke` operation alpha value.
    //  * @private
    //  */
    // public get stroke() : number {
    //     let result : number = this.getNumber(this.dictionaryProperties.CA);
    //     return result;
    // }
    // /**
    //  * Gets the `fill` operation alpha value.
    //  * @private
    //  */
    // public get fill() : number {
    //     let result : number = this.getNumber(this.dictionaryProperties.ca);
    //     return result;
    // }
    // /**
    //  * Gets the `blend mode`.
    //  * @private
    //  */
    // public get mode() : PdfBlendMode {
    //     let result : string = this.getName(this.dictionaryProperties.ca);
    //     return PdfBlendMode.Normal;
    // }
    // Constructors
    /**
     * Initializes a new instance of the `Transparency` class.
     * @private
     */ function PdfTransparency(stroke, fill, mode) {
        // Fields
        /**
         * Internal variable to store `dictionary`.
         * @default new PdfDictionary()
         * @private
         */ this.dictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        /**
         * Internal variable for accessing fields from `DictionryProperties` class.
         * @default new DictionaryProperties()
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        this.dictionary.items.setValue(this.dictionaryProperties.CA, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(stroke));
        this.dictionary.items.setValue(this.dictionaryProperties.ca, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(fill));
        this.dictionary.items.setValue(this.dictionaryProperties.BM, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(mode.toString()));
    }
    Object.defineProperty(PdfTransparency.prototype, "element", {
        // // Implementation
        // /**
        //  * Gets the `number value`.
        //  * @private
        //  */
        // private getNumber(keyName : string) : number {
        //     let result : number = 0.0;
        //     let numb : PdfNumber = this.dictionary.items.getValue(keyName) as PdfNumber;
        //     result = numb.intValue;
        //     return result;
        // }
        // /**
        //  * Gets the `name value`.
        //  * @private
        //  */
        // private getName(keyName : string) : string {
        //     let result : string = null;
        //     let name : PdfName = this.dictionary.items.getValue(keyName) as PdfName;
        //     result = name.value;
        //     return result;
        // }
        // IPdfWrapper Members
        /**
         * Gets the `element`.
         * @private
         */ get: function() {
            return this.dictionary;
        },
        enumerable: true,
        configurable: true
    });
    return PdfTransparency;
}();





/**
 * Represent a `collection of automatic fields information`.
 * @private
 */ var $71be2216ae09945b$export$d6fefdcdf2389ea0 = /** @class */ function() {
    /**
     * Initializes a new instance of the 'PdfPageNumberFieldInfoCollection' class.
     * @private
     */ function PdfAutomaticFieldInfoCollection() {
        /**
         * Internal variable to store instance of `pageNumberFields` class.
         * @private
         */ this.automaticFieldsInformation = [];
    //
    }
    Object.defineProperty(PdfAutomaticFieldInfoCollection.prototype, "automaticFields", {
        /**
         * Gets the `page number fields collection`.
         * @private
         */ get: function() {
            return this.automaticFieldsInformation;
        },
        enumerable: true,
        configurable: true
    });
    // Public methods
    /// Adds the specified field info.
    /**
     * Add page number field into collection.
     * @private
     */ PdfAutomaticFieldInfoCollection.prototype.add = function(fieldInfo) {
        return this.automaticFields.push(fieldInfo);
    };
    return PdfAutomaticFieldInfoCollection;
}();


/**
 * PdfAutomaticFieldInfo.ts class for EJ2-PDF
 * @private
 */ 

/**
 * Represents information about the automatic field.
 * @private
 */ var $1ddf98521086c978$export$64e2124497f91cca = /** @class */ function() {
    function PdfAutomaticFieldInfo(field, location, scaleX, scaleY) {
        // Fields
        /**
         * Internal variable to store location of the field.
         * @private
         */ this.pageNumberFieldLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)();
        /**
         * Internal variable to store field.
         * @private
         */ this.pageNumberField = null;
        /**
         * Internal variable to store x scaling factor.
         * @private
         */ this.scaleX = 1;
        /**
         * Internal variable to store y scaling factor.
         * @private
         */ this.scaleY = 1;
        if (typeof location === "undefined" && field instanceof PdfAutomaticFieldInfo) {
            this.pageNumberField = field.field;
            this.pageNumberFieldLocation = field.location;
            this.scaleX = field.scalingX;
            this.scaleY = field.scalingY;
        } else if (typeof scaleX === "undefined" && location instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && field instanceof (0, $d05c5b0034846734$export$801607a04494f8a2)) {
            this.pageNumberField = field;
            this.pageNumberFieldLocation = location;
        } else {
            this.pageNumberField = field;
            this.pageNumberFieldLocation = location;
            this.scaleX = scaleX;
            this.scaleY = scaleY;
        }
    }
    Object.defineProperty(PdfAutomaticFieldInfo.prototype, "location", {
        /* tslint:enable */ // Properties
        /**
         * Gets or sets the location.
         * @private
         */ get: function() {
            return this.pageNumberFieldLocation;
        },
        set: function(value) {
            this.pageNumberFieldLocation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticFieldInfo.prototype, "field", {
        /**
         * Gets or sets the field.
         * @private
         */ get: function() {
            return this.pageNumberField;
        },
        set: function(value) {
            this.pageNumberField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticFieldInfo.prototype, "scalingX", {
        /**
         * Gets or sets the scaling X factor.
         * @private
         */ get: function() {
            return this.scaleX;
        },
        set: function(value) {
            this.scaleX = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticFieldInfo.prototype, "scalingY", {
        /**
         * Gets or sets the scaling Y factor.
         * @private
         */ get: function() {
            return this.scaleY;
        },
        set: function(value) {
            this.scaleY = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfAutomaticFieldInfo;
}();



/**
 * TrueTypeFont.ts class for EJ2-PDF
 */ 
/**
 * TtfReader.ts class for EJ2-PDF
 */ /**
 * TtfTableInfo.ts class for EJ2-PDF
 */ var $1786831587a4cf8a$export$bff52f3db65739c6 = /** @class */ function() {
    function TtfTableInfo() {}
    Object.defineProperty(TtfTableInfo.prototype, "empty", {
        //Properties
        /**
         * Gets a value indicating whether this table is empty.
         * @private
         */ get: function() {
            var empty = this.offset === this.length && this.length === this.checksum && this.checksum === 0;
            return empty;
        },
        enumerable: true,
        configurable: true
    });
    return TtfTableInfo;
}();



var $16259412604f6457$export$6bfe9d8cde9cdfa4 = /** @class */ function() {
    function TtfNameTable() {}
    return TtfNameTable;
}();


/**
 * TtfNameRecord.ts class for EJ2-PDF
 */ var $bde4abd5e333aaa4$export$4a2fe02c6a3bd590 = /** @class */ function() {
    function TtfNameRecord() {}
    return TtfNameRecord;
}();


/**
 * TtfHeadTable.ts class for EJ2-PDF
 */ var $38b86716e03e31f4$export$36c7d031394edac3 = /** @class */ function() {
    function TtfHeadTable() {}
    return TtfHeadTable;
}();


var $459afd7422caedbb$export$6670e0779ff5deb9 = /** @class */ function() {
    function TtfMetrics() {}
    Object.defineProperty(TtfMetrics.prototype, "isItalic", {
        //Properties
        /**
         * Gets a value indicating whether this instance is italic.
         */ get: function() {
            return (this.macStyle & 2) !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TtfMetrics.prototype, "isBold", {
        /**
         * Gets a value indicating whether this instance is bold.
         */ get: function() {
            return (this.macStyle & 1) !== 0;
        },
        enumerable: true,
        configurable: true
    });
    return TtfMetrics;
}();


/**
 * TtfHorizontalHeaderTable.ts class for EJ2-PDF
 */ var $79d8eb8c4111e6a7$export$d44d27552e952b6f = /** @class */ function() {
    function TtfHorizontalHeaderTable() {}
    return TtfHorizontalHeaderTable;
}();


/**
 * TtfOS2Table.ts class for EJ2-PDF
 * The OS/2 table consists of a set of metrics that are required by Windows and OS/2.
 */ var $5f1da967a3671609$export$27654c9dbdde6051 = /** @class */ function() {
    function TtfOS2Table() {}
    return TtfOS2Table;
}();


/**
 * TtfPostTable.ts class for EJ2-PDF
 */ var $179ab3dcae7a5ac4$export$8f5fe58f68f7718e = /** @class */ function() {
    function TtfPostTable() {}
    return TtfPostTable;
}();


/**
 * TtfLongHorMetric.ts class for EJ2-PDF
 */ var $fa485c5850eaaea5$export$693afe9fd835702e = /** @class */ function() {
    function TtfLongHorMetric() {}
    return TtfLongHorMetric;
}();


/**
 * TtfCmapSubTable.ts class for EJ2-PDF
 */ var $70ca92d3563522a2$export$b83890684e0d96ff = /** @class */ function() {
    function TtfCmapSubTable() {}
    return TtfCmapSubTable;
}();


/**
 * TtfCmapTable.ts class for EJ2-PDF
 */ var $1c5a4af8f99afab6$export$3fded85998352de = /** @class */ function() {
    function TtfCmapTable() {}
    return TtfCmapTable;
}();


/**
 * TtfGlyphInfo.ts class for EJ2-PDF
 */ var $c37c6223d92dddaa$export$7b06ef24fb906c2f = /** @class */ function() {
    function TtfGlyphInfo() {}
    Object.defineProperty(TtfGlyphInfo.prototype, "empty", {
        //Properties
        /**
         * Gets a value indicating whether this TtfGlyphInfo is empty.
         */ get: function() {
            var empty = this.index === this.width && this.width === this.charCode && this.charCode === 0;
            return empty;
        },
        enumerable: true,
        configurable: true
    });
    //IComparable implementation
    /**
     * Compares two WidthDescriptor objects.
     */ TtfGlyphInfo.prototype.compareTo = function(obj) {
        var glyph = obj;
        return this.index - glyph.index;
    };
    return TtfGlyphInfo;
}();


/**
 * TtfLocaTable.ts class for EJ2-PDF
 */ var $be5f30a36a1e9491$export$6374c9a0e44e7627 = /** @class */ function() {
    function TtfLocaTable() {}
    return TtfLocaTable;
}();


/**
 * TtfAppleCmapSubTable.ts class for EJ2-PDF
 */ var $3f930f9940f93d01$export$1b899ff50e1fe2a3 = /** @class */ function() {
    function TtfAppleCmapSubTable() {}
    return TtfAppleCmapSubTable;
}();


/**
 * TtfMicrosoftCmapSubTable.ts class for EJ2-PDF
 */ var $3844815edba43d42$export$54253fe3dc3f2ba8 = /** @class */ function() {
    function TtfMicrosoftCmapSubTable() {}
    return TtfMicrosoftCmapSubTable;
}();


/**
 * TtfTrimmedCmapSubTable.ts class for EJ2-PDF
 */ var $92d445a4e803b6df$export$9658d2c86a8b4f22 = /** @class */ function() {
    function TtfTrimmedCmapSubTable() {}
    return TtfTrimmedCmapSubTable;
}();


/**
 * TtfLocaTable.ts class for EJ2-PDF
 */ var $ee9bfc086cacabeb$export$d2cb18f104497a66 = /** @class */ function() {
    function TtfGlyphHeader() {}
    return TtfGlyphHeader;
}();





/**
 * Writes data in BigEndian order.
 */ var $ae35c05e6bdc305d$export$3442d87134d25bf9 = /** @class */ function() {
    //Constructors
    /**
     * Creates a new writer.
     */ function BigEndianWriter(capacity) {
        //Constants
        /**
         * Size of Int32 type.
         */ this.int32Size = 4;
        /**
         * Size of Int16 type.
         */ this.int16Size = 2;
        /**
         * Size of long type.
         */ this.int64Size = 8;
        this.bufferLength = capacity;
        this.buffer = [];
    }
    Object.defineProperty(BigEndianWriter.prototype, "data", {
        //Properties
        /**
         * Gets data written to the writer.
         */ get: function() {
            if (this.buffer.length < this.bufferLength) {
                var length_1 = this.bufferLength - this.buffer.length;
                for(var i = 0; i < length_1; i++)this.buffer.push(0);
            }
            return this.buffer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BigEndianWriter.prototype, "position", {
        /// <summary>
        /// Gets position of the internal buffer.
        /// </summary>
        get: function() {
            if (this.internalPosition === undefined || this.internalPosition === null) this.internalPosition = 0;
            return this.internalPosition;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Writes short value.
     */ BigEndianWriter.prototype.writeShort = function(value) {
        var bytes = [
            (value & 0x0000ff00) >> 8,
            value & 0x000000ff
        ];
        this.flush(bytes);
    };
    /**
     * Writes int value.
     */ BigEndianWriter.prototype.writeInt = function(value) {
        var i1 = (value & 0xff000000) >> 24;
        i1 = i1 < 0 ? 256 + i1 : i1;
        var i2 = (value & 0x00ff0000) >> 16;
        i2 = i2 < 0 ? 256 + i2 : i2;
        var i3 = (value & 0x0000ff00) >> 8;
        i3 = i3 < 0 ? 256 + i3 : i3;
        var i4 = value & 0x000000ff;
        i4 = i4 < 0 ? 256 + i4 : i4;
        var bytes = [
            (value & 0xff000000) >> 24,
            (value & 0x00ff0000) >> 16,
            (value & 0x0000ff00) >> 8,
            value & 0x000000ff
        ];
        this.flush(bytes);
    };
    /**
     * Writes u int value.
     */ BigEndianWriter.prototype.writeUInt = function(value) {
        var buff = [
            (value & 0xff000000) >> 24,
            (value & 0x00ff0000) >> 16,
            (value & 0x0000ff00) >> 8,
            value & 0x000000ff
        ];
        this.flush(buff);
    };
    /**
     * Writes string value.
     */ BigEndianWriter.prototype.writeString = function(value) {
        if (value == null) throw new Error("Argument Null Exception : value");
        var bytes = [];
        for(var i = 0; i < value.length; i++)bytes.push(value.charCodeAt(i));
        this.flush(bytes);
    };
    /**
     * Writes byte[] value.
     */ BigEndianWriter.prototype.writeBytes = function(value) {
        this.flush(value);
    };
    // //Implementation
    BigEndianWriter.prototype.flush = function(buff) {
        if (buff === null) throw new Error("Argument Null Exception : buff");
        var position = this.position;
        for(var i = 0; i < buff.length; i++){
            this.buffer[position] = buff[i];
            position++;
        }
        this.internalPosition += buff.length;
    };
    return BigEndianWriter;
}();


var $e70bd4219f4fdb24$export$7727ccb118793aba = /** @class */ function() {
    //Constructors
    function TtfReader(fontData) {
        this.int32Size = 4;
        this.isTtcFont = false;
        this.isMacTtf = false;
        this.metricsName = "";
        this.isMacTTF = false;
        this.missedGlyphs = 0;
        this.tableNames = [
            "cvt ",
            "fpgm",
            "glyf",
            "head",
            "hhea",
            "hmtx",
            "loca",
            "maxp",
            "prep"
        ];
        this.entrySelectors = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4
        ];
        this.fontData = fontData;
        this.initialize();
    }
    Object.defineProperty(TtfReader.prototype, "macintosh", {
        //Properties
        /**
         * Gets glyphs for Macintosh or Symbol fonts (char - key, glyph - value).
         */ get: function() {
            if (this.macintoshDictionary === null || this.macintoshDictionary === undefined) this.macintoshDictionary = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            return this.macintoshDictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TtfReader.prototype, "microsoft", {
        /**
         * Gets glyphs for Microsoft or Symbol fonts (char - key, glyph - value).
         */ get: function() {
            if (this.microsoftDictionary === null || this.microsoftDictionary === undefined) this.microsoftDictionary = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            return this.microsoftDictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TtfReader.prototype, "macintoshGlyphs", {
        /**
         * Gets glyphs for Macintosh or Symbol fonts (glyph index - key, glyph - value).
         */ get: function() {
            if (this.internalMacintoshGlyphs === null || this.internalMacintoshGlyphs === undefined) this.internalMacintoshGlyphs = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            return this.internalMacintoshGlyphs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TtfReader.prototype, "microsoftGlyphs", {
        /**
         * Gets glyphs for Microsoft Unicode fonts (glyph index - key, glyph - value).
         */ get: function() {
            if (this.internalMicrosoftGlyphs === null || this.internalMicrosoftGlyphs === undefined) this.internalMicrosoftGlyphs = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            return this.internalMicrosoftGlyphs;
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    TtfReader.prototype.initialize = function() {
        if (this.metrics === undefined) this.metrics = new (0, $459afd7422caedbb$export$6670e0779ff5deb9)();
        this.readFontDictionary();
        var nameTable = this.readNameTable();
        var headTable = this.readHeadTable();
        this.initializeFontName(nameTable);
        this.metrics.macStyle = headTable.macStyle;
    };
    TtfReader.prototype.readFontDictionary = function() {
        this.offset = 0;
        var version = this.checkPreambula();
        //this.offset += 4;
        var numTables = this.readInt16(this.offset);
        var searchRange = this.readInt16(this.offset);
        var entrySelector = this.readInt16(this.offset);
        var rangeShift = this.readInt16(this.offset);
        if (this.tableDirectory === undefined) this.tableDirectory = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        for(var i = 0; i < numTables; ++i){
            var table = new (0, $1786831587a4cf8a$export$bff52f3db65739c6)();
            var tableKey = this.readString(this.int32Size);
            table.checksum = this.readInt32(this.offset);
            table.offset = this.readInt32(this.offset);
            table.length = this.readInt32(this.offset);
            this.tableDirectory.setValue(tableKey, table);
        }
        this.lowestPosition = this.offset;
        if (!this.isTtcFont) this.fixOffsets();
    };
    TtfReader.prototype.fixOffsets = function() {
        var minOffset = Number.MAX_VALUE;
        // Search for a smallest offset and compare it with the lowest position found.
        var tableKeys = this.tableDirectory.keys();
        for(var i = 0; i < tableKeys.length; i++){
            var value = this.tableDirectory.getValue(tableKeys[i]);
            var offset = value.offset;
            if (minOffset > offset) {
                minOffset = offset;
                if (minOffset <= this.lowestPosition) break;
            }
        }
        var shift = minOffset - this.lowestPosition;
        if (shift !== 0) {
            var table = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
            for(var i = 0; i < tableKeys.length; i++){
                var value = this.tableDirectory.getValue(tableKeys[i]);
                value.offset -= shift;
                table.setValue(tableKeys[i], value);
            }
            this.tableDirectory = table;
        }
    };
    TtfReader.prototype.checkPreambula = function() {
        var version = this.readInt32(this.offset);
        this.isMacTtf = version === 0x74727565 ? true : false;
        if (version !== 0x10000 && version !== 0x74727565 && version !== 0x4f54544f) {
            this.isTtcFont = true;
            this.offset = 0;
            var fontTag = this.readString(4);
            if (fontTag !== "ttcf") throw new Error("Can not read TTF font data");
            //skip 4
            this.offset += 4;
            var ttcIdentificationNumber = this.readInt32(this.offset);
            if (ttcIdentificationNumber < 0) throw new Error("Can not read TTF font data");
            this.offset = this.readInt32(this.offset);
            version = this.readInt32(this.offset);
        }
        return version;
    };
    TtfReader.prototype.readNameTable = function() {
        var tableInfo = this.getTable("name");
        this.offset = tableInfo.offset;
        var table = new (0, $16259412604f6457$export$6bfe9d8cde9cdfa4)();
        table.formatSelector = this.readUInt16(this.offset);
        table.recordsCount = this.readUInt16(this.offset);
        table.offset = this.readUInt16(this.offset);
        table.nameRecords = [];
        var recordSize = 12;
        var position = this.offset;
        for(var i = 0; i < table.recordsCount; i++){
            this.offset = position;
            var record = new (0, $bde4abd5e333aaa4$export$4a2fe02c6a3bd590)();
            record.platformID = this.readUInt16(this.offset);
            record.encodingID = this.readUInt16(this.offset);
            record.languageID = this.readUInt16(this.offset);
            record.nameID = this.readUInt16(this.offset);
            record.length = this.readUInt16(this.offset);
            record.offset = this.readUInt16(this.offset);
            this.offset = tableInfo.offset + table.offset + record.offset;
            var unicode = record.platformID === 0 || record.platformID === 3;
            record.name = this.readString(record.length, unicode);
            table.nameRecords[i] = record;
            position += recordSize;
        }
        return table;
    };
    TtfReader.prototype.readHeadTable = function() {
        var tableInfo = this.getTable("head");
        this.offset = tableInfo.offset;
        var table = new (0, $38b86716e03e31f4$export$36c7d031394edac3)();
        table.version = this.readFixed(this.offset);
        table.fontRevision = this.readFixed(this.offset);
        table.checkSumAdjustment = this.readUInt32(this.offset);
        table.magicNumber = this.readUInt32(this.offset);
        table.flags = this.readUInt16(this.offset);
        table.unitsPerEm = this.readUInt16(this.offset);
        table.created = this.readInt64(this.offset);
        table.modified = this.readInt64(this.offset);
        table.xMin = this.readInt16(this.offset);
        table.yMin = this.readInt16(this.offset);
        table.xMax = this.readInt16(this.offset);
        table.yMax = this.readInt16(this.offset);
        table.macStyle = this.readUInt16(this.offset);
        table.lowestReadableSize = this.readUInt16(this.offset);
        table.fontDirectionHint = this.readInt16(this.offset);
        table.indexToLocalFormat = this.readInt16(this.offset);
        table.glyphDataFormat = this.readInt16(this.offset);
        return table;
    };
    TtfReader.prototype.readHorizontalHeaderTable = function() {
        var tableInfo = this.getTable("hhea");
        this.offset = tableInfo.offset;
        var table = new (0, $79d8eb8c4111e6a7$export$d44d27552e952b6f)();
        table.version = this.readFixed(this.offset);
        table.ascender = this.readInt16(this.offset);
        table.descender = this.readInt16(this.offset);
        table.lineGap = this.readInt16(this.offset);
        table.advanceWidthMax = this.readUInt16(this.offset);
        table.minLeftSideBearing = this.readInt16(this.offset);
        table.minRightSideBearing = this.readInt16(this.offset);
        table.xMaxExtent = this.readInt16(this.offset);
        table.caretSlopeRise = this.readInt16(this.offset);
        table.caretSlopeRun = this.readInt16(this.offset);
        //skip 2 * 5
        this.offset += 10;
        table.metricDataFormat = this.readInt16(this.offset);
        table.numberOfHMetrics = this.readUInt16(this.offset);
        return table;
    };
    TtfReader.prototype.readOS2Table = function() {
        var tableInfo = this.getTable("OS/2");
        this.offset = tableInfo.offset;
        var table = new (0, $5f1da967a3671609$export$27654c9dbdde6051)();
        table.version = this.readUInt16(this.offset);
        table.xAvgCharWidth = this.readInt16(this.offset);
        table.usWeightClass = this.readUInt16(this.offset);
        table.usWidthClass = this.readUInt16(this.offset);
        table.fsType = this.readInt16(this.offset);
        table.ySubscriptXSize = this.readInt16(this.offset);
        table.ySubscriptYSize = this.readInt16(this.offset);
        table.ySubscriptXOffset = this.readInt16(this.offset);
        table.ySubscriptYOffset = this.readInt16(this.offset);
        table.ySuperscriptXSize = this.readInt16(this.offset);
        table.ySuperscriptYSize = this.readInt16(this.offset);
        table.ySuperscriptXOffset = this.readInt16(this.offset);
        table.ySuperscriptYOffset = this.readInt16(this.offset);
        table.yStrikeoutSize = this.readInt16(this.offset);
        table.yStrikeoutPosition = this.readInt16(this.offset);
        table.sFamilyClass = this.readInt16(this.offset);
        table.panose = this.readBytes(10);
        table.ulUnicodeRange1 = this.readUInt32(this.offset);
        table.ulUnicodeRange2 = this.readUInt32(this.offset);
        table.ulUnicodeRange3 = this.readUInt32(this.offset);
        table.ulUnicodeRange4 = this.readUInt32(this.offset);
        table.vendorIdentifier = this.readBytes(4);
        table.fsSelection = this.readUInt16(this.offset);
        table.usFirstCharIndex = this.readUInt16(this.offset);
        table.usLastCharIndex = this.readUInt16(this.offset);
        table.sTypoAscender = this.readInt16(this.offset);
        table.sTypoDescender = this.readInt16(this.offset);
        table.sTypoLineGap = this.readInt16(this.offset);
        table.usWinAscent = this.readUInt16(this.offset);
        table.usWinDescent = this.readUInt16(this.offset);
        table.ulCodePageRange1 = this.readUInt32(this.offset);
        table.ulCodePageRange2 = this.readUInt32(this.offset);
        if (table.version > 1) {
            table.sxHeight = this.readInt16(this.offset);
            table.sCapHeight = this.readInt16(this.offset);
            table.usDefaultChar = this.readUInt16(this.offset);
            table.usBreakChar = this.readUInt16(this.offset);
            table.usMaxContext = this.readUInt16(this.offset);
        } else {
            table.sxHeight = 0;
            table.sCapHeight = 0;
            table.usDefaultChar = 0;
            table.usBreakChar = 0;
            table.usMaxContext = 0;
        }
        return table;
    };
    TtfReader.prototype.readPostTable = function() {
        var tableInfo = this.getTable("post");
        this.offset = tableInfo.offset;
        var table = new (0, $179ab3dcae7a5ac4$export$8f5fe58f68f7718e)();
        table.formatType = this.readFixed(this.offset);
        table.italicAngle = this.readFixed(this.offset);
        table.underlinePosition = this.readInt16(this.offset);
        table.underlineThickness = this.readInt16(this.offset);
        table.isFixedPitch = this.readUInt32(this.offset);
        table.minType42 = this.readUInt32(this.offset);
        table.maxType42 = this.readUInt32(this.offset);
        table.minType1 = this.readUInt32(this.offset);
        table.maxType1 = this.readUInt32(this.offset);
        return table;
    };
    /**
     * Reads Width of the glyphs.
     */ TtfReader.prototype.readWidthTable = function(glyphCount, unitsPerEm) {
        var tableInfo = this.getTable("hmtx");
        this.offset = tableInfo.offset;
        var width = [];
        for(var i = 0; i < glyphCount; i++){
            var glyph = new (0, $fa485c5850eaaea5$export$693afe9fd835702e)();
            glyph.advanceWidth = this.readUInt16(this.offset);
            glyph.lsb = this.readInt16(this.offset);
            var glyphWidth = glyph.advanceWidth * 1000 / unitsPerEm;
            width.push(Math.floor(glyphWidth));
        }
        return width;
    };
    /**
     * Reads the cmap table.
     */ TtfReader.prototype.readCmapTable = function() {
        var tableInfo = this.getTable("cmap");
        this.offset = tableInfo.offset;
        var table = new (0, $1c5a4af8f99afab6$export$3fded85998352de)();
        table.version = this.readUInt16(this.offset);
        table.tablesCount = this.readUInt16(this.offset);
        var position = this.offset;
        var subTables = [];
        for(var i = 0; i < table.tablesCount; i++){
            this.offset = position;
            var subTable = new (0, $70ca92d3563522a2$export$b83890684e0d96ff)();
            subTable.platformID = this.readUInt16(this.offset);
            subTable.encodingID = this.readUInt16(this.offset);
            subTable.offset = this.readUInt32(this.offset);
            position = this.offset;
            this.readCmapSubTable(subTable);
            subTables[i] = subTable;
        }
        return subTables;
    };
    /**
     * Reads the cmap sub table.
     */ TtfReader.prototype.readCmapSubTable = function(subTable) {
        var tableInfo = this.getTable("cmap");
        this.offset = tableInfo.offset + subTable.offset;
        var format = this.readUInt16(this.offset);
        var encoding = this.getCmapEncoding(subTable.platformID, subTable.encodingID);
        var platform = encoding === (0, $32129651824bb502$export$5894ac961b177c22).Macintosh ? (0, $32129651824bb502$export$bb3cfc97ef45f19a).Macintosh : (0, $32129651824bb502$export$bb3cfc97ef45f19a).Microsoft;
        if (encoding !== (0, $32129651824bb502$export$5894ac961b177c22).Unknown) switch(format){
            case (0, $32129651824bb502$export$18f1edb7e09345b2).Apple:
                this.readAppleCmapTable(subTable, encoding);
                break;
            case (0, $32129651824bb502$export$18f1edb7e09345b2).Microsoft:
                this.readMicrosoftCmapTable(subTable, encoding);
                break;
            case (0, $32129651824bb502$export$18f1edb7e09345b2).Trimmed:
                this.readTrimmedCmapTable(subTable, encoding);
                break;
        }
    };
    /**
     * Reads Symbol cmap table.
     */ TtfReader.prototype.readAppleCmapTable = function(subTable, encoding) {
        var tableInfo = this.getTable("cmap");
        this.offset = tableInfo.offset + subTable.offset;
        var table = new (0, $3f930f9940f93d01$export$1b899ff50e1fe2a3)();
        table.format = this.readUInt16(this.offset);
        table.length = this.readUInt16(this.offset);
        table.version = this.readUInt16(this.offset);
        if (this.maxMacIndex === null || this.maxMacIndex === undefined) this.maxMacIndex = 0;
        for(var i = 0; i < 256; ++i){
            var glyphInfo = new (0, $c37c6223d92dddaa$export$7b06ef24fb906c2f)();
            glyphInfo.index = this.readByte(this.offset);
            glyphInfo.width = this.getWidth(glyphInfo.index);
            glyphInfo.charCode = i;
            this.macintosh.setValue(i, glyphInfo);
            this.addGlyph(glyphInfo, encoding);
            // NOTE: this code fixes char codes that extends 0x100. However, it might corrupt something.
            this.maxMacIndex = Math.max(i, this.maxMacIndex);
        }
    };
    /**
     * Reads Symbol cmap table.
     */ TtfReader.prototype.readMicrosoftCmapTable = function(subTable, encoding) {
        var tableInfo = this.getTable("cmap");
        this.offset = tableInfo.offset + subTable.offset;
        var collection = encoding === (0, $32129651824bb502$export$5894ac961b177c22).Unicode ? this.microsoft : this.macintosh;
        var table = new (0, $3844815edba43d42$export$54253fe3dc3f2ba8)();
        table.format = this.readUInt16(this.offset);
        table.length = this.readUInt16(this.offset);
        table.version = this.readUInt16(this.offset);
        table.segCountX2 = this.readUInt16(this.offset);
        table.searchRange = this.readUInt16(this.offset);
        table.entrySelector = this.readUInt16(this.offset);
        table.rangeShift = this.readUInt16(this.offset);
        var segCount = table.segCountX2 / 2;
        table.endCount = this.readUshortArray(segCount);
        table.reservedPad = this.readUInt16(this.offset);
        table.startCount = this.readUshortArray(segCount);
        table.idDelta = this.readUshortArray(segCount);
        table.idRangeOffset = this.readUshortArray(segCount);
        var length = table.length / 2 - 8 - segCount * 4;
        table.glyphID = this.readUshortArray(length);
        // Process glyphIdArray array.
        var codeOffset = 0;
        var index = 0;
        for(var j = 0; j < segCount; j++)for(var k = table.startCount[j]; k <= table.endCount[j] && k !== 65535; k++){
            if (table.idRangeOffset[j] === 0) codeOffset = k + table.idDelta[j] & 65535;
            else {
                index = j + table.idRangeOffset[j] / 2 - segCount + k - table.startCount[j];
                if (index >= table.glyphID.length) continue;
                codeOffset = table.glyphID[index] + table.idDelta[j] & 65535;
            }
            var glyph = new (0, $c37c6223d92dddaa$export$7b06ef24fb906c2f)();
            glyph.index = codeOffset;
            glyph.width = this.getWidth(glyph.index);
            var id = encoding === (0, $32129651824bb502$export$5894ac961b177c22).Symbol ? (k & 0xff00) === 0xf000 ? k & 0xff : k : k;
            glyph.charCode = id;
            collection.setValue(id, glyph);
            this.addGlyph(glyph, encoding);
        }
    };
    /**
     * Reads Trimed cmap table.
     */ TtfReader.prototype.readTrimmedCmapTable = function(subTable, encoding) {
        var tableInfo = this.getTable("cmap");
        this.offset = tableInfo.offset + subTable.offset;
        var table = new (0, $92d445a4e803b6df$export$9658d2c86a8b4f22)();
        table.format = this.readUInt16(this.offset);
        table.length = this.readUInt16(this.offset);
        table.version = this.readUInt16(this.offset);
        table.firstCode = this.readUInt16(this.offset);
        table.entryCount = this.readUInt16(this.offset);
        for(var i = 0; i < table.entryCount; ++i){
            var glyphInfo = new (0, $c37c6223d92dddaa$export$7b06ef24fb906c2f)();
            glyphInfo.index = this.readUInt16(this.offset);
            glyphInfo.width = this.getWidth(glyphInfo.index);
            glyphInfo.charCode = i + table.firstCode;
            this.macintosh.setValue(i, glyphInfo);
            this.addGlyph(glyphInfo, encoding);
            // NOTE: this code fixes char codes that extends 0x100. However, it might corrupt something.
            this.maxMacIndex = Math.max(i, this.maxMacIndex);
        }
    };
    TtfReader.prototype.initializeFontName = function(nameTable) {
        for(var i = 0; i < nameTable.recordsCount; i++){
            var record = nameTable.nameRecords[i];
            if (record.nameID === 1) //font family
            this.metrics.fontFamily = record.name;
            else if (record.nameID === 6) //post script name
            this.metrics.postScriptName = record.name;
            /* tslint:disable */ if (this.metrics.fontFamily !== null && this.metrics.fontFamily !== undefined && this.metrics.postScriptName !== null && this.metrics.postScriptName !== undefined) break;
        /* tslint:disable */ }
    };
    TtfReader.prototype.getTable = function(name) {
        // if (name === null) {
        //     throw new Error('Argument Null Exception : name');
        // }
        var table = new (0, $1786831587a4cf8a$export$bff52f3db65739c6)();
        var obj;
        if (this.tableDirectory.containsKey(name)) obj = this.tableDirectory.getValue(name);
        if (obj !== null && obj !== undefined) table = obj;
        return table;
    };
    /**
     * Returns width of the glyph.
     */ TtfReader.prototype.getWidth = function(glyphCode) {
        glyphCode = glyphCode < this.width.length ? glyphCode : this.width.length - 1;
        return this.width[glyphCode];
    };
    /**
     * Gets CMAP encoding based on platform ID and encoding ID.
     */ /* tslint:disable */ TtfReader.prototype.getCmapEncoding = function(platformID, encodingID) {
        var format = (0, $32129651824bb502$export$5894ac961b177c22).Unknown;
        if (platformID == (0, $32129651824bb502$export$bb3cfc97ef45f19a).Microsoft && encodingID == (0, $32129651824bb502$export$c7e834ce569513c8).Undefined) // When building a symbol font for Windows,
        // the platform ID should be 3 and the encoding ID should be 0.
        format = (0, $32129651824bb502$export$5894ac961b177c22).Symbol;
        else if (platformID == (0, $32129651824bb502$export$bb3cfc97ef45f19a).Microsoft && encodingID == (0, $32129651824bb502$export$c7e834ce569513c8).Unicode) // When building a Unicode font for Windows,
        // the platform ID should be 3 and the encoding ID should be 1.
        format = (0, $32129651824bb502$export$5894ac961b177c22).Unicode;
        else if (platformID == (0, $32129651824bb502$export$bb3cfc97ef45f19a).Macintosh && encodingID == (0, $32129651824bb502$export$6dfeb707034057d3).Roman) // When building a font that will be used on the Macintosh,
        // the platform ID should be 1 and the encoding ID should be 0.
        format = (0, $32129651824bb502$export$5894ac961b177c22).Macintosh;
        return format;
    };
    /* tslint:enable */ /**
     * Adds glyph to the collection.
     */ TtfReader.prototype.addGlyph = function(glyph, encoding) {
        var collection = null;
        switch(encoding){
            case (0, $32129651824bb502$export$5894ac961b177c22).Unicode:
                collection = this.microsoftGlyphs;
                break;
            case (0, $32129651824bb502$export$5894ac961b177c22).Macintosh:
            case (0, $32129651824bb502$export$5894ac961b177c22).Symbol:
                collection = this.macintoshGlyphs;
                break;
        }
        collection.setValue(glyph.index, glyph);
    };
    /**
     * Initializes metrics.
     */ /* tslint:disable */ TtfReader.prototype.initializeMetrics = function(nameTable, headTable, horizontalHeadTable, os2Table, postTable, cmapTables) {
        /* tslint:enable */ // if (cmapTables === null) {
        //     throw new Error('ArgumentNullException : cmapTables');
        // }
        this.initializeFontName(nameTable);
        // Get font encoding.
        var bSymbol = false;
        for(var i = 0; i < cmapTables.length; i++){
            var subTable = cmapTables[i];
            var encoding = this.getCmapEncoding(subTable.platformID, subTable.encodingID);
            if (encoding === (0, $32129651824bb502$export$5894ac961b177c22).Symbol) {
                bSymbol = true;
                break;
            }
        }
        this.metrics.isSymbol = bSymbol;
        this.metrics.macStyle = headTable.macStyle;
        this.metrics.isFixedPitch = postTable.isFixedPitch !== 0;
        this.metrics.italicAngle = postTable.italicAngle;
        var factor = 1000 / headTable.unitsPerEm;
        this.metrics.winAscent = os2Table.sTypoAscender * factor;
        this.metrics.macAscent = horizontalHeadTable.ascender * factor;
        //m_metrics.MacAscent = os2Table.UsWinAscent * factor;
        // NOTE: This is stange workaround. The value is good if os2Table.SCapHeight != 0, otherwise it should be properly computed.
        this.metrics.capHeight = os2Table.sCapHeight !== 0 ? os2Table.sCapHeight : 0.7 * headTable.unitsPerEm * factor;
        this.metrics.winDescent = os2Table.sTypoDescender * factor;
        this.metrics.macDescent = horizontalHeadTable.descender * factor;
        //m_metrics.MacDescent = -os2Table.UsWinDescent * factor;
        this.metrics.leading = (os2Table.sTypoAscender - os2Table.sTypoDescender + os2Table.sTypoLineGap) * factor;
        this.metrics.lineGap = Math.ceil(horizontalHeadTable.lineGap * factor);
        var left = headTable.xMin * factor;
        var top = Math.ceil(this.metrics.macAscent + this.metrics.lineGap);
        var right = headTable.xMax * factor;
        var bottom = this.metrics.macDescent;
        this.metrics.fontBox = new (0, $e1df9a3657e111f3$export$4617fb02663045ef)(left, top, right, bottom);
        // NOTE: Strange!
        this.metrics.stemV = 80;
        this.metrics.widthTable = this.updateWidth();
        this.metrics.contains = this.tableDirectory.containsKey("CFF");
        this.metrics.subScriptSizeFactor = headTable.unitsPerEm / os2Table.ySubscriptYSize;
        this.metrics.superscriptSizeFactor = headTable.unitsPerEm / os2Table.ySuperscriptYSize;
    };
    /**
     * Updates chars structure which is used in the case of ansi encoding (256 bytes).
     */ TtfReader.prototype.updateWidth = function() {
        var count = 256;
        var bytes = [];
        if (this.metrics.isSymbol) for(var i = 0; i < count; i++){
            var glyphInfo = this.getGlyph(String.fromCharCode(i));
            bytes[i] = glyphInfo.empty ? 0 : glyphInfo.width;
        }
        else {
            var byteToProcess = [];
            var unknown = "?";
            var space = String.fromCharCode(32);
            for(var i = 0; i < count; i++){
                byteToProcess[0] = i;
                var text = this.getString(byteToProcess, 0, byteToProcess.length);
                var ch = text.length > 0 ? text[0] : unknown;
                var glyphInfo = this.getGlyph(ch);
                if (!glyphInfo.empty) bytes[i] = glyphInfo.width;
                else {
                    glyphInfo = this.getGlyph(space);
                    bytes[i] = glyphInfo.empty ? 0 : glyphInfo.width;
                }
            }
        }
        return bytes;
    };
    /**
     * Returns default glyph.
     */ TtfReader.prototype.getDefaultGlyph = function() {
        var glyph = this.getGlyph((0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace);
        return glyph;
    };
    /**
     * Reads unicode string from byte array.
     */ TtfReader.prototype.getString = function(byteToProcess, start, length) {
        var result = "";
        for(var index = 0; index < length; index++)result += String.fromCharCode(byteToProcess[index + start]);
        return result;
    };
    /**
     * Reads loca table.
     */ TtfReader.prototype.readLocaTable = function(bShort) {
        var tableInfo = this.getTable("loca");
        this.offset = tableInfo.offset;
        var table = new (0, $be5f30a36a1e9491$export$6374c9a0e44e7627)();
        var buffer = null;
        if (bShort) {
            var len = tableInfo.length / 2;
            buffer = [];
            for(var i = 0; i < len; i++)buffer[i] = this.readUInt16(this.offset) * 2;
        } else {
            var len = tableInfo.length / 4;
            buffer = [];
            for(var i = 0; i < len; i++)buffer[i] = this.readUInt32(this.offset);
        }
        table.offsets = buffer;
        return table;
    };
    /**
     * Updates hash table of used glyphs.
     */ TtfReader.prototype.updateGlyphChars = function(glyphChars, locaTable) {
        // if (glyphChars === null) {
        //     throw new Error('Argument Null Exception : glyphChars');
        // }
        // Add zero key.
        if (!glyphChars.containsKey(0)) glyphChars.setValue(0, 0);
        var clone = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        var glyphCharKeys = glyphChars.keys();
        for(var i = 0; i < glyphCharKeys.length; i++)clone.setValue(glyphCharKeys[i], glyphChars.getValue(glyphCharKeys[i]));
        for(var i = 0; i < glyphCharKeys.length; i++){
            var nextKey = glyphCharKeys[i];
            this.processCompositeGlyph(glyphChars, nextKey, locaTable);
        }
    };
    /**
     * Checks if glyph is composite or not.
     */ TtfReader.prototype.processCompositeGlyph = function(glyphChars, glyph, locaTable) {
        // if (glyphChars === null) {
        //     throw new Error('Argument Null Exception : glyphChars');
        // }
        // Is in range.
        if (glyph < locaTable.offsets.length - 1) {
            var glyphOffset = locaTable.offsets[glyph];
            if (glyphOffset !== locaTable.offsets[glyph + 1]) {
                var tableInfo = this.getTable("glyf");
                this.offset = tableInfo.offset + glyphOffset;
                var glyphHeader = new (0, $ee9bfc086cacabeb$export$d2cb18f104497a66)();
                glyphHeader.numberOfContours = this.readInt16(this.offset);
                glyphHeader.xMin = this.readInt16(this.offset);
                glyphHeader.yMin = this.readInt16(this.offset);
                glyphHeader.xMax = this.readInt16(this.offset);
                glyphHeader.yMax = this.readInt16(this.offset);
                // Glyph is composite.
                if (glyphHeader.numberOfContours < 0) {
                    var skipBytes = 0;
                    var entry = true;
                    while(entry){
                        var flags = this.readUInt16(this.offset);
                        var glyphIndex = this.readUInt16(this.offset);
                        if (!glyphChars.containsKey(glyphIndex)) glyphChars.setValue(glyphIndex, 0);
                        if ((flags & (0, $32129651824bb502$export$4f04ee1e3ea31dc5).MoreComponents) === 0) break;
                        skipBytes = (flags & (0, $32129651824bb502$export$4f04ee1e3ea31dc5).Arg1And2AreWords) !== 0 ? 4 : 2;
                        if ((flags & (0, $32129651824bb502$export$4f04ee1e3ea31dc5).WeHaveScale) !== 0) skipBytes += 2;
                        else if ((flags & (0, $32129651824bb502$export$4f04ee1e3ea31dc5).WeHaveAnXyScale) !== 0) skipBytes += 4;
                        else if ((flags & (0, $32129651824bb502$export$4f04ee1e3ea31dc5).WeHaveTwoByTwo) !== 0) skipBytes += 8;
                        this.offset += skipBytes;
                    }
                }
            }
        }
    };
    /**
     * Creates new glyph tables based on chars that are used for output.
     */ /* tslint:disable */ TtfReader.prototype.generateGlyphTable = function(glyphChars, locaTable, newLocaTable, newGlyphTable) {
        /* tslint:enable */ // if (glyphChars === null) {
        //     throw new Error('Argument Null Exception : glyphChars');
        // }
        newLocaTable = [];
        // Sorting used glyphs keys.
        var activeGlyphs = glyphChars.keys();
        activeGlyphs.sort(function(a, b) {
            return a - b;
        });
        var glyphSize = 0;
        for(var i = 0; i < activeGlyphs.length; i++){
            var glyphIndex = activeGlyphs[i];
            if (locaTable.offsets.length > 0) glyphSize += locaTable.offsets[glyphIndex + 1] - locaTable.offsets[glyphIndex];
        }
        var glyphSizeAligned = this.align(glyphSize);
        newGlyphTable = [];
        for(var i = 0; i < glyphSizeAligned; i++)newGlyphTable.push(0);
        var nextGlyphOffset = 0;
        var nextGlyphIndex = 0;
        var table = this.getTable("glyf");
        // Creating NewLocaTable - that would hold offsets for filtered glyphs.
        for(var i = 0; i < locaTable.offsets.length; i++){
            newLocaTable.push(nextGlyphOffset);
            if (nextGlyphIndex < activeGlyphs.length && activeGlyphs[nextGlyphIndex] === i) {
                ++nextGlyphIndex;
                newLocaTable[i] = nextGlyphOffset;
                var oldGlyphOffset = locaTable.offsets[i];
                var oldNextGlyphOffset = locaTable.offsets[i + 1] - oldGlyphOffset;
                if (oldNextGlyphOffset > 0) {
                    this.offset = table.offset + oldGlyphOffset;
                    var result = this.read(newGlyphTable, nextGlyphOffset, oldNextGlyphOffset);
                    newGlyphTable = result.buffer;
                    nextGlyphOffset += oldNextGlyphOffset;
                }
            }
        }
        return {
            glyphTableSize: glyphSize,
            newLocaTable: newLocaTable,
            newGlyphTable: newGlyphTable
        };
    };
    /**
     * Updates new Loca table.
     */ /* tslint:disable */ TtfReader.prototype.updateLocaTable = function(newLocaTable, bLocaIsShort, newLocaTableOut) {
        /* tslint:enable */ if (newLocaTable === null) throw new Error("Argument Null Exception : newLocaTable");
        var size = bLocaIsShort ? newLocaTable.length * 2 : newLocaTable.length * 4;
        var count = this.align(size);
        //BigEndianWiter
        var writer = new (0, $ae35c05e6bdc305d$export$3442d87134d25bf9)(count);
        for(var i = 0; i < newLocaTable.length; i++){
            var value = newLocaTable[i];
            if (bLocaIsShort) {
                value /= 2;
                writer.writeShort(value);
            } else writer.writeInt(value);
        }
        return {
            newLocaUpdated: writer.data,
            newLocaSize: size
        };
    };
    /**
     * Aligns number to be divisible on 4.
     */ TtfReader.prototype.align = function(value) {
        return value + 3 & -4;
    };
    /**
     * Returns font program data.
     */ /* tslint:disable */ TtfReader.prototype.getFontProgram = function(newLocaTableOut, newGlyphTable, glyphTableSize, locaTableSize) {
        /* tslint:enable */ if (newLocaTableOut === null) throw new Error("Argument Null Exception : newLocaTableOut");
        if (newGlyphTable === null) throw new Error("Argument Null Exception : newGlyphTable");
        var tableNames = this.tableNames;
        var result = this.getFontProgramLength(newLocaTableOut, newGlyphTable, 0);
        var fontProgramLength = result.fontProgramLength;
        var numTables = result.numTables;
        var writer = new (0, $ae35c05e6bdc305d$export$3442d87134d25bf9)(fontProgramLength);
        writer.writeInt(0x10000);
        writer.writeShort(numTables);
        var entrySelector = this.entrySelectors[numTables];
        writer.writeShort((1 << (entrySelector & 31)) * 16);
        writer.writeShort(entrySelector);
        writer.writeShort((numTables - (1 << (entrySelector & 31))) * 16);
        // Writing to destination buffer - checksums && sizes of used tables.
        this.writeCheckSums(writer, numTables, newLocaTableOut, newGlyphTable, glyphTableSize, locaTableSize);
        // // Writing to destination buffer - used glyphs.
        this.writeGlyphs(writer, newLocaTableOut, newGlyphTable);
        return writer.data;
    };
    /* tslint:disable */ TtfReader.prototype.getFontProgramLength = function(newLocaTableOut, newGlyphTable, numTables) {
        /* tslint:enable */ if (newLocaTableOut === null) throw new Error("Argument Null Exception : newLocaTableOut");
        if (newGlyphTable === null) throw new Error("Argument Null Exception : newGlyphTable");
        // glyf and loca are used by default;
        numTables = 2;
        var tableNames = this.tableNames;
        var fontProgramLength = 0;
        for(var i = 0; i < tableNames.length; i++){
            var tableName = tableNames[i];
            if (tableName !== "glyf" && tableName !== "loca") {
                var table = this.getTable(tableName);
                if (!table.empty) {
                    ++numTables;
                    fontProgramLength += this.align(table.length);
                }
            }
        }
        fontProgramLength += newLocaTableOut.length;
        fontProgramLength += newGlyphTable.length;
        var usedTablesSize = numTables * 16 + 12;
        fontProgramLength += usedTablesSize;
        return {
            fontProgramLength: fontProgramLength,
            numTables: numTables
        };
    };
    /**
     * Writing to destination buffer - checksums and sizes of used tables.
     */ /* tslint:disable */ TtfReader.prototype.writeCheckSums = function(writer, numTables, newLocaTableOut, newGlyphTable, glyphTableSize, locaTableSize) {
        /* tslint:enable */ if (writer === null) throw new Error("Argument Null Exception : writer");
        if (newLocaTableOut === null) throw new Error("Argument Null Exception : newLocaTableOut");
        if (newGlyphTable === null) throw new Error("Argument Null Exception : newGlyphTable");
        var tableNames = this.tableNames;
        var usedTablesSize = numTables * 16 + 12;
        var nextTableSize = 0;
        for(var i = 0; i < tableNames.length; i++){
            var tableName = tableNames[i];
            var tableInfo = this.getTable(tableName);
            if (tableInfo.empty) continue;
            writer.writeString(tableName);
            if (tableName === "glyf") {
                var checksum = this.calculateCheckSum(newGlyphTable);
                writer.writeInt(checksum);
                nextTableSize = glyphTableSize;
            } else if (tableName === "loca") {
                var checksum = this.calculateCheckSum(newLocaTableOut);
                writer.writeInt(checksum);
                nextTableSize = locaTableSize;
            } else {
                writer.writeInt(tableInfo.checksum);
                nextTableSize = tableInfo.length;
            }
            writer.writeUInt(usedTablesSize);
            writer.writeUInt(nextTableSize);
            usedTablesSize += this.align(nextTableSize);
        }
    };
    /**
     * Gets checksum from source buffer.
     */ TtfReader.prototype.calculateCheckSum = function(bytes) {
        if (bytes === null) throw new Error("Argument Null Exception : bytes");
        var pos = 0;
        var byte1 = 0;
        var byte2 = 0;
        var byte3 = 0;
        var byte4 = 0;
        for(var i = 0; i < (bytes.length + 1) / 4; i++){
            byte4 += bytes[pos++] & 255;
            byte3 += bytes[pos++] & 255;
            byte2 += bytes[pos++] & 255;
            byte1 += bytes[pos++] & 255;
        }
        var result = byte1;
        result += byte2 << 8;
        result += byte3 << 16;
        result += byte4 << 24;
        return result;
    };
    /**
     * Writing to destination buffer - used glyphs.
     */ TtfReader.prototype.writeGlyphs = function(writer, newLocaTable, newGlyphTable) {
        if (writer === null) throw new Error("Argument Null Exception : writer");
        if (newLocaTable === null) throw new Error("Argument Null Exception : newLocaTableOut");
        if (newGlyphTable === null) throw new Error("Argument Null Exception : newGlyphTable");
        var tableNames = this.tableNames;
        for(var i = 0; i < tableNames.length; i++){
            var tableName = tableNames[i];
            var tableInfo = this.getTable(tableName);
            if (tableInfo.empty) continue;
            if (tableName === "glyf") writer.writeBytes(newGlyphTable);
            else if (tableName === "loca") writer.writeBytes(newLocaTable);
            else {
                var count = this.align(tableInfo.length);
                var buff = [];
                for(var i_1 = 0; i_1 < count; i_1++)buff.push(0);
                this.offset = tableInfo.offset;
                var result = this.read(buff, 0, tableInfo.length);
                writer.writeBytes(result.buffer);
            }
        }
    };
    //public methods
    /**
     * Sets position value of font data.
     */ TtfReader.prototype.setOffset = function(offset) {
        this.offset = offset;
    };
    /**
     * Creates font Internals
     * @private
     */ TtfReader.prototype.createInternals = function() {
        this.metrics = new (0, $459afd7422caedbb$export$6670e0779ff5deb9)();
        var nameTable = this.readNameTable();
        var headTable = this.readHeadTable();
        this.bIsLocaShort = headTable.indexToLocalFormat === 0;
        var horizontalHeadTable = this.readHorizontalHeaderTable();
        var os2Table = this.readOS2Table();
        var postTable = this.readPostTable();
        this.width = this.readWidthTable(horizontalHeadTable.numberOfHMetrics, headTable.unitsPerEm);
        var subTables = this.readCmapTable();
        this.initializeMetrics(nameTable, headTable, horizontalHeadTable, os2Table, postTable, subTables);
    };
    TtfReader.prototype.getGlyph = function(charCode) {
        if (typeof charCode === "number") {
            var obj1 = null;
            if (!this.metrics.isSymbol && this.microsoftGlyphs != null) {
                if (this.microsoftGlyphs.containsKey(charCode)) obj1 = this.microsoftGlyphs.getValue(charCode);
            } else if (this.metrics.isSymbol && this.macintoshGlyphs != null) {
                if (this.macintoshGlyphs.containsKey(charCode)) obj1 = this.macintoshGlyphs.getValue(charCode);
            }
            var glyph = obj1 != null ? obj1 : this.getDefaultGlyph();
            return glyph;
        } else {
            var obj = null;
            var code = charCode.charCodeAt(0);
            if (!this.metrics.isSymbol && this.microsoft !== null) {
                if (this.microsoft.containsKey(code)) {
                    obj = this.microsoft.getValue(code);
                    if (code !== (0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace.charCodeAt(0)) this.isFontPresent = true;
                } else if (code !== (0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace.charCodeAt(0)) this.isFontPresent = false;
            } else if (this.metrics.isSymbol && this.macintosh !== null || this.isMacTTF) {
                // NOTE: this code fixes char codes that extends 0x100. However, it might corrupt something.
                if (this.maxMacIndex !== 0) code %= this.maxMacIndex + 1;
                else code = (code & 0xff00) === 0xf000 ? code & 0xff : code;
                if (this.macintosh.containsKey(code)) {
                    obj = this.macintosh.getValue(code);
                    this.isFontPresent = true;
                }
            }
            // Fix for StackOverFlow exception in XPS to PDF converter
            if (charCode === (0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace && obj === null) obj = new (0, $c37c6223d92dddaa$export$7b06ef24fb906c2f)();
            var glyph = obj !== null ? obj : this.getDefaultGlyph();
            return glyph;
        }
    };
    /**
     * Gets hash table with chars indexed by glyph index.
     */ TtfReader.prototype.getGlyphChars = function(chars) {
        if (chars === null || chars === undefined) throw new Error("Argument Null Exception : chars");
        var dictionary = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        var charKeys = chars.keys();
        for(var i = 0; i < charKeys.length; i++){
            var ch = charKeys[i];
            var glyph = this.getGlyph(ch);
            if (!glyph.empty) dictionary.setValue(glyph.index, ch.charCodeAt(0));
        }
        return dictionary;
    };
    /**
     * Gets all glyphs.
     */ TtfReader.prototype.getAllGlyphs = function() {
        var allGlyphInfo = [];
        var info = new (0, $c37c6223d92dddaa$export$7b06ef24fb906c2f)();
        var index = 0;
        for(var i = 0; i < this.width.length; i++){
            var width = this.width[i];
            info.index = index;
            info.width = width;
            allGlyphInfo.push(info);
            index++;
        }
        return allGlyphInfo;
    };
    /**
     * Reads a font's program.
     * @private
     */ TtfReader.prototype.readFontProgram = function(chars) {
        var glyphChars = this.getGlyphChars(chars);
        var locaTable = this.readLocaTable(this.bIsLocaShort);
        if (glyphChars.size() < chars.size()) this.missedGlyphs = chars.size() - glyphChars.size();
        this.updateGlyphChars(glyphChars, locaTable);
        /* tslint:disable */ var result1 = this.generateGlyphTable(glyphChars, locaTable, null, null);
        /* tslint:enable */ var glyphTableSize = result1.glyphTableSize;
        var newLocaTable = result1.newLocaTable;
        var newGlyphTable = result1.newGlyphTable;
        var result2 = this.updateLocaTable(newLocaTable, this.bIsLocaShort, null);
        var newLocaSize = result2.newLocaSize;
        var newLocaUpdated = result2.newLocaUpdated;
        var fontProgram = this.getFontProgram(newLocaUpdated, newGlyphTable, glyphTableSize, newLocaSize);
        return fontProgram;
    };
    /**
     * Reconverts string to be in proper format saved into PDF file.
     */ TtfReader.prototype.convertString = function(text) {
        if (text === null) throw new Error("Argument Null Exception : text");
        var glyph = "";
        var i = 0;
        for(var k = 0; k < text.length; k++){
            var ch = text[k];
            var glyphInfo = this.getGlyph(ch);
            if (!glyphInfo.empty) {
                glyph += String.fromCharCode(glyphInfo.index);
                i++;
            }
        }
        return glyph;
    };
    /**
     * Gets char width.
     */ TtfReader.prototype.getCharWidth = function(code) {
        var glyphInfo = this.getGlyph(code);
        glyphInfo = !glyphInfo.empty ? glyphInfo : this.getDefaultGlyph();
        var codeWidth = !glyphInfo.empty ? glyphInfo.width : 0;
        return codeWidth;
    };
    TtfReader.prototype.readString = function(length, isUnicode) {
        if (isUnicode === undefined) return this.readString(length, false);
        else {
            //let buffer : number[] = this.readBytes(length);
            var result = "";
            if (isUnicode) for(var i = 0; i < length; i++){
                if (i % 2 !== 0) result += String.fromCharCode(this.fontData[this.offset]);
                this.offset += 1;
            }
            else for(var i = 0; i < length; i++){
                result += String.fromCharCode(this.fontData[this.offset]);
                this.offset += 1;
            }
            return result;
        }
    };
    TtfReader.prototype.readFixed = function(offset) {
        var integer = this.readInt16(offset);
        var sFraction = this.readInt16(offset + 2);
        var fraction = sFraction / 16384;
        return integer + fraction;
    };
    TtfReader.prototype.readInt32 = function(offset) {
        var i1 = this.fontData[offset + 3];
        var i2 = this.fontData[offset + 2];
        var i3 = this.fontData[offset + 1];
        var i4 = this.fontData[offset];
        this.offset += 4;
        return i1 + (i2 << 8) + (i3 << 16) + (i4 << 24);
    };
    TtfReader.prototype.readUInt32 = function(offset) {
        var i1 = this.fontData[offset + 3];
        var i2 = this.fontData[offset + 2];
        var i3 = this.fontData[offset + 1];
        var i4 = this.fontData[offset];
        this.offset += 4;
        return i1 | i2 << 8 | i3 << 16 | i4 << 24;
    };
    // private readInt16(offset : number) : number {
    //     let result : number = (this.fontData[offset] << 8) + this.fontData[offset + 1];
    //     this.offset += 2;
    //     return result;
    // }
    TtfReader.prototype.readInt16 = function(offset) {
        var result = (this.fontData[offset] << 8) + this.fontData[offset + 1];
        result = result & 32768 ? result - 0x10000 : result;
        this.offset += 2;
        return result;
    };
    TtfReader.prototype.readInt64 = function(offset) {
        var low = this.readInt32(offset + 4);
        var n = this.readInt32(offset) * 4294967296.0 + low;
        if (low < 0) n += 4294967296;
        return n;
    };
    TtfReader.prototype.readUInt16 = function(offset) {
        var result = this.fontData[offset] << 8 | this.fontData[offset + 1];
        this.offset += 2;
        return result;
    };
    /**
     * Reads ushort array.
     */ TtfReader.prototype.readUshortArray = function(length) {
        var buffer = [];
        for(var i = 0; i < length; i++)buffer[i] = this.readUInt16(this.offset);
        return buffer;
    };
    TtfReader.prototype.readBytes = function(length) {
        var result = [];
        for(var i = 0; i < length; i++){
            result.push(this.fontData[this.offset]);
            this.offset += 1;
        }
        return result;
    };
    TtfReader.prototype.readByte = function(offset) {
        var result = this.fontData[offset];
        this.offset += 1;
        return result;
    };
    /**
     * Reads bytes to array in BigEndian order.
     * @private
     */ TtfReader.prototype.read = function(buffer, index, count) {
        if (buffer === null) throw new Error("Argument Null Exception : buffer");
        var written = 0;
        var read = 0;
        do {
            for(var i = 0; i < count - written && this.offset + i < this.fontData.length; i++)buffer[index + i] = this.fontData[this.offset + i];
            read = count - written;
            this.offset += read;
            written += read;
        }while (written < count);
        return {
            buffer: buffer,
            written: written
        };
    };
    return TtfReader;
}();












var $08793818e6cf5e5a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `Metrics` of the font.
 * @private
 */ var $08793818e6cf5e5a$export$4cb7d36a071e5774 = /** @class */ function() {
    function PdfFontMetrics() {
        /**
         * `Line gap`.
         * @private
         */ this.lineGap = 0;
    }
    //  Public methods
    /**
     * Returns `ascent` taking into consideration font`s size.
     * @private
     */ PdfFontMetrics.prototype.getAscent = function(format) {
        var returnValue = this.ascent * (0, $ec27d251b6edcb44$export$60d73556588f648b).charSizeMultiplier * this.getSize(format);
        return returnValue;
    };
    /**
     * Returns `descent` taking into consideration font`s size.
     * @private
     */ PdfFontMetrics.prototype.getDescent = function(format) {
        var returnValue = this.descent * (0, $ec27d251b6edcb44$export$60d73556588f648b).charSizeMultiplier * this.getSize(format);
        return returnValue;
    };
    /**
     * Returns `Line gap` taking into consideration font`s size.
     * @private
     */ PdfFontMetrics.prototype.getLineGap = function(format) {
        var returnValue = this.lineGap * (0, $ec27d251b6edcb44$export$60d73556588f648b).charSizeMultiplier * this.getSize(format);
        return returnValue;
    };
    /**
     * Returns `height` taking into consideration font`s size.
     * @private
     */ PdfFontMetrics.prototype.getHeight = function(format) {
        var height;
        var clearTypeFonts = [
            "cambria",
            "candara",
            "constantia",
            "corbel",
            "cariadings"
        ];
        var clearTypeFontCollection = [];
        for(var index = 0; index < clearTypeFonts.length; index++){
            var font = clearTypeFonts[index];
            clearTypeFontCollection.push(font);
        }
        if (this.getDescent(format) < 0) // if ((clearTypeFontCollection.indexOf(this.name.toLowerCase()) !== -1) && !this.isUnicodeFont) {
        //     height = (this.GetAscent(format) - this.GetDescent(format) - this.GetLineGap(format));
        // } else {
        height = this.getAscent(format) - this.getDescent(format) + this.getLineGap(format);
        else height = this.getAscent(format) + this.getDescent(format) + this.getLineGap(format);
        return height;
    };
    /**
     * Calculates `size` of the font depending on the subscript/superscript value.
     * @private
     */ PdfFontMetrics.prototype.getSize = function(format) {
        var size = this.size;
        if (format != null) switch(format.subSuperScript){
            case (0, $32129651824bb502$export$72189ec4d9b4f960).SubScript:
                size /= this.subScriptSizeFactor;
                break;
            case (0, $32129651824bb502$export$72189ec4d9b4f960).SuperScript:
                size /= this.superscriptSizeFactor;
                break;
        }
        return size;
    };
    /**
     * `Clones` the metrics.
     * @private
     */ PdfFontMetrics.prototype.clone = function() {
        var metrics = this;
        metrics.widthTable = $08793818e6cf5e5a$export$a17c759f02971d00.clone();
        return metrics;
    };
    Object.defineProperty(PdfFontMetrics.prototype, "widthTable", {
        //  Properies
        /**
         * Gets or sets the `width table`.
         * @private
         */ get: function() {
            return this.internalWidthTable;
        },
        set: function(value) {
            this.internalWidthTable = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfFontMetrics;
}();
var $08793818e6cf5e5a$export$a17c759f02971d00 = /** @class */ function() {
    function WidthTable() {}
    /**
     * Static `clones` this instance of the WidthTable class.
     * @private
     */ WidthTable.clone = function() {
        return null;
    };
    return WidthTable;
}();
var $08793818e6cf5e5a$export$8a4fe9dae84da916 = /** @class */ function(_super) {
    $08793818e6cf5e5a$var$__extends(StandardWidthTable, _super);
    // Constructors
    /**
     * Initializes a new instance of the `StandardWidthTable` class.
     * @private
     */ function StandardWidthTable(widths) {
        var _this = _super.call(this) || this;
        if (widths == null) throw new Error("ArgumentNullException:widths");
        _this.widths = widths;
        return _this;
    }
    //Properties
    /**
     * Gets the `32 bit number` at the specified index.
     * @private
     */ StandardWidthTable.prototype.items = function(index) {
        if (index < 0 || index >= this.widths.length) throw new Error("ArgumentOutOfRangeException:index, The character is not supported by the font.");
        var result = this.widths[index];
        return result;
    };
    Object.defineProperty(StandardWidthTable.prototype, "length", {
        /**
         * Gets the `length` of the internal array.
         * @private
         */ get: function() {
            return this.widths.length;
        },
        enumerable: true,
        configurable: true
    });
    //Overrides
    /**
     * `Clones` this instance of the WidthTable class.
     * @private
     */ StandardWidthTable.prototype.clone = function() {
        var swt = this;
        swt.widths = this.widths;
        return swt;
    };
    /**
     * Converts width table to a `PDF array`.
     * @private
     */ StandardWidthTable.prototype.toArray = function() {
        var arr = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)(this.widths);
        return arr;
    };
    return StandardWidthTable;
}($08793818e6cf5e5a$export$a17c759f02971d00);







var $13da76851e74b0e2$export$c62c39062f746216 = /** @class */ function() {
    /* tslint:enable */ //Constructors
    /**
     * Initializes a new instance of the `PdfTrueTypeFont` class.
     * @private
     */ function UnicodeTrueTypeFont(base64String, size) {
        // Fields
        this.nameString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        /**
         * Specifies the Internal variable to store fields of `PdfDictionaryProperties`.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * Indicates whether the font program is compressed or not.
         * @private
         */ this.isCompress = false;
        /**
         * Indicates whether the font is embedded or not.
         */ this.isEmbedFont = false;
        /**
         * Cmap table's start prefix.
         */ /* tslint:disable */ this.cmapPrefix = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine + "/CIDSystemInfo << /Registry (Adobe)/Ordering (UCS)/Supplement 0>> def\n/CMapName " + "/Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        /* tslint:enable */ /**
         * Cmap table's start suffix.
         */ this.cmapEndCodespaceRange = "endcodespacerange" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        /**
         * Cmap's begin range marker.
         */ this.cmapBeginRange = "beginbfrange" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        /**
         * Cmap's end range marker.
         */ this.cmapEndRange = "endbfrange" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        /**
         * Cmap table's end
         */ /* tslint:disable */ this.cmapSuffix = "endbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend end" + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
        if (base64String === null || base64String === undefined) throw new Error("ArgumentNullException:base64String");
        this.fontSize = size;
        this.fontString = base64String;
        this.Initialize();
    }
    //Implementation
    /**
     * Returns width of the char symbol.
     */ UnicodeTrueTypeFont.prototype.getCharWidth = function(charCode) {
        var codeWidth = this.ttfReader.getCharWidth(charCode);
        return codeWidth;
    };
    /**
     * Returns width of the text line.
     */ UnicodeTrueTypeFont.prototype.getLineWidth = function(line) {
        // if (line == null) {
        //     throw new Error('ArgumentNullException : line');
        // }
        var width = 0;
        for(var i = 0, len = line.length; i < len; i++){
            var ch = line[i];
            var charWidth = this.getCharWidth(ch);
            width += charWidth;
        }
        return width;
    };
    /**
     * Initializes a new instance of the `PdfTrueTypeFont` class.
     * @private
     */ UnicodeTrueTypeFont.prototype.Initialize = function() {
        var byteArray = new (0, $72b64e0afda10076$export$a963f15d59b126e1)(this.fontString.length);
        byteArray.writeFromBase64String(this.fontString);
        this.fontData = byteArray.internalBuffer;
        this.ttfReader = new (0, $e70bd4219f4fdb24$export$7727ccb118793aba)(this.fontData);
        this.ttfMetrics = this.ttfReader.metrics;
    };
    UnicodeTrueTypeFont.prototype.createInternals = function() {
        this.fontDictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        this.fontProgram = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        this.cmap = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        this.descendantFont = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        this.metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        this.ttfReader.createInternals();
        this.ttfMetrics = this.ttfReader.metrics;
        this.initializeMetrics();
        // Create all the dictionaries of the font.
        this.subsetName = this.getFontName();
        this.createDescendantFont();
        this.createCmap();
        this.createFontDictionary();
        this.createFontProgram();
    };
    UnicodeTrueTypeFont.prototype.getInternals = function() {
        return this.fontDictionary;
    };
    /**
     * Initializes metrics.
     */ UnicodeTrueTypeFont.prototype.initializeMetrics = function() {
        var ttfMetrics = this.ttfReader.metrics;
        this.metrics.ascent = ttfMetrics.macAscent;
        this.metrics.descent = ttfMetrics.macDescent;
        this.metrics.height = ttfMetrics.macAscent - ttfMetrics.macDescent + ttfMetrics.lineGap;
        this.metrics.name = ttfMetrics.fontFamily;
        this.metrics.postScriptName = ttfMetrics.postScriptName;
        this.metrics.size = this.fontSize;
        this.metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(ttfMetrics.widthTable);
        this.metrics.lineGap = ttfMetrics.lineGap;
        this.metrics.subScriptSizeFactor = ttfMetrics.subScriptSizeFactor;
        this.metrics.superscriptSizeFactor = ttfMetrics.superscriptSizeFactor;
        this.metrics.isBold = ttfMetrics.isBold;
    };
    /**
     * Gets random string.
     */ UnicodeTrueTypeFont.prototype.getFontName = function() {
        var builder = "";
        var name;
        // if (this.isEmbed === false) {
        for(var i = 0; i < 6; i++){
            var index = Math.floor(Math.random() * 26) + 0;
            builder += this.nameString[index];
        }
        builder += "+";
        // }
        builder += this.ttfReader.metrics.postScriptName;
        name = builder.toString();
        // if (name === '') {
        //     name = this.ttfReader.metrics.fontFamily;
        // }
        name = this.formatName(name);
        return name;
    };
    /**
     * Generates name of the font.
     */ UnicodeTrueTypeFont.prototype.formatName = function(fontName) {
        // if (fontName === null) {
        //     throw new Error('ArgumentNullException : fontName');
        // }
        // if (fontName === '') {
        //     throw new Error('ArgumentOutOfRangeException : fontName, Parameter can not be empty');
        // }
        var ret = fontName.replace("(", "#28");
        ret = ret.replace(")", "#29");
        ret = ret.replace("[", "#5B");
        ret = ret.replace("]", "#5D");
        ret = ret.replace("<", "#3C");
        ret = ret.replace(">", "#3E");
        ret = ret.replace("{", "#7B");
        ret = ret.replace("}", "#7D");
        ret = ret.replace("/", "#2F");
        ret = ret.replace("%", "#25");
        return ret.replace(" ", "#20");
    };
    /**
     * Creates descendant font.
     */ UnicodeTrueTypeFont.prototype.createDescendantFont = function() {
        // Set property used to clone Font every time
        this.descendantFont.isResource = true;
        this.descendantFont.descendantFontBeginSave = new (0, $467b51a52206950c$export$8958daefdc2ff)(this);
        this.descendantFont.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.font));
        this.descendantFont.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.cIDFontType2));
        this.descendantFont.items.setValue(this.dictionaryProperties.baseFont, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.subsetName));
        this.descendantFont.items.setValue(this.dictionaryProperties.cIDToGIDMap, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.identity));
        this.descendantFont.items.setValue(this.dictionaryProperties.dw, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(1000));
        this.fontDescriptor = this.createFontDescriptor();
        this.descendantFont.items.setValue(this.dictionaryProperties.fontDescriptor, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.fontDescriptor));
        var systemInfo = this.createSystemInfo();
        this.descendantFont.items.setValue(this.dictionaryProperties.cIDSystemInfo, systemInfo);
    };
    /**
     * Creates font descriptor.
     */ UnicodeTrueTypeFont.prototype.createFontDescriptor = function() {
        var descriptor = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        var metrics = this.ttfReader.metrics;
        // Set property used to clone Font every time
        descriptor.isResource = true;
        descriptor.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.fontDescriptor));
        descriptor.items.setValue(this.dictionaryProperties.fontName, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.subsetName));
        descriptor.items.setValue(this.dictionaryProperties.flags, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.getDescriptorFlags()));
        descriptor.items.setValue(this.dictionaryProperties.fontBBox, (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(this.getBoundBox()));
        descriptor.items.setValue(this.dictionaryProperties.missingWidth, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.widthTable[32]));
        descriptor.items.setValue(this.dictionaryProperties.stemV, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.stemV));
        descriptor.items.setValue(this.dictionaryProperties.italicAngle, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.italicAngle));
        descriptor.items.setValue(this.dictionaryProperties.capHeight, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.capHeight));
        descriptor.items.setValue(this.dictionaryProperties.ascent, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.winAscent));
        descriptor.items.setValue(this.dictionaryProperties.descent, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.winDescent));
        descriptor.items.setValue(this.dictionaryProperties.leading, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.leading));
        descriptor.items.setValue(this.dictionaryProperties.avgWidth, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.widthTable[32]));
        descriptor.items.setValue(this.dictionaryProperties.fontFile2, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.fontProgram));
        descriptor.items.setValue(this.dictionaryProperties.maxWidth, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(metrics.widthTable[32]));
        descriptor.items.setValue(this.dictionaryProperties.xHeight, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0));
        descriptor.items.setValue(this.dictionaryProperties.stemH, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0));
        return descriptor;
    };
    /**
     * Generates cmap.
     * @private
     */ UnicodeTrueTypeFont.prototype.createCmap = function() {
        this.cmap.cmapBeginSave = new (0, $15c367619ceaca0d$export$dd3025ce91a23ff5)(this);
    };
    /**
     * Generates font dictionary.
     */ UnicodeTrueTypeFont.prototype.createFontDictionary = function() {
        // Set property used to clone Font every time
        this.fontDictionary.isResource = true;
        this.fontDictionary.fontDictionaryBeginSave = new (0, $467b51a52206950c$export$b8d69296544a79db)(this);
        this.fontDictionary.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.font));
        this.fontDictionary.items.setValue(this.dictionaryProperties.baseFont, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.subsetName));
        this.fontDictionary.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.type0));
        this.fontDictionary.items.setValue(this.dictionaryProperties.encoding, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.identityH));
        var descFonts = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        var reference = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.descendantFont);
        // Set property used to clone Font every time
        descFonts.isFont = true;
        descFonts.add(reference);
        this.fontDictionary.items.setValue(this.dictionaryProperties.descendantFonts, descFonts);
    };
    /**
     * Creates font program.
     */ UnicodeTrueTypeFont.prototype.createFontProgram = function() {
        this.fontProgram.fontProgramBeginSave = new (0, $15c367619ceaca0d$export$56a09a2087b8457a)(this);
    };
    /**
     * Creates system info dictionary for CID font.
     * @private
     */ UnicodeTrueTypeFont.prototype.createSystemInfo = function() {
        var systemInfo = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        systemInfo.items.setValue(this.dictionaryProperties.registry, new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)("Adobe"));
        systemInfo.items.setValue(this.dictionaryProperties.ordering, new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)(this.dictionaryProperties.identity));
        systemInfo.items.setValue(this.dictionaryProperties.supplement, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0));
        return systemInfo;
    };
    /**
     * Runs before font Dictionary will be saved.
     */ UnicodeTrueTypeFont.prototype.descendantFontBeginSave = function() {
        if (this.usedChars !== null && this.usedChars !== undefined && this.usedChars.size() > 0) {
            var width = this.getDescendantWidth();
            if (width !== null) this.descendantFont.items.setValue(this.dictionaryProperties.w, width);
        }
    };
    /**
     * Runs before font Dictionary will be saved.
     */ UnicodeTrueTypeFont.prototype.cmapBeginSave = function() {
        this.generateCmap();
    };
    /**
     * Runs before font Dictionary will be saved.
     */ /* tslint:disable */ UnicodeTrueTypeFont.prototype.fontDictionaryBeginSave = function() {
        if (this.usedChars !== null && this.usedChars !== undefined && this.usedChars.size() > 0 && !this.fontDictionary.containsKey(this.dictionaryProperties.toUnicode)) this.fontDictionary.items.setValue(this.dictionaryProperties.toUnicode, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.cmap));
    };
    /* tslint:enable */ /**
     * Runs before font program stream save.
     */ UnicodeTrueTypeFont.prototype.fontProgramBeginSave = function() {
        this.isCompress = true;
        this.generateFontProgram();
    };
    /**
     * Gets width description pad array for c i d font.
     */ UnicodeTrueTypeFont.prototype.getDescendantWidth = function() {
        var array = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        if (this.usedChars !== null && this.usedChars !== undefined && this.usedChars.size() > 0) {
            var glyphInfo = [];
            // if (!this.isEmbedFont) {
            var keys = this.usedChars.keys();
            for(var i = 0; i < keys.length; i++){
                var chLen = keys[i];
                var glyph = this.ttfReader.getGlyph(chLen);
                if (glyph.empty) continue;
                glyphInfo.push(glyph);
            }
            // } else {
            //     glyphInfo = this.ttfReader.getAllGlyphs();
            // }
            glyphInfo.sort(function(a, b) {
                return a.index - b.index;
            });
            var firstGlyphIndex = 0;
            var lastGlyphIndex = 0;
            var firstGlyphIndexWasSet = false;
            var widthDetails = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
            // if (!this.isEmbedFont) {
            for(var i = 0; i < glyphInfo.length; i++){
                var glyph = glyphInfo[i];
                if (!firstGlyphIndexWasSet) {
                    firstGlyphIndexWasSet = true;
                    firstGlyphIndex = glyph.index;
                    lastGlyphIndex = glyph.index - 1;
                }
                if ((lastGlyphIndex + 1 !== glyph.index || i + 1 === glyphInfo.length) && glyphInfo.length > 1) {
                    // Add glyph index / width.
                    array.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(firstGlyphIndex));
                    if (i !== 0) array.add(widthDetails);
                    firstGlyphIndex = glyph.index;
                    widthDetails = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
                }
                widthDetails.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(glyph.width));
                if (i + 1 === glyphInfo.length) {
                    array.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(firstGlyphIndex));
                    array.add(widthDetails);
                }
                lastGlyphIndex = glyph.index;
            }
        // } else {
        //     for (let i : number = 0; i < glyphInfo.length; i++) {
        //         let glyph : TtfGlyphInfo = glyphInfo[i];
        //         if (!firstGlyphIndexWasSet) {
        //             firstGlyphIndexWasSet = true;
        //             lastGlyphIndex = glyph.index - 1;
        //         }
        //         firstGlyphIndex = glyph.index;
        //         if ((lastGlyphIndex + 1 === glyph.index || (i + 1 === glyphInfo.length)) && glyphInfo.length > 1) {
        //             // Add glyph index / width.
        //             widthDetails.add(new PdfNumber(glyph.width));
        //             array.add(new PdfNumber(firstGlyphIndex));
        //             array.add(widthDetails);
        //             widthDetails = new PdfArray();
        //         }
        //         lastGlyphIndex = glyph.index;
        //     }
        // }
        }
        return array;
    };
    /**
     * Creates cmap.
     */ UnicodeTrueTypeFont.prototype.generateCmap = function() {
        if (this.usedChars !== null && this.usedChars !== undefined && this.usedChars.size() > 0) {
            var glyphChars = this.ttfReader.getGlyphChars(this.usedChars);
            if (glyphChars.size() > 0) {
                var keys = glyphChars.keys().sort();
                // add first and last glyph indexes
                var first = keys[0];
                var last = keys[keys.length - 1];
                var middlePart = this.toHexString(first, false) + this.toHexString(last, false) + (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine;
                var builder = "";
                builder += this.cmapPrefix;
                builder += middlePart;
                builder += this.cmapEndCodespaceRange;
                var nextRange = 0;
                for(var i = 0; i < keys.length; i++){
                    if (nextRange === 0) {
                        if (i !== 0) builder += this.cmapEndRange;
                        nextRange = Math.min(100, keys.length - i);
                        builder += nextRange;
                        builder += (0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).whiteSpace;
                        builder += this.cmapBeginRange;
                    }
                    nextRange -= 1;
                    var key = keys[i];
                    /* tslint:disable */ builder += this.toHexString(key, true) + this.toHexString(key, true) + this.toHexString(glyphChars.getValue(key), true) + "\n";
                /* tslint:enable */ }
                builder += this.cmapSuffix;
                this.cmap.clearStream();
                this.cmap.isResource = true;
                this.cmap.write(builder);
            }
        }
    };
    /**
     * Generates font program.
     */ UnicodeTrueTypeFont.prototype.generateFontProgram = function() {
        var fontProgram = null;
        this.usedChars = this.usedChars === null || this.usedChars === undefined ? new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)() : this.usedChars;
        this.ttfReader.setOffset(0);
        fontProgram = this.ttfReader.readFontProgram(this.usedChars);
        this.fontProgram.clearStream();
        this.fontProgram.isResource = true;
        this.fontProgram.writeBytes(fontProgram);
    };
    /**
     * Calculates flags for the font descriptor.
     * @private
     */ UnicodeTrueTypeFont.prototype.getDescriptorFlags = function() {
        var flags = 0;
        var metrics = this.ttfReader.metrics;
        if (metrics.isFixedPitch) flags |= (0, $32129651824bb502$export$d37c3ab05448369c).FixedPitch;
        if (metrics.isSymbol) flags |= (0, $32129651824bb502$export$d37c3ab05448369c).Symbolic;
        else flags |= (0, $32129651824bb502$export$d37c3ab05448369c).Nonsymbolic;
        if (metrics.isItalic) flags |= (0, $32129651824bb502$export$d37c3ab05448369c).Italic;
        if (metrics.isBold) flags |= (0, $32129651824bb502$export$d37c3ab05448369c).ForceBold;
        return flags;
    };
    /**
     * Calculates BoundBox of the descriptor.
     * @private
     */ UnicodeTrueTypeFont.prototype.getBoundBox = function() {
        var rect = this.ttfReader.metrics.fontBox;
        var width = Math.abs(rect.right - rect.left);
        var height = Math.abs(rect.top - rect.bottom);
        var rectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(rect.left, rect.bottom, width, height);
        return rectangle;
    };
    /**
     * Converts integer of decimal system to hex integer.
     */ UnicodeTrueTypeFont.prototype.toHexString = function(n, isCaseChange) {
        var s = n.toString(16);
        if (isCaseChange) s = s.toUpperCase();
        return "<0000".substring(0, 5 - s.length) + s + ">";
    };
    /**
     * Stores used symbols.
     */ UnicodeTrueTypeFont.prototype.setSymbols = function(text) {
        if (text === null) throw new Error("Argument Null Exception : text");
        if (this.usedChars === null || this.usedChars === undefined) this.usedChars = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        for(var i = 0; i < text.length; i++){
            var ch = text[i];
            this.usedChars.setValue(ch, String.fromCharCode(0));
        }
        // else {
        //     if (text === null) {
        //         throw new Error('Argument Null Exception : glyphs');
        //     }
        //     if (this.usedChars === null || this.usedChars === undefined) {
        //             this.usedChars = new Dictionary<string, string>();
        //     }
        //     for (let i : number = 0; i < text.length; i++) {
        //         let glyphIndex : number = text[i];
        //         let glyph : TtfGlyphInfo =  this.ttfReader.getGlyph(glyphIndex);
        //         if (!glyph == null) {
        //             let c : string = glyph.charCode.toLocaleString();
        //             this.usedChars.setValue(c, String.fromCharCode(0));
        //         }
        //     }
        // }
        if (this.isEmbedFont === false) this.getDescendantWidth();
    };
    return UnicodeTrueTypeFont;
}();



/**
 * ArabicShapeRenderer.ts class for EJ2-PDF
 */ 
var $e1db529dd2812c4d$export$2c6e4803a1eed28d = /** @class */ function() {
    //#endregion
    //#region Constructor
    function ArabicShapeRenderer() {
        //#region Constants
        this.arabicCharTable = [
            [
                "\u0621",
                "\uFE80"
            ],
            [
                "\u0622",
                "\uFE81",
                "\uFE82"
            ],
            [
                "\u0623",
                "\uFE83",
                "\uFE84"
            ],
            [
                "\u0624",
                "\uFE85",
                "\uFE86"
            ],
            [
                "\u0625",
                "\uFE87",
                "\uFE88"
            ],
            [
                "\u0626",
                "\uFE89",
                "\uFE8A",
                "\uFE8B",
                "\uFE8C"
            ],
            [
                "\u0627",
                "\uFE8D",
                "\uFE8E"
            ],
            [
                "\u0628",
                "\uFE8F",
                "\uFE90",
                "\uFE91",
                "\uFE92"
            ],
            [
                "\u0629",
                "\uFE93",
                "\uFE94"
            ],
            [
                "\u062A",
                "\uFE95",
                "\uFE96",
                "\uFE97",
                "\uFE98"
            ],
            [
                "\u062B",
                "\uFE99",
                "\uFE9A",
                "\uFE9B",
                "\uFE9C"
            ],
            [
                "\u062C",
                "\uFE9D",
                "\uFE9E",
                "\uFE9F",
                "\uFEA0"
            ],
            [
                "\u062D",
                "\uFEA1",
                "\uFEA2",
                "\uFEA3",
                "\uFEA4"
            ],
            [
                "\u062E",
                "\uFEA5",
                "\uFEA6",
                "\uFEA7",
                "\uFEA8"
            ],
            [
                "\u062F",
                "\uFEA9",
                "\uFEAA"
            ],
            [
                "\u0630",
                "\uFEAB",
                "\uFEAC"
            ],
            [
                "\u0631",
                "\uFEAD",
                "\uFEAE"
            ],
            [
                "\u0632",
                "\uFEAF",
                "\uFEB0"
            ],
            [
                "\u0633",
                "\uFEB1",
                "\uFEB2",
                "\uFEB3",
                "\uFEB4"
            ],
            [
                "\u0634",
                "\uFEB5",
                "\uFEB6",
                "\uFEB7",
                "\uFEB8"
            ],
            [
                "\u0635",
                "\uFEB9",
                "\uFEBA",
                "\uFEBB",
                "\uFEBC"
            ],
            [
                "\u0636",
                "\uFEBD",
                "\uFEBE",
                "\uFEBF",
                "\uFEC0"
            ],
            [
                "\u0637",
                "\uFEC1",
                "\uFEC2",
                "\uFEC3",
                "\uFEC4"
            ],
            [
                "\u0638",
                "\uFEC5",
                "\uFEC6",
                "\uFEC7",
                "\uFEC8"
            ],
            [
                "\u0639",
                "\uFEC9",
                "\uFECA",
                "\uFECB",
                "\uFECC"
            ],
            [
                "\u063A",
                "\uFECD",
                "\uFECE",
                "\uFECF",
                "\uFED0"
            ],
            [
                "\u0640",
                "\u0640",
                "\u0640",
                "\u0640",
                "\u0640"
            ],
            [
                "\u0641",
                "\uFED1",
                "\uFED2",
                "\uFED3",
                "\uFED4"
            ],
            [
                "\u0642",
                "\uFED5",
                "\uFED6",
                "\uFED7",
                "\uFED8"
            ],
            [
                "\u0643",
                "\uFED9",
                "\uFEDA",
                "\uFEDB",
                "\uFEDC"
            ],
            [
                "\u0644",
                "\uFEDD",
                "\uFEDE",
                "\uFEDF",
                "\uFEE0"
            ],
            [
                "\u0645",
                "\uFEE1",
                "\uFEE2",
                "\uFEE3",
                "\uFEE4"
            ],
            [
                "\u0646",
                "\uFEE5",
                "\uFEE6",
                "\uFEE7",
                "\uFEE8"
            ],
            [
                "\u0647",
                "\uFEE9",
                "\uFEEA",
                "\uFEEB",
                "\uFEEC"
            ],
            [
                "\u0648",
                "\uFEED",
                "\uFEEE"
            ],
            [
                "\u0649",
                "\uFEEF",
                "\uFEF0",
                "\uFBE8",
                "\uFBE9"
            ],
            [
                "\u064A",
                "\uFEF1",
                "\uFEF2",
                "\uFEF3",
                "\uFEF4"
            ],
            [
                "\u0671",
                "\uFB50",
                "\uFB51"
            ],
            [
                "\u0679",
                "\uFB66",
                "\uFB67",
                "\uFB68",
                "\uFB69"
            ],
            [
                "\u067A",
                "\uFB5E",
                "\uFB5F",
                "\uFB60",
                "\uFB61"
            ],
            [
                "\u067B",
                "\uFB52",
                "\uFB53",
                "\uFB54",
                "\uFB55"
            ],
            [
                "\u067E",
                "\uFB56",
                "\uFB57",
                "\uFB58",
                "\uFB59"
            ],
            [
                "\u067F",
                "\uFB62",
                "\uFB63",
                "\uFB64",
                "\uFB65"
            ],
            [
                "\u0680",
                "\uFB5A",
                "\uFB5B",
                "\uFB5C",
                "\uFB5D"
            ],
            [
                "\u0683",
                "\uFB76",
                "\uFB77",
                "\uFB78",
                "\uFB79"
            ],
            [
                "\u0684",
                "\uFB72",
                "\uFB73",
                "\uFB74",
                "\uFB75"
            ],
            [
                "\u0686",
                "\uFB7A",
                "\uFB7B",
                "\uFB7C",
                "\uFB7D"
            ],
            [
                "\u0687",
                "\uFB7E",
                "\uFB7F",
                "\uFB80",
                "\uFB81"
            ],
            [
                "\u0688",
                "\uFB88",
                "\uFB89"
            ],
            [
                "\u068C",
                "\uFB84",
                "\uFB85"
            ],
            [
                "\u068D",
                "\uFB82",
                "\uFB83"
            ],
            [
                "\u068E",
                "\uFB86",
                "\uFB87"
            ],
            [
                "\u0691",
                "\uFB8C",
                "\uFB8D"
            ],
            [
                "\u0698",
                "\uFB8A",
                "\uFB8B"
            ],
            [
                "\u06A4",
                "\uFB6A",
                "\uFB6B",
                "\uFB6C",
                "\uFB6D"
            ],
            [
                "\u06A6",
                "\uFB6E",
                "\uFB6F",
                "\uFB70",
                "\uFB71"
            ],
            [
                "\u06A9",
                "\uFB8E",
                "\uFB8F",
                "\uFB90",
                "\uFB91"
            ],
            [
                "\u06AD",
                "\uFBD3",
                "\uFBD4",
                "\uFBD5",
                "\uFBD6"
            ],
            [
                "\u06AF",
                "\uFB92",
                "\uFB93",
                "\uFB94",
                "\uFB95"
            ],
            [
                "\u06B1",
                "\uFB9A",
                "\uFB9B",
                "\uFB9C",
                "\uFB9D"
            ],
            [
                "\u06B3",
                "\uFB96",
                "\uFB97",
                "\uFB98",
                "\uFB99"
            ],
            [
                "\u06BA",
                "\uFB9E",
                "\uFB9F"
            ],
            [
                "\u06BB",
                "\uFBA0",
                "\uFBA1",
                "\uFBA2",
                "\uFBA3"
            ],
            [
                "\u06BE",
                "\uFBAA",
                "\uFBAB",
                "\uFBAC",
                "\uFBAD"
            ],
            [
                "\u06C0",
                "\uFBA4",
                "\uFBA5"
            ],
            [
                "\u06C1",
                "\uFBA6",
                "\uFBA7",
                "\uFBA8",
                "\uFBA9"
            ],
            [
                "\u06C5",
                "\uFBE0",
                "\uFBE1"
            ],
            [
                "\u06C6",
                "\uFBD9",
                "\uFBDA"
            ],
            [
                "\u06C7",
                "\uFBD7",
                "\uFBD8"
            ],
            [
                "\u06C8",
                "\uFBDB",
                "\uFBDC"
            ],
            [
                "\u06C9",
                "\uFBE2",
                "\uFBE3"
            ],
            [
                "\u06CB",
                "\uFBDE",
                "\uFBDF"
            ],
            [
                "\u06CC",
                "\uFBFC",
                "\uFBFD",
                "\uFBFE",
                "\uFBFF"
            ],
            [
                "\u06D0",
                "\uFBE4",
                "\uFBE5",
                "\uFBE6",
                "\uFBE7"
            ],
            [
                "\u06D2",
                "\uFBAE",
                "\uFBAF"
            ],
            [
                "\u06D3",
                "\uFBB0",
                "\uFBB1"
            ]
        ];
        this.alef = "\u0627";
        this.alefHamza = "\u0623";
        this.alefHamzaBelow = "\u0625";
        this.alefMadda = "\u0622";
        this.lam = "\u0644";
        this.hamza = "\u0621";
        this.zeroWidthJoiner = "\u200D";
        this.hamzaAbove = "\u0654";
        this.hamzaBelow = "\u0655";
        this.wawHamza = "\u0624";
        this.yehHamza = "\u0626";
        this.waw = "\u0648";
        this.alefMaksura = "\u0649";
        this.yeh = "\u064A";
        this.farsiYeh = "\u06CC";
        this.shadda = "\u0651";
        this.madda = "\u0653";
        this.lwa = "\uFEFB";
        this.lwawh = "\uFEF7";
        this.lwawhb = "\uFEF9";
        this.lwawm = "\uFEF5";
        this.bwhb = "\u06D3";
        this.fathatan = "\u064B";
        this.superScriptalef = "\u0670";
        this.vowel = 0x1;
        // #endregion
        //#region Fields
        this.arabicMapTable = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        for(var i = 0; i < this.arabicCharTable.length; i++)this.arabicMapTable.setValue(this.arabicCharTable[i][0], this.arabicCharTable[i]);
    }
    //#endregion
    //#region implementation
    ArabicShapeRenderer.prototype.getCharacterShape = function(input, index) {
        if (input >= this.hamza && input <= this.bwhb) {
            var value = [];
            if (this.arabicMapTable.getValue(input)) {
                value = this.arabicMapTable.getValue(input);
                return value[index + 1];
            }
        } else if (input >= this.lwawm && input <= this.lwa) return input;
        return input;
    };
    ArabicShapeRenderer.prototype.shape = function(text, level) {
        var builder = "";
        var str2 = "";
        for(var i = 0; i < text.length; i++){
            var c = text[i];
            if (c >= "\u0600" && c <= "\u06FF") //if(c>= 0x0600.toString() && c<= 0x06FF.toString()) {
            str2 = str2 + c;
            else {
                if (str2.length > 0) {
                    var st = this.doShape(str2.toString(), 0);
                    builder = builder + st;
                    str2 = "";
                }
                builder = builder + c;
            }
        }
        if (str2.length > 0) {
            var st = this.doShape(str2.toString(), 0);
            builder = builder + st;
        }
        return builder.toString();
    };
    ArabicShapeRenderer.prototype.doShape = function(input, level) {
        var str = "";
        var ligature = 0;
        var len = 0;
        var i = 0;
        var next = "";
        var previous = new $e1db529dd2812c4d$export$f19255a2b10a5555();
        var present = new $e1db529dd2812c4d$export$f19255a2b10a5555();
        while(i < input.length){
            next = input[i++];
            ligature = this.ligature(next, present);
            if (ligature === 0) {
                var shapeCount = this.getShapeCount(next);
                len = shapeCount === 1 ? 0 : 2;
                if (previous.Shapes > 2) len += 1;
                len = len % present.Shapes;
                present.Value = this.getCharacterShape(present.Value, len);
                str = this.append(str, previous, level);
                previous = present;
                present = new $e1db529dd2812c4d$export$f19255a2b10a5555();
                present.Value = next;
                present.Shapes = shapeCount;
                present.Ligature++;
            }
        }
        len = previous.Shapes > 2 ? 1 : 0;
        len = len % present.Shapes;
        present.Value = this.getCharacterShape(present.Value, len);
        str = this.append(str, previous, level);
        str = this.append(str, present, level);
        return str.toString();
    };
    ArabicShapeRenderer.prototype.append = function(builder, shape, level) {
        if (shape.Value !== "") {
            builder = builder + shape.Value;
            shape.Ligature -= 1;
            if (shape.Type !== "") {
                if ((level & this.vowel) === 0) {
                    builder = builder + shape.Type;
                    shape.Ligature -= 1;
                } else shape.Ligature -= 1;
            }
            if (shape.vowel !== "") {
                if ((level & this.vowel) === 0) {
                    builder = builder + shape.vowel;
                    shape.Ligature -= 1;
                } else shape.Ligature -= 1;
            }
        }
        return builder;
    };
    ArabicShapeRenderer.prototype.ligature = function(value, shape) {
        if (shape.Value !== "") {
            var result = 0;
            if (value >= this.fathatan && value <= this.hamzaBelow || value === this.superScriptalef) {
                result = 1;
                if (shape.vowel !== "" && value !== this.shadda) result = 2;
                if (value === this.shadda) {
                    if (shape.Type == null) shape.Type = this.shadda;
                    else return 0;
                } else if (value === this.hamzaBelow) {
                    if (shape.Value === this.alef) {
                        shape.Value = this.alefHamzaBelow;
                        result = 2;
                    } else if (value === this.lwa) {
                        shape.Value = this.lwawhb;
                        result = 2;
                    } else shape.Type = this.hamzaBelow;
                } else if (value === this.hamzaAbove) {
                    if (shape.Value === this.alef) {
                        shape.Value = this.alefHamza;
                        result = 2;
                    } else if (shape.Value === this.lwa) {
                        shape.Value = this.lwawh;
                        result = 2;
                    } else if (shape.Value === this.waw) {
                        shape.Value = this.wawHamza;
                        result = 2;
                    } else if (shape.Value === this.yeh || shape.Value === this.alefMaksura || shape.Value === this.farsiYeh) {
                        shape.Value = this.yehHamza;
                        result = 2;
                    } else shape.Type = this.hamzaAbove;
                } else if (value === this.madda) {
                    if (shape.Value === this.alef) {
                        shape.Value = this.alefMadda;
                        result = 2;
                    }
                } else shape.vowel = value;
                if (result === 1) shape.Ligature++;
                return result;
            }
            if (shape.vowel !== "") return 0;
            if (shape.Value === this.lam) {
                if (value === this.alef) {
                    shape.Value = this.lwa;
                    shape.Shapes = 2;
                    result = 3;
                } else if (value === this.alefHamza) {
                    shape.Value = this.lwawh;
                    shape.Shapes = 2;
                    result = 3;
                } else if (value === this.alefHamzaBelow) {
                    shape.Value = this.lwawhb;
                    shape.Shapes = 2;
                    result = 3;
                } else if (value === this.alefMadda) {
                    shape.Value = this.lwawm;
                    shape.Shapes = 2;
                    result = 3;
                }
            }
            // else if (shape.Value === '') {
            //     shape.Value = value;
            //     shape.Shapes = this.getShapeCount(value);
            //     result = 1;
            // }
            return result;
        } else return 0;
    };
    ArabicShapeRenderer.prototype.getShapeCount = function(shape) {
        if (shape >= this.hamza && shape <= this.bwhb && !(shape >= this.fathatan && shape <= this.hamzaBelow || shape === this.superScriptalef)) {
            var c = [];
            if (this.arabicMapTable.getValue(shape)) {
                c = this.arabicMapTable.getValue(shape);
                return c.length - 1;
            }
        } else if (shape === this.zeroWidthJoiner) return 4;
        return 1;
    };
    return ArabicShapeRenderer;
}();
//#endregion
//#region Internals
var $e1db529dd2812c4d$export$f19255a2b10a5555 = /** @class */ function() {
    function ArabicShape() {
        //#region Fields
        this.shapeValue = "";
        this.shapeType = "";
        this.shapeVowel = "";
        this.shapeLigature = 0;
        this.shapeShapes = 1;
    //#endregion
    }
    Object.defineProperty(ArabicShape.prototype, "Value", {
        //#endregion
        //#region Properties 
        /**
         * Gets or sets the values.
         * @private
         */ get: function() {
            return this.shapeValue;
        },
        set: function(value) {
            this.shapeValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArabicShape.prototype, "Type", {
        /**
         * Gets or sets the values.
         * @private
         */ get: function() {
            return this.shapeType;
        },
        set: function(value) {
            this.shapeType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArabicShape.prototype, "vowel", {
        /**
         * Gets or sets the values.
         * @private
         */ get: function() {
            return this.shapeVowel;
        },
        set: function(value) {
            this.shapeVowel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArabicShape.prototype, "Ligature", {
        /**
         * Gets or sets the values.
         * @private
         */ get: function() {
            return this.shapeLigature;
        },
        set: function(value) {
            this.shapeLigature = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArabicShape.prototype, "Shapes", {
        /**
         * Gets or sets the values.
         * @private
         */ get: function() {
            return this.shapeShapes;
        },
        set: function(value) {
            this.shapeShapes = value;
        },
        enumerable: true,
        configurable: true
    });
    return ArabicShape;
}();
 //#endregion



/**
 * Bidi.ts class for EJ2-PDF
 */ 
/**
 * `Metrics` of the font.
 * @private
 */ var $8d6c280e77b82d6f$export$83b047b4376c0567 = /** @class */ function() {
    //#endregion
    //#region Constructor
    function Bidi() {
        //#region Fields
        this.indexes = [];
        this.indexLevels = [];
        this.mirroringShapeCharacters = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        this.update();
    }
    //#endregion
    //#region implementation
    Bidi.prototype.doMirrorShaping = function(text) {
        var result = [];
        for(var i = 0; i < text.length; i++)if ((this.indexLevels[i] & 1) === 1 && this.mirroringShapeCharacters.containsKey(text[i].charCodeAt(0))) result[i] = String.fromCharCode(this.mirroringShapeCharacters.getValue(text[i].charCodeAt(0)));
        else result[i] = text[i].toString();
        var res = "";
        for(var j = 0; j < result.length; j++)res = res + result[j];
        return res;
    };
    Bidi.prototype.getLogicalToVisualString = function(inputText, isRtl) {
        var rtlCharacters = new $8d6c280e77b82d6f$export$74e04eb940f505b4();
        this.indexLevels = rtlCharacters.getVisualOrder(inputText, isRtl);
        this.setDefaultIndexLevel();
        this.doOrder(0, this.indexLevels.length - 1);
        var text = this.doMirrorShaping(inputText);
        //let text : string = inputText;
        var resultBuilder = "";
        for(var i = 0; i < this.indexes.length; i++){
            var index = this.indexes[i];
            resultBuilder += text[index];
        }
        return resultBuilder.toString();
    };
    Bidi.prototype.setDefaultIndexLevel = function() {
        for(var i = 0; i < this.indexLevels.length; i++)this.indexes[i] = i;
    };
    Bidi.prototype.doOrder = function(sIndex, eIndex) {
        var max = this.indexLevels[sIndex];
        var min = max;
        var odd = max;
        var even = max;
        for(var i = sIndex + 1; i <= eIndex; ++i){
            var data = this.indexLevels[i];
            if (data > max) max = data;
            else if (data < min) min = data;
            odd &= data;
            even |= data;
        }
        if ((even & 1) === 0) return;
        if ((odd & 1) === 1) {
            this.reArrange(sIndex, eIndex + 1);
            return;
        }
        min |= 1;
        while(max >= min){
            var pstart = sIndex;
            /*tslint:disable:no-constant-condition */ while(true){
                while(pstart <= eIndex){
                    if (this.indexLevels[pstart] >= max) break;
                    pstart += 1;
                }
                if (pstart > eIndex) break;
                var pend = pstart + 1;
                while(pend <= eIndex){
                    if (this.indexLevels[pend] < max) break;
                    pend += 1;
                }
                this.reArrange(pstart, pend);
                pstart = pend + 1;
            }
            max -= 1;
        }
    };
    Bidi.prototype.reArrange = function(i, j) {
        var length = (i + j) / 2;
        --j;
        for(; i < length; ++i, --j){
            var temp = this.indexes[i];
            this.indexes[i] = this.indexes[j];
            this.indexes[j] = temp;
        }
    };
    Bidi.prototype.update = function() {
        this.mirroringShapeCharacters.setValue(40, 41);
        this.mirroringShapeCharacters.setValue(41, 40);
        this.mirroringShapeCharacters.setValue(60, 62);
        this.mirroringShapeCharacters.setValue(62, 60);
        this.mirroringShapeCharacters.setValue(91, 93);
        this.mirroringShapeCharacters.setValue(93, 91);
        this.mirroringShapeCharacters.setValue(123, 125);
        this.mirroringShapeCharacters.setValue(125, 123);
        this.mirroringShapeCharacters.setValue(171, 187);
        this.mirroringShapeCharacters.setValue(187, 171);
        this.mirroringShapeCharacters.setValue(8249, 8250);
        this.mirroringShapeCharacters.setValue(8250, 8249);
        this.mirroringShapeCharacters.setValue(8261, 8262);
        this.mirroringShapeCharacters.setValue(8262, 8261);
        this.mirroringShapeCharacters.setValue(8317, 8318);
        this.mirroringShapeCharacters.setValue(8318, 8317);
        this.mirroringShapeCharacters.setValue(8333, 8334);
        this.mirroringShapeCharacters.setValue(8334, 8333);
        this.mirroringShapeCharacters.setValue(8712, 8715);
        this.mirroringShapeCharacters.setValue(8713, 8716);
        this.mirroringShapeCharacters.setValue(8714, 8717);
        this.mirroringShapeCharacters.setValue(8715, 8712);
        this.mirroringShapeCharacters.setValue(8716, 8713);
        this.mirroringShapeCharacters.setValue(8717, 8714);
        this.mirroringShapeCharacters.setValue(8725, 10741);
        this.mirroringShapeCharacters.setValue(8764, 8765);
        this.mirroringShapeCharacters.setValue(8765, 8764);
        this.mirroringShapeCharacters.setValue(8771, 8909);
        this.mirroringShapeCharacters.setValue(8786, 8787);
        this.mirroringShapeCharacters.setValue(8787, 8786);
        this.mirroringShapeCharacters.setValue(8788, 8789);
        this.mirroringShapeCharacters.setValue(8789, 8788);
        this.mirroringShapeCharacters.setValue(8804, 8805);
        this.mirroringShapeCharacters.setValue(8805, 8804);
        this.mirroringShapeCharacters.setValue(8806, 8807);
        this.mirroringShapeCharacters.setValue(8807, 8806);
        this.mirroringShapeCharacters.setValue(8808, 8809);
        this.mirroringShapeCharacters.setValue(8809, 8808);
        this.mirroringShapeCharacters.setValue(8810, 8811);
        this.mirroringShapeCharacters.setValue(8811, 8810);
        this.mirroringShapeCharacters.setValue(8814, 8815);
        this.mirroringShapeCharacters.setValue(8815, 8814);
        this.mirroringShapeCharacters.setValue(8816, 8817);
        this.mirroringShapeCharacters.setValue(8817, 8816);
        this.mirroringShapeCharacters.setValue(8818, 8819);
        this.mirroringShapeCharacters.setValue(8819, 8818);
        this.mirroringShapeCharacters.setValue(8820, 8821);
        this.mirroringShapeCharacters.setValue(8821, 8820);
        this.mirroringShapeCharacters.setValue(8822, 8823);
        this.mirroringShapeCharacters.setValue(8823, 8822);
        this.mirroringShapeCharacters.setValue(8824, 8825);
        this.mirroringShapeCharacters.setValue(8825, 8824);
        this.mirroringShapeCharacters.setValue(8826, 8827);
        this.mirroringShapeCharacters.setValue(8827, 8826);
        this.mirroringShapeCharacters.setValue(8828, 8829);
        this.mirroringShapeCharacters.setValue(8829, 8828);
        this.mirroringShapeCharacters.setValue(8830, 8831);
        this.mirroringShapeCharacters.setValue(8831, 8830);
        this.mirroringShapeCharacters.setValue(8832, 8833);
        this.mirroringShapeCharacters.setValue(8833, 8832);
        this.mirroringShapeCharacters.setValue(8834, 8835);
        this.mirroringShapeCharacters.setValue(8835, 8834);
        this.mirroringShapeCharacters.setValue(8836, 8837);
        this.mirroringShapeCharacters.setValue(8837, 8836);
        this.mirroringShapeCharacters.setValue(8838, 8839);
        this.mirroringShapeCharacters.setValue(8839, 8838);
        this.mirroringShapeCharacters.setValue(8840, 8841);
        this.mirroringShapeCharacters.setValue(8841, 8840);
        this.mirroringShapeCharacters.setValue(8842, 8843);
        this.mirroringShapeCharacters.setValue(8843, 8842);
        this.mirroringShapeCharacters.setValue(8847, 8848);
        this.mirroringShapeCharacters.setValue(8848, 8847);
        this.mirroringShapeCharacters.setValue(8849, 8850);
        this.mirroringShapeCharacters.setValue(8850, 8849);
        this.mirroringShapeCharacters.setValue(8856, 10680);
        this.mirroringShapeCharacters.setValue(8866, 8867);
        this.mirroringShapeCharacters.setValue(8867, 8866);
        this.mirroringShapeCharacters.setValue(8870, 10974);
        this.mirroringShapeCharacters.setValue(8872, 10980);
        this.mirroringShapeCharacters.setValue(8873, 10979);
        this.mirroringShapeCharacters.setValue(8875, 10981);
        this.mirroringShapeCharacters.setValue(8880, 8881);
        this.mirroringShapeCharacters.setValue(8881, 8880);
        this.mirroringShapeCharacters.setValue(8882, 8883);
        this.mirroringShapeCharacters.setValue(8883, 8882);
        this.mirroringShapeCharacters.setValue(8884, 8885);
        this.mirroringShapeCharacters.setValue(8885, 8884);
        /*tslint:disable:max-func-body-length */ this.mirroringShapeCharacters.setValue(8886, 8887);
        this.mirroringShapeCharacters.setValue(8887, 8886);
        this.mirroringShapeCharacters.setValue(8905, 8906);
        this.mirroringShapeCharacters.setValue(8906, 8905);
        this.mirroringShapeCharacters.setValue(8907, 8908);
        this.mirroringShapeCharacters.setValue(8908, 8907);
        this.mirroringShapeCharacters.setValue(8909, 8771);
        this.mirroringShapeCharacters.setValue(8912, 8913);
        this.mirroringShapeCharacters.setValue(8913, 8912);
        this.mirroringShapeCharacters.setValue(8918, 8919);
        this.mirroringShapeCharacters.setValue(8919, 8918);
        this.mirroringShapeCharacters.setValue(8920, 8921);
        this.mirroringShapeCharacters.setValue(8921, 8920);
        this.mirroringShapeCharacters.setValue(8922, 8923);
        this.mirroringShapeCharacters.setValue(8923, 8922);
        this.mirroringShapeCharacters.setValue(8924, 8925);
        this.mirroringShapeCharacters.setValue(8925, 8924);
        this.mirroringShapeCharacters.setValue(8926, 8927);
        this.mirroringShapeCharacters.setValue(8927, 8926);
        this.mirroringShapeCharacters.setValue(8928, 8929);
        this.mirroringShapeCharacters.setValue(8929, 8928);
        this.mirroringShapeCharacters.setValue(8930, 8931);
        this.mirroringShapeCharacters.setValue(8931, 8930);
        this.mirroringShapeCharacters.setValue(8932, 8933);
        this.mirroringShapeCharacters.setValue(8933, 8932);
        this.mirroringShapeCharacters.setValue(8934, 8935);
        this.mirroringShapeCharacters.setValue(8935, 8934);
        this.mirroringShapeCharacters.setValue(8936, 8937);
        this.mirroringShapeCharacters.setValue(8937, 8936);
        this.mirroringShapeCharacters.setValue(8938, 8939);
        this.mirroringShapeCharacters.setValue(8939, 8938);
        this.mirroringShapeCharacters.setValue(8940, 8941);
        this.mirroringShapeCharacters.setValue(8941, 8940);
        this.mirroringShapeCharacters.setValue(8944, 8945);
        this.mirroringShapeCharacters.setValue(8945, 8944);
        this.mirroringShapeCharacters.setValue(8946, 8954);
        this.mirroringShapeCharacters.setValue(8947, 8955);
        this.mirroringShapeCharacters.setValue(8948, 8956);
        this.mirroringShapeCharacters.setValue(8950, 8957);
        this.mirroringShapeCharacters.setValue(8951, 8958);
        this.mirroringShapeCharacters.setValue(8954, 8946);
        this.mirroringShapeCharacters.setValue(8955, 8947);
        this.mirroringShapeCharacters.setValue(8956, 8948);
        this.mirroringShapeCharacters.setValue(8957, 8950);
        this.mirroringShapeCharacters.setValue(8958, 8951);
        this.mirroringShapeCharacters.setValue(8968, 8969);
        this.mirroringShapeCharacters.setValue(8969, 8968);
        this.mirroringShapeCharacters.setValue(8970, 8971);
        this.mirroringShapeCharacters.setValue(8971, 8970);
        this.mirroringShapeCharacters.setValue(9001, 9002);
        this.mirroringShapeCharacters.setValue(9002, 9001);
        this.mirroringShapeCharacters.setValue(10088, 10089);
        this.mirroringShapeCharacters.setValue(10089, 10088);
        this.mirroringShapeCharacters.setValue(10090, 10091);
        this.mirroringShapeCharacters.setValue(10091, 10090);
        this.mirroringShapeCharacters.setValue(10092, 10093);
        this.mirroringShapeCharacters.setValue(10093, 10092);
        this.mirroringShapeCharacters.setValue(10094, 10095);
        this.mirroringShapeCharacters.setValue(10095, 10094);
        this.mirroringShapeCharacters.setValue(10096, 10097);
        this.mirroringShapeCharacters.setValue(10097, 10096);
        this.mirroringShapeCharacters.setValue(10098, 10099);
        this.mirroringShapeCharacters.setValue(10099, 10098);
        this.mirroringShapeCharacters.setValue(10100, 10101);
        this.mirroringShapeCharacters.setValue(10101, 10100);
        this.mirroringShapeCharacters.setValue(10197, 10198);
        this.mirroringShapeCharacters.setValue(10198, 10197);
        this.mirroringShapeCharacters.setValue(10205, 10206);
        this.mirroringShapeCharacters.setValue(10206, 10205);
        this.mirroringShapeCharacters.setValue(10210, 10211);
        this.mirroringShapeCharacters.setValue(10211, 10210);
        this.mirroringShapeCharacters.setValue(10212, 10213);
        this.mirroringShapeCharacters.setValue(10213, 10212);
        this.mirroringShapeCharacters.setValue(10214, 10215);
        this.mirroringShapeCharacters.setValue(10215, 10214);
        this.mirroringShapeCharacters.setValue(10216, 10217);
        this.mirroringShapeCharacters.setValue(10217, 10216);
        this.mirroringShapeCharacters.setValue(10218, 10219);
        this.mirroringShapeCharacters.setValue(10219, 10218);
        this.mirroringShapeCharacters.setValue(10627, 10628);
        this.mirroringShapeCharacters.setValue(10628, 10627);
        this.mirroringShapeCharacters.setValue(10629, 10630);
        this.mirroringShapeCharacters.setValue(10630, 10629);
        this.mirroringShapeCharacters.setValue(10631, 10632);
        this.mirroringShapeCharacters.setValue(10632, 10631);
        this.mirroringShapeCharacters.setValue(10633, 10634);
        this.mirroringShapeCharacters.setValue(10634, 10633);
        this.mirroringShapeCharacters.setValue(10635, 10636);
        this.mirroringShapeCharacters.setValue(10636, 10635);
        this.mirroringShapeCharacters.setValue(10637, 10640);
        this.mirroringShapeCharacters.setValue(10638, 10639);
        this.mirroringShapeCharacters.setValue(10639, 10638);
        this.mirroringShapeCharacters.setValue(10640, 10637);
        this.mirroringShapeCharacters.setValue(10641, 10642);
        this.mirroringShapeCharacters.setValue(10642, 10641);
        this.mirroringShapeCharacters.setValue(10643, 10644);
        this.mirroringShapeCharacters.setValue(10644, 10643);
        this.mirroringShapeCharacters.setValue(10645, 10646);
        this.mirroringShapeCharacters.setValue(10646, 10645);
        this.mirroringShapeCharacters.setValue(10647, 10648);
        this.mirroringShapeCharacters.setValue(10648, 10647);
        this.mirroringShapeCharacters.setValue(10680, 8856);
        this.mirroringShapeCharacters.setValue(10688, 10689);
        this.mirroringShapeCharacters.setValue(10689, 10688);
        this.mirroringShapeCharacters.setValue(10692, 10693);
        this.mirroringShapeCharacters.setValue(10693, 10692);
        this.mirroringShapeCharacters.setValue(10703, 10704);
        this.mirroringShapeCharacters.setValue(10704, 10703);
        this.mirroringShapeCharacters.setValue(10705, 10706);
        this.mirroringShapeCharacters.setValue(10706, 10705);
        this.mirroringShapeCharacters.setValue(10708, 10709);
        this.mirroringShapeCharacters.setValue(10709, 10708);
        this.mirroringShapeCharacters.setValue(10712, 10713);
        this.mirroringShapeCharacters.setValue(10713, 10712);
        this.mirroringShapeCharacters.setValue(10714, 10715);
        this.mirroringShapeCharacters.setValue(10715, 10714);
        this.mirroringShapeCharacters.setValue(10741, 8725);
        this.mirroringShapeCharacters.setValue(10744, 10745);
        this.mirroringShapeCharacters.setValue(10745, 10744);
        this.mirroringShapeCharacters.setValue(10748, 10749);
        this.mirroringShapeCharacters.setValue(10749, 10748);
        this.mirroringShapeCharacters.setValue(10795, 10796);
        this.mirroringShapeCharacters.setValue(10796, 10795);
        this.mirroringShapeCharacters.setValue(10797, 10796);
        this.mirroringShapeCharacters.setValue(10798, 10797);
        this.mirroringShapeCharacters.setValue(10804, 10805);
        this.mirroringShapeCharacters.setValue(10805, 10804);
        this.mirroringShapeCharacters.setValue(10812, 10813);
        this.mirroringShapeCharacters.setValue(10813, 10812);
        this.mirroringShapeCharacters.setValue(10852, 10853);
        this.mirroringShapeCharacters.setValue(10853, 10852);
        this.mirroringShapeCharacters.setValue(10873, 10874);
        this.mirroringShapeCharacters.setValue(10874, 10873);
        this.mirroringShapeCharacters.setValue(10877, 10878);
        this.mirroringShapeCharacters.setValue(10878, 10877);
        this.mirroringShapeCharacters.setValue(10879, 10880);
        this.mirroringShapeCharacters.setValue(10880, 10879);
        this.mirroringShapeCharacters.setValue(10881, 10882);
        this.mirroringShapeCharacters.setValue(10882, 10881);
        this.mirroringShapeCharacters.setValue(10883, 10884);
        this.mirroringShapeCharacters.setValue(10884, 10883);
        this.mirroringShapeCharacters.setValue(10891, 10892);
        this.mirroringShapeCharacters.setValue(10892, 10891);
        this.mirroringShapeCharacters.setValue(10897, 10898);
        this.mirroringShapeCharacters.setValue(10898, 10897);
        this.mirroringShapeCharacters.setValue(10899, 10900);
        this.mirroringShapeCharacters.setValue(10900, 10899);
        this.mirroringShapeCharacters.setValue(10901, 10902);
        this.mirroringShapeCharacters.setValue(10902, 10901);
        this.mirroringShapeCharacters.setValue(10903, 10904);
        this.mirroringShapeCharacters.setValue(10904, 10903);
        this.mirroringShapeCharacters.setValue(10905, 10906);
        this.mirroringShapeCharacters.setValue(10906, 10905);
        this.mirroringShapeCharacters.setValue(10907, 10908);
        this.mirroringShapeCharacters.setValue(10908, 10907);
        this.mirroringShapeCharacters.setValue(10913, 10914);
        this.mirroringShapeCharacters.setValue(10914, 10913);
        this.mirroringShapeCharacters.setValue(10918, 10919);
        this.mirroringShapeCharacters.setValue(10919, 10918);
        this.mirroringShapeCharacters.setValue(10920, 10921);
        this.mirroringShapeCharacters.setValue(10921, 10920);
        this.mirroringShapeCharacters.setValue(10922, 10923);
        this.mirroringShapeCharacters.setValue(10923, 10922);
        this.mirroringShapeCharacters.setValue(10924, 10925);
        this.mirroringShapeCharacters.setValue(10925, 10924);
        this.mirroringShapeCharacters.setValue(10927, 10928);
        this.mirroringShapeCharacters.setValue(10928, 10927);
        this.mirroringShapeCharacters.setValue(10931, 10932);
        this.mirroringShapeCharacters.setValue(10932, 10931);
        this.mirroringShapeCharacters.setValue(10939, 10940);
        this.mirroringShapeCharacters.setValue(10940, 10939);
        this.mirroringShapeCharacters.setValue(10941, 10942);
        this.mirroringShapeCharacters.setValue(10942, 10941);
        this.mirroringShapeCharacters.setValue(10943, 10944);
        this.mirroringShapeCharacters.setValue(10944, 10943);
        this.mirroringShapeCharacters.setValue(10945, 10946);
        this.mirroringShapeCharacters.setValue(10946, 10945);
        this.mirroringShapeCharacters.setValue(10947, 10948);
        this.mirroringShapeCharacters.setValue(10948, 10947);
        this.mirroringShapeCharacters.setValue(10949, 10950);
        this.mirroringShapeCharacters.setValue(10950, 10949);
        this.mirroringShapeCharacters.setValue(10957, 10958);
        this.mirroringShapeCharacters.setValue(10958, 10957);
        this.mirroringShapeCharacters.setValue(10959, 10960);
        this.mirroringShapeCharacters.setValue(10960, 10959);
        this.mirroringShapeCharacters.setValue(10961, 10962);
        this.mirroringShapeCharacters.setValue(10962, 10961);
        this.mirroringShapeCharacters.setValue(10963, 10964);
        this.mirroringShapeCharacters.setValue(10964, 10963);
        this.mirroringShapeCharacters.setValue(10965, 10966);
        this.mirroringShapeCharacters.setValue(10966, 10965);
        this.mirroringShapeCharacters.setValue(10974, 8870);
        this.mirroringShapeCharacters.setValue(10979, 8873);
        this.mirroringShapeCharacters.setValue(10980, 8872);
        this.mirroringShapeCharacters.setValue(10981, 8875);
        this.mirroringShapeCharacters.setValue(10988, 10989);
        this.mirroringShapeCharacters.setValue(10989, 10988);
        this.mirroringShapeCharacters.setValue(10999, 11000);
        this.mirroringShapeCharacters.setValue(11000, 10999);
        this.mirroringShapeCharacters.setValue(11001, 11002);
        this.mirroringShapeCharacters.setValue(11002, 11001);
        this.mirroringShapeCharacters.setValue(12296, 12297);
        this.mirroringShapeCharacters.setValue(12297, 12296);
        this.mirroringShapeCharacters.setValue(12298, 12299);
        this.mirroringShapeCharacters.setValue(12299, 12298);
        this.mirroringShapeCharacters.setValue(12300, 12301);
        this.mirroringShapeCharacters.setValue(12301, 12300);
        this.mirroringShapeCharacters.setValue(12302, 12303);
        this.mirroringShapeCharacters.setValue(12303, 12302);
        this.mirroringShapeCharacters.setValue(12304, 12305);
        this.mirroringShapeCharacters.setValue(12305, 12304);
        this.mirroringShapeCharacters.setValue(12308, 12309);
        this.mirroringShapeCharacters.setValue(12309, 12308);
        this.mirroringShapeCharacters.setValue(12310, 12311);
        this.mirroringShapeCharacters.setValue(12311, 12310);
        this.mirroringShapeCharacters.setValue(12312, 12313);
        this.mirroringShapeCharacters.setValue(12313, 12312);
        this.mirroringShapeCharacters.setValue(12314, 12315);
        this.mirroringShapeCharacters.setValue(12315, 12314);
        this.mirroringShapeCharacters.setValue(65288, 65289);
        this.mirroringShapeCharacters.setValue(65289, 65288);
        this.mirroringShapeCharacters.setValue(65308, 65310);
        this.mirroringShapeCharacters.setValue(65310, 65308);
        this.mirroringShapeCharacters.setValue(65339, 65341);
        this.mirroringShapeCharacters.setValue(65341, 65339);
        this.mirroringShapeCharacters.setValue(65371, 65373);
        this.mirroringShapeCharacters.setValue(65373, 65371);
        this.mirroringShapeCharacters.setValue(65375, 65376);
        this.mirroringShapeCharacters.setValue(65376, 65375);
        this.mirroringShapeCharacters.setValue(65378, 65379);
        this.mirroringShapeCharacters.setValue(65379, 65378);
    };
    return Bidi;
}();
var $8d6c280e77b82d6f$export$74e04eb940f505b4 = /** @class */ function() {
    //#endregion
    //#region constructors
    function RtlCharacters() {
        //#region fields
        /// <summary>
        /// Specifies the character types.
        /// </summary>
        this.types = [];
        /// <summary>
        /// Specifies the text order (RTL or LTR).
        /// </summary>
        this.textOrder = -1;
        /// <summary>
        /// Specifies the RTL character types.
        /// </summary>
        /* tslint:disable-next-line:prefer-array-literal */ this.rtlCharacterTypes = new Array(65536);
        //#endregion
        //#region constants
        /// <summary>
        /// Left-to-Right (Non-European or non-Arabic digits).
        /// </summary>
        this.L = 0;
        /// <summary>
        /// Left-to-Right Embedding
        /// </summary>
        this.LRE = 1;
        /// <summary>
        /// Left-to-Right Override
        /// </summary>
        this.LRO = 2;
        /// <summary>
        /// Right-to-Left (Hebrew alphabet, and related punctuation).
        /// </summary>
        this.R = 3;
        /// <summary>
        /// Right-to-Left Arabic 
        /// </summary>
        this.AL = 4;
        /// <summary>
        /// Right-to-Left Embedding.
        /// </summary>
        this.RLE = 5;
        /// <summary>
        /// Right-to-Left Override
        /// </summary>
        this.RLO = 6;
        /// <summary>
        /// Pop Directional Format
        /// </summary>
        this.PDF = 7;
        /// <summary>
        /// European Number (European digits, Eastern Arabic-Indic digits).
        /// </summary>
        this.EN = 8;
        /// <summary>
        /// European Number Separator (Plus sign, Minus sign).
        /// </summary>
        this.ES = 9;
        /// <summary>
        /// European Number Terminator (Degree sign, currency symbols).
        /// </summary>
        this.ET = 10;
        /// <summary>
        /// Arabic Number (Arabic-Indic digits, Arabic decimal and thousands separators).
        /// </summary>
        this.AN = 11;
        /// <summary>
        /// Common Number Separator (Colon, Comma, Full Stop, No-Break Space.
        /// </summary>
        this.CS = 12;
        /// <summary>
        /// Nonspacing Mark (Characters with the General_Category values).
        /// </summary>
        this.NSM = 13;
        /// <summary>
        /// Boundary Neutral (Default ignorables, non-characters, and control characters, other than those explicitly given other types.)
        /// </summary>
        this.BN = 14;
        /// <summary>
        /// Paragraph Separator (Paragraph separator, appropriate Newline Functions, higher-level protocol paragraph determination).
        /// </summary>
        this.B = 15;
        /// <summary>
        /// 	Segment Separator (tab).
        /// </summary>
        this.S = 16;
        /// <summary>
        /// Whitespace (Space, Figure space, Line separator, Form feed, General Punctuation spaces).
        /// </summary>
        this.WS = 17;
        /// <summary>
        /// Other Neutrals (All other characters, including object replacement character).
        /// </summary>
        this.ON = 18;
        /// <summary>
        /// RTL character types.
        /// </summary>
        this.charTypes = [
            this.L,
            this.EN,
            this.BN,
            this.ES,
            this.ES,
            this.S,
            this.ET,
            this.ET,
            this.B,
            this.AN,
            this.AN,
            this.S,
            this.CS,
            this.CS,
            this.WS,
            this.NSM,
            this.NSM,
            this.B,
            this.BN,
            27,
            this.BN,
            28,
            30,
            this.B,
            31,
            31,
            this.S,
            32,
            32,
            this.WS,
            33,
            34,
            this.ON,
            35,
            37,
            this.ET,
            38,
            42,
            this.ON,
            43,
            43,
            this.ET,
            44,
            44,
            this.CS,
            45,
            45,
            this.ET,
            46,
            46,
            this.CS,
            47,
            47,
            this.CS,
            48,
            57,
            this.EN,
            58,
            58,
            this.CS,
            59,
            64,
            this.ON,
            65,
            90,
            this.L,
            91,
            96,
            this.ON,
            97,
            122,
            this.L,
            123,
            126,
            this.ON,
            127,
            132,
            this.BN,
            133,
            133,
            this.B,
            134,
            159,
            this.BN,
            160,
            160,
            this.CS,
            161,
            161,
            this.ON,
            162,
            165,
            this.ET,
            166,
            169,
            this.ON,
            170,
            170,
            this.L,
            171,
            175,
            this.ON,
            176,
            177,
            this.ET,
            178,
            179,
            this.EN,
            180,
            180,
            this.ON,
            181,
            181,
            this.L,
            182,
            184,
            this.ON,
            185,
            185,
            this.EN,
            186,
            186,
            this.L,
            187,
            191,
            this.ON,
            192,
            214,
            this.L,
            215,
            215,
            this.ON,
            216,
            246,
            this.L,
            247,
            247,
            this.ON,
            248,
            696,
            this.L,
            697,
            698,
            this.ON,
            699,
            705,
            this.L,
            706,
            719,
            this.ON,
            720,
            721,
            this.L,
            722,
            735,
            this.ON,
            736,
            740,
            this.L,
            741,
            749,
            this.ON,
            750,
            750,
            this.L,
            751,
            767,
            this.ON,
            768,
            855,
            this.NSM,
            856,
            860,
            this.L,
            861,
            879,
            this.NSM,
            880,
            883,
            this.L,
            884,
            885,
            this.ON,
            886,
            893,
            this.L,
            894,
            894,
            this.ON,
            895,
            899,
            this.L,
            900,
            901,
            this.ON,
            902,
            902,
            this.L,
            903,
            903,
            this.ON,
            904,
            1013,
            this.L,
            1014,
            1014,
            this.ON,
            1015,
            1154,
            this.L,
            1155,
            1158,
            this.NSM,
            1159,
            1159,
            this.L,
            1160,
            1161,
            this.NSM,
            1162,
            1417,
            this.L,
            1418,
            1418,
            this.ON,
            1419,
            1424,
            this.L,
            1425,
            1441,
            this.NSM,
            1442,
            1442,
            this.L,
            1443,
            1465,
            this.NSM,
            1466,
            1466,
            this.L,
            1467,
            1469,
            this.NSM,
            1470,
            1470,
            this.R,
            1471,
            1471,
            this.NSM,
            1472,
            1472,
            this.R,
            1473,
            1474,
            this.NSM,
            1475,
            1475,
            this.R,
            1476,
            1476,
            this.NSM,
            1477,
            1487,
            this.L,
            1488,
            1514,
            this.R,
            1515,
            1519,
            this.L,
            1520,
            1524,
            this.R,
            1525,
            1535,
            this.L,
            1536,
            1539,
            this.AL,
            1540,
            1547,
            this.L,
            1548,
            1548,
            this.CS,
            1549,
            1549,
            this.AL,
            1550,
            1551,
            this.ON,
            1552,
            1557,
            this.NSM,
            1558,
            1562,
            this.L,
            1563,
            1563,
            this.AL,
            1564,
            1566,
            this.L,
            1567,
            1567,
            this.AL,
            1568,
            1568,
            this.L,
            1569,
            1594,
            this.AL,
            1595,
            1599,
            this.L,
            1600,
            1610,
            this.AL,
            1611,
            1624,
            this.NSM,
            1625,
            1631,
            this.L,
            1632,
            1641,
            this.AN,
            1642,
            1642,
            this.ET,
            1643,
            1644,
            this.AN,
            1645,
            1647,
            this.AL,
            1648,
            1648,
            this.NSM,
            1649,
            1749,
            this.AL,
            1750,
            1756,
            this.NSM,
            1757,
            1757,
            this.AL,
            1758,
            1764,
            this.NSM,
            1765,
            1766,
            this.AL,
            1767,
            1768,
            this.NSM,
            1769,
            1769,
            this.ON,
            1770,
            1773,
            this.NSM,
            1774,
            1775,
            this.AL,
            1776,
            1785,
            this.EN,
            1786,
            1805,
            this.AL,
            1806,
            1806,
            this.L,
            1807,
            1807,
            this.BN,
            1808,
            1808,
            this.AL,
            1809,
            1809,
            this.NSM,
            1810,
            1839,
            this.AL,
            1840,
            1866,
            this.NSM,
            1867,
            1868,
            this.L,
            1869,
            1871,
            this.AL,
            1872,
            1919,
            this.L,
            1920,
            1957,
            this.AL,
            1958,
            1968,
            this.NSM,
            1969,
            1969,
            this.AL,
            1970,
            2304,
            this.L,
            2305,
            2306,
            this.NSM,
            2307,
            2363,
            this.L,
            2364,
            2364,
            this.NSM,
            2365,
            2368,
            this.L,
            2369,
            2376,
            this.NSM,
            2377,
            2380,
            this.L,
            2381,
            2381,
            this.NSM,
            2382,
            2384,
            this.L,
            2385,
            2388,
            this.NSM,
            2389,
            2401,
            this.L,
            2402,
            2403,
            this.NSM,
            2404,
            2432,
            this.L,
            2433,
            2433,
            this.NSM,
            2434,
            2491,
            this.L,
            2492,
            2492,
            this.NSM,
            2493,
            2496,
            this.L,
            2497,
            2500,
            this.NSM,
            2501,
            2508,
            this.L,
            2509,
            2509,
            this.NSM,
            2510,
            2529,
            this.L,
            2530,
            2531,
            this.NSM,
            2532,
            2545,
            this.L,
            2546,
            2547,
            this.ET,
            2548,
            2560,
            this.L,
            2561,
            2562,
            this.NSM,
            2563,
            2619,
            this.L,
            2620,
            2620,
            this.NSM,
            2621,
            2624,
            this.L,
            2625,
            2626,
            this.NSM,
            2627,
            2630,
            this.L,
            2631,
            2632,
            this.NSM,
            2633,
            2634,
            this.L,
            2635,
            2637,
            this.NSM,
            2638,
            2671,
            this.L,
            2672,
            2673,
            this.NSM,
            2674,
            2688,
            this.L,
            2689,
            2690,
            this.NSM,
            2691,
            2747,
            this.L,
            2748,
            2748,
            this.NSM,
            2749,
            2752,
            this.L,
            2753,
            2757,
            this.NSM,
            2758,
            2758,
            this.L,
            2759,
            2760,
            this.NSM,
            2761,
            2764,
            this.L,
            2765,
            2765,
            this.NSM,
            2766,
            2785,
            this.L,
            2786,
            2787,
            this.NSM,
            2788,
            2800,
            this.L,
            2801,
            2801,
            this.ET,
            2802,
            2816,
            this.L,
            2817,
            2817,
            this.NSM,
            2818,
            2875,
            this.L,
            2876,
            2876,
            this.NSM,
            2877,
            2878,
            this.L,
            2879,
            2879,
            this.NSM,
            2880,
            2880,
            this.L,
            2881,
            2883,
            this.NSM,
            2884,
            2892,
            this.L,
            2893,
            2893,
            this.NSM,
            2894,
            2901,
            this.L,
            2902,
            2902,
            this.NSM,
            2903,
            2945,
            this.L,
            2946,
            2946,
            this.NSM,
            2947,
            3007,
            this.L,
            3008,
            3008,
            this.NSM,
            3009,
            3020,
            this.L,
            3021,
            3021,
            this.NSM,
            3022,
            3058,
            this.L,
            3059,
            3064,
            this.ON,
            3065,
            3065,
            this.ET,
            3066,
            3066,
            this.ON,
            3067,
            3133,
            this.L,
            3134,
            3136,
            this.NSM,
            3137,
            3141,
            this.L,
            3142,
            3144,
            this.NSM,
            3145,
            3145,
            this.L,
            3146,
            3149,
            this.NSM,
            3150,
            3156,
            this.L,
            3157,
            3158,
            this.NSM,
            3159,
            3259,
            this.L,
            3260,
            3260,
            this.NSM,
            3261,
            3275,
            this.L,
            3276,
            3277,
            this.NSM,
            3278,
            3392,
            this.L,
            3393,
            3395,
            this.NSM,
            3396,
            3404,
            this.L,
            3405,
            3405,
            this.NSM,
            3406,
            3529,
            this.L,
            3530,
            3530,
            this.NSM,
            3531,
            3537,
            this.L,
            3538,
            3540,
            this.NSM,
            3541,
            3541,
            this.L,
            3542,
            3542,
            this.NSM,
            3543,
            3632,
            this.L,
            3633,
            3633,
            this.NSM,
            3634,
            3635,
            this.L,
            3636,
            3642,
            this.NSM,
            3643,
            3646,
            this.L,
            3647,
            3647,
            this.ET,
            3648,
            3654,
            this.L,
            3655,
            3662,
            this.NSM,
            3663,
            3760,
            this.L,
            3761,
            3761,
            this.NSM,
            3762,
            3763,
            this.L,
            3764,
            3769,
            this.NSM,
            3770,
            3770,
            this.L,
            3771,
            3772,
            this.NSM,
            3773,
            3783,
            this.L,
            3784,
            3789,
            this.NSM,
            3790,
            3863,
            this.L,
            3864,
            3865,
            this.NSM,
            3866,
            3892,
            this.L,
            3893,
            3893,
            this.NSM,
            3894,
            3894,
            this.L,
            3895,
            3895,
            this.NSM,
            3896,
            3896,
            this.L,
            3897,
            3897,
            this.NSM,
            3898,
            3901,
            this.ON,
            3902,
            3952,
            this.L,
            3953,
            3966,
            this.NSM,
            3967,
            3967,
            this.L,
            3968,
            3972,
            this.NSM,
            3973,
            3973,
            this.L,
            3974,
            3975,
            this.NSM,
            3976,
            3983,
            this.L,
            3984,
            3991,
            this.NSM,
            3992,
            3992,
            this.L,
            3993,
            4028,
            this.NSM,
            4029,
            4037,
            this.L,
            4038,
            4038,
            this.NSM,
            4039,
            4140,
            this.L,
            4141,
            4144,
            this.NSM,
            4145,
            4145,
            this.L,
            4146,
            4146,
            this.NSM,
            4147,
            4149,
            this.L,
            4150,
            4151,
            this.NSM,
            4152,
            4152,
            this.L,
            4153,
            4153,
            this.NSM,
            4154,
            4183,
            this.L,
            4184,
            4185,
            this.NSM,
            4186,
            5759,
            this.L,
            5760,
            5760,
            this.WS,
            5761,
            5786,
            this.L,
            5787,
            5788,
            this.ON,
            5789,
            5905,
            this.L,
            5906,
            5908,
            this.NSM,
            5909,
            5937,
            this.L,
            5938,
            5940,
            this.NSM,
            5941,
            5969,
            this.L,
            5970,
            5971,
            this.NSM,
            5972,
            6001,
            this.L,
            6002,
            6003,
            this.NSM,
            6004,
            6070,
            this.L,
            6071,
            6077,
            this.NSM,
            6078,
            6085,
            this.L,
            6086,
            6086,
            this.NSM,
            6087,
            6088,
            this.L,
            6089,
            6099,
            this.NSM,
            6100,
            6106,
            this.L,
            6107,
            6107,
            this.ET,
            6108,
            6108,
            this.L,
            6109,
            6109,
            this.NSM,
            6110,
            6127,
            this.L,
            6128,
            6137,
            this.ON,
            6138,
            6143,
            this.L,
            6144,
            6154,
            this.ON,
            6155,
            6157,
            this.NSM,
            6158,
            6158,
            this.WS,
            6159,
            6312,
            this.L,
            6313,
            6313,
            this.NSM,
            6314,
            6431,
            this.L,
            6432,
            6434,
            this.NSM,
            6435,
            6438,
            this.L,
            6439,
            6443,
            this.NSM,
            6444,
            6449,
            this.L,
            6450,
            6450,
            this.NSM,
            6451,
            6456,
            this.L,
            6457,
            6459,
            this.NSM,
            6460,
            6463,
            this.L,
            6464,
            6464,
            this.ON,
            6465,
            6467,
            this.L,
            6468,
            6469,
            this.ON,
            6470,
            6623,
            this.L,
            6624,
            6655,
            this.ON,
            6656,
            8124,
            this.L,
            8125,
            8125,
            this.ON,
            8126,
            8126,
            this.L,
            8127,
            8129,
            this.ON,
            8130,
            8140,
            this.L,
            8141,
            8143,
            this.ON,
            8144,
            8156,
            this.L,
            8157,
            8159,
            this.ON,
            8160,
            8172,
            this.L,
            8173,
            8175,
            this.ON,
            8176,
            8188,
            this.L,
            8189,
            8190,
            this.ON,
            8191,
            8191,
            this.L,
            8192,
            8202,
            this.WS,
            8203,
            8205,
            this.BN,
            8206,
            8206,
            this.L,
            8207,
            8207,
            this.R,
            8208,
            8231,
            this.ON,
            8232,
            8232,
            this.WS,
            8233,
            8233,
            this.B,
            8234,
            8234,
            this.LRE,
            8235,
            8235,
            this.RLE,
            8236,
            8236,
            this.PDF,
            8237,
            8237,
            this.LRO,
            8238,
            8238,
            this.RLO,
            8239,
            8239,
            this.WS,
            8240,
            8244,
            this.ET,
            8245,
            8276,
            this.ON,
            8277,
            8278,
            this.L,
            8279,
            8279,
            this.ON,
            8280,
            8286,
            this.L,
            8287,
            8287,
            this.WS,
            8288,
            8291,
            this.BN,
            8292,
            8297,
            this.L,
            8298,
            8303,
            this.BN,
            8304,
            8304,
            this.EN,
            8305,
            8307,
            this.L,
            8308,
            8313,
            this.EN,
            8314,
            8315,
            this.ET,
            8316,
            8318,
            this.ON,
            8319,
            8319,
            this.L,
            8320,
            8329,
            this.EN,
            8330,
            8331,
            this.ET,
            8332,
            8334,
            this.ON,
            8335,
            8351,
            this.L,
            8352,
            8369,
            this.ET,
            8370,
            8399,
            this.L,
            8400,
            8426,
            this.NSM,
            8427,
            8447,
            this.L,
            8448,
            8449,
            this.ON,
            8450,
            8450,
            this.L,
            8451,
            8454,
            this.ON,
            8455,
            8455,
            this.L,
            8456,
            8457,
            this.ON,
            8458,
            8467,
            this.L,
            8468,
            8468,
            this.ON,
            8469,
            8469,
            this.L,
            8470,
            8472,
            this.ON,
            8473,
            8477,
            this.L,
            8478,
            8483,
            this.ON,
            8484,
            8484,
            this.L,
            8485,
            8485,
            this.ON,
            8486,
            8486,
            this.L,
            8487,
            8487,
            this.ON,
            8488,
            8488,
            this.L,
            8489,
            8489,
            this.ON,
            8490,
            8493,
            this.L,
            8494,
            8494,
            this.ET,
            8495,
            8497,
            this.L,
            8498,
            8498,
            this.ON,
            8499,
            8505,
            this.L,
            8506,
            8507,
            this.ON,
            8508,
            8511,
            this.L,
            8512,
            8516,
            this.ON,
            8517,
            8521,
            this.L,
            8522,
            8523,
            this.ON,
            8524,
            8530,
            this.L,
            8531,
            8543,
            this.ON,
            8544,
            8591,
            this.L,
            8592,
            8721,
            this.ON,
            8722,
            8723,
            this.ET,
            8724,
            9013,
            this.ON,
            9014,
            9082,
            this.L,
            9083,
            9108,
            this.ON,
            9109,
            9109,
            this.L,
            9110,
            9168,
            this.ON,
            9169,
            9215,
            this.L,
            9216,
            9254,
            this.ON,
            9255,
            9279,
            this.L,
            9280,
            9290,
            this.ON,
            9291,
            9311,
            this.L,
            9312,
            9371,
            this.EN,
            9372,
            9449,
            this.L,
            9450,
            9450,
            this.EN,
            9451,
            9751,
            this.ON,
            9752,
            9752,
            this.L,
            9753,
            9853,
            this.ON,
            9854,
            9855,
            this.L,
            9856,
            9873,
            this.ON,
            9874,
            9887,
            this.L,
            9888,
            9889,
            this.ON,
            9890,
            9984,
            this.L,
            9985,
            9988,
            this.ON,
            9989,
            9989,
            this.L,
            9990,
            9993,
            this.ON,
            9994,
            9995,
            this.L,
            9996,
            10023,
            this.ON,
            10024,
            10024,
            this.L,
            10025,
            10059,
            this.ON,
            10060,
            10060,
            this.L,
            10061,
            10061,
            this.ON,
            10062,
            10062,
            this.L,
            10063,
            10066,
            this.ON,
            10067,
            10069,
            this.L,
            10070,
            10070,
            this.ON,
            10071,
            10071,
            this.L,
            10072,
            10078,
            this.ON,
            10079,
            10080,
            this.L,
            10081,
            10132,
            this.ON,
            10133,
            10135,
            this.L,
            10136,
            10159,
            this.ON,
            10160,
            10160,
            this.L,
            10161,
            10174,
            this.ON,
            10175,
            10191,
            this.L,
            10192,
            10219,
            this.ON,
            10220,
            10223,
            this.L,
            10224,
            11021,
            this.ON,
            11022,
            11903,
            this.L,
            11904,
            11929,
            this.ON,
            11930,
            11930,
            this.L,
            11931,
            12019,
            this.ON,
            12020,
            12031,
            this.L,
            12032,
            12245,
            this.ON,
            12246,
            12271,
            this.L,
            12272,
            12283,
            this.ON,
            12284,
            12287,
            this.L,
            12288,
            12288,
            this.WS,
            12289,
            12292,
            this.ON,
            12293,
            12295,
            this.L,
            12296,
            12320,
            this.ON,
            12321,
            12329,
            this.L,
            12330,
            12335,
            this.NSM,
            12336,
            12336,
            this.ON,
            12337,
            12341,
            this.L,
            12342,
            12343,
            this.ON,
            12344,
            12348,
            this.L,
            12349,
            12351,
            this.ON,
            12352,
            12440,
            this.L,
            12441,
            12442,
            this.NSM,
            12443,
            12444,
            this.ON,
            12445,
            12447,
            this.L,
            12448,
            12448,
            this.ON,
            12449,
            12538,
            this.L,
            12539,
            12539,
            this.ON,
            12540,
            12828,
            this.L,
            12829,
            12830,
            this.ON,
            12831,
            12879,
            this.L,
            12880,
            12895,
            this.ON,
            12896,
            12923,
            this.L,
            12924,
            12925,
            this.ON,
            12926,
            12976,
            this.L,
            12977,
            12991,
            this.ON,
            12992,
            13003,
            this.L,
            13004,
            13007,
            this.ON,
            13008,
            13174,
            this.L,
            13175,
            13178,
            this.ON,
            13179,
            13277,
            this.L,
            13278,
            13279,
            this.ON,
            13280,
            13310,
            this.L,
            13311,
            13311,
            this.ON,
            13312,
            19903,
            this.L,
            19904,
            19967,
            this.ON,
            19968,
            42127,
            this.L,
            42128,
            42182,
            this.ON,
            42183,
            64284,
            this.L,
            64285,
            64285,
            this.R,
            64286,
            64286,
            this.NSM,
            64287,
            64296,
            this.R,
            64297,
            64297,
            this.ET,
            64298,
            64310,
            this.R,
            64311,
            64311,
            this.L,
            64312,
            64316,
            this.R,
            64317,
            64317,
            this.L,
            64318,
            64318,
            this.R,
            64319,
            64319,
            this.L,
            64320,
            64321,
            this.R,
            64322,
            64322,
            this.L,
            64323,
            64324,
            this.R,
            64325,
            64325,
            this.L,
            64326,
            64335,
            this.R,
            64336,
            64433,
            this.AL,
            64434,
            64466,
            this.L,
            64467,
            64829,
            this.AL,
            64830,
            64831,
            this.ON,
            64832,
            64847,
            this.L,
            64848,
            64911,
            this.AL,
            64912,
            64913,
            this.L,
            64914,
            64967,
            this.AL,
            64968,
            65007,
            this.L,
            65008,
            65020,
            this.AL,
            65021,
            65021,
            this.ON,
            65022,
            65023,
            this.L,
            65024,
            65039,
            this.NSM,
            65040,
            65055,
            this.L,
            65056,
            65059,
            this.NSM,
            65060,
            65071,
            this.L,
            65072,
            65103,
            this.ON,
            65104,
            65104,
            this.CS,
            65105,
            65105,
            this.ON,
            65106,
            65106,
            this.CS,
            65107,
            65107,
            this.L,
            65108,
            65108,
            this.ON,
            65109,
            65109,
            this.CS,
            65110,
            65118,
            this.ON,
            65119,
            65119,
            this.ET,
            65120,
            65121,
            this.ON,
            65122,
            65123,
            this.ET,
            65124,
            65126,
            this.ON,
            65127,
            65127,
            this.L,
            65128,
            65128,
            this.ON,
            65129,
            65130,
            this.ET,
            65131,
            65131,
            this.ON,
            65132,
            65135,
            this.L,
            65136,
            65140,
            this.AL,
            65141,
            65141,
            this.L,
            65142,
            65276,
            this.AL,
            65277,
            65278,
            this.L,
            65279,
            65279,
            this.BN,
            65280,
            65280,
            this.L,
            65281,
            65282,
            this.ON,
            65283,
            65285,
            this.ET,
            65286,
            65290,
            this.ON,
            65291,
            65291,
            this.ET,
            65292,
            65292,
            this.CS,
            65293,
            65293,
            this.ET,
            65294,
            65294,
            this.CS,
            65295,
            65295,
            this.ES,
            65296,
            65305,
            this.EN,
            65306,
            65306,
            this.CS,
            65307,
            65312,
            this.ON,
            65313,
            65338,
            this.L,
            65339,
            65344,
            this.ON,
            65345,
            65370,
            this.L,
            65371,
            65381,
            this.ON,
            65382,
            65503,
            this.L,
            65504,
            65505,
            this.ET,
            65506,
            65508,
            this.ON,
            65509,
            65510,
            this.ET,
            65511,
            65511,
            this.L,
            65512,
            65518,
            this.ON,
            65519,
            65528,
            this.L,
            65529,
            65531,
            this.BN,
            65532,
            65533,
            this.ON,
            65534,
            65535,
            this.L
        ];
        for(var i = 0; i < this.charTypes.length; ++i){
            var start = this.charTypes[i];
            var end = this.charTypes[++i];
            var b = this.charTypes[++i];
            while(start <= end)this.rtlCharacterTypes[start++] = b;
        }
    }
    //#endregion
    //#region implementation
    RtlCharacters.prototype.getVisualOrder = function(inputText, isRtl) {
        this.types = this.getCharacterCode(inputText);
        this.textOrder = isRtl ? this.LRE : this.L;
        this.doVisualOrder();
        var result = [];
        for(var i = 0; i < this.levels.length; i++)result[i] = this.levels[i];
        return result;
    };
    RtlCharacters.prototype.getCharacterCode = function(text) {
        var characterCodes = [];
        for(var i = 0; i < text.length; i++)characterCodes[i] = this.rtlCharacterTypes[text[i].charCodeAt(0)];
        return characterCodes;
    };
    RtlCharacters.prototype.setDefaultLevels = function() {
        for(var i = 0; i < this.length; i++)this.levels[i] = this.textOrder;
    };
    RtlCharacters.prototype.setLevels = function() {
        this.setDefaultLevels();
        for(var n = 0; n < this.length; ++n){
            var level = this.levels[n];
            if ((level & 0x80) !== 0) {
                level &= 0x7f;
                this.result[n] = (level & 0x1) === 0 ? this.L : this.R;
            }
            this.levels[n] = level;
        }
    };
    RtlCharacters.prototype.updateLevels = function(index, level, length) {
        if ((level & 1) === 0) for(var i = index; i < length; ++i){
            if (this.result[i] === this.R) this.levels[i] += 1;
            else if (this.result[i] !== this.L) this.levels[i] += 2;
        }
        else {
            for(var i = index; i < length; ++i)if (this.result[i] !== this.R) this.levels[i] += 1;
        }
    };
    RtlCharacters.prototype.doVisualOrder = function() {
        this.length = this.types.length;
        this.result = this.types;
        this.levels = [];
        this.setLevels();
        this.length = this.getEmbeddedCharactersLength();
        var preview = this.textOrder;
        var i = 0;
        while(i < this.length){
            var level = this.levels[i];
            var preType = (Math.max(preview, level) & 0x1) === 0 ? this.L : this.R;
            var length_1 = i + 1;
            while(length_1 < this.length && this.levels[length_1] === level)++length_1;
            var success = length_1 < this.length ? this.levels[length_1] : this.textOrder;
            var type = (Math.max(success, level) & 0x1) === 0 ? this.L : this.R;
            this.checkNSM(i, length_1, level, preType, type);
            this.updateLevels(i, level, length_1);
            preview = level;
            i = length_1;
        }
        this.checkEmbeddedCharacters(this.length);
    };
    RtlCharacters.prototype.getEmbeddedCharactersLength = function() {
        var index = 0;
        for(var i = 0; i < this.length; ++i)if (!(this.types[i] === this.LRE || this.types[i] === this.RLE || this.types[i] === this.LRO || this.types[i] === this.RLO || this.types[i] === this.PDF || this.types[i] === this.BN)) {
            this.result[index] = this.result[i];
            this.levels[index] = this.levels[i];
            index++;
        }
        return index;
    };
    RtlCharacters.prototype.checkEmbeddedCharacters = function(length) {
        for(var i = this.types.length - 1; i >= 0; --i)if (this.types[i] === this.LRE || this.types[i] === this.RLE || this.types[i] === this.LRO || this.types[i] === this.RLO || this.types[i] === this.PDF || this.types[i] === this.BN) {
            this.result[i] = this.types[i];
            this.levels[i] = -1;
        } else {
            length -= 1;
            this.result[i] = this.result[length];
            this.levels[i] = this.levels[length];
        }
        for(var i = 0; i < this.types.length; i++)if (this.levels[i] === -1) {
            if (i === 0) this.levels[i] = this.textOrder;
            else this.levels[i] = this.levels[i - 1];
        }
    };
    RtlCharacters.prototype.checkNSM = function(index, length, level, startType, endType) {
        var charType = startType;
        for(var i = index; i < length; ++i)if (this.result[i] === this.NSM) this.result[i] = charType;
        else charType = this.result[i];
        this.checkEuropeanDigits(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkEuropeanDigits = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.EN) {
            for(var j = i - 1; j >= index; --j)if (this.result[j] === this.L || this.result[j] === this.R || this.result[j] === this.AL) {
                if (this.result[j] === this.AL) this.result[i] = this.AN;
                break;
            }
        }
        this.checkArabicCharacters(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkArabicCharacters = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.AL) this.result[i] = this.R;
        this.checkEuropeanNumberSeparator(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkEuropeanNumberSeparator = function(index, length, level, startType, endType) {
        for(var i = index + 1; i < length - 1; ++i)if (this.result[i] === this.ES || this.result[i] === this.CS) {
            var preview = this.result[i - 1];
            var success = this.result[i + 1];
            if (preview === this.EN && success === this.EN) this.result[i] = this.EN;
            else if (this.result[i] === this.CS && preview === this.AN && success === this.AN) this.result[i] = this.AN;
        }
        this.checkEuropeanNumberTerminator(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkEuropeanNumberTerminator = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.ET) {
            var s = i;
            var b = [];
            b.push(this.ET);
            var l = this.getLength(s, length, b);
            var data = s === index ? startType : this.result[s - 1];
            if (data !== this.EN) data = l === length ? endType : this.result[l];
            if (data === this.EN) for(var j = s; j < l; ++j)this.result[j] = this.EN;
            i = l;
        }
        this.checkOtherNeutrals(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkOtherNeutrals = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.ES || this.result[i] === this.ET || this.result[i] === this.CS) this.result[i] = this.ON;
        this.checkOtherCharacters(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.checkOtherCharacters = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.EN) {
            var pst = startType;
            for(var j = i - 1; j >= index; --j)if (this.result[j] === this.L || this.result[j] === this.R) {
                pst = this.result[j];
                break;
            }
            if (pst === this.L) this.result[i] = this.L;
        }
        this.checkCommanCharacters(index, length, level, startType, endType);
    };
    RtlCharacters.prototype.getLength = function(index, length, validSet) {
        --index;
        while(++index < length){
            var t = this.result[index];
            for(var i = 0; i < validSet.length; ++i)if (t === validSet[i]) index = this.getLength(++index, length, validSet);
            return index;
        }
        return length;
    };
    RtlCharacters.prototype.checkCommanCharacters = function(index, length, level, startType, endType) {
        for(var i = index; i < length; ++i)if (this.result[i] === this.WS || this.result[i] === this.ON || this.result[i] === this.B || this.result[i] === this.S) {
            var s = i;
            var byte = [
                this.B,
                this.S,
                this.WS,
                this.ON
            ];
            var l = this.getLength(s, length, byte);
            var lt = 0;
            var tt = 0;
            var rt = 0;
            if (s === index) lt = startType;
            else {
                lt = this.result[s - 1];
                if (lt === this.AN) lt = this.R;
                else if (lt === this.EN) lt = this.R;
            }
            if (l === length) tt = endType;
            else {
                tt = this.result[l];
                if (tt === this.AN) tt = this.R;
                else if (tt === this.EN) tt = this.R;
            }
            if (lt === tt) rt = lt;
            else rt = (level & 0x1) === 0 ? this.L : this.R;
            for(var j = s; j < l; ++j)this.result[j] = rt;
            i = l;
        }
    };
    return RtlCharacters;
}();


/**
 * `Metrics` of the font.
 * @private
 */ var $6d1b729459efb672$export$f23a0a3175647431 = /** @class */ function() {
    function RtlRenderer() {
        //region Constants
        /// Open bracket symbol.
        /// </summary>
        this.openBracket = "(";
        /// <summary>
        /// Close bracket symbol.
        /// </summary>
        this.closeBracket = ")";
    //#endregion
    }
    //#region Constructors
    /// <summary>
    /// Initializes a new instance of the <see cref="RtlRenderer"/> class.
    /// </summary>
    // public constructor() {
    // }
    //#region Public Methods
    /// <summary>
    /// Layouts text. Changes blocks position in the RTL text.
    /// Ligates the text if needed.
    /// </summary>
    /// <param name="line">Line of the text.</param>
    /// <param name="font">Font to be used for string printing.</param>
    /// <param name="rtl">Font alignment.</param>
    /// <param name="wordSpace">Indicates whether Word Spacing used or not.</param>
    /// <returns>Layout string.</returns>
    RtlRenderer.prototype.layout = function(line, font, rtl, wordSpace, format) {
        if (line == null) throw new Error("ArgumentNullException : line");
        if (font == null) throw new Error("ArgumentNullException : font");
        var result = [];
        if (font.Unicode) result = this.customLayout(line, rtl, format, font, wordSpace);
        else {
            result = [];
            result[0] = line;
        }
        return result;
    };
    /// <summary>
    /// Layouts a string and splits it by the words and using correct lay outing.
    /// </summary>
    /// <param name="line">Text line.</param>
    /// <param name="font">Font object.</param>
    /// <param name="rtl">Indicates whether RTL should be applied.</param>
    /// <param name="wordSpace">Indicates whether word spacing is used.</param>
    /// <returns>Array of words if converted, null otherwise.</returns>
    RtlRenderer.prototype.splitLayout = function(line, font, rtl, wordSpace, format) {
        if (line == null) throw new Error("ArgumentNullException : line");
        if (font == null) throw new Error("ArgumentNullException : font");
        var words = [];
        var system = false;
        if (!system || words == null) words = this.customSplitLayout(line, font, rtl, wordSpace, format);
        return words;
    };
    //#endregion
    //#region Implementation
    // private isEnglish( word : string) : boolean
    // {
    //     let c : string = (word.length > 0) ? word[0] : '';
    //     return (c >= '0' && c < 'ÿ');
    // }
    // private keepOrder( words : string, startIndex : number, count: number, result : string[], resultIndex : number) : void
    // {
    //     for (let i : number = 0, ri = resultIndex - count + 1; i < count; ++i, ++ri) {
    //         result[ri] = words[i + startIndex];
    //     }
    // }
    /// <summary>
    /// Uses system API to layout the text.
    /// </summary>
    /// <param name="line">Line of the text to be layouted.</param>
    /// <param name="font">Font which is used for text printing.</param>
    /// <param name="rtl">Indicates whether we use RTL or RTL lay outing of the text container.</param>
    /// <returns>Layout string.</returns>
    /* tslint:disable-next-line:max-line-length */ RtlRenderer.prototype.getGlyphIndex = function(line, font, rtl, /*out*/ glyphs, custom) {
        var success = true;
        var fail = false;
        if (line == null) throw new Error("ArgumentNullException : line");
        if (font == null) throw new Error("ArgumentNullException : font");
        glyphs = null;
        if (line.length === 0) return {
            success: fail,
            glyphs: glyphs
        };
        var renderer = new (0, $e1db529dd2812c4d$export$2c6e4803a1eed28d)();
        var text = renderer.shape(line, 0);
        var internalFont = font.fontInternal;
        var ttfReader = internalFont.ttfReader;
        glyphs = new Uint16Array(text.length);
        var i = 0;
        for(var k = 0, len = text.length; k < len; k++){
            var ch = text[k];
            var glyphInfo = ttfReader.getGlyph(ch);
            if (glyphInfo !== null && typeof glyphInfo !== "undefined") glyphs[i++] = glyphInfo.index;
        }
        return {
            success: success,
            glyphs: glyphs
        };
    };
    /* tslint:disable-next-line:max-line-length */ RtlRenderer.prototype.customLayout = function(line, rtl, format, font, wordSpace) {
        if (wordSpace === null || typeof wordSpace === "undefined") {
            if (line == null) throw new Error("ArgumentNullException : line");
            var result = null;
            //bidirectional order.
            if (format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) {
                var bidi = new (0, $8d6c280e77b82d6f$export$83b047b4376c0567)();
                result = bidi.getLogicalToVisualString(line, rtl);
            }
            return result;
        } else {
            if (line == null) throw new Error("ArgumentNullException : line");
            if (font == null) throw new Error("ArgumentNullException : font");
            var layouted = null;
            if (format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) {
                var renderer = new (0, $e1db529dd2812c4d$export$2c6e4803a1eed28d)();
                var txt = renderer.shape(line, 0);
                layouted = this.customLayout(txt, rtl, format);
            }
            // else {
            //     layouted = this.customLayout(line, rtl, format);
            // }
            // We have unicode font, but from the file.        
            var result = [];
            // Split the text by words if word spacing is not default.
            if (wordSpace) {
                var words = layouted.split("");
                var count = words.length;
                for(var i = 0; i < count; i++)words[i] = this.addChars(font, words[i]);
                result = words;
            } else {
                result = [];
                result[0] = this.addChars(font, layouted);
            }
            return result;
        }
    };
    /// <summary>
    /// Add information about used glyphs to the font.
    /// </summary>
    /// <param name="font">Font used for text rendering.</param>
    /// <param name="glyphs">Array of used glyphs.</param>
    /// <returns>String in the form to be written to the file.</returns>
    RtlRenderer.prototype.addChars = function(font, glyphs) {
        var line = glyphs;
        if (font == null) throw new Error("ArgumentNullException : font");
        if (line == null) throw new Error("ArgumentNullException : line");
        var text = line;
        var internalFont = font.fontInternal;
        var ttfReader = internalFont.ttfReader;
        font.setSymbols(text);
        // Reconvert string according to unicode standard.
        text = ttfReader.convertString(text);
        var bytes = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).toUnicodeArray(text, false);
        text = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).byteToString(bytes);
        return text;
    // else {
    //     if (font == null) {
    //         throw new Error('ArgumentNullException : font');
    //     }
    //     if (glyphs == null) {
    //         throw new Error('ArgumentNullException : glyphs');
    //     }
    //     // Mark the chars as used.
    //     let text : string = '';
    //     font.setSymbols(glyphs);
    //     // Create string from the glyphs.
    //     
    //     let chars : string[] = [];
    //     for (let i : number = 0; i < glyphs.length; i++) {
    //         chars[i] = glyphs[i].toString();
    //     }
    //     for (let j : number = 0 ; j < chars.length; j++) {
    //         text = text + chars[j];
    //     }
    //     let bytes : number[] = PdfString.toUnicodeArray(text, false);
    //     text = PdfString.byteToString(bytes);
    //     return text;
    // }
    };
    /// <summary>
    /// Layouts a string and splits it by the words by using custom lay outing.
    /// </summary>
    /// <param name="line">Text line.</param>
    /// <param name="font">Font object.</param>
    /// <param name="rtl">Indicates whether RTL should be applied.</param>
    /// <param name="wordSpace">Indicates whether word spacing is used.</param>
    /// <returns>Array of words if converted, null otherwise.</returns>
    /* tslint:disable-next-line:max-line-length */ RtlRenderer.prototype.customSplitLayout = function(line, font, rtl, wordSpace, format) {
        if (line == null) throw new Error("ArgumentNullException : line");
        if (font == null) throw new Error("ArgumentNullException : font");
        var reversedLine = this.customLayout(line, rtl, format);
        var words = reversedLine.split("");
        return words;
    };
    return RtlRenderer;
}();


/**
 * public Enum for `PdfLayoutType`.
 * @private
 */ var $5ffc34ffc68e39dd$export$3652975898b34cce;
(function(PdfLayoutType) {
    /**
     * Specifies the type of `Paginate`.
     * @private
     */ PdfLayoutType[PdfLayoutType["Paginate"] = 0] = "Paginate";
    /**
     * Specifies the type of `OnePage`.
     * @private
     */ PdfLayoutType[PdfLayoutType["OnePage"] = 1] = "OnePage";
})($5ffc34ffc68e39dd$export$3652975898b34cce || ($5ffc34ffc68e39dd$export$3652975898b34cce = {}));
var $5ffc34ffc68e39dd$export$f886812f74e09fd0;
(function(PdfLayoutBreakType) {
    /**
     * Specifies the type of `FitPage`.
     * @private
     */ PdfLayoutBreakType[PdfLayoutBreakType["FitPage"] = 0] = "FitPage";
    /**
     * Specifies the type of `FitElement`.
     * @private
     */ PdfLayoutBreakType[PdfLayoutBreakType["FitElement"] = 1] = "FitElement";
    /**
     * Specifies the type of `FitColumnsToPage`.
     * @private
     */ PdfLayoutBreakType[PdfLayoutBreakType["FitColumnsToPage"] = 2] = "FitColumnsToPage";
})($5ffc34ffc68e39dd$export$f886812f74e09fd0 || ($5ffc34ffc68e39dd$export$f886812f74e09fd0 = {}));
var $5ffc34ffc68e39dd$export$291db033450eaddd;
(function(PathPointType) {
    /**
     * Specifies the path point type of `Start`.
     * @private
     */ PathPointType[PathPointType["Start"] = 0] = "Start";
    /**
     * Specifies the path point type of `Line`.
     * @private
     */ PathPointType[PathPointType["Line"] = 1] = "Line";
    /**
     * Specifies the path point type of `Bezier3`.
     * @private
     */ PathPointType[PathPointType["Bezier3"] = 3] = "Bezier3";
    /**
     * Specifies the path point type of `Bezier`.
     * @private
     */ PathPointType[PathPointType["Bezier"] = 3] = "Bezier";
    /**
     * Specifies the path point type of `PathTypeMask`.
     * @private
     */ PathPointType[PathPointType["PathTypeMask"] = 7] = "PathTypeMask";
    /**
     * Specifies the path point type of `DashMode`.
     * @private
     */ PathPointType[PathPointType["DashMode"] = 16] = "DashMode";
    /**
     * Specifies the path point type of `PathMarker`.
     * @private
     */ PathPointType[PathPointType["PathMarker"] = 32] = "PathMarker";
    /**
     * Specifies the path point type of `CloseSubpath`.
     * @private
     */ PathPointType[PathPointType["CloseSubpath"] = 128] = "CloseSubpath";
})($5ffc34ffc68e39dd$export$291db033450eaddd || ($5ffc34ffc68e39dd$export$291db033450eaddd = {}));












var $6587e87f441fc490$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfGradientBrush` class provides objects used to fill the interiors of graphical shapes such as rectangles,
 * ellipses, pies, polygons, and paths.
 * @private
 */ var $6587e87f441fc490$export$63959b57c9e2ff54 = /** @class */ function(_super) {
    $6587e87f441fc490$var$__extends(PdfGradientBrush, _super);
    //Constructor
    /**
     * Initializes a new instance of the `PdfGradientBrush` class.
     * @public
     */ /* tslint:disable-next-line:max-line-length */ function PdfGradientBrush(shading) {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Local variable to store the background color.
         * @private
         */ _this.mbackground = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(255, 255, 255);
        /**
         * Local variable to store the stroking color.
         * @private
         */ _this.mbStroking = false;
        /**
         * Local variable to store the function.
         * @private
         */ _this.mfunction = null;
        /**
         * Local variable to store the DictionaryProperties.
         * @private
         */ _this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        _this.mpatternDictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        _this.mpatternDictionary.items.setValue(_this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(_this.dictionaryProperties.pattern));
        _this.mpatternDictionary.items.setValue(_this.dictionaryProperties.patternType, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(2));
        _this.shading = shading;
        _this.colorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        return _this;
    }
    Object.defineProperty(PdfGradientBrush.prototype, "background", {
        //Properties
        /**
         * Gets or sets the background color of the brush.
         * @public
         */ get: function() {
            return this.mbackground;
        },
        set: function(value) {
            this.mbackground = value;
            var sh = this.shading;
            if (value.isEmpty) sh.remove(this.dictionaryProperties.background);
            else sh.items.setValue(this.dictionaryProperties.background, value.toArray(this.colorSpace));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "antiAlias", {
        /**
         * Gets or sets a value indicating whether use anti aliasing algorithm.
         * @public
         */ get: function() {
            var sh = this.shading;
            var aa = sh.items.getValue(this.dictionaryProperties.antiAlias);
            return aa.value;
        },
        set: function(value) {
            var sh = this.shading;
            var aa = sh.items.getValue(this.dictionaryProperties.antiAlias);
            if (aa == null && typeof aa === "undefined") {
                aa = new (0, $502bea31c0cd284e$export$9101e1382351029d)(value);
                sh.items.setValue(this.dictionaryProperties.antiAlias, aa);
            } else aa.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "function", {
        /**
         * Gets or sets the function of the brush.
         * @protected
         */ get: function() {
            return this.mfunction;
        },
        set: function(value) {
            this.mfunction = value;
            if (value != null && typeof value !== "undefined") this.shading.items.setValue(this.dictionaryProperties.function, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.mfunction));
            else this.shading.remove(this.dictionaryProperties.function);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "bBox", {
        /**
         * Gets or sets the boundary box of the brush.
         * @protected
         */ get: function() {
            var sh = this.shading;
            var box = sh.items.getValue(this.dictionaryProperties.bBox);
            return box;
        },
        set: function(value) {
            var sh = this.shading;
            if (value == null && typeof value === "undefined") sh.remove(this.dictionaryProperties.bBox);
            else sh.items.setValue(this.dictionaryProperties.bBox, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "colorSpace", {
        /**
         * Gets or sets the color space of the brush.
         * @public
         */ get: function() {
            return this.mcolorSpace;
        },
        set: function(value) {
            var colorSpace = this.shading.items.getValue(this.dictionaryProperties.colorSpace);
            if (value !== this.mcolorSpace || colorSpace == null) {
                this.mcolorSpace = value;
                var csValue = this.colorSpaceToDeviceName(value);
                this.shading.items.setValue(this.dictionaryProperties.colorSpace, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(csValue));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "stroking", {
        /**
         * Gets or sets a value indicating whether this PdfGradientBrush is stroking.
         * @public
         */ get: function() {
            return this.mbStroking;
        },
        set: function(value) {
            this.mbStroking = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "patternDictionary", {
        /**
         * Gets the pattern dictionary.
         * @protected
         */ get: function() {
            if (this.mpatternDictionary == null) this.mpatternDictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
            return this.mpatternDictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "shading", {
        /**
         * Gets or sets the shading dictionary.
         * @protected
         */ get: function() {
            return this.mshading;
        },
        set: function(value) {
            if (value == null) throw new Error("ArgumentNullException : Shading");
            if (value !== this.mshading) {
                this.mshading = value;
                this.patternDictionary.items.setValue(this.dictionaryProperties.shading, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.mshading));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGradientBrush.prototype, "matrix", {
        /**
         * Gets or sets the transformation matrix.
         * @public
         */ get: function() {
            return this.mmatrix;
        },
        set: function(value) {
            if (value == null) throw new Error("ArgumentNullException : Matrix");
            if (value !== this.mmatrix) {
                this.mmatrix = value.clone();
                var m = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)(this.mmatrix.matrix.elements);
                this.mpatternDictionary.items.setValue(this.dictionaryProperties.matrix, m);
            }
        },
        enumerable: true,
        configurable: true
    });
    //Overrides
    /**
     * Monitors the changes of the brush and modify PDF state respectfully.
     * @param brush The brush.
     * @param streamWriter The stream writer.
     * @param getResources The get resources delegate.
     * @param saveChanges if set to true the changes should be saved anyway.
     * @param currentColorSpace The current color space.
     */ /* tslint:disable-next-line:max-line-length */ PdfGradientBrush.prototype.monitorChanges = function(brush, streamWriter, getResources, saveChanges, currentColorSpace) {
        var diff = false;
        if (brush instanceof PdfGradientBrush) {
            if (this.colorSpace !== currentColorSpace) {
                this.colorSpace = currentColorSpace;
                this.resetFunction();
            }
            //  Set the /Pattern colour space.
            streamWriter.setColorSpace("Pattern", this.mbStroking);
            //  Set the pattern for non-stroking operations.
            var resources = getResources.getResources();
            var name_1 = resources.getName(this);
            streamWriter.setColourWithPattern(null, name_1, this.mbStroking);
            diff = true;
        }
        return diff;
    };
    /**
     * Resets the changes, which were made by the brush.
     * In other words resets the state to the initial one.
     * @param streamWriter The stream writer.
     */ PdfGradientBrush.prototype.resetChanges = function(streamWriter) {
    //  Unable reset.
    };
    //Implementation
    /**
     * Converts colorspace enum to a PDF name.
     * @param colorSpace The color space enum value.
     */ PdfGradientBrush.prototype.colorSpaceToDeviceName = function(colorSpace) {
        var result;
        switch(colorSpace){
            case (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb:
                result = "DeviceRGB";
                break;
        }
        return result;
    };
    /**
     * Resets the pattern dictionary.
     * @param dictionary A new pattern dictionary.
     */ PdfGradientBrush.prototype.resetPatternDictionary = function(dictionary) {
        this.mpatternDictionary = dictionary;
    };
    /**
     * Clones the anti aliasing value.
     * @param brush The brush.
     */ PdfGradientBrush.prototype.cloneAntiAliasingValue = function(brush) {
        if (brush == null) throw new Error("ArgumentNullException : brush");
        var sh = this.shading;
        var aa = sh.items.getValue(this.dictionaryProperties.antiAlias);
        if (aa != null) brush.shading.items.setValue(this.dictionaryProperties.antiAlias, new (0, $502bea31c0cd284e$export$9101e1382351029d)(aa.value));
    };
    /**
     * Clones the background value.
     * @param brush The brush.
     */ PdfGradientBrush.prototype.cloneBackgroundValue = function(brush) {
        var background = this.background;
        if (!background.isEmpty) brush.background = background;
    };
    Object.defineProperty(PdfGradientBrush.prototype, "element", {
        /* tslint:enable */ // IPdfWrapper Members
        /**
         * Gets the `element`.
         * @private
         */ get: function() {
            return this.patternDictionary;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGradientBrush;
}((0, $7e20ae7ea9857864$export$e91b732cd7775ec5));















/**
 * PdfTemplate.ts class for EJ2-PDF
 */ 






/**
 * Represents `Pdf Template` object.
 * @private
 */ var $094796745e9b29a1$export$cbb9d62db9e1cba0 = /** @class */ function() {
    function PdfTemplate(arg1, arg2) {
        /**
         * Initialize an instance for `DictionaryProperties` class.
         * @private
         * @hidden
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * Checks whether the transformation 'is performed'.
         * @default true
         * @private
         */ this.writeTransformation = true;
        if (typeof arg1 === "undefined") ;
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$81f866bb912d8821) && typeof arg2 === "undefined") {
            this.content = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
            var tempSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg1.width, arg1.height);
            this.setSize(tempSize);
            this.initialize();
        } else {
            this.content = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
            this.setSize(new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg1, arg2));
            this.initialize();
        }
    }
    Object.defineProperty(PdfTemplate.prototype, "size", {
        //Properties
        /**
         * Gets the size of the 'PdfTemplate'.
         */ get: function() {
            return this.templateSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTemplate.prototype, "width", {
        /**
         * Gets the width of the 'PdfTemplate'.
         */ get: function() {
            return this.size.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTemplate.prototype, "height", {
        /**
         * Gets the height of the 'PdfTemplate'.
         */ get: function() {
            return this.size.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTemplate.prototype, "graphics", {
        /**
         * Gets the `graphics` of the 'PdfTemplate'.
         */ get: function() {
            if (this.pdfGraphics == null || typeof this.pdfGraphics === "undefined") {
                var gr = new (0, $fb8dc0c26a98dd16$export$d6852a765bb5199f)(this);
                var g = new (0, $fb8dc0c26a98dd16$export$b71fac00da485609)(this.size, gr, this.content);
                this.pdfGraphics = g;
                // if(this.writeTransformation) {
                // Transform co-ordinates to Top/Left.
                this.pdfGraphics.initializeCoordinates();
            // }
            }
            return this.pdfGraphics;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the resources and modifies the template dictionary.
     * @private
     */ PdfTemplate.prototype.getResources = function() {
        if (this.resources == null) {
            this.resources = new (0, $fd5f6c449fbc58fe$export$97d157607b67be30)();
            this.content.items.setValue(this.dictionaryProperties.resources, this.resources);
        }
        return this.resources;
    };
    // Public methods
    /**
     * `Initialize` the type and subtype of the template.
     * @private
     */ PdfTemplate.prototype.initialize = function() {
        this.addType();
        this.addSubType();
    };
    /**
     * `Adds type key`.
     * @private
     */ PdfTemplate.prototype.addType = function() {
        var value = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.xObject);
        this.content.items.setValue(this.dictionaryProperties.type, value);
    };
    /**
     * `Adds SubType key`.
     * @private
     */ PdfTemplate.prototype.addSubType = function() {
        var value = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.form);
        this.content.items.setValue(this.dictionaryProperties.subtype, value);
    };
    PdfTemplate.prototype.reset = function(size) {
        if (typeof size === "undefined") {
            if (this.resources != null) {
                this.resources = null;
                this.content.remove(this.dictionaryProperties.resources);
            }
            if (this.graphics != null) this.graphics.reset(this.size);
        } else {
            this.setSize(size);
            this.reset();
        }
    };
    /**
     * `Set the size` of the 'PdfTemplate'.
     * @private
     */ PdfTemplate.prototype.setSize = function(size) {
        var rect = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0), size);
        var val = (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(rect);
        this.content.items.setValue(this.dictionaryProperties.bBox, val);
        this.templateSize = size;
    };
    Object.defineProperty(PdfTemplate.prototype, "element", {
        // /**
        //  * Returns the value of current graphics.
        //  * @private
        //  */
        // public GetGraphics(g : PdfGraphics) : PdfGraphics {
        //     if (this.graphics == null || typeof this.graphics === 'undefined') {
        //         this.graphics = g;
        //         this.graphics.Size = this.Size;
        //         this.graphics.StreamWriter = new PdfStreamWriter(this.content)
        //         this.graphics.Initialize();
        //         if(this.writeTransformation) {
        //             this.graphics.InitializeCoordinates();
        //         }
        //     }
        //     return this.graphics;
        // }
        // IPdfWrapper Members
        /**
         * Gets the `content stream` of 'PdfTemplate' class.
         * @private
         */ get: function() {
            return this.content;
        },
        enumerable: true,
        configurable: true
    });
    return PdfTemplate;
}();








var $fd5f6c449fbc58fe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfResources` class used to set resource contents like font, image.
 * @private
 */ var $fd5f6c449fbc58fe$export$97d157607b67be30 = /** @class */ function(_super) {
    $fd5f6c449fbc58fe$var$__extends(PdfResources, _super);
    function PdfResources(baseDictionary) {
        var _this = _super.call(this, baseDictionary) || this;
        /**
         * Dictionary for the `properties names`.
         * @private
         */ _this.properties = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        return _this;
    }
    Object.defineProperty(PdfResources.prototype, "names", {
        //Properties
        /**
         * Gets the `font names`.
         * @private
         */ get: function() {
            return this.getNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfResources.prototype, "document", {
        /**
         * Get or set the `page document`.
         * @private
         */ get: function() {
            return this.pdfDocument;
        },
        set: function(value) {
            this.pdfDocument = value;
        },
        enumerable: true,
        configurable: true
    });
    //Public Methods
    /**
     * `Generates name` for the object and adds to the resource if the object is new.
     * @private
     */ PdfResources.prototype.getName = function(obj) {
        var primitive = obj.element;
        var name = null;
        if (this.names.containsKey(primitive)) name = this.names.getValue(primitive);
        // Object is new.
        if (name == null) {
            var sName = this.generateName();
            name = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(sName);
            this.names.setValue(primitive, name);
            if (obj instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b)) this.add(obj, name);
            else if (obj instanceof (0, $094796745e9b29a1$export$cbb9d62db9e1cba0)) this.add(obj, name);
            else if (obj instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54) || obj instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) this.add(obj, name);
            else if (obj instanceof (0, $0ede958bcf41280e$export$9ef1b6d3d933406c)) this.add(obj, name);
            else if (obj instanceof (0, $722331ec33bd9a93$export$ee8313b7edf5feab) || obj instanceof (0, $c987c917f397d328$export$a738614a0b6b3b5a)) this.add(obj, name);
        }
        return name;
    };
    /**
     * Gets `resource names` to font dictionaries.
     * @private
     */ PdfResources.prototype.getNames = function() {
        if (this.pdfNames == null) this.pdfNames = new (0, $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb)();
        var fonts = this.items.getValue(this.dictionaryProperties.font);
        if (fonts != null) {
            var reference = fonts;
            var dictionary = fonts;
            dictionary = (0, $8866b473e717b660$export$8c4e0ee04681847e).dereference(fonts);
        }
        return this.pdfNames;
    };
    /**
     * Add `RequireProcedureSet` into procset array.
     * @private
     */ PdfResources.prototype.requireProcedureSet = function(procedureSetName) {
        if (procedureSetName == null) throw new Error("ArgumentNullException:procedureSetName");
        var procSets = this.items.getValue(this.dictionaryProperties.procset);
        if (procSets == null) {
            procSets = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
            this.items.setValue(this.dictionaryProperties.procset, procSets);
        }
        var name = new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(procedureSetName);
        if (!procSets.contains(name)) procSets.add(name);
    };
    //Helper Methods
    /**
     * `Remove font` from array.
     * @private
     */ PdfResources.prototype.removeFont = function(name) {
        var key = null;
        var keys = this.pdfNames.keys();
        for(var index = 0; index < this.pdfNames.size(); index++)if (this.pdfNames.getValue(keys[index]) === new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(name)) {
            key = keys[index];
            break;
        }
        if (key != null) this.pdfNames.remove(key);
    };
    /**
     * Generates `Unique string name`.
     * @private
     */ PdfResources.prototype.generateName = function() {
        var name = $fd5f6c449fbc58fe$export$f6d5d4774149a3bf.getNewGuidString();
        return name;
    };
    PdfResources.prototype.add = function(arg1, arg2) {
        if (arg1 instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b)) {
            var dictionary = null;
            var fonts = this.items.getValue(this.dictionaryProperties.font);
            if (fonts != null) {
                var reference = fonts;
                dictionary = fonts;
                dictionary = fonts;
            } else {
                dictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                this.items.setValue(this.dictionaryProperties.font, dictionary);
            }
            dictionary.items.setValue(arg2.value, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(arg1.element));
        } else if (arg1 instanceof (0, $094796745e9b29a1$export$cbb9d62db9e1cba0)) {
            var xobjects = void 0;
            xobjects = this.items.getValue(this.dictionaryProperties.xObject);
            // Create fonts dictionary.
            if (xobjects == null) {
                xobjects = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                this.items.setValue(this.dictionaryProperties.xObject, xobjects);
            }
            xobjects.items.setValue(arg2.value, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(arg1.element));
        } else if (arg1 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5)) {
            if (arg1 instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54) || arg1 instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) {
                var savable = arg1.element;
                if (savable != null) {
                    var pattern = this.items.getValue(this.dictionaryProperties.pattern);
                    // Create a new pattern dictionary.
                    if (pattern == null) {
                        pattern = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                        this.items.setValue(this.dictionaryProperties.pattern, pattern);
                    }
                    pattern.items.setValue(arg2.value, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(savable));
                }
            }
        } else if (arg1 instanceof (0, $0ede958bcf41280e$export$9ef1b6d3d933406c)) {
            var savable = arg1.element;
            var transDic = null;
            transDic = this.items.getValue(this.dictionaryProperties.extGState);
            // Create a new pattern dictionary.
            if (transDic == null) {
                transDic = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                this.items.setValue(this.dictionaryProperties.extGState, transDic);
            }
            transDic.items.setValue(arg2.value, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(savable));
        } else {
            /* tslint:disable */ var xobjects = this.Dictionary.items.getValue(this.dictionaryProperties.xObject);
            var parentXObjects = void 0;
            if (typeof this.pdfDocument !== "undefined") parentXObjects = this.pdfDocument.sections.element.items.getValue(this.dictionaryProperties.resources).items.getValue(this.dictionaryProperties.xObject);
            var values = this.Dictionary.items.values();
            var hasSameImageStream = false;
            var oldReference = void 0;
            if (typeof this.pdfDocument !== "undefined" && parentXObjects == null) {
                parentXObjects = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                this.pdfDocument.sections.element.items.getValue(this.dictionaryProperties.resources).items.setValue(this.dictionaryProperties.xObject, parentXObjects);
            } else if (typeof this.pdfDocument !== "undefined") {
                var values_1 = parentXObjects.items.values();
                for(var i = 0; i < values_1.length; i++){
                    if (typeof values_1[i] !== "undefined" && typeof values_1[i].element !== "undefined") {
                        if (values_1[i].element.data[0] === arg1.element.data[0]) {
                            oldReference = values_1[i];
                            hasSameImageStream = true;
                        }
                    }
                }
            }
            if (xobjects == null) {
                xobjects = new (0, $467b51a52206950c$export$f103d8ead0680780)();
                this.Dictionary.items.setValue(this.dictionaryProperties.xObject, xobjects);
            }
            if (hasSameImageStream && typeof oldReference !== "undefined") xobjects.items.setValue(arg2.value, oldReference);
            else {
                var reference = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(arg1.element);
                xobjects.items.setValue(arg2.value, reference);
                if (typeof this.pdfDocument !== "undefined") parentXObjects.items.setValue(arg2.value, reference);
            }
        /* tslint:enable */ }
    };
    return PdfResources;
}((0, $467b51a52206950c$export$f103d8ead0680780));
/* tslint:disable */ /**
 * Used to create new guid for resources.
 * @private
 */ var $fd5f6c449fbc58fe$export$f6d5d4774149a3bf = /** @class */ function() {
    function Guid() {}
    /**
     * Generate `new GUID`.
     * @private
     */ Guid.getNewGuidString = function() {
        return "aaaaaaaa-aaaa-4aaa-baaa-aaaaaaaaaaaa".replace(/[ab]/g, function(c) {
            var random = Math.random() * 16 | 0;
            var result = c === "a" ? random : random & 0x3 | 0x8;
            return result.toString(16);
        });
    };
    return Guid;
}();
 /* tslint:enable */ 



var $3bd0650cea4e8a32$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfTilingBrush` Implements a colored tiling brush.
 */ var $3bd0650cea4e8a32$export$77a6ef39f02aa8bc = /** @class */ function(_super) {
    $3bd0650cea4e8a32$var$__extends(PdfTilingBrush, _super);
    /**
     * Initializes a new instance of the `PdfTilingBrush` class.
     * @public
     */ function PdfTilingBrush(arg1, arg2) {
        var _this = _super.call(this) || this;
        /**
         * Local variable to store Stroking.
         * @private
         */ _this.mStroking = false;
        /**
         * Local variable to store the tile start location.
         * @private
         */ _this.mLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
        /**
         * Local variable to store the dictionary properties.
         * @private
         */ _this.mDictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        var rect = null;
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$4617fb02663045ef)) rect = arg1;
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$81f866bb912d8821)) rect = new (0, $e1df9a3657e111f3$export$4617fb02663045ef)(0, 0, arg1.width, arg1.height);
        if (arg2 !== null && arg2 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08)) _this.mPage = arg2;
        _this.brushStream = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        _this.mResources = new (0, $fd5f6c449fbc58fe$export$97d157607b67be30)();
        _this.brushStream.items.setValue(_this.mDictionaryProperties.resources, _this.mResources);
        _this.setBox(rect);
        _this.setObligatoryFields();
        if (arg2 !== null && arg2 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08)) {
            _this.mPage = arg2;
            _this.graphics.colorSpace = arg2.document.colorSpace;
        }
        return _this;
    }
    /**
     * Initializes a new instance of the `PdfTilingBrush` class.
     * @private
     * @param rectangle The size of the smallest brush cell.
     * @param page The Current Page Object.
     * @param location The Tile start location.
     * @param matrix The matrix.
     */ PdfTilingBrush.prototype.initialize = function(rectangle, page, location, matrix) {
        this.mPage = page;
        this.mLocation = location;
        this.mTransformationMatrix = matrix;
        this.tempBrushStream = this.brushStream;
        this.brushStream = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        var tempResource = new (0, $fd5f6c449fbc58fe$export$97d157607b67be30)();
        this.brushStream.items.setValue(this.mDictionaryProperties.resources, tempResource);
        this.setBox(rectangle);
        this.setObligatoryFields();
        return this;
    };
    Object.defineProperty(PdfTilingBrush.prototype, "location", {
        //Properties
        /**
         * Location representing the start position of the tiles.
         * @public
         */ get: function() {
            return this.mLocation;
        },
        set: function(value) {
            this.mLocation = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the obligatory fields.
     * @private
     */ PdfTilingBrush.prototype.setObligatoryFields = function() {
        this.brushStream.items.setValue(this.mDictionaryProperties.patternType, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(1));
        //  Tiling brush.
        this.brushStream.items.setValue(this.mDictionaryProperties.paintType, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(1));
        //  Coloured.
        this.brushStream.items.setValue(this.mDictionaryProperties.tilingType, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(1));
        //  Constant spacing.
        this.brushStream.items.setValue(this.mDictionaryProperties.xStep, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.mBox.right - this.mBox.left));
        this.brushStream.items.setValue(this.mDictionaryProperties.yStep, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.mBox.bottom - this.mBox.top));
        if (this.mPage != null && this.mLocation != null) {
            if (this.mTransformationMatrix == null && typeof this.mTransformationMatrix === "undefined") {
                // Transform the tile origin to fit the location
                var tileTransform = this.mPage.size.height % this.rectangle.size.height - this.mLocation.y;
                /* tslint:disable-next-line:max-line-length */ this.brushStream.items.setValue(this.mDictionaryProperties.matrix, new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)([
                    1,
                    0,
                    0,
                    1,
                    this.mLocation.x,
                    tileTransform
                ]));
            } else {
                var tileTransform = 0;
                // Transform the tile origin to fit the location
                var elements = this.mTransformationMatrix.matrix.elements;
                if (this.mPage.size.height > this.rectangle.size.height) tileTransform = this.mTransformationMatrix.matrix.offsetY - this.mPage.size.height % this.rectangle.size.height;
                else tileTransform = this.mPage.size.height % this.rectangle.size.height + this.mTransformationMatrix.matrix.offsetY;
                this.brushStream.items.setValue(this.mDictionaryProperties.matrix, new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)([
                    elements[0],
                    elements[1],
                    elements[2],
                    elements[3],
                    elements[4],
                    tileTransform
                ]));
            }
        }
    };
    /**
     * Sets the BBox coordinates.
     * @private
     */ PdfTilingBrush.prototype.setBox = function(box) {
        this.mBox = box;
        var rect = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(this.mBox.left, this.mBox.top, this.mBox.right, this.mBox.bottom);
        this.brushStream.items.setValue(this.mDictionaryProperties.bBox, (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(rect));
    };
    Object.defineProperty(PdfTilingBrush.prototype, "rectangle", {
        //Properties
        /**
         * Gets the boundary box of the smallest brush cell.
         * @public
         */ get: function() {
            return this.mBox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTilingBrush.prototype, "size", {
        /**
         * Gets the size of the smallest brush cell.
         * @public
         */ get: function() {
            return this.mBox.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTilingBrush.prototype, "graphics", {
        /**
         * Gets Graphics context of the brush.
         */ get: function() {
            if (this.mGraphics == null && typeof this.mGraphics === "undefined") {
                var gr = new (0, $fb8dc0c26a98dd16$export$d6852a765bb5199f)(this);
                var g = new (0, $fb8dc0c26a98dd16$export$b71fac00da485609)(this.size, gr, this.brushStream);
                this.mGraphics = g;
                this.mResources = this.getResources();
                this.mGraphics.initializeCoordinates();
            }
            return this.mGraphics;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the resources and modifies the template dictionary.
     * @public
     */ PdfTilingBrush.prototype.getResources = function() {
        return this.mResources;
    };
    Object.defineProperty(PdfTilingBrush.prototype, "stroking", {
        /**
         * Gets or sets a value indicating whether this PdfTilingBrush
         * is used for stroking operations.
         */ get: function() {
            return this.mStroking;
        },
        set: function(value) {
            this.mStroking = value;
        },
        enumerable: true,
        configurable: true
    });
    //PdfBrush methods
    /**
     * Creates a new copy of a brush.
     * @public
     */ PdfTilingBrush.prototype.clone = function() {
        var brush = this.initialize(this.rectangle, this.mPage, this.location, this.mTransformationMatrix);
        if (this.mTransformationMatrix != null && this.mTransformationMatrix.matrix != null) /* tslint:disable-next-line:max-line-length */ brush.brushStream.items.setValue(this.mDictionaryProperties.matrix, new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)(this.mTransformationMatrix.matrix.elements));
        brush.brushStream.data = this.tempBrushStream.data;
        brush.mResources = new (0, $fd5f6c449fbc58fe$export$97d157607b67be30)(this.mResources);
        brush.brushStream.items.setValue(this.mDictionaryProperties.resources, brush.mResources);
        return brush;
    };
    /**
     * Monitors the changes of the brush and modify PDF state respectfully.
     * @param brush The brush
     * @param streamWriter The stream writer
     * @param getResources The get resources delegate.
     * @param saveChanges if set to true the changes should be saved anyway.
     * @param currentColorSpace The current color space.
     */ /* tslint:disable-next-line:max-line-length */ PdfTilingBrush.prototype.monitorChanges = function(brush, streamWriter, getResources, saveChanges, currentColorSpace) {
        var diff = false;
        if (brush !== this) {
            //  Set the Pattern colour space.
            streamWriter.setColorSpace("Pattern", this.mStroking);
            //  Set the pattern for non-stroking operations.
            var resources1 = getResources.getResources();
            var name1 = resources1.getName(this);
            streamWriter.setColourWithPattern(null, name1, this.mStroking);
            diff = true;
        } else if (brush instanceof PdfTilingBrush) {
            //  Set the /Pattern colour space.
            streamWriter.setColorSpace("Pattern", this.mStroking);
            //  Set the pattern for non-stroking operations.
            var resources = getResources.getResources();
            var name_1 = resources.getName(this);
            streamWriter.setColourWithPattern(null, name_1, this.mStroking);
            diff = true;
        }
        return diff;
    };
    /**
     * Resets the changes, which were made by the brush.
     * In other words resets the state to the initial one.
     * @param streamWriter The stream writer.
     */ PdfTilingBrush.prototype.resetChanges = function(streamWriter) {
    //  We shouldn't do anything to reset changes.
    //  All changes will be reset automatically by setting a new colour space.
    };
    Object.defineProperty(PdfTilingBrush.prototype, "element", {
        /* tslint:enable */ // IPdfWrapper Members
        /**
         * Gets the `element`.
         * @public
         */ get: function() {
            return this.brushStream;
        },
        enumerable: true,
        configurable: true
    });
    return PdfTilingBrush;
}((0, $7e20ae7ea9857864$export$e91b732cd7775ec5));


/**
 * `PdfGraphics` class represents a graphics context of the objects.
 * It's used for performing all the graphics operations.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a new page to the document
 * let page1 : PdfPage = document.pages.add();
 * // set the font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * // create black brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * //
 * //graphics of the page
 * let page1Graphics : PdfGraphics = page1.graphics;
 * // draw the text on the page1 graphics
 * page1Graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
 * //
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $fb8dc0c26a98dd16$export$b71fac00da485609 = /** @class */ function() {
    function PdfGraphics(arg1, arg2, arg3) {
        /**
         * Represents the `Current color space`.
         * @private
         */ this.currentColorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        /**
         * Stores `previous rendering mode`.
         * @private
         */ this.previousTextRenderingMode = (0, $d174213b46afc09a$export$ca45e4ab114d4814).Fill;
        /**
         * Previous `character spacing` value or 0.
         * @private
         */ this.previousCharacterSpacing = 0.0;
        /**
         * Previous `word spacing` value or 0.
         * @private
         */ this.previousWordSpacing = 0.0;
        /**
         * The `previously used text scaling` value.
         * @private
         */ this.previousTextScaling = 100.0;
        /**
         * Instance of `ProcedureSets` class.
         * @private
         */ this.procedureSets = new (0, $73ee494d7b86816e$export$6043bbbff85abf3c)();
        /**
         * To check wihether it is a `direct text rendering`.
         * @default true
         * @private
         */ this.isNormalRender = true;
        /**
         * check whether to `use font size` to calculate the shift.
         * @default false
         * @private
         */ this.isUseFontSize = false;
        /**
         * check whether the font is in `italic type`.
         * @default false
         * @private
         */ this.isItalic = false;
        /**
         * Check whether it is an `emf Text Matrix`.
         * @default false
         * @private
         */ this.isEmfTextScaled = false;
        /**
         * Check whether it is an `emf` call.
         * @default false
         * @private
         */ this.isEmf = false;
        /**
         * Check whether it is an `emf plus` call.
         * @default false
         * @private
         */ this.isEmfPlus = false;
        /**
         * Check whether it is in `base line format`.
         * @default true
         * @private
         */ this.isBaselineFormat = true;
        /**
         * Emf Text `Scaling Factor`.
         * @private
         */ this.emfScalingFactor = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
        /**
         * To check whether the `last color space` of document and garphics is saved.
         * @private
         */ this.colorSpaceChanged = false;
        /**
         * Stores an instance of `DictionaryProperties`.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * Checks whether the x co-ordinate is need to set as client size or not.
         * @hidden
         * @private
         */ this.isOverloadWithPosition = false;
        /**
         * Checks whether the x co-ordinate is need to set as client size or not.
         * @hidden
         * @private
         */ this.isPointOverload = false;
        /**
         * Current colorspaces.
         * @hidden
         * @private
         */ this.currentColorSpaces = [
            "RGB",
            "CMYK",
            "GrayScale",
            "Indexed"
        ];
        /**
         * Checks the current image `is optimized` or not.
         * @default false.
         * @private
         */ this.isImageOptimized = false;
        /**
         * Stores the `graphics states`.
         * @private
         */ this.graphicsState = [];
        /**
         * Indicates whether the object `had trasparency`.
         * @default false
         * @private
         */ this.istransparencySet = false;
        /**
         * Stores the instance of `PdfAutomaticFieldInfoCollection` class .
         * @default null
         * @private
         */ this.internalAutomaticFields = null;
        /**
         * Stores the index of the start line that should draw with in the next page.
         * @private
         */ this.startCutIndex = -1;
        this.getResources = arg2;
        this.canvasSize = arg1;
        if (arg3 instanceof (0, $2475646aad2db433$export$a3a234703dae340f)) this.pdfStreamWriter = arg3;
        else this.pdfStreamWriter = new (0, $2475646aad2db433$export$a3a234703dae340f)(arg3);
        this.initialize();
    }
    Object.defineProperty(PdfGraphics.prototype, "stringLayoutResult", {
        //  Properties
        /**
         * Returns the `result` after drawing string.
         * @private
         */ get: function() {
            return this.pdfStringLayoutResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "size", {
        /**
         * Gets the `size` of the canvas.
         * @private
         */ get: function() {
            return this.canvasSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "mediaBoxUpperRightBound", {
        /**
         * Gets and Sets the value of `MediaBox upper right bound`.
         * @private
         */ get: function() {
            if (typeof this.internalMediaBoxUpperRightBound === "undefined") this.internalMediaBoxUpperRightBound = 0;
            return this.internalMediaBoxUpperRightBound;
        },
        set: function(value) {
            this.internalMediaBoxUpperRightBound = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "clientSize", {
        /**
         * Gets the `size` of the canvas reduced by margins and page templates.
         * @private
         */ get: function() {
            return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.clipBounds.width, this.clipBounds.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "colorSpace", {
        /**
         * Gets or sets the current `color space` of the document
         * @private
         */ get: function() {
            return this.currentColorSpace;
        },
        set: function(value) {
            this.currentColorSpace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "streamWriter", {
        /**
         * Gets the `stream writer`.
         * @private
         */ get: function() {
            return this.pdfStreamWriter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "matrix", {
        /**
         * Gets the `transformation matrix` reflecting current transformation.
         * @private
         */ get: function() {
            if (this.transformationMatrix == null) this.transformationMatrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
            return this.transformationMatrix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "layer", {
        /**
         * Gets the `layer` for the graphics, if exists.
         * @private
         */ get: function() {
            return this.pageLayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "page", {
        /**
         * Gets the `page` for this graphics, if exists.
         * @private
         */ get: function() {
            return this.pageLayer.page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphics.prototype, "automaticFields", {
        get: function() {
            if (this.internalAutomaticFields == null || typeof this.internalAutomaticFields === "undefined") this.internalAutomaticFields = new (0, $71be2216ae09945b$export$d6fefdcdf2389ea0)();
            return this.internalAutomaticFields;
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    /**
     * `Initializes` this instance.
     * @private
     */ PdfGraphics.prototype.initialize = function() {
        this.bStateSaved = false;
        this.currentPen = null;
        this.currentBrush = null;
        this.currentFont = null;
        this.currentColorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        this.bCSInitialized = false;
        this.transformationMatrix = null;
        this.previousTextRenderingMode = -1; //.Fill;
        this.previousCharacterSpacing = -1;
        this.previousWordSpacing = -1;
        this.previousTextScaling = -100;
        // this.m_trasparencies = null;
        this.currentStringFormat = null;
        this.clipBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0), this.size);
        this.getResources.getResources().requireProcedureSet(this.procedureSets.pdf);
    };
    PdfGraphics.prototype.drawPdfTemplate = function(template, location, size) {
        if (typeof size === "undefined") {
            if (template == null) throw Error("ArgumentNullException-template");
            this.drawPdfTemplate(template, location, template.size);
        } else {
            // let crossTable : PdfCrossTable = null;
            // if (this.pageLayer != null) {
            //     crossTable = (this.page as PdfPage).section.parentDocument.crossTable;
            // }
            if (template == null) throw Error("ArgumentNullException-template");
            var scaleX = template.width > 0 ? size.width / template.width : 1;
            var scaleY = template.height > 0 ? size.height / template.height : 1;
            var bNeedScale = !(scaleX === 1 && scaleY === 1);
            // Save state.
            var state = this.save();
            // Take into consideration that rect location is bottom/left.
            var matrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
            if (this.pageLayer != null) this.getTranslateTransform(location.x, location.y + size.height, matrix);
            if (bNeedScale) this.getScaleTransform(scaleX, scaleY, matrix);
            this.pdfStreamWriter.modifyCtm(matrix);
            // Output template.
            var resources = this.getResources.getResources();
            var name_1 = resources.getName(template);
            this.pdfStreamWriter.executeObject(name_1);
            // Restore state.
            this.restore(state);
            //Transfer automatic fields from template.
            var g = template.graphics;
            if (g != null) for(var index = 0; index < g.automaticFields.automaticFields.length; index++){
                var fieldInfo = g.automaticFields.automaticFields[index];
                var newLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(fieldInfo.location.x + location.x, fieldInfo.location.y + location.y);
                var scalingX = template.size.width == 0 ? 0 : size.width / template.size.width;
                var scalingY = template.size.height == 0 ? 0 : size.height / template.size.height;
                this.automaticFields.add(new (0, $1ddf98521086c978$export$64e2124497f91cca)(fieldInfo.field, newLocation, scalingX, scalingY));
                this.page.dictionary.modify();
            }
            this.getResources.getResources().requireProcedureSet(this.procedureSets.imageB);
            this.getResources.getResources().requireProcedureSet(this.procedureSets.imageC);
            this.getResources.getResources().requireProcedureSet(this.procedureSets.imageI);
            this.getResources.getResources().requireProcedureSet(this.procedureSets.text);
        }
    };
    /**
     * @public
     */ PdfGraphics.prototype.drawString = function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
        if (typeof arg1 === "string" && arg2 instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b) && (arg3 instanceof (0, $54efcdfb173c5ebf$export$c07084e815da81a4) || arg3 === null) && (arg4 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5) || arg4 === null) && typeof arg5 === "number" && typeof arg6 === "number" && (arg7 instanceof (0, $0a9de299d3bdc240$export$9e0870cc2541dcff) || arg7 === null) && typeof arg8 === "undefined") {
            this.isOverloadWithPosition = true;
            this.drawString(arg1, arg2, arg3, arg4, arg5, arg6, this.clientSize.width - arg5, 0, arg7);
        } else {
            var temparg3 = arg3;
            var temparg4 = arg4;
            var temparg5 = arg5;
            var temparg6 = arg6;
            var temparg7 = arg7;
            var temparg8 = arg8;
            var temparg9 = arg9;
            var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
            var result = layouter.layout(arg1, arg2, temparg9, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(temparg7, temparg8), this.isOverloadWithPosition, this.clientSize);
            if (!result.empty) {
                var rect = this.checkCorrectLayoutRectangle(result.actualSize, temparg5, temparg6, temparg9);
                if (temparg7 <= 0) {
                    temparg5 = rect.x;
                    temparg7 = rect.width;
                }
                if (temparg8 <= 0) {
                    temparg6 = rect.y;
                    temparg8 = rect.height;
                }
                this.drawStringLayoutResult(result, arg2, temparg3, temparg4, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(temparg5, temparg6, temparg7, temparg8), temparg9);
                this.isEmfTextScaled = false;
                this.emfScalingFactor = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
            }
            this.getResources.getResources().requireProcedureSet(this.procedureSets.text);
            this.isNormalRender = true;
            this.pdfStringLayoutResult = result;
            this.isUseFontSize = false;
        }
    };
    PdfGraphics.prototype.drawLine = function(arg1, arg2, arg3, arg4, arg5) {
        if (arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) {
            var temparg2 = arg2;
            var temparg3 = arg3;
            this.drawLine(arg1, temparg2.x, temparg2.y, temparg3.x, temparg3.y);
        } else {
            var temparg2 = arg2;
            var temparg3 = arg3;
            var temparg4 = arg4;
            var temparg5 = arg5;
            this.stateControl(arg1, null, null);
            var sw = this.streamWriter;
            sw.beginPath(temparg2, temparg3);
            sw.appendLineSegment(temparg4, temparg5);
            sw.strokePath();
            this.getResources.getResources().requireProcedureSet(this.procedureSets.pdf);
        }
    };
    PdfGraphics.prototype.drawRectangle = function(arg1, arg2, arg3, arg4, arg5, arg6) {
        if (arg1 instanceof (0, $54efcdfb173c5ebf$export$c07084e815da81a4) && typeof arg2 === "number") {
            var temparg3 = arg3;
            this.drawRectangle(arg1, null, arg2, temparg3, arg4, arg5);
        } else if (arg1 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5) && typeof arg2 === "number") {
            var temparg3 = arg3;
            this.drawRectangle(null, arg1, arg2, temparg3, arg4, arg5);
        } else {
            var temparg3 = arg3;
            var temparg4 = arg4;
            var temparg5 = arg5;
            var temparg6 = arg6;
            if (arg2 instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) {
                this.bCSInitialized = false;
                var xOffset = this.matrix.matrix.offsetX + temparg3;
                var yOffset = void 0;
                if (this.layer != null && this.layer.page != null) yOffset = this.layer.page.size.height - this.matrix.matrix.offsetY + temparg4;
                else yOffset = this.clientSize.height - this.matrix.matrix.offsetY + temparg4;
                arg2.location = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(xOffset, yOffset);
                arg2.graphics.colorSpace = this.colorSpace;
            } else if (arg2 instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54)) arg2.colorSpace = this.colorSpace;
            if (arg2 instanceof (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e) && arg2.color.isEmpty) arg2 = null;
            var temparg1 = arg1;
            var temparg2 = arg2;
            this.stateControl(temparg1, temparg2, null);
            this.streamWriter.appendRectangle(temparg3, temparg4, temparg5, temparg6);
            this.drawPathHelper(temparg1, temparg2, false);
        }
    };
    /**
     * Draw rounded rectangle specified by a brush, pen, coordinate pair, a width, a height and a radius.
     * ```typescript
     * // Create a new PDF document.
     * let document : PdfDocument = new PdfDocument();
     * // Create a new page
     * let page : PdfPage = document.pages.add();
     * // Create brush for draw rectangle
     * let brush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(238, 130, 238));
     * // Create a new PDF pen
     * let pen: PdfPen = new PdfPen(new PdfColor(255, 0, 0), 1);
     * // Draw rounded rectangle
     * page.graphics.drawRoundedRectangle(pen, brush, 20, 20, 100, 50, 5);
     * // save the document
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param pen Stoke color of the rectangle.
     * @param brush Fill color of the rectangle.
     * @param x The x-coordinate of the upper-left corner of the rectangle to draw.
     * @param y The y-coordinate of the upper-left corner of the rectangle to draw.
     * @param width Width of the rectangle to draw.
     * @param height Height of the rectangle to draw.
     * @param radius Radius of the arcs to draw.
     */ PdfGraphics.prototype.drawRoundedRectangle = function(pen, brush, x, y, width, height, radius) {
        if (pen === null) throw new Error("pen");
        if (brush === null) throw new Error("brush");
        if (radius === 0) this.drawRectangle(pen, brush, x, y, width, height);
        else {
            var bounds = [
                x,
                y,
                width,
                height
            ];
            var diameter = radius * 2;
            var size = [
                diameter,
                diameter
            ];
            var arc = [
                bounds[0],
                bounds[1],
                size[0],
                size[1]
            ];
            this._pathPoints = [];
            this._pathTypes = [];
            var startFigure = true;
            startFigure = this._addArc(arc[0], arc[1], arc[2], arc[3], 180, 90, startFigure);
            arc[0] = bounds[0] + bounds[2] - diameter;
            startFigure = this._addArc(arc[0], arc[1], arc[2], arc[3], 270, 90, startFigure);
            arc[1] = bounds[1] + bounds[3] - diameter;
            startFigure = this._addArc(arc[0], arc[1], arc[2], arc[3], 0, 90, startFigure);
            arc[0] = bounds[0];
            startFigure = this._addArc(arc[0], arc[1], arc[2], arc[3], 90, 90, startFigure);
            var index = this._pathPoints.length - 1;
            var type = this._pathTypes[index];
            type = type | (0, $5ffc34ffc68e39dd$export$291db033450eaddd).CloseSubpath;
            this._pathTypes[index] = type;
            this._drawPath(pen, brush, this._pathPoints, this._pathTypes, (0, $d174213b46afc09a$export$6a8bdcdc458c5885).Alternate);
            this._pathPoints = [];
            this._pathTypes = [];
        }
    };
    PdfGraphics.prototype._addArc = function(x, y, width, height, startAngle, sweepAngle, startFigure) {
        var points = this._getBezierArcPoints(x, y, x + width, y + height, startAngle, sweepAngle);
        for(var i = 0; i < points.length; i = i + 8){
            var point = [
                points[i],
                points[i + 1],
                points[i + 2],
                points[i + 3],
                points[i + 4],
                points[i + 5],
                points[i + 6],
                points[i + 7]
            ];
            startFigure = this._addArcPoints(point, (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Bezier3, startFigure);
        }
        return startFigure;
    };
    PdfGraphics.prototype._addArcPoints = function(points, pointType, startFigure) {
        for(var i = 0; i < points.length; i++){
            var point = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(points[i], points[i + 1]);
            if (i === 0) {
                if (this._pathPoints.length === 0 || startFigure) {
                    this._addPoint(point, (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Start);
                    startFigure = false;
                } else if (point.x !== this._getLastPoint().x || point.y !== this._getLastPoint().y) this._addPoint(point, (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Line);
            } else this._addPoint(point, pointType);
            i++;
        }
        return startFigure;
    };
    PdfGraphics.prototype._getLastPoint = function() {
        var lastPoint = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
        var count = this._pathPoints.length;
        if (count > 0) {
            lastPoint.x = this._pathPoints[count - 1].x;
            lastPoint.y = this._pathPoints[count - 1].y;
        }
        return lastPoint;
    };
    PdfGraphics.prototype._addPoint = function(point, type) {
        this._pathPoints.push(point);
        this._pathTypes.push(type);
    };
    PdfGraphics.prototype._getBezierArcPoints = function(x1, y1, x2, y2, s1, e1) {
        if (x1 > x2) {
            var tmp = void 0;
            tmp = x1;
            x1 = x2;
            x2 = tmp;
        }
        if (y2 > y1) {
            var tmp = void 0;
            tmp = y1;
            y1 = y2;
            y2 = tmp;
        }
        var fragAngle;
        var numFragments;
        if (Math.abs(e1) <= 90) {
            fragAngle = e1;
            numFragments = 1;
        } else {
            numFragments = Math.ceil(Math.abs(e1) / 90);
            fragAngle = e1 / numFragments;
        }
        var xcen = (x1 + x2) / 2;
        var ycen = (y1 + y2) / 2;
        var rx = (x2 - x1) / 2;
        var ry = (y2 - y1) / 2;
        var halfAng = fragAngle * (Math.PI / 360);
        var kappa = Math.abs(4.0 / 3.0 * (1.0 - Math.cos(halfAng)) / Math.sin(halfAng));
        var pointList = [];
        for(var i = 0; i < numFragments; i++){
            var theta0 = (s1 + i * fragAngle) * (Math.PI / 180);
            var theta1 = (s1 + (i + 1) * fragAngle) * (Math.PI / 180);
            var cos0 = Math.cos(theta0);
            var cos1 = Math.cos(theta1);
            var sin0 = Math.sin(theta0);
            var sin1 = Math.sin(theta1);
            if (fragAngle > 0) pointList.push(xcen + rx * cos0, ycen - ry * sin0, xcen + rx * (cos0 - kappa * sin0), ycen - ry * (sin0 + kappa * cos0), xcen + rx * (cos1 + kappa * sin1), ycen - ry * (sin1 - kappa * cos1), xcen + rx * cos1, ycen - ry * sin1);
            else pointList.push(xcen + rx * cos0, ycen - ry * sin0, xcen + rx * (cos0 + kappa * sin0), ycen - ry * (sin0 - kappa * cos0), xcen + rx * (cos1 - kappa * sin1), ycen - ry * (sin1 + kappa * cos1), xcen + rx * cos1, ycen - ry * sin1);
        }
        return pointList;
    };
    PdfGraphics.prototype.drawPathHelper = function(arg1, arg2, arg3, arg4) {
        if (typeof arg3 === "boolean") {
            var temparg3 = arg3;
            this.drawPathHelper(arg1, arg2, (0, $d174213b46afc09a$export$6a8bdcdc458c5885).Winding, temparg3);
        } else {
            var temparg3 = arg3;
            var temparg4 = arg4;
            var isPen = arg1 != null;
            var isBrush = arg2 != null;
            var isEvenOdd = temparg3 === (0, $d174213b46afc09a$export$6a8bdcdc458c5885).Alternate;
            if (isPen && isBrush) this.streamWriter.fillStrokePath(isEvenOdd);
            else if (!isPen && !isBrush) this.streamWriter.endPath();
            else if (isPen) this.streamWriter.strokePath();
            else this.streamWriter.fillPath(isEvenOdd);
        }
    };
    PdfGraphics.prototype.drawImage = function(arg1, arg2, arg3, arg4, arg5) {
        if (typeof arg2 === "number" && typeof arg3 === "number" && typeof arg4 === "undefined") {
            var size = arg1.physicalDimension;
            this.drawImage(arg1, arg2, arg3, size.width, size.height);
        } else {
            var temparg2 = arg2;
            var temparg3 = arg3;
            var temparg4 = arg4;
            var temparg5 = arg5;
            arg1.save();
            var matrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
            this.getTranslateTransform(temparg2, temparg3 + temparg5, matrix);
            this.getScaleTransform(arg4, arg5, matrix);
            this.pdfStreamWriter.write("q");
            this.pdfStreamWriter.modifyCtm(matrix);
            // Output template.
            var resources = this.getResources.getResources();
            if (typeof this.pageLayer !== "undefined" && this.page != null) resources.document = this.page.document;
            var name_2 = resources.getName(arg1);
            if (typeof this.pageLayer !== "undefined") this.page.setResources(resources);
            this.pdfStreamWriter.executeObject(name_2);
            this.pdfStreamWriter.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).restoreState);
            this.pdfStreamWriter.write((0, $af8c9dd11ffb27bb$export$7fa100a28fbb5fe2).newLine);
            var resource = this.getResources.getResources();
            resource.requireProcedureSet(this.procedureSets.imageB);
            resource.requireProcedureSet(this.procedureSets.imageC);
            resource.requireProcedureSet(this.procedureSets.imageI);
            resource.requireProcedureSet(this.procedureSets.text);
        }
    };
    //Implementation
    /**
     * Returns `bounds` of the line info.
     * @private
     */ PdfGraphics.prototype.getLineBounds = function(lineIndex, result, font, layoutRectangle, format) {
        var bounds;
        if (!result.empty && lineIndex < result.lineCount && lineIndex >= 0) {
            var line = result.lines[lineIndex];
            var vShift = this.getTextVerticalAlignShift(result.actualSize.height, layoutRectangle.height, format);
            var y = vShift + layoutRectangle.y + result.lineHeight * lineIndex;
            var lineWidth = line.width;
            var hShift = this.getHorizontalAlignShift(lineWidth, layoutRectangle.width, format);
            var lineIndent = this.getLineIndent(line, format, layoutRectangle, lineIndex === 0);
            hShift += !this.rightToLeft(format) ? lineIndent : 0;
            var x = layoutRectangle.x + hShift;
            var width = !this.shouldJustify(line, layoutRectangle.width, format) ? lineWidth - lineIndent : layoutRectangle.width - lineIndent;
            var height = result.lineHeight;
            bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, width, height);
        } else bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
        return bounds;
    };
    /**
     * Creates `lay outed rectangle` depending on the text settings.
     * @private
     */ PdfGraphics.prototype.checkCorrectLayoutRectangle = function(textSize, x, y, format) {
        var layoutedRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, textSize.width, textSize.width);
        if (format != null) {
            switch(format.alignment){
                case (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center:
                    layoutedRectangle.x -= layoutedRectangle.width / 2;
                    break;
                case (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right:
                    layoutedRectangle.x -= layoutedRectangle.width;
                    break;
            }
            switch(format.lineAlignment){
                case (0, $d174213b46afc09a$export$2692e69612b4a9e9).Middle:
                    layoutedRectangle.y -= layoutedRectangle.height / 2;
                    break;
                case (0, $d174213b46afc09a$export$2692e69612b4a9e9).Bottom:
                    layoutedRectangle.y -= layoutedRectangle.height;
                    break;
            }
        }
        return layoutedRectangle;
    };
    /**
     * Sets the `layer` for the graphics.
     * @private
     */ PdfGraphics.prototype.setLayer = function(layer) {
        this.pageLayer = layer;
        var page = layer.page;
        if (page != null && typeof page !== "undefined") page.beginSave = this.pageSave;
    };
    /**
     * Adding page number field before page saving.
     * @private
     */ PdfGraphics.prototype.pageSave = function(page) {
        if (page.graphics.automaticFields != null) for(var i = 0; i < page.graphics.automaticFields.automaticFields.length; i++){
            var fieldInfo = page.graphics.automaticFields.automaticFields[i];
            fieldInfo.field.performDraw(page.graphics, fieldInfo.location, fieldInfo.scalingX, fieldInfo.scalingY);
        }
    };
    /**
     * `Draws a layout result`.
     * @private
     */ PdfGraphics.prototype.drawStringLayoutResult = function(result, font, pen, brush, layoutRectangle, format) {
        if (!result.empty) {
            this.applyStringSettings(font, pen, brush, format, layoutRectangle);
            // Set text scaling
            var textScaling = format != null ? format.horizontalScalingFactor : 100.0;
            if (textScaling !== this.previousTextScaling && !this.isEmfTextScaled) {
                this.pdfStreamWriter.setTextScaling(textScaling);
                this.previousTextScaling = textScaling;
            }
            var height = format == null || format.lineSpacing === 0 ? font.height : format.lineSpacing + font.height;
            var subScript = format != null && format.subSuperScript === (0, $32129651824bb502$export$72189ec4d9b4f960).SubScript;
            var shift = 0;
            shift = subScript ? height - (font.height + font.metrics.getDescent(format)) : height - font.metrics.getAscent(format);
            this.shift = shift;
            this.pdfStreamWriter.startNextLine(layoutRectangle.x, layoutRectangle.y - shift);
            this.pdfStreamWriter.setLeading(+height);
            var resultHeight = 0;
            var remainingString = "";
            for(var i = 0; i < result.lines.length; i++){
                resultHeight += result.lineHeight;
                if (layoutRectangle.y + resultHeight > this.clientSize.height) {
                    this.startCutIndex = i;
                    break;
                }
            }
            for(var j = this.startCutIndex; j < result.lines.length && j >= 0; j++)remainingString += result.lines[j].text;
            var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height);
            this.drawLayoutResult(result, font, format, layoutRectangle);
            this.underlineStrikeoutText(pen, brush, result, font, bounds, format);
            this.isEmfPlus = false;
            this.isUseFontSize = false;
            if (this.startCutIndex !== -1) {
                var page = this.getNextPage();
                page.graphics.drawString(remainingString, font, pen, brush, layoutRectangle.x, 0, layoutRectangle.width, 0, format);
            }
        } else throw new Error("ArgumentNullException:result");
    };
    /**
     * Gets the `next page`.
     * @private
     */ PdfGraphics.prototype.getNextPage = function() {
        var section = this.currentPage.section;
        var nextPage = null;
        var index = section.indexOf(this.currentPage);
        if (index === section.count - 1) nextPage = section.add();
        else nextPage = section.getPages()[index + 1];
        return nextPage;
    };
    PdfGraphics.prototype.setClip = function(rectangle, mode) {
        if (typeof mode === "undefined") this.setClip(rectangle, (0, $d174213b46afc09a$export$6a8bdcdc458c5885).Winding);
        else {
            this.pdfStreamWriter.appendRectangle(rectangle);
            this.pdfStreamWriter.clipPath(mode === (0, $d174213b46afc09a$export$6a8bdcdc458c5885).Alternate);
        }
    };
    /**
     * Applies all the `text settings`.
     * @private
     */ PdfGraphics.prototype.applyStringSettings = function(font, pen, brush, format, bounds) {
        if (brush instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) {
            this.bCSInitialized = false;
            brush.graphics.colorSpace = this.colorSpace;
        } else if (brush instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54)) {
            this.bCSInitialized = false;
            brush.colorSpace = this.colorSpace;
        }
        var setLineWidth = false;
        var tm = this.getTextRenderingMode(pen, brush, format);
        this.stateControl(pen, brush, font, format);
        this.pdfStreamWriter.beginText();
        if (tm !== this.previousTextRenderingMode) {
            this.pdfStreamWriter.setTextRenderingMode(tm);
            this.previousTextRenderingMode = tm;
        }
        // Set character spacing.
        var cs = format != null ? format.characterSpacing : 0;
        if (cs !== this.previousCharacterSpacing && !this.isEmfTextScaled) {
            this.pdfStreamWriter.setCharacterSpacing(cs);
            this.previousCharacterSpacing = cs;
        }
        // Set word spacing.
        // NOTE: it works only if the space code is equal to 32 (0x20).
        var ws = format != null ? format.wordSpacing : 0;
        if (ws !== this.previousWordSpacing) {
            this.pdfStreamWriter.setWordSpacing(ws);
            this.previousWordSpacing = ws;
        }
    };
    /**
     * Calculates `shift value` if the text is vertically aligned.
     * @private
     */ PdfGraphics.prototype.getTextVerticalAlignShift = function(textHeight, boundsHeight, format) {
        var shift = 0;
        if (boundsHeight >= 0 && format != null && format.lineAlignment !== (0, $d174213b46afc09a$export$2692e69612b4a9e9).Top) switch(format.lineAlignment){
            case (0, $d174213b46afc09a$export$2692e69612b4a9e9).Middle:
                shift = (boundsHeight - textHeight) / 2;
                break;
            case (0, $d174213b46afc09a$export$2692e69612b4a9e9).Bottom:
                shift = boundsHeight - textHeight;
                break;
        }
        return shift;
    };
    /**
     * `Draws layout result`.
     * @private
     */ PdfGraphics.prototype.drawLayoutResult = function(result, font, format, layoutRectangle) {
        var vAlignShift = this.getTextVerticalAlignShift(result.actualSize.height, layoutRectangle.height, format);
        if (vAlignShift !== 0) this.pdfStreamWriter.startNextLine(0, vAlignShift);
        var ttfFont = font;
        var unicode = ttfFont != null && ttfFont.isUnicode;
        var embed = ttfFont != null && ttfFont.isEmbedFont;
        var lines = result.lines;
        for(var i = 0, len = lines.length; i < len && i !== this.startCutIndex; i++){
            var lineInfo = lines[i];
            var line = lineInfo.text;
            var lineWidth = lineInfo.width;
            var hAlignShift = this.getHorizontalAlignShift(lineWidth, layoutRectangle.width, format);
            var lineIndent = this.getLineIndent(lineInfo, format, layoutRectangle, i === 0);
            hAlignShift += !this.rightToLeft(format) ? lineIndent : 0;
            if (hAlignShift !== 0 && !this.isEmfTextScaled) this.pdfStreamWriter.startNextLine(hAlignShift, 0);
            if (unicode) this.drawUnicodeLine(lineInfo, layoutRectangle, font, format);
            else this.drawAsciiLine(lineInfo, layoutRectangle, font, format);
            if (hAlignShift !== 0 && !this.isEmfTextScaled) this.pdfStreamWriter.startNextLine(-hAlignShift, 0);
            if (this.isOverloadWithPosition && lines.length > 1) {
                this.pdfStreamWriter.startNextLine(-layoutRectangle.x, 0);
                layoutRectangle.x = 0;
                layoutRectangle.width = this.clientSize.width;
                this.isOverloadWithPosition = false;
                this.isPointOverload = true;
            }
        }
        this.getResources.getResources().requireProcedureSet(this.procedureSets.text);
        if (vAlignShift !== 0) this.pdfStreamWriter.startNextLine(0, -(vAlignShift - result.lineHeight));
        this.pdfStreamWriter.endText();
    };
    /**
     * `Draws Ascii line`.
     * @private
     */ PdfGraphics.prototype.drawAsciiLine = function(lineInfo, layoutRectangle, font, format) {
        this.justifyLine(lineInfo, layoutRectangle.width, format);
        var value = "";
        if (lineInfo.text.indexOf("(") !== -1 || lineInfo.text.indexOf(")") !== -1) for(var i = 0; i < lineInfo.text.length; i++){
            if (lineInfo.text[i] === "(") value += "\\(";
            else if (lineInfo.text[i] === ")") value += "\\)";
            else value += lineInfo.text[i];
        }
        if (value === "") value = lineInfo.text;
        var line = "(" + value + ")";
        this.pdfStreamWriter.showNextLineText(new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)(line));
    };
    /**
     * Draws unicode line.
     * @private
     */ PdfGraphics.prototype.drawUnicodeLine = function(lineInfo, layoutRectangle, font, format) {
        var line = lineInfo.text;
        var lineWidth = lineInfo.width;
        var rtl = format !== null && typeof format !== "undefined" && format.rightToLeft;
        var useWordSpace = format !== null && typeof format !== "undefined" && (format.wordSpacing !== 0 || format.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify);
        var ttfFont = font;
        var wordSpacing = this.justifyLine(lineInfo, layoutRectangle.width, format);
        var rtlRender = new (0, $6d1b729459efb672$export$f23a0a3175647431)();
        if (rtl || format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) {
            var blocks = null;
            var rightAlign = format !== null && typeof format !== "undefined" && format.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right;
            if (format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) /* tslint:disable-next-line:max-line-length */ blocks = rtlRender.layout(line, ttfFont, format.textDirection === (0, $d174213b46afc09a$export$96fe374e3268ced4).RightToLeft ? true : false, useWordSpace, format);
            else blocks = rtlRender.layout(line, ttfFont, rightAlign, useWordSpace, format);
            var words = null;
            if (blocks.length > 1) {
                if (format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) /* tslint:disable-next-line:max-line-length */ words = rtlRender.splitLayout(line, ttfFont, format.textDirection === (0, $d174213b46afc09a$export$96fe374e3268ced4).RightToLeft ? true : false, useWordSpace, format);
                else words = rtlRender.splitLayout(line, ttfFont, rightAlign, useWordSpace, format);
            } else words = [
                line
            ];
            this.drawUnicodeBlocks(blocks, words, ttfFont, format, wordSpacing);
        } else if (useWordSpace) {
            var result = this.breakUnicodeLine(line, ttfFont, null);
            var blocks = result.tokens;
            var words = result.words;
            this.drawUnicodeBlocks(blocks, words, ttfFont, format, wordSpacing);
        } else {
            var token = this.convertToUnicode(line, ttfFont);
            var value = this.getUnicodeString(token);
            this.streamWriter.showNextLineText(value);
        }
    };
    /**
     * Draws array of unicode tokens.
     */ PdfGraphics.prototype.drawUnicodeBlocks = function(blocks, words, font, format, wordSpacing) {
        if (blocks == null) throw new Error("Argument Null Exception : blocks");
        if (words == null) throw new Error("Argument Null Exception : words");
        if (font == null) throw new Error("Argument Null Exception : font");
        this.streamWriter.startNextLine();
        var x = 0;
        var xShift = 0;
        var firstLineIndent = 0;
        var paragraphIndent = 0;
        try {
            if (format !== null && typeof format !== "undefined") {
                firstLineIndent = format.firstLineIndent;
                paragraphIndent = format.paragraphIndent;
                format.firstLineIndent = 0;
                format.paragraphIndent = 0;
            }
            var spaceWidth = font.getCharWidth((0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace, format) + wordSpacing;
            var characterSpacing = format != null ? format.characterSpacing : 0;
            var wordSpace = format !== null && typeof format !== "undefined" && wordSpacing === 0 ? format.wordSpacing : 0;
            spaceWidth += characterSpacing + wordSpace;
            for(var i = 0; i < blocks.length; i++){
                var token = blocks[i];
                var word = words[i];
                var tokenWidth = 0;
                if (x !== 0) this.streamWriter.startNextLine(x, 0);
                if (word.length > 0) {
                    tokenWidth += /*Utils.Round(*/ font.measureString(word, format).width /*)*/ ;
                    tokenWidth += characterSpacing;
                    var val = this.getUnicodeString(token);
                    this.streamWriter.showText(val);
                }
                if (i !== blocks.length - 1) {
                    x = tokenWidth + spaceWidth;
                    xShift += x;
                }
            }
            // Rolback current line position.
            if (xShift > 0) this.streamWriter.startNextLine(-xShift, 0);
        } finally{
            if (format !== null && typeof format !== "undefined") {
                format.firstLineIndent = firstLineIndent;
                format.paragraphIndent = paragraphIndent;
            }
        }
    };
    /**
     * Breakes the unicode line to the words and converts symbols to glyphs.
     */ PdfGraphics.prototype.breakUnicodeLine = function(line, ttfFont, words) {
        if (line === null) throw new Error("Argument Null Exception : line");
        words = line.split(null);
        var tokens = [];
        for(var i = 0; i < words.length; i++){
            // Reconvert string according to unicode standard.
            var word = words[i];
            var token = this.convertToUnicode(word, ttfFont);
            tokens[i] = token;
        }
        return {
            tokens: tokens,
            words: words
        };
    };
    /**
     * Creates PdfString from the unicode text.
     */ PdfGraphics.prototype.getUnicodeString = function(token) {
        if (token === null) throw new Error("Argument Null Exception : token");
        var val = new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)(token);
        val.converted = true;
        val.encode = (0, $e48c8fcac1e340e6$export$efbe7cbddf4d0360).ForceEncoding.Ascii;
        return val;
    };
    /**
     * Converts to unicode format.
     */ PdfGraphics.prototype.convertToUnicode = function(text, ttfFont) {
        var token = null;
        if (text == null) throw new Error("Argument Null Exception : text");
        if (ttfFont == null) throw new Error("Argument Null Exception : ttfFont");
        if (ttfFont.fontInternal instanceof (0, $13da76851e74b0e2$export$c62c39062f746216)) {
            var ttfReader = ttfFont.fontInternal.ttfReader;
            ttfFont.setSymbols(text);
            token = ttfReader.convertString(text);
            var bytes = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).toUnicodeArray(token, false);
            token = (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83).byteToString(bytes);
        }
        return token;
    };
    /**
     * `Justifies` the line if needed.
     * @private
     */ PdfGraphics.prototype.justifyLine = function(lineInfo, boundsWidth, format) {
        var line = lineInfo.text;
        var lineWidth = lineInfo.width;
        var shouldJustify = this.shouldJustify(lineInfo, boundsWidth, format);
        var hasWordSpacing = format != null && format.wordSpacing !== 0;
        var symbols = (0, $6d330c1e9d5e5065$export$c130daea5962048f).spaces;
        var whitespacesCount = (0, $6d330c1e9d5e5065$export$c130daea5962048f).getCharsCount(line, symbols);
        var wordSpace = 0;
        if (shouldJustify) {
            // Correct line width.
            if (hasWordSpacing) lineWidth -= whitespacesCount * format.wordSpacing;
            var difference = boundsWidth - lineWidth;
            wordSpace = difference / whitespacesCount;
            this.pdfStreamWriter.setWordSpacing(wordSpace);
        } else // If there is justifying, but the line shouldn't be justified, restore default word spacing.
        if (hasWordSpacing) this.pdfStreamWriter.setWordSpacing(format.wordSpacing);
        else this.pdfStreamWriter.setWordSpacing(0);
        return wordSpace;
    };
    /**
     * `Reset` or reinitialize the current graphic value.
     * @private
     */ PdfGraphics.prototype.reset = function(size) {
        this.canvasSize = size;
        this.streamWriter.clear();
        this.initialize();
        this.initializeCoordinates();
    };
    /**
     * Checks whether the line should be `justified`.
     * @private
     */ PdfGraphics.prototype.shouldJustify = function(lineInfo, boundsWidth, format) {
        var line = lineInfo.text;
        var lineWidth = lineInfo.width;
        var justifyStyle = format != null && format.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify;
        var goodWidth = boundsWidth >= 0 && lineWidth < boundsWidth;
        var symbols = (0, $6d330c1e9d5e5065$export$c130daea5962048f).spaces;
        var whitespacesCount = (0, $6d330c1e9d5e5065$export$c130daea5962048f).getCharsCount(line, symbols);
        var hasSpaces = whitespacesCount > 0 && line[0] !== (0, $6d330c1e9d5e5065$export$c130daea5962048f).whiteSpace;
        var goodLineBreakStyle = (lineInfo.lineType & (0, $da0806e60b4d67c7$export$aa318e0578993894).LayoutBreak) > 0;
        var shouldJustify = justifyStyle && goodWidth && hasSpaces && (goodLineBreakStyle || format.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify);
        return shouldJustify;
    };
    /**
     * Emulates `Underline, Strikeout` of the text if needed.
     * @private
     */ PdfGraphics.prototype.underlineStrikeoutText = function(pen, brush, result, font, layoutRectangle, format) {
        if (font.underline || font.strikeout) {
            // Calculate line width.
            var linePen = this.createUnderlineStikeoutPen(pen, brush, font, format);
            if (linePen != null) {
                // Approximate line positions.
                var vShift = this.getTextVerticalAlignShift(result.actualSize.height, layoutRectangle.height, format);
                var underlineYOffset = 0;
                underlineYOffset = layoutRectangle.y + vShift + font.metrics.getAscent(format) + 1.5 * linePen.width;
                var strikeoutYOffset = layoutRectangle.y + vShift + font.metrics.getHeight(format) / 2 + 1.5 * linePen.width;
                var lines = result.lines;
                // Run through the text and draw lines.
                for(var i = 0, len = result.lineCount; i < len; i++){
                    var lineInfo = lines[i];
                    var line = lineInfo.text;
                    var lineWidth = lineInfo.width;
                    var hShift = this.getHorizontalAlignShift(lineWidth, layoutRectangle.width, format);
                    var lineIndent = this.getLineIndent(lineInfo, format, layoutRectangle, i === 0);
                    hShift += !this.rightToLeft(format) ? lineIndent : 0;
                    var x1 = layoutRectangle.x + hShift;
                    var x2 = !this.shouldJustify(lineInfo, layoutRectangle.width, format) ? x1 + lineWidth - lineIndent : x1 + layoutRectangle.width - lineIndent;
                    if (font.underline) {
                        var y = underlineYOffset;
                        this.drawLine(linePen, x1, y, x2, y);
                        underlineYOffset += result.lineHeight;
                    }
                    if (font.strikeout) {
                        var y = strikeoutYOffset;
                        this.drawLine(linePen, x1, y, x2, y);
                        strikeoutYOffset += result.lineHeight;
                    }
                    if (this.isPointOverload && lines.length > 1) {
                        layoutRectangle.x = 0;
                        layoutRectangle.width = this.clientSize.width;
                    }
                }
                this.isPointOverload = false;
            }
        }
    };
    /**
     * `Creates a pen` for drawing lines in the text.
     * @private
     */ PdfGraphics.prototype.createUnderlineStikeoutPen = function(pen, brush, font, format) {
        // Calculate line width.
        var lineWidth = font.metrics.getSize(format) / 20;
        var linePen = null;
        // Create a pen fo the lines.
        if (pen != null) linePen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(pen.color, lineWidth);
        else if (brush != null) linePen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(brush, lineWidth);
        return linePen;
    };
    /**
     * Return `text rendering mode`.
     * @private
     */ PdfGraphics.prototype.getTextRenderingMode = function(pen, brush, format) {
        var tm = (0, $d174213b46afc09a$export$ca45e4ab114d4814).None;
        if (pen != null && brush != null) tm = (0, $d174213b46afc09a$export$ca45e4ab114d4814).FillStroke;
        else if (pen != null) tm = (0, $d174213b46afc09a$export$ca45e4ab114d4814).Stroke;
        else tm = (0, $d174213b46afc09a$export$ca45e4ab114d4814).Fill;
        if (format != null && format.clipPath) tm |= (0, $d174213b46afc09a$export$ca45e4ab114d4814).ClipFlag;
        return tm;
    };
    /**
     * Returns `line indent` for the line.
     * @private
     */ PdfGraphics.prototype.getLineIndent = function(lineInfo, format, layoutBounds, firstLine) {
        var lineIndent = 0;
        var firstParagraphLine = (lineInfo.lineType & (0, $da0806e60b4d67c7$export$aa318e0578993894).FirstParagraphLine) > 0;
        if (format != null && firstParagraphLine) {
            lineIndent = firstLine ? format.firstLineIndent : format.paragraphIndent;
            lineIndent = layoutBounds.width > 0 ? Math.min(layoutBounds.width, lineIndent) : lineIndent;
        }
        return lineIndent;
    };
    /**
     * Calculates shift value if the line is `horizontaly aligned`.
     * @private
     */ PdfGraphics.prototype.getHorizontalAlignShift = function(lineWidth, boundsWidth, format) {
        var shift = 0;
        if (boundsWidth >= 0 && format != null && format.alignment !== (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left) switch(format.alignment){
            case (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center:
                shift = (boundsWidth - lineWidth) / 2;
                break;
            case (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right:
                shift = boundsWidth - lineWidth;
                break;
        }
        return shift;
    };
    /**
     * Gets or sets the value that indicates `text direction` mode.
     * @private
     */ PdfGraphics.prototype.rightToLeft = function(format) {
        var rtl = format !== null && typeof format !== "undefined" && format.rightToLeft;
        if (format !== null && typeof format !== "undefined") {
            if (format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None && typeof format.textDirection !== "undefined") rtl = true;
        }
        return rtl;
    };
    PdfGraphics.prototype.stateControl = function(pen, brush, font, format) {
        if (typeof format === "undefined") this.stateControl(pen, brush, font, null);
        else {
            if (brush instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54)) {
                this.bCSInitialized = false;
                brush.colorSpace = this.colorSpace;
            }
            if (brush instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) {
                this.bCSInitialized = false;
                brush.graphics.colorSpace = this.colorSpace;
            }
            var saveState = false;
            if (brush !== null) {
                var solidBrush = brush;
                if (typeof this.pageLayer !== "undefined" && this.pageLayer != null) {
                    if (this.colorSpaceChanged === false) {
                        this.lastDocumentCS = this.pageLayer.page.document.colorSpace;
                        this.lastGraphicsCS = this.pageLayer.page.graphics.colorSpace;
                        this.colorSpace = this.pageLayer.page.document.colorSpace;
                        this.currentColorSpace = this.pageLayer.page.document.colorSpace;
                        this.colorSpaceChanged = true;
                    }
                }
                this.initCurrentColorSpace(this.currentColorSpace);
            } else if (pen != null) {
                var pdfPen = pen;
                if (typeof this.pageLayer !== "undefined" && this.pageLayer != null) {
                    this.colorSpace = this.pageLayer.page.document.colorSpace;
                    this.currentColorSpace = this.pageLayer.page.document.colorSpace;
                }
                this.initCurrentColorSpace(this.currentColorSpace);
            }
            this.penControl(pen, saveState);
            this.brushControl(brush, saveState);
            this.fontControl(font, format, saveState);
        }
    };
    /**
     * Initializes the `current color space`.
     * @private
     */ PdfGraphics.prototype.initCurrentColorSpace = function(colorspace) {
        var re = this.getResources.getResources();
        if (!this.bCSInitialized) {
            if (this.currentColorSpace != (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).GrayScale) {
                this.pdfStreamWriter.setColorSpace("Device" + this.currentColorSpaces[this.currentColorSpace], true);
                this.pdfStreamWriter.setColorSpace("Device" + this.currentColorSpaces[this.currentColorSpace], false);
                this.bCSInitialized = true;
            } else {
                this.pdfStreamWriter.setColorSpace("DeviceGray", true);
                this.pdfStreamWriter.setColorSpace("DeviceGray", false);
                this.bCSInitialized = true;
            }
        }
    };
    /**
     * Controls the `pen state`.
     * @private
     */ PdfGraphics.prototype.penControl = function(pen, saveState) {
        if (pen != null) {
            this.currentPen = pen;
            pen.monitorChanges(this.currentPen, this.pdfStreamWriter, this.getResources, saveState, this.colorSpace, this.matrix.clone());
            this.currentPen = pen.clone();
        }
    };
    /**
     * Controls the `brush state`.
     * @private
     */ PdfGraphics.prototype.brushControl = function(brush, saveState) {
        if (brush != null && typeof brush !== "undefined") {
            var b = brush.clone();
            var lgb = b;
            if (lgb !== null && typeof lgb !== "undefined" && !(brush instanceof (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)) && !(brush instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc))) {
                var m = lgb.matrix;
                var matrix = this.matrix.clone();
                if (m != null) {
                    m.multiply(matrix);
                    matrix = m;
                }
                lgb.matrix = matrix;
            }
            this.currentBrush = lgb;
            var br = brush;
            b.monitorChanges(this.currentBrush, this.pdfStreamWriter, this.getResources, saveState, this.colorSpace);
            this.currentBrush = brush;
            brush = null;
        }
    };
    /**
     * Saves the font and other `font settings`.
     * @private
     */ PdfGraphics.prototype.fontControl = function(font, format, saveState) {
        if (font != null) {
            var curSubSuper = format != null ? format.subSuperScript : (0, $32129651824bb502$export$72189ec4d9b4f960).None;
            var prevSubSuper = this.currentStringFormat != null ? this.currentStringFormat.subSuperScript : (0, $32129651824bb502$export$72189ec4d9b4f960).None;
            if (saveState || font !== this.currentFont || curSubSuper !== prevSubSuper) {
                var resources = this.getResources.getResources();
                this.currentFont = font;
                this.currentStringFormat = format;
                var size = font.metrics.getSize(format);
                this.isEmfTextScaled = false;
                var fontName = resources.getName(font);
                this.pdfStreamWriter.setFont(font, fontName, size);
            }
        }
    };
    PdfGraphics.prototype.setTransparency = function(arg1, arg2, arg3) {
        if (typeof arg2 === "undefined") {
            this.istransparencySet = true;
            this.setTransparency(arg1, arg1, (0, $d174213b46afc09a$export$69caf60bba815dab).Normal);
        } else if (typeof arg2 === "number" && typeof arg3 === "undefined") this.setTransparency(arg1, arg2, (0, $d174213b46afc09a$export$69caf60bba815dab).Normal);
        else {
            if (this.trasparencies == null) this.trasparencies = new (0, $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb)();
            var transp = null;
            var td = new $fb8dc0c26a98dd16$var$TransparencyData(arg1, arg2, arg3);
            if (this.trasparencies.containsKey(td)) transp = this.trasparencies.getValue(td);
            if (transp == null) {
                transp = new (0, $0ede958bcf41280e$export$9ef1b6d3d933406c)(arg1, arg2, arg3);
                this.trasparencies.setValue(td, transp);
            }
            var resources = this.getResources.getResources();
            var name_3 = resources.getName(transp);
            var sw = this.streamWriter;
            sw.setGraphicsState(name_3);
        }
    };
    PdfGraphics.prototype.clipTranslateMargins = function(x, y, left, top, right, bottom) {
        if (x instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof y === "undefined") {
            this.clipBounds = x;
            this.pdfStreamWriter.writeComment("Clip margins.");
            this.pdfStreamWriter.appendRectangle(x);
            this.pdfStreamWriter.closePath();
            this.pdfStreamWriter.clipPath(false);
            this.pdfStreamWriter.writeComment("Translate co-ordinate system.");
            this.translateTransform(x.x, x.y);
        } else if (typeof x === "number") {
            var clipArea = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(left, top, this.size.width - left - right, this.size.height - top - bottom);
            this.clipBounds = clipArea;
            this.pdfStreamWriter.writeComment("Clip margins.");
            this.pdfStreamWriter.appendRectangle(clipArea);
            this.pdfStreamWriter.closePath();
            this.pdfStreamWriter.clipPath(false);
            this.pdfStreamWriter.writeComment("Translate co-ordinate system.");
            this.translateTransform(x, y);
        }
    };
    /**
     * `Updates y` co-ordinate.
     * @private
     */ PdfGraphics.prototype.updateY = function(y) {
        return -y;
    };
    /**
     * Used to `translate the transformation`.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // create a new page
     * let page1 : PdfPage = document.pages.add();
     * // set pen
     * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
     * //
     * // set translate transform
     * page1.graphics.translateTransform(100, 100);
     * //
     * // draw the rectangle after applying translate transform
     * page1.graphics.drawRectangle(pen, new RectangleF({x : 0, y : 0}, {width : 100, height : 50}));
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param offsetX The x-coordinate of the translation.
     * @param offsetY The y-coordinate of the translation.
     */ PdfGraphics.prototype.translateTransform = function(offsetX, offsetY) {
        var matrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
        this.getTranslateTransform(offsetX, offsetY, matrix);
        this.pdfStreamWriter.modifyCtm(matrix);
        this.matrix.multiply(matrix);
    };
    /**
     * `Translates` coordinates of the input matrix.
     * @private
     */ PdfGraphics.prototype.getTranslateTransform = function(x, y, input) {
        input.translate(x, this.updateY(y));
        return input;
    };
    /**
     * Applies the specified `scaling operation` to the transformation matrix of this Graphics by prepending it to the object's transformation matrix.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // create a new page
     * let page1 : PdfPage = document.pages.add();
     * // create pen
     * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
     * //
     * // apply scaling trasformation
     * page1.graphics.scaleTransform(1.5, 2);
     * //
     * // draw the rectangle after applying scaling transform
     * page1.graphics.drawRectangle(pen, new RectangleF({x : 100, y : 100}, {width : 100, height : 50}));
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param scaleX Scale factor in the x direction.
     * @param scaleY Scale factor in the y direction.
     */ PdfGraphics.prototype.scaleTransform = function(scaleX, scaleY) {
        var matrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
        this.getScaleTransform(scaleX, scaleY, matrix);
        this.pdfStreamWriter.modifyCtm(matrix);
        this.matrix.multiply(matrix);
    };
    /**
     * `Scales` coordinates of the input matrix.
     * @private
     */ PdfGraphics.prototype.getScaleTransform = function(x, y, input) {
        if (input == null) input = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
        input.scale(x, y);
        return input;
    };
    /**
     * Applies the specified `rotation` to the transformation matrix of this Graphics.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // create a new page
     * let page1 : PdfPage = document.pages.add();
     * // create pen
     * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
     * //
     * // set RotateTransform with 25 degree of angle
     * page1.graphics.rotateTransform(25);
     * //
     * // draw the rectangle after RotateTransformation
     * page1.graphics.drawRectangle(pen, new RectangleF({x : 100, y : 100}, {width : 100, height : 50}));
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param angle Angle of rotation in degrees.
     */ PdfGraphics.prototype.rotateTransform = function(angle) {
        var matrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
        this.getRotateTransform(angle, matrix);
        this.pdfStreamWriter.modifyCtm(matrix);
        this.matrix.multiply(matrix);
    };
    /**
     * `Initializes coordinate system`.
     * @private
     */ PdfGraphics.prototype.initializeCoordinates = function() {
        // Matrix equation: TM(T-1)=M', where T=[1 0 0 -1 0 h]
        this.pdfStreamWriter.writeComment("Change co-ordinate system to left/top.");
        // Translate co-ordinates only, don't flip.
        if (this.mediaBoxUpperRightBound !== -this.size.height) {
            if (this.cropBox == null) {
                if (this.mediaBoxUpperRightBound === this.size.height || this.mediaBoxUpperRightBound === 0) this.translateTransform(0, this.updateY(this.size.height));
                else this.translateTransform(0, this.updateY(this.mediaBoxUpperRightBound));
            }
        }
    };
    /**
     * `Rotates` coordinates of the input matrix.
     * @private
     */ PdfGraphics.prototype.getRotateTransform = function(angle, input) {
        if (input == null || typeof input === "undefined") input = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
        input.rotate(this.updateY(angle));
        return input;
    };
    /**
     * `Saves` the current state of this Graphics and identifies the saved state with a GraphicsState.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // create a new page
     * let page1 : PdfPage = document.pages.add();
     * // create pen
     * let pen : PdfPen = new PdfPen(new PdfColor(0, 0, 0));
     * //
     * // save the graphics state
     * let state1 : PdfGraphicsState = page1.graphics.save();
     * //
     * page1.graphics.scaleTransform(1.5, 2);
     * // draw the rectangle
     * page1.graphics.drawRectangle(pen, new RectangleF({x : 100, y : 100}, {width : 100, height : 50}));
     * // restore the graphics state
     * page1.graphics.restore(state1);
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     */ PdfGraphics.prototype.save = function() {
        var state = new $fb8dc0c26a98dd16$export$a19a3822b1d2d1df(this, this.matrix.clone());
        state.brush = this.currentBrush;
        state.pen = this.currentPen;
        state.font = this.currentFont;
        state.colorSpace = this.currentColorSpace;
        state.characterSpacing = this.previousCharacterSpacing;
        state.wordSpacing = this.previousWordSpacing;
        state.textScaling = this.previousTextScaling;
        state.textRenderingMode = this.previousTextRenderingMode;
        this.graphicsState.push(state);
        this.pdfStreamWriter.saveGraphicsState();
        return state;
    };
    PdfGraphics.prototype.restore = function(state) {
        if (typeof state === "undefined") {
            if (this.graphicsState.length > 0) this.doRestoreState();
        } else {
            if (this.graphicsState.indexOf(state) !== -1) for(;;){
                if (this.graphicsState.length === 0) break;
                var popState = this.doRestoreState();
                if (popState === state) break;
            }
        }
    };
    /**
     * `Restores graphics state`.
     * @private
     */ PdfGraphics.prototype.doRestoreState = function() {
        var state = this.graphicsState.pop();
        this.transformationMatrix = state.matrix;
        this.currentBrush = state.brush;
        this.currentPen = state.pen;
        this.currentFont = state.font;
        this.currentColorSpace = state.colorSpace;
        this.previousCharacterSpacing = state.characterSpacing;
        this.previousWordSpacing = state.wordSpacing;
        this.previousTextScaling = state.textScaling;
        this.previousTextRenderingMode = state.textRenderingMode;
        this.pdfStreamWriter.restoreGraphicsState();
        return state;
    };
    /**
     * `Draws the specified path`, using its original physical size, at the location specified by a coordinate pair.
     * ```typescript
     * // create a new PDF document.
     * let document : PdfDocument = new PdfDocument();
     * // add a page to the document.
     * let page1 : PdfPage = document.pages.add();
     * //Create new PDF path.
     * let path : PdfPath = new PdfPath();
     * //Add line path points.
     * path.addLine(new PointF(10, 100), new PointF(10, 200));
     * path.addLine(new PointF(100, 100), new PointF(100, 200));
     * path.addLine(new PointF(100, 200), new PointF(55, 150));
     * // set pen
     * let pen : PdfPen = new PdfPen(new PdfColor(255, 0, 0));
     * // set brush
     * let brush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
     * // draw the path
     * page1.graphics.drawPath(pen, brush, path);
     * //
     * // save the document.
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     * @param pen Color of the text.
     * @param brush Color of the text.
     * @param path Draw path.
     */ PdfGraphics.prototype.drawPath = function(pen, brush, path) {
        this._drawPath(pen, brush, path.pathPoints, path.pathTypes, path.fillMode);
    };
    PdfGraphics.prototype._drawPath = function(pen, brush, pathPoints, pathTypes, fillMode) {
        if (brush instanceof (0, $3bd0650cea4e8a32$export$77a6ef39f02aa8bc)) {
            this.bCSInitialized = false;
            brush.graphics.colorSpace = this.colorSpace;
        } else if (brush instanceof (0, $6587e87f441fc490$export$63959b57c9e2ff54)) {
            this.bCSInitialized = false;
            brush.colorSpace = this.colorSpace;
        }
        this.stateControl(pen, brush, null);
        this.buildUpPath(pathPoints, pathTypes);
        this.drawPathHelper(pen, brush, fillMode, false);
    };
    /* tslint:disable-next-line:max-line-length */ PdfGraphics.prototype.drawArc = function(arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
        if (arg2 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02)) this.drawArc(arg1, arg2.x, arg2.y, arg2.width, arg2.height, arg3, arg4);
        else if (arg7 !== 0) {
            this.stateControl(arg1, null, null);
            this.constructArcPath(arg2, arg3, arg2 + arg4, arg3 + arg5, arg6, arg7);
            this.drawPathHelper(arg1, null, false);
        }
    };
    /**
     * Builds up the path.
     * @private
     */ PdfGraphics.prototype.buildUpPath = function(arg1, arg2) {
        var cnt = arg1.length;
        for(var i = 0; i < cnt; ++i){
            var typeValue = 0;
            var point = arg1[i];
            switch(arg2[i] & PdfGraphics.pathTypesValuesMask){
                case (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Start:
                    this.pdfStreamWriter.beginPath(point.x, point.y);
                    break;
                case (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Bezier3:
                    var p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
                    var p3 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
                    var result1 = this.getBezierPoints(arg1, arg2, i, p2, p3);
                    this.pdfStreamWriter.appendBezierSegment(point, result1.p2, result1.p3);
                    i = result1.i;
                    break;
                case (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Line:
                    this.pdfStreamWriter.appendLineSegment(point);
                    break;
                default:
                    throw new Error("ArithmeticException - Incorrect path formation.");
            }
            typeValue = arg2[i];
            this.checkFlags(typeValue);
        }
    };
    /**
     * Gets the bezier points from respective arrays.
     * @private
     */ /* tslint:disable-next-line:max-line-length */ PdfGraphics.prototype.getBezierPoints = function(points, types, i, p2, p3) {
        var errorMsg = "Malforming path.";
        ++i;
        if ((types[i] & PdfGraphics.pathTypesValuesMask) === (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Bezier3) {
            p2 = points[i];
            ++i;
            if ((types[i] & PdfGraphics.pathTypesValuesMask) === (0, $5ffc34ffc68e39dd$export$291db033450eaddd).Bezier3) p3 = points[i];
            else throw new Error("ArgumentException : errorMsg");
        } else throw new Error("ArgumentException : errorMsg");
        return {
            i: i,
            p2: p2,
            p3: p3
        };
    };
    /**
     * Checks path point type flags.
     * @private
     */ PdfGraphics.prototype.checkFlags = function(type) {
        if ((type & (0, $5ffc34ffc68e39dd$export$291db033450eaddd).CloseSubpath) === (0, $5ffc34ffc68e39dd$export$291db033450eaddd).CloseSubpath) this.pdfStreamWriter.closePath();
    };
    /**
     * Constructs the arc path using Bezier curves.
     * @private
     */ PdfGraphics.prototype.constructArcPath = function(x1, y1, x2, y2, startAng, sweepAngle) {
        var points = this.getBezierArc(x1, y1, x2, y2, startAng, sweepAngle);
        if (points.length === 0) return;
        var pt = [
            points[0],
            points[1],
            points[2],
            points[3],
            points[4],
            points[5],
            points[6],
            points[7]
        ];
        this.pdfStreamWriter.beginPath(pt[0], pt[1]);
        var i = 0;
        for(i = 0; i < points.length; i = i + 8){
            pt = [
                points[i],
                points[i + 1],
                points[i + 2],
                points[i + 3],
                points[i + 4],
                points[i + 5],
                points[i + 6],
                points[i + 7]
            ];
            this.pdfStreamWriter.appendBezierSegment(pt[2], pt[3], pt[4], pt[5], pt[6], pt[7]);
        }
    };
    /**
     * Gets the bezier points for arc constructing.
     * @private
     */ PdfGraphics.prototype.getBezierArc = function(numX1, numY1, numX2, numY2, s1, e1) {
        if (numX1 > numX2) {
            var tmp = void 0;
            tmp = numX1;
            numX1 = numX2;
            numX2 = tmp;
        }
        if (numY2 > numY1) {
            var tmp = void 0;
            tmp = numY1;
            numY1 = numY2;
            numY2 = tmp;
        }
        var fragAngle1;
        var numFragments;
        if (Math.abs(e1) <= 90) {
            fragAngle1 = e1;
            numFragments = 1;
        } else {
            numFragments = Math.ceil(Math.abs(e1) / 90);
            fragAngle1 = e1 / numFragments;
        }
        var xcen = (numX1 + numX2) / 2;
        var ycen = (numY1 + numY2) / 2;
        var rx = (numX2 - numX1) / 2;
        var ry = (numY2 - numY1) / 2;
        var halfAng = fragAngle1 * (Math.PI / 360);
        var kappa = Math.abs(4.0 / 3.0 * (1.0 - Math.cos(halfAng)) / Math.sin(halfAng));
        var pointsList = [];
        for(var i = 0; i < numFragments; i++){
            var thetaValue0 = (s1 + i * fragAngle1) * (Math.PI / 180);
            var thetaValue1 = (s1 + (i + 1) * fragAngle1) * (Math.PI / 180);
            var cos0 = Math.cos(thetaValue0);
            var cos1 = Math.cos(thetaValue1);
            var sin0 = Math.sin(thetaValue0);
            var sin1 = Math.sin(thetaValue1);
            if (fragAngle1 > 0) /* tslint:disable-next-line:max-line-length */ pointsList.push(xcen + rx * cos0, ycen - ry * sin0, xcen + rx * (cos0 - kappa * sin0), ycen - ry * (sin0 + kappa * cos0), xcen + rx * (cos1 + kappa * sin1), ycen - ry * (sin1 - kappa * cos1), xcen + rx * cos1, ycen - ry * sin1);
            else /* tslint:disable-next-line:max-line-length */ pointsList.push(xcen + rx * cos0, ycen - ry * sin0, xcen + rx * (cos0 + kappa * sin0), ycen - ry * (sin0 - kappa * cos0), xcen + rx * (cos1 - kappa * sin1), ycen - ry * (sin1 + kappa * cos1), xcen + rx * cos1, ycen - ry * sin1);
        }
        return pointsList;
    };
    /* tslint:disable */ // Constants
    /**
     * Specifies the mask of `path type values`.
     * @private
     */ PdfGraphics.pathTypesValuesMask = 0xf;
    /**
     * Checks whether the object is `transparencyObject`.
     * @hidden
     * @private
     */ PdfGraphics.transparencyObject = false;
    return PdfGraphics;
}();
/**
 * `GetResourceEventHandler` class is alternate for event handlers and delegates.
 * @private
 * @hidden
 */ var $fb8dc0c26a98dd16$export$d6852a765bb5199f = /** @class */ function() {
    /**
     * Initialize instance of `GetResourceEventHandler` class.
     * Alternate for event handlers and delegates.
     * @private
     */ function GetResourceEventHandler(sender) {
        this.sender = sender;
    }
    /**
     * Return the instance of `PdfResources` class.
     * @private
     */ GetResourceEventHandler.prototype.getResources = function() {
        return this.sender.getResources();
    };
    return GetResourceEventHandler;
}();
var $fb8dc0c26a98dd16$export$a19a3822b1d2d1df = /** @class */ function() {
    function PdfGraphicsState(graphics, matrix) {
        /**
         * Stores `previous rendering mode`.
         * @default TextRenderingMode.Fill
         * @private
         */ this.internalTextRenderingMode = (0, $d174213b46afc09a$export$ca45e4ab114d4814).Fill;
        /**
         * `Previous character spacing` value or 0.
         * @default 0.0
         * @private
         */ this.internalCharacterSpacing = 0.0;
        /**
         * `Previous word spacing` value or 0.
         * @default 0.0
         * @private
         */ this.internalWordSpacing = 0.0;
        /**
         * The previously used `text scaling value`.
         * @default 100.0
         * @private
         */ this.internalTextScaling = 100.0;
        /**
         * `Current color space`.
         * @default PdfColorSpace.Rgb
         * @private
         */ this.pdfColorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        if (typeof graphics !== "undefined") {
            this.pdfGraphics = graphics;
            var elements_1 = [];
            graphics.matrix.matrix.elements.forEach(function(element) {
                elements_1.push(element);
            });
            this.transformationMatrix = new (0, $31933e0cf70afc95$export$ab1b31af38a0591e)();
            this.transformationMatrix.matrix = new (0, $31933e0cf70afc95$export$5b12bf1653c0dd85)(elements_1);
        }
    }
    Object.defineProperty(PdfGraphicsState.prototype, "graphics", {
        // Properties
        /**
         * Gets the parent `graphics object`.
         * @private
         */ get: function() {
            return this.pdfGraphics;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "matrix", {
        /**
         * Gets the `current matrix`.
         * @private
         */ get: function() {
            return this.transformationMatrix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "characterSpacing", {
        /**
         * Gets or sets the `current character spacing`.
         * @private
         */ get: function() {
            return this.internalCharacterSpacing;
        },
        set: function(value) {
            this.internalCharacterSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "wordSpacing", {
        /**
         * Gets or sets the `word spacing` value.
         * @private
         */ get: function() {
            return this.internalWordSpacing;
        },
        set: function(value) {
            this.internalWordSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "textScaling", {
        /**
         * Gets or sets the `text scaling` value.
         * @private
         */ get: function() {
            return this.internalTextScaling;
        },
        set: function(value) {
            this.internalTextScaling = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "pen", {
        /**
         * Gets or sets the `current pen` object.
         * @private
         */ get: function() {
            return this.pdfPen;
        },
        set: function(value) {
            this.pdfPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "brush", {
        /**
         * Gets or sets the `brush`.
         * @private
         */ get: function() {
            return this.pdfBrush;
        },
        set: function(value) {
            this.pdfBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "font", {
        /**
         * Gets or sets the `current font` object.
         * @private
         */ get: function() {
            return this.pdfFont;
        },
        set: function(value) {
            this.pdfFont = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "colorSpace", {
        /**
         * Gets or sets the `current color space` value.
         * @private
         */ get: function() {
            return this.pdfColorSpace;
        },
        set: function(value) {
            this.pdfColorSpace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGraphicsState.prototype, "textRenderingMode", {
        /**
         * Gets or sets the `text rendering mode`.
         * @private
         */ get: function() {
            return this.internalTextRenderingMode;
        },
        set: function(value) {
            this.internalTextRenderingMode = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGraphicsState;
}();
var $fb8dc0c26a98dd16$var$TransparencyData = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `TransparencyData` class.
     * @private
     */ function TransparencyData(alphaPen, alphaBrush, blendMode) {
        this.alphaPen = alphaPen;
        this.alphaBrush = alphaBrush;
        this.blendMode = blendMode;
    }
    return TransparencyData;
}(); /* tslint:enable */ 





/**
 * The `PdfPageLayer` used to create layers in PDF document.
 * @private
 */ var $0a238f0c7673328f$export$1a076d1355e3f65d = /** @class */ function() {
    function PdfPageLayer(page, streamClipPageTemplates) {
        // private bSaved : boolean;
        /**
         * Local Variable to store the `color space` of the document.
         * @private
         */ this.pdfColorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        /**
         * Local Variable to set `visibility`.
         * @default true
         * @private
         */ this.isVisible = true;
        /**
         * Indicates if `Sublayer` is present.
         * @default false
         * @private
         */ this.sublayer = false;
        /**
         * Local variable to store `length` of the graphics.
         * @default 0
         * @private
         */ this.contentLength = 0;
        /**
         * Instance for `PdfDictionaryProperties` Class.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        if (page === null) throw new Error("ArgumentNullException:page");
        this.pdfPage = page;
        this.clipPageTemplates = true;
        if (typeof streamClipPageTemplates === "undefined") this.content = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        else if (streamClipPageTemplates instanceof (0, $15c367619ceaca0d$export$4d7493161880398c) || streamClipPageTemplates === null) {
            if (streamClipPageTemplates === null) throw new Error("ArgumentNullException:stream");
            this.content = streamClipPageTemplates;
        } else {
            this.content = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
            this.clipPageTemplates = streamClipPageTemplates;
        }
    }
    Object.defineProperty(PdfPageLayer.prototype, "colorSpace", {
        // Properties
        /**
         * Get or set the `color space`.
         * @private
         */ get: function() {
            return this.pdfColorSpace;
        },
        set: function(value) {
            this.pdfColorSpace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "page", {
        /**
         * Gets parent `page` of the layer.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "layerId", {
        /**
         * Gets and Sets the `id of the layer`.
         * @private
         */ get: function() {
            return this.layerid;
        },
        set: function(value) {
            this.layerid = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "name", {
        /**
         * Gets or sets the `name` of the layer.
         * @private
         */ get: function() {
            return this.layerName;
        },
        set: function(value) {
            this.layerName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "visible", {
        /**
         * Gets or sets the `visibility` of the layer.
         * @private
         */ get: function() {
            return this.isVisible;
        },
        set: function(value) {
            this.isVisible = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "graphics", {
        /**
         * Gets `Graphics` context of the layer, used to draw various graphical content on layer.
         * @private
         */ get: function() {
            if (this.pdfGraphics == null) this.initializeGraphics(this.page);
            return this.pdfGraphics;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageLayer.prototype, "layers", {
        /**
         * Gets the collection of `PdfPageLayer`, this collection handle by the class 'PdfPageLayerCollection'.
         * @private
         */ get: function() {
            if (this.layer == null) {
                this.layer = new (0, $9e42580cb200149a$export$a678a6aff63258b1)(this.page);
                this.layer.sublayer = true;
                return this.layer;
            } else return this.layer;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Adds` a new PDF Page layer.
     * @private
     */ PdfPageLayer.prototype.add = function() {
        var layer = new PdfPageLayer(this.pdfPage);
        layer.name = "";
        return layer;
    };
    /**
     * Returns a value indicating the `sign` of a single-precision floating-point number.
     * @private
     */ PdfPageLayer.prototype.sign = function(number) {
        if (number === 0) return 0;
        else if (number > 0) return 1;
        else return -1;
    };
    /**
     * `Initializes Graphics context` of the layer.
     * @private
     */ PdfPageLayer.prototype.initializeGraphics = function(page) {
        var oPage = page;
        var gr = new (0, $fb8dc0c26a98dd16$export$d6852a765bb5199f)(this.page);
        var cropBox = null;
        this.pdfGraphics = new (0, $fb8dc0c26a98dd16$export$b71fac00da485609)(page.size, gr, this.content);
        this.pdfGraphics.mediaBoxUpperRightBound = 0;
        if (oPage != null) {
            var sc = oPage.section.parent;
            if (sc != null) {
                this.pdfGraphics.colorSpace = sc.document.colorSpace;
                this.colorSpace = sc.document.colorSpace;
            }
        }
        // Transform coordinates to the left/top and activate margins.
        var isSame = this.sign(page.origin.y) === this.sign(page.origin.x);
        // if (page != null) {
        if (page.origin.x >= 0 && page.origin.y >= 0 || !isSame) this.pdfGraphics.initializeCoordinates();
        var clipRect = oPage.section.getActualBounds(oPage, true);
        var margins = oPage.section.pageSettings.margins;
        if (this.clipPageTemplates) {
            if (page.origin.x >= 0 && page.origin.y >= 0) this.pdfGraphics.clipTranslateMargins(clipRect);
        } else this.graphics.clipTranslateMargins(clipRect.x, clipRect.y, margins.left, margins.top, margins.right, margins.bottom);
        this.pdfGraphics.setLayer(this);
    // this.bSaved = false;
    };
    Object.defineProperty(PdfPageLayer.prototype, "element", {
        // IPdfWrapper Members
        /**
         * Gets the wrapped `element`.
         * @private
         */ get: function() {
            return this.content;
        },
        enumerable: true,
        configurable: true
    });
    return PdfPageLayer;
}();


/**
 * PdfCollection.ts class for EJ2-PDF
 * The class used to handle the collection of PdF objects.
 */ var $74431ddebba053ff$export$495ef44325a217b6 = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `Collection` class.
     * @private
     */ function PdfCollection() {
    //
    }
    Object.defineProperty(PdfCollection.prototype, "count", {
        // Properties
        /**
         * Gets the `Count` of stored objects.
         * @private
         */ get: function() {
            if (typeof this.collection === "undefined") this.collection = [];
            return this.collection.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCollection.prototype, "list", {
        /**
         * Gets the `list` of stored objects.
         * @private
         */ get: function() {
            if (typeof this.collection === "undefined") this.collection = [];
            return this.collection;
        },
        enumerable: true,
        configurable: true
    });
    return PdfCollection;
}();




var $9e42580cb200149a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * The class provides methods and properties to handle the collections of `PdfPageLayer`.
 */ var $9e42580cb200149a$export$a678a6aff63258b1 = /** @class */ function(_super) {
    $9e42580cb200149a$var$__extends(PdfPageLayerCollection, _super);
    function PdfPageLayerCollection(page) {
        var _this = _super.call(this) || this;
        /**
         * Stores the `number of first level layers` in the document.
         * @default 0
         * @private
         */ _this.parentLayerCount = 0;
        /**
         * Indicates if `Sublayer` is present.
         * @default false
         * @private
         */ _this.sublayer = false;
        /**
         * Stores the `optional content dictionary`.
         * @private
         */ _this.optionalContent = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        if (page instanceof (0, $def696edfccdb54e$export$3bab7751b49fcc4b)) {
            // if (page == null) {
            //     throw new Error('ArgumentNullException:page');
            // }
            _this.page = page;
            var lPage = page;
            // if (lPage != null) {
            _this.parseLayers(lPage);
        // }
        }
        return _this;
    }
    PdfPageLayerCollection.prototype.items = function(index, value) {
        if (typeof index === "number" && typeof value === "undefined") {
            var obj = this.list[index];
            return obj;
        } else {
            if (value == null) throw new Error("ArgumentNullException: layer");
            if (value.page !== this.page) throw new Error("ArgumentException: The layer belongs to another page");
        // // Add/remove the layer.
        // let layer : PdfPageLayer = this.items(index);
        // if (layer != null) {
        //     this.RemoveLayer(layer);
        // }
        // this.List[index] = value;
        // this.InsertLayer(index, value);
        }
    };
    PdfPageLayerCollection.prototype.add = function(firstArgument, secondArgument) {
        if (typeof firstArgument === "undefined") {
            var layer = new (0, $0a238f0c7673328f$export$1a076d1355e3f65d)(this.page);
            layer.name = "";
            this.add(layer);
            return layer;
        } else if (firstArgument instanceof (0, $0a238f0c7673328f$export$1a076d1355e3f65d)) {
            // if (layer == null)
            //     throw new ArgumentNullException("layer");
            // if (layer.Page != m_page)
            //     throw new ArgumentException("The layer belongs to another page");
            var index = this.list.push(firstArgument);
            // Register layer.
            this.addLayer(index, firstArgument);
            return index;
        } else return 0;
    };
    /**
     * Registers `layer` at the page.
     * @private
     */ PdfPageLayerCollection.prototype.addLayer = function(index, layer) {
        var reference = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(layer);
        this.page.contents.add(reference);
    };
    // private RemoveLayer(layer : PdfPageLayer) : void {
    //     if (layer == null) {
    //         throw new Error('ArgumentNullException:layer');
    //     }
    //     let reference : PdfReferenceHolder = new PdfReferenceHolder(layer);
    //     if (this.page != null) {
    //         this.page.Contents.Remove(reference);
    //     }
    // }
    /**
     * Inserts `PdfPageLayer` into the collection at specified index.
     * @private
     */ PdfPageLayerCollection.prototype.insert = function(index, layer) {
        // if (index < 0)
        //     throw new ArgumentOutOfRangeException("index", "Value can not be less 0");
        // if (layer == null)
        //     throw new ArgumentNullException("layer");
        // if (layer.Page != m_page)
        //     throw new ArgumentException("The layer belongs to another page");
        var list = [];
        var length = this.list.length;
        for(var i = index; i < length; i++)list.push(this.list.pop());
        this.list.push(layer);
        for(var i = 0; i < list.length; i++)this.list.push(list[i]);
        // Register layer.
        this.insertLayer(index, layer);
    };
    /**
     * Registers layer at the page.
     * @private
     */ PdfPageLayerCollection.prototype.insertLayer = function(index, layer) {
        if (layer == null) throw new Error("ArgumentNullException:layer");
        var reference = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(layer);
        this.page.contents.insert(index, reference);
    };
    // tslint:disable
    /**
     * `Parses the layers`.
     * @private
     */ PdfPageLayerCollection.prototype.parseLayers = function(loadedPage) {
        // if (loadedPage == null) {
        //     throw new Error('ArgumentNullException:loadedPage');
        // }
        var contents = this.page.contents;
        var resource = this.page.getResources();
        var crossTable = null;
        var ocproperties = null;
        var propertie = null;
        var isLayerAdded = false;
        // if (loadedPage instanceof PdfPage) {
        crossTable = loadedPage.crossTable;
        // } else {
        //     crossTable = (loadedPage as PdfLoadedPage).CrossTable;
        //     Propertie = PdfCrossTable.Dereference(Resource[DictionaryProperties.Properties]) as PdfDictionary;
        //     ocproperties = PdfCrossTable.Dereference((loadedPage as PdfLoadedPage).
        //     Document.Catalog[DictionaryProperties.OCProperties]) as PdfDictionary;
        // }
        var saveStream = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        var restoreStream = new (0, $15c367619ceaca0d$export$4d7493161880398c)();
        var saveState = "q";
        var newLine = "\n";
        var restoreState = "Q";
        // for (let index : number = 0; index < contents.Items.length; index++) {
        //     let obj : IPdfPrimitive = contents[index];
        //     let stream : PdfStream = crossTable.GetObject(obj) as PdfStream;
        //     if (stream == null)
        //         throw new PdfDocumentException("Invalid contents array.");
        //     // if (stream.Compress)
        //     {
        //         if (!loadedPage.Imported)
        //             stream.Decompress();
        //     }
        //     byte[] contentId = stream.Data;
        //     string str = PdfString.ByteToString(contentId);
        //     if (!loadedPage.Imported && (contents.Count == 1) && ((stream.Data[stream.Data.Length - 2] ==
        //     RestoreState) || (stream.Data[stream.Data.Length - 1] == RestoreState)))
        //     {
        //         byte[] content = stream.Data;
        //         byte[] data = new byte[content.Length + 4];
        //         data[0] = SaveState;
        //         data[1] = NewLine;
        //         content.CopyTo(data, 2);
        //         data[data.Length - 2] = NewLine;
        //         data[data.Length - 1] = RestoreState;
        //         stream.Data = data;
        //     }
        //     if (ocproperties != null)
        //     {
        //         if (Propertie != null)
        //         {
        //             foreach (KeyValuePair<PdfName, IPdfPrimitive> prop in Propertie.Items)
        //             {
        //                 String Key = prop.Key.ToString();
        //                 PdfReferenceHolder refh = prop.Value as PdfReferenceHolder;
        //                 PdfDictionary Dict = null;
        //                 if (refh != null)
        //                 {
        //                     Dict = refh.Object as PdfDictionary;
        //                 }
        //                 else
        //                 {
        //                     Dict = prop.Value as PdfDictionary;
        //                 }
        //                 PdfDictionary m_usage = PdfCrossTable.Dereference(Dict[DictionaryProperties.Usage]) as PdfDictionary;
        //                 if (m_usage != null)
        //                 {
        //                     if (str.Contains(Key))
        //                     {
        //                         PdfPageLayer layer = new PdfPageLayer(loadedPage, stream);
        //                         PdfDictionary printoption = PdfCrossTable.Dereference(m_usage[DictionaryProperties.Print])
        //                         as PdfDictionary;
        //                         if (printoption != null)
        //                         {
        //                             layer.m_printOption = printoption;
        //                             foreach (KeyValuePair<PdfName, IPdfPrimitive> value in printoption.Items)
        //                             {
        //                                 if (value.Key.Value.Equals(DictionaryProperties.PrintState))
        //                                 {
        //                                     string printState = (value.Value as PdfName).Value;
        //                                     if (printState.Equals(DictionaryProperties.OCGON))
        //                                     {
        //                                         layer.PrintState = PdfPrintState.AlwaysPrint;
        //                                         break;
        //                                     }
        //                                     else
        //                                     {
        //                                         layer.PrintState = PdfPrintState.NeverPrint;
        //                                         break;
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                         PdfString layerName = PdfCrossTable.Dereference(Dict[DictionaryProperties.Name]) as PdfString;
        //                         layer.Name = layerName.Value;
        //                         List.add(layer);
        //                         isLayerAdded = true;
        //                         if(!str.Contains("EMC"))
        //                         break;
        //                     }
        //                 }
        //                 else
        //                 {
        //                     if (str.Contains(Key))
        //                     {
        //                         PdfPageLayer layer = new PdfPageLayer(loadedPage, stream);
        //                         List.add(layer);
        //                         if(Dict.ContainsKey(DictionaryProperties.Name))
        //                         {
        //                         PdfString layerName = PdfCrossTable.Dereference(Dict[DictionaryProperties.Name]) as PdfString;
        //                         layer.Name = layerName.Value;
        //                         }
        //                         isLayerAdded = true;
        //                         break;
        //                     }
        //                 }
        //             }
        //         }
        //     }
        //     if (!isLayerAdded)
        //     {
        //         PdfPageLayer layer = new PdfPageLayer(loadedPage, stream);
        //         List.add(layer);
        //     }
        //     else
        //         isLayerAdded = false;
        // }
        var saveData = [];
        saveData.push(saveState);
        saveStream.data = saveData;
        contents.insert(0, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(saveStream));
        saveData = [];
        saveData.push(restoreState);
        restoreStream.data = saveData;
        contents.insert(contents.count, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(restoreStream));
    };
    /**
     * Returns `index of` the `PdfPageLayer` in the collection if exists, -1 otherwise.
     * @private
     */ PdfPageLayerCollection.prototype.indexOf = function(layer) {
        if (layer == null) throw new Error("ArgumentNullException: layer");
        var index = this.list.indexOf(layer);
        return index;
    };
    return PdfPageLayerCollection;
}((0, $74431ddebba053ff$export$495ef44325a217b6));




/**
 * The abstract base class for all pages,
 * `PdfPageBase` class provides methods and properties to create PDF pages and its elements.
 * @private
 */ var $def696edfccdb54e$export$3bab7751b49fcc4b = /** @class */ function() {
    //constructors
    /**
     * Initializes a new instance of the `PdfPageBase` class.
     * @private
     */ function PdfPageBase(dictionary) {
        /**
         * `Index` of the default layer.
         * @default -1.
         * @private
         */ this.defLayerIndex = -1;
        /**
         * Local variable to store if page `updated`.
         * @default false.
         * @private
         */ this.modified = false;
        /**
         * Instance of `DictionaryProperties` class.
         * @hidden
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        this.pageDictionary = dictionary;
    }
    Object.defineProperty(PdfPageBase.prototype, "section", {
        //Properties
        /**
         * Gets the `section` of a page.
         * @private
         */ get: function() {
            // if (this.pdfSection === null) {
            //     throw new Error('PdfException : Page must be added to some section before using.');
            // }
            return this.pdfSection;
        },
        set: function(value) {
            this.pdfSection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageBase.prototype, "dictionary", {
        /**
         * Gets the page `dictionary`.
         * @private
         */ get: function() {
            return this.pageDictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageBase.prototype, "element", {
        /**
         * Gets the wrapped `element`.
         * @private
         */ get: function() {
            return this.pageDictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageBase.prototype, "defaultLayer", {
        /**
         * Gets the `default layer` of the page (Read only).
         * @private
         */ get: function() {
            var layer = this.layers;
            var index = this.defaultLayerIndex;
            var returnlayer = layer.items(index);
            return returnlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageBase.prototype, "defaultLayerIndex", {
        /**
         * Gets or sets `index of the default layer`.
         * @private
         */ get: function() {
            if (this.layerCollection.count === 0 || this.defLayerIndex === -1) {
                var layer = this.layerCollection.add();
                this.defLayerIndex = this.layerCollection.indexOf(layer);
            }
            return this.defLayerIndex;
        },
        /**
         * Gets or sets` index of the default layer`.
         * @private
         */ set: function(value) {
            if (value < 0 || value > this.layers.count - 1) throw new Error("ArgumentOutOfRangeException : value, Index can not be less 0 and greater Layers.Count - 1");
            else {
                this.defLayerIndex = value;
                this.modified = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageBase.prototype, "layers", {
        /**
         * Gets the collection of the page's `layers` (Read only).
         * @private
         */ get: function() {
            if (this.layerCollection == null || typeof this.layerCollection === "undefined") this.layerCollection = new (0, $9e42580cb200149a$export$a678a6aff63258b1)(this);
            return this.layerCollection;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Return an instance of `PdfResources` class.
     * @private
     */ PdfPageBase.prototype.getResources = function() {
        if (this.resources == null) {
            this.resources = new (0, $fd5f6c449fbc58fe$export$97d157607b67be30)();
            this.dictionary.items.setValue(this.dictionaryProperties.resources, this.resources);
        }
        return this.resources;
    };
    Object.defineProperty(PdfPageBase.prototype, "contents", {
        /**
         * Gets `array of page's content`.
         * @private
         */ get: function() {
            var obj = this.pageDictionary.items.getValue(this.dictionaryProperties.contents);
            var contents = obj;
            var rh = obj;
            if (contents == null) {
                contents = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
                this.pageDictionary.items.setValue(this.dictionaryProperties.contents, contents);
            }
            return contents;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the `resources`.
     * @private
     */ PdfPageBase.prototype.setResources = function(res) {
        this.resources = res;
        this.dictionary.items.setValue(this.dictionaryProperties.resources, this.resources);
        this.modified = true;
    };
    return PdfPageBase;
}();












/**
 * `PdfAnnotationCollection` class represents the collection of 'PdfAnnotation' objects.
 * @private
 */ var $e3c3df83f35985a6$export$cecc4dafdd6758b = /** @class */ function() {
    function PdfAnnotationCollection(page) {
        // Constants
        /**
         * `Error` constant message.
         * @private
         */ this.alreadyExistsAnnotationError = "This annotatation had been already added to page";
        /**
         * `Error` constant message.
         * @private
         */ this.missingAnnotationException = "Annotation is not contained in collection.";
        /**
         * Specifies the Internal variable to store fields of `PdfDictionaryProperties`.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * Array of the `annotations`.
         * @private
         */ this.internalAnnotations = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        /**
         * privte `list` for the annotations.
         * @private
         */ this.lists = [];
        if (typeof page !== "undefined") this.page = page;
    }
    Object.defineProperty(PdfAnnotationCollection.prototype, "annotations", {
        /**
         * Gets the `PdfAnnotation` object at the specified index. Read-Only.
         * @private
         */ get: function() {
            return this.internalAnnotations;
        },
        set: function(value) {
            this.internalAnnotations = value;
        },
        enumerable: true,
        configurable: true
    });
    // Public methods
    /**
     * `Adds` a new annotation to the collection.
     * @private
     */ PdfAnnotationCollection.prototype.add = function(annotation) {
        // this.SetPrint(annotation);
        this.doAdd(annotation);
    };
    /**
     * `Adds` a Annotation to collection.
     * @private
     */ /* tslint:disable */ PdfAnnotationCollection.prototype.doAdd = function(annotation) {
        if (typeof annotation.destination !== "undefined") {
            var layout = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
            var layoutResult = layout.layout(annotation.text, annotation.font, annotation.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(annotation.bounds.width, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            var lastPosition = annotation.bounds.y;
            if (layoutResult.lines.length === 1) {
                var size = annotation.font.measureString(layoutResult.lines[0].text);
                annotation.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(annotation.bounds.x, lastPosition), size);
                annotation.text = layoutResult.lines[0].text;
                //Draw Annotation Text.
                this.page.graphics.drawString(annotation.text, annotation.font, null, annotation.brush, annotation.bounds.x, annotation.bounds.y, annotation.bounds.width, annotation.bounds.height, null);
                //Add annotation to dictionary.
                annotation.setPage(this.page);
                this.setColor(annotation);
                this.internalAnnotations.add(new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(annotation));
                this.lists.push(annotation);
            } else for(var i = 0; i < layoutResult.lines.length; i++){
                var size = annotation.font.measureString(layoutResult.lines[i].text);
                if (i === 0) {
                    annotation.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(annotation.bounds.x, lastPosition, size.width, size.height);
                    annotation.text = layoutResult.lines[i].text;
                    //Draw Annotation Text.
                    this.page.graphics.drawString(annotation.text, annotation.font, null, annotation.brush, annotation.bounds.x, lastPosition, size.width, size.height, null);
                    //Add annotation to dictionary.
                    annotation.setPage(this.page);
                    this.setColor(annotation);
                    this.internalAnnotations.add(new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(annotation));
                    this.lists.push(annotation);
                    //Update y for drawing next line of the text.
                    lastPosition += annotation.bounds.height;
                } else {
                    var annot = annotation.clone();
                    annot.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(annotation.bounds.x, lastPosition), size);
                    annot.text = layoutResult.lines[i].text;
                    //Draw Annotation Text.
                    this.page.graphics.drawString(annot.text, annot.font, null, annot.brush, annot.bounds.x, annot.bounds.y, annot.bounds.width, annot.bounds.height, null);
                    //Add annotation to dictionary.
                    annot.setPage(this.page);
                    this.setColor(annot);
                    this.internalAnnotations.add(new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(annot));
                    this.lists.push(annot);
                    //Update y for drawing next line of the text.
                    lastPosition += annot.bounds.height;
                }
            }
        } else {
            annotation.setPage(this.page);
            this.internalAnnotations.add(new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(annotation));
            return this.lists.push(annotation);
        }
    };
    /* tslint:enable */ /**
     * `Set a color of an annotation`.
     * @private
     */ PdfAnnotationCollection.prototype.setColor = function(annotation) {
        var cs = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        var colours = annotation.color.toArray(cs);
        annotation.dictionary.items.setValue(this.dictionaryProperties.c, colours);
    };
    Object.defineProperty(PdfAnnotationCollection.prototype, "element", {
        // IPdfWrapper Members
        /**
         * Gets the `Element` representing this object.
         * @private
         */ get: function() {
            return this.internalAnnotations;
        },
        enumerable: true,
        configurable: true
    });
    return PdfAnnotationCollection;
}();



var $b3834a1b559693d8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Provides methods and properties to create pages and its elements.
 * `PdfPage` class inherited from the `PdfPageBase` class.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * //
 * // add a new page to the document
 * let page1 : PdfPage = document.pages.add();
 * //
 * // set the font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * // create black brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $b3834a1b559693d8$export$1686f89eb33d2b08 = /** @class */ function(_super) {
    $b3834a1b559693d8$var$__extends(PdfPage, _super);
    //constructors
    /**
     * Initialize the new instance for `PdfPage` class.
     * @private
     */ function PdfPage() {
        var _this = _super.call(this, new (0, $467b51a52206950c$export$f103d8ead0680780)()) || this;
        /**
         * Stores the instance of `PdfAnnotationCollection` class.
         * @hidden
         * @default null
         * @private
         */ _this.annotationCollection = null;
        /**
         * Stores the instance of `PageBeginSave` event for Page Number Field.
         * @default null
         * @private
         */ _this.beginSave = null;
        _this.initialize();
        return _this;
    }
    Object.defineProperty(PdfPage.prototype, "document", {
        //Properties
        /**
         * Gets current `document`.
         * @private
         */ get: function() {
            if (this.section !== null && this.section.parent !== null) return this.section.parent.document;
            else return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPage.prototype, "graphics", {
        /**
         * Get the current `graphics`.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * // add a new page to the document
         * let page1 : PdfPage = document.pages.add();
         * //
         * // get graphics
         * let graphics : PdfGraphics = page1.graphics;
         * //
         * // set the font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // create black brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * // draw the text
         * graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            var result = this.defaultLayer.graphics;
            result.currentPage = this;
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPage.prototype, "crossTable", {
        /**
         * Gets the `cross table`.
         * @private
         */ get: function() {
            if (this.section === null) throw new Error("PdfDocumentException : Page is not created");
            return this.section.parent === null ? this.section.parentDocument.crossTable : this.section.parent.document.crossTable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPage.prototype, "size", {
        /**
         * Gets the size of the PDF page- Read only.
         * @public
         */ get: function() {
            return this.section.pageSettings.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPage.prototype, "origin", {
        /**
         * Gets the `origin` of the page.
         * @private
         */ get: function() {
            return this.section.pageSettings.origin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPage.prototype, "annotations", {
        /**
         * Gets a collection of the `annotations` of the page- Read only.
         * @private
         */ get: function() {
            if (this.annotationCollection == null) {
                this.annotationCollection = new (0, $e3c3df83f35985a6$export$cecc4dafdd6758b)(this);
                // if (!this.Dictionary.ContainsKey(this.dictionaryProperties.annots)) {
                this.dictionary.items.setValue(this.dictionaryProperties.annots, this.annotationCollection.element);
                // }
                this.annotationCollection.annotations = this.dictionary.items.getValue(this.dictionaryProperties.annots);
            }
            return this.annotationCollection;
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    /**
     * `Initializes` a page.
     * @private
     */ PdfPage.prototype.initialize = function() {
        this.dictionary.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)("Page"));
        this.dictionary.pageBeginDrawTemplate = new (0, $467b51a52206950c$export$374b0d08b3114f68)(this);
    };
    /**
     * Sets parent `section` to the page.
     * @private
     */ PdfPage.prototype.setSection = function(section) {
        this.section = section;
        this.dictionary.items.setValue(this.dictionaryProperties.parent, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(section));
    };
    /**
     * `Resets the progress`.
     * @private
     */ PdfPage.prototype.resetProgress = function() {
        this.isProgressOn = false;
    };
    /**
     * Get the page size reduced by page margins and page template dimensions.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // add a pages to the document
     * let page1 : PdfPage = document.pages.add();
     * // create new standard font
     * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
     * // set brush
     * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
     * //
     * // set the specified point using `getClientSize` method
     * let point : PointF = new PointF(page1.getClientSize().width - 200, page1.getClientSize().height - 200);
     * // draw the text
     * page1.graphics.drawString('Hello World', font, blackBrush, point);
     * //
     * // save the document
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     */ PdfPage.prototype.getClientSize = function() {
        var returnValue = this.section.getActualBounds(this, true);
        return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(returnValue.width, returnValue.height);
    };
    /**
     * Helper method to retrive the instance of `PageBeginSave` event for header and footer elements.
     * @private
     */ PdfPage.prototype.pageBeginSave = function() {
        var doc = this.document;
        if (doc != null) this.drawPageTemplates(doc);
        if (this.beginSave != null && typeof this.beginSave !== "undefined") this.beginSave(this);
    };
    /**
     * Helper method to draw template elements.
     * @private
     */ PdfPage.prototype.drawPageTemplates = function(document) {
        // Draw Background templates.
        var hasBackTemplates = this.section.containsTemplates(document, this, false);
        if (hasBackTemplates) {
            var backLayer = new (0, $0a238f0c7673328f$export$1a076d1355e3f65d)(this, false);
            this.layers.insert(0, backLayer);
            this.section.drawTemplates(this, backLayer, document, false);
            if (backLayer.graphics !== null && typeof backLayer.graphics !== "undefined") for(var i = 0; i < backLayer.graphics.automaticFields.automaticFields.length; i++){
                var fieldInfo = backLayer.graphics.automaticFields.automaticFields[i];
                fieldInfo.field.performDraw(backLayer.graphics, fieldInfo.location, fieldInfo.scalingX, fieldInfo.scalingY);
            }
        }
        // Draw Foreground templates.
        var hasFrontTemplates = this.section.containsTemplates(document, this, true);
        if (hasFrontTemplates) {
            var frontLayer = new (0, $0a238f0c7673328f$export$1a076d1355e3f65d)(this, false);
            this.layers.add(frontLayer);
            this.section.drawTemplates(this, frontLayer, document, true);
        }
    };
    return PdfPage;
}((0, $def696edfccdb54e$export$3bab7751b49fcc4b));


/**
 * Provides data for `PageAddedEventHandler` event.
 * This event raises when adding the new PDF page to the PDF document.
 */ var $527206db78592850$export$345bfdc4eaf3b9dd = /** @class */ function() {
    function PageAddedEventArgs(page) {
        if (typeof page !== "undefined") this.pdfPage = page;
        else this.pdfPage = null;
    }
    Object.defineProperty(PageAddedEventArgs.prototype, "page", {
        /**
         * Gets the `newly added page`.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    return PageAddedEventArgs;
}();









/**
 * Represents the `collection of pages in a section`.
 * @private
 */ var $96e495a42e9fc8cb$export$56489e89398d9e19 = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `PdfSectionPageCollection` class.
     * @private
     */ function PdfSectionPageCollection(section) {
        //  Fields
        /**
         * @hidden
         * @private
         */ this.pdfSection = null;
        if (section == null) throw Error('ArgumentNullException("section")');
        this.section = section;
    }
    Object.defineProperty(PdfSectionPageCollection.prototype, "section", {
        // Properties
        /**
         * Gets the `PdfPage` at the specified index.
         * @private
         */ get: function() {
            return this.pdfSection;
        },
        set: function(value) {
            this.pdfSection = value;
        },
        enumerable: true,
        configurable: true
    });
    // Public Methods
    /**
     * `Determines` whether the specified page is within the collection.
     * @private
     */ PdfSectionPageCollection.prototype.contains = function(page) {
        return this.section.contains(page);
    };
    /**
     * `Removes` the specified page from collection.
     * @private
     */ PdfSectionPageCollection.prototype.remove = function(page) {
        this.section.remove(page);
    };
    /**
     * `Adds` a new page from collection.
     * @private
     */ PdfSectionPageCollection.prototype.add = function() {
        return this.section.add();
    };
    return PdfSectionPageCollection;
}();




// import { PdfStampCollection } from `./../Pages/PdfStampCollection`;
/**
 * `PdfDocumentTemplate` class encapsulates a page template for all the pages in the document.
 * @private
 */ var $37f475734d88d5c5$export$bbb3b48dbd10b480 = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `PdfDocumentTemplate` class.
     * @public
     */ function PdfDocumentTemplate() {
    //
    }
    Object.defineProperty(PdfDocumentTemplate.prototype, "left", {
        // private m_stamps : PdfStampCollection;
        // Properties
        /**
         * `Left` page template object.
         * @public
         */ get: function() {
            return this.leftTemplate;
        },
        set: function(value) {
            this.leftTemplate = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "top", {
        /**
         * `Top` page template object.
         * @public
         */ get: function() {
            return this.topTemplate;
        },
        set: function(value) {
            this.topTemplate = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "right", {
        /**
         * `Right` page template object.
         * @public
         */ get: function() {
            return this.rightTemplate;
        },
        set: function(value) {
            this.rightTemplate = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "bottom", {
        /**
         * `Bottom` page template object.
         * @public
         */ get: function() {
            return this.bottomTemplate;
        },
        set: function(value) {
            this.bottomTemplate = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "EvenLeft", {
        /**
         * `EvenLeft` page template object.
         * @public
         */ get: function() {
            return this.evenLeft;
        },
        set: function(value) {
            this.evenLeft = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "EvenTop", {
        /**
         * `EvenTop` page template object.
         * @public
         */ get: function() {
            return this.evenTop;
        },
        set: function(value) {
            this.evenTop = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "EvenRight", {
        /**
         * `EvenRight` page template object.
         * @public
         */ get: function() {
            return this.evenRight;
        },
        set: function(value) {
            this.evenRight = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "EvenBottom", {
        /**
         * `EvenBottom` page template object.
         * @public
         */ get: function() {
            return this.evenBottom;
        },
        set: function(value) {
            this.evenBottom = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "OddLeft", {
        /**
         * `OddLeft` page template object.
         * @public
         */ get: function() {
            return this.oddLeft;
        },
        set: function(value) {
            this.oddLeft = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "OddTop", {
        /**
         * `OddTop` page template object.
         * @public
         */ get: function() {
            return this.oddTop;
        },
        set: function(value) {
            this.oddTop = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "OddRight", {
        /**
         * `OddRight` page template object.
         * @public
         */ get: function() {
            return this.oddRight;
        },
        set: function(value) {
            this.oddRight = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentTemplate.prototype, "OddBottom", {
        /**
         * `OddBottom` page template object.
         * @public
         */ get: function() {
            return this.oddBottom;
        },
        set: function(value) {
            this.oddBottom = this.checkElement(value, (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom);
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * Returns `left` template.
     * @public
     */ PdfDocumentTemplate.prototype.getLeft = function(page) {
        if (page == null) throw new Error("ArgumentNullException:page");
        var template = null;
        // if (page.Document.Pages != null) {
        var even = this.isEven(page);
        if (even) template = this.EvenLeft != null ? this.EvenLeft : this.left;
        else template = this.OddLeft != null ? this.OddLeft : this.left;
        // }
        return template;
    };
    /**
     * Returns `top` template.
     * @public
     */ PdfDocumentTemplate.prototype.getTop = function(page) {
        if (page == null) throw new Error("ArgumentNullException:page");
        var template = null;
        // if (page.Document.Pages != null) {
        var even = this.isEven(page);
        if (even) template = this.EvenTop != null ? this.EvenTop : this.top;
        else template = this.OddTop != null ? this.OddTop : this.top;
        // }
        return template;
    };
    /**
     * Returns `right` template.
     * @public
     */ PdfDocumentTemplate.prototype.getRight = function(page) {
        if (page == null) throw new Error("ArgumentNullException:page");
        var template = null;
        // if (page.Document.Pages != null) {
        var even = this.isEven(page);
        if (even) template = this.EvenRight != null ? this.EvenRight : this.right;
        else template = this.OddRight != null ? this.OddRight : this.right;
        // }
        return template;
    };
    /**
     * Returns `bottom` template.
     * @public
     */ PdfDocumentTemplate.prototype.getBottom = function(page) {
        if (page == null) throw new Error("ArgumentNullException:page");
        var template = null;
        // if (page.Document.Pages != null) {
        var even = this.isEven(page);
        if (even) template = this.EvenBottom != null ? this.EvenBottom : this.bottom;
        else template = this.OddBottom != null ? this.OddBottom : this.bottom;
        // }
        return template;
    };
    /**
     * Checks whether the page `is even`.
     * @private
     */ PdfDocumentTemplate.prototype.isEven = function(page) {
        var pages = page.section.document.pages;
        var index = 0;
        if (pages.pageCollectionIndex.containsKey(page)) index = pages.pageCollectionIndex.getValue(page) + 1;
        else index = pages.indexOf(page) + 1;
        var even = index % 2 === 0;
        return even;
    };
    /**
     * Checks a `template element`.
     * @private
     */ PdfDocumentTemplate.prototype.checkElement = function(templateElement, type) {
        if (templateElement != null) {
            if (typeof templateElement.type !== "undefined" && templateElement.type !== (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) throw new Error("NotSupportedException:Can not reassign the template element. Please, create new one.");
            templateElement.type = type;
        }
        return templateElement;
    };
    return PdfDocumentTemplate;
}();


var $d739365b109dbda9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents a `page template` for all the pages in the section.
 */ var $d739365b109dbda9$export$10e7fe8445bdd03b = /** @class */ function(_super) {
    $d739365b109dbda9$var$__extends(PdfSectionTemplate, _super);
    // Constructors
    /**
     * `Creates a new object`.
     * @private
     */ function PdfSectionTemplate() {
        var _this = _super.call(this) || this;
        _this.leftValue = _this.topValue = _this.rightValue = _this.bottomValue = _this.stampValue = true;
        return _this;
    }
    Object.defineProperty(PdfSectionTemplate.prototype, "applyDocumentLeftTemplate", {
        // Properties
        /**
         * Gets or sets value indicating whether parent `Left page template should be used or not`.
         * @private
         */ get: function() {
            return this.leftValue;
        },
        set: function(value) {
            this.leftValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionTemplate.prototype, "applyDocumentTopTemplate", {
        /**
         * Gets or sets value indicating whether parent `Top page template should be used or not`.
         * @private
         */ get: function() {
            return this.topValue;
        },
        set: function(value) {
            this.topValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionTemplate.prototype, "applyDocumentRightTemplate", {
        /**
         * Gets or sets value indicating whether parent `Right page template should be used or not`.
         * @private
         */ get: function() {
            return this.rightValue;
        },
        set: function(value) {
            this.rightValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionTemplate.prototype, "applyDocumentBottomTemplate", {
        /**
         * Gets or sets value indicating whether parent `Bottom page template should be used or not`.
         * @private
         */ get: function() {
            return this.bottomValue;
        },
        set: function(value) {
            this.bottomValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionTemplate.prototype, "applyDocumentStamps", {
        /**
         * Gets or sets value indicating whether the `stamp value` is true or not.
         * @private
         */ get: function() {
            return this.stampValue;
        },
        set: function(value) {
            this.stampValue = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfSectionTemplate;
}((0, $37f475734d88d5c5$export$bbb3b48dbd10b480));


/**
 * Represents a `section` entity. A section it's a set of the pages with similar page settings.
 */ var $05be0d3ce943f055$export$bdf2a2e0c7c8f73c = /** @class */ function() {
    function PdfSection(document, pageSettings) {
        //Fields
        //public PageAdded() : PageAddedEventArgs.PageAddedEventHandler = new PageAddedEventArgs.PageAddedEventHandler(Object,args)
        /**
         * @hidden
         * @private
         */ this.pageAdded = new (0, $527206db78592850$export$345bfdc4eaf3b9dd)();
        /**
         * @hidden
         * @private
         */ this.pdfPages = [];
        /**
         * @hidden
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        this.pdfDocument = document;
        if (typeof pageSettings === "undefined") {
            this.settings = document.pageSettings.clone();
            this.initialSettings = this.settings.clone();
        } else {
            this.settings = pageSettings.clone();
            this.initialSettings = this.settings.clone();
        }
        this.initialize();
    }
    Object.defineProperty(PdfSection.prototype, "parent", {
        //Property
        /**
         * Gets or sets the `parent`.
         * @private
         */ get: function() {
            return this.sectionCollection;
        },
        set: function(value) {
            this.sectionCollection = value;
            this.section.items.setValue(this.dictionaryProperties.parent, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(value));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "parentDocument", {
        /**
         * Gets the `parent document`.
         * @private
         */ get: function() {
            return this.pdfDocument;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "pageSettings", {
        /**
         * Gets or sets the `page settings` of the section.
         * @private
         */ get: function() {
            return this.settings;
        },
        set: function(value) {
            if (value != null) this.settings = value;
            else throw Error("Value can not be null.");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "element", {
        /**
         * Gets the wrapped `element`.
         * @private
         */ get: function() {
            return this.section;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "count", {
        /**
         * Gets the `count` of the pages in the section.
         * @private
         */ get: function() {
            return this.pagesReferences.count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "template", {
        /**
         * Gets or sets a `template` for the pages in the section.
         * @private
         */ get: function() {
            if (this.pageTemplate == null) this.pageTemplate = new (0, $d739365b109dbda9$export$10e7fe8445bdd03b)();
            return this.pageTemplate;
        },
        set: function(value) {
            this.pageTemplate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "document", {
        /**
         * Gets the `document`.
         * @private
         */ get: function() {
            return this.sectionCollection.document;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSection.prototype, "pages", {
        /**
         * Gets the collection of `pages` in a section (Read only)
         * @private
         */ get: function() {
            if (this.pagesCollection == null || typeof this.pagesCollection === "undefined") this.pagesCollection = new (0, $96e495a42e9fc8cb$export$56489e89398d9e19)(this);
            return this.pagesCollection;
        },
        enumerable: true,
        configurable: true
    });
    //methods
    /**
     * `Return the page collection` of current section.
     * @private
     */ PdfSection.prototype.getPages = function() {
        return this.pdfPages;
    };
    /**
     * `Translates` point into native coordinates of the page.
     * @private
     */ PdfSection.prototype.pointToNativePdf = function(page, point) {
        var bounds = this.getActualBounds(page, true);
        point.x += bounds.x;
        point.y = this.pageSettings.height - point.y;
        return point;
    };
    /**
     * Sets the page setting of the current section.
     * @public
     * @param settings Instance of `PdfPageSettings`
     */ PdfSection.prototype.setPageSettings = function(settings) {
        this.settings = settings;
        this.state.orientation = settings.orientation;
        this.state.rotate = settings.rotate;
        this.state.size = settings.size;
        this.state.origin = settings.origin;
    };
    /**
     * `Initializes` the object.
     * @private
     */ PdfSection.prototype.initialize = function() {
        this.pagesReferences = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        this.section = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        this.state = new $05be0d3ce943f055$export$a164da05398c7d2d(this.pdfDocument);
        this.section.sectionBeginSave = new (0, $467b51a52206950c$export$ed84ec84144fcf26)(this, this.state);
        this.pageCount = new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0);
        this.section.items.setValue(this.dictionaryProperties.count, this.pageCount);
        this.section.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.pages));
        this.section.items.setValue(this.dictionaryProperties.kids, this.pagesReferences);
    };
    /**
     * Checks whether any template should be printed on this layer.
     * @private
     * @param document The parent document.
     * @param page The parent page.
     * @param foreground Layer z-order.
     * @returns True - if some content should be printed on the layer, False otherwise.
     */ PdfSection.prototype.containsTemplates = function(document, page, foreground) {
        var documentHeaders = this.getDocumentTemplates(document, page, foreground);
        var sectionTemplates = this.getSectionTemplates(page, foreground);
        return documentHeaders.length > 0 || sectionTemplates.length > 0;
    };
    /**
     * Returns array of the document templates.
     * @private
     * @param document The parent document.
     * @param page The parent page.
     * @param headers If true - return headers/footers, if false - return simple templates.
     * @param foreground If true - return foreground templates, if false - return background templates.
     * @returns Returns array of the document templates.
     */ /* tslint:disable */ PdfSection.prototype.getDocumentTemplates = function(document, page, foreground) {
        var templates = [];
        if (this.template.applyDocumentTopTemplate && document.template.getTop(page) != null) {
            if (!(document.template.getTop(page).foreground || foreground) || document.template.getTop(page).foreground && foreground) templates.push(document.template.getTop(page));
        }
        if (this.template.applyDocumentBottomTemplate && document.template.getBottom(page) != null) {
            if (!(document.template.getBottom(page).foreground || foreground) || document.template.getBottom(page).foreground && foreground) templates.push(document.template.getBottom(page));
        }
        if (this.template.applyDocumentLeftTemplate && document.template.getLeft(page) != null) {
            if (!(document.template.getLeft(page).foreground || foreground) || document.template.getLeft(page).foreground && foreground) templates.push(document.template.getLeft(page));
        }
        if (this.template.applyDocumentRightTemplate && document.template.getRight(page) != null) {
            if (!(document.template.getRight(page).foreground || foreground) || document.template.getRight(page).foreground && foreground) templates.push(document.template.getRight(page));
        }
        return templates;
    };
    /**
     * Returns array of the section templates.
     * @private
     * @param page The parent page.
     * @param foreground If true - return foreground templates, if false - return background templates.
     * @returns Returns array of the section templates.
     */ /* tslint:disable */ PdfSection.prototype.getSectionTemplates = function(page, foreground) {
        var templates = [];
        if (this.template.getTop(page) != null) {
            var pageTemplate = this.template.getTop(page);
            if (!(pageTemplate.foreground || foreground) || pageTemplate.foreground && foreground) templates.push(pageTemplate);
        }
        if (this.template.getBottom(page) != null) {
            var pageTemplate = this.template.getBottom(page);
            if (!(pageTemplate.foreground || foreground) || pageTemplate.foreground && foreground) templates.push(pageTemplate);
        }
        if (this.template.getLeft(page) != null) {
            var pageTemplate = this.template.getLeft(page);
            if (!(pageTemplate.foreground || foreground) || pageTemplate.foreground && foreground) templates.push(pageTemplate);
        }
        if (this.template.getRight(page) != null) {
            var pageTemplate = this.template.getRight(page);
            if (!(pageTemplate.foreground || foreground) || pageTemplate.foreground && foreground) templates.push(pageTemplate);
        }
        return templates;
    };
    /* tslint:enable */ /**
     * `Adds` the specified page.
     * @private
     */ PdfSection.prototype.add = function(page) {
        if (typeof page === "undefined") {
            var page_1 = new (0, $b3834a1b559693d8$export$1686f89eb33d2b08)();
            this.add(page_1);
            return page_1;
        } else {
            var r = this.checkPresence(page);
            this.pdfPages.push(page);
            this.pagesReferences.add(r);
            page.setSection(this);
            page.resetProgress();
            this.pageAddedMethod(page);
        }
    };
    /**
     * `Checks the presence`.
     * @private
     */ PdfSection.prototype.checkPresence = function(page) {
        var rh = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(page);
        var contains = false;
        var sc = this.parent;
        for(var index = 0; index < sc.section.length; index++){
            var section = sc.section[index];
            contains = contains || section.contains(page);
        }
        return rh;
    };
    /**
     * `Determines` whether the page in within the section.
     * @private
     */ PdfSection.prototype.contains = function(page) {
        var index = this.indexOf(page);
        return 0 <= index;
    };
    /**
     * Get the `index of` the page.
     * @private
     */ PdfSection.prototype.indexOf = function(page) {
        for(var index = 0; index < this.pdfPages.length; index++){
            if (this.pdfPages[index] === page) return this.pdfPages.indexOf(page);
        }
        var r = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(page);
        return this.pagesReferences.indexOf(r);
    };
    /**
     * Call two event's methods.
     * @hidden
     * @private
     */ PdfSection.prototype.pageAddedMethod = function(page) {
        //Create event's arguments
        var args = new (0, $527206db78592850$export$345bfdc4eaf3b9dd)(page);
        this.onPageAdded(args);
        var parent = this.parent;
        parent.document.pages.onPageAdded(args);
        this.pageCount.intValue = this.count;
    };
    /**
     * Called when the page has been added.
     * @hidden
     * @private
     */ PdfSection.prototype.onPageAdded = function(args) {
    //
    };
    PdfSection.prototype.getActualBounds = function(arg1, arg2, arg3) {
        if (arg1 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08) && typeof arg2 === "boolean") {
            var result = void 0;
            var document_1 = this.parent.document;
            result = this.getActualBounds(document_1, arg1, arg2);
            return result;
        } else {
            arg1;
            arg2;
            arg3;
            var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
            bounds.height = arg3 ? this.pageSettings.size.height : this.pageSettings.getActualSize().height;
            bounds.width = arg3 ? this.pageSettings.size.width : this.pageSettings.getActualSize().width;
            var left = this.getLeftIndentWidth(arg1, arg2, arg3);
            var top_1 = this.getTopIndentHeight(arg1, arg2, arg3);
            var right = this.getRightIndentWidth(arg1, arg2, arg3);
            var bottom = this.getBottomIndentHeight(arg1, arg2, arg3);
            bounds.x += left;
            bounds.y += top_1;
            bounds.width -= left + right;
            bounds.height -= top_1 + bottom;
            return bounds;
        }
    };
    /**
     * Calculates width of the `left indent`.
     * @private
     */ PdfSection.prototype.getLeftIndentWidth = function(document, page, includeMargins) {
        if (document == null) throw new Error("ArgumentNullException:document");
        if (page == null) throw new Error("ArgumentNullException:page");
        var value = includeMargins ? this.pageSettings.margins.left : 0;
        var templateWidth = this.template.getLeft(page) != null ? this.template.getLeft(page).width : 0;
        var docTemplateWidth = document.template.getLeft(page) != null ? document.template.getLeft(page).width : 0;
        value += this.template.applyDocumentLeftTemplate ? Math.max(templateWidth, docTemplateWidth) : templateWidth;
        return value;
    };
    /**
     * Calculates `Height` of the top indent.
     * @private
     */ PdfSection.prototype.getTopIndentHeight = function(document, page, includeMargins) {
        if (document == null) throw new Error("ArgumentNullException:document");
        if (page == null) throw new Error("ArgumentNullException:page");
        var value = includeMargins ? this.pageSettings.margins.top : 0;
        var templateHeight = this.template.getTop(page) != null ? this.template.getTop(page).height : 0;
        var docTemplateHeight = document.template.getTop(page) != null ? document.template.getTop(page).height : 0;
        value += this.template.applyDocumentTopTemplate ? Math.max(templateHeight, docTemplateHeight) : templateHeight;
        return value;
    };
    /**
     * Calculates `width` of the right indent.
     * @private
     */ PdfSection.prototype.getRightIndentWidth = function(document, page, includeMargins) {
        if (document == null) throw new Error("ArgumentNullException:document");
        if (page == null) throw new Error("ArgumentNullException:page");
        var value = includeMargins ? this.pageSettings.margins.right : 0;
        var templateWidth = this.template.getRight(page) != null ? this.template.getRight(page).width : 0;
        var docTemplateWidth = document.template.getRight(page) != null ? document.template.getRight(page).width : 0;
        value += this.template.applyDocumentRightTemplate ? Math.max(templateWidth, docTemplateWidth) : templateWidth;
        return value;
    };
    /**
     * Calculates `Height` of the bottom indent.
     * @private
     */ PdfSection.prototype.getBottomIndentHeight = function(document, page, includeMargins) {
        if (document == null) throw new Error("ArgumentNullException:document");
        if (page == null) throw new Error("ArgumentNullException:page");
        var value = includeMargins ? this.pageSettings.margins.bottom : 0;
        var templateHeight = this.template.getBottom(page) != null ? this.template.getBottom(page).height : 0;
        var docTemplateHeight = document.template.getBottom(page) != null ? document.template.getBottom(page).height : 0;
        value += this.template.applyDocumentBottomTemplate ? Math.max(templateHeight, docTemplateHeight) : templateHeight;
        return value;
    };
    /**
     * `Removes` the page from the section.
     * @private
     */ PdfSection.prototype.remove = function(page) {
        if (page == null) throw Error('ArgumentNullException("page")');
        var index = this.pdfPages.indexOf(page);
        this.pagesReferences.removeAt(index);
        var temproaryPages = [];
        for(var j = 0; j < index; j++)temproaryPages.push(this.pdfPages[j]);
        for(var j = index + 1; j < this.pdfPages.length; j++)temproaryPages.push(this.pdfPages[j]);
        this.pdfPages = temproaryPages;
    };
    /**
     * In fills dictionary by the data from `Page settings`.
     * @private
     */ PdfSection.prototype.applyPageSettings = function(container, parentSettings, state) {
        var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(state.origin, state.size);
        container.items.setValue(this.dictionaryProperties.mediaBox, (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(bounds));
        var rotate = 0;
        rotate = (0, $2851d20f042c06f3$export$1295bf8a61de96dd).rotateFactor * state.rotate;
        var angle = new (0, $f982301cdcaba043$export$8883fe148ef336b4)(rotate);
        container.items.setValue(this.dictionaryProperties.rotate, angle);
    };
    /**
     * Catches the Save event of the dictionary.
     * @hidden
     * @private
     */ PdfSection.prototype.beginSave = function(state, writer) {
        var doc = writer.document;
        this.applyPageSettings(this.section, doc.pageSettings, state);
    };
    /**
     * Draws page templates on the page.
     * @private
     */ PdfSection.prototype.drawTemplates = function(page, layer, document, foreground) {
        var documentHeaders = this.getDocumentTemplates(document, page, foreground);
        var sectionHeaders = this.getSectionTemplates(page, foreground);
        this.drawTemplatesHelper(layer, document, documentHeaders);
        this.drawTemplatesHelper(layer, document, sectionHeaders);
    };
    /**
     * Draws page templates on the page.
     * @private
     */ PdfSection.prototype.drawTemplatesHelper = function(layer, document, templates) {
        if (templates != null && templates.length > 0) {
            var len = templates.length;
            for(var i = 0; i < len; i++){
                var template = templates[i];
                template.draw(layer, document);
            }
        }
    };
    return PdfSection;
}();
var $05be0d3ce943f055$export$a164da05398c7d2d = /** @class */ function() {
    //Public Constructor
    /**
     * New instance to store the `PageSettings`.
     * @private
     */ function PageSettingsState(document) {
        this.pageOrientation = document.pageSettings.orientation;
        this.pageRotate = document.pageSettings.rotate;
        this.pageSize = document.pageSettings.size;
        this.pageOrigin = document.pageSettings.origin;
    }
    Object.defineProperty(PageSettingsState.prototype, "orientation", {
        //public Properties
        /**
         * @hidden
         * @private
         */ get: function() {
            return this.pageOrientation;
        },
        set: function(value) {
            this.pageOrientation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageSettingsState.prototype, "rotate", {
        /**
         * @hidden
         * @private
         */ get: function() {
            return this.pageRotate;
        },
        set: function(value) {
            this.pageRotate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageSettingsState.prototype, "size", {
        /**
         * @hidden
         * @private
         */ get: function() {
            return this.pageSize;
        },
        set: function(value) {
            this.pageSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageSettingsState.prototype, "origin", {
        /**
         * @hidden
         * @private
         */ get: function() {
            return this.pageOrigin;
        },
        set: function(value) {
            this.pageOrigin = value;
        },
        enumerable: true,
        configurable: true
    });
    return PageSettingsState;
}();



/**
 * Represents the `collection of the sections`.
 * @private
 */ var $2851d20f042c06f3$export$1295bf8a61de96dd = /** @class */ function() {
    //constructor
    /**
     * Initializes a new instance of the `PdfSectionCollection` class.
     * @private
     */ function PdfSectionCollection(document) {
        /**
         * @hidden
         * @private
         */ this.sections = [];
        /**
         * @hidden
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        // if (document === null) {
        //     throw new Error('ArgumentNullException : document');
        // }
        this.pdfDocument = document.clone();
        this.initialize();
    }
    Object.defineProperty(PdfSectionCollection.prototype, "section", {
        //Properties
        /**
         * Gets the `Section` collection.
         */ get: function() {
            return this.sections;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionCollection.prototype, "document", {
        /**
         * Gets a parent `document`.
         * @private
         */ get: function() {
            return this.pdfDocument;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionCollection.prototype, "count", {
        /**
         * Gets the `number of sections` in a document.
         * @private
         */ get: function() {
            return this.sections.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfSectionCollection.prototype, "element", {
        /**
         * Gets the wrapped `element`.
         * @private
         */ get: function() {
            return this.pages;
        },
        enumerable: true,
        configurable: true
    });
    //Methods
    /**
     * `Initializes the object`.
     * @private
     */ PdfSectionCollection.prototype.initialize = function() {
        this.sectionCount = new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0);
        this.sectionCollection = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        this.pages = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        this.pages.beginSave = new (0, $467b51a52206950c$export$6e00e39d26720792)(this);
        this.pages.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)("Pages"));
        this.pages.items.setValue(this.dictionaryProperties.kids, this.sectionCollection);
        this.pages.items.setValue(this.dictionaryProperties.count, this.sectionCount);
        this.pages.items.setValue(this.dictionaryProperties.resources, new (0, $467b51a52206950c$export$f103d8ead0680780)());
        this.setPageSettings(this.pages, this.pdfDocument.pageSettings);
    };
    /**
     * Initializes a new instance of the `PdfSectionCollection` class.
     * @private
     */ PdfSectionCollection.prototype.pdfSectionCollection = function(index) {
        if (index < 0 || index >= this.count) throw new Error("IndexOutOfRangeException()");
        return this.sections[index];
    };
    /**
     * In fills dictionary by the data from `Page settings`.
     * @private
     */ PdfSectionCollection.prototype.setPageSettings = function(container, pageSettings) {
        // if (container === null) {
        //     throw new Error('ArgumentNullException : container');
        // }
        // if (pageSettings === null) {
        //     throw new Error('ArgumentNullException : pageSettings');
        // }
        var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(), pageSettings.size);
        container.items.setValue(this.dictionaryProperties.mediaBox, (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(bounds));
    };
    /**
     * `Adds` the specified section.
     * @private
     */ PdfSectionCollection.prototype.add = function(section) {
        if (typeof section === "undefined") {
            var section_1 = new (0, $05be0d3ce943f055$export$bdf2a2e0c7c8f73c)(this.pdfDocument);
            this.add(section_1);
            return section_1;
        } else {
            // if (section === null) {
            //     throw new Error('ArgumentNullException : section');
            // }
            var r = this.checkSection(section);
            this.sections.push(section);
            section.parent = this;
            this.sectionCollection.add(r);
            return this.sections.indexOf(section);
        }
    };
    /**
     * `Checks` if the section is within the collection.
     * @private
     */ PdfSectionCollection.prototype.checkSection = function(section) {
        var r = new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(section);
        var contains = this.sectionCollection.contains(r);
        // if (contains) {
        //     throw new Error('ArgumentException : The object can not be added twice to the collection,section');
        // }
        return r;
    };
    /**
     * Catches the Save event of the dictionary to `count the pages`.
     * @private
     */ PdfSectionCollection.prototype.countPages = function() {
        var count = 0;
        this.sections.forEach(function(n) {
            return count += n.count;
        });
        return count;
    };
    /**
     * Catches the Save event of the dictionary to `count the pages`.
     * @hidden
     * @private
     */ PdfSectionCollection.prototype.beginSave = function() {
        this.sectionCount.intValue = this.countPages();
    };
    //Fields
    /**
     * Rotate factor for page `rotation`.
     * @default 90
     * @private
     */ PdfSectionCollection.rotateFactor = 90;
    return PdfSectionCollection;
}();




/**
 * Represents a virtual collection of all the pages in the document.
 * @private
 */ var $9400b0f694f1a1f2$export$98e5bfaac9374900 = /** @class */ function() {
    //constructor
    /**
     * Initializes a new instance of the `PdfPageCollection` class.
     * @private
     */ function PdfDocumentPageCollection(document) {
        /**
         * It holds the page collection with the `index`.
         * @private
         */ this.pdfPageCollectionIndex = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
        this.document = document;
    }
    Object.defineProperty(PdfDocumentPageCollection.prototype, "count", {
        //Property
        /**
         * Gets the total `number of the pages`.
         * @private
         */ get: function() {
            return this.countPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocumentPageCollection.prototype, "pageCollectionIndex", {
        /**
         * Gets a `page index` from the document.
         * @private
         */ get: function() {
            return this.pdfPageCollectionIndex;
        },
        enumerable: true,
        configurable: true
    });
    PdfDocumentPageCollection.prototype.add = function(page) {
        if (typeof page === "undefined") {
            var page_1 = new (0, $b3834a1b559693d8$export$1686f89eb33d2b08)();
            this.add(page_1);
            return page_1;
        } else {
            var section = this.getLastSection();
            section.add(page);
        }
    };
    /**
     * Returns `last section` in the document.
     * @private
     */ PdfDocumentPageCollection.prototype.getLastSection = function() {
        var sc = this.document.sections;
        if (sc.section.length === 0) sc.add();
        var section = sc.section[sc.section.length - 1];
        return section;
    };
    /**
     * Called when `new page has been added`.
     * @private
     */ PdfDocumentPageCollection.prototype.onPageAdded = function(args) {
    // if (PageAdded !== null)
    // {
    //     PageAdded(this, args);
    // }
    };
    /**
     * Gets the `total number of pages`.
     * @private
     */ PdfDocumentPageCollection.prototype.countPages = function() {
        var sc = this.document.sections;
        var count = 0;
        for(var index = 0; index < sc.section.length; index++)count += sc.section[index].count;
        return count;
    };
    /**
     * Gets the `page object` from page index.
     * @private
     */ PdfDocumentPageCollection.prototype.getPageByIndex = function(index) {
        return this.getPage(index);
    };
    /**
     * Gets a page by its `index` in the document.
     * @private
     */ PdfDocumentPageCollection.prototype.getPage = function(index) {
        if (index < 0 || index >= this.count) throw Error('ArgumentOutOfRangeException("index", "Value can not be less 0")');
        var page = null;
        var sectionStartIndex = 0;
        var sectionCount = 0;
        var pageIndex = 0;
        var length = this.document.sections.count;
        for(var i = 0; i < length; i++){
            var section = this.document.sections.section[i];
            sectionCount = section.count;
            pageIndex = index - sectionStartIndex;
            // We found a section containing the page.
            if (index >= sectionStartIndex && pageIndex < sectionCount) {
                page = section.getPages()[pageIndex];
                break;
            }
            sectionStartIndex += sectionCount;
        }
        return page;
    };
    /**
     * Gets the `index of` the page in the document.
     * @private
     */ PdfDocumentPageCollection.prototype.indexOf = function(page) {
        var index = -1;
        if (page == null) throw new Error("ArgumentNullException: page");
        else {
            var numPages = 0;
            for(var i = 0, len = this.document.sections.count; i < len; i++){
                var section = this.document.sections.pdfSectionCollection(i);
                index = section.indexOf(page);
                if (index >= 0) {
                    index += numPages;
                    break;
                } else index = -1;
                numPages += section.count;
            }
        }
        return index;
    };
    /**
     * `Removes` the specified page.
     * @private
     */ PdfDocumentPageCollection.prototype.remove = function(page) {
        if (page == null) throw Error('ArgumentNullException("page")');
        var section = null;
        var len;
        for(var i = 0, len_1 = this.document.sections.count; i < len_1; i++){
            section = this.document.sections.pdfSectionCollection(i);
            if (section.pages.contains(page)) {
                section.pages.remove(page);
                break;
            }
        }
        return section;
    };
    return PdfDocumentPageCollection;
}();


/**
 * PdfCacheCollection.ts class for EJ2-PDF
 */ 
/**
 * `Collection of the cached objects`.
 * @private
 */ var $07539e5c5ace4ab0$export$6aa948e0610f285b = /** @class */ function() {
    // Constructors
    /**
     * Initializes a new instance of the `PdfCacheCollection` class.
     * @private
     */ function PdfCacheCollection() {
        this.referenceObjects = [];
        this.pdfFontCollection = new (0, $19695c1d6738aaeb$export$4ee70ab773570fb9)();
    }
    // Public methods
    /**
     * `Searches` for the similar cached object. If is not found - adds the object to the cache.
     * @private
     */ PdfCacheCollection.prototype.search = function(obj) {
        var result = null;
        var group = this.getGroup(obj);
        if (group == null) group = this.createNewGroup();
        else if (group.length > 0) result = group[0];
        group.push(obj);
        return result;
    };
    // Implementation
    /**
     * `Creates` a new group.
     * @private
     */ PdfCacheCollection.prototype.createNewGroup = function() {
        var group = [];
        this.referenceObjects.push(group);
        return group;
    };
    /**
     * `Find and Return` a group.
     * @private
     */ PdfCacheCollection.prototype.getGroup = function(result) {
        var group = null;
        if (result !== null) {
            var len = this.referenceObjects.length;
            for(var i = 0; i < len; i++){
                if (this.referenceObjects.length > 0) {
                    var tGroup = this.referenceObjects[i];
                    if (tGroup.length > 0) {
                        var representative = tGroup[0];
                        if (result.equalsTo(representative)) {
                            group = tGroup;
                            break;
                        }
                    } else this.removeGroup(tGroup);
                }
                len = this.referenceObjects.length;
            }
        }
        return group;
    };
    /**
     * Remove a group from the storage.
     */ PdfCacheCollection.prototype.removeGroup = function(group) {
        if (group !== null) {
            var index = this.referenceObjects.indexOf(group);
            this.referenceObjects.slice(index, index + 1);
        }
    };
    PdfCacheCollection.prototype.destroy = function() {
        this.pdfFontCollection = undefined;
        this.referenceObjects = undefined;
    };
    return PdfCacheCollection;
}();








/**
 * PdfStandardFontMetricsFactory.ts class for EJ2-PDF
 */ 

/**
 * @private
 * `Factory of the standard fonts metrics`.
 */ var $8715da285fefaebb$export$7d9aa3116289ddad = /** @class */ function() {
    function PdfStandardFontMetricsFactory() {}
    /**
     * Returns `metrics` of the font.
     * @private
     */ PdfStandardFontMetricsFactory.getMetrics = function(fontFamily, fontStyle, size) {
        var metrics = null;
        switch(fontFamily){
            case (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica:
                metrics = this.getHelveticaMetrics(fontFamily, fontStyle, size);
                break;
            case (0, $32129651824bb502$export$be66ab191dea7a97).Courier:
                metrics = this.getCourierMetrics(fontFamily, fontStyle, size);
                break;
            case (0, $32129651824bb502$export$be66ab191dea7a97).TimesRoman:
                metrics = this.getTimesMetrics(fontFamily, fontStyle, size);
                break;
            case (0, $32129651824bb502$export$be66ab191dea7a97).Symbol:
                metrics = this.getSymbolMetrics(fontFamily, fontStyle, size);
                break;
            case (0, $32129651824bb502$export$be66ab191dea7a97).ZapfDingbats:
                metrics = this.getZapfDingbatsMetrics(fontFamily, fontStyle, size);
                break;
            default:
                metrics = this.getHelveticaMetrics((0, $32129651824bb502$export$be66ab191dea7a97).Helvetica, fontStyle, size);
                break;
        }
        metrics.name = fontFamily.toString();
        metrics.subScriptSizeFactor = this.subSuperScriptFactor;
        metrics.superscriptSizeFactor = this.subSuperScriptFactor;
        return metrics;
    };
    // Implementation
    /**
     * Creates `Helvetica font metrics`.
     * @private
     */ PdfStandardFontMetricsFactory.getHelveticaMetrics = function(fontFamily, fontStyle, size) {
        var metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0 && (fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.helveticaBoldItalicAscent;
            metrics.descent = this.helveticaBoldItalicDescent;
            metrics.postScriptName = this.helveticaBoldItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.arialBoldWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0) {
            metrics.ascent = this.helveticaBoldAscent;
            metrics.descent = this.helveticaBoldDescent;
            metrics.postScriptName = this.helveticaBoldName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.arialBoldWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.helveticaItalicAscent;
            metrics.descent = this.helveticaItalicDescent;
            metrics.postScriptName = this.helveticaItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.arialWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else {
            metrics.ascent = this.helveticaAscent;
            metrics.descent = this.helveticaDescent;
            metrics.postScriptName = this.helveticaName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.arialWidth);
            metrics.height = metrics.ascent - metrics.descent;
        }
        return metrics;
    };
    /**
     * Creates `Courier font metrics`.
     * @private
     */ PdfStandardFontMetricsFactory.getCourierMetrics = function(fontFamily, fontStyle, size) {
        var metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0 && (fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.courierBoldItalicAscent;
            metrics.descent = this.courierBoldItalicDescent;
            metrics.postScriptName = this.courierBoldItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.fixedWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0) {
            metrics.ascent = this.courierBoldAscent;
            metrics.descent = this.courierBoldDescent;
            metrics.postScriptName = this.courierBoldName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.fixedWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.courierItalicAscent;
            metrics.descent = this.courierItalicDescent;
            metrics.postScriptName = this.courierItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.fixedWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else {
            metrics.ascent = this.courierAscent;
            metrics.descent = this.courierDescent;
            metrics.postScriptName = this.courierName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.fixedWidth);
            metrics.height = metrics.ascent - metrics.descent;
        }
        return metrics;
    };
    /**
     * Creates `Times font metrics`.
     * @private
     */ PdfStandardFontMetricsFactory.getTimesMetrics = function(fontFamily, fontStyle, size) {
        var metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0 && (fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.timesBoldItalicAscent;
            metrics.descent = this.timesBoldItalicDescent;
            metrics.postScriptName = this.timesBoldItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.timesRomanBoldItalicWidths);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Bold) > 0) {
            metrics.ascent = this.timesBoldAscent;
            metrics.descent = this.timesBoldDescent;
            metrics.postScriptName = this.timesBoldName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.timesRomanBoldWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else if ((fontStyle & (0, $32129651824bb502$export$80979869bc40ff1f).Italic) > 0) {
            metrics.ascent = this.timesItalicAscent;
            metrics.descent = this.timesItalicDescent;
            metrics.postScriptName = this.timesItalicName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.timesRomanItalicWidth);
            metrics.height = metrics.ascent - metrics.descent;
        } else {
            metrics.ascent = this.timesAscent;
            metrics.descent = this.timesDescent;
            metrics.postScriptName = this.timesName;
            metrics.size = size;
            metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.timesRomanWidth);
            metrics.height = metrics.ascent - metrics.descent;
        }
        return metrics;
    };
    /**
     * Creates `Symbol font metrics`.
     * @private
     */ PdfStandardFontMetricsFactory.getSymbolMetrics = function(fontFamily, fontStyle, size) {
        var metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        metrics.ascent = this.symbolAscent;
        metrics.descent = this.symbolDescent;
        metrics.postScriptName = this.symbolName;
        metrics.size = size;
        metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.symbolWidth);
        metrics.height = metrics.ascent - metrics.descent;
        return metrics;
    };
    /**
     * Creates `ZapfDingbats font metrics`.
     * @private
     */ PdfStandardFontMetricsFactory.getZapfDingbatsMetrics = function(fontFamily, fontStyle, size) {
        var metrics = new (0, $08793818e6cf5e5a$export$4cb7d36a071e5774)();
        metrics.ascent = this.zapfDingbatsAscent;
        metrics.descent = this.zapfDingbatsDescent;
        metrics.postScriptName = this.zapfDingbatsName;
        metrics.size = size;
        metrics.widthTable = new (0, $08793818e6cf5e5a$export$8a4fe9dae84da916)(this.zapfDingbatsWidth);
        metrics.height = metrics.ascent - metrics.descent;
        return metrics;
    };
    /**
     * `Multiplier` os subscript superscript.
     * @private
     */ PdfStandardFontMetricsFactory.subSuperScriptFactor = 1.52;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaAscent = 931;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaDescent = -225;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaName = "Helvetica";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldAscent = 962;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldDescent = -228;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldName = "Helvetica-Bold";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaItalicAscent = 931;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaItalicDescent = -225;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaItalicName = "Helvetica-Oblique";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldItalicAscent = 962;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldItalicDescent = -228;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.helveticaBoldItalicName = "Helvetica-BoldOblique";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierAscent = 805;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierDescent = -250;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.courierName = "Courier";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldAscent = 801;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldDescent = -250;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldName = "Courier-Bold";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierItalicAscent = 805;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierItalicDescent = -250;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.courierItalicName = "Courier-Oblique";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldItalicAscent = 801;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldItalicDescent = -250;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.courierBoldItalicName = "Courier-BoldOblique";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesAscent = 898;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesDescent = -218;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.timesName = "Times-Roman";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldAscent = 935;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldDescent = -218;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldName = "Times-Bold";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesItalicAscent = 883;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesItalicDescent = -217;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.timesItalicName = "Times-Italic";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldItalicAscent = 921;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldItalicDescent = -218;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.timesBoldItalicName = "Times-BoldItalic";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.symbolAscent = 1010;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.symbolDescent = -293;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.symbolName = "Symbol";
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.zapfDingbatsAscent = 820;
    /**
     * `Ascender` value for the font.
     * @private
     */ PdfStandardFontMetricsFactory.zapfDingbatsDescent = -143;
    /**
     * `Font type`.
     * @private
     */ PdfStandardFontMetricsFactory.zapfDingbatsName = "ZapfDingbats";
    /**
     * `Arial` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.arialWidth = [
        278,
        278,
        355,
        556,
        556,
        889,
        667,
        191,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        584,
        584,
        584,
        556,
        1015,
        667,
        667,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        500,
        667,
        556,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        278,
        278,
        278,
        469,
        556,
        333,
        556,
        556,
        500,
        556,
        556,
        278,
        556,
        556,
        222,
        222,
        500,
        222,
        833,
        556,
        556,
        556,
        556,
        333,
        500,
        278,
        556,
        500,
        722,
        500,
        500,
        500,
        334,
        260,
        334,
        584,
        0,
        556,
        0,
        222,
        556,
        333,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        0,
        611,
        0,
        0,
        222,
        222,
        333,
        333,
        350,
        556,
        1000,
        333,
        1000,
        500,
        333,
        944,
        0,
        500,
        667,
        0,
        333,
        556,
        556,
        556,
        556,
        260,
        556,
        333,
        737,
        370,
        556,
        584,
        0,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        556,
        537,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        667,
        667,
        667,
        667,
        667,
        667,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        500,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        584,
        611,
        556,
        556,
        556,
        556,
        500,
        556,
        500
    ];
    /**
     * `Arial bold` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.arialBoldWidth = [
        278,
        333,
        474,
        556,
        556,
        889,
        722,
        238,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        333,
        333,
        584,
        584,
        584,
        611,
        975,
        722,
        722,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        556,
        722,
        611,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        333,
        278,
        333,
        584,
        556,
        333,
        556,
        611,
        556,
        611,
        556,
        333,
        611,
        611,
        278,
        278,
        556,
        278,
        889,
        611,
        611,
        611,
        611,
        389,
        556,
        333,
        611,
        556,
        778,
        556,
        556,
        500,
        389,
        280,
        389,
        584,
        0,
        556,
        0,
        278,
        556,
        500,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        0,
        611,
        0,
        0,
        278,
        278,
        500,
        500,
        350,
        556,
        1000,
        333,
        1000,
        556,
        333,
        944,
        0,
        500,
        667,
        0,
        333,
        556,
        556,
        556,
        556,
        280,
        556,
        333,
        737,
        370,
        556,
        584,
        0,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        611,
        556,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        722,
        722,
        722,
        722,
        722,
        722,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        611,
        611,
        611,
        611,
        611,
        611,
        611,
        584,
        611,
        611,
        611,
        611,
        611,
        556,
        611,
        556
    ];
    /**
     * `Fixed` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.fixedWidth = [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ];
    /**
     * `Times` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.timesRomanWidth = [
        250,
        333,
        408,
        500,
        500,
        833,
        778,
        180,
        333,
        333,
        500,
        564,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        278,
        278,
        564,
        564,
        564,
        444,
        921,
        722,
        667,
        667,
        722,
        611,
        556,
        722,
        722,
        333,
        389,
        722,
        611,
        889,
        722,
        722,
        556,
        722,
        667,
        556,
        611,
        722,
        722,
        944,
        722,
        722,
        611,
        333,
        278,
        333,
        469,
        500,
        333,
        444,
        500,
        444,
        500,
        444,
        333,
        500,
        500,
        278,
        278,
        500,
        278,
        778,
        500,
        500,
        500,
        500,
        333,
        389,
        278,
        500,
        500,
        722,
        500,
        500,
        444,
        480,
        200,
        480,
        541,
        0,
        500,
        0,
        333,
        500,
        444,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        889,
        0,
        611,
        0,
        0,
        333,
        333,
        444,
        444,
        350,
        500,
        1000,
        333,
        980,
        389,
        333,
        722,
        0,
        444,
        722,
        0,
        333,
        500,
        500,
        500,
        500,
        200,
        500,
        333,
        760,
        276,
        500,
        564,
        0,
        760,
        333,
        400,
        564,
        300,
        300,
        333,
        500,
        453,
        250,
        333,
        300,
        310,
        500,
        750,
        750,
        750,
        444,
        722,
        722,
        722,
        722,
        722,
        722,
        889,
        667,
        611,
        611,
        611,
        611,
        333,
        333,
        333,
        333,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        564,
        722,
        722,
        722,
        722,
        722,
        722,
        556,
        500,
        444,
        444,
        444,
        444,
        444,
        444,
        667,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        564,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500
    ];
    /**
     * `Times bold` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.timesRomanBoldWidth = [
        250,
        333,
        555,
        500,
        500,
        1000,
        833,
        278,
        333,
        333,
        500,
        570,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        570,
        570,
        570,
        500,
        930,
        722,
        667,
        722,
        722,
        667,
        611,
        778,
        778,
        389,
        500,
        778,
        667,
        944,
        722,
        778,
        611,
        778,
        722,
        556,
        667,
        722,
        722,
        1000,
        722,
        722,
        667,
        333,
        278,
        333,
        581,
        500,
        333,
        500,
        556,
        444,
        556,
        444,
        333,
        500,
        556,
        278,
        333,
        556,
        278,
        833,
        556,
        500,
        556,
        556,
        444,
        389,
        333,
        556,
        500,
        722,
        500,
        500,
        444,
        394,
        220,
        394,
        520,
        0,
        500,
        0,
        333,
        500,
        500,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        1000,
        0,
        667,
        0,
        0,
        333,
        333,
        500,
        500,
        350,
        500,
        1000,
        333,
        1000,
        389,
        333,
        722,
        0,
        444,
        722,
        0,
        333,
        500,
        500,
        500,
        500,
        220,
        500,
        333,
        747,
        300,
        500,
        570,
        0,
        747,
        333,
        400,
        570,
        300,
        300,
        333,
        556,
        540,
        250,
        333,
        300,
        330,
        500,
        750,
        750,
        750,
        500,
        722,
        722,
        722,
        722,
        722,
        722,
        1000,
        722,
        667,
        667,
        667,
        667,
        389,
        389,
        389,
        389,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        570,
        778,
        722,
        722,
        722,
        722,
        722,
        611,
        556,
        500,
        500,
        500,
        500,
        500,
        500,
        722,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        556,
        500,
        500,
        500,
        500,
        500,
        570,
        500,
        556,
        556,
        556,
        556,
        500,
        556,
        500
    ];
    /**
     * `Times italic` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.timesRomanItalicWidth = [
        250,
        333,
        420,
        500,
        500,
        833,
        778,
        214,
        333,
        333,
        500,
        675,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        675,
        675,
        675,
        500,
        920,
        611,
        611,
        667,
        722,
        611,
        611,
        722,
        722,
        333,
        444,
        667,
        556,
        833,
        667,
        722,
        611,
        722,
        611,
        500,
        556,
        722,
        611,
        833,
        611,
        556,
        556,
        389,
        278,
        389,
        422,
        500,
        333,
        500,
        500,
        444,
        500,
        444,
        278,
        500,
        500,
        278,
        278,
        444,
        278,
        722,
        500,
        500,
        500,
        500,
        389,
        389,
        278,
        500,
        444,
        667,
        444,
        444,
        389,
        400,
        275,
        400,
        541,
        0,
        500,
        0,
        333,
        500,
        556,
        889,
        500,
        500,
        333,
        1000,
        500,
        333,
        944,
        0,
        556,
        0,
        0,
        333,
        333,
        556,
        556,
        350,
        500,
        889,
        333,
        980,
        389,
        333,
        667,
        0,
        389,
        556,
        0,
        389,
        500,
        500,
        500,
        500,
        275,
        500,
        333,
        760,
        276,
        500,
        675,
        0,
        760,
        333,
        400,
        675,
        300,
        300,
        333,
        500,
        523,
        250,
        333,
        300,
        310,
        500,
        750,
        750,
        750,
        500,
        611,
        611,
        611,
        611,
        611,
        611,
        889,
        667,
        611,
        611,
        611,
        611,
        333,
        333,
        333,
        333,
        722,
        667,
        722,
        722,
        722,
        722,
        722,
        675,
        722,
        722,
        722,
        722,
        722,
        556,
        611,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        667,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        675,
        500,
        500,
        500,
        500,
        500,
        444,
        500,
        444
    ];
    /**
     * `Times bold italic` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.timesRomanBoldItalicWidths = [
        250,
        389,
        555,
        500,
        500,
        833,
        778,
        278,
        333,
        333,
        500,
        570,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        570,
        570,
        570,
        500,
        832,
        667,
        667,
        667,
        722,
        667,
        667,
        722,
        778,
        389,
        500,
        667,
        611,
        889,
        722,
        722,
        611,
        722,
        667,
        556,
        611,
        722,
        667,
        889,
        667,
        611,
        611,
        333,
        278,
        333,
        570,
        500,
        333,
        500,
        500,
        444,
        500,
        444,
        333,
        500,
        556,
        278,
        278,
        500,
        278,
        778,
        556,
        500,
        500,
        500,
        389,
        389,
        278,
        556,
        444,
        667,
        500,
        444,
        389,
        348,
        220,
        348,
        570,
        0,
        500,
        0,
        333,
        500,
        500,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        944,
        0,
        611,
        0,
        0,
        333,
        333,
        500,
        500,
        350,
        500,
        1000,
        333,
        1000,
        389,
        333,
        722,
        0,
        389,
        611,
        0,
        389,
        500,
        500,
        500,
        500,
        220,
        500,
        333,
        747,
        266,
        500,
        606,
        0,
        747,
        333,
        400,
        570,
        300,
        300,
        333,
        576,
        500,
        250,
        333,
        300,
        300,
        500,
        750,
        750,
        750,
        500,
        667,
        667,
        667,
        667,
        667,
        667,
        944,
        667,
        667,
        667,
        667,
        667,
        389,
        389,
        389,
        389,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        570,
        722,
        722,
        722,
        722,
        722,
        611,
        611,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        722,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        556,
        500,
        500,
        500,
        500,
        500,
        570,
        500,
        556,
        556,
        556,
        556,
        444,
        500,
        444
    ];
    /**
     * `Symbol` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.symbolWidth = [
        250,
        333,
        713,
        500,
        549,
        833,
        778,
        439,
        333,
        333,
        500,
        549,
        250,
        549,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        278,
        278,
        549,
        549,
        549,
        444,
        549,
        722,
        667,
        722,
        612,
        611,
        763,
        603,
        722,
        333,
        631,
        722,
        686,
        889,
        722,
        722,
        768,
        741,
        556,
        592,
        611,
        690,
        439,
        768,
        645,
        795,
        611,
        333,
        863,
        333,
        658,
        500,
        500,
        631,
        549,
        549,
        494,
        439,
        521,
        411,
        603,
        329,
        603,
        549,
        549,
        576,
        521,
        549,
        549,
        521,
        549,
        603,
        439,
        576,
        713,
        686,
        493,
        686,
        494,
        480,
        200,
        480,
        549,
        750,
        620,
        247,
        549,
        167,
        713,
        500,
        753,
        753,
        753,
        753,
        1042,
        987,
        603,
        987,
        603,
        400,
        549,
        411,
        549,
        549,
        713,
        494,
        460,
        549,
        549,
        549,
        549,
        1000,
        603,
        1000,
        658,
        823,
        686,
        795,
        987,
        768,
        768,
        823,
        768,
        768,
        713,
        713,
        713,
        713,
        713,
        713,
        713,
        768,
        713,
        790,
        790,
        890,
        823,
        549,
        250,
        713,
        603,
        603,
        1042,
        987,
        603,
        987,
        603,
        494,
        329,
        790,
        790,
        786,
        713,
        384,
        384,
        384,
        384,
        384,
        384,
        494,
        494,
        494,
        494,
        329,
        274,
        686,
        686,
        686,
        384,
        384,
        384,
        384,
        384,
        384,
        494,
        494,
        494,
        -1
    ];
    /**
     * `Zip dingbats` widths table.
     * @private
     */ PdfStandardFontMetricsFactory.zapfDingbatsWidth = [
        278,
        974,
        961,
        974,
        980,
        719,
        789,
        790,
        791,
        690,
        960,
        939,
        549,
        855,
        911,
        933,
        911,
        945,
        974,
        755,
        846,
        762,
        761,
        571,
        677,
        763,
        760,
        759,
        754,
        494,
        552,
        537,
        577,
        692,
        786,
        788,
        788,
        790,
        793,
        794,
        816,
        823,
        789,
        841,
        823,
        833,
        816,
        831,
        923,
        744,
        723,
        749,
        790,
        792,
        695,
        776,
        768,
        792,
        759,
        707,
        708,
        682,
        701,
        826,
        815,
        789,
        789,
        707,
        687,
        696,
        689,
        786,
        787,
        713,
        791,
        785,
        791,
        873,
        761,
        762,
        762,
        759,
        759,
        892,
        892,
        788,
        784,
        438,
        138,
        277,
        415,
        392,
        392,
        668,
        668,
        390,
        390,
        317,
        317,
        276,
        276,
        509,
        509,
        410,
        410,
        234,
        234,
        334,
        334,
        732,
        544,
        544,
        910,
        667,
        760,
        760,
        776,
        595,
        694,
        626,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        788,
        894,
        838,
        1016,
        458,
        748,
        924,
        748,
        918,
        927,
        928,
        928,
        834,
        873,
        828,
        924,
        924,
        917,
        930,
        931,
        463,
        883,
        836,
        836,
        867,
        867,
        696,
        696,
        874,
        874,
        760,
        946,
        771,
        865,
        771,
        888,
        967,
        888,
        831,
        873,
        927,
        970,
        918
    ];
    return PdfStandardFontMetricsFactory;
}();





var $3d7be084b745fac4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents one of the 14 standard fonts.
 * It's used to create a standard PDF font to draw the text in to the PDF.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a new page to the document
 * let page1 : PdfPage = document.pages.add();
 * //
 * // create new standard font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * //
 * // create black brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $3d7be084b745fac4$export$2e90fbfccef6edcf = /** @class */ function(_super) {
    $3d7be084b745fac4$var$__extends(PdfStandardFont, _super);
    function PdfStandardFont(fontFamilyPrototype, size, style) {
        var _this = _super.call(this, size, typeof style === "undefined" ? fontFamilyPrototype instanceof PdfStandardFont ? fontFamilyPrototype.style : (0, $32129651824bb502$export$80979869bc40ff1f).Regular : style) || this;
        /**
         * Gets `ascent` of the font.
         * @private
         */ _this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * Gets `encodings` for internal class use.
         * @hidden
         * @private
         */ _this.encodings = [
            "Unknown",
            "StandardEncoding",
            "MacRomanEncoding",
            "MacExpertEncoding",
            "WinAnsiEncoding",
            "PDFDocEncoding",
            "IdentityH"
        ];
        if (typeof fontFamilyPrototype === "undefined") _this.pdfFontFamily = (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
        else if (fontFamilyPrototype instanceof PdfStandardFont) _this.pdfFontFamily = fontFamilyPrototype.fontFamily;
        else _this.pdfFontFamily = fontFamilyPrototype;
        _this.checkStyle();
        _this.initializeInternals();
        return _this;
    }
    Object.defineProperty(PdfStandardFont.prototype, "fontFamily", {
        /* tslint:enable */ //Properties
        /**
         * Gets the `FontFamily`.
         * @private
         */ get: function() {
            return this.pdfFontFamily;
        },
        enumerable: true,
        configurable: true
    });
    //methods
    /**
     * Checks font `style` of the font.
     * @private
     */ PdfStandardFont.prototype.checkStyle = function() {
        if (this.fontFamily === (0, $32129651824bb502$export$be66ab191dea7a97).Symbol || this.fontFamily === (0, $32129651824bb502$export$be66ab191dea7a97).ZapfDingbats) {
            var style = this.style;
            style &= ~((0, $32129651824bb502$export$80979869bc40ff1f).Bold | (0, $32129651824bb502$export$80979869bc40ff1f).Italic);
            this.setStyle(style);
        }
    };
    /**
     * Returns `width` of the line.
     * @public
     */ PdfStandardFont.prototype.getLineWidth = function(line, format) {
        if (line == null) throw new Error("ArgumentNullException:line");
        var width = 0;
        var name = this.name;
        line = PdfStandardFont.convert(line);
        for(var i = 0, len = line.length; i < len; i++){
            var ch = line[i];
            var charWidth = this.getCharWidthInternal(ch, format);
            width += charWidth;
        }
        var size = this.metrics.getSize(format);
        width *= (0, $ec27d251b6edcb44$export$60d73556588f648b).charSizeMultiplier * size;
        width = this.applyFormatSettings(line, format, width);
        return width;
    };
    /**
     * Checks whether fonts are `equals`.
     * @private
     */ PdfStandardFont.prototype.equalsToFont = function(font) {
        var equal = false;
        var stFont = font;
        if (stFont != null) {
            var fontFamilyEqual = this.fontFamily === stFont.fontFamily;
            var lineReducer = ~((0, $32129651824bb502$export$80979869bc40ff1f).Underline | (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout);
            var styleEqual = (this.style & lineReducer) === (stFont.style & lineReducer);
            equal = fontFamilyEqual && styleEqual;
        }
        return equal;
    };
    /**
     * `Initializes` font internals..
     * @private
     */ PdfStandardFont.prototype.initializeInternals = function() {
        var equalFont = null;
        // if (PdfDocument.EnableCache) {
        equalFont = (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).cache.search(this);
        // }
        var internals = null;
        // if (equalFont == null) {
        // Create font metrics.
        var metrics = (0, $8715da285fefaebb$export$7d9aa3116289ddad).getMetrics(this.pdfFontFamily, this.style, this.size);
        this.metrics = metrics;
        internals = this.createInternals();
        this.setInternals(internals);
    };
    /**
     * `Creates` font`s dictionary.
     * @private
     */ PdfStandardFont.prototype.createInternals = function() {
        var dictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        dictionary.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.font));
        dictionary.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.type1));
        dictionary.items.setValue(this.dictionaryProperties.baseFont, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.metrics.postScriptName));
        if (this.fontFamily !== (0, $32129651824bb502$export$be66ab191dea7a97).Symbol && this.fontFamily !== (0, $32129651824bb502$export$be66ab191dea7a97).ZapfDingbats) {
            var encoding = this.encodings[(0, $32129651824bb502$export$98fe6dd79a4f2c0c).WinAnsiEncoding];
            dictionary.items.setValue(this.dictionaryProperties.encoding, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(encoding));
        }
        return dictionary;
    };
    /**
     * Returns `width` of the char. This methods doesn`t takes into consideration font`s size.
     * @private
     */ PdfStandardFont.prototype.getCharWidthInternal = function(charCode, format) {
        var width = 0;
        var code = 0;
        code = charCode.charCodeAt(0);
        if (this.name === "0" || this.name === "1" || this.name === "2" || this.name === "3" || this.name === "4") code = code - PdfStandardFont.charOffset;
        code = code >= 0 && code !== 128 ? code : 0;
        var metrics = this.metrics;
        var widthTable = metrics.widthTable;
        width = widthTable.items(code);
        return width;
    };
    /**
     * `Converts` the specified text.
     * @private
     */ PdfStandardFont.convert = function(text) {
        return text;
    };
    //Constants
    /**
     * First character `position`.
     * @private
     */ PdfStandardFont.charOffset = 32;
    return PdfStandardFont;
}((0, $ec27d251b6edcb44$export$60d73556588f648b));


var $9492e318cdd65a97$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents a PDF document and can be used to create a new PDF document from the scratch.
 * ```typescript
 * // create a new PDF document
 * let document : PdfDocument = new PdfDocument();
 * // add a new page to the document
 * let page1 : PdfPage = document.pages.add();
 * // set the font
 * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
 * // create black brush
 * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
 * // draw the text
 * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
 * // save the document
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $9492e318cdd65a97$export$d46c104bc6d5cb7e = /** @class */ function(_super) {
    $9492e318cdd65a97$var$__extends(PdfDocument, _super);
    function PdfDocument(isMerging) {
        var _this = _super.call(this) || this;
        /**
         * Default `margin` value.
         * @default 40.0
         * @private
         */ _this.defaultMargin = 40.0;
        /**
         * Internal variable to store instance of `StreamWriter` classes..
         * @default null
         * @private
         */ _this.streamWriter = null;
        _this.document = _this;
        var isMerge = false;
        if (typeof isMerging === "undefined") {
            PdfDocument.cacheCollection = new (0, $07539e5c5ace4ab0$export$6aa948e0610f285b)();
            isMerge = false;
        } else isMerge = isMerging;
        var objects = new (0, $6f19eb0a6c25f093$export$2a7f345104069332)();
        _this.setMainObjectCollection(objects);
        var crossTable = new (0, $8866b473e717b660$export$8c4e0ee04681847e)();
        crossTable.isMerging = isMerge;
        crossTable.document = _this;
        _this.setCrossTable(crossTable);
        var catalog = new (0, $bfda723cbb1176de$export$44014050ffe2bb13)();
        _this.setCatalog(catalog);
        objects.add(catalog);
        catalog.position = -1;
        _this.sectionCollection = new (0, $2851d20f042c06f3$export$1295bf8a61de96dd)(_this);
        _this.documentPageCollection = new (0, $9400b0f694f1a1f2$export$98e5bfaac9374900)(_this);
        catalog.pages = _this.sectionCollection;
        return _this;
    }
    Object.defineProperty(PdfDocument, "defaultFont", {
        //Properties
        /**
         * Gets the `default font`. It is used for complex objects when font is not explicitly defined.
         * @private
         */ get: function() {
            if (this.defaultStandardFont == null) this.defaultStandardFont = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)((0, $32129651824bb502$export$be66ab191dea7a97).Helvetica, 8);
            return this.defaultStandardFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument.prototype, "sections", {
        /**
         * Gets the collection of the `sections` in the document.
         * @private
         */ get: function() {
            return this.sectionCollection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument.prototype, "pageSettings", {
        /**
         * Gets the document's page setting.
         * @public
         */ get: function() {
            if (this.settings == null) this.settings = new (0, $38437f6299029180$export$b29d0b05f007ad1b)(this.defaultMargin);
            return this.settings;
        },
        /**
         * Sets the document's page setting.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         *
         * // sets the right margin of the page
         * document.pageSettings.margins.right = 0;
         * // set the page size.
         * document.pageSettings.size = new SizeF(500, 500);
         * // change the page orientation to landscape
         * document.pageSettings.orientation = PdfPageOrientation.Landscape;
         * // apply 90 degree rotation on the page
         * document.pageSettings.rotate = PdfPageRotateAngle.RotateAngle90;
         *
         * // add a pages to the document
         * let page1 : PdfPage = document.pages.add();
         * // set font
         * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
         * // set brush
         * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
         * // set the specified Point
         * let point : PointF = new PointF(page1.getClientSize().width - 200, page1.getClientSize().height - 200);
         * // draw the text
         * page1.graphics.drawString('Hello World', font, blackBrush, point);
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ set: function(value) {
            this.settings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument.prototype, "pages", {
        /**
         * Represents the collection of pages in the PDF document.
         * ```typescript
         * // create a new PDF document
         * let document : PdfDocument = new PdfDocument();
         * //
         * // get the collection of pages in the document
         * let pageCollection : PdfDocumentPageCollection  = document.pages;
         * //
         * // add pages
         * let page1 : PdfPage = pageCollection.add();
         * // save the document
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.documentPageCollection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument, "cache", {
        /**
         * Gets collection of the `cached objects`.
         * @private
         */ get: function() {
            if (typeof PdfDocument.cacheCollection === "undefined" || PdfDocument.cacheCollection == null) return new (0, $07539e5c5ace4ab0$export$6aa948e0610f285b)();
            return PdfDocument.cacheCollection;
        },
        /**
         * Sets collection of the `cached objects`.
         * @private
         */ set: function(value) {
            this.cacheCollection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument, "enableCache", {
        /**
         * Gets the value of enable cache.
         * @private
         */ get: function() {
            return this.isCacheEnabled;
        },
        /**
         * Sets thie value of enable cache.
         * @private
         */ set: function(value) {
            this.isCacheEnabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument.prototype, "colorSpace", {
        /* tslint:disable */ /**
         * Gets or sets the `color space` of the document. This property can be used to create PDF document in RGB, Gray scale or CMYK color spaces.
         * @private
         */ get: function() {
            if (this.pdfColorSpace === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb || this.pdfColorSpace === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Cmyk || this.pdfColorSpace === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).GrayScale) return this.pdfColorSpace;
            else return (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        },
        set: function(value) {
            if (value === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb || value === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Cmyk || value === (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).GrayScale) this.pdfColorSpace = value;
            else this.pdfColorSpace = (0, $d174213b46afc09a$export$3c2d1c75bca6b8d3).Rgb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfDocument.prototype, "template", {
        /* tslint:enable */ /**
         * Gets or sets a `template` to all pages in the document.
         * @private
         */ get: function() {
            if (this.pageTemplate == null) this.pageTemplate = new (0, $37f475734d88d5c5$export$bbb3b48dbd10b480)();
            return this.pageTemplate;
        },
        set: function(value) {
            this.pageTemplate = value;
        },
        enumerable: true,
        configurable: true
    });
    PdfDocument.prototype.docSave = function(stream, arg2, arg3) {
        this.checkPagesPresence();
        if (stream === null) throw new Error("ArgumentNullException : stream");
        this.streamWriter = stream;
        var writer = new (0, $4962a411bd3103d0$export$94ae96e4b9812ca4)(stream);
        writer.document = this;
        if (typeof arg2 === "boolean" && typeof arg3 === "undefined") return this.crossTable.save(writer);
        else this.crossTable.save(writer, arg2);
    };
    /**
     * Checks the pages `presence`.
     * @private
     */ PdfDocument.prototype.checkPagesPresence = function() {
        if (this.pages.count === 0) this.pages.add();
    };
    /**
     * disposes the current instance of `PdfDocument` class.
     * ```typescript
     * // create a new PDF document
     * let document : PdfDocument = new PdfDocument();
     * // add a new page to the document
     * let page1 : PdfPage = document.pages.add();
     * // set the font
     * let font : PdfStandardFont = new PdfStandardFont(PdfFontFamily.Helvetica, 20);
     * // create black brush
     * let blackBrush : PdfSolidBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
     * // draw the text
     * page1.graphics.drawString('Hello World', font, blackBrush, new PointF(0, 0));
     * // save the document
     * document.save('output.pdf');
     * // destroy the document
     * document.destroy();
     * ```
     */ PdfDocument.prototype.destroy = function() {
        this.catalog = undefined;
        this.colorSpace = undefined;
        this.currentSavingObj = undefined;
        this.documentPageCollection = undefined;
        this.isStreamCopied = undefined;
        this.pageSettings = undefined;
        this.pageTemplate = undefined;
        this.pdfColorSpace = undefined;
        this.sectionCollection = undefined;
        PdfDocument.cache.destroy();
        this.crossTable.pdfObjects.destroy();
        PdfDocument.cache = undefined;
        this.streamWriter.destroy();
    };
    /**
     * `Font` used in complex objects to draw strings and text when it is not defined explicitly.
     * @default null
     * @private
     */ PdfDocument.defaultStandardFont = null;
    /**
     * Indicates whether enable cache or not
     * @default true
     * @private
     */ PdfDocument.isCacheEnabled = true;
    return PdfDocument;
}((0, $8bdeb2916eaf3ca0$export$423f0e8d02c69ea3));


/**
 * Represents a base class for all page graphics elements.
 */ var $14fa3dbb74e7336f$export$d59bd28985b2c69 = /** @class */ function() {
    // Constructors
    function PdfGraphicsElement() {
    //
    }
    /**
     * `Draws` the page number field.
     * @public
     */ PdfGraphicsElement.prototype.drawHelper = function(graphics, x, y) {
        var bNeedSave = x !== 0 || y !== 0;
        var gState = null;
        // Translate co-ordinates.
        if (bNeedSave) {
            // Save state.
            gState = graphics.save();
            graphics.translateTransform(x, y);
        }
        this.drawInternal(graphics);
        if (bNeedSave) // Restore state.
        graphics.restore(gState);
    };
    return PdfGraphicsElement;
}();



var $d05c5b0034846734$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents a fields which is calculated before the document saves.
 */ var $d05c5b0034846734$export$801607a04494f8a2 = /** @class */ function(_super) {
    $d05c5b0034846734$var$__extends(PdfAutomaticField, _super);
    // Constructors
    function PdfAutomaticField() {
        var _this = _super.call(this) || this;
        // Fields
        _this.internalBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
        _this.internalTemplateSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
        return _this;
    }
    Object.defineProperty(PdfAutomaticField.prototype, "bounds", {
        // Properties
        get: function() {
            return this.internalBounds;
        },
        set: function(value) {
            this.internalBounds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "size", {
        get: function() {
            return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.bounds.width, this.bounds.height);
        },
        set: function(value) {
            this.bounds.width = value.width;
            this.bounds.height = value.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "location", {
        get: function() {
            return new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(this.bounds.x, this.bounds.y);
        },
        set: function(value) {
            this.bounds.x = value.x;
            this.bounds.y = value.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "font", {
        get: function() {
            return this.internalFont;
        },
        set: function(value) {
            this.internalFont = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "brush", {
        get: function() {
            return this.internalBrush;
        },
        set: function(value) {
            this.internalBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "pen", {
        get: function() {
            return this.internalPen;
        },
        set: function(value) {
            this.internalPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAutomaticField.prototype, "stringFormat", {
        get: function() {
            return this.internalStringFormat;
        },
        set: function(value) {
            this.internalStringFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    PdfAutomaticField.prototype.performDrawHelper = function(graphics, location, scalingX, scalingY) {
        if (this.bounds.height === 0 || this.bounds.width === 0) {
            var text = this.getValue(graphics);
            this.internalTemplateSize = this.getFont().measureString(text, this.size, this.stringFormat);
        }
    };
    PdfAutomaticField.prototype.draw = function(arg1, arg2, arg3) {
        if (typeof arg2 === "undefined") {
            var location_1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
            this.draw(arg1, location_1);
        } else if (arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) this.draw(arg1, arg2.x, arg2.y);
        else {
            this.drawHelper(arg1, arg2, arg3);
            var info = new (0, $1ddf98521086c978$export$64e2124497f91cca)(this, new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(arg2, arg3));
            arg1.automaticFields.add(info);
        }
    };
    PdfAutomaticField.prototype.getSize = function() {
        if (this.bounds.height === 0 || this.bounds.width === 0) return this.internalTemplateSize;
        else return this.size;
    };
    PdfAutomaticField.prototype.drawInternal = function(graphics) {
    //
    };
    /* tslint:disable */ PdfAutomaticField.prototype.getBrush = function() {
        return typeof this.internalBrush === "undefined" || this.internalBrush == null ? new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0)) : this.internalBrush;
    };
    PdfAutomaticField.prototype.getFont = function() {
        return typeof this.internalFont === "undefined" || this.internalFont == null ? (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).defaultFont : this.internalFont;
    };
    /* tslint:enable */ PdfAutomaticField.prototype.getPageFromGraphics = function(graphics) {
        if (typeof graphics.page !== "undefined" && graphics.page !== null) {
            var page = graphics.page;
            return page;
        } else {
            var page = graphics.currentPage;
            return page;
        }
    };
    return PdfAutomaticField;
}((0, $14fa3dbb74e7336f$export$d59bd28985b2c69));



/**
 * Represent class to store information about `template and value pairs`.
 * @private
 */ var $266741a02586c222$export$c7b15b8ace1d9a7a = /** @class */ function() {
    function PdfTemplateValuePair(template, value) {
        // Fields
        /**
         * Internal variable to store template.
         * @default null
         * @private
         */ this.pdfTemplate = null;
        /**
         * Intenal variable to store value.
         * @private
         */ this.content = "";
        if (typeof template === "undefined") ;
        else {
            this.template = template;
            this.value = value;
        }
    }
    Object.defineProperty(PdfTemplateValuePair.prototype, "template", {
        // Properties
        /**
         * Gets or sets the template.
         * @private
         */ get: function() {
            return this.pdfTemplate;
        },
        set: function(value) {
            this.pdfTemplate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTemplateValuePair.prototype, "value", {
        /**
         * Gets or sets the value.
         * @private
         */ get: function() {
            return this.content;
        },
        set: function(value) {
            this.content = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfTemplateValuePair;
}();




var $779bc41d0b2d2595$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents automatic field which has the same value within the `PdfGraphics`.
 */ var $779bc41d0b2d2595$export$e4d54284f720f6d5 = /** @class */ function(_super) {
    $779bc41d0b2d2595$var$__extends(PdfMultipleValueField, _super);
    function PdfMultipleValueField() {
        var _this = _super.call(this) || this;
        //  Fields
        /**
         * Stores the instance of dictionary values of `graphics and template value pair`.
         * @private
         */ _this.list = new (0, $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb)();
        return _this;
    }
    // Implementation
    /* tslint:disable */ PdfMultipleValueField.prototype.performDraw = function(graphics, location, scalingX, scalingY) {
        _super.prototype.performDrawHelper.call(this, graphics, location, scalingX, scalingY);
        var value = this.getValue(graphics);
        var template = new (0, $094796745e9b29a1$export$cbb9d62db9e1cba0)(this.getSize());
        this.list.setValue(graphics, new (0, $266741a02586c222$export$c7b15b8ace1d9a7a)(template, value));
        var g = template.graphics;
        var size = this.getSize();
        template.graphics.drawString(value, this.getFont(), this.pen, this.getBrush(), 0, 0, size.width, size.height, this.stringFormat);
        var drawLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(location.x + this.location.x, location.y + this.location.y);
        graphics.drawPdfTemplate(template, drawLocation, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(template.width * scalingX, template.height * scalingY));
    };
    return PdfMultipleValueField;
}((0, $d05c5b0034846734$export$801607a04494f8a2));


var $b30674b120ef5a4a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents class which can concatenate multiple automatic fields into single string.
 */ var $b30674b120ef5a4a$export$b112c9b7092835e0 = /** @class */ function(_super) {
    $b30674b120ef5a4a$var$__extends(PdfCompositeField, _super);
    // Constructor
    /**
     * Initialize a new instance of `PdfCompositeField` class.
     * @param font Font of the field.
     * @param brush Color of the field.
     * @param text Content of the field.
     * @param list List of the automatic fields in specific order based on the text content.
     */ function PdfCompositeField(font, brush, text) {
        var list = [];
        for(var _i = 3; _i < arguments.length; _i++)list[_i - 3] = arguments[_i];
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Stores the array of automatic fields.
         * @private
         */ _this.internalAutomaticFields = null;
        /**
         * Stores the text value of the field.
         * @private
         */ _this.internalText = "";
        _this.font = font;
        _this.brush = brush;
        _this.text = text;
        _this.automaticFields = list;
        return _this;
    }
    Object.defineProperty(PdfCompositeField.prototype, "text", {
        // Properties
        /**
         * Gets and sets the content of the field.
         * @public
         */ get: function() {
            return this.internalText;
        },
        set: function(value) {
            this.internalText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfCompositeField.prototype, "automaticFields", {
        /**
         * Gets and sets the list of the field to drawn.
         * @public
         */ get: function() {
            return this.internalAutomaticFields;
        },
        set: function(value) {
            this.internalAutomaticFields = value;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * Return the actual value generated from the list of automatic fields.
     * @public
     */ PdfCompositeField.prototype.getValue = function(graphics) {
        var values = [];
        var text = this.text.toString();
        if (typeof this.automaticFields !== "undefined" && this.automaticFields != null && this.automaticFields.length > 0) for(var i = 0; i < this.automaticFields.length; i++){
            var automaticField = this.automaticFields[i];
            text = text.replace("{" + i + "}", automaticField.getValue(graphics));
        }
        return text;
    };
    return PdfCompositeField;
}((0, $779bc41d0b2d2595$export$e4d54284f720f6d5));



/**
 * public Enum for `PdfBorderOverlapStyle`.
 * @private
 */ var $238f209b947082e7$export$bd6016b867e69b14;
(function(PdfBorderOverlapStyle) {
    /**
     * Specifies the type of `Overlap`.
     * @private
     */ PdfBorderOverlapStyle[PdfBorderOverlapStyle["Overlap"] = 0] = "Overlap";
    /**
     * Specifies the type of `Inside`.
     * @private
     */ PdfBorderOverlapStyle[PdfBorderOverlapStyle["Inside"] = 1] = "Inside";
})($238f209b947082e7$export$bd6016b867e69b14 || ($238f209b947082e7$export$bd6016b867e69b14 = {}));


var $fa5fb82b29645b96$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Base class for the `grid style`,
 */ var $fa5fb82b29645b96$export$f59c15c3f36dde58 = /** @class */ function() {
    function PdfGridStyleBase() {}
    Object.defineProperty(PdfGridStyleBase.prototype, "backgroundBrush", {
        // Properties
        /**
         * Gets or sets the `background brush`.
         * @private
         */ get: function() {
            return this.gridBackgroundBrush;
        },
        set: function(value) {
            this.gridBackgroundBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyleBase.prototype, "textBrush", {
        /**
         * Gets or sets the `text brush`.
         * @private
         */ get: function() {
            return this.gridTextBrush;
        },
        set: function(value) {
            this.gridTextBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyleBase.prototype, "textPen", {
        /**
         * Gets or sets the `text pen`.
         * @private
         */ get: function() {
            return this.gridTextPen;
        },
        set: function(value) {
            this.gridTextPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyleBase.prototype, "font", {
        /**
         * Gets or sets the `font`.
         * @private
         */ get: function() {
            return this.gridFont;
        },
        set: function(value) {
            this.gridFont = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyleBase.prototype, "backgroundImage", {
        /**
         * Gets or sets the `background Image`.
         * @private
         */ get: function() {
            return this.gridBackgroundImage;
        },
        set: function(value) {
            this.gridBackgroundImage = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridStyleBase;
}();
/**
 * `PdfGridStyle` class provides customization of the appearance for the 'PdfGrid'.
 */ var $fa5fb82b29645b96$export$62337a055adb3f1 = /** @class */ function(_super) {
    $fa5fb82b29645b96$var$__extends(PdfGridStyle, _super);
    //constructor
    /**
     * Initialize a new instance for `PdfGridStyle` class.
     * @private
     */ function PdfGridStyle() {
        var _this = _super.call(this) || this;
        _this.gridBorderOverlapStyle = (0, $238f209b947082e7$export$bd6016b867e69b14).Overlap;
        _this.bAllowHorizontalOverflow = false;
        _this.gridHorizontalOverflowType = $fa5fb82b29645b96$export$b1ba1503b24fbf5f.LastPage;
        return _this;
    }
    Object.defineProperty(PdfGridStyle.prototype, "cellSpacing", {
        //Properties
        /**
         * Gets or sets the `cell spacing` of the 'PdfGrid'.
         * @private
         */ get: function() {
            if (typeof this.gridCellSpacing === "undefined") this.gridCellSpacing = 0;
            return this.gridCellSpacing;
        },
        set: function(value) {
            this.gridCellSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyle.prototype, "horizontalOverflowType", {
        /**
         * Gets or sets the type of the `horizontal overflow` of the 'PdfGrid'.
         * @private
         */ get: function() {
            return this.gridHorizontalOverflowType;
        },
        set: function(value) {
            this.gridHorizontalOverflowType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyle.prototype, "allowHorizontalOverflow", {
        /**
         * Gets or sets a value indicating whether to `allow horizontal overflow`.
         * @private
         */ get: function() {
            return this.bAllowHorizontalOverflow;
        },
        set: function(value) {
            this.bAllowHorizontalOverflow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyle.prototype, "cellPadding", {
        /**
         * Gets or sets the `cell padding`.
         * @private
         */ get: function() {
            if (typeof this.gridCellPadding === "undefined") this.gridCellPadding = new (0, $446c769ec2cda75b$export$98e68eadb1bc5ba0)();
            return this.gridCellPadding;
        },
        set: function(value) {
            if (typeof this.gridCellPadding === "undefined") {
                this.gridCellPadding = new (0, $446c769ec2cda75b$export$98e68eadb1bc5ba0)();
                this.gridCellPadding = value;
            } else this.gridCellPadding = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridStyle.prototype, "borderOverlapStyle", {
        /**
         * Gets or sets the `border overlap style` of the 'PdfGrid'.
         * @private
         */ get: function() {
            return this.gridBorderOverlapStyle;
        },
        set: function(value) {
            this.gridBorderOverlapStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridStyle;
}($fa5fb82b29645b96$export$f59c15c3f36dde58);
/**
 * `PdfGridCellStyle` class provides customization of the appearance for the 'PdfGridCell'.
 */ var $fa5fb82b29645b96$export$d8846553b004a98c = /** @class */ function(_super) {
    $fa5fb82b29645b96$var$__extends(PdfGridCellStyle, _super);
    /**
     * Initializes a new instance of the `PdfGridCellStyle` class.
     * @private
     */ function PdfGridCellStyle() {
        var _this = _super.call(this) || this;
        /**
         * @hidden
         * @private
         */ _this.gridCellBorders = (0, $446c769ec2cda75b$export$69818a9b64460535).default;
        return _this;
    }
    Object.defineProperty(PdfGridCellStyle.prototype, "stringFormat", {
        //Properties
        /**
         * Gets the `string format` of the 'PdfGridCell'.
         * @private
         */ get: function() {
            return this.format;
        },
        set: function(value) {
            this.format = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCellStyle.prototype, "borders", {
        /**
         * Gets or sets the `border` of the 'PdfGridCell'.
         * @private
         */ get: function() {
            return this.gridCellBorders;
        },
        set: function(value) {
            this.gridCellBorders = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCellStyle.prototype, "cellPadding", {
        /**
         * Gets or sets the `cell padding`.
         * @private
         */ get: function() {
            return this.gridCellPadding;
        },
        set: function(value) {
            if (this.gridCellPadding == null || typeof this.gridCellPadding === "undefined") this.gridCellPadding = new (0, $446c769ec2cda75b$export$98e68eadb1bc5ba0)();
            this.gridCellPadding = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridCellStyle;
}($fa5fb82b29645b96$export$f59c15c3f36dde58);
/**
 * `PdfGridRowStyle` class provides customization of the appearance for the `PdfGridRow`.
 */ var $fa5fb82b29645b96$export$f5afdcc4564f8d68 = /** @class */ function() {
    // Constructor
    /**
     * Initializes a new instance of the `PdfGridRowStyle` class.
     * @private
     */ function PdfGridRowStyle() {
    //
    }
    Object.defineProperty(PdfGridRowStyle.prototype, "backgroundBrush", {
        // Properties
        /**
         * Gets or sets the `background brush`.
         * @private
         */ get: function() {
            return this.gridRowBackgroundBrush;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowStyle.prototype.setBackgroundBrush = function(value) {
        this.gridRowBackgroundBrush = value;
        if (typeof this.parent !== "undefined") for(var i = 0; i < this.parent.cells.count; i++)this.parent.cells.getCell(i).style.backgroundBrush = value;
    };
    Object.defineProperty(PdfGridRowStyle.prototype, "textBrush", {
        /**
         * Gets or sets the `text brush`.
         * @private
         */ get: function() {
            return this.gridRowTextBrush;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowStyle.prototype.setTextBrush = function(value) {
        this.gridRowTextBrush = value;
        if (typeof this.parent !== "undefined") for(var i = 0; i < this.parent.cells.count; i++)this.parent.cells.getCell(i).style.textBrush = value;
    };
    Object.defineProperty(PdfGridRowStyle.prototype, "textPen", {
        /**
         * Gets or sets the `text pen`.
         * @private
         */ get: function() {
            return this.gridRowTextPen;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowStyle.prototype.setTextPen = function(value) {
        this.gridRowTextPen = value;
        if (typeof this.parent !== "undefined") for(var i = 0; i < this.parent.cells.count; i++)this.parent.cells.getCell(i).style.textPen = value;
    };
    Object.defineProperty(PdfGridRowStyle.prototype, "font", {
        /**
         * Gets or sets the `font`.
         * @private
         */ get: function() {
            return this.gridRowFont;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowStyle.prototype.setFont = function(value) {
        this.gridRowFont = value;
        if (typeof this.parent !== "undefined") for(var i = 0; i < this.parent.cells.count; i++)this.parent.cells.getCell(i).style.font = value;
    };
    Object.defineProperty(PdfGridRowStyle.prototype, "border", {
        /**
         * Gets or sets the `border` of the current row.
         * @private
         */ get: function() {
            if (typeof this.gridRowBorder === "undefined") this.setBorder(new (0, $446c769ec2cda75b$export$69818a9b64460535)());
            return this.gridRowBorder;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowStyle.prototype.setBorder = function(value) {
        this.gridRowBorder = value;
        if (typeof this.parent !== "undefined") for(var i = 0; i < this.parent.cells.count; i++)this.parent.cells.getCell(i).style.borders = value;
    };
    /**
     * sets the `parent row` of the current object.
     * @private
     */ PdfGridRowStyle.prototype.setParent = function(parent) {
        this.parent = parent;
    };
    Object.defineProperty(PdfGridRowStyle.prototype, "backgroundImage", {
        /**
         * Gets or sets the `backgroundImage` of the 'PdfGridCell'.
         * @private
         */ get: function() {
            return this.gridRowBackgroundImage;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * sets the `backgroundImage` of the 'PdfGridCell'.
     * @private
     */ PdfGridRowStyle.prototype.setBackgroundImage = function(value) {
        this.gridRowBackgroundImage = value;
    };
    return PdfGridRowStyle;
}();
var $fa5fb82b29645b96$export$b1ba1503b24fbf5f;
(function(PdfHorizontalOverflowType) {
    /**
     * Specifies the type of `NextPage`.
     * @private
     */ PdfHorizontalOverflowType[PdfHorizontalOverflowType["NextPage"] = 0] = "NextPage";
    /**
     * Specifies the type of `LastPage`.
     * @private
     */ PdfHorizontalOverflowType[PdfHorizontalOverflowType["LastPage"] = 1] = "LastPage";
})($fa5fb82b29645b96$export$b1ba1503b24fbf5f || ($fa5fb82b29645b96$export$b1ba1503b24fbf5f = {}));















/**
 * ElementLayouter.ts class for EJ2-PDF
 */ 
/**
 * Base class for `elements lay outing`.
 * @private
 */ var $67f37859b2b467ca$export$41d0043537bfe2f2 = /** @class */ function() {
    // Constructor
    /**
     * Initializes a new instance of the `ElementLayouter` class.
     * @private
     */ function ElementLayouter(element) {
        this.layoutElement = element;
    }
    Object.defineProperty(ElementLayouter.prototype, "elements", {
        // Properties
        /**
         * Gets the `element`.
         * @private
         */ get: function() {
            return this.layoutElement;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the `element`.
     * @private
     */ ElementLayouter.prototype.getElement = function() {
        return this.layoutElement;
    };
    // Implementation
    /**
     * `Layouts` the element.
     * @private
     */ ElementLayouter.prototype.layout = function(param) {
        return this.layoutInternal(param);
    };
    ElementLayouter.prototype.Layouter = function(param) {
        return this.layoutInternal(param);
    };
    /**
     * Returns the `next page`.
     * @private
     */ ElementLayouter.prototype.getNextPage = function(currentPage) {
        var section = currentPage.section;
        var nextPage = section.add();
        return nextPage;
    };
    ElementLayouter.prototype.getPaginateBounds = function(param) {
        if (param == null) throw new Error("ArgumentNullException : param");
        var result = param.format.usePaginateBounds ? param.format.paginateBounds : new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(param.bounds.x, 0, param.bounds.width, param.bounds.height);
        return result;
    };
    return ElementLayouter;
}();
var $67f37859b2b467ca$export$b25c3374095e50f6 = /** @class */ function() {
    function PdfLayoutFormat(baseFormat) {
        if (typeof baseFormat === "undefined") ;
        else {
            this.break = baseFormat.break;
            this.layout = baseFormat.layout;
            this.paginateBounds = baseFormat.paginateBounds;
            this.boundsSet = baseFormat.usePaginateBounds;
        }
    }
    Object.defineProperty(PdfLayoutFormat.prototype, "layout", {
        // Properties
        /**
         * Gets or sets `layout` type of the element.
         * @private
         */ get: function() {
            // if (typeof this.layoutType === 'undefined' || this.layoutType == null) {
            //      this.layoutType = PdfLayoutType.Paginate;
            // }
            return this.layoutType;
        },
        set: function(value) {
            this.layoutType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutFormat.prototype, "break", {
        /**
         * Gets or sets `break` type of the element.
         * @private
         */ get: function() {
            // if (typeof this.breakType === 'undefined' || this.boundsSet == null) {
            //      this.breakType = PdfLayoutBreakType.FitPage;
            // }
            return this.breakType;
        },
        set: function(value) {
            this.breakType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutFormat.prototype, "paginateBounds", {
        /**
         * Gets or sets the `bounds` on the next page.
         * @private
         */ get: function() {
            if (typeof this.layoutPaginateBounds === "undefined" && this.layoutPaginateBounds == null) this.layoutPaginateBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
            return this.layoutPaginateBounds;
        },
        set: function(value) {
            this.layoutPaginateBounds = value;
            this.boundsSet = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutFormat.prototype, "usePaginateBounds", {
        /**
         * Gets a value indicating whether [`use paginate bounds`].
         * @private
         */ get: function() {
            // if (typeof this.boundsSet === 'undefined' || this.boundsSet == null) {
            //      this.boundsSet = false;
            // }
            return this.boundsSet;
        },
        enumerable: true,
        configurable: true
    });
    return PdfLayoutFormat;
}();
var $67f37859b2b467ca$export$ab6ea71ea2ace1ae = /** @class */ function() {
    function PdfLayoutParams() {}
    Object.defineProperty(PdfLayoutParams.prototype, "page", {
        // Properties
        /**
         * Gets or sets the layout `page` for the element.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        set: function(value) {
            this.pdfPage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutParams.prototype, "bounds", {
        /**
         * Gets or sets layout `bounds` for the element.
         * @private
         */ get: function() {
            return new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(this.layoutBounds.x, this.layoutBounds.y, this.layoutBounds.width, this.layoutBounds.height);
        },
        set: function(value) {
            this.layoutBounds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutParams.prototype, "format", {
        /**
         * Gets or sets `layout settings` for the element.
         * @private
         */ get: function() {
            return this.layoutFormat;
        },
        set: function(value) {
            this.layoutFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfLayoutParams;
}();
var $67f37859b2b467ca$export$602ac6ae91f8f048 = /** @class */ function() {
    // Constructors
    /**
     * Initializes the new instance of `PdfLayoutResult` class.
     * @private
     */ function PdfLayoutResult(page, bounds) {
        this.pdfPage = page;
        this.layoutBounds = bounds;
    }
    Object.defineProperty(PdfLayoutResult.prototype, "page", {
        // Properties
        /**
         * Gets the last `page` where the element was drawn.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutResult.prototype, "bounds", {
        /**
         * Gets the `bounds` of the element on the last page where it was drawn.
         * @private
         */ get: function() {
            return this.layoutBounds;
        },
        enumerable: true,
        configurable: true
    });
    return PdfLayoutResult;
}();



/**
 * `PdfLayoutElement` class represents the base class for all elements that can be layout on the pages.
 * @private
 */ var $0b3d5296901e666e$export$1a83e429ff9500b6 = /** @class */ function() {
    function PdfLayoutElement() {}
    Object.defineProperty(PdfLayoutElement.prototype, "raiseBeginPageLayout", {
        // Property
        /**
         * Gets a value indicating whether the `start page layout event` should be raised.
         * @private
         */ get: function() {
            return typeof this.beginPageLayout !== "undefined";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfLayoutElement.prototype, "raiseEndPageLayout", {
        /**
         * Gets a value indicating whether the `ending page layout event` should be raised.
         * @private
         */ get: function() {
            return typeof this.endPageLayout !== "undefined";
        },
        enumerable: true,
        configurable: true
    });
    //Event Handlers
    PdfLayoutElement.prototype.onBeginPageLayout = function(args) {
        if (this.beginPageLayout) this.beginPageLayout(this, args);
    };
    PdfLayoutElement.prototype.onEndPageLayout = function(args) {
        if (this.endPageLayout) this.endPageLayout(this, args);
    };
    PdfLayoutElement.prototype.drawHelper = function(arg2, arg3, arg4, arg5) {
        if (arg3 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg3.width === "undefined" && typeof arg4 === "undefined") return this.drawHelper(arg2, arg3.x, arg3.y);
        else if (typeof arg3 === "number" && typeof arg4 === "number" && typeof arg5 === "undefined") return this.drawHelper(arg2, arg3, arg4, null);
        else if (arg3 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg3.width !== "undefined" && typeof arg4 === "undefined") return this.drawHelper(arg2, arg3, null);
        else if (arg3 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg3.width === "undefined" && arg4 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6)) return this.drawHelper(arg2, arg3.x, arg3.y, arg4);
        else if (typeof arg3 === "number" && typeof arg4 === "number" && (arg5 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6) || arg5 == null)) {
            var width = arg2.graphics.clientSize.width - arg3;
            var layoutRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(arg3, arg4, width, 0);
            return this.drawHelper(arg2, layoutRectangle, arg5);
        } else if (arg3 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg3.width !== "undefined" && typeof arg4 === "boolean") {
            this.bEmbedFonts = arg4;
            return this.drawHelper(arg2, arg3, null);
        } else {
            var param = new (0, $67f37859b2b467ca$export$ab6ea71ea2ace1ae)();
            var temparg3 = arg3;
            var temparg4 = arg4;
            param.page = arg2;
            param.bounds = temparg3;
            if (param != null) {
                var x = param.bounds.x;
                var y = param.bounds.y;
                if (param.bounds.x === 0) x = (0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2;
                if (param.bounds.y === 0) y = (0, $446c769ec2cda75b$export$69818a9b64460535).default.top.width / 2;
                var newBound = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, param.bounds.width, param.bounds.height);
                param.bounds = newBound;
            }
            param.format = temparg4 != null ? temparg4 : new (0, $67f37859b2b467ca$export$b25c3374095e50f6)();
            var result = this.layout(param);
            return result;
        }
    };
    return PdfLayoutElement;
}();













var $c3036a83e14e92e9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Class that `layouts the text`.
 * @private
 */ var $c3036a83e14e92e9$export$862c0a49411f26fc = /** @class */ function(_super) {
    $c3036a83e14e92e9$var$__extends(TextLayouter, _super);
    // Constructors
    /**
     * Initializes a new instance of the `TextLayouter` class.
     * @private
     */ function TextLayouter(element) {
        return _super.call(this, element) || this;
    }
    Object.defineProperty(TextLayouter.prototype, "element", {
        /**
         * Gets the layout `element`.
         * @private
         */ get: function() {
            return _super.prototype.getElement.call(this);
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Layouts` the element.
     * @private
     */ TextLayouter.prototype.layoutInternal = function(param) {
        /* tslint:disable */ this.format = this.element.stringFormat !== null && typeof this.element.stringFormat !== "undefined" ? this.element.stringFormat : null;
        var currentPage = param.page;
        var currentBounds = param.bounds;
        var text = this.element.value;
        var result = null;
        var pageResult = new $c3036a83e14e92e9$export$cc1d0f8b1e36212a();
        pageResult.page = currentPage;
        pageResult.remainder = text;
        for(;;){
            pageResult = this.layoutOnPage(text, currentPage, currentBounds, param);
            result = this.getLayoutResult(pageResult);
            break;
        }
        /* tslint:enable */ return result;
    };
    /**
     * Raises `PageLayout` event if needed.
     * @private
     */ TextLayouter.prototype.getLayoutResult = function(pageResult) {
        var result = new $c3036a83e14e92e9$export$b4eaf6931d70656b(pageResult.page, pageResult.bounds, pageResult.remainder, pageResult.lastLineBounds);
        return result;
    };
    /* tslint:disable */ /**
     * `Layouts` the text on the page.
     * @private
     */ TextLayouter.prototype.layoutOnPage = function(text, currentPage, currentBounds, param) {
        var result = new $c3036a83e14e92e9$export$cc1d0f8b1e36212a();
        result.remainder = text;
        result.page = currentPage;
        currentBounds = this.checkCorrectBounds(currentPage, currentBounds);
        var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
        var stringResult = layouter.layout(text, this.element.font, this.format, currentBounds, currentPage.getClientSize().height, false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
        var textFinished = stringResult.remainder == null;
        var doesntFit = param.format.break === (0, $5ffc34ffc68e39dd$export$f886812f74e09fd0).FitElement;
        var canDraw = !(doesntFit || stringResult.empty);
        // Draw the text.
        var graphics = currentPage.graphics;
        var brush = this.element.getBrush();
        if (this.element instanceof (0, $0b4b1f60d7f75a26$export$6c765b7085f136fc)) brush.color = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 255);
        graphics.drawStringLayoutResult(stringResult, this.element.font, this.element.pen, brush, currentBounds, this.format);
        var lineInfo = stringResult.lines[stringResult.lineCount - 1];
        result.lastLineBounds = graphics.getLineBounds(stringResult.lineCount - 1, stringResult, this.element.font, currentBounds, this.format);
        result.bounds = this.getTextPageBounds(currentPage, currentBounds, stringResult);
        result.remainder = stringResult.remainder;
        result.end = textFinished;
        return result;
    };
    /* tslint:enable */ /**
     * `Corrects current bounds` on the page.
     * @private
     */ TextLayouter.prototype.checkCorrectBounds = function(currentPage, currentBounds) {
        var pageSize = currentPage.graphics.clientSize;
        currentBounds.height = currentBounds.height > 0 ? currentBounds.height : pageSize.height - currentBounds.y;
        return currentBounds;
    };
    /**
     * Returns a `rectangle` where the text was printed on the page.
     * @private
     */ /* tslint:disable */ TextLayouter.prototype.getTextPageBounds = function(currentPage, currentBounds, stringResult) {
        var textSize = stringResult.actualSize;
        var x = currentBounds.x;
        var y = currentBounds.y;
        var width = currentBounds.width > 0 ? currentBounds.width : textSize.width;
        var height = textSize.height;
        var shiftedRect = currentPage.graphics.checkCorrectLayoutRectangle(textSize, currentBounds.x, currentBounds.y, this.format);
        // if (currentBounds.width <= 0) {
        x = shiftedRect.x;
        // }
        var verticalShift = currentPage.graphics.getTextVerticalAlignShift(textSize.height, currentBounds.height, this.format);
        y += verticalShift;
        var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, width, height);
        return bounds;
    };
    return TextLayouter;
}((0, $67f37859b2b467ca$export$41d0043537bfe2f2));
var $c3036a83e14e92e9$export$cc1d0f8b1e36212a = /** @class */ function() {
    function TextPageLayoutResult() {}
    return TextPageLayoutResult;
}();
var $c3036a83e14e92e9$export$b4eaf6931d70656b = /** @class */ function(_super) {
    $c3036a83e14e92e9$var$__extends(PdfTextLayoutResult, _super);
    // Constructors
    /**
     * Initializes the new instance of `PdfTextLayoutResult` class.
     * @private
     */ function PdfTextLayoutResult(page, bounds, remainder, lastLineBounds) {
        var _this = _super.call(this, page, bounds) || this;
        _this.remainderText = remainder;
        _this.lastLineTextBounds = lastLineBounds;
        return _this;
    }
    Object.defineProperty(PdfTextLayoutResult.prototype, "remainder", {
        // Properties
        /**
         * Gets a value that contains the `text` that was not printed.
         * @private
         */ get: function() {
            return this.remainderText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextLayoutResult.prototype, "lastLineBounds", {
        /**
         * Gets a value that indicates the `bounds` of the last line that was printed on the page.
         * @private
         */ get: function() {
            return this.lastLineTextBounds;
        },
        enumerable: true,
        configurable: true
    });
    return PdfTextLayoutResult;
}((0, $67f37859b2b467ca$export$602ac6ae91f8f048));








var $a084eff51a9fd62d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfTextElement` class represents the text area with the ability to span several pages
 * and inherited from the 'PdfLayoutElement' class.
 * @private
 */ var $a084eff51a9fd62d$export$f22180f21fa91b94 = /** @class */ function(_super) {
    $a084eff51a9fd62d$var$__extends(PdfTextElement, _super);
    function PdfTextElement(arg1, arg2, arg3, arg4, arg5) {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * `Text` data.
         * @private
         */ _this.content = "";
        /**
         * `Value` of text data.
         * @private
         */ _this.elementValue = "";
        /**
         * indicate whether the drawText with PointF overload is called or not.
         * @default false
         * @private
         */ _this.hasPointOverload = false;
        /**
         * indicate whether the PdfGridCell value is `PdfTextElement`
         * @default false
         * @private
         */ _this.isPdfTextElement = false;
        if (typeof arg1 === "undefined") ;
        else if (typeof arg1 === "string" && typeof arg2 === "undefined") {
            _this.content = arg1;
            _this.elementValue = arg1;
        } else if (typeof arg1 === "string" && arg2 instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b) && typeof arg3 === "undefined") {
            _this.content = arg1;
            _this.elementValue = arg1;
            _this.pdfFont = arg2;
        } else if (typeof arg1 === "string" && arg2 instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b) && arg3 instanceof (0, $54efcdfb173c5ebf$export$c07084e815da81a4) && typeof arg4 === "undefined") {
            _this.content = arg1;
            _this.elementValue = arg1;
            _this.pdfFont = arg2;
            _this.pdfPen = arg3;
        } else if (typeof arg1 === "string" && arg2 instanceof (0, $ec27d251b6edcb44$export$60d73556588f648b) && arg3 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5) && typeof arg4 === "undefined") {
            _this.content = arg1;
            _this.elementValue = arg1;
            _this.pdfFont = arg2;
            _this.pdfBrush = arg3;
        } else {
            _this.content = arg1;
            _this.elementValue = arg1;
            _this.pdfFont = arg2;
            _this.pdfPen = arg3;
            _this.pdfBrush = arg4;
            _this.format = arg5;
        }
        return _this;
    }
    Object.defineProperty(PdfTextElement.prototype, "text", {
        // Properties
        /**
         * Gets or sets a value indicating the `text` that should be printed.
         * ```typescript
         * // create a new PDF document.
         * let document : PdfDocument = new PdfDocument();
         * // add a page to the document.
         * let page1 : PdfPage = document.pages.add();
         * // create the font
         * let font : PdfFont = new PdfStandardFont(PdfFontFamily.Helvetica, 12);
         * // create the Text Web Link
         * let textLink : PdfTextWebLink = new PdfTextWebLink();
         * // set the hyperlink
         * textLink.url = 'http://www.google.com';
         * //
         * // set the link text
         * textLink.text = 'Google';
         * //
         * // set the font
         * textLink.font = font;
         * // draw the hyperlink in PDF page
         * textLink.draw(page1, new PointF(10, 40));
         * // save the document.
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.content;
        },
        set: function(value) {
            this.elementValue = value;
            this.content = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextElement.prototype, "value", {
        //get value
        /**
         * Gets or sets a `value` indicating the text that should be printed.
         * @private
         */ get: function() {
            return this.elementValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextElement.prototype, "pen", {
        //get pen
        /**
         * Gets or sets a `PdfPen` that determines the color, width, and style of the text
         * @private
         */ get: function() {
            return this.pdfPen;
        },
        //Set pen value
        set: function(value) {
            this.pdfPen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextElement.prototype, "brush", {
        //get brush
        /**
         * Gets or sets the `PdfBrush` that will be used to draw the text with color and texture.
         * @private
         */ get: function() {
            return this.pdfBrush;
        },
        //Set brush value
        set: function(value) {
            this.pdfBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextElement.prototype, "font", {
        //get font
        /**
         * Gets or sets a `PdfFont` that defines the text format.
         * ```typescript
         * // create a new PDF document.
         * let document : PdfDocument = new PdfDocument();
         * // add a page to the document.
         * let page1 : PdfPage = document.pages.add();
         * // create the font
         * let font : PdfFont = new PdfStandardFont(PdfFontFamily.Helvetica, 12);
         * // create the Text Web Link
         * let textLink : PdfTextWebLink = new PdfTextWebLink();
         * // set the hyperlink
         * textLink.url = 'http://www.google.com';
         * // set the link text
         * textLink.text = 'Google';
         * //
         * // set the font
         * textLink.font = font;
         * //
         * // draw the hyperlink in PDF page
         * textLink.draw(page1, new PointF(10, 40));
         * // save the document.
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.pdfFont;
        },
        set: function(value) {
            this.pdfFont = value;
            if (this.pdfFont instanceof (0, $3d7be084b745fac4$export$2e90fbfccef6edcf) && this.content != null) this.elementValue = (0, $3d7be084b745fac4$export$2e90fbfccef6edcf).convert(this.content);
            else this.elementValue = this.content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfTextElement.prototype, "stringFormat", {
        /**
         * Gets or sets the `PdfStringFormat` that will be used to set the string format
         * @private
         */ get: function() {
            return this.format;
        },
        set: function(value) {
            this.format = value;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * Gets a `brush` for drawing.
     * @private
     */ PdfTextElement.prototype.getBrush = function() {
        return this.pdfBrush == null || typeof this.pdfBrush === "undefined" ? new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0)) : this.pdfBrush;
    };
    // /**
    //  * `Draws` an element on the Graphics.
    //  * @private
    //  */
    // public drawInternal(graphics : PdfGraphics) : void {
    //     graphics.drawString(this.elementValue, this.pdfFont, this.pdfPen, this.getBrush(), 0, 0, this.stringFormat);
    // }
    /**
     * `Layouts` the element.
     * @private
     */ PdfTextElement.prototype.layout = function(param) {
        var layouter = new (0, $c3036a83e14e92e9$export$862c0a49411f26fc)(this);
        var result = layouter.layout(param);
        return result;
    };
    PdfTextElement.prototype.drawText = function(arg2, arg3, arg4, arg5) {
        if (arg3 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg3.width === "undefined" && typeof arg4 === "undefined") {
            this.hasPointOverload = true;
            return this.drawText(arg2, arg3.x, arg3.y);
        } else if (typeof arg3 === "number" && typeof arg4 === "number" && typeof arg5 === "undefined") {
            this.hasPointOverload = true;
            return this.drawText(arg2, arg3, arg4, null);
        } else if (arg3 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg3.width !== "undefined" && typeof arg4 === "undefined") return this.drawText(arg2, arg3, null);
        else if (arg3 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg3.width === "undefined" && arg4 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6)) {
            this.hasPointOverload = true;
            return this.drawText(arg2, arg3.x, arg3.y, arg4);
        } else if (typeof arg3 === "number" && typeof arg4 === "number" && (arg5 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6) || arg5 == null)) {
            this.hasPointOverload = true;
            var width = arg2.graphics.clientSize.width - arg3;
            var layoutRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(arg3, arg4, width, 0);
            return this.drawText(arg2, layoutRectangle, arg5);
        } else if (arg3 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg3.width !== "undefined" && typeof arg4 === "boolean") return this.drawText(arg2, arg3, null);
        else {
            var layout = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
            if (this.hasPointOverload) {
                var stringLayoutResult = layout.layout(this.value, this.font, this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg2.graphics.clientSize.width - arg3.x, 0), true, arg2.graphics.clientSize);
                var layoutResult = void 0;
                var param = new (0, $67f37859b2b467ca$export$ab6ea71ea2ace1ae)();
                var temparg3 = arg3;
                var temparg4 = arg4;
                param.page = arg2;
                var previousPage = arg2;
                param.bounds = temparg3;
                param.format = temparg4 != null ? temparg4 : new (0, $67f37859b2b467ca$export$b25c3374095e50f6)();
                if (stringLayoutResult.lines.length > 1) {
                    this.text = stringLayoutResult.layoutLines[0].text;
                    if (param.bounds.y <= param.page.graphics.clientSize.height) {
                        var previousPosition = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(param.bounds.x, param.bounds.y);
                        layoutResult = this.layout(param);
                        var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, layoutResult.bounds.y + stringLayoutResult.lineHeight, arg2.graphics.clientSize.width, stringLayoutResult.lineHeight);
                        var isPaginate = false;
                        for(var i = 1; i < stringLayoutResult.lines.length; i++){
                            param.page = layoutResult.page;
                            param.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y), new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(bounds.width, bounds.height));
                            this.text = stringLayoutResult.layoutLines[i].text;
                            if (bounds.y + stringLayoutResult.lineHeight > layoutResult.page.graphics.clientSize.height) {
                                isPaginate = true;
                                param.page = param.page.graphics.getNextPage();
                                if (previousPosition.y > layoutResult.page.graphics.clientSize.height - layoutResult.bounds.height) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, layoutResult.bounds.height, layoutResult.page.graphics.clientSize.width, stringLayoutResult.lineHeight);
                                else bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, layoutResult.page.graphics.clientSize.width, stringLayoutResult.lineHeight);
                                param.bounds = bounds;
                            }
                            layoutResult = this.layout(param);
                            if (i !== stringLayoutResult.lines.length - 1) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, layoutResult.bounds.y + stringLayoutResult.lineHeight, layoutResult.page.graphics.clientSize.width, stringLayoutResult.lineHeight);
                            else {
                                var lineWidth = this.font.measureString(this.text, this.format).width;
                                layoutResult = this.calculateResultBounds(layoutResult, lineWidth, layoutResult.page.graphics.clientSize.width, 0);
                            }
                        }
                    }
                    return layoutResult;
                } else {
                    var lineSize = this.font.measureString(this.text, this.format);
                    if (param.bounds.y <= param.page.graphics.clientSize.height) {
                        layoutResult = this.layout(param);
                        layoutResult = this.calculateResultBounds(layoutResult, lineSize.width, layoutResult.page.graphics.clientSize.width, 0);
                    }
                    return layoutResult;
                }
            } else {
                var layoutResult = layout.layout(this.value, this.font, this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg3.width, 0), false, arg2.graphics.clientSize);
                var result = void 0;
                var param = new (0, $67f37859b2b467ca$export$ab6ea71ea2ace1ae)();
                var temparg3 = arg3;
                var temparg4 = arg4;
                param.page = arg2;
                param.bounds = temparg3;
                param.format = temparg4 != null ? temparg4 : new (0, $67f37859b2b467ca$export$b25c3374095e50f6)();
                if (layoutResult.lines.length > 1) {
                    this.text = layoutResult.layoutLines[0].text;
                    if (param.bounds.y <= param.page.graphics.clientSize.height) {
                        var previousPosition = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(param.bounds.x, param.bounds.y);
                        result = this.layout(param);
                        var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(temparg3.x, result.bounds.y + layoutResult.lineHeight, temparg3.width, layoutResult.lineHeight);
                        var isPaginate = false;
                        for(var i = 1; i < layoutResult.lines.length; i++){
                            param.page = result.page;
                            param.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(bounds.x, bounds.y, bounds.width, bounds.height);
                            this.text = layoutResult.layoutLines[i].text;
                            if (bounds.y + layoutResult.lineHeight > result.page.graphics.clientSize.height) {
                                isPaginate = true;
                                param.page = param.page.graphics.getNextPage();
                                if (previousPosition.y > result.page.graphics.clientSize.height - result.bounds.height) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(temparg3.x, layoutResult.lineHeight, temparg3.width, layoutResult.lineHeight);
                                else bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(temparg3.x, 0, temparg3.width, layoutResult.lineHeight);
                                param.bounds = bounds;
                            }
                            result = this.layout(param);
                            if (i !== layoutResult.lines.length - 1) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(temparg3.x, result.bounds.y + layoutResult.lineHeight, temparg3.width, layoutResult.lineHeight);
                            else {
                                var lineWidth = this.font.measureString(this.text, this.format).width;
                                result = this.calculateResultBounds(result, lineWidth, temparg3.width, temparg3.x);
                            }
                        }
                    }
                    return result;
                } else {
                    var lineSize = this.font.measureString(this.text, this.format);
                    if (param.bounds.y <= param.page.graphics.clientSize.height) {
                        result = this.layout(param);
                        result = this.calculateResultBounds(result, lineSize.width, temparg3.width, temparg3.x);
                    }
                    return result;
                }
            }
        }
    };
    PdfTextElement.prototype.calculateResultBounds = function(result, lineWidth, maximumWidth, startPosition) {
        var shift = 0;
        if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center) {
            result.bounds.x = startPosition + (maximumWidth - lineWidth) / 2;
            result.bounds.width = lineWidth;
        } else if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right) {
            result.bounds.x = startPosition + (maximumWidth - lineWidth);
            result.bounds.width = lineWidth;
        } else if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify) {
            result.bounds.x = startPosition;
            result.bounds.width = maximumWidth;
        } else {
            result.bounds.width = startPosition;
            result.bounds.width = lineWidth;
        }
        return result;
    };
    return PdfTextElement;
}((0, $0b3d5296901e666e$export$1a83e429ff9500b6));
















/**
 * `PdfAnnotation` class represents the base class for annotation objects.
 * @private
 */ var $0a47f10b7bba39d2$export$57507f60419a32eb = /** @class */ function() {
    function PdfAnnotation(arg1) {
        // Fields
        /**
         * Specifies the Internal variable to store fields of `PdfDictionaryProperties`.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        /**
         * `Color` of the annotation
         * @private
         */ this.pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(255, 255, 255);
        /**
         * `Bounds` of the annotation.
         * @private
         */ this.rectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
        /**
         * Parent `page` of the annotation.
         * @private
         */ this.pdfPage = null;
        /**
         * `Brush of the text` of the annotation.
         * @default new PdfSolidBrush(new PdfColor(0, 0, 0))
         * @private
         */ this.textBrush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        /**
         * `Font of the text` of the annotation.
         * @default new PdfStandardFont(PdfFontFamily.TimesRoman, 10)
         * @private
         */ this.textFont = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)((0, $32129651824bb502$export$be66ab191dea7a97).TimesRoman, 10);
        /**
         * `StringFormat of the text` of the annotation.
         * @default new PdfStringFormat(PdfTextAlignment.Left)
         * @private
         */ this.format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)((0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left);
        /**
         * `Text` of the annotation.
         * @private
         */ this.content = "";
        /**
         * Internal variable to store `dictionary`.
         * @private
         */ this.pdfDictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
        /**
         * To specifying the `Inner color` with which to fill the annotation
         * @private
         */ this.internalColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)();
        /**
         * `opacity or darkness` of the annotation.
         * @private
         * @default 1.0
         */ this.darkness = 1.0;
        if (typeof arg1 === "undefined") this.initialize();
        else {
            this.initialize();
            this.bounds = arg1;
        }
    }
    Object.defineProperty(PdfAnnotation.prototype, "color", {
        // Properties
        /**
         * `Color` of the annotation
         * @private
         */ get: function() {
            return this.pdfColor;
        },
        set: function(value) {
            this.pdfColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "innerColor", {
        /**
         * To specifying the `Inner color` with which to fill the annotation
         * @private
         */ get: function() {
            return this.internalColor;
        },
        set: function(value) {
            this.internalColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "bounds", {
        /**
         * `bounds` of the annotation.
         * @private
         */ get: function() {
            return this.rectangle;
        },
        set: function(value) {
            this.rectangle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "page", {
        /**
         * Parent `page` of the annotation.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "font", {
        /**
         * To specifying the `Font of the text` in the annotation.
         * @private
         */ get: function() {
            return this.textFont;
        },
        set: function(value) {
            this.textFont = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "stringFormat", {
        /**
         * To specifying the `StringFormat of the text` in the annotation.
         * @private
         */ get: function() {
            return this.format;
        },
        set: function(value) {
            this.format = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "brush", {
        /**
         * To specifying the `Brush of the text` in the annotation.
         * @private
         */ get: function() {
            return this.textBrush;
        },
        set: function(value) {
            this.textBrush = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "text", {
        /**
         * `Text` of the annotation.
         * @private
         */ get: function() {
            return this.content;
        },
        set: function(value) {
            this.content = value;
            this.dictionary.items.setValue(this.dictionaryProperties.contents, new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)(this.content));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAnnotation.prototype, "dictionary", {
        /**
         * Internal variable to store `dictionary`.
         * @hidden
         */ get: function() {
            return this.pdfDictionary;
        },
        set: function(value) {
            this.pdfDictionary = value;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Initialize` the annotation event handler and specifies the type of the annotation.
     * @private
     */ PdfAnnotation.prototype.initialize = function() {
        this.pdfDictionary.annotationBeginSave = new (0, $467b51a52206950c$export$6073dc40a48caacd)(this);
        this.pdfDictionary.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.annot));
    };
    /**
     * Sets related `page` of the annotation.
     * @private
     */ PdfAnnotation.prototype.setPage = function(page) {
        this.pdfPage = page;
        this.pdfDictionary.items.setValue(this.dictionaryProperties.p, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.pdfPage));
    };
    /**
     * Handles the `BeginSave` event of the Dictionary.
     * @private
     */ PdfAnnotation.prototype.beginSave = function() {
        this.save();
    };
    /**
     * `Saves` an annotation.
     * @private
     */ /* tslint:disable */ PdfAnnotation.prototype.save = function() {
        var nativeRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
        var section = this.pdfPage.section;
        var initialHeight = nativeRectangle.height;
        var tempLoacation = section.pointToNativePdf(this.page, new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(nativeRectangle.x, nativeRectangle.y));
        nativeRectangle.x = tempLoacation.x;
        nativeRectangle.width = tempLoacation.x + nativeRectangle.width;
        nativeRectangle.y = tempLoacation.y - this.page.document.pageSettings.margins.top;
        nativeRectangle.height = nativeRectangle.y - initialHeight;
        this.pdfDictionary.items.setValue(this.dictionaryProperties.rect, (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab).fromRectangle(nativeRectangle));
        this.dictionary.items.setValue(this.dictionaryProperties.ca, new (0, $f982301cdcaba043$export$8883fe148ef336b4)(this.darkness));
    };
    Object.defineProperty(PdfAnnotation.prototype, "element", {
        /* tslint:enable */ // IPdfWrapper Members
        /**
         * Gets the `element`.
         * @private
         */ get: function() {
            return this.pdfDictionary;
        },
        enumerable: true,
        configurable: true
    });
    return PdfAnnotation;
}();



var $79115b6aca19a2c8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfLinkAnnotation` class represents the ink annotation class.
 * @private
 */ var $79115b6aca19a2c8$export$babc7fe0f5d44396 = /** @class */ function(_super) {
    $79115b6aca19a2c8$var$__extends(PdfLinkAnnotation, _super);
    function PdfLinkAnnotation(rectangle) {
        return _super.call(this, rectangle) || this;
    }
    // Implementation
    /**
     * `Initializes` annotation object.
     * @private
     */ PdfLinkAnnotation.prototype.initialize = function() {
        _super.prototype.initialize.call(this);
        this.dictionary.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.link));
    };
    return PdfLinkAnnotation;
}((0, $0a47f10b7bba39d2$export$57507f60419a32eb));


var $d764f9edae20bb06$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents base class for `link annotations` with associated action.
 * @private
 */ var $d764f9edae20bb06$export$10113f750eb5005b = /** @class */ function(_super) {
    $d764f9edae20bb06$var$__extends(PdfActionLinkAnnotation, _super);
    // Constructors
    /**
     * Specifies the constructor for `ActionLinkAnnotation`.
     * @private
     */ function PdfActionLinkAnnotation(rectangle) {
        var _this = _super.call(this, rectangle) || this;
        // Fields
        /**
         * Internal variable to store annotation's `action`.
         * @default null
         * @private
         */ _this.pdfAction = null;
        return _this;
    }
    //Public method
    /**
     * get and set the `action`.
     * @hidden
     */ PdfActionLinkAnnotation.prototype.getSetAction = function(value) {
        if (typeof value === "undefined") return this.pdfAction;
        else this.pdfAction = value;
    };
    return PdfActionLinkAnnotation;
}((0, $79115b6aca19a2c8$export$babc7fe0f5d44396));







/**
 * `PdfAction` class represents base class for all action types.
 * @private
 */ var $3bf3a66df17fb626$export$41d049420f22f074 = /** @class */ function() {
    // Constructors
    /**
     * Initialize instance for `Action` class.
     * @private
     */ function PdfAction() {
        /**
         * Specifies the Next `action` to perform.
         * @private
         */ this.action = null;
        /**
         * Specifies the Internal variable to store `dictionary properties`.
         * @private
         */ this.dictionaryProperties = new (0, $06a5c2a1ab6ca508$export$1b5caccf55a43567)();
        // super(); -> Object()
        this.initialize();
    }
    Object.defineProperty(PdfAction.prototype, "next", {
        // Properties
        /**
         * Gets and Sets the `Next` action to perform.
         * @private
         */ get: function() {
            return this.action;
        },
        set: function(value) {
            // if (this.action !== value) {
            this.action = value;
            this.dictionary.items.setValue(this.dictionaryProperties.next, new (0, $8f73ad8fb76d816c$export$9f625259dd339115)(this.action));
        // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfAction.prototype, "dictionary", {
        /**
         * Gets and Sets the instance of PdfDictionary class for `Dictionary`.
         * @private
         */ get: function() {
            if (typeof this.pdfDictionary === "undefined") this.pdfDictionary = new (0, $467b51a52206950c$export$f103d8ead0680780)();
            return this.pdfDictionary;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Initialize` the action type.
     * @private
     */ PdfAction.prototype.initialize = function() {
        this.dictionary.items.setValue(this.dictionaryProperties.type, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.action));
    };
    Object.defineProperty(PdfAction.prototype, "element", {
        // IPdfWrapper Members
        /**
         * Gets the `Element` as IPdfPrimitive class.
         * @private
         */ get: function() {
            return this.dictionary;
        },
        enumerable: true,
        configurable: true
    });
    return PdfAction;
}();




var $6433f839bc95f5ba$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfUriAction` class for initialize the uri related internals.
 * @private
 */ var $6433f839bc95f5ba$export$44f82255c83ec6bd = /** @class */ function(_super) {
    $6433f839bc95f5ba$var$__extends(PdfUriAction, _super);
    function PdfUriAction(uri) {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Specifies the `uri` string.
         * @default ''.
         * @private
         */ _this.uniformResourceIdentifier = "";
        return _this;
    }
    Object.defineProperty(PdfUriAction.prototype, "uri", {
        // Properties
        /**
         * Gets and Sets the value of `Uri`.
         * @private
         */ get: function() {
            return this.uniformResourceIdentifier;
        },
        set: function(value) {
            this.uniformResourceIdentifier = value;
            this.dictionary.items.setValue(this.dictionaryProperties.uri, new (0, $e48c8fcac1e340e6$export$46679d7eb18d0b83)(this.uniformResourceIdentifier));
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Initialize` the internals.
     * @private
     */ PdfUriAction.prototype.initialize = function() {
        _super.prototype.initialize.call(this);
        this.dictionary.items.setValue(this.dictionaryProperties.s, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.uri));
    };
    return PdfUriAction;
}((0, $3bf3a66df17fb626$export$41d049420f22f074));


var $f1859dccba7ed03f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfUriAnnotation` class represents the Uri annotation.
 * @private
 */ var $f1859dccba7ed03f$export$958bc7a7cac0aff5 = /** @class */ function(_super) {
    $f1859dccba7ed03f$var$__extends(PdfUriAnnotation, _super);
    function PdfUriAnnotation(rectangle, uri) {
        var _this = _super.call(this, rectangle) || this;
        if (typeof uri !== "undefined") _this.uri = uri;
        return _this;
    }
    Object.defineProperty(PdfUriAnnotation.prototype, "uriAction", {
        /**
         * Get `action` of the annotation.
         * @private
         */ get: function() {
            if (typeof this.pdfUriAction === "undefined") this.pdfUriAction = new (0, $6433f839bc95f5ba$export$44f82255c83ec6bd)();
            return this.pdfUriAction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfUriAnnotation.prototype, "uri", {
        // Properties
        /**
         * Gets or sets the `Uri` address.
         * @private
         */ get: function() {
            return this.uriAction.uri;
        },
        set: function(value) {
            if (this.uriAction.uri !== value) this.uriAction.uri = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfUriAnnotation.prototype, "action", {
        /**
         * Gets or sets the `action`.
         * @private
         */ get: function() {
            return this.getSetAction();
        },
        set: function(value) {
            this.getSetAction(value);
            this.uriAction.next = value;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * `Initializes` annotation object.
     * @private
     */ PdfUriAnnotation.prototype.initialize = function() {
        _super.prototype.initialize.call(this);
        this.dictionary.items.setValue(this.dictionaryProperties.subtype, new (0, $93a92e6ea67161be$export$b440601b3bfe4454)(this.dictionaryProperties.link));
        var tempPrimitive = this.uriAction.element;
        this.dictionary.items.setValue(this.dictionaryProperties.a, this.uriAction.element);
    };
    return PdfUriAnnotation;
}((0, $d764f9edae20bb06$export$10113f750eb5005b));







var $0b4b1f60d7f75a26$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * `PdfTextWebLink` class represents the class for text web link annotation.
 * ```typescript
 * // create a new PDF document.
 * let document : PdfDocument = new PdfDocument();
 * // add a page to the document.
 * let page1 : PdfPage = document.pages.add();
 * // create the font
 * let font : PdfFont = new PdfStandardFont(PdfFontFamily.Helvetica, 12);
 * //
 * // create the Text Web Link
 * let textLink : PdfTextWebLink = new PdfTextWebLink();
 * // set the hyperlink
 * textLink.url = 'http://www.google.com';
 * // set the link text
 * textLink.text = 'Google';
 * // set the font
 * textLink.font = font;
 * // draw the hyperlink in PDF page
 * textLink.draw(page1, new PointF(10, 40));
 * //
 * // save the document.
 * document.save('output.pdf');
 * // destroy the document
 * document.destroy();
 * ```
 */ var $0b4b1f60d7f75a26$export$6c765b7085f136fc = /** @class */ function(_super) {
    $0b4b1f60d7f75a26$var$__extends(PdfTextWebLink, _super);
    // Constructors
    /**
     * Initializes a new instance of the `PdfTextWebLink` class.
     * @private
     */ function PdfTextWebLink() {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Internal variable to store `Url`.
         * @default ''
         * @private
         */ _this.uniformResourceLocator = "";
        /**
         * Internal variable to store `Uri Annotation` object.
         * @default null
         * @private
         */ _this.uriAnnotation = null;
        /**
         * Checks whether the drawTextWebLink method with `PointF` overload is called or not.
         * If it set as true, then the start position of each lines excluding firest line is changed as (0, Y).
         * @private
         * @hidden
         */ _this.recalculateBounds = false;
        _this.defaultBorder = new (0, $e627fb2b0c05e4bc$export$348890a1cfbbd0ab)();
        for(var i = 0; i < 3; i++)_this.defaultBorder.add(new (0, $f982301cdcaba043$export$8883fe148ef336b4)(0));
        return _this;
    }
    Object.defineProperty(PdfTextWebLink.prototype, "url", {
        // Properties
        /**
         * Gets or sets the `Uri address`.
         * ```typescript
         * // create a new PDF document.
         * let document : PdfDocument = new PdfDocument();
         * // add a page to the document.
         * let page1 : PdfPage = document.pages.add();
         * // create the font
         * let font : PdfFont = new PdfStandardFont(PdfFontFamily.Helvetica, 12);
         * // create the Text Web Link
         * let textLink : PdfTextWebLink = new PdfTextWebLink();
         * //
         * // set the hyperlink
         * textLink.url = 'http://www.google.com';
         * //
         * // set the link text
         * textLink.text = 'Google';
         * // set the font
         * textLink.font = font;
         * // draw the hyperlink in PDF page
         * textLink.draw(page1, new PointF(10, 40));
         * // save the document.
         * document.save('output.pdf');
         * // destroy the document
         * document.destroy();
         * ```
         */ get: function() {
            return this.uniformResourceLocator;
        },
        set: function(value) {
            if (value.length === 0) throw new Error("ArgumentException : Url - string can not be empty");
            this.uniformResourceLocator = value;
        },
        enumerable: true,
        configurable: true
    });
    PdfTextWebLink.prototype.draw = function(arg1, arg2) {
        if (arg1 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08)) {
            var layout = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
            var previousFontStyle = this.font.style;
            if (arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)) {
                this.recalculateBounds = true;
                this.font.style = (0, $32129651824bb502$export$80979869bc40ff1f).Underline;
                var layoutResult = layout.layout(this.value, this.font, this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg1.graphics.clientSize.width - arg2.x, 0), true, arg1.graphics.clientSize);
                if (layoutResult.lines.length === 1) {
                    var textSize = this.font.measureString(this.value);
                    var rect = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(arg2, textSize);
                    rect = this.calculateBounds(rect, textSize.width, arg1.graphics.clientSize.width, arg2.x);
                    this.uriAnnotation = new (0, $f1859dccba7ed03f$export$958bc7a7cac0aff5)(rect, this.url);
                    this.uriAnnotation.dictionary.items.setValue("Border", this.defaultBorder);
                    arg1.annotations.add(this.uriAnnotation);
                    var result = this.drawText(arg1, arg2);
                    this.font.style = previousFontStyle;
                    return result;
                } else {
                    var result = this.drawMultipleLineWithPoint(layoutResult, arg1, arg2);
                    this.font.style = previousFontStyle;
                    return result;
                }
            } else {
                var layoutResult = layout.layout(this.value, this.font, this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(arg2.width, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
                this.font.style = (0, $32129651824bb502$export$80979869bc40ff1f).Underline;
                if (layoutResult.lines.length === 1) {
                    var textSize = this.font.measureString(this.value);
                    var rect = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(arg2.x, arg2.y), textSize);
                    rect = this.calculateBounds(rect, textSize.width, arg2.width, arg2.x);
                    this.uriAnnotation = new (0, $f1859dccba7ed03f$export$958bc7a7cac0aff5)(rect, this.url);
                    this.uriAnnotation.dictionary.items.setValue("Border", this.defaultBorder);
                    arg1.annotations.add(this.uriAnnotation);
                    var returnValue = this.drawText(arg1, arg2);
                    this.font.style = previousFontStyle;
                    return returnValue;
                } else {
                    var returnValue = this.drawMultipleLineWithBounds(layoutResult, arg1, arg2);
                    this.font.style = previousFontStyle;
                    return returnValue;
                }
            }
        } else {
            var page = new (0, $b3834a1b559693d8$export$1686f89eb33d2b08)();
            page = arg1.page;
            return this.draw(page, arg2);
        }
    };
    /* tslint:enable */ //Private methods
    /**
     * Helper method `Draw` a Multiple Line Text Web Link on the Graphics with the specified location.
     * @private
     */ PdfTextWebLink.prototype.drawMultipleLineWithPoint = function(result, page, location) {
        var layoutResult;
        for(var i = 0; i < result.layoutLines.length; i++){
            var size = this.font.measureString(result.lines[i].text);
            var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location, size);
            if (i !== 0) bounds.x = 0;
            this.text = result.lines[i].text;
            if (bounds.y + size.height > page.graphics.clientSize.height) {
                if (i !== 0) {
                    page = page.graphics.getNextPage();
                    bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, page.graphics.clientSize.width, size.height);
                    location.y = 0;
                } else break;
            }
            bounds = this.calculateBounds(bounds, size.width, page.graphics.clientSize.width, bounds.x);
            this.uriAnnotation = new (0, $f1859dccba7ed03f$export$958bc7a7cac0aff5)(bounds, this.url);
            this.uriAnnotation.dictionary.items.setValue("Border", this.defaultBorder);
            page.annotations.add(this.uriAnnotation);
            if (i !== 0) layoutResult = this.drawText(page, new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, bounds.y));
            else layoutResult = this.drawText(page, bounds.x, bounds.y);
            location.y += size.height;
        }
        return layoutResult;
    };
    /**
     * Helper method `Draw` a Multiple Line Text Web Link on the Graphics with the specified bounds.
     * @private
     */ PdfTextWebLink.prototype.drawMultipleLineWithBounds = function(result, page, bounds) {
        var layoutResult;
        for(var i = 0; i < result.layoutLines.length; i++){
            var size = this.font.measureString(result.lines[i].text);
            var internalBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y), size);
            internalBounds = this.calculateBounds(internalBounds, size.width, bounds.width, bounds.x);
            this.text = result.lines[i].text;
            if (bounds.y + size.height > page.graphics.clientSize.height) {
                if (i !== 0) {
                    page = page.graphics.getNextPage();
                    bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(bounds.x, 0, bounds.width, size.height);
                    internalBounds.y = 0;
                } else break;
            }
            this.uriAnnotation = new (0, $f1859dccba7ed03f$export$958bc7a7cac0aff5)(internalBounds, this.url);
            this.uriAnnotation.dictionary.items.setValue("Border", this.defaultBorder);
            page.annotations.add(this.uriAnnotation);
            layoutResult = this.drawText(page, bounds);
            bounds.y += size.height;
        }
        return layoutResult;
    };
    /* tslint:disable */ PdfTextWebLink.prototype.calculateBounds = function(currentBounds, lineWidth, maximumWidth, startPosition) {
        var shift = 0;
        if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center) {
            currentBounds.x = startPosition + (maximumWidth - lineWidth) / 2;
            currentBounds.width = lineWidth;
        } else if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right) {
            currentBounds.x = startPosition + (maximumWidth - lineWidth);
            currentBounds.width = lineWidth;
        } else if (this.stringFormat != null && typeof this.stringFormat !== "undefined" && this.stringFormat.alignment === (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify) {
            currentBounds.x = startPosition;
            currentBounds.width = maximumWidth;
        } else {
            currentBounds.width = startPosition;
            currentBounds.width = lineWidth;
        }
        return currentBounds;
    };
    return PdfTextWebLink;
}((0, $a084eff51a9fd62d$export$f22180f21fa91b94));













var $7f829739b2688b0e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Class `lay outing the text`.
 *
 */ var $7f829739b2688b0e$export$11c2bcbc14388afe = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridLayouter, _super);
    //constructor
    /**
     * Initialize a new instance for `PdfGrid` class.
     * @private
     */ function PdfGridLayouter(baseFormat) {
        var _this = _super.call(this, baseFormat) || this;
        /**
         * @hidden
         * @private
         */ _this.gridInitialWidth = 0;
        /**
         * @hidden
         * @private
         */ _this.gridSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
        _this.parentCellIndex = 0;
        _this.tempWidth = 0;
        _this.childheight = 0;
        /**
         * Check weather it is `child grid or not`.
         * @private
         */ _this.isChildGrid = false;
        /**
         * @hidden
         * @private
         */ _this.hasRowSpanSpan = false;
        /**
         * @hidden
         * @private
         */ _this.isRearranged = false;
        /**
         * @hidden
         * @private
         */ _this.pageBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)();
        /**
         * @hidden
         * @private
         */ _this.listOfNavigatePages = [];
        /**
         * @hidden
         * @private
         */ _this.flag = true;
        /**
         * @hidden
         * @private
         */ _this.columnRanges = [];
        /**
         * @hidden
         * @private
         */ _this.currentLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
        /**
         * @hidden
         * @private
         */ _this.breakRow = true;
        _this.slr = null;
        _this.remainderText = null;
        _this.isPaginate = false;
        /**
         * Checks whether the x co-ordinate is need to set as client size or not.
         * @hidden
         * @private
         */ _this.isOverloadWithPosition = false;
        return _this;
    }
    Object.defineProperty(PdfGridLayouter.prototype, "Grid", {
        //Properties
        get: function() {
            return this.elements;
        },
        enumerable: true,
        configurable: true
    });
    // Constructors
    /**
     * Initializes a new instance of the `StringLayouter` class.
     * @private
     */ //Public methods
    /**
     * `Layouts` the text.
     * @private
     */ /**
     * `Layouts` the specified graphics.
     * @private
     */ /**
     * `Layouts` the specified graphics.
     * @private
     */ /*public layout(graphics : PdfLayoutParams) : PdfLayoutResult
    public layout(graphics : PdfGraphics, bounds : RectangleF) : void
    public layout(graphics : PdfGraphics, bounds : PointF) : void
    public layout(graphics ?: PdfGraphics | PdfLayoutParams, bounds ?: PointF | RectangleF) : void | PdfLayoutResult  {
        if (graphics instanceof PdfGraphics) {
        if (bounds instanceof PointF) {
            if (bounds.x === 0) {
                bounds.x = PdfBorders.default.right.width / 2;
            }
            if (bounds.y === 0) {
                bounds.y = PdfBorders.default.top.width / 2;
            }
            let boundaries : RectangleF = new RectangleF(bounds, new SizeF(0, 0));
            this.layout(graphics, boundaries);
        } else {
            let width : number = graphics.clientSize.width;
            let parameter : PdfLayoutParams = new PdfLayoutParams();
            parameter.bounds = bounds;
            this.currentGraphics = graphics;
            if (graphics.layer != null) {
                let index : number = 0;
                if (this.currentGraphics.page instanceof PdfPage) {
                    index = (this.currentGraphics.page as PdfPage).section.indexOf(this.currentGraphics.page as PdfPage);
                } else {
                    index = (this.currentGraphics.page as PdfPageBase).defaultLayerIndex;
                }
            } else {
                this.layoutInternal(parameter);
            }
        }
    }
    }*/ /**
     * Gets the `format`.
     * @private
     */ PdfGridLayouter.prototype.getFormat = function(format) {
        var f = format;
        return f;
    };
    /**
     * `Layouts` the element.
     * @private
     */ PdfGridLayouter.prototype.layoutInternal = function(param) {
        var format = this.getFormat(param.format);
        this.gridLayoutFormat = this.getFormat(param.format);
        this.currentPage = param.page;
        if (this.currentPage !== null) {
            var pageHeight = this.currentPage.getClientSize().height;
            var pageWidth = this.currentPage.getClientSize().width;
            this.currentPageBounds = this.currentPage.getClientSize();
        } else throw Error("Can not set page as null");
        this.currentGraphics = this.currentPage.graphics;
        //this.currentGraphics = (this.currentPage != null ) ? this.currentPage.graphics : this.currentGraphics;
        // if (this.currentGraphics.layer !== null) {
        //     let index : number = 0;
        //     if (this.currentGraphics.page instanceof PdfPage) {
        //         index = (this.currentGraphics.page as PdfPage).section.indexOf(this.currentGraphics.page as PdfPage);
        //     } else {
        //         index = (this.currentGraphics.page as PdfPageBase).defaultLayerIndex;
        //     }
        //     this.listOfNavigatePages.push(index);
        // }
        var index = 0;
        index = this.currentGraphics.page.section.indexOf(this.currentGraphics.page);
        this.listOfNavigatePages.push(index);
        if (format != null && format.break === (0, $5ffc34ffc68e39dd$export$f886812f74e09fd0).FitColumnsToPage) this.currentBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(param.bounds.x, param.bounds.y), new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.Grid.columns.width, this.currentGraphics.clientSize.height));
        else this.currentBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(param.bounds.x, param.bounds.y), this.currentGraphics.clientSize);
        //this.currentBounds = new RectangleF(new PointF(param.bounds.x, param.bounds.y), this.currentGraphics.clientSize);
        if (this.Grid.rows.count !== 0) this.currentBounds.width = param.bounds.width > 0 ? param.bounds.width : this.currentBounds.width - this.Grid.rows.getRow(0).cells.getCell(0).style.borders.left.width / 2;
        else if (this.Grid.headers.count !== 0) // this.currentBounds.width = (param.bounds.width > 0) ? param.bounds.width : (this.currentBounds.width -
        //                                 this.Grid.headers.getHeader(0).cells.getCell(0).style.borders.left.width / 2);
        this.currentBounds.width = param.bounds.width;
        else throw Error("Please add row or header into grid");
        this.startLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(param.bounds.x, param.bounds.y);
        // if (this.Grid.style.allowHorizontalOverflow && this.currentBounds.width > this.currentGraphics.clientSize.width) {
        //     this.currentBounds.width = this.currentGraphics.clientSize.width;
        //     this.currentBounds.width -= this.currentBounds.x;
        // }
        // if (this.Grid.isChildGrid) {
        //     this.childheight = param.bounds.height;
        // }
        // if (param.format !== null && param.format.usePaginateBounds) {
        //     if (param.format.paginateBounds.height > 0) {
        //         this.currentBounds.height = param.format.paginateBounds.height;
        //     }
        //} else 
        if (param.bounds.height > 0 && !this.Grid.isChildGrid) this.currentBounds.height = param.bounds.height;
        if (!this.Grid.isChildGrid) this.hType = this.Grid.style.horizontalOverflowType;
        if (!this.Grid.style.allowHorizontalOverflow) {
            this.columnRanges = [];
            if (typeof this.Grid.isChildGrid !== "undefined" && typeof this.Grid.isChildGrid) this.Grid.measureColumnsWidth(this.currentBounds);
            else this.Grid.measureColumnsWidth(new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(this.currentBounds.x, this.currentBounds.y, this.currentBounds.x + this.currentBounds.width, this.currentBounds.height));
            this.columnRanges.push([
                0,
                this.Grid.columns.count - 1
            ]);
        } else {
            this.Grid.measureColumnsWidth();
            this.determineColumnDrawRanges();
        }
        if (this.Grid.hasRowSpanSpan) {
            for(var i = 0; i < this.Grid.rows.count; i++)if (this.Grid.rows.getRow(i).height !== -1 && !this.Grid.rows.getRow(i).isRowHeightSet) this.Grid.rows.getRow(i).isRowHeightSet = true;
        }
        var result = this.layoutOnPage(param);
        return result;
    };
    // /* tslint:enable */
    /**
     * `Determines the column draw ranges`.
     * @private
     */ PdfGridLayouter.prototype.determineColumnDrawRanges = function() {
        var startColumn = 0;
        var endColumn = 0;
        var cellWidths = 0;
        var availableWidth = this.currentGraphics.clientSize.width - this.currentBounds.x;
        for(var i = 0; i < this.Grid.columns.count; i++){
            cellWidths += this.Grid.columns.getColumn(i).width;
            if (cellWidths >= availableWidth) {
                var subWidths = 0;
                for(var j = startColumn; j <= i; j++){
                    subWidths += this.Grid.columns.getColumn(j).width;
                    if (subWidths > availableWidth) break;
                    endColumn = j;
                }
                this.columnRanges.push([
                    startColumn,
                    endColumn
                ]);
                startColumn = endColumn + 1;
                endColumn = startColumn;
                cellWidths = endColumn <= i ? this.Grid.columns.getColumn(i).width : 0;
            }
        }
        // if (startColumn !== this.columns.Count) {
        this.columnRanges.push([
            startColumn,
            this.Grid.columns.count - 1
        ]);
    // }
    };
    /**
     * `Layouts the on page`.
     * @private
     */ PdfGridLayouter.prototype.layoutOnPage = function(param) {
        /* tslint:disable */ this.pageBounds.x = param.bounds.x;
        this.pageBounds.y = param.bounds.y;
        this.pageBounds.height = param.bounds.height;
        var format = this.getFormat(param.format);
        var endArgs = null;
        var result = null;
        var layoutedPages = new (0, $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb)();
        var startPage = param.page;
        var isParentCell = false;
        var cellBounds = [];
        for(var index = 0; index < this.columnRanges.length; index++){
            var range = this.columnRanges[index];
            this.cellStartIndex = range[0];
            this.cellEndIndex = range[1];
            var returnObject = this.raiseBeforePageLayout(this.currentPage, this.currentBounds, this.currentRowIndex);
            this.currentBounds = returnObject.currentBounds;
            this.currentRowIndex = returnObject.currentRowIndex;
            // if (returnObject.returnValue) {
            //     result = new PdfGridLayoutResult(this.currentPage, this.currentBounds);
            //     break;
            // }
            //Draw Headers.
            var drawHeader = void 0;
            for(var i_1 = 0; i_1 < this.Grid.headers.count; i_1++){
                var row = this.Grid.headers.getHeader(i_1);
                var headerHeight = this.currentBounds.y;
                this.isHeader = true;
                if (startPage != this.currentPage) {
                    for(var k = this.cellStartIndex; k <= this.cellEndIndex; k++)if (row.cells.getCell(k).isCellMergeContinue) {
                        row.cells.getCell(k).isCellMergeContinue = false;
                        row.cells.getCell(k).value = "";
                    }
                }
                // RowLayoutResult
                var headerResult = this.drawRow(row);
                if (headerHeight === this.currentBounds.y) {
                    drawHeader = true;
                    if (PdfGridLayouter.repeatRowIndex === -1) PdfGridLayouter.repeatRowIndex = i_1;
                } else drawHeader = false;
                if (!headerResult.isFinish && startPage !== null && format.layout !== (0, $5ffc34ffc68e39dd$export$3652975898b34cce).OnePage && drawHeader) {
                    this.startLocation.x = this.currentBounds.x;
                    this.currentPage = this.getNextPageformat(format);
                    this.startLocation.y = this.currentBounds.y;
                    if (typeof format.paginateBounds !== "undefined" && format.paginateBounds.x === 0 && format.paginateBounds.y === 0 && format.paginateBounds.width === 0 && format.paginateBounds.height === 0) this.currentBounds.x += this.startLocation.x;
                    this.drawRow(row);
                }
                this.isHeader = false;
            }
            var i = 0;
            var length_1 = this.Grid.rows.count;
            var repeatRow = void 0;
            var startingHeight = 0;
            var flag = true;
            //Here is to draw parent Grid and Cells
            cellBounds = [];
            //Draw row by row with the specified cell range.
            for(var j = 0; j < this.Grid.rows.count; j++){
                var row = this.Grid.rows.getRow(j);
                i++;
                this.currentRowIndex = i - 1;
                var originalHeight = this.currentBounds.y;
                startPage = this.currentPage;
                PdfGridLayouter.repeatRowIndex = -1;
                if (flag && row.grid.isChildGrid) {
                    startingHeight = originalHeight;
                    flag = false;
                }
                var rowResult = null;
                ///rowResult = this.drawRow(row);
                /*if(!row.isrowFinish) {
                    if(!row.grid.isgridSplit){
                        rowResult = this.drawRow(row);
                        row.isrowFinish = true;
                        row.isrowDraw = true;
                    } else {
                        if(!row.isrowDraw){
                            rowResult = this.drawRow(row);
                            row.isrowFinish = true;
                            row.isrowDraw = true;
                            row.grid.isgridSplit = false;
                        } else {
                            rowResult =  null;
                            break;
                        }
                    }
                }
                else {
                    //row.isrowFinish = false;
                    //rowResult = this.drawRow(row);
                    rowResult = null;
                    break;
                    
                }             */ if (this.Grid.splitChildRowIndex == -1) {
                    rowResult = this.drawRow(row);
                    row.isrowFinish = true;
                } else {
                    if (row.grid.ParentCell.row.grid.isGridSplit && this.Grid.splitChildRowIndex <= row.rowIndex) {
                        rowResult = this.drawRow(row);
                        row.isrowFinish = true;
                    } else if (row.isrowFinish) continue;
                    else break;
                }
                //rowResult = this.drawRow(row);
                cellBounds.push(rowResult.bounds.width);
                /*if (row.isRowBreaksNextPage)
                    {
                        let x : number  = 0;
                        for (let l : number = 0; l < row.cells.count; l++)
                        {
                            let isNestedRowBreak : boolean = false;
                            if (row.height == row.cells.getCell(l).height)
                            {
                                let n : number;
                                let grid : PdfGrid = row.cells.getCell(l).value as PdfGrid;
                                for (let m : number = grid.rows.count; 0 < m; m--)
                                {
                                    if ((grid.rows.getRow(m - 1).rowBreakHeight > 0))
                                    {
                                        isNestedRowBreak = true;
                                        break;
                                    }
                                    if (grid.rows.getRow(m - 1).isRowBreaksNextPage)
                                    {
                                        row.rowBreakHeightValue = grid.rows.getRow(m - 1).rowBreakHeightValue;
                                        break;
                                    }
                                    row.rowBreakHeightValue += grid.rows.getRow(m - 1).height;
                                }
                            }
                            if (isNestedRowBreak)
                                break;
                        }
                        for (let j : number = 0; j < row.cells.count; j++)
                        {

                            if (row.height > row.cells.getCell(j).height)
                            {
                                row.cells.getCell(j).value = " ";
                                let rect : RectangleF ;
                                let page : PdfPage = this.getNextPage(this.currentPage);
                                let section : PdfSection = this.currentPage.section;
                                let index : number = section.indexOf(page);
                                for (let k : number = 0; k < (section.count - 1) - index; k++)
                                {
                                    rect = new RectangleF(x, 0, row.grid.columns.getColumn(j).width, page.getClientSize().height);
                                    PdfGridLayouter.repeatRowIndex = -1;
                                    row.cells.getCell(j).draw(page.graphics, rect, false);
                                    page = this.getNextPage(page);
                                }
                                rect = new RectangleF(x, 0, row.grid.columns.getColumn(j).width, row.rowBreakHeightValue);

                                row.cells.getCell(j).draw(page.graphics, rect, false);
                            }
                            x += row.grid.columns.getColumn(j).width;
                        }
                    }*/ //if height remains same, it is understood that row is not drawn in the page
                if (originalHeight === this.currentBounds.y) {
                    repeatRow = true;
                    PdfGridLayouter.repeatRowIndex = this.Grid.rows.rowCollection.indexOf(row);
                } else {
                    repeatRow = false;
                    PdfGridLayouter.repeatRowIndex = -1;
                }
                while(!rowResult.isFinish && startPage != null){
                    var tempResult = this.getLayoutResult();
                    /*if (startPage != this.currentPage)
                        {
                            if (row.grid.isChildGrid && row.grid.ParentCell != null)
                            {
                                let bounds : RectangleF= new RectangleF(new PointF(format.paginateBounds.x,format.paginateBounds.y), new SizeF(param.bounds.width, tempResult.bounds.height));
                                bounds.x += param.bounds.x;
                                if (row.grid.ParentCell.row.grid.style.cellPadding != null)
                                {
                                    bounds.y += row.grid.ParentCell.row.grid.style.cellPadding.top;
                                    if (bounds.height > this.currentPageBounds.height)
                                    {
                                        bounds.height = this.currentPageBounds.height - bounds.y;
                                        bounds.height -= (row.grid.ParentCell.row.grid.style.cellPadding.bottom);
                                    }
                                }
                                // Draw border for cells in the nested grid cell's row.
                                for (let c : number = 0; c < row.cells.count; c++)
                                {
                                    let cell : PdfGridCell = row.cells.getCell(c);
                                    let cellWidth :  number= 0;
                                    if (cell.columnSpan > 1)
                                    {
                                        for (; c < cell.columnSpan; c++)
                                            cellWidth += row.grid.columns.getColumn(c).width;
                                    }
                                    else
                                        cellWidth = Math.max(cell.width, row.grid.columns.getColumn(c).width);
                                    cell.drawCellBorders(this.currentGraphics, new RectangleF(new PointF(bounds.x,bounds.y), new SizeF(cellWidth, bounds.height)));
                                    bounds.x += cellWidth;
                                    c += (cell.columnSpan - 1);
                                }
                            }
                        }
                        */ endArgs = this.raisePageLayouted(tempResult);
                    if (endArgs.cancel || repeatRow) break;
                    else if (this.Grid.allowRowBreakAcrossPages) {
                        //If there is no space in the current page, add new page and then draw the remaining row.
                        this.currentPage = this.getNextPageformat(format);
                        originalHeight = this.currentBounds.y;
                        var location_1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)((0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2, (0, $446c769ec2cda75b$export$69818a9b64460535).default.top.width / 2);
                        if (format.paginateBounds.x === 0 && format.paginateBounds.y === 0 && format.paginateBounds.width === 0 && format.paginateBounds.height === 0 && this.startLocation.x === location_1.x && this.startLocation.y === location_1.y) {
                            this.currentBounds.x += this.startLocation.x;
                            this.currentBounds.y += this.startLocation.y;
                        }
                        if (this.isPaginate) {
                            this.startLocation.y = this.currentBounds.y;
                            this.isPaginate = false;
                        }
                        if (this.Grid.isChildGrid && row.grid.ParentCell != null) {
                            if (this.Grid.ParentCell.row.grid.style.cellPadding != null) {
                                if (row.rowBreakHeight + this.Grid.ParentCell.row.grid.style.cellPadding.top < this.currentBounds.height) this.currentBounds.y = this.Grid.ParentCell.row.grid.style.cellPadding.top;
                            }
                        }
                        if (row.grid.ParentCell != null) {
                            row.grid.ParentCell.row.isRowBreaksNextPage = true;
                            row.grid.ParentCell.row.rowBreakHeightValue = row.rowBreakHeight + this.Grid.ParentCell.row.grid.style.cellPadding.top + this.Grid.ParentCell.row.grid.style.cellPadding.bottom;
                            for(var i_2 = row.rowIndex + 1; i_2 < row.grid.rows.count; i_2++)row.grid.ParentCell.row.rowBreakHeightValue += row.grid.rows.getRow(i_2).height;
                        //row.rowBreakHeight = row.grid.ParentCell.row.rowBreakHeightValue;
                        }
                        /*if (row.noOfPageCount > 1)
                        {
                            let temp : number = row.rowBreakHeightValue;
                            for (let j : number = 1; j < row.noOfPageCount; j++)
                            {
                                row.rowBreakHeightValue = 0;
                                row.height = ((row.noOfPageCount - 1) * this.currentPage.getClientSize().height);
                                this.drawRow(row);
                                this.currentPage = this.getNextPageformat(format);
                                startPage = this.currentPage;
                            }
                            row.rowBreakHeightValue = temp;
                            row.noOfPageCount = 1;
                            rowResult = this.drawRow(row);
                        } else {
                            rowResult = this.drawRow(row);
                        }
                        /*if(row.grid.isChildGrid){
                            row.isrowFinish = false;
                            row.isrowDraw = false;
                            row.grid.isgridSplit = true;
                            row.grid.ParentCell.row.grid.isgridSplit = true;
                            //rowResult.isFinish = false;
                            break;
                        }*/ if (row.grid.isChildGrid) {
                            //row.grid.isgridSplit = true;
                            row.isrowFinish = false;
                            //row.grid.ParentCell.row.grid.isgridSplit = true;
                            row.grid.splitChildRowIndex = row.rowIndex;
                            row.grid.ParentCell.row.grid.splitChildRowIndex = row.grid.ParentCell.row.rowIndex;
                            if (row.grid.ParentCell.row.grid.isGridSplit) {
                                row.grid.ParentCell.row.noOfPageCount += 1;
                                row.grid.ParentCell.row.grid.isGridSplit = false;
                            }
                            break;
                        }
                        if (row.noOfPageCount < 1) {
                            if (row.grid.splitChildRowIndex != -1) row.grid.isGridSplit = true;
                            if (row.style.border != null && (row.style.border.left != null && row.style.border.left.width !== 1 || row.style.border.top != null && row.style.border.top.width !== 1)) {
                                var x = row.style.border.left.width / 2;
                                var y = row.style.border.top.width / 2;
                                if (this.currentBounds.x === (0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2 && this.currentBounds.y === (0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2) {
                                    var newBound = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, this.currentBounds.width, this.currentBounds.height);
                                    this.currentBounds = newBound;
                                }
                            }
                            if (this.Grid.repeatHeader) for(var j_1 = 0; j_1 < this.Grid.headers.count; j_1++){
                                var headerRepeat = this.Grid.headers.getHeader(j_1);
                                this.drawRow(headerRepeat);
                            }
                            rowResult = this.drawRow(row);
                            if (row.noOfPageCount >= 1) {
                                var temp = row.rowBreakHeightValue;
                                for(var j_2 = 0; j_2 < row.noOfPageCount; j_2++){
                                    //this.currentPage.section.add();
                                    var tempResult1 = this.getLayoutResult();
                                    endArgs = this.raisePageLayouted(tempResult1);
                                    this.currentPage = this.getNextPageformat(format);
                                    originalHeight = this.currentBounds.y;
                                    //row.rowBreakHeightValue = 0;
                                    if (row.grid.splitChildRowIndex != -1) row.grid.isGridSplit = true;
                                    this.currentBounds.y = 0.5;
                                    if (this.Grid.repeatHeader) for(var i_3 = 0; i_3 < this.Grid.headers.count; i_3++){
                                        var header = this.Grid.headers.getHeader(i_3);
                                        this.drawRow(header);
                                    }
                                    //row.height = ((row.noOfPageCount - 1) * this.currentPage.getClientSize().height);
                                    this.drawRow(row);
                                }
                            // row.rowBreakHeight = temp;
                            // row.noOfPageCount = 1;
                            // rowResult = this.drawRow(row);
                            }
                            row.grid.splitChildRowIndex = -1;
                            row.grid.isGridSplit = false;
                            rowResult.isFinish = this.checkIsFisished(row);
                            //row.NestedGridLayoutResult.bounds.height = row.rowBreakHeightValue;
                            //this.currentBounds.y = rowResult.bounds.y;
                            for(var i_4 = 0; i_4 < row.cells.count; i_4++)if (row.cells.getCell(i_4).value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) row.cells.getCell(i_4).value.splitChildRowIndex = -1;
                        }
                    }
                // else if (!this.Grid.allowRowBreakAcrossPages && i < length)
                // {
                //     this.currentPage = this.getNextPageformat(format);
                //     break;
                // }
                // else if (i >= length)
                //     break;
                }
                if (!rowResult.isFinish && startPage !== null && format.layout !== (0, $5ffc34ffc68e39dd$export$3652975898b34cce).OnePage && repeatRow) {
                    // During pagination, cell position is maintained here.
                    this.startLocation.x = this.currentBounds.x;
                    var isAddNextPage = false;
                    this.currentPage = this.getNextPageformat(format);
                    /*if (!this.Grid.isSingleGrid)
                    {
                        for ( let j : number= 0; j < this.Grid.rows.count; j++)
                        {
                            let isWidthGreaterthanParent : boolean = false;
                            for (let k : number = 0; k < this.Grid.rows.getRow(j).cells.count; k++)
                            {
                                if (this.Grid.rows.getRow(j).cells.getCell(k).width > this.currentPageBounds.width)
                                    isWidthGreaterthanParent = true;
                            }
                            if (isWidthGreaterthanParent && this.Grid.rows.getRow(j).cells.getCell(this.rowBreakPageHeightCellIndex).pageCount > 0)
                            {
                                isAddNextPage = true;
                            }
                        }
                    }
                    if (!this.Grid.isRearranged && isAddNextPage)
                         {
                             let section : PdfSection = this.currentPage.section;
                             
                             //this.currentPage = section.add();
                         
                             this.currentGraphics = this.currentPage.graphics;
                             this.currentBounds = new RectangleF(new PointF(0,0), this.currentPage.getClientSize());
                          
                             let pageindex  : number = (this.currentGraphics.page as PdfPage).section.indexOf(this.currentGraphics.page as PdfPage);
                         }
                         else
                         {
                             this.currentPage = this.getNextPageformat(format);
                         }
                         if (format.paginateBounds.y == 0)
                             this.currentBounds.y = PdfBorders.default.top.width/2;
                         else
                         {
                             this.currentBounds.y = format == null ? 0 : format.paginateBounds.y;
                             
                         }*/ if (this.raiseBeforePageLayout(this.currentPage, this.currentBounds, this.currentRowIndex).returnValue) break;
                    if (param.format !== null && !param.format.usePaginateBounds && param.bounds !== null && param.bounds.height > 0 && !this.Grid.isChildGrid) this.currentBounds.height = param.bounds.height;
                    if (typeof param.format !== "undefined" && param.format != null && typeof param.format.usePaginateBounds !== "undefined" && !param.format.usePaginateBounds && !(param.format.paginateBounds.x === 0 && param.format.paginateBounds.y === 0 && param.format.paginateBounds.width === 0 && param.format.paginateBounds.height === 0) && param.format.paginateBounds.y === 0) this.currentBounds.y = (0, $446c769ec2cda75b$export$69818a9b64460535).default.top.width / 2;
                    else {
                        this.currentBounds.y = format == null ? 0 : format.paginateBounds.y;
                        if (format != null && (format.paginateBounds.x !== 0 || format.paginateBounds.y !== 0 || format.paginateBounds.height !== 0 || format.paginateBounds.width !== 0)) {
                            this.currentBounds.x = format.paginateBounds.x;
                            this.currentBounds.width = format.paginateBounds.width;
                            this.currentBounds.height = format.paginateBounds.height;
                        }
                    }
                    if (typeof param.format !== "undefined" && param.format !== null && typeof param.format.usePaginateBounds !== "undefined" && !param.format.usePaginateBounds && param.bounds !== null && param.bounds.y > 0 && !this.Grid.isChildGrid) this.currentBounds.y = param.bounds.y;
                    this.startLocation.y = this.currentBounds.y;
                    if (format.paginateBounds.x === format.paginateBounds.y && format.paginateBounds.y === format.paginateBounds.height && format.paginateBounds.height === format.paginateBounds.width && format.paginateBounds.width === 0) this.currentBounds.x += this.startLocation.x;
                    if (this.currentBounds.x === (0, $446c769ec2cda75b$export$69818a9b64460535).default.left.width / 2) this.currentBounds.y += this.startLocation.x;
                    if (this.Grid.repeatHeader) for(var i_5 = 0; i_5 < this.Grid.headers.count; i_5++){
                        var header = this.Grid.headers.getHeader(i_5);
                        this.drawRow(header);
                    }
                    this.drawRow(row);
                    if (this.currentPage !== null && !layoutedPages.containsKey(this.currentPage)) layoutedPages.add(this.currentPage, range);
                }
                if (row.NestedGridLayoutResult != null) {
                    // Position for next row in the grid.
                    this.currentPage = row.NestedGridLayoutResult.page;
                    this.currentGraphics = this.currentPage.graphics; //If not, next row will not be drawn in the layouted page.
                    this.startLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(row.NestedGridLayoutResult.bounds.x, row.NestedGridLayoutResult.bounds.y);
                    var recalHeight = this.ReCalculateHeight(row, row.NestedGridLayoutResult.bounds.height);
                    this.currentBounds.y = recalHeight;
                    //this.currentBounds.y = row.NestedGridLayoutResult.bounds.height;
                    if (startPage != this.currentPage) {
                        var section = this.currentPage.section;
                        var startIndex = section.indexOf(startPage) + 1;
                        var endIndex = section.indexOf(this.currentPage);
                        for(var page = startIndex; page < endIndex + 1; page++){
                            var pageGraphics = section.getPages()[page].graphics;
                            var location_2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(format.paginateBounds.x, format.paginateBounds.y);
                            var height = page == endIndex ? row.NestedGridLayoutResult.bounds.height - param.bounds.y : this.currentBounds.height - location_2.y;
                            if (height <= pageGraphics.clientSize.height) height += param.bounds.y;
                            // if (row.grid.isChildGrid && row.grid.ParentCell != null)
                            //     location.x += param.bounds.x;
                            location_2.y = format == null ? 0.5 : format.paginateBounds.y;
                            // Draw border for last paginated row containing nested grid.
                            for(var c = 0; c < row.cells.count; c++){
                                var cell = row.cells.getCell(c);
                                var cellWidth = 0;
                                var totalwidth = 0;
                                var childGridCell = void 0;
                                if (cell.value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                                    if (!childGridCell) childGridCell = cell;
                                    for(var i_6 = 0; i_6 < cell.value.columns.count; i_6++)totalwidth += cell.value.columns.getColumn(i_6).columnWidth;
                                } else totalwidth = cell.width;
                                if (cell.columnSpan > 1) for(; c < cell.columnSpan; c++)cellWidth += row.grid.columns.getColumn(c).width;
                                else cellWidth = Math.max(totalwidth, row.grid.columns.getColumn(c).width);
                                var bottomPadding = void 0;
                                if (childGridCell && childGridCell.style && childGridCell.style.cellPadding) bottomPadding = childGridCell.style.cellPadding.bottom;
                                else bottomPadding = this.Grid.style.cellPadding.bottom;
                                if (typeof bottomPadding === "number" && height + bottomPadding < pageGraphics.clientSize.height) {
                                    height += bottomPadding;
                                    this.currentBounds.y += bottomPadding;
                                }
                                cell.drawCellBorders(pageGraphics, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_2, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(cellWidth, height)));
                                var rowWidth = this.Grid.rows.getRow(this.Grid.rows.count - 1).width;
                                if (cellWidth !== rowWidth) cell.drawCellBorders(pageGraphics, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_2, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(rowWidth, height)));
                                location_2.x += cellWidth;
                                c += cell.columnSpan - 1;
                            }
                        }
                        // So, nested grid drawing is completed for the current row. Update page.
                        // Otherwise, the next nested grid of the parent will draw borders from start.
                        startPage = this.currentPage;
                    }
                }
            }
            var isPdfGrid = false;
            var maximumCellBoundsWidth = 0;
            if (cellBounds.length > 0) maximumCellBoundsWidth = cellBounds[0];
            var largeNavigatePage = [
                [
                    1,
                    2
                ]
            ];
            for(var c = 0; c < this.Grid.rows.count; c++)if (this.cellEndIndex != -1 && this.Grid.rows.getRow(c).cells.getCell(this.cellEndIndex).value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                var grid = this.Grid.rows.getRow(c).cells.getCell(this.cellEndIndex).value;
                this.rowLayoutBoundsWidth = grid.rowLayoutBoundsWidth;
                isPdfGrid = true;
            // if (largeNavigatePage[0][0] < grid.listOfNavigatePages.length)
            // {
            //     largeNavigatePage[0][0] = grid.listOfNavigatePages.length;
            //     largeNavigatePage[0][1] = cellBounds[c];
            // }
            // else if ((largeNavigatePage[0][0] == grid.listOfNavigatePages.length) && (largeNavigatePage[0][1] < cellBounds[c]))
            // {
            //     largeNavigatePage[0][1] = cellBounds[c];
            // }
            }
            if (!isPdfGrid && cellBounds.length > 0) {
                for(var c = 0; c < i - 1; c++)if (maximumCellBoundsWidth < cellBounds[c]) maximumCellBoundsWidth = cellBounds[c];
                this.rowLayoutBoundsWidth = maximumCellBoundsWidth;
            } else this.rowLayoutBoundsWidth = largeNavigatePage[0][1];
            if (this.columnRanges.indexOf(range) < this.columnRanges.length - 1 && startPage != null && format.layout != (0, $5ffc34ffc68e39dd$export$3652975898b34cce).OnePage) {
                isParentCell = this.Grid.isChildGrid;
                if (largeNavigatePage[0][0] != 0) {
                    var section = this.currentPage.section;
                    var pageIndex = section.indexOf(this.currentPage);
                    this.currentGraphics = this.currentPage.graphics;
                    this.currentBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0), this.currentPage.getClientSize());
                    var pageindex = this.currentGraphics.page.section.indexOf(this.currentGraphics.page);
                } else this.currentPage = this.getNextPageformat(format);
            // let locationGrid : PointF= new PointF(PdfBorders.default.right.width / 2, PdfBorders.default.top.width / 2);
            // if (format.paginateBounds == new RectangleF(0,0,0,0) && this.startLocation == locationGrid)
            // {
            //     this.currentBounds.x += this.startLocation.x;
            //     this.currentBounds.y += this.startLocation.y;
            // }
            }
            if (this.columnRanges.length - 1 !== index && this.columnRanges.length > 1 && format.layout !== (0, $5ffc34ffc68e39dd$export$3652975898b34cce).OnePage) {
                this.currentPage = this.getNextPageformat(format);
                if (format.paginateBounds.x === format.paginateBounds.y && format.paginateBounds.y === format.paginateBounds.height && format.paginateBounds.height === format.paginateBounds.width && format.paginateBounds.width === 0) {
                    this.currentBounds.x += this.startLocation.x;
                    this.currentBounds.y += this.startLocation.y;
                //this.currentBounds.height = this.pageBounds.height;
                }
            }
        }
        result = this.getLayoutResult();
        if (this.Grid.style.allowHorizontalOverflow && this.Grid.style.horizontalOverflowType == (0, $fa5fb82b29645b96$export$b1ba1503b24fbf5f).NextPage) this.reArrangePages(layoutedPages);
        this.raisePageLayouted(result);
        return result;
    };
    PdfGridLayouter.prototype.checkIsFisished = function(row) {
        var result = true;
        for(var i = 0; i < row.cells.count; i++)if (!row.cells.getCell(i).FinishedDrawingCell) result = false;
        return result;
    };
    /* tslint:enable */ /**
     * Gets the `next page`.
     * @private
     */ PdfGridLayouter.prototype.getNextPageformat = function(format) {
        var section = this.currentPage.section;
        var nextPage = null;
        var index = section.indexOf(this.currentPage);
        this.flag = false;
        if (index === section.count - 1) nextPage = section.add();
        else nextPage = section.getPages()[index + 1];
        this.currentGraphics = nextPage.graphics;
        var pageindex = this.currentGraphics.page.section.indexOf(this.currentGraphics.page);
        if (!(this.listOfNavigatePages.indexOf(pageindex) !== -1)) this.listOfNavigatePages.push(pageindex);
        this.currentBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0), nextPage.getClientSize());
        if (typeof format !== "undefined" && format != null && format.usePaginateBounds && typeof format.paginateBounds !== "undefined" && format.paginateBounds != null && format.paginateBounds.x !== format.paginateBounds.y && format.paginateBounds.y !== format.paginateBounds.height && format.paginateBounds.height !== format.paginateBounds.width && format.paginateBounds.width !== 0) {
            this.currentBounds.x = format.paginateBounds.x;
            this.currentBounds.y = format.paginateBounds.y;
            this.currentBounds.height = format.paginateBounds.height;
        }
        return nextPage;
    };
    PdfGridLayouter.prototype.CheckIfDefaultFormat = function(format) {
        var defaultFormat = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
        return format.alignment === defaultFormat.alignment && format.characterSpacing === defaultFormat.characterSpacing && format.clipPath === defaultFormat.clipPath && format.firstLineIndent === defaultFormat.firstLineIndent && format.horizontalScalingFactor === defaultFormat.horizontalScalingFactor && format.lineAlignment === defaultFormat.lineAlignment && format.lineLimit === defaultFormat.lineLimit && format.lineSpacing === defaultFormat.lineSpacing && format.measureTrailingSpaces === defaultFormat.measureTrailingSpaces && format.noClip === defaultFormat.noClip && format.paragraphIndent === defaultFormat.paragraphIndent && format.rightToLeft === defaultFormat.rightToLeft && format.subSuperScript === defaultFormat.subSuperScript && format.wordSpacing === defaultFormat.wordSpacing && format.wordWrap === defaultFormat.wordWrap;
    };
    /**
     * `Raises BeforeCellDraw event`.
     * @private
     */ PdfGridLayouter.prototype.RaiseBeforeCellDraw = function(graphics, rowIndex, cellIndex, bounds, value, style) {
        var args = null;
        if (this.Grid.raiseBeginCellDraw) {
            args = new $7f829739b2688b0e$export$ce3af96805733f2e(graphics, rowIndex, cellIndex, bounds, value, style);
            this.Grid.onBeginCellDraw(args);
            style = args.style;
        }
        return style;
    };
    /**
     * `Raises AfterCellDraw event`.
     * @private
     */ PdfGridLayouter.prototype.raiseAfterCellDraw = function(graphics, rowIndex, cellIndex, bounds, value, cellstyle) {
        var args = null;
        if (this.Grid.raiseEndCellDraw) {
            args = new $7f829739b2688b0e$export$73242a9ed834cba1(graphics, rowIndex, cellIndex, bounds, value, cellstyle);
            this.Grid.onEndCellDraw(args);
        }
    };
    PdfGridLayouter.prototype.reArrangePages = function(layoutedPages) {
        var document = this.currentPage.document;
        var pages = [];
        var keys = layoutedPages.keys();
        var values = layoutedPages.values();
        for(var i = 0; i < keys.length; i++){
            var page = keys[i];
            page.section = null;
            pages.push(page);
            document.pages.remove(page);
        }
        /* tslint:disable */ for(var i = 0; i < layoutedPages.size(); i++){
            var count = 0;
            for(var j = i, count_1 = layoutedPages.size() / this.columnRanges.length; j < layoutedPages.size(); j += count_1){
                var page = pages[j];
                if (typeof page !== "undefined" && document.pages.indexOf(page) === -1) document.pages.add(page);
            }
        }
    /* tslint:enable */ };
    /**
     * Gets the `layout result`.
     * @private
     */ PdfGridLayouter.prototype.getLayoutResult = function() {
        if (this.Grid.isChildGrid && this.Grid.allowRowBreakAcrossPages) for(var i = 0; i < this.Grid.rows.count; i++){
            var row = this.Grid.rows.getRow(i);
            if (row.rowBreakHeight > 0 && row.repeatFlag) this.startLocation.y = this.currentPage.origin.y;
        }
        var bounds;
        if (!this.isChanged) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(this.startLocation, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.currentBounds.width, this.currentBounds.y - this.startLocation.y));
        // else {
        //     bounds = new RectangleF(this.currentLocation, new SizeF(this.currentBounds.width, this.currentBounds.y -
        //                              this.currentLocation.y));
        // }
        /* tslint:enable */ return new $7f829739b2688b0e$export$b1e26fde1b28811f(this.currentPage, bounds);
    };
    /**
     * `Recalculate row height` for the split cell to be drawn.
     * @private
     */ PdfGridLayouter.prototype.ReCalculateHeight = function(row, height) {
        var newHeight = 0.0;
        for(var i = this.cellStartIndex; i <= this.cellEndIndex; i++)if (!(row.cells.getCell(i).remainingString === null || row.cells.getCell(i).remainingString === "" || typeof row.cells.getCell(i).remainingString === "undefined")) newHeight = Math.max(newHeight, row.cells.getCell(i).measureHeight());
        return Math.max(height, newHeight);
    };
    /**
     * `Raises BeforePageLayout event`.
     * @private
     */ PdfGridLayouter.prototype.raiseBeforePageLayout = function(currentPage, currentBounds, currentRow) {
        var cancel = false;
        if (this.Grid.raiseBeginPageLayout) {
            var args = new $7f829739b2688b0e$export$6abed87151438d5b(currentBounds, currentPage, currentRow);
            this.Grid.onBeginPageLayout(args);
            // if (currentBounds !== args.Bounds) {
            //     this.isChanged = true;
            //     this.currentLocation = new PointF(args.Bounds.x, args.Bounds.y);
            //     this.measureColumnsWidth(new RectangleF(new PointF(args.Bounds.x, args.Bounds.y) ,
            //                                                  new SizeF(args.Bounds.width + args.Bounds.x ,
            //                                                                 args.Bounds.height)));
            // }
            cancel = typeof args.cancel === "undefined" ? false : args.cancel;
            currentBounds = args.bounds;
            currentRow = args.startRowIndex;
        }
        return {
            returnValue: cancel,
            currentBounds: currentBounds,
            currentRowIndex: currentRow
        };
    };
    /**
     * `Raises PageLayout event` if needed.
     * @private
     */ PdfGridLayouter.prototype.raisePageLayouted = function(result) {
        var args = new $7f829739b2688b0e$export$fe75e3f858c3996b(result);
        if (this.Grid.raiseEndPageLayout) this.Grid.onEndPageLayout(args);
        return args;
    };
    PdfGridLayouter.prototype.drawRow = function(row, result, height) {
        if (typeof result === "undefined") {
            //.. Check if required space available.
            //.....If the row conains spans which  falls through more than one page, then draw the row to next page.                        
            var result_1 = new $7f829739b2688b0e$export$173c93f5d3f4834d();
            var rowHeightWithSpan = 0;
            var location_3 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0);
            var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
            var isHeader = false;
            if (row.rowSpanExists) {
                var maxSpan = 0;
                var currRowIndex = this.Grid.rows.rowCollection.indexOf(row);
                if (currRowIndex === -1) {
                    currRowIndex = this.Grid.headers.indexOf(row);
                    if (currRowIndex !== -1) isHeader = true;
                }
                for(var i = 0; i < row.cells.count; i++){
                    var cell = row.cells.getCell(i);
                    maxSpan = Math.max(maxSpan, cell.rowSpan);
                }
                for(var i = currRowIndex; i < currRowIndex + maxSpan; i++)rowHeightWithSpan += isHeader ? this.Grid.headers.getHeader(i).height : this.Grid.rows.getRow(i).height;
            // let rowMaxHeight : number = rowHeightWithSpan;
            // for (let i : number = 0; i < row.cells.count; i++ ) {
            //     rowMaxHeight = rowMaxHeight > row.cells.getCell(i).height ? rowMaxHeight : row.cells.getCell(i).height;
            // }
            // let flag : boolean = true;
            // let nextRow : PdfGridRow = this.Grid.headers.getHeader(this.Grid.headers.indexOf(row) + 1);
            // for (let i : number = 0; i < nextRow.cells.count; i++ ) {
            //     if (nextRow.cells.getCell(i).value !== '' && nextRow.cells.getCell(i).value !== undefined) {
            //         flag = false;
            //         break;
            //     }
            // }
            // if ((rowMaxHeight > rowHeightWithSpan) && flag) {
            //     row.height += (rowMaxHeight - rowHeightWithSpan);
            // }                
            }
            var calculatedHeight = row.rowBreakHeight > 0.0 ? row.rowBreakHeight : row.height;
            if (typeof this.Grid.isChildGrid !== "undefined" && this.Grid.isChildGrid && typeof this.Grid.ParentCell !== "undefined" && this.Grid.ParentCell != null) {
                //Split row only if row height exceeds page height and AllowRowBreakAcrossPages is true.
                // if (calculatedHeight + this.Grid.ParentCell.row.grid.style.cellPadding.bottom +
                //             this.Grid.ParentCell.row.grid.style.cellPadding.top > this.currentPageBounds.height) {
                //     if (this.Grid.allowRowBreakAcrossPages) {
                //         result.isFinish = true;
                //         if ( this.Grid.isChildGrid && row.rowBreakHeight > 0 ) {
                //             if (this.Grid.ParentCell.row.grid.style.cellPadding !== null) {
                //                 this.currentBounds.y += this.Grid.ParentCell.row.grid.style.cellPadding.top;
                //             }
                //             this.currentBounds.x = this.startLocation.x;
                //         }
                //         result.bounds = this.currentBounds ;
                //         this.drawRowWithBreak(result, row, calculatedHeight);
                //     } else {
                //         //If AllowRowBreakAcrossPages is not true, draw the row till it fits the page.                       
                //         if (this.Grid.ParentCell.row.grid.style.cellPadding != null) {
                //             this.currentBounds.y += this.Grid.ParentCell.row.grid.style.cellPadding.top;
                //             calculatedHeight = this.currentBounds.height - this.currentBounds.y -
                //                     this.Grid.ParentCell.row.grid.style.cellPadding.bottom;
                //         }
                //         result.isFinish = false;
                //         this.drawRow( row, result, calculatedHeight);
                //     }
                // } else
                if (this.currentBounds.y + this.Grid.ParentCell.row.grid.style.cellPadding.bottom + calculatedHeight > this.currentPageBounds.height || this.currentBounds.y + this.Grid.ParentCell.row.grid.style.cellPadding.bottom + calculatedHeight > this.currentBounds.height || this.currentBounds.y + this.Grid.ParentCell.row.grid.style.cellPadding.bottom + rowHeightWithSpan > this.currentPageBounds.height) {
                    //If a row is repeated and still cannot fit in page, proceed draw.
                    if (typeof this.Grid.ParentCell.row.grid.LayoutFormat !== "undefined" && this.Grid.ParentCell.row.grid.LayoutFormat.break === (0, $5ffc34ffc68e39dd$export$f886812f74e09fd0).FitPage) {
                        PdfGridLayouter.repeatRowIndex = this.Grid.rows.rowCollection.indexOf(row);
                        this.Grid.splitChildRowIndex = this.Grid.rows.rowCollection.indexOf(row);
                    }
                    if (PdfGridLayouter.repeatRowIndex > -1 && PdfGridLayouter.repeatRowIndex === row.rowIndex) {
                        if (this.Grid.allowRowBreakAcrossPages) {
                            result_1.isFinish = true;
                            // if (this.Grid.isChildGrid && row.rowBreakHeightValue > 0) {
                            //     // if (this.Grid.ParentCell.row.grid.style.cellPadding != null) {
                            //     //     this.currentBounds.y += this.Grid.ParentCell.row.grid.style.cellPadding.top;
                            //     // }
                            //     this.currentBounds.x = this.startLocation.x;
                            // }
                            result_1.bounds = this.currentBounds;
                            this.drawRowWithBreak(result_1, row, calculatedHeight);
                            row.repeatFlag = true;
                            row.repeatRowNumber = PdfGridLayouter.repeatRowIndex;
                        }
                    }
                // else {
                //     result.isFinish = false;
                // }
                } else {
                    result_1.isFinish = true;
                    if (row.grid.ParentCell.row.rowBreakHeightValue > 0) row.repeatFlag = true;
                    else {
                        row.repeatFlag = false;
                        calculatedHeight = row.height;
                    }
                    if (this.Grid.isChildGrid && row.rowBreakHeight > 0) {
                        if (this.Grid.ParentCell.row.grid.style.cellPadding != null) calculatedHeight += this.Grid.ParentCell.row.grid.style.cellPadding.bottom;
                    }
                    this.drawRow(row, result_1, calculatedHeight);
                }
            } else {
                //Split row only if row height exceeds page height and AllowRowBreakAcrossPages is true.
                if (calculatedHeight > this.currentPageBounds.height) {
                    if (this.Grid.allowRowBreakAcrossPages) {
                        result_1.isFinish = true;
                        //result.bounds = this.currentBounds;
                        this.drawRowWithBreak(result_1, row, calculatedHeight);
                        row.isrowFinish = true;
                        row.repeatFlag = true;
                        if (row.grid.splitChildRowIndex !== -1) result_1.isFinish = false;
                    }
                } else if (this.currentBounds.y + calculatedHeight > this.currentPageBounds.height || this.currentBounds.y + calculatedHeight > this.currentBounds.height + this.startLocation.y || this.currentBounds.y + rowHeightWithSpan > this.currentPageBounds.height) {
                    // If a row is repeated and still cannot fit in page, proceed draw.
                    var isFit = false;
                    if (this.Grid.allowRowBreakAcrossPages && !this.Grid.repeatHeader && !row.isRowHeightSet && !row.rowMergeComplete) {
                        if (this.Grid.LayoutFormat !== null && this.Grid.LayoutFormat.paginateBounds.height > 0) isFit = this.isFitToCell(this.currentBounds.height + this.startLocation.y - this.currentBounds.y, this.Grid, row);
                        else isFit = this.isFitToCell(this.currentPageBounds.height - this.currentBounds.y, this.Grid, row);
                        if (isFit) this.isPaginate = true;
                    } else if (this.Grid.allowRowBreakAcrossPages && this.Grid.LayoutFormat != null && this.Grid.LayoutFormat.layout == (0, $5ffc34ffc68e39dd$export$3652975898b34cce).Paginate && this.Grid.LayoutFormat.break != (0, $5ffc34ffc68e39dd$export$f886812f74e09fd0).FitElement && row.isRowHeightSet && this.currentBounds.y + height > this.currentPageBounds.height) {
                        isFit = this.isFitToCell(this.currentPageBounds.height - this.currentBounds.y, this.Grid, row);
                        if (!isFit) isFit = !(this.slr !== null && this.slr.actualSize.height == 0 && this.slr.remainder != null && this.slr.remainder.length > 0 && this.remainderText == this.slr.remainder);
                        if (isFit && this.slr != null && this.slr.lineCount > 1) //It may text cutoff issue
                        isFit = false;
                        this.remainderText = null;
                    }
                    if (PdfGridLayouter.repeatRowIndex > -1 && PdfGridLayouter.repeatRowIndex === row.rowIndex || isFit) {
                        if (this.Grid.allowRowBreakAcrossPages) {
                            result_1.isFinish = true;
                            this.drawRowWithBreak(result_1, row, calculatedHeight);
                            row.repeatFlag = true;
                            row.repeatRowNumber = PdfGridLayouter.repeatRowIndex;
                            if (row.grid.splitChildRowIndex !== -1) result_1.isFinish = false;
                        } else {
                            result_1.isFinish = false;
                            this.drawRow(row, result_1, calculatedHeight);
                        }
                    } else result_1.isFinish = false;
                } else {
                    result_1.isFinish = true;
                    this.drawRow(row, result_1, calculatedHeight);
                    row.repeatFlag = false;
                }
            }
            return result_1;
        } else {
            var skipcell = false;
            var location_4 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(this.currentBounds.x, this.currentBounds.y);
            // if (row.grid.isChildGrid && row.grid.allowRowBreakAcrossPages && this.startLocation.x !== this.currentBounds.x && row.width <
            //                 this.currentPage.getClientSize().width) {
            //     location.x = this.startLocation.x;
            // }
            result.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_4, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            height = this.ReCalculateHeight(row, height);
            for(var i = this.cellStartIndex; i <= this.cellEndIndex; i++){
                var cancelSpans = i > this.cellEndIndex + 1 && row.cells.getCell(i).columnSpan > 1;
                // let cancelSpans : boolean = false;
                if (!cancelSpans) for(var j = 1; j < row.cells.getCell(i).columnSpan; j++)row.cells.getCell(i + j).isCellMergeContinue = true;
                var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.Grid.columns.getColumn(i).width, height);
                // if (size.width > this.currentGraphics.clientSize.width) {
                //     size.width = this.currentGraphics.clientSize.width;
                // }
                // if (this.Grid.isChildGrid && this.Grid.style.allowHorizontalOverflow) {
                //     if (size.width >= this.currentGraphics.clientSize.width) {
                //         size.width -= 2 * this.currentBounds.x;
                //     }
                // }
                /* tslint:disable */ if (!this.CheckIfDefaultFormat(this.Grid.columns.getColumn(i).format) && this.CheckIfDefaultFormat(row.cells.getCell(i).stringFormat)) row.cells.getCell(i).stringFormat = this.Grid.columns.getColumn(i).format;
                var cellstyle = row.cells.getCell(i).style;
                var tempValue = typeof row.cells.getCell(i).value === "string" && row.cells.getCell(i).value !== null ? row.cells.getCell(i).value : "";
                row.cells.getCell(i).style = this.RaiseBeforeCellDraw(this.currentGraphics, this.currentRowIndex, i, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_4, size), tempValue, cellstyle);
                //row.cells.getCell(i).style = cellstyle;
                if (!skipcell) {
                    if (row.cells.getCell(i).value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                        var grid = row.cells.getCell(i).value;
                        grid.parentCellIndex = i;
                    }
                    var stringResult = row.cells.getCell(i).draw(this.currentGraphics, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_4, size), cancelSpans);
                    if (row.grid.style.allowHorizontalOverflow && (row.cells.getCell(i).columnSpan > this.cellEndIndex || i + row.cells.getCell(i).columnSpan > this.cellEndIndex + 1) && this.cellEndIndex < row.cells.count - 1) row.rowOverflowIndex = this.cellEndIndex;
                    if (row.grid.style.allowHorizontalOverflow && row.rowOverflowIndex > 0 && (row.cells.getCell(i).columnSpan > this.cellEndIndex || i + row.cells.getCell(i).columnSpan > this.cellEndIndex + 1) && row.cells.getCell(i).columnSpan - this.cellEndIndex + i - 1 > 0) {
                        row.cells.getCell(row.rowOverflowIndex + 1).value = stringResult !== null ? stringResult.remainder !== undefined ? stringResult.remainder : "" : "";
                        row.cells.getCell(row.rowOverflowIndex + 1).stringFormat = row.cells.getCell(i).stringFormat;
                        row.cells.getCell(row.rowOverflowIndex + 1).style = row.cells.getCell(i).style;
                        row.cells.getCell(row.rowOverflowIndex + 1).columnSpan = row.cells.getCell(i).columnSpan - this.cellEndIndex + i - 1;
                    }
                }
                /* tslint:enable */ tempValue = typeof row.cells.getCell(i).value === "string" && row.cells.getCell(i).value !== null ? row.cells.getCell(i).value : "";
                if (!cancelSpans) this.raiseAfterCellDraw(this.currentGraphics, this.currentRowIndex, i, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location_4, size), tempValue, row.cells.getCell(i).style);
                if (row.cells.getCell(i).value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                    var grid = row.cells.getCell(i).value;
                    if (this.Grid.columns.getColumn(i).width >= this.currentGraphics.clientSize.width) {
                        location_4.x = grid.rowLayoutBoundsWidth;
                        location_4.x += grid.style.cellSpacing;
                    } else location_4.x += this.Grid.columns.getColumn(i).width;
                } else location_4.x += this.Grid.columns.getColumn(i).width;
            }
            if (!row.rowMergeComplete || row.isRowHeightSet) this.currentBounds.y += height;
            result.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(result.bounds.x, result.bounds.y), new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(location_4.x, location_4.y));
        }
    };
    PdfGridLayouter.prototype.isFitToCell = function(currentHeight, grid, gridRow) {
        var isFit = false;
        var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
        for(var i = 0; i < gridRow.cells.count; i++){
            var cell = gridRow.cells.getCell(i);
            if (typeof cell.value !== "undefined" && cell.value !== null && typeof cell.value === "string") {
                var font = null;
                if (typeof cell.style.font !== "undefined" && cell.style.font != null) font = cell.style.font;
                else if (typeof cell.row.style.font !== "undefined" && cell.row.style.font != null) font = cell.row.style.font;
                else if (typeof cell.row.grid.style.font !== "undefined" && cell.row.grid.style.font != null) font = cell.row.grid.style.font;
                else font = (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).defaultFont;
                this.remainderText = cell.value;
                var width = cell.width;
                var column = grid.columns.getColumn(i);
                if (column.isCustomWidth && cell.width > column.width) width = column.width;
                this.slr = layouter.layout(cell.value, font, cell.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, currentHeight), false, this.currentPageBounds);
                var height = this.slr.actualSize.height;
                if (cell.value !== "" && height === 0) {
                    isFit = false;
                    break;
                }
                if (cell.style !== null && cell.style.borders !== null && cell.style.borders.top !== null && cell.style.borders.bottom !== null) height += (cell.style.borders.top.width + cell.style.borders.bottom.width) * 2;
                if (this.slr.lineCount > 1 && cell.stringFormat != null && cell.stringFormat.lineSpacing != 0) height += (this.slr.lineCount - 1) * cell.style.stringFormat.lineSpacing;
                if (cell.style.cellPadding === null) height += grid.style.cellPadding.top + grid.style.cellPadding.bottom;
                else height += grid.style.cellPadding.top + grid.style.cellPadding.bottom;
                height += grid.style.cellSpacing;
                if (currentHeight > height || typeof this.slr.remainder !== "undefined" && this.slr.remainder !== null) {
                    isFit = true;
                    break;
                }
            }
        }
        return isFit;
    };
    PdfGridLayouter.prototype.drawRowWithBreak = function(result, row, calculateHeight) {
        var location = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(this.currentBounds.x, this.currentBounds.y);
        if (row.grid.isChildGrid && row.grid.allowRowBreakAcrossPages && this.startLocation.x !== this.currentBounds.x) location.x = this.startLocation.x;
        result.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
        this.gridHeight = row.rowBreakHeight > 0 ? this.currentPageBounds.height : 0;
        // Calculate the remaining height.
        if (row.grid.style.cellPadding.top + this.currentBounds.y + row.grid.style.cellPadding.bottom < this.currentPageBounds.height) row.rowBreakHeight = this.currentBounds.y + calculateHeight - this.currentPageBounds.height;
        // else {
        //     row.rowBreakHeight = calculateHeight;
        //     result.isFinish = false;
        //     return;
        // }
        // No need to explicit break if the row height is equal to grid height.
        for(var i = 0; i < row.cells.count; i++){
            var cell = row.cells.getCell(i);
            var cellHeight = cell.measureHeight();
            if (cellHeight === calculateHeight && cell.value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) row.rowBreakHeight = 0;
        // else if (cellHeight === calculateHeight && (cell.value as PdfGrid) === null) {
        //     row.rowBreakHeight = this.currentBounds.y + calculateHeight - this.currentPageBounds.height;
        // }
        }
        for(var i = this.cellStartIndex; i <= this.cellEndIndex; i++){
            var gridColumnWidth = this.Grid.columns.getColumn(i).width;
            var cancelSpans = row.cells.getCell(i).columnSpan + i > this.cellEndIndex + 1 && row.cells.getCell(i).columnSpan > 1;
            if (!cancelSpans) for(var k = 1; k < row.cells.getCell(i).columnSpan; k++){
                row.cells.getCell(i + k).isCellMergeContinue = true;
                gridColumnWidth += this.Grid.columns.getColumn(i + k).width;
            }
            var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(gridColumnWidth, this.gridHeight > 0.0 ? this.gridHeight : this.currentPageBounds.height);
            // if (size.width === 0) {
            //     size = new SizeF(row.cells.getCell(i).width, size.height);
            // }
            // if (!this.CheckIfDefaultFormat(this.Grid.columns.getColumn(i).format) &&
            //         this.CheckIfDefaultFormat((row.cells.getCell(i).stringFormat))) {
            //     row.cells.getCell(i).stringFormat = this.Grid.columns.getColumn(i).format;
            // }
            var cellstyle1 = row.cells.getCell(i).style;
            row.cells.getCell(i).style = cellstyle1;
            var skipcell = false;
            var stringResult = null;
            if (!skipcell) {
                row.cells.getCell(i)._rowHeight = row.height;
                stringResult = row.cells.getCell(i).draw(this.currentGraphics, new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(location, size), cancelSpans);
            }
            //If still row is to be drawn, set cell finished drawing cell as false and update the text to be drawn.
            if (row.rowBreakHeight > 0.0) {
                if (stringResult != null && typeof stringResult.remainder !== "undefined") {
                    row.cells.getCell(i).FinishedDrawingCell = false;
                    row.cells.getCell(i).remainingString = stringResult.remainder == null ? " " : stringResult.remainder;
                    row.rowBreakHeight = calculateHeight - stringResult.actualSize.height;
                }
            }
            result.isFinish = !result.isFinish ? result.isFinish : row.cells.getCell(i).FinishedDrawingCell;
            // let tempValue : string = ((typeof row.cells.getCell(i).value === 'string' &&
            //row.cells.getCell(i).value !== null) ? row.cells.getCell(i).value : '') as string;
            // if (!cancelSpans) {
            //     // this.raiseAfterCellDraw(this.currentGraphics, this.currentRowIndex, i,
            //     //           new RectangleF(location, size), tempValue, row.cells.getCell(i).style);            
            //     this.raiseAfterCellDraw(this.currentGraphics, this.currentRowIndex, i, new RectangleF(location, size),
            //                             (row.cells.getCell(i).value as string) ? row.cells.getCell(i).value.toString() : ' ',
            //                             row.cells.getCell(i).style);
            //     }                
            if (row.cells.getCell(i).value instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                var grid = row.cells.getCell(i).value;
                this.rowBreakPageHeightCellIndex = i;
                // row.cells.getCell(i).pageCount = grid.listOfNavigatePages.length;
                // for (let j : number = 0;j<grid.listOfNavigatePages.length;j++){
                //     let pageIndex : number =grid.listOfNavigatePages.indexOf(j);
                //             this.Grid.listOfNavigatePages.push(pageIndex);
                //     }
                if (this.Grid.columns.getColumn(i).width >= this.currentGraphics.clientSize.width) {
                    location.x = this.rowLayoutBoundsWidth;
                    location.x += grid.style.cellSpacing;
                } else location.x += this.Grid.columns.getColumn(i).width;
            } else location.x += this.Grid.columns.getColumn(i).width;
        }
        this.currentBounds.y += this.gridHeight > 0.0 ? this.gridHeight : calculateHeight;
        result.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(result.bounds.x, result.bounds.y), new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(location.x, location.y));
    };
    /**
     * @hidden
     * @private
     */ PdfGridLayouter.repeatRowIndex = -1;
    return PdfGridLayouter;
}((0, $67f37859b2b467ca$export$41d0043537bfe2f2));
// recalculateBounds : boolean, clientSize : SizeF
//Implementation
/**
 * `Initializes` internal data.
 * @private
 */ //Internal declaration
var $7f829739b2688b0e$export$b1e26fde1b28811f = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridLayoutResult, _super);
    /**
     * Constructor
     * @private
     */ function PdfGridLayoutResult(page, bounds) {
        return _super.call(this, page, bounds) || this;
    }
    return PdfGridLayoutResult;
}((0, $67f37859b2b467ca$export$602ac6ae91f8f048));
/**
 * `PdfGridLayoutFormat` class represents a flexible grid that consists of columns and rows.
 */ var $7f829739b2688b0e$export$5dfae482b3795fa8 = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridLayoutFormat, _super);
    /**
     * Initializes a new instance of the `PdfGridLayoutFormat` class.
     * @private
     */ function PdfGridLayoutFormat(baseFormat) {
        return _super.call(this, baseFormat) || this;
    }
    return PdfGridLayoutFormat;
}((0, $67f37859b2b467ca$export$b25c3374095e50f6));
var $7f829739b2688b0e$export$8872450b6b5f0c5 = /** @class */ function() {
    // Constructors
    /**
     * Initialize a new instance for `GridCellEventArgs` class.
     * @private
     */ function GridCellEventArgs(graphics, rowIndex, cellIndex, bounds, value) {
        this.gridRowIndex = rowIndex;
        this.gridCellIndex = cellIndex;
        this.internalValue = value;
        this.gridBounds = bounds;
        this.pdfGraphics = graphics;
    }
    Object.defineProperty(GridCellEventArgs.prototype, "rowIndex", {
        // Properties
        /**
         * Gets the value of current `row index`.
         * @private
         */ get: function() {
            return this.gridRowIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "cellIndex", {
        /**
         * Gets the value of current `cell index`.
         * @private
         */ get: function() {
            return this.gridCellIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "value", {
        /**
         * Gets the actual `value` of current cell.
         * @private
         */ get: function() {
            return this.internalValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "bounds", {
        /**
         * Gets the `bounds` of current cell.
         * @private
         */ get: function() {
            return this.gridBounds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "graphics", {
        /**
         * Gets the instance of `current graphics`.
         * @private
         */ get: function() {
            return this.pdfGraphics;
        },
        enumerable: true,
        configurable: true
    });
    return GridCellEventArgs;
}();
var $7f829739b2688b0e$export$ce3af96805733f2e = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridBeginCellDrawEventArgs, _super);
    // Constructors
    /**
     * Initializes a new instance of the `StartCellLayoutEventArgs` class.
     * @private
     */ function PdfGridBeginCellDrawEventArgs(graphics, rowIndex, cellIndex, bounds, value, style) {
        var _this = _super.call(this, graphics, rowIndex, cellIndex, bounds, value) || this;
        _this.style = style;
        return _this;
    }
    Object.defineProperty(PdfGridBeginCellDrawEventArgs.prototype, "skip", {
        // Properties
        /**
         * Gets or sets a value indicating whether the value of this cell should be `skipped`.
         * @private
         */ get: function() {
            return this.bSkip;
        },
        set: function(value) {
            this.bSkip = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridBeginCellDrawEventArgs.prototype, "style", {
        /**
         * Gets or sets a `style` value of the cell.
         * @private
         */ get: function() {
            return this.cellStyle;
        },
        set: function(value) {
            this.cellStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridBeginCellDrawEventArgs;
}($7f829739b2688b0e$export$8872450b6b5f0c5);
var $7f829739b2688b0e$export$73242a9ed834cba1 = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridEndCellDrawEventArgs, _super);
    // Constructors
    /**
     * Initializes a new instance of the `PdfGridEndCellLayoutEventArgs` class.
     * @private
     */ function PdfGridEndCellDrawEventArgs(graphics, rowIndex, cellIndex, bounds, value, style) {
        var _this = _super.call(this, graphics, rowIndex, cellIndex, bounds, value) || this;
        _this.cellStyle = style;
        return _this;
    }
    Object.defineProperty(PdfGridEndCellDrawEventArgs.prototype, "style", {
        // Propertise
        /**
         * Get the `PdfGridCellStyle`.
         * @private
         */ get: function() {
            return this.cellStyle;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridEndCellDrawEventArgs;
}($7f829739b2688b0e$export$8872450b6b5f0c5);
var $7f829739b2688b0e$export$6bbeaa901cbe26cd = /** @class */ function() {
    function PdfCancelEventArgs() {}
    Object.defineProperty(PdfCancelEventArgs.prototype, "cancel", {
        // Properties
        /**
         * Gets and Sets the value of `cancel`.
         * @private
         */ get: function() {
            return this.isCancel;
        },
        set: function(value) {
            this.isCancel = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfCancelEventArgs;
}();
var $7f829739b2688b0e$export$447feaee214930a8 = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(BeginPageLayoutEventArgs, _super);
    // Constructors
    /**
     * Initializes a new instance of the `BeginPageLayoutEventArgs` class with the specified rectangle and page.
     * @private
     */ function BeginPageLayoutEventArgs(bounds, page) {
        var _this = _super.call(this) || this;
        _this.bounds = bounds;
        _this.pdfPage = page;
        return _this;
    }
    Object.defineProperty(BeginPageLayoutEventArgs.prototype, "bounds", {
        // Properties
        /**
         * Gets or sets value that indicates the lay outing `bounds` on the page.
         * @private
         */ get: function() {
            return this.cellBounds;
        },
        set: function(value) {
            this.cellBounds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BeginPageLayoutEventArgs.prototype, "page", {
        /**
         * Gets the `page` where the lay outing should start.
         * @private
         */ get: function() {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    return BeginPageLayoutEventArgs;
}($7f829739b2688b0e$export$6bbeaa901cbe26cd);
/**
 * `EndPageLayoutEventArgs` class is alternate for end page layout events.
 */ var $7f829739b2688b0e$export$8273fd88e8fdaaa6 = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(EndPageLayoutEventArgs, _super);
    // Constructors
    /**
     * Initializes a new instance of the `EndPageLayoutEventArgs` class. with the specified 'PdfLayoutResult'.
     * @private
     */ function EndPageLayoutEventArgs(result) {
        var _this = _super.call(this) || this;
        _this.layoutResult = result;
        return _this;
    }
    Object.defineProperty(EndPageLayoutEventArgs.prototype, "result", {
        // Properties
        /**
         * Gets the lay outing `result` of the page.
         * @private
         */ get: function() {
            return this.layoutResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EndPageLayoutEventArgs.prototype, "nextPage", {
        /**
         * Gets or sets a value indicating the `next page` where the element should be layout.
         * @private
         */ get: function() {
            return this.nextPdfPage;
        },
        set: function(value) {
            this.nextPdfPage = value;
        },
        enumerable: true,
        configurable: true
    });
    return EndPageLayoutEventArgs;
}($7f829739b2688b0e$export$6bbeaa901cbe26cd);
/**
 * `PdfGridBeginPageLayoutEventArgs` class is alternate for begin page layout events.
 */ var $7f829739b2688b0e$export$6abed87151438d5b = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridBeginPageLayoutEventArgs, _super);
    // Constructors
    /**
     * Initialize a new instance of `PdfGridBeginPageLayoutEventArgs` class.
     * @private
     */ function PdfGridBeginPageLayoutEventArgs(bounds, page, startRow) {
        var _this = _super.call(this, bounds, page) || this;
        _this.startRow = startRow;
        return _this;
    }
    Object.defineProperty(PdfGridBeginPageLayoutEventArgs.prototype, "startRowIndex", {
        // Properties
        /**
         * Gets the `start row index`.
         * @private
         */ get: function() {
            return this.startRow;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridBeginPageLayoutEventArgs;
}($7f829739b2688b0e$export$447feaee214930a8);
/**
 * `PdfGridEndPageLayoutEventArgs` class is alternate for begin page layout events.
 */ var $7f829739b2688b0e$export$fe75e3f858c3996b = /** @class */ function(_super) {
    $7f829739b2688b0e$var$__extends(PdfGridEndPageLayoutEventArgs, _super);
    // Constructors
    /**
     * Initialize a new instance of `PdfGridEndPageLayoutEventArgs` class.
     * @private
     */ function PdfGridEndPageLayoutEventArgs(result) {
        return _super.call(this, result) || this;
    }
    return PdfGridEndPageLayoutEventArgs;
}($7f829739b2688b0e$export$8273fd88e8fdaaa6);
var $7f829739b2688b0e$export$173c93f5d3f4834d = /** @class */ function() {
    //Constructors
    /**
     * Initializes a new instance of the `RowLayoutResult` class.
     * @private
     */ function RowLayoutResult() {
        this.layoutedBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, 0, 0);
    }
    Object.defineProperty(RowLayoutResult.prototype, "isFinish", {
        /**
         * Gets or sets a value indicating whether this instance `is finish`.
         * @private
         */ get: function() {
            return this.bIsFinished;
        },
        set: function(value) {
            this.bIsFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowLayoutResult.prototype, "bounds", {
        /**
         * Gets or sets the `bounds`.
         * @private
         */ get: function() {
            return this.layoutedBounds;
        },
        set: function(value) {
            this.layoutedBounds = value;
        },
        enumerable: true,
        configurable: true
    });
    return RowLayoutResult;
}();



/**
 * `PdfGridCell` class represents the schema of a cell in a 'PdfGrid'.
 */ var $7c721536952b564d$export$7b661e766a1ad80 = /** @class */ function() {
    function PdfGridCell(row) {
        /**
         * `Width` of the cell.
         * @default 0
         * @private
         */ this.cellWidth = 0;
        /**
         * `Height` of the cell.
         * @default 0
         * @private
         */ this.cellHeight = 0;
        /**
         * `tempval`to stores current width .
         * @default 0
         * @private
         */ this.tempval = 0;
        this.fontSpilt = false;
        /**
         * Specifies weather the `cell is drawn`.
         * @default true
         * @private
         */ this.finsh = true;
        /**
         * The `remaining height` of row span.
         * @default 0
         * @private
         */ this.rowSpanRemainingHeight = 0;
        this.hasRowSpan = false;
        this.hasColSpan = false;
        /**
         * the 'isFinish' is set to page finish
         */ this.isFinish = true;
        /**
         * The `present' to store the current cell.
         * @default false
         * @private
         */ this.present = false;
        this.gridRowSpan = 1;
        this.colSpan = 1;
        if (typeof row !== "undefined") this.gridRow = row;
    }
    Object.defineProperty(PdfGridCell.prototype, "isCellMergeContinue", {
        //Properties
        get: function() {
            return this.internalIsCellMergeContinue;
        },
        set: function(value) {
            this.internalIsCellMergeContinue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "isRowMergeContinue", {
        get: function() {
            return this.internalIsRowMergeContinue;
        },
        set: function(value) {
            this.internalIsRowMergeContinue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "isCellMergeStart", {
        get: function() {
            return this.internalIsCellMergeStart;
        },
        set: function(value) {
            this.internalIsCellMergeStart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "isRowMergeStart", {
        get: function() {
            return this.internalIsRowMergeStart;
        },
        set: function(value) {
            this.internalIsRowMergeStart = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "remainingString", {
        /**
         * Gets or sets the `remaining string` after the row split between pages.
         * @private
         */ get: function() {
            return this.remaining;
        },
        set: function(value) {
            this.remaining = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "FinishedDrawingCell", {
        /**
         * Gets or sets the `FinishedDrawingCell` .
         * @private
         */ get: function() {
            return this.isFinish;
        },
        set: function(value) {
            this.isFinish = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "stringFormat", {
        /**
         * Gets or sets the `string format`.
         * @private
         */ get: function() {
            if (this.format == null) this.format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
            return this.format;
        },
        set: function(value) {
            this.format = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "row", {
        /**
         * Gets or sets the parent `row`.
         * @private
         */ get: function() {
            return this.gridRow;
        },
        set: function(value) {
            this.gridRow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "value", {
        /**
         * Gets or sets the `value` of the cell.
         * @private
         */ get: function() {
            return this.objectValue;
        },
        set: function(value) {
            this.objectValue = value;
            if (this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
                this.row.grid.isSingleGrid = false;
                var grid = this.objectValue;
                grid.ParentCell = this;
                this.objectValue.isChildGrid = true;
                var rowCount = this.row.grid.rows.count;
                for(var i = 0; i < rowCount; i++){
                    var row = this.row.grid.rows.getRow(i);
                    var colCount = row.cells.count;
                    for(var j = 0; j < colCount; j++){
                        var cell = row.cells.getCell(j);
                        cell.parent = this;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "rowSpan", {
        /**
         * Gets or sets a value that indicates the total number of rows that cell `spans` within a PdfGrid.
         * @private
         */ get: function() {
            return this.gridRowSpan;
        },
        set: function(value) {
            if (value < 1) throw new Error("ArgumentException : Invalid span specified, must be greater than or equal to 1");
            else {
                this.gridRowSpan = value;
                this.row.rowSpanExists = true;
                this.row.grid.hasRowSpanSpan = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "style", {
        /**
         * Gets or sets the cell `style`.
         * @private
         */ get: function() {
            if (this.cellStyle == null) this.cellStyle = new (0, $fa5fb82b29645b96$export$d8846553b004a98c)();
            return this.cellStyle;
        },
        set: function(value) {
            this.cellStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "height", {
        /**
         * Gets the `height` of the PdfGrid cell.[Read-Only].
         * @private
         */ get: function() {
            if (this.cellHeight === 0) this.cellHeight = this.measureHeight();
            return this.cellHeight;
        },
        set: function(value) {
            this.cellHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "columnSpan", {
        /**
         * Gets or sets a value that indicates the total number of columns that cell `spans` within a PdfGrid.
         * @private
         */ get: function() {
            return this.colSpan;
        },
        set: function(value) {
            if (value < 1) throw Error("Invalid span specified, must be greater than or equal to 1");
            else {
                this.colSpan = value;
                this.row.columnSpanExists = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridCell.prototype, "width", {
        /**
         * Gets the `width` of the PdfGrid cell.[Read-Only].
         * @private
         */ get: function() {
            if (this.cellWidth === 0 || this.row.grid.isComplete) this.cellWidth = this.measureWidth();
            return Math.round(this.cellWidth);
        },
        set: function(value) {
            this.cellWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    /**
     * `Calculates the width`.
     * @private
     */ PdfGridCell.prototype.measureWidth = function() {
        // .. Calculate the cell text width.
        // .....Add border widths, cell spacings and paddings to the width.
        var width = 0;
        var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
        if (typeof this.objectValue === "string") {
            /* tslint:disable */ var slr = layouter.layout(this.objectValue, this.getTextFont(), this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(Number.MAX_VALUE, Number.MAX_VALUE), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            width += slr.actualSize.width;
            width += (this.style.borders.left.width + this.style.borders.right.width) * 2;
        } else if (this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) width = this.objectValue.size.width;
        else if (this.objectValue instanceof (0, $722331ec33bd9a93$export$ee8313b7edf5feab) || this.objectValue instanceof (0, $c987c917f397d328$export$a738614a0b6b3b5a)) width += this.objectValue.width;
        else if (this.objectValue instanceof (0, $0b4b1f60d7f75a26$export$6c765b7085f136fc)) {
            var webLink = this.objectValue;
            var result = layouter.layout(webLink.text, webLink.font, webLink.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            /* tslint:enable */ width += result.actualSize.width;
            width += (this.style.borders.left.width + this.style.borders.right.width) * 2;
        }
        if (!(this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6))) {
            if (this.style.cellPadding != null) width += this.style.cellPadding.left + this.style.cellPadding.right;
            else width += this.row.grid.style.cellPadding.left + this.row.grid.style.cellPadding.right;
        } else if (this.style.cellPadding != null || typeof this.style.cellPadding !== "undefined") {
            if (typeof this.style.cellPadding.left !== "undefined" && this.style.cellPadding.hasLeftPad) width += this.style.cellPadding.left;
            if (typeof this.style.cellPadding.right !== "undefined" && this.style.cellPadding.hasRightPad) width += this.style.cellPadding.right;
        } else {
            if (typeof this.row.grid.style.cellPadding.left !== "undefined" && this.row.grid.style.cellPadding.hasLeftPad) width += this.row.grid.style.cellPadding.left;
            if (typeof this.row.grid.style.cellPadding.right !== "undefined" && this.row.grid.style.cellPadding.hasRightPad) width += this.row.grid.style.cellPadding.right;
        }
        width += this.row.grid.style.cellSpacing;
        return width;
    };
    /**
     * Draw the `cell background`.
     * @private
     */ PdfGridCell.prototype.drawCellBackground = function(graphics, bounds) {
        var backgroundBrush = this.getBackgroundBrush();
        //graphics.isTemplateGraphics = true;
        if (backgroundBrush != null) {
            graphics.save();
            graphics.drawRectangle(backgroundBrush, bounds.x, bounds.y, bounds.width, bounds.height);
            graphics.restore();
        }
        if (this.style.backgroundImage != null) {
            var image = this.getBackgroundImage();
            graphics.drawImage(this.style.backgroundImage, bounds.x, bounds.y, bounds.width, bounds.height);
        }
    };
    /**
     * `Adjusts the text layout area`.
     * @private
     */ /* tslint:disable */ PdfGridCell.prototype.adjustContentLayoutArea = function(bounds) {
        //Add Padding value to its Cell Bounds
        var returnBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(bounds.x, bounds.y, bounds.width, bounds.height);
        if (!(this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6))) {
            if (typeof this.style.cellPadding === "undefined" || this.style.cellPadding == null) {
                returnBounds.x += this.gridRow.grid.style.cellPadding.left;
                returnBounds.y += this.gridRow.grid.style.cellPadding.top;
                returnBounds.width -= this.gridRow.grid.style.cellPadding.right + this.gridRow.grid.style.cellPadding.left;
                returnBounds.height -= this.gridRow.grid.style.cellPadding.bottom + this.gridRow.grid.style.cellPadding.top;
            } else {
                returnBounds.x += this.style.cellPadding.left;
                returnBounds.y += this.style.cellPadding.top;
                returnBounds.width -= this.style.cellPadding.right + this.style.cellPadding.left;
                returnBounds.height -= this.style.cellPadding.bottom + this.style.cellPadding.top;
                if (this.rowSpan === 1) returnBounds.width -= this.style.borders.left.width;
            }
            if (typeof this.style.borders === "undefined" || this.style.borders == null) {
                returnBounds.x += this.gridRow.style.border.left.width;
                returnBounds.y += this.gridRow.style.border.top.width;
                returnBounds.width -= this.gridRow.style.border.left.width + this.gridRow.style.border.right.width;
                returnBounds.height -= this.gridRow.style.border.top.width + this.gridRow.style.border.bottom.width;
            } else {
                returnBounds.x += this.style.borders.left.width;
                returnBounds.y += this.style.borders.top.width;
                returnBounds.width -= this.style.borders.left.width + this.style.borders.right.width;
                returnBounds.height -= this.style.borders.top.width + this.style.borders.bottom.width;
                if (this.rowSpan === 1) returnBounds.width -= this.style.borders.left.width;
            }
        } else {
            if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") {
                if (this.gridRow.grid.style.cellPadding !== null && typeof this.gridRow.grid.style.cellPadding !== "undefined") {
                    var hasLeftPad = this.gridRow.grid.style.cellPadding.hasLeftPad;
                    var hasTopPad = this.gridRow.grid.style.cellPadding.hasTopPad;
                    var hasRightPad = this.gridRow.grid.style.cellPadding.hasRightPad;
                    var hasBottomPad = this.gridRow.grid.style.cellPadding.hasBottomPad;
                    if (hasLeftPad || hasTopPad || hasRightPad || hasBottomPad) {
                        if (typeof this.gridRow.grid.style.cellPadding.left !== "undefined" && hasLeftPad) {
                            returnBounds.x += this.gridRow.grid.style.cellPadding.left + this.cellStyle.borders.left.width;
                            returnBounds.width -= this.gridRow.grid.style.cellPadding.left;
                        }
                        if (typeof this.gridRow.grid.style.cellPadding.top !== "undefined" && hasTopPad) {
                            returnBounds.y += this.gridRow.grid.style.cellPadding.top + this.cellStyle.borders.top.width;
                            returnBounds.height -= this.gridRow.grid.style.cellPadding.top;
                        }
                        if (typeof this.gridRow.grid.style.cellPadding.right !== "undefined" && hasRightPad) returnBounds.width -= this.gridRow.grid.style.cellPadding.right;
                        if (typeof this.gridRow.grid.style.cellPadding.bottom !== "undefined" && hasBottomPad) returnBounds.height -= this.gridRow.grid.style.cellPadding.bottom;
                    } else {
                        var format = this.getStringFormat();
                        if (format.alignment === null || typeof format.alignment === "undefined") {
                            returnBounds.x += this.row.grid.style.cellPadding.left;
                            returnBounds.y += this.row.grid.style.cellPadding.top;
                        }
                    }
                } else {
                    var format = this.getStringFormat();
                    if (format.alignment === null || typeof format.alignment === "undefined") {
                        returnBounds.x += this.row.grid.style.cellPadding.left;
                        returnBounds.y += this.row.grid.style.cellPadding.top;
                    }
                }
            } else {
                if (typeof this.style.cellPadding.left !== "undefined" && this.style.cellPadding.hasLeftPad) {
                    returnBounds.x += this.style.cellPadding.left + this.cellStyle.borders.left.width;
                    returnBounds.width -= this.style.cellPadding.left;
                }
                if (typeof this.style.cellPadding.top !== "undefined" && this.style.cellPadding.hasTopPad) {
                    returnBounds.y += this.style.cellPadding.top + this.cellStyle.borders.top.width;
                    returnBounds.height -= this.style.cellPadding.top;
                }
                if (typeof this.style.cellPadding.right !== "undefined" && this.style.cellPadding.hasRightPad) returnBounds.width -= this.style.cellPadding.right;
                if (typeof this.style.cellPadding.bottom !== "undefined" && this.style.cellPadding.hasBottomPad) returnBounds.height -= this.style.cellPadding.bottom;
            }
            returnBounds.width -= this.cellStyle.borders.left.width + this.cellStyle.borders.right.width;
            returnBounds.height -= this.cellStyle.borders.top.width + this.cellStyle.borders.bottom.width;
        }
        return returnBounds;
    };
    /**
     * `Draws` the specified graphics.
     * @private
     */ PdfGridCell.prototype.draw = function(graphics, bounds, cancelSubsequentSpans) {
        var isrowbreak = false;
        /*if (!this.row.grid.isSingleGrid)
        {
            //Check whether the Grid Span to Nextpage
            if ((this.remainingString != null) || (PdfGridLayouter.repeatRowIndex != -1))
            {
                this.DrawParentCells(graphics, bounds, true);
            }
            else if (this.row.grid.rows.count > 1)
            {
                for (let i : number  = 0; i < this.row.grid.rows.count; i++)
                {
                    if (this.row == this.row.grid.rows.getRow(i))
                    {
                        if (this.row.grid.rows.getRow(i).rowBreakHeight > 0)
                            isrowbreak = true;
                        if ((i > 0) && (isrowbreak))
                            this.DrawParentCells(graphics, bounds, false);
                    }
                }
            }
        } */ var result = null;
        /*if (cancelSubsequentSpans)
        {
            //..Cancel all subsequent cell spans, if no space exists.
            let currentCellIndex : number = this.row.cells.indexOf(this);
            for (let i : number = currentCellIndex + 1; i <= currentCellIndex + this.colSpan; i++)
            {
                this.row.cells.getCell(i).isCellMergeContinue = false;
                this.row.cells.getCell(i).isRowMergeContinue = false;
            }
            this.colSpan = 1;
        }*/ //..Skip cells which were already covered by spanmap.
        if (this.internalIsCellMergeContinue || this.internalIsRowMergeContinue) {
            if (this.internalIsCellMergeContinue && this.row.grid.style.allowHorizontalOverflow) {
                if (this.row.rowOverflowIndex > 0 && this.row.cells.indexOf(this) != this.row.rowOverflowIndex + 1 || this.row.rowOverflowIndex == 0 && this.internalIsCellMergeContinue) return result;
            } else return result;
        }
        //Adjust bounds with Row and Column Spacing
        bounds = this.adjustOuterLayoutArea(bounds, graphics);
        this.drawCellBackground(graphics, bounds);
        var textPen = this.getTextPen();
        var textBrush = this.getTextBrush();
        if (typeof textPen === "undefined" && typeof textBrush === "undefined") textBrush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        var font = this.getTextFont();
        var strFormat = this.getStringFormat();
        var innerLayoutArea = bounds;
        if (innerLayoutArea.height >= graphics.clientSize.height) // If to break row to next page.
        {
            if (this.row.grid.allowRowBreakAcrossPages) {
                innerLayoutArea.height -= innerLayoutArea.y;
                if (typeof this._rowHeight !== "undefined" && this._rowHeight !== null && innerLayoutArea.height > this._rowHeight) innerLayoutArea.height = this._rowHeight;
            //bounds.height -= bounds.y;
            // if(this.row.grid.isChildGrid)
            // {
            //     innerLayoutArea.height -= this.row.grid.ParentCell.row.grid.style.cellPadding.bottom;
            // }
            }
        }
        innerLayoutArea = this.adjustContentLayoutArea(innerLayoutArea);
        if (typeof this.objectValue === "string" || typeof this.remaining === "string") {
            var temp = void 0;
            var layoutRectangle = void 0;
            if (innerLayoutArea.height < font.height) layoutRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(innerLayoutArea.x, innerLayoutArea.y, innerLayoutArea.width, font.height);
            else layoutRectangle = innerLayoutArea;
            if (innerLayoutArea.height < font.height && this.row.grid.isChildGrid && this.row.grid.ParentCell != null) {
                var height = layoutRectangle.height - this.row.grid.ParentCell.row.grid.style.cellPadding.bottom - this.row.grid.style.cellPadding.bottom;
                if (this.row.grid.splitChildRowIndex != -1) {
                    this.fontSpilt = true;
                    this.row.rowFontSplit = true;
                }
                if (height > 0 && height < font.height) layoutRectangle.height = height;
            // else if (height + this.row.grid.style.cellPadding.bottom > 0 && height + this.row.grid.style.cellPadding.bottom < font.height)
            //     layoutRectangle.height = height + this.row.grid.style.cellPadding.bottom;
            // else if (bounds.height < font.height)
            //     layoutRectangle.height = bounds.height;
            // else if (bounds.height - this.row.grid.ParentCell.row.grid.style.cellPadding.bottom < font.height)
            //     layoutRectangle.height = bounds.height - this.row.grid.ParentCell.row.grid.style.cellPadding.bottom;                        
            }
            if (this.gridRow.grid.style.cellSpacing != 0) {
                layoutRectangle.width -= this.gridRow.grid.style.cellSpacing;
                bounds.width -= this.gridRow.grid.style.cellSpacing;
            }
            if (this.isFinish) {
                // if (this.row.grid.splitChildRowIndex != -1 && !this.row.grid.isChildGrid && typeof this.remaining === 'undefined'){
                //     this.remaining = '';
                //     graphics.drawString(this.remaining, font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);
                // } else {
                temp = this.remaining === "" ? this.remaining : this.objectValue;
                graphics.drawString(temp, font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);
                if (this.row.grid.splitChildRowIndex != -1 && !this.row.grid.isChildGrid && typeof this.remaining === "undefined") this.remaining = "";
            } else {
                if (typeof this.remaining == "undefined" || this.remaining === null) this.remaining = "";
                if (this.row.repeatFlag) graphics.drawString(this.remaining, font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);
                //  else {
                //     if(this.row.grid.ParentCell.row.repeatFlag) {
                //         graphics.drawString((this.remaining as string), font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);                    
                //     } else {
                //         layoutRectangle.height = this.row.height;
                //         graphics.drawString((this.objectValue as string), font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);
                //         bounds.height = this.row.height;
                //     }
                //  }
                this.isFinish = true;
            //graphics.drawString((this.remaining as string), font, textPen, textBrush, layoutRectangle.x, layoutRectangle.y, layoutRectangle.width, layoutRectangle.height, strFormat);
            }
            result = graphics.stringLayoutResult;
        // if(this.row.grid.isChildGrid && this.row.rowBreakHeight > 0 && result !=null) {
        //     bounds.height -= this.row.grid.ParentCell.row.grid.style.cellPadding.bottom;
        // }
        } else if (this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
            var childGrid = this.objectValue;
            childGrid.isChildGrid = true;
            childGrid.ParentCell = this;
            var layoutRect = void 0;
            layoutRect = innerLayoutArea;
            if (this.gridRow.grid.style.cellSpacing != 0) bounds.width -= this.gridRow.grid.style.cellSpacing;
            // layoutRect = bounds;
            // if (this.style.cellPadding != null){
            //     layoutRect = bounds;            
            // } else if((this.row.grid.style.cellPadding != null) && (childGrid.style.cellPadding.bottom === 0.5) && (childGrid.style.cellPadding.top === 0.5)
            //                               && (childGrid.style.cellPadding.left === 5.76) && (childGrid.style.cellPadding.right === 5.76)
            //                               && (this.gridRow.grid.style.cellSpacing === 0) && (childGrid.style.cellSpacing === 0)) {
            //     layoutRect = innerLayoutArea;
            // }
            // if(this.objectValue.style.cellPadding != null && typeof this.objectValue.style.cellPadding !== 'undefined'){
            //     layoutRect = bounds;
            // }           
            var layouter = new (0, $7f829739b2688b0e$export$11c2bcbc14388afe)(childGrid);
            var format = new (0, $7f829739b2688b0e$export$5dfae482b3795fa8)();
            if (this.row.grid.LayoutFormat != null) format = this.row.grid.LayoutFormat;
            else format.layout = (0, $5ffc34ffc68e39dd$export$3652975898b34cce).Paginate;
            var param = new (0, $67f37859b2b467ca$export$ab6ea71ea2ace1ae)();
            if (graphics.layer != null) {
                // Define layout parameters.
                param.page = graphics.page;
                param.bounds = layoutRect;
                param.format = format;
                //Set the span 
                childGrid.setSpan();
                childGrid.checkSpan();
                // Draw the child grid.
                var childGridResult = layouter.Layouter(param);
                //let childGridResult : PdfLayoutResult = layouter.innerLayout(param);
                this.value = childGrid;
                if (this.row.grid.splitChildRowIndex !== -1) this.height = this.row.rowBreakHeightValue;
                if (param.page != childGridResult.page) {
                    if (this.row.rowBreakHeightValue !== null && typeof this.row.rowBreakHeightValue !== "undefined") childGridResult.bounds.height = this.row.rowBreakHeightValue;
                    if (this.row.rowBreakHeight == 0) this.row.NestedGridLayoutResult = childGridResult;
                    else this.row.rowBreakHeight = this.row.rowBreakHeightValue;
                //bounds.height = this.row.rowBreakHeight;
                //After drawing paginated nested grid, the bounds of the parent grid in start page should be corrected for borders.
                //bounds.height = graphics.clientSize.height - bounds.y;
                }
            }
        } else if (this.objectValue instanceof (0, $722331ec33bd9a93$export$ee8313b7edf5feab) || this.objectValue instanceof (0, $c987c917f397d328$export$a738614a0b6b3b5a)) {
            var imageBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(innerLayoutArea.x, innerLayoutArea.y, innerLayoutArea.width, innerLayoutArea.height);
            var image = this.objectValue;
            if (image.width <= innerLayoutArea.width) imageBounds.width = image.width;
            if (image.height <= innerLayoutArea.height) imageBounds.height = image.height;
            graphics.drawImage(this.objectValue, imageBounds.x, imageBounds.y, imageBounds.width, imageBounds.height);
        } else if (this.objectValue instanceof (0, $0b4b1f60d7f75a26$export$6c765b7085f136fc)) this.objectValue.draw(graphics.currentPage, innerLayoutArea);
        else if (typeof this.objectValue === "undefined") {
            this.objectValue = "";
            graphics.drawString(this.objectValue, font, textPen, textBrush, innerLayoutArea.x, innerLayoutArea.y, innerLayoutArea.width, innerLayoutArea.height, strFormat);
            if (this.style.cellPadding != null && this.style.cellPadding.bottom == 0 && this.style.cellPadding.left == 0 && this.style.cellPadding.right == 0 && this.style.cellPadding.top == 0) bounds.width -= this.style.borders.left.width + this.style.borders.right.width;
            if (this.gridRow.grid.style.cellSpacing != 0) bounds.width -= this.gridRow.grid.style.cellSpacing;
        }
        if (this.style.borders != null) {
            if (!this.fontSpilt) this.drawCellBorders(graphics, bounds);
            else if (this.row.grid.ParentCell.row.grid.splitChildRowIndex != -1) {
                this.row.rowFontSplit = false;
                this.drawCellBorders(graphics, bounds);
            }
        }
        return result;
    };
    /* tslint:enable */ /**
     * Draws the `cell border` constructed by drawing lines.
     * @private
     */ PdfGridCell.prototype.drawCellBorders = function(graphics, bounds) {
        if (this.row.grid.style.borderOverlapStyle === (0, $238f209b947082e7$export$bd6016b867e69b14).Inside) {
            bounds.x += this.style.borders.left.width;
            bounds.y += this.style.borders.top.width;
            bounds.width -= this.style.borders.right.width;
            bounds.height -= this.style.borders.bottom.width;
        }
        var p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y + bounds.height);
        var p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y);
        var pen = this.cellStyle.borders.left;
        if (this.cellStyle.borders.left.dashStyle === (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid) pen.lineCap = (0, $d174213b46afc09a$export$7c913101b81a8134).Square;
        // SetTransparency(ref graphics, pen);
        if (pen.width !== 0) graphics.drawLine(pen, p1, p2);
        p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x + bounds.width, bounds.y);
        p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x + bounds.width, bounds.y + bounds.height);
        pen = this.cellStyle.borders.right;
        if (bounds.x + bounds.width > graphics.clientSize.width - pen.width / 2) {
            p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(graphics.clientSize.width - pen.width / 2, bounds.y);
            p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(graphics.clientSize.width - pen.width / 2, bounds.y + bounds.height);
        }
        if (this.cellStyle.borders.right.dashStyle === (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid) pen.lineCap = (0, $d174213b46afc09a$export$7c913101b81a8134).Square;
        if (pen.width !== 0) graphics.drawLine(pen, p1, p2);
        p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y);
        p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x + bounds.width, bounds.y);
        pen = this.cellStyle.borders.top;
        if (this.cellStyle.borders.top.dashStyle === (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid) pen.lineCap = (0, $d174213b46afc09a$export$7c913101b81a8134).Square;
        if (pen.width !== 0) graphics.drawLine(pen, p1, p2);
        p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x + bounds.width, bounds.y + bounds.height);
        p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y + bounds.height);
        pen = this.cellStyle.borders.bottom;
        if (bounds.y + bounds.height > graphics.clientSize.height - pen.width / 2) {
            p1 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x + bounds.width, graphics.clientSize.height - pen.width / 2);
            p2 = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, graphics.clientSize.height - pen.width / 2);
        }
        if (this.cellStyle.borders.bottom.dashStyle === (0, $d174213b46afc09a$export$a8fd4dfaf26dd3eb).Solid) pen.lineCap = (0, $d174213b46afc09a$export$7c913101b81a8134).Square;
        if (pen.width !== 0) graphics.drawLine(pen, p1, p2);
    };
    // private setTransparency(graphics : PdfGraphics, pen : PdfPen) : void {
    //     let alpha : number = (pen.color.a / 255) as number;
    //     graphics.save();
    //     graphics.setTransparency(alpha);
    // }
    /**
     * `Adjusts the outer layout area`.
     * @private
     */ /* tslint:disable */ PdfGridCell.prototype.adjustOuterLayoutArea = function(bounds, g) {
        var isHeader = false;
        var cellSpacing = this.row.grid.style.cellSpacing;
        if (cellSpacing > 0) bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(bounds.x + cellSpacing, bounds.y + cellSpacing, bounds.width - cellSpacing, bounds.height - cellSpacing);
        var currentColIndex = this.row.cells.indexOf(this);
        if (this.columnSpan > 1 || this.row.rowOverflowIndex > 0 && currentColIndex == this.row.rowOverflowIndex + 1 && this.isCellMergeContinue) {
            var span = this.columnSpan;
            if (span == 1 && this.isCellMergeContinue) for(var j = currentColIndex + 1; j < this.row.grid.columns.count; j++){
                if (this.row.cells.getCell(j).isCellMergeContinue) span++;
                else break;
            }
            var totalWidth = 0;
            for(var i = currentColIndex; i < currentColIndex + span; i++){
                if (this.row.grid.style.allowHorizontalOverflow) {
                    var width = void 0;
                    var compWidth = this.row.grid.size.width < g.clientSize.width ? this.row.grid.size.width : g.clientSize.width;
                    if (this.row.grid.size.width > g.clientSize.width) width = bounds.x + totalWidth + this.row.grid.columns.getColumn(i).width;
                    else width = totalWidth + this.row.grid.columns.getColumn(i).width;
                    if (width > compWidth) break;
                }
                totalWidth += this.row.grid.columns.getColumn(i).width;
            }
            totalWidth -= this.row.grid.style.cellSpacing;
            bounds.width = totalWidth;
        }
        if (this.rowSpan > 1 || this.row.rowSpanExists) {
            var span = this.rowSpan;
            var currentRowIndex = this.row.grid.rows.rowCollection.indexOf(this.row);
            if (currentRowIndex == -1) {
                currentRowIndex = this.row.grid.headers.indexOf(this.row);
                if (currentRowIndex != -1) isHeader = true;
            }
            // if (span == 1 && this.isCellMergeContinue) {
            //         for (let j : number = currentRowIndex + 1; j < this.row.grid.rows.count; j++)
            //         {
            //             let flag : boolean = (isHeader ? this.row.grid.headers.getHeader(j).cells.getCell(currentColIndex).isCellMergeContinue : this.row.grid.rows.getRow(j).cells.getCell(currentColIndex).isCellMergeContinue);
            //             if (flag)
            //                 span++;
            //             else
            //                 break;
            //         }
            // }
            var totalHeight = 0;
            var max = 0;
            for(var i = currentRowIndex; i < currentRowIndex + span; i++){
                totalHeight += isHeader ? this.row.grid.headers.getHeader(i).height : this.row.grid.rows.getRow(i).height;
                var row = this.row.grid.rows.getRow(i);
                var rowIndex = this.row.grid.rows.rowCollection.indexOf(row);
            /*if (this.rowSpan > 1)
                    {
                        for (let k : number = 0; k < this.row.cells.count; k++) {
                            let cell : PdfGridCell = this.row.cells.getCell(k);
                            if(cell.rowSpan>1)
                            {
                                let tempHeight : number =0;
                                
                                for (let j :number = i; j < i +cell.rowSpan; j++)
                                {
                                    if (!this.row.grid.rows.getRow(j).isRowSpanRowHeightSet)
                                        this.row.grid.rows.getRow(j).isRowHeightSet = false;
                                    tempHeight += this.row.grid.rows.getRow(j).height;
                                    if (!this.row.grid.rows.getRow(j).isRowSpanRowHeightSet)
                                        this.row.grid.rows.getRow(j).isRowHeightSet = true;
                                }
                                //To check the Row spanned cell height is greater than the total spanned row height.
                                if(cell.height>tempHeight)
                                {
                                    if (max < (cell.height - tempHeight))
                                    {
                                        max = cell.height - tempHeight;
                                        if (this.rowSpanRemainingHeight != 0 && max > this.rowSpanRemainingHeight)
                                        {
                                            max += this.rowSpanRemainingHeight;
                                        }
                                        let index :number = row.cells.indexOf(cell);
                                        //set the m_rowspanRemainingHeight to last rowspanned row.
                                        this.row.grid.rows.getRow((rowIndex +cell.rowSpan) - 1).cells.getCell(index).rowSpanRemainingHeight = max;
                                        this.rowSpanRemainingHeight = this.row.grid.rows.getRow((rowIndex + cell.rowSpan) - 1).cells.getCell(index).rowSpanRemainingHeight;
                                    }
                                }
                            }
                        }
                    }
                    if (!this.row.grid.rows.getRow(i).isRowSpanRowHeightSet)
                    this.row.grid.rows.getRow(i).isRowHeightSet = true;*/ }
            var cellIndex = this.row.cells.indexOf(this);
            totalHeight -= this.row.grid.style.cellSpacing;
            // if (this.row.cells.getCell(cellIndex).height > totalHeight && (!this.row.grid.rows.getRow((currentRowIndex + span) - 1).isRowHeightSet)) {
            //      this.row.grid.rows.getRow((currentRowIndex + span) - 1).cells.getCell(cellIndex).rowSpanRemainingHeight = this.row.cells.getCell(cellIndex).height - totalHeight;
            //      totalHeight = this.row.cells.getCell(cellIndex).height;
            //      bounds.height = totalHeight;
            // } else {
            bounds.height = totalHeight;
            //  }
            if (!this.row.rowMergeComplete) bounds.height = totalHeight;
        }
        return bounds;
    };
    /* tslint:enable */ /**
     * Gets the `text font`.
     * @private
     */ PdfGridCell.prototype.getTextFont = function() {
        if (typeof this.style.font !== "undefined" && this.style.font != null) return this.style.font;
        else if (typeof this.row.style.font !== "undefined" && this.row.style.font != null) return this.row.style.font;
        else if (typeof this.row.grid.style.font !== "undefined" && this.row.grid.style.font != null) return this.row.grid.style.font;
        else return (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).defaultFont;
    };
    /**
     * Gets the `text brush`.
     * @private
     */ PdfGridCell.prototype.getTextBrush = function() {
        if (typeof this.style.textBrush !== "undefined" && this.style.textBrush != null) return this.style.textBrush;
        else if (typeof this.row.style.textBrush !== "undefined" && this.row.style.textBrush != null) return this.row.style.textBrush;
        else return this.row.grid.style.textBrush;
    };
    /**
     * Gets the `text pen`.
     * @private
     */ PdfGridCell.prototype.getTextPen = function() {
        if (typeof this.style.textPen !== "undefined" && this.style.textPen != null) return this.style.textPen;
        else if (typeof this.row.style.textPen !== "undefined" && this.row.style.textPen != null) return this.row.style.textPen;
        else return this.row.grid.style.textPen;
    };
    /**
     * Gets the `background brush`.
     * @private
     */ PdfGridCell.prototype.getBackgroundBrush = function() {
        if (typeof this.style.backgroundBrush !== "undefined" && this.style.backgroundBrush != null) return this.style.backgroundBrush;
        else if (typeof this.row.style.backgroundBrush !== "undefined" && this.row.style.backgroundBrush != null) return this.row.style.backgroundBrush;
        else return this.row.grid.style.backgroundBrush;
    };
    /**
     * Gets the `background image`.
     * @private
     */ PdfGridCell.prototype.getBackgroundImage = function() {
        if (typeof this.style.backgroundImage !== "undefined" && this.style.backgroundImage != null) return this.style.backgroundImage;
        else if (typeof this.row.style.backgroundImage !== "undefined" && this.row.style.backgroundImage != null) return this.row.style.backgroundImage;
        else return this.row.grid.style.backgroundImage;
    };
    /**
     * Gets the current `StringFormat`.
     * @private
     */ PdfGridCell.prototype.getStringFormat = function() {
        if (typeof this.style.stringFormat !== "undefined" && this.style.stringFormat != null) return this.style.stringFormat;
        else return this.stringFormat;
    };
    /**
     * Calculates the `height`.
     * @private
     */ PdfGridCell.prototype.measureHeight = function() {
        // .. Calculate the cell text height.
        // .....Add border widths, cell spacings and paddings to the height.
        var width = this.calculateWidth();
        // //check whether the Current PdfGridCell has padding
        if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") width -= this.gridRow.grid.style.cellPadding.right + this.gridRow.grid.style.cellPadding.left;
        else {
            width -= this.style.cellPadding.right + this.style.cellPadding.left;
            width -= this.style.borders.left.width + this.style.borders.right.width;
        }
        var height = 0;
        var layouter = new (0, $da0806e60b4d67c7$export$53b9c0a8035b9a38)();
        if (typeof this.objectValue === "string" || typeof this.remaining === "string") {
            var currentValue = this.objectValue;
            /* tslint:disable */ if (!this.isFinish) currentValue = !(this.remaining === null || this.remaining === "" || typeof this.remaining === "undefined") ? this.remaining : this.objectValue;
            var slr = null;
            var cellIndex = this.row.cells.indexOf(this);
            if (this.gridRow.grid.style.cellSpacing != 0) width -= this.gridRow.grid.style.cellSpacing * 2;
            if (!this.row.cells.getCell(cellIndex).hasColSpan && !this.row.cells.getCell(cellIndex).hasRowSpan) {
                if (this.gridRow.grid.isChildGrid) {
                    if (width < 0) {
                        this.tempval = width;
                        if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") this.tempval += this.gridRow.grid.style.cellPadding.right + this.gridRow.grid.style.cellPadding.left;
                        else {
                            this.tempval += this.style.cellPadding.right + this.style.cellPadding.left;
                            this.tempval += this.style.borders.left.width + this.style.borders.right.width;
                        }
                    } else this.tempval = width;
                    slr = layouter.layout(currentValue, this.getTextFont(), this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(this.tempval, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
                    height += slr.actualSize.height;
                } else {
                    slr = layouter.layout(currentValue, this.getTextFont(), this.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
                    height += slr.actualSize.height;
                }
            }
            /* tslint:enable */ height += (this.style.borders.top.width + this.style.borders.bottom.width) * 2;
        } else if (this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6)) {
            var cellIndex = this.row.cells.indexOf(this);
            var internalWidth = 0;
            if (this.style.cellPadding != null || typeof this.style.cellPadding !== "undefined") {
                internalWidth = this.calculateWidth();
                if (typeof this.style.cellPadding.left !== "undefined" && this.style.cellPadding.hasLeftPad) internalWidth -= this.style.cellPadding.left;
                if (typeof this.style.cellPadding.right !== "undefined" && this.style.cellPadding.hasRightPad) internalWidth -= this.style.cellPadding.right;
            } else if (this.row.grid.style.cellPadding != null || typeof this.row.grid.style.cellPadding !== "undefined") {
                internalWidth = this.calculateWidth();
                if (typeof this.row.grid.style.cellPadding.left !== "undefined" && this.row.grid.style.cellPadding.hasLeftPad) internalWidth -= this.row.grid.style.cellPadding.left;
                if (typeof this.row.grid.style.cellPadding.right !== "undefined" && this.row.grid.style.cellPadding.hasRightPad) internalWidth -= this.row.grid.style.cellPadding.right;
            } else internalWidth = this.calculateWidth();
            this.objectValue.tempWidth = internalWidth;
            if (!this.row.cells.getCell(cellIndex).hasColSpan && !this.row.cells.getCell(cellIndex).hasRowSpan) height = this.objectValue.size.height;
            else height += (this.style.borders.top.width + this.style.borders.bottom.width) * 2;
            if (this.gridRow.grid.style.cellSpacing !== 0) width -= this.gridRow.grid.style.cellSpacing * 2;
            if (this.style.cellPadding != null || typeof this.style.cellPadding !== "undefined") {
                if (typeof this.row.grid.style.cellPadding.top !== "undefined" && this.row.grid.style.cellPadding.hasTopPad) height += this.row.grid.style.cellPadding.top;
                if (this.row.grid.style.cellPadding.hasBottomPad && typeof this.row.grid.style.cellPadding.bottom !== "undefined") height += this.row.grid.style.cellPadding.bottom;
            }
            height += this.objectValue.style.cellSpacing;
        } else if (this.objectValue instanceof (0, $722331ec33bd9a93$export$ee8313b7edf5feab) || this.objectValue instanceof (0, $c987c917f397d328$export$a738614a0b6b3b5a)) height += this.objectValue.height;
        else if (this.objectValue instanceof (0, $0b4b1f60d7f75a26$export$6c765b7085f136fc)) {
            var webLink = this.objectValue;
            /* tslint:disable */ var slr = layouter.layout(webLink.text, webLink.font, webLink.stringFormat, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, 0), false, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0));
            /* tslint:enable */ height += slr.actualSize.height;
            height += (this.style.borders.top.width + this.style.borders.bottom.width) * 2;
        } else if (typeof this.objectValue === "undefined") {
            if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") width -= this.gridRow.grid.style.cellPadding.right + this.gridRow.grid.style.cellPadding.left;
            else {
                width -= this.style.cellPadding.right + this.style.cellPadding.left;
                width -= this.style.borders.left.width + this.style.borders.right.width;
            }
            height += (this.style.borders.top.width + this.style.borders.bottom.width) * 2;
        }
        //Add padding top and bottom value to height
        if (!(this.objectValue instanceof (0, $3e86d9e9de96833e$export$443e23810511d2c6))) {
            if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") height += this.row.grid.style.cellPadding.top + this.row.grid.style.cellPadding.bottom;
            else height += this.style.cellPadding.top + this.style.cellPadding.bottom;
        } else if (this.style.cellPadding == null || typeof this.style.cellPadding === "undefined") {
            if (typeof this.row.grid.style.cellPadding.top !== "undefined" && this.row.grid.style.cellPadding.hasTopPad) height += this.row.grid.style.cellPadding.top;
            if (typeof this.row.grid.style.cellPadding.bottom !== "undefined" && this.row.grid.style.cellPadding.hasBottomPad) height += this.row.grid.style.cellPadding.bottom;
        } else {
            if (typeof this.style.cellPadding.top !== "undefined" && this.style.cellPadding.hasTopPad) height += this.style.cellPadding.top;
            if (typeof this.style.cellPadding.bottom !== "undefined" && this.style.cellPadding.hasBottomPad) height += this.style.cellPadding.bottom;
        }
        height += this.row.grid.style.cellSpacing;
        return height;
    };
    /**
     * return the calculated `width` of the cell.
     * @private
     */ PdfGridCell.prototype.calculateWidth = function() {
        var cellIndex = this.row.cells.indexOf(this);
        var rowindex = this.row.grid.rows.rowCollection.indexOf(this.row);
        var columnSpan = this.columnSpan;
        var width = 0;
        if (columnSpan === 1) for(var i = 0; i < columnSpan; i++)width += this.row.grid.columns.getColumn(cellIndex + i).width;
        else if (columnSpan > 1) for(var i = 0; i < columnSpan; i++){
            width += this.row.grid.columns.getColumn(cellIndex + i).width;
            if (i + 1 < columnSpan) this.row.cells.getCell(cellIndex + i + 1).hasColSpan = true;
        }
        if (this.parent != null && this.parent.row.width > 0) {
            if (this.row.grid.isChildGrid && this.parent != null && this.row.width > this.parent.row.width) {
                width = 0;
                for(var j = 0; j < this.parent.columnSpan; j++)width += this.parent.row.grid.columns.getColumn(j).width;
                width = width / this.row.cells.count;
            }
        }
        return width;
    };
    return PdfGridCell;
}();
/**
 * `PdfGridCellCollection` class provides access to an ordered,
 * strongly typed collection of 'PdfGridCell' objects.
 * @private
 */ var $7c721536952b564d$export$a3887c5912fdd5e1 = /** @class */ function() {
    //Constructor
    /**
     * Initializes a new instance of the `PdfGridCellCollection` class with the row.
     * @private
     */ function PdfGridCellCollection(row) {
        /**
         * @hidden
         * @private
         */ this.cells = [];
        this.gridRow = row;
    }
    //Properties
    /**
     * Gets the current `cell`.
     * @private
     */ PdfGridCellCollection.prototype.getCell = function(index) {
        if (index < 0 || index >= this.count) throw new Error("IndexOutOfRangeException");
        return this.cells[index];
    };
    Object.defineProperty(PdfGridCellCollection.prototype, "count", {
        /**
         * Gets the cells `count`.[Read-Only].
         * @private
         */ get: function() {
            return this.cells.length;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridCellCollection.prototype.add = function(cell) {
        if (typeof cell === "undefined") {
            var tempcell = new $7c721536952b564d$export$7b661e766a1ad80();
            this.add(tempcell);
            return cell;
        } else {
            cell.row = this.gridRow;
            this.cells.push(cell);
        }
    };
    /**
     * Returns the `index of` a particular cell in the collection.
     * @private
     */ PdfGridCellCollection.prototype.indexOf = function(cell) {
        return this.cells.indexOf(cell);
    };
    return PdfGridCellCollection;
}();



/**
 * `PdfGridColumn` class represents the schema of a column in a 'PdfGrid'.
 */ var $8990c9951f86db9a$export$846fda65582732c4 = /** @class */ function() {
    //Constructors
    /**
     * Initializes a new instance of the `PdfGridColumn` class with the parent grid.
     * @private
     */ function PdfGridColumn(grid) {
        /**
         * The `width` of the column.
         * @default 0
         * @private
         */ this.columnWidth = 0;
        this.grid = grid;
    }
    Object.defineProperty(PdfGridColumn.prototype, "width", {
        /**
         * Gets or sets the `width` of the 'PdfGridColumn'.
         * @private
         */ get: function() {
            return this.columnWidth;
        },
        set: function(value) {
            this.isCustomWidth = true;
            this.columnWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridColumn.prototype, "format", {
        /**
         * Gets or sets the information about the text `formatting`.
         * @private
         */ get: function() {
            if (this.stringFormat == null) this.stringFormat = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)(); //GetDefaultFormat();
            return this.stringFormat;
        },
        set: function(value) {
            this.stringFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    return PdfGridColumn;
}();
/**
 * `PdfGridColumnCollection` class provides access to an ordered,
 * strongly typed collection of 'PdfGridColumn' objects.
 * @private
 */ var $8990c9951f86db9a$export$a9e64c7332173e74 = /** @class */ function() {
    //properties
    //Constructors
    /**
     * Initializes a new instance of the `PdfGridColumnCollection` class with the parent grid.
     * @private
     */ function PdfGridColumnCollection(grid) {
        /**
         * @hidden
         * @private
         */ this.internalColumns = [];
        /**
         * @hidden
         * @private
         */ this.columnWidth = 0;
        this.grid = grid;
        this.internalColumns = [];
    }
    //Iplementation
    /**
     * `Add` a new column to the 'PdfGrid'.
     * @private
     */ PdfGridColumnCollection.prototype.add = function(count) {
        // public add(column : PdfGridColumn) : void
        // public add(arg : number|PdfGridColumn) : void {
        // if (typeof arg === 'number') {
        for(var i = 0; i < count; i++){
            this.internalColumns.push(new $8990c9951f86db9a$export$846fda65582732c4(this.grid));
            for(var index = 0; index < this.grid.rows.count; index++){
                var row = this.grid.rows.getRow(index);
                var cell = new (0, $7c721536952b564d$export$7b661e766a1ad80)();
                cell.value = "";
                row.cells.add(cell);
            }
        }
    // } else {
    //     let column : PdfGridColumn = new PdfGridColumn(this.grid);
    //     this.columns.push(column);
    //     return column;
    // }
    };
    Object.defineProperty(PdfGridColumnCollection.prototype, "count", {
        /**
         * Gets the `number of columns` in the 'PdfGrid'.[Read-Only].
         * @private
         */ get: function() {
            return this.internalColumns.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridColumnCollection.prototype, "width", {
        /**
         * Gets the `widths`.
         * @private
         */ get: function() {
            if (this.columnWidth === 0) this.columnWidth = this.measureColumnsWidth();
            if (this.grid.initialWidth !== 0 && this.columnWidth !== this.grid.initialWidth && !this.grid.style.allowHorizontalOverflow) {
                this.columnWidth = this.grid.initialWidth;
                this.grid.isPageWidth = true;
            }
            return this.columnWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridColumnCollection.prototype, "columns", {
        /**
         * Gets the `array of PdfGridColumn`.[Read-Only]
         * @private
         */ get: function() {
            return this.internalColumns;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the `PdfGridColumn` from the specified index.[Read-Only]
     * @private
     */ PdfGridColumnCollection.prototype.getColumn = function(index) {
        if (index >= 0 && index <= this.columns.length) return this.columns[index];
        else throw Error("can not get the column from the index: " + index);
    };
    //Implementation
    /**
     * `Calculates the column widths`.
     * @private
     */ PdfGridColumnCollection.prototype.measureColumnsWidth = function() {
        var totalWidth = 0;
        this.grid.measureColumnsWidth();
        for(var i = 0, count = this.internalColumns.length; i < count; i++)totalWidth += this.internalColumns[i].width;
        return totalWidth;
    };
    /**
     * Gets the `widths of the columns`.
     * @private
     */ PdfGridColumnCollection.prototype.getDefaultWidths = function(totalWidth) {
        var widths = [];
        var summ = 0.0;
        var subFactor = this.count;
        for(var i = 0; i < this.count; i++)if (this.grid.isPageWidth && totalWidth >= 0 && !this.internalColumns[i].isCustomWidth) this.internalColumns[i].width = 0;
        else {
            widths[i] = this.internalColumns[i].width;
            if (this.internalColumns[i].width > 0 && this.internalColumns[i].isCustomWidth) {
                totalWidth -= this.internalColumns[i].width;
                subFactor--;
            } else widths[i] = 0;
        }
        for(var i = 0; i < this.count; i++){
            var width = totalWidth / subFactor;
            if (widths[i] <= 0) widths[i] = width;
        }
        return widths;
    };
    return PdfGridColumnCollection;
}();




/**
 * `PdfGridRow` class provides customization of the settings for the particular row.
 */ var $5bc9967a2f2c130e$export$9d7616a4f289f509 = /** @class */ function() {
    //Constructor
    /**
     * Initializes a new instance of the `PdfGridRow` class with the parent grid.
     * @private
     */ function PdfGridRow(grid) {
        /**
         * Stores the index of the overflowing row.
         * @private
         */ this.gridRowOverflowIndex = 0;
        /**
         * The `height` of the row.
         * @private
         */ this.rowHeight = 0;
        /**
         * The `width` of the row.
         * @private
         */ this.rowWidth = 0;
        /**
         * The `isFinish` of the row.
         * @private
         */ this.isrowFinish = false;
        /**
         * Check whether the Row span row height `is set explicitly`.
         * @default false
         * @public
         */ this.isRowSpanRowHeightSet = false;
        /**
         * The `page count` of the row.
         * @public
         */ this.noOfPageCount = 0;
        /**
         * Check whether the row height `is set explicitly`.
         * @default false
         * @private
         */ this.isRowHeightSet = false;
        this.isPageBreakRowSpanApplied = false;
        /**
         * Check weather the row merge `is completed` or not.
         * @default true
         * @private
         */ this.isRowMergeComplete = true;
        this.repeatFlag = false;
        this.rowFontSplit = false;
        this.isHeaderRow = false;
        this.pdfGrid = grid;
    }
    Object.defineProperty(PdfGridRow.prototype, "rowSpanExists", {
        //Properties
        /**
         * Gets or sets a value indicating [`row span exists`].
         * @private
         */ get: function() {
            return this.bRowSpanExists;
        },
        set: function(value) {
            this.bRowSpanExists = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "cells", {
        /**
         * Gets the `cells` from the selected row.[Read-Only].
         * @private
         */ get: function() {
            if (this.gridCells == null) this.gridCells = new (0, $7c721536952b564d$export$a3887c5912fdd5e1)(this);
            return this.gridCells;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "grid", {
        /**
         * Gets or sets the parent `grid`.
         * @private
         */ get: function() {
            return this.pdfGrid;
        },
        set: function(value) {
            this.pdfGrid = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "style", {
        /**
         * Gets or sets the row `style`.
         * @private
         */ get: function() {
            if (typeof this.rowStyle === "undefined") {
                this.rowStyle = new (0, $fa5fb82b29645b96$export$f5afdcc4564f8d68)();
                this.rowStyle.setParent(this);
            }
            return this.rowStyle;
        },
        set: function(value) {
            this.rowStyle = value;
            for(var i = 0; i < this.cells.count; i++){
                this.cells.getCell(i).style.borders = value.border;
                if (typeof value.font !== "undefined") this.cells.getCell(i).style.font = value.font;
                if (typeof value.backgroundBrush !== "undefined") this.cells.getCell(i).style.backgroundBrush = value.backgroundBrush;
                if (typeof value.backgroundImage !== "undefined") this.cells.getCell(i).style.backgroundImage = value.backgroundImage;
                if (typeof value.textBrush !== "undefined") this.cells.getCell(i).style.textBrush = value.textBrush;
                if (typeof value.textPen !== "undefined") this.cells.getCell(i).style.textPen = value.textPen;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "rowBreakHeight", {
        /**
         * `Height` of the row yet to be drawn after split.
         * @private
         */ get: function() {
            if (typeof this.gridRowBreakHeight === "undefined") this.gridRowBreakHeight = 0;
            return this.gridRowBreakHeight;
        },
        set: function(value) {
            this.gridRowBreakHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "rowOverflowIndex", {
        /**
         * `over flow index` of the row.
         * @private
         */ get: function() {
            return this.gridRowOverflowIndex;
        },
        set: function(value) {
            this.gridRowOverflowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "height", {
        /**
         * Gets or sets the `height` of the row.
         * @private
         */ get: function() {
            if (!this.isRowHeightSet) this.rowHeight = this.measureHeight();
            return this.rowHeight;
        },
        set: function(value) {
            this.rowHeight = value;
            this.isRowHeightSet = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "width", {
        /**
         * Gets or sets the `width` of the row.
         * @private
         */ get: function() {
            if (this.rowWidth === 0 || typeof this.rowWidth === "undefined") this.rowWidth = this.measureWidth();
            return this.rowWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "NestedGridLayoutResult", {
        /**
         * Gets or sets the row `Nested grid Layout Result`.
         * @private
         */ get: function() {
            return this.gridResult;
        },
        set: function(value) {
            this.gridResult = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "columnSpanExists", {
        /**
         * Gets or sets a value indicating [`column span exists`].
         * @private
         */ get: function() {
            return this.bColumnSpanExists;
        },
        set: function(value) {
            this.bColumnSpanExists = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "rowMergeComplete", {
        /**
         * Check whether the Row `has row span or row merge continue`.
         * @private
         */ get: function() {
            return this.isRowMergeComplete;
        },
        set: function(value) {
            this.isRowMergeComplete = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRow.prototype, "rowIndex", {
        /**
         * Returns `index` of the row.
         * @private
         */ get: function() {
            return this.grid.rows.rowCollection.indexOf(this);
        },
        enumerable: true,
        configurable: true
    });
    //Implementation
    /**
     * `Calculates the height`.
     * @private
     */ PdfGridRow.prototype.measureHeight = function() {
        var rowSpanRemainingHeight = 0;
        var rowHeight;
        var maxHeight = 0;
        if (this.cells.getCell(0).rowSpan > 1) rowHeight = 0;
        else rowHeight = this.cells.getCell(0).height;
        for(var i = 0; i < this.cells.count; i++){
            var cell = this.cells.getCell(i);
            //get the maximum rowspan remaining height.
            if (cell.rowSpanRemainingHeight > rowSpanRemainingHeight) rowSpanRemainingHeight = cell.rowSpanRemainingHeight;
            //skip the cell if row spanned.
            // if (cell.isRowMergeContinue) {
            //     continue;
            // }
            // if (!cell.isRowMergeContinue) {
            //     this.rowMergeComplete = false;
            // }
            this.rowMergeComplete = false;
            if (cell.rowSpan > 1) {
                var cellIn = i;
                var rowin = this.isHeaderRow ? this.grid.headers.indexOf(this) : this.grid.rows.rowCollection.indexOf(this);
                for(var j = 0; j < cell.rowSpan; j++)if (j + 1 < cell.rowSpan) (this.isHeaderRow ? this.grid.headers.getHeader(rowin + j + 1) : this.grid.rows.getRow(rowin + j + 1)).cells.getCell(cellIn).hasRowSpan = true;
                if (maxHeight < cell.height) maxHeight = cell.height;
                continue;
            }
            rowHeight = Math.max(rowHeight, cell.height);
        }
        if (maxHeight > rowHeight) rowHeight = maxHeight;
        if (rowHeight === 0) rowHeight = maxHeight;
        else if (rowSpanRemainingHeight > 0) rowHeight += rowSpanRemainingHeight;
        return rowHeight;
    };
    PdfGridRow.prototype.measureWidth = function() {
        var rowWid = 0;
        for(var i = 0; i < this.grid.columns.count; i++){
            var column = this.grid.columns.getColumn(i);
            rowWid += column.width;
        }
        return rowWid;
    };
    return PdfGridRow;
}();
/**
 * `PdfGridRowCollection` class provides access to an ordered, strongly typed collection of 'PdfGridRow' objects.
 * @private
 */ var $5bc9967a2f2c130e$export$ef84da574edc2de8 = /** @class */ function() {
    // Constructor
    /**
     * Initializes a new instance of the `PdfGridRowCollection` class with the parent grid.
     * @private
     */ function PdfGridRowCollection(grid) {
        this.rows = [];
        this.grid = grid;
    }
    Object.defineProperty(PdfGridRowCollection.prototype, "count", {
        //Properties
        /**
         * Gets the number of header in the `PdfGrid`.[Read-Only].
         * @private
         */ get: function() {
            return this.rows.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGridRowCollection.prototype, "rowCollection", {
        //Implementation
        /**
         * Return the row collection of the `grid`.
         * @private
         */ get: function() {
            return this.rows;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridRowCollection.prototype.addRow = function(arg) {
        if (typeof arg === "undefined") {
            var temprow = new $5bc9967a2f2c130e$export$9d7616a4f289f509(this.grid);
            this.addRow(temprow);
            return temprow;
        } else {
            arg.style.setBackgroundBrush(this.grid.style.backgroundBrush);
            arg.style.setFont(this.grid.style.font);
            arg.style.setTextBrush(this.grid.style.textBrush);
            arg.style.setTextPen(this.grid.style.textPen);
            if (arg.cells.count === 0) for(var i = 0; i < this.grid.columns.count; i++)arg.cells.add(new (0, $7c721536952b564d$export$7b661e766a1ad80)());
            this.rows.push(arg);
        }
    };
    /**
     * Return the row by index.
     * @private
     */ PdfGridRowCollection.prototype.getRow = function(index) {
        return this.rows[index];
    };
    return PdfGridRowCollection;
}();
/**
 * `PdfGridHeaderCollection` class provides customization of the settings for the header.
 * @private
 */ var $5bc9967a2f2c130e$export$7410fb160b4e7114 = /** @class */ function() {
    //constructor
    /**
     * Initializes a new instance of the `PdfGridHeaderCollection` class with the parent grid.
     * @private
     */ function PdfGridHeaderCollection(grid) {
        /**
         * The array to store the `rows` of the grid header.
         * @private
         */ this.rows = [];
        this.grid = grid;
        this.rows = [];
    }
    //Properties
    /**
     * Gets a 'PdfGridRow' object that represents the `header` row in a 'PdfGridHeaderCollection' control.[Read-Only].
     * @private
     */ PdfGridHeaderCollection.prototype.getHeader = function(index) {
        // if (index < 0 || index >= Count) {
        //     throw new IndexOutOfRangeException();
        // }
        return this.rows[index];
    };
    Object.defineProperty(PdfGridHeaderCollection.prototype, "count", {
        /**
         * Gets the `number of header` in the 'PdfGrid'.[Read-Only]
         * @private
         */ get: function() {
            return this.rows.length;
        },
        enumerable: true,
        configurable: true
    });
    PdfGridHeaderCollection.prototype.add = function(arg) {
        if (typeof arg === "number") {
            var row = void 0;
            for(var i = 0; i < arg; i++){
                row = new $5bc9967a2f2c130e$export$9d7616a4f289f509(this.grid);
                row.isHeaderRow = true;
                for(var j = 0; j < this.grid.columns.count; j++)row.cells.add(new (0, $7c721536952b564d$export$7b661e766a1ad80)());
                this.rows.push(row);
            }
            return this.rows;
        } else this.rows.push(arg);
    };
    PdfGridHeaderCollection.prototype.indexOf = function(row) {
        return this.rows.indexOf(row);
    };
    return PdfGridHeaderCollection;
}();








var $3e86d9e9de96833e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3e86d9e9de96833e$export$443e23810511d2c6 = /** @class */ function(_super) {
    $3e86d9e9de96833e$var$__extends(PdfGrid, _super);
    //constructor
    /**
     * Initialize a new instance for `PdfGrid` class.
     * @private
     */ function PdfGrid() {
        var _this = _super.call(this) || this;
        /**
         * @hidden
         * @private
         */ _this.gridSize = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(0, 0);
        /**
         * Check the child grid is ' split or not'
         */ _this.isGridSplit = false;
        /**
         * @hidden
         * @private
         */ _this.isRearranged = false;
        /**
         * @hidden
         * @private
         */ _this.pageBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)();
        /**
         * @hidden
         * @private
         */ _this.listOfNavigatePages = [];
        /**
         * @hidden
         * @private
         */ _this.parentCellIndex = 0;
        _this.tempWidth = 0;
        /**
         * @hidden
         * @private
         */ _this.breakRow = true;
        _this.splitChildRowIndex = -1;
        /**
         * The event raised on `begin cell lay outing`.
         * @event
         * @private
         */ //public beginPageLayout : Function;
        /**
         * The event raised on `end cell lay outing`.
         * @event
         * @private
         */ //public endPageLayout : Function;
        _this.hasRowSpanSpan = false;
        _this.hasColumnSpan = false;
        _this.isSingleGrid = true;
        return _this;
    }
    Object.defineProperty(PdfGrid.prototype, "raiseBeginCellDraw", {
        //Properties
        /**
         * Gets a value indicating whether the `start cell layout event` should be raised.
         * @private
         */ get: function() {
            return typeof this.beginCellDraw !== "undefined" && (this.beginCellDraw, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "raiseEndCellDraw", {
        /**
         * Gets a value indicating whether the `end cell layout event` should be raised.
         * @private
         */ get: function() {
            return typeof this.endCellDraw !== "undefined" && (this.endCellDraw, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "repeatHeader", {
        /**
         * Gets or sets a value indicating whether to `repeat header`.
         * @private
         */ get: function() {
            if (this.bRepeatHeader == null || typeof this.bRepeatHeader === "undefined") this.bRepeatHeader = false;
            return this.bRepeatHeader;
        },
        set: function(value) {
            this.bRepeatHeader = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "allowRowBreakAcrossPages", {
        /**
         * Gets or sets a value indicating whether to split or cut rows that `overflow a page`.
         * @private
         */ get: function() {
            return this.breakRow;
        },
        set: function(value) {
            this.breakRow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "columns", {
        /**
         * Gets the `column` collection of the PdfGrid.[Read-Only]
         * @private
         */ get: function() {
            if (this.gridColumns == null || typeof this.gridColumns === "undefined") this.gridColumns = new (0, $8990c9951f86db9a$export$a9e64c7332173e74)(this);
            return this.gridColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "rows", {
        /**
         * Gets the `row` collection from the PdfGrid.[Read-Only]
         * @private
         */ get: function() {
            if (this.gridRows == null) this.gridRows = new (0, $5bc9967a2f2c130e$export$ef84da574edc2de8)(this);
            return this.gridRows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "headers", {
        /**
         * Gets the `headers` collection from the PdfGrid.[Read-Only]
         * @private
         */ get: function() {
            if (this.gridHeaders == null || typeof this.gridHeaders === "undefined") this.gridHeaders = new (0, $5bc9967a2f2c130e$export$7410fb160b4e7114)(this);
            return this.gridHeaders;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "initialWidth", {
        /**
         * Indicating `initial width` of the page.
         * @private
         */ get: function() {
            return this.gridInitialWidth;
        },
        set: function(value) {
            this.gridInitialWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "style", {
        /**
         * Gets or sets the `grid style`.
         * @private
         */ get: function() {
            if (this.gridStyle == null) this.gridStyle = new (0, $fa5fb82b29645b96$export$62337a055adb3f1)();
            return this.gridStyle;
        },
        set: function(value) {
            if (this.gridStyle == null) this.gridStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "isPageWidth", {
        /**
         * Gets a value indicating whether the grid column width is considered to be `page width`.
         * @private
         */ get: function() {
            return this.ispageWidth;
        },
        set: function(value) {
            this.ispageWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "isChildGrid", {
        /**
         * Gets or set if grid `is nested grid`.
         * @private
         */ get: function() {
            return this.ischildGrid;
        },
        set: function(value) {
            this.ischildGrid = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "size", {
        /**
         * Gets or set if grid ' is split or not'
         * @public
         */ // public get isGridSplit() : boolean {
        //     return this.isgridSplit;
        // }
        // public set isGridSplit(value : boolean) {
        //     this.isgridSplit = value;
        // }public get isGridSplit() : boolean {
        //     return this.isgridSplit;
        // }
        // public set isGridSplit(value : boolean) {
        //     this.isgridSplit = value;
        // }
        /**
         * Gets the `size`.
         * @private
         */ get: function() {
            if ((this.gridSize.width === 0 || typeof this.gridSize.width === "undefined") && this.gridSize.height === 0) this.gridSize = this.measure();
            return this.gridSize;
        // } else {
        //     return this.gridSize;
        // }
        },
        set: function(value) {
            this.gridSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "ParentCell", {
        get: function() {
            return this.parentCell;
        },
        set: function(value) {
            this.parentCell = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfGrid.prototype, "LayoutFormat", {
        get: function() {
            return this.layoutFormat;
        },
        enumerable: true,
        configurable: true
    });
    PdfGrid.prototype.draw = function(arg1, arg2, arg3, arg4) {
        if (arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg2.width === "undefined" && typeof arg3 === "undefined") return this.drawHelper(arg1, arg2.x, arg2.y);
        else if (typeof arg2 === "number" && typeof arg3 === "number" && typeof arg4 === "undefined") return this.drawHelper(arg1, arg2, arg3, null);
        else if (arg2 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg2.width !== "undefined" && typeof arg3 === "undefined") return this.drawHelper(arg1, arg2, null);
        else if (arg2 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && typeof arg2.width === "undefined" && arg3 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6)) return this.drawHelper(arg1, arg2.x, arg2.y, arg3);
        else if (typeof arg2 === "number" && typeof arg3 === "number" && (arg4 instanceof (0, $67f37859b2b467ca$export$b25c3374095e50f6) || arg4 == null)) {
            var width = arg1.graphics.clientSize.width - arg2;
            var layoutRectangle = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(arg2, arg3, width, 0);
            return this.drawHelper(arg1, layoutRectangle, arg4);
        } else if (arg2 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg2.width !== "undefined" && typeof arg3 === "boolean") return this.drawHelper(arg1, arg2, null);
        else return this.drawHelper(arg1, arg2, arg3);
    };
    /**
     * `measures` this instance.
     * @private
     */ PdfGrid.prototype.measure = function() {
        var height = 0;
        var width = this.columns.width;
        for(var i = 0; i < this.headers.count; i++){
            var row = this.headers.getHeader(i);
            height += row.height;
        }
        for(var i = 0; i < this.rows.count; i++){
            var row = this.rows.getRow(i);
            height += row.height;
        }
        return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, height);
    };
    PdfGrid.prototype.onBeginCellDraw = function(args) {
        if (this.raiseBeginCellDraw) this.beginCellDraw(this, args);
    };
    PdfGrid.prototype.onEndCellDraw = function(args) {
        if (this.raiseEndCellDraw) this.endCellDraw(this, args);
    };
    /**
     * `Layouts` the specified graphics.
     * @private
     */ PdfGrid.prototype.layout = function(param) {
        var width = param.bounds.width;
        var height = param.bounds.height;
        var hasChanged = false;
        if (typeof param.bounds.width === "undefined" || param.bounds.width === 0) {
            width = param.page.getClientSize().width - param.bounds.x;
            hasChanged = true;
        }
        if (typeof param.bounds.height === "undefined" || param.bounds.height === 0) {
            height = param.page.getClientSize().height - param.bounds.y;
            hasChanged = true;
        }
        if (hasChanged) param.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(param.bounds.x, param.bounds.y, width, height);
        if (this.rows.count !== 0) {
            var currentRow = this.rows.getRow(0).cells.getCell(0).style;
            if (currentRow.borders != null && (currentRow.borders.left != null && currentRow.borders.left.width !== 1 || currentRow.borders.top != null && currentRow.borders.top.width !== 1)) {
                var x = currentRow.borders.left.width / 2;
                var y = currentRow.borders.top.width / 2;
                if (param.bounds.x === (0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2 && param.bounds.y === (0, $446c769ec2cda75b$export$69818a9b64460535).default.right.width / 2) {
                    var newBound = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, this.gridSize.width, this.gridSize.height);
                    param.bounds = newBound;
                }
            }
        }
        this.setSpan();
        this.checkSpan();
        this.layoutFormat = param.format;
        this.gridLocation = param.bounds;
        var layouter = new (0, $7f829739b2688b0e$export$11c2bcbc14388afe)(this);
        var result = layouter.Layouter(param);
        return result;
    };
    PdfGrid.prototype.setSpan = function() {
        var colSpan = 1;
        var rowSpan = 1;
        var currentCellIndex = 0;
        var currentRowIndex = 0;
        var maxSpan = 0;
        var rowCount = this.headers.count;
        for(var i = 0; i < rowCount; i++){
            var row = this.headers.getHeader(i);
            maxSpan = 0;
            var colCount = row.cells.count;
            for(var j = 0; j < colCount; j++){
                var cell = row.cells.getCell(j);
                maxSpan = Math.max(maxSpan, cell.rowSpan);
                //Skip setting span map for already coverted rows/columns.
                if (!cell.isCellMergeContinue && !cell.isRowMergeContinue && (cell.columnSpan > 1 || cell.rowSpan > 1)) {
                    if (cell.columnSpan + j > row.cells.count) throw new Error("Invalid span specified at row " + j.toString() + " column " + i.toString());
                    if (cell.rowSpan + i > this.headers.count) throw new Error("Invalid span specified at Header " + j.toString() + " column " + i.toString());
                    // if (this.rows.count !== 0 && cell.rowSpan + i > this.rows.count) {
                    //     throw new Error('Invalid span specified at row ' + j.toString() + ' column ' + i.toString());
                    // }
                    if (cell.columnSpan > 1 && cell.rowSpan > 1) {
                        colSpan = cell.columnSpan;
                        rowSpan = cell.rowSpan;
                        currentCellIndex = j;
                        currentRowIndex = i;
                        cell.isCellMergeStart = true;
                        cell.isRowMergeStart = true;
                        //Set Column merges for first row
                        while(colSpan > 1){
                            currentCellIndex++;
                            row.cells.getCell(currentCellIndex).isCellMergeContinue = true;
                            row.cells.getCell(currentCellIndex).isRowMergeContinue = true;
                            row.cells.getCell(currentCellIndex).rowSpan = rowSpan;
                            colSpan--;
                        }
                        currentCellIndex = j;
                        colSpan = cell.columnSpan;
                        //Set Row Merges and column merges foreach subsequent rows.
                        while(rowSpan > 1){
                            currentRowIndex++;
                            this.headers.getHeader(currentRowIndex).cells.getCell(j).isRowMergeContinue = true;
                            this.headers.getHeader(currentRowIndex).cells.getCell(currentCellIndex).isRowMergeContinue = true;
                            rowSpan--;
                            while(colSpan > 1){
                                currentCellIndex++;
                                this.headers.getHeader(currentRowIndex).cells.getCell(currentCellIndex).isCellMergeContinue = true;
                                this.headers.getHeader(currentRowIndex).cells.getCell(currentCellIndex).isRowMergeContinue = true;
                                colSpan--;
                            }
                            colSpan = cell.columnSpan;
                            currentCellIndex = j;
                        }
                    } else if (cell.columnSpan > 1 && cell.rowSpan === 1) {
                        colSpan = cell.columnSpan;
                        currentCellIndex = j;
                        cell.isCellMergeStart = true;
                        //Set Column merges.
                        while(colSpan > 1){
                            currentCellIndex++;
                            row.cells.getCell(currentCellIndex).isCellMergeContinue = true;
                            colSpan--;
                        }
                    } else if (cell.columnSpan === 1 && cell.rowSpan > 1) {
                        rowSpan = cell.rowSpan;
                        currentRowIndex = i;
                        //Set row Merges.
                        while(rowSpan > 1){
                            currentRowIndex++;
                            this.headers.getHeader(currentRowIndex).cells.getCell(j).isRowMergeContinue = true;
                            rowSpan--;
                        }
                    }
                }
            }
            row.maximumRowSpan = maxSpan;
        }
    };
    PdfGrid.prototype.checkSpan = function() {
        var cellcolSpan;
        var cellrowSpan = 1;
        var cellmaxSpan = 0;
        var currentCellIndex;
        var currentRowIndex = 0;
        cellcolSpan = cellrowSpan = 1;
        currentCellIndex = currentRowIndex = 0;
        if (this.hasRowSpanSpan || this.hasColumnSpan) {
            var rowCount = this.rows.count;
            for(var i = 0; i < rowCount; i++){
                var row = this.rows.getRow(i);
                cellmaxSpan = 0;
                var colCount = row.cells.count;
                for(var j = 0; j < colCount; j++){
                    var cell = row.cells.getCell(j);
                    cellmaxSpan = Math.max(cellmaxSpan, cell.rowSpan);
                    //Skip setting span map for already coverted rows/columns.
                    if (!cell.isCellMergeContinue && !cell.isRowMergeContinue && (cell.columnSpan > 1 || cell.rowSpan > 1)) {
                        if (cell.columnSpan + j > row.cells.count) throw new Error("Invalid span specified at row  " + j.toString() + " column " + i.toString());
                        if (cell.rowSpan + i > this.rows.count) throw new Error("Invalid span specified at row  " + j.toString() + " column " + i.toString());
                        if (cell.columnSpan > 1 && cell.rowSpan > 1) {
                            cellcolSpan = cell.columnSpan;
                            cellrowSpan = cell.rowSpan;
                            currentCellIndex = j;
                            currentRowIndex = i;
                            cell.isCellMergeStart = true;
                            cell.isRowMergeStart = true;
                            //Set Column merges for first row
                            while(cellcolSpan > 1){
                                currentCellIndex++;
                                row.cells.getCell(currentCellIndex).isCellMergeContinue = true;
                                row.cells.getCell(currentCellIndex).isRowMergeContinue = true;
                                cellcolSpan--;
                            }
                            currentCellIndex = j;
                            cellcolSpan = cell.columnSpan;
                            //Set Row Merges and column merges foreach subsequent rows.
                            while(cellrowSpan > 1){
                                currentRowIndex++;
                                this.rows.getRow(currentRowIndex).cells.getCell(j).isRowMergeContinue = true;
                                this.rows.getRow(currentRowIndex).cells.getCell(currentCellIndex).isRowMergeContinue = true;
                                cellrowSpan--;
                                while(cellcolSpan > 1){
                                    currentCellIndex++;
                                    this.rows.getRow(currentRowIndex).cells.getCell(currentCellIndex).isCellMergeContinue = true;
                                    this.rows.getRow(currentRowIndex).cells.getCell(currentCellIndex).isRowMergeContinue = true;
                                    cellcolSpan--;
                                }
                                cellcolSpan = cell.columnSpan;
                                currentCellIndex = j;
                            }
                        } else if (cell.columnSpan > 1 && cell.rowSpan === 1) {
                            cellcolSpan = cell.columnSpan;
                            currentCellIndex = j;
                            cell.isCellMergeStart = true;
                            //Set Column merges.
                            while(cellcolSpan > 1){
                                currentCellIndex++;
                                row.cells.getCell(currentCellIndex).isCellMergeContinue = true;
                                cellcolSpan--;
                            }
                        } else if (cell.columnSpan === 1 && cell.rowSpan > 1) {
                            cellrowSpan = cell.rowSpan;
                            currentRowIndex = i;
                            //Set row Merges.
                            while(cellrowSpan > 1){
                                currentRowIndex++;
                                this.rows.getRow(currentRowIndex).cells.getCell(j).isRowMergeContinue = true;
                                cellrowSpan--;
                            }
                        }
                    }
                }
                row.maximumRowSpan = cellmaxSpan;
            }
        }
    };
    PdfGrid.prototype.measureColumnsWidth = function(bounds) {
        if (typeof bounds !== "undefined") {
            this.isPageWidth = false;
            var widths = this.columns.getDefaultWidths(bounds.width - bounds.x);
            //let tempWidth : number = this.columns.getColumn(0).width;
            for(var i = 0, count = this.columns.count; i < count; i++){
                // if (this.columns.getColumn(i).width < 0)
                //     this.columns.getColumn(i).columnWidth = widths[i];
                // else if (this.columns.getColumn(i).width > 0 && !this.columns.getColumn(i).isCustomWidth && widths[i]>0 && this.isComplete)
                this.columns.getColumn(i).columnWidth = widths[i];
                this.tempWidth = widths[i];
            }
            if (this.ParentCell != null && this.style.allowHorizontalOverflow == false && this.ParentCell.row.grid.style.allowHorizontalOverflow == false) {
                var padding = 0;
                var columnWidth = 0;
                var columnCount = this.columns.count;
                var childGridColumnWidth = 0;
                if (this.ParentCell.style.cellPadding != null || typeof this.ParentCell.style.cellPadding !== "undefined") {
                    if (typeof this.ParentCell.style.cellPadding.left != "undefined" && this.ParentCell.style.cellPadding.hasLeftPad) padding += this.ParentCell.style.cellPadding.left;
                    if (typeof this.ParentCell.style.cellPadding.right != "undefined" && this.ParentCell.style.cellPadding.hasRightPad) padding += this.ParentCell.style.cellPadding.right;
                }
                for(var i = 0; i < this.ParentCell.columnSpan; i++)columnWidth += this.ParentCell.row.grid.columns.getColumn(this.parentCellIndex + i).width;
                for(var j = 0; j < this.columns.count; j++)if (this.gridColumns.getColumn(j).width > 0 && this.gridColumns.getColumn(j).isCustomWidth) {
                    columnWidth -= this.gridColumns.getColumn(j).width;
                    columnCount--;
                }
                if (this.ParentCell.row.grid.style.cellPadding != null || typeof this.ParentCell.row.grid.style.cellPadding != "undefined") {
                    if (typeof this.ParentCell.row.grid.style.cellPadding.top != "undefined" && this.ParentCell.row.grid.style.cellPadding.hasTopPad) padding += this.ParentCell.row.grid.style.cellPadding.top;
                    if (typeof this.ParentCell.row.grid.style.cellPadding.bottom != "undefined" && this.ParentCell.row.grid.style.cellPadding.hasBottomPad) padding += this.ParentCell.row.grid.style.cellPadding.bottom;
                }
                if (this.ParentCell.row.grid.style.cellSpacing != 0) columnWidth -= this.ParentCell.row.grid.style.cellSpacing * 2;
                if (columnWidth > padding) {
                    childGridColumnWidth = (columnWidth - padding) / columnCount;
                    this.tempWidth = childGridColumnWidth;
                    if (this.ParentCell != null) {
                        for(var j = 0; j < this.columns.count; j++)if (!this.columns.getColumn(j).isCustomWidth) this.columns.getColumn(j).columnWidth = childGridColumnWidth;
                    }
                }
            }
        // if (this.ParentCell != null && this.ParentCell.row.width > 0)
        // {
        //     if (this.isChildGrid && this.gridSize.width > this.ParentCell.row.width)
        //     {
        //         widths = this.columns.getDefaultWidths(bounds.width);
        //         for (let i : number = 0; i < this.columns.count; i++)
        //         {
        //             this.columns.getColumn(i).width = widths[i];
        //         }
        //     }
        // }
        } else {
            var widths = [
                this.columns.count
            ];
            for(var n = 0; n < this.columns.count; n++)widths[n] = 0;
            var cellWidth = 0;
            var cellWidths = 0;
            if (typeof this.isChildGrid === "undefined" && typeof this.gridLocation !== "undefined" || this.isChildGrid === null && typeof this.gridLocation !== "undefined") this.initialWidth = this.gridLocation.width;
            if (this.headers.count > 0) {
                var colCount_1 = this.headers.getHeader(0).cells.count;
                var rowCount = this.headers.count;
                for(var i = 0; i < colCount_1; i++){
                    cellWidth = 0;
                    for(var j = 0; j < rowCount; j++){
                        var rowWidth = Math.min(this.initialWidth, this.headers.getHeader(j).cells.getCell(i).width);
                        cellWidth = Math.max(cellWidth, rowWidth);
                    }
                    widths[i] = cellWidth;
                }
            }
            // else {
            //     let colCount : number = this.rows.getRow(0).cells.count;
            //     let rowCount : number = this.rows.count;
            //     for (let i : number = 0; i < colCount; i++) {
            //         cellWidth = 0;
            //         for (let j : number = 0; j < rowCount; j++) {
            //             let rowWidth : number = Math.min(this.initialWidth, this.rows.getRow(j).cells.getCell(i).width);
            //             cellWidth = Math.max(cellWidth, rowWidth);
            //         }
            //         widths[i] = cellWidth;
            //     }
            // }
            cellWidth = 0;
            for(var i = 0, colCount_2 = this.columns.count; i < colCount_2; i++){
                for(var j = 0, rowCount = this.rows.count; j < rowCount; j++)if (this.rows.getRow(j).cells.getCell(i).columnSpan == 1 && !this.rows.getRow(j).cells.getCell(i).isCellMergeContinue || this.rows.getRow(j).cells.getCell(i).value != null) {
                    if (this.rows.getRow(j).cells.getCell(i).value != null && !this.rows.getRow(j).grid.style.allowHorizontalOverflow) var value = this.rows.getRow(j).grid.style.cellPadding.right + this.rows.getRow(j).grid.style.cellPadding.left + this.rows.getRow(j).cells.getCell(i).style.borders.left.width / 2;
                    var rowWidth = 0;
                    rowWidth = this.initialWidth > 0.0 ? Math.min(this.initialWidth, this.rows.getRow(j).cells.getCell(i).width) : this.rows.getRow(j).cells.getCell(i).width;
                    // let internalWidth : number = this.rows.getRow(j).cells.getCell(i).width;
                    // internalWidth += this.rows.getRow(j).cells.getCell(i).style.borders.left.width;
                    // internalWidth += this.rows.getRow(j).cells.getCell(i).style.borders.right.width;
                    // let internalHeight : number = this.rows.getRow(j).cells.getCell(i).height;
                    // internalHeight += (this.rows.getRow(j).cells.getCell(i).style.borders.top.width);
                    // internalHeight += (this.rows.getRow(j).cells.getCell(i).style.borders.bottom.width);
                    // let isCorrectWidth : boolean = (internalWidth + this.gridLocation.x) > this.currentGraphics.clientSize.width;
                    // let isCorrectHeight : boolean = (internalHeight + this.gridLocation.y) > this.currentGraphics.clientSize.height;
                    // if (isCorrectWidth || isCorrectHeight) {
                    //     throw Error('Image size exceeds client size of the page. Can not insert this image');
                    // }
                    // rowWidth = Math.min(this.initialWidth, this.rows.getRow(j).cells.getCell(i).width);
                    cellWidth = Math.max(widths[i], Math.max(cellWidth, rowWidth));
                    cellWidth = Math.max(this.columns.getColumn(i).width, cellWidth);
                }
                if (this.rows.count != 0) widths[i] = cellWidth;
                cellWidth = 0;
            }
            for(var i = 0, RowCount = this.rows.count; i < RowCount; i++){
                for(var j = 0, ColCount = this.columns.count; j < ColCount; j++)if (this.rows.getRow(i).cells.getCell(j).columnSpan > 1) {
                    var total = widths[j];
                    for(var k = 1; k < this.rows.getRow(i).cells.getCell(j).columnSpan; k++)total += widths[j + k];
                // if (this.rows.getRow(i).cells.getCell(j).width > total)
                // {
                //     let extendedWidth : number = this.rows.getRow(i).cells.getCell(j).width - total;
                //     extendedWidth = extendedWidth / this.rows.getRow(i).cells.getCell(j).columnSpan;
                //     for (let k : number = j; k < j + this.rows.getRow(i).cells.getCell(j).columnSpan; k++)
                //         widths[k] += extendedWidth;
                // }
                }
            }
            // if (this.isChildGrid && this.initialWidth != 0)
            // {
            //     widths = this.columns.getDefaultWidths(this.initialWidth);
            // }
            for(var i = 0, count = this.columns.count; i < count; i++){
                if (this.columns.getColumn(i).width <= 0) this.columns.getColumn(i).columnWidth = widths[i];
                else if (this.columns.getColumn(i).width > 0 && !this.columns.getColumn(i).isCustomWidth) this.columns.getColumn(i).columnWidth = widths[i];
            }
            var padding = 0;
            var colWidth = 0;
            var colCount = this.columns.count;
            var childGridColWidth = 0;
            colWidth = this.tempWidth;
            for(var j = 0; j < this.columns.count; j++)if (this.gridColumns.getColumn(j).width > 0 && this.gridColumns.getColumn(j).isCustomWidth) {
                colWidth -= this.gridColumns.getColumn(j).width;
                colCount--;
            }
            // if (this.style.cellSpacing != 0){
            //     colWidth -= this.style.cellSpacing * 2;
            // }
            if (colWidth > 0) {
                if (this.ParentCell.row.grid.style.cellSpacing != 0) colWidth -= this.ParentCell.row.grid.style.cellSpacing * 2;
            }
            if (colWidth > padding) {
                childGridColWidth = colWidth / colCount;
                if (this.ParentCell != null) {
                    for(var j = 0; j < this.columns.count; j++)if (!this.columns.getColumn(j).isCustomWidth) this.columns.getColumn(j).columnWidth = childGridColWidth;
                }
            }
        }
    };
    return PdfGrid;
}((0, $0b3d5296901e666e$export$1a83e429ff9500b6));






var $f28a95f7fa1280c8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents automatic field which has the same value in the whole document.
 */ var $f28a95f7fa1280c8$export$6f3e33510f9f307 = /** @class */ function(_super) {
    $f28a95f7fa1280c8$var$__extends(PdfSingleValueField, _super);
    // Constructors
    function PdfSingleValueField() {
        var _this = _super.call(this) || this;
        // Fields
        /* tslint:disable */ _this.list = new (0, $d2671c6eb1e201ae$export$be68aa8ea4d1b1bb)();
        /* tslint:enable */ _this.painterGraphics = [];
        return _this;
    }
    PdfSingleValueField.prototype.performDraw = function(graphics, location, scalingX, scalingY) {
        _super.prototype.performDrawHelper.call(this, graphics, location, scalingX, scalingY);
        var page = this.getPageFromGraphics(graphics);
        var document = page.document;
        var textValue = this.getValue(graphics);
        /* tslint:disable */ if (this.list.containsKey(document)) {
            var pair = this.list.getValue(document);
            var drawLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(location.x + this.location.x, location.y + this.location.y);
            graphics.drawPdfTemplate(pair.template, drawLocation, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(pair.template.width * scalingX, pair.template.height * scalingY));
            this.painterGraphics.push(graphics);
        } else {
            var size = this.getSize();
            var template = new (0, $094796745e9b29a1$export$cbb9d62db9e1cba0)(size);
            this.list.setValue(document, new (0, $266741a02586c222$export$c7b15b8ace1d9a7a)(template, textValue));
            template.graphics.drawString(textValue, this.getFont(), this.pen, this.getBrush(), 0, 0, size.width, size.height, this.stringFormat);
            var drawLocation = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(location.x + this.location.x, location.y + this.location.y);
            graphics.drawPdfTemplate(template, drawLocation, new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(template.width * scalingX, template.height * scalingY));
            this.painterGraphics.push(graphics);
        }
    /* tslint:enable */ };
    return PdfSingleValueField;
}((0, $d05c5b0034846734$export$801607a04494f8a2));




/**
 * PdfNumbersConvertor.ts class for EJ2-PDF
 * @private
 */ 
/**
 * `PdfNumbersConvertor` for convert page number into numbers, roman letters, etc.,
 * @private
 */ var $241638cbaa0402b4$export$fa33df295c947ab5 = /** @class */ function() {
    function PdfNumbersConvertor() {}
    // Static methods
    /**
     * Convert string value from page number with correct format.
     * @private
     */ PdfNumbersConvertor.convert = function(intArabic, numberStyle) {
        var result = "";
        switch(numberStyle){
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).None:
                result = "";
                break;
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).Numeric:
                result = intArabic.toString();
                break;
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).LowerLatin:
                result = this.arabicToLetter(intArabic).toLowerCase();
                break;
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).LowerRoman:
                result = this.arabicToRoman(intArabic).toLowerCase();
                break;
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).UpperLatin:
                result = this.arabicToLetter(intArabic);
                break;
            case (0, $98f82adf1cbc5a19$export$67251fd30ad77).UpperRoman:
                result = this.arabicToRoman(intArabic);
                break;
        }
        return result;
    };
    /**
     * Converts `arabic to roman` letters.
     * @private
     */ PdfNumbersConvertor.arabicToRoman = function(intArabic) {
        var retval = "";
        var retvalM = this.generateNumber(intArabic, 1000, "M");
        retval += retvalM.returnValue;
        intArabic = retvalM.intArabic;
        var retvalCM = this.generateNumber(intArabic, 900, "CM");
        retval += retvalCM.returnValue;
        intArabic = retvalCM.intArabic;
        var retvalD = this.generateNumber(intArabic, 500, "D");
        retval += retvalD.returnValue;
        intArabic = retvalD.intArabic;
        var retvalCD = this.generateNumber(intArabic, 400, "CD");
        retval += retvalCD.returnValue;
        intArabic = retvalCD.intArabic;
        var retvalC = this.generateNumber(intArabic, 100, "C");
        retval += retvalC.returnValue;
        intArabic = retvalC.intArabic;
        var retvalXC = this.generateNumber(intArabic, 90, "XC");
        retval += retvalXC.returnValue;
        intArabic = retvalXC.intArabic;
        var retvalL = this.generateNumber(intArabic, 50, "L");
        retval += retvalL.returnValue;
        intArabic = retvalL.intArabic;
        var retvalXL = this.generateNumber(intArabic, 40, "XL");
        retval += retvalXL.returnValue;
        intArabic = retvalXL.intArabic;
        var retvalX = this.generateNumber(intArabic, 10, "X");
        retval += retvalX.returnValue;
        intArabic = retvalX.intArabic;
        var retvalIX = this.generateNumber(intArabic, 9, "IX");
        retval += retvalIX.returnValue;
        intArabic = retvalIX.intArabic;
        var retvalV = this.generateNumber(intArabic, 5, "V");
        retval += retvalV.returnValue;
        intArabic = retvalV.intArabic;
        var retvalIV = this.generateNumber(intArabic, 4, "IV");
        retval += retvalIV.returnValue;
        intArabic = retvalIV.intArabic;
        var retvalI = this.generateNumber(intArabic, 1, "I");
        retval += retvalI.returnValue;
        intArabic = retvalI.intArabic;
        return retval.toString();
    };
    /**
     * Converts `arabic to normal letters`.
     * @private
     */ PdfNumbersConvertor.arabicToLetter = function(arabic) {
        var stack = this.convertToLetter(arabic);
        var result = "";
        while(stack.length > 0){
            var num = stack.pop();
            result = this.appendChar(result, num);
        }
        return result.toString();
    };
    /**
     * Generate a string value of an input number.
     * @private
     */ PdfNumbersConvertor.generateNumber = function(value, magnitude, letter) {
        var numberstring = "";
        while(value >= magnitude){
            value -= magnitude;
            numberstring += letter;
        }
        return {
            returnValue: numberstring.toString(),
            intArabic: value
        };
    };
    /**
     * Convert a input number into letters.
     * @private
     */ PdfNumbersConvertor.convertToLetter = function(arabic) {
        if (arabic <= 0) throw Error("ArgumentOutOfRangeException-arabic, Value can not be less 0");
        var stack = [];
        while(arabic > this.letterLimit){
            var remainder = arabic % this.letterLimit;
            if (remainder === 0.0) {
                arabic = arabic / this.letterLimit - 1;
                remainder = this.letterLimit;
            } else arabic /= this.letterLimit;
            stack.push(remainder);
        }
        stack.push(arabic);
        return stack;
    };
    /**
     * Convert number to actual string value.
     * @private
     */ PdfNumbersConvertor.appendChar = function(builder, value) {
        var letter = String.fromCharCode(PdfNumbersConvertor.acsiiStartIndex + value);
        builder += letter;
        return builder;
    };
    // Fields
    /**
     * numbers of letters in english [readonly].
     * @default = 26.0
     * @private
     */ PdfNumbersConvertor.letterLimit = 26.0;
    /**
     * Resturns `acsii start index` value.
     * @default 64
     * @private
     */ PdfNumbersConvertor.acsiiStartIndex = 64;
    return PdfNumbersConvertor;
}();


var $b261dcdfbb93158a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents total PDF document page count automatic field.
 */ var $b261dcdfbb93158a$export$87a596dd5a6e103c = /** @class */ function(_super) {
    $b261dcdfbb93158a$var$__extends(PdfPageCountField, _super);
    function PdfPageCountField(font, arg2) {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Stores the number style of the field.
         * @private
         */ _this.internalNumberStyle = (0, $98f82adf1cbc5a19$export$67251fd30ad77).Numeric;
        if (typeof arg2 === "undefined") _this.font = font;
        else if (arg2 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5)) {
            _this.font = font;
            _this.brush = arg2;
        } else {
            _this.font = font;
            _this.bounds = arg2;
        }
        return _this;
    }
    Object.defineProperty(PdfPageCountField.prototype, "numberStyle", {
        // Properties
        /**
         * Gets and sets the number style of the field.
         * @public
         */ get: function() {
            return this.internalNumberStyle;
        },
        set: function(value) {
            this.internalNumberStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    // Implementation
    /**
     * Return the actual value of the content to drawn.
     * @public
     */ PdfPageCountField.prototype.getValue = function(graphics) {
        var result = null;
        var page = this.getPageFromGraphics(graphics);
        var document = page.section.parent.document;
        var count = document.pages.count;
        result = (0, $241638cbaa0402b4$export$fa33df295c947ab5).convert(count, this.numberStyle);
        return result;
    };
    return PdfPageCountField;
}((0, $f28a95f7fa1280c8$export$6f3e33510f9f307));





var $dc16533f34d49c75$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Represents PDF document `page number field`.
 * @public
 */ var $dc16533f34d49c75$export$a7b17fe3dad27965 = /** @class */ function(_super) {
    $dc16533f34d49c75$var$__extends(PdfPageNumberField, _super);
    function PdfPageNumberField(font, arg2) {
        var _this = _super.call(this) || this;
        // Fields
        /**
         * Stores the number style of the page number field.
         * @private
         */ _this.internalNumberStyle = (0, $98f82adf1cbc5a19$export$67251fd30ad77).Numeric;
        if (typeof arg2 === "undefined") _this.font = font;
        else if (arg2 instanceof (0, $7e20ae7ea9857864$export$e91b732cd7775ec5)) {
            _this.font = font;
            _this.brush = arg2;
        } else {
            _this.font = font;
            _this.bounds = arg2;
        }
        return _this;
    }
    Object.defineProperty(PdfPageNumberField.prototype, "numberStyle", {
        // Properties
        /**
         * Gets and sets the number style of the page number field.
         * @private
         */ get: function() {
            return this.internalNumberStyle;
        },
        set: function(value) {
            this.internalNumberStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Return the `string` value of page number field.
     * @public
     */ PdfPageNumberField.prototype.getValue = function(graphics) {
        var result = null;
        var page = this.getPageFromGraphics(graphics);
        result = this.internalGetValue(page);
        return result;
    };
    /**
     * Internal method to `get actual value of page number`.
     * @private
     */ PdfPageNumberField.prototype.internalGetValue = function(page) {
        var document = page.document;
        var pageIndex = document.pages.indexOf(page) + 1;
        return (0, $241638cbaa0402b4$export$fa33df295c947ab5).convert(pageIndex, this.numberStyle);
    };
    return PdfPageNumberField;
}((0, $779bc41d0b2d2595$export$e4d54284f720f6d5));

/**
 * PdfPageTemplateElement.ts class for EJ2-Pdf
 */ 



/**
 * Describes a `page template` object that can be used as header/footer, watermark or stamp.
 */ var $c33f2752f598011d$export$6ed0b78de60eb5b0 = /** @class */ function() {
    /* tslint:disable */ function PdfPageTemplateElement(arg1, arg2, arg3, arg4, arg5) {
        if (arg1 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && typeof arg2 === "undefined") this.InitiateBounds(arg1.x, arg1.y, arg1.width, arg1.height, null);
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$6543fe32ba958b02) && arg2 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08) && typeof arg3 === "undefined") this.InitiateBounds(arg1.x, arg1.y, arg1.width, arg1.height, arg2);
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && arg2 instanceof (0, $e1df9a3657e111f3$export$81f866bb912d8821) && typeof arg3 === "undefined") this.InitiateBounds(arg1.x, arg1.y, arg2.width, arg2.height, null);
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$a878d5fce7d721a5) && arg2 instanceof (0, $e1df9a3657e111f3$export$81f866bb912d8821) && arg3 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08) && typeof arg4 === "undefined") this.InitiateBounds(arg1.x, arg1.y, arg2.width, arg2.height, arg3);
        else if (arg1 instanceof (0, $e1df9a3657e111f3$export$81f866bb912d8821) && typeof arg2 === "undefined") this.InitiateBounds(0, 0, arg1.width, arg1.height, null);
        else if (typeof arg1 === "number" && typeof arg2 === "number" && typeof arg3 === "undefined") this.InitiateBounds(0, 0, arg1, arg2, null);
        else if (typeof arg1 === "number" && typeof arg2 === "number" && arg3 instanceof (0, $b3834a1b559693d8$export$1686f89eb33d2b08) && typeof arg4 === "undefined") this.InitiateBounds(0, 0, arg1, arg2, arg3);
        else if (typeof arg1 === "number" && typeof arg2 === "number" && typeof arg3 === "number" && typeof arg4 === "number" && typeof arg5 === "undefined") this.InitiateBounds(arg1, arg2, arg3, arg4, null);
        else this.InitiateBounds(arg1, arg2, arg3, arg4, null);
    /* tslint:enable */ }
    Object.defineProperty(PdfPageTemplateElement.prototype, "dock", {
        // Properties
        /**
         * Gets or sets the `dock style` of the page template element.
         * @private
         */ get: function() {
            return this.dockStyle;
        },
        set: function(value) {
            // if (this.dockStyle !== value && this.Type === TemplateType.None) {
            this.dockStyle = value;
            // Reset alignment.
            this.resetAlignment();
        // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "alignment", {
        /**
         * Gets or sets `alignment` of the page template element.
         * @private
         */ get: function() {
            return this.alignmentStyle;
        },
        set: function(value) {
            // if (this.alignmentStyle !== value) {
            this.setAlignment(value);
        // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "foreground", {
        /**
         * Indicates whether the page template is located `in front of the page layers or behind of it`.
         * @private
         */ get: function() {
            return this.isForeground;
        },
        set: function(value) {
            // if (this.foreground !== value) {
            this.isForeground = value;
        // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "background", {
        /**
         * Indicates whether the page template is located `behind of the page layers or in front of it`.
         * @private
         */ get: function() {
            return !this.isForeground;
        },
        set: function(value) {
            this.isForeground = !value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "location", {
        /**
         * Gets or sets `location` of the page template element.
         * @private
         */ get: function() {
            return this.currentLocation;
        },
        set: function(value) {
            if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) this.currentLocation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "x", {
        /**
         * Gets or sets `X` co-ordinate of the template element on the page.
         * @private
         */ get: function() {
            var value = typeof this.currentLocation !== "undefined" ? this.currentLocation.x : 0;
            return value;
        },
        set: function(value) {
            if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) this.currentLocation.x = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "y", {
        /**
         * Gets or sets `Y` co-ordinate of the template element on the page.
         * @private
         */ get: function() {
            var value = typeof this.currentLocation !== "undefined" ? this.currentLocation.y : 0;
            return value;
        },
        set: function(value) {
            if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) this.currentLocation.y = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "size", {
        /**
         * Gets or sets `size` of the page template element.
         * @private
         */ get: function() {
            return this.template.size;
        },
        set: function(value) {
            if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) this.template.reset(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "width", {
        /**
         * Gets or sets `width` of the page template element.
         * @private
         */ get: function() {
            return this.template.width;
        },
        set: function(value) {
            if (this.template.width !== value && this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) {
                var size = this.template.size;
                size.width = value;
                this.template.reset(size);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "height", {
        /**
         * Gets or sets `height` of the page template element.
         * @private
         */ get: function() {
            return this.template.height;
        },
        set: function(value) {
            if (this.template.height !== value && this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) {
                var size = this.template.size;
                size.height = value;
                this.template.reset(size);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "graphics", {
        /**
         * Gets `graphics` context of the page template element.
         * @private
         */ get: function() {
            return this.template.graphics;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "template", {
        /**
         * Gets Pdf `template` object.
         * @private
         */ get: function() {
            // if (typeof this.pdfTemplate === 'undefined' || this.pdfTemplate == null) {
            //     this.pdfTemplate = new PdfTemplate(this.size);
            // }
            return this.pdfTemplate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "type", {
        /**
         * Gets or sets `type` of the usage of this page template.
         * @private
         */ get: function() {
            return this.templateType;
        },
        set: function(value) {
            this.updateDocking(value);
            this.templateType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfPageTemplateElement.prototype, "bounds", {
        /**
         * Gets or sets `bounds` of the page template.
         * @public
         */ get: function() {
            return new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(this.x, this.y), this.size);
        },
        set: function(value) {
            if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) {
                this.location = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(value.x, value.y);
                this.size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(value.width, value.height);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * `Initialize Bounds` Initialize the bounds value of the template.
     * @private
     */ PdfPageTemplateElement.prototype.InitiateBounds = function(arg1, arg2, arg3, arg4, arg5) {
        this.x = arg1;
        this.y = arg2;
        this.pdfTemplate = new (0, $094796745e9b29a1$export$cbb9d62db9e1cba0)(arg3, arg4);
    // this.graphics.colorSpace = this.page.document.colorSpace;
    };
    /**
     * `Updates Dock` property if template is used as header/footer.
     * @private
     */ PdfPageTemplateElement.prototype.updateDocking = function(type) {
        if (type !== (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) {
            switch(type){
                case (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top:
                    this.dock = (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Top;
                    break;
                case (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom:
                    this.dock = (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Bottom;
                    break;
                case (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left:
                    this.dock = (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Left;
                    break;
                case (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right:
                    this.dock = (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Right;
                    break;
            }
            this.resetAlignment();
        }
    };
    /**
     * `Resets alignment` of the template.
     * @private
     */ PdfPageTemplateElement.prototype.resetAlignment = function() {
        this.alignment = (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
    };
    /**
     * `Sets alignment` of the template.
     * @private
     */ PdfPageTemplateElement.prototype.setAlignment = function(alignment) {
        if (this.dock === (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).None) this.alignmentStyle = alignment;
        else {
            // Template is docked and alignment has been changed.
            var canBeSet = false;
            switch(this.dock){
                case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Left:
                    canBeSet = alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopLeft || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleLeft || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomLeft || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
                    break;
                case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Top:
                    canBeSet = alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopLeft || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopCenter || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopRight || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
                    break;
                case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Right:
                    canBeSet = alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopRight || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleRight || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomRight || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
                    break;
                case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Bottom:
                    canBeSet = alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomLeft || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomCenter || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomRight || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
                    break;
                case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Fill:
                    canBeSet = alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleCenter || alignment === (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None;
                    break;
            }
            if (canBeSet) this.alignmentStyle = alignment;
        }
    };
    /**
     * Draws the template.
     * @private
     */ PdfPageTemplateElement.prototype.draw = function(layer, document) {
        var page = layer.page;
        var bounds = this.calculateBounds(page, document);
        layer.graphics.drawPdfTemplate(this.template, new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(bounds.x, bounds.y), new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(bounds.width, bounds.height));
    };
    /**
     * Calculates bounds of the page template.
     * @private
     */ PdfPageTemplateElement.prototype.calculateBounds = function(page, document) {
        var result = this.bounds;
        if (this.alignmentStyle !== (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).None) result = this.getAlignmentBounds(page, document);
        else if (this.dockStyle !== (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).None) result = this.getDockBounds(page, document);
        return result;
    };
    /**
     * Calculates bounds according to the alignment.
     * @private
     */ PdfPageTemplateElement.prototype.getAlignmentBounds = function(page, document) {
        var result = this.bounds;
        if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) result = this.getSimpleAlignmentBounds(page, document);
        else result = this.getTemplateAlignmentBounds(page, document);
        return result;
    };
    /**
     * Calculates bounds according to the alignment.
     * @private
     */ PdfPageTemplateElement.prototype.getSimpleAlignmentBounds = function(page, document) {
        var bounds = this.bounds;
        var pdfSection = page.section;
        var actualBounds = pdfSection.getActualBounds(document, page, false);
        var x = this.x;
        var y = this.y;
        switch(this.alignmentStyle){
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopLeft:
                x = 0;
                y = 0;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopCenter:
                x = (actualBounds.width - this.width) / 2;
                y = 0;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopRight:
                x = actualBounds.width - this.width;
                y = 0;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleLeft:
                x = 0;
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleCenter:
                x = (actualBounds.width - this.width) / 2;
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleRight:
                x = actualBounds.width - this.width;
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomLeft:
                x = 0;
                y = actualBounds.height - this.height;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomCenter:
                x = (actualBounds.width - this.width) / 2;
                y = actualBounds.height - this.height;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomRight:
                x = actualBounds.width - this.width;
                y = actualBounds.height - this.height;
                break;
        }
        bounds.x = x;
        bounds.y = y;
        return bounds;
    };
    /**
     * Calculates bounds according to the alignment.
     * @private
     */ PdfPageTemplateElement.prototype.getTemplateAlignmentBounds = function(page, document) {
        var result = this.bounds;
        var section = page.section;
        var actualBounds = section.getActualBounds(document, page, false);
        var x = this.x;
        var y = this.y;
        switch(this.alignmentStyle){
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopLeft:
                if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left) {
                    x = this.convertSign(actualBounds.x);
                    y = 0;
                } else if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top) {
                    x = this.convertSign(actualBounds.x);
                    y = this.convertSign(actualBounds.y);
                }
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopCenter:
                x = (actualBounds.width - this.width) / 2;
                y = this.convertSign(actualBounds.y);
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).TopRight:
                if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right) {
                    x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                    y = 0;
                } else if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Top) {
                    x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                    y = this.convertSign(actualBounds.y);
                }
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleLeft:
                x = this.convertSign(actualBounds.x);
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleCenter:
                x = (actualBounds.width - this.width) / 2;
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).MiddleRight:
                x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                y = (actualBounds.height - this.height) / 2;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomLeft:
                if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Left) {
                    x = this.convertSign(actualBounds.x);
                    y = actualBounds.height - this.height;
                } else if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom) {
                    x = this.convertSign(actualBounds.x);
                    y = actualBounds.height + section.getBottomIndentHeight(document, page, false) - this.height;
                }
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomCenter:
                x = (actualBounds.width - this.width) / 2;
                y = actualBounds.height + section.getBottomIndentHeight(document, page, false) - this.height;
                break;
            case (0, $98f82adf1cbc5a19$export$1899d10b8f4f2e5a).BottomRight:
                if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Right) {
                    x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                    y = actualBounds.height - this.height;
                } else if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).Bottom) {
                    x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                    y = actualBounds.height + section.getBottomIndentHeight(document, page, false) - this.height;
                }
                break;
        }
        result.x = x;
        result.y = y;
        return result;
    };
    /**
     * Calculates bounds according to the docking.
     * @private
     */ PdfPageTemplateElement.prototype.getDockBounds = function(page, document) {
        var result = this.bounds;
        if (this.type === (0, $98f82adf1cbc5a19$export$fd0446c06165ed92).None) result = this.getSimpleDockBounds(page, document);
        else result = this.getTemplateDockBounds(page, document);
        return result;
    };
    /**
     * Calculates bounds according to the docking.
     * @private
     */ PdfPageTemplateElement.prototype.getSimpleDockBounds = function(page, document) {
        var result = this.bounds;
        var section = page.section;
        var actualBounds = section.getActualBounds(document, page, false);
        var x = this.x;
        var y = this.y;
        var width = this.width;
        var height = this.height;
        switch(this.dockStyle){
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Left:
                x = 0;
                y = 0;
                width = this.width;
                height = actualBounds.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Top:
                x = 0;
                y = 0;
                width = actualBounds.width;
                height = this.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Right:
                x = actualBounds.width - this.width;
                y = 0;
                width = this.width;
                height = actualBounds.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Bottom:
                x = 0;
                y = actualBounds.height - this.height;
                width = actualBounds.width;
                height = this.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Fill:
                x = 0;
                x = 0;
                width = actualBounds.width;
                height = actualBounds.height;
                break;
        }
        result = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, width, height);
        return result;
    };
    /**
     * Calculates template bounds basing on docking if template is a page template.
     * @private
     */ PdfPageTemplateElement.prototype.getTemplateDockBounds = function(page, document) {
        var result = this.bounds;
        var section = page.section;
        var actualBounds = section.getActualBounds(document, page, false);
        var actualSize = section.pageSettings.getActualSize();
        var x = this.x;
        var y = this.y;
        var width = this.width;
        var height = this.height;
        switch(this.dockStyle){
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Left:
                x = this.convertSign(actualBounds.x);
                y = 0;
                width = this.width;
                height = actualBounds.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Top:
                x = this.convertSign(actualBounds.x);
                y = this.convertSign(actualBounds.y);
                width = actualSize.width;
                height = this.height;
                if (actualBounds.height < 0) y = actualSize.height - actualBounds.y;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Right:
                x = actualBounds.width + section.getRightIndentWidth(document, page, false) - this.width;
                y = 0;
                width = this.width;
                height = actualBounds.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Bottom:
                x = this.convertSign(actualBounds.x);
                y = actualBounds.height + section.getBottomIndentHeight(document, page, false) - this.height;
                width = actualSize.width;
                height = this.height;
                if (actualBounds.height < 0) y -= actualSize.height;
                break;
            case (0, $98f82adf1cbc5a19$export$d7cd715375e0be52).Fill:
                x = 0;
                x = 0;
                width = actualBounds.width;
                height = actualBounds.height;
                break;
        }
        result = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, width, height);
        return result;
    };
    /**
     * Ignore value zero, otherwise convert sign.
     * @private
     */ PdfPageTemplateElement.prototype.convertSign = function(value) {
        return value !== 0 || value === 0 && 1 / value === -Infinity ? -value : value;
    };
    return PdfPageTemplateElement;
}();







var $643b7e3e735d4d72$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
//https://www.giftofspeed.com/base64-encoder/
var $643b7e3e735d4d72$export$bee362ba4c0720b4 = /** @class */ function(_super) {
    $643b7e3e735d4d72$var$__extends(PdfTrueTypeFont, _super);
    function PdfTrueTypeFont(base64String, size, style) {
        var _this = _super.call(this, size) || this;
        /**
         * Indicates whether the font is embedded or not.
         * @private
         */ _this.isEmbedFont = false;
        /**
         * Indicates whether the font is unicoded or not.
         * @private
         */ _this.isUnicode = true;
        if (style !== undefined) _this.createFontInternal(base64String, style);
        else _this.createFontInternal(base64String, (0, $32129651824bb502$export$80979869bc40ff1f).Regular);
        return _this;
    }
    PdfTrueTypeFont.prototype.equalsToFont = function(font) {
        var result = false;
        //let result : boolean = this.fontInternal.equalsToFont(font);
        return result;
    };
    PdfTrueTypeFont.prototype.getLineWidth = function(line, format) {
        var width = 0;
        if (format !== null && typeof format !== "undefined" && format.textDirection !== (0, $d174213b46afc09a$export$96fe374e3268ced4).None) {
            var returnValue = this.getUnicodeLineWidth(line, /*out*/ width, format);
            width = returnValue.width;
        } else width = this.fontInternal.getLineWidth(line);
        var size = this.metrics.getSize(format);
        width *= (0, $ec27d251b6edcb44$export$60d73556588f648b).charSizeMultiplier * size;
        width = this.applyFormatSettings(line, format, width);
        return width;
    };
    /**
     * Returns width of the char.
     */ PdfTrueTypeFont.prototype.getCharWidth = function(charCode, format) {
        var codeWidth = this.fontInternal.getCharWidth(charCode);
        var size = this.metrics.getSize(format);
        codeWidth *= 0.001 * size;
        return codeWidth;
    };
    //Implementation
    PdfTrueTypeFont.prototype.createFontInternal = function(base64String, style) {
        this.fontInternal = new (0, $13da76851e74b0e2$export$c62c39062f746216)(base64String, this.size);
        this.calculateStyle(style);
        this.initializeInternals();
    };
    PdfTrueTypeFont.prototype.calculateStyle = function(style) {
        var iStyle = this.fontInternal.ttfMetrics.macStyle;
        if ((style & (0, $32129651824bb502$export$80979869bc40ff1f).Underline) !== 0) iStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Underline;
        if ((style & (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout) !== 0) iStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout;
        this.setStyle(iStyle);
    };
    PdfTrueTypeFont.prototype.initializeInternals = function() {
        var equalFont = null;
        if ((0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).enableCache) // Search for the similar fonts.
        equalFont = (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e).cache.search(this);
        var internals = null;
        // There is not equal font in the cache.
        if (equalFont !== null && equalFont !== undefined) {
            // Get the settings from the cached font.
            internals = equalFont.getInternals();
            var metrics = equalFont.metrics;
            metrics = metrics.clone();
            metrics.size = this.size;
            this.metrics = metrics;
            this.fontInternal = equalFont.fontInternal;
        } else if (equalFont == null) {
            if (this.fontInternal instanceof (0, $13da76851e74b0e2$export$c62c39062f746216)) this.fontInternal.isEmbed = this.isEmbedFont;
            this.fontInternal.createInternals();
            internals = this.fontInternal.getInternals();
            this.metrics = this.fontInternal.metrics;
        }
        this.metrics.isUnicodeFont = true;
        this.setInternals(internals);
    //this.ttfReader = (this.fontInternal as UnicodeTrueTypeFont).ttfReader;
    };
    /**
     * Stores used symbols.
     */ PdfTrueTypeFont.prototype.setSymbols = function(text) {
        var internalFont = this.fontInternal;
        if (internalFont != null) internalFont.setSymbols(text);
    };
    Object.defineProperty(PdfTrueTypeFont.prototype, "Unicode", {
        /**
         * Property
         *
         */ get: function() {
            return this.isUnicode;
        },
        enumerable: true,
        configurable: true
    });
    // public get Font() : UnicodeTrueTypeFont {
    //     return this.fontInternal as UnicodeTrueTypeFont;
    // }
    PdfTrueTypeFont.prototype.getUnicodeLineWidth = function(line, /*out*/ width, format) {
        // if (line == null) {
        //     throw new Error('ArgumentNullException : line');
        // }
        width = 0;
        var glyphIndices = null;
        var rtlRender = new (0, $6d1b729459efb672$export$f23a0a3175647431)();
        /* tslint:disable-next-line:max-line-length */ var result = rtlRender.getGlyphIndex(line, this, format.textDirection === (0, $d174213b46afc09a$export$96fe374e3268ced4).RightToLeft ? true : false, /*out*/ glyphIndices, true);
        var resultGlyph = result.success;
        glyphIndices = result.glyphs;
        if (resultGlyph && glyphIndices !== null) {
            var ttfReader = this.fontInternal.ttfReader;
            for(var i = 0, len = glyphIndices.length; i < len; i++){
                var glyphIndex = glyphIndices[i];
                var glyph = ttfReader.getGlyph(glyphIndex);
                if (glyph !== null && typeof glyph !== "undefined") width += glyph.width;
            }
        }
        return {
            success: resultGlyph,
            width: width
        };
    };
    return PdfTrueTypeFont;
}((0, $ec27d251b6edcb44$export$60d73556588f648b));





parcelRequire("j7YE8");
var $c2qqN = parcelRequire("c2qqN");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



/**
 * `PDF Export` module is used to handle the exportToPDF action.
 *
 * @hidden
 */ var $b844ce8ad16ed721$export$425bf53802e2b731 = /** @class */ function() {
    /**
     * Constructor for the Grid PDF Export module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */ function PdfExport(parent) {
        this.hideColumnInclude = false;
        this.currentViewData = false;
        this.customDataSource = false;
        this.isGrouping = false;
        this.headerOnPages = [];
        this.drawPosition = {
            xPosition: 0,
            yPosition: 0
        };
        this.parent = parent;
        this.helper = new (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872)(parent);
        this.gridPool = {};
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     */ PdfExport.prototype.getModuleName = function() {
        return "PdfExport";
    };
    PdfExport.prototype.init = function(parent) {
        this.exportValueFormatter = new (0, $4c91757c13b9ef0b$export$83adc223acd57528)(parent.locale);
        this.pdfDocument = undefined;
        this.hideColumnInclude = false;
        this.currentViewData = false;
        this.parent = parent;
        this.isGrouping = false;
        this.isExporting = true;
        parent.id = (0, $748c2240e597a9b7$export$5e82334337e0f204)("main-grid");
        this.gridPool[parent.id] = false;
        this.pdfPageSettings = new (0, $38437f6299029180$export$b29d0b05f007ad1b)();
    };
    PdfExport.prototype.exportWithData = function(parent, pdfDoc, resolve, returnType, pdfExportProperties, isMultipleExport, reject) {
        var _this = this;
        this.init(parent);
        if (!(0, $3EnZW.isNullOrUndefined)(pdfDoc)) this.pdfDocument = pdfDoc;
        else this.pdfDocument = new (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e)();
        this.processExport(parent, returnType, pdfExportProperties, isMultipleExport).then(function() {
            _this.isExporting = false;
            parent.trigger($17b89d3b1fc93cdb$export$7a8d89800dc1933f, _this.isBlob ? {
                promise: _this.blobPromise
            } : {
                gridInstance: _this.parent
            });
            _this.parent.log("exporting_complete", _this.getModuleName());
            resolve(_this.pdfDocument);
        }).catch(function(e) {
            reject(_this.pdfDocument);
            _this.parent.trigger($17b89d3b1fc93cdb$export$6df5a05f342711e3, e);
        });
    };
    /**
     * Used to map the input data
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {PdfExportProperties} pdfExportProperties - specifies the PdfExportProperties
     * @param {boolean} isMultipleExport - specifies the isMultipleExport
     * @param {Object} pdfDoc - specifies the pdfDoc
     * @param {boolean} isBlob - speciies whether it is Blob or not
     * @returns {void}
     */ PdfExport.prototype.Map = function(parent, pdfExportProperties, isMultipleExport, pdfDoc, isBlob) {
        var _this = this;
        this.data = new (0, $2c6cbc1793f29e30$export$2d0294657ab35f1b)(this.parent);
        this.isBlob = isBlob;
        this.gridPool = {};
        var query = pdfExportProperties && pdfExportProperties.query ? pdfExportProperties.query : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        if ((parent.childGrid || parent.detailTemplate) && !(!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && pdfExportProperties.hierarchyExportMode === "None")) parent.expandedRows = (0, $748c2240e597a9b7$export$854231c97a3cacb6)(parent).expandedRows;
        var args = {
            requestType: "beforePdfExport",
            cancel: false,
            headerPageNumbers: [],
            gridDrawPosition: {
                xPosition: 0,
                yPosition: 0
            },
            generateQuery: false
        };
        var gridObject = "gridObject";
        args["" + gridObject] = parent;
        var can = "cancel";
        var generateQuery = "generateQuery";
        var header = "headerPageNumbers";
        var drawPos = "gridDrawPosition";
        parent.trigger($17b89d3b1fc93cdb$export$f9f9dd98810deee, args);
        if (args["" + can] === true) // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return new Promise(function(resolve, reject) {
            return resolve();
        });
        if ((0, $748c2240e597a9b7$export$54b64ba4d3ca13b3)(pdfExportProperties)) (0, $748c2240e597a9b7$export$e25aefb92a91af83)(pdfExportProperties, parent);
        if (args["" + generateQuery]) query = (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872).getQuery(parent, this.data);
        this.headerOnPages = args["" + header];
        this.drawPosition = args["" + drawPos];
        this.parent.log("exporting_begin", this.getModuleName());
        if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.dataSource)) {
            pdfExportProperties.dataSource = pdfExportProperties.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) ? pdfExportProperties.dataSource : new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(pdfExportProperties.dataSource);
            if ((0, $3EnZW.isNullOrUndefined)(query.isCountRequired) || parent.aggregates) query.isCountRequired = true;
            return new Promise(function(resolve, reject) {
                pdfExportProperties.dataSource.executeQuery(query).then(function(returnType) {
                    _this.exportWithData(parent, pdfDoc, resolve, returnType, pdfExportProperties, isMultipleExport, reject);
                });
            });
        } else if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && pdfExportProperties.exportType === "CurrentPage" && !(this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && !this.parent.getDataModule().isRemote())) return new Promise(function(resolve, reject) {
            _this.exportWithData(parent, pdfDoc, resolve, _this.parent.getCurrentViewRecords(), pdfExportProperties, isMultipleExport, reject);
        });
        else {
            var allPromise_1 = [];
            var query_1 = (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872).getQuery(parent, this.data);
            if (this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && !this.parent.getDataModule().isRemote()) {
                if ((0, $3EnZW.isNullOrUndefined)(pdfExportProperties)) pdfExportProperties = {
                    hierarchyExportMode: "All"
                };
                pdfExportProperties.hierarchyExportMode = pdfExportProperties.hierarchyExportMode === "None" ? "None" : "All";
                if (pdfExportProperties.hierarchyExportMode === "All") query_1.lazyLoad = [];
            }
            allPromise_1.push(this.data.getData({}, query_1));
            allPromise_1.push(this.helper.getColumnData(parent));
            return new Promise(function(resolve, reject) {
                Promise.all(allPromise_1).then(function(e) {
                    _this.init(parent);
                    if (!(0, $3EnZW.isNullOrUndefined)(pdfDoc)) _this.pdfDocument = pdfDoc["document"];
                    else _this.pdfDocument = new (0, $9492e318cdd65a97$export$d46c104bc6d5cb7e)();
                    _this.processExport(parent, e[0], pdfExportProperties, isMultipleExport, pdfDoc).then(function(results) {
                        _this.isExporting = false;
                        parent.trigger($17b89d3b1fc93cdb$export$7a8d89800dc1933f, _this.isBlob ? {
                            promise: _this.blobPromise
                        } : {
                            gridInstance: _this.parent
                        });
                        _this.parent.log("exporting_complete", _this.getModuleName());
                        if (pdfExportProperties && pdfExportProperties.multipleExport && pdfExportProperties.multipleExport.type === "AppendToPage") resolve(results);
                        else resolve(_this.pdfDocument);
                    }).catch(function(e) {
                        reject(_this.pdfDocument);
                        _this.parent.trigger($17b89d3b1fc93cdb$export$6df5a05f342711e3, e);
                    });
                });
            });
        }
    };
    PdfExport.prototype.processExport = function(gObj, returnType, pdfExportProperties, isMultipleExport, pdfDoc) {
        var _this = this;
        var section = !(pdfDoc && pdfExportProperties && pdfExportProperties.multipleExport && pdfExportProperties.multipleExport.type === "AppendToPage") ? this.pdfDocument.sections.add() : null;
        var pdfGrid;
        this.processSectionExportProperties(section, pdfExportProperties);
        var pdfPage = pdfDoc && pdfExportProperties && pdfExportProperties.multipleExport && pdfExportProperties.multipleExport.type === "AppendToPage" ? pdfDoc["result"].page : section.pages.add();
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return new Promise(function(resolve, reject) {
            pdfGrid = _this.processGridExport(gObj, returnType, pdfExportProperties);
            _this.globalResolve = resolve;
            _this.gridPool[gObj.id] = true;
            _this.helper.checkAndExport(_this.gridPool, _this.globalResolve);
        }).then(function() {
            // draw the grid
            var xPosition = _this.drawPosition["xPosition"];
            var yPosition;
            if (pdfDoc && pdfExportProperties && pdfExportProperties.multipleExport && pdfExportProperties.multipleExport.type === "AppendToPage") {
                yPosition = pdfDoc["result"].bounds.y + pdfDoc["result"].bounds.height;
                if (pdfExportProperties.multipleExport.blankSpace) yPosition = pdfDoc["result"].bounds.y + pdfDoc["result"].bounds.height + pdfExportProperties.multipleExport.blankSpace;
            } else yPosition = _this.drawPosition["yPosition"];
            var result;
            if (isMultipleExport) {
                var layoutFormat = new (0, $7f829739b2688b0e$export$5dfae482b3795fa8)();
                layoutFormat.layout = (0, $5ffc34ffc68e39dd$export$3652975898b34cce).Paginate;
                layoutFormat.break = (0, $5ffc34ffc68e39dd$export$f886812f74e09fd0).FitPage;
                //Set pagination bounds of PDF grid
                layoutFormat.paginateBounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(0, 0, pdfPage.getClientSize().width, pdfPage.getClientSize().height);
                result = pdfGrid.draw(pdfPage, xPosition, yPosition, layoutFormat);
            } else result = pdfGrid.draw(pdfPage, xPosition, yPosition);
            _this.drawHeader(pdfExportProperties);
            if (!isMultipleExport) {
                // save the PDF
                if (!_this.isBlob) {
                    if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && pdfExportProperties.fileName) _this.pdfDocument.save(pdfExportProperties.fileName);
                    else _this.pdfDocument.save("Export.pdf");
                } else _this.blobPromise = _this.pdfDocument.save();
                _this.pdfDocument.destroy();
                delete gObj.expandedRows;
            }
            if (pdfExportProperties && pdfExportProperties.multipleExport && pdfExportProperties.multipleExport.type === "AppendToPage") return {
                document: _this.pdfDocument,
                result: result
            };
            else return _this.pdfDocument;
        });
    };
    PdfExport.prototype.processSectionExportProperties = function(section, pdfExportProperties) {
        if (!(0, $3EnZW.isNullOrUndefined)(section) && !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.pageOrientation) || !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.pageSize))) {
            this.pdfPageSettings.orientation = pdfExportProperties.pageOrientation === "Landscape" ? (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Landscape : (0, $98f82adf1cbc5a19$export$242e5fa5b02fc46).Portrait;
            this.pdfPageSettings.size = this.getPageSize(pdfExportProperties.pageSize);
            section.setPageSettings(this.pdfPageSettings);
        }
        return section;
    };
    PdfExport.prototype.processGridExport = function(gObj, returnType, pdfExportProperties) {
        var allowHorizontalOverflow = true;
        if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties)) {
            this.gridTheme = pdfExportProperties.theme;
            allowHorizontalOverflow = (0, $3EnZW.isNullOrUndefined)(pdfExportProperties.allowHorizontalOverflow) ? true : pdfExportProperties.allowHorizontalOverflow;
        }
        var helper = new (0, $4c91757c13b9ef0b$export$5c1397e8a9aad872)(gObj, this.helper.getForeignKeyData());
        var dataSource = this.processExportProperties(pdfExportProperties, returnType.result);
        var columns = (0, $748c2240e597a9b7$export$54b64ba4d3ca13b3)(pdfExportProperties) ? (0, $748c2240e597a9b7$export$1147582dfae658c6)(pdfExportProperties.columns, gObj.enableColumnVirtualization) : helper.getGridExportColumns(gObj.columns);
        columns = columns.filter(function(columns) {
            return (0, $3EnZW.isNullOrUndefined)(columns.commands);
        });
        var isGrouping = false;
        if (gObj.groupSettings.columns.length) isGrouping = true;
        if ((gObj.childGrid || gObj.detailTemplate) && !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties)) gObj.hierarchyPrintMode = pdfExportProperties.hierarchyExportMode || "Expanded";
        // create a grid
        var pdfGrid = new (0, $3e86d9e9de96833e$export$443e23810511d2c6)();
        // get header theme style
        var headerThemeStyle = this.getHeaderThemeStyle();
        var border = headerThemeStyle.border;
        var headerFont = headerThemeStyle.font;
        var headerBrush = headerThemeStyle.brush;
        var returnValue = helper.getHeaders(columns, this.hideColumnInclude);
        // Column collection with respect to the records in the grid
        var gridColumns = returnValue.columns;
        // process grid header content
        pdfGrid = this.processGridHeaders(gObj.groupSettings.columns.length, pdfGrid, returnValue.rows, gridColumns, border, headerFont, headerBrush, gObj, allowHorizontalOverflow, columns);
        // set alignment, width and type of the values of the column
        this.setColumnProperties(gridColumns, pdfGrid, helper, gObj, allowHorizontalOverflow);
        var captionThemeStyle = this.getSummaryCaptionThemeStyle();
        if (!(0, $3EnZW.isNullOrUndefined)(dataSource) && dataSource.length) {
            if (isGrouping) {
                if (!(0, $3EnZW.isNullOrUndefined)(captionThemeStyle.border)) border = captionThemeStyle.border;
                this.processGroupedRecords(pdfGrid, dataSource, gridColumns, gObj, border, 0, captionThemeStyle.font, captionThemeStyle.brush, captionThemeStyle.backgroundBrush, returnType, pdfExportProperties, helper, 0);
            } else this.processRecord(border, gridColumns, gObj, dataSource, pdfGrid, 0, pdfExportProperties, helper, 0);
            if (!(0, $3EnZW.isNullOrUndefined)(returnType.aggregates)) {
                var summaryModel = new (0, $add3e338055b95e6$export$5d9b1dac619ba2d8)(gObj);
                var sRows = void 0;
                var column = summaryModel.getColumns();
                column = column.filter(function(col) {
                    return (0, $3EnZW.isNullOrUndefined)(col.commands) && col.type !== "checkbox";
                });
                if (gObj.aggregates.length && this.parent !== gObj) gObj.aggregateModule.prepareSummaryInfo();
                if (this.customDataSource) sRows = summaryModel.generateRows(dataSource, returnType.aggregates, null, null, column);
                else if (this.currentViewData) sRows = summaryModel.generateRows(this.parent.getCurrentViewRecords(), returnType.aggregates);
                else if (isGrouping) sRows = summaryModel.generateRows(dataSource.records, returnType.aggregates);
                else sRows = summaryModel.generateRows(returnType.result, returnType.aggregates, null, null, column);
                this.processAggregates(sRows, pdfGrid, border, captionThemeStyle.font, captionThemeStyle.brush, captionThemeStyle.backgroundBrush, false, null, null, null, isGrouping ? false : true);
            }
        } else {
            var row = pdfGrid.rows.addRow();
            row.style.setBorder(border);
        }
        return pdfGrid;
    };
    PdfExport.prototype.getSummaryCaptionThemeStyle = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme) && !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.caption)) {
            var fontSize = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.caption.fontSize) ? this.gridTheme.caption.fontSize : 9.75;
            var fontFamily = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.caption.fontName) ? this.getFontFamily(this.gridTheme.caption.fontName) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
            var fontStyle = this.getFontStyle(this.gridTheme.caption);
            var pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0);
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.caption.fontColor)) {
                var penBrushColor = this.hexToRgb(this.gridTheme.caption.fontColor);
                pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(penBrushColor.r, penBrushColor.g, penBrushColor.b);
            }
            var borderCaption = this.gridTheme.caption.border ? this.getBorderStyle(this.gridTheme.caption.border) : null;
            var font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily, fontSize, fontStyle);
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.caption.font)) font = this.gridTheme.caption.font;
            return {
                font: font,
                brush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(pdfColor),
                backgroundBrush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(246, 246, 246)),
                border: borderCaption
            };
        } else //Material theme
        return {
            font: new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)((0, $32129651824bb502$export$be66ab191dea7a97).Helvetica, 9.75),
            brush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0)),
            backgroundBrush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(246, 246, 246))
        };
    };
    PdfExport.prototype.getGridPdfFont = function(args) {
        var fontFamily = "fontFamily";
        var fontSize = "fontSize";
        var fontStyle = "fontStyle";
        var isTrueType = "isTrueType";
        var style = 0;
        if (args.header && args.header.font) {
            var headerFont = args.header.font["" + fontFamily];
            var headerSize = args.header.font["" + fontSize];
            var headerStyle = args.header.font["" + fontStyle];
            style = (0, $3EnZW.isNullOrUndefined)((0, $32129651824bb502$export$80979869bc40ff1f)["" + headerStyle]) ? 0 : (0, $32129651824bb502$export$80979869bc40ff1f)["" + headerStyle];
            if (args.header.font["" + isTrueType]) args.header.font = new (0, $643b7e3e735d4d72$export$bee362ba4c0720b4)(headerFont, headerSize, style);
            else {
                var fontFamily_1 = !(0, $3EnZW.isNullOrUndefined)(headerFont) ? this.getFontFamily(headerFont) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
                args.header.font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily_1, headerSize, style);
            }
        }
        if (args.caption && args.caption.font) {
            var captionFont = args.caption.font["" + fontFamily];
            var captionSize = args.caption.font["" + fontSize];
            var captionStyle = args.caption.font["" + fontStyle];
            style = (0, $3EnZW.isNullOrUndefined)((0, $32129651824bb502$export$80979869bc40ff1f)["" + captionStyle]) ? 0 : (0, $32129651824bb502$export$80979869bc40ff1f)["" + captionStyle];
            if (args.caption.font["" + isTrueType]) args.caption.font = new (0, $643b7e3e735d4d72$export$bee362ba4c0720b4)(captionFont, captionSize, style);
            else {
                var fontFamily_2 = !(0, $3EnZW.isNullOrUndefined)(captionFont) ? this.getFontFamily(captionFont) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
                args.caption.font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily_2, captionSize, style);
            }
        }
        if (args.record && args.record.font) {
            var recordFont = args.record.font["" + fontFamily];
            var recordSize = args.record.font["" + fontSize];
            var recordStyle = args.record.font["" + fontStyle];
            style = (0, $3EnZW.isNullOrUndefined)((0, $32129651824bb502$export$80979869bc40ff1f)["" + recordStyle]) ? 0 : (0, $32129651824bb502$export$80979869bc40ff1f)["" + recordStyle];
            if (args.record.font["" + isTrueType]) args.record.font = new (0, $643b7e3e735d4d72$export$bee362ba4c0720b4)(recordFont, recordSize, style);
            else {
                var fontFamily_3 = !(0, $3EnZW.isNullOrUndefined)(recordFont) ? this.getFontFamily(recordFont) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
                args.record.font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily_3, recordSize, style);
            }
        }
    };
    PdfExport.prototype.getHeaderThemeStyle = function() {
        var border = new (0, $446c769ec2cda75b$export$69818a9b64460535)();
        if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme) && !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.header)) {
            var fontFamily = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.header.fontName) ? this.getFontFamily(this.gridTheme.header.fontName) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
            var fontStyle = this.getFontStyle(this.gridTheme.header);
            var fontSize = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.header.fontSize) ? this.gridTheme.header.fontSize : 10.5;
            var pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)();
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.header.fontColor)) {
                var penBrushColor = this.hexToRgb(this.gridTheme.header.fontColor);
                pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(penBrushColor.r, penBrushColor.g, penBrushColor.b);
            }
            var font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily, fontSize, fontStyle);
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.header.font)) font = this.gridTheme.header.font;
            return {
                border: this.getBorderStyle(this.gridTheme.header.border),
                font: font,
                brush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(pdfColor)
            };
        } else {
            //Material theme
            border.all = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(234, 234, 234));
            return {
                border: border,
                font: new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)((0, $32129651824bb502$export$be66ab191dea7a97).Helvetica, 10.5),
                brush: new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(102, 102, 102))
            };
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.processGroupedRecords = function(pdfGrid, dataSource, gridColumns, gObj, border, level, font, brush, backgroundBrush, returnType, pdfExportProperties, helper, index) {
        var _this = this;
        var groupIndex = level;
        var _loop_1 = function(dataSourceItems) {
            var row = pdfGrid.rows.addRow();
            var col = gObj.getColumnByField(dataSourceItems.field);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var args = {
                value: dataSourceItems.key,
                column: col,
                style: undefined,
                isForeignKey: col.isForeignColumn()
            };
            var value = gObj.getColumnByField(dataSourceItems.field).headerText + ": " + (!col.enableGroupByFormat ? this_1.exportValueFormatter.formatCellValue(args) : dataSourceItems.key) + " - " + dataSourceItems.count + (dataSource.count > 1 ? " items" : " item");
            var cArgs = {
                captionText: value,
                type: "PDF",
                data: dataSourceItems,
                style: undefined
            };
            this_1.parent.trigger($17b89d3b1fc93cdb$export$43919fe2f0396d45, cArgs, function(cArgs) {
                row.cells.getCell(groupIndex).value = cArgs.captionText;
                row.cells.getCell(groupIndex).style.stringFormat = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)((0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left);
                row.style.setBorder(border);
                row.style.setFont(font);
                row.style.setTextBrush(brush);
                row.style.setBackgroundBrush(backgroundBrush);
                if (!(0, $3EnZW.isNullOrUndefined)(cArgs.style)) _this.processCellStyle(row.cells.getCell(groupIndex), cArgs);
                var sRows;
                var captionSummaryModel = new (0, $add3e338055b95e6$export$626eb12b5cc2f09f)(gObj);
                if (!(0, $3EnZW.isNullOrUndefined)(dataSourceItems.items.records)) sRows = captionSummaryModel.generateRows(dataSourceItems.items.records, dataSourceItems);
                else sRows = captionSummaryModel.generateRows(dataSourceItems.items, dataSourceItems);
                if (!(0, $3EnZW.isNullOrUndefined)(sRows) && sRows.length === 0) row.cells.getCell(groupIndex + 1).columnSpan = pdfGrid.columns.count - (groupIndex + 1);
                if (!(0, $3EnZW.isNullOrUndefined)(dataSource.childLevels) && dataSource.childLevels > 0) {
                    _this.processAggregates(sRows, pdfGrid, border, font, brush, backgroundBrush, true, row, groupIndex, null, null, gObj);
                    _this.processGroupedRecords(pdfGrid, dataSourceItems.items, gridColumns, gObj, border, groupIndex + 1, font, brush, backgroundBrush, returnType, pdfExportProperties, helper, index);
                    index = _this.rowIndex;
                    var groupSummaryModel = new (0, $add3e338055b95e6$export$f766a86dea6dd817)(gObj);
                    sRows = groupSummaryModel.generateRows(dataSourceItems.items.records, dataSourceItems);
                    _this.processAggregates(sRows, pdfGrid, border, font, brush, backgroundBrush, false);
                } else {
                    _this.processAggregates(sRows, pdfGrid, border, font, brush, backgroundBrush, true, row, groupIndex, null, null, gObj);
                    index = _this.processRecord(border, gridColumns, gObj, dataSourceItems.items, pdfGrid, groupIndex + 1, pdfExportProperties, helper, index);
                    var groupSummaryModel = new (0, $add3e338055b95e6$export$f766a86dea6dd817)(gObj);
                    sRows = groupSummaryModel.generateRows(dataSourceItems.items, dataSourceItems);
                    var isGroupedFooter = true;
                    _this.processAggregates(sRows, pdfGrid, border, font, brush, backgroundBrush, false, null, null, isGroupedFooter, null, gObj);
                }
            });
        };
        var this_1 = this;
        for(var _i = 0, dataSource_1 = dataSource; _i < dataSource_1.length; _i++){
            var dataSourceItems = dataSource_1[_i];
            _loop_1(dataSourceItems);
        }
    };
    PdfExport.prototype.processGridHeaders = function(childLevels, pdfGrid, rows, gridColumn, border, headerFont, headerBrush, grid, allowHorizontalOverflow, eCols) {
        var _this = this;
        var columnCount = gridColumn.length + childLevels;
        var depth = (0, $748c2240e597a9b7$export$d6485206a212c36b)(eCols);
        var cols = eCols;
        var index = 0;
        var rowNumber = [];
        for(var i = 0; i < rows.length; i++)rowNumber[parseInt(i.toString(), 10)] = 0;
        if (grid.groupSettings.columns.length) {
            index = grid.groupSettings.columns.length - 1;
            columnCount = columnCount - 1;
        }
        pdfGrid.columns.add(columnCount);
        pdfGrid.style.cellPadding = new (0, $446c769ec2cda75b$export$98e68eadb1bc5ba0)(5.76, 5.76, 0.5, 0.5);
        pdfGrid.headers.add(rows.length);
        var applyTextAndSpan = function(rowIdx, colIdx, col, rowSpan, colSpan) {
            var gridHeader = pdfGrid.headers.getHeader(rowIdx);
            var pdfCell = gridHeader.cells.getCell(colIdx);
            var cell = rows[parseInt(rowIdx.toString(), 10)].cells[grid.groupSettings.columns.length ? colIdx : rowNumber[parseInt(rowIdx.toString(), 10)]];
            rowNumber[parseInt(rowIdx.toString(), 10)] = rowNumber[parseInt(rowIdx.toString(), 10)] + 1;
            if (!(0, $3EnZW.isNullOrUndefined)(col.headerTextAlign)) pdfCell.style.stringFormat = _this.getHorizontalAlignment(col.headerTextAlign);
            if (rowSpan > 0) {
                pdfCell.rowSpan = rowSpan;
                pdfCell.style.stringFormat = _this.getVerticalAlignment("Bottom", pdfCell.style.stringFormat, col.textAlign);
            }
            if (colSpan > 0) pdfCell.columnSpan = colSpan;
            gridHeader.style.setBorder(border);
            gridHeader.style.setFont(headerFont);
            gridHeader.style.setTextBrush(headerBrush);
            pdfCell.value = col.headerText;
            if (!(0, $3EnZW.isNullOrUndefined)(cell) && (cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).HeaderIndent || cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailHeader)) {
                pdfCell.value = "";
                pdfCell.width = 20;
            }
            var args = {
                cell: pdfCell,
                gridCell: cell,
                style: pdfCell.style
            };
            _this.parent.trigger($17b89d3b1fc93cdb$export$1e87179d61662966, args);
            var evtArgs = args;
            var setCellBorder = args.style.borders;
            var setCellFont = args.style.font;
            var setHeaderBrush = args.style.textBrush;
            if (!(0, $3EnZW.isNullOrUndefined)(setCellBorder)) gridHeader.style.setBorder(setCellBorder);
            if (!(0, $3EnZW.isNullOrUndefined)(setCellFont)) gridHeader.style.setFont(setCellFont);
            if (!(0, $3EnZW.isNullOrUndefined)(setHeaderBrush)) gridHeader.style.setTextBrush(setHeaderBrush);
            if (!(0, $3EnZW.isNullOrUndefined)(evtArgs.style.verticalAlignment)) pdfCell.style.stringFormat = _this.getVerticalAlignment(evtArgs.style.verticalAlignment, pdfCell.style.stringFormat);
            if (!(0, $3EnZW.isNullOrUndefined)(evtArgs.image)) pdfCell.value = new (0, $c987c917f397d328$export$a738614a0b6b3b5a)(evtArgs.image.base64);
            if (!(0, $3EnZW.isNullOrUndefined)(evtArgs.hyperLink)) pdfCell.value = _this.setHyperLink(evtArgs);
        };
        var recuHeader = function(cols, depth, spanCnt, colIndex, rowIndex, isRoot) {
            var cidx = 0;
            for(var i = 0; i < cols.length; i++){
                if (isRoot) {
                    cidx = cidx + spanCnt + (i === 0 ? 0 : -1);
                    colIndex = cidx;
                    spanCnt = 0;
                }
                if (!isRoot && !cols[parseInt(i.toString(), 10)].visible) colIndex = colIndex - 1;
                if (cols[parseInt(i.toString(), 10)].columns && cols[parseInt(i.toString(), 10)].columns.length) {
                    var newSpanCnt = recuHeader(cols[parseInt(i.toString(), 10)].columns, depth - 1, 0, i + colIndex, rowIndex + 1, false);
                    applyTextAndSpan(rowIndex, i + colIndex + index, cols[parseInt(i.toString(), 10)], 0, newSpanCnt);
                    spanCnt = spanCnt + newSpanCnt;
                    colIndex = colIndex + newSpanCnt - 1;
                } else if (cols[parseInt(i.toString(), 10)].visible || _this.hideColumnInclude) {
                    spanCnt++;
                    applyTextAndSpan(rowIndex, i + colIndex + index, cols[parseInt(i.toString(), 10)], depth, 0);
                }
            }
            return spanCnt;
        };
        recuHeader(cols, depth, 0, 0, 0, true);
        if (pdfGrid.columns.count >= 6 && allowHorizontalOverflow) pdfGrid.style.allowHorizontalOverflow = true;
        return pdfGrid;
    };
    PdfExport.prototype.processExportProperties = function(pdfExportProperties, dataSource) {
        if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties)) {
            if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.theme)) this.gridTheme = pdfExportProperties.theme;
            var clientSize = this.pdfPageSettings.size;
            this.drawHeader(pdfExportProperties);
            if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.footer)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var footer = pdfExportProperties.footer;
                var position = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, clientSize.width - 80 - footer.fromBottom * 0.75);
                var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(clientSize.width - 80, footer.height * 0.75);
                var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(position, size);
                this.pdfDocument.template.bottom = this.drawPageTemplate(new (0, $c33f2752f598011d$export$6ed0b78de60eb5b0)(bounds), footer);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.includeHiddenColumn) && !this.isGrouping) this.hideColumnInclude = pdfExportProperties.includeHiddenColumn;
            if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.dataSource)) {
                this.customDataSource = true;
                this.currentViewData = false;
            } else if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.exportType)) {
                if (pdfExportProperties.exportType === "CurrentPage") {
                    dataSource = this.parent.groupSettings && this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length && !this.parent.getDataModule().isRemote() ? dataSource : this.parent.currentViewData;
                    this.currentViewData = true;
                    this.customDataSource = false;
                } else {
                    this.currentViewData = false;
                    this.customDataSource = false;
                }
            } else {
                this.currentViewData = false;
                this.customDataSource = false;
            }
        } else {
            this.currentViewData = false;
            this.customDataSource = false;
        }
        return dataSource;
    };
    PdfExport.prototype.drawHeader = function(pdfExportProperties) {
        var _this = this;
        var clientSize = this.pdfPageSettings.size;
        if (!(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties.header)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var header = pdfExportProperties.header;
            var position = new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, header.fromTop);
            var size = new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(clientSize.width - 80, header.height * 0.75);
            var bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(position, size);
            if (!this.headerOnPages.length) this.pdfDocument.template.top = this.drawPageTemplate(new (0, $c33f2752f598011d$export$6ed0b78de60eb5b0)(bounds), header);
            else {
                var headerTemplate_1 = this.drawPageTemplate(new (0, $c33f2752f598011d$export$6ed0b78de60eb5b0)(bounds), header);
                this.headerOnPages.filter(function(index) {
                    if (index - 1 >= 0 && index - 1 <= _this.pdfDocument.pages.count - 1) _this.pdfDocument.pages.getPageByIndex(index - 1).graphics.drawPdfTemplate(headerTemplate_1.template, new (0, $e1df9a3657e111f3$export$a878d5fce7d721a5)(0, 0));
                });
            }
        }
    };
    PdfExport.prototype.drawPageTemplate = function(template, element) {
        for(var _i = 0, _a = element.contents; _i < _a.length; _i++){
            var content = _a[_i];
            this.processContentValidation(content);
            switch(content.type){
                case "Text":
                    if (content.value === "" || content.value === undefined || content.value === null || typeof content.value !== "string") throw new Error("please enter the valid input value in text content...");
                    this.drawText(template, content);
                    break;
                case "PageNumber":
                    this.drawPageNumber(template, content);
                    break;
                case "Image":
                    if (content.src === undefined || content.src === null || content.src === "") throw new Error("please enter the valid base64 string in image content...");
                    this.drawImage(template, content);
                    break;
                case "Line":
                    this.drawLine(template, content);
                    break;
                default:
                    throw new Error("Please set valid content type...");
            }
        }
        return template;
    };
    PdfExport.prototype.processContentValidation = function(content) {
        if (content.type === undefined || content.type === null) throw new Error("please set valid content type...");
        else if (content.type === "Line") {
            if (content.points === undefined || content.points === null) throw new Error("please enter valid points in " + content.type + " content...");
            else {
                if (content.points.x1 === undefined || content.points.x1 === null || typeof content.points.x1 !== "number") throw new Error("please enter valid x1 co-ordinate in " + content.type + " points...");
                if (content.points.y1 === undefined || content.points.y1 === null || typeof content.points.y1 !== "number") throw new Error("please enter valid y1 co-ordinate in " + content.type + " points...");
                if (content.points.x2 === undefined || content.points.x2 === null || typeof content.points.x2 !== "number") throw new Error("please enter valid x2 co-ordinate in " + content.type + " points...");
                if (content.points.y2 === undefined || content.points.y2 === null || typeof content.points.y2 !== "number") throw new Error("please enter valid y2 co-ordinate in " + content.type + " points...");
            }
        } else {
            if (content.position === undefined || content.position === null) throw new Error("please enter valid position in " + content.type + " content...");
            else {
                if (content.position.x === undefined || content.position.x === null || typeof content.position.x !== "number") throw new Error("please enter valid x co-ordinate in " + content.type + " position...");
                if (content.position.y === undefined || content.position.y === null || typeof content.position.y !== "number") throw new Error("please enter valid y co-ordinate in " + content.type + " position...");
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.drawText = function(pageTemplate, content) {
        var font = this.getFont(content);
        var brush = this.getBrushFromContent(content);
        var pen = null;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.textPenColor)) {
            var penColor = this.hexToRgb(content.style.textPenColor);
            pen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(penColor.r, penColor.g, penColor.b));
        }
        if (brush == null && pen == null) brush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        var value = content.value.toString();
        var x = content.position.x * 0.75;
        var y = content.position.y * 0.75;
        var format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.stringFormat)) format.alignment = content.style.stringFormat.alignment;
        var result = this.setContentFormat(content, format);
        if (result !== null && !(0, $3EnZW.isNullOrUndefined)(result.format) && !(0, $3EnZW.isNullOrUndefined)(result.size)) pageTemplate.graphics.drawString(value, font, pen, brush, x, y, result.size.width, result.size.height, result.format);
        else pageTemplate.graphics.drawString(value, font, pen, brush, x, y, format);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.drawPageNumber = function(documentHeader, content) {
        var font = this.getFont(content);
        var brush = null;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.textBrushColor)) {
            var brushColor = this.hexToRgb(content.style.textBrushColor);
            brush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(brushColor.r, brushColor.g, brushColor.b));
        } else brush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        var pageNumber = new (0, $dc16533f34d49c75$export$a7b17fe3dad27965)(font, brush);
        pageNumber.numberStyle = this.getPageNumberStyle(content.pageNumberType);
        var compositeField;
        var format;
        if (!(0, $3EnZW.isNullOrUndefined)(content.format)) {
            var total = "$total";
            var current = "$current";
            if (content.format.indexOf(total) !== -1 && content.format.indexOf(current) !== -1) {
                var pageCount = new (0, $b261dcdfbb93158a$export$87a596dd5a6e103c)(font);
                pageCount.numberStyle = this.getPageNumberStyle(content.pageNumberType);
                if (content.format.indexOf(total) > content.format.indexOf(current)) {
                    format = content.format.replace(current, "0");
                    format = format.replace(total, "1");
                } else {
                    format = content.format.replace(current, "1");
                    format = format.replace(total, "0");
                }
                compositeField = new (0, $b30674b120ef5a4a$export$b112c9b7092835e0)(font, brush, format, pageNumber, pageCount);
            } else if (content.format.indexOf(current) !== -1 && content.format.indexOf(total) === -1) {
                format = content.format.replace(current, "0");
                compositeField = new (0, $b30674b120ef5a4a$export$b112c9b7092835e0)(font, brush, format, pageNumber);
            } else {
                var pageCount = new (0, $b261dcdfbb93158a$export$87a596dd5a6e103c)(font);
                format = content.format.replace(total, "0");
                compositeField = new (0, $b30674b120ef5a4a$export$b112c9b7092835e0)(font, brush, format, pageCount);
            }
        } else {
            format = "{0}";
            compositeField = new (0, $b30674b120ef5a4a$export$b112c9b7092835e0)(font, brush, format, pageNumber);
        }
        var x = content.position.x * 0.75;
        var y = content.position.y * 0.75;
        var result = this.setContentFormat(content, compositeField.stringFormat);
        if (result !== null && !(0, $3EnZW.isNullOrUndefined)(result.format) && !(0, $3EnZW.isNullOrUndefined)(result.size)) {
            compositeField.stringFormat = result.format;
            compositeField.bounds = new (0, $e1df9a3657e111f3$export$6543fe32ba958b02)(x, y, result.size.width, result.size.height);
        }
        compositeField.draw(documentHeader.graphics, x, y);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.drawImage = function(documentHeader, content) {
        var x = content.position.x * 0.75;
        var y = content.position.y * 0.75;
        var width = !(0, $3EnZW.isNullOrUndefined)(content.size) ? content.size.width * 0.75 : undefined;
        var height = !(0, $3EnZW.isNullOrUndefined)(content.size) ? content.size.height * 0.75 : undefined;
        var image = new (0, $c987c917f397d328$export$a738614a0b6b3b5a)(content.src);
        if (!(0, $3EnZW.isNullOrUndefined)(width)) documentHeader.graphics.drawImage(image, x, y, width, height);
        else documentHeader.graphics.drawImage(image, x, y);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.drawLine = function(documentHeader, content) {
        var x1 = content.points.x1 * 0.75;
        var y1 = content.points.y1 * 0.75;
        var x2 = content.points.x2 * 0.75;
        var y2 = content.points.y2 * 0.75;
        var pen = this.getPenFromContent(content);
        if (!(0, $3EnZW.isNullOrUndefined)(content.style) && content.style !== null) {
            if (!(0, $3EnZW.isNullOrUndefined)(content.style.penSize) && content.style.penSize !== null && typeof content.style.penSize === "number") pen.width = content.style.penSize * 0.75;
            pen.dashStyle = this.getDashStyle(content.style.dashStyle);
        }
        documentHeader.graphics.drawLine(pen, x1, y1, x2, y2);
    };
    PdfExport.prototype.processAggregates = function(sRows, pdfGrid, border, font, brush, backgroundBrush, isCaption, captionRow, groupIndex, isGroupedFooter, isAggregate, gObj) {
        for(var _i = 0, sRows_1 = sRows; _i < sRows_1.length; _i++){
            var row = sRows_1[_i];
            var leastCaptionSummaryIndex = -1;
            var index = 0;
            var isEmpty = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = [];
            var aggIdx = isAggregate ? 0 : 1;
            var gridRow = void 0;
            if ((0, $3EnZW.isNullOrUndefined)(captionRow)) {
                gridRow = pdfGrid.rows.addRow();
                gridRow.style.setBorder(border);
                gridRow.style.setFont(font);
                gridRow.style.setTextBrush(brush);
                gridRow.style.setBackgroundBrush(backgroundBrush);
            }
            for(var i = 0; i < pdfGrid.columns.count + aggIdx; i++){
                var cell = row.cells[parseInt(index.toString(), 10)];
                if (cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailFooterIntent) {
                    i--;
                    index++;
                    continue;
                }
                if (!this.hideColumnInclude) {
                    while(cell.visible === undefined){
                        if (cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).DetailFooterIntent) continue;
                        if (!(0, $3EnZW.isNullOrUndefined)(captionRow)) {
                            if (!(0, $3EnZW.isNullOrUndefined)(captionRow.cells.getCell(i).value)) {
                                value.push(captionRow.cells.getCell(i).value);
                                isEmpty = false;
                                if (!isCaption) i += 1;
                            } else value.push("");
                        } else value.push("");
                        i += 1;
                        index = index + 1;
                        cell = row.cells[parseInt(index.toString(), 10)];
                    }
                    while(!(0, $3EnZW.isNullOrUndefined)(cell.visible) && !cell.visible){
                        index = index + 1;
                        cell = row.cells[parseInt(index.toString(), 10)];
                    }
                }
                if (cell.isDataCell) {
                    var templateFn = {};
                    var footerTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.footerTemplate);
                    var groupFooterTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.groupFooterTemplate);
                    var groupCaptionTemplate = !(0, $3EnZW.isNullOrUndefined)(cell.column.groupCaptionTemplate);
                    if (footerTemplate || groupCaptionTemplate || groupFooterTemplate) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var result = this.getTemplateFunction(templateFn, i, leastCaptionSummaryIndex, cell);
                        templateFn = result.templateFunction;
                        leastCaptionSummaryIndex = result.leastCaptionSummaryIndex;
                        var txt = void 0;
                        var data = row.data[cell.column.field ? cell.column.field : cell.column.columnName];
                        if ((this.parent.isReact || this.parent.isVue || this.parent.isVue3 || this.parent.isAngular) && !(typeof cell.column.footerTemplate === "string" || typeof cell.column.groupFooterTemplate === "string" || typeof cell.column.groupCaptionTemplate === "string")) {
                            txt = data[cell.column.type];
                            txt = !(0, $3EnZW.isNullOrUndefined)(txt) ? txt : "";
                        } else {
                            txt = templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), cell.cellType)](data, this.parent);
                            txt = this.parent.isVue3 && !(0, $3EnZW.isNullOrUndefined)(txt[1]) ? txt[1].textContent : !(0, $3EnZW.isNullOrUndefined)(txt[0]) ? txt[0].textContent : "";
                        }
                        isEmpty = false;
                        var args = {
                            row: row,
                            type: footerTemplate ? "Footer" : groupFooterTemplate ? "GroupFooter" : "GroupCaption",
                            style: (0, $3EnZW.isNullOrUndefined)(captionRow) ? gridRow.cells : captionRow.cells,
                            cell: cell,
                            value: txt
                        };
                        this.parent.trigger($17b89d3b1fc93cdb$export$84db6b91e23ae16e, args);
                        value.push(args.value);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var result = this.getSummaryWithoutTemplate(row.data[cell.column.field]);
                        if (!(0, $3EnZW.isNullOrUndefined)(result)) value.push(result);
                    }
                } else value.push("");
                if (isEmpty && value[parseInt(i.toString(), 10)] !== "" && !(0, $3EnZW.isNullOrUndefined)(value[parseInt(i.toString(), 10)]) && value[parseInt(i.toString(), 10)] !== null) isEmpty = false;
                index += 1;
            }
            if (!isAggregate) {
                if (!isCaption) value.splice(0, 1);
                else for(var i = gObj.groupSettings.columns.length; i < value.length - 1; i++){
                    value[parseInt(i.toString(), 10)] = value[i + 1];
                    value[i + 1] = value[i + 2] ? value[i + 2] : "";
                }
            }
            if (!isEmpty) {
                if (!isCaption) for(var i = 0; i < pdfGrid.columns.count; i++)gridRow.cells.getCell(i).value = value[parseInt(i.toString(), 10)].toString();
                else for(var i = 0; i < pdfGrid.columns.count; i++){
                    captionRow.cells.getCell(i).value = value[parseInt(i.toString(), 10)].toString();
                    if (i === groupIndex && leastCaptionSummaryIndex !== -1 && leastCaptionSummaryIndex !== 1) captionRow.cells.getCell(i).columnSpan = leastCaptionSummaryIndex - 1 - groupIndex;
                    else if (i === groupIndex && leastCaptionSummaryIndex === -1) captionRow.cells.getCell(i).columnSpan = pdfGrid.columns.count - groupIndex;
                }
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.getTemplateFunction = function(templateFn, index, leastCaptionSummaryIndex, cell) {
        if (!(0, $3EnZW.isNullOrUndefined)(cell.column.footerTemplate) && cell.cellType === (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Summary) templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Summary)] = (0, $c2qqN.compile)(cell.column.footerTemplate);
        else if (!(0, $3EnZW.isNullOrUndefined)(cell.column.groupCaptionTemplate)) {
            if (leastCaptionSummaryIndex === -1) leastCaptionSummaryIndex = index;
            templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).CaptionSummary)] = (0, $c2qqN.compile)(cell.column.groupCaptionTemplate);
        } else templateFn[(0, $3EnZW.getEnumValue)((0, $6b76944ddf827cb7$export$705e36171f4cbbfe), (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).GroupSummary)] = (0, $c2qqN.compile)(cell.column.groupFooterTemplate);
        return {
            templateFunction: templateFn,
            leastCaptionSummaryIndex: leastCaptionSummaryIndex
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.getSummaryWithoutTemplate = function(data) {
        if (!(0, $3EnZW.isNullOrUndefined)(data.Sum)) return data.Sum;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.Average)) return data.Average;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.Max)) return data.Max;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.Min)) return data.Min;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.Count)) return data.Count;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.TrueCount)) return data.TrueCount;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.FalseCount)) return data.FalseCount;
        else if (!(0, $3EnZW.isNullOrUndefined)(data.Custom)) return data.Custom;
    };
    /**
     * Set alignment, width and type of the values of the column
     *
     * @param {Column[]} gridColumns - specifies the grid column
     * @param {PdfGrid} pdfGrid - specifies the pdfGrid
     * @param {ExportHelper} helper - specifies the helper
     * @param {IGrid} gObj - specifies the IGrid
     * @param {boolean} allowHorizontalOverflow - specifies the allowHorizontalOverflow
     * @returns {void}
     */ PdfExport.prototype.setColumnProperties = function(gridColumns, pdfGrid, helper, gObj, allowHorizontalOverflow) {
        var startIndex = gObj.groupSettings.columns.length ? gObj.groupSettings.columns.length - 1 : 0;
        for(var i = 0; i < startIndex; i++)pdfGrid.columns.getColumn(i).width = 20;
        for(var i = 0; i < gridColumns.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(gridColumns[parseInt(i.toString(), 10)].textAlign)) pdfGrid.columns.getColumn(i + startIndex).format = this.getHorizontalAlignment(gridColumns[parseInt(i.toString(), 10)].textAlign);
            // Need to add width consideration with % value
            if (pdfGrid.style.allowHorizontalOverflow && !(0, $3EnZW.isNullOrUndefined)(gridColumns[parseInt(i.toString(), 10)].width) && allowHorizontalOverflow) pdfGrid.columns.getColumn(i + startIndex).width = typeof gridColumns[parseInt(i.toString(), 10)].width === "number" ? gridColumns[parseInt(i.toString(), 10)].width * 0.75 : helper.getConvertedWidth(gridColumns[parseInt(i.toString(), 10)].width) * 0.75;
        }
    };
    /**
     * set default style properties of each rows in exporting grid
     *
     * @param {PdfGridRow} row - specifies the PdfGridRow
     * @param {PdfBorders} border - specifies the PdfBorders
     * @returns {PdfGrid} returns the pdfgrid
     * @private
     */ PdfExport.prototype.setRecordThemeStyle = function(row, border) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme) && !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.record)) {
            var fontFamily = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.record.fontName) ? this.getFontFamily(this.gridTheme.record.fontName) : (0, $32129651824bb502$export$be66ab191dea7a97).Helvetica;
            var fontSize = !(0, $3EnZW.isNullOrUndefined)(this.gridTheme.record.fontSize) ? this.gridTheme.record.fontSize : 9.75;
            var fontStyle = this.getFontStyle(this.gridTheme.record);
            var font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily, fontSize, fontStyle);
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.record.font)) font = this.gridTheme.record.font;
            row.style.setFont(font);
            var pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)();
            if (!(0, $3EnZW.isNullOrUndefined)(this.gridTheme.record.fontColor)) {
                var penBrushColor = this.hexToRgb(this.gridTheme.record.fontColor);
                pdfColor = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(penBrushColor.r, penBrushColor.g, penBrushColor.b);
            }
            row.style.setTextBrush(new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(pdfColor));
        } else row.style.setTextBrush(new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0)));
        var borderRecord = this.gridTheme && this.gridTheme.record && this.gridTheme.record.border ? this.getBorderStyle(this.gridTheme.record.border) : border;
        row.style.setBorder(borderRecord);
        return row;
    };
    /**
     * generate the formatted cell values
     *
     * @param {PdfBorders} border - specifies the border
     * @param {Column[]} columns - specifies the columns
     * @param {IGrid} gObj - specifies the IGrid
     * @param {Object[]} dataSource - specifies the datasource
     * @param {PdfGrid} pdfGrid - specifies the pdfGrid
     * @param {number} startIndex - specifies the startindex
     * @param {PdfExportProperties} pdfExportProperties - specifies the pdfExportProperties
     * @param {ExportHelper} helper - specifies the helper
     * @param {number} rowIndex - specifies the rowIndex
     * @returns {number} returns the number of records
     * @private
     */ PdfExport.prototype.processRecord = function(border, columns, gObj, dataSource, pdfGrid, startIndex, pdfExportProperties, helper, rowIndex) {
        var rows = helper.getGridRowModel(columns, dataSource, gObj, rowIndex);
        for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
            var row = rows_1[_i];
            rowIndex++;
            this.rowIndex = rowIndex;
            // create a new row and set default style properties
            var gridRow = this.setRecordThemeStyle(pdfGrid.rows.addRow(), border);
            var cellLength = row.cells.length;
            for(var j = 0; j < cellLength; j++){
                var gridCell = row.cells[parseInt(j.toString(), 10)];
                if (gridCell.cellType !== (0, $6b76944ddf827cb7$export$705e36171f4cbbfe).Data) continue;
                var column = gridCell.column;
                var field = column.field;
                var cellValue = !(0, $3EnZW.isNullOrUndefined)(field) ? column.valueAccessor(field, row.data, column) : "";
                var value = !(0, $3EnZW.isNullOrUndefined)(cellValue) ? cellValue : "";
                var foreignKeyData = void 0;
                if (column.isForeignColumn && column.isForeignColumn()) {
                    foreignKeyData = helper.getFData(value, column);
                    value = (0, $3EnZW.getValue)(column.foreignKeyValue, foreignKeyData);
                }
                var data = row.data;
                var cell = gridRow.cells.getCell(j);
                var args = {
                    data: data,
                    value: value,
                    column: column,
                    style: undefined,
                    colSpan: 1,
                    cell: cell
                };
                args.value = args.column.type === "boolean" && typeof args.value === "string" ? args.value : this.exportValueFormatter.formatCellValue(args);
                this.parent.trigger($17b89d3b1fc93cdb$export$e994f1ebdba13290, args);
                if (!(0, $3EnZW.isNullOrUndefined)(args.image)) {
                    args.value = new (0, $c987c917f397d328$export$a738614a0b6b3b5a)(args.image.base64);
                    args.value.height = args.image.height || args.value.height;
                    args.value.width = args.image.width || args.value.width;
                }
                cell.value = args.value;
                if (!(0, $3EnZW.isNullOrUndefined)(args.hyperLink)) cell.value = this.setHyperLink(args);
                if (!(0, $3EnZW.isNullOrUndefined)(args.style)) this.processCellStyle(cell, args);
                if (args.colSpan > 1) {
                    if (j + 1 + args.colSpan > gridRow.cells.count) args.colSpan = gridRow.cells.count - (j + 1);
                    cell.columnSpan = args.colSpan;
                    for(var i = 1; i < cell.columnSpan; i++){
                        var spanCell = gridRow.cells.getCell(j + i);
                        spanCell.value = "";
                    }
                    j += args.colSpan - 1;
                }
            }
            if (row.isExpand) {
                var gridRow_1 = this.setRecordThemeStyle(pdfGrid.rows.addRow(), border);
                var startIndexVal = this.parent.childGrid || this.parent.detailTemplate ? 0 : startIndex;
                var cell = gridRow_1.cells.getCell(startIndexVal);
                cell.columnSpan = gridRow_1.cells.count - startIndexVal;
                cell.style.cellPadding = new (0, $446c769ec2cda75b$export$98e68eadb1bc5ba0)(10, 10, 10, 10);
                if (this.parent.childGrid) {
                    gObj.isPrinting = true;
                    var exportType = !(0, $3EnZW.isNullOrUndefined)(pdfExportProperties) && pdfExportProperties.exportType ? pdfExportProperties.exportType : "AllPages";
                    var returnValue = this.helper.createChildGrid(gObj, row, exportType, this.gridPool);
                    var childGridObj = returnValue.childGrid;
                    var element = returnValue.element;
                    childGridObj.actionFailure = helper.failureHandler(this.gridPool, childGridObj, this.globalResolve);
                    var childExportProperties = (0, $3EnZW.extend)(pdfExportProperties, {
                        columns: null,
                        dataSource: null,
                        query: null
                    });
                    var args = {
                        childGrid: childGridObj,
                        row: row,
                        cell: cell,
                        exportProperties: childExportProperties
                    };
                    this.parent.trigger($17b89d3b1fc93cdb$export$47abd346227d718b, args);
                    childGridObj.beforeDataBound = this.childGridCell(cell, childGridObj, childExportProperties);
                    childGridObj.appendTo(element);
                } else if (this.parent.detailTemplate) {
                    var args = {
                        parentRow: row,
                        row: gridRow_1,
                        value: {},
                        action: "pdfexport",
                        gridInstance: gObj
                    };
                    this.parent.trigger($17b89d3b1fc93cdb$export$4807207a16495a60, args);
                    cell.value = this.processDetailTemplate(args);
                }
            }
            this.parent.notify($17b89d3b1fc93cdb$export$37f61a67cc87a415, {
                type: "pdf",
                rowObj: row
            });
        }
        return rowIndex;
    };
    PdfExport.prototype.processDetailTemplate = function(templateData) {
        var _this = this;
        if (templateData.value.columnHeader || templateData.value.rows) {
            // create a grid
            var pdfGrid = new (0, $3e86d9e9de96833e$export$443e23810511d2c6)();
            // get header theme style
            var headerThemeStyle = this.getHeaderThemeStyle();
            var border_1 = headerThemeStyle.border;
            var headerFont_1 = headerThemeStyle.font;
            var headerBrush_1 = headerThemeStyle.brush;
            var processRow = function(row, gridRow, isHeader) {
                if (isHeader) {
                    gridRow.style.setBorder(border_1);
                    gridRow.style.setFont(headerFont_1);
                    gridRow.style.setTextBrush(headerBrush_1);
                }
                for(var j = 0; j < row.cells.length; j++){
                    var currentCell = row.cells[parseInt(j.toString(), 10)];
                    var pdfCell = gridRow.cells.getCell(currentCell.index ? currentCell.index : j);
                    if (currentCell.rowSpan > 0) pdfCell.rowSpan = currentCell.rowSpan;
                    if (currentCell.colSpan > 0) pdfCell.columnSpan = currentCell.colSpan;
                    pdfCell.value = currentCell.value;
                    if (!(0, $3EnZW.isNullOrUndefined)(currentCell.image)) {
                        pdfCell.value = new (0, $c987c917f397d328$export$a738614a0b6b3b5a)(currentCell.image.base64);
                        pdfCell.value.height = currentCell.image.height;
                        pdfCell.value.width = currentCell.image.width;
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(currentCell.hyperLink)) pdfCell.value = _this.setHyperLink(currentCell);
                    if (!(0, $3EnZW.isNullOrUndefined)(currentCell.style)) {
                        var cellStyle = {
                            style: {
                                backgroundColor: currentCell.style.backColor,
                                textAlignment: currentCell.style.pdfTextAlignment,
                                verticalAlignment: currentCell.style.pdfVerticalAlignment,
                                textBrushColor: currentCell.style.fontColor,
                                textPenColor: currentCell.style.pdfTextPenColor,
                                fontFamily: currentCell.style.pdfFontFamily,
                                fontSize: currentCell.style.fontSize,
                                bold: currentCell.style.bold,
                                italic: currentCell.style.italic,
                                underline: currentCell.style.underline,
                                strikeout: currentCell.style.strikeThrough,
                                border: currentCell.style.pdfBorder,
                                paragraphIndent: currentCell.style.pdfParagraphIndent,
                                cellPadding: currentCell.style.pdfCellPadding
                            }
                        };
                        _this.processCellStyle(pdfCell, cellStyle);
                    }
                }
            };
            if (templateData.value.columnCount) pdfGrid.columns.add(templateData.value.columnCount);
            else {
                if (templateData.value.columnHeader && templateData.value.columnHeader.length) pdfGrid.columns.add(templateData.value.columnHeader[0].cells.length);
                else if (templateData.value.rows && templateData.value.rows.length) pdfGrid.columns.add(templateData.value.rows[0].cells.length);
            }
            if (templateData.value.columnHeader) {
                pdfGrid.headers.add(templateData.value.columnHeader.length);
                for(var i = 0; i < templateData.value.columnHeader.length; i++){
                    var gridHeader = pdfGrid.headers.getHeader(parseInt(i.toString(), 10));
                    processRow(templateData.value.columnHeader[parseInt(i.toString(), 10)], gridHeader, true);
                }
            }
            if (templateData.value.rows) for(var _i = 0, _a = templateData.value.rows; _i < _a.length; _i++){
                var row = _a[_i];
                // create a new row and set default style properties
                var gridRow = this.setRecordThemeStyle(pdfGrid.rows.addRow(), border_1);
                processRow(row, gridRow, false);
            }
            return pdfGrid;
        } else if (templateData.value.image) return new (0, $c987c917f397d328$export$a738614a0b6b3b5a)(templateData.value.image.base64);
        else if (templateData.value.text) return templateData.value.text;
        else if (templateData.value.hyperLink) return this.setHyperLink(templateData.value);
        return "";
    };
    PdfExport.prototype.setHyperLink = function(args) {
        // create the Text Web Link
        var textLink = new (0, $0b4b1f60d7f75a26$export$6c765b7085f136fc)();
        // set the hyperlink
        textLink.url = args.hyperLink.target;
        // set the link text
        textLink.text = args.hyperLink.displayText || args.hyperLink.target;
        // set the font
        textLink.font = new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)((0, $32129651824bb502$export$be66ab191dea7a97).Helvetica, 9.75);
        // set the brush and pen for the text color
        textLink.brush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(51, 102, 187));
        return textLink;
    };
    PdfExport.prototype.childGridCell = function(cell, childGridObj, pdfExportProperties) {
        var _this = this;
        return function(result) {
            childGridObj.beforeDataBound = null;
            result.cancel = true;
            cell.value = _this.processGridExport(childGridObj, result, pdfExportProperties);
            childGridObj.destroy();
            (0, $4ZDHT.detach)(childGridObj.element);
            _this.gridPool[childGridObj.id] = true;
            _this.helper.checkAndExport(_this.gridPool, _this.globalResolve);
            return cell;
        };
    };
    PdfExport.prototype.processCellStyle = function(cell, args) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.backgroundColor)) {
            var backColor = this.hexToRgb(args.style.backgroundColor);
            cell.style.backgroundBrush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(backColor.r, backColor.g, backColor.b));
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.textAlignment)) cell.style.stringFormat = this.getHorizontalAlignment(args.style.textAlignment);
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.cellPadding)) cell.style.cellPadding = args.style.cellPadding;
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.verticalAlignment)) cell.style.stringFormat = this.getVerticalAlignment(args.style.verticalAlignment, cell.style.stringFormat);
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.textBrushColor)) {
            var textBrushColor = this.hexToRgb(args.style.textBrushColor);
            cell.style.textBrush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(textBrushColor.r, textBrushColor.g, textBrushColor.b));
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.textPenColor)) {
            var textPenColor = this.hexToRgb(args.style.textPenColor);
            cell.style.textPen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(textPenColor.r, textPenColor.g, textPenColor.b));
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.fontFamily) || !(0, $3EnZW.isNullOrUndefined)(args.style.fontSize) || !(0, $3EnZW.isNullOrUndefined)(args.style.bold) || !(0, $3EnZW.isNullOrUndefined)(args.style.italic) || !(0, $3EnZW.isNullOrUndefined)(args.style.underline) || !(0, $3EnZW.isNullOrUndefined)(args.style.strikeout)) cell.style.font = this.getFont(args);
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.border)) {
            var border = new (0, $446c769ec2cda75b$export$69818a9b64460535)();
            var borderWidth = args.style.border.width;
            // set border width
            var width = !(0, $3EnZW.isNullOrUndefined)(borderWidth) && typeof borderWidth === "number" ? borderWidth * 0.75 : undefined;
            // set border color
            var color = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(196, 196, 196);
            if (!(0, $3EnZW.isNullOrUndefined)(args.style.border.color)) {
                var borderColor = this.hexToRgb(args.style.border.color);
                color = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(borderColor.r, borderColor.g, borderColor.b);
            }
            var pen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(color, width);
            // set border dashStyle 'Solid <default>, Dash, Dot, DashDot, DashDotDot'
            if (!(0, $3EnZW.isNullOrUndefined)(args.style.border.dashStyle)) pen.dashStyle = this.getDashStyle(args.style.border.dashStyle);
            border.all = pen;
            cell.style.borders = border;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args.style.paragraphIndent)) {
            cell.style.stringFormat = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
            cell.style.stringFormat.paragraphIndent = args.style.paragraphIndent;
        }
    };
    /**
     * set text alignment of each columns in exporting grid
     *
     * @param {string} textAlign - specifies the textAlign
     * @param {PdfStringFormat} format - specifies the PdfStringFormat
     * @returns {PdfStringFormat} returns the PdfStringFormat
     * @private
     */ PdfExport.prototype.getHorizontalAlignment = function(textAlign, format) {
        if (format === undefined) format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
        switch(textAlign){
            case "Right":
                format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right;
                break;
            case "Center":
                format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center;
                break;
            case "Justify":
                format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify;
                break;
            case "Left":
                format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left;
                break;
        }
        return format;
    };
    /**
     * set vertical alignment of each columns in exporting grid
     *
     * @param {string} verticalAlign - specifies the verticalAlign
     * @param {PdfStringFormat} format - specifies the PdfStringFormat
     * @param {string} textAlign - specifies the text align
     * @returns {PdfStringFormat} returns the PdfStringFormat
     * @private
     */ PdfExport.prototype.getVerticalAlignment = function(verticalAlign, format, textAlign) {
        if (format === undefined) {
            format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)();
            format = this.getHorizontalAlignment(textAlign, format);
        }
        switch(verticalAlign){
            case "Bottom":
                format.lineAlignment = (0, $d174213b46afc09a$export$2692e69612b4a9e9).Bottom;
                break;
            case "Middle":
                format.lineAlignment = (0, $d174213b46afc09a$export$2692e69612b4a9e9).Middle;
                break;
            case "Top":
                format.lineAlignment = (0, $d174213b46afc09a$export$2692e69612b4a9e9).Top;
                break;
        }
        return format;
    };
    PdfExport.prototype.getFontFamily = function(fontFamily) {
        switch(fontFamily){
            case "TimesRoman":
                return 2;
            case "Courier":
                return 1;
            case "Symbol":
                return 3;
            case "ZapfDingbats":
                return 4;
            default:
                return 0;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PdfExport.prototype.getFont = function(content) {
        if (content.font) return content.font;
        var fontSize = !(0, $3EnZW.isNullOrUndefined)(content.style.fontSize) ? content.style.fontSize * 0.75 : 9.75;
        var fontFamily = !(0, $3EnZW.isNullOrUndefined)(content.style.fontFamily) ? this.getFontFamily(content.style.fontFamily) : (0, $32129651824bb502$export$be66ab191dea7a97).TimesRoman;
        var fontStyle = (0, $32129651824bb502$export$80979869bc40ff1f).Regular;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.bold) && content.style.bold) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Bold;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.italic) && content.style.italic) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Italic;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.underline) && content.style.underline) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Underline;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.strikeout) && content.style.strikeout) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout;
        return new (0, $3d7be084b745fac4$export$2e90fbfccef6edcf)(fontFamily, fontSize, fontStyle);
    };
    PdfExport.prototype.getPageNumberStyle = function(pageNumberType) {
        switch(pageNumberType){
            case "LowerLatin":
                return 2;
            case "LowerRoman":
                return 3;
            case "UpperLatin":
                return 4;
            case "UpperRoman":
                return 5;
            default:
                return 1;
        }
    };
    PdfExport.prototype.setContentFormat = function(content, format) {
        if (!(0, $3EnZW.isNullOrUndefined)(content.size)) {
            var width = content.size.width * 0.75;
            var height = content.size.height * 0.75;
            format = new (0, $0a9de299d3bdc240$export$9e0870cc2541dcff)((0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left, (0, $d174213b46afc09a$export$2692e69612b4a9e9).Middle);
            if (!(0, $3EnZW.isNullOrUndefined)(content.style.hAlign)) switch(content.style.hAlign){
                case "Right":
                    format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Right;
                    break;
                case "Center":
                    format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Center;
                    break;
                case "Justify":
                    format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Justify;
                    break;
                default:
                    format.alignment = (0, $d174213b46afc09a$export$ff2ffbe66a522e26).Left;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(content.style.vAlign)) format = this.getVerticalAlignment(content.style.vAlign, format);
            return {
                format: format,
                size: new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(width, height)
            };
        }
        return null;
    };
    PdfExport.prototype.getPageSize = function(pageSize) {
        switch(pageSize){
            case "Letter":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 792);
            case "Note":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(540, 720);
            case "Legal":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 1008);
            case "A0":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2380, 3368);
            case "A1":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1684, 2380);
            case "A2":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1190, 1684);
            case "A3":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(842, 1190);
            case "A5":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(421, 595);
            case "A6":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(297, 421);
            case "A7":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(210, 297);
            case "A8":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(148, 210);
            case "A9":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(105, 148);
            // case 'A10':
            // return new SizeF(74, 105);
            case "B0":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2836, 4008);
            case "B1":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2004, 2836);
            case "B2":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1418, 2004);
            case "B3":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1002, 1418);
            case "B4":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(709, 1002);
            case "B5":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(501, 709);
            case "Archa":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(648, 864);
            case "Archb":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(864, 1296);
            case "Archc":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1296, 1728);
            case "Archd":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1728, 2592);
            case "Arche":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(2592, 3456);
            case "Flsa":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(612, 936);
            case "HalfLetter":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(396, 612);
            case "Letter11x17":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(792, 1224);
            case "Ledger":
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(1224, 792);
            default:
                return new (0, $e1df9a3657e111f3$export$81f866bb912d8821)(595, 842);
        }
    };
    PdfExport.prototype.getDashStyle = function(dashStyle) {
        switch(dashStyle){
            case "Dash":
                return 1;
            case "Dot":
                return 2;
            case "DashDot":
                return 3;
            case "DashDotDot":
                return 4;
            default:
                return 0;
        }
    };
    PdfExport.prototype.getPenFromContent = function(content) {
        var pen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(0, 0, 0));
        if (!(0, $3EnZW.isNullOrUndefined)(content.style) && content.style !== null && !(0, $3EnZW.isNullOrUndefined)(content.style.penColor)) {
            var penColor = this.hexToRgb(content.style.penColor);
            pen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(penColor.r, penColor.g, penColor.b));
        }
        return pen;
    };
    PdfExport.prototype.getBrushFromContent = function(content) {
        var brush = null;
        if (!(0, $3EnZW.isNullOrUndefined)(content.style.textBrushColor)) {
            /* tslint:disable-next-line:max-line-length */ var brushColor = this.hexToRgb(content.style.textBrushColor);
            brush = new (0, $8d6e90cfe5409a69$export$b12f80b59b66a57e)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(brushColor.r, brushColor.g, brushColor.b));
        }
        return brush;
    };
    PdfExport.prototype.hexToRgb = function(hex) {
        if (hex === null || hex === "" || hex.length !== 7) throw new Error("please set valid hex value for color...");
        hex = hex.substring(1);
        var bigint = parseInt(hex, 16);
        var r = bigint >> 16 & 255;
        var g = bigint >> 8 & 255;
        var b = bigint & 255;
        return {
            r: r,
            g: g,
            b: b
        };
    };
    PdfExport.prototype.getFontStyle = function(theme) {
        var fontStyle = (0, $32129651824bb502$export$80979869bc40ff1f).Regular;
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && theme.bold) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Bold;
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && theme.italic) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Italic;
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && theme.underline) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Underline;
        if (!(0, $3EnZW.isNullOrUndefined)(theme) && theme.strikeout) fontStyle |= (0, $32129651824bb502$export$80979869bc40ff1f).Strikeout;
        return fontStyle;
    };
    PdfExport.prototype.getBorderStyle = function(border) {
        var borders = new (0, $446c769ec2cda75b$export$69818a9b64460535)();
        if (!(0, $3EnZW.isNullOrUndefined)(border)) {
            var borderWidth = border.width;
            // set border width
            var width = !(0, $3EnZW.isNullOrUndefined)(borderWidth) && typeof borderWidth === "number" ? borderWidth * 0.75 : undefined;
            // set border color
            var color = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(196, 196, 196);
            if (!(0, $3EnZW.isNullOrUndefined)(border.color)) {
                var borderColor = this.hexToRgb(border.color);
                color = new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(borderColor.r, borderColor.g, borderColor.b);
            }
            var pen = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(color, width);
            // set border dashStyle 'Solid <default>, Dash, Dot, DashDot, DashDotDot'
            if (!(0, $3EnZW.isNullOrUndefined)(border.dashStyle)) pen.dashStyle = this.getDashStyle(border.dashStyle);
            borders.all = pen;
        } else borders.all = new (0, $54efcdfb173c5ebf$export$c07084e815da81a4)(new (0, $e81c483e1287b796$export$4eb81a4e8d53d55d)(234, 234, 234));
        return borders;
    };
    PdfExport.prototype.destroy = function() {
    //destroy for exporting
    };
    return PdfExport;
}();




var $91a2a42ce66cdfd8$export$832250593589325a = {
    header: "." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0,
    content: "." + $1b5568e76cdae6d4$export$ee5f1442ff7df474,
    edit: ".e-inline-edit",
    batchEdit: ".e-editedbatchcell",
    editIcon: "e-edit",
    pager: ".e-gridpager",
    delete: "e-delete",
    save: "e-save",
    cancel: "e-cancel",
    copy: "e-copy",
    pdf: "e-pdfexport",
    group: "e-icon-group",
    ungroup: "e-icon-ungroup",
    csv: "e-csvexport",
    excel: "e-excelexport",
    fPage: "e-icon-first",
    nPage: "e-icon-next",
    lPage: "e-icon-last",
    pPage: "e-icon-prev",
    ascending: "e-icon-ascending",
    descending: "e-icon-descending",
    groupHeader: "e-groupdroparea",
    touchPop: "e-gridpopup"
};
/**
 * The `ContextMenu` module is used to handle context menu actions.
 */ var $91a2a42ce66cdfd8$export$8dc6765e8be191c7 = /** @class */ function() {
    function ContextMenu(parent, serviceLocator) {
        this.defaultItems = {};
        this.disableItems = [];
        this.hiddenItems = [];
        this.localeText = this.setLocaleKey();
        this.parent = parent;
        this.gridID = parent.element.id;
        this.serviceLocator = serviceLocator;
        this.addEventListener();
    }
    /**
     * @returns {void}
     * @hidden
     */ ContextMenu.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRenderMenu, this);
        this.parent.on($17b89d3b1fc93cdb$export$b70fe0c8c3456154, this.render, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
    };
    /**
     * @returns {void}
     * @hidden
     */ ContextMenu.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($17b89d3b1fc93cdb$export$b70fe0c8c3456154, this.render);
        this.parent.off($17b89d3b1fc93cdb$export$27ad5926bed65d9, this.enableAfterRenderMenu);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.keyDownHandler.bind(this));
    };
    ContextMenu.prototype.keyDownHandler = function(e) {
        if (e.code === "Tab" || e.which === 9) this.contextMenu.close();
        if (e.code === "Escape") {
            this.contextMenu.close();
            this.parent.notify($17b89d3b1fc93cdb$export$2284e449d64b22d5, {});
        }
    };
    ContextMenu.prototype.render = function() {
        this.parent.element.classList.add("e-noselect");
        this.l10n = this.serviceLocator.getService("localization");
        this.element = this.parent.createElement("ul", {
            id: this.gridID + "_cmenu"
        });
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.keyDownHandler.bind(this));
        this.parent.element.appendChild(this.element);
        var target = "#" + this.gridID;
        this.contextMenu = new (0, $4017afccb487b2c7$export$8dc6765e8be191c7)({
            items: this.getMenuItems(),
            enableRtl: this.parent.enableRtl,
            enablePersistence: this.parent.enablePersistence,
            locale: this.parent.locale,
            target: target,
            select: this.contextMenuItemClick.bind(this),
            beforeOpen: this.contextMenuBeforeOpen.bind(this),
            onOpen: this.contextMenuOpen.bind(this),
            onClose: this.contextMenuOnClose.bind(this),
            cssClass: this.parent.cssClass ? "e-grid-menu " + this.parent.cssClass : "e-grid-menu"
        });
        this.contextMenu.appendTo(this.element);
    };
    ContextMenu.prototype.enableAfterRenderMenu = function(e) {
        if (e.module === this.getModuleName() && e.enable) {
            if (this.contextMenu) {
                this.contextMenu.destroy();
                (0, $4ZDHT.remove)(this.element);
                this.parent.element.classList.remove("e-noselect");
            }
            this.render();
        }
    };
    ContextMenu.prototype.getMenuItems = function() {
        var menuItems = [];
        var exportItems = [];
        for(var _i = 0, _a = this.parent.contextMenuItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string" && this.getDefaultItems().indexOf(item) !== -1) {
                if (item.toLocaleLowerCase().indexOf("export") !== -1) exportItems.push(this.buildDefaultItems(item));
                else menuItems.push(this.buildDefaultItems(item));
            } else if (typeof item !== "string") menuItems.push(item);
        }
        if (exportItems.length > 0) {
            var exportGroup = this.buildDefaultItems("export");
            exportGroup.items = exportItems;
            menuItems.push(exportGroup);
        }
        return menuItems;
    };
    ContextMenu.prototype.getLastPage = function() {
        var totalpage = Math.floor(this.parent.pageSettings.totalRecordsCount / this.parent.pageSettings.pageSize);
        if (this.parent.pageSettings.totalRecordsCount % this.parent.pageSettings.pageSize) totalpage += 1;
        return totalpage;
    };
    ContextMenu.prototype.contextMenuOpen = function() {
        this.isOpen = true;
    };
    /**
     * @param {ContextMenuClickEventArgs} args - specifies the ContextMenuClickEventArgs argument type
     * @returns {void}
     * @hidden
     */ ContextMenu.prototype.contextMenuItemClick = function(args) {
        var item = this.getKeyFromId(args.item.id);
        switch(item){
            case "AutoFitAll":
                this.parent.autoFitColumns([]);
                break;
            case "AutoFit":
                this.parent.autoFitColumns(this.targetColumn.field);
                break;
            case "Group":
                this.parent.groupColumn(this.targetColumn.field);
                break;
            case "Ungroup":
                this.parent.ungroupColumn(this.targetColumn.field);
                break;
            case "Edit":
                if (this.parent.editModule) {
                    if (this.parent.editSettings.mode === "Batch") {
                        if (this.row && this.cell && !isNaN(parseInt(this.cell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10))) this.parent.editModule.editCell(parseInt(this.row.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10), // eslint-disable-next-line
                        this.parent.getColumns()[parseInt(this.cell.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10)].field);
                    } else {
                        this.parent.editModule.endEdit();
                        this.parent.editModule.startEdit(this.row);
                    }
                }
                break;
            case "Delete":
                if (this.parent.editModule) {
                    if (this.parent.editSettings.mode !== "Batch") this.parent.editModule.endEdit();
                    if (this.parent.getSelectedRecords().length === 1) this.parent.editModule.deleteRow(this.row);
                    else this.parent.deleteRecord();
                }
                break;
            case "Save":
                if (this.parent.editModule) this.parent.editModule.endEdit();
                break;
            case "Cancel":
                if (this.parent.editModule) this.parent.editModule.closeEdit();
                break;
            case "Copy":
                this.parent.copy();
                break;
            case "PdfExport":
                this.parent.pdfExport();
                break;
            case "ExcelExport":
                this.parent.excelExport();
                break;
            case "CsvExport":
                this.parent.csvExport();
                break;
            case "SortAscending":
                this.isOpen = false;
                this.parent.sortColumn(this.targetColumn.field, "Ascending");
                break;
            case "SortDescending":
                this.isOpen = false;
                this.parent.sortColumn(this.targetColumn.field, "Descending");
                break;
            case "FirstPage":
                this.parent.goToPage(1);
                break;
            case "PrevPage":
                this.parent.goToPage(this.parent.pageSettings.currentPage - 1);
                break;
            case "LastPage":
                this.parent.goToPage(this.getLastPage());
                break;
            case "NextPage":
                this.parent.goToPage(this.parent.pageSettings.currentPage + 1);
                break;
        }
        args.column = this.targetColumn;
        args.rowInfo = this.targetRowdata;
        this.parent.trigger($17b89d3b1fc93cdb$export$d21e637e8c1f5e9d, args);
    };
    ContextMenu.prototype.contextMenuOnClose = function(args) {
        var parent = "parentObj";
        if (args.items.length > 0 && args.items[0]["" + parent] instanceof (0, $4017afccb487b2c7$export$8dc6765e8be191c7)) this.updateItemStatus();
        this.parent.notify($17b89d3b1fc93cdb$export$dee075e2eb3f74a8, {
            isOpen: false
        });
    };
    ContextMenu.prototype.getLocaleText = function(item) {
        return this.l10n.getConstant(this.localeText["" + item]);
    };
    ContextMenu.prototype.updateItemStatus = function() {
        this.contextMenu.showItems(this.hiddenItems);
        this.contextMenu.enableItems(this.disableItems);
        this.hiddenItems = [];
        this.disableItems = [];
        this.isOpen = false;
    };
    ContextMenu.prototype.contextMenuBeforeOpen = function(args) {
        var closestGrid = (0, $4ZDHT.closest)(args.event.target, ".e-grid");
        if (args.event && closestGrid && closestGrid !== this.parent.element) args.cancel = true;
        else if (args.event && ((0, $4ZDHT.closest)(args.event.target, "." + $91a2a42ce66cdfd8$export$832250593589325a.groupHeader) || (0, $4ZDHT.closest)(args.event.target, "." + $91a2a42ce66cdfd8$export$832250593589325a.touchPop) || (0, $4ZDHT.closest)(args.event.target, ".e-summarycell") || (0, $4ZDHT.closest)(args.event.target, ".e-groupcaption") || (0, $4ZDHT.closest)(args.event.target, ".e-filterbarcell")) || this.parent.editSettings.showAddNewRow && (0, $4ZDHT.closest)(args.event.target, ".e-addedrow") && this.parent.element.querySelector(".e-editedrow")) args.cancel = true;
        else {
            this.targetColumn = this.getColumn(args.event);
            if ((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(args.event.target, "e-grid")) this.targetRowdata = this.parent.getRowInfo(args.event.target);
            if ((0, $3EnZW.isNullOrUndefined)(args.parentItem) && this.targetColumn) {
                if (this.targetRowdata.cell) {
                    this.parent.notify($17b89d3b1fc93cdb$export$dee075e2eb3f74a8, {
                        isOpen: true
                    });
                    this.selectRow(args.event, this.targetRowdata.cell.classList.contains("e-selectionbackground") && this.parent.selectionSettings.type === "Multiple" ? false : true);
                }
            }
            var hideSepItems = [];
            var showSepItems = [];
            for(var _i = 0, _a = args.items; _i < _a.length; _i++){
                var item = _a[_i];
                var key = this.getKeyFromId(item.id);
                var dItem = this.defaultItems["" + key];
                if (this.getDefaultItems().indexOf(key) !== -1) {
                    if (this.ensureDisabledStatus(key)) this.disableItems.push(item.text);
                    if (args.event && (this.ensureTarget(args.event.target, $91a2a42ce66cdfd8$export$832250593589325a.edit) || this.ensureTarget(args.event.target, $91a2a42ce66cdfd8$export$832250593589325a.batchEdit))) {
                        if (key !== "Save" && key !== "Cancel") this.hiddenItems.push(item.text);
                    } else if (this.parent.editModule && this.parent.editSettings.mode === "Batch" && ((0, $4ZDHT.closest)(args.event.target, ".e-gridform") || this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$f7789a67e74c1e3f].length || this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$aef5e1398935f398].length || this.parent.editModule.getBatchChanges()[$1b5568e76cdae6d4$export$c509ef778c751c4e].length) && (key === "Save" || key === "Cancel")) continue;
                    else if ((0, $3EnZW.isNullOrUndefined)(args.parentItem) && args.event && !this.ensureTarget(args.event.target, dItem.target)) this.hiddenItems.push(item.text);
                } else if (item.target && args.event && !this.ensureTarget(args.event.target, item.target)) {
                    if (item.separator) hideSepItems.push(item.id);
                    else this.hiddenItems.push(item.text);
                } else if (this.ensureTarget(args.event.target, item.target) && item.separator) showSepItems.push(item.id);
            }
            if (showSepItems.length > 0) this.contextMenu.showItems(showSepItems, true);
            this.contextMenu.enableItems(this.disableItems, false);
            this.contextMenu.hideItems(this.hiddenItems);
            if (hideSepItems.length > 0) this.contextMenu.hideItems(hideSepItems, true);
            this.eventArgs = args.event;
            args.column = this.targetColumn;
            args.rowInfo = this.targetRowdata;
            this.parent.trigger($17b89d3b1fc93cdb$export$f34b303782c25f4, args);
            if (args.cancel || this.hiddenItems.length === args.items.length && !args.parentItem) {
                this.updateItemStatus();
                args.cancel = true;
            }
        }
        (0, $748c2240e597a9b7$export$b6c750d9a4b9bf2b)(this.parent.element, this.contextMenu.element.parentElement);
    };
    ContextMenu.prototype.ensureTarget = function(targetElement, selector) {
        var target = targetElement;
        if (this.ensureFrozenHeader(targetElement) && (selector === $91a2a42ce66cdfd8$export$832250593589325a.header || selector === $91a2a42ce66cdfd8$export$832250593589325a.content)) target = (0, $4ZDHT.closest)(targetElement, selector === $91a2a42ce66cdfd8$export$832250593589325a.header ? "thead" : $1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        else if (selector === $91a2a42ce66cdfd8$export$832250593589325a.content || selector === $91a2a42ce66cdfd8$export$832250593589325a.header) target = (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)((0, $4ZDHT.closest)(targetElement, "." + $1b5568e76cdae6d4$export$9852986a3ec5f6a0), selector.substr(1, selector.length));
        else target = (0, $4ZDHT.closest)(targetElement, selector);
        return target && (0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(target, "e-grid") === this.parent.element;
    };
    ContextMenu.prototype.ensureFrozenHeader = function(targetElement) {
        return this.parent.frozenRows && (0, $4ZDHT.closest)(targetElement, $91a2a42ce66cdfd8$export$832250593589325a.header) ? true : false;
    };
    ContextMenu.prototype.ensureDisabledStatus = function(item) {
        var status = false;
        switch(item){
            case "AutoFitAll":
            case "AutoFit":
                status = !(this.parent.ensureModuleInjected((0, $6807bc11aae112a3$export$76856258f71db1ea)) && !this.parent.isEdit) || this.targetColumn && !this.targetColumn.field && item === "AutoFit";
                break;
            case "Group":
                if (!this.parent.allowGrouping || this.parent.ensureModuleInjected((0, $59e0e5762e06e953$export$eb2fcfdbd7ba97d4)) && this.targetColumn && this.parent.groupSettings.columns.indexOf(this.targetColumn.field) >= 0 || this.targetColumn && !this.targetColumn.field) status = true;
                break;
            case "Ungroup":
                if (!this.parent.allowGrouping || !this.parent.ensureModuleInjected((0, $59e0e5762e06e953$export$eb2fcfdbd7ba97d4)) || this.parent.ensureModuleInjected((0, $59e0e5762e06e953$export$eb2fcfdbd7ba97d4)) && this.targetColumn && this.parent.groupSettings.columns.indexOf(this.targetColumn.field) < 0) status = true;
                break;
            case "Edit":
            case "Delete":
            case "Save":
            case "Cancel":
                if (!this.parent.editModule || this.parent.getDataRows().length === 0) status = true;
                break;
            case "Copy":
                if (this.parent.getSelectedRowIndexes().length === 0 && this.parent.getSelectedRowCellIndexes().length === 0 || this.parent.getCurrentViewRecords().length === 0) status = true;
                break;
            case "export":
                if (!this.parent.allowExcelExport || !this.parent.excelExport || !this.parent.ensureModuleInjected((0, $b844ce8ad16ed721$export$425bf53802e2b731)) && !this.parent.ensureModuleInjected((0, $0f7a73cd92e9f074$export$9860ff607cfdeed8))) status = true;
                break;
            case "PdfExport":
                if (!this.parent.allowPdfExport || !this.parent.ensureModuleInjected((0, $b844ce8ad16ed721$export$425bf53802e2b731))) status = true;
                break;
            case "ExcelExport":
            case "CsvExport":
                if (!this.parent.allowExcelExport || !this.parent.ensureModuleInjected((0, $0f7a73cd92e9f074$export$9860ff607cfdeed8))) status = true;
                break;
            case "SortAscending":
            case "SortDescending":
                if (!this.parent.allowSorting || !this.parent.ensureModuleInjected((0, $e02f22598f2cfb09$export$d43f91ac58cde147)) || this.targetColumn && !this.targetColumn.field) status = true;
                else if (this.parent.ensureModuleInjected((0, $e02f22598f2cfb09$export$d43f91ac58cde147)) && this.parent.sortSettings.columns.length > 0 && this.targetColumn) {
                    var sortColumns = this.parent.sortSettings.columns;
                    for(var i = 0; i < sortColumns.length; i++)if (sortColumns[parseInt(i.toString(), 10)].field === this.targetColumn.field && sortColumns[parseInt(i.toString(), 10)].direction.toLowerCase() === item.toLowerCase().replace("sort", "").toLocaleLowerCase()) status = true;
                }
                break;
            case "FirstPage":
            case "PrevPage":
                if (!this.parent.allowPaging || !this.parent.ensureModuleInjected((0, $5d65e63dd7eec2c1$export$6955bcca4cd3539f)) || this.parent.getCurrentViewRecords().length === 0 || this.parent.ensureModuleInjected((0, $5d65e63dd7eec2c1$export$6955bcca4cd3539f)) && this.parent.pageSettings.currentPage === 1) status = true;
                break;
            case "LastPage":
            case "NextPage":
                if (!this.parent.allowPaging || !this.parent.ensureModuleInjected((0, $5d65e63dd7eec2c1$export$6955bcca4cd3539f)) || this.parent.getCurrentViewRecords().length === 0 || this.parent.ensureModuleInjected((0, $5d65e63dd7eec2c1$export$6955bcca4cd3539f)) && this.parent.pageSettings.currentPage === this.getLastPage()) status = true;
                break;
        }
        return status;
    };
    /**
     * Gets the context menu element from the Grid.
     *
     * @returns {Element} returns the element
     */ ContextMenu.prototype.getContextMenu = function() {
        return this.element;
    };
    /**
     * Destroys the context menu component in the Grid.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ ContextMenu.prototype.destroy = function() {
        var gridElement = this.parent.element;
        if (!gridElement || !gridElement.querySelector("." + $1b5568e76cdae6d4$export$b8cf6f078a9012e0) && !gridElement.querySelector("." + $1b5568e76cdae6d4$export$ee5f1442ff7df474)) return;
        if (this.contextMenu) {
            this.contextMenu.select = null;
            this.contextMenu.beforeOpen = null;
            this.contextMenu.onOpen = null;
            this.contextMenu.onClose = null;
        }
        this.removeEventListener();
        this.contextMenu.destroy();
        if (this.element.parentNode) (0, $4ZDHT.remove)(this.element);
        this.parent.element.classList.remove("e-noselect");
    };
    ContextMenu.prototype.getModuleName = function() {
        return "contextMenu";
    };
    ContextMenu.prototype.generateID = function(item) {
        return this.gridID + "_cmenu_" + item;
    };
    ContextMenu.prototype.getKeyFromId = function(id) {
        return id.replace(this.gridID + "_cmenu_", "");
    };
    ContextMenu.prototype.buildDefaultItems = function(item) {
        var menuItem;
        switch(item){
            case "AutoFitAll":
            case "AutoFit":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.header
                };
                break;
            case "Group":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.header,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.group
                };
                break;
            case "Ungroup":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.header,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.ungroup
                };
                break;
            case "Edit":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.editIcon
                };
                break;
            case "Delete":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.delete
                };
                break;
            case "Save":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.edit,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.save
                };
                break;
            case "Cancel":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.edit,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.cancel
                };
                break;
            case "Copy":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.copy
                };
                break;
            case "export":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content
                };
                break;
            case "PdfExport":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.pdf
                };
                break;
            case "ExcelExport":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.excel
                };
                break;
            case "CsvExport":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.content,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.csv
                };
                break;
            case "SortAscending":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.header,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.ascending
                };
                break;
            case "SortDescending":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.header,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.descending
                };
                break;
            case "FirstPage":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.pager,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.fPage
                };
                break;
            case "PrevPage":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.pager,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.pPage
                };
                break;
            case "LastPage":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.pager,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.lPage
                };
                break;
            case "NextPage":
                menuItem = {
                    target: $91a2a42ce66cdfd8$export$832250593589325a.pager,
                    iconCss: $91a2a42ce66cdfd8$export$832250593589325a.nPage
                };
                break;
        }
        this.defaultItems["" + item] = {
            text: this.getLocaleText(item),
            id: this.generateID(item),
            target: menuItem.target,
            iconCss: menuItem.iconCss ? "e-icons " + menuItem.iconCss : ""
        };
        return this.defaultItems["" + item];
    };
    ContextMenu.prototype.getDefaultItems = function() {
        return [
            "AutoFitAll",
            "AutoFit",
            "Group",
            "Ungroup",
            "Edit",
            "Delete",
            "Save",
            "Cancel",
            "Copy",
            "export",
            "PdfExport",
            "ExcelExport",
            "CsvExport",
            "SortAscending",
            "SortDescending",
            "FirstPage",
            "PrevPage",
            "LastPage",
            "NextPage"
        ];
    };
    ContextMenu.prototype.setLocaleKey = function() {
        var localeKeys = {
            "AutoFitAll": "autoFitAll",
            "AutoFit": "autoFit",
            "Copy": "Copy",
            "Group": "Group",
            "Ungroup": "Ungroup",
            "Edit": "EditRecord",
            "Delete": "DeleteRecord",
            "Save": "Save",
            "Cancel": "CancelButton",
            "PdfExport": "Pdfexport",
            "ExcelExport": "Excelexport",
            "CsvExport": "Csvexport",
            "export": "Export",
            "SortAscending": "SortAscending",
            "SortDescending": "SortDescending",
            "FirstPage": "FirstPage",
            "LastPage": "LastPage",
            "PrevPage": "PreviousPage",
            "NextPage": "NextPage"
        };
        return localeKeys;
    };
    ContextMenu.prototype.getColumn = function(e) {
        var cell = (0, $4ZDHT.closest)(e.target, "th.e-headercell");
        if (cell) {
            var uid = cell.querySelector(".e-headercelldiv, .e-stackedheadercelldiv").getAttribute("e-mappinguid");
            return this.parent.getColumnByUid(uid);
        } else {
            var ele = this.parent.getRowInfo(e.target).column;
            return ele || null;
        }
    };
    ContextMenu.prototype.selectRow = function(e, isSelectable) {
        this.cell = e.target;
        this.row = (0, $4ZDHT.closest)(e.target, "tr.e-row") || this.row;
        if (this.row && isSelectable && !(0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(e.target, "e-gridpager")) this.parent.selectRow(parseInt(this.row.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10));
    };
    return ContextMenu;
}();



parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");





parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
var $aqzbR = parcelRequire("aqzbR");
/**
 * InterSectionObserver - class watch whether it enters the viewport.
 *
 * @hidden
 */ var $92f1ac473c8a887f$export$1956e4e512cc09ce = /** @class */ function() {
    function InterSectionObserver(element, options, movableEle) {
        var _this = this;
        this.fromWheel = false;
        this.touchMove = false;
        this.options = {};
        this.sentinelInfo = {
            "up": {
                check: function(rect, info) {
                    var top = rect.top - _this.containerRect.top;
                    var bottom = _this.containerRect.bottom > rect.bottom ? _this.containerRect.bottom - rect.bottom : 0;
                    info.entered = top >= 0;
                    return top + _this.options.pageHeight / 2 >= 0 || bottom > 0 && rect.bottom > 0;
                },
                axis: "Y"
            },
            "down": {
                check: function(rect, info) {
                    var bottom = rect.bottom;
                    info.entered = rect.bottom <= _this.containerRect.bottom;
                    return bottom - _this.containerRect.top - _this.options.pageHeight / 2 <= _this.options.pageHeight / 2;
                },
                axis: "Y"
            },
            "right": {
                check: function(rect, info) {
                    var right = rect.right;
                    info.entered = right < _this.containerRect.right;
                    return right - _this.containerRect.width <= _this.containerRect.right;
                },
                axis: "X"
            },
            "left": {
                check: function(rect, info) {
                    var left = rect.left;
                    info.entered = left > 0;
                    return left + _this.containerRect.width >= _this.containerRect.left;
                },
                axis: "X"
            }
        };
        this.element = element;
        this.options = options;
        this.movableEle = movableEle;
    }
    InterSectionObserver.prototype.observe = function(callback, onEnterCallback) {
        var _this = this;
        this.containerRect = this.options.container.getBoundingClientRect();
        (0, $aqzbR.EventHandler).add(this.options.container, "wheel", function() {
            return _this.fromWheel = true;
        }, this);
        (0, $aqzbR.EventHandler).add(this.options.container, "scroll", this.virtualScrollHandler(callback, onEnterCallback), this);
    };
    InterSectionObserver.prototype.check = function(direction) {
        var info = this.sentinelInfo["" + direction];
        return info.check(this.element.getBoundingClientRect(), info);
    };
    InterSectionObserver.prototype.virtualScrollHandler = function(callback, onEnterCallback) {
        var _this = this;
        var delay = (0, $5q7BP.Browser).info.name === "chrome" ? 200 : 100;
        var debounced100 = (0, $3EnZW.debounce)(callback, delay);
        var debounced50 = (0, $3EnZW.debounce)(callback, 50);
        this.options.prevTop = this.options.prevLeft = 0;
        return function(e) {
            var top = e.target.scrollTop;
            var left = e.target.scrollLeft;
            var direction = _this.options.prevTop < top ? "down" : "up";
            direction = _this.options.prevLeft === left ? direction : _this.options.prevLeft < left ? "right" : "left";
            _this.options.prevTop = top;
            _this.options.prevLeft = left;
            var current = _this.sentinelInfo["" + direction];
            if (_this.options.axes.indexOf(current.axis) === -1) return;
            _this.containerRect = _this.options.container.getBoundingClientRect();
            var check = _this.check(direction);
            if (current.entered) onEnterCallback(_this.element, current, direction, {
                top: top,
                left: left
            }, _this.fromWheel, check);
            if (check) {
                var fn = debounced100;
                //this.fromWheel ? this.options.debounceEvent ? debounced100 : callback : debounced100;
                if (current.axis === "X") fn = debounced50;
                fn({
                    direction: direction,
                    sentinel: current,
                    offset: {
                        top: top,
                        left: left
                    },
                    focusElement: document.activeElement
                });
            }
            _this.fromWheel = false;
        };
    };
    InterSectionObserver.prototype.setPageHeight = function(value) {
        this.options.pageHeight = value;
    };
    return InterSectionObserver;
}();


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");





/**
 * Content module is used to render grid content
 */ var $ef57b291636ad58b$export$78ac632d55fb89a = /** @class */ function() {
    function VirtualRowModelGenerator(parent) {
        this.cOffsets = {};
        this.cache = {};
        this.rowCache = {};
        this.data = {};
        this.groups = {};
        this.currentInfo = {};
        this.prevInfo = {};
        this.parent = parent;
        this.model = this.parent.pageSettings;
        this.rowModelGenerator = this.parent.allowGrouping ? new (0, $00f5ac64cc4c9276$export$e121011a4bc11d9e)(this.parent) : new (0, $7ddfd3da489c240b$export$2cf41885b7ecbd06)(this.parent);
    }
    VirtualRowModelGenerator.prototype.columnInfiniteRows = function(data, e) {
        var result = [];
        if (e.requestType === "virtualscroll") {
            var rows = this.parent.getRowsObject();
            // eslint-disable-next-line prefer-spread
            result.push.apply(result, this.rowModelGenerator.refreshRows(rows));
            if (this.parent.infiniteScrollSettings.enableCache) {
                var currentRowStartIndex = this.parent.frozenRows && this.parent.pageSettings.currentPage === 1 ? 0 : (0, $748c2240e597a9b7$export$cc75f426469dab70)(this.parent.getContentTable().querySelector(".e-row:not(.e-addedrow)"));
                var newResult = result.slice(currentRowStartIndex, currentRowStartIndex + this.parent.pageSettings.pageSize * 3);
                if (this.parent.frozenRows && this.parent.pageSettings.currentPage !== 1) newResult = result.slice(0, this.parent.frozenRows).concat(newResult);
                result = newResult;
            }
        } else // eslint-disable-next-line prefer-spread
        result.push.apply(result, this.rowModelGenerator.generateRows(data, e));
        return result;
    };
    VirtualRowModelGenerator.prototype.generateRows = function(data, e) {
        var _this = this;
        if (this.parent.enableColumnVirtualization && this.parent.enableInfiniteScrolling) return this.columnInfiniteRows(data, e);
        var isManualRefresh = false;
        var info = e.virtualInfo = e.virtualInfo || (e.requestType === "sorting" || e.requestType === "delete") && (0, $748c2240e597a9b7$export$bab3117844264a75)(this.parent) && this.prevInfo || this.getData();
        this.prevInfo = info;
        var xAxis = info.sentinelInfo && info.sentinelInfo.axis === "X";
        var page = !xAxis && info.loadNext && !info.loadSelf ? info.nextInfo.page : info.page;
        var result = [];
        var indexes = this.getBlockIndexes(page);
        var loadedBlocks = [];
        if (this.currentInfo.blockIndexes) {
            indexes = info.blockIndexes = e.virtualInfo.blockIndexes = this.includePrevPage ? this.currentInfo.blockIndexes.slice(1) : this.currentInfo.blockIndexes.slice(0, this.currentInfo.blockIndexes.length - 1);
            isManualRefresh = true;
        }
        this.checkAndResetCache(e.requestType);
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && this.parent.vcRows.length) {
            var dataRows = this.parent.vcRows.filter(function(row) {
                return row.isDataRow;
            });
            if (this.parent.isManualRefresh && dataRows.length === data["records"].length || !this.parent.isManualRefresh) return result = this.parent.vcRows;
        }
        if (this.parent.enableColumnVirtualization) {
            for(var i = 0; i < info.blockIndexes.length; i++)if (this.isBlockAvailable(info.blockIndexes[parseInt(i.toString(), 10)])) this.cache[info.blockIndexes[parseInt(i.toString(), 10)]] = this.rowModelGenerator.refreshRows(this.cache[info.blockIndexes[parseInt(i.toString(), 10)]]);
        }
        var values = info.blockIndexes;
        var _loop_1 = function(i) {
            if (!this_1.isBlockAvailable(values[parseInt(i.toString(), 10)])) {
                var startIdx = !(0, $3EnZW.isNullOrUndefined)(this_1.startIndex) ? this_1.startIndex : this_1.getStartIndex(values[parseInt(i.toString(), 10)], data);
                startIdx = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this_1.parent) && !this_1.parent.vcRows.length && (e.requestType === "sorting" || e.requestType === "delete") ? 0 : startIdx;
                var rows = this_1.rowModelGenerator.generateRows(data, {
                    virtualInfo: info,
                    startIndex: startIdx
                });
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this_1.parent) && !this_1.parent.vcRows.length) {
                    this_1.recordsCount = data.records.length;
                    this_1.parent.vRows = rows;
                    this_1.parent.vcRows = rows;
                    this_1.parent.notify($17b89d3b1fc93cdb$export$8fcd90c21e6d64a3, {});
                }
                var median = void 0;
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this_1.parent)) this_1.getGroupVirtualRecordsByIndex(rows);
                else {
                    if (isManualRefresh) this_1.setBlockForManualRefresh(this_1.cache, indexes, rows);
                    else if ((e.requestType === "sorting" || e.requestType === "delete") && (0, $748c2240e597a9b7$export$bab3117844264a75)(this_1.parent)) {
                        var visiblePage = (0, $748c2240e597a9b7$export$e3139d168f68ec7e)(info.blockIndexes);
                        var prevEndIndex = 0;
                        for(var i_1 = 0; i_1 < visiblePage.length; i_1++){
                            var indexes_1 = this_1.getBlockIndexes(visiblePage[parseInt(i_1.toString(), 10)]);
                            var startIndex = this_1.model.pageSize * i_1;
                            var endIndex = startIndex + this_1.model.pageSize;
                            if (this_1.parent.allowGrouping && this_1.parent.groupSettings.columns.length) {
                                var dataRowObject = rows.filter(function(row) {
                                    return row.isDataRow;
                                }).slice(startIndex, endIndex);
                                startIndex = prevEndIndex;
                                endIndex = rows.indexOf(dataRowObject[dataRowObject.length - 1]) + 1;
                            }
                            var pageRecord = rows.slice(startIndex, endIndex);
                            var median_1 = ~~Math.max(pageRecord.length, this_1.model.pageSize) / 2;
                            if (!this_1.isBlockAvailable(indexes_1[0])) this_1.cache[indexes_1[0]] = pageRecord.slice(0, median_1);
                            if (!this_1.isBlockAvailable(indexes_1[1])) this_1.cache[indexes_1[1]] = pageRecord.slice(median_1);
                            prevEndIndex = endIndex;
                        }
                    } else {
                        median = ~~Math.max(rows.length, this_1.model.pageSize) / 2;
                        if (!this_1.isBlockAvailable(indexes[0])) this_1.cache[indexes[0]] = rows.slice(0, median);
                        if (!this_1.isBlockAvailable(indexes[1])) this_1.cache[indexes[1]] = rows.slice(median);
                    }
                }
            }
            if (this_1.parent.groupSettings.columns.length && !xAxis && this_1.cache[values[parseInt(i.toString(), 10)]] && !this_1.parent.groupSettings.enableLazyLoading) this_1.cache[values[parseInt(i.toString(), 10)]] = this_1.updateGroupRow(this_1.cache[values[parseInt(i.toString(), 10)]], values[parseInt(i.toString(), 10)]);
            if (!e.renderMovableContent && !e.renderFrozenRightContent && this_1.cache[values[parseInt(i.toString(), 10)]]) {
                // eslint-disable-next-line prefer-spread
                result.push.apply(result, this_1.cache[values[parseInt(i.toString(), 10)]]);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var DataRecord_1 = [];
                if (this_1.parent.enableVirtualization && this_1.parent.groupSettings.columns.length) result.forEach(function(data) {
                    if (!DataRecord_1.includes(data)) DataRecord_1.push(data);
                });
                result = DataRecord_1.length ? DataRecord_1 : result;
            }
            if (this_1.isBlockAvailable(values[parseInt(i.toString(), 10)])) loadedBlocks.push(values[parseInt(i.toString(), 10)]);
        };
        var this_1 = this;
        for(var i = 0; i < values.length; i++)_loop_1(i);
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && this.parent.vcRows.length && e.requestType === "sorting" && e.scrollTop.top !== 0) return result = this.parent.vcRows;
        info.blockIndexes = loadedBlocks;
        var grouping = "records";
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) this.parent.currentViewData["" + grouping] = result.map(function(m) {
            return m.data;
        });
        else this.parent.currentViewData = result.map(function(m) {
            return m.data;
        });
        if (e.requestType === "grouping") this.parent.currentViewData["" + grouping] = this.parent.currentViewData["" + grouping].filter(function(item, index) {
            return _this.parent.currentViewData["" + grouping].indexOf(item) === index;
        });
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && this.parent.vcRows.length) {
            if ([
                "save",
                "delete"
            ].some(function(value) {
                return e.requestType === value;
            })) return result = this.parent.vcRows;
        }
        return result;
    };
    VirtualRowModelGenerator.prototype.setBlockForManualRefresh = function(cache, blocks, rows) {
        var size = this.model.pageSize / 2;
        if (this.includePrevPage) {
            cache[blocks[0] - 1] = rows.slice(0, size);
            cache[blocks[0]] = rows.slice(size, size * 2);
            cache[blocks[1]] = rows.slice(size * 2, size * 3);
            cache[blocks[2]] = rows.slice(size * 3, size * 4);
        } else {
            cache[blocks[0]] = rows.slice(0, size);
            cache[blocks[1]] = rows.slice(size, size * 2);
            cache[blocks[2]] = rows.slice(size * 2, size * 3);
            cache[blocks[2] + 1] = rows.slice(size * 3, size * 4);
        }
    };
    VirtualRowModelGenerator.prototype.getBlockIndexes = function(page) {
        return [
            page + (page - 1),
            page * 2
        ];
    };
    VirtualRowModelGenerator.prototype.getPage = function(block) {
        return block % 2 === 0 ? block / 2 : (block + 1) / 2;
    };
    VirtualRowModelGenerator.prototype.isBlockAvailable = function(value) {
        return value in this.cache;
    };
    VirtualRowModelGenerator.prototype.getData = function() {
        return {
            page: this.model.currentPage,
            blockIndexes: this.getBlockIndexes(this.model.currentPage),
            direction: "down",
            columnIndexes: this.parent.getColumnIndexesInView()
        };
    };
    VirtualRowModelGenerator.prototype.getStartIndex = function(blk, data, full) {
        if (full === void 0) full = true;
        var page = this.getPage(blk);
        var even = blk % 2 === 0;
        var index = (page - 1) * this.model.pageSize;
        return full || !even ? index : index + ~~(this.model.pageSize / 2);
    };
    VirtualRowModelGenerator.prototype.getColumnIndexes = function(content) {
        var _this = this;
        if (content === void 0) content = this.parent.getHeaderContent().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
        var indexes = [];
        var sLeft = content.scrollLeft | 0;
        var keys = Object.keys(this.cOffsets);
        var cWidth = content.getBoundingClientRect().width;
        sLeft = Math.min(this.cOffsets[keys.length - 1] - cWidth, sLeft);
        var calWidth = (0, $5q7BP.Browser).isDevice ? 2 * cWidth : cWidth / 2;
        var left = sLeft + cWidth + (sLeft === 0 ? calWidth : 0);
        var frzLeftWidth = 0;
        var diffWidth = sLeft - calWidth;
        if (this.parent.isFrozenGrid()) {
            frzLeftWidth = this.parent.leftrightColumnWidth("left");
            if (diffWidth > 0) {
                for(var i = this.parent.getVisibleFrozenLeftCount() - 1; i >= 0; i--)if (diffWidth <= this.cOffsets[parseInt(i.toString(), 10)]) {
                    frzLeftWidth = frzLeftWidth - this.cOffsets[parseInt(i.toString(), 10)];
                    break;
                }
            }
            if (this.parent.getFrozenMode() === $1b5568e76cdae6d4$export$dbca8b7c1e4e42a2) {
                var rightCol = this.parent.getVisibleFrozenRightCount();
                keys.splice(keys.length - 1 - rightCol, rightCol);
            }
        }
        keys.some(function(offset) {
            var iOffset = Number(offset);
            var offsetVal = _this.cOffsets["" + offset];
            var border = diffWidth + frzLeftWidth <= offsetVal && left + calWidth >= offsetVal;
            if (border) indexes.push(iOffset);
            return left + calWidth < offsetVal;
        });
        return indexes;
    };
    VirtualRowModelGenerator.prototype.checkAndResetCache = function(action) {
        var actions = [
            "paging",
            "refresh",
            "sorting",
            "filtering",
            "searching",
            "grouping",
            "ungrouping",
            "reorder",
            "save",
            "delete"
        ];
        var clear = actions.some(function(value) {
            return action === value;
        });
        if (clear) {
            this.cache = {};
            this.data = {};
            this.groups = {};
        }
        return clear;
    };
    VirtualRowModelGenerator.prototype.refreshColOffsets = function() {
        var _this = this;
        var col = 0;
        this.cOffsets = {};
        var gLen = this.parent.groupSettings.columns.length;
        var cols = this.parent.columns;
        var cLen = cols.length;
        var isVisible = function(column) {
            return column.visible && (!_this.parent.groupSettings.showGroupedColumn ? _this.parent.groupSettings.columns.indexOf(column.field) < 0 : column.visible);
        };
        var c = this.parent.groupSettings.columns;
        for(var i = 0; i < c.length; i++)this.cOffsets[parseInt(i.toString(), 10)] = (this.cOffsets[i - 1] | 0) + 30;
        // eslint-disable-next-line prefer-spread
        var blocks = Array.apply(null, Array(cLen)).map(function() {
            return col++;
        });
        for(var j = 0; j < blocks.length; j++){
            blocks[parseInt(j.toString(), 10)] = blocks[parseInt(j.toString(), 10)] + gLen;
            this.cOffsets[blocks[parseInt(j.toString(), 10)]] = (this.cOffsets[blocks[parseInt(j.toString(), 10)] - 1] | 0) + (isVisible(cols[parseInt(j.toString(), 10)]) ? parseInt(cols[parseInt(j.toString(), 10)].width, 10) : 0);
        }
    };
    VirtualRowModelGenerator.prototype.updateGroupRow = function(current, block) {
        var currentFirst = current[0];
        var rows = [];
        var keys = Object.keys(this.cache);
        for(var i = 0; i < keys.length; i++)if (Number(keys[parseInt(i.toString(), 10)]) < block) rows = rows.concat(this.cache[keys[parseInt(i.toString(), 10)]]);
        if (currentFirst && currentFirst.isDataRow || block % 2 === 0) return current;
        return this.iterateGroup(current, rows);
    };
    VirtualRowModelGenerator.prototype.iterateGroup = function(current, rows) {
        var currentFirst = current[0];
        var offset = 0;
        if (currentFirst && currentFirst.isDataRow) return current;
        var isPresent = current.some(function(row) {
            return rows.some(function(oRow, index) {
                var res = oRow && oRow.data.field !== undefined && oRow.data.field === row.data.field && oRow.data.key === row.data.key;
                if (res) offset = index;
                return res;
            });
        });
        if (isPresent) {
            current.shift();
            current = this.iterateGroup(current, rows.slice(offset));
        }
        return current;
    };
    VirtualRowModelGenerator.prototype.getRows = function() {
        var rows = [];
        var keys = Object.keys(this.cache);
        for(var i = 0; i < keys.length; i++)rows = rows.concat(this.cache[keys[parseInt(i.toString(), 10)]]);
        return rows;
    };
    VirtualRowModelGenerator.prototype.generateCells = function(foreignKeyData) {
        var cells = [];
        var cols = this.parent.columnModel;
        for(var i = 0; i < cols.length; i++)cells.push(this.rowModelGenerator.generateCell(cols[parseInt(i.toString(), 10)], null, null, null, null, foreignKeyData));
        return cells;
    };
    VirtualRowModelGenerator.prototype.getGroupVirtualRecordsByIndex = function(rows) {
        var blocks = this.parent.contentModule.getGroupedTotalBlocks();
        var blockSize = this.parent.contentModule.getBlockSize();
        for(var i = 1; i <= blocks; i++){
            var count = 0;
            this.cache[parseInt(i.toString(), 10)] = [];
            for(var j = (i - 1) * blockSize; j < rows.length; j++){
                if (count === blockSize) break;
                this.cache[parseInt(i.toString(), 10)].push(rows[parseInt(j.toString(), 10)]);
                if (rows[parseInt(j.toString(), 10)].isDataRow) count++;
            }
        }
    };
    return VirtualRowModelGenerator;
}();




var $873f1f65b622d98b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * VirtualContentRenderer
 *
 * @hidden
 */ var $873f1f65b622d98b$export$4470c3010ae1fd4f = /** @class */ function(_super) {
    $873f1f65b622d98b$var$__extends(VirtualContentRenderer, _super);
    function VirtualContentRenderer(parent, locator) {
        var _this = _super.call(this, parent, locator) || this;
        _this.prevHeight = 0;
        /** @hidden */ _this.startIndex = 0;
        _this.preStartIndex = 0;
        _this.preventEvent = false;
        _this.actions = [
            "filtering",
            "searching",
            "grouping",
            "ungrouping"
        ];
        /** @hidden */ _this.offsets = {};
        _this.tmpOffsets = {};
        /** @hidden */ _this.virtualEle = new $873f1f65b622d98b$export$651d72d69c6c33f4();
        _this.offsetKeys = [];
        _this.isFocused = false;
        _this.isSelection = false;
        _this.isBottom = false;
        _this.diff = 0;
        _this.heightChange = false;
        /** @hidden */ _this.isTop = false;
        _this.empty = undefined;
        _this.isCancel = false;
        _this.requestTypes = [
            "beginEdit",
            "cancel",
            "delete",
            "add",
            "save",
            "sorting"
        ];
        _this.isNormaledit = _this.parent.editSettings.mode === "Normal";
        /** @hidden */ _this.virtualData = {};
        _this.virtualInfiniteData = {};
        _this.emptyRowData = {};
        _this.isContextMenuOpen = false;
        _this.isSelectionScroll = false;
        _this.validationCheck = false;
        _this.locator = locator;
        _this.eventListener("on");
        _this.widthServices = locator.getService("widthService");
        _this.parent.on($17b89d3b1fc93cdb$export$c480fa254fb70e72, _this.setVisible, _this);
        _this.vgenerator = _this.generator;
        return _this;
    }
    VirtualContentRenderer.prototype.renderTable = function() {
        this.header = this.locator.getService("rendererFactory").getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header);
        _super.prototype.renderTable.call(this);
        this.virtualEle.table = this.getTable();
        this.virtualEle.content = this.content = this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb);
        this.virtualEle.renderWrapper(this.parent.height);
        this.virtualEle.renderPlaceHolder();
        if (!(!this.parent.enableVirtualization && this.parent.enableColumnVirtualization)) this.virtualEle.wrapper.style.position = "absolute";
        var debounceEvent = this.parent.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !this.parent.dataSource.dataSource.offline;
        var opt = {
            container: this.content,
            pageHeight: this.getBlockHeight() * 2,
            debounceEvent: debounceEvent,
            axes: this.parent.enableColumnVirtualization ? [
                "X",
                "Y"
            ] : [
                "Y"
            ]
        };
        this.observer = new (0, $92f1ac473c8a887f$export$1956e4e512cc09ce)(this.virtualEle.wrapper, opt);
    };
    VirtualContentRenderer.prototype.renderEmpty = function(tbody) {
        this.getTable().appendChild(tbody);
        if (this.parent.frozenRows) this.parent.getHeaderContent().querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c).innerHTML = "";
        this.virtualEle.adjustTable(0, 0);
    };
    VirtualContentRenderer.prototype.getReorderedFrozenRows = function(args) {
        var blockIndex = args.virtualInfo.blockIndexes;
        var colsIndex = args.virtualInfo.columnIndexes;
        var page = args.virtualInfo.page;
        args.virtualInfo.blockIndexes = [
            1,
            2
        ];
        args.virtualInfo.page = 1;
        args.virtualInfo.columnIndexes = [];
        var recordslength = this.parent.getCurrentViewRecords().length;
        var firstRecords = this.parent.renderModule.data.dataManager.dataSource.json.slice(0, recordslength);
        var virtualRows = this.vgenerator.generateRows(firstRecords, args);
        args.virtualInfo.blockIndexes = blockIndex;
        args.virtualInfo.columnIndexes = colsIndex;
        args.virtualInfo.page = page;
        return virtualRows.splice(0, this.parent.frozenRows);
    };
    VirtualContentRenderer.prototype.scrollListener = function(scrollArgs) {
        if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization && (scrollArgs.direction === "up" || scrollArgs.direction === "down")) return;
        this.scrollAfterEdit();
        if (this.parent.enablePersistence) this.parent.scrollPosition = scrollArgs.offset;
        if (this.preventEvent || this.parent.isDestroyed) {
            this.preventEvent = false;
            return;
        }
        if ((0, $3EnZW.isNullOrUndefined)(document.activeElement)) this.isFocused = false;
        else this.isFocused = this.content === (0, $4ZDHT.closest)(document.activeElement, "." + $1b5568e76cdae6d4$export$a7db06668cad9adb) || this.content === document.activeElement;
        if (this.parent.islazyloadRequest && scrollArgs.direction === "down") {
            this.parent.removeMaskRow();
            this.parent.islazyloadRequest = false;
            return;
        }
        var info = scrollArgs.sentinel;
        var viewInfo = this.currentInfo = this.getInfoFromView(scrollArgs.direction, info, scrollArgs.offset);
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent)) {
            if (viewInfo.blockIndexes && this.prevInfo.blockIndexes.toString() === viewInfo.blockIndexes.toString()) {
                this.parent.removeMaskRow();
                return;
            } else {
                viewInfo.event = "refresh-virtual-block";
                if (!(0, $3EnZW.isNullOrUndefined)(viewInfo.offsets)) viewInfo.offsets.top = this.content.scrollTop;
                this.parent.pageSettings.currentPage = viewInfo.page;
                if (this.parent.enableVirtualMaskRow) {
                    this.parent.showMaskRow(info.axis);
                    this.parent.addShimmerEffect();
                }
                if (this.parent.editSettings.showAddNewRow) this.parent.closeEdit();
                this.parent.notify(viewInfo.event, {
                    requestType: "virtualscroll",
                    virtualInfo: viewInfo,
                    focusElement: scrollArgs.focusElement
                });
                return;
            }
        }
        if (this.prevInfo && (info.axis === "Y" && this.prevInfo.blockIndexes.toString() === viewInfo.blockIndexes.toString() || info.axis === "X" && this.prevInfo.columnIndexes.toString() === viewInfo.columnIndexes.toString())) {
            this.parent.removeMaskRow();
            if ((0, $5q7BP.Browser).isIE) this.parent.hideSpinner();
            this.requestType = this.requestType === "virtualscroll" ? this.empty : this.requestType;
            if (info.axis === "Y") this.restoreEdit();
            if (this.parent.groupSettings.enableLazyLoading && this.prevInfo.blockIndexes[0] === 1 && viewInfo.blockIndexes[0] === 1 && scrollArgs.direction === "up") this.virtualEle.adjustTable(0, viewInfo.offsets.top < this.offsets[1] ? 0 : this.getBlockHeight());
            return;
        }
        this.parent.setColumnIndexesInView(this.parent.enableColumnVirtualization ? viewInfo.columnIndexes : []);
        if (!(!this.parent.enableVirtualization && this.parent.enableColumnVirtualization)) this.parent.pageSettings.currentPage = viewInfo.loadNext && !viewInfo.loadSelf ? viewInfo.nextInfo.page : viewInfo.page;
        this.requestType = "virtualscroll";
        if (this.parent.enableVirtualMaskRow) {
            this.parent.showMaskRow(info.axis);
            this.parent.addShimmerEffect();
        }
        this.parent.islazyloadRequest = false;
        if (this.parent.editSettings.showAddNewRow) this.parent.closeEdit();
        this.parent.notify(viewInfo.event, {
            requestType: "virtualscroll",
            virtualInfo: viewInfo,
            focusElement: scrollArgs.focusElement
        });
        if (this.parent.enableColumnVirtualization && !this.parent.getContentTable().querySelector("tr.e-row")) {
            this.parent.removeMaskRow();
            this.appendContent(undefined, undefined, {
                requestType: "virtualscroll",
                virtualInfo: viewInfo,
                focusElement: scrollArgs.focusElement
            });
            this.prevInfo = viewInfo;
        }
    };
    VirtualContentRenderer.prototype.block = function(blk) {
        return this.vgenerator.isBlockAvailable(blk);
    };
    VirtualContentRenderer.prototype.getInfoFromView = function(direction, info, e) {
        var isBlockAdded = false;
        var tempBlocks = [];
        var infoType = {
            direction: direction,
            sentinelInfo: info,
            offsets: e,
            startIndex: this.preStartIndex,
            endIndex: this.preEndIndex
        };
        infoType.page = this.getPageFromTop(e.top, infoType);
        infoType.blockIndexes = tempBlocks = this.vgenerator.getBlockIndexes(infoType.page);
        infoType.loadSelf = !this.vgenerator.isBlockAvailable(tempBlocks[infoType.block]);
        var blocks = this.ensureBlocks(infoType);
        if (this.activeKey === "upArrow" && infoType.blockIndexes.toString() !== blocks.toString()) {
            // To avoid dupilcate row index problem in key focus support
            var newBlock = blocks[blocks.length - 1];
            if (infoType.blockIndexes.indexOf(newBlock) === -1) isBlockAdded = true;
        }
        if (!(!this.parent.enableVirtualization && this.parent.enableColumnVirtualization)) infoType.blockIndexes = blocks;
        infoType.loadNext = !blocks.filter(function(val) {
            return tempBlocks.indexOf(val) === -1;
        }).every(this.block.bind(this));
        infoType.event = infoType.loadNext || infoType.loadSelf ? (0, $17b89d3b1fc93cdb$export$80cded91831c5507) : (0, $17b89d3b1fc93cdb$export$68c56a16fdd92a5);
        infoType.nextInfo = infoType.loadNext ? {
            page: Math.max(1, infoType.page + (direction === "down" ? 1 : -1))
        } : {};
        if (isBlockAdded) infoType.blockIndexes = [
            infoType.blockIndexes[0] - 1,
            infoType.blockIndexes[0],
            infoType.blockIndexes[0] + 1
        ];
        if (this.activeKey === "downArrow" && !isNaN(this.rowIndex)) {
            var firstBlock = Math.ceil(this.rowIndex / this.getBlockSize());
            if (firstBlock !== 1 && (infoType.blockIndexes[1] !== firstBlock || infoType.blockIndexes.length < 3)) infoType.blockIndexes = [
                firstBlock - 1,
                firstBlock,
                firstBlock + 1
            ];
        }
        infoType.columnIndexes = info.axis === "X" ? this.vgenerator.getColumnIndexes() : this.parent.getColumnIndexesInView();
        if (this.parent.enableColumnVirtualization && info.axis === "X") infoType.event = (0, $17b89d3b1fc93cdb$export$68c56a16fdd92a5);
        return infoType;
    };
    VirtualContentRenderer.prototype.ensureBlocks = function(info) {
        var _this = this;
        var index = info.blockIndexes[info.block];
        var mIdx;
        var old = index;
        var max = Math.max;
        var indexes = info.direction === "down" ? [
            max(index, 1),
            ++index,
            ++index
        ] : [
            max(index - 1, 1),
            index,
            index + 1
        ];
        this.prevInfo = this.prevInfo || this.vgenerator.getData();
        indexes = indexes.filter(function(val, ind) {
            return indexes.indexOf(val) === ind;
        });
        var preventSelf = false;
        if ((0, $748c2240e597a9b7$export$bab3117844264a75)(this.parent) && info.direction === "up" && ((info.page + 1 === this.prevInfo.page || info.page === this.prevInfo.page) && info.block === 1 || info.page === this.prevInfo.page && indexes.length === 2) && this.vgenerator.isBlockAvailable(info.blockIndexes[1] + 1)) {
            preventSelf = info.page + 1 === this.prevInfo.page && info.block === 1;
            index += 1;
            indexes = [
                max(index - 1, 1),
                index,
                index + 1
            ];
        }
        if (this.prevInfo.blockIndexes.toString() === indexes.toString()) return indexes;
        if (info.loadSelf && !preventSelf || info.direction === "down" && this.isEndBlock(old)) indexes = this.vgenerator.getBlockIndexes(info.page);
        indexes.some(function(val, ind) {
            var result = val === ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(_this.parent) ? _this.getGroupedTotalBlocks() : _this.getTotalBlocks());
            if (result) mIdx = ind;
            return result;
        });
        if (mIdx !== undefined) {
            indexes = indexes.slice(0, mIdx + 1);
            if (info.block === 0 && indexes.length === 1 && this.vgenerator.isBlockAvailable(indexes[0] - 1)) indexes = [
                indexes[0] - 1,
                indexes[0]
            ];
        }
        return indexes;
    };
    // tslint:disable-next-line:max-func-body-length
    VirtualContentRenderer.prototype.appendContent = function(target, newChild, e) {
        var _this = this;
        // currentInfo value will be used if there are multiple dom updates happened due to mousewheel
        var info = e.virtualInfo.sentinelInfo && e.virtualInfo.sentinelInfo.axis === "Y" && this.currentInfo.page && this.currentInfo.page !== e.virtualInfo.page ? this.currentInfo : e.virtualInfo;
        this.prevInfo = this.prevInfo || e.virtualInfo;
        var cBlock = info.columnIndexes[0] - 1;
        var cOffset = this.getColumnOffset(cBlock);
        var width;
        var blocks = info.blockIndexes;
        if (this.parent.groupSettings.columns.length) this.refreshOffsets();
        if (this.parent.height === "100%") this.parent.element.style.height = "100%";
        var vHeight = this.parent.height.toString().indexOf("%") < 0 ? this.content.getBoundingClientRect().height : this.parent.element.getBoundingClientRect().height;
        if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization) vHeight = 0;
        var reduceWidth = 0;
        if (this.parent.enableColumnVirtualization && this.parent.isFrozenGrid()) {
            var frzLeftWidth_1 = 0;
            this.parent.getColumns().filter(function(col) {
                if (col.visible) {
                    reduceWidth += parseInt(col.width.toString(), 10);
                    if (col.freeze === "Left") frzLeftWidth_1 += parseInt(col.width.toString(), 10);
                }
            });
            var cIndex = info.columnIndexes;
            width = this.getColumnOffset(cIndex[cIndex.length - 1]) - this.getColumnOffset(cIndex[0] - 1) + "";
            if (cBlock > this.parent.getVisibleFrozenLeftCount()) cOffset = cOffset - frzLeftWidth_1;
            this.resetStickyLeftPos(cOffset, newChild);
        }
        if (!this.requestTypes.some(function(value) {
            return value === _this.requestType;
        })) {
            var translate = this.getTranslateY(this.content.scrollTop, vHeight, info);
            if (this.parent.groupSettings.enableLazyLoading && info && this.prevInfo && this.prevInfo.blockIndexes[0] === 1 && info.blockIndexes[0] === 1 && info.direction === "up") this.virtualEle.adjustTable(0, this.content.scrollTop < this.offsets[1] ? 0 : this.getBlockHeight());
            else this.virtualEle.adjustTable(cOffset, translate);
        }
        if (this.parent.enableColumnVirtualization) this.header.virtualEle.adjustTable(cOffset, 0);
        if (this.parent.enableColumnVirtualization) {
            var cIndex = info.columnIndexes;
            width = this.getColumnOffset(cIndex[cIndex.length - 1]) - this.getColumnOffset(cIndex[0] - 1) + "";
            if (this.parent.isFrozenGrid()) {
                width = reduceWidth.toString();
                if (this.parent.allowResizing) {
                    this.parent.getHeaderTable().style.width = reduceWidth + "px";
                    this.parent.getContentTable().style.width = reduceWidth + "Px";
                }
            }
            this.header.virtualEle.setWrapperWidth(width);
        }
        this.virtualEle.setWrapperWidth(width, (0, $5q7BP.Browser).isIE || (0, $5q7BP.Browser).info.name === "edge");
        if (this.parent.enableColumnVirtualization && (0, $3EnZW.isNullOrUndefined)(target) && (0, $3EnZW.isNullOrUndefined)(newChild)) return;
        if (!(0, $3EnZW.isNullOrUndefined)(target) && !(0, $3EnZW.isNullOrUndefined)(target.parentNode)) (0, $4ZDHT.remove)(target);
        var tbody = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$a7db06668cad9adb).querySelector($1b5568e76cdae6d4$export$7cdd536eaa8f163c);
        if (tbody) {
            (0, $4ZDHT.remove)(tbody);
            target = null;
        }
        var isReact = this.parent.isReact && !(0, $3EnZW.isNullOrUndefined)(this.parent.rowTemplate);
        if (!isReact) {
            target = this.parent.createElement($1b5568e76cdae6d4$export$7cdd536eaa8f163c, {
                attrs: {
                    role: "rowgroup"
                }
            });
            target.appendChild(newChild);
        } else target = newChild;
        if (this.parent.frozenRows && e.requestType === "virtualscroll" && (this.parent.pageSettings.currentPage === 1 || this.isInfiniteColumnvirtualization())) for(var i = 0; i < this.parent.frozenRows; i++)target.children[0].remove();
        this.getTable().appendChild(target);
        this.requestType = this.requestType === "virtualscroll" ? this.empty : this.requestType;
        if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization && (info.direction === "right" || info.direction === "left")) {
            this.content.scrollTop = this.currentInfo.offsets.top;
            this.content.scrollLeft = this.currentInfo.offsets.left;
        }
        if (this.parent.groupSettings.columns.length) {
            if (!(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && info.direction === "up") {
                var blk = this.offsets[this.getTotalBlocks()] - this.prevHeight;
                var sTop = this.content.scrollTop;
                this.content.scrollTop = sTop + blk;
            }
            this.setVirtualHeight();
            if (!this.parent.groupSettings.enableLazyLoading) this.observer.setPageHeight(this.getOffset(blocks[blocks.length - 1]) - this.getOffset(blocks[0] - 1));
        }
        if (e.requestType === "ungrouping" && !this.parent.groupSettings.enableLazyLoading && this.parent.groupSettings.columns.length === 0) this.observer.setPageHeight(this.getBlockHeight() * 2);
        this.prevInfo = info;
        if (this.isFocused && this.activeKey !== "downArrow" && this.activeKey !== "upArrow") this.content.focus();
        var lastPage = Math.ceil(this.getTotalBlocks() / 2);
        if (this.isBottom) {
            this.isBottom = false;
            this.parent.getContent().firstElementChild.scrollTop = this.offsets[this.offsetKeys.length - 1];
        }
        if ((this.parent.pageSettings.currentPage + 1 === lastPage || this.parent.pageSettings.currentPage === lastPage) && blocks.length === 2 && e.requestType === "delete") this.parent.getContent().firstElementChild.scrollTop = this.offsets[this.offsetKeys.length - 1];
        if (this.parent.pageSettings.currentPage === lastPage && blocks.length === 1) {
            this.isBottom = true;
            this.parent.getContent().firstElementChild.scrollTop = this.offsets[this.offsetKeys.length - 2];
        }
        if (this.isTop) {
            this.parent.getContent().firstElementChild.scrollTop = 0;
            this.isTop = false;
        }
        if (e.requestType === "virtualscroll" && e.virtualInfo.sentinelInfo.axis === "X") this.parent.notify($17b89d3b1fc93cdb$export$bb86da570a7327af, {});
        this.focusCell(e);
        this.restoreEdit(e);
        this.restoreAdd();
        this.ensureSelectedRowPosition();
        this.validationScrollLeft();
        if (this.parent.isFrozenGrid() && this.parent.enableColumnVirtualization) this.widthServices.refreshFrozenScrollbar();
        if (!this.initialRowTop) {
            var gridTop = this.parent.element.getBoundingClientRect().top;
            if (this.parent.getRowByIndex(0)) this.initialRowTop = this.parent.getRowByIndex(0).getBoundingClientRect().top - gridTop;
        }
    };
    VirtualContentRenderer.prototype.validationScrollLeft = function() {
        if (this.validationCheck) {
            if (this.validationCol) {
                var offset = this.vgenerator.cOffsets[this.validationCol.index - this.parent.getVisibleFrozenColumns() - 1];
                this.validationCol = null;
                this.content.scrollLeft = offset;
            } else {
                this.validationCheck = false;
                this.parent.editModule.editFormValidate();
            }
        }
    };
    VirtualContentRenderer.prototype.ensureSelectedRowPosition = function() {
        if (!this.isSelection && this.isSelectionScroll && !(0, $3EnZW.isNullOrUndefined)(this.selectRowIndex)) {
            this.isSelectionScroll = false;
            var row = this.parent.getRowByIndex(this.selectRowIndex);
            if (row && !this.isRowInView(row)) this.rowSelected({
                rowIndex: this.selectRowIndex,
                row: row
            }, true);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    VirtualContentRenderer.prototype.focusCell = function(e) {
        if (this.activeKey !== "upArrow" && this.activeKey !== "downArrow") return;
        var row = this.parent.getRowByIndex(this.rowIndex);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var cell = row.cells[this.cellIndex];
        cell.focus({
            preventScroll: true
        });
        if (!this.parent.selectionSettings.checkboxOnly) this.parent.selectRow(parseInt(row.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10));
        this.activeKey = this.empty;
    };
    VirtualContentRenderer.prototype.restoreEdit = function(e) {
        if (this.isNormaledit) {
            if (this.parent.editSettings.allowEditing && this.parent.editModule && !(0, $3EnZW.isNullOrUndefined)(this.editedRowIndex)) {
                var row = this.getRowByIndex(this.editedRowIndex);
                var content = this.content;
                var keys = Object.keys(this.virtualData);
                var isXaxis = e && e.virtualInfo && e.virtualInfo.sentinelInfo.axis === "X";
                if (keys.length && row && !content.querySelector("." + $1b5568e76cdae6d4$export$76a2698a7195dbfe) && [
                    "sorting",
                    "filtering",
                    "grouping",
                    "refresh",
                    "searching",
                    "ungrouping",
                    "reorder"
                ].indexOf(e.requestType) === -1) {
                    var top_1 = row.getBoundingClientRect().top;
                    if (isXaxis || top_1 < this.content.offsetHeight && top_1 > this.parent.getRowHeight()) {
                        this.parent.isEdit = false;
                        this.parent.editModule.startEdit(row);
                    }
                }
                if (row && this.content.querySelector("." + $1b5568e76cdae6d4$export$76a2698a7195dbfe) && !keys.length) {
                    var rowData = !this.parent.enableVirtualization && this.parent.enableColumnVirtualization ? this.enableCacheOnInfiniteColumnVirtual() ? this.virtualInfiniteData : (0, $3EnZW.extend)({}, this.parent.getCurrentViewRecords()[this.editedRowIndex]) : (0, $3EnZW.extend)({}, this.getRowObjectByIndex(this.editedRowIndex));
                    this.virtualData = this.getVirtualEditedData(rowData);
                }
            }
            this.restoreAdd();
        }
    };
    VirtualContentRenderer.prototype.getVirtualEditedData = function(rowData) {
        var editForms = [].slice.call(this.parent.element.getElementsByClassName("e-gridform"));
        var isFormDestroyed = this.parent.editModule && this.parent.editModule.formObj && this.parent.editModule.formObj.isDestroyed;
        if (!isFormDestroyed) for(var i = 0; i < editForms.length; i++)rowData = this.parent.editModule.getCurrentEditedData(editForms[parseInt(i.toString(), 10)], rowData);
        return rowData;
    };
    VirtualContentRenderer.prototype.restoreAdd = function() {
        var startAdd = !this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2);
        if (this.isNormaledit && this.isAdd && startAdd) {
            var isTop = this.parent.editSettings.newRowPosition === "Top" && this.content.scrollTop < this.parent.getRowHeight();
            var isBottom = this.parent.editSettings.newRowPosition === "Bottom" && this.parent.pageSettings.currentPage === this.maxPage;
            if (isTop || isBottom) {
                this.parent.isEdit = false;
                this.parent.addRecord();
            }
        }
    };
    VirtualContentRenderer.prototype.onDataReady = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.count)) {
            this.count = e.count;
            this.maxPage = Math.ceil((this.parent.groupSettings.columns.length && this.parent.vcRows.length ? this.parent.vcRows.length : e.count) / this.parent.pageSettings.pageSize);
        }
        this.vgenerator.checkAndResetCache(e.requestType);
        if ([
            "refresh",
            "filtering",
            "searching",
            "grouping",
            "ungrouping",
            "reorder",
            undefined
        ].some(function(value) {
            return e.requestType === value;
        })) this.refreshOffsets();
        this.setVirtualHeight();
        this.resetScrollPosition(e.requestType);
    };
    /**
     * @param {number} height - specifies the height
     * @returns {void}
     * @hidden
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    VirtualContentRenderer.prototype.setVirtualHeight = function(height) {
        var width = this.parent.enableColumnVirtualization ? this.getColumnOffset(this.parent.columns.length + this.parent.groupSettings.columns.length - 1) + "px" : "100%";
        var virtualHeight = this.offsets[(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && this.count !== 0 ? this.getGroupedTotalBlocks() : this.getTotalBlocks()];
        if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization) virtualHeight = 0;
        var totalBlocks = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && this.count !== 0 ? this.getGroupedTotalBlocks() : this.getTotalBlocks();
        var lastPage = Math.ceil(totalBlocks / 2);
        var placeHolderBottom = Math.round(this.virtualEle.placeholder.getBoundingClientRect().bottom);
        var wrapperBottom = Math.round(this.virtualEle.wrapper.getBoundingClientRect().bottom);
        if ((this.currentInfo.page === lastPage || this.currentInfo.page + 1 === lastPage) && this.currentInfo.direction === "down" && placeHolderBottom > wrapperBottom && !this.diff) this.diff = placeHolderBottom - wrapperBottom;
        if (this.diff && this.currentInfo.page === lastPage && placeHolderBottom > wrapperBottom) {
            virtualHeight -= this.diff;
            this.heightChange = true;
        } else if (this.diff && this.heightChange && this.requestType === "virtualscroll") {
            virtualHeight -= this.diff;
            this.heightChange = false;
        }
        this.virtualEle.setVirtualHeight(virtualHeight, width);
        if (this.virtualEle && this.virtualEle.wrapper) {
            if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization) this.virtualEle.wrapper.style.minHeight = "";
            else this.virtualEle.wrapper.style.minHeight = !(0, $3EnZW.isNullOrUndefined)(virtualHeight) ? (0, $3EnZW.formatUnit)(this.parent.height) : "0px";
        }
        if (this.parent.enableColumnVirtualization) this.header.virtualEle.setVirtualHeight(1, width);
    };
    VirtualContentRenderer.prototype.getPageFromTop = function(sTop, info) {
        var _this = this;
        var total = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.getGroupedTotalBlocks() : this.getTotalBlocks();
        var page = 0;
        this.offsetKeys.some(function(offset) {
            var iOffset = Number(offset);
            var border = sTop <= _this.offsets["" + offset] || iOffset === total && sTop > _this.offsets["" + offset];
            if (border) {
                if (_this.offsetKeys.length % 2 !== 0 && iOffset.toString() === _this.offsetKeys[_this.offsetKeys.length - 2] && sTop <= _this.offsets[_this.offsetKeys.length - 1]) iOffset = iOffset + 1;
                info.block = iOffset % 2 === 0 ? 1 : 0;
                page = Math.max(1, Math.min(_this.vgenerator.getPage(iOffset), _this.maxPage));
            }
            return border;
        });
        return page;
    };
    VirtualContentRenderer.prototype.getTranslateY = function(sTop, cHeight, info, isOnenter) {
        if (info === undefined) {
            info = {
                page: this.getPageFromTop(sTop, {})
            };
            info.blockIndexes = this.vgenerator.getBlockIndexes(info.page);
        }
        var block = (info.blockIndexes[0] || 1) - 1;
        var translate = this.getOffset(block);
        var endTranslate = this.getOffset(info.blockIndexes[info.blockIndexes.length - 1]);
        if (isOnenter) info = this.prevInfo;
        var result = translate > sTop ? this.getOffset(block - 1) : endTranslate < sTop + cHeight ? this.getOffset(block + 1) : translate;
        var blockHeight = this.offsets[info.blockIndexes[info.blockIndexes.length - 1]] - this.tmpOffsets[info.blockIndexes[0]];
        var totalBlocks = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.getGroupedTotalBlocks() : this.getTotalBlocks();
        if (result + blockHeight > this.offsets[parseInt(totalBlocks.toString(), 10)]) result -= result + blockHeight - this.offsets[parseInt(totalBlocks.toString(), 10)];
        if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization) result = 0;
        return result;
    };
    VirtualContentRenderer.prototype.getOffset = function(block) {
        return Math.min(this.offsets[parseInt(block.toString(), 10)] | 0, this.offsets[this.maxBlock] | 0);
    };
    VirtualContentRenderer.prototype.onEntered = function() {
        var _this = this;
        return function(element, current, direction, e, isWheel, check) {
            if ((direction === "down" || direction === "up") && !_this.parent.enableVirtualization && _this.parent.enableColumnVirtualization) return;
            if ((0, $5q7BP.Browser).isIE && !isWheel && check && !_this.preventEvent && !_this.parent.enableVirtualMaskRow) _this.parent.showSpinner();
            _this.prevInfo = _this.prevInfo || _this.vgenerator.getData();
            if (_this.parent.enableVirtualMaskRow && !_this.preventEvent) {
                var firstOffSetKey = parseInt(_this.offsetKeys[0], 10);
                var lastOffSetKey = parseInt(_this.offsetKeys[_this.offsetKeys.length - 1], 10);
                var blockIndex = _this.currentInfo.blockIndexes;
                var viewInfo = _this.getInfoFromView(direction, current, e);
                var disableShowMaskRow = _this.prevInfo && current.axis === "X" && _this.prevInfo.columnIndexes.toString() === viewInfo.columnIndexes.toString() || direction === "down" && _this.parent.allowGrouping && _this.parent.groupSettings.columns.length && (_this.parent.allowFiltering && _this.parent.filterSettings.columns.length || _this.parent.searchSettings.key.length) && _this.offsetKeys.length <= 2;
                if (!(blockIndex && blockIndex[0] === firstOffSetKey && direction === "up" || blockIndex && blockIndex[blockIndex.length - 1] === lastOffSetKey && direction === "down" || disableShowMaskRow)) setTimeout(function() {
                    _this.parent.showMaskRow(current.axis);
                }, 0);
            }
            var xAxis = current.axis === "X";
            var top = _this.prevInfo.offsets ? _this.prevInfo.offsets.top : null;
            var height = _this.content.getBoundingClientRect().height;
            var x = _this.getColumnOffset(xAxis ? _this.vgenerator.getColumnIndexes()[0] - 1 : _this.prevInfo.columnIndexes[0] - 1);
            if (_this.parent.isFrozenGrid() && _this.parent.enableColumnVirtualization && _this.currentInfo && _this.currentInfo.columnIndexes) {
                var cBlock = _this.currentInfo.columnIndexes[0] - 1;
                var frzLeftWidth_2 = 0;
                _this.parent.getColumns().filter(function(col) {
                    if (col.visible && col.freeze === "Left") frzLeftWidth_2 += parseInt(col.width.toString(), 10);
                });
                if (cBlock > _this.parent.getVisibleFrozenLeftCount()) x = x - frzLeftWidth_2;
            }
            if (xAxis) {
                var idx = Object.keys(_this.vgenerator.cOffsets).length - _this.prevInfo.columnIndexes.length;
                var maxLeft = _this.vgenerator.cOffsets[idx - 1];
                x = x > maxLeft ? maxLeft : x; //TODO: This fix horizontal scrollbar jumping issue in column virtualization.
            }
            if (!_this.parent.enableVirtualization && _this.parent.enableColumnVirtualization) _this.virtualEle.adjustTable(x, 0);
            else {
                var y = _this.getTranslateY(e.top, height, xAxis && top === e.top ? _this.prevInfo : undefined, true);
                _this.virtualEle.adjustTable(x, Math.min(y, _this.offsets[_this.maxBlock]));
            }
            if (_this.parent.enableColumnVirtualization) {
                _this.header.virtualEle.adjustTable(x, 0);
                if (_this.parent.isFrozenGrid()) _this.resetStickyLeftPos(x);
            }
        };
    };
    VirtualContentRenderer.prototype.dataBound = function() {
        this.parent.notify($17b89d3b1fc93cdb$export$a93bfbc041c6ccb0, {});
        if (this.isSelection && this.activeKey !== "upArrow" && this.activeKey !== "downArrow") this.parent.selectRow(this.selectedRowIndex);
        else {
            this.activeKey = this.empty;
            this.requestType = this.empty;
        }
    };
    /**
     * To calculate the position of frozen cells
     *
     * @param {number} valueX - specifies the transform X value
     * @param {DocumentFragment | HTMLElement} newChild - specifies the element to transform
     * @returns {void}
     * @hidden
     */ VirtualContentRenderer.prototype.resetStickyLeftPos = function(valueX, newChild) {
        var cells = [].slice.call(this.parent.getHeaderContent().querySelectorAll(".e-leftfreeze,.e-rightfreeze,.e-fixedfreeze")).concat([].slice.call((newChild ? newChild : this.parent.getContent()).querySelectorAll(".e-leftfreeze,.e-rightfreeze,.e-fixedfreeze")));
        var frzLeftWidth = 0;
        var frzRightWidth = 0;
        if (this.parent.getHeaderContent().querySelectorAll(".e-fixedfreeze").length) {
            frzLeftWidth = this.parent.leftrightColumnWidth("left");
            frzRightWidth = this.parent.leftrightColumnWidth("right");
        }
        if (cells.length) for(var i = 0; i < cells.length; i++){
            var cell = cells[parseInt(i.toString(), 10)];
            var col = void 0;
            if (cell.classList.contains("e-rowcell")) {
                if ((0, $3EnZW.isNullOrUndefined)(cell.getAttribute("data-colindex")) && cell.querySelector("[e-mappinguid]")) {
                    var uid = cell.querySelector("[e-mappinguid]").getAttribute("e-mappinguid");
                    col = this.parent.getColumnByUid(uid);
                } else {
                    var idx = parseInt(cell.getAttribute("data-colindex"), 10);
                    col = this.parent.getColumnByIndex(parseInt(idx.toString(), 10));
                }
            } else if (cell.classList.contains("e-headercell") || cell.classList.contains("e-filterbarcell")) {
                var uid = cell.classList.contains("e-filterbarcell") ? cell.getAttribute("e-mappinguid") : cell.querySelector("[e-mappinguid]").getAttribute("e-mappinguid");
                col = this.parent.getColumnByUid(uid);
            }
            if (col.freeze === "Left") cell.style.left = col.valueX - valueX + "px";
            else if (col.freeze === "Right") cell.style.right = col.valueX + valueX + "px";
            else if (col.freeze === "Fixed") {
                cell.style.left = frzLeftWidth - valueX + "px";
                cell.style.right = frzRightWidth + valueX + "px";
            }
        }
        this.parent.translateX = valueX;
    };
    VirtualContentRenderer.prototype.rowSelected = function(args, isSelection) {
        if ((this.isSelection || isSelection) && !this.isLastBlockRow(args.rowIndex)) {
            var transform = (0, $748c2240e597a9b7$export$3046fdef117e6822)(this.content.firstElementChild);
            var gridTop = this.parent.element.getBoundingClientRect().top;
            var rowTop = args.row.getBoundingClientRect().top - gridTop;
            var height = this.content.getBoundingClientRect().height;
            var isBottom = height < rowTop;
            var remainHeight = isBottom ? rowTop - height : this.initialRowTop - rowTop;
            var translateY = isBottom ? transform.height - remainHeight : transform.height + remainHeight;
            this.virtualEle.adjustTable(transform.width, translateY);
            var wrapperInfo = this.virtualEle.wrapper.getBoundingClientRect();
            var contentInfo = this.content.getBoundingClientRect();
            if (wrapperInfo.top > contentInfo.top) this.virtualEle.adjustTable(transform.width, translateY - (wrapperInfo.top - contentInfo.top));
            var lastRowTop = this.content.querySelector("tbody").lastElementChild.getBoundingClientRect().top - gridTop;
            if (lastRowTop < height) {
                translateY = translateY + (height - (args.row.getBoundingClientRect().top - gridTop));
                this.virtualEle.adjustTable(transform.width, translateY - this.parent.getRowHeight() / 2);
            } else if (contentInfo.bottom > wrapperInfo.bottom) this.virtualEle.adjustTable(transform.width, translateY + (contentInfo.bottom - wrapperInfo.bottom));
            if (this.parent.enableColumnVirtualization && this.parent.isFrozenGrid()) this.resetStickyLeftPos(transform.width);
        }
        this.isSelection = false;
    };
    VirtualContentRenderer.prototype.isLastBlockRow = function(index) {
        var scrollEle = this.parent.getContent().firstElementChild;
        var visibleRowCount = Math.floor(scrollEle.offsetHeight / this.parent.getRowHeight()) - 1;
        var startIdx = this.maxPage * this.parent.pageSettings.pageSize - visibleRowCount;
        return index >= startIdx;
    };
    VirtualContentRenderer.prototype.refreshMaxPage = function() {
        if (this.parent.groupSettings.columns.length && this.parent.vcRows.length) this.maxPage = Math.ceil(this.parent.vcRows.length / this.parent.pageSettings.pageSize);
    };
    VirtualContentRenderer.prototype.setVirtualPageQuery = function(args) {
        var visiblePage = [];
        if (this.prevInfo && this.prevInfo.blockIndexes) visiblePage = (0, $748c2240e597a9b7$export$e3139d168f68ec7e)(this.prevInfo.blockIndexes);
        if ((this.requestType === "sorting" || this.requestType === "delete") && visiblePage.length && (0, $748c2240e597a9b7$export$bab3117844264a75)(this.parent)) {
            args.query.skip(this.parent.pageSettings.pageSize * (visiblePage[0] - 1));
            args.query.take(this.parent.pageSettings.pageSize * visiblePage.length);
            args.skipPage = true;
            return;
        }
        var row = this.parent.getContent().querySelector(".e-row");
        if (this.requestType === "virtualscroll" && this.vgenerator.currentInfo.blockIndexes) this.vgenerator.currentInfo = {};
        if (row && this.parent.isManualRefresh && this.currentInfo.blockIndexes && (this.currentInfo.blockIndexes.length === 3 || visiblePage.length > 1)) {
            this.vgenerator.startIndex = parseInt(row.getAttribute("data-rowindex"), 10);
            this.vgenerator.currentInfo = (0, $3EnZW.extend)({}, this.currentInfo);
            this.vgenerator.currentInfo.blockIndexes = this.currentInfo.blockIndexes.slice();
            var includePrevPage = this.vgenerator.includePrevPage = this.currentInfo.blockIndexes[0] % 2 === 0;
            if (includePrevPage) {
                this.vgenerator.startIndex = this.vgenerator.startIndex - this.getBlockSize();
                this.vgenerator.currentInfo.blockIndexes.unshift(this.currentInfo.blockIndexes[0] - 1);
            } else this.vgenerator.currentInfo.blockIndexes.push(this.currentInfo.blockIndexes[this.currentInfo.blockIndexes.length - 1] + 1);
            var skip = (this.vgenerator.currentInfo.blockIndexes[0] - 1) * this.getBlockSize();
            var take = this.vgenerator.currentInfo.blockIndexes.length * this.getBlockSize();
            args.query.skip(skip);
            args.query.take(take);
            args.skipPage = true;
        }
    };
    VirtualContentRenderer.prototype.eventListener = function(action) {
        var _this = this;
        this.parent["" + action]((0, $17b89d3b1fc93cdb$export$32ed53e78850bc76), this.onDataReady, this);
        this.parent.addEventListener($17b89d3b1fc93cdb$export$a04129a54dd9eaf2, this.dataBound.bind(this));
        this.parent.addEventListener($17b89d3b1fc93cdb$export$df204737a6131aab, this.actionBegin.bind(this));
        this.parent.addEventListener($17b89d3b1fc93cdb$export$830631a3cb598490, this.actionComplete.bind(this));
        this.parent.addEventListener($17b89d3b1fc93cdb$export$547c6771ab2f0fc5, this.rowSelected.bind(this));
        this.parent["" + action]((0, $17b89d3b1fc93cdb$export$68c56a16fdd92a5), this.refreshContentRows, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$c0e33c0984c61ab9, this.refreshVirtualLazyLoadCache, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$d6c7825c8cd16473, this.selectVirtualRow, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$9ee6037f4bacdaa7, this.virtualCellFocus, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$6d303e5560d57498, this.editActionBegin, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$25a0d5e14cd34614, this.addActionBegin, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$ca52857b7b04ae17, this.restoreEdit, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$d2863c79b905c4cd, this.editSuccess, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$a715e34adf8189a2, this.refreshCache, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$82a793dcb3807178, this.resetIsedit, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$a1aad2683385fb49, this.getVirtualData, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$7fd078d634a647bc, this.editCancel, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$8fcd90c21e6d64a3, this.refreshMaxPage, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$d51281e311b00699, this.setVirtualPageQuery, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$dee075e2eb3f74a8, this.selectRowOnContextOpen, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$4621d2cf9ca5b53b, this.resetVirtualFocus, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$8cbbcbf676a1a501, this.refreshCells, this);
        this.parent["" + action]($17b89d3b1fc93cdb$export$51907d4a017438aa, this.scrollToEdit, this);
        var event = this.actions;
        for(var i = 0; i < event.length; i++)this.parent["" + action](event[parseInt(i.toString(), 10)] + "-begin", this.onActionBegin, this);
        var fn = function() {
            _this.observer.observe(function(scrollArgs) {
                return _this.scrollListener(scrollArgs);
            }, _this.onEntered());
            var gObj = _this.parent;
            if (gObj.enablePersistence && gObj.scrollPosition) {
                _this.content.scrollTop = gObj.scrollPosition.top;
                var scrollValues = {
                    direction: "down",
                    sentinel: _this.observer.sentinelInfo.down,
                    offset: gObj.scrollPosition,
                    focusElement: gObj.element
                };
                _this.scrollListener(scrollValues);
                if (gObj.enableColumnVirtualization) _this.content.scrollLeft = gObj.scrollPosition.left;
            }
            _this.parent.off((0, $17b89d3b1fc93cdb$export$f44d9209b353bf3e), fn);
        };
        this.parent.on((0, $17b89d3b1fc93cdb$export$f44d9209b353bf3e), fn, this);
    };
    VirtualContentRenderer.prototype.refreshVirtualLazyLoadCache = function(e) {
        var blockIndex = this.currentInfo.blockIndexes;
        if ((0, $3EnZW.isNullOrUndefined)(this.currentInfo.blockIndexes)) blockIndex = [
            1,
            2
        ];
        var block;
        var index;
        var cache;
        for(var i = 0; i < blockIndex.length; i++){
            var rows = this.vgenerator.cache[blockIndex[parseInt(i.toString(), 10)]];
            for(var j = 0; j < rows.length; j++)if (rows[parseInt(j.toString(), 10)].uid === e.uid) {
                block = blockIndex[parseInt(i.toString(), 10)];
                index = j;
                cache = rows;
                break;
            }
        }
        if (e.count) this.vgenerator.cache[parseInt(block.toString(), 10)].splice(index + 1, e.count);
        else if (e.rows && e.rows.length) this.vgenerator.cache[parseInt(block.toString(), 10)] = [].slice.call(cache.slice(0, index + 1)).concat([].slice.call(e.rows)).concat([].slice.call(cache.slice(index + 1, cache.length)));
        this.refreshOffsets();
    };
    VirtualContentRenderer.prototype.scrollToEdit = function(col) {
        var allowScroll = true;
        this.validationCheck = true;
        if (this.isAdd && this.content.scrollTop > 0) {
            allowScroll = false;
            var keys = Object.keys(this.offsets);
            this.content.scrollTop = this.parent.editSettings.newRowPosition === "Top" ? 0 : this.offsets[keys.length - 1];
        }
        var row = this.parent.getRowByIndex(this.editedRowIndex);
        if (!row && !(0, $3EnZW.isNullOrUndefined)(this.editedRowIndex)) {
            if (!row || !this.isRowInView(row)) {
                var rowIndex = this.parent.getRowHeight();
                var scrollTop = this.editedRowIndex * rowIndex;
                if (!(0, $3EnZW.isNullOrUndefined)(scrollTop)) {
                    allowScroll = false;
                    this.content.scrollTop = scrollTop;
                }
            }
        }
        if (col && allowScroll) {
            var offset = this.vgenerator.cOffsets[col.index - this.parent.getVisibleFrozenColumns() - 1];
            if (!this.parent.enableColumnVirtualization) {
                var header = this.parent.getHeaderContent().querySelector('.e-headercelldiv[e-mappinguid="' + col.uid + '"]');
                offset = header.parentElement.offsetLeft;
            }
            if (this.parent.enableColumnVirtualization && this.parent.getVisibleFrozenLeftCount()) offset -= this.parent.leftrightColumnWidth("left");
            this.content.scrollLeft = this.parent.enableRtl ? -Math.abs(offset) : offset;
        }
        if (col && !allowScroll) this.validationCol = col;
    };
    VirtualContentRenderer.prototype.refreshCells = function(rowObj) {
        rowObj.cells = this.vgenerator.generateCells(rowObj.foreignKeyData);
    };
    VirtualContentRenderer.prototype.resetVirtualFocus = function(e) {
        this.isCancel = e.isCancel;
    };
    /**
     * @param {Object} data - specifies the data
     * @param {Object} data.virtualData -specifies the data
     * @param {boolean} data.isAdd - specifies isAdd
     * @param {boolean} data.isCancel - specifies boolean in cancel
     * @param {boolean} data.isScroll - specifies boolean for scroll
     * @returns {void}
     * @hidden
     */ VirtualContentRenderer.prototype.getVirtualData = function(data) {
        if (this.isNormaledit) {
            var error = this.parent.element.querySelector('.e-griderror:not([style*="display: none"])');
            var keys = Object.keys(this.virtualData);
            data.isScroll = keys.length !== 0 && this.currentInfo.sentinelInfo && this.currentInfo.sentinelInfo.axis === "X";
            if (error) return;
            this.virtualData = keys.length ? this.virtualData : data.virtualData;
            this.getVirtualEditedData(this.virtualData);
            data.virtualData = this.virtualData;
            data.isAdd = this.isAdd || this.parent.editSettings.showAddNewRow;
            data.isCancel = this.isCancel;
        }
    };
    VirtualContentRenderer.prototype.selectRowOnContextOpen = function(args) {
        this.isContextMenuOpen = args.isOpen;
    };
    VirtualContentRenderer.prototype.editCancel = function(args) {
        var dataIndex = (0, $748c2240e597a9b7$export$b52dd6069dba6e03)(this.parent, args.data);
        if (!(0, $3EnZW.isNullOrUndefined)(dataIndex)) args.data = this.parent.getCurrentViewRecords()[parseInt(dataIndex.toString(), 10)];
    };
    VirtualContentRenderer.prototype.editSuccess = function(args) {
        if (this.isNormaledit) {
            if (!this.isAdd && args.data) this.updateCurrentViewData(args.data);
            this.isAdd = false;
        }
    };
    VirtualContentRenderer.prototype.updateCurrentViewData = function(data) {
        var dataIndex = (0, $748c2240e597a9b7$export$b52dd6069dba6e03)(this.parent, data);
        if (!(0, $3EnZW.isNullOrUndefined)(dataIndex)) this.parent.getCurrentViewRecords()[parseInt(dataIndex.toString(), 10)] = data;
    };
    VirtualContentRenderer.prototype.actionBegin = function(args) {
        if (args.requestType !== "virtualscroll") this.requestType = args.requestType;
        if (!args.cancel) this.parent.notify($17b89d3b1fc93cdb$export$66883d42f956398d, args);
    };
    VirtualContentRenderer.prototype.virtualCellFocus = function(e) {
        // To decide the action (select or scroll), when using arrow keys for cell focus
        var ele = document.activeElement;
        if (!ele.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) && (ele instanceof HTMLInputElement || !(0, $3EnZW.isNullOrUndefined)(ele.closest(".e-templatecell")))) ele = ele.closest(".e-rowcell");
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length && ele && (ele.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) || !(0, $3EnZW.isNullOrUndefined)((0, $748c2240e597a9b7$export$dcd0aa73ca0eb350)(ele, $1b5568e76cdae6d4$export$368b824418d94f0))) && e && (e.action === "upArrow" || e.action === "downArrow")) {
            var scrollEle = this.parent.getContent().firstElementChild;
            var scrollEleInfo = scrollEle.getBoundingClientRect();
            var row = (0, $4ZDHT.closest)(ele, "tr");
            var nextFocusRow = e.action === "downArrow" ? row.nextElementSibling : row.previousElementSibling;
            var nextFocusRowInfo = !(0, $3EnZW.isNullOrUndefined)(nextFocusRow) ? nextFocusRow.getBoundingClientRect() : undefined;
            if ((0, $3EnZW.isNullOrUndefined)(nextFocusRow) || e.action === "downArrow" && nextFocusRowInfo.bottom > scrollEleInfo.bottom || e.action === "upArrow" && nextFocusRowInfo.top < scrollEleInfo.top) {
                this.activeKey = e.action;
                this.parent.focusModule.virtualSelectionInfo = {
                    isPending: (0, $3EnZW.isNullOrUndefined)(nextFocusRow),
                    direction: e.action,
                    event: e
                };
                var viewDifference = (0, $3EnZW.isNullOrUndefined)(nextFocusRow) ? this.parent.getRowHeight() : e.action === "downArrow" ? nextFocusRowInfo.bottom - scrollEleInfo.bottom : scrollEleInfo.top - nextFocusRowInfo.top;
                scrollEle.scrollTop = e.action === "downArrow" ? scrollEle.scrollTop + viewDifference : scrollEle.scrollTop - viewDifference;
            } else this.activeKey = this.empty;
            return;
        }
        if (ele && ele.classList.contains($1b5568e76cdae6d4$export$deb49d6cac2bdaca) && e && (e.action === "upArrow" || e.action === "downArrow")) {
            var rowIndex = parseInt(ele.parentElement.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            if (e && (e.action === "downArrow" || e.action === "upArrow")) {
                var scrollEle = this.parent.getContent().firstElementChild;
                if (e.action === "downArrow") rowIndex += 1;
                else rowIndex -= 1;
                this.rowIndex = rowIndex;
                this.cellIndex = parseInt(ele.getAttribute($1b5568e76cdae6d4$export$fff541542e3093ed), 10);
                var row = this.parent.getRowByIndex(rowIndex);
                var page = this.parent.pageSettings.currentPage;
                var visibleRowCount = Math.floor(scrollEle.offsetHeight / this.parent.getRowHeight()) - 1;
                var emptyRow = false;
                if ((0, $3EnZW.isNullOrUndefined)(row)) {
                    emptyRow = true;
                    if (e.action === "downArrow" && page === this.maxPage - 1 || e.action === "upArrow" && page === 1) emptyRow = false;
                }
                if (emptyRow || (0, $748c2240e597a9b7$export$f783eb11715a8ca3)(row, this.parent) && e.action === "downArrow" || (0, $748c2240e597a9b7$export$80c5f36a72f4a3c7)(row, this.parent.getRowHeight() * 2) && e.action === "upArrow") {
                    this.activeKey = e.action;
                    scrollEle.scrollTop = e.action === "downArrow" ? (rowIndex - visibleRowCount) * this.parent.getRowHeight() : rowIndex * this.parent.getRowHeight();
                } else this.activeKey = this.empty;
                if (!this.parent.selectionSettings.checkboxOnly) this.parent.selectRow(rowIndex);
            }
        }
    };
    VirtualContentRenderer.prototype.editActionBegin = function(e) {
        this.editedRowIndex = e.index;
        var rowData = !this.parent.enableVirtualization && this.parent.enableColumnVirtualization ? (0, $3EnZW.extend)({}, this.parent.getCurrentViewRecords()[e.index]) : (0, $3EnZW.extend)({}, this.getRowObjectByIndex(e.index));
        var keys = Object.keys(this.virtualData);
        e.data = keys.length && !this.parent.editSettings.showAddNewRow ? this.virtualData : this.isInfiniteColumnvirtualization() ? e.data : rowData;
        if (this.enableCacheOnInfiniteColumnVirtual()) this.virtualInfiniteData = e.data;
        e.isScroll = keys.length !== 0 && this.currentInfo.sentinelInfo && this.currentInfo.sentinelInfo.axis === "X";
    };
    VirtualContentRenderer.prototype.getEditedRowObject = function() {
        var rowObjects = this.parent.vcRows;
        var editedrow;
        for(var i = 0; i < rowObjects.length; i++)if (rowObjects[parseInt(i.toString(), 10)].index === this.editedRowIndex) editedrow = rowObjects[parseInt(i.toString(), 10)];
        return editedrow;
    };
    VirtualContentRenderer.prototype.refreshCache = function(args) {
        if (this.isInfiniteColumnvirtualization()) return;
        var block = Math.ceil((this.editedRowIndex + 1) / this.getBlockSize());
        if (this.parent.allowPaging && this.parent.enableColumnVirtualization) block = Math.ceil((this.editedRowIndex + 1 + (this.parent.pageSettings.currentPage - 1) * this.parent.pageSettings.pageSize) / this.getBlockSize());
        var index = this.parent.allowPaging && this.parent.enableColumnVirtualization ? this.editedRowIndex % this.getBlockSize() : this.editedRowIndex - (block - 1) * this.getBlockSize();
        if (this.parent.groupSettings.columns.length) {
            var editRowObject = this.getEditedRowObject();
            if (editRowObject) editRowObject.data = args.data;
        } else this.vgenerator.cache[parseInt(block.toString(), 10)][parseInt(index.toString(), 10)].data = args.data;
    };
    VirtualContentRenderer.prototype.actionComplete = function(args) {
        if (!(this.parent.enableVirtualization || this.parent.enableColumnVirtualization)) return;
        var editRequestTypes = [
            "delete",
            "save",
            "cancel"
        ];
        var dataActionRequestTypes = [
            "sorting",
            "filtering",
            "grouping",
            "refresh",
            "searching",
            "ungrouping",
            "reorder"
        ];
        if (editRequestTypes.some(function(value) {
            return value === args.requestType;
        })) {
            this.refreshOffsets();
            this.refreshVirtualElement();
        }
        if (this.isNormaledit && (dataActionRequestTypes.some(function(value) {
            return value === args.requestType;
        }) || editRequestTypes.some(function(value) {
            return value === args.requestType;
        }))) {
            this.isCancel = true;
            this.isAdd = (0, this.parent.editSettings.showAddNewRow);
            this.editedRowIndex = this.empty;
            this.virtualData = {};
            this.virtualInfiniteData = {};
            if (this.parent.editModule) this.parent.editModule.editModule.previousData = undefined;
        }
        if (this.parent.enableColumnVirtualization && args.requestType === "filterAfterOpen" && this.currentInfo.columnIndexes && this.currentInfo.columnIndexes[0] > 0) this.parent.resetFilterDlgPosition(args.columnName);
    };
    VirtualContentRenderer.prototype.resetIsedit = function() {
        if (this.parent.enableVirtualization && this.isNormaledit) {
            if (this.parent.editSettings.allowEditing && Object.keys(this.virtualData).length || this.parent.editSettings.allowAdding && this.isAdd) this.parent.isEdit = true;
        }
    };
    VirtualContentRenderer.prototype.scrollAfterEdit = function() {
        if (this.parent.editModule && this.parent.editSettings.allowEditing && this.isNormaledit) {
            if (this.parent.element.querySelector(".e-gridform")) {
                var editForm = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$76a2698a7195dbfe);
                var addForm = this.parent.element.querySelector("." + $1b5568e76cdae6d4$export$792eb12cf4991bf2);
                if (editForm || addForm) {
                    var rowData = editForm ? (0, $3EnZW.extend)({}, this.getRowObjectByIndex(this.editedRowIndex)) : (0, $3EnZW.extend)({}, this.emptyRowData);
                    var keys = Object.keys(this.virtualData);
                    this.virtualData = keys.length ? this.getVirtualEditedData(this.virtualData) : this.getVirtualEditedData(rowData);
                }
            }
        }
    };
    VirtualContentRenderer.prototype.createEmptyRowdata = function() {
        var _this = this;
        this.parent.columnModel.filter(function(e) {
            _this.emptyRowData[e.field] = _this.empty;
        });
    };
    VirtualContentRenderer.prototype.addActionBegin = function(args) {
        if (this.isNormaledit) {
            if (!Object.keys(this.emptyRowData).length) this.createEmptyRowdata();
            this.isAdd = true;
            var page = this.parent.pageSettings.currentPage;
            if (!this.parent.frozenRows && this.content.scrollTop > 0 && this.parent.editSettings.newRowPosition === "Top") {
                this.isAdd = true;
                this.onActionBegin();
                args.startEdit = false;
                this.content.scrollTop = 0;
            }
            if (page < this.maxPage - 1 && this.parent.editSettings.newRowPosition === "Bottom") {
                this.isAdd = true;
                this.parent.setProperties({
                    pageSettings: {
                        currentPage: this.maxPage - 1
                    }
                }, true);
                args.startEdit = false;
                this.content.scrollTop = this.offsets[this.offsetKeys.length];
            }
        }
    };
    /**
     * @param {number} index - specifies the index
     * @returns {Object} returns the object
     * @hidden
     */ VirtualContentRenderer.prototype.getRowObjectByIndex = function(index) {
        var data = this.getRowCollection(index, true);
        return data;
    };
    VirtualContentRenderer.prototype.getBlockSize = function() {
        return this.parent.pageSettings.pageSize >> 1;
    };
    VirtualContentRenderer.prototype.getBlockHeight = function() {
        return this.getBlockSize() * this.parent.getRowHeight();
    };
    VirtualContentRenderer.prototype.isEndBlock = function(index) {
        var totalBlocks = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.getGroupedTotalBlocks() : this.getTotalBlocks();
        return index >= totalBlocks || index === totalBlocks - 1;
    };
    VirtualContentRenderer.prototype.isOddPageSize = function() {
        return this.parent.pageSettings.pageSize % 2 !== 0;
    };
    VirtualContentRenderer.prototype.getOddBlockSize = function() {
        return this.isOddPageSize() ? this.parent.pageSettings.pageSize / 2 : this.getBlockSize();
    };
    VirtualContentRenderer.prototype.getGroupedTotalBlocks = function() {
        var rows = this.parent.vcRows;
        return Math.floor(rows.length / this.getOddBlockSize() < 1 ? 1 : rows.length / this.getOddBlockSize());
    };
    VirtualContentRenderer.prototype.getTotalBlocks = function() {
        return Math.ceil(this.count / this.getOddBlockSize());
    };
    VirtualContentRenderer.prototype.getColumnOffset = function(block) {
        return this.vgenerator.cOffsets[parseInt(block.toString(), 10)] | 0;
    };
    VirtualContentRenderer.prototype.getModelGenerator = function() {
        return new (0, $ef57b291636ad58b$export$78ac632d55fb89a)(this.parent);
    };
    VirtualContentRenderer.prototype.resetScrollPosition = function(action) {
        if (this.actions.some(function(value) {
            return value === action;
        })) {
            this.preventEvent = this.content.scrollTop !== 0;
            this.content.scrollTop = 0;
        }
        if (action !== "virtualscroll") this.isAdd = false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    VirtualContentRenderer.prototype.onActionBegin = function(e) {
        //Update property silently..
        this.parent.setProperties({
            pageSettings: {
                currentPage: 1
            }
        }, true);
    };
    VirtualContentRenderer.prototype.getRows = function() {
        return this.isInfiniteColumnvirtualization() ? this.getInfiniteRows() : this.vgenerator.getRows();
    };
    VirtualContentRenderer.prototype.getRowByIndex = function(index) {
        var row;
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent)) {
            if (!(0, $3EnZW.isNullOrUndefined)(index) && this.parent.enableVirtualization && this.parent.groupSettings.columns.length) {
                for(var i = 0; i < this.parent.getDataRows().length; i++)if (this.parent.getDataRows()[parseInt(i.toString(), 10)].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82) === index.toString()) row = this.parent.getDataRows()[parseInt(i.toString(), 10)];
            } else row = !(0, $3EnZW.isNullOrUndefined)(index) ? this.parent.getDataRows()[parseInt(index.toString(), 10)] : undefined;
        } else if (!this.parent.enableVirtualization && this.parent.enableColumnVirtualization) row = !(0, $3EnZW.isNullOrUndefined)(index) ? this.enableCacheOnInfiniteColumnVirtual() ? this.parent.getDataRows().find(function(element) {
            return parseInt(element.getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10) === index;
        }) : this.parent.getDataRows()[parseInt(index.toString(), 10)] : undefined;
        else if (this.prevInfo) row = this.getRowCollection(index, false);
        return row;
    };
    VirtualContentRenderer.prototype.getMovableVirtualRowByIndex = function(index) {
        return this.getRowCollection(index, false);
    };
    VirtualContentRenderer.prototype.getFrozenRightVirtualRowByIndex = function(index) {
        return this.getRowCollection(index, false);
    };
    VirtualContentRenderer.prototype.getRowCollection = function(index, isRowObject) {
        var prev = this.prevInfo.blockIndexes;
        var startIdx = (prev[0] - 1) * this.getBlockSize();
        if (this.parent.pageSettings.pageSize % 2 !== 0) startIdx += Math.floor(startIdx / this.getBlockSize() / 2);
        var rowCollection = this.parent.getDataRows();
        var collection = isRowObject ? this.parent.getCurrentViewRecords() : rowCollection;
        if (isRowObject && this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            startIdx = parseInt(this.parent.getRows()[0].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
            collection = collection.filter(function(m) {
                return (0, $3EnZW.isNullOrUndefined)(m.items);
            });
        }
        if (!isRowObject && this.parent.allowGrouping && this.parent.groupSettings.columns.length && rowCollection.length) startIdx = parseInt(rowCollection[0].getAttribute($1b5568e76cdae6d4$export$bbfd9040f0589a82), 10);
        var selectedRow = collection[index - startIdx];
        if (this.parent.frozenRows && this.parent.pageSettings.currentPage > 1) {
            if (!isRowObject) selectedRow = index <= this.parent.frozenRows ? rowCollection[parseInt(index.toString(), 10)] : rowCollection[index - startIdx + this.parent.frozenRows];
            else selectedRow = index <= this.parent.frozenRows ? this.parent.getRowsObject()[parseInt(index.toString(), 10)].data : selectedRow;
        }
        return selectedRow;
    };
    VirtualContentRenderer.prototype.getVirtualRowIndex = function(index) {
        var prev = this.prevInfo.blockIndexes;
        var startIdx = (prev[0] - 1) * this.getBlockSize();
        if (this.parent.enableVirtualization && this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            var vGroupedRows = this.vgenerator.cache[prev[0]];
            for(var i = 0; i < vGroupedRows.length; i++)if (vGroupedRows["" + i].isDataRow) {
                startIdx = vGroupedRows["" + i].index;
                break;
            }
        }
        return startIdx + index;
    };
    /**
     * @returns {void}
     * @hidden */ VirtualContentRenderer.prototype.refreshOffsets = function() {
        var gObj = this.parent;
        var row = 0;
        var blockSize = this.getBlockSize();
        var oddBlockSize = this.getOddBlockSize();
        var total = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.getGroupedTotalBlocks() : this.getTotalBlocks();
        this.prevHeight = this.offsets[parseInt(total.toString(), 10)];
        this.maxBlock = total % 2 === 0 ? total - 2 : total - 1;
        this.offsets = {};
        //Row offset update
        // eslint-disable-next-line prefer-spread
        var blocks = Array.apply(null, Array(total)).map(function() {
            return ++row;
        });
        for(var i = 0; i < blocks.length; i++){
            var tmp = (this.vgenerator.cache[blocks[parseInt(i.toString(), 10)]] || []).length;
            var rem = !(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.isOddPageSize() ? Math.ceil(this.count % oddBlockSize) : this.count % blockSize : this.isOddPageSize() ? Math.ceil(gObj.vcRows.length % oddBlockSize) : gObj.vcRows.length % blockSize;
            var size = !(0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) && blocks[parseInt(i.toString(), 10)] in this.vgenerator.cache ? tmp * this.parent.getRowHeight() : rem && blocks[parseInt(i.toString(), 10)] === total ? rem * this.parent.getRowHeight() : this.getBlockHeight();
            if (this.isOddPageSize() && !(blocks[parseInt(i.toString(), 10)] in this.vgenerator.cache) && !(rem && blocks[parseInt(i.toString(), 10)] === total)) size = (blocks[parseInt(i.toString(), 10)] % 2 !== 0 ? Math.floor(oddBlockSize) : Math.ceil(oddBlockSize)) * this.parent.getRowHeight();
            // let size: number = this.parent.groupSettings.columns.length && block in this.vgenerator.cache ?
            // tmp * getRowHeight() : this.getBlockHeight();
            this.offsets[blocks[parseInt(i.toString(), 10)]] = (this.offsets[blocks[parseInt(i.toString(), 10)] - 1] | 0) + size;
            this.tmpOffsets[blocks[parseInt(i.toString(), 10)]] = this.offsets[blocks[parseInt(i.toString(), 10)] - 1] | 0;
        }
        this.offsetKeys = Object.keys(this.offsets);
        if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent)) this.parent.vGroupOffsets = this.offsets;
        //Column offset update
        if (this.parent.enableColumnVirtualization) this.vgenerator.refreshColOffsets();
    };
    VirtualContentRenderer.prototype.refreshVirtualElement = function() {
        this.vgenerator.refreshColOffsets();
        this.setVirtualHeight();
    };
    VirtualContentRenderer.prototype.setVisible = function(columns) {
        var gObj = this.parent;
        var rows = [];
        rows = this.getRows();
        var testRow;
        rows.some(function(r) {
            if (r.isDataRow) testRow = r;
            return r.isDataRow;
        });
        var isRefresh = true;
        if (!gObj.groupSettings.columns.length && testRow) isRefresh = false;
        var tr = gObj.getDataRows();
        for(var c = 0, clen = columns.length; c < clen; c++){
            var column = columns[parseInt(c.toString(), 10)];
            var idx = gObj.getNormalizedColumnIndex(column.uid);
            var displayVal = column.visible === true ? "" : "none";
            var colGrp = this.getColGroup().children;
            if (idx !== -1 && testRow && idx < testRow.cells.length) (0, $4ZDHT.setStyleAttribute)(colGrp[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
            if (!isRefresh) {
                var width = void 0;
                if (column.width) {
                    if (column.visible) width = this.virtualEle.wrapper.offsetWidth + parseInt(column.width.toString(), 10);
                    else width = this.virtualEle.wrapper.offsetWidth - parseInt(column.width.toString(), 10);
                }
                if (width > gObj.width) {
                    this.setDisplayNone(tr, idx, displayVal, rows);
                    if (this.parent.enableColumnVirtualization) this.virtualEle.setWrapperWidth(width + "");
                    this.refreshVirtualElement();
                } else isRefresh = true;
            }
            if (!this.parent.invokedFromMedia && column.hideAtMedia) this.parent.updateMediaColumns(column);
            this.parent.invokedFromMedia = false;
        }
        if (isRefresh) this.refreshContentRows({
            requestType: "refresh"
        });
        else this.parent.notify($17b89d3b1fc93cdb$export$868d7674f5a0caf5, {
            rows: rows,
            args: {
                isFrozen: false,
                rows: rows
            }
        });
    };
    VirtualContentRenderer.prototype.selectVirtualRow = function(args) {
        var _this = this;
        var count = (0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent) ? this.vgenerator.recordsCount : this.count;
        args.isAvailable = args.selectedIndex < count;
        if (args.isAvailable && !this.isContextMenuOpen && this.activeKey !== "upArrow" && this.activeKey !== "downArrow" && !this.isSelection && !this.requestTypes.some(function(value) {
            return value === _this.requestType;
        }) && !this.parent.selectionModule.isInteracted) {
            var selectedRow = this.parent.getRowByIndex(args.selectedIndex);
            var rowHeight = this.parent.getRowHeight();
            if (!selectedRow || !this.isRowInView(selectedRow)) {
                this.isSelection = true;
                this.selectedRowIndex = args.selectedIndex;
                var scrollTop = (args.selectedIndex + 1) * rowHeight;
                if ((0, $748c2240e597a9b7$export$d3edab9aa707d65f)(this.parent)) {
                    var selectedRowObjectIndex = this.parent.vcRows.findIndex(function(row) {
                        return row.index === args.selectedIndex;
                    });
                    scrollTop = selectedRowObjectIndex !== -1 ? selectedRowObjectIndex * rowHeight : undefined;
                    this.isSelection = selectedRowObjectIndex !== -1 ? this.isSelection : false;
                } else if (this.parent.getDataModule().isRemote() && this.parent.groupSettings.columns.length) {
                    var page = Math.ceil((args.selectedIndex + 1) / this.parent.pageSettings.pageSize);
                    var blockIndexes = this.vgenerator.getBlockIndexes(page);
                    scrollTop = this.offsets[blockIndexes[0]];
                }
                if (!(0, $3EnZW.isNullOrUndefined)(scrollTop)) {
                    var direction = this.content.scrollTop < scrollTop ? "down" : "up";
                    this.selectRowIndex = args.selectedIndex;
                    this.content.scrollTop = scrollTop;
                    this.isSelectionScroll = this.observer.check(direction);
                }
            }
        }
        this.requestType = this.empty;
    };
    VirtualContentRenderer.prototype.isRowInView = function(row) {
        var top = row.getBoundingClientRect().top;
        var bottom = row.getBoundingClientRect().bottom;
        return top >= this.content.getBoundingClientRect().top && bottom <= this.content.getBoundingClientRect().bottom;
    };
    return VirtualContentRenderer;
}((0, $c2232dcd2e373cda$export$6e65718da26e0698));
/**
 * @hidden
 */ var $873f1f65b622d98b$export$ffd6549d2a4d5534 = /** @class */ function(_super) {
    $873f1f65b622d98b$var$__extends(VirtualHeaderRenderer, _super);
    function VirtualHeaderRenderer(parent, locator) {
        var _this = _super.call(this, parent, locator) || this;
        _this.virtualEle = new $873f1f65b622d98b$export$651d72d69c6c33f4();
        _this.isMovable = false;
        _this.gen = new (0, $ef57b291636ad58b$export$78ac632d55fb89a)(_this.parent);
        _this.parent.on($17b89d3b1fc93cdb$export$c480fa254fb70e72, _this.setVisible, _this);
        _this.parent.on((0, $17b89d3b1fc93cdb$export$68c56a16fdd92a5), function(e) {
            return e.virtualInfo.sentinelInfo.axis === "X" ? _this.refreshUI() : null;
        }, _this);
        return _this;
    }
    VirtualHeaderRenderer.prototype.renderTable = function() {
        this.gen.refreshColOffsets();
        this.parent.setColumnIndexesInView(this.gen.getColumnIndexes(this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3)));
        _super.prototype.renderTable.call(this);
        this.virtualEle.table = this.getTable();
        this.virtualEle.content = this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3);
        this.virtualEle.content.style.position = "relative";
        this.virtualEle.renderWrapper();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !(this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) && this.parent.enableColumnVirtualization ? this.virtualEle.renderPlaceHolder() : this.virtualEle.renderPlaceHolder("absolute");
    };
    VirtualHeaderRenderer.prototype.appendContent = function(table) {
        this.virtualEle.wrapper.appendChild(table);
    };
    VirtualHeaderRenderer.prototype.refreshUI = function() {
        this.gen.refreshColOffsets();
        this.parent.setColumnIndexesInView(this.gen.getColumnIndexes(this.getPanel().querySelector("." + $1b5568e76cdae6d4$export$838c0e7679321ff3)));
        _super.prototype.refreshUI.call(this);
    };
    VirtualHeaderRenderer.prototype.setVisible = function(columns) {
        var gObj = this.parent;
        var displayVal;
        var idx;
        var needFullRefresh;
        for(var c = 0, clen = columns.length; c < clen; c++){
            var column = columns[parseInt(c.toString(), 10)];
            idx = gObj.getNormalizedColumnIndex(column.uid);
            displayVal = column.visible ? "" : "none";
            var colGrp = this.getColGroup().children;
            (0, $4ZDHT.setStyleAttribute)(colGrp[parseInt(idx.toString(), 10)], {
                "display": displayVal
            });
            if (gObj.enableColumnVirtualization && !gObj.groupSettings.columns.length) {
                var tablewidth = void 0;
                if (column.visible) tablewidth = this.virtualEle.wrapper.offsetWidth + parseInt(column.width.toString(), 10);
                else tablewidth = this.virtualEle.wrapper.offsetWidth - parseInt(column.width.toString(), 10);
                if (tablewidth > gObj.width) {
                    this.setDisplayNone(column, displayVal);
                    this.virtualEle.setWrapperWidth(tablewidth + "");
                    this.gen.refreshColOffsets();
                } else needFullRefresh = true;
            } else needFullRefresh = true;
            if (needFullRefresh) this.refreshUI();
        }
    };
    VirtualHeaderRenderer.prototype.setDisplayNone = function(col, displayVal) {
        var table = this.getTable();
        for(var _i = 0, _a = [].slice.apply(table.querySelectorAll("th.e-headercell")); _i < _a.length; _i++){
            var ele = _a[_i];
            if (ele.querySelector("[e-mappinguid]") && ele.querySelector("[e-mappinguid]").getAttribute("e-mappinguid") === col.uid) {
                (0, $4ZDHT.setStyleAttribute)(ele, {
                    "display": displayVal
                });
                if (displayVal === "") (0, $4ZDHT.removeClass)([
                    ele
                ], "e-hide");
                break;
            }
        }
    };
    return VirtualHeaderRenderer;
}((0, $837013bb596bf019$export$83fd0f90b83678b1));
/**
 * @hidden
 */ var $873f1f65b622d98b$export$651d72d69c6c33f4 = /** @class */ function() {
    function VirtualElementHandler() {}
    VirtualElementHandler.prototype.renderWrapper = function(height) {
        this.wrapper = (0, $4ZDHT.createElement)("div", {
            className: "e-virtualtable",
            styles: "min-height:" + (0, $3EnZW.formatUnit)(height)
        });
        this.wrapper.appendChild(this.table);
        this.content.appendChild(this.wrapper);
    };
    VirtualElementHandler.prototype.renderPlaceHolder = function(position) {
        if (position === void 0) position = "relative";
        this.placeholder = (0, $4ZDHT.createElement)("div", {
            className: "e-virtualtrack",
            styles: "position:" + position
        });
        this.content.appendChild(this.placeholder);
    };
    VirtualElementHandler.prototype.renderFrozenWrapper = function(height) {
        this.wrapper = (0, $4ZDHT.createElement)("div", {
            className: "e-virtualtable",
            styles: "min-height:" + (0, $3EnZW.formatUnit)(height) + "; display: flex"
        });
        this.content.appendChild(this.wrapper);
    };
    VirtualElementHandler.prototype.renderFrozenPlaceHolder = function() {
        this.placeholder = (0, $4ZDHT.createElement)("div", {
            className: "e-virtualtrack"
        });
        this.content.appendChild(this.placeholder);
    };
    VirtualElementHandler.prototype.adjustTable = function(xValue, yValue) {
        this.wrapper.style.transform = "translate(" + xValue + "px, " + yValue + "px)";
    };
    VirtualElementHandler.prototype.setWrapperWidth = function(width, full) {
        if (width && width.indexOf("%") === -1 && !(this.content.getBoundingClientRect().width < parseInt(width, 10))) {
            width = undefined;
            full = true;
        }
        this.wrapper.style.width = width ? width + "px" : full ? "100%" : "";
    };
    VirtualElementHandler.prototype.setVirtualHeight = function(height, width) {
        this.placeholder.style.height = !(0, $3EnZW.isNullOrUndefined)(height) ? height + "px" : "0px";
        if (width && width.indexOf("%") === -1 && !(this.content.getBoundingClientRect().width < parseInt(width, 10))) width = "100%";
        this.placeholder.style.width = width;
    };
    VirtualElementHandler.prototype.setFreezeWrapperWidth = function(wrapper, width, full) {
        wrapper.style.width = width ? width + "px" : full ? "100%" : "";
    };
    return VirtualElementHandler;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");

/**
 * Virtual Scrolling class
 */ var $0496c3a4be15f3f0$export$a9803c21e23b1e14 = /** @class */ function() {
    function VirtualScroll(parent, locator) {
        this.parent = parent;
        this.locator = locator;
        this.addEventListener();
    }
    VirtualScroll.prototype.getModuleName = function() {
        return "virtualscroll";
    };
    VirtualScroll.prototype.instantiateRenderer = function() {
        this.parent.log([
            "limitation",
            "virtual_height"
        ], "virtualization");
        var renderer = this.locator.getService("rendererFactory");
        if (this.parent.enableColumnVirtualization) renderer.addRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Header, new (0, $873f1f65b622d98b$export$ffd6549d2a4d5534)(this.parent, this.locator));
        renderer.addRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content, new (0, $873f1f65b622d98b$export$4470c3010ae1fd4f)(this.parent, this.locator));
        if (!(!this.parent.enableVirtualization && this.parent.enableColumnVirtualization)) this.ensurePageSize();
    };
    VirtualScroll.prototype.ensurePageSize = function() {
        var rowHeight = this.parent.getRowHeight();
        var vHeight = this.parent.height.toString().indexOf("%") < 0 ? this.parent.height : this.parent.element.getBoundingClientRect().height;
        this.blockSize = ~~(parseFloat(vHeight.toString()) / rowHeight);
        var height = this.blockSize * 2;
        var size = this.parent.pageSettings.pageSize;
        this.parent.setProperties({
            pageSettings: {
                pageSize: size < height ? height : size
            }
        }, true);
    };
    VirtualScroll.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on((0, $17b89d3b1fc93cdb$export$b70fe0c8c3456154), this.instantiateRenderer, this);
        this.parent.on($17b89d3b1fc93cdb$export$deabcf5530617ea3, this.refreshVirtualElement, this);
        this.parent.on($17b89d3b1fc93cdb$export$cd929038e92da795, this.createVirtualValidationForm, this);
        this.parent.on($17b89d3b1fc93cdb$export$4ff55734cc1d30f6, this.virtualEditFormValidation, this);
        this.parent.on($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy, this);
    };
    VirtualScroll.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off((0, $17b89d3b1fc93cdb$export$b70fe0c8c3456154), this.instantiateRenderer);
        this.parent.off($17b89d3b1fc93cdb$export$deabcf5530617ea3, this.refreshVirtualElement);
        this.parent.off($17b89d3b1fc93cdb$export$cd929038e92da795, this.createVirtualValidationForm);
        this.parent.off($17b89d3b1fc93cdb$export$4ff55734cc1d30f6, this.virtualEditFormValidation);
        this.parent.off($17b89d3b1fc93cdb$export$b1fb4cac938035f7, this.destroy);
    };
    VirtualScroll.prototype.getCurrentEditedData = function(prevData) {
        var data = {
            virtualData: (0, $3EnZW.extend)({}, {}, prevData, true),
            isAdd: false,
            isScroll: false,
            endEdit: true
        };
        this.parent.notify($17b89d3b1fc93cdb$export$a1aad2683385fb49, data);
        return data.virtualData;
    };
    VirtualScroll.prototype.createVirtualValidationForm = function(e) {
        var gObj = this.parent;
        if (gObj.enableVirtualization && gObj.editSettings.mode === "Normal") {
            var cols = gObj.columns;
            var rowRenderer = new (0, $dc8dcd3c3e5ce513$export$a41edaea3b7c09c8)(this.locator, null, this.parent);
            var rowObj = (0, $3EnZW.extend)({}, {}, gObj.getRowObjectFromUID(e.uid), true);
            gObj.notify($17b89d3b1fc93cdb$export$8cbbcbf676a1a501, rowObj);
            var args = e.argsCreator(this.getCurrentEditedData(e.prevData), {}, false);
            args.isCustomFormValidation = true;
            args.row = rowRenderer.render(rowObj, cols);
            e.renderer.update(args);
            var rules = {};
            for(var i = 0; i < cols.length; i++){
                if (!cols[parseInt(i.toString(), 10)].visible) continue;
                if (cols[parseInt(i.toString(), 10)].validationRules) (0, $748c2240e597a9b7$export$8bd3ebb3e5212b46)(cols[parseInt(i.toString(), 10)], 0, rules, {}, {}, cols.length, true);
            }
            args.form.classList.add("e-virtual-validation");
            gObj.editModule.virtualFormObj = gObj.editModule.createFormObj(args.form, rules);
        }
    };
    VirtualScroll.prototype.virtualEditFormValidation = function(args) {
        var gObj = this.parent;
        var error = gObj.element.querySelector('.e-griderror:not([style*="display: none"])');
        if (gObj.editModule.virtualFormObj) {
            if (error && error.style.display !== "none") {
                var errorDomRect = error.getBoundingClientRect();
                var forms = gObj.element.querySelectorAll(".e-gridform");
                var form = forms[0];
                var contentLeft = gObj.getContent().getBoundingClientRect().left;
                if (forms.length > 1) form = forms[1];
                if (errorDomRect.left < contentLeft || errorDomRect.right > gObj.element.offsetWidth) {
                    var tooltip = form.querySelector('.e-tooltip-wrap:not([style*="display: none"])');
                    this.scrollToEdit(tooltip, {
                        editIdx: args.editIdx,
                        addIdx: args.addIdx
                    }, true);
                }
            } else if (gObj.editModule.virtualFormObj && (!error || error.style.display === "none")) {
                var existingErrors = gObj.editModule.virtualFormObj.element.querySelectorAll('.e-tooltip-wrap:not([style*="display: none"])');
                for(var i = 0; i < existingErrors.length; i++)(0, $4ZDHT.remove)(existingErrors[parseInt(i.toString(), 10)]);
                this.setEditedDataToValidationForm(gObj.editModule.virtualFormObj.element, this.getCurrentEditedData(args.prevData));
                args.isValid = gObj.editModule.virtualFormObj.validate();
                if (!args.isValid) {
                    var tooltip = gObj.editModule.virtualFormObj.element.querySelector('.e-tooltip-wrap:not([style*="display: none"])');
                    this.scrollToEdit(tooltip, {
                        editIdx: args.editIdx,
                        addIdx: args.addIdx
                    });
                }
            }
        }
    };
    VirtualScroll.prototype.scrollToEdit = function(tooltip, args, isRenderer) {
        var gObj = this.parent;
        if (tooltip) {
            var cols = gObj.columnModel;
            var field = (0, $748c2240e597a9b7$export$71b71683b3fc7313)(tooltip.id).split("_")[0];
            var col = gObj.getColumnByField(field);
            var scrollTop = this.parent.getContent().firstElementChild.scrollTop;
            var row = gObj.getRowByIndex(args.editIdx);
            if (!(0, $3EnZW.isNullOrUndefined)(args.addIdx) && scrollTop > 0 || !(0, $3EnZW.isNullOrUndefined)(args.editIdx) && !row || isRenderer || !col) {
                var validationCol = void 0;
                for(var i = 0; i < cols.length && !col; i++)if (cols[parseInt(i.toString(), 10)].field === field) {
                    validationCol = cols[parseInt(i.toString(), 10)];
                    break;
                }
                if (isRenderer) validationCol = col;
                this.parent.notify($17b89d3b1fc93cdb$export$51907d4a017438aa, validationCol);
            }
        }
    };
    VirtualScroll.prototype.setEditedDataToValidationForm = function(form, editedData) {
        var inputs = [].slice.call(form.getElementsByClassName("e-field"));
        for(var i = 0, len = inputs.length; i < len; i++){
            var col = (0, $748c2240e597a9b7$export$bab3b2013af0811b)(this.parent, inputs[parseInt(i.toString(), 10)].getAttribute("e-mappinguid"));
            if (col.field) {
                var value = (0, $3EnZW.getValue)(col.field, editedData);
                value = (0, $3EnZW.isNullOrUndefined)(value) ? "" : value;
                inputs[parseInt(i.toString(), 10)].value = value;
            }
        }
    };
    VirtualScroll.prototype.refreshVirtualElement = function(args) {
        if (this.parent.enableColumnVirtualization && args.module === "resize") {
            var renderer = this.locator.getService("rendererFactory");
            renderer.getRenderer((0, $6b76944ddf827cb7$export$ed706b0a66efb05c).Content).refreshVirtualElement();
        }
    };
    VirtualScroll.prototype.destroy = function() {
        this.removeEventListener();
    };
    return VirtualScroll;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $eAUyT = parcelRequire("eAUyT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $c2qqN = parcelRequire("c2qqN");
var $bWDaN = parcelRequire("bWDaN");
var $dyv7X = parcelRequire("dyv7X");
var $3P3ke = parcelRequire("3P3ke");
var $i528u = parcelRequire("i528u");








/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * DetailsView module
 */ var $2133c38ddabe1767$export$9e4341e656034b31 = /** @class */ function() {
    /**
     * Constructor for the GridView module
     *
     * @param {FileManager} parent - specifies the parent.
     * @hidden
     */ function DetailsView(parent) {
        this.isInteracted = true;
        this.interaction = true;
        this.isPasteOperation = false;
        this.isColumnRefresh = false;
        this.dragObj = null;
        this.startIndex = null;
        this.firstItemIndex = null;
        this.isSelectionUpdate = false;
        this.currentSelectedItem = [];
        this.count = 0;
        this.isRendered = true;
        this.isLoaded = false;
        this.isNameWidth = false;
        this.isMultiSelect = false;
        this.pasteOperation = false;
        this.uploadOperation = false;
        (0, $503c118799028775$export$ef2184bd89960b14).Inject((0, $6807bc11aae112a3$export$76856258f71db1ea), (0, $91a2a42ce66cdfd8$export$8dc6765e8be191c7), (0, $e02f22598f2cfb09$export$d43f91ac58cde147), (0, $0496c3a4be15f3f0$export$a9803c21e23b1e14));
        this.parent = parent;
        this.element = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$7e576f6604f42645, this.parent.element);
        this.addEventListener();
        this.keyConfigs = {
            altEnter: "alt+enter",
            esc: "escape",
            tab: "tab",
            moveDown: "downarrow",
            ctrlEnd: "ctrl+end",
            ctrlHome: "ctrl+home",
            ctrlDown: "ctrl+downarrow",
            ctrlLeft: "ctrl+leftarrow",
            ctrlRight: "ctrl+rightarrow",
            shiftEnd: "shift+end",
            shiftHome: "shift+home",
            shiftDown: "shift+downarrow",
            shiftUp: "shift+uparrow",
            ctrlUp: "ctrl+uparrow",
            csEnd: "ctrl+shift+end",
            csHome: "ctrl+shift+home",
            csDown: "ctrl+shift+downarrow",
            csUp: "ctrl+shift+uparrow",
            space: "space",
            ctrlSpace: "ctrl+space",
            shiftSpace: "shift+space",
            csSpace: "ctrl+shift+space",
            end: "end",
            home: "home",
            moveUp: "uparrow",
            del: "delete",
            ctrlX: this.parent.isMac ? "cmd+x" : "ctrl+x",
            ctrlC: this.parent.isMac ? "cmd+c" : "ctrl+c",
            ctrlV: this.parent.isMac ? "cmd+v" : "ctrl+v",
            ctrlShiftN: "ctrl+shift+n",
            shiftdel: "shift+delete",
            ctrlD: "ctrl+d",
            f2: "f2",
            ctrlA: "ctrl+a",
            enter: "enter",
            back: "backspace"
        };
    }
    /* istanbul ignore next */ DetailsView.prototype.render = function(args) {
        var _this = this;
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.parent.element);
        if (this.parent.view === "Details") {
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
            var items = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, args.files);
            this.checkNameWidth();
            var columns = this.getColumns();
            var sortSettings = void 0;
            var isValidSortField = !(0, $3EnZW.isNullOrUndefined)(columns) && columns.findIndex(function(col) {
                return col.field === _this.parent.sortBy;
            }) !== -1;
            if (this.parent.isMobile || !isValidSortField) sortSettings = [];
            else if (this.parent.sortOrder !== "None") sortSettings = [
                {
                    direction: this.parent.sortOrder,
                    field: this.parent.sortBy
                }
            ];
            this.gridObj = new (0, $503c118799028775$export$ef2184bd89960b14)({
                dataSource: items,
                allowSorting: true,
                rowSelecting: this.onSelection.bind(this, "select"),
                rowDeselecting: this.onSelection.bind(this, "unselect"),
                rowSelected: this.onSelected.bind(this),
                rowDeselected: this.onDeSelection.bind(this),
                allowResizing: this.parent.detailsViewSettings.columnResizing,
                selectionSettings: {
                    type: this.parent.allowMultiSelection ? "Multiple" : "Single",
                    checkboxMode: "ResetOnRowClick"
                },
                enableRtl: this.parent.enableRtl,
                pageSettings: {
                    pageSize: 20
                },
                enableVirtualization: this.parent.enableVirtualization,
                enablePersistence: this.parent.enablePersistence,
                enableVirtualMaskRow: true,
                sortSettings: {
                    allowUnsort: false,
                    columns: sortSettings
                },
                columns: columns,
                recordDoubleClick: this.DblClickEvents.bind(this),
                beforeDataBound: this.onBeforeDataBound.bind(this),
                dataBound: this.onDataBound.bind(this),
                rowDataBound: this.onRowDataBound.bind(this),
                actionBegin: this.onActionBegin.bind(this),
                headerCellInfo: this.onHeaderCellInfo.bind(this),
                width: "100%",
                height: this.parent.enableVirtualization ? this.getGridHeight() : "auto",
                beforeCopy: function(args) {
                    args.cancel = true;
                },
                load: function() {
                    this.focusModule.destroy();
                },
                locale: this.parent.locale
            });
            if (this.parent.isReact) {
                this.gridObj.isReact = true;
                this.gridObj.portals = [];
                this.gridObj.on("reactTemplateRender", this.reactTemplateRender, this);
            }
            this.gridObj.isStringTemplate = true;
            this.gridObj.appendTo("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$7e576f6604f42645);
            this.wireEvents();
            this.adjustHeight();
            this.emptyArgs = args;
        }
    };
    DetailsView.prototype.reactTemplateRender = function(args) {
        this.parent["portals"] = args;
        if (this.parent.portals && this.parent.toolbarModule && this.parent.toolbarModule.toolbarObj && this.parent.toolbarModule.toolbarObj.portals) this.parent["portals"] = this.parent["portals"].concat(this.parent.toolbarModule.toolbarObj.portals);
        this.parent.notify("renderReactTemplate", this.parent["portals"]);
        this.parent["renderReactTemplates"]();
    };
    /**
     * Gets the grid height.
     *
     * @returns {number} - The grid height.
     * @private
     */ DetailsView.prototype.getGridHeight = function() {
        // Get the content pane and breadcrumb bar elements
        var pane = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$1d72a157e3e556f6, this.parent.element);
        var bar = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a, this.parent.element);
        // The maximum height of the header is 36
        var headerMaxHeight = 36;
        // Calculate and return the grid height
        return pane.offsetHeight - bar.offsetHeight - headerMaxHeight;
    };
    DetailsView.prototype.checkNameWidth = function() {
        var initialColumn = this.parent.detailsViewSettings.columns;
        this.isNameWidth = false;
        for(var i = 0; i < initialColumn.length; i++)if (initialColumn[i].field === "name") {
            this.isNameWidth = !(0, $3EnZW.isNullOrUndefined)(initialColumn[i].width);
            return;
        }
    };
    DetailsView.prototype.adjustWidth = function(columns, fieldName) {
        if (this.isNameWidth && fieldName === "name") return;
        for(var i = 0; i < columns.length; i++)if (columns[i].field === fieldName) {
            var nameWidth = void 0;
            if (this.parent.breadcrumbbarModule.searchObj.element.value === "" && !this.parent.isFiltered) nameWidth = this.element.clientWidth <= 500 ? "120px" : "auto";
            else nameWidth = this.element.clientWidth <= 680 ? fieldName === "name" ? "120px" : "180px" : "auto";
            columns[i].width = nameWidth;
        }
    };
    DetailsView.prototype.getColumns = function() {
        var columns;
        var enableHtmlSanitizer = this.parent.enableHtmlSanitizer;
        if (this.parent.isMobile) columns = [
            {
                field: "name",
                headerText: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Name"),
                width: "auto",
                minWidth: 120,
                headerTextAlign: "Left",
                template: (0, $c2qqN.initializeCSPTemplate)(function(data) {
                    var name = enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(data.name) : data.name;
                    return '<div class="e-fe-text">' + name + '</div><div class="e-fe-date">' + data._fm_modified + '</div><span class="e-fe-size">' + data.size + "</span>";
                })
            }
        ];
        else {
            columns = (0, $3EnZW.extend)([], this.parent.detailsViewSettings.columns, null, true);
            this.adjustWidth(columns, "name");
            var _loop_1 = function(i, len) {
                columns[i].headerText = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this_1.parent, columns[i].headerText);
                if (columns[i].field === "name" && !(0, $3EnZW.isNullOrUndefined)(columns[i].template) && !(typeof columns[i].template === "function")) {
                    var template_1 = columns[i].template;
                    columns[i].template = (0, $c2qqN.initializeCSPTemplate)(function(data) {
                        var name = enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(data.name) : data.name;
                        return template_1.replace(/\${name}/g, name);
                    });
                }
            };
            var this_1 = this;
            for(var i = 0, len = columns.length; i < len; i++)_loop_1(i, len);
        }
        var iWidth = this.parent.isMobile || this.parent.isBigger ? "54" : "46";
        var icon = {
            field: "type",
            width: iWidth,
            minWidth: iWidth,
            template: (0, $c2qqN.initializeCSPTemplate)(function(data) {
                return '<span class="e-fe-icon ' + data._fm_iconClass + '"></span>';
            }),
            allowResizing: false,
            allowSorting: true,
            customAttributes: {
                class: "e-fe-grid-icon"
            },
            headerTemplate: (0, $c2qqN.initializeCSPTemplate)(function() {
                return "<span class='e-fe-icon e-fe-folder'></span>";
            })
        };
        columns.unshift(icon);
        if (this.parent.showItemCheckBoxes) {
            var cWidth = this.parent.isBigger ? "36" : "26";
            var cBox = {
                type: "checkbox",
                width: cWidth,
                minWidth: cWidth,
                customAttributes: {
                    class: "e-fe-checkbox"
                },
                allowResizing: false,
                allowSorting: false
            };
            if (this.parent.isMobile) columns.push(cBox);
            else columns.unshift(cBox);
        }
        for(var i = 0, len = columns.length; i < len; i++)columns[i].disableHtmlEncode = !this.parent.enableHtmlSanitizer;
        if (this.parent.enableRangeSelection) {
            var HiddenName = {
                field: "name",
                visible: false,
                customAttributes: {
                    class: "e-drag-text"
                }
            };
            columns.push(HiddenName);
        }
        return columns;
    };
    DetailsView.prototype.adjustHeight = function() {
        if (!this.gridObj) return;
        var pane = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$1d72a157e3e556f6, this.parent.element);
        var bar = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a, this.parent.element);
        var gridHeader = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$be6b1c5f4806b375, this.parent.element);
        var height = pane.offsetHeight - bar.offsetHeight - gridHeader.offsetHeight;
        this.gridObj.height = height;
        this.gridObj.dataBind();
    };
    DetailsView.prototype.renderCheckBox = function() {
        this.gridObj.columns = this.getColumns();
        this.isColumnRefresh = true;
        this.gridObj.refreshColumns();
    };
    DetailsView.prototype.onRowDataBound = function(args) {
        var td = (0, $4ZDHT.select)(".e-fe-grid-name", args.row);
        if (!td) {
            var columns = this.parent.detailsViewSettings.columns;
            for(var i = 0; i < columns.length; i++)if (columns[i].field === "name") {
                td = args.row.children[this.parent.allowMultiSelection ? i + 2 : i + 1];
                break;
            }
        }
        if (td) td.setAttribute("title", (0, $3EnZW.getValue)("name", args.data));
        if (this.parent.isLayoutChange && this.parent.isCut && this.parent.fileAction === "move" && this.parent.selectedNodes && this.parent.selectedNodes.length !== 0) {
            if (this.parent.selectedNodes.indexOf((0, $3EnZW.getValue)("name", args.data)) !== -1) (0, $a3d9eadd9d99207c$export$7f40c4cb15687f80)(args.row);
        }
        if (!this.parent.showFileExtension && (0, $3EnZW.getValue)("isFile", args.data)) {
            var text = (0, $3EnZW.getValue)("name", args.data);
            var textEle = args.row.querySelector('[title= "' + text + '"]');
            if (textEle) {
                var name_1 = (0, $3EnZW.getValue)("name", args.data);
                var type = (0, $3EnZW.getValue)("type", args.data);
                if (name_1.indexOf(type) !== -1) textEle.innerHTML = name_1.substr(0, name_1.length - type.length);
            }
        }
        if ((0, $3EnZW.getValue)("size", args.data) !== undefined && args.row.querySelector(".e-fe-size")) {
            var sizeEle = args.row.querySelector(".e-fe-size");
            var modifiedSize = void 0;
            if (!(0, $3EnZW.getValue)("isFile", args.data)) modifiedSize = "";
            else {
                var sizeValue = (0, $3EnZW.getValue)("size", args.data);
                var intl = new (0, $bWDaN.Internationalization)(this.parent.locale);
                var sizeFormat = void 0;
                var columns = this.parent.detailsViewSettings.columns;
                for(var i = 0; i < columns.length; i++)if (columns[i].field === "size") {
                    sizeFormat = !(0, $3EnZW.isNullOrUndefined)(columns[i].format) ? columns[i].format.toString() : "n";
                    break;
                }
                var value = intl.formatNumber(sizeValue / 1024, {
                    format: sizeFormat
                });
                modifiedSize = value + " " + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "KB");
            }
            sizeEle.innerHTML = modifiedSize;
        }
        if (this.parent.isMobile) {
            if ((0, $3EnZW.getValue)("_fm_modified", args.data) !== undefined && args.row.querySelector(".e-fe-date")) {
                var dateEle = args.row.querySelector(".e-fe-date");
                var intl = new (0, $bWDaN.Internationalization)(this.parent.locale);
                var columns = this.parent.detailsViewSettings.columns;
                var format = void 0;
                for(var i = 0; i < columns.length; i++)if (columns[i].field === "dateModified") {
                    format = columns[i].format;
                    break;
                }
                var formattedString = intl.formatDate(new Date((0, $3EnZW.getValue)("_fm_modified", args.data)), format);
                dateEle.innerHTML = formattedString;
            }
        }
        var checkWrap = args.row.querySelector("." + $15a2a1ec4804cfd7$export$fb41b8a6ed371c7d);
        if (checkWrap) checkWrap.classList.add("e-small");
        if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(args.data)) args.row.className += " " + (0, $a3d9eadd9d99207c$export$e4c8c20b1ca0ec47)(args.data);
        var eventArgs = {
            element: args.row,
            fileDetails: args.data,
            module: "DetailsView"
        };
        this.parent.trigger("fileLoad", eventArgs);
    };
    DetailsView.prototype.onActionBegin = function(args) {
        if (args.requestType === "sorting") {
            this.parent.setProperties({
                sortOrder: args.direction
            }, true);
            this.parent.setProperties({
                sortBy: args.columnName
            }, true);
            if (this.parent.selectedItems.length !== 0) {
                this.sortItem = true;
                var rows = this.gridObj.getSelectedRowIndexes();
                var len = rows.length;
                this.sortSelectedNodes = [];
                while(len > 0){
                    var data = this.gridObj.getRowsObject()[rows[len - 1]].data;
                    this.sortSelectedNodes.push((0, $3EnZW.getValue)(this.parent.hasId ? "id" : "name", data));
                    len--;
                }
            }
            this.parent.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
        }
    };
    DetailsView.prototype.onHeaderCellInfo = function(args) {
        var checkWrap = args.node.querySelector("." + $15a2a1ec4804cfd7$export$fb41b8a6ed371c7d);
        if (checkWrap) checkWrap.classList.add("e-small");
    };
    DetailsView.prototype.onBeforeDataBound = function(args) {
        var _this = this;
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.parent.element);
        var nameColumn = this.parent.detailsViewSettings.columns.find(function(column) {
            return column.field === _this.parent.sortBy;
        });
        if (nameColumn && !("sortComparer" in nameColumn)) {
            var items = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, this.parent.enableVirtualization ? args.result : this.gridObj.dataSource);
            args.result = items;
        }
    };
    /* istanbul ignore next */ DetailsView.prototype.onDataBound = function() {
        this.createDragObj();
        if (this.parent.selectedItems.length !== 0 && !this.parent.enableVirtualization || this.parent.selectedItems.length !== 0 && this.parent.enableVirtualization && this.element.querySelector(".e-content").scrollTop === 0) this.selectRecords(this.parent.selectedItems);
        if (this.isPasteOperation === true) {
            if (!this.isColumnRefresh) {
                this.selectRecords(this.parent.pasteNodes);
                this.isPasteOperation = false;
            } else this.isColumnRefresh = false;
        }
        if (this.parent.createdItem) {
            this.selectRecords([
                (0, $3EnZW.getValue)(this.parent.hasId ? "id" : "name", this.parent.createdItem)
            ]);
            this.parent.createdItem = null;
        }
        if (this.parent.layoutSelectedItems.length) this.selectRecords(this.parent.layoutSelectedItems);
        if (this.parent.renamedItem) {
            this.addSelection(this.parent.renamedItem);
            this.parent.renamedItem = null;
        }
        if (this.sortItem === true) {
            this.selectRecords(this.sortSelectedNodes);
            this.sortItem = false;
        }
        if (this.isSelectionUpdate) {
            if (!this.isColumnRefresh) {
                this.selectRecords(this.currentSelectedItem);
                this.isSelectionUpdate = false;
            } else this.isColumnRefresh = false;
        }
        if (this.uploadOperation === true) {
            this.count++;
            this.selectRecords(this.parent.uploadItem);
            if (this.count === this.parent.uploadItem.length) {
                this.uploadOperation = false;
                this.parent.uploadItem = [];
            }
        }
        if (this.gridObj.currentViewData.length * this.gridObj.getRowHeight() < this.gridObj.height) {
            var hdTable = this.gridObj.getHeaderContent();
            hdTable.style.paddingRight = "";
            hdTable.style.paddingLeft = "";
            var hdContent = (0, $4ZDHT.select)(".e-headercontent", hdTable);
            hdContent.style.borderRightWidth = "0";
            var cnTable = this.gridObj.getContent().querySelector(".e-content");
            cnTable.style.overflowY = "";
            cnTable.classList.add("e-scrollShow");
        } else {
            var hdTable = this.gridObj.getHeaderContent();
            if (!this.parent.enableRtl) hdTable.style.paddingRight = "16px";
            else hdTable.style.paddingLeft = "16px";
            var cnTable = this.gridObj.getContent().querySelector(".e-content");
            cnTable.classList.remove("e-scrollShow");
        }
        this.isRendered = true;
        this.parent.isLayoutChange = false;
        (0, $d4834c37f505aa74$export$95fec50f68454318)(this.parent.element);
        this.checkEmptyDiv(this.emptyArgs);
        this.isInteracted = this.isLoaded ? true : this.isInteracted;
        this.isLoaded = false;
    };
    DetailsView.prototype.selectRecords = function(nodes) {
        var gridRecords = this.gridObj.getCurrentViewRecords();
        var sRecords = [];
        for(var i = 0, len = gridRecords.length; i < len; i++){
            var node = this.parent.hasId ? (0, $3EnZW.getValue)("id", gridRecords[i]) : (0, $a3d9eadd9d99207c$export$7d9f7e9c1c02b41e)(this.parent, gridRecords[i]);
            if (nodes.indexOf(node) !== -1) sRecords.push(i);
            else if (!this.parent.showFileExtension && !this.parent.hasId && node.includes(".")) {
                var Str2 = node.split(".").slice(0, -1).join(".");
                if (nodes.indexOf(Str2) !== -1) sRecords.push(i);
            }
        }
        if (sRecords.length !== 0) {
            this.gridObj.selectRows(sRecords);
            this.addFocus(this.gridObj.selectedRowIndex);
        }
    };
    DetailsView.prototype.addSelection = function(data) {
        var items = this.gridObj.getCurrentViewRecords();
        var rData = [];
        if (this.parent.hasId) rData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(items).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("id", "equal", this.parent.renamedId, false));
        else {
            var nData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(items).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("name", "equal", (0, $3EnZW.getValue)("name", data), false));
            if (nData.length > 0) rData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(nData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("filterPath", "equal", this.parent.filterPath, false));
        }
        if (rData.length > 0) {
            var index = items.indexOf(rData[0]);
            this.gridObj.selectRows([
                index
            ]);
        }
    };
    DetailsView.prototype.onSortColumn = function() {
        if (this.parent.sortOrder !== "None") this.gridObj.sortModule.sortColumn(this.parent.sortBy, this.parent.sortOrder);
        else this.gridObj.dataSource = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, this.gridObj.dataSource);
        if (this.element.querySelector(".e-content").scrollTop !== 0) this.gridObj.freezeRefresh();
    };
    DetailsView.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName() && e.module !== "common") /* istanbul ignore next */ return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "allowDragAndDrop":
                    this.createDragObj();
                    break;
                case "height":
                    this.adjustHeight();
                    break;
                case "detailsViewSettings":
                    if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj)) {
                        this.checkNameWidth();
                        var columns = this.getColumns();
                        this.gridObj.columns = columns;
                        this.gridObj.allowResizing = this.parent.detailsViewSettings.columnResizing;
                        this.gridObj.dataBind();
                        this.gridObj.refreshColumns();
                    }
                    break;
                case "selectedItems":
                    this.interaction = false;
                    if (this.parent.selectedItems.length !== 0) {
                        if (!this.parent.allowMultiSelection) {
                            var slItems = this.parent.selectedItems.slice(this.parent.selectedItems.length - 1);
                            this.parent.setProperties({
                                selectedItems: slItems
                            }, true);
                        }
                        this.selectRecords(this.parent.selectedItems);
                        this.parent.setProperties({
                            selectedItems: this.parent.selectedItems
                        }, true);
                    } else if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj)) {
                        this.gridObj.clearSelection();
                        this.interaction = true;
                    }
                    break;
                case "showFileExtension":
                    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
                    break;
                case "showHiddenItems":
                    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
                    break;
                case "showItemCheckBoxes":
                case "allowMultiSelection":
                    if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj)) {
                        this.currentSelectedItem = this.parent.selectedItems;
                        this.gridObj.selectionSettings.type = e.newProp.allowMultiSelection ? "Multiple" : "Single";
                        this.isSelectionUpdate = true;
                        this.renderCheckBox();
                    }
                    break;
                case "view":
                    (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this.parent, "Details");
                    break;
                case "width":
                    this.onDetailsResize();
            }
        }
    };
    DetailsView.prototype.onPathChanged = function(args) {
        this.parent.isCut = false;
        var pathField = this.parent.detailsViewSettings.columns.find(function(column) {
            return column.field === "filterPath";
        });
        if (this.parent.breadcrumbbarModule.searchObj.element.value.trim() === "" && this.gridObj || !(0, $3EnZW.isNullOrUndefined)(pathField) && !(0, $3EnZW.isNullOrUndefined)(pathField.hideAtMedia) && pathField.hideAtMedia !== "") {
            this.parent.searchedItems = [];
            if (!this.parent.isFiltered) this.removePathColumn(false);
            else this.updatePathColumn();
        }
        (0, $a3d9eadd9d99207c$export$f9525c32dad03cf2)(this.parent);
        if (this.parent.view === "Details") {
            /* istanbul ignore next */ this.isInteracted = false;
            (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.parent.element);
            this.parent.setProperties({
                selectedItems: []
            }, true);
            this.gridObj.dataSource = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, args.files);
            this.gridObj.freezeRefresh();
            if (this.parent.isReact) this.gridObj.on("reactTemplateRender", this.reactTemplateRender, this);
        }
        this.emptyArgs = args;
    };
    DetailsView.prototype.updatePathColumn = function() {
        var len = this.gridObj.columns.length;
        var columnData = JSON.parse(JSON.stringify(this.gridObj.columns));
        if (columnData[len - 1].field && columnData[len - 1].field !== "filterPath" && !this.parent.isMobile) {
            var pathColumn = {
                field: "filterPath",
                headerText: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Path"),
                minWidth: 180,
                width: "auto"
            };
            this.gridObj.columns.push(pathColumn);
            this.adjustWidth(this.gridObj.columns, "filterPath");
            this.adjustWidth(this.gridObj.columns, "name");
            this.isColumnRefresh = true;
            this.gridObj.refreshColumns();
        }
    };
    DetailsView.prototype.checkEmptyDiv = function(args) {
        var items = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, args.files);
        if (items.length === 0 && !(0, $3EnZW.isNullOrUndefined)(this.element.querySelector("." + $15a2a1ec4804cfd7$export$3556ea5f805d5290))) (0, $a3d9eadd9d99207c$export$b7ca5bd2fd689a12)(this.parent, this.element, args);
        else if (items.length !== 0 && this.element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58)) {
            if (this.element.querySelector("." + $15a2a1ec4804cfd7$export$3556ea5f805d5290).querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58)) {
                var emptyDiv = this.element.querySelector("." + $15a2a1ec4804cfd7$export$3556ea5f805d5290).querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58);
                this.element.querySelector("." + $15a2a1ec4804cfd7$export$3556ea5f805d5290).removeChild(emptyDiv);
            } else this.element.removeChild(this.element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58));
        }
    };
    DetailsView.prototype.onOpenInit = function() {
        if (this.parent.activeModule === "detailsview") {
            var data = this.gridObj.getSelectedRecords()[0];
            this.openContent(data);
        }
    };
    DetailsView.prototype.DblClickEvents = function(args) {
        this.gridObj.selectRows([
            args.rowIndex
        ]);
        var data;
        if (args.rowData) {
            data = JSON.parse(JSON.stringify(args.rowData));
            this.openContent(data);
        }
    };
    DetailsView.prototype.openContent = function(data) {
        var _this = this;
        if (!(0, $a3d9eadd9d99207c$export$7121632912d0e323)(data)) {
            (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, data, $f592513f3f17ead8$export$826a768f8295bc53);
            return;
        }
        var eventArgs = {
            cancel: false,
            fileDetails: data,
            module: "DetailsView"
        };
        this.parent.trigger("fileOpen", eventArgs, function(fileOpenArgs) {
            if (!fileOpenArgs.cancel) {
                var name_2 = (0, $3EnZW.getValue)("name", data);
                if ((0, $3EnZW.getValue)("isFile", data)) {
                    var icon = (0, $a3d9eadd9d99207c$export$e40fbc04d72f5340)(data);
                    if (icon === $15a2a1ec4804cfd7$export$a3f7f90e20dcc8e7) {
                        var imgUrl = (0, $a3d9eadd9d99207c$export$492f76f65bf1bced)(_this.parent, data);
                        (0, $1ded0ca663b14865$export$a5bbeff43904cfce)(_this.parent, name_2, imgUrl);
                    }
                } else {
                    var val = _this.parent.breadcrumbbarModule.searchObj.element.value;
                    if (val === "" && !_this.parent.isFiltered) {
                        var id = (0, $3EnZW.getValue)("id", data);
                        _this.parent.oldPath = _this.parent.path;
                        var newPath = _this.parent.path + ((0, $3EnZW.isNullOrUndefined)(id) ? name_2 : id) + "/";
                        _this.parent.setProperties({
                            path: newPath
                        }, true);
                        _this.parent.pathNames.push(name_2);
                        _this.parent.pathId.push((0, $3EnZW.getValue)("_fm_id", data));
                        _this.parent.itemData = [
                            data
                        ];
                        (0, $a3d9eadd9d99207c$export$d42fb38e7fbe6740)(_this.parent);
                    } else (0, $a3d9eadd9d99207c$export$d60e3393d26bdbb4)(_this.parent, data);
                    _this.parent.isFiltered = false;
                }
                _this.element.focus();
                if (_this.parent.enableVirtualization) _this.parent.element.querySelector("#" + _this.parent.element.id + $15a2a1ec4804cfd7$export$e6b68dc330b66d31).focus();
            }
        });
    };
    /* istanbul ignore next */ DetailsView.prototype.onLayoutChange = function(args) {
        if (this.parent.view === "Details") {
            if (this.parent.enableVirtualization) this.parent.setProperties({
                selectedItems: []
            }, true);
            if (!this.gridObj) this.render(args);
            else this.isLoaded = true;
            if (this.parent.isFiltered) {
                this.updatePathColumn();
                this.parent.setProperties({
                    selectedItems: []
                }, true);
            }
            this.gridObj.dataSource = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, args.files);
            this.parent.notify($f592513f3f17ead8$export$2aa63067005154ea, {});
            this.gridObj.element.classList.remove($15a2a1ec4804cfd7$export$acfd27c680995d44);
            this.isInteracted = false;
            this.gridObj.clearSelection();
            if (this.parent.breadcrumbbarModule.searchObj.element.value.trim() !== "") this.onSearchFiles(args);
            this.adjustHeight();
            if (this.gridObj.sortSettings.columns.length > 0 && this.gridObj.sortSettings.columns[0].field !== this.parent.sortBy) {
                if (this.parent.sortOrder !== "None") this.gridObj.sortColumn(this.parent.sortBy, this.parent.sortOrder);
            }
        }
    };
    /* istanbul ignore next */ DetailsView.prototype.onSearchFiles = function(args) {
        if (this.parent.view === "Details") {
            this.parent.setProperties({
                selectedItems: []
            }, true);
            this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
            if (!this.parent.isLayoutChange) this.parent.layoutSelectedItems = [];
            this.updatePathColumn();
            this.parent.searchedItems = args.files;
            this.onPathChanged(args);
        }
    };
    DetailsView.prototype.removePathColumn = function(isRefresh) {
        var len = this.gridObj.columns.length;
        var columnData = JSON.parse(JSON.stringify(this.gridObj.columns));
        if (columnData[len - 1].field && columnData[len - 1].field === "filterPath") {
            /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj.sortSettings.columns[0]) && this.gridObj.sortSettings.columns[0].field === "filterPath") {
                if (this.parent.sortOrder !== "None") this.gridObj.sortColumn("name", this.parent.sortOrder);
                else this.gridObj.dataSource = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, this.gridObj.dataSource);
                this.parent.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
            }
            this.gridObj.columns.pop();
            if (!isRefresh) {
                this.isColumnRefresh = true;
                this.gridObj.refreshColumns();
            }
        }
    };
    DetailsView.prototype.onFinalizeEnd = function(args) {
        if (this.parent.view !== "Details") return;
        if (!this.gridObj) this.render(args);
        else this.onPathChanged(args);
    };
    DetailsView.prototype.onCreateEnd = function(args) {
        if (this.parent.view !== "Details") return;
        this.onPathChanged(args);
    };
    DetailsView.prototype.onRenameInit = function() {
        if (this.parent.activeModule === "detailsview" && this.parent.selectedItems.length === 1) this.updateRenameData();
    };
    DetailsView.prototype.onSelectedData = function() {
        if (this.parent.activeModule === "detailsview") this.parent.itemData = this.gridObj.getSelectedRecords();
    };
    DetailsView.prototype.onDeleteInit = function() {
        if (this.parent.activeModule === "detailsview") (0, $5703c0df24e3a120$export$bfadae053a633538)(this.parent, this.parent.selectedItems, this.parent.path, "delete");
    };
    /* istanbul ignore next */ DetailsView.prototype.onDeleteEnd = function(args) {
        if (this.parent.view !== "Details") return;
        this.onPathChanged(args);
        this.parent.setProperties({
            selectedItems: []
        }, true);
    };
    DetailsView.prototype.onRefreshEnd = function(args) {
        if (this.parent.view !== "Details") return;
        this.isInteracted = false;
        this.removePathColumn(false);
        this.gridObj.dataSource = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, args.files);
        this.emptyArgs = args;
    };
    DetailsView.prototype.onHideLayout = function() {
        if (this.parent.view !== "Details" && this.gridObj) this.gridObj.element.classList.add($15a2a1ec4804cfd7$export$acfd27c680995d44);
    };
    DetailsView.prototype.onSelectAllInit = function() {
        if (this.parent.view === "Details") {
            this.isInteracted = false;
            if (this.parent.allowMultiSelection) this.gridObj.selectionModule.selectRowsByRange(0, this.gridObj.getRows().length);
            else this.gridObj.selectRow(this.gridObj.getRows().length - 1);
            this.isInteracted = true;
            this.interaction = true;
        }
    };
    DetailsView.prototype.onClearAllInit = function() {
        if (this.parent.view === "Details") {
            this.removeSelection();
            this.interaction = true;
        }
    };
    /* istanbul ignore next */ DetailsView.prototype.onSelectionChanged = function() {
        (0, $4ZDHT.removeClass)([
            this.element
        ], $15a2a1ec4804cfd7$export$a6e1934effcfc9b9);
        if (this.parent.selectedItems.length > 0) (0, $4ZDHT.addClass)([
            this.element
        ], $15a2a1ec4804cfd7$export$a6e1934effcfc9b9);
    };
    DetailsView.prototype.onLayoutRefresh = function() {
        if (this.parent.view !== "Details") return;
        this.adjustHeight();
    };
    DetailsView.prototype.onBeforeRequest = function() {
        this.isRendered = false;
    };
    DetailsView.prototype.onAfterRequest = function() {
        this.isRendered = true;
    };
    DetailsView.prototype.onUpdateSelectionData = function() {
        if (this.parent.view !== "Details") return;
        this.parent.itemData = this.gridObj.getSelectedRecords();
    };
    DetailsView.prototype.addEventListener = function() {
        this.parent.on($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd, this);
        this.parent.on($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange, this);
        this.parent.on($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd, this);
        this.parent.on($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit, this);
        this.parent.on($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit, this);
        this.parent.on($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd, this);
        this.parent.on($f592513f3f17ead8$export$d76128d007d19019, this.onSearchFiles, this);
        this.parent.on($f592513f3f17ead8$export$5cd299b993c9e318, this.onMethodCall, this);
        this.parent.on($f592513f3f17ead8$export$6df5a05f342711e3, this.onActionFailure, this);
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit, this);
        this.parent.on($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd, this);
        this.parent.on($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData, this);
        this.parent.on($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit, this);
        this.parent.on($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit, this);
        this.parent.on($f592513f3f17ead8$export$18b54396d5a039c5, this.onSortColumn, this);
        this.parent.on($f592513f3f17ead8$export$d9e8b42c77102776, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$cd2e3b33990298ee, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$df482b6a24e5bccf, this.onPasteInit, this);
        this.parent.on($f592513f3f17ead8$export$2aa63067005154ea, this.onHideLayout, this);
        this.parent.on($f592513f3f17ead8$export$8c0e181e1fb07b6c, this.onSelectAllInit, this);
        this.parent.on($f592513f3f17ead8$export$846f4c514484a0e8, this.onClearAllInit, this);
        this.parent.on($f592513f3f17ead8$export$40ce9a35c05f873f, this.onPathColumn, this);
        this.parent.on($f592513f3f17ead8$export$6abf7ade54df8039, this.onSelectionChanged, this);
        this.parent.on($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.onBeforeRequest, this);
        this.parent.on($f592513f3f17ead8$export$5af90369d26bf4d0, this.onAfterRequest, this);
        this.parent.on($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd, this);
        this.parent.on($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit, this);
        this.parent.on($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData, this);
        this.parent.on($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.onDetailsResizeHandler, this);
        this.parent.on($f592513f3f17ead8$export$d8057c29295b3f97, this.onDetailsResize, this);
        this.parent.on($f592513f3f17ead8$export$c8a5c97778a58170, this.onLayoutRefresh, this);
        this.parent.on($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath, this);
        this.parent.on($f592513f3f17ead8$export$ed7f9366d0aedd6a, this.onUpdateSelectionData, this);
    };
    DetailsView.prototype.removeEventListener = function() {
        this.parent.off($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd);
        this.parent.off($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange);
        this.parent.off($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$df482b6a24e5bccf, this.onPasteInit);
        this.parent.off($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd);
        this.parent.off($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd);
        this.parent.off($f592513f3f17ead8$export$d76128d007d19019, this.onSearchFiles);
        this.parent.off($f592513f3f17ead8$export$5cd299b993c9e318, this.onMethodCall);
        this.parent.off($f592513f3f17ead8$export$6df5a05f342711e3, this.onActionFailure);
        this.parent.off($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit);
        this.parent.off($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$cd2e3b33990298ee, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit);
        this.parent.off($f592513f3f17ead8$export$18b54396d5a039c5, this.onSortColumn);
        this.parent.off($f592513f3f17ead8$export$d9e8b42c77102776, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$2aa63067005154ea, this.onHideLayout);
        this.parent.off($f592513f3f17ead8$export$8c0e181e1fb07b6c, this.onSelectAllInit);
        this.parent.off($f592513f3f17ead8$export$846f4c514484a0e8, this.onClearAllInit);
        this.parent.off($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit);
        this.parent.off($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd);
        this.parent.off($f592513f3f17ead8$export$40ce9a35c05f873f, this.onPathColumn);
        this.parent.off($f592513f3f17ead8$export$6abf7ade54df8039, this.onSelectionChanged);
        this.parent.off($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.onBeforeRequest);
        this.parent.off($f592513f3f17ead8$export$5af90369d26bf4d0, this.onAfterRequest);
        this.parent.off($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd);
        this.parent.off($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit);
        this.parent.off($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit);
        this.parent.off($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData);
        this.parent.off($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit);
        this.parent.off($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData);
        this.parent.off($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.onDetailsResizeHandler);
        this.parent.off($f592513f3f17ead8$export$d8057c29295b3f97, this.onDetailsResize);
        this.parent.off($f592513f3f17ead8$export$c8a5c97778a58170, this.onLayoutRefresh);
        this.parent.off($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath);
        this.parent.off($f592513f3f17ead8$export$ed7f9366d0aedd6a, this.onUpdateSelectionData);
    };
    DetailsView.prototype.onActionFailure = function() {
        this.interaction = true;
    };
    DetailsView.prototype.onMenuItemData = function(args) {
        if (this.parent.activeModule === this.getModuleName()) this.parent.itemData = [
            this.gridObj.getRowInfo(args.target).rowData
        ];
    };
    DetailsView.prototype.onPasteInit = function() {
        if (this.parent.activeModule === this.getModuleName()) this.parent.itemData = this.parent.folderPath !== "" ? this.gridObj.getSelectedRecords() : [
            (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this.parent)
        ];
    };
    DetailsView.prototype.onDetailsInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            if (this.parent.selectedItems.length !== 0) this.parent.itemData = this.gridObj.getSelectedRecords();
            else this.parent.itemData = [
                (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent)
            ];
        }
    };
    DetailsView.prototype.dragHelper = function(args) {
        var dragTarget = args.sender.target;
        var dragLi = dragTarget.closest("tr.e-row");
        if (!dragLi) return null;
        var name;
        if (dragLi.getElementsByClassName("e-fe-text")[0]) name = this.parent.hasId ? this.gridObj.getRowInfo(dragLi).rowData.id : dragLi.getElementsByClassName("e-fe-text")[0].innerText;
        else if (dragLi.getElementsByClassName("e-rowcell e-templatecell")[0].nextElementSibling) name = this.parent.hasId ? this.gridObj.getRowInfo(dragLi).rowData.id : dragLi.getElementsByClassName("e-rowcell e-templatecell")[0].nextElementSibling.innerText;
        if (dragLi && !dragLi.querySelector(".e-active")) this.selectRecords([
            name
        ]);
        (0, $a3d9eadd9d99207c$export$90835e7e06f4e75b)(this.parent, dragLi);
        this.parent.activeElements = [];
        this.parent.dragData = [];
        this.parent.dragData = this.gridObj.getSelectedRecords();
        var dragRow;
        if (this.parent.dragData.length === 0 && dragLi) dragRow = this.gridObj.getRowInfo(dragLi);
        if (dragRow) this.parent.dragData.push(dragRow.rowData);
        this.parent.dragPath = this.parent.path;
        this.parent.activeElements = this.gridObj.getSelectedRows();
        (0, $a3d9eadd9d99207c$export$fda104f371357c1e)(this.parent);
        return this.parent.virtualDragElement;
    };
    /* istanbul ignore next */ DetailsView.prototype.onDetailsResize = function() {
        if (this.parent.view === "Details" && !this.parent.isMobile && !(0, $3EnZW.isNullOrUndefined)(this.gridObj)) {
            var gridHeader = this.gridObj.getHeaderContent().querySelector(".e-headercontent");
            var gridHeaderColGroup = gridHeader.firstChild.childNodes[0];
            var gridContentColGroup = this.gridObj.getContent().querySelector(".e-content .e-table").children[0];
            var gridHeaderColNames = this.gridObj.getColumns();
            for(var i = 0; i < gridHeaderColNames.length; i++)if (!this.isNameWidth && gridHeaderColNames[i].field === "name" || gridHeaderColNames[i].field === "filterPath") {
                if (this.parent.breadcrumbbarModule.searchObj.element.value === "" && !this.parent.isFiltered) {
                    if (this.element.clientWidth <= 500) {
                        gridHeaderColGroup.children[i].setAttribute("style", "width: 120px");
                        gridContentColGroup.children[i].setAttribute("style", "width: 120px");
                    } else if (this.element.clientWidth > 500) {
                        gridHeaderColGroup.children[i].setAttribute("style", "width: auto");
                        gridContentColGroup.children[i].setAttribute("style", "width: auto");
                    }
                } else {
                    if (this.element.clientWidth <= 680) {
                        if (gridHeaderColNames[i].field === "name") {
                            gridHeaderColGroup.children[i].setAttribute("style", "width: 120px");
                            gridContentColGroup.children[i].setAttribute("style", "width: 120px");
                        } else {
                            gridHeaderColGroup.children[i].setAttribute("style", "width: 180px");
                            gridContentColGroup.children[i].setAttribute("style", "width: 180px");
                        }
                    } else if (this.element.clientWidth > 680) {
                        gridHeaderColGroup.children[i].setAttribute("style", "width: auto");
                        gridContentColGroup.children[i].setAttribute("style", "width: auto");
                    }
                }
            }
        }
    };
    DetailsView.prototype.onDetailsResizeHandler = function() {
        this.onDetailsResize();
        if (this.parent.view === "Details" && !this.parent.isMobile && !(0, $3EnZW.isNullOrUndefined)(this.gridObj)) this.adjustHeight();
    };
    DetailsView.prototype.createDragObj = function() {
        var _this = this;
        if (this.gridObj) {
            if (this.parent.allowDragAndDrop && (0, $3EnZW.isNullOrUndefined)(this.dragObj)) this.dragObj = new (0, $eAUyT.Draggable)(this.gridObj.element, {
                cursorAt: this.parent.dragCursorPosition,
                distance: 5,
                enableTailMode: true,
                dragArea: this.parent.element,
                dragTarget: "." + $15a2a1ec4804cfd7$export$7d8b172d5f206b6c,
                drag: (0, $a3d9eadd9d99207c$export$f293f44a7af9215d).bind(this, this.parent),
                dragStart: function(args) {
                    (0, $a3d9eadd9d99207c$export$db131b841f9f6440)(_this.parent, args, _this.dragObj);
                },
                dragStop: (0, $a3d9eadd9d99207c$export$202f08d3a6bd576).bind(this, this.parent),
                enableAutoScroll: false,
                helper: this.dragHelper.bind(this)
            });
            else if (!this.parent.allowDragAndDrop && this.dragObj) {
                this.dragObj.destroy();
                this.dragObj = null;
            }
        }
    };
    DetailsView.prototype.onDropInit = function(args) {
        if (this.parent.targetModule === this.getModuleName()) {
            /* istanbul ignore next */ var cwdData = (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent);
            if (!args.target.closest("tr")) {
                this.parent.dropPath = this.parent.path;
                this.parent.dropData = cwdData;
            } else {
                var info = null;
                info = this.gridObj.getRowInfo(args.target).rowData;
                this.parent.dropPath = info.isFile ? this.parent.path : (0, $a3d9eadd9d99207c$export$ce41aaed7504a4ce)(this.parent, info, this.parent.path);
                this.parent.dropData = info.isFile ? cwdData : info;
            }
        }
    };
    DetailsView.prototype.oncutCopyInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            this.parent.activeRecords = this.gridObj.getSelectedRecords();
            this.parent.activeElements = this.gridObj.getSelectedRows();
        }
    };
    DetailsView.prototype.onpasteEnd = function(args) {
        if (this.parent.view === "Details") {
            this.isPasteOperation = true;
            if (this.parent.path === this.parent.destinationPath || this.parent.path === (0, $a3d9eadd9d99207c$export$386ecaf3f3c304a2)(this.parent, args) || this.parent.hasId) this.onPathChanged(args);
        }
    };
    DetailsView.prototype.onDropPath = function(args) {
        if (this.parent.view === "Details") {
            this.isPasteOperation = true;
            this.onPathChanged(args);
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns modules name.
     * @private
     */ DetailsView.prototype.getModuleName = function() {
        return "detailsview";
    };
    DetailsView.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        if (this.gridObj) {
            if (this.parent.isReact) this.gridObj.off("reactTemplateRender", this.reactTemplateRender);
            this.unWireEvents();
            this.gridObj.destroy();
        }
    };
    DetailsView.prototype.updateType = function(item) {
        var folder = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$d31d8fac97169a4b, item);
        this.parent.isFile = (0, $3EnZW.isNullOrUndefined)(folder) ? true : false;
    };
    /* istanbul ignore next */ DetailsView.prototype.onSelection = function(action, args) {
        var eventArgs = {
            action: action,
            fileDetails: args.data,
            isInteracted: this.interaction,
            cancel: false,
            target: args.target
        };
        this.parent.trigger("fileSelection", eventArgs);
        args.cancel = eventArgs.cancel;
        if (!this.isMultiSelect) {
            this.isMultiSelect = true;
            if ((args.isShiftPressed || args.isCtrlPressed) && !this.parent.allowMultiSelection && args.target && args.target.parentElement && !args.target.parentElement.classList.contains("e-checkbox-wrapper")) {
                args.cancel = true;
                var rowIndex = args && args.rowIndexes ? args.rowIndexes[args.rowIndexes.length - 1] : args.rowIndex;
                this.gridObj.selectRow(rowIndex);
            }
            this.isMultiSelect = false;
        }
    };
    /* istanbul ignore next */ DetailsView.prototype.onSelected = function(args) {
        this.parent.activeModule = "detailsview";
        if (!this.parent.isLayoutChange || this.parent.isFiltered) this.selectedRecords();
        this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
        if (this.gridObj.getSelectedRowIndexes().length === 1) this.firstItemIndex = this.gridObj.selectedRowIndex;
        this.gridObj.element.setAttribute("tabindex", "-1");
        this.triggerSelect("select", args);
        var item = this.gridObj.getRowByIndex(this.gridObj.selectedRowIndex);
        this.updateType(item);
        if (!(0, $3EnZW.isNullOrUndefined)(item) && !(0, $3EnZW.isNullOrUndefined)(item.querySelector(".e-checkselect"))) {
            if (this.gridObj.getSelectedRowIndexes().length !== 1) {
                var lastItemIndex = this.gridObj.getSelectedRowIndexes()[this.gridObj.getSelectedRowIndexes().length - 2];
                var lastItem = this.gridObj.getRowByIndex(lastItemIndex);
                lastItem.querySelector(".e-checkselect").setAttribute("tabindex", "-1");
            }
            item.querySelector(".e-rowcell.e-fe-checkbox").removeAttribute("tabindex");
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj) && !(0, $3EnZW.isNullOrUndefined)(this.gridObj.element.querySelector(".e-checkselectall"))) this.gridObj.element.querySelector(".e-checkselectall").setAttribute("tabindex", "-1");
        var rows = this.gridObj.getSelectedRowIndexes();
        if (!this.parent.allowMultiSelection) {
            for(var i = 0; i < rows.length; i++)if (rows[i] === this.gridObj.selectedRowIndex) this.gridObj.getRowByIndex(rows[i]).setAttribute("tabindex", "0");
            else this.gridObj.getRowByIndex(rows[i]).removeAttribute("tabindex");
        }
        var len = rows.length;
        if (this.parent.enableVirtualization) this.parent.currentItemText = (0, $3EnZW.getValue)("name", args.data);
        else if (len > 0) {
            var data = this.gridObj.getRowsObject()[rows[len - 1]].data;
            this.parent.currentItemText = (0, $3EnZW.getValue)("name", data);
        }
        var indexes = (0, $3EnZW.getValue)("rowIndexes", args);
        var multiSelect = (0, $3EnZW.getValue)("enableSelectMultiTouch", this.gridObj.selectionModule);
        if (this.parent.isDevice && (0, $3EnZW.isNullOrUndefined)(indexes) && args.target && !multiSelect && !args.target.closest(".e-headercell")) {
            this.parent.isFile = (0, $3EnZW.getValue)("isFile", args.data);
            if (!this.parent.isFile) this.openContent(args.data);
        }
        this.parent.visitedItem = args.row;
        if (!this.parent.enableVirtualization || !args.isHeaderCheckboxClicked) this.addFocus(this.gridObj.selectedRowIndex);
        if (!this.parent.isLayoutChange) this.isInteracted = true;
    };
    /* istanbul ignore next */ DetailsView.prototype.onPathColumn = function() {
        if (this.parent.view === "Details" && !(0, $3EnZW.isNullOrUndefined)(this.gridObj)) {
            if (this.parent.breadcrumbbarModule.searchObj.element.value === "" && !this.parent.isFiltered) this.removePathColumn(false);
        }
    };
    DetailsView.prototype.selectedRecords = function() {
        this.parent.setProperties({
            selectedItems: []
        }, true);
        var selectedRecords = this.gridSelectNodes();
        var selectSize = 0;
        while(selectSize < selectedRecords.length){
            var record = selectedRecords[selectSize];
            var name_3 = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, record);
            this.parent.selectedItems.push(name_3);
            selectSize++;
        }
        this.parent.setProperties({
            selectedItems: this.parent.selectedItems
        }, true);
    };
    DetailsView.prototype.onDeSelection = function(args) {
        /* istanbul ignore next */ if (!this.parent.allowMultiSelection && (0, $3EnZW.isNullOrUndefined)(args.data)) this.gridObj.getRowByIndex(args.rowIndex).removeAttribute("tabindex");
        else if (this.gridObj.getSelectedRowIndexes().length > 1) {
            var lastItemIndex = this.gridObj.getSelectedRowIndexes()[this.gridObj.getSelectedRowIndexes().length - 2];
            this.gridObj.getRowByIndex(lastItemIndex).querySelector(".e-checkselect").removeAttribute("tabindex");
        }
        if (this.gridObj.selectedRowIndex === -1) this.gridObj.element.setAttribute("tabindex", "0");
        if (!this.isInteracted) {
            this.isInteracted = true;
            return;
        }
        this.selectedRecords();
        if (this.parent.selectedItems.length === 0) {
            (0, $3EnZW.setValue)("enableSelectMultiTouch", false, this.gridObj.selectionModule);
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
        }
        this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
        this.triggerSelect("unselect", args);
        this.parent.visitedItem = null;
    };
    DetailsView.prototype.triggerSelect = function(action, args) {
        var eventArgs = {
            action: action,
            fileDetails: args.data,
            isInteracted: this.interaction
        };
        this.parent.trigger("fileSelect", eventArgs);
        this.interaction = true;
    };
    DetailsView.prototype.wireEvents = function() {
        this.wireClickEvent(true);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.gridObj.element, {
            keyAction: this.keyupHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keyup"
        });
        this.keyboardDownModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keydownHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
        (0, $aqzbR.EventHandler).add(this.gridObj.element, "blur", this.removeFocus, this);
        (0, $aqzbR.EventHandler).add(this.parent.element, "focusout", this.onBlur, this);
    };
    DetailsView.prototype.unWireEvents = function() {
        this.wireClickEvent(false);
        this.keyboardModule.destroy();
        this.keyboardDownModule.destroy();
        (0, $aqzbR.EventHandler).remove(this.gridObj.element, "blur", this.removeFocus);
        (0, $aqzbR.EventHandler).remove(this.parent.element, "focusout", this.onBlur);
    };
    DetailsView.prototype.wireClickEvent = function(toBind) {
        var _this = this;
        if (toBind) {
            var ele = this.gridObj.getContent();
            this.clickObj = new (0, $i528u.Touch)(ele, {
                tap: function(eve) {
                    if (eve.tapCount === 1 && eve.originalEvent.target.classList.contains("e-content")) _this.onClearAllInit();
                },
                tapHold: function(e) {
                    if (_this.parent.isDevice) {
                        e.originalEvent.preventDefault();
                        if (_this.parent.allowMultiSelection) {
                            (0, $3EnZW.setValue)("enableSelectMultiTouch", _this.parent.allowMultiSelection, _this.gridObj.selectionModule);
                            (0, $4ZDHT.addClass)([
                                _this.parent.element
                            ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
                        }
                        var target = e.originalEvent.target;
                        if (target) {
                            var row = (0, $4ZDHT.closest)(target, "." + $15a2a1ec4804cfd7$export$7d8b172d5f206b6c);
                            var index = _this.gridObj.getRows().indexOf(row);
                            _this.gridObj.selectRow(index);
                        }
                    }
                }
            });
        } else if (this.clickObj) this.clickObj.destroy();
    };
    /* istanbul ignore next */ DetailsView.prototype.removeSelection = function() {
        (0, $4ZDHT.removeClass)([
            this.parent.element
        ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
        this.gridObj.clearSelection();
        this.parent.setProperties({
            selectedItems: []
        }, true);
        this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
        if (this.gridObj.selectedRowIndex === -1) this.startIndex = null;
        this.isInteracted = true;
    };
    DetailsView.prototype.removeFocus = function() {
        this.addFocus(null);
    };
    DetailsView.prototype.onBlur = function(e) {
        if (e.relatedTarget !== null && (0, $4ZDHT.closest)(e.relatedTarget, ".e-grid") !== e.relatedTarget) return;
        if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj.element)) {
            var thElements = this.gridObj.element.querySelectorAll("th");
            for(var i = 0; i < thElements.length; i++)if (thElements[i].classList.contains("e-focus")) this.addFocus(null);
        }
    };
    DetailsView.prototype.getFocusedItemIndex = function() {
        return !(0, $3EnZW.isNullOrUndefined)(this.getFocusedItem()) ? parseInt(this.getFocusedItem().getAttribute("data-rowindex"), 10) : null;
    };
    /* istanbul ignore next */ DetailsView.prototype.keydownHandler = function(e) {
        if (!this.isRendered) return;
        switch(e.action){
            case "end":
            case "home":
            case "space":
            case "ctrlSpace":
            case "shiftSpace":
            case "csSpace":
            case "ctrlA":
            case "enter":
            case "altEnter":
            case "ctrlEnd":
            case "shiftEnd":
            case "csEnd":
            case "ctrlHome":
            case "shiftHome":
            case "csHome":
            case "ctrlDown":
            case "shiftDown":
            case "csDown":
            case "ctrlLeft":
            case "shiftLeft":
            case "csLeft":
            case "esc":
            case "del":
            case "shiftdel":
            case "ctrlC":
            case "ctrlV":
            case "ctrlX":
            case "f2":
            case "moveDown":
            case "moveUp":
            case "ctrlD":
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    /* istanbul ignore next */ DetailsView.prototype.keyupHandler = function(e) {
        if (!this.isRendered) return;
        e.preventDefault();
        var action = e.action;
        var gridItems = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, this.gridObj.dataSource);
        var gridLength = gridItems.length;
        var focIndex = this.getFocusedItemIndex();
        var selIndex = this.gridObj.selectedRowIndex;
        var selRowIndeces = this.gridObj.getSelectedRowIndexes();
        var rowData;
        var firstItem;
        var lastItem;
        switch(action){
            case "altEnter":
                this.parent.notify($f592513f3f17ead8$export$d41cfdb8d87b5bef, {});
                (0, $5703c0df24e3a120$export$1b969bdfbc184d40)(this.parent, this.parent.selectedItems, this.parent.path, "details");
                break;
            case "esc":
                (0, $a3d9eadd9d99207c$export$931affad7351dd89)(this.parent);
                break;
            case "del":
            case "shiftdel":
                this.performDelete();
                break;
            case "enter":
                if (this.gridObj.selectedRowIndex === -1 && this.gridObj.allowSorting === true) {
                    if (!e.target.classList.contains("e-fe-grid-icon")) {
                        var direction = !e.target.getElementsByClassName("e-ascending").length ? "Ascending" : "Descending";
                        var currentField = this.gridObj.getColumnByUid(e.target.querySelector(".e-headercelldiv").getAttribute("e-mappinguid")).field;
                        this.gridObj.sortColumn(currentField, direction);
                        if (!(0, $3EnZW.isNullOrUndefined)(this.getFocusedItem().nextSibling)) this.getFocusedItem().nextSibling.setAttribute("tabindex", "0");
                    }
                    break;
                }
                rowData = this.gridObj.getRowsObject()[this.gridObj.selectedRowIndex].data;
                if (rowData) {
                    var data = JSON.parse(JSON.stringify(rowData));
                    this.openContent(data);
                }
                break;
            case "ctrlC":
                (0, $a3d9eadd9d99207c$export$6738b3634be42910)(this.parent);
                break;
            case "ctrlV":
                this.parent.folderPath = "";
                (0, $a3d9eadd9d99207c$export$5b201a757191240e)(this.parent);
                break;
            case "ctrlX":
                (0, $a3d9eadd9d99207c$export$3e9460fe0b724f5e)(this.parent);
                break;
            case "ctrlD":
                this.doDownload();
                break;
            case "f2":
                this.performRename();
                break;
            case "ctrlA":
                if (!(0, $3EnZW.isNullOrUndefined)(gridItems[0]) && this.parent.allowMultiSelection) {
                    var cnTable = this.gridObj.getContent().querySelector(".e-content");
                    var crtSrlPos = cnTable.scrollTop;
                    var crtFocusIndex = this.gridObj.selectedRowIndex;
                    this.gridObj.selectionModule.selectRowsByRange(0, gridItems.length - 1);
                    cnTable.scrollTop = crtSrlPos;
                    if (crtFocusIndex !== -1) this.addFocus(crtFocusIndex);
                }
                break;
            case "ctrlHome":
            case "tab":
                if (!(0, $3EnZW.isNullOrUndefined)(gridItems[0])) {
                    if (!this.parent.allowMultiSelection && e.action === "ctrlHome") this.gridObj.selectRow(0);
                    else if (this.gridObj.selectedRowIndex !== -1 && e.action === "tab") return;
                    else this.addHeaderFocus(e);
                }
                break;
            case "ctrlEnd":
                if (!(0, $3EnZW.isNullOrUndefined)(gridItems[0])) {
                    if (!this.parent.allowMultiSelection) this.gridObj.selectRow(gridLength - 1);
                    else this.addFocus(gridLength - 1);
                }
                break;
            case "shiftHome":
            case "shiftEnd":
            case "csHome":
            case "csEnd":
                if (!this.parent.allowMultiSelection) this.gridObj.selectRow(e.action === "shiftHome" || e.action === "csHome" ? 0 : gridItems.length - 1);
                else if (!(0, $3EnZW.isNullOrUndefined)(gridItems[0])) {
                    if (!(0, $3EnZW.isNullOrUndefined)(selIndex) && selIndex !== -1) this.checkRowsKey(gridItems, selIndex, null, e);
                    else if (e.action === "csHome" || e.action === "shiftHome") this.gridObj.selectRow(0);
                    else this.gridObj.selectionModule.selectRowsByRange(0, gridItems.length - 1);
                }
                break;
            case "space":
            case "csSpace":
            case "shiftSpace":
            case "ctrlSpace":
                this.spaceSelection(selRowIndeces, focIndex, selIndex, e);
                break;
            case "csUp":
            case "csDown":
            case "shiftUp":
            case "shiftDown":
                this.shiftMoveMethod(gridItems, selIndex, focIndex, selRowIndeces, e);
                break;
            case "ctrlUp":
            case "ctrlDown":
                if (!this.parent.allowMultiSelection) this.moveFunction(gridItems, e, selIndex);
                else this.ctrlMoveFunction(gridItems, e, selIndex);
                break;
            case "home":
                firstItem = [
                    (0, $3EnZW.getValue)(this.parent.hasId ? "id" : "name", gridItems[0])
                ];
                this.parent.setProperties({
                    selectedItems: firstItem
                }, true);
                this.selectRecords(firstItem);
                break;
            case "moveUp":
            case "moveDown":
                this.moveFunction(gridItems, e, selIndex);
                break;
            case "end":
                lastItem = [
                    (0, $3EnZW.getValue)(this.parent.hasId ? "id" : "name", gridItems[gridLength - 1])
                ];
                this.parent.setProperties({
                    selectedItems: lastItem
                }, true);
                this.selectRecords(lastItem);
                break;
            case "back":
                this.parent.traverseBackward();
                break;
        }
    };
    DetailsView.prototype.gridSelectNodes = function() {
        return this.gridObj.getSelectedRecords();
    };
    DetailsView.prototype.doDownload = function() {
        if (this.parent.selectedItems.length !== 0) {
            this.parent.itemData = this.gridObj.getSelectedRecords();
            var items = this.parent.itemData;
            for(var i = 0; i < items.length; i++)if (!(0, $a3d9eadd9d99207c$export$afe83600fb70ac59)(items[i])) {
                (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, items[i], $f592513f3f17ead8$export$1812abec3897779e);
                return;
            }
            (0, $5703c0df24e3a120$export$a7aaed3e118dd255)(this.parent, this.parent.path, this.parent.selectedItems);
        }
    };
    DetailsView.prototype.performDelete = function() {
        if (this.parent.selectedItems && this.parent.selectedItems.length > 0) {
            this.parent.itemData = this.gridObj.getSelectedRecords();
            var items = this.parent.itemData;
            for(var i = 0; i < items.length; i++)if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(items[i])) {
                (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, items[i], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                return;
            }
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this.parent, "Delete");
        }
    };
    DetailsView.prototype.performRename = function() {
        if (this.parent.selectedItems.length === 1) {
            this.updateRenameData();
            (0, $a3d9eadd9d99207c$export$d52c45268ea880af)(this.parent);
        }
    };
    DetailsView.prototype.updateRenameData = function() {
        var data = this.gridSelectNodes()[0];
        (0, $a3d9eadd9d99207c$export$f3fb02da958b835d)(this.parent, data);
    };
    DetailsView.prototype.shiftMoveMethod = function(gridItems, selIndex, focIndex, selRowIndeces, e) {
        if (!this.parent.allowMultiSelection) this.moveFunction(gridItems, e, selIndex);
        else {
            if (selIndex === -1 && (e.action === "csUp" || e.action === "csDown")) this.ctrlMoveFunction(gridItems, e, selIndex);
            else if (selIndex !== -1 && focIndex !== selIndex && !((e.action === "csUp" || e.action === "csDown") && this.isSelected(selRowIndeces, focIndex))) this.shiftSelectFocusItem(selIndex, focIndex, selRowIndeces, e);
            else this.shiftSelectedItem(selIndex, selRowIndeces, gridItems, e);
        }
    };
    DetailsView.prototype.moveFunction = function(selectedItems, e, rowIndex) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.getFocusedItem()) && this.parent.allowMultiSelection) {
            if (e.action === "moveDown") this.gridObj.selectRow(this.getFocusedItemIndex() + 1);
            else this.gridObj.selectRow(this.getFocusedItemIndex() - 1);
        } else if (!(0, $3EnZW.isNullOrUndefined)(rowIndex) && rowIndex !== -1) {
            if (e.action === "moveDown" || e.action === "ctrlDown" || e.action === "shiftDown" || e.action === "csDown") this.gridObj.selectRow(rowIndex + (rowIndex !== selectedItems.length - 1 ? 1 : 0));
            else this.gridObj.selectRow(rowIndex - (rowIndex !== 0 ? 1 : 0));
        } else if (!(0, $3EnZW.isNullOrUndefined)(selectedItems[0])) this.gridObj.selectRow(0);
    };
    DetailsView.prototype.spaceSelection = function(selRowIndeces, focIndex, selIndex, e) {
        if (!this.isSelected(selRowIndeces, focIndex) && selIndex !== -1 && (e.action === "shiftSpace" || e.action === "csSpace")) {
            if (focIndex < selIndex) this.gridObj.selectionModule.selectRowsByRange(focIndex, selIndex);
            else this.gridObj.selectionModule.selectRowsByRange(selIndex, focIndex);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.getFocusedItem()) && focIndex !== selIndex) {
            selRowIndeces.push(this.getFocusedItemIndex());
            this.gridObj.selectRows(selRowIndeces);
        } else if (selIndex !== -1 && e.action === "ctrlSpace" && this.parent.allowMultiSelection) {
            var lItem = selIndex;
            selRowIndeces.pop();
            this.gridObj.selectRows(selRowIndeces);
            this.addFocus(lItem);
        } else if (e.action === "shiftSpace") this.gridObj.selectRow(selIndex);
    };
    DetailsView.prototype.ctrlMoveFunction = function(items, e, rowIndex) {
        var nextItem;
        if (!(0, $3EnZW.isNullOrUndefined)(this.getFocusedItem())) {
            var nextIndex = this.getFocusedItemIndex();
            nextItem = e.action === "ctrlDown" || e.action === "csDown" ? nextIndex + (nextIndex < items.length - 1 ? 1 : 0) : nextIndex - (nextIndex < 1 ? 0 : 1);
        } else if (!(0, $3EnZW.isNullOrUndefined)(rowIndex) && rowIndex !== -1) nextItem = e.action === "ctrlDown" || e.action === "csDown" ? rowIndex + (rowIndex < items.length ? 1 : 0) : rowIndex - (rowIndex < 1 ? 0 : 1);
        else if (!(0, $3EnZW.isNullOrUndefined)(items[0])) nextItem = 0;
        this.addFocus(nextItem);
    };
    DetailsView.prototype.checkRowsKey = function(items, indexValue, focIndex, e) {
        if (this.gridObj.checkAllRows === "Uncheck" || this.gridObj.checkAllRows === "Intermediate") {
            if (e.action !== "csHome" && e.action !== "csEnd") {
                if ((0, $3EnZW.isNullOrUndefined)(this.startIndex) && this.firstItemIndex !== indexValue) this.firstItemIndex = indexValue;
                if (e.action === "shiftEnd") this.gridObj.selectionModule.selectRowsByRange(this.firstItemIndex, items.length - 1);
                else this.gridObj.selectionModule.selectRowsByRange(0, this.firstItemIndex);
                this.startIndex = indexValue;
            } else {
                if (e.action === "csEnd") this.gridObj.selectRows(this.InnerItems((0, $3EnZW.isNullOrUndefined)(indexValue) ? 0 : indexValue, (0, $3EnZW.isNullOrUndefined)(focIndex) ? items.length - 1 : focIndex, e));
                else if ((0, $3EnZW.isNullOrUndefined)(indexValue)) this.gridObj.selectRow(0);
                else this.gridObj.selectRows(this.InnerItems((0, $3EnZW.isNullOrUndefined)(focIndex) ? 0 : focIndex, indexValue, e));
            }
        } else this.gridObj.selectionModule.selectRow(e.action === "shiftHome" || e.action === "csHome" ? 0 : items.length - 1);
    };
    DetailsView.prototype.InnerItems = function(fItem, lItem, e) {
        var itemArr = this.gridObj.getSelectedRowIndexes();
        if (e.action === "csEnd") for(var i = fItem + 1; i <= lItem; i++)itemArr.push(i);
        else for(var i = lItem - 1; fItem <= i; i--)itemArr.push(i);
        return itemArr;
    };
    DetailsView.prototype.shiftSelectFocusItem = function(selIndex, fIndex, selRowIndexes, e) {
        var lItem = fIndex + (e.action === "shiftDown" || e.action === "csDown" ? 1 : -1);
        var fItem = (0, $3EnZW.isNullOrUndefined)(this.startIndex) ? selIndex : selRowIndexes[0];
        if (fItem === lItem) this.gridObj.selectRow(fItem);
        else {
            if (fItem < lItem) {
                if (e.action === "shiftDown" || e.action === "csDown") this.gridObj.selectionModule.selectRowsByRange(fItem, lItem);
                else this.gridObj.selectionModule.selectRowsByRange(lItem, fItem);
            } else if (e.action === "shiftDown" || e.action === "csDown") this.gridObj.selectionModule.selectRowsByRange(lItem, fItem);
            else this.gridObj.selectionModule.selectRowsByRange(fItem, lItem);
        }
        this.startIndex = this.gridObj.selectedRowIndex;
    };
    DetailsView.prototype.addFocus = function(item) {
        var fItem = this.getFocusedItem();
        var itemElement = this.gridObj.getRowByIndex(item);
        if (fItem) {
            fItem.removeAttribute("tabindex");
            (0, $4ZDHT.removeClass)([
                fItem
            ], [
                $15a2a1ec4804cfd7$export$82de3c1c31c751e2,
                $15a2a1ec4804cfd7$export$f5d61d2df1985dc7
            ]);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(itemElement)) {
            this.gridObj.element.setAttribute("tabindex", "-1");
            itemElement.setAttribute("tabindex", "0");
            itemElement.focus();
            (0, $4ZDHT.addClass)([
                itemElement
            ], [
                $15a2a1ec4804cfd7$export$82de3c1c31c751e2,
                $15a2a1ec4804cfd7$export$f5d61d2df1985dc7
            ]);
        }
    };
    DetailsView.prototype.addHeaderFocus = function(e) {
        var treeFocus = (0, $4ZDHT.select)(".e-row", this.element);
        this.gridObj.element.setAttribute("tabindex", "-1");
        var nameFocus;
        if (!(0, $3EnZW.isNullOrUndefined)(e.target) && e.target.classList.contains("e-defaultcursor")) {
            this.addFocus(0);
            nameFocus = e.target.nextElementSibling;
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.gridObj.element.querySelector(".e-focus")) && this.gridObj.element.querySelector(".e-focus").tagName === "TH") {
            nameFocus = this.gridObj.element.querySelector(".e-focus").nextElementSibling;
            this.addFocus(0);
        } else nameFocus = (0, $4ZDHT.select)("th.e-fe-grid-icon", this.element);
        if (!(0, $3EnZW.isNullOrUndefined)(nameFocus)) {
            nameFocus.setAttribute("tabindex", "0");
            nameFocus.focus();
            (0, $4ZDHT.addClass)([
                nameFocus
            ], [
                $15a2a1ec4804cfd7$export$82de3c1c31c751e2,
                $15a2a1ec4804cfd7$export$f5d61d2df1985dc7
            ]);
            treeFocus.setAttribute("tabindex", "0");
            if (treeFocus.tabIndex === 0 && nameFocus.tabIndex === 0) (0, $4ZDHT.removeClass)([
                treeFocus
            ], [
                $15a2a1ec4804cfd7$export$82de3c1c31c751e2,
                $15a2a1ec4804cfd7$export$f5d61d2df1985dc7
            ]);
        }
    };
    DetailsView.prototype.getFocusedItem = function() {
        return (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$f5d61d2df1985dc7, this.element);
    };
    DetailsView.prototype.isSelected = function(selRowIndexes, focIndex) {
        var check = false;
        for(var i = 0; i <= selRowIndexes.length - 1; i++)if (selRowIndexes[i] === focIndex) {
            check = true;
            break;
        }
        return check;
    };
    DetailsView.prototype.shiftSelectedItem = function(selIndex, selRowIndexes, gridItems, e) {
        if (selIndex === -1) this.gridObj.selectRow(0);
        else {
            if ((0, $3EnZW.isNullOrUndefined)(this.startIndex) && e.shiftKey) {
                this.startIndex = this.gridObj.selectedRowIndex;
                this.gridObj.selectRows([
                    selIndex,
                    e.action === "shiftDown" || e.action === "csDown" ? selIndex + (selIndex !== gridItems.length - 1 ? 1 : 0) : selIndex - (selIndex !== 0 ? 1 : 0)
                ]);
            } else if (e.action === "shiftDown" || e.action === "shiftUp") {
                if (e.action === "shiftDown" && selRowIndexes.indexOf(selIndex + 1) === -1) {
                    if (selIndex !== gridItems.length - 1) selRowIndexes.push(selIndex + 1);
                } else if (e.action === "shiftUp" && selRowIndexes.indexOf(selIndex - 1) === -1) {
                    if (selIndex !== 0) selRowIndexes.push(selIndex - 1);
                } else selRowIndexes.pop();
                this.gridObj.selectRows(selRowIndexes);
            } else {
                if (e.action === "csDown") {
                    if (!this.isSelected(selRowIndexes, this.getFocusedItemIndex() + 1)) {
                        selRowIndexes.push(this.getFocusedItemIndex() + 1);
                        this.gridObj.selectRows(selRowIndexes);
                    } else this.addFocus(this.getFocusedItemIndex() + 1);
                } else if (!this.isSelected(selRowIndexes, this.getFocusedItemIndex() - 1)) {
                    selRowIndexes.push(this.getFocusedItemIndex() - 1);
                    this.gridObj.selectRows(selRowIndexes);
                } else this.addFocus(this.getFocusedItemIndex() - 1);
            }
        }
    };
    DetailsView.prototype.onMethodCall = function(e) {
        if (this.parent.view !== "Details") return;
        var action = (0, $3EnZW.getValue)("action", e);
        switch(action){
            case "deleteFiles":
                this.deleteFiles((0, $3EnZW.getValue)("ids", e));
                break;
            case "downloadFiles":
                this.downloadFiles((0, $3EnZW.getValue)("ids", e));
                break;
            case "openFile":
                this.openFile((0, $3EnZW.getValue)("id", e));
                break;
            case "createFolder":
                this.interaction = false;
                break;
            case "renameFile":
                this.interaction = false;
                this.renameFile((0, $3EnZW.getValue)("id", e), (0, $3EnZW.getValue)("newName", e));
                break;
            case "selectAll":
                this.interaction = false;
                this.onSelectAllInit();
                break;
            case "clearSelection":
                this.interaction = false;
                this.onClearAllInit();
                break;
        }
    };
    DetailsView.prototype.getRecords = function(nodes) {
        var gridRecords = this.gridObj.getCurrentViewRecords();
        var records = [];
        var hasFilter = this.parent.breadcrumbbarModule.searchObj.element.value !== "" || this.parent.isFiltered ? true : false;
        var filter = this.parent.hasId ? "id" : "name";
        if (this.parent.hasId || !hasFilter) {
            for(var i = 0, len = gridRecords.length; i < len; i++)if (nodes.indexOf((0, $3EnZW.getValue)(filter, gridRecords[i])) !== -1) records.push(gridRecords[i]);
        } else for(var i = 0, len = gridRecords.length; i < len; i++){
            var name_4 = (0, $3EnZW.getValue)("filterPath", gridRecords[i]) + (0, $3EnZW.getValue)("name", gridRecords[i]);
            if (nodes.indexOf(name_4) !== -1) records.push(gridRecords[i]);
        }
        return records;
    };
    DetailsView.prototype.deleteFiles = function(ids) {
        this.parent.activeModule = "detailsview";
        if ((0, $3EnZW.isNullOrUndefined)(ids)) {
            this.performDelete();
            return;
        }
        var records = this.getRecords(ids);
        if (records.length === 0) return;
        var data = [];
        var newIds = [];
        for(var i = 0; i < records.length; i++){
            data[i] = records[i];
            newIds[i] = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, data[i]);
        }
        (0, $a3d9eadd9d99207c$export$c0b03dfe5656b20c)(this.parent, data, newIds);
    };
    DetailsView.prototype.downloadFiles = function(ids) {
        if ((0, $3EnZW.isNullOrUndefined)(ids)) {
            this.doDownload();
            return;
        }
        var dRecords = this.getRecords(ids);
        if (dRecords.length === 0) return;
        var data = [];
        var newIds = [];
        for(var i = 0; i < dRecords.length; i++){
            data[i] = dRecords[i];
            newIds[i] = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, data[i]);
        }
        (0, $a3d9eadd9d99207c$export$5ff022e5f248fa5e)(this.parent, data, newIds);
    };
    DetailsView.prototype.openFile = function(id) {
        if ((0, $3EnZW.isNullOrUndefined)(id)) return;
        var records = this.getRecords([
            id
        ]);
        if (records.length > 0) this.openContent(records[0]);
    };
    DetailsView.prototype.renameFile = function(id, name) {
        this.parent.activeModule = "detailsview";
        if ((0, $3EnZW.isNullOrUndefined)(id)) {
            this.performRename();
            return;
        }
        var records = this.getRecords([
            id
        ]);
        if (records.length > 0) {
            (0, $a3d9eadd9d99207c$export$f3fb02da958b835d)(this.parent, records[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(name)) {
                if ((0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(this.parent.itemData[0])) (0, $5703c0df24e3a120$export$7ac989ec0c9c279)(this.parent, this.parent.path, name);
                else (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, this.parent.itemData[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
            } else (0, $a3d9eadd9d99207c$export$d52c45268ea880af)(this.parent);
        }
    };
    return DetailsView;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $e7i2H = parcelRequire("e7i2H");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $c2qqN = parcelRequire("c2qqN");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $3P3ke = parcelRequire("3P3ke");
var $7bada17cf2b24fe1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7bada17cf2b24fe1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7bada17cf2b24fe1$var$ROOT = "e-splitter";
var $7bada17cf2b24fe1$var$HORIZONTAL_PANE = "e-splitter-horizontal";
var $7bada17cf2b24fe1$var$VERTICAL_PANE = "e-splitter-vertical";
var $7bada17cf2b24fe1$var$PANE = "e-pane";
var $7bada17cf2b24fe1$var$SPLIT_H_PANE = "e-pane-horizontal";
var $7bada17cf2b24fe1$var$SPLIT_V_PANE = "e-pane-vertical";
var $7bada17cf2b24fe1$var$SPLIT_BAR = "e-split-bar";
var $7bada17cf2b24fe1$var$SPLIT_H_BAR = "e-split-bar-horizontal";
var $7bada17cf2b24fe1$var$SPLIT_V_BAR = "e-split-bar-vertical";
var $7bada17cf2b24fe1$var$STATIC_PANE = "e-static-pane";
var $7bada17cf2b24fe1$var$SCROLL_PANE = "e-scrollable";
var $7bada17cf2b24fe1$var$RESIZE_BAR = "e-resize-handler";
var $7bada17cf2b24fe1$var$RESIZABLE_BAR = "e-resizable-split-bar";
var $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER = "e-split-bar-hover";
var $7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE = "e-split-bar-active";
var $7bada17cf2b24fe1$var$HIDE_HANDLER = "e-hide-handler";
var $7bada17cf2b24fe1$var$SPLIT_TOUCH = "e-splitter-touch";
var $7bada17cf2b24fe1$var$DISABLED = "e-disabled";
var $7bada17cf2b24fe1$var$RTL = "e-rtl";
var $7bada17cf2b24fe1$var$E_ICONS = "e-icons";
var $7bada17cf2b24fe1$var$COLLAPSIBLE = "e-collapsible";
var $7bada17cf2b24fe1$var$NAVIGATE_ARROW = "e-navigate-arrow";
var $7bada17cf2b24fe1$var$ARROW_RIGHT = "e-arrow-right";
var $7bada17cf2b24fe1$var$ARROW_LEFT = "e-arrow-left";
var $7bada17cf2b24fe1$var$ARROW_UP = "e-arrow-up";
var $7bada17cf2b24fe1$var$ARROW_DOWN = "e-arrow-down";
var $7bada17cf2b24fe1$var$HIDE_ICON = "e-icon-hidden";
var $7bada17cf2b24fe1$var$EXPAND_PANE = "e-expanded";
var $7bada17cf2b24fe1$var$COLLAPSE_PANE = "e-collapsed";
var $7bada17cf2b24fe1$var$PANE_HIDDEN = "e-pane-hidden";
var $7bada17cf2b24fe1$var$RESIZABLE_PANE = "e-resizable";
var $7bada17cf2b24fe1$var$LAST_BAR = "e-last-bar";
var $7bada17cf2b24fe1$var$BAR_SIZE_DEFAULT = 1;
/**
 * Interface to configure pane properties such as its content, size, min, max, resizable, collapsed and collapsible.
 */ var $7bada17cf2b24fe1$export$a84d73855da1a171 = /** @class */ function(_super) {
    $7bada17cf2b24fe1$var$__extends(PaneProperties, _super);
    function PaneProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)()
    ], PaneProperties.prototype, "size", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PaneProperties.prototype, "collapsible", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PaneProperties.prototype, "collapsed", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], PaneProperties.prototype, "resizable", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PaneProperties.prototype, "min", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PaneProperties.prototype, "max", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)()
    ], PaneProperties.prototype, "content", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], PaneProperties.prototype, "cssClass", void 0);
    return PaneProperties;
}((0, $3fcxu.ChildProperty));
/**
 * Splitter is a layout user interface (UI) control that has resizable and collapsible split panes.
 * The container can be split into multiple panes, which are oriented horizontally or vertically.
 * The separator (divider) splits the panes and resizes and expands/collapses the panes.
 * The splitter is placed inside the split pane to make a nested layout user interface.
 *
 * ```html
 * <div id="splitter">
 *  <div> Left Pane </div>
 *  <div> Center Pane </div>
 *  <div> Right Pane </div>
 * </div>
 * ```
 * ```typescript
 * <script>
 *   var splitterObj = new Splitter({ width: '300px', height: '200px'});
 *   splitterObj.appendTo('#splitter');
 * </script>
 * ```
 */ var $7bada17cf2b24fe1$export$980082fdfafd21f8 = /** @class */ function(_super) {
    $7bada17cf2b24fe1$var$__extends(Splitter, _super);
    /**
     * Initializes a new instance of the Splitter class.
     *
     * @param options  - Specifies Splitter model properties as options.
     * @param element  - Specifies the element that is rendered as an Splitter.
     */ function Splitter(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.needsID = true;
        return _this;
    }
    /**
     * Gets called when the model property changes.The data that describes the old and new values of the property that changed.
     *
     * @param  {SplitterModel} newProp - specifies the new property
     * @param  {SplitterModel} oldProp - specifies the old property
     * @returns {void}
     * @private
     */ Splitter.prototype.onPropertyChanged = function(newProp, oldProp) {
        if (!this.element.classList.contains($7bada17cf2b24fe1$var$ROOT)) return;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "height":
                    this.setSplitterSize(this.element, newProp.height, "height");
                    break;
                case "width":
                    this.setSplitterSize(this.element, newProp.width, "width");
                    break;
                case "cssClass":
                    this.setCssClass(this.element, newProp.cssClass);
                    break;
                case "enabled":
                    this.isEnabled(this.enabled);
                    break;
                case "enableReversePanes":
                    this.setReversePane();
                    break;
                case "separatorSize":
                    this.setSeparatorSize(newProp.separatorSize);
                    break;
                case "orientation":
                    this.changeOrientation(newProp.orientation);
                    break;
                case "paneSettings":
                    if (!(newProp.paneSettings instanceof Array && oldProp.paneSettings instanceof Array)) {
                        var paneCounts = Object.keys(newProp.paneSettings);
                        var isPaneContentChanged = paneCounts.some(function(count) {
                            return !(0, $3EnZW.isNullOrUndefined)(newProp.paneSettings[count].content);
                        });
                        if (this.isReact && isPaneContentChanged) {
                            var cPaneCount = 0;
                            for(var k = 0; k < this.paneSettings.length; k++)if (typeof this.paneSettings[k].content === "function") cPaneCount = cPaneCount + 1;
                            var hasAllContent = cPaneCount === this.paneSettings.length;
                            if (hasAllContent) this.clearTemplate();
                        }
                        for(var i = 0; i < paneCounts.length; i++){
                            var index = parseInt(Object.keys(newProp.paneSettings)[i], 10);
                            var changedPropsCount = Object.keys(newProp.paneSettings[index]).length;
                            for(var j = 0; j < changedPropsCount; j++){
                                var property = Object.keys(newProp.paneSettings[index])[j];
                                switch(property){
                                    case "content":
                                        var newValue = Object(newProp.paneSettings[index])["" + property];
                                        if (!(0, $3EnZW.isNullOrUndefined)(newValue)) {
                                            this.allPanes[index].innerHTML = "";
                                            this.setTemplate(newValue, this.allPanes[index]);
                                        }
                                        break;
                                    case "resizable":
                                        var newVal = Object(newProp.paneSettings[index])["" + property];
                                        this.resizableModel(index, newVal);
                                        break;
                                    case "collapsible":
                                        this.collapsibleModelUpdate(index);
                                        break;
                                    case "collapsed":
                                        if (newProp.paneSettings[index].collapsed) this.isCollapsed(index);
                                        else this.collapsedOnchange(index);
                                        break;
                                    case "cssClass":
                                        this.setCssClass(this.allPanes[index], newProp.paneSettings[index].cssClass);
                                        break;
                                    case "size":
                                        var newValSize = Object(newProp.paneSettings[index])["" + property];
                                        if (newValSize !== "" && !(0, $3EnZW.isNullOrUndefined)(newValSize)) this.updatePaneSize(newValSize, index);
                                        break;
                                }
                            }
                        }
                    } else {
                        this.clearTemplate();
                        this.destroyPaneSettings();
                        this.allBars = [];
                        this.allPanes = [];
                        this.createSplitPane(this.element);
                        this.addSeparator(this.element);
                        this.getPanesDimensions();
                        this.setRTL(this.enableRtl);
                        this.isCollapsed();
                    }
                    break;
                case "enableRtl":
                    this.setRTL(newProp.enableRtl);
                    break;
            }
        }
    };
    Splitter.prototype.updatePaneSize = function(newValSize, index) {
        this.allPanes[index].style.flexBasis = newValSize;
        var flexPaneIndexes = [];
        var staticPaneWidth;
        var flexCount = 0;
        for(var i = 0; i < this.allPanes.length; i++){
            if (!this.paneSettings[i].size && !(this.allPanes[i].innerText === "")) {
                flexPaneIndexes[flexCount] = i;
                flexCount++;
            } else if (this.paneSettings[i].size) staticPaneWidth = this.orientation === "Horizontal" ? this.allPanes[index].offsetWidth : this.allPanes[index].offsetHeight;
        }
        staticPaneWidth = this.orientation === "Horizontal" ? this.allBars[0].offsetWidth * this.allBars.length + staticPaneWidth : this.allBars[0].offsetHeight * this.allBars.length + staticPaneWidth;
        var flexPaneWidth = (this.orientation === "Horizontal" ? this.element.offsetWidth : this.element.offsetHeight) - staticPaneWidth - this.border * 2;
        var avgDiffWidth = flexPaneWidth / flexPaneIndexes.length;
        for(var j = 0; j < flexPaneIndexes.length; j++)if (this.allPanes[flexPaneIndexes[j]].style.flexBasis !== "") this.allPanes[flexPaneIndexes[j]].style.flexBasis = avgDiffWidth + "px";
        this.allPanes[index].classList.add($7bada17cf2b24fe1$var$STATIC_PANE);
    };
    Splitter.prototype.initializeValues = function() {
        this.allPanes = [];
        this.paneOrder = [];
        this.separatorOrder = [];
        this.allBars = [];
        this.previousCoordinates = {};
        this.currentCoordinates = {};
        this.updatePrePaneInPercentage = false;
        this.updateNextPaneInPercentage = false;
        this.panesDimensions = [];
        this.border = 0;
        this.validDataAttributes = [
            "data-size",
            "data-min",
            "data-max",
            "data-collapsible",
            "data-resizable",
            "data-content",
            "data-collapsed"
        ];
        this.validElementAttributes = [
            "data-orientation",
            "data-width",
            "data-height"
        ];
        this.iconsDelay = 300;
        this.templateElement = [];
        this.collapseFlag = false;
        this.expandFlag = true;
    };
    Splitter.prototype.preRender = function() {
        this.initializeValues();
        this.onReportWindowSize = this.reportWindowSize.bind(this);
        this.onMouseMoveHandler = this.onMouseMove.bind(this);
        this.onMouseUpHandler = this.onMouseUp.bind(this);
        this.onTouchMoveHandler = this.onMouseMove.bind(this);
        this.onTouchEndHandler = this.onMouseUp.bind(this);
        this.wrapper = this.element.cloneNode(true);
        this.wrapperParent = this.element.parentElement;
        (0, $4ZDHT.removeClass)([
            this.wrapper
        ], [
            "e-control",
            "e-lib",
            $7bada17cf2b24fe1$var$ROOT
        ]);
        var orientation = this.orientation === "Horizontal" ? $7bada17cf2b24fe1$var$HORIZONTAL_PANE : $7bada17cf2b24fe1$var$VERTICAL_PANE;
        (0, $4ZDHT.addClass)([
            this.element
        ], orientation);
        var name = (0, $5q7BP.Browser).info.name;
        var css = name === "msie" ? "e-ie" : "";
        this.setCssClass(this.element, css);
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.addClass)([
            this.element
        ], $7bada17cf2b24fe1$var$SPLIT_TOUCH);
    };
    Splitter.prototype.getPersistData = function() {
        return this.addOnPersist([
            "paneSettings"
        ]);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - returns the string value
     * @private
     */ Splitter.prototype.getModuleName = function() {
        return "splitter";
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Splitter.prototype.render = function() {
        this.checkDataAttributes();
        this.setCssClass(this.element, this.cssClass);
        this.isEnabled(this.enabled);
        this.setDimension(this.getHeight(this.element), this.getWidth(this.element));
        this.createSplitPane(this.element);
        this.addSeparator(this.element);
        this.getPanesDimensions();
        this.setPaneSettings();
        this.setRTL(this.enableRtl);
        if (this.enableReversePanes) this.setReversePane();
        this.collapseFlag = true;
        this.isCollapsed();
        this.collapseFlag = false;
        (0, $aqzbR.EventHandler).add(document, "touchstart click", this.onDocumentClick, this);
        this.renderComplete();
        this.element.ownerDocument.defaultView.addEventListener("resize", this.onReportWindowSize, true);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.onMove, this);
    };
    Splitter.prototype.onDocumentClick = function(e) {
        if (!e.target.classList.contains($7bada17cf2b24fe1$var$SPLIT_BAR) && !(0, $3EnZW.isNullOrUndefined)(this.currentSeparator)) {
            this.currentSeparator.classList.remove($7bada17cf2b24fe1$var$SPLIT_BAR_HOVER);
            this.currentSeparator.classList.remove($7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
        }
    };
    Splitter.prototype.checkPaneSize = function(e) {
        var prePaneSize = this.orientation === "Horizontal" ? this.previousPane.offsetWidth : this.previousPane.offsetHeight;
        var nextPaneSize = this.orientation === "Horizontal" ? this.nextPane.offsetWidth : this.nextPane.offsetHeight;
        var splitBarSize = (0, $3EnZW.isNullOrUndefined)(this.separatorSize) ? $7bada17cf2b24fe1$var$BAR_SIZE_DEFAULT : this.separatorSize;
        if (this.previousPane.style.flexBasis.indexOf("%") > 0 || this.previousPane.style.flexBasis.indexOf("p") > 0 || this.nextPane.style.flexBasis.indexOf("%") > 0) {
            var previousFlexBasis = this.updatePaneFlexBasis(this.previousPane);
            var nextFlexBasis = this.updatePaneFlexBasis(this.nextPane);
            this.totalPercent = previousFlexBasis + nextFlexBasis;
            this.totalWidth = this.convertPercentageToPixel(this.totalPercent + "%");
            if (e.type === "keydown" && !(0, $3EnZW.isNullOrUndefined)(e.keyCode)) {
                if ((e.keyCode === 39 || e.keyCode === 40) && nextPaneSize > 0 && this.getMinInPixel(this.paneSettings[this.nextPaneIndex].min) < this.convertPercentageToPixel(nextFlexBasis - 1 + "%")) {
                    this.previousPane.style.flexBasis = previousFlexBasis + 1 + "%";
                    this.nextPane.style.flexBasis = nextFlexBasis - 1 + "%";
                } else if ((e.keyCode === 37 || e.keyCode === 38) && prePaneSize > 0 && this.getMinInPixel(this.paneSettings[this.prevPaneIndex].min) < this.convertPercentageToPixel(previousFlexBasis - 1 + "%")) {
                    this.previousPane.style.flexBasis = previousFlexBasis - 1 + "%";
                    this.nextPane.style.flexBasis = nextFlexBasis + 1 + "%";
                }
            }
        } else {
            this.totalWidth = this.orientation === "Horizontal" ? this.previousPane.offsetWidth + this.nextPane.offsetWidth : this.previousPane.offsetHeight + this.nextPane.offsetHeight;
            if (e.type === "keydown" && !(0, $3EnZW.isNullOrUndefined)(e.keyCode)) {
                if ((e.keyCode === 39 || e.keyCode === 40) && nextPaneSize > 0 && this.getMinInPixel(this.paneSettings[this.nextPaneIndex].min) < nextPaneSize + splitBarSize) {
                    this.addStaticPaneClass();
                    this.previousPane.style.flexBasis = prePaneSize + splitBarSize + "px";
                    this.nextPane.style.flexBasis = nextPaneSize < splitBarSize ? "0px" : nextPaneSize - splitBarSize + "px";
                } else if ((e.keyCode === 37 || e.keyCode === 38) && prePaneSize > 0 && this.getMinInPixel(this.paneSettings[this.prevPaneIndex].min) < prePaneSize - splitBarSize) {
                    this.addStaticPaneClass();
                    this.previousPane.style.flexBasis = prePaneSize < splitBarSize ? "0px" : prePaneSize - splitBarSize + "px";
                    this.nextPane.style.flexBasis = nextPaneSize + splitBarSize + "px";
                }
            }
        }
    };
    Splitter.prototype.onMove = function(event) {
        if (this.allPanes.length > 1) {
            var index = this.getSeparatorIndex(this.currentSeparator);
            var isPrevpaneCollapsed = this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE);
            var isPrevpaneExpanded = this.previousPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE);
            var isNextpaneCollapsed = this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE);
            if ((this.orientation !== "Horizontal" && event.keyCode === 38 || this.orientation === "Horizontal" && event.keyCode === 39 || this.orientation === "Horizontal" && event.keyCode === 37 || this.orientation !== "Horizontal" && event.keyCode === 40) && (!isPrevpaneExpanded && !isNextpaneCollapsed && !isPrevpaneCollapsed || isPrevpaneExpanded && !isNextpaneCollapsed) && document.activeElement.classList.contains($7bada17cf2b24fe1$var$SPLIT_BAR) && this.paneSettings[index].resizable && this.paneSettings[index + 1].resizable) {
                event.preventDefault();
                this.checkPaneSize(event);
                this.triggerResizing(event);
            } else if (event.keyCode === 13 && this.paneSettings[index].collapsible && document.activeElement.classList.contains($7bada17cf2b24fe1$var$SPLIT_BAR) && this.currentSeparator.classList.contains($7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE)) {
                if (!this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                    this.collapse(index);
                    (0, $4ZDHT.addClass)([
                        this.currentSeparator
                    ], $7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
                } else {
                    this.expand(index);
                    (0, $4ZDHT.addClass)([
                        this.currentSeparator
                    ], $7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
                }
            }
        }
    };
    Splitter.prototype.getMinInPixel = function(minValue) {
        if ((0, $3EnZW.isNullOrUndefined)(minValue)) return 0;
        var paneMinRange = this.convertPixelToNumber(minValue.toString());
        if (minValue.indexOf("%") > 0) paneMinRange = this.convertPercentageToPixel(minValue);
        var min = this.convertPixelToNumber(paneMinRange.toString());
        return min;
    };
    /**
     * @param {string} value - specifies the string value
     * @returns {string} returns the string
     * @hidden
     */ Splitter.prototype.sanitizeHelper = function(value) {
        if (this.enableHtmlSanitizer) {
            var item = (0, $3P3ke.SanitizeHtmlHelper).beforeSanitize();
            var beforeEvent = {
                cancel: false,
                helper: null
            };
            (0, $3EnZW.extend)(item, item, beforeEvent);
            this.trigger("beforeSanitizeHtml", item);
            if (item.cancel && !(0, $3EnZW.isNullOrUndefined)(item.helper)) value = item.helper(value);
            else if (!item.cancel) value = (0, $3P3ke.SanitizeHtmlHelper).serializeValue(item, value);
        }
        return value;
    };
    Splitter.prototype.checkDataAttributes = function() {
        var api;
        var value;
        // Element values
        for(var dataIndex = 0; dataIndex < this.validElementAttributes.length; dataIndex++){
            value = this.element.getAttribute(this.validElementAttributes[dataIndex]);
            if (!(0, $3EnZW.isNullOrUndefined)(value)) {
                api = this.removeDataPrefix(this.validElementAttributes[dataIndex]);
                // eslint-disable-next-line
                this[api] = value;
            }
        }
        // Pane values
        for(var paneIndex = 0; paneIndex < this.element.children.length; paneIndex++)for(var dataAttr = 0; dataAttr < this.validDataAttributes.length; dataAttr++){
            value = this.element.children[paneIndex].getAttribute(this.validDataAttributes[dataAttr]);
            if (!(0, $3EnZW.isNullOrUndefined)(value)) {
                api = this.removeDataPrefix(this.validDataAttributes[dataAttr]);
                value = api === "collapsible" || api === "resizable" ? value === "true" : value;
                if ((0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex])) this.paneSettings[paneIndex] = {
                    size: "",
                    min: null,
                    max: null,
                    content: "",
                    resizable: true,
                    collapsible: false,
                    collapsed: false
                };
                // eslint-disable-next-line
                var paneAPI = this.paneSettings[paneIndex][api];
                if (api === "resizable" || api === "collapsible" || api === "collapsed") // eslint-disable-next-line
                this.paneSettings[paneIndex][api] = value;
                if ((0, $3EnZW.isNullOrUndefined)(paneAPI) || paneAPI === "") // eslint-disable-next-line
                this.paneSettings[paneIndex][api] = value;
            }
        }
    };
    Splitter.prototype.destroyPaneSettings = function() {
        [].slice.call(this.element.children).forEach(function(el) {
            (0, $4ZDHT.detach)(el);
        });
        this.restoreElem();
    };
    Splitter.prototype.setPaneSettings = function() {
        var childCount = this.allPanes.length;
        var paneCollection = [];
        var paneValue = {
            size: "",
            min: null,
            max: null,
            content: "",
            resizable: true,
            collapsed: false,
            collapsible: false,
            cssClass: ""
        };
        for(var i = 0; i < childCount; i++)if ((0, $3EnZW.isNullOrUndefined)(this.paneSettings[i])) paneCollection[i] = paneValue;
        else paneCollection[i] = this.paneSettings[i];
        this.setProperties({
            "paneSettings": paneCollection
        }, true);
    };
    Splitter.prototype.checkArrow = function(paneIndex, targetArrow) {
        return this.allBars[paneIndex].querySelector("." + $7bada17cf2b24fe1$var$NAVIGATE_ARROW + "." + targetArrow);
    };
    Splitter.prototype.removeDataPrefix = function(attribute) {
        return attribute.slice(attribute.lastIndexOf("-") + 1);
    };
    Splitter.prototype.setRTL = function(rtl) {
        if (rtl) (0, $4ZDHT.addClass)([
            this.element
        ], $7bada17cf2b24fe1$var$RTL);
        else (0, $4ZDHT.removeClass)([
            this.element
        ], $7bada17cf2b24fe1$var$RTL);
    };
    Splitter.prototype.setReversePane = function() {
        this.allPanes = this.allPanes.reverse();
        this.allBars = this.allBars.reverse();
        (0, $4ZDHT.addClass)([
            this.allBars[this.allBars.length - 1]
        ], $7bada17cf2b24fe1$var$LAST_BAR);
        (0, $4ZDHT.removeClass)([
            this.allBars[0]
        ], $7bada17cf2b24fe1$var$LAST_BAR);
        this.setProperties({
            "paneSettings": this.paneSettings.reverse()
        }, true);
        if (this.enableReversePanes) this.element.setAttribute("dir", "rtl");
        else this.element.removeAttribute("dir");
    };
    Splitter.prototype.setSplitterSize = function(element, size, property) {
        var style = property === "width" ? {
            "width": (0, $3EnZW.formatUnit)(size)
        } : {
            "height": (0, $3EnZW.formatUnit)(size)
        };
        (0, $4ZDHT.setStyleAttribute)(element, style);
    };
    Splitter.prototype.getPanesDimensions = function() {
        for(var index = 0; index < this.allPanes.length; index++)if (this.orientation === "Horizontal") this.panesDimensions.push(this.allPanes[index].getBoundingClientRect().width);
        else this.panesDimensions.push(this.allPanes[index].getBoundingClientRect().height);
    };
    Splitter.prototype.setCssClass = function(element, className) {
        if (className) (0, $4ZDHT.addClass)([
            element
        ], className.split(className.indexOf(",") > -1 ? "," : " "));
    };
    Splitter.prototype.hideResizer = function(target) {
        (0, $4ZDHT.addClass)([
            (0, $4ZDHT.select)("." + $7bada17cf2b24fe1$var$RESIZE_BAR, target)
        ], $7bada17cf2b24fe1$var$HIDE_HANDLER);
    };
    Splitter.prototype.showResizer = function(target) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.previousPane) && this.previousPane.classList.contains($7bada17cf2b24fe1$var$RESIZABLE_PANE) && !(0, $3EnZW.isNullOrUndefined)(this.nextPane) && this.nextPane.classList.contains($7bada17cf2b24fe1$var$RESIZABLE_PANE)) (0, $4ZDHT.removeClass)([
            (0, $4ZDHT.select)("." + $7bada17cf2b24fe1$var$RESIZE_BAR, target)
        ], $7bada17cf2b24fe1$var$HIDE_HANDLER);
    };
    Splitter.prototype.resizableModel = function(index, newVal) {
        var paneIndex = index === this.allBars.length ? index - 1 : index;
        var i = index;
        (0, $aqzbR.EventHandler).remove(this.allBars[paneIndex], "mousedown", this.onMouseDown);
        if (newVal) {
            (0, $aqzbR.EventHandler).add(this.allBars[paneIndex], "mousedown", this.onMouseDown, this);
            if (this.isResizable()) {
                this.showResizer(this.allBars[paneIndex]);
                (0, $4ZDHT.removeClass)([
                    (0, $4ZDHT.select)("." + $7bada17cf2b24fe1$var$RESIZE_BAR, this.allBars[paneIndex])
                ], $7bada17cf2b24fe1$var$HIDE_HANDLER);
                this.allBars[paneIndex].classList.add($7bada17cf2b24fe1$var$RESIZABLE_BAR);
                if (index === this.allBars.length) this.allPanes[index].classList.add($7bada17cf2b24fe1$var$RESIZABLE_PANE);
                else this.allPanes[paneIndex].classList.add($7bada17cf2b24fe1$var$RESIZABLE_PANE);
                this.updateResizablePanes(i);
            }
        } else {
            this.updateResizablePanes(i);
            this.hideResizer(this.allBars[paneIndex]);
            this.allBars[paneIndex].classList.remove($7bada17cf2b24fe1$var$RESIZABLE_BAR);
            if (index === this.allBars.length) this.allPanes[index].classList.remove($7bada17cf2b24fe1$var$RESIZABLE_PANE);
            else this.allPanes[paneIndex].classList.remove($7bada17cf2b24fe1$var$RESIZABLE_PANE);
        }
    };
    Splitter.prototype.collapsibleModelUpdate = function(index) {
        var paneIndex = index === this.allBars.length ? index - 1 : index;
        var arrow2 = this.orientation === "Horizontal" ? this.checkArrow(paneIndex, $7bada17cf2b24fe1$var$ARROW_LEFT) : this.checkArrow(paneIndex, $7bada17cf2b24fe1$var$ARROW_UP);
        var arrow1 = this.orientation === "Horizontal" ? this.checkArrow(paneIndex, $7bada17cf2b24fe1$var$ARROW_RIGHT) : this.checkArrow(paneIndex, $7bada17cf2b24fe1$var$ARROW_DOWN);
        this.paneCollapsible(this.allPanes[index], index);
        this.updateCollapseIcons(paneIndex, arrow1, arrow2);
    };
    Splitter.prototype.collapseArrow = function(barIndex, arrow) {
        return (0, $4ZDHT.selectAll)("." + arrow, this.allBars[barIndex])[0];
    };
    Splitter.prototype.updateIsCollapsed = function(index, collapseArrow, lastBarArrow) {
        if (!(0, $3EnZW.isNullOrUndefined)(index)) {
            var targetEle = void 0;
            var lastBarIndex = index === this.allBars.length;
            var barIndex = lastBarIndex ? index - 1 : index;
            if (!lastBarIndex && this.allPanes[index + 1].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && index !== 0) targetEle = this.collapseArrow(barIndex - 1, lastBarArrow);
            else targetEle = lastBarIndex ? this.collapseArrow(barIndex, lastBarArrow) : this.collapseArrow(barIndex, collapseArrow);
            targetEle.click();
        }
    };
    Splitter.prototype.isCollapsed = function(index) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(index) && this.paneSettings[index].collapsed && (0, $3EnZW.isNullOrUndefined)(this.allPanes[index].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE))) return;
        this.expandFlag = false;
        if (!(0, $3EnZW.isNullOrUndefined)(index)) {
            this.collapseFlag = true;
            var targetEle = void 0;
            var lastBarIndex = index === this.allBars.length;
            var barIndex = lastBarIndex ? index - 1 : index;
            if (!lastBarIndex && this.allPanes[index + 1].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && index !== 0) targetEle = this.collapseArrow(barIndex - 1, this.targetArrows().lastBarArrow);
            else targetEle = lastBarIndex ? this.collapseArrow(barIndex, this.targetArrows().lastBarArrow) : this.collapseArrow(barIndex, this.targetArrows().collapseArrow);
            var event_1 = {
                target: targetEle
            };
            var eventArgs = this.beforeAction(event_1);
            this.trigger("beforeCollapse", eventArgs, function(beforeCollapseArgs) {
                if (!beforeCollapseArgs.cancel) {
                    var collapsedindex = [];
                    collapsedindex[0] = index;
                    var j = 1;
                    for(var i = 0; i < _this.allPanes.length; i++)if (_this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                        collapsedindex[j] = i;
                        j++;
                    }
                    collapsedindex = collapsedindex.sort();
                    _this.updateIsCollapsed(index, _this.targetArrows().collapseArrow, _this.targetArrows().lastBarArrow);
                    for(var i = 0; i < collapsedindex.length; i++)if (!_this.allPanes[collapsedindex[i]].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) _this.updateIsCollapsed(collapsedindex[i], _this.targetArrows().collapseArrow, _this.targetArrows().lastBarArrow);
                    for(var i = collapsedindex.length; i > 0; i--)if (!_this.allPanes[collapsedindex[i - 1]].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                        var targetArrow = _this.targetArrows();
                        _this.updateIsCollapsed(collapsedindex[i - 1], targetArrow.collapseArrow, targetArrow.lastBarArrow);
                    }
                    var collapseEventArgs = _this.afterAction(event_1);
                    _this.trigger("collapsed", collapseEventArgs);
                    _this.collapseFlag = false;
                }
            });
        } else {
            for(var m = 0; m < this.allPanes.length; m++)if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[m]) && this.paneSettings[m].collapsed) this.updateIsCollapsed(m, this.targetArrows().collapseArrow, this.targetArrows().lastBarArrow);
            for(var m = this.allPanes.length - 1; m >= 0; m--)if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[m]) && this.paneSettings[m].collapsed && !this.allPanes[m].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                var collapseArrow = this.orientation === "Horizontal" ? $7bada17cf2b24fe1$var$ARROW_RIGHT : $7bada17cf2b24fe1$var$ARROW_DOWN;
                if (m !== 0) {
                    var targetEle = this.collapseArrow(m - 1, collapseArrow);
                    targetEle.click();
                }
                if (!this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                    var targetEle = this.collapseArrow(m - 1, collapseArrow);
                    targetEle.click();
                }
            }
        }
        this.expandFlag = true;
    };
    Splitter.prototype.targetArrows = function() {
        this.splitterProperty();
        return {
            collapseArrow: this.orientation === "Horizontal" ? $7bada17cf2b24fe1$var$ARROW_LEFT : $7bada17cf2b24fe1$var$ARROW_UP,
            lastBarArrow: this.orientation === "Vertical" ? $7bada17cf2b24fe1$var$ARROW_DOWN : $7bada17cf2b24fe1$var$ARROW_RIGHT
        };
    };
    Splitter.prototype.collapsedOnchange = function(index) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index].collapsed) && this.allPanes[index].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) this.updateIsCollapsed(index, this.targetArrows().lastBarArrow, this.targetArrows().collapseArrow);
    };
    Splitter.prototype.isEnabled = function(enabled) {
        if (enabled) (0, $4ZDHT.removeClass)([
            this.element
        ], $7bada17cf2b24fe1$var$DISABLED);
        else (0, $4ZDHT.addClass)([
            this.element
        ], $7bada17cf2b24fe1$var$DISABLED);
    };
    Splitter.prototype.setSeparatorSize = function(size) {
        var sizeValue = (0, $3EnZW.isNullOrUndefined)(size) ? "auto" : size + "px";
        var separator = this.orientation === "Horizontal" ? $7bada17cf2b24fe1$var$SPLIT_H_BAR : $7bada17cf2b24fe1$var$SPLIT_V_BAR;
        for(var index = 0; index < this.allBars.length; index++){
            var splitBar = (0, $4ZDHT.selectAll)("." + separator, this.element)[index];
            var resizeBar = (0, $4ZDHT.selectAll)("." + $7bada17cf2b24fe1$var$RESIZE_BAR, splitBar)[0];
            if (this.orientation === "Horizontal") {
                splitBar.style.width = sizeValue;
                if (!(0, $3EnZW.isNullOrUndefined)(resizeBar)) resizeBar.style.width = sizeValue;
            } else {
                splitBar.style.height = sizeValue;
                if (!(0, $3EnZW.isNullOrUndefined)(resizeBar)) resizeBar.style.height = sizeValue;
            }
        }
    };
    Splitter.prototype.changeOrientation = function(orientation) {
        var isVertical = orientation === "Vertical";
        this.element.classList.remove(isVertical ? $7bada17cf2b24fe1$var$HORIZONTAL_PANE : $7bada17cf2b24fe1$var$VERTICAL_PANE);
        this.element.classList.add(isVertical ? $7bada17cf2b24fe1$var$VERTICAL_PANE : $7bada17cf2b24fe1$var$HORIZONTAL_PANE);
        for(var index = 0; index < this.allPanes.length; index++){
            this.allPanes[index].classList.remove(isVertical ? $7bada17cf2b24fe1$var$SPLIT_H_PANE : $7bada17cf2b24fe1$var$SPLIT_V_PANE);
            this.allPanes[index].classList.add(isVertical ? $7bada17cf2b24fe1$var$SPLIT_V_PANE : $7bada17cf2b24fe1$var$SPLIT_H_PANE);
        }
        for(var index = 0; index < this.allBars.length; index++)(0, $4ZDHT.detach)(this.allBars[index]);
        this.allBars = [];
        this.addSeparator(this.element);
    };
    Splitter.prototype.checkSplitPane = function(currentBar, elementIndex) {
        var paneEle = this.collectPanes(currentBar.parentElement.children)[elementIndex];
        return paneEle;
    };
    Splitter.prototype.collectPanes = function(childNodes) {
        var elements = [];
        for(var i = 0; i < childNodes.length; i++)if (childNodes[i].classList.contains($7bada17cf2b24fe1$var$PANE)) elements.push(childNodes[i]);
        return elements;
    };
    Splitter.prototype.getPrevPane = function(order) {
        return this.enableReversePanes ? this.getOrderPane(order + 1) : this.getOrderPane(order - 1);
    };
    Splitter.prototype.getNextPane = function(order) {
        return this.enableReversePanes ? this.getOrderPane(order - 1) : this.getOrderPane(order + 1);
    };
    Splitter.prototype.getOrderPane = function(order) {
        var pane;
        for(var i = 0; i < this.element.children.length; i++)if (parseInt(this.element.children[i].style.order, 10) === order) pane = this.element.children[i];
        return pane;
    };
    Splitter.prototype.getOrderIndex = function(order, type) {
        var index;
        var panes;
        if (type === "pane") panes = this.allPanes;
        else panes = this.allBars;
        for(var i = 0; i < panes.length; i++)if (parseInt(panes[i].style.order, 10) === order) index = i;
        return index;
    };
    Splitter.prototype.updateSeparatorSize = function(resizeHanlder) {
        var sizeValue = (0, $3EnZW.isNullOrUndefined)(this.separatorSize) ? "1px" : this.separatorSize + "px";
        if (this.orientation === "Horizontal") resizeHanlder.style.width = sizeValue;
        else resizeHanlder.style.height = sizeValue;
    };
    Splitter.prototype.addResizeHandler = function(currentBar) {
        var resizeHanlder = this.createElement("div");
        (0, $4ZDHT.addClass)([
            resizeHanlder
        ], [
            $7bada17cf2b24fe1$var$RESIZE_BAR,
            $7bada17cf2b24fe1$var$E_ICONS
        ]);
        this.updateSeparatorSize(resizeHanlder);
        currentBar.appendChild(resizeHanlder);
    };
    Splitter.prototype.getHeight = function(target) {
        var height = this.height;
        height = target.style.height !== "" && this.height === "100%" ? target.style.height : this.height;
        return height;
    };
    Splitter.prototype.getWidth = function(target) {
        var width = this.width;
        width = target.style.width !== "" && this.width === "100%" ? target.style.width : this.width;
        return width;
    };
    Splitter.prototype.setDimension = function(height, width) {
        (0, $4ZDHT.setStyleAttribute)(this.element, {
            "height": height,
            "width": width
        });
    };
    Splitter.prototype.updateCollapseIcons = function(index, arrow1, arrow2) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index])) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index].collapsible)) {
                if (this.paneSettings[index].collapsible) (0, $4ZDHT.removeClass)([
                    arrow2
                ], [
                    $7bada17cf2b24fe1$var$HIDE_ICON
                ]);
                else (0, $4ZDHT.addClass)([
                    arrow2
                ], [
                    $7bada17cf2b24fe1$var$HIDE_ICON
                ]);
                if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index + 1])) {
                    if (this.paneSettings[index + 1].collapsible) (0, $4ZDHT.removeClass)([
                        arrow1
                    ], [
                        $7bada17cf2b24fe1$var$HIDE_ICON
                    ]);
                    else (0, $4ZDHT.addClass)([
                        arrow1
                    ], [
                        $7bada17cf2b24fe1$var$HIDE_ICON
                    ]);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index + 1])) {
                    if (this.paneSettings[index + 1].collapsible) {
                        if (this.paneSettings[index + 1].collapsible) (0, $4ZDHT.removeClass)([
                            arrow1
                        ], [
                            $7bada17cf2b24fe1$var$HIDE_ICON
                        ]);
                        else (0, $4ZDHT.addClass)([
                            arrow1
                        ], [
                            $7bada17cf2b24fe1$var$HIDE_ICON
                        ]);
                    }
                }
            }
        }
    };
    Splitter.prototype.updateIconClass = function() {
        if (this.orientation === "Horizontal") {
            this.leftArrow = $7bada17cf2b24fe1$var$ARROW_LEFT;
            this.rightArrow = $7bada17cf2b24fe1$var$ARROW_RIGHT;
        } else {
            this.leftArrow = $7bada17cf2b24fe1$var$ARROW_UP;
            this.rightArrow = $7bada17cf2b24fe1$var$ARROW_DOWN;
        }
    };
    Splitter.prototype.createSeparator = function(i) {
        var separator = this.createElement("div");
        this.allBars.push(separator);
        var arrow1 = this.createElement("button");
        var arrow2 = this.createElement("button");
        arrow1.setAttribute("tabindex", "-1");
        arrow2.setAttribute("tabindex", "-1");
        arrow1.setAttribute("aria-label", "Toggle navigation");
        arrow2.setAttribute("aria-label", "Toggle navigation");
        arrow1.setAttribute("type", "button");
        arrow2.setAttribute("type", "button");
        var size = (0, $3EnZW.isNullOrUndefined)(this.separatorSize) ? "1px" : this.separatorSize + "px";
        var proxy = this;
        if (this.orientation === "Horizontal") {
            this.updateIconClass();
            (0, $4ZDHT.addClass)([
                arrow2
            ], [
                $7bada17cf2b24fe1$var$NAVIGATE_ARROW,
                $7bada17cf2b24fe1$var$ARROW_LEFT,
                $7bada17cf2b24fe1$var$HIDE_ICON
            ]);
            (0, $4ZDHT.addClass)([
                arrow1
            ], [
                $7bada17cf2b24fe1$var$NAVIGATE_ARROW,
                $7bada17cf2b24fe1$var$ARROW_RIGHT,
                $7bada17cf2b24fe1$var$HIDE_ICON
            ]);
            (0, $4ZDHT.addClass)([
                separator
            ], [
                $7bada17cf2b24fe1$var$SPLIT_BAR,
                $7bada17cf2b24fe1$var$SPLIT_H_BAR
            ]);
            separator.style.width = size;
        } else {
            (0, $4ZDHT.addClass)([
                arrow1
            ], [
                $7bada17cf2b24fe1$var$NAVIGATE_ARROW,
                $7bada17cf2b24fe1$var$ARROW_DOWN,
                $7bada17cf2b24fe1$var$HIDE_ICON
            ]);
            (0, $4ZDHT.addClass)([
                arrow2
            ], [
                $7bada17cf2b24fe1$var$NAVIGATE_ARROW,
                $7bada17cf2b24fe1$var$ARROW_UP,
                $7bada17cf2b24fe1$var$HIDE_ICON
            ]);
            (0, $4ZDHT.addClass)([
                separator
            ], [
                $7bada17cf2b24fe1$var$SPLIT_BAR,
                $7bada17cf2b24fe1$var$SPLIT_V_BAR
            ]);
            this.updateIconClass();
            separator.style.height = size;
        }
        this.addMouseActions(separator);
        separator.appendChild(arrow2);
        this.addResizeHandler(separator);
        separator.appendChild(arrow1);
        this.updateCollapseIcons(i, arrow1, arrow2);
        separator.setAttribute("tabindex", "-1");
        separator.setAttribute("aria-hidden", "true");
        if (this.enableReversePanes) separator.setAttribute("dir", "ltr");
        else separator.removeAttribute("dir");
        separator.addEventListener("focus", function() {
            separator.classList.add($7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
            proxy.currentSeparator = separator;
            proxy.getPaneDetails();
        });
        separator.addEventListener("blur", function() {
            separator.classList.remove($7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
        });
        return separator;
    };
    Splitter.prototype.updateResizablePanes = function(index) {
        this.getPaneDetails();
        if (this.isResizable()) this.allPanes[index].classList.add($7bada17cf2b24fe1$var$RESIZABLE_PANE);
        else this.allPanes[index].classList.remove($7bada17cf2b24fe1$var$RESIZABLE_PANE);
    };
    Splitter.prototype.addSeparator = function(target) {
        var childCount = this.allPanes.length;
        var clonedEle = target.children;
        var separator;
        for(var i = 0; i < childCount; i++)if (i < childCount - 1) {
            separator = this.createSeparator(i);
            (0, $4ZDHT.setStyleAttribute)(separator, {
                "order": i * 2 + 1
            });
            this.separatorOrder.push(i * 2 + 1);
            clonedEle[i].parentNode.appendChild(separator);
            this.currentSeparator = separator;
            separator.setAttribute("role", "separator");
            separator.setAttribute("aria-valuenow", i.toString());
            if (!(0, $3EnZW.isNullOrUndefined)(this.orientation)) separator.setAttribute("aria-orientation", this.orientation.toLowerCase());
            this.wireClickEvents();
            if (!(0, $3EnZW.isNullOrUndefined)(separator)) {
                if (this.isResizable()) {
                    (0, $aqzbR.EventHandler).add(separator, "mousedown", this.onMouseDown, this);
                    var eventName = (0, $5q7BP.Browser).info.name === "msie" ? "pointerdown" : "touchstart";
                    (0, $aqzbR.EventHandler).add(separator, eventName, this.onMouseDown, this);
                    separator.classList.add($7bada17cf2b24fe1$var$RESIZABLE_BAR);
                    this.updateResizablePanes(i);
                } else (0, $4ZDHT.addClass)([
                    (0, $4ZDHT.select)("." + $7bada17cf2b24fe1$var$RESIZE_BAR, separator)
                ], $7bada17cf2b24fe1$var$HIDE_HANDLER);
            }
        } else {
            if (separator) (0, $4ZDHT.addClass)([
                separator
            ], $7bada17cf2b24fe1$var$LAST_BAR);
            if (childCount > 1) this.updateResizablePanes(i);
        }
        if ((0, $5q7BP.Browser).info.name === "msie") {
            var allBar = this.element.querySelectorAll(".e-splitter .e-resize-handler");
            for(var i = 0; i < allBar.length; i++){
                var sepSize = (0, $3EnZW.isNullOrUndefined)(this.separatorSize) ? 1 : this.separatorSize;
                allBar[i].style.paddingLeft = sepSize / 2 + "px";
                allBar[i].style.paddingRight = sepSize / 2 + "px";
            }
        }
    };
    Splitter.prototype.isResizable = function() {
        var resizable = false;
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[this.getPreviousPaneIndex()]) && this.paneSettings[this.getPreviousPaneIndex()].resizable && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[this.getNextPaneIndex()]) && this.paneSettings[this.getNextPaneIndex()].resizable || (0, $3EnZW.isNullOrUndefined)(this.paneSettings[this.getNextPaneIndex()])) resizable = true;
        return resizable;
    };
    Splitter.prototype.addMouseActions = function(separator) {
        var _this = this;
        var sTout;
        var hoverTimeOut;
        separator.addEventListener("mouseenter", function() {
            /* istanbul ignore next */ sTout = setTimeout(function() {
                (0, $4ZDHT.addClass)([
                    separator
                ], [
                    $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER
                ]);
            }, _this.iconsDelay);
        });
        separator.addEventListener("mouseleave", function() {
            clearTimeout(sTout);
            (0, $4ZDHT.removeClass)([
                separator
            ], [
                $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER
            ]);
        });
        separator.addEventListener("mouseout", function() {
            clearTimeout(hoverTimeOut);
        });
        separator.addEventListener("mouseover", function() {
            /* istanbul ignore next */ hoverTimeOut = setTimeout(function() {
                (0, $4ZDHT.addClass)([
                    separator
                ], [
                    $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER
                ]);
            });
        });
    };
    Splitter.prototype.getEventType = function(e) {
        return e.indexOf("mouse") > -1 ? "mouse" : "touch";
    };
    Splitter.prototype.updateCurrentSeparator = function(target) {
        this.currentSeparator = this.isSeparator(target) ? target.parentElement : target;
    };
    Splitter.prototype.isSeparator = function(target) {
        return target.classList.contains($7bada17cf2b24fe1$var$SPLIT_BAR) ? false : true;
    };
    Splitter.prototype.isMouseEvent = function(e) {
        var isMouse = false;
        if (this.getEventType(e.type) === "mouse" || !(0, $3EnZW.isNullOrUndefined)(e.pointerType) && this.getEventType(e.pointerType) === "mouse") isMouse = true;
        return isMouse;
    };
    Splitter.prototype.updateCursorPosition = function(e, type) {
        if (this.isMouseEvent(e)) this.changeCoordinates({
            x: e.pageX,
            y: e.pageY
        }, type);
        else {
            var eventType = (0, $5q7BP.Browser).info.name !== "msie" ? e.touches[0] : e;
            this.changeCoordinates({
                x: eventType.pageX,
                y: eventType.pageY
            }, type);
        }
    };
    Splitter.prototype.changeCoordinates = function(coordinates, type) {
        if (type === "previous") this.previousCoordinates = coordinates;
        else this.currentCoordinates = coordinates;
    };
    Splitter.prototype.reportWindowSize = function() {
        var _this = this;
        var paneCount = this.allPanes.length;
        if (!document.body.contains(this.element)) {
            document.defaultView.removeEventListener("resize", this.onReportWindowSize);
            return;
        }
        for(var i = 0; i < paneCount; i++){
            if ((0, $3EnZW.isNullOrUndefined)(this.paneSettings[i].size)) this.allPanes[i].classList.remove($7bada17cf2b24fe1$var$STATIC_PANE);
            if (paneCount - 1 === i) {
                var staticPaneCount = this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$STATIC_PANE).length;
                if (staticPaneCount === paneCount) {
                    if (this.allPanes[i].style.flexBasis === "") (0, $4ZDHT.removeClass)([
                        this.allPanes[i]
                    ], $7bada17cf2b24fe1$var$STATIC_PANE);
                }
            }
        }
        if (paneCount > 0) setTimeout(function() {
            _this.updateSplitterSize(true);
        }, 200);
    };
    Splitter.prototype.updateSplitterSize = function(iswindowResize) {
        var totalWidth = 0;
        var flexPaneIndexes = [];
        var flexCount = 0;
        var children = this.element.children;
        for(var i = 0, len = children.length; i < len; i++)totalWidth += this.orientation === "Horizontal" ? children[i].offsetWidth : children[i].offsetHeight;
        for(var j = 0, len = this.allBars.length; j < len; j++)totalWidth += this.orientation === "Horizontal" ? parseInt(getComputedStyle(this.allBars[j]).marginLeft, 10) + parseInt(getComputedStyle(this.allBars[j]).marginLeft, 10) : parseInt(getComputedStyle(this.allBars[j]).marginTop, 10) + parseInt(getComputedStyle(this.allBars[j]).marginBottom, 10);
        var diff = this.orientation === "Horizontal" ? this.element.offsetWidth - (this.border * 2 + totalWidth) : this.element.offsetHeight - (this.border * 2 + totalWidth);
        for(var i = 0, len = this.allPanes.length; i < len; i++)if (this.allPanes[i].innerText === "" ? !this.paneSettings[i].size || !(this.allPanes[i].innerText === "") : !this.paneSettings[i].size && !(this.allPanes[i].innerText === "")) {
            flexPaneIndexes[flexCount] = i;
            flexCount++;
        }
        var avgDiffWidth = diff / flexPaneIndexes.length;
        for(var j = 0, len = flexPaneIndexes.length; j < len; j++)if (this.allPanes[flexPaneIndexes[j]].style.flexBasis !== "") this.allPanes[flexPaneIndexes[j]].style.flexBasis = this.orientation === "Horizontal" ? this.allPanes[flexPaneIndexes[j]].offsetWidth + avgDiffWidth + "px" : this.allPanes[flexPaneIndexes[j]].offsetHeight + avgDiffWidth + "px";
        if (this.allPanes.length === 2 && iswindowResize) {
            var paneCount = this.allPanes.length;
            var minValue = void 0;
            var paneMinRange = void 0;
            var paneIndex = 0;
            var updatePane = void 0;
            var flexPane = void 0;
            for(var i = 0; i < paneCount; i++)if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[i].min)) {
                paneMinRange = this.convertPixelToNumber(this.paneSettings[i].min.toString());
                if (this.paneSettings[i].min.indexOf("%") > 0) paneMinRange = this.convertPercentageToPixel(this.paneSettings[i].min);
                minValue = this.convertPixelToNumber(paneMinRange.toString());
                if ((this.orientation === "Horizontal" ? this.allPanes[i].offsetWidth : this.allPanes[i].offsetHeight) < minValue) {
                    if (i === paneIndex) {
                        updatePane = this.allPanes[i];
                        flexPane = this.allPanes[i + 1];
                    } else {
                        updatePane = this.allPanes[i];
                        flexPane = this.allPanes[i - 1];
                    }
                    var sizeDiff = minValue - (this.orientation === "Horizontal" ? this.allPanes[i].offsetWidth : this.allPanes[i].offsetHeight);
                    var isPercent = updatePane.style.flexBasis.indexOf("%") > -1;
                    var updatePaneOffset = this.orientation === "Horizontal" ? updatePane.offsetWidth : updatePane.offsetHeight;
                    if (!(0, $3EnZW.isNullOrUndefined)(updatePane) && updatePane.style.flexBasis !== "" && updatePane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE)) updatePane.style.flexBasis = isPercent ? this.convertPixelToPercentage(updatePaneOffset + sizeDiff) + "%" : updatePaneOffset + sizeDiff + "px";
                    var flexPaneOffset = this.orientation === "Horizontal" ? flexPane.offsetWidth : flexPane.offsetHeight;
                    if (!(0, $3EnZW.isNullOrUndefined)(flexPane) && flexPane.style.flexBasis !== "" && !flexPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE)) flexPane.style.flexBasis = flexPane.style.flexBasis.indexOf("%") > -1 ? this.convertPixelToPercentage(flexPaneOffset - sizeDiff) + "%" : flexPaneOffset - sizeDiff + "px";
                }
            }
        }
    };
    Splitter.prototype.wireResizeEvents = function() {
        document.addEventListener("mousemove", this.onMouseMoveHandler, true);
        document.addEventListener("mouseup", this.onMouseUpHandler, true);
        var touchMoveEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointermove" : "touchmove";
        var touchEndEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointerup" : "touchend";
        document.addEventListener(touchMoveEvent, this.onTouchMoveHandler, true);
        document.addEventListener(touchEndEvent, this.onTouchEndHandler, true);
    };
    Splitter.prototype.unwireResizeEvents = function() {
        this.element.ownerDocument.defaultView.removeEventListener("resize", this.onReportWindowSize);
        var touchMoveEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointermove" : "touchmove";
        var touchEndEvent = (0, $5q7BP.Browser).info.name === "msie" ? "pointerup" : "touchend";
        document.removeEventListener("mousemove", this.onMouseMoveHandler, true);
        document.removeEventListener("mouseup", this.onMouseUpHandler, true);
        document.removeEventListener(touchMoveEvent, this.onTouchMoveHandler, true);
        document.removeEventListener(touchEndEvent, this.onTouchEndHandler, true);
    };
    Splitter.prototype.wireClickEvents = function() {
        (0, $aqzbR.EventHandler).add(this.currentSeparator, "touchstart click", this.clickHandler, this);
    };
    Splitter.prototype.clickHandler = function(e) {
        if (!e.target.classList.contains($7bada17cf2b24fe1$var$NAVIGATE_ARROW)) {
            var hoverBars = (0, $4ZDHT.selectAll)("." + $7bada17cf2b24fe1$var$ROOT + " > ." + $7bada17cf2b24fe1$var$SPLIT_BAR + "." + $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER);
            if (hoverBars.length > 0) (0, $4ZDHT.removeClass)(hoverBars, $7bada17cf2b24fe1$var$SPLIT_BAR_HOVER);
            e.target.classList.add($7bada17cf2b24fe1$var$SPLIT_BAR_HOVER);
        }
        this.splitterDetails(e);
        var icon = e.target;
        if (icon.classList.contains($7bada17cf2b24fe1$var$ARROW_LEFT) || icon.classList.contains($7bada17cf2b24fe1$var$ARROW_RIGHT) || icon.classList.contains($7bada17cf2b24fe1$var$ARROW_DOWN) || icon.classList.contains($7bada17cf2b24fe1$var$ARROW_UP)) {
            if (!this.nextPane.classList.contains($7bada17cf2b24fe1$var$PANE_HIDDEN) && !this.previousPane.classList.contains($7bada17cf2b24fe1$var$PANE_HIDDEN)) this.collapseAction(e);
            else this.expandAction(e);
            this.updateSplitterSize();
        }
    };
    Splitter.prototype.expandAction = function(e) {
        var _this = this;
        var eventArgs = this.beforeAction(e);
        if (this.expandFlag) this.trigger("beforeExpand", eventArgs, function(beforeExpandArgs) {
            if (!beforeExpandArgs.cancel) _this.expandPane(e);
            var expandEventArgs = _this.afterAction(e);
            _this.trigger("expanded", expandEventArgs);
        });
        else this.expandPane(e);
    };
    Splitter.prototype.getIcon = function(e) {
        var targetClass = e.target.className.split(" ").filter(function(className) {
            return className !== $7bada17cf2b24fe1$var$NAVIGATE_ARROW && className !== $7bada17cf2b24fe1$var$HIDE_ICON;
        });
        return targetClass[0];
    };
    Splitter.prototype.expandPane = function(e) {
        this.removeStaticPanes();
        var collapseCount = this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$COLLAPSE_PANE).length;
        var flexStatus = !this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && this.previousPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && !this.nextPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE) && this.nextPane.nextElementSibling.classList.contains($7bada17cf2b24fe1$var$PANE) && !this.nextPane.nextElementSibling.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !(collapseCount === this.allPanes.length - 2);
        var collapseClass = [
            $7bada17cf2b24fe1$var$COLLAPSE_PANE,
            $7bada17cf2b24fe1$var$PANE_HIDDEN
        ];
        var icon = this.getIcon(e);
        var isLeftOrUp = icon === $7bada17cf2b24fe1$var$ARROW_LEFT || icon === $7bada17cf2b24fe1$var$ARROW_UP;
        var collapsePane = isLeftOrUp ? this.nextPane : this.previousPane;
        var expandPane = isLeftOrUp ? this.previousPane : this.nextPane;
        var expandPaneIndex = isLeftOrUp ? this.nextPaneIndex : this.prevPaneIndex;
        (0, $4ZDHT.removeClass)([
            collapsePane
        ], collapseClass);
        collapsePane.setAttribute("aria-hidden", "false");
        // cCount is calculated after removing the COLLAPSE_PANE
        var cCount = this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$COLLAPSE_PANE).length;
        if (cCount > 0) {
            if (!expandPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                (0, $4ZDHT.addClass)([
                    expandPane
                ], $7bada17cf2b24fe1$var$EXPAND_PANE);
                expandPane.setAttribute("aria-expanded", "true");
            }
        } else if (cCount === 0) {
            for(var i = 0; i < this.allPanes.length; i++)if (!this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                (0, $4ZDHT.removeClass)([
                    this.allPanes[i]
                ], $7bada17cf2b24fe1$var$EXPAND_PANE);
                this.allPanes[i].setAttribute("aria-expanded", "false");
            }
        }
        if (this.expandFlag) this.updatePaneSettings(expandPaneIndex, false);
        this.updateIconsOnExpand(e, icon);
        this.updateFlexGrow();
        if (flexStatus) {
            this.previousPane.classList.remove($7bada17cf2b24fe1$var$EXPAND_PANE);
            this.previousPane.setAttribute("aria-expanded", "false");
            this.previousPane.style.flexGrow = "";
        }
    };
    Splitter.prototype.updateFlexGrow = function() {
        var collapseCount = 0;
        for(var j = 0; j < this.element.children.length; j++)if (this.element.children[j].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) collapseCount = collapseCount + 1;
        var visiblePane = collapseCount === this.allPanes.length - 2;
        var panes = this.allPanes;
        for(var i = 0; i < panes.length; i++){
            panes[i].style.flexGrow = "";
            if (visiblePane && this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && this.paneSettings[i].size && i !== this.allPanes.length - 1) panes[i].style.flexGrow = "";
            if (panes[i].classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE)) panes[i].style.flexGrow = "1";
            else if (panes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) panes[i].style.flexGrow = "0";
        }
    };
    Splitter.prototype.hideTargetBarIcon = function(targetBar, targetArrow) {
        (0, $4ZDHT.addClass)([
            (0, $4ZDHT.select)("." + targetArrow, targetBar)
        ], $7bada17cf2b24fe1$var$HIDE_ICON);
    };
    Splitter.prototype.showTargetBarIcon = function(targetBar, targetArrow) {
        (0, $4ZDHT.removeClass)([
            (0, $4ZDHT.select)("." + targetArrow, targetBar)
        ], $7bada17cf2b24fe1$var$HIDE_ICON);
    };
    Splitter.prototype.updateIconsOnCollapse = function(e, targetIcon) {
        this.splitterProperty();
        var removeIcon = this.arrow;
        var otherBar = this.currentBarIndex === this.allBars.length - 1 ? this.prevBar : this.nextBar;
        var otherBarIndex = this.currentBarIndex === this.allBars.length - 1 ? this.currentBarIndex - 1 : this.currentBarIndex + 1;
        if (!e.target.classList.contains($7bada17cf2b24fe1$var$HIDE_ICON)) {
            if (this.splitInstance.prevPaneCollapsed || this.splitInstance.nextPaneCollapsed) {
                if (this.paneSettings[this.prevPaneIndex].collapsible && this.paneSettings[this.nextPaneIndex].collapsible) {
                    this.resizableModel(this.currentBarIndex, false);
                    this.hideTargetBarIcon(this.currentSeparator, targetIcon);
                    if (!(0, $3EnZW.isNullOrUndefined)(otherBar)) {
                        var otherPrevPaneIndex = otherBarIndex;
                        var otherNextPaneIndex = otherBarIndex + 1;
                        var collapsecount = this.getCollapseCount(otherPrevPaneIndex, otherNextPaneIndex);
                        if (this.paneSettings[otherPrevPaneIndex].collapsible && this.paneSettings[otherNextPaneIndex].collapsible) {
                            if (collapsecount === 1) {
                                this.hideTargetBarIcon(otherBar, removeIcon);
                                this.resizableModel(otherBarIndex, false);
                            } else if (collapsecount === 2) {
                                this.hideBarIcons(otherBar);
                                this.resizableModel(otherBarIndex, false);
                            }
                            if (!this.paneSettings[otherPrevPaneIndex].collapsible || !this.paneSettings[otherNextPaneIndex].collapsible) this.hideTargetBarIcon(otherBar, targetIcon);
                        }
                    }
                } else {
                    this.showTargetBarIcon(this.currentSeparator, removeIcon);
                    this.hideTargetBarIcon(this.currentSeparator, targetIcon);
                    this.resizableModel(this.currentBarIndex, false);
                }
            }
        } else {
            this.resizableModel(this.currentBarIndex, false);
            if (!(0, $3EnZW.isNullOrUndefined)(otherBar)) this.resizableModel(otherBarIndex, false);
            if (!this.paneSettings[this.prevPaneIndex].collapsible || !this.paneSettings[this.nextPaneIndex].collapsible) {
                if (!(0, $3EnZW.isNullOrUndefined)(otherBar)) this.hideTargetBarIcon(otherBar, targetIcon);
                this.hideTargetBarIcon(this.currentSeparator, removeIcon);
            } else {
                if (!(0, $3EnZW.isNullOrUndefined)(otherBar)) this.hideTargetBarIcon(otherBar, removeIcon);
                this.showTargetBarIcon(this.currentSeparator, removeIcon);
            }
        }
    };
    Splitter.prototype.collapseAction = function(e) {
        var _this = this;
        var eventArgs = this.beforeAction(e);
        if (this.collapseFlag) this.collapsePane(e);
        else this.trigger("beforeCollapse", eventArgs, function(beforeCollapseArgs) {
            if (!beforeCollapseArgs.cancel) {
                _this.collapsePane(e);
                var collapseEventArgs = _this.afterAction(e);
                _this.trigger("collapsed", collapseEventArgs);
            }
        });
    };
    Splitter.prototype.collapsePane = function(e) {
        this.removeStaticPanes();
        var collapseCount = this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$COLLAPSE_PANE).length;
        var flexStatus = this.previousPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && !this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && this.nextPane.nextElementSibling.classList.contains($7bada17cf2b24fe1$var$PANE) && !this.nextPane.nextElementSibling.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !this.nextPane.nextElementSibling.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && !(collapseCount === this.allPanes.length - 2) || this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && !this.previousPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && this.nextPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE);
        var collapseClass = [
            $7bada17cf2b24fe1$var$COLLAPSE_PANE,
            $7bada17cf2b24fe1$var$PANE_HIDDEN
        ];
        var icon = this.getIcon(e);
        var isLeftOrUp = icon === $7bada17cf2b24fe1$var$ARROW_LEFT || icon === $7bada17cf2b24fe1$var$ARROW_UP;
        var collapsePane = isLeftOrUp ? this.previousPane : this.nextPane;
        var expandPane = isLeftOrUp ? this.nextPane : this.previousPane;
        var collapsePaneIndex = isLeftOrUp ? this.prevPaneIndex : this.nextPaneIndex;
        (0, $4ZDHT.removeClass)([
            collapsePane
        ], $7bada17cf2b24fe1$var$EXPAND_PANE);
        collapsePane.setAttribute("aria-expanded", "false");
        (0, $4ZDHT.addClass)([
            collapsePane
        ], collapseClass);
        collapsePane.setAttribute("aria-hidden", "true");
        var isFlexPane = collapsePane.style.flexBasis === "";
        if (isFlexPane) {
            (0, $4ZDHT.addClass)([
                expandPane
            ], $7bada17cf2b24fe1$var$EXPAND_PANE);
            expandPane.setAttribute("aria-expanded", "true");
        } else {
            var isFlexPaneHidden = true;
            for(var i = 0; i < this.allPanes.length; i++){
                if (!this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) {
                    if (this.allPanes[i].style.flexBasis === "" && !this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE) && !this.allPanes[i].classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE)) {
                        (0, $4ZDHT.addClass)([
                            this.allPanes[i]
                        ], $7bada17cf2b24fe1$var$EXPAND_PANE);
                        this.allPanes[i].setAttribute("aria-expanded", "true");
                        isFlexPaneHidden = false;
                        break;
                    }
                }
            }
            if (isFlexPaneHidden) {
                (0, $4ZDHT.addClass)([
                    expandPane
                ], $7bada17cf2b24fe1$var$EXPAND_PANE);
                expandPane.setAttribute("aria-expanded", "true");
            }
        }
        if (!this.collapseFlag) this.updatePaneSettings(collapsePaneIndex, true);
        this.updateIconsOnCollapse(e, icon);
        this.updateFlexGrow();
        if (flexStatus) {
            this.nextPane.classList.remove($7bada17cf2b24fe1$var$EXPAND_PANE);
            this.nextPane.style.flexGrow = "";
        }
    };
    Splitter.prototype.removeStaticPanes = function() {
        for(var i = 0; i < this.allPanes.length; i++)if ((0, $3EnZW.isNullOrUndefined)(this.paneSettings[i].size)) this.allPanes[i].classList.remove($7bada17cf2b24fe1$var$STATIC_PANE);
    };
    Splitter.prototype.beforeAction = function(e) {
        var eventArgs = {
            element: this.element,
            event: e,
            pane: [
                this.previousPane,
                this.nextPane
            ],
            index: [
                this.prevPaneIndex,
                this.nextPaneIndex
            ],
            separator: this.currentSeparator,
            cancel: false
        };
        return eventArgs;
    };
    Splitter.prototype.updatePaneSettings = function(index, collapsed) {
        var paneValues = this.paneSettings;
        paneValues[index].collapsed = collapsed;
        this.setProperties({
            "paneSettings": paneValues
        }, true);
    };
    Splitter.prototype.splitterProperty = function() {
        this.splitInstance = {
            currentBarIndex: this.currentBarIndex,
            nextPaneCollapsible: this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSIBLE),
            prevPaneCollapsible: this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSIBLE),
            prevPaneExpanded: this.previousPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE),
            nextPaneExpanded: this.nextPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE),
            nextPaneCollapsed: this.nextPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE),
            prevPaneCollapsed: this.previousPane.classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE),
            nextPaneIndex: this.getNextPaneIndex(),
            prevPaneIndex: this.getPreviousPaneIndex(),
            nextPaneNextEle: this.nextPane.nextElementSibling,
            prevPanePreEle: this.previousPane.previousElementSibling
        };
    };
    Splitter.prototype.showCurrentBarIcons = function() {
        (0, $4ZDHT.removeClass)([
            (0, $4ZDHT.select)("." + this.arrow, this.currentSeparator)
        ], $7bada17cf2b24fe1$var$HIDE_ICON);
    };
    Splitter.prototype.hideBarIcons = function(bar) {
        (0, $4ZDHT.addClass)([
            (0, $4ZDHT.select)("." + this.arrow, bar)
        ], $7bada17cf2b24fe1$var$HIDE_ICON);
    };
    Splitter.prototype.getCollapseCount = function(prevPaneIndex, nextPaneIndex) {
        var collapsecount = 0;
        if (this.allPanes[prevPaneIndex].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) collapsecount = collapsecount + 1;
        if (this.allPanes[nextPaneIndex].classList.contains($7bada17cf2b24fe1$var$COLLAPSE_PANE)) collapsecount = collapsecount + 1;
        return collapsecount;
    };
    Splitter.prototype.checkResizableProp = function(prevPaneIndex, nextPaneIndex) {
        if (this.paneSettings[prevPaneIndex].resizable && this.paneSettings[nextPaneIndex].resizable) return true;
        else return false;
    };
    Splitter.prototype.updateIconsOnExpand = function(e, targetIcon) {
        this.splitterProperty();
        var showIcon = this.arrow;
        var otherBar = this.currentBarIndex === this.allBars.length - 1 ? this.prevBar : this.nextBar;
        var otherBarIndex = this.currentBarIndex === this.allBars.length - 1 ? this.currentBarIndex - 1 : this.currentBarIndex + 1;
        if (!e.target.classList.contains($7bada17cf2b24fe1$var$HIDE_ICON)) // prevPane ! collapsed && nextPane ! collapsed
        {
            if (!this.splitInstance.prevPaneCollapsed && !this.splitInstance.nextPaneCollapsed) {
                if (this.paneSettings[this.prevPaneIndex].collapsible && this.paneSettings[this.nextPaneIndex].collapsible) {
                    this.showCurrentBarIcons();
                    if (this.checkResizableProp(this.prevPaneIndex, this.nextPaneIndex)) this.resizableModel(this.currentBarIndex, true);
                    else this.resizableModel(this.currentBarIndex, false);
                    if (!(0, $3EnZW.isNullOrUndefined)(otherBar)) {
                        var otherPrevPaneIndex = otherBarIndex;
                        var otherNextPaneIndex = otherBarIndex + 1;
                        var collapsecount = this.getCollapseCount(otherPrevPaneIndex, otherNextPaneIndex);
                        if (this.paneSettings[otherPrevPaneIndex].collapsible && this.paneSettings[otherNextPaneIndex].collapsible) {
                            if (collapsecount === 0) {
                                this.showTargetBarIcon(otherBar, targetIcon);
                                this.showTargetBarIcon(otherBar, showIcon);
                                if (this.checkResizableProp(otherPrevPaneIndex, otherNextPaneIndex)) this.resizableModel(otherBarIndex, true);
                            } else if (collapsecount === 1) {
                                this.hideBarIcons(otherBar);
                                // If condition Edge case in flexible cases
                                if (this.allPanes[otherPrevPaneIndex].classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE) || this.allPanes[otherNextPaneIndex].classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE)) this.showTargetBarIcon(otherBar, showIcon);
                                else // Common case
                                this.showTargetBarIcon(otherBar, targetIcon);
                                this.resizableModel(otherBarIndex, false);
                            }
                        }
                    }
                } else {
                    this.hideTargetBarIcon(this.currentSeparator, targetIcon);
                    this.showTargetBarIcon(this.currentSeparator, showIcon);
                    if (!this.splitInstance.prevPaneCollapsed && !this.splitInstance.nextPaneCollapsed) {
                        if (this.checkResizableProp(this.prevPaneIndex, this.nextPaneIndex)) this.resizableModel(this.currentBarIndex, true);
                    } else this.resizableModel(this.currentBarIndex, false);
                }
            }
        } else {
            if (!this.paneSettings[this.prevPaneIndex].collapsible && !this.paneSettings[this.nextPaneIndex].collapsible) {
                if (this.checkResizableProp(this.prevPaneIndex, this.nextPaneIndex)) this.resizableModel(this.currentBarIndex, true);
            }
        }
    };
    Splitter.prototype.afterAction = function(e) {
        var eventArgs = {
            element: this.element,
            event: e,
            pane: [
                this.previousPane,
                this.nextPane
            ],
            index: [
                this.prevPaneIndex,
                this.nextPaneIndex
            ],
            separator: this.currentSeparator
        };
        return eventArgs;
    };
    Splitter.prototype.currentIndex = function(e) {
        this.currentBarIndex = this.getOrderIndex(parseInt(e.target.parentElement.style.order, 10), "splitbar");
    };
    Splitter.prototype.getSeparatorIndex = function(target) {
        var array = [].slice.call(this.allBars);
        array = this.enableReversePanes ? array.reverse() : array;
        return array.indexOf(target);
    };
    Splitter.prototype.getPrevBar = function(currentBar) {
        var prevbar = this.allBars[currentBar - 1];
        return prevbar;
    };
    Splitter.prototype.getNextBar = function(currentBar) {
        var prevbar = this.allBars[currentBar + 1];
        return prevbar;
    };
    Splitter.prototype.updateBars = function(index) {
        this.prevBar = this.getPrevBar(index);
        this.nextBar = this.getNextBar(index);
    };
    Splitter.prototype.splitterDetails = function(e) {
        if (this.orientation === "Horizontal") this.arrow = e.target.classList.contains($7bada17cf2b24fe1$var$ARROW_LEFT) ? $7bada17cf2b24fe1$var$ARROW_RIGHT : $7bada17cf2b24fe1$var$ARROW_LEFT;
        else this.arrow = e.target.classList.contains($7bada17cf2b24fe1$var$ARROW_UP) ? $7bada17cf2b24fe1$var$ARROW_DOWN : $7bada17cf2b24fe1$var$ARROW_UP;
        this.updateCurrentSeparator(e.target);
        this.currentIndex(e);
        this.updateBars(this.currentBarIndex);
        this.getPaneDetails();
    };
    Splitter.prototype.triggerResizing = function(e) {
        var eventArgs = {
            element: this.element,
            event: e,
            pane: [
                this.previousPane,
                this.nextPane
            ],
            index: [
                this.prevPaneIndex,
                this.nextPaneIndex
            ],
            paneSize: [
                this.prePaneDimenson,
                this.nextPaneDimension
            ],
            separator: this.currentSeparator
        };
        this.trigger("resizing", eventArgs);
    };
    Splitter.prototype.onMouseDown = function(e) {
        var _this = this;
        e.preventDefault();
        var target = e.target;
        if (target.classList.contains($7bada17cf2b24fe1$var$NAVIGATE_ARROW)) return;
        this.updateCurrentSeparator(target);
        (0, $4ZDHT.addClass)([
            this.currentSeparator
        ], $7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
        this.updateCursorPosition(e, "previous");
        this.getPaneDetails();
        var eventArgs = {
            element: this.element,
            event: e,
            pane: [
                this.previousPane,
                this.nextPane
            ],
            index: [
                this.getPreviousPaneIndex(),
                this.getNextPaneIndex()
            ],
            separator: this.currentSeparator,
            cancel: false
        };
        for(var i = 0; i < this.element.querySelectorAll("iframe").length; i++)this.element.querySelectorAll("iframe")[i].style.pointerEvents = "none";
        this.trigger("resizeStart", eventArgs, function(resizeStartArgs) {
            if (!resizeStartArgs.cancel) {
                _this.wireResizeEvents();
                _this.checkPaneSize(e);
            }
        });
    };
    Splitter.prototype.updatePaneFlexBasis = function(pane) {
        var previous;
        if (pane.style.flexBasis.indexOf("%") > 0) previous = this.removePercentageUnit(pane.style.flexBasis);
        else if (pane.style.flexBasis !== "") previous = this.convertPixelToPercentage(this.convertPixelToNumber(pane.style.flexBasis));
        else {
            var offset = this.orientation === "Horizontal" ? pane.offsetWidth : pane.offsetHeight;
            previous = this.convertPixelToPercentage(offset);
        }
        return previous;
    };
    Splitter.prototype.removePercentageUnit = function(value) {
        return parseFloat(value.slice(0, value.indexOf("%")));
    };
    Splitter.prototype.convertPercentageToPixel = function(value, targetElement) {
        var percentage = value.toString();
        var convertedValue;
        if (percentage.indexOf("%") > -1) {
            convertedValue = parseFloat(percentage.slice(0, percentage.indexOf("%")));
            var offsetValue = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(targetElement)) offsetValue = this.panesDimensions[this.allPanes.indexOf(targetElement)];
            else offsetValue = this.orientation === "Horizontal" ? this.element.offsetWidth : this.element.offsetHeight;
            convertedValue = Math.ceil(offsetValue * (convertedValue / 100));
        } else convertedValue = parseInt(percentage, 10);
        return convertedValue;
    };
    Splitter.prototype.convertPixelToPercentage = function(value) {
        var offsetValue = this.orientation === "Horizontal" ? this.element.offsetWidth : this.element.offsetHeight;
        return value / offsetValue * 100;
    };
    Splitter.prototype.convertPixelToNumber = function(value) {
        value = value.toString();
        if (value.indexOf("p") > -1) return parseFloat(value.slice(0, value.indexOf("p")));
        else return parseFloat(value);
    };
    Splitter.prototype.calcDragPosition = function(rectValue, offsetValue) {
        var separatorPosition = this.orientation === "Horizontal" ? this.currentCoordinates.x - rectValue : this.currentCoordinates.y - rectValue;
        var separator;
        separator = separatorPosition / offsetValue;
        separator = separator > 1 ? 1 : separator < 0 ? 0 : separator;
        return separator * offsetValue;
    };
    Splitter.prototype.getSeparatorPosition = function(e) {
        this.updateCursorPosition(e, "current");
        var rectBound = this.orientation === "Horizontal" ? this.element.getBoundingClientRect().left + window.scrollX : this.element.getBoundingClientRect().top + window.scrollY;
        var offSet = this.orientation === "Horizontal" ? this.element.offsetWidth : this.element.offsetHeight;
        return this.calcDragPosition(rectBound, offSet);
    };
    Splitter.prototype.getMinMax = function(paneIndex, target, selection) {
        var defaultVal = selection === "min" ? 0 : null;
        // eslint-disable-next-line
        var paneValue = null;
        if (selection === "min") {
            if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex].min)) paneValue = this.paneSettings[paneIndex].min;
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex].max)) paneValue = this.paneSettings[paneIndex].max;
        if (this.paneSettings.length > 0 && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(paneValue)) {
            if (paneValue.indexOf("%") > 0) paneValue = this.convertPercentageToPixel(paneValue).toString();
            return this.convertPixelToNumber(paneValue);
        } else return defaultVal;
    };
    Splitter.prototype.getPreviousPaneIndex = function() {
        var separatorIndex = this.enableReversePanes ? parseInt(this.currentSeparator.style.order, 10) + 1 : parseInt(this.currentSeparator.style.order, 10) - 1;
        return this.getOrderIndex(separatorIndex, "pane");
    };
    Splitter.prototype.getNextPaneIndex = function() {
        var separatorIndex = this.enableReversePanes ? parseInt(this.currentSeparator.style.order, 10) - 1 : parseInt(this.currentSeparator.style.order, 10) + 1;
        return this.getOrderIndex(separatorIndex, "pane");
    };
    Splitter.prototype.getPaneDetails = function() {
        var prevPane = null;
        var nextPane = null;
        this.order = parseInt(this.currentSeparator.style.order, 10);
        if (this.allPanes.length > 1) {
            prevPane = this.getPrevPane(this.order);
            nextPane = this.getNextPane(this.order);
        }
        if (prevPane && nextPane) {
            this.previousPane = prevPane;
            this.nextPane = nextPane;
            this.prevPaneIndex = this.getPreviousPaneIndex();
            this.nextPaneIndex = this.getNextPaneIndex();
        } else return;
    };
    Splitter.prototype.getPaneHeight = function(pane) {
        return this.orientation === "Horizontal" ? pane.offsetWidth.toString() : pane.offsetHeight.toString();
    };
    Splitter.prototype.isValidSize = function(paneIndex) {
        var isValid = false;
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex].size) && this.paneSettings[paneIndex].size.indexOf("%") > -1) isValid = true;
        return isValid;
    };
    Splitter.prototype.getPaneDimensions = function() {
        this.previousPaneHeightWidth = this.previousPane.style.flexBasis === "" ? this.getPaneHeight(this.previousPane) : this.previousPane.style.flexBasis;
        this.nextPaneHeightWidth = this.nextPane.style.flexBasis === "" ? this.getPaneHeight(this.nextPane) : this.nextPane.style.flexBasis;
        if (this.isValidSize(this.prevPaneIndex)) {
            this.previousPaneHeightWidth = this.convertPercentageToPixel(this.previousPaneHeightWidth).toString();
            this.updatePrePaneInPercentage = true;
        }
        if (this.isValidSize(this.nextPaneIndex)) {
            this.nextPaneHeightWidth = this.convertPercentageToPixel(this.nextPaneHeightWidth).toString();
            this.updateNextPaneInPercentage = true;
        }
        this.prePaneDimenson = this.convertPixelToNumber(this.previousPaneHeightWidth.toString());
        this.nextPaneDimension = this.convertPixelToNumber(this.nextPaneHeightWidth.toString());
    };
    Splitter.prototype.checkCoordinates = function(pageX, pageY) {
        var coordinatesChanged = true;
        if (pageX === this.previousCoordinates.x && pageY === this.previousCoordinates.y) coordinatesChanged = false;
        return coordinatesChanged;
    };
    Splitter.prototype.isCursorMoved = function(e) {
        var cursorMoved = true;
        if (this.getEventType(e.type) === "mouse" || !(0, $3EnZW.isNullOrUndefined)(e.pointerType) && this.getEventType(e.pointerType) === "mouse") cursorMoved = this.checkCoordinates(e.pageX, e.pageY);
        else cursorMoved = (0, $5q7BP.Browser).info.name !== "msie" ? this.checkCoordinates(e.touches[0].pageX, e.touches[0].pageY) : this.checkCoordinates(e.pageX, e.pageY);
        return cursorMoved;
    };
    Splitter.prototype.getBorder = function() {
        this.border = 0;
        var border = this.orientation === "Horizontal" ? (this.element.offsetWidth - this.element.clientWidth) / 2 : (this.element.offsetHeight - this.element.clientHeight) / 2;
        this.border = (0, $5q7BP.Browser).info.name !== "chrome" ? this.border : border;
    };
    Splitter.prototype.onMouseMove = function(e) {
        if (!this.isCursorMoved(e)) return;
        this.getPaneDetails();
        this.getPaneDimensions();
        this.triggerResizing(e);
        var left = this.validateDraggedPosition(this.getSeparatorPosition(e), this.prePaneDimenson, this.nextPaneDimension);
        var separatorNewPosition;
        this.getBorder();
        if (this.orientation === "Horizontal") separatorNewPosition = this.element.getBoundingClientRect().left + left - this.currentSeparator.getBoundingClientRect().left + this.border;
        else separatorNewPosition = this.element.getBoundingClientRect().top + left - this.currentSeparator.getBoundingClientRect().top + this.border;
        this.nextPaneHeightWidth = typeof this.nextPaneHeightWidth === "string" && this.nextPaneHeightWidth.indexOf("p") > -1 ? this.convertPixelToNumber(this.nextPaneHeightWidth) : parseInt(this.nextPaneHeightWidth, 10);
        this.previousPaneHeightWidth = typeof this.previousPaneHeightWidth === "string" && this.previousPaneHeightWidth.indexOf("p") > -1 ? this.convertPixelToNumber(this.previousPaneHeightWidth) : parseInt(this.previousPaneHeightWidth, 10);
        this.prevPaneCurrentWidth = separatorNewPosition + this.previousPaneHeightWidth;
        this.nextPaneCurrentWidth = this.nextPaneHeightWidth - separatorNewPosition;
        this.validateMinMaxValues();
        if (this.nextPaneCurrentWidth < 0) this.nextPaneCurrentWidth = 0;
        /* istanbul ignore next */ if (this.prevPaneCurrentWidth < 0) this.prevPaneCurrentWidth = 0;
        if (this.nextPaneCurrentWidth + this.prevPaneCurrentWidth > this.totalWidth) {
            if (this.nextPaneCurrentWidth < this.prevPaneCurrentWidth) this.prevPaneCurrentWidth = this.prevPaneCurrentWidth - (this.nextPaneCurrentWidth + this.prevPaneCurrentWidth - this.totalWidth);
            else this.nextPaneCurrentWidth = this.nextPaneCurrentWidth - (this.nextPaneCurrentWidth + this.prevPaneCurrentWidth - this.totalWidth);
        }
        /* istanbul ignore next */ if (this.nextPaneCurrentWidth + this.prevPaneCurrentWidth < this.totalWidth) {
            var difference = this.totalWidth - (this.nextPaneCurrentWidth + this.prevPaneCurrentWidth);
            this.nextPaneCurrentWidth = this.nextPaneCurrentWidth + difference;
        }
        this.calculateCurrentDimensions();
        this.addStaticPaneClass();
        var flexPaneCount = 0;
        for(var i = 0; i < this.paneSettings.length; i++){
            if (this.paneSettings[i].size === "") flexPaneCount = flexPaneCount + 1;
            else if (this.allPanes[i].style.flexBasis !== "") this.paneSettings[i].size = this.allPanes[i].style.flexBasis;
        }
        var allFlexiblePanes = flexPaneCount === this.allPanes.length;
        // Two flexible Pane Case.
        if (this.previousPane.style.flexBasis === "" && this.nextPane.style.flexBasis === "" && !allFlexiblePanes) {
            var middlePaneIndex = this.allPanes.length % this.allBars.length;
            if (this.prevPaneIndex === middlePaneIndex) {
                this.nextPane.style.flexBasis = this.nextPaneCurrentWidth;
                (0, $4ZDHT.addClass)([
                    this.nextPane
                ], $7bada17cf2b24fe1$var$STATIC_PANE);
            } else if (this.nextPaneIndex === middlePaneIndex) {
                this.previousPane.style.flexBasis = this.prevPaneCurrentWidth;
                (0, $4ZDHT.addClass)([
                    this.previousPane
                ], $7bada17cf2b24fe1$var$STATIC_PANE);
            } else {
                this.nextPane.style.flexBasis = this.nextPaneCurrentWidth;
                (0, $4ZDHT.addClass)([
                    this.nextPane
                ], $7bada17cf2b24fe1$var$STATIC_PANE);
            }
        } else if (allFlexiblePanes) {
            this.previousPane.style.flexBasis = this.prevPaneCurrentWidth;
            (0, $4ZDHT.addClass)([
                this.previousPane
            ], $7bada17cf2b24fe1$var$STATIC_PANE);
            this.nextPane.style.flexBasis = this.nextPaneCurrentWidth;
            (0, $4ZDHT.addClass)([
                this.nextPane
            ], $7bada17cf2b24fe1$var$STATIC_PANE);
        } else {
            if (this.previousPane.style.flexBasis !== "" && this.previousPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE)) this.previousPane.style.flexBasis = this.prevPaneCurrentWidth;
            if (this.nextPane.style.flexBasis !== "" && this.nextPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE)) this.nextPane.style.flexBasis = this.nextPaneCurrentWidth;
        }
        var isStaticPanes = this.previousPane.style.flexBasis !== "" && this.nextPane.style.flexBasis !== "";
        if (!(this.allPanes.length > 2) && isStaticPanes) this.updateSplitterSize();
    };
    Splitter.prototype.validateMinRange = function(paneIndex, paneCurrentWidth) {
        var paneMinRange = null;
        var paneMinDimensions;
        var difference = 0;
        var validatedVal;
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex].min)) paneMinRange = this.paneSettings[paneIndex].min.toString();
        if (!(0, $3EnZW.isNullOrUndefined)(paneMinRange)) {
            if (paneMinRange.indexOf("%") > 0) paneMinRange = this.convertPercentageToPixel(paneMinRange).toString();
            paneMinDimensions = this.convertPixelToNumber(paneMinRange);
            if (paneCurrentWidth < paneMinDimensions) {
                difference = paneCurrentWidth - paneMinDimensions <= 0 ? 0 : paneCurrentWidth - paneMinDimensions;
                this.totalWidth = this.totalWidth - difference;
                this.totalPercent = this.convertPixelToPercentage(this.totalWidth);
                validatedVal = paneMinDimensions;
            }
        }
        return (0, $3EnZW.isNullOrUndefined)(validatedVal) ? paneCurrentWidth : validatedVal;
    };
    Splitter.prototype.validateMaxRange = function(paneIndex, paneCurrentWidth) {
        var paneMaxRange = null;
        var paneMaxDimensions;
        var validatedVal;
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[paneIndex].max)) paneMaxRange = this.paneSettings[paneIndex].max.toString();
        if (!(0, $3EnZW.isNullOrUndefined)(paneMaxRange)) {
            if (paneMaxRange.indexOf("%") > 0) paneMaxRange = this.convertPercentageToPixel(paneMaxRange).toString();
            paneMaxDimensions = this.convertPixelToNumber(paneMaxRange);
            if (paneCurrentWidth > paneMaxDimensions) {
                this.totalWidth = this.totalWidth - (paneCurrentWidth - paneMaxDimensions);
                this.totalPercent = this.convertPixelToPercentage(this.totalWidth);
                validatedVal = paneMaxDimensions;
            }
        }
        return (0, $3EnZW.isNullOrUndefined)(validatedVal) ? paneCurrentWidth : validatedVal;
    };
    Splitter.prototype.validateMinMaxValues = function() {
        //validate previous pane minimum range
        this.prevPaneCurrentWidth = this.validateMinRange(this.prevPaneIndex, this.prevPaneCurrentWidth);
        // Validate next pane minimum range
        this.nextPaneCurrentWidth = this.validateMinRange(this.nextPaneIndex, this.nextPaneCurrentWidth);
        // validate previous pane maximum range
        this.prevPaneCurrentWidth = this.validateMaxRange(this.prevPaneIndex, this.prevPaneCurrentWidth);
        // validate next pane maximum range
        this.nextPaneCurrentWidth = this.validateMaxRange(this.nextPaneIndex, this.nextPaneCurrentWidth);
    };
    Splitter.prototype.equatePaneWidths = function() {
        var difference;
        if (this.prevPaneCurrentWidth + this.nextPaneCurrentWidth > this.totalPercent) {
            difference = this.prevPaneCurrentWidth + this.nextPaneCurrentWidth - this.totalPercent;
            this.prevPaneCurrentWidth = this.prevPaneCurrentWidth - difference / 2 + "%";
            this.nextPaneCurrentWidth = this.nextPaneCurrentWidth - difference / 2 + "%";
        }
        if (this.prevPaneCurrentWidth + this.nextPaneCurrentWidth < this.totalPercent) {
            difference = this.totalPercent - (this.prevPaneCurrentWidth + this.nextPaneCurrentWidth);
            this.prevPaneCurrentWidth = this.prevPaneCurrentWidth + difference / 2 + "%";
            this.nextPaneCurrentWidth = this.nextPaneCurrentWidth + difference / 2 + "%";
        }
    };
    Splitter.prototype.calculateCurrentDimensions = function() {
        if (this.updatePrePaneInPercentage || this.updateNextPaneInPercentage) {
            this.prevPaneCurrentWidth = Math.round(Number(Math.round(this.convertPixelToPercentage(this.prevPaneCurrentWidth) * 10) / 10));
            this.nextPaneCurrentWidth = Math.round(Number(Math.round(this.convertPixelToPercentage(this.nextPaneCurrentWidth) * 10) / 10));
            if (this.prevPaneCurrentWidth === 0) this.nextPaneCurrentWidth = this.totalPercent;
            if (this.nextPaneCurrentWidth === 0) this.prevPaneCurrentWidth = this.totalPercent;
            if (this.prevPaneCurrentWidth + this.nextPaneCurrentWidth !== this.totalPercent) this.equatePaneWidths();
            else {
                this.prevPaneCurrentWidth = this.prevPaneCurrentWidth + "%";
                this.nextPaneCurrentWidth = this.nextPaneCurrentWidth + "%";
            }
            this.prevPaneCurrentWidth = this.updatePrePaneInPercentage ? this.prevPaneCurrentWidth : this.convertPercentageToPixel(this.prevPaneCurrentWidth) + "px";
            this.nextPaneCurrentWidth = this.updateNextPaneInPercentage ? this.nextPaneCurrentWidth : this.convertPercentageToPixel(this.nextPaneCurrentWidth) + "px";
            this.updatePrePaneInPercentage = false;
            this.updateNextPaneInPercentage = false;
        } else {
            this.prevPaneCurrentWidth = this.prevPaneCurrentWidth + "px";
            this.nextPaneCurrentWidth = this.nextPaneCurrentWidth + "px";
        }
    };
    Splitter.prototype.addStaticPaneClass = function() {
        if (!this.previousPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !(this.previousPane.style.flexBasis === "") && !this.previousPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE)) this.previousPane.classList.add($7bada17cf2b24fe1$var$STATIC_PANE);
        if (!this.nextPane.classList.contains($7bada17cf2b24fe1$var$STATIC_PANE) && !(this.nextPane.style.flexBasis === "") && !this.nextPane.classList.contains($7bada17cf2b24fe1$var$EXPAND_PANE)) this.nextPane.classList.add($7bada17cf2b24fe1$var$STATIC_PANE);
    };
    Splitter.prototype.validateDraggedPosition = function(draggedPos, prevPaneHeightWidth, nextPaneHeightWidth) {
        var separatorTopLeft = this.orientation === "Horizontal" ? this.currentSeparator.offsetLeft : this.currentSeparator.offsetTop;
        var prePaneRange = separatorTopLeft - prevPaneHeightWidth;
        var nextPaneRange = nextPaneHeightWidth + separatorTopLeft;
        var pane1MinSize = this.getMinMax(this.prevPaneIndex, this.previousPane, "min");
        var pane2MinSize = this.getMinMax(this.nextPaneIndex, this.nextPane, "min");
        var pane1MaxSize = this.getMinMax(this.prevPaneIndex, this.previousPane, "max");
        var pane2MaxSize = this.getMinMax(this.nextPaneIndex, this.nextPane, "max");
        var validatedSize = draggedPos;
        if (draggedPos > nextPaneRange - pane2MinSize) validatedSize = nextPaneRange - pane2MinSize;
        else if (draggedPos < prePaneRange + pane1MinSize) validatedSize = prePaneRange + pane1MinSize;
        if (!(0, $3EnZW.isNullOrUndefined)(pane1MaxSize)) {
            if (draggedPos > prePaneRange + pane1MaxSize) validatedSize = prePaneRange + pane1MaxSize;
        } else if (!(0, $3EnZW.isNullOrUndefined)(pane2MaxSize)) {
            if (draggedPos < nextPaneRange - pane2MaxSize) validatedSize = nextPaneRange - pane2MaxSize;
        }
        return validatedSize;
    };
    Splitter.prototype.onMouseUp = function(e) {
        (0, $4ZDHT.removeClass)([
            this.currentSeparator
        ], $7bada17cf2b24fe1$var$SPLIT_BAR_ACTIVE);
        this.unwireResizeEvents();
        var eventArgs = {
            event: e,
            element: this.element,
            pane: [
                this.previousPane,
                this.nextPane
            ],
            index: [
                this.prevPaneIndex,
                this.nextPaneIndex
            ],
            separator: this.currentSeparator,
            paneSize: [
                this.prePaneDimenson,
                this.nextPaneDimension
            ]
        };
        for(var i = 0; i < this.element.querySelectorAll("iframe").length; i++)this.element.querySelectorAll("iframe")[i].style.pointerEvents = "auto";
        this.trigger("resizeStop", eventArgs);
        if (this.enablePersistence) {
            var paneValues = this.paneSettings;
            paneValues[this.getPreviousPaneIndex()].size = this.allPanes[this.getPreviousPaneIndex()].style.flexBasis;
            paneValues[this.getNextPaneIndex()].size = this.allPanes[this.getNextPaneIndex()].style.flexBasis;
            this.setProperties({
                "paneSettings": paneValues
            }, true);
        }
    };
    Splitter.prototype.panesDimension = function(index, child) {
        var childCount = child.length;
        var size;
        parseInt(this.getHeight(this.element), 10);
        if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index])) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[index].size)) {
                size = this.paneSettings[index].size;
                if (index < childCount) {
                    (0, $4ZDHT.setStyleAttribute)(child[index], {
                        "flex-basis": size,
                        "order": index * 2
                    });
                    if (index < childCount - 1 && this.paneSettings[index].size !== "") (0, $4ZDHT.addClass)([
                        child[index]
                    ], $7bada17cf2b24fe1$var$STATIC_PANE);
                    else if (!this.sizeFlag) child[index].style.flexBasis = null;
                    if (index === childCount - 1 && this.sizeFlag && this.paneSettings[index].size !== "") (0, $4ZDHT.addClass)([
                        child[index]
                    ], $7bada17cf2b24fe1$var$STATIC_PANE);
                }
            } else {
                this.sizeFlag = true;
                (0, $4ZDHT.setStyleAttribute)(child[index], {
                    "order": index * 2
                });
            }
        } else (0, $4ZDHT.setStyleAttribute)(child[index], {
            "order": index * 2
        });
        this.paneOrder.push(index * 2);
    };
    Splitter.prototype.setTemplate = function(template, toElement) {
        toElement.innerHTML = "";
        template = typeof template === "string" ? this.sanitizeHelper(template) : template;
        this.templateCompile(toElement, template);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) this.renderReactTemplates();
    };
    // eslint-disable-next-line
    Splitter.prototype.templateCompile = function(ele, cnt) {
        // eslint-disable-next-line
        var blazorContain = Object.keys(window);
        var tempEle = this.createElement("div");
        this.compileElement(tempEle, cnt, "content");
        if (tempEle.childNodes.length !== 0) [].slice.call(tempEle.childNodes).forEach(function(childEle) {
            ele.appendChild(childEle);
        });
    };
    Splitter.prototype.compileElement = function(ele, val, prop) {
        // eslint-disable-next-line
        var blazorContain = Object.keys(window);
        if (typeof val === "string") {
            if (val[0] === "." || val[0] === "#") {
                var eleVal = document.querySelector(val);
                if (!(0, $3EnZW.isNullOrUndefined)(eleVal)) {
                    this.templateElement.push(eleVal);
                    if (eleVal.style.display === "none") eleVal.style.removeProperty("display");
                    if (eleVal.getAttribute("style") === "") eleVal.removeAttribute("style");
                    ele.appendChild(eleVal);
                    return;
                } else val = val.trim();
            } else val = val.trim();
        }
        var templateFn;
        if (!(0, $3EnZW.isNullOrUndefined)(val.outerHTML)) templateFn = (0, $c2qqN.compile)(val.outerHTML);
        else templateFn = (0, $c2qqN.compile)(val);
        var templateFUN;
        if (!(0, $3EnZW.isNullOrUndefined)(templateFn)) templateFUN = templateFn({}, this, prop, this.element.id + "content" + this.allPanes.length.toString(), true);
        if (!(0, $3EnZW.isNullOrUndefined)(templateFn) && templateFUN && templateFUN.length > 0) [].slice.call(templateFUN).forEach(function(el) {
            ele.appendChild(el);
        });
    };
    Splitter.prototype.paneCollapsible = function(pane, index) {
        // eslint-disable-next-line
        this.paneSettings[index].collapsible ? (0, $4ZDHT.addClass)([
            pane
        ], $7bada17cf2b24fe1$var$COLLAPSIBLE) : (0, $4ZDHT.removeClass)([
            pane
        ], $7bada17cf2b24fe1$var$COLLAPSIBLE);
    };
    Splitter.prototype.createSplitPane = function(target) {
        var childCount = target.children.length;
        for(var i = 0; i < this.paneSettings.length; i++)if (childCount < this.paneSettings.length) {
            var childElement = this.createElement("div");
            this.element.appendChild(childElement);
            childCount = childCount + 1;
        }
        childCount = target.children.length;
        var child = [].slice.call(target.children);
        this.sizeFlag = false;
        if (childCount > 0) {
            for(var i = 0; i < childCount; i++)// To accept only div and span element as pane
            if (child[i].nodeName === "DIV" || child[i].nodeName === "SPAN") {
                this.allPanes.push(child[i]);
                if (this.orientation === "Horizontal") {
                    (0, $4ZDHT.addClass)([
                        child[i]
                    ], [
                        $7bada17cf2b24fe1$var$PANE,
                        $7bada17cf2b24fe1$var$SPLIT_H_PANE,
                        $7bada17cf2b24fe1$var$SCROLL_PANE
                    ]);
                    this.panesDimension(i, child);
                } else {
                    (0, $4ZDHT.addClass)([
                        child[i]
                    ], [
                        $7bada17cf2b24fe1$var$PANE,
                        $7bada17cf2b24fe1$var$SPLIT_V_PANE,
                        $7bada17cf2b24fe1$var$SCROLL_PANE
                    ]);
                    this.panesDimension(i, child);
                }
                if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[i]) && !(0, $3EnZW.isNullOrUndefined)(this.paneSettings[i].content)) this.setTemplate(this.paneSettings[i].content, child[i]);
                if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[i]) && this.paneSettings[i].cssClass) this.setCssClass(child[i], this.paneSettings[i].cssClass);
                if (!(0, $3EnZW.isNullOrUndefined)(this.paneSettings[i])) this.paneCollapsible(child[i], i);
            }
        }
    };
    /**
     * expands corresponding pane based on the index is passed.
     *
     * @param { number } index - Specifies the index value of the corresponding pane to be expanded at initial rendering of splitter.
     * @returns {void}
     */ Splitter.prototype.expand = function(index) {
        this.collapsedOnchange(index);
        this.updatePaneSettings(index, false);
    };
    /**
     * collapses corresponding pane based on the index is passed.
     *
     * @param { number } index - Specifies the index value of the corresponding pane to be collapsed at initial rendering of splitter.
     * @returns {void}
     */ Splitter.prototype.collapse = function(index) {
        this.isCollapsed(index);
        this.updatePaneSettings(index, true);
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */ Splitter.prototype.destroy = function() {
        if (!this.isDestroyed) {
            _super.prototype.destroy.call(this);
            (0, $aqzbR.EventHandler).remove(document, "touchstart click", this.onDocumentClick);
            (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.onMove);
            this.element.ownerDocument.defaultView.removeEventListener("resize", this.onReportWindowSize, true);
            while(this.element.attributes.length > 0)this.element.removeAttribute(this.element.attributes[0].name);
            this.element.innerHTML = this.wrapper.innerHTML;
            for(var i = 0; i < this.wrapper.attributes.length; i++)this.element.setAttribute(this.wrapper.attributes[i].name, this.wrapper.attributes[i].value);
            if (this.refreshing) {
                (0, $4ZDHT.addClass)([
                    this.element
                ], [
                    "e-control",
                    "e-lib",
                    $7bada17cf2b24fe1$var$ROOT
                ]);
                this.allBars = [];
                this.allPanes = [];
            }
            this.restoreElem();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.isReact) this.clearTemplate();
            this.allBars = [];
            this.allPanes = [];
            this.previousPane = null;
            this.nextPane = null;
            this.currentSeparator = null;
        }
    };
    Splitter.prototype.restoreElem = function() {
        if (this.templateElement.length > 0) for(var i = 0; i < this.templateElement.length; i++){
            this.templateElement[i].style.display = "none";
            document.body.appendChild(this.templateElement[i]);
        }
    };
    Splitter.prototype.addPaneClass = function(pane) {
        if (this.orientation === "Horizontal") (0, $4ZDHT.addClass)([
            pane
        ], [
            $7bada17cf2b24fe1$var$PANE,
            $7bada17cf2b24fe1$var$SPLIT_H_PANE,
            $7bada17cf2b24fe1$var$SCROLL_PANE
        ]);
        else (0, $4ZDHT.addClass)([
            pane
        ], [
            $7bada17cf2b24fe1$var$PANE,
            $7bada17cf2b24fe1$var$SPLIT_V_PANE,
            $7bada17cf2b24fe1$var$SCROLL_PANE
        ]);
        return pane;
    };
    Splitter.prototype.removePaneOrders = function(paneClass) {
        var childNodes = this.element.childNodes;
        var panes = [];
        for(var i = 0; childNodes.length < 0; i++)if (childNodes[i].classList.contains(paneClass)) panes.push(childNodes[i]);
        for(var i = 0; i < panes.length; i++)panes[i].style.removeProperty("order");
    };
    Splitter.prototype.setPaneOrder = function() {
        for(var i = 0; i < this.allPanes.length; i++)this.panesDimension(i, this.allPanes);
    };
    Splitter.prototype.removeSeparator = function() {
        for(var i = 0; i < this.allBars.length; i++)(0, $4ZDHT.detach)(this.allBars[i]);
        this.allBars = [];
    };
    Splitter.prototype.updatePanes = function() {
        this.setPaneOrder();
        this.removeSeparator();
        this.addSeparator(this.element);
    };
    /**
     * Allows you to add a pane dynamically to the specified index position by passing the pane properties.
     *
     * @param { PanePropertiesModel } paneProperties - Specifies the pane’s properties that apply to new pane.
     * @param { number } index - Specifies the index where the pane will be inserted.
     * @returns {void}
     */ Splitter.prototype.addPane = function(paneProperties, index) {
        var newPane = this.createElement("div");
        newPane = this.addPaneClass(newPane);
        index = index > this.allPanes.length + 1 ? this.allPanes.length : index;
        var paneDetails = {
            size: (0, $3EnZW.isNullOrUndefined)(paneProperties.size) ? "" : paneProperties.size,
            min: (0, $3EnZW.isNullOrUndefined)(paneProperties.min) ? null : paneProperties.min,
            max: (0, $3EnZW.isNullOrUndefined)(paneProperties.max) ? null : paneProperties.max,
            content: (0, $3EnZW.isNullOrUndefined)(paneProperties.content) ? "" : paneProperties.content,
            resizable: (0, $3EnZW.isNullOrUndefined)(paneProperties.resizable) ? true : paneProperties.resizable,
            collapsible: (0, $3EnZW.isNullOrUndefined)(paneProperties.collapsible) ? false : paneProperties.collapsible,
            collapsed: (0, $3EnZW.isNullOrUndefined)(paneProperties.collapsed) ? false : paneProperties.collapsed,
            cssClass: (0, $3EnZW.isNullOrUndefined)(paneProperties.cssClass) ? "" : paneProperties.cssClass
        };
        this.paneSettings.splice(index, 0, paneDetails);
        this.setProperties({
            "paneSettings": this.paneSettings
        }, true);
        if (this.orientation === "Horizontal") {
            this.element.insertBefore(newPane, this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$SPLIT_H_PANE)[index]);
            this.removePaneOrders($7bada17cf2b24fe1$var$SPLIT_H_PANE);
        } else {
            this.element.insertBefore(newPane, this.element.querySelectorAll("." + $7bada17cf2b24fe1$var$SPLIT_V_PANE)[index]);
            this.removePaneOrders($7bada17cf2b24fe1$var$SPLIT_V_PANE);
        }
        this.allPanes.splice(index, 0, newPane);
        this.updatePanes();
        this.setTemplate(this.paneSettings[index].content, newPane);
        this.setCssClass(this.allPanes[index], paneProperties.cssClass);
        this.allPanes[this.allPanes.length - 1].classList.remove($7bada17cf2b24fe1$var$STATIC_PANE);
    };
    /**
     * Allows you to remove the specified pane dynamically by passing its index value.
     *
     * @param { number } index - Specifies the index value to remove the corresponding pane.
     * @returns {void}
     */ Splitter.prototype.removePane = function(index) {
        index = index > this.allPanes.length + 1 ? this.allPanes.length : index;
        var elementClass = this.orientation === "Horizontal" ? $7bada17cf2b24fe1$var$SPLIT_H_PANE : $7bada17cf2b24fe1$var$SPLIT_V_PANE;
        if ((0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll("." + elementClass)[index])) return;
        (0, $4ZDHT.detach)(this.element.querySelectorAll("." + elementClass)[index]);
        this.allPanes.splice(index, 1);
        this.removePaneOrders(elementClass);
        this.updatePanes();
        this.paneSettings.splice(index, 1);
        this.setProperties({
            "paneSettings": this.paneSettings
        }, true);
        if (this.allPanes.length > 0) this.allPanes[this.allPanes.length - 1].classList.remove($7bada17cf2b24fe1$var$STATIC_PANE);
    };
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], Splitter.prototype, "height", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Splitter.prototype, "enableReversePanes", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], Splitter.prototype, "width", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Splitter.prototype, "enablePersistence", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Collection)([], $7bada17cf2b24fe1$export$a84d73855da1a171)
    ], Splitter.prototype, "paneSettings", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)("Horizontal")
    ], Splitter.prototype, "orientation", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Splitter.prototype, "cssClass", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Splitter.prototype, "enabled", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Splitter.prototype, "enableHtmlSanitizer", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Splitter.prototype, "separatorSize", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "beforeSanitizeHtml", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "created", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "resizeStart", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "resizing", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "resizeStop", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "beforeCollapse", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "beforeExpand", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "collapsed", void 0);
    $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.Event)()
    ], Splitter.prototype, "expanded", void 0);
    Splitter = $7bada17cf2b24fe1$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Splitter);
    return Splitter;
}((0, $hQxLN.Component));




parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $89f25b044ddeaaea$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89f25b044ddeaaea$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Specifies the Ajax settings of the File Manager.
 */ var $89f25b044ddeaaea$export$c7d0cd64e9070819 = /** @class */ function(_super) {
    $89f25b044ddeaaea$var$__extends(AjaxSettings, _super);
    function AjaxSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $89f25b044ddeaaea$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AjaxSettings.prototype, "downloadUrl", void 0);
    $89f25b044ddeaaea$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AjaxSettings.prototype, "getImageUrl", void 0);
    $89f25b044ddeaaea$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AjaxSettings.prototype, "uploadUrl", void 0);
    $89f25b044ddeaaea$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AjaxSettings.prototype, "url", void 0);
    return AjaxSettings;
}((0, $3fcxu.ChildProperty));

parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $b165f47ecab2e2f8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b165f47ecab2e2f8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b165f47ecab2e2f8$export$9f62ea2e52cdc15f = [
    {
        field: "name",
        headerText: "Name",
        minWidth: 120,
        template: '<span class="e-fe-text">${name}</span>',
        customAttributes: {
            class: "e-fe-grid-name"
        }
    },
    {
        field: "_fm_modified",
        headerText: "DateModified",
        type: "dateTime",
        format: "MMMM dd, yyyy HH:mm",
        minWidth: 120,
        width: "190"
    },
    {
        field: "size",
        headerText: "Size",
        minWidth: 90,
        width: "110",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        template: (0, $c2qqN.initializeCSPTemplate)(function(data) {
            return '<span class="e-fe-size">' + data.size + "</span>";
        }),
        format: "n2"
    }
];
/**
 * Specifies the grid settings of the File Manager.
 */ var $b165f47ecab2e2f8$export$2414f677b69712c = /** @class */ function(_super) {
    $b165f47ecab2e2f8$var$__extends(DetailsViewSettings, _super);
    function DetailsViewSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $b165f47ecab2e2f8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DetailsViewSettings.prototype, "columnResizing", void 0);
    $b165f47ecab2e2f8$var$__decorate([
        (0, $5rsSz.Property)($b165f47ecab2e2f8$export$9f62ea2e52cdc15f)
    ], DetailsViewSettings.prototype, "columns", void 0);
    return DetailsViewSettings;
}((0, $3fcxu.ChildProperty));

parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $d1b6780e16f65095$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d1b6780e16f65095$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Specifies the navigationpane settings of the File Manager.
 */ var $d1b6780e16f65095$export$246cb6a888617168 = /** @class */ function(_super) {
    $d1b6780e16f65095$var$__extends(NavigationPaneSettings, _super);
    function NavigationPaneSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $d1b6780e16f65095$var$__decorate([
        (0, $5rsSz.Property)("650px")
    ], NavigationPaneSettings.prototype, "maxWidth", void 0);
    $d1b6780e16f65095$var$__decorate([
        (0, $5rsSz.Property)("240px")
    ], NavigationPaneSettings.prototype, "minWidth", void 0);
    $d1b6780e16f65095$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], NavigationPaneSettings.prototype, "visible", void 0);
    $d1b6780e16f65095$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], NavigationPaneSettings.prototype, "sortOrder", void 0);
    return NavigationPaneSettings;
}((0, $3fcxu.ChildProperty));

parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $fdd3737878e30161$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fdd3737878e30161$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Specifies the Search settings of the File Manager.
 */ var $fdd3737878e30161$export$352475af1e1a6201 = /** @class */ function(_super) {
    $fdd3737878e30161$var$__extends(SearchSettings, _super);
    function SearchSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $fdd3737878e30161$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SearchSettings.prototype, "allowSearchOnTyping", void 0);
    $fdd3737878e30161$var$__decorate([
        (0, $5rsSz.Property)("contains")
    ], SearchSettings.prototype, "filterType", void 0);
    $fdd3737878e30161$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], SearchSettings.prototype, "ignoreCase", void 0);
    $fdd3737878e30161$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], SearchSettings.prototype, "placeholder", void 0);
    return SearchSettings;
}((0, $3fcxu.ChildProperty));

parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $dc7b44f9b460d0c8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dc7b44f9b460d0c8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dc7b44f9b460d0c8$export$77de82121f294532 = [
    "NewFolder",
    "Upload",
    "Cut",
    "Copy",
    "Paste",
    "Delete",
    "Download",
    "Rename",
    "SortBy",
    "Refresh",
    "Selection",
    "View",
    "Details"
];
/**
 * Specifies the Toolbar settings of the FileManager.
 */ var $dc7b44f9b460d0c8$export$b468e96770a3e7db = /** @class */ function(_super) {
    $dc7b44f9b460d0c8$var$__extends(ToolbarSettings, _super);
    function ToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)($dc7b44f9b460d0c8$export$77de82121f294532)
    ], ToolbarSettings.prototype, "items", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ToolbarSettings.prototype, "visible", void 0);
    return ToolbarSettings;
}((0, $3fcxu.ChildProperty));
var $dc7b44f9b460d0c8$export$cb67beb212e92bbd = /** @class */ function(_super) {
    $dc7b44f9b460d0c8$var$__extends(ToolbarItem, _super);
    function ToolbarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "id", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "text", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], ToolbarItem.prototype, "width", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "cssClass", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ToolbarItem.prototype, "showAlwaysInPopup", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ToolbarItem.prototype, "disabled", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "prefixIcon", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "suffixIcon", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ToolbarItem.prototype, "visible", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], ToolbarItem.prototype, "overflow", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "template", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("Button")
    ], ToolbarItem.prototype, "type", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("Both")
    ], ToolbarItem.prototype, "showTextOn", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ToolbarItem.prototype, "htmlAttributes", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ToolbarItem.prototype, "tooltipText", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], ToolbarItem.prototype, "align", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)(-1)
    ], ToolbarItem.prototype, "tabIndex", void 0);
    $dc7b44f9b460d0c8$var$__decorate([
        (0, $5rsSz.Property)()
    ], ToolbarItem.prototype, "name", void 0);
    return ToolbarItem;
}((0, $3fcxu.ChildProperty));



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $eAUyT = parcelRequire("eAUyT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $i528u = parcelRequire("i528u");









/**
 * LargeIconsView module
 */ var $4ae4c662e1820e8a$export$455f788c1604ad53 = /** @class */ function() {
    /**
     * Constructor for the LargeIcons module.
     *
     * @param {IFileManager} parent - specifies the parent element.
     * @hidden
     */ function LargeIconsView(parent) {
        this.isInteraction = true;
        this.uploadOperation = false;
        this.count = 0;
        this.isRendered = true;
        this.tapCount = 0;
        this.isSelectAllCalled = false;
        this.isPasteOperation = false;
        this.isInteracted = true;
        this.parent = parent;
        this.element = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$f558f378488ddc5d, this.parent.element);
        (0, $4ZDHT.addClass)([
            this.element
        ], $15a2a1ec4804cfd7$export$aec2fde68eb32201);
        this.addEventListener();
        this.keyConfigs = {
            end: "end",
            home: "home",
            tab: "tab",
            moveDown: "downarrow",
            moveLeft: "leftarrow",
            moveRight: "rightarrow",
            moveUp: "uparrow",
            ctrlEnd: "ctrl+end",
            ctrlHome: "ctrl+home",
            ctrlDown: "ctrl+downarrow",
            ctrlLeft: "ctrl+leftarrow",
            ctrlRight: "ctrl+rightarrow",
            ctrlUp: "ctrl+uparrow",
            shiftEnd: "shift+end",
            shiftHome: "shift+home",
            shiftDown: "shift+downarrow",
            shiftLeft: "shift+leftarrow",
            shiftRight: "shift+rightarrow",
            shiftUp: "shift+uparrow",
            csEnd: "ctrl+shift+end",
            csHome: "ctrl+shift+home",
            csDown: "ctrl+shift+downarrow",
            csLeft: "ctrl+shift+leftarrow",
            csRight: "ctrl+shift+rightarrow",
            csUp: "ctrl+shift+uparrow",
            space: "space",
            ctrlSpace: "ctrl+space",
            shiftSpace: "shift+space",
            csSpace: "ctrl+shift+space",
            ctrlA: "ctrl+a",
            enter: "enter",
            altEnter: "alt+enter",
            esc: "escape",
            del: "delete",
            ctrlX: this.parent.isMac ? "cmd+x" : "ctrl+x",
            ctrlC: this.parent.isMac ? "cmd+c" : "ctrl+c",
            ctrlV: this.parent.isMac ? "cmd+v" : "ctrl+v",
            f2: "f2",
            shiftdel: "shift+delete",
            back: "backspace",
            ctrlD: "ctrl+d"
        };
    }
    LargeIconsView.prototype.render = function(args) {
        this.parent.visitedItem = null;
        this.startItem = null;
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.parent.element);
        if (this.parent.view === "LargeIcons") {
            this.resetMultiSelect();
            this.element.setAttribute("tabindex", "0");
            if (this.listObj) {
                this.unWireEvents();
                this.removeEventListener();
            }
            this.parent.notify($f592513f3f17ead8$export$2aa63067005154ea, {});
            var iconsView = (0, $4ZDHT.select)("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$f558f378488ddc5d, this.parent.element);
            var ul = (0, $4ZDHT.select)("ul", iconsView);
            if (ul) (0, $4ZDHT.remove)(ul);
            this.listObj = {
                ariaAttributes: {
                    itemRole: "option",
                    listRole: "listbox",
                    itemText: "",
                    groupItemRole: "group",
                    wrapperRole: ""
                },
                showIcon: true,
                fields: {
                    text: "name",
                    iconCss: "_fm_icon",
                    imageUrl: "_fm_imageUrl",
                    htmlAttributes: "_fm_htmlAttr"
                },
                sortOrder: this.parent.sortOrder,
                itemCreated: this.onItemCreated.bind(this),
                enableHtmlSanitizer: this.parent.enableHtmlSanitizer
            };
            this.items = [];
            this.items = this.renderList(args);
            if (this.parent.sortComparer && this.parent.sortBy !== "None") this.items = this.allItems = (0, $fc77c1cdc02c8be7$export$de67910a89dbf741).sort(this.items, this.parent.sortBy, this.comparer.bind(this));
            else this.items = this.allItems = (0, $a3d9eadd9d99207c$export$78086a13d87d987d)(this.parent, this.items);
            iconsView.classList.remove($15a2a1ec4804cfd7$export$acfd27c680995d44);
            if (this.parent.enableVirtualization && this.allItems.length > 0) this.parent.virtualizationModule.setUIVirtualization();
            this.listElements = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createListFromJson((0, $4ZDHT.createElement), this.items, this.listObj);
            this.itemList = Array.prototype.slice.call((0, $4ZDHT.selectAll)("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13, this.listElements));
            this.element.appendChild(this.listElements);
            this.listElements.setAttribute("aria-label", "listbox");
            this.preventImgDrag();
            this.createDragObj();
            if (this.itemList.length === 0) {
                var emptyList = this.element.querySelector("." + $15a2a1ec4804cfd7$export$ff283a997e6ca548);
                this.element.removeChild(emptyList);
                (0, $a3d9eadd9d99207c$export$b7ca5bd2fd689a12)(this.parent, this.element, args);
            } else if (this.itemList.length !== 0 && this.element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58)) this.element.removeChild(this.element.querySelector("." + $15a2a1ec4804cfd7$export$ccb33e29d92c9a58));
            if (this.isPasteOperation === true) {
                this.selectItems(this.parent.pasteNodes);
                this.isPasteOperation = false;
            }
            /* istanbul ignore next */ if (this.uploadOperation === true) {
                this.selectItems(this.parent.uploadItem);
                this.parent.setProperties({
                    selectedItems: []
                }, true);
                this.count++;
                if (this.count === this.parent.uploadItem.length) {
                    this.uploadOperation = false;
                    this.parent.uploadItem = [];
                }
            }
            var activeEle = this.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143);
            if (activeEle.length !== 0) this.parent.activeModule = "largeiconsview";
            for(var i = 0; i < activeEle.length; i++)activeEle[i].setAttribute("aria-selected", "true");
            this.element.style.maxHeight = "100%";
            this.getItemCount();
            this.addEventListener();
            this.wireEvents();
            if (this.parent.enableVirtualization && this.allItems.length > 0) {
                this.parent.virtualizationModule.setUlElementHeight();
                this.parent.virtualizationModule.wireScrollEvent(false);
            }
            this.isRendered = true;
            (0, $d4834c37f505aa74$export$95fec50f68454318)(this.parent.element);
            if (this.parent.selectedItems.length) this.checkItem();
        }
    };
    LargeIconsView.prototype.comparer = function(x, y) {
        if (this.parent.sortOrder === "Descending") {
            var z = x;
            x = y;
            y = z;
        }
        return this.parent.sortComparer(x, y);
    };
    LargeIconsView.prototype.preventImgDrag = function() {
        var i = 0;
        while(i < this.itemList.length){
            if (this.itemList[i].querySelector("img")) /* istanbul ignore next */ this.itemList[i].ondragstart = function() {
                return false;
            };
            i++;
        }
    };
    LargeIconsView.prototype.createDragObj = function() {
        var _this = this;
        if (this.listObj) {
            if (this.parent.allowDragAndDrop) {
                if (this.dragObj) this.dragObj.destroy();
                this.dragObj = new (0, $eAUyT.Draggable)(this.listElements, {
                    enableTailMode: true,
                    distance: 5,
                    enableAutoScroll: false,
                    dragTarget: "." + $15a2a1ec4804cfd7$export$b74755a023d92165,
                    helper: this.dragHelper.bind(this),
                    cursorAt: this.parent.dragCursorPosition,
                    dragArea: this.parent.element,
                    dragStop: (0, $a3d9eadd9d99207c$export$202f08d3a6bd576).bind(this, this.parent),
                    drag: (0, $a3d9eadd9d99207c$export$f293f44a7af9215d).bind(this, this.parent),
                    clone: true,
                    dragStart: function(args) {
                        (0, $a3d9eadd9d99207c$export$db131b841f9f6440)(_this.parent, args, _this.dragObj);
                    }
                });
            } else if (this.dragObj && !this.parent.allowDragAndDrop) this.dragObj.destroy();
        }
    };
    LargeIconsView.prototype.dragHelper = function(args) {
        var dragTarget = args.sender.target;
        var dragLi = (0, $4ZDHT.closest)(dragTarget, ".e-list-item");
        if (!dragLi) return null;
        if (dragLi && !dragLi.classList.contains("e-active")) this.setFocus(dragLi);
        var activeEle = this.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143);
        this.parent.activeElements = [];
        this.parent.dragData = [];
        for(var i = 0; i < activeEle.length; i++){
            this.parent.dragData.push(this.getItemObject(activeEle[parseInt(i.toString(), 10)]));
            this.parent.activeElements.push(activeEle[i]);
        }
        (0, $a3d9eadd9d99207c$export$90835e7e06f4e75b)(this.parent, dragLi);
        this.parent.dragPath = this.parent.path;
        (0, $a3d9eadd9d99207c$export$fda104f371357c1e)(this.parent);
        return this.parent.virtualDragElement;
    };
    LargeIconsView.prototype.onDropInit = function(args) {
        if (this.parent.targetModule === this.getModuleName()) {
            var dropLi = (0, $4ZDHT.closest)(args.target, ".e-list-item");
            var cwdData = (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent);
            if (dropLi) {
                var info = this.getItemObject(dropLi);
                this.parent.dropPath = info.isFile ? this.parent.path : (0, $a3d9eadd9d99207c$export$ce41aaed7504a4ce)(this.parent, info, this.parent.path);
                this.parent.dropData = info.isFile ? cwdData : info;
            } else {
                this.parent.dropPath = this.parent.path;
                this.parent.dropData = cwdData;
            }
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the module name.
     * @private
     */ LargeIconsView.prototype.getModuleName = function() {
        return "largeiconsview";
    };
    LargeIconsView.prototype.onItemCreated = function(args) {
        args.item.removeAttribute("aria-level");
        if (!this.parent.showFileExtension && (0, $3EnZW.getValue)("isFile", args.curData)) {
            var textEle = args.item.querySelector("." + $15a2a1ec4804cfd7$export$7080f700b8701d5a);
            var txt = (0, $3EnZW.getValue)("name", args.curData);
            var type = (0, $3EnZW.getValue)("type", args.curData);
            if (txt.indexOf(type) !== -1) textEle.innerHTML = txt.substr(0, txt.length - type.length);
        }
        this.renderCheckbox(args);
        var eventArgs = {
            element: args.item,
            fileDetails: args.curData,
            module: "LargeIconsView"
        };
        this.parent.trigger("fileLoad", eventArgs);
    };
    LargeIconsView.prototype.renderCheckbox = function(args) {
        if (!this.parent.showItemCheckBoxes) return;
        var checkElement = (0, $6a51972c93f30c96$export$1ef36a84bae94342)((0, $4ZDHT.createElement), false, {
            checked: false,
            cssClass: "e-small"
        });
        checkElement.setAttribute("role", "checkbox");
        checkElement.setAttribute("aria-checked", "false");
        checkElement.setAttribute("aria-label", "checkbox");
        args.item.firstElementChild.insertBefore(checkElement, args.item.firstElementChild.childNodes[0]);
    };
    LargeIconsView.prototype.onLayoutChange = function(args) {
        if (this.parent.view === "LargeIcons") {
            this.destroy();
            if (this.parent.enableVirtualization) this.parent.setProperties({
                selectedItems: []
            }, true);
            this.render(args);
            /* istanbul ignore next */ if ((0, $3EnZW.getValue)("name", args) === "layout-change" && this.parent.fileAction === "move" && this.parent.isCut && this.parent.selectedNodes && this.parent.selectedNodes.length !== 0) {
                var indexes = this.getIndexes(this.parent.selectedNodes);
                var length_1 = 0;
                while(length_1 < indexes.length){
                    (0, $a3d9eadd9d99207c$export$7f40c4cb15687f80)(this.itemList[indexes[length_1]]);
                    length_1++;
                }
            }
            var activeEle = this.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143);
            if (activeEle.length !== 0) this.element.focus();
            this.checkItem();
            this.parent.isLayoutChange = false;
        } else this.element.setAttribute("tabindex", "-1");
    };
    LargeIconsView.prototype.checkItem = function() {
        var checkEle = this.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143);
        if (checkEle) {
            var checkLength = 0;
            while(checkLength < checkEle.length){
                this.checkState(checkEle[checkLength], true);
                checkLength++;
            }
        }
    };
    LargeIconsView.prototype.renderList = function(args) {
        var i = 0;
        var items = JSON.parse(JSON.stringify(args.files));
        while(i < items.length){
            var icon = (0, $a3d9eadd9d99207c$export$e40fbc04d72f5340)(items[i]);
            var name_1 = (0, $3EnZW.getValue)("name", items[i]);
            var selected = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, items[i]);
            var className = this.parent.selectedItems && this.parent.selectedItems.indexOf(selected) !== -1 ? $15a2a1ec4804cfd7$export$b74755a023d92165 + " e-active" : $15a2a1ec4804cfd7$export$b74755a023d92165;
            if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(items[i])) className += " " + (0, $a3d9eadd9d99207c$export$e4c8c20b1ca0ec47)(items[i]);
            if (icon === $15a2a1ec4804cfd7$export$a3f7f90e20dcc8e7 && this.parent.showThumbnail && (0, $a3d9eadd9d99207c$export$7121632912d0e323)(items[i])) {
                var imgUrl = (0, $a3d9eadd9d99207c$export$492f76f65bf1bced)(this.parent, items[i]);
                (0, $3EnZW.setValue)("_fm_imageUrl", imgUrl, items[i]);
                (0, $3EnZW.setValue)("_fm_imageAttr", {
                    alt: name_1
                }, items[i]);
            } else (0, $3EnZW.setValue)("_fm_icon", icon, items[i]);
            (0, $3EnZW.setValue)("_fm_htmlAttr", {
                class: className,
                title: name_1
            }, items[i]);
            i++;
        }
        return items;
    };
    LargeIconsView.prototype.onFinalizeEnd = function(args) {
        this.render(args);
    };
    LargeIconsView.prototype.onCreateEnd = function(args) {
        if (this.parent.view !== "LargeIcons") return;
        this.onLayoutChange(args);
        this.clearSelect();
        this.selectItems([
            (0, $3EnZW.getValue)(this.parent.hasId ? "id" : "name", this.parent.createdItem)
        ]);
        this.parent.createdItem = null;
        this.parent.largeiconsviewModule.element.focus();
        this.parent.activeModule = "largeiconsview";
    };
    LargeIconsView.prototype.onSelectedData = function() {
        if (this.parent.activeModule === "largeiconsview") this.updateSelectedData();
    };
    LargeIconsView.prototype.onDeleteInit = function() {
        if (this.parent.activeModule === "largeiconsview") (0, $5703c0df24e3a120$export$bfadae053a633538)(this.parent, this.parent.selectedItems, this.parent.path, "delete");
    };
    /* istanbul ignore next */ LargeIconsView.prototype.onDeleteEnd = function(args) {
        if (this.parent.view !== "LargeIcons") return;
        this.onLayoutChange(args);
        this.parent.setProperties({
            selectedItems: []
        }, true);
        this.clearSelect();
    };
    LargeIconsView.prototype.onRefreshEnd = function(args) {
        if (this.parent.view !== "LargeIcons") return;
        this.onLayoutChange(args);
    };
    LargeIconsView.prototype.onRenameInit = function() {
        if (this.parent.activeModule === "largeiconsview" && this.parent.selectedItems.length === 1) this.updateRenameData();
    };
    LargeIconsView.prototype.onPathChanged = function(args) {
        this.parent.isCut = false;
        /* istanbul ignore next */ if (this.parent.breadcrumbbarModule.searchObj.element.value === "") this.parent.searchedItems = [];
        if (this.parent.view === "LargeIcons") {
            (0, $a3d9eadd9d99207c$export$f9525c32dad03cf2)(this.parent);
            this.parent.setProperties({
                selectedItems: []
            }, true);
            this.onLayoutChange(args);
            if (this.parent.renamedItem) {
                this.clearSelect();
                this.addSelection(this.parent.renamedItem);
            }
        }
    };
    LargeIconsView.prototype.onOpenInit = function(args) {
        if (this.parent.activeModule === "largeiconsview") this.doOpenAction(args.target);
    };
    LargeIconsView.prototype.onHideLayout = function() {
        if (this.parent.view !== "LargeIcons" && this.element) this.element.classList.add($15a2a1ec4804cfd7$export$acfd27c680995d44);
    };
    LargeIconsView.prototype.onSelectAllInit = function() {
        if (this.parent.view === "LargeIcons") {
            this.startItem = this.getFirstItem();
            var lastItem = this.getLastItem();
            var eveArgs = {
                ctrlKey: true,
                shiftKey: true
            };
            this.doSelection(lastItem, eveArgs);
            this.isInteraction = true;
            this.isInteracted = true;
        }
    };
    LargeIconsView.prototype.onClearAllInit = function() {
        if (this.parent.view === "LargeIcons") {
            this.clearSelection();
            this.isInteraction = true;
            this.isInteracted = true;
        }
    };
    LargeIconsView.prototype.onBeforeRequest = function() {
        this.isRendered = false;
    };
    LargeIconsView.prototype.onAfterRequest = function() {
        this.isRendered = true;
    };
    /* istanbul ignore next */ LargeIconsView.prototype.onSearch = function(args) {
        if (this.parent.view === "LargeIcons") {
            this.parent.setProperties({
                selectedItems: []
            }, true);
            this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
            this.parent.searchedItems = args.files;
            this.onLayoutChange(args);
        }
    };
    LargeIconsView.prototype.onLayoutRefresh = function() {
        if (this.parent.view !== "LargeIcons") return;
    };
    LargeIconsView.prototype.onUpdateSelectionData = function() {
        if (this.parent.view !== "LargeIcons") return;
        this.updateSelectedData();
    };
    LargeIconsView.prototype.onPathColumn = function() {
        if (this.parent.view === "LargeIcons" && !(0, $3EnZW.isNullOrUndefined)(this.listObj) && this.parent.breadcrumbbarModule.searchObj.element.value === "" && !this.parent.isFiltered && this.parent.sortBy === "filterPath") {
            this.parent.sortBy = "name";
            this.parent.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
        }
    };
    LargeIconsView.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($f592513f3f17ead8$export$40ce9a35c05f873f, this.onPathColumn);
        this.parent.off($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd);
        this.parent.off($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd);
        this.parent.off($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData);
        this.parent.off($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit);
        this.parent.off($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd);
        this.parent.off($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd);
        this.parent.off($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange);
        this.parent.off($f592513f3f17ead8$export$d76128d007d19019, this.onSearch);
        this.parent.off($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit);
        this.parent.off($f592513f3f17ead8$export$d9e8b42c77102776, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($f592513f3f17ead8$export$5cd299b993c9e318, this.onMethodCall);
        this.parent.off($f592513f3f17ead8$export$6df5a05f342711e3, this.onActionFailure);
        this.parent.off($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit);
        this.parent.off($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$2aa63067005154ea, this.onHideLayout);
        this.parent.off($f592513f3f17ead8$export$8c0e181e1fb07b6c, this.onSelectAllInit);
        this.parent.off($f592513f3f17ead8$export$846f4c514484a0e8, this.onClearAllInit);
        this.parent.off($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData);
        this.parent.off($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.onBeforeRequest);
        this.parent.off($f592513f3f17ead8$export$5af90369d26bf4d0, this.onAfterRequest);
        this.parent.off($f592513f3f17ead8$export$d8057c29295b3f97, this.splitterResizeHandler);
        this.parent.off($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.resizeHandler);
        this.parent.off($f592513f3f17ead8$export$df482b6a24e5bccf, this.onpasteInit);
        this.parent.off($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd);
        this.parent.off($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit);
        this.parent.off($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit);
        this.parent.off($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit);
        this.parent.off($f592513f3f17ead8$export$c8a5c97778a58170, this.onLayoutRefresh);
        this.parent.off($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath);
        this.parent.off($f592513f3f17ead8$export$ed7f9366d0aedd6a, this.onUpdateSelectionData);
        this.parent.off($f592513f3f17ead8$export$cd2e3b33990298ee, this.onPathChanged);
    };
    LargeIconsView.prototype.addEventListener = function() {
        this.parent.on($f592513f3f17ead8$export$40ce9a35c05f873f, this.onPathColumn, this);
        this.parent.on($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd, this);
        this.parent.on($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd, this);
        this.parent.on($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd, this);
        this.parent.on($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData, this);
        this.parent.on($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit, this);
        this.parent.on($f592513f3f17ead8$export$df482b6a24e5bccf, this.onpasteInit, this);
        this.parent.on($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd, this);
        this.parent.on($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange, this);
        this.parent.on($f592513f3f17ead8$export$d76128d007d19019, this.onSearch, this);
        this.parent.on($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit, this);
        this.parent.on($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit, this);
        this.parent.on($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$d9e8b42c77102776, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($f592513f3f17ead8$export$5cd299b993c9e318, this.onMethodCall, this);
        this.parent.on($f592513f3f17ead8$export$6df5a05f342711e3, this.onActionFailure, this);
        this.parent.on($f592513f3f17ead8$export$2aa63067005154ea, this.onHideLayout, this);
        this.parent.on($f592513f3f17ead8$export$8c0e181e1fb07b6c, this.onSelectAllInit, this);
        this.parent.on($f592513f3f17ead8$export$846f4c514484a0e8, this.onClearAllInit, this);
        this.parent.on($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData, this);
        this.parent.on($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.onBeforeRequest, this);
        this.parent.on($f592513f3f17ead8$export$5af90369d26bf4d0, this.onAfterRequest, this);
        this.parent.on($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit, this);
        this.parent.on($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit, this);
        this.parent.on($f592513f3f17ead8$export$d8057c29295b3f97, this.splitterResizeHandler, this);
        this.parent.on($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.resizeHandler, this);
        this.parent.on($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd, this);
        this.parent.on($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit, this);
        this.parent.on($f592513f3f17ead8$export$c8a5c97778a58170, this.onLayoutRefresh, this);
        this.parent.on($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath, this);
        this.parent.on($f592513f3f17ead8$export$ed7f9366d0aedd6a, this.onUpdateSelectionData, this);
        this.parent.on($f592513f3f17ead8$export$cd2e3b33990298ee, this.onPathChanged, this);
    };
    LargeIconsView.prototype.onActionFailure = function() {
        this.isInteraction = true;
        this.isInteracted = true;
    };
    LargeIconsView.prototype.onMenuItemData = function(args) {
        if (this.parent.activeModule === this.getModuleName()) {
            var ele = (0, $4ZDHT.closest)(args.target, "li");
            this.parent.itemData = [
                this.getItemObject(ele)
            ];
        }
    };
    LargeIconsView.prototype.onDetailsInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            if (this.parent.selectedItems.length !== 0) this.updateSelectedData();
            else this.parent.itemData = [
                (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent)
            ];
        }
    };
    LargeIconsView.prototype.onpasteInit = function() {
        if (this.parent.activeModule === this.getModuleName()) this.parent.itemData = this.parent.folderPath === "" ? [
            (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this.parent)
        ] : [
            this.getItemObject((0, $4ZDHT.select)(".e-active", this.element))
        ];
    };
    LargeIconsView.prototype.oncutCopyInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            var activeEle = this.element.querySelectorAll("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143);
            this.parent.activeRecords = [];
            this.parent.activeElements = [];
            for(var i = 0; i < activeEle.length; i++){
                this.parent.activeElements.push(activeEle[i]);
                this.parent.activeRecords.push(this.getItemObject(activeEle[i]));
            }
        }
    };
    LargeIconsView.prototype.onpasteEnd = function(args) {
        if (this.parent.view === "LargeIcons") {
            this.isPasteOperation = true;
            if (this.parent.path === this.parent.destinationPath || this.parent.path === (0, $a3d9eadd9d99207c$export$386ecaf3f3c304a2)(this.parent, args) || this.parent.hasId) this.onPathChanged(args);
        }
    };
    LargeIconsView.prototype.onDropPath = function(args) {
        if (this.parent.view === "LargeIcons") {
            this.isPasteOperation = true;
            this.onPathChanged(args);
        }
    };
    LargeIconsView.prototype.onPropertyChanged = function(e) {
        var currentSelected;
        if (e.module !== this.getModuleName() && e.module !== "common") return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "allowDragAndDrop":
                    this.createDragObj();
                    break;
                case "selectedItems":
                    this.isInteraction = false;
                    this.isInteracted = false;
                    currentSelected = (0, $3EnZW.isNullOrUndefined)(this.parent.selectedItems) ? [] : this.parent.selectedItems.slice(0);
                    currentSelected = this.parent.allowMultiSelection ? currentSelected : currentSelected.slice(currentSelected.length - 1);
                    this.parent.setProperties({
                        selectedItems: []
                    }, true);
                    this.onClearAllInit();
                    if (currentSelected.length) this.selectItems(currentSelected);
                    this.parent.setProperties({
                        selectedItems: this.parent.selectedItems
                    }, true);
                    this.isInteraction = true;
                    this.isInteracted = true;
                    break;
                case "showThumbnail":
                    (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this.parent);
                    break;
                case "showFileExtension":
                    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
                    break;
                case "showHiddenItems":
                    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
                    break;
                case "allowMultiSelection":
                case "showItemCheckBoxes":
                    if (this.parent.view !== "LargeIcons") break;
                    (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this.parent);
                    break;
                case "view":
                    (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this.parent, "LargeIcons");
                    break;
            }
        }
    };
    LargeIconsView.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        if (this.listObj) this.unWireEvents();
        this.startItem = null;
        this.listElements = null;
    };
    LargeIconsView.prototype.wireEvents = function() {
        this.wireClickEvent(true);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keyup"
        });
        this.keyboardDownModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keydownActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
        (0, $aqzbR.EventHandler).add(this.element, "mouseover", this.onMouseOver, this);
    };
    LargeIconsView.prototype.unWireEvents = function() {
        this.wireClickEvent(false);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseover", this.onMouseOver);
        this.keyboardModule.destroy();
        this.keyboardDownModule.destroy();
    };
    /* istanbul ignore next */ LargeIconsView.prototype.onMouseOver = function(e) {
        var targetEle = (0, $4ZDHT.closest)(e.target, ".e-list-item");
        (0, $a3d9eadd9d99207c$export$f9525c32dad03cf2)(this.parent, "hover");
        if (targetEle !== null) targetEle.classList.add($15a2a1ec4804cfd7$export$9d358706ccac3727);
    };
    LargeIconsView.prototype.wireClickEvent = function(toBind) {
        var _this = this;
        if (toBind) this.clickObj = new (0, $i528u.Touch)(this.element, {
            tap: function(eve) {
                if (_this.parent.isDevice) {
                    _this.tapCount = eve.tapCount;
                    _this.tapEvent = eve;
                    setTimeout(function() {
                        if (_this.tapCount > 0) _this.doTapAction(_this.tapEvent);
                        _this.tapCount = 0;
                    }, 350);
                } else if (eve.tapCount === 2 && eve.originalEvent.which !== 3) _this.dblClickHandler(eve);
                else _this.clickHandler(eve);
            },
            tapHold: function(e) {
                if (_this.parent.isDevice) {
                    _this.multiSelect = _this.parent.allowMultiSelection ? true : false;
                    if (_this.parent.allowMultiSelection) (0, $4ZDHT.addClass)([
                        _this.parent.element
                    ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
                    _this.clickHandler(e);
                }
            }
        });
        else if (this.clickObj) this.clickObj.destroy();
    };
    LargeIconsView.prototype.doTapAction = function(eve) {
        var target = eve.originalEvent.target;
        var item = (0, $4ZDHT.closest)(target, "." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13);
        if (this.multiSelect || target.classList.contains($15a2a1ec4804cfd7$export$ff283a997e6ca548) || (0, $3EnZW.isNullOrUndefined)(item)) this.clickHandler(eve);
        else {
            this.parent.isFile = false;
            this.updateType(item);
            if (!this.parent.isFile) this.dblClickHandler(eve);
            else if (eve.tapCount === 2) {
                this.clickHandler(eve);
                this.dblClickHandler(eve);
            } else this.clickHandler(eve);
        }
    };
    LargeIconsView.prototype.clickHandler = function(e) {
        var target = e.originalEvent.target;
        (0, $a3d9eadd9d99207c$export$f9525c32dad03cf2)(this.parent, "hover");
        this.doSelection(target, e.originalEvent);
        this.parent.activeModule = "largeiconsview";
    };
    /**
     *
     * @param {Element} target - specifies the target element.
     * @param {TouchEventArgs | MouseEventArgs | KeyboardEventArgs} e - specifies event arguements.
     * @returns {void}
     * @hidden
     */ LargeIconsView.prototype.doSelection = function(target, e) {
        var item = (0, $4ZDHT.closest)(target, "." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13);
        var cList = target.classList;
        this.parent.isFile = false;
        var action = "select";
        if (e.which === 3 && !(0, $3EnZW.isNullOrUndefined)(item) && item.classList.contains($15a2a1ec4804cfd7$export$2b35adb71b3f6143)) {
            this.addActive(item);
            this.updateType(item);
            return;
        } else if (!(0, $3EnZW.isNullOrUndefined)(item)) {
            if (this.parent.allowMultiSelection && item.classList.contains($15a2a1ec4804cfd7$export$2b35adb71b3f6143) && (e.ctrlKey || target.classList.contains($15a2a1ec4804cfd7$export$c953d1cd180adfae))) action = "unselect";
            if (e.ctrlKey && e.shiftKey) this.isSelectAllCalled = true;
            var fileSelectionArgs = this.triggerSelection(action, item);
            if (fileSelectionArgs.cancel !== true) {
                if ((!this.parent.allowMultiSelection || !this.multiSelect && e && !e.ctrlKey) && !cList.contains($15a2a1ec4804cfd7$export$42d32ecba327b593)) {
                    this.updateType(item);
                    this.clearSelect();
                }
                if (this.parent.allowMultiSelection && e.shiftKey) {
                    if (!(e && e.ctrlKey)) this.clearSelect();
                    if (!this.startItem) this.startItem = item;
                    var startIndex = this.itemList.indexOf(this.startItem);
                    var endIndex = this.itemList.indexOf(item);
                    if (startIndex > endIndex) for(var i = startIndex; i >= endIndex; i--)this.addActive(this.itemList[i]);
                    else for(var i = startIndex; i <= endIndex; i++)this.addActive(this.itemList[i]);
                    this.addFocus(this.itemList[endIndex]);
                } else {
                    this.startItem = item;
                    if (this.parent.allowMultiSelection && item.classList.contains($15a2a1ec4804cfd7$export$2b35adb71b3f6143)) this.removeActive(item);
                    else this.addActive(item);
                    this.addFocus(item);
                }
                if (this.parent.selectedItems.length === 0) this.resetMultiSelect();
                this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
                this.triggerSelect(action, item);
            }
        } else {
            if (this.parent.selectedItems.length === this.itemList.length) this.isSelectAllCalled = true;
            this.clearSelection();
        }
        if (!(0, $3EnZW.isNullOrUndefined)(item)) {
            this.isSelectAllCalled = false;
            this.updateType(item);
        }
    };
    LargeIconsView.prototype.dblClickHandler = function(e) {
        this.parent.activeModule = "largeiconsview";
        var target = e.originalEvent.target;
        this.doOpenAction(target);
    };
    LargeIconsView.prototype.clearSelection = function() {
        this.clearSelect();
        this.resetMultiSelect();
        this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
    };
    LargeIconsView.prototype.resetMultiSelect = function() {
        this.multiSelect = false;
        (0, $4ZDHT.removeClass)([
            this.parent.element
        ], $15a2a1ec4804cfd7$export$8efc9eeb05d66b6);
    };
    LargeIconsView.prototype.doOpenAction = function(target) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(target)) return;
        var item = (0, $4ZDHT.closest)(target, "." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13);
        this.parent.isFile = false;
        if (!(0, $3EnZW.isNullOrUndefined)(item)) {
            this.updateType(item);
            var details_1 = this.getItemObject(item);
            if (!(0, $a3d9eadd9d99207c$export$7121632912d0e323)(details_1)) {
                (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, details_1, $f592513f3f17ead8$export$826a768f8295bc53);
                return;
            }
            var eventArgs = {
                cancel: false,
                fileDetails: details_1,
                module: "LargeIconsView"
            };
            this.parent.trigger("fileOpen", eventArgs, function(fileOpenArgs) {
                if (!fileOpenArgs.cancel) {
                    var text = (0, $3EnZW.getValue)("name", details_1);
                    if (!_this.parent.isFile) {
                        var val = _this.parent.breadcrumbbarModule.searchObj.element.value;
                        if (val === "" && !_this.parent.isFiltered) {
                            var id = (0, $3EnZW.getValue)("id", details_1);
                            _this.parent.oldPath = _this.parent.path;
                            var newPath = _this.parent.path + ((0, $3EnZW.isNullOrUndefined)(id) ? text : id) + "/";
                            _this.parent.setProperties({
                                path: newPath
                            }, true);
                            _this.parent.pathNames.push(text);
                            _this.parent.pathId.push((0, $3EnZW.getValue)("_fm_id", details_1));
                            _this.parent.itemData = [
                                details_1
                            ];
                            (0, $a3d9eadd9d99207c$export$d42fb38e7fbe6740)(_this.parent);
                        } else (0, $a3d9eadd9d99207c$export$d60e3393d26bdbb4)(_this.parent, details_1);
                        _this.parent.isFiltered = false;
                        _this.parent.setProperties({
                            selectedItems: []
                        }, true);
                    } else {
                        var icon = (0, $a3d9eadd9d99207c$export$e40fbc04d72f5340)(details_1);
                        if (icon === $15a2a1ec4804cfd7$export$a3f7f90e20dcc8e7) {
                            var imgUrl = (0, $a3d9eadd9d99207c$export$492f76f65bf1bced)(_this.parent, details_1);
                            (0, $1ded0ca663b14865$export$a5bbeff43904cfce)(_this.parent, text, imgUrl);
                        }
                    }
                }
            });
        }
    };
    LargeIconsView.prototype.updateType = function(item) {
        var folder = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$d31d8fac97169a4b, item);
        this.parent.isFile = (0, $3EnZW.isNullOrUndefined)(folder) ? true : false;
    };
    /* istanbul ignore next */ LargeIconsView.prototype.keydownActionHandler = function(e) {
        if (!this.isRendered) return;
        switch(e.action){
            case "end":
            case "home":
            case "moveDown":
            case "moveLeft":
            case "moveRight":
            case "moveUp":
            case "ctrlEnd":
            case "shiftEnd":
            case "csEnd":
            case "ctrlHome":
            case "shiftHome":
            case "csHome":
            case "ctrlDown":
            case "shiftDown":
            case "csDown":
            case "ctrlLeft":
            case "shiftLeft":
            case "csLeft":
            case "ctrlRight":
            case "shiftRight":
            case "csRight":
            case "space":
            case "ctrlSpace":
            case "shiftSpace":
            case "csSpace":
            case "ctrlA":
            case "enter":
            case "altEnter":
            case "esc":
            case "del":
            case "shiftdel":
            case "ctrlC":
            case "ctrlV":
            case "ctrlX":
            case "f2":
            case "ctrlD":
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    /* istanbul ignore next */ LargeIconsView.prototype.keyActionHandler = function(e) {
        var _this = this;
        if (!this.isRendered) return;
        var fItem = this.getFocusedItem();
        var firstItem = this.getFirstItem();
        var lastItem = this.getLastItem();
        switch(e.action){
            case "end":
                if (this.parent.enableVirtualization) {
                    this.clearSelect();
                    this.element.firstElementChild.scrollTo(0, this.element.firstElementChild.scrollHeight);
                    setTimeout(function() {
                        _this.navigateItem(_this.itemList[_this.itemList.length - 1]);
                    }, 10);
                } else this.navigateItem(lastItem);
                break;
            case "home":
                if (this.parent.enableVirtualization) {
                    this.clearSelect();
                    this.element.firstElementChild.scrollTop = 0;
                    setTimeout(function() {
                        _this.navigateItem(_this.itemList[0]);
                    }, 10);
                } else this.navigateItem(firstItem);
                break;
            case "tab":
                if (!(0, $3EnZW.isNullOrUndefined)(fItem)) this.addFocus(fItem);
                else if (!(0, $3EnZW.isNullOrUndefined)(firstItem)) this.addFocus(firstItem);
                break;
            case "moveDown":
                this.navigateDown(fItem, true);
                break;
            case "moveLeft":
                this.navigateRight(fItem, false);
                break;
            case "moveRight":
                this.navigateRight(fItem, true);
                break;
            case "moveUp":
                this.navigateDown(fItem, false);
                break;
            case "ctrlEnd":
            case "shiftEnd":
            case "csEnd":
                this.csEndKey(lastItem, e);
                break;
            case "ctrlHome":
            case "shiftHome":
            case "csHome":
                this.csHomeKey(firstItem, e);
                break;
            case "ctrlDown":
            case "shiftDown":
            case "csDown":
                this.csDownKey(fItem, e);
                break;
            case "ctrlLeft":
            case "shiftLeft":
            case "csLeft":
                this.csLeftKey(fItem, e);
                break;
            case "ctrlRight":
            case "shiftRight":
            case "csRight":
                this.csRightKey(fItem, e);
                break;
            case "ctrlUp":
            case "shiftUp":
            case "csUp":
                this.csUpKey(fItem, e);
                break;
            case "space":
                this.spaceKey(fItem);
                break;
            case "ctrlSpace":
            case "shiftSpace":
            case "csSpace":
                if (!(0, $3EnZW.isNullOrUndefined)(fItem)) this.doSelection(fItem, e);
                break;
            case "ctrlA":
                this.ctrlAKey(firstItem, lastItem);
                break;
            case "enter":
                this.doOpenAction(this.parent.visitedItem ? this.parent.visitedItem : this.getVisitedItem());
                break;
            case "altEnter":
                this.parent.notify($f592513f3f17ead8$export$d41cfdb8d87b5bef, {});
                (0, $5703c0df24e3a120$export$1b969bdfbc184d40)(this.parent, this.parent.selectedItems, this.parent.path, "details");
                break;
            case "esc":
                (0, $a3d9eadd9d99207c$export$931affad7351dd89)(this.parent);
                break;
            case "del":
            case "shiftdel":
                this.performDelete();
                break;
            case "ctrlC":
                (0, $a3d9eadd9d99207c$export$6738b3634be42910)(this.parent);
                break;
            case "ctrlV":
                this.parent.folderPath = "";
                (0, $a3d9eadd9d99207c$export$5b201a757191240e)(this.parent);
                break;
            case "ctrlX":
                (0, $a3d9eadd9d99207c$export$3e9460fe0b724f5e)(this.parent);
                break;
            case "f2":
                this.performRename();
                break;
            case "ctrlD":
                this.doDownload();
                break;
            case "back":
                this.parent.traverseBackward();
                break;
        }
    };
    LargeIconsView.prototype.doDownload = function() {
        this.updateSelectedData();
        (0, $a3d9eadd9d99207c$export$c986efa34c53294)(this.parent);
    };
    LargeIconsView.prototype.performDelete = function() {
        if (this.parent.selectedItems && this.parent.selectedItems.length > 0) {
            this.updateSelectedData();
            var data = this.parent.itemData;
            for(var i = 0; i < data.length; i++)if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(data[i])) {
                (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, data[i], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                return;
            }
            (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this.parent, "Delete");
        }
    };
    LargeIconsView.prototype.performRename = function() {
        if (this.parent.selectedItems.length === 1) {
            this.updateRenameData();
            (0, $a3d9eadd9d99207c$export$d52c45268ea880af)(this.parent);
        }
    };
    LargeIconsView.prototype.updateRenameData = function() {
        var item = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13 + "." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143, this.element);
        var data = this.getItemObject(item);
        (0, $a3d9eadd9d99207c$export$f3fb02da958b835d)(this.parent, data);
    };
    LargeIconsView.prototype.getVisitedItem = function() {
        var item = this.parent.selectedItems[this.parent.selectedItems.length - 1];
        var indexes = this.getIndexes([
            item
        ], this.parent.hasId);
        return this.itemList[indexes[0]];
    };
    LargeIconsView.prototype.getFocusedItem = function() {
        return (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13 + "." + $15a2a1ec4804cfd7$export$82de3c1c31c751e2, this.element);
    };
    LargeIconsView.prototype.getActiveItem = function() {
        return (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13 + "." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143, this.element);
    };
    LargeIconsView.prototype.getFirstItem = function() {
        return this.itemList[0];
    };
    LargeIconsView.prototype.getLastItem = function() {
        return this.itemList[this.itemList.length - 1];
    };
    LargeIconsView.prototype.navigateItem = function(item) {
        this.setFocus(item);
    };
    LargeIconsView.prototype.navigateDown = function(fItem, isTowards) {
        var nItem = this.getNextItem(fItem, isTowards, this.perRow);
        this.setFocus(nItem);
    };
    LargeIconsView.prototype.navigateRight = function(fItem, isTowards) {
        var nItem = this.getNextItem(fItem, isTowards);
        this.setFocus(nItem);
    };
    LargeIconsView.prototype.getNextItem = function(li, isTowards, perRow) {
        if ((0, $3EnZW.isNullOrUndefined)(li)) return this.getFocusedItem() || this.getActiveItem() || this.getFirstItem();
        var index = this.itemList.indexOf(li);
        var nextItem;
        do {
            if (isTowards) index = perRow ? index + perRow : index + 1;
            else index = perRow ? index - perRow : index - 1;
            nextItem = this.itemList[index];
            if (this.parent.enableVirtualization && (0, $3EnZW.isNullOrUndefined)(nextItem)) {
                var marginValue = parseInt(window.getComputedStyle(this.itemList[0]).getPropertyValue("margin-top"), 10) + parseInt(window.getComputedStyle(this.itemList[0]).getPropertyValue("margin-bottom"), 10);
                var scrollHeight = this.itemList[0].getBoundingClientRect().height + marginValue;
                this.element.firstElementChild.scrollTo(this.element.firstElementChild.scrollTop, this.element.firstElementChild.scrollTop + scrollHeight);
            }
            if ((0, $3EnZW.isNullOrUndefined)(nextItem)) return li;
        }while (!(0, $4ZDHT.isVisible)(nextItem));
        return nextItem;
    };
    LargeIconsView.prototype.setFocus = function(nextItem) {
        if (!(0, $3EnZW.isNullOrUndefined)(nextItem)) {
            var fileSelectionArgs = this.triggerSelection("select", nextItem);
            if (fileSelectionArgs.cancel !== true) {
                this.startItem = nextItem;
                this.clearSelect();
                this.addActive(nextItem);
                this.addFocus(nextItem);
                this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
                this.triggerSelect("select", nextItem);
            }
        }
    };
    LargeIconsView.prototype.spaceKey = function(fItem) {
        if (!(0, $3EnZW.isNullOrUndefined)(fItem) && !fItem.classList.contains($15a2a1ec4804cfd7$export$2b35adb71b3f6143)) {
            var fileSelectionArgs = this.triggerSelection("select", fItem);
            if (fileSelectionArgs.cancel !== true) {
                this.addActive(fItem);
                this.parent.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
                this.triggerSelect("select", fItem);
            }
        }
    };
    LargeIconsView.prototype.ctrlAKey = function(firstItem, lastItem) {
        if (this.parent.allowMultiSelection && !(0, $3EnZW.isNullOrUndefined)(firstItem)) {
            this.startItem = firstItem;
            var eveArgs = {
                ctrlKey: true,
                shiftKey: true
            };
            var liParent = this.element.querySelector("." + $15a2a1ec4804cfd7$export$ff283a997e6ca548);
            var liScrPos = liParent.scrollTop;
            var getCurFocusedItem = this.getFocusedItem();
            this.doSelection(lastItem, eveArgs);
            liParent.scrollTop = liScrPos;
            if (!(0, $3EnZW.isNullOrUndefined)(getCurFocusedItem)) this.addFocus(getCurFocusedItem);
        }
    };
    LargeIconsView.prototype.csEndKey = function(lastItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateItem(lastItem);
        else if (!(0, $3EnZW.isNullOrUndefined)(lastItem)) {
            if (e.action === "ctrlEnd") this.addFocus(lastItem);
            else this.doSelection(lastItem, e);
        }
    };
    LargeIconsView.prototype.csHomeKey = function(firstItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateItem(firstItem);
        else if (!(0, $3EnZW.isNullOrUndefined)(firstItem)) {
            if (e.action === "ctrlHome") this.addFocus(firstItem);
            else this.doSelection(firstItem, e);
        }
    };
    LargeIconsView.prototype.csDownKey = function(fItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateDown(fItem, true);
        else {
            var dItem = this.getNextItem(fItem, true, this.perRow);
            if (!(0, $3EnZW.isNullOrUndefined)(dItem)) {
                if (e.action === "ctrlDown") this.addFocus(dItem);
                else this.doSelection(dItem, e);
            }
        }
    };
    LargeIconsView.prototype.csLeftKey = function(fItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateRight(fItem, false);
        else {
            var lItem = this.getNextItem(fItem, false);
            if (!(0, $3EnZW.isNullOrUndefined)(lItem)) {
                if (e.action === "ctrlLeft") this.addFocus(lItem);
                else this.doSelection(lItem, e);
            }
        }
    };
    LargeIconsView.prototype.csRightKey = function(fItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateRight(fItem, true);
        else {
            var rItem = this.getNextItem(fItem, true);
            if (!(0, $3EnZW.isNullOrUndefined)(rItem)) {
                if (e.action === "ctrlRight") this.addFocus(rItem);
                else this.doSelection(rItem, e);
            }
        }
    };
    LargeIconsView.prototype.csUpKey = function(fItem, e) {
        if (!this.parent.allowMultiSelection) this.navigateDown(fItem, false);
        else {
            var uItem = this.getNextItem(fItem, false, this.perRow);
            if (!(0, $3EnZW.isNullOrUndefined)(uItem)) {
                if (e.action === "ctrlUp") this.addFocus(uItem);
                else this.doSelection(uItem, e);
            }
        }
    };
    LargeIconsView.prototype.addActive = function(nextItem) {
        if (!(0, $3EnZW.isNullOrUndefined)(nextItem)) {
            if (!nextItem.classList.contains($15a2a1ec4804cfd7$export$2b35adb71b3f6143)) {
                this.parent.selectedItems.push(this.getDataName(nextItem));
                this.parent.setProperties({
                    selectedItems: this.parent.selectedItems
                }, true);
                (0, $4ZDHT.addClass)([
                    nextItem
                ], [
                    $15a2a1ec4804cfd7$export$2b35adb71b3f6143
                ]);
                nextItem.setAttribute("aria-selected", "true");
                this.checkState(nextItem, true);
            }
            this.parent.visitedItem = nextItem;
        }
    };
    LargeIconsView.prototype.removeActive = function(preItem) {
        if (!(0, $3EnZW.isNullOrUndefined)(preItem)) {
            (0, $4ZDHT.removeClass)([
                preItem
            ], [
                $15a2a1ec4804cfd7$export$2b35adb71b3f6143
            ]);
            if (this.parent.allowMultiSelection) preItem.setAttribute("aria-selected", "false");
            else preItem.removeAttribute("aria-selected");
            this.checkState(preItem, false);
            var index = this.parent.selectedItems.indexOf(this.getDataName(preItem));
            if (index > -1) {
                this.parent.selectedItems.splice(index, 1);
                this.parent.setProperties({
                    selectedItems: this.parent.selectedItems
                }, true);
            }
            this.parent.visitedItem = null;
        }
    };
    LargeIconsView.prototype.getDataName = function(item) {
        var data = this.getItemObject(item);
        return (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, data);
    };
    LargeIconsView.prototype.addFocus = function(item) {
        this.element.setAttribute("tabindex", "-1");
        var fItem = this.getFocusedItem();
        if (fItem) {
            fItem.removeAttribute("tabindex");
            (0, $4ZDHT.removeClass)([
                fItem
            ], [
                $15a2a1ec4804cfd7$export$82de3c1c31c751e2
            ]);
        }
        (0, $4ZDHT.addClass)([
            item
        ], [
            $15a2a1ec4804cfd7$export$82de3c1c31c751e2
        ]);
        item.setAttribute("tabindex", "0");
        item.focus();
    };
    LargeIconsView.prototype.checkState = function(item, toCheck) {
        if (!this.parent.showItemCheckBoxes) return;
        var checkEle = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$42d32ecba327b593, item);
        if ((0, $3EnZW.isNullOrUndefined)(checkEle)) return;
        if (toCheck) {
            if (!checkEle.classList.contains($15a2a1ec4804cfd7$export$c953d1cd180adfae)) {
                (0, $4ZDHT.addClass)([
                    checkEle
                ], $15a2a1ec4804cfd7$export$c953d1cd180adfae);
                (0, $4ZDHT.closest)(checkEle, "." + $15a2a1ec4804cfd7$export$fb41b8a6ed371c7d).setAttribute("aria-checked", "true");
            }
        } else if (checkEle.classList.contains($15a2a1ec4804cfd7$export$c953d1cd180adfae)) {
            (0, $4ZDHT.removeClass)([
                checkEle
            ], $15a2a1ec4804cfd7$export$c953d1cd180adfae);
            (0, $4ZDHT.closest)(checkEle, "." + $15a2a1ec4804cfd7$export$fb41b8a6ed371c7d).setAttribute("aria-checked", "false");
        }
    };
    LargeIconsView.prototype.clearSelect = function() {
        var eles = Array.prototype.slice.call((0, $4ZDHT.selectAll)("." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143, this.listElements));
        var fileSelectionArgs;
        if (eles.length !== 0) {
            fileSelectionArgs = this.triggerSelection("unselect", eles[0]);
            if (fileSelectionArgs.cancel !== true) for(var i = 0, len = eles.length; i < len; i++)this.removeActive(eles[i]);
            this.triggerSelect("unselect", eles[0]);
        }
    };
    LargeIconsView.prototype.resizeHandler = function() {
        this.getItemCount();
    };
    LargeIconsView.prototype.splitterResizeHandler = function() {
        this.getItemCount();
    };
    LargeIconsView.prototype.getItemCount = function() {
        var perRow = 1;
        if (this.itemList) for(var i = 0, len = this.itemList.length - 1; i < len; i++){
            if (this.itemList[i].getBoundingClientRect().top === this.itemList[i + 1].getBoundingClientRect().top) perRow++;
            else break;
        }
        this.perRow = perRow;
    };
    LargeIconsView.prototype.triggerSelection = function(action, item) {
        var data = [];
        if (this.isSelectAllCalled) for(var i = 0, len = this.itemList.length; i < len; i++)data[i] = this.getItemObject(this.itemList[i]);
        else data[0] = this.getItemObject(item);
        var eventArgs = {
            action: action,
            fileDetails: data.length > 1 ? data : data[0],
            isInteracted: this.isInteraction,
            cancel: false,
            target: this.isSelectAllCalled ? null : item
        };
        this.parent.trigger("fileSelection", eventArgs);
        this.isInteraction = true;
        return eventArgs;
    };
    LargeIconsView.prototype.triggerSelect = function(action, item) {
        var data = [];
        if (this.isSelectAllCalled) {
            for(var i = 0, len = this.itemList.length; i < len; i++)data[i] = this.getItemObject(this.itemList[i]);
            this.isSelectAllCalled = false;
        } else data[0] = this.getItemObject(item);
        this.parent.visitedData = data.length > 1 ? data[data.length - 1] : data[0];
        var eventArgs = {
            action: action,
            fileDetails: data.length > 1 ? data : data[0],
            isInteracted: this.isInteracted
        };
        this.parent.trigger("fileSelect", eventArgs);
        this.isInteracted = true;
    };
    LargeIconsView.prototype.selectItems = function(items) {
        var indexes = this.getIndexes(items, this.parent.hasId);
        for(var j = 0, len = indexes.length; j < len; j++){
            var eveArgs = {
                ctrlKey: true,
                shiftKey: false
            };
            this.doSelection(this.itemList[indexes[j]], eveArgs);
        }
    };
    LargeIconsView.prototype.getIndexes = function(items, byId) {
        var indexes = [];
        var filter = byId ? "id" : "name";
        for(var i = 0, len = this.items.length; i < len; i++)if (items.indexOf((0, $3EnZW.getValue)(filter, this.items[i])) !== -1) indexes.push(i);
        return indexes;
    };
    LargeIconsView.prototype.getItemObject = function(item) {
        var index = this.itemList.indexOf(item);
        return this.items[index];
    };
    LargeIconsView.prototype.addSelection = function(data) {
        var resultData = [];
        if (this.parent.hasId) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.items).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("id", "equal", this.parent.renamedId, false));
        else {
            var newData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.items).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("name", "equal", (0, $3EnZW.getValue)("name", data), false));
            if (newData.length > 0) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(newData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("filterPath", "equal", this.parent.filterPath, false));
        }
        if (resultData.length > 0) {
            var index = this.items.indexOf(resultData[0]);
            var eveArgs = {
                ctrlKey: true,
                shiftKey: false
            };
            this.doSelection(this.itemList[index], eveArgs);
        }
    };
    LargeIconsView.prototype.updateSelectedData = function() {
        var data = [];
        var items = (0, $4ZDHT.selectAll)("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13 + "." + $15a2a1ec4804cfd7$export$2b35adb71b3f6143, this.element);
        for(var i = 0; i < items.length; i++)data[i] = this.getItemObject(items[i]);
        this.parent.itemData = data;
    };
    LargeIconsView.prototype.onMethodCall = function(args) {
        if (this.parent.view !== "LargeIcons") return;
        var action = (0, $3EnZW.getValue)("action", args);
        switch(action){
            case "deleteFiles":
                this.deleteFiles((0, $3EnZW.getValue)("ids", args));
                break;
            case "downloadFiles":
                this.downloadFiles((0, $3EnZW.getValue)("ids", args));
                break;
            case "openFile":
                this.openFile((0, $3EnZW.getValue)("id", args));
                break;
            case "renameFile":
                this.isInteraction = false;
                this.isInteracted = false;
                this.renameFile((0, $3EnZW.getValue)("id", args), (0, $3EnZW.getValue)("newName", args));
                break;
            case "createFolder":
                this.isInteraction = false;
                this.isInteracted = false;
                break;
            case "clearSelection":
                this.isInteraction = false;
                this.isInteracted = false;
                this.onClearAllInit();
                break;
            case "selectAll":
                this.isInteraction = false;
                this.isInteracted = false;
                this.onSelectAllInit();
                break;
        }
    };
    LargeIconsView.prototype.getItemsIndex = function(items) {
        var indexes = [];
        var isFilter = this.parent.breadcrumbbarModule.searchObj.element.value !== "" || this.parent.isFiltered ? true : false;
        var filterName = this.parent.hasId ? "id" : "name";
        if (this.parent.hasId || !isFilter) {
            for(var i = 0, len = this.items.length; i < len; i++)if (items.indexOf((0, $3EnZW.getValue)(filterName, this.items[i])) !== -1) indexes.push(i);
        } else for(var i = 0, len = this.items.length; i < len; i++){
            var name_2 = (0, $3EnZW.getValue)("filterPath", this.items[i]) + (0, $3EnZW.getValue)("name", this.items[i]);
            if (items.indexOf(name_2) !== -1 || items.indexOf((0, $3EnZW.getValue)(filterName, this.items[i])) !== -1) indexes.push(i);
        }
        return indexes;
    };
    LargeIconsView.prototype.deleteFiles = function(ids) {
        this.parent.activeModule = "largeiconsview";
        if ((0, $3EnZW.isNullOrUndefined)(ids)) {
            this.performDelete();
            return;
        }
        var indexes = this.getItemsIndex(ids);
        if (indexes.length === 0) return;
        var data = [];
        var newIds = [];
        for(var i = 0; i < indexes.length; i++){
            data[i] = this.items[indexes[i]];
            newIds[i] = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, data[i]);
        }
        (0, $a3d9eadd9d99207c$export$c0b03dfe5656b20c)(this.parent, data, newIds);
    };
    LargeIconsView.prototype.downloadFiles = function(ids) {
        if ((0, $3EnZW.isNullOrUndefined)(ids)) {
            this.doDownload();
            return;
        }
        var index = this.getItemsIndex(ids);
        if (index.length === 0) return;
        var data = [];
        var newIds = [];
        for(var i = 0; i < index.length; i++){
            data[i] = this.items[index[i]];
            newIds[i] = (0, $a3d9eadd9d99207c$export$31330438f6059b08)(this.parent, data[i]);
        }
        (0, $a3d9eadd9d99207c$export$5ff022e5f248fa5e)(this.parent, data, newIds);
    };
    LargeIconsView.prototype.openFile = function(id) {
        if ((0, $3EnZW.isNullOrUndefined)(id)) return;
        var indexes = this.getItemsIndex([
            id
        ]);
        if (indexes.length > 0) this.doOpenAction(this.itemList[indexes[0]]);
    };
    LargeIconsView.prototype.renameFile = function(id, name) {
        this.parent.activeModule = "largeiconsview";
        if ((0, $3EnZW.isNullOrUndefined)(id)) {
            this.performRename();
            return;
        }
        var indexes = this.getItemsIndex([
            id
        ]);
        if (indexes.length > 0) {
            (0, $a3d9eadd9d99207c$export$f3fb02da958b835d)(this.parent, this.items[indexes[0]]);
            if ((0, $3EnZW.isNullOrUndefined)(name)) (0, $a3d9eadd9d99207c$export$d52c45268ea880af)(this.parent);
            else if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(this.parent.itemData[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, this.parent.itemData[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
            else (0, $5703c0df24e3a120$export$7ac989ec0c9c279)(this.parent, this.parent.path, name);
        }
    };
    return LargeIconsView;
}();



parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $5aa4792b5d1e0993$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5aa4792b5d1e0993$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Specifies the Ajax settings of the File Manager.
 */ var $5aa4792b5d1e0993$export$a2087ef30e892b25 = /** @class */ function(_super) {
    $5aa4792b5d1e0993$var$__extends(UploadSettings, _super);
    function UploadSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)("")
    ], UploadSettings.prototype, "allowedExtensions", void 0);
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], UploadSettings.prototype, "autoUpload", void 0);
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], UploadSettings.prototype, "autoClose", void 0);
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], UploadSettings.prototype, "directoryUpload", void 0);
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], UploadSettings.prototype, "minFileSize", void 0);
    $5aa4792b5d1e0993$var$__decorate([
        (0, $5rsSz.Property)(30000000)
    ], UploadSettings.prototype, "maxFileSize", void 0);
    return UploadSettings;
}((0, $3fcxu.ChildProperty));






parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $4532973e3b134128$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4532973e3b134128$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4532973e3b134128$export$98a40ee6ac8079a0 = [
    "Open",
    "|",
    "Cut",
    "Copy",
    "|",
    "Delete",
    "Download",
    "Rename",
    "|",
    "Details"
];
var $4532973e3b134128$export$850b8fd439648d50 = [
    "Open",
    "|",
    "Cut",
    "Copy",
    "Paste",
    "|",
    "Delete",
    "Rename",
    "Download",
    "|",
    "Details"
];
var $4532973e3b134128$export$e01c925dbe116d36 = [
    "SortBy",
    "View",
    "Refresh",
    "|",
    "Paste",
    "|",
    "NewFolder",
    "Upload",
    "|",
    "Details",
    "|",
    "SelectAll"
];
/**
 * Specifies the ContextMenu settings of the File Manager.
 */ var $4532973e3b134128$export$87795476079a01f9 = /** @class */ function(_super) {
    $4532973e3b134128$var$__extends(ContextMenuSettings, _super);
    function ContextMenuSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $4532973e3b134128$var$__decorate([
        (0, $5rsSz.Property)($4532973e3b134128$export$98a40ee6ac8079a0)
    ], ContextMenuSettings.prototype, "file", void 0);
    $4532973e3b134128$var$__decorate([
        (0, $5rsSz.Property)($4532973e3b134128$export$850b8fd439648d50)
    ], ContextMenuSettings.prototype, "folder", void 0);
    $4532973e3b134128$var$__decorate([
        (0, $5rsSz.Property)($4532973e3b134128$export$e01c925dbe116d36)
    ], ContextMenuSettings.prototype, "layout", void 0);
    $4532973e3b134128$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ContextMenuSettings.prototype, "visible", void 0);
    return ContextMenuSettings;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $jmffE = parcelRequire("jmffE");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");
var $3P3ke = parcelRequire("3P3ke");


var $2vAqh = parcelRequire("2vAqh");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3fcxu = parcelRequire("3fcxu");
var $3EnZW = parcelRequire("3EnZW");
var $5rsSz = parcelRequire("5rsSz");
var $22807a4aeae41444$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $22807a4aeae41444$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $22807a4aeae41444$export$289ca1c318c0384(props, model) {
    var obj = (0, $3EnZW.extend)({}, props);
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var prop = _a[_i];
        if (model.indexOf(prop) < 0) (0, $3EnZW.deleteObject)(obj, prop);
    }
    return obj;
}
function $22807a4aeae41444$export$63e3353a137c40b5(ul, keyCode) {
    var defaultIdx = keyCode === 40 ? 0 : ul.childElementCount - 1;
    var liIdx = defaultIdx;
    var li;
    var selectedLi = ul.querySelector(".e-selected");
    if (selectedLi) selectedLi.classList.remove("e-selected");
    for(var i = 0, len = ul.children.length; i < len; i++)if (ul.children[i].classList.contains("e-focused")) {
        li = ul.children[i];
        liIdx = i;
        li.classList.remove("e-focused");
        if (keyCode === 40) liIdx++;
        else liIdx--;
        if (liIdx === (keyCode === 40 ? ul.childElementCount : -1)) liIdx = defaultIdx;
    }
    li = ul.children[liIdx];
    liIdx = $22807a4aeae41444$var$isValidLI(ul, li, liIdx, keyCode);
    if (liIdx !== -1) {
        (0, $4ZDHT.addClass)([
            ul.children[liIdx]
        ], "e-focused");
        ul.children[liIdx].focus();
    }
}
/**
 * Get Valid LI element
 *
 * @param {HTMLElement} ul - Specifies the UL element
 * @param {Element} li - Specifies the LI element
 * @param {number} index - Specifies the index
 * @param {number} keyCode - Specifies the keycode
 * @param {number} count - Specifies the count
 * @returns {number} - Index
 */ function $22807a4aeae41444$var$isValidLI(ul, li, index, keyCode, count) {
    if (count === void 0) count = 0;
    if (li.classList.contains("e-separator") || li.classList.contains("e-disabled")) {
        if (index === (keyCode === 40 ? ul.childElementCount - 1 : 0)) index = keyCode === 40 ? 0 : ul.childElementCount - 1;
        else if (keyCode === 40) index++;
        else index--;
    }
    li = ul.children[index];
    if (li.classList.contains("e-separator") || li.classList.contains("e-disabled")) {
        count++;
        if (count === ul.childElementCount) return index = -1;
        index = $22807a4aeae41444$var$isValidLI(ul, li, index, keyCode, count);
    }
    return index;
}
function $22807a4aeae41444$export$61a58621342b3674(popup, blankIcon) {
    var blankIconList = [].slice.call(popup.getElementsByClassName("e-blank-icon"));
    if (blankIcon) {
        var menuItem = [].slice.call(popup.getElementsByClassName("e-item"));
        menuItem.forEach(function(li) {
            if (li.style.paddingLeft || li.style.paddingRight) li.removeAttribute("style");
        });
    }
    if (!blankIconList.length) return;
    var iconLi = popup.querySelector(".e-item:not(.e-blank-icon):not(.e-separator)");
    if ((0, $3EnZW.isNullOrUndefined)(iconLi)) return;
    if (iconLi.classList.contains("e-url")) iconLi = iconLi.querySelector(".e-menu-url");
    var icon = iconLi.querySelector(".e-menu-icon");
    var cssProp;
    var enableRtl = popup.classList.contains("e-rtl");
    if (enableRtl) cssProp = {
        padding: "paddingRight",
        margin: "marginLeft"
    };
    else cssProp = {
        padding: "paddingLeft",
        margin: "marginRight"
    };
    /* eslint-disable */ var size = parseInt(getComputedStyle(icon).fontSize, 10) + parseInt(enableRtl ? getComputedStyle(icon)[cssProp.margin] : getComputedStyle(icon)[cssProp.margin], 10) + parseInt(getComputedStyle(iconLi).paddingLeft, 10) + "px";
    blankIconList.forEach(function(li) {
        if (li.classList.contains("e-url")) li.querySelector(".e-menu-url").style[cssProp.padding] = size;
        else li.style[cssProp.padding] = size;
    });
/* eslint-enable */ }
/**
 * Defines the items of Split Button/DropDownButton.
 */ var $22807a4aeae41444$export$6d08773d2e66f8f2 = /** @class */ function(_super) {
    $22807a4aeae41444$var$__extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "iconCss", void 0);
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "id", void 0);
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Item.prototype, "separator", void 0);
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "text", void 0);
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Item.prototype, "url", void 0);
    $22807a4aeae41444$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Item.prototype, "disabled", void 0);
    return Item;
}((0, $3fcxu.ChildProperty));


var $2f39802b01f31b03$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2f39802b01f31b03$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2f39802b01f31b03$var$classNames = {
    DISABLED: "e-disabled",
    FOCUS: "e-focused",
    ICON: "e-menu-icon",
    ITEM: "e-item",
    POPUP: "e-dropdown-popup",
    RTL: "e-rtl",
    SEPARATOR: "e-separator",
    VERTICAL: "e-vertical"
};
/**
 * DropDownButton component is used to toggle contextual overlays for displaying list of action items.
 * It can contain both text and images.
 * ```html
 * <button id="element">DropDownButton</button>
 * ```
 * ```typescript
 * <script>
 * var dropDownButtonObj = new DropDownButton({items: [{ text: 'Action1' }, { text: 'Action2' },{ text: 'Action3' }]);
 * dropDownButtonObj.appendTo("#element");
 * </script>
 * ```
 */ var $2f39802b01f31b03$export$e200d4ca2624495d = /** @class */ function(_super) {
    $2f39802b01f31b03$var$__extends(DropDownButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {DropDownButtonModel} options - Specifies dropdown button model
     * @param  {string|HTMLButtonElement} element - Specifies element
     * @hidden
     */ function DropDownButton(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isPopupCreated = true;
        return _this;
    }
    DropDownButton.prototype.preRender = function() {
    /** */ };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */ DropDownButton.prototype.getPersistData = function() {
        return this.addOnPersist([]);
    };
    /**
     * To open/close DropDownButton popup based on current state of the DropDownButton.
     *
     * @returns {void}
     */ DropDownButton.prototype.toggle = function() {
        if (this.canOpen()) this.openPopUp();
        else if (this.createPopupOnClick && !this.isPopupCreated) {
            this.createPopup();
            this.openPopUp();
        } else this.closePopup();
    };
    /**
     * Initialize the Component rendering
     *
     * @returns {void}
     * @private
     */ DropDownButton.prototype.render = function() {
        this.initialize();
        if (!this.disabled) this.wireEvents();
        this.renderComplete();
    };
    /**
     * Adds a new item to the menu. By default, new item appends to the list as the last item,
     * but you can insert based on the text parameter.
     *
     * @param  { ItemModel[] } items - Specifies an array of JSON data.
     * @param { string } text - Specifies the text to insert the newly added item in the menu.
     * @returns {void}.
     */ DropDownButton.prototype.addItems = function(items, text) {
        var newItem;
        var idx = this.items.length;
        for(var j = 0, len = this.items.length; j < len; j++)if (text === this.items[j].text) {
            idx = j;
            break;
        }
        for(var i = items.length - 1; i >= 0; i--){
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            newItem = new (0, $22807a4aeae41444$export$6d08773d2e66f8f2)(this, "items", items[i], true);
            this.items.splice(idx, 0, newItem);
        }
        if (!this.canOpen()) this.createItems();
    };
    /**
     * Removes the items from the menu.
     *
     * @param  { string[] } items - Specifies an array of string to remove the items.
     * @param { string } isUniqueId - Set `true` if specified items is a collection of unique id.
     * @returns {void}.
     */ DropDownButton.prototype.removeItems = function(items, isUniqueId) {
        var refresh = false;
        for(var i = 0, len = items.length; i < len; i++){
            for(var j = 0, len_1 = this.items.length; j < len_1; j++)if (items[i] === (isUniqueId ? this.items[j].id : this.items[j].text)) {
                this.items.splice(j, 1);
                refresh = true;
                break;
            }
        }
        if (refresh && this.getULElement()) this.createItems();
    };
    DropDownButton.prototype.createPopup = function() {
        var _a;
        var div = this.createElement("div", {
            className: $2f39802b01f31b03$var$classNames.POPUP,
            id: this.element.id + "-popup"
        });
        document.body.appendChild(div);
        this.dropDown = new (0, $2vAqh.Popup)(div, {
            relateTo: this.element,
            collision: {
                X: "fit",
                Y: "flip"
            },
            position: {
                X: "left",
                Y: "bottom"
            },
            targetType: "relative",
            content: this.target ? this.getTargetElement() : "",
            enableRtl: this.enableRtl
        });
        this.dropDown.element.setAttribute("role", "dialog");
        this.dropDown.element.setAttribute("aria-label", "dropdown menu");
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupContent)) this.popupContent.style.display = "";
        if (this.dropDown.element.style.position === "fixed") this.dropDown.refreshPosition(this.element);
        this.dropDown.hide();
        (0, $4ZDHT.attributes)(this.element, (_a = {}, _a["aria-haspopup"] = this.items.length || this.target ? "true" : "false", _a["aria-expanded"] = "false", _a["type"] = "button", _a));
        if (this.cssClass) (0, $4ZDHT.addClass)([
            div
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        this.isPopupCreated = true;
    };
    DropDownButton.prototype.getTargetElement = function() {
        if (this.createPopupOnClick && !this.isColorPicker() && !(0, $3EnZW.isNullOrUndefined)(this.popupContent)) return this.popupContent;
        return typeof this.target === "string" ? (0, $4ZDHT.select)(this.target) : this.target;
    };
    DropDownButton.prototype.createItems = function(appendItems) {
        var items = this.items;
        var showIcon = this.hasIcon(this.items, "iconCss");
        var span;
        var item;
        var li;
        var eventArgs;
        var ul = this.getULElement();
        if (ul) ul.innerHTML = "";
        else ul = this.createElement("ul", {
            attrs: {
                "role": "menu",
                "tabindex": "0"
            }
        });
        for(var i = 0; i < items.length; i++){
            item = items[i];
            var tempItem = item.text;
            li = this.createElement("li", {
                innerHTML: item.url ? "" : tempItem,
                className: item.separator ? $2f39802b01f31b03$var$classNames.ITEM + " " + $2f39802b01f31b03$var$classNames.SEPARATOR : $2f39802b01f31b03$var$classNames.ITEM,
                attrs: item.separator ? {
                    "role": "separator",
                    "tabindex": "-1",
                    "aria-label": "separator",
                    "aria-hidden": "true"
                } : {
                    "role": "menuitem",
                    "tabindex": "-1",
                    "aria-label": tempItem
                },
                id: item.id ? item.id : (0, $3EnZW.getUniqueID)("e-" + this.getModuleName() + "-item")
            });
            if (this.enableHtmlSanitizer) li.textContent = item.url ? "" : tempItem;
            else li.innerHTML = item.url ? "" : tempItem;
            if (item.url) {
                li.appendChild(this.createAnchor(item));
                li.classList.add("e-url");
            }
            if (item.iconCss) {
                span = this.createElement("span", {
                    className: $2f39802b01f31b03$var$classNames.ICON + " " + item.iconCss
                });
                if (item.url) li.childNodes[0].appendChild(span);
                else li.insertBefore(span, li.childNodes[0]);
            } else if (showIcon && !item.separator) li.classList.add("e-blank-icon");
            var beforeDisabled = item.disabled;
            if (item.disabled) li.classList.add("e-disabled");
            eventArgs = {
                item: item,
                element: li
            };
            this.trigger("beforeItemRender", eventArgs);
            var afterDisabled = eventArgs.item.disabled;
            if (beforeDisabled !== afterDisabled) {
                if (eventArgs.item.disabled) li.classList.add("e-disabled");
                else li.classList.remove("e-disabled");
            }
            ul.appendChild(li);
        }
        if (appendItems) this.getPopUpElement().appendChild(ul);
        if (showIcon) (0, $22807a4aeae41444$export$61a58621342b3674)(this.getPopUpElement());
    };
    DropDownButton.prototype.hasIcon = function(items, field) {
        for(var i = 0, len = items.length; i < len; i++){
            if (items[i]["" + field]) return true;
        }
        return false;
    };
    DropDownButton.prototype.createAnchor = function(item) {
        var tempItem = this.enableHtmlSanitizer ? (0, $3P3ke.SanitizeHtmlHelper).sanitize(item.text) : item.text;
        return this.createElement("a", {
            className: "e-menu-text e-menu-url",
            innerHTML: tempItem,
            attrs: {
                "href": item.url
            }
        });
    };
    DropDownButton.prototype.initialize = function() {
        this.button = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            iconCss: this.iconCss,
            iconPosition: this.iconPosition,
            cssClass: this.cssClass,
            content: this.content,
            disabled: this.disabled,
            enableRtl: this.enableRtl,
            enablePersistence: this.enablePersistence
        });
        this.button.createElement = this.createElement;
        this.button.appendTo(this.element);
        if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)("e-" + this.getModuleName());
        this.appendArrowSpan();
        this.setActiveElem([
            this.element
        ]);
        this.element.setAttribute("tabindex", "0");
        this.element.setAttribute("aria-label", this.element.textContent ? this.element.textContent : "dropdownbutton");
        if (this.target && !this.isColorPicker() && !this.createPopupOnClick || !this.createPopupOnClick) this.createPopup();
        else {
            this.isPopupCreated = false;
            if (this.target && !this.isColorPicker() && this.createPopupOnClick) {
                this.popupContent = this.getTargetElement();
                this.popupContent.style.display = "none";
            }
        }
    };
    DropDownButton.prototype.isColorPicker = function() {
        if (!this.element) return false;
        var prevElem = this.element.previousSibling;
        if (prevElem && prevElem.classList && prevElem.classList.contains("e-split-colorpicker")) return true;
        return false;
    };
    DropDownButton.prototype.appendArrowSpan = function() {
        this.cssClass = (0, $3EnZW.isNullOrUndefined)(this.cssClass) ? "" : this.cssClass;
        this.element.appendChild(this.createElement("span", {
            className: "e-btn-icon e-icons e-icon-" + (this.cssClass.indexOf($2f39802b01f31b03$var$classNames.VERTICAL) > -1 ? "bottom" : "right") + " e-caret"
        }));
    };
    DropDownButton.prototype.setActiveElem = function(elem) {
        this.activeElem = elem;
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */ DropDownButton.prototype.getModuleName = function() {
        return "dropdown-btn";
    };
    DropDownButton.prototype.canOpen = function() {
        var val = false;
        if (this.isPopupCreated) val = this.getPopUpElement().classList.contains("e-popup-close");
        return val;
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */ DropDownButton.prototype.destroy = function() {
        var _this = this;
        _super.prototype.destroy.call(this);
        if (this.getModuleName() === "dropdown-btn") {
            var classList_1;
            if (this.element.querySelector("span.e-caret")) (0, $4ZDHT.detach)(this.element.querySelector("span.e-caret"));
            if (this.cssClass) classList_1 = this.cssClass.split(" ");
            this.button.destroy();
            if (classList_1) (0, $4ZDHT.removeClass)([
                this.element
            ], classList_1);
            (0, $4ZDHT.removeClass)(this.activeElem, [
                "e-active"
            ]);
            var attrList = this.element.getAttribute("class") ? [
                "aria-haspopup",
                "aria-expanded",
                "aria-owns",
                "type"
            ] : [
                "aria-haspopup",
                "aria-expanded",
                "aria-owns",
                "type",
                "class"
            ];
            attrList.forEach(function(key) {
                _this.element.removeAttribute(key);
            });
            this.popupUnWireEvents();
            this.destroyPopup();
            this.isPopupCreated = false;
            if (!this.disabled) this.unWireEvents();
        }
    };
    DropDownButton.prototype.destroyPopup = function() {
        if (this.isPopupCreated) {
            this.dropDown.destroy();
            if (this.getPopUpElement()) {
                var popupEle = document.getElementById(this.getPopUpElement().id);
                if (popupEle) {
                    (0, $4ZDHT.removeClass)([
                        popupEle
                    ], [
                        "e-popup-open",
                        "e-popup-close"
                    ]);
                    (0, $4ZDHT.detach)(popupEle);
                }
            }
            (0, $aqzbR.EventHandler).remove(this.getPopUpElement(), "click", this.clickHandler);
            (0, $aqzbR.EventHandler).remove(this.getPopUpElement(), "keydown", this.keyBoardHandler);
            if (this.isPopupCreated && this.dropDown) {
                this.dropDown.element = null;
                this.dropDown = undefined;
            }
        }
        this.isPopupCreated = false;
    };
    DropDownButton.prototype.getPopUpElement = function() {
        var val = null;
        if (!this.dropDown && this.activeElem[0].classList.contains("e-split-btn")) {
            var dropDownBtn = (0, $jmffE.getComponent)(this.activeElem[1], "dropdown-btn");
            if (dropDownBtn) this.dropDown = dropDownBtn.dropDown;
        }
        if (this.dropDown) val = this.dropDown.element;
        return val;
    };
    DropDownButton.prototype.getULElement = function() {
        var val = null;
        if (this.getPopUpElement()) val = this.getPopUpElement().children[0];
        return val;
    };
    DropDownButton.prototype.wireEvents = function() {
        this.delegateMousedownHandler = this.mousedownHandler.bind(this);
        if (!this.createPopupOnClick) (0, $aqzbR.EventHandler).add(document, "mousedown touchstart", this.delegateMousedownHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keydown", this.keyBoardHandler, this);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).add(window, "resize", this.windowResize, this);
    };
    DropDownButton.prototype.windowResize = function() {
        if (!this.canOpen() && this.dropDown) this.dropDown.refreshPosition(this.element);
    };
    DropDownButton.prototype.popupWireEvents = function() {
        if (!this.delegateMousedownHandler) this.delegateMousedownHandler = this.mousedownHandler.bind(this);
        var popupElement = this.getPopUpElement();
        if (this.createPopupOnClick) (0, $aqzbR.EventHandler).add(document, "mousedown touchstart", this.delegateMousedownHandler, this);
        if (popupElement) {
            (0, $aqzbR.EventHandler).add(popupElement, "click", this.clickHandler, this);
            (0, $aqzbR.EventHandler).add(popupElement, "keydown", this.keyBoardHandler, this);
            if (this.closeActionEvents) (0, $aqzbR.EventHandler).add(popupElement, this.closeActionEvents, this.focusoutHandler, this);
        }
        this.rippleFn = (0, $kj1BR.rippleEffect)(popupElement, {
            selector: "." + $2f39802b01f31b03$var$classNames.ITEM
        });
    };
    DropDownButton.prototype.popupUnWireEvents = function() {
        var popupElement = this.getPopUpElement();
        if (this.createPopupOnClick) (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", this.delegateMousedownHandler);
        if (popupElement && popupElement.parentElement) {
            (0, $aqzbR.EventHandler).remove(popupElement, "click", this.clickHandler);
            (0, $aqzbR.EventHandler).remove(popupElement, "keydown", this.keyBoardHandler);
            if (this.closeActionEvents) (0, $aqzbR.EventHandler).remove(popupElement, this.closeActionEvents, this.focusoutHandler);
        }
        if ((0, $kj1BR.isRippleEnabled) && this.rippleFn) this.rippleFn();
    };
    /**
     * Handles the keyboard interactions.
     *
     * @param {KeyboardEventArgs} e - Specifies keyboard event args.
     * @returns {void}
     * @hidden
     */ DropDownButton.prototype.keyBoardHandler = function(e) {
        if (e.target === this.element && (e.keyCode === 9 || !e.altKey && e.keyCode === 40 || e.keyCode === 38)) return;
        switch(e.keyCode){
            case 38:
            case 40:
                if (e.altKey && (e.keyCode === 38 || e.keyCode === 40)) this.keyEventHandler(e);
                else this.upDownKeyHandler(e);
                break;
            case 9:
            case 13:
            case 27:
            case 32:
                this.keyEventHandler(e);
                break;
        }
    };
    DropDownButton.prototype.isSafari = function() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    };
    DropDownButton.prototype.upDownKeyHandler = function(e) {
        if (this.target && (e.keyCode === 38 || e.keyCode === 40)) return;
        e.preventDefault();
        (0, $22807a4aeae41444$export$63e3353a137c40b5)(this.getULElement(), e.keyCode);
    };
    DropDownButton.prototype.keyEventHandler = function(e) {
        if (this.target && (e.keyCode === 13 || e.keyCode === 9)) return;
        if (e.keyCode === 13 && this.activeElem[0].classList.contains("e-split-btn")) {
            this.triggerSelect(e);
            this.activeElem[0].focus();
            return;
        }
        if (e.target && e.target.className.indexOf("e-edit-template") > -1 && e.keyCode === 32) return;
        if (e.keyCode !== 9) e.preventDefault();
        if (e.keyCode === 27 || e.keyCode === 38 || e.keyCode === 9) {
            if (!this.canOpen()) this.closePopup(e, this.element);
        } else this.clickHandler(e);
    };
    DropDownButton.prototype.getLI = function(elem) {
        return elem.tagName === "LI" ? elem : (0, $4ZDHT.closest)(elem, "li");
    };
    DropDownButton.prototype.mousedownHandler = function(e) {
        var trgt = e.target;
        if (this.dropDown && !this.canOpen() && !((0, $4ZDHT.closest)(trgt, '[id="' + this.getPopUpElement().id + '"]') || (0, $4ZDHT.closest)(trgt, '[id="' + this.element.id + '"]'))) this.closePopup(e);
    };
    DropDownButton.prototype.focusoutHandler = function(e) {
        if (this.isPopupCreated && !this.canOpen()) {
            var liTarget = e.relatedTarget || e.target;
            if (liTarget && liTarget.className.indexOf("e-item") > -1) {
                var li = this.getLI(liTarget);
                if (li) {
                    var liIdx = Array.prototype.indexOf.call(this.getULElement().children, li);
                    var item = this.items[liIdx];
                    if (item) {
                        var selectEventArgs = {
                            element: li,
                            item: item,
                            event: e
                        };
                        this.trigger("select", selectEventArgs);
                    }
                }
            }
            this.closePopup(e);
        }
    };
    DropDownButton.prototype.clickHandler = function(e) {
        var trgt = e.target;
        if ((0, $4ZDHT.closest)(trgt, '[id="' + this.element.id + '"]')) {
            if (!this.createPopupOnClick || this.target && this.target !== "" && !this.isColorPicker() && !this.createPopupOnClick) {
                if (this.getPopUpElement().classList.contains("e-popup-close")) this.openPopUp(e);
                else this.closePopup(e);
            } else if (this.isPopupCreated) this.closePopup(e, this.activeElem[0]);
            else {
                this.createPopup();
                this.openPopUp(e);
            }
        } else if ((0, $4ZDHT.closest)(trgt, '[id="' + this.getPopUpElement().id + '"]')) {
            var li = this.getLI(e.target);
            if (li) {
                this.triggerSelect(e);
                this.closePopup(e, this.activeElem[0]);
            }
        }
    };
    DropDownButton.prototype.triggerSelect = function(e) {
        var eventArgs;
        var liIdx;
        var item;
        var li = this.getLI(e.target);
        if (li) {
            liIdx = Array.prototype.indexOf.call(this.getULElement().children, li);
            item = this.items[liIdx];
            if (item) {
                eventArgs = {
                    element: li,
                    item: item,
                    event: e
                };
                this.trigger("select", eventArgs);
            }
        }
    };
    DropDownButton.prototype.openPopUp = function(e) {
        var _this = this;
        if (e === void 0) e = null;
        var isReact = false;
        var popupElem = this.getPopUpElement();
        if (!this.target) this.createItems(true);
        else {
            if (this.activeElem.length > 1) {
                var splitButton = (0, $jmffE.getComponent)(this.activeElem[0], "split-btn");
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (splitButton.isReact && popupElem.childNodes.length < 1) {
                    isReact = true;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (splitButton.appendReactElement) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    splitButton.appendReactElement(this.getTargetElement(), this.getPopUpElement());
                    this.renderReactTemplates();
                }
            } else // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.isReact && popupElem.childNodes.length < 1) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                isReact = true;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (this.appendReactElement) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.appendReactElement(this.getTargetElement(), this.getPopUpElement());
                this.renderReactTemplates();
            }
        }
        var ul = this.getULElement();
        this.popupWireEvents();
        var beforeOpenArgs = {
            element: ul,
            items: this.items,
            event: e,
            cancel: false
        };
        this.trigger("beforeOpen", beforeOpenArgs, function(observedArgs) {
            if (!observedArgs.cancel) {
                var ul_1 = _this.getULElement();
                _this.dropDown.show(null, _this.element);
                (0, $4ZDHT.addClass)([
                    _this.element
                ], "e-active");
                _this.element.setAttribute("aria-expanded", "true");
                _this.element.setAttribute("aria-owns", _this.getPopUpElement().id);
                if (ul_1 && !_this.isSafari()) ul_1.focus();
                if (_this.enableRtl && ul_1.parentElement.style.left !== "0px") {
                    var wrapperWidth = void 0;
                    if (_this.element.parentElement && _this.element.parentElement.classList.contains("e-split-btn-wrapper")) wrapperWidth = _this.element.parentElement.offsetWidth;
                    else wrapperWidth = _this.element.offsetWidth;
                    var popupRect = ul_1.parentElement.offsetWidth - wrapperWidth;
                    var popupLeft = parseFloat(ul_1.parentElement.style.left) - popupRect;
                    if (popupLeft < 0) popupLeft = 0;
                    ul_1.parentElement.style.left = popupLeft + "px";
                }
                var openArgs = {
                    element: ul_1,
                    items: _this.items
                };
                _this.trigger("open", openArgs);
                if (ul_1 && _this.isSafari()) ul_1.focus();
            }
        });
    };
    DropDownButton.prototype.closePopup = function(e, focusEle) {
        var _this = this;
        if (e === void 0) e = null;
        var ul = this.getULElement();
        var beforeCloseArgs = {
            element: ul,
            items: this.items,
            event: e,
            cancel: false
        };
        this.trigger("beforeClose", beforeCloseArgs, function(observedArgs) {
            if (!observedArgs.cancel) {
                var popupElement = _this.getPopUpElement();
                if (popupElement) (0, $aqzbR.EventHandler).remove(popupElement, "keydown", _this.keyBoardHandler);
                _this.popupUnWireEvents();
                var ul_2 = _this.getULElement();
                var selectedLi = void 0;
                if (ul_2) selectedLi = ul_2.querySelector(".e-selected");
                if (selectedLi) selectedLi.classList.remove("e-selected");
                _this.dropDown.hide();
                (0, $4ZDHT.removeClass)(_this.activeElem, "e-active");
                _this.element.setAttribute("aria-expanded", "false");
                _this.element.removeAttribute("aria-owns");
                if (focusEle) focusEle.focus();
                var closeArgs = {
                    element: ul_2,
                    items: _this.items
                };
                _this.trigger("close", closeArgs);
                if (!_this.target && ul_2) (0, $4ZDHT.detach)(ul_2);
                if (!_this.target || _this.isColorPicker() || _this.target && !_this.isColorPicker()) {
                    if (_this.createPopupOnClick) _this.destroyPopup();
                }
            } else if (ul) ul.focus();
        });
    };
    DropDownButton.prototype.unWireEvents = function() {
        if (!this.createPopupOnClick) (0, $aqzbR.EventHandler).remove(document, "mousedown touchstart", this.delegateMousedownHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.clickHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keydown", this.keyBoardHandler);
        if (this.isPopupCreated) {
            (0, $aqzbR.EventHandler).remove(this.getPopUpElement(), "click", this.clickHandler);
            (0, $aqzbR.EventHandler).remove(this.getPopUpElement(), "keydown", this.keyBoardHandler);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $aqzbR.EventHandler).remove(window, "resize", this.windowResize);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {DropDownButtonModel} newProp - Specifies new properties
     * @param  {DropDownButtonModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */ DropDownButton.prototype.onPropertyChanged = function(newProp, oldProp) {
        var btnModel = [
            "content",
            "cssClass",
            "iconCss",
            "iconPosition",
            "disabled",
            "enableRtl"
        ];
        this.button.setProperties((0, $22807a4aeae41444$export$289ca1c318c0384)(newProp, btnModel));
        var popupElement;
        if (this.isPopupCreated) {
            popupElement = this.getPopUpElement();
            this.dropDown.setProperties((0, $22807a4aeae41444$export$289ca1c318c0384)(newProp, [
                "enableRtl"
            ]));
        }
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "content":
                    if (!this.element.querySelector("span.e-caret")) this.appendArrowSpan();
                    break;
                case "disabled":
                    if (newProp.disabled) {
                        this.unWireEvents();
                        if (this.isPopupCreated && !this.canOpen()) this.closePopup();
                    } else this.wireEvents();
                    break;
                case "cssClass":
                    oldProp.cssClass = (0, $3EnZW.isNullOrUndefined)(oldProp.cssClass) ? "" : oldProp.cssClass;
                    if (newProp.cssClass.indexOf($2f39802b01f31b03$var$classNames.VERTICAL) > -1 || oldProp.cssClass.indexOf($2f39802b01f31b03$var$classNames.VERTICAL) > -1) {
                        if (!this.element.querySelector("span.e-caret")) this.appendArrowSpan();
                        var arrowSpan = this.element.querySelector("span.e-caret");
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        newProp.cssClass.indexOf($2f39802b01f31b03$var$classNames.VERTICAL) > -1 ? (0, $4ZDHT.classList)(arrowSpan, [
                            "e-icon-bottom"
                        ], [
                            "e-icon-right"
                        ]) : (0, $4ZDHT.classList)(arrowSpan, [
                            "e-icon-right"
                        ], [
                            "e-icon-bottom"
                        ]);
                    }
                    if (this.isPopupCreated) {
                        if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                            popupElement
                        ], oldProp.cssClass.split(" "));
                        if (newProp.cssClass) (0, $4ZDHT.addClass)([
                            popupElement
                        ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    }
                    break;
                case "target":
                    this.dropDown.content = this.getTargetElement();
                    this.dropDown.dataBind();
                    break;
                case "items":
                    if (this.isPopupCreated && this.getULElement()) this.createItems();
                    break;
                case "createPopupOnClick":
                    if (newProp.createPopupOnClick) this.destroyPopup();
                    else this.createPopup();
                    break;
            }
        }
    };
    /**
     * Sets the focus to DropDownButton
     * its native method
     *
     * @public
     * @returns {void}
     */ DropDownButton.prototype.focusIn = function() {
        this.element.focus();
    };
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("")
    ], DropDownButton.prototype, "content", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("")
    ], DropDownButton.prototype, "cssClass", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownButton.prototype, "disabled", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("")
    ], DropDownButton.prototype, "iconCss", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], DropDownButton.prototype, "iconPosition", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], DropDownButton.prototype, "enableHtmlSanitizer", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $22807a4aeae41444$export$6d08773d2e66f8f2))
    ], DropDownButton.prototype, "items", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], DropDownButton.prototype, "createPopupOnClick", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("")
    ], DropDownButton.prototype, "target", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Property)("")
    ], DropDownButton.prototype, "closeActionEvents", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "beforeItemRender", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "beforeOpen", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "beforeClose", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "close", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "open", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "select", void 0);
    $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.Event)()
    ], DropDownButton.prototype, "created", void 0);
    DropDownButton = $2f39802b01f31b03$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], DropDownButton);
    return DropDownButton;
}((0, $hQxLN.Component));






/**
 * BreadCrumbBar module
 */ var $ac3523cb0a11942e$export$817a8c895c36efa8 = /** @class */ function() {
    /**
     * constructor for addressbar module
     *
     * @hidden
     * @param {IFileManager} parent - specifies parent element.
     * @private
     *
     */ function BreadCrumbBar(parent) {
        this.addressPath = "";
        this.addressBarLink = "";
        this.searchTimer = null;
        this.searchWrapWidth = null;
        this.parent = parent;
        this.keyConfigs = {
            enter: "enter"
        };
        this.render();
    }
    BreadCrumbBar.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName() && e.module !== "common") return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            var value = e.newProp.searchSettings;
            switch(prop){
                case "searchSettings":
                    if (!(0, $3EnZW.isNullOrUndefined)(value.allowSearchOnTyping)) this.searchEventBind(value.allowSearchOnTyping);
                    if (this.parent.breadcrumbbarModule.searchObj.value && this.parent.breadcrumbbarModule.searchObj.value !== "" && !(!(0, $3EnZW.isNullOrUndefined)(value.allowSearchOnTyping) && (0, $3EnZW.isNullOrUndefined)(value.filterType) && (0, $3EnZW.isNullOrUndefined)(value.ignoreCase))) (0, $a3d9eadd9d99207c$export$dbc315476b554bdb)(this.parent, this.parent.breadcrumbbarModule.searchObj.value, false);
                    break;
            }
        }
    };
    BreadCrumbBar.prototype.render = function() {
        this.addEventListener();
    };
    BreadCrumbBar.prototype.onPathChange = function() {
        var pathNames = this.parent.pathNames;
        var paths = this.parent.path.split("/");
        var addressbarUL = this.parent.createElement("ul", {
            className: "e-addressbar-ul"
        });
        var addressbarLI = null;
        var pathNamesLen = pathNames.length;
        if (pathNames.length > 0) {
            var id = "";
            for(var i = 0; i < pathNamesLen; i++){
                var addressATag = null;
                addressbarLI = this.parent.createElement("li", {
                    className: "e-address-list-item"
                });
                for(var j = 0; j <= i; j++)id = id + paths[j] + "/";
                addressbarLI.setAttribute("data-utext", id);
                if (i !== 0) {
                    var icon = (0, $4ZDHT.createElement)("span", {
                        className: $15a2a1ec4804cfd7$export$fde44257752a9f60
                    });
                    addressbarLI.appendChild(icon);
                }
                if (pathNamesLen - i !== 1) {
                    addressATag = (0, $4ZDHT.createElement)("a", {
                        className: $15a2a1ec4804cfd7$export$7080f700b8701d5a
                    });
                    addressbarLI.setAttribute("tabindex", "0");
                } else addressATag = (0, $4ZDHT.createElement)("span", {
                    className: $15a2a1ec4804cfd7$export$7080f700b8701d5a
                });
                id = "";
                addressATag.innerText = pathNames[i];
                addressbarLI.appendChild(addressATag);
                addressbarUL.appendChild(addressbarLI);
            }
            var ulElement = this.parent.breadCrumbBarNavigation.querySelector(".e-addressbar-ul");
            if (!(0, $3EnZW.isNullOrUndefined)(ulElement)) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.subMenuObj)) this.subMenuObj.destroy();
                (0, $4ZDHT.remove)(ulElement);
            }
            var searchWrap = this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");
            if (!searchWrap) this.parent.breadCrumbBarNavigation.insertBefore(addressbarUL, searchWrap);
            else this.parent.breadCrumbBarNavigation.appendChild(addressbarUL);
            this.updateBreadCrumbBar(addressbarUL);
        }
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.updateBreadCrumbBar = function(addresBarUL) {
        var liElements = addresBarUL.querySelectorAll("li");
        var ulElement = this.parent.breadCrumbBarNavigation.querySelector(".e-addressbar-ul");
        var style = window.getComputedStyle(ulElement, null);
        var pRight = parseFloat(style.getPropertyValue("padding-right"));
        var pLeft = parseFloat(style.getPropertyValue("padding-left"));
        var breadCrumbBarWidth = ulElement.offsetWidth - pRight - pLeft;
        var addressbarUL = this.parent.createElement("ul", {
            className: "e-addressbar-ul"
        });
        var liElementsWidth = 0;
        var liElementsWidths = [];
        for(var i = 0; i < liElements.length; i++){
            var width = liElements[i].clientWidth;
            liElementsWidths.push(width);
            liElementsWidth = liElementsWidth + width;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(ulElement)) (0, $4ZDHT.remove)(ulElement);
        var searchContainer = this.parent.createElement("div");
        searchContainer.setAttribute("class", "e-search-wrap");
        var id = this.parent.element.id + $15a2a1ec4804cfd7$export$cb7313172c50f93c;
        var searchInput = (0, $4ZDHT.createElement)("input", {
            id: id,
            attrs: {
                autocomplete: "off",
                "aria-label": (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Search")
            }
        });
        searchContainer.appendChild(searchInput);
        var searchEle = this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap .e-input");
        if ((0, $3EnZW.isNullOrUndefined)(searchEle)) {
            this.parent.breadCrumbBarNavigation.appendChild(searchContainer);
            var span = (0, $4ZDHT.createElement)("span", {
                className: "e-icons e-fe-search"
            });
            (0, $aqzbR.EventHandler).add(span, "click", this.onShowInput, this);
            searchInput.parentElement.insertBefore(span, searchInput);
            this.searchObj = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
                value: "",
                showClearButton: true,
                placeholder: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Search"),
                focus: this.onFocus.bind(this),
                blur: this.onBlur.bind(this)
            });
            this.searchObj.appendTo("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$cb7313172c50f93c);
            this.searchEventBind(this.parent.searchSettings.allowSearchOnTyping);
            var search = this.searchObj.element.nextElementSibling;
            (0, $aqzbR.EventHandler).add(search, "mousedown", this.searchChangeHandler.bind(this), this);
            (0, $aqzbR.EventHandler).add(this.searchObj.element, "keyup", this.onKeyUp.bind(this), this);
        }
        var searchWrap = this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");
        breadCrumbBarWidth = breadCrumbBarWidth - (this.searchWrapWidth ? this.searchWrapWidth : searchWrap.offsetWidth);
        if (liElementsWidth > breadCrumbBarWidth) {
            var i = liElements.length;
            while(i--){
                var diff = breadCrumbBarWidth - liElementsWidths[i];
                if (diff > 40) {
                    addressbarUL.insertBefore(liElements[i], addressbarUL.querySelector("li"));
                    breadCrumbBarWidth = diff;
                } else {
                    var items = [];
                    for(var j = 0; j <= i; j++){
                        var liElement = liElements[j];
                        items.push({
                            text: liElement.innerText,
                            utext: liElement.getAttribute("data-utext")
                        });
                    }
                    var subMenuLi = this.parent.createElement("li", {
                        className: "e-breadcrumb-menu"
                    });
                    var attributes = {
                        className: "e-breadcrumb-submenu"
                    };
                    var subMenuSpan = this.parent.createElement("button", attributes);
                    subMenuLi.appendChild(subMenuSpan);
                    addressbarUL.insertBefore(subMenuLi, addressbarUL.querySelector("li"));
                    this.subMenuObj = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
                        items: items,
                        cssClass: "e-caret-hide e-submenu",
                        iconCss: $15a2a1ec4804cfd7$export$c1566f536bc98e1c,
                        iconPosition: "Top",
                        enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
                        beforeItemRender: this.addSubMenuAttributes.bind(this),
                        select: this.subMenuSelectOperations.bind(this)
                    });
                    this.subMenuObj.isStringTemplate = true;
                    this.subMenuObj.appendTo(subMenuSpan);
                    break;
                }
            }
            this.parent.breadCrumbBarNavigation.insertBefore(addressbarUL, searchWrap);
        } else this.parent.breadCrumbBarNavigation.insertBefore(addresBarUL, searchWrap);
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onFocus = function() {
        var wrap = (0, $4ZDHT.closest)(this.searchObj.element, ".e-search-wrap");
        wrap.classList.add("e-focus");
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onKeyUp = function() {
        this.parent.notify($f592513f3f17ead8$export$40ce9a35c05f873f, {
            args: this.parent
        });
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onBlur = function() {
        var wrap = (0, $4ZDHT.closest)(this.searchObj.element, ".e-search-wrap");
        wrap.classList.remove("e-focus");
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.subMenuSelectOperations = function(event) {
        var args = {
            target: event.element
        };
        this.addressPathClickHandler(args);
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.addSubMenuAttributes = function(args) {
        args.element.setAttribute("data-utext", (0, $3EnZW.getValue)("utext", args.item));
        var anchor = this.parent.createElement("a", {
            className: "e-list-text"
        });
        args.element.appendChild(anchor);
    };
    BreadCrumbBar.prototype.searchEventBind = function(allow) {
        if (allow) {
            this.searchObj.input = this.searchChangeHandler.bind(this);
            this.searchObj.change = null;
        } else {
            this.searchObj.change = this.searchChangeHandler.bind(this);
            this.searchObj.input = null;
        }
    };
    BreadCrumbBar.prototype.searchChangeHandler = function(args) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(args.value)) {
            this.parent.isFiltered = false;
            if (this.parent.searchSettings.allowSearchOnTyping) {
                window.clearTimeout(this.searchTimer);
                this.searchTimer = window.setTimeout(function() {
                    (0, $a3d9eadd9d99207c$export$dbc315476b554bdb)(_this.parent, args.value, false);
                }, 300);
            } else (0, $a3d9eadd9d99207c$export$dbc315476b554bdb)(this.parent, args.value, false);
        }
    };
    BreadCrumbBar.prototype.addressPathClickHandler = function(e) {
        var li = e.target;
        if (li.nodeName === "LI" || li.nodeName === "A") {
            var node = li.nodeName === "LI" ? li.children[0] : li;
            if (!(0, $3EnZW.isNullOrUndefined)(node)) {
                this.parent.isFiltered = false;
                var currentPath = this.updatePath(node);
                this.parent.itemData = [
                    (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent)
                ];
                this.triggerFileOpen(this.parent.itemData[0]);
                (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$f012f19194778278, currentPath);
                var treeNodeId = this.parent.pathId[this.parent.pathId.length - 1];
                this.parent.notify($f592513f3f17ead8$export$faa80f63dbb892e4, {
                    module: "treeview",
                    selectedNode: treeNodeId
                });
            }
        }
    };
    BreadCrumbBar.prototype.triggerFileOpen = function(data) {
        var eventArgs = {
            cancel: false,
            fileDetails: data,
            module: "BreadCrumbBar"
        };
        delete eventArgs.cancel;
        this.parent.trigger("fileOpen", eventArgs);
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onShowInput = function() {
        if (this.parent.isMobile) {
            if (this.parent.element.classList.contains($15a2a1ec4804cfd7$export$c1c49903035a02df)) {
                (0, $4ZDHT.removeClass)([
                    this.parent.element
                ], $15a2a1ec4804cfd7$export$c1c49903035a02df);
                this.searchWrapWidth = null;
            } else {
                var searchWrap = this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");
                this.searchWrapWidth = searchWrap.offsetWidth;
                (0, $4ZDHT.addClass)([
                    this.parent.element
                ], $15a2a1ec4804cfd7$export$c1c49903035a02df);
                this.searchObj.element.focus();
            }
        }
    };
    BreadCrumbBar.prototype.updatePath = function(list) {
        var li = (0, $4ZDHT.closest)(list, "li");
        var liElementId = li.getAttribute("data-utext");
        this.addressBarLink = liElementId;
        var link = this.addressBarLink.split("/");
        var ids = this.parent.pathId;
        var names = this.parent.pathNames;
        this.parent.pathId = [];
        this.parent.pathNames = [];
        var newpath = "";
        for(var i = 0, len = link.length - 1; i < len; i++){
            this.parent.pathId.push(ids[i]);
            this.parent.pathNames.push(names[i]);
            newpath += link[i] + "/";
        }
        this.parent.setProperties({
            path: newpath
        }, true);
        return newpath;
    };
    BreadCrumbBar.prototype.onUpdatePath = function() {
        this.onPathChange();
        this.removeSearchValue();
    };
    BreadCrumbBar.prototype.onCreateEnd = function() {
        this.onPathChange();
    };
    BreadCrumbBar.prototype.onRenameEnd = function() {
        this.onPathChange();
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onDeleteEnd = function() {
        this.onUpdatePath();
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.removeSearchValue = function() {
        this.parent.isFiltered = false;
        if (this.searchObj && (this.searchObj.value !== "" || this.searchObj.element.value !== "")) {
            this.searchObj.value = "";
            this.searchObj.element.value = "";
            this.searchObj.dataBind();
        }
    };
    BreadCrumbBar.prototype.onResize = function() {
        this.onPathChange();
    };
    BreadCrumbBar.prototype.onPasteEnd = function() {
        this.onPathChange();
    };
    BreadCrumbBar.prototype.addEventListener = function() {
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.parent.breadCrumbBarNavigation, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        (0, $aqzbR.EventHandler).add(this.parent.breadCrumbBarNavigation, "click", this.addressPathClickHandler, this);
        this.parent.on($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($f592513f3f17ead8$export$f012f19194778278, this.onUpdatePath, this);
        this.parent.on($f592513f3f17ead8$export$30adba19178942b3, this.onUpdatePath, this);
        this.parent.on($f592513f3f17ead8$export$102918c6556d57bd, this.onUpdatePath, this);
        this.parent.on($f592513f3f17ead8$export$d9e8b42c77102776, this.onUpdatePath, this);
        this.parent.on($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd, this);
        this.parent.on($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onRenameEnd, this);
        this.parent.on($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd, this);
        this.parent.on($f592513f3f17ead8$export$d8057c29295b3f97, this.onResize, this);
        this.parent.on($f592513f3f17ead8$export$e936e35532731338, this.onPasteEnd, this);
        this.parent.on($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.onResize, this);
        this.parent.on($f592513f3f17ead8$export$4faa0c3c173303f6, this.onSearchTextChange, this);
        this.parent.on($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit, this);
        this.parent.on($f592513f3f17ead8$export$c8a5c97778a58170, this.onResize, this);
        this.parent.on($f592513f3f17ead8$export$950f16bb18c1805d, this.onPathChange, this);
    };
    BreadCrumbBar.prototype.keyActionHandler = function(e) {
        switch(e.action){
            case "enter":
                this.addressPathClickHandler(e);
                break;
        }
    };
    BreadCrumbBar.prototype.removeEventListener = function() {
        this.keyboardModule.destroy();
        this.parent.off($f592513f3f17ead8$export$f012f19194778278, this.onUpdatePath);
        this.parent.off($f592513f3f17ead8$export$30adba19178942b3, this.onUpdatePath);
        this.parent.off($f592513f3f17ead8$export$102918c6556d57bd, this.onUpdatePath);
        this.parent.off($f592513f3f17ead8$export$d9e8b42c77102776, this.onUpdatePath);
        this.parent.off($f592513f3f17ead8$export$e936e35532731338, this.onPasteEnd);
        this.parent.off($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd);
        this.parent.off($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onRenameEnd);
        this.parent.off($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd);
        this.parent.off($f592513f3f17ead8$export$d8057c29295b3f97, this.onResize);
        this.parent.off($f592513f3f17ead8$export$4ee2cc9ab61ebd89, this.onResize);
        this.parent.off($f592513f3f17ead8$export$4faa0c3c173303f6, this.onSearchTextChange);
        this.parent.off($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit);
        this.parent.off($f592513f3f17ead8$export$c8a5c97778a58170, this.onResize);
        this.parent.off($f592513f3f17ead8$export$950f16bb18c1805d, this.onPathChange);
    };
    /* istanbul ignore next */ BreadCrumbBar.prototype.onDropInit = function(args) {
        if (this.parent.targetModule === this.getModuleName()) {
            var liEle = args.target.closest("li");
            this.parent.dropPath = this.updatePath(liEle.children[0]);
            this.parent.dropData = (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feParent);
            this.triggerFileOpen(this.parent.dropData);
            var treeNodeId = this.parent.pathId[this.parent.pathId.length - 1];
            this.parent.notify($f592513f3f17ead8$export$faa80f63dbb892e4, {
                module: "treeview",
                selectedNode: treeNodeId
            });
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the module name
     * @private
     */ BreadCrumbBar.prototype.getModuleName = function() {
        return "breadcrumbbar";
    };
    BreadCrumbBar.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        /* istanbul ignore next */ if (!(0, $3EnZW.isNullOrUndefined)(this.subMenuObj)) this.subMenuObj.destroy();
        if (!(0, $3EnZW.isNullOrUndefined)(this.searchObj)) this.searchObj.destroy();
    };
    BreadCrumbBar.prototype.onSearchTextChange = function(args) {
        this.searchObj.element.placeholder = this.parent.searchSettings.placeholder != null ? this.parent.searchSettings.placeholder : (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Search") + " " + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, args.cwd.name.toString());
    };
    return BreadCrumbBar;
}();



/**
 * Specifies the default locale of FileManager component
 */ var $0b28dce20ab809c9$export$d7f512c98c859244 = {
    "NewFolder": "New folder",
    "Upload": "Upload",
    "Delete": "Delete",
    "Rename": "Rename",
    "Download": "Download",
    "Cut": "Cut",
    "Copy": "Copy",
    "Paste": "Paste",
    "SortBy": "Sort by",
    "Refresh": "Refresh",
    "Item-Selection": "item selected",
    "Items-Selection": "items selected",
    "View": "View",
    "Details": "Details",
    "SelectAll": "Select all",
    "Open": "Open",
    "Tooltip-NewFolder": "New folder",
    "Tooltip-Upload": "Upload",
    "Tooltip-Delete": "Delete",
    "Tooltip-Rename": "Rename",
    "Tooltip-Download": "Download",
    "Tooltip-Cut": "Cut",
    "Tooltip-Copy": "Copy",
    "Tooltip-Paste": "Paste",
    "Tooltip-SortBy": "Sort by",
    "Tooltip-Refresh": "Refresh",
    "Tooltip-Selection": "Clear selection",
    "Tooltip-View": "View",
    "Tooltip-Details": "Details",
    "Tooltip-SelectAll": "Select all",
    "Name": "Name",
    "Size": "Size",
    "DateModified": "Modified",
    "DateCreated": "Date created",
    "Path": "Path",
    "Modified": "Modified",
    "Created": "Created",
    "Location": "Location",
    "Type": "Type",
    "Permission": "Permission",
    "Ascending": "Ascending",
    "Descending": "Descending",
    "None": "None",
    "View-LargeIcons": "Large icons",
    "View-Details": "Details",
    "Search": "Search",
    "Button-Ok": "OK",
    "Button-Cancel": "Cancel",
    "Button-Yes": "Yes",
    "Button-No": "No",
    "Button-Create": "Create",
    "Button-Save": "Save",
    "Header-NewFolder": "Folder",
    "Content-NewFolder": "Enter your folder name",
    "Header-Rename": "Rename",
    "Content-Rename": "Enter your new name",
    "Header-Rename-Confirmation": "Rename Confirmation",
    "Content-Rename-Confirmation": "If you change a file name extension, the file might become unstable. Are you sure you want to change it?",
    "Header-Delete": "Delete File",
    "Content-Delete": "Are you sure you want to delete this file?",
    "Header-Folder-Delete": "Delete Folder",
    "Content-Folder-Delete": "Are you sure you want to delete this folder?",
    "Header-Multiple-Delete": "Delete Multiple Items",
    "Content-Multiple-Delete": "Are you sure you want to delete these {0} items?",
    "Header-Duplicate": "File/Folder exists",
    "Content-Duplicate": "{0} already exists. Do you want to rename and paste?",
    "Header-Upload": "Upload Files",
    "Error": "Error",
    "Validation-Empty": "The file or folder name cannot be empty.",
    "Validation-Invalid": 'The file or folder name {0} contains invalid characters. Please use a different name. Valid file or folder names cannot end with a dot or space, and cannot contain any of the following characters: \\/:*?"<>|',
    "Validation-NewFolder-Exists": "A file or folder with the name {0} already exists.",
    "Validation-Rename-Exists": "Cannot rename {0} to {1}: destination already exists.",
    "Folder-Empty": "This folder is empty",
    "File-Upload": "Drag files here to upload",
    "Search-Empty": "No results found",
    "Search-Key": "Try with different keywords",
    "Filter-Empty": "No results found",
    "Filter-Key": "Try with different filter",
    "Sub-Folder-Error": "The destination folder is the subfolder of the source folder.",
    "Same-Folder-Error": "The destination folder is the same as the source folder.",
    "Access-Denied": "Access Denied",
    "Access-Details": 'You don"t have permission to access this folder.',
    "Header-Retry": "File Already Exists",
    "Content-Retry": "A file with this name already exists in this folder. What would you like to do?",
    "Button-Keep-Both": "Keep both",
    "Button-Replace": "Replace",
    "Button-Skip": "Skip",
    "ApplyAll-Label": "Do this for all current items",
    "KB": "KB",
    "Access-Message": "{0} is not accessible. You need permission to perform the {1} action.",
    "Network-Error": "NetworkError: Failed to send on XMLHTTPRequest: Failed to load",
    "Server-Error": "ServerError: Invalid response from"
};


var $dadc0c1cfe4fa5dc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dadc0c1cfe4fa5dc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * The FileManager component allows users to access and manage the file system through the web  browser. It can performs the
 * functionalities like add, rename, search, sort, upload and delete files or folders. And also it
 * provides an easy way of  dynamic injectable modules like toolbar, navigationpane, detailsview, largeiconsview.
 * ```html
 *  <div id="file"></div>
 * ```
 * ```typescript,
 *  let feObj: FileManager = new FileManager();
 *  feObj.appendTo('#file');
 * ```
 */ var $dadc0c1cfe4fa5dc$export$a5245c9b2355d1f8 = /** @class */ function(_super) {
    $dadc0c1cfe4fa5dc$var$__extends(FileManager, _super);
    function FileManager(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.filterData = null;
        _this.selectedNodes = [];
        _this.duplicateItems = [];
        _this.duplicateRecords = [];
        _this.previousPath = [];
        _this.nextPath = [];
        _this.existingFileCount = 0;
        _this.isLayoutChange = false;
        _this.layoutSelectedItems = [];
        _this.renamedId = null;
        _this.uploadItem = [];
        _this.deleteRecords = [];
        _this.isFile = false;
        _this.isCut = false;
        _this.isSearchCut = false;
        _this.isSearchDrag = false;
        _this.isPasteError = false;
        _this.folderPath = "";
        _this.isSameAction = false;
        _this.isFiltered = false;
        // Specifies whether the sort by option is clicked or not.
        _this.isSortByClicked = false;
        _this.enablePaste = false;
        _this.persistData = false;
        _this.retryArgs = [];
        _this.isOpened = false;
        _this.isRetryOpened = false;
        _this.isPathDrag = false;
        _this.searchedItems = [];
        _this.retryFiles = [];
        _this.isApplySame = false;
        _this.dragData = [];
        _this.dragNodes = [];
        _this.dragPath = "";
        _this.dropPath = "";
        _this.isDragDrop = false;
        _this.treeExpandTimer = null;
        _this.dragCursorPosition = {
            left: 44,
            top: 18
        };
        _this.isDropEnd = false;
        _this.dragCount = 0;
        _this.droppedObjects = [];
        _this.uploadingCount = 0;
        _this.uploadedCount = 0;
        //Specifies whether the operating system is MAC or not
        _this.isMac = false;
        _this.dragSelectedItems = [];
        FileManager_1.Inject((0, $ac3523cb0a11942e$export$817a8c895c36efa8), (0, $4ae4c662e1820e8a$export$455f788c1604ad53), (0, $761ef639f2f64957$export$8dc6765e8be191c7));
        return _this;
    }
    FileManager_1 = FileManager;
    /**
     * Get component name.
     *
     * @returns {string} - returns module name.
     * @private
     */ FileManager.prototype.getModuleName = function() {
        return "filemanager";
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     */ FileManager.prototype.preRender = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.element.id) || this.element.id === "") this.element.setAttribute("id", (0, $3EnZW.getUniqueID)("filemanager"));
        this.ensurePath();
        this.feParent = [];
        this.feFiles = [];
        (0, $4ZDHT.setStyleAttribute)(this.element, {
            "width": (0, $3EnZW.formatUnit)(this.width),
            "height": (0, $3EnZW.formatUnit)(this.height)
        });
        this.isDevice = (0, $5q7BP.Browser).isDevice;
        this.isMobile = this.checkMobile();
        if (this.isMobile) this.setProperties({
            navigationPaneSettings: {
                visible: false
            }
        }, true);
        var ele = (0, $4ZDHT.closest)(this.element, ".e-bigger");
        this.isBigger = ele ? true : false;
        this.activeModule = this.view === "LargeIcons" ? "largeiconsview" : "detailsview";
        (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
            target: this.element
        }, (0, $4ZDHT.createElement));
        this.addWrapper();
        this.keyConfigs = {
            altN: "alt+n",
            f5: "f5",
            ctrlShift1: "ctrl+shift+1",
            ctrlShift2: "ctrl+shift+2",
            ctrlU: "ctrl+u"
        };
        this.localeObj = new (0, $e7i2H.L10n)(this.getModuleName(), (0, $0b28dce20ab809c9$export$d7f512c98c859244), this.locale);
    };
    /**
     * Gets the properties to be maintained upon browser refresh.
     *
     * @returns {string} - returns the persisted data.
     * @hidden
     */ FileManager.prototype.getPersistData = function() {
        var keyEntity = [
            "view",
            "path",
            "selectedItems"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} - returns module declaration.
     * @hidden
     */ FileManager.prototype.requiredModules = function() {
        var modules = [];
        modules.push({
            member: "breadcrumbbar",
            args: [
                this
            ]
        });
        modules.push({
            member: "largeiconsview",
            args: [
                this
            ]
        });
        if (this.toolbarSettings.visible) modules.push({
            member: "toolbar",
            args: [
                this
            ],
            name: "Toolbar"
        });
        if (this.navigationPaneSettings.visible) modules.push({
            member: "navigationpane",
            args: [
                this
            ],
            name: "NavigationPane"
        });
        if (this.view) modules.push({
            member: "detailsview",
            args: [
                this
            ],
            name: "DetailsView"
        });
        if (this.contextMenuSettings.visible && !this.isDevice) modules.push({
            member: "contextmenu",
            args: [
                this
            ],
            name: "ContextMenu"
        });
        if (this.enableVirtualization) modules.push({
            member: "virtualization",
            args: [
                this
            ],
            name: "Virtualization"
        });
        return modules;
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ FileManager.prototype.render = function() {
        this.initialize();
        var slItems = (0, $3EnZW.isNullOrUndefined)(this.selectedItems) ? [] : this.allowMultiSelection ? this.selectedItems : this.selectedItems.slice(this.selectedItems.length - 1);
        this.setProperties({
            selectedItems: slItems
        }, true);
        this.fileView = this.view;
        this.isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        this.setRtl(this.enableRtl);
        this.addEventListeners();
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this, this.path !== this.originalPath ? $f592513f3f17ead8$export$5d4840440f592fca : $f592513f3f17ead8$export$30adba19178942b3, this.path);
        if (this.fileView === "Details") this.largeiconsviewModule.element.classList.add($15a2a1ec4804cfd7$export$acfd27c680995d44);
        this.adjustHeight();
        if ((0, $3EnZW.isNullOrUndefined)(this.navigationpaneModule)) {
            this.splitterObj.collapse(this.enableRtl ? 1 : 0);
            var bar = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$bec757eb9b4095e5, this.element);
            bar.classList.add($15a2a1ec4804cfd7$export$acfd27c680995d44);
        }
        this.wireEvents();
        this.renderComplete();
    };
    FileManager.prototype.ensurePath = function() {
        var currentPath = this.path;
        if ((0, $3EnZW.isNullOrUndefined)(currentPath)) currentPath = "/";
        if (currentPath.lastIndexOf("/") !== currentPath.length - 1) currentPath = currentPath + "/";
        this.originalPath = currentPath;
        var paths = currentPath.split("/");
        this.setProperties({
            path: paths[0] + "/"
        }, true);
        this.pathNames = [];
        this.pathId = [
            "fe_tree"
        ];
        this.itemData = [];
    };
    FileManager.prototype.initialize = function() {
        if (this.isMobile) (0, $4ZDHT.addClass)([
            this.element
        ], $15a2a1ec4804cfd7$export$10d133fc283ac2c8);
        if (this.allowMultiSelection) (0, $4ZDHT.addClass)([
            this.element
        ], $15a2a1ec4804cfd7$export$8324798886b7308c);
        this.addCssClass(null, this.cssClass);
        this.renderFileUpload();
    };
    FileManager.prototype.addWrapper = function() {
        var headerWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$4b2454a32e09a33d
        });
        this.element.appendChild(headerWrap);
        var layoutWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$2adadcb5e010c2b8,
            className: $15a2a1ec4804cfd7$export$78ca07932ec5b059
        });
        this.element.appendChild(layoutWrap);
        var navigationWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$38ee3afa2b45a08,
            className: $15a2a1ec4804cfd7$export$f52dcf7131a7f04
        });
        var treeWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$5fedb72465b4ade3
        });
        navigationWrap.appendChild(treeWrap);
        var contentWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$1d72a157e3e556f6,
            className: $15a2a1ec4804cfd7$export$5cf3c525b7cf1403
        });
        this.breadCrumbBarNavigation = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$fbc8fb92eac08d2a,
            className: $15a2a1ec4804cfd7$export$c3619772211b515b
        });
        contentWrap.appendChild(this.breadCrumbBarNavigation);
        var gridWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$7e576f6604f42645
        });
        contentWrap.appendChild(gridWrap);
        var largeiconWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$f558f378488ddc5d,
            className: $15a2a1ec4804cfd7$export$aec2fde68eb32201,
            attrs: {
                "role": "group"
            }
        });
        contentWrap.appendChild(largeiconWrap);
        var overlay = this.createElement("span", {
            className: $15a2a1ec4804cfd7$export$abec5a3e0b81aaba
        });
        contentWrap.appendChild(overlay);
        var paneSettings;
        if (!this.enableRtl) {
            layoutWrap.appendChild(navigationWrap);
            layoutWrap.appendChild(contentWrap);
            paneSettings = [
                {
                    size: "25%",
                    min: this.navigationPaneSettings.minWidth.toString(),
                    max: this.navigationPaneSettings.maxWidth.toString()
                },
                {
                    size: "75%",
                    min: "270px"
                }
            ];
        } else {
            layoutWrap.appendChild(contentWrap);
            layoutWrap.appendChild(navigationWrap);
            paneSettings = [
                {
                    size: "75%",
                    min: "270px"
                },
                {
                    size: "25%",
                    min: this.navigationPaneSettings.minWidth.toString(),
                    max: this.navigationPaneSettings.maxWidth.toString()
                }
            ];
        }
        this.splitterObj = new (0, $7bada17cf2b24fe1$export$980082fdfafd21f8)({
            paneSettings: paneSettings,
            width: "100%",
            enableRtl: false,
            enableHtmlSanitizer: this.enableHtmlSanitizer,
            resizing: this.splitterResize.bind(this)
        });
        this.splitterObj.isStringTemplate = true;
        this.splitterObj.appendTo(layoutWrap);
        var dialogWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$59dec0612bc7a4af
        });
        this.element.appendChild(dialogWrap);
        var menuWrap = this.createElement("ul", {
            id: this.element.id + $15a2a1ec4804cfd7$export$4010213931ead79d
        });
        this.element.appendChild(menuWrap);
        var dialogImgWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$e6b68dc330b66d31
        });
        this.element.appendChild(dialogImgWrap);
        var extnDialogWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$5b7b4899d6625112
        });
        this.element.appendChild(extnDialogWrap);
        var uploadDialogWrap = this.createElement("div", {
            id: this.element.id + $15a2a1ec4804cfd7$export$d18d566614d39740
        });
        this.element.appendChild(uploadDialogWrap);
    };
    FileManager.prototype.adjustHeight = function() {
        var toolbar = (0, $4ZDHT.select)("#" + this.element.id + $15a2a1ec4804cfd7$export$4b2454a32e09a33d, this.element);
        var toolBarHeight = toolbar ? toolbar.offsetHeight : 0;
        if (this.splitterObj) {
            this.splitterObj.height = (this.element.clientHeight - toolBarHeight).toString();
            this.splitterObj.dataBind();
        }
    };
    /* istanbul ignore next */ FileManager.prototype.splitterResize = function() {
        this.notify($f592513f3f17ead8$export$d8057c29295b3f97, {});
    };
    FileManager.prototype.splitterAdjust = function() {
        var bar = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$bec757eb9b4095e5, this.element);
        if (this.navigationPaneSettings.visible) {
            this.splitterObj.expand(this.enableRtl ? 1 : 0);
            bar.classList.remove($15a2a1ec4804cfd7$export$acfd27c680995d44);
        } else {
            this.splitterObj.collapse(this.enableRtl ? 1 : 0);
            bar.classList.add($15a2a1ec4804cfd7$export$acfd27c680995d44);
        }
    };
    FileManager.prototype.addCssClass = function(oldOne, newOne) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldOne) && oldOne !== "") (0, $4ZDHT.removeClass)([
            this.element
        ], oldOne.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(newOne) && newOne !== "") (0, $4ZDHT.addClass)([
            this.element
        ], newOne.split(" "));
    };
    FileManager.prototype.showSpinner = function() {
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.element);
    };
    FileManager.prototype.hideSpinner = function() {
        (0, $d4834c37f505aa74$export$95fec50f68454318)(this.element);
    };
    FileManager.prototype.onContextMenu = function(e) {
        e.preventDefault();
    };
    FileManager.prototype.checkMobile = function() {
        return /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test((0, $5q7BP.Browser).userAgent.toLowerCase()) && /mobile/i.test((0, $5q7BP.Browser).userAgent.toLowerCase());
    };
    FileManager.prototype.renderFileUpload = function() {
        var id = this.element.id + $15a2a1ec4804cfd7$export$c84f804ae34d414b;
        var uploadEle = this.createElement("input", {
            id: id,
            attrs: {
                name: "uploadFiles",
                type: "file"
            }
        });
        this.element.appendChild(uploadEle);
        this.uploadDialogObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)({
            header: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this, "Header-Upload"),
            content: uploadEle,
            animationSettings: {
                effect: "None"
            },
            showCloseIcon: true,
            closeOnEscape: true,
            visible: false,
            isModal: true,
            width: "350px",
            target: this.popupTarget ? this.popupTarget : "#" + this.element.id,
            cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this, this.isMobile ? $15a2a1ec4804cfd7$export$2f2a984ccbc6a639 : $15a2a1ec4804cfd7$export$ee3777be229b6eef),
            locale: this.locale,
            allowDragging: true,
            position: {
                X: "center",
                Y: "center"
            },
            enableRtl: this.enableRtl,
            enableHtmlSanitizer: this.enableHtmlSanitizer,
            open: this.onOpen.bind(this),
            close: this.onClose.bind(this),
            beforeOpen: this.onBeforeOpen.bind(this),
            beforeClose: this.onBeforeClose.bind(this)
        });
        this.uploadDialogObj.appendTo("#" + this.element.id + $15a2a1ec4804cfd7$export$d18d566614d39740);
        this.renderUploadBox();
    };
    FileManager.prototype.renderUploadBox = function() {
        var uploadUrl = this.ajaxSettings.uploadUrl ? this.ajaxSettings.uploadUrl : this.ajaxSettings.url;
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            dropArea: (0, $4ZDHT.select)("#" + this.element.id + $15a2a1ec4804cfd7$export$1d72a157e3e556f6, this.element),
            asyncSettings: {
                saveUrl: uploadUrl,
                removeUrl: uploadUrl
            },
            locale: this.locale,
            enableRtl: this.enableRtl,
            uploading: this.onUploading.bind(this),
            removing: this.onRemoving.bind(this),
            canceling: this.onCancel.bind(this),
            clearing: this.onClearing.bind(this),
            selected: this.onSelected.bind(this),
            success: this.onUploadSuccess.bind(this),
            failure: this.onUploadFailure.bind(this),
            autoUpload: this.uploadSettings.autoUpload,
            minFileSize: this.uploadSettings.minFileSize,
            maxFileSize: this.uploadSettings.maxFileSize,
            allowedExtensions: this.uploadSettings.allowedExtensions,
            directoryUpload: this.uploadSettings.directoryUpload,
            fileListRendering: this.onFileListRender.bind(this)
        });
        this.uploadObj.appendTo("#" + this.element.id + $15a2a1ec4804cfd7$export$c84f804ae34d414b);
    };
    FileManager.prototype.onFileListRender = function(args) {
        this.trigger("uploadListCreate", args);
    };
    FileManager.prototype.updateUploader = function() {
        this.uploadObj.autoUpload = this.uploadSettings.autoUpload;
        this.uploadObj.minFileSize = this.uploadSettings.minFileSize;
        this.uploadObj.maxFileSize = this.uploadSettings.maxFileSize;
        this.uploadObj.allowedExtensions = this.uploadSettings.allowedExtensions;
        this.uploadObj.directoryUpload = this.uploadSettings.directoryUpload;
        this.uploadObj.dataBind();
    };
    FileManager.prototype.onBeforeOpen = function(args) {
        var eventArgs = {
            cancel: args.cancel,
            popupName: "Upload",
            popupModule: this.uploadDialogObj
        };
        this.trigger("beforePopupOpen", eventArgs, function(eventargs) {
            args.cancel = eventargs.cancel;
        });
    };
    FileManager.prototype.onBeforeClose = function(args) {
        var eventArgs = {
            cancel: args.cancel,
            popupName: "Upload",
            popupModule: this.uploadDialogObj
        };
        this.trigger("beforePopupClose", eventArgs, function(eventargs) {
            args.cancel = eventargs.cancel;
        });
    };
    FileManager.prototype.onOpen = function() {
        this.isOpened = true;
        this.uploadDialogObj.element.focus();
        var args = {
            popupModule: this.uploadDialogObj,
            popupName: "Upload",
            element: this.uploadDialogObj.element
        };
        this.trigger("popupOpen", args);
    };
    FileManager.prototype.onClose = function() {
        this.isOpened = false;
        this.uploadObj.clearAll();
        var args = {
            popupModule: this.uploadDialogObj,
            popupName: "Upload",
            element: this.uploadDialogObj.element
        };
        this.trigger("popupClose", args);
    };
    /* istanbul ignore next */ FileManager.prototype.onUploading = function(args) {
        var action = "save";
        if (this.retryArgs.length !== 0) {
            for(var i = 0; i < this.retryArgs.length; i++)if (args.fileData.name === this.retryArgs[i].file.name) {
                action = this.retryArgs[i].action;
                this.retryArgs.splice(i, 1);
                i = this.retryArgs.length;
            }
        }
        var data = JSON.stringify((0, $3EnZW.getValue)(this.pathId[this.pathId.length - 1], this.feParent));
        args.customFormData = [
            {
                "path": this.path
            },
            {
                "action": action
            },
            {
                "data": data
            },
            {
                "filename": args.fileData.name
            }
        ];
        var uploadUrl = this.ajaxSettings.uploadUrl ? this.ajaxSettings.uploadUrl : this.ajaxSettings.url;
        var ajaxSettings = {
            url: uploadUrl,
            type: "POST",
            mode: true,
            dataType: null,
            contentType: null,
            data: JSON.stringify(args.customFormData),
            onSuccess: null,
            onFailure: null,
            beforeSend: null
        };
        this.uploadEventArgs = {
            action: "Upload",
            ajaxSettings: ajaxSettings,
            cancel: false
        };
        this.trigger("beforeSend", this.uploadEventArgs, function(uploadEventArgs) {
            args.customFormData = JSON.parse((0, $3EnZW.getValue)("data", uploadEventArgs.ajaxSettings));
            args.cancel = uploadEventArgs.cancel;
            var eventArgs = {
                cancel: false,
                httpRequest: args.currentRequest
            };
            if (typeof (0, $3EnZW.getValue)("beforeSend", uploadEventArgs.ajaxSettings) === "function") {
                (0, $3EnZW.getValue)("beforeSend", uploadEventArgs.ajaxSettings)(eventArgs);
                if ((0, $3EnZW.getValue)("cancel", eventArgs)) args.cancel = (0, $3EnZW.getValue)("cancel", eventArgs);
            }
        });
    };
    FileManager.prototype.onRemoving = function() {
        this.onFileUploadSuccess({
            count: 1
        });
        if (this.uploadObj.getFilesData().length === 1) this.uploadDialogObj.hide();
    };
    /* istanbul ignore next */ FileManager.prototype.onCancel = function(args) {
        var data = JSON.stringify((0, $3EnZW.getValue)(this.pathId[this.pathId.length - 1], this.feParent));
        args.customFormData = [
            {
                "path": this.path
            },
            {
                "action": "remove"
            },
            {
                "data": data
            }
        ];
    };
    /* istanbul ignore next */ FileManager.prototype.onClearing = function() {
        if (this.isOpened) this.uploadDialogObj.hide();
    };
    /* istanbul ignore next */ FileManager.prototype.onSelected = function(args) {
        if (args.filesData.length === 0) return;
        this.uploadingCount = args.filesData.length;
        this.uploadedCount = 0;
        var details = (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this);
        if (!(0, $a3d9eadd9d99207c$export$b8fc31a54b49d5cc)(details)) {
            args.cancel = true;
            (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this, details, $f592513f3f17ead8$export$8dc6cd422363cdbc);
            return;
        }
        this.uploadDialogObj.show();
    };
    FileManager.prototype.onFileUploadSuccess = function(args) {
        this.uploadedCount = this.uploadedCount + args.count;
        if (this.uploadSettings.autoClose && this.uploadingCount === this.uploadedCount) this.uploadDialogObj.hide();
    };
    /* istanbul ignore next */ FileManager.prototype.onUploadSuccess = function(files) {
        var args = {
            action: "Upload",
            result: files
        };
        this.trigger("success", args);
        this.itemData = [
            (0, $3EnZW.getValue)(this.pathId[this.pathId.length - 1], this.feParent)
        ];
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this, $f592513f3f17ead8$export$f012f19194778278, this.path);
        this.onFileUploadSuccess({
            count: 1
        });
        if (typeof (0, $3EnZW.getValue)("onSuccess", this.uploadEventArgs.ajaxSettings) === "function") (0, $3EnZW.getValue)("onSuccess", this.uploadEventArgs.ajaxSettings)();
    };
    /* istanbul ignore next */ FileManager.prototype.onUploadFailure = function(files) {
        var response = (0, $3EnZW.getValue)("response", files);
        var statusText = (0, $3EnZW.getValue)("statusText", response);
        if (statusText !== "") (0, $3EnZW.setValue)("statusText", statusText, files);
        var args = {
            action: "Upload",
            error: files
        };
        this.trigger("failure", args);
        if ((0, $3EnZW.getValue)("statusCode", response) === 400) {
            this.retryFiles.push((0, $3EnZW.getValue)("file", files));
            if (!this.isRetryOpened) (0, $1ded0ca663b14865$export$2d7e4f57882298f)(this, "UploadRetry");
        }
        if (typeof (0, $3EnZW.getValue)("onFailure", this.uploadEventArgs.ajaxSettings) === "function") (0, $3EnZW.getValue)("onFailure", this.uploadEventArgs.ajaxSettings)();
    };
    FileManager.prototype.onInitialEnd = function() {
        (0, $a3d9eadd9d99207c$export$5c336ffc984a639f)(this, this.path);
    };
    FileManager.prototype.addEventListeners = function() {
        this.on($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.showSpinner, this);
        this.on($f592513f3f17ead8$export$5af90369d26bf4d0, this.hideSpinner, this);
        this.on($f592513f3f17ead8$export$5d4840440f592fca, this.onInitialEnd, this);
        this.on($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit, this);
        this.on($f592513f3f17ead8$export$4ba81805392dbd9, this.onFileUploadSuccess, this);
        (0, $aqzbR.EventHandler).add(this.element, "contextmenu", this.onContextMenu, this);
    };
    FileManager.prototype.removeEventListeners = function() {
        if (this.isDestroyed) return;
        this.off($f592513f3f17ead8$export$efdf6d98d39d3b1a, this.showSpinner);
        this.off($f592513f3f17ead8$export$5af90369d26bf4d0, this.hideSpinner);
        this.off($f592513f3f17ead8$export$5d4840440f592fca, this.onInitialEnd);
        this.off($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit);
        this.off($f592513f3f17ead8$export$4ba81805392dbd9, this.onFileUploadSuccess);
        (0, $aqzbR.EventHandler).remove(this.element, "contextmenu", this.onContextMenu);
    };
    FileManager.prototype.onDetailsInit = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.activeModule)) this.itemData = [
            (0, $3EnZW.getValue)(this.pathId[this.pathId.length - 1], this.feParent)
        ];
    };
    FileManager.prototype.resizeHandler = function() {
        this.adjustHeight();
        this.notify($f592513f3f17ead8$export$4ee2cc9ab61ebd89, {});
    };
    FileManager.prototype.keyActionHandler = function(e) {
        var uploadEle;
        switch(e.action){
            case "altN":
                e.preventDefault();
                this.itemData = [
                    (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this)
                ];
                if (!(0, $a3d9eadd9d99207c$export$68aea2408366db21)(this.itemData[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this, this.itemData[0], $f592513f3f17ead8$export$7f45bb9cb17642db);
                else (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this, "NewFolder");
                break;
            case "f5":
                e.preventDefault();
                (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this);
                break;
            /* istanbul ignore next */ case "ctrlShift1":
                e.preventDefault();
                this.fileView = "Details";
                this.setProperties({
                    view: "Details"
                }, true);
                (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.element);
                (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this, "Details");
                break;
            /* istanbul ignore next */ case "ctrlShift2":
                e.preventDefault();
                this.fileView = "LargeIcons";
                this.setProperties({
                    view: "LargeIcons"
                }, true);
                (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.element);
                (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this, "LargeIcons");
                break;
            case "ctrlU":
                e.preventDefault();
                if (this.toolbarSettings.items.indexOf("Upload") !== -1) {
                    uploadEle = (0, $4ZDHT.select)("#" + this.element.id + $15a2a1ec4804cfd7$export$c84f804ae34d414b, this.element);
                    uploadEle.click();
                }
                break;
        }
    };
    FileManager.prototype.wireSelectOnDragEvent = function(isBind) {
        if ((0, $3EnZW.isNullOrUndefined)(this.view)) return;
        if (isBind) this.viewElem = this.view === "LargeIcons" ? this.largeiconsviewModule.element : this.element.querySelector(".e-gridcontent");
        if (!this.viewElem) return;
        if (isBind) {
            if (this.allowMultiSelection) {
                (0, $aqzbR.EventHandler).add(this.viewElem, "mousedown", this.onDragStart, this);
                this.on($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange, this);
                this.on($f592513f3f17ead8$export$6abf7ade54df8039, this.onLayoutChange, this);
            }
        } else {
            (0, $aqzbR.EventHandler).remove(this.viewElem, "mousedown", this.onDragStart);
            this.off($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange);
            this.off($f592513f3f17ead8$export$6abf7ade54df8039, this.onLayoutChange);
        }
    };
    FileManager.prototype.wireEvents = function() {
        if (this.enableRangeSelection) this.wireSelectOnDragEvent(true);
        (0, $aqzbR.EventHandler).add(window, "resize", this.resizeHandler, this);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
    };
    FileManager.prototype.unWireEvents = function() {
        this.wireSelectOnDragEvent(false);
        (0, $aqzbR.EventHandler).remove(window, "resize", this.resizeHandler);
        this.keyboardModule.destroy();
    };
    FileManager.prototype.onDragStart = function(event) {
        if (this.viewElem) {
            if (this.allowDragAndDrop) {
                var targetElement = (0, $4ZDHT.closest)(event.target, this.viewElem.classList.contains("e-large-icons") ? ".e-list-item" : ".e-fe-text");
                if (targetElement) return;
            }
            event.preventDefault();
            this.dragX = event.pageX;
            this.dragY = event.pageY;
            if (!this.dragSelectElement) {
                this.dragSelectElement = (0, $4ZDHT.createElement)("div", {
                    id: this.element.id + "_drag",
                    className: "e-filemanager e-drag-select",
                    styles: "left: " + this.dragX + "px;top: " + this.dragY + "px;"
                });
                document.body.append(this.dragSelectElement);
            }
            (0, $aqzbR.EventHandler).add(document, "mouseup", this.onDragStop, this);
            (0, $aqzbR.EventHandler).add(this.viewElem, "mousemove", this.onDrag, this);
            (0, $aqzbR.EventHandler).add(this.dragSelectElement, "mousemove", this.onDrag, this);
        }
    };
    FileManager.prototype.onDrag = function(event) {
        event.stopPropagation();
        if (this.dragSelectElement) {
            var diffX = event.pageX - this.dragX;
            var diffY = event.pageY - this.dragY;
            (0, $4ZDHT.setStyleAttribute)(this.dragSelectElement, {
                "left": diffX < 0 ? this.dragX + diffX + "px" : this.dragX + "px",
                "top": diffY < 0 ? this.dragY + diffY + "px" : this.dragY + "px",
                "height": Math.abs(diffY) + "px",
                "width": Math.abs(diffX) + "px"
            });
            this.selectItems();
        } else (0, $aqzbR.EventHandler).remove(this.viewElem, "mousemove", this.onDrag);
    };
    FileManager.prototype.onDragStop = function() {
        if (this.viewElem) {
            (0, $aqzbR.EventHandler).remove(document, "mouseup", this.onDragStop);
            (0, $aqzbR.EventHandler).remove(this.viewElem, "mousemove", this.onDrag);
        }
        if (this.dragSelectElement) {
            (0, $aqzbR.EventHandler).remove(this.dragSelectElement, "mousemove", this.onDrag);
            if (this.dragSelectElement.clientHeight > 0 && this.dragSelectElement.clientWidth > 0) this.setProperties({
                selectedItems: this.dragSelectedItems
            });
            this.dragSelectedItems = [];
            (0, $4ZDHT.detach)(this.dragSelectElement);
            this.dragSelectElement = null;
        }
    };
    FileManager.prototype.selectItems = function() {
        this.dragSelectedItems = [];
        var dragRect = this.dragSelectElement.getBoundingClientRect();
        var allItems = (0, $4ZDHT.selectAll)(this.viewElem.classList.contains("e-large-icons") ? ".e-list-item" : ".e-row", this.viewElem);
        (0, $4ZDHT.removeClass)((0, $4ZDHT.selectAll)(".e-active", this.viewElem), [
            "e-active",
            "e-focus"
        ]);
        (0, $4ZDHT.removeClass)((0, $4ZDHT.selectAll)(".e-check", this.viewElem), [
            "e-check"
        ]);
        for(var _i = 0, allItems_1 = allItems; _i < allItems_1.length; _i++){
            var item = allItems_1[_i];
            var itemRect = item.getBoundingClientRect();
            if (!(dragRect.right < itemRect.left || dragRect.left > itemRect.right || dragRect.bottom < itemRect.top || dragRect.top > itemRect.bottom) && this.dragSelectElement.clientHeight > 0 && this.dragSelectElement.clientWidth > 0) {
                if (this.viewElem.classList.contains("e-large-icons")) {
                    item.classList.add("e-active");
                    this.dragSelectedItems.push(item.getAttribute("title"));
                } else {
                    (0, $4ZDHT.addClass)((0, $4ZDHT.selectAll)(".e-rowcell", item), [
                        "e-active"
                    ]);
                    this.dragSelectedItems.push(item.querySelector(".e-drag-text").textContent);
                }
                item.querySelector(".e-frame").classList.add("e-check");
            }
        }
    };
    FileManager.prototype.onLayoutChange = function() {
        if (this.enableRangeSelection) {
            this.unWireEvents();
            this.wireEvents();
        }
    };
    FileManager.prototype.setPath = function() {
        this.setProperties({
            selectedItems: []
        }, true);
        this.ensurePath();
        this.notify($f592513f3f17ead8$export$167b6548d992c399, {
            selectedNode: this.pathId[0]
        });
        (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this, this.path !== this.originalPath ? $f592513f3f17ead8$export$5d4840440f592fca : $f592513f3f17ead8$export$30adba19178942b3, this.path);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {FileManager} newProp
     * @param  {FileManager} oldProp
     * @returns void
     * @private
     */ /* istanbul ignore next */ FileManager.prototype.onPropertyChanged = function(newProp, oldProp) {
        var _this = this;
        var height;
        var requiresRefresh = false;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "ajaxSettings":
                    this.ajaxSettingSetModel(newProp);
                    break;
                case "allowDragAndDrop":
                    this.allowDragAndDrop = newProp.allowDragAndDrop;
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "showItemCheckBoxes":
                    this.showItemCheckBoxes = newProp.showItemCheckBoxes;
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "enableVirtualization":
                    this.enableVirtualization = newProp.enableVirtualization;
                    requiresRefresh = true;
                    break;
                case "allowMultiSelection":
                    if (this.allowMultiSelection) (0, $4ZDHT.addClass)([
                        this.element
                    ], $15a2a1ec4804cfd7$export$8324798886b7308c);
                    else {
                        if (this.selectedItems.length > 1) this.setProperties({
                            selectedItems: this.selectedItems.slice(this.selectedItems.length - 1)
                        }, true);
                        (0, $4ZDHT.removeClass)([
                            this.element
                        ], $15a2a1ec4804cfd7$export$8324798886b7308c);
                    }
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "cssClass":
                    this.addCssClass(oldProp.cssClass, newProp.cssClass);
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "detailsViewSettings":
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "detailsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "enableRangeSelection":
                    this.wireSelectOnDragEvent(false);
                    if (newProp.enableRangeSelection) this.wireSelectOnDragEvent(true);
                    break;
                case "enableRtl":
                    this.enableRtl = newProp.enableRtl;
                    requiresRefresh = true;
                    break;
                case "rootAliasName":
                    this.rootAliasName = newProp.rootAliasName;
                    requiresRefresh = true;
                    break;
                case "height":
                    height = !(0, $3EnZW.isNullOrUndefined)(newProp.height) ? (0, $3EnZW.formatUnit)(newProp.height) : newProp.height;
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "height": height
                    });
                    this.adjustHeight();
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "locale":
                    if (!(0, $3EnZW.isNullOrUndefined)(newProp.enableRtl)) this.setProperties({
                        enableRtl: newProp.enableRtl
                    }, true);
                    this.localeSetModelOption(newProp);
                    break;
                case "navigationPaneSettings":
                    this.splitterAdjust();
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "navigationpane",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "path":
                    this.setPath();
                    break;
                case "searchSettings":
                    if (!(0, $3EnZW.isNullOrUndefined)(newProp.searchSettings.allowSearchOnTyping)) this.setProperties({
                        searchSettings: {
                            allowSearchOnTyping: newProp.searchSettings.allowSearchOnTyping
                        }
                    }, true);
                    if ((0, $3EnZW.isNullOrUndefined)(newProp.searchSettings.ignoreCase)) this.setProperties({
                        searchSettings: {
                            ignoreCase: newProp.searchSettings.ignoreCase
                        }
                    }, true);
                    if ((0, $3EnZW.isNullOrUndefined)(newProp.searchSettings.filterType)) this.setProperties({
                        searchSettings: {
                            filterType: newProp.searchSettings.filterType
                        }
                    }, true);
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "breadcrumbbar",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "selectedItems":
                    if (this.view === "Details") this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "detailsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    else if (this.view === "LargeIcons") this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "largeiconsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "showFileExtension":
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "showHiddenItems":
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "showThumbnail":
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "largeiconsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "toolbarSettings":
                case "toolbarItems":
                    this.adjustHeight();
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "toolbar",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "uploadSettings":
                    this.updateUploader();
                    break;
                case "view":
                    if (newProp.view === "Details") this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "detailsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    else if (newProp.view === "LargeIcons") this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "largeiconsview",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "width":
                    (0, $4ZDHT.setStyleAttribute)(this.element, {
                        "width": !(0, $3EnZW.isNullOrUndefined)(newProp.width) ? (0, $3EnZW.formatUnit)(newProp.width) : newProp.width
                    });
                    this.notify($f592513f3f17ead8$export$80cded91831c5507, {
                        module: "common",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "sortOrder":
                    (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this);
                    this.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
                    break;
                case "sortBy":
                    if (this.view === "Details") {
                        var columns = this.detailsViewSettings.columns;
                        var isValidSortField = !(0, $3EnZW.isNullOrUndefined)(columns) && columns.findIndex(function(col) {
                            return col.field === _this.sortBy;
                        }) !== -1;
                        if (!isValidSortField) return;
                        (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this);
                        this.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
                        this.notify($f592513f3f17ead8$export$18b54396d5a039c5, {});
                    } else {
                        (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this);
                        this.notify($f592513f3f17ead8$export$ebb59e6780002d23, {});
                    }
                    break;
                case "popupTarget":
                    if (this.uploadDialogObj) this.uploadDialogObj.target = newProp.popupTarget;
                    if (this.dialogObj) this.dialogObj.target = newProp.popupTarget;
                    if (this.extDialogObj) this.extDialogObj.target = newProp.popupTarget;
                    if (this.viewerObj) this.viewerObj.target = newProp.popupTarget;
                    break;
                case "fileSystemData":
                    this.fileSystemData = newProp.fileSystemData;
                    requiresRefresh = true;
                    break;
            }
        }
        if (requiresRefresh) this.refresh();
    };
    /* istanbul ignore next */ FileManager.prototype.ajaxSettingSetModel = function(newProp) {
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.ajaxSettings.url)) this.setProperties({
            ajaxSettings: {
                url: newProp.ajaxSettings.url
            }
        }, true);
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.ajaxSettings.uploadUrl)) this.setProperties({
            ajaxSettings: {
                uploadUrl: newProp.ajaxSettings.uploadUrl
            }
        }, true);
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.ajaxSettings.downloadUrl)) this.setProperties({
            ajaxSettings: {
                downloadUrl: newProp.ajaxSettings.downloadUrl
            }
        }, true);
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.ajaxSettings.getImageUrl)) this.setProperties({
            ajaxSettings: {
                getImageUrl: newProp.ajaxSettings.getImageUrl
            }
        }, true);
        this.setProperties({
            path: "/"
        }, true);
        this.setProperties({
            selectedItems: []
        }, true);
        _super.prototype.refresh.call(this);
    };
    /* istanbul ignore next */ FileManager.prototype.localeSetModelOption = function(newProp) {
        this.uploadObj.locale = newProp.locale;
        _super.prototype.refresh.call(this);
    };
    /**
     * Triggers when the component is destroyed.
     *
     * @returns {void}
     */ FileManager.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (!this.refreshing) this.notify($f592513f3f17ead8$export$b1fb4cac938035f7, {});
        this.uploadObj.destroy();
        this.uploadObj = null;
        this.uploadDialogObj.destroy();
        this.uploadDialogObj = null;
        this.splitterObj.destroy();
        this.splitterObj = null;
        if (this.dialogObj) {
            this.dialogObj.destroy();
            this.dialogObj = null;
        }
        if (this.viewerObj) {
            this.viewerObj.destroy();
            this.viewerObj = null;
        }
        if (this.extDialogObj) {
            this.extDialogObj.destroy();
            this.extDialogObj = null;
        }
        this.element.removeAttribute("style");
        this.element.removeAttribute("tabindex");
        this.removeEventListeners();
        this.unWireEvents();
        this.addCssClass(this.cssClass, null);
        (0, $4ZDHT.removeClass)([
            this.element
        ], [
            $15a2a1ec4804cfd7$export$850f7749a2909601,
            $15a2a1ec4804cfd7$export$10d133fc283ac2c8,
            $15a2a1ec4804cfd7$export$8324798886b7308c
        ]);
        this.element.innerHTML = "";
        this.breadCrumbBarNavigation = null;
        this.activeElements = null;
        this.virtualDragElement = null;
        this.visitedItem = null;
        _super.prototype.destroy.call(this);
        this.virtualizationModule = null;
        this.navigationpaneModule = null;
        this.toolbarModule = null;
        this.contextmenuModule = null;
        this.largeiconsviewModule = null;
        this.detailsviewModule = null;
        this.breadcrumbbarModule = null;
        this.viewElem = null;
        this.dragSelectElement = null;
        this.dragSelectedItems = null;
    };
    /**
     * Creates a new folder in file manager.
     *
     * @param {string} name – Specifies the name of new folder in current path.
     * If it is not specified, then the default new folder dialog will be opened.
     * @returns {void}
     */ FileManager.prototype.createFolder = function(name) {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "createFolder"
        });
        var details = [
            (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this)
        ];
        this.itemData = details;
        if (name) {
            if (/[/\\|*?"<>:]/.test(name)) {
                var result = {
                    files: null,
                    error: {
                        code: "402",
                        message: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this, "Validation-Invalid").replace("{0}", '"' + name + '"'),
                        fileExists: null
                    }
                };
                (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this, "Error", result);
            } else if (!(0, $a3d9eadd9d99207c$export$68aea2408366db21)(details[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this, details[0], $f592513f3f17ead8$export$7f45bb9cb17642db);
            else (0, $5703c0df24e3a120$export$b385cd416acc7fdd)(this, name);
        } else (0, $a3d9eadd9d99207c$export$a7450cfe784d304d)(this);
    };
    /**
     * Deletes the folders or files from the given unique identifiers.
     *
     * @param {string} ids - Specifies the name of folders or files in current path. If you want to delete the nested level folders or
     * files, then specify the filter path along with name of the folders or files when performing the search or custom filtering.
     * For ID based file provider, specify the unique identifier of folders or files.
     * If it is not specified, then delete confirmation dialog will be opened for selected item.
     *
     * @returns {void}
     */ FileManager.prototype.deleteFiles = function(ids) {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "deleteFiles",
            ids: ids
        });
    };
    /**
     * Disables the specified toolbar items of the file manager.
     *
     * @param {string[]} items - Specifies an array of items to be disabled.
     * @returns {void}
     */ FileManager.prototype.disableToolbarItems = function(items) {
        if (!(0, $3EnZW.isNullOrUndefined)(items) && this.toolbarModule) this.toolbarModule.enableItems(items, false);
    };
    /**
     * Downloads the folders or files from the given unique identifiers.
     *
     * @param {string} ids - Specifies the name of folders or files in current path. If you want to download the nested level folders
     * or files, then specify the filter path along with name of the folders or files when performing search or custom filtering.
     * For ID based file provider, specify the unique identifier of folders or files.
     * If it is not specified, then the selected items will be downloaded.
     *
     * @returns {void}
     */ FileManager.prototype.downloadFiles = function(ids) {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "downloadFiles",
            ids: ids
        });
    };
    /**
     * Enables the specified toolbar items of the file manager.
     *
     * @param {string[]} items - Specifies an array of items to be enabled.
     * @returns {void}
     */ FileManager.prototype.enableToolbarItems = function(items) {
        if (!(0, $3EnZW.isNullOrUndefined)(items) && this.toolbarModule) this.toolbarModule.enableItems(items, true);
    };
    /**
     * Disables the specified context menu items in file manager. This method is used only in the menuOpen event.
     *
     * @param {string[]} items - Specifies an array of items to be disabled.
     * @returns {void}
     */ FileManager.prototype.disableMenuItems = function(items) {
        if (!(0, $3EnZW.isNullOrUndefined)(items) && !(0, $3EnZW.isNullOrUndefined)(this.contextmenuModule.contextMenu)) this.contextmenuModule.disableItem(items);
    };
    /**
     * Returns the index position of given current context menu item in file manager.
     *
     * @param {string} item - Specifies an item to get the index position.
     * @returns {number} - returns menu item index.
     */ FileManager.prototype.getMenuItemIndex = function(item) {
        if (this.contextmenuModule) return this.contextmenuModule.getItemIndex(item);
        else return -1;
    };
    /**
     * Returns the index position of given toolbar item in file manager.
     *
     * @param {string} item - Specifies an item to get the index position.
     * @returns {number} - returns toolbar item index.
     */ FileManager.prototype.getToolbarItemIndex = function(item) {
        if (this.toolbarModule) return this.toolbarModule.getItemIndex(item);
        else return -1;
    };
    /**
     * Display the custom filtering files in file manager.
     *
     * @param {Object} filterData - Specifies the custom filter details along with custom file action name,
     * which needs to be sent to the server side. If you do not specify the details, then default action name will be `filter`.
     *
     * @returns {void}
     */ FileManager.prototype.filterFiles = function(filterData) {
        this.filterData = filterData ? filterData : null;
        this.setProperties({
            selectedItems: []
        }, true);
        this.notify($f592513f3f17ead8$export$6abf7ade54df8039, {});
        this.isFiltered = true;
        if (this.breadcrumbbarModule.searchObj.element.value !== "") this.breadcrumbbarModule.searchObj.element.value = "";
        (0, $5703c0df24e3a120$export$3dea766d36a8935f)(this, $f592513f3f17ead8$export$cd2e3b33990298ee);
    };
    /**
     * Gets the details of the selected files in the file manager.
     *
     * @returns {Object[]} - returns selected files.
     */ FileManager.prototype.getSelectedFiles = function() {
        this.notify($f592513f3f17ead8$export$ed7f9366d0aedd6a, {});
        return this.itemData;
    };
    /**
     * Opens the corresponding file or folder from the given unique identifier.
     *
     * @param {string} id - Specifies the name of folder or file in current path. If you want to open the nested level folder or
     * file, then specify the filter path along with name of the folder or file when performing search or custom filtering. For ID based
     * file provider, specify the unique identifier of folder or file.
     *
     * @returns {void}
     */ FileManager.prototype.openFile = function(id) {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "openFile",
            id: id
        });
    };
    /**
     * Refreshes the folder files of the file manager.
     *
     * @returns {void}
     */ FileManager.prototype.refreshFiles = function() {
        (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(this);
    };
    /**
     * Refreshes the layout of the file manager.
     *
     * @returns {void}
     */ FileManager.prototype.refreshLayout = function() {
        this.adjustHeight();
        this.notify($f592513f3f17ead8$export$c8a5c97778a58170, {});
    };
    /**
     * Selects the entire folders and files in current path.
     *
     * @returns {void}
     */ FileManager.prototype.selectAll = function() {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "selectAll"
        });
    };
    /**
     * Specifies the method that must be invoked to traverse the path backwards in the file manager.
     *
     * @returns {void}
     */ FileManager.prototype.traverseBackward = function() {
        if (this.pathNames.length > 1 && this.breadcrumbbarModule.searchObj.element.value === "" && !this.isFiltered) {
            this.pathId.pop();
            this.pathNames.pop();
            var newPath = this.pathNames.slice(1).join("/");
            newPath = newPath === "" ? "/" : "/" + newPath + "/";
            this.setProperties({
                path: newPath
            }, true);
            (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this, $f592513f3f17ead8$export$f012f19194778278, this.path);
            var treeNodeId = this.pathId[this.pathId.length - 1];
            this.notify($f592513f3f17ead8$export$faa80f63dbb892e4, {
                module: "treeview",
                selectedNode: treeNodeId
            });
        }
    };
    /**
     * Deselects the currently selected folders and files in current path.
     *
     * @returns {void}
     */ FileManager.prototype.clearSelection = function() {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "clearSelection"
        });
    };
    /**
     * Renames the file or folder with given new name in file manager.
     *
     * @param {string} id - Specifies the name of folder or file in current path. If you want to rename the nested level folder or
     * file, then specify the filter path along with name of the folder or file when performing search or custom filtering. For ID based
     * file provider, specify the unique identifier of folder or file.
     * If it is not specified, then rename dialog will be opened for selected item.
     *
     * @param {string} name – Specifies the new name of the file or folder in current path. If it is not specified, then rename dialog
     * will be opened for given identifier.
     *
     * @returns {void}
     */ FileManager.prototype.renameFile = function(id, name) {
        this.notify($f592513f3f17ead8$export$5cd299b993c9e318, {
            action: "renameFile",
            id: id,
            newName: name
        });
    };
    /**
     * Opens the upload dialog in file manager.
     *
     * @returns {void}
     */ FileManager.prototype.uploadFiles = function() {
        var details = [
            (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this)
        ];
        this.itemData = details;
        (0, $a3d9eadd9d99207c$export$e5277fc94f47f9c6)(this);
    };
    /**
     * Specifies the method which must be invoked to programmatically close the dialog popup in the file manager.
     *
     * @returns {void}
     */ FileManager.prototype.closeDialog = function() {
        (0, $a3d9eadd9d99207c$export$e6889fb0929ccf91)(this);
    };
    /**
     * Specifies the direction of FileManager
     *
     * @param {boolean} rtl - specifies rtl parameter.
     * @returns {void}
     */ FileManager.prototype.setRtl = function(rtl) {
        if (rtl) this.addCssClass(null, $15a2a1ec4804cfd7$export$850f7749a2909601);
        else this.addCssClass($15a2a1ec4804cfd7$export$850f7749a2909601, null);
        if (this.uploadObj) {
            this.uploadDialogObj.enableRtl = rtl;
            this.uploadObj.enableRtl = rtl;
        }
    };
    var FileManager_1;
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $89f25b044ddeaaea$export$c7d0cd64e9070819))
    ], FileManager.prototype, "ajaxSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)([])
    ], FileManager.prototype, "fileSystemData", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManager.prototype, "allowDragAndDrop", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManager.prototype, "allowMultiSelection", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManager.prototype, "showItemCheckBoxes", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $4532973e3b134128$export$87795476079a01f9))
    ], FileManager.prototype, "contextMenuSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("")
    ], FileManager.prototype, "cssClass", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $b165f47ecab2e2f8$export$2414f677b69712c))
    ], FileManager.prototype, "detailsViewSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManager.prototype, "enableHtmlSanitizer", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManager.prototype, "enablePersistence", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManager.prototype, "enableVirtualization", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("400px")
    ], FileManager.prototype, "height", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("LargeIcons")
    ], FileManager.prototype, "view", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $d1b6780e16f65095$export$246cb6a888617168))
    ], FileManager.prototype, "navigationPaneSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("/")
    ], FileManager.prototype, "path", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FileManager.prototype, "popupTarget", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $fdd3737878e30161$export$352475af1e1a6201))
    ], FileManager.prototype, "searchSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)()
    ], FileManager.prototype, "selectedItems", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManager.prototype, "showFileExtension", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FileManager.prototype, "rootAliasName", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManager.prototype, "showHiddenItems", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManager.prototype, "showThumbnail", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("Ascending")
    ], FileManager.prototype, "sortOrder", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("name")
    ], FileManager.prototype, "sortBy", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FileManager.prototype, "sortComparer", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManager.prototype, "enableRangeSelection", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $dc7b44f9b460d0c8$export$b468e96770a3e7db))
    ], FileManager.prototype, "toolbarSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $dc7b44f9b460d0c8$export$cb67beb212e92bbd))
    ], FileManager.prototype, "toolbarItems", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $5aa4792b5d1e0993$export$a2087ef30e892b25))
    ], FileManager.prototype, "uploadSettings", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], FileManager.prototype, "width", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileLoad", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileOpen", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeDownload", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeImageLoad", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforePopupClose", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforePopupOpen", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeSend", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "created", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeFolderCreate", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "folderCreate", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "destroyed", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeDelete", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "delete", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeRename", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "rename", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "beforeMove", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "move", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "search", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileDragStart", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileDragging", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileDragStop", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileDropped", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileSelection", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "fileSelect", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "menuClick", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "menuOpen", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "menuClose", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "failure", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "popupClose", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "popupOpen", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "success", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "toolbarClick", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "toolbarCreate", void 0);
    $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManager.prototype, "uploadListCreate", void 0);
    FileManager = FileManager_1 = $dadc0c1cfe4fa5dc$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], FileManager);
    return FileManager;
}((0, $hQxLN.Component));

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $eAUyT = parcelRequire("eAUyT");
var $g9Ic7 = parcelRequire("g9Ic7");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");
var $3P3ke = parcelRequire("3P3ke");
var $i528u = parcelRequire("i528u");





var $71c78e892be7c33f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $71c78e892be7c33f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $71c78e892be7c33f$var$ROOT = "e-treeview";
var $71c78e892be7c33f$var$CONTROL = "e-control";
var $71c78e892be7c33f$var$COLLAPSIBLE = "e-icon-collapsible";
var $71c78e892be7c33f$var$EXPANDABLE = "e-icon-expandable";
var $71c78e892be7c33f$var$LISTITEM = "e-list-item";
var $71c78e892be7c33f$var$LISTTEXT = "e-list-text";
var $71c78e892be7c33f$var$LISTWRAP = "e-text-wrap";
var $71c78e892be7c33f$var$IELISTWRAP = "e-ie-wrap";
var $71c78e892be7c33f$var$PARENTITEM = "e-list-parent";
var $71c78e892be7c33f$var$HOVER = "e-hover";
var $71c78e892be7c33f$var$ACTIVE = "e-active";
var $71c78e892be7c33f$var$LOAD = "e-icons-spinner";
var $71c78e892be7c33f$var$PROCESS = "e-process";
var $71c78e892be7c33f$var$ICON = "e-icons";
var $71c78e892be7c33f$var$TEXTWRAP = "e-text-content";
var $71c78e892be7c33f$var$INPUT = "e-input";
var $71c78e892be7c33f$var$INPUTGROUP = "e-input-group";
var $71c78e892be7c33f$var$TREEINPUT = "e-tree-input";
var $71c78e892be7c33f$var$EDITING = "e-editing";
var $71c78e892be7c33f$var$RTL = "e-rtl";
var $71c78e892be7c33f$var$INTERACTION = "e-interaction";
var $71c78e892be7c33f$var$DRAGITEM = "e-drag-item";
var $71c78e892be7c33f$var$DROPPABLE = "e-droppable";
var $71c78e892be7c33f$var$DRAGGING = "e-dragging";
var $71c78e892be7c33f$var$SIBLING = "e-sibling";
var $71c78e892be7c33f$var$DROPIN = "e-drop-in";
var $71c78e892be7c33f$var$DROPNEXT = "e-drop-next";
var $71c78e892be7c33f$var$DROPOUT = "e-drop-out";
var $71c78e892be7c33f$var$NODROP = "e-no-drop";
var $71c78e892be7c33f$var$FULLROWWRAP = "e-fullrow-wrap";
var $71c78e892be7c33f$var$FULLROW = "e-fullrow";
var $71c78e892be7c33f$var$SELECTED = "e-selected";
var $71c78e892be7c33f$var$EXPANDED = "e-expanded";
var $71c78e892be7c33f$var$NODECOLLAPSED = "e-node-collapsed";
var $71c78e892be7c33f$var$DISABLE = "e-disable";
var $71c78e892be7c33f$var$DROPCOUNT = "e-drop-count";
var $71c78e892be7c33f$var$CHECK = "e-check";
var $71c78e892be7c33f$var$INDETERMINATE = "e-stop";
var $71c78e892be7c33f$var$CHECKBOXWRAP = "e-treeview-checkbox";
var $71c78e892be7c33f$var$CHECKBOXFRAME = "e-frame";
var $71c78e892be7c33f$var$CHECKBOXRIPPLE = "e-ripple-container";
var $71c78e892be7c33f$var$RIPPLE = "e-ripple";
var $71c78e892be7c33f$var$RIPPLEELMENT = "e-ripple-element";
var $71c78e892be7c33f$var$FOCUS = "e-node-focus";
var $71c78e892be7c33f$var$IMAGE = "e-list-img";
var $71c78e892be7c33f$var$BIGGER = "e-bigger";
var $71c78e892be7c33f$var$SMALL = "e-small";
var $71c78e892be7c33f$var$CHILD = "e-has-child";
var $71c78e892be7c33f$var$ITEM_ANIMATION_ACTIVE = "e-animation-active";
var $71c78e892be7c33f$var$DISABLED = "e-disabled";
var $71c78e892be7c33f$var$PREVENTSELECT = "e-prevent";
var $71c78e892be7c33f$var$treeAriaAttr = {
    treeRole: "group",
    itemRole: "treeitem",
    listRole: "group",
    itemText: "",
    wrapperRole: ""
};
/**
 * Configures the fields to bind to the properties of node in the TreeView component.
 */ var $71c78e892be7c33f$export$c3ab4f2afb2ecd8f = /** @class */ function(_super) {
    $71c78e892be7c33f$var$__extends(FieldsSettings, _super);
    function FieldsSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("child")
    ], FieldsSettings.prototype, "child", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)([])
    ], FieldsSettings.prototype, "dataSource", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("expanded")
    ], FieldsSettings.prototype, "expanded", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("hasChildren")
    ], FieldsSettings.prototype, "hasChildren", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("htmlAttributes")
    ], FieldsSettings.prototype, "htmlAttributes", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("iconCss")
    ], FieldsSettings.prototype, "iconCss", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("id")
    ], FieldsSettings.prototype, "id", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("imageUrl")
    ], FieldsSettings.prototype, "imageUrl", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("isChecked")
    ], FieldsSettings.prototype, "isChecked", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("parentID")
    ], FieldsSettings.prototype, "parentID", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FieldsSettings.prototype, "query", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("selectable")
    ], FieldsSettings.prototype, "selectable", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("selected")
    ], FieldsSettings.prototype, "selected", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FieldsSettings.prototype, "tableName", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("text")
    ], FieldsSettings.prototype, "text", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("tooltip")
    ], FieldsSettings.prototype, "tooltip", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("navigateUrl")
    ], FieldsSettings.prototype, "navigateUrl", void 0);
    return FieldsSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures animation settings for the TreeView component.
 */ var $71c78e892be7c33f$export$fc826ffccae27283 = /** @class */ function(_super) {
    $71c78e892be7c33f$var$__extends(ActionSettings, _super);
    function ActionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("SlideDown")
    ], ActionSettings.prototype, "effect", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(400)
    ], ActionSettings.prototype, "duration", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("linear")
    ], ActionSettings.prototype, "easing", void 0);
    return ActionSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the animation settings for expanding and collapsing nodes in TreeView.
 */ var $71c78e892be7c33f$export$419f99ebc99c8f2a = /** @class */ function(_super) {
    $71c78e892be7c33f$var$__extends(NodeAnimationSettings, _super);
    function NodeAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Complex)({
            effect: "SlideUp",
            duration: 400,
            easing: "linear"
        }, $71c78e892be7c33f$export$fc826ffccae27283)
    ], NodeAnimationSettings.prototype, "collapse", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Complex)({
            effect: "SlideDown",
            duration: 400,
            easing: "linear"
        }, $71c78e892be7c33f$export$fc826ffccae27283)
    ], NodeAnimationSettings.prototype, "expand", void 0);
    return NodeAnimationSettings;
}((0, $3fcxu.ChildProperty));
/**
 * The TreeView component is used to represent hierarchical data in a tree like structure with advanced
 * functions to perform edit, drag and drop, selection with check-box, and more.
 * ```html
 * <div id="tree"></div>
 * ```
 * ```typescript
 * let treeObj: TreeView = new TreeView();
 * treeObj.appendTo('#tree');
 * ```
 */ var $71c78e892be7c33f$export$6940b0d9c820eca7 = /** @class */ function(_super) {
    $71c78e892be7c33f$var$__extends(TreeView, _super);
    function TreeView(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isRefreshed = false;
        _this.preventExpand = false;
        _this.checkedElement = [];
        _this.disableNode = [];
        _this.validArr = [];
        _this.validNodes = [];
        _this.expandChildren = [];
        _this.isFieldChange = false;
        _this.changeDataSource = false;
        _this.hasTemplate = false;
        _this.isFirstRender = false;
        // Specifies whether the node is dropped or not
        _this.isNodeDropped = false;
        _this.isInteracted = false;
        _this.isRightClick = false;
        _this.mouseDownStatus = false;
        _this.isDropIn = false;
        _this.OldCheckedData = [];
        return _this;
    }
    TreeView_1 = TreeView;
    /**
     * Get component name.
     *
     * @returns {string} - returns module name.
     * @private
     */ TreeView.prototype.getModuleName = function() {
        return "treeview";
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     */ TreeView.prototype.preRender = function() {
        var _this = this;
        this.checkActionNodes = [];
        this.parentNodeCheck = [];
        this.dragStartAction = false;
        this.isAnimate = false;
        this.keyConfigs = {
            escape: "escape",
            end: "end",
            enter: "enter",
            f2: "f2",
            home: "home",
            moveDown: "downarrow",
            moveLeft: "leftarrow",
            moveRight: "rightarrow",
            moveUp: "uparrow",
            ctrlDown: "ctrl+downarrow",
            ctrlUp: "ctrl+uparrow",
            ctrlEnter: "ctrl+enter",
            ctrlHome: "ctrl+home",
            ctrlEnd: "ctrl+end",
            ctrlA: "ctrl+A",
            shiftDown: "shift+downarrow",
            shiftUp: "shift+uparrow",
            shiftEnter: "shift+enter",
            shiftHome: "shift+home",
            shiftEnd: "shift+end",
            csDown: "ctrl+shift+downarrow",
            csUp: "ctrl+shift+uparrow",
            csEnter: "ctrl+shift+enter",
            csHome: "ctrl+shift+home",
            csEnd: "ctrl+shift+end",
            space: "space",
            shiftSpace: "shift+space",
            ctrlSpace: "ctrl+space"
        };
        this.listBaseOption = {
            expandCollapse: true,
            showIcon: true,
            expandIconClass: $71c78e892be7c33f$var$EXPANDABLE,
            ariaAttributes: $71c78e892be7c33f$var$treeAriaAttr,
            expandIconPosition: "Left",
            itemCreated: function(e) {
                _this.beforeNodeCreate(e);
            },
            enableHtmlSanitizer: this.enableHtmlSanitizer,
            itemNavigable: this.fullRowNavigable
        };
        this.updateListProp(this.fields);
        this.aniObj = new (0, $kj1BR.Animation)({});
        this.treeList = [];
        this.isLoaded = false;
        this.isInitalExpand = false;
        this.expandChildren = [];
        this.index = 0;
        this.setTouchClass();
        this.DDTTreeData = JSON.parse(JSON.stringify(this.fields.dataSource));
        if ((0, $3EnZW.isNullOrUndefined)(this.selectedNodes)) this.setProperties({
            selectedNodes: []
        }, true);
        if ((0, $3EnZW.isNullOrUndefined)(this.checkedNodes)) this.setProperties({
            checkedNodes: []
        }, true);
        if ((0, $3EnZW.isNullOrUndefined)(this.expandedNodes)) this.setProperties({
            expandedNodes: []
        }, true);
        else this.isInitalExpand = true;
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - returns the persisted data
     * @hidden
     */ TreeView.prototype.getPersistData = function() {
        var keyEntity = [
            "selectedNodes",
            "checkedNodes",
            "expandedNodes"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ TreeView.prototype.render = function() {
        this.initialRender = true;
        this.initialize();
        this.setDataBinding(false);
        this.setDisabledMode();
        this.setExpandOnType();
        if (!this.disabled) this.setRipple();
        this.wireEditingEvents(this.allowEditing);
        this.setDragAndDrop(this.allowDragAndDrop);
        if (!this.disabled) this.wireEvents();
        this.initialRender = false;
        this.renderComplete();
    };
    TreeView.prototype.initialize = function() {
        this.element.setAttribute("role", "tree");
        this.element.setAttribute("aria-activedescendant", this.element.id + "_active");
        this.setCssClass(null, this.cssClass);
        this.setEnableRtl();
        this.setFullRow(this.fullRowSelect);
        this.setTextWrap();
        this.nodeTemplateFn = this.templateComplier(this.nodeTemplate);
    };
    TreeView.prototype.setDisabledMode = function() {
        if (this.disabled) {
            this.element.classList.add($71c78e892be7c33f$var$DISABLED);
            this.element.setAttribute("aria-disabled", "true");
        } else {
            this.element.classList.remove($71c78e892be7c33f$var$DISABLED);
            this.element.setAttribute("aria-disabled", "false");
        }
    };
    TreeView.prototype.setEnableRtl = function() {
        (this.enableRtl ? (0, $4ZDHT.addClass) : (0, $4ZDHT.removeClass))([
            this.element
        ], $71c78e892be7c33f$var$RTL);
    };
    TreeView.prototype.setRipple = function() {
        var tempStr = "." + $71c78e892be7c33f$var$FULLROW + ",." + $71c78e892be7c33f$var$TEXTWRAP;
        var rippleModel = {
            selector: tempStr,
            ignore: "." + $71c78e892be7c33f$var$TEXTWRAP + " > ." + $71c78e892be7c33f$var$ICON + ",." + $71c78e892be7c33f$var$INPUTGROUP + ",." + $71c78e892be7c33f$var$INPUT + ", ." + $71c78e892be7c33f$var$CHECKBOXWRAP
        };
        this.rippleFn = (0, $kj1BR.rippleEffect)(this.element, rippleModel);
        var iconModel = {
            selector: "." + $71c78e892be7c33f$var$TEXTWRAP + " > ." + $71c78e892be7c33f$var$ICON,
            isCenterRipple: true
        };
        this.rippleIconFn = (0, $kj1BR.rippleEffect)(this.element, iconModel);
    };
    TreeView.prototype.setFullRow = function(isEnabled) {
        (isEnabled ? (0, $4ZDHT.addClass) : (0, $4ZDHT.removeClass))([
            this.element
        ], $71c78e892be7c33f$var$FULLROWWRAP);
    };
    TreeView.prototype.setMultiSelect = function(isEnabled) {
        if (isEnabled) this.element.setAttribute("aria-multiselectable", "true");
        else this.element.setAttribute("aria-multiselectable", "false");
    };
    TreeView.prototype.templateComplier = function(template) {
        if (template) {
            this.hasTemplate = true;
            this.element.classList.add($71c78e892be7c33f$var$INTERACTION);
            try {
                if (typeof template !== "function" && document.querySelectorAll(template).length) return (0, $c2qqN.compile)(document.querySelector(template).innerHTML.trim());
                else return (0, $c2qqN.compile)(template);
            } catch (e) {
                return (0, $c2qqN.compile)(template);
            }
        }
        this.element.classList.remove($71c78e892be7c33f$var$INTERACTION);
        return undefined;
    };
    TreeView.prototype.setDataBinding = function(changeDataSource) {
        var _this = this;
        this.treeList.push("false");
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            this.isOffline = this.fields.dataSource.dataSource.offline;
            if (this.fields.dataSource.ready) this.fields.dataSource.ready.then(function(e) {
                _this.isOffline = _this.fields.dataSource.dataSource.offline;
                if (_this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && _this.isOffline) {
                    _this.treeList.pop();
                    _this.treeData = e.result;
                    _this.isNumberTypeId = _this.getType();
                    _this.setRootData();
                    _this.renderItems(true);
                    if (_this.treeList.length === 0 && !_this.isLoaded) _this.finalize();
                }
            }).catch(function(e) {
                _this.trigger("actionFailure", {
                    error: e
                });
            });
            else this.fields.dataSource.executeQuery(this.getQuery(this.fields)).then(function(e) {
                _this.treeList.pop();
                _this.treeData = e.result;
                _this.isNumberTypeId = _this.getType();
                _this.setRootData();
                if (changeDataSource) _this.changeDataSource = true;
                _this.renderItems(true);
                _this.changeDataSource = false;
                if (_this.treeList.length === 0 && !_this.isLoaded) _this.finalize();
            }).catch(function(e) {
                _this.trigger("actionFailure", {
                    error: e
                });
            });
        } else {
            this.treeList.pop();
            if ((0, $3EnZW.isNullOrUndefined)(this.fields.dataSource)) this.rootData = this.treeData = [];
            else {
                this.treeData = JSON.parse(JSON.stringify(this.fields.dataSource));
                this.setRootData();
            }
            this.isNumberTypeId = this.getType();
            this.renderItems(false);
        }
        if (this.treeList.length === 0 && !this.isLoaded) this.finalize();
    };
    TreeView.prototype.getQuery = function(mapper, value) {
        if (value === void 0) value = null;
        var columns = [];
        var query;
        if (!mapper.query) {
            query = new (0, $56262f229d1cff45$export$62297b13309008b2)();
            var prop = this.getActualProperties(mapper);
            for(var _i = 0, _a = Object.keys(prop); _i < _a.length; _i++){
                var col = _a[_i];
                if (col !== "dataSource" && col !== "tableName" && col !== "child" && !!mapper["" + col] && col !== "url" && columns.indexOf(mapper["" + col]) === -1) columns.push(mapper["" + col]);
            }
            query.select(columns);
            if (Object.prototype.hasOwnProperty.call(prop, "tableName")) query.from(mapper.tableName);
        } else query = mapper.query.clone();
        (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).addSorting(this.sortOrder, mapper.text, query);
        if (!(0, $3EnZW.isNullOrUndefined)(value) && !(0, $3EnZW.isNullOrUndefined)(mapper.parentID)) query.where(mapper.parentID, "equal", this.isNumberTypeId ? parseFloat(value) : value);
        return query;
    };
    TreeView.prototype.getType = function() {
        return this.treeData[0] ? typeof (0, $3EnZW.getValue)(this.fields.id, this.treeData[0]) === "number" ? true : false : false;
    };
    TreeView.prototype.setRootData = function() {
        this.dataType = this.getDataType(this.treeData, this.fields);
        if (this.dataType === 1) {
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
            var rootItems = this.getChildNodes(this.treeData, undefined, true);
            if ((0, $3EnZW.isNullOrUndefined)(rootItems)) this.rootData = [];
            else this.rootData = rootItems;
        } else this.rootData = this.treeData;
    };
    TreeView.prototype.isChildObject = function() {
        if (typeof this.fields.child === "object") return true;
        else return false;
    };
    TreeView.prototype.renderItems = function(isSorted) {
        this.listBaseOption.ariaAttributes.level = 1;
        var sortedData = this.getSortedData(this.rootData);
        this.ulElement = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, isSorted ? this.rootData : sortedData, this.listBaseOption);
        this.element.appendChild(this.ulElement);
        var rootNodes = this.ulElement.querySelectorAll(".e-list-item");
        if (this.loadOnDemand === false) {
            var i = 0;
            while(i < rootNodes.length){
                this.renderChildNodes(rootNodes[parseInt(i.toString(), 10)], true, null, true);
                i++;
            }
        }
        var parentEle = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$PARENTITEM, this.element);
        if (parentEle.length === 1 && rootNodes && rootNodes.length !== 0 || this.loadOnDemand) this.finalizeNode(this.element);
        this.parentNodeCheck = [];
        this.parentCheckData = [];
        this.updateCheckedStateFromDS();
        if (this.autoCheck && this.showCheckBox && !this.isLoaded) this.updateParentCheckState();
    };
    /**
     * Update the checkedNodes from datasource at initial rendering
     *
     * @returns {void}
     */ TreeView.prototype.updateCheckedStateFromDS = function() {
        this.validNodes = [];
        if (this.treeData && this.showCheckBox) {
            if (this.dataType === 1) {
                var mapper = this.fields;
                var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.isChecked, "equal", true, false));
                for(var i = 0; i < resultData.length; i++){
                    var resultId = resultData[parseInt(i.toString(), 10)][this.fields.id] ? resultData[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                    if (this.checkedNodes.indexOf(resultId) === -1 && !this.isLoaded) this.checkDisabledState(resultId, resultData[i]);
                    if (resultData[parseInt(i.toString(), 10)][this.fields.hasChildren]) {
                        var id = resultData[parseInt(i.toString(), 10)][this.fields.id];
                        var childData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.parentID, "equal", id, false));
                        for(var child = 0; child < childData.length; child++){
                            var childId = childData[parseInt(child.toString(), 10)][this.fields.id] ? childData[parseInt(child.toString(), 10)][this.fields.id].toString() : null;
                            if (this.checkedNodes.indexOf(childId) === -1 && this.autoCheck) this.checkDisabledState(childId, childData[child]);
                        }
                    }
                }
                for(var i = 0; i < this.checkedNodes.length; i++){
                    var mapper_1 = this.fields;
                    var checkState = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper_1.id, "equal", this.checkedNodes[parseInt(i.toString(), 10)], true));
                    if (checkState[0] && this.autoCheck) {
                        this.getCheckedNodeDetails(mapper_1, checkState);
                        this.checkIndeterminateState(checkState[0]);
                    }
                    if (checkState.length > 0) {
                        var checkedId = checkState[0][this.fields.id] ? checkState[0][this.fields.id].toString() : null;
                        if (this.checkedNodes.indexOf(checkedId) > -1 && this.validNodes.indexOf(checkedId) === -1) this.validNodes.push(checkedId);
                    }
                    var checkedData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper_1.parentID, "equal", this.checkedNodes[parseInt(i.toString(), 10)], true));
                    for(var index = 0; index < checkedData.length; index++){
                        var checkedId = checkedData[parseInt(index.toString(), 10)][this.fields.id] ? checkedData[parseInt(index.toString(), 10)][this.fields.id].toString() : null;
                        if (this.checkedNodes.indexOf(checkedId) === -1 && this.autoCheck) this.checkDisabledState(checkedId, checkedData[index]);
                        if (this.checkedNodes.indexOf(checkedId) > -1 && this.validNodes.indexOf(checkedId) === -1) this.validNodes.push(checkedId);
                    }
                }
            } else if (this.dataType === 2 || this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.isOffline) {
                for(var index = 0; index < this.treeData.length; index++){
                    var fieldId = this.treeData[parseInt(index.toString(), 10)][this.fields.id] ? this.treeData[parseInt(index.toString(), 10)][this.fields.id].toString() : "";
                    if (this.treeData[parseInt(index.toString(), 10)][this.fields.isChecked] && !this.isLoaded && this.checkedNodes.indexOf(fieldId) === -1) this.checkDisabledState(fieldId, this.treeData[index]);
                    if (this.checkedNodes.indexOf(fieldId) > -1 && this.validNodes.indexOf(fieldId) === -1) this.validNodes.push(fieldId);
                    var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), this.treeData[parseInt(index.toString(), 10)]);
                    if (childItems) this.updateChildCheckState(childItems, this.treeData[parseInt(index.toString(), 10)]);
                }
                this.validNodes = this.enablePersistence ? this.checkedNodes : this.validNodes;
            }
            this.setProperties({
                checkedNodes: this.validNodes
            }, true);
        }
    };
    /**
     * To check whether the list data has sub child and to change the parent check state accordingly
     *
     * @param {FieldsSettingsModel} mapper - The mapper object containing field settings.
     * @param {Object[]} checkNodes - The array of checked nodes.
     * @returns {void}
     * @private
     */ TreeView.prototype.getCheckedNodeDetails = function(mapper, checkNodes) {
        var id = checkNodes[0][this.fields.parentID] ? checkNodes[0][this.fields.parentID].toString() : null;
        var count = 0;
        var element = this.element.querySelector('[data-uid="' + checkNodes[0][this.fields.id] + '"]');
        var parentEle = this.element.querySelector('[data-uid="' + checkNodes[0][this.fields.parentID] + '"]');
        if (!element && !parentEle) {
            if (this.parentNodeCheck.indexOf(id) === -1) this.parentNodeCheck.push(id);
            var childNodes = this.getChildNodes(this.treeData, id);
            for(var i = 0; i < childNodes.length; i++){
                var childId = childNodes[parseInt(i.toString(), 10)][this.fields.id] ? childNodes[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                if (this.checkedNodes.indexOf(childId) !== -1) count++;
                if (count === childNodes.length && this.checkedNodes.indexOf(id) === -1) this.checkDisabledState(id);
            }
            var preElement = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.id, "equal", id, true));
            this.getCheckedNodeDetails(mapper, preElement);
        } else if (parentEle) {
            var check = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECK, parentEle);
            if (!check) this.changeState(parentEle, "indeterminate", null, true, true);
        }
    };
    /**
     * Update the checkedNodes and parent state when all the child Nodes are in checkedstate at initial rendering
     *
     * @returns {void}
     * @private
     */ TreeView.prototype.updateParentCheckState = function() {
        var indeterminate = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$INDETERMINATE, this.element);
        var childCheckedElement;
        var data = this.treeData;
        if (this.element.classList.contains("e-filtering")) data = this.DDTTreeData;
        for(var i = 0; i < indeterminate.length; i++){
            var node = (0, $4ZDHT.closest)(indeterminate[parseInt(i.toString(), 10)], "." + $71c78e892be7c33f$var$LISTITEM);
            var nodeId = node.getAttribute("data-uid").toString();
            var OldCheckedNodes = void 0;
            if (this.element.classList.contains("e-filtering")) OldCheckedNodes = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.OldCheckedData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("parentID", "equal", nodeId, true));
            if (this.dataType === 1) childCheckedElement = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(data).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.fields.parentID, "equal", nodeId, true));
            else childCheckedElement = this.getChildNodes(data, nodeId);
            var count = 0;
            if (childCheckedElement) {
                var _loop_1 = function(j) {
                    var childId = childCheckedElement[parseInt(j.toString(), 10)][this_1.fields.id].toString();
                    if (this_1.checkedNodes.indexOf(childId) !== -1) count++;
                    else if (this_1.element.classList.contains("e-filtering") && OldCheckedNodes.findIndex(function(e) {
                        return e["id"] === childId;
                    }) !== -1) count++;
                };
                var this_1 = this;
                for(var j = 0; j < childCheckedElement.length; j++)_loop_1(j);
                if (count === childCheckedElement.length) {
                    var nodeCheck = node.getAttribute("data-uid");
                    if (this.checkedNodes.indexOf(nodeCheck) === -1) this.checkDisabledState(nodeCheck);
                    this.changeState(node, "check", null, true, true);
                } else if (count === 0 && this.checkedNodes.length === 0) this.changeState(node, "uncheck", null, true, true);
            }
            var parentElement = (0, $4ZDHT.closest)(node, "." + $71c78e892be7c33f$var$PARENTITEM);
            if (!(0, $3EnZW.isNullOrUndefined)(parentElement)) this.ensureParentCheckState((0, $4ZDHT.closest)(parentElement, "." + $71c78e892be7c33f$var$LISTITEM));
        }
    };
    /**
     * Change the parent to indeterminate state whenever the child is in checked state which is not rendered in DOM
     *
     * @param {Object} data - The data object to check for indeterminate state.
     * @returns {void}
     * @private
     */ TreeView.prototype.checkIndeterminateState = function(data) {
        var element;
        if (this.dataType === 1) element = this.element.querySelector('[data-uid="' + data[this.fields.parentID] + '"]');
        else element = this.element.querySelector('[data-uid="' + data[this.fields.id] + '"]');
        if (element) {
            var ariaChecked = element.getAttribute("aria-checked");
            if (ariaChecked !== "true") this.changeState(element, "indeterminate", null, true, true);
        } else if (this.dataType === 2) {
            if (this.parentNodeCheck.indexOf(data[this.fields.id].toString()) === -1) this.parentNodeCheck.push(data[this.fields.id].toString());
        }
    };
    /**
     * Update the checkedNodes for child and subchild from datasource (hierarchical datasource) at initial rendering
     *
     * @param {Object[]} childItems - The array of child items to update the checked state.
     * @param {Object} treeData - The tree data object containing field values.
     * @returns {void}
     * @private
     */ TreeView.prototype.updateChildCheckState = function(childItems, treeData) {
        var count = 0;
        var checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : "";
        for(var index = 0; index < childItems.length; index++){
            var checkedChild = childItems[parseInt(index.toString(), 10)][this.fields.id] ? childItems[parseInt(index.toString(), 10)][this.fields.id].toString() : "";
            if (childItems[parseInt(index.toString(), 10)][this.fields.isChecked] && !this.isLoaded && this.checkedNodes.indexOf(checkedChild) === -1) this.checkDisabledState(checkedChild, childItems[index]);
            if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1 && this.autoCheck) this.checkDisabledState(checkedChild, childItems[index]);
            if (this.checkedNodes.indexOf(checkedChild) !== -1 && this.autoCheck) count++;
            if (this.checkedNodes.indexOf(checkedChild) > -1 && this.validNodes.indexOf(checkedChild) === -1) this.validNodes.push(checkedChild);
            var subChildItems = (0, $3EnZW.getValue)(this.fields.child.toString(), childItems[parseInt(index.toString(), 10)]);
            if (subChildItems && subChildItems.length) {
                if (this.parentCheckData.indexOf(treeData) === -1) this.parentCheckData.push(treeData);
                this.updateChildCheckState(subChildItems, childItems[parseInt(index.toString(), 10)]);
            }
            if (count === childItems.length && this.autoCheck && this.checkedNodes.indexOf(checkedParent) === -1) this.checkDisabledState(checkedParent, treeData);
        }
        if (count !== 0 && this.autoCheck) {
            this.checkIndeterminateState(treeData);
            for(var len = 0; len < this.parentCheckData.length; len++)if (treeData !== this.parentCheckData[parseInt(len.toString(), 10)] && this.parentCheckData[parseInt(len.toString(), 10)]) this.checkIndeterminateState(this.parentCheckData[parseInt(len.toString(), 10)]);
        }
        this.parentCheckData = [];
    };
    TreeView.prototype.beforeNodeCreate = function(e) {
        if (this.showCheckBox) {
            var checkboxEle = (0, $6a51972c93f30c96$export$1ef36a84bae94342)(this.createElement, true, {
                cssClass: this.touchClass
            });
            checkboxEle.classList.add($71c78e892be7c33f$var$CHECKBOXWRAP);
            var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, e.item);
            var id = e.item.getAttribute("data-uid");
            e.item.childNodes[0].insertBefore(checkboxEle, e.item.childNodes[0].childNodes[(0, $3EnZW.isNullOrUndefined)(icon) ? 0 : 1]);
            var checkValue = (0, $3EnZW.getValue)(e.fields.isChecked, e.curData);
            if (this.checkedNodes.indexOf(id) > -1) {
                (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXFRAME, checkboxEle).classList.add($71c78e892be7c33f$var$CHECK);
                e.item.setAttribute("aria-checked", "true");
                this.addCheck(e.item);
            } else if (!(0, $3EnZW.isNullOrUndefined)(checkValue) && checkValue.toString() === "true") {
                (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXFRAME, checkboxEle).classList.add($71c78e892be7c33f$var$CHECK);
                e.item.setAttribute("aria-checked", "true");
                this.addCheck(e.item);
            } else e.item.setAttribute("aria-checked", "false");
            var frame = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXFRAME, checkboxEle);
            (0, $aqzbR.EventHandler).add(frame, "mousedown", this.frameMouseHandler, this);
            (0, $aqzbR.EventHandler).add(frame, "mouseup", this.frameMouseHandler, this);
        }
        if (this.fullRowSelect) this.createFullRow(e.item);
        if (this.allowMultiSelection && !e.item.classList.contains($71c78e892be7c33f$var$SELECTED)) e.item.setAttribute("aria-selected", "false");
        var fields = e.fields;
        this.addActionClass(e, fields.selected, $71c78e892be7c33f$var$SELECTED);
        this.addActionClass(e, fields.expanded, $71c78e892be7c33f$var$EXPANDED);
        e.item.setAttribute("tabindex", "-1");
        (0, $aqzbR.EventHandler).add(e.item, "focus", this.focusIn, this);
        if (!(0, $3EnZW.isNullOrUndefined)(this.nodeTemplateFn)) {
            var textEle = e.item.querySelector("." + $71c78e892be7c33f$var$LISTTEXT);
            var dataId = e.item.getAttribute("data-uid");
            textEle.innerHTML = "";
            this.renderNodeTemplate(e.curData, textEle, dataId);
        }
        var eventArgs = {
            node: e.item,
            nodeData: e.curData,
            text: e.text
        };
        if (!this.isRefreshed) {
            this.trigger("drawNode", eventArgs);
            if (e.curData[this.fields.selectable] === false && !this.showCheckBox) {
                e.item.classList.add($71c78e892be7c33f$var$PREVENTSELECT);
                e.item.firstElementChild.setAttribute("style", "cursor: not-allowed");
            }
        }
    };
    TreeView.prototype.frameMouseHandler = function(e) {
        var rippleSpan = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXRIPPLE, e.target.parentElement);
        (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
    };
    TreeView.prototype.addActionClass = function(e, action, cssClass) {
        var data = e.curData;
        var actionValue = (0, $3EnZW.getValue)(action, data);
        if (!(0, $3EnZW.isNullOrUndefined)(actionValue) && actionValue.toString() !== "false") e.item.classList.add(cssClass);
    };
    TreeView.prototype.getDataType = function(ds, mapper) {
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            for(var i = 0; i < ds.length; i++){
                if (this.isOffline) {
                    if (typeof mapper.child === "string" && (0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, ds[parseInt(i.toString(), 10)])) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.parentID, ds[parseInt(i.toString(), 10)]))) return 1;
                } else if (typeof mapper.child === "string" && (0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, ds[parseInt(i.toString(), 10)]))) return 1;
            }
            return 2;
        }
        for(var i = 0, len = ds.length; i < len; i++){
            if (typeof mapper.child === "string" && (!(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, ds[parseInt(i.toString(), 10)])) || Object.prototype.hasOwnProperty.call(ds[parseInt(i.toString(), 10)], mapper.child))) return 2;
            if (this.isChildObject()) return 2;
            if (!(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.parentID, ds[parseInt(i.toString(), 10)])) || !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.hasChildren, ds[parseInt(i.toString(), 10)]))) return 1;
        }
        return 1;
    };
    TreeView.prototype.getGroupedData = function(dataSource, groupBy) {
        var cusQuery = new (0, $56262f229d1cff45$export$62297b13309008b2)().group(groupBy);
        var ds = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).getDataSource(dataSource, cusQuery);
        var grpItem = [];
        for(var j = 0; j < ds.length; j++){
            var itemObj = ds[parseInt(j.toString(), 10)].items;
            grpItem.push(itemObj);
        }
        return grpItem;
    };
    TreeView.prototype.getSortedData = function(list) {
        if (list && this.sortOrder !== "None") list = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).getDataSource(list, (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).addSorting(this.sortOrder, this.fields.text));
        return list;
    };
    TreeView.prototype.finalizeNode = function(element, isFromExpandAll, expandChild) {
        var _this = this;
        if (!isFromExpandAll) this.updateAttributes(element);
        if (!expandChild) {
            var eNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$EXPANDED, element);
            if (!this.loadOnDemand && this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.isInitalExpand = this.treeData.filter(function(e) {
                return e[_this.fields.expanded] === true;
            }).length > 0 ? true : this.isInitalExpand;
            if (!this.isInitalExpand) for(var i = 0; i < eNodes.length; i++)this.renderChildNodes(eNodes[parseInt(i.toString(), 10)]);
            (0, $4ZDHT.removeClass)(eNodes, $71c78e892be7c33f$var$EXPANDED);
        }
        if (!isFromExpandAll) this.updateList();
        if (this.isLoaded) this.updateCheckedProp();
    };
    TreeView.prototype.updateAttributes = function(element) {
        var iNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$IMAGE, element);
        for(var k = 0; k < iNodes.length; k++)iNodes[parseInt(k.toString(), 10)].setAttribute("alt", $71c78e892be7c33f$var$IMAGE);
        if (this.isLoaded) {
            var sNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$SELECTED, element);
            for(var i = 0; i < sNodes.length; i++){
                this.selectNode(sNodes[parseInt(i.toString(), 10)], null);
                break;
            }
            (0, $4ZDHT.removeClass)(sNodes, $71c78e892be7c33f$var$SELECTED);
        }
        var cNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM + ":not(." + $71c78e892be7c33f$var$EXPANDED + ")", element);
        for(var j = 0; j < cNodes.length; j++){
            var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, cNodes[parseInt(j.toString(), 10)]);
            if (icon && icon.classList.contains($71c78e892be7c33f$var$EXPANDABLE)) this.disableExpandAttr(cNodes[parseInt(j.toString(), 10)]);
        }
    };
    TreeView.prototype.updateCheckedProp = function() {
        if (this.showCheckBox) {
            var nodes = [].concat([], this.checkedNodes);
            this.setProperties({
                checkedNodes: nodes
            }, true);
        }
    };
    TreeView.prototype.ensureIndeterminate = function() {
        if (this.autoCheck) {
            var liElement = (0, $4ZDHT.selectAll)("li", this.element);
            var ulElement = void 0;
            for(var i = 0; i < liElement.length; i++)if (liElement[parseInt(i.toString(), 10)].classList.contains($71c78e892be7c33f$var$LISTITEM)) {
                ulElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, liElement[parseInt(i.toString(), 10)]);
                if (ulElement) this.ensureParentCheckState(liElement[parseInt(i.toString(), 10)]);
                else this.ensureChildCheckState(liElement[parseInt(i.toString(), 10)]);
            }
        } else {
            var indeterminate = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$INDETERMINATE, this.element);
            for(var i = 0; i < indeterminate.length; i++)indeterminate[parseInt(i.toString(), 10)].classList.remove($71c78e892be7c33f$var$INDETERMINATE);
        }
    };
    TreeView.prototype.ensureParentCheckState = function(element) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            if (element.classList.contains($71c78e892be7c33f$var$ROOT)) return;
            var ulElement = element;
            if (element.classList.contains($71c78e892be7c33f$var$LISTITEM)) ulElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, element);
            var checkedNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$CHECKBOXWRAP + " ." + $71c78e892be7c33f$var$CHECK, ulElement);
            var indeterminateNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$INDETERMINATE, ulElement);
            var nodes = (0, $4ZDHT.selectAll)(this.checkDisabledChildren ? "." + $71c78e892be7c33f$var$LISTITEM : "." + $71c78e892be7c33f$var$LISTITEM + ":not(." + $71c78e892be7c33f$var$DISABLE + ")", ulElement);
            var checkBoxEle = element.getElementsByClassName($71c78e892be7c33f$var$CHECKBOXWRAP)[0];
            var count = nodes.length;
            var checkedCount = checkedNodes.length;
            var dataUid_1 = element.getAttribute("data-uid");
            if (this.element.classList.contains("e-filtering")) {
                var oldCheckedNodes = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.OldCheckedData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("parentID", "equal", dataUid_1, true));
                checkedCount = oldCheckedNodes.length;
                var parentNode = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.OldCheckedData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("hasChildren", "equal", true, true));
                if (parentNode.length > 0 && this.OldCheckedData.some(function(oldNode) {
                    return oldNode.id === dataUid_1;
                })) checkedCount = parentNode.length;
                var childItems = [];
                if (this.dataType === 1) childItems = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.DDTTreeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.fields.parentID, "equal", dataUid_1, true));
                else childItems = this.getChildNodes(this.DDTTreeData, dataUid_1);
                count = childItems.length;
            }
            if (count === 0 && checkedCount === 0) return;
            else if (count === checkedCount) this.changeState(checkBoxEle, "check", null, true, true);
            else if (checkedCount > 0 || indeterminateNodes.length > 0) this.changeState(checkBoxEle, "indeterminate", null, true, true);
            else if (checkedCount === 0) this.changeState(checkBoxEle, "uncheck", null, true, true);
            var parentUL = (0, $4ZDHT.closest)(element, "." + $71c78e892be7c33f$var$PARENTITEM);
            if (!(0, $3EnZW.isNullOrUndefined)(parentUL)) {
                var currentParent = (0, $4ZDHT.closest)(parentUL, "." + $71c78e892be7c33f$var$LISTITEM);
                this.ensureParentCheckState(currentParent);
            }
        }
    };
    TreeView.prototype.ensureChildCheckState = function(element, e, isFromExpandAll) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            var childElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, element);
            var checkBoxes = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(childElement)) {
                checkBoxes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$CHECKBOXWRAP, childElement);
                var isChecked = element.getElementsByClassName($71c78e892be7c33f$var$CHECKBOXFRAME)[0].classList.contains($71c78e892be7c33f$var$CHECK);
                var parentCheck = element.getElementsByClassName($71c78e892be7c33f$var$CHECKBOXFRAME)[0].classList.contains($71c78e892be7c33f$var$INDETERMINATE);
                var childCheck = childElement.querySelectorAll("li");
                var checkedState = void 0;
                for(var index = 0; index < checkBoxes.length; index++){
                    var childId = childCheck[parseInt(index.toString(), 10)].getAttribute("data-uid");
                    if (!(0, $3EnZW.isNullOrUndefined)(this.currentLoadData) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(this.fields.isChecked, this.currentLoadData[parseInt(index.toString(), 10)]))) {
                        checkedState = (0, $3EnZW.getValue)(this.fields.isChecked, this.currentLoadData[parseInt(index.toString(), 10)]) ? "check" : "uncheck";
                        if (this.ele !== -1) checkedState = isChecked ? "check" : "uncheck";
                        if (checkedState === "uncheck" && !(0, $3EnZW.isUndefined)(this.parentNodeCheck) && this.autoCheck && this.parentNodeCheck.indexOf(childId) !== -1) {
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                            checkedState = "indeterminate";
                        }
                    } else {
                        var isNodeChecked = checkBoxes[parseInt(index.toString(), 10)].getElementsByClassName($71c78e892be7c33f$var$CHECKBOXFRAME)[0].classList.contains($71c78e892be7c33f$var$CHECK);
                        if (isChecked) checkedState = "check";
                        else if (isNodeChecked && !this.isLoaded) checkedState = "check";
                        else if (this.checkedNodes.indexOf(childId) !== -1 && this.isLoaded && (parentCheck || isChecked)) checkedState = "check";
                        else if (childCheck[parseInt(index.toString(), 10)].classList.contains($71c78e892be7c33f$var$CHILD) && !(0, $3EnZW.isUndefined)(this.parentNodeCheck) && this.autoCheck && (isChecked || parentCheck) && this.parentNodeCheck.indexOf(childId) !== -1) {
                            checkedState = "indeterminate";
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                        } else if (this.dataType === 1 && !(0, $3EnZW.isUndefined)(this.parentNodeCheck) && this.autoCheck && (isChecked || parentCheck) && this.parentNodeCheck.indexOf(childId) !== -1) {
                            checkedState = "indeterminate";
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                        } else checkedState = "uncheck";
                    }
                    this.changeState(checkBoxes[parseInt(index.toString(), 10)], checkedState, e, true, true);
                }
            }
            if (this.autoCheck && this.isLoaded && !isFromExpandAll) this.updateParentCheckState();
        }
    };
    TreeView.prototype.doCheckBoxAction = function(nodes, doCheck) {
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) {
            nodes.reverse();
            for(var len = nodes.length - 1; len >= 0; len--){
                var liEle = this.getElement(nodes[parseInt(len.toString(), 10)]);
                if ((0, $3EnZW.isNullOrUndefined)(liEle)) {
                    var node = nodes[len - nodes.length] ? nodes[len - nodes.length].toString() : nodes[parseInt(len.toString(), 10)] ? nodes[parseInt(len.toString(), 10)].toString() : null;
                    if (node !== "" && doCheck && node) {
                        this.setValidCheckedNode(node);
                        this.dynamicCheckState(node, doCheck);
                    } else if (this.checkedNodes.indexOf(node) !== -1 && node !== "" && !doCheck) {
                        this.checkedNodes.splice(this.checkedNodes.indexOf(node), 1);
                        var childItems = this.getChildNodes(this.treeData, node);
                        if (childItems) {
                            for(var i = 0; i < childItems.length; i++){
                                var id = childItems[parseInt(i.toString(), 10)][this.fields.id] ? childItems[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                                if (this.checkedNodes.indexOf(id) !== -1) {
                                    this.checkedNodes.splice(this.checkedNodes.indexOf(id), 1);
                                    var ele = this.element.querySelector('[data-uid="' + id + '"]');
                                    if (ele) this.changeState(ele, "uncheck", null);
                                }
                            }
                            if (this.parentNodeCheck.indexOf(node) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(node), 1);
                        }
                        if (node) this.dynamicCheckState(node, doCheck);
                        this.updateField(this.treeData, this.fields, node, "isChecked", null);
                    }
                    continue;
                }
                var checkBox = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM + " ." + $71c78e892be7c33f$var$CHECKBOXWRAP, liEle);
                this.validateCheckNode(checkBox, !doCheck, liEle, null);
            }
        } else {
            var checkBoxes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$CHECKBOXWRAP, this.element);
            if (this.loadOnDemand) for(var index = 0; index < checkBoxes.length; index++){
                this.updateFieldChecked(checkBoxes[parseInt(index.toString(), 10)], doCheck);
                this.changeState(checkBoxes[parseInt(index.toString(), 10)], doCheck ? "check" : "uncheck", null, null, null, doCheck);
            }
            else for(var index = 0; index < checkBoxes.length; index++){
                this.updateFieldChecked(checkBoxes[parseInt(index.toString(), 10)], doCheck);
                this.changeState(checkBoxes[parseInt(index.toString(), 10)], doCheck ? "check" : "uncheck");
            }
        }
        if (nodes) for(var j = 0; j < nodes.length - 1; j++){
            var node = nodes[parseInt(j.toString(), 10)] ? nodes[parseInt(j.toString(), 10)].toString() : "";
            if (!doCheck) this.updateField(this.treeData, this.fields, node, "isChecked", null);
        }
        if (this.autoCheck) this.updateParentCheckState();
    };
    TreeView.prototype.updateFieldChecked = function(checkbox, doCheck) {
        var currLi = (0, $4ZDHT.closest)(checkbox, "." + $71c78e892be7c33f$var$LISTITEM);
        var id = currLi.getAttribute("data-uid");
        var nodeDetails = this.getNodeData(currLi);
        if (nodeDetails.isChecked === "true" && !doCheck) this.updateField(this.treeData, this.fields, id, "isChecked", null);
    };
    /**
     * Changes the parent and child  check state while changing the checkedNodes via setmodel
     *
     * @param {string} node - The unique identifier of the node.
     * @param {boolean} doCheck - A boolean value indicating whether to check or uncheck the node.
     * @returns {void}
     * @private
     */ TreeView.prototype.dynamicCheckState = function(node, doCheck) {
        if (this.dataType === 1) {
            var count = 0;
            var resultId = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.fields.id, "equal", node, true));
            if (resultId[0]) {
                var id = resultId[0][this.fields.id] ? resultId[0][this.fields.id].toString() : null;
                var parent_1 = resultId[0][this.fields.parentID] ? resultId[0][this.fields.parentID].toString() : null;
                var parentElement = this.element.querySelector('[data-uid="' + parent_1 + '"]');
                var element = this.element.querySelector('[data-uid="' + id + '"]');
                var childNodes = this.getChildNodes(this.treeData, parent_1);
                if (childNodes) for(var i = 0; i < childNodes.length; i++){
                    var childId = childNodes[parseInt(i.toString(), 10)][this.fields.id] ? childNodes[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                    if (this.checkedNodes.indexOf(childId) !== -1) count++;
                }
                if (this.checkedNodes.indexOf(node) !== -1 && parentElement && id === node && this.autoCheck) this.changeState(parentElement, "indeterminate", null);
                else if (this.checkedNodes.indexOf(node) === -1 && element && id === node && !doCheck) this.changeState(element, "uncheck", null);
                else if (this.checkedNodes.indexOf(node) !== -1 && element && id === node && doCheck) this.changeState(element, "check", null);
                else if (this.checkedNodes.indexOf(node) === -1 && !element && parentElement && id === node && this.autoCheck && count !== 0) this.changeState(parentElement, "indeterminate", null);
                else if (this.checkedNodes.indexOf(node) === -1 && !element && parentElement && id === node && this.autoCheck && count === 0) this.changeState(parentElement, "uncheck", null);
                else if (!element && !parentElement && id === node && this.autoCheck) this.updateIndeterminate(node, doCheck);
            }
        } else if (this.dataType === 2 || this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.isOffline) {
            var id = void 0;
            var parentElement = void 0;
            var check = void 0;
            for(var i = 0; i < this.treeData.length; i++){
                id = this.treeData[parseInt(i.toString(), 10)][this.fields.id] ? this.treeData[parseInt(i.toString(), 10)][this.fields.id].toString() : "";
                parentElement = this.element.querySelector('[data-uid="' + id + '"]');
                check = parentElement ? (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECK, parentElement) : null;
                if (this.checkedNodes.indexOf(id) === -1 && parentElement && check && !doCheck) this.changeState(parentElement, "uncheck", null);
                var subChild = (0, $3EnZW.getValue)(this.fields.child.toString(), this.treeData[parseInt(i.toString(), 10)]);
                if (subChild) this.updateChildIndeterminate(subChild, id, node, doCheck, id);
            }
        }
    };
    /**
     * updates the parent and child  check state while changing the checkedNodes via setmodel for listData
     *
     * @param {string} node - The unique identifier of the node.
     * @param {boolean} doCheck - A boolean value indicating whether to check or uncheck the node.
     * @returns {void}
     * @private
     */ TreeView.prototype.updateIndeterminate = function(node, doCheck) {
        var indeterminateData = this.getTreeData(node);
        var count = 0;
        var parent;
        if (this.dataType === 1) parent = indeterminateData[0][this.fields.parentID] ? indeterminateData[0][this.fields.parentID].toString() : null;
        var childNodes = this.getChildNodes(this.treeData, parent);
        if (childNodes) for(var i = 0; i < childNodes.length; i++){
            var childId = childNodes[parseInt(i.toString(), 10)][this.fields.id] ? childNodes[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
            if (this.checkedNodes.indexOf(childId) !== -1) count++;
        }
        var parentElement = this.element.querySelector('[data-uid="' + parent + '"]');
        if (parentElement && doCheck) this.changeState(parentElement, "indeterminate", null);
        else if (!doCheck && parentElement && this.parentNodeCheck.indexOf(parent) === -1 && count !== 0) this.changeState(parentElement, "indeterminate", null);
        else if (!doCheck && parentElement && this.parentNodeCheck.indexOf(parent) === -1 && count === 0) this.changeState(parentElement, "uncheck", null);
        else if (!parentElement) {
            if (!doCheck && this.checkedNodes.indexOf(parent) === -1 && this.parentNodeCheck.indexOf(parent) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(parent), 1);
            else if (doCheck && this.checkedNodes.indexOf(parent) === -1 && this.parentNodeCheck.indexOf(parent) === -1) this.parentNodeCheck.push(parent);
            else if (!doCheck && this.checkedNodes.indexOf(parent) !== -1 && this.parentNodeCheck.indexOf(parent) === -1 && count !== 0) this.parentNodeCheck.push(parent);
            this.updateIndeterminate(parent, doCheck);
            if (this.checkedNodes.indexOf(parent) !== -1 && !doCheck) this.checkedNodes.splice(this.checkedNodes.indexOf(parent), 1);
        }
    };
    /**
     * updates the parent and child  check state while changing the checkedNodes via setmodel for hierarchical data
     *
     * @param {Object[]} subChild - Array of child nodes
     * @param {string} parent - Parent identifier
     * @param {string} node - Current node identifier
     * @param {boolean} doCheck - Boolean indicating whether to perform a check
     * @param {string} [child] - Optional child identifier
     * @returns {void}
     * @private
     */ TreeView.prototype.updateChildIndeterminate = function(subChild, parent, node, doCheck, child) {
        var count = 0;
        for(var j = 0; j < subChild.length; j++){
            var subId = subChild[parseInt(j.toString(), 10)][this.fields.id] ? subChild[parseInt(j.toString(), 10)][this.fields.id].toString() : "";
            if (this.checkedNodes.indexOf(subId) !== -1) count++;
            var parentElement = this.element.querySelector('[data-uid="' + parent + '"]');
            var indeterminate = parentElement ? (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$INDETERMINATE, parentElement) : null;
            var check = parentElement ? (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECK, parentElement) : null;
            var element = this.element.querySelector('[data-uid="' + subId + '"]');
            var childElementCheck = element ? (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECK, element) : null;
            if (this.checkedNodes.indexOf(node) !== -1 && parentElement && subId === node && this.autoCheck) this.changeState(parentElement, "indeterminate", null);
            else if (this.checkedNodes.indexOf(node) === -1 && parentElement && !element && subId === node && !doCheck) {
                if (this.autoCheck) this.changeState(parentElement, "uncheck", null);
                else if (count !== 0) this.changeState(parentElement, "indeterminate", null);
                else this.changeState(parentElement, "uncheck", null);
            } else if (this.checkedNodes.indexOf(node) === -1 && element && subId === node && !doCheck) this.changeState(element, "uncheck", null);
            else if (this.checkedNodes.indexOf(node) === -1 && indeterminate && subId === node && this.autoCheck && count === 0 && !doCheck) indeterminate.classList.remove($71c78e892be7c33f$var$INDETERMINATE);
            else if (this.checkedNodes.indexOf(node) === -1 && !element && check && subId === node && count === 0) this.changeState(parentElement, "uncheck", null);
            else if (this.checkedNodes.indexOf(subId) === -1 && element && childElementCheck && count === 0) this.changeState(element, "uncheck", null);
            else if (!element && !parentElement && subId === node || this.parentNodeCheck.indexOf(parent) !== -1 && this.autoCheck) {
                var childElement = this.element.querySelector('[data-uid="' + child + '"]');
                if (doCheck && count !== 0) this.changeState(childElement, "indeterminate", null);
                else if (doCheck && count === subChild.length && this.checkedNodes.indexOf(parent) === -1) this.checkDisabledState(parent);
                else if (!doCheck && count === 0 && this.parentNodeCheck.indexOf(parent) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(parent));
                if (this.parentNodeCheck.indexOf(parent) === -1) this.parentNodeCheck.push(parent);
            }
            var innerChild = (0, $3EnZW.getValue)(this.fields.child.toString(), subChild[parseInt(j.toString(), 10)]);
            if (innerChild) this.updateChildIndeterminate(innerChild, subId, node, doCheck, child);
        }
    };
    TreeView.prototype.changeState = function(wrapper, state, e, isPrevent, isAdd, doCheck) {
        var _this = this;
        var eventArgs;
        var currLi = (0, $4ZDHT.closest)(wrapper, "." + $71c78e892be7c33f$var$LISTITEM);
        if (!this.checkDisabledChildren && currLi && (currLi.classList.contains($71c78e892be7c33f$var$DISABLE) || this.disableNode && this.disableNode.indexOf(currLi.getAttribute("data-uid")) !== -1)) return;
        if (wrapper === currLi) wrapper = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXWRAP, currLi);
        if (!isPrevent) {
            this.checkActionNodes = [];
            eventArgs = this.getCheckEvent(currLi, state, e);
            this.trigger("nodeChecking", eventArgs, function(observedArgs) {
                if (!observedArgs.cancel) _this.nodeCheckAction(wrapper, state, currLi, observedArgs, e, isPrevent, isAdd, doCheck);
            });
        } else this.nodeCheckAction(wrapper, state, currLi, eventArgs, e, isPrevent, isAdd, doCheck);
    };
    TreeView.prototype.nodeCheckAction = function(wrapper, state, currLi, eventArgs, e, isPrevent, isAdd, doCheck) {
        var ariaState;
        var frameSpan = wrapper.getElementsByClassName($71c78e892be7c33f$var$CHECKBOXFRAME)[0];
        if (state === "check" && !frameSpan.classList.contains($71c78e892be7c33f$var$CHECK)) {
            frameSpan.classList.remove($71c78e892be7c33f$var$INDETERMINATE);
            frameSpan.classList.add($71c78e892be7c33f$var$CHECK);
            this.addCheck(currLi);
            ariaState = "true";
        } else if (state === "uncheck" && (frameSpan.classList.contains($71c78e892be7c33f$var$CHECK) || frameSpan.classList.contains($71c78e892be7c33f$var$INDETERMINATE))) {
            (0, $4ZDHT.removeClass)([
                frameSpan
            ], [
                $71c78e892be7c33f$var$CHECK,
                $71c78e892be7c33f$var$INDETERMINATE
            ]);
            this.removeCheck(currLi);
            ariaState = "false";
        } else if (state === "indeterminate" && this.autoCheck) {
            frameSpan.classList.remove($71c78e892be7c33f$var$CHECK);
            frameSpan.classList.add($71c78e892be7c33f$var$INDETERMINATE);
            this.removeCheck(currLi);
            ariaState = "mixed";
        }
        ariaState = state === "check" ? "true" : state === "uncheck" ? "false" : ariaState;
        if (!(0, $3EnZW.isNullOrUndefined)(ariaState)) currLi.setAttribute("aria-checked", ariaState);
        if (isAdd) {
            var data = [].concat([], this.checkActionNodes);
            eventArgs = this.getCheckEvent(currLi, state, e);
            if ((0, $3EnZW.isUndefined)(isPrevent)) eventArgs.data = data;
        }
        if (doCheck !== undefined) this.ensureStateChange(currLi, doCheck);
        if (!isPrevent) {
            if (!(0, $3EnZW.isNullOrUndefined)(ariaState)) {
                currLi.setAttribute("aria-checked", ariaState);
                eventArgs.data[0].checked = ariaState;
                this.trigger("nodeChecked", eventArgs);
                this.checkActionNodes = [];
            }
        }
    };
    TreeView.prototype.addCheck = function(liEle) {
        var id = liEle.getAttribute("data-uid");
        if (!(0, $3EnZW.isNullOrUndefined)(id) && this.checkedNodes.indexOf(id) === -1) this.checkDisabledState(id);
    };
    TreeView.prototype.removeCheck = function(liEle) {
        var index = this.checkedNodes.indexOf(liEle.getAttribute("data-uid"));
        if (index > -1) this.checkedNodes.splice(index, 1);
    };
    TreeView.prototype.getCheckEvent = function(currLi, action, e) {
        this.checkActionNodes.push(this.getNodeData(currLi));
        var nodeData = this.checkActionNodes;
        return {
            action: action,
            cancel: false,
            isInteracted: (0, $3EnZW.isNullOrUndefined)(e) ? false : true,
            node: currLi,
            data: nodeData
        };
    };
    TreeView.prototype.finalize = function() {
        var firstUl = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, this.element);
        if (!(0, $3EnZW.isNullOrUndefined)(firstUl)) {
            firstUl.setAttribute("role", $71c78e892be7c33f$var$treeAriaAttr.treeRole);
            this.setMultiSelect(this.allowMultiSelection);
            var firstNode = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTITEM, this.element);
            if (firstNode) {
                firstNode.setAttribute("tabindex", "0");
                this.updateIdAttr(null, firstNode);
            }
            if (this.allowTextWrap) this.updateWrap();
            this.renderReactTemplates();
            this.hasPid = this.rootData[0] ? Object.prototype.hasOwnProperty.call(this.rootData[0], this.fields.parentID) : false;
            this.doExpandAction();
        }
    };
    TreeView.prototype.setTextWrap = function() {
        (this.allowTextWrap ? (0, $4ZDHT.addClass) : (0, $4ZDHT.removeClass))([
            this.element
        ], $71c78e892be7c33f$var$LISTWRAP);
        if ((0, $5q7BP.Browser).isIE) (this.allowTextWrap ? (0, $4ZDHT.addClass) : (0, $4ZDHT.removeClass))([
            this.element
        ], $71c78e892be7c33f$var$IELISTWRAP);
    };
    TreeView.prototype.updateWrap = function(ulEle) {
        if (!this.fullRowSelect) return;
        var liEle = ulEle ? (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM, ulEle) : this.liList;
        var length = liEle.length;
        for(var i = 0; i < length; i++)this.calculateWrap(liEle[parseInt(i.toString(), 10)]);
    };
    TreeView.prototype.calculateWrap = function(liEle) {
        var element = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$FULLROW, liEle);
        if (element && element.nextElementSibling) element.style.height = this.allowTextWrap ? element.nextElementSibling.offsetHeight + "px" : "";
    };
    TreeView.prototype.doExpandAction = function() {
        var _this = this;
        var eUids = this.expandedNodes;
        if (!this.loadOnDemand && this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.isInitalExpand = this.treeData.filter(function(e) {
            return e[_this.fields.expanded] === true;
        }).length > 0 ? true : this.isInitalExpand;
        if (this.isInitalExpand && eUids.length > 0) {
            this.setProperties({
                expandedNodes: []
            }, true);
            if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.expandGivenNodes(eUids);
            else {
                for(var i = 0; i < eUids.length; i++){
                    var eNode = (0, $4ZDHT.select)('[data-uid="' + eUids[parseInt(i.toString(), 10)] + '"]', this.element);
                    if (!(0, $3EnZW.isNullOrUndefined)(eNode)) {
                        var icon = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$EXPANDABLE, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, eNode));
                        if (!(0, $3EnZW.isNullOrUndefined)(icon)) this.expandAction(eNode, icon, null);
                    } else {
                        if (eUids[parseInt(i.toString(), 10)] && this.expandChildren.indexOf(eUids[parseInt(i.toString(), 10)]) === -1) this.expandChildren.push(eUids[parseInt(i.toString(), 10)].toString());
                        continue;
                    }
                }
                this.afterFinalized();
            }
        } else this.afterFinalized();
    };
    TreeView.prototype.expandGivenNodes = function(arr) {
        var _this = this;
        this.expandCallback(arr[this.index], function() {
            _this.index++;
            if (_this.index < arr.length) _this.expandGivenNodes(arr);
            else _this.afterFinalized();
        });
        if (this.index > 0) this.index = 0;
    };
    TreeView.prototype.expandCallback = function(eUid, callback) {
        var eNode = (0, $4ZDHT.select)('[data-uid="' + eUid + '"]', this.element);
        if (!(0, $3EnZW.isNullOrUndefined)(eNode)) {
            var icon = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$EXPANDABLE, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, eNode));
            if (!(0, $3EnZW.isNullOrUndefined)(icon)) this.expandAction(eNode, icon, null, false, callback);
            callback();
        } else callback();
    };
    TreeView.prototype.afterFinalized = function() {
        this.doSelectionAction();
        this.updateCheckedProp();
        this.isAnimate = true;
        this.isInitalExpand = false;
        if ((!this.isLoaded || this.isFieldChange) && !this.isNodeDropped) {
            var eventArgs = {
                data: this.treeData
            };
            this.trigger("dataBound", eventArgs);
        }
        this.isLoaded = true;
        this.isNodeDropped = false;
    };
    TreeView.prototype.doSelectionAction = function() {
        var sNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$SELECTED, this.element);
        var sUids = this.selectedNodes;
        if (sUids.length > 0) {
            this.setProperties({
                selectedNodes: []
            }, true);
            for(var i = 0; i < sUids.length; i++){
                var sNode = (0, $4ZDHT.select)('[data-uid="' + sUids[parseInt(i.toString(), 10)] + '"]', this.element);
                if (sNode && !sNode.classList.contains("e-active")) this.selectNode(sNode, null, true);
                else this.selectedNodes.push(sUids[parseInt(i.toString(), 10)]);
                if (!this.allowMultiSelection) break;
            }
        } else this.selectGivenNodes(sNodes);
        (0, $4ZDHT.removeClass)(sNodes, $71c78e892be7c33f$var$SELECTED);
    };
    TreeView.prototype.selectGivenNodes = function(sNodes) {
        for(var i = 0; i < sNodes.length; i++){
            if (!sNodes[parseInt(i.toString(), 10)].classList.contains("e-disable")) this.selectNode(sNodes[parseInt(i.toString(), 10)], null, true);
            if (!this.allowMultiSelection) break;
        }
    };
    TreeView.prototype.clickHandler = function(event) {
        var target = (0, $5q7BP.Browser).isDevice && event.originalEvent.changedTouches && !(0, $5q7BP.Browser).isIos ? document.elementFromPoint(event.originalEvent.changedTouches[0].clientX, event.originalEvent.changedTouches[0].clientY) : event.originalEvent.target;
        (0, $aqzbR.EventHandler).remove(this.element, "contextmenu", this.preventContextMenu);
        if (!target || this.dragStartAction) return;
        else {
            var classList = target.classList;
            var li = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
            if (!li || li.classList.contains($71c78e892be7c33f$var$PREVENTSELECT) && !(classList.contains($71c78e892be7c33f$var$EXPANDABLE) || classList.contains($71c78e892be7c33f$var$COLLAPSIBLE))) return;
            else if (event.originalEvent.which !== 3) {
                var rippleElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$RIPPLEELMENT, li);
                var rippleIcons = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$ICON, li);
                this.removeHover();
                this.setFocusElement(li);
                if (this.showCheckBox && !li.classList.contains("e-disable")) {
                    var checkWrapper = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$CHECKBOXWRAP);
                    if (!(0, $3EnZW.isNullOrUndefined)(checkWrapper)) {
                        var checkElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXFRAME, checkWrapper);
                        this.validateCheckNode(checkWrapper, checkElement.classList.contains($71c78e892be7c33f$var$CHECK), li, event.originalEvent);
                        this.triggerClickEvent(event.originalEvent, li);
                        return;
                    }
                }
                if (classList.contains($71c78e892be7c33f$var$EXPANDABLE)) this.expandAction(li, target, event);
                else if (classList.contains($71c78e892be7c33f$var$COLLAPSIBLE)) this.collapseNode(li, target, event);
                else if (rippleElement && rippleIcons) {
                    if (rippleIcons.classList.contains($71c78e892be7c33f$var$RIPPLE) && rippleIcons.classList.contains($71c78e892be7c33f$var$EXPANDABLE)) this.expandAction(li, rippleIcons, event);
                    else if (rippleIcons.classList.contains($71c78e892be7c33f$var$RIPPLE) && rippleIcons.classList.contains($71c78e892be7c33f$var$COLLAPSIBLE)) this.collapseNode(li, rippleIcons, event);
                    else if (!classList.contains($71c78e892be7c33f$var$PARENTITEM) && !classList.contains($71c78e892be7c33f$var$LISTITEM)) this.toggleSelect(li, event.originalEvent, false);
                } else if (!classList.contains($71c78e892be7c33f$var$PARENTITEM) && !classList.contains($71c78e892be7c33f$var$LISTITEM)) this.toggleSelect(li, event.originalEvent, false);
            }
            if (event.originalEvent.which === 3) this.isRightClick = true;
            this.triggerClickEvent(event.originalEvent, li);
        }
    };
    TreeView.prototype.nodeCheckedEvent = function(wrapper, isCheck, e) {
        var eventArgs = this.getCheckEvent(wrapper, isCheck ? "uncheck" : "check", e);
        eventArgs.data = eventArgs.data.splice(0, eventArgs.data.length - 1);
        this.trigger("nodeChecked", eventArgs);
    };
    TreeView.prototype.updateOldCheckedData = function(data) {
        var dataManager = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(data);
        var childItems = dataManager.executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("isChecked", "equal", "true", true));
        var uncheckedItems = dataManager.executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("isChecked", "equal", "false", true));
        if (uncheckedItems.length > 0) {
            var index = this.OldCheckedData.findIndex(function(e) {
                return e["id"] === uncheckedItems[0]["id"];
            });
            if (index !== -1) {
                this.OldCheckedData.splice(index, 1);
                return;
            }
        }
        if (childItems.length > 0) {
            var index = this.OldCheckedData.findIndex(function(e) {
                return e["id"] === childItems[0]["id"];
            });
            if (index === -1) {
                this.OldCheckedData.push(childItems[0]);
                return;
            }
        }
    };
    TreeView.prototype.triggerClickEvent = function(e, li) {
        var eventArgs = {
            event: e,
            node: li
        };
        this.trigger("nodeClicked", eventArgs);
    };
    TreeView.prototype.expandNode = function(currLi, icon, loaded) {
        var _this = this;
        this.renderReactTemplates();
        if (icon.classList.contains($71c78e892be7c33f$var$LOAD)) this.hideSpinner(icon);
        if (!this.initialRender) icon.classList.add("interaction");
        if (loaded !== true || loaded === true && currLi.classList.contains("e-expanded")) {
            if (this.preventExpand !== true) {
                (0, $4ZDHT.removeClass)([
                    icon
                ], $71c78e892be7c33f$var$EXPANDABLE);
                (0, $4ZDHT.addClass)([
                    icon
                ], $71c78e892be7c33f$var$COLLAPSIBLE);
                var start_1 = 0;
                var end_1 = 0;
                var ul_1 = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, currLi);
                var liEle_1 = currLi;
                if (this.isAnimate && !this.isRefreshed) {
                    this.setHeight(liEle_1, ul_1);
                    var activeElement_1 = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTITEM + "." + $71c78e892be7c33f$var$ACTIVE, currLi);
                    this.aniObj.animate(ul_1, {
                        name: this.animation.expand.effect,
                        duration: this.animation.expand.duration === 0 && (0, $kj1BR.animationMode) === "Enable" ? 400 : this.animation.expand.duration,
                        timingFunction: this.animation.expand.easing,
                        begin: function() {
                            liEle_1.style.overflow = "hidden";
                            if (!(0, $3EnZW.isNullOrUndefined)(activeElement_1) && activeElement_1 instanceof HTMLElement) activeElement_1.classList.add($71c78e892be7c33f$var$ITEM_ANIMATION_ACTIVE);
                            start_1 = liEle_1.offsetHeight;
                            end_1 = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, currLi).offsetHeight;
                        },
                        progress: function(args) {
                            args.element.style.display = "block";
                            _this.animateHeight(args, start_1, end_1);
                        },
                        end: function(args) {
                            args.element.style.display = "block";
                            if (!(0, $3EnZW.isNullOrUndefined)(activeElement_1) && activeElement_1 instanceof HTMLElement) activeElement_1.classList.remove($71c78e892be7c33f$var$ITEM_ANIMATION_ACTIVE);
                            _this.expandedNode(liEle_1, ul_1, icon);
                        }
                    });
                } else this.expandedNode(liEle_1, ul_1, icon);
            }
        } else {
            var ul = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, currLi);
            ul.style.display = "none";
            if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) === true) this.preventExpand = false;
        }
        if (this.initialRender) icon.classList.add("interaction");
    };
    TreeView.prototype.expandedNode = function(currLi, ul, icon) {
        ul.style.display = "block";
        currLi.style.display = "block";
        currLi.style.overflow = "";
        currLi.style.height = "";
        (0, $4ZDHT.removeClass)([
            icon
        ], $71c78e892be7c33f$var$PROCESS);
        this.addExpand(currLi);
        if (this.allowTextWrap && this.isLoaded && this.isFirstRender) {
            this.updateWrap(currLi);
            this.isFirstRender = false;
        }
        if (this.isLoaded && this.expandArgs && !this.isRefreshed) {
            this.expandArgs = this.getExpandEvent(currLi, null);
            this.expandArgs.isInteracted = this.isInteracted;
            this.trigger("nodeExpanded", this.expandArgs);
        }
    };
    TreeView.prototype.addExpand = function(liEle) {
        liEle.setAttribute("aria-expanded", "true");
        (0, $4ZDHT.removeClass)([
            liEle
        ], $71c78e892be7c33f$var$NODECOLLAPSED);
        var id = liEle.getAttribute("data-uid");
        if (!(0, $3EnZW.isNullOrUndefined)(id) && this.expandedNodes.indexOf(id) === -1) this.expandedNodes.push(id);
    };
    TreeView.prototype.collapseNode = function(currLi, icon, e) {
        var _this = this;
        if (icon.classList.contains($71c78e892be7c33f$var$PROCESS)) return;
        else (0, $4ZDHT.addClass)([
            icon
        ], $71c78e892be7c33f$var$PROCESS);
        var colArgs;
        if (this.isLoaded) {
            colArgs = this.getExpandEvent(currLi, e);
            this.isInteracted = colArgs.isInteracted;
            this.trigger("nodeCollapsing", colArgs, function(observedArgs) {
                if (observedArgs.cancel) (0, $4ZDHT.removeClass)([
                    icon
                ], $71c78e892be7c33f$var$PROCESS);
                else _this.nodeCollapseAction(currLi, icon, observedArgs);
            });
        } else this.nodeCollapseAction(currLi, icon, colArgs);
    };
    TreeView.prototype.nodeCollapseAction = function(currLi, icon, colArgs) {
        var _this = this;
        (0, $4ZDHT.removeClass)([
            icon
        ], $71c78e892be7c33f$var$COLLAPSIBLE);
        (0, $4ZDHT.addClass)([
            icon
        ], $71c78e892be7c33f$var$EXPANDABLE);
        var start = 0;
        var end = 0;
        var ul = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, currLi);
        var liEle = currLi;
        var activeElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTITEM + "." + $71c78e892be7c33f$var$ACTIVE, currLi);
        if (this.isAnimate) this.aniObj.animate(ul, {
            name: this.animation.collapse.effect,
            duration: this.animation.collapse.duration === 0 && (0, $kj1BR.animationMode) === "Enable" ? 400 : this.animation.collapse.duration,
            timingFunction: this.animation.collapse.easing,
            begin: function() {
                liEle.style.overflow = "hidden";
                if (!(0, $3EnZW.isNullOrUndefined)(activeElement) && activeElement instanceof HTMLElement) activeElement.classList.add($71c78e892be7c33f$var$ITEM_ANIMATION_ACTIVE);
                start = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, currLi).offsetHeight;
                end = liEle.offsetHeight;
            },
            progress: function(args) {
                _this.animateHeight(args, start, end);
            },
            end: function(args) {
                args.element.style.display = "none";
                if (!(0, $3EnZW.isNullOrUndefined)(activeElement) && activeElement instanceof HTMLElement) activeElement.classList.remove($71c78e892be7c33f$var$ITEM_ANIMATION_ACTIVE);
                _this.collapsedNode(liEle, ul, icon, colArgs);
            }
        });
        else this.collapsedNode(liEle, ul, icon, colArgs);
    };
    TreeView.prototype.collapsedNode = function(liEle, ul, icon, colArgs) {
        ul.style.display = "none";
        liEle.style.overflow = "";
        liEle.style.height = "";
        (0, $4ZDHT.removeClass)([
            icon
        ], $71c78e892be7c33f$var$PROCESS);
        this.removeExpand(liEle);
        if (this.isLoaded) {
            colArgs = this.getExpandEvent(liEle, null);
            colArgs.isInteracted = this.isInteracted;
            this.trigger("nodeCollapsed", colArgs);
        }
    };
    TreeView.prototype.removeExpand = function(liEle, toRemove) {
        if (toRemove) liEle.removeAttribute("aria-expanded");
        else this.disableExpandAttr(liEle);
        var index = this.expandedNodes.indexOf(liEle.getAttribute("data-uid"));
        if (index > -1) this.expandedNodes.splice(index, 1);
    };
    TreeView.prototype.disableExpandAttr = function(liEle) {
        liEle.setAttribute("aria-expanded", "false");
        (0, $4ZDHT.addClass)([
            liEle
        ], $71c78e892be7c33f$var$NODECOLLAPSED);
    };
    TreeView.prototype.setHeight = function(currLi, ul) {
        ul.style.display = "block";
        ul.style.visibility = "hidden";
        currLi.style.height = currLi.offsetHeight + "px";
        ul.style.display = "none";
        ul.style.visibility = "";
    };
    TreeView.prototype.animateHeight = function(args, start, end) {
        var remaining = (args.duration - args.timeStamp) / args.duration;
        var currentHeight = (end - start) * remaining + start;
        args.element.parentElement.style.height = currentHeight + "px";
    };
    TreeView.prototype.renderChildNodes = function(parentLi, expandChild, callback, loaded, isFromExpandAll) {
        var _this = this;
        var eicon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, parentLi);
        if ((0, $3EnZW.isNullOrUndefined)(eicon)) return;
        this.showSpinner(eicon);
        var childItems;
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            var level = this.parents(parentLi, "." + $71c78e892be7c33f$var$PARENTITEM).length;
            var mapper_2 = this.getChildFields(this.fields, level, 1);
            if ((0, $3EnZW.isNullOrUndefined)(mapper_2) || (0, $3EnZW.isNullOrUndefined)(mapper_2.dataSource)) {
                (0, $4ZDHT.detach)(eicon);
                this.removeExpand(parentLi, true);
                return;
            }
            this.treeList.push("false");
            if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && this.isOffline) {
                this.treeList.pop();
                childItems = this.getChildNodes(this.treeData, parentLi.getAttribute("data-uid"));
                this.loadChild(childItems, mapper_2, eicon, parentLi, expandChild, callback, loaded);
            } else mapper_2.dataSource.executeQuery(this.getQuery(mapper_2, parentLi.getAttribute("data-uid"))).then(function(e) {
                _this.treeList.pop();
                childItems = e.result;
                if (_this.dataType === 1) _this.dataType = 2;
                _this.loadChild(childItems, mapper_2, eicon, parentLi, expandChild, callback, loaded);
            }).catch(function(e) {
                _this.trigger("actionFailure", {
                    error: e
                });
            });
        } else {
            childItems = this.getChildNodes(this.treeData, parentLi.getAttribute("data-uid"), false, parseFloat(parentLi.getAttribute("aria-level")) + 1);
            this.currentLoadData = this.getSortedData(childItems);
            if ((0, $3EnZW.isNullOrUndefined)(childItems) || childItems.length === 0) {
                (0, $4ZDHT.detach)(eicon);
                if (eicon.classList.contains($71c78e892be7c33f$var$LOAD)) this.hideSpinner(eicon);
                this.removeExpand(parentLi, true);
                return;
            } else {
                this.listBaseOption.ariaAttributes.level = parseFloat(parentLi.getAttribute("aria-level")) + 1;
                parentLi.appendChild((0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, this.currentLoadData, this.listBaseOption));
                this.expandNode(parentLi, eicon, loaded);
                this.setSelectionForChildNodes(childItems);
                this.ensureCheckNode(parentLi, isFromExpandAll);
                this.finalizeNode(parentLi, isFromExpandAll, expandChild);
                this.disableTreeNodes(childItems);
                this.renderSubChild(parentLi, expandChild, loaded, isFromExpandAll);
            }
        }
    };
    TreeView.prototype.loadChild = function(childItems, mapper, eicon, parentLi, expandChild, callback, loaded) {
        this.currentLoadData = childItems;
        if ((0, $3EnZW.isNullOrUndefined)(childItems) || childItems.length === 0) {
            (0, $4ZDHT.detach)(eicon);
            this.removeExpand(parentLi, true);
        } else {
            this.updateListProp(mapper);
            if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !this.isOffline) {
                var id = parentLi.getAttribute("data-uid");
                var nodeData = this.getNodeObject(id);
                (0, $3EnZW.setValue)("child", childItems, nodeData);
            }
            this.listBaseOption.ariaAttributes.level = parseFloat(parentLi.getAttribute("aria-level")) + 1;
            parentLi.appendChild((0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createList(this.createElement, childItems, this.listBaseOption));
            this.expandNode(parentLi, eicon, loaded);
            this.setSelectionForChildNodes(childItems);
            this.ensureCheckNode(parentLi);
            this.finalizeNode(parentLi);
            this.disableTreeNodes(childItems);
            this.renderSubChild(parentLi, expandChild, loaded);
        }
        if (callback) callback();
        if (expandChild) this.expandedNodes.push(parentLi.getAttribute("data-uid"));
        if (this.treeList.length === 0 && !this.isLoaded) this.finalize();
    };
    TreeView.prototype.disableTreeNodes = function(childItems) {
        if ((0, $3EnZW.isNullOrUndefined)(this.disableNode) || this.disableNode.length === 0) return;
        var i = 0;
        while(i < childItems.length){
            var id = childItems[parseInt(i.toString(), 10)][this.fields.id] ? childItems[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
            if (this.disableNode !== undefined && this.disableNode.indexOf(id) !== -1) this.doDisableAction([
                id
            ]);
            i++;
        }
    };
    /**
     * Sets the child Item in selectedState while rendering the child node
     *
     * @param {Object[]} nodes - Array of nodes
     * @returns {void}
     */ TreeView.prototype.setSelectionForChildNodes = function(nodes) {
        if ((0, $3EnZW.isNullOrUndefined)(this.selectedNodes) || this.selectedNodes.length === 0) return;
        var i;
        for(i = 0; i < nodes.length; i++){
            var id = nodes[parseInt(i.toString(), 10)][this.fields.id] ? nodes[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
            if (this.selectedNodes !== undefined && this.selectedNodes.indexOf(id) !== -1) this.doSelectionAction();
        }
    };
    TreeView.prototype.ensureCheckNode = function(element, isFromExpandAll) {
        if (this.showCheckBox) {
            this.ele = this.checkedElement ? this.checkedElement.indexOf(element.getAttribute("data-uid")) : null;
            if (this.autoCheck) {
                this.ensureChildCheckState(element, null, isFromExpandAll);
                if (isFromExpandAll ? (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECK, this.element) || (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$INDETERMINATE, this.element) : true) this.ensureParentCheckState(element);
            }
        }
        this.currentLoadData = null;
    };
    TreeView.prototype.getFields = function(mapper, nodeLevel, dataLevel) {
        if (nodeLevel === dataLevel) return mapper;
        else return this.getFields(this.getChildMapper(mapper), nodeLevel, dataLevel + 1);
    };
    TreeView.prototype.getChildFields = function(mapper, nodeLevel, dataLevel) {
        if (nodeLevel === dataLevel) return this.getChildMapper(mapper);
        else return this.getChildFields(this.getChildMapper(mapper), nodeLevel, dataLevel + 1);
    };
    TreeView.prototype.getChildMapper = function(mapper) {
        return typeof mapper.child === "string" || (0, $3EnZW.isNullOrUndefined)(mapper.child) ? mapper : mapper.child;
    };
    TreeView.prototype.getChildNodes = function(obj, parentId, isRoot, level) {
        var _this = this;
        if (isRoot === void 0) isRoot = false;
        var childNodes;
        if ((0, $3EnZW.isNullOrUndefined)(obj)) return childNodes;
        if (this.dataType === 1) return this.getChildGroup(this.groupedData, parentId, isRoot);
        if (typeof this.fields.child === "string") return this.findChildNodes(obj, this.fields.id, parentId) || this.findNestedChildNodes(obj, parentId, level) || [];
        if (this.isChildObject()) {
            var tempField = !(0, $3EnZW.isNullOrUndefined)(level) ? this.fields : this.fields.child;
            var i = 1;
            while(i < level){
                if (!(0, $3EnZW.isNullOrUndefined)(tempField.child)) tempField = tempField.child;
                else break;
                i++;
            }
            this.updateListProp(tempField);
            var index = obj.findIndex(function(data) {
                return (0, $3EnZW.getValue)(_this.fields.id, data) && (0, $3EnZW.getValue)(_this.fields.id, data).toString() === parentId;
            });
            if (index !== -1) return (0, $3EnZW.getValue)("child", obj[parseInt(index.toString(), 10)]);
            if (index === -1) for(var i_1 = 0, objlen = obj.length; i_1 < objlen; i_1++){
                var tempArray = (0, $3EnZW.getValue)("child", obj[parseInt(i_1.toString(), 10)]);
                var childIndex = !(0, $3EnZW.isNullOrUndefined)(tempArray) ? tempArray.findIndex(function(data) {
                    return (0, $3EnZW.getValue)(_this.fields.child.id, data) && (0, $3EnZW.getValue)(_this.fields.child.id, data).toString() === parentId;
                }) : -1;
                if (childIndex !== -1) return (0, $3EnZW.getValue)("child", tempArray[parseInt(childIndex.toString(), 10)]);
                else if (!(0, $3EnZW.isNullOrUndefined)(tempArray)) {
                    childNodes = this.getChildNodes(tempArray, parentId, false, level);
                    if (childNodes !== undefined) break;
                }
            }
        }
        return childNodes;
    };
    TreeView.prototype.findChildNodes = function(items, idField, parentId) {
        var index = items.findIndex(function(data) {
            var value = (0, $3EnZW.getValue)(idField, data);
            return value && value.toString() === parentId;
        });
        if (index !== -1) return (0, $3EnZW.getValue)(this.fields.child, items[index]);
        return null;
    };
    TreeView.prototype.findNestedChildNodes = function(items, parentId, level) {
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var tempArray = (0, $3EnZW.getValue)(this.fields.child, item);
            if (!(0, $3EnZW.isNullOrUndefined)(tempArray)) {
                var childNodes = this.findChildNodes(tempArray, this.fields.id, parentId);
                if (childNodes) return childNodes;
                var nestedChildNodes = this.getChildNodes(tempArray, parentId, false, level);
                if (nestedChildNodes && nestedChildNodes.length > 0) return nestedChildNodes;
            }
        }
        return undefined;
    };
    TreeView.prototype.getChildGroup = function(data, parentId, isRoot) {
        var childNodes;
        if ((0, $3EnZW.isNullOrUndefined)(data)) return childNodes;
        for(var i = 0, objlen = data.length; i < objlen; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(data[parseInt(i.toString(), 10)][0]) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(this.fields.parentID, data[parseInt(i.toString(), 10)][0]))) {
                if ((0, $3EnZW.getValue)(this.fields.parentID, data[parseInt(i.toString(), 10)][0]).toString() === parentId) return data[parseInt(i.toString(), 10)];
            } else if (isRoot) return data[parseInt(i.toString(), 10)];
            else return [];
        }
        return childNodes;
    };
    TreeView.prototype.renderSubChild = function(element, expandChild, loaded, isFromExpandAll) {
        if (expandChild) {
            var cIcons = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$EXPANDABLE, element);
            for(var i = 0, len = cIcons.length; i < len; i++){
                var icon = cIcons[parseInt(i.toString(), 10)];
                if (element.querySelector(".e-icons") !== cIcons[parseInt(i.toString(), 10)]) {
                    var curLi = (0, $4ZDHT.closest)(icon, "." + $71c78e892be7c33f$var$LISTITEM);
                    this.expandArgs = this.getExpandEvent(curLi, null);
                    if (loaded !== true) this.trigger("nodeExpanding", this.expandArgs);
                    this.renderChildNodes(curLi, expandChild, null, loaded, isFromExpandAll);
                }
            }
        }
    };
    TreeView.prototype.toggleSelect = function(li, e, multiSelect) {
        if (!li.classList.contains("e-disable")) {
            if (this.allowMultiSelection && (e && e.ctrlKey || multiSelect) && this.isActive(li)) this.unselectNode(li, e);
            else this.selectNode(li, e, multiSelect);
        }
    };
    TreeView.prototype.isActive = function(li) {
        return li.classList.contains($71c78e892be7c33f$var$ACTIVE) ? true : false;
    };
    TreeView.prototype.selectNode = function(li, e, multiSelect) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(li) || !this.allowMultiSelection && this.isActive(li) && !(0, $3EnZW.isNullOrUndefined)(e)) {
            this.setFocusElement(li);
            return;
        }
        var eventArgs;
        if (this.isLoaded) {
            eventArgs = this.getSelectEvent(li, "select", e);
            this.trigger("nodeSelecting", eventArgs, function(observedArgs) {
                if (!observedArgs.cancel && !observedArgs.node.classList.contains($71c78e892be7c33f$var$PREVENTSELECT)) _this.nodeSelectAction(li, e, observedArgs, multiSelect);
            });
        } else this.nodeSelectAction(li, e, eventArgs, multiSelect);
    };
    TreeView.prototype.nodeSelectAction = function(li, e, eventArgs, multiSelect) {
        if (!this.allowMultiSelection || !multiSelect && (!e || e && !(e.ctrlKey || e.metaKey))) this.removeSelectAll();
        if (this.allowMultiSelection && e && e.shiftKey) {
            if (!this.startNode) this.startNode = li;
            var startIndex = this.liList.indexOf(this.startNode);
            var endIndex = this.liList.indexOf(li);
            if (startIndex > endIndex) {
                var temp = startIndex;
                startIndex = endIndex;
                endIndex = temp;
            }
            for(var i = startIndex; i <= endIndex; i++){
                var currNode = this.liList[parseInt(i.toString(), 10)];
                if ((0, $4ZDHT.isVisible)(currNode) && !currNode.classList.contains("e-disable")) this.addSelect(currNode);
            }
        } else {
            this.startNode = li;
            this.addSelect(li);
        }
        if (this.isLoaded) {
            eventArgs.nodeData = this.getNodeData(li);
            this.trigger("nodeSelected", eventArgs);
            this.isRightClick = false;
        }
        this.isRightClick = false;
    };
    TreeView.prototype.unselectNode = function(li, e) {
        var _this = this;
        var eventArgs;
        if (this.isLoaded) {
            eventArgs = this.getSelectEvent(li, "un-select", e);
            this.trigger("nodeSelecting", eventArgs, function(observedArgs) {
                if (!observedArgs.cancel) _this.nodeUnselectAction(li, observedArgs);
            });
        } else this.nodeUnselectAction(li, eventArgs);
    };
    TreeView.prototype.nodeUnselectAction = function(li, eventArgs) {
        this.removeSelect(li);
        this.setFocusElement(li);
        if (this.isLoaded) {
            eventArgs.nodeData = this.getNodeData(li);
            this.trigger("nodeSelected", eventArgs);
        }
    };
    TreeView.prototype.setFocusElement = function(li) {
        if (!(0, $3EnZW.isNullOrUndefined)(li)) {
            var focusedNode = this.getFocusedNode();
            if (focusedNode) {
                (0, $4ZDHT.removeClass)([
                    focusedNode
                ], $71c78e892be7c33f$var$FOCUS);
                focusedNode.setAttribute("tabindex", "-1");
            }
            (0, $4ZDHT.addClass)([
                li
            ], $71c78e892be7c33f$var$FOCUS);
            li.setAttribute("tabindex", "0");
            (0, $aqzbR.EventHandler).add(li, "blur", this.focusOut, this);
            this.updateIdAttr(focusedNode, li);
        }
    };
    TreeView.prototype.addSelect = function(liEle) {
        liEle.setAttribute("aria-selected", "true");
        (0, $4ZDHT.addClass)([
            liEle
        ], $71c78e892be7c33f$var$ACTIVE);
        var id = liEle.getAttribute("data-uid");
        if (!(0, $3EnZW.isNullOrUndefined)(id) && this.selectedNodes.indexOf(id) === -1) this.selectedNodes.push(id);
    };
    TreeView.prototype.removeSelect = function(liEle) {
        if (this.allowMultiSelection) liEle.setAttribute("aria-selected", "false");
        else liEle.removeAttribute("aria-selected");
        (0, $4ZDHT.removeClass)([
            liEle
        ], $71c78e892be7c33f$var$ACTIVE);
        var index = this.selectedNodes.indexOf(liEle.getAttribute("data-uid"));
        if (index > -1) this.selectedNodes.splice(index, 1);
    };
    TreeView.prototype.removeSelectAll = function() {
        var selectedLI = this.element.querySelectorAll("." + $71c78e892be7c33f$var$ACTIVE);
        for(var _i = 0, selectedLI_1 = selectedLI; _i < selectedLI_1.length; _i++){
            var ele = selectedLI_1[_i];
            if (this.allowMultiSelection) ele.setAttribute("aria-selected", "false");
            else ele.removeAttribute("aria-selected");
        }
        (0, $4ZDHT.removeClass)(selectedLI, $71c78e892be7c33f$var$ACTIVE);
        this.setProperties({
            selectedNodes: []
        }, true);
    };
    TreeView.prototype.getSelectEvent = function(currLi, action, e) {
        var nodeData = this.getNodeData(currLi);
        return {
            action: action,
            cancel: false,
            isInteracted: (0, $3EnZW.isNullOrUndefined)(e) ? false : true,
            node: currLi,
            nodeData: nodeData
        };
    };
    TreeView.prototype.setExpandOnType = function() {
        this.expandOnType = this.expandOn === "Auto" ? (0, $5q7BP.Browser).isDevice ? "Click" : "DblClick" : this.expandOn;
    };
    TreeView.prototype.expandHandler = function(e) {
        var target = e.originalEvent.target;
        if (!target || target.classList.contains($71c78e892be7c33f$var$INPUT) || target.classList.contains($71c78e892be7c33f$var$ROOT) || target.classList.contains($71c78e892be7c33f$var$PARENTITEM) || target.classList.contains($71c78e892be7c33f$var$LISTITEM) || target.classList.contains($71c78e892be7c33f$var$ICON) || this.showCheckBox && (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$CHECKBOXWRAP)) return;
        else this.expandCollapseAction((0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM), e);
    };
    TreeView.prototype.expandCollapseAction = function(currLi, e) {
        var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, currLi);
        if (!icon || icon.classList.contains($71c78e892be7c33f$var$PROCESS)) return;
        else {
            var classList = icon.classList;
            if (classList.contains($71c78e892be7c33f$var$EXPANDABLE)) this.expandAction(currLi, icon, e);
            else if (classList.contains($71c78e892be7c33f$var$COLLAPSIBLE)) this.collapseNode(currLi, icon, e);
        }
    };
    TreeView.prototype.expandAction = function(currLi, icon, e, expandChild, callback, isFromExpandAll) {
        var _this = this;
        if (icon.classList.contains($71c78e892be7c33f$var$PROCESS)) return;
        else (0, $4ZDHT.addClass)([
            icon
        ], $71c78e892be7c33f$var$PROCESS);
        if (this.isLoaded && !this.isRefreshed) {
            this.expandArgs = this.getExpandEvent(currLi, e);
            this.isInteracted = this.expandArgs.isInteracted;
            this.trigger("nodeExpanding", this.expandArgs, function(observedArgs) {
                if (observedArgs.cancel) (0, $4ZDHT.removeClass)([
                    icon
                ], $71c78e892be7c33f$var$PROCESS);
                else _this.nodeExpandAction(currLi, icon, expandChild, callback, isFromExpandAll);
            });
        } else this.nodeExpandAction(currLi, icon, expandChild, callback, isFromExpandAll);
    };
    TreeView.prototype.nodeExpandAction = function(currLi, icon, expandChild, callback, isFromExpandAll) {
        var ul = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, currLi);
        if (ul && ul.nodeName === "UL") this.expandNode(currLi, icon);
        else {
            this.isFirstRender = true;
            this.renderChildNodes(currLi, expandChild, callback, null, isFromExpandAll);
            var liEles = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM, currLi);
            for(var i = 0; i < liEles.length; i++){
                var id = this.getId(liEles[parseInt(i.toString(), 10)]);
                if (this.expandChildren.indexOf(id) !== -1 && this.expandChildren !== undefined) {
                    var icon_1 = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$EXPANDABLE, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, liEles[parseInt(i.toString(), 10)]));
                    if (!(0, $3EnZW.isNullOrUndefined)(icon_1)) this.expandAction(liEles[parseInt(i.toString(), 10)], icon_1, null);
                    this.expandChildren.splice(this.expandChildren.indexOf(id), 1);
                }
            }
        }
    };
    TreeView.prototype.keyActionHandler = function(e) {
        var _this = this;
        var target = e.target;
        var focusedNode = this.getFocusedNode();
        if (target && target.classList.contains($71c78e892be7c33f$var$INPUT)) {
            var inpEle = target;
            if (e.action === "enter") inpEle.blur();
            else if (e.action === "escape") {
                inpEle.value = this.oldText;
                inpEle.blur();
            }
            return;
        }
        e.preventDefault();
        var eventArgs = {
            cancel: false,
            event: e,
            node: focusedNode
        };
        this.trigger("keyPress", eventArgs, function(observedArgs) {
            if (!observedArgs.cancel) switch(e.action){
                case "space":
                    if (_this.showCheckBox) _this.checkNode(e);
                    else _this.toggleSelect(focusedNode, e);
                    break;
                case "moveRight":
                    _this.openNode(_this.enableRtl ? false : true, e);
                    break;
                case "moveLeft":
                    _this.openNode(_this.enableRtl ? true : false, e);
                    break;
                case "shiftDown":
                    _this.shiftKeySelect(true, e);
                    break;
                case "moveDown":
                case "ctrlDown":
                case "csDown":
                    _this.navigateNode(true);
                    break;
                case "shiftUp":
                    _this.shiftKeySelect(false, e);
                    break;
                case "moveUp":
                case "ctrlUp":
                case "csUp":
                    _this.navigateNode(false);
                    break;
                case "home":
                case "shiftHome":
                case "ctrlHome":
                case "csHome":
                    _this.navigateRootNode(true);
                    break;
                case "end":
                case "shiftEnd":
                case "ctrlEnd":
                case "csEnd":
                    _this.navigateRootNode(false);
                    break;
                case "enter":
                case "ctrlEnter":
                case "shiftEnter":
                case "csEnter":
                case "shiftSpace":
                case "ctrlSpace":
                    _this.toggleSelect(focusedNode, e);
                    break;
                case "f2":
                    if (_this.allowEditing && !focusedNode.classList.contains("e-disable")) _this.createTextbox(focusedNode);
                    break;
                case "ctrlA":
                    if (_this.allowMultiSelection) {
                        var sNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM + ":not(." + $71c78e892be7c33f$var$ACTIVE + ")", _this.element);
                        _this.selectGivenNodes(sNodes);
                    }
                    break;
            }
        });
    };
    TreeView.prototype.navigateToFocus = function(isUp) {
        var focusNode = this.getFocusedNode().querySelector("." + $71c78e892be7c33f$var$TEXTWRAP);
        var pos = focusNode.getBoundingClientRect();
        var parent = this.getScrollParent(this.element);
        if (!(0, $3EnZW.isNullOrUndefined)(parent)) {
            var parentPos = parent.getBoundingClientRect();
            if (pos.bottom > parentPos.bottom) parent.scrollTop += pos.bottom - parentPos.bottom;
            else if (pos.top < parentPos.top) parent.scrollTop -= parentPos.top - pos.top;
        }
        var isVisible = this.isVisibleInViewport(focusNode);
        if (!isVisible) focusNode.scrollIntoView(isUp);
    };
    TreeView.prototype.isVisibleInViewport = function(txtWrap) {
        var pos = txtWrap.getBoundingClientRect();
        return pos.top >= 0 && pos.left >= 0 && pos.bottom <= (window.innerHeight || document.documentElement.clientHeight) && pos.right <= (window.innerWidth || document.documentElement.clientWidth);
    };
    TreeView.prototype.getScrollParent = function(node) {
        if ((0, $3EnZW.isNullOrUndefined)(node)) return null;
        return node.scrollHeight > node.clientHeight ? node : this.getScrollParent(node.parentElement);
    };
    TreeView.prototype.shiftKeySelect = function(isTowards, e) {
        if (this.allowMultiSelection) {
            var focusedNode = this.getFocusedNode();
            var nextNode = isTowards ? this.getNextNode(focusedNode) : this.getPrevNode(focusedNode);
            this.removeHover();
            this.setFocusElement(nextNode);
            this.toggleSelect(nextNode, e, false);
            this.navigateToFocus(!isTowards);
        } else this.navigateNode(isTowards);
    };
    TreeView.prototype.checkNode = function(e) {
        var focusedNode = this.getFocusedNode();
        var checkWrap = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXWRAP, focusedNode);
        var isChecked = (0, $4ZDHT.select)(" ." + $71c78e892be7c33f$var$CHECKBOXFRAME, checkWrap).classList.contains($71c78e892be7c33f$var$CHECK);
        if (!focusedNode.classList.contains("e-disable")) {
            if (focusedNode.getElementsByClassName("e-checkbox-disabled").length === 0) this.validateCheckNode(checkWrap, isChecked, focusedNode, e);
        }
    };
    TreeView.prototype.validateCheckNode = function(checkWrap, isCheck, li, e) {
        var _this = this;
        var currLi = (0, $4ZDHT.closest)(checkWrap, "." + $71c78e892be7c33f$var$LISTITEM);
        this.checkActionNodes = [];
        var ariaState = !isCheck ? "true" : "false";
        if (!(0, $3EnZW.isNullOrUndefined)(ariaState)) currLi.setAttribute("aria-checked", ariaState);
        var eventArgs = this.getCheckEvent(currLi, isCheck ? "uncheck" : "check", e);
        this.trigger("nodeChecking", eventArgs, function(observedArgs) {
            if (!observedArgs.cancel) _this.nodeCheckingAction(checkWrap, isCheck, li, observedArgs, e);
        });
    };
    TreeView.prototype.nodeCheckingAction = function(checkWrap, isCheck, li, eventArgs, e) {
        if (this.checkedElement.indexOf(li.getAttribute("data-uid")) === -1) {
            this.checkedElement.push(li.getAttribute("data-uid"));
            if (this.autoCheck) {
                var child = this.getChildNodes(this.treeData, li.getAttribute("data-uid"));
                if (child !== null) this.allCheckNode(child, this.checkedElement, null, null, false);
                else child = null;
            }
        }
        this.changeState(checkWrap, isCheck ? "uncheck" : "check", e, true);
        if (this.autoCheck) {
            this.ensureChildCheckState(li);
            this.updateOldCheckedData([
                this.getNodeData(li)
            ]);
            this.ensureParentCheckState((0, $4ZDHT.closest)((0, $4ZDHT.closest)(li, "." + $71c78e892be7c33f$var$PARENTITEM), "." + $71c78e892be7c33f$var$LISTITEM));
            var doCheck = void 0;
            if (eventArgs.action === "check") doCheck = true;
            else if (eventArgs.action === "uncheck") doCheck = false;
            this.ensureStateChange(li, doCheck);
        }
        this.nodeCheckedEvent(checkWrap, isCheck, e);
    };
    /**
     * Update checkedNodes when UI interaction happens before the child node renders in DOM
     *
     * @param {Element} li - The list item element
     * @param {boolean} [doCheck] - Optional parameter to specify whether to perform a check
     * @returns {void}
     */ TreeView.prototype.ensureStateChange = function(li, doCheck) {
        var childElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, li);
        var parentIndex = li.getAttribute("data-uid");
        var mapper = this.fields;
        if (this.dataType === 1 && this.autoCheck) {
            var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.parentID, "equal", parentIndex, true));
            for(var i = 0; i < resultData.length; i++){
                var resultId = resultData[parseInt(i.toString(), 10)][this.fields.id] ? resultData[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                var isCheck = resultData[parseInt(i.toString(), 10)][this.fields.isChecked] ? resultData[parseInt(i.toString(), 10)][this.fields.isChecked].toString() : null;
                if (this.checkedNodes.indexOf(parentIndex) !== -1 && this.checkedNodes.indexOf(resultId) === -1) {
                    this.checkDisabledState(resultId, resultData[i]);
                    var childItems = this.getChildNodes(this.treeData, resultId);
                    this.getChildItems(childItems, doCheck);
                    if (this.parentNodeCheck.indexOf(resultId) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(resultId), 1);
                } else if (this.checkedNodes.indexOf(parentIndex) === -1 && childElement === null && this.checkedNodes.indexOf(resultId) !== -1) {
                    this.checkedNodes.splice(this.checkedNodes.indexOf(resultId), 1);
                    if (isCheck === "true") this.updateField(this.treeData, this.fields, resultId, "isChecked", null);
                    if (this.checkedNodes.indexOf(parentIndex) === -1 && childElement === null || this.parentNodeCheck.indexOf(resultId) !== -1) {
                        var childNodes = this.getChildNodes(this.treeData, resultId);
                        this.getChildItems(childNodes, doCheck);
                        if (this.parentNodeCheck.indexOf(resultId) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(resultId), 1);
                    }
                } else {
                    var childItems = this.getChildNodes(this.treeData, resultId);
                    this.getChildItems(childItems, doCheck);
                }
            }
        } else if (this.dataType === 1 && !this.autoCheck) {
            if (!doCheck) {
                var checkedData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.isChecked, "equal", true, false));
                for(var i = 0; i < checkedData.length; i++){
                    var id = checkedData[parseInt(i.toString(), 10)][this.fields.id] ? checkedData[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                    if (this.checkedNodes.indexOf(id) !== -1) this.checkedNodes.splice(this.checkedNodes.indexOf(id), 1);
                    this.updateField(this.treeData, this.fields, id, "isChecked", null);
                }
                this.checkedNodes = [];
            } else for(var i = 0; i < this.treeData.length; i++){
                var checkedId = this.treeData[parseInt(i.toString(), 10)][this.fields.id] ? this.treeData[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
                if (this.checkedNodes.indexOf(checkedId) === -1) this.checkDisabledState(checkedId, this.treeData[i]);
            }
        } else {
            var childItems = this.getChildNodes(this.treeData, parentIndex);
            if (childItems) this.childStateChange(childItems, parentIndex, childElement, doCheck);
        }
    };
    TreeView.prototype.checkDisabledState = function(resultId, currentItem) {
        var requiresUpdate = this.checkDisabledChildren;
        if (!requiresUpdate) {
            var shouldPreventUpdate = true;
            if (this.loadOnDemand && this.fields.htmlAttributes) {
                currentItem = (0, $3EnZW.isNullOrUndefined)(currentItem) ? currentItem : this.getNodeObject(resultId);
                if (!(0, $3EnZW.isNullOrUndefined)(currentItem)) {
                    var htmlAttributes = currentItem[this.fields.htmlAttributes];
                    if (htmlAttributes && !(0, $3EnZW.isNullOrUndefined)(htmlAttributes.class) && htmlAttributes.class.indexOf($71c78e892be7c33f$var$DISABLE) !== -1) shouldPreventUpdate = false;
                }
            }
            var liElement = (0, $4ZDHT.select)('[data-uid="' + resultId + '"]', this.element);
            requiresUpdate = liElement ? !liElement.classList.contains($71c78e892be7c33f$var$DISABLE) : this.disableNode.indexOf(resultId) === -1 && shouldPreventUpdate;
        }
        if (requiresUpdate) this.checkedNodes.push(resultId);
    };
    TreeView.prototype.getChildItems = function(childItems, doCheck) {
        for(var i = 0; i < childItems.length; i++){
            var childId = childItems[parseInt(i.toString(), 10)][this.fields.id] ? childItems[parseInt(i.toString(), 10)][this.fields.id].toString() : null;
            var childIsCheck = childItems[parseInt(i.toString(), 10)][this.fields.isChecked] ? childItems[parseInt(i.toString(), 10)][this.fields.isChecked].toString() : null;
            if (this.checkedNodes.indexOf(childId) !== -1 && !doCheck) this.checkedNodes.splice(this.checkedNodes.indexOf(childId), 1);
            if (this.checkedNodes.indexOf(childId) === -1 && doCheck) this.checkDisabledState(childId, childItems[i]);
            if (childIsCheck === "true" && !doCheck) this.updateField(this.treeData, this.fields, childId, "isChecked", null);
            var subChildItems = this.getChildNodes(this.treeData, childId);
            if (subChildItems.length > 0) this.getChildItems(subChildItems, doCheck);
        }
    };
    /**
     * Update checkedNodes when UI interaction happens before the child node renders in DOM for hierarchical DS
     *
     * @param {Object[]} childItems - Array of child items
     * @param {string} parent - Parent identifier
     * @param {Element} childElement - Child DOM element
     * @param {boolean} [doCheck] - Optional parameter to specify whether to perform a check
     * @returns {void}
     */ TreeView.prototype.childStateChange = function(childItems, parent, childElement, doCheck) {
        for(var i = 0; i < childItems.length; i++){
            var checkedChild = childItems[parseInt(i.toString(), 10)][this.fields.id] ? childItems[parseInt(i.toString(), 10)][this.fields.id].toString() : "";
            var isCheck = childItems[parseInt(i.toString(), 10)][this.fields.isChecked] ? childItems[parseInt(i.toString(), 10)][this.fields.isChecked].toString() : null;
            if (this.autoCheck) {
                if (this.checkedNodes.indexOf(parent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1) {
                    this.checkDisabledState(checkedChild, childItems[i]);
                    if (this.parentNodeCheck.indexOf(checkedChild) !== -1) this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(checkedChild), 1);
                } else if (this.checkedNodes.indexOf(parent) === -1 && this.checkedNodes.indexOf(checkedChild) !== -1 && !doCheck) {
                    this.checkedNodes.splice(this.checkedNodes.indexOf(checkedChild), 1);
                    if (isCheck === "true") this.updateField(this.treeData, this.fields, checkedChild, "isChecked", null);
                }
            } else if (!this.autoCheck) {
                if (!doCheck) {
                    if (this.checkedNodes.indexOf(checkedChild) !== -1) this.checkedNodes.splice(this.checkedNodes.indexOf(checkedChild), 1);
                    this.updateField(this.treeData, this.fields, checkedChild, "isChecked", null);
                    this.checkedNodes = [];
                } else if (this.checkedNodes.indexOf(checkedChild) === -1) this.checkDisabledState(checkedChild, childItems[i]);
            }
            var subChild = this.getChildNodes([
                childItems[parseInt(i.toString(), 10)]
            ], checkedChild);
            if (subChild) this.childStateChange(subChild, parent, childElement, doCheck);
        }
    };
    //This method can be used to get all child nodes of a parent by passing the children of a parent along with 'validateCheck' set to false
    TreeView.prototype.allCheckNode = function(child, newCheck, checked, childCheck, validateCheck) {
        if (child) for(var length_1 = 0; length_1 < child.length; length_1++){
            var childId = (0, $3EnZW.getValue)(this.fields.id, child[parseInt(length_1.toString(), 10)]);
            var check = this.element.querySelector('[data-uid="' + childId + '"]');
            //Validates isChecked case while no UI interaction has been performed on the node or it's parent
            if (validateCheck !== false && this.checkedElement.indexOf(childId.toString()) === -1) {
                if (check === null && !(0, $3EnZW.isNullOrUndefined)(child[parseInt(length_1.toString(), 10)][this.fields.isChecked]) && newCheck.indexOf(childId.toString()) === -1 || childCheck === 0 || checked === 2) {
                    if (child[parseInt(length_1.toString(), 10)][this.fields.isChecked] !== false || checked === 2) newCheck.push(childId.toString());
                    else childCheck = null;
                    childCheck = child[parseInt(length_1.toString(), 10)][this.fields.isChecked] !== false || checked === 2 ? 0 : null;
                }
            }
            //Pushes child checked node done thro' UI interaction
            if (newCheck.indexOf(childId.toString()) === -1 && (0, $3EnZW.isNullOrUndefined)(checked)) newCheck.push(childId.toString());
            var hierChildId = (0, $3EnZW.getValue)(this.fields.child.toString(), child[parseInt(length_1.toString(), 10)]);
            //Gets if any next level children are available for child nodes
            if ((0, $3EnZW.getValue)(this.fields.hasChildren, child[parseInt(length_1.toString(), 10)]) === true || hierChildId) {
                var id = (0, $3EnZW.getValue)(this.fields.id, child[parseInt(length_1.toString(), 10)]);
                var childId_1 = void 0;
                if (this.dataType === 1) childId_1 = this.getChildNodes(this.treeData, id.toString());
                else childId_1 = hierChildId;
                if (childId_1) {
                    if ((0, $3EnZW.isNullOrUndefined)(validateCheck)) this.allCheckNode(childId_1, newCheck, checked, childCheck);
                    else this.allCheckNode(childId_1, newCheck, checked, childCheck, validateCheck);
                    childCheck = null;
                }
            }
            childCheck = null;
        }
    };
    TreeView.prototype.openNode = function(toBeOpened, e) {
        var focusedNode = this.getFocusedNode();
        var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, focusedNode);
        if (toBeOpened) {
            if (!icon) return;
            else if (icon.classList.contains($71c78e892be7c33f$var$EXPANDABLE)) this.expandAction(focusedNode, icon, e);
            else this.focusNextNode(focusedNode, true);
        } else if (icon && icon.classList.contains($71c78e892be7c33f$var$COLLAPSIBLE)) this.collapseNode(focusedNode, icon, e);
        else {
            var parentLi = (0, $4ZDHT.closest)((0, $4ZDHT.closest)(focusedNode, "." + $71c78e892be7c33f$var$PARENTITEM), "." + $71c78e892be7c33f$var$LISTITEM);
            if (!parentLi) return;
            else if (!parentLi.classList.contains("e-disable")) {
                this.setFocus(focusedNode, parentLi);
                this.navigateToFocus(true);
            }
        }
    };
    TreeView.prototype.navigateNode = function(isTowards) {
        var focusedNode = this.getFocusedNode();
        this.focusNextNode(focusedNode, isTowards);
    };
    TreeView.prototype.navigateRootNode = function(isBackwards) {
        var focusedNode = this.getFocusedNode();
        var rootNode = isBackwards ? this.getRootNode() : this.getEndNode();
        if (!rootNode.classList.contains("e-disable")) {
            this.setFocus(focusedNode, rootNode);
            this.navigateToFocus(isBackwards);
        }
    };
    TreeView.prototype.getFocusedNode = function() {
        var selectedItem;
        var fNode = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTITEM + '[tabindex="0"]', this.element);
        if ((0, $3EnZW.isNullOrUndefined)(fNode)) selectedItem = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTITEM, this.element);
        return (0, $3EnZW.isNullOrUndefined)(fNode) ? (0, $3EnZW.isNullOrUndefined)(selectedItem) ? this.element.firstElementChild : selectedItem : fNode;
    };
    TreeView.prototype.focusNextNode = function(li, isTowards) {
        var nextNode = isTowards ? this.getNextNode(li) : this.getPrevNode(li);
        this.setFocus(li, nextNode);
        this.navigateToFocus(!isTowards);
        if (nextNode.classList.contains("e-disable")) {
            var lastChild = nextNode.lastChild;
            if (nextNode.previousSibling == null && nextNode.classList.contains("e-level-1")) this.focusNextNode(nextNode, true);
            else if (nextNode.nextSibling == null && nextNode.classList.contains("e-node-collapsed")) this.focusNextNode(nextNode, false);
            else if (nextNode.nextSibling == null && lastChild.classList.contains($71c78e892be7c33f$var$TEXTWRAP)) this.focusNextNode(nextNode, false);
            else this.focusNextNode(nextNode, isTowards);
        }
    };
    TreeView.prototype.getNextNode = function(li) {
        var index = this.liList.indexOf(li);
        var nextNode;
        do {
            index++;
            nextNode = this.liList[parseInt(index.toString(), 10)];
            if ((0, $3EnZW.isNullOrUndefined)(nextNode)) return li;
        }while (!(0, $4ZDHT.isVisible)(nextNode));
        return nextNode;
    };
    TreeView.prototype.getPrevNode = function(li) {
        var index = this.liList.indexOf(li);
        var prevNode;
        do {
            index--;
            prevNode = this.liList[parseInt(index.toString(), 10)];
            if ((0, $3EnZW.isNullOrUndefined)(prevNode)) return li;
        }while (!(0, $4ZDHT.isVisible)(prevNode));
        return prevNode;
    };
    TreeView.prototype.getRootNode = function() {
        var index = 0;
        var rootNode;
        do {
            rootNode = this.liList[parseInt(index.toString(), 10)];
            index++;
        }while (!(0, $4ZDHT.isVisible)(rootNode));
        return rootNode;
    };
    TreeView.prototype.getEndNode = function() {
        var index = this.liList.length - 1;
        var endNode;
        do {
            endNode = this.liList[parseInt(index.toString(), 10)];
            index--;
        }while (!(0, $4ZDHT.isVisible)(endNode));
        return endNode;
    };
    TreeView.prototype.setFocus = function(preNode, nextNode) {
        (0, $4ZDHT.removeClass)([
            preNode
        ], $71c78e892be7c33f$var$FOCUS);
        preNode.setAttribute("tabindex", "-1");
        if (!nextNode.classList.contains("e-disable")) {
            (0, $4ZDHT.addClass)([
                nextNode
            ], $71c78e892be7c33f$var$FOCUS);
            nextNode.setAttribute("tabindex", "0");
            nextNode.focus();
            (0, $aqzbR.EventHandler).add(nextNode, "blur", this.focusOut, this);
            this.updateIdAttr(preNode, nextNode);
        }
    };
    TreeView.prototype.updateIdAttr = function(preNode, nextNode) {
        this.element.removeAttribute("aria-activedescendant");
        if (preNode) preNode.removeAttribute("id");
        nextNode.setAttribute("id", this.element.id + "_active");
        this.element.setAttribute("aria-activedescendant", this.element.id + "_active");
    };
    TreeView.prototype.focusIn = function() {
        if (!this.mouseDownStatus) {
            var focusedElement = this.getFocusedNode();
            if (focusedElement.classList.contains("e-disable")) {
                focusedElement.setAttribute("tabindex", "-1");
                this.navigateNode(true);
            } else {
                focusedElement.setAttribute("tabindex", "0");
                (0, $4ZDHT.addClass)([
                    focusedElement
                ], $71c78e892be7c33f$var$FOCUS);
                (0, $aqzbR.EventHandler).add(focusedElement, "blur", this.focusOut, this);
            }
            this.mouseDownStatus = false;
        }
    };
    TreeView.prototype.focusOut = function(event) {
        var focusedElement = this.getFocusedNode();
        if (event.target === focusedElement) {
            (0, $4ZDHT.removeClass)([
                focusedElement
            ], $71c78e892be7c33f$var$FOCUS);
            (0, $aqzbR.EventHandler).remove(focusedElement, "blur", this.focusOut);
        }
    };
    TreeView.prototype.onMouseOver = function(e) {
        if ((0, $5q7BP.Browser).isDevice) return;
        var target = e.target;
        var classList = target.classList;
        var currentLi = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
        if (!currentLi || classList.contains($71c78e892be7c33f$var$PARENTITEM) || classList.contains($71c78e892be7c33f$var$LISTITEM)) {
            this.removeHover();
            return;
        } else if (currentLi && !currentLi.classList.contains("e-disable")) this.setHover(currentLi);
    };
    TreeView.prototype.setHover = function(li) {
        if (!li.classList.contains($71c78e892be7c33f$var$HOVER) && !li.classList.contains($71c78e892be7c33f$var$PREVENTSELECT)) {
            this.removeHover();
            (0, $4ZDHT.addClass)([
                li
            ], $71c78e892be7c33f$var$HOVER);
        }
    };
    TreeView.prototype.onMouseLeave = function() {
        this.removeHover();
    };
    TreeView.prototype.removeHover = function() {
        var hoveredNode = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$HOVER, this.element);
        if (hoveredNode && hoveredNode.length) (0, $4ZDHT.removeClass)(hoveredNode, $71c78e892be7c33f$var$HOVER);
    };
    TreeView.prototype.getNodeData = function(currLi, fromDS) {
        if (!(0, $3EnZW.isNullOrUndefined)(currLi) && currLi.classList.contains($71c78e892be7c33f$var$LISTITEM) && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(currLi, "." + $71c78e892be7c33f$var$CONTROL)) && (0, $4ZDHT.closest)(currLi, "." + $71c78e892be7c33f$var$CONTROL).classList.contains($71c78e892be7c33f$var$ROOT)) {
            var id = currLi.getAttribute("data-uid");
            var text = this.getText(currLi, fromDS);
            var pNode = (0, $4ZDHT.closest)(currLi.parentNode, "." + $71c78e892be7c33f$var$LISTITEM);
            var pid = pNode ? pNode.getAttribute("data-uid") : null;
            var selected = currLi.classList.contains($71c78e892be7c33f$var$ACTIVE);
            var selectable = currLi.classList.contains($71c78e892be7c33f$var$PREVENTSELECT) ? false : true;
            var expanded = currLi.getAttribute("aria-expanded") === "true" ? true : false;
            var hasChildren = currLi.getAttribute("aria-expanded") !== null ? true : ((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$EXPANDABLE, currLi) || (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$COLLAPSIBLE, currLi)) != null ? true : false;
            var checked = null;
            var checkboxElement = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$CHECKBOXWRAP, currLi);
            if (this.showCheckBox && checkboxElement) checked = currLi.getAttribute("aria-checked");
            return {
                id: id,
                text: text,
                parentID: pid,
                selected: selected,
                selectable: selectable,
                expanded: expanded,
                isChecked: checked,
                hasChildren: hasChildren
            };
        }
        return {
            id: "",
            text: "",
            parentID: "",
            selected: false,
            expanded: false,
            isChecked: "",
            hasChildren: false
        };
    };
    TreeView.prototype.getText = function(currLi, fromDS) {
        if (fromDS) {
            var nodeData = this.getNodeObject(currLi.getAttribute("data-uid"));
            var level = parseFloat(currLi.getAttribute("aria-level"));
            var nodeFields = this.getFields(this.fields, level, 1);
            return (0, $3EnZW.getValue)(nodeFields.text, nodeData);
        }
        return (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTTEXT, currLi).textContent;
    };
    TreeView.prototype.getExpandEvent = function(currLi, e) {
        var nodeData = this.getNodeData(currLi);
        return {
            cancel: false,
            isInteracted: (0, $3EnZW.isNullOrUndefined)(e) ? false : true,
            node: currLi,
            nodeData: nodeData,
            event: e
        };
    };
    TreeView.prototype.renderNodeTemplate = function(data, textEle, dataId) {
        var tempArr = this.nodeTemplateFn(data, this, "nodeTemplate" + dataId, this.element.id + "nodeTemplate", this.isStringTemplate, undefined, textEle, this.root);
        if (tempArr) {
            tempArr = Array.prototype.slice.call(tempArr);
            (0, $4ZDHT.append)(tempArr, textEle);
        }
    };
    TreeView.prototype.destroyTemplate = function(liEle) {
        this.clearTemplate([
            "nodeTemplate" + liEle.getAttribute("data-uid")
        ]);
    };
    TreeView.prototype.reRenderNodes = function() {
        this.updateListProp(this.fields);
        if ((0, $5q7BP.Browser).isIE) {
            this.ulElement = this.element.querySelector(".e-list-parent.e-ul");
            this.ulElement.parentElement.removeChild(this.ulElement);
        } else this.element.innerHTML = "";
        if (!(0, $3EnZW.isNullOrUndefined)(this.nodeTemplateFn)) this.clearTemplate();
        this.setTouchClass();
        this.setProperties({
            selectedNodes: [],
            checkedNodes: [],
            expandedNodes: []
        }, true);
        this.checkedElement = [];
        this.isLoaded = false;
        this.setDataBinding(true);
    };
    TreeView.prototype.setCssClass = function(oldClass, newClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass) && oldClass !== "") (0, $4ZDHT.removeClass)([
            this.element
        ], oldClass.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(newClass) && newClass !== "") (0, $4ZDHT.addClass)([
            this.element
        ], newClass.split(" "));
    };
    TreeView.prototype.editingHandler = function(e) {
        var target = e.target;
        if (!target || target.classList.contains($71c78e892be7c33f$var$ROOT) || target.classList.contains($71c78e892be7c33f$var$PARENTITEM) || target.classList.contains($71c78e892be7c33f$var$LISTITEM) || target.classList.contains($71c78e892be7c33f$var$ICON) || target.classList.contains($71c78e892be7c33f$var$INPUT) || target.classList.contains($71c78e892be7c33f$var$INPUTGROUP)) return;
        else {
            var liEle = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
            this.createTextbox(liEle);
        }
    };
    TreeView.prototype.createTextbox = function(liEle) {
        var _this = this;
        var oldInpEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TREEINPUT, this.element);
        if (oldInpEle) oldInpEle.blur();
        var textEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTTEXT, liEle);
        this.updateOldText(liEle);
        var innerEle = this.createElement("input", {
            className: $71c78e892be7c33f$var$TREEINPUT,
            attrs: {
                value: this.oldText
            }
        });
        var eventArgs = this.getEditEvent(liEle, null, innerEle.outerHTML);
        this.trigger("nodeEditing", eventArgs, function(observedArgs) {
            if (!observedArgs.cancel) {
                var inpWidth = textEle.offsetWidth + 5;
                var style_1 = "width:" + inpWidth + "px";
                (0, $4ZDHT.addClass)([
                    liEle
                ], $71c78e892be7c33f$var$EDITING);
                if (!(0, $3EnZW.isNullOrUndefined)(_this.nodeTemplateFn)) _this.destroyTemplate(liEle);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (_this.isReact) setTimeout(function() {
                    _this.renderTextBox(eventArgs, textEle, style_1);
                }, 5);
                else _this.renderTextBox(eventArgs, textEle, style_1);
            }
        });
    };
    TreeView.prototype.renderTextBox = function(eventArgs, textEle, style) {
        textEle.innerHTML = eventArgs.innerHtml;
        var inpEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TREEINPUT, textEle);
        this.inputObj = (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
            element: inpEle,
            properties: {
                enableRtl: this.enableRtl
            }
        }, this.createElement);
        this.inputObj.container.setAttribute("style", style);
        inpEle.focus();
        var inputEle = inpEle;
        inputEle.setSelectionRange(0, inputEle.value.length);
        this.wireInputEvents(inpEle);
    };
    TreeView.prototype.updateOldText = function(liEle) {
        var id = liEle.getAttribute("data-uid");
        this.editData = this.getNodeObject(id);
        var level = parseFloat(liEle.getAttribute("aria-level"));
        this.editFields = this.getFields(this.fields, level, 1);
        this.oldText = (0, $3EnZW.getValue)(this.editFields.text, this.editData);
    };
    TreeView.prototype.inputFocusOut = function(e) {
        if (!(0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TREEINPUT, this.element)) return;
        var target = e.target;
        var newText = target.value;
        var txtEle = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTTEXT);
        var liEle = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
        (0, $4ZDHT.detach)(this.inputObj.container);
        (0, $168e4e125732cd26$export$f5b8910cec6cf069).destroy({
            element: target,
            properties: this.properties
        });
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !this.isOffline) this.crudOperation("update", null, liEle, newText, null, null, true);
        else this.appendNewText(liEle, txtEle, newText, true);
        (0, $aqzbR.EventHandler).remove(target, "blur", this.inputFocusOut);
        this.inputObj = null;
        (0, $4ZDHT.detach)(target);
        target = null;
    };
    TreeView.prototype.appendNewText = function(liEle, txtEle, newText, isInput) {
        var _this = this;
        var eventArgs = this.getEditEvent(liEle, newText, null);
        this.trigger("nodeEdited", eventArgs, function(observedArgs) {
            newText = observedArgs.cancel ? observedArgs.oldText : observedArgs.newText;
            _this.updateText(liEle, txtEle, newText, isInput);
            if (observedArgs.oldText !== newText) _this.triggerEvent("nodeEdited", [
                _this.getNode(liEle)
            ]);
        });
    };
    TreeView.prototype.updateText = function(liEle, txtEle, newText, isInput) {
        var newData = (0, $3EnZW.setValue)(this.editFields.text, newText, this.editData);
        if (!(0, $3EnZW.isNullOrUndefined)(this.nodeTemplateFn)) {
            txtEle.innerText = "";
            var dataId = liEle.getAttribute("data-uid");
            this.renderNodeTemplate(newData, txtEle, dataId);
            this.renderReactTemplates();
        } else if (this.enableHtmlSanitizer) txtEle.innerText = (0, $3P3ke.SanitizeHtmlHelper).sanitize(newText);
        else txtEle.innerHTML = newText;
        if (isInput) {
            (0, $4ZDHT.removeClass)([
                liEle
            ], $71c78e892be7c33f$var$EDITING);
            liEle.focus();
            (0, $aqzbR.EventHandler).add(liEle, "blur", this.focusOut, this);
            (0, $4ZDHT.addClass)([
                liEle
            ], $71c78e892be7c33f$var$FOCUS);
        }
        if (this.allowTextWrap) this.calculateWrap(liEle);
    };
    TreeView.prototype.getElement = function(ele) {
        if ((0, $3EnZW.isNullOrUndefined)(ele)) return null;
        else if (typeof ele === "string") return this.element.querySelector('[data-uid="' + ele + '"]');
        else if (typeof ele === "object") return (0, $3EnZW.getElement)(ele);
        else return null;
    };
    TreeView.prototype.getId = function(ele) {
        if ((0, $3EnZW.isNullOrUndefined)(ele)) return null;
        else if (typeof ele === "string") return ele;
        else if (typeof ele === "object") return (0, $3EnZW.getElement)(ele).getAttribute("data-uid");
        else return null;
    };
    TreeView.prototype.getEditEvent = function(liEle, newText, inpEle) {
        var data = this.getNodeData(liEle);
        return {
            cancel: false,
            newText: newText,
            node: liEle,
            nodeData: data,
            oldText: this.oldText,
            innerHtml: inpEle
        };
    };
    TreeView.prototype.getNodeObject = function(id) {
        var childNodes;
        if ((0, $3EnZW.isNullOrUndefined)(id)) return childNodes;
        else if (this.dataType === 1) for(var i = 0, objlen = this.treeData.length; i < objlen; i++){
            var dataId = (0, $3EnZW.getValue)(this.fields.id, this.treeData[parseInt(i.toString(), 10)]);
            if (!(0, $3EnZW.isNullOrUndefined)(this.treeData[parseInt(i.toString(), 10)]) && !(0, $3EnZW.isNullOrUndefined)(dataId) && dataId.toString() === id) return this.treeData[parseInt(i.toString(), 10)];
        }
        else return this.getChildNodeObject(this.treeData, this.fields, id);
        return childNodes;
    };
    TreeView.prototype.getChildNodeObject = function(obj, mapper, id) {
        var newList;
        if ((0, $3EnZW.isNullOrUndefined)(obj)) return newList;
        for(var i = 0, objlen = obj.length; i < objlen; i++){
            var dataId = (0, $3EnZW.getValue)(mapper.id, obj[parseInt(i.toString(), 10)]);
            if (obj[parseInt(i.toString(), 10)] && dataId && dataId.toString() === id) return obj[parseInt(i.toString(), 10)];
            else if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]))) {
                var childData = (0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]);
                newList = this.getChildNodeObject(childData, this.getChildMapper(mapper), id);
                if (newList !== undefined) break;
            } else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]))) {
                var child = "child";
                newList = this.getChildNodeObject((0, $3EnZW.getValue)(child, obj[parseInt(i.toString(), 10)]), this.getChildMapper(mapper), id);
                if (newList !== undefined) break;
            } else if (this.isChildObject()) {
                var children = "child";
                var childData = (0, $3EnZW.getValue)(children, obj[parseInt(i.toString(), 10)]);
                newList = this.getChildNodeObject(childData, this.getChildMapper(mapper), id);
                if (newList !== undefined) break;
            }
        }
        return newList;
    };
    TreeView.prototype.setDragAndDrop = function(toBind) {
        if (toBind && !this.disabled) this.initializeDrag();
        else this.destroyDrag();
    };
    TreeView.prototype.initializeDrag = function() {
        var _this = this;
        var virtualEle;
        this.dragObj = new (0, $eAUyT.Draggable)(this.element, {
            enableTailMode: true,
            enableAutoScroll: true,
            dragArea: this.dragArea,
            dragTarget: "." + $71c78e892be7c33f$var$TEXTWRAP,
            enableTapHold: true,
            tapHoldThreshold: 100,
            helper: function(e) {
                _this.dragTarget = e.sender.target;
                var dragRoot = (0, $4ZDHT.closest)(_this.dragTarget, "." + $71c78e892be7c33f$var$ROOT);
                var dragWrap = (0, $4ZDHT.closest)(_this.dragTarget, "." + $71c78e892be7c33f$var$TEXTWRAP);
                _this.dragLi = (0, $4ZDHT.closest)(_this.dragTarget, "." + $71c78e892be7c33f$var$LISTITEM);
                if (_this.fullRowSelect && !dragWrap && _this.dragTarget.classList.contains($71c78e892be7c33f$var$FULLROW)) dragWrap = _this.dragTarget.nextElementSibling;
                if (!_this.dragTarget || !e.element.isSameNode(dragRoot) || !dragWrap || _this.dragTarget.classList.contains($71c78e892be7c33f$var$ROOT) || _this.dragTarget.classList.contains($71c78e892be7c33f$var$PARENTITEM) || _this.dragTarget.classList.contains($71c78e892be7c33f$var$LISTITEM) || _this.dragLi.classList.contains("e-disable")) return false;
                var cloneEle = dragWrap.cloneNode(true);
                if ((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, cloneEle))) {
                    var icon = _this.createElement("div", {
                        className: $71c78e892be7c33f$var$ICON + " " + $71c78e892be7c33f$var$EXPANDABLE
                    });
                    cloneEle.insertBefore(icon, cloneEle.children[0]);
                }
                var cssClass = $71c78e892be7c33f$var$DRAGITEM + " " + $71c78e892be7c33f$var$ROOT + " " + _this.cssClass + " " + (_this.enableRtl ? $71c78e892be7c33f$var$RTL : "");
                virtualEle = _this.createElement("div", {
                    className: cssClass
                });
                virtualEle.appendChild(cloneEle);
                var nLen = _this.selectedNodes.length;
                if (nLen > 1 && _this.allowMultiSelection && _this.dragLi.classList.contains($71c78e892be7c33f$var$ACTIVE)) {
                    var cNode = _this.createElement("span", {
                        className: $71c78e892be7c33f$var$DROPCOUNT,
                        innerHTML: "" + nLen
                    });
                    virtualEle.appendChild(cNode);
                }
                document.body.appendChild(virtualEle);
                document.body.style.cursor = "";
                _this.dragData = _this.getNodeData(_this.dragLi);
                return virtualEle;
            },
            dragStart: function(e) {
                (0, $4ZDHT.addClass)([
                    _this.element
                ], $71c78e892be7c33f$var$DRAGGING);
                var listItem = (0, $4ZDHT.closest)(e.target, ".e-list-item");
                var level;
                if (listItem) level = parseInt(listItem.getAttribute("aria-level"), 10);
                var eventArgs = _this.getDragEvent(e.event, _this, null, e.target, null, virtualEle, level);
                if (eventArgs.draggedNode.classList.contains($71c78e892be7c33f$var$EDITING)) {
                    _this.dragObj.intDestroy(e.event);
                    _this.dragCancelAction(virtualEle);
                } else _this.trigger("nodeDragStart", eventArgs, function(observedArgs) {
                    if (observedArgs.cancel) {
                        _this.dragObj.intDestroy(e.event);
                        _this.dragCancelAction(virtualEle);
                    } else _this.dragStartAction = true;
                });
            },
            drag: function(e) {
                _this.dragObj.setProperties({
                    cursorAt: {
                        top: !(0, $3EnZW.isNullOrUndefined)(e.event.targetTouches) || (0, $5q7BP.Browser).isDevice ? 60 : -20
                    }
                });
                _this.dragAction(e, virtualEle);
            },
            dragStop: function(e) {
                (0, $4ZDHT.removeClass)([
                    _this.element
                ], $71c78e892be7c33f$var$DRAGGING);
                if (!e.target.classList.contains("e-sibling")) _this.removeVirtualEle();
                var dropTarget = e.target;
                var preventTargetExpand = false;
                var dropRoot = (0, $4ZDHT.closest)(dropTarget, "." + $71c78e892be7c33f$var$DROPPABLE);
                // eslint-disable-next-line
                var isHelperElement = true;
                if (!dropTarget || !dropRoot) {
                    (0, $4ZDHT.detach)(e.helper);
                    document.body.style.cursor = "";
                }
                var listItem = (0, $4ZDHT.closest)(dropTarget, ".e-list-item");
                var level;
                if (listItem) level = parseInt(listItem.getAttribute("aria-level"), 10);
                var eventArgs = _this.getDragEvent(e.event, _this, dropTarget, dropTarget, null, e.helper, level);
                eventArgs.preventTargetExpand = preventTargetExpand;
                _this.trigger("nodeDragStop", eventArgs, function(observedArgs) {
                    _this.dragParent = observedArgs.draggedParentNode;
                    _this.preventExpand = observedArgs.preventTargetExpand;
                    if (observedArgs.cancel) {
                        if (e.helper.parentNode) (0, $4ZDHT.detach)(e.helper);
                        document.body.style.cursor = "";
                        isHelperElement = false;
                        if (dropTarget.classList.contains("e-sibling")) _this.removeVirtualEle();
                    }
                    _this.dragStartAction = false;
                });
            }
        });
        this.dropObj = new (0, $g9Ic7.Droppable)(this.element, {
            out: function(e) {
                if (!(0, $3EnZW.isNullOrUndefined)(e) && !e.target.classList.contains($71c78e892be7c33f$var$SIBLING) && _this.dropObj.dragData.default && _this.dropObj.dragData.default.helper.classList.contains($71c78e892be7c33f$var$ROOT)) document.body.style.cursor = "not-allowed";
            },
            over: function() {
                document.body.style.cursor = "";
            },
            drop: function(e) {
                _this.dropAction(e);
                _this.removeVirtualEle();
            }
        });
    };
    TreeView.prototype.dragCancelAction = function(virtualEle) {
        (0, $4ZDHT.detach)(virtualEle);
        (0, $4ZDHT.removeClass)([
            this.element
        ], $71c78e892be7c33f$var$DRAGGING);
        this.dragStartAction = false;
    };
    TreeView.prototype.getOffsetX = function(event, target) {
        var touchList = event.changedTouches;
        if (touchList && touchList.length > 0) return touchList[0].clientX - target.getBoundingClientRect().left;
        else return event.offsetX;
    };
    TreeView.prototype.getOffsetY = function(event, target) {
        var touchList = event.changedTouches;
        if (touchList && touchList.length > 0) return touchList[0].clientY - target.getBoundingClientRect().top;
        else return event.offsetY;
    };
    TreeView.prototype.dragAction = function(e, virtualEle) {
        var dropRoot = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$DROPPABLE);
        var dropWrap = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$TEXTWRAP);
        var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, virtualEle);
        (0, $4ZDHT.removeClass)([
            icon
        ], [
            $71c78e892be7c33f$var$DROPIN,
            $71c78e892be7c33f$var$DROPNEXT,
            $71c78e892be7c33f$var$DROPOUT,
            $71c78e892be7c33f$var$NODROP
        ]);
        this.isDropIn = false;
        this.removeVirtualEle();
        document.body.style.cursor = "";
        var classList = e.target.classList;
        var event = e.event;
        var offsetY = this.getOffsetY(event, e.target);
        var offsetX = this.getOffsetX(event, e.target);
        if (this.fullRowSelect && !dropWrap && !(0, $3EnZW.isNullOrUndefined)(classList) && classList.contains($71c78e892be7c33f$var$FULLROW)) dropWrap = e.target.nextElementSibling;
        if (dropRoot) {
            var dropLi = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$LISTITEM);
            var checkWrapper = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$CHECKBOXWRAP);
            var collapse = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$COLLAPSIBLE);
            var expand = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$EXPANDABLE);
            if (!dropRoot.classList.contains($71c78e892be7c33f$var$ROOT) || dropWrap && !dropLi.isSameNode(this.dragLi) && !this.isDescendant(this.dragLi, dropLi)) {
                if (this.hasTemplate && dropLi) {
                    var templateTarget = (0, $4ZDHT.select)(this.fullRowSelect ? "." + $71c78e892be7c33f$var$FULLROW : "." + $71c78e892be7c33f$var$TEXTWRAP, dropLi);
                    if (e && !expand && !collapse && offsetY < 7 && !checkWrapper || expand && offsetY < 5 || collapse && offsetX < 3) {
                        var index = this.fullRowSelect ? 1 : 0;
                        this.appendIndicator(dropLi, icon, index);
                    } else if (e && !expand && !collapse && !checkWrapper && templateTarget && offsetY > templateTarget.offsetHeight - 10 || expand && offsetY > 19 || collapse && offsetX > 19) {
                        var index = this.fullRowSelect ? 2 : 1;
                        this.appendIndicator(dropLi, icon, index);
                    } else {
                        (0, $4ZDHT.addClass)([
                            icon
                        ], $71c78e892be7c33f$var$DROPIN);
                        this.isDropIn = true;
                    }
                } else {
                    if (dropLi && e && !expand && !collapse && offsetY < 7 && !checkWrapper || expand && offsetY < 5 || collapse && offsetX < 3) {
                        var index = this.fullRowSelect ? 1 : 0;
                        this.appendIndicator(dropLi, icon, index);
                    } else if (dropLi && e && !expand && !collapse && e.target.offsetHeight > 0 && offsetY > e.target.offsetHeight - 10 && !checkWrapper || expand && offsetY > 19 || collapse && offsetX > 19) {
                        var index = this.fullRowSelect ? 2 : 1;
                        this.appendIndicator(dropLi, icon, index);
                    } else {
                        (0, $4ZDHT.addClass)([
                            icon
                        ], $71c78e892be7c33f$var$DROPIN);
                        this.isDropIn = true;
                    }
                }
            } else if (e.target.nodeName === "LI" && !dropLi.isSameNode(this.dragLi) && !this.isDescendant(this.dragLi, dropLi)) {
                (0, $4ZDHT.addClass)([
                    icon
                ], $71c78e892be7c33f$var$DROPNEXT);
                this.renderVirtualEle(e);
            } else if (e.target.classList.contains($71c78e892be7c33f$var$SIBLING)) (0, $4ZDHT.addClass)([
                icon
            ], $71c78e892be7c33f$var$DROPNEXT);
            else (0, $4ZDHT.addClass)([
                icon
            ], $71c78e892be7c33f$var$DROPOUT);
        } else {
            (0, $4ZDHT.addClass)([
                icon
            ], $71c78e892be7c33f$var$NODROP);
            document.body.style.cursor = "not-allowed";
        }
        var listItem = (0, $4ZDHT.closest)(e.target, ".e-list-item");
        var level;
        if (listItem) level = parseInt(listItem.getAttribute("aria-level"), 10);
        var eventArgs = this.getDragEvent(e.event, this, e.target, e.target, null, virtualEle, level);
        if (eventArgs.dropIndicator) (0, $4ZDHT.removeClass)([
            icon
        ], eventArgs.dropIndicator);
        this.trigger("nodeDragging", eventArgs);
        if (eventArgs.dropIndicator) (0, $4ZDHT.addClass)([
            icon
        ], eventArgs.dropIndicator);
    };
    TreeView.prototype.appendIndicator = function(dropLi, icon, index) {
        (0, $4ZDHT.addClass)([
            icon
        ], $71c78e892be7c33f$var$DROPNEXT);
        var virEle = this.createElement("div", {
            className: $71c78e892be7c33f$var$SIBLING
        });
        dropLi.insertBefore(virEle, dropLi.children[parseInt(index.toString(), 10)]);
    };
    TreeView.prototype.dropAction = function(e) {
        var event = e.event;
        var offsetY = this.getOffsetY(event, e.target);
        var dropTarget = e.target;
        var dragObj;
        var level;
        var drop = false;
        var nodeData = [];
        var liArray = [];
        var dragInstance = e.dragData.draggable;
        for(var i = 0; i < dragInstance.ej2_instances.length; i++)if (dragInstance.ej2_instances[parseInt(i.toString(), 10)] instanceof TreeView_1) {
            dragObj = dragInstance.ej2_instances[parseInt(i.toString(), 10)];
            break;
        }
        if (dragObj && dragObj.dragTarget) {
            var dragTarget = dragObj.dragTarget;
            var dragLi = (0, $4ZDHT.closest)(dragTarget, "." + $71c78e892be7c33f$var$LISTITEM);
            var dropLi = (0, $4ZDHT.closest)(dropTarget, "." + $71c78e892be7c33f$var$LISTITEM);
            liArray.push(dragLi);
            if (dropLi == null && dropTarget.classList.contains($71c78e892be7c33f$var$ROOT)) dropLi = dropTarget.firstElementChild;
            (0, $4ZDHT.detach)(e.droppedElement);
            document.body.style.cursor = "";
            if (!dropLi || dropLi.isSameNode(dragLi) || this.isDescendant(dragLi, dropLi)) {
                if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) === false) this.preventExpand = false;
                return;
            }
            if (dragObj.allowMultiSelection && dragLi.classList.contains($71c78e892be7c33f$var$ACTIVE)) {
                var sNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$ACTIVE, dragObj.element);
                liArray = sNodes;
                if (e.target.offsetHeight <= 33 && offsetY > e.target.offsetHeight - 10 && offsetY > 6) for(var i = sNodes.length - 1; i >= 0; i--){
                    if (dropLi.isSameNode(sNodes[parseInt(i.toString(), 10)]) || this.isDescendant(sNodes[parseInt(i.toString(), 10)], dropLi)) continue;
                    this.appendNode(dropTarget, sNodes[parseInt(i.toString(), 10)], dropLi, e, dragObj, offsetY);
                }
                else for(var i = 0; i < sNodes.length; i++){
                    if (dropLi.isSameNode(sNodes[parseInt(i.toString(), 10)]) || this.isDescendant(sNodes[parseInt(i.toString(), 10)], dropLi)) continue;
                    this.appendNode(dropTarget, sNodes[parseInt(i.toString(), 10)], dropLi, e, dragObj, offsetY);
                }
            } else this.appendNode(dropTarget, dragLi, dropLi, e, dragObj, offsetY);
            level = parseInt(dragLi.getAttribute("aria-level"), 10);
            drop = true;
        }
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) === false) this.preventExpand = false;
        for(var i = 0; i < liArray.length; i++)nodeData.push(this.getNode(liArray[parseInt(i.toString(), 10)]));
        this.trigger("nodeDropped", this.getDragEvent(e.event, dragObj, dropTarget, e.target, e.dragData.draggedElement, null, level, drop));
        if (dragObj.element.id !== this.element.id) {
            dragObj.triggerEvent("nodeDropped", nodeData);
            this.isNodeDropped = true;
            this.fields.dataSource = this.treeData;
        }
        this.triggerEvent("nodeDropped", nodeData);
    };
    TreeView.prototype.appendNode = function(dropTarget, dragLi, dropLi, e, dragObj, offsetY) {
        var checkWrapper = (0, $4ZDHT.closest)(dropTarget, "." + $71c78e892be7c33f$var$CHECKBOXWRAP);
        var collapse = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$COLLAPSIBLE);
        var expand = (0, $4ZDHT.closest)(e.target, "." + $71c78e892be7c33f$var$EXPANDABLE);
        if (!dragLi.classList.contains("e-disable") && !checkWrapper && (expand && e.event.offsetY < 5 || collapse && e.event.offsetX < 3 || expand && e.event.offsetY > 19 || collapse && e.event.offsetX > 19 || !expand && !collapse)) {
            if (dropTarget.nodeName === "LI") this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
            else if (dropTarget.firstElementChild && dropTarget.classList.contains($71c78e892be7c33f$var$ROOT)) {
                if (dropTarget.firstElementChild.nodeName === "UL") this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
            } else if (dropTarget.classList.contains("e-icon-collapsible") || dropTarget.classList.contains("e-icon-expandable")) this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
            else this.dropAsChildNode(dragLi, dropLi, dragObj, null, e, offsetY, null, dropTarget);
        } else this.dropAsChildNode(dragLi, dropLi, dragObj, null, e, offsetY, true, dropTarget);
        if (this.showCheckBox) this.ensureIndeterminate();
    };
    TreeView.prototype.dropAsSiblingNode = function(dragLi, dropLi, e, dragObj) {
        var dropUl = (0, $4ZDHT.closest)(dropLi, "." + $71c78e892be7c33f$var$PARENTITEM);
        var dragParentUl = (0, $4ZDHT.closest)(dragLi, "." + $71c78e892be7c33f$var$PARENTITEM);
        var dragParentLi = (0, $4ZDHT.closest)(dragParentUl, "." + $71c78e892be7c33f$var$LISTITEM);
        var pre;
        if (e.target.offsetHeight > 0 && e.event.offsetY > e.target.offsetHeight - 2) pre = false;
        else if (e.event.offsetY < 2) pre = true;
        else if (e.target.classList.contains("e-icon-expandable") || e.target.classList.contains("e-icon-collapsible")) {
            if (e.event.offsetY < 5 || e.event.offsetX < 3) pre = true;
            else if (e.event.offsetY > 15 || e.event.offsetX > 17) pre = false;
        }
        if (e.target.classList.contains("e-icon-expandable") || e.target.classList.contains("e-icon-collapsible")) {
            var target = e.target.closest("li");
            dropUl.insertBefore(dragLi, pre ? target : target.nextElementSibling);
        } else dropUl.insertBefore(dragLi, pre ? e.target : e.target.nextElementSibling);
        this.moveData(dragLi, dropLi, dropUl, pre, dragObj);
        this.updateElement(dragParentUl, dragParentLi);
        this.updateAriaLevel(dragLi);
        if (dragObj.element.id === this.element.id) this.updateList();
        else {
            dragObj.updateInstance();
            this.updateInstance();
        }
    };
    TreeView.prototype.dropAsChildNode = function(dragLi, dropLi, dragObj, index, e, pos, isCheck, dropTarget) {
        var dragParentUl = (0, $4ZDHT.closest)(dragLi, "." + $71c78e892be7c33f$var$PARENTITEM);
        var dragParentLi = (0, $4ZDHT.closest)(dragParentUl, "." + $71c78e892be7c33f$var$LISTITEM);
        var dropParentUl = (0, $4ZDHT.closest)(dropLi, "." + $71c78e892be7c33f$var$PARENTITEM);
        var templateTarget;
        if (e && e.target) templateTarget = (0, $4ZDHT.select)(this.fullRowSelect ? "." + $71c78e892be7c33f$var$FULLROW : "." + $71c78e892be7c33f$var$TEXTWRAP, dropLi);
        if (e && (pos < 7 && !dropTarget.classList.contains("e-sibling") || dropTarget.classList.contains("e-sibling") && !dropLi.lastChild.classList.contains("e-sibling")) && !isCheck) {
            dropParentUl.insertBefore(dragLi, dropLi);
            this.moveData(dragLi, dropLi, dropParentUl, true, dragObj);
        } else if (e && e.target.offsetHeight > 0 && pos > e.target.offsetHeight - 10 && !isCheck && !this.hasTemplate) {
            dropParentUl.insertBefore(dragLi, dropLi.nextElementSibling);
            this.moveData(dragLi, dropLi, dropParentUl, false, dragObj);
        } else if (this.hasTemplate && templateTarget && pos > templateTarget.offsetHeight - 10 && !isCheck) {
            dropParentUl.insertBefore(dragLi, dropLi.nextElementSibling);
            this.moveData(dragLi, dropLi, dropParentUl, false, dragObj);
        } else {
            var dropUl = this.expandParent(dropLi);
            var childLi = !(0, $3EnZW.isNullOrUndefined)(index) ? dropUl.childNodes[parseInt(index.toString(), 10)] : null;
            dropUl.insertBefore(dragLi, childLi);
            this.moveData(dragLi, childLi, dropUl, true, dragObj);
        }
        this.updateElement(dragParentUl, dragParentLi);
        this.updateAriaLevel(dragLi);
        if (dragObj.element.id === this.element.id) this.updateList();
        else {
            dragObj.updateInstance();
            this.updateInstance();
        }
    };
    TreeView.prototype.moveData = function(dragLi, dropLi, dropUl, pre, dragObj) {
        var dropParentLi = (0, $4ZDHT.closest)(dropUl, "." + $71c78e892be7c33f$var$LISTITEM);
        var id = this.getId(dragLi);
        var removedData = dragObj.updateChildField(dragObj.treeData, dragObj.fields, id, null, null, true);
        var refId = this.getId(dropLi);
        var index = this.getDataPos(this.treeData, this.fields, refId);
        var parentId = this.getId(dropParentLi);
        if (this.dataType === 1) {
            this.updateField(this.treeData, this.fields, parentId, "hasChildren", true);
            var pos = (0, $3EnZW.isNullOrUndefined)(index) ? this.treeData.length : pre ? index : index + 1;
            if ((0, $3EnZW.isNullOrUndefined)(parentId) && !this.hasPid) delete removedData[0][this.fields.parentID];
            else {
                var currPid = this.isNumberTypeId ? parseFloat(parentId) : parentId;
                (0, $3EnZW.setValue)(this.fields.parentID, currPid, removedData[0]);
            }
            this.treeData.splice(pos, 0, removedData[0]);
            if (dragObj.element.id !== this.element.id) {
                var childData = dragObj.removeChildNodes(id);
                pos++;
                for(var i = 0, len = childData.length; i < len; i++){
                    this.treeData.splice(pos, 0, childData[parseInt(i.toString(), 10)]);
                    pos++;
                }
                dragObj.groupedData = dragObj.getGroupedData(dragObj.treeData, dragObj.fields.parentID);
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        } else this.addChildData(this.treeData, this.fields, parentId, removedData, pre ? index : index + 1);
    };
    TreeView.prototype.expandParent = function(dropLi) {
        var dropIcon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
        if (dropIcon && dropIcon.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && this.preventExpand !== true) this.expandAction(dropLi, dropIcon, null);
        var dropUl = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, dropLi);
        if (this.preventExpand === true && !dropUl && dropIcon) this.renderChildNodes(dropLi);
        dropUl = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, dropLi);
        if (!(0, $3EnZW.isNullOrUndefined)(dropUl) && this.preventExpand === true) dropUl.style.display = "none";
        if (!(0, $3EnZW.isNullOrUndefined)(dropUl) && this.preventExpand === false) dropUl.style.display = "block";
        if ((0, $3EnZW.isNullOrUndefined)(dropUl) && this.preventExpand === true) {
            if ((0, $3EnZW.isNullOrUndefined)(dropIcon)) (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateIcon(this.createElement, dropLi, $71c78e892be7c33f$var$EXPANDABLE, this.listBaseOption);
            var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
            if (icon) icon.classList.add("e-icon-expandable");
            dropUl = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateUL(this.createElement, [], null, this.listBaseOption);
            dropLi.appendChild(dropUl);
            if (icon) (0, $4ZDHT.removeClass)([
                icon
            ], $71c78e892be7c33f$var$COLLAPSIBLE);
            else (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateIcon(this.createElement, dropLi, $71c78e892be7c33f$var$EXPANDABLE, this.listBaseOption);
            dropLi.setAttribute("aria-expanded", "false");
            dropUl.style.display = "none";
        }
        if ((0, $3EnZW.isNullOrUndefined)(dropUl)) {
            var args = this.expandArgs;
            if ((0, $3EnZW.isNullOrUndefined)(args) || args && args.name !== "nodeExpanding") this.trigger("nodeExpanding", this.getExpandEvent(dropLi, null));
            if ((0, $3EnZW.isNullOrUndefined)(dropIcon)) (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateIcon(this.createElement, dropLi, $71c78e892be7c33f$var$COLLAPSIBLE, this.listBaseOption);
            var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
            if (icon) (0, $4ZDHT.removeClass)([
                icon
            ], $71c78e892be7c33f$var$EXPANDABLE);
            else {
                (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateIcon(this.createElement, dropLi, $71c78e892be7c33f$var$COLLAPSIBLE, this.listBaseOption);
                icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
                (0, $4ZDHT.removeClass)([
                    icon
                ], $71c78e892be7c33f$var$EXPANDABLE);
            }
            dropUl = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).generateUL(this.createElement, [], null, this.listBaseOption);
            dropLi.appendChild(dropUl);
            this.addExpand(dropLi);
            this.trigger("nodeExpanded", this.getExpandEvent(dropLi, null));
        }
        return dropUl;
    };
    TreeView.prototype.updateElement = function(dragParentUl, dragParentLi) {
        if (dragParentLi && dragParentUl.childElementCount === 0) {
            var dragIcon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dragParentLi);
            (0, $4ZDHT.detach)(dragParentUl);
            (0, $4ZDHT.detach)(dragIcon);
            var parentId = this.getId(dragParentLi);
            this.updateField(this.treeData, this.fields, parentId, "hasChildren", false);
            this.removeExpand(dragParentLi, true);
        }
    };
    TreeView.prototype.updateAriaLevel = function(dragLi) {
        var level = this.parents(dragLi, "." + $71c78e892be7c33f$var$PARENTITEM).length;
        dragLi.setAttribute("aria-level", "" + level);
        this.updateChildAriaLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, dragLi), level + 1);
    };
    TreeView.prototype.updateChildAriaLevel = function(element, level) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            var cNodes = element.childNodes;
            for(var i = 0, len = cNodes.length; i < len; i++){
                var liEle = cNodes[parseInt(i.toString(), 10)];
                liEle.setAttribute("aria-level", "" + level);
                this.updateChildAriaLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, liEle), level + 1);
            }
        }
    };
    TreeView.prototype.renderVirtualEle = function(e) {
        var pre;
        var event = e.event;
        var offsetY = this.getOffsetY(event, e.target);
        if (offsetY > e.target.offsetHeight - 2) pre = false;
        else if (offsetY < 2) pre = true;
        var virEle = this.createElement("div", {
            className: $71c78e892be7c33f$var$SIBLING
        });
        var index = this.fullRowSelect ? pre ? 1 : 2 : pre ? 0 : 1;
        e.target.insertBefore(virEle, e.target.children[parseInt(index.toString(), 10)]);
    };
    TreeView.prototype.removeVirtualEle = function() {
        var sibEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$SIBLING);
        if (sibEle) (0, $4ZDHT.detach)(sibEle);
    };
    TreeView.prototype.destroyDrag = function() {
        if (this.dragObj && this.dropObj) {
            this.dragObj.destroy();
            this.dropObj.destroy();
        }
    };
    TreeView.prototype.getDragEvent = function(event, obj, dropTarget, target, dragNode, cloneEle, level, drop) {
        var dropLi = dropTarget ? (0, $4ZDHT.closest)(dropTarget, "." + $71c78e892be7c33f$var$LISTITEM) : null;
        var dropData = dropLi ? this.getNodeData(dropLi) : null;
        var draggedNode = obj ? obj.dragLi : dragNode;
        var draggedNodeData = obj ? obj.dragData : null;
        var newParent = dropTarget ? this.parents(dropTarget, "." + $71c78e892be7c33f$var$LISTITEM) : null;
        var dragLiParent = obj.dragLi.parentElement;
        var dragParent = obj.dragLi ? (0, $4ZDHT.closest)(dragLiParent, "." + $71c78e892be7c33f$var$LISTITEM) : null;
        var targetParent = null;
        var indexValue = null;
        var iconCss = [
            $71c78e892be7c33f$var$DROPNEXT,
            $71c78e892be7c33f$var$DROPIN,
            $71c78e892be7c33f$var$DROPOUT,
            $71c78e892be7c33f$var$NODROP
        ];
        var iconClass = null;
        var node = drop === true ? draggedNode : dropLi;
        var index = node ? (0, $4ZDHT.closest)(node, ".e-list-parent") : null;
        var i = 0;
        var position = null;
        dragParent = obj.dragLi && dragParent === null ? (0, $4ZDHT.closest)(dragLiParent, "." + $71c78e892be7c33f$var$ROOT) : dragParent;
        dragParent = drop === true ? this.dragParent : dragParent;
        if (cloneEle) while(i < 4){
            if ((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$ICON, cloneEle).classList.contains(iconCss[parseInt(i.toString(), 10)])) {
                iconClass = iconCss[parseInt(i.toString(), 10)];
                break;
            }
            i++;
        }
        if (index) {
            var dropTar = 0;
            for(i = 0; i < index.childElementCount; i++){
                dropTar = drop !== true && index.children[parseInt(i.toString(), 10)] === draggedNode && dropLi !== draggedNode ? ++dropTar : dropTar;
                if (drop !== true && index.children[parseInt(i.toString(), 10)].classList.contains("e-hover")) {
                    indexValue = event.offsetY >= 23 ? i + 1 : i;
                    break;
                } else if (index.children[parseInt(i.toString(), 10)] === node) {
                    indexValue = event.offsetY >= 23 ? i : i;
                    break;
                }
            }
            indexValue = dropTar !== 0 ? --indexValue : indexValue;
            position = this.isDropIn ? "Inside" : event.offsetY < 7 ? "Before" : "After";
        }
        if (dropTarget) {
            if (newParent.length === 0) targetParent = null;
            else if (dropTarget.classList.contains($71c78e892be7c33f$var$LISTITEM)) targetParent = newParent[0];
            else targetParent = newParent[1];
        }
        if (dropLi === draggedNode) targetParent = dropLi;
        if (dropTarget && target.offsetHeight <= 33 && event.offsetY < target.offsetHeight - 10 && event.offsetY > 6) {
            targetParent = dropLi;
            if (drop !== true) {
                level = ++level;
                var parent_2 = targetParent ? (0, $4ZDHT.select)(".e-list-parent", targetParent) : null;
                indexValue = parent_2 ? parent_2.children.length : 0;
                if (!(this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && parent_2 === null && targetParent) {
                    var parent_3 = targetParent.hasAttribute("data-uid") ? this.getChildNodes(this.fields.dataSource, targetParent.getAttribute("data-uid").toString()) : null;
                    indexValue = parent_3 ? parent_3.length : 0;
                }
            }
        }
        return {
            cancel: false,
            clonedNode: cloneEle,
            event: event,
            draggedNode: draggedNode,
            draggedNodeData: draggedNodeData,
            droppedNode: dropLi,
            droppedNodeData: dropData,
            dropIndex: indexValue,
            dropLevel: level,
            draggedParentNode: dragParent,
            dropTarget: targetParent,
            dropIndicator: iconClass,
            target: target,
            position: position
        };
    };
    TreeView.prototype.addFullRow = function(toAdd) {
        var len = this.liList.length;
        if (toAdd) for(var i = 0; i < len; i++)this.createFullRow(this.liList[parseInt(i.toString(), 10)]);
        else for(var i = 0; i < len; i++){
            var rowDiv = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$FULLROW, this.liList[parseInt(i.toString(), 10)]);
            (0, $4ZDHT.detach)(rowDiv);
        }
    };
    TreeView.prototype.createFullRow = function(item) {
        var rowDiv = this.createElement("div", {
            className: $71c78e892be7c33f$var$FULLROW
        });
        item.insertBefore(rowDiv, item.childNodes[0]);
    };
    TreeView.prototype.addMultiSelect = function(toAdd) {
        if (toAdd) {
            var liEles = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM + ':not([aria-selected="true"])', this.element);
            for(var _i = 0, liEles_1 = liEles; _i < liEles_1.length; _i++){
                var ele = liEles_1[_i];
                ele.setAttribute("aria-selected", "false");
            }
        } else {
            var liEles = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM + '[aria-selected="false"]', this.element);
            for(var _a = 0, liEles_2 = liEles; _a < liEles_2.length; _a++){
                var ele = liEles_2[_a];
                ele.removeAttribute("aria-selected");
            }
        }
    };
    TreeView.prototype.collapseByLevel = function(element, level, excludeHiddenNodes, currentLevel) {
        currentLevel = (0, $3EnZW.isNullOrUndefined)(currentLevel) ? 1 : currentLevel;
        if (level > 0 && !(0, $3EnZW.isNullOrUndefined)(element)) {
            var cNodes = this.getVisibleNodes(excludeHiddenNodes, element.childNodes);
            for(var i = 0, len = cNodes.length; i < len; i++){
                var liEle = cNodes[parseInt(i.toString(), 10)];
                var icon = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$COLLAPSIBLE, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, liEle));
                if (currentLevel >= level && !(0, $3EnZW.isNullOrUndefined)(icon)) this.collapseNode(liEle, icon, null);
                this.collapseByLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, liEle), level, excludeHiddenNodes, currentLevel + 1);
            }
        }
    };
    TreeView.prototype.collapseAllNodes = function(excludeHiddenNodes) {
        var cIcons = this.getVisibleNodes(excludeHiddenNodes, (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$COLLAPSIBLE, this.element));
        for(var i = 0, len = cIcons.length; i < len; i++){
            var icon = cIcons[parseInt(i.toString(), 10)];
            var liEle = (0, $4ZDHT.closest)(icon, "." + $71c78e892be7c33f$var$LISTITEM);
            this.collapseNode(liEle, icon, null);
        }
    };
    TreeView.prototype.expandByLevel = function(element, level, excludeHiddenNodes) {
        if (level > 0 && !(0, $3EnZW.isNullOrUndefined)(element)) {
            var eNodes = this.getVisibleNodes(excludeHiddenNodes, element.childNodes);
            for(var i = 0, len = eNodes.length; i < len; i++){
                var liEle = eNodes[parseInt(i.toString(), 10)];
                var icon = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$EXPANDABLE, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, liEle));
                if (!(0, $3EnZW.isNullOrUndefined)(icon)) this.expandAction(liEle, icon, null);
                this.expandByLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, liEle), level - 1, excludeHiddenNodes);
            }
        }
    };
    TreeView.prototype.expandAllNodes = function(excludeHiddenNodes) {
        var eIcons = this.getVisibleNodes(excludeHiddenNodes, (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$EXPANDABLE, this.element));
        for(var _i = 0, eIcons_1 = eIcons; _i < eIcons_1.length; _i++){
            var icon = eIcons_1[_i];
            var liEle = (0, $4ZDHT.closest)(icon, "." + $71c78e892be7c33f$var$LISTITEM);
            this.expandAction(liEle, icon, null, true, null, true);
        }
    };
    TreeView.prototype.getVisibleNodes = function(excludeHiddenNodes, nodes) {
        var vNodes = Array.prototype.slice.call(nodes);
        if (excludeHiddenNodes) {
            for(var i = 0; i < vNodes.length; i++)if (!(0, $4ZDHT.isVisible)(vNodes[parseInt(i.toString(), 10)])) {
                vNodes.splice(i, 1);
                i--;
            }
        }
        return vNodes;
    };
    TreeView.prototype.removeNode = function(node) {
        var dragParentUl = (0, $4ZDHT.closest)(node, "." + $71c78e892be7c33f$var$PARENTITEM);
        var dragParentLi = (0, $4ZDHT.closest)(dragParentUl, "." + $71c78e892be7c33f$var$LISTITEM);
        if (!(0, $3EnZW.isNullOrUndefined)(this.nodeTemplateFn)) this.destroyTemplate(node);
        (0, $4ZDHT.detach)(node);
        this.updateElement(dragParentUl, dragParentLi);
        this.removeData(node);
    };
    TreeView.prototype.updateInstance = function() {
        this.updateList();
        this.updateSelectedNodes();
        this.updateExpandedNodes();
    };
    TreeView.prototype.updateList = function() {
        this.liList = Array.prototype.slice.call((0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$LISTITEM, this.element));
    };
    TreeView.prototype.updateSelectedNodes = function() {
        this.setProperties({
            selectedNodes: []
        }, true);
        var sNodes = (0, $4ZDHT.selectAll)("." + $71c78e892be7c33f$var$ACTIVE, this.element);
        this.selectGivenNodes(sNodes);
    };
    TreeView.prototype.updateExpandedNodes = function() {
        this.setProperties({
            expandedNodes: []
        }, true);
        var eNodes = (0, $4ZDHT.selectAll)('[aria-expanded="true"]', this.element);
        for(var i = 0, len = eNodes.length; i < len; i++)this.addExpand(eNodes[parseInt(i.toString(), 10)]);
    };
    TreeView.prototype.removeData = function(node) {
        if (this.dataType === 1) {
            var dm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData);
            var id = this.getId(node);
            var data = {};
            var newId = this.isNumberTypeId ? parseFloat(id) : id;
            data[this.fields.id] = newId;
            dm.remove(this.fields.id, data);
            this.removeChildNodes(id);
        } else {
            var id = this.getId(node);
            this.updateChildField(this.treeData, this.fields, id, null, null, true);
        }
    };
    TreeView.prototype.removeChildNodes = function(parentId) {
        var cNodes = this.getChildGroup(this.groupedData, parentId, false);
        var childData = [];
        if (cNodes) for(var i = 0, len = cNodes.length; i < len; i++){
            var dm = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData);
            var id = (0, $3EnZW.getValue)(this.fields.id, cNodes[parseInt(i.toString(), 10)]).toString();
            var data = {};
            var currId = this.isNumberTypeId ? parseFloat(id) : id;
            data[this.fields.id] = currId;
            var nodeData = dm.remove(this.fields.id, data);
            childData.push(nodeData[0]);
            this.removeChildNodes(id);
        }
        return childData;
    };
    TreeView.prototype.doGivenAction = function(nodes, selector, toExpand) {
        for(var i = 0, len = nodes.length; i < len; i++){
            var liEle = this.getElement(nodes[parseInt(i.toString(), 10)]);
            if ((0, $3EnZW.isNullOrUndefined)(liEle)) continue;
            var icon = (0, $4ZDHT.select)("." + selector, (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, liEle));
            if (!(0, $3EnZW.isNullOrUndefined)(icon)) {
                if (toExpand) this.expandAction(liEle, icon, null);
                else this.collapseNode(liEle, icon, null);
            }
        }
    };
    TreeView.prototype.addGivenNodes = function(nodes, dropLi, index, isRemote, dropEle) {
        if (nodes.length === 0) return;
        var sNodes = this.getSortedData(nodes);
        var level = dropLi ? parseFloat(dropLi.getAttribute("aria-level")) + 1 : 1;
        if (isRemote) this.updateMapper(level);
        var li = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createListItemFromJson(this.createElement, sNodes, this.listBaseOption, level);
        var id = this.getId(dropLi);
        var dropIcon1;
        if (!(0, $3EnZW.isNullOrUndefined)(dropLi)) dropIcon1 = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
        if (this.dataType === 1 && dropIcon1 && dropIcon1.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && !(0, $3EnZW.isNullOrUndefined)(this.element.offsetParent) && !this.element.offsetParent.parentElement.classList.contains("e-filemanager")) this.preventExpand = true;
        if (this.dataType !== 1) {
            this.addChildData(this.treeData, this.fields, id, nodes, index);
            this.isFirstRender = false;
        }
        var dropUl;
        if (!dropEle) dropUl = dropLi ? this.expandParent(dropLi) : (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, this.element);
        else dropUl = dropEle;
        var refNode = !(0, $3EnZW.isNullOrUndefined)(index) ? dropUl.childNodes[parseInt(index.toString(), 10)] : null;
        if (!this.isFirstRender || this.dataType === 1) {
            var args = this.expandArgs;
            if (refNode || this.sortOrder === "None") {
                for(var i = 0; i < li.length; i++)dropUl.insertBefore(li[parseInt(i.toString(), 10)], refNode);
                if (this.dataType === 1 && !(0, $3EnZW.isNullOrUndefined)(dropLi) && !(0, $3EnZW.isNullOrUndefined)(this.element.offsetParent) && !this.element.offsetParent.parentElement.classList.contains("e-filemanager")) {
                    this.preventExpand = false;
                    var dropIcon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
                    if (dropIcon && dropIcon.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && ((0, $3EnZW.isNullOrUndefined)(args) || args.name !== "nodeExpanding")) this.expandAction(dropLi, dropIcon, null);
                }
            }
            if (!refNode && (this.sortOrder === "Ascending" || this.sortOrder === "Descending")) {
                if (dropUl.childNodes.length === 0) {
                    for(var i = 0; i < li.length; i++)dropUl.insertBefore(li[parseInt(i.toString(), 10)], refNode);
                    if (this.dataType === 1 && !(0, $3EnZW.isNullOrUndefined)(dropLi) && !(0, $3EnZW.isNullOrUndefined)(this.element.offsetParent) && !this.element.offsetParent.parentElement.classList.contains("e-filemanager")) {
                        this.preventExpand = false;
                        var dropIcon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, dropLi);
                        if (dropIcon && dropIcon.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && ((0, $3EnZW.isNullOrUndefined)(args) || args.name !== "nodeExpanding")) this.expandAction(dropLi, dropIcon, null);
                    }
                } else {
                    var cNodes = dropUl.childNodes;
                    for(var i = 0; i < li.length; i++)for(var j = 0; j < cNodes.length; j++){
                        var returnValue = this.sortOrder === "Ascending" ? cNodes[parseInt(j.toString(), 10)].textContent.toUpperCase() > li[parseInt(i.toString(), 10)].innerText.toUpperCase() : cNodes[parseInt(j.toString(), 10)].textContent.toUpperCase() < li[parseInt(i.toString(), 10)].innerText.toUpperCase();
                        if (returnValue) {
                            dropUl.insertBefore(li[parseInt(i.toString(), 10)], cNodes[parseInt(j.toString(), 10)]);
                            break;
                        }
                        dropUl.insertBefore(li[parseInt(i.toString(), 10)], cNodes[cNodes.length]);
                    }
                }
            }
        }
        if (this.dataType === 1) {
            this.updateField(this.treeData, this.fields, id, "hasChildren", true);
            var refId = this.getId(refNode);
            var pos = (0, $3EnZW.isNullOrUndefined)(refId) ? this.treeData.length : this.getDataPos(this.treeData, this.fields, refId);
            for(var j = 0; j < nodes.length; j++){
                if (!(0, $3EnZW.isNullOrUndefined)(id)) {
                    var currId = this.isNumberTypeId ? parseFloat(id) : id;
                    (0, $3EnZW.setValue)(this.fields.parentID, currId, nodes[parseInt(j.toString(), 10)]);
                }
                this.treeData.splice(pos, 0, nodes[parseInt(j.toString(), 10)]);
                pos++;
            }
        }
        this.finalizeNode(dropUl);
    };
    TreeView.prototype.updateMapper = function(level) {
        var mapper = level === 1 ? this.fields : this.getChildFields(this.fields, level - 1, 1);
        this.updateListProp(mapper);
    };
    TreeView.prototype.updateListProp = function(mapper) {
        var prop = this.getActualProperties(mapper);
        this.listBaseOption.fields = prop;
        this.listBaseOption.fields.url = Object.prototype.hasOwnProperty.call(prop, "navigateUrl") ? prop.navigateUrl : "navigateUrl";
    };
    TreeView.prototype.getDataPos = function(obj, mapper, id) {
        var pos = null;
        for(var i = 0, objlen = obj.length; i < objlen; i++){
            var nodeId = (0, $3EnZW.getValue)(mapper.id, obj[parseInt(i.toString(), 10)]);
            if (obj[parseInt(i.toString(), 10)] && nodeId && nodeId.toString() === id) return i;
            else if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]))) {
                var data = (0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]);
                pos = this.getDataPos(data, this.getChildMapper(mapper), id);
                if (pos !== null) break;
            } else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]))) {
                var items = (0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]);
                pos = this.getDataPos(items, this.getChildMapper(mapper), id);
                if (pos !== null) break;
            }
        }
        return pos;
    };
    TreeView.prototype.addChildData = function(obj, mapper, id, data, index) {
        var updated;
        if ((0, $3EnZW.isNullOrUndefined)(id)) {
            index = (0, $3EnZW.isNullOrUndefined)(index) ? obj.length : index;
            for(var k = 0, len = data.length; k < len; k++){
                obj.splice(index, 0, data[parseInt(k.toString(), 10)]);
                index++;
            }
            return updated;
        }
        for(var i = 0, objlen = obj.length; i < objlen; i++){
            var nodeId = (0, $3EnZW.getValue)(mapper.id, obj[parseInt(i.toString(), 10)]);
            if (obj[parseInt(i.toString(), 10)] && nodeId && nodeId.toString() === id) {
                if (typeof mapper.child === "string" && Object.prototype.hasOwnProperty.call(obj[parseInt(i.toString(), 10)], mapper.child) && obj[parseInt(i.toString(), 10)][mapper.child] !== null || this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && Object.prototype.hasOwnProperty.call(obj[parseInt(i.toString(), 10)], "child")) {
                    var key = typeof mapper.child === "string" ? mapper.child : "child";
                    var childData = (0, $3EnZW.getValue)(key, obj[parseInt(i.toString(), 10)]);
                    if ((0, $3EnZW.isNullOrUndefined)(childData)) childData = [];
                    index = (0, $3EnZW.isNullOrUndefined)(index) ? childData.length : index;
                    for(var k = 0, len = data.length; k < len; k++){
                        childData.splice(index, 0, data[parseInt(k.toString(), 10)]);
                        index++;
                    }
                } else {
                    var key = typeof mapper.child === "string" ? mapper.child : "child";
                    obj[parseInt(i.toString(), 10)]["" + key] = data;
                }
                return true;
            } else if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]))) {
                var childObj = (0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]);
                updated = this.addChildData(childObj, this.getChildMapper(mapper), id, data, index);
                if (updated !== undefined) break;
            } else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]))) {
                var childData = (0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]);
                updated = this.addChildData(childData, this.getChildMapper(mapper), id, data, index);
                if (updated !== undefined) break;
            }
        }
        return updated;
    };
    TreeView.prototype.doDisableAction = function(nodes) {
        var validNodes = this.nodeType(nodes);
        var validID = this.checkValidId(validNodes);
        this.validArr = [];
        for(var i = 0, len = validID.length; i < len; i++){
            var id = validID[parseInt(i.toString(), 10)][this.fields.id].toString();
            if (id && this.disableNode.indexOf(id) === -1) this.disableNode.push(id);
            var liEle = this.getElement(id);
            if (liEle) {
                liEle.setAttribute("aria-disabled", "true");
                (0, $4ZDHT.addClass)([
                    liEle
                ], $71c78e892be7c33f$var$DISABLE);
            }
        }
    };
    TreeView.prototype.doEnableAction = function(nodes) {
        var strNodes = this.nodeType(nodes);
        for(var i = 0, len = strNodes.length; i < len; i++){
            var liEle = this.getElement(strNodes[parseInt(i.toString(), 10)]);
            var id = strNodes[parseInt(i.toString(), 10)];
            if (id && this.disableNode.indexOf(id) !== -1) this.disableNode.splice(this.disableNode.indexOf(id), 1);
            if (liEle) {
                liEle.removeAttribute("aria-disabled");
                (0, $4ZDHT.removeClass)([
                    liEle
                ], $71c78e892be7c33f$var$DISABLE);
            }
        }
    };
    TreeView.prototype.nodeType = function(nodes) {
        var validID = [];
        for(var i = 0, len = nodes.length; i < len; i++){
            var id = void 0;
            if (typeof nodes[parseInt(i.toString(), 10)] == "string") id = nodes[parseInt(i.toString(), 10)] ? nodes[parseInt(i.toString(), 10)].toString() : null;
            else if (typeof nodes[parseInt(i.toString(), 10)] === "object") id = nodes[parseInt(i.toString(), 10)] ? nodes[parseInt(i.toString(), 10)].getAttribute("data-uid").toString() : null;
            if (validID.indexOf(id) === -1) validID.push(id);
        }
        return validID;
    };
    TreeView.prototype.checkValidId = function(node) {
        var _this = this;
        if (this.dataType === 1) this.validArr = this.treeData.filter(function(data) {
            return node.indexOf(data[_this.fields.id] ? data[_this.fields.id].toString() : null) !== -1;
        });
        else if (this.dataType === 2) for(var k = 0; k < this.treeData.length; k++){
            var id = this.treeData[parseInt(k.toString(), 10)][this.fields.id] ? this.treeData[parseInt(k.toString(), 10)][this.fields.id].toString() : null;
            if (node.indexOf(id) !== -1) this.validArr.push(this.treeData[parseInt(k.toString(), 10)]);
            var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), this.treeData[parseInt(k.toString(), 10)]);
            if (childItems) this.filterNestedChild(childItems, node);
        }
        return this.validArr;
    };
    TreeView.prototype.filterNestedChild = function(treeData, nodes) {
        for(var k = 0; k < treeData.length; k++){
            var id = treeData[parseInt(k.toString(), 10)][this.fields.id] ? treeData[parseInt(k.toString(), 10)][this.fields.id].toString() : null;
            if (nodes.indexOf(id) !== -1) this.validArr.push(treeData[parseInt(k.toString(), 10)]);
            var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), treeData[parseInt(k.toString(), 10)]);
            if (childItems) this.filterNestedChild(childItems, nodes);
        }
    };
    TreeView.prototype.setTouchClass = function() {
        var ele = (0, $4ZDHT.closest)(this.element, "." + $71c78e892be7c33f$var$BIGGER);
        this.touchClass = (0, $3EnZW.isNullOrUndefined)(ele) ? "" : $71c78e892be7c33f$var$SMALL;
    };
    TreeView.prototype.updatePersistProp = function() {
        this.removeField(this.treeData, this.fields, [
            "selected",
            "expanded"
        ]);
        var sleNodes = this.selectedNodes;
        for(var l = 0, slelen = sleNodes.length; l < slelen; l++)this.updateField(this.treeData, this.fields, sleNodes[parseInt(l.toString(), 10)], "selected", true);
        var enodes = this.expandedNodes;
        for(var k = 0, nodelen = enodes.length; k < nodelen; k++)this.updateField(this.treeData, this.fields, enodes[parseInt(k.toString(), 10)], "expanded", true);
        if (this.showCheckBox) {
            this.removeField(this.treeData, this.fields, [
                "isChecked"
            ]);
            var cnodes = this.checkedNodes;
            for(var m = 0, nodelen = cnodes.length; m < nodelen; m++)this.updateField(this.treeData, this.fields, cnodes[parseInt(m.toString(), 10)], "isChecked", true);
        }
    };
    TreeView.prototype.removeField = function(obj, mapper, names) {
        if ((0, $3EnZW.isNullOrUndefined)(obj) || (0, $3EnZW.isNullOrUndefined)(mapper)) return;
        for(var i = 0, objlen = obj.length; i < objlen; i++){
            for(var j = 0; j < names.length; j++){
                var field = this.getMapperProp(mapper, names[parseInt(j.toString(), 10)]);
                if (!(0, $3EnZW.isNullOrUndefined)(obj[parseInt(i.toString(), 10)]["" + field])) delete obj[parseInt(i.toString(), 10)]["" + field];
            }
            if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]))) this.removeField((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]), this.getChildMapper(mapper), names);
            else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]))) this.removeField((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]), this.getChildMapper(mapper), names);
        }
    };
    TreeView.prototype.getMapperProp = function(mapper, fieldName) {
        switch(fieldName){
            case "selected":
                return !(0, $3EnZW.isNullOrUndefined)(mapper.selected) ? mapper.selected : "selected";
            case "expanded":
                return !(0, $3EnZW.isNullOrUndefined)(mapper.expanded) ? mapper.expanded : "expanded";
            case "isChecked":
                return !(0, $3EnZW.isNullOrUndefined)(mapper.isChecked) ? mapper.isChecked : "isChecked";
            case "hasChildren":
                return !(0, $3EnZW.isNullOrUndefined)(mapper.hasChildren) ? mapper.hasChildren : "hasChildren";
            default:
                return fieldName;
        }
    };
    TreeView.prototype.updateField = function(obj, mapper, id, key, value) {
        if ((0, $3EnZW.isNullOrUndefined)(id)) return;
        else if (this.dataType === 1) {
            var newId = this.isNumberTypeId ? parseFloat(id) : id;
            var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.id, "equal", newId, false));
            (0, $3EnZW.setValue)(this.getMapperProp(mapper, key), value, resultData[0]);
        } else this.updateChildField(obj, mapper, id, key, value);
    };
    TreeView.prototype.updateChildField = function(obj, mapper, id, key, value, remove) {
        var removedData;
        if ((0, $3EnZW.isNullOrUndefined)(obj)) return removedData;
        for(var i = 0, objlen = obj.length; i < objlen; i++){
            var nodeId = (0, $3EnZW.getValue)(mapper.id, obj[parseInt(i.toString(), 10)]);
            if (obj[parseInt(i.toString(), 10)] && !(0, $3EnZW.isNullOrUndefined)(nodeId) && nodeId.toString() === id) {
                if (remove) removedData = obj.splice(i, 1);
                else {
                    (0, $3EnZW.setValue)(this.getMapperProp(mapper, key), value, obj[parseInt(i.toString(), 10)]);
                    removedData = [];
                }
                return removedData;
            } else if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]))) {
                var childData = (0, $3EnZW.getValue)(mapper.child, obj[parseInt(i.toString(), 10)]);
                removedData = this.updateChildField(childData, this.getChildMapper(mapper), id, key, value, remove);
                if (removedData !== undefined) break;
            } else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]))) {
                var childItems = (0, $3EnZW.getValue)("child", obj[parseInt(i.toString(), 10)]);
                removedData = this.updateChildField(childItems, this.getChildMapper(mapper), id, key, value, remove);
                if (removedData !== undefined) break;
            }
        }
        return removedData;
    };
    TreeView.prototype.triggerEvent = function(action, node) {
        this.renderReactTemplates();
        if (action === "addNodes") {
            var nodeData = [];
            for(var i = 0; i < node.length; i++)nodeData.push(this.getNode(this.getElement((0, $3EnZW.isNullOrUndefined)(node[parseInt(i.toString(), 10)][this.fields.id]) ? (0, $3EnZW.getValue)(this.fields.id, node[parseInt(i.toString(), 10)]).toString() : null)));
            node = nodeData;
        }
        var eventArgs = {
            data: this.treeData,
            action: action,
            nodeData: node
        };
        this.trigger("dataSourceChanged", eventArgs);
    };
    TreeView.prototype.wireInputEvents = function(inpEle) {
        (0, $aqzbR.EventHandler).add(inpEle, "blur", this.inputFocusOut, this);
    };
    TreeView.prototype.wireEditingEvents = function(toBind) {
        var _this = this;
        if (toBind && !this.disabled) this.touchEditObj = new (0, $i528u.Touch)(this.element, {
            tap: function(e) {
                if (_this.isDoubleTapped(e) && e.tapCount === 2) {
                    e.originalEvent.preventDefault();
                    _this.editingHandler(e.originalEvent);
                }
            }
        });
        else if (this.touchEditObj) this.touchEditObj.destroy();
    };
    TreeView.prototype.wireClickEvent = function(toBind) {
        var _this = this;
        if (toBind) this.touchClickObj = new (0, $i528u.Touch)(this.element, {
            tap: function(e) {
                _this.clickHandler(e);
            }
        });
        else if (this.touchClickObj) this.touchClickObj.destroy();
    };
    TreeView.prototype.wireExpandOnEvent = function(toBind) {
        var _this = this;
        if (toBind) this.touchExpandObj = new (0, $i528u.Touch)(this.element, {
            tap: function(e) {
                if ((_this.expandOnType === "Click" || _this.expandOnType === "DblClick" && _this.isDoubleTapped(e) && e.tapCount === 2) && e.originalEvent.which !== 3) _this.expandHandler(e);
            }
        });
        else if (this.touchExpandObj) this.touchExpandObj.destroy();
    };
    TreeView.prototype.mouseDownHandler = function(e) {
        this.mouseDownStatus = true;
        if (e.shiftKey || e.ctrlKey) e.preventDefault();
        if (e.ctrlKey && this.allowMultiSelection) (0, $aqzbR.EventHandler).add(this.element, "contextmenu", this.preventContextMenu, this);
    };
    TreeView.prototype.preventContextMenu = function(e) {
        e.preventDefault();
    };
    TreeView.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, "mousedown", this.mouseDownHandler, this);
        this.wireClickEvent(true);
        if (this.expandOnType !== "None") this.wireExpandOnEvent(true);
        (0, $aqzbR.EventHandler).add(this.element, "mouseover", this.onMouseOver, this);
        (0, $aqzbR.EventHandler).add(this.element, "mouseout", this.onMouseLeave, this);
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
    };
    TreeView.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "mousedown", this.mouseDownHandler);
        this.wireClickEvent(false);
        this.wireExpandOnEvent(false);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseover", this.onMouseOver);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseout", this.onMouseLeave);
        if (!this.disabled) this.keyboardModule.destroy();
    };
    TreeView.prototype.parents = function(element, selector) {
        var matched = [];
        var el = element.parentNode;
        while(!(0, $3EnZW.isNullOrUndefined)(el)){
            if ((0, $4ZDHT.matches)(el, selector)) matched.push(el);
            el = el.parentNode;
        }
        return matched;
    };
    TreeView.prototype.isDoubleTapped = function(e) {
        var target = e.originalEvent.target;
        var secondTap;
        if (target && e.tapCount) {
            if (e.tapCount === 1) this.firstTap = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
            else if (e.tapCount === 2) secondTap = (0, $4ZDHT.closest)(target, "." + $71c78e892be7c33f$var$LISTITEM);
        }
        return this.firstTap === secondTap;
    };
    TreeView.prototype.isDescendant = function(parent, child) {
        var node = child.parentNode;
        while(!(0, $3EnZW.isNullOrUndefined)(node)){
            if (node === parent) return true;
            node = node.parentNode;
        }
        return false;
    };
    TreeView.prototype.showSpinner = function(element) {
        (0, $4ZDHT.addClass)([
            element
        ], $71c78e892be7c33f$var$LOAD);
        (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
            target: element,
            width: (0, $5q7BP.Browser).isDevice ? 16 : 14
        }, this.createElement);
        (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(element);
    };
    TreeView.prototype.hideSpinner = function(element) {
        (0, $d4834c37f505aa74$export$95fec50f68454318)(element);
        element.innerHTML = "";
        (0, $4ZDHT.removeClass)([
            element
        ], $71c78e892be7c33f$var$LOAD);
    };
    TreeView.prototype.setCheckedNodes = function(nodes) {
        nodes = JSON.parse(JSON.stringify(nodes));
        this.uncheckAll(this.checkedNodes);
        this.setIndeterminate(nodes);
        if (nodes.length > 0) this.checkAll(nodes);
    };
    /**
     * Checks whether the checkedNodes entered are valid and sets the valid checkedNodes while changing via setmodel
     *
     * @param {string} node - The unique identifier of the node.
     * @returns {void}
     * @private
     */ TreeView.prototype.setValidCheckedNode = function(node) {
        if (this.dataType === 1) {
            var mapper = this.fields;
            var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(mapper.id, "equal", node, true));
            if (resultData[0]) {
                this.setChildCheckState(resultData, node, resultData[0]);
                if (this.autoCheck) {
                    var parent_4 = resultData[0][this.fields.parentID] ? resultData[0][this.fields.parentID].toString() : null;
                    var childNodes = this.getChildNodes(this.treeData, parent_4);
                    var count = 0;
                    for(var len = 0; len < childNodes.length; len++){
                        var childId = childNodes[parseInt(len.toString(), 10)][this.fields.id].toString();
                        if (this.checkedNodes.indexOf(childId) !== -1) count++;
                    }
                    if (count === childNodes.length && this.checkedNodes.indexOf(parent_4) === -1 && parent_4) this.checkDisabledState(parent_4);
                }
            }
        } else if (this.dataType === 2) for(var a = 0; a < this.treeData.length; a++){
            var index = this.treeData[parseInt(a.toString(), 10)][this.fields.id] ? this.treeData[parseInt(a.toString(), 10)][this.fields.id].toString() : "";
            if (index === node && this.checkedNodes.indexOf(node) === -1) {
                this.checkDisabledState(node);
                break;
            }
            var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), this.treeData[parseInt(a.toString(), 10)]);
            if (childItems) this.setChildCheckState(childItems, node, this.treeData[parseInt(a.toString(), 10)]);
        }
    };
    /**
     * Checks whether the checkedNodes entered are valid and sets the valid checkedNodes while changing via setmodel(for hierarchical DS)
     *
     * @param {Object[]} childItems - The child items to check.
     * @param {string} node - The node to set the check state for.
     * @param {Object} [treeData] - The optional tree data.
     * @returns {void}
     * @private
     */ TreeView.prototype.setChildCheckState = function(childItems, node, treeData) {
        var checkedParent;
        var count = 0;
        if (this.dataType === 1) {
            if (treeData) checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : null;
            for(var index = 0; index < childItems.length; index++){
                var checkNode = childItems[parseInt(index.toString(), 10)][this.fields.id] ? childItems[parseInt(index.toString(), 10)][this.fields.id].toString() : null;
                if (treeData && checkedParent && this.autoCheck) {
                    if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkNode) === -1) this.checkDisabledState(checkNode, childItems[index]);
                }
                if (checkNode === node && this.checkedNodes.indexOf(node) === -1) this.checkDisabledState(node);
                var subChildItems = this.getChildNodes(this.treeData, checkNode);
                if (subChildItems) this.setChildCheckState(subChildItems, node, treeData);
            }
        } else {
            if (treeData) checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : "";
            for(var index = 0; index < childItems.length; index++){
                var checkedChild = childItems[parseInt(index.toString(), 10)][this.fields.id] ? childItems[parseInt(index.toString(), 10)][this.fields.id].toString() : "";
                if (treeData && checkedParent && this.autoCheck) {
                    if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1) this.checkDisabledState(checkedChild, childItems[index]);
                }
                if (checkedChild === node && this.checkedNodes.indexOf(node) === -1) this.checkDisabledState(node);
                var subChildItems = (0, $3EnZW.getValue)(this.fields.child.toString(), childItems[parseInt(index.toString(), 10)]);
                if (subChildItems) this.setChildCheckState(subChildItems, node, childItems[parseInt(index.toString(), 10)]);
                if (this.checkedNodes.indexOf(checkedChild) !== -1 && this.autoCheck) count++;
                if (count === childItems.length && this.checkedNodes.indexOf(checkedParent) === -1 && this.autoCheck) this.checkDisabledState(checkedParent, treeData);
            }
        }
    };
    TreeView.prototype.setIndeterminate = function(nodes) {
        for(var i = 0; i < nodes.length; i++)this.setValidCheckedNode(nodes[parseInt(i.toString(), 10)]);
    };
    TreeView.prototype.updatePosition = function(id, newData, isRefreshChild, childValue) {
        if (this.dataType === 1) {
            var pos = this.getDataPos(this.treeData, this.fields, id);
            this.treeData.splice(pos, 1, newData);
            if (isRefreshChild) {
                this.removeChildNodes(id);
                for(var j = 0; j < childValue.length; j++){
                    this.treeData.splice(pos, 0, childValue[parseInt(j.toString(), 10)]);
                    pos++;
                }
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        } else this.updateChildPosition(this.treeData, this.fields, id, [
            newData
        ], undefined);
    };
    TreeView.prototype.updateChildPosition = function(treeData, mapper, currID, newData, index) {
        var found;
        for(var i = 0, objlen = treeData.length; i < objlen; i++){
            var nodeId = (0, $3EnZW.getValue)(mapper.id, treeData[parseInt(i.toString(), 10)]);
            if (treeData[parseInt(i.toString(), 10)] && nodeId && nodeId.toString() === currID) {
                treeData[parseInt(i.toString(), 10)] = newData[0];
                return true;
            } else if (typeof mapper.child === "string" && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)(mapper.child, treeData[parseInt(i.toString(), 10)]))) {
                var childObj = (0, $3EnZW.getValue)(mapper.child, treeData[parseInt(i.toString(), 10)]);
                found = this.updateChildPosition(childObj, this.getChildMapper(mapper), currID, newData, index);
                if (found !== undefined) break;
            } else if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !(0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("child", treeData[parseInt(i.toString(), 10)]))) {
                var childData = (0, $3EnZW.getValue)("child", treeData[parseInt(i.toString(), 10)]);
                found = this.updateChildPosition(childData, this.getChildMapper(mapper), currID, newData, index);
                if (found !== undefined) break;
            }
        }
        return found;
    };
    TreeView.prototype.dynamicState = function() {
        this.setDragAndDrop(this.allowDragAndDrop);
        this.wireEditingEvents(this.allowEditing);
        if (!this.disabled) {
            this.wireEvents();
            this.setRipple();
        } else {
            this.unWireEvents();
            this.rippleFn();
            this.rippleIconFn();
        }
    };
    TreeView.prototype.crudOperation = function(operation, nodes, target, newText, newNode, index, prevent) {
        var _this = this;
        var data = this.fields.dataSource;
        var matchedArr = [];
        var query = this.getQuery(this.fields);
        var key = this.fields.id;
        var crud;
        var changes = {
            addedRecords: [],
            deletedRecords: [],
            changedRecords: []
        };
        var nodesID = [];
        if (nodes) nodesID = this.nodeType(nodes);
        else if (target) {
            if (typeof target == "string") nodesID[0] = target.toString();
            else if (typeof target === "object") nodesID[0] = target.getAttribute("data-uid").toString();
        }
        for(var i = 0, len = nodesID.length; i < len; i++){
            var liEle = this.getElement(nodesID[parseInt(i.toString(), 10)]);
            if ((0, $3EnZW.isNullOrUndefined)(liEle)) continue;
            var removedData = this.getNodeObject(nodesID[parseInt(i.toString(), 10)]);
            matchedArr.push(removedData);
        }
        switch(operation){
            case "delete":
                if (nodes.length === 1) crud = data.remove(key, matchedArr[0], query.fromTable, query);
                else {
                    changes.deletedRecords = matchedArr;
                    crud = data.saveChanges(changes, key, query.fromTable, query);
                }
                crud.then(function() {
                    return _this.deleteSuccess(nodesID);
                }).catch(function(e) {
                    return _this.dmFailure(e);
                });
                break;
            case "update":
                matchedArr[0][this.fields.text] = newText;
                crud = data.update(key, matchedArr[0], query.fromTable, query);
                crud.then(function() {
                    return _this.editSucess(target, newText, prevent);
                }).catch(function(e) {
                    return _this.dmFailure(e, target, prevent);
                });
                break;
            case "insert":
                if (newNode.length === 1) crud = data.insert(newNode[0], query.fromTable, query);
                else {
                    var arr = [];
                    for(var i = 0, len = newNode.length; i < len; i++)arr.push(newNode[parseInt(i.toString(), 10)]);
                    changes.addedRecords = arr;
                    crud = data.saveChanges(changes, key, query.fromTable, query);
                }
                crud.then(function() {
                    var dropLi = _this.getElement(target);
                    _this.addSuccess(newNode, dropLi, index);
                    _this.preventExpand = false;
                }).catch(function(e) {
                    return _this.dmFailure(e);
                });
                break;
        }
    };
    TreeView.prototype.deleteSuccess = function(nodes) {
        var nodeData = [];
        for(var i = 0, len = nodes.length; i < len; i++){
            var liEle = this.getElement(nodes[parseInt(i.toString(), 10)]);
            nodeData.push(this.getNode(liEle));
            if ((0, $3EnZW.isNullOrUndefined)(liEle)) continue;
            this.removeNode(liEle);
        }
        this.updateInstance();
        if (this.dataType === 1) this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        this.triggerEvent("removeNode", nodeData);
    };
    TreeView.prototype.editSucess = function(target, newText, prevent) {
        var liEle = this.getElement(target);
        var txtEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTTEXT, liEle);
        this.appendNewText(liEle, txtEle, newText, prevent);
    };
    TreeView.prototype.addSuccess = function(nodes, dropLi, index) {
        var _this = this;
        var dropUl;
        var icon = dropLi ? dropLi.querySelector("." + $71c78e892be7c33f$var$ICON) : null;
        if (dropLi && icon && icon.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && dropLi.querySelector("." + $71c78e892be7c33f$var$PARENTITEM) === null) this.renderChildNodes(dropLi, null, function() {
            dropUl = dropLi.querySelector("." + $71c78e892be7c33f$var$PARENTITEM);
            _this.addGivenNodes(nodes, dropLi, index, true, dropUl);
            _this.triggerEvent("addNodes", nodes);
        });
        else {
            this.addGivenNodes(nodes, dropLi, index, true);
            this.triggerEvent("addNodes", nodes);
        }
    };
    TreeView.prototype.dmFailure = function(e, target, prevent) {
        if (target) this.updatePreviousText(target, prevent);
        this.trigger("actionFailure", {
            error: e
        });
    };
    TreeView.prototype.updatePreviousText = function(target, prevent) {
        var liEle = this.getElement(target);
        var txtEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTTEXT, liEle);
        this.updateText(liEle, txtEle, this.oldText, prevent);
    };
    TreeView.prototype.getHierarchicalParentId = function(node, data, parentsID) {
        var _this = this;
        var index = data.findIndex(function(data) {
            return data[_this.fields.id] && data[_this.fields.id].toString() === node;
        });
        if (index === -1) for(var i = 0; i < data.length; i++){
            var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), data[parseInt(i.toString(), 10)]);
            if (!(0, $3EnZW.isNullOrUndefined)(childItems)) {
                index = childItems.findIndex(function(data) {
                    return data[_this.fields.id] && data[_this.fields.id].toString() === node;
                });
                if (index === -1) this.getHierarchicalParentId(node, childItems, parentsID);
                else {
                    parentsID.push(data[parseInt(i.toString(), 10)][this.fields.id].toString());
                    this.getHierarchicalParentId(data[parseInt(i.toString(), 10)][this.fields.id].toString(), this.treeData, parentsID);
                    break;
                }
            }
        }
        return parentsID;
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {TreeViewModel} newProp - The new property value.
     * @param {TreeViewModel} oldProp - The old property value.
     * @returns {void}
     * @private
     */ TreeView.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "allowDragAndDrop":
                    this.setDragAndDrop(this.allowDragAndDrop);
                    break;
                case "dragArea":
                    if (this.allowDragAndDrop) this.dragObj.dragArea = this.dragArea;
                    break;
                case "allowEditing":
                    this.wireEditingEvents(this.allowEditing);
                    break;
                case "allowMultiSelection":
                    if (this.selectedNodes.length > 1) {
                        var sNode = this.getElement(this.selectedNodes[0]);
                        this.isLoaded = false;
                        this.removeSelectAll();
                        this.selectNode(sNode, null);
                        this.isLoaded = true;
                    }
                    this.setMultiSelect(this.allowMultiSelection);
                    this.addMultiSelect(this.allowMultiSelection);
                    break;
                case "allowTextWrap":
                    this.setTextWrap();
                    this.updateWrap();
                    break;
                case "checkedNodes":
                    if (this.showCheckBox) {
                        this.checkedNodes = oldProp.checkedNodes;
                        this.setCheckedNodes(newProp.checkedNodes);
                    }
                    break;
                case "autoCheck":
                    if (this.showCheckBox) {
                        this.autoCheck = newProp.autoCheck;
                        this.ensureIndeterminate();
                    }
                    break;
                case "cssClass":
                    this.setCssClass(oldProp.cssClass, newProp.cssClass);
                    break;
                case "enableRtl":
                    this.setEnableRtl();
                    break;
                case "expandedNodes":
                    this.isAnimate = false;
                    this.setProperties({
                        expandedNodes: []
                    }, true);
                    this.collapseAll();
                    this.isInitalExpand = true;
                    this.setProperties({
                        expandedNodes: (0, $3EnZW.isNullOrUndefined)(newProp.expandedNodes) ? [] : newProp.expandedNodes
                    }, true);
                    this.doExpandAction();
                    this.isInitalExpand = false;
                    this.isAnimate = true;
                    break;
                case "expandOn":
                    this.wireExpandOnEvent(false);
                    this.setExpandOnType();
                    if (this.expandOnType !== "None" && !this.disabled) this.wireExpandOnEvent(true);
                    break;
                case "disabled":
                    this.setDisabledMode();
                    this.dynamicState();
                    break;
                case "fields":
                    this.isAnimate = false;
                    this.isFieldChange = true;
                    this.initialRender = true;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.isReact || this.isReact && !(this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd))) {
                        if (!this.element.classList.contains("e-filtering")) this.DDTTreeData = JSON.parse(JSON.stringify(this.fields.dataSource));
                        this.reRenderNodes();
                    }
                    this.initialRender = false;
                    this.isAnimate = true;
                    this.isFieldChange = false;
                    break;
                case "fullRowSelect":
                    this.setFullRow(this.fullRowSelect);
                    this.addFullRow(this.fullRowSelect);
                    if (this.allowTextWrap) {
                        this.setTextWrap();
                        this.updateWrap();
                    }
                    break;
                case "loadOnDemand":
                    if (this.loadOnDemand === false && !this.onLoaded) {
                        var nodes = this.element.querySelectorAll("li");
                        var i = 0;
                        while(i < nodes.length){
                            if (nodes[parseInt(i.toString(), 10)].getAttribute("aria-expanded") !== "true") this.renderChildNodes(nodes[parseInt(i.toString(), 10)], true, null, true);
                            i++;
                        }
                        this.onLoaded = true;
                    }
                    break;
                case "nodeTemplate":
                    this.hasTemplate = false;
                    this.nodeTemplateFn = this.templateComplier(this.nodeTemplate);
                    this.reRenderNodes();
                    break;
                case "selectedNodes":
                    this.removeSelectAll();
                    this.setProperties({
                        selectedNodes: newProp.selectedNodes
                    }, true);
                    this.doSelectionAction();
                    break;
                case "showCheckBox":
                case "checkDisabledChildren":
                    this.reRenderNodes();
                    break;
                case "sortOrder":
                    this.reRenderNodes();
                    break;
                case "fullRowNavigable":
                    this.setProperties({
                        fullRowNavigable: newProp.fullRowNavigable
                    }, true);
                    this.listBaseOption.itemNavigable = newProp.fullRowNavigable;
                    this.reRenderNodes();
                    break;
            }
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. It also removes the attributes and classes.
     *
     * @returns {void}
     */ TreeView.prototype.destroy = function() {
        this.clearTemplate();
        this.element.removeAttribute("aria-activedescendant");
        this.unWireEvents();
        this.wireEditingEvents(false);
        if (!this.disabled) {
            this.rippleFn();
            this.rippleIconFn();
        }
        this.setCssClass(this.cssClass, null);
        this.setDragAndDrop(false);
        this.setFullRow(false);
        if (this.ulElement && this.ulElement.parentElement) this.ulElement.parentElement.removeChild(this.ulElement);
        this.ulElement = null;
        this.liList = null;
        this.startNode = null;
        this.firstTap = null;
        this.expandArgs = null;
        this.dragLi = null;
        this.dragTarget = null;
        this.dragParent = null;
        this.dragObj = null;
        this.dropObj = null;
        this.inputObj = null;
        this.touchEditObj = null;
        this.touchExpandObj = null;
        this.touchClickObj = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Adds the collection of TreeView nodes based on target and index position. If target node is not specified,
     * then the nodes are added as children of the given parentID or in the root level of TreeView.
     *
     * @param  { object } nodes - Specifies the array of JSON data that has to be added.
     * @param  { string | Element } target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  { number } index - Specifies the index to place the newly added nodes in the target element.
     * @param { boolean } preventTargetExpand - If set to true, the target parent node will be prevented from auto expanding.
     * @returns {void}
     */ TreeView.prototype.addNodes = function(nodes, target, index, preventTargetExpand) {
        if ((0, $3EnZW.isNullOrUndefined)(nodes)) return;
        nodes = JSON.parse(JSON.stringify(nodes));
        var dropLi = this.getElement(target);
        this.preventExpand = preventTargetExpand;
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) {
            if (!this.isOffline) this.crudOperation("insert", null, target, null, nodes, index, this.preventExpand);
            else this.addSuccess(nodes, dropLi, index);
        } else if (this.dataType === 2) this.addGivenNodes(nodes, dropLi, index);
        else {
            if (dropLi) this.addGivenNodes(nodes, dropLi, index);
            else {
                nodes = this.getSortedData(nodes);
                for(var i = 0; i < nodes.length; i++){
                    var pid = (0, $3EnZW.getValue)(this.fields.parentID, nodes[parseInt(i.toString(), 10)]);
                    dropLi = pid ? this.getElement(pid.toString()) : pid;
                    this.addGivenNodes([
                        nodes[parseInt(i.toString(), 10)]
                    ], dropLi, index);
                }
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        }
        this.updateCheckedStateFromDS();
        if (this.showCheckBox && dropLi) this.ensureParentCheckState(dropLi);
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) === false) {
            this.preventExpand = false;
            this.triggerEvent("addNodes", nodes);
        }
    };
    /**
     * Editing can also be enabled by using the `beginEdit` property, instead of clicking on the
     * TreeView node. On passing the node ID or element through this property, the edit textBox
     * will be created for the particular node thus allowing us to edit it.
     *
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     * @returns {void}
     */ TreeView.prototype.beginEdit = function(node) {
        var ele = this.getElement(node);
        if ((0, $3EnZW.isNullOrUndefined)(ele) || this.disabled) return;
        this.createTextbox(ele);
    };
    /**
     * Checks all the unchecked nodes. You can also check specific nodes by passing array of unchecked nodes
     * as argument to this method.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     * @returns {void}
     */ TreeView.prototype.checkAll = function(nodes) {
        if (this.showCheckBox) this.doCheckBoxAction(nodes, true);
    };
    /**
     * Collapses all the expanded TreeView nodes. You can collapse specific nodes by passing array of nodes as argument to this method.
     * You can also collapse all the nodes excluding the hidden nodes by setting **excludeHiddenNodes** to true. If you want to collapse
     * a specific level of nodes, set **level** as argument to collapseAll method.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/ array of TreeView node.
     * @param  {number} level - TreeView nodes will collapse up to the given level.
     * @param  {boolean} excludeHiddenNodes - Whether or not to exclude hidden nodes of TreeView when collapsing all nodes.
     * @returns {void}
     */ TreeView.prototype.collapseAll = function(nodes, level, excludeHiddenNodes) {
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) this.doGivenAction(nodes, $71c78e892be7c33f$var$COLLAPSIBLE, false);
        else if (level > 0) this.collapseByLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, this.element), level, excludeHiddenNodes);
        else this.collapseAllNodes(excludeHiddenNodes);
    };
    /**
     * Disables the collection of nodes by passing the ID of nodes or node elements in the array.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     * @returns {void}
     */ TreeView.prototype.disableNodes = function(nodes) {
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) this.doDisableAction(nodes);
    };
    /**
     * Enables the collection of disabled nodes by passing the ID of nodes or node elements in the array.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     * @returns {void}
     */ TreeView.prototype.enableNodes = function(nodes) {
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) this.doEnableAction(nodes);
    };
    /**
     * Ensures visibility of the TreeView node by using node ID or node element.
     * When many TreeView nodes are present and we need to find a particular node, `ensureVisible` property
     * helps bring the node to visibility by expanding the TreeView and scrolling to the specific node.
     *
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView nodes.
     * @returns {void}
     */ TreeView.prototype.ensureVisible = function(node) {
        var parentsId = [];
        if (this.dataType === 1) {
            var nodeData = this.getTreeData(node);
            while(nodeData.length !== 0 && !(0, $3EnZW.isNullOrUndefined)(nodeData[0][this.fields.parentID])){
                parentsId.push(nodeData[0][this.fields.parentID].toString());
                nodeData = this.getTreeData(nodeData[0][this.fields.parentID].toString());
            }
        } else if (this.dataType === 2) parentsId = this.getHierarchicalParentId(node, this.treeData, parentsId);
        this.expandAll(parentsId.reverse());
        var liEle = this.getElement(node);
        if (!(0, $3EnZW.isNullOrUndefined)(liEle)) {
            if (typeof node == "object") {
                var parents = this.parents(liEle, "." + $71c78e892be7c33f$var$LISTITEM);
                this.expandAll(parents);
            }
            setTimeout(function() {
                liEle.scrollIntoView({
                    behavior: "smooth"
                });
            }, 450);
        }
    };
    /**
     * Expands all the collapsed TreeView nodes. You can expand the specific nodes by passing the array of collapsed nodes
     * as argument to this method. You can also expand all the collapsed nodes by excluding the hidden nodes by setting
     * **excludeHiddenNodes** to true to this method. To expand a specific level of nodes, set **level** as argument to expandAll method.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     * @param  {number} level - TreeView nodes will expand up to the given level.
     * @param  {boolean} excludeHiddenNodes - Whether or not to exclude hidden nodes when expanding all nodes.
     * @param  {boolean} preventAnimation - Prevent the expand animation when expanding all nodes.
     * @returns {void}
     */ TreeView.prototype.expandAll = function(nodes, level, excludeHiddenNodes, preventAnimation) {
        this.isAnimate = !preventAnimation;
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) this.doGivenAction(nodes, $71c78e892be7c33f$var$EXPANDABLE, true);
        else if (level > 0) this.expandByLevel((0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, this.element), level, excludeHiddenNodes);
        else {
            this.expandAllNodes(excludeHiddenNodes);
            if (!this.loadOnDemand) {
                this.updateAttributes(this.element);
                this.updateList();
            }
        }
        this.isAnimate = true;
    };
    /**
     * Gets all the checked nodes including child, whether it is loaded or not.
     *
     * @returns {string[]} - An array of strings representing the unique identifiers of checked nodes.
     */ TreeView.prototype.getAllCheckedNodes = function() {
        var checkNodes = this.checkedNodes;
        return checkNodes;
    };
    /**
     * Gets all the disabled nodes including child, whether it is loaded or not.
     *
     * @returns {string[]} An array of strings representing the unique identifiers of disabled nodes.
     */ TreeView.prototype.getDisabledNodes = function() {
        var disabledNodes = this.disableNode;
        return disabledNodes;
    };
    /**
     * Gets the node's data such as id, text, parentID, selected, isChecked, and expanded by passing the node element or it's ID.
     *
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     * @returns {Object} - The data associated with the specified node.
     */ TreeView.prototype.getNode = function(node) {
        var ele = this.getElement(node);
        return this.getNodeData(ele, true);
    };
    /**
     * To get the updated data source of TreeView after performing some operation like drag and drop, node editing,
     * node selecting/unSelecting, node expanding/collapsing, node checking/unChecking, adding and removing node.
     * * If you pass the ID of TreeView node as arguments for this method then it will return the updated data source
     * of the corresponding node otherwise it will return the entire updated data source of TreeView.
     * * The updated data source also contains custom attributes if you specified in data source.
     *
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     * @isGenericType true
     * @returns {Object} - The tree data associated with the specified node or element.
     */ TreeView.prototype.getTreeData = function(node) {
        var id = this.getId(node);
        this.updatePersistProp();
        if ((0, $3EnZW.isNullOrUndefined)(id)) return this.treeData;
        else {
            var data = this.getNodeObject(id);
            return (0, $3EnZW.isNullOrUndefined)(data) ? [] : [
                data
            ];
        }
    };
    /**
     * Moves the collection of nodes within the same TreeView based on target or its index position.
     *
     * @param  {string[] | Element[]} sourceNodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     * @param  {string | Element} target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  {number} index - Specifies the index to place the moved nodes in the target element.
     * @param { boolean } preventTargetExpand - If set to true, the target parent node will be prevented from auto expanding.
     * @returns {void}
     */ TreeView.prototype.moveNodes = function(sourceNodes, target, index, preventTargetExpand) {
        var dropLi = this.getElement(target);
        var nodeData = [];
        if ((0, $3EnZW.isNullOrUndefined)(dropLi)) return;
        for(var i = 0; i < sourceNodes.length; i++){
            var dragLi = this.getElement(sourceNodes[parseInt(i.toString(), 10)]);
            nodeData.push(this.getNode(dragLi));
            if ((0, $3EnZW.isNullOrUndefined)(dragLi) || dropLi.isSameNode(dragLi) || this.isDescendant(dragLi, dropLi)) continue;
            this.preventExpand = preventTargetExpand;
            this.dropAsChildNode(dragLi, dropLi, this, index, null, null, null, dropLi);
        }
        if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) === false) this.preventExpand = false;
        this.triggerEvent("moveNodes", nodeData);
    };
    /**
     * Refreshes a particular node of the TreeView.
     *
     * @param  {string | Element} target - Specifies the ID of TreeView node or TreeView node as target element.
     * @param  {Object[]} newData - Specifies the new data of TreeView node.
     * @returns {void}
     */ TreeView.prototype.refreshNode = function(target, newData) {
        if ((0, $3EnZW.isNullOrUndefined)(target) || (0, $3EnZW.isNullOrUndefined)(newData)) return;
        var isRefreshChild = false;
        if (this.dataType === 1 && newData.length > 1) isRefreshChild = true;
        else if (this.dataType === 2 && newData.length === 1) {
            var updatedChildValue = (0, $3EnZW.getValue)(this.fields.child.toString(), newData[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(updatedChildValue)) isRefreshChild = true;
        }
        var liEle = this.getElement(target);
        var id = liEle ? liEle.getAttribute("data-uid") : target ? target.toString() : null;
        this.refreshData = this.getNodeObject(id);
        newData = JSON.parse(JSON.stringify(newData));
        var newNodeData;
        var parentData;
        if (this.dataType === 1 && isRefreshChild) {
            for(var k = 0; k < newData.length; k++)if ((0, $3EnZW.isNullOrUndefined)(newData[parseInt(k.toString(), 10)][this.fields.parentID])) {
                parentData = newData[parseInt(k.toString(), 10)];
                newData.splice(k, 1);
                break;
            }
            newNodeData = (0, $3EnZW.extend)({}, this.refreshData, parentData);
        } else newNodeData = (0, $3EnZW.extend)({}, this.refreshData, newData[0]);
        if ((0, $3EnZW.isNullOrUndefined)(liEle)) {
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
            return;
        }
        this.isRefreshed = true;
        var level = parseFloat(liEle.getAttribute("aria-level"));
        var newliEle = (0, $ebf1cfbcf051ff2a$export$8f4a37dcf1e373df).createListItemFromJson(this.createElement, [
            newNodeData
        ], this.listBaseOption, level);
        var ul = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$PARENTITEM, liEle);
        var childItems = (0, $3EnZW.getValue)(this.fields.child.toString(), newNodeData);
        if (isRefreshChild && ul || isRefreshChild && !(0, $3EnZW.isNullOrUndefined)(childItems)) {
            var parentEle = liEle.parentElement;
            var index = Array.prototype.indexOf.call(parentEle.childNodes, liEle);
            (0, $4ZDHT.remove)(liEle);
            parentEle.insertBefore(newliEle[0], parentEle.childNodes[parseInt(index.toString(), 10)]);
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
            if (isRefreshChild && ul) this.expandAll([
                id
            ]);
        } else {
            var txtEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, liEle);
            var newTextEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$TEXTWRAP, newliEle[0]);
            var icon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, txtEle);
            var newIcon = (0, $4ZDHT.select)("div." + $71c78e892be7c33f$var$ICON, newTextEle);
            if (icon && newIcon) {
                if (newIcon.classList.contains($71c78e892be7c33f$var$EXPANDABLE) && icon.classList.contains($71c78e892be7c33f$var$COLLAPSIBLE)) {
                    (0, $4ZDHT.removeClass)([
                        newIcon
                    ], $71c78e892be7c33f$var$EXPANDABLE);
                    (0, $4ZDHT.addClass)([
                        newIcon
                    ], $71c78e892be7c33f$var$COLLAPSIBLE);
                } else if (newIcon.classList.contains($71c78e892be7c33f$var$COLLAPSIBLE) && icon.classList.contains($71c78e892be7c33f$var$EXPANDABLE)) {
                    (0, $4ZDHT.removeClass)([
                        newIcon
                    ], $71c78e892be7c33f$var$COLLAPSIBLE);
                    (0, $4ZDHT.addClass)([
                        newIcon
                    ], $71c78e892be7c33f$var$EXPANDABLE);
                } else if (icon.classList.contains("interaction")) (0, $4ZDHT.addClass)([
                    newIcon
                ], "interaction");
            }
            (0, $4ZDHT.remove)(txtEle);
            var fullEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$FULLROW, liEle);
            fullEle.parentNode.insertBefore(newTextEle, fullEle.nextSibling);
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
        }
        liEle = this.getElement(target);
        if (newNodeData[this.fields.tooltip]) liEle.setAttribute("title", newNodeData[this.fields.tooltip]);
        if (Object.prototype.hasOwnProperty.call(newNodeData, this.fields.htmlAttributes) && newNodeData[this.fields.htmlAttributes]) {
            var attr = {};
            (0, $3EnZW.merge)(attr, newNodeData[this.fields.htmlAttributes]);
            if (attr.class) {
                (0, $4ZDHT.addClass)([
                    liEle
                ], attr.class.split(" "));
                delete attr.class;
            } else (0, $4ZDHT.attributes)(liEle, attr);
        }
        if (this.selectedNodes.indexOf(id) !== -1) {
            liEle.setAttribute("aria-selected", "true");
            (0, $4ZDHT.addClass)([
                liEle
            ], $71c78e892be7c33f$var$ACTIVE);
        }
        this.isRefreshed = false;
        this.triggerEvent("refreshNode", [
            this.getNode(liEle)
        ]);
    };
    /**
     * Removes the collection of TreeView nodes by passing the array of node details as argument to this method.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     * @returns {void}
     */ TreeView.prototype.removeNodes = function(nodes) {
        if (!(0, $3EnZW.isNullOrUndefined)(nodes)) {
            if (this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !this.isOffline) this.crudOperation("delete", nodes);
            else this.deleteSuccess(nodes);
        }
    };
    /**
     * Replaces the text of the TreeView node with the given text.
     *
     * @param  {string | Element} target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  {string} newText - Specifies the new text of TreeView node.
     * @returns {void}
     */ TreeView.prototype.updateNode = function(target, newText) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(target) || (0, $3EnZW.isNullOrUndefined)(newText) || !this.allowEditing) return;
        var liEle = this.getElement(target);
        if ((0, $3EnZW.isNullOrUndefined)(liEle)) return;
        var txtEle = (0, $4ZDHT.select)("." + $71c78e892be7c33f$var$LISTTEXT, liEle);
        this.updateOldText(liEle);
        var eventArgs = this.getEditEvent(liEle, null, null);
        this.trigger("nodeEditing", eventArgs, function(observedArgs) {
            if (!observedArgs.cancel) {
                if (_this.fields.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd) && !_this.isOffline) _this.crudOperation("update", null, target, newText, null, null, false);
                else _this.appendNewText(liEle, txtEle, newText, false);
            }
        });
    };
    /**
     * Unchecks all the checked nodes. You can also uncheck the specific nodes by passing array of checked nodes
     * as argument to this method.
     *
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     * @returns {void}
     */ TreeView.prototype.uncheckAll = function(nodes) {
        if (this.showCheckBox) this.doCheckBoxAction(nodes, false);
    };
    var TreeView_1;
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "allowDragAndDrop", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "allowEditing", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "allowMultiSelection", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "allowTextWrap", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Complex)({}, $71c78e892be7c33f$export$419f99ebc99c8f2a)
    ], TreeView.prototype, "animation", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)()
    ], TreeView.prototype, "checkedNodes", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TreeView.prototype, "checkDisabledChildren", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TreeView.prototype, "cssClass", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "disabled", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TreeView.prototype, "dragArea", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TreeView.prototype, "enableHtmlSanitizer", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "enablePersistence", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)()
    ], TreeView.prototype, "expandedNodes", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("Auto")
    ], TreeView.prototype, "expandOn", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Complex)({}, $71c78e892be7c33f$export$c3ab4f2afb2ecd8f)
    ], TreeView.prototype, "fields", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TreeView.prototype, "fullRowSelect", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TreeView.prototype, "loadOnDemand", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)()
    ], TreeView.prototype, "locale", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)()
    ], TreeView.prototype, "nodeTemplate", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)()
    ], TreeView.prototype, "selectedNodes", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], TreeView.prototype, "sortOrder", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "showCheckBox", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TreeView.prototype, "autoCheck", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TreeView.prototype, "fullRowNavigable", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "actionFailure", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "created", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "dataBound", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "dataSourceChanged", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "drawNode", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "destroyed", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "keyPress", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeChecked", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeChecking", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeClicked", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeCollapsed", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeCollapsing", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeDragging", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeDragStart", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeDragStop", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeDropped", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeEdited", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeEditing", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeExpanded", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeExpanding", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeSelected", void 0);
    $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.Event)()
    ], TreeView.prototype, "nodeSelecting", void 0);
    TreeView = TreeView_1 = $71c78e892be7c33f$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], TreeView);
    return TreeView;
}((0, $hQxLN.Component));


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $eAUyT = parcelRequire("eAUyT");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");







/**
 * NavigationPane module
 */ var $316df11747aff4c1$export$4ea64754f0a8ff9e = /** @class */ function() {
    /**
     * Constructor for the TreeView module
     *
     * @param {IFileManager} parent - specifies the parent element.
     * @hidden
     */ /* istanbul ignore next */ function NavigationPane(parent) {
        this.removeNodes = [];
        this.moveNames = [];
        this.expandTree = false;
        this.isDrag = false;
        this.isPathDragged = false;
        this.isRenameParent = false;
        this.isRightClick = false;
        this.isSameNodeClicked = false;
        this.isNodeExpandCalled = false;
        this.renameParent = null;
        // Specifies the previously selected nodes in the treeview control.
        this.previousSelected = null;
        // Specifies whether the nodeClicked event of the treeview control is triggered or not.
        this.isNodeClickCalled = false;
        // Specifies whether to restrict node selection in the treeview control.
        this.restrictSelecting = false;
        this.parent = parent;
        this.addEventListener();
        this.keyConfigs = {
            altEnter: "alt+enter",
            esc: "escape",
            del: "delete",
            ctrlX: this.parent.isMac ? "cmd+x" : "ctrl+x",
            ctrlC: this.parent.isMac ? "cmd+c" : "ctrl+c",
            ctrlV: this.parent.isMac ? "cmd+v" : "ctrl+v",
            ctrlShiftN: "ctrl+shift+n",
            shiftF10: "shift+F10",
            f2: "f2"
        };
    }
    NavigationPane.prototype.onInit = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.treeObj)) return;
        var rootData = (0, $3EnZW.getValue)(this.parent.pathId[0], this.parent.feParent);
        (0, $3EnZW.setValue)("_fm_icon", "e-fe-folder", rootData);
        var attr = {};
        var id = (0, $3EnZW.getValue)("id", rootData);
        if (!(0, $3EnZW.isNullOrUndefined)(id)) (0, $3EnZW.setValue)("data-id", id, attr);
        if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(rootData)) (0, $3EnZW.setValue)("class", (0, $a3d9eadd9d99207c$export$e4c8c20b1ca0ec47)(rootData), attr);
        if (!(0, $3EnZW.isNullOrUndefined)(attr)) (0, $3EnZW.setValue)("_fm_htmlAttr", attr, rootData);
        this.treeObj = new (0, $71c78e892be7c33f$export$6940b0d9c820eca7)({
            fields: {
                dataSource: [
                    rootData
                ],
                id: "_fm_id",
                parentID: "_fm_pId",
                expanded: "_fm_expanded",
                selected: "_fm_selected",
                text: "name",
                hasChildren: "hasChild",
                iconCss: "_fm_icon",
                htmlAttributes: "_fm_htmlAttr",
                tooltip: "name"
            },
            enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
            sortOrder: this.parent.navigationPaneSettings.sortOrder,
            nodeSelecting: this.onNodeSelecting.bind(this),
            nodeSelected: this.onNodeSelected.bind(this),
            nodeExpanding: this.onNodeExpand.bind(this),
            nodeClicked: this.onNodeClicked.bind(this),
            allowEditing: true,
            nodeEditing: this.onNodeEditing.bind(this),
            drawNode: this.onDrowNode.bind(this),
            enableRtl: this.parent.enableRtl,
            dataBound: this.addDragDrop.bind(this)
        });
        this.treeObj.isStringTemplate = true;
        this.treeObj.appendTo("#" + this.parent.element.id + $15a2a1ec4804cfd7$export$5fedb72465b4ade3);
        this.wireEvents();
    };
    NavigationPane.prototype.addDragDrop = function() {
        var _this = this;
        if (!this.parent.isMobile && this.treeObj) {
            if (this.parent.allowDragAndDrop && (0, $3EnZW.isNullOrUndefined)(this.dragObj)) this.dragObj = new (0, $eAUyT.Draggable)(this.treeObj.element, {
                cursorAt: this.parent.dragCursorPosition,
                dragTarget: "." + $15a2a1ec4804cfd7$export$c025b5389024f4d2,
                distance: 5,
                dragArea: this.parent.element,
                drag: (0, $a3d9eadd9d99207c$export$f293f44a7af9215d).bind(this, this.parent),
                dragStart: function(args) {
                    (0, $a3d9eadd9d99207c$export$db131b841f9f6440)(_this.parent, args, _this.dragObj);
                },
                dragStop: (0, $a3d9eadd9d99207c$export$202f08d3a6bd576).bind(this, this.parent),
                enableTailMode: true,
                enableAutoScroll: false,
                helper: this.dragHelper.bind(this)
            });
            else if (!this.parent.allowDragAndDrop && this.dragObj) {
                this.dragObj.destroy();
                this.dragObj = null;
            }
        }
    };
    NavigationPane.prototype.dragHelper = function(args) {
        var dragTarget = args.sender.target;
        if (!dragTarget.classList.contains($15a2a1ec4804cfd7$export$c025b5389024f4d2)) return null;
        var dragLi = (0, $4ZDHT.closest)(dragTarget, "li");
        this.parent.dragPath = "";
        this.parent.dragData = [];
        this.parent.activeElements = [];
        this.parent.activeElements = [
            dragLi
        ];
        this.parent.dragNodes = [];
        (0, $a3d9eadd9d99207c$export$90835e7e06f4e75b)(this.parent, dragLi);
        this.parent.dragData = this.getTreeData(dragLi);
        this.parent.dragPath = this.getDragPath(dragLi, this.parent.dragData[0].name);
        this.parent.dragNodes.push(this.parent.dragData[0].name);
        (0, $a3d9eadd9d99207c$export$fda104f371357c1e)(this.parent);
        return this.parent.virtualDragElement;
    };
    NavigationPane.prototype.getDragPath = function(dragLi, text) {
        var path = this.getDropPath(dragLi, text);
        return (0, $a3d9eadd9d99207c$export$5a4b9be52684123a)(path);
    };
    NavigationPane.prototype.getDropPath = function(node, text) {
        var id = node.getAttribute("data-id");
        var newText = this.parent.hasId ? id : text;
        return (0, $a3d9eadd9d99207c$export$2aa3fd96c49a84a8)(node, newText, this.parent.hasId);
    };
    NavigationPane.prototype.onDrowNode = function(args) {
        var eventArgs = {
            element: args.node,
            fileDetails: args.nodeData,
            module: "NavigationPane"
        };
        this.parent.trigger("fileLoad", eventArgs);
    };
    NavigationPane.prototype.addChild = function(files, target, prevent) {
        var directories = (0, $a3d9eadd9d99207c$export$f29bab63f8b0973c)(files);
        var targetDirectory = this.getTreeData(target);
        if (directories.length > 0 && targetDirectory.length > 0 && (directories[0].filterPath == null || (0, $3EnZW.isNullOrUndefined)(targetDirectory[0]) && targetDirectory[0].filterPath == null || directories[0].filterPath !== targetDirectory[0].filterPath)) {
            var length_1 = 0;
            var folders = directories;
            while(length_1 < directories.length){
                // eslint-disable-next-line camelcase
                folders[parseInt(length_1.toString(), 10)]._fm_icon = "e-fe-folder";
                var attr = {};
                var id = (0, $3EnZW.getValue)("id", folders[length_1]);
                if (!(0, $3EnZW.isNullOrUndefined)(id)) (0, $3EnZW.setValue)("data-id", id, attr);
                if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(folders[length_1])) (0, $3EnZW.setValue)("class", (0, $a3d9eadd9d99207c$export$e4c8c20b1ca0ec47)(folders[length_1]), attr);
                if (!(0, $3EnZW.isNullOrUndefined)(attr)) (0, $3EnZW.setValue)("_fm_htmlAttr", attr, folders[length_1]);
                length_1++;
            }
            var element = (0, $4ZDHT.select)('[data-uid="' + target + '"]', this.treeObj.element);
            var childElements = (0, $4ZDHT.select)("ul", element);
            if ((0, $3EnZW.isNullOrUndefined)(childElements)) this.treeObj.addNodes(directories, target, null, prevent);
        }
    };
    // Node Selecting event handler
    NavigationPane.prototype.onNodeSelecting = function(args) {
        if (!args.isInteracted && !this.isRightClick && !this.isSameNodeClicked && !this.isPathDragged && !this.isRenameParent || this.restrictSelecting) {
            this.restrictSelecting = false;
            this.isNodeClickCalled = false;
            return;
        }
        if (!this.renameParent) {
            this.parent.activeModule = "navigationpane";
            var nodeData = this.getTreeData((0, $3EnZW.getValue)("id", args.nodeData));
            if (args.node.getAttribute("data-uid") !== this.parent.pathId[this.parent.pathId.length - 1] && !this.isRightClick && !this.isNodeClickCalled || this.isSameNodeClicked) {
                this.isNodeClickCalled = false;
                if (!this.isSameNodeClicked) {
                    this.isSameNodeClicked = true;
                    var selecEventArgs = {
                        action: args.action,
                        fileDetails: nodeData[0],
                        isInteracted: args.isInteracted
                    };
                    this.parent.trigger("fileSelect", selecEventArgs);
                }
                if (!this.isRightClick) {
                    var eventArgs = {
                        cancel: false,
                        fileDetails: nodeData[0],
                        module: "NavigationPane"
                    };
                    this.parent.trigger("fileOpen", eventArgs);
                    args.cancel = eventArgs.cancel;
                }
                if (args.cancel) {
                    this.restrictSelecting = this.isNodeClickCalled ? this.previousSelected[0] !== args.node.getAttribute("data-uid") : false;
                    this.isNodeClickCalled = true;
                    this.isSameNodeClicked = false;
                    this.previousSelected = this.treeObj.selectedNodes;
                    this.treeObj.selectedNodes = [
                        args.node.getAttribute("data-uid")
                    ];
                }
            } else if (this.previousSelected[0] !== args.node.getAttribute("data-uid")) {
                var selecEventArgs = {
                    action: args.action,
                    fileDetails: nodeData[0],
                    isInteracted: this.isNodeClickCalled
                };
                this.parent.trigger("fileSelect", selecEventArgs);
            }
        }
    };
    // Opens the folder while clicking open context menu item in the treeview.
    NavigationPane.prototype.openFileOnContextMenuClick = function(node) {
        var data = this.treeObj.getTreeData(node);
        this.parent.selectedItems = [];
        this.parent.itemData = data;
        this.activeNode = node;
        this.parent.activeModule = "navigationpane";
        var eventArgs = {
            cancel: false,
            fileDetails: data[0],
            module: "NavigationPane"
        };
        this.parent.trigger("fileOpen", eventArgs);
        this.isNodeClickCalled = true;
        if (!eventArgs.cancel) {
            (0, $a3d9eadd9d99207c$export$a2c7f654da2cad11)(node, this.parent.itemData[0], this.parent);
            (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, this.isPathDragged ? $f592513f3f17ead8$export$e936e35532731338 : $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
            this.parent.visitedItem = node;
            this.isPathDragged = this.isRenameParent = this.isRightClick = false;
            this.treeObj.selectedNodes = [
                node.getAttribute("data-uid")
            ];
        }
    };
    NavigationPane.prototype.onNodeSelected = function(args) {
        if (this.parent.breadcrumbbarModule && this.parent.breadcrumbbarModule.searchObj && !this.renameParent) {
            this.parent.breadcrumbbarModule.searchObj.element.value = "";
            this.parent.isFiltered = false;
            this.isNodeClickCalled = false;
        }
        this.parent.searchedItems = [];
        if (!args.isInteracted && !this.isRightClick && !this.isSameNodeClicked && !this.isPathDragged && !this.isRenameParent) {
            this.parent.pathId = (0, $a3d9eadd9d99207c$export$f33e5fa5d190a2a9)(args.node);
            return;
        }
        this.activeNode = args.node;
        this.parent.activeModule = "navigationpane";
        var nodeData = this.getTreeData((0, $3EnZW.getValue)("id", args.nodeData));
        this.parent.selectedItems = [];
        this.parent.itemData = nodeData;
        var previousPath = this.parent.path;
        if (!this.isRightClick && this.isSameNodeClicked) (0, $a3d9eadd9d99207c$export$a2c7f654da2cad11)(args.node, this.parent.itemData[0], this.parent);
        else {
            this.parent.pathId = (0, $a3d9eadd9d99207c$export$f33e5fa5d190a2a9)(args.node);
            this.parent.visitedItem = args.node;
        }
        if (args.node.querySelector("." + $15a2a1ec4804cfd7$export$fde44257752a9f60) && args.node.querySelector("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13) === null) this.expandNodeTarget = "add";
        if (previousPath !== this.parent.path) {
            if (!this.isRightClick && this.isSameNodeClicked) {
                (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, this.isPathDragged ? $f592513f3f17ead8$export$e936e35532731338 : $f592513f3f17ead8$export$f012f19194778278, this.parent.path);
                this.isNodeClickCalled = true;
            }
            this.parent.visitedItem = args.node;
        }
        this.isPathDragged = this.isRenameParent = this.isRightClick = this.isSameNodeClicked = false;
    };
    /* istanbul ignore next */ NavigationPane.prototype.onPathDrag = function(args) {
        this.isPathDragged = true;
        this.selectResultNode(args[0]);
    };
    /* istanbul ignore next */ NavigationPane.prototype.onNodeExpand = function(args) {
        if (!args.isInteracted && !this.isDrag) return;
        if (args.node.querySelector("." + $15a2a1ec4804cfd7$export$8ffe6fa0f85bec13) === null) {
            this.isNodeExpandCalled = true;
            var text = (0, $3EnZW.getValue)("text", args.nodeData);
            var id = args.node.getAttribute("data-id");
            var isId = (0, $3EnZW.isNullOrUndefined)(id) ? false : true;
            var newText = (0, $3EnZW.isNullOrUndefined)(id) ? text : id;
            var path = (0, $a3d9eadd9d99207c$export$2aa3fd96c49a84a8)(args.node, newText, isId);
            this.expandNodeTarget = args.node.getAttribute("data-uid");
            this.parent.expandedId = this.expandNodeTarget;
            this.parent.itemData = this.getTreeData((0, $3EnZW.getValue)("id", args.nodeData));
            this.parent.pathId.push((0, $3EnZW.getValue)("id", args.nodeData));
            (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$c71f547a81ce4daa, path);
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onNodeExpanded = function(args) {
        this.addChild(args.files, this.expandNodeTarget, false);
        this.parent.expandedId = null;
        this.isNodeExpandCalled = false;
    };
    NavigationPane.prototype.onNodeClicked = function(args) {
        this.parent.activeModule = "navigationpane";
        this.previousSelected = this.treeObj.selectedNodes;
        this.activeNode = args.node;
        if (args.event.which === 3 && args.node.getAttribute("data-uid") !== this.treeObj.selectedNodes[0]) {
            this.isRightClick = true;
            this.isNodeClickCalled = true;
            this.treeObj.selectedNodes = [
                args.node.getAttribute("data-uid")
            ];
        } else if (args.node.getAttribute("data-uid") === this.treeObj.selectedNodes[0] && this.parent.selectedItems.length !== 0) {
            this.parent.setProperties({
                selectedItems: []
            }, true);
            var layout = this.parent.view === "LargeIcons" ? "largeiconsview" : "detailsview";
            this.parent.notify($f592513f3f17ead8$export$80cded91831c5507, {
                module: layout,
                newProp: {
                    selectedItems: []
                }
            });
        } else if (args.node.getAttribute("data-uid") === this.treeObj.selectedNodes[0] && !this.isNodeClickCalled && !this.isNodeExpandCalled) {
            if (args.event.which === 3) this.isRightClick = true;
            this.isSameNodeClicked = true;
            this.isNodeClickCalled = true;
            this.treeObj.selectedNodes = [
                args.node.getAttribute("data-uid")
            ];
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onNodeEditing = function(args) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.innerHtml)) args.cancel = true;
    };
    NavigationPane.prototype.onPathChanged = function(args) {
        this.parent.isCut = false;
        var currFiles = (0, $3EnZW.getValue)(this.parent.pathId[this.parent.pathId.length - 1], this.parent.feFiles);
        if (this.expandNodeTarget === "add") {
            var sNode = (0, $4ZDHT.select)('[data-uid="' + this.treeObj.selectedNodes[0] + '"]', this.treeObj.element);
            var ul = !(0, $3EnZW.isNullOrUndefined)(sNode) ? (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$ff283a997e6ca548, sNode) : null;
            if ((0, $3EnZW.isNullOrUndefined)(ul)) this.addChild(args.files, this.treeObj.selectedNodes[0], !this.expandTree);
            this.expandNodeTarget = "";
        }
        this.expandTree = false;
        if ((0, $3EnZW.isNullOrUndefined)(currFiles)) (0, $3EnZW.setValue)(this.parent.pathId[this.parent.pathId.length - 1], args.files, this.parent.feFiles);
        if (this.parent.uploadObj.directoryUpload && !this.parent.hasId) this.updateTree(args);
    };
    NavigationPane.prototype.updateTree = function(args) {
        if (this.treeObj) {
            var id = this.treeObj.selectedNodes[0];
            this.updateTreeNode(args, id);
        }
    };
    NavigationPane.prototype.updateTreeNode = function(args, id) {
        var toExpand = this.treeObj.expandedNodes.indexOf(id) === -1 ? false : true;
        this.removeChildNodes(id);
        this.addChild(args.files, id, !toExpand);
    };
    NavigationPane.prototype.removeChildNodes = function(id) {
        var sNode = (0, $4ZDHT.select)('[data-uid="' + id + '"]', this.treeObj.element);
        var parent = (0, $4ZDHT.select)("." + $15a2a1ec4804cfd7$export$ff283a997e6ca548, sNode);
        var childs = parent ? Array.prototype.slice.call(parent.children) : null;
        if (childs) this.treeObj.removeNodes(childs);
    };
    NavigationPane.prototype.onOpenEnd = function(args) {
        var sleId = this.parent.pathId[this.parent.pathId.length - 1];
        this.treeObj.expandAll(this.treeObj.selectedNodes);
        this.treeObj.selectedNodes = [
            sleId
        ];
        this.expandNodeTarget = "add";
        this.onPathChanged(args);
    };
    NavigationPane.prototype.onOpenInit = function(args) {
        if (this.parent.activeModule === "navigationpane") {
            if (args.target.querySelector("." + $15a2a1ec4804cfd7$export$fde44257752a9f60)) this.treeObj.expandAll(this.treeObj.selectedNodes);
        }
    };
    NavigationPane.prototype.onInitialEnd = function(args) {
        this.onInit();
        this.addChild(args.files, (0, $3EnZW.getValue)("_fm_id", args.cwd), false);
    };
    NavigationPane.prototype.onFinalizeEnd = function(args) {
        this.onInit();
        var id = (0, $3EnZW.getValue)("_fm_id", args.cwd);
        this.addChild(args.files, id, false);
        this.treeObj.selectedNodes = [
            this.parent.pathId[this.parent.pathId.length - 1]
        ];
    };
    NavigationPane.prototype.onCreateEnd = function(args) {
        this.updateTree(args);
    };
    NavigationPane.prototype.onSelectedData = function() {
        if (this.parent.activeModule === "navigationpane") this.updateItemData();
    };
    NavigationPane.prototype.onDeleteInit = function() {
        if (this.parent.activeModule === "navigationpane") {
            this.updateActionData();
            var name_1 = (0, $3EnZW.getValue)("name", this.parent.itemData[0]);
            (0, $5703c0df24e3a120$export$bfadae053a633538)(this.parent, [
                name_1
            ], this.parent.path, "delete");
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onDeleteEnd = function(args) {
        if (this.parent.activeModule === "navigationpane") {
            var selectedNode = this.treeObj.selectedNodes[0];
            var selcetedEle = (0, $4ZDHT.select)('[data-uid="' + selectedNode + '"]', this.treeObj.element);
            var selectedNodeEle = (0, $4ZDHT.closest)(selcetedEle, "." + $15a2a1ec4804cfd7$export$ff283a997e6ca548).parentElement;
            this.treeObj.selectedNodes = [
                selectedNodeEle.getAttribute("data-uid")
            ];
            this.treeObj.dataBind();
        }
        this.updateTree(args);
    };
    NavigationPane.prototype.onRefreshEnd = function(args) {
        this.updateTree(args);
    };
    NavigationPane.prototype.onRenameInit = function() {
        if (this.parent.activeModule === "navigationpane") this.updateRenameData();
    };
    /* istanbul ignore next */ NavigationPane.prototype.onRenameEndParent = function(args) {
        var id = this.renameParent ? this.renameParent : this.parent.pathId[this.parent.pathId.length - 1];
        this.expandTree = this.treeObj.expandedNodes.indexOf(this.treeObj.selectedNodes[0]) !== -1;
        this.updateTreeNode(args, id);
        this.parent.expandedId = null;
        if (this.renameParent) this.renameParent = null;
        else {
            var resultData = [];
            if (this.parent.hasId) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("id", "equal", this.parent.renamedId, false));
            else {
                var nData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.treeObj.fields.text, "equal", this.parent.renameText, false));
                if (nData.length > 0) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(nData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("_fm_pId", "equal", id, false));
            }
            if (resultData.length > 0) {
                var id_1 = (0, $3EnZW.getValue)(this.treeObj.fields.id, resultData[0]);
                this.treeObj.selectedNodes = [
                    id_1
                ];
                this.treeObj.dataBind();
            }
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onRenameEnd = function(args) {
        if (this.parent.breadcrumbbarModule.searchObj.element.value === "" && !this.parent.isFiltered) this.updateTree(args);
        else {
            var data = this.treeObj.getTreeData();
            var resultData = [];
            if (this.parent.hasId) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(data).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("id", "equal", this.parent.renamedId, false));
            else {
                var nData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(data).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.treeObj.fields.text, "equal", this.parent.currentItemText, false));
                if (nData.length > 0) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(nData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("filterPath", "equal", this.parent.filterPath, false));
            }
            if (resultData.length > 0) {
                this.renameParent = (0, $3EnZW.getValue)(this.treeObj.fields.parentID, resultData[0]);
                this.parent.expandedId = this.renameParent;
                this.parent.itemData = this.getTreeData(this.renameParent);
                (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$fdf3aa211c42164c, this.parent.filterPath.replace(/\\/g, "/"));
            }
        }
    };
    NavigationPane.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName() && e.module !== "common") /* istanbul ignore next */ return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "allowDragAndDrop":
                    this.addDragDrop();
                    break;
                case "navigationPaneSettings":
                    (0, $5703c0df24e3a120$export$aafa59e2e03f2942)(this.parent, $f592513f3f17ead8$export$30adba19178942b3, "/");
                    if (e.oldProp.navigationPaneSettings.sortOrder !== e.newProp.navigationPaneSettings.sortOrder) this.treeObj.sortOrder = e.newProp.navigationPaneSettings.sortOrder;
                    break;
            }
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onDownLoadInit = function() {
        this.doDownload();
    };
    NavigationPane.prototype.onSelectionChanged = function(e) {
        this.treeObj.selectedNodes = [
            e.selectedNode
        ];
    };
    NavigationPane.prototype.onClearPathInit = function(e) {
        this.removeChildNodes(e.selectedNode);
    };
    NavigationPane.prototype.onDragEnd = function(args) {
        var moveNames = [];
        if (this.parent.isPasteError || this.parent.isSearchDrag) moveNames = this.getMoveNames(args.files, this.parent.isSearchDrag, this.parent.dragPath);
        else moveNames = this.moveNames;
        this.treeObj.removeNodes(moveNames);
    };
    NavigationPane.prototype.getMoveNames = function(files, flag, path) {
        var moveNames = [];
        for(var i = 0; i < files.length; i++){
            if (!files[i].isFile) {
                if (!this.parent.hasId) {
                    var name_2 = files[i].previousName;
                    if (flag) {
                        path = path + files[i].previousName;
                        var index = path.lastIndexOf("/");
                        name_2 = path.substring(index + 1);
                        path = path.substring(0, index + 1);
                    }
                    var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.treeObj.fields.text, "equal", name_2, false));
                    for(var j = 0; j < resultData.length; j++){
                        var fPath = (0, $3EnZW.getValue)("filterPath", resultData[j]);
                        fPath = fPath.replace(/\\/g, "/");
                        if (fPath === path) {
                            moveNames.push((0, $3EnZW.getValue)(this.treeObj.fields.id, resultData[j]));
                            break;
                        }
                    }
                }
            }
        }
        return moveNames;
    };
    NavigationPane.prototype.onCutEnd = function(args) {
        var moveNames = [];
        if (this.parent.isPasteError || this.parent.isSearchCut) this.moveNames = this.getMoveNames(args.files, this.parent.isSearchCut, this.parent.targetPath);
        else moveNames = this.moveNames;
        this.treeObj.removeNodes(moveNames);
    };
    /* istanbul ignore next */ NavigationPane.prototype.selectResultNode = function(resultObj) {
        if (!this.parent.hasId) {
            var path = (0, $3EnZW.getValue)("filterPath", resultObj);
            var itemname = (0, $3EnZW.getValue)("name", resultObj);
            var data = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.treeObj.fields.text, "equal", itemname, false));
            if (data.length > 0) {
                var resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(data).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("filterPath", "equal", path, false));
                if (resultData.length > 0) {
                    var id = (0, $3EnZW.getValue)(this.treeObj.fields.id, resultData[0]);
                    this.treeObj.selectedNodes = [
                        id
                    ];
                    this.treeObj.dataBind();
                }
            }
        } else {
            var selectedNode = this.treeObj.getTreeData().filter(function(obj) {
                return obj.name === resultObj.name;
            })[0];
            this.treeObj.selectedNodes = [
                (0, $3EnZW.getValue)("_fm_id", selectedNode)
            ];
            this.treeObj.dataBind();
        }
    };
    NavigationPane.prototype.onDropPath = function(args) {
        this.onpasteEnd(args);
        this.selectResultNode(this.parent.dropData);
        this.parent.isDropEnd = !this.parent.isPasteError;
    };
    NavigationPane.prototype.onpasteEnd = function(args) {
        var resultData = [];
        if (this.parent.hasId) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("id", "equal", (0, $3EnZW.getValue)("id", args.cwd), false));
        else {
            var nData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(this.treeObj.getTreeData()).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where(this.treeObj.fields.text, "equal", (0, $3EnZW.getValue)("name", args.cwd), false));
            if (nData.length > 0) resultData = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)(nData).executeLocal(new (0, $56262f229d1cff45$export$62297b13309008b2)().where("filterPath", "equal", (0, $3EnZW.getValue)("filterPath", args.cwd), false));
        }
        if (resultData.length > 0) {
            var id = (0, $3EnZW.getValue)(this.treeObj.fields.id, resultData[0]);
            var toExpand = this.treeObj.expandedNodes.indexOf(id) === -1;
            this.removeChildNodes(id);
            this.addChild(args.files, id, toExpand);
        }
        this.parent.expandedId = null;
        this.onPathChanged(args);
        if (this.parent.isDragDrop) this.checkDropPath(args);
    };
    /* istanbul ignore next */ NavigationPane.prototype.checkDropPath = function(args) {
        if ((0, $5703c0df24e3a120$export$ff708c1db2088d11)(this.parent) && (this.parent.path === this.parent.dropPath || this.parent.targetModule === "navigationpane")) return;
        if (this.parent.hasId) {
            this.parent.isDropEnd = !this.parent.isPasteError;
            (0, $a3d9eadd9d99207c$export$81da05fc5b680ef7)(this.parent);
            return;
        }
        if (this.parent.dropPath.indexOf((0, $a3d9eadd9d99207c$export$386ecaf3f3c304a2)(this.parent, args)) === -1) {
            this.parent.isDropEnd = false;
            (0, $a3d9eadd9d99207c$export$81da05fc5b680ef7)(this.parent);
        } else this.parent.isDropEnd = !this.parent.isPasteError;
    };
    NavigationPane.prototype.onpasteInit = function() {
        if (this.parent.activeModule === this.getModuleName()) this.updateItemData();
        this.moveNames = [];
        var obj = this.parent.isDragDrop || (0, $5703c0df24e3a120$export$ff708c1db2088d11)(this.parent) ? this.parent.dragData : this.parent.actionRecords;
        for(var i = 0; i < obj.length; i++)if ((0, $3EnZW.getValue)("isFile", obj[i]) === false) this.moveNames.push((0, $3EnZW.getValue)("_fm_id", obj[i]));
    };
    NavigationPane.prototype.oncutCopyInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            this.parent.activeRecords = this.getTreeData(this.treeObj.selectedNodes[0]);
            this.parent.activeElements = [
                this.activeNode
            ];
        }
    };
    NavigationPane.prototype.addEventListener = function() {
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($f592513f3f17ead8$export$996119a35335562f, this.onDownLoadInit, this);
        this.parent.on($f592513f3f17ead8$export$5d4840440f592fca, this.onInitialEnd, this);
        this.parent.on($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd, this);
        this.parent.on($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged, this);
        this.parent.on($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd, this);
        this.parent.on($f592513f3f17ead8$export$85f3ebc828366994, this.onCutEnd, this);
        this.parent.on($f592513f3f17ead8$export$df482b6a24e5bccf, this.onpasteInit, this);
        this.parent.on($f592513f3f17ead8$export$c71f547a81ce4daa, this.onNodeExpanded, this);
        this.parent.on($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd, this);
        this.parent.on($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData, this);
        this.parent.on($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit, this);
        this.parent.on($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd, this);
        this.parent.on($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd, this);
        this.parent.on($f592513f3f17ead8$export$faa80f63dbb892e4, this.onSelectionChanged, this);
        this.parent.on($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit, this);
        this.parent.on($f592513f3f17ead8$export$d9e8b42c77102776, this.onOpenEnd, this);
        this.parent.on($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit, this);
        this.parent.on($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onRenameEnd, this);
        this.parent.on($f592513f3f17ead8$export$fdf3aa211c42164c, this.onRenameEndParent, this);
        this.parent.on($f592513f3f17ead8$export$167b6548d992c399, this.onClearPathInit, this);
        this.parent.on($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit, this);
        this.parent.on($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit, this);
        this.parent.on($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData, this);
        this.parent.on($f592513f3f17ead8$export$5d38b0bd4bef40ba, this.onDragEnd, this);
        this.parent.on($f592513f3f17ead8$export$8e6c816465ea7419, this.onDragging, this);
        this.parent.on($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath, this);
        this.parent.on($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit, this);
        this.parent.on($f592513f3f17ead8$export$c1264df8455e40f0, this.onPathDrag, this);
    };
    NavigationPane.prototype.removeEventListener = function() {
        this.parent.off($f592513f3f17ead8$export$5d4840440f592fca, this.onInitialEnd);
        this.parent.off($f592513f3f17ead8$export$996119a35335562f, this.onDownLoadInit);
        this.parent.off($f592513f3f17ead8$export$30adba19178942b3, this.onFinalizeEnd);
        this.parent.off($f592513f3f17ead8$export$1bab5b85a1c363d3, this.onSelectedData);
        this.parent.off($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($f592513f3f17ead8$export$f012f19194778278, this.onPathChanged);
        this.parent.off($f592513f3f17ead8$export$e936e35532731338, this.onpasteEnd);
        this.parent.off($f592513f3f17ead8$export$85f3ebc828366994, this.onCutEnd);
        this.parent.off($f592513f3f17ead8$export$df482b6a24e5bccf, this.onpasteInit);
        this.parent.off($f592513f3f17ead8$export$faa80f63dbb892e4, this.onSelectionChanged);
        this.parent.off($f592513f3f17ead8$export$c71f547a81ce4daa, this.onNodeExpanded);
        this.parent.off($f592513f3f17ead8$export$870f71f756707ad0, this.onCreateEnd);
        this.parent.off($f592513f3f17ead8$export$102918c6556d57bd, this.onRefreshEnd);
        this.parent.off($f592513f3f17ead8$export$c2e8e8195b50c1cd, this.onOpenInit);
        this.parent.off($f592513f3f17ead8$export$d9e8b42c77102776, this.onOpenEnd);
        this.parent.off($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($f592513f3f17ead8$export$8192f7ae2d5b7044, this.onRenameInit);
        this.parent.off($f592513f3f17ead8$export$a6dd9c7789352fcb, this.onRenameEnd);
        this.parent.off($f592513f3f17ead8$export$fdf3aa211c42164c, this.onRenameEndParent);
        this.parent.off($f592513f3f17ead8$export$167b6548d992c399, this.onClearPathInit);
        this.parent.off($f592513f3f17ead8$export$6c22e1520513dd53, this.onDeleteInit);
        this.parent.off($f592513f3f17ead8$export$ce97bad2aef2d46a, this.onDeleteEnd);
        this.parent.off($f592513f3f17ead8$export$8d0c229d5a5bfdc1, this.oncutCopyInit);
        this.parent.off($f592513f3f17ead8$export$80d4b84b534c2942, this.onDropInit);
        this.parent.off($f592513f3f17ead8$export$5d38b0bd4bef40ba, this.onDragEnd);
        this.parent.off($f592513f3f17ead8$export$8e6c816465ea7419, this.onDragging);
        this.parent.off($f592513f3f17ead8$export$950f16bb18c1805d, this.onDropPath);
        this.parent.off($f592513f3f17ead8$export$d41cfdb8d87b5bef, this.onDetailsInit);
        this.parent.off($f592513f3f17ead8$export$8f25f467acbd067b, this.onMenuItemData);
        this.parent.off($f592513f3f17ead8$export$c1264df8455e40f0, this.onPathDrag);
    };
    /* istanbul ignore next */ NavigationPane.prototype.onDetailsInit = function() {
        if (this.parent.activeModule === this.getModuleName()) {
            var dataobj = this.getTreeData(this.treeObj.selectedNodes[0]);
            this.parent.itemData = dataobj;
        }
    };
    NavigationPane.prototype.onMenuItemData = function(args) {
        if (this.parent.activeModule === this.getModuleName()) {
            var liEle = (0, $4ZDHT.closest)(args.target, "li");
            this.parent.itemData = this.getTreeData(liEle.getAttribute("data-uid"));
        }
    };
    /* istanbul ignore next */ NavigationPane.prototype.onDragging = function(args) {
        var ele = (0, $4ZDHT.closest)(args.target, "li");
        if (ele.classList.contains("e-node-collapsed")) {
            this.isDrag = true;
            var level = parseInt(ele.getAttribute("aria-level"), 10);
            this.treeObj.expandAll([
                ele.getAttribute("data-uid")
            ], level + 1);
            this.isDrag = false;
        }
    };
    NavigationPane.prototype.onDropInit = function(args) {
        if (this.parent.targetModule === this.getModuleName()) {
            var dropLi = (0, $4ZDHT.closest)(args.target, "li");
            this.parent.dropData = this.getTreeData(dropLi)[0];
            this.parent.dropPath = this.getDropPath(dropLi, (0, $3EnZW.getValue)("name", this.parent.dropData));
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the module name.
     * @private
     */ NavigationPane.prototype.getModuleName = function() {
        return "navigationpane";
    };
    NavigationPane.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        if (this.treeObj) {
            this.unWireEvents();
            this.treeObj.destroy();
        }
    };
    NavigationPane.prototype.wireEvents = function() {
        this.keyboardModule = new (0, $dyv7X.KeyboardEvents)(this.treeObj.element, {
            keyAction: this.keyDown.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: "keydown"
        });
    };
    NavigationPane.prototype.unWireEvents = function() {
        this.keyboardModule.destroy();
    };
    /* istanbul ignore next */ NavigationPane.prototype.keyDown = function(e) {
        var action = e.action;
        switch(action){
            case "altEnter":
                this.parent.notify($f592513f3f17ead8$export$d41cfdb8d87b5bef, {});
                (0, $5703c0df24e3a120$export$1b969bdfbc184d40)(this.parent, [], this.parent.path, "details");
                break;
            case "esc":
                (0, $a3d9eadd9d99207c$export$931affad7351dd89)(this.parent);
                break;
            case "del":
                if (this.parent.pathId[0] !== this.activeNode.getAttribute("data-uid")) {
                    this.updateItemData();
                    if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(this.parent.itemData[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, this.parent.itemData[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                    else {
                        this.removeNodes = [];
                        (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this.parent, "Delete");
                    }
                }
                break;
            case "ctrlC":
                (0, $a3d9eadd9d99207c$export$6738b3634be42910)(this.parent);
                break;
            case "ctrlV":
                this.parent.folderPath = "";
                (0, $a3d9eadd9d99207c$export$5b201a757191240e)(this.parent);
                break;
            case "ctrlX":
                (0, $a3d9eadd9d99207c$export$3e9460fe0b724f5e)(this.parent);
                break;
            case "shiftF10":
                this.updateItemData();
                if (!(0, $a3d9eadd9d99207c$export$afe83600fb70ac59)(this.parent.itemData[0])) {
                    (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, this.parent.itemData[0], $f592513f3f17ead8$export$1812abec3897779e);
                    return;
                }
                if (this.parent.selectedItems.length !== 0) this.doDownload();
                break;
            case "f2":
                if (this.parent.selectedItems.length === 0) {
                    var data = this.getTreeData(this.treeObj.selectedNodes[0])[0];
                    if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(data)) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(this.parent, data, $f592513f3f17ead8$export$95ed0b4b15a415e8);
                    else {
                        this.updateRenameData();
                        (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(this.parent, "Rename");
                    }
                }
                break;
        }
    };
    NavigationPane.prototype.getTreeData = function(args) {
        var data = this.treeObj.getTreeData(args);
        for(var i = 0; i < data.length; i++)if ((0, $3EnZW.isNullOrUndefined)((0, $3EnZW.getValue)("hasChild", data[i]))) (0, $3EnZW.setValue)("hasChild", false, data[i]);
        return data;
    };
    NavigationPane.prototype.updateRenameData = function() {
        this.updateItemData();
        this.parent.currentItemText = (0, $3EnZW.getValue)("name", this.parent.itemData[0]);
    };
    NavigationPane.prototype.updateItemData = function() {
        var data = this.getTreeData(this.treeObj.selectedNodes[0])[0];
        this.parent.itemData = [
            data
        ];
        this.parent.isFile = false;
    };
    NavigationPane.prototype.updateActionData = function() {
        this.updateItemData();
        var newPath = (0, $a3d9eadd9d99207c$export$5a4b9be52684123a)(this.parent.path);
        this.parent.setProperties({
            path: newPath
        }, true);
        this.parent.pathId.pop();
        this.parent.pathNames.pop();
    };
    /* istanbul ignore next */ NavigationPane.prototype.doDownload = function() {
        var newPath = (0, $a3d9eadd9d99207c$export$5a4b9be52684123a)(this.parent.path);
        var itemId = this.treeObj.selectedNodes[0];
        var name = itemId === this.parent.pathId[0] ? "" : (0, $3EnZW.getValue)("name", this.parent.itemData[0]);
        (0, $5703c0df24e3a120$export$a7aaed3e118dd255)(this.parent, newPath, [
            name
        ]);
    };
    return NavigationPane;
}();

/* eslint-disable @typescript-eslint/no-explicit-any */ 
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");







/**
 * Toolbar module
 */ var $fabb2477399975ea$export$4c260019440d418f = /** @class */ function() {
    /**
     * Constructor for the Toolbar module
     *
     * @hidden
     * @param {IFileManager} parent - specifies the parent element.
     * @private
     */ function Toolbar(parent) {
        this.default = [
            "Delete",
            "Rename",
            "Download",
            "Cut",
            "Copy",
            "Paste"
        ];
        this.single = [
            "Delete",
            "Rename",
            "Download",
            "Cut",
            "Copy"
        ];
        this.multiple = [
            "Delete",
            "Download",
            "Cut",
            "Copy",
            "Refresh"
        ];
        this.selection = [
            "NewFolder",
            "Upload",
            "SortBy",
            "Refresh"
        ];
        this.parent = parent;
        this.render();
        this.addEventListener();
    }
    Toolbar.prototype.render = function() {
        var _this = this;
        this.items = this.toolbarItemData(this.getItems(this.parent.toolbarSettings.items.map(function(item) {
            return item.trim();
        })));
        var eventArgs = {
            items: this.items
        };
        this.parent.trigger("toolbarCreate", eventArgs, function(toolbarCreateArgs) {
            _this.items = toolbarCreateArgs.items;
            _this.toolbarObj = new (0, $6e0c0888b69d6c4c$export$4c260019440d418f)({
                items: _this.items,
                created: _this.toolbarCreateHandler.bind(_this),
                overflowMode: "Popup",
                clicked: _this.onClicked.bind(_this),
                enableHtmlSanitizer: _this.parent.enableHtmlSanitizer,
                enableRtl: _this.parent.enableRtl
            });
            _this.toolbarObj.isStringTemplate = true;
            _this.toolbarObj.root = _this.parent.root ? _this.parent.root : _this.parent;
            _this.toolbarObj.appendTo("#" + _this.parent.element.id + $15a2a1ec4804cfd7$export$4b2454a32e09a33d);
        });
    };
    Toolbar.prototype.getItemIndex = function(item) {
        var itemId = this.getId(item);
        for(var i = 0; i < this.items.length; i++){
            if (this.items[i].id === itemId) return i;
        }
        return -1;
    };
    Toolbar.prototype.getItems = function(items) {
        var currItems = items.slice();
        if (this.parent.isDevice && this.parent.allowMultiSelection) currItems.push("SelectAll");
        if (this.parent.toolbarItems.length > 0) currItems = this.parent.toolbarItems.map(function(item) {
            return item.name;
        });
        return currItems;
    };
    /* istanbul ignore next */ Toolbar.prototype.onClicked = function(args) {
        var _this = this;
        if ((0, $3EnZW.isNullOrUndefined)(args.item) || !args.item.id) return;
        var tool = args.item.id.substr((this.parent.element.id + "_tb_").length);
        var details;
        if (tool === "refresh" || tool === "newfolder" || tool === "upload") {
            details = [
                (0, $a3d9eadd9d99207c$export$c578b88ebf312dbd)(this.parent)
            ];
            this.parent.itemData = details;
        } else {
            this.parent.notify($f592513f3f17ead8$export$1bab5b85a1c363d3, {});
            details = this.parent.itemData;
        }
        var eventArgs = {
            cancel: false,
            fileDetails: details,
            item: args.item
        };
        this.parent.trigger("toolbarClick", eventArgs, function(toolbarClickArgs) {
            var sItems;
            var target;
            if (!toolbarClickArgs.cancel) switch(tool){
                case "sortby":
                    target = (0, $4ZDHT.closest)(args.originalEvent.target, "." + $15a2a1ec4804cfd7$export$d7715306c67126ab);
                    if (target && target.classList.contains("e-toolbar-popup")) args.cancel = true;
                    break;
                case "newfolder":
                    (0, $a3d9eadd9d99207c$export$a7450cfe784d304d)(_this.parent);
                    break;
                case "cut":
                    (0, $a3d9eadd9d99207c$export$3e9460fe0b724f5e)(_this.parent);
                    break;
                case "copy":
                    (0, $a3d9eadd9d99207c$export$6738b3634be42910)(_this.parent);
                    break;
                case "delete":
                    for(var i = 0; i < details.length; i++)if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(details[i])) {
                        (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(_this.parent, details[i], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                        return;
                    }
                    (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(_this.parent, "Delete");
                    break;
                case "details":
                    _this.parent.notify($f592513f3f17ead8$export$d41cfdb8d87b5bef, {});
                    sItems = _this.parent.selectedItems;
                    if (_this.parent.activeModule === "navigationpane") sItems = [];
                    (0, $5703c0df24e3a120$export$1b969bdfbc184d40)(_this.parent, sItems, _this.parent.path, "details");
                    break;
                case "paste":
                    _this.parent.folderPath = "";
                    (0, $a3d9eadd9d99207c$export$5b201a757191240e)(_this.parent);
                    break;
                case "refresh":
                    (0, $a3d9eadd9d99207c$export$2d6e9b4c68afb6c8)(_this.parent);
                    break;
                case "download":
                    (0, $a3d9eadd9d99207c$export$c986efa34c53294)(_this.parent);
                    break;
                case "rename":
                    if (!(0, $a3d9eadd9d99207c$export$35caa3cd1e53fb8d)(details[0])) (0, $a3d9eadd9d99207c$export$8f59902e1ae078e6)(_this.parent, details[0], $f592513f3f17ead8$export$95ed0b4b15a415e8);
                    else {
                        _this.parent.notify($f592513f3f17ead8$export$8192f7ae2d5b7044, {});
                        (0, $1ded0ca663b14865$export$3f449967ffb2f4b2)(_this.parent, "Rename");
                    }
                    break;
                case "upload":
                    (0, $a3d9eadd9d99207c$export$e5277fc94f47f9c6)(_this.parent);
                    break;
                case "selectall":
                    _this.parent.notify($f592513f3f17ead8$export$8c0e181e1fb07b6c, {});
                    break;
                case "selection":
                    _this.parent.notify($f592513f3f17ead8$export$846f4c514484a0e8, {});
                    break;
            }
        });
    };
    Toolbar.prototype.toolbarCreateHandler = function() {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("#" + this.getId("SortBy"), this.parent.element))) {
            var items = [
                {
                    id: this.getPupupId("name"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Name"),
                    iconCss: this.parent.sortBy === "name" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : ""
                },
                {
                    id: this.getPupupId("size"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Size"),
                    iconCss: this.parent.sortBy === "size" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : ""
                },
                {
                    id: this.getPupupId("date"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "DateModified"),
                    iconCss: this.parent.sortBy === "_fm_modified" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : ""
                },
                {
                    separator: true
                },
                {
                    id: this.getPupupId("ascending"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Ascending"),
                    iconCss: this.parent.sortOrder === "Ascending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : ""
                },
                {
                    id: this.getPupupId("descending"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Descending"),
                    iconCss: this.parent.sortOrder === "Descending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : ""
                },
                {
                    id: this.getPupupId("none"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "None"),
                    iconCss: this.parent.sortOrder === "None" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : ""
                }
            ];
            this.buttonObj = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
                items: items,
                cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, $15a2a1ec4804cfd7$export$ee3777be229b6eef),
                select: (0, $a3d9eadd9d99207c$export$3378c763463f8b33).bind(this, this.parent),
                enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
                enableRtl: this.parent.enableRtl,
                iconCss: $15a2a1ec4804cfd7$export$7e533dc0afd7438d
            });
            this.buttonObj.isStringTemplate = true;
            this.buttonObj.appendTo("#" + this.getId("SortBy"));
        }
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("#" + this.getId("View"), this.parent.element))) {
            var gridSpan_1 = '<span class="' + $15a2a1ec4804cfd7$export$aad553f955d4f5af + " " + $15a2a1ec4804cfd7$export$3a5f55a56dfc3645 + '"></span>';
            var largeIconSpan_1 = '<span class="' + $15a2a1ec4804cfd7$export$ef62356806fa9c5a + " " + $15a2a1ec4804cfd7$export$3a5f55a56dfc3645 + '"></span>';
            var layoutItems = [
                {
                    id: this.getPupupId("large"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View-LargeIcons"),
                    iconCss: this.parent.view === "Details" ? "" : $15a2a1ec4804cfd7$export$7c3c1a4030f052e2
                },
                {
                    id: this.getPupupId("details"),
                    text: (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View-Details"),
                    iconCss: this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : ""
                }
            ];
            this.layoutBtnObj = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
                iconCss: this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$aad553f955d4f5af : $15a2a1ec4804cfd7$export$ef62356806fa9c5a,
                cssClass: (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, "e-caret-hide " + $15a2a1ec4804cfd7$export$ee3777be229b6eef),
                items: layoutItems,
                select: this.layoutChange.bind(this),
                enableRtl: this.parent.enableRtl,
                content: '<span class="e-tbar-btn-text">' + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View") + "</span>",
                beforeItemRender: function(args) {
                    var tickIcon = args.item.iconCss;
                    var viewText = args.item.text === (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(_this.parent, "View-LargeIcons");
                    var iconClass = tickIcon ? " e-menu-icon " + tickIcon : "";
                    args.element.innerHTML = '<span class="' + iconClass + '"></span>' + (viewText ? largeIconSpan_1 : gridSpan_1) + args.item.text;
                    var span = args.element.firstChild;
                    if (span && span.className === "") args.element.removeChild(span);
                }
            });
            this.layoutBtnObj.isStringTemplate = true;
            this.layoutBtnObj.appendTo("#" + this.getId("View"));
        }
        this.hideItems(this.default, true);
        this.hideStatus();
        if (this.parent.portals && this.toolbarObj.portals) {
            this.parent.portals = this.parent.portals.concat(this.toolbarObj.portals);
            this.parent["renderReactTemplates"]();
        }
        var btnElement = (0, $4ZDHT.selectAll)(".e-btn", this.toolbarObj.element);
        var _loop_1 = function(btnCount) {
            /* istanbul ignore next */ btnElement[btnCount].onkeydown = function(e) {
                if (e.keyCode === 13 && !e.target.classList.contains("e-fe-popup")) e.preventDefault();
            };
            btnElement[btnCount].onkeyup = function(e) {
                if (e.keyCode === 13 && !e.target.classList.contains("e-fe-popup")) btnElement[btnCount].click();
            };
        };
        for(var btnCount = 0; btnCount < btnElement.length; btnCount++)_loop_1(btnCount);
        this.parent.refreshLayout();
    };
    Toolbar.prototype.updateSortByButton = function() {
        if (this.buttonObj) {
            var items = this.buttonObj.items;
            for(var itemCount = 0; itemCount < items.length; itemCount++){
                if (items[itemCount].id === this.getPupupId("name")) items[itemCount].iconCss = this.parent.sortBy === "name" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : "";
                else if (items[itemCount].id === this.getPupupId("size")) items[itemCount].iconCss = this.parent.sortBy === "size" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : "";
                else if (items[itemCount].id === this.getPupupId("date")) {
                    if (this.parent.sortBy === "dateModified" || this.parent.sortBy === "dateCreated") items[itemCount].iconCss = this.parent.sortBy === this.parent.sortBy ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : "";
                    else items[itemCount].iconCss = this.parent.sortBy === "_fm_modified" ? $15a2a1ec4804cfd7$export$c59cc7186c7cd9dd : "";
                } else if (items[itemCount].id === this.getPupupId("ascending")) items[itemCount].iconCss = this.parent.sortOrder === "Ascending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : "";
                else if (items[itemCount].id === this.getPupupId("descending")) items[itemCount].iconCss = this.parent.sortOrder === "Descending" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : "";
                else if (items[itemCount].id === this.getPupupId("none")) items[itemCount].iconCss = this.parent.sortOrder === "None" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : "";
            }
        }
    };
    Toolbar.prototype.getPupupId = function(id) {
        return this.parent.element.id + "_ddl_" + id.toLowerCase();
    };
    Toolbar.prototype.layoutChange = function(args) {
        if (this.parent.view === "Details") {
            if (args.item.id === this.getPupupId("large")) (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this.parent, "LargeIcons");
        } else if (args.item.id === this.getPupupId("details")) (0, $a3d9eadd9d99207c$export$16101e34a0df23af)(this.parent, "Details");
    };
    Toolbar.prototype.toolbarItemData = function(data) {
        var items = [];
        var mode = "Both";
        if (this.parent.isMobile) mode = "Overflow";
        for(var i = 0; i < data.length; i++){
            var item = void 0;
            var propItem = void 0;
            if (this.parent.toolbarItems.length > 0) propItem = this.getItemModel(this.parent.toolbarItems[parseInt(i.toString(), 10)]);
            var itemId = this.getId(data[i]);
            var itemText = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, data[i]);
            var itemTooltip = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Tooltip-" + data[i]);
            switch(data[i]){
                case "|":
                    item = {
                        type: "Separator"
                    };
                    break;
                case "Upload":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$668107712639d3c1,
                        showTextOn: mode
                    };
                    break;
                case "SortBy":
                    var spanElement = '<span class="e-tbar-btn-text e-tbar-ddb-text">' + itemText + "</span>";
                    if (propItem && propItem.text) spanElement = '<span class="e-tbar-btn-text e-tbar-ddb-text">' + propItem.text + "</span>";
                    item = {
                        id: itemId,
                        tooltipText: itemTooltip,
                        template: '<button id="' + itemId + '" class="e-tbar-btn e-tbtn-txt" tabindex="-1">' + spanElement + "</button>"
                    };
                    break;
                case "Refresh":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$885ce83a8b956470,
                        showTextOn: mode
                    };
                    break;
                case "Selection":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        suffixIcon: $15a2a1ec4804cfd7$export$de94d784588986a1,
                        overflow: "Show",
                        align: "Right"
                    };
                    break;
                case "View":
                    var viewText = void 0;
                    if (propItem && propItem.text) viewText = propItem.text;
                    else viewText = (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "View");
                    item = {
                        id: itemId,
                        tooltipText: itemTooltip,
                        prefixIcon: this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$aad553f955d4f5af : $15a2a1ec4804cfd7$export$ef62356806fa9c5a,
                        overflow: "Show",
                        align: "Right",
                        text: itemText,
                        showTextOn: "Overflow",
                        template: '<button id="' + itemId + '" class="e-tbar-btn e-tbtn-txt" tabindex="-1" aria-label=' + viewText + "></button>"
                    };
                    break;
                case "Details":
                    item = {
                        id: itemId,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$de358f4807ef8cba,
                        overflow: "Show",
                        align: "Right",
                        text: itemText,
                        showTextOn: "Overflow"
                    };
                    break;
                case "NewFolder":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$57ae219d1e034dc1,
                        showTextOn: mode
                    };
                    break;
                case "Cut":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$59600ec56318ce2e,
                        showTextOn: mode
                    };
                    break;
                case "Copy":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$e08ef55150a91249,
                        showTextOn: mode
                    };
                    break;
                case "Paste":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$b61aa7a218246ebb,
                        showTextOn: mode
                    };
                    break;
                case "Delete":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$e5b93bb6e343631c,
                        showTextOn: mode
                    };
                    break;
                case "Rename":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$f1d4ae5347f9c581,
                        showTextOn: mode
                    };
                    break;
                case "Download":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$41f3da434144936c,
                        showTextOn: mode
                    };
                    break;
                case "SelectAll":
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        prefixIcon: $15a2a1ec4804cfd7$export$c7cf3941a3f8df35,
                        showTextOn: mode
                    };
                    break;
                default:
                    item = {
                        id: itemId,
                        text: itemText,
                        tooltipText: itemTooltip,
                        template: ""
                    };
                    break;
            }
            if (this.parent.toolbarItems.length > 0 && propItem) {
                var mergedItems = Object.assign({}, item, propItem);
                items.push(mergedItems);
            } else items.push(item);
        }
        return items;
    };
    Toolbar.prototype.getItemModel = function(propItem) {
        var item = {};
        if (propItem.id) item.id = propItem.id;
        if (propItem.text) item.text = propItem.text;
        if (propItem.tooltipText) item.tooltipText = propItem.tooltipText;
        if (propItem.prefixIcon) item.prefixIcon = propItem.prefixIcon;
        if (propItem.cssClass) item.cssClass = propItem.cssClass;
        if (propItem.showTextOn !== "Both") item.showTextOn = propItem.showTextOn;
        if (propItem.template) item.template = propItem.template;
        if (propItem.disabled) item.disabled = propItem.disabled;
        if (propItem.width !== "auto") item.width = propItem.width;
        if (propItem.suffixIcon) item.suffixIcon = propItem.suffixIcon;
        if (propItem.align !== "Left") item.align = propItem.align;
        if (propItem.overflow !== "None") item.overflow = propItem.overflow;
        if (propItem.htmlAttributes) item.htmlAttributes = propItem.htmlAttributes;
        if (propItem.type !== "Button") item.type = propItem.type;
        if (propItem.visible !== true) item.visible = propItem.visible;
        if (propItem.showAlwaysInPopup) item.showAlwaysInPopup = propItem.showAlwaysInPopup;
        if (propItem.tabIndex !== -1) item.tabIndex = propItem.tabIndex;
        return item;
    };
    Toolbar.prototype.getId = function(id) {
        return this.parent.element.id + "_tb_" + id.toLowerCase();
    };
    Toolbar.prototype.addEventListener = function() {
        this.parent.on($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($f592513f3f17ead8$export$6abf7ade54df8039, this.onSelectionChanged, this);
        this.parent.on($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange, this);
        this.parent.on($f592513f3f17ead8$export$dd3932d6faae8783, this.showPaste, this);
        this.parent.on($f592513f3f17ead8$export$e4ef78b2d2708441, this.hidePaste, this);
        this.parent.on($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($f592513f3f17ead8$export$ebb59e6780002d23, this.updateSortByButton, this);
    };
    Toolbar.prototype.reRenderToolbar = function(e) {
        var _this = this;
        var itemsToProcess = [];
        if (this.parent.toolbarItems.length > 0) itemsToProcess = this.parent.toolbarItems.map(function(item) {
            return item.name;
        });
        else if (e.newProp.toolbarSettings.items !== undefined) itemsToProcess = e.newProp.toolbarSettings.items.map(function(item) {
            return item.trim();
        });
        if (itemsToProcess.length > 0) {
            this.items = this.toolbarItemData(this.getItems(itemsToProcess));
            var eventArgs = {
                items: this.items
            };
            this.parent.trigger("toolbarCreate", eventArgs, function(toolbarCreateArgs) {
                if (_this.buttonObj) _this.buttonObj.destroy();
                if (_this.layoutBtnObj) _this.layoutBtnObj.destroy();
                _this.items = toolbarCreateArgs.items;
                _this.toolbarObj.items = _this.items;
                _this.toolbarObj.dataBind();
                _this.toolbarCreateHandler();
            });
        }
    };
    Toolbar.prototype.onSelectionChanged = function() {
        this.hideStatus();
        this.hideItems(this.single, true);
        this.hideItems(this.selection, false);
        if (this.parent.selectedItems.length === 1) {
            this.hideItems(this.single, false);
            this.hideItems(this.selection, true);
        } else if (this.parent.selectedItems.length > 1) {
            this.hideItems(this.multiple, false);
            this.hideItems(this.selection, true);
        }
        var ele = (0, $4ZDHT.select)("#" + this.getId("Selection"), this.toolbarObj.element);
        if (this.parent.selectedItems.length > 0 && ele && !this.parent.enableVirtualization) {
            var txt = void 0;
            if (this.parent.selectedItems.length === 1) txt = this.parent.selectedItems.length + " " + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Item-Selection");
            else txt = this.parent.selectedItems.length + " " + (0, $a3d9eadd9d99207c$export$6ed696cdb1a60da9)(this.parent, "Items-Selection");
            (0, $4ZDHT.select)(".e-tbar-btn-text", ele).textContent = txt;
            this.toolbarObj.hideItem(ele.parentElement, false);
        }
    };
    Toolbar.prototype.hideItems = function(tools, toHide) {
        for(var i = 0; i < tools.length; i++){
            var ele = (0, $4ZDHT.select)("#" + this.getId(tools[i]), this.parent.element);
            if (ele) this.toolbarObj.hideItem(ele.parentElement, toHide);
        }
    };
    Toolbar.prototype.hideStatus = function() {
        var ele = (0, $4ZDHT.select)("#" + this.getId("Selection"), this.toolbarObj.element);
        if (ele) this.toolbarObj.hideItem(ele.parentElement, true);
    };
    Toolbar.prototype.showPaste = function() {
        this.hideItems([
            "Paste"
        ], false);
    };
    Toolbar.prototype.hidePaste = function() {
        this.hideItems([
            "Paste"
        ], true);
    };
    Toolbar.prototype.onLayoutChange = function() {
        if (this.layoutBtnObj) {
            this.layoutBtnObj.iconCss = this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$aad553f955d4f5af : $15a2a1ec4804cfd7$export$ef62356806fa9c5a;
            var items = this.layoutBtnObj.items;
            for(var itemCount = 0; itemCount < items.length; itemCount++){
                if (items[itemCount].id === this.getPupupId("large")) items[itemCount].iconCss = this.parent.view === "LargeIcons" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : "";
                else if (items[itemCount].id === this.getPupupId("details")) items[itemCount].iconCss = this.parent.view === "Details" ? $15a2a1ec4804cfd7$export$7c3c1a4030f052e2 : "";
            }
        }
    };
    Toolbar.prototype.removeEventListener = function() {
        this.parent.off($f592513f3f17ead8$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($f592513f3f17ead8$export$6abf7ade54df8039, this.onSelectionChanged);
        this.parent.off($f592513f3f17ead8$export$3b302e9dbb0aad19, this.onLayoutChange);
        this.parent.off($f592513f3f17ead8$export$dd3932d6faae8783, this.showPaste);
        this.parent.off($f592513f3f17ead8$export$e4ef78b2d2708441, this.hidePaste);
        this.parent.off($f592513f3f17ead8$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($f592513f3f17ead8$export$ebb59e6780002d23, this.updateSortByButton);
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns module name.
     * @private
     */ Toolbar.prototype.getModuleName = function() {
        return "toolbar";
    };
    Toolbar.prototype.onPropertyChanged = function(e) {
        if (e.module !== this.getModuleName() && e.module !== "common") /* istanbul ignore next */ return;
        for(var _i = 0, _a = Object.keys(e.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "cssClass":
                    if (this.buttonObj) this.buttonObj.cssClass = (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, $15a2a1ec4804cfd7$export$ee3777be229b6eef);
                    if (this.layoutBtnObj) this.layoutBtnObj.cssClass = (0, $a3d9eadd9d99207c$export$1840124d43c97419)(this.parent, "e-caret-hide " + $15a2a1ec4804cfd7$export$ee3777be229b6eef);
                    break;
                case "height":
                case "width":
                    this.toolbarObj.refreshOverflow();
                    break;
                case "toolbarSettings":
                case "toolbarItems":
                    this.reRenderToolbar(e);
                    break;
            }
        }
    };
    Toolbar.prototype.destroy = function() {
        if (this.parent.isDestroyed) return;
        this.removeEventListener();
        if (this.buttonObj) this.buttonObj.destroy();
        if (this.layoutBtnObj) this.layoutBtnObj.destroy();
        this.toolbarObj.destroy();
        this.parent.refreshLayout();
    };
    Toolbar.prototype.enableItems = function(items, isEnable) {
        for(var i = 0; i < items.length; i++){
            var ele = (0, $4ZDHT.select)("#" + this.getId(items[i]), this.parent.element);
            if (ele) this.toolbarObj.enableItems(ele.parentElement, isEnable);
        }
    };
    return Toolbar;
}();






/**
 * `FileManager` module is used to display the directories and images inside the editor.
 */ var $4f645c5c20d097dd$export$a5245c9b2355d1f8 = /** @class */ function() {
    function FileManager(parent, locator) {
        (0, $dadc0c1cfe4fa5dc$export$a5245c9b2355d1f8).Inject((0, $761ef639f2f64957$export$8dc6765e8be191c7), (0, $2133c38ddabe1767$export$9e4341e656034b31), (0, $316df11747aff4c1$export$4ea64754f0a8ff9e), (0, $fabb2477399975ea$export$4c260019440d418f));
        this.parent = parent;
        this.i10n = locator.getService("rteLocale");
        this.dialogRenderObj = locator.getService("dialogRenderObject");
        this.rendererFactory = locator.getService("rendererFactory");
        this.addEventListener();
        this.isDestroyed = false;
        this.insertImageBoundFn = this.insertImageUrl.bind(this);
        this.cancelDialogBoundFn = this.cancelDialog.bind(this);
        this.renderFileManagerBoundFn = this.renderFileManager.bind(this);
        this.dialogClosedBoundFn = this.dialogClosed.bind(this);
        this.onDocumentClickBoundFn = this.onDocumentClick.bind(this);
    }
    FileManager.prototype.initialize = function() {
        this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
    };
    FileManager.prototype.render = function(e) {
        var dlgInsert;
        if (e.selectNode && e.selectNode[0].nodeName === "IMG") dlgInsert = this.parent.localeObj.getConstant("dialogUpdate");
        else dlgInsert = this.i10n.getConstant("dialogInsert");
        var dlgHeader = this.parent.localeObj.getConstant("fileDialogHeader");
        var dlgCancel = this.i10n.getConstant("dialogCancel");
        this.dlgButtons = [
            {
                click: this.insertImageBoundFn,
                buttonModel: {
                    content: dlgInsert,
                    cssClass: "e-flat e-insertImage",
                    isPrimary: true,
                    disabled: true
                }
            },
            {
                click: this.cancelDialogBoundFn,
                buttonModel: {
                    cssClass: "e-flat e-cancel",
                    content: dlgCancel
                }
            }
        ];
        this.selectObj = {
            selection: e.selection,
            args: e.args,
            selectParent: e.selectParent
        };
        var dlgTarget = this.parent.createElement("div", {
            className: "e-rte-file-manager-dialog",
            id: this.parent.getID() + "_file-manager-dialog",
            attrs: {
                "aria-owns": this.parent.getID()
            }
        });
        document.body.appendChild(dlgTarget);
        this.fileWrap = this.parent.createElement("div", {
            id: this.parent.getID() + "_rte-file-manager",
            className: "e-img-file-wrap"
        });
        dlgTarget.appendChild(this.fileWrap);
        dlgTarget.appendChild(this.getInputUrlElement());
        var dialogModel = {
            visible: false,
            isModal: true,
            header: dlgHeader,
            target: document.body,
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl,
            cssClass: $afc560df281b588d$export$d3f61cb93957903e,
            animationSettings: {
                effect: "None"
            },
            showCloseIcon: true,
            closeOnEscape: true,
            width: "720px",
            height: "auto",
            position: {
                X: "center",
                Y: "center"
            },
            buttons: this.dlgButtons,
            created: this.renderFileManagerBoundFn,
            close: this.dialogClosedBoundFn
        };
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(dlgTarget);
        this.dialogObj.show((0, $5q7BP.Browser).isDevice ? true : false);
        this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    // eslint-disable-next-line @typescript-eslint/tslint/config
    FileManager.prototype.setCssClass = function(e) {
        if (this.dialogObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) this.dialogObj.setProperties({
                cssClass: (this.dialogObj.cssClass + " " + e.cssClass).trim()
            });
            else this.dialogObj.setProperties({
                cssClass: (this.dialogObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FileManager.prototype.dialogClosed = function(e) {
        this.parent.isBlur = false;
        if (e && e.event.returnValue) this.selectObj.selection.restore();
        this.destroyComponents();
        this.parent.element.ownerDocument.removeEventListener("mousedown", this.onDocumentClickBoundFn);
        this.dialogRenderObj.close(e);
    };
    FileManager.prototype.renderFileManager = function() {
        var _this = this;
        this.fileObj = new (0, $dadc0c1cfe4fa5dc$export$a5245c9b2355d1f8)({
            allowMultiSelection: false,
            locale: this.parent.locale,
            enableRtl: this.parent.enableRtl,
            path: this.parent.fileManagerSettings.path,
            view: this.parent.fileManagerSettings.view,
            enablePersistence: this.parent.enablePersistence,
            cssClass: this.parent.fileManagerSettings.cssClass,
            sortOrder: this.parent.fileManagerSettings.sortOrder,
            ajaxSettings: this.parent.fileManagerSettings.ajaxSettings,
            showThumbnail: this.parent.fileManagerSettings.showThumbnail,
            rootAliasName: this.parent.fileManagerSettings.rootAliasName,
            uploadSettings: this.parent.fileManagerSettings.uploadSettings,
            searchSettings: this.parent.fileManagerSettings.searchSettings,
            toolbarSettings: this.parent.fileManagerSettings.toolbarSettings,
            showHiddenItems: this.parent.fileManagerSettings.showHiddenItems,
            allowDragAndDrop: this.parent.fileManagerSettings.allowDragAndDrop,
            showFileExtension: this.parent.fileManagerSettings.showFileExtension,
            detailsViewSettings: this.parent.fileManagerSettings.detailsViewSettings,
            contextMenuSettings: this.parent.fileManagerSettings.contextMenuSettings,
            navigationPaneSettings: this.parent.fileManagerSettings.navigationPaneSettings,
            beforeSend: this.parent.fileManagerSettings.beforeSend,
            fileSelect: function(e) {
                var selectedFile = e.fileDetails;
                if (selectedFile.isFile && _this.parent.insertImageSettings.allowedTypes.indexOf(selectedFile.type) > -1) {
                    _this.inputUrl.value = _this.parent.fileManagerSettings.ajaxSettings.getImageUrl + "?path=" + (selectedFile.filterPath && selectedFile.filterPath.replace(/\\/g, "/")) + selectedFile.name;
                    _this.dlgButtons[0].buttonModel.disabled = false;
                } else {
                    _this.inputUrl.value = "";
                    _this.dlgButtons[0].buttonModel.disabled = true;
                }
                _this.dialogObj.setProperties({
                    buttons: _this.dlgButtons
                });
            },
            created: function() {
                _this.inputUrl.removeAttribute("disabled");
            },
            success: function() {
                _this.fileObj.refreshLayout();
            }
        });
        if ((0, $5q7BP.Browser).isDevice) this.fileObj.height = "85%";
        this.fileObj.appendTo(this.fileWrap);
        this.parent.element.ownerDocument.addEventListener("mousedown", this.onDocumentClickBoundFn);
    };
    FileManager.prototype.getInputUrlElement = function() {
        var imgUrl = this.parent.createElement("div", {
            className: "imgUrl"
        });
        var urlLabel = this.parent.createElement("div", {
            className: "e-rte-label"
        });
        urlLabel.innerHTML = '<label for="rteSample_img_url">' + this.i10n.getConstant("linkWebUrl") + "</label>";
        imgUrl.appendChild(urlLabel);
        var placeUrl = this.i10n.getConstant("imageUrl");
        this.inputUrl = this.parent.createElement("input", {
            className: "e-input e-img-url",
            attrs: {
                placeholder: placeUrl,
                spellcheck: "false",
                disabled: "true"
            }
        });
        imgUrl.appendChild(this.inputUrl);
        return imgUrl;
    };
    // eslint-disable-next-line
    FileManager.prototype.insertImageUrl = function(e) {
        var url = this.inputUrl.value;
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        if (url !== "") {
            if (this.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.selectObj.selection.range.startContainer.parentNode, "#" + this.contentModule.getPanel().id))) {
                this.contentModule.getEditPanel().focus();
                var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
                this.selectObj.selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.contentModule.getDocument());
                this.selectObj.selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            }
            var regex = /[\w-]+.(jpg|png|jpeg|gif)/g;
            var matchUrl = !(0, $3EnZW.isNullOrUndefined)(url.match(regex)) && this.parent.editorMode === "HTML" ? url.match(regex)[0] : "";
            var value = {
                cssClass: this.parent.insertImageSettings.display === "inline" ? $afc560df281b588d$export$650bb6ed56b4642 : $afc560df281b588d$export$c6e979ddaa53685e,
                url: url,
                selection: this.selectObj.selection,
                altText: matchUrl,
                selectParent: this.selectObj.selectParent,
                width: {
                    width: this.parent.insertImageSettings.width,
                    minWidth: this.parent.insertImageSettings.minWidth,
                    maxWidth: this.parent.getInsertImgMaxWidth()
                },
                height: {
                    height: this.parent.insertImageSettings.height,
                    minHeight: this.parent.insertImageSettings.minHeight,
                    maxHeight: this.parent.insertImageSettings.maxHeight
                }
            };
            this.parent.formatter.process(this.parent, this.selectObj.args, this.selectObj.args.originalEvent, value);
            this.dialogObj.hide({
                returnValue: false
            });
        }
    };
    FileManager.prototype.cancelDialog = function() {
        this.parent.isBlur = false;
        this.dialogObj.hide({
            returnValue: true
        });
    };
    FileManager.prototype.onDocumentClick = function(e) {
        var target = e.target;
        var prevEle = target.nodeName !== "#document" && !(0, $3EnZW.isNullOrUndefined)(target.previousElementSibling) && target.previousElementSibling;
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj) && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_file-manager-dialog") && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_rte-file-manager_tb_sortby-popup") && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_rte-file-manager_tb_view-popup") && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_rte-file-manager_contextmenu") && !(!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, ".e-contextmenu-wrapper")) && (0, $4ZDHT.closest)(target, ".e-contextmenu-wrapper").querySelector("#" + this.parent.getID() + "_rte-file-manager_contextmenu")) && !(0, $3EnZW.isNullOrUndefined)(prevEle) && !prevEle.classList.contains("e-rte-file-manager-dialog") && !(0, $3EnZW.isNullOrUndefined)(prevEle) && prevEle.id !== this.parent.getID() + "_rte-file-manager_contextmenu") {
            this.dialogObj.hide({
                returnValue: true
            });
            this.parent.isBlur = true;
            (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
        } else this.parent.isRTE = true;
    };
    FileManager.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.initialize, this);
        this.parent.on($947a002e9a697770$export$82523cb97e033732, this.render, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    FileManager.prototype.removeEventListener = function() {
        this.parent.element.ownerDocument.removeEventListener("mousedown", this.onDocumentClickBoundFn);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.initialize);
        this.parent.off($947a002e9a697770$export$82523cb97e033732, this.render);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
    };
    FileManager.prototype.destroyComponents = function() {
        if (this.fileObj) {
            this.fileObj.destroy();
            this.fileObj = null;
        }
        if (this.dialogObj) {
            this.dialogObj.destroy();
            (0, $4ZDHT.detach)(this.dialogObj.element);
        }
    };
    FileManager.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.destroyComponents();
        this.removeEventListener();
        this.dlgButtons = null;
        this.isDestroyed = true;
        this.insertImageBoundFn = null;
        this.cancelDialogBoundFn = null;
        this.renderFileManagerBoundFn = null;
        this.dialogClosedBoundFn = null;
        this.onDocumentClickBoundFn = null;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string value
     * @hidden
     */ FileManager.prototype.getModuleName = function() {
        return "fileManager";
    };
    return FileManager;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

var $7c797bf333ef7f08$export$f60085f983ca5dd5 = /** @class */ function() {
    function FormatPainter(parent) {
        this.isSticky = false;
        this.isActive = false;
        this.parent = parent;
        this.addEventListener();
        this.isDestroyed = false;
    }
    FormatPainter.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$499fb5841cd4be09, this.toolbarClick, this);
        this.parent.on($947a002e9a697770$export$e26301c11948181c, this.toolbarDoubleClick, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClick, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    FormatPainter.prototype.toolbarClick = function(clickargs) {
        this.parent.focusIn();
        if (!this.isSticky) {
            this.isActive = true;
            this.actionHandler(clickargs, "click");
        } else {
            // Handling the format painter double click toolbar esape action
            clickargs.args.action = "escape";
            this.actionHandler(clickargs, "keyBoard");
        }
        if (this.parent.quickToolbarModule && !(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text) && this.parent.element.ownerDocument.contains(this.parent.quickToolbarModule.textQTBar.element)) this.parent.quickToolbarModule.textQTBar.hidePopup();
    };
    FormatPainter.prototype.toolbarDoubleClick = function(args) {
        this.isActive = true;
        this.isSticky = true;
        this.parent.focusIn();
        this.actionHandler(args, "dbClick");
    };
    FormatPainter.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        if (!(0, $3EnZW.isNullOrUndefined)(originalEvent) && !(0, $3EnZW.isNullOrUndefined)(originalEvent.action) && (originalEvent.action === "format-copy" || originalEvent.action === "format-paste") || originalEvent.action === "escape" && (this.previousAction === "format-copy" || this.previousAction === "format-paste")) {
            if (originalEvent.action === "format-copy" || originalEvent.action === "format-paste") originalEvent.stopPropagation();
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1) originalEvent.preventDefault();
            this.actionHandler(event, "keyBoard");
        }
    };
    FormatPainter.prototype.actionHandler = function(event, type) {
        var action;
        var isKeyboard = false;
        var originalEvent;
        var args;
        var item;
        switch(type){
            case "dbClick":
                args = event.args;
                item = args.item;
                originalEvent = event.args.originalEvent;
                action = "format-copy";
                break;
            case "keyBoard":
                args = null;
                originalEvent = event.args;
                isKeyboard = true;
                action = event.args.action;
                if (action === "escape") {
                    this.isSticky = false;
                    this.isActive = false;
                }
                break;
            case "click":
                args = event.args;
                item = args.item;
                originalEvent = event.args.originalEvent;
                action = "format-copy";
                break;
            case "docClick":
                originalEvent = event;
                action = "format-paste";
                break;
        }
        this.updateCursor(isKeyboard);
        var enable = type === "docClick" || action === "escape" ? false : true;
        this.updateToolbarBtn(enable);
        if ((0, $3EnZW.isNullOrUndefined)(item)) item = {
            command: "FormatPainter",
            subCommand: "FormatPainter"
        };
        var actionBeginArgs = {
            requestType: "FormatPainter",
            originalEvent: originalEvent,
            name: action,
            item: item
        };
        var value = {
            formatPainterAction: action
        };
        this.parent.formatter.process(this.parent, actionBeginArgs, originalEvent, value);
        this.previousAction = action;
    };
    FormatPainter.prototype.updateCursor = function(isKeyboard) {
        if (!this.parent.inputElement.classList.contains("e-rte-cursor-brush") && !isKeyboard) (0, $4ZDHT.addClass)([
            this.parent.inputElement
        ], "e-rte-cursor-brush");
        else if (!this.isSticky) (0, $4ZDHT.removeClass)([
            this.parent.inputElement
        ], "e-rte-cursor-brush");
    };
    FormatPainter.prototype.updateToolbarBtn = function(enable) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.element.querySelector(".e-rte-format-painter"))) {
            var toolbarBtn = this.parent.element.querySelector(".e-rte-format-painter").parentElement.parentElement;
            if (enable) (0, $4ZDHT.addClass)([
                toolbarBtn
            ], "e-active");
            else if (!this.isSticky) (0, $4ZDHT.removeClass)([
                toolbarBtn
            ], "e-active");
        }
    };
    FormatPainter.prototype.editAreaClick = function(args) {
        if (this.isActive) {
            if (!this.isSticky) this.isActive = false;
            this.actionHandler(args, "docClick");
            this.updateToolbarBtn(false);
        }
    };
    FormatPainter.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.parent.off($947a002e9a697770$export$499fb5841cd4be09, this.toolbarClick);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClick);
        this.parent.off($947a002e9a697770$export$e26301c11948181c, this.toolbarDoubleClick);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent = null;
        this.isSticky = null;
        this.isActive = null;
        this.previousAction = null;
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ FormatPainter.prototype.getModuleName = function() {
        return "formatPainter";
    };
    return FormatPainter;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");
parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


/**
 * Constant values for Common
 */ /**
 * Keydown event trigger
 *
 * @hidden
 */ var $ee11fb99ae4d2c3e$export$a80636c6f41931fe = "keydown";
var $ee11fb99ae4d2c3e$export$9523889e0a5da4ba = "action";
var $ee11fb99ae4d2c3e$export$a9c1924e9a351d3d = "format-type";
var $ee11fb99ae4d2c3e$export$76852bc82d3e273b = "keydown-handler";
var $ee11fb99ae4d2c3e$export$22c50a44ec8aa5dd = "list-type";
var $ee11fb99ae4d2c3e$export$10fceeafb7518dd8 = "keyup-handler";
var $ee11fb99ae4d2c3e$export$390330c10ff2b9a1 = "keyup";
var $ee11fb99ae4d2c3e$export$230373593f042ef0 = "model_changed_plugin";
var $ee11fb99ae4d2c3e$export$bcb6f3aa635029d9 = "model_changed";
var $ee11fb99ae4d2c3e$export$197fda2d47388ee9 = "ms_word_cleanup_plugin";
var $ee11fb99ae4d2c3e$export$14c0a92c01180ed4 = "ms_word_cleanup";
var $ee11fb99ae4d2c3e$export$586814fbf9e806f = "onBegin";
var $ee11fb99ae4d2c3e$export$22b6648d4944f9ee = "actionBegin";
var $ee11fb99ae4d2c3e$export$c234d9c0576b5f9a = "format_painter_actions";
var $ee11fb99ae4d2c3e$export$1f5745aaf208647c = "blockquote_list_handled";
var $ee11fb99ae4d2c3e$export$bb3de268509fc258 = "emoji_picker_actions";
var $ee11fb99ae4d2c3e$export$c9576abd961512a2 = "mouseDown";
var $ee11fb99ae4d2c3e$export$31bf7b39daf71c67 = "destroy";
var $ee11fb99ae4d2c3e$export$71d691dc2f49a346 = "internal_destroy";


/**
 * Formatter
 *
 * @hidden

 */ var $b3bddae4b7750825$export$a06636add2a09fd8 = /** @class */ function() {
    function Formatter() {}
    /**
     * To execute the command
     *
     * @param  {IRichTextEditor} self - specifies the self element.
     * @param  {ActionBeginEventArgs} args - specifies the event arguments.
     * @param  {MouseEvent|KeyboardEvent} event - specifies the keyboard event.
     * @param  {IItemCollectionArgs} value - specifies the collection arguments
     * @returns {void}
     * @hidden

     */ Formatter.prototype.process = function(self, args, event1, value) {
        var _this = this;
        var selection = self.contentModule.getDocument().getSelection();
        var range = selection.rangeCount > 0 ? selection.getRangeAt(selection.rangeCount - 1) : null;
        var saveSelection;
        var newRange;
        if (!(0, $3EnZW.isNullOrUndefined)(value) && !(0, $3EnZW.isNullOrUndefined)(value.selection)) newRange = value.selection.range;
        var isKeyboardVideoInsert = !(0, $3EnZW.isNullOrUndefined)(value) && !(0, $3EnZW.isNullOrUndefined)(value.cssClass) && value.cssClass !== "e-video-inline";
        if (self.editorMode === "HTML") {
            if (!(0, $3EnZW.isNullOrUndefined)(args) && !isKeyboardVideoInsert) {
                if ((0, $3EnZW.isNullOrUndefined)(args.name) || !(0, $3EnZW.isNullOrUndefined)(args.name) && args.name !== "showDialog") {
                    if (newRange) saveSelection = this.editorManager.nodeSelection.save(newRange, self.contentModule.getDocument());
                    else saveSelection = this.editorManager.nodeSelection.save(range, self.contentModule.getDocument());
                }
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(args) && args.item.command && args.item.command !== "Table" && args.item.command !== "Actions" && args.item.command !== "Links" && args.item.command !== "Images" && args.item.command !== "Files" && args.item.command !== "Audios" && args.item.command !== "Videos" && args.item.command !== "EmojiPicker" && range && !(self.contentModule.getEditPanel().contains(this.getAncestorNode(range.commonAncestorContainer)) || self.contentModule.getEditPanel() === range.commonAncestorContainer || self.contentModule.getPanel() === range.commonAncestorContainer)) return;
        if (!(0, $3EnZW.isNullOrUndefined)(args) && self.maxLength !== -1 && !(0, $3EnZW.isNullOrUndefined)(args.item.command)) {
            var currentInsertContentLength = 0;
            if (args.item.command === "Links") currentInsertContentLength = value.text.length === 0 ? value.url.length : value.text.length;
            if (args.item.command === "Images" || args.item.command === "Videos" || args.item.command === "Table" || args.item.command === "Files") currentInsertContentLength = 1;
            var currentLength = self.getText().trim().replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "").length;
            var selectionLength = self.getSelection().length;
            var totalLength = currentLength - selectionLength + currentInsertContentLength;
            if (!(self.maxLength === -1 || totalLength <= self.maxLength)) return;
        }
        if ((0, $3EnZW.isNullOrUndefined)(args)) {
            var action_1 = event1.action;
            args = {};
            var items = {
                originalEvent: event1,
                cancel: false,
                requestType: action_1 || event1.key + "Key",
                itemCollection: value
            };
            (0, $3EnZW.extend)(args, args, items, true);
            if (action_1 !== "tab" && action_1 !== "enter" && action_1 !== "space" && action_1 !== "escape") {
                if (self.editorMode === "Markdown" && action_1 === "insert-table") value = {
                    "headingText": self.localeObj.getConstant("TableHeadingText"),
                    "colText": self.localeObj.getConstant("TableColText")
                };
                self.trigger($947a002e9a697770$export$df204737a6131aab, args, function(actionBeginArgs) {
                    if (actionBeginArgs.cancel) {
                        if (action_1 === "paste" || action_1 === "cut" || action_1 === "copy") event1.preventDefault();
                    }
                });
            }
            if (!args.cancel) {
                var isTableModule = (0, $3EnZW.isNullOrUndefined)(self.tableModule) ? true : self.tableModule ? self.tableModule.ensureInsideTableList : false;
                if (event1.which === 9 && isTableModule || event1.which !== 9) {
                    if (event1.which === 13 && self.editorMode === "HTML") value = {
                        "enterAction": self.enterKey
                    };
                    this.editorManager.observer.notify(event1.type === "keydown" ? (0, $ee11fb99ae4d2c3e$export$a80636c6f41931fe) : (0, $ee11fb99ae4d2c3e$export$390330c10ff2b9a1), {
                        event: event1,
                        callBack: this.onSuccess.bind(this, self),
                        value: value,
                        enterAction: self.enterKey
                    });
                }
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(args) && args.item.command && args.item.subCommand && (args.item.command !== args.item.subCommand && args.item.command !== "Font" && args.item.command !== "Export" || (args.item.subCommand === "FontName" || args.item.subCommand === "FontSize") && args.name === "dropDownSelect" || (args.item.subCommand === "BackgroundColor" || args.item.subCommand === "FontColor") && args.name === "colorPickerChanged" || args.item.subCommand === "FormatPainter" || args.item.subCommand === "EmojiPicker")) {
            (0, $3EnZW.extend)(args, args, {
                requestType: args.item.subCommand,
                cancel: false,
                itemCollection: value,
                selectType: args.name
            }, true);
            self.trigger($947a002e9a697770$export$df204737a6131aab, args, function(actionBeginArgs) {
                if (!actionBeginArgs.cancel) {
                    var formatPainterCopy = !(0, $3EnZW.isNullOrUndefined)(actionBeginArgs.requestType) && actionBeginArgs.requestType === "FormatPainter" && actionBeginArgs.name === "format-copy";
                    var formatPainterPaste = !(0, $3EnZW.isNullOrUndefined)(actionBeginArgs.requestType) && actionBeginArgs.requestType === "FormatPainter" && actionBeginArgs.name === "format-paste";
                    if (_this.getUndoRedoStack().length === 0 && actionBeginArgs.item.command !== "Links" && actionBeginArgs.item.command !== "Images" && !formatPainterCopy || formatPainterPaste) _this.saveData();
                    self.isBlur = false;
                    var quickToolbarAction = !(0, $3EnZW.isNullOrUndefined)(event1) && !(0, $3EnZW.isNullOrUndefined)(event1.target) && (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(event1.target, ".e-rte-elements.e-dropdown-popup.e-rte-dropdown-popup.e-quick-dropdown.e-popup-open")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(event1.target, ".e-rte-elements.e-rte-quick-popup.e-popup-open")));
                    if ((0, $3EnZW.isNullOrUndefined)(saveSelection) || !quickToolbarAction && ((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(saveSelection.range.startContainer.parentElement, ".e-img-caption")) ? true : !((0, $4ZDHT.closest)(saveSelection.range.startContainer.parentElement, ".e-img-caption").getAttribute("contenteditable") === "false")) && !((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1)) self.contentModule.getEditPanel().focus();
                    if (self.editorMode === "HTML" && !isKeyboardVideoInsert) {
                        if ((0, $3EnZW.isNullOrUndefined)(args.selectType) || !(0, $3EnZW.isNullOrUndefined)(args.selectType) && args.selectType !== "showDialog") saveSelection.restore();
                    }
                    var command = actionBeginArgs.item.subCommand.toLocaleLowerCase();
                    if (command === "image") value = actionBeginArgs.itemCollection;
                    if (command === "paste" || command === "cut" || command === "copy") self.clipboardAction(command, event1);
                    else {
                        _this.editorManager.observer.notify($947a002e9a697770$export$b2d123672bfdbe32, {
                            subCommand: actionBeginArgs.item.subCommand
                        });
                        _this.editorManager.execCommand(actionBeginArgs.item.command, actionBeginArgs.item.subCommand, event1, _this.onSuccess.bind(_this, self), actionBeginArgs.item.value, actionBeginArgs.item.subCommand === "Pre" && actionBeginArgs.selectType === "dropDownSelect" ? {
                            name: actionBeginArgs.selectType
                        } : value, "#" + self.getID() + " iframe", self.enterKey);
                    }
                }
            });
        }
        if ((0, $3EnZW.isNullOrUndefined)(event1) || event1 && event1.action !== "copy") this.enableUndo(self);
    };
    Formatter.prototype.getAncestorNode = function(node) {
        node = node.nodeType === 3 ? node.parentNode : node;
        return node;
    };
    /**
     * onKeyHandler method
     *
     * @param {IRichTextEditor} self - specifies the self element.
     * @param {KeyboardEvent} e - specifies the keyboard event.
     * @returns {void}
     * @hidden

     */ Formatter.prototype.onKeyHandler = function(self, e) {
        var _this = this;
        this.editorManager.observer.notify((0, $ee11fb99ae4d2c3e$export$390330c10ff2b9a1), {
            event: e,
            callBack: function() {
                self.notify($947a002e9a697770$export$a2ef9682a059097c, {});
                _this.enableUndo(self);
            },
            enterAction: self.enterKey
        });
    };
    /**
     * onSuccess method
     *
     * @param {IRichTextEditor} self - specifies the self element.
     * @param {IMarkdownFormatterCallBack} events - specifies the event call back
     * @returns {void}
     * @hidden

     */ Formatter.prototype.onSuccess = function(self, events) {
        self.notify($947a002e9a697770$export$a2ef9682a059097c, {});
        if (events && ((0, $3EnZW.isNullOrUndefined)(events.event) || events.event.action !== "copy")) {
            this.enableUndo(self);
            self.notify($947a002e9a697770$export$4e0a4553c5a3311d, events);
        }
        self.trigger($947a002e9a697770$export$830631a3cb598490, events, function(callbackArgs) {
            self.setPlaceHolder();
            if ((callbackArgs.requestType === "Images" || callbackArgs.requestType === "Links" || callbackArgs.requestType === "Audios" || callbackArgs.requestType === "Videos") && self.editorMode === "HTML") {
                var args = callbackArgs;
                if (callbackArgs.requestType === "Links" && callbackArgs.event && callbackArgs.event.type === "keydown" && callbackArgs.event.keyCode === 32) return;
                self.notify($947a002e9a697770$export$ac0f8621e12395a0, {
                    args: args.event,
                    type: callbackArgs.requestType,
                    isNotify: true,
                    elements: args.elements
                });
            }
            if (callbackArgs.requestType === "VideosPlayPause") self.notify("editAreaClick", {
                args: event
            });
            self.autoResize();
        });
    };
    /**
     * Save the data for undo and redo action.
     *
     * @param {KeyboardEvent} e - specifies the keyboard event.
     * @returns {void}
     * @hidden

     */ Formatter.prototype.saveData = function(e) {
        this.editorManager.undoRedoManager.saveData(e);
    };
    /**
     * getUndoStatus method
     *
     * @returns {void}
     * @hidden

     */ Formatter.prototype.getUndoStatus = function() {
        return this.editorManager.undoRedoManager.getUndoStatus();
    };
    /* eslint-disable */ /**
     * getUndoRedoStack method
     *
     * @param {IHtmlUndoRedoData}  - specifies the redo data.
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ Formatter.prototype.getUndoRedoStack = function() {
        return this.editorManager.undoRedoManager.undoRedoStack;
    };
    /**
     * enableUndo method
     *
     * @param {IRichTextEditor} self - specifies the self element.
     * @returns {void}
     * @hidden

     */ Formatter.prototype.enableUndo = function(self) {
        var status = this.getUndoStatus();
        if (self.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(self.quickToolbarModule.inlineQTBar.quickTBarObj, status);
        else if (self.toolbarModule && self.toolbarModule.baseToolbar) (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(self.toolbarModule.baseToolbar, status);
    };
    Formatter.prototype.beforeSlashMenuApply = function() {
        this.editorManager.beforeSlashMenuApplyFormat();
    };
    return Formatter;
}();


parcelRequire("j7YE8");
var $13zI2 = parcelRequire("13zI2");
/**
 * Constant values for EditorManager
 */ /**
 * Image plugin events
 *
 * @hidden
 */ var $56b963295b740d00$export$74f94c628b84d921 = "INSERT-IMAGE";
var $56b963295b740d00$export$27a341487b23f48f = "INSERT-AUDIO";
var $56b963295b740d00$export$f3657d8d6be09c14 = "INSERT-VIDEO";
var $56b963295b740d00$export$88a597d0c7ae97b = "INSERT-TABLE";
var $56b963295b740d00$export$b395009ca7f092c7 = "INSERT-LINK";
var $56b963295b740d00$export$4f907db68c03b38f = "INSERT-ROW";
var $56b963295b740d00$export$90f8dc07e17eff78 = "INSERT-COLUMN";
var $56b963295b740d00$export$bbc7b4de7639a0e6 = "DELETE-ROW";
var $56b963295b740d00$export$8257751f67095555 = "DELETE-COLUMN";
var $56b963295b740d00$export$bd1f6cc7291d4cf1 = "REMOVE-TABLE";
var $56b963295b740d00$export$8f899c1b459a778c = "TABLE-HEADER";
var $56b963295b740d00$export$88d20efa8d21dfb9 = "TABLE_VERTICAL_ALIGN";
var $56b963295b740d00$export$ca0fb188aaf9f2cf = "TABLE_MERGE";
var $56b963295b740d00$export$2a47f47b618178e4 = "TABLE_VERTICAL_SPLIT";
var $56b963295b740d00$export$a4764f7dc1ebaae7 = "TABLE_HORIZONTAL_SPLIT";
var $56b963295b740d00$export$684cafe96c16a76 = "TABLE_MOVE";
var $56b963295b740d00$export$d79d483636d4477c = "alignment-type";
var $56b963295b740d00$export$303836d45647271d = "indent-type";
var $56b963295b740d00$export$d5f8cd4675f465a5 = "p";
var $56b963295b740d00$export$d8e31d963c9fa6cb = [
    "address",
    "article",
    "aside",
    "audio",
    "blockquote",
    "canvas",
    "details",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "noscript",
    "ol",
    "output",
    "p",
    "pre",
    "section",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "ul",
    "video",
    "body"
];
var $56b963295b740d00$export$5668f6141f812fad = [
    "td",
    "th"
];
var $56b963295b740d00$export$42fa0eda31a41dcc = [
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
];
var $56b963295b740d00$export$96527b3d022fe7df = "selection-type";
var $56b963295b740d00$export$3eeeec04b2c6224 = "inserthtml-type";
var $56b963295b740d00$export$d5e6ccd3e4d93c9b = "insert-text-type";
var $56b963295b740d00$export$556ae66def187bfd = "clear-type";
var $56b963295b740d00$export$7f7c530a82f07f20 = [
    "area",
    "base",
    "br",
    "embed",
    "hr",
    "img",
    "input",
    "param",
    "source",
    "track",
    "wbr",
    "iframe",
    "td",
    "table"
];
var $56b963295b740d00$export$9b8dbe4d9d74124c = [
    "word",
    "excel",
    "onenote"
];



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * `Selection` module is used to handle RTE Selections.
 */ var $55b5a64fb1119729$export$e2940151ac854c0b = /** @class */ function() {
    function NodeSelection() {
        this.startNodeName = [];
        this.endNodeName = [];
    }
    NodeSelection.prototype.saveInstance = function(range, body) {
        this.range = range.cloneRange();
        this.rootNode = this.documentFromRange(range);
        this.body = body;
        this.startContainer = this.getNodeArray(range.startContainer, true);
        this.endContainer = this.getNodeArray(range.endContainer, false);
        this.startOffset = range.startOffset;
        this.endOffset = range.endOffset;
        this.html = this.body.innerHTML;
        return this;
    };
    NodeSelection.prototype.documentFromRange = function(range) {
        return 9 === range.startContainer.nodeType ? range.startContainer : range.startContainer.ownerDocument;
    };
    NodeSelection.prototype.getRange = function(docElement) {
        var select = this.get(docElement);
        var range = select && select.rangeCount > 0 ? select.getRangeAt(select.rangeCount - 1) : docElement.createRange();
        return range.startContainer !== docElement || range.endContainer !== docElement || range.startOffset || range.endOffset || (range.setStart(docElement.body, 0), range.collapse(!0)), range;
    };
    /**
     * get method
     *
     * @param {Document} docElement - specifies the get function
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.get = function(docElement) {
        return docElement.defaultView.getSelection();
    };
    /**
     * save method
     *
     * @param {Range} range - range value.
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.save = function(range, docElement) {
        range = range ? range.cloneRange() : this.getRange(docElement);
        return this.saveInstance(range, docElement.body);
    };
    /**
     * getIndex method
     *
     * @param {Node} node - specifies the node value.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getIndex = function(node) {
        var index;
        var num = 0;
        node = !node.previousSibling && node.tagName === "BR" ? node : node.previousSibling;
        if (node) for(var type = node.nodeType; node;){
            index = node.nodeType;
            num++;
            //eslint-disable-next-line
            type = index;
            node = node.previousSibling;
        }
        return num;
    };
    NodeSelection.prototype.isChildNode = function(nodeCollection, parentNode) {
        for(var index = 0; index < parentNode.childNodes.length; index++){
            if (nodeCollection.indexOf(parentNode.childNodes[index]) > -1) return true;
        }
        return false;
    };
    NodeSelection.prototype.getNode = function(startNode, endNode, nodeCollection) {
        if (endNode === startNode && (startNode.nodeType === 3 || !startNode.firstChild || nodeCollection.indexOf(startNode.firstChild) !== -1 || this.isChildNode(nodeCollection, startNode))) return null;
        if (startNode.nodeType === 3 && startNode.previousSibling === endNode && endNode.nodeName === "IMG") return null;
        if (nodeCollection.indexOf(startNode.firstChild) === -1 && startNode.firstChild && !this.isChildNode(nodeCollection, startNode)) return startNode.firstChild;
        if (startNode.nextSibling) return startNode.nextSibling;
        if (!startNode.parentNode) return null;
        else return startNode.parentNode;
    };
    /**
     * getNodeCollection method
     *
     * @param {Range} range -specifies the range.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getNodeCollection = function(range) {
        var startNode = range.startContainer.childNodes[range.startOffset] || range.startContainer;
        var endNode = range.endContainer.childNodes[range.endOffset > 0 ? range.endOffset - 1 : range.endOffset] || range.endContainer;
        if ((startNode === endNode || startNode.nodeName === "BR" && startNode === range.endContainer.childNodes[range.endOffset]) && startNode.childNodes.length === 0) return [
            startNode
        ];
        if (range.startOffset === range.endOffset && range.startOffset !== 0 && range.startContainer.nodeName === "PRE") return [
            startNode.nodeName === "BR" || startNode.nodeName === "#text" ? startNode : startNode.childNodes[0]
        ];
        var nodeCollection = [];
        do {
            if (nodeCollection.indexOf(startNode) === -1) nodeCollection.push(startNode);
            startNode = this.getNode(startNode, endNode, nodeCollection);
        }while (startNode);
        return nodeCollection;
    };
    /**
     * getParentNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getParentNodeCollection = function(range) {
        return this.getParentNodes(this.getNodeCollection(range), range);
    };
    /**
     * getParentNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @param {Range} range - specifies the range values.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getParentNodes = function(nodeCollection, range) {
        nodeCollection = nodeCollection.reverse();
        for(var index = 0; index < nodeCollection.length; index++){
            if (nodeCollection.indexOf(nodeCollection[index].parentNode) !== -1 || nodeCollection[index].nodeType === 3 && range.startContainer !== range.endContainer && range.startContainer.parentNode !== range.endContainer.parentNode) {
                nodeCollection.splice(index, 1);
                index--;
            } else if (nodeCollection[index].nodeType === 3) nodeCollection[index] = nodeCollection[index].parentNode;
        }
        return nodeCollection;
    };
    /**
     * getSelectionNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getSelectionNodeCollection = function(range) {
        return this.getSelectionNodes(this.getNodeCollection(range));
    };
    /**
     * getSelectionNodeCollection along with BR node method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getSelectionNodeCollectionBr = function(range) {
        return this.getSelectionNodesBr(this.getNodeCollection(range));
    };
    /**
     * getParentNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getSelectionNodes = function(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        var regEx = new RegExp("\u200B", "g");
        for(var index = 0; index < nodeCollection.length; index++)if (nodeCollection[index].nodeType !== 3 || nodeCollection[index].textContent.trim() === "" || nodeCollection[index].textContent.length === 1 && nodeCollection[index].textContent.match(regEx)) {
            nodeCollection.splice(index, 1);
            index--;
        }
        return nodeCollection.reverse();
    };
    /**
     * Get selection text nodes with br method.
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getSelectionNodesBr = function(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        var regEx = new RegExp("\u200B", "g");
        for(var index = 0; index < nodeCollection.length; index++)if (nodeCollection[index].nodeName !== "BR" && (nodeCollection[index].nodeType !== 3 || nodeCollection[index].textContent.trim() === "" || nodeCollection[index].textContent.length === 1 && nodeCollection[index].textContent.match(regEx))) {
            nodeCollection.splice(index, 1);
            index--;
        }
        return nodeCollection.reverse();
    };
    /**
     * getInsertNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getInsertNodeCollection = function(range) {
        return this.getInsertNodes(this.getNodeCollection(range));
    };
    /**
     * getInsertNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getInsertNodes = function(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        for(var index = 0; index < nodeCollection.length; index++)if (nodeCollection[index].childNodes.length !== 0 && nodeCollection[index].nodeType !== 3 || nodeCollection[index].nodeType === 3 && nodeCollection[index].textContent === "") {
            nodeCollection.splice(index, 1);
            index--;
        }
        return nodeCollection.reverse();
    };
    /**
     * getNodeArray method
     *
     * @param {Node} node - specifies the node content.
     * @param {boolean} isStart - specifies the boolean value.
     * @param {Document} root - specifies the root document.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getNodeArray = function(node, isStart, root) {
        var array = [];
        // eslint-disable-next-line
        isStart ? this.startNodeName = [] : this.endNodeName = [];
        for(; node !== (root ? root : this.rootNode);){
            if ((0, $3EnZW.isNullOrUndefined)(node)) break;
            // eslint-disable-next-line
            isStart ? this.startNodeName.push(node.nodeName.toLowerCase()) : this.endNodeName.push(node.nodeName.toLowerCase());
            array.push(this.getIndex(node));
            node = node.parentNode;
        }
        return array;
    };
    NodeSelection.prototype.setRangePoint = function(range, isvalid, num, size) {
        var node = this.rootNode;
        var index = num.length;
        var constant = size;
        for(; index--;)node = node && node.childNodes[num[index]];
        if (node && constant >= 0 && node.nodeName !== "html") {
            if (node.nodeType === 3 && node.nodeValue.replace(/\u00a0/g, "&nbsp;") === "&nbsp;") constant = node.textContent.length;
            range[isvalid ? "setStart" : "setEnd"](node, constant);
        }
        return range;
    };
    /**
     * restore method
     *
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.restore = function() {
        var range = this.range.cloneRange();
        range = this.setRangePoint(range, true, this.startContainer, this.startOffset);
        range = this.setRangePoint(range, false, this.endContainer, this.endOffset);
        this.selectRange(this.rootNode, range);
        return range;
    };
    NodeSelection.prototype.selectRange = function(docElement, range) {
        this.setRange(docElement, range);
        this.save(range, docElement);
    };
    /**
     * setRange method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Range} range - specifies the range.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.setRange = function(docElement, range) {
        var selection = this.get(docElement);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    /**
     * setSelectionText method
     *
     * @param {Document} docElement - specifies the documrent
     * @param {Node} startNode - specifies the starting node.
     * @param {Node} endNode - specifies the the end node.
     * @param {number} startIndex - specifies the starting index.
     * @param {number} endIndex - specifies the end index.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.setSelectionText = function(docElement, startNode, endNode, startIndex, endIndex) {
        var range = docElement.createRange();
        range.setStart(startNode, startIndex);
        range.setEnd(endNode, endIndex);
        this.setRange(docElement, range);
    };
    /**
     * setSelectionContents method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} element - specifies the node.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.setSelectionContents = function(docElement, element) {
        var range = docElement.createRange();
        range.selectNode(element);
        this.setRange(docElement, range);
    };
    /**
     * setSelectionNode method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} element - specifies the node.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.setSelectionNode = function(docElement, element) {
        var range = docElement.createRange();
        range.selectNodeContents(element);
        this.setRange(docElement, range);
    };
    /**
     * getSelectedNodes method
     *
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.getSelectedNodes = function(docElement) {
        return this.getNodeCollection(this.getRange(docElement));
    };
    /**
     * Clear method
     *
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.Clear = function(docElement) {
        this.get(docElement).removeAllRanges();
    };
    /**
     * insertParentNode method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} newNode - specicfies the new node.
     * @param {Range} range - specifies the range.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.insertParentNode = function(docElement, newNode, range) {
        range.surroundContents(newNode);
        this.selectRange(docElement, range);
    };
    /**
     * setCursorPoint method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Element} element - specifies the element.
     * @param {number} point - specifies the point.
     * @returns {void}
     * @hidden

     */ NodeSelection.prototype.setCursorPoint = function(docElement, element, point) {
        var range = docElement.createRange();
        var selection = docElement.defaultView.getSelection();
        range.setStart(element, point);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    return NodeSelection;
}();


/**
 * Default Markdown formats config for adapter
 */ var $9dc0015271a44eb1$export$353ee4035bba39f5 = {
    "h6": "###### ",
    "h5": "##### ",
    "h4": "#### ",
    "h3": "### ",
    "h2": "## ",
    "h1": "# ",
    "blockquote": "> ",
    "pre": "```\n",
    "p": ""
};
var $9dc0015271a44eb1$export$a0d7d3d7f12db22d = {
    "Bold": "**",
    "Italic": "*",
    "StrikeThrough": "~~",
    "InlineCode": "`",
    "SubScript": "<sub>",
    "SuperScript": "<sup>",
    "UpperCase": "A-Z",
    "LowerCase": "a-z"
};
var $9dc0015271a44eb1$export$28ada9cf17b591a5 = {
    "OL": "1. ",
    "UL": "- "
};
var $9dc0015271a44eb1$export$67e31f1c194fcbe6 = {
    "toolbar-focus": "alt+f10",
    "escape": "escape",
    "backspace": "backspace",
    "insert-link": "ctrl+k",
    "insert-image": "ctrl+shift+i",
    "insert-audio": "ctrl+shift+a",
    "insert-video": "ctrl+alt+v",
    "insert-table": "ctrl+shift+e",
    "undo": "ctrl+z",
    "redo": "ctrl+y",
    "copy": "ctrl+c",
    "cut": "ctrl+x",
    "paste": "ctrl+v",
    "bold": "ctrl+b",
    "italic": "ctrl+i",
    "underline": "ctrl+u",
    "strikethrough": "ctrl+shift+s",
    "uppercase": "ctrl+shift+u",
    "lowercase": "ctrl+shift+l",
    "superscript": "ctrl+shift+=",
    "subscript": "ctrl+=",
    "indents": "ctrl+]",
    "outdents": "ctrl+[",
    "html-source": "ctrl+shift+h",
    "full-screen": "ctrl+shift+f",
    "decrease-fontsize": "ctrl+shift+<",
    "increase-fontsize": "ctrl+shift+>",
    "justify-center": "ctrl+e",
    "justify-full": "ctrl+j",
    "justify-left": "ctrl+l",
    "justify-right": "ctrl+r",
    "clear-format": "ctrl+shift+r",
    "ordered-list": "ctrl+shift+o",
    "unordered-list": "ctrl+alt+o",
    "space": "space",
    "enter": "enter",
    "tab": "tab",
    "delete": "delete",
    "format-copy": "alt+shift+c",
    "format-paste": "alt+shift+v",
    "inlinecode": "ctrl+`"
};
var $9dc0015271a44eb1$export$d2efe7aebbebd18a = {
    "toolbar-focus": "alt+f10",
    "escape": "27",
    "insert-link": "ctrl+k",
    "insert-image": "ctrl+shift+i",
    "insert-table": "ctrl+shift+e",
    "undo": "ctrl+z",
    "redo": "ctrl+y",
    "copy": "ctrl+c",
    "cut": "ctrl+x",
    "paste": "ctrl+v",
    "bold": "ctrl+b",
    "italic": "ctrl+i",
    "strikethrough": "ctrl+shift+s",
    "uppercase": "ctrl+shift+u",
    "lowercase": "ctrl+shift+l",
    "superscript": "ctrl+shift+=",
    "subscript": "ctrl+=",
    "full-screen": "ctrl+shift+f",
    "ordered-list": "ctrl+shift+o",
    "unordered-list": "ctrl+alt+o"
};
var $9dc0015271a44eb1$export$5c2f1340ff782edf = {
    "b": [
        "strong"
    ],
    "strong": [
        "b"
    ],
    "i": [
        "emp",
        "cite"
    ],
    "emp": [
        "i",
        "cite"
    ],
    "cite": [
        "i",
        "emp"
    ]
};
var $9dc0015271a44eb1$export$7a0014018b7ea28e = {
    "first": "MsoListParagraphCxSpFirst",
    "middle": "MsoListParagraphCxSpMiddle",
    "last": "MsoListParagraphCxSpLast"
};
var $9dc0015271a44eb1$export$8fb6da1e62ba734b = [
    "BR",
    "IMG"
];
var $9dc0015271a44eb1$export$217aab06593c0153 = {
    topLeft: [
        -1,
        -1
    ],
    topRight: [
        1,
        -1
    ],
    botRight: [
        1,
        1
    ],
    botLeft: [
        -1,
        1
    ]
};
var $9dc0015271a44eb1$export$edf0c42e7cc84b69 = [
    "ArrowUp",
    "ArrowDown",
    "Enter",
    "Tab",
    "Escape"
];



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Utilities to handle the table cell selection
 */ var $b53cb9a305ffcc69$export$d1314ebcfd9d7a36 = /** @class */ function() {
    function TableSelection(root, currentDocument) {
        this.BLOCK_TAGS = [
            "p",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "li",
            "pre",
            "td",
            "th",
            "div",
            "hr",
            "section",
            "figure"
        ];
        this.BASIC_FORMATS = [
            "p",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "pre"
        ];
        this.root = root;
        this.currentDocument = currentDocument;
    }
    /**
     * Get the block nodes from the selected cells.
     *
     * @returns {HTMLTableCellElement[]} - Returns the selected cells
     */ TableSelection.prototype.getBlockNodes = function() {
        var blockNodes = [];
        if ((0, $3EnZW.isNullOrUndefined)(this.root.querySelector(".e-cell-select"))) return blockNodes;
        var currentTable = this.root.querySelector(".e-cell-select").closest("table");
        var cellSelectNode = currentTable.querySelectorAll(".e-cell-select");
        if ((0, $3EnZW.isNullOrUndefined)(cellSelectNode) || cellSelectNode.length < 2) return blockNodes;
        // Generate block nodes
        for(var i = 0; i < cellSelectNode.length; i++)this.addBlockNodes(cellSelectNode[i], blockNodes);
        this.wrapParagraphNodes(blockNodes);
        return blockNodes;
    };
    TableSelection.prototype.addBlockNodes = function(node, blockNodes) {
        var nodes = node.childNodes;
        if (nodes.length === 0) {
            blockNodes.push(node);
            return;
        }
        for(var j = 0; j < nodes.length; j++){
            var currentNode = nodes[j];
            if (blockNodes.indexOf(currentNode.parentElement) >= 0) continue;
            if (currentNode.parentElement && (currentNode.parentElement.nodeName === "TD" || currentNode.parentElement.nodeName === "TH") && currentNode.parentElement.childNodes.length === 1) {
                if (currentNode.nodeName === "BR") blockNodes.push(currentNode.parentElement);
                else if (currentNode.nodeType === Node.TEXT_NODE) blockNodes.push(currentNode.parentElement);
                else blockNodes.push(currentNode.parentElement);
            } else blockNodes.push(currentNode.parentElement);
        }
    };
    /**
     * Get the text nodes from the selected cells
     *
     * @returns {Node[]} - Returns the text nodes
     */ TableSelection.prototype.getTextNodes = function() {
        var textNodes = [];
        if ((0, $3EnZW.isNullOrUndefined)(this.root.querySelector(".e-cell-select"))) return textNodes;
        var currentTable = this.root.querySelector(".e-cell-select").closest("table");
        var cellSelectNode = currentTable.querySelectorAll(".e-cell-select");
        if ((0, $3EnZW.isNullOrUndefined)(cellSelectNode) || cellSelectNode.length < 2) return textNodes;
        // Generate text nodes
        for(var i = 0; i < cellSelectNode.length; i++)this.addTextNodes(cellSelectNode[i], textNodes);
        return textNodes;
    };
    TableSelection.prototype.addTextNodes = function(parent, textNodes) {
        var nodes = parent.childNodes;
        if (nodes.length === 0 && (parent.nodeName === "TD" || parent.nodeName === "TH")) {
            var text = this.currentDocument.createTextNode("\u200B");
            parent.appendChild(text);
            textNodes.push(text);
            return;
        } else if (nodes.length === 1 && (parent.nodeName === "TD" || parent.nodeName === "TH") && nodes[0].nodeName === "BR") {
            var text = this.currentDocument.createTextNode("\u200B");
            parent.insertBefore(text, nodes[0]);
            textNodes.push(text);
            return;
        }
        for(var j = 0; j < nodes.length; j++){
            var currentNode = nodes[j];
            if (currentNode.nodeType === Node.TEXT_NODE) textNodes.push(currentNode);
            else if (currentNode.nodeType === Node.ELEMENT_NODE) // Recursively check all descendants
            this.addTextNodes(currentNode, textNodes);
        }
    };
    TableSelection.prototype.wrapParagraphNodes = function(blockNodes) {
        var blockNodesArry = Array.from(blockNodes);
        for(var i = 0; i < blockNodesArry.length; i++){
            var node = blockNodesArry[i];
            if (node.nodeName === "TD" || node.nodeName === "TH") {
                // Case 1: Simple TD with BR or inline or text nodes
                if (node.childNodes.length === 1 && (node.childNodes[0].nodeName === "BR" || node.childNodes[0].nodeType === Node.TEXT_NODE)) {
                    var childNode = node.childNodes[0];
                    var paragraph = (0, $4ZDHT.createElement)("p");
                    childNode.parentElement.insertBefore(paragraph, childNode);
                    paragraph.appendChild(childNode);
                    var index = blockNodes.indexOf(node);
                    blockNodes[index] = paragraph;
                } else {
                    var newIndex = blockNodes.indexOf(node);
                    this.wrapInlineNodes(node, blockNodes, newIndex);
                }
            }
        }
        for(var i = 0; i < blockNodes.length; i++){
            var currentNode = blockNodes[i];
            if (currentNode.nodeName === "LI" && currentNode.childNodes.length === 1) {
                var firstChild = currentNode.childNodes[0];
                if (firstChild.nodeType === Node.ELEMENT_NODE && this.BASIC_FORMATS.indexOf(firstChild.nodeName.toLocaleLowerCase()) >= 0 && firstChild.textContent === currentNode.textContent) blockNodes[i] = firstChild;
            }
        }
    };
    TableSelection.prototype.wrapInlineNodes = function(node, blockNodes, index) {
        var child = node.childNodes[0];
        var wrapperElement = (0, $4ZDHT.createElement)("p");
        var tempBlockNodes = [];
        if ((0, $3EnZW.isNullOrUndefined)(child)) {
            node.appendChild(wrapperElement);
            tempBlockNodes.push(wrapperElement);
            (0, $259257662ca103fc$export$262596b10371f908)(blockNodes, tempBlockNodes, index);
            return;
        }
        while(child){
            // CASE 1: BR Elements
            if (child.nodeName === "BR") {
                child.parentNode.insertBefore(wrapperElement, child);
                wrapperElement.appendChild(child);
                if (wrapperElement.childNodes.length > 0 && tempBlockNodes.indexOf(wrapperElement) < 0) tempBlockNodes.push(wrapperElement);
                child = wrapperElement.nextSibling;
                wrapperElement = (0, $4ZDHT.createElement)("p");
            } else if (this.BLOCK_TAGS.indexOf(child.nodeName.toLocaleLowerCase()) >= 0) {
                tempBlockNodes.push(child);
                if (wrapperElement.childNodes.length > 0) child = wrapperElement.nextSibling;
                else {
                    // Check if any nested list items are present
                    if (child && child.nodeName === "LI" && child.querySelectorAll("li").length > 0) {
                        var listNodes = child.querySelectorAll("li");
                        for(var i = 0; i < listNodes.length; i++)tempBlockNodes.push(listNodes[i]);
                    }
                    if (child.nodeName === "LI" && (0, $3EnZW.isNullOrUndefined)(child.nextSibling)) child = child.parentElement.nextSibling;
                    else child = child.nextSibling;
                }
            } else if (child.nodeType === Node.TEXT_NODE) {
                // Remove empty text nodes
                if (child.textContent.trim() === "" && child.textContent.indexOf("\u200B") < 0) {
                    var nextSibling = child.nextSibling;
                    (0, $4ZDHT.detach)(child);
                    child = nextSibling;
                    continue;
                }
                child.parentNode.insertBefore(wrapperElement, child);
                var textNode = child;
                wrapperElement.appendChild(textNode);
                if (wrapperElement.childNodes.length > 0 && tempBlockNodes.indexOf(wrapperElement) < 0) tempBlockNodes.push(wrapperElement);
                child = wrapperElement.nextSibling;
            } else if (child.nodeName === "TABLE" || child.nodeName === "UL" || child.nodeName === "OL") {
                if (child.nodeName === "TABLE") {
                    var nestedBlockNodes = [];
                    var cellSelectNode = child.querySelectorAll("td, th");
                    for(var i = 0; i < cellSelectNode.length; i++)this.addBlockNodes(cellSelectNode[i], nestedBlockNodes);
                    this.wrapParagraphNodes(nestedBlockNodes);
                    for(var i = 0; i < nestedBlockNodes.length; i++)tempBlockNodes.push(nestedBlockNodes[i]);
                    child = child.nextSibling;
                } else child = child.firstElementChild;
            } else if (this.BLOCK_TAGS.indexOf(child.nodeName.toLocaleLowerCase()) < 0) {
                child.parentNode.insertBefore(wrapperElement, child);
                wrapperElement.appendChild(child);
                if (wrapperElement.childNodes.length > 0 && tempBlockNodes.indexOf(wrapperElement) < 0) tempBlockNodes.push(wrapperElement);
                child = wrapperElement.nextSibling;
            }
        }
        // Merge the block nodes
        (0, $259257662ca103fc$export$262596b10371f908)(blockNodes, tempBlockNodes, index);
    };
    return TableSelection;
}();


var $885a3ef7b3a774b1$export$d4b62e40c274c281 = {
    startSelection: "e-editor-select-start",
    endSelection: "e-editor-select-end"
};
/**
 * DOMNode internal plugin
 *
 * @hidden

 */ var $885a3ef7b3a774b1$export$913ca0ecb04f4c72 = /** @class */ function() {
    /**
     * Constructor for creating the DOMNode plugin
     *
     * @param {Element} parent - specifies the parent element
     * @param {Document} currentDocument - specifies the current document.
     * @hidden

     */ function DOMNode(parent, currentDocument) {
        this.parent = parent;
        this.nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        this.currentDocument = currentDocument;
        this.tableSelection = new (0, $b53cb9a305ffcc69$export$d1314ebcfd9d7a36)(parent, currentDocument);
    }
    /**
     * contents method
     *
     * @param {Element} element - specifies the element.
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.contents = function(element) {
        return element && "IFRAME" !== element.tagName ? Array.prototype.slice.call(element.childNodes || []) : [];
    };
    /**
     * isBlockNode method
     *
     * @param {Element} element - specifies the node element.
     * @returns {boolean} - sepcifies the boolean value
     * @hidden

     */ DOMNode.prototype.isBlockNode = function(element) {
        return !!element && element.nodeType === Node.ELEMENT_NODE && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(element.tagName.toLowerCase()) >= 0;
    };
    /**
     * isLink method
     *
     * @param {Element} element - specifies the element
     * @returns {boolean} -  specifies the boolean value
     * @hidden

     */ DOMNode.prototype.isLink = function(element) {
        return !!element && element.nodeType === Node.ELEMENT_NODE && "a" === element.tagName.toLowerCase();
    };
    /**
     * blockParentNode method
     *
     * @param {Element} element - specifies the element
     * @returns {Element} - returns the element value
     * @hidden

     */ DOMNode.prototype.blockParentNode = function(element) {
        for(; element && element.parentNode !== this.parent && (!element.parentNode || !this.hasClass(element.parentNode, "e-node-inner"));){
            element = element.parentNode;
            if (this.isBlockNode(element)) return element;
        }
        return element;
    };
    /**
     * rawAttributes method
     *
     * @param {Element} element - specifies the element
     * @returns {string} - returns the string value
     * @hidden

     */ DOMNode.prototype.rawAttributes = function(element) {
        var rawAttr = {};
        var attributes = element.attributes;
        if (attributes.length > 0) for(var d = 0; d < attributes.length; d++){
            var e = attributes[d];
            rawAttr[e.nodeName] = e.value;
        }
        return rawAttr;
    };
    /**
     * attributes method
     *
     * @param {Element} element - sepcifies the element.
     * @returns {string} - returns the string value.
     * @hidden

     */ DOMNode.prototype.attributes = function(element) {
        if (!element) return "";
        var attr = "";
        var rawAttr = this.rawAttributes(element);
        var orderRawAttr = Object.keys(rawAttr).sort();
        for(var e = 0; e < orderRawAttr.length; e++){
            var attrKey = orderRawAttr[e];
            var attrValue = rawAttr["" + attrKey];
            /* eslint-disable */ if (attrValue.indexOf("'") < 0 && attrValue.indexOf('"') >= 0) attr += " " + attrKey + "='" + attrValue + "'";
            else if (attrValue.indexOf('"') >= 0 && attrValue.indexOf("'") >= 0) {
                /* eslint-enable */ attrValue = attrValue.replace(/"/g, "&quot;");
                attr += " " + attrKey + '="' + attrValue + '"';
            } else attr += " " + attrKey + '="' + attrValue + '"';
        }
        return attr;
    };
    /**
     * clearAttributes method
     *
     * @param {Element} element - specifies the element
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.clearAttributes = function(element) {
        for(var attr = element.attributes, c = attr.length - 1; c >= 0; c--){
            var key = attr[c];
            element.removeAttribute(key.nodeName);
        }
    };
    /**
     * openTagString method
     *
     * @param {Element} element - specifies the element.
     * @returns {string} - returns the string
     * @hidden

     */ DOMNode.prototype.openTagString = function(element) {
        return "<" + element.tagName.toLowerCase() + this.attributes(element) + ">";
    };
    /**
     * closeTagString method
     *
     * @param {Element} element - specifies the element
     * @returns {string} - returns the string value
     * @hidden

     */ DOMNode.prototype.closeTagString = function(element) {
        return "</" + element.tagName.toLowerCase() + ">";
    };
    /**
     * createTagString method
     *
     * @param {string} tagName - specifies the tag name
     * @param {Element} relativeElement - specifies the relative element
     * @param {string} innerHTML - specifies the string value
     * @returns {string} - returns the string value.
     * @hidden

     */ DOMNode.prototype.createTagString = function(tagName, relativeElement, innerHTML) {
        return "<" + tagName.toLowerCase() + this.attributes(relativeElement) + ">" + innerHTML + "</" + tagName.toLowerCase() + ">";
    };
    /**
     * isList method
     *
     * @param {Element} element - specifes the element.
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ DOMNode.prototype.isList = function(element) {
        return !!element && [
            "UL",
            "OL"
        ].indexOf(element.tagName) >= 0;
    };
    /**
     * isElement method
     *
     * @param {Element} element - specifes the element.
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ DOMNode.prototype.isElement = function(element) {
        return element === this.parent;
    };
    /**
     * isEditable method
     *
     * @param {Element} element - specifes the element.
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ DOMNode.prototype.isEditable = function(element) {
        return (!element.getAttribute || element.getAttribute("contenteditable") === "true") && [
            "STYLE",
            "SCRIPT"
        ].indexOf(element.tagName) < 0;
    };
    /**
     * hasClass method
     *
     * @param {Element} element - specifes the element.
     * @param {string} className - specifies the class name value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ DOMNode.prototype.hasClass = function(element, className) {
        return element && element.classList && element.classList.contains(className);
    };
    /**
     * replaceWith method
     *
     * @param {Element} element - specifes the element.
     * @param {string} value - specifies the string value
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.replaceWith = function(element, value) {
        var parentNode = element.parentNode;
        parentNode.insertBefore(this.parseHTMLFragment(value), element);
        (0, $4ZDHT.detach)(element);
    };
    /**
     * parseHTMLFragment method
     *
     * @param {string} value - specifies the string value
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.parseHTMLFragment = function(value) {
        /* eslint-disable */ var temp = (0, $4ZDHT.createElement)("template");
        temp.innerHTML = value;
        if (temp.content instanceof DocumentFragment) return temp.content;
        else return document.createRange().createContextualFragment(value);
    /* eslint-enable */ };
    /**
     * wrap method
     *
     * @param {Element} element - specifies the element
     * @param {Element} wrapper - specifies the element.
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.wrap = function(element, wrapper) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper = element.previousSibling;
        wrapper.appendChild(element);
        return wrapper;
    };
    /**
     * insertAfter method
     *
     * @param {Element} newNode - specifies the new node element
     * @param {Element} referenceNode - specifies the referenece node
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.insertAfter = function(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    /**
     * wrapInner method
     *
     * @param {Element} parent - specifies the parent element.
     * @param {Element} wrapper - specifies the wrapper element.
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.wrapInner = function(parent, wrapper) {
        parent.appendChild(wrapper);
        wrapper = parent.querySelector(".e-rte-wrap-inner");
        wrapper.classList.remove("e-rte-wrap-inner");
        if (wrapper.classList.length === 0) wrapper.removeAttribute("class");
        while(parent.firstChild !== wrapper)wrapper.appendChild(parent.firstChild);
        return wrapper;
    };
    /**
     * unWrap method
     *
     * @param {Element} element - specifies the element.
     * @returns {Element} - returns the element.
     * @hidden

     */ DOMNode.prototype.unWrap = function(element) {
        var parent = element.parentNode;
        var unWrapNode = [];
        while(element.firstChild && element.textContent !== " "){
            unWrapNode.push(element.firstChild);
            parent.insertBefore(element.firstChild, element);
        }
        unWrapNode = unWrapNode.length > 0 ? unWrapNode : [
            element.parentNode
        ];
        parent.removeChild(element);
        return unWrapNode;
    };
    /**
     * getSelectedNode method
     *
     * @param {Element} element - specifies the element
     * @param {number} index - specifies the index value.
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.getSelectedNode = function(element, index) {
        if (element.nodeType === Node.ELEMENT_NODE && element.childNodes.length > 0 && element.childNodes[index - 1] && element.childNodes[index - 1].nodeType === Node.ELEMENT_NODE && (element.childNodes[index - 1].classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || element.childNodes[index - 1].classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection))) element = element.childNodes[index - 1];
        else if (element.nodeType === Node.ELEMENT_NODE && element.childNodes.length > 0 && element.childNodes[index]) element = element.childNodes[index];
        if (element.nodeType === Node.TEXT_NODE) element = element.parentNode;
        return element;
    };
    /**
     * nodeFinds method
     *
     * @param {Element} element - specifies the element.
     * @param {Element[]} elements - specifies the array of elements
     * @returns {Element[]} - returnts the array elements
     * @hidden

     */ DOMNode.prototype.nodeFinds = function(element, elements) {
        var existNodes = [];
        for(var i = 0; i < elements.length; i++)if (element.contains(elements[i]) && element !== elements[i]) existNodes.push(elements[i]);
        return existNodes;
    };
    /**
     * isEditorArea method
     *
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ DOMNode.prototype.isEditorArea = function() {
        var range = this.getRangePoint(0);
        var element;
        for(element = range.commonAncestorContainer; element && !this.isElement(element);)element = element.parentNode;
        return !!this.isElement(element);
    };
    /**
     * getRangePoint method
     *
     * @param {number} point - specifies the number value.
     * @returns {Range} - returns the range.
     * @hidden

     */ DOMNode.prototype.getRangePoint = function(point) {
        var selection = this.getSelection();
        var ranges = [];
        if (selection && selection.getRangeAt && selection.rangeCount) {
            ranges = [];
            for(var f = 0; f < selection.rangeCount; f++)ranges.push(selection.getRangeAt(f));
        } else ranges = [
            this.currentDocument.createRange()
        ];
        return "undefined" !== typeof point ? ranges[point] : ranges;
    };
    DOMNode.prototype.getSelection = function() {
        return this.nodeSelection.get(this.currentDocument);
    };
    /**
     * getPreviousNode method
     *
     * @param {Element} element - specifies the element
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.getPreviousNode = function(element) {
        element = element.previousElementSibling;
        for(; element && element.textContent === "\n";)element = element.previousElementSibling;
        return element;
    };
    /**
     * encode method
     *
     * @param {string} value - specifies the string value
     * @returns {string} - specifies the string value
     * @hidden

     */ DOMNode.prototype.encode = function(value) {
        var divNode = document.createElement("div");
        divNode.innerText = value;
        // eslint-disable-next-line
        return divNode.innerHTML.replace(/<br\s*[\/]?>/gi, "\n");
    };
    /**
     * saveMarker method
     *
     * @param {NodeSelection} save - specifies the node selection,
     * @returns {NodeSelection} - returns the value
     * @hidden

     */ DOMNode.prototype.saveMarker = function(save) {
        var start = this.parent.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection);
        var end = this.parent.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection);
        var startTextNode;
        var endTextNode;
        if (this.hasClass(start, $885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) && start.classList.length > 1) {
            var replace = this.createTagString($56b963295b740d00$export$d5f8cd4675f465a5, start, this.encode(start.textContent));
            this.replaceWith(start, replace);
            start = this.parent.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection);
            start.classList.remove($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection);
            startTextNode = start.childNodes[0];
        } else startTextNode = this.unWrap(start)[0];
        if (this.hasClass(end, $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection) && end.classList.length > 1) {
            var replace = this.createTagString($56b963295b740d00$export$d5f8cd4675f465a5, end, this.encode(end.textContent));
            this.replaceWith(end, replace);
            end = this.parent.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection);
            end.classList.remove($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection);
            endTextNode = end.childNodes[0];
        } else endTextNode = end ? this.unWrap(end)[0] : startTextNode;
        save.startContainer = save.getNodeArray(startTextNode, true);
        save.endContainer = save.getNodeArray(endTextNode, false);
        return save;
    };
    DOMNode.prototype.marker = function(className, textContent) {
        return '<span class="' + className + '">' + textContent + "</span>";
    };
    /**
     * setMarker method
     *
     * @param {NodeSelection} save - specifies the node selection.
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.setMarker = function(save) {
        var range = save.range;
        var startChildNodes = range.startContainer.childNodes;
        var isTableStart = startChildNodes.length > 1 && startChildNodes[0].nodeName === "TABLE";
        var isImgOnlySelected = startChildNodes.length > 1 && startChildNodes[0].nodeName === "IMAGE" && range.endOffset === 1 && range.endContainer.nodeName === "#text" && range.endContainer.textContent.length === 0;
        var start = (isTableStart ? (0, $259257662ca103fc$export$ed8d42d2d9cfe830)(startChildNodes[range.startOffset + 1]) : startChildNodes[range.startOffset > 0 ? range.startOffset - 1 : range.startOffset]) || range.startContainer;
        var end = range.endContainer.childNodes[range.endOffset > 0 ? isImgOnlySelected ? range.endOffset : range.endOffset - 1 : range.endOffset] || range.endContainer;
        if (start.nodeType === Node.ELEMENT_NODE && end.nodeType === Node.ELEMENT_NODE && (start.contains(end) || end.contains(start))) {
            var existNode = start.contains(end) ? start : end;
            var isElement = existNode.nodeType !== Node.TEXT_NODE;
            if (isElement) {
                var nodes = [];
                var textNodes = [];
                for(var node = existNode; existNode.contains(node);){
                    if (nodes.indexOf(node) < 0 && node.childNodes && node.childNodes.length) {
                        nodes.push(node);
                        node = node.childNodes[0];
                    } else if (node.nextSibling) node = node.nextSibling;
                    else if (node.parentNode) {
                        node = node.parentNode;
                        nodes.push(node);
                    }
                    if (textNodes.indexOf(node) < 0 && (node.nodeType === Node.TEXT_NODE || $56b963295b740d00$export$5668f6141f812fad.indexOf(node.parentNode.tagName.toLocaleLowerCase()) >= 0 && (node.tagName === "BR" || node.tagName === "IMG"))) textNodes.push(node);
                }
                if (textNodes.length) {
                    start = start.contains(end) ? textNodes[0] : start;
                    end = textNodes[textNodes.length - 1];
                }
            }
        }
        if (start !== end) {
            if (start.nodeType !== Node.TEXT_NODE && (start.tagName === "BR" && $56b963295b740d00$export$5668f6141f812fad.indexOf(start.parentNode.tagName.toLocaleLowerCase()) >= 0 || start.tagName === "IMG")) {
                this.replaceWith(start, this.marker($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection, this.encode(start.textContent)));
                var markerStart = range.startContainer.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection);
                markerStart.appendChild(start);
            } else if (start.nodeType !== 3 && start.nodeName !== "#text" && start.nodeName !== "BR") {
                var marker = this.marker($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection, "");
                (0, $4ZDHT.append)([
                    this.parseHTMLFragment(marker)
                ], start);
            } else this.replaceWith(start, this.marker($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection, this.encode(start.textContent)));
            if (end.nodeType !== Node.TEXT_NODE && end.tagName === "BR" && $56b963295b740d00$export$5668f6141f812fad.indexOf(end.parentNode.tagName.toLocaleLowerCase()) >= 0) {
                this.replaceWith(end, this.marker($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection, this.encode(end.textContent)));
                var markerEnd = range.endContainer.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection);
                markerEnd.appendChild(end);
            } else this.ensureSelfClosingTag(end, $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection, range);
        } else this.ensureSelfClosingTag(start, $885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection, range);
    };
    /**
     * ensureSelfClosingTag method
     *
     * @param {Element} start - specifies the element.
     * @param {string} className - specifes the class name string value
     * @param {Range} range - specifies the range value
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.ensureSelfClosingTag = function(start, className, range) {
        var isTable = false;
        if (start.nodeType === 3) this.replaceWith(start, this.marker(className, this.encode(start.textContent)));
        else if (start.tagName === "BR") {
            this.replaceWith(start, this.marker(className, this.encode(start.textContent)));
            var markerStart = range.startContainer.querySelector("." + className);
            if (markerStart) markerStart.parentElement.appendChild(start);
        } else {
            var tagName = !(0, $3EnZW.isNullOrUndefined)(start.parentElement) ? start.parentElement.tagName.toLocaleLowerCase() : "";
            if (start.tagName === "IMG" && tagName !== "p" && tagName !== "div") {
                var parNode = document.createElement("p");
                start.parentElement.insertBefore(parNode, start);
                parNode.appendChild(start);
                start = parNode.children[0];
            }
            if (start.tagName === "TABLE") {
                isTable = true;
                if (start.textContent === "") {
                    var tdNode = start.querySelectorAll("td");
                    start = tdNode[tdNode.length - 1];
                    start = !(0, $3EnZW.isNullOrUndefined)(start.childNodes[0]) ? start.childNodes[0] : start;
                } else {
                    var lastNode = start.lastChild;
                    while(lastNode.nodeType !== 3 && lastNode.nodeName !== "#text" && lastNode.nodeName !== "BR")lastNode = lastNode.lastChild;
                    start = lastNode;
                }
            }
            for(var i = 0; i < (0, $9dc0015271a44eb1$export$8fb6da1e62ba734b).length; i++)start = start.tagName === (0, $9dc0015271a44eb1$export$8fb6da1e62ba734b)[i] && !isTable ? start.parentNode : start;
            if (start.nodeType === 3 && start.nodeName === "#text") this.replaceWith(start, this.marker(className, this.encode(start.textContent)));
            else if (start.nodeName === "BR") {
                this.replaceWith(start, this.marker($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection, this.encode(start.textContent)));
                var markerEnd = range.endContainer.querySelector("." + $885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection);
                markerEnd.appendChild(start);
            } else {
                var marker = this.marker(className, "");
                (0, $4ZDHT.append)([
                    this.parseHTMLFragment(marker)
                ], start);
            }
        }
    };
    /**
     * createTempNode method
     *
     * @param {Element} element - specifies the element.
     * @returns {Element} - returns the element
     * @hidden

     */ DOMNode.prototype.createTempNode = function(element) {
        var textContent = element.textContent;
        if (element.tagName === "BR") {
            var wrapper = "<" + $56b963295b740d00$export$d5f8cd4675f465a5 + "></" + $56b963295b740d00$export$d5f8cd4675f465a5 + ">";
            var node = element.parentNode;
            if ($56b963295b740d00$export$5668f6141f812fad.indexOf(node.tagName.toLocaleLowerCase()) >= 0) element = this.wrap(element, this.parseHTMLFragment(wrapper));
        } else if (element.nodeType !== Node.TEXT_NODE && (element.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || element.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection)) || textContent.replace(/\n/g, "").replace(/(^ *)|( *$)/g, "").length > 0 || textContent.length && textContent.indexOf("\n") < 0) {
            var wrapper = "<" + $56b963295b740d00$export$d5f8cd4675f465a5 + "></" + $56b963295b740d00$export$d5f8cd4675f465a5 + ">";
            var target = element;
            element = this.wrap(element, this.parseHTMLFragment(wrapper));
            var ignoreBr = target.nodeType === Node.ELEMENT_NODE && target.firstChild && target.firstChild.nodeName === "BR" && (target.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || target.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection));
            if (!ignoreBr && element.nextElementSibling && element.nextElementSibling.tagName === "BR") element.appendChild(element.nextElementSibling);
        }
        return element;
    };
    /**
     * getImageTagInSelection method
     *
     * @returns {void}
     * @hidden

     */ DOMNode.prototype.getImageTagInSelection = function() {
        var selection = this.getSelection();
        if (this.isEditorArea() && selection.rangeCount) return selection.focusNode.querySelectorAll("img");
        return null;
    };
    /**
     * Method to wrap the inline and text node with block node.
     *
     * @param {HTMLElement} node - specifies the element sent to wrap the node around it with block nodes.
     * @param {string} wrapperElement - specifies which block nodes to wrap around.
     * @returns {HTMLElement} - returns the wrapped element.
     * @hidden

     */ DOMNode.prototype.gatherElementsAround = function(node, wrapperElement) {
        var newWrapElem = (0, $4ZDHT.createElement)(wrapperElement);
        // Insert the new div element before the current node.
        var currentNode = node.previousSibling;
        var currentNodeParent = node.parentElement;
        if (currentNodeParent.className === "e-editor-select-start") currentNodeParent.parentNode.insertBefore(newWrapElem, currentNodeParent);
        else if (currentNodeParent) currentNodeParent.insertBefore(newWrapElem, node);
        var i = 0;
        while(currentNode !== null && currentNode.nodeName !== "BR" && !this.isBlockNode(currentNode)){
            var prevSibling = currentNode.previousSibling;
            if (currentNode.nodeType === 3 || currentNode.nodeType === 1) {
                if (i === 0) newWrapElem.appendChild(currentNode);
                else newWrapElem.insertBefore(currentNode, newWrapElem.firstChild);
            }
            currentNode = prevSibling;
            i++;
        }
        // Add the current node to the new div
        newWrapElem.appendChild(node);
        // Gather text and inline elements after the currentNode
        currentNode = newWrapElem.nextSibling ? newWrapElem.nextSibling : newWrapElem.parentElement.nextSibling;
        while(currentNode !== null && currentNode.nodeName !== "BR" && !this.isBlockNode(currentNode)){
            var nextSibling = currentNode.nextSibling ? currentNode.nextSibling : currentNode.parentElement.nextSibling;
            if (currentNode.nodeType === 3 || currentNode.nodeType === 1) newWrapElem.appendChild(currentNode);
            currentNode = nextSibling;
        }
        return newWrapElem;
    };
    /**
     * Method to convert all the inline nodes between the selection to block nodes.
     *
     * @param {Node[]} selectedNodes - specifies the nodes of the start and end selection.
     * @param {boolean} fromList - specifies if the method is called from list module.
     * @returns {Node[]} - returns the selected list of elements as block nodes.
     * @hidden

     */ DOMNode.prototype.convertToBlockNodes = function(selectedNodes, fromList) {
        if (selectedNodes.length > 1) {
            var i = 0;
            var currentSelectedNode = selectedNodes[0];
            while(!(0, $3EnZW.isNullOrUndefined)(currentSelectedNode)){
                if (currentSelectedNode.nodeName === "BR") {
                    var nextNode = currentSelectedNode.nextSibling;
                    (0, $4ZDHT.detach)(currentSelectedNode);
                    currentSelectedNode = nextNode;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(currentSelectedNode)) {
                    if (fromList) selectedNodes[i] = currentSelectedNode.nodeName === "LI" || this.isBlockNode(currentSelectedNode) ? currentSelectedNode : this.gatherElementsAround(currentSelectedNode, fromList ? "p" : "div");
                    else selectedNodes[i] = !this.isBlockNode(selectedNodes[i]) ? this.gatherElementsAround(currentSelectedNode, fromList ? "p" : "div") : selectedNodes[i];
                    var currentProcessNode = selectedNodes[i].nodeName === "LI" ? selectedNodes[i].parentElement : selectedNodes[i];
                    var currentElementCheckNode = currentProcessNode.nodeName === "#text" ? currentProcessNode.parentElement : currentProcessNode;
                    currentSelectedNode = !(0, $3EnZW.isNullOrUndefined)(currentElementCheckNode.querySelector(".e-editor-select-end")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(currentSelectedNode, ".e-editor-select-end")) ? null : currentProcessNode.nextSibling;
                    if (currentSelectedNode === null && !(0, $3EnZW.isNullOrUndefined)(currentProcessNode.nextSibling) && currentProcessNode.nextSibling.nodeName === "BR") (0, $4ZDHT.detach)(currentProcessNode.nextSibling);
                }
                i++;
            }
        } else if (!this.isBlockNode(selectedNodes[0])) {
            selectedNodes[0] = this.gatherElementsAround(selectedNodes[0], fromList ? "p" : "div");
            if (!(0, $3EnZW.isNullOrUndefined)(selectedNodes[0].nextSibling) && selectedNodes[0].nextSibling.nodeName === "BR") (0, $4ZDHT.detach)(selectedNodes[0].nextSibling);
        }
        return selectedNodes;
    };
    /**
     * blockNodes method
     *
     * @param {boolean} action - Optional Boolean that specifies the action is whether performed.
     * @returns {Node[]} - returns the node array values
     * @hidden

     */ DOMNode.prototype.blockNodes = function(action) {
        var collectionNodes = [];
        var selection = this.getSelection();
        if (this.isEditorArea() && selection.rangeCount) {
            var ranges = this.getRangePoint();
            for(var j = 0; j < ranges.length; j++){
                var parentNode = void 0;
                var range = ranges[j];
                var startNode = this.getSelectedNode(range.startContainer, range.startOffset);
                var endNode = this.getSelectedNode(range.endContainer, range.endOffset);
                if (this.isBlockNode(startNode) && collectionNodes.indexOf(startNode) < 0) collectionNodes.push(startNode);
                parentNode = this.blockParentNode(startNode);
                var endParentNode = this.blockParentNode(endNode);
                if (parentNode && collectionNodes.indexOf(parentNode) < 0) {
                    if (!(0, $3EnZW.isNullOrUndefined)(action) && action) {
                        if (range.commonAncestorContainer.nodeName === "TD" || parentNode.nodeName === "TD" || endParentNode.nodeName === "TD") {
                            var processedNodes = this.getPreBlockNodeCollection(range);
                            if (processedNodes.length > 1) this.wrapWithBlockNode(processedNodes, collectionNodes);
                            else if (processedNodes.length > 0) {
                                if (startNode !== endNode && startNode.nodeName !== "BR") collectionNodes.push(this.createTempNode(startNode));
                                else if (startNode === endNode && startNode.nodeName === "SPAN" && (startNode.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || startNode.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection))) collectionNodes.push(this.createTempNode(startNode));
                            }
                        } else collectionNodes.push(parentNode);
                    } else if ($56b963295b740d00$export$5668f6141f812fad.indexOf(parentNode.tagName.toLocaleLowerCase()) >= 0 && (startNode.tagName === "BR" || startNode.nodeType === Node.TEXT_NODE || startNode.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || startNode.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection))) {
                        var tempNode = startNode.previousSibling && startNode.previousSibling.nodeType === Node.TEXT_NODE ? startNode.previousSibling : startNode;
                        if (!startNode.nextSibling && !startNode.previousSibling && startNode.tagName === "BR") collectionNodes.push(tempNode);
                        else collectionNodes.push(this.createTempNode(tempNode));
                    } else collectionNodes.push(parentNode);
                }
                var nodes = [];
                for(var node = startNode; node !== endNode && node !== this.parent;){
                    if (nodes.indexOf(node) < 0 && node.childNodes && node.childNodes.length) {
                        nodes.push(node);
                        node = node.childNodes[0];
                    } else if (node && node.nodeType !== 8 && (node.tagName === "BR" || node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "" || node.nodeType !== Node.TEXT_NODE && (node.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || node.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection))) && $56b963295b740d00$export$5668f6141f812fad.indexOf(node.parentNode.tagName.toLocaleLowerCase()) >= 0) node = this.createTempNode(node);
                    else if (node.nextSibling && node.nextSibling.nodeType !== 8 && (node.nextSibling.tagName === "BR" || node.nextSibling.nodeType === Node.TEXT_NODE || node.nextSibling.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || node.nextSibling.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection)) && $56b963295b740d00$export$5668f6141f812fad.indexOf(node.nextSibling.parentNode.tagName.toLocaleLowerCase()) >= 0) node = this.createTempNode(node.nextSibling);
                    else if (node.nextSibling) node = node.nextSibling;
                    else if (node.parentNode) {
                        node = node.parentNode;
                        nodes.push(node);
                    }
                    if (collectionNodes.indexOf(node) < 0 && node.nodeType === Node.ELEMENT_NODE && $56b963295b740d00$export$5668f6141f812fad.indexOf(node.parentNode.tagName.toLocaleLowerCase()) >= 0 && (node.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.startSelection) || node.classList.contains($885a3ef7b3a774b1$export$d4b62e40c274c281.endSelection))) collectionNodes.push(this.createTempNode(node));
                    if (this.isBlockNode(node) && this.ignoreTableTag(node) && nodes.indexOf(node) < 0 && collectionNodes.indexOf(node) < 0 && (node !== endNode || range.endOffset > 0)) collectionNodes.push(node);
                    if (node.nodeName === "IMG" && node.parentElement.contentEditable === "true") collectionNodes.push(node);
                }
                parentNode = this.blockParentNode(endNode);
                if (parentNode && this.ignoreTableTag(parentNode) && collectionNodes.indexOf(parentNode) < 0 && !(0, $3EnZW.isNullOrUndefined)(parentNode.previousElementSibling) && parentNode.previousElementSibling.tagName !== "IMG") collectionNodes.push(parentNode);
            }
        }
        for(var i = collectionNodes.length - 1; i > 0; i--){
            var nodes = this.nodeFinds(collectionNodes[i], collectionNodes);
            if (nodes.length) {
                var listNodes = collectionNodes[i].querySelectorAll("ul, ol");
                if (collectionNodes[i].tagName === "LI" && listNodes.length > 0) continue;
                else collectionNodes.splice(i, 1);
            }
        }
        var tableBlockNodes = this.tableSelection.getBlockNodes();
        if (tableBlockNodes.length > 0) return tableBlockNodes;
        return collectionNodes;
    };
    DOMNode.prototype.ignoreTableTag = function(element) {
        return !($56b963295b740d00$export$42fa0eda31a41dcc.indexOf(element.tagName.toLocaleLowerCase()) >= 0);
    };
    DOMNode.prototype.getPreBlockNodeCollection = function(range) {
        var startNode = this.getSelectedNode(range.startContainer, range.startOffset);
        var endNode = this.getSelectedNode(range.endContainer, range.endOffset);
        var nodes = [];
        var rootNode = startNode.closest("td, th");
        if ((0, $3EnZW.isNullOrUndefined)(rootNode)) return nodes;
        var rootChildNode = Array.from(rootNode.childNodes);
        var isContinue = true;
        var processedStart = this.getClosestInlineParent(startNode, rootNode, true);
        var processedEnd = this.getClosestInlineParent(endNode, rootNode, false);
        for(var i = 0; i < rootChildNode.length; i++){
            var child = rootChildNode[i];
            if (processedStart === processedEnd && child === processedStart) {
                nodes.push(child);
                isContinue = true;
            } else if (child === processedStart) isContinue = false;
            else if (child === processedEnd) {
                nodes.push(child); // Early Exit so Push the end node.
                isContinue = true;
            }
            if (isContinue) continue;
            else nodes.push(child);
        }
        return nodes;
    };
    DOMNode.prototype.getClosestInlineParent = function(node, rootNode, isStart) {
        // 1. If the node is a text node, return the node
        // 2. If the node is a block node return block node
        // 3. If the node is a inline node,
        //      Traverse back untill the TD or TH node
        //      Check if the the previous sibling , next sibling is a block node.
        //      If yes return the inline node that is closest to the block node.
        if (node.nodeType === Node.TEXT_NODE) return node;
        if (this.isBlockNode(node)) return node;
        var currentNode = node;
        var rootFlag = false;
        while(currentNode){
            var previousNode = currentNode;
            if (rootFlag) {
                if (this.isBlockNode(currentNode)) return previousNode;
                if (isStart && currentNode.previousSibling) {
                    if (this.isBlockNode(currentNode.previousSibling) || currentNode.previousSibling.nodeName === "BR") return previousNode;
                    else currentNode = currentNode.previousSibling;
                } else if (!isStart && currentNode.nextSibling) {
                    if (this.isBlockNode(currentNode.nextSibling) || currentNode.nextSibling.nodeName === "BR") return previousNode;
                    else currentNode = currentNode.nextSibling;
                } else return currentNode;
            } else {
                currentNode = currentNode.parentElement;
                if (currentNode === rootNode) {
                    currentNode = previousNode;
                    rootFlag = true;
                }
            }
        }
        return null;
    };
    DOMNode.prototype.wrapWithBlockNode = function(nodes, collectionNodes) {
        var wrapperElement = (0, $4ZDHT.createElement)("p");
        for(var i = 0; i < nodes.length; i++){
            var child = nodes[i];
            if (child.nodeName === "BR") {
                child.parentNode.insertBefore(wrapperElement, child);
                wrapperElement.appendChild(child);
                if (wrapperElement.childNodes.length > 0) collectionNodes.push(wrapperElement);
                wrapperElement = (0, $4ZDHT.createElement)("p");
            } else {
                if (!this.isBlockNode(child)) {
                    if (child.nodeName === "#text" && child.textContent.trim() === "") continue;
                    if (wrapperElement.childElementCount === 0) {
                        child.parentNode.insertBefore(wrapperElement, child);
                        wrapperElement.appendChild(child);
                    } else wrapperElement.appendChild(child);
                } else collectionNodes.push(child);
                // Use case when the BR is next sibling but the BR is not the part of selection.
                if (i === nodes.length - 1 && wrapperElement.nextElementSibling && wrapperElement.querySelectorAll("br").length === 0 && wrapperElement.nextElementSibling.nodeName === "BR") wrapperElement.appendChild(wrapperElement.nextElementSibling);
            }
        }
        if (wrapperElement.childNodes.length > 0 && collectionNodes.indexOf(wrapperElement) < 0) collectionNodes.push(wrapperElement);
    };
    return DOMNode;
}();




/**
 * Lists internal component
 *
 * @hidden

 */ var $4054e52afc0effaa$export$e1553435d4022be = /** @class */ function() {
    /**
     * Constructor for creating the Lists plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function Lists(parent) {
        this.parent = parent;
        this.domNode = this.parent.domNode;
        this.addEventListener();
    }
    Lists.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$22c50a44ec8aa5dd, this.applyListsHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.onKeyUp, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$22b6648d4944f9ee, this.spaceKeyAction, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    Lists.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$22c50a44ec8aa5dd, this.applyListsHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.onKeyUp);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$22b6648d4944f9ee, this.spaceKeyAction);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    Lists.prototype.testList = function(elem) {
        var olListRegex = [
            /^[\d]+[.]+$/,
            /^(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})[.]$/gi,
            /^[a-zA-Z][.]+$/
        ];
        var elementStart = !(0, $3EnZW.isNullOrUndefined)(elem) ? elem.innerText.trim().split(".")[0] + "." : null;
        if (!(0, $3EnZW.isNullOrUndefined)(elementStart)) for(var i = 0; i < olListRegex.length; i++){
            if (olListRegex[i].test(elementStart)) return true;
        }
        return false;
    };
    Lists.prototype.testCurrentList = function(range) {
        var olListStartRegex = [
            /^[1]+[.]+$/,
            /^[i]+[.]+$/,
            /^[a]+[.]+$/
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(range.startContainer.textContent.slice(0, range.startOffset))) {
            var currentContent = range.startContainer.textContent.replace(/\u200B/g, "").slice(0, range.startOffset).trim();
            for(var i = 0; i < olListStartRegex.length; i++){
                if (olListStartRegex[i].test(currentContent) && currentContent.length === 2) return true;
            }
        }
        return false;
    };
    Lists.prototype.spaceList = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        // eslint-disable-next-line
        var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        var preElement = startNode.previousElementSibling;
        var nextElement = startNode.nextElementSibling;
        var preElemULStart = !(0, $3EnZW.isNullOrUndefined)(preElement) ? preElement.innerText.trim().substring(0, 1) : null;
        var nextElemULStart = !(0, $3EnZW.isNullOrUndefined)(nextElement) ? nextElement.innerText.trim().substring(0, 1) : null;
        var startElementOLTest = this.testCurrentList(range);
        var preElementOLTest = this.testList(preElement);
        var nextElementOLTest = this.testList(nextElement);
        if (!preElementOLTest && !nextElementOLTest && preElemULStart !== "*" && nextElemULStart !== "*") {
            var brElement = (0, $4ZDHT.createElement)("br");
            if (startElementOLTest) {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === "#text" && range.startContainer.textContent.length === 0) this.parent.domNode.insertAfter(brElement, range.startContainer);
                this.applyListsHandler({
                    subCommand: "OL",
                    callBack: e.callBack
                });
                e.event.preventDefault();
            } else if (range.startContainer.textContent.replace(/\u200B/g, "").slice(0, range.startOffset).trim() === "*" || range.startContainer.textContent.replace(/\u200B/g, "").slice(0, range.startOffset).trim() === "-") {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === "#text" && range.startContainer.textContent.length === 0) this.parent.domNode.insertAfter(brElement, range.startContainer);
                this.applyListsHandler({
                    subCommand: "UL",
                    callBack: e.callBack
                });
                e.event.preventDefault();
            }
        }
    };
    Lists.prototype.enterList = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var startNode = range.startContainer.nodeName === "LI" ? range.startContainer : range.startContainer.parentElement.closest("LI");
        var endNode = range.endContainer.nodeName === "LI" ? range.endContainer : range.endContainer.parentElement.closest("LI");
        // Checks for Image, Audio , Video Element inside List Element
        var hasMediaElem = false;
        if (!(0, $3EnZW.isNullOrUndefined)(startNode)) {
            var videoElemList = startNode.querySelectorAll(".e-video-clickelem");
            var embedVideoElem = videoElemList.length > 0 && videoElemList[0].childNodes[0].nodeName === "IFRAME";
            hasMediaElem = startNode.querySelectorAll("IMG").length > 0 || startNode.querySelectorAll("AUDIO").length > 0 || startNode.querySelectorAll("VIDEO").length > 0 || embedVideoElem;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(startNode) && !(0, $3EnZW.isNullOrUndefined)(endNode) && startNode === endNode && startNode.tagName === "LI" && startNode.textContent.trim() === "" && !hasMediaElem) {
            if (startNode.innerHTML.indexOf("&nbsp;") >= 0) return;
            if (startNode.textContent.charCodeAt(0) === 65279) startNode.textContent = "";
            var startNodeParent = startNode.parentElement;
            var parentOfCurrentOLUL = startNodeParent.parentElement;
            if ((0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL.closest("UL")) && (0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL.closest("OL"))) {
                if (!(0, $3EnZW.isNullOrUndefined)(startNode.nextElementSibling)) {
                    var nearBlockNode = this.parent.domNode.blockParentNode(startNode);
                    this.parent.nodeCutter.GetSpliceNode(range, nearBlockNode);
                }
                var insertTag = void 0;
                if (e.enterAction === "DIV") {
                    insertTag = (0, $4ZDHT.createElement)("div");
                    insertTag.innerHTML = "<br>";
                } else if (e.enterAction === "P") {
                    insertTag = (0, $4ZDHT.createElement)("p");
                    insertTag.innerHTML = "<br>";
                } else insertTag = (0, $4ZDHT.createElement)("br");
                if (!(0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL) && parentOfCurrentOLUL.nodeName === "BLOCKQUOTE") this.parent.observer.notify("blockquote_list_handled", {});
                this.parent.domNode.insertAfter(insertTag, startNodeParent);
                e.event.preventDefault();
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, insertTag, 0);
                if (startNodeParent.textContent === "" && startNodeParent.querySelectorAll("audio,video").length === 0) (0, $4ZDHT.detach)(startNodeParent);
                else (0, $4ZDHT.detach)(startNode);
            }
            // To handle the nested enter key press in the list for the first LI element
            if (!(0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL) && (!(0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL.closest("UL")) || !(0, $3EnZW.isNullOrUndefined)(parentOfCurrentOLUL.closest("OL"))) && parentOfCurrentOLUL.nodeName === "LI" && parentOfCurrentOLUL.style.listStyleType === "none" && parentOfCurrentOLUL.textContent === "" && startNode.textContent === "" && startNode === startNodeParent.firstElementChild && (0, $3EnZW.isNullOrUndefined)(startNode.nextSibling)) {
                (0, $4ZDHT.detach)(startNodeParent);
                parentOfCurrentOLUL.style.removeProperty("list-style-type");
                e.event.preventDefault();
            }
        }
    };
    Lists.prototype.backspaceList = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        startNode = startNode.nodeName === "BR" ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === "BR" ? endNode.parentElement : endNode;
        if (startNode === endNode && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(startNode, "li")) && (startNode.textContent.trim() === "" && startNode.textContent.charCodeAt(0) === 65279 || startNode.textContent.length === 1 && startNode.textContent.charCodeAt(0) === 8203)) startNode.textContent = "";
        if (startNode === endNode && startNode.tagName === "LI" && startNode.textContent.length === 0 && (0, $3EnZW.isNullOrUndefined)(startNode.previousElementSibling)) startNode.removeAttribute("style");
        if (startNode === endNode && startNode.textContent === "") {
            if (startNode.parentElement.tagName === "LI" && endNode.parentElement.tagName === "LI") (0, $4ZDHT.detach)(startNode);
            else if (startNode.closest("ul") || startNode.closest("ol")) {
                var parentList = !(0, $3EnZW.isNullOrUndefined)(startNode.closest("ul")) ? startNode.closest("ul") : startNode.closest("ol");
                if (parentList.firstElementChild === startNode && !(0, $3EnZW.isNullOrUndefined)(parentList.children[1]) && (parentList.children[1].tagName === "OL" || parentList.children[1].tagName === "UL")) {
                    if (parentList.tagName === parentList.children[1].tagName) {
                        while(parentList.children[1].lastChild)this.parent.domNode.insertAfter(parentList.children[1].lastChild, parentList.children[1]);
                        (0, $4ZDHT.detach)(parentList.children[1]);
                    } else parentList.parentElement.insertBefore(parentList.children[1], parentList);
                }
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(startNode.firstChild) && startNode.firstChild.nodeName === "BR" && !(0, $3EnZW.isNullOrUndefined)(startNode.childNodes[1]) && (startNode.childNodes[1].nodeName === "UL" || startNode.childNodes[1].nodeName === "OL")) {
            var parentList = !(0, $3EnZW.isNullOrUndefined)(startNode.closest("ul")) ? startNode.closest("ul") : startNode.closest("ol");
            if (parentList.tagName === startNode.childNodes[1].nodeName) {
                while(startNode.childNodes[1].lastChild)this.parent.domNode.insertAfter(startNode.children[1].lastChild, startNode);
                (0, $4ZDHT.detach)(startNode.childNodes[1]);
            } else parentList.parentElement.insertBefore(startNode.children[1], parentList);
        }
        this.removeList(range, e);
        this.firstListBackSpace(range, e);
    };
    Lists.prototype.removeList = function(range, e) {
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        var endNode = !(0, $3EnZW.isNullOrUndefined)(range.endContainer.parentElement.closest("li")) && range.endContainer.parentElement.closest("li").childElementCount > 1 && range.endContainer.nodeName === "#text" ? range.endContainer : this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        var parentList = range.startContainer.nodeName === "#text" ? range.startContainer.parentElement.closest("li") : range.startContainer.closest("li");
        var fullContent = "";
        if (!(0, $3EnZW.isNullOrUndefined)(parentList) && !(0, $3EnZW.isNullOrUndefined)(parentList.firstChild)) parentList.childNodes.forEach(function(e) {
            fullContent = fullContent + e.textContent;
        });
        startNode = startNode.nodeName === "BR" ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === "BR" ? endNode.parentElement : endNode;
        startNode = startNode.nodeName !== "LI" && !(0, $3EnZW.isNullOrUndefined)(startNode.closest("LI")) ? startNode.closest("LI") : startNode;
        endNode = endNode.nodeName !== "LI" && endNode.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(endNode.closest("LI")) ? endNode.closest("LI") : endNode;
        if ((range.commonAncestorContainer.nodeName === "OL" || range.commonAncestorContainer.nodeName === "UL" || range.commonAncestorContainer.nodeName === "LI") && (0, $3EnZW.isNullOrUndefined)(endNode.nextElementSibling) && endNode.textContent.length === range.endOffset && (0, $3EnZW.isNullOrUndefined)(startNode.previousElementSibling) && range.startOffset === 0 || (0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement && range.startOffset === 0 && range.endOffset === 1) {
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1) (0, $4ZDHT.detach)(range.commonAncestorContainer.childNodes[0]);
            else if (range.commonAncestorContainer.nodeName === "LI") (0, $4ZDHT.detach)(range.commonAncestorContainer.parentElement);
            else (0, $4ZDHT.detach)(range.commonAncestorContainer);
            e.event.preventDefault();
        } else if (!(0, $3EnZW.isNullOrUndefined)(parentList) && !range.collapsed && parentList.textContent === fullContent) {
            range.deleteContents();
            this.parent.editableElement.querySelectorAll("li").forEach(function(li) {
                if (!li.firstChild || li.textContent.trim() === "") li.parentNode.removeChild(li);
            });
            this.parent.editableElement.querySelectorAll("ol").forEach(function(ol) {
                if (!ol.firstChild || ol.textContent.trim() === "") ol.parentNode.removeChild(ol);
            });
            this.parent.editableElement.querySelectorAll("ul").forEach(function(ul) {
                if (!ul.firstChild || ul.textContent.trim() === "") ul.parentNode.removeChild(ul);
            });
            e.event.preventDefault();
        }
    };
    Lists.prototype.onKeyUp = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.commonLIParent) && !(0, $3EnZW.isNullOrUndefined)(this.commonLIParent.querySelector(".removeList"))) {
            var currentLIElem = this.commonLIParent.querySelector(".removeList");
            while(!(0, $3EnZW.isNullOrUndefined)(currentLIElem.firstChild))this.parent.domNode.insertAfter(currentLIElem.firstChild, currentLIElem);
            (0, $4ZDHT.detach)(currentLIElem);
        }
        if (e.event.keyCode === 13) {
            var listElements = this.parent.editableElement.querySelectorAll("UL, OL");
            for(var i = 0; i < listElements.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(listElements[i]) && !(0, $3EnZW.isNullOrUndefined)(listElements[i].parentElement) && !(0, $3EnZW.isNullOrUndefined)(listElements[i].previousElementSibling) && (listElements[i].parentElement.nodeName === "UL" || listElements[i].parentElement.nodeName === "OL")) listElements[i].previousElementSibling.appendChild(listElements[i]);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Lists.prototype.firstListBackSpace = function(range, _e) {
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        if (!(0, $3EnZW.isNullOrUndefined)(startNode.closest("OL"))) this.commonLIParent = startNode.closest("OL");
        else if (!(0, $3EnZW.isNullOrUndefined)(startNode.closest("UL"))) this.commonLIParent = startNode.closest("UL");
        if (startNode.nodeName === "LI" && range.startOffset === 0 && range.endOffset === 0 && (0, $3EnZW.isNullOrUndefined)(startNode.previousSibling) && !(0, $3EnZW.isNullOrUndefined)(this.commonLIParent) && (0, $3EnZW.isNullOrUndefined)(this.commonLIParent.previousSibling) && (0, $3EnZW.isNullOrUndefined)(this.commonLIParent.parentElement.closest("OL")) && (0, $3EnZW.isNullOrUndefined)(this.commonLIParent.parentElement.closest("UL")) && (0, $3EnZW.isNullOrUndefined)(this.commonLIParent.parentElement.closest("LI"))) {
            var currentElem = (0, $4ZDHT.createElement)("P");
            currentElem.innerHTML = "&#8203;";
            startNode.classList.add("removeList");
            this.commonLIParent.parentElement.insertBefore(currentElem, this.commonLIParent);
        }
    };
    Lists.prototype.keyDownHandler = function(e) {
        if (e.event.which === 13) this.enterList(e);
        if (e.event.which === 32) this.spaceList(e);
        if (e.event.which === 8) this.backspaceList(e);
        if (e.event.which === 46 && e.event.action === "delete" || e.event.which === 88 && e.event.action === "cut") {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            var commonAncestor = range.commonAncestorContainer;
            var startEle = range.startContainer;
            var endEle = range.endContainer;
            var startNode = startEle.nodeType === 3 ? this.domNode.blockParentNode(startEle) : startEle;
            var endNode = endEle.nodeType === 3 ? this.domNode.blockParentNode(endEle) : endEle;
            if ((commonAncestor.nodeName === "UL" || commonAncestor.nodeName === "OL") && startNode !== endNode && (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(startNode, "ul")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(startNode, "ol"))) && (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(endNode, "ul")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(endNode, "ol"))) && commonAncestor.lastElementChild === (0, $4ZDHT.closest)(endNode, "li") && commonAncestor.lastChild !== endNode && !range.collapsed) {
                if (this.areAllListItemsSelected(commonAncestor, range)) (0, $4ZDHT.detach)(commonAncestor);
            }
            this.removeList(range, e);
        }
        if (e.event.which === 9) {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            if (!(e.event.action && e.event.action === "indent")) this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            var blockNodes = void 0;
            var startOffset = range.startOffset;
            var endOffset = range.endOffset;
            var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
            var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
            if (startNode === endNode && (startNode.nodeName === "BR" || startNode.nodeName === "#text") && $56b963295b740d00$export$5668f6141f812fad.indexOf(startNode.parentNode.tagName.toLocaleLowerCase()) >= 0) return;
            else {
                if (!(e.event.action && e.event.action === "indent")) this.domNode.setMarker(this.saveSelection);
                blockNodes = this.domNode.blockNodes();
            }
            var nodes = [];
            var isNested = true;
            for(var i = 0; i < blockNodes.length; i++){
                if (blockNodes[i].parentNode.tagName === "LI") nodes.push(blockNodes[i].parentNode);
                else if (blockNodes[i].tagName === "LI" && blockNodes[i].childNodes[0].tagName !== "P" && blockNodes[i].childNodes[0].tagName !== "OL" && blockNodes[i].childNodes[0].tagName !== "UL") nodes.push(blockNodes[i]);
            }
            if (nodes.length > 1 || nodes.length === 1) {
                e.event.preventDefault();
                e.event.stopPropagation();
                this.currentAction = this.getAction(nodes[0]);
                if (e.event.shiftKey) {
                    this.revertList(nodes, e);
                    this.revertClean();
                } else isNested = this.nestedList(nodes);
                if (isNested) {
                    this.cleanNode();
                    this.parent.editableElement.focus({
                        preventScroll: true
                    });
                }
                if (!(e.event.action && e.event.action === "indent")) {
                    this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                    this.saveSelection.restore();
                    if (e.callBack) e.callBack({
                        requestType: this.currentAction,
                        editorMode: "HTML",
                        range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                        elements: this.parent.domNode.blockNodes(),
                        event: e.event
                    });
                }
            } else if (!(e.event.action && e.event.action === "indent")) {
                if (e.event && e.event.shiftKey && e.event.key === "Tab") e.event.action = "tab";
                this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                this.saveSelection.restore();
            }
        } else switch(e.event.action){
            case "ordered-list":
                this.applyListsHandler({
                    subCommand: "OL",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "unordered-list":
                this.applyListsHandler({
                    subCommand: "UL",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
        }
    };
    Lists.prototype.spaceKeyAction = function(e) {
        if (e.event.which === 32) this.spaceList(e);
    };
    Lists.prototype.getAction = function(element) {
        var parentNode = element.parentNode;
        return parentNode.nodeName === "OL" ? "OL" : "UL";
    };
    Lists.prototype.revertClean = function() {
        var collectionNodes = this.parent.editableElement.querySelectorAll("ul, ol");
        for(var i = 0; i < collectionNodes.length; i++){
            var listNodes = collectionNodes[i].querySelectorAll("ul, ol");
            if (listNodes.length > 0) for(var j = 0; j < listNodes.length; j++){
                var prevSibling = listNodes[j].previousSibling;
                if (prevSibling && prevSibling.tagName === "LI") prevSibling.appendChild(listNodes[j]);
            }
        }
    };
    Lists.prototype.noPreviousElement = function(elements) {
        var firstNode;
        var firstNodeOL;
        var siblingListOL = elements.querySelectorAll("ol, ul");
        var siblingListLI = elements.querySelectorAll("li");
        var siblingListLIFirst = this.domNode.contents(siblingListLI[0])[0];
        if (siblingListLI.length > 0 && (siblingListLIFirst.nodeName === "OL" || siblingListLIFirst.nodeName === "UL")) firstNode = siblingListLI[0];
        else firstNodeOL = siblingListOL[0];
        if (firstNode) for(var h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h);){
            var nextSibling = h.nextSibling;
            (0, $4ZDHT.prepend)([
                h
            ], firstNode);
            (0, $4ZDHT.setStyleAttribute)(elements, {
                "list-style-type": "none"
            });
            (0, $4ZDHT.setStyleAttribute)(firstNode, {
                "list-style-type": ""
            });
            h = nextSibling;
        }
        else if (firstNodeOL) {
            var nestedElement = (0, $4ZDHT.createElement)("li");
            (0, $4ZDHT.prepend)([
                nestedElement
            ], firstNodeOL);
            for(var h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h);){
                var nextSibling = h.nextSibling;
                nestedElement.appendChild(h);
                h = nextSibling;
            }
            (0, $4ZDHT.prepend)([
                firstNodeOL
            ], elements.parentNode);
            (0, $4ZDHT.detach)(elements);
            var nestedElementLI = (0, $4ZDHT.createElement)("li", {
                styles: "list-style-type: none;"
            });
            (0, $4ZDHT.prepend)([
                nestedElementLI
            ], firstNodeOL.parentNode);
            (0, $4ZDHT.append)([
                firstNodeOL
            ], nestedElementLI);
        } else {
            var nestedElementLI = (0, $4ZDHT.createElement)("li", {
                styles: "list-style-type: none;"
            });
            (0, $4ZDHT.prepend)([
                nestedElementLI
            ], elements.parentNode);
            var nestedElement = (0, $4ZDHT.createElement)(elements.parentNode.tagName);
            (0, $4ZDHT.prepend)([
                nestedElement
            ], nestedElementLI);
            (0, $4ZDHT.append)([
                elements
            ], nestedElement);
        }
    };
    Lists.prototype.nestedList = function(elements) {
        var isNested = false;
        for(var i = 0; i < elements.length; i++){
            var prevSibling = this.domNode.getPreviousNode(elements[i]);
            if (prevSibling) {
                isNested = true;
                var firstNode = void 0;
                var firstNodeLI = void 0;
                var siblingListOL = elements[i].querySelectorAll("ol, ul");
                var siblingListLI = elements[i].querySelectorAll("li");
                var siblingListLIFirst = this.domNode.contents(siblingListLI[0])[0];
                if (siblingListLI.length > 0 && (siblingListLIFirst.nodeName === "OL" || siblingListLIFirst.nodeName === "UL")) firstNodeLI = siblingListLI[0];
                else firstNode = siblingListOL[0];
                if (firstNode) {
                    var nestedElement = (0, $4ZDHT.createElement)("li");
                    (0, $4ZDHT.prepend)([
                        nestedElement
                    ], firstNode);
                    for(var h = this.domNode.contents(elements[i])[0]; h && !this.domNode.isList(h);){
                        var nextSibling = h.nextSibling;
                        nestedElement.appendChild(h);
                        h = nextSibling;
                    }
                    (0, $4ZDHT.append)([
                        firstNode
                    ], prevSibling);
                    (0, $4ZDHT.detach)(elements[i]);
                } else if (firstNodeLI) {
                    if (prevSibling.tagName === "LI") {
                        for(var h = this.domNode.contents(elements[i])[0]; h && !this.domNode.isList(h);){
                            var nextSibling = h.nextSibling;
                            (0, $4ZDHT.prepend)([
                                h
                            ], firstNodeLI);
                            (0, $4ZDHT.setStyleAttribute)(elements[i], {
                                "list-style-type": "none"
                            });
                            (0, $4ZDHT.setStyleAttribute)(firstNodeLI, {
                                "list-style-type": ""
                            });
                            h = nextSibling;
                        }
                        (0, $4ZDHT.append)([
                            firstNodeLI.parentNode
                        ], prevSibling);
                        (0, $4ZDHT.detach)(elements[i]);
                    }
                } else {
                    if (prevSibling.tagName === "LI") {
                        var nestedElement = (0, $4ZDHT.createElement)(elements[i].parentNode.tagName);
                        nestedElement.style.listStyleType = elements[i].parentNode.style.listStyleType;
                        (0, $4ZDHT.append)([
                            nestedElement
                        ], prevSibling);
                        (0, $4ZDHT.append)([
                            elements[i]
                        ], nestedElement);
                    } else if (prevSibling.tagName === "OL" || prevSibling.tagName === "UL") (0, $4ZDHT.append)([
                        elements[i]
                    ], prevSibling);
                }
            } else {
                var element = elements[i];
                isNested = true;
                this.noPreviousElement(element);
            }
        }
        return isNested;
    };
    Lists.prototype.applyListsHandler = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement) {
            var startChildNodes = range.startContainer.childNodes;
            var startNode = startChildNodes[range.startOffset > 0 ? range.startOffset - 1 : range.startOffset] || range.startContainer;
            var endNode = range.endContainer.childNodes[range.endOffset > 0 ? range.endOffset - 1 : range.endOffset] || range.endContainer;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var lastSelectionNode = endNode.lastChild.nodeName === "BR" ? (0, $3EnZW.isNullOrUndefined)(endNode.lastChild.previousSibling) ? endNode : endNode.lastChild.previousSibling : endNode.lastChild;
            while(!(0, $3EnZW.isNullOrUndefined)(lastSelectionNode) && lastSelectionNode.nodeName !== "#text" && lastSelectionNode.nodeName !== "IMG" && lastSelectionNode.nodeName !== "BR" && lastSelectionNode.nodeName !== "HR")lastSelectionNode = lastSelectionNode.lastChild;
            this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startNode, lastSelectionNode, 0, lastSelectionNode.textContent.length);
            range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        }
        if (range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement && range.startOffset === range.endOffset && range.startOffset === 0 && this.parent.editableElement.textContent.length === 0 && this.parent.editableElement.childNodes[0].nodeName !== "TABLE" && this.parent.editableElement.childNodes[0].nodeName !== "IMG") {
            var focusNode = range.startContainer.childNodes[0];
            this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, focusNode, focusNode, 0, 0);
            range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        }
        this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        this.currentAction = e.subCommand;
        this.currentAction = e.subCommand = this.currentAction === "NumberFormatList" ? "OL" : this.currentAction === "BulletFormatList" ? "UL" : this.currentAction;
        this.domNode.setMarker(this.saveSelection);
        var listsNodes = this.domNode.blockNodes(true);
        if (e.enterAction === "BR") {
            this.setSelectionBRConfig();
            this.parent.domNode.convertToBlockNodes(this.parent.domNode.blockNodes(), true);
            this.setSelectionBRConfig();
            listsNodes = this.parent.domNode.blockNodes();
        }
        for(var i = 0; i < listsNodes.length; i++){
            if (listsNodes[i].tagName === "TABLE" && !range.collapsed) listsNodes.splice(i, 1);
            if (listsNodes.length > 0 && listsNodes[i].tagName !== "LI" && "LI" === listsNodes[i].parentNode.tagName) listsNodes[i] = listsNodes[i].parentNode;
        }
        this.applyLists(listsNodes, this.currentAction, e.selector, e.item, e);
        if (e.callBack) e.callBack({
            requestType: this.currentAction,
            event: e.event,
            editorMode: "HTML",
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.domNode.blockNodes()
        });
    };
    Lists.prototype.setSelectionBRConfig = function() {
        var startElem = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).startSelection);
        var endElem = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).endSelection);
        if ((0, $3EnZW.isNullOrUndefined)(endElem)) this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, startElem, 0);
        else this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startElem, endElem, 0, 0);
    };
    Lists.prototype.applyLists = function(elements, type, selector, item, e) {
        var isReverse = true;
        if (this.isRevert(elements, type, item) && (0, $3EnZW.isNullOrUndefined)(item)) {
            this.revertList(elements, e);
            this.removeEmptyListElements();
        } else {
            this.checkLists(elements, type, item);
            var marginLeftAttribute = "";
            if (elements[0].style.marginLeft !== "") marginLeftAttribute = ' style = "margin-left: ' + elements[0].style.marginLeft + ';"';
            for(var i = 0; i < elements.length; i++){
                if (!(0, $3EnZW.isNullOrUndefined)(item) && !(0, $3EnZW.isNullOrUndefined)(item.listStyle)) {
                    if (item.listStyle === "listImage") (0, $4ZDHT.setStyleAttribute)(elements[i], {
                        "list-style-image": item.listImage
                    });
                    else {
                        (0, $4ZDHT.setStyleAttribute)(elements[i], {
                            "list-style-image": "none"
                        });
                        (0, $4ZDHT.setStyleAttribute)(elements[i], {
                            "list-style-type": item.listStyle.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
                        });
                    }
                }
                elements[i].style.removeProperty("margin-left");
                var elemAtt = elements[i].tagName === "IMG" || elements[i].classList.contains("e-editor-select-start") ? "" : this.domNode.attributes(elements[i]);
                if (elements[i].getAttribute("contenteditable") === "true" && elements[i].childNodes.length === 1 && elements[i].childNodes[0].nodeName === "TABLE") {
                    var listEle = document.createElement(type);
                    listEle.innerHTML = "<li><br/></li>";
                    elements[i].appendChild(listEle);
                } else if ("LI" !== elements[i].tagName && (0, $3EnZW.isNullOrUndefined)(item) && elements[i].nodeName === "BLOCKQUOTE") {
                    isReverse = false;
                    var openTag = "<" + type + marginLeftAttribute + ">";
                    var closeTag = "</" + type + ">";
                    var newTag = "li" + elemAtt;
                    var replaceHTML = elements[i].innerHTML;
                    var innerHTML = this.domNode.createTagString(newTag, null, replaceHTML);
                    var collectionString = openTag + innerHTML + closeTag;
                    elements[i].innerHTML = collectionString;
                } else if ("LI" !== elements[i].tagName && (0, $3EnZW.isNullOrUndefined)(item)) {
                    isReverse = false;
                    var openTag = "<" + type + marginLeftAttribute + ">";
                    var closeTag = "</" + type + ">";
                    var newTag = "li" + elemAtt;
                    var replaceHTML = elements[i].tagName.toLowerCase() === $56b963295b740d00$export$d5f8cd4675f465a5 ? elements[i].innerHTML : elements[i].outerHTML;
                    var innerHTML = this.domNode.createTagString(newTag, null, replaceHTML);
                    var collectionString = openTag + innerHTML + closeTag;
                    this.domNode.replaceWith(elements[i], collectionString);
                } else if (!(0, $3EnZW.isNullOrUndefined)(item) && "LI" !== elements[i].tagName) {
                    // eslint-disable-next-line
                    isReverse = false;
                    var currentElemAtt = elements[i].tagName === "IMG" ? "" : this.domNode.attributes(elements[i]);
                    var openTag = "<" + type + currentElemAtt + ">";
                    var closeTag = "</" + type + ">";
                    var newTag = "li";
                    var replaceHTML = elements[i].tagName.toLowerCase() === $56b963295b740d00$export$d5f8cd4675f465a5 ? elements[i].innerHTML : elements[i].outerHTML;
                    var innerHTML = this.domNode.createTagString(newTag, null, replaceHTML);
                    var collectionString = openTag + innerHTML + closeTag;
                    this.domNode.replaceWith(elements[i], collectionString);
                }
            }
        }
        this.cleanNode();
        if (e.enterAction === "BR") {
            var spansToRemove = document.querySelectorAll("span#removeSpan");
            spansToRemove.forEach(function(span) {
                var fragment = document.createDocumentFragment();
                while(span.firstChild)fragment.appendChild(span.firstChild);
                span.parentNode.replaceChild(fragment, span);
            });
        }
        this.parent.editableElement.focus({
            preventScroll: true
        });
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(this.parent.editableElement, selector);
        this.saveSelection = this.domNode.saveMarker(this.saveSelection);
        this.saveSelection.restore();
    };
    Lists.prototype.removeEmptyListElements = function() {
        var listElem = this.parent.editableElement.querySelectorAll("ol, ul");
        for(var i = 0; i < listElem.length; i++)if (listElem[i].textContent.trim() === "") (0, $4ZDHT.detach)(listElem[i]);
    };
    Lists.prototype.isRevert = function(nodes, tagName, item) {
        var isRevert = true;
        for(var i = 0; i < nodes.length; i++){
            if (nodes[i].tagName !== "LI") return false;
            if (nodes[i].parentNode.tagName !== tagName || (0, $3EnZW.isNullOrUndefined)(item) && nodes[i].parentNode.style.listStyleType !== "") isRevert = false;
            if (nodes[i].parentNode.tagName === tagName && nodes[i].parentNode.style.listStyleType !== "") isRevert = true;
        }
        return isRevert;
    };
    Lists.prototype.checkLists = function(nodes, tagName, item) {
        var nodesTemp = [];
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i].parentNode;
            if (!(0, $3EnZW.isNullOrUndefined)(item) && "LI" === nodes[i].tagName && !(0, $3EnZW.isNullOrUndefined)(item.listStyle)) {
                if (item.listStyle === "listImage") (0, $4ZDHT.setStyleAttribute)(node, {
                    "list-style-image": item.listImage
                });
                else {
                    (0, $4ZDHT.setStyleAttribute)(node, {
                        "list-style-image": "none"
                    });
                    (0, $4ZDHT.setStyleAttribute)(node, {
                        "list-style-type": item.listStyle.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
                    });
                }
            }
            if (nodes[i].tagName === "LI" && node.tagName !== tagName && nodesTemp.indexOf(node) < 0 || nodes[i].tagName === "LI" && node.tagName === tagName && nodesTemp.indexOf(node) < 0 && item !== null) nodesTemp.push(node);
            if ((0, $3EnZW.isNullOrUndefined)(item) && (node.tagName === tagName || (node.tagName === "UL" || node.tagName === "OL") && node.hasAttribute("style"))) {
                if (node.hasAttribute("style")) node.removeAttribute("style");
            }
        }
        for(var j = nodesTemp.length - 1; j >= 0; j--){
            var h = nodesTemp[j];
            var replace = "<" + tagName.toLowerCase() + " " + this.domNode.attributes(h) + ">" + h.innerHTML + "</" + tagName.toLowerCase() + ">";
            this.domNode.replaceWith(nodesTemp[j], replace);
        }
    };
    Lists.prototype.cleanNode = function() {
        var liParents = this.parent.editableElement.querySelectorAll("ol + ol, ul + ul");
        var listStyleType;
        var firstNodeOL;
        for(var c = 0; c < liParents.length; c++){
            var node = liParents[c];
            var toFindtopOlUl = true;
            var containsListElements = node;
            while(containsListElements.parentElement){
                if (containsListElements.parentElement && containsListElements.parentElement.tagName !== "LI" && containsListElements.parentElement.tagName !== "OL" && containsListElements.parentElement.tagName !== "UL") break;
                containsListElements = containsListElements.parentElement;
            }
            if (toFindtopOlUl && (liParents[c].parentElement.parentElement.nodeName === "OL" || liParents[c].parentElement.parentElement.nodeName === "UL")) {
                toFindtopOlUl = false;
                var preElement = liParents[c].parentElement.parentElement;
                listStyleType = preElement.style.listStyleType;
                firstNodeOL = node.previousElementSibling;
            }
            if (this.domNode.isList(node.previousElementSibling) && this.domNode.openTagString(node) === this.domNode.openTagString(node.previousElementSibling)) {
                var contentNodes = this.domNode.contents(node);
                for(var f = 0; f < contentNodes.length; f++)node.previousElementSibling.appendChild(contentNodes[f]);
                node.parentNode.removeChild(node);
            } else if (!(0, $3EnZW.isNullOrUndefined)(node.getAttribute("level"))) {
                if (node.tagName === node.previousElementSibling.tagName) node.previousElementSibling.lastChild.append(node);
            } else if (this.domNode.isList(node.previousElementSibling) && containsListElements.contains(node.previousElementSibling) && (node.tagName === "OL" || node.tagName === "UL") && (node.previousElementSibling.nodeName === "OL" || node.previousElementSibling.nodeName === "UL")) {
                var contentNodes = this.domNode.contents(node);
                for(var f = 0; f < contentNodes.length; f++)node.previousElementSibling.appendChild(contentNodes[f]);
                node.parentNode.removeChild(node);
            }
        }
        if (firstNodeOL) {
            firstNodeOL.style.listStyleType = listStyleType;
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            var listOlUlElements = [];
            if (range.commonAncestorContainer.nodeName === "UL" || range.commonAncestorContainer.nodeName === "OL") {
                if (range.commonAncestorContainer instanceof Element) listOlUlElements.push(range.commonAncestorContainer);
                listOlUlElements = listOlUlElements.concat(Array.from(range.commonAncestorContainer.querySelectorAll("ol, ul")));
            } else listOlUlElements = Array.from(range.commonAncestorContainer.querySelectorAll("ol, ul"));
            for(var k = 0; k < listOlUlElements.length; k++){
                var listStyle = void 0;
                var listElements = listOlUlElements[k];
                while(listElements){
                    if (listElements.nodeName === "OL" || listElements.nodeName === "OL") {
                        if (listElements.style.listStyleType !== "" && listElements.style.listStyleType !== "none" && listElements.nodeName !== "LI") listStyle = listElements.style.listStyleType;
                        else if (!(0, $3EnZW.isNullOrUndefined)(listStyle) && (listElements.style.listStyleType === "" || listElements.style.listStyleType === "none") && listElements.nodeName !== "LI" && (listElements.nodeName === "UL" || listElements.nodeName === "OL")) listElements.style.listStyleType = listStyle;
                    }
                    listElements = listElements.querySelector("UL,OL");
                }
            }
        }
    };
    Lists.prototype.findUnSelected = function(temp, elements) {
        temp = temp.slice().reverse();
        if (temp.length > 0) {
            var rightIndent = [];
            var indentElements = [];
            var lastElement = elements[elements.length - 1];
            var lastElementChild = [];
            var childElements = [];
            lastElementChild = lastElement.childNodes;
            for(var z = 0; z < lastElementChild.length; z++)if (lastElementChild[z].tagName === "OL" || lastElementChild[z].tagName === "UL") {
                var childLI = lastElementChild[z].querySelectorAll("li");
                if (childLI.length > 0) for(var y = 0; y < childLI.length; y++)childElements.push(childLI[y]);
            }
            for(var i = 0; i < childElements.length; i++){
                var count = 0;
                for(var j = 0; j < temp.length; j++)if (!childElements[i].contains(temp[j])) count = count + 1;
                if (count === temp.length) indentElements.push(childElements[i]);
            }
            if (indentElements.length > 0) {
                for(var x = 0; x < indentElements.length; x++)if (this.domNode.contents(indentElements[x])[0].nodeName !== "OL" && this.domNode.contents(indentElements[x])[0].nodeName !== "UL") rightIndent.push(indentElements[x]);
            }
            if (rightIndent.length > 0) this.nestedList(rightIndent);
        }
    };
    Lists.prototype.revertList = function(elements, e) {
        var temp = [];
        for(var i = elements.length - 1; i >= 0; i--){
            for(var j = i - 1; j >= 0; j--)if (elements[j].contains(elements[i]) || elements[j] === elements[i]) {
                temp.push(elements[i]);
                elements.splice(i, 1);
                break;
            }
        }
        this.findUnSelected(temp, elements);
        var viewNode = [];
        for(var i = 0; i < elements.length; i++){
            var element = elements[i];
            if (this.domNode.contents(element)[0].nodeType === 3 && this.domNode.contents(element)[0].textContent.trim().length === 0) (0, $4ZDHT.detach)(this.domNode.contents(element)[0]);
            var parentNode = elements[i].parentNode;
            var className = element.getAttribute("class");
            if (temp.length === 0) {
                var siblingList = elements[i].querySelectorAll("ul, ol");
                var firstNode = siblingList[0];
                if (firstNode) {
                    var child = firstNode.querySelectorAll("li");
                    if (child) {
                        var nestedElement = (0, $4ZDHT.createElement)(firstNode.tagName);
                        (0, $4ZDHT.append)([
                            nestedElement
                        ], firstNode.parentNode);
                        var nestedElementLI = (0, $4ZDHT.createElement)("li", {
                            styles: "list-style-type: none;"
                        });
                        (0, $4ZDHT.append)([
                            nestedElementLI
                        ], nestedElement);
                        (0, $4ZDHT.append)([
                            firstNode
                        ], nestedElementLI);
                    }
                }
            }
            if (element.parentNode.insertBefore(this.closeTag(parentNode.tagName), element), "LI" === parentNode.parentNode.tagName || "OL" === parentNode.parentNode.tagName || "UL" === parentNode.parentNode.tagName) element.parentNode.insertBefore(this.closeTag("LI"), element);
            else {
                var classAttr = "";
                if (className) // eslint-disable-next-line
                classAttr += ' class="' + className + '"';
                if ($56b963295b740d00$export$d5f8cd4675f465a5 && 0 === element.querySelectorAll($56b963295b740d00$export$d8e31d963c9fa6cb.join(", ")).length) {
                    var wrapperclass = (0, $3EnZW.isNullOrUndefined)(className) ? ' class="e-rte-wrap-inner"' : ' class="' + className + ' e-rte-wrap-inner"';
                    var parentElement = parentNode;
                    if (elements.length === parentElement.querySelectorAll("li").length) {
                        if (!(0, $3EnZW.isNullOrUndefined)(parentElement.style.listStyleType)) parentNode.style.removeProperty("list-style-type");
                        if (!(0, $3EnZW.isNullOrUndefined)(parentElement.style.listStyleImage)) parentNode.style.removeProperty("list-style-image");
                        if (parentElement.style.length === 0) parentNode.removeAttribute("style");
                    }
                    var wrapperTag = (0, $3EnZW.isNullOrUndefined)(e.enterAction) ? $56b963295b740d00$export$d5f8cd4675f465a5 : e.enterAction;
                    var wrapper = "<" + wrapperTag + wrapperclass + this.domNode.attributes(element) + "></" + wrapperTag + ">";
                    if (e.enterAction !== "BR") this.domNode.wrapInner(element, this.domNode.parseHTMLFragment(wrapper));
                    else {
                        var wrapperSpan = "<span class=e-rte-wrap-inner id=removeSpan></span>";
                        var br = document.createElement("br");
                        this.domNode.wrapInner(element, this.domNode.parseHTMLFragment(wrapperSpan));
                        element.appendChild(br);
                    }
                } else if (this.domNode.contents(element)[0].nodeType === 3) {
                    var replace = this.domNode.createTagString($56b963295b740d00$export$d5f8cd4675f465a5, parentNode, this.parent.domNode.encode(this.domNode.contents(element)[0].textContent));
                    this.domNode.replaceWith(this.domNode.contents(element)[0], replace);
                } else if (this.domNode.contents(element)[0].classList.contains((0, $885a3ef7b3a774b1$export$d4b62e40c274c281).startSelection) || this.domNode.contents(element)[0].classList.contains((0, $885a3ef7b3a774b1$export$d4b62e40c274c281).endSelection)) {
                    var replace = this.domNode.createTagString($56b963295b740d00$export$d5f8cd4675f465a5, parentNode, this.domNode.contents(element)[0].outerHTML);
                    this.domNode.replaceWith(this.domNode.contents(element)[0], replace);
                } else {
                    var childNode = element.firstChild;
                    if (childNode) {
                        var attributes_1 = element.parentElement.attributes;
                        if (attributes_1.length > 0) for(var d = 0; d < attributes_1.length; d++){
                            var e_1 = attributes_1[d];
                            var existingValue = childNode.getAttribute(e_1.nodeName);
                            var parentValue = element.parentElement.getAttribute(e_1.nodeName);
                            childNode.setAttribute(e_1.nodeName, existingValue ? parentValue + " " + existingValue : parentValue);
                        }
                    }
                    className = childNode.getAttribute("class");
                    if (className && childNode.getAttribute("class")) (0, $4ZDHT.attributes)(childNode, {
                        "class": className + " " + childNode.getAttribute("class")
                    });
                }
                (0, $4ZDHT.append)([
                    this.openTag("LI")
                ], element);
                (0, $4ZDHT.prepend)([
                    this.closeTag("LI")
                ], element);
            }
            this.domNode.insertAfter(this.openTag(parentNode.tagName), element);
            if (parentNode.parentNode.tagName === "LI") parentNode = parentNode.parentNode.parentNode;
            if (viewNode.indexOf(parentNode) < 0) viewNode.push(parentNode);
        }
        for(var i = 0; i < viewNode.length; i++){
            var node = viewNode[i];
            var nodeInnerHtml = node.innerHTML;
            var closeTag = /<span class="e-rte-list-close-([a-z]*)"><\/span>/g;
            var openTag = /<span class="e-rte-list-open-([a-z]*)"><\/span>/g;
            nodeInnerHtml = nodeInnerHtml.replace(closeTag, "</$1>");
            nodeInnerHtml = nodeInnerHtml.replace(openTag, "<$1 " + this.domNode.attributes(node) + ">");
            this.domNode.replaceWith(node, this.domNode.openTagString(node) + nodeInnerHtml.trim() + this.domNode.closeTagString(node));
        }
        var emptyUl = this.parent.editableElement.querySelectorAll("ul:empty, ol:empty");
        for(var i = 0; i < emptyUl.length; i++)(0, $4ZDHT.detach)(emptyUl[i]);
        var emptyLi = this.parent.editableElement.querySelectorAll("li:empty");
        for(var i = 0; i < emptyLi.length; i++)(0, $4ZDHT.detach)(emptyLi[i]);
    };
    Lists.prototype.openTag = function(type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-open-' + type.toLowerCase() + '"></span>');
    };
    Lists.prototype.closeTag = function(type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-close-' + type.toLowerCase() + '"></span>');
    };
    Lists.prototype.destroy = function() {
        this.removeEventListener();
        if (this.domNode) this.domNode = null;
    };
    Lists.prototype.areAllListItemsSelected = function(list, range) {
        var listItems = list.querySelectorAll("li");
        for(var i = 0; i < listItems.length; i++){
            var listItem = listItems[i];
            var listItemRange = this.parent.currentDocument.createRange();
            listItemRange.selectNodeContents(listItem);
            if (!range.intersectsNode(listItem)) return false;
        }
        return true;
    };
    return Lists;
}();





parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Node appending methods.
 *
 * @hidden
 */ var $ced7ef277e5d7d73$export$7231aa4567d9c92f = /** @class */ function() {
    function InsertMethods() {}
    /**
     * WrapBefore method
     *
     * @param {Text} textNode - specifies the text node
     * @param {HTMLElement} parentNode - specifies the parent node
     * @param {boolean} isAfter - specifies the boolean value
     * @returns {Text} - returns the text value
     * @hidden

     */ InsertMethods.WrapBefore = function(textNode, parentNode, isAfter) {
        parentNode.innerText = textNode.textContent;
        //eslint-disable-next-line
        !isAfter ? this.AppendBefore(parentNode, textNode) : this.AppendBefore(parentNode, textNode, true);
        if (textNode.parentNode) textNode.parentNode.removeChild(textNode);
        return parentNode.childNodes[0];
    };
    /**
     * Wrap method
     *
     * @param {HTMLElement} childNode - specifies the child node
     * @param {HTMLElement} parentNode - specifies the parent node.
     * @returns {HTMLElement} - returns the element
     * @hidden

     */ InsertMethods.Wrap = function(childNode, parentNode) {
        this.AppendBefore(parentNode, childNode);
        parentNode.appendChild(childNode);
        return childNode;
    };
    /**
     * unwrap method
     *
     * @param {Node} node - specifies the node element.
     * @returns {Node[]} - returns the array of value
     * @hidden

     */ InsertMethods.unwrap = function(node) {
        var parent = node.parentNode;
        var child = [];
        for(; node.firstChild;)child.push(parent.insertBefore(node.firstChild, node));
        parent.removeChild(node);
        return child;
    };
    /**
     * AppendBefore method
     *
     * @param {HTMLElement} textNode - specifies the element
     * @param {HTMLElement} parentNode - specifies the parent node
     * @param {boolean} isAfter - specifies the boolean value
     * @returns {void}
     * @hidden

     */ InsertMethods.AppendBefore = function(textNode, parentNode, isAfter) {
        return parentNode.parentNode ? !isAfter ? parentNode.parentNode.insertBefore(textNode, parentNode) : parentNode.parentNode.insertBefore(textNode, parentNode.nextSibling) : parentNode;
    };
    return InsertMethods;
}();


/**
 * Split the Node based on selection
 *
 * @hidden

 */ var $5aa4bc5f0d5dd043$export$7983d5b845f781c0 = /** @class */ function() {
    function NodeCutter() {
        this.enterAction = "P";
        this.position = -1;
        this.nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
    }
    // Split Selection Node
    /**
     * GetSpliceNode method
     *
     * @param {Range} range - specifies the range
     * @param {HTMLElement} node - specifies the node element.
     * @returns {Node} - returns the node value
     * @hidden

     */ NodeCutter.prototype.GetSpliceNode = function(range, node) {
        node = this.SplitNode(range, node, true);
        node = this.SplitNode(range, node, false);
        return node;
    };
    /**
     * @param {Range} range - specifies the range
     * @param {HTMLElement} node - specifies the node element.
     * @param {boolean} isCollapsed - specifies the boolean value
     * @returns {HTMLElement} - returns the element
     * @hidden

     */ NodeCutter.prototype.SplitNode = function(range, node, isCollapsed) {
        if (node) {
            var clone = range.cloneRange();
            var parent_1 = node.parentNode;
            var index = this.nodeSelection.getIndex(node);
            clone.collapse(isCollapsed);
            // eslint-disable-next-line
            isCollapsed ? clone.setStartBefore(node) : clone.setEndAfter(node);
            var fragment = clone.extractContents();
            if (isCollapsed) {
                node = parent_1.childNodes[index];
                fragment = this.spliceEmptyNode(fragment, false);
                if (fragment && fragment.childNodes.length > 0) {
                    var isEmpty = fragment.childNodes.length === 1 && fragment.childNodes[0].nodeName !== "IMG" && !(fragment.querySelectorAll("img").length > 0) && this.isRteElm(fragment) && fragment.textContent.trim() === "" ? true : false;
                    if (!isEmpty) {
                        if (node) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(fragment, node);
                        else {
                            parent_1.appendChild(fragment);
                            var divNode = document.createElement("div");
                            divNode.innerHTML = "&#65279;&#65279;";
                            node = divNode.firstChild;
                            parent_1.appendChild(node);
                        }
                    }
                }
            } else {
                node = parent_1.childNodes.length > 1 ? parent_1.childNodes[index] : parent_1.childNodes[0];
                fragment = this.spliceEmptyNode(fragment, true);
                if (fragment && fragment.childNodes.length > 0) {
                    var isEmpty = fragment.childNodes.length === 1 && fragment.childNodes[0].nodeName !== "IMG" && this.isRteElm(fragment) && fragment.textContent.trim() === "" ? true : false;
                    if (!isEmpty) {
                        if (node) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(fragment, node, true);
                        else {
                            parent_1.appendChild(fragment);
                            var divNode = document.createElement("div");
                            divNode.innerHTML = "&#65279;&#65279;";
                            parent_1.insertBefore(divNode.firstChild, parent_1.firstChild);
                            node = parent_1.firstChild;
                        }
                    }
                }
            }
            return node;
        } else return null;
    };
    NodeCutter.prototype.isRteElm = function(fragment) {
        var result = true;
        if (fragment.childNodes.length === 1 && fragment.childNodes[0].nodeName !== "IMG") {
            var firstChild = fragment.childNodes[0];
            for(var i = 0; !(0, $3EnZW.isNullOrUndefined)(firstChild.childNodes) && i < firstChild.childNodes.length; i++)if (firstChild.childNodes[i].nodeName === "IMG" || firstChild.childNodes[i].nodeName === "SPAN" && (firstChild.childNodes[i].classList.contains("e-video-wrap") || firstChild.childNodes[i].classList.contains("e-embed-video-wrap") || firstChild.childNodes[i].classList.contains("e-audio-wrap"))) result = false;
        } else result = true;
        return result;
    };
    NodeCutter.prototype.spliceEmptyNode = function(fragment, isStart) {
        var len;
        if (fragment.childNodes.length === 1 && fragment.childNodes[0].nodeName === "#text" && fragment.childNodes[0].textContent === "" || fragment.textContent === "") len = -1;
        else len = fragment.childNodes.length - 1;
        if (len > -1 && !isStart) this.spliceEmptyNode(fragment.childNodes[len], isStart);
        else if (len > -1) this.spliceEmptyNode(fragment.childNodes[0], isStart);
        else if (fragment.nodeType !== 3 && fragment.nodeType !== 11 && fragment.nodeName !== "IMG" && !(fragment.querySelectorAll("img").length > 0) && !fragment.classList.contains("e-video-wrap") && !fragment.classList.contains("e-audio-wrap")) fragment.parentNode.removeChild(fragment);
        return fragment;
    };
    // Cursor Position split
    NodeCutter.prototype.GetCursorStart = function(indexes, index, isStart) {
        indexes = isStart ? indexes : indexes.reverse();
        var position = indexes[0];
        for(var num = 0; num < indexes.length && (isStart ? indexes[num] < index : indexes[num] >= index); num++)position = indexes[num];
        return position;
    };
    /**
     * GetCursorRange method
     *
     * @param {Document} docElement - specifies the document
     * @param {Range} range - specifies the range
     * @param {Node} node - specifies the node.
     * @returns {Range} - returns the range value
     * @hidden

     */ NodeCutter.prototype.GetCursorRange = function(docElement, range, node) {
        var cursorRange = docElement.createRange();
        var indexes = [];
        indexes.push(0);
        var str = this.TrimLineBreak(node.data);
        var index = str.indexOf(" ", 0);
        while(index !== -1){
            if (indexes.indexOf(index) < 0) indexes.push(index);
            if (new RegExp("\\s").test(str[index - 1]) && indexes.indexOf(index - 1) < 0) indexes.push(index - 1);
            if (new RegExp("\\s").test(str[index + 1])) indexes.push(index + 1);
            index = str.indexOf(" ", index + 1);
        }
        indexes.push(str.length);
        if (indexes.indexOf(range.startOffset) >= 0 || indexes.indexOf(range.startOffset - 1) >= 0 && (range.startOffset !== 1 || range.startOffset === 1 && new RegExp("\\s").test(str[0])) || indexes[indexes.length - 1] - 1 === range.startOffset && range.endOffset !== str.length - 1 && !new RegExp("\\s").test(str[0])) {
            cursorRange = range;
            this.position = 1;
        } else {
            var startOffset = this.GetCursorStart(indexes, range.startOffset, true);
            this.position = range.startOffset - startOffset;
            if (startOffset !== 0 && str[startOffset] && str[startOffset] === " ") startOffset = startOffset + 1;
            cursorRange.setStart(range.startContainer, startOffset);
            cursorRange.setEnd(range.startContainer, this.GetCursorStart(indexes, range.startOffset, false));
        }
        return cursorRange;
    };
    /**
     * GetCursorNode method
     *
     * @param {Document} docElement - specifies the document
     * @param {Range} range - specifies the range
     * @param {Node} node - specifies the node.
     * @returns {Node} - returns the node value
     * @hidden

     */ NodeCutter.prototype.GetCursorNode = function(docElement, range, node) {
        return this.GetSpliceNode(this.GetCursorRange(docElement, range, node), node);
    };
    /**
     * TrimLineBreak method
     *
     * @param {string} line - specifies the string value.
     * @returns {string} - returns the string
     * @hidden

     */ NodeCutter.prototype.TrimLineBreak = function(line) {
        return line.replace(/(\r\n\t|\n|\r\t)/gm, " ");
    };
    return NodeCutter;
}();


/**
 * Formats internal component
 *
 * @hidden

 */ var $a9472a70d27ba3fe$export$8132710d1930b03e = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element.
     * @hidden

     */ function Formats(parent) {
        this.blockquotePrevent = false;
        this.parent = parent;
        this.addEventListener();
    }
    Formats.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, this.applyFormats, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.onKeyUp, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$1f5745aaf208647c, this.blockQuotesHandled, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    Formats.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, this.applyFormats);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.onKeyUp);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    Formats.prototype.getParentNode = function(node) {
        for(; node.parentNode && node.parentNode !== this.parent.editableElement;)node = node.parentNode;
        return node;
    };
    Formats.prototype.blockQuotesHandled = function() {
        this.blockquotePrevent = true;
    };
    Formats.prototype.onKeyUp = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var endCon = range.endContainer;
        var lastChild = endCon.lastChild;
        if (e.event.which === 13 && range.startContainer === endCon && endCon.nodeType !== 3) {
            var pTag = (0, $4ZDHT.createElement)("p");
            pTag.innerHTML = "<br>";
            if (!(0, $3EnZW.isNullOrUndefined)(lastChild) && lastChild && lastChild.nodeName === "BR" && lastChild.previousSibling && lastChild.previousSibling.nodeName === "TABLE") {
                endCon.replaceChild(pTag, lastChild);
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, pTag, 0);
            } else {
                var brNode = this.parent.nodeSelection.getSelectionNodeCollectionBr(range)[0];
                if (!(0, $3EnZW.isNullOrUndefined)(brNode) && brNode.nodeName === "BR" && brNode.previousSibling && brNode.previousSibling.nodeName === "TABLE") {
                    endCon.replaceChild(pTag, brNode);
                    this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, pTag, 0);
                }
            }
        }
        if (e.enterAction !== "BR" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer) && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.parentElement) && range.startContainer === range.endContainer && range.startContainer.nodeName === "#text" && range.startContainer.parentElement.classList.contains("e-content") && range.startContainer.parentElement.isContentEditable) {
            var pTag = (0, $4ZDHT.createElement)(e.enterAction);
            range.startContainer.parentElement.insertBefore(pTag, range.startContainer);
            pTag.appendChild(range.startContainer);
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, pTag, 1);
        }
    };
    Formats.prototype.getBlockParent = function(node, endNode) {
        var currentParent = node;
        while(node !== endNode){
            currentParent = node;
            node = node.parentElement;
        }
        return currentParent;
    };
    Formats.prototype.onKeyDown = function(e) {
        if (e.event.which === 13 && !this.blockquotePrevent) {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            var startCon = range.startContainer.textContent.length === 0 || range.startContainer.nodeName === "PRE" ? range.startContainer : range.startContainer.parentElement;
            var endCon = range.endContainer.textContent.length === 0 || range.endContainer.nodeName === "PRE" ? range.endContainer : range.endContainer.parentElement;
            var preElem = (0, $4ZDHT.closest)(startCon, "pre");
            var endPreElem = (0, $4ZDHT.closest)(endCon, "pre");
            var blockquoteEle = (0, $4ZDHT.closest)(startCon, "blockquote");
            var endBlockquoteEle = (0, $4ZDHT.closest)(endCon, "blockquote");
            var liParent = !(0, $3EnZW.isNullOrUndefined)(preElem) && !(0, $3EnZW.isNullOrUndefined)(preElem.parentElement) && preElem.parentElement.tagName === "LI";
            if (liParent) return;
            if ((0, $3EnZW.isNullOrUndefined)(preElem) && !(0, $3EnZW.isNullOrUndefined)(endPreElem) || !(0, $3EnZW.isNullOrUndefined)(preElem) && (0, $3EnZW.isNullOrUndefined)(endPreElem)) {
                e.event.preventDefault();
                this.deleteContent(range);
                this.removeCodeContent(range);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, endCon, 0);
            }
            if (e.event.which === 13 && (!(0, $3EnZW.isNullOrUndefined)(blockquoteEle) && !(0, $3EnZW.isNullOrUndefined)(endBlockquoteEle) || !(0, $3EnZW.isNullOrUndefined)(blockquoteEle) && (0, $3EnZW.isNullOrUndefined)(endBlockquoteEle))) {
                var startParent = this.getBlockParent(range.startContainer, blockquoteEle);
                if (startParent.textContent.charCodeAt(0) === 8203 && startParent.textContent.length === 1 || startParent.textContent.length === 0 && startParent.querySelectorAll("img").length === 0 && startParent.querySelectorAll("table").length === 0) {
                    e.event.preventDefault();
                    if ((0, $3EnZW.isNullOrUndefined)(startParent.nextElementSibling)) this.paraFocus(startParent.parentElement === this.parent.editableElement ? startParent : startParent.parentElement); //Revert from blockquotes while pressing enter key
                    else {
                        var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
                        var newElem = nodeCutter.SplitNode(range, startParent.parentElement, false).cloneNode(true);
                        this.paraFocus(startParent.parentElement === this.parent.editableElement ? startParent : startParent.parentElement);
                    }
                }
            }
            if (e.event.which === 13 && !(0, $3EnZW.isNullOrUndefined)(preElem) && !(0, $3EnZW.isNullOrUndefined)(endPreElem)) {
                e.event.preventDefault();
                this.deleteContent(range);
                this.removeCodeContent(range);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
                var lastEmpty = range.startContainer.childNodes[range.endOffset];
                var lastBeforeBr = range.startContainer.childNodes[range.endOffset - 1];
                var startParent = range.startContainer;
                if (!(0, $3EnZW.isNullOrUndefined)(lastEmpty) && !(0, $3EnZW.isNullOrUndefined)(lastBeforeBr) && (0, $3EnZW.isNullOrUndefined)(lastEmpty.nextSibling) && lastEmpty.nodeName === "BR" && lastBeforeBr.nodeName === "BR") this.paraFocus(range.startContainer, e.enterAction);
                else if (startParent.textContent.charCodeAt(0) === 8203 && startParent.textContent.length === 1 || startParent.textContent.length === 0) {
                    //Double enter with any parent tag for the node
                    while(startParent.parentElement.nodeName !== "PRE" && (startParent.textContent.length === 1 || startParent.textContent.length === 0))startParent = startParent.parentElement;
                    if (!(0, $3EnZW.isNullOrUndefined)(startParent.previousSibling) && startParent.previousSibling.nodeName === "BR" && (0, $3EnZW.isNullOrUndefined)(startParent.nextSibling)) this.paraFocus(startParent.parentElement);
                    else this.isNotEndCursor(preElem, range);
                } else //Cursor at start and middle
                this.isNotEndCursor(preElem, range);
            }
        }
        this.blockquotePrevent = false;
    };
    Formats.prototype.removeCodeContent = function(range) {
        var regEx = new RegExp("\uFEFF", "g");
        if (!(0, $3EnZW.isNullOrUndefined)(range.endContainer.textContent.match(regEx))) {
            var pointer = range.endContainer.textContent.charCodeAt(range.endOffset - 1) === 65279 ? range.endOffset - 2 : range.endOffset;
            range.endContainer.textContent = range.endContainer.textContent.replace(regEx, "");
            if (range.endContainer.textContent === "") this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, range.endContainer.parentElement, 0);
            else this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, range.endContainer, pointer);
        }
    };
    Formats.prototype.deleteContent = function(range) {
        if (range.startContainer !== range.endContainer || range.startOffset !== range.endOffset) range.deleteContents();
    };
    Formats.prototype.paraFocus = function(referNode, enterAction) {
        var insertTag;
        if (enterAction === "DIV") {
            insertTag = (0, $4ZDHT.createElement)("div");
            insertTag.innerHTML = "<br>";
        } else if (enterAction === "BR") insertTag = (0, $4ZDHT.createElement)("br");
        else {
            insertTag = (0, $4ZDHT.createElement)("p");
            insertTag.innerHTML = "<br>";
        }
        this.parent.domNode.insertAfter(insertTag, referNode);
        this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, insertTag, 0);
        (0, $4ZDHT.detach)(referNode.lastChild);
    };
    Formats.prototype.isNotEndCursor = function(preElem, range) {
        var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
        var isEnd = range.startOffset === preElem.lastChild.textContent.length && preElem.lastChild.textContent === range.startContainer.textContent;
        //Cursor at start point
        if (preElem.textContent.indexOf(range.startContainer.textContent) === 0 && (range.startOffset === 0 && range.endOffset === 0 || range.startContainer.nodeName === "PRE")) {
            this.insertMarker(preElem, range);
            var brTag = (0, $4ZDHT.createElement)("br");
            preElem.childNodes[range.endOffset].parentElement.insertBefore(brTag, preElem.childNodes[range.endOffset]);
        } else {
            //Cursor at middle
            var cloneNode = nodeCutter.SplitNode(range, preElem, true);
            this.insertMarker(preElem, range);
            var previousSib = preElem.previousElementSibling;
            if (previousSib.tagName === "PRE") {
                previousSib.insertAdjacentHTML("beforeend", "<br>" + cloneNode.innerHTML);
                (0, $4ZDHT.detach)(preElem);
            }
        }
        //To place the cursor position
        this.setCursorPosition(isEnd, preElem);
    };
    Formats.prototype.setCursorPosition = function(isEnd, preElem) {
        var isEmpty = false;
        var markerElem = this.parent.editableElement.querySelector(".tempSpan");
        var mrkParentElem = markerElem.parentElement;
        // eslint-disable-next-line
        markerElem.parentNode.textContent === "" ? isEmpty = true : this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, markerElem, 0);
        if (isEnd) {
            if (isEmpty) {
                //Enter press when pre element is empty
                if (mrkParentElem === preElem) {
                    this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, markerElem, 0);
                    (0, $4ZDHT.detach)(markerElem);
                } else this.focusSelectionParent(markerElem, mrkParentElem);
            } else {
                var brElm = (0, $4ZDHT.createElement)("br");
                this.parent.domNode.insertAfter(brElm, markerElem);
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, markerElem, 0);
                (0, $4ZDHT.detach)(markerElem);
            }
        } else // eslint-disable-next-line
        isEmpty ? this.focusSelectionParent(markerElem, mrkParentElem) : (0, $4ZDHT.detach)(markerElem);
    };
    Formats.prototype.focusSelectionParent = function(markerElem, tempSpanPElem) {
        (0, $4ZDHT.detach)(markerElem);
        tempSpanPElem.innerHTML = "\u200B";
        this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, tempSpanPElem, 0);
    };
    Formats.prototype.insertMarker = function(preElem, range) {
        var tempSpan = (0, $4ZDHT.createElement)("span", {
            className: "tempSpan"
        });
        if (range.startContainer.nodeName === "PRE") preElem.childNodes[range.endOffset].parentElement.insertBefore(tempSpan, preElem.childNodes[range.endOffset]);
        else range.startContainer.parentElement.insertBefore(tempSpan, range.startContainer);
    };
    Formats.prototype.applyFormats = function(e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var isSelectAll = false;
        if (this.parent.editableElement === range.endContainer && !(0, $3EnZW.isNullOrUndefined)(this.parent.editableElement.children[range.endOffset - 1]) && this.parent.editableElement.children[range.endOffset - 1].tagName === "TABLE" && !range.collapsed) isSelectAll = true;
        var save = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        this.parent.domNode.setMarker(save);
        var formatsNodes = this.parent.domNode.blockNodes(true);
        if (e.enterAction === "BR") {
            this.setSelectionBRConfig();
            var allSelectedNode = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument);
            var selectedNodes = this.parent.nodeSelection.getSelectionNodes(allSelectedNode);
            var currentFormatNodes = [];
            if (selectedNodes.length === 0) selectedNodes.push(formatsNodes[0]);
            for(var i = 0; i < selectedNodes.length; i++){
                var currentNode = selectedNodes[i];
                var previousCurrentNode = void 0;
                while(!this.parent.domNode.isBlockNode(currentNode) && currentNode !== this.parent.editableElement){
                    previousCurrentNode = currentNode;
                    currentNode = currentNode.parentElement;
                }
                if (this.parent.domNode.isBlockNode(currentNode) && currentNode === this.parent.editableElement) currentFormatNodes.push(previousCurrentNode);
            }
            for(var i = 0; i < currentFormatNodes.length; i++)if (!this.parent.domNode.isBlockNode(currentFormatNodes[i])) {
                var currentNode = currentFormatNodes[i];
                var previousNode = currentNode;
                while(currentNode === this.parent.editableElement){
                    previousNode = currentNode;
                    currentNode = currentNode.parentElement;
                }
                var tempElem = void 0;
                if (this.parent.domNode.isBlockNode(previousNode.parentElement) && previousNode.parentElement === this.parent.editableElement) {
                    tempElem = (0, $4ZDHT.createElement)("div");
                    previousNode.parentElement.insertBefore(tempElem, previousNode);
                    tempElem.appendChild(previousNode);
                    if (previousNode.textContent.length === 0) previousNode.appendChild((0, $4ZDHT.createElement)("br"));
                } else tempElem = previousNode;
                var preNode = tempElem.previousSibling;
                while(!(0, $3EnZW.isNullOrUndefined)(preNode) && preNode.nodeName !== "BR" && !this.parent.domNode.isBlockNode(preNode)){
                    tempElem.firstChild.parentElement.insertBefore(preNode, tempElem.firstChild);
                    preNode = tempElem.previousSibling;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(preNode) && preNode.nodeName === "BR") (0, $4ZDHT.detach)(preNode);
                var postNode = tempElem.nextSibling;
                while(!(0, $3EnZW.isNullOrUndefined)(postNode) && postNode.nodeName !== "BR" && !this.parent.domNode.isBlockNode(postNode)){
                    tempElem.appendChild(postNode);
                    postNode = tempElem.nextSibling;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(postNode) && postNode.nodeName === "BR") (0, $4ZDHT.detach)(postNode);
            }
            this.setSelectionBRConfig();
            formatsNodes = this.parent.domNode.blockNodes();
        }
        var isWholeBlockquoteNotSelected = false;
        var isPartiallySelected = false;
        for(var i = 0; i < formatsNodes.length; i++)if ((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[0], "blockquote")) || (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[formatsNodes.length - 1], "blockquote"))) isPartiallySelected = true;
        for(var i = 0; i < formatsNodes.length; i++){
            var parentNode = void 0;
            var replaceHTML = void 0;
            if (e.subCommand.toLowerCase() === "blockquote") {
                parentNode = this.getParentNode(formatsNodes[i]);
                if (e.enterAction === "BR") replaceHTML = parentNode.innerHTML;
                else if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[i], "table")) && this.parent.editableElement.contains((0, $4ZDHT.closest)(formatsNodes[i], "table"))) replaceHTML = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[i], "blockquote")) ? (0, $4ZDHT.closest)(formatsNodes[i], "blockquote").outerHTML : formatsNodes[i].outerHTML;
                else replaceHTML = parentNode.outerHTML;
            } else {
                parentNode = formatsNodes[i];
                replaceHTML = parentNode.innerHTML;
            }
            if (e.subCommand.toLowerCase() === "blockquote" && e.subCommand.toLowerCase() === parentNode.tagName.toLowerCase() && isPartiallySelected || e.subCommand.toLowerCase() === parentNode.tagName.toLowerCase() && (e.subCommand.toLowerCase() !== "pre" && e.subCommand.toLowerCase() !== "blockquote" || !(0, $3EnZW.isNullOrUndefined)(e.exeValue) && e.exeValue.name === "dropDownSelect") || (0, $3EnZW.isNullOrUndefined)(parentNode.parentNode) || parentNode.tagName === "TABLE" && e.subCommand.toLowerCase() === "pre") continue;
            this.cleanFormats(parentNode, e.subCommand);
            var replaceNode = e.subCommand.toLowerCase() === "pre" && parentNode.tagName.toLowerCase() === "pre" ? "p" : e.subCommand;
            var isToggleBlockquoteList = e.subCommand.toLowerCase() === parentNode.tagName.toLowerCase() && e.subCommand.toLowerCase() === "blockquote" && this.parent.domNode.isList(parentNode.firstElementChild);
            var ensureNode = parentNode.tagName === "TABLE" ? !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[i], "blockquote")) ? (0, $4ZDHT.closest)(formatsNodes[i], "blockquote") : parentNode : parentNode;
            var isToggleBlockquote = e.subCommand.toLowerCase() === ensureNode.tagName.toLowerCase() && e.subCommand.toLowerCase() === "blockquote";
            var replaceTag = void 0;
            if (isToggleBlockquoteList) replaceTag = replaceHTML.replace("<blockquote>", "").replace("</blockquote>", "");
            else if (isToggleBlockquote && (0, $4ZDHT.closest)(formatsNodes[0], "blockquote") && (0, $4ZDHT.closest)(formatsNodes[formatsNodes.length - 1], "blockquote")) {
                if ((0, $3EnZW.isNullOrUndefined)(formatsNodes[0].previousSibling) && (0, $3EnZW.isNullOrUndefined)(formatsNodes[formatsNodes.length - 1].nextSibling)) replaceTag = replaceHTML.replace(/<blockquote[^>]*>|<\/blockquote>/g, "");
                else {
                    isWholeBlockquoteNotSelected = true;
                    if (i === 0) {
                        var tempCloseSpanElem = (0, $4ZDHT.createElement)("span");
                        tempCloseSpanElem.classList.add("e-rte-blockquote-close");
                        formatsNodes[i].parentNode.insertBefore(tempCloseSpanElem, formatsNodes[i]);
                    }
                    if (i === formatsNodes.length - 1) {
                        var tempOpenSpanElem = (0, $4ZDHT.createElement)("span");
                        tempOpenSpanElem.classList.add("e-rte-blockquote-open");
                        this.parent.domNode.insertAfter(tempOpenSpanElem, formatsNodes[i]);
                    }
                }
            } else replaceTag = this.parent.domNode.createTagString(replaceNode, e.subCommand.toLowerCase() === "blockquote" ? null : parentNode, replaceHTML.replace(/>\s+</g, "><"));
            if (parentNode.tagName === "LI") {
                parentNode.innerHTML = "";
                parentNode.insertAdjacentHTML("beforeend", replaceTag);
            } else if (!isWholeBlockquoteNotSelected) {
                var currentTag = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[i], "table")) && this.parent.editableElement.contains((0, $4ZDHT.closest)(formatsNodes[i], "table")) ? !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(formatsNodes[i], "blockquote")) ? (0, $4ZDHT.closest)(formatsNodes[i], "blockquote") : formatsNodes[i] : parentNode;
                this.parent.domNode.replaceWith(currentTag, replaceTag);
            }
        }
        if (isWholeBlockquoteNotSelected) {
            var blockquoteElem = this.parent.editableElement.querySelectorAll(".e-rte-blockquote-open, .e-rte-blockquote-close");
            for(var i = 0; i < blockquoteElem.length; i++){
                var blockquoteNode = blockquoteElem[i].parentElement;
                var blockquoteContent = blockquoteNode.innerHTML;
                blockquoteContent = blockquoteContent.replace(/<span class="e-rte-blockquote-open"><\/span>/g, "<blockquote>");
                blockquoteContent = blockquoteContent.replace(/<span class="e-rte-blockquote-close"><\/span>/g, "</blockquote>");
                if (blockquoteElem[0].parentElement === blockquoteElem[1].parentElement) {
                    this.parent.domNode.replaceWith(blockquoteNode, this.parent.domNode.openTagString(blockquoteNode) + blockquoteContent.trim() + this.parent.domNode.closeTagString(blockquoteNode));
                    break;
                } else if (i === blockquoteElem.length - 1 && !(0, $3EnZW.isNullOrUndefined)(blockquoteElem[i]) && !(0, $3EnZW.isNullOrUndefined)(blockquoteElem[i - 1]) && blockquoteElem[i].parentElement !== blockquoteElem[i - 1].parentElement) this.parent.domNode.replaceWith(blockquoteNode, blockquoteContent.trim());
                else this.parent.domNode.replaceWith(blockquoteNode, this.parent.domNode.openTagString(blockquoteNode) + blockquoteContent.trim() + this.parent.domNode.closeTagString(blockquoteNode));
            }
        }
        this.preFormatMerge();
        this.blockquotesFormatMerge(e.enterAction);
        var startNode = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).startSelection);
        var endNode = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).endSelection);
        if (!(0, $3EnZW.isNullOrUndefined)(startNode) && !(0, $3EnZW.isNullOrUndefined)(endNode)) {
            startNode = startNode.lastChild;
            endNode = endNode.lastChild;
        }
        save = this.parent.domNode.saveMarker(save);
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(this.parent.editableElement, e.selector);
        if (isSelectAll) this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startNode, endNode, 0, endNode.textContent.length);
        else save.restore();
        if (e.callBack) e.callBack({
            requestType: e.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.domNode.blockNodes()
        });
    };
    Formats.prototype.setSelectionBRConfig = function() {
        var startElem = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).startSelection);
        var endElem = this.parent.editableElement.querySelector("." + (0, $885a3ef7b3a774b1$export$d4b62e40c274c281).endSelection);
        if ((0, $3EnZW.isNullOrUndefined)(endElem)) this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, startElem, 0);
        else this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startElem, endElem, 0, 0);
    };
    Formats.prototype.preFormatMerge = function() {
        var preNodes = this.parent.editableElement.querySelectorAll("PRE");
        if (!(0, $3EnZW.isNullOrUndefined)(preNodes)) for(var i = 0; i < preNodes.length; i++){
            var previousSib = preNodes[i].previousElementSibling;
            if (!(0, $3EnZW.isNullOrUndefined)(previousSib) && previousSib.tagName === "PRE") {
                previousSib.insertAdjacentHTML("beforeend", "<br>" + preNodes[i].innerHTML);
                (0, $4ZDHT.detach)(preNodes[i]);
            }
        }
    };
    Formats.prototype.blockquotesFormatMerge = function(enterAction) {
        var blockquoteNodes = this.parent.editableElement.querySelectorAll("BLOCKQUOTE");
        if (!(0, $3EnZW.isNullOrUndefined)(blockquoteNodes)) for(var i = 0; i < blockquoteNodes.length; i++){
            if (blockquoteNodes[i].innerHTML.trim() === "") (0, $4ZDHT.detach)(blockquoteNodes[i]);
            var previousSib = blockquoteNodes[i].previousElementSibling;
            if (!(0, $3EnZW.isNullOrUndefined)(previousSib) && previousSib.tagName === "BLOCKQUOTE") {
                previousSib.insertAdjacentHTML("beforeend", (enterAction === "BR" ? "<br>" : "") + blockquoteNodes[i].innerHTML);
                (0, $4ZDHT.detach)(blockquoteNodes[i]);
            }
        }
    };
    Formats.prototype.cleanFormats = function(element, tagName) {
        var ignoreAttr = [
            "display",
            "font-size",
            "margin-top",
            "margin-bottom",
            "margin-left",
            "margin-right",
            "font-weight"
        ];
        tagName = tagName.toLowerCase();
        for(var i = 0; i < ignoreAttr.length && tagName !== "p" && tagName !== "blockquote" && tagName !== "pre"; i++)element.style.removeProperty(ignoreAttr[i]);
    };
    Formats.prototype.destroy = function() {
        this.removeEventListener();
    };
    return Formats;
}();








parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


/**
 * Insert a HTML Node or Text
 *
 * @hidden

 */ var $d506f52aebbae6a6$export$d39fd72c6bafacf3 = /** @class */ function() {
    function InsertHtml() {}
    InsertHtml.Insert = function(docElement, insertNode, editNode, isExternal, enterAction) {
        var node;
        if (typeof insertNode === "string") {
            var divNode = document.createElement("div");
            divNode.innerHTML = insertNode;
            node = isExternal ? divNode : divNode.firstChild;
        } else if (isExternal && !(!(0, $3EnZW.isNullOrUndefined)(insertNode) && !(0, $3EnZW.isNullOrUndefined)(insertNode.classList) && insertNode.classList.contains("pasteContent"))) {
            var divNode = document.createElement("div");
            divNode.appendChild(insertNode);
            node = divNode;
        } else node = insertNode;
        var nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
        var range = nodeSelection.getRange(docElement);
        if (range.startContainer === editNode && range.startContainer === range.endContainer && range.startOffset === 0 && range.startOffset === range.endOffset && editNode.textContent.length === 0 && (editNode.children[0].tagName === "P" || editNode.children[0].tagName === "DIV" || editNode.children[0].tagName === "BR")) {
            nodeSelection.setSelectionText(docElement, range.startContainer.children[0], range.startContainer.children[0], 0, 0);
            range = nodeSelection.getRange(docElement);
        }
        if (range.startContainer === editNode && range.startContainer === range.endContainer && range.startOffset === 0 && range.startOffset === range.endOffset && editNode.textContent.trim().length > 0) {
            var focusNode = this.findFirstTextNode(range.startContainer);
            if (!(0, $3EnZW.isNullOrUndefined)(focusNode)) {
                nodeSelection.setSelectionText(docElement, focusNode, focusNode, 0, 0);
                range = nodeSelection.getRange(docElement);
            }
        }
        if (range.startContainer.nodeName === "BR" && range.startOffset === 0 && range.startOffset === range.endOffset && range.startContainer === range.endContainer) {
            var currentIndex = Array.prototype.slice.call(range.startContainer.parentElement.childNodes).indexOf(range.startContainer);
            nodeSelection.setSelectionText(docElement, range.startContainer.parentElement, range.startContainer.parentElement, currentIndex, currentIndex);
            range = nodeSelection.getRange(docElement);
        }
        var isCursor = range.startOffset === range.endOffset && range.startOffset === 0 && range.startContainer === range.endContainer;
        var isCollapsed = range.collapsed;
        var nodes = this.getNodeCollection(range, nodeSelection, node);
        var closestParentNode = node.nodeName.toLowerCase() === "table" ? !(0, $3EnZW.isNullOrUndefined)(nodes[0]) ? this.closestEle(nodes[0].parentNode, editNode) : range.startContainer : nodes[0];
        if (closestParentNode && closestParentNode.nodeName === "LI" && node.nodeName.toLowerCase() === "table") {
            this.insertTableInList(range, node, closestParentNode, nodes[0], nodeCutter);
            return;
        }
        if (isCursor && range.startContainer.textContent === "" && range.startContainer.nodeName !== "BR" && enterAction !== "BR" && node.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(node.children[0]) && !(0, $3EnZW.isNullOrUndefined)(node.children[0].tagName) && node.children[0].tagName === "IMG" && node.children.length === 1) range.startContainer.innerHTML = "";
        if (isExternal || !(0, $3EnZW.isNullOrUndefined)(node) && !(0, $3EnZW.isNullOrUndefined)(node.classList) && node.classList.contains("pasteContent")) {
            this.pasteInsertHTML(nodes, node, range, nodeSelection, nodeCutter, docElement, isCollapsed, closestParentNode, editNode, enterAction);
            return;
        }
        if (editNode !== range.startContainer && (!isCollapsed && !(closestParentNode.nodeType === Node.ELEMENT_NODE && $56b963295b740d00$export$42fa0eda31a41dcc.indexOf(closestParentNode.tagName.toLocaleLowerCase()) !== -1) || node.nodeName.toLowerCase() === "table" && closestParentNode && $56b963295b740d00$export$42fa0eda31a41dcc.indexOf(closestParentNode.tagName.toLocaleLowerCase()) === -1)) {
            var preNode = nodeCutter.GetSpliceNode(range, closestParentNode);
            var sibNode = preNode.previousSibling;
            var parentNode = preNode.parentNode;
            if (nodes.length === 1 || node.nodeName.toLowerCase() === "table" && preNode.childElementCount === 0) {
                nodeSelection.setSelectionContents(docElement, preNode);
                range = nodeSelection.getRange(docElement);
            } else {
                var lasNode = nodeCutter.GetSpliceNode(range, nodes[nodes.length - 1].parentElement);
                lasNode = (0, $3EnZW.isNullOrUndefined)(lasNode) ? preNode : lasNode;
                nodeSelection.setSelectionText(docElement, preNode, lasNode, 0, lasNode.nodeType === 3 ? lasNode.textContent.length : lasNode.childNodes.length);
                range = nodeSelection.getRange(docElement);
            }
            if (range.startContainer.parentElement.closest("ol,ul") !== null && range.endContainer.parentElement.closest("ol,ul") !== null) (0, $259257662ca103fc$export$1370d694ef0c2923)(range);
            else range.extractContents();
            if (insertNode.tagName === "TABLE") this.removeEmptyElements(editNode);
            for(var index = 0; index < nodes.length; index++)if (nodes[index].nodeType !== 3 && nodes[index].parentNode != null) {
                if (nodes[index].nodeName === "IMG") continue;
                nodes[index].parentNode.removeChild(nodes[index]);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(sibNode) && !(0, $3EnZW.isNullOrUndefined)(sibNode.parentNode)) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(node, sibNode, true);
            else {
                var previousNode = null;
                while(parentNode !== editNode && parentNode.firstChild && parentNode.textContent.trim() === ""){
                    var parentNode1 = parentNode.parentNode;
                    previousNode = parentNode;
                    parentNode = parentNode1;
                }
                if (previousNode !== null) parentNode = previousNode;
                if (parentNode.firstChild && (parentNode !== editNode || node.nodeName === "TABLE" && isCursor && parentNode === range.startContainer && parentNode === range.endContainer)) {
                    if (parentNode.textContent.trim() === "" && parentNode !== editNode) {
                        (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(node, parentNode, false);
                        (0, $4ZDHT.detach)(parentNode);
                    } else (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(node, parentNode.firstChild, false);
                } else if ((0, $3EnZW.isNullOrUndefined)(preNode.previousSibling) && insertNode.tagName === "TABLE") parentNode.prepend(node);
                else parentNode.appendChild(node);
            }
            if (node.nodeName === "IMG") this.imageFocus(node, nodeSelection, docElement);
            else if (node.nodeType !== 3) nodeSelection.setSelectionText(docElement, node, node, 0, node.childNodes.length);
            else nodeSelection.setSelectionText(docElement, node, node, 0, node.textContent.length);
        } else {
            range.deleteContents();
            if (isCursor && range.startContainer.textContent === "" && range.startContainer.nodeName !== "BR") range.startContainer.innerHTML = "";
            if ((0, $5q7BP.Browser).isIE) {
                var frag = docElement.createDocumentFragment();
                frag.appendChild(node);
                range.insertNode(frag);
            } else if (range.startContainer.nodeType === 1 && range.startContainer.nodeName.toLowerCase() === "hr" && range.endContainer.nodeName.toLowerCase() === "hr") {
                var paraElem = range.startContainer.nextElementSibling;
                if (paraElem) {
                    if (paraElem.querySelector("br")) (0, $4ZDHT.detach)(paraElem.querySelector("br"));
                    paraElem.appendChild(node);
                }
            } else if (range.startContainer.nodeName === "BR") range.startContainer.parentElement.insertBefore(node, range.startContainer);
            else range.insertNode(node);
            if (node.nodeType !== 3 && node.childNodes.length > 0) nodeSelection.setSelectionText(docElement, node, node, 1, 1);
            else if (node.nodeName === "IMG") this.imageFocus(node, nodeSelection, docElement);
            else if (node.nodeType !== 3) nodeSelection.setSelectionContents(docElement, node);
            else nodeSelection.setSelectionText(docElement, node, node, node.textContent.length, node.textContent.length);
        }
    };
    InsertHtml.findFirstTextNode = function(node) {
        if (node.nodeType === Node.TEXT_NODE) return node;
        for(var i = 0; i < node.childNodes.length; i++){
            var textNode = this.findFirstTextNode(node.childNodes[i]);
            if (!(0, $3EnZW.isNullOrUndefined)(textNode)) return textNode;
        }
        return null;
    };
    InsertHtml.pasteInsertHTML = function(nodes, node, range, nodeSelection, nodeCutter, docElement, isCollapsed, closestParentNode, editNode, enterAction) {
        var isCursor = range.startOffset === range.endOffset && range.startContainer === range.endContainer;
        if (isCursor && range.startContainer === editNode && editNode.textContent === "") {
            var currentBlockNode = this.getImmediateBlockNode(nodes[nodes.length - 1], editNode);
            nodeSelection.setSelectionText(docElement, currentBlockNode, currentBlockNode, 0, 0);
            range = nodeSelection.getRange(docElement);
        }
        var lasNode;
        var sibNode;
        var isSingleNode;
        var preNode;
        if (editNode !== range.startContainer && (!isCollapsed && !(closestParentNode.nodeType === Node.ELEMENT_NODE && $56b963295b740d00$export$42fa0eda31a41dcc.indexOf(closestParentNode.tagName.toLocaleLowerCase()) !== -1) || node.nodeName.toLowerCase() === "table" && closestParentNode && $56b963295b740d00$export$42fa0eda31a41dcc.indexOf(closestParentNode.tagName.toLocaleLowerCase()) === -1)) {
            preNode = nodeCutter.GetSpliceNode(range, closestParentNode);
            if (!(0, $3EnZW.isNullOrUndefined)(preNode)) {
                sibNode = (0, $3EnZW.isNullOrUndefined)(preNode.previousSibling) ? preNode.parentNode.previousSibling : preNode.previousSibling;
                if (nodes.length === 1) {
                    nodeSelection.setSelectionContents(docElement, preNode);
                    range = nodeSelection.getRange(docElement);
                    isSingleNode = true;
                } else {
                    lasNode = nodeCutter.GetSpliceNode(range, nodes[nodes.length - 1].parentElement);
                    lasNode = (0, $3EnZW.isNullOrUndefined)(lasNode) ? preNode : lasNode;
                    nodeSelection.setSelectionText(docElement, preNode, lasNode, 0, lasNode.nodeType === 3 ? lasNode.textContent.length : lasNode.childNodes.length);
                    range = nodeSelection.getRange(docElement);
                    isSingleNode = false;
                }
            }
        }
        var containsBlockNode = false;
        this.removingComments(node);
        var allChildNodes = node.childNodes;
        for(var i = 0; i < allChildNodes.length; i++)if ($56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(allChildNodes[i].nodeName.toLocaleLowerCase()) >= 0) {
            containsBlockNode = true;
            break;
        }
        var lastSelectionNode;
        var fragment = document.createDocumentFragment();
        if (!containsBlockNode) {
            if (!isCursor) {
                while(node.firstChild){
                    lastSelectionNode = node.firstChild;
                    fragment.appendChild(node.firstChild);
                }
                if (isSingleNode) {
                    range.deleteContents();
                    this.removeEmptyElements(editNode, true);
                    range.insertNode(fragment);
                } else {
                    var startContainerParent = editNode === range.startContainer ? range.startContainer : range.startContainer.parentNode;
                    // Get the index of the start container among its siblings
                    var startIndex = Array.prototype.indexOf.call(startContainerParent.childNodes, (0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && editNode === range.startContainer ? range.startContainer.firstChild : range.startContainer);
                    range.deleteContents();
                    range.setStart(startContainerParent, startIndex);
                    range.setEnd(startContainerParent, startIndex);
                    if (!(0, $3EnZW.isNullOrUndefined)(lasNode) && lasNode !== editNode) {
                        (0, $4ZDHT.detach)(lasNode);
                        this.removeEmptyElements(editNode, true);
                    }
                    // eslint-disable-next-line
                    !(0, $3EnZW.isNullOrUndefined)(sibNode) ? sibNode.parentNode === editNode ? sibNode.appendChild(fragment) : sibNode.parentNode.appendChild(fragment) : range.insertNode(fragment);
                }
            } else {
                var tempSpan = (0, $4ZDHT.createElement)("span", {
                    className: "tempSpan"
                });
                var nearestAnchor = (0, $4ZDHT.closest)(range.startContainer.parentElement, "a");
                if (range.startContainer.nodeType === 3 && nearestAnchor && (0, $4ZDHT.closest)(nearestAnchor, "span")) {
                    var immediateBlockNode = this.getImmediateBlockNode(range.startContainer, editNode);
                    if (immediateBlockNode.querySelectorAll("br").length > 0) (0, $4ZDHT.detach)(immediateBlockNode.querySelector("br"));
                    var rangeElement = (0, $4ZDHT.closest)(nearestAnchor, "span");
                    rangeElement.appendChild(tempSpan);
                } else if (nodes[0].nodeName === "#text" && nodes[0].nodeValue.includes("\u200B") && !(0, $3EnZW.isNullOrUndefined)(nodes[0].parentElement) && !(0, $3EnZW.isNullOrUndefined)(nodes[0].parentElement.previousElementSibling) && nodes[0].parentElement.previousElementSibling.classList.contains("e-mention-chip")) range.startContainer.parentElement.insertAdjacentElement("afterend", tempSpan);
                else range.insertNode(tempSpan);
                while(node.firstChild){
                    lastSelectionNode = node.firstChild;
                    fragment.appendChild(node.firstChild);
                }
                tempSpan.parentNode.replaceChild(fragment, tempSpan);
            }
        } else {
            var parentElem = range.startContainer;
            while(!(0, $3EnZW.isNullOrUndefined)(parentElem) && parentElem.nodeName !== "PRE" && parentElem !== editNode)parentElem = parentElem.parentElement;
            if (!(0, $3EnZW.isNullOrUndefined)(node) && !(0, $3EnZW.isNullOrUndefined)(parentElem) && parentElem.nodeName === "PRE") {
                range.insertNode(node);
                lastSelectionNode = node.lastChild;
            } else {
                this.insertTempNode(range, node, nodes, nodeCutter, editNode);
                var isFirstTextNode = true;
                var isPreviousInlineElem = void 0;
                var paraElm = void 0;
                var previousParent = void 0;
                if (!this.contentsDeleted) {
                    if (!isCollapsed && range.startContainer.parentElement.textContent.length === 0 && range.startContainer.nodeName === "BR" && range.startContainer.parentElement.nodeName === "P") editNode.removeChild(range.startContainer.parentElement);
                    range.deleteContents();
                }
                while(node.firstChild){
                    if (node.firstChild.nodeName === "#text" && node.firstChild.textContent.trim() === "") {
                        (0, $4ZDHT.detach)(node.firstChild);
                        continue;
                    }
                    if (node.firstChild.nodeName === "#text" && isFirstTextNode || this.inlineNode.indexOf(node.firstChild.nodeName.toLocaleLowerCase()) >= 0 && isFirstTextNode) {
                        lastSelectionNode = node.firstChild;
                        if ((0, $3EnZW.isNullOrUndefined)(node.previousElementSibling)) {
                            var firstParaElm = enterAction === "DIV" ? (0, $4ZDHT.createElement)("div") : (0, $4ZDHT.createElement)("p");
                            node.parentElement.insertBefore(firstParaElm, node);
                        }
                        if (node.previousElementSibling.nodeName === "BR") node.parentElement.insertBefore(node.firstChild, node);
                        else node.previousElementSibling.appendChild(node.firstChild);
                    } else {
                        lastSelectionNode = node.firstChild;
                        if (node.firstChild.nodeName === "#text" || this.inlineNode.indexOf(node.firstChild.nodeName.toLocaleLowerCase()) >= 0) {
                            if (!isPreviousInlineElem) {
                                paraElm = enterAction === "DIV" ? (0, $4ZDHT.createElement)("div") : (0, $4ZDHT.createElement)("p");
                                paraElm.appendChild(node.firstChild);
                                fragment.appendChild(paraElm);
                            } else {
                                previousParent.appendChild(node.firstChild);
                                fragment.appendChild(previousParent);
                            }
                            previousParent = paraElm;
                            isPreviousInlineElem = true;
                        } else {
                            fragment.appendChild(node.firstChild);
                            isPreviousInlineElem = false;
                        }
                        isFirstTextNode = false;
                    }
                }
                node.parentNode.replaceChild(fragment, node);
            }
        }
        if (lastSelectionNode.nodeName === "TABLE") {
            var pTag = (0, $4ZDHT.createElement)("p");
            pTag.appendChild((0, $4ZDHT.createElement)("br"));
            lastSelectionNode.parentElement.insertBefore(pTag, lastSelectionNode.nextSibling);
            lastSelectionNode = pTag;
        }
        if (lastSelectionNode.nodeName === "#text") this.placeCursorEnd(lastSelectionNode, node, nodeSelection, docElement, editNode);
        else if (lastSelectionNode.nodeName === "HR") {
            var nextSiblingNode = lastSelectionNode.nextSibling ? lastSelectionNode.nextSibling : null;
            var siblingTag = enterAction === "DIV" ? (0, $4ZDHT.createElement)("div") : (0, $4ZDHT.createElement)("p");
            siblingTag.appendChild((0, $4ZDHT.createElement)("br"));
            if (!(0, $3EnZW.isNullOrUndefined)(nextSiblingNode) && nextSiblingNode.nodeName === "HR") {
                lastSelectionNode.parentNode.insertBefore(siblingTag, nextSiblingNode);
                lastSelectionNode = siblingTag;
            } else if (!(0, $3EnZW.isNullOrUndefined)(nextSiblingNode)) lastSelectionNode = nextSiblingNode;
            else {
                lastSelectionNode.parentNode.appendChild(siblingTag);
                lastSelectionNode.parentNode.insertBefore(lastSelectionNode, siblingTag);
                lastSelectionNode = siblingTag;
            }
            nodeSelection.setSelectionText(docElement, lastSelectionNode, lastSelectionNode, 0, 0);
        } else this.cursorPos(lastSelectionNode, node, nodeSelection, docElement, editNode, enterAction);
        this.alignCheck(editNode);
    };
    InsertHtml.placeCursorEnd = function(lastSelectionNode, node, nodeSelection, docElement, editNode) {
        lastSelectionNode = lastSelectionNode.nodeName === "BR" ? (0, $3EnZW.isNullOrUndefined)(lastSelectionNode.previousSibling) ? lastSelectionNode.parentNode : lastSelectionNode.previousSibling : lastSelectionNode;
        while(!(0, $3EnZW.isNullOrUndefined)(lastSelectionNode) && lastSelectionNode.nodeName !== "#text" && lastSelectionNode.nodeName !== "IMG" && lastSelectionNode.nodeName !== "BR" && lastSelectionNode.nodeName !== "HR"){
            if (!(0, $3EnZW.isNullOrUndefined)(lastSelectionNode.lastChild) && lastSelectionNode.lastChild.nodeName === "P" && lastSelectionNode.lastChild.innerHTML === "") {
                var lineBreak = (0, $4ZDHT.createElement)("br");
                lastSelectionNode.lastChild.appendChild(lineBreak);
            }
            lastSelectionNode = lastSelectionNode.lastChild;
        }
        lastSelectionNode = (0, $3EnZW.isNullOrUndefined)(lastSelectionNode) ? node : lastSelectionNode;
        if (lastSelectionNode.nodeName === "IMG") this.imageFocus(lastSelectionNode, nodeSelection, docElement);
        else nodeSelection.setSelectionText(docElement, lastSelectionNode, lastSelectionNode, lastSelectionNode.textContent.length, lastSelectionNode.textContent.length);
        this.removeEmptyElements(editNode);
    };
    InsertHtml.getNodeCollection = function(range, nodeSelection, node) {
        var nodes = [];
        if (range.startOffset === range.endOffset && range.startContainer === range.endContainer && range.startContainer.nodeName !== "BR" && range.startContainer.childNodes.length > 0 && (range.startContainer.nodeName === "TD" || range.startContainer.nodeType !== 3 && node.classList && node.classList.contains("pasteContent"))) nodes.push(range.startContainer.childNodes[range.endOffset]);
        else nodes = nodeSelection.getInsertNodeCollection(range);
        return nodes;
    };
    InsertHtml.insertTempNode = function(range, node, nodes, nodeCutter, editNode) {
        if (range.startContainer === editNode && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.endOffset - 1]) && range.startContainer.childNodes[range.endOffset - 1].nodeName === "TABLE") {
            if ((0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.endOffset - 1].nextSibling)) range.startContainer.appendChild(node);
            else range.startContainer.insertBefore(node, range.startContainer.childNodes[range.endOffset - 1].nextSibling);
        } else if (range.startContainer === editNode && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.endOffset]) && range.startContainer.childNodes[range.endOffset].nodeName === "TABLE") range.startContainer.insertBefore(node, range.startContainer.childNodes[range.endOffset]);
        else if (range.startContainer === range.endContainer && range.startContainer.nodeType !== 3 && node.firstChild.nodeName === "HR") {
            if (range.startContainer.classList.contains("e-content") || range.startContainer.nodeName === "BODY") range.startContainer.appendChild(node);
            else range.startContainer.parentNode.insertBefore(node, range.startContainer);
        } else {
            var blockNode = this.getImmediateBlockNode(nodes[nodes.length - 1], editNode);
            if (((0, $3EnZW.isNullOrUndefined)(blockNode) || (0, $3EnZW.isNullOrUndefined)(blockNode.parentElement)) && range.endContainer.nodeType !== 3) {
                blockNode = range.endContainer;
                range.setEnd(blockNode, range.endContainer.textContent.length);
            }
            if (blockNode && blockNode.nodeName === "BODY" && range.startContainer === range.endContainer && range.startContainer.nodeType === 1) blockNode = range.startContainer;
            if (blockNode && blockNode.closest("LI") && editNode.contains(blockNode.closest("LI")) && blockNode.nodeName !== "TD" && blockNode.nodeName !== "TH" && blockNode.nodeName !== "TR" && node && node.firstElementChild && (node.firstElementChild.tagName === "OL" || node.firstElementChild.tagName === "UL")) {
                var liNode = void 0;
                while(node.firstElementChild.lastElementChild && node.firstElementChild.lastElementChild.tagName === "LI"){
                    liNode = node.firstElementChild.lastElementChild;
                    liNode.style.removeProperty("margin-left");
                    liNode.style.removeProperty("margin-top");
                    liNode.style.removeProperty("margin-bottom");
                    node.firstElementChild.insertAdjacentElement("afterend", liNode);
                }
            }
            if (blockNode && blockNode.nodeName === "TD" || blockNode.nodeName === "TH" || blockNode.nodeName === "TR") {
                var tempSpan = (0, $4ZDHT.createElement)("span", {
                    className: "tempSpan"
                });
                range.insertNode(tempSpan);
                tempSpan.parentNode.replaceChild(node, tempSpan);
            } else {
                var nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
                var currentNode = this.getNodeCollection(range, nodeSelection, node)[this.getNodeCollection(range, nodeSelection, node).length - 1];
                var splitedElm = void 0;
                if ((currentNode.nodeName === "BR" || currentNode.nodeName === "HR" || currentNode.nodeName === "#text" && !(0, $3EnZW.isNullOrUndefined)(currentNode.parentElement) && currentNode.parentElement.nodeName === "LI") && !(0, $3EnZW.isNullOrUndefined)(currentNode.parentElement) && currentNode.parentElement.textContent.trim().length === 0) {
                    splitedElm = currentNode;
                    if (currentNode.parentElement.nodeName === "LI" && !(0, $3EnZW.isNullOrUndefined)(currentNode.nextSibling) && currentNode.nextSibling.nodeName === "BR") (0, $4ZDHT.detach)(currentNode.nextSibling);
                    if (currentNode.parentElement.nodeName === "LI" && currentNode.parentElement.textContent === "") {
                        this.removeListfromPaste(range);
                        range.insertNode(node);
                        this.contentsDeleted = true;
                        return;
                    }
                } else if ((currentNode.nodeName === "#text" || currentNode.nodeName === "BR") && !(0, $3EnZW.isNullOrUndefined)(currentNode.parentElement) && (currentNode.parentElement.nodeName === "LI" || currentNode.parentElement.closest("LI") || blockNode === editNode && currentNode.parentElement === blockNode) && currentNode.parentElement.textContent.trim().length > 0) {
                    splitedElm = currentNode;
                    if (currentNode.parentElement.nodeName === "LI" && !(0, $3EnZW.isNullOrUndefined)(currentNode.nextSibling) && currentNode.nextSibling.nodeName === "BR") (0, $4ZDHT.detach)(currentNode.nextSibling);
                    if (!range.collapsed) this.removeListfromPaste(range);
                    range.insertNode(node);
                    this.contentsDeleted = true;
                    return;
                } else splitedElm = nodeCutter.GetSpliceNode(range, blockNode);
                splitedElm.parentNode.replaceChild(node, splitedElm);
            }
        }
    };
    InsertHtml.cursorPos = function(lastSelectionNode, node, nodeSelection, docElement, editNode, enterAction) {
        lastSelectionNode.classList.add("lastNode");
        editNode.innerHTML = (0, $259257662ca103fc$export$cce115c473292573)(editNode.innerHTML, enterAction);
        lastSelectionNode = editNode.querySelector(".lastNode");
        if (!(0, $3EnZW.isNullOrUndefined)(lastSelectionNode)) {
            this.placeCursorEnd(lastSelectionNode, node, nodeSelection, docElement, editNode);
            lastSelectionNode.classList.remove("lastNode");
            if (lastSelectionNode.classList.length === 0) lastSelectionNode.removeAttribute("class");
        }
    };
    InsertHtml.imageFocus = function(node, nodeSelection, docElement) {
        var focusNode = document.createTextNode(" ");
        if (node.parentNode && node.parentNode.nodeName === "A") {
            var anchorTag = node.parentNode;
            var parentNode = anchorTag.parentNode;
            parentNode.insertBefore(focusNode, anchorTag.nextSibling);
            parentNode.insertBefore(node, focusNode);
        } else node.parentNode.insertBefore(focusNode, node.nextSibling);
        nodeSelection.setSelectionText(docElement, node.nextSibling, node.nextSibling, 0, 0);
    };
    // eslint-disable-next-line
    InsertHtml.getImmediateBlockNode = function(node, editNode) {
        do node = node.parentNode;
        while (node && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(node.nodeName.toLocaleLowerCase()) < 0);
        return node;
    };
    InsertHtml.removingComments = function(elm) {
        var innerElement = elm.innerHTML;
        innerElement = innerElement.replace(/<!--[\s\S]*?-->/g, "");
        elm.innerHTML = innerElement;
    };
    InsertHtml.findDetachEmptyElem = function(element, ignoreBlockNodes) {
        if (ignoreBlockNodes === void 0) ignoreBlockNodes = false;
        var removableElement;
        if (!(0, $3EnZW.isNullOrUndefined)(element.parentElement)) {
            var hasNbsp = element.parentElement.textContent.length > 0 && element.parentElement.textContent.match(/\u00a0/g) && element.parentElement.textContent.match(/\u00a0/g).length > 0;
            if (!hasNbsp && element.parentElement.textContent.trim() === "" && element.parentElement.contentEditable !== "true" && (0, $3EnZW.isNullOrUndefined)(element.parentElement.querySelector("img")) && element.parentElement.nodeName !== "TD" && element.parentElement.nodeName !== "TH") removableElement = ignoreBlockNodes && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(element.parentElement.tagName.toLowerCase()) !== -1 ? element : this.findDetachEmptyElem(element.parentElement, ignoreBlockNodes);
            else removableElement = ignoreBlockNodes && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(element.tagName.toLowerCase()) !== -1 ? null : element;
        } else removableElement = null;
        return removableElement;
    };
    InsertHtml.removeEmptyElements = function(element, ignoreBlockNodes) {
        if (ignoreBlockNodes === void 0) ignoreBlockNodes = false;
        var emptyElements = element.querySelectorAll(":empty");
        var nonSvgEmptyElements = Array.from(emptyElements).filter(function(element) {
            // Check if the element is an SVG element or an ancestor of an SVG element
            return !element.closest("svg") && !element.closest("canvas");
        });
        for(var i = 0; i < nonSvgEmptyElements.length; i++){
            var lineWithDiv = true;
            if (nonSvgEmptyElements[i].tagName === "DIV") lineWithDiv = nonSvgEmptyElements[i].style.borderBottom === "none" || nonSvgEmptyElements[i].style.borderBottom === "" ? true : false;
            if ($56b963295b740d00$export$7f7c530a82f07f20.indexOf(nonSvgEmptyElements[i].tagName.toLowerCase()) < 0 && lineWithDiv) {
                var detachableElement = this.findDetachEmptyElem(nonSvgEmptyElements[i], ignoreBlockNodes);
                if (!(0, $3EnZW.isNullOrUndefined)(detachableElement)) (0, $4ZDHT.detach)(detachableElement);
            }
        }
    };
    InsertHtml.closestEle = function(element, editNode) {
        var el = element;
        if ((0, $4ZDHT.closest)(el, "li")) return (0, $4ZDHT.closest)(el, "li");
        while(el && el.nodeType === 1){
            if (el.parentNode === editNode || !(0, $3EnZW.isNullOrUndefined)(el.parentNode.tagName) && $56b963295b740d00$export$5668f6141f812fad.indexOf(el.parentNode.tagName.toLocaleLowerCase()) !== -1) return el;
            el = el.parentNode;
        }
        return null;
    };
    InsertHtml.insertTableInList = function(range, insertNode, parentNode, currentNode, nodeCutter) {
        if (range.collapsed) {
            var isStart = range.startOffset === 0;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var isEnd = range.startContainer.textContent.trimEnd().length === range.startOffset;
            if (isStart || isEnd) {
                if (isStart) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(insertNode, currentNode, false);
                else (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).AppendBefore(insertNode, currentNode, true);
            } else {
                var preNode = nodeCutter.SplitNode(range, parentNode, true);
                var sibNode = preNode.previousSibling;
                sibNode.appendChild(insertNode);
            }
        } else {
            range.deleteContents();
            parentNode.appendChild(insertNode);
        }
        insertNode.classList.add("ignore-table");
    };
    InsertHtml.alignCheck = function(editNode) {
        var spanAligns = editNode.querySelectorAll('span[style*="text-align"]');
        for(var i = 0; i < spanAligns.length; i++){
            var spanAlign = spanAligns[i];
            if (spanAlign) {
                var blockAlign = this.getImmediateBlockNode(spanAlign, null);
                if (blockAlign) {
                    var totalSpanText = "";
                    for(var j = 0; j < spanAligns.length; j++){
                        var span = spanAligns[j];
                        if (blockAlign.contains(span)) totalSpanText += span.textContent;
                    }
                    if (blockAlign.textContent.trim() === totalSpanText.trim()) blockAlign.style.textAlign = spanAlign.style.textAlign;
                }
            }
        }
    };
    InsertHtml.removeListfromPaste = function(range) {
        range.deleteContents();
        var value = range.startContainer;
        if (!(0, $3EnZW.isNullOrUndefined)(value) && value.nodeName === "LI" && !(0, $3EnZW.isNullOrUndefined)(value.parentElement) && (value.parentElement.nodeName === "OL" || value.parentElement.nodeName === "UL") && value.textContent.trim() === "") value.parentElement.querySelectorAll("li").forEach(function(item) {
            if (item.textContent.trim() === "") item.remove();
        });
    };
    /**
     * Insert method
     *
     * @hidden

     */ InsertHtml.inlineNode = [
        "a",
        "abbr",
        "acronym",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "br",
        "button",
        "canvas",
        "cite",
        "code",
        "data",
        "datalist",
        "del",
        "dfn",
        "em",
        "embed",
        "font",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "map",
        "mark",
        "meter",
        "noscript",
        "object",
        "output",
        "picture",
        "progress",
        "q",
        "ruby",
        "s",
        "samp",
        "script",
        "select",
        "slot",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "svg",
        "template",
        "textarea",
        "time",
        "u",
        "tt",
        "var",
        "video",
        "wbr"
    ];
    InsertHtml.contentsDeleted = false;
    return InsertHtml;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Link internal component
 *
 * @hidden

 */ var $12fb7df4ec593114$export$716db6c6fd6cbe7b = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the editor manager
     * @hidden

     */ function LinkCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    LinkCommand.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$b395009ca7f092c7, this.linkCommand, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    LinkCommand.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$b395009ca7f092c7, this.linkCommand);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    LinkCommand.prototype.linkCommand = function(e) {
        switch(e.value.toString().toLocaleLowerCase()){
            case "createlink":
            case "editlink":
                this.createLink(e);
                break;
            case "openlink":
                this.openLink(e);
                break;
            case "removelink":
                this.removeLink(e);
                break;
        }
    };
    LinkCommand.prototype.createLink = function(e) {
        var closestAnchor = !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && e.item.selectParent.length > 0 && (0, $4ZDHT.closest)(e.item.selectParent[0], "a");
        closestAnchor = !(0, $3EnZW.isNullOrUndefined)(closestAnchor) ? closestAnchor : !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && e.item.selectParent.length > 0 ? e.item.selectParent[0] : null;
        if (!(0, $3EnZW.isNullOrUndefined)(closestAnchor) && closestAnchor.tagName === "A") {
            var anchorEle = closestAnchor;
            var linkText = "";
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.url)) anchorEle.setAttribute("href", e.item.url);
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.title)) anchorEle.setAttribute("title", e.item.title);
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.text) && e.item.text !== "") {
                linkText = anchorEle.innerText;
                if (anchorEle.firstChild.nodeName === "#text") anchorEle.innerText = e.item.text;
                else anchorEle.firstChild.innerText = e.item.text;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.target)) {
                anchorEle.setAttribute("target", e.item.target);
                anchorEle.setAttribute("aria-label", e.item.ariaLabel);
            } else {
                anchorEle.removeAttribute("target");
                anchorEle.removeAttribute("aria-label");
            }
            if (linkText === e.item.text) {
                e.item.selection.setSelectionText(this.parent.currentDocument, anchorEle, anchorEle, 1, 1);
                e.item.selection.restore();
            } else {
                var startIndex = e.item.action === "Paste" ? anchorEle.childNodes[0].textContent.length : 0;
                var endIndex = anchorEle.firstChild.nodeName === "#text" ? anchorEle.childNodes[0].textContent.length : anchorEle.childNodes.length;
                e.item.selection.setSelectionText(this.parent.currentDocument, anchorEle.childNodes[0], anchorEle.childNodes[0], startIndex, endIndex);
            }
        } else {
            var domSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
            var range = domSelection.getRange(this.parent.currentDocument);
            if (range.endContainer.nodeName === "#text" && range.startContainer.textContent.length === range.endOffset + 1 && range.endContainer.textContent.charAt(range.endOffset) === " " && !(0, $3EnZW.isNullOrUndefined)(range.endContainer.nextSibling) && range.endContainer.nextSibling.nodeName === "A") {
                domSelection.setSelectionText(this.parent.currentDocument, range.startContainer, range.endContainer, range.startOffset, range.endOffset + 1);
                range = domSelection.getRange(this.parent.currentDocument);
            }
            var text = (0, $3EnZW.isNullOrUndefined)(e.item.text) ? true : e.item.text.replace(/ /g, "").localeCompare(range.toString().replace(/\n/g, " ").replace(/ /g, "")) < 0;
            if (e.event && e.event.type === "keydown" && (e.event.keyCode === 32 || e.event.keyCode === 13) || e.item.action === "Paste" || range.collapsed || text) {
                var anchor = this.createAchorNode(e);
                anchor.innerText = e.item.text === "" ? e.item.url : e.item.text;
                var text_1 = anchor.innerText;
                // Replace spaces with non-breaking spaces
                var modifiedText = text_1.replace(/  +/g, function(match) {
                    return "\xa0".repeat(match.length);
                });
                anchor.innerText = modifiedText;
                e.item.selection.restore();
                (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, anchor, this.parent.editableElement);
                if (e.event && e.event.type === "keydown" && (e.event.keyCode === 32 || e.event.keyCode === 13)) {
                    var startContainer = e.item.selection.range.startContainer;
                    startContainer.textContent = this.removeText(startContainer.textContent, e.item.text);
                } else {
                    var startIndex = e.item.action === "Paste" ? anchor.childNodes[0].textContent.length : 0;
                    e.item.selection.setSelectionText(this.parent.currentDocument, anchor.childNodes[0], anchor.childNodes[0], startIndex, anchor.childNodes[0].textContent.length);
                }
            } else this.createLinkNode(e);
        }
        if (e.callBack) e.callBack({
            requestType: "Links",
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    LinkCommand.prototype.createLinkNode = function(e) {
        var domSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
        var range = domSelection.getRange(this.parent.currentDocument);
        var nodes = this.getSelectionNodes(domSelection.getNodeCollection(range));
        var save = domSelection.save(range, this.parent.currentDocument);
        var txtArray = [];
        var inlineNodes = [];
        var currentNode;
        var removeNodes = [];
        var anchorNodes = [];
        var finalinlineNodes = [];
        var cloneNode;
        for(var index = 0; index < nodes.length; index++){
            nodes[index] = nodeCutter.GetSpliceNode(range, nodes[index]);
            txtArray[index] = nodes[index];
        }
        for(var i = 0; i < txtArray.length; i++){
            var check = true;
            currentNode = txtArray[i];
            while(check === true){
                if (currentNode.parentNode.nodeName === "A") {
                    var anchorEle = currentNode.parentNode;
                    currentNode.parentNode.parentNode.insertBefore(anchorEle.firstChild, anchorEle);
                    currentNode.parentNode.removeChild(anchorEle);
                }
                if (this.isBlockNode(currentNode.parentNode) || txtArray.length === 0 || i === 0 || i === txtArray.length - 1 || range.startContainer.nodeType === 3) {
                    inlineNodes[i] = currentNode;
                    check = false;
                } else currentNode = currentNode.parentNode;
            }
        }
        for(var i = 0, j_1 = 0; i < inlineNodes.length; i++){
            if (i === 0) finalinlineNodes[j_1] = inlineNodes[i];
            if (inlineNodes.length > 1 && i < inlineNodes.length - 1) {
                if (inlineNodes[i].parentElement === inlineNodes[i + 1].parentElement && inlineNodes[i] === inlineNodes[i + 1]) continue;
                else {
                    finalinlineNodes[j_1 + 1] = inlineNodes[i + 1];
                    j_1++;
                }
            }
        }
        var j = 0;
        anchorNodes[j] = this.createAchorNode(e);
        for(var i = 0; i < finalinlineNodes.length; i++){
            if (i === 0) {
                cloneNode = finalinlineNodes[i].cloneNode(true);
                anchorNodes[i].appendChild(cloneNode);
            }
            if (i < finalinlineNodes.length - 1) {
                if (finalinlineNodes[i].parentNode === finalinlineNodes[i + 1].parentNode) {
                    var cln = finalinlineNodes[i + 1].cloneNode(true);
                    anchorNodes[j].appendChild(cln);
                } else {
                    j = j + 1;
                    anchorNodes[j] = this.createAchorNode(e);
                    cloneNode = finalinlineNodes[i + 1].cloneNode(true);
                    anchorNodes[j].appendChild(cloneNode);
                }
            }
        }
        this.parent.nodeSelection.setRange(document, save.range);
        for(var i = 0, j_2 = 0, k = 0; i <= finalinlineNodes.length; i++){
            if (i === 0) {
                finalinlineNodes[i].parentNode.insertBefore(anchorNodes[j_2], finalinlineNodes[i].nextSibling);
                if (this.parent.domNode.blockNodes().length === 1 && anchorNodes.length === 1) this.parent.nodeSelection.setSelectionNode(this.parent.currentDocument, anchorNodes[j_2]);
                removeNodes[k] = finalinlineNodes[i];
                k++;
            }
            if (i < finalinlineNodes.length - 1) {
                if (finalinlineNodes[i].parentNode === finalinlineNodes[i + 1].parentNode) {
                    removeNodes[k] = finalinlineNodes[i + 1];
                    k++;
                } else {
                    j_2 = j_2 + 1;
                    finalinlineNodes[i + 1].parentNode.insertBefore(anchorNodes[j_2], finalinlineNodes[i + 1]);
                    removeNodes[k] = finalinlineNodes[i + 1];
                    k++;
                }
            }
        }
        for(var i = 0; i < removeNodes.length; i++)if (removeNodes[i].parentNode) removeNodes[i].parentNode.removeChild(removeNodes[i]);
    };
    LinkCommand.prototype.createAchorNode = function(e) {
        var anchorEle = (0, $4ZDHT.createElement)("a", {
            className: "e-rte-anchor",
            attrs: {
                href: e.item.url,
                title: (0, $3EnZW.isNullOrUndefined)(e.item.title) || e.item.title === "" ? e.item.url : e.item.title
            }
        });
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.target)) anchorEle.setAttribute("target", e.item.target);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.ariaLabel)) anchorEle.setAttribute("aria-label", e.item.ariaLabel);
        return anchorEle;
    };
    LinkCommand.prototype.getSelectionNodes = function(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        for(var index = 0; index < nodeCollection.length; index++){
            if (nodeCollection[index].nodeType !== 3 || nodeCollection[index].textContent.trim() === "") {
                if (nodeCollection[index].nodeName !== "IMG") {
                    nodeCollection.splice(index, 1);
                    index--;
                }
            }
        }
        return nodeCollection.reverse();
    };
    LinkCommand.prototype.isBlockNode = function(element) {
        return !!element && element.nodeType === Node.ELEMENT_NODE && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(element.tagName.toLowerCase()) >= 0;
    };
    LinkCommand.prototype.removeText = function(text, val) {
        var arr = text.split(" ");
        for(var i = 0; i < arr.length; i++)if (arr[i] === val) {
            arr.splice(i, 1);
            i--;
        }
        return arr.join(" ") + " ";
    };
    LinkCommand.prototype.openLink = function(e) {
        document.defaultView.open(e.item.url, e.item.target);
        this.callBack(e);
    };
    LinkCommand.prototype.removeLink = function(e) {
        var blockNodes = this.parent.domNode.blockNodes();
        if (blockNodes.length < 2) {
            this.parent.domNode.setMarker(e.item.selection);
            var closestAnchor = (0, $4ZDHT.closest)(e.item.selectParent[0], "a");
            var selectParent = closestAnchor ? closestAnchor : e.item.selectParent[0];
            var parent_1 = selectParent.parentNode;
            var child = [];
            for(; selectParent.firstChild;){
                if (parent_1) child.push(parent_1.insertBefore(selectParent.firstChild, selectParent));
                else break;
            }
            parent_1.removeChild(selectParent);
            if (child && child.length === 1) {
                e.item.selection.startContainer = e.item.selection.getNodeArray(child[child.length - 1], true);
                e.item.selection.endContainer = e.item.selection.startContainer;
            }
            e.item.selection = this.parent.domNode.saveMarker(e.item.selection);
        } else for(var i = 0; i < blockNodes.length; i++){
            var linkNode = blockNodes[i].querySelectorAll("a");
            for(var j = 0; j < linkNode.length; j++)if (this.parent.currentDocument.getSelection().containsNode(linkNode[j], true)) linkNode[j].outerHTML = linkNode[j].innerHTML;
        }
        e.item.selection.restore();
        this.callBack(e);
    };
    LinkCommand.prototype.callBack = function(e) {
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    LinkCommand.prototype.destroy = function() {
        this.removeEventListener();
    };
    return LinkCommand;
}();



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");


/**
 * Formats internal component
 *
 * @hidden

 */ var $d7bd1980500e1bb6$export$778d96ef961014bf = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element.
     * @returns {void}
     * @hidden

     */ function Alignments(parent) {
        this.alignments = {
            "JustifyLeft": "left",
            "JustifyCenter": "center",
            "JustifyRight": "right",
            "JustifyFull": "justify"
        };
        this.parent = parent;
        this.addEventListener();
    }
    Alignments.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$d79d483636d4477c, this.applyAlignment, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    Alignments.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$d79d483636d4477c, this.applyAlignment);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    Alignments.prototype.onKeyDown = function(e) {
        switch(e.event.action){
            case "justify-center":
                this.applyAlignment({
                    subCommand: "JustifyCenter",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "justify-full":
                this.applyAlignment({
                    subCommand: "JustifyFull",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "justify-left":
                this.applyAlignment({
                    subCommand: "JustifyLeft",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "justify-right":
                this.applyAlignment({
                    subCommand: "JustifyRight",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
        }
    };
    Alignments.prototype.getTableNode = function(range) {
        var startNode = range.startContainer.nodeType === Node.ELEMENT_NODE ? range.startContainer : range.startContainer.parentNode;
        var cellNode = (0, $4ZDHT.closest)(startNode, "td,th");
        return [
            cellNode
        ];
    };
    Alignments.prototype.applyAlignment = function(e) {
        var isTableAlign = e.value === "Table" ? true : false;
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var save = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        if (!isTableAlign) {
            this.parent.domNode.setMarker(save);
            var alignmentNodes = this.parent.domNode.blockNodes();
            if (e.enterAction === "BR") alignmentNodes = this.parent.domNode.convertToBlockNodes(alignmentNodes, false);
            for(var i = 0; i < alignmentNodes.length; i++){
                var parentNode = alignmentNodes[i];
                (0, $4ZDHT.setStyleAttribute)(parentNode, {
                    "text-align": this.alignments[e.subCommand]
                });
            }
            var imageTags = this.parent.domNode.getImageTagInSelection();
            for(var i = 0; i < imageTags.length; i++){
                var elementNode = [];
                elementNode.push(imageTags[i]);
                this.parent.imgObj.imageCommand({
                    item: {
                        selectNode: elementNode
                    },
                    subCommand: e.subCommand,
                    value: e.subCommand,
                    callBack: e.callBack,
                    selector: e.selector
                });
            }
            this.parent.editableElement.focus({
                preventScroll: true
            });
            save = this.parent.domNode.saveMarker(save);
            if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(this.parent.editableElement, e.selector);
            save.restore();
        } else (0, $4ZDHT.setStyleAttribute)(this.getTableNode(range)[0], {
            "text-align": this.alignments[e.subCommand]
        });
        if (e.callBack) e.callBack({
            requestType: e.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: isTableAlign ? this.getTableNode(range) : this.parent.domNode.blockNodes()
        });
    };
    Alignments.prototype.destroy = function() {
        this.removeEventListener();
    };
    return Alignments;
}();





/**
 * Indents internal component
 *
 * @hidden

 */ var $de6987afc8e510a6$export$1a8bb67630667279 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function Indents(parent) {
        this.indentValue = 20;
        this.parent = parent;
        this.addEventListener();
    }
    Indents.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$303836d45647271d, this.applyIndents, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    Indents.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$303836d45647271d, this.applyIndents);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    Indents.prototype.onKeyDown = function(e) {
        switch(e.event.action){
            case "indents":
                this.applyIndents({
                    subCommand: "Indent",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "outdents":
                this.applyIndents({
                    subCommand: "Outdent",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
        }
    };
    Indents.prototype.applyIndents = function(e) {
        var editEle = this.parent.editableElement;
        var isRtl = editEle.classList.contains("e-rtl");
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var save = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        this.parent.domNode.setMarker(save);
        var indentsNodes = this.parent.domNode.blockNodes();
        if (e.enterAction === "BR") indentsNodes = this.parent.domNode.convertToBlockNodes(indentsNodes, false);
        var parentNodes = indentsNodes.slice();
        var listsNodes = [];
        for(var i = 0; i < parentNodes.length; i++){
            if (parentNodes[i].tagName !== "LI" && "LI" === parentNodes[i].parentNode.tagName) {
                indentsNodes.splice(indentsNodes.indexOf(parentNodes[i]), 1);
                listsNodes.push(parentNodes[i].parentNode);
            } else if (parentNodes[i].tagName === "LI") {
                indentsNodes.splice(indentsNodes.indexOf(parentNodes[i]), 1);
                listsNodes.push(parentNodes[i]);
            }
        }
        if (listsNodes.length > 0) this.parent.observer.notify($ee11fb99ae4d2c3e$export$76852bc82d3e273b, {
            event: {
                preventDefault: function() {
                    return;
                },
                stopPropagation: function() {
                    return;
                },
                shiftKey: e.subCommand === "Indent" ? false : true,
                which: 9,
                action: "indent"
            }
        });
        for(var i = 0; i < indentsNodes.length; i++){
            var parentNode = indentsNodes[i];
            var marginLeftOrRight = isRtl ? parentNode.style.marginRight : parentNode.style.marginLeft;
            var indentsValue = void 0;
            if (e.subCommand === "Indent") {
                /* eslint-disable */ indentsValue = marginLeftOrRight === "" ? this.indentValue + "px" : parseInt(marginLeftOrRight, null) + this.indentValue + "px";
                isRtl ? parentNode.style.marginRight = indentsValue : parentNode.style.marginLeft = indentsValue;
            } else {
                indentsValue = marginLeftOrRight === "" || marginLeftOrRight === "0px" || marginLeftOrRight === "0in" ? "" : parseInt(marginLeftOrRight, null) - this.indentValue + "px";
                isRtl ? parentNode.style.marginRight = indentsValue : parentNode.style.marginLeft = indentsValue;
            /* eslint-enable */ }
        }
        editEle.focus({
            preventScroll: true
        });
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(editEle, e.selector);
        save = this.parent.domNode.saveMarker(save);
        save.restore();
        if (e.callBack) e.callBack({
            requestType: e.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.domNode.blockNodes()
        });
    };
    Indents.prototype.destroy = function() {
        this.removeEventListener();
    };
    return Indents;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Rich Text Editor classes defined here.
 */ /**
 * @hidden

 */ var $a55b1d4723d2c9fa$export$f81a032811eb58dc = "e-imgright";
var $a55b1d4723d2c9fa$export$93d6d348ebc7339b = "e-imgleft";
var $a55b1d4723d2c9fa$export$26772a1f5f3475b9 = "e-imgcenter";
var $a55b1d4723d2c9fa$export$a9a8177cbbeafa5b = "e-video-right";
var $a55b1d4723d2c9fa$export$37ea167cf9949f90 = "e-video-left";
var $a55b1d4723d2c9fa$export$18d05a53549dadb3 = "e-video-center";
var $a55b1d4723d2c9fa$export$9cc350563ffd58ce = "e-imgbreak";
var $a55b1d4723d2c9fa$export$565fffcabd84d016 = "e-audio-break";
var $a55b1d4723d2c9fa$export$68c9ac73bcff26fd = "e-video-break";
var $a55b1d4723d2c9fa$export$b755d214af40ff87 = "e-img-caption";
var $a55b1d4723d2c9fa$export$9f84b6e68d75d81 = "e-rte-img-caption";
var $a55b1d4723d2c9fa$export$2cdf4f5bc5e6ab17 = "e-caption-inline";
var $a55b1d4723d2c9fa$export$2c7f4b9de2fcd836 = "e-imginline";
var $a55b1d4723d2c9fa$export$45a36adcbe83d7d1 = "e-audio-inline";
var $a55b1d4723d2c9fa$export$68b81b7a25917fd9 = "e-clickelem";
var $a55b1d4723d2c9fa$export$6a881736acda7d9 = "e-video-clickelem";
var $a55b1d4723d2c9fa$export$e60e94c39d5aeebd = "e-rte-audio";
var $a55b1d4723d2c9fa$export$4947cd40388c7e29 = "e-rte-video";
var $a55b1d4723d2c9fa$export$3b06fc142c718da9 = "e-audio-wrap";
var $a55b1d4723d2c9fa$export$56c9d038288f600d = "e-video-wrap";
var $a55b1d4723d2c9fa$export$1e4e627aeae7457e = "e-embed-video-wrap";
var $a55b1d4723d2c9fa$export$cd3465bd206f5f9b = "e-audio-focus";
var $a55b1d4723d2c9fa$export$2b3796ce7d0e9d00 = "e-video-focus";
var $a55b1d4723d2c9fa$export$b42ef43587637838 = "e-video-inline";




/**
 * Link internal component
 *
 * @hidden

 */ var $e6c697d9184b91d9$export$cfd550c1514622de = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function ImageCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    ImageCommand.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$74f94c628b84d921, this.imageCommand, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    ImageCommand.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$74f94c628b84d921, this.imageCommand);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * imageCommand method
     *
     * @param {IHtmlItem} e - specifies the element
     * @returns {void}
     * @hidden

     */ ImageCommand.prototype.imageCommand = function(e) {
        switch(e.value.toString().toLowerCase()){
            case "image":
            case "replace":
                this.createImage(e);
                break;
            case "insertlink":
                this.insertImageLink(e);
                break;
            case "openimagelink":
                this.openImageLink(e);
                break;
            case "editimagelink":
                this.editImageLink(e);
                break;
            case "removeimagelink":
                this.removeImageLink(e);
                break;
            case "remove":
                this.removeImage(e);
                break;
            case "alttext":
                this.insertAltTextImage(e);
                break;
            case "dimension":
                this.imageDimension(e);
                break;
            case "caption":
                this.imageCaption(e);
                break;
            case "justifyleft":
                this.imageJustifyLeft(e);
                break;
            case "justifycenter":
                this.imageJustifyCenter(e);
                break;
            case "justifyright":
                this.imageJustifyRight(e);
                break;
            case "inline":
                this.imageInline(e);
                break;
            case "break":
                this.imageBreak(e);
                break;
        }
    };
    ImageCommand.prototype.createImage = function(e) {
        var _this = this;
        var isReplaced = false;
        e.item.url = (0, $3EnZW.isNullOrUndefined)(e.item.url) || e.item.url === "undefined" ? e.item.src : e.item.url;
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && e.item.selectParent[0].tagName === "IMG") {
            var imgEle = e.item.selectParent[0];
            isReplaced = true;
            this.setStyle(imgEle, e, isReplaced);
        } else {
            var imgElement = (0, $4ZDHT.createElement)("img");
            this.setStyle(imgElement, e);
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.selection)) e.item.selection.restore();
            if (!(0, $3EnZW.isNullOrUndefined)(e.selector) && e.selector === "pasteCleanupModule") {
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.currentDocument)) e.callBack({
                    requestType: "Images",
                    editorMode: "HTML",
                    event: e.event,
                    range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                    elements: [
                        imgElement
                    ]
                });
            } else (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, imgElement, this.parent.editableElement);
        }
        if (e.callBack && ((0, $3EnZW.isNullOrUndefined)(e.selector) || !(0, $3EnZW.isNullOrUndefined)(e.selector) && e.selector !== "pasteCleanupModule")) {
            var selectedNode = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0];
            var imgElm_1 = e.value === "Replace" || isReplaced ? e.item.selectParent[0] : (0, $5q7BP.Browser).isIE ? selectedNode.previousSibling : selectedNode.previousElementSibling;
            var onImageLoadEvent_1 = function() {
                if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.currentDocument)) e.callBack({
                    requestType: e.value === "Replace" ? (e.item.subCommand = "Replace", "Replace") : "Images",
                    editorMode: "HTML",
                    event: e.event,
                    range: _this.parent.nodeSelection.getRange(_this.parent.currentDocument),
                    elements: [
                        imgElm_1
                    ]
                });
                imgElm_1.removeEventListener("load", onImageLoadEvent_1);
            };
            imgElm_1.addEventListener("load", onImageLoadEvent_1);
        }
    };
    ImageCommand.prototype.setStyle = function(imgElement, e, imgReplace) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.url)) imgElement.setAttribute("src", e.item.url);
        var alignClassName;
        if (imgReplace) {
            var alignClass = {
                "e-imgcenter": "e-imgcenter",
                "e-imgright": "e-imgright",
                "e-imgleft": "e-imgleft"
            };
            var imgClassList = imgElement.classList;
            for(var i = 0; i < imgClassList.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(alignClass[imgClassList[i]])) alignClassName = alignClass[imgClassList[i]];
        }
        imgElement.setAttribute("class", "e-rte-image" + ((0, $3EnZW.isNullOrUndefined)(e.item.cssClass) ? "" : " " + e.item.cssClass) + ((0, $3EnZW.isNullOrUndefined)(alignClassName) ? "" : " " + alignClassName));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.altText)) imgElement.setAttribute("alt", e.item.altText.replace(/\.[a-zA-Z0-9]+$/, ""));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.width)) imgElement.setAttribute("width", this.calculateStyleValue(e.item.width.width));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.height)) imgElement.setAttribute("height", this.calculateStyleValue(e.item.height.height));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.minWidth)) imgElement.style.minWidth = this.calculateStyleValue(e.item.width.minWidth);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.maxWidth)) imgElement.style.maxWidth = this.calculateStyleValue(e.item.width.maxWidth);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.minHeight)) imgElement.style.minHeight = this.calculateStyleValue(e.item.height.minHeight);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.maxHeight)) imgElement.style.maxHeight = this.calculateStyleValue(e.item.height.maxHeight);
    };
    ImageCommand.prototype.calculateStyleValue = function(value) {
        var styleValue;
        if (typeof value === "string") {
            if (value.indexOf("px") || value.indexOf("%") || value.indexOf("auto")) styleValue = value;
            else styleValue = value + "px";
        } else styleValue = value + "px";
        return styleValue;
    };
    ImageCommand.prototype.insertImageLink = function(e) {
        var anchor = (0, $4ZDHT.createElement)("a", {
            attrs: {
                href: e.item.url
            }
        });
        if (e.item.selectNode[0].parentElement.classList.contains("e-img-wrap")) {
            e.item.selection.restore();
            anchor.setAttribute("contenteditable", "true");
        }
        anchor.appendChild(e.item.selectNode[0]);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.target)) anchor.setAttribute("target", e.item.target);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.ariaLabel)) anchor.setAttribute("aria-label", e.item.ariaLabel);
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, anchor, this.parent.editableElement);
        this.callBack(e);
    };
    ImageCommand.prototype.openImageLink = function(e) {
        document.defaultView.open(e.item.url, e.item.target);
        this.callBack(e);
    };
    ImageCommand.prototype.removeImageLink = function(e) {
        var selectParent = e.item.selectParent[0];
        if (selectParent.classList.contains("e-img-caption")) {
            var capImgWrap = (0, $4ZDHT.select)(".e-img-wrap", selectParent);
            var textEle = (0, $4ZDHT.select)(".e-img-inner", selectParent);
            var newTextEle = textEle.cloneNode(true);
            (0, $4ZDHT.detach)((0, $4ZDHT.select)("a", selectParent));
            (0, $4ZDHT.detach)(textEle);
            capImgWrap.appendChild(e.item.insertElement);
            capImgWrap.appendChild(newTextEle);
        } else {
            (0, $4ZDHT.detach)(selectParent);
            if ((0, $5q7BP.Browser).isIE && e.item.selection) e.item.selection.restore();
            (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, e.item.insertElement, this.parent.editableElement);
        }
        this.callBack(e);
    };
    ImageCommand.prototype.editImageLink = function(e) {
        e.item.selectNode[0].parentElement.href = e.item.url;
        if ((0, $3EnZW.isNullOrUndefined)(e.item.target)) {
            e.item.selectNode[0].parentElement.removeAttribute("target");
            e.item.selectNode[0].parentElement.removeAttribute("aria-label");
        } else {
            e.item.selectNode[0].parentElement.target = e.item.target;
            e.item.selectNode[0].parentElement.setAttribute("aria-label", e.item.ariaLabel);
        }
        this.callBack(e);
    };
    ImageCommand.prototype.removeImage = function(e) {
        if ((0, $4ZDHT.closest)(e.item.selectNode[0], "a")) {
            if (e.item.selectNode[0].parentElement.nodeName === "A" && !(0, $3EnZW.isNullOrUndefined)(e.item.selectNode[0].parentElement.innerText)) {
                if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.item.selectNode[0], "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) (0, $4ZDHT.detach)((0, $4ZDHT.closest)(e.item.selectNode[0], "." + $a55b1d4723d2c9fa$export$b755d214af40ff87));
                else (0, $4ZDHT.detach)(e.item.selectNode[0]);
            } else (0, $4ZDHT.detach)((0, $4ZDHT.closest)(e.item.selectNode[0], "a"));
        } else if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.item.selectNode[0], "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) (0, $4ZDHT.detach)((0, $4ZDHT.closest)(e.item.selectNode[0], "." + $a55b1d4723d2c9fa$export$b755d214af40ff87));
        else (0, $4ZDHT.detach)(e.item.selectNode[0]);
        this.callBack(e);
    };
    ImageCommand.prototype.insertAltTextImage = function(e) {
        e.item.selectNode[0].setAttribute("alt", e.item.altText);
        this.callBack(e);
    };
    ImageCommand.prototype.imageDimension = function(e) {
        var selectNode = e.item.selectNode[0];
        selectNode.style.height = "";
        selectNode.style.width = "";
        if (e.item.width !== "auto") selectNode.style.width = (0, $3EnZW.formatUnit)(e.item.width);
        else selectNode.removeAttribute("width");
        if (e.item.height !== "auto") selectNode.style.height = (0, $3EnZW.formatUnit)(e.item.height);
        else selectNode.removeAttribute("height");
        this.callBack(e);
    };
    ImageCommand.prototype.imageCaption = function(e) {
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, e.item.insertElement, this.parent.editableElement);
        this.callBack(e);
    };
    ImageCommand.prototype.imageJustifyLeft = function(e) {
        var selectNode = e.item.selectNode[0];
        if (!(0, $3EnZW.isNullOrUndefined)(selectNode)) {
            selectNode.removeAttribute("class");
            (0, $4ZDHT.addClass)([
                selectNode
            ], "e-rte-image");
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) {
                (0, $4ZDHT.removeClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
                (0, $4ZDHT.addClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
            }
            if (selectNode.parentElement.nodeName === "A") {
                (0, $4ZDHT.removeClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
                (0, $4ZDHT.addClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
                (0, $4ZDHT.addClass)([
                    selectNode
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
            } else (0, $4ZDHT.addClass)([
                selectNode
            ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
            this.callBack(e);
        }
    };
    ImageCommand.prototype.imageJustifyCenter = function(e) {
        var selectNode = e.item.selectNode[0];
        if (!(0, $3EnZW.isNullOrUndefined)(selectNode)) {
            selectNode.removeAttribute("class");
            (0, $4ZDHT.addClass)([
                selectNode
            ], "e-rte-image");
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) {
                (0, $4ZDHT.removeClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
                (0, $4ZDHT.removeClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
                (0, $4ZDHT.addClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
            }
            if (selectNode.parentElement.nodeName === "A") {
                (0, $4ZDHT.removeClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
                (0, $4ZDHT.removeClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
                (0, $4ZDHT.addClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
                (0, $4ZDHT.addClass)([
                    selectNode
                ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
            } else (0, $4ZDHT.addClass)([
                selectNode
            ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
            this.callBack(e);
        }
    };
    ImageCommand.prototype.imageJustifyRight = function(e) {
        var selectNode = e.item.selectNode[0];
        if (!(0, $3EnZW.isNullOrUndefined)(selectNode)) {
            selectNode.removeAttribute("class");
            (0, $4ZDHT.addClass)([
                selectNode
            ], "e-rte-image");
            if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) {
                (0, $4ZDHT.removeClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
                (0, $4ZDHT.addClass)([
                    (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
            }
            if (selectNode.parentElement.nodeName === "A") {
                (0, $4ZDHT.removeClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
                (0, $4ZDHT.addClass)([
                    selectNode.parentElement
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
                (0, $4ZDHT.addClass)([
                    selectNode
                ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
            } else (0, $4ZDHT.addClass)([
                selectNode
            ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
            this.callBack(e);
        }
    };
    ImageCommand.prototype.imageInline = function(e) {
        var selectNode = e.item.selectNode[0];
        selectNode.removeAttribute("class");
        (0, $4ZDHT.addClass)([
            selectNode
        ], "e-rte-image");
        (0, $4ZDHT.addClass)([
            selectNode
        ], $a55b1d4723d2c9fa$export$2c7f4b9de2fcd836);
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) {
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$9cc350563ffd58ce);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
            (0, $4ZDHT.addClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$2cdf4f5bc5e6ab17);
        }
        this.callBack(e);
    };
    ImageCommand.prototype.imageBreak = function(e) {
        var selectNode = e.item.selectNode[0];
        selectNode.removeAttribute("class");
        (0, $4ZDHT.addClass)([
            selectNode
        ], $a55b1d4723d2c9fa$export$9cc350563ffd58ce);
        (0, $4ZDHT.addClass)([
            selectNode
        ], "e-rte-image");
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87))) {
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$2cdf4f5bc5e6ab17);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$26772a1f5f3475b9);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$93d6d348ebc7339b);
            (0, $4ZDHT.removeClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$f81a032811eb58dc);
            (0, $4ZDHT.addClass)([
                (0, $4ZDHT.closest)(selectNode, "." + $a55b1d4723d2c9fa$export$b755d214af40ff87)
            ], $a55b1d4723d2c9fa$export$9cc350563ffd58ce);
        }
        this.callBack(e);
    };
    ImageCommand.prototype.callBack = function(e) {
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    ImageCommand.prototype.destroy = function() {
        this.removeEventListener();
    };
    return ImageCommand;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");




/**
 * Audio internal component
 *
 * @hidden

 */ var $9efbc9216fe2941e$export$d3aef97e7cc6d07b = /** @class */ function() {
    /**
     * Constructor for creating the Audio plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function AudioCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    AudioCommand.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$27a341487b23f48f, this.audioCommand, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    AudioCommand.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$27a341487b23f48f, this.audioCommand);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * audioCommand method
     *
     * @param {IHtmlItem} e - specifies the element
     * @returns {void}
     * @hidden

     */ AudioCommand.prototype.audioCommand = function(e) {
        var selectNode;
        var value = e.value.toString().toLowerCase();
        if (value === "inline" || value === "break" || value === "audioremove") selectNode = e.item.selectNode[0];
        switch(value){
            case "audio":
            case "audioreplace":
                this.createAudio(e);
                break;
            case "inline":
                selectNode.removeAttribute("class");
                selectNode.closest("." + $a55b1d4723d2c9fa$export$3b06fc142c718da9).style.display = "inline-block";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$e60e94c39d5aeebd,
                    $a55b1d4723d2c9fa$export$45a36adcbe83d7d1,
                    $a55b1d4723d2c9fa$export$cd3465bd206f5f9b
                ]);
                this.callBack(e);
                break;
            case "break":
                selectNode.removeAttribute("class");
                selectNode.closest("." + $a55b1d4723d2c9fa$export$3b06fc142c718da9).style.display = "block";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$565fffcabd84d016,
                    $a55b1d4723d2c9fa$export$e60e94c39d5aeebd,
                    $a55b1d4723d2c9fa$export$cd3465bd206f5f9b
                ]);
                this.callBack(e);
                break;
            case "audioremove":
                (0, $4ZDHT.detach)(selectNode);
                this.callBack(e);
                break;
        }
    };
    AudioCommand.prototype.createAudio = function(e) {
        var _this = this;
        var isReplaced = false;
        var wrapElement;
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && e.item.selectParent[0].classList && (e.item.selectParent[0].classList.contains($a55b1d4723d2c9fa$export$68b81b7a25917fd9) || e.item.selectParent[0].classList.contains($a55b1d4723d2c9fa$export$3b06fc142c718da9))) {
            var audioEle = e.item.selectParent[0].querySelector("source");
            this.setStyle(audioEle, e);
            isReplaced = true;
        } else {
            wrapElement = (0, $4ZDHT.createElement)("span", {
                className: $a55b1d4723d2c9fa$export$3b06fc142c718da9,
                attrs: {
                    contentEditable: "false",
                    title: !(0, $3EnZW.isNullOrUndefined)(e.item.title) ? e.item.title : !(0, $3EnZW.isNullOrUndefined)(e.item.fileName) ? e.item.fileName : ""
                }
            });
            var audElement = (0, $4ZDHT.createElement)("audio", {
                className: $a55b1d4723d2c9fa$export$e60e94c39d5aeebd + " " + $a55b1d4723d2c9fa$export$45a36adcbe83d7d1,
                attrs: {
                    controls: ""
                }
            });
            var sourceElement = (0, $4ZDHT.createElement)("source");
            var clickElement = (0, $4ZDHT.createElement)("span", {
                className: $a55b1d4723d2c9fa$export$68b81b7a25917fd9
            });
            this.setStyle(sourceElement, e);
            audElement.appendChild(sourceElement);
            clickElement.appendChild(audElement);
            wrapElement.appendChild(clickElement);
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.selection)) e.item.selection.restore();
            (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, wrapElement, this.parent.editableElement);
            if (wrapElement.nextElementSibling === null) {
                var insertElem = (0, $4ZDHT.createElement)("br");
                wrapElement.parentNode.insertBefore(insertElem, wrapElement.nextSibling);
            }
        }
        if (e.callBack && ((0, $3EnZW.isNullOrUndefined)(e.selector) || !(0, $3EnZW.isNullOrUndefined)(e.selector) && e.selector !== "pasteCleanupModule")) {
            var selectedNode = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0];
            var audioElm_1 = e.value === "AudioReplace" || isReplaced ? e.item.selectParent[0].querySelector("audio") : (0, $5q7BP.Browser).isIE ? selectedNode : selectedNode.querySelector("audio");
            audioElm_1.addEventListener("loadeddata", function() {
                if (e.value !== "AudioReplace" || !isReplaced) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.currentDocument)) e.callBack({
                        requestType: "Audios",
                        editorMode: "HTML",
                        event: e.event,
                        range: _this.parent.nodeSelection.getRange(_this.parent.currentDocument),
                        elements: [
                            audioElm_1
                        ]
                    });
                }
            });
            if (isReplaced) audioElm_1.load();
        }
    };
    AudioCommand.prototype.setStyle = function(sourceElement, e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.url)) sourceElement.setAttribute("src", e.item.url);
        var fileExtension = e.item.fileName ? e.item.fileName.split(".").pop().toLowerCase() : e.item.url ? e.item.url.split(".").pop().toLowerCase() : "";
        if (fileExtension === "opus") sourceElement.type = "audio/ogg";
        else if (fileExtension === "m4a") sourceElement.type = "audio/mp4";
        else sourceElement.type = e.item.fileName && e.item.fileName.split(".").length > 0 ? "audio/" + e.item.fileName.split(".")[e.item.fileName.split(".").length - 1] : e.item.url && e.item.url.split(".").length > 0 ? "audio/" + e.item.url.split(".")[e.item.url.split(".").length - 1] : "";
    };
    AudioCommand.prototype.callBack = function(e) {
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    AudioCommand.prototype.destroy = function() {
        this.removeEventListener();
    };
    return AudioCommand;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");




/**
 * Video internal component
 *
 * @hidden

 */ var $ff897e152c5dfbc6$export$8bf61d9e46409f0 = /** @class */ function() {
    /**
     * Constructor for creating the Video plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function VideoCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    VideoCommand.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$f3657d8d6be09c14, this.videoCommand, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    VideoCommand.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$f3657d8d6be09c14, this.videoCommand);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * videoCommand method
     *
     * @param {IHtmlItem} e - specifies the element
     * @returns {void}
     * @hidden

     */ VideoCommand.prototype.videoCommand = function(e) {
        var selectNode;
        var videoWrapNode;
        var videoClickElem;
        var value = e.value.toString().toLowerCase();
        if (value !== "video" && value !== "videoreplace") {
            selectNode = e.item.selectNode[0];
            videoWrapNode = selectNode.closest("." + $a55b1d4723d2c9fa$export$1e4e627aeae7457e);
            videoClickElem = selectNode.closest("." + $a55b1d4723d2c9fa$export$6a881736acda7d9);
        }
        switch(value){
            case "video":
            case "videoreplace":
                this.createVideo(e);
                break;
            case "videodimension":
                this.videoDimension(e);
                break;
            case "inline":
                selectNode.removeAttribute("class");
                if (videoWrapNode) videoWrapNode.style.display = "inline-block";
                if (videoClickElem) selectNode.parentElement.style.cssFloat = "";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$4947cd40388c7e29,
                    $a55b1d4723d2c9fa$export$b42ef43587637838,
                    $a55b1d4723d2c9fa$export$2b3796ce7d0e9d00
                ]);
                this.callBack(e);
                break;
            case "break":
                selectNode.removeAttribute("class");
                if (videoWrapNode) videoWrapNode.style.display = "block";
                if (videoClickElem) selectNode.parentElement.style.cssFloat = "";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$68c9ac73bcff26fd,
                    $a55b1d4723d2c9fa$export$4947cd40388c7e29,
                    $a55b1d4723d2c9fa$export$2b3796ce7d0e9d00
                ]);
                this.callBack(e);
                break;
            case "justifyleft":
                selectNode.removeAttribute("class");
                if (videoWrapNode) videoWrapNode.style.display = "block";
                if (videoClickElem) selectNode.parentElement.style.cssFloat = "left";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$4947cd40388c7e29,
                    $a55b1d4723d2c9fa$export$37ea167cf9949f90
                ]);
                this.callBack(e);
                break;
            case "justifycenter":
                selectNode.removeAttribute("class");
                if (videoWrapNode) videoWrapNode.style.display = "block";
                if (videoClickElem) selectNode.parentElement.style.cssFloat = "";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$4947cd40388c7e29,
                    $a55b1d4723d2c9fa$export$18d05a53549dadb3
                ]);
                this.callBack(e);
                break;
            case "justifyright":
                selectNode.removeAttribute("class");
                if (videoWrapNode) videoWrapNode.style.display = "block";
                if (videoClickElem) selectNode.parentElement.style.cssFloat = "right";
                (0, $4ZDHT.addClass)([
                    selectNode
                ], [
                    $a55b1d4723d2c9fa$export$4947cd40388c7e29,
                    $a55b1d4723d2c9fa$export$a9a8177cbbeafa5b
                ]);
                this.callBack(e);
                break;
            case "videoremove":
                (0, $4ZDHT.detach)(selectNode.parentElement);
                this.callBack(e);
                break;
        }
    };
    VideoCommand.prototype.wrapVideo = function(e) {
        var wrapElement;
        var sourceElement;
        if (e.item.isEmbedUrl) {
            wrapElement = (0, $4ZDHT.createElement)("span", {
                className: $a55b1d4723d2c9fa$export$1e4e627aeae7457e,
                attrs: {
                    contentEditable: "false"
                }
            });
            var clickElement = (0, $4ZDHT.createElement)("span", {
                className: $a55b1d4723d2c9fa$export$6a881736acda7d9
            });
            var temp = (0, $4ZDHT.createElement)("template");
            temp.innerHTML = e.item.fileName;
            clickElement.appendChild(temp.content);
            this.vidElement = sourceElement = clickElement.firstElementChild;
            this.setStyle(sourceElement, e, this.vidElement);
            wrapElement.style.display = e.item.cssClass === $a55b1d4723d2c9fa$export$b42ef43587637838 ? "inline-block" : "block";
            wrapElement.appendChild(clickElement);
        } else {
            wrapElement = (0, $4ZDHT.createElement)("span", {
                className: $a55b1d4723d2c9fa$export$56c9d038288f600d,
                attrs: {
                    contentEditable: "false",
                    title: !(0, $3EnZW.isNullOrUndefined)(e.item.title) ? e.item.title : !(0, $3EnZW.isNullOrUndefined)(e.item.fileName) ? e.item.fileName : ""
                }
            });
            this.vidElement = (0, $4ZDHT.createElement)("video", {
                className: $a55b1d4723d2c9fa$export$4947cd40388c7e29 + " " + $a55b1d4723d2c9fa$export$b42ef43587637838,
                attrs: {
                    controls: ""
                }
            });
            sourceElement = (0, $4ZDHT.createElement)("source");
            this.setStyle(sourceElement, e, this.vidElement);
            this.vidElement.appendChild(sourceElement);
            wrapElement.appendChild(this.vidElement);
        }
        return wrapElement;
    };
    VideoCommand.prototype.createVideo = function(e) {
        var _this = this;
        var isReplaced = false;
        var wrapElement;
        if (e.value === "VideoReplace" && !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && e.item.selectParent[0].tagName === "VIDEO") {
            if (e.item.isEmbedUrl) {
                wrapElement = this.wrapVideo(e);
                var oldEle = e.item.selection.range.startContainer;
                oldEle.parentNode.replaceChild(wrapElement, oldEle);
            } else {
                var videoEle = e.item.selectParent[0].querySelector("source");
                this.setStyle(videoEle, e, videoEle);
                isReplaced = true;
            }
        } else if (e.value === "VideoReplace" && !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && (0, $3EnZW.isNullOrUndefined)(e.item.selectParent[0].querySelector("iframe")) && e.item.selectParent[0].classList && e.item.selectParent[0].classList.contains($a55b1d4723d2c9fa$export$6a881736acda7d9)) {
            e.item.selectParent[0].innerHTML = e.item.fileName;
            this.setStyle(e.item.selectParent[0].firstElementChild, e, e.item.selectParent[0].firstElementChild);
        } else if (e.value === "VideoReplace" && !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent) && !(0, $3EnZW.isNullOrUndefined)(e.item.selectParent[0].querySelector("iframe")) && !e.item.isEmbedUrl) {
            wrapElement = this.wrapVideo(e);
            var oldEle = e.item.selection.range.startContainer;
            oldEle.parentNode.replaceChild(wrapElement, oldEle);
        } else {
            if (!e.item.isEmbedUrl) wrapElement = this.wrapVideo(e);
            else wrapElement = this.wrapVideo(e);
            if (!(0, $3EnZW.isNullOrUndefined)(e.item.selection)) e.item.selection.restore();
            (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, wrapElement, this.parent.editableElement);
            if (wrapElement.nextElementSibling === null) {
                var insertElem = (0, $4ZDHT.createElement)("br");
                wrapElement.parentNode.insertBefore(insertElem, wrapElement.nextSibling);
            }
        }
        if (e.callBack && ((0, $3EnZW.isNullOrUndefined)(e.selector) || !(0, $3EnZW.isNullOrUndefined)(e.selector) && e.selector !== "pasteCleanupModule")) {
            var selectedNode = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0];
            var videoElm_1;
            if (e.value === "VideoReplace" || isReplaced) {
                if (!e.item.isEmbedUrl) videoElm_1 = e.item.selectParent[0];
                else if (e.item.isEmbedUrl) {
                    if (!(0, $3EnZW.isNullOrUndefined)(wrapElement)) videoElm_1 = wrapElement.querySelector("iframe");
                } else videoElm_1 = e.item.selectParent[0].querySelector("iframe");
            } else videoElm_1 = !e.item.isEmbedUrl ? selectedNode.lastElementChild : selectedNode.querySelector("iframe");
            videoElm_1.addEventListener(videoElm_1.tagName !== "IFRAME" ? "loadeddata" : "load", function() {
                if (e.value !== "VideoReplace" || !isReplaced) {
                    if (e.item.isEmbedUrl && videoElm_1) videoElm_1.classList.add("e-rte-embed-url");
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.currentDocument)) e.callBack({
                        requestType: "Videos",
                        editorMode: "HTML",
                        event: e.event,
                        range: _this.parent.nodeSelection.getRange(_this.parent.currentDocument),
                        elements: [
                            videoElm_1
                        ]
                    });
                }
            });
            if (isReplaced) videoElm_1.load();
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1) {
                this.vidElement.addEventListener("play", function() {
                    _this.editAreaVideoClick(e);
                });
                this.vidElement.addEventListener("pause", function() {
                    _this.editAreaVideoClick(e);
                });
            }
        }
    };
    VideoCommand.prototype.editAreaVideoClick = function(e) {
        e.callBack({
            requestType: "VideosPlayPause",
            editorMode: "HTML",
            event: e.event
        });
    };
    VideoCommand.prototype.setStyle = function(sourceElement, e, videoEle) {
        if (e.item.url !== "" && !(0, $3EnZW.isNullOrUndefined)(e.item.url) && (0, $3EnZW.isNullOrUndefined)(sourceElement) ? false : sourceElement.nodeName.toLowerCase() !== "iframe") sourceElement.setAttribute("src", e.item.url);
        if (!e.item.isEmbedUrl) sourceElement.type = e.item.fileName && e.item.fileName.split(".").length > 0 ? "video/" + e.item.fileName.split(".")[e.item.fileName.split(".").length - 1] : e.item.url && e.item.url.split(".").length > 0 ? "video/" + e.item.url.split(".")[e.item.url.split(".").length - 1] : "";
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.width)) videoEle.setAttribute("width", (0, $3EnZW.formatUnit)(e.item.width.width));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.height)) videoEle.setAttribute("height", (0, $3EnZW.formatUnit)(e.item.height.height));
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.minWidth)) videoEle.style.minWidth = (0, $3EnZW.formatUnit)(e.item.width.minWidth);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width) && !(0, $3EnZW.isNullOrUndefined)(e.item.width.maxWidth)) videoEle.style.maxWidth = (0, $3EnZW.formatUnit)(e.item.width.maxWidth);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.minHeight)) videoEle.style.minHeight = (0, $3EnZW.formatUnit)(e.item.height.minHeight);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.height) && !(0, $3EnZW.isNullOrUndefined)(e.item.height.maxHeight)) videoEle.style.maxHeight = (0, $3EnZW.formatUnit)(e.item.height.maxHeight);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.cssClass)) {
            if (e.item.cssClass === $a55b1d4723d2c9fa$export$68c9ac73bcff26fd) {
                (0, $4ZDHT.addClass)([
                    videoEle
                ], [
                    $a55b1d4723d2c9fa$export$68c9ac73bcff26fd
                ]);
                (0, $4ZDHT.removeClass)([
                    videoEle
                ], [
                    $a55b1d4723d2c9fa$export$b42ef43587637838
                ]);
            } else {
                (0, $4ZDHT.addClass)([
                    videoEle
                ], [
                    $a55b1d4723d2c9fa$export$b42ef43587637838
                ]);
                (0, $4ZDHT.removeClass)([
                    videoEle
                ], [
                    $a55b1d4723d2c9fa$export$68c9ac73bcff26fd
                ]);
            }
        }
    };
    VideoCommand.prototype.videoDimension = function(e) {
        var selectNode = !e.item.selectNode[0].classList.contains($a55b1d4723d2c9fa$export$6a881736acda7d9) ? e.item.selectNode[0] : e.item.selectNode[0].querySelector("iframe");
        selectNode.style.height = "";
        selectNode.style.width = "";
        if (e.item.width !== "auto") selectNode.style.width = (0, $3EnZW.formatUnit)(e.item.width);
        else selectNode.removeAttribute("width");
        if (e.item.height !== "auto") selectNode.style.height = (0, $3EnZW.formatUnit)(e.item.height);
        else selectNode.removeAttribute("height");
        this.callBack(e);
    };
    VideoCommand.prototype.callBack = function(e) {
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    VideoCommand.prototype.destroy = function() {
        this.removeEventListener();
    };
    return VideoCommand;
}();


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");




/**
 * Link internal component
 *
 * @hidden

 */ var $eff586c2ee4b592c$export$198ea458cbfb59e4 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function TableCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    TableCommand.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$88a597d0c7ae97b, this.createTable, this);
        this.parent.observer.on($56b963295b740d00$export$4f907db68c03b38f, this.insertRow, this);
        this.parent.observer.on($56b963295b740d00$export$90f8dc07e17eff78, this.insertColumn, this);
        this.parent.observer.on($56b963295b740d00$export$bbc7b4de7639a0e6, this.deleteRow, this);
        this.parent.observer.on($56b963295b740d00$export$8257751f67095555, this.deleteColumn, this);
        this.parent.observer.on($56b963295b740d00$export$bd1f6cc7291d4cf1, this.removeTable, this);
        this.parent.observer.on($56b963295b740d00$export$8f899c1b459a778c, this.tableHeader, this);
        this.parent.observer.on($56b963295b740d00$export$88d20efa8d21dfb9, this.tableVerticalAlign, this);
        this.parent.observer.on($56b963295b740d00$export$ca0fb188aaf9f2cf, this.cellMerge, this);
        this.parent.observer.on($56b963295b740d00$export$a4764f7dc1ebaae7, this.HorizontalSplit, this);
        this.parent.observer.on($56b963295b740d00$export$2a47f47b618178e4, this.VerticalSplit, this);
        this.parent.observer.on($56b963295b740d00$export$684cafe96c16a76, this.tableMove, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    TableCommand.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$88a597d0c7ae97b, this.createTable);
        this.parent.observer.off($56b963295b740d00$export$4f907db68c03b38f, this.insertRow);
        this.parent.observer.off($56b963295b740d00$export$90f8dc07e17eff78, this.insertColumn);
        this.parent.observer.off($56b963295b740d00$export$bbc7b4de7639a0e6, this.deleteRow);
        this.parent.observer.off($56b963295b740d00$export$8257751f67095555, this.deleteColumn);
        this.parent.observer.off($56b963295b740d00$export$bd1f6cc7291d4cf1, this.removeTable);
        this.parent.observer.off($56b963295b740d00$export$8f899c1b459a778c, this.tableHeader);
        this.parent.observer.off($56b963295b740d00$export$88d20efa8d21dfb9, this.tableVerticalAlign);
        this.parent.observer.off($56b963295b740d00$export$ca0fb188aaf9f2cf, this.cellMerge);
        this.parent.observer.off($56b963295b740d00$export$a4764f7dc1ebaae7, this.HorizontalSplit);
        this.parent.observer.off($56b963295b740d00$export$2a47f47b618178e4, this.VerticalSplit);
        this.parent.observer.off($56b963295b740d00$export$684cafe96c16a76, this.tableMove);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    TableCommand.prototype.createTable = function(e) {
        var table = (0, $4ZDHT.createElement)("table", {
            className: "e-rte-table"
        });
        var tblBody = (0, $4ZDHT.createElement)("tbody");
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width.width)) table.style.width = this.calculateStyleValue(e.item.width.width);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width.minWidth)) table.style.minWidth = this.calculateStyleValue(e.item.width.minWidth);
        if (!(0, $3EnZW.isNullOrUndefined)(e.item.width.maxWidth)) table.style.maxWidth = this.calculateStyleValue(e.item.width.maxWidth);
        var tdWid = parseInt(e.item.width.width, 10) > 100 ? 100 / e.item.columns : parseInt(e.item.width.width, 10) / e.item.columns;
        for(var i = 0; i < e.item.rows; i++){
            var row = (0, $4ZDHT.createElement)("tr");
            for(var j = 0; j < e.item.columns; j++){
                var cell = (0, $4ZDHT.createElement)("td");
                cell.appendChild((0, $4ZDHT.createElement)("br"));
                cell.style.width = tdWid + "%";
                row.appendChild(cell);
            }
            tblBody.appendChild(row);
        }
        table.appendChild(tblBody);
        e.item.selection.restore();
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, table, this.parent.editableElement);
        e.item.selection.setSelectionText(this.parent.currentDocument, table.querySelector("td"), table.querySelector("td"), 0, 0);
        if (table.nextElementSibling === null && !table.classList.contains("ignore-table")) {
            var insertElem = void 0;
            if (e.enterAction === "DIV") {
                insertElem = (0, $4ZDHT.createElement)("div");
                insertElem.appendChild((0, $4ZDHT.createElement)("br"));
            } else if (e.enterAction === "BR") insertElem = (0, $4ZDHT.createElement)("br");
            else {
                insertElem = (0, $4ZDHT.createElement)("p");
                insertElem.appendChild((0, $4ZDHT.createElement)("br"));
            }
            this.insertAfter(insertElem, table);
        }
        if (table.classList.contains("ignore-table")) (0, $259257662ca103fc$export$7e42d760c0740ccc)([
            table
        ], [
            "ignore-table"
        ]);
        table.querySelector("td").classList.add("e-cell-select");
        if (e.callBack) e.callBack({
            requestType: "Table",
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: [
                table
            ]
        });
        return table;
    };
    TableCommand.prototype.calculateStyleValue = function(value) {
        var styleValue;
        if (typeof value === "string") {
            if (value.indexOf("px") >= 0 || value.indexOf("%") >= 0 || value.indexOf("auto") >= 0) styleValue = value;
            else styleValue = value + "px";
        } else styleValue = value + "px";
        return styleValue;
    };
    TableCommand.prototype.insertAfter = function(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    TableCommand.prototype.getSelectedCellMinMaxIndex = function(e) {
        var selectedCells = this.curTable.querySelectorAll(".e-cell-select");
        var a = 0;
        var minI = e.length;
        var maxI = 0;
        var minJ = e[0].length;
        var maxJ = 0;
        //eslint-disable-next-line
        for(var i = 0; a < selectedCells.length; a++){
            var selectedCellIndex = this.getCorrespondingIndex(selectedCells[a], e);
            var minMaxIndex = this.FindIndex(selectedCellIndex[0], selectedCellIndex[1], e);
            //eslint-disable-next-line
            minI = Math.min(selectedCellIndex[0], minI), maxI = Math.max(minMaxIndex[0], maxI), minJ = Math.min(selectedCellIndex[1], minJ), maxJ = Math.max(minMaxIndex[1], maxJ);
        }
        return {
            startRow: minI,
            endRow: maxI,
            startColumn: minJ,
            endColumn: maxJ
        };
    };
    TableCommand.prototype.insertRow = function(e) {
        var isBelow = e.item.subCommand === "InsertRowBefore" ? false : true;
        var selectedCell = e.item.selection.range.startContainer;
        if (!(selectedCell.nodeName === "TH" || selectedCell.nodeName === "TD")) selectedCell = (0, $4ZDHT.closest)(selectedCell.parentElement, "td,th");
        if (selectedCell.nodeName.toLowerCase() === "th" && e.item.subCommand === "InsertRowBefore") return;
        this.curTable = (0, $4ZDHT.closest)(this.parent.nodeSelection.range.startContainer.parentElement, "table");
        if (this.curTable.querySelectorAll(".e-cell-select").length === 0) {
            var lastRow = this.curTable.rows[this.curTable.rows.length - 1];
            var cloneRow = lastRow.cloneNode(true);
            cloneRow.removeAttribute("rowspan");
            this.insertAfter(cloneRow, lastRow);
        } else {
            var allCells = this.getCorrespondingColumns();
            var minMaxIndex = this.getSelectedCellMinMaxIndex(allCells);
            var minVal = isBelow ? minMaxIndex.endRow : minMaxIndex.startRow;
            var newRow = (0, $4ZDHT.createElement)("tr");
            var isHeaderSelect = this.curTable.querySelectorAll("th.e-cell-select").length > 0;
            for(var i = 0; i < allCells[minVal].length; i++){
                // eslint-disable-next-line max-len
                if (isBelow && minVal < allCells.length - 1 && allCells[minVal][i] === allCells[minVal + 1][i] || !isBelow && 0 < minVal && allCells[minVal][i] === allCells[minVal - 1][i]) {
                    if (0 === i || 0 < i && allCells[minVal][i] !== allCells[minVal][i - 1]) allCells[minVal][i].setAttribute("rowspan", (parseInt(allCells[minVal][i].getAttribute("rowspan"), 10) + 1).toString());
                } else {
                    var tdElement = (0, $4ZDHT.createElement)("td");
                    tdElement.appendChild((0, $4ZDHT.createElement)("br"));
                    newRow.appendChild(tdElement);
                    tdElement.setAttribute("style", allCells[isHeaderSelect && isBelow ? allCells[minVal + 1] ? minVal + 1 : minVal : minVal][i].getAttribute("style"));
                }
            }
            // eslint-disable-next-line
            var selectedRow = void 0;
            if (isHeaderSelect && isBelow) selectedRow = this.curTable.querySelector("tbody").childNodes[0];
            else selectedRow = this.curTable.rows[minVal];
            // eslint-disable-next-line
            e.item.subCommand === "InsertRowBefore" ? selectedRow.parentElement.insertBefore(newRow, selectedRow) : isHeaderSelect ? selectedRow.parentElement.insertBefore(newRow, selectedRow) : this.insertAfter(newRow, selectedRow);
        }
        e.item.selection.setSelectionText(this.parent.currentDocument, e.item.selection.range.startContainer, e.item.selection.range.startContainer, 0, 0);
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.insertColumn = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        if (!(selectedCell.nodeName === "TH" || selectedCell.nodeName === "TD")) selectedCell = (0, $4ZDHT.closest)(selectedCell.parentElement, "td,th");
        var curRow = (0, $4ZDHT.closest)(selectedCell, "tr");
        var curCell;
        var allRows = (0, $4ZDHT.closest)(curRow, "table").rows;
        var colIndex = Array.prototype.slice.call(curRow.querySelectorAll(":scope > td, :scope > th")).indexOf(selectedCell);
        var previousWidth = parseInt(e.item.width, 10) / curRow.querySelectorAll(":scope > td, :scope > th").length;
        var currentWidth = parseInt(e.item.width, 10) / (curRow.querySelectorAll(":scope > td, :scope > th").length + 1);
        var currentTabElm = (0, $4ZDHT.closest)(curRow, "table");
        var thTdElm = (0, $4ZDHT.closest)(curRow, "table").querySelectorAll("th,td");
        for(var i = 0; i < thTdElm.length; i++)thTdElm[i].dataset.oldWidth = thTdElm[i].offsetWidth / currentTabElm.offsetWidth * 100 + "%";
        if ((0, $3EnZW.isNullOrUndefined)(currentTabElm.style.width) || currentTabElm.style.width === "") currentTabElm.style.width = currentTabElm.offsetWidth + "px";
        for(var i = 0; i < allRows.length; i++){
            curCell = allRows[i].querySelectorAll(":scope > td, :scope > th")[colIndex];
            var colTemplate = curCell.cloneNode(true);
            colTemplate.innerHTML = "";
            colTemplate.appendChild((0, $4ZDHT.createElement)("br"));
            colTemplate.removeAttribute("class");
            colTemplate.removeAttribute("colspan");
            colTemplate.removeAttribute("rowspan");
            // eslint-disable-next-line
            e.item.subCommand === "InsertColumnLeft" ? curCell.parentElement.insertBefore(colTemplate, curCell) : this.insertAfter(colTemplate, curCell);
            colTemplate.style.width = currentWidth.toFixed(4) + "%";
            delete colTemplate.dataset.oldWidth;
        }
        for(var i = 0; i < thTdElm.length; i++){
            thTdElm[i].style.width = (Number(thTdElm[i].dataset.oldWidth.split("%")[0]) * currentWidth / previousWidth).toFixed(4) + "%";
            delete thTdElm[i].dataset.oldWidth;
        }
        e.item.selection.setSelectionText(this.parent.currentDocument, selectedCell, selectedCell, 0, 0);
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.deleteColumn = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        if (selectedCell.nodeType === 3) selectedCell = (0, $4ZDHT.closest)(selectedCell.parentElement, "td,th");
        var tBodyHeadEle = (0, $4ZDHT.closest)(selectedCell, selectedCell.tagName === "TH" ? "thead" : "tbody");
        var rowIndex = tBodyHeadEle && Array.prototype.indexOf.call(tBodyHeadEle.childNodes, selectedCell.parentNode);
        this.curTable = (0, $4ZDHT.closest)(selectedCell, "table");
        var curRow = (0, $4ZDHT.closest)(selectedCell, "tr");
        if (curRow.querySelectorAll("th,td").length === 1) {
            e.item.selection.restore();
            (0, $4ZDHT.detach)((0, $4ZDHT.closest)(selectedCell.parentElement, "table"));
        } else {
            var deleteIndex = void 0;
            var allCells = this.getCorrespondingColumns();
            //eslint-disable-next-line
            var selectedMinMaxIndex = this.getSelectedCellMinMaxIndex(allCells);
            var minCol = selectedMinMaxIndex.startColumn;
            var maxCol = selectedMinMaxIndex.endColumn;
            for(var i = 0; i < allCells.length; i++){
                var currentRow = allCells[i];
                for(var j = 0; j < currentRow.length; j++){
                    var currentCell = currentRow[j];
                    //eslint-disable-next-line
                    var currentCellIndex = this.getCorrespondingIndex(currentCell, allCells);
                    var colSpanVal = parseInt(currentCell.getAttribute("colspan"), 10) || 1;
                    if (currentCellIndex[1] + (colSpanVal - 1) >= minCol && currentCellIndex[1] <= maxCol) {
                        if (colSpanVal > 1) currentCell.setAttribute("colspan", (colSpanVal - 1).toString());
                        else {
                            (0, $4ZDHT.detach)(currentCell);
                            deleteIndex = j;
                            if ((0, $5q7BP.Browser).isIE) {
                                e.item.selection.setSelectionText(this.parent.currentDocument, this.curTable.querySelector("td"), this.curTable.querySelector("td"), 0, 0);
                                this.curTable.querySelector("td, th").classList.add("e-cell-select");
                            }
                        }
                    }
                }
            }
            if (deleteIndex > -1) {
                var rowHeadEle = tBodyHeadEle.children[rowIndex];
                var nextFocusCell = rowHeadEle && rowHeadEle.children[deleteIndex <= rowHeadEle.children.length - 1 ? deleteIndex : deleteIndex - 1];
                if (nextFocusCell) {
                    e.item.selection.setSelectionText(this.parent.currentDocument, nextFocusCell, nextFocusCell, 0, 0);
                    nextFocusCell.classList.add("e-cell-select");
                }
            }
        }
        if (e.callBack) {
            var sContainer = this.parent.nodeSelection.getRange(this.parent.currentDocument).startContainer;
            if (sContainer.nodeName !== "TD") {
                var startChildLength = this.parent.nodeSelection.getRange(this.parent.currentDocument).startOffset;
                var focusNode = sContainer.children[startChildLength];
                if (focusNode) this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, focusNode, 0);
            }
            e.callBack({
                requestType: e.item.subCommand,
                editorMode: "HTML",
                event: e.event,
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
            });
        }
    };
    TableCommand.prototype.deleteRow = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        if (selectedCell.nodeType === 3) selectedCell = (0, $4ZDHT.closest)(selectedCell.parentElement, "td,th");
        var colIndex = Array.prototype.indexOf.call(selectedCell.parentNode.childNodes, selectedCell);
        this.curTable = (0, $4ZDHT.closest)(selectedCell, "table");
        var currentRow;
        var allCells = this.getCorrespondingColumns();
        var minMaxIndex = this.getSelectedCellMinMaxIndex(allCells);
        var maxI;
        var j;
        if (this.curTable.rows.length === 1) {
            e.item.selection.restore();
            (0, $4ZDHT.detach)((0, $4ZDHT.closest)(selectedCell.parentElement, "table"));
        } else for(maxI = minMaxIndex.endRow; maxI >= minMaxIndex.startRow; maxI--){
            currentRow = this.curTable.rows[maxI];
            for(j = 0; j < allCells[maxI].length; j++){
                if (j === 0 || allCells[maxI][j] !== allCells[maxI][j - 1]) {
                    if (1 < parseInt(allCells[maxI][j].getAttribute("rowspan"), 10)) {
                        var rowSpanVal = parseInt(allCells[maxI][j].getAttribute("rowspan"), 10) - 1;
                        if (1 === rowSpanVal) {
                            allCells[maxI][j].removeAttribute("rowspan");
                            var cell = this.getMergedRow(this.getCorrespondingColumns())[j];
                            if (cell) {
                                var cloneNode = cell.cloneNode(true);
                                cloneNode.innerHTML = "<br>";
                                if (cell.parentElement) cell.parentElement.insertBefore(cloneNode, cell);
                            }
                        } else allCells[maxI][j].setAttribute("rowspan", rowSpanVal.toString());
                    /* eslint-enable */ }
                }
                // eslint-disable-next-line max-len
                if (maxI < allCells.length - 1 && allCells[maxI][j] === allCells[maxI + 1][j] && (0 === maxI || allCells[maxI][j] !== allCells[maxI - 1][j])) {
                    var element = allCells[maxI][j];
                    var index = void 0;
                    // eslint-disable-next-line max-len
                    for(index = j; 0 < index && allCells[maxI][index] === allCells[maxI][index - 1]; index--)if (index === 0) this.curTable.rows[maxI + 1].prepend(element);
                    else allCells[maxI + 1][index - 1].insertAdjacentElement("afterend", element);
                }
            }
            var deleteIndex = currentRow.rowIndex;
            this.curTable.deleteRow(deleteIndex);
            var focusTrEle = !(0, $3EnZW.isNullOrUndefined)(this.curTable.rows[deleteIndex]) ? this.curTable.querySelectorAll("tbody tr")[deleteIndex] : this.curTable.querySelectorAll("tbody tr")[deleteIndex - 1];
            var nextFocusCell = focusTrEle && focusTrEle.querySelectorAll("td")[colIndex];
            if (nextFocusCell) {
                e.item.selection.setSelectionText(this.parent.currentDocument, nextFocusCell, nextFocusCell, 0, 0);
                nextFocusCell.classList.add("e-cell-select");
            } else {
                e.item.selection.setSelectionText(this.parent.currentDocument, this.curTable.querySelector("td"), this.curTable.querySelector("td"), 0, 0);
                this.curTable.querySelector("td, th").classList.add("e-cell-select");
            }
        }
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.getMergedRow = function(cells) {
        var mergedRow;
        for(var i = 0; i < cells.length; i++)if (cells[i].length !== this.curTable.rows[0].childNodes.length) mergedRow = cells[i];
        return mergedRow;
    };
    TableCommand.prototype.removeTable = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        selectedCell = selectedCell.nodeType === 3 ? selectedCell.parentNode : selectedCell;
        var selectedTable = (0, $4ZDHT.closest)(selectedCell.parentElement, "table");
        if (selectedTable) {
            e.item.selection.restore();
            (0, $4ZDHT.detach)(selectedTable);
        }
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.tableHeader = function(e) {
        var headerExit = false;
        var selectedCell = e.item.selection.range.startContainer;
        selectedCell = selectedCell.nodeType === 3 ? selectedCell.parentNode : selectedCell;
        var table = (0, $4ZDHT.closest)(selectedCell.parentElement, "table");
        [].slice.call(table.childNodes).forEach(function(el) {
            if (el.nodeName === "THEAD") headerExit = true;
        });
        if (table && !headerExit) {
            var cellCount = table.querySelector("tr").childElementCount;
            var colSpanCount = 0;
            for(var i = 0; i < cellCount; i++)colSpanCount = colSpanCount + (parseInt(table.querySelector("tr").children[i].getAttribute("colspan"), 10) || 1);
            var header = table.createTHead();
            var row = header.insertRow(0);
            for(var j = 0; j < colSpanCount; j++){
                var th = (0, $4ZDHT.createElement)("th");
                th.appendChild((0, $4ZDHT.createElement)("br"));
                row.appendChild(th);
            }
        } else table.deleteTHead();
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.tableVerticalAlign = function(e) {
        var value = "";
        switch(e.item.subCommand){
            case "AlignTop":
                value = "top";
                break;
            case "AlignMiddle":
                value = "middle";
                break;
            case "AlignBottom":
                value = "bottom";
                break;
        }
        e.item.tableCell.style.verticalAlign = value;
        if (value && value !== "" && e.item.tableCell.getAttribute("valign")) e.item.tableCell.removeAttribute("valign");
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.cellMerge = function(e) {
        if ((0, $3EnZW.isNullOrUndefined)(this.curTable)) this.curTable = (0, $4ZDHT.closest)(this.parent.nodeSelection.range.startContainer.parentElement, "table");
        var selectedCells = this.curTable.querySelectorAll(".e-cell-select");
        if (selectedCells.length < 2) return;
        this.mergeCellContent();
        var minMaxIndexes = this.getSelectedMinMaxIndexes(this.getCorrespondingColumns());
        var firstCell = selectedCells[0];
        var rowSelectedCells = firstCell.parentElement.querySelectorAll(".e-cell-select");
        var maxHeight = 0;
        for(var j = 0; j < rowSelectedCells.length; j++){
            var cellHeight = rowSelectedCells[j].offsetHeight;
            if (cellHeight > maxHeight) maxHeight = cellHeight;
        }
        if (minMaxIndexes.startColumn < minMaxIndexes.endColumn) firstCell.setAttribute("colspan", (minMaxIndexes.endColumn - minMaxIndexes.startColumn + 1).toString());
        if (minMaxIndexes.startRow < minMaxIndexes.endRow) firstCell.setAttribute("rowspan", (minMaxIndexes.endRow - minMaxIndexes.startRow + 1).toString());
        var totalWidth = 0;
        var unit;
        for(var j = rowSelectedCells.length - 1; j >= 0; j--)if (!(0, $3EnZW.isNullOrUndefined)(rowSelectedCells[j].style.width) && rowSelectedCells[j].style.width !== "") {
            if (!unit) {
                var match = rowSelectedCells[j].style.width.match(/^([\d.]+)([a-z%]+)$/i);
                unit = match ? match[2] : "%";
            }
            totalWidth = totalWidth + parseFloat(rowSelectedCells[j].style.width);
        } else {
            totalWidth = totalWidth + rowSelectedCells[j].offsetWidth / this.curTable.offsetWidth * 100;
            unit = "%";
        }
        firstCell.style.width = totalWidth + unit;
        firstCell.style.height = maxHeight + "px";
        for(var i = 1; i <= selectedCells.length - 1; i++)(0, $4ZDHT.detach)(selectedCells[i]);
        for(var i = 0; i < this.curTable.rows.length; i++)if (this.curTable.rows[i].innerHTML.trim() === "") (0, $4ZDHT.detach)(this.curTable.rows[i]);
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.curTable.querySelectorAll("table td, table th"), "e-multi-cells-select");
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.curTable.querySelectorAll("table td, table th"), "e-cell-select-end");
        this.updateRowSpanStyle(minMaxIndexes.startRow, minMaxIndexes.endRow, this.getCorrespondingColumns());
        this.updateColSpanStyle(minMaxIndexes.startColumn, minMaxIndexes.endColumn, this.getCorrespondingColumns());
        e.item.selection.setSelectionText(this.parent.currentDocument, e.item.selection.range.startContainer, e.item.selection.range.startContainer, 0, 0);
        if (this.parent.nodeSelection && firstCell) this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, // eslint-disable-next-line
        firstCell, 0);
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.updateColSpanStyle = function(min, max, elements) {
        var colValue;
        var colIndex;
        var colMin;
        var index = 0;
        var attrValue;
        var count = 0;
        var eleArray = elements;
        //eslint-disable-next-line
        if (min < (max = Math.min(max, eleArray[0].length - 1))) {
            for(colIndex = min; colIndex <= max; colIndex++){
                index = Math.min(parseInt(eleArray[0][colIndex].getAttribute("colspan"), 10) || 1, max - min + 1);
                if (!(min < colIndex && eleArray[0][colIndex] === eleArray[0][colIndex - 1]) && 1 < index && eleArray[0][colIndex] === eleArray[0][colIndex + 1]) for(count = index - 1, colValue = 1; colValue < eleArray.length; colValue++){
                    if (eleArray[colValue][colIndex] !== eleArray[colValue - 1][colIndex]) for(colMin = colIndex; colMin < colIndex + index; colMin++){
                        attrValue = parseInt(eleArray[colValue][colMin].getAttribute("colspan"), 10) || 1;
                        if (1 < attrValue && eleArray[colValue][colMin] === eleArray[colValue][colMin + 1]) colMin += count = Math.min(count, attrValue - 1);
                        else {
                            count = Math.max(0, count - 1);
                            if (count === 0) break;
                        }
                    /* eslint-enable */ }
                    if (!count) break;
                }
            }
            if (count) this.updateCellAttribute(eleArray, count, "colspan", 0, eleArray.length - 1, min, max);
        }
    };
    TableCommand.prototype.updateRowSpanStyle = function(min, max, ele) {
        var rowValue;
        var colIndex;
        var rowMin;
        var index = 0;
        var attrValue;
        var count = 0;
        var eleArray = ele;
        // eslint-disable-next-line
        if (min < (max = Math.min(max, eleArray.length - 1))) {
            for(rowValue = min; rowValue <= max; rowValue++)if (!(min < rowValue && eleArray[rowValue][0] === eleArray[rowValue - 1][0]) && eleArray[rowValue][0] && 1 < (index = Math.min(parseInt(eleArray[rowValue][0].getAttribute("rowspan"), 10) || 1, max - min + 1)) && eleArray[rowValue][0] === eleArray[rowValue + 1][0]) {
                for(count = index - 1, colIndex = 1; colIndex < eleArray[0].length; colIndex++)if (eleArray[rowValue][colIndex] !== eleArray[rowValue][colIndex - 1]) {
                    for(rowMin = rowValue; rowMin < rowValue + index; rowMin++){
                        attrValue = parseInt(eleArray[rowMin][colIndex].getAttribute("rowspan"), 10) || 1;
                        if (1 < attrValue && eleArray[rowMin][colIndex] === eleArray[rowMin + 1][colIndex]) rowMin += count = Math.min(count, attrValue - 1);
                        else if (!(count = Math.max(0, count - 1))) break;
                    }
                    if (!count) break;
                }
            }
            if (count) this.updateCellAttribute(eleArray, count, "rowspan", min, max, 0, eleArray[0].length - 1);
        }
    };
    TableCommand.prototype.updateCellAttribute = function(elements, index, attr, min, max, firstIndex, length) {
        var rowIndex;
        var colIndex;
        var spanCount;
        for(rowIndex = min; rowIndex <= max; rowIndex++)for(colIndex = firstIndex; colIndex <= length; colIndex++){
            spanCount = parseInt(elements[rowIndex][colIndex].getAttribute(attr), 10) || 1;
            if (min < rowIndex && elements[rowIndex][colIndex] === elements[rowIndex - 1][colIndex] || firstIndex < colIndex && elements[rowIndex][colIndex] === elements[rowIndex][colIndex - 1] || 1 < spanCount) {
                if (1 < spanCount - index) elements[rowIndex][colIndex].setAttribute(attr, (spanCount - index).toString());
                else elements[rowIndex][colIndex].removeAttribute(attr);
            }
        }
    };
    TableCommand.prototype.mergeCellContent = function() {
        var selectedCells = this.curTable.querySelectorAll(".e-cell-select");
        var innerHtml = selectedCells[0].innerHTML === "<br>" ? "" : selectedCells[0].innerHTML;
        for(var i = 1; i < selectedCells.length; i++)if ("<br>" !== selectedCells[i].innerHTML) innerHtml = innerHtml ? innerHtml + "<br>" + selectedCells[i].innerHTML : innerHtml + selectedCells[i].innerHTML;
        selectedCells[0].innerHTML = innerHtml;
    };
    TableCommand.prototype.getSelectedMinMaxIndexes = function(correspondingCells) {
        var selectedCells = this.curTable.querySelectorAll(".e-cell-select");
        if (0 < selectedCells.length) {
            var minRow = correspondingCells.length;
            var maxRow = 0;
            var minCol = correspondingCells[0].length;
            var maxCol = 0;
            for(var i = 0; i < selectedCells.length; i++){
                var currentRowCol = this.getCorrespondingIndex(selectedCells[i], correspondingCells);
                var targetRowCol = this.FindIndex(currentRowCol[0], currentRowCol[1], correspondingCells);
                minRow = Math.min(currentRowCol[0], minRow);
                maxRow = Math.max(targetRowCol[0], maxRow);
                minCol = Math.min(currentRowCol[1], minCol);
                maxCol = Math.max(targetRowCol[1], maxCol);
            }
            return {
                startRow: minRow,
                endRow: maxRow,
                startColumn: minCol,
                endColumn: maxCol
            };
        }
        return null;
    };
    TableCommand.prototype.HorizontalSplit = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        this.curTable = (0, $4ZDHT.closest)(selectedCell.parentElement, "table");
        if (this.curTable.querySelectorAll(".e-cell-select").length > 1) return;
        this.activeCell = this.curTable.querySelector(".e-cell-select");
        var newCell = this.activeCell.cloneNode(true);
        newCell.removeAttribute("class");
        newCell.innerHTML = "</br>";
        var activeCellIndex = this.getCorrespondingIndex(this.activeCell, this.getCorrespondingColumns());
        var correspondingCells = this.getCorrespondingColumns();
        var activeCellRowSpan = this.activeCell.getAttribute("rowspan") ? parseInt(this.activeCell.getAttribute("rowspan"), 10) : 1;
        if (activeCellRowSpan > 1) {
            var avgCount = Math.ceil(activeCellRowSpan / 2);
            // eslint-disable-next-line
            1 < avgCount ? this.activeCell.setAttribute("rowspan", avgCount.toString()) : this.activeCell.removeAttribute("rowspan");
            // eslint-disable-next-line
            1 < activeCellRowSpan - avgCount ? newCell.setAttribute("rowspan", (activeCellRowSpan - avgCount).toString()) : newCell.removeAttribute("rowspan");
            var avgRowIndex = void 0;
            var colIndex = void 0;
            for(avgRowIndex = activeCellIndex[0] + Math.ceil(activeCellRowSpan / 2), colIndex = 0 === activeCellIndex[1] ? activeCellIndex[1] : activeCellIndex[1] - 1; 0 <= colIndex && (correspondingCells[avgRowIndex][colIndex] === // eslint-disable-next-line max-len
            correspondingCells[avgRowIndex][colIndex - 1] || 0 < avgRowIndex && correspondingCells[avgRowIndex][colIndex] === correspondingCells[avgRowIndex - 1][colIndex]);)colIndex--;
            if (colIndex === -1) {
                if (this.curTable.rows[avgRowIndex].firstChild) this.curTable.rows[avgRowIndex].prepend(newCell);
                else this.curTable.appendChild(newCell);
            } else correspondingCells[avgRowIndex][colIndex].insertAdjacentElement("afterend", newCell);
        } else {
            var newTrEle = (0, $4ZDHT.createElement)("tr");
            newTrEle.appendChild(newCell);
            var selectedRow = correspondingCells[activeCellIndex[0]];
            for(var j = 0; j <= selectedRow.length - 1; j++)if (selectedRow[j] !== selectedRow[j - 1] && selectedRow[j] !== this.activeCell) selectedRow[j].setAttribute("rowspan", ((parseInt(selectedRow[j].getAttribute("rowspan"), 10) ? parseInt(selectedRow[j].getAttribute("rowspan"), 10) : 1) + 1).toString());
            this.activeCell.parentNode.insertAdjacentElement("afterend", newTrEle);
        }
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.VerticalSplit = function(e) {
        var selectedCell = e.item.selection.range.startContainer;
        this.curTable = (0, $4ZDHT.closest)(selectedCell.parentElement, "table");
        if (this.curTable.querySelectorAll(".e-cell-select").length > 1) return;
        this.activeCell = this.curTable.querySelector(".e-cell-select");
        var allRows = this.curTable.rows;
        var newCell = this.activeCell.cloneNode(true);
        newCell.removeAttribute("class");
        newCell.innerHTML = "</br>";
        var activeCellIndex = this.getCorrespondingIndex(this.activeCell, this.getCorrespondingColumns());
        var correspondingColumns = this.getCorrespondingColumns();
        var activeCellcolSpan = parseInt(this.activeCell.getAttribute("colspan"), 10) || 1;
        if (activeCellcolSpan > 1) {
            var colSpan = Math.ceil(activeCellcolSpan / 2);
            var getColSizes = this.getColSizes(this.curTable);
            var activeCellUpdatedWidth = this.getSplitColWidth(activeCellIndex[1], activeCellIndex[1] + colSpan - 1, getColSizes);
            var newCellWidth = this.getSplitColWidth(activeCellIndex[1] + colSpan, activeCellIndex[1] + activeCellcolSpan - 1, getColSizes);
            var activeCellWidth = this.convertPixelToPercentage(this.activeCell.offsetWidth, this.curTable.offsetWidth);
            newCellWidth = activeCellWidth - activeCellUpdatedWidth < newCellWidth ? activeCellWidth - activeCellUpdatedWidth : newCellWidth;
            if (1 < colSpan) this.activeCell.setAttribute("colspan", colSpan.toString());
            else this.activeCell.removeAttribute("colspan");
            if (1 < activeCellcolSpan - colSpan) newCell.setAttribute("colspan", (activeCellcolSpan - colSpan).toString());
            else newCell.removeAttribute("colspan");
            this.activeCell.style.width = activeCellUpdatedWidth + "%";
            newCell.style.width = newCellWidth + "%";
        } else {
            var avgWidth = parseFloat(this.activeCell.style.width) / 2;
            for(var i = 0; i <= allRows.length - 1; i++)if (0 === i || correspondingColumns[i][activeCellIndex[1]] !== correspondingColumns[i - 1][activeCellIndex[1]]) {
                var currentCell = correspondingColumns[i][activeCellIndex[1]];
                if (currentCell !== this.activeCell) currentCell.setAttribute("colspan", ((parseInt(currentCell.getAttribute("colspan"), 10) ? parseInt(currentCell.getAttribute("colspan"), 10) : 1) + 1).toString());
            }
            this.activeCell.style.width = avgWidth + "%";
            newCell.style.width = avgWidth + "%";
        }
        this.activeCell.parentNode.insertBefore(newCell, this.activeCell.nextSibling);
        if (e.callBack) e.callBack({
            requestType: e.item.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    TableCommand.prototype.getSplitColWidth = function(startIndex, endInex, sizes) {
        var width = 0;
        for(var i = startIndex; i <= endInex; i++)width += sizes[i];
        return this.convertPixelToPercentage(width, this.curTable.offsetWidth);
    };
    TableCommand.prototype.getColSizes = function(curTable) {
        var cellColl = curTable.rows[0].cells;
        var cellCount = 0;
        for(var cell = 0; cell < cellColl.length; cell++)cellCount = cellCount + cellColl[cell].colSpan;
        var sizes = new Array(cellCount);
        var rowSpanCells = new Map();
        for(var i = 0; i < curTable.rows.length; i++){
            var currentColIndex = 0;
            for(var k = 0; k < curTable.rows[i].cells.length; k++){
                for(var l = 1; l < curTable.rows[i].cells[k].rowSpan; l++){
                    var key = "" + (i + l) + currentColIndex;
                    rowSpanCells.set(key, curTable.rows[i].cells[k]);
                }
                var cellIndex = this.getCellIndex(rowSpanCells, i, k);
                if (cellIndex > currentColIndex) currentColIndex = cellIndex;
                var width = curTable.rows[i].cells[k].offsetWidth;
                if (!sizes[currentColIndex] || width < sizes[currentColIndex]) sizes[currentColIndex] = width;
                currentColIndex += 1 + curTable.rows[i].cells[k].colSpan - 1;
            }
        }
        return sizes;
    };
    TableCommand.prototype.getCellIndex = function(rowSpanCells, rowIndex, colIndex) {
        var cellKey = "" + rowIndex + colIndex;
        var spannedCell = rowSpanCells.get(cellKey);
        if (spannedCell) return this.getCellIndex(rowSpanCells, rowIndex, colIndex + spannedCell.colSpan);
        else return colIndex;
    };
    TableCommand.prototype.convertPixelToPercentage = function(value, offsetValue) {
        return value / offsetValue * 100;
    };
    TableCommand.prototype.getCorrespondingColumns = function() {
        var elementArray = [];
        // eslint-disable-next-line
        var _this = this;
        var colspan = 0;
        var allRows = _this.curTable.rows;
        for(var i = 0; i <= allRows.length - 1; i++){
            var ele = allRows[i];
            var index = 0;
            for(var j = 0; j <= ele.children.length - 1; j++){
                var colEle = ele.children[j];
                for(var ele_1 = colEle, colspan_1 = parseInt(ele_1.getAttribute("colspan"), 10) || 1, rowSpan = parseInt(ele_1.getAttribute("rowspan"), 10) || 1, rowIndex = i; rowIndex < i + rowSpan; rowIndex++)for(var colIndex = index; colIndex < index + colspan_1; colIndex++){
                    if (!elementArray[rowIndex]) elementArray[rowIndex] = [];
                    if (elementArray[rowIndex][colIndex]) index++;
                    else elementArray[rowIndex][colIndex] = colEle;
                }
                index += colspan;
            }
        /* eslint-enable */ }
        return elementArray;
    };
    // eslint-disable-next-line
    TableCommand.prototype.FindIndex = function(rowIndex, columnIndex, cells) {
        var nextIndex;
        var nextCol;
        for(nextIndex = rowIndex + 1, nextCol = columnIndex + 1; nextIndex < cells.length;){
            if (cells[nextIndex][columnIndex] !== cells[rowIndex][columnIndex]) {
                nextIndex--;
                break;
            }
            nextIndex++;
        }
        for(nextIndex === cells.length && nextIndex--; nextCol < cells[rowIndex].length;){
            if (cells[rowIndex][nextCol] !== cells[rowIndex][columnIndex]) {
                nextCol--;
                break;
            }
            nextCol++;
        }
        return nextCol === cells[rowIndex].length && nextCol--, [
            nextIndex,
            nextCol
        ];
    };
    TableCommand.prototype.getCorrespondingIndex = function(cell, allCells) {
        //let value: RowCol = new RowCol();
        for(var i = 0; i < allCells.length; i++)for(var j = 0; j < allCells[i].length; j++){
            if (allCells[i][j] === cell) return [
                i,
                j
            ];
        }
        return [];
    };
    TableCommand.prototype.highlightCells = function(minRow, maxRow, minCol, maxCol, eleArray) {
        var j;
        var k;
        var startCell;
        var endCell;
        var minRowIndex = minRow;
        var maxRowIndex = maxRow;
        var minColIndex = minCol;
        var maxColIndex = maxCol;
        var minMaxValues = new $eff586c2ee4b592c$var$MinMax();
        for(j = minRowIndex; j <= maxRowIndex; j++){
            startCell = this.getCorrespondingIndex(eleArray[j][minColIndex], eleArray);
            endCell = this.FindIndex(startCell[0], startCell[1], eleArray);
            if ((1 < (parseInt(eleArray[j][minColIndex].getAttribute("rowspan"), 10) || 1) || 1 < (parseInt(eleArray[j][minColIndex].getAttribute("colspan"), 10) || 1)) && endCell) {
                minRowIndex = Math.min(startCell[0], minRowIndex);
                maxRowIndex = Math.max(endCell[0], maxRowIndex);
                minColIndex = Math.min(startCell[1], minColIndex);
                maxColIndex = Math.max(endCell[1], maxColIndex);
            } else if (1 < (parseInt(eleArray[j][maxColIndex].getAttribute("rowspan"), 10) || 1) || 1 < (parseInt(eleArray[j][maxColIndex].getAttribute("colspan"), 10) || 1)) {
                startCell = this.getCorrespondingIndex(eleArray[j][maxColIndex], eleArray);
                endCell = this.FindIndex(startCell[0], startCell[1], eleArray);
                if (endCell) {
                    minRowIndex = Math.min(startCell[0], minRowIndex);
                    maxRowIndex = Math.max(endCell[0], maxRowIndex);
                    minColIndex = Math.min(startCell[1], minColIndex);
                    maxColIndex = Math.max(endCell[1], maxColIndex);
                }
            }
            for(k = minColIndex; k <= maxColIndex; k++){
                startCell = this.getCorrespondingIndex(eleArray[minRowIndex][k], eleArray);
                endCell = this.FindIndex(startCell[0], startCell[1], eleArray);
                if ((1 < (parseInt(eleArray[minRowIndex][k].getAttribute("rowspan"), 10) || 1) || 1 < (parseInt(eleArray[minRowIndex][k].getAttribute("colspan"), 10) || 1)) && endCell) {
                    minRowIndex = Math.min(startCell[0], minRowIndex);
                    maxRowIndex = Math.max(endCell[0], maxRowIndex);
                    minColIndex = Math.min(startCell[1], minColIndex);
                    maxColIndex = Math.max(endCell[1], maxColIndex);
                } else if (1 < (parseInt(eleArray[maxRowIndex][k].getAttribute("rowspan"), 10) || 1) || 1 < (parseInt(eleArray[maxRowIndex][k].getAttribute("colspan"), 10) || 1)) {
                    startCell = this.getCorrespondingIndex(eleArray[maxRowIndex][k], eleArray);
                    endCell = this.FindIndex(startCell[0], startCell[1], eleArray);
                    if (endCell) {
                        minRowIndex = Math.min(startCell[0], minRowIndex);
                        maxRowIndex = Math.max(endCell[0], maxRowIndex);
                        minColIndex = Math.min(startCell[1], minColIndex);
                        maxColIndex = Math.max(endCell[1], maxColIndex);
                    }
                }
            }
            minMaxValues = minRowIndex === minRow && maxRowIndex === maxRow && minColIndex === minCol && maxColIndex === maxCol ? {
                startRow: minRow,
                endRow: maxRow,
                startColumn: minCol,
                endColumn: maxCol
            } : this.highlightCells(minRowIndex, maxRowIndex, minColIndex, maxColIndex, eleArray);
        }
        return minMaxValues;
    /* eslint-enable */ };
    TableCommand.prototype.restoreRange = function(target) {
        if (this.parent.currentDocument.getSelection().rangeCount && (target.nodeName === "TD" || target.nodeName === "TH")) this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, target, 0);
    };
    TableCommand.prototype.tableMove = function(e) {
        this.activeCell = e.selectNode[0];
        var target = e.event.target;
        var activeCellTag = this.activeCell.tagName;
        var targetCellTag = target.tagName;
        this.curTable = (0, $4ZDHT.closest)(target, "table");
        if (target.tagName !== "TD" && target.tagName !== "TH" && activeCellTag !== targetCellTag) return;
        var activeCellTable = (0, $4ZDHT.closest)(this.activeCell, "table");
        if ((0, $3EnZW.isNullOrUndefined)(this.curTable) || (0, $3EnZW.isNullOrUndefined)(activeCellTable) || activeCellTable !== this.curTable) return;
        var correspondingCells = this.getCorrespondingColumns();
        var activeIndexes = this.getCorrespondingIndex(this.activeCell, correspondingCells);
        var targetIndexes = this.getCorrespondingIndex(target, correspondingCells);
        var activeCellList = this.curTable.querySelectorAll(".e-cell-select, .e-multi-cells-select, .e-cell-select-end");
        for(var i = activeCellList.length - 1; i >= 0; i--){
            if (this.activeCell !== activeCellList[i]) (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                activeCellList[i]
            ], [
                "e-cell-select"
            ]);
            (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                activeCellList[i]
            ], [
                "e-multi-cells-select"
            ]);
            (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                activeCellList[i]
            ], [
                "e-cell-select-end"
            ]);
        }
        if (activeIndexes[0] === targetIndexes[0] && activeIndexes[1] === targetIndexes[1]) {
            if (activeCellList.length > 1) this.restoreRange(target);
            return;
        }
        var minMaxIndexes = this.highlightCells(Math.min(activeIndexes[0], targetIndexes[0]), Math.max(activeIndexes[0], targetIndexes[0]), Math.min(activeIndexes[1], targetIndexes[1]), Math.max(activeIndexes[1], targetIndexes[1]), correspondingCells);
        for(var rowIndex = minMaxIndexes.startRow; rowIndex <= minMaxIndexes.endRow; rowIndex++)for(var colIndex = minMaxIndexes.startColumn; colIndex <= minMaxIndexes.endColumn; colIndex++){
            correspondingCells[rowIndex][colIndex].classList.add("e-cell-select");
            correspondingCells[rowIndex][colIndex].classList.add("e-multi-cells-select");
        }
        target.classList.add("e-cell-select-end");
        if (e.event.type) e.event.preventDefault();
        this.restoreRange(target);
    };
    TableCommand.prototype.destroy = function() {
        this.removeEventListener();
    };
    return TableCommand;
}();
var $eff586c2ee4b592c$var$MinMax = /** @class */ function() {
    function MinMax() {}
    return MinMax;
}();



/**
 * `Selection` module is used to handle RTE Selections.
 */ 


/**
 * Is formatted or not.
 *
 * @hidden

 */ var $fc5331de40b32b1d$export$cfa313d0a8d98bda = /** @class */ function() {
    function IsFormatted() {}
    /**
     * getFormattedNode method
     *
     * @param {Node} node - specifies the node.
     * @param {string} format - specifies the string value.
     * @param {Node} endNode - specifies the end node
     * @returns {Node} - returns the node
     * @hidden

     */ IsFormatted.prototype.getFormattedNode = function(node, format, endNode) {
        var parentNode = this.getFormatParent(node, format, endNode);
        if (parentNode !== null && parentNode !== endNode) return parentNode;
        return null;
    };
    IsFormatted.prototype.getFormatParent = function(node, format, endNode) {
        do node = node.parentNode;
        while (node && node !== endNode && !this.isFormattedNode(node, format));
        return node;
    };
    IsFormatted.prototype.isFormattedNode = function(node, format) {
        switch(format){
            case "bold":
                return IsFormatted.isBold(node);
            case "italic":
                return IsFormatted.isItalic(node);
            case "underline":
                return IsFormatted.isUnderline(node);
            case "strikethrough":
                return IsFormatted.isStrikethrough(node);
            case "superscript":
                return IsFormatted.isSuperscript(node);
            case "subscript":
                return IsFormatted.isSubscript(node);
            case "fontcolor":
                return this.isFontColor(node);
            case "fontname":
                return this.isFontName(node);
            case "fontsize":
                return this.isFontSize(node);
            case "backgroundcolor":
                return this.isBackgroundColor(node);
            case "inlinecode":
                return IsFormatted.isCode(node);
            default:
                return false;
        }
    };
    /**
     * isBold method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isBold = function(node) {
        var validTags = [
            "strong",
            "b"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else if (this.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && node.style && node.style.fontWeight === "bold") return true;
        else return false;
    };
    /**
     * isItalic method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isItalic = function(node) {
        var validTags = [
            "em",
            "i"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else if (this.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && node.style && node.style.fontStyle === "italic") return true;
        else return false;
    };
    /**
     * isUnderline method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isUnderline = function(node) {
        var validTags = [
            "u"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else if (this.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && node.style && (node.style.textDecoration === "underline" || node.style.textDecorationLine === "underline")) /* eslint-enable */ return true;
        else return false;
    };
    /**
     * isStrikethrough method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isStrikethrough = function(node) {
        var validTags = [
            "del",
            "strike",
            "s"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else if (this.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && node.style && (node.style.textDecoration === "line-through" || node.style.textDecorationLine === "line-through")) /* eslint-enable */ return true;
        else return false;
    };
    /**
     * isSuperscript method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isSuperscript = function(node) {
        var validTags = [
            "sup"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else return false;
    };
    /**
     * isSubscript method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isSubscript = function(node) {
        var validTags = [
            "sub"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else return false;
    };
    IsFormatted.prototype.isFontColor = function(node) {
        var color = node.style && node.style.color;
        if (IsFormatted.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && color !== null && color !== "" && color !== undefined) return true;
        else return false;
    };
    IsFormatted.prototype.isBackgroundColor = function(node) {
        var backColor = node.style && node.style.backgroundColor;
        if (IsFormatted.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && backColor !== null && backColor !== "" && backColor !== undefined) return true;
        else return false;
    };
    IsFormatted.prototype.isFontSize = function(node) {
        var size = node.style && node.style.fontSize;
        if (IsFormatted.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && size !== null && size !== "" && size !== undefined) return true;
        else return false;
    };
    IsFormatted.prototype.isFontName = function(node) {
        var name = node.style && node.style.fontFamily;
        if (IsFormatted.inlineTags.indexOf(node.nodeName.toLowerCase()) !== -1 && name !== null && name !== "" && name !== undefined) return true;
        else return false;
    };
    /**
     * isCode method
     *
     * @param {Node} node - specifies the node value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ IsFormatted.isCode = function(node) {
        var validTags = [
            "code"
        ];
        if (validTags.indexOf(node.nodeName.toLowerCase()) !== -1) return true;
        else return false;
    };
    // Get Formatted Node
    IsFormatted.inlineTags = [
        "a",
        "abbr",
        "acronym",
        "b",
        "bdo",
        "big",
        "cite",
        "code",
        "dfn",
        "em",
        "font",
        "i",
        "kbd",
        "label",
        "q",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "tt",
        "u",
        "var",
        "del"
    ];
    return IsFormatted;
}();



parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

var $7dd901ee55c381ee$export$182333f802b3d72b = /** @class */ function() {
    function SelectionCommands() {}
    /**
     * applyFormat method
     *
     * @param {Document} docElement - specifies the document
     * @param {string} format - specifies the string value
     * @param {Node} endNode - specifies the end node
     * @param {string} enterAction - specifies the enter key action
     * @param {ITableSelection} tableCellSelection - specifies the table cell selection
     * @param {string} value - specifies the string value
     * @param {string} selector - specifies the string
     * @param {FormatPainterValue} painterValues specifies the element created and last child
     * @returns {void}
     * @hidden

     */ SelectionCommands.applyFormat = function(docElement, format, endNode, enterAction, tableCellSelection, value, selector, painterValues) {
        this.enterAction = enterAction;
        var validFormats = [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "superscript",
            "subscript",
            "uppercase",
            "lowercase",
            "fontcolor",
            "fontname",
            "fontsize",
            "backgroundcolor",
            "inlinecode"
        ];
        if (validFormats.indexOf(format) > -1 || value === "formatPainter") {
            if (format === "backgroundcolor" && value === "") value = "transparent";
            var domSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
            var domNode = new (0, $885a3ef7b3a774b1$export$913ca0ecb04f4c72)(endNode, docElement);
            var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
            var isFormatted = new (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda)();
            var range = domSelection.getRange(docElement);
            var currentAnchorNode = range.startContainer.parentElement;
            if (range.collapsed && !(0, $3EnZW.isNullOrUndefined)(currentAnchorNode) && currentAnchorNode.tagName === "A" && (range.startOffset === currentAnchorNode.textContent.length || range.startOffset === 0)) {
                var emptyTextNode = document.createTextNode("");
                if (range.startOffset === 0) currentAnchorNode.parentNode.insertBefore(emptyTextNode, currentAnchorNode);
                else if (!(0, $3EnZW.isNullOrUndefined)(currentAnchorNode.nextSibling)) currentAnchorNode.parentElement.insertBefore(emptyTextNode, currentAnchorNode.nextSibling);
                else currentAnchorNode.parentNode.appendChild(emptyTextNode);
                // Set the range to the empty text node
                var newRange = docElement.createRange();
                range.setStart(emptyTextNode, 0);
                range.setEnd(emptyTextNode, 0);
                range.collapse(true);
                domSelection.setRange(docElement, newRange);
            }
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && range.startContainer === range.endContainer && !(0, $3EnZW.isNullOrUndefined)(endNode) && range.startContainer === endNode) {
                var startChildNodes = range.startContainer.childNodes;
                var startNode = startChildNodes[range.startOffset > 0 ? range.startOffset - 1 : range.startOffset] || range.startContainer;
                var endNode_1 = range.endContainer.childNodes[range.endOffset > 0 ? range.endOffset - 1 : range.endOffset] || range.endContainer;
                var lastSelectionNode = endNode_1.lastChild.nodeName === "BR" ? (0, $3EnZW.isNullOrUndefined)(endNode_1.lastChild.previousSibling) ? endNode_1 : endNode_1.lastChild.previousSibling : endNode_1.firstChild;
                while(!(0, $3EnZW.isNullOrUndefined)(lastSelectionNode) && lastSelectionNode.nodeName !== "#text" && lastSelectionNode.nodeName !== "IMG" && lastSelectionNode.nodeName !== "BR" && lastSelectionNode.nodeName !== "HR")lastSelectionNode = lastSelectionNode.lastChild;
                domSelection.setSelectionText(docElement, startNode, lastSelectionNode, 0, 0);
                range = domSelection.getRange(docElement);
            }
            var save = domSelection.save(range, docElement);
            var nodes = void 0;
            var isTableSelect = false;
            if (endNode && tableCellSelection && endNode.nodeName !== "#text") nodes = tableCellSelection.getTextNodes();
            if (nodes && nodes.length > 0) isTableSelect = true;
            else nodes = range.collapsed ? domSelection.getSelectionNodeCollection(range) : domSelection.getSelectionNodeCollectionBr(range);
            var isCollapsed = false;
            var isFormat = false;
            var isCursor = false;
            var preventRestore = false;
            var isFontStyle = [
                "fontcolor",
                "fontname",
                "fontsize",
                "backgroundcolor"
            ].indexOf(format) > -1;
            if (!isTableSelect && range.collapsed) {
                var currentFormatNode = isFormatted.getFormattedNode(range.startContainer, format, endNode);
                var currentSelector = !(0, $3EnZW.isNullOrUndefined)(currentFormatNode) ? currentFormatNode.getAttribute("style") === null ? currentFormatNode.nodeName : currentFormatNode.nodeName + "[style='" + currentFormatNode.getAttribute("style") + "']" : null;
                if (nodes.length > 0) {
                    isCollapsed = true;
                    range = nodeCutter.GetCursorRange(docElement, range, nodes[0]);
                } else if (range.startContainer.nodeType === 3 && (range.startContainer.parentElement.childElementCount > 0 && range.startOffset > 0 && range.startContainer.parentElement.firstElementChild.tagName.toLowerCase() !== "br" || !(0, $3EnZW.isNullOrUndefined)(currentFormatNode) && currentFormatNode === range.startContainer.parentElement.closest(currentSelector) && range.startContainer.parentElement.closest(currentSelector).textContent.replace(new RegExp("\u200B", "g"), "").trim().length !== 0)) {
                    isCollapsed = true;
                    range = nodeCutter.GetCursorRange(docElement, range, range.startContainer);
                    nodes.push(range.startContainer);
                } else {
                    var cursorNode = this.insertCursorNode(docElement, domSelection, range, isFormatted, nodeCutter, format, value, endNode);
                    domSelection.endContainer = domSelection.startContainer = domSelection.getNodeArray(cursorNode, true);
                    var childNodes = cursorNode.nodeName === "BR" && cursorNode.parentNode.childNodes;
                    if (!(0, $3EnZW.isNullOrUndefined)(childNodes) && childNodes.length === 1 && childNodes[0].nodeName === "BR" && nodes.length === 0) {
                        domSelection.setSelectionText(docElement, range.startContainer, range.endContainer, 0, 0);
                        preventRestore = true;
                    } else domSelection.endOffset = domSelection.startOffset = 1;
                    if (cursorNode.nodeName === "BR" && cursorNode.parentNode.textContent.length === 0) preventRestore = true;
                }
            }
            isCursor = isTableSelect ? false : range.collapsed;
            var isSubSup = false;
            for(var index = 0; index < nodes.length; index++){
                var formatNode = isFormatted.getFormattedNode(nodes[index], format, endNode);
                if (formatNode === null) {
                    if (format === "subscript") {
                        formatNode = isFormatted.getFormattedNode(nodes[index], "superscript", endNode);
                        isSubSup = formatNode === null ? false : true;
                    } else if (format === "superscript") {
                        formatNode = isFormatted.getFormattedNode(nodes[index], "subscript", endNode);
                        isSubSup = formatNode === null ? false : true;
                    }
                }
                if (index === 0 && formatNode === null) isFormat = true;
                if (formatNode !== null && (!isFormat || isFontStyle)) nodes[index] = this.removeFormat(nodes, index, formatNode, isCursor, isTableSelect, isFormat, isFontStyle, range, nodeCutter, format, value, domSelection, endNode, domNode);
                else nodes[index] = this.insertFormat(docElement, nodes, index, formatNode, isCursor, isTableSelect, isFormat, isFontStyle, range, nodeCutter, format, value, painterValues, domNode, endNode);
                if (!isTableSelect) domSelection = this.applySelection(nodes, domSelection, nodeCutter, index, isCollapsed);
            }
            if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(endNode, selector);
            if (!preventRestore && !isTableSelect) save.restore();
            if (isSubSup) this.applyFormat(docElement, format, endNode, enterAction);
        }
    };
    SelectionCommands.insertCursorNode = function(docElement, domSelection, range, isFormatted, nodeCutter, format, value, endNode) {
        var cursorNodes = domSelection.getNodeCollection(range);
        var domNode = new (0, $885a3ef7b3a774b1$export$913ca0ecb04f4c72)(endNode, docElement);
        var cursorFormat = cursorNodes.length > 0 ? cursorNodes.length > 1 && range.startContainer === range.endContainer ? this.getCursorFormat(isFormatted, cursorNodes, format, endNode) : value === "" && format === "fontsize" && isFormatted.getFormattedNode(cursorNodes[0], format, endNode) == null && cursorNodes[0].parentElement.nodeName === "SPAN" ? cursorNodes[0].parentElement : isFormatted.getFormattedNode(cursorNodes[0], format, endNode) : null;
        var cursorNode = null;
        if (cursorFormat) {
            cursorNode = cursorNodes[0];
            if (cursorFormat.firstChild.textContent.charCodeAt(0) === 8203 && cursorFormat.firstChild.nodeType === 3) {
                var regEx = new RegExp("\u200B", "g");
                var emptySpaceNode = void 0;
                if (cursorNode.nodeName !== "#text") {
                    for(var i = 0; i < cursorNodes.length; i++)if (cursorNodes[i].nodeType === Node.TEXT_NODE) cursorNode = cursorNodes[i];
                }
                if (cursorFormat.firstChild === cursorNode) {
                    cursorNode.textContent = cursorFormat.parentElement && (domNode.isBlockNode(cursorFormat.parentElement) && cursorFormat.parentElement.textContent.length <= 1 ? cursorFormat.parentElement.childElementCount > 1 : cursorFormat.childElementCount === 0) && (cursorFormat.parentElement.textContent.length > 1 || cursorFormat.parentElement.firstChild && cursorFormat.parentElement.firstChild.nodeType === 1) ? cursorNode.textContent : cursorNode.textContent.replace(regEx, "");
                    emptySpaceNode = cursorNode;
                } else {
                    cursorFormat.firstChild.textContent = cursorFormat.firstChild.textContent.replace(regEx, "");
                    emptySpaceNode = cursorFormat.firstChild;
                }
                var pointer = void 0;
                if (emptySpaceNode.textContent.length === 0) {
                    if (!(0, $3EnZW.isNullOrUndefined)(emptySpaceNode.previousSibling)) {
                        cursorNode = emptySpaceNode.previousSibling;
                        pointer = emptySpaceNode.textContent.length - 1;
                        domSelection.setCursorPoint(docElement, emptySpaceNode, pointer);
                    } else if (!(0, $3EnZW.isNullOrUndefined)(emptySpaceNode.parentElement) && emptySpaceNode.parentElement.textContent.length === 0) {
                        var brElem = document.createElement("BR");
                        emptySpaceNode.parentElement.appendChild(brElem);
                        (0, $4ZDHT.detach)(emptySpaceNode);
                        cursorNode = brElem;
                        domSelection.setCursorPoint(docElement, cursorNode.parentElement, 0);
                    }
                }
            }
            if ([
                "fontcolor",
                "fontname",
                "fontsize",
                "backgroundcolor"
            ].indexOf(format) > -1) {
                if (format === "fontcolor") cursorFormat.style.color = value;
                else if (format === "fontname") cursorFormat.style.fontFamily = value;
                else if (format === "fontsize") cursorFormat.style.fontSize = value;
                else cursorFormat.style.backgroundColor = value;
                cursorNode = cursorFormat;
            } else (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(cursorFormat);
        } else {
            if (cursorNodes.length > 1 && range.startOffset > 0 && cursorNodes[0].firstElementChild && cursorNodes[0].firstElementChild.tagName.toLowerCase() === "br") cursorNodes[0].innerHTML = "";
            if (cursorNodes.length === 1 && range.startOffset === 0 && (cursorNodes[0].nodeName === "BR" || ((0, $3EnZW.isNullOrUndefined)(cursorNodes[0].nextSibling) ? false : cursorNodes[0].nextSibling.nodeName === "BR"))) (0, $4ZDHT.detach)(cursorNodes[0].nodeName === "#text" ? cursorNodes[0].nextSibling : cursorNodes[0]);
            if (!(0, $3EnZW.isNullOrUndefined)(cursorNodes[0].parentElement) && (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).inlineTags.indexOf(cursorNodes[0].parentElement.tagName.toLowerCase()) !== -1 && cursorNodes[0].textContent.includes("\u200B")) {
                var element = this.GetFormatNode(format, value);
                var tempNode = cursorNodes[0];
                if (format === "fontsize") {
                    var currentFormatNode = cursorNodes[0];
                    while(currentFormatNode){
                        var isSameTextContent = currentFormatNode.parentElement.textContent.trim() === cursorNodes[0].textContent.trim();
                        var previousElement = currentFormatNode.parentElement;
                        if (!domNode.isBlockNode(previousElement) && isSameTextContent && !(previousElement.nodeName === "SPAN" && previousElement.classList.contains("e-img-inner"))) currentFormatNode = previousElement;
                        else break;
                        cursorNodes[0] = currentFormatNode;
                    }
                }
                this.applyStyles(cursorNodes, 0, element);
                return tempNode;
            }
            cursorNode = this.getInsertNode(docElement, range, format, value).firstChild;
        }
        return cursorNode;
    };
    SelectionCommands.getCursorFormat = function(isFormatted, cursorNodes, format, endNode) {
        var currentNode;
        for(var index = 0; index < cursorNodes.length; index++)currentNode = cursorNodes[index].lastElementChild ? cursorNodes[index].lastElementChild : cursorNodes[index];
        return format === "fontsize" && isFormatted.getFormattedNode(currentNode, format, endNode) == null && currentNode.parentElement.nodeName === "SPAN" ? currentNode.parentElement : isFormatted.getFormattedNode(currentNode, format, endNode);
    };
    SelectionCommands.removeFormat = function(nodes, index, formatNode, isCursor, isTableCell, isFormat, isFontStyle, range, nodeCutter, format, value, domSelection, endNode, domNode) {
        var splitNode = null;
        var startText = range.startContainer.nodeName === "#text" ? range.startContainer.textContent.substring(range.startOffset, range.startContainer.textContent.length) : range.startContainer.textContent;
        var nodeText = nodes[index].textContent;
        if (!(range.startContainer === range.endContainer && range.startOffset === 0 && range.endOffset === range.startContainer.length)) {
            var nodeIndex = [];
            var cloneNode = nodes[index];
            var clonedElement = cloneNode;
            do {
                nodeIndex.push(domSelection.getIndex(cloneNode));
                cloneNode = cloneNode.parentNode;
            }while (cloneNode && cloneNode !== formatNode);
            if (nodes[index].nodeName !== "BR") {
                if (clonedElement.nodeName === "#text" && clonedElement.textContent.includes("\u200B")) clonedElement.remove();
                if (!isTableCell) cloneNode = splitNode = isCursor && formatNode.textContent.length - 1 === range.startOffset ? nodeCutter.SplitNode(range, formatNode, true) : nodeCutter.GetSpliceNode(range, formatNode);
            }
            if (!isCursor) {
                while(cloneNode && cloneNode.childNodes.length > 0 && nodeIndex.length - 1 >= 0 && cloneNode.childNodes.length > nodeIndex[nodeIndex.length - 1]){
                    cloneNode = cloneNode.childNodes[nodeIndex[nodeIndex.length - 1]];
                    nodeIndex.pop();
                }
                if (nodes[index].nodeName !== "BR") {
                    if (cloneNode.nodeType === 3 && !(isCursor && cloneNode.nodeValue === "")) nodes[index] = cloneNode;
                    else {
                        var divNode = document.createElement("div");
                        divNode.innerHTML = "&#8203;";
                        if (cloneNode.nodeType !== 3) {
                            cloneNode.insertBefore(divNode.firstChild, cloneNode.firstChild);
                            nodes[index] = cloneNode.firstChild;
                        } else {
                            cloneNode.parentNode.insertBefore(divNode.firstChild, cloneNode);
                            nodes[index] = cloneNode.previousSibling;
                            cloneNode.parentNode.removeChild(cloneNode);
                        }
                    }
                }
            } else {
                var lastNode = splitNode;
                for(; lastNode.firstChild !== null && lastNode.firstChild.nodeType !== 3;)lastNode = lastNode.firstChild;
                lastNode.innerHTML = "&#8203;";
                nodes[index] = lastNode.firstChild;
            }
        } else if (isFontStyle && !nodes[index].contains(formatNode) && nodes[index].nodeType === 3 && nodes[index].textContent !== formatNode.textContent) {
            // If the selection is within the format node .
            var isFullNodeSelected = nodes[index].textContent === nodes[index].wholeText;
            var nodeTraverse = nodes[index];
            var styleElement = this.GetFormatNode(format, value);
            // while loop and traverse back until text content does not match with parent text content
            while(nodeTraverse && nodeTraverse.textContent === nodeTraverse.parentElement.textContent)nodeTraverse = nodeTraverse.parentElement;
            if (isFullNodeSelected && formatNode.textContent !== nodeTraverse.textContent) {
                var nodeArray = [];
                var priorityNode = this.getPriorityFormatNode(nodeTraverse, endNode);
                if (priorityNode && priorityNode.textContent === nodeTraverse.textContent) nodeTraverse = priorityNode;
                nodeArray.push(nodeTraverse);
                this.applyStyles(nodeArray, 0, styleElement);
                return nodes[index];
            }
        }
        var fontStyle;
        if (format === "backgroundcolor") fontStyle = formatNode.style.fontSize;
        var bgStyle;
        if (format === "fontsize") {
            var bg = (0, $4ZDHT.closest)(nodes[index].parentElement, "span[style*=background-color]");
            if (!(0, $3EnZW.isNullOrUndefined)(bg)) bgStyle = bg.style.backgroundColor;
        }
        var formatNodeStyles = formatNode.getAttribute("style");
        var formatNodeTagName = formatNode.tagName;
        var child;
        if (formatNodeTagName === "A" && format === "underline") {
            formatNode.style.textDecoration = "none";
            child = [
                formatNode
            ];
        } else if ((0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).inlineTags.indexOf(formatNodeTagName.toLowerCase()) !== -1 && isFontStyle && formatNodeTagName.toLocaleLowerCase() !== "span") {
            var fontNodeStyle = formatNode.style;
            if (fontNodeStyle.color && format === "fontcolor") {
                if (formatNode.nodeName === "A") fontNodeStyle.color = value;
                else fontNodeStyle.color = "";
            } else if (fontNodeStyle.backgroundColor && format === "backgroundcolor") fontNodeStyle.backgroundColor = "";
            else if (fontNodeStyle.fontSize && format === "fontsize") fontNodeStyle.fontSize = "";
            else if (fontNodeStyle.fontFamily && format === "fontname") fontNodeStyle.fontFamily = "";
            if (formatNode.getAttribute("style") === "") formatNode.removeAttribute("style");
            child = [
                formatNode
            ];
        } else {
            child = (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(formatNode);
            var liElement = nodes[index].parentElement;
            if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() !== "li") liElement = (0, $4ZDHT.closest)(liElement, "li");
            if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() === nodes[index].textContent.trim()) {
                if (format === "bold") liElement.style.fontWeight = "normal";
                else if (format === "italic") liElement.style.fontStyle = "normal";
            } else if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() !== nodes[index].textContent.trim()) SelectionCommands.conCatenateTextNode(liElement, format, "", "normal", value);
        }
        if (child[0] && !isFontStyle) {
            var nodeTraverse = child[index] ? child[index] : child[0];
            var textNode = nodeTraverse;
            for(; nodeTraverse && nodeTraverse.parentElement && nodeTraverse.parentElement !== endNode; nodeTraverse){
                var nodeTraverseCondition = void 0;
                if (formatNode.nodeName === "SPAN") nodeTraverseCondition = nodeTraverse.parentElement.tagName.toLocaleLowerCase() === formatNode.tagName.toLocaleLowerCase() && nodeTraverse.parentElement.getAttribute("style") === formatNodeStyles;
                else nodeTraverseCondition = nodeTraverse.parentElement.tagName.toLocaleLowerCase() === formatNode.tagName.toLocaleLowerCase();
                if (nodeTraverse.parentElement && nodeTraverseCondition && (nodeTraverse.parentElement.childElementCount > 1 || range.startOffset > 1)) {
                    if (textNode.parentElement && textNode.parentElement.tagName.toLocaleLowerCase() === formatNode.tagName.toLocaleLowerCase()) {
                        if (range.startOffset === range.endOffset && textNode.nodeType !== 1 && !(0, $3EnZW.isNullOrUndefined)(textNode.textContent) && textNode.parentElement.childElementCount > 1) {
                            range.setStart(textNode, 0);
                            range.setEnd(textNode, textNode.textContent.length);
                            nodeCutter.SplitNode(range, textNode.parentElement, false);
                        }
                    }
                    if (nodeTraverse.parentElement.tagName.toLocaleLowerCase() === "span") {
                        if (formatNode.style.textDecoration === "underline" && nodeTraverse.parentElement.style.textDecoration !== "underline") {
                            nodeTraverse = nodeTraverse.parentElement;
                            continue;
                        }
                    }
                    (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(nodeTraverse.parentElement);
                    nodeTraverse = !(0, $3EnZW.isNullOrUndefined)(nodeTraverse.parentElement) && !domNode.isBlockNode(nodeTraverse.parentElement) ? textNode : nodeTraverse.parentElement;
                } else nodeTraverse = nodeTraverse.parentElement;
            }
        }
        if (child.length > 0 && isFontStyle && !(format === "fontname" && value === "" || format === "fontsize" && value === "")) {
            for(var num = 0; num < child.length; num++)if (child[num].nodeType !== 3 || child[num].textContent && child[num].textContent.trim().length > 0) {
                child[num] = (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(child[num], this.GetFormatNode(format, value, formatNodeTagName, formatNodeStyles));
                var liElement = nodes[index].parentElement;
                if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() !== "li") liElement = (0, $4ZDHT.closest)(liElement, "li");
                if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() === nodes[index].textContent.trim()) {
                    if (format === "fontname") liElement.style.fontFamily = value;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() !== nodes[index].textContent.trim()) SelectionCommands.conCatenateTextNode(liElement, format, liElement.textContent, format, value);
                if (child[num].textContent === startText) {
                    if (num === 0) range.setStartBefore(child[num]);
                    else if (num === child.length - 1) range.setEndAfter(child[num]);
                }
            }
            var currentNodeElem = nodes[index].parentElement;
            if (!(0, $3EnZW.isNullOrUndefined)(fontStyle) && fontStyle !== "") currentNodeElem.style.fontSize = fontStyle;
            if (!(0, $3EnZW.isNullOrUndefined)(bgStyle) && bgStyle !== "") currentNodeElem.style.backgroundColor = bgStyle;
            if (format === "backgroundcolor" && !(0, $3EnZW.isNullOrUndefined)(fontStyle) && fontStyle !== "" && currentNodeElem.parentElement.innerHTML === currentNodeElem.outerHTML) {
                var curParentElem = currentNodeElem.parentElement;
                curParentElem.parentElement.insertBefore(currentNodeElem, curParentElem);
                (0, $4ZDHT.detach)(curParentElem);
            }
            if (format === "fontsize" || format === "fontcolor") {
                var liElement = nodes[index].parentElement;
                var parentElement = nodes[index].parentElement;
                while(!(0, $3EnZW.isNullOrUndefined)(parentElement) && parentElement.tagName.toLowerCase() !== "li"){
                    parentElement = parentElement.parentElement;
                    liElement = parentElement;
                }
                var num = index;
                var liChildContent = "";
                while(num >= 0 && !(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.contains(nodes[num]) && liElement.textContent.replace("/\u200B/g", "").trim().includes(nodes[num].textContent.trim())){
                    /* eslint-enable security/detect-object-injection */ liChildContent = " " + nodes[num].textContent.trim() + liChildContent;
                    num--;
                }
                var isNestedList = false;
                var nestedListCount = 0;
                var isNestedListItem = false;
                if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.childNodes) {
                    for(var num_1 = 0; num_1 < liElement.childNodes.length; num_1++)if (liElement.childNodes[num_1].nodeName === "OL") {
                        nestedListCount++;
                        isNestedList = true;
                    }
                }
                if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.split("\u200B").join("").trim() === liChildContent.split("\u200B").join("").trim()) {
                    if (format === "fontsize") liElement.style.fontSize = value;
                    else {
                        liElement.style.color = value;
                        liElement.style.textDecoration = "inherit";
                    }
                } else if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && isNestedList) {
                    if (isNestedList && nestedListCount > 0) {
                        for(var num_2 = 0; num_2 < liElement.childNodes.length; num_2++)if (nodes[index].textContent === liElement.childNodes[num_2].textContent && nodes[index].textContent === nodeText && liElement.textContent.replace("/\u200B/g", "").trim().includes(liChildContent.split("\u200B").join("").trim())) isNestedListItem = true;
                    }
                    if (isNestedListItem) {
                        for(var num_3 = 0; num_3 < liElement.childNodes.length; num_3++)if (liElement.childNodes[num_3].nodeName === "OL") liElement.childNodes[num_3].style.fontSize = "initial";
                        if (format === "fontsize") liElement.style.fontSize = value;
                        else {
                            liElement.style.color = value;
                            liElement.style.textDecoration = "inherit";
                        }
                    }
                }
            }
        }
        return nodes[index];
    };
    SelectionCommands.insertFormat = function(docElement, nodes, index, formatNode, isCursor, isTableSelect, isFormat, isFontStyle, range, nodeCutter, format, value, painterValues, domNode, endNode) {
        if (!isCursor) {
            if (formatNode === null && isFormat || isFontStyle) {
                if (!isTableSelect && nodes[index].nodeName !== "BR") {
                    nodes[index] = nodeCutter.GetSpliceNode(range, nodes[index]);
                    nodes[index].textContent = nodeCutter.TrimLineBreak(nodes[index].textContent);
                }
                if (format === "uppercase" || format === "lowercase") nodes[index].textContent = format === "uppercase" ? nodes[index].textContent.toLocaleUpperCase() : nodes[index].textContent.toLocaleLowerCase();
                else if (!(isFontStyle === true && value === "")) {
                    var element = this.GetFormatNode(format, value);
                    if (value === "formatPainter" || isFontStyle) {
                        var liElement = nodes[index].parentElement;
                        var parentElement = nodes[index].parentElement;
                        while(!(0, $3EnZW.isNullOrUndefined)(parentElement) && parentElement.tagName.toLowerCase() !== "li"){
                            parentElement = parentElement.parentElement;
                            liElement = parentElement;
                        }
                        if (format === "fontcolor" || format === "fontname" || format === "fontsize") {
                            var parentElem = nodes[index].parentElement;
                            if (!(0, $3EnZW.isNullOrUndefined)(parentElem) && parentElem.childNodes) for(var i = 0; i < parentElem.childNodes.length; i++){
                                if (this.concatenateTextExcludingList(nodes, index) === nodes[index].textContent) {
                                    var liElement_1 = void 0;
                                    if (parentElem.tagName === "LI") liElement_1 = parentElem;
                                    else if (parentElem.closest("li")) liElement_1 = parentElem.closest("li");
                                    if (!(0, $3EnZW.isNullOrUndefined)(liElement_1)) switch(format){
                                        case "fontcolor":
                                            liElement_1.style.color = value;
                                            break;
                                        case "fontname":
                                            liElement_1.style.fontFamily = value;
                                            break;
                                        case "fontsize":
                                            liElement_1.style.fontSize = value;
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                var childElement = parentElem.childNodes[i];
                                if (childElement.tagName === "OL" || childElement.tagName === "UL") switch(format){
                                    case "fontcolor":
                                        childElement.style.color = "initial";
                                        break;
                                    case "fontname":
                                        childElement.style.fontFamily = "initial";
                                        break;
                                    case "fontsize":
                                        childElement.style.fontSize = "initial";
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() === nodes[index].textContent.trim()) {
                            if (format === "fontsize") liElement.style.fontSize = value;
                            else if (format === "fontcolor") {
                                liElement.style.color = value;
                                liElement.style.textDecoration = "inherit";
                            } else if (format === "fontname") liElement.style.fontFamily = value;
                        }
                        if (value === "formatPainter") return this.insertFormatPainterElem(nodes, index, range, nodeCutter, painterValues, domNode);
                        var currentNode = nodes[index];
                        var priorityNode = this.getPriorityFormatNode(currentNode, endNode);
                        // 1. Checking is there any priority node present in the selection range. (Use case for nested styles);
                        // 2  Or font style is applied. (Use case not a nested style)
                        if (!(0, $3EnZW.isNullOrUndefined)(priorityNode) || isFontStyle) {
                            var currentFormatNode = (0, $3EnZW.isNullOrUndefined)(priorityNode) ? currentNode : priorityNode;
                            currentFormatNode = !(0, $3EnZW.isNullOrUndefined)(priorityNode) && priorityNode.style.fontSize !== "" ? currentFormatNode.firstChild : currentFormatNode;
                            if ((0, $3EnZW.isNullOrUndefined)(priorityNode) || format === "fontsize") while(currentFormatNode){
                                var isSameTextContent = currentFormatNode.parentElement.textContent.trim() === nodes[index].textContent.trim();
                                var parent_1 = currentFormatNode.parentElement;
                                if (!domNode.isBlockNode(parent_1) && isSameTextContent && !(parent_1.nodeName === "SPAN" && parent_1.classList.contains("e-img-inner"))) currentFormatNode = parent_1;
                                else break;
                            }
                            var nodeList = [];
                            // Since color is different for different themnes, we need to wrap the fontColor over the text node.
                            if (format === "fontcolor") {
                                var closestAnchor = (0, $4ZDHT.closest)(nodes[index].parentElement, "A");
                                if (!(0, $3EnZW.isNullOrUndefined)(closestAnchor) && closestAnchor.firstChild.textContent.trim() === nodes[index].textContent.trim()) currentFormatNode = nodes[index];
                            }
                            if (nodes[index].textContent.trim() !== currentFormatNode.textContent.trim()) currentFormatNode = nodes[index];
                            nodeList[0] = currentFormatNode;
                            this.applyStyles(nodeList, 0, element);
                            if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() !== nodes[index].textContent.trim()) SelectionCommands.conCatenateTextNode(liElement, format, liElement.textContent, format, value);
                        } else nodes[index] = this.applyStyles(nodes, index, element);
                    } else {
                        nodes[index] = this.applyStyles(nodes, index, element);
                        var liElement = nodes[index].parentElement;
                        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() !== "li") liElement = (0, $4ZDHT.closest)(liElement, "li");
                        if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() === nodes[index].textContent.trim()) {
                            if (format === "bold") liElement.style.fontWeight = "bold";
                            else if (format === "italic") liElement.style.fontStyle = "italic";
                        } else if (!(0, $3EnZW.isNullOrUndefined)(liElement) && liElement.tagName.toLowerCase() === "li" && liElement.textContent.trim() !== nodes[index].textContent.trim()) SelectionCommands.conCatenateTextNode(liElement, format, liElement.textContent, format);
                    }
                }
            } else if (!isTableSelect) nodes[index] = nodeCutter.GetSpliceNode(range, nodes[index]);
        } else if (format !== "uppercase" && format !== "lowercase") {
            var element = this.getInsertNode(docElement, range, format, value);
            nodes[index] = element.firstChild;
            nodeCutter.position = 1;
        } else nodeCutter.position = range.startOffset;
        return nodes[index];
    };
    SelectionCommands.applyStyles = function(nodes, index, element) {
        if (!(nodes[index].nodeName === "BR" && this.enterAction === "BR")) {
            nodes[index] = index === nodes.length - 1 || nodes[index].nodeName === "BR" ? (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(nodes[index], element) : (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).WrapBefore(nodes[index], element, true);
            nodes[index] = this.getChildNode(nodes[index], element);
        }
        return nodes[index];
    };
    SelectionCommands.getPriorityFormatNode = function(node, endNode) {
        var isFormatted = new (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda)();
        var fontSizeNode = isFormatted.getFormattedNode(node, "fontsize", endNode);
        var fontColorNode;
        var backgroundColorNode;
        var fontNameNode;
        if ((0, $3EnZW.isNullOrUndefined)(fontSizeNode)) {
            backgroundColorNode = isFormatted.getFormattedNode(node, "backgroundcolor", endNode);
            if ((0, $3EnZW.isNullOrUndefined)(backgroundColorNode)) {
                fontNameNode = isFormatted.getFormattedNode(node, "fontname", endNode);
                if ((0, $3EnZW.isNullOrUndefined)(fontNameNode)) {
                    fontColorNode = isFormatted.getFormattedNode(node, "fontcolor", endNode);
                    if ((0, $3EnZW.isNullOrUndefined)(fontColorNode)) return null;
                    else return fontColorNode;
                } else return fontNameNode;
            } else return backgroundColorNode;
        } else return fontSizeNode;
    };
    SelectionCommands.getInsertNode = function(docElement, range, format, value) {
        var element = this.GetFormatNode(format, value);
        element.innerHTML = "&#8203;";
        if ((0, $5q7BP.Browser).isIE) {
            var frag = docElement.createDocumentFragment();
            frag.appendChild(element);
            range.insertNode(frag);
        } else range.insertNode(element);
        return element;
    };
    SelectionCommands.getChildNode = function(node, element) {
        if (node === undefined || node === null) {
            element.innerHTML = "&#8203;";
            node = element.firstChild;
        }
        return node;
    };
    SelectionCommands.applySelection = function(nodes, domSelection, nodeCutter, index, isCollapsed) {
        if (nodes.length === 1 && !isCollapsed) {
            domSelection.startContainer = domSelection.getNodeArray(nodes[index], true);
            domSelection.endContainer = domSelection.startContainer;
            domSelection.startOffset = 0;
            domSelection.endOffset = nodes[index].textContent.length;
        } else if (nodes.length === 1 && isCollapsed) {
            domSelection.startContainer = domSelection.getNodeArray(nodes[index], true);
            domSelection.endContainer = domSelection.startContainer;
            domSelection.startOffset = nodeCutter.position;
            domSelection.endOffset = nodeCutter.position;
        } else if (index === 0) {
            domSelection.startContainer = domSelection.getNodeArray(nodes[index], true);
            domSelection.startOffset = 0;
        } else if (index === nodes.length - 1) {
            domSelection.endContainer = domSelection.getNodeArray(nodes[index], false);
            domSelection.endOffset = nodes[index].textContent.length;
        }
        return domSelection;
    };
    SelectionCommands.GetFormatNode = function(format, value, tagName, styles) {
        var node;
        switch(format){
            case "bold":
                return document.createElement("strong");
            case "italic":
                return document.createElement("em");
            case "underline":
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.textDecoration = "underline";
                return node;
            case "strikethrough":
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.textDecoration = "line-through";
                return node;
            case "superscript":
                return document.createElement("sup");
            case "subscript":
                return document.createElement("sub");
            case "fontcolor":
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.color = value;
                node.style.textDecoration = "inherit";
                return node;
            case "fontname":
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.fontFamily = value;
                return node;
            case "fontsize":
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.fontSize = value;
                return node;
            case "inlinecode":
                return document.createElement("code");
            default:
                node = document.createElement("span");
                this.updateStyles(node, tagName, styles);
                node.style.backgroundColor = value;
                return node;
        }
    };
    SelectionCommands.updateStyles = function(ele, tag, styles) {
        if (styles !== null && tag === "SPAN") ele.setAttribute("style", styles);
    };
    // Below function is used to insert the element created by the format painter plugin.
    SelectionCommands.insertFormatPainterElem = function(nodes, index, range, nodeCutter, painterValues, domNode) {
        var parent = !domNode.isBlockNode(nodes[index].parentElement) ? nodes[index].parentElement : nodes[index];
        if (!domNode.isBlockNode(parent)) while(parent.textContent.trim() === parent.parentElement.textContent.trim() && !domNode.isBlockNode(parent.parentElement))parent = parent.parentElement;
        // The below code is used to remove the already present inline style from the text node.
        if (!(0, $3EnZW.isNullOrUndefined)(parent) && parent.nodeType === 1 && !(parent.classList.contains("e-rte-img-caption") || parent.classList.contains("e-img-inner"))) this.formatPainterCleanup(index, nodes, parent, range, nodeCutter, domNode);
        var elem = painterValues.element;
        // The below code is used to apply the inline format copied.
        if (!(0, $3EnZW.isNullOrUndefined)(elem)) {
            // Step 1: Cloning the element that is created by format painter.
            // Step 2: Finding the last child of the nested elememt using the paintervalues.lastchild nodename
            // Step 3: Assigning the nodes[index] text content to the last child element.
            // Step 4: Wrapping the cloned element with the nodes[index]
            var clonedElement = elem.cloneNode(true);
            var elemList = clonedElement.querySelectorAll(painterValues.lastChild.nodeName);
            var lastElement = void 0;
            if (elemList.length > 0) lastElement = elemList[elemList.length - 1];
            else if (!(0, $3EnZW.isNullOrUndefined)(clonedElement) && clonedElement.nodeName === painterValues.lastChild.nodeName) lastElement = clonedElement;
            lastElement.textContent = nodes[index].textContent;
            var lastChild = lastElement.childNodes[0];
            nodes[index] = (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(nodes[index], clonedElement);
            nodes[index].textContent = "";
            nodes[index] = lastChild;
        }
        return nodes[index];
    };
    SelectionCommands.formatPainterCleanup = function(index, nodes, parent, range, nodeCutter, domNode) {
        var INVALID_TAGS = [
            "A",
            "AUDIO",
            "IMG",
            "VIDEO",
            "IFRAME"
        ];
        if (index === 0 && parent.textContent.trim() !== nodes[index].textContent.trim()) {
            nodeCutter.SplitNode(range, parent, true);
            var childELemList = nodes[index].parentElement.childNodes;
            for(var i = 0; i < childELemList.length; i++)if (childELemList[i].textContent.trim() === nodes[i].textContent.trim()) {
                parent.parentNode.insertBefore(childELemList[i], parent);
                break;
            }
            var blockChildNodes = parent.parentElement.childNodes;
            for(var k = 0; k < blockChildNodes.length; k++)if ((blockChildNodes[k].textContent.trim() === "" || blockChildNodes[k].textContent.length === 0) && blockChildNodes[k].textContent.charCodeAt(0) !== 160) // 160 is the char code for &nbsp;
            (0, $4ZDHT.detach)(blockChildNodes[k]);
        } else if (parent.textContent.trim() !== nodes[index].textContent.trim()) parent.parentElement.insertBefore(nodes[index], parent);
        else while(!(0, $3EnZW.isNullOrUndefined)(parent) && parent.nodeType !== 3 && !domNode.isBlockNode(parent)){
            var temp = void 0;
            for(var i = 0; i < parent.childNodes.length; i++){
                var currentChild = parent.childNodes[i];
                if (currentChild.textContent.trim().length !== 0 && currentChild.nodeType !== 3) temp = parent.childNodes[i];
            }
            if (INVALID_TAGS.indexOf(parent.tagName) === -1) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(parent);
            parent = temp;
        }
    };
    SelectionCommands.concatenateTextExcludingList = function(nodes, index) {
        var result = "";
        var parentNode = nodes[index].nodeName === "#text" ? (0, $4ZDHT.closest)(nodes[index].parentElement, "li") : (0, $4ZDHT.closest)(nodes[index], "li");
        if (!(0, $3EnZW.isNullOrUndefined)(parentNode)) for(var i = 0; i < parentNode.childNodes.length; i++){
            var childNode = parentNode.childNodes[i];
            if (childNode.nodeType === 3 || childNode.nodeType === 1 && childNode.tagName !== "OL" && childNode.tagName !== "UL") result += childNode.textContent;
        }
        return result;
    };
    SelectionCommands.conCatenateTextNode = function(liElement, format, value, formatStr, constVal) {
        var result = "";
        var colorStyle = "";
        var fontSize = "";
        var fontFamily = "";
        switch(format){
            case "bold":
                liElement.querySelectorAll("strong").forEach(function(e) {
                    result = result + e.textContent;
                });
                if (result === value) liElement.style.fontWeight = formatStr;
                break;
            case "italic":
                liElement.querySelectorAll("em").forEach(function(e) {
                    result = result + e.textContent;
                });
                if (result === value) liElement.style.fontStyle = formatStr;
                break;
            case "fontcolor":
                liElement.querySelectorAll("span").forEach(function(span) {
                    colorStyle = span.style.color;
                    if (colorStyle === constVal) result = result + span.textContent;
                });
                if (result === value) {
                    liElement.style.color = colorStyle;
                    liElement.style.textDecoration = "inherit";
                }
                break;
            case "fontsize":
                liElement.querySelectorAll("span").forEach(function(span) {
                    fontSize = span.style.getPropertyValue("font-size");
                    if (fontSize === constVal) result = result + span.textContent;
                });
                if (result === value) liElement.style.fontSize = fontSize;
                break;
            case "fontname":
                liElement.querySelectorAll("span").forEach(function(span) {
                    fontFamily = span.style.getPropertyValue("font-family");
                    fontFamily = fontFamily.replace(/ /g, "");
                    if (fontFamily === constVal) result = result + span.textContent;
                });
                if (result === value) liElement.style.fontFamily = fontFamily;
                break;
        }
    };
    SelectionCommands.enterAction = "P";
    return SelectionCommands;
}();



/**
 * Selection EXEC internal component
 *
 * @hidden

 */ var $6aafe83ff7d024e3$export$9e1aabd7bce64036 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function SelectionBasedExec(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    SelectionBasedExec.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$96527b3d022fe7df, this.applySelection, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    SelectionBasedExec.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$96527b3d022fe7df, this.applySelection);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    SelectionBasedExec.prototype.keyDownHandler = function(e) {
        var validFormats = [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "superscript",
            "subscript",
            "uppercase",
            "lowercase",
            "inlinecode"
        ];
        if ((e.event.ctrlKey || e.event.metaKey) && validFormats.indexOf(e.event.action) > -1) {
            e.event.preventDefault();
            (0, $7dd901ee55c381ee$export$182333f802b3d72b).applyFormat(this.parent.currentDocument, e.event.action, this.parent.editableElement, e.enterAction, this.parent.tableCellSelection);
            this.callBack(e, e.event.action);
        }
    };
    SelectionBasedExec.prototype.applySelection = function(e) {
        (0, $7dd901ee55c381ee$export$182333f802b3d72b).applyFormat(this.parent.currentDocument, e.subCommand.toLocaleLowerCase(), this.parent.editableElement, e.enterAction, this.parent.tableCellSelection, e.value, e.selector);
        this.callBack(e, e.subCommand);
    };
    SelectionBasedExec.prototype.callBack = function(event, action) {
        if (event.callBack) event.callBack({
            requestType: action,
            event: event.event,
            editorMode: "HTML",
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    SelectionBasedExec.prototype.destroy = function() {
        this.removeEventListener();
    };
    return SelectionBasedExec;
}();





/**
 * Selection EXEC internal component
 *
 * @hidden

 */ var $0860029f12fff0a9$export$1c5539f1e0843472 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - sepcifies the parent element
     * @hidden

     */ function InsertHtmlExec(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    InsertHtmlExec.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$3eeeec04b2c6224, this.applyHtml, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    InsertHtmlExec.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$3eeeec04b2c6224, this.applyHtml);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    InsertHtmlExec.prototype.applyHtml = function(e) {
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, e.value, this.parent.editableElement, true, e.enterAction);
        if (e.subCommand === "pasteCleanup") {
            var pastedElements = this.parent.editableElement.querySelectorAll(".pasteContent_RTE");
            var allPastedElements = [].slice.call(pastedElements);
            var imgElements = this.parent.editableElement.querySelectorAll(".pasteContent_Img");
            var allImgElm = [].slice.call(imgElements);
            e.callBack({
                requestType: e.subCommand,
                editorMode: "HTML",
                elements: allPastedElements,
                imgElem: allImgElm
            });
        } else if (e.callBack) e.callBack({
            requestType: e.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    InsertHtmlExec.prototype.destroy = function() {
        this.removeEventListener();
    };
    return InsertHtmlExec;
}();



/**
 * `Clear Format` module is used to handle Clear Format.
 */ parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");






var $c0591847ae4e30f5$export$f93b98e4c57df5b8 = /** @class */ function() {
    function ClearFormat() {}
    /**
     * clear method
     *
     * @param {Document} docElement - specifies the document element.
     * @param {Node} endNode - specifies the end node
     * @param {string} enterAction - specifies the enter key action
     * @param {string} selector - specifies the string value
     * @param {string} command - specifies the command value
     * @returns {void}
     * @hidden

     */ ClearFormat.clear = function(docElement, endNode, enterAction, selector, command) {
        this.domNode = new (0, $885a3ef7b3a774b1$export$913ca0ecb04f4c72)(endNode, docElement);
        this.defaultTag = enterAction === "P" ? this.defaultTag : "div";
        var nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        var nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
        var range = nodeSelection.getRange(docElement);
        var nodes = range.collapsed ? nodeSelection.getSelectionNodeCollection(range) : nodeSelection.getSelectionNodeCollectionBr(range);
        var save = nodeSelection.save(range, docElement);
        var cursorRange = false;
        if (range.collapsed && command !== "ClearFormat") {
            cursorRange = true;
            range = nodeCutter.GetCursorRange(docElement, range, nodes[0]);
        }
        var isCollapsed = range.collapsed;
        if (!isCollapsed) {
            var preNode = void 0;
            if (nodes.length > 0 && nodes[0].nodeName === "BR" && (0, $4ZDHT.closest)(nodes[0], "table")) preNode = nodeCutter.GetSpliceNode(range, (0, $4ZDHT.closest)(nodes[0], "table"));
            else preNode = nodeCutter.GetSpliceNode(range, nodes[nodes.length > 1 && nodes[0].nodeName === "IMG" ? 1 : 0]);
            if (nodes.length === 1) {
                nodeSelection.setSelectionContents(docElement, preNode);
                range = nodeSelection.getRange(docElement);
            } else if (nodes.length > 1) {
                var i = 1;
                var lastText = nodes[nodes.length - i];
                while(nodes.length <= i && nodes[nodes.length - i].nodeName === "BR"){
                    i++;
                    lastText = nodes[nodes.length - i];
                }
                var lasNode = nodeCutter.GetSpliceNode(range, lastText);
                if (lasNode) nodeSelection.setSelectionText(docElement, preNode, lasNode, 0, lasNode.nodeType === 3 ? lasNode.textContent.length : lasNode.childNodes.length);
                range = nodeSelection.getRange(docElement);
            }
            var exactNodes = nodeSelection.getNodeCollection(range);
            var cloneSelectNodes = exactNodes.slice();
            this.clearInlines(nodeSelection.getSelectionNodes(cloneSelectNodes), cloneSelectNodes, nodeSelection.getRange(docElement), nodeCutter, endNode);
            this.reSelection(docElement, save, exactNodes);
            range = nodeSelection.getRange(docElement);
            exactNodes = nodeSelection.getNodeCollection(range);
            var cloneParentNodes = exactNodes.slice();
            this.clearBlocks(docElement, cloneParentNodes, endNode, nodeCutter, nodeSelection);
            if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(endNode, selector);
            this.reSelection(docElement, save, exactNodes);
        }
        if (cursorRange) nodeSelection.setCursorPoint(docElement, range.endContainer, range.endOffset);
    };
    ClearFormat.reSelection = function(docElement, save, exactNodes) {
        var selectionNodes = save.getInsertNodes(exactNodes);
        save.startContainer = save.getNodeArray(selectionNodes[0], true, docElement);
        save.startOffset = 0;
        save.endContainer = save.getNodeArray(selectionNodes[selectionNodes.length - 1], false, docElement);
        var endIndexNode = selectionNodes[selectionNodes.length - 1];
        save.endOffset = endIndexNode.nodeType === 3 ? endIndexNode.textContent.length : endIndexNode.childNodes.length;
        save.restore();
    };
    ClearFormat.clearBlocks = function(docElement, nodes, endNode, nodeCutter, nodeSelection) {
        var parentNodes = [];
        for(var index = 0; index < nodes.length; index++){
            if (this.BLOCK_TAGS.indexOf(nodes[index].nodeName.toLocaleLowerCase()) > -1 && parentNodes.indexOf(nodes[index]) === -1) parentNodes.push(nodes[index]);
            else if (this.BLOCK_TAGS.indexOf(nodes[index].parentNode.nodeName.toLocaleLowerCase()) > -1 && parentNodes.indexOf(nodes[index].parentNode) === -1 && endNode !== nodes[index].parentNode) parentNodes.push(nodes[index].parentNode);
        }
        parentNodes = this.spliceParent(parentNodes, nodes)[0];
        parentNodes = this.removeParent(parentNodes);
        this.unWrap(docElement, parentNodes, nodeCutter, nodeSelection);
    };
    ClearFormat.spliceParent = function(parentNodes, nodes) {
        for(var index1 = 0; index1 < parentNodes.length; index1++){
            var len = parentNodes[index1].childNodes.length;
            for(var index2 = 0; index2 < len; index2++){
                if (nodes.indexOf(parentNodes[index1].childNodes[index2]) > 0 && parentNodes[index1].childNodes[index2].childNodes.length > 0) nodes = this.spliceParent([
                    parentNodes[index1].childNodes[index2]
                ], nodes)[1];
                if (nodes.indexOf(parentNodes[index1].childNodes[index2]) <= -1 && parentNodes[index1].childNodes[index2].textContent.trim() !== "") {
                    for(var index3 = 0; index3 < len; index3++)if (nodes.indexOf(parentNodes[index1].childNodes[index3]) > -1) nodes.splice(nodes.indexOf(parentNodes[index1].childNodes[index3]), 1);
                    index2 = parentNodes[index1].childNodes.length;
                    var parentIndex = parentNodes.indexOf(parentNodes[index1].parentNode);
                    var nodeIndex = nodes.indexOf(parentNodes[index1].parentNode);
                    if (parentIndex > -1) parentNodes.splice(parentIndex, 1);
                    if (nodeIndex > -1) nodes.splice(nodeIndex, 1);
                    var elementIndex = nodes.indexOf(parentNodes[index1]);
                    if (elementIndex > -1) nodes.splice(elementIndex, 1);
                    parentNodes.splice(index1, 1);
                    index1--;
                }
            }
        }
        return [
            parentNodes,
            nodes
        ];
    };
    ClearFormat.removeChild = function(parentNodes, parentNode) {
        var count = parentNode.childNodes.length;
        if (count > 0) {
            for(var index = 0; index < count; index++)if (parentNodes.indexOf(parentNode.childNodes[index]) > -1) {
                parentNodes = this.removeChild(parentNodes, parentNode.childNodes[index]);
                parentNodes.splice(parentNodes.indexOf(parentNode.childNodes[index]), 1);
            }
        }
        return parentNodes;
    };
    ClearFormat.removeParent = function(parentNodes) {
        for(var index = 0; index < parentNodes.length; index++)if (parentNodes.indexOf(parentNodes[index].parentNode) > -1) {
            parentNodes = this.removeChild(parentNodes, parentNodes[index]);
            parentNodes.splice(index, 1);
            index--;
        }
        return parentNodes;
    };
    ClearFormat.unWrap = function(docElement, parentNodes, nodeCutter, nodeSelection) {
        for(var index1 = 0; index1 < parentNodes.length; index1++){
            if (this.NONVALID_TAGS.indexOf(parentNodes[index1].nodeName.toLowerCase()) > -1 && parentNodes[index1].parentNode && this.NONVALID_PARENT_TAGS.indexOf(parentNodes[index1].parentNode.nodeName.toLowerCase()) > -1) {
                nodeSelection.setSelectionText(docElement, parentNodes[index1], parentNodes[index1], 0, parentNodes[index1].childNodes.length);
                (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(nodeCutter.GetSpliceNode(nodeSelection.getRange(docElement), parentNodes[index1].parentNode));
            }
            var blockquoteNode = (0, $4ZDHT.closest)(parentNodes[index1], "blockquote");
            if (parentNodes[index1].nodeName.toLocaleLowerCase() !== "blockquote" && !(0, $3EnZW.isNullOrUndefined)(blockquoteNode) && blockquoteNode.textContent === parentNodes[index1].textContent) {
                var blockNodes = this.removeParent([
                    blockquoteNode
                ]);
                this.unWrap(docElement, blockNodes, nodeCutter, nodeSelection);
            }
            if (parentNodes[index1].nodeName.toLocaleLowerCase() !== "p") {
                if (this.NONVALID_PARENT_TAGS.indexOf(parentNodes[index1].nodeName.toLowerCase()) < 0 && !((parentNodes[index1].nodeName.toLocaleLowerCase() === "blockquote" || parentNodes[index1].nodeName.toLocaleLowerCase() === "li") && this.IGNORE_PARENT_TAGS.indexOf(parentNodes[index1].childNodes[0].nodeName.toLocaleLowerCase()) > -1) && !(parentNodes[index1].childNodes.length === 1 && parentNodes[index1].childNodes[0].nodeName.toLocaleLowerCase() === "p")) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(parentNodes[index1], docElement.createElement(this.defaultTag));
                var childNodes = (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(parentNodes[index1]);
                if (childNodes.length === 1 && childNodes[0].parentNode.nodeName.toLocaleLowerCase() === "p") {
                    (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(parentNodes[index1], docElement.createElement(this.defaultTag));
                    (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(parentNodes[index1]);
                }
                for(var index2 = 0; index2 < childNodes.length; index2++){
                    if (this.NONVALID_TAGS.indexOf(childNodes[index2].nodeName.toLowerCase()) > -1) this.unWrap(docElement, [
                        childNodes[index2]
                    ], nodeCutter, nodeSelection);
                    else if (this.BLOCK_TAGS.indexOf(childNodes[index2].nodeName.toLocaleLowerCase()) > -1 && childNodes[index2].nodeName.toLocaleLowerCase() !== "p") {
                        var blockNodes = this.removeParent([
                            childNodes[index2]
                        ]);
                        this.unWrap(docElement, blockNodes, nodeCutter, nodeSelection);
                    } else if (this.BLOCK_TAGS.indexOf(childNodes[index2].nodeName.toLocaleLowerCase()) > -1 && childNodes[index2].nodeName.toLocaleLowerCase() === "p") {
                        if (childNodes[index2].parentNode.nodeName.toLocaleLowerCase() === "p") (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(childNodes[index2].parentNode);
                        (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(childNodes[index2], docElement.createElement(this.defaultTag));
                        (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(childNodes[index2]);
                    } else if (this.BLOCK_TAGS.indexOf(childNodes[index2].nodeName.toLocaleLowerCase()) > -1 && childNodes[index2].parentNode.nodeName.toLocaleLowerCase() === childNodes[index2].nodeName.toLocaleLowerCase()) (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(childNodes[index2]);
                }
            } else {
                (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).Wrap(parentNodes[index1], docElement.createElement(this.defaultTag));
                (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(parentNodes[index1]);
            }
        }
    };
    ClearFormat.clearInlines = function(textNodes, nodes, range, nodeCutter, // eslint-disable-next-line
    endNode) {
        for(var index = 0; index < textNodes.length; index++){
            var currentInlineNode = textNodes[index];
            var currentNode = void 0;
            while(!this.domNode.isBlockNode(currentInlineNode) && currentInlineNode.parentElement && !currentInlineNode.parentElement.classList.contains("e-img-inner")){
                currentNode = currentInlineNode;
                currentInlineNode = currentInlineNode.parentElement;
            }
            if (currentNode && (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).inlineTags.indexOf(currentNode.nodeName.toLocaleLowerCase()) > -1) {
                nodeCutter.GetSpliceNode(range, currentNode);
                this.removeInlineParent(currentNode);
            }
        }
    };
    ClearFormat.removeInlineParent = function(textNodes) {
        var nodes = (0, $ced7ef277e5d7d73$export$7231aa4567d9c92f).unwrap(textNodes);
        for(var index = 0; index < nodes.length; index++){
            if (nodes[index].parentNode.childNodes.length === 1 && !nodes[index].parentNode.classList.contains("e-img-inner") && (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).inlineTags.indexOf(nodes[index].parentNode.nodeName.toLocaleLowerCase()) > -1) this.removeInlineParent(nodes[index].parentNode);
            else if ((0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).inlineTags.indexOf(nodes[index].nodeName.toLocaleLowerCase()) > -1) this.removeInlineParent(nodes[index]);
        }
    };
    ClearFormat.BLOCK_TAGS = [
        "address",
        "article",
        "aside",
        "blockquote",
        "details",
        "dd",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "p",
        "pre",
        "section",
        "ul"
    ];
    ClearFormat.NONVALID_PARENT_TAGS = [
        "thead",
        "tbody",
        "ul",
        "ol",
        "table",
        "tfoot",
        "tr"
    ];
    ClearFormat.IGNORE_PARENT_TAGS = [
        "ul",
        "ol",
        "table"
    ];
    ClearFormat.NONVALID_TAGS = [
        "thead",
        "tbody",
        "figcaption",
        "td",
        "tr",
        "th",
        "tfoot",
        "figcaption",
        "li"
    ];
    ClearFormat.defaultTag = "p";
    return ClearFormat;
}();



/**
 * Clear Format EXEC internal component
 *
 * @hidden

 */ var $ce6662ec3221c493$export$86d30f51c9ab2b39 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - specifies the parent element.
     * @returns {void}
     * @hidden

     */ function ClearFormatExec(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    ClearFormatExec.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$556ae66def187bfd, this.applyClear, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    ClearFormatExec.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$556ae66def187bfd, this.applyClear);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    ClearFormatExec.prototype.onKeyDown = function(e) {
        switch(e.event.action){
            case "clear-format":
                this.applyClear({
                    subCommand: "ClearFormat",
                    callBack: e.callBack,
                    enterAction: e.enterAction
                });
                e.event.preventDefault();
                break;
        }
    };
    ClearFormatExec.prototype.applyClear = function(e) {
        if (e.subCommand === "ClearFormat") {
            (0, $c0591847ae4e30f5$export$f93b98e4c57df5b8).clear(this.parent.currentDocument, this.parent.editableElement, e.enterAction, e.selector, e.subCommand);
            if (e.callBack) e.callBack({
                requestType: e.subCommand,
                event: e.event,
                editorMode: "HTML",
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
            });
        }
    };
    ClearFormatExec.prototype.destroy = function() {
        this.removeEventListener();
    };
    return ClearFormatExec;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");



/**
 * `Undo` module is used to handle undo actions.
 */ var $0498b8f502bd71e1$export$2aef42d075d45ec5 = /** @class */ function() {
    function UndoRedoManager(parent, options) {
        this.undoRedoStack = [];
        this.parent = parent;
        this.undoRedoSteps = !(0, $3EnZW.isNullOrUndefined)(options) ? options.undoRedoSteps : 30;
        this.undoRedoTimer = !(0, $3EnZW.isNullOrUndefined)(options) ? options.undoRedoTimer : 300;
        this.addEventListener();
    }
    UndoRedoManager.prototype.addEventListener = function() {
        this.debounceListener = (0, $3EnZW.debounce)(this.keyUp, this.undoRedoTimer);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.debounceListener, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, this.onAction, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    UndoRedoManager.prototype.onPropertyChanged = function(props) {
        for(var _i = 0, _a = Object.keys(props.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "undoRedoSteps":
                    this.undoRedoSteps = props.newProp.undoRedoSteps;
                    break;
                case "undoRedoTimer":
                    this.undoRedoTimer = props.newProp.undoRedoTimer;
                    break;
            }
        }
    };
    UndoRedoManager.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.keyUp);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, this.onAction);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
        this.debounceListener = null;
    };
    /**
     * onAction method
     *
     * @param {IHtmlSubCommands} e - specifies the sub command
     * @returns {void}
     * @hidden

     */ UndoRedoManager.prototype.onAction = function(e) {
        if (e.subCommand === "Undo") this.undo(e);
        else this.redo(e);
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ UndoRedoManager.prototype.destroy = function() {
        this.removeEventListener();
        this.element = null;
        this.steps = null;
        this.undoRedoStack = [];
        this.undoRedoSteps = null;
        this.undoRedoTimer = null;
    };
    UndoRedoManager.prototype.keyDown = function(e) {
        var event = e.event;
        // eslint-disable-next-line
        var proxy = this;
        switch(event.action){
            case "undo":
                event.preventDefault();
                proxy.undo(e);
                break;
            case "redo":
                event.preventDefault();
                proxy.redo(e);
                break;
        }
    };
    UndoRedoManager.prototype.keyUp = function(e) {
        if (e.event.keyCode !== 17 && !e.event.ctrlKey) this.saveData(e);
    };
    UndoRedoManager.prototype.getTextContentFromFragment = function(fragment) {
        var textContent = "";
        for(var i = 0; i < fragment.childNodes.length; i++){
            var childNode = fragment.childNodes[i];
            if (childNode.nodeType === Node.TEXT_NODE) textContent += childNode.textContent;
            else if (childNode.nodeType === Node.ELEMENT_NODE) textContent += this.getTextContentFromFragment(childNode);
        }
        return textContent;
    };
    UndoRedoManager.prototype.isElementStructureEqual = function(previousFragment, currentFragment) {
        if (previousFragment.childNodes.length !== currentFragment.childNodes.length) return false;
        for(var i = 0; i < previousFragment.childNodes.length; i++){
            var previousFragmentNode = previousFragment.childNodes[i];
            var currentFragmentNode = currentFragment.childNodes[i];
            if (!previousFragmentNode || !currentFragmentNode) return false;
            if (previousFragmentNode.nodeType !== currentFragmentNode.nodeType) return false;
            if (previousFragmentNode.outerHTML !== currentFragmentNode.outerHTML) return false;
        }
        return true;
    };
    /**
     * RTE collection stored html format.
     *
     * @function saveData
     * @param {KeyboardEvent} e - specifies the keyboard event
     * @returns {void}
     * @hidden

     */ UndoRedoManager.prototype.saveData = function(e) {
        if (!this.parent.currentDocument) return;
        var range = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)().getRange(this.parent.currentDocument);
        var currentContainer = this.parent.editableElement === range.startContainer.parentElement ? range.startContainer.parentElement : range.startContainer;
        for(var i = currentContainer.childNodes.length - 1; i >= 0; i--)if (!(0, $3EnZW.isNullOrUndefined)(currentContainer.childNodes[i]) && currentContainer.childNodes[i].nodeName === "#text" && currentContainer.childNodes[i].textContent.length === 0 && currentContainer.childNodes[i].nodeName !== "IMG" && currentContainer.childNodes[i].nodeName !== "BR" && currentContainer.childNodes[i].nodeName && "HR") (0, $4ZDHT.detach)(currentContainer.childNodes[i]);
        range = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)().getRange(this.parent.currentDocument);
        var save = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)().save(range, this.parent.currentDocument);
        var clonedElement = this.parent.editableElement.cloneNode(true);
        var fragment = document.createDocumentFragment();
        while(clonedElement.firstChild)fragment.appendChild(clonedElement.firstChild);
        var changEle = {
            text: fragment,
            range: save
        };
        if (this.undoRedoStack.length >= this.steps) this.undoRedoStack = this.undoRedoStack.slice(0, this.steps + 1);
        if (this.undoRedoStack.length > 1 && this.undoRedoStack[this.undoRedoStack.length - 1].range.range.collapsed === range.collapsed && this.undoRedoStack[this.undoRedoStack.length - 1].range.startOffset === save.range.startOffset && this.undoRedoStack[this.undoRedoStack.length - 1].range.endOffset === save.range.endOffset && this.undoRedoStack[this.undoRedoStack.length - 1].range.range.startContainer === save.range.startContainer && this.getTextContentFromFragment(this.undoRedoStack[this.undoRedoStack.length - 1].text).trim() === this.getTextContentFromFragment(changEle.text).trim() && this.isElementStructureEqual(this.undoRedoStack[this.undoRedoStack.length - 1].text, changEle.text)) return;
        this.undoRedoStack.push(changEle);
        this.steps = this.undoRedoStack.length - 1;
        if (this.steps > this.undoRedoSteps) {
            this.undoRedoStack.shift();
            this.steps--;
        }
        if (e && e.callBack) e.callBack();
    };
    /**
     * Undo the editable text.
     *
     * @function undo
     * @param {IHtmlSubCommands} e - specifies the sub commands
     * @returns {void}
     * @hidden

     */ UndoRedoManager.prototype.undo = function(e) {
        if (this.steps > 0) {
            var range = this.undoRedoStack[this.steps - 1].range;
            var removedContent = this.undoRedoStack[this.steps - 1].text;
            this.parent.editableElement.innerHTML = "";
            this.parent.editableElement.appendChild(removedContent.cloneNode(true));
            this.parent.editableElement.focus();
            (0, $259257662ca103fc$export$7e1ec7538889cd1)(this.parent.currentDocument, this.parent.editableElement);
            if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(this.parent.editableElement, e.selector);
            range.restore();
            this.steps--;
            if (e.callBack) e.callBack({
                requestType: "Undo",
                editorMode: "HTML",
                range: range,
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),
                event: e.event
            });
        }
    };
    /**
     * Redo the editable text.
     *
     * @param {IHtmlSubCommands} e - specifies the sub commands
     * @function redo
     * @returns {void}
     * @hidden

     */ UndoRedoManager.prototype.redo = function(e) {
        if (this.undoRedoStack[this.steps + 1] != null) {
            var range = this.undoRedoStack[this.steps + 1].range;
            var addedContent = this.undoRedoStack[this.steps + 1].text;
            this.parent.editableElement.innerHTML = "";
            this.parent.editableElement.appendChild(addedContent.cloneNode(true));
            this.parent.editableElement.focus();
            (0, $259257662ca103fc$export$7e1ec7538889cd1)(this.parent.currentDocument, this.parent.editableElement);
            if ((0, $259257662ca103fc$export$80ca177350c4af26)()) (0, $259257662ca103fc$export$9f8b84040f122328)(this.parent.editableElement, e.selector);
            range.restore();
            this.steps++;
            if (e.callBack) e.callBack({
                requestType: "Redo",
                editorMode: "HTML",
                range: range,
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),
                event: e.event
            });
        }
    };
    /**
     * getUndoStatus method
     *
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ UndoRedoManager.prototype.getUndoStatus = function() {
        var status = {
            undo: false,
            redo: false
        };
        if (this.steps > 0) status.undo = true;
        if (this.undoRedoStack[this.steps + 1] != null) status.redo = true;
        return status;
    };
    return UndoRedoManager;
}();



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

/**
 * PasteCleanup for MsWord content
 *
 * @hidden

 */ var $30d0d69d23909284$export$67508203d4c57a4d = /** @class */ function() {
    function MsWordPaste(parent) {
        this.olData = [
            "decimal",
            "decimal-leading-zero",
            "lower-alpha",
            "lower-roman",
            "upper-alpha",
            "upper-roman",
            "lower-greek"
        ];
        this.ulData = [
            "disc",
            "square",
            "circle",
            "disc",
            "square",
            "circle"
        ];
        this.ignorableNodes = [
            "A",
            "APPLET",
            "B",
            "BLOCKQUOTE",
            "BR",
            "BUTTON",
            "CENTER",
            "CODE",
            "COL",
            "COLGROUP",
            "DD",
            "DEL",
            "DFN",
            "DIR",
            "DIV",
            "DL",
            "DT",
            "EM",
            "FIELDSET",
            "FONT",
            "FORM",
            "FRAME",
            "FRAMESET",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "HR",
            "I",
            "IMG",
            "IFRAME",
            "INPUT",
            "INS",
            "LABEL",
            "LI",
            "OL",
            "OPTION",
            "P",
            "PARAM",
            "PRE",
            "Q",
            "S",
            "SELECT",
            "SPAN",
            "STRIKE",
            "STRONG",
            "SUB",
            "SUP",
            "TABLE",
            "TBODY",
            "TD",
            "TEXTAREA",
            "TFOOT",
            "TH",
            "THEAD",
            "TITLE",
            "TR",
            "TT",
            "U",
            "UL"
        ];
        this.blockNode = [
            "div",
            "p",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "address",
            "blockquote",
            "button",
            "center",
            "dd",
            "dir",
            "dl",
            "dt",
            "fieldset",
            "frameset",
            "hr",
            "iframe",
            "isindex",
            "li",
            "map",
            "menu",
            "noframes",
            "noscript",
            "object",
            "ol",
            "pre",
            "table",
            "tbody",
            "td",
            "tfoot",
            "th",
            "thead",
            "tr",
            "ul",
            "header",
            "article",
            "nav",
            "footer",
            "section",
            "aside",
            "main",
            "figure",
            "figcaption"
        ];
        this.borderStyle = [
            "border-top",
            "border-right",
            "border-bottom",
            "border-left"
        ];
        this.upperRomanNumber = [
            "I",
            "II",
            "III",
            "IV",
            "V",
            "VI",
            "VII",
            "VIII",
            "IX",
            "X",
            "XI",
            "XII",
            "XIII",
            "XIV",
            "XV",
            "XVI",
            "XVII",
            "XVIII",
            "XIX",
            "XX"
        ];
        this.lowerRomanNumber = [
            "i",
            "ii",
            "iii",
            "iv",
            "v",
            "vi",
            "vii",
            "viii",
            "ix",
            "x",
            "xi",
            "xii",
            "xiii",
            "xiv",
            "xv",
            "xvi",
            "xvii",
            "xviii",
            "xix",
            "xx"
        ];
        this.lowerGreekNumber = [
            "\u03B1",
            "\u03B2",
            "\u03B3",
            "\u03B4",
            "\u03B5",
            "\u03B6",
            "\u03B7",
            "\u03B8",
            "\u03B9",
            "\u03BA",
            "\u03BB",
            "\u03BC",
            "\u03BD",
            "\u03BE",
            "\u03BF",
            "\u03C0",
            "\u03C1",
            "\u03C3",
            "\u03C4",
            "\u03C5",
            "\u03C6",
            "\u03C7",
            "\u03C8",
            "\u03C9"
        ];
        this.removableElements = [
            "o:p",
            "style",
            "w:sdt"
        ];
        this.listContents = [];
        this.cropImageDimensions = [];
        this.parent = parent;
        this.addEventListener();
    }
    MsWordPaste.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$197fda2d47388ee9, this.wordCleanup, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MsWordPaste.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$197fda2d47388ee9, this.wordCleanup);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MsWordPaste.prototype.wordCleanup = function(e) {
        var wordPasteStyleConfig = !(0, $3EnZW.isNullOrUndefined)(e.allowedStylePropertiesArray) ? e.allowedStylePropertiesArray : [];
        var listNodes = [];
        var tempHTMLContent = e.args.clipboardData.getData("text/HTML");
        var rtfData = e.args.clipboardData.getData("text/rtf");
        var elm = (0, $4ZDHT.createElement)("p");
        elm.setAttribute("id", "MSWord-Content");
        elm.innerHTML = tempHTMLContent;
        this.addDoubleBr(elm);
        var patern = /class='?Mso|style='[^ ]*\bmso-/i;
        var patern2 = /class="?Mso|style="[^ ]*\bmso-/i;
        var patern3 = /(class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument)/gi;
        var pattern4 = /style='mso-width-source:/i;
        var source = this.findSource(elm);
        if (patern.test(tempHTMLContent) || patern2.test(tempHTMLContent) || patern3.test(tempHTMLContent) || pattern4.test(tempHTMLContent)) {
            tempHTMLContent = tempHTMLContent.replace(/<img[^>]+>/i, "");
            this.addListClass(elm);
            listNodes = this.cleanUp(elm, listNodes);
            if (!(0, $3EnZW.isNullOrUndefined)(listNodes[0]) && listNodes[0].parentElement.tagName !== "UL" && listNodes[0].parentElement.tagName !== "OL") this.listConverter(listNodes);
            this.imageConversion(elm, rtfData);
            this.cleanList(elm, "UL");
            this.cleanList(elm, "OL");
            this.styleCorrection(elm, wordPasteStyleConfig);
            this.removingComments(elm);
            this.removeUnwantedElements(elm);
            this.removeEmptyElements(elm);
            this.removeEmptyAnchorTag(elm);
            this.breakLineAddition(elm);
            this.processMargin(elm);
            this.removeClassName(elm);
            if (pattern4.test(tempHTMLContent)) this.addTableBorderClass(elm);
            e.callBack(elm.innerHTML, this.cropImageDimensions, source);
        } else e.callBack(elm.innerHTML, null, source);
    };
    MsWordPaste.prototype.addDoubleBr = function(elm) {
        var newline = elm.querySelector(".Apple-interchange-newline");
        if (!(0, $3EnZW.isNullOrUndefined)(newline) && (0, $5q7BP.Browser).userAgent.indexOf("Chrome") !== -1 && newline.parentElement.nodeName === "P" && elm !== newline.parentElement) for(var i = 0; i < elm.childNodes.length; i++){
            var node = elm.childNodes[i];
            if (node.nodeType === Node.COMMENT_NODE && node.nodeValue.includes("StartFragment")) {
                var newElement = document.createElement("p");
                newElement.innerHTML = "<br>";
                var cssText = newline.parentElement.style.cssText;
                var currentStyle = newElement.getAttribute("style") || "";
                var newStyle = currentStyle + cssText;
                newElement.setAttribute("style", newStyle);
                elm.insertBefore(newElement, node.nextSibling);
                (0, $4ZDHT.detach)(newline);
                break;
            }
        }
    };
    MsWordPaste.prototype.cleanList = function(elm, listTag) {
        var replacableElem = elm.querySelectorAll(listTag + " div");
        for(var j = replacableElem.length - 1; j >= 0; j--){
            var parentElem = replacableElem[j].parentNode;
            while(replacableElem[j].firstChild)parentElem.insertBefore(replacableElem[j].firstChild, replacableElem[j]);
            var closestListElem = this.findClosestListElem(replacableElem[j]);
            if (closestListElem) this.insertAfter(replacableElem[j], closestListElem);
        }
    };
    MsWordPaste.prototype.insertAfter = function(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    MsWordPaste.prototype.findClosestListElem = function(listElem) {
        var closestListElem;
        while(!(0, $3EnZW.isNullOrUndefined)(listElem)){
            listElem = !(0, $3EnZW.isNullOrUndefined)(listElem.closest("ul")) && listElem.tagName !== "UL" ? listElem.closest("ul") : listElem.tagName !== "OL" ? listElem.closest("ol") : null;
            closestListElem = !(0, $3EnZW.isNullOrUndefined)(listElem) ? listElem : closestListElem;
        }
        return closestListElem;
    };
    MsWordPaste.prototype.addListClass = function(elm) {
        var allNodes = elm.querySelectorAll("*");
        for(var index = 0; index < allNodes.length; index++)if (!(0, $3EnZW.isNullOrUndefined)(allNodes[index].getAttribute("style")) && allNodes[index].getAttribute("style").replace(/ /g, "").replace("\n", "").indexOf("mso-list:l") >= 0 && allNodes[index].className.toLowerCase().indexOf("msolistparagraph") === -1 && allNodes[index].tagName.charAt(0) !== "H" && allNodes[index].tagName !== "LI" && allNodes[index].tagName !== "OL" && allNodes[index].tagName !== "UL") allNodes[index].classList.add("msolistparagraph");
    };
    MsWordPaste.prototype.addTableBorderClass = function(elm) {
        var allTableElm = elm.querySelectorAll("table");
        var hasTableBorder = false;
        for(var i = 0; i < allTableElm.length; i++){
            for(var j = 0; j < this.borderStyle.length; j++)if (allTableElm[i].innerHTML.indexOf(this.borderStyle[j]) >= 0) {
                hasTableBorder = true;
                break;
            }
            if (hasTableBorder) {
                allTableElm[i].classList.add("e-rte-table-border");
                hasTableBorder = false;
            }
        }
    };
    MsWordPaste.prototype.imageConversion = function(elm, rtfData) {
        this.checkVShape(elm);
        var imgElem = elm.querySelectorAll("img");
        for(var i = 0; i < imgElem.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(imgElem[i].getAttribute("v:shapes")) && imgElem[i].getAttribute("v:shapes").indexOf("Picture") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("\u5716\u7247") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("Grafik") < 0 && imgElem[i].getAttribute("v:shapes").toLowerCase().indexOf("image") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("Graphic") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("_x0000_s") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("_x0000_i") < 0 && imgElem[i].getAttribute("v:shapes").indexOf("img1") < 0) imgElem[i].classList.add("e-rte-image-unsupported");
            imgElem[i].removeAttribute("v:shapes");
        }
        imgElem = elm.querySelectorAll("img");
        var imgSrc = [];
        var base64Src = [];
        var imgName = [];
        // eslint-disable-next-line
        var linkRegex = new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.)|(blob\:))(\S+))/gi);
        if (imgElem.length > 0) {
            for(var i = 0; i < imgElem.length; i++){
                imgSrc.push(imgElem[i].getAttribute("src"));
                imgName.push(imgElem[i].getAttribute("src").split("/")[imgElem[i].getAttribute("src").split("/").length - 1].split(".")[0]);
            }
            var hexValue = this.hexConversion(rtfData);
            for(var i = 0; i < hexValue.length; i++){
                base64Src.push({
                    base64Data: !(0, $3EnZW.isNullOrUndefined)(hexValue[i].hex) ? this.convertToBase64(hexValue[i]) : null,
                    isCroppedImage: hexValue[i].isCroppedImage
                });
                if (hexValue[i].isCroppedImage) this.cropImageDimensions.push({
                    goalWidth: hexValue[i].goalWidth,
                    goalHeight: hexValue[i].goalHeight,
                    cropLength: hexValue[i].cropLength,
                    cropTop: hexValue[i].cropTop,
                    cropR: hexValue[i].cropR,
                    cropB: hexValue[i].cropB
                });
            }
            imgElem = elm.querySelectorAll("img:not(.e-rte-image-unsupported");
            for(var i = 0; i < imgElem.length; i++){
                if (imgSrc[i].match(linkRegex)) imgElem[i].setAttribute("src", imgSrc[i]);
                else {
                    if (!(0, $3EnZW.isNullOrUndefined)(base64Src[i]) && !(0, $3EnZW.isNullOrUndefined)(base64Src[i].base64Data)) imgElem[i].setAttribute("src", base64Src[i].base64Data);
                    else {
                        imgElem[i].removeAttribute("src");
                        imgElem[i].classList.add("e-rte-image-unsupported");
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(base64Src[i]) && base64Src[i].isCroppedImage) imgElem[i].classList.add("e-img-cropped");
                }
                imgElem[i].setAttribute("id", "msWordImg-" + imgName[i]);
            }
            imgElem = elm.querySelectorAll(".e-rte-image-unsupported");
            for(var i = 0; i < imgElem.length; i++)imgElem[i].removeAttribute("src");
        }
    };
    MsWordPaste.prototype.checkVShape = function(elm) {
        var allNodes = elm.querySelectorAll("*");
        for(var i = 0; i < allNodes.length; i++)switch(allNodes[i].nodeName){
            case "V:SHAPETYPE":
                (0, $4ZDHT.detach)(allNodes[i]);
                break;
            case "V:SHAPE":
                if (allNodes[i].firstElementChild.nodeName === "V:IMAGEDATA") {
                    var src = allNodes[i].firstElementChild.getAttribute("src");
                    var imgElement = (0, $4ZDHT.createElement)("img");
                    imgElement.setAttribute("src", src);
                    allNodes[i].parentElement.insertBefore(imgElement, allNodes[i]);
                    (0, $4ZDHT.detach)(allNodes[i]);
                }
                break;
        }
    };
    MsWordPaste.prototype.convertToBase64 = function(hexValue) {
        var byteArr = this.conHexStringToBytes(hexValue.hex);
        var base64String = this.conBytesToBase64(byteArr);
        var base64 = hexValue.type ? "data:" + hexValue.type + ";base64," + base64String : null;
        return base64;
    };
    MsWordPaste.prototype.conBytesToBase64 = function(byteArr) {
        var base64Str = "";
        var base64Char = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var byteArrLen = byteArr.length;
        for(var i = 0; i < byteArrLen; i += 3){
            var array3 = byteArr.slice(i, i + 3);
            var array3length = array3.length;
            var array4 = [];
            if (array3length < 3) for(var j = array3length; j < 3; j++)array3[j] = 0;
            array4[0] = (array3[0] & 0xFC) >> 2;
            array4[1] = (array3[0] & 0x03) << 4 | array3[1] >> 4;
            array4[2] = (array3[1] & 0x0F) << 2 | (array3[2] & 0xC0) >> 6;
            array4[3] = array3[2] & 0x3F;
            for(var j = 0; j < 4; j++)if (j <= array3length) base64Str += base64Char.charAt(array4[j]);
            else base64Str += "=";
        }
        return base64Str;
    };
    MsWordPaste.prototype.conHexStringToBytes = function(hex) {
        var byteArr = [];
        var byteArrLen = hex.length / 2;
        for(var i = 0; i < byteArrLen; i++)byteArr.push(parseInt(hex.substr(i * 2, 2), 16));
        return byteArr;
    };
    MsWordPaste.prototype.hexConversion = function(rtfData) {
        var regExp = RegExp;
        var picHead = new regExp("\\{\\\\pict[\\s\\S]+?\\\\bliptag-?\\d+(\\\\blipupi-?\\d+)?(\\{\\\\\\*\\\\blipuid\\s?[\\da-fA-F]+)?[\\s\\}]*?");
        var pic = new regExp("(?:(" + picHead.source + "))([\\da-fA-F\\s]+)\\}", "g");
        var fullImg = rtfData.match(pic);
        var imgType;
        var result = [];
        if (!(0, $3EnZW.isNullOrUndefined)(fullImg)) for(var i = 0; i < fullImg.length; i++){
            if (fullImg[i].indexOf("fIsBullet") !== -1 && fullImg[i].indexOf("wzName") === -1) continue;
            var isCroppedImage = false;
            var goalWidth = 0;
            var goalHeight = 0;
            var cropLength = 0;
            var cropTop = 0;
            var cropR = 0;
            var cropB = 0;
            if (picHead.test(fullImg[i])) {
                if (fullImg[i].indexOf("\\pngblip") !== -1) imgType = "image/png";
                else if (fullImg[i].indexOf("\\jpegblip") !== -1) imgType = "image/jpeg";
                else if (fullImg[i].indexOf("\\emfblip") !== -1) imgType = null;
                else continue;
                isCroppedImage = this.extractCropValue("cropl", fullImg[i]) > 0 && this.extractCropValue("cropt", fullImg[i]) > 0 || this.extractCropValue("cropr", fullImg[i]) > 0 || this.extractCropValue("cropb", fullImg[i]) ? true : false;
                if (isCroppedImage) {
                    goalWidth = this.extractCropValue("wgoal", fullImg[i]);
                    goalHeight = this.extractCropValue("hgoal", fullImg[i]);
                    cropLength = this.extractCropValue("cropl", fullImg[i]);
                    cropTop = this.extractCropValue("cropt", fullImg[i]);
                    cropR = this.extractCropValue("cropr", fullImg[i]);
                    cropB = this.extractCropValue("cropb", fullImg[i]);
                }
                result.push({
                    hex: imgType ? fullImg[i].replace(picHead, "").replace(/[^\da-fA-F]/g, "") : null,
                    type: imgType,
                    isCroppedImage: isCroppedImage,
                    goalWidth: goalWidth,
                    goalHeight: goalHeight,
                    cropLength: cropLength,
                    cropTop: cropTop,
                    cropR: cropR,
                    cropB: cropB
                });
            }
        }
        return result;
    };
    MsWordPaste.prototype.extractCropValue = function(crop, rtfData) {
        var regExp = RegExp;
        var result = new regExp("\\\\pic" + crop + "(\\-?\\d+)\\\\").exec(rtfData.replace(/\r\n\\/g, "\\").replace(/\n/g, "\\"))[1];
        return parseInt(result, 10);
    };
    MsWordPaste.prototype.removeClassName = function(elm) {
        var elmWithClass = elm.querySelectorAll("*[class]:not(.e-img-cropped):not(.e-rte-image-unsupported)");
        for(var i = 0; i < elmWithClass.length; i++)elmWithClass[i].removeAttribute("class");
    };
    MsWordPaste.prototype.breakLineAddition = function(elm) {
        var allElements = elm.querySelectorAll("*");
        for(var i = 0; i < allElements.length; i++)if (allElements[i].children.length === 0 && allElements[i].innerHTML === "&nbsp;" && allElements[i].innerHTML === "&nbsp;" && !allElements[i].closest("li") && !allElements[i].closest("td") && (allElements[i].nodeName !== "SPAN" || allElements[i].nodeName === "SPAN" && (0, $3EnZW.isNullOrUndefined)(allElements[i].previousElementSibling) && (0, $3EnZW.isNullOrUndefined)(allElements[i].nextElementSibling))) {
            var detachableElement = this.findDetachElem(allElements[i]);
            var brElement = (0, $4ZDHT.createElement)("br");
            var hasNbsp = detachableElement.textContent.length > 0 && detachableElement.textContent.match(/\u00a0/g) && detachableElement.textContent.match(/\u00a0/g).length > 0;
            if (!hasNbsp && !(0, $3EnZW.isNullOrUndefined)(detachableElement.parentElement)) {
                detachableElement.parentElement.insertBefore(brElement, detachableElement);
                (0, $4ZDHT.detach)(detachableElement);
            }
        }
    };
    MsWordPaste.prototype.findDetachElem = function(element) {
        var removableElement;
        if (!(0, $3EnZW.isNullOrUndefined)(element.parentElement) && element.parentElement.textContent.trim() === "" && element.parentElement.tagName !== "TD" && (0, $3EnZW.isNullOrUndefined)(element.parentElement.querySelector("img"))) removableElement = this.findDetachElem(element.parentElement);
        else removableElement = element;
        return removableElement;
    };
    MsWordPaste.prototype.removeUnwantedElements = function(elm) {
        var styleElm = elm.querySelector("style");
        if (!(0, $3EnZW.isNullOrUndefined)(styleElm)) (0, $4ZDHT.detach)(styleElm);
        var innerElement = elm.innerHTML;
        for(var i = 0; i < this.removableElements.length; i++){
            var regExp = RegExp;
            var regExpStartElem = new regExp("<" + this.removableElements[i] + "\\s*[^>]*>", "g");
            var regExpEndElem = new regExp("</" + this.removableElements[i] + ">", "g");
            innerElement = innerElement.replace(regExpStartElem, "");
            innerElement = innerElement.replace(regExpEndElem, "");
        }
        elm.innerHTML = innerElement;
        elm.querySelectorAll(":empty");
    };
    MsWordPaste.prototype.findDetachEmptyElem = function(element) {
        var removableElement;
        if (!(0, $3EnZW.isNullOrUndefined)(element.parentElement)) {
            var hasNbsp = element.parentElement.textContent.length > 0 && element.parentElement.textContent.match(/\u00a0/g) && element.parentElement.textContent.match(/\u00a0/g).length > 0;
            if (!hasNbsp && element.parentElement.textContent.trim() === "" && element.parentElement.getAttribute("id") !== "MSWord-Content" && !this.hasParentWithClass(element, "MsoListParagraph") && (0, $3EnZW.isNullOrUndefined)(element.parentElement.querySelector("img"))) removableElement = this.findDetachEmptyElem(element.parentElement);
            else removableElement = element;
        } else removableElement = null;
        return removableElement;
    };
    MsWordPaste.prototype.hasParentWithClass = function(element, className) {
        var currentParentElem = element.parentElement;
        while(!(0, $3EnZW.isNullOrUndefined)(currentParentElem)){
            if (currentParentElem.classList.contains(className)) return true;
            currentParentElem = currentParentElem.parentElement;
        }
        return false;
    };
    MsWordPaste.prototype.removeEmptyElements = function(element) {
        var emptyElements = element.querySelectorAll(":empty");
        for(var i = 0; i < emptyElements.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(emptyElements[i].closest("td")) && !(0, $3EnZW.isNullOrUndefined)(emptyElements[i].closest("td").querySelector(".MsoNormal"))) emptyElements[i].innerHTML = "-";
            var lineWithDiv = true;
            if (emptyElements[i].tagName === "DIV") lineWithDiv = emptyElements[i].style.borderBottom === "none" || emptyElements[i].style.borderBottom === "" ? true : false;
            if (emptyElements[i].tagName !== "IMG" && emptyElements[i].tagName !== "BR" && emptyElements[i].tagName !== "IFRAME" && emptyElements[i].tagName !== "TD" && emptyElements[i].tagName !== "HR" && lineWithDiv) {
                var detachableElement = this.findDetachEmptyElem(emptyElements[i]);
                if (!(0, $3EnZW.isNullOrUndefined)(detachableElement)) (0, $4ZDHT.detach)(detachableElement);
            }
        }
    };
    MsWordPaste.prototype.styleCorrection = function(elm, wordPasteStyleConfig) {
        var styleElement = elm.querySelectorAll("style");
        var styles = [];
        if (styleElement.length > 0) {
            if (!(0, $3EnZW.isNullOrUndefined)(styleElement[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi))) styles = styleElement[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);
            else if (styleElement.length > 1) styles = styleElement[1].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);
            var styleClassObject_1 = !(0, $3EnZW.isNullOrUndefined)(styles) ? this.findStyleObject(styles) : null;
            if (!(0, $3EnZW.isNullOrUndefined)(styleClassObject_1)) {
                var keys = Object.keys(styleClassObject_1);
                var values = keys.map(function(key) {
                    return styleClassObject_1["" + key];
                });
                values = this.removeUnwantedStyle(values, wordPasteStyleConfig);
                this.filterStyles(elm, wordPasteStyleConfig);
                var resultElem = void 0;
                var fromClass = false;
                var regex = /^(p|div|li)\.(1|10|11)$/;
                for(var i = 0; i < keys.length; i++){
                    if (keys[i].split(".")[0] === "") {
                        resultElem = elm.getElementsByClassName(keys[i].split(".")[1]);
                        fromClass = true;
                    } else if (keys[i].split(".").length === 1 && keys[i].split(".")[0].indexOf("@") >= 0 || regex.test(keys[i])) continue;
                    else if (keys[i].split(".").length === 1 && keys[i].split(".")[0].indexOf("@") < 0) resultElem = elm.getElementsByTagName(keys[i]);
                    else resultElem = elm.querySelectorAll(keys[i]);
                    for(var j = 0; j < resultElem.length; j++){
                        if (resultElem[j].closest("li") && keys[i] === "p") continue;
                        var styleProperty = resultElem[j].getAttribute("style");
                        if (!(0, $3EnZW.isNullOrUndefined)(styleProperty) && styleProperty.trim() !== "") {
                            var valueSplit = values[i].split(";");
                            for(var q = 0; q < valueSplit.length; q++)if (valueSplit[q].split(":")[0] === "border" && valueSplit[q].split(":")[1] === "none") {
                                valueSplit.splice(q, 1);
                                q--;
                            }
                            if (!fromClass) for(var k = 0; k < valueSplit.length; k++){
                                var propertyName = valueSplit[k].split(":")[0];
                                if (styleProperty.includes(propertyName + ":")) {
                                    valueSplit.splice(k, 1);
                                    k--;
                                }
                            }
                            var changedValue = valueSplit.join(";") + ";" + styleProperty;
                            resultElem[j].setAttribute("style", changedValue);
                        } else {
                            values[i] = values[i].replace(/text-indent:-(.*?)(?=;|$)/gm, "");
                            resultElem[j].setAttribute("style", values[i]);
                        }
                    }
                    fromClass = false;
                }
                var listClass = [
                    "MsoListParagraphCxSpFirst",
                    "MsoListParagraphCxSpMiddle",
                    "MsoListParagraphCxSpLast"
                ];
                for(var i = 0; i < listClass.length; i++)if (keys.indexOf("li." + listClass[i]) > -1) {
                    var olULElems = elm.querySelectorAll("ol." + listClass[i] + ", ul." + listClass[i]);
                    for(var j = 0; j < olULElems.length; j++){
                        var styleProperty = olULElems[j].getAttribute("style");
                        if (!(0, $3EnZW.isNullOrUndefined)(styleProperty) && styleProperty.trim() !== "" && olULElems[j].style.marginLeft !== "") {
                            var valueSplit = values[keys.indexOf("li." + listClass[i])].split(";");
                            for(var k = 0; k < valueSplit.length; k++){
                                if ("margin-left".indexOf(valueSplit[k].split(":")[0]) >= 0) {
                                    if (!(0, $3EnZW.isNullOrUndefined)(valueSplit[k].split(":")[1]) && valueSplit[k].split(":")[1].indexOf("in") >= 0 && olULElems[j].style.marginLeft.indexOf("in") >= 0) {
                                        var classStyle = parseFloat(valueSplit[k].split(":")[1].split("in")[0]);
                                        var inlineStyle = parseFloat(olULElems[j].style.marginLeft.split("in")[0]);
                                        olULElems[j].style.marginLeft = inlineStyle - classStyle + "in";
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    MsWordPaste.prototype.filterStyles = function(elm, wordPasteStyleConfig) {
        var elmWithStyles = elm.querySelectorAll("*[style]");
        for(var i = 0; i < elmWithStyles.length; i++){
            var elemStyleProperty = elmWithStyles[i].getAttribute("style").split(";");
            var styleValue = "";
            for(var j = 0; j < elemStyleProperty.length; j++)if (wordPasteStyleConfig.indexOf(elemStyleProperty[j].split(":")[0].trim()) >= 0) styleValue += elemStyleProperty[j] + ";";
            elmWithStyles[i].setAttribute("style", styleValue);
        }
    };
    MsWordPaste.prototype.removeUnwantedStyle = function(values, wordPasteStyleConfig) {
        for(var i = 0; i < values.length; i++){
            var styleValues = values[i].split(";");
            values[i] = "";
            for(var j = 0; j < styleValues.length; j++)if (wordPasteStyleConfig.indexOf(styleValues[j].split(":")[0]) >= 0) values[i] += styleValues[j] + ";";
        }
        return values;
    };
    MsWordPaste.prototype.findStyleObject = function(styles) {
        var styleClassObject = {};
        for(var i = 0; i < styles.length; i++){
            var tempStyle = styles[i];
            var classNameCollection = tempStyle.replace(/([\S ]+\s+){[\s\S]+?}/gi, "$1");
            var stylesCollection = tempStyle.replace(/[\S ]+\s+{([\s\S]+?)}/gi, "$1");
            classNameCollection = classNameCollection.replace(/^[\s]|[\s]$/gm, "");
            stylesCollection = stylesCollection.replace(/^[\s]|[\s]$/gm, "");
            classNameCollection = classNameCollection.replace(/\n|\r|\n\r/g, "");
            stylesCollection = stylesCollection.replace(/\n|\r|\n\r/g, "");
            for(var classNames = classNameCollection.split(", "), j = 0; j < classNames.length; j++)styleClassObject[classNames[j]] = stylesCollection;
        }
        return styleClassObject;
    };
    MsWordPaste.prototype.removingComments = function(elm) {
        var innerElement = elm.innerHTML;
        innerElement = innerElement.replace(/<!--[\s\S]*?-->/g, "");
        elm.innerHTML = innerElement;
    };
    MsWordPaste.prototype.cleanUp = function(node, listNodes) {
        var tempCleaner = [];
        var prevflagState;
        var allNodes = node.querySelectorAll("*");
        for(var index = 0; index < allNodes.length; index++){
            if (this.ignorableNodes.indexOf(allNodes[index].nodeName) === -1 || allNodes[index].nodeType === 3 && allNodes[index].textContent.trim() === "") {
                tempCleaner.push(allNodes[index]);
                continue;
            } else if (allNodes[index].className && allNodes[index].className.toLowerCase().indexOf("msolistparagraph") !== -1 && !(0, $3EnZW.isNullOrUndefined)(allNodes[index].getAttribute("style")) && allNodes[index].getAttribute("style").indexOf("mso-list:") >= 0) {
                if (allNodes[index].className.indexOf("MsoListParagraphCxSpFirst") >= 0 && listNodes.length > 0 && listNodes[listNodes.length - 1] !== null) listNodes.push(null);
                listNodes.push(allNodes[index]);
            }
            if (prevflagState && this.blockNode.indexOf(allNodes[index].nodeName.toLowerCase()) !== -1 && !(allNodes[index].className && allNodes[index].className.toLowerCase().indexOf("msolistparagraph") !== -1 && !(0, $3EnZW.isNullOrUndefined)(allNodes[index].getAttribute("style")) && allNodes[index].getAttribute("style").indexOf("mso-list:") >= 0)) listNodes.push(null);
            if (this.blockNode.indexOf(allNodes[index].nodeName.toLowerCase()) !== -1) {
                if (allNodes[index].className && allNodes[index].className.toLowerCase().indexOf("msolistparagraph") !== -1 && !(0, $3EnZW.isNullOrUndefined)(allNodes[index].getAttribute("style")) && allNodes[index].getAttribute("style").indexOf("mso-list:") >= 0) prevflagState = true;
                else prevflagState = false;
            }
        }
        if (listNodes.length && listNodes[listNodes.length - 1] !== null) listNodes.push(null);
        return listNodes;
    };
    MsWordPaste.prototype.listConverter = function(listNodes) {
        var level;
        var data = [];
        var listFormatOverride;
        var collection = [];
        var content = "";
        var stNode;
        var currentListStyle = "";
        for(var i = 0; i < listNodes.length; i++){
            if (listNodes[i] === null) {
                data.push({
                    content: this.makeConversion(collection),
                    node: listNodes[i - 1]
                });
                collection = [];
                continue;
            }
            if (listNodes[i].getAttribute("style") && listNodes[i].getAttribute("style").indexOf("mso-outline-level") !== -1) listNodes[i].setAttribute("style", listNodes[i].getAttribute("style").replace("mso-outline-level", "mso-outline"));
            content = listNodes[i].getAttribute("style");
            if (content && content.indexOf("level") !== -1) // eslint-disable-next-line
            level = parseInt(content.charAt(content.indexOf("level") + 5), null);
            else level = 1;
            if (content && content.indexOf("mso-list:") !== -1) {
                var msoListValue = void 0;
                if (content.match(/mso-list:[^;]+;?/)) {
                    var changedContent = content.replace(new RegExp("\\n", "g"), "").split(" ").join("");
                    msoListValue = changedContent.match(/mso-list:[^;]+;?/)[0].split(":l");
                    listFormatOverride = (0, $3EnZW.isNullOrUndefined)(msoListValue) ? null : parseInt(msoListValue[1].split("level")[0], 10);
                } else listFormatOverride = null;
            }
            this.listContents = [];
            this.getListContent(listNodes[i]);
            var type = void 0;
            var listStyleType = void 0;
            var startAttr = void 0;
            var styleMarginLeft = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(this.listContents[0])) {
                type = this.listContents[0].trim().length > 1 ? "ol" : "ul";
                listStyleType = this.getlistStyleType(this.listContents[0], type);
                if (type === "ol" && (i === 0 || listNodes[i - 1] === null)) {
                    var startString = this.listContents[0].split(".")[0];
                    var listTypes = [
                        "A",
                        "a",
                        "I",
                        "i",
                        "\u03B1",
                        "1",
                        "01",
                        "1-"
                    ]; // Add '1-' for rare list type.
                    if (listTypes.indexOf(startString) === -1) {
                        if (listStyleType === "decimal") // Bug in getlistStyleType() list style stype is returned as decimal for nested list with start attribute
                        {
                            if (!isNaN(parseInt(startString, 10))) startAttr = parseInt(startString, 10);
                        } else if (listStyleType === "decimal-leading-zero") {
                            if (!isNaN(parseInt(startString, 10))) startAttr = parseInt(startString, 10);
                        } else if (listStyleType === "upper-alpha") startAttr = startString.split(".")[0].charCodeAt(0) - 64;
                        else if (listStyleType === "lower-alpha") startAttr = startString.split(".")[0].charCodeAt(0) - 96;
                        else if (listStyleType === "upper-roman") startAttr = this.upperRomanNumber.indexOf(this.listContents[0].split(".")[0]) + 1;
                        else if (listStyleType === "lower-roman") startAttr = this.lowerRomanNumber.indexOf(this.listContents[0].split(".")[0]) + 1;
                        else if (listStyleType === "lower-greek") startAttr = this.lowerGreekNumber.indexOf(this.listContents[0].split(".")[0]) + 1;
                    }
                }
                if (listNodes[i].style.marginLeft !== "") styleMarginLeft = listNodes[i].style.marginLeft;
                var tempNode = [];
                for(var j = 1; j < this.listContents.length; j++)tempNode.push(this.listContents[j]);
                var currentClassName = void 0;
                if (!(0, $3EnZW.isNullOrUndefined)(listNodes[i].className)) currentClassName = listNodes[i].className;
                if (!(0, $3EnZW.isNullOrUndefined)(listNodes[i].getAttribute("style"))) {
                    listNodes[i].setAttribute("style", listNodes[i].getAttribute("style").replace("text-align:start;", ""));
                    listNodes[i].style.textIndent = "";
                    currentListStyle = listNodes[i].getAttribute("style");
                }
                collection.push({
                    listType: type,
                    content: tempNode,
                    nestedLevel: level,
                    listFormatOverride: listFormatOverride,
                    class: currentClassName,
                    listStyle: currentListStyle,
                    listStyleTypeName: listStyleType,
                    start: startAttr,
                    styleMarginLeft: styleMarginLeft
                });
            }
        }
        stNode = listNodes.shift();
        while(stNode){
            var elemColl = [];
            for(var temp1 = 0; temp1 < data.length; temp1++)if (data[temp1].node === stNode) {
                for(var index = 0; index < data[temp1].content.childNodes.length; index++)elemColl.push(data[temp1].content.childNodes[index]);
                for(var index = 0; index < elemColl.length; index++)stNode.parentElement.insertBefore(elemColl[index], stNode);
                break;
            }
            stNode.remove();
            stNode = listNodes.shift();
            if (!stNode) stNode = listNodes.shift();
        }
    };
    MsWordPaste.prototype.getlistStyleType = function(listContent, type) {
        var currentListClass;
        if (type === "ol") {
            var charCode = listContent.split(".")[0].charCodeAt(0);
            switch(true){
                case this.upperRomanNumber.indexOf(listContent.split(".")[0]) > -1:
                    currentListClass = "upper-roman";
                    break;
                case this.lowerRomanNumber.indexOf(listContent.split(".")[0]) > -1:
                    currentListClass = "lower-roman";
                    break;
                case this.lowerGreekNumber.indexOf(listContent.split(".")[0]) > -1:
                    currentListClass = "lower-greek";
                    break;
                case charCode > 64 && charCode < 91:
                    currentListClass = "upper-alpha";
                    break;
                case charCode > 96 && charCode < 123:
                    currentListClass = "lower-alpha";
                    break;
                case listContent.split(".")[0].length > 1 && listContent.split(".")[0][0] === "0" && !isNaN(Number(listContent.split(".")[0])):
                    currentListClass = "decimal-leading-zero";
                    break;
                default:
                    currentListClass = "decimal";
                    break;
            }
        } else switch(listContent.split(".")[0]){
            case "o":
                currentListClass = "circle";
                break;
            case "\xa7":
                currentListClass = "square";
                break;
            default:
                currentListClass = "disc";
                break;
        }
        return currentListClass;
    };
    MsWordPaste.prototype.makeConversion = function(collection) {
        var root = (0, $4ZDHT.createElement)("div");
        var temp;
        var pLevel = 1;
        var prevList;
        var listCount = 0;
        var elem;
        var lfo = collection[0].listFormatOverride;
        for(var index = 0; index < collection.length; index++){
            var listClass = [
                "MsoListParagraphCxSpFirst",
                "MsoListParagraphCxSpMiddle",
                "MsoListParagraphCxSpLast"
            ];
            var isNormalList = false;
            for(var i = 0; i < listClass.length; i++)if (listClass[i].indexOf(collection[index].class) >= 0) {
                isNormalList = true;
                break;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(prevList) && index !== 0 && collection[index - 1].listType !== collection[index].listType && !isNormalList) prevList = null;
            var pElement = (0, $4ZDHT.createElement)("p", {
                className: "MsoNoSpacing"
            });
            pElement.innerHTML = collection[index].content.join(" ");
            if (collection[index].nestedLevel === 1 && (listCount === 0 || lfo !== collection[index].listFormatOverride) && collection[index].content) {
                root.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType, {
                    className: collection[index].class
                }));
                prevList = (0, $4ZDHT.createElement)("li");
                prevList.appendChild(pElement);
                temp.appendChild(prevList);
                temp.setAttribute("level", collection[index].nestedLevel.toString());
                if (collection[index].class !== "msolistparagraph") temp.style.marginLeft = collection[index].styleMarginLeft;
                else (0, $4ZDHT.addClass)([
                    temp
                ], "marginLeftIgnore");
                temp.style.listStyleType = collection[index].listStyleTypeName;
            } else if (collection[index].nestedLevel === pLevel && lfo === collection[index].listFormatOverride) {
                if (!(0, $3EnZW.isNullOrUndefined)(prevList) && !(0, $3EnZW.isNullOrUndefined)(prevList.parentElement) && prevList.parentElement.tagName.toLowerCase() === collection[index].listType) {
                    prevList.parentElement.appendChild(prevList = (0, $4ZDHT.createElement)("li"));
                    prevList.appendChild(pElement);
                } else if ((0, $3EnZW.isNullOrUndefined)(prevList)) {
                    temp = (0, $4ZDHT.createElement)(collection[index].listType);
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                    prevList = (0, $4ZDHT.createElement)("li");
                    prevList.appendChild(pElement);
                    temp.appendChild(prevList);
                    temp.setAttribute("level", collection[index].nestedLevel.toString());
                    root.appendChild(temp);
                } else {
                    temp = (0, $4ZDHT.createElement)(collection[index].listType);
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                    prevList.parentElement.parentElement.appendChild(temp);
                    prevList = (0, $4ZDHT.createElement)("li");
                    prevList.appendChild(pElement);
                    temp.appendChild(prevList);
                    temp.setAttribute("level", collection[index].nestedLevel.toString());
                }
            } else if (collection[index].nestedLevel > pLevel) {
                if (!(0, $3EnZW.isNullOrUndefined)(prevList)) {
                    for(var j = 0; j < collection[index].nestedLevel - pLevel; j++){
                        prevList.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                        prevList = (0, $4ZDHT.createElement)("li");
                        if (j !== collection[index].nestedLevel - pLevel - 1 && collection[index].nestedLevel - pLevel > 1) prevList.style.listStyleType = "none";
                        temp.appendChild(prevList);
                    }
                    prevList.appendChild(pElement);
                    temp.setAttribute("level", collection[index].nestedLevel.toString());
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                } else if (collection[index].nestedLevel > pLevel && isNormalList) {
                    var initialNode = (0, $4ZDHT.createElement)(collection[index].listType);
                    prevList = (0, $4ZDHT.createElement)("li");
                    initialNode.appendChild(prevList);
                    initialNode.style.listStyleType = "none";
                    for(var j = 0; j < collection[index].nestedLevel - 1; j++){
                        prevList.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                        prevList = (0, $4ZDHT.createElement)("li");
                        temp.appendChild(prevList);
                        temp.style.listStyleType = "none";
                    }
                    prevList.appendChild(pElement);
                    root.appendChild(initialNode);
                    temp.setAttribute("level", collection[index].nestedLevel.toString());
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                } else {
                    root.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                    prevList = (0, $4ZDHT.createElement)("li");
                    prevList.appendChild(pElement);
                    temp.appendChild(prevList);
                    temp.setAttribute("level", collection[index].nestedLevel.toString());
                    if (collection[index].class !== "msolistparagraph") temp.style.marginLeft = collection[index].styleMarginLeft;
                    else (0, $4ZDHT.addClass)([
                        temp
                    ], "marginLeftIgnore");
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                }
            } else if (collection[index].nestedLevel === 1) {
                if (root.lastChild.tagName.toLowerCase() === collection[index].listType) temp = root.lastChild;
                else {
                    root.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                    temp.style.listStyleType = collection[index].listStyleTypeName;
                }
                prevList = (0, $4ZDHT.createElement)("li");
                prevList.appendChild(pElement);
                temp.appendChild(prevList);
                temp.setAttribute("level", collection[index].nestedLevel.toString());
            } else {
                elem = prevList;
                while(elem.parentElement){
                    elem = elem.parentElement;
                    if (elem.attributes.getNamedItem("level")) {
                        if (parseInt(elem.attributes.getNamedItem("level").textContent, 10) === collection[index].nestedLevel && lfo === collection[index].listFormatOverride) {
                            prevList = (0, $4ZDHT.createElement)("li");
                            prevList.appendChild(pElement);
                            elem.appendChild(prevList);
                            break;
                        // eslint-disable-next-line
                        } else if (parseInt(elem.attributes.getNamedItem("level").textContent, null) === collection[index].nestedLevel && lfo !== collection[index].listFormatOverride) {
                            temp = (0, $4ZDHT.createElement)(collection[index].listType);
                            prevList = (0, $4ZDHT.createElement)("li");
                            temp.appendChild(prevList);
                            if (collection[index].nestedLevel > 1) for(var k = 0; k < collection[index].nestedLevel - 1; k++){
                                prevList.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                                prevList = (0, $4ZDHT.createElement)("li");
                                temp.appendChild(prevList);
                                temp.style.listStyleType = "none";
                            }
                            prevList.appendChild(pElement);
                            elem.appendChild(temp);
                            temp.setAttribute("level", collection[index].nestedLevel.toString());
                            temp.style.listStyleType = collection[index].listStyleTypeName;
                            break;
                        } else if (collection[index].nestedLevel > parseInt(elem.attributes.getNamedItem("level").textContent, 10)) {
                            elem.appendChild(temp = (0, $4ZDHT.createElement)(collection[index].listType));
                            prevList = (0, $4ZDHT.createElement)("li");
                            prevList.appendChild(pElement);
                            temp.appendChild(prevList);
                            temp.setAttribute("level", collection[index].nestedLevel.toString());
                            temp.style.listStyleType = collection[index].listStyleTypeName;
                            break;
                        }
                    }
                    continue;
                }
            }
            prevList.setAttribute("class", collection[index].class);
            prevList.setAttribute("style", !(0, $3EnZW.isNullOrUndefined)(collection[index].listStyle) ? collection[index].listStyle : "");
            pLevel = collection[index].nestedLevel;
            lfo = collection[index].listFormatOverride;
            listCount++;
            if (!(0, $3EnZW.isNullOrUndefined)(collection[index].start && collection[index].start !== 1 && collection[index].listType === "ol")) temp.setAttribute("start", collection[index].start.toString());
        }
        return root;
    };
    MsWordPaste.prototype.getListContent = function(elem) {
        var pushContent = "";
        var firstChild = elem.firstElementChild;
        if (firstChild.textContent.trim() === "" && !(0, $3EnZW.isNullOrUndefined)(firstChild.firstElementChild) && firstChild.firstElementChild.nodeName === "IMG") {
            pushContent = elem.innerHTML.trim();
            this.listContents.push("");
            this.listContents.push(pushContent);
        } else //Add to support separate list which looks like same list and also to add all tags as it is inside list
        if (firstChild.childNodes.length > 0) {
            var listIgnoreTag = firstChild.querySelectorAll('[style*="mso-list"]');
            for(var i = 0; i < listIgnoreTag.length; i++)listIgnoreTag[i].setAttribute("style", listIgnoreTag[i].getAttribute("style").replace(/\n/g, ""));
            var listOrderCleanup = firstChild.querySelector('span[style*="mso-list"]');
            if (listOrderCleanup) {
                var style = listOrderCleanup.getAttribute("style");
                if (style) {
                    style = style.replace(/\s*:\s*/g, ":");
                    listOrderCleanup.setAttribute("style", style);
                }
            }
            var listOrder = firstChild.querySelector('span[style="mso-list:Ignore"]');
            if (!(0, $3EnZW.isNullOrUndefined)(listOrder)) {
                this.listContents.push(listOrder.textContent.trim());
                (0, $4ZDHT.detach)(listOrder);
                this.removingComments(elem);
                this.removeUnwantedElements(elem);
            }
        }
        this.listContents.push(elem.innerHTML);
    };
    MsWordPaste.prototype.processMargin = function(element) {
        var liChildren = element.querySelectorAll("li");
        if (liChildren.length > 0) {
            for(var i = 0; i < liChildren.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(liChildren[i].style.marginLeft) && !liChildren[i].parentElement.classList.contains("marginLeftIgnore")) liChildren[i].style.marginLeft = "";
        }
        var tableChildren = element.querySelectorAll("table");
        if (tableChildren.length > 0) {
            for(var i = 0; i < tableChildren.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(tableChildren[i].style.marginLeft) && tableChildren[i].style.marginLeft.indexOf("-") >= 0) tableChildren[i].style.marginLeft = "";
        }
        var ignoredNode = element.querySelectorAll(".marginLeftIgnore li");
        if (ignoredNode.length > 0) {
            for(var i = 0; i < ignoredNode.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(ignoredNode[i].style.marginLeft) && ignoredNode[i].style.marginLeft !== "") {
                var marginLeft = ignoredNode[i].style.marginLeft;
                var marginLeftValue = parseFloat(marginLeft.split("in")[0]);
                var result = marginLeftValue - 0.5;
                ignoredNode[i].style.marginLeft = result.toString() + "in";
            }
        }
    };
    MsWordPaste.prototype.removeEmptyAnchorTag = function(element) {
        var removableElement = element.querySelectorAll("a:not([href])");
        for(var j = removableElement.length - 1; j >= 0; j--){
            var parentElem = removableElement[j].parentNode;
            while(removableElement[j].firstChild)parentElem.insertBefore(removableElement[j].firstChild, removableElement[j]);
            parentElem.removeChild(removableElement[j]);
        }
    };
    MsWordPaste.prototype.findSource = function(element) {
        var metaNodes = element.querySelectorAll("meta");
        for(var i = 0; i < metaNodes.length; i++){
            var metaNode = metaNodes[i];
            var content = metaNode.getAttribute("content");
            var name_1 = metaNode.getAttribute("name");
            if (name_1 && name_1.toLowerCase().indexOf("generator") >= 0 && content && content.toLowerCase().indexOf("microsoft") >= 0) for(var j = 0; j < (0, $56b963295b740d00$export$9b8dbe4d9d74124c).length; j++){
                if (content.toLowerCase().indexOf((0, $56b963295b740d00$export$9b8dbe4d9d74124c)[j]) >= 0) return (0, $56b963295b740d00$export$9b8dbe4d9d74124c)[j];
            }
        }
        return "html";
    };
    MsWordPaste.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MsWordPaste;
}();






/**
 * Insert a Text Node or Text
 *
 * @hidden

 */ var $d63c9a472424714e$export$1290385b0e0ceb87 = /** @class */ function() {
    /**
     * Constructor for creating the InsertText plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden

     */ function InsertTextExec(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    InsertTextExec.prototype.addEventListener = function() {
        this.parent.observer.on($56b963295b740d00$export$d5e6ccd3e4d93c9b, this.insertText, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    InsertTextExec.prototype.removeEventListener = function() {
        this.parent.observer.off($56b963295b740d00$export$d5e6ccd3e4d93c9b, this.insertText);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    InsertTextExec.prototype.insertText = function(e) {
        var node = document.createTextNode(e.value);
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, node, this.parent.editableElement);
        if (e.callBack) e.callBack({
            requestType: e.subCommand,
            editorMode: "HTML",
            event: e.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    InsertTextExec.prototype.destroy = function() {
        this.removeEventListener();
    };
    return InsertTextExec;
}();



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");


var $685010ff8f578838$export$13a9ed9091b85070 = /** @class */ function() {
    function FormatPainterActions(parent, options) {
        this.INVALID_TAGS = [
            "A",
            "AUDIO",
            "IMG",
            "VIDEO",
            "IFRAME"
        ];
        this.parent = parent;
        this.settings = options;
        this.addEventListener();
        this.setDeniedFormats();
    }
    FormatPainterActions.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$c234d9c0576b5f9a, this.actionHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    FormatPainterActions.prototype.onPropertyChanged = function(prop) {
        if (prop && prop.module === "formatPainter") {
            if (!(0, $3EnZW.isNullOrUndefined)(prop.newProp.formatPainterSettings.allowedFormats)) this.settings.allowedFormats = prop.newProp.formatPainterSettings.allowedFormats;
            if (!(0, $3EnZW.isNullOrUndefined)(prop.newProp.formatPainterSettings.deniedFormats)) {
                this.settings.deniedFormats = prop.newProp.formatPainterSettings.deniedFormats;
                this.setDeniedFormats();
            }
        }
    };
    FormatPainterActions.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$c234d9c0576b5f9a, this.actionHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * Destroys the format painter.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ FormatPainterActions.prototype.destroy = function() {
        this.removeEventListener();
        this.INVALID_TAGS = null;
        this.copyCollection = null;
        this.deniedFormatsCollection = null;
        this.newElem = null;
        this.newElemLastChild = null;
        this.settings = null;
        this.parent = null;
    };
    FormatPainterActions.prototype.actionHandler = function(args) {
        this.settings.allowedContext = [
            "Text",
            "List",
            "Table"
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(args) && !(0, $3EnZW.isNullOrUndefined)(args.item) && !(0, $3EnZW.isNullOrUndefined)(args.item.formatPainterAction)) {
            switch(args.item.formatPainterAction){
                case "format-copy":
                    this.copyAction();
                    break;
                case "format-paste":
                    this.pasteAction();
                    break;
                case "escape":
                    this.escapeAction();
                    break;
            }
            this.callBack(args);
        }
    };
    FormatPainterActions.prototype.callBack = function(event) {
        if (event.callBack) event.callBack({
            requestType: "FormatPainter",
            action: event.item.formatPainterAction,
            event: event.event,
            editorMode: "HTML",
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    FormatPainterActions.prototype.generateElement = function() {
        var copyCollection = this.copyCollection.slice(); // To clone without reversing the collcection array
        copyCollection.reverse();
        var length = copyCollection.length;
        var elemCollection = (0, $4ZDHT.createElement)("div", {
            className: "e-format-paste-wrapper"
        });
        var lastAppendChild;
        for(var i = 0; i < length; i++){
            var _a = copyCollection[i], attrs = _a.attrs, className = _a.className, styles = _a.styles, tagName = _a.tagName;
            var elem = (0, $4ZDHT.createElement)(tagName);
            if (className !== "") elem.className = className;
            for(var i_1 = 0; i_1 < attrs.length; i_1++){
                var property = attrs[i_1].name;
                var value = attrs[i_1].value;
                elem.setAttribute(property, value);
            }
            for(var i_2 = 0; i_2 < styles.length; i_2++){
                var property = styles[i_2].property;
                var value = styles[i_2].value;
                var priority = styles[i_2].priority;
                elem.style.setProperty(property, value, priority);
            }
            if (elemCollection.childElementCount === 0) {
                elemCollection.append(elem);
                lastAppendChild = elem;
            } else {
                lastAppendChild.append(elem);
                lastAppendChild = elem;
            }
        }
        var elemChild = this.removeDeniedFormats(elemCollection);
        var currentElem = elemChild;
        while(currentElem)if (currentElem.firstChild === null) {
            lastAppendChild = currentElem;
            currentElem = undefined;
        } else currentElem = currentElem.firstChild;
        this.newElem = elemChild;
        this.newElemLastChild = lastAppendChild;
    };
    FormatPainterActions.prototype.pasteAction = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.copyCollection) || this.copyCollection.length === 0) {
            this.paintPlainTextFormat();
            return;
        }
        this.insertFormatNode(this.newElem, this.newElemLastChild);
    };
    FormatPainterActions.prototype.removeDeniedFormats = function(parentElement) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.deniedFormatsCollection) && this.deniedFormatsCollection.length > 0) {
            var deniedPropArray = this.deniedFormatsCollection;
            var length_1 = deniedPropArray.length;
            for(var i = 0; i < length_1; i++){
                var tag = deniedPropArray[i].tag;
                if (deniedPropArray[i].tag) {
                    var elementsList = parentElement.querySelectorAll(tag);
                    for(var j = 0; j < elementsList.length; j++){
                        if (deniedPropArray[i].classes.length > 0) {
                            var classes = deniedPropArray[i].classes;
                            var classLength = classes.length;
                            for(var k = 0; k < classLength; k++)if (elementsList[j].classList.contains(classes[k])) (0, $4ZDHT.removeClass)([
                                elementsList[j]
                            ], classes[k].trim());
                            if (elementsList[j].classList.length === 0) elementsList[j].removeAttribute("class");
                        }
                        if (deniedPropArray[i].styles.length > 0) {
                            var styles = deniedPropArray[i].styles;
                            var styleLength = styles.length;
                            for(var k = 0; k < styleLength; k++)elementsList[j].style.removeProperty(styles[k].trim());
                            if (elementsList[j].style.length === 0) elementsList[j].removeAttribute("style");
                        }
                        if (deniedPropArray[i].attributes.length > 0) {
                            var attributes = deniedPropArray[i].attributes;
                            var attributeLength = attributes.length;
                            for(var k = 0; k < attributeLength; k++)elementsList[j].removeAttribute(attributes[k].trim());
                        }
                    }
                }
            }
        }
        return parentElement.firstElementChild;
    };
    FormatPainterActions.prototype.copyAction = function() {
        var copyCollection = [];
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var domSelection = this.parent.nodeSelection;
        var nodes = range.collapsed ? domSelection.getSelectionNodeCollection(range) : domSelection.getSelectionNodeCollectionBr(range);
        if (nodes.length === 0 && domSelection.getSelectionNodeCollectionBr(range).length === 0) return;
        else nodes = nodes.length === 0 ? domSelection.getSelectionNodeCollectionBr(range) : nodes;
        var parentElem = nodes[0].parentElement;
        var currentContext = this.findCurrentContext(parentElem);
        var allowedRulesArray = this.settings.allowedFormats.indexOf(";") > -1 ? this.settings.allowedFormats.split(";") : [
            this.settings.allowedFormats
        ];
        for(var i = 0; i < allowedRulesArray.length; i++)allowedRulesArray[i] = allowedRulesArray[i].trim();
        var _a = this.getRangeParentElem(currentContext, parentElem), rangeParentElem = _a[0], context = _a[1];
        if (currentContext === null) currentContext = context;
        if (!(0, $3EnZW.isNullOrUndefined)(currentContext) && this.settings.allowedContext.indexOf(currentContext) > -1) {
            if (range.startContainer.nodeName === "#text") parentElem = range.startContainer.parentElement;
            var lastElement = parentElem;
            do {
                if (allowedRulesArray.indexOf(parentElem.nodeName.toLowerCase()) > -1) {
                    var allAttributes = parentElem.attributes;
                    var attribute = [];
                    for(var i = 0; i < allAttributes.length; i++)if (allAttributes[i].name !== "class" && allAttributes[i].name !== "style") attribute.push(allAttributes[i]);
                    var classes = parentElem.className;
                    var allStyles = parentElem.style;
                    var styleProp = [];
                    for(var i = 0; i < allStyles.length; i++){
                        var property = allStyles[i];
                        var value = allStyles.getPropertyValue(property);
                        var priority = allStyles.getPropertyPriority(property);
                        styleProp.push({
                            property: property,
                            value: value,
                            priority: priority
                        });
                    }
                    copyCollection.push({
                        attrs: attribute,
                        className: classes,
                        styles: styleProp,
                        tagName: parentElem.nodeName
                    });
                }
                if (rangeParentElem === parentElem) parentElem = undefined;
                else if (!(0, $3EnZW.isNullOrUndefined)(parentElem.parentElement)) parentElem = parentElem.parentElement;
                if (lastElement === parentElem) break;
            }while (!(0, $3EnZW.isNullOrUndefined)(parentElem) || parentElem === this.parent.editableElement);
            this.copyCollection = copyCollection;
        }
        this.generateElement();
    };
    FormatPainterActions.prototype.getRangeParentElem = function(currentContext, rangeParent) {
        var startContainer = rangeParent;
        var rangeParentELem;
        if (startContainer.nodeType === 3) startContainer = startContainer.parentElement;
        switch(currentContext){
            case "Table":
                rangeParentELem = (0, $4ZDHT.closest)(startContainer, "td");
                if ((0, $3EnZW.isNullOrUndefined)(rangeParentELem)) rangeParentELem = (0, $4ZDHT.closest)(startContainer, "th");
                break;
            case "List":
                rangeParentELem = (0, $4ZDHT.closest)(startContainer, "li");
                break;
            case "Text":
                rangeParentELem = (0, $4ZDHT.closest)(startContainer, "p");
                break;
        }
        if ((0, $3EnZW.isNullOrUndefined)(rangeParentELem)) {
            var nearBlockParentName = this.getNearestBlockParentElement(rangeParent);
            if (!(0, $3EnZW.isNullOrUndefined)(nearBlockParentName) && nearBlockParentName !== "UL" && nearBlockParentName !== "OL" && nearBlockParentName !== "LI") {
                rangeParentELem = (0, $4ZDHT.closest)(startContainer, nearBlockParentName);
                currentContext = "Text";
            }
        }
        if (currentContext === "List") rangeParentELem = rangeParentELem.parentElement;
        return [
            rangeParentELem,
            currentContext
        ];
    };
    FormatPainterActions.prototype.getNearestBlockParentElement = function(rangeParent) {
        var node = rangeParent;
        if (node.nodeType === 3) node = node.parentNode;
        // iterate untill the content editable div
        while(node && node !== this.parent.editableElement){
            // If true return the block node name.
            if (!(0, $3EnZW.isNullOrUndefined)(node) && this.isBlockElement(node)) return node.nodeName;
            // if false re assign node to parent node
            node = node.parentNode;
        }
        return null;
    };
    FormatPainterActions.prototype.isBlockElement = function(node) {
        var blockTags = [
            "P",
            "DIV",
            "UL",
            "OL",
            "LI",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "ADDRESS",
            "ARTICLE",
            "ASIDE",
            "BLOCKQUOTE",
            "FIGCAPTION",
            "FIGURE",
            "FOOTER",
            "HEADER",
            "HR",
            "MAIN",
            "NAV",
            "SECTION",
            "SUMMARY",
            "PRE"
        ];
        return blockTags.indexOf(node.nodeName) > -1;
    };
    FormatPainterActions.prototype.escapeAction = function() {
        this.copyCollection = [];
    };
    FormatPainterActions.prototype.paintPlainTextFormat = function() {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var domSelection = this.parent.nodeSelection;
        var nodes = range.collapsed ? domSelection.getSelectionNodeCollection(range) : domSelection.getSelectionNodeCollectionBr(range);
        var isInValid;
        if (nodes.length > 1) for(var i = 0; i < nodes.length; i++)isInValid = this.validateELementTag(nodes[i]);
        else isInValid = this.validateELementTag(range.startContainer) && this.validateELementTag(range.endContainer);
        if (!isInValid) this.parent.execCommand("Clear", "ClearFormat", null, null);
    };
    FormatPainterActions.prototype.validateELementTag = function(node) {
        if (node.nodeType === 3) node = node.parentElement;
        return this.INVALID_TAGS.indexOf(node.tagName) > -1;
    };
    FormatPainterActions.prototype.findCurrentContext = function(parentElem) {
        var closestParagraph = (0, $4ZDHT.closest)(parentElem, "p");
        var closestList = (0, $4ZDHT.closest)(parentElem, "li");
        if (closestParagraph && !closestList) return "Text";
        else if ((0, $4ZDHT.closest)(parentElem, "li")) {
            if (!(0, $3EnZW.isNullOrUndefined)(closestParagraph) && !(0, $3EnZW.isNullOrUndefined)(closestList) && closestParagraph.textContent.trim() !== closestList.textContent.trim()) return "Text";
            return "List";
        } else if ((0, $4ZDHT.closest)(parentElem, "td") || (0, $4ZDHT.closest)(parentElem, "tr") || (0, $4ZDHT.closest)(parentElem, "th")) return "Table";
        return null;
    };
    FormatPainterActions.prototype.insertFormatNode = function(elem, lastChild) {
        var clonedElem = elem.cloneNode(true);
        if (!this.isBlockElement(elem)) {
            var newBlockElem = (0, $4ZDHT.createElement)("P");
            newBlockElem.appendChild(elem);
            clonedElem = newBlockElem.cloneNode(true);
        }
        var endNode = this.parent.editableElement;
        var docElement = this.parent.currentDocument;
        var childElem = clonedElem.firstChild;
        var inlineElement;
        while(childElem)if (this.isBlockElement(childElem)) childElem = childElem.firstChild;
        else {
            inlineElement = childElem.parentNode.removeChild(childElem);
            break;
        }
        var formatValues = {
            element: inlineElement,
            lastChild: lastChild
        };
        (0, $7dd901ee55c381ee$export$182333f802b3d72b).applyFormat(docElement, null, endNode, "P", null, "formatPainter", null, formatValues);
        var range = this.parent.nodeSelection.getRange(docElement);
        var isCollapsed = range.collapsed;
        var blockNodes = this.parent.domNode.blockNodes();
        var isListCopied = this.isListCopied();
        if (isListCopied) {
            for(var i = 0; i < blockNodes.length; i++)if ((0, $4ZDHT.closest)(blockNodes[i], "li")) blockNodes[i] = (0, $4ZDHT.closest)(blockNodes[i], "li");
        }
        var isFullNodeSelected = false;
        if (blockNodes.length === 1) isFullNodeSelected = blockNodes[0].textContent.trim() === range.toString().trim();
        if (this.isBlockElement(clonedElem) && isCollapsed || blockNodes.length > 1 || isFullNodeSelected) this.insertBlockNode(clonedElem, range, docElement, blockNodes);
    };
    FormatPainterActions.prototype.isListCopied = function() {
        var isListCopied = false;
        for(var i = 0; i < this.copyCollection.length; i++)if (this.copyCollection[i].tagName === "OL" || this.copyCollection[i].tagName === "UL") {
            isListCopied = true;
            break;
        }
        return isListCopied;
    };
    FormatPainterActions.prototype.insertBlockNode = function(element, range, docElement, nodes) {
        var domSelection = this.parent.nodeSelection;
        var saveSelection = domSelection.save(range, docElement);
        this.parent.domNode.setMarker(saveSelection);
        var listElement; // To clone to multiple list elements
        var cloneListParentNode;
        var sameListType = false;
        if (element.nodeName === "UL" || element.nodeName === "OL") {
            cloneListParentNode = element.cloneNode(true);
            listElement = cloneListParentNode.firstChild;
        }
        var cloneElementNode = (0, $3EnZW.isNullOrUndefined)(cloneListParentNode) ? element : element.firstChild;
        for(var index = 0; index < nodes.length; index++){
            if (this.INVALID_TAGS.indexOf(nodes[index].nodeName) > -1 || nodes[index].querySelectorAll("img,audio,video,iframe").length > 0) continue;
            var cloneParentNode = cloneElementNode.cloneNode(false);
            // Appending all the child elements
            while(nodes[index].firstChild)if (nodes[index].textContent.trim().length !== 0) cloneParentNode.appendChild(nodes[index].firstChild);
            else nodes[index].removeChild(nodes[index].firstChild);
            if (nodes[index].nodeName === "TD" || nodes[index].nodeName === "TH") {
                if ((0, $3EnZW.isNullOrUndefined)(cloneListParentNode)) {
                    nodes[index].appendChild(cloneParentNode);
                    continue;
                } else if (index === 0 && !(0, $3EnZW.isNullOrUndefined)(cloneListParentNode)) {
                    nodes[index].appendChild(cloneListParentNode);
                    cloneListParentNode.appendChild(cloneParentNode);
                    continue;
                } else {
                    nodes[index].appendChild(cloneParentNode);
                    continue;
                }
            }
            if (!(0, $3EnZW.isNullOrUndefined)(cloneListParentNode)) sameListType = this.isSameListType(element, nodes[index]);
            if (cloneParentNode.nodeName === "LI" && !sameListType) this.insertNewList(range, nodes, index, cloneListParentNode, cloneParentNode);
            else if (sameListType) this.insertSameList(nodes, index, cloneListParentNode, cloneParentNode);
            else nodes[index].parentNode.replaceChild(cloneParentNode, nodes[index]);
            /**Removing the inserted block node in list and appending to previous element sibling */ if (cloneParentNode.nodeName !== "LI" && (cloneParentNode.parentElement.nodeName === "OL" || cloneParentNode.parentElement.nodeName === "UL")) {
                var parent_1 = cloneParentNode.parentElement;
                // Cutting single ul or ol to two ul or ol based on the range
                this.parent.nodeCutter.SplitNode(range, parent_1, true);
                if (!(0, $3EnZW.isNullOrUndefined)(parent_1.previousElementSibling)) {
                    parent_1.previousElementSibling.after(cloneParentNode);
                    // To remove the nested list items out of the block element
                    if (cloneParentNode.childNodes.length > 1) for(var j = 0; j < cloneParentNode.childNodes.length; j++){
                        var currentChild = cloneParentNode.childNodes[j];
                        if (currentChild.nodeName === "OL" || currentChild.nodeName === "UL") cloneParentNode.after(currentChild);
                    }
                } else parent_1.parentElement.prepend(cloneParentNode);
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !(0, $3EnZW.isNullOrUndefined)(listElement) && (0, $4ZDHT.detach)(listElement);
        this.cleanEmptyLists();
        var save = this.parent.domNode.saveMarker(saveSelection);
        save.restore();
    };
    FormatPainterActions.prototype.insertNewList = function(range, nodes, index, cloneListParentNode, cloneParentNode) {
        // Appending the li nodes to the ol or ul node
        if (index === 0) {
            var nodeName = nodes[index].nodeName;
            nodes[index] = nodes[index].parentNode.replaceChild(cloneListParentNode, nodes[index]);
            var parent_2 = nodeName === "LI" ? cloneListParentNode.parentElement : cloneListParentNode;
            // Splicing and then inserting the node to previous element sibling of the Listparent.parent
            this.parent.nodeCutter.SplitNode(range, parent_2, true);
            if (nodes[index].nodeName === "LI" && !(0, $3EnZW.isNullOrUndefined)(parent_2)) {
                cloneListParentNode.append(cloneParentNode);
                if (!(0, $3EnZW.isNullOrUndefined)(parent_2.parentNode)) parent_2.parentNode.insertBefore(cloneListParentNode, parent_2);
            } else if (!(0, $3EnZW.isNullOrUndefined)(parent_2)) {
                if (!(0, $3EnZW.isNullOrUndefined)(parent_2.previousElementSibling) && parent_2.previousElementSibling.nodeName === cloneListParentNode.nodeName) {
                    var currentParent = parent_2.previousElementSibling;
                    currentParent.append(cloneParentNode);
                    while(currentParent.firstChild)cloneListParentNode.append(currentParent.firstChild);
                } else if (!(0, $3EnZW.isNullOrUndefined)(parent_2.nextElementSibling) && parent_2.nextElementSibling.nodeName === cloneListParentNode.nodeName) {
                    var currentParent = parent_2.nextElementSibling;
                    currentParent.prepend(cloneParentNode);
                    while(currentParent.firstChild)cloneListParentNode.append(currentParent.firstChild);
                } else cloneListParentNode.append(cloneParentNode);
            } else cloneListParentNode.append(cloneParentNode);
        } else cloneListParentNode.append(cloneParentNode);
        this.detachEmptyBlockNodes(nodes[index]);
    };
    FormatPainterActions.prototype.insertSameList = function(nodes, index, cloneListParentNode, cloneParentNode) {
        if (index === 0) {
            if (!(0, $3EnZW.isNullOrUndefined)(nodes[index].parentNode) && (nodes[index].parentNode.nodeName === "UL" || nodes[index].parentNode.nodeName === "OL")) {
                // append the nodes[index].parentNode.childNodes to the clonelistparentnode
                if (nodes.length === 1) {
                    // When clicked with cursor in the single list item
                    while(cloneParentNode.firstChild)nodes[index].append(cloneParentNode.firstChild);
                    for(var i = 0; i < nodes[index].parentNode.childNodes.length; i++){
                        var currentChild = nodes[index].parentNode.childNodes[i];
                        cloneListParentNode.append(currentChild.cloneNode(true));
                    }
                } else cloneListParentNode.append(cloneParentNode);
                // replace the older ol and ul with new ol and ul of clonelistparentnode
                nodes[index].parentNode.parentNode.replaceChild(cloneListParentNode, nodes[index].parentNode);
            }
        } else cloneListParentNode.append(cloneParentNode);
        this.detachEmptyBlockNodes(nodes[index]);
    };
    FormatPainterActions.prototype.isSameListType = function(element, node) {
        var isSameListType = false;
        var nearestListNode = (0, $4ZDHT.closest)(node, "ol, ul");
        if (!(0, $3EnZW.isNullOrUndefined)(nearestListNode) && nearestListNode.querySelectorAll("li").length > 0) {
            if (nearestListNode.nodeName === element.nodeName) isSameListType = true;
            else isSameListType = false;
        }
        return isSameListType;
    };
    FormatPainterActions.prototype.cleanEmptyLists = function() {
        var listElem = this.parent.editableElement.querySelectorAll("ol, ul");
        for(var i = 0; i < listElem.length; i++)if (listElem[i].textContent.trim() === "") (0, $4ZDHT.detach)(listElem[i]);
    };
    FormatPainterActions.prototype.setDeniedFormats = function() {
        var deniedFormatsCollection = [];
        if ((0, $3EnZW.isNullOrUndefined)(this.settings) || (0, $3EnZW.isNullOrUndefined)(this.settings.deniedFormats)) return;
        var deniedFormats = this.settings.deniedFormats.indexOf(";") > -1 ? this.settings.deniedFormats.split(";") : [
            this.settings.deniedFormats
        ];
        var length = deniedFormats.length;
        for(var i = 0; i < length; i++){
            var formatString = deniedFormats[i];
            if (formatString !== "") {
                formatString.trim();
                var collection = this.makeDeniedFormatsCollection(formatString);
                if (!(0, $3EnZW.isNullOrUndefined)(collection)) deniedFormatsCollection.push(collection);
            }
        }
        this.deniedFormatsCollection = deniedFormatsCollection;
    };
    FormatPainterActions.prototype.detachEmptyBlockNodes = function(node) {
        if (!(0, $3EnZW.isNullOrUndefined)(node) && node.textContent.trim() === "") (0, $4ZDHT.detach)(node);
    };
    FormatPainterActions.prototype.makeDeniedFormatsCollection = function(value) {
        var openParenIndex = value.indexOf("(");
        var closeParenIndex = value.indexOf(")");
        var openBracketIndex = value.indexOf("[");
        var closeBracketIndex = value.indexOf("]");
        var openBraceIndex = value.indexOf("{");
        var closeBraceIndex = value.indexOf("}");
        var classes = [];
        var attributes = "";
        var styles = "";
        var tagName = "";
        var classList = [];
        var attributesList = [];
        var stylesList = [];
        if (openParenIndex > -1 && closeParenIndex > -1) {
            classes = value.substring(openParenIndex + 1, closeParenIndex).split(" ");
            classList = classes[0].split(")")[0].split(",");
        }
        if (openBracketIndex > -1 && closeBracketIndex > -1) {
            attributes = value.substring(openBracketIndex + 1, closeBracketIndex);
            attributesList = attributes.split(",");
        }
        if (openBraceIndex > -1 && closeBraceIndex > -1) {
            styles = value.substring(openBraceIndex + 1, closeBraceIndex);
            stylesList = styles.split(",");
        }
        var openIndexArray = [
            openParenIndex,
            openBracketIndex,
            openBraceIndex
        ];
        openIndexArray = openIndexArray.filter(function(index) {
            return index > -1;
        });
        var len = openIndexArray.length;
        var min;
        if (len === 1) min = openIndexArray[0];
        else if (len === 2) min = Math.min(openIndexArray[0], openIndexArray[1]);
        else if (len === 3) min = Math.min(openIndexArray[0], openIndexArray[1], openIndexArray[2]);
        tagName = value.substring(0, min);
        tagName = tagName.trim();
        return {
            tag: tagName,
            styles: stylesList,
            classes: classList,
            attributes: attributesList
        };
    };
    return FormatPainterActions;
}();




var $bcb549db2fb78e05$export$98af294173a3a62b = /** @class */ function() {
    function EmojiPickerAction(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    EmojiPickerAction.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$bb3de268509fc258, this.emojiInsert, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    EmojiPickerAction.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$bb3de268509fc258, this.emojiInsert);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    EmojiPickerAction.prototype.emojiInsert = function(args) {
        var node = document.createTextNode(args.value);
        var selection = this.parent.currentDocument.getSelection();
        var range = selection.getRangeAt(0);
        var cursorPos = range.startOffset;
        for(var i = cursorPos - 1; i >= cursorPos - 15; i--){
            var prevChar_1 = selection.focusNode.textContent.substring(i - 1, i);
            var isPrevSpace_1 = /:$/.test(prevChar_1);
            if (isPrevSpace_1) {
                this.beforeApplyFormat(true);
                break;
            }
        }
        var colon = /:$/.test(selection.focusNode.textContent.charAt(cursorPos - 1));
        var prevChar = selection.focusNode.textContent.charAt(cursorPos - 2);
        var isPrevSpace = /\s/.test(prevChar);
        if (colon && (isPrevSpace || selection.focusOffset === 1)) this.beforeApplyFormat(true);
        (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.parent.currentDocument, node, this.parent.editableElement);
        if (args.callBack) args.callBack({
            requestType: args.subCommand,
            editorMode: "HTML",
            event: args.event,
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    };
    EmojiPickerAction.prototype.beforeApplyFormat = function(isBlockFormat) {
        var range1 = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var node = this.parent.nodeSelection.getNodeCollection(range1)[0];
        var blockNewLine = !(node.parentElement.innerHTML.replace(/&nbsp;|<br>/g, "").trim() === ":" || node.textContent.trim().indexOf("/") === 0);
        var startNode = node;
        if (blockNewLine && isBlockFormat) while(startNode !== this.parent.editableElement)startNode = startNode.parentElement;
        var startPoint = range1.startOffset;
        while(this.parent.nodeSelection.getRange(document).toString().indexOf(":") === -1){
            this.parent.nodeSelection.setSelectionText(document, node, node, startPoint, range1.endOffset);
            startPoint--;
        }
        var range2 = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var node2 = this.parent.nodeCutter.GetSpliceNode(range2, node);
        node2.parentNode.removeChild(node2);
    };
    EmojiPickerAction.prototype.destroy = function() {
        this.removeEventListener();
    };
    return EmojiPickerAction;
}();



/**
 * EditorManager internal component
 *
 * @hidden

 */ var $f9047ee5aba07026$export$18002c264c39dab4 = /** @class */ function() {
    /**
     * Constructor for creating the component
     *
     * @hidden

     * @param {ICommandModel} options - specifies the command Model
     */ function EditorManager(options) {
        this.currentDocument = options.document;
        this.editableElement = options.editableElement;
        this.nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        this.nodeCutter = new (0, $5aa4bc5f0d5dd043$export$7983d5b845f781c0)();
        this.domNode = new (0, $885a3ef7b3a774b1$export$913ca0ecb04f4c72)(this.editableElement, this.currentDocument);
        this.observer = new (0, $13zI2.Observer)(this);
        this.listObj = new (0, $4054e52afc0effaa$export$e1553435d4022be)(this);
        this.formatObj = new (0, $a9472a70d27ba3fe$export$8132710d1930b03e)(this);
        this.alignmentObj = new (0, $d7bd1980500e1bb6$export$778d96ef961014bf)(this);
        this.indentsObj = new (0, $de6987afc8e510a6$export$1a8bb67630667279)(this);
        this.linkObj = new (0, $12fb7df4ec593114$export$716db6c6fd6cbe7b)(this);
        this.imgObj = new (0, $e6c697d9184b91d9$export$cfd550c1514622de)(this);
        this.audioObj = new (0, $9efbc9216fe2941e$export$d3aef97e7cc6d07b)(this);
        this.videoObj = new (0, $ff897e152c5dfbc6$export$8bf61d9e46409f0)(this);
        this.selectionObj = new (0, $6aafe83ff7d024e3$export$9e1aabd7bce64036)(this);
        this.inserthtmlObj = new (0, $0860029f12fff0a9$export$1c5539f1e0843472)(this);
        this.insertTextObj = new (0, $d63c9a472424714e$export$1290385b0e0ceb87)(this);
        this.clearObj = new (0, $ce6662ec3221c493$export$86d30f51c9ab2b39)(this);
        this.tableObj = new (0, $eff586c2ee4b592c$export$198ea458cbfb59e4)(this);
        this.undoRedoManager = new (0, $0498b8f502bd71e1$export$2aef42d075d45ec5)(this, options.options);
        this.msWordPaste = new (0, $30d0d69d23909284$export$67508203d4c57a4d)(this);
        this.formatPainterEditor = new (0, $685010ff8f578838$export$13a9ed9091b85070)(this, options.formatPainterSettings);
        this.emojiPickerObj = new (0, $bcb549db2fb78e05$export$98af294173a3a62b)(this);
        this.tableCellSelection = new (0, $b53cb9a305ffcc69$export$d1314ebcfd9d7a36)(this.editableElement, this.currentDocument);
        this.wireEvents();
        this.isDestroyed = false;
    }
    EditorManager.prototype.wireEvents = function() {
        this.observer.on($ee11fb99ae4d2c3e$export$a80636c6f41931fe, this.editorKeyDown, this);
        this.observer.on($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp, this);
        this.observer.on($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp, this);
        this.observer.on($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, this.onPropertyChanged, this);
        this.observer.on($ee11fb99ae4d2c3e$export$14c0a92c01180ed4, this.onWordPaste, this);
        this.observer.on($ee11fb99ae4d2c3e$export$586814fbf9e806f, this.onBegin, this);
        this.observer.on($ee11fb99ae4d2c3e$export$c9576abd961512a2, this.editorMouseDown, this);
        this.observer.on($ee11fb99ae4d2c3e$export$31bf7b39daf71c67, this.destroy, this);
    };
    EditorManager.prototype.unwireEvents = function() {
        this.observer.off($ee11fb99ae4d2c3e$export$a80636c6f41931fe, this.editorKeyDown);
        this.observer.off($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp);
        this.observer.off($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp);
        this.observer.off($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, this.onPropertyChanged);
        this.observer.off($ee11fb99ae4d2c3e$export$14c0a92c01180ed4, this.onWordPaste);
        this.observer.off($ee11fb99ae4d2c3e$export$586814fbf9e806f, this.onBegin);
        this.observer.off($ee11fb99ae4d2c3e$export$c9576abd961512a2, this.editorMouseDown);
        this.observer.off($ee11fb99ae4d2c3e$export$31bf7b39daf71c67, this.destroy);
    };
    EditorManager.prototype.onWordPaste = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$197fda2d47388ee9, e);
    };
    EditorManager.prototype.onPropertyChanged = function(props) {
        this.observer.notify($ee11fb99ae4d2c3e$export$230373593f042ef0, props);
    };
    EditorManager.prototype.editorKeyDown = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$76852bc82d3e273b, e);
    };
    EditorManager.prototype.editorKeyUp = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, e);
    };
    EditorManager.prototype.onBegin = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$22b6648d4944f9ee, e);
    };
    /* eslint-disable */ /**
     * execCommand
     *
     * @param {ExecCommand} command - specifies the execution command
     * @param {T} value - specifes the value.
     * @param {Event} event - specifies the call back event
     * @param {Function} callBack - specifies the function
     * @param {string} text - specifies the string value
     * @param {T} exeValue - specifies the values to be executed
     * @param {string} selector - specifies the selector values
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ EditorManager.prototype.execCommand = function(command, value, event, callBack, text, exeValue, selector, enterAction) {
        switch(command.toLowerCase()){
            case "lists":
                this.observer.notify($ee11fb99ae4d2c3e$export$22c50a44ec8aa5dd, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector,
                    item: exeValue,
                    enterAction: enterAction
                });
                break;
            case "formats":
                this.observer.notify($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector,
                    exeValue: exeValue,
                    enterAction: enterAction
                });
                break;
            case "alignments":
                this.observer.notify($56b963295b740d00$export$d79d483636d4477c, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector,
                    value: exeValue,
                    enterAction: enterAction
                });
                break;
            case "indents":
                this.observer.notify($56b963295b740d00$export$303836d45647271d, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector,
                    enterAction: enterAction
                });
                break;
            case "links":
                this.observer.notify($56b963295b740d00$export$b395009ca7f092c7, {
                    command: command,
                    value: value,
                    item: exeValue,
                    event: event,
                    callBack: callBack
                });
                break;
            case "files":
                this.observer.notify($56b963295b740d00$export$74f94c628b84d921, {
                    command: command,
                    value: "Image",
                    item: exeValue,
                    event: event,
                    callBack: callBack,
                    selector: selector
                });
                break;
            case "images":
                this.observer.notify($56b963295b740d00$export$74f94c628b84d921, {
                    command: command,
                    value: value,
                    item: exeValue,
                    event: event,
                    callBack: callBack,
                    selector: selector
                });
                break;
            case "audios":
                this.observer.notify($56b963295b740d00$export$27a341487b23f48f, {
                    command: command,
                    value: value,
                    item: exeValue,
                    event: event,
                    callBack: callBack,
                    selector: selector
                });
                break;
            case "videos":
                this.observer.notify($56b963295b740d00$export$f3657d8d6be09c14, {
                    command: command,
                    value: value,
                    item: exeValue,
                    event: event,
                    callBack: callBack,
                    selector: selector
                });
                break;
            case "table":
                switch(value.toString().toLocaleLowerCase()){
                    case "createtable":
                        this.observer.notify($56b963295b740d00$export$88a597d0c7ae97b, {
                            item: exeValue,
                            event: event,
                            callBack: callBack,
                            enterAction: enterAction
                        });
                        break;
                    case "insertrowbefore":
                    case "insertrowafter":
                        this.observer.notify($56b963295b740d00$export$4f907db68c03b38f, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "insertcolumnleft":
                    case "insertcolumnright":
                        this.observer.notify($56b963295b740d00$export$90f8dc07e17eff78, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "deleterow":
                        this.observer.notify($56b963295b740d00$export$bbc7b4de7639a0e6, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "deletecolumn":
                        this.observer.notify($56b963295b740d00$export$8257751f67095555, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "tableremove":
                        this.observer.notify($56b963295b740d00$export$bd1f6cc7291d4cf1, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "tableheader":
                        this.observer.notify($56b963295b740d00$export$8f899c1b459a778c, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "aligntop":
                    case "alignmiddle":
                    case "alignbottom":
                        this.observer.notify($56b963295b740d00$export$88d20efa8d21dfb9, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "merge":
                        this.observer.notify($56b963295b740d00$export$ca0fb188aaf9f2cf, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "horizontalsplit":
                        this.observer.notify($56b963295b740d00$export$a4764f7dc1ebaae7, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                    case "verticalsplit":
                        this.observer.notify($56b963295b740d00$export$2a47f47b618178e4, {
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                }
                break;
            case "font":
            case "style":
            case "effects":
            case "casing":
                this.observer.notify($56b963295b740d00$export$96527b3d022fe7df, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    value: text,
                    selector: selector,
                    enterAction: enterAction
                });
                break;
            case "inserthtml":
                this.observer.notify($56b963295b740d00$export$3eeeec04b2c6224, {
                    subCommand: value,
                    callBack: callBack,
                    value: text,
                    enterAction: enterAction
                });
                break;
            case "inserttext":
                this.observer.notify($56b963295b740d00$export$d5e6ccd3e4d93c9b, {
                    subCommand: value,
                    callBack: callBack,
                    value: text
                });
                break;
            case "clear":
                this.observer.notify($56b963295b740d00$export$556ae66def187bfd, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector,
                    enterAction: enterAction
                });
                break;
            case "actions":
                this.observer.notify($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    selector: selector
                });
                break;
            case "formatpainter":
                this.observer.notify($ee11fb99ae4d2c3e$export$c234d9c0576b5f9a, {
                    item: exeValue,
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "emojipicker":
                this.observer.notify($ee11fb99ae4d2c3e$export$bb3de268509fc258, {
                    item: exeValue,
                    subCommand: value,
                    value: text,
                    event: event,
                    callBack: callBack
                });
        }
    };
    EditorManager.prototype.editorMouseDown = function(e) {
        if (e.args.detail === 3) this.tripleClickSelection(e.args);
    };
    EditorManager.prototype.tripleClickSelection = function(e) {
        var range = this.nodeSelection.getRange(this.currentDocument);
        var selection = this.nodeSelection.get(this.currentDocument);
        if (selection.rangeCount > 0 && selection.toString() !== "") {
            var startBlockNode = this.getParentBlockNode(range.startContainer);
            var endBlockNode = this.getParentBlockNode(range.endContainer);
            if (startBlockNode && endBlockNode && startBlockNode === endBlockNode) {
                var newRange = this.currentDocument.createRange();
                var startTextNode = this.getFirstTextNode(startBlockNode);
                var endTextNode = this.getLastTextNode(endBlockNode);
                if (startTextNode && endTextNode) {
                    newRange.setStart(startTextNode, 0);
                    newRange.setEnd(endTextNode, endTextNode.textContent.length);
                    this.nodeSelection.setRange(this.currentDocument, newRange);
                    e.preventDefault();
                }
            }
        }
    };
    EditorManager.prototype.getParentBlockNode = function(node) {
        var treeWalker = this.currentDocument.createTreeWalker(this.editableElement, NodeFilter.SHOW_ELEMENT, {
            acceptNode: function(currentNode) {
                // Check if the node is a block element
                var displayStyle = window.getComputedStyle(currentNode).display;
                if (displayStyle.indexOf("inline") < 0) return NodeFilter.FILTER_ACCEPT;
                else return NodeFilter.FILTER_SKIP;
            }
        });
        treeWalker.currentNode = node;
        var blockParent = treeWalker.parentNode();
        return blockParent;
    };
    EditorManager.prototype.getLastTextNode = function(node) {
        var treeWalker = this.currentDocument.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
        var lastTextNode = null;
        var currentNode = treeWalker.nextNode();
        while(currentNode){
            lastTextNode = currentNode;
            currentNode = treeWalker.nextNode();
        }
        return lastTextNode;
    };
    EditorManager.prototype.getFirstTextNode = function(node) {
        var treeWalker = this.currentDocument.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
        var firstTextNode = treeWalker.nextNode();
        return firstTextNode;
    };
    EditorManager.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.unwireEvents();
        this.observer.notify($ee11fb99ae4d2c3e$export$71d691dc2f49a346);
        if (this.editableElement) this.editableElement = null;
        this.currentDocument = null;
        if (this.nodeCutter) this.nodeCutter = null;
        if (this.domNode) this.domNode = null;
        if (this.listObj) this.listObj = null;
        if (this.formatObj) this.formatObj = null;
        if (this.alignmentObj) this.alignmentObj = null;
        if (this.indentsObj) this.indentsObj = null;
        if (this.linkObj) this.linkObj = null;
        if (this.imgObj) this.imgObj = null;
        if (this.audioObj) this.audioObj = null;
        if (this.videoObj) this.videoObj = null;
        if (this.selectionObj) this.selectionObj = null;
        if (this.inserthtmlObj) this.inserthtmlObj = null;
        if (this.insertTextObj) this.insertTextObj = null;
        if (this.clearObj) this.clearObj = null;
        if (this.tableObj) this.tableObj = null;
        if (this.msWordPaste) this.msWordPaste = null;
        if (this.formatPainterEditor) this.formatPainterEditor = null;
        if (this.emojiPickerObj) this.emojiPickerObj = null;
        if (this.tableCellSelection) this.tableCellSelection = null;
        this.isDestroyed = true;
    };
    EditorManager.prototype.beforeSlashMenuApplyFormat = function() {
        var currentRange = this.nodeSelection.getRange(this.currentDocument);
        var node = this.nodeSelection.getNodeCollection(currentRange)[0];
        var startPoint = currentRange.startOffset;
        while(this.nodeSelection.getRange(document).toString().indexOf("/") === -1){
            this.nodeSelection.setSelectionText(document, node, node, startPoint, currentRange.endOffset);
            startPoint--;
        }
        var slashRange = this.nodeSelection.getRange(this.currentDocument);
        var slashNode = this.nodeCutter.GetSpliceNode(slashRange, node);
        var previouNode = slashNode.previousSibling;
        if (slashNode.parentElement && slashNode.parentElement.innerHTML.length === 1) slashNode.parentElement.appendChild(document.createElement("br"));
        slashNode.parentNode.removeChild(slashNode);
        if (previouNode) this.nodeSelection.setCursorPoint(document, previouNode, previouNode.textContent.length);
    };
    return EditorManager;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

var $e716a16ba77f9b61$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * HTML adapter
 *
 * @hidden

 */ var $e716a16ba77f9b61$export$fd3b937a11f1074e = /** @class */ function(_super) {
    $e716a16ba77f9b61$var$__extends(HTMLFormatter, _super);
    function HTMLFormatter(options) {
        var _this = _super.call(this) || this;
        _this.initialize();
        (0, $3EnZW.extend)(_this, _this, options, true);
        if (_this.currentDocument && _this.element) _this.updateFormatter(_this.element, _this.currentDocument, options.options, options.formatPainterSettings);
        return _this;
    }
    HTMLFormatter.prototype.initialize = function() {
        this.keyConfig = (0, $9dc0015271a44eb1$export$67e31f1c194fcbe6);
    };
    /**
     * Update the formatter of RichTextEditor
     *
     * @param {Element} editElement - specifies the edit element.
     * @param {Document} doc - specifies the doucment
     * @param {number} options - specifies the options
     * @param {FormatPainterSettingsModel} formatPainterSettings - specifies the format painter settings
     * @returns {void}
     * @hidden

     */ HTMLFormatter.prototype.updateFormatter = function(editElement, doc, options, formatPainterSettings) {
        if (editElement && doc) this.editorManager = new (0, $f9047ee5aba07026$export$18002c264c39dab4)({
            document: doc,
            editableElement: editElement,
            options: options,
            formatPainterSettings: formatPainterSettings
        });
    };
    return HTMLFormatter;
}((0, $b3bddae4b7750825$export$a06636add2a09fd8));









parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $58a5a5299a589153$export$4977dcb254d3a725 = (0, $259257662ca103fc$export$9f385661c3e974c1)();
var $58a5a5299a589153$export$43229ac8f78c6cea = /** @class */ function() {
    function ToolbarStatus() {}
    /**
     * get method
     *
     * @param {Document} docElement - specifies the document element
     * @param {Node} rootNode - specifies the content editable element
     * @param {string[]} formatNode - specifies the format node
     * @param {string[]} fontSize - specifies the font size
     * @param {string[]} fontName - specifies the font name.
     * @param {Node} documentNode - specifies the document node.
     * @returns {IToolbarStatus} - returns the toolbar status
     * @hidden

     */ ToolbarStatus.get = function(docElement, rootNode, formatNode, fontSize, fontName, documentNode) {
        var formatCollection = JSON.parse(JSON.stringify($58a5a5299a589153$export$4977dcb254d3a725));
        var nodeCollection = JSON.parse(JSON.stringify($58a5a5299a589153$export$4977dcb254d3a725));
        var nodeSelection = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        var range = nodeSelection.getRange(docElement);
        var nodes = documentNode ? [
            documentNode
        ] : range.collapsed ? nodeSelection.getNodeCollection(range) : nodeSelection.getSelectionNodeCollectionBr(range);
        var nodesLength = nodes.length;
        var isNodeChanged = false;
        for(var index = 0; index < nodes.length; index++){
            while(nodes[index].nodeType === 3 && range.startContainer.nodeType === 3 && nodes[index].parentNode && nodes[index].parentNode.lastElementChild && nodes[index].parentNode.lastElementChild.nodeName !== "BR" && this.getImmediateBlockNode(nodes[index].parentNode).textContent.replace(/\u200B/g, "").length === 0 && range.startContainer.textContent.replace(/\u200B/g, "").length === 0 && nodeSelection.get(docElement).toString().replace(/\u200B/g, "").length === 0){
                nodes[index] = nodes[index].parentNode.lastElementChild.firstChild;
                isNodeChanged = true;
            }
            if (isNodeChanged && nodes[index]) {
                nodeSelection.setCursorPoint(docElement, nodes[index], nodes[index].textContent.length);
                isNodeChanged = false;
            }
            if (nodes[index].nodeName !== "BR" && nodes[index].nodeType !== 3 || nodesLength > 1 && nodes[index].nodeType === 3 && nodes[index].textContent.trim() === "") {
                nodes.splice(index, 1);
                index--;
            }
        }
        for(var index = 0; index < nodes.length; index++){
            // eslint-disable-next-line max-len
            formatCollection = this.getFormatParent(docElement, formatCollection, nodes[index], rootNode, formatNode, fontSize, fontName);
            if (index === 0 && formatCollection.bold || !formatCollection.bold) nodeCollection.bold = formatCollection.bold;
            if (index === 0 && formatCollection.insertcode || !formatCollection.insertcode) nodeCollection.insertcode = formatCollection.insertcode;
            if (index === 0 && formatCollection.blockquote || !formatCollection.blockquote) nodeCollection.blockquote = formatCollection.blockquote;
            if (index === 0 && formatCollection.italic || !formatCollection.italic) nodeCollection.italic = formatCollection.italic;
            if (index === 0 && formatCollection.underline || !formatCollection.underline) nodeCollection.underline = formatCollection.underline;
            if (index === 0 && formatCollection.strikethrough || !formatCollection.strikethrough) nodeCollection.strikethrough = formatCollection.strikethrough;
            if (index === 0 && formatCollection.superscript || !formatCollection.superscript) nodeCollection.superscript = formatCollection.superscript;
            if (index === 0 && formatCollection.subscript || !formatCollection.subscript) nodeCollection.subscript = formatCollection.subscript;
            if (index === 0 && formatCollection.fontcolor || !formatCollection.fontcolor) nodeCollection.fontcolor = formatCollection.fontcolor;
            if (index === 0 && formatCollection.fontname) nodeCollection.fontname = formatCollection.fontname;
            else nodeCollection.fontname = formatCollection.fontname === nodeCollection.fontname ? formatCollection.fontname : "empty";
            if (index === 0 && formatCollection.fontsize) nodeCollection.fontsize = formatCollection.fontsize;
            else nodeCollection.fontsize = formatCollection.fontsize === nodeCollection.fontsize ? formatCollection.fontsize : "empty";
            if (index === 0 && formatCollection.backgroundcolor || !formatCollection.backgroundcolor) nodeCollection.backgroundcolor = formatCollection.backgroundcolor;
            if (index === 0 && formatCollection.orderedlist || !formatCollection.orderedlist) nodeCollection.orderedlist = formatCollection.orderedlist;
            if (index === 0 && formatCollection.unorderedlist || !formatCollection.unorderedlist) nodeCollection.unorderedlist = formatCollection.unorderedlist;
            if (index === 0 && formatCollection.alignments || !formatCollection.alignments) nodeCollection.alignments = formatCollection.alignments;
            if (index === 0 && formatCollection.formats) nodeCollection.formats = formatCollection.formats;
            else nodeCollection.formats = formatCollection.formats === nodeCollection.formats ? formatCollection.formats : "empty";
            if (index === 0 && formatCollection.createlink || !formatCollection.createlink) nodeCollection.createlink = formatCollection.createlink;
            if (index === 0 && formatCollection.numberFormatList || !formatCollection.numberFormatList) nodeCollection.numberFormatList = formatCollection.numberFormatList;
            if (index === 0 && formatCollection.bulletFormatList || !formatCollection.bulletFormatList) nodeCollection.bulletFormatList = formatCollection.bulletFormatList;
            if (index === 0 && formatCollection.inlinecode || !formatCollection.inlinecode) nodeCollection.inlinecode = formatCollection.inlinecode;
            formatCollection = JSON.parse(JSON.stringify($58a5a5299a589153$export$4977dcb254d3a725));
        }
        return nodeCollection;
    };
    ToolbarStatus.getImmediateBlockNode = function(node) {
        do node = node.parentNode;
        while (node && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(node.nodeName.toLocaleLowerCase()) < 0);
        return node;
    };
    ToolbarStatus.getFormatParent = function(docElement, formatCollection, node, targetNode, formatNode, fontSize, fontName) {
        var isListUpdated = false;
        var isComplexListUpdated = false;
        if (targetNode.contains(node) || node.nodeType === 3 && targetNode.nodeType !== 3 && targetNode.contains(node.parentNode)) do {
            formatCollection = this.isFormattedNode(docElement, formatCollection, node, isListUpdated, isComplexListUpdated, formatNode, fontSize, fontName);
            if (formatCollection.orderedlist || formatCollection.unorderedlist) isListUpdated = true;
            if (formatCollection.bulletFormatList || formatCollection.numberFormatList) isComplexListUpdated = true;
            node = node.parentNode;
        }while (node && node !== targetNode);
        return formatCollection;
    };
    ToolbarStatus.isFormattedNode = function(docElement, formatCollection, node, isListUpdated, isComplexListUpdated, formatNode, fontSize, fontName) {
        if (!formatCollection.bold) formatCollection.bold = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isBold(node);
        if (!formatCollection.italic) formatCollection.italic = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isItalic(node);
        if (!formatCollection.underline) formatCollection.underline = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isUnderline(node);
        if (!formatCollection.strikethrough) formatCollection.strikethrough = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isStrikethrough(node);
        if (!formatCollection.superscript) formatCollection.superscript = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isSuperscript(node);
        if (!formatCollection.subscript) formatCollection.subscript = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isSubscript(node);
        if (!formatCollection.fontcolor) formatCollection.fontcolor = this.isFontColor(docElement, node);
        if (!formatCollection.fontname) formatCollection.fontname = this.isFontName(docElement, node, fontName);
        if (!formatCollection.fontsize) formatCollection.fontsize = this.isFontSize(docElement, node, fontSize);
        if (!formatCollection.backgroundcolor) formatCollection.backgroundcolor = this.isBackgroundColor(node);
        if (!formatCollection.orderedlist && !isListUpdated) formatCollection.orderedlist = this.isOrderedList(node);
        if (!formatCollection.unorderedlist && !isListUpdated) formatCollection.unorderedlist = this.isUnorderedList(node);
        if (!formatCollection.alignments) formatCollection.alignments = this.isAlignment(node);
        if (!formatCollection.formats) {
            formatCollection.formats = this.isFormats(node, formatNode);
            if (formatCollection.formats === "pre") formatCollection.insertcode = true;
        }
        if (!formatCollection.blockquote) {
            var currentFormatCollection = void 0;
            if (!(0, $3EnZW.isNullOrUndefined)(formatNode)) {
                if (formatNode.indexOf("blockquote") > -1) {
                    formatCollection.formats = this.isFormats(node, formatNode);
                    currentFormatCollection = formatCollection.formats;
                } else {
                    formatNode.push("blockquote");
                    currentFormatCollection = this.isFormats(node, formatNode);
                    for(var i = formatNode.length - 1; i >= 0; i--)if (formatNode[i] === "blockquote") formatNode.splice(i, 1);
                }
            }
            if (currentFormatCollection === "blockquote") formatCollection.blockquote = true;
        }
        if (!formatCollection.createlink) formatCollection.createlink = this.isLink(node);
        if (!formatCollection.numberFormatList && !isComplexListUpdated) formatCollection.numberFormatList = this.isNumberFormatList(node);
        if (!formatCollection.bulletFormatList && !isComplexListUpdated) formatCollection.bulletFormatList = this.isBulletFormatList(node);
        if (!formatCollection.inlinecode) formatCollection.inlinecode = (0, $fc5331de40b32b1d$export$cfa313d0a8d98bda).isCode(node);
        return formatCollection;
    };
    ToolbarStatus.isFontColor = function(docElement, node) {
        var color = node.style && node.style.color;
        if ((color === null || color === undefined || color === "") && node.nodeType !== 3) color = this.getComputedStyle(docElement, node, "color");
        if (color !== null && color !== "" && color !== undefined) return color;
        else return null;
    };
    ToolbarStatus.isLink = function(node) {
        if (node.nodeName.toLocaleLowerCase() === "a") return true;
        else return false;
    };
    ToolbarStatus.isBackgroundColor = function(node) {
        var backColor = node.style && node.style.backgroundColor;
        if (backColor !== null && backColor !== "" && backColor !== undefined) return backColor;
        else return null;
    };
    ToolbarStatus.isFontSize = function(docElement, node, fontSize) {
        var size = node.style && node.style.fontSize;
        if ((size === null || size === undefined || size === "") && node.nodeType !== 3 && node.parentElement.classList.contains("e-content")) size = this.getComputedStyle(docElement, node, "font-size");
        if (size !== null && size !== "" && size !== undefined && (fontSize === null || fontSize === undefined || fontSize.indexOf(size) > -1)) return size;
        else return null;
    };
    ToolbarStatus.isFontName = function(docElement, node, fontName) {
        var name = node.style && node.style.fontFamily;
        if ((name === null || name === undefined || name === "") && node.nodeType !== 3) name = this.getComputedStyle(docElement, node, "font-family");
        var index = null;
        if (name !== null && name !== "" && name !== undefined && (fontName === null || fontName === undefined || fontName.filter(function(value, pos) {
            var regExp = RegExp;
            var pattern = new regExp(name, "i");
            if (value.replace(/"/g, "").replace(/ /g, "").toLowerCase() === name.replace(/"/g, "").replace(/ /g, "").toLowerCase() || value.split(",")[0] && !(0, $3EnZW.isNullOrUndefined)(value.split(",")[0].trim().match(pattern)) && value.split(",")[0].trim() === value.split(",")[0].trim().match(pattern)[0]) index = pos;
        }) && index !== null)) return index !== null ? fontName[index] : name.replace(/"/g, "");
        else return null;
    };
    ToolbarStatus.isOrderedList = function(node) {
        if (node.nodeName.toLocaleLowerCase() === "ol") return true;
        else return false;
    };
    ToolbarStatus.isUnorderedList = function(node) {
        if (node.nodeName.toLocaleLowerCase() === "ul") return true;
        else return false;
    };
    ToolbarStatus.isAlignment = function(node) {
        var align = node.style && node.style.textAlign;
        if (align === "left") return "justifyleft";
        else if (align === "center") return "justifycenter";
        else if (align === "right") return "justifyright";
        else if (align === "justify") return "justifyfull";
        else return null;
    };
    ToolbarStatus.isFormats = function(node, formatNode) {
        if ((formatNode === undefined || formatNode === null) && $56b963295b740d00$export$d8e31d963c9fa6cb.indexOf(node.nodeName.toLocaleLowerCase()) > -1 || formatNode !== null && formatNode !== undefined && formatNode.indexOf(node.nodeName.toLocaleLowerCase()) > -1) return node.nodeName.toLocaleLowerCase();
        else return null;
    };
    ToolbarStatus.getComputedStyle = function(docElement, node, prop) {
        return docElement.defaultView.getComputedStyle(node, null).getPropertyValue(prop);
    };
    ToolbarStatus.isNumberFormatList = function(node) {
        var list = node.style && node.style.listStyleType;
        if (list === "lower-alpha") return "Lower Alpha";
        else if (list === "number") return "Number";
        else if (list === "upper-alpha") return "Upper Alpha";
        else if (list === "lower-roman") return "Lower Roman";
        else if (list === "upper-roman") return "Upper Roman";
        else if (list === "lower-greek") return "Lower Greek";
        else if (list === "none") return "None";
        else if (this.isOrderedList(node)) return true;
        else return null;
    };
    ToolbarStatus.isBulletFormatList = function(node) {
        var list = node.style && node.style.listStyleType;
        if (list === "circle") return "Circle";
        else if (list === "square") return "Square";
        else if (list === "none") return "None";
        else if (list === "disc") return "Disc";
        else if (this.isUnorderedList(node)) return true;
        else return null;
    };
    return ToolbarStatus;
}();



/**
 * HtmlToolbarStatus module for refresh the toolbar status
 */ var $d2002c76fe025874$export$985c0ddff8a9cc89 = /** @class */ function() {
    function HtmlToolbarStatus(parent) {
        this.parent = parent;
        this.toolbarStatus = this.prevToolbarStatus = (0, $259257662ca103fc$export$9f385661c3e974c1)();
        this.addEventListener();
    }
    HtmlToolbarStatus.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$6a017cfaa3b33c68, this.onRefreshHandler, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
    };
    HtmlToolbarStatus.prototype.removeEventListener = function() {
        this.toolbarStatus = null;
        this.prevToolbarStatus = null;
        this.parent.off($947a002e9a697770$export$6a017cfaa3b33c68, this.onRefreshHandler);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
    };
    HtmlToolbarStatus.prototype.onRefreshHandler = function(args) {
        if (this.parent.readonly) return;
        var fontsize = [];
        var fontName = [];
        var formats = [];
        this.parent.fontSize.items.forEach(function(item) {
            fontsize.push(item.value);
        });
        this.parent.fontFamily.items.forEach(function(item) {
            fontName.push(item.value);
        });
        this.parent.format.types.forEach(function(item) {
            formats.push(item.value.toLocaleLowerCase());
        });
        this.toolbarStatus = (0, $58a5a5299a589153$export$43229ac8f78c6cea).get(this.parent.contentModule.getDocument(), this.parent.contentModule.getEditPanel(), formats, fontsize, fontName, args.documentNode);
        var tbStatusString = JSON.stringify(this.toolbarStatus);
        this.parent.notify($947a002e9a697770$export$209bc394f8eec6dc, this.toolbarStatus);
        if (JSON.stringify(this.prevToolbarStatus) !== tbStatusString) {
            this.parent.notify($947a002e9a697770$export$4755fca075b63809, {
                html: JSON.parse(tbStatusString),
                markdown: null
            });
            this.prevToolbarStatus = JSON.parse(tbStatusString);
        }
    };
    return HtmlToolbarStatus;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden

 */ var $5c966c61f6f4d3b0$export$6e65718da26e0698 = /** @class */ function() {
    /**
     * Constructor for content renderer module
     *
     * @param {IRichTextEditor} parent - specifies the parent element.
     */ function ContentRender(parent) {
        this.parent = parent;
    }
    /**
     * The function is used to render Rich Text Editor content div
     *
     * @returns {void}
     * @hidden

     */ ContentRender.prototype.renderPanel = function() {
        var rteObj = this.parent;
        var div = this.parent.createElement("div", {
            className: "e-rte-content",
            id: this.parent.getID() + "rte-view"
        });
        var rteContent = (0, $c77ecbfae9b8c035$export$4649c1610e50ca8d)(rteObj.value, rteObj);
        this.editableElement = this.parent.createElement("div", {
            className: "e-content",
            id: this.parent.getID() + "_rte-edit-view",
            attrs: {
                "contenteditable": "true"
            }
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontFamily.default)) this.editableElement.style.fontFamily = this.parent.fontFamily.default;
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontSize.default)) this.editableElement.style.fontSize = this.parent.fontSize.default;
        this.editableElement.innerHTML = rteContent;
        div.appendChild(this.editableElement);
        this.setPanel(div);
        rteObj.rootContainer.appendChild(div);
    };
    /**
     * Get the content div element of RichTextEditor
     *
     * @returns {Element} - specifies the element.
     * @hidden

     */ ContentRender.prototype.getPanel = function() {
        return this.contentPanel;
    };
    /**
     * Get the editable element of RichTextEditor
     *
     * @returns {Element} - specifies the return element.
     * @hidden

     */ ContentRender.prototype.getEditPanel = function() {
        return this.editableElement;
    };
    /**
     * Returns the text content as string.
     *
     * @returns {string} - specifies the string element.
     */ ContentRender.prototype.getText = function() {
        var textString = this.getEditPanel().innerText;
        return textString === "\n" ? "" : textString;
    };
    /**
     * Set the content div element of RichTextEditor
     *
     * @param {Element} panel - specifies the panel element.
     * @returns {void}
     * @hidden

     */ ContentRender.prototype.setPanel = function(panel) {
        this.contentPanel = panel;
    };
    /**
     * Get the document of RichTextEditor
     *
     * @returns {Document} - specifies the document.
     * @hidden

     */ ContentRender.prototype.getDocument = function() {
        return this.getEditPanel().ownerDocument;
    };
    return ContentRender;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

var $c0a94f196797148a$export$d82a022e3dec174f = '\n@charset "UTF-8";\n\nhtml {\n    height: auto;\n}\n\nhtml, body {\n    margin: 0;\n}\n\nbody {\n    color: #333;\n    word-wrap: break-word;\n}\n\n.e-content {\n    background: unset;\n    box-sizing: border-box;\n    min-height: 100px;\n    outline: 0 solid transparent;\n    padding: 16px;\n    position: relative;\n    overflow-x: auto;\n    font-weight: normal;\n    line-height: 1.5;\n    font-size: 14px;\n    text-align: inherit;\n    font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif", "-apple-system", "BlinkMacSystemFont";\n}\n\n.e-content p {\n    margin: 0 0 10px;\n    margin-bottom: 10px;\n}\n\n.e-content h1 {\n    font-size: 2.857em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 10px 0;\n}\n\n.e-content h2 {\n    font-size: 2.285em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 10px 0;\n}\n\n.e-content h3 {\n    font-size: 2em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 10px 0;\n}\n\n.e-content h4 {\n    font-size: 1.714em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 10px 0;\n}\n\n.e-content h5 {\n    font-size: 1.428em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 10px 0;\n}\n\n.e-content h6 {\n    font-size: 1.142em;\n    font-weight: 600;\n    line-height: 1.5;\n    margin: 10px 0;\n}\n\n.e-content blockquote {\n    margin: 10px 0;\n    padding-left: 12px;\n    border-left: 2px solid #5c5c5c;\n}\n\n.e-rtl.e-content blockquote {\n    padding-left: 0;\n    padding-right: 12px;\n}\n\n.e-content pre {\n    border: 0;\n    border-radius: 0;\n    color: #333;\n    font-size: inherit;\n    line-height: inherit;\n    margin: 0 0 10px;\n    overflow: visible;\n    padding: 0;\n    white-space: pre-wrap;\n    word-break: inherit;\n    word-wrap: break-word;\n}\n\n.e-content code {\n    background: #9d9d9d26;\n    color: #ed484c;\n}\n\n.e-content strong,\n.e-content b {\n    font-weight: bold;\n}\n\n.e-content a {\n    text-decoration: none;\n    user-select: auto;\n}\n\n.e-content a:hover {\n    text-decoration: underline;\n}\n\n.e-content li {\n    margin-bottom: 10px;\n}\n\n.e-content li ol,\n.e-content li ul {\n    margin-block-start: 10px;\n}\n\n.e-content ul {\n    list-style-type: disc;\n}\n\n.e-content ul ul,\n.e-content ol ul {\n    list-style-type: circle;\n}\n\n.e-content ul ul ul,\n.e-content ol ul ul,\n.e-content ul ol ul,\n.e-content ol ol ul {\n    list-style-type: square;\n}\n\n.e-rte-image,\n.e-rte-video {\n    border: 0;\n    cursor: pointer;\n    display: block;\n    float: none;\n    height: auto;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-content p:last-child,\n.e-content pre:last-child,\n.e-content blockquote:last-child {\n    margin-bottom: 0;\n}\n\n.e-content h3 + h4,\n.e-content h4 + h5,\n.e-content h5 + h6 {\n    margin-top: 0.6em;\n}\n\n.e-content ul:last-child {\n    margin-bottom: 0;\n}\n\n.e-content table {\n    margin-bottom: 10px;\n    border-collapse: collapse;\n    empty-cells: show;\n}\n\n.e-content table.e-cell-select {\n    position: relative;\n}\n\n.e-content table.e-cell-select::after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 2px solid #4a90e2;\n    pointer-events: none;\n}\n\ntable .e-cell-select {\n    border: 1px double #4a90e2 !important;\n}\n\n.e-content table.e-rte-table th {\n    background-color: #E0E0E0;\n}\n\n.e-rte-table td,\n.e-rte-table th {\n    border: 1px solid #BDBDBD;\n    height: 20px;\n    min-width: 20px;\n    padding: 2px 5px;\n    box-sizing: border-box;\n}\n\n.e-rte-table td.e-cell-select.e-multi-cells-select,\n.e-rte-table th.e-cell-select.e-multi-cells-select {\n    position: relative;\n}\n\n.e-rte-table td.e-cell-select.e-multi-cells-select::after,\n.e-rte-table th.e-cell-select.e-multi-cells-select::after {\n    background-color: rgba(13, 110, 253, 0.08);\n    content: "";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    bottom: 0;\n    pointer-events: none;\n    right: 0;\n}\n\ntable td.e-multi-cells-select ::selection,\ntable th.e-multi-cells-select ::selection {\n    background-color: transparent;\n}\n\ntd.e-multi-cells-select,\nth.e-multi-cells-select {\n    user-select: none !important;\n}\n\n.e-rte-table.e-dashed-border td,\n.e-rte-table.e-dashed-border th {\n    border-style: dashed;\n}\n\n.e-rte-table .e-alternate-border tbody tr:nth-child(2n) {\n    background-color: #F5F5F5;\n}\n\n.e-rte-audio {\n    border: 0;\n    cursor: pointer;\n    display: block;\n    float: none;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-rte-image.e-imginline,\n.e-rte-audio.e-audio-inline,\n.e-rte-video.e-video-inline {\n    display: inline-block;\n    float: none;\n    margin-left: 5px;\n    margin-right: 5px;\n    max-width: calc(100% - (2 * 5px));\n    padding: 1px;\n    vertical-align: bottom;\n}\n\n.e-rte-image.e-imgcenter,\n.e-rte-video.e-video-center {\n    cursor: pointer;\n    display: block;\n    float: none;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-rte-image.e-imgright,\n.e-rte-video.e-video-right {\n    float: right;\n    margin: 0 auto;\n    margin-left: 5px;\n    text-align: right;\n}\n\n.e-rte-image.e-imgleft,\n.e-rte-video.e-video-left {\n    float: left;\n    margin: 0 auto;\n    margin-right: 5px;\n    text-align: left;\n}\n\n.e-img-caption {\n    display: inline-block;\n    float: none;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-img-caption.e-caption-inline {\n    display: inline-block;\n    float: none;\n    margin: 5px auto;\n    margin-left: 5px;\n    margin-right: 5px;\n    max-width: calc(100% - (2 * 5px));\n    position: relative;\n    text-align: center;\n    vertical-align: bottom;\n}\n\n.e-rte-img-caption.e-imgcenter {\n    display: contents;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.e-rte-img-caption.e-imgright {\n    display: contents;\n    margin-left: auto;\n    margin-right: 0;\n}\n\n.e-rte-img-caption.e-imgleft {\n    display: contents;\n    margin-left: 0;\n    margin-right: auto;\n}\n\n.e-img-caption.e-rte-img-caption.e-imgbreak {\n    display: contents;\n}\n\n.e-img-inner {\n    box-sizing: border-box;\n    display: block;\n    font-size: 16px;\n    font-weight: initial;\n    margin: auto;\n    opacity: .9;\n    text-align: center;\n    width: 100%;\n}\n\n.e-img-wrap {\n    display: inline-block;\n    margin: auto;\n    padding: 0;\n    text-align: center;\n    width: 100%;\n}\n\n.e-imgleft,\n.e-video-left {\n    float: left;\n    margin: 0 5px 0 0;\n    text-align: left;\n}\n\n.e-imgright,\n.e-video-right {\n    float: right;\n    margin: 0 0 0 5px;\n    text-align: right;\n}\n\n.e-imgcenter,\n.e-video-center {\n    cursor: pointer;\n    display: block;\n    float: none;\n    height: auto;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-control img:not(.e-resize) {\n    border: 2px solid transparent;\n    z-index: 1000\n}\n\n.e-imginline,\n.e-audio-inline,\n.e-video-inline {\n    display: inline-block;\n    float: none;\n    margin-left: 5px;\n    margin-right: 5px;\n    max-width: calc(100% - (2 * 5px));\n    vertical-align: bottom;\n}\n\n.e-imgbreak,\n.e-audio-break,\n.e-video-break {\n    border: 0;\n    cursor: pointer;\n    display: block;\n    float: none;\n    height: auto;\n    margin: 5px auto;\n    max-width: 100%;\n    position: relative;\n}\n\n.e-rte-image.e-img-focus:not(.e-resize),\n.e-audio-focus:not(.e-resize),\n.e-video-focus:not(.e-resize) {\n    border: solid 2px #4a90e2;\n}\n\nimg.e-img-focus::selection,\naudio.e-audio-focus::selection,\n.e-video-focus::selection {\n    background: transparent;\n    color: transparent;\n}\n\nspan.e-rte-imageboxmark,\nspan.e-rte-videoboxmark {\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    display: block;\n    background: #4a90e2;\n    border: 1px solid #fff;\n    z-index: 1000;\n}\n\n.e-mob-rte.e-mob-span span.e-rte-imageboxmark,\n.e-mob-rte.e-mob-span span.e-rte-videoboxmark {\n    background: #4a90e2;\n    border: 1px solid #fff;\n}\n\n.e-mob-rte span.e-rte-imageboxmark,\n.e-mob-rte span.e-rte-videoboxmark {\n    background: #fff;\n    border: 1px solid #4a90e2;\n    border-radius: 15px;\n    height: 20px;\n    width: 20px;\n}\n\n.e-mob-rte.e-mob-span span.e-rte-imageboxmark,\n.e-mob-rte.e-mob-span span.e-rte-videoboxmark {\n    background: #4a90e2;\n    border: 1px solid #fff;\n}\n\n.e-content img.e-resize,\n.e-content video.e-resize {\n    z-index: 1000;\n}\n\n.e-img-caption .e-img-inner {\n    outline: 0;\n}\n\n.e-rte-img-caption.e-imgleft .e-img-inner {\n    float: left;\n    text-align: left;\n}\n\n.e-rte-img-caption.e-imgright .e-img-inner {\n    float: right;\n    text-align: right;\n}\n\n.e-rte-img-caption.e-imgleft .e-img-wrap,\n.e-rte-img-caption.e-imgright .e-img-wrap {\n    display: contents;\n}\n\n.e-img-caption a:focus-visible {\n    outline: none;\n}\n\n.e-rte-img-caption .e-rte-image.e-imgright {\n    margin-left: auto;\n    margin-right: 0;\n}\n\n.e-rte-img-caption .e-rte-image.e-imgleft {\n    margin: 0;\n}\n\nspan.e-table-box {\n    cursor: nwse-resize;\n    display: block;\n    height: 10px;\n    position: absolute;\n    width: 10px;\n    background-color: #ffffff;\n    border: 1px solid #BDBDBD;\n}\n\nspan.e-table-box.e-rmob {\n    height: 14px;\n    width: 14px;\n    background-color: #BDBDBD;\n    border: 1px solid #BDBDBD;\n}\n\n.e-row-resize,\n.e-column-resize {\n    background-color: transparent;\n    background-repeat: repeat;\n    bottom: 0;\n    cursor: col-resize;\n    height: 1px;\n    overflow: visible;\n    position: absolute;\n    width: 1px;\n}\n\n.e-row-resize {\n    cursor: row-resize;\n    height: 1px;\n}\n\n.e-table-rhelper {\n    cursor: col-resize;\n    opacity: .87;\n    position: absolute;\n}\n\n.e-table-rhelper.e-column-helper {\n    width: 1px;\n}\n\n.e-table-rhelper.e-row-helper {\n    height: 1px;\n}\n\n.e-reicon::before {\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid;\n    border-top: 6px solid transparent;\n    content: \'\';\n    display: block;\n    height: 0;\n    position: absolute;\n    right: 4px;\n    top: 4px;\n    width: 20px;\n}\n\n.e-reicon::after {\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid;\n    border-top: 6px solid transparent;\n    content: \'\';\n    display: block;\n    height: 0;\n    left: 4px;\n    position: absolute;\n    top: 4px;\n    width: 20px;\n    z-index: 3;\n}\n\n.e-row-helper.e-reicon::after {\n    top: 10px;\n    transform: rotate(90deg);\n}\n\n.e-row-helper.e-reicon::before {\n    left: 4px;\n    top: -20px;\n    transform: rotate(90deg);\n}\n\n\n.e-table-rhelper {\n    background-color: #4a90e2;\n}\n\n.e-rtl {\n    direction: rtl;\n}\n\n.e-rte-placeholder::before {\n    content: attr(placeholder);\n    opacity: 0.54;\n    overflow: hidden;\n    padding-top: 16px;\n    position: absolute;\n    text-align: start;\n    top: 0;\n    z-index: 1;\n}\n\n.e-resize-enabled,\n.e-count-enabled {\n    padding-bottom: 0px;\n}\n';


var $167cf0a6a9a35591$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $167cf0a6a9a35591$var$IFRAMEHEADER = "\n    <!DOCTYPE html> \n    <html>\n         <head>\n            <meta charset='utf-8' /> \n            <style>" + (0, $c0a94f196797148a$export$d82a022e3dec174f).replace(/[\n\t]/g, "") + "\n            </style>\n        </head>\n";
/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden

 */ var $167cf0a6a9a35591$export$4f29d334a579802c = /** @class */ function(_super) {
    $167cf0a6a9a35591$var$__extends(IframeContentRender, _super);
    function IframeContentRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The function is used to render Rich Text Editor iframe
     *
     * @hidden

     */ IframeContentRender.prototype.renderPanel = function() {
        var rteObj = this.parent;
        var rteContent = (0, $c77ecbfae9b8c035$export$4649c1610e50ca8d)(rteObj.value, rteObj);
        var iFrameBodyContent = '<body contenteditable="true">' + rteContent + "</body></html>";
        var iFrameContent = $167cf0a6a9a35591$var$IFRAMEHEADER + iFrameBodyContent;
        var iframe = this.parent.createElement("iframe", {
            id: this.parent.getID() + "_rte-view",
            className: "e-rte-content",
            attrs: {
                "srcdoc": iFrameContent
            }
        });
        iframe.setAttribute("role", "none");
        this.setPanel(iframe);
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.iframeSettings.sandbox)) {
            var sandboxValues = this.parent.iframeSettings.sandbox.map(function(element) {
                return element.toLocaleLowerCase().trim();
            }).join(" ");
            if (!sandboxValues.includes("allow-same-origin")) sandboxValues += " allow-same-origin";
            iframe.setAttribute("sandbox", sandboxValues.trim());
        }
        rteObj.rootContainer.appendChild(iframe);
        iframe.contentDocument.body.setAttribute("aria-owns", this.parent.getID());
        iframe.contentDocument.open();
        iFrameContent = this.setThemeColor(iFrameContent, {
            color: "#333"
        });
        iframe.contentDocument.write(iFrameContent);
        iframe.contentDocument.close();
        var body = iframe.contentDocument.body;
        body.className = "e-content";
        if (this.parent.height === "auto") body.style.overflowY = "hidden";
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontFamily.default)) body.style.fontFamily = this.parent.fontFamily.default;
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontSize.default)) body.style.fontSize = this.parent.fontSize.default;
        body.id = this.parent.getID() + "_rte-edit-view";
        if (rteObj.enableRtl) this.contentPanel.contentDocument.body.setAttribute("class", "e-rtl");
        if (!(0, $3EnZW.isNullOrUndefined)(iframe.contentDocument.head) && this.parent.iframeSettings.metaTags.length > 0) {
            var head_1 = iframe.contentDocument.head;
            var metaData = this.parent.iframeSettings.metaTags;
            metaData.forEach(function(tag) {
                var meta = document.createElement("meta");
                for(var key in tag)if (!(0, $3EnZW.isNullOrUndefined)(tag[key])) meta.setAttribute(key === "httpEquiv" ? "http-equiv" : key, tag[key]);
                head_1.appendChild(meta);
            });
        }
    };
    IframeContentRender.prototype.setThemeColor = function(content, styles) {
        var fontColor = getComputedStyle(this.parent.element, ".e-richtexteditor").getPropertyValue("color");
        return content.replace(styles.color, fontColor);
    };
    /**
     * Get the editable element of RichTextEditor
     *
     * @returns {Element} - specifies the element.
     * @hidden

     */ IframeContentRender.prototype.getEditPanel = function() {
        var editNode;
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentPanel.contentDocument)) editNode = this.contentPanel.contentDocument.body;
        else editNode = this.parent.inputElement;
        return editNode;
    };
    /**
     * Get the document of RichTextEditor
     *
     * @returns {void}
     * @hidden

     */ IframeContentRender.prototype.getDocument = function() {
        return this.getEditPanel().ownerDocument;
    };
    return IframeContentRender;
}((0, $5c966c61f6f4d3b0$export$6e65718da26e0698));








parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");
/**
 * XhtmlValidation module called when set enableXhtml as true
 */ var $157cc54a6a784f4a$export$2457b22d30aa88aa = /** @class */ function() {
    function XhtmlValidation(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    XhtmlValidation.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$76028e63d5b7a5cc, this.enableXhtmlValidation, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
    };
    XhtmlValidation.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$76028e63d5b7a5cc, this.enableXhtmlValidation);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
    };
    XhtmlValidation.prototype.enableXhtmlValidation = function() {
        if (this.parent.enableXhtml) {
            if ((0, $3EnZW.isNullOrUndefined)(this.parent.inputElement)) this.currentElement = this.parent.element;
            else this.currentElement = this.parent.inputElement;
            this.clean(this.currentElement);
            this.ImageTags();
            this.removeTags();
            this.RemoveUnsupported();
            this.currentElement.innerHTML = this.selfEncloseValidation(this.currentElement.innerHTML, this.currentElement.innerText === "\n" ? this.currentElement.innerText.length : this.currentElement.innerText.trim().length);
            this.parent.setProperties({
                value: this.currentElement.innerHTML
            }, true);
        }
    };
    /**
     * @param {string} currentValue - specifies the string value.
     * @param {number} valueLength - specifies the length of the current value.
     * @returns {void}

     */ XhtmlValidation.prototype.selfEncloseValidation = function(currentValue, valueLength) {
        if (valueLength === 0 && currentValue.indexOf("table") < 0 && currentValue.indexOf("img") < 0 && currentValue.includes("&nbsp;")) {
            var arrayValue = currentValue.split("&nbsp;");
            arrayValue[arrayValue.length - 1] = "&#8203;" + arrayValue[arrayValue.length - 1];
            currentValue = arrayValue.join("");
        }
        currentValue = currentValue.replace(/<br>/g, "<br/>").replace(/<hr>/g, "<hr/>").replace(/ /g, " ");
        var valueTemp;
        var valueDupe = [];
        var valueOriginal = [];
        var imgRegexp = [
            /<img(.*?)>/gi,
            /<area(.*?)>/gi,
            /<base(.*?)>/gi,
            /<col (.*?)>/gi,
            /<embed(.*?)>/gi,
            /<input(.*?)>/gi,
            /<link(.*?)>/gi,
            /<meta(.*?)>/gi,
            /<param(.*?)>/gi,
            /<source(.*?)>/gi,
            /<track(.*?)>/gi,
            /<wbr(.*?)>/gi
        ];
        for(var j = 0; j < imgRegexp.length; j++){
            valueTemp = imgRegexp[j].exec(currentValue);
            while(valueTemp !== null){
                valueDupe.push(valueTemp[0].toString());
                valueTemp = imgRegexp[j].exec(currentValue);
            }
            valueOriginal = valueDupe.slice(0);
            for(var i = 0; i < valueDupe.length; i++)if (valueDupe[i].indexOf("/") === -1 || valueDupe[i].lastIndexOf("/") !== valueDupe[i].length - 2) valueDupe[i] = valueDupe[i].substr(0, valueDupe[i].length - 1) + " /" + valueDupe[i].substr(valueDupe[i].length - 1, valueDupe[i].length);
            for(var g = 0; g <= valueDupe.length - 1; g++)currentValue = currentValue.replace(valueOriginal[g], valueDupe[g]);
        }
        return currentValue;
    };
    XhtmlValidation.prototype.clean = function(node) {
        for(var n = 0; n < node.childNodes.length; n++){
            var child = node.childNodes[n];
            if (child.nodeType === 8 || child.nodeName === "V:IMAGE") {
                node.removeChild(child);
                n--;
            } else if (child.nodeType === 1) this.clean(child);
        }
        return this.currentElement.innerHTML;
    };
    XhtmlValidation.prototype.ImageTags = function() {
        var imgNodes = this.currentElement.querySelectorAll("IMG");
        for(var i = imgNodes.length - 1; i >= 0; i--)if (!imgNodes[i].hasAttribute("alt")) {
            var img = imgNodes[i];
            img.setAttribute("alt", "");
        }
    };
    XhtmlValidation.prototype.removeTags = function() {
        var removeAttribute = [
            [
                "br",
                "ul"
            ],
            [
                "br",
                "ol"
            ],
            [
                "table",
                "span"
            ],
            [
                "div",
                "span"
            ],
            [
                "p",
                "span"
            ]
        ];
        for(var i = 0; i < removeAttribute.length; i++)this.RemoveElementNode(removeAttribute[i][0], removeAttribute[i][1]);
    };
    XhtmlValidation.prototype.RemoveElementNode = function(rmvNode, parentNode) {
        var parentArray = this.currentElement.querySelectorAll(parentNode);
        for(var i = 0; i < parentArray.length; i++){
            var rmvArray = parentArray[i].querySelectorAll(rmvNode);
            for(var j = rmvArray.length; j > 0; j--)(0, $4ZDHT.detach)(rmvArray[j - 1]);
        }
    };
    XhtmlValidation.prototype.RemoveUnsupported = function() {
        var underlineEle = this.currentElement.querySelectorAll("u");
        for(var i = underlineEle.length - 1; i >= 0; i--){
            var spanEle = this.parent.createElement("span");
            spanEle.style.textDecoration = "underline";
            spanEle.innerHTML = underlineEle[i].innerHTML;
            underlineEle[i].parentNode.insertBefore(spanEle, underlineEle[i]);
            (0, $4ZDHT.detach)(underlineEle[i]);
        }
        var strongEle = this.currentElement.querySelectorAll("strong");
        for(var i = strongEle.length - 1; i >= 0; i--){
            var boldEle = this.parent.createElement("b");
            boldEle.innerHTML = strongEle[i].innerHTML;
            strongEle[i].parentNode.insertBefore(boldEle, strongEle[i]);
            (0, $4ZDHT.detach)(strongEle[i]);
        }
        var attrArray = [
            "language",
            "role",
            "target",
            "contenteditable",
            "cellspacing",
            "cellpadding",
            "border",
            "valign",
            "colspan"
        ];
        for(var i = 0; i <= attrArray.length; i++)this.RemoveAttributeByName(attrArray[i]);
    };
    XhtmlValidation.prototype.RemoveAttributeByName = function(attrName) {
        if (this.currentElement.firstChild !== null) {
            if (this.currentElement.firstChild.nodeType !== 3) for(var i = 0; i < this.currentElement.childNodes.length; i++){
                var ele = this.currentElement.childNodes[i];
                if (ele.nodeType !== 3 && ele.nodeName !== "TABLE" && ele.nodeName !== "TBODY" && ele.nodeName !== "THEAD" && ele.nodeName !== "TH" && ele.nodeName !== "TR" && ele.nodeName !== "TD") {
                    if (ele.hasAttribute(attrName)) ele.removeAttribute(attrName);
                    if (ele.hasChildNodes()) for(var j = 0; j < ele.childNodes.length; j++){
                        var childEle = ele.childNodes[j];
                        if (childEle.nodeType !== 3 && childEle.nodeName !== "TABLE" && childEle.nodeName !== "TBODY" && childEle.nodeName !== "THEAD" && childEle.nodeName !== "TH" && childEle.nodeName !== "TR" && childEle.nodeName !== "TD" && childEle.hasAttribute(attrName) && !childEle.classList.contains("e-mention-chip")) childEle.removeAttribute(attrName);
                        if (childEle.hasChildNodes()) {
                            for(var k = 0; k < childEle.childNodes.length; k++)if (childEle.childNodes[k].nodeType !== 3 && childEle.childNodes[k].nodeName !== "TABLE" && childEle.childNodes[k].nodeName !== "TBODY" && childEle.childNodes[k].nodeName !== "THEAD" && childEle.childNodes[k].nodeName !== "TH" && childEle.childNodes[k].nodeName !== "TR" && childEle.childNodes[k].nodeName !== "TD" && childEle.childNodes[k].hasAttribute(attrName)) childEle.childNodes[k].removeAttribute(attrName);
                        }
                    }
                }
            }
        }
    };
    return XhtmlValidation;
}();



/**
 * `HtmlEditor` module is used to HTML editor
 */ var $f33d01d1f6cb2ad3$export$23bffbc1d2dae0de = /** @class */ function() {
    function HtmlEditor(parent, serviceLocator) {
        this.rangeCollection = [];
        this.isImageDelete = false;
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.xhtmlValidation = new (0, $157cc54a6a784f4a$export$2457b22d30aa88aa)(parent);
        this.addEventListener();
        this.isDestroyed = false;
        this.isCopyAll = false;
    }
    /**
     * Destroys the Markdown.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ HtmlEditor.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
        }
        this.removeEventListener();
        this.locator = null;
        this.contentRenderer = null;
        this.renderFactory = null;
        this.toolbarUpdate = null;
        this.nodeSelectionObj = null;
        this.isCopyAll = null;
        if (this.rangeCollection.length > 0) this.rangeCollection = [];
        if (this.rangeElement) this.rangeElement = null;
        if (this.oldRangeElement) this.oldRangeElement = null;
        if (this.deleteRangeElement) this.deleteRangeElement = null;
        if (this.deleteOldRangeElement) this.deleteOldRangeElement = null;
        if (this.saveSelection) this.saveSelection = null;
        if (this.xhtmlValidation) this.xhtmlValidation = null;
        this.isDestroyed = true;
    };
    /**
     * @param {string} value - specifies the string value
     * @returns {void}
     * @hidden

     */ HtmlEditor.prototype.sanitizeHelper = function(value) {
        value = (0, $c77ecbfae9b8c035$export$b868d07f1dfe5080)(value, this.parent);
        return value;
    };
    HtmlEditor.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.nodeSelectionObj = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        this.parent.on($947a002e9a697770$export$b70fe0c8c3456154, this.instantiateRenderer, this);
        this.parent.on($947a002e9a697770$export$d3e2e39ad7d15e6d, this.onToolbarClick, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.render, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$90aca4adda6ff0f5, this.selectAll, this);
        this.parent.on($947a002e9a697770$export$86be68e1224a0620, this.selectRange, this);
        this.parent.on($947a002e9a697770$export$76d3c88e0e217d4e, this.getSelectedHtml, this);
        this.parent.on($947a002e9a697770$export$dd9b49d5e9b25abd, this.onSelectionSave, this);
        this.parent.on($947a002e9a697770$export$ae80d5dbf349b0b4, this.onSelectionRestore, this);
        this.parent.on($947a002e9a697770$export$ff4edde773b9bda2, this.updateReadOnly, this);
        this.parent.on($947a002e9a697770$export$9b6706c8686cfc8e, this.onPaste, this);
        this.parent.on($947a002e9a697770$export$5dbeb4561f6544b7, this.isTableClassAdded, this);
        this.parent.on($947a002e9a697770$export$6f23f8d8c684bbf3, this.onHandleFontsizeChange, this);
    };
    HtmlEditor.prototype.updateReadOnly = function() {
        if (this.parent.readonly) {
            (0, $4ZDHT.attributes)(this.parent.contentModule.getEditPanel(), {
                contenteditable: "false"
            });
            (0, $4ZDHT.addClass)([
                this.parent.element
            ], $afc560df281b588d$export$f53692bf3792d5c);
        } else {
            (0, $4ZDHT.attributes)(this.parent.contentModule.getEditPanel(), {
                contenteditable: "true"
            });
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], $afc560df281b588d$export$f53692bf3792d5c);
        }
    };
    HtmlEditor.prototype.onSelectionSave = function() {
        var currentDocument = this.contentRenderer.getDocument();
        var range = this.nodeSelectionObj.getRange(currentDocument);
        this.saveSelection = this.nodeSelectionObj.save(range, currentDocument);
    };
    HtmlEditor.prototype.onSelectionRestore = function(e) {
        this.parent.isBlur = false;
        if ((0, $3EnZW.isNullOrUndefined)(e.items) || e.items) this.saveSelection.restore();
    };
    HtmlEditor.prototype.isTableClassAdded = function() {
        var tableElement = this.parent.inputElement.querySelectorAll("table");
        for(var i = 0; i < tableElement.length; i++)if (!tableElement[i].classList.contains("e-rte-table") && !tableElement[i].classList.contains("e-rte-paste-table")) tableElement[i].classList.add("e-rte-table");
    };
    HtmlEditor.prototype.onHandleFontsizeChange = function(e) {
        var keyboardArgs = e.args;
        var args = {
            name: "dropDownSelect"
        };
        args.item = {
            command: "Font",
            subCommand: "FontSize"
        };
        var items = this.parent.fontSize.items;
        var activeElem;
        if (this.parent.toolbarModule && this.parent.toolbarModule.dropDownModule && this.parent.toolbarModule.dropDownModule.fontSizeDropDown && !(0, $3EnZW.isNullOrUndefined)(this.parent.toolbarModule.dropDownModule.fontSizeDropDown.activeElem[0].textContent) && this.parent.toolbarModule.dropDownModule.fontSizeDropDown.activeElem[0].textContent !== "") activeElem = this.parent.toolbarModule.dropDownModule.fontSizeDropDown.activeElem[0].textContent;
        else {
            var fontSizeValue = void 0;
            var selection = this.parent.contentModule.getDocument().getSelection();
            if (selection && selection.focusNode && selection.focusNode.parentElement) fontSizeValue = document.defaultView.getComputedStyle(selection.focusNode.parentElement, null).getPropertyValue("font-size");
            else fontSizeValue = this.parent.fontSize.width;
            fontSizeValue = (0, $3EnZW.isNullOrUndefined)(fontSizeValue) ? this.parent.fontSize.width : fontSizeValue;
            var actualTxtFontValues = fontSizeValue.match(/^([\d.]+)(\D+)$/);
            var size_1 = parseInt(actualTxtFontValues[1], 10);
            var unit = actualTxtFontValues[2];
            var defaultFontValues = items[1].value.match(/^([\d.]+)(\D+)$/);
            if (defaultFontValues[2] === unit) {
                var index = items.findIndex(function(_a) {
                    var value = _a.value;
                    return parseInt(value, 10) >= size_1;
                });
                activeElem = items[index].text;
            } else {
                var convertedSize_1 = this.convertFontSize(size_1, unit, defaultFontValues[2]);
                var index = items.findIndex(function(_a) {
                    var value = _a.value;
                    return parseInt(value, 10) >= convertedSize_1;
                });
                activeElem = items[index].text;
            }
        }
        var fontIndex = items.findIndex(function(size) {
            return size.text === (activeElem === "Font Size" ? "Default" : activeElem);
        });
        if (keyboardArgs.action === "increase-fontsize" && fontIndex !== -1) {
            if (fontIndex >= items.length - 1) {
                var fontValues = items[fontIndex].value.match(/^([\d.]+)(\D+)$/);
                if (fontValues) {
                    var size = parseInt(fontValues[1], 10);
                    var unit = fontValues[2];
                    var roundedSize = size % 10 === 0 ? Math.ceil((size + 1) / 10) * 10 : Math.ceil(size / 10) * 10;
                    args.item.value = roundedSize.toLocaleString() + unit;
                    args.item.text = roundedSize.toLocaleString() + " " + unit;
                }
                this.parent.fontSize.items.push(args.item);
            } else {
                args.item.value = items[fontIndex + 1].value;
                args.item.text = items[fontIndex + 1].text;
            }
        } else if (keyboardArgs.action === "decrease-fontsize" && fontIndex !== -1 && fontIndex > 0) {
            args.item.value = items[fontIndex - 1].value;
            args.item.text = items[fontIndex - 1].text;
        } else if (fontIndex >= 0 && fontIndex < items.length && items[fontIndex]) {
            args.item.value = items[fontIndex].value;
            args.item.text = items[fontIndex].text;
        }
        this.parent.formatter.process(this.parent, args, keyboardArgs);
    };
    HtmlEditor.prototype.convertFontSize = function(value, originalUnit, targetUnit) {
        if ($947a002e9a697770$export$75a6c7326da01ed3.indexOf(originalUnit) !== -1 || $947a002e9a697770$export$75a6c7326da01ed3.indexOf(targetUnit) !== -1) originalUnit = "px";
        var convertedValue = value * $947a002e9a697770$export$7b5604ec01e659a3[originalUnit][targetUnit];
        return convertedValue;
    };
    HtmlEditor.prototype.onKeyUp = function(e) {
        var args = e.args;
        var restrictKeys = [
            8,
            9,
            13,
            17,
            18,
            20,
            27,
            37,
            38,
            39,
            40,
            44,
            45,
            46,
            91,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123
        ];
        var range = this.parent.getRange();
        var regEx = new RegExp("\u200B", "g");
        var isEmptyNode = range.startContainer === range.endContainer && range.startOffset === range.endOffset && range.startOffset === 1 && range.startContainer.textContent.length === 1 && range.startContainer.textContent.charCodeAt(0) === 8203 && range.startContainer.textContent.replace(regEx, "").length === 0;
        var isMention = false;
        if (range.startContainer === range.endContainer && range.startOffset === range.endOffset && range.startContainer !== this.parent.inputElement && range.startOffset !== 0) {
            var mentionStartNode = range.startContainer.nodeType === 3 ? range.startContainer : range.startContainer.childNodes[range.startOffset - 1];
            isMention = args.keyCode === 16 && mentionStartNode.textContent.charCodeAt(0) === 8203 && !(0, $3EnZW.isNullOrUndefined)(mentionStartNode.previousSibling) && mentionStartNode.previousSibling.contentEditable === "false";
        }
        if (this.isCopyAll) return;
        var pointer;
        var isRootParent = false;
        if (restrictKeys.indexOf(args.keyCode) < 0 && !args.shiftKey && !args.ctrlKey && !args.altKey && !isEmptyNode && !isMention) {
            pointer = range.startOffset;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            range.startContainer.nodeName === "#text" ? range.startContainer.parentElement !== this.parent.inputElement ? range.startContainer.parentElement.classList.add("currentStartMark") : isRootParent = true : range.startContainer.classList.add("currentStartMark");
            if (range.startContainer.textContent.charCodeAt(0) === 8203) {
                var previousLength_1 = range.startContainer.textContent.length;
                var previousRange = range.startOffset;
                range.startContainer.textContent = range.startContainer.textContent.replace(regEx, "");
                pointer = previousRange === 0 ? previousRange : previousRange - (previousLength_1 - range.startContainer.textContent.length);
                this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), range.startContainer, pointer);
            }
            var previousLength = this.parent.inputElement.innerHTML.length;
            var currentLength = this.parent.inputElement.innerHTML.replace(regEx, "").length;
            var focusNode = range.startContainer;
            if (previousLength > currentLength && !isRootParent) {
                if (focusNode.textContent.trim().length !== 0 && focusNode.previousSibling) {
                    var tempSpan = document.createElement("span");
                    tempSpan.className = "tempSpan";
                    range.insertNode(tempSpan);
                }
                var currentChild = this.parent.inputElement.firstChild;
                while(!(0, $3EnZW.isNullOrUndefined)(currentChild)){
                    if (currentChild.nodeName === "#text") {
                        currentChild = currentChild.nextElementSibling;
                        continue;
                    }
                    if (currentChild.textContent.replace(regEx, "").trim().length > 0 && currentChild.textContent.includes("\u200B")) currentChild.innerHTML = currentChild.innerHTML.replace(regEx, "");
                    currentChild = currentChild.nextElementSibling;
                }
                var tempSpanToRemove = this.parent.inputElement.querySelector(".tempSpan");
                if (tempSpanToRemove && tempSpanToRemove.previousSibling && focusNode.textContent.trim().length !== 0) {
                    focusNode = tempSpanToRemove.previousSibling;
                    pointer = tempSpanToRemove.previousSibling.textContent.length;
                    var parentElement = tempSpanToRemove.parentNode;
                    parentElement.removeChild(tempSpanToRemove);
                    tempSpanToRemove = null;
                }
                var currentChildNode = this.parent.inputElement.querySelector(".currentStartMark").childNodes;
                if (currentChildNode.length > 1) for(var i = 0; i < currentChildNode.length; i++){
                    if (currentChildNode[i].nodeName === "#text" && currentChildNode[i].textContent.length === 0) {
                        (0, $4ZDHT.detach)(currentChildNode[i]);
                        i--;
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(currentChildNode[i]) && focusNode.textContent.replace(regEx, "") === currentChildNode[i].textContent) {
                        pointer = focusNode.textContent.length > 1 ? focusNode.textContent === currentChildNode[i].textContent ? pointer : pointer - (focusNode.textContent.length - focusNode.textContent.replace(regEx, "").length) : focusNode.textContent.length;
                        focusNode = currentChildNode[i];
                    }
                }
                else if (currentChildNode.length === 1) {
                    if (focusNode.textContent.replace(regEx, "") === currentChildNode[0].textContent) focusNode = currentChildNode[0];
                }
                this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), focusNode, pointer);
            }
            var currentElem = this.parent.inputElement.querySelector(".currentStartMark");
            if (!(0, $3EnZW.isNullOrUndefined)(currentElem)) {
                currentElem.classList.remove("currentStartMark");
                if (currentElem.getAttribute("class").trim() === "") currentElem.removeAttribute("class");
            }
            if (!(0, $3EnZW.isNullOrUndefined)(range.startContainer.previousSibling) && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.previousSibling.parentElement) && range.startContainer.parentElement === range.startContainer.previousSibling.parentElement && range.startContainer.previousSibling.textContent.charCodeAt(0) === 8203 && range.startContainer.previousSibling.textContent.length <= 1) range.startContainer.previousSibling.textContent = range.startContainer.previousSibling.textContent.replace(regEx, "");
            if (range.endContainer.textContent.charCodeAt(range.endOffset) === 8203) {
                pointer = range.startOffset;
                range.endContainer.textContent = range.endContainer.textContent.replace(regEx, "");
                this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), range.startContainer, pointer);
            }
        }
    };
    HtmlEditor.prototype.onKeyDown = function(e) {
        var _this = this;
        if (e.args.ctrlKey && e.args.keyCode === 65) this.isCopyAll = true;
        else this.isCopyAll = false;
        var currentRange;
        var args = e.args;
        if (this.parent.inputElement.querySelectorAll(".e-cell-select").length > 1 && (args.keyCode === 8 || args.keyCode === 32 || args.keyCode === 13)) {
            this.tableSelectionKeyAction(e);
            this.parent.autoResize();
            return;
        }
        if ((0, $5q7BP.Browser).info.name === "chrome") {
            currentRange = this.parent.getRange();
            this.backSpaceCleanup(e, currentRange);
            this.deleteCleanup(e, currentRange);
        }
        if (args.keyCode === 9 && this.parent.enableTabKey) {
            this.parent.formatter.saveData(e);
            if (!(0, $3EnZW.isNullOrUndefined)(args.target) && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(args.target, ".e-rte-toolbar"))) {
                var range = this.nodeSelectionObj.getRange(this.contentRenderer.getDocument());
                var parentNode = this.nodeSelectionObj.getParentNodeCollection(range);
                if (!(parentNode[0].nodeName === "LI" || (0, $4ZDHT.closest)(parentNode[0], "li") || (0, $4ZDHT.closest)(parentNode[0], "table"))) {
                    args.preventDefault();
                    var selection = this.contentRenderer.getDocument().getSelection().getRangeAt(0);
                    var alignmentNodes = this.parent.formatter.editorManager.domNode.blockNodes();
                    if (this.parent.enterKey === "BR") {
                        if (selection.startOffset !== selection.endOffset && selection.startOffset === 0) {
                            var save = this.nodeSelectionObj.save(range, this.contentRenderer.getDocument());
                            this.parent.formatter.editorManager.domNode.setMarker(save);
                            alignmentNodes = this.parent.formatter.editorManager.domNode.blockNodes();
                            this.parent.formatter.editorManager.domNode.convertToBlockNodes(alignmentNodes, false);
                            this.marginTabAdd(args.shiftKey, alignmentNodes);
                            save = this.parent.formatter.editorManager.domNode.saveMarker(save);
                            save.restore();
                        } else {
                            (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.contentRenderer.getDocument(), "&nbsp;&nbsp;&nbsp;&nbsp;");
                            this.rangeCollection.push(this.nodeSelectionObj.getRange(this.contentRenderer.getDocument()));
                        }
                    } else {
                        if (!args.shiftKey) {
                            if (selection.startOffset !== selection.endOffset && selection.startOffset === 0) this.marginTabAdd(args.shiftKey, alignmentNodes);
                            else {
                                (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.contentRenderer.getDocument(), "&nbsp;&nbsp;&nbsp;&nbsp;");
                                this.rangeCollection.push(this.nodeSelectionObj.getRange(this.contentRenderer.getDocument()));
                            }
                        } else if (this.rangeCollection.length > 0 && this.rangeCollection[this.rangeCollection.length - 1].startContainer.textContent.length === 4) {
                            var textCont = this.rangeCollection[this.rangeCollection.length - 1].startContainer;
                            this.nodeSelectionObj.setSelectionText(this.contentRenderer.getDocument(), textCont, textCont, 0, textCont.textContent.length);
                            (0, $d506f52aebbae6a6$export$d39fd72c6bafacf3).Insert(this.contentRenderer.getDocument(), document.createTextNode(""));
                            this.rangeCollection.pop();
                        } else this.marginTabAdd(args.shiftKey, alignmentNodes);
                    }
                }
            }
            this.parent.formatter.saveData(e);
        }
        if (e.args.action === "space" || e.args.action === "enter" || e.args.keyCode === 13) {
            this.spaceLink(e.args);
            if (this.parent.editorMode === "HTML" && !this.parent.readonly) {
                var currentLength = this.parent.getText().trim().replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "").length;
                var selectionLength = this.parent.getSelection().length;
                var totalLength = currentLength - selectionLength + 1;
                if (!(this.parent.maxLength === -1 || totalLength <= this.parent.maxLength) && e.args.keyCode === 13) {
                    e.args.preventDefault();
                    return;
                } else {
                    this.parent.notify($947a002e9a697770$export$606c1792086c85f2, {
                        args: e.args
                    });
                    (0, $259257662ca103fc$export$7e1ec7538889cd1)(this.parent.contentModule.getDocument(), this.parent.inputElement);
                }
            }
        }
        if (e.args.action === "space") {
            var currentRange_1 = this.parent.getRange();
            var editorValue = currentRange_1.startContainer.textContent.slice(0, currentRange_1.startOffset);
            var orderedList_1 = this.isOrderedList(editorValue);
            var unOrderedList = this.isUnOrderedList(editorValue);
            var hasSplitedText = this.hasMultipleTextNode(currentRange_1);
            if (!hasSplitedText && (orderedList_1 && !unOrderedList || unOrderedList && !orderedList_1)) {
                var eventArgs_1 = {
                    callBack: null,
                    event: e.args,
                    name: "keydown-handler"
                };
                var actionBeginArgs = {
                    cancel: false,
                    item: {
                        command: "Lists",
                        subCommand: orderedList_1 ? "OL" : "UL"
                    },
                    name: "actionBegin",
                    originalEvent: e.args,
                    requestType: orderedList_1 ? "OL" : "UL"
                };
                this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
                    if (!actionBeginArgs.cancel) {
                        _this.parent.formatter.editorManager.observer.notify((0, $ee11fb99ae4d2c3e$export$586814fbf9e806f), eventArgs_1);
                        _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
                            editorMode: _this.parent.editorMode,
                            elements: _this.parent.formatter.editorManager.domNode.blockNodes(),
                            event: e.args,
                            name: $947a002e9a697770$export$830631a3cb598490,
                            range: _this.parent.getRange(),
                            requestType: orderedList_1 ? "OL" : "UL"
                        });
                    }
                });
            }
        }
        if ((0, $5q7BP.Browser).info.name === "chrome" && (!(0, $3EnZW.isNullOrUndefined)(this.rangeElement) && !(0, $3EnZW.isNullOrUndefined)(this.oldRangeElement) || !(0, $3EnZW.isNullOrUndefined)(this.deleteRangeElement) && !(0, $3EnZW.isNullOrUndefined)(this.deleteOldRangeElement)) && currentRange.startContainer.parentElement.tagName !== "TD" && currentRange.startContainer.parentElement.tagName !== "TH") {
            this.rangeElement = null;
            this.oldRangeElement = null;
            this.deleteRangeElement = null;
            this.deleteOldRangeElement = null;
            if (!this.isImageDelete) args.preventDefault();
            args.preventDefault();
        }
        this.parent.autoResize();
    };
    HtmlEditor.prototype.isOrderedList = function(editorValue) {
        editorValue = editorValue.replace(/\u200B/g, "");
        var olListStartRegex = [
            /^[1]+[.]+$/,
            /^[i]+[.]+$/,
            /^[a]+[.]+$/
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(editorValue)) for(var i = 0; i < olListStartRegex.length; i++){
            if (olListStartRegex[i].test(editorValue)) return true;
        }
        return false;
    };
    HtmlEditor.prototype.isUnOrderedList = function(editorValue) {
        editorValue = editorValue.replace(/\u200B/g, "");
        var ulListStartRegex = [
            /^[*]$/,
            /^[-]$/
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(editorValue)) for(var i = 0; i < ulListStartRegex.length; i++){
            if (ulListStartRegex[i].test(editorValue)) return true;
        }
        return false;
    };
    HtmlEditor.prototype.hasMultipleTextNode = function(range) {
        if (range && range.startContainer && range.startContainer.parentNode) {
            var parentNode = range.startContainer.parentNode;
            if (this.parent.enterKey === "BR" || (0, $4ZDHT.closest)(parentNode, "table")) return false;
            var childNodes = parentNode.childNodes;
            var textNodes = [];
            for(var i = 0; i < childNodes.length; i++){
                var node = childNodes[i];
                if (node && node.nodeType === Node.TEXT_NODE) {
                    textNodes.push(node);
                    if (textNodes.length > 1) return true;
                }
            }
        }
        return false;
    };
    HtmlEditor.prototype.backSpaceCleanup = function(e, currentRange) {
        var isLiElement = false;
        var isPreviousNotContentEditable = true;
        if (!(0, $3EnZW.isNullOrUndefined)(currentRange.startContainer.previousSibling) && currentRange.startContainer.previousSibling.nodeName === "SPAN") isPreviousNotContentEditable = currentRange.startContainer.previousSibling.contentEditable === "false" ? false : true;
        var checkNode = currentRange.startContainer.nodeName === "#text" ? currentRange.startContainer.parentElement : currentRange.startContainer;
        var isSelectedPositionNotStart = (0, $4ZDHT.closest)(currentRange.startContainer.nodeName === "#text" ? currentRange.startContainer.parentElement : currentRange.startContainer, "li") ? checkNode.nodeName !== "li" && (0, $3EnZW.isNullOrUndefined)(checkNode.previousSibling) : true;
        if (e.args.code === "Backspace" && e.args.keyCode === 8 && currentRange.startOffset === 0 && currentRange.endOffset === 0 && this.parent.getSelection().length === 0 && currentRange.startContainer.textContent.length > 0 && currentRange.startContainer.parentElement.tagName !== "TD" && currentRange.startContainer.parentElement.tagName !== "TH" && isPreviousNotContentEditable && isSelectedPositionNotStart) {
            if (!this.parent.formatter.editorManager.domNode.isBlockNode(checkNode) && !(0, $3EnZW.isNullOrUndefined)(checkNode.previousSibling) && checkNode.previousSibling.nodeName === "BR" || !(0, $3EnZW.isNullOrUndefined)(currentRange.startContainer.previousSibling) && currentRange.startContainer.previousSibling.nodeName === "BR") return;
            this.rangeElement = this.getRootBlockNode(currentRange.startContainer);
            if (this.rangeElement.tagName === "OL" || this.rangeElement.tagName === "UL") {
                var liElement = this.getRangeLiNode(currentRange.startContainer);
                if (liElement.previousElementSibling && liElement.previousElementSibling.childElementCount > 0) {
                    this.oldRangeElement = liElement.previousElementSibling.lastElementChild.nodeName === "BR" ? liElement.previousElementSibling : liElement.previousElementSibling.lastChild;
                    if (!(0, $3EnZW.isNullOrUndefined)(liElement.lastElementChild) && liElement.lastElementChild.nodeName !== "BR" && (0, $3EnZW.isNullOrUndefined)(liElement.lastElementChild.previousSibling) && liElement.lastChild.nodeName !== "#text") {
                        this.rangeElement = liElement.lastElementChild;
                        isLiElement = true;
                    } else this.rangeElement = liElement;
                }
            } else if (this.rangeElement === this.parent.inputElement || this.rangeElement.tagName === "TABLE" || !(0, $3EnZW.isNullOrUndefined)(this.rangeElement.previousElementSibling) && this.rangeElement.previousElementSibling.tagName === "TABLE") return;
            else this.oldRangeElement = this.rangeElement.previousElementSibling;
            var findBlockElement = this.parent.formatter.editorManager.domNode.blockNodes();
            if (!(0, $3EnZW.isNullOrUndefined)(findBlockElement[0]) && currentRange.collapsed && currentRange.startOffset === 0 && currentRange.endOffset === 0 && findBlockElement[0].style.marginLeft !== "") findBlockElement[0].style.marginLeft = parseInt(findBlockElement[0].style.marginLeft, 10) <= 20 ? "" : parseInt(findBlockElement[0].style.marginLeft, 10) - 20 + "px";
            if ((0, $3EnZW.isNullOrUndefined)(this.oldRangeElement)) return;
            else {
                if (this.oldRangeElement.tagName === "OL" || this.oldRangeElement.tagName === "UL") this.oldRangeElement = this.oldRangeElement.lastElementChild.lastElementChild ? this.oldRangeElement.lastElementChild.lastElementChild : this.oldRangeElement.lastElementChild;
                var lastNode = this.oldRangeElement.lastChild ? this.oldRangeElement.lastChild : this.oldRangeElement;
                while(lastNode.nodeType !== 3 && lastNode.nodeName !== "#text" && lastNode.nodeName !== "BR" && !(0, $3EnZW.isNullOrUndefined)(lastNode.lastChild))lastNode = lastNode.lastChild;
                if (lastNode.nodeName === "IMG") this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), lastNode.parentElement, lastNode.parentElement.childNodes.length);
                else this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), // eslint-disable-next-line
                lastNode, lastNode.textContent.length);
                if (this.oldRangeElement.nodeName !== "#text" && this.oldRangeElement.querySelectorAll("BR").length === 1) (0, $4ZDHT.detach)(this.oldRangeElement.querySelector("BR"));
                if (!(0, $3EnZW.isNullOrUndefined)(this.rangeElement) && this.oldRangeElement !== this.rangeElement) {
                    while(this.rangeElement.firstChild)if (this.oldRangeElement.nodeName === "#text") this.oldRangeElement.parentElement.appendChild(this.rangeElement.childNodes[0]);
                    else this.oldRangeElement.appendChild(this.rangeElement.childNodes[0]);
                    // eslint-disable-next-line
                    !isLiElement ? (0, $4ZDHT.detach)(this.rangeElement) : (0, $4ZDHT.detach)(this.rangeElement.parentElement);
                    this.oldRangeElement.normalize();
                }
            }
        }
    };
    HtmlEditor.prototype.deleteCleanup = function(e, currentRange) {
        var isLiElement = false;
        var liElement;
        var rootElement;
        if (e.args.code === "Delete" && e.args.keyCode === 46 && this.parent.contentModule.getText().trim().replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "").length !== 0 && this.parent.getSelection().length === 0 && currentRange.startContainer.parentElement.tagName !== "TD" && currentRange.startContainer.parentElement.tagName !== "TH") {
            this.deleteRangeElement = rootElement = this.getRootBlockNode(currentRange.startContainer);
            if (this.deleteRangeElement.tagName === "OL" || this.deleteRangeElement.tagName === "UL") {
                liElement = this.getRangeLiNode(currentRange.startContainer);
                if (liElement.nextElementSibling && liElement.nextElementSibling.childElementCount > 0 && !liElement.nextElementSibling.querySelector("BR")) {
                    if (!(0, $3EnZW.isNullOrUndefined)(liElement.lastElementChild)) {
                        this.deleteRangeElement = liElement.lastElementChild;
                        isLiElement = true;
                    } else this.deleteRangeElement = liElement;
                } else this.deleteRangeElement = this.getRangeElement(liElement);
            } else if (this.deleteRangeElement.nodeType === 3 || this.deleteRangeElement.tagName === "TABLE" || !(0, $3EnZW.isNullOrUndefined)(this.deleteRangeElement.nextElementSibling) && this.deleteRangeElement.nextElementSibling.tagName === "TABLE") return;
            var isImgWithEmptyBlockNode = false;
            if (this.deleteRangeElement.querySelectorAll("img").length > 0 && this.deleteRangeElement.textContent.trim() === "") isImgWithEmptyBlockNode = true;
            if (this.getCaretIndex(currentRange, this.deleteRangeElement) === this.deleteRangeElement.textContent.length && !isImgWithEmptyBlockNode) {
                if (!(0, $3EnZW.isNullOrUndefined)(liElement)) {
                    if (isLiElement || !(0, $3EnZW.isNullOrUndefined)(liElement.nextElementSibling)) this.deleteOldRangeElement = this.getRangeElement(liElement.nextElementSibling);
                    else this.deleteOldRangeElement = rootElement.nextElementSibling;
                } else this.deleteOldRangeElement = this.deleteRangeElement.nextElementSibling;
                if ((0, $3EnZW.isNullOrUndefined)(this.deleteOldRangeElement)) return;
                else {
                    if (currentRange.startOffset === 0 && currentRange.endOffset === 1 && this.deleteRangeElement.childNodes[0].nodeName === "IMG") {
                        this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.parent.contentModule.getDocument(), this.deleteRangeElement, this.deleteRangeElement, 0, 1);
                        this.isImageDelete = true;
                    } else {
                        this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), this.deleteRangeElement, this.deleteRangeElement.childNodes.length);
                        this.isImageDelete = false;
                    }
                    var brNode = this.deleteRangeElement.querySelector("BR");
                    var brLastChildNode = this.deleteRangeElement.lastChild;
                    if (brNode && brNode.classList.contains("e-rte-image-remove-focus")) {
                        (0, $4ZDHT.removeClass)([
                            brNode
                        ], [
                            "e-rte-image-focus"
                        ]);
                        return;
                    } else if (brNode && brLastChildNode && brLastChildNode.nodeName === "BR") {
                        (0, $4ZDHT.detach)(brLastChildNode);
                        e.args.preventDefault();
                    }
                    if (!(0, $3EnZW.isNullOrUndefined)(this.deleteRangeElement) && this.deleteOldRangeElement.tagName !== "OL" && this.deleteOldRangeElement.tagName !== "UL" && this.deleteOldRangeElement !== this.deleteRangeElement) {
                        while(this.deleteOldRangeElement.firstChild)this.deleteRangeElement.appendChild(this.deleteOldRangeElement.childNodes[0]);
                        if (!isLiElement) (0, $4ZDHT.detach)(this.deleteOldRangeElement);
                        else (0, $4ZDHT.detach)(this.deleteOldRangeElement.parentElement);
                        this.deleteRangeElement.normalize();
                    } else {
                        this.deleteRangeElement = null;
                        this.deleteOldRangeElement = null;
                    }
                }
            } else this.deleteRangeElement = null;
        }
    };
    HtmlEditor.prototype.getCaretIndex = function(currentRange, element) {
        var position = 0;
        if (this.parent.contentModule.getDocument().getSelection().rangeCount !== 0) {
            var preCaretRange = currentRange.cloneRange();
            preCaretRange.selectNodeContents(element);
            preCaretRange.setEnd(currentRange.endContainer, currentRange.endOffset);
            position = preCaretRange.toString().length;
        }
        return position;
    };
    HtmlEditor.prototype.getRangeElement = function(element) {
        var rangeElement = element.lastElementChild ? element.lastElementChild.tagName === "BR" ? element.lastElementChild.previousElementSibling ? element.lastElementChild.previousElementSibling : element : element.lastElementChild : element;
        return rangeElement;
    };
    HtmlEditor.prototype.getRootBlockNode = function(rangeBlockNode) {
        // eslint-disable-next-line
        for(; rangeBlockNode && this.parent && this.parent.inputElement !== rangeBlockNode; rangeBlockNode){
            if (rangeBlockNode.parentElement === this.parent.inputElement) break;
            else rangeBlockNode = rangeBlockNode.parentElement;
        }
        return rangeBlockNode;
    };
    HtmlEditor.prototype.getRangeLiNode = function(rangeLiNode) {
        var node = rangeLiNode.parentElement;
        while(node !== this.parent.inputElement){
            if (node.nodeType === 1 && node.tagName === "LI") break;
            node = node.parentElement;
        }
        return node;
    };
    HtmlEditor.prototype.onPaste = function(e) {
        // eslint-disable-next-line
        var regex = new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi);
        if (e.text.match(regex)) {
            if (e.isWordPaste) return;
            e.args.preventDefault();
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            // eslint-disable-next-line
            var saveSelection = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            // eslint-disable-next-line
            var httpRegex = new RegExp(/([^\S]|^)(((https?\:\/\/)))/gi);
            var wwwRegex = new RegExp(/([^\S]|^)(((www\.))(\S+))/gi);
            var enterSplitText = e.text.split("\n");
            var contentInnerElem = "";
            for(var i = 0; i < enterSplitText.length; i++)if (enterSplitText[i].trim() === "") contentInnerElem += (0, $c77ecbfae9b8c035$export$9f15c5f175f17548)(this.parent);
            else {
                var contentWithSpace = "";
                var spaceBetweenContent = true;
                var spaceSplit = enterSplitText[i].split(" ");
                for(var j = 0; j < spaceSplit.length; j++)if (spaceSplit[j].trim() === "") contentWithSpace += spaceBetweenContent ? "&nbsp;" : " ";
                else {
                    spaceBetweenContent = false;
                    contentWithSpace += spaceSplit[j] + " ";
                }
                if (i === 0) contentInnerElem += "<span>" + contentWithSpace.trim() + "</span>";
                else contentInnerElem += "<p>" + contentWithSpace.trim() + "</p>";
            }
            var divElement = this.parent.createElement("div");
            divElement.setAttribute("class", "pasteContent");
            divElement.style.display = "inline";
            divElement.innerHTML = contentInnerElem.replace("&para", "&amp;para");
            var paraElem = divElement.querySelectorAll("span, p");
            for(var i = 0; i < paraElem.length; i++){
                var splitTextContent = paraElem[i].innerHTML.split(" ");
                var resultSplitContent = "";
                for(var j = 0; j < splitTextContent.length; j++)if (splitTextContent[j].match(httpRegex) || splitTextContent[j].match(wwwRegex)) resultSplitContent += '<a class="e-rte-anchor" href="' + splitTextContent[j] + '" title="' + splitTextContent[j] + '" target="_blank"' + ' aria-label="' + this.parent.serviceLocator.getService("rteLocale").getConstant("linkAriaLabel") + '">' + splitTextContent[j] + " </a>";
                else resultSplitContent += splitTextContent[j] + " ";
                paraElem[i].innerHTML = resultSplitContent.trim();
            }
            var anchorElement = divElement.childNodes[0];
            if (!(0, $3EnZW.isNullOrUndefined)(anchorElement) && !(0, $3EnZW.isNullOrUndefined)(anchorElement.childNodes[0]) && anchorElement.nodeName === "SPAN" && anchorElement.childNodes[0].nodeName === "A") divElement.innerHTML = divElement.innerHTML.replace("<span>", "").replace("</span>", "");
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.pasteCleanupModule)) e.callBack(divElement.innerHTML);
            else this.parent.formatter.editorManager.execCommand("insertHTML", null, null, null, divElement);
        }
    };
    HtmlEditor.prototype.spaceLink = function(e) {
        var range = this.nodeSelectionObj.getRange(this.contentRenderer.getDocument());
        var selectNodeEle = this.nodeSelectionObj.getParentNodeCollection(range);
        var text = range.startContainer.textContent.substr(0, range.endOffset);
        var splitText = text.split(" ");
        var urlText = splitText[splitText.length - 1];
        var urlTextRange = range.startOffset - (text.length - splitText[splitText.length - 1].length);
        urlText = urlText.slice(0, urlTextRange);
        // eslint-disable-next-line
        var regex = new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi);
        if (selectNodeEle[0].nodeName !== "A" && urlText.match(regex)) {
            var selection = this.nodeSelectionObj.save(range, this.parent.contentModule.getDocument());
            var url = urlText.indexOf("http") > -1 ? urlText : "http://" + urlText;
            var selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            var value = {
                url: url,
                selection: selection,
                selectParent: selectParent,
                text: urlText,
                title: "",
                target: "_blank"
            };
            this.parent.formatter.process(this.parent, {
                item: {
                    "command": "Links",
                    "subCommand": "CreateLink"
                }
            }, e, value);
        }
    };
    HtmlEditor.prototype.onToolbarClick = function(args) {
        var _this = this;
        var save;
        var selectNodeEle;
        var selectParentEle;
        var item = args.item;
        var closestElement = (0, $4ZDHT.closest)(args.originalEvent.target, ".e-rte-quick-popup");
        var target = args.originalEvent.target;
        this.parent.notify($947a002e9a697770$export$6108d95d641a81fb, {
            target: target
        });
        if (item.command !== "FormatPainter") {
            if (closestElement && !closestElement.classList.contains("e-rte-inline-popup") && !closestElement.classList.contains("e-rte-text-popup")) {
                if (!(item.subCommand === "SourceCode" || item.subCommand === "Preview" || item.subCommand === "FontColor" || item.subCommand === "BackgroundColor")) {
                    if ((0, $259257662ca103fc$export$80ca177350c4af26)() && item.command === "Images") this.nodeSelectionObj.restore();
                    var range = this.nodeSelectionObj.getRange(this.parent.contentModule.getDocument());
                    save = this.nodeSelectionObj.save(range, this.parent.contentModule.getDocument());
                    selectNodeEle = this.nodeSelectionObj.getNodeCollection(range);
                    selectParentEle = this.nodeSelectionObj.getParentNodeCollection(range);
                }
                if (item.command === "Images") this.parent.notify($947a002e9a697770$export$af013f327a7c9f36, {
                    member: "image",
                    args: args,
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle
                });
                if (item.command === "Audios") this.parent.notify($947a002e9a697770$export$14e4186604d20036, {
                    member: "audio",
                    args: args,
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle
                });
                if (item.command === "Videos") this.parent.notify($947a002e9a697770$export$5f8f11a2ec9ad852, {
                    member: "video",
                    args: args,
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle
                });
                if (item.command === "Links") this.parent.notify($947a002e9a697770$export$977b0775e5db06ed, {
                    member: "link",
                    args: args,
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle
                });
                if (item.command === "Table") this.parent.notify($947a002e9a697770$export$fc73c017dfcf29c9, {
                    member: "table",
                    args: args,
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle
                });
            } else {
                var linkDialog = document.getElementById(this.parent.getID() + "_rtelink");
                var imageDialog = document.getElementById(this.parent.getID() + "_image");
                if (!(item.subCommand === "SourceCode" || item.subCommand === "Preview" || item.subCommand === "FontColor" || item.subCommand === "BackgroundColor" || item.subCommand === "NumberFormatList" || item.subCommand === "BulletFormatList")) {
                    var range = this.nodeSelectionObj.getRange(this.parent.contentModule.getDocument());
                    if ((0, $3EnZW.isNullOrUndefined)(linkDialog) && (0, $3EnZW.isNullOrUndefined)(imageDialog)) save = this.nodeSelectionObj.save(range, this.parent.contentModule.getDocument());
                    selectNodeEle = this.nodeSelectionObj.getNodeCollection(range);
                    selectParentEle = this.nodeSelectionObj.getParentNodeCollection(range);
                }
                switch(item.subCommand){
                    case "Maximize":
                        this.parent.notify($947a002e9a697770$export$6b5a35c4a823eab1, {
                            args: args
                        });
                        break;
                    case "Minimize":
                        this.parent.notify($947a002e9a697770$export$7f96353fc4f89f6b, {
                            args: args
                        });
                        break;
                    case "CreateLink":
                        this.parent.notify($947a002e9a697770$export$c13c4fbf8f656592, {
                            member: "link",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "RemoveLink":
                        this.parent.notify($947a002e9a697770$export$85ed0bdd39881c2c, {
                            member: "link",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "Print":
                        this.parent.print();
                        break;
                    case "Image":
                        this.parent.notify($947a002e9a697770$export$5ae819692184d2fb, {
                            member: "image",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "Audio":
                        this.parent.notify($947a002e9a697770$export$b71d7033796fa5cc, {
                            member: "audio",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "Video":
                        this.parent.notify($947a002e9a697770$export$73a289ac38fc1ec, {
                            member: "video",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "CreateTable":
                        this.parent.notify($947a002e9a697770$export$33bbb3ec7652e187, {
                            member: "table",
                            args: args,
                            selection: save
                        });
                        break;
                    case "SourceCode":
                        this.parent.notify($947a002e9a697770$export$a03f62af6e933a3, {
                            member: "viewSource",
                            args: args
                        });
                        break;
                    case "Preview":
                        this.parent.notify($947a002e9a697770$export$328b0edc9fda3a36, {
                            member: "updateSource",
                            args: args
                        });
                        break;
                    case "FontColor":
                    case "BackgroundColor":
                        break;
                    case "File":
                        this.parent.notify($947a002e9a697770$export$82523cb97e033732, {
                            member: "fileManager",
                            args: args,
                            selectNode: selectNodeEle,
                            selection: save,
                            selectParent: selectParentEle
                        });
                        break;
                    case "EmojiPicker":
                        this.parent.notify($947a002e9a697770$export$4d7e4d3283b3fc57, {
                            member: "emojiPicker",
                            args: args
                        });
                        break;
                    case "ImportWord":
                        this.parent.notify($947a002e9a697770$export$9d60f25f506de572, {});
                        break;
                    case "ExportWord":
                        this.parent.notify($947a002e9a697770$export$386d6cd834630df8, {
                            member: "ExportWord",
                            args: args
                        });
                        break;
                    case "ExportPdf":
                        this.parent.notify($947a002e9a697770$export$386d6cd834630df8, {
                            member: "ExportPdf",
                            args: args
                        });
                        break;
                    default:
                        this.parent.formatter.process(this.parent, args, args.originalEvent, null);
                        break;
                }
            }
        } else if (args.originalEvent.detail === 1) {
            clearTimeout(this.clickTimeout);
            this.clickTimeout = setTimeout(function() {
                _this.parent.notify($947a002e9a697770$export$499fb5841cd4be09, {
                    member: "formatPainter",
                    args: args
                });
            }, 200);
        } else {
            clearTimeout(this.clickTimeout);
            this.parent.notify($947a002e9a697770$export$e26301c11948181c, {
                member: "formatPainter",
                args: args
            });
        }
    };
    HtmlEditor.prototype.instantiateRenderer = function() {
        if (this.parent.iframeSettings.enable) this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content, new (0, $167cf0a6a9a35591$export$4f29d334a579802c)(this.parent));
        else this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content, new (0, $5c966c61f6f4d3b0$export$6e65718da26e0698)(this.parent));
    };
    HtmlEditor.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.render);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($947a002e9a697770$export$d3e2e39ad7d15e6d, this.onToolbarClick);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$b70fe0c8c3456154, this.instantiateRenderer);
        this.parent.off($947a002e9a697770$export$90aca4adda6ff0f5, this.selectAll);
        this.parent.off($947a002e9a697770$export$86be68e1224a0620, this.selectRange);
        this.parent.off($947a002e9a697770$export$76d3c88e0e217d4e, this.getSelectedHtml);
        this.parent.off($947a002e9a697770$export$dd9b49d5e9b25abd, this.onSelectionSave);
        this.parent.off($947a002e9a697770$export$ae80d5dbf349b0b4, this.onSelectionRestore);
        this.parent.off($947a002e9a697770$export$ff4edde773b9bda2, this.updateReadOnly);
        this.parent.off($947a002e9a697770$export$9b6706c8686cfc8e, this.onPaste);
        this.parent.off($947a002e9a697770$export$5dbeb4561f6544b7, this.isTableClassAdded);
    };
    HtmlEditor.prototype.render = function() {
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        var editElement = this.contentRenderer.getEditPanel();
        var option = {
            undoRedoSteps: this.parent.undoRedoSteps,
            undoRedoTimer: this.parent.undoRedoTimer
        };
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.formatter)) {
            var formatterClass = new (0, $e716a16ba77f9b61$export$fd3b937a11f1074e)({
                currentDocument: this.contentRenderer.getDocument(),
                element: editElement,
                options: option,
                formatPainterSettings: this.parent.formatPainterSettings
            });
            this.parent.setProperties({
                formatter: formatterClass
            }, true);
        } else this.parent.formatter.updateFormatter(editElement, this.contentRenderer.getDocument(), option);
        if (this.parent.enableXhtml) this.parent.notify($947a002e9a697770$export$76028e63d5b7a5cc, {});
        if (this.parent.toolbarSettings.enable) this.toolbarUpdate = new (0, $d2002c76fe025874$export$985c0ddff8a9cc89)(this.parent);
        if (this.parent.inlineMode.enable) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontFamily.default)) editElement.style.fontFamily = this.parent.fontFamily.default;
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontSize.default)) editElement.style.fontSize = this.parent.fontSize.default;
        }
        this.parent.notify($947a002e9a697770$export$c909ec3b151c9e0e, {});
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} e - specifies the editor model
     * @returns {void}
     * @hidden

     */ HtmlEditor.prototype.onPropertyChanged = function(e) {
        // On property code change here
        if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.newProp.toolbarSettings) && !(0, $3EnZW.isNullOrUndefined)(e.newProp.toolbarSettings.enable)) this.toolbarUpdate = new (0, $d2002c76fe025874$export$985c0ddff8a9cc89)(this.parent);
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.formatter)) {
            var editElement = this.contentRenderer.getEditPanel();
            var option = {
                undoRedoSteps: this.parent.undoRedoSteps,
                undoRedoTimer: this.parent.undoRedoTimer
            };
            this.parent.formatter.updateFormatter(editElement, this.contentRenderer.getDocument(), option);
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string value
     * @hidden
     */ HtmlEditor.prototype.getModuleName = function() {
        return "htmlEditor";
    };
    /**
     * For selecting all content in RTE
     *
     * @returns {void}
     * @private
     * @hidden
     */ HtmlEditor.prototype.selectAll = function() {
        var nodes = (0, $c77ecbfae9b8c035$export$583075c8d044926c)(this.parent.contentModule.getDocument(), this.parent.contentModule.getEditPanel());
        if (nodes.length > 0) this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.parent.contentModule.getDocument(), nodes[0], nodes[nodes.length - 1], 0, nodes[nodes.length - 1].textContent.length);
    };
    /**
     * For selecting all content in RTE
     *
     * @param {NotifyArgs} e - specifies the notified arguments
     * @returns {void}
     * @private
     * @hidden
     */ HtmlEditor.prototype.selectRange = function(e) {
        this.parent.formatter.editorManager.nodeSelection.setRange(this.parent.contentModule.getDocument(), e.range);
    };
    /**
     * For get a selected text in RTE
     *
     * @param {NotifyArgs} e - specifies the notified arguments
     * @returns {void}
     * @hidden
     */ HtmlEditor.prototype.getSelectedHtml = function(e) {
        e.callBack(this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()).toString());
    };
    HtmlEditor.prototype.tableSelectionKeyAction = function(e) {
        var args = e.args;
        // Handle the space, enter and backspace keys when the table cells are selected.
        var tableCellSelectNodes = this.parent.inputElement.querySelectorAll(".e-cell-select");
        for(var i = 0; i < tableCellSelectNodes.length; i++){
            var currentCell = tableCellSelectNodes[i];
            (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                currentCell
            ], [
                $afc560df281b588d$export$e959d74fe932d9e5,
                $afc560df281b588d$export$4a8550b2cafbc9fc,
                $afc560df281b588d$export$fb3f256521ea2317
            ]);
            if (i === 0) {
                if (args.keyCode === 32) currentCell.innerHTML = "&#8203;<br>";
                else currentCell.innerHTML = "<br>";
                this.nodeSelectionObj.setCursorPoint(this.parent.contentModule.getDocument(), currentCell.firstChild, 0);
            } else currentCell.innerHTML = "<br>";
        }
    };
    HtmlEditor.prototype.marginTabAdd = function(val, alignmentNodes) {
        for(var index = 0; index < alignmentNodes.length; index++){
            var element = alignmentNodes[index];
            if (element.closest("li")) continue;
            if (element.style.marginLeft) {
                var count = parseInt(element.style.marginLeft, 10);
                if (val) count -= 20;
                else count += 20;
                element.style.marginLeft = count.toString() + "px";
                if (element.style.marginLeft === "0px") element.removeAttribute("style");
            } else if (!val) element.style.marginLeft = "20px";
        }
    };
    return HtmlEditor;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");




var $2vAqh = parcelRequire("2vAqh");





/**
 * `Image` module is used to handle image actions.
 */ var $49a6f5fde11efa2c$export$3e431a229df88919 = /** @class */ function() {
    function Image(parent, serviceLocator) {
        this.isImgUploaded = false;
        this.isAllowedTypes = true;
        this.pageX = null;
        this.pageY = null;
        this.deletedImg = [];
        this.parent = parent;
        this.rteID = parent.element.id;
        this.i10n = serviceLocator.getService("rteLocale");
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.addEventListener();
        this.drop = this.dragDrop.bind(this);
        this.drag = this.dragOver.bind(this);
        this.enter = this.dragEnter.bind(this);
        this.start = this.dragStart.bind(this);
        this.docClick = this.onDocumentClick.bind(this);
        this.isDestroyed = false;
    }
    Image.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp, this);
        this.parent.on($947a002e9a697770$export$5ae819692184d2fb, this.insertImage, this);
        this.parent.on($947a002e9a697770$export$5617ef57439be2b, this.showDialog, this);
        this.parent.on($947a002e9a697770$export$5884d34c82a0825a, this.closeDialog, this);
        this.parent.on($947a002e9a697770$export$bad6189f4d27c01f, this.onWindowResize, this);
        this.parent.on($947a002e9a697770$export$ac0f8621e12395a0, this.showImageQuickToolbar, this);
        this.parent.on($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj, this);
        this.parent.on($947a002e9a697770$export$af013f327a7c9f36, this.onToolbarAction, this);
        this.parent.on($947a002e9a697770$export$d1a88e38890bde53, this.caption, this);
        this.parent.on($947a002e9a697770$export$bf265c1f5581a919, this.deleteImg, this);
        this.parent.on($947a002e9a697770$export$d5e570a5ba3c39ae, this.insertImgLink, this);
        this.parent.on($947a002e9a697770$export$da137bcb4d9a1f5c, this.insertAltText, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$da6ba7b3a8f90d94, this.imageSize, this);
        this.parent.on($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$446aef6294af7f8b, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$9b6706c8686cfc8e, this.imagePaste, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    Image.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp);
        this.parent.off($947a002e9a697770$export$bad6189f4d27c01f, this.onWindowResize);
        this.parent.off($947a002e9a697770$export$5ae819692184d2fb, this.insertImage);
        this.parent.off($947a002e9a697770$export$5617ef57439be2b, this.showDialog);
        this.parent.off($947a002e9a697770$export$5884d34c82a0825a, this.closeDialog);
        this.parent.off($947a002e9a697770$export$ac0f8621e12395a0, this.showImageQuickToolbar);
        this.parent.off($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj);
        this.parent.off($947a002e9a697770$export$d1a88e38890bde53, this.caption);
        this.parent.off($947a002e9a697770$export$af013f327a7c9f36, this.onToolbarAction);
        this.parent.off($947a002e9a697770$export$bf265c1f5581a919, this.deleteImg);
        this.parent.off($947a002e9a697770$export$d5e570a5ba3c39ae, this.insertImgLink);
        this.parent.off($947a002e9a697770$export$da137bcb4d9a1f5c, this.insertAltText);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$da6ba7b3a8f90d94, this.imageSize);
        this.parent.off($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.afterRender);
        this.parent.off($947a002e9a697770$export$446aef6294af7f8b, this.afterRender);
        this.parent.off($947a002e9a697770$export$9b6706c8686cfc8e, this.imagePaste);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        var dropElement = this.parent.iframeSettings.enable ? this.parent.inputElement.ownerDocument : this.parent.inputElement;
        dropElement.removeEventListener("drop", this.drop, true);
        dropElement.removeEventListener("dragstart", this.drag, true);
        dropElement.removeEventListener("dragenter", this.enter, true);
        dropElement.removeEventListener("dragover", this.start, true);
        this.drop = null;
        this.drag = null;
        this.enter = null;
        this.start = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule)) {
            (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.imageClick);
            this.parent.formatter.editorManager.observer.off($947a002e9a697770$export$b2d123672bfdbe32, this.undoStack);
            if (this.parent.insertImageSettings.resize) {
                (0, $aqzbR.EventHandler).remove(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
                this.parent.element.ownerDocument.removeEventListener("mousedown", this.docClick);
                this.docClick = null;
                (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), "cut", this.onCutHandler);
                (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
            }
        }
    };
    Image.prototype.updateCss = function(currentObj, e) {
        if (currentObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) currentObj.setProperties({
                cssClass: (currentObj.cssClass + " " + e.cssClass).trim()
            });
            else currentObj.setProperties({
                cssClass: (currentObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    // eslint-disable-next-line @typescript-eslint/tslint/config
    Image.prototype.setCssClass = function(e) {
        if (this.popupObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) (0, $4ZDHT.addClass)([
                this.popupObj.element
            ], e.cssClass);
            else {
                (0, $4ZDHT.removeClass)([
                    this.popupObj.element
                ], e.oldCssClass);
                (0, $4ZDHT.addClass)([
                    this.popupObj.element
                ], e.cssClass);
            }
        }
        this.updateCss(this.checkBoxObj, e);
        this.updateCss(this.widthNum, e);
        this.updateCss(this.heightNum, e);
        this.updateCss(this.uploadObj, e);
        this.updateCss(this.dialogObj, e);
    };
    Image.prototype.onIframeMouseDown = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Image.prototype.afterRender = function() {
        this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.imageClick, this);
        if (this.parent.insertImageSettings.resize) {
            (0, $aqzbR.EventHandler).add(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart, this);
            this.parent.element.ownerDocument.addEventListener("mousedown", this.docClick);
            (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), "cut", this.onCutHandler, this);
        }
        var dropElement = this.parent.iframeSettings.enable ? this.parent.inputElement.ownerDocument : this.parent.inputElement;
        dropElement.addEventListener("drop", this.drop, true);
        dropElement.addEventListener("dragstart", this.drag, true);
        dropElement.addEventListener("dragenter", this.enter, true);
        dropElement.addEventListener("dragover", this.start, true);
    };
    Image.prototype.undoStack = function(args) {
        if ((args.subCommand.toLowerCase() === "undo" || args.subCommand.toLowerCase() === "redo") && this.parent.editorMode === "HTML") for(var i = 0; i < this.parent.formatter.getUndoRedoStack().length; i++){
            var temp = this.parent.createElement("div");
            var contentElem = this.parent.formatter.getUndoRedoStack()[i].text;
            temp.appendChild(contentElem.cloneNode(true));
            var img = temp.querySelectorAll("img");
            if (temp.querySelector(".e-img-resize") && img.length > 0) {
                for(var j = 0; j < img.length; j++)img[j].style.outline = "";
                (0, $4ZDHT.detach)(temp.querySelector(".e-img-resize"));
                var clonedElement = temp.cloneNode(true);
                var fragment = document.createDocumentFragment();
                while(clonedElement.firstChild)fragment.appendChild(clonedElement.firstChild);
                this.parent.formatter.getUndoRedoStack()[i].text = fragment;
            }
        }
    };
    Image.prototype.resizeEnd = function(e) {
        this.resizeBtnInit();
        if (this.imgEle.parentElement) this.imgEle.parentElement.style.cursor = "auto";
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.removeClass)([
            e.target.parentElement
        ], "e-mob-span");
        var args = {
            event: e,
            requestType: "images"
        };
        this.parent.trigger($947a002e9a697770$export$8c4d3b559babc6db, args);
        this.parent.formatter.editorManager.observer.on($947a002e9a697770$export$b2d123672bfdbe32, this.undoStack, this);
        this.parent.formatter.saveData();
    };
    Image.prototype.resizeStart = function(e, ele) {
        var _this = this;
        if (this.parent.readonly) return;
        var target = ele ? ele : e.target;
        this.prevSelectedImgEle = this.imgEle;
        if (target.tagName === "IMG") {
            this.parent.preventDefaultResize(e);
            var img = target;
            if (this.imgResizeDiv && this.contentModule.getEditPanel().contains(this.imgResizeDiv)) (0, $4ZDHT.detach)(this.imgResizeDiv);
            this.imageResize(img);
        }
        if (target.classList.contains("e-rte-imageboxmark")) {
            if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
            this.pageX = this.getPointX(e);
            this.pageY = this.getPointY(e);
            e.preventDefault();
            e.stopImmediatePropagation();
            this.resizeBtnInit();
            if (this.quickToolObj) this.quickToolObj.imageQTBar.hidePopup();
            var handlers = [
                "topLeft",
                "topRight",
                "botLeft",
                "botRight"
            ];
            for(var i = 0; i < handlers.length; i++){
                var handler = handlers[i];
                if (target.classList.contains("e-rte-" + handler)) {
                    this.resizeBtnStat[handler] = true;
                    this.currentResizeHandler = handler;
                    this.aspectRatio = this.findAspectRatio(this.imgEle);
                    break; // Exit the loop once a match is found
                }
            }
            if ((0, $5q7BP.Browser).isDevice && this.contentModule.getEditPanel().contains(this.imgResizeDiv) && !this.imgResizeDiv.classList.contains("e-mob-span")) (0, $4ZDHT.addClass)([
                this.imgResizeDiv
            ], "e-mob-span");
            else {
                var args = {
                    event: e,
                    requestType: "images"
                };
                this.parent.trigger($947a002e9a697770$export$6aff6a45c0c4e7c4, args, function(resizeStartArgs) {
                    if (resizeStartArgs.cancel) _this.cancelResizeAction();
                });
            }
            (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing, this);
            (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd, this);
        }
    };
    Image.prototype.imageClick = function(e) {
        if ((0, $5q7BP.Browser).isDevice) {
            if (e.target.tagName === "IMG" && e.target.parentElement.tagName === "A" || e.target.tagName === "IMG") {
                this.contentModule.getEditPanel().setAttribute("contenteditable", "false");
                e.target.focus();
            } else if (!this.parent.readonly) this.contentModule.getEditPanel().setAttribute("contenteditable", "true");
        }
        if (e.target.tagName === "IMG" && e.target.parentElement.tagName === "A") e.preventDefault();
    };
    Image.prototype.onCutHandler = function() {
        if (this.imgResizeDiv && this.contentModule.getEditPanel().contains(this.imgResizeDiv)) this.cancelResizeAction();
    };
    Image.prototype.imageResize = function(e) {
        this.resizeBtnInit();
        this.imgEle = e;
        (0, $4ZDHT.addClass)([
            this.imgEle
        ], "e-resize");
        this.imgResizeDiv = this.parent.createElement("span", {
            className: "e-img-resize" + this.parent.getCssClass(true),
            id: this.rteID + "_imgResize"
        });
        this.imgResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-imageboxmark e-rte-topLeft" + this.parent.getCssClass(true),
            styles: "cursor: nwse-resize"
        }));
        this.imgResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-imageboxmark e-rte-topRight" + this.parent.getCssClass(true),
            styles: "cursor: nesw-resize"
        }));
        this.imgResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-imageboxmark e-rte-botLeft" + this.parent.getCssClass(true),
            styles: "cursor: nesw-resize"
        }));
        this.imgResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-imageboxmark e-rte-botRight" + this.parent.getCssClass(true),
            styles: "cursor: nwse-resize"
        }));
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.addClass)([
            this.imgResizeDiv
        ], "e-mob-rte");
        e.style.outline = "2px solid #4a90e2";
        this.imgResizePos(e, this.imgResizeDiv);
        this.resizeImgDupPos(e);
        this.contentModule.getEditPanel().appendChild(this.imgResizeDiv);
    };
    Image.prototype.getPointX = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageX;
        else return e.pageX;
    };
    Image.prototype.getPointY = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageY;
        else return e.pageY;
    };
    Image.prototype.imgResizePos = function(e, imgResizeDiv) {
        var pos = this.calcPos(e);
        var top = pos.top;
        var left = pos.left;
        var imgWid = e.getBoundingClientRect().width;
        var imgHgt = e.getBoundingClientRect().height;
        var borWid = (0, $5q7BP.Browser).isDevice ? 4 * parseInt(e.style.outline.slice(-3), 10) + 2 : 2 * parseInt(e.style.outline.slice(-3), 10) + 2; //span border width + image outline width
        var devWid = (0, $5q7BP.Browser).isDevice ? 0 : 2; // span border width
        imgResizeDiv.querySelector(".e-rte-botLeft").style.left = left - borWid + "px";
        imgResizeDiv.querySelector(".e-rte-botLeft").style.top = imgHgt - borWid + top + "px";
        imgResizeDiv.querySelector(".e-rte-botRight").style.left = imgWid - (borWid - devWid) + left + "px";
        imgResizeDiv.querySelector(".e-rte-botRight").style.top = imgHgt - borWid + top + "px";
        imgResizeDiv.querySelector(".e-rte-topRight").style.left = imgWid - (borWid - devWid) + left + "px";
        imgResizeDiv.querySelector(".e-rte-topRight").style.top = top - borWid + "px";
        imgResizeDiv.querySelector(".e-rte-topLeft").style.left = left - borWid + "px";
        imgResizeDiv.querySelector(".e-rte-topLeft").style.top = top - borWid + "px";
    };
    Image.prototype.calcPos = function(elem) {
        var ignoreOffset = [
            "TD",
            "TH",
            "TABLE",
            "A"
        ];
        var parentOffset = {
            top: 0,
            left: 0
        };
        var elementOffset;
        var doc = elem.ownerDocument;
        var offsetParent = (elem.offsetParent && (elem.offsetParent.classList.contains("e-img-caption") || ignoreOffset.indexOf(elem.offsetParent.tagName) > -1) ? (0, $4ZDHT.closest)(elem, "#" + this.parent.getID() + "_rte-edit-view") : elem.offsetParent) || doc.documentElement;
        while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && offsetParent.style.position === "static")offsetParent = offsetParent.parentNode;
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) parentOffset = offsetParent.getBoundingClientRect();
        if (elem.offsetParent && elem.offsetParent.classList.contains("e-img-caption")) {
            elementOffset = elem.getBoundingClientRect();
            return {
                top: elementOffset.top - parentOffset.top,
                left: elementOffset.left - parentOffset.left
            };
        } else return {
            top: elem.offsetTop,
            left: elem.offsetLeft
        };
    };
    Image.prototype.setAspectRatio = function(img, expectedX, expectedY) {
        if ((0, $3EnZW.isNullOrUndefined)(img.width)) return;
        var width = img.width;
        var height = img.height;
        var sameHeightWidth = width === height;
        var factor = this.parent.insertImageSettings.resizeByPercent ? "%" : "px";
        var emptyStyleDimension = img.style.width === "" && img.style.height === "";
        if (!sameHeightWidth && !emptyStyleDimension) {
            if (img.style.width !== "" && img.style.height !== "") {
                if (this.parent.insertImageSettings.resizeByPercent) {
                    this.setImageWidth(img, expectedX, factor);
                    this.removeImageHeight(img);
                } else {
                    this.setImageWidth(img, expectedX, factor);
                    this.setImageHeight(img, expectedY, factor);
                }
            } else if (img.style.width !== "") {
                if (this.parent.insertImageSettings.resizeByPercent) {
                    this.setImageWidth(img, expectedX, factor);
                    this.removeImageHeight(img);
                } else this.setImageWidth(img, expectedX, factor);
            } else if (img.style.height !== "") {
                if (this.parent.insertImageSettings.resizeByPercent) {
                    this.setImageWidth(img, expectedX, factor);
                    this.removeImageHeight(img);
                } else this.setImageHeight(img, expectedY, factor);
            }
        } else {
            this.setImageWidth(img, expectedX, factor);
            if (this.parent.insertImageSettings.resizeByPercent) this.removeImageHeight(img);
            else this.setImageHeight(img, expectedY, factor);
        }
    };
    Image.prototype.setImageWidth = function(img, value, suffix) {
        img.style.width = this.getImageDimension(value, img) + suffix;
        if (!this.parent.insertImageSettings.resizeByPercent) img.setAttribute("width", value.toString());
    };
    Image.prototype.setImageHeight = function(img, value, suffix) {
        img.style.height = this.getImageDimension(value, img) + suffix;
        if (!this.parent.insertImageSettings.resizeByPercent) img.setAttribute("height", value.toString());
    };
    Image.prototype.removeImageHeight = function(img) {
        img.style.height = "";
        img.removeAttribute("height");
    };
    Image.prototype.getImageDimension = function(value, img) {
        if (this.parent.insertImageSettings.resizeByPercent) {
            var rootElem = img.parentElement;
            return this.pixToPerc(value, rootElem);
        } else return value;
    };
    Image.prototype.adjustDimensionsByAspectRatio = function(width, height, aspectRatio, isWidthPrimary) {
        if (isWidthPrimary) {
            height = Math.round(width / aspectRatio);
            width = Math.round(height * aspectRatio);
        } else {
            width = Math.round(height * aspectRatio);
            height = Math.round(width / aspectRatio);
        }
        return {
            width: width,
            height: height
        };
    };
    Image.prototype.pixToPerc = function(expected, parentEle) {
        return expected / parseFloat(getComputedStyle(parentEle).width) * 100;
    };
    Image.prototype.imgDupMouseMove = function(width, height, e) {
        var _this = this;
        var args = {
            event: e,
            requestType: "images"
        };
        this.parent.trigger($947a002e9a697770$export$45b39e67d4ce4921, args, function(resizingArgs) {
            if (resizingArgs.cancel) _this.cancelResizeAction();
            else {
                if (parseInt(_this.parent.insertImageSettings.minWidth, 10) >= parseInt(width, 10) || parseInt(_this.parent.getInsertImgMaxWidth(), 10) <= parseInt(width, 10) && (0, $3EnZW.isNullOrUndefined)(_this.imgEle.style.width)) return;
                if (!_this.parent.insertImageSettings.resizeByPercent && (parseInt(_this.parent.insertImageSettings.minHeight, 10) >= parseInt(height, 10) || parseInt(_this.parent.insertImageSettings.maxHeight, 10) <= parseInt(height, 10))) return;
                _this.imgEle.parentElement.style.cursor = "pointer";
                _this.setAspectRatio(_this.imgEle, parseInt(width, 10), parseInt(height, 10));
                _this.resizeImgDupPos(_this.imgEle);
                _this.imgResizePos(_this.imgEle, _this.imgResizeDiv);
            }
        });
    };
    Image.prototype.resizing = function(e) {
        if (!this.parent) {
            this.cancelResizeAction();
            return;
        }
        if (this.resizeBtnStat.botRight || this.resizeBtnStat.botLeft || this.resizeBtnStat.topRight || this.resizeBtnStat.topLeft) {
            var pageX = this.getPointX(e);
            var pageY = this.getPointY(e);
            var resizeFactor = this.getResizeFactor(this.currentResizeHandler);
            var diffX = pageX - this.pageX;
            var diffY = pageY - this.pageY;
            var currentWidth = this.imgEle.clientWidth;
            var currentHeight = this.imgEle.clientHeight;
            var width = diffX * resizeFactor[0] + currentWidth;
            var height = diffY * resizeFactor[1] + currentHeight;
            var dimensions = this.adjustDimensions(width, height, diffX, diffY, this.aspectRatio);
            this.pageX = pageX;
            this.pageY = pageY;
            this.imgDupMouseMove(dimensions.width + "px", dimensions.height + "px", e);
        }
    };
    Image.prototype.adjustDimensions = function(width, height, diffX, diffY, aspectRatio) {
        width = width < 16 ? 16 : width;
        height = height < 16 ? 16 : height;
        var isWidthPrimary = Math.abs(diffX) > Math.abs(diffY);
        var dimensions = this.adjustDimensionsByAspectRatio(width, height, aspectRatio, isWidthPrimary);
        return dimensions;
    };
    Image.prototype.getResizeFactor = function(value) {
        return (0, $9dc0015271a44eb1$export$217aab06593c0153)[value];
    };
    Image.prototype.findAspectRatio = function(image) {
        return image.clientWidth / image.clientHeight;
    };
    Image.prototype.cancelResizeAction = function() {
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        if (this.imgEle && this.imgResizeDiv && this.contentModule.getEditPanel().contains(this.imgResizeDiv)) {
            (0, $4ZDHT.detach)(this.imgResizeDiv);
            this.imgEle.style.outline = "";
            this.imgResizeDiv = null;
            this.pageX = null;
            this.pageY = null;
            this.currentResizeHandler = null;
            this.aspectRatio = null;
        }
    };
    Image.prototype.resizeImgDupPos = function(e) {
        this.imgDupPos = {
            width: e.style.width !== "" && this.parent.insertImageSettings && !this.parent.insertImageSettings.resizeByPercent ? this.imgEle.style.width : e.width + "px",
            height: e.style.height !== "" ? this.imgEle.style.height : e.height + "px"
        };
    };
    Image.prototype.resizeBtnInit = function() {
        this.aspectRatio = null;
        this.currentResizeHandler = null;
        return this.resizeBtnStat = {
            botLeft: false,
            botRight: false,
            topRight: false,
            topLeft: false
        };
    };
    Image.prototype.onToolbarAction = function(args) {
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
        var item = args.args.item;
        switch(item.subCommand){
            case "Replace":
                if (this.parent.fileManagerSettings.enable) this.parent.notify($947a002e9a697770$export$82523cb97e033732, args);
                else this.parent.notify($947a002e9a697770$export$5ae819692184d2fb, args);
                break;
            case "Caption":
                this.parent.notify($947a002e9a697770$export$d1a88e38890bde53, args);
                break;
            case "InsertLink":
                this.parent.notify($947a002e9a697770$export$d5e570a5ba3c39ae, args);
                break;
            case "AltText":
                this.parent.notify($947a002e9a697770$export$da137bcb4d9a1f5c, args);
                break;
            case "Remove":
                this.parent.notify($947a002e9a697770$export$bf265c1f5581a919, args);
                break;
            case "Dimension":
                this.parent.notify($947a002e9a697770$export$da6ba7b3a8f90d94, args);
                break;
            case "OpenImageLink":
                this.openImgLink(args);
                break;
            case "EditImageLink":
                this.editImgLink(args);
                break;
            case "RemoveImageLink":
                this.removeImgLink(args);
                break;
        }
    };
    Image.prototype.openImgLink = function(e) {
        var target = e.selectParent[0].parentNode.target === "" ? "_self" : "_blank";
        this.parent.formatter.process(this.parent, e.args, e.args, {
            url: e.selectParent[0].parentNode.href,
            target: target,
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
    };
    Image.prototype.editImgLink = function(e) {
        var selectParentEle = e.selectParent[0].parentNode;
        var linkUpdate = this.i10n.getConstant("dialogUpdate");
        var inputDetails = {
            url: selectParentEle.href,
            target: selectParentEle.target,
            header: "Edit Link",
            btnText: linkUpdate
        };
        this.insertImgLink(e, inputDetails);
    };
    Image.prototype.removeImgLink = function(e) {
        if ((0, $5q7BP.Browser).isIE) this.contentModule.getEditPanel().focus();
        e.selection.restore();
        var isCapLink = this.contentModule.getEditPanel().contains(this.captionEle) && (0, $4ZDHT.select)("a", this.captionEle) ? true : false;
        var selectParent = isCapLink ? [
            this.captionEle
        ] : [
            e.selectNode[0].parentElement
        ];
        this.parent.formatter.process(this.parent, e.args, e.args, {
            insertElement: e.selectNode[0],
            selectParent: selectParent,
            selection: e.selection,
            subCommand: e.args.item.subCommand
        });
        if (this.quickToolObj && document.body.contains(this.quickToolObj.imageQTBar.element)) {
            this.quickToolObj.imageQTBar.hidePopup();
            if (!(0, $3EnZW.isNullOrUndefined)(e.selectParent)) (0, $4ZDHT.removeClass)([
                e.selectParent[0]
            ], "e-img-focus");
        }
        if (isCapLink) (0, $4ZDHT.select)(".e-img-inner", this.captionEle).focus();
    };
    Image.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        this.deletedImg = [];
        var isCursor;
        var keyCodeValues = [
            27,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            44,
            45,
            9,
            16,
            17,
            18,
            19,
            20,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            91,
            92,
            93,
            144,
            145,
            182,
            183
        ];
        if (this.parent.editorMode === "HTML") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            isCursor = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
        }
        if (!isCursor && this.parent.editorMode === "HTML" && keyCodeValues.indexOf(originalEvent.which) < 0) {
            var nodes = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            for(var i = 0; i < nodes.length; i++)if (nodes[i].nodeName === "IMG") this.deletedImg.push(nodes[i]);
        }
        if (this.parent.editorMode === "HTML" && (originalEvent.which === 8 && originalEvent.code === "Backspace" || originalEvent.which === 46 && originalEvent.code === "Delete")) {
            var isCursor_1 = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (originalEvent.which === 8 && originalEvent.code === "Backspace" && isCursor_1) this.checkImageBack(range);
            else if (originalEvent.which === 46 && originalEvent.code === "Delete" && isCursor_1) this.checkImageDel(range);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && originalEvent.code !== "KeyK") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            if (!originalEvent.ctrlKey && originalEvent.key && (originalEvent.key.length === 1 || originalEvent.action === "enter") && !(0, $3EnZW.isNullOrUndefined)(selectParentEle[0]) && selectParentEle[0].tagName === "IMG" && selectParentEle[0].parentElement) {
                if (this.contentModule.getEditPanel().querySelector(".e-img-resize")) this.removeResizeEle();
                (0, $4ZDHT.removeClass)([
                    selectParentEle[0]
                ], "e-img-focus");
                if (this.quickToolObj && this.quickToolObj.imageQTBar) this.quickToolObj.imageQTBar.hidePopup();
            }
        }
        if (originalEvent.ctrlKey && (originalEvent.keyCode === 89 || originalEvent.keyCode === 90)) {
            if (this.parent.editorMode !== "Markdown") this.undoStack({
                subCommand: originalEvent.keyCode === 90 ? "undo" : "redo"
            });
        }
        if (originalEvent.keyCode === 8 || originalEvent.keyCode === 46) {
            if (selectNodeEle && selectNodeEle[0].nodeName === "IMG" && selectNodeEle.length < 1) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                originalEvent.preventDefault();
                var event_1 = {
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle,
                    args: {
                        item: {
                            command: "Images",
                            subCommand: "Remove"
                        },
                        originalEvent: originalEvent
                    }
                };
                this.deleteImg(event_1, originalEvent.keyCode);
            }
            if (this.parent.contentModule.getEditPanel().querySelector(".e-img-resize")) this.removeResizeEle();
        }
        if (originalEvent.code === "Backspace") originalEvent.action = "backspace";
        switch(originalEvent.action){
            case "escape":
                if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) this.dialogObj.close();
                break;
            case "backspace":
            case "delete":
                if (this.parent.editorMode !== "Markdown") {
                    if (range.startContainer.nodeType === 3) {
                        if (originalEvent.code === "Backspace") {
                            if (range.startContainer.previousElementSibling && range.startOffset === 0 && range.startContainer.previousElementSibling.classList.contains($afc560df281b588d$export$8cc8187364c14638) && range.startContainer.previousElementSibling.classList.contains($afc560df281b588d$export$dcd8f689ae4af23c)) (0, $4ZDHT.detach)(range.startContainer.previousElementSibling);
                        } else if (range.startContainer.nextElementSibling && range.endContainer.textContent.length === range.endOffset && range.startContainer.nextElementSibling.classList.contains($afc560df281b588d$export$8cc8187364c14638) && range.startContainer.nextElementSibling.classList.contains($afc560df281b588d$export$dcd8f689ae4af23c)) (0, $4ZDHT.detach)(range.startContainer.nextElementSibling);
                    } else if (range.startContainer.nodeType === 1) {
                        if (range.startContainer.querySelector("." + $afc560df281b588d$export$8cc8187364c14638 + "." + $afc560df281b588d$export$dcd8f689ae4af23c)) (0, $4ZDHT.detach)(range.startContainer.querySelector("." + $afc560df281b588d$export$8cc8187364c14638 + "." + $afc560df281b588d$export$dcd8f689ae4af23c));
                        else if (range.startContainer.querySelector("." + $afc560df281b588d$export$8cc8187364c14638 + "." + $afc560df281b588d$export$c6e979ddaa53685e)) (0, $4ZDHT.detach)(range.startContainer.querySelector("." + $afc560df281b588d$export$8cc8187364c14638 + "." + $afc560df281b588d$export$c6e979ddaa53685e));
                        else if (range.startContainer.classList.contains("e-img-wrap") && (0, $4ZDHT.closest)(range.startContainer, "." + $afc560df281b588d$export$8cc8187364c14638)) {
                            var parentElem = range.startContainer.parentElement.parentElement;
                            (0, $4ZDHT.detach)((0, $4ZDHT.closest)(range.startContainer, "." + $afc560df281b588d$export$8cc8187364c14638));
                            if (parentElem && parentElem.textContent.trim() === "") {
                                var brElem = this.parent.createElement("br");
                                brElem.classList.add("e-rte-image-remove-focus");
                                parentElem.appendChild(brElem);
                            }
                        }
                    }
                }
                break;
            case "insert-image":
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                this.openDialog(true, originalEvent, save, selectNodeEle, selectParentEle);
                originalEvent.preventDefault();
                break;
        }
        if (originalEvent.ctrlKey && originalEvent.key === "a") this.handleSelectAll();
    };
    Image.prototype.handleSelectAll = function() {
        this.cancelResizeAction();
        var imgFocusNodes = this.parent.inputElement.querySelectorAll("." + $afc560df281b588d$export$cab1e7d690401761);
        (0, $4ZDHT.removeClass)(imgFocusNodes, $afc560df281b588d$export$cab1e7d690401761);
    };
    Image.prototype.openDialog = function(isInternal, event, selection, ele, parentEle) {
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        if (!isInternal && !(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = selection;
            selectNodeEle = ele;
            selectParentEle = parentEle;
        }
        if (this.parent.editorMode === "HTML") this.insertImage({
            args: {
                item: {
                    command: "Images",
                    subCommand: "Image"
                },
                originalEvent: event,
                name: !isInternal ? "showDialog" : null
            },
            selectNode: selectNodeEle,
            selection: save,
            selectParent: selectParentEle
        });
        else this.insertImage({
            args: {
                item: {
                    command: "Images",
                    subCommand: "Image"
                },
                originalEvent: event,
                name: !isInternal ? "showDialog" : null
            },
            member: "image",
            text: this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()),
            module: "Markdown",
            name: "insertImage"
        });
    };
    Image.prototype.showDialog = function() {
        this.openDialog(false);
        this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    Image.prototype.closeDialog = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Image.prototype.onKeyUp = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.deletedImg) && this.deletedImg.length > 0) {
            var deleteImages = Array.from(this.deletedImg);
            for(var i = deleteImages.length - 1; i >= 0; i--){
                var args = {
                    element: this.deletedImg[i],
                    src: this.deletedImg[i].getAttribute("src")
                };
                this.parent.trigger($947a002e9a697770$export$61590b3a6f2109b, args);
                this.deletedImg.splice(i, 1);
            }
        }
    };
    Image.prototype.checkImageBack = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === 0 && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.previousSibling) && range.startContainer.previousSibling.nodeName === "IMG") this.deletedImg.push(range.startContainer.previousSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset - 1]) && range.startContainer.childNodes[range.startOffset - 1].nodeName === "IMG") this.deletedImg.push(range.startContainer.childNodes[range.startOffset - 1]);
    };
    Image.prototype.checkImageDel = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === range.startContainer.textContent.length && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.nextSibling) && range.startContainer.nextSibling.nodeName === "IMG") this.deletedImg.push(range.startContainer.nextSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset]) && range.startContainer.childNodes[range.startOffset].nodeName === "IMG") this.deletedImg.push(range.startContainer.childNodes[range.startOffset]);
    };
    Image.prototype.alignmentSelect = function(e) {
        var item = e.item;
        if (!document.body.contains(document.body.querySelector(".e-rte-quick-toolbar")) || item.command !== "Images") return;
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
        selectNodeEle = selectNodeEle[0].nodeName === "IMG" ? selectNodeEle : [
            this.imgEle
        ];
        var args = {
            args: e,
            selectNode: selectNodeEle
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        switch(item.subCommand){
            case "JustifyLeft":
                this.alignImage(args);
                break;
            case "JustifyCenter":
                this.alignImage(args);
                break;
            case "JustifyRight":
                this.alignImage(args);
                break;
            case "Inline":
                this.inline(args);
                break;
            case "Break":
                this.break(args);
                break;
        }
        if (this.quickToolObj && document.body.contains(this.quickToolObj.imageQTBar.element)) {
            this.quickToolObj.imageQTBar.hidePopup();
            (0, $4ZDHT.removeClass)([
                selectNodeEle[0]
            ], "e-img-focus");
        }
        this.cancelResizeAction();
    };
    Image.prototype.imageWithLinkQTBarItemUpdate = function() {
        var items = this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item");
        for(var i = 0; i < items.length; i++){
            if (items[i].getAttribute("title") === this.i10n.getConstant("openLink") || items[i].getAttribute("title") === this.i10n.getConstant("editLink") || items[i].getAttribute("title") === this.i10n.getConstant("removeLink")) {
                (0, $4ZDHT.addClass)([
                    items[i]
                ], "e-link-groups");
                items[i].style.display = "none";
            } else if (items[i].getAttribute("title") === "Insert Link") items[i].style.display = "";
            else if (items[i].classList.contains("e-rte-horizontal-separator")) (0, $4ZDHT.detach)(items[i]);
        }
        var newItems = this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item:not(.e-link-groups)");
        this.quickToolObj.imageQTBar.addQTBarItem([
            "-"
        ], Math.round(newItems.length / 2));
    };
    Image.prototype.showImageQuickToolbar = function(e) {
        var _this = this;
        if (e.type !== "Images" || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule) || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule.imageQTBar) || (0, $3EnZW.isNullOrUndefined)(e.args)) return;
        this.quickToolObj = this.parent.quickToolbarModule;
        var args = e.args;
        var target = e.elements;
        [].forEach.call(e.elements, function(element, index) {
            if (index === 0) target = element;
        });
        if (target && !(0, $4ZDHT.closest)(target, "a")) this.imageWithLinkQTBarItemUpdate();
        if (target.nodeName === "IMG") (0, $4ZDHT.addClass)([
            target
        ], [
            "e-img-focus"
        ]);
        var pageY = this.parent.iframeSettings.enable ? window.pageYOffset + this.parent.element.getBoundingClientRect().top + args.clientY : args.pageY;
        if (this.parent.quickToolbarModule.imageQTBar) {
            if (e.isNotify) this.imageQTPopupTime = setTimeout(function() {
                _this.parent.formatter.editorManager.nodeSelection.Clear(_this.contentModule.getDocument());
                _this.parent.formatter.editorManager.nodeSelection.setSelectionContents(_this.contentModule.getDocument(), target);
                _this.quickToolObj.imageQTBar.showPopup(args.pageX, pageY, target);
                _this.resizeStart(e.args, target);
            }, 400);
            else {
                var coordinates = target.getBoundingClientRect();
                this.quickToolObj.imageQTBar.showPopup(coordinates.left, coordinates.top, target, "Image");
            }
        }
    };
    Image.prototype.hideImageQuickToolbar = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector(".e-img-focus"))) {
            (0, $4ZDHT.removeClass)([
                this.contentModule.getEditPanel().querySelector(".e-img-focus")
            ], "e-img-focus");
            if (this.quickToolObj && this.quickToolObj.imageQTBar && document.body.contains(this.quickToolObj.imageQTBar.element)) this.quickToolObj.imageQTBar.hidePopup();
        }
    };
    Image.prototype.editAreaClickHandler = function(e) {
        if (this.parent.readonly) {
            this.hideImageQuickToolbar();
            return;
        }
        var args = e.args;
        var showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (args.which === 2 || showOnRightClick && args.which === 1 || !showOnRightClick && args.which === 3) {
            if (showOnRightClick && args.which === 1 && !(0, $3EnZW.isNullOrUndefined)(args.target) && args.target.tagName === "IMG") {
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), args.target);
            }
            return;
        }
        if (this.parent.editorMode === "HTML" && this.parent.quickToolbarModule && this.parent.quickToolbarModule.imageQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
            var target = args.target;
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var isPopupOpen = this.quickToolObj.imageQTBar.element.classList.contains("e-rte-pop");
            if (target.nodeName === "IMG" && this.parent.quickToolbarModule) {
                if (isPopupOpen) return;
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
                if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, e);
                (0, $4ZDHT.addClass)([
                    target
                ], "e-img-focus");
                var items = this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item");
                var separator = void 0;
                if ((0, $4ZDHT.closest)(target, "a")) {
                    for(var i = 0; i < items.length; i++){
                        if (items[i].getAttribute("title") === this.i10n.getConstant("openLink") || items[i].getAttribute("title") === this.i10n.getConstant("editLink") || items[i].getAttribute("title") === this.i10n.getConstant("removeLink")) {
                            items[i].style.display = "";
                            (0, $4ZDHT.removeClass)([
                                items[i]
                            ], "e-link-groups");
                        } else if (items[i].getAttribute("title") === "Insert Link") items[i].style.display = "none";
                        else if (items[i].classList.contains("e-rte-horizontal-separator")) {
                            // eslint-disable-next-line
                            separator = items[i];
                            (0, $4ZDHT.detach)(items[i]);
                        }
                    }
                    var newItems = this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item:not(.e-link-groups)");
                    this.quickToolObj.imageQTBar.addQTBarItem([
                        "-"
                    ], Math.round(newItems.length / 2));
                } else if (!(0, $4ZDHT.closest)(target, "a")) this.imageWithLinkQTBarItemUpdate();
                this.showImageQuickToolbar({
                    args: args,
                    type: "Images",
                    elements: [
                        args.target
                    ]
                });
            } else this.hideImageQuickToolbar();
        }
    };
    Image.prototype.insertImgLink = function(e, inputDetails) {
        var _this = this;
        if (e.selectNode[0].nodeName !== "IMG") return;
        this.imagDialog(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            var linkWrap = this.parent.createElement("div", {
                className: "e-img-linkwrap" + this.parent.getCssClass(true)
            });
            var linkUrl = this.i10n.getConstant("linkurl");
            var content = '<div class="e-rte-field' + this.parent.getCssClass(true) + '">' + '<input type="text" data-role ="none" class="e-input e-img-link' + this.parent.getCssClass(true) + '" spellcheck="false" placeholder="' + linkUrl + '"/></div>' + '<div class="e-rte-label"></div>' + '<div class="e-rte-field">' + '<input type="checkbox" class="e-rte-linkTarget' + this.parent.getCssClass(true) + '"  data-role ="none"></div>';
            var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
            linkWrap.appendChild(contentElem);
            var linkTarget = linkWrap.querySelector(".e-rte-linkTarget");
            var inputLink = linkWrap.querySelector(".e-img-link");
            var linkOpenLabel = this.i10n.getConstant("linkOpenInNewWindow");
            this.checkBoxObj = new (0, $1c7c93589ae50f14$export$ea5f704b89d806f6)({
                label: linkOpenLabel,
                checked: true,
                enableRtl: this.parent.enableRtl,
                cssClass: this.parent.getCssClass(),
                change: function(e) {
                    if (e.checked) target_1 = "_blank";
                    else target_1 = null;
                }
            });
            this.checkBoxObj.isStringTemplate = true;
            this.checkBoxObj.createElement = this.parent.createElement;
            this.checkBoxObj.appendTo(linkTarget);
            var target_1 = "_blank";
            var imageLabel = this.i10n.getConstant("imageLinkAriaLabel");
            var linkUpdate = this.i10n.getConstant("dialogUpdate");
            var linkargs_1 = {
                args: e.args,
                selfImage: this,
                selection: e.selection,
                selectNode: e.selectNode,
                selectParent: e.selectParent,
                link: inputLink,
                target: target_1,
                ariaLabel: imageLabel
            };
            this.dialogObj.setProperties({
                width: "290px",
                header: this.parent.localeObj.getConstant("imageInsertLinkHeader"),
                content: linkWrap,
                buttons: [
                    {
                        // eslint-disable-next-line
                        click: function(e) {
                            _this.insertlink(linkargs_1);
                        },
                        buttonModel: {
                            content: linkUpdate,
                            cssClass: "e-flat e-update-link" + this.parent.getCssClass(true),
                            isPrimary: true
                        }
                    }
                ],
                cssClass: this.dialogObj.cssClass + " e-rte-img-link-dialog"
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) this.dialogObj.setProperties({
                cssClass: this.parent.cssClass
            });
            if (!(0, $3EnZW.isNullOrUndefined)(inputDetails)) {
                inputLink.value = inputDetails.url;
                this.checkBoxObj.checked = inputDetails.target ? true : false;
                this.dialogObj.header = inputDetails.header;
            }
            this.dialogObj.element.style.maxHeight = "inherit";
            this.dialogObj.content.querySelector("input").focus();
        }
    };
    Image.prototype.insertAltText = function(e) {
        var _this = this;
        if (e.selectNode[0].nodeName !== "IMG") return;
        this.imagDialog(e);
        var altText = this.i10n.getConstant("altText");
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            var altWrap = this.parent.createElement("div", {
                className: "e-img-altwrap" + this.parent.getCssClass(true)
            });
            var altHeader = this.i10n.getConstant("alternateHeader");
            var linkUpdate = this.i10n.getConstant("dialogUpdate");
            var getAlt = e.selectNode[0].getAttribute("alt") === null ? "" : e.selectNode[0].getAttribute("alt");
            var content = '<div class="e-rte-field' + this.parent.getCssClass(true) + '">' + '<input type="text" spellcheck="false"  class="e-input e-img-alt' + this.parent.getCssClass(true) + '" placeholder="' + altText + '"/>' + "</div>";
            var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
            contentElem.querySelector("input").setAttribute("value", getAlt);
            altWrap.appendChild(contentElem);
            var inputAlt = altWrap.querySelector(".e-img-alt");
            var altArgs_1 = {
                args: e.args,
                selfImage: this,
                selection: e.selection,
                selectNode: e.selectNode,
                alt: inputAlt
            };
            this.dialogObj.setProperties({
                width: "290px",
                header: altHeader,
                content: altWrap,
                buttons: [
                    {
                        // eslint-disable-next-line
                        click: function(e) {
                            _this.insertAlt(altArgs_1);
                        },
                        buttonModel: {
                            content: linkUpdate,
                            cssClass: "e-flat e-update-alt" + this.parent.getCssClass(true),
                            isPrimary: true
                        }
                    }
                ],
                cssClass: this.dialogObj.cssClass + " e-rte-img-alt-dialog"
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) this.dialogObj.setProperties({
                cssClass: this.parent.cssClass
            });
            this.dialogObj.element.style.maxHeight = "inherit";
            this.dialogObj.content.querySelector("input").focus();
        }
    };
    Image.prototype.insertAlt = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.alt)) {
            e.selection.restore();
            if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
            var altText = e.alt.value;
            this.parent.formatter.process(this.parent, e.args, e.args, {
                altText: altText,
                selectNode: e.selectNode,
                subCommand: e.args.item.subCommand
            });
            this.dialogObj.hide({
                returnValue: false
            });
        }
    };
    Image.prototype.insertlink = function(e) {
        if (e.selectNode[0].nodeName !== "IMG") return;
        var url = e.link.value;
        if (url === "") {
            (0, $4ZDHT.addClass)([
                e.link
            ], "e-error");
            e.link.setSelectionRange(0, url.length);
            e.link.focus();
            return;
        }
        if (!this.isUrl(url)) url = "http://" + url;
        else (0, $4ZDHT.removeClass)([
            e.link
        ], "e-error");
        var proxy = e.selfImage;
        if (proxy.parent.editorMode === "HTML") e.selection.restore();
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        if (e.selectNode[0].parentElement.nodeName === "A") {
            proxy.parent.formatter.process(proxy.parent, e.args, e.args, {
                url: url,
                target: proxy.checkBoxObj.checked ? "_blank" : null,
                ariaLabel: proxy.checkBoxObj.checked ? this.i10n.getConstant("imageLinkAriaLabel") : null,
                selectNode: e.selectNode,
                subCommand: e.args.item.subCommand
            });
            proxy.dialogObj.hide({
                returnValue: true
            });
            return;
        }
        proxy.parent.formatter.process(proxy.parent, e.args, e.args, {
            url: url,
            target: proxy.checkBoxObj.checked ? "_blank" : null,
            ariaLabel: proxy.checkBoxObj.checked ? this.i10n.getConstant("imageLinkAriaLabel") : null,
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand,
            selection: e.selection
        });
        var captionEle = (0, $4ZDHT.closest)(e.selectNode[0], ".e-img-caption");
        if (captionEle) (0, $4ZDHT.select)(".e-img-inner", captionEle).focus();
        if (captionEle) (0, $4ZDHT.select)(".e-img-inner", captionEle).focus();
        proxy.dialogObj.hide({
            returnValue: false
        });
    };
    Image.prototype.isUrl = function(url) {
        var regExp = RegExp;
        var regexp = new regExp("(ftp|http|https)://(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(/|/([\\w#!:.?+=&%@\\-\\/]))?", "gi");
        return regexp.test(url);
    };
    Image.prototype.deleteImg = function(e, keyCode) {
        if (e.selectNode[0].nodeName !== "IMG") return;
        var args = {
            element: e.selectNode[0],
            src: e.selectNode[0].getAttribute("src")
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        var restoreStartElement = e.selection.range.startContainer;
        if (e.selection.range.startContainer.nodeName === "SPAN" && restoreStartElement.classList.contains("e-img-wrap") && restoreStartElement.parentElement.classList.contains("e-img-caption")) {
            restoreStartElement = restoreStartElement.parentElement;
            if (!(0, $3EnZW.isNullOrUndefined)(restoreStartElement.previousSibling)) {
                var lastNode = restoreStartElement.previousSibling;
                while(lastNode.nodeName !== "#text" && lastNode.nodeName !== "BR")lastNode = lastNode.lastChild;
                this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), lastNode, lastNode.nodeName !== "BR" ? lastNode.textContent.length : 0);
            } else if (!(0, $3EnZW.isNullOrUndefined)(restoreStartElement.nextSibling)) {
                var firstNode = restoreStartElement.nextSibling;
                while(firstNode.nodeName !== "#text" && firstNode.nodeName !== "BR")firstNode = firstNode.firstChild;
                this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), firstNode, 0);
            }
        } else e.selection.restore();
        if (this.contentModule.getEditPanel().querySelector(".e-img-resize")) this.removeResizeEle();
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            captionClass: $afc560df281b588d$export$8cc8187364c14638,
            subCommand: e.args.item.subCommand
        });
        if (this.quickToolObj && document.body.contains(this.quickToolObj.imageQTBar.element)) this.quickToolObj.imageQTBar.hidePopup();
        this.cancelResizeAction();
        if ((0, $3EnZW.isNullOrUndefined)(keyCode)) this.parent.trigger($947a002e9a697770$export$61590b3a6f2109b, args);
    };
    Image.prototype.caption = function(e) {
        var selectNode = e.selectNode[0];
        if (selectNode.nodeName !== "IMG") return;
        e.selection.restore();
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        this.cancelResizeAction();
        (0, $4ZDHT.addClass)([
            selectNode
        ], "e-rte-image");
        var subCommand = e.args.item ? e.args.item.subCommand : "Caption";
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(selectNode, "." + $afc560df281b588d$export$8cc8187364c14638))) {
            (0, $4ZDHT.detach)((0, $4ZDHT.closest)(selectNode, "." + $afc560df281b588d$export$8cc8187364c14638));
            if ((0, $5q7BP.Browser).isIE) {
                this.contentModule.getEditPanel().focus();
                e.selection.restore();
            }
            if (selectNode.parentElement.tagName === "A") this.parent.formatter.process(this.parent, e.args, e.args, {
                insertElement: selectNode.parentElement,
                selectNode: e.selectNode,
                subCommand: subCommand
            });
            else this.parent.formatter.process(this.parent, e.args, e.args, {
                insertElement: selectNode,
                selectNode: e.selectNode,
                subCommand: subCommand
            });
        } else {
            this.captionEle = this.parent.createElement("span", {
                className: $afc560df281b588d$export$8cc8187364c14638 + " " + $afc560df281b588d$export$f23065c8d5ed6b8d + this.parent.getCssClass(true),
                attrs: {
                    contenteditable: "false",
                    draggable: "false",
                    style: "width:" + this.parent.insertImageSettings.width
                }
            });
            var imgWrap = this.parent.createElement("span", {
                className: "e-img-wrap" + this.parent.getCssClass(true)
            });
            var imgInner = this.parent.createElement("span", {
                className: "e-img-inner" + this.parent.getCssClass(true),
                attrs: {
                    contenteditable: "true"
                }
            });
            var parent_1 = e.selectNode[0].parentElement;
            if (parent_1.tagName === "A") parent_1.setAttribute("contenteditable", "true");
            imgWrap.appendChild(parent_1.tagName === "A" ? parent_1 : e.selectNode[0]);
            imgWrap.appendChild(imgInner);
            var imgCaption = this.i10n.getConstant("imageCaption");
            imgInner.innerHTML = imgCaption;
            this.captionEle.appendChild(imgWrap);
            if (selectNode.classList.contains($afc560df281b588d$export$650bb6ed56b4642)) (0, $4ZDHT.addClass)([
                this.captionEle
            ], $afc560df281b588d$export$dcd8f689ae4af23c);
            if (selectNode.classList.contains($afc560df281b588d$export$c6e979ddaa53685e)) (0, $4ZDHT.addClass)([
                this.captionEle
            ], $afc560df281b588d$export$c6e979ddaa53685e);
            if (selectNode.classList.contains($afc560df281b588d$export$3d22da888fd4da4c)) (0, $4ZDHT.addClass)([
                this.captionEle
            ], $afc560df281b588d$export$3d22da888fd4da4c);
            if (selectNode.classList.contains($afc560df281b588d$export$d04b9cba559647e)) (0, $4ZDHT.addClass)([
                this.captionEle
            ], $afc560df281b588d$export$d04b9cba559647e);
            if (selectNode.classList.contains($afc560df281b588d$export$6001aa7dff3449a3)) (0, $4ZDHT.addClass)([
                this.captionEle
            ], $afc560df281b588d$export$6001aa7dff3449a3);
            this.parent.formatter.process(this.parent, e.args, e.args, {
                insertElement: this.captionEle,
                selectNode: e.selectNode,
                subCommand: subCommand
            });
            this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), imgInner.childNodes[0], imgInner.childNodes[0], 0, imgInner.childNodes[0].textContent.length);
        }
        if (this.quickToolObj && document.body.contains(this.quickToolObj.imageQTBar.element)) {
            this.quickToolObj.imageQTBar.hidePopup();
            (0, $4ZDHT.removeClass)([
                selectNode
            ], "e-img-focus");
        }
    };
    Image.prototype.imageSize = function(e) {
        var _this = this;
        if (e.selectNode[0].nodeName !== "IMG") return;
        this.imagDialog(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            var imgSizeHeader = this.i10n.getConstant("imageSizeHeader");
            var linkUpdate = this.i10n.getConstant("dialogUpdate");
            var dialogContent = this.imgsizeInput(e);
            var selectObj_1 = {
                args: e.args,
                selfImage: this,
                selection: e.selection,
                selectNode: e.selectNode
            };
            this.dialogObj.setProperties({
                width: "290px",
                header: imgSizeHeader,
                content: dialogContent,
                buttons: [
                    {
                        // eslint-disable-next-line
                        click: function(e) {
                            _this.insertSize(selectObj_1);
                        },
                        buttonModel: {
                            content: linkUpdate,
                            cssClass: "e-flat e-update-size" + this.parent.getCssClass(true),
                            isPrimary: true
                        }
                    }
                ],
                cssClass: this.dialogObj.cssClass + " e-rte-img-size-dialog"
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) this.dialogObj.setProperties({
                cssClass: this.parent.cssClass
            });
            this.dialogObj.element.style.maxHeight = "inherit";
            this.dialogObj.content.querySelector("input").focus();
        }
    };
    Image.prototype.break = function(e) {
        if (e.selectNode[0].nodeName !== "IMG") return;
        var subCommand = e.args.item.subCommand;
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Image.prototype.inline = function(e) {
        if (e.selectNode[0].nodeName !== "IMG") return;
        var subCommand = e.args.item.subCommand;
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Image.prototype.alignImage = function(e) {
        var subCommand = e.args.item.subCommand;
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Image.prototype.clearDialogObj = function() {
        if (this.uploadObj && !this.uploadObj.isDestroyed) {
            this.uploadObj.destroy();
            (0, $4ZDHT.detach)(this.uploadObj.element);
            this.uploadObj = null;
        }
        if (this.checkBoxObj && !this.checkBoxObj.isDestroyed) {
            this.checkBoxObj.destroy();
            (0, $4ZDHT.detach)(this.checkBoxObj.element);
            this.checkBoxObj = null;
        }
        if (this.popupObj && !this.popupObj.isDestroyed) {
            this.popupObj.destroy();
            (0, $4ZDHT.detach)(this.popupObj.element);
            this.popupObj = null;
        }
        if (this.widthNum && !this.widthNum.isDestroyed) {
            this.widthNum.destroy();
            (0, $4ZDHT.detach)(this.widthNum.element);
            this.widthNum = null;
        }
        if (this.heightNum && !this.heightNum.isDestroyed) {
            this.heightNum.destroy();
            (0, $4ZDHT.detach)(this.heightNum.element);
            this.heightNum = null;
        }
        if (this.browseButton && !this.browseButton.isDestroyed) {
            this.browseButton.destroy();
            (0, $4ZDHT.detach)(this.browseButton.element);
            this.browseButton = null;
        }
        if (this.dialogObj && !this.dialogObj.isDestroyed) {
            this.dialogObj.destroy();
            (0, $4ZDHT.detach)(this.dialogObj.element);
            this.dialogObj = null;
        }
    };
    Image.prototype.imagDialog = function(e) {
        var _this = this;
        if (this.dialogObj) {
            this.dialogObj.hide({
                returnValue: true
            });
            return;
        }
        var imgDialog = this.parent.createElement("div", {
            className: "e-rte-img-dialog" + this.parent.getCssClass(true),
            id: this.rteID + "_image"
        });
        this.parent.rootContainer.appendChild(imgDialog);
        var imgInsert = this.i10n.getConstant("dialogInsert");
        var imglinkCancel = this.i10n.getConstant("dialogCancel");
        var imgHeader = this.i10n.getConstant("imageHeader");
        var selection = e.selection;
        var selectObj = {
            selfImage: this,
            selection: e.selection,
            args: e.args,
            selectParent: e.selectParent
        };
        var dialogModel = {
            header: imgHeader,
            cssClass: $afc560df281b588d$export$d3f61cb93957903e + this.parent.getCssClass(true),
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true,
            closeOnEscape: true,
            width: (0, $5q7BP.Browser).isDevice ? "290px" : "340px",
            isModal: (0, $5q7BP.Browser).isDevice,
            buttons: [
                {
                    click: this.insertImageUrl.bind(selectObj),
                    buttonModel: {
                        content: imgInsert,
                        cssClass: "e-flat e-insertImage" + this.parent.getCssClass(true),
                        isPrimary: true,
                        disabled: this.parent.editorMode === "Markdown" ? false : true
                    }
                },
                {
                    click: this.cancelDialog.bind(this),
                    buttonModel: {
                        cssClass: "e-flat e-cancel" + this.parent.getCssClass(true),
                        content: imglinkCancel
                    }
                }
            ],
            target: (0, $5q7BP.Browser).isDevice ? document.body : this.parent.element,
            animationSettings: {
                effect: "None"
            },
            close: function(event) {
                if (event && event.closedBy !== "user action" && _this.uploadObj.filesData.length > 0) _this.uploadObj.remove();
                _this.parent.isBlur = false;
                if (event && !(0, $3EnZW.isNullOrUndefined)(event.event) && event.event.returnValue) {
                    if (_this.parent.editorMode === "HTML") selection.restore();
                    else _this.parent.formatter.editorManager.markdownSelection.restore(_this.parent.contentModule.getEditPanel());
                }
                _this.clearDialogObj();
                _this.dialogRenderObj.close(event);
            }
        };
        var dialogContent = this.parent.createElement("div", {
            className: "e-img-content" + this.parent.getCssClass(true)
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertImageSettings.path) && this.parent.editorMode === "Markdown" || this.parent.editorMode === "HTML") dialogContent.appendChild(this.imgUpload(e));
        var linkHeader = this.parent.createElement("div", {
            className: "e-linkheader" + this.parent.getCssClass(true)
        });
        var linkHeaderText = this.i10n.getConstant("imageLinkHeader");
        if (this.parent.editorMode === "HTML") linkHeader.innerHTML = linkHeaderText;
        else linkHeader.innerHTML = this.i10n.getConstant("mdimageLink");
        dialogContent.appendChild(linkHeader);
        dialogContent.appendChild(this.imageUrlPopup(e));
        if (e.selectNode && e.selectNode[0].nodeName === "IMG") {
            dialogModel.header = this.parent.localeObj.getConstant("editImageHeader");
            dialogModel.content = dialogContent;
            dialogModel.buttons[0].buttonModel.cssClass = dialogModel.buttons[0].buttonModel.cssClass + " e-updateImage";
        } else dialogModel.content = dialogContent;
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(imgDialog);
        if ((0, $3EnZW.isNullOrUndefined)(this.dialogObj)) return;
        if (e.selectNode && e.selectNode[0].nodeName === "IMG" && e.name === "insertImage") this.dialogObj.element.querySelector(".e-insertImage").textContent = this.parent.localeObj.getConstant("dialogUpdate");
        imgDialog.style.maxHeight = "inherit";
        if (this.quickToolObj) {
            if (this.quickToolObj.imageQTBar && document.body.contains(this.quickToolObj.imageQTBar.element)) {
                this.quickToolObj.imageQTBar.hidePopup();
                if (!(0, $3EnZW.isNullOrUndefined)(e.selectParent)) (0, $4ZDHT.removeClass)([
                    e.selectParent[0]
                ], "e-img-focus");
            }
            if (this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) this.quickToolObj.inlineQTBar.hidePopup();
            if (this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) this.quickToolObj.textQTBar.hidePopup();
        }
    };
    Image.prototype.cancelDialog = function() {
        this.parent.isBlur = false;
        if (this.uploadObj.filesData.length > 0) this.uploadObj.remove();
        this.dialogObj.hide({
            returnValue: true
        });
    };
    Image.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if ((0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel())) return;
        if (target.nodeName === "IMG") this.imgEle = target;
        if (!this.parent) return;
        if (target.nodeName !== "#document") this.parent.currentTarget = e.target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj) && (// eslint-disable-next-line
        !(0, $4ZDHT.closest)(target, "[id='" + this.dialogObj.element.id + "'" + "]") && this.parent.toolbarSettings.enable && this.parent.getToolbarElement() && !this.parent.getToolbarElement().contains(e.target) || this.parent.getToolbarElement() && this.parent.getToolbarElement().contains(e.target) && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_toolbar_Image") && !target.querySelector("#" + this.parent.getID() + "_toolbar_Image"))) {
            /* eslint-disable */ if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) ;
            else {
                this.parent.notify($947a002e9a697770$export$4895f32c534ef936, {
                    closedBy: "outside click"
                });
                this.dialogObj.hide({
                    returnValue: true
                });
                this.parent.isBlur = true;
                (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
            }
        /* eslint-enable */ }
        if (!(this.parent.iframeSettings.enable && !(0, $3EnZW.isNullOrUndefined)(this.parent.currentTarget) && this.parent.currentTarget.nodeName === "IMG") && e.target.tagName !== "IMG" && this.imgResizeDiv && !(this.quickToolObj && this.quickToolObj.imageQTBar && this.quickToolObj.imageQTBar.element.contains(e.target)) && this.contentModule.getEditPanel().contains(this.imgResizeDiv)) this.cancelResizeAction();
        if (this.contentModule.getEditPanel().querySelector(".e-img-resize") && !(this.parent.iframeSettings.enable && this.parent.currentTarget.nodeName === "IMG")) {
            if (target.tagName !== "IMG") this.removeResizeEle();
            if (target.tagName !== "IMG" && !(0, $3EnZW.isNullOrUndefined)(this.imgEle)) this.imgEle.style.outline = "";
            else if (!(0, $3EnZW.isNullOrUndefined)(this.prevSelectedImgEle) && this.prevSelectedImgEle !== target) this.prevSelectedImgEle.style.outline = "";
        }
        if (target.tagName !== "IMG") {
            var items = this.contentModule.getEditPanel().querySelectorAll("img");
            for(var i = 0; i < items.length; i++){
                (0, $4ZDHT.removeClass)([
                    items[i]
                ], "e-img-focus");
                (0, $4ZDHT.removeClass)([
                    items[i]
                ], "e-resize");
            }
        }
        if (this.parent.inlineMode.enable && target && this.dialogObj && !(0, $4ZDHT.closest)(target, "#" + this.dialogObj.element.id)) this.dialogObj.hide();
    };
    Image.prototype.removeResizeEle = function() {
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        (0, $4ZDHT.detach)(this.contentModule.getEditPanel().querySelector(".e-img-resize"));
    };
    Image.prototype.onWindowResize = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule) && !(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector(".e-img-resize"))) this.cancelResizeAction();
    };
    Image.prototype.imageUrlPopup = function(e) {
        var _this = this;
        var imgUrl = this.parent.createElement("div", {
            className: "imgUrl" + this.parent.getCssClass(true)
        });
        var placeUrl = this.i10n.getConstant("imageUrl");
        this.inputUrl = this.parent.createElement("input", {
            className: "e-input e-img-url" + this.parent.getCssClass(true),
            attrs: {
                placeholder: placeUrl,
                spellcheck: "false",
                "aria-label": this.i10n.getConstant("imageLinkHeader")
            }
        });
        this.inputUrl.addEventListener("input", function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.inputUrl)) {
                if (_this.inputUrl.value.length === 0) _this.dialogObj.getButtons(0).element.disabled = true;
                else _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
            }
        });
        if (e.selectNode && e.selectNode[0].nodeName === "IMG") {
            var regex = new RegExp(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi);
            this.inputUrl.value = e.selectNode[0].src.match(regex) ? e.selectNode[0].src : "";
        }
        imgUrl.appendChild(this.inputUrl);
        return imgUrl;
    };
    Image.prototype.insertImageUrl = function(e) {
        var proxy = this.selfImage;
        proxy.isImgUploaded = false;
        var url = proxy.inputUrl.value;
        if (e.target && e.target.nodeName === "BUTTON" && e.target.classList.contains("e-updateImage")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var element = this.selectNode && this.selectNode[0] && this.selectNode[0].nodeName === "IMG" ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.selectNode[0] : null;
            var args = {
                element: element,
                src: url
            };
            proxy.parent.trigger($947a002e9a697770$export$61590b3a6f2109b, args);
        }
        if (proxy.parent.editorMode === "Markdown" && url === "") url = "http://";
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        if (!(0, $3EnZW.isNullOrUndefined)(proxy.uploadUrl) && proxy.uploadUrl.url !== "") {
            proxy.uploadUrl.cssClass = proxy.parent.insertImageSettings.display === "inline" ? $afc560df281b588d$export$650bb6ed56b4642 : $afc560df281b588d$export$c6e979ddaa53685e;
            proxy.dialogObj.hide({
                returnValue: false
            });
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, proxy.uploadUrl);
            proxy.uploadUrl.url = "";
            if (proxy.contentModule.getEditPanel().querySelector(".e-img-resize")) {
                proxy.imgEle.style.outline = "";
                proxy.removeResizeEle();
            }
        } else if (url !== "") {
            if (proxy.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(// eslint-disable-next-line
            this.selection.range.startContainer.parentNode, "[id='" + proxy.contentModule.getPanel().id + "'" + "]"))) {
                proxy.contentModule.getEditPanel().focus();
                var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.contentModule.getDocument());
                this.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.contentModule.getDocument());
                this.selectParent = proxy.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            }
            var regex = /[\w-]+.(jpg|png|jpeg|gif)/g;
            var matchUrl = !(0, $3EnZW.isNullOrUndefined)(url.match(regex)) && proxy.parent.editorMode === "HTML" ? url.match(regex)[0] : "";
            var value = {
                cssClass: proxy.parent.insertImageSettings.display === "inline" ? $afc560df281b588d$export$650bb6ed56b4642 : $afc560df281b588d$export$c6e979ddaa53685e,
                url: url,
                selection: this.selection,
                altText: matchUrl,
                selectParent: this.selectParent,
                width: {
                    width: proxy.parent.insertImageSettings.width,
                    minWidth: proxy.parent.insertImageSettings.minWidth,
                    maxWidth: proxy.parent.getInsertImgMaxWidth()
                },
                height: {
                    height: proxy.parent.insertImageSettings.height,
                    minHeight: proxy.parent.insertImageSettings.minHeight,
                    maxHeight: proxy.parent.insertImageSettings.maxHeight
                }
            };
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, value);
            proxy.dialogObj.hide({
                returnValue: false
            });
        }
    };
    Image.prototype.imgsizeInput = function(e) {
        var _this = this;
        var selectNode = e.selectNode[0];
        var imgHeight = this.i10n.getConstant("imageHeight");
        var imgWidth = this.i10n.getConstant("imageWidth");
        var imgSizeWrap = this.parent.createElement("div", {
            className: "e-img-sizewrap" + this.parent.getCssClass(true)
        });
        var widthVal = (0, $3EnZW.isNullOrUndefined)(this.changedWidthValue) && (selectNode.style.width.toString() === "auto" || selectNode.style.width !== "") ? selectNode.style.width : !(0, $3EnZW.isNullOrUndefined)(this.changedWidthValue) ? this.changedWidthValue : parseInt(selectNode.getClientRects()[0].width.toString(), 10).toString();
        var heightVal = (0, $3EnZW.isNullOrUndefined)(this.changedHeightValue) && (selectNode.style.height.toString() === "auto" || selectNode.style.height !== "") ? selectNode.style.height : !(0, $3EnZW.isNullOrUndefined)(this.changedHeightValue) ? this.changedHeightValue : parseInt(selectNode.getClientRects()[0].height.toString(), 10).toString();
        if (selectNode.style.width === "") widthVal = "auto";
        if (selectNode.style.height === "") heightVal = "auto";
        this.changedWidthValue = null;
        this.changedHeightValue = null;
        var content = '<div class="e-rte-label' + this.parent.getCssClass(true) + '"><label>' + imgWidth + '</label></div><div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" id="imgwidth" class="e-img-width' + this.parent.getCssClass(true) + '"/></div>' + '<div class="e-rte-label' + this.parent.getCssClass(true) + '">' + "<label>" + imgHeight + '</label></div><div class="e-rte-field' + this.parent.getCssClass(true) + '"> ' + '<input type="text" id="imgheight" class="e-img-height' + this.parent.getCssClass(true) + '"/></div>';
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        contentElem.getElementById("imgwidth").setAttribute("value", widthVal);
        contentElem.getElementById("imgheight").setAttribute("value", heightVal);
        imgSizeWrap.appendChild(contentElem);
        this.widthNum = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
            value: (0, $3EnZW.formatUnit)(widthVal),
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.getCssClass(),
            input: function(e) {
                _this.inputWidthValue = (0, $3EnZW.formatUnit)(_this.inputValue(e.value));
            }
        });
        this.widthNum.createElement = this.parent.createElement;
        this.widthNum.appendTo(imgSizeWrap.querySelector("#imgwidth"));
        this.heightNum = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
            value: (0, $3EnZW.formatUnit)(heightVal),
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.getCssClass(),
            input: function(e) {
                _this.inputHeightValue = (0, $3EnZW.formatUnit)(_this.inputValue(e.value));
            }
        });
        this.heightNum.createElement = this.parent.createElement;
        this.heightNum.appendTo(imgSizeWrap.querySelector("#imgheight"));
        return imgSizeWrap;
    };
    Image.prototype.inputValue = function(value) {
        if (value === "auto" || value.indexOf("%") !== -1 || value.indexOf("px") !== -1 || value.match(/(\d+)/)) return value;
        else return "auto";
    };
    Image.prototype.insertSize = function(e) {
        e.selection.restore();
        var proxy = e.selfImage;
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        var dialogEle = proxy.dialogObj.element;
        this.changedWidthValue = this.inputWidthValue;
        this.changedHeightValue = this.inputHeightValue;
        var width = dialogEle.querySelector(".e-img-width").value;
        var height = dialogEle.parentElement.querySelector(".e-img-height").value;
        proxy.parent.formatter.process(this.parent, e.args, e.args, {
            width: width,
            height: height,
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
        if (this.imgResizeDiv) proxy.imgResizePos(e.selectNode[0], this.imgResizeDiv);
        proxy.dialogObj.hide({
            returnValue: true
        });
    };
    Image.prototype.insertImage = function(e) {
        this.imagDialog(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            this.dialogObj.element.style.maxHeight = "inherit";
            var dialogContent = this.dialogObj.element.querySelector(".e-img-content");
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertImageSettings.path) && this.parent.editorMode === "Markdown" || this.parent.editorMode === "HTML") document.getElementById(this.rteID + "_insertImage").focus();
            else dialogContent.querySelector(".e-img-url").focus();
        }
    };
    Image.prototype.imgUpload = function(e) {
        var _this = this;
        var save;
        var selectParent;
        // eslint-disable-next-line
        var proxy = this;
        var iframe = proxy.parent.iframeSettings.enable;
        if (proxy.parent.editorMode === "HTML" && (!iframe && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.selection.range.startContainer.parentNode, "[id='" + this.parent.contentModule.getPanel().id + "'" + "]")) || iframe && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(e.selection.range.startContainer.parentNode.ownerDocument.querySelector("body"), "e-lib"))) {
            this.contentModule.getEditPanel().focus();
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = e.selection;
            selectParent = e.selectParent;
        }
        var uploadParentEle = this.parent.createElement("div", {
            className: "e-img-uploadwrap e-droparea" + this.parent.getCssClass(true)
        });
        var deviceImgUpMsg = this.i10n.getConstant("imageDeviceUploadMessage");
        var imgUpMsg = this.i10n.getConstant("imageUploadMessage");
        var span = this.parent.createElement("span", {
            className: "e-droptext" + this.parent.getCssClass(true)
        });
        var spanMsg = this.parent.createElement("span", {
            className: "e-rte-upload-text" + this.parent.getCssClass(true),
            innerHTML: (0, $5q7BP.Browser).isDevice ? deviceImgUpMsg : imgUpMsg
        });
        span.appendChild(spanMsg);
        var btnEle = this.parent.createElement("button", {
            className: "e-browsebtn" + this.parent.getCssClass(true),
            id: this.rteID + "_insertImage",
            attrs: {
                autofocus: "true",
                type: "button"
            }
        });
        span.appendChild(btnEle);
        uploadParentEle.appendChild(span);
        var browserMsg = this.i10n.getConstant("browse");
        this.browseButton = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            content: browserMsg,
            enableRtl: this.parent.enableRtl
        });
        this.browseButton.isStringTemplate = true;
        this.browseButton.createElement = this.parent.createElement;
        this.browseButton.appendTo(btnEle);
        var btnClick = (0, $5q7BP.Browser).isDevice ? span : btnEle;
        (0, $aqzbR.EventHandler).add(btnClick, "click", this.fileSelect, this);
        var uploadEle = this.parent.createElement("input", {
            id: this.rteID + "_upload",
            attrs: {
                type: "File",
                name: "UploadFiles"
            },
            className: this.parent.getCssClass()
        });
        uploadParentEle.appendChild(uploadEle);
        var altText;
        var selectArgs;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var filesData;
        var previousFileInfo = null;
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            asyncSettings: {
                saveUrl: this.parent.insertImageSettings.saveUrl,
                removeUrl: this.parent.insertImageSettings.removeUrl
            },
            dropArea: span,
            multiple: false,
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.getCssClass(),
            allowedExtensions: this.parent.insertImageSettings.allowedTypes.toString(),
            selected: function(e) {
                proxy.isImgUploaded = true;
                selectArgs = e;
                filesData = e.filesData;
                _this.parent.trigger($947a002e9a697770$export$ca9dc16f801d1711, selectArgs, function(selectArgs) {
                    if (!selectArgs.cancel) {
                        _this.checkExtension(selectArgs.filesData[0]);
                        altText = selectArgs.filesData[0].name.replace(/\.[a-zA-Z0-9]+$/, "");
                        if (_this.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)(_this.parent.insertImageSettings.path)) {
                            var reader_1 = new FileReader();
                            // eslint-disable-next-line
                            reader_1.addEventListener("load", function(e) {
                                var url = _this.parent.insertImageSettings.saveFormat === "Base64" ? reader_1.result : URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(reader_1.result));
                                proxy.uploadUrl = {
                                    url: url,
                                    selection: save,
                                    altText: altText,
                                    selectParent: selectParent,
                                    width: {
                                        width: proxy.parent.insertImageSettings.width,
                                        minWidth: proxy.parent.insertImageSettings.minWidth,
                                        maxWidth: proxy.parent.getInsertImgMaxWidth()
                                    },
                                    height: {
                                        height: proxy.parent.insertImageSettings.height,
                                        minHeight: proxy.parent.insertImageSettings.minHeight,
                                        maxHeight: proxy.parent.insertImageSettings.maxHeight
                                    }
                                };
                                proxy.inputUrl.setAttribute("disabled", "true");
                                if ((0, $3EnZW.isNullOrUndefined)(proxy.parent.insertImageSettings.saveUrl) && _this.isAllowedTypes && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj) && selectArgs.filesData[0].size <= _this.uploadObj.maxFileSize) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                            });
                            reader_1.readAsDataURL(selectArgs.filesData[0].rawFile);
                        }
                    }
                });
            },
            beforeUpload: function(args) {
                _this.parent.trigger($947a002e9a697770$export$21462d42bdb4e9c, args);
            },
            uploading: function(e) {
                if (!_this.parent.isServerRendered) _this.parent.trigger($947a002e9a697770$export$fce94e5d515bb6fa, e);
            },
            success: function(e) {
                e.detectImageSource = (0, $2eaa618655f536c2$export$857a3989d2b808cc).Uploaded;
                _this.parent.trigger($947a002e9a697770$export$3d5930a2bedfca4f, e, function(e) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.insertImageSettings.path)) {
                        var url = _this.parent.insertImageSettings.path + e.file.name;
                        // Update the URL of the previously uploaded image
                        if (!(0, $3EnZW.isNullOrUndefined)(previousFileInfo) && e.operation === "upload") _this.uploadObj.remove(previousFileInfo);
                        // eslint-disable-next-line
                        var value = {
                            url: url,
                            selection: save
                        };
                        proxy.uploadUrl = {
                            url: url,
                            selection: save,
                            altText: altText,
                            selectParent: selectParent,
                            width: {
                                width: proxy.parent.insertImageSettings.width,
                                minWidth: proxy.parent.insertImageSettings.minWidth,
                                maxWidth: proxy.parent.getInsertImgMaxWidth()
                            },
                            height: {
                                height: proxy.parent.insertImageSettings.height,
                                minHeight: proxy.parent.insertImageSettings.minHeight,
                                maxHeight: proxy.parent.insertImageSettings.maxHeight
                            }
                        };
                        proxy.inputUrl.setAttribute("disabled", "true");
                        previousFileInfo = e.file;
                    }
                    if (e.operation === "upload" && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj)) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                });
            },
            failure: function(e) {
                _this.parent.trigger($947a002e9a697770$export$e3f6ff7da8c3e03f, e);
            },
            removing: function(removeEventArgs) {
                // eslint-disable-next-line
                _this.parent.trigger($947a002e9a697770$export$2004dcd6614347a, removeEventArgs, function(e) {
                    proxy.isImgUploaded = false;
                    _this.dialogObj.getButtons(0).element.disabled = true;
                    proxy.inputUrl.removeAttribute("disabled");
                    if (proxy.uploadUrl) proxy.uploadUrl.url = "";
                });
            }
        });
        this.uploadObj.isStringTemplate = true;
        this.uploadObj.createElement = this.parent.createElement;
        this.uploadObj.appendTo(uploadEle);
        return uploadParentEle;
    };
    Image.prototype.checkExtension = function(e) {
        if (this.uploadObj.allowedExtensions) {
            if (e.type) {
                if (this.uploadObj.allowedExtensions.toLocaleLowerCase().indexOf(("." + e.type).toLocaleLowerCase()) === -1) {
                    this.dialogObj.getButtons(0).element.setAttribute("disabled", "disabled");
                    this.isAllowedTypes = false;
                } else this.isAllowedTypes = true;
            }
        }
    };
    Image.prototype.fileSelect = function() {
        this.dialogObj.element.getElementsByClassName("e-file-select-wrap")[0].querySelector("button").click();
        return false;
    };
    Image.prototype.dragStart = function(e) {
        if (e.target.nodeName === "IMG") this.parent.trigger($947a002e9a697770$export$df204737a6131aab, e, function(actionBeginArgs) {
            if (actionBeginArgs.cancel) e.preventDefault();
            else {
                e.dataTransfer.effectAllowed = "copyMove";
                e.target.classList.add($afc560df281b588d$export$93c5e02e280495b6);
            }
        });
        else return true;
    };
    Image.prototype.dragEnter = function(e) {
        e.dataTransfer.dropEffect = "copy";
        e.preventDefault();
    };
    Image.prototype.dragOver = function(e) {
        if ((0, $5q7BP.Browser).info.name === "edge" && e.dataTransfer.items[0].type.split("/")[0].indexOf("image") > -1 || (0, $5q7BP.Browser).isIE && e.dataTransfer.types[0] === "Files") e.preventDefault();
        else return true;
    };
    /**
     * Used to set range When drop an image
     *
     * @param {ImageDropEventArgs} args - specifies the image arguments.
     * @returns {void}
     */ Image.prototype.dragDrop = function(args) {
        var _this = this;
        this.parent.trigger($947a002e9a697770$export$ccd2477faa5965e8, args, function(e) {
            var imgElement = _this.parent.inputElement.ownerDocument.querySelector("." + $afc560df281b588d$export$93c5e02e280495b6);
            var isImgOrFileDrop = imgElement && imgElement.tagName === "IMG" || e.dataTransfer.files.length > 0;
            if (!e.cancel && isImgOrFileDrop) {
                if ((0, $4ZDHT.closest)(e.target, "#" + _this.parent.getID() + "_toolbar") || _this.parent.inputElement.contentEditable === "false") {
                    e.preventDefault();
                    return;
                }
                if (_this.parent.element.querySelector("." + $afc560df281b588d$export$47b7482a512fac11)) (0, $4ZDHT.detach)(_this.imgResizeDiv);
                e.preventDefault();
                var range = void 0;
                if (_this.contentModule.getDocument().caretRangeFromPoint) range = _this.contentModule.getDocument().caretRangeFromPoint(e.clientX, e.clientY);
                else if (e.rangeParent) {
                    range = _this.contentModule.getDocument().createRange();
                    range.setStart(e.rangeParent, e.rangeOffset);
                } else range = _this.getDropRange(e.clientX, e.clientY); //For internet explorer
                _this.parent.notify($947a002e9a697770$export$86be68e1224a0620, {
                    range: range
                });
                var uploadArea = _this.parent.element.querySelector("." + $afc560df281b588d$export$e6b14ab7328f4f39);
                if (uploadArea) return;
                _this.insertDragImage(e);
            } else if (isImgOrFileDrop) e.preventDefault();
        });
    };
    /**
     * Used to calculate range on internet explorer
     *
     * @param {number} x - specifies the x range.
     * @param {number} y - specifies the y range.
     * @returns {void}
     */ Image.prototype.getDropRange = function(x, y) {
        var startRange = this.contentModule.getDocument().createRange();
        this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(), startRange);
        var elem = this.contentModule.getDocument().elementFromPoint(x, y);
        var startNode = elem.childNodes.length > 0 ? elem.childNodes[0] : elem;
        var startCharIndexCharacter = 0;
        if (this.parent.inputElement.firstChild.innerHTML === "<br>") {
            startRange.setStart(startNode, startCharIndexCharacter);
            startRange.setEnd(startNode, startCharIndexCharacter);
        } else {
            var rangeRect = void 0;
            do {
                startCharIndexCharacter++;
                startRange.setStart(startNode, startCharIndexCharacter);
                startRange.setEnd(startNode, startCharIndexCharacter + 1);
                rangeRect = startRange.getBoundingClientRect();
            }while (rangeRect.left < x && startCharIndexCharacter < startNode.length - 1);
        }
        return startRange;
    };
    Image.prototype.insertDragImage = function(e) {
        var _this = this;
        e.preventDefault();
        var activePopupElement = this.parent.element.querySelector("" + $afc560df281b588d$export$22ab25c53e8ff6fa);
        this.parent.notify($947a002e9a697770$export$663103110d94aac9, {
            args: e
        });
        if (activePopupElement) activePopupElement.classList.add($afc560df281b588d$export$e5db7105a59c014a);
        var imgElement = this.parent.inputElement.ownerDocument.querySelector("." + $afc560df281b588d$export$93c5e02e280495b6);
        var actionBeginArgs = {
            requestType: "Images",
            name: "ImageDragAndDrop",
            cancel: false,
            originalEvent: e
        };
        if (e.dataTransfer.files.length > 0 && imgElement === null) {
            if (e.dataTransfer.files.length > 1) return;
            var imgFiles_1 = e.dataTransfer.files;
            var fileName = imgFiles_1[0].name;
            var imgType = fileName.substring(fileName.lastIndexOf("."));
            var allowedTypes = this.parent.insertImageSettings.allowedTypes;
            for(var i = 0; i < allowedTypes.length; i++)if (imgType.toLocaleLowerCase() === allowedTypes[i].toLowerCase()) {
                if (this.parent.insertImageSettings.saveUrl) this.onSelect(e);
                else this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
                    if (!actionBeginArgs.cancel) {
                        var args = {
                            args: e,
                            text: "",
                            file: imgFiles_1[0]
                        };
                        e.preventDefault();
                        _this.imagePaste(args);
                    } else actionBeginArgs.originalEvent.preventDefault();
                });
            }
        } else this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
            if (!actionBeginArgs.cancel) {
                var range = _this.parent.formatter.editorManager.nodeSelection.getRange(_this.parent.contentModule.getDocument());
                if (imgElement && imgElement.tagName === "IMG") {
                    if (imgElement.nextElementSibling) {
                        if (imgElement.nextElementSibling.classList.contains($afc560df281b588d$export$4d0524c27ed8c0b1)) range.insertNode(imgElement.parentElement.parentElement);
                        else range.insertNode(imgElement);
                    } else range.insertNode(imgElement);
                    imgElement.classList.remove($afc560df281b588d$export$93c5e02e280495b6);
                    var imgArgs_1 = {
                        elements: [
                            imgElement
                        ]
                    };
                    imgElement.addEventListener("load", function() {
                        _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, imgArgs_1);
                    });
                    _this.parent.formatter.editorManager.nodeSelection.Clear(_this.contentModule.getDocument());
                    var args = e;
                    _this.resizeStart(args, imgElement);
                    _this.hideImageQuickToolbar();
                }
            } else actionBeginArgs.originalEvent.preventDefault();
        });
    };
    Image.prototype.onSelect = function(args) {
        var _this = this;
        // eslint-disable-next-line
        var proxy = this;
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var parentElement = this.parent.createElement("ul", {
            className: $afc560df281b588d$export$fe30c7e405c723d0
        });
        this.parent.rootContainer.appendChild(parentElement);
        var validFiles = {
            name: args.dataTransfer.files[0].name,
            size: args.dataTransfer.files[0].size,
            status: "",
            statusCode: "",
            type: args.dataTransfer.files[0].type,
            rawFile: args.dataTransfer.files[0],
            validationMessages: {}
        };
        var imageTag = this.parent.createElement("IMG");
        imageTag.style.opacity = "0.5";
        imageTag.classList.add($afc560df281b588d$export$43b7526f3bcf1c7d);
        imageTag.classList.add($afc560df281b588d$export$650bb6ed56b4642);
        imageTag.classList.add($afc560df281b588d$export$905c13406078d997);
        var file = validFiles.rawFile;
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            var url = URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(reader.result));
            imageTag.src = proxy.parent.insertImageSettings.saveFormat === "Blob" ? url : reader.result;
        });
        if (file) reader.readAsDataURL(file);
        var selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
        var imageCommand = {
            cssClass: this.parent.insertImageSettings.display === "inline" ? $afc560df281b588d$export$650bb6ed56b4642 : $afc560df281b588d$export$c6e979ddaa53685e,
            url: this.parent.insertImageSettings.path + file.name,
            selection: selection,
            altText: file.name.replace(/\.[a-zA-Z0-9]+$/, ""),
            width: {
                width: this.parent.insertImageSettings.width,
                minWidth: this.parent.insertImageSettings.minWidth,
                maxWidth: this.parent.getInsertImgMaxWidth()
            },
            height: {
                height: this.parent.insertImageSettings.height,
                minHeight: this.parent.insertImageSettings.minHeight,
                maxHeight: this.parent.insertImageSettings.maxHeight
            }
        };
        var actionBeginArgs = {
            requestType: "Image",
            name: "ImageDragAndDrop",
            cancel: false,
            originalEvent: args,
            itemCollection: imageCommand
        };
        this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
            if (!actionBeginArgs.cancel) {
                var command = actionBeginArgs.itemCollection;
                var image_1 = (0, $4ZDHT.createElement)("img", {
                    className: command.cssClass,
                    attrs: {
                        src: command.url,
                        alt: command.altText
                    }
                });
                image_1.style.opacity = "0.5";
                image_1.classList.add($afc560df281b588d$export$43b7526f3bcf1c7d);
                image_1.classList.add($afc560df281b588d$export$650bb6ed56b4642);
                image_1.classList.add($afc560df281b588d$export$905c13406078d997);
                range.insertNode(image_1);
                _this.uploadMethod(args, image_1);
                image_1.addEventListener("load", function(e) {
                    var actionCompleteArgs = {
                        requestType: "Image",
                        name: "InsertDropImage",
                        elements: [
                            image_1
                        ],
                        event: e,
                        editorMode: "HTML"
                    };
                    _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, actionCompleteArgs);
                });
                (0, $4ZDHT.detach)(parentElement);
            } else actionBeginArgs.originalEvent.preventDefault();
        });
    };
    /**
     * Rendering uploader and popup for drag and drop
     *
     * @param {DragEvent} dragEvent - specifies the event.
     * @param {HTMLImageElement} imageElement - specifies the element.
     * @returns {void}
     */ Image.prototype.uploadMethod = function(dragEvent, imageElement) {
        var _this = this;
        var isUploading = false;
        // eslint-disable-next-line
        var proxy = this;
        var popupEle = this.parent.createElement("div");
        this.parent.rootContainer.appendChild(popupEle);
        var uploadEle = this.parent.createElement("input", {
            id: this.rteID + "_upload",
            attrs: {
                type: "File",
                name: "UploadFiles"
            }
        });
        var offsetY = this.parent.iframeSettings.enable ? -50 : -90;
        this.popupObj = new (0, $2vAqh.Popup)(popupEle, {
            relateTo: imageElement,
            height: "85px",
            width: "300px",
            offsetY: offsetY,
            content: uploadEle,
            viewPortElement: this.parent.element,
            position: {
                X: "center",
                Y: "top"
            },
            enableRtl: this.parent.enableRtl,
            zIndex: 10001,
            // eslint-disable-next-line
            close: function(event) {
                _this.parent.isBlur = false;
                _this.popupObj.destroy();
                (0, $4ZDHT.detach)(_this.popupObj.element);
                _this.popupObj = null;
                if (!_this.parent.inlineMode.enable) _this.parent.toolbarModule.baseToolbar.toolbarObj.disable(false);
            }
        });
        this.popupObj.element.style.display = "none";
        (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], $afc560df281b588d$export$22ab25c53e8ff6fa);
        (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], $afc560df281b588d$export$d9076b806c6d0f7b);
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], this.parent.cssClass.replace(/\s+/g, " ").trim().split(" "));
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var timeOut = dragEvent.dataTransfer.files[0].size > 1000000 ? 300 : 100;
        this.imageDragPopupTime = setTimeout(function() {
            proxy.refreshPopup(imageElement);
        }, timeOut);
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            asyncSettings: {
                saveUrl: this.parent.insertImageSettings.saveUrl,
                removeUrl: this.parent.insertImageSettings.removeUrl
            },
            cssClass: $afc560df281b588d$export$a464db1be8da8ef9 + this.parent.getCssClass(true),
            dropArea: this.parent.element,
            allowedExtensions: this.parent.insertImageSettings.allowedTypes.toString(),
            removing: function() {
                _this.parent.inputElement.contentEditable = "true";
                isUploading = false;
                (0, $4ZDHT.detach)(imageElement);
                _this.popupObj.close();
            },
            canceling: function() {
                _this.parent.inputElement.contentEditable = "true";
                isUploading = false;
                (0, $4ZDHT.detach)(imageElement);
                _this.popupObj.close();
                _this.quickToolObj.imageQTBar.hidePopup();
                _this.uploadCancelTime = setTimeout(function() {
                    _this.uploadObj.destroy();
                }, 900);
            },
            beforeUpload: function(args) {
                _this.parent.trigger($947a002e9a697770$export$21462d42bdb4e9c, args);
                if (!_this.parent.inlineMode.enable) _this.parent.toolbarModule.baseToolbar.toolbarObj.disable(true);
            },
            uploading: function(e) {
                if (!_this.parent.isServerRendered) {
                    isUploading = true;
                    _this.parent.trigger($947a002e9a697770$export$fce94e5d515bb6fa, e, function(imageUploadingArgs) {
                        if (imageUploadingArgs.cancel) {
                            if (!(0, $3EnZW.isNullOrUndefined)(imageElement)) (0, $4ZDHT.detach)(imageElement);
                            if (!(0, $3EnZW.isNullOrUndefined)(_this.popupObj.element)) (0, $4ZDHT.detach)(_this.popupObj.element);
                        } else _this.parent.inputElement.contentEditable = "false";
                    });
                }
            },
            selected: function(e) {
                if (isUploading) e.cancel = true;
            },
            failure: function(e) {
                isUploading = false;
                _this.parent.inputElement.contentEditable = "true";
                var args = {
                    args: dragEvent,
                    type: "Images",
                    isNotify: undefined,
                    elements: imageElement
                };
                _this.uploadFailureTime = setTimeout(function() {
                    _this.uploadFailure(imageElement, args, e);
                }, 900);
            },
            success: function(e) {
                if (e.operation === "cancel") return;
                isUploading = false;
                _this.parent.inputElement.contentEditable = "true";
                var args = {
                    args: dragEvent,
                    type: "Images",
                    isNotify: undefined,
                    elements: imageElement
                };
                _this.uploadSuccessTime = setTimeout(function() {
                    _this.uploadSuccess(imageElement, dragEvent, args, e);
                }, 900);
            }
        });
        this.uploadObj.appendTo(this.popupObj.element.childNodes[0]);
        this.popupObj.element.querySelector(".e-rte-dialog-upload .e-file-select-wrap").style.display = "none";
        range.selectNodeContents(imageElement);
        this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(), range);
    };
    Image.prototype.refreshPopup = function(imageElement) {
        var imgPosition = this.parent.iframeSettings.enable ? this.parent.element.offsetTop + imageElement.offsetTop : imageElement.offsetTop;
        var rtePosition = this.parent.element.offsetTop + this.parent.element.offsetHeight;
        if (imgPosition > rtePosition) {
            this.popupObj.relateTo = this.parent.inputElement;
            this.popupObj.offsetY = this.parent.iframeSettings.enable ? -30 : -65;
            this.popupObj.element.style.display = "block";
        } else if (this.popupObj) {
            this.popupObj.refreshPosition(imageElement);
            this.popupObj.element.style.display = "block";
        }
    };
    /**
     * Called when drop image upload was failed
     *
     * @param {HTMLElement} imgEle - specifies the image element.
     * @param {IShowPopupArgs} args - specifies the arguments.
     * @param {Object} e - specfies the object.
     * @returns {void}
     */ Image.prototype.uploadFailure = function(imgEle, args, e) {
        (0, $4ZDHT.detach)(imgEle);
        if (this.popupObj) this.popupObj.close();
        this.parent.trigger($947a002e9a697770$export$e3f6ff7da8c3e03f, e);
        this.uploadObj.destroy();
    };
    /**
     * Called when drop image upload was successful
     *
     * @param {HTMLElement} imageElement - specifies the image element.
     * @param {DragEvent} dragEvent - specifies the drag event.
     * @param {IShowPopupArgs} args - specifies the arguments.
     * @param {ImageSuccessEventArgs} e - specifies the success event.
     * @returns {void}
     */ Image.prototype.uploadSuccess = function(imageElement, dragEvent, args, e) {
        var _this = this;
        imageElement.style.opacity = "1";
        imageElement.classList.add($afc560df281b588d$export$cab1e7d690401761);
        e.element = imageElement;
        e.detectImageSource = (0, $2eaa618655f536c2$export$857a3989d2b808cc).Dropped;
        this.parent.trigger($947a002e9a697770$export$3d5930a2bedfca4f, e, function(e) {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.insertImageSettings.path)) {
                var url = _this.parent.insertImageSettings.path + e.file.name;
                imageElement.src = url;
                imageElement.setAttribute("alt", e.file.name);
            }
        });
        if (this.popupObj) {
            this.popupObj.close();
            this.uploadObj.destroy();
        }
        this.showImageQuickToolbar(args);
        this.resizeStart(dragEvent, imageElement);
    };
    Image.prototype.imagePaste = function(args) {
        var _this = this;
        if (args.text.length === 0 && !(0, $3EnZW.isNullOrUndefined)(args.file)) {
            // eslint-disable-next-line
            var proxy_1 = this;
            var reader_2 = new FileReader();
            args.args.preventDefault();
            // eslint-disable-next-line
            reader_2.addEventListener("load", function(e) {
                var url = {
                    cssClass: proxy_1.parent.insertImageSettings.display === "inline" ? $afc560df281b588d$export$650bb6ed56b4642 : $afc560df281b588d$export$c6e979ddaa53685e,
                    url: _this.parent.insertImageSettings.saveFormat === "Base64" || !(0, $3EnZW.isNullOrUndefined)(args.callBack) ? reader_2.result : URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(reader_2.result)),
                    width: {
                        width: proxy_1.parent.insertImageSettings.width,
                        minWidth: proxy_1.parent.insertImageSettings.minWidth,
                        maxWidth: proxy_1.parent.getInsertImgMaxWidth()
                    },
                    height: {
                        height: proxy_1.parent.insertImageSettings.height,
                        minHeight: proxy_1.parent.insertImageSettings.minHeight,
                        maxHeight: proxy_1.parent.insertImageSettings.maxHeight
                    }
                };
                if (!(0, $3EnZW.isNullOrUndefined)(args.callBack)) {
                    args.callBack(url);
                    return;
                } else {
                    proxy_1.parent.formatter.process(proxy_1.parent, {
                        item: {
                            command: "Images",
                            subCommand: "Image"
                        }
                    }, args.args, url);
                    _this.showPopupToolBar(args, url);
                }
            });
            reader_2.readAsDataURL(args.file);
        }
    };
    Image.prototype.showPopupToolBar = function(e, url) {
        var _this = this;
        var imageSrc = 'img[src="' + url.url + '"]';
        var imageElement = this.parent.inputElement.querySelector(imageSrc);
        this.parent.quickToolbarModule.createQTBar("Image", "MultiRow", this.parent.quickToolbarSettings.image, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).ImageToolbar);
        var args = {
            args: e.args,
            type: "Images",
            isNotify: undefined,
            elements: imageElement
        };
        if (imageElement) this.showImageQTbarTime = setTimeout(function() {
            _this.showImageQuickToolbar(args);
            _this.resizeStart(e.args, imageElement);
        }, 0);
    };
    /* eslint-disable */ /**
     * Destroys the ToolBar.
     *
     * @method destroy
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ Image.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.prevSelectedImgEle = undefined;
        if (!(0, $3EnZW.isNullOrUndefined)(this.imageQTPopupTime)) {
            clearTimeout(this.imageQTPopupTime);
            this.imageQTPopupTime = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.imageDragPopupTime)) {
            clearTimeout(this.imageDragPopupTime);
            this.imageDragPopupTime = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.uploadCancelTime)) {
            clearTimeout(this.uploadCancelTime);
            this.uploadCancelTime = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.uploadFailureTime)) {
            clearTimeout(this.uploadFailureTime);
            this.uploadFailureTime = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.showImageQTbarTime)) {
            clearTimeout(this.showImageQTbarTime);
            this.showImageQTbarTime = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.uploadSuccessTime)) {
            clearTimeout(this.uploadSuccessTime);
            this.uploadSuccessTime = null;
        }
        this.removeEventListener();
        this.clearDialogObj();
        this.cancelResizeAction();
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     */ Image.prototype.getModuleName = function() {
        return "image";
    };
    return Image;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");






/**
 * `Link` module is used to handle undo actions.
 */ var $d24ea15df6d7af38$export$a6c7ac8248d6e38a = /** @class */ function() {
    function Link(parent, serviceLocator) {
        this.parent = parent;
        this.rteID = parent.element.id;
        this.i10n = serviceLocator.getService("rteLocale");
        this.addEventListener();
        this.serviceLocator = serviceLocator;
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.isDestroyed = false;
        this.mouseDown = this.onDocumentClick.bind(this);
    }
    Link.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$c13c4fbf8f656592, this.linkDialog, this);
        this.parent.on($947a002e9a697770$export$133203a753e0e8c5, this.showDialog, this);
        this.parent.on($947a002e9a697770$export$1183608103c7fad2, this.closeDialog, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$ac0f8621e12395a0, this.showLinkQuickToolbar, this);
        this.parent.on($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj, this);
        this.parent.on($947a002e9a697770$export$977b0775e5db06ed, this.onToolbarAction, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$85ed0bdd39881c2c, this.removeLink, this);
        this.parent.on($947a002e9a697770$export$f32208a27284df67, this.editLink, this);
        this.parent.on($947a002e9a697770$export$95185d699e05d4d7, this.openLink, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    Link.prototype.onToolbarAction = function(args) {
        var item = args.args.item;
        switch(item.subCommand){
            case "OpenLink":
                this.parent.notify($947a002e9a697770$export$95185d699e05d4d7, args);
                break;
            case "EditLink":
                this.parent.notify($947a002e9a697770$export$f32208a27284df67, args);
                break;
            case "RemoveLink":
                this.parent.notify($947a002e9a697770$export$85ed0bdd39881c2c, args);
                break;
        }
    };
    Link.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$c13c4fbf8f656592, this.linkDialog);
        this.parent.off($947a002e9a697770$export$133203a753e0e8c5, this.showDialog);
        this.parent.off($947a002e9a697770$export$1183608103c7fad2, this.closeDialog);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$ac0f8621e12395a0, this.showLinkQuickToolbar);
        this.parent.off($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj);
        this.parent.off($947a002e9a697770$export$977b0775e5db06ed, this.onToolbarAction);
        this.parent.off($947a002e9a697770$export$85ed0bdd39881c2c, this.removeLink);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$f32208a27284df67, this.editLink);
        this.parent.off($947a002e9a697770$export$95185d699e05d4d7, this.openLink);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
    };
    Link.prototype.onIframeMouseDown = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Link.prototype.updateCss = function(currentObj, e) {
        if (currentObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) currentObj.setProperties({
                cssClass: (currentObj.cssClass + " " + e.cssClass).trim()
            });
            else currentObj.setProperties({
                cssClass: (currentObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    // eslint-disable-next-line @typescript-eslint/tslint/config
    Link.prototype.setCssClass = function(e) {
        this.updateCss(this.checkBoxObj, e);
        this.updateCss(this.dialogObj, e);
    };
    Link.prototype.showLinkQuickToolbar = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.args) && e.args.action !== "enter" && e.args.action !== "space") {
            var pageX = void 0;
            var pageY = void 0;
            if (e.type !== "Links" || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule) || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule.linkQTBar)) return;
            this.quickToolObj = this.parent.quickToolbarModule;
            var parentTop = this.parent.element.getBoundingClientRect().top;
            var parentLeft = this.parent.element.getBoundingClientRect().left;
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            var target_1;
            [].forEach.call(e.elements, function(element, index) {
                if (index === 0) target_1 = element.nodeName === "#text" ? element.parentNode : element;
            });
            if (e.isNotify) {
                var tbElement = this.parent.toolbarModule.getToolbarElement();
                var linkTop = target_1.getBoundingClientRect().top;
                var linkLeft = target_1.getBoundingClientRect().left;
                var linkPos = linkTop - parentTop;
                var tbHeight = tbElement ? tbElement.offsetHeight + this.parent.toolbarModule.getExpandTBarPopHeight() : 0;
                pageX = this.parent.iframeSettings.enable ? parentLeft + linkLeft : target_1.getBoundingClientRect().left;
                pageY = window.pageYOffset + (this.parent.iframeSettings.enable ? parentTop + tbHeight + linkTop : parentTop + linkPos);
            } else {
                var args = void 0;
                args = e.args.touches ? e.args.changedTouches[0] : args = e.args;
                pageX = this.parent.iframeSettings.enable ? window.pageXOffset + parentLeft + args.clientX : args.pageX;
                pageY = this.parent.iframeSettings.enable ? window.pageYOffset + parentTop + args.clientY : args.pageY;
            }
            if (this.quickToolObj.linkQTBar) this.quickToolObj.linkQTBar.showPopup(pageX, pageY, range.endContainer, "link");
        }
    };
    Link.prototype.hideLinkQuickToolbar = function() {
        if (this.quickToolObj && this.quickToolObj.linkQTBar && document.body.contains(this.quickToolObj.linkQTBar.element)) this.quickToolObj.linkQTBar.hidePopup();
    };
    Link.prototype.editAreaClickHandler = function(e) {
        if (this.parent.readonly) {
            this.hideLinkQuickToolbar();
            return;
        }
        var args = e.args;
        var showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (args.which === 2 || showOnRightClick && args.which === 1 || !showOnRightClick && args.which === 3) return;
        if (this.parent.editorMode === "HTML" && this.parent.quickToolbarModule && this.parent.quickToolbarModule.linkQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
            var target = args.target;
            target = this.getAnchorNode(target);
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var isPopupOpen = this.quickToolObj.linkQTBar.element.classList.contains("e-rte-pop");
            if (target.nodeName === "A" && target.childNodes.length > 0 && target.childNodes[0].nodeName !== "IMG" && e.args.target.nodeName !== "IMG" && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.parent.getRange().startContainer.parentElement, "A")) && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.parent.getRange().endContainer.parentElement, "A"))) {
                if (isPopupOpen) return;
                if (e.args.ctrlKey === false) this.showLinkQuickToolbar({
                    args: args,
                    isNotify: false,
                    type: "Links",
                    elements: [
                        args.target
                    ]
                });
                else {
                    var selection = this.parent.formatter.editorManager.nodeSelection;
                    var range = selection.getRange(this.parent.contentModule.getDocument());
                    var args_1 = {
                        args: {
                            item: {
                                subCommand: "OpenLink",
                                command: "Links",
                                name: ""
                            },
                            originalEvent: e.args
                        },
                        selectNode: selection.getNodeCollection(range),
                        selectParent: selection.getParentNodeCollection(range),
                        selection: selection.save(range, this.parent.contentModule.getDocument())
                    };
                    this.parent.notify($947a002e9a697770$export$95185d699e05d4d7, args_1);
                }
            } else this.hideLinkQuickToolbar();
        }
    };
    Link.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        switch(originalEvent.action){
            case "escape":
                if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) this.dialogObj.close();
                break;
            case "insert-link":
                this.openDialog(true, event);
                originalEvent.preventDefault();
                break;
        }
    };
    Link.prototype.openDialog = function(isInternal, event) {
        if (!isInternal) this.parent.contentModule.getEditPanel().focus();
        if (this.parent.editorMode === "HTML") {
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            var save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            var selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            var selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            var eventArgs = {
                args: event ? event.args : {
                    item: {
                        command: "Links",
                        subCommand: "CreateLink"
                    },
                    originalEvent: undefined,
                    name: !isInternal ? "showDialog" : null
                },
                selectNode: selectNodeEle,
                selection: save,
                selectParent: selectParentEle
            };
            this.linkDialog(eventArgs);
        } else {
            var textArea = this.parent.contentModule.getEditPanel();
            this.parent.formatter.editorManager.markdownSelection.save(textArea.selectionStart, textArea.selectionEnd);
            this.linkDialog({
                args: {
                    item: {
                        command: "Links",
                        subCommand: "Link"
                    },
                    originalEvent: event && event.args
                },
                member: "link",
                text: this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()),
                module: "Markdown",
                name: "insertLink"
            });
        }
    };
    Link.prototype.showDialog = function() {
        this.openDialog(false);
        this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    Link.prototype.closeDialog = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Link.prototype.clearDialogObj = function() {
        if (this.dialogObj) {
            this.dialogObj.destroy();
            (0, $4ZDHT.detach)(this.dialogObj.element);
            this.dialogObj = null;
        }
    };
    Link.prototype.linkDialog = function(e, inputDetails) {
        var _this = this;
        if (this.dialogObj) {
            this.dialogObj.hide({
                returnValue: true
            });
            return;
        }
        if (this.parent.editorMode === "HTML" && e.selectParent.length > 0 && !(0, $3EnZW.isNullOrUndefined)(e.selectParent[0].classList) && e.selectParent[0].classList.contains("e-rte-anchor") && (0, $3EnZW.isNullOrUndefined)(inputDetails)) {
            this.editLink(e);
            return;
        }
        var linkWebAddress = this.i10n.getConstant("linkWebUrl");
        var linkDisplayText = this.i10n.getConstant("linkText");
        var linkTooltip = this.i10n.getConstant("linkTooltipLabel");
        var urlPlace = this.i10n.getConstant("linkurl");
        var textPlace = this.i10n.getConstant("textPlaceholder");
        var title = this.i10n.getConstant("linkTitle");
        var linkDialogEle = this.parent.createElement("div", {
            className: "e-rte-link-dialog" + this.parent.getCssClass(true),
            id: this.rteID + "_rtelink"
        });
        this.parent.rootContainer.appendChild(linkDialogEle);
        var linkContent = this.parent.createElement("div", {
            className: "e-rte-linkcontent" + this.parent.getCssClass(true),
            id: this.rteID + "_linkContent"
        });
        var htmlTextbox = this.parent.editorMode === "HTML" ? "<label>" + linkTooltip + '</label></div><div class="e-rte-field' + this.parent.getCssClass(true) + '">' + '<input type="text" data-role ="none" spellcheck="false" placeholder = "' + title + '"aria-label="' + this.i10n.getConstant("linkTitle") + '" class="e-input e-rte-linkTitle' + this.parent.getCssClass(true) + '"></div>' + '<div class="e-rte-label' + this.parent.getCssClass(true) + '"></div>' + '<div class="e-rte-field' + this.parent.getCssClass(true) + '">' + '<input type="checkbox" class="e-rte-linkTarget' + this.parent.getCssClass(true) + '"  data-role ="none"></div>' : "";
        var content = '<div class="e-rte-label' + this.parent.getCssClass(true) + '"><label>' + linkWebAddress + "</label></div>" + '<div class="e-rte-field' + this.parent.getCssClass(true) + '">' + '<input type="text" data-role ="none" spellcheck="false" placeholder="' + urlPlace + '"aria-label="' + this.i10n.getConstant("linkWebUrl") + '" class="e-input e-rte-linkurl' + this.parent.getCssClass(true) + '"/></div>' + '<div class="e-rte-label' + this.parent.getCssClass(true) + '">' + "<label>" + linkDisplayText + '</label></div><div class="e-rte-field' + this.parent.getCssClass(true) + '"> ' + '<input type="text" data-role ="none" spellcheck="false" class="e-input e-rte-linkText' + this.parent.getCssClass(true) + '"aria-label="' + this.i10n.getConstant("linkText") + '" placeholder="' + textPlace + '">' + '</div><div class="e-rte-label' + this.parent.getCssClass(true) + '">' + htmlTextbox;
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        linkContent.appendChild(contentElem);
        var linkTarget = linkContent.querySelector(".e-rte-linkTarget");
        var linkUrl = linkContent.querySelector(".e-rte-linkurl");
        var linkText = linkContent.querySelector(".e-rte-linkText");
        var linkTitle = linkContent.querySelector(".e-rte-linkTitle");
        var linkOpenLabel = this.i10n.getConstant("linkOpenInNewWindow");
        this.checkBoxObj = new (0, $1c7c93589ae50f14$export$ea5f704b89d806f6)({
            label: linkOpenLabel,
            checked: true,
            enableRtl: this.parent.enableRtl,
            cssClass: this.parent.getCssClass()
        });
        this.checkBoxObj.isStringTemplate = true;
        this.checkBoxObj.createElement = this.parent.createElement;
        this.checkBoxObj.appendTo(linkTarget);
        var selectText = this.parent.editorMode === "HTML" ? e.selection.getRange(this.parent.contentModule.getDocument()).toString() : e.text;
        var linkInsert = this.i10n.getConstant("dialogInsert");
        var linkCancel = this.i10n.getConstant("dialogCancel");
        var selection = e.selection;
        var selectObj = {
            selfLink: this,
            selection: e.selection,
            selectParent: e.selectParent,
            args: e.args
        };
        var dialogModel = {
            header: this.i10n.getConstant("linkHeader"),
            content: linkContent,
            cssClass: (0, $afc560df281b588d$export$d3f61cb93957903e) + this.parent.getCssClass(true),
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true,
            closeOnEscape: true,
            width: (0, $5q7BP.Browser).isDevice ? "290px" : "310px",
            isModal: (0, $5q7BP.Browser).isDevice,
            buttons: [
                {
                    click: this.insertlink.bind(selectObj),
                    buttonModel: {
                        content: linkInsert,
                        cssClass: "e-flat e-insertLink" + this.parent.getCssClass(true),
                        isPrimary: true
                    }
                },
                {
                    click: this.cancelDialog.bind(selectObj),
                    buttonModel: {
                        cssClass: "e-flat" + this.parent.getCssClass(true),
                        content: linkCancel
                    }
                }
            ],
            target: (0, $5q7BP.Browser).isDevice ? document.body : this.parent.element,
            animationSettings: {
                effect: "None"
            },
            close: function(event) {
                _this.parent.isBlur = false;
                if (event && event.event.returnValue) {
                    if (_this.parent.editorMode === "HTML") selection.restore();
                    else _this.parent.formatter.editorManager.markdownSelection.restore(_this.parent.contentModule.getEditPanel());
                }
                _this.dialogObj.destroy();
                (0, $4ZDHT.detach)(_this.dialogObj.element);
                var args = _this.dialogObj;
                _this.dialogRenderObj.close(args);
                _this.dialogObj = null;
            }
        };
        // eslint-disable-next-line
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(linkDialogEle);
        linkDialogEle.style.maxHeight = "inherit";
        if ((0, $3EnZW.isNullOrUndefined)(this.dialogObj)) return;
        if (!(0, $3EnZW.isNullOrUndefined)(inputDetails)) {
            linkUrl.value = inputDetails.url;
            linkText.value = inputDetails.text;
            linkTitle.value = inputDetails.title;
            // eslint-disable-next-line
            inputDetails.target ? this.checkBoxObj.checked = true : this.checkBoxObj.checked = false;
            this.dialogObj.header = inputDetails.header;
            this.dialogObj.element.querySelector(".e-insertLink").textContent = inputDetails.btnText;
        }
        this.checkUrl(false);
        if (this.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)(inputDetails) && (!(0, $3EnZW.isNullOrUndefined)(selectText) && selectText !== "" && e.selection.range.startOffset === 0 || e.selection.range.startOffset !== e.selection.range.endOffset) || e.module === "Markdown") linkText.value = selectText;
        this.parent.element.ownerDocument.addEventListener("mousedown", this.mouseDown);
        if (this.quickToolObj) {
            this.hideLinkQuickToolbar();
            if (this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) this.quickToolObj.inlineQTBar.hidePopup();
            if (this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) this.quickToolObj.textQTBar.hidePopup();
        }
    };
    // eslint-disable-next-line
    Link.prototype.insertlink = function(e) {
        var linkEle = this.selfLink.dialogObj.element;
        var linkUrl = linkEle.querySelector(".e-rte-linkurl").value.trim();
        var linkText = linkEle.querySelector(".e-rte-linkText").value;
        var linkTitle;
        if (this.selfLink.parent.editorMode === "HTML") linkTitle = linkEle.querySelector(".e-rte-linkTitle").value;
        var target = this.selfLink.checkBoxObj.checked ? "_blank" : null;
        var linkLabel = this.selfLink.checkBoxObj.checked ? this.selfLink.i10n.getConstant("linkAriaLabel") : null;
        if (this.selfLink.parent.editorMode === "Markdown" && linkUrl === "") linkUrl = "http://";
        if (linkUrl === "") {
            this.selfLink.checkUrl(true);
            return;
        }
        if (!this.selfLink.isUrl(linkUrl)) {
            if (this.selfLink.parent.editorMode === "Markdown") linkText = linkText !== "" ? linkText : "";
            else linkText = linkText === "" ? linkUrl : linkText;
            if (!this.selfLink.parent.enableAutoUrl) linkUrl = linkUrl.indexOf("http") > -1 ? linkUrl : "http://" + linkUrl;
            else // eslint-disable-next-line
            linkUrl;
        } else this.selfLink.checkUrl(false);
        var proxy = this.selfLink;
        if (proxy.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.selection.range.startContainer.parentNode, "[id='" + proxy.parent.contentModule.getPanel().id + "'" + "]"))) {
            proxy.parent.contentModule.getEditPanel().focus();
            if ((0, $5q7BP.Browser).isIE && proxy.parent.iframeSettings.enable) this.selection.restore();
            var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.parent.contentModule.getDocument());
            this.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.parent.contentModule.getDocument());
            this.selectParent = proxy.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        }
        var value = {
            url: linkUrl,
            text: linkText,
            title: linkTitle,
            target: target,
            ariaLabel: linkLabel,
            selection: this.selection,
            selectParent: this.selectParent
        };
        if (document.body.contains(proxy.dialogObj.element)) this.selfLink.dialogObj.hide({
            returnValue: false
        });
        if ((0, $259257662ca103fc$export$80ca177350c4af26)() && proxy.parent.iframeSettings.enable) (0, $4ZDHT.select)("iframe", proxy.parent.element).contentWindow.focus();
        if (proxy.parent.editorMode === "HTML") this.selection.restore();
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        var argsValue;
        if (!(0, $3EnZW.isNullOrUndefined)(this.args) && this.args.code === "KeyK") {
            var originalEvent = this.args;
            (0, $3EnZW.extend)(this.args, {
                item: {
                    command: "Links",
                    subCommand: "CreateLink"
                },
                originalEvent: originalEvent
            }, true);
            var argsVal = {
                item: {
                    command: "Links",
                    subCommand: "CreateLink"
                },
                originalEvent: originalEvent
            };
            argsValue = argsVal;
        } else argsValue = this.args;
        this.selfLink.parent.formatter.process(this.selfLink.parent, argsValue, !(0, $3EnZW.isNullOrUndefined)(this.args) && this.args.originalEvent, value);
        this.selfLink.parent.contentModule.getEditPanel().focus();
    };
    Link.prototype.isUrl = function(url) {
        var regExp = RegExp;
        var regexp = new regExp("(ftp|http|https)://(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(/|/([\\w#!:.?+=&%@\\-\\/]))?", "gi");
        return regexp.test(url);
    };
    Link.prototype.checkUrl = function(e) {
        var linkEle = this.dialogObj.element;
        var linkUrl = linkEle.querySelector(".e-rte-linkurl");
        if (e) {
            (0, $4ZDHT.addClass)([
                linkUrl
            ], "e-error");
            linkUrl.setSelectionRange(0, linkUrl.value.length);
            linkUrl.focus();
        } else (0, $4ZDHT.removeClass)([
            linkUrl
        ], "e-error");
    };
    Link.prototype.removeLink = function(e) {
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        var selectParentEle = this.getAnchorNode(e.selectParent[0]);
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            selectParent: e.selectParent,
            selection: e.selection,
            text: selectParentEle.innerText,
            subCommand: e.args.item.subCommand
        });
        if ((0, $259257662ca103fc$export$80ca177350c4af26)() && this.parent.iframeSettings.enable) (0, $4ZDHT.select)("iframe", this.parent.element).contentWindow.focus();
        else this.parent.contentModule.getEditPanel().focus();
        this.hideLinkQuickToolbar();
    };
    Link.prototype.openLink = function(e) {
        var selectParentEle = this.getAnchorNode(e.selectParent[0]);
        if (selectParentEle.classList.contains("e-rte-anchor") || selectParentEle.tagName === "A") this.parent.formatter.process(this.parent, e.args, e.args, {
            url: selectParentEle.href,
            text: selectParentEle.innerText,
            target: selectParentEle.target === "" ? "_self" : "_blank",
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
    };
    Link.prototype.getAnchorNode = function(element) {
        var selectParent = (0, $4ZDHT.closest)(element, "a");
        return selectParent ? selectParent : element;
    };
    Link.prototype.editLink = function(e) {
        var selectedNode = this.getAnchorNode(e.selectNode[0]);
        var selectParentEle = this.getAnchorNode(e.selectParent[0]);
        selectParentEle = selectedNode.nodeName === "A" ? selectedNode : selectParentEle;
        if (selectParentEle.classList.contains("e-rte-anchor") || selectParentEle.tagName === "A") {
            var linkUpdate = this.i10n.getConstant("dialogUpdate");
            var inputDetails = {
                url: selectParentEle.getAttribute("href"),
                text: selectParentEle.innerText,
                title: selectParentEle.title,
                target: selectParentEle.target,
                header: this.i10n.getConstant("editLink"),
                btnText: linkUpdate
            };
            this.linkDialog(e, inputDetails);
        }
    };
    // eslint-disable-next-line
    Link.prototype.cancelDialog = function(e) {
        this.selfLink.parent.isBlur = false;
        this.selfLink.dialogObj.hide({
            returnValue: true
        });
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.selection.restore();
        else {
            var x = window.scrollX;
            var y = window.scrollY;
            this.selfLink.parent.contentModule.getEditPanel().focus();
            window.scrollTo(x, y);
        }
    };
    Link.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj) && (// eslint-disable-next-line
        !(0, $4ZDHT.closest)(target, "[id='" + this.dialogObj.element.id + "'" + "]") && this.parent.toolbarSettings.enable && this.parent.getToolbarElement() && !this.parent.getToolbarElement().contains(e.target) || (this.parent.getToolbarElement() && this.parent.getToolbarElement().contains(e.target) || this.parent.inlineMode.enable && !(0, $4ZDHT.closest)(target, "#" + this.dialogObj.element.id)) && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_toolbar_CreateLink") && !target.querySelector("#" + this.parent.getID() + "_toolbar_CreateLink"))) {
            this.parent.notify($947a002e9a697770$export$4895f32c534ef936, {
                closedBy: "outside click"
            });
            this.dialogObj.hide({
                returnValue: true
            });
            this.parent.element.ownerDocument.removeEventListener("mousedown", this.mouseDown);
            this.mouseDown = null;
            this.parent.isBlur = true;
            (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
        }
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ Link.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.parent.element.ownerDocument.removeEventListener("mousedown", this.mouseDown);
        this.mouseDown = null;
        this.removeEventListener();
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     */ Link.prototype.getModuleName = function() {
        return "link";
    };
    return Link;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
var $13zI2 = parcelRequire("13zI2");
/**
 * Constant values for Markdown Parser
 */ /**
 * List plugin events
 *
 * @hidden
 */ var $a08d2100ce06ecee$export$baef95a53485c3e2 = "lists-commands";
var $a08d2100ce06ecee$export$7a8b6a1abdd0777b = "command-type";
var $a08d2100ce06ecee$export$268a6231cd912896 = "link-commands";
var $a08d2100ce06ecee$export$10e55da310d14a57 = "clear-commands";
var $a08d2100ce06ecee$export$90d351dbe45272a2 = "insert-table";
var $a08d2100ce06ecee$export$94b363b9fea45dcf = "insert-text";



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Lists internal component
 *
 * @hidden
 */ var $660ea6f21d1695f0$export$3e9b220a716171f3 = /** @class */ function() {
    /**
     * Constructor for creating the Lists plugin
     *
     * @param {IMDFormats} options - specifies the options
     * @hidden
     */ function MDLists(options) {
        (0, $3EnZW.extend)(this, this, options, true);
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDLists.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$baef95a53485c3e2, this.applyListsHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.keyUpHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDLists.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$baef95a53485c3e2, this.applyListsHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, this.keyUpHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MDLists.prototype.keyDownHandler = function(event) {
        switch(event.event.which){
            case 9:
                this.tabKey(event);
                break;
        }
        switch(event.event.action){
            case "ordered-list":
                this.applyListsHandler({
                    subCommand: "OL",
                    callBack: event.callBack
                });
                event.event.preventDefault();
                break;
            case "unordered-list":
                this.applyListsHandler({
                    subCommand: "UL",
                    callBack: event.callBack
                });
                event.event.preventDefault();
                break;
        }
    };
    MDLists.prototype.keyUpHandler = function(event) {
        switch(event.event.which){
            case 13:
                this.enterKey(event);
                break;
        }
    };
    MDLists.prototype.tabKey = function(event) {
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var parents = this.selection.getSelectedParentPoints(textArea);
        var addedLength = 0;
        var isNotFirst = this.isNotFirstLine(textArea, parents[0]);
        if (!isNotFirst && !event.event.shiftKey) {
            this.restore(textArea, start, end + addedLength, event);
            return;
        }
        var listFormat = this.olListType();
        var regex = this.getListRegex();
        this.currentAction = this.getAction(parents[0].text);
        for(var i = 0; i < parents.length; i++){
            // eslint-disable-next-line max-len
            var prevIndex = event.event.shiftKey ? parents[i].line - 1 : parents[i].line - 1;
            var prevLine = this.selection.getLine(textArea, prevIndex);
            if (prevLine && (!event.event.shiftKey && isNotFirst || event.event.shiftKey)) {
                var prevLineSplit = prevLine.split(". ");
                var tabSpace = "	";
                var tabSpaceLength = event.event.shiftKey ? -tabSpace.length : tabSpace.length;
                var splitTab = parents[i].text.split("	");
                if (event.event.shiftKey && splitTab.length === 1) break;
                if (this.currentAction === "OL" && /^\d+$/.test(prevLineSplit[0].trim()) && listFormat) {
                    event.event.preventDefault();
                    parents[i].text = event.event.shiftKey ? splitTab.splice(1, splitTab.length).join("	") : tabSpace + parents[i].text;
                    var curTabSpace = this.getTabSpace(parents[i].text);
                    var prevTabSpace = this.getTabSpace(prevLine);
                    var splitText = parents[i].text.split(". ");
                    if (curTabSpace === prevTabSpace) this.changeTextAreaValue(splitText, this.nextOrderedListValue(prevLineSplit[0].trim()), event, textArea, parents, i, end);
                    else if (prevTabSpace < curTabSpace) this.changeTextAreaValue(splitText, "1. ", event, textArea, parents, i, end);
                    else for(; prevTabSpace.length > curTabSpace.length;){
                        prevIndex = prevIndex - 1;
                        prevLine = this.selection.getLine(textArea, prevIndex);
                        var prevLineSplit_1 = prevLine.trim().split(". ");
                        if (/^\d+$/.test(prevLineSplit_1[0])) {
                            prevTabSpace = this.getTabSpace(prevLine);
                            if (prevTabSpace.length <= curTabSpace.length) {
                                this.changeTextAreaValue(splitText, this.nextOrderedListValue(prevLineSplit_1[0]), event, textArea, parents, i, end);
                                break;
                            }
                        }
                    }
                } else if (this.currentAction === "UL" && regex.test(prevLine.trim()) || !listFormat) {
                    event.event.preventDefault();
                    parents[i].text = event.event.shiftKey ? splitTab.splice(1, splitTab.length).join("	") : tabSpace + parents[i].text;
                    textArea.value = textArea.value.substr(0, parents[i].start) + parents[i].text + "\n" + textArea.value.substr(parents[i].end, textArea.value.length);
                }
                start = i === 0 ? start + tabSpaceLength : start;
                addedLength += tabSpaceLength;
                if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                    // eslint-disable-next-line max-len
                    parents[j].start = j !== 0 ? parents[j].start + tabSpaceLength : parents[j].start;
                    parents[j].end = parents[j].end + tabSpaceLength;
                }
            }
        }
        this.restore(textArea, start, end + addedLength, event);
    };
    MDLists.prototype.changeTextAreaValue = function(splitText, prefixValue, event, // eslint-disable-next-line
    textArea, parents, k, end) {
        var prefix = prefixValue;
        splitText.splice(0, 1);
        var textAreaLength = this.selection.getAllParents(textArea.value).length;
        var changedList = "";
        var curTabSpace = this.getTabSpace(parents[k].text);
        // eslint-disable-next-line
        var prefixNumber = parseInt(prefix.split(".")[0], null);
        var nestedTabSpace = this.getTabSpace(parents[k].text);
        var nestedlistorder = true;
        var nestedListStart = true;
        var curTabSpaceLength;
        var nextPrefixValue = -1;
        var traversIncreased = true;
        var nextLineLength = 0;
        var lineBreak = "";
        changedList = this.selection.getLine(textArea, parents[0].line + 1) !== "" ? "" : changedList + textArea.value.substr(parents[0].end, textArea.value.length);
        for(var i = 1; i < textAreaLength && !(0, $3EnZW.isNullOrUndefined)(this.selection.getLine(textArea, parents[0].line + i)) && this.selection.getLine(textArea, parents[0].line + i) !== ""; i++){
            var nextLine = this.selection.getLine(textArea, parents[0].line + i);
            var nextTabSpace = this.getTabSpace(nextLine);
            var nextLineSplit = nextLine.split(". ");
            if (nextLineSplit.length === 1) {
                changedList += textArea.value.substr(parents[0].end + nextLineLength, textArea.value.length);
                break;
            } else {
                nextLineLength += nextLine.length;
                var shiftTabTargetList = false;
                curTabSpaceLength = event.event.shiftKey ? curTabSpace.length + 1 : curTabSpace.length - 1;
                if (nextTabSpace.length > nestedTabSpace.length) traversIncreased = false;
                if (curTabSpace.length !== nextTabSpace.length && nextTabSpace.length < nestedTabSpace.length) {
                    nestedListStart = true;
                    nestedlistorder = false;
                    shiftTabTargetList = event.event.shiftKey && curTabSpace.length === nextTabSpace.length ? (nestedListStart = false, true) : false;
                } else if (traversIncreased && event.event.shiftKey && curTabSpace.length === nextTabSpace.length && nextTabSpace.length === nestedTabSpace.length) {
                    nestedListStart = false;
                    shiftTabTargetList = true;
                }
                lineBreak = changedList === "" ? "" : "\n";
                if (curTabSpaceLength === nextTabSpace.length && nestedListStart) {
                    var nextPrefix = event.event.shiftKey ? (nextPrefixValue++, this.nextOrderedListValue(nextPrefixValue.toString())) : this.previousOrderedListValue(nextLineSplit[0]);
                    nextLineSplit.splice(0, 1);
                    changedList = changedList + lineBreak + nextTabSpace + nextPrefix + nextLineSplit.join(". ");
                } else if (curTabSpace.length === nextTabSpace.length && nestedlistorder || shiftTabTargetList) {
                    var nextPrefix = this.nextOrderedListValue(prefixNumber.toString());
                    prefixNumber++;
                    nextLineSplit.splice(0, 1);
                    changedList = changedList + lineBreak + nextTabSpace + nextPrefix + nextLineSplit.join(". ");
                } else {
                    changedList = changedList + lineBreak + nextLine;
                    nestedListStart = false;
                }
                nestedTabSpace = this.getTabSpace(nextLine);
            }
        }
        parents[k].text = this.getTabSpace(parents[k].text) + prefix + splitText.join(". ") + "\n";
        textArea.value = textArea.value.substr(0, parents[k].start) + parents[k].text + changedList;
    };
    MDLists.prototype.getTabSpace = function(line) {
        var split = line.split("	");
        var tabs = "";
        for(var i = 0; i < split.length; i++){
            if (split[i] === "") tabs += "	";
            else break;
        }
        return tabs;
    };
    MDLists.prototype.isNotFirstLine = function(textArea, points) {
        var currentLine = points.text;
        var prevIndex = points.line - 1;
        var prevLine = this.selection.getLine(textArea, prevIndex);
        var regex = this.getListRegex();
        var isNotFirst = false;
        var regexFirstCondition;
        if (prevLine) {
            this.currentAction = this.getAction(prevLine);
            var prevLineSplit = prevLine.split(". ");
            regexFirstCondition = this.currentAction === "OL" ? /^\d+$/.test(prevLineSplit[0].trim()) : regex.test(prevLine.trim());
        }
        if (prevLine && regexFirstCondition) {
            var curTabSpace = this.getTabSpace(currentLine);
            var prevTabSpace = this.getTabSpace(prevLine);
            isNotFirst = curTabSpace === prevTabSpace ? true : isNotFirst;
            for(; prevTabSpace.length > curTabSpace.length;){
                prevIndex = prevIndex - 1;
                prevLine = this.selection.getLine(textArea, prevIndex);
                var prevLineSplit = prevLine.trim().split(". ");
                var regexSecondCondition = this.currentAction === "OL" ? /^\d+$/.test(prevLineSplit[0]) : regex.test(prevLine.trim());
                if (regexSecondCondition) {
                    prevTabSpace = this.getTabSpace(prevLine);
                    if (prevTabSpace.length <= curTabSpace.length) {
                        isNotFirst = true;
                        break;
                    }
                }
            }
        }
        return isNotFirst;
    };
    MDLists.prototype.getAction = function(line) {
        var ol = line.split(". ")[0];
        // eslint-disable-next-line
        var currentState = /^\d+$/.test(ol.trim());
        // eslint-disable-next-line
        var ul = line.trim().split(new RegExp("^(" + this.selection.replaceSpecialChar(this.syntax.UL).trim() + ")"))[1];
        return currentState ? "OL" : ul ? "UL" : "NOTLIST";
    };
    MDLists.prototype.nextOrderedListValue = function(previousLine) {
        // eslint-disable-next-line
        var currentValue = parseInt(previousLine, null);
        var nextValue = currentValue + 1;
        return nextValue.toString() + ". ";
    };
    MDLists.prototype.previousOrderedListValue = function(previousLine) {
        // eslint-disable-next-line
        var currentValue = parseInt(previousLine, null);
        var nextValue = currentValue - 1;
        return nextValue.toString() + ". ";
    };
    MDLists.prototype.enterKey = function(event) {
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var parents = this.selection.getSelectedParentPoints(textArea);
        var prevLine = this.selection.getLine(textArea, parents[0].line - 1);
        var listFormat = this.olListType();
        var regex = this.getListRegex();
        var prevLineSplit = [];
        if (!(0, $3EnZW.isNullOrUndefined)(prevLine)) {
            prevLineSplit = prevLine.split(". ");
            this.currentAction = this.getAction(prevLine);
        }
        var addedLength = 0;
        if (this.currentAction === "OL" && prevLineSplit.length > 1 && /^\d+$/.test(prevLineSplit[0].trim()) && listFormat && prevLineSplit[1] !== "") {
            var tabSpace = this.getTabSpace(prevLine);
            this.currentAction = this.getAction(prevLine);
            var prefix = this.nextOrderedListValue(prevLineSplit[0]);
            parents[0].text = tabSpace + prefix + parents[0].text;
            var textAreaLength = this.selection.getAllParents(textArea.value).length;
            var changedList = "\n";
            var curTabSpace = this.getTabSpace(prevLine);
            var nestedTabSpace = this.getTabSpace(parents[0].text);
            var nestedListOrder = true;
            for(var i = 1; i < textAreaLength && textArea.value.substr(parents[0].end, textArea.value.length) !== ""; i++){
                var nextLine = this.selection.getLine(textArea, parents[0].line + i);
                if ((0, $3EnZW.isNullOrUndefined)(nextLine)) changedList = changedList + "";
                else {
                    var nextLineSplit = nextLine.split(". ");
                    var nextTabSpace = this.getTabSpace(nextLine);
                    if (nextTabSpace.length < nestedTabSpace.length) nestedListOrder = false;
                    if (nextLineSplit.length > 1 && /^\d+$/.test(nextLineSplit[0].trim()) && curTabSpace.length === nextTabSpace.length && nestedListOrder) {
                        var nextPrefix = this.nextOrderedListValue(nextLineSplit[0]);
                        nextLineSplit.splice(0, 1);
                        changedList = changedList + nextTabSpace + nextPrefix + nextLineSplit.join(". ") + "\n";
                    } else {
                        changedList = changedList + nextLine + "\n";
                        nestedTabSpace = this.getTabSpace(nextLine);
                    }
                }
            }
            textArea.value = textArea.value.substr(0, parents[0].start) + curTabSpace + prefix + this.selection.getLine(textArea, parents[0].line) + changedList;
            start = start + prefix.length + tabSpace.length;
            addedLength += prefix.length + tabSpace.length;
        } else if (this.currentAction === "UL" && prevLine && regex.test(prevLine.trim()) && prevLine.trim().replace(regex, "") !== "" || this.currentAction === "OL" && !listFormat) {
            var tabSpace = this.getTabSpace(prevLine);
            var prefix = this.syntax[this.currentAction];
            parents[0].text = tabSpace + prefix + parents[0].text + (parents[0].text.trim().length > 0 ? "\n" : "");
            textArea.value = textArea.value.substr(0, parents[0].start) + parents[0].text + textArea.value.substr(parents[0].end, textArea.value.length);
            start = start + prefix.length + tabSpace.length;
            addedLength += prefix.length + tabSpace.length;
        }
        this.restore(textArea, start, end + addedLength, event);
    };
    MDLists.prototype.olListType = function() {
        var olSyntaxList = this.syntax.OL.split(".,");
        var listType = olSyntaxList.length === 1 ? null : // eslint-disable-next-line
        parseInt(olSyntaxList[2].trim(), null) - parseInt(olSyntaxList[0].trim(), null);
        if (listType) return 1;
        else return 0;
    };
    MDLists.prototype.applyListsHandler = function(e) {
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        this.currentAction = e.subCommand;
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var addedLength = 0;
        var startLength = 0;
        var endLength = 0;
        var parents = this.selection.getSelectedParentPoints(textArea);
        var prefix = "";
        var listFormat = this.olListType();
        var regex;
        var perfixObj = {};
        for(var i = 0; i < parents.length; i++){
            if (listFormat) regex = this.currentAction === "OL" ? i + listFormat + ". " : this.syntax[this.currentAction];
            else regex = this.currentAction === "OL" ? this.syntax.OL : this.syntax[this.currentAction];
            if (!this.selection.isStartWith(parents[i].text, regex)) {
                if (parents[i].text === "" && i === 0) {
                    this.selection.save(start, end);
                    if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                        parents[j].start = j !== 0 ? 1 + parents[j].start : parents[j].start;
                        parents[j].end = 1 + parents[j].end;
                    }
                }
                var preLineTabSpaceLength = !(0, $3EnZW.isNullOrUndefined)(parents[i - 1]) ? this.getTabSpace(parents[i - 1].text).length : 0;
                var replace = this.appliedLine(parents[i].text, regex, perfixObj, preLineTabSpaceLength);
                prefix = replace.line ? prefix : regex;
                parents[i].text = replace.line ? replace.line : prefix + parents[i].text;
                replace.space = replace.space ? replace.space : 0;
                textArea.value = textArea.value.substr(0, parents[i].start + endLength) + parents[i].text + "\n" + textArea.value.substr(parents[i].end, textArea.value.length);
                start = i === 0 ? start + prefix.length + replace.space > 0 ? start + prefix.length + replace.space : 0 : start;
                addedLength += prefix.length + replace.space;
                if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                    parents[j].start = j !== 0 ? prefix.length + parents[j].start + replace.space : parents[j].start;
                    parents[j].end = prefix.length + parents[j].end + replace.space;
                }
                this.restore(textArea, start, end + addedLength, null);
            } else {
                parents[i].text = parents[i].text.replace(regex, "");
                textArea.value = textArea.value.substr(0, parents[i].start + endLength) + parents[i].text + "\n" + textArea.value.substr(parents[i].end + endLength, textArea.value.length);
                endLength -= regex.length;
                startLength = regex.length;
                this.restore(textArea, start - startLength, end + endLength, null);
            }
        }
        this.restore(textArea, null, null, e);
    };
    MDLists.prototype.appliedLine = function(line, prefixPattern, perfixObj, preTabSpaceLength) {
        var points = {};
        // eslint-disable-next-line
        var regex = new RegExp("^[" + this.syntax.UL.trim() + "]");
        var lineSplit = line.split(". ");
        var currentPrefix = lineSplit[0] + ". ";
        var isExist = regex.test(line.trim()) || line.trim() === this.syntax.OL.trim() || line.trim() === this.syntax.UL.trim() || /^\d+$/.test(lineSplit[0].trim());
        var listFormat = this.olListType();
        var curTabSpaceLength = this.getTabSpace(line).length;
        if (this.currentAction === "OL" && listFormat) {
            perfixObj[curTabSpaceLength.toString()] = !(0, $3EnZW.isNullOrUndefined)(perfixObj[curTabSpaceLength.toString()]) ? perfixObj[curTabSpaceLength.toString()].valueOf() + 1 : 1;
            prefixPattern = perfixObj[curTabSpaceLength.toString()].valueOf().toString() + ". ";
            if (!(0, $3EnZW.isNullOrUndefined)(preTabSpaceLength) && preTabSpaceLength > curTabSpaceLength) perfixObj[preTabSpaceLength.toString()] = 0;
        }
        if (isExist) {
            var replace = void 0;
            var pattern = void 0;
            // eslint-disable-next-line
            var space = 0;
            if (regex.test(line.trim())) {
                pattern = this.syntax.UL;
                replace = prefixPattern;
                points.space = prefixPattern.trim().length - this.syntax.UL.trim().length;
            } else if (/^\d+$/.test(lineSplit[0].trim()) && listFormat) {
                pattern = lineSplit[0].trim() + ". ";
                replace = prefixPattern;
                points.space = this.syntax.UL.trim().length - currentPrefix.trim().length;
            } else if (/^\d+$/.test(lineSplit[0].trim())) {
                pattern = lineSplit[0].trim() + ". ";
                replace = this.syntax.UL;
                points.space = this.syntax.UL.trim().length - currentPrefix.trim().length;
            }
            points.line = line.replace(pattern, replace);
        }
        return points;
    };
    MDLists.prototype.restore = function(textArea, start, end, event) {
        if (!(0, $3EnZW.isNullOrUndefined)(start) && !(0, $3EnZW.isNullOrUndefined)(start)) this.selection.save(start, end);
        if (!(0, $3EnZW.isNullOrUndefined)(event)) this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: this.currentAction,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    MDLists.prototype.getListRegex = function() {
        var regex = "";
        var configKey = Object.keys(this.syntax);
        var regExp = RegExp;
        for(var j = 0; j < configKey.length; j++){
            var syntax = this.selection.replaceSpecialChar(this.syntax[configKey[j]]);
            regex += regex === "" ? "^(" + syntax + ")|^(" + syntax.trim() + ")" : "|^(" + syntax + ")|^(" + syntax.trim() + ")";
        }
        return new regExp(regex);
    };
    MDLists.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MDLists;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");


/**
 * MDFormats internal plugin
 *
 * @hidden

 */ var $08fb55b03e008240$export$bfbb5aaec69d5c10 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {IMDFormats} options - specifies the formats
     * @hidden

     */ function MDFormats(options) {
        (0, $3EnZW.extend)(this, this, options, true);
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDFormats.prototype.addEventListener = function() {
        this.parent.observer.on($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, this.applyFormats, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDFormats.prototype.removeEventListener = function() {
        this.parent.observer.off($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, this.applyFormats);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MDFormats.prototype.applyFormats = function(e) {
        e.subCommand = e.subCommand.toLowerCase();
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        var parents = this.selection.getSelectedParentPoints(textArea);
        if (this.isAppliedFormat(parents) === e.subCommand) {
            if (e.subCommand === "pre") {
                if (parents.length > 1) this.applyCodeBlock(textArea, e, parents);
                else return;
            }
            this.cleanFormat(textArea);
            this.restore(textArea, textArea.selectionStart, textArea.selectionEnd, e);
            return;
        }
        if (e.subCommand === "p") {
            this.cleanFormat(textArea);
            this.restore(textArea, textArea.selectionStart, textArea.selectionEnd, e);
            return;
        } else if (e.subCommand === "pre" && parents.length !== 1 || e.subCommand !== "pre") this.cleanFormat(textArea, e.subCommand);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var addedLength = 0;
        parents = this.selection.getSelectedParentPoints(textArea);
        if (e.subCommand === "pre") {
            if (parents.length > 1) this.applyCodeBlock(textArea, e, parents);
            else {
                (0, $3EnZW.extend)(e, e, {
                    subCommand: "InlineCode"
                }, true);
                this.parent.observer.notify($a08d2100ce06ecee$export$7a8b6a1abdd0777b, e);
            }
            return;
        }
        for(var i = 0; i < parents.length; i++){
            if (parents[i].text !== "" && !this.selection.isStartWith(parents[i].text, "\\" + this.syntax[e.subCommand])) {
                parents[i].text = this.syntax[e.subCommand] + parents[i].text;
                textArea.value = textArea.value.substr(0, parents[i].start) + parents[i].text + "\n" + textArea.value.substr(parents[i].end, textArea.value.length);
                start = i === 0 ? start + this.syntax[e.subCommand].length : start;
                addedLength += this.syntax[e.subCommand].length;
                if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                    parents[j].start = j !== 0 ? this.syntax[e.subCommand].length + parents[j].start : parents[j].start;
                    parents[j].end = this.syntax[e.subCommand].length + parents[j].end;
                }
            } else if (parents[i].text === "" && i === 0) {
                this.selection.save(start, end);
                if (this.selection.getSelectedText(textArea).length === 0) {
                    parents[i].text = this.syntax[e.subCommand];
                    textArea.value = textArea.value.substr(0, parents[i].start) + this.syntax[e.subCommand] + textArea.value.substr(parents[i].end, textArea.value.length);
                    start = i === 0 ? start + this.syntax[e.subCommand].length : start;
                    addedLength += this.syntax[e.subCommand].length;
                }
                if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                    parents[j].start = j !== 0 ? 1 + parents[j].start : parents[j].start;
                    parents[j].end = 1 + parents[j].end;
                }
            }
        }
        this.restore(textArea, start, end + addedLength, e);
    };
    MDFormats.prototype.clearRegex = function() {
        var regex = "";
        var configKey = Object.keys(this.syntax);
        for(var j = 0; j < configKey.length && configKey[j] !== "pre" && configKey[j] !== "p"; j++)regex += regex === "" ? "^(" + this.selection.replaceSpecialChar(this.syntax[configKey[j]].trim()) + ")" : "|^(" + this.selection.replaceSpecialChar(this.syntax[configKey[j]].trim()) + ")";
        return regex;
    };
    MDFormats.prototype.cleanFormat = function(textArea, command) {
        var parents = this.selection.getSelectedParentPoints(textArea);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var removeLength = 0;
        if (this.selection.isClear(parents, this.clearRegex())) {
            for(var i = 0; i < parents.length; i++){
                var configKey = Object.keys(this.syntax);
                for(var j = 0; parents[i].text !== "" && j < configKey.length; j++){
                    var removeText = this.syntax[configKey[j]];
                    if (configKey[j] === command) continue;
                    // eslint-disable-next-line
                    var regex = new RegExp("^(" + this.selection.replaceSpecialChar(removeText) + ")", "gim");
                    if (regex.test(parents[i].text)) {
                        parents[i].text = parents[i].text.replace(regex, "");
                        textArea.value = textArea.value.substr(0, parents[i].start) + parents[i].text + "\n" + textArea.value.substr(parents[i].end, textArea.value.length);
                        start = i === 0 ? start - removeText.length > 0 ? start - removeText.length : 0 : start;
                        removeLength += removeText.length;
                        if (parents.length !== 1) for(var k = 0; k < parents.length; k++){
                            parents[k].start = k !== 0 ? parents[k].start - removeText.length : parents[k].start;
                            parents[k].end = parents[k].end - removeText.length;
                        }
                        break;
                    }
                }
                if (parents[i].text === "" && i === 0) {
                    this.selection.save(start, end);
                    if (parents.length !== 1) for(var j = i; j < parents.length; j++){
                        parents[j].start = j !== 0 ? 1 + parents[j].start : parents[j].start;
                        parents[j].end = 1 + parents[j].end;
                    }
                }
            }
            this.restore(textArea, start, end - removeLength);
        }
    };
    MDFormats.prototype.applyCodeBlock = function(textArea, event, parents) {
        var command = event.subCommand;
        var start = parents[0].start;
        var end = parents[parents.length - 1].end;
        var parentLines = this.selection.getAllParents(textArea.value);
        var firstPrevText = parentLines[parents[0].line - 1];
        var lastNextText = parentLines[parents.length + 1 + 1];
        // eslint-disable-next-line
        var addedLength = 0;
        if (!this.selection.isStartWith(firstPrevText, this.syntax.pre.split("\n")[0]) && !this.selection.isStartWith(lastNextText, this.syntax.pre.split("\n")[0])) {
            var lines = textArea.value.substring(start, end).split("\n");
            var lastLine = lines[lines.length - 1] === "" ? "" : "\n";
            textArea.value = textArea.value.substr(0, start) + this.syntax["" + command] + textArea.value.substring(start, end) + lastLine + this.syntax["" + command] + textArea.value.substr(end, textArea.value.length);
            start = this.selection.selectionStart + this.syntax["" + command].length;
            end = this.selection.selectionEnd + this.syntax["" + command].length - 1;
        } else {
            var cmd = this.syntax["" + command];
            var selection = this.parent.markdownSelection.getSelectedInlinePoints(textArea);
            var startNo = textArea.value.substr(0, textArea.selectionStart).lastIndexOf(cmd);
            var endNo = textArea.value.substr(textArea.selectionEnd, textArea.selectionEnd).indexOf(cmd);
            endNo = endNo + selection.end;
            var repStartText = this.replaceAt(textArea.value.substr(0, selection.start), cmd, "", startNo, selection.start);
            var repEndText = this.replaceAt(textArea.value.substr(selection.end, textArea.value.length), cmd, "", 0, endNo);
            textArea.value = repStartText + selection.text + repEndText;
            start = this.selection.selectionStart - cmd.length;
            end = this.selection.selectionEnd - cmd.length;
        }
        this.restore(textArea, start, end, event);
    };
    MDFormats.prototype.replaceAt = function(input, search, replace, start, end) {
        return input.slice(0, start) + input.slice(start, end).replace(search, replace) + input.slice(end);
    };
    MDFormats.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: event.subCommand,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    MDFormats.prototype.isAppliedFormat = function(lines, documentNode) {
        var format = "p";
        // eslint-disable-next-line
        var configKey = Object.keys(this.syntax);
        var keys = Object.keys(this.syntax);
        var direction = this.parent.element.selectionDirection;
        var checkLine = direction === "backward" ? lines[0].text : lines[lines.length - 1].text;
        for(var i = 0; !documentNode && i < keys.length; i++){
            if (keys[i] !== "pre" && this.selection.isStartWith(checkLine, this.syntax[keys[i]])) {
                format = keys[i];
                break;
            } else if (keys[i] === "pre") {
                var parentLines = this.selection.getAllParents(this.parent.element.value);
                var firstPrevText = parentLines[lines[0].line - 1];
                var lastNextText = parentLines[lines.length + 1];
                if (this.selection.isStartWith(firstPrevText, this.syntax[keys[i]].split("\n")[0]) && this.selection.isStartWith(lastNextText, this.syntax[keys[i]].split("\n")[0])) {
                    format = keys[i];
                    break;
                }
            }
        }
        return format;
    };
    MDFormats.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MDFormats;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");


/**
 * SelectionCommands internal component
 *
 * @hidden

 */ var $86772f8f16025794$export$44c08ff7044b1d3f = /** @class */ function() {
    function MDSelectionFormats(parent) {
        (0, $3EnZW.extend)(this, this, parent, true);
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDSelectionFormats.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$7a8b6a1abdd0777b, this.applyCommands, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDSelectionFormats.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$7a8b6a1abdd0777b, this.applyCommands);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDownHandler);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MDSelectionFormats.prototype.keyDownHandler = function(e) {
        switch(e.event.action){
            case "bold":
                this.applyCommands({
                    subCommand: "Bold",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "italic":
                this.applyCommands({
                    subCommand: "Italic",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "strikethrough":
                this.applyCommands({
                    subCommand: "StrikeThrough",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "uppercase":
                this.applyCommands({
                    subCommand: "UpperCase",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "lowercase":
                this.applyCommands({
                    subCommand: "LowerCase",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "superscript":
                this.applyCommands({
                    subCommand: "SuperScript",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
            case "subscript":
                this.applyCommands({
                    subCommand: "SubScript",
                    callBack: e.callBack
                });
                e.event.preventDefault();
                break;
        }
    };
    MDSelectionFormats.prototype.isBold = function(text, cmd) {
        return text.search("\\" + cmd + "\\" + cmd + "") !== -1;
    };
    MDSelectionFormats.prototype.isItalic = function(text, cmd) {
        return text.search("\\" + cmd) !== -1;
    };
    MDSelectionFormats.prototype.isMatch = function(text, cmd) {
        var matchText = [
            ""
        ];
        switch(cmd){
            case this.syntax.Italic:
                matchText = text.match(this.singleCharRegx(cmd));
                break;
            case this.syntax.InlineCode:
                matchText = text.match(this.singleCharRegx(cmd));
                break;
            case this.syntax.StrikeThrough:
                matchText = text.match(this.singleCharRegx(cmd));
                break;
        }
        return matchText;
    };
    MDSelectionFormats.prototype.multiCharRegx = function(cmd) {
        var regExp = RegExp;
        return new regExp("(\\" + cmd + "\\" + cmd + ")", "g");
    };
    MDSelectionFormats.prototype.singleCharRegx = function(cmd) {
        var regExp = RegExp;
        return new regExp("(\\" + cmd + ")", "g");
    };
    MDSelectionFormats.prototype.isAppliedCommand = function(cmd) {
        // eslint-disable-next-line
        var selectCmd = "";
        var isFormat = false;
        var textArea = this.parent.element;
        var start = textArea.selectionStart;
        var splitAt = function(index) {
            return function(x) {
                return [
                    x.slice(0, index),
                    x.slice(index)
                ];
            };
        };
        var splitText = splitAt(start)(textArea.value);
        var cmdB = this.syntax.Bold.substr(0, 1);
        var cmdI = this.syntax.Italic;
        var selectedText = this.parent.markdownSelection.getSelectedText(textArea);
        if (selectedText !== "" && selectedText === selectedText.toLocaleUpperCase() && cmd === "UpperCase") return true;
        else if (selectedText === "") {
            var beforeText = textArea.value.substr(splitText[0].length - 1, 1);
            var afterText = splitText[1].substr(0, 1);
            if (beforeText !== "" && afterText !== "" && beforeText.match(/[a-z]/i) && beforeText === beforeText.toLocaleUpperCase() && afterText === afterText.toLocaleUpperCase() && cmd === "UpperCase") return true;
        }
        if (!this.isBold(splitText[0], cmdB) && !this.isItalic(splitText[0], cmdI) && !this.isBold(splitText[1], cmdB) && !this.isItalic(splitText[1], cmdI)) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[0], this.syntax.StrikeThrough)) && !(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[1], this.syntax.StrikeThrough)) && this.isMatch(splitText[0], this.syntax.StrikeThrough).length % 2 === 1 && this.isMatch(splitText[1], this.syntax.StrikeThrough).length % 2 === 1 && cmd === "StrikeThrough") isFormat = true;
            if (!(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[0], this.syntax.InlineCode)) && !(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[1], this.syntax.InlineCode)) && this.isMatch(splitText[0], this.syntax.InlineCode).length % 2 === 1 && this.isMatch(splitText[1], this.syntax.InlineCode).length % 2 === 1 && cmd === "InlineCode") isFormat = true;
            /* eslint-disable */ if (!(0, $3EnZW.isNullOrUndefined)(splitText[0].match(/\<sub>/g)) && !(0, $3EnZW.isNullOrUndefined)(splitText[1].match(/\<\/sub>/g)) && splitText[0].match(/\<sub>/g).length % 2 === 1 && splitText[1].match(/\<\/sub>/g).length % 2 === 1 && cmd === "SubScript") isFormat = true;
            if (!(0, $3EnZW.isNullOrUndefined)(splitText[0].match(/\<sup>/g)) && !(0, $3EnZW.isNullOrUndefined)(splitText[1].match(/\<\/sup>/g)) && splitText[0].match(/\<sup>/g).length % 2 === 1 && splitText[1].match(/\<\/sup>/g).length % 2 === 1 && cmd === "SuperScript") isFormat = true;
        /* eslint-enable */ }
        if (this.isBold(splitText[0], cmdB) && this.isBold(splitText[1], cmdB) && splitText[0].match(this.multiCharRegx(cmdB)).length % 2 === 1 && splitText[1].match(this.multiCharRegx(cmdB)).length % 2 === 1 && cmd === "Bold") isFormat = true;
        splitText[0] = this.isBold(splitText[0], cmdB) ? splitText[0].replace(this.multiCharRegx(cmdB), "$%@") : splitText[0];
        splitText[1] = this.isBold(splitText[1], cmdB) ? splitText[1].replace(this.multiCharRegx(cmdB), "$%@") : splitText[1];
        if (!(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[0], this.syntax.Italic)) && !(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[1], this.syntax.Italic)) && this.isMatch(splitText[0], this.syntax.Italic).length % 2 === 1 && this.isMatch(splitText[1], this.syntax.Italic).length % 2 === 1 && cmd === "Italic") isFormat = true;
        if (!(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[0], this.syntax.StrikeThrough)) && !(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[1], this.syntax.StrikeThrough)) && this.isMatch(splitText[0], this.syntax.StrikeThrough).length % 2 === 1 && this.isMatch(splitText[1], this.syntax.StrikeThrough).length % 2 === 1 && cmd === "StrikeThrough") isFormat = true;
        if (!(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[0], this.syntax.InlineCode)) && !(0, $3EnZW.isNullOrUndefined)(this.isMatch(splitText[1], this.syntax.InlineCode)) && this.isMatch(splitText[0], this.syntax.InlineCode).length % 2 === 1 && this.isMatch(splitText[1], this.syntax.InlineCode).length % 2 === 1 && cmd === "InlineCode") isFormat = true;
        /* eslint-disable */ if (!(0, $3EnZW.isNullOrUndefined)(splitText[0].match(/\<sub>/g)) && !(0, $3EnZW.isNullOrUndefined)(splitText[1].match(/\<\/sub>/g)) && splitText[0].match(/\<sub>/g).length % 2 === 1 && splitText[1].match(/\<\/sub>/g).length % 2 === 1 && cmd === "SubScript") isFormat = true;
        if (!(0, $3EnZW.isNullOrUndefined)(splitText[0].match(/\<sup>/g)) && !(0, $3EnZW.isNullOrUndefined)(splitText[1].match(/\<\/sup>/g)) && splitText[0].match(/\<sup>/g).length % 2 === 1 && splitText[1].match(/\<\/sup>/g).length % 2 === 1 && cmd === "SuperScript") isFormat = true;
        return isFormat;
    };
    MDSelectionFormats.prototype.applyCommands = function(e) {
        this.currentAction = e.subCommand;
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var addedLength = 0;
        var selection = this.parent.markdownSelection.getSelectedInlinePoints(textArea);
        if (this.isAppliedCommand(e.subCommand) && selection.text !== "") {
            var startCmd = this.syntax[e.subCommand];
            var endCmd = e.subCommand === "SubScript" ? "</sub>" : e.subCommand === "SuperScript" ? "</sup>" : this.syntax[e.subCommand];
            var startLength = e.subCommand === "UpperCase" || e.subCommand === "LowerCase" ? 0 : startCmd.length;
            var startNo = textArea.value.substr(0, selection.start).lastIndexOf(startCmd);
            var endNo = textArea.value.substr(selection.end, textArea.value.length).indexOf(endCmd);
            endNo = endNo + selection.end;
            var repStartText = this.replaceAt(textArea.value.substr(0, selection.start), startCmd, "", startNo, selection.start);
            var repEndText = this.replaceAt(textArea.value.substr(selection.end, textArea.value.length), endCmd, "", 0, endNo);
            textArea.value = repStartText + selection.text + repEndText;
            this.restore(textArea, start - startLength, end - startLength, e);
            return;
        }
        if (selection.text !== "" && !this.isApplied(selection, e.subCommand)) {
            addedLength = e.subCommand === "UpperCase" || e.subCommand === "LowerCase" ? 0 : this.syntax[e.subCommand].length;
            var repStart = textArea.value.substr(selection.start - this.syntax[e.subCommand].length, this.syntax[e.subCommand].length);
            var repEnd = void 0;
            if (repStart === e.subCommand || selection.start - this.syntax[e.subCommand].length === textArea.value.indexOf(this.syntax[e.subCommand]) && (selection.end === textArea.value.lastIndexOf(this.syntax[e.subCommand]) || selection.end === textArea.value.lastIndexOf("</" + this.syntax[e.subCommand].substring(1, 5)))) {
                if (e.subCommand === "SubScript" || e.subCommand === "SuperScript") repEnd = textArea.value.substr(selection.end, this.syntax[e.subCommand].length + 1);
                else repEnd = textArea.value.substr(selection.end, this.syntax[e.subCommand].length);
                var repStartText = this.replaceAt(textArea.value.substr(0, selection.start), repStart, "", selection.start - this.syntax[e.subCommand].length, selection.start);
                var repEndText = this.replaceAt(textArea.value.substr(selection.end, textArea.value.length), repEnd, "", 0, repEnd.length);
                textArea.value = repStartText + selection.text + repEndText;
                this.restore(textArea, start - addedLength, end - addedLength, e);
            } else {
                if (e.subCommand === "SubScript" || e.subCommand === "SuperScript") selection.text = this.syntax[e.subCommand] + selection.text + "</" + this.syntax[e.subCommand].substring(1, 5);
                else if (e.subCommand === "UpperCase" || e.subCommand === "LowerCase") selection.text = e.subCommand === "UpperCase" ? selection.text.toUpperCase() : selection.text.toLowerCase();
                else selection.text = this.syntax[e.subCommand] + selection.text + this.syntax[e.subCommand];
                textArea.value = textArea.value.substr(0, selection.start) + selection.text + textArea.value.substr(selection.end, textArea.value.length);
                this.restore(textArea, start + addedLength, end + addedLength, e);
            }
        } else if (e.subCommand !== "UpperCase" && e.subCommand !== "LowerCase") {
            if (e.subCommand === "SubScript" || e.subCommand === "SuperScript") {
                selection.text = this.textReplace(selection.text, e.subCommand);
                selection.text = this.syntax[e.subCommand] + selection.text + "</" + this.syntax[e.subCommand].substring(1, 5);
            } else {
                selection.text = this.textReplace(selection.text, e.subCommand);
                selection.text = this.syntax[e.subCommand] + selection.text + this.syntax[e.subCommand];
            }
            textArea.value = textArea.value.substr(0, selection.start) + selection.text + textArea.value.substr(selection.end, textArea.value.length);
            addedLength = this.syntax[e.subCommand].length;
            if (selection.start === selection.end) this.restore(textArea, start + addedLength, end + addedLength, e);
            else this.restore(textArea, start + addedLength, end - addedLength, e);
        } else this.restore(textArea, start, end, e);
        this.parent.undoRedoManager.saveData();
    };
    MDSelectionFormats.prototype.replaceAt = function(input, search, replace, start, end) {
        return input.slice(0, start) + input.slice(start, end).replace(search, replace) + input.slice(end);
    };
    MDSelectionFormats.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: this.currentAction,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    MDSelectionFormats.prototype.textReplace = function(text, command) {
        var regx = this.singleCharRegx(this.syntax["" + command]);
        switch(command){
            case "Bold":
                regx = this.multiCharRegx(this.syntax["" + command].substr(0, 1));
                text = text.replace(regx, "");
                break;
            case "Italic":
                if (!this.isBold(text, this.syntax["" + command].substr(0, 1))) text = text.replace(regx, "");
                else {
                    var regxB = this.multiCharRegx(this.syntax["" + command].substr(0, 1));
                    var repText = text;
                    repText = repText.replace(regxB, "$%@").replace(regx, "");
                    var regxTemp = new RegExp("\\$%@", "g");
                    text = repText.replace(regxTemp, this.syntax["" + command].substr(0, 1) + this.syntax["" + command].substr(0, 1));
                }
                break;
            case "StrikeThrough":
                text = text.replace(regx, "");
                break;
            case "InlineCode":
                text = text.replace(regx, "");
                break;
            case "SubScript":
                text = text.replace(/<sub>/g, "").replace(/<\/sub>/g, "");
                break;
            case "SuperScript":
                text = text.replace(/<sup>/g, "").replace(/<\/sup>/g, "");
                break;
        }
        return text;
    };
    MDSelectionFormats.prototype.isApplied = function(line, command) {
        var regx = this.singleCharRegx(this.syntax["" + command]);
        var regExp;
        switch(command){
            case "SubScript":
            case "SuperScript":
                regx = this.singleCharRegx(this.syntax["" + command]);
                return regx.test(line.text);
            case "Bold":
            case "StrikeThrough":
                regx = this.multiCharRegx(this.syntax["" + command].substr(0, 1));
                return regx.test(line.text);
            case "UpperCase":
            case "LowerCase":
                regExp = RegExp;
                regx = new regExp("^[" + this.syntax["" + command] + "]*$", "g");
                return regx.test(line.text);
            case "Italic":
                var regTest = void 0;
                var regxB = this.multiCharRegx(this.syntax["" + command].substr(0, 1));
                if (regxB.test(line.text)) {
                    var repText = line.text;
                    repText = repText.replace(regxB, "$%#");
                    regTest = regx.test(repText);
                } else regTest = regx.test(line.text);
                return regTest;
            case "InlineCode":
                return regx.test(line.text);
        }
    };
    MDSelectionFormats.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MDSelectionFormats;
}();


/**
 * MarkdownSelection internal module
 *
 * @hidden

 */ var $26913129ed9a7e1f$export$7688e44ded64d9b9 = /** @class */ function() {
    function MarkdownSelection() {}
    /**
     * markdown getLineNumber method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @param {number} point - specifies the number value
     * @returns {number} - returns the value
     * @hidden

     */ MarkdownSelection.prototype.getLineNumber = function(textarea, point) {
        return textarea.value.substr(0, point).split("\n").length;
    };
    /**
     * markdown getSelectedText method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @returns {string} - specifies the string value
     * @hidden

     */ MarkdownSelection.prototype.getSelectedText = function(textarea) {
        var start = textarea.selectionStart;
        var end = textarea.selectionEnd;
        return textarea.value.substring(start, end);
    };
    /**
     * markdown getAllParents method
     *
     * @param {string} value - specifies the string value
     * @returns {string[]} - returns the string value
     * @hidden

     */ MarkdownSelection.prototype.getAllParents = function(value) {
        return value.split("\n");
    };
    /**
     * markdown getSelectedLine method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @returns {string} - returns the string value
     * @hidden

     */ MarkdownSelection.prototype.getSelectedLine = function(textarea) {
        var lines = this.getAllParents(textarea.value);
        var index = this.getLineNumber(textarea, textarea.selectionStart);
        return lines[index - 1];
    };
    /**
     * markdown getLine method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @param {number} index - specifies the number value
     * @returns {string} - returns the string value
     * @hidden

     */ MarkdownSelection.prototype.getLine = function(textarea, index) {
        var lines = this.getAllParents(textarea.value);
        return lines[index];
    };
    /**
     * markdown getSelectedParentPoints method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @returns {string} - returns the string value
     * @hidden

     */ MarkdownSelection.prototype.getSelectedParentPoints = function(textarea) {
        var lines = this.getAllParents(textarea.value);
        var start = this.getLineNumber(textarea, textarea.selectionStart);
        var end = this.getLineNumber(textarea, textarea.selectionEnd);
        var parents = this.getSelectedText(textarea).split("\n");
        var selectedPoints = [];
        var selectedLine = lines[start - 1];
        var startLength = lines.slice(0, start - 1).join("").length;
        var firstPoint = {};
        firstPoint.line = start - 1;
        firstPoint.start = startLength + firstPoint.line;
        firstPoint.end = selectedLine !== "" ? firstPoint.start + selectedLine.length + 1 : firstPoint.start + selectedLine.length;
        firstPoint.text = selectedLine;
        selectedPoints.push(firstPoint);
        if (parents.length > 1) {
            for(var i = 1; i < parents.length - 1; i++){
                var points = {};
                points.line = selectedPoints[i - 1].line + 1;
                points.start = parents[i] !== "" ? selectedPoints[i - 1].end : selectedPoints[i - 1].end;
                points.end = points.start + parents[i].length + 1;
                points.text = parents[i];
                selectedPoints.push(points);
            }
            var lastPoint = {};
            lastPoint.line = selectedPoints[selectedPoints.length - 1].line + 1;
            lastPoint.start = selectedPoints[selectedPoints.length - 1].end;
            lastPoint.end = lastPoint.start + lines[end - 1].length + 1;
            lastPoint.text = lines[end - 1];
            selectedPoints.push(lastPoint);
        }
        return selectedPoints;
    };
    /**
     * markdown setSelection method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area element
     * @param {number} start - specifies the start vaulue
     * @param {number} end - specifies the end value
     * @returns {void}
     * @hidden

     */ MarkdownSelection.prototype.setSelection = function(textarea, start, end) {
        textarea.setSelectionRange(start, end);
        textarea.focus();
    };
    /**
     * markdown save method
     *
     * @param {number} start - specifies the start vaulue
     * @param {number} end - specifies the end value
     * @returns {void}
     * @hidden

     */ MarkdownSelection.prototype.save = function(start, end) {
        this.selectionStart = start;
        this.selectionEnd = end;
    };
    /**
     * markdown restore method
     *
     * @param {HTMLTextAreaElement} textArea - specifies the text area element
     * @returns {void}
     * @hidden

     */ MarkdownSelection.prototype.restore = function(textArea) {
        this.setSelection(textArea, this.selectionStart, this.selectionEnd);
    };
    /**
     * markdown isStartWith method
     *
     * @param {string} line - specifies the string value
     * @param {string} command - specifies the string value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ MarkdownSelection.prototype.isStartWith = function(line, command) {
        var isStart = false;
        var regExp = RegExp;
        if (line) {
            var reg = line.trim() === command.trim() ? new regExp("^(" + this.replaceSpecialChar(command.trim()) + ")", "gim") : new regExp("^(" + this.replaceSpecialChar(command) + ")", "gim");
            isStart = reg.test(line.trim());
        }
        return isStart;
    };
    /**
     * markdown replaceSpecialChar method
     *
     * @param {string} value - specifies the string value
     * @returns {string} - returns the value
     * @hidden

     */ MarkdownSelection.prototype.replaceSpecialChar = function(value) {
        // eslint-disable-next-line
        return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, "\\$&");
    };
    /**
     * markdown isClear method
     *
     * @param {string} parents - specifies the parent element
     * @param {string} regex - specifies the regex value
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ MarkdownSelection.prototype.isClear = function(parents, regex) {
        var isClear = false;
        var regExp = RegExp;
        for(var i = 0; i < parents.length; i++){
            if (new regExp(regex, "gim").test(parents[i].text)) return true;
        }
        return isClear;
    };
    /**
     * markdown getSelectedInlinePoints method
     *
     * @param {HTMLTextAreaElement} textarea - specifies the text area
     * @returns {void}
     * @hidden

     */ MarkdownSelection.prototype.getSelectedInlinePoints = function(textarea) {
        var start = textarea.selectionStart;
        var end = textarea.selectionEnd;
        var selection = this.getSelectedText(textarea);
        return {
            start: start,
            end: end,
            text: selection
        };
    };
    return MarkdownSelection;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * `Undo` module is used to handle undo actions.
 */ var $3c6e1deecc2e3e83$export$9a12316519cebdb1 = /** @class */ function() {
    function UndoRedoCommands(parent, options) {
        this.undoRedoStack = [];
        this.parent = parent;
        this.undoRedoSteps = !(0, $3EnZW.isNullOrUndefined)(options) ? options.undoRedoSteps : 30;
        this.undoRedoTimer = !(0, $3EnZW.isNullOrUndefined)(options) ? options.undoRedoTimer : 300;
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    UndoRedoCommands.prototype.addEventListener = function() {
        var debounceListener = (0, $3EnZW.debounce)(this.keyUp, this.undoRedoTimer);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, debounceListener, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, this.onAction, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    UndoRedoCommands.prototype.onPropertyChanged = function(props) {
        for(var _i = 0, _a = Object.keys(props.newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "undoRedoSteps":
                    this.undoRedoSteps = props.newProp.undoRedoSteps;
                    break;
                case "undoRedoTimer":
                    this.undoRedoTimer = props.newProp.undoRedoTimer;
                    break;
            }
        }
    };
    UndoRedoCommands.prototype.removeEventListener = function() {
        var debounceListener = (0, $3EnZW.debounce)(this.keyUp, 300);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, debounceListener);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.keyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, this.onAction);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$230373593f042ef0, this.onPropertyChanged);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ UndoRedoCommands.prototype.destroy = function() {
        this.removeEventListener();
    };
    /**
     * onAction method
     *
     * @param {IMarkdownSubCommands} e - specifies the sub commands
     * @returns {void}
     * @hidden

     */ UndoRedoCommands.prototype.onAction = function(e) {
        if (e.subCommand === "Undo") this.undo(e);
        else this.redo(e);
    };
    UndoRedoCommands.prototype.keyDown = function(e) {
        var event = e.event;
        // eslint-disable-next-line
        var proxy = this;
        switch(event.action){
            case "undo":
                event.preventDefault();
                proxy.undo(e);
                break;
            case "redo":
                event.preventDefault();
                proxy.redo(e);
                break;
        }
    };
    UndoRedoCommands.prototype.keyUp = function(e) {
        if (e.event.keyCode !== 17 && !e.event.ctrlKey) this.saveData(e);
    };
    /**
     * MD collection stored string format.
     *
     * @param {KeyboardEvent} e - specifies the key board event
     * @function saveData
     * @returns {void}
     * @hidden

     */ UndoRedoCommands.prototype.saveData = function(e) {
        var textArea = this.parent.element;
        this.selection.save(textArea.selectionStart, textArea.selectionEnd);
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var textValue = this.parent.element.value;
        var changEle = {
            text: textValue,
            start: start,
            end: end
        };
        if (this.undoRedoStack.length >= this.steps) this.undoRedoStack = this.undoRedoStack.slice(0, this.steps + 1);
        if (this.undoRedoStack.length > 1 && this.undoRedoStack[this.undoRedoStack.length - 1].start === start && this.undoRedoStack[this.undoRedoStack.length - 1].end === end) return;
        this.undoRedoStack.push(changEle);
        this.steps = this.undoRedoStack.length - 1;
        if (this.steps > this.undoRedoSteps) {
            this.undoRedoStack.shift();
            this.steps--;
        }
        if (e && e.callBack) e.callBack();
    };
    /**
     * Undo the editable text.
     *
     * @param {IMarkdownSubCommands} e - specifies the sub commands
     * @function undo
     * @returns {void}
     * @hidden

     */ UndoRedoCommands.prototype.undo = function(e) {
        if (this.steps > 0) {
            this.currentAction = "Undo";
            var start = this.undoRedoStack[this.steps - 1].start;
            var end = this.undoRedoStack[this.steps - 1].end;
            var removedContent = this.undoRedoStack[this.steps - 1].text;
            this.parent.element.value = removedContent;
            this.parent.element.focus();
            this.steps--;
            this.restore(this.parent.element, start, end, e);
        }
    };
    /**
     * Redo the editable text.
     *
     * @param {IMarkdownSubCommands} e - specifies the sub commands
     * @function redo
     * @returns {void}
     * @hidden

     */ UndoRedoCommands.prototype.redo = function(e) {
        if (this.undoRedoStack[this.steps + 1] != null) {
            this.currentAction = "Redo";
            var start = this.undoRedoStack[this.steps + 1].start;
            var end = this.undoRedoStack[this.steps + 1].end;
            this.parent.element.value = this.undoRedoStack[this.steps + 1].text;
            this.parent.element.focus();
            this.steps++;
            this.restore(this.parent.element, start, end, e);
        }
    };
    UndoRedoCommands.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: this.currentAction,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    /**
     * getUndoStatus method
     *
     * @returns {boolean} - returns the boolean value
     * @hidden

     */ UndoRedoCommands.prototype.getUndoStatus = function() {
        var status = {
            undo: false,
            redo: false
        };
        if (this.steps > 0) status.undo = true;
        if (this.undoRedoStack[this.steps + 1] != null) status.redo = true;
        return status;
    };
    return UndoRedoCommands;
}();




/**
 * Link internal component
 *
 * @hidden

 */ var $2ebfb3bfd6f0016e$export$6e5f79d9971df141 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {MarkdownParser} parent - specifies the parent element
     * @hidden

     */ function MDLink(parent) {
        this.parent = parent;
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDLink.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$268a6231cd912896, this.createLink, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDLink.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$268a6231cd912896, this.createLink);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MDLink.prototype.createLink = function(e) {
        var textArea = this.parent.element;
        textArea.focus();
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var text = e.subCommand === "Image" ? this.selection.getSelectedText(textArea) : e.item.text;
        var startOffset = e.subCommand === "Image" ? start + 2 : start + 1;
        var endOffset = e.subCommand === "Image" ? end + 2 : end + 1;
        text = e.subCommand === "Image" ? "![" + text + "](" + e.item.url + ")" : "[" + text + "](" + e.item.url + ")";
        textArea.value = textArea.value.substr(0, start) + text + textArea.value.substr(end, textArea.value.length);
        this.parent.markdownSelection.setSelection(textArea, startOffset, endOffset);
        this.restore(textArea, startOffset, endOffset, e);
    };
    MDLink.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: event.subCommand,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    MDLink.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MDLink;
}();



parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Link internal component
 *
 * @hidden

 */ var $d68a5e536305d53f$export$516722ef09d79618 = /** @class */ function() {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {IMDTable} options - specifies the options
     * @hidden

     */ function MDTable(options) {
        (0, $3EnZW.extend)(this, this, options, true);
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDTable.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$90d351dbe45272a2, this.createTable, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDTable.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$90d351dbe45272a2, this.createTable);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    /**
     * markdown destroy method
     *
     * @returns {void}
     * @hidden

     */ MDTable.prototype.destroy = function() {
        this.removeEventListener();
    };
    MDTable.prototype.onKeyDown = function(e) {
        if (e.event.action === "insert-table") {
            e.item = e.value;
            this.createTable(e);
        }
    };
    MDTable.prototype.createTable = function(e) {
        this.element = this.parent.element;
        var start = this.element.selectionStart;
        var end = this.element.selectionEnd;
        var textAreaInitial = this.element.value;
        this.locale = e;
        this.selection.save(start, end);
        this.restore(this.element.selectionStart, this.element.selectionEnd, null);
        this.insertTable(start, end, textAreaInitial, e);
    };
    MDTable.prototype.getTable = function() {
        var table = "";
        table += this.textNonEmpty();
        table += this.tableHeader(this.locale);
        table += this.tableCell(this.locale);
        return table;
    };
    MDTable.prototype.tableHeader = function(e) {
        var text = "";
        for(var i = 1; i <= 2; i++){
            text += "|";
            for(var j = 1; j <= 2; j++)if (i === 1) text += e.item.headingText + " " + j + "|";
            else text += "---------|";
            text += this.insertLine();
        }
        return text;
    };
    MDTable.prototype.tableCell = function(e) {
        var text = "";
        for(var i = 1; i <= 2; i++){
            text += "|";
            for(var j = 1; j <= 2; j++)text += e.item.colText + " " + this.convertToLetters(i) + j + "|";
            text += this.insertLine();
        }
        text += this.insertLine();
        return text;
    };
    MDTable.prototype.insertLine = function() {
        var dummyElement = document.createElement("div");
        dummyElement.innerHTML = "\n";
        return dummyElement.textContent;
    };
    MDTable.prototype.insertTable = function(start, end, textAreaInitial, e) {
        var parentText = this.selection.getSelectedParentPoints(this.element);
        var lastLineSplit = parentText[parentText.length - 1].text.split(" ", 2);
        var syntaxArr = this.getFormatTag();
        // eslint-disable-next-line
        var syntaxCount = 0;
        if (lastLineSplit.length < 2) {
            this.element.value = this.updateValue(this.getTable());
            this.makeSelection(textAreaInitial, start, end);
        } else if (this.ensureFormatApply(parentText[parentText.length - 1].text)) this.checkValid(start, end, this.getTable(), textAreaInitial, e, lastLineSplit, parentText, syntaxArr);
        else {
            this.element.value = this.updateValue(this.getTable());
            this.makeSelection(textAreaInitial, start, end);
        }
        this.restore(this.element.selectionStart, this.element.selectionEnd, e);
    };
    MDTable.prototype.makeSelection = function(textAreaInitial, start, end) {
        end = start + (textAreaInitial.length > 0 ? 12 : 10); //end is added 12 or 10 because to make the table heading selected
        start += textAreaInitial.length > 0 ? 3 : 1; // Start is added 3 or 1 because new lines are added when inserting table
        this.selection.setSelection(this.element, start, end);
    };
    MDTable.prototype.getFormatTag = function() {
        var syntaxFormatKey = Object.keys(this.syntaxTag.Formats);
        var syntaxListKey = Object.keys(this.syntaxTag.List);
        var syntaxArr = [];
        for(var i = 0; i < syntaxFormatKey.length; i++)syntaxArr.push(this.syntaxTag.Formats[syntaxFormatKey[i]]);
        for(var j = 0; j < syntaxListKey.length; j++)syntaxArr.push(this.syntaxTag.List[syntaxListKey[j]]);
        return syntaxArr;
    };
    MDTable.prototype.ensureFormatApply = function(line) {
        var formatTags = this.getFormatTag();
        var formatSplitZero = line.trim().split(" ", 2)[0] + " ";
        for(var i = 0; i < formatTags.length; i++){
            if (formatSplitZero === formatTags[i] || /^[\d.]+[ ]+$/.test(formatSplitZero)) return true;
        }
        return false;
    };
    MDTable.prototype.ensureStartValid = function(firstLine, parentText) {
        var firstLineSplit = parentText[0].text.split(" ", 2);
        for(var i = firstLine + 1; i <= firstLine + firstLineSplit[0].length + 1; i++){
            if (this.element.selectionStart === i || this.element.selectionEnd === i) return false;
        }
        return true;
    };
    MDTable.prototype.ensureEndValid = function(lastLine, formatSplitLength) {
        for(var i = lastLine + 1; i <= lastLine + formatSplitLength + 1; i++){
            if (this.element.selectionEnd === i) return false;
        }
        return true;
    };
    MDTable.prototype.updateValueWithFormat = function(formatSplit, text) {
        var textApplyFormat = this.element.value.substring(this.element.selectionEnd, this.element.value.length);
        text += textApplyFormat.replace(textApplyFormat, formatSplit[0] + " " + textApplyFormat);
        return this.element.value.substr(0, this.element.selectionStart) + text;
    };
    MDTable.prototype.updateValue = function(text) {
        return this.element.value.substr(0, this.element.selectionStart) + text + this.element.value.substr(this.element.selectionEnd, this.element.value.length);
    };
    MDTable.prototype.checkValid = function(start, end, text, textAreaInitial, // eslint-disable-next-line
    e, formatSplit, parentText, syntaxArr) {
        if (this.ensureStartValid(parentText[0].start, parentText) && this.ensureEndValid(parentText[parentText.length - 1].start, formatSplit[0].length)) {
            if (start === parentText[0].start) {
                if (start !== end && end !== parentText[parentText.length - 1].end - 1) this.element.value = this.updateValueWithFormat(formatSplit, text);
                else this.element.value = this.updateValue(text);
            } else if (end === parentText[parentText.length - 1].end - 1) this.element.value = this.updateValue(text);
            else this.element.value = this.updateValueWithFormat(formatSplit, text);
            this.makeSelection(textAreaInitial, start, end);
        }
    };
    MDTable.prototype.convertToLetters = function(rowNumber) {
        var baseChar = "A".charCodeAt(0);
        var letters = "";
        do {
            rowNumber -= 1;
            letters = String.fromCharCode(baseChar + rowNumber % 26) + letters;
            rowNumber = rowNumber / 26 >> 0;
        }while (rowNumber > 0);
        return letters;
    };
    MDTable.prototype.textNonEmpty = function() {
        var emptyText = "";
        if (this.isCursorBased() || this.isSelectionBased()) {
            if (this.element.value.length > 0) {
                emptyText += this.insertLine();
                emptyText += this.insertLine(); // to append two new line when textarea having content.
            }
        }
        return emptyText;
    };
    MDTable.prototype.isCursorBased = function() {
        return this.element.selectionStart === this.element.selectionEnd;
    };
    MDTable.prototype.isSelectionBased = function() {
        return this.element.selectionStart !== this.element.selectionEnd;
    };
    MDTable.prototype.restore = function(start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(this.element);
        if (event && event.callBack) event.callBack({
            requestType: event.subCommand,
            selectedText: this.selection.getSelectedText(this.element),
            editorMode: "Markdown",
            event: event.event
        });
    };
    return MDTable;
}();





/**
 * Link internal component
 *
 * @hidden

 */ var $0279c4ececd0b9b6$export$f93b98e4c57df5b8 = /** @class */ function() {
    /**
     * Constructor for creating the clear format plugin
     *
     * @param {MarkdownParser} parent - specifies the parent element
     * @hidden

     */ function ClearFormat(parent) {
        this.parent = parent;
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    ClearFormat.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$10e55da310d14a57, this.clear, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    ClearFormat.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$10e55da310d14a57, this.clear);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    ClearFormat.prototype.replaceRegex = function(data) {
        /* eslint-disable */ return data.replace(/\*/ig, "\\*").replace(/\&/ig, "\\&").replace(/\-/ig, "\\-").replace(/\^/ig, "\\^").replace(/\$/ig, "\\$").replace(/\./ig, "\\.").replace(/\|/ig, "\\|").replace(/\?/ig, "\\?").replace(/\+/ig, "\\+").replace(/\-/ig, "\\-").replace(/\&/ig, "\\&");
    /* eslint-enable */ };
    ClearFormat.prototype.clearSelectionTags = function(text) {
        var data = this.parent.selectionTags;
        var keys = Object.keys(data);
        for(var num = 0; num < keys.length; num++){
            var key = keys[num];
            if (Object.prototype.hasOwnProperty.call(data, key) && data["" + key] !== "") {
                var expString = this.replaceRegex(data["" + key]);
                var regExp = void 0;
                var startExp = data["" + key].length;
                var endExp = data["" + key] === "<sup>" || data["" + key] === "<sub>" ? data["" + key].length + 1 : data["" + key].length;
                if (data["" + key] === "<sup>") // eslint-disable-next-line
                regExp = new RegExp("<sup>(.*?)</sup>", "ig");
                else if (data["" + key] === "<sub>") // eslint-disable-next-line
                regExp = new RegExp("<sub>(.*?)</sub>", "ig");
                else {
                    var regExpr = RegExp;
                    regExp = new regExpr(expString + "(.*?)" + expString, "ig");
                }
                var val = text.match(regExp);
                for(var index = 0; val && index < val.length && val[index] !== ""; index++)// eslint-disable-next-line max-len
                text = text.replace(val[index], val[index].substr(startExp, val[index].length - endExp - startExp));
            }
        }
        return text;
    };
    ClearFormat.prototype.clearFormatTags = function(text) {
        var lines = text.split("\n");
        return this.clearFormatLines(lines);
    };
    ClearFormat.prototype.clearFormatLines = function(lines) {
        var tags = [
            this.parent.formatTags,
            this.parent.listTags
        ];
        var str = "";
        for(var len = 0; len < lines.length; len++){
            for(var num = 0; num < tags.length; num++){
                var data = tags[num];
                var keys = Object.keys(data);
                for(var index = 0; index < keys.length; index++){
                    var key = keys[index];
                    if (Object.prototype.hasOwnProperty.call(data, key) && data["" + key] !== "") {
                        if (lines[len].indexOf(data["" + key]) === 0) {
                            lines[len] = lines[len].replace(data["" + key], "");
                            lines[len] = this.clearFormatLines([
                                lines[len]
                            ]);
                        }
                    }
                }
            }
            str = str + lines[len] + (len !== lines.length - 1 ? "\n" : "");
        }
        return str;
    };
    ClearFormat.prototype.clear = function(e) {
        var textArea = this.parent.element;
        textArea.focus();
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var text = this.selection.getSelectedText(textArea);
        text = this.clearSelectionTags(text);
        text = this.clearFormatTags(text);
        textArea.value = textArea.value.substr(0, start) + text + textArea.value.substr(end, textArea.value.length);
        this.parent.markdownSelection.setSelection(textArea, start, start + text.length);
        this.restore(textArea, start, start + text.length, e);
    };
    ClearFormat.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: event.subCommand,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    ClearFormat.prototype.destroy = function() {
        this.removeEventListener();
    };
    return ClearFormat;
}();




/**
 * Link internal component
 *
 * @hidden

 */ var $7faee38f31ebc4a8$export$82753471975af578 = /** @class */ function() {
    /**
     * Constructor for creating the insert text plugin
     *
     * @param {MarkdownParser} parent - specifies the parent element
     * @hidden

     */ function MDInsertText(parent) {
        this.parent = parent;
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    MDInsertText.prototype.addEventListener = function() {
        this.parent.observer.on($a08d2100ce06ecee$export$94b363b9fea45dcf, this.InsertTextExec, this);
        this.parent.observer.on($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy, this);
    };
    MDInsertText.prototype.removeEventListener = function() {
        this.parent.observer.off($a08d2100ce06ecee$export$94b363b9fea45dcf, this.InsertTextExec);
        this.parent.observer.off($ee11fb99ae4d2c3e$export$71d691dc2f49a346, this.destroy);
    };
    MDInsertText.prototype.InsertTextExec = function(e) {
        var textArea = this.parent.element;
        textArea.focus();
        var start = textArea.selectionStart;
        var end = textArea.selectionEnd;
        var text = e.value.text;
        var startOffset = start + text.length;
        var endOffset = end + text.length;
        textArea.value = textArea.value.substr(0, start) + text + textArea.value.substr(end, textArea.value.length);
        this.parent.markdownSelection.setSelection(textArea, startOffset, endOffset);
        this.restore(textArea, startOffset, endOffset, e);
    };
    MDInsertText.prototype.restore = function(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) event.callBack({
            requestType: event.subCommand,
            selectedText: this.selection.getSelectedText(textArea),
            editorMode: "Markdown",
            event: event.event
        });
    };
    MDInsertText.prototype.destroy = function() {
        this.removeEventListener();
    };
    return MDInsertText;
}();


/**
 * MarkdownParser internal component
 *
 * @hidden

 */ var $ded15c93c5801631$export$a64f782182dea128 = /** @class */ function() {
    /**
     * Constructor for creating the component
     *
     * @param {IMarkdownParserModel} options - specifies the options
     * @hidden

     */ function MarkdownParser(options) {
        this.initialize();
        (0, $3EnZW.extend)(this, this, options, true);
        this.observer = new (0, $13zI2.Observer)(this);
        this.markdownSelection = new (0, $26913129ed9a7e1f$export$7688e44ded64d9b9)();
        this.listObj = new (0, $660ea6f21d1695f0$export$3e9b220a716171f3)({
            parent: this,
            syntax: this.listTags
        });
        this.formatObj = new (0, $08fb55b03e008240$export$bfbb5aaec69d5c10)({
            parent: this,
            syntax: this.formatTags
        });
        this.undoRedoManager = new (0, $3c6e1deecc2e3e83$export$9a12316519cebdb1)(this, options.options);
        this.mdSelectionFormats = new (0, $86772f8f16025794$export$44c08ff7044b1d3f)({
            parent: this,
            syntax: this.selectionTags
        });
        this.linkObj = new (0, $2ebfb3bfd6f0016e$export$6e5f79d9971df141)(this);
        this.tableObj = new (0, $d68a5e536305d53f$export$516722ef09d79618)({
            parent: this,
            syntaxTag: {
                Formats: this.formatTags,
                List: this.listTags
            }
        });
        this.clearObj = new (0, $0279c4ececd0b9b6$export$f93b98e4c57df5b8)(this);
        this.insertTextObj = new (0, $7faee38f31ebc4a8$export$82753471975af578)(this);
        this.wireEvents();
    }
    MarkdownParser.prototype.initialize = function() {
        this.formatTags = (0, $9dc0015271a44eb1$export$353ee4035bba39f5);
        this.listTags = (0, $9dc0015271a44eb1$export$28ada9cf17b591a5);
        this.selectionTags = (0, $9dc0015271a44eb1$export$a0d7d3d7f12db22d);
    };
    MarkdownParser.prototype.wireEvents = function() {
        this.observer.on($ee11fb99ae4d2c3e$export$a80636c6f41931fe, this.editorKeyDown, this);
        this.observer.on($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp, this);
        this.observer.on($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, this.onPropertyChanged, this);
    };
    MarkdownParser.prototype.unwireEvents = function() {
        this.observer.off($ee11fb99ae4d2c3e$export$a80636c6f41931fe, this.editorKeyDown);
        this.observer.off($ee11fb99ae4d2c3e$export$390330c10ff2b9a1, this.editorKeyUp);
        this.observer.off($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, this.onPropertyChanged);
    };
    MarkdownParser.prototype.onPropertyChanged = function(props) {
        this.observer.notify($ee11fb99ae4d2c3e$export$230373593f042ef0, props);
    };
    MarkdownParser.prototype.editorKeyDown = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$76852bc82d3e273b, e);
    };
    MarkdownParser.prototype.editorKeyUp = function(e) {
        this.observer.notify($ee11fb99ae4d2c3e$export$10fceeafb7518dd8, e);
    };
    /* eslint-disable */ /**
     * markdown execCommand method
     *
     * @param {MarkdownExecCommand} command - specifies the command
     * @param {T} - specifies the value
     * @param {Event} event - specifies the event
     * @param {Function} callBack - specifies the call back function
     * @param {string} text - specifies the string value
     * @param {T} exeValue - specifies the value
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ MarkdownParser.prototype.execCommand = function(command, value, event, callBack, text, exeValue) {
        switch(command.toLocaleLowerCase()){
            case "lists":
                this.observer.notify($a08d2100ce06ecee$export$baef95a53485c3e2, {
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "formats":
                this.observer.notify($ee11fb99ae4d2c3e$export$a9c1924e9a351d3d, {
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "actions":
                this.observer.notify($ee11fb99ae4d2c3e$export$9523889e0a5da4ba, {
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "style":
            case "effects":
            case "casing":
                this.observer.notify($a08d2100ce06ecee$export$7a8b6a1abdd0777b, {
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "links":
            case "images":
                this.observer.notify($a08d2100ce06ecee$export$268a6231cd912896, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    item: exeValue
                });
                break;
            case "table":
                switch(value.toString().toLocaleLowerCase()){
                    case "createtable":
                        this.observer.notify($a08d2100ce06ecee$export$90d351dbe45272a2, {
                            subCommand: value,
                            item: exeValue,
                            event: event,
                            callBack: callBack
                        });
                        break;
                }
                break;
            case "clear":
                this.observer.notify($a08d2100ce06ecee$export$10e55da310d14a57, {
                    subCommand: value,
                    event: event,
                    callBack: callBack
                });
                break;
            case "inserttext":
                this.observer.notify($a08d2100ce06ecee$export$94b363b9fea45dcf, {
                    subCommand: value,
                    event: event,
                    callBack: callBack,
                    value: {
                        text: exeValue
                    }
                });
                break;
        }
    };
    MarkdownParser.prototype.destroy = function() {
        this.observer.notify($ee11fb99ae4d2c3e$export$71d691dc2f49a346, {});
        this.unwireEvents();
    };
    return MarkdownParser;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

var $4053b4a7a70014ed$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Markdown adapter
 *
 * @hidden

 */ var $4053b4a7a70014ed$export$e5dc7cab9d9d930 = /** @class */ function(_super) {
    $4053b4a7a70014ed$var$__extends(MarkdownFormatter, _super);
    function MarkdownFormatter(options) {
        var _this = _super.call(this) || this;
        _this.initialize();
        (0, $3EnZW.extend)(_this, _this, options, true);
        if (options && _this.element) _this.updateFormatter(_this.element, document, options.options);
        return _this;
    }
    MarkdownFormatter.prototype.initialize = function() {
        this.keyConfig = (0, $9dc0015271a44eb1$export$d2efe7aebbebd18a);
        this.formatTags = (0, $9dc0015271a44eb1$export$353ee4035bba39f5);
        this.listTags = (0, $9dc0015271a44eb1$export$28ada9cf17b591a5);
        this.selectionTags = (0, $9dc0015271a44eb1$export$a0d7d3d7f12db22d);
    };
    /**
     * Update the formatter of RichTextEditor
     *
     * @param  {Element} editElement - specifies the edit element.
     * @param  {Document} doc - specifies the document.
     * @param {number} options - specifies the options
     * @returns {void}
     * @hidden

     */ MarkdownFormatter.prototype.updateFormatter = function(editElement, doc, options) {
        if (editElement) this.editorManager = new (0, $ded15c93c5801631$export$a64f782182dea128)({
            element: editElement,
            formatTags: this.formatTags,
            listTags: this.listTags,
            selectionTags: this.selectionTags,
            options: options
        });
    };
    return MarkdownFormatter;
}((0, $b3bddae4b7750825$export$a06636add2a09fd8));







/**
 * MarkdownToolbarStatus module for refresh the toolbar status
 */ var $2f7c44f117f18de6$export$6fb6dbbace152d16 = /** @class */ function() {
    function MarkdownToolbarStatus(parent) {
        this.toolbarStatus = this.prevToolbarStatus = (0, $259257662ca103fc$export$34ca5c1b18eb2015)();
        this.selection = new (0, $26913129ed9a7e1f$export$7688e44ded64d9b9)();
        this.parent = parent;
        this.element = this.parent.contentModule.getEditPanel();
        this.addEventListener();
    }
    MarkdownToolbarStatus.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$6a017cfaa3b33c68, this.onRefreshHandler, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
    };
    MarkdownToolbarStatus.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$6a017cfaa3b33c68, this.onRefreshHandler);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
    };
    MarkdownToolbarStatus.prototype.onRefreshHandler = function(args) {
        var parentsLines = this.selection.getSelectedParentPoints(this.element);
        this.toolbarStatus = {
            orderedlist: args.documentNode ? false : this.isListsApplied(parentsLines, "OL"),
            unorderedlist: args.documentNode ? false : this.isListsApplied(parentsLines, "UL"),
            formats: this.currentFormat(parentsLines, args.documentNode),
            bold: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("Bold"),
            italic: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("Italic"),
            inlinecode: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("InlineCode"),
            strikethrough: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("StrikeThrough"),
            subscript: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("SubScript"),
            superscript: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("SuperScript"),
            uppercase: args.documentNode ? false : this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("UpperCase")
        };
        if (this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("InlineCode")) this.toolbarStatus.formats = "pre";
        var tbStatusString = JSON.stringify(this.toolbarStatus);
        this.parent.notify($947a002e9a697770$export$209bc394f8eec6dc, this.toolbarStatus);
        if (JSON.stringify(this.prevToolbarStatus) !== tbStatusString) {
            this.parent.notify($947a002e9a697770$export$4755fca075b63809, {
                html: null,
                markdown: JSON.parse(tbStatusString)
            });
            this.prevToolbarStatus = JSON.parse(tbStatusString);
        }
    };
    MarkdownToolbarStatus.prototype.isListsApplied = function(lines, type) {
        var isApply = true;
        if (type === "OL") for(var i = 0; i < lines.length; i++){
            var lineSplit = lines[i].text.trim().split(" ", 2)[0] + " ";
            if (!/^[\d.]+[ ]+$/.test(lineSplit)) {
                isApply = false;
                break;
            }
        }
        else {
            for(var i = 0; i < lines.length; i++)if (!this.selection.isStartWith(lines[i].text, this.parent.formatter.listTags["" + type])) {
                isApply = false;
                break;
            }
        }
        return isApply;
    };
    MarkdownToolbarStatus.prototype.currentFormat = function(lines, documentNode) {
        var format = "p";
        var keys = Object.keys(this.parent.formatter.formatTags);
        var direction = this.element.selectionDirection;
        var checkLine = direction === "backward" ? lines[0].text : lines[lines.length - 1].text;
        for(var i = 0; !documentNode && i < keys.length; i++){
            if (keys[i] !== "pre" && this.selection.isStartWith(checkLine, this.parent.formatter.formatTags[keys[i]])) {
                format = keys[i];
                break;
            } else if (keys[i] === "pre") {
                if (this.codeFormat()) {
                    format = keys[i];
                    break;
                }
            }
        }
        return format;
    };
    MarkdownToolbarStatus.prototype.codeFormat = function() {
        var isFormat = false;
        var textArea = this.parent.inputElement;
        var start = textArea.selectionStart;
        var splitAt = function(index) {
            return function(x) {
                return [
                    x.slice(0, index),
                    x.slice(index)
                ];
            };
        };
        var splitText = splitAt(start)(textArea.value);
        var cmdPre = this.parent.formatter.formatTags.pre;
        var selectedText = this.getSelectedText(textArea);
        if (selectedText !== "" && selectedText === selectedText.toLocaleUpperCase()) return true;
        else if (selectedText === "") {
            var beforeText = textArea.value.substr(splitText[0].length - 1, 1);
            var afterText = splitText[1].substr(0, 1);
            if (beforeText !== "" && afterText !== "" && beforeText.match(/[a-z]/i) && beforeText === beforeText.toLocaleUpperCase() && afterText === afterText.toLocaleUpperCase()) return true;
        }
        if (this.isCode(splitText[0], cmdPre) && this.isCode(splitText[1], cmdPre) && splitText[0].match(this.multiCharRegx(cmdPre)).length % 2 === 1 && splitText[1].match(this.multiCharRegx(cmdPre)).length % 2 === 1) isFormat = true;
        return isFormat;
    };
    MarkdownToolbarStatus.prototype.getSelectedText = function(textarea) {
        return textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
    };
    MarkdownToolbarStatus.prototype.isCode = function(text, cmd) {
        return text.search("\\" + cmd + "") !== -1;
    };
    MarkdownToolbarStatus.prototype.multiCharRegx = function(cmd) {
        var regExp = RegExp;
        return new regExp("(\\" + cmd + ")", "g");
    };
    return MarkdownToolbarStatus;
}();


/**
 * Markdown module is used to render Rich Text Editor as Markdown editor content
 *
 * @hidden

 */ var $9e9057eb5ccb1bca$export$62ea91d61389b408 = /** @class */ function() {
    /**
     * Constructor for content renderer module
     *
     * @param {IRichTextEditor} parent - specifies the parent.
     */ function MarkdownRender(parent) {
        this.parent = parent;
    }
    /**
     * The function is used to render Rich Text Editor content div
     *
     * @returns {void}
     * @hidden

     */ MarkdownRender.prototype.renderPanel = function() {
        var rteObj = this.parent;
        var div = this.parent.createElement("div", {
            id: this.parent.getID() + "_view",
            className: "e-rte-content"
        });
        this.editableElement = this.parent.createElement("textarea", {
            className: "e-content",
            id: this.parent.getID() + "_editable-content",
            attrs: {
                "aria-labelledby": this.parent.getID() + "_view"
            }
        });
        div.appendChild(this.editableElement);
        this.setPanel(div);
        rteObj.rootContainer.appendChild(div);
    };
    /**
     * Get the content div element of RichTextEditor
     *
     * @returns {Element} - specifies the element
     * @hidden

     */ MarkdownRender.prototype.getPanel = function() {
        return this.contentPanel;
    };
    /**
     * Get the editable element of RichTextEditor
     *
     * @returns {Element} - specifies the element
     * @hidden

     */ MarkdownRender.prototype.getEditPanel = function() {
        return this.editableElement;
    };
    /**
     * Returns the text content as string.
     *
     * @returns {string} - specifies the string values.
     */ MarkdownRender.prototype.getText = function() {
        return this.getEditPanel().value;
    };
    /**
     * Set the content div element of RichTextEditor
     *
     * @param  {Element} panel - specifies the element.
     * @returns {void}
     * @hidden

     */ MarkdownRender.prototype.setPanel = function(panel) {
        this.contentPanel = panel;
    };
    /**
     * Get the document of RichTextEditor
     *
     * @returns {void}
     * @hidden

     */ MarkdownRender.prototype.getDocument = function() {
        return this.getEditPanel().ownerDocument;
    };
    return MarkdownRender;
}();



/**
 * `MarkdownEditor` module is used to markdown editor
 */ var $6786024aab39709d$export$18a9461578883ec4 = /** @class */ function() {
    function MarkdownEditor(parent, serviceLocator) {
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
        this.isDestroyed = false;
    }
    /**
     * Destroys the Markdown.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ MarkdownEditor.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.removeEventListener();
        this.isDestroyed = true;
    };
    MarkdownEditor.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.saveSelection = new (0, $26913129ed9a7e1f$export$7688e44ded64d9b9)();
        this.parent.on($947a002e9a697770$export$b70fe0c8c3456154, this.instantiateRenderer, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.render, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($947a002e9a697770$export$2a6b3606af0895e8, this.onToolbarClick, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$90aca4adda6ff0f5, this.selectAll, this);
        this.parent.on($947a002e9a697770$export$76d3c88e0e217d4e, this.getSelectedHtml, this);
        this.parent.on($947a002e9a697770$export$dd9b49d5e9b25abd, this.onSelectionSave, this);
        this.parent.on($947a002e9a697770$export$ae80d5dbf349b0b4, this.onSelectionRestore, this);
        this.parent.on($947a002e9a697770$export$ff4edde773b9bda2, this.updateReadOnly, this);
    };
    MarkdownEditor.prototype.updateReadOnly = function() {
        if (this.parent.readonly) {
            this.parent.contentModule.getEditPanel().setAttribute("readonly", "readonly");
            (0, $4ZDHT.addClass)([
                this.parent.element
            ], $afc560df281b588d$export$f53692bf3792d5c);
        } else {
            this.parent.contentModule.getEditPanel().removeAttribute("readonly");
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], $afc560df281b588d$export$f53692bf3792d5c);
        }
    };
    MarkdownEditor.prototype.onSelectionSave = function() {
        var textArea = this.parent.contentModule.getEditPanel();
        this.saveSelection.save(textArea.selectionStart, textArea.selectionEnd);
    };
    // eslint-disable-next-line
    MarkdownEditor.prototype.onSelectionRestore = function(e) {
        this.contentRenderer.getEditPanel().focus();
        var textArea = this.parent.contentModule.getEditPanel();
        this.saveSelection.restore(textArea);
    };
    MarkdownEditor.prototype.onToolbarClick = function(args) {
        var item = args.item;
        var textArea = this.parent.contentModule.getEditPanel();
        if (item.command !== "Formats") textArea.focus();
        var startOffset = textArea.selectionStart;
        var endOffset = textArea.selectionEnd;
        var text = textArea.value.substring(startOffset, endOffset);
        switch(item.subCommand){
            case "Maximize":
                this.parent.notify($947a002e9a697770$export$6b5a35c4a823eab1, {
                    args: args
                });
                break;
            case "Minimize":
                this.parent.notify($947a002e9a697770$export$7f96353fc4f89f6b, {
                    args: args
                });
                break;
            case "CreateLink":
                this.parent.notify($947a002e9a697770$export$c13c4fbf8f656592, {
                    member: "link",
                    args: args,
                    text: text,
                    module: "Markdown"
                });
                break;
            case "Image":
                this.parent.notify($947a002e9a697770$export$5ae819692184d2fb, {
                    member: "image",
                    args: args,
                    text: text,
                    module: "Markdown"
                });
                break;
            case "CreateTable":
                var tableConstant = {
                    "headingText": this.parent.localeObj.getConstant("TableHeadingText"),
                    "colText": this.parent.localeObj.getConstant("TableColText")
                };
                this.parent.formatter.process(this.parent, args, args.originalEvent, tableConstant);
                break;
            default:
                this.parent.formatter.process(this.parent, args, args.originalEvent, null);
                break;
        }
    };
    MarkdownEditor.prototype.instantiateRenderer = function() {
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content, new (0, $9e9057eb5ccb1bca$export$62ea91d61389b408)(this.parent));
    };
    MarkdownEditor.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.render);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$2a6b3606af0895e8, this.onToolbarClick);
        this.parent.off($947a002e9a697770$export$b70fe0c8c3456154, this.instantiateRenderer);
        this.parent.off($947a002e9a697770$export$90aca4adda6ff0f5, this.selectAll);
        this.parent.off($947a002e9a697770$export$76d3c88e0e217d4e, this.getSelectedHtml);
        this.parent.off($947a002e9a697770$export$dd9b49d5e9b25abd, this.onSelectionSave);
        this.parent.off($947a002e9a697770$export$ae80d5dbf349b0b4, this.onSelectionRestore);
        this.parent.off($947a002e9a697770$export$ff4edde773b9bda2, this.updateReadOnly);
    };
    MarkdownEditor.prototype.render = function() {
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        var editElement = this.contentRenderer.getEditPanel();
        var option = {
            undoRedoSteps: this.parent.undoRedoSteps,
            undoRedoTimer: this.parent.undoRedoTimer
        };
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.formatter)) this.parent.formatter = new (0, $4053b4a7a70014ed$export$e5dc7cab9d9d930)({
            element: editElement,
            options: option
        });
        else this.parent.formatter.updateFormatter(editElement, this.contentRenderer.getDocument(), option);
        if (this.parent.toolbarSettings.enable) this.toolbarUpdate = new (0, $2f7c44f117f18de6$export$6fb6dbbace152d16)(this.parent);
        this.parent.notify($947a002e9a697770$export$c909ec3b151c9e0e, {});
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} e - specifies the editor model
     * @returns {void}
     * @hidden

     */ MarkdownEditor.prototype.onPropertyChanged = function(e) {
        // On property code change here
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.formatter)) {
            var editElement = this.contentRenderer.getEditPanel();
            var option = {
                undoRedoSteps: this.parent.undoRedoSteps,
                undoRedoTimer: this.parent.undoRedoTimer
            };
            this.parent.formatter.updateFormatter(editElement, this.contentRenderer.getDocument(), option);
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     */ MarkdownEditor.prototype.getModuleName = function() {
        return "markdownEditor";
    };
    /**
     * For selecting all content in RTE
     *
     * @returns {void}
     * @private
     */ MarkdownEditor.prototype.selectAll = function() {
        this.parent.formatter.editorManager.markdownSelection.setSelection(this.parent.contentModule.getEditPanel(), 0, this.parent.contentModule.getEditPanel().value.length);
    };
    /**
     * For get a selected text in RTE
     *
     * @param {NotifyArgs} e - specifies the arguments.
     * @returns {void}
     * @private
     */ MarkdownEditor.prototype.getSelectedHtml = function(e) {
        e.callBack(this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()));
    };
    return MarkdownEditor;
}();



var $2vAqh = parcelRequire("2vAqh");

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");








/**
 * PasteCleanup module called when pasting content in RichTextEditor
 */ var $30bc71f720415a27$export$a1226420f67c68f9 = /** @class */ function() {
    function PasteCleanup(parent, serviceLocator) {
        this.inlineNode = [
            "a",
            "abbr",
            "acronym",
            "audio",
            "b",
            "bdi",
            "bdo",
            "big",
            "br",
            "button",
            "canvas",
            "cite",
            "code",
            "data",
            "datalist",
            "del",
            "dfn",
            "em",
            "embed",
            "font",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "map",
            "mark",
            "meter",
            "noscript",
            "object",
            "output",
            "picture",
            "progress",
            "q",
            "ruby",
            "s",
            "samp",
            "script",
            "select",
            "slot",
            "small",
            "span",
            "strong",
            "sub",
            "sup",
            "svg",
            "template",
            "textarea",
            "time",
            "u",
            "tt",
            "var",
            "video",
            "wbr"
        ];
        this.blockNode = [
            "div",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "address",
            "blockquote",
            "button",
            "center",
            "dd",
            "dir",
            "dl",
            "dt",
            "fieldset",
            "frameset",
            "hr",
            "iframe",
            "isindex",
            "li",
            "map",
            "menu",
            "noframes",
            "noscript",
            "object",
            "ol",
            "pre",
            "td",
            "tr",
            "th",
            "tbody",
            "tfoot",
            "thead",
            "table",
            "ul",
            "header",
            "article",
            "nav",
            "footer",
            "section",
            "aside",
            "main",
            "figure",
            "figcaption"
        ];
        this.isNotFromHtml = false;
        this.containsHtml = false;
        this.cropImageData = [];
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.i10n = serviceLocator.getService("rteLocale");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.addEventListener();
        this.isDestroyed = false;
    }
    PasteCleanup.prototype.addEventListener = function() {
        this.nodeSelectionObj = new (0, $55b5a64fb1119729$export$e2940151ac854c0b)();
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$32f783c04cad0a05, this.pasteClean, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick, this);
    };
    PasteCleanup.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.fireFoxUploadTime) {
            clearTimeout(this.fireFoxUploadTime);
            this.fireFoxUploadTime = null;
        }
        if (this.refreshPopupTime) {
            clearTimeout(this.refreshPopupTime);
            this.refreshPopupTime = null;
        }
        if (this.popupCloseTime) {
            clearTimeout(this.popupCloseTime);
            this.popupCloseTime = null;
        }
        if (this.failureTime) {
            clearTimeout(this.failureTime);
            this.failureTime = null;
        }
        if (this.iframeUploadTime) {
            clearTimeout(this.iframeUploadTime);
            this.iframeUploadTime = null;
        }
        this.removeEventListener();
        if (this.popupObj && !this.popupObj.isDestroyed) {
            this.popupObj.destroy();
            this.popupObj = null;
        }
        if (this.uploadObj && !this.uploadObj.isDestroyed) {
            this.uploadObj.destroy();
            this.uploadObj = null;
        }
        if (this.keepRadioButton && !this.keepRadioButton.isDestroyed) {
            this.keepRadioButton.destroy();
            this.keepRadioButton = null;
        }
        if (this.cleanRadioButton && !this.cleanRadioButton.isDestroyed) {
            this.cleanRadioButton.destroy();
            this.cleanRadioButton = null;
        }
        if (this.plainTextRadioButton && !this.plainTextRadioButton.isDestroyed) {
            this.plainTextRadioButton.destroy();
            this.plainTextRadioButton = null;
        }
        this.isDestroyed = true;
    };
    PasteCleanup.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$32f783c04cad0a05, this.pasteClean);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick);
    };
    PasteCleanup.prototype.pasteClean = function(e) {
        var _this = this;
        var args = {
            requestType: "Paste",
            editorMode: this.parent.editorMode,
            event: e
        };
        var value = null;
        var isClipboardHTMLDataNull = false;
        var imageproperties;
        if (e.args && !(0, $3EnZW.isNullOrUndefined)(e.args.clipboardData)) value = e.args.clipboardData.getData("text/html");
        if (e.args && value !== null && this.parent.editorMode === "HTML") {
            var file = void 0;
            if (value.length === 0) {
                var htmlRegex = new RegExp(/<\/[a-z][\s\S]*>/i);
                value = e.args.clipboardData.getData("text/plain");
                this.parent.trigger($947a002e9a697770$export$b3d75de79ba96fb7, {
                    value: value
                });
                this.isNotFromHtml = value !== "" ? true : false;
                value = value.replace(/</g, "&lt;");
                value = value.replace(/>/g, "&gt;");
                this.containsHtml = htmlRegex.test(value);
                file = e && e.args.clipboardData && e.args.clipboardData.items.length > 0 ? e.args.clipboardData.items[0].getAsFile() === null ? !(0, $3EnZW.isNullOrUndefined)(e.args.clipboardData.items[1]) ? e.args.clipboardData.items[1].getAsFile() : null : e.args.clipboardData.items[0].getAsFile() : null;
                this.parent.notify($947a002e9a697770$export$9b6706c8686cfc8e, {
                    file: file,
                    args: e.args,
                    text: value,
                    callBack: function(b) {
                        imageproperties = b;
                        if (typeof imageproperties === "object") _this.parent.formatter.editorManager.execCommand("Images", "Image", e.args, _this.imageFormatting.bind(_this, args), "pasteCleanup", imageproperties, "pasteCleanupModule");
                        else value = imageproperties;
                    }
                });
                if (!htmlRegex.test(value)) {
                    var divElement = this.parent.createElement("div");
                    divElement.innerHTML = this.splitBreakLine(value);
                    value = divElement.innerHTML;
                    isClipboardHTMLDataNull = true;
                }
            } else if (value.length > 0) {
                this.parent.trigger($947a002e9a697770$export$b3d75de79ba96fb7, {
                    value: value
                });
                this.parent.formatter.editorManager.observer.notify($ee11fb99ae4d2c3e$export$14c0a92c01180ed4, {
                    args: e.args,
                    text: e.text,
                    allowedStylePropertiesArray: this.parent.pasteCleanupSettings.allowedStyleProps,
                    callBack: function(a, cropImageData, pasteTableSource) {
                        args.pasteTableSource = pasteTableSource;
                        value = a.trim();
                        _this.cropImageData = cropImageData;
                    }
                });
            }
            this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var currentDocument = this.contentRenderer.getDocument();
            var range = this.nodeSelectionObj.getRange(currentDocument);
            this.saveSelection = this.nodeSelectionObj.save(range, currentDocument);
            var tempDivElem = this.parent.createElement("div");
            tempDivElem.innerHTML = value;
            var unsupportedImg = tempDivElem.querySelectorAll(".e-rte-image-unsupported");
            for(var index = 0; index < unsupportedImg.length; index++){
                unsupportedImg[index].setAttribute("alt", this.i10n.getConstant("unsupportedImage"));
                unsupportedImg[index].classList.remove("e-rte-image-unsupported");
            }
            value = tempDivElem.innerHTML;
            var isValueNotEmpty = tempDivElem.textContent !== "" || !(0, $3EnZW.isNullOrUndefined)(tempDivElem.querySelector("img")) || !(0, $3EnZW.isNullOrUndefined)(tempDivElem.querySelector("table"));
            this.parent.notify($947a002e9a697770$export$9da6da25c8aa3ca9, {
                value: value,
                callBack: function(currentValue) {
                    value = currentValue;
                }
            });
            if (this.parent.pasteCleanupSettings.prompt) {
                if (isValueNotEmpty) {
                    e.args.preventDefault();
                    this.pasteDialog(value, args, isClipboardHTMLDataNull);
                }
            } else if (this.parent.pasteCleanupSettings.plainText) {
                e.args.preventDefault();
                this.plainFormatting(value, args, isClipboardHTMLDataNull);
            } else if (this.parent.pasteCleanupSettings.keepFormat) {
                e.args.preventDefault();
                this.formatting(value, false, args);
            } else {
                e.args.preventDefault();
                this.formatting(value, true, args);
            }
        }
    };
    PasteCleanup.prototype.splitBreakLine = function(value) {
        var enterSplitText = value.split("\n");
        var contentInnerElem = "";
        var startNode = this.parent.enterKey === "P" ? "<p>" : this.parent.enterKey === "DIV" ? "<div>" : "";
        var endNode = this.parent.enterKey === "P" ? "</p>" : this.parent.enterKey === "DIV" ? "</div>" : "<br>";
        for(var i = 0; i < enterSplitText.length; i++)if (enterSplitText[i].trim() === "") contentInnerElem += (0, $c77ecbfae9b8c035$export$9f15c5f175f17548)(this.parent);
        else {
            var contentWithSpace = this.makeSpace(enterSplitText[i]);
            contentInnerElem += (i === 0 && this.parent.enterKey !== "BR" ? "<span>" : startNode) + (contentWithSpace.trim() === "" ? "<br>" : contentWithSpace.trim()) + (enterSplitText.length - 1 === i && this.parent.enterKey === "BR" ? "" : i === 0 && this.parent.enterKey !== "BR" ? "</span>" : endNode);
        }
        return contentInnerElem;
    };
    PasteCleanup.prototype.makeSpace = function(enterSplitText) {
        var contentWithSpace = "";
        var spaceBetweenContent = true;
        enterSplitText = enterSplitText.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
        var spaceSplit = enterSplitText.split(" ");
        for(var j = 0; j < spaceSplit.length; j++)if (spaceSplit[j].trim() === "") contentWithSpace += spaceBetweenContent ? "&nbsp;" : " ";
        else {
            spaceBetweenContent = false;
            contentWithSpace += spaceSplit[j] + " ";
        }
        return contentWithSpace;
    };
    PasteCleanup.prototype.imgUploading = function(elm) {
        var allImgElm = elm.querySelectorAll(".pasteContent_Img");
        if (this.parent.insertImageSettings.saveUrl && allImgElm.length > 0) {
            var base64Src = [];
            var imgName = [];
            var uploadImg = [];
            for(var i = 0; i < allImgElm.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(allImgElm[i].getAttribute("src")) && allImgElm[i].getAttribute("src").split(",")[0].indexOf("base64") >= 0) {
                base64Src.push(allImgElm[i].getAttribute("src"));
                imgName.push((0, $3EnZW.getUniqueID)("rte_image"));
                uploadImg.push(allImgElm[i]);
            }
            var fileList = [];
            for(var i = 0; i < base64Src.length; i++)fileList.push(this.base64ToFile(base64Src[i], imgName[i]));
            for(var i = 0; i < fileList.length; i++)this.uploadMethod(fileList[i], uploadImg[i]);
            if ((0, $3EnZW.isNullOrUndefined)(this.parent.insertImageSettings.path) && this.parent.insertImageSettings.saveFormat === "Blob") this.getBlob(allImgElm);
        } else if (this.parent.insertImageSettings.saveFormat === "Blob") this.getBlob(allImgElm);
        var allImgElmId = elm.querySelectorAll(".pasteContent_Img");
        for(var i = 0; i < allImgElmId.length; i++){
            allImgElmId[i].classList.remove("pasteContent_Img");
            if (allImgElmId[i].getAttribute("class").trim() === "") allImgElm[i].removeAttribute("class");
        }
    };
    PasteCleanup.prototype.getBlob = function(allImgElm) {
        for(var i = 0; i < allImgElm.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(allImgElm[i].getAttribute("src")) && allImgElm[i].getAttribute("src").split(",")[0].indexOf("base64") >= 0) {
            var blopUrl = URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(allImgElm[i].getAttribute("src")));
            allImgElm[i].setAttribute("src", blopUrl);
        }
    };
    PasteCleanup.prototype.toolbarEnableDisable = function(state) {
        if (!this.parent.inlineMode.enable) this.parent.toolbarModule.baseToolbar.toolbarObj.disable(state);
    };
    PasteCleanup.prototype.uploadMethod = function(file, imgElem) {
        var _this = this;
        imgElem.style.opacity = "0.5";
        var popupEle = this.parent.createElement("div");
        this.parent.rootContainer.appendChild(popupEle);
        var contentEle = this.parent.createElement("input", {
            id: this.parent.getID() + "_upload",
            attrs: {
                type: "File",
                name: "UploadFiles"
            }
        });
        var offsetY = this.parent.iframeSettings.enable ? -50 : -90;
        this.popupObj = new (0, $2vAqh.Popup)(popupEle, {
            relateTo: imgElem,
            height: "85px",
            width: "300px",
            offsetY: offsetY,
            content: contentEle,
            viewPortElement: this.parent.element,
            position: {
                X: "center",
                Y: "top"
            },
            enableRtl: this.parent.enableRtl,
            zIndex: 10001,
            // eslint-disable-next-line
            close: function(event) {
                _this.parent.isBlur = false;
                _this.popupObj.destroy();
                (0, $4ZDHT.detach)(_this.popupObj.element);
            }
        });
        this.popupObj.element.style.display = "none";
        (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], [
            $afc560df281b588d$export$22ab25c53e8ff6fa,
            $afc560df281b588d$export$d9076b806c6d0f7b
        ]);
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], this.parent.cssClass.replace(/\s+/g, " ").trim().split(" "));
        var timeOut = file.size > 1000000 ? 300 : 100;
        this.refreshPopupTime = setTimeout(function() {
            _this.refreshPopup(imgElem, _this.popupObj);
        }, timeOut);
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            asyncSettings: {
                saveUrl: this.parent.insertImageSettings.saveUrl,
                removeUrl: this.parent.insertImageSettings.removeUrl
            },
            cssClass: $afc560df281b588d$export$a464db1be8da8ef9,
            dropArea: this.parent.inputElement,
            allowedExtensions: this.parent.insertImageSettings.allowedTypes.toString(),
            success: function(e) {
                _this.popupClose(_this.popupObj, _this.uploadObj, imgElem, e);
            },
            uploading: function(e) {
                if (!_this.parent.isServerRendered) _this.parent.trigger($947a002e9a697770$export$fce94e5d515bb6fa, e, function(imageUploadingArgs) {
                    if (imageUploadingArgs.cancel) {
                        if (!(0, $3EnZW.isNullOrUndefined)(imgElem)) (0, $4ZDHT.detach)(imgElem);
                        if (!(0, $3EnZW.isNullOrUndefined)(_this.popupObj.element)) (0, $4ZDHT.detach)(_this.popupObj.element);
                    } else _this.parent.inputElement.contentEditable = "false";
                });
            },
            beforeUpload: function(args) {
                _this.parent.trigger($947a002e9a697770$export$21462d42bdb4e9c, args);
                _this.toolbarEnableDisable(true);
            },
            failure: function(e) {
                _this.failureTime = setTimeout(function() {
                    _this.uploadFailure(imgElem, _this.uploadObj, _this.popupObj, e);
                }, 900);
            },
            canceling: function() {
                _this.parent.inputElement.contentEditable = "true";
                if (imgElem.nextSibling.textContent === " ") (0, $4ZDHT.detach)(imgElem.nextSibling);
                (0, $4ZDHT.detach)(imgElem);
                _this.popupObj.close();
            },
            selected: function(e) {
                e.cancel = true;
            },
            removing: function() {
                _this.parent.inputElement.contentEditable = "true";
                if (imgElem.nextSibling.textContent === " ") (0, $4ZDHT.detach)(imgElem.nextSibling);
                (0, $4ZDHT.detach)(imgElem);
                _this.popupObj.close();
            }
        });
        this.uploadObj.appendTo(this.popupObj.element.childNodes[0]);
        var fileInfo = [
            {
                name: file.name,
                rawFile: file,
                size: file.size,
                type: file.type,
                status: "Ready to Upload",
                validationMessages: {
                    minSize: "",
                    maxSize: ""
                },
                statusCode: "1"
            }
        ];
        this.uploadObj.createFileList(fileInfo);
        this.uploadObj.upload(fileInfo);
        this.popupObj.element.getElementsByClassName("e-file-select-wrap")[0].style.display = "none";
        (0, $4ZDHT.detach)(this.popupObj.element.querySelector(".e-rte-dialog-upload .e-file-select-wrap"));
    };
    PasteCleanup.prototype.uploadFailure = function(imgElem, uploadObj, popupObj, e) {
        if (this.parent && this.parent.isDestroyed) return;
        this.parent.inputElement.contentEditable = "true";
        (0, $4ZDHT.detach)(imgElem);
        if (popupObj) popupObj.close();
        this.parent.trigger($947a002e9a697770$export$e3f6ff7da8c3e03f, e);
        if (uploadObj && document.body.contains(uploadObj.element)) uploadObj.destroy();
    };
    PasteCleanup.prototype.popupClose = function(popupObj, uploadObj, imgElem, e) {
        var _this = this;
        this.parent.inputElement.contentEditable = "true";
        e.element = imgElem;
        e.detectImageSource = (0, $2eaa618655f536c2$export$857a3989d2b808cc).Pasted;
        var element = e.file;
        if (element.statusCode === "2") this.parent.trigger($947a002e9a697770$export$3d5930a2bedfca4f, e, function(e) {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.insertImageSettings.path)) {
                var url = _this.parent.insertImageSettings.path + e.file.name;
                imgElem.src = url;
                imgElem.setAttribute("alt", e.file.name);
            }
        });
        else if (element.statusCode === "5") this.parent.trigger($947a002e9a697770$export$2004dcd6614347a, e, function(e) {
            if (!(0, $3EnZW.isNullOrUndefined)(e.element.src)) e.element.src = "";
        });
        this.popupCloseTime = setTimeout(function() {
            popupObj.close();
            imgElem.style.opacity = "1";
            _this.toolbarEnableDisable(false);
            if (uploadObj && document.body.contains(uploadObj.element)) uploadObj.destroy();
        }, 1500);
    };
    PasteCleanup.prototype.refreshPopup = function(imageElement, popupObj) {
        var imgPosition = this.parent.iframeSettings.enable ? this.parent.element.offsetTop + imageElement.offsetTop : imageElement.offsetTop;
        var rtePosition = this.parent.element.offsetTop + this.parent.element.offsetHeight;
        if (imgPosition > rtePosition) {
            popupObj.relateTo = this.parent.inputElement;
            popupObj.offsetY = this.parent.iframeSettings.enable ? -30 : -65;
            popupObj.element.style.display = "block";
        } else if (popupObj) {
            popupObj.refreshPosition(imageElement);
            popupObj.element.style.display = "block";
        }
    };
    PasteCleanup.prototype.base64ToFile = function(base64, filename) {
        var baseStr = base64.split(",");
        var typeStr = baseStr[0].match(/:(.*?);/)[1];
        var extension = typeStr.split("/")[1];
        var decodeStr = atob(baseStr[1]);
        var strLen = decodeStr.length;
        var decodeArr = new Uint8Array(strLen);
        while(strLen--)decodeArr[strLen] = decodeStr.charCodeAt(strLen);
        if ((0, $5q7BP.Browser).isIE || navigator.appVersion.indexOf("Edge") > -1) {
            var blob = new Blob([
                decodeArr
            ], {
                type: extension
            });
            (0, $3EnZW.extend)(blob, {
                name: filename + "." + (!(0, $3EnZW.isNullOrUndefined)(extension) ? extension : "")
            });
            return blob;
        } else return new File([
            decodeArr
        ], filename + "." + (!(0, $3EnZW.isNullOrUndefined)(extension) ? extension : ""), {
            type: extension
        });
    };
    /**
     * Method for image formatting when pasting
     *
     * @param {Object} pasteArgs - specifies the paste arguments.
     * @param {Element []} imgElement - specifies the array elements.
     * @returns {void}
     * @hidden

     */ PasteCleanup.prototype.imageFormatting = function(pasteArgs, imgElement) {
        if (!(0, $3EnZW.isNullOrUndefined)(imgElement.elements[0].getAttribute("src"))) imgElement.elements[0].classList.add("pasteContent_Img");
        var imageElement = this.parent.createElement("span");
        imageElement.appendChild(imgElement.elements[0]);
        var imageValue = imageElement.innerHTML;
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        var currentDocument = this.contentRenderer.getDocument();
        var range = this.nodeSelectionObj.getRange(currentDocument);
        this.saveSelection = this.nodeSelectionObj.save(range, currentDocument);
        if (this.parent.pasteCleanupSettings.prompt) this.pasteDialog(imageValue, pasteArgs, false);
        else if (this.parent.pasteCleanupSettings.plainText) this.plainFormatting(imageValue, pasteArgs, false);
        else if (this.parent.pasteCleanupSettings.keepFormat) this.formatting(imageValue, false, pasteArgs);
        else this.formatting(imageValue, true, pasteArgs);
    };
    PasteCleanup.prototype.radioRender = function() {
        this.keepRadioButton = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.i10n.getConstant("keepFormat"),
            name: "pasteOption",
            checked: true
        });
        this.keepRadioButton.isStringTemplate = true;
        var keepFormatElement = this.parent.element.querySelector("#keepFormating");
        this.keepRadioButton.appendTo(keepFormatElement);
        this.cleanRadioButton = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.i10n.getConstant("cleanFormat"),
            name: "pasteOption"
        });
        this.cleanRadioButton.isStringTemplate = true;
        var cleanFormatElement = this.parent.element.querySelector("#cleanFormat");
        this.cleanRadioButton.appendTo(cleanFormatElement);
        this.plainTextRadioButton = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.i10n.getConstant("plainText"),
            name: "pasteOption"
        });
        this.plainTextRadioButton.isStringTemplate = true;
        var plainTextElement = this.parent.element.querySelector("#plainTextFormat");
        this.plainTextRadioButton.appendTo(plainTextElement);
    };
    PasteCleanup.prototype.selectFormatting = function(value, args, keepChecked, cleanChecked, isClipboardHTMLDataNull) {
        if (keepChecked) this.formatting(value, false, args);
        else if (cleanChecked) this.formatting(value, true, args);
        else this.plainFormatting(value, args, isClipboardHTMLDataNull);
    };
    PasteCleanup.prototype.pasteDialog = function(value, args, isClipboardHTMLDataNull) {
        var _this = this;
        var dialogModel = {
            buttons: [
                {
                    click: function() {
                        if (!_this.dialogObj.isDestroyed) {
                            var keepChecked = _this.parent.element.querySelector("#keepFormating").checked;
                            var cleanChecked = _this.parent.element.querySelector("#cleanFormat").checked;
                            _this.dialogObj.hide();
                            var argument = _this.dialogObj;
                            _this.dialogRenderObj.close(argument);
                            _this.dialogObj.destroy();
                            _this.selectFormatting(value, args, keepChecked, cleanChecked, isClipboardHTMLDataNull);
                        }
                    },
                    buttonModel: {
                        isPrimary: true,
                        cssClass: "e-flat " + (0, $afc560df281b588d$export$cff6ea0e0f2bf1ea),
                        content: this.i10n.getConstant("pasteDialogOk")
                    }
                },
                {
                    click: function() {
                        if (!_this.dialogObj.isDestroyed) {
                            _this.dialogObj.hide();
                            var args_1 = _this.dialogObj;
                            _this.dialogRenderObj.close(args_1);
                            _this.dialogObj.destroy();
                        }
                    },
                    buttonModel: {
                        cssClass: "e-flat " + (0, $afc560df281b588d$export$e332cd1ae50c0315),
                        content: this.i10n.getConstant("pasteDialogCancel")
                    }
                }
            ],
            header: this.i10n.getConstant("pasteFormat"),
            content: this.i10n.getConstant("pasteFormatContent") + '<br/><div><div style="padding-top:24px;">' + '<input type="radio" class="' + (0, $afc560df281b588d$export$d7d05b723fc9e7ff) + '" id="keepFormating"/>' + '</div><div style="padding-top:20px;"><input type="radio" class="' + (0, $afc560df281b588d$export$87cd0d9d8e507a26) + '" id="cleanFormat"/></div>' + '<div style="padding-top:20px;"><input type="radio" class="' + (0, $afc560df281b588d$export$a19a2e43f10bbf59) + '" id="plainTextFormat"/></div></div>',
            target: this.parent.element,
            width: "300px",
            height: "265px",
            cssClass: (0, $afc560df281b588d$export$d8ca6c8d9715ac5b),
            isModal: (0, $5q7BP.Browser).isDevice,
            visible: false
        };
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        var rteDialogWrapper = this.parent.element.querySelector("#" + this.parent.getID() + "_pasteCleanupDialog");
        if (rteDialogWrapper !== null && rteDialogWrapper.innerHTML !== "") this.destroyDialog(rteDialogWrapper);
        if (rteDialogWrapper === null) {
            rteDialogWrapper = this.parent.createElement("div", {
                id: this.parent.getID() + "_pasteCleanupDialog"
            });
            this.parent.rootContainer.appendChild(rteDialogWrapper);
        }
        this.dialogObj.appendTo(rteDialogWrapper);
        this.radioRender();
        this.dialogObj.show();
        this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    PasteCleanup.prototype.updateCss = function(currentObj, e) {
        if (currentObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) currentObj.setProperties({
                cssClass: (currentObj.cssClass + " " + e.cssClass).trim()
            });
            else currentObj.setProperties({
                cssClass: (currentObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    // eslint-disable-next-line @typescript-eslint/tslint/config
    PasteCleanup.prototype.setCssClass = function(e) {
        if (this.popupObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) (0, $4ZDHT.addClass)([
                this.popupObj.element
            ], e.cssClass);
            else {
                (0, $4ZDHT.removeClass)([
                    this.popupObj.element
                ], e.oldCssClass);
                (0, $4ZDHT.addClass)([
                    this.popupObj.element
                ], e.cssClass);
            }
        }
        this.updateCss(this.dialogObj, e);
        this.updateCss(this.uploadObj, e);
        this.updateCss(this.plainTextRadioButton, e);
        this.updateCss(this.cleanRadioButton, e);
        this.updateCss(this.keepRadioButton, e);
    };
    PasteCleanup.prototype.destroyDialog = function(rteDialogWrapper) {
        var rteDialogContainer = this.parent.element.querySelector(".e-rte-dialog-minheight");
        (0, $4ZDHT.detach)(rteDialogContainer);
        var rteDialogWrapperChildLength = rteDialogWrapper.children.length;
        for(var i = 0; i < rteDialogWrapperChildLength; i++)(0, $4ZDHT.detach)(rteDialogWrapper.children[0]);
    };
    PasteCleanup.prototype.docClick = function(e) {
        var target = e.args.target;
        if (target && target.classList && this.dialogObj && !(0, $4ZDHT.closest)(target, "[id='" + this.dialogObj.element.id + "'" + "]") && !target.classList.contains("e-toolbar-item")) {
            if (this.dialogObj) this.dialogObj.hide();
        }
    };
    PasteCleanup.prototype.cleanAppleClass = function(elem) {
        var appleClassElem = elem.querySelectorAll("br.Apple-interchange-newline");
        for(var i = 0; i < appleClassElem.length; i++)(0, $4ZDHT.detach)(appleClassElem[i]);
        return elem;
    };
    PasteCleanup.prototype.formatting = function(value, clean, args) {
        var _this = this;
        var clipBoardElem = this.parent.createElement("div", {
            className: "pasteContent",
            styles: "display:inline;"
        });
        if (this.isNotFromHtml && this.containsHtml) value = this.splitBreakLine(value);
        clipBoardElem.innerHTML = value;
        clipBoardElem = this.cleanAppleClass(clipBoardElem);
        if (this.parent.pasteCleanupSettings.deniedTags !== null) clipBoardElem = this.deniedTags(clipBoardElem);
        if (clean) clipBoardElem = this.deniedAttributes(clipBoardElem, clean);
        else if (this.parent.pasteCleanupSettings.deniedAttrs !== null) clipBoardElem = this.deniedAttributes(clipBoardElem, clean);
        if (this.parent.pasteCleanupSettings.allowedStyleProps !== null) clipBoardElem = this.allowedStyle(clipBoardElem);
        this.saveSelection.restore();
        var newText = clipBoardElem.innerHTML.split("&").join("&amp;");
        clipBoardElem.innerHTML = this.sanitizeHelper(newText);
        var allImg = clipBoardElem.querySelectorAll("img");
        for(var i = 0; i < allImg.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(allImg[i].getAttribute("src"))) allImg[i].classList.add("pasteContent_Img");
            this.setImageProperties(allImg[i]);
        }
        this.addTempClass(clipBoardElem);
        if (clipBoardElem.querySelectorAll("picture").length > 0) this.processPictureElement(clipBoardElem);
        if (clipBoardElem.textContent !== "" || !(0, $3EnZW.isNullOrUndefined)(clipBoardElem.querySelector("img")) || !(0, $3EnZW.isNullOrUndefined)(clipBoardElem.querySelector("table"))) {
            var tempWrapperElem = this.parent.createElement("div");
            tempWrapperElem.innerHTML = value;
            var filesData = [];
            if (!(0, $3EnZW.isNullOrUndefined)(tempWrapperElem.querySelector("img"))) {
                var imgElem = tempWrapperElem.querySelectorAll("img");
                var base64Src = [];
                var imgName = [];
                var uploadImg = [];
                for(var i = 0; i < imgElem.length; i++)if (imgElem[i].getAttribute("src") && imgElem[i].getAttribute("src").split(",")[0].indexOf("base64") >= 0) {
                    base64Src.push(imgElem[i].getAttribute("src"));
                    imgName.push((0, $3EnZW.getUniqueID)("rte_image"));
                    uploadImg.push(imgElem[i]);
                }
                var fileList = [];
                var currentData = void 0;
                for(var i = 0; i < base64Src.length; i++){
                    fileList.push(this.base64ToFile(base64Src[i], imgName[i]));
                    currentData = {
                        name: fileList[i].name,
                        rawFile: fileList[i],
                        size: fileList[i].size,
                        type: fileList[i].type,
                        status: "",
                        validationMessages: {
                            minSize: "",
                            maxSize: ""
                        },
                        statusCode: "1"
                    };
                    filesData.push(currentData);
                }
            }
            this.parent.trigger($947a002e9a697770$export$66c84204ad5d6049, {
                value: clipBoardElem.innerHTML,
                filesData: filesData
            }, function(updatedArgs) {
                value = updatedArgs.value;
            });
            clipBoardElem.innerHTML = this.parent.addAnchorAriaLabel(value);
            clipBoardElem = this.addTableClass(clipBoardElem, args.pasteTableSource);
            this.parent.formatter.editorManager.execCommand("inserthtml", "pasteCleanup", args, function(returnArgs) {
                (0, $3EnZW.extend)(args, {
                    elements: returnArgs.elements,
                    imageElements: returnArgs.imgElem
                }, true);
                _this.parent.formatter.onSuccess(_this.parent, args);
            }, clipBoardElem, null, null, this.parent.enterKey);
            this.parent.notify($947a002e9a697770$export$c1294d1049dd22e8, {});
            (0, $259257662ca103fc$export$7e1ec7538889cd1)(this.parent.contentModule.getDocument(), this.parent.inputElement);
            this.removeTempClass();
            this.parent.notify($947a002e9a697770$export$6a017cfaa3b33c68, {});
            this.cropImageHandler(this.parent.inputElement);
        }
    };
    PasteCleanup.prototype.convertBlobToBase64 = function(element) {
        var imgElem = element.querySelectorAll("img");
        var _loop_1 = function(i) {
            if (imgElem[i].getAttribute("src") && imgElem[i].getAttribute("src").startsWith("blob")) {
                var blobImageUrl = imgElem[i].getAttribute("src");
                var img_1 = new Image();
                var onImageLoadEvent_1 = function() {
                    var canvas = document.createElement("canvas");
                    var ctx = canvas.getContext("2d");
                    canvas.width = img_1.width;
                    canvas.height = img_1.height;
                    ctx.drawImage(img_1, 0, 0);
                    var base64String = canvas.toDataURL("image/png");
                    imgElem[i].src = base64String;
                    img_1.removeEventListener("load", onImageLoadEvent_1);
                };
                img_1.src = blobImageUrl;
                img_1.addEventListener("load", onImageLoadEvent_1);
            }
        };
        for(var i = 0; i < imgElem.length; i++)_loop_1(i);
    };
    PasteCleanup.prototype.cropImageHandler = function(element) {
        var _this = this;
        var allImgElm = element.querySelectorAll(".e-img-cropped");
        if (allImgElm.length > 0) {
            var _loop_2 = function(i) {
                if (allImgElm[i].getAttribute("src").split(",")[0].indexOf("base64") >= 0) {
                    var image_1 = new Image();
                    image_1.src = allImgElm[i].getAttribute("src");
                    var canvas_1 = document.createElement("canvas");
                    var ctx_1 = canvas_1.getContext("2d");
                    image_1.onload = function() {
                        var wGoalWidth = _this.cropImageData[i].goalWidth / image_1.naturalWidth;
                        var hGoalHeight = _this.cropImageData[i].goalHeight / image_1.naturalHeight;
                        var cropLength = _this.cropImageData[i].cropLength / wGoalWidth;
                        var cropTop = _this.cropImageData[i].cropTop / hGoalHeight;
                        var cropWidth = (_this.cropImageData[i].goalWidth - _this.cropImageData[i].cropLength - _this.cropImageData[i].cropR) / wGoalWidth;
                        var cropHeight = (_this.cropImageData[i].goalHeight - _this.cropImageData[i].cropTop - _this.cropImageData[i].cropB) / hGoalHeight;
                        canvas_1.width = cropWidth;
                        canvas_1.height = cropHeight;
                        // Draw the cropped portion of the image onto the canvas
                        ctx_1.drawImage(image_1, cropLength, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                        // Convert the cropped canvas to a base64 encoded image
                        var croppedBase64 = canvas_1.toDataURL("image/png");
                        // Call the provided callback with the cropped base64 data
                        allImgElm[i].setAttribute("src", croppedBase64);
                        allImgElm[i].classList.remove("e-img-cropped");
                        _this.imgUploading(_this.parent.inputElement);
                        if (_this.parent.iframeSettings.enable) _this.parent.updateValue();
                    };
                }
            };
            for(var i = 0; i < allImgElm.length; i++)_loop_2(i);
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertImageSettings.saveUrl) && !(0, $3EnZW.isNullOrUndefined)(this.parent.insertImageSettings.path) && this.parent.inputElement.querySelectorAll("img").length > 0 && this.parent.inputElement.querySelectorAll("img")[0].src.startsWith("blob")) {
            this.convertBlobToBase64(this.parent.inputElement);
            this.iframeUploadTime = setTimeout(function() {
                _this.imgUploading(_this.parent.inputElement);
                if (_this.parent.iframeSettings.enable) _this.parent.updateValue();
            }, 20);
        } else {
            this.imgUploading(this.parent.inputElement);
            if (this.parent.iframeSettings.enable) this.parent.updateValue();
        }
    };
    PasteCleanup.prototype.addTableClass = function(element, source) {
        var tableElement = element.querySelectorAll("table");
        for(var i = 0; i < tableElement.length; i++){
            var isMSTeamsTable = tableElement[i].parentElement.nodeName === "FIGURE";
            if (this.parent.pasteCleanupSettings.keepFormat && source && !isMSTeamsTable) tableElement[i].classList.add("e-rte-paste-" + source + "-table");
            else if (!tableElement[i].classList.contains("e-rte-table")) tableElement[i].classList.add("e-rte-table");
        }
        return element;
    };
    PasteCleanup.prototype.setImageProperties = function(allImg) {
        if (this.parent.insertImageSettings.width !== "auto") allImg.setAttribute("width", this.parent.insertImageSettings.width);
        if (this.parent.insertImageSettings.minWidth !== "0" && this.parent.insertImageSettings.minWidth !== 0) allImg.style.minWidth = this.parent.insertImageSettings.minWidth.toString();
        if (this.parent.insertImageSettings.maxWidth !== null) allImg.style.maxWidth = this.parent.getInsertImgMaxWidth().toString();
        if (this.parent.insertImageSettings.height !== "auto") allImg.setAttribute("height", this.parent.insertImageSettings.height);
        if (this.parent.insertImageSettings.minHeight !== "0" && this.parent.insertImageSettings.minHeight !== 0) allImg.style.minHeight = this.parent.insertImageSettings.minHeight.toString();
        if (this.parent.insertImageSettings.maxHeight !== null) allImg.style.maxHeight = this.parent.insertImageSettings.maxHeight.toString();
    };
    PasteCleanup.prototype.addTempClass = function(clipBoardElem) {
        var allChild = clipBoardElem.children;
        for(var i = 0; i < allChild.length; i++)allChild[i].classList.add("pasteContent_RTE");
    };
    PasteCleanup.prototype.removeTempClass = function() {
        var classElm = this.parent.inputElement.querySelectorAll(".pasteContent_RTE");
        for(var i = 0; i < classElm.length; i++){
            classElm[i].classList.remove("pasteContent_RTE");
            if (classElm[i].getAttribute("class") === "") classElm[i].removeAttribute("class");
        }
    };
    PasteCleanup.prototype.sanitizeHelper = function(value) {
        value = (0, $c77ecbfae9b8c035$export$b868d07f1dfe5080)(value, this.parent);
        return value;
    };
    //Plain Formatting
    PasteCleanup.prototype.plainFormatting = function(value, args, isClipboardHTMLDataNull) {
        var _this = this;
        var clipBoardElem = this.parent.createElement("div", {
            className: "pasteContent",
            styles: "display:inline;"
        });
        clipBoardElem.innerHTML = value;
        this.detachInlineElements(clipBoardElem);
        this.getTextContent(clipBoardElem);
        if (clipBoardElem.textContent.trim() !== "") {
            if (!(0, $3EnZW.isNullOrUndefined)(clipBoardElem.firstElementChild) && clipBoardElem.firstElementChild.tagName !== "BR") {
                var firstElm = clipBoardElem.firstElementChild;
                if (!(0, $3EnZW.isNullOrUndefined)(clipBoardElem.firstElementChild)) {
                    var spanElm = this.parent.createElement("span");
                    for(var i = 0, j = 0; i < firstElm.childNodes.length; i++, j++){
                        if (firstElm.childNodes[i].nodeName === "#text") {
                            spanElm.appendChild(firstElm.childNodes[i]);
                            clipBoardElem.insertBefore(spanElm, clipBoardElem.firstElementChild);
                            i--;
                        } else if (firstElm.childNodes[i].nodeName !== "#text" && j === 0) {
                            for(var k = 0; k < firstElm.childNodes[i].childNodes.length; k++){
                                spanElm.appendChild(firstElm.childNodes[i].childNodes[k]);
                                clipBoardElem.insertBefore(spanElm, clipBoardElem.firstElementChild);
                                k--;
                            }
                            i--;
                        } else break;
                    }
                    if (!firstElm.hasChildNodes()) (0, $4ZDHT.detach)(firstElm);
                }
            }
            this.removeEmptyElements(clipBoardElem);
            this.saveSelection.restore();
            clipBoardElem.innerHTML = this.sanitizeHelper(clipBoardElem.innerHTML);
            this.addTempClass(clipBoardElem);
            this.removingComments(clipBoardElem);
            if (this.parent.enterKey === "BR" && !isClipboardHTMLDataNull) clipBoardElem = this.reframeToBrContent(clipBoardElem);
            else if (this.parent.enterKey === "DIV") clipBoardElem.innerHTML = clipBoardElem.innerHTML.replace(/<p class="pasteContent_RTE">/g, "<div>").replace(/<\/p>/g, "</div>");
            this.parent.trigger($947a002e9a697770$export$66c84204ad5d6049, {
                value: clipBoardElem.innerHTML,
                filesData: null
            }, function(updatedArgs) {
                value = updatedArgs.value;
            });
            clipBoardElem.innerHTML = value;
            this.parent.formatter.editorManager.execCommand("inserthtml", "pasteCleanup", args, function(returnArgs) {
                (0, $3EnZW.extend)(args, {
                    elements: returnArgs.elements,
                    imageElements: returnArgs.imgElem
                }, true);
                _this.parent.formatter.onSuccess(_this.parent, args);
            }, clipBoardElem, null, null, this.parent.enterKey);
            this.removeTempClass();
        } else {
            this.saveSelection.restore();
            (0, $3EnZW.extend)(args, {
                elements: []
            }, true);
            this.parent.formatter.onSuccess(this.parent, args);
        }
    };
    PasteCleanup.prototype.removingComments = function(elm) {
        var innerElement = elm.innerHTML;
        innerElement = innerElement.replace(/<!--[\s\S]*?-->/g, "");
        elm.innerHTML = innerElement;
    };
    PasteCleanup.prototype.reframeToBrContent = function(clipBoardElem) {
        var newClipBoardElem = this.parent.createElement("div", {
            className: "pasteContent",
            styles: "display:inline;"
        });
        while(!(0, $3EnZW.isNullOrUndefined)(clipBoardElem.firstChild)){
            var brElem = this.parent.createElement("br");
            var currentFirstChild = clipBoardElem.firstChild;
            if (currentFirstChild.nodeName === "#text") {
                var isNextSibPresent = !(0, $3EnZW.isNullOrUndefined)(currentFirstChild.nextSibling);
                newClipBoardElem.appendChild(currentFirstChild);
                if (isNextSibPresent) newClipBoardElem.appendChild(brElem);
            } else {
                var isCurrentNodeBRElm = currentFirstChild.nodeName === "BR";
                if (isCurrentNodeBRElm) newClipBoardElem.appendChild(currentFirstChild);
                else newClipBoardElem.appendChild(currentFirstChild.childNodes[0]);
                if (!(0, $3EnZW.isNullOrUndefined)(currentFirstChild) && !(0, $3EnZW.isNullOrUndefined)(currentFirstChild.nextSibling)) newClipBoardElem.appendChild(brElem);
                if (!isCurrentNodeBRElm && !(0, $3EnZW.isNullOrUndefined)(currentFirstChild)) (0, $4ZDHT.detach)(currentFirstChild);
            }
        }
        return newClipBoardElem;
    };
    PasteCleanup.prototype.getTextContent = function(clipBoardElem) {
        for(var i = 0; i < this.blockNode.length; i++){
            var inElem = clipBoardElem.querySelectorAll(this.blockNode[i]);
            for(var j = 0; j < inElem.length; j++){
                var parElem = void 0;
                for(var k = 0, l = 0, preNode = void 0; k < inElem[j].childNodes.length; k++, l++)if (inElem[j].childNodes[k].nodeName === "DIV" || inElem[j].childNodes[k].nodeName === "P" || inElem[j].childNodes[k].nodeName === "#text" && inElem[j].childNodes[k].nodeValue.replace(/\u00a0/g, "&nbsp;") !== "&nbsp;" && inElem[j].childNodes[k].textContent.trim() === "") {
                    parElem = inElem[j].childNodes[k].parentElement;
                    inElem[j].childNodes[k].parentElement.parentElement.insertBefore(inElem[j].childNodes[k], inElem[j].childNodes[k].parentElement);
                    k--;
                } else {
                    parElem = inElem[j].childNodes[k].parentElement;
                    if (preNode === "text") {
                        var previousElem = parElem.previousElementSibling;
                        previousElem.appendChild(inElem[j].childNodes[k]);
                    } else {
                        var divElement = this.parent.createElement("div", {
                            id: "newDiv"
                        });
                        divElement.appendChild(inElem[j].childNodes[k]);
                        parElem.parentElement.insertBefore(divElement, parElem);
                    }
                    k--;
                    preNode = "text";
                }
                if (!(0, $3EnZW.isNullOrUndefined)(parElem)) (0, $4ZDHT.detach)(parElem);
            }
        }
        var allElems = clipBoardElem.querySelectorAll("*");
        for(var i = 0; i < allElems.length; i++){
            var allAtr = allElems[i].attributes;
            for(var j = 0; j < allAtr.length; j++){
                allElems[i].removeAttribute(allAtr[j].name);
                j--;
            }
        }
    };
    PasteCleanup.prototype.detachInlineElements = function(clipBoardElem) {
        for(var i = 0; i < this.inlineNode.length; i++){
            var inElem = clipBoardElem.querySelectorAll(this.inlineNode[i]);
            for(var j = 0; j < inElem.length; j++)if (!(inElem[j] === clipBoardElem.firstChild && inElem[j].nodeName === "SPAN")) {
                var parElem = void 0;
                for(var k = 0; k < inElem[j].childNodes.length; k++){
                    parElem = inElem[j].childNodes[k].parentElement;
                    inElem[j].childNodes[k].parentElement.parentElement.insertBefore(inElem[j].childNodes[k], inElem[j].childNodes[k].parentElement);
                    k--;
                }
                if (!(0, $3EnZW.isNullOrUndefined)(parElem)) (0, $4ZDHT.detach)(parElem);
            }
        }
    };
    PasteCleanup.prototype.findDetachEmptyElem = function(element) {
        var removableElement;
        if (!(0, $3EnZW.isNullOrUndefined)(element) && !(0, $3EnZW.isNullOrUndefined)(element.parentElement)) {
            var hasNbsp = element.parentElement.textContent.length > 0 && element.parentElement.textContent.match(/\u00a0/g) && element.parentElement.textContent.match(/\u00a0/g).length > 0;
            if (!hasNbsp && element.parentElement.textContent.trim() === "" && element.parentElement.getAttribute("class") !== "pasteContent") removableElement = this.findDetachEmptyElem(element.parentElement);
            else removableElement = element;
        } else removableElement = null;
        return removableElement;
    };
    PasteCleanup.prototype.removeEmptyElements = function(element) {
        var emptyElements = element.querySelectorAll(":empty");
        for(var i = 0; i < emptyElements.length; i++)if (emptyElements[i].tagName !== "BR") {
            var detachableElement = this.findDetachEmptyElem(emptyElements[i]);
            if (!(0, $3EnZW.isNullOrUndefined)(detachableElement)) (0, $4ZDHT.detach)(detachableElement);
        }
    };
    //GroupingTags
    PasteCleanup.prototype.tagGrouping = function(deniedTags) {
        var groupingTags = deniedTags.slice();
        var keys = Object.keys((0, $9dc0015271a44eb1$export$5c2f1340ff782edf));
        var values = keys.map(function(key) {
            return (0, $9dc0015271a44eb1$export$5c2f1340ff782edf)["" + key];
        });
        var addTags = [];
        for(var i = 0; i < groupingTags.length; i++){
            //The value split using '[' because to retrieve the tag name from the user given format which may contain tag with attributes
            if (groupingTags[i].split("[").length > 1) groupingTags[i] = groupingTags[i].split("[")[0].trim();
            if (keys.indexOf(groupingTags[i]) > -1) {
                for(var j = 0; j < values[keys.indexOf(groupingTags[i])].length; j++)if (groupingTags.indexOf(values[keys.indexOf(groupingTags[i])][j]) < 0 && addTags.indexOf(values[keys.indexOf(groupingTags[i])][j]) < 0) addTags.push(values[keys.indexOf(groupingTags[i])][j]);
            }
        }
        return deniedTags = deniedTags.concat(addTags);
    };
    //Filter Attributes in Denied Tags
    PasteCleanup.prototype.attributesfilter = function(deniedTags) {
        for(var i = 0; i < deniedTags.length; i++)if (deniedTags[i].split("[").length > 1) {
            var userAttributes = deniedTags[i].split("[")[1].split("]")[0].split(",");
            var allowedAttributeArray = [];
            var deniedAttributeArray = [];
            for(var j = 0; j < userAttributes.length; j++)if (userAttributes[j].indexOf("!") < 0) allowedAttributeArray.push(userAttributes[j].trim());
            else deniedAttributeArray.push(userAttributes[j].split("!")[1].trim());
            var allowedAttribute = allowedAttributeArray.length > 1 ? allowedAttributeArray.join("][") : allowedAttributeArray.join();
            var deniedAttribute = deniedAttributeArray.length > 1 ? deniedAttributeArray.join("][") : deniedAttributeArray.join();
            if (deniedAttribute.length > 0) {
                var select = allowedAttribute !== "" ? deniedTags[i].split("[")[0] + "[" + allowedAttribute + "]" : deniedTags[i].split("[")[0];
                deniedTags[i] = select + ":not([" + deniedAttribute + "])";
            } else deniedTags[i] = deniedTags[i].split("[")[0] + "[" + allowedAttribute + "]";
        }
        return deniedTags;
    };
    //Denied Tags
    PasteCleanup.prototype.deniedTags = function(clipBoardElem) {
        var deniedTags = (0, $3EnZW.isNullOrUndefined)(this.parent.pasteCleanupSettings.deniedTags) ? [] : this.parent.pasteCleanupSettings.deniedTags.slice();
        deniedTags = this.attributesfilter(deniedTags);
        deniedTags = this.tagGrouping(deniedTags);
        for(var i = 0; i < deniedTags.length; i++){
            var removableElement = clipBoardElem.querySelectorAll(deniedTags[i]);
            for(var j = removableElement.length - 1; j >= 0; j--){
                var parentElem = removableElement[j].parentNode;
                while(removableElement[j].firstChild)parentElem.insertBefore(removableElement[j].firstChild, removableElement[j]);
                parentElem.removeChild(removableElement[j]);
            }
        }
        return clipBoardElem;
    };
    //Denied Attributes
    PasteCleanup.prototype.deniedAttributes = function(clipBoardElem, clean) {
        var deniedAttrs = (0, $3EnZW.isNullOrUndefined)(this.parent.pasteCleanupSettings.deniedAttrs) ? [] : this.parent.pasteCleanupSettings.deniedAttrs.slice();
        if (clean) deniedAttrs.push("style");
        for(var i = 0; i < deniedAttrs.length; i++){
            var removableAttrElement = clipBoardElem.querySelectorAll("[" + deniedAttrs[i] + "]");
            for(var j = 0; j < removableAttrElement.length; j++)removableAttrElement[j].removeAttribute(deniedAttrs[i]);
        }
        return clipBoardElem;
    };
    //Allowed Style Properties
    PasteCleanup.prototype.allowedStyle = function(clipBoardElem) {
        var allowedStyleProps = (0, $3EnZW.isNullOrUndefined)(this.parent.pasteCleanupSettings.allowedStyleProps) ? [] : this.parent.pasteCleanupSettings.allowedStyleProps.slice();
        allowedStyleProps.push("list-style-type", "list-style");
        var styleElement = clipBoardElem.querySelectorAll("[style]");
        for(var i = 0; i < styleElement.length; i++){
            var allowedStyleValue = "";
            var allowedStyleValueArray = [];
            var styleValue = styleElement[i].getAttribute("style").split(";");
            for(var k = 0; k < styleValue.length; k++)if (allowedStyleProps.indexOf(styleValue[k].split(":")[0].trim()) >= 0) allowedStyleValueArray.push(styleValue[k]);
            styleElement[i].removeAttribute("style");
            allowedStyleValue = allowedStyleValueArray.join(";").trim() === "" ? allowedStyleValueArray.join(";") : allowedStyleValueArray.join(";") + ";";
            if (allowedStyleValue) styleElement[i].setAttribute("style", allowedStyleValue);
        }
        return clipBoardElem;
    };
    PasteCleanup.prototype.processPictureElement = function(clipBoardElem) {
        var pictureElems = clipBoardElem.querySelectorAll("picture");
        for(var i = 0; i < pictureElems.length; i++){
            var imgElem = pictureElems[i].querySelector("img");
            var sourceElems = pictureElems[i].querySelectorAll("source");
            if (imgElem && imgElem.getAttribute("src")) {
                var srcValue = imgElem.getAttribute("src");
                var url = new URL(srcValue);
                for(var j = 0; j < sourceElems.length; j++){
                    var srcset = sourceElems[j].getAttribute("srcset");
                    if (srcset) {
                        if (srcset.indexOf("http") === -1) {
                            var fullPath = url.origin + srcset;
                            sourceElems[j].setAttribute("srcset", fullPath);
                        }
                    }
                }
            }
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ PasteCleanup.prototype.getModuleName = function() {
        return "pasteCleanup";
    };
    return PasteCleanup;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");



parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

var $49u5W = parcelRequire("49u5W");









parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");



var $2vAqh = parcelRequire("2vAqh");


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $e7i2H = parcelRequire("e7i2H");
var $kj1BR = parcelRequire("kj1BR");
parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");



var $03bd16efb3eac670$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $03bd16efb3eac670$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $03bd16efb3eac670$var$RTL = "e-rtl";
var $03bd16efb3eac670$var$TAGNAME = "EJS-SPLITBUTTON";
/**
 * SplitButton component has primary and secondary button. Primary button is used to select
 * default action and secondary button is used to toggle contextual overlays for displaying list of
 * action items. It can contain both text and images.
 * ```html
 * <button id="element"></button>
 * ```
 * ```typescript
 * <script>
 * var splitBtnObj = new SplitButton({content: 'SplitButton'});
 * splitBtnObj.appendTo("#element");
 * </script>
 * ```
 */ var $03bd16efb3eac670$export$651ad66661acd392 = /** @class */ function(_super) {
    $03bd16efb3eac670$var$__extends(SplitButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {SplitButtonModel} options - Specifies the splitbutton model
     * @param  {string|HTMLButtonElement} element - Specifies the element
     * @hidden
     */ function SplitButton(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize Angular support.
     *
     * @private
     * @returns {void}
     */ SplitButton.prototype.preRender = function() {
        var ele = this.element;
        if (ele.tagName === $03bd16efb3eac670$var$TAGNAME) {
            var ejInstance = (0, $3EnZW.getValue)("ej2_instances", ele);
            var btn = this.createElement("button", {
                attrs: {
                    "type": "button"
                }
            });
            var wrapper = this.createElement($03bd16efb3eac670$var$TAGNAME, {
                className: "e-" + this.getModuleName() + "-wrapper"
            });
            for(var idx = 0, len = ele.attributes.length; idx < len; idx++)btn.setAttribute(ele.attributes[idx].nodeName, ele.attributes[idx].nodeValue);
            ele.parentNode.insertBefore(wrapper, ele);
            (0, $4ZDHT.detach)(ele);
            ele = btn;
            wrapper.appendChild(ele);
            (0, $3EnZW.setValue)("ej2_instances", ejInstance, ele);
            this.wrapper = wrapper;
            this.element = ele;
        }
        if (!this.element.id) this.element.id = (0, $3EnZW.getUniqueID)("e-" + this.getModuleName());
    };
    /**
     * Initialize the Component rendering.
     *
     * @returns {void}
     * @private
     */ SplitButton.prototype.render = function() {
        this.initWrapper();
        this.createPrimaryButton();
        this.renderControl();
    };
    SplitButton.prototype.renderControl = function() {
        this.createSecondaryButton();
        this.setActiveElem([
            this.element,
            this.secondaryBtnObj.element
        ]);
        this.setAria();
        this.wireEvents();
        this.renderComplete();
    };
    /**
     * Adds a new item to the menu. By default, new item appends to the list as the last item,
     * but you can insert based on the text parameter.
     *
     * @param  { ItemModel[] } items - Specifies an array of JSON data.
     * @param { string } text - Specifies the text to insert the newly added item in the menu.
     * @returns {void}.
     */ SplitButton.prototype.addItems = function(items, text) {
        _super.prototype.addItems.call(this, items, text);
        this.secondaryBtnObj.items = this.items;
    };
    /**
     * Removes the items from the menu.
     *
     * @param  { string[] } items - Specifies an array of string to remove the items.
     * @param { string } isUniqueId - Set `true` if specified items is a collection of unique id.
     * @returns {void}.
     */ SplitButton.prototype.removeItems = function(items, isUniqueId) {
        _super.prototype.removeItems.call(this, items, isUniqueId);
        this.secondaryBtnObj.items = this.items;
    };
    SplitButton.prototype.initWrapper = function() {
        if (!this.wrapper) {
            this.wrapper = this.createElement("div", {
                className: "e-" + this.getModuleName() + "-wrapper"
            });
            this.element.parentNode.insertBefore(this.wrapper, this.element);
        }
        this.element.classList.remove("e-" + this.getModuleName());
        if (this.enableRtl) this.wrapper.classList.add($03bd16efb3eac670$var$RTL);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
    };
    SplitButton.prototype.createPrimaryButton = function() {
        var btnModel = {
            cssClass: this.cssClass,
            enableRtl: this.enableRtl,
            iconCss: this.iconCss,
            iconPosition: this.iconPosition,
            content: this.content,
            disabled: this.disabled
        };
        this.primaryBtnObj = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)(btnModel);
        this.primaryBtnObj.createElement = this.createElement;
        this.primaryBtnObj.appendTo(this.element);
        this.element.classList.add("e-" + this.getModuleName());
        this.element.type = "button";
        this.wrapper.appendChild(this.element);
    };
    SplitButton.prototype.createSecondaryButton = function() {
        var _this = this;
        var btnElem = this.createElement("button", {
            className: "e-icon-btn",
            attrs: {
                "tabindex": "-1"
            },
            id: this.element.id + "_dropdownbtn"
        });
        this.wrapper.appendChild(btnElem);
        var dropDownBtnModel = {
            cssClass: this.cssClass,
            disabled: this.disabled,
            enableRtl: this.enableRtl,
            items: this.items,
            target: this.target,
            createPopupOnClick: this.createPopupOnClick
        };
        dropDownBtnModel.beforeItemRender = function(args) {
            if (_this.createPopupOnClick) {
                _this.secondaryBtnObj.dropDown.relateTo = _this.wrapper;
                _this.dropDown = _this.secondaryBtnObj.dropDown;
            }
            _this.trigger("beforeItemRender", args);
        };
        dropDownBtnModel.open = function(args) {
            _this.trigger("open", args);
        };
        dropDownBtnModel.close = function(args) {
            _this.trigger("close", args);
        };
        dropDownBtnModel.select = function(args) {
            _this.trigger("select", args);
        };
        dropDownBtnModel.beforeOpen = function(args) {
            if (_this.createPopupOnClick && _this.items.length === 0) {
                _this.secondaryBtnObj.dropDown.relateTo = _this.wrapper;
                _this.dropDown = _this.secondaryBtnObj.dropDown;
            }
            var callBackPromise = new $03bd16efb3eac670$export$85f6557964517f1a();
            _this.trigger("beforeOpen", args, function(observedArgs) {
                callBackPromise.resolve(observedArgs);
            });
            return callBackPromise;
        };
        dropDownBtnModel.beforeClose = function(args) {
            var callBackPromise = new $03bd16efb3eac670$export$85f6557964517f1a();
            _this.trigger("beforeClose", args, function(observedArgs) {
                callBackPromise.resolve(observedArgs);
            });
            return callBackPromise;
        };
        this.secondaryBtnObj = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)(dropDownBtnModel);
        this.secondaryBtnObj.createElement = this.createElement;
        this.secondaryBtnObj.appendTo(btnElem);
        if (!this.createPopupOnClick) {
            this.secondaryBtnObj.dropDown.relateTo = this.wrapper;
            this.dropDown = this.secondaryBtnObj.dropDown;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.isPopupCreated = this.secondaryBtnObj.isPopupCreated;
        this.secondaryBtnObj.activeElem = [
            this.element,
            this.secondaryBtnObj.element
        ];
        this.secondaryBtnObj.element.querySelector(".e-btn-icon").classList.remove("e-icon-right");
        if (this.disabled) this.wrapper.classList.add("e-splitbtn-disabled");
    };
    SplitButton.prototype.setAria = function() {
        (0, $4ZDHT.attributes)(this.element, {
            "aria-expanded": "false",
            "aria-haspopup": "true",
            "aria-label": this.element.textContent ? this.element.textContent + " splitbutton" : "splitbutton",
            "aria-owns": this.element.id + "_dropdownbtn-popup"
        });
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */ SplitButton.prototype.getModuleName = function() {
        return "split-btn";
    };
    /**
     * To open/close SplitButton popup based on current state of the SplitButton.
     *
     * @returns {void}
     */ SplitButton.prototype.toggle = function() {
        this.secondaryBtnObj.toggle();
    };
    SplitButton.prototype.destroy = function() {
        var _this = this;
        var classList = [
            $03bd16efb3eac670$var$RTL
        ];
        if (this.cssClass) classList = classList.concat(this.cssClass.split(" "));
        if (this.element) {
            var element = document.getElementById(this.element.id);
            if (element && element.parentElement === this.wrapper) {
                if (this.wrapper.tagName === $03bd16efb3eac670$var$TAGNAME) {
                    this.wrapper.innerHTML = "";
                    (0, $4ZDHT.removeClass)([
                        this.wrapper
                    ], [
                        "e-rtl",
                        "e-" + this.getModuleName() + "-wrapper"
                    ]);
                    (0, $4ZDHT.removeClass)([
                        this.wrapper
                    ], this.cssClass.split(" "));
                } else {
                    (0, $4ZDHT.removeClass)([
                        this.element
                    ], classList);
                    [
                        "aria-label",
                        "aria-haspopup",
                        "aria-expanded",
                        "aria-owns",
                        "type"
                    ].forEach(function(key) {
                        _this.element.removeAttribute(key);
                    });
                    this.wrapper.parentNode.insertBefore(this.element, this.wrapper);
                    (0, $4ZDHT.remove)(this.wrapper);
                }
                this.unWireEvents();
            }
        }
        this.primaryBtnObj.destroy();
        this.secondaryBtnObj.destroy();
        _super.prototype.destroy.call(this);
        if (this.element && !this.element.getAttribute("class")) this.element.removeAttribute("class");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.refreshing && this.isAngular) {
            this.element = this.wrapper;
            [
                "e-control",
                "e-split-btn",
                "e-lib"
            ].forEach(function(key) {
                _this.element.classList.add(key);
            });
            (0, $3EnZW.setValue)("ej2_instances", [
                this
            ], this.element);
        }
        this.wrapper = null;
    };
    SplitButton.prototype.wireEvents = function() {
        (0, $aqzbR.EventHandler).add(this.element, "click", this.primaryBtnClickHandler, this);
        new (0, $dyv7X.KeyboardEvents)(this.element, {
            keyAction: this.btnKeyBoardHandler.bind(this),
            keyConfigs: {
                altdownarrow: "alt+downarrow",
                enter: "enter"
            }
        });
    };
    SplitButton.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.primaryBtnClickHandler);
        (0, $3EnZW.getInstance)(this.element, (0, $dyv7X.KeyboardEvents)).destroy();
    };
    SplitButton.prototype.primaryBtnClickHandler = function() {
        this.trigger("click", {
            element: this.element
        });
    };
    SplitButton.prototype.btnKeyBoardHandler = function(e) {
        switch(e.action){
            case "altdownarrow":
                this.clickHandler(e);
                break;
            case "enter":
                this.clickHandler(e);
                if (this.getPopUpElement() && !this.getPopUpElement().classList.contains("e-popup-close")) {
                    this.element.classList.remove("e-active");
                    this.secondaryBtnObj.element.classList.add("e-active");
                } else this.secondaryBtnObj.element.classList.remove("e-active");
                break;
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {SplitButtonModel} newProp - Specifies new properties
     * @param  {SplitButtonModel} oldProp - Specifies old properties
     * @returns {void}
     */ SplitButton.prototype.onPropertyChanged = function(newProp, oldProp) {
        var model = [
            "content",
            "iconCss",
            "iconPosition",
            "cssClass",
            "disabled",
            "enableRtl"
        ];
        this.primaryBtnObj.setProperties((0, $22807a4aeae41444$export$289ca1c318c0384)(newProp, model));
        model = [
            "beforeOpen",
            "beforeItemRender",
            "select",
            "open",
            "close",
            "cssClass",
            "disabled",
            "enableRtl",
            "createPopupOnClick"
        ];
        if (Object.keys(newProp).indexOf("items") > -1) {
            this.secondaryBtnObj.items = newProp.items;
            this.secondaryBtnObj.dataBind();
        }
        this.secondaryBtnObj.setProperties((0, $22807a4aeae41444$export$289ca1c318c0384)(newProp, model));
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        this.wrapper
                    ], oldProp.cssClass.split(" "));
                    (0, $4ZDHT.addClass)([
                        this.wrapper
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) (0, $4ZDHT.addClass)([
                        this.wrapper
                    ], $03bd16efb3eac670$var$RTL);
                    else (0, $4ZDHT.removeClass)([
                        this.wrapper
                    ], $03bd16efb3eac670$var$RTL);
                    break;
                case "disabled":
                    if (newProp.disabled) (0, $4ZDHT.addClass)([
                        this.wrapper
                    ], "e-splitbtn-disabled");
                    else (0, $4ZDHT.removeClass)([
                        this.wrapper
                    ], "e-splitbtn-disabled");
            }
        }
    };
    /**
     * Sets the focus to SplitButton
     * its native method
     *
     * @public
     * @returns {void}
     */ SplitButton.prototype.focusIn = function() {
        this.element.focus();
    };
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SplitButton.prototype, "content", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SplitButton.prototype, "cssClass", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SplitButton.prototype, "disabled", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SplitButton.prototype, "iconCss", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)("Left")
    ], SplitButton.prototype, "iconPosition", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SplitButton.prototype, "createPopupOnClick", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Collection)([], (0, $22807a4aeae41444$export$6d08773d2e66f8f2))
    ], SplitButton.prototype, "items", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Property)("")
    ], SplitButton.prototype, "target", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "beforeItemRender", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "beforeOpen", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "beforeClose", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "click", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "close", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "open", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "select", void 0);
    $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.Event)()
    ], SplitButton.prototype, "created", void 0);
    SplitButton = $03bd16efb3eac670$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], SplitButton);
    return SplitButton;
}((0, $2f39802b01f31b03$export$e200d4ca2624495d));
/**
 * Deferred is used to handle asynchronous operation.
 */ var $03bd16efb3eac670$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        /**
         * Promise is an object that represents a value that may not be available yet, but will be resolved at some point in the future.
         */ this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        /**
         * Defines the callback function triggers when the Deferred object is rejected.
         */ this.catch = this.promise.catch.bind(this.promise);
        /**
         * Defines the callback function triggers when the Deferred object is resolved.
         */ this.then = this.promise.then.bind(this.promise);
    }
    return Deferred;
}();



var $2vAqh = parcelRequire("2vAqh");
var $49u5W = parcelRequire("49u5W");


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $c2qqN = parcelRequire("c2qqN");
var $bWDaN = parcelRequire("bWDaN");
var $e7i2H = parcelRequire("e7i2H");
var $3P3ke = parcelRequire("3P3ke");

var $2vAqh = parcelRequire("2vAqh");
var $f45acda29d40e6a4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f45acda29d40e6a4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the ticks data of the Slider.
 */ var $f45acda29d40e6a4$export$f34b233da822b7a4 = /** @class */ function(_super) {
    $f45acda29d40e6a4$var$__extends(TicksData, _super);
    function TicksData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], TicksData.prototype, "placement", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], TicksData.prototype, "largeStep", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], TicksData.prototype, "smallStep", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TicksData.prototype, "showSmallTicks", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TicksData.prototype, "format", void 0);
    return TicksData;
}((0, $3fcxu.ChildProperty));
/**
 * It illustrates the color track data in slider.
 * {% codeBlock src='slider/colorrange/index.md' %}{% endcodeBlock %}
 */ var $f45acda29d40e6a4$export$76ce685e0cc0f924 = /** @class */ function(_super) {
    $f45acda29d40e6a4$var$__extends(ColorRangeData, _super);
    function ColorRangeData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ColorRangeData.prototype, "color", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ColorRangeData.prototype, "start", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ColorRangeData.prototype, "end", void 0);
    return ColorRangeData;
}((0, $3fcxu.ChildProperty));
/**
 * It illustrates the limit data in slider.
 * {% codeBlock src='slider/limits/index.md' %}{% endcodeBlock %}
 */ var $f45acda29d40e6a4$export$9989835030ecd317 = /** @class */ function(_super) {
    $f45acda29d40e6a4$var$__extends(LimitData, _super);
    function LimitData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LimitData.prototype, "enabled", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LimitData.prototype, "minStart", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LimitData.prototype, "minEnd", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LimitData.prototype, "maxStart", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], LimitData.prototype, "maxEnd", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LimitData.prototype, "startHandleFixed", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], LimitData.prototype, "endHandleFixed", void 0);
    return LimitData;
}((0, $3fcxu.ChildProperty));
/**
 * It illustrates the tooltip data in slider.
 */ var $f45acda29d40e6a4$export$a3fed9f45e6bfeec = /** @class */ function(_super) {
    $f45acda29d40e6a4$var$__extends(TooltipData, _super);
    function TooltipData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], TooltipData.prototype, "cssClass", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("Before")
    ], TooltipData.prototype, "placement", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("Focus")
    ], TooltipData.prototype, "showOn", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], TooltipData.prototype, "isVisible", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TooltipData.prototype, "format", void 0);
    return TooltipData;
}((0, $3fcxu.ChildProperty));
var $f45acda29d40e6a4$var$bootstrapTooltipOffset = 6;
var $f45acda29d40e6a4$var$bootstrap4TooltipOffset = 3;
var $f45acda29d40e6a4$var$classNames = {
    root: "e-slider",
    rtl: "e-rtl",
    sliderHiddenInput: "e-slider-input",
    controlWrapper: "e-control-wrapper",
    sliderHandle: "e-handle",
    rangeBar: "e-range",
    sliderButton: "e-slider-button",
    firstButton: "e-first-button",
    secondButton: "e-second-button",
    scale: "e-scale",
    tick: "e-tick",
    large: "e-large",
    tickValue: "e-tick-value",
    sliderTooltip: "e-slider-tooltip",
    sliderHover: "e-slider-hover",
    sliderFirstHandle: "e-handle-first",
    sliderSecondHandle: "e-handle-second",
    sliderDisabled: "e-disabled",
    sliderContainer: "e-slider-container",
    horizontalTooltipBefore: "e-slider-horizontal-before",
    horizontalTooltipAfter: "e-slider-horizontal-after",
    verticalTooltipBefore: "e-slider-vertical-before",
    verticalTooltipAfter: "e-slider-vertical-after",
    materialTooltip: "e-material-tooltip",
    materialTooltipOpen: "e-material-tooltip-open",
    materialTooltipActive: "e-tooltip-active",
    materialSlider: "e-material-slider",
    sliderTrack: "e-slider-track",
    sliderHorizantalColor: "e-slider-horizantal-color",
    sliderVerticalColor: "e-slider-vertical-color",
    sliderHandleFocused: "e-handle-focused",
    verticalSlider: "e-vertical",
    horizontalSlider: "e-horizontal",
    sliderHandleStart: "e-handle-start",
    sliderTooltipStart: "e-material-tooltip-start",
    sliderTabHandle: "e-tab-handle",
    sliderButtonIcon: "e-button-icon",
    sliderSmallSize: "e-small-size",
    sliderTickPosition: "e-tick-pos",
    sliderFirstTick: "e-first-tick",
    sliderLastTick: "e-last-tick",
    sliderButtonClass: "e-slider-btn",
    sliderTooltipWrapper: "e-tooltip-wrap",
    sliderTabTrack: "e-tab-track",
    sliderTabRange: "e-tab-range",
    sliderActiveHandle: "e-handle-active",
    sliderMaterialHandle: "e-material-handle",
    sliderMaterialRange: "e-material-range",
    sliderMaterialDefault: "e-material-default",
    materialTooltipShow: "e-material-tooltip-show",
    materialTooltipHide: "e-material-tooltip-hide",
    readonly: "e-read-only",
    limits: "e-limits",
    limitBarDefault: "e-limit-bar",
    limitBarFirst: "e-limit-first",
    limitBarSecond: "e-limit-second",
    dragHorizontal: "e-drag-horizontal",
    dragVertical: "e-drag-vertical"
};
/**
 * The Slider component allows the user to select a value or range
 * of values in-between a min and max range, by dragging the handle over the slider bar.
 * ```html
 * <div id='slider'></div>
 * ```
 * ```typescript
 * <script>
 *   var sliderObj = new Slider({ value: 10 });
 *   sliderObj.appendTo('#slider');
 * </script>
 * ```
 */ var $f45acda29d40e6a4$export$472062a354075cee = /** @class */ function(_super) {
    $f45acda29d40e6a4$var$__extends(Slider, _super);
    function Slider(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.horDir = "left";
        _this.verDir = "bottom";
        _this.transition = {
            handle: "left .4s cubic-bezier(.25, .8, .25, 1), right .4s cubic-bezier(.25, .8, .25, 1), top .4s cubic-bezier(.25, .8, .25, 1) , bottom .4s cubic-bezier(.25, .8, .25, 1)",
            rangeBar: "all .4s cubic-bezier(.25, .8, .25, 1)"
        };
        _this.transitionOnMaterialTooltip = {
            handle: "left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, top 1ms ease-out",
            rangeBar: "left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, width 1ms ease-out, height 1ms ease-out"
        };
        _this.scaleTransform = "transform .4s cubic-bezier(.25, .8, .25, 1)";
        _this.customAriaText = null;
        _this.drag = true;
        _this.isDragComplete = false;
        _this.initialTooltip = true;
        return _this;
    }
    Slider.prototype.preRender = function() {
        var localeText = {
            incrementTitle: "Increase",
            decrementTitle: "Decrease"
        };
        this.l10n = new (0, $e7i2H.L10n)("slider", localeText, this.locale);
        this.isElementFocused = false;
        this.tickElementCollection = [];
        this.tooltipFormatInfo = {};
        this.ticksFormatInfo = {};
        this.initCultureInfo();
        this.initCultureFunc();
        this.formChecker();
    };
    Slider.prototype.formChecker = function() {
        var formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (formElement) {
            this.isForm = true;
            // this condition needs to be checked, if the slider is going to be refreshed by `refresh()`
            // then we need to revert the slider `value` back to `formResetValue` to preserve the initial value
            if (!(0, $3EnZW.isNullOrUndefined)(this.formResetValue)) this.setProperties({
                "value": this.formResetValue
            }, true);
            this.formResetValue = this.value;
            if (this.type === "Range" && ((0, $3EnZW.isNullOrUndefined)(this.formResetValue) || typeof this.formResetValue !== "object")) this.formResetValue = [
                parseFloat((0, $3EnZW.formatUnit)(this.min)),
                parseFloat((0, $3EnZW.formatUnit)(this.max))
            ];
            else if ((0, $3EnZW.isNullOrUndefined)(this.formResetValue)) this.formResetValue = parseFloat((0, $3EnZW.formatUnit)(this.min));
            this.formElement = formElement;
        } else this.isForm = false;
    };
    Slider.prototype.initCultureFunc = function() {
        this.internationalization = new (0, $bWDaN.Internationalization)(this.locale);
    };
    Slider.prototype.initCultureInfo = function() {
        this.tooltipFormatInfo.format = !(0, $3EnZW.isNullOrUndefined)(this.tooltip.format) ? this.tooltip.format : null;
        this.ticksFormatInfo.format = !(0, $3EnZW.isNullOrUndefined)(this.ticks.format) ? this.ticks.format : null;
    };
    Slider.prototype.formatString = function(value, formatInfo) {
        var formatValue = null;
        var formatString = null;
        if (value || value === 0) {
            formatValue = this.formatNumber(value);
            var numberOfDecimals = this.numberOfDecimals(value);
            formatString = this.internationalization.getNumberFormat(formatInfo)(this.makeRoundNumber(value, numberOfDecimals));
        }
        return {
            elementVal: formatValue,
            formatString: formatString
        };
    };
    Slider.prototype.formatNumber = function(value) {
        var numberOfDecimals = this.numberOfDecimals(value);
        return this.internationalization.getNumberFormat({
            maximumFractionDigits: numberOfDecimals,
            minimumFractionDigits: numberOfDecimals,
            useGrouping: false
        })(value);
    };
    Slider.prototype.numberOfDecimals = function(value) {
        var decimalPart = value.toString().split(".")[1];
        var numberOfDecimals = !decimalPart || !decimalPart.length ? 0 : decimalPart.length;
        return numberOfDecimals;
    };
    Slider.prototype.makeRoundNumber = function(value, precision) {
        var decimals = precision || 0;
        return Number(value.toFixed(decimals));
    };
    Slider.prototype.fractionalToInteger = function(value) {
        value = this.numberOfDecimals(value) === 0 ? Number(value).toFixed(this.noOfDecimals) : value;
        var tens = 1;
        for(var i = 0; i < this.noOfDecimals; i++)tens *= 10;
        value = Number((value * tens).toFixed(0));
        return value;
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */ Slider.prototype.render = function() {
        var _this = this;
        this.initialize();
        this.initRender();
        this.wireEvents();
        this.setZindex();
        this.renderComplete();
        if (this.element.tagName === "EJS-SLIDER") {
            if (this.getTheme(this.sliderContainer) === "none") setTimeout(function() {
                _this.refresh();
            }, 0);
        }
    };
    Slider.prototype.initialize = function() {
        (0, $4ZDHT.addClass)([
            this.element
        ], $f45acda29d40e6a4$var$classNames.root);
        this.setCSSClass();
    };
    Slider.prototype.setElementWidth = function(width) {
        if (!(0, $3EnZW.isNullOrUndefined)(width) && !(0, $3EnZW.isNullOrUndefined)(this.sliderContainer)) {
            if (typeof width === "number") this.sliderContainer.style.width = (0, $3EnZW.formatUnit)(width);
            else if (typeof width === "string") this.sliderContainer.style.width = width.match(/px|%|em/) ? width : (0, $3EnZW.formatUnit)(width);
        }
    };
    Slider.prototype.setCSSClass = function(oldCSSClass) {
        if (oldCSSClass) (0, $4ZDHT.removeClass)([
            this.element
        ], oldCSSClass.split(" "));
        if (this.cssClass) (0, $4ZDHT.addClass)([
            this.element
        ], this.cssClass.split(" "));
    };
    Slider.prototype.setEnabled = function() {
        if (!this.enabled) {
            (0, $4ZDHT.addClass)([
                this.sliderContainer
            ], [
                $f45acda29d40e6a4$var$classNames.sliderDisabled
            ]);
            if (this.tooltip.isVisible && this.tooltipElement && this.tooltip.showOn === "Always") this.tooltipElement.classList.add($f45acda29d40e6a4$var$classNames.sliderDisabled);
            this.unwireEvents();
        } else {
            (0, $4ZDHT.removeClass)([
                this.sliderContainer
            ], [
                $f45acda29d40e6a4$var$classNames.sliderDisabled
            ]);
            if (this.tooltip.isVisible && this.tooltipElement && this.tooltip.showOn === "Always") this.tooltipElement.classList.remove($f45acda29d40e6a4$var$classNames.sliderDisabled);
            this.wireEvents();
        }
    };
    Slider.prototype.getTheme = function(container) {
        var theme = window.getComputedStyle(container, ":after").getPropertyValue("content");
        return theme.replace(/['"]+/g, "");
    };
    /**
     * Initialize the rendering
     *
     * @returns {void}
     * @private
     */ Slider.prototype.initRender = function() {
        this.sliderContainer = this.createElement("div", {
            className: $f45acda29d40e6a4$var$classNames.sliderContainer + " " + $f45acda29d40e6a4$var$classNames.controlWrapper
        });
        this.element.parentNode.insertBefore(this.sliderContainer, this.element);
        this.sliderContainer.appendChild(this.element);
        this.sliderTrack = this.createElement("div", {
            className: $f45acda29d40e6a4$var$classNames.sliderTrack
        });
        this.element.appendChild(this.sliderTrack);
        this.setElementWidth(this.width);
        this.element.tabIndex = -1;
        this.getThemeInitialization();
        this.setHandler();
        this.createRangeBar();
        if (this.limits.enabled) this.createLimitBar();
        this.setOrientClass();
        this.hiddenInput = this.createElement("input", {
            attrs: {
                type: "hidden",
                value: (0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.isNullOrUndefined)(this.min) ? "0" : this.min.toString() : this.value.toString(),
                name: this.element.getAttribute("name") || this.element.getAttribute("id") || "_" + (Math.random() * 1000).toFixed(0) + "slider",
                class: $f45acda29d40e6a4$var$classNames.sliderHiddenInput
            }
        });
        this.hiddenInput.tabIndex = -1;
        this.sliderContainer.appendChild(this.hiddenInput);
        if (this.showButtons) this.setButtons();
        this.setEnableRTL();
        if (this.type === "Range") this.rangeValueUpdate();
        else this.value = (0, $3EnZW.isNullOrUndefined)(this.value) ? (0, $3EnZW.isNullOrUndefined)(this.min) ? 0 : parseFloat((0, $3EnZW.formatUnit)(this.min.toString())) : this.value;
        this.previousVal = this.type !== "Range" ? this.checkHandleValue(parseFloat((0, $3EnZW.formatUnit)(this.value.toString()))) : [
            this.checkHandleValue(parseFloat((0, $3EnZW.formatUnit)(this.value[0].toString()))),
            this.checkHandleValue(parseFloat((0, $3EnZW.formatUnit)(this.value[1].toString())))
        ];
        this.previousChanged = this.previousVal;
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.hasAttribute("name"))) this.element.removeAttribute("name");
        this.setValue();
        if (this.limits.enabled) this.setLimitBar();
        if (this.ticks.placement !== "None") this.renderScale();
        if (this.tooltip.isVisible) this.renderTooltip();
        if (!this.enabled) (0, $4ZDHT.addClass)([
            this.sliderContainer
        ], [
            $f45acda29d40e6a4$var$classNames.sliderDisabled
        ]);
        else (0, $4ZDHT.removeClass)([
            this.sliderContainer
        ], [
            $f45acda29d40e6a4$var$classNames.sliderDisabled
        ]);
        if (this.readonly) (0, $4ZDHT.addClass)([
            this.sliderContainer
        ], [
            $f45acda29d40e6a4$var$classNames.readonly
        ]);
        else (0, $4ZDHT.removeClass)([
            this.sliderContainer
        ], [
            $f45acda29d40e6a4$var$classNames.readonly
        ]);
    };
    Slider.prototype.getThemeInitialization = function() {
        this.isMaterial = this.getTheme(this.sliderContainer) === "material" || this.getTheme(this.sliderContainer) === "material-dark";
        this.isMaterial3 = this.getTheme(this.sliderContainer) === "Material3" || this.getTheme(this.sliderContainer) === "Material3-dark";
        this.isBootstrap = this.getTheme(this.sliderContainer) === "bootstrap" || this.getTheme(this.sliderContainer) === "bootstrap-dark";
        this.isBootstrap4 = this.getTheme(this.sliderContainer) === "bootstrap4";
        this.isTailwind = this.getTheme(this.sliderContainer) === "tailwind" || this.getTheme(this.sliderContainer) === "tailwind-dark";
        this.isBootstrap5 = this.getTheme(this.sliderContainer) === "bootstrap5";
        this.isFluent = this.getTheme(this.sliderContainer) === "FluentUI";
        this.isFluent2 = this.getTheme(this.sliderContainer) === "fluent2";
        this.isBootstrap5Dot3 = this.getTheme(this.sliderContainer) === "bootstrap5.3";
        this.isMaterialTooltip = (this.isMaterial || this.isMaterial3) && this.type !== "Range" && this.tooltip.isVisible;
    };
    Slider.prototype.createRangeBar = function() {
        if (this.type !== "Default") {
            this.rangeBar = this.createElement("div", {
                attrs: {
                    class: $f45acda29d40e6a4$var$classNames.rangeBar
                }
            });
            this.element.appendChild(this.rangeBar);
            if (this.drag && this.type === "Range") {
                if (this.orientation === "Horizontal") this.rangeBar.classList.add($f45acda29d40e6a4$var$classNames.dragHorizontal);
                else this.rangeBar.classList.add($f45acda29d40e6a4$var$classNames.dragVertical);
            }
        }
    };
    Slider.prototype.createLimitBar = function() {
        var firstElementClassName = this.type !== "Range" ? $f45acda29d40e6a4$var$classNames.limitBarDefault : $f45acda29d40e6a4$var$classNames.limitBarFirst;
        firstElementClassName += " " + $f45acda29d40e6a4$var$classNames.limits;
        this.limitBarFirst = this.createElement("div", {
            attrs: {
                class: firstElementClassName
            }
        });
        this.element.appendChild(this.limitBarFirst);
        if (this.type === "Range") {
            this.limitBarSecond = this.createElement("div", {
                attrs: {
                    class: $f45acda29d40e6a4$var$classNames.limitBarSecond + " " + $f45acda29d40e6a4$var$classNames.limits
                }
            });
            this.element.appendChild(this.limitBarSecond);
        }
    };
    Slider.prototype.setOrientClass = function() {
        if (this.orientation !== "Vertical") {
            this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.verticalSlider);
            this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.horizontalSlider);
            this.firstHandle.setAttribute("aria-orientation", "horizontal");
            if (this.type === "Range") this.secondHandle.setAttribute("aria-orientation", "horizontal");
        } else {
            this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.horizontalSlider);
            this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.verticalSlider);
            this.firstHandle.setAttribute("aria-orientation", "vertical");
            if (this.type === "Range") this.secondHandle.setAttribute("aria-orientation", "vertical");
        }
    };
    Slider.prototype.setAriaAttributes = function(element) {
        var _this = this;
        var min = this.min;
        var max = this.max;
        if (!(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0) {
            min = this.customValues[0];
            max = this.customValues[this.customValues.length - 1];
        }
        if (this.type !== "Range") (0, $4ZDHT.attributes)(element, {
            "aria-valuemin": (0, $3EnZW.isNullOrUndefined)(min) ? "0" : min.toString(),
            "aria-valuemax": (0, $3EnZW.isNullOrUndefined)(max) ? "100" : max.toString()
        });
        else {
            var range = !(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0 ? [
                [
                    min.toString(),
                    this.customValues[this.value[1]].toString()
                ],
                [
                    this.customValues[this.value[0]].toString(),
                    max.toString()
                ]
            ] : [
                [
                    min.toString(),
                    this.value[1].toString()
                ],
                [
                    this.value[0].toString(),
                    max.toString()
                ]
            ];
            range.forEach(function(range, index) {
                var element = index === 0 ? _this.firstHandle : _this.secondHandle;
                if (element) (0, $4ZDHT.attributes)(element, {
                    "aria-valuemin": range[0],
                    "aria-valuemax": range[1]
                });
            });
        }
    };
    Slider.prototype.createSecondHandle = function() {
        this.secondHandle = this.createElement("div", {
            attrs: {
                class: $f45acda29d40e6a4$var$classNames.sliderHandle,
                "role": "slider",
                tabIndex: "0",
                "aria-label": "slider"
            }
        });
        this.secondHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderSecondHandle);
        this.element.appendChild(this.secondHandle);
    };
    Slider.prototype.createFirstHandle = function() {
        this.firstHandle = this.createElement("div", {
            attrs: {
                class: $f45acda29d40e6a4$var$classNames.sliderHandle,
                "role": "slider",
                tabIndex: "0",
                "aria-label": "slider"
            }
        });
        this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderFirstHandle);
        this.element.appendChild(this.firstHandle);
        if (this.isMaterialTooltip) {
            this.materialHandle = this.createElement("div", {
                attrs: {
                    class: $f45acda29d40e6a4$var$classNames.sliderHandle + " " + $f45acda29d40e6a4$var$classNames.sliderMaterialHandle
                }
            });
            this.element.appendChild(this.materialHandle);
        }
    };
    Slider.prototype.wireFirstHandleEvt = function(destroy) {
        if (!destroy) {
            (0, $aqzbR.EventHandler).add(this.firstHandle, "mousedown touchstart", this.handleFocus, this);
            (0, $aqzbR.EventHandler).add(this.firstHandle, "transitionend", this.transitionEnd, this);
            (0, $aqzbR.EventHandler).add(this.firstHandle, "mouseenter touchenter", this.handleOver, this);
            (0, $aqzbR.EventHandler).add(this.firstHandle, "mouseleave touchend", this.handleLeave, this);
        } else {
            (0, $aqzbR.EventHandler).remove(this.firstHandle, "mousedown touchstart", this.handleFocus);
            (0, $aqzbR.EventHandler).remove(this.firstHandle, "transitionend", this.transitionEnd);
            (0, $aqzbR.EventHandler).remove(this.firstHandle, "mouseenter touchenter", this.handleOver);
            (0, $aqzbR.EventHandler).remove(this.firstHandle, "mouseleave touchend", this.handleLeave);
        }
    };
    Slider.prototype.wireSecondHandleEvt = function(destroy) {
        if (!destroy) {
            (0, $aqzbR.EventHandler).add(this.secondHandle, "mousedown touchstart", this.handleFocus, this);
            (0, $aqzbR.EventHandler).add(this.secondHandle, "transitionend", this.transitionEnd, this);
            (0, $aqzbR.EventHandler).add(this.secondHandle, "mouseenter touchenter", this.handleOver, this);
            (0, $aqzbR.EventHandler).add(this.secondHandle, "mouseleave touchend", this.handleLeave, this);
        } else {
            (0, $aqzbR.EventHandler).remove(this.secondHandle, "mousedown touchstart", this.handleFocus);
            (0, $aqzbR.EventHandler).remove(this.secondHandle, "transitionend", this.transitionEnd);
            (0, $aqzbR.EventHandler).remove(this.secondHandle, "mouseenter touchenter", this.handleOver);
            (0, $aqzbR.EventHandler).remove(this.secondHandle, "mouseleave touchend", this.handleLeave);
        }
    };
    Slider.prototype.handleStart = function() {
        if (this.type !== "Range") {
            this.firstHandle.classList[this.handlePos1 === 0 ? "add" : "remove"]($f45acda29d40e6a4$var$classNames.sliderHandleStart);
            if (this.isMaterialTooltip) {
                this.materialHandle.classList[this.handlePos1 === 0 ? "add" : "remove"]($f45acda29d40e6a4$var$classNames.sliderHandleStart);
                if (this.tooltipElement) this.tooltipElement.classList[this.handlePos1 === 0 ? "add" : "remove"]($f45acda29d40e6a4$var$classNames.sliderTooltipStart);
            }
        }
    };
    Slider.prototype.transitionEnd = function(e) {
        if (e.propertyName !== "transform") {
            this.handleStart();
            if (!this.enableAnimation) this.getHandle().style.transition = "none";
            if (this.type !== "Default") this.rangeBar.style.transition = "none";
            if ((this.isMaterial || this.isMaterial3) && this.tooltip.isVisible && this.type === "Default") this.tooltipElement.style.transition = this.transition.handle;
            this.tooltipToggle(this.getHandle());
            this.closeTooltip();
        }
    };
    Slider.prototype.handleFocusOut = function() {
        if (this.firstHandle.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandleFocused)) this.firstHandle.classList.remove($f45acda29d40e6a4$var$classNames.sliderHandleFocused);
        if (this.type === "Range") {
            if (this.secondHandle.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandleFocused)) this.secondHandle.classList.remove($f45acda29d40e6a4$var$classNames.sliderHandleFocused);
        }
    };
    Slider.prototype.handleFocus = function(e) {
        this.focusSliderElement();
        this.sliderBarClick(e);
        if (e.currentTarget === this.firstHandle) {
            this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderHandleFocused);
            this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderTabHandle);
        } else {
            this.secondHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderHandleFocused);
            this.secondHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderTabHandle);
        }
        (0, $aqzbR.EventHandler).add(document, "mousemove touchmove", this.sliderBarMove, this);
        (0, $aqzbR.EventHandler).add(document, "mouseup touchend", this.sliderBarUp, this);
    };
    Slider.prototype.handleOver = function(e) {
        if (this.tooltip.isVisible && this.tooltip.showOn === "Hover") this.tooltipToggle(e.currentTarget);
        if (this.type === "Default") this.tooltipToggle(this.getHandle());
    };
    Slider.prototype.handleLeave = function(e) {
        if (this.tooltip.isVisible && this.tooltip.showOn === "Hover" && !e.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandleFocused) && !e.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.closeTooltip();
    };
    Slider.prototype.setHandler = function() {
        this.createFirstHandle();
        if (this.type === "Range") this.createSecondHandle();
    };
    Slider.prototype.setEnableRTL = function() {
        if (this.enableRtl && this.orientation !== "Vertical") (0, $4ZDHT.addClass)([
            this.sliderContainer
        ], $f45acda29d40e6a4$var$classNames.rtl);
        else (0, $4ZDHT.removeClass)([
            this.sliderContainer
        ], $f45acda29d40e6a4$var$classNames.rtl);
        var preDir = this.orientation !== "Vertical" ? this.horDir : this.verDir;
        if (this.enableRtl) {
            this.horDir = "right";
            this.verDir = "bottom";
        } else {
            this.horDir = "left";
            this.verDir = "bottom";
        }
        var currDir = this.orientation !== "Vertical" ? this.horDir : this.verDir;
        if (preDir !== currDir) {
            if (this.orientation === "Horizontal") {
                (0, $4ZDHT.setStyleAttribute)(this.firstHandle, {
                    "right": "",
                    "left": "auto"
                });
                if (this.type === "Range") (0, $4ZDHT.setStyleAttribute)(this.secondHandle, {
                    "top": "",
                    "left": "auto"
                });
            }
        }
        this.setBarColor();
    };
    Slider.prototype.tooltipValue = function() {
        var _this = this;
        var text;
        var args = {
            value: this.value,
            text: ""
        };
        if (this.initialTooltip) {
            this.initialTooltip = false;
            this.setTooltipContent();
            args.text = text = typeof this.tooltipObj.content === "function" ? this.tooltipObj.content() : this.tooltipObj.content;
            this.trigger("tooltipChange", args, function(observedArgs) {
                _this.addTooltipClass(observedArgs.text);
                if (text !== observedArgs.text) {
                    _this.customAriaText = observedArgs.text;
                    if (_this.enableHtmlSanitizer) observedArgs.text = (0, $3P3ke.SanitizeHtmlHelper).sanitize(observedArgs.text.toString());
                    else observedArgs.text = observedArgs.text.toString();
                    var contentTemp = function() {
                        return observedArgs.text;
                    };
                    _this.tooltipObj.content = (0, $c2qqN.initializeCSPTemplate)(contentTemp);
                    _this.setAriaAttrValue(_this.firstHandle);
                    if (_this.type === "Range") _this.setAriaAttrValue(_this.secondHandle);
                }
            });
            if (this.isMaterialTooltip) this.setPreviousVal("change", this.value);
        }
    };
    Slider.prototype.setTooltipContent = function() {
        var content = this.formatContent(this.tooltipFormatInfo, false);
        var contentTemp = function() {
            return content;
        };
        this.tooltipObj.content = (0, $c2qqN.initializeCSPTemplate)(contentTemp);
    };
    Slider.prototype.formatContent = function(formatInfo, ariaContent) {
        var content = "";
        var handle1 = this.handleVal1;
        var handle2 = this.handleVal2;
        if (!(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0) {
            handle1 = this.customValues[this.handleVal1];
            handle2 = this.customValues[this.handleVal2];
        }
        if (!ariaContent) {
            if (this.type === "Range") {
                if (this.enableRtl && this.orientation !== "Vertical") content = !(0, $3EnZW.isNullOrUndefined)(formatInfo.format) ? this.formatString(handle2, formatInfo).formatString + " - " + this.formatString(handle1, formatInfo).formatString : handle2.toString() + " - " + handle1.toString();
                else content = !(0, $3EnZW.isNullOrUndefined)(formatInfo.format) ? this.formatString(handle1, formatInfo).formatString + " - " + this.formatString(handle2, formatInfo).formatString : handle1.toString() + " - " + handle2.toString();
            } else if (!(0, $3EnZW.isNullOrUndefined)(handle1)) content = !(0, $3EnZW.isNullOrUndefined)(formatInfo.format) ? this.formatString(handle1, formatInfo).formatString : handle1.toString();
            return content;
        } else {
            if (this.type === "Range") {
                if (this.enableRtl && this.orientation !== "Vertical") content = !(0, $3EnZW.isNullOrUndefined)(this.tooltip) && !(0, $3EnZW.isNullOrUndefined)(this.tooltip.format) ? this.formatString(handle2, formatInfo).elementVal + " - " + this.formatString(handle1, formatInfo).elementVal : handle2.toString() + " - " + handle1.toString();
                else content = !(0, $3EnZW.isNullOrUndefined)(this.tooltip) && !(0, $3EnZW.isNullOrUndefined)(this.tooltip.format) ? this.formatString(handle1, formatInfo).elementVal + " - " + this.formatString(handle2, formatInfo).elementVal : handle1.toString() + " - " + handle2.toString();
            } else if (!(0, $3EnZW.isNullOrUndefined)(handle1)) content = !(0, $3EnZW.isNullOrUndefined)(this.tooltip) && !(0, $3EnZW.isNullOrUndefined)(this.tooltip.format) ? this.formatString(handle1, formatInfo).elementVal : handle1.toString();
            return content;
        }
    };
    Slider.prototype.addTooltipClass = function(content) {
        if (this.isMaterialTooltip) {
            var count = content.toString().length;
            if (!this.tooltipElement) {
                var cssClass = count > 4 ? $f45acda29d40e6a4$var$classNames.sliderMaterialRange : $f45acda29d40e6a4$var$classNames.sliderMaterialDefault;
                this.tooltipObj.cssClass = $f45acda29d40e6a4$var$classNames.sliderTooltip + " " + cssClass;
            } else {
                var cssClass = count > 4 ? {
                    oldCss: $f45acda29d40e6a4$var$classNames.sliderMaterialDefault,
                    newCss: $f45acda29d40e6a4$var$classNames.sliderMaterialRange
                } : {
                    oldCss: $f45acda29d40e6a4$var$classNames.sliderMaterialRange,
                    newCss: $f45acda29d40e6a4$var$classNames.sliderMaterialDefault
                };
                this.tooltipElement.classList.remove(cssClass.oldCss);
                if (!this.tooltipElement.classList.contains(cssClass.newCss)) {
                    this.tooltipElement.classList.add(cssClass.newCss);
                    this.tooltipElement.style.transform = count > 4 ? "scale(1)" : this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
                }
            }
        }
    };
    Slider.prototype.tooltipPlacement = function() {
        return this.orientation === "Horizontal" ? this.tooltip.placement === "Before" ? "TopCenter" : "BottomCenter" : this.tooltip.placement === "Before" ? "LeftCenter" : "RightCenter";
    };
    Slider.prototype.tooltipBeforeOpen = function(args) {
        this.tooltipElement = args.element;
        if (this.tooltip.cssClass) (0, $4ZDHT.addClass)([
            this.tooltipElement
        ], this.tooltip.cssClass.split(" ").filter(function(css) {
            return css;
        }));
        args.target.removeAttribute("aria-describedby");
        if (this.isMaterialTooltip) {
            this.tooltipElement.firstElementChild.classList.add($f45acda29d40e6a4$var$classNames.materialTooltipHide);
            this.handleStart();
            this.setTooltipTransform();
        }
    };
    Slider.prototype.tooltipCollision = function(position) {
        if (this.isBootstrap || this.isBootstrap4 || (this.isMaterial || this.isMaterial3) && !this.isMaterialTooltip) {
            var tooltipOffsetValue = this.isBootstrap4 ? $f45acda29d40e6a4$var$bootstrap4TooltipOffset : $f45acda29d40e6a4$var$bootstrapTooltipOffset;
            switch(position){
                case "TopCenter":
                    this.tooltipObj.setProperties({
                        "offsetY": -tooltipOffsetValue
                    }, false);
                    break;
                case "BottomCenter":
                    this.tooltipObj.setProperties({
                        "offsetY": tooltipOffsetValue
                    }, false);
                    break;
                case "LeftCenter":
                    this.tooltipObj.setProperties({
                        "offsetX": -tooltipOffsetValue
                    }, false);
                    break;
                case "RightCenter":
                    this.tooltipObj.setProperties({
                        "offsetX": tooltipOffsetValue
                    }, false);
                    break;
            }
        }
    };
    Slider.prototype.materialTooltipEventCallBack = function(event) {
        this.sliderBarClick(event);
        (0, $aqzbR.EventHandler).add(document, "mousemove touchmove", this.sliderBarMove, this);
        (0, $aqzbR.EventHandler).add(document, "mouseup touchend", this.sliderBarUp, this);
    };
    Slider.prototype.wireMaterialTooltipEvent = function(destroy) {
        if (this.isMaterialTooltip) {
            if (!destroy) (0, $aqzbR.EventHandler).add(this.tooltipElement, "mousedown touchstart", this.materialTooltipEventCallBack, this);
            else (0, $aqzbR.EventHandler).remove(this.tooltipElement, "mousedown touchstart", this.materialTooltipEventCallBack);
        }
    };
    Slider.prototype.tooltipPositionCalculation = function(position) {
        var cssClass;
        switch(position){
            case "TopCenter":
                cssClass = $f45acda29d40e6a4$var$classNames.horizontalTooltipBefore;
                break;
            case "BottomCenter":
                cssClass = $f45acda29d40e6a4$var$classNames.horizontalTooltipAfter;
                break;
            case "LeftCenter":
                cssClass = $f45acda29d40e6a4$var$classNames.verticalTooltipBefore;
                break;
            case "RightCenter":
                cssClass = $f45acda29d40e6a4$var$classNames.verticalTooltipAfter;
                break;
        }
        return cssClass;
    };
    Slider.prototype.getTooltipTransformProperties = function(className) {
        var transformProperties;
        if (this.tooltipElement) {
            var position = this.orientation === "Horizontal" ? this.tooltipElement.clientHeight + 14 - this.tooltipElement.clientHeight / 2 : this.tooltipElement.clientWidth + 14 - this.tooltipElement.clientWidth / 2;
            transformProperties = this.orientation === "Horizontal" ? className === $f45acda29d40e6a4$var$classNames.horizontalTooltipBefore ? {
                rotate: "rotate(45deg)",
                translate: "translateY(" + position + "px)"
            } : {
                rotate: "rotate(225deg)",
                translate: "translateY(" + -position + "px)"
            } : className === $f45acda29d40e6a4$var$classNames.verticalTooltipBefore ? {
                rotate: "rotate(-45deg)",
                translate: "translateX(" + position + "px)"
            } : {
                rotate: "rotate(-225deg)",
                translate: "translateX(" + -position + "px)"
            };
        }
        return transformProperties;
    };
    Slider.prototype.openMaterialTooltip = function() {
        var _this = this;
        if (this.isMaterialTooltip) {
            this.refreshTooltip(this.firstHandle);
            var tooltipContentElement = this.tooltipElement.firstElementChild;
            tooltipContentElement.classList.remove($f45acda29d40e6a4$var$classNames.materialTooltipHide);
            tooltipContentElement.classList.add($f45acda29d40e6a4$var$classNames.materialTooltipShow);
            this.firstHandle.style.cursor = "default";
            this.tooltipElement.style.transition = this.scaleTransform;
            this.tooltipElement.classList.add($f45acda29d40e6a4$var$classNames.materialTooltipOpen);
            this.materialHandle.style.transform = "scale(0)";
            if (tooltipContentElement.innerText.length > 4) this.tooltipElement.style.transform = "scale(1)";
            else this.tooltipElement.style.transform = this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
            if (this.type === "Default") setTimeout(function() {
                if (_this.tooltipElement) _this.tooltipElement.style.transition = _this.transition.handle;
            }, 2500);
            else setTimeout(function() {
                if (_this.tooltipElement) _this.tooltipElement.style.transition = "none";
            }, 2500);
        }
    };
    Slider.prototype.closeMaterialTooltip = function() {
        var _this = this;
        if (this.isMaterialTooltip) {
            var tooltipContentElement = this.tooltipElement.firstElementChild;
            this.tooltipElement.style.transition = this.scaleTransform;
            tooltipContentElement.classList.remove($f45acda29d40e6a4$var$classNames.materialTooltipShow);
            tooltipContentElement.classList.add($f45acda29d40e6a4$var$classNames.materialTooltipHide);
            this.firstHandle.style.cursor = "-webkit-grab";
            this.firstHandle.style.cursor = "grab";
            if (this.materialHandle) this.materialHandle.style.transform = "scale(1)";
            this.tooltipElement.classList.remove($f45acda29d40e6a4$var$classNames.materialTooltipOpen);
            this.setTooltipTransform();
            this.tooltipTarget = undefined;
            setTimeout(function() {
                if (_this.tooltipElement) _this.tooltipElement.style.transition = "none";
            }, 2500);
        }
    };
    Slider.prototype.checkTooltipPosition = function(args) {
        var tooltipClass = this.tooltipPositionCalculation(args.collidedPosition);
        if (this.tooltipCollidedPosition === undefined || this.tooltipCollidedPosition !== args.collidedPosition || !args.element.classList.contains(tooltipClass)) {
            if (this.isMaterialTooltip) {
                if (tooltipClass !== undefined) {
                    args.element.classList.remove(this.previousTooltipClass);
                    args.element.classList.add(tooltipClass);
                    this.previousTooltipClass = tooltipClass;
                }
                if (args.element.style.transform && args.element.classList.contains($f45acda29d40e6a4$var$classNames.materialTooltipOpen) && args.element.firstElementChild.innerText.length <= 4) args.element.style.transform = this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
            }
            this.tooltipCollidedPosition = args.collidedPosition;
        }
        if (this.isMaterialTooltip && this.tooltipElement && this.tooltipElement.style.transform.indexOf("translate") !== -1) this.setTooltipTransform();
    };
    Slider.prototype.setTooltipTransform = function() {
        var transformProperties = this.getTooltipTransformProperties(this.previousTooltipClass);
        if ((0, $3EnZW.isNullOrUndefined)(this.tooltipElement)) return;
        if (this.tooltipElement.firstElementChild.innerText.length > 4) this.tooltipElement.style.transform = transformProperties.translate + " scale(0.01)";
        else this.tooltipElement.style.transform = transformProperties.translate + " " + transformProperties.rotate + " scale(0.01)";
    };
    Slider.prototype.renderTooltip = function() {
        this.tooltipObj = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)({
            showTipPointer: this.isBootstrap || this.isMaterial || this.isMaterial3 || this.isBootstrap4 || this.isTailwind || this.isBootstrap5 || this.isFluent || this.isFluent2 || this.isBootstrap5Dot3,
            cssClass: $f45acda29d40e6a4$var$classNames.sliderTooltip,
            height: this.isMaterial || this.isMaterial3 ? 30 : "auto",
            animation: {
                open: {
                    effect: "None"
                },
                close: {
                    effect: "FadeOut",
                    duration: 500
                }
            },
            opensOn: "Custom",
            beforeOpen: this.tooltipBeforeOpen.bind(this),
            beforeCollision: this.checkTooltipPosition.bind(this),
            beforeClose: this.tooltipBeforeClose.bind(this),
            enableHtmlSanitizer: this.enableHtmlSanitizer
        });
        this.tooltipObj.appendTo(this.firstHandle);
        this.initializeTooltipProps();
    };
    Slider.prototype.initializeTooltipProps = function() {
        var tooltipShowOn = this.tooltip.showOn === "Auto" ? "Hover" : this.tooltip.showOn;
        this.setProperties({
            tooltip: {
                showOn: tooltipShowOn
            }
        }, true);
        this.tooltipObj.position = this.tooltipPlacement();
        this.tooltipCollision(this.tooltipObj.position);
        [
            this.firstHandle,
            this.rangeBar,
            this.secondHandle
        ].forEach(function(handle) {
            if (!(0, $3EnZW.isNullOrUndefined)(handle)) handle.style.transition = "none";
        });
        if (this.isMaterialTooltip) {
            this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.materialSlider);
            this.tooltipValue();
            this.tooltipObj.animation.close.effect = "None";
            this.tooltipObj.open(this.firstHandle);
        }
    };
    Slider.prototype.tooltipBeforeClose = function() {
        this.tooltipElement = undefined;
        this.tooltipCollidedPosition = undefined;
    };
    Slider.prototype.setButtons = function() {
        this.firstBtn = this.createElement("div", {
            className: $f45acda29d40e6a4$var$classNames.sliderButton + " " + $f45acda29d40e6a4$var$classNames.firstButton
        });
        this.firstBtn.appendChild(this.createElement("span", {
            className: $f45acda29d40e6a4$var$classNames.sliderButtonIcon
        }));
        if (this.isTailwind) this.firstBtn.querySelector("span").classList.add("e-icons");
        this.firstBtn.tabIndex = -1;
        this.secondBtn = this.createElement("div", {
            className: $f45acda29d40e6a4$var$classNames.sliderButton + " " + $f45acda29d40e6a4$var$classNames.secondButton
        });
        this.secondBtn.appendChild(this.createElement("span", {
            className: $f45acda29d40e6a4$var$classNames.sliderButtonIcon
        }));
        if (this.isTailwind) this.secondBtn.querySelector("span").classList.add("e-icons");
        this.secondBtn.tabIndex = -1;
        this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.sliderButtonClass);
        this.sliderContainer.appendChild(this.firstBtn);
        this.sliderContainer.appendChild(this.secondBtn);
        this.sliderContainer.appendChild(this.element);
        this.buttonTitle();
    };
    Slider.prototype.buttonTitle = function() {
        var enabledRTL = this.enableRtl && this.orientation !== "Vertical";
        this.l10n.setLocale(this.locale);
        var decrementTitle = this.l10n.getConstant("decrementTitle");
        var incrementTitle = this.l10n.getConstant("incrementTitle");
        (0, $4ZDHT.attributes)(enabledRTL ? this.secondBtn : this.firstBtn, {
            "aria-label": decrementTitle,
            title: decrementTitle
        });
        (0, $4ZDHT.attributes)(enabledRTL ? this.firstBtn : this.secondBtn, {
            "aria-label": incrementTitle,
            title: incrementTitle
        });
    };
    Slider.prototype.buttonFocusOut = function() {
        if (this.isMaterial || this.isMaterial3) this.getHandle().classList.remove("e-large-thumb-size");
    };
    Slider.prototype.repeatButton = function(args) {
        var hVal = this.handleValueUpdate();
        var enabledRTL = this.enableRtl && this.orientation !== "Vertical";
        var value;
        if (args.target.parentElement.classList.contains($f45acda29d40e6a4$var$classNames.firstButton) || args.target.classList.contains($f45acda29d40e6a4$var$classNames.firstButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.step.toString()), true);
            else value = this.add(hVal, parseFloat(this.step.toString()), false);
        } else if (args.target.parentElement.classList.contains($f45acda29d40e6a4$var$classNames.secondButton) || args.target.classList.contains($f45acda29d40e6a4$var$classNames.secondButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.step.toString()), false);
            else value = this.add(hVal, parseFloat(this.step.toString()), true);
        }
        if (this.limits.enabled) value = this.getLimitCorrectedValues(value);
        if (value >= this.min && value <= this.max) {
            this.changeHandleValue(value);
            this.tooltipToggle(this.getHandle());
        }
    };
    Slider.prototype.repeatHandlerMouse = function(args) {
        args.preventDefault();
        if (args.type === "mousedown" || args.type === "touchstart") {
            this.buttonClick(args);
            this.repeatInterval = setInterval(this.repeatButton.bind(this), 180, args);
        }
    };
    Slider.prototype.materialChange = function() {
        if (!this.getHandle().classList.contains("e-large-thumb-size")) this.getHandle().classList.add("e-large-thumb-size");
    };
    Slider.prototype.focusHandle = function() {
        if (!this.getHandle().classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.getHandle().classList.add($f45acda29d40e6a4$var$classNames.sliderTabHandle);
    };
    Slider.prototype.repeatHandlerUp = function(e) {
        this.changeEvent("changed", e);
        this.closeTooltip();
        clearInterval(this.repeatInterval);
        this.getHandle().focus();
    };
    Slider.prototype.customTickCounter = function(bigNum) {
        var tickCount = 4;
        if (!(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0) {
            if (bigNum > 4) tickCount = 3;
            if (bigNum > 7) tickCount = 2;
            if (bigNum > 14) tickCount = 1;
            if (bigNum > 28) tickCount = 0;
        }
        return tickCount;
    };
    Slider.prototype.renderScale = function() {
        var orien = this.orientation === "Vertical" ? "v" : "h";
        this.noOfDecimals = this.numberOfDecimals(this.step);
        this.ul = this.createElement("ul", {
            className: $f45acda29d40e6a4$var$classNames.scale + " " + "e-" + orien + "-scale " + $f45acda29d40e6a4$var$classNames.tick + "-" + this.ticks.placement.toLowerCase(),
            attrs: {
                role: "presentation",
                "aria-hidden": "true"
            }
        });
        this.ul.style.zIndex = "-1";
        if ((0, $5q7BP.Browser).isAndroid && orien === "h") this.ul.classList.add($f45acda29d40e6a4$var$classNames.sliderTickPosition);
        var smallStep = this.ticks.smallStep;
        if (!this.ticks.showSmallTicks) {
            if (this.ticks.largeStep > 0) smallStep = this.ticks.largeStep;
            else smallStep = parseFloat((0, $3EnZW.formatUnit)(this.max)) - parseFloat((0, $3EnZW.formatUnit)(this.min));
        } else if (smallStep <= 0) smallStep = parseFloat((0, $3EnZW.formatUnit)(this.step));
        var min = this.fractionalToInteger(this.min);
        var max = this.fractionalToInteger(this.max);
        var steps = this.fractionalToInteger(smallStep);
        var bigNum = !(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0 && this.customValues.length - 1;
        var customStep = this.customTickCounter(bigNum);
        var count = !(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0 ? bigNum * customStep + bigNum : Math.abs((max - min) / steps);
        this.element.appendChild(this.ul);
        var li;
        var start = parseFloat(this.min.toString());
        if (orien === "v") start = parseFloat(this.max.toString());
        var left = 0;
        var islargeTick;
        var tickWidth = 100 / count;
        if (tickWidth === Infinity) tickWidth = 5;
        for(var i = 0, y = !(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0 ? this.customValues.length - 1 : 0, k = 0; i <= count; i++){
            li = this.createElement("li", {
                attrs: {
                    class: $f45acda29d40e6a4$var$classNames.tick,
                    role: "presentation",
                    "aria-hidden": "true"
                }
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0) {
                islargeTick = i % (customStep + 1) === 0;
                if (islargeTick) {
                    if (orien === "h") {
                        start = this.customValues[k];
                        k++;
                    } else {
                        start = this.customValues[y];
                        y--;
                    }
                    li.setAttribute("title", start.toString());
                }
            } else {
                li.setAttribute("title", start.toString());
                if (this.numberOfDecimals(this.max) === 0 && this.numberOfDecimals(this.min) === 0 && this.numberOfDecimals(this.step) === 0) {
                    if (orien === "h") islargeTick = (start - parseFloat(this.min.toString())) % this.ticks.largeStep === 0 ? true : false;
                    else islargeTick = Math.abs(start - parseFloat(this.max.toString())) % this.ticks.largeStep === 0 ? true : false;
                } else {
                    var largestep = this.fractionalToInteger(this.ticks.largeStep);
                    var startValue = this.fractionalToInteger(start);
                    if (orien === "h") islargeTick = (startValue - min) % largestep === 0 ? true : false;
                    else islargeTick = Math.abs(startValue - parseFloat(max.toString())) % largestep === 0 ? true : false;
                }
            }
            if (islargeTick) li.classList.add($f45acda29d40e6a4$var$classNames.large);
            if (orien === "h") li.style.width = tickWidth + "%";
            else li.style.height = tickWidth + "%";
            var repeat = islargeTick ? this.ticks.placement === "Both" ? 2 : 1 : 0;
            if (islargeTick) for(var j = 0; j < repeat; j++)this.createTick(li, start);
            else if ((0, $3EnZW.isNullOrUndefined)(this.customValues)) this.formatTicksValue(li, start);
            this.ul.appendChild(li);
            this.tickElementCollection.push(li);
            var decimalPoints = void 0;
            if ((0, $3EnZW.isNullOrUndefined)(this.customValues)) {
                if (this.numberOfDecimals(smallStep) > this.numberOfDecimals(start)) decimalPoints = this.numberOfDecimals(smallStep);
                else decimalPoints = this.numberOfDecimals(start);
                if (orien === "h") start = this.makeRoundNumber(start + smallStep, decimalPoints);
                else if (this.min > this.max) start = this.makeRoundNumber(start + smallStep, decimalPoints);
                else start = this.makeRoundNumber(start - smallStep, decimalPoints);
                left = this.makeRoundNumber(left + smallStep, decimalPoints);
            }
        }
        this.ticksAlignment(orien, tickWidth);
    };
    Slider.prototype.ticksAlignment = function(orien, tickWidth, triggerEvent) {
        if (triggerEvent === void 0) triggerEvent = true;
        this.firstChild = this.ul.firstElementChild;
        this.lastChild = this.ul.lastElementChild;
        this.firstChild.classList.add($f45acda29d40e6a4$var$classNames.sliderFirstTick);
        this.lastChild.classList.add($f45acda29d40e6a4$var$classNames.sliderLastTick);
        this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.scale + "-" + this.ticks.placement.toLowerCase());
        if (orien === "h") {
            this.firstChild.style.width = tickWidth / 2 + "%";
            this.lastChild.style.width = tickWidth / 2 + "%";
        } else {
            this.firstChild.style.height = tickWidth / 2 + "%";
            this.lastChild.style.height = tickWidth / 2 + "%";
        }
        var eventArgs = {
            ticksWrapper: this.ul,
            tickElements: this.tickElementCollection
        };
        if (triggerEvent) this.trigger("renderedTicks", eventArgs);
        this.scaleAlignment();
    };
    Slider.prototype.createTick = function(li, start) {
        var span = this.createElement("span", {
            className: $f45acda29d40e6a4$var$classNames.tickValue + " " + $f45acda29d40e6a4$var$classNames.tick + "-" + this.ticks.placement.toLowerCase(),
            attrs: {
                role: "presentation",
                "aria-hidden": "true"
            }
        });
        li.appendChild(span);
        if ((0, $3EnZW.isNullOrUndefined)(this.customValues)) this.formatTicksValue(li, start, span);
        else if (this.enableHtmlSanitizer) span.innerHTML = (0, $3P3ke.SanitizeHtmlHelper).sanitize(start.toString());
        else span.innerHTML = start.toString();
    };
    Slider.prototype.formatTicksValue = function(li, start, spanElement) {
        var _this = this;
        var tickText = this.formatNumber(start);
        var text = !(0, $3EnZW.isNullOrUndefined)(this.ticks) && !(0, $3EnZW.isNullOrUndefined)(this.ticks.format) ? this.formatString(start, this.ticksFormatInfo).formatString : tickText;
        var eventArgs = {
            value: start,
            text: text,
            tickElement: li
        };
        this.trigger("renderingTicks", eventArgs, function(observedArgs) {
            li.setAttribute("title", observedArgs.text.toString());
            if (spanElement) {
                if (_this.enableHtmlSanitizer) spanElement.innerHTML = (0, $3P3ke.SanitizeHtmlHelper).sanitize(observedArgs.text.toString());
                else spanElement.innerHTML = observedArgs.text.toString();
            }
        });
    };
    Slider.prototype.scaleAlignment = function() {
        this.tickValuePosition();
        if (this.orientation === "Vertical") {
            if (this.element.getBoundingClientRect().width <= 15) this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.sliderSmallSize);
            else this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.sliderSmallSize);
        } else if (this.element.getBoundingClientRect().height <= 15) this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.sliderSmallSize);
        else this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.sliderSmallSize);
    };
    Slider.prototype.tickValuePosition = function() {
        this.firstChild = this.element.querySelector("ul").children[0];
        var first = this.firstChild.getBoundingClientRect();
        var firstChild;
        var otherChild;
        var smallStep = this.ticks.smallStep;
        var count = Math.abs(parseFloat((0, $3EnZW.formatUnit)(this.max)) - parseFloat((0, $3EnZW.formatUnit)(this.min))) / smallStep;
        if (this.firstChild.children.length > 0) firstChild = this.firstChild.children[0].getBoundingClientRect();
        var tickElements = [
            this.sliderContainer.querySelectorAll("." + $f45acda29d40e6a4$var$classNames.tick + "." + $f45acda29d40e6a4$var$classNames.large + " ." + $f45acda29d40e6a4$var$classNames.tickValue)
        ];
        var other;
        if (this.ticks.placement === "Both") other = [].slice.call(tickElements[0], 2);
        else other = [].slice.call(tickElements[0], 1);
        var tickWidth = this.orientation === "Vertical" ? first.height * 2 : first.width * 2;
        for(var i = 0; i < this.firstChild.children.length; i++){
            if (this.orientation === "Vertical") this.firstChild.children[i].style.top = -(firstChild.height / 2) + "px";
            else if (!this.enableRtl) this.firstChild.children[i].style.left = -(firstChild.width / 2) + "px";
            else this.firstChild.children[i].style.left = (tickWidth - this.firstChild.children[i].getBoundingClientRect().width) / 2 + "px";
        }
        for(var i = 0; i < other.length; i++){
            otherChild = other[i].getBoundingClientRect();
            if (this.orientation === "Vertical") (0, $4ZDHT.setStyleAttribute)(other[i], {
                top: (tickWidth - otherChild.height) / 2 + "px"
            });
            else (0, $4ZDHT.setStyleAttribute)(other[i], {
                left: (tickWidth - otherChild.width) / 2 + "px"
            });
        }
        if (this.enableRtl && this.lastChild.children.length && count !== 0) {
            this.lastChild.children[0].style.left = -(this.lastChild.getBoundingClientRect().width / 2) + "px";
            if (this.ticks.placement === "Both") this.lastChild.children[1].style.left = -(this.lastChild.getBoundingClientRect().width / 2) + "px";
        }
        if (count === 0) {
            if (this.orientation === "Horizontal") {
                if (!this.enableRtl) {
                    this.firstChild.classList.remove($f45acda29d40e6a4$var$classNames.sliderLastTick);
                    this.firstChild.style.left = this.firstHandle.style.left;
                } else {
                    this.firstChild.classList.remove($f45acda29d40e6a4$var$classNames.sliderLastTick);
                    this.firstChild.style.right = this.firstHandle.style.right;
                    this.firstChild.children[0].style.left = this.firstChild.getBoundingClientRect().width / 2 + 2 + "px";
                    if (this.ticks.placement === "Both") this.firstChild.children[1].style.left = this.firstChild.getBoundingClientRect().width / 2 + 2 + "px";
                }
            }
            if (this.orientation === "Vertical") this.firstChild.classList.remove($f45acda29d40e6a4$var$classNames.sliderLastTick);
        }
    };
    Slider.prototype.setAriaAttrValue = function(element) {
        var ariaValueText;
        var isTickFormatted = !(0, $3EnZW.isNullOrUndefined)(this.ticks) && !(0, $3EnZW.isNullOrUndefined)(this.ticks.format) ? true : false;
        var text = !isTickFormatted ? this.formatContent(this.ticksFormatInfo, false) : this.formatContent(this.tooltipFormatInfo, false);
        var valuenow = isTickFormatted ? this.formatContent(this.ticksFormatInfo, true) : this.formatContent(this.tooltipFormatInfo, true);
        text = !this.customAriaText ? text : this.customAriaText;
        if (text.split(" - ").length === 2) ariaValueText = text.split(" - ");
        else ariaValueText = [
            text,
            text
        ];
        this.setAriaAttributes(element);
        if (this.type !== "Range") (0, $4ZDHT.attributes)(element, {
            "aria-valuenow": valuenow,
            "aria-valuetext": text
        });
        else {
            if (!this.enableRtl) {
                if (element === this.firstHandle) (0, $4ZDHT.attributes)(element, {
                    "aria-valuenow": valuenow.split(" - ")[0],
                    "aria-valuetext": ariaValueText[0]
                });
                else (0, $4ZDHT.attributes)(element, {
                    "aria-valuenow": valuenow.split(" - ")[1],
                    "aria-valuetext": ariaValueText[1]
                });
            } else if (element === this.firstHandle) (0, $4ZDHT.attributes)(element, {
                "aria-valuenow": valuenow.split(" - ")[1],
                "aria-valuetext": ariaValueText[1]
            });
            else (0, $4ZDHT.attributes)(element, {
                "aria-valuenow": valuenow.split(" - ")[0],
                "aria-valuetext": ariaValueText[0]
            });
        }
    };
    Slider.prototype.handleValueUpdate = function() {
        var hVal;
        if (this.type === "Range") {
            if (this.activeHandle === 1) hVal = this.handleVal1;
            else hVal = this.handleVal2;
        } else hVal = this.handleVal1;
        return hVal;
    };
    Slider.prototype.getLimitCorrectedValues = function(value) {
        if (this.type === "MinRange" || this.type === "Default") value = this.getLimitValueAndPosition(value, this.limits.minStart, this.limits.minEnd)[0];
        else if (this.activeHandle === 1) value = this.getLimitValueAndPosition(value, this.limits.minStart, this.limits.minEnd)[0];
        else value = this.getLimitValueAndPosition(value, this.limits.maxStart, this.limits.maxEnd)[0];
        return value;
    };
    Slider.prototype.focusSliderElement = function() {
        if (!this.isElementFocused) {
            this.element.focus();
            this.isElementFocused = true;
        }
    };
    Slider.prototype.buttonClick = function(args) {
        this.focusSliderElement();
        var value;
        var enabledRTL = this.enableRtl && this.orientation !== "Vertical";
        var hVal = this.handleValueUpdate();
        if (args.keyCode === 40 || args.keyCode === 37 || args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.firstButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.step.toString()), true);
            else value = this.add(hVal, parseFloat(this.step.toString()), false);
        } else if (args.keyCode === 38 || args.keyCode === 39 || args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.secondButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.step.toString()), false);
            else value = this.add(hVal, parseFloat(this.step.toString()), true);
        } else if (args.keyCode === 33 || args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.firstButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), false);
            else value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), true);
        } else if (args.keyCode === 34 || args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.secondButton)) {
            if (enabledRTL) value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), true);
            else value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), false);
        } else if (args.keyCode === 36) value = parseFloat(this.min < this.max ? this.min.toString() : this.max.toString());
        else if (args.keyCode === 35) value = parseFloat(this.min < this.max ? this.max.toString() : this.min.toString());
        if (this.limits.enabled) value = this.getLimitCorrectedValues(value);
        this.changeHandleValue(value);
        if ((this.isMaterial || this.isMaterial3) && !this.tooltip.isVisible && !this.getHandle().classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.materialChange();
        this.tooltipToggle(this.getHandle());
        this.getHandle().focus();
        this.focusHandle();
        if (args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.firstButton)) (0, $aqzbR.EventHandler).add(this.firstBtn, "mouseup touchend", this.buttonUp, this);
        if (args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.secondButton)) (0, $aqzbR.EventHandler).add(this.secondBtn, "mouseup touchend", this.buttonUp, this);
    };
    Slider.prototype.tooltipToggle = function(target) {
        if (this.isMaterialTooltip) {
            if (!this.tooltipElement.classList.contains($f45acda29d40e6a4$var$classNames.materialTooltipOpen)) this.openMaterialTooltip();
            else this.refreshTooltip(this.firstHandle);
        } else if (!this.tooltipElement) this.openTooltip(target);
        else this.refreshTooltip(target);
    };
    Slider.prototype.buttonUp = function(args) {
        if (args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.firstButton)) (0, $aqzbR.EventHandler).remove(this.firstBtn, "mouseup touchend", this.buttonUp);
        if (args.currentTarget.classList.contains($f45acda29d40e6a4$var$classNames.secondButton)) (0, $aqzbR.EventHandler).remove(this.secondBtn, "mouseup touchend", this.buttonUp);
    };
    Slider.prototype.setRangeBar = function() {
        if (this.orientation === "Horizontal" && !(0, $3EnZW.isNullOrUndefined)(this.rangeBar)) {
            if (this.type === "MinRange") {
                if (this.enableRtl) this.rangeBar.style.right = "0px";
                else this.rangeBar.style.left = "0px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "width": (0, $3EnZW.isNullOrUndefined)(this.handlePos1) ? 0 : this.handlePos1 + "px"
                });
            } else {
                if (this.enableRtl) this.rangeBar.style.right = this.handlePos1 + "px";
                else this.rangeBar.style.left = this.handlePos1 + "px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "width": this.handlePos2 - this.handlePos1 + "px"
                });
            }
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.rangeBar)) {
            if (this.type === "MinRange") {
                this.rangeBar.style.bottom = this.min > this.max ? this.handlePos1 + "px" : "0px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "height": (0, $3EnZW.isNullOrUndefined)(this.handlePos1) ? 0 : this.min > this.max ? this.element.clientHeight - this.handlePos1 + "px" : this.handlePos1 + "px"
                });
            } else {
                this.rangeBar.style.bottom = this.min > this.max ? this.handlePos2 + "px" : this.handlePos1 + "px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "height": this.min > this.max ? this.handlePos1 - this.handlePos2 + "px" : this.handlePos2 - this.handlePos1 + "px"
                });
            }
        }
    };
    Slider.prototype.checkValidValueAndPos = function(value) {
        value = this.checkHandleValue(value);
        value = this.checkHandlePosition(value);
        return value;
    };
    Slider.prototype.setLimitBarPositions = function(fromMinPostion, fromMaxpostion, toMinPostion, toMaxpostion) {
        if (this.orientation === "Horizontal") {
            if (!this.enableRtl) {
                this.limitBarFirst.style.left = fromMinPostion + "px";
                this.limitBarFirst.style.width = fromMaxpostion - fromMinPostion + "px";
            } else {
                this.limitBarFirst.style.right = fromMinPostion + "px";
                this.limitBarFirst.style.width = fromMaxpostion - fromMinPostion + "px";
            }
        } else {
            this.limitBarFirst.style.bottom = (this.min < this.max ? fromMinPostion : fromMaxpostion) + "px";
            this.limitBarFirst.style.height = (this.min < this.max ? fromMaxpostion - fromMinPostion : fromMinPostion - fromMaxpostion) + "px";
        }
        if (this.type === "Range") {
            if (this.orientation === "Horizontal") {
                if (!this.enableRtl) {
                    this.limitBarSecond.style.left = toMinPostion + "px";
                    this.limitBarSecond.style.width = toMaxpostion - toMinPostion + "px";
                } else {
                    this.limitBarSecond.style.right = toMinPostion + "px";
                    this.limitBarSecond.style.width = toMaxpostion - toMinPostion + "px";
                }
            } else {
                this.limitBarSecond.style.bottom = (this.min < this.max ? toMinPostion : toMaxpostion) + "px";
                this.limitBarSecond.style.height = (this.min < this.max ? toMaxpostion - toMinPostion : toMinPostion - toMaxpostion) + "px";
            }
        }
    };
    Slider.prototype.setLimitBar = function() {
        if (this.type === "Default" || this.type === "MinRange") {
            var fromPosition = this.getLimitValueAndPosition(this.limits.minStart, this.limits.minStart, this.limits.minEnd, true)[0];
            fromPosition = this.checkValidValueAndPos(fromPosition);
            var toPosition = this.getLimitValueAndPosition(this.limits.minEnd, this.limits.minStart, this.limits.minEnd, true)[0];
            toPosition = this.checkValidValueAndPos(toPosition);
            this.setLimitBarPositions(fromPosition, toPosition);
        } else if (this.type === "Range") {
            var fromMinPostion = this.getLimitValueAndPosition(this.limits.minStart, this.limits.minStart, this.limits.minEnd, true)[0];
            fromMinPostion = this.checkValidValueAndPos(fromMinPostion);
            var fromMaxpostion = this.getLimitValueAndPosition(this.limits.minEnd, this.limits.minStart, this.limits.minEnd, true)[0];
            fromMaxpostion = this.checkValidValueAndPos(fromMaxpostion);
            var toMinPostion = this.getLimitValueAndPosition(this.limits.maxStart, this.limits.maxStart, this.limits.maxEnd, true)[0];
            toMinPostion = this.checkValidValueAndPos(toMinPostion);
            var toMaxpostion = this.getLimitValueAndPosition(this.limits.maxEnd, this.limits.maxStart, this.limits.maxEnd, true)[0];
            toMaxpostion = this.checkValidValueAndPos(toMaxpostion);
            this.setLimitBarPositions(fromMinPostion, fromMaxpostion, toMinPostion, toMaxpostion);
        }
    };
    Slider.prototype.getLimitValueAndPosition = function(currentValue, minValue, maxValue, limitBar) {
        if ((0, $3EnZW.isNullOrUndefined)(minValue)) {
            minValue = this.min < this.max ? this.min : this.max;
            if ((0, $3EnZW.isNullOrUndefined)(currentValue) && limitBar) currentValue = minValue;
        }
        if ((0, $3EnZW.isNullOrUndefined)(maxValue)) {
            maxValue = this.min < this.max ? this.max : this.min;
            if ((0, $3EnZW.isNullOrUndefined)(currentValue) && limitBar) currentValue = maxValue;
        }
        if (currentValue < minValue) currentValue = minValue;
        if (currentValue > maxValue) currentValue = maxValue;
        return [
            currentValue,
            this.checkHandlePosition(currentValue)
        ];
    };
    Slider.prototype.setValue = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.customValues) && this.customValues.length > 0) {
            this.min = 0;
            this.max = this.customValues.length - 1;
            this.setBarColor();
        }
        this.setAriaAttributes(this.firstHandle);
        this.handleVal1 = (0, $3EnZW.isNullOrUndefined)(this.value) ? this.checkHandleValue(parseFloat(this.min.toString())) : this.checkHandleValue(parseFloat(this.value.toString()));
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.preHandlePos1 = this.handlePos1;
        if ((0, $3EnZW.isNullOrUndefined)(this.activeHandle)) this.activeHandle = this.type === "Range" ? 2 : 1;
        if (this.type === "Default" || this.type === "MinRange") {
            if (this.limits.enabled) {
                var values = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
                this.handleVal1 = values[0];
                this.handlePos1 = values[1];
                this.preHandlePos1 = this.handlePos1;
            }
            this.setHandlePosition(null);
            this.handleStart();
            this.value = this.handleVal1;
            this.setAriaAttrValue(this.firstHandle);
            this.changeEvent("changed", null);
        } else this.validateRangeValue();
        if (this.type !== "Default") this.setRangeBar();
        if (this.limits.enabled) this.setLimitBar();
    };
    Slider.prototype.rangeValueUpdate = function() {
        if (this.value === null || typeof this.value !== "object") this.value = [
            parseFloat((0, $3EnZW.formatUnit)(this.min)),
            parseFloat((0, $3EnZW.formatUnit)(this.max))
        ];
    };
    Slider.prototype.validateRangeValue = function() {
        this.rangeValueUpdate();
        this.setRangeValue();
    };
    Slider.prototype.modifyZindex = function() {
        if (this.type === "Range" && !(0, $3EnZW.isNullOrUndefined)(this.firstHandle) && !(0, $3EnZW.isNullOrUndefined)(this.secondHandle)) {
            if (this.activeHandle === 1) {
                this.firstHandle.style.zIndex = this.zIndex + 4 + "";
                this.secondHandle.style.zIndex = this.zIndex + 3 + "";
            } else {
                this.firstHandle.style.zIndex = this.zIndex + 3 + "";
                this.secondHandle.style.zIndex = this.zIndex + 4 + "";
            }
        } else if (this.isMaterialTooltip && this.tooltipElement) this.tooltipElement.style.zIndex = (0, $2vAqh.getZindexPartial)(this.element) + "";
    };
    Slider.prototype.setHandlePosition = function(event) {
        var _this = this;
        var handle;
        var pos = this.activeHandle === 1 ? this.handlePos1 : this.handlePos2;
        if (this.isMaterialTooltip) handle = [
            this.firstHandle,
            this.materialHandle
        ];
        else handle = [
            this.getHandle()
        ];
        this.handleStart();
        handle.forEach(function(handle) {
            if ((0, $3EnZW.isNullOrUndefined)(handle)) return;
            if (_this.orientation === "Horizontal") {
                if (_this.enableRtl) handle.style.right = pos + "px";
                else handle.style.left = pos + "px";
            } else handle.style.bottom = pos + "px";
        });
        this.changeEvent("change", event);
    };
    Slider.prototype.getHandle = function() {
        return this.activeHandle === 1 ? this.firstHandle : this.secondHandle;
    };
    Slider.prototype.setRangeValue = function() {
        this.updateRangeValue();
        this.activeHandle = 1;
        this.setHandlePosition(null);
        this.activeHandle = 2;
        this.setHandlePosition(null);
        this.activeHandle = 1;
    };
    Slider.prototype.changeEvent = function(eventName, e) {
        var previous = eventName === "change" ? this.previousVal : this.previousChanged;
        if (this.type !== "Range") {
            this.setProperties({
                "value": this.handleVal1
            }, true);
            if (previous !== this.value && (!this.isMaterialTooltip || !this.initialTooltip)) {
                this.trigger(eventName, this.changeEventArgs(eventName, e));
                this.initialTooltip = true;
                this.setPreviousVal(eventName, this.value);
            }
            this.setAriaAttrValue(this.firstHandle);
        } else {
            var value = this.value = [
                this.handleVal1,
                this.handleVal2
            ];
            this.setProperties({
                "value": value
            }, true);
            if (previous.length === this.value.length && this.value[0] !== previous[0] || this.value[1] !== previous[1]) {
                this.initialTooltip = false;
                this.trigger(eventName, this.changeEventArgs(eventName, e));
                this.initialTooltip = true;
                this.setPreviousVal(eventName, this.value);
            }
            this.setAriaAttrValue(this.getHandle());
        }
        this.hiddenInput.value = this.value.toString();
    };
    Slider.prototype.changeEventArgs = function(eventName, e) {
        var eventArgs;
        if (this.tooltip.isVisible && this.tooltipObj && this.initialTooltip) {
            this.tooltipValue();
            eventArgs = {
                value: this.value,
                previousValue: eventName === "change" ? this.previousVal : this.previousChanged,
                action: eventName,
                text: typeof this.tooltipObj.content === "function" ? this.tooltipObj.content() : this.tooltipObj.content,
                isInteracted: (0, $3EnZW.isNullOrUndefined)(e) ? false : true
            };
        } else eventArgs = {
            value: this.value,
            previousValue: eventName === "change" ? this.previousVal : this.previousChanged,
            action: eventName,
            text: (0, $3EnZW.isNullOrUndefined)(this.ticksFormatInfo.format) ? this.value.toString() : this.type !== "Range" ? this.formatString(this.value, this.ticksFormatInfo).formatString : this.formatString(this.value[0], this.ticksFormatInfo).formatString + " - " + this.formatString(this.value[1], this.ticksFormatInfo).formatString,
            isInteracted: (0, $3EnZW.isNullOrUndefined)(e) ? false : true
        };
        return eventArgs;
    };
    Slider.prototype.setPreviousVal = function(eventName, value) {
        if (eventName === "change") this.previousVal = value;
        else this.previousChanged = value;
    };
    Slider.prototype.updateRangeValue = function() {
        var values = this.value.toString().split(",").map(Number);
        if (this.enableRtl && this.orientation !== "Vertical" || this.rtl) this.value = [
            values[1],
            values[0]
        ];
        else this.value = [
            values[0],
            values[1]
        ];
        if (this.enableRtl && this.orientation !== "Vertical") {
            this.handleVal1 = this.checkHandleValue(this.value[1]);
            this.handleVal2 = this.checkHandleValue(this.value[0]);
        } else {
            this.handleVal1 = this.checkHandleValue(this.value[0]);
            this.handleVal2 = this.checkHandleValue(this.value[1]);
        }
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.handlePos2 = this.checkHandlePosition(this.handleVal2);
        if (this.min < this.max && this.handlePos1 > this.handlePos2) {
            this.handlePos1 = this.handlePos2;
            this.handleVal1 = this.handleVal2;
        }
        if (this.min > this.max && this.handlePos1 < this.handlePos2) {
            this.handlePos2 = this.handlePos1;
            this.handleVal2 = this.handleVal1;
        }
        this.preHandlePos1 = this.handlePos1;
        this.preHandlePos2 = this.handlePos2;
        if (this.limits.enabled) {
            this.activeHandle = 1;
            var values_1 = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
            this.handleVal1 = values_1[0];
            this.handlePos1 = values_1[1];
            this.preHandlePos1 = this.handlePos1;
            this.activeHandle = 2;
            values_1 = this.getLimitValueAndPosition(this.handleVal2, this.limits.maxStart, this.limits.maxEnd);
            this.handleVal2 = values_1[0];
            this.handlePos2 = values_1[1];
            this.preHandlePos2 = this.handlePos2;
        }
    };
    Slider.prototype.checkHandlePosition = function(value) {
        var pos;
        value = 100 * (value - parseFloat((0, $3EnZW.formatUnit)(this.min))) / (parseFloat((0, $3EnZW.formatUnit)(this.max)) - parseFloat((0, $3EnZW.formatUnit)(this.min)));
        if (this.orientation === "Horizontal") pos = this.element.getBoundingClientRect().width * (value / 100);
        else pos = this.element.getBoundingClientRect().height * (value / 100);
        if (parseFloat((0, $3EnZW.formatUnit)(this.max)) === parseFloat((0, $3EnZW.formatUnit)(this.min))) {
            if (this.orientation === "Horizontal") pos = this.element.getBoundingClientRect().width;
            else pos = this.element.getBoundingClientRect().height;
        }
        return pos;
    };
    Slider.prototype.checkHandleValue = function(value) {
        if (this.min === this.max) return parseFloat((0, $3EnZW.formatUnit)(this.max));
        var handle = this.tempStartEnd();
        if (value < handle.start) value = handle.start;
        else if (value > handle.end) value = handle.end;
        return value;
    };
    /**
     * It is used to reposition slider.
     *
     * @returns {void}
     */ Slider.prototype.reposition = function() {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(this.firstHandle)) this.firstHandle.style.transition = "none";
        if (this.type !== "Default" && !(0, $3EnZW.isNullOrUndefined)(this.rangeBar)) this.rangeBar.style.transition = "none";
        if (this.type === "Range" && !(0, $3EnZW.isNullOrUndefined)(this.secondHandle)) this.secondHandle.style.transition = "none";
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        if (this.handleVal2) this.handlePos2 = this.checkHandlePosition(this.handleVal2);
        if (this.orientation === "Horizontal") {
            if (this.enableRtl) this.firstHandle.style.right = this.handlePos1 + "px";
            else this.firstHandle.style.left = this.handlePos1 + "px";
            if (this.isMaterialTooltip && !(0, $3EnZW.isNullOrUndefined)(this.materialHandle)) {
                if (this.enableRtl) this.materialHandle.style.right = this.handlePos1 + "px";
                else this.materialHandle.style.left = this.handlePos1 + "px";
            }
            if (this.type === "MinRange" && !(0, $3EnZW.isNullOrUndefined)(this.rangeBar)) {
                if (this.enableRtl) this.rangeBar.style.right = "0px";
                else this.rangeBar.style.left = "0px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "width": (0, $3EnZW.isNullOrUndefined)(this.handlePos1) ? 0 : this.handlePos1 + "px"
                });
            } else if (this.type === "Range" && !(0, $3EnZW.isNullOrUndefined)(this.secondHandle) && !(0, $3EnZW.isNullOrUndefined)(this.rangeBar)) {
                if (this.enableRtl) {
                    this.secondHandle.style.right = this.handlePos2 + "px";
                    this.rangeBar.style.right = this.handlePos1 + "px";
                } else {
                    this.secondHandle.style.left = this.handlePos2 + "px";
                    this.rangeBar.style.left = this.handlePos1 + "px";
                }
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "width": this.handlePos2 - this.handlePos1 + "px"
                });
            }
        } else {
            this.firstHandle.style.bottom = this.handlePos1 + "px";
            if (this.isMaterialTooltip) this.materialHandle.style.bottom = this.handlePos1 + "px";
            if (this.type === "MinRange") {
                this.rangeBar.style.bottom = this.min > this.max ? this.handlePos1 + "px" : "0px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "height": (0, $3EnZW.isNullOrUndefined)(this.handlePos1) ? 0 : this.min > this.max ? this.element.clientHeight - this.handlePos1 + "px" : this.handlePos1 + "px"
                });
            } else if (this.type === "Range") {
                this.secondHandle.style.bottom = this.handlePos2 + "px";
                this.rangeBar.style.bottom = this.min > this.max ? this.handlePos2 + "px" : this.handlePos1 + "px";
                (0, $4ZDHT.setStyleAttribute)(this.rangeBar, {
                    "height": this.min > this.max ? this.handlePos1 - this.handlePos2 + "px" : this.handlePos2 - this.handlePos1 + "px"
                });
            }
        }
        if (this.limits.enabled) this.setLimitBar();
        if (this.ticks.placement !== "None" && this.ul) {
            this.removeElement(this.ul);
            this.ul = undefined;
            this.renderScale();
        }
        this.handleStart();
        if (!this.tooltip.isVisible) setTimeout(function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.firstHandle)) _this.firstHandle.style.transition = _this.scaleTransform;
            if (_this.type === "Range" && !(0, $3EnZW.isNullOrUndefined)(_this.secondHandle)) _this.secondHandle.style.transition = _this.scaleTransform;
        });
        this.refreshTooltip(this.tooltipTarget);
        this.setBarColor();
    };
    Slider.prototype.changeHandleValue = function(value) {
        var position = null;
        if (this.activeHandle === 1) {
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                this.handleVal1 = this.checkHandleValue(value);
                this.handlePos1 = this.checkHandlePosition(this.handleVal1);
                if (this.type === "Range" && (this.handlePos1 > this.handlePos2 && this.min < this.max || this.handlePos1 < this.handlePos2 && this.min > this.max)) {
                    this.handlePos1 = this.handlePos2;
                    this.handleVal1 = this.handleVal2;
                }
                if (this.handlePos1 !== this.preHandlePos1) position = this.preHandlePos1 = this.handlePos1;
            }
            this.modifyZindex();
        } else {
            if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                this.handleVal2 = this.checkHandleValue(value);
                this.handlePos2 = this.checkHandlePosition(this.handleVal2);
                if (this.type === "Range" && (this.handlePos2 < this.handlePos1 && this.min < this.max || this.handlePos2 > this.handlePos1 && this.min > this.max)) {
                    this.handlePos2 = this.handlePos1;
                    this.handleVal2 = this.handleVal1;
                }
                if (this.handlePos2 !== this.preHandlePos2) position = this.preHandlePos2 = this.handlePos2;
            }
            this.modifyZindex();
        }
        if (position !== null) {
            if (this.type !== "Default") this.setRangeBar();
            this.setHandlePosition(null);
        }
    };
    Slider.prototype.tempStartEnd = function() {
        if (this.min > this.max) return {
            start: this.max,
            end: this.min
        };
        else return {
            start: this.min,
            end: this.max
        };
    };
    Slider.prototype.xyToPosition = function(position) {
        var pos;
        if (this.min === this.max) return 100;
        if (this.orientation === "Horizontal") {
            var left = position.x - this.element.getBoundingClientRect().left;
            var num = this.element.offsetWidth / 100;
            this.val = left / num;
        } else {
            var top_1 = position.y - this.element.getBoundingClientRect().top;
            var num = this.element.offsetHeight / 100;
            this.val = 100 - top_1 / num;
        }
        var val = this.stepValueCalculation(this.val);
        if (val < 0) val = 0;
        else if (val > 100) val = 100;
        if (this.enableRtl && this.orientation !== "Vertical") val = 100 - val;
        if (this.orientation === "Horizontal") pos = this.element.getBoundingClientRect().width * (val / 100);
        else pos = this.element.getBoundingClientRect().height * (val / 100);
        return pos;
    };
    Slider.prototype.stepValueCalculation = function(value) {
        if (this.step === 0) this.step = 1;
        var percentStep = parseFloat((0, $3EnZW.formatUnit)(this.step)) / ((parseFloat((0, $3EnZW.formatUnit)(this.max)) - parseFloat((0, $3EnZW.formatUnit)(this.min))) / 100);
        var remain = value % Math.abs(percentStep);
        if (remain !== 0) {
            if (percentStep / 2 > remain) value -= remain;
            else value += Math.abs(percentStep) - remain;
        }
        return value;
    };
    Slider.prototype.add = function(a, b, addition) {
        var precision;
        var x = Math.pow(10, precision || 3);
        var val;
        if (addition) val = (Math.round(a * x) + Math.round(b * x)) / x;
        else val = (Math.round(a * x) - Math.round(b * x)) / x;
        return val;
    };
    Slider.prototype.positionToValue = function(pos) {
        var val;
        var diff = parseFloat((0, $3EnZW.formatUnit)(this.max)) - parseFloat((0, $3EnZW.formatUnit)(this.min));
        if (this.orientation === "Horizontal") val = pos / this.element.getBoundingClientRect().width * diff;
        else val = pos / this.element.getBoundingClientRect().height * diff;
        var total = this.add(val, parseFloat(this.min.toString()), true);
        return total;
    };
    Slider.prototype.sliderBarClick = function(evt) {
        evt.preventDefault();
        var pos;
        if (evt.type === "mousedown" || evt.type === "mouseup" || evt.type === "click") pos = {
            x: evt.clientX,
            y: evt.clientY
        };
        else if (evt.type === "touchend" || evt.type === "touchstart") pos = {
            x: evt.changedTouches[0].clientX,
            y: evt.changedTouches[0].clientY
        };
        var handlepos = this.xyToPosition(pos);
        var handleVal = this.positionToValue(handlepos);
        if (this.type === "Range" && (this.min < this.max && this.handlePos2 - handlepos < handlepos - this.handlePos1 || this.min > this.max && this.handlePos1 - handlepos > handlepos - this.handlePos2)) {
            this.activeHandle = 2;
            if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                if (this.limits.enabled) {
                    var value = this.getLimitValueAndPosition(handleVal, this.limits.maxStart, this.limits.maxEnd);
                    handleVal = value[0];
                    handlepos = value[1];
                }
                this.secondHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
                this.handlePos2 = this.preHandlePos2 = handlepos;
                this.handleVal2 = handleVal;
            }
            this.modifyZindex();
            this.secondHandle.focus();
        } else {
            this.activeHandle = 1;
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                if (this.limits.enabled) {
                    var value = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                    handleVal = value[0];
                    handlepos = value[1];
                }
                this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
                this.handlePos1 = this.preHandlePos1 = handlepos;
                this.handleVal1 = handleVal;
            }
            this.modifyZindex();
            this.firstHandle.focus();
        }
        if (this.isMaterialTooltip) this.tooltipElement.classList.add($f45acda29d40e6a4$var$classNames.materialTooltipActive);
        var focusedElement = this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle);
        if (focusedElement && this.getHandle() !== focusedElement) focusedElement.classList.remove($f45acda29d40e6a4$var$classNames.sliderTabHandle);
        var handle = this.activeHandle === 1 ? this.firstHandle : this.secondHandle;
        var behindElement;
        if ((evt.type === "click" || evt.type === "mousedown") && evt.target === handle) {
            var eventX = evt.clientX, eventY = evt.clientY;
            behindElement = document.elementFromPoint(eventX, eventY);
        }
        if (!this.checkRepeatedValue(handleVal)) return;
        var transition = (this.isMaterial || this.isMaterial3) && this.tooltip.isVisible ? this.transitionOnMaterialTooltip : this.transition;
        this.getHandle().style.transition = transition.handle;
        if (this.type !== "Default") this.rangeBar.style.transition = transition.rangeBar;
        this.setHandlePosition(evt);
        if (this.isMaterialTooltip) this.initialTooltip = false;
        if (evt.target !== handle) this.changeEvent("changed", evt);
        if (this.type !== "Default") this.setRangeBar();
    };
    Slider.prototype.handleValueAdjust = function(handleValue, assignValue, handleNumber) {
        if (handleNumber === 1) {
            this.handleVal1 = assignValue;
            this.handleVal2 = this.handleVal1 + this.minDiff;
        } else if (handleNumber === 2) {
            this.handleVal2 = assignValue;
            this.handleVal1 = this.handleVal2 - this.minDiff;
        }
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.handlePos2 = this.checkHandlePosition(this.handleVal2);
    };
    Slider.prototype.dragRangeBarMove = function(event) {
        var _a, _b;
        if (event.type !== "touchmove") event.preventDefault();
        this.rangeBarDragged = true;
        var pos;
        this.rangeBar.style.transition = "none";
        this.firstHandle.style.transition = "none";
        this.secondHandle.style.transition = "none";
        var xPostion;
        var yPostion;
        if (event.type === "mousemove") _a = [
            event.clientX,
            event.clientY
        ], xPostion = _a[0], yPostion = _a[1];
        else _b = [
            event.changedTouches[0].clientX,
            event.changedTouches[0].clientY
        ], xPostion = _b[0], yPostion = _b[1];
        if (!(this.limits.enabled && this.limits.startHandleFixed) && !(this.limits.enabled && this.limits.endHandleFixed)) {
            if (!this.enableRtl) pos = {
                x: xPostion - this.firstPartRemain,
                y: yPostion + this.secondPartRemain
            };
            else pos = {
                x: xPostion + this.secondPartRemain,
                y: yPostion + this.secondPartRemain
            };
            if (this.min > this.max) {
                this.handlePos2 = this.xyToPosition(pos);
                this.handleVal2 = this.positionToValue(this.handlePos2);
            } else {
                this.handlePos1 = this.xyToPosition(pos);
                this.handleVal1 = this.positionToValue(this.handlePos1);
            }
            if (!this.enableRtl) pos = {
                x: xPostion + this.secondPartRemain,
                y: yPostion - this.firstPartRemain
            };
            else pos = {
                x: xPostion - this.firstPartRemain,
                y: yPostion - this.firstPartRemain
            };
            if (this.min > this.max) {
                this.handlePos1 = this.xyToPosition(pos);
                this.handleVal1 = this.positionToValue(this.handlePos1);
            } else {
                this.handlePos2 = this.xyToPosition(pos);
                this.handleVal2 = this.positionToValue(this.handlePos2);
            }
            if (this.limits.enabled) {
                var value = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
                this.handleVal1 = value[0];
                this.handlePos1 = value[1];
                if (this.handleVal1 === this.limits.minEnd) this.handleValueAdjust(this.handleVal1, this.limits.minEnd, 1);
                if (this.handleVal1 === this.limits.minStart) this.handleValueAdjust(this.handleVal1, this.limits.minStart, 1);
                value = this.getLimitValueAndPosition(this.handleVal2, this.limits.maxStart, this.limits.maxEnd);
                this.handleVal2 = value[0];
                this.handlePos2 = value[1];
                if (this.handleVal2 === this.limits.maxStart) this.handleValueAdjust(this.handleVal2, this.limits.maxStart, 2);
                if (this.handleVal2 === this.limits.maxEnd) this.handleValueAdjust(this.handleVal2, this.limits.maxEnd, 2);
            }
            if (this.handleVal2 === (this.min > this.max ? this.min : this.max)) this.handleValueAdjust(this.handleVal2, this.min > this.max ? this.min : this.max, 2);
            if (this.handleVal1 === (this.min > this.max ? this.max : this.min)) this.handleValueAdjust(this.handleVal1, this.min > this.max ? this.max : this.min, 1);
        }
        this.activeHandle = 1;
        this.setHandlePosition(event);
        this.activeHandle = 2;
        this.setHandlePosition(event);
        this.tooltipToggle(this.rangeBar);
        this.setRangeBar();
    };
    Slider.prototype.sliderBarUp = function(event) {
        this.changeEvent("changed", event);
        this.handleFocusOut();
        this.firstHandle.classList.remove($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
        if (this.type === "Range") {
            this.initialTooltip = false;
            this.secondHandle.classList.remove($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
        }
        this.closeTooltip();
        if (this.isMaterial || this.isMaterial3) {
            this.getHandle().classList.remove("e-large-thumb-size");
            if (this.isMaterialTooltip) this.tooltipElement.classList.remove($f45acda29d40e6a4$var$classNames.materialTooltipActive);
        }
        (0, $aqzbR.EventHandler).remove(document, "mousemove touchmove", this.sliderBarMove);
        (0, $aqzbR.EventHandler).remove(document, "mouseup touchend", this.sliderBarUp);
    };
    Slider.prototype.sliderBarMove = function(evt) {
        if (evt.type !== "touchmove") evt.preventDefault();
        var pos;
        if (evt.type === "mousemove") pos = {
            x: evt.clientX,
            y: evt.clientY
        };
        else pos = {
            x: evt.changedTouches[0].clientX,
            y: evt.changedTouches[0].clientY
        };
        var handlepos = this.xyToPosition(pos);
        var handleVal = this.positionToValue(handlepos);
        handlepos = Math.round(handlepos);
        if (this.type !== "Range" && this.activeHandle === 1) {
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                if (this.limits.enabled) {
                    var valueAndPostion = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                    handlepos = valueAndPostion[1];
                    handleVal = valueAndPostion[0];
                }
                this.handlePos1 = handlepos;
                this.handleVal1 = handleVal;
            }
            this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
        }
        if (this.type === "Range") {
            if (this.activeHandle === 1) {
                this.firstHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
                if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                    if (this.min < this.max && handlepos > this.handlePos2 || this.min > this.max && handlepos < this.handlePos2) {
                        handlepos = this.handlePos2;
                        handleVal = this.handleVal2;
                    }
                    if (handlepos !== this.preHandlePos1) {
                        if (this.limits.enabled) {
                            var value = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                            handleVal = value[0];
                            handlepos = value[1];
                        }
                        this.handlePos1 = this.preHandlePos1 = handlepos;
                        this.handleVal1 = handleVal;
                        this.activeHandle = 1;
                    }
                }
            } else if (this.activeHandle === 2) {
                this.secondHandle.classList.add($f45acda29d40e6a4$var$classNames.sliderActiveHandle);
                if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                    if (this.min < this.max && handlepos < this.handlePos1 || this.min > this.max && handlepos > this.handlePos1) {
                        handlepos = this.handlePos1;
                        handleVal = this.handleVal1;
                    }
                    if (handlepos !== this.preHandlePos2) {
                        if (this.limits.enabled) {
                            var value = this.getLimitValueAndPosition(handleVal, this.limits.maxStart, this.limits.maxEnd);
                            handleVal = value[0];
                            handlepos = value[1];
                        }
                        this.handlePos2 = this.preHandlePos2 = handlepos;
                        this.handleVal2 = handleVal;
                        this.activeHandle = 2;
                    }
                }
            }
        }
        if (!this.checkRepeatedValue(handleVal)) return;
        this.getHandle().style.transition = this.scaleTransform;
        if (this.type !== "Default") this.rangeBar.style.transition = "none";
        this.setHandlePosition(evt);
        if ((this.isMaterial || this.isMaterial3) && !this.tooltip.isVisible && !this.getHandle().classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.materialChange();
        this.tooltipToggle(this.getHandle());
        if (this.type !== "Default") this.setRangeBar();
    };
    Slider.prototype.dragRangeBarUp = function(event) {
        if (!this.rangeBarDragged) {
            this.focusSliderElement();
            this.sliderBarClick(event);
        } else this.isDragComplete = true;
        this.changeEvent("changed", event);
        this.closeTooltip();
        (0, $aqzbR.EventHandler).remove(document, "mousemove touchmove", this.dragRangeBarMove);
        (0, $aqzbR.EventHandler).remove(document, "mouseup touchend", this.dragRangeBarUp);
        this.rangeBarDragged = false;
    };
    Slider.prototype.checkRepeatedValue = function(currentValue) {
        if (this.type === "Range") {
            var previousVal = this.enableRtl && this.orientation !== "Vertical" ? this.activeHandle === 1 ? this.previousVal[1] : this.previousVal[0] : this.activeHandle === 1 ? this.previousVal[0] : this.previousVal[1];
            if (currentValue === previousVal) return 0;
        } else {
            if (currentValue === this.previousVal) return 0;
        }
        return 1;
    };
    Slider.prototype.refreshTooltip = function(target) {
        if (this.tooltip.isVisible && this.tooltipObj) {
            this.tooltipValue();
            if (target) {
                this.tooltipObj.refresh(target);
                this.tooltipTarget = target;
            }
        }
    };
    Slider.prototype.openTooltip = function(target) {
        if (this.tooltip.isVisible && this.tooltipObj && !this.isMaterialTooltip) {
            this.tooltipValue();
            this.tooltipObj.open(target);
            this.tooltipTarget = target;
        }
    };
    Slider.prototype.closeTooltip = function() {
        if (this.tooltip.isVisible && this.tooltipObj && this.tooltip.showOn !== "Always" && !this.isMaterialTooltip) {
            this.tooltipValue();
            this.tooltipObj.close();
            this.tooltipTarget = undefined;
        }
    };
    Slider.prototype.keyDown = function(event) {
        switch(event.keyCode){
            case 37:
            case 38:
            case 39:
            case 40:
            case 33:
            case 34:
            case 36:
            case 35:
                event.preventDefault();
                this.buttonClick(event);
                break;
        }
    };
    Slider.prototype.wireButtonEvt = function(destroy) {
        if (!destroy) {
            (0, $aqzbR.EventHandler).add(this.firstBtn, "mouseleave touchleave", this.buttonFocusOut, this);
            (0, $aqzbR.EventHandler).add(this.secondBtn, "mouseleave touchleave", this.buttonFocusOut, this);
            (0, $aqzbR.EventHandler).add(this.firstBtn, "mousedown touchstart", this.repeatHandlerMouse, this);
            (0, $aqzbR.EventHandler).add(this.firstBtn, "mouseup mouseleave touchup touchend", this.repeatHandlerUp, this);
            (0, $aqzbR.EventHandler).add(this.secondBtn, "mousedown touchstart", this.repeatHandlerMouse, this);
            (0, $aqzbR.EventHandler).add(this.secondBtn, "mouseup mouseleave touchup touchend", this.repeatHandlerUp, this);
            (0, $aqzbR.EventHandler).add(this.firstBtn, "focusout", this.sliderFocusOut, this);
            (0, $aqzbR.EventHandler).add(this.secondBtn, "focusout", this.sliderFocusOut, this);
        } else {
            (0, $aqzbR.EventHandler).remove(this.firstBtn, "mouseleave touchleave", this.buttonFocusOut);
            (0, $aqzbR.EventHandler).remove(this.secondBtn, "mouseleave touchleave", this.buttonFocusOut);
            (0, $aqzbR.EventHandler).remove(this.firstBtn, "mousedown touchstart", this.repeatHandlerMouse);
            (0, $aqzbR.EventHandler).remove(this.firstBtn, "mouseup mouseleave touchup touchend", this.repeatHandlerUp);
            (0, $aqzbR.EventHandler).remove(this.secondBtn, "mousedown touchstart", this.repeatHandlerMouse);
            (0, $aqzbR.EventHandler).remove(this.secondBtn, "mouseup mouseleave touchup touchend", this.repeatHandlerUp);
            (0, $aqzbR.EventHandler).remove(this.firstBtn, "focusout", this.sliderFocusOut);
            (0, $aqzbR.EventHandler).remove(this.secondBtn, "focusout", this.sliderFocusOut);
        }
    };
    Slider.prototype.rangeBarMousedown = function(event) {
        var _a, _b;
        event.preventDefault();
        this.focusSliderElement();
        if (this.type === "Range" && this.drag && event.target === this.rangeBar) {
            var xPostion = void 0;
            var yPostion = void 0;
            if (event.type === "mousedown") _a = [
                event.clientX,
                event.clientY
            ], xPostion = _a[0], yPostion = _a[1];
            else if (event.type === "touchstart") _b = [
                event.changedTouches[0].clientX,
                event.changedTouches[0].clientY
            ], xPostion = _b[0], yPostion = _b[1];
            if (this.orientation === "Horizontal") {
                this.firstPartRemain = xPostion - this.rangeBar.getBoundingClientRect().left;
                this.secondPartRemain = this.rangeBar.getBoundingClientRect().right - xPostion;
            } else {
                this.firstPartRemain = yPostion - this.rangeBar.getBoundingClientRect().top;
                this.secondPartRemain = this.rangeBar.getBoundingClientRect().bottom - yPostion;
            }
            this.minDiff = this.handleVal2 - this.handleVal1;
            this.tooltipToggle(this.rangeBar);
            var focusedElement = this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle);
            if (focusedElement) focusedElement.classList.remove($f45acda29d40e6a4$var$classNames.sliderTabHandle);
            (0, $aqzbR.EventHandler).add(document, "mousemove touchmove", this.dragRangeBarMove, this);
            (0, $aqzbR.EventHandler).add(document, "mouseup touchend", this.dragRangeBarUp, this);
        }
    };
    Slider.prototype.elementClick = function(event) {
        if (this.isDragComplete) {
            this.isDragComplete = false;
            return;
        }
        event.preventDefault();
        this.focusSliderElement();
        this.sliderBarClick(event);
        this.focusHandle();
    };
    Slider.prototype.wireEvents = function() {
        this.onresize = this.reposition.bind(this);
        window.addEventListener("resize", this.onresize);
        if (this.enabled && !this.readonly) {
            (0, $aqzbR.EventHandler).add(this.element, "click", this.elementClick, this);
            if (this.type === "Range" && this.drag) (0, $aqzbR.EventHandler).add(this.rangeBar, "mousedown touchstart", this.rangeBarMousedown, this);
            (0, $aqzbR.EventHandler).add(this.sliderContainer, "keydown", this.keyDown, this);
            (0, $aqzbR.EventHandler).add(this.sliderContainer, "keyup", this.keyUp, this);
            (0, $aqzbR.EventHandler).add(this.element, "focusout", this.sliderFocusOut, this);
            (0, $aqzbR.EventHandler).add(this.sliderContainer, "mouseover mouseout touchstart touchend", this.hover, this);
            this.wireFirstHandleEvt(false);
            if (this.type === "Range") this.wireSecondHandleEvt(false);
            if (this.showButtons) this.wireButtonEvt(false);
            this.wireMaterialTooltipEvent(false);
            if (this.isForm) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.formResetHandler, this);
        }
    };
    Slider.prototype.unwireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.element, "click", this.elementClick);
        if (this.type === "Range" && this.drag) (0, $aqzbR.EventHandler).remove(this.rangeBar, "mousedown touchstart", this.rangeBarMousedown);
        (0, $aqzbR.EventHandler).remove(this.sliderContainer, "keydown", this.keyDown);
        (0, $aqzbR.EventHandler).remove(this.sliderContainer, "keyup", this.keyUp);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.sliderFocusOut);
        (0, $aqzbR.EventHandler).remove(this.sliderContainer, "mouseover mouseout touchstart touchend", this.hover);
        this.wireFirstHandleEvt(true);
        if (this.type === "Range") this.wireSecondHandleEvt(true);
        if (this.showButtons) this.wireButtonEvt(true);
        this.wireMaterialTooltipEvent(true);
        (0, $aqzbR.EventHandler).remove(this.element, "reset", this.formResetHandler);
    };
    Slider.prototype.formResetHandler = function() {
        this.setProperties({
            "value": this.formResetValue
        }, true);
        this.setValue();
    };
    Slider.prototype.keyUp = function(event) {
        if (event.keyCode === 9 && event.target.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandle)) {
            this.focusSliderElement();
            if (!event.target.classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) {
                if (this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle).classList.remove($f45acda29d40e6a4$var$classNames.sliderTabHandle);
                event.target.classList.add($f45acda29d40e6a4$var$classNames.sliderTabHandle);
                var parentElement = event.target.parentElement;
                if (parentElement === this.element) {
                    parentElement.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTrack).classList.add($f45acda29d40e6a4$var$classNames.sliderTabTrack);
                    if (this.type === "Range" || this.type === "MinRange") parentElement.querySelector("." + $f45acda29d40e6a4$var$classNames.rangeBar).classList.add($f45acda29d40e6a4$var$classNames.sliderTabRange);
                }
                if (this.type === "Range") {
                    var previousSibling = event.target.previousSibling;
                    if (previousSibling && previousSibling.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandle)) this.activeHandle = 2;
                    else this.activeHandle = 1;
                }
                this.getHandle().focus();
                this.tooltipToggle(this.getHandle());
            }
        }
        this.closeTooltip();
        this.changeEvent("changed", event);
    };
    Slider.prototype.hover = function(event) {
        if (!(0, $3EnZW.isNullOrUndefined)(event)) {
            if (event.type === "mouseover" || event.type === "touchmove" || event.type === "mousemove" || event.type === "pointermove" || event.type === "touchstart") this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.sliderHover);
            else {
                this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.sliderHover);
                var curTarget = event.currentTarget;
                if (this.tooltip.isVisible && this.tooltip.showOn !== "Always" && this.tooltipObj && this.isMaterialTooltip && !curTarget.classList.contains($f45acda29d40e6a4$var$classNames.sliderHandleFocused) && !curTarget.classList.contains($f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.closeMaterialTooltip();
            }
        }
    };
    Slider.prototype.sliderFocusOut = function(event) {
        if (event.relatedTarget !== this.secondHandle && event.relatedTarget !== this.firstHandle && event.relatedTarget !== this.element && event.relatedTarget !== this.firstBtn && event.relatedTarget !== this.secondBtn) {
            this.closeMaterialTooltip();
            this.closeTooltip();
            if (this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle)) this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabHandle).classList.remove($f45acda29d40e6a4$var$classNames.sliderTabHandle);
            if (this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabTrack)) {
                this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabTrack).classList.remove($f45acda29d40e6a4$var$classNames.sliderTabTrack);
                if ((this.type === "Range" || this.type === "MinRange") && this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabRange)) this.element.querySelector("." + $f45acda29d40e6a4$var$classNames.sliderTabRange).classList.remove($f45acda29d40e6a4$var$classNames.sliderTabRange);
            }
            this.hiddenInput.focus();
            this.hiddenInput.blur();
            this.isElementFocused = false;
        }
    };
    Slider.prototype.removeElement = function(element) {
        if (element.parentNode) element.parentNode.removeChild(element);
    };
    Slider.prototype.changeSliderType = function(type, args) {
        if (this.isMaterialTooltip && this.materialHandle) {
            this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.materialSlider);
            this.removeElement(this.materialHandle);
            this.materialHandle = undefined;
        }
        this.removeElement(this.firstHandle);
        this.firstHandle = undefined;
        if (type !== "Default") {
            if (type === "Range") {
                this.removeElement(this.secondHandle);
                this.secondHandle = undefined;
            }
            this.removeElement(this.rangeBar);
            this.rangeBar = undefined;
        }
        if (this.tooltip.isVisible && !(0, $3EnZW.isNullOrUndefined)(this.tooltipObj)) {
            this.tooltipObj.destroy();
            this.tooltipElement = undefined;
            this.tooltipCollidedPosition = undefined;
        }
        if (this.limits.enabled) {
            if (type === "MinRange" || type === "Default") {
                if (!(0, $3EnZW.isNullOrUndefined)(this.limitBarFirst)) {
                    this.removeElement(this.limitBarFirst);
                    this.limitBarFirst = undefined;
                }
            } else if (!(0, $3EnZW.isNullOrUndefined)(this.limitBarSecond)) {
                this.removeElement(this.limitBarSecond);
                this.limitBarSecond = undefined;
            }
        }
        this.activeHandle = 1;
        this.getThemeInitialization();
        if (this.type === "Range") this.rangeValueUpdate();
        this.createRangeBar();
        if (this.limits.enabled) this.createLimitBar();
        this.setHandler();
        this.setOrientClass();
        this.wireFirstHandleEvt(!this.enabled);
        if (this.type === "Range") this.wireSecondHandleEvt(!this.enabled);
        this.setValue();
        if (this.tooltip.isVisible) {
            this.renderTooltip();
            this.wireMaterialTooltipEvent(false);
        }
        this.setBarColor();
        if (args !== "tooltip") this.updateConfig();
        if (this.readonly) {
            this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.readonly);
            this.setReadOnly();
        }
    };
    Slider.prototype.changeRtl = function() {
        if (!this.enableRtl && this.type === "Range") this.value = [
            this.handleVal2,
            this.handleVal1
        ];
        this.updateConfig();
        if (this.tooltip.isVisible) this.tooltipObj.refresh(this.firstHandle);
        if (this.showButtons) {
            var enabledRTL = this.enableRtl && this.orientation !== "Vertical";
            (0, $4ZDHT.attributes)(enabledRTL ? this.secondBtn : this.firstBtn, {
                "aria-label": "Decrease",
                title: "Decrease"
            });
            (0, $4ZDHT.attributes)(enabledRTL ? this.firstBtn : this.secondBtn, {
                "aria-label": "Increase",
                title: "Increase"
            });
        }
    };
    Slider.prototype.changeOrientation = function() {
        this.changeSliderType(this.type, "null");
    };
    Slider.prototype.updateConfig = function() {
        this.setEnableRTL();
        this.setValue();
        if (this.tooltip.isVisible) this.refreshTooltip(this.tooltipTarget);
        if (this.ticks.placement !== "None") {
            if (this.ul) {
                this.removeElement(this.ul);
                this.ul = undefined;
                this.renderScale();
            }
        }
        this.limitsPropertyChange();
    };
    Slider.prototype.limitsPropertyChange = function() {
        if (this.limits.enabled) {
            if ((0, $3EnZW.isNullOrUndefined)(this.limitBarFirst) && this.type !== "Range") this.createLimitBar();
            if ((0, $3EnZW.isNullOrUndefined)(this.limitBarFirst) && (0, $3EnZW.isNullOrUndefined)(this.limitBarSecond) && this.type === "Range") this.createLimitBar();
            this.setLimitBar();
            this.setValue();
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(this.limitBarFirst)) (0, $4ZDHT.detach)(this.limitBarFirst);
            if (!(0, $3EnZW.isNullOrUndefined)(this.limitBarSecond)) (0, $4ZDHT.detach)(this.limitBarSecond);
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Returns the string
     * @private
     */ Slider.prototype.getPersistData = function() {
        var keyEntity = [
            "value"
        ];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ Slider.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.unwireEvents();
        window.removeEventListener("resize", this.onresize);
        (0, $4ZDHT.removeClass)([
            this.sliderContainer
        ], [
            $f45acda29d40e6a4$var$classNames.sliderDisabled
        ]);
        this.firstHandle.removeAttribute("aria-orientation");
        if (this.type === "Range") this.secondHandle.removeAttribute("aria-orientation");
        if (this.sliderContainer.parentNode) this.sliderContainer.parentNode.insertBefore(this.element, this.sliderContainer);
        (0, $4ZDHT.detach)(this.sliderContainer);
        if (this.tooltip.isVisible) this.tooltipObj.destroy();
        this.element.innerHTML = "";
        this.hiddenInput = null;
        this.sliderContainer = null;
        this.sliderTrack = null;
        this.rangeBar = null;
        this.firstHandle = null;
        this.secondHandle = null;
        this.tickElementCollection = null;
        this.ul = null;
        this.firstBtn = null;
        this.secondBtn = null;
        this.materialHandle = null;
        this.tooltipObj = null;
        this.tooltipTarget = null;
        this.limitBarFirst = null;
        this.limitBarSecond = null;
        this.firstChild = null;
        this.lastChild = null;
        this.tooltipElement = null;
    };
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {SliderModel} newProp - Specifies the new properties
     * @param {SliderModel} oldProp - Specifies the old properties
     * @returns {void}
     * @private
     */ Slider.prototype.onPropertyChanged = function(newProp, oldProp) {
        var _this = this;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "cssClass":
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case "value":
                    if (newProp && oldProp) {
                        var value = (0, $3EnZW.isNullOrUndefined)(newProp.value) ? this.type === "Range" ? [
                            this.min,
                            this.max
                        ] : this.min : newProp.value;
                        this.setProperties({
                            "value": value
                        }, true);
                        if (!(0, $3EnZW.isNullOrUndefined)(oldProp.value) && oldProp.value.toString() !== value.toString()) {
                            this.setValue();
                            this.refreshTooltip(this.tooltipTarget);
                            if (this.type === "Range") {
                                if ((0, $3EnZW.isNullOrUndefined)(newProp.value) || oldProp.value[1] === value[1]) this.activeHandle = 1;
                                else this.activeHandle = 2;
                            }
                        }
                    }
                    break;
                case "min":
                case "step":
                case "max":
                    this.setMinMaxValue();
                    break;
                case "tooltip":
                    if (!(0, $3EnZW.isNullOrUndefined)(newProp.tooltip) && !(0, $3EnZW.isNullOrUndefined)(oldProp.tooltip)) {
                        this.initialTooltip = true;
                        this.setTooltip(prop);
                        if (!this.showButtons) this.wireEvents();
                    }
                    break;
                case "type":
                    if (!(0, $3EnZW.isNullOrUndefined)(oldProp) && Object.keys(oldProp).length && !(0, $3EnZW.isNullOrUndefined)(oldProp.type)) {
                        this.changeSliderType(oldProp.type, prop);
                        this.setZindex();
                    }
                    break;
                case "enableRtl":
                    if (oldProp.enableRtl !== newProp.enableRtl && this.orientation !== "Vertical") {
                        this.rtl = oldProp.enableRtl;
                        this.changeRtl();
                    }
                    break;
                case "limits":
                    this.limitsPropertyChange();
                    break;
                case "orientation":
                    this.changeOrientation();
                    break;
                case "ticks":
                    if (!(0, $3EnZW.isNullOrUndefined)(this.sliderContainer.querySelector("." + $f45acda29d40e6a4$var$classNames.scale))) {
                        (0, $4ZDHT.detach)(this.ul);
                        Array.prototype.forEach.call(this.sliderContainer.classList, function(className) {
                            if (className.match(/e-scale-/)) _this.sliderContainer.classList.remove(className);
                        });
                    }
                    if (this.ticks.placement !== "None") {
                        this.renderScale();
                        this.setZindex();
                    }
                    break;
                case "locale":
                    if (this.showButtons) this.buttonTitle();
                    break;
                case "showButtons":
                    if (newProp.showButtons) {
                        this.setButtons();
                        this.reposition();
                        if (this.enabled && !this.readonly) this.wireButtonEvt(false);
                    } else if (this.firstBtn && this.secondBtn) {
                        this.sliderContainer.removeChild(this.firstBtn);
                        this.sliderContainer.removeChild(this.secondBtn);
                        this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.sliderButtonClass);
                        this.firstBtn = undefined;
                        this.secondBtn = undefined;
                        this.reposition();
                    }
                    break;
                case "enabled":
                    this.setEnabled();
                    break;
                case "readonly":
                    this.setReadOnly();
                    break;
                case "customValues":
                    this.setValue();
                    this.reposition();
                    break;
                case "colorRange":
                    this.reposition();
                    break;
                case "width":
                    this.setElementWidth(newProp.width);
                    this.setMinMaxValue();
                    if (this.limits) this.limitsPropertyChange();
                    break;
            }
        }
    };
    Slider.prototype.setReadOnly = function() {
        if (this.readonly) {
            this.unwireEvents();
            this.sliderContainer.classList.add($f45acda29d40e6a4$var$classNames.readonly);
        } else {
            this.wireEvents();
            this.sliderContainer.classList.remove($f45acda29d40e6a4$var$classNames.readonly);
        }
    };
    Slider.prototype.setMinMaxValue = function() {
        var _this = this;
        this.setValue();
        this.refreshTooltip(this.tooltipTarget);
        if (!(0, $3EnZW.isNullOrUndefined)(this.sliderContainer.querySelector("." + $f45acda29d40e6a4$var$classNames.scale))) {
            if (this.ul) {
                (0, $4ZDHT.detach)(this.ul);
                Array.prototype.forEach.call(this.sliderContainer.classList, function(className) {
                    if (className.match(/e-scale-/)) _this.sliderContainer.classList.remove(className);
                });
            }
        }
        if (this.ticks.placement !== "None") {
            this.renderScale();
            this.setZindex();
        }
    };
    Slider.prototype.setZindex = function() {
        this.zIndex = 6;
        if (!(0, $3EnZW.isNullOrUndefined)(this.ticks) && this.ticks.placement !== "None" && !(0, $3EnZW.isNullOrUndefined)(this.ul) && !(0, $3EnZW.isNullOrUndefined)(this.element)) {
            this.ul.style.zIndex = this.zIndex + -7 + "";
            this.element.style.zIndex = this.zIndex + 2 + "";
        }
        if (!this.isMaterial && !this.isMaterial3 && !(0, $3EnZW.isNullOrUndefined)(this.ticks) && this.ticks.placement === "Both") this.element.style.zIndex = this.zIndex + 2 + "";
        if (!(0, $3EnZW.isNullOrUndefined)(this.firstHandle)) this.firstHandle.style.zIndex = this.zIndex + 3 + "";
        if (this.type === "Range" && !(0, $3EnZW.isNullOrUndefined)(this.secondHandle)) this.secondHandle.style.zIndex = this.zIndex + 4 + "";
    };
    Slider.prototype.setTooltip = function(args) {
        this.changeSliderType(this.type, args);
    };
    Slider.prototype.setBarColor = function() {
        var trackPosition;
        var trackClassName;
        var child = this.sliderTrack.lastElementChild;
        while(child){
            this.sliderTrack.removeChild(child);
            child = this.sliderTrack.lastElementChild;
        }
        for(var i = 0; i < this.colorRange.length; i++){
            if (!(0, $3EnZW.isNullOrUndefined)(this.colorRange[i].start) && !(0, $3EnZW.isNullOrUndefined)(this.colorRange[i].end)) {
                if (this.colorRange[i].end > this.colorRange[i].start) {
                    if (this.colorRange[i].start < this.min) this.colorRange[i].start = this.min;
                    if (this.colorRange[i].end > this.max) this.colorRange[i].end = this.max;
                    var startingPosition = this.checkHandlePosition(this.colorRange[i].start);
                    var endPosition = this.checkHandlePosition(this.colorRange[i].end);
                    var trackContainer = this.createElement("div");
                    trackContainer.style.backgroundColor = this.colorRange[i].color;
                    trackContainer.style.border = "1px solid " + this.colorRange[i].color;
                    if (this.orientation === "Horizontal") {
                        trackClassName = $f45acda29d40e6a4$var$classNames.sliderHorizantalColor;
                        if (this.enableRtl) {
                            if ((0, $3EnZW.isNullOrUndefined)(this.customValues)) trackPosition = this.checkHandlePosition(this.max) - this.checkHandlePosition(this.colorRange[i].end);
                            else trackPosition = this.checkHandlePosition(this.customValues.length - this.colorRange[i].end - 1);
                        } else trackPosition = this.checkHandlePosition(this.colorRange[i].start);
                        trackContainer.style.width = endPosition - startingPosition + "px";
                        trackContainer.style.left = trackPosition + "px";
                    } else {
                        trackClassName = $f45acda29d40e6a4$var$classNames.sliderVerticalColor;
                        trackPosition = this.checkHandlePosition(this.colorRange[i].start);
                        trackContainer.style.height = endPosition - startingPosition + "px";
                        trackContainer.style.bottom = trackPosition + "px";
                    }
                    trackContainer.classList.add(trackClassName);
                    this.sliderTrack.appendChild(trackContainer);
                }
            }
        }
    };
    /**
     * Gets the component name
     *
     * @returns {string} - Returns the string
     * @private
     */ Slider.prototype.getModuleName = function() {
        return "slider";
    };
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Slider.prototype, "value", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Slider.prototype, "customValues", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(1)
    ], Slider.prototype, "step", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Slider.prototype, "width", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Slider.prototype, "min", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(100)
    ], Slider.prototype, "max", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Slider.prototype, "readonly", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("Default")
    ], Slider.prototype, "type", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Collection)([
            {}
        ], $f45acda29d40e6a4$export$76ce685e0cc0f924)
    ], Slider.prototype, "colorRange", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Complex)({}, $f45acda29d40e6a4$export$f34b233da822b7a4)
    ], Slider.prototype, "ticks", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Complex)({}, $f45acda29d40e6a4$export$9989835030ecd317)
    ], Slider.prototype, "limits", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Slider.prototype, "enabled", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Complex)({}, $f45acda29d40e6a4$export$a3fed9f45e6bfeec)
    ], Slider.prototype, "tooltip", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Slider.prototype, "showButtons", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Slider.prototype, "enableAnimation", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("Horizontal")
    ], Slider.prototype, "orientation", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Slider.prototype, "cssClass", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Slider.prototype, "enableHtmlSanitizer", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "created", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "change", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "changed", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "renderingTicks", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "renderedTicks", void 0);
    $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.Event)()
    ], Slider.prototype, "tooltipChange", void 0);
    Slider = $f45acda29d40e6a4$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Slider);
    return Slider;
}((0, $hQxLN.Component));


var $38fcc89172ec2635$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $38fcc89172ec2635$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $38fcc89172ec2635$var$APPLY = "e-apply";
var $38fcc89172ec2635$var$CANCEL = "e-cancel";
var $38fcc89172ec2635$var$CURRENT = "e-current";
var $38fcc89172ec2635$var$CONTAINER = "e-container";
var $38fcc89172ec2635$var$CTRLBTN = "e-ctrl-btn";
var $38fcc89172ec2635$var$CTRLSWITCH = "e-switch-ctrl-btn";
var $38fcc89172ec2635$var$DISABLED = "e-disabled";
var $38fcc89172ec2635$var$FORMATSWITCH = "e-value-switch-btn";
var $38fcc89172ec2635$var$HANDLER = "e-handler";
var $38fcc89172ec2635$var$HEX = "e-hex";
var $38fcc89172ec2635$var$HIDEHEX = "e-hide-hex-value";
var $38fcc89172ec2635$var$HIDEOPACITY = "e-hide-opacity";
var $38fcc89172ec2635$var$HIDERGBA = "e-hide-switchable-value";
var $38fcc89172ec2635$var$HIDEVALUE = "e-hide-value";
var $38fcc89172ec2635$var$HIDEVALUESWITCH = "e-hide-valueswitcher";
var $38fcc89172ec2635$var$HSVAREA = "e-hsv-color";
var $38fcc89172ec2635$var$HSVCONTAINER = "e-hsv-container";
var $38fcc89172ec2635$var$INPUTWRAPPER = "e-selected-value";
var $38fcc89172ec2635$var$MODESWITCH = "e-mode-switch-btn";
var $38fcc89172ec2635$var$NOCOLOR = "e-nocolor-item";
var $38fcc89172ec2635$var$OPACITY = "e-opacity-value";
var $38fcc89172ec2635$var$PALETTES = "e-palette";
var $38fcc89172ec2635$var$PALETTECONTENT = "e-color-palette";
var $38fcc89172ec2635$var$PICKERCONTENT = "e-color-picker";
var $38fcc89172ec2635$var$PREVIEW = "e-preview-container";
var $38fcc89172ec2635$var$PREVIOUS = "e-previous";
var $38fcc89172ec2635$var$RTL = "e-rtl";
var $38fcc89172ec2635$var$SHOWVALUE = "e-show-value";
var $38fcc89172ec2635$var$SELECT = "e-selected";
var $38fcc89172ec2635$var$SPLITPREVIEW = "e-split-preview";
var $38fcc89172ec2635$var$TILE = "e-tile";
var $38fcc89172ec2635$var$presets = {
    default: [
        "#000000",
        "#f44336",
        "#e91e63",
        "#9c27b0",
        "#673ab7",
        "#2196f3",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#ffeb3b",
        "#ffffff",
        "#ffebee",
        "#fce4ec",
        "#f3e5f5",
        "#ede7f6",
        "#e3f2fd",
        "#e1f5fe",
        "#e0f7fa",
        "#e0f2f1",
        "#fffde7",
        "#f2f2f2",
        "#ffcdd2",
        "#f8bbd0",
        "#e1bee7",
        "#d1c4e9",
        "#bbdefb",
        "#b3e5fc",
        "#b2ebf2",
        "#b2dfdb",
        "#fff9c4",
        "#e6e6e6",
        "#ef9a9a",
        "#f48fb1",
        "#ce93d8",
        "#b39ddb",
        "#90caf9",
        "#81d4fa",
        "#80deea",
        "#80cbc4",
        "#fff59d",
        "#cccccc",
        "#e57373",
        "#f06292",
        "#ba68c8",
        "#9575cd",
        "#64b5f6",
        "#4fc3f7",
        "#4dd0e1",
        "#4db6ac",
        "#fff176",
        "#b3b3b3",
        "#ef5350",
        "#ec407a",
        "#ab47bc",
        "#7e57c2",
        "#42a5f5",
        "#29b6f6",
        "#26c6da",
        "#26a69a",
        "#ffee58",
        "#999999",
        "#e53935",
        "#d81b60",
        "#8e24aa",
        "#5e35b1",
        "#1e88e5",
        "#039be5",
        "#00acc1",
        "#00897b",
        "#fdd835",
        "#808080",
        "#d32f2f",
        "#c2185b",
        "#7b1fa2",
        "#512da8",
        "#1976d2",
        "#0288d1",
        "#0097a7",
        "#00796b",
        "#fbc02d",
        "#666666",
        "#c62828",
        "#ad1457",
        "#6a1b9a",
        "#4527a0",
        "#1565c0",
        "#0277bd",
        "#00838f",
        "#00695c",
        "#f9a825",
        "#4d4d4d",
        "#b71c1c",
        "#880e4f",
        "#4a148c",
        "#311b92",
        "#0d47a1",
        "#01579b",
        "#006064",
        "#004d40",
        "#f57f17"
    ]
};
/**
 * ColorPicker component is a user interface to select and adjust color values. It provides supports for various
 * color specification like Red Green Blue, Hue Saturation Value and Hex codes.
 * ```html
 * <input type="color" id="color-picker">
 * ```
 * ```typescript
 * <script>
 *   let colorPickerObj: ColorPicker = new ColorPicker(null , "#color-picker");
 * </script>
 * ```
 */ var $38fcc89172ec2635$export$9feb1bc2e5f1ccb3 = /** @class */ function(_super) {
    $38fcc89172ec2635$var$__extends(ColorPicker, _super);
    function ColorPicker(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.recentColors = [];
        return _this;
    }
    ColorPicker.prototype.preRender = function() {
        var ele = this.element;
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.formResetHandler, this);
        var localeText = {
            Apply: "Apply",
            Cancel: "Cancel",
            ModeSwitcher: "Switch Mode",
            RecentColors: "Recent colors"
        };
        this.l10n = new (0, $e7i2H.L10n)("colorpicker", localeText, this.locale);
        if (ele.getAttribute("ejs-for") && !ele.getAttribute("name")) ele.setAttribute("name", ele.id);
    };
    /**
     * To Initialize the component rendering
     *
     * @private
     * @returns {void}
     */ ColorPicker.prototype.render = function() {
        this.initWrapper();
        if (this.inline) this.createWidget();
        else this.createSplitBtn();
        if (!this.enableOpacity) (0, $4ZDHT.addClass)([
            this.container.parentElement
        ], $38fcc89172ec2635$var$HIDEOPACITY);
        this.renderComplete();
    };
    ColorPicker.prototype.initWrapper = function() {
        var wrapper = this.createElement("div", {
            className: "e-" + this.getModuleName() + "-wrapper"
        });
        this.element.parentNode.insertBefore(wrapper, this.element);
        wrapper.appendChild(this.element);
        (0, $4ZDHT.attributes)(this.element, {
            "tabindex": "-1",
            "spellcheck": "false",
            "aria-label": "colorpicker"
        });
        this.container = this.createElement("div", {
            className: $38fcc89172ec2635$var$CONTAINER
        });
        this.getWrapper().appendChild(this.container);
        var value = this.value ? this.roundValue(this.value).toLowerCase() : "#008000ff";
        if (this.noColor && this.mode === "Palette" && this.value === "") value = "";
        var slicedValue = value.slice(0, 7);
        if ((0, $3EnZW.isNullOrUndefined)(this.initialInputValue)) this.initialInputValue = slicedValue;
        this.element.value = slicedValue;
        if (this.enableOpacity) this.setProperties({
            "value": value
        }, true);
        else this.setProperties({
            "value": slicedValue
        }, true);
        if (this.enableRtl) wrapper.classList.add($38fcc89172ec2635$var$RTL);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        this.tileRipple = (0, $kj1BR.rippleEffect)(this.container, {
            selector: "." + $38fcc89172ec2635$var$TILE
        });
        this.ctrlBtnRipple = (0, $kj1BR.rippleEffect)(this.container, {
            selector: ".e-btn"
        });
    };
    ColorPicker.prototype.getWrapper = function() {
        return this.element.parentElement;
    };
    ColorPicker.prototype.createWidget = function() {
        if (this.mode === "Palette") {
            this.createPalette();
            if (!this.inline) this.firstPaletteFocus();
        } else {
            this.createPicker();
            if (!this.inline) this.getDragHandler().focus();
        }
        this.isRgb = true;
        this.createInput();
        this.createCtrlBtn();
        if (!this.disabled) this.wireEvents();
        if (this.inline && this.disabled) this.toggleDisabled(true);
        if ((0, $5q7BP.Browser).isDevice) this.refreshPopupPos();
    };
    ColorPicker.prototype.createSplitBtn = function() {
        var _this = this;
        var splitButton = this.createElement("button", {
            className: "e-split-colorpicker"
        });
        this.getWrapper().appendChild(splitButton);
        this.splitBtn = new (0, $03bd16efb3eac670$export$651ad66661acd392)({
            iconCss: "e-selected-color",
            target: this.container,
            disabled: this.disabled,
            enableRtl: this.enableRtl,
            createPopupOnClick: this.createPopupOnClick,
            open: this.onOpen.bind(this),
            click: function() {
                var ev = new MouseEvent("click", {
                    bubbles: true,
                    cancelable: false
                });
                _this.trigger("change", {
                    currentValue: {
                        hex: _this.value.slice(0, 7),
                        rgba: _this.convertToRgbString(_this.hexToRgb(_this.value))
                    },
                    previousValue: {
                        hex: null,
                        rgba: null
                    },
                    value: _this.value,
                    event: ev
                });
            }
        });
        this.splitBtn.createElement = this.createElement;
        this.splitBtn.appendTo(splitButton);
        this.splitBtn.element.setAttribute("aria-label", "colorpicker");
        var preview = this.createElement("span", {
            className: $38fcc89172ec2635$var$SPLITPREVIEW
        });
        (0, $4ZDHT.select)(".e-selected-color", splitButton).appendChild(preview);
        preview.style.backgroundColor = this.convertToRgbString(this.hexToRgb(this.value));
        var popupEle = this.getPopupEle();
        (0, $4ZDHT.addClass)([
            popupEle
        ], "e-colorpicker-popup");
        if (this.cssClass) (0, $4ZDHT.addClass)([
            popupEle
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
        if ((0, $5q7BP.Browser).isDevice && !this.createPopupOnClick) {
            var popupInst = this.getPopupInst();
            popupInst.relateTo = document.body;
            popupInst.position = {
                X: "center",
                Y: "center"
            };
            popupInst.targetType = "container";
            popupInst.collision = {
                X: "fit",
                Y: "fit"
            };
            popupInst.offsetY = 4;
            popupEle.style.zIndex = (0, $2vAqh.getZindexPartial)(this.splitBtn.element).toString();
        }
        this.bindCallBackEvent();
    };
    ColorPicker.prototype.onOpen = function() {
        this.trigger("open", {
            element: this.container
        });
        if (!(0, $5q7BP.Browser).isDevice) {
            var popupInst = this.getPopupInst();
            var collision = (0, $49u5W.isCollide)(popupInst.element);
            if (collision.length > 0) {
                popupInst.collision = {
                    X: "flip",
                    Y: "fit"
                };
                popupInst.position = {
                    X: "right",
                    Y: "bottom"
                };
                popupInst.targetType = "container";
            }
        }
    };
    ColorPicker.prototype.getPopupInst = function() {
        return (0, $3EnZW.getInstance)(this.getPopupEle(), (0, $2vAqh.Popup));
    };
    ColorPicker.prototype.bindCallBackEvent = function() {
        var _this = this;
        this.splitBtn.beforeOpen = function(args) {
            var callBackPromise = new (0, $03bd16efb3eac670$export$85f6557964517f1a)();
            _this.trigger("beforeOpen", args, function(observeOpenArgs) {
                if (!observeOpenArgs.cancel) {
                    var popupEle = _this.getPopupEle();
                    popupEle.style.top = (0, $3EnZW.formatUnit)(0 + pageYOffset);
                    popupEle.style.left = (0, $3EnZW.formatUnit)(0 + pageXOffset);
                    popupEle.style.display = "block";
                    _this.createWidget();
                    popupEle.style.display = "";
                    if ((0, $5q7BP.Browser).isDevice) {
                        if (_this.createPopupOnClick) {
                            var popupInst = _this.getPopupInst();
                            popupInst.relateTo = document.body;
                            popupInst.position = {
                                X: "center",
                                Y: "center"
                            };
                            popupInst.targetType = "container";
                            popupInst.collision = {
                                X: "fit",
                                Y: "fit"
                            };
                            popupInst.offsetY = 4;
                            popupEle.style.zIndex = (0, $2vAqh.getZindexPartial)(_this.splitBtn.element).toString();
                        }
                        _this.modal = _this.createElement("div");
                        _this.modal.className = "e-" + _this.getModuleName() + " e-modal";
                        _this.modal.style.display = "none";
                        document.body.insertBefore(_this.modal, popupEle);
                        document.body.className += " e-colorpicker-overflow";
                        _this.modal.style.display = "block";
                        _this.modal.style.zIndex = (Number(popupEle.style.zIndex) - 1).toString();
                    }
                }
                args.cancel = observeOpenArgs.cancel;
                callBackPromise.resolve(observeOpenArgs);
            });
            return callBackPromise;
        };
        this.splitBtn.beforeClose = function(args) {
            var callBackPromise = new (0, $03bd16efb3eac670$export$85f6557964517f1a)();
            if (!(0, $3EnZW.isNullOrUndefined)(args.event)) {
                var beforeCloseArgs = {
                    element: _this.container,
                    event: args.event,
                    cancel: false
                };
                _this.trigger("beforeClose", beforeCloseArgs, function(observedCloseArgs) {
                    if ((0, $5q7BP.Browser).isDevice && args.event.target === _this.modal) observedCloseArgs.cancel = true;
                    if (!observedCloseArgs.cancel) _this.onPopupClose();
                    args.cancel = observedCloseArgs.cancel;
                    callBackPromise.resolve(observedCloseArgs);
                });
            } else callBackPromise.resolve(args);
            return callBackPromise;
        };
    };
    ColorPicker.prototype.onPopupClose = function() {
        this.unWireEvents();
        this.destroyOtherComp();
        this.container.style.width = "";
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$SPLITPREVIEW, this.splitBtn.element).style.backgroundColor = this.convertToRgbString(this.hexToRgb(this.value));
        this.container.innerHTML = "";
        (0, $4ZDHT.removeClass)([
            this.container
        ], [
            $38fcc89172ec2635$var$PICKERCONTENT,
            $38fcc89172ec2635$var$PALETTECONTENT
        ]);
        if ((0, $5q7BP.Browser).isDevice && this.modal) {
            (0, $4ZDHT.removeClass)([
                document.body
            ], "e-colorpicker-overflow");
            this.modal.style.display = "none";
            this.modal.outerHTML = "";
            this.modal = null;
        }
    };
    ColorPicker.prototype.createPalette = function() {
        (0, $4ZDHT.classList)(this.container, [
            $38fcc89172ec2635$var$PALETTECONTENT
        ], [
            $38fcc89172ec2635$var$PICKERCONTENT
        ]);
        if (this.presetColors) {
            var paletteGroup = this.createElement("div", {
                className: "e-custom-palette"
            });
            this.appendElement(paletteGroup);
            var keys = Object.keys(this.presetColors);
            if (keys.length === 1) this.appendPalette(this.presetColors[keys[0]], keys[0], paletteGroup);
            else for(var i = 0, len = keys.length; i < len; i++)this.appendPalette(this.presetColors[keys[i]], keys[i], paletteGroup);
            if ((0, $4ZDHT.selectAll)(".e-row", paletteGroup).length > 10) (0, $4ZDHT.addClass)([
                paletteGroup
            ], "e-palette-group");
        } else this.appendPalette($38fcc89172ec2635$var$presets.default, "default");
        if (this.mode === "Palette" && !this.modeSwitcher && this.noColor) this.setNoColor();
        if (this.showRecentColors && this.recentColors && this.recentColors.length > 0) this.renderRecentColor();
        var width = parseInt(getComputedStyle(this.container).borderBottomWidth, 10);
        this.container.style.width = (0, $3EnZW.formatUnit)(this.container.children[0].offsetWidth + width + width);
        this.rgb = this.hexToRgb(this.roundValue(this.value));
        this.hsv = this.rgbToHsv.apply(this, this.rgb);
    };
    ColorPicker.prototype.renderRecentColor = function() {
        var _this = this;
        var recentClrWpr = this.container.querySelector(".e-clr-pal-rec-wpr");
        if (recentClrWpr) (0, $4ZDHT.detach)(recentClrWpr);
        var recentColorWrapper = this.createElement("div", {
            className: "e-clr-pal-rec-wpr"
        });
        var refEle = this.container.querySelector(".e-switch-ctrl-btn");
        if (refEle) this.container.insertBefore(recentColorWrapper, refEle);
        else this.container.appendChild(recentColorWrapper);
        var recentClrSpan = this.createElement("label", {
            className: "e-recent-clr-span"
        });
        recentClrSpan.textContent = this.l10n.getConstant("RecentColors");
        recentColorWrapper.appendChild(recentClrSpan);
        if (this.recentColors.length > 0) {
            this.recentColors = this.recentColors.filter(function(item, index) {
                return _this.recentColors.indexOf(item) === index;
            });
            while(this.recentColors.length > 10)this.recentColors.pop();
            this.appendPalette(this.recentColors, "recent-color", recentColorWrapper);
        }
    };
    ColorPicker.prototype.firstPaletteFocus = function() {
        if (!(0, $4ZDHT.select)("." + $38fcc89172ec2635$var$SELECT, this.container.children[0])) (0, $4ZDHT.selectAll)("." + $38fcc89172ec2635$var$PALETTES, this.container)[0].focus();
    };
    ColorPicker.prototype.appendPalette = function(colors, key, refEle) {
        var palette = this.createElement("div", {
            className: $38fcc89172ec2635$var$PALETTES,
            attrs: {
                "tabindex": "0",
                "role": "grid"
            }
        });
        if (key === "recent-color") palette.classList.add("e-recent-palette");
        if (refEle) refEle.appendChild(palette);
        else this.appendElement(palette);
        var row;
        var tile;
        var roundedColor;
        for(var i = 0, len = colors.length; i < len; i++){
            if (i === 0 || i % this.columns === 0) {
                row = this.createElement("div", {
                    className: "e-row",
                    attrs: {
                        "role": "row"
                    }
                });
                palette.appendChild(row);
            }
            roundedColor = this.roundValue(colors[i]).toLowerCase();
            tile = this.createElement("span", {
                className: $38fcc89172ec2635$var$TILE,
                attrs: {
                    "role": "gridcell",
                    "aria-label": roundedColor,
                    "aria-selected": "false"
                }
            });
            this.trigger("beforeTileRender", {
                element: tile,
                presetName: key,
                value: colors[i]
            });
            row.appendChild(tile);
            if (this.value === roundedColor && key !== "recent-color") {
                this.addTileSelection(tile);
                palette.focus();
            }
            tile.style.backgroundColor = this.convertToRgbString(this.hexToRgb(roundedColor));
        }
    };
    ColorPicker.prototype.setNoColor = function() {
        var noColorEle = this.container.querySelector(".e-row").children[0];
        noColorEle.classList.add($38fcc89172ec2635$var$NOCOLOR);
        if (!this.value) {
            noColorEle.classList.add($38fcc89172ec2635$var$SELECT);
            (0, $4ZDHT.closest)(noColorEle, "." + $38fcc89172ec2635$var$PALETTES).focus();
        }
        [
            "aria-selected",
            "aria-label"
        ].forEach(function(attr) {
            noColorEle.removeAttribute(attr);
        });
        noColorEle.style.backgroundColor = "";
    };
    ColorPicker.prototype.appendElement = function(ele, insertPos) {
        if (insertPos === void 0) insertPos = 0;
        var refEle = this.container.children[insertPos];
        if (refEle) this.container.insertBefore(ele, refEle);
        else this.container.appendChild(ele);
    };
    ColorPicker.prototype.addTileSelection = function(ele) {
        if (ele) {
            ele.classList.add($38fcc89172ec2635$var$SELECT);
            ele.setAttribute("aria-selected", "true");
        }
    };
    ColorPicker.prototype.createPicker = function() {
        (0, $4ZDHT.classList)(this.container, [
            $38fcc89172ec2635$var$PICKERCONTENT
        ], [
            $38fcc89172ec2635$var$PALETTECONTENT
        ]);
        var hsvContainer = this.createElement("div", {
            className: $38fcc89172ec2635$var$HSVCONTAINER
        });
        this.appendElement(hsvContainer);
        hsvContainer.appendChild(this.createElement("div", {
            className: $38fcc89172ec2635$var$HSVAREA
        }));
        var dragHandler = this.createElement("span", {
            className: $38fcc89172ec2635$var$HANDLER,
            attrs: {
                "tabindex": "0"
            }
        });
        hsvContainer.appendChild(dragHandler);
        if (this.value === null || this.value === "") this.value = "#008000ff";
        this.rgb = this.hexToRgb(this.value);
        this.hsv = this.rgbToHsv.apply(this, this.rgb);
        this.setHsvContainerBg();
        this.setHandlerPosition();
        this.createSlider();
        this.createDragTooltip();
    };
    ColorPicker.prototype.setHsvContainerBg = function(h) {
        if (h === void 0) h = this.hsv[0];
        this.getHsvContainer().style.backgroundColor = this.convertToRgbString(this.hsvToRgb(h, 100, 100, 1));
    };
    ColorPicker.prototype.getHsvContainer = function() {
        return (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HSVCONTAINER, this.container);
    };
    ColorPicker.prototype.setHandlerPosition = function() {
        var dragHandler = this.getDragHandler();
        var hsvArea = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HSVAREA, this.container);
        if (this.enableRtl) dragHandler.style.left = (0, $3EnZW.formatUnit)((hsvArea.offsetWidth - dragHandler.offsetWidth / 2.5) * Math.abs(100 - this.hsv[1]) / 100);
        else dragHandler.style.left = (0, $3EnZW.formatUnit)((hsvArea.offsetWidth - dragHandler.offsetWidth / 2.5) * this.hsv[1] / 100);
        dragHandler.style.top = (0, $3EnZW.formatUnit)((hsvArea.offsetHeight - dragHandler.offsetHeight / 2.5) * (100 - this.hsv[2]) / 100);
    };
    ColorPicker.prototype.createSlider = function() {
        var sliderPreviewWrapper = this.createElement("div", {
            className: "e-slider-preview"
        });
        this.appendElement(sliderPreviewWrapper, 1);
        this.createPreview(sliderPreviewWrapper);
        var sliderWrapper = this.createElement("div", {
            className: "e-colorpicker-slider"
        });
        sliderPreviewWrapper.insertBefore(sliderWrapper, sliderPreviewWrapper.children[0]);
        var slider = this.createElement("div", {
            className: "e-hue-slider"
        });
        sliderWrapper.appendChild(slider);
        this.hueSlider = new (0, $f45acda29d40e6a4$export$472062a354075cee)({
            value: this.hsv[0],
            min: 0,
            max: 359,
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            change: this.hueChange.bind(this)
        });
        this.hueSlider.createElement = this.createElement;
        this.hueSlider.appendTo(slider);
        if (this.enableOpacity) {
            slider = this.createElement("div", {
                className: "e-opacity-slider"
            });
            sliderWrapper.appendChild(slider);
            this.createOpacitySlider(slider);
        }
    };
    ColorPicker.prototype.createOpacitySlider = function(slider) {
        this.opacitySlider = new (0, $f45acda29d40e6a4$export$472062a354075cee)({
            value: this.rgb[3] * 100,
            min: 0,
            max: 100,
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            change: this.opacityChange.bind(this)
        });
        this.opacitySlider.createElement = this.createElement;
        this.opacitySlider.appendTo(slider);
        var opacityBgTrack = this.createElement("div", {
            className: "e-opacity-empty-track"
        });
        slider.appendChild(opacityBgTrack);
        this.updateOpacitySliderBg();
    };
    ColorPicker.prototype.updateOpacitySliderBg = function() {
        var direction = this.enableRtl ? "to left" : "to right";
        var opacityEle = (0, $4ZDHT.select)(".e-opacity-empty-track", this.opacitySlider.element);
        if (opacityEle) opacityEle.style.background = "linear-gradient(" + direction + ", rgba(" + this.rgb.slice(0, 3) + ", 0) 0%, " + this.convertToRgbString(this.rgb.slice(0, 3)) + " 100%)";
    };
    ColorPicker.prototype.hueChange = function(args) {
        this.hsv[0] = args.value;
        this.setHsvContainerBg();
        this.convertToOtherFormat();
    };
    ColorPicker.prototype.opacityChange = function(args) {
        var value = args.value;
        var pValue = this.rgbToHex(this.rgb);
        this.hsv[3] = value / 100;
        this.rgb[3] = value / 100;
        var cValue = this.rgbToHex(this.rgb);
        this.updateOpacityInput(value);
        var rgb = this.convertToRgbString(this.rgb);
        this.updatePreview(rgb);
        this.triggerEvent(cValue, pValue, rgb);
    };
    ColorPicker.prototype.updateOpacityInput = function(value) {
        if (this.enableOpacity && !this.getWrapper().classList.contains($38fcc89172ec2635$var$HIDEVALUE)) {
            var opacityTextBoxInst = (0, $3EnZW.getInstance)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$OPACITY, this.container), (0, $75082a70d3498091$export$d910e4596d16bb81));
            opacityTextBoxInst.value = value;
            opacityTextBoxInst.dataBind();
        }
    };
    ColorPicker.prototype.createPreview = function(parentEle) {
        var previewContainer = this.createElement("div", {
            className: $38fcc89172ec2635$var$PREVIEW
        });
        parentEle.appendChild(previewContainer);
        var preview = this.createElement("span", {
            className: "e-preview " + $38fcc89172ec2635$var$CURRENT
        });
        previewContainer.appendChild(preview);
        var colorValue = this.convertToRgbString(this.rgb);
        preview.style.backgroundColor = colorValue;
        preview = this.createElement("span", {
            className: "e-preview " + $38fcc89172ec2635$var$PREVIOUS
        });
        previewContainer.appendChild(preview);
        preview.style.backgroundColor = colorValue;
    };
    ColorPicker.prototype.isPicker = function() {
        return !this.container.classList.contains($38fcc89172ec2635$var$PALETTECONTENT);
    };
    ColorPicker.prototype.getPopupEle = function() {
        return this.container.parentElement;
    };
    ColorPicker.prototype.createNumericInput = function(element, value, label, max) {
        var _this = this;
        var numericInput = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            value: value,
            placeholder: label,
            min: 0,
            max: max,
            format: "###.##",
            showSpinButton: false,
            floatLabelType: "Always",
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            readonly: this.isPicker() ? false : true,
            change: function(args) {
                if (args.event) _this.inputHandler(args.event);
            }
        });
        numericInput.createElement = this.createElement;
        numericInput.appendTo(element);
    };
    ColorPicker.prototype.createInput = function() {
        var isPicker = this.isPicker();
        var wrapper = this.getWrapper();
        if (isPicker && !wrapper.classList.contains($38fcc89172ec2635$var$HIDEVALUE) || !isPicker && wrapper.classList.contains($38fcc89172ec2635$var$SHOWVALUE)) {
            var inputWrap = this.createElement("div", {
                className: $38fcc89172ec2635$var$INPUTWRAPPER
            });
            if (isPicker) this.appendElement(inputWrap, 2);
            else this.appendElement(inputWrap, 1);
            var container = this.createElement("div", {
                className: "e-input-container"
            });
            inputWrap.appendChild(container);
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEVALUESWITCH)) this.appendValueSwitchBtn(inputWrap);
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEHEX)) {
                var hexInput = this.createElement("input", {
                    className: $38fcc89172ec2635$var$HEX,
                    attrs: {
                        "maxlength": "7",
                        "spellcheck": "false",
                        "aria-label": "HEX"
                    }
                });
                container.appendChild(hexInput);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).createInput({
                    element: hexInput,
                    floatLabelType: "Always",
                    properties: {
                        placeholder: "HEX",
                        enableRtl: this.enableRtl,
                        enabled: !this.disabled,
                        readonly: this.isPicker() ? false : true
                    }
                }, this.createElement);
                (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(this.value.slice(0, 7), hexInput);
                hexInput.addEventListener("input", this.inputHandler.bind(this));
            }
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDERGBA)) {
                var label = void 0;
                var value = void 0;
                if (this.isRgb) {
                    label = "RGB";
                    value = this.rgb;
                } else {
                    label = "HSV";
                    value = this.hsv;
                }
                var clsName = [
                    "rh",
                    "gs",
                    "bv"
                ];
                for(var i = 0; i < 3; i++)this.createNumericInput(container.appendChild(this.createElement("input", {
                    className: "e-" + clsName[i] + "-value"
                })), value[i], label[i], 255);
                if (this.enableOpacity) this.appendOpacityValue(container);
            }
        }
    };
    ColorPicker.prototype.appendOpacityValue = function(container) {
        this.createNumericInput(container.appendChild(this.createElement("input", {
            className: $38fcc89172ec2635$var$OPACITY
        })), this.rgb[3] * 100, "A", 100);
    };
    ColorPicker.prototype.appendValueSwitchBtn = function(targetEle) {
        var valueSwitchBtn = this.createElement("button", {
            className: "e-icons e-css e-btn e-flat e-icon-btn " + $38fcc89172ec2635$var$FORMATSWITCH,
            attrs: {
                "title": "Toggle format"
            }
        });
        targetEle.appendChild(valueSwitchBtn);
        if (this.isPicker() && !this.getWrapper().classList.contains($38fcc89172ec2635$var$HIDERGBA)) valueSwitchBtn.addEventListener("click", this.formatSwitchHandler.bind(this));
    };
    ColorPicker.prototype.createCtrlBtn = function() {
        if (this.modeSwitcher || this.showButtons) {
            this.l10n.setLocale(this.locale);
            var btnWrapper = this.createElement("div", {
                className: $38fcc89172ec2635$var$CTRLSWITCH
            });
            this.container.appendChild(btnWrapper);
            if (this.showButtons) {
                var controlBtnWrapper = this.createElement("div", {
                    className: $38fcc89172ec2635$var$CTRLBTN
                });
                btnWrapper.appendChild(controlBtnWrapper);
                var apply = this.l10n.getConstant("Apply");
                controlBtnWrapper.appendChild(this.createElement("button", {
                    innerHTML: apply,
                    className: "e-btn e-css e-flat e-primary e-small " + $38fcc89172ec2635$var$APPLY,
                    attrs: {
                        "title": apply
                    }
                }));
                var cancel = this.l10n.getConstant("Cancel");
                controlBtnWrapper.appendChild(this.createElement("button", {
                    innerHTML: cancel,
                    className: "e-btn e-css e-flat e-small " + $38fcc89172ec2635$var$CANCEL,
                    attrs: {
                        "title": cancel
                    }
                }));
            }
            if (this.modeSwitcher) this.appendModeSwitchBtn();
        }
    };
    ColorPicker.prototype.appendModeSwitchBtn = function() {
        var modeSwitcher = this.createElement("button", {
            className: "e-icons e-btn e-flat e-icon-btn " + $38fcc89172ec2635$var$MODESWITCH,
            attrs: {
                title: this.l10n.getConstant("ModeSwitcher")
            }
        });
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLSWITCH, this.container).insertBefore(modeSwitcher, (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLBTN, this.container));
    };
    ColorPicker.prototype.createDragTooltip = function() {
        var _this = this;
        var tooltip = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)({
            opensOn: "Custom",
            showTipPointer: false,
            cssClass: "e-color-picker-tooltip",
            htmlAttributes: {
                title: "tooltip"
            },
            beforeOpen: function(args) {
                _this.tooltipEle = args.element;
            },
            animation: {
                open: {
                    effect: "None"
                },
                close: {
                    effect: "None"
                }
            }
        });
        tooltip.createElement = this.createElement;
        tooltip.appendTo(this.container);
        tooltip.open(this.container);
        this.tooltipEle.style.zIndex = (0, $2vAqh.getZindexPartial)(this.tooltipEle).toString();
        this.tooltipEle.setAttribute("aria-label", "colorpicker-tooltip");
        (0, $4ZDHT.select)(".e-tip-content", this.tooltipEle).appendChild(this.createElement("div", {
            className: "e-tip-transparent"
        }));
    };
    ColorPicker.prototype.getTooltipInst = function() {
        return (0, $3EnZW.getInstance)(this.container, (0, $47b4397f26bd41a3$export$28c660c63b792dea));
    };
    ColorPicker.prototype.setTooltipOffset = function(value) {
        this.getTooltipInst().offsetY = value;
    };
    ColorPicker.prototype.toggleDisabled = function(enable) {
        if (enable) this.getWrapper().classList.add($38fcc89172ec2635$var$DISABLED);
        else this.getWrapper().classList.remove($38fcc89172ec2635$var$DISABLED);
        if (this.showButtons) [].slice.call((0, $4ZDHT.selectAll)(".e-btn", this.container)).forEach(function(ele) {
            if (enable) (0, $4ZDHT.attributes)(ele, {
                "disabled": ""
            });
            else ele.removeAttribute("disabled");
        });
    };
    ColorPicker.prototype.convertToRgbString = function(rgb) {
        return rgb.length ? rgb.length === 4 ? "rgba(" + rgb.join() + ")" : "rgb(" + rgb.join() + ")" : "";
    };
    ColorPicker.prototype.convertToHsvString = function(hsv) {
        return hsv.length === 4 ? "hsva(" + hsv.join() + ")" : "hsv(" + hsv.join() + ")";
    };
    ColorPicker.prototype.updateHsv = function() {
        this.hsv[1] = this.hsv[1] > 100 ? 100 : this.hsv[1];
        this.hsv[2] = this.hsv[2] > 100 ? 100 : this.hsv[2];
        this.setHandlerPosition();
    };
    ColorPicker.prototype.convertToOtherFormat = function(isKey, e) {
        if (isKey === void 0) isKey = false;
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = this.hsvToRgb.apply(this, this.hsv);
        var cValue = this.rgbToHex(this.rgb);
        var rgba = this.convertToRgbString(this.rgb);
        this.updatePreview(rgba);
        this.updateInput(cValue);
        this.triggerEvent(cValue, pValue, rgba, isKey, e);
    };
    ColorPicker.prototype.updateInput = function(value) {
        var wrapper = this.getWrapper();
        if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEVALUE)) {
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEHEX)) (0, $168e4e125732cd26$export$f5b8910cec6cf069).setValue(value.substr(0, 7), (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HEX, this.container));
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDERGBA)) {
                if (this.isRgb) this.updateValue(this.rgb, false);
                else this.updateValue(this.hsv, false);
            }
        }
    };
    ColorPicker.prototype.updatePreview = function(value) {
        if (this.enableOpacity) this.updateOpacitySliderBg();
        (0, $4ZDHT.select)(".e-tip-transparent", this.tooltipEle).style.backgroundColor = value;
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$PREVIEW + " ." + $38fcc89172ec2635$var$CURRENT, this.container).style.backgroundColor = value;
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$PREVIEW + " ." + $38fcc89172ec2635$var$PREVIOUS, this.container).style.backgroundColor = this.convertToRgbString(this.hexToRgb(this.value));
    };
    ColorPicker.prototype.getDragHandler = function() {
        return (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HANDLER, this.container);
    };
    ColorPicker.prototype.removeTileSelection = function() {
        var selectedEle = [].slice.call((0, $4ZDHT.selectAll)("." + $38fcc89172ec2635$var$SELECT, this.container));
        selectedEle.forEach(function(ele) {
            ele.classList.remove($38fcc89172ec2635$var$SELECT);
            ele.setAttribute("aria-selected", "false");
        });
    };
    ColorPicker.prototype.convertRgbToNumberArray = function(value) {
        return value.slice(value.indexOf("(") + 1, value.indexOf(")")).split(",").map(function(n, i) {
            return i !== 3 ? parseInt(n, 10) : parseFloat(n);
        });
    };
    /**
     * To get color value in specified type.
     *
     * @param {string} value - Specify the color value.
     * @param {string} type - Specify the type to which the specified color needs to be converted.
     * @method getValue
     * @returns {string} - Color value
     */ ColorPicker.prototype.getValue = function(value, type) {
        if (!value) value = this.value;
        type = !type ? "hex" : type.toLowerCase();
        if (value[0] === "r") {
            var cValue = this.convertRgbToNumberArray(value);
            if (type === "hex" || type === "hexa") {
                var hex = this.rgbToHex(cValue);
                return type === "hex" ? hex.slice(0, 7) : hex;
            } else {
                if (type === "hsv") return this.convertToHsvString(this.rgbToHsv.apply(this, cValue.slice(0, 3)));
                else {
                    if (type === "hsva") return this.convertToHsvString(this.rgbToHsv.apply(this, cValue));
                    else return "null";
                }
            }
        } else if (value[0] === "h") {
            var cValue = this.hsvToRgb.apply(this, this.convertRgbToNumberArray(value));
            if (type === "rgba") return this.convertToRgbString(cValue);
            else if (type === "hex" || type === "hexa") {
                var hex = this.rgbToHex(cValue);
                return type === "hex" ? hex.slice(0, 7) : hex;
            } else {
                if (type === "rgb") return this.convertToRgbString(cValue.slice(0, 3));
                else return "null";
            }
        } else {
            value = this.roundValue(value);
            var rgb = this.hexToRgb(value);
            if (type === "rgb" || type === "hsv") rgb = rgb.slice(0, 3);
            if (type === "rgba" || type === "rgb") return this.convertToRgbString(rgb);
            else {
                if (type === "hsva" || type === "hsv") return this.convertToHsvString(this.rgbToHsv.apply(this, rgb));
                else {
                    if (type === "hex") return value.slice(0, 7);
                    else {
                        if (type === "a") return rgb[3].toString();
                        else return "null";
                    }
                }
            }
        }
    };
    /**
     * To show/hide ColorPicker popup based on current state of the SplitButton.
     *
     * @method toggle
     * @returns {void}
     */ ColorPicker.prototype.toggle = function() {
        if (this.container.parentElement.classList.contains("e-popup-close")) this.splitBtn.toggle();
        else this.closePopup(null);
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */ ColorPicker.prototype.getModuleName = function() {
        return "colorpicker";
    };
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */ ColorPicker.prototype.getPersistData = function() {
        return this.addOnPersist([
            "value"
        ]);
    };
    ColorPicker.prototype.wireEvents = function() {
        if (this.isPicker()) {
            var dragHandler = this.getDragHandler();
            (0, $aqzbR.EventHandler).add(dragHandler, "keydown", this.pickerKeyDown, this);
            var ctrlBtn = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLBTN, this.container);
            if (ctrlBtn) (0, $aqzbR.EventHandler).add(ctrlBtn, "keydown", this.ctrlBtnKeyDown, this);
            (0, $aqzbR.EventHandler).add(this.getHsvContainer(), "mousedown touchstart", this.handlerDown, this);
            if (this.modeSwitcher || this.showButtons) this.addCtrlSwitchEvent();
            (0, $aqzbR.EventHandler).add((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$PREVIOUS, this.container), "click", this.previewHandler, this);
        } else {
            (0, $aqzbR.EventHandler).add(this.container, "click", this.paletteClickHandler, this);
            (0, $aqzbR.EventHandler).add(this.container, "keydown", this.paletteKeyDown, this);
        }
    };
    ColorPicker.prototype.formResetHandler = function() {
        this.value = this.initialInputValue;
        (0, $4ZDHT.attributes)(this.element, {
            "value": this.initialInputValue
        });
    };
    ColorPicker.prototype.addCtrlSwitchEvent = function() {
        var ctrlSwitchBtn = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLSWITCH, this.container);
        if (ctrlSwitchBtn) (0, $aqzbR.EventHandler).add(ctrlSwitchBtn, "click", this.btnClickHandler, this);
    };
    ColorPicker.prototype.ctrlBtnKeyDown = function(e) {
        if (e.keyCode === 13) {
            var applyBtn = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$APPLY, this.container);
            if (applyBtn) {
                var cValue = this.rgbToHex(this.rgb);
                this.triggerChangeEvent(cValue);
            }
            this.splitBtn.element.focus();
        }
    };
    ColorPicker.prototype.pickerKeyDown = function(e) {
        switch(e.keyCode){
            case 39:
                this.handlerDragPosition(1, this.enableRtl ? -1 : 1, e);
                break;
            case 37:
                this.handlerDragPosition(1, this.enableRtl ? 1 : -1, e);
                break;
            case 38:
                this.handlerDragPosition(2, 1, e);
                break;
            case 40:
                this.handlerDragPosition(2, -1, e);
                break;
            case 13:
                e.preventDefault();
                var cValue = this.rgbToHex(this.rgb);
                this.enterKeyHandler(cValue);
        }
    };
    ColorPicker.prototype.enterKeyHandler = function(value) {
        this.triggerChangeEvent(value);
        if (!this.inline) this.splitBtn.element.focus();
    };
    ColorPicker.prototype.closePopup = function(e) {
        var _this = this;
        var beforeCloseArgs = {
            element: this.container,
            event: e,
            cancel: false
        };
        this.trigger("beforeClose", beforeCloseArgs, function(observedcloseArgs) {
            if (!observedcloseArgs.cancel) {
                _this.splitBtn.toggle();
                _this.onPopupClose();
            }
        });
    };
    ColorPicker.prototype.triggerChangeEvent = function(value, e) {
        var hex = value.slice(0, 7);
        this.trigger("change", {
            currentValue: {
                hex: hex,
                rgba: this.convertToRgbString(this.rgb)
            },
            event: e,
            previousValue: {
                hex: this.value.slice(0, 7),
                rgba: this.convertToRgbString(this.hexToRgb(this.value))
            },
            value: this.enableOpacity ? value : hex
        });
        if (this.showRecentColors) {
            this.recentColors.unshift(hex);
            if (this.inline) this.renderRecentColor();
        }
        if (this.enableOpacity) this.setProperties({
            "value": value
        }, true);
        else this.setProperties({
            "value": hex
        }, true);
        this.element.value = hex ? hex : "#000000";
    };
    ColorPicker.prototype.handlerDragPosition = function(prob, value, e) {
        e.preventDefault();
        this.hsv[prob] += value * (e.ctrlKey ? 1 : 3);
        if (this.hsv[prob] < 0) this.hsv[prob] = 0;
        this.updateHsv();
        this.convertToOtherFormat(true, e);
    };
    ColorPicker.prototype.handlerDown = function(e) {
        e.preventDefault();
        if (e.type === "mousedown") {
            this.clientX = Math.abs(e.pageX - pageXOffset);
            this.clientY = Math.abs(e.pageY - pageYOffset);
            this.setTooltipOffset(8);
        } else {
            this.clientX = Math.abs(e.changedTouches[0].pageX - pageXOffset);
            this.clientY = Math.abs(e.changedTouches[0].pageY - pageYOffset);
            this.setTooltipOffset(-8);
        }
        this.setHsv(this.clientX, this.clientY);
        this.getDragHandler().style.transition = "left .4s cubic-bezier(.25, .8, .25, 1), top .4s cubic-bezier(.25, .8, .25, 1)";
        this.updateHsv();
        this.convertToOtherFormat(false, e);
        this.getDragHandler().focus();
        (0, $aqzbR.EventHandler).add(document, "mousemove touchmove", this.handlerMove, this);
        (0, $aqzbR.EventHandler).add(document, "mouseup touchend", this.handlerEnd, this);
    };
    ColorPicker.prototype.handlerMove = function(e) {
        if (e.type !== "touchmove") e.preventDefault();
        var x;
        var y;
        if (e.type === "mousemove") {
            x = Math.abs(e.pageX - pageXOffset);
            y = Math.abs(e.pageY - pageYOffset);
        } else {
            x = Math.abs(e.changedTouches[0].pageX - pageXOffset);
            y = Math.abs(e.changedTouches[0].pageY - pageYOffset);
        }
        this.setHsv(x, y);
        var dragHandler = this.getDragHandler();
        this.updateHsv();
        this.convertToOtherFormat(false, e);
        this.getTooltipInst().refresh(dragHandler);
        if (!this.tooltipEle.style.transform) {
            if (Math.abs(this.clientX - x) > 8 || Math.abs(this.clientY - y) > 8) {
                (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HSVAREA, this.container).style.cursor = "pointer";
                dragHandler.style.transition = "none";
                if (!this.inline) this.tooltipEle.style.zIndex = (parseInt(this.getPopupEle().style.zIndex, 10) + 1).toString();
                this.tooltipEle.style.transform = "rotate(45deg)";
                dragHandler.classList.add("e-hide-handler");
            }
        }
    };
    ColorPicker.prototype.setHsv = function(clientX, clientY) {
        var ele = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HSVAREA, this.container);
        var position = ele.getBoundingClientRect();
        if (this.enableRtl) clientX = clientX > position.right ? 0 : Math.abs(clientX - position.right);
        else clientX = clientX > position.left ? Math.abs(clientX - position.left) : 0;
        clientY = clientY > position.top ? Math.abs(clientY - position.top) : 0;
        this.hsv[2] = Math.round(Number(100 * (ele.offsetHeight - Math.max(0, Math.min(ele.offsetHeight, clientY - ele.offsetTop))) / ele.offsetHeight) * 10) / 10;
        this.hsv[1] = Math.round(Number(100 * Math.max(0, Math.min(ele.offsetWidth, clientX - ele.offsetLeft)) / ele.offsetWidth) * 10) / 10;
    };
    ColorPicker.prototype.handlerEnd = function(e) {
        if (e.type !== "touchend") e.preventDefault();
        (0, $aqzbR.EventHandler).remove(document, "mousemove touchmove", this.handlerMove);
        (0, $aqzbR.EventHandler).remove(document, "mouseup touchend", this.handlerEnd);
        var dragHandler = this.getDragHandler();
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$HSVAREA, this.container).style.cursor = "";
        if (this.tooltipEle.style.transform) {
            this.tooltipEle.style.transform = "";
            dragHandler.classList.remove("e-hide-handler");
        }
        if (!this.inline && !this.showButtons) this.closePopup(e);
    };
    ColorPicker.prototype.btnClickHandler = function(e) {
        var target = e.target;
        if ((0, $4ZDHT.closest)(target, "." + $38fcc89172ec2635$var$MODESWITCH)) {
            e.stopPropagation();
            this.switchToPalette();
        } else if (target.classList.contains($38fcc89172ec2635$var$APPLY) || target.classList.contains($38fcc89172ec2635$var$CANCEL)) this.ctrlBtnClick(target, e);
    };
    ColorPicker.prototype.switchToPalette = function() {
        this.trigger("beforeModeSwitch", {
            element: this.container,
            mode: "Palette"
        });
        this.unWireEvents();
        this.destroyOtherComp();
        (0, $4ZDHT.detach)((0, $4ZDHT.select)(".e-slider-preview", this.container));
        if (!this.getWrapper().classList.contains($38fcc89172ec2635$var$HIDEVALUE)) (0, $4ZDHT.remove)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$INPUTWRAPPER, this.container));
        (0, $4ZDHT.detach)(this.getHsvContainer());
        this.createPalette();
        this.firstPaletteFocus();
        this.createInput();
        this.refreshPopupPos();
        //for image editor popup position refreshing
        if (this.element.parentElement && this.element.parentElement.parentElement && this.element.parentElement.parentElement.classList.contains("e-ie-ddb-popup")) this.refreshImageEditorPopupPos();
        this.wireEvents();
        this.trigger("onModeSwitch", {
            element: this.container,
            mode: "Palette"
        });
    };
    //for image editor popup position refreshing
    ColorPicker.prototype.refreshImageEditorPopupPos = function() {
        if ((0, $5q7BP.Browser).isDevice) {
            var popupEle = this.getPopupEle();
            popupEle.style.left = (0, $3EnZW.formatUnit)(0 + pageXOffset);
            popupEle.style.top = (0, $3EnZW.formatUnit)(0 + pageYOffset);
            var btnElem = document.querySelector("#" + this.element.parentElement.parentElement.id.split("-popup")[0]);
            if (btnElem) //eslint-disable-next-line @typescript-eslint/no-explicit-any
            popupEle.parentElement.ej2_instances[0].refreshPosition(btnElem);
        }
    };
    ColorPicker.prototype.refreshPopupPos = function() {
        if (!this.inline) {
            var popupEle = this.getPopupEle();
            popupEle.style.left = (0, $3EnZW.formatUnit)(0 + pageXOffset);
            popupEle.style.top = (0, $3EnZW.formatUnit)(0 + pageYOffset);
            this.getPopupInst().refreshPosition(this.splitBtn.element.parentElement);
        }
    };
    ColorPicker.prototype.formatSwitchHandler = function() {
        if (this.isRgb) {
            this.updateValue(this.hsv, true, 3, [
                360,
                100,
                100
            ]);
            this.isRgb = false;
        } else {
            this.updateValue(this.rgb, true, 2);
            this.isRgb = true;
        }
    };
    ColorPicker.prototype.updateValue = function(value, format, idx, max) {
        var clsName = [
            "e-rh-value",
            "e-gs-value",
            "e-bv-value"
        ];
        var inst;
        for(var i = 0, len = clsName.length; i < len; i++){
            inst = (0, $3EnZW.getInstance)((0, $4ZDHT.select)("." + clsName[i], this.container), (0, $75082a70d3498091$export$d910e4596d16bb81));
            inst.value = Math.round(value[i]);
            if (format) {
                inst.placeholder = clsName[i].substr(idx, 1).toUpperCase();
                inst.max = max ? max[i] : 255;
            }
            inst.dataBind();
        }
    };
    ColorPicker.prototype.previewHandler = function(e) {
        var target = e.target;
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = this.convertRgbToNumberArray(target.style.backgroundColor);
        if (!this.rgb[3]) this.rgb[3] = 1;
        var cValue = this.rgbToHex(this.rgb);
        var hsv = this.rgbToHsv.apply(this, this.rgb);
        if (hsv[0] !== this.hsv[0]) {
            this.hueSlider.setProperties({
                "value": hsv[0]
            }, true);
            this.hueSlider.refresh();
        }
        this.setHsvContainerBg(hsv[0]);
        if (this.enableOpacity && hsv[3] !== this.hsv[3]) {
            this.opacitySlider.setProperties({
                "value": hsv[3] * 100
            }, true);
            this.opacitySlider.refresh();
            this.updateOpacitySliderBg();
        }
        this.hsv = hsv;
        this.setHandlerPosition();
        this.updateInput(cValue);
        (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$PREVIEW + " ." + $38fcc89172ec2635$var$CURRENT, this.container).style.backgroundColor = this.convertToRgbString(this.rgb);
        this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb), false, e);
    };
    ColorPicker.prototype.paletteClickHandler = function(e) {
        e.preventDefault();
        var target = e.target;
        if (target.classList.contains($38fcc89172ec2635$var$TILE)) {
            this.removeTileSelection();
            this.addTileSelection(target);
            if (target.classList.contains($38fcc89172ec2635$var$NOCOLOR)) this.noColorTile();
            else {
                var cValue = target.getAttribute("aria-label");
                var pValue = this.rgbToHex(this.rgb);
                this.rgb = this.hexToRgb(this.roundValue(cValue));
                this.hsv = this.rgbToHsv.apply(this, this.rgb);
                if (this.getWrapper().classList.contains($38fcc89172ec2635$var$SHOWVALUE)) this.updateInput(cValue);
                this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb), false, e);
            }
            if (!this.inline && !this.showButtons) this.closePopup(e);
        } else if ((0, $4ZDHT.closest)(target, "." + $38fcc89172ec2635$var$MODESWITCH)) this.switchToPicker();
        else {
            if (target.classList.contains($38fcc89172ec2635$var$APPLY) || target.classList.contains($38fcc89172ec2635$var$CANCEL)) this.ctrlBtnClick(target, e);
            else if (this.getWrapper().classList.contains($38fcc89172ec2635$var$SHOWVALUE) && (0, $4ZDHT.closest)(target, "." + $38fcc89172ec2635$var$FORMATSWITCH)) this.formatSwitchHandler();
        }
    };
    ColorPicker.prototype.noColorTile = function(isKey) {
        if (isKey === void 0) isKey = false;
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = [];
        this.hsv = [];
        this.triggerEvent("", pValue, "", isKey);
    };
    ColorPicker.prototype.switchToPicker = function() {
        var wrapper = this.getWrapper();
        this.trigger("beforeModeSwitch", {
            element: this.container,
            mode: "Picker"
        });
        this.unWireEvents();
        [].slice.call((0, $4ZDHT.selectAll)("." + $38fcc89172ec2635$var$PALETTES, this.container)).forEach(function(ele) {
            (0, $4ZDHT.detach)(ele);
        });
        if (this.container.querySelector(".e-clr-pal-rec-wpr")) (0, $4ZDHT.detach)(this.container.querySelector(".e-clr-pal-rec-wpr"));
        if (wrapper.classList.contains($38fcc89172ec2635$var$SHOWVALUE)) (0, $4ZDHT.detach)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$INPUTWRAPPER, this.container));
        this.container.style.width = "";
        var grpEle = (0, $4ZDHT.select)(".e-custom-palette", this.container);
        if (this.presetColors) (0, $4ZDHT.remove)(grpEle);
        this.createPicker();
        this.getDragHandler().focus();
        this.createInput();
        this.refreshPopupPos();
        //for image editor popup position refreshing
        if (this.element.parentElement && this.element.parentElement.parentElement && this.element.parentElement.parentElement.classList.contains("e-ie-ddb-popup")) this.refreshImageEditorPopupPos();
        this.wireEvents();
        this.trigger("onModeSwitch", {
            element: this.container,
            mode: "Picker"
        });
    };
    ColorPicker.prototype.ctrlBtnClick = function(ele, e) {
        if (ele.classList.contains($38fcc89172ec2635$var$APPLY)) {
            var cValue = this.rgbToHex(this.rgb);
            this.triggerChangeEvent(cValue, e);
        }
        if (!this.inline) {
            this.closePopup(e);
            this.splitBtn.element.focus();
        } else if (ele.classList.contains($38fcc89172ec2635$var$CANCEL)) {
            var beforeCloseArgs = {
                element: this.container,
                event: e,
                cancel: false
            };
            this.trigger("beforeClose", beforeCloseArgs);
        }
    };
    ColorPicker.prototype.paletteKeyDown = function(e) {
        var target = e.target;
        if (!target.classList.contains($38fcc89172ec2635$var$PALETTES)) return;
        var selectedEle;
        var idx;
        var tiles = [].slice.call((0, $4ZDHT.selectAll)("." + $38fcc89172ec2635$var$TILE, target));
        var prevSelectedEle = tiles.filter(function(tile) {
            return tile.classList.contains("e-selected");
        }).pop();
        switch(!e.altKey && e.keyCode){
            case 39:
                e.preventDefault();
                selectedEle = prevSelectedEle ? tiles[this.tilePosition(tiles, prevSelectedEle, this.enableRtl ? -1 : 1)] : tiles[this.enableRtl ? tiles.length - 1 : 0];
                this.keySelectionChanges(selectedEle);
                break;
            case 37:
                e.preventDefault();
                selectedEle = prevSelectedEle ? tiles[this.tilePosition(tiles, prevSelectedEle, this.enableRtl ? 1 : -1)] : tiles[this.enableRtl ? 0 : tiles.length - 1];
                this.keySelectionChanges(selectedEle);
                break;
            case 38:
                e.preventDefault();
                idx = prevSelectedEle ? this.tilePosition(tiles, prevSelectedEle, -this.columns) : 0;
                selectedEle = tiles[idx] ? tiles[idx] : tiles[idx - this.columns];
                this.keySelectionChanges(selectedEle);
                break;
            case 40:
                e.preventDefault();
                idx = prevSelectedEle ? this.tilePosition(tiles, prevSelectedEle, this.columns) : tiles.length - 1;
                if (tiles[idx]) selectedEle = tiles[idx];
                else {
                    idx %= tiles.length;
                    idx += tiles[tiles.length - 1].parentElement.childElementCount;
                    selectedEle = tiles[idx];
                }
                this.keySelectionChanges(selectedEle);
                break;
            case 13:
                e.preventDefault();
                if (prevSelectedEle) {
                    var cValue = prevSelectedEle.getAttribute("aria-label");
                    this.enterKeyHandler(cValue ? cValue : "");
                }
                break;
        }
    };
    ColorPicker.prototype.keySelectionChanges = function(newEle) {
        this.removeTileSelection();
        this.addTileSelection(newEle);
        if (newEle.classList.contains($38fcc89172ec2635$var$NOCOLOR)) this.noColorTile(true);
        else {
            var cValue = newEle.getAttribute("aria-label");
            var pValue = this.rgbToHex(this.rgb);
            this.rgb = this.hexToRgb(cValue);
            this.hsv = this.rgbToHsv.apply(this, this.rgb);
            if (this.getWrapper().classList.contains($38fcc89172ec2635$var$SHOWVALUE)) this.updateInput(cValue);
            this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb), true);
        }
    };
    ColorPicker.prototype.tilePosition = function(items, element, cIdx) {
        items = Array.prototype.slice.call(items);
        var n = items.length;
        var emptyCount = this.columns - items[n - 1].parentElement.childElementCount;
        var idx = items.indexOf(element);
        idx += cIdx;
        if (idx < 0) idx += n + emptyCount;
        else idx %= n + emptyCount;
        return idx;
    };
    ColorPicker.prototype.inputHandler = function(e) {
        var target = e.target;
        if (!target.value.length) return;
        var hsv;
        var pValue;
        var label = (0, $4ZDHT.select)(".e-float-text", target.parentElement).textContent;
        switch(label){
            case "HEX":
                var value = "";
                if (target.value[0] === "#" && target.value.length !== 5 || target.value[0] !== "#" && target.value.length !== 4) value = this.roundValue(target.value);
                if (value.length === 9) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb = this.hexToRgb(value + value.substr(-2));
                    this.inputValueChange(this.rgbToHsv.apply(this, this.rgb), pValue, target.value, e);
                } else return;
                break;
            case "R":
                if (this.rgb[0] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[0] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue, null, e);
                }
                break;
            case "G":
                if (this.rgb[1] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[1] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue, null, e);
                }
                break;
            case "B":
                if (this.rgb[2] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[2] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue, null, e);
                }
                break;
            case "H":
                this.hueSlider.value = Number(target.value);
                break;
            case "S":
                if (this.hsv[1] !== Number(target.value)) {
                    this.hsv[1] = Number(target.value);
                    this.updateHsv();
                    this.convertToOtherFormat(false, e);
                }
                break;
            case "V":
                if (this.hsv[2] !== Number(target.value)) {
                    this.hsv[2] = Number(target.value);
                    this.updateHsv();
                    this.convertToOtherFormat(false, e);
                }
                break;
            case "A":
                this.opacitySlider.value = Number(target.value);
                break;
        }
    };
    ColorPicker.prototype.inputValueChange = function(hsv, pValue, value, e) {
        if (hsv[0] !== this.hsv[0]) {
            this.hueSlider.setProperties({
                "value": hsv[0]
            }, true);
            this.hueSlider.refresh();
            this.setHsvContainerBg(hsv[0]);
        }
        this.hsv = hsv;
        var cValue = this.rgbToHex(this.rgb);
        this.setHandlerPosition();
        this.updateInput(value ? value : cValue);
        var rgba = this.convertToRgbString(this.rgb);
        this.updatePreview(rgba);
        this.triggerEvent(cValue, pValue, rgba, false, e);
    };
    ColorPicker.prototype.triggerEvent = function(cValue, pValue, rgba, isKey, e) {
        if (isKey === void 0) isKey = false;
        var hex = cValue.slice(0, 7);
        if ((0, $3EnZW.isNullOrUndefined)(e)) e = new MouseEvent("click", {
            bubbles: true,
            cancelable: false
        });
        if (!this.showButtons && !isKey) {
            this.trigger("change", {
                currentValue: {
                    hex: hex,
                    rgba: rgba
                },
                event: e,
                previousValue: {
                    hex: this.value.slice(0, 7),
                    rgba: this.convertToRgbString(this.hexToRgb(this.value))
                },
                value: cValue
            });
            if (this.showRecentColors) {
                this.recentColors.unshift(hex);
                if (this.inline) this.renderRecentColor();
            }
            if (this.enableOpacity) this.setProperties({
                "value": cValue
            }, true);
            else this.setProperties({
                "value": hex
            }, true);
            this.element.value = hex ? hex : "#000000";
        } else this.trigger("select", {
            currentValue: {
                hex: hex,
                rgba: rgba
            },
            event: e,
            previousValue: {
                hex: pValue.slice(0, 7),
                rgba: this.convertToRgbString(this.hexToRgb(pValue))
            }
        });
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */ ColorPicker.prototype.destroy = function() {
        var _this = this;
        var wrapper = this.getWrapper();
        _super.prototype.destroy.call(this);
        [
            "tabindex",
            "spellcheck"
        ].forEach(function(attr) {
            _this.element.removeAttribute(attr);
        });
        if (this.inline) {
            this.unWireEvents();
            this.destroyOtherComp();
        } else {
            if (this.isPopupOpen()) {
                this.unWireEvents();
                this.destroyOtherComp();
            }
            this.splitBtn.destroy();
            this.splitBtn = null;
        }
        this.tileRipple();
        this.tileRipple = null;
        this.ctrlBtnRipple();
        this.ctrlBtnRipple = null;
        if (this.element.nextElementSibling) (0, $4ZDHT.detach)(this.element.nextElementSibling);
        if (wrapper) {
            wrapper.parentElement.insertBefore(this.element, wrapper);
            (0, $4ZDHT.detach)(wrapper);
        }
        this.container = null;
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.formResetHandler);
    };
    ColorPicker.prototype.destroyOtherComp = function() {
        if (this.isPicker()) {
            var popup = (0, $4ZDHT.closest)(this.hueSlider.element, ".e-color-picker");
            var numericElemColl = popup.querySelectorAll(".e-numerictextbox");
            for(var i = 0; i < numericElemColl.length; i++)(0, $3EnZW.getInstance)(numericElemColl[i], (0, $75082a70d3498091$export$d910e4596d16bb81)).destroy();
            this.hueSlider.destroy();
            if (this.enableOpacity) {
                this.opacitySlider.destroy();
                this.opacitySlider = null;
            }
            this.hueSlider = null;
            var tooltipInst = this.getTooltipInst();
            tooltipInst.close();
            tooltipInst.destroy();
            this.tooltipEle = null;
        }
    };
    ColorPicker.prototype.isPopupOpen = function() {
        return this.getPopupEle().classList.contains("e-popup-open");
    };
    ColorPicker.prototype.unWireEvents = function() {
        if (this.isPicker()) {
            var dragHandler = this.getDragHandler();
            (0, $aqzbR.EventHandler).remove(dragHandler, "keydown", this.pickerKeyDown);
            var ctrlBtn = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLBTN, this.container);
            if (ctrlBtn) (0, $aqzbR.EventHandler).remove(ctrlBtn, "keydown", this.ctrlBtnKeyDown);
            (0, $aqzbR.EventHandler).remove(this.getHsvContainer(), "mousedown touchstart", this.handlerDown);
            if (this.modeSwitcher || this.showButtons) (0, $aqzbR.EventHandler).remove((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLSWITCH, this.container), "click", this.btnClickHandler);
            (0, $aqzbR.EventHandler).remove((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$PREVIOUS, this.container), "click", this.previewHandler);
        } else {
            (0, $aqzbR.EventHandler).remove(this.container, "click", this.paletteClickHandler);
            (0, $aqzbR.EventHandler).remove(this.container, "keydown", this.paletteKeyDown);
        }
    };
    ColorPicker.prototype.roundValue = function(value) {
        if (!value) return "";
        if (value[0] !== "#") value = "#" + value;
        var len = value.length;
        if (len === 4) {
            value += "f";
            len = 5;
        }
        if (len === 5) {
            var tempValue = "";
            for(var i = 1, len_1 = value.length; i < len_1; i++)tempValue += value.charAt(i) + value.charAt(i);
            value = "#" + tempValue;
            len = 9;
        }
        if (len === 7) value += "ff";
        return value;
    };
    ColorPicker.prototype.hexToRgb = function(hex) {
        if (!hex) return [];
        hex = hex.trim();
        if (hex.length !== 9) hex = this.roundValue(hex);
        var opacity = Number((parseInt(hex.slice(-2), 16) / 255).toFixed(2));
        hex = hex.slice(1, 7);
        var bigInt = parseInt(hex, 16);
        var h = [];
        h.push(bigInt >> 16 & 255);
        h.push(bigInt >> 8 & 255);
        h.push(bigInt & 255);
        h.push(opacity);
        return h;
    };
    ColorPicker.prototype.rgbToHsv = function(r, g, b, opacity) {
        if (this.rgb && !this.rgb.length) return [];
        r /= 255;
        g /= 255;
        b /= 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h;
        var v = max;
        var d = max - min;
        var s = max === 0 ? 0 : d / max;
        if (max === min) h = 0;
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        var hsv = [
            Math.round(h * 360),
            Math.round(s * 1000) / 10,
            Math.round(v * 1000) / 10
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(opacity)) hsv.push(opacity);
        return hsv;
    };
    ColorPicker.prototype.hsvToRgb = function(h, s, v, opacity) {
        var r;
        var g;
        var b;
        s /= 100;
        v /= 100;
        if (s === 0) {
            r = g = b = v;
            return [
                Math.round(r * 255),
                Math.round(g * 255),
                Math.round(b * 255),
                opacity
            ];
        }
        h /= 60;
        var i = Math.floor(h);
        var f = h - i;
        var p = v * (1 - s);
        var q = v * (1 - s * f);
        var t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            default:
                r = v;
                g = p;
                b = q;
        }
        var rgb = [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255)
        ];
        if (!(0, $3EnZW.isNullOrUndefined)(opacity)) rgb.push(opacity);
        return rgb;
    };
    ColorPicker.prototype.rgbToHex = function(rgb) {
        return rgb.length ? "#" + this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]) + (!(0, $3EnZW.isNullOrUndefined)(rgb[3]) ? rgb[3] !== 0 ? (Math.round(rgb[3] * 255) + 0x10000).toString(16).substr(-2) : "00" : "") : "";
    };
    ColorPicker.prototype.hex = function(x) {
        return ("0" + x.toString(16)).slice(-2);
    };
    ColorPicker.prototype.changeModeSwitcherProp = function(prop) {
        var ctrlSwitchWrapper = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLSWITCH, this.container);
        if (prop) {
            if (ctrlSwitchWrapper) this.appendModeSwitchBtn();
            else {
                this.createCtrlBtn();
                if (this.isPicker() && !this.disabled) this.addCtrlSwitchEvent();
            }
        } else if (ctrlSwitchWrapper) {
            if (this.showButtons) (0, $4ZDHT.detach)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$MODESWITCH, ctrlSwitchWrapper));
            else (0, $4ZDHT.remove)(ctrlSwitchWrapper);
        }
    };
    ColorPicker.prototype.changeShowBtnProps = function(prop) {
        var ctrlBtnWrapper = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLSWITCH, this.container);
        if (prop) {
            if (ctrlBtnWrapper) (0, $4ZDHT.remove)(ctrlBtnWrapper);
            this.createCtrlBtn();
            if (this.isPicker() && !this.disabled) this.addCtrlSwitchEvent();
        } else if (this.modeSwitcher) (0, $4ZDHT.detach)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$CTRLBTN, ctrlBtnWrapper));
        else (0, $4ZDHT.remove)(ctrlBtnWrapper);
    };
    ColorPicker.prototype.changeValueProp = function(newProp) {
        if (this.isPicker()) {
            this.rgb = this.hexToRgb(newProp);
            this.hsv = this.rgbToHsv.apply(this, this.rgb);
            this.setHandlerPosition();
            (0, $4ZDHT.detach)((0, $4ZDHT.closest)(this.hueSlider.element, ".e-slider-preview"));
            this.createSlider();
            this.setHsvContainerBg();
            this.updateInput(newProp);
            if (this.rgb.length === 4) this.updateOpacityInput(this.rgb[3] * 100);
        } else {
            this.removeTileSelection();
            var ele = this.container.querySelector('span[aria-label="' + this.roundValue(newProp) + '"]');
            if (ele) this.addTileSelection(ele);
        }
    };
    ColorPicker.prototype.setInputEleProps = function() {
        (0, $4ZDHT.remove)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$INPUTWRAPPER, this.container));
        this.createInput();
    };
    ColorPicker.prototype.changeDisabledProp = function(newProp) {
        if (this.isPicker()) {
            this.hueSlider.enabled = !newProp;
            this.opacitySlider.enabled = !newProp;
            this.setInputEleProps();
        }
        if (newProp) {
            this.toggleDisabled(true);
            this.unWireEvents();
        } else {
            this.toggleDisabled(false);
            this.wireEvents();
        }
    };
    ColorPicker.prototype.changeCssClassProps = function(newProp, oldProp) {
        var wrapper = this.getWrapper();
        var popupWrapper = this.getPopupEle();
        if (oldProp) (0, $4ZDHT.removeClass)([
            wrapper,
            popupWrapper
        ], oldProp.split(" "));
        if (newProp) (0, $4ZDHT.addClass)([
            wrapper,
            popupWrapper
        ], newProp.replace(/\s+/g, " ").trim().split(" "));
    };
    ColorPicker.prototype.changeRtlProps = function(newProp) {
        if (newProp) (0, $4ZDHT.addClass)([
            this.getWrapper()
        ], "e-rtl");
        else (0, $4ZDHT.removeClass)([
            this.getWrapper()
        ], "e-rtl");
    };
    ColorPicker.prototype.changePaletteProps = function() {
        (0, $4ZDHT.detach)(this.container.children[0]);
        this.container.style.width = "";
        this.createPalette();
    };
    ColorPicker.prototype.changeOpacityProps = function(newProp) {
        var wrapper = this.getWrapper();
        if (newProp) {
            (0, $4ZDHT.removeClass)([
                this.container.parentElement
            ], $38fcc89172ec2635$var$HIDEOPACITY);
            this.createOpacitySlider((0, $4ZDHT.select)(".e-colorpicker-slider", this.container).appendChild(this.createElement("div", {
                className: "e-opacity-slider"
            })));
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEVALUE) && !wrapper.classList.contains($38fcc89172ec2635$var$HIDERGBA)) this.appendOpacityValue((0, $4ZDHT.select)(".e-input-container", this.container));
        } else {
            (0, $4ZDHT.addClass)([
                this.container.parentElement
            ], $38fcc89172ec2635$var$HIDEOPACITY);
            this.opacitySlider.destroy();
            (0, $4ZDHT.remove)(this.opacitySlider.element);
            this.opacitySlider = null;
            if (!wrapper.classList.contains($38fcc89172ec2635$var$HIDEVALUE) && !wrapper.classList.contains($38fcc89172ec2635$var$HIDERGBA)) (0, $4ZDHT.remove)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$OPACITY, this.container).parentElement);
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {ColorPickerModel} newProp - Specifies new properties
     * @param  {ColorPickerModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */ ColorPicker.prototype.onPropertyChanged = function(newProp, oldProp) {
        var _this = this;
        if (!(0, $3EnZW.isNullOrUndefined)(newProp.value)) {
            var value = this.roundValue(newProp.value);
            if (value.length === 9) {
                this.element.value = this.roundValue(value).slice(0, 7);
                var preview = this.splitBtn && (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$SPLITPREVIEW, this.splitBtn.element);
                if (preview) preview.style.backgroundColor = this.convertToRgbString(this.hexToRgb(newProp.value));
            } else if (this.noColor && this.mode === "Palette" && this.value === "") {
                var preview = this.splitBtn && (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$SPLITPREVIEW, this.splitBtn.element);
                preview.style.backgroundColor = "";
            } else this.value = oldProp.value;
        }
        if (!this.inline && (0, $3EnZW.isNullOrUndefined)(newProp.inline)) {
            var otherCompModel = [
                "disabled",
                "enableRtl"
            ];
            this.splitBtn.setProperties((0, $22807a4aeae41444$export$289ca1c318c0384)(newProp, otherCompModel));
            if (!this.isPopupOpen()) {
                this.changeCssClassProps(newProp.cssClass, oldProp.cssClass);
                this.changeRtlProps(newProp.enableRtl);
                return;
            }
        }
        var _loop_1 = function(prop) {
            switch(prop){
                case "inline":
                    if (newProp.inline) {
                        this_1.getWrapper().appendChild(this_1.container);
                        this_1.splitBtn.destroy();
                        (0, $4ZDHT.detach)(this_1.element.nextElementSibling);
                        if (!this_1.container.children.length) this_1.createWidget();
                    } else {
                        this_1.destroyOtherComp();
                        this_1.unWireEvents();
                        this_1.container.innerHTML = "";
                        this_1.createSplitBtn();
                    }
                    break;
                case "cssClass":
                    this_1.changeCssClassProps(newProp.cssClass, oldProp.cssClass);
                    var props = newProp.cssClass.split(" ").concat(oldProp.cssClass.split(" "));
                    props = props.reduce(function(a, b) {
                        if (a.indexOf(b) < 0) a.push(b);
                        return a;
                    }, []);
                    var count_1 = 0;
                    props.forEach(function(cls) {
                        if (count_1 === 0 && (cls === $38fcc89172ec2635$var$HIDEVALUE || cls === $38fcc89172ec2635$var$HIDEVALUESWITCH || cls === $38fcc89172ec2635$var$SHOWVALUE || cls === $38fcc89172ec2635$var$HIDEHEX || cls === $38fcc89172ec2635$var$HIDERGBA)) {
                            var inputWrap = (0, $4ZDHT.select)("." + $38fcc89172ec2635$var$INPUTWRAPPER, _this.container);
                            if (inputWrap) (0, $4ZDHT.remove)((0, $4ZDHT.select)("." + $38fcc89172ec2635$var$INPUTWRAPPER, _this.container));
                            _this.createInput();
                            count_1++;
                        }
                    });
                    break;
                case "enableRtl":
                    if (this_1.isPicker()) {
                        this_1.hueSlider.enableRtl = newProp.enableRtl;
                        if (this_1.enableOpacity) this_1.opacitySlider.enableRtl = newProp.enableRtl;
                        this_1.setInputEleProps();
                    }
                    this_1.changeRtlProps(newProp.enableRtl);
                    break;
                case "disabled":
                    this_1.changeDisabledProp(newProp.disabled);
                    break;
                case "value":
                    if (this_1.value !== oldProp.value) this_1.changeValueProp(newProp.value);
                    break;
                case "showButtons":
                    this_1.changeShowBtnProps(newProp.showButtons);
                    break;
                case "mode":
                    if (newProp.mode === "Picker") this_1.switchToPicker();
                    else this_1.switchToPalette();
                    break;
                case "modeSwitcher":
                    this_1.changeModeSwitcherProp(newProp.modeSwitcher);
                    break;
                case "columns":
                case "presetColors":
                    if (!this_1.isPicker()) this_1.changePaletteProps();
                    break;
                case "noColor":
                    if (newProp.noColor) {
                        if (this_1.mode === "Palette" && !this_1.modeSwitcher) this_1.setNoColor();
                    } else this_1.changePaletteProps();
                    break;
                case "enableOpacity":
                    this_1.changeOpacityProps(newProp.enableOpacity);
                    break;
                case "showRecentColors":
                    if (!newProp.showRecentColors) {
                        var recentClrWpr = this_1.container.querySelector(".e-clr-pal-rec-wpr");
                        if (recentClrWpr) (0, $4ZDHT.detach)(recentClrWpr);
                    }
                    this_1.recentColors = [];
                    break;
            }
        };
        var this_1 = this;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            _loop_1(prop);
        }
    };
    /**
     * Sets the focus to Colorpicker
     * its native method
     *
     * @public
     * @returns {void}
     */ ColorPicker.prototype.focusIn = function() {
        this.element.parentElement.focus();
    };
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)("#008000ff")
    ], ColorPicker.prototype, "value", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)("")
    ], ColorPicker.prototype, "cssClass", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "disabled", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)("Picker")
    ], ColorPicker.prototype, "mode", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ColorPicker.prototype, "modeSwitcher", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ColorPicker.prototype, "presetColors", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ColorPicker.prototype, "showButtons", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], ColorPicker.prototype, "columns", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "inline", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "noColor", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "enablePersistence", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ColorPicker.prototype, "enableOpacity", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "createPopupOnClick", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ColorPicker.prototype, "showRecentColors", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "select", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "change", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "beforeTileRender", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "beforeOpen", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "open", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "beforeClose", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "beforeModeSwitch", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "onModeSwitch", void 0);
    $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.Event)()
    ], ColorPicker.prototype, "created", void 0);
    ColorPicker = $38fcc89172ec2635$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], ColorPicker);
    return ColorPicker;
}((0, $hQxLN.Component));




/**
 * `Toolbar renderer` module is used to render toolbar in RichTextEditor.
 *
 * @hidden

 */ var $e31405e65c29c50d$export$a3fa63e58e0aecf1 = /** @class */ function() {
    /**
     * Constructor for toolbar renderer module
     *
     * @param {IRichTextEditor} parent - specifies the parent element.
     * @param {ServiceLocator} serviceLocator - specifies the serviceLocator
     */ function ToolbarRenderer(parent, serviceLocator) {
        this.parent = parent;
        this.isDestroyed = false;
        if (serviceLocator) this.l10n = serviceLocator.getService("rteLocale");
        this.wireEvent();
    }
    ToolbarRenderer.prototype.wireEvent = function() {
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$121c0465ebbf863b, this.destroyTooltip, this);
        this.parent.on($947a002e9a697770$export$6108d95d641a81fb, this.closeTooltip, this);
    };
    ToolbarRenderer.prototype.destroyTooltip = function() {
        var currentDocument = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().ownerDocument : this.parent.contentModule.getDocument();
        if (!(0, $3EnZW.isNullOrUndefined)(currentDocument.querySelector(".e-tooltip-wrap")) && !(0, $3EnZW.isNullOrUndefined)(currentDocument.querySelector("[data-tooltip-id]"))) {
            var tooltipTargetEle = currentDocument.querySelector("[data-tooltip-id]");
            var event_1 = new MouseEvent("mouseleave", {
                bubbles: true,
                cancelable: true
            });
            tooltipTargetEle.dispatchEvent(event_1);
        }
    };
    ToolbarRenderer.prototype.unWireEvent = function() {
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$121c0465ebbf863b, this.destroyTooltip);
        this.parent.off($947a002e9a697770$export$6108d95d641a81fb, this.closeTooltip);
    };
    ToolbarRenderer.prototype.toolbarBeforeCreate = function(e) {
        if (this.mode === "Extended") e.enableCollision = false;
    };
    ToolbarRenderer.prototype.toolbarCreated = function() {
        this.parent.notify($947a002e9a697770$export$e07a9422bd2a0dce, this);
    };
    ToolbarRenderer.prototype.toolbarClicked = function(args) {
        if (!this.parent.enabled) return;
        this.parent.trigger("toolbarClick", args);
        if (!this.parent.readonly || (0, $3EnZW.isNullOrUndefined)(args.item)) this.parent.notify($947a002e9a697770$export$56b876c24dda3084, args);
    };
    ToolbarRenderer.prototype.dropDownSelected = function(args) {
        this.parent.notify($947a002e9a697770$export$55eface7583121e7, {
            element: args.element,
            item: args.item,
            originalEvent: args.event
        });
        this.destroyTooltip();
    };
    ToolbarRenderer.prototype.beforeDropDownItemRender = function(args) {
        if (this.parent.readonly || !this.parent.enabled) return;
        this.parent.notify($947a002e9a697770$export$9c270263992f2055, args);
    };
    ToolbarRenderer.prototype.tooltipBeforeRender = function(args) {
        if (!(0, $3EnZW.isNullOrUndefined)(args.target.getAttribute("title"))) {
            var tooltipTarget = args.target.getAttribute("title");
            var tooltipText = void 0;
            switch(tooltipTarget){
                case "Minimize":
                    tooltipText = this.l10n.getConstant("minimize");
                    args.target.setAttribute("title", tooltipText + " (Esc)");
                    break;
                case "Maximize":
                    tooltipText = this.l10n.getConstant("maximize");
                    args.target.setAttribute("title", tooltipText + " (Ctrl+Shift+F)");
                    break;
            }
        }
        if (args.target.querySelector(".e-active")) {
            args.cancel = true;
            if (!(0, $3EnZW.isNullOrUndefined)(args.target.getAttribute("title"))) this.closeTooltip({
                target: args.target,
                isTitle: true
            });
        }
    };
    ToolbarRenderer.prototype.dropDownOpen = function(args) {
        if (args.element.parentElement.getAttribute("id").indexOf("TableCell") > -1 && !(0, $3EnZW.isNullOrUndefined)(args.element.parentElement.querySelector(".e-cell-merge")) && (!(0, $3EnZW.isNullOrUndefined)(args.element.parentElement.querySelector(".e-cell-horizontal-split")) || !(0, $3EnZW.isNullOrUndefined)(args.element.parentElement.querySelector(".e-cell-vertical-split")))) {
            var listEle = args.element.querySelectorAll("li");
            var selectedEles_1 = this.parent.inputElement.querySelectorAll(".e-cell-select");
            if (selectedEles_1.length === 1) {
                (0, $4ZDHT.addClass)([
                    listEle[0]
                ], "e-disabled");
                (0, $4ZDHT.removeClass)([
                    listEle[1],
                    listEle[2]
                ], "e-disabled");
            } else if (selectedEles_1.length > 1) {
                if (!Array.from(selectedEles_1).every(function(element) {
                    return element.tagName.toLowerCase() === selectedEles_1[0].tagName.toLowerCase();
                })) (0, $4ZDHT.addClass)([
                    listEle[0]
                ], "e-disabled");
                else (0, $4ZDHT.removeClass)([
                    listEle[0]
                ], "e-disabled");
                (0, $4ZDHT.addClass)([
                    listEle[1],
                    listEle[2]
                ], "e-disabled");
            }
        }
        this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, args);
    };
    ToolbarRenderer.prototype.dropDownClose = function(args) {
        this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, args);
    };
    /**
     * renderToolbar method
     *
     * @param {IToolbarOptions} args - specifies the arguments.
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderToolbar = function(args) {
        this.setPanel(args.target);
        this.renderPanel();
        this.mode = args.overflowMode;
        args.rteToolbarObj.toolbarObj = new (0, $6e0c0888b69d6c4c$export$4c260019440d418f)({
            items: args.items,
            width: "100%",
            overflowMode: args.overflowMode,
            beforeCreate: this.toolbarBeforeCreate.bind(this),
            created: this.toolbarCreated.bind(this),
            clicked: this.toolbarClicked.bind(this),
            enablePersistence: args.enablePersistence,
            enableRtl: args.enableRtl,
            cssClass: args.cssClass
        });
        args.rteToolbarObj.toolbarObj.isStringTemplate = true;
        args.rteToolbarObj.toolbarObj.createElement = this.parent.createElement;
        args.rteToolbarObj.toolbarObj.appendTo(args.target);
        if (this.parent.showTooltip && args.type === "toolbar") {
            this.tooltip = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)({
                target: "#" + this.parent.getID() + "_toolbar_wrapper [title]",
                showTipPointer: true,
                openDelay: 400,
                opensOn: "Hover",
                beforeRender: this.tooltipBeforeRender.bind(this),
                beforeOpen: this.tooltipBeforeOpen.bind(this),
                cssClass: this.parent.getCssClass(),
                windowCollision: true,
                position: "BottomCenter"
            });
            this.tooltip.appendTo(args.target.parentElement);
        }
    };
    ToolbarRenderer.prototype.tooltipBeforeOpen = function(args) {
        if (args.element) args.element.setAttribute("data-rte-id", this.parent.getID());
    };
    /**
     * renderDropDownButton method
     *
     * @param {IDropDownModel} args - specifies the the arguments.
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderDropDownButton = function(args) {
        var _this = this;
        var css;
        args.element.classList.add((0, $afc560df281b588d$export$a16280636ed97757));
        css = args.cssClass + " " + (0, $afc560df281b588d$export$d3f61cb93957903e) + " " + (0, $afc560df281b588d$export$7446a6f3c13dcc36);
        if (this.parent.inlineMode.enable && (0, $5q7BP.Browser).isDevice) css = css + " " + (0, $afc560df281b588d$export$de9fd411a461238e);
        // eslint-disable-next-line
        var proxy = this;
        var dropDown = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
            items: args.items,
            iconCss: args.iconCss,
            cssClass: css,
            content: args.content,
            enablePersistence: this.parent.enablePersistence,
            enableRtl: this.parent.enableRtl,
            select: this.dropDownSelected.bind(this),
            beforeOpen: function(args) {
                if (proxy.parent.readonly || !proxy.parent.enabled) {
                    args.cancel = true;
                    return;
                }
                // Table styles dropdown preselect
                if (proxy.parent.editorMode !== "Markdown") {
                    var startNode = proxy.parent.getRange().startContainer.parentElement;
                    var tableEle = startNode.closest("table");
                    var trow = startNode.closest("tr");
                    if (!(0, $3EnZW.isNullOrUndefined)(tableEle) && tableEle.classList.contains("e-dashed-border")) {
                        for(var index = 0; index < args.element.childNodes.length; index++)if (args.element.childNodes[index].classList.contains("e-dashed-borders")) (0, $4ZDHT.addClass)([
                            args.element.childNodes[index]
                        ], "e-active");
                    } else if (!(0, $3EnZW.isNullOrUndefined)(tableEle) && !tableEle.classList.contains("e-dashed-border") && tableEle.classList.contains("e-alternate-rows") && window.getComputedStyle(trow).backgroundColor !== "") {
                        for(var index = 0; index < args.element.childNodes.length; index++)if (args.element.childNodes[index].classList.contains("e-alternate-rows")) (0, $4ZDHT.addClass)([
                            args.element.childNodes[index]
                        ], "e-active");
                    }
                    //Alignments preselect
                    var alignEle = proxy.parent.getRange().startContainer;
                    while(alignEle !== proxy.parent.inputElement && !(0, $3EnZW.isNullOrUndefined)(alignEle.parentElement)){
                        if (alignEle.nodeName === "#text") alignEle = alignEle.parentElement;
                        var alignStyle = window.getComputedStyle(alignEle).textAlign;
                        if (args.items[0].command === "Alignments") {
                            if (args.items[0].text === "Align Left" && alignStyle === "left" || alignStyle === "start") {
                                (0, $4ZDHT.addClass)([
                                    args.element.childNodes[0]
                                ], "e-active");
                                break;
                            } else if (args.items[1].text === "Align Center" && alignStyle === "center") {
                                (0, $4ZDHT.addClass)([
                                    args.element.childNodes[1]
                                ], "e-active");
                                break;
                            } else if (args.items[2].text === "Align Right" && alignStyle === "right") {
                                (0, $4ZDHT.addClass)([
                                    args.element.childNodes[2]
                                ], "e-active");
                                break;
                            } else if (args.items[3].text === "Align Justify" && alignStyle === "justify") {
                                (0, $4ZDHT.addClass)([
                                    args.element.childNodes[3]
                                ], "e-active");
                                break;
                            }
                        }
                        alignEle = alignEle.parentElement;
                    }
                    //image preselect
                    var closestNode = startNode.closest("img");
                    var imageEle = closestNode ? closestNode : startNode.querySelector("img");
                    if (args.items[0].command === "Images") {
                        if (!(0, $3EnZW.isNullOrUndefined)(imageEle)) {
                            var index = void 0;
                            if (imageEle.classList.contains("e-imgleft") || imageEle.classList.contains("e-imginline")) index = 0;
                            else if (imageEle.classList.contains("e-imgcenter") || imageEle.classList.contains("e-imgbreak")) index = 1;
                            else if (imageEle.classList.contains("e-imgright")) index = 2;
                            if (!(0, $3EnZW.isNullOrUndefined)(args.element.childNodes[index])) (0, $4ZDHT.addClass)([
                                args.element.childNodes[index]
                            ], "e-active");
                        }
                    }
                    //Formats preselect
                    if (args.items[0].command === "Formats" || args.items[0].command === "Font") {
                        var fontName_1 = [];
                        var formats_1 = [];
                        var hasUpdatedActive = false;
                        _this.parent.format.types.forEach(function(item) {
                            formats_1.push(item.value.toLocaleLowerCase());
                        });
                        _this.parent.fontFamily.items.forEach(function(item) {
                            fontName_1.push(item.value);
                        });
                        var toolbarStatus = (0, $58a5a5299a589153$export$43229ac8f78c6cea).get(_this.parent.contentModule.getDocument(), _this.parent.contentModule.getEditPanel(), formats_1, null, fontName_1);
                        for(var index = 0; index < args.element.childNodes.length; index++){
                            var divNode = _this.parent.createElement("div");
                            divNode.innerHTML = dropDown.content.trim();
                            if (!hasUpdatedActive && (divNode.textContent.trim() !== "" && args.element.childNodes[index].textContent.trim() === divNode.textContent.trim() || args.items[0].command === "Formats" && !(0, $3EnZW.isNullOrUndefined)(toolbarStatus.formats) && _this.parent.format.types[index].value.toLowerCase() === toolbarStatus.formats.toLowerCase() && args.element.childNodes[index].classList.contains(_this.parent.format.types[index].cssClass) || args.items[0].subCommand === "FontName" && args.items[0].command === "Font" && !(0, $3EnZW.isNullOrUndefined)(toolbarStatus.fontname) && !(0, $3EnZW.isNullOrUndefined)(_this.parent.fontFamily.items[index]) && _this.parent.fontFamily.items[index].value.toLowerCase() === toolbarStatus.fontname.toLowerCase() && args.element.childNodes[index].classList.contains(_this.parent.fontFamily.items[index].cssClass) || args.items[0].subCommand === "FontName" && _this.parent.fontFamily.items[index].value === "" && (0, $3EnZW.isNullOrUndefined)(toolbarStatus.fontname) && args.element.childNodes[index].classList.contains(_this.parent.fontFamily.items[index].cssClass) || args.items[0].subCommand === "FontSize" && args.element.childNodes[index].textContent === "Default" && divNode.textContent === "Font Size" && _this.parent.fontSize.items[index].value === "" && !(0, $3EnZW.isNullOrUndefined)(toolbarStatus.fontsize))) {
                                if (!args.element.childNodes[index].classList.contains("e-active")) {
                                    (0, $4ZDHT.addClass)([
                                        args.element.childNodes[index]
                                    ], "e-active");
                                    hasUpdatedActive = true;
                                }
                            } else (0, $4ZDHT.removeClass)([
                                args.element.childNodes[index]
                            ], "e-active");
                        }
                    }
                } else if (proxy.parent.editorMode === "Markdown") {
                    if (args.items[0].command === "Formats") {
                        var formats_2 = [];
                        var hasUpdatedActive = false;
                        _this.parent.format.types.forEach(function(item) {
                            formats_2.push(item.value.toLocaleLowerCase());
                        });
                        var childNodes = args.element.childNodes;
                        for(var index = 0; index < childNodes.length; index++){
                            var divNode = _this.parent.createElement("div");
                            divNode.innerHTML = dropDown.content.trim();
                            if (!hasUpdatedActive && divNode.textContent.trim() !== "" && childNodes[index].textContent.trim() === divNode.textContent.trim()) {
                                if (!childNodes[index].classList.contains("e-active")) {
                                    (0, $4ZDHT.addClass)([
                                        childNodes[index]
                                    ], "e-active");
                                    hasUpdatedActive = true;
                                }
                            } else (0, $4ZDHT.removeClass)([
                                childNodes[index]
                            ], "e-active");
                        }
                    }
                }
                proxy.parent.notify($947a002e9a697770$export$3582505bf03a41c5, args);
            },
            close: this.dropDownClose.bind(this),
            open: this.dropDownOpen.bind(this),
            beforeItemRender: this.beforeDropDownItemRender.bind(this)
        });
        dropDown.isStringTemplate = true;
        dropDown.createElement = proxy.parent.createElement;
        dropDown.appendTo(args.element);
        args.element.tabIndex = -1;
        var popupElement = document.getElementById(dropDown.element.id + "-popup");
        popupElement.setAttribute("aria-owns", this.parent.getID());
        return dropDown;
    };
    ToolbarRenderer.prototype.mouseOutHandler = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.tooltipTargetEle)) this.tooltipTargetEle.setAttribute("title", this.tooltipTargetEle.getAttribute("data-title"));
        else {
            var currentDocument = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().ownerDocument : this.parent.contentModule.getDocument();
            this.tooltipTargetEle = currentDocument.querySelector("[data-title]");
            this.tooltipTargetEle.setAttribute("title", this.tooltipTargetEle.getAttribute("data-title"));
        }
        this.tooltipTargetEle.removeAttribute("data-title");
        (0, $aqzbR.EventHandler).remove(this.tooltipTargetEle, "mouseout", this.mouseOutHandler);
    };
    ToolbarRenderer.prototype.closeTooltip = function(args) {
        if (args.isTitle) {
            this.tooltipTargetEle = args.target;
            this.tooltipTargetEle.setAttribute("data-title", this.tooltipTargetEle.getAttribute("title"));
            this.tooltipTargetEle.removeAttribute("title");
            (0, $aqzbR.EventHandler).add(this.tooltipTargetEle, "mouseout", this.mouseOutHandler, this);
        } else {
            var currentDocument = this.parent.iframeSettings.enable ? this.parent.contentModule.getPanel().ownerDocument : this.parent.contentModule.getDocument();
            this.tooltipTargetEle = (0, $4ZDHT.closest)(args.target, "[data-tooltip-id]");
            if (!(0, $3EnZW.isNullOrUndefined)(this.tooltipTargetEle) && this.parent.showTooltip && !(0, $3EnZW.isNullOrUndefined)(currentDocument.querySelector(".e-tooltip-wrap"))) {
                this.destroyTooltip();
                this.tooltipTargetEle.setAttribute("data-title", this.tooltipTargetEle.getAttribute("title"));
                this.tooltipTargetEle.removeAttribute("title");
                (0, $aqzbR.EventHandler).add(this.tooltipTargetEle, "mouseout", this.mouseOutHandler, this);
            }
        }
    };
    /**
     * renderListDropDown method
     *
     * @param {IDropDownModel} args - specifies the the arguments.
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderListDropDown = function(args) {
        var _this = this;
        // eslint-disable-next-line
        var proxy = this;
        var css = (0, $afc560df281b588d$export$d3f61cb93957903e) + " " + (0, $afc560df281b588d$export$7446a6f3c13dcc36) + (this.parent.inlineMode ? " " + (0, $afc560df281b588d$export$de9fd411a461238e) : "");
        css += " " + (args.itemName === "NumberFormatList" ? (0, $afc560df281b588d$export$ecbbc31b8a8bb45c) : (0, $afc560df281b588d$export$2a6a4b5d454c6efc));
        var content = proxy.parent.createElement("span", {
            className: (0, $afc560df281b588d$export$b7c856c7a2548da8)
        });
        var inlineEle = proxy.parent.createElement("span", {
            className: args.cssClass
        });
        content.appendChild(inlineEle);
        var dropDown = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
            items: args.items,
            cssClass: css,
            content: args.content,
            enablePersistence: this.parent.enablePersistence,
            enableRtl: this.parent.enableRtl,
            select: this.dropDownSelected.bind(this),
            beforeOpen: function(args) {
                if (proxy.parent.editorMode !== "Markdown") {
                    var startNode = proxy.parent.getRange().startContainer.parentElement;
                    var listElem = startNode.closest("LI");
                    var currentLiElem = !(0, $3EnZW.isNullOrUndefined)(listElem) ? listElem.parentElement : null;
                    if (!(0, $3EnZW.isNullOrUndefined)(currentLiElem) && (currentLiElem.nodeName === "OL" || currentLiElem.nodeName === "UL")) {
                        if (currentLiElem.nodeName === "UL" && args.items[0].subCommand === "NumberFormatList") (0, $4ZDHT.addClass)([
                            args.element.childNodes[0]
                        ], "e-active");
                        else if (currentLiElem.nodeName === "OL" && args.items[0].subCommand === "BulletFormatList") (0, $4ZDHT.addClass)([
                            args.element.childNodes[0]
                        ], "e-active");
                        else {
                            var currentListStyle = currentLiElem.style.listStyleType.split("-").join("").toLocaleLowerCase();
                            currentListStyle = currentListStyle === "decimal" ? "number" : currentListStyle;
                            for(var index = 0; index < args.element.childNodes.length; index++){
                                if (currentListStyle === args.element.childNodes[index].innerHTML.split(" ").join("").toLocaleLowerCase()) {
                                    (0, $4ZDHT.addClass)([
                                        args.element.childNodes[index]
                                    ], "e-active");
                                    break;
                                } else if (currentListStyle === "" && args.element.childNodes[index].innerHTML !== "None") {
                                    (0, $4ZDHT.addClass)([
                                        args.element.childNodes[index]
                                    ], "e-active");
                                    break;
                                }
                            }
                        }
                    } else (0, $4ZDHT.addClass)([
                        args.element.childNodes[0]
                    ], "e-active");
                }
                _this.closeTooltip({
                    target: args.event.target
                });
                if (proxy.parent.readonly || !proxy.parent.enabled) {
                    args.cancel = true;
                    return;
                }
                proxy.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
                var element = args.event ? args.event.target : null;
                proxy.currentElement = dropDown.element;
                proxy.currentDropdown = dropDown;
                if (args.event && args.event.type === "click" && (element.classList.contains((0, $afc560df281b588d$export$b7c856c7a2548da8)) || element.parentElement.classList.contains((0, $afc560df281b588d$export$b7c856c7a2548da8)))) {
                    args.cancel = true;
                    return;
                }
                proxy.parent.notify($947a002e9a697770$export$3582505bf03a41c5, args);
            },
            close: this.dropDownClose.bind(this),
            open: this.dropDownOpen.bind(this),
            beforeItemRender: this.beforeDropDownItemRender.bind(this)
        });
        dropDown.isStringTemplate = true;
        dropDown.createElement = proxy.parent.createElement;
        dropDown.appendTo(args.element);
        args.element.tabIndex = -1;
        args.element.setAttribute("role", "button");
        var popupElement = document.getElementById(dropDown.element.id + "-popup");
        popupElement.setAttribute("aria-owns", this.parent.getID());
        if (args.element.childElementCount === 1) dropDown.element.insertBefore(content, dropDown.element.querySelector(".e-caret"));
        args.element.tabIndex = -1;
        dropDown.element.removeAttribute("type");
        dropDown.element.onmousedown = function() {
            proxy.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
        };
        dropDown.element.onkeydown = function() {
            proxy.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
        };
        return dropDown;
    };
    ToolbarRenderer.prototype.paletteSelection = function(dropDownArgs, currentElement) {
        var ele = dropDownArgs.element.querySelector(".e-control.e-colorpicker");
        var colorbox = [].slice.call((0, $4ZDHT.selectAll)(".e-tile", ele.parentElement));
        (0, $4ZDHT.removeClass)(colorbox, "e-selected");
        var style = currentElement.querySelector("." + (0, $afc560df281b588d$export$d3f61cb93957903e)).style.borderBottomColor;
        colorbox.filter(function(colorbox) {
            if (colorbox.style.backgroundColor === style) (0, $4ZDHT.addClass)([
                colorbox
            ], "e-selected");
        });
    };
    /**
     * renderColorPickerDropDown method
     *
     * @param {IColorPickerModel} args - specifies the arguments.
     * @param {string} item - specifies the item.
     * @param {ColorPicker} colorPicker - specifies the colorpicker.
     * @param {string} defaultColor -specifies the defaultColor.
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderColorPickerDropDown = function(args, item, colorPicker, defaultColor) {
        var _this = this;
        // eslint-disable-next-line
        var proxy = this;
        var css = (0, $afc560df281b588d$export$d3f61cb93957903e) + " " + (0, $afc560df281b588d$export$7446a6f3c13dcc36) + (this.parent.inlineMode ? " " + (0, $afc560df281b588d$export$de9fd411a461238e) : "");
        css += " " + (item === "backgroundcolor" ? (0, $afc560df281b588d$export$ea10f5b2db4abd9e) : (0, $afc560df281b588d$export$9c7ffbe575933c12));
        css += this.parent.getCssClass(true);
        var content = proxy.parent.createElement("span", {
            className: (0, $afc560df281b588d$export$7a2bf3ea134093f0)
        });
        var inlineEle = proxy.parent.createElement("span", {
            className: args.cssClass
        });
        var range;
        var initialBackgroundColor = (0, $3EnZW.isNullOrUndefined)(defaultColor) ? proxy.parent.backgroundColor.default : defaultColor;
        inlineEle.style.borderBottomColor = item === "backgroundcolor" ? initialBackgroundColor : proxy.parent.fontColor.default;
        content.appendChild(inlineEle);
        var dropDown = new (0, $2f39802b01f31b03$export$e200d4ca2624495d)({
            target: colorPicker.element.parentElement,
            cssClass: css,
            enablePersistence: this.parent.enablePersistence,
            enableRtl: this.parent.enableRtl,
            beforeOpen: function(dropDownArgs) {
                if (proxy.parent.readonly || !proxy.parent.enabled) {
                    dropDownArgs.cancel = true;
                    return;
                }
                var element = dropDownArgs.event ? dropDownArgs.event.target : null;
                proxy.currentElement = dropDown.element;
                proxy.currentDropdown = dropDown;
                proxy.paletteSelection(dropDownArgs, proxy.currentElement);
                if (dropDownArgs.event && dropDownArgs.event.type === "click" && (element.classList.contains((0, $afc560df281b588d$export$7a2bf3ea134093f0)) || element.parentElement.classList.contains((0, $afc560df281b588d$export$7a2bf3ea134093f0)))) {
                    dropDownArgs.cancel = true;
                    var colorpickerValue = element.classList.contains((0, $afc560df281b588d$export$d3f61cb93957903e)) ? element.style.borderBottomColor : element.querySelector("." + (0, $afc560df281b588d$export$d3f61cb93957903e)).style.borderBottomColor;
                    proxy.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
                    range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.parent.contentModule.getDocument());
                    var parentNode = range.startContainer.parentNode;
                    var closestElement = (0, $4ZDHT.closest)(range.startContainer.parentNode, "table");
                    if ((range.startContainer.nodeName === "TD" || range.startContainer.nodeName === "TH" || (0, $4ZDHT.closest)(range.startContainer.parentNode, "td,th") || proxy.parent.iframeSettings.enable && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(parentNode.ownerDocument.querySelector("body"), "e-lib")) && range.collapsed && args.subCommand === "BackgroundColor" && (0, $4ZDHT.closest)(closestElement, "." + $afc560df281b588d$export$1961a0ca09d720a9)) proxy.parent.notify($947a002e9a697770$export$417c038e951e7489, {
                        item: {
                            command: args.command,
                            subCommand: args.subCommand,
                            value: colorpickerValue
                        }
                    });
                    else proxy.parent.notify($947a002e9a697770$export$be0ed384f2f95da8, {
                        item: {
                            command: args.command,
                            subCommand: args.subCommand,
                            value: colorpickerValue
                        }
                    });
                    return;
                } else {
                    var ele = dropDownArgs.element.querySelector(".e-control.e-colorpicker");
                    var inst = (0, $3EnZW.getInstance)(ele, (0, $38fcc89172ec2635$export$9feb1bc2e5f1ccb3));
                    inst.showButtons = dropDownArgs.element.querySelector(".e-color-palette") ? false : true;
                    inst.dataBind();
                }
                dropDownArgs.element.onclick = function(args) {
                    if (args.target.classList.contains("e-cancel")) dropDown.toggle();
                };
            },
            open: function(dropDownArgs) {
                _this.setColorPickerContentWidth(colorPicker);
                var focusEle;
                var ele = dropDownArgs.element.querySelector(".e-control.e-colorpicker");
                if (dropDownArgs.element.querySelector(".e-color-palette")) focusEle = ele.parentElement.querySelector(".e-palette");
                else focusEle = ele.parentElement.querySelector("e-handler");
                if (focusEle) focusEle.focus();
                _this.pickerRefresh(dropDownArgs);
            },
            beforeClose: function(dropDownArgs) {
                var element = dropDownArgs.event ? dropDownArgs.event.target : null;
                if (dropDownArgs.event && dropDownArgs.event.type === "click" && (element.classList.contains((0, $afc560df281b588d$export$7a2bf3ea134093f0)) || element.parentElement.classList.contains((0, $afc560df281b588d$export$7a2bf3ea134093f0)))) {
                    var colorpickerValue = element.classList.contains((0, $afc560df281b588d$export$d3f61cb93957903e)) ? element.style.borderBottomColor : element.querySelector("." + (0, $afc560df281b588d$export$d3f61cb93957903e)).style.borderBottomColor;
                    range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.parent.contentModule.getDocument());
                    if ((range.startContainer.nodeName === "TD" || range.startContainer.nodeName === "TH" || (0, $4ZDHT.closest)(range.startContainer.parentNode, "td,th")) && range.collapsed) proxy.parent.notify($947a002e9a697770$export$417c038e951e7489, {
                        item: {
                            command: args.command,
                            subCommand: args.subCommand,
                            value: colorpickerValue
                        }
                    });
                    else proxy.parent.notify($947a002e9a697770$export$be0ed384f2f95da8, {
                        item: {
                            command: args.command,
                            subCommand: args.subCommand,
                            value: colorpickerValue
                        }
                    });
                    return;
                }
            },
            close: function() {
                proxy.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
            }
        });
        dropDown.isStringTemplate = true;
        dropDown.createElement = proxy.parent.createElement;
        args.element.setAttribute("role", "button");
        dropDown.appendTo(args.element);
        var popupElement = document.getElementById(dropDown.element.id + "-popup");
        popupElement.setAttribute("aria-owns", this.parent.getID());
        dropDown.element.insertBefore(content, dropDown.element.querySelector(".e-caret"));
        args.element.tabIndex = -1;
        dropDown.element.removeAttribute("type");
        dropDown.element.onmousedown = function() {
            proxy.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
        };
        dropDown.element.onkeydown = function() {
            proxy.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
        };
        return dropDown;
    };
    ToolbarRenderer.prototype.pickerRefresh = function(dropDownArgs) {
        if (this.parent.backgroundColor.mode === "Picker") {
            var popupElem = dropDownArgs.element.parentElement;
            popupElem.style.width = (popupElem.offsetWidth + 5).toString() + "px";
            (0, $3EnZW.getInstance)(popupElem, (0, $2vAqh.Popup)).refreshPosition(popupElem);
            popupElem.style.width = (popupElem.offsetWidth - 5).toString() + "px";
        }
    };
    ToolbarRenderer.prototype.setColorPickerContentWidth = function(colorPicker) {
        var colorPickerContent = colorPicker.element.nextSibling;
        if (colorPickerContent.style.width === "0px") {
            colorPickerContent.style.width = "";
            var borderWidth = parseInt(getComputedStyle(colorPickerContent).borderBottomWidth, 10);
            colorPickerContent.style.width = (0, $3EnZW.formatUnit)(colorPickerContent.children[0].offsetWidth + borderWidth + borderWidth);
        }
    };
    /**
     * renderColorPicker method
     *
     * @param {IColorPickerModel} args - specifies the arguments
     * @param {string} item - specifies the string values
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderColorPicker = function(args, item) {
        var _this = this;
        // eslint-disable-next-line
        var proxy = this;
        var value;
        var colorPicker = new (0, $38fcc89172ec2635$export$9feb1bc2e5f1ccb3)({
            enablePersistence: this.parent.enablePersistence,
            enableRtl: this.parent.enableRtl,
            inline: true,
            value: null,
            cssClass: (item === "backgroundcolor" ? (0, $afc560df281b588d$export$c914a9c929148d63) : (0, $afc560df281b588d$export$39c6a5301555ae46)) + " " + args.cssClass + " " + "e-rte-picker-init",
            created: function() {
                var value = item === "backgroundcolor" ? proxy.parent.backgroundColor.default : proxy.parent.fontColor.default;
                var cssClass = (item === "backgroundcolor" ? (0, $afc560df281b588d$export$c914a9c929148d63) : (0, $afc560df281b588d$export$39c6a5301555ae46)) + " " + args.cssClass;
                colorPicker.setProperties({
                    value: value,
                    cssClass: cssClass
                });
            },
            mode: item === "backgroundcolor" ? proxy.parent.backgroundColor.mode : proxy.parent.fontColor.mode,
            modeSwitcher: item === "backgroundcolor" ? proxy.parent.backgroundColor.modeSwitcher : proxy.parent.fontColor.modeSwitcher,
            presetColors: item === "backgroundcolor" ? this.parent.backgroundColor.colorCode : this.parent.fontColor.colorCode,
            columns: item === "backgroundcolor" ? this.parent.backgroundColor.columns : this.parent.fontColor.columns,
            beforeTileRender: function(args) {
                args.element.classList.add((0, $afc560df281b588d$export$cfaef651d407891e));
                args.element.classList.add((0, $afc560df281b588d$export$7773d35a37f81fdf));
                if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.cssClass)) {
                    var allClassName = _this.parent.getCssClass().split(" ");
                    for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") args.element.classList.add(allClassName[i]);
                }
                if (args.value === "") args.element.classList.add((0, $afc560df281b588d$export$5dc99c196bef170f));
            },
            change: function(colorPickerArgs) {
                var colorpickerValue = colorPickerArgs.currentValue.rgba;
                colorPickerArgs.item = {
                    command: args.command,
                    subCommand: args.subCommand,
                    value: colorpickerValue
                };
                proxy.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
                proxy.currentElement.querySelector("." + (0, $afc560df281b588d$export$d3f61cb93957903e)).style.borderBottomColor = colorpickerValue;
                var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.parent.contentModule.getDocument());
                var closestElement = (0, $4ZDHT.closest)(range.startContainer.parentNode, "table");
                if ((range.startContainer.nodeName === "TD" || range.startContainer.nodeName === "TH" || range.startContainer.nodeName === "BODY" || (0, $4ZDHT.closest)(range.startContainer.parentNode, "td,th")) && range.collapsed && args.subCommand === "BackgroundColor" && (0, $4ZDHT.closest)(closestElement, "." + $afc560df281b588d$export$1961a0ca09d720a9)) proxy.parent.notify($947a002e9a697770$export$417c038e951e7489, colorPickerArgs);
                else proxy.parent.notify($947a002e9a697770$export$be0ed384f2f95da8, colorPickerArgs);
                proxy.currentDropdown.toggle();
            },
            beforeModeSwitch: function(args) {
                value = colorPicker.value;
                if (value === "") colorPicker.setProperties({
                    value: args.mode === "Picker" ? "#008000ff" : ""
                }, true);
                colorPicker.showButtons = args.mode === "Palette" ? false : true;
            }
        });
        colorPicker.isStringTemplate = true;
        colorPicker.createElement = this.parent.createElement;
        colorPicker.appendTo(document.getElementById(args.target));
        return colorPicker;
    };
    /**
     * The function is used to render Rich Text Editor toolbar
     *
     * @returns {void}
     * @hidden

     */ ToolbarRenderer.prototype.renderPanel = function() {
        this.getPanel().classList.add((0, $afc560df281b588d$export$c944507d642a4701));
    };
    /**
     * Get the toolbar element of RichTextEditor
     *
     * @returns {Element} - specifies the element.
     * @hidden

     */ ToolbarRenderer.prototype.getPanel = function() {
        return this.toolbarPanel;
    };
    /**
     * Set the toolbar element of RichTextEditor
     *
     * @returns {void}
     * @param  {Element} panel - specifies the element.
     * @hidden

     */ ToolbarRenderer.prototype.setPanel = function(panel) {
        this.toolbarPanel = panel;
    };
    ToolbarRenderer.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.tooltip && !this.tooltip.isDestroyed) {
            this.tooltip.destroy();
            var tooltipElements = document.querySelectorAll('[data-rte-id="' + this.parent.getID() + '"]');
            for(var i = 0; i < tooltipElements.length; i++){
                var tooltipEle = tooltipElements[i];
                if (this.parent.getID() === tooltipEle.getAttribute("data-rte-id")) (0, $4ZDHT.detach)(tooltipEle);
            }
        }
        this.unWireEvent();
        this.mode = null;
        this.toolbarPanel = null;
        this.currentElement = null;
        this.currentDropdown = null;
        this.tooltip = null;
        this.tooltipTargetEle = null;
        this.isDestroyed = true;
    };
    return ToolbarRenderer;
}();


/**
 * `Toolbar` module is used to handle Toolbar actions.
 */ var $a8379000104ab123$export$550e9eddeb4f342e = /** @class */ function() {
    function BaseToolbar(parent, serviceLocator) {
        this.tools = {};
        this.parent = parent;
        this.locator = serviceLocator;
        this.isDestroyed = false;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
        if (this.parent.toolbarSettings && Object.keys(this.parent.toolbarSettings.itemConfigs).length > 0) (0, $3EnZW.extend)(this.tools, (0, $228f7f224d55f07b$export$904054328df186b), (0, $c77ecbfae9b8c035$export$422955f13ff9f307)(this.parent.toolbarSettings.itemConfigs), true);
        else this.tools = (0, $228f7f224d55f07b$export$904054328df186b);
        if (this.parent.toolbarSettings.enable || this.parent.quickToolbarSettings.enable) {
            this.toolbarRenderer = new (0, $e31405e65c29c50d$export$a3fa63e58e0aecf1)(this.parent, this.locator);
            this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Toolbar, this.toolbarRenderer);
        }
    }
    BaseToolbar.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
    };
    BaseToolbar.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
    };
    BaseToolbar.prototype.setCssClass = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.toolbarObj)) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) this.toolbarObj.setProperties({
                cssClass: (this.toolbarObj.cssClass + " " + e.cssClass).trim()
            });
            else this.toolbarObj.setProperties({
                cssClass: (this.toolbarObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    BaseToolbar.prototype.setRtl = function(args) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.toolbarObj)) this.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
    };
    BaseToolbar.prototype.getClass = function(item) {
        var classes;
        switch(item){
            case "fontsize":
                classes = "e-rte-inline-size-template";
                break;
            case "fontcolor":
            case "backgroundcolor":
                classes = "e-rte-inline-color-template";
                break;
            default:
                classes = "e-rte-inline-template";
                break;
        }
        return classes;
    };
    BaseToolbar.prototype.getTemplateObject = function(itemStr, container) {
        var tagName;
        switch(itemStr){
            case "fontcolor":
            case "backgroundcolor":
            case "numberformatlist":
            case "bulletformatlist":
                tagName = "span";
                break;
            default:
                tagName = "button";
                break;
        }
        return {
            command: this.tools[itemStr.toLocaleLowerCase()].command,
            subCommand: this.tools[itemStr.toLocaleLowerCase()].subCommand,
            template: this.parent.createElement(tagName, {
                id: this.parent.getID() + "_" + container + "_" + this.tools[itemStr.toLocaleLowerCase()].id
            }).outerHTML,
            cssClass: this.parent.inlineMode.enable ? this.getClass(itemStr) : "",
            tooltipText: (0, $c77ecbfae9b8c035$export$3c8120d2b233073c)(itemStr, this.locator)
        };
    };
    /**
     * getObject method
     *
     * @param {string} item - specifies the string value
     * @param {string} container - specifies the value of string
     * @returns {IToolbarItemModel} - returns the model element
     * @hidden

     */ BaseToolbar.prototype.getObject = function(item, container) {
        var itemStr = item.toLowerCase();
        if ((0, $228f7f224d55f07b$export$eb8062f5486943a9).indexOf(itemStr) !== -1) return this.getTemplateObject(itemStr, container);
        else switch(itemStr){
            case "|":
                return {
                    type: "Separator"
                };
            case "-":
                return {
                    type: "Separator",
                    cssClass: (0, $afc560df281b588d$export$1814cae66e425659)
                };
            default:
                return {
                    id: this.parent.getID() + "_" + container + "_" + this.tools[itemStr.toLocaleLowerCase()].id,
                    prefixIcon: this.tools[itemStr.toLocaleLowerCase()].icon,
                    tooltipText: (0, $c77ecbfae9b8c035$export$3c8120d2b233073c)(itemStr, this.locator),
                    command: this.tools[itemStr.toLocaleLowerCase()].command,
                    subCommand: this.tools[itemStr.toLocaleLowerCase()].subCommand
                };
        }
    };
    /**
     * @param {string} tbItems - specifies the string value
     * @param {string} container - specifies the container value
     * @returns {ItemModel} - retunrs the model element
     * @hidden

     */ BaseToolbar.prototype.getItems = function(tbItems, container) {
        var _this = this;
        if (this.parent.toolbarSettings.items.length < 1) return [];
        var items = [];
        var _loop_1 = function(item) {
            switch(typeof item){
                case "string":
                    items.push(this_1.getObject(item, container));
                    break;
                default:
                    if (!(0, $3EnZW.isNullOrUndefined)(item.click)) {
                        var proxy_1 = item;
                        var callback_1 = proxy_1.click;
                        proxy_1.click = function() {
                            if (proxy_1.undo && _this.parent.formatter.getUndoRedoStack().length === 0) _this.parent.formatter.saveData();
                            callback_1.call(_this);
                            if (_this.parent.formatter.getUndoRedoStack().length > 0) {
                                var currentContentElem = _this.parent.createElement("div");
                                var stackItem = _this.parent.formatter.getUndoRedoStack()[_this.parent.formatter.getUndoRedoStack().length - 1];
                                var clonedItem = stackItem.text.cloneNode(true);
                                currentContentElem.appendChild(clonedItem);
                                if (currentContentElem.innerHTML.trim() === _this.parent.inputElement.innerHTML.trim()) return;
                            }
                            if (proxy_1.undo) _this.parent.formatter.saveData();
                        };
                    }
                    items.push(item);
            }
        };
        var this_1 = this;
        for(var _i = 0, tbItems_1 = tbItems; _i < tbItems_1.length; _i++){
            var item = tbItems_1[_i];
            _loop_1(item);
        }
        if (this.parent.showTooltip) for(var num = 0; num < items.length; num++){
            var tooltipText = items[num].tooltipText;
            var shortCutKey = void 0;
            var isMacDev = window.navigator.platform.toLocaleLowerCase().includes("mac");
            if ((0, $228f7f224d55f07b$export$82ec818572629db6)["" + tooltipText] && (!(0, $3EnZW.isNullOrUndefined)(items[num].id) || !(0, $3EnZW.isNullOrUndefined)(items[num].cssClass))) shortCutKey = isMacDev ? (0, $228f7f224d55f07b$export$82ec818572629db6)["" + tooltipText].replace("Ctrl+", "\u2318").replace("Shift+", "\u21E7").replace("Alt+", "\u2325") : (0, $228f7f224d55f07b$export$82ec818572629db6)["" + tooltipText];
            else shortCutKey = tooltipText;
            if (shortCutKey) {
                if (!(items[num].command === "Images" && items[num].subCommand === "InsertLink")) items[num].tooltipText = tooltipText !== shortCutKey ? tooltipText + " (" + shortCutKey + ")" : tooltipText;
            }
        }
        return items;
    };
    BaseToolbar.prototype.getToolbarOptions = function(args) {
        return {
            target: args.target,
            rteToolbarObj: this,
            items: this.getItems(args.items, args.container),
            overflowMode: args.mode,
            enablePersistence: this.parent.enablePersistence,
            enableRtl: this.parent.enableRtl,
            cssClass: args.cssClass,
            type: args.container
        };
    };
    /**
     * render method
     *
     * @param {IToolbarRenderOptions} args - specifies the toolbar options
     * @returns {void}
     * @hidden

     */ BaseToolbar.prototype.render = function(args) {
        this.toolbarRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Toolbar);
        if (this.toolbarRenderer && this.toolbarRenderer.isDestroyed) this.toolbarRenderer = new (0, $e31405e65c29c50d$export$a3fa63e58e0aecf1)(this.parent, this.locator);
        this.toolbarRenderer.renderToolbar(this.getToolbarOptions(args));
    };
    BaseToolbar.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.removeEventListener();
        if (this.toolbarObj && !this.toolbarObj.isDestroyed) {
            this.toolbarObj.destroy();
            this.toolbarObj = null;
        }
        this.toolbarRenderer.destroy();
        this.toolbarRenderer = null;
        this.tools = {};
        this.isDestroyed = true;
    };
    return BaseToolbar;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");





/**
 * `Toolbar` module is used to handle Toolbar actions.
 */ var $7fd080065df28547$export$6a25c66b900b8efc = /** @class */ function() {
    function DropDownButtons(parent, serviceLocator) {
        this.parent = parent;
        this.locator = serviceLocator;
        this.i10n = serviceLocator.getService("rteLocale");
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
    }
    DropDownButtons.prototype.initializeInstance = function() {
        this.toolbarRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Toolbar);
    };
    DropDownButtons.prototype.beforeRender = function(args) {
        var item = args.item;
        if (item.cssClass) (0, $4ZDHT.addClass)([
            args.element
        ], item.cssClass);
    };
    DropDownButtons.prototype.dropdownContent = function(width, type, content) {
        return '<span style="display: inline-flex;width:' + (type === "quick" ? "auto" : width) + '" >' + '<span class="e-rte-dropdown-btn-text">' + content + "</span></span>";
    };
    /**
     * renderDropDowns method
     *
     * @param {IDropDownRenderArgs} args - specifies the arguments
     * @returns {void}
     * @hidden

     */ DropDownButtons.prototype.renderDropDowns = function(args) {
        var _this = this;
        this.initializeInstance();
        var type = args.containerType;
        var tbElement = args.container;
        $228f7f224d55f07b$export$eb8062f5486943a9.forEach(function(item) {
            var targetElement = undefined;
            if ((0, $c77ecbfae9b8c035$export$ddfa24987dade61b)(item, args.items) !== -1) switch(item){
                case "numberformatlist":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_NumberFormatList", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    var formatOLItem = _this.parent.numberFormatList.types.slice();
                    formatOLItem.forEach(function(item) {
                        Object.defineProperties(item, {
                            command: {
                                value: "Lists",
                                enumerable: true
                            },
                            subCommand: {
                                value: "NumberFormatList",
                                enumerable: true
                            }
                        });
                    });
                    _this.numberFormatListDropDown = _this.toolbarRenderer.renderListDropDown({
                        cssClass: "e-order-list " + $afc560df281b588d$export$d3f61cb93957903e + " " + $afc560df281b588d$export$dca6c13941d1c7e,
                        itemName: "NumberFormatList",
                        items: formatOLItem,
                        element: targetElement
                    });
                    break;
                case "bulletformatlist":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_BulletFormatList", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    var formatULItem = _this.parent.bulletFormatList.types.slice();
                    formatULItem.forEach(function(item) {
                        Object.defineProperties(item, {
                            command: {
                                value: "Lists",
                                enumerable: true
                            },
                            subCommand: {
                                value: "BulletFormatList",
                                enumerable: true
                            }
                        });
                    });
                    _this.bulletFormatListDropDown = _this.toolbarRenderer.renderListDropDown({
                        cssClass: "e-unorder-list " + $afc560df281b588d$export$d3f61cb93957903e + " " + $afc560df281b588d$export$dca6c13941d1c7e,
                        itemName: "BulletFormatList",
                        items: formatULItem,
                        element: targetElement
                    });
                    break;
                case "formats":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_Formats", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    var formatItem = _this.parent.format.types.slice();
                    formatItem.forEach(function(item) {
                        Object.defineProperties(item, {
                            command: {
                                value: "Formats",
                                enumerable: true
                            },
                            subCommand: {
                                value: item.value,
                                enumerable: true
                            }
                        });
                    });
                    var formatContent = (0, $3EnZW.isNullOrUndefined)(_this.parent.format.default) ? formatItem[0].text : _this.parent.format.default;
                    _this.formatDropDown = _this.toolbarRenderer.renderDropDownButton({
                        iconCss: type === "quick" ? "e-formats e-icons" : "",
                        content: _this.dropdownContent(_this.parent.format.width, type, type === "quick" ? "" : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(formatItem, formatContent, "text", "text")),
                        cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$322d1188ce2fb80b,
                        itemName: "Formats",
                        items: formatItem,
                        element: targetElement
                    });
                    break;
                case "fontname":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_FontName", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    var fontItem = _this.parent.fontFamily.items.slice();
                    fontItem.forEach(function(item) {
                        Object.defineProperties(item, {
                            command: {
                                value: "Font",
                                enumerable: true
                            },
                            subCommand: {
                                value: "FontName",
                                enumerable: true
                            }
                        });
                    });
                    var fontNameContent = (0, $3EnZW.isNullOrUndefined)(_this.parent.fontFamily.default) ? fontItem[0].text : _this.parent.fontFamily.default;
                    _this.fontNameDropDown = _this.toolbarRenderer.renderDropDownButton({
                        iconCss: type === "quick" ? "e-font-name e-icons" : "",
                        content: _this.dropdownContent(_this.parent.fontFamily.width, type, type === "quick" ? "" : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontItem, fontNameContent, "text", "text") === "Default" ? _this.i10n.getConstant("fontName") : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontItem, fontNameContent, "text", "text")),
                        cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$26e46de3c028f9ab,
                        itemName: "FontName",
                        items: fontItem,
                        element: targetElement
                    });
                    break;
                case "fontsize":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_FontSize", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    var fontsize = !(0, $3EnZW.isNullOrUndefined)(_this.fontSizeDropDown) && !(0, $3EnZW.isNullOrUndefined)(_this.fontSizeDropDown.items) && _this.fontSizeDropDown.items.length > 0 ? _this.fontSizeDropDown.items : JSON.parse(JSON.stringify(_this.parent.fontSize.items.slice()));
                    fontsize.forEach(function(item) {
                        Object.defineProperties(item, {
                            command: {
                                value: "Font",
                                enumerable: true
                            },
                            subCommand: {
                                value: "FontSize",
                                enumerable: true
                            }
                        });
                    });
                    var fontSizeContent = (0, $3EnZW.isNullOrUndefined)(_this.parent.fontSize.default) ? fontsize[0].text : _this.parent.fontSize.default;
                    var fontSizeDropDownContent = fontSizeContent === "Default" ? (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontsize, fontSizeContent.replace(/\s/g, ""), "text", "text") : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontsize, fontSizeContent.replace(/\s/g, ""), "value", "text");
                    _this.fontSizeDropDown = _this.toolbarRenderer.renderDropDownButton({
                        content: _this.dropdownContent(_this.parent.fontSize.width, type, (0, $c77ecbfae9b8c035$export$7c77dc956338b76)(fontSizeDropDownContent === "Default" ? _this.i10n.getConstant("fontSize") : fontSizeDropDownContent)),
                        cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$efeebb5e697869be,
                        itemName: "FontSize",
                        items: fontsize,
                        element: targetElement
                    });
                    break;
                case "alignments":
                    targetElement = (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + type + "_Alignments", tbElement);
                    if ((0, $3EnZW.isNullOrUndefined)(targetElement) || targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
                    _this.alignDropDown = _this.toolbarRenderer.renderDropDownButton({
                        iconCss: "e-justify-left e-icons",
                        cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$731568aba8c683a,
                        itemName: "Alignments",
                        items: $228f7f224d55f07b$export$37fac68e48a6e8a1,
                        element: targetElement
                    });
                    break;
                case "align":
                case "videoalign":
                    _this.renderAlignmentDropDown(type, tbElement, targetElement, item);
                    break;
                case "display":
                case "audiolayoutoption":
                case "videolayoutoption":
                    _this.renderDisplayDropDown(type, tbElement, targetElement, item);
                    break;
                case "tablerows":
                    _this.rowDropDown(type, tbElement, targetElement);
                    break;
                case "tablecolumns":
                    _this.columnDropDown(type, tbElement, targetElement);
                    break;
                case "tablecell":
                    _this.cellDropDown(type, tbElement, targetElement);
                    break;
                case "tablecellverticalalign":
                    _this.verticalAlignDropDown(type, tbElement, targetElement);
                    break;
                case "styles":
                    _this.tableStylesDropDown(type, tbElement, targetElement);
                    break;
            }
        });
        if (this.parent.inlineMode.enable) this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    DropDownButtons.prototype.getUpdateItems = function(items, value) {
        var dropDownItems = items.slice();
        dropDownItems.forEach(function(item) {
            Object.defineProperties(item, {
                command: {
                    value: value === "Format" ? "Formats" : "Font",
                    enumerable: true
                },
                subCommand: {
                    value: value === "Format" ? item.value : value,
                    enumerable: true
                }
            });
        });
        return dropDownItems;
    };
    DropDownButtons.prototype.onPropertyChanged = function(model) {
        var newProp = model.newProp;
        var type;
        var content;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "fontFamily":
                    if (this.fontNameDropDown) for(var _b = 0, _c = Object.keys(newProp.fontFamily); _b < _c.length; _b++){
                        var fontFamily = _c[_b];
                        switch(fontFamily){
                            case "default":
                            case "width":
                                var fontItems = this.fontNameDropDown.items;
                                type = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.fontNameDropDown.element, "." + $afc560df281b588d$export$1af4006d1f8f8239)) ? "quick" : "toolbar";
                                var fontNameContent = (0, $3EnZW.isNullOrUndefined)(this.parent.fontFamily.default) ? fontItems[0].text : this.parent.fontFamily.default;
                                content = this.dropdownContent(this.parent.fontFamily.width, type, type === "quick" ? "" : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontItems, fontNameContent, "text", "text") === "Default" ? this.i10n.getConstant("fontName") : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontItems, fontNameContent, "text", "text"));
                                this.fontNameDropDown.setProperties({
                                    content: content
                                });
                                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontFamily.default)) this.getEditNode().style.fontFamily = this.parent.fontFamily.default;
                                else this.getEditNode().style.removeProperty("font-family");
                                break;
                            case "items":
                                this.fontNameDropDown.setProperties({
                                    items: this.getUpdateItems(newProp.fontFamily.items, "FontName")
                                });
                                break;
                        }
                    }
                    break;
                case "fontSize":
                    if (this.fontSizeDropDown) for(var _d = 0, _e = Object.keys(newProp.fontSize); _d < _e.length; _d++){
                        var fontSize = _e[_d];
                        switch(fontSize){
                            case "default":
                            case "width":
                                var fontsize = this.fontSizeDropDown.items;
                                type = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.fontSizeDropDown.element, "." + $afc560df281b588d$export$1af4006d1f8f8239)) ? "quick" : "toolbar";
                                var fontSizeContent = (0, $3EnZW.isNullOrUndefined)(this.parent.fontSize.default) ? fontsize[0].text : this.parent.fontSize.default;
                                var fontSizeDropDownContent = fontSizeContent === "Default" ? (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontsize, fontSizeContent.replace(/\s/g, ""), "text", "text") : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(fontsize, fontSizeContent.replace(/\s/g, ""), "value", "text");
                                content = this.dropdownContent(this.parent.fontSize.width, type, (0, $c77ecbfae9b8c035$export$7c77dc956338b76)(fontSizeDropDownContent === "Default" ? this.i10n.getConstant("fontSize") : fontSizeDropDownContent));
                                this.fontSizeDropDown.setProperties({
                                    content: content
                                });
                                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.fontSize.default)) this.getEditNode().style.fontSize = this.parent.fontSize.default;
                                else this.getEditNode().style.removeProperty("font-size");
                                break;
                            case "items":
                                this.fontSizeDropDown.setProperties({
                                    items: this.getUpdateItems(newProp.fontSize.items, "FontSize")
                                });
                                break;
                        }
                    }
                    break;
                case "format":
                    if (this.formatDropDown) for(var _f = 0, _g = Object.keys(newProp.format); _f < _g.length; _f++){
                        var format = _g[_f];
                        switch(format){
                            case "default":
                            case "width":
                                var formatItems = this.formatDropDown.items;
                                type = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(this.formatDropDown.element, "." + $afc560df281b588d$export$1af4006d1f8f8239)) ? "quick" : "toolbar";
                                var formatContent = (0, $3EnZW.isNullOrUndefined)(this.parent.format.default) ? formatItems[0].text : this.parent.format.default;
                                content = this.dropdownContent(this.parent.format.width, type, type === "quick" ? "" : (0, $c77ecbfae9b8c035$export$ac59afca8e35227f)(formatItems, formatContent, "text", "text"));
                                this.formatDropDown.setProperties({
                                    content: content
                                });
                                break;
                            case "types":
                                this.formatDropDown.setProperties({
                                    items: this.getUpdateItems(newProp.format.types, "Format")
                                });
                                break;
                        }
                    }
                    break;
            }
        }
    };
    DropDownButtons.prototype.getEditNode = function() {
        return this.parent.contentModule.getEditPanel();
    };
    DropDownButtons.prototype.rowDropDown = function(type, tbElement, targetElement) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + "_TableRows", tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.tableRowsDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-table-rows e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: "TableRows",
            items: $228f7f224d55f07b$export$c29ed6326cb3f73b,
            element: targetElement
        });
    };
    DropDownButtons.prototype.columnDropDown = function(type, tbElement, targetElement) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + "_TableColumns", tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.tableColumnsDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-table-columns e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: "TableColumns",
            items: $228f7f224d55f07b$export$9e05ef73d8495ced,
            element: targetElement
        });
    };
    DropDownButtons.prototype.cellDropDown = function(type, tbElement, targetElement) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + "_TableCell", tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.tableCellDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-table-cell e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: "TableCell",
            items: $228f7f224d55f07b$export$405c7eefcc675146,
            element: targetElement
        });
    };
    DropDownButtons.prototype.verticalAlignDropDown = function(type, tbElement, targetElement) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + "_TableCellVerticalAlign", tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.tableCellVerticalAlignDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-table-cell-ver-align e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: "TableCellVerticalAlign",
            items: $228f7f224d55f07b$export$a713f1d7939b8be7,
            element: targetElement
        });
    };
    DropDownButtons.prototype.renderDisplayDropDown = function(type, tbElement, targetElement, item) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + (item === "display" ? "_Display" : item === "videolayoutoption" ? "_VideoLayoutOption" : "_AudioLayoutOption"), tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.displayDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: item === "display" ? "e-display e-icons" : item === "videolayoutoption" ? "e-video-display e-icons" : "e-audio-display e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$363cb49e8d5ce21c + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: item === "display" ? "Display" : item === "videolayoutoption" ? "VideoLayoutOption" : "AudioLayoutOption",
            items: item === "display" ? $228f7f224d55f07b$export$7fa25053523b3bbf : item === "videolayoutoption" ? $228f7f224d55f07b$export$a2ea5be81b76fd04 : $228f7f224d55f07b$export$7f774eaa2938202e,
            element: targetElement
        });
    };
    DropDownButtons.prototype.renderAlignmentDropDown = function(type, tbElement, targetElement, item) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + (item === "align" ? "_Align" : "_VideoAlign"), tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.imageAlignDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-justify-left e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$64945f631d1fe0d8 + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: item === "align" ? "Align" : "VideoAlign",
            items: item === "align" ? $228f7f224d55f07b$export$30dade541bdbdfa6 : $228f7f224d55f07b$export$c6055797c8a0da23,
            element: targetElement
        });
    };
    DropDownButtons.prototype.tableStylesDropDown = function(type, tbElement, targetElement) {
        targetElement = (0, $4ZDHT.select)("#" + this.parent.getID() + "_" + type + "_Styles", tbElement);
        if (targetElement.classList.contains($afc560df281b588d$export$a16280636ed97757)) return;
        this.imageAlignDropDown = this.toolbarRenderer.renderDropDownButton({
            iconCss: "e-style e-icons",
            cssClass: $afc560df281b588d$export$e87b94e3426d0cad + " " + $afc560df281b588d$export$64945f631d1fe0d8 + " " + $afc560df281b588d$export$ee37e714e6bdefff,
            itemName: "Styles",
            items: this.parent.tableSettings.styles,
            element: targetElement
        });
    };
    DropDownButtons.prototype.removeDropDownClasses = function(target) {
        (0, $4ZDHT.removeClass)([
            target
        ], [
            $afc560df281b588d$export$a16280636ed97757,
            $afc560df281b588d$export$e87b94e3426d0cad,
            $afc560df281b588d$export$64945f631d1fe0d8,
            $afc560df281b588d$export$363cb49e8d5ce21c
        ]);
    };
    /**
     * destroyDropDowns method
     *
     * @returns {void}
     * @hidden

     */ DropDownButtons.prototype.destroyDropDowns = function() {
        if (this.formatDropDown) {
            this.removeDropDownClasses(this.formatDropDown.element);
            this.formatDropDown.destroy();
            this.formatDropDown = null;
        }
        if (this.fontNameDropDown) {
            this.removeDropDownClasses(this.fontNameDropDown.element);
            this.fontNameDropDown.destroy();
            this.fontNameDropDown = null;
        }
        if (this.fontSizeDropDown) {
            this.removeDropDownClasses(this.fontSizeDropDown.element);
            this.fontSizeDropDown.destroy();
            this.fontSizeDropDown = null;
        }
        if (this.alignDropDown) {
            this.removeDropDownClasses(this.alignDropDown.element);
            this.alignDropDown.destroy();
            this.alignDropDown = null;
        }
        if (this.imageAlignDropDown) {
            this.removeDropDownClasses(this.imageAlignDropDown.element);
            this.imageAlignDropDown.destroy();
            this.imageAlignDropDown = null;
        }
        if (this.displayDropDown) {
            this.removeDropDownClasses(this.displayDropDown.element);
            this.displayDropDown.destroy();
            this.displayDropDown = null;
        }
        if (this.tableRowsDropDown) {
            this.removeDropDownClasses(this.tableRowsDropDown.element);
            this.tableRowsDropDown.destroy();
            this.tableRowsDropDown = null;
        }
        if (this.tableColumnsDropDown) {
            this.removeDropDownClasses(this.tableColumnsDropDown.element);
            this.tableColumnsDropDown.destroy();
            this.tableColumnsDropDown = null;
        }
        if (this.tableCellDropDown) {
            this.removeDropDownClasses(this.tableCellDropDown.element);
            this.tableCellDropDown.destroy();
            this.tableCellDropDown = null;
        }
        if (this.tableCellVerticalAlignDropDown) {
            this.removeDropDownClasses(this.tableCellVerticalAlignDropDown.element);
            this.tableCellVerticalAlignDropDown.destroy();
            this.tableCellVerticalAlignDropDown = null;
        }
        if (this.numberFormatListDropDown) {
            this.removeDropDownClasses(this.numberFormatListDropDown.element);
            this.numberFormatListDropDown.destroy();
            this.numberFormatListDropDown = null;
        }
        if (this.bulletFormatListDropDown) {
            this.removeDropDownClasses(this.bulletFormatListDropDown.element);
            this.bulletFormatListDropDown.destroy();
            this.bulletFormatListDropDown = null;
        }
        this.toolbarRenderer = null;
    };
    DropDownButtons.prototype.setRtl = function(args) {
        if (this.formatDropDown) this.formatDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.fontNameDropDown) this.fontNameDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.fontSizeDropDown) this.fontSizeDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.alignDropDown) this.alignDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.imageAlignDropDown) this.imageAlignDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.displayDropDown) this.displayDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.numberFormatListDropDown) this.numberFormatListDropDown.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.bulletFormatListDropDown) this.bulletFormatListDropDown.setProperties({
            enableRtl: args.enableRtl
        });
    };
    DropDownButtons.prototype.updateCss = function(dropDownObj, e) {
        if (dropDownObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) dropDownObj.setProperties({
                cssClass: (dropDownObj.cssClass + " " + e.cssClass).trim()
            });
            else dropDownObj.setProperties({
                cssClass: (dropDownObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    DropDownButtons.prototype.setCssClass = function(e) {
        var dropDownObj = [
            this.formatDropDown,
            this.fontNameDropDown,
            this.fontSizeDropDown,
            this.alignDropDown,
            this.imageAlignDropDown,
            this.displayDropDown,
            this.numberFormatListDropDown,
            this.bulletFormatListDropDown,
            this.tableRowsDropDown,
            this.tableColumnsDropDown,
            this.tableCellDropDown,
            this.tableCellVerticalAlignDropDown
        ];
        for(var i = 0; i < dropDownObj.length; i++)this.updateCss(dropDownObj[i], e);
    };
    DropDownButtons.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$9c270263992f2055, this.beforeRender, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
    };
    DropDownButtons.prototype.onIframeMouseDown = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getToolbarElement()) && (this.parent.getToolbarElement().querySelectorAll('.e-rte-dropdown-btn[aria-expanded="true"]').length > 0 || this.parent.getToolbarElement().querySelectorAll('.e-dropdown-btn.e-rte-inline-dropdown[aria-expanded="true"]').length > 0)) (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(document, "mousedown");
    };
    DropDownButtons.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl);
        this.parent.off($947a002e9a697770$export$9c270263992f2055, this.beforeRender);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
    };
    DropDownButtons.prototype.destroy = function() {
        this.removeEventListener();
        this.destroyDropDowns();
    };
    return DropDownButtons;
}();


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");





/**
 * `Color Picker` module is used to handle ColorPicker actions.
 */ var $7284c217dd61c302$export$75bdaf6ecc1f1e02 = /** @class */ function() {
    function ColorPickerInput(parent, serviceLocator) {
        this.tools = {};
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.addEventListener();
        if (this.parent.toolbarSettings && Object.keys(this.parent.toolbarSettings.itemConfigs).length > 0) (0, $3EnZW.extend)(this.tools, (0, $228f7f224d55f07b$export$904054328df186b), (0, $c77ecbfae9b8c035$export$422955f13ff9f307)(this.parent.toolbarSettings.itemConfigs), true);
        else this.tools = (0, $228f7f224d55f07b$export$904054328df186b);
    }
    ColorPickerInput.prototype.initializeInstance = function() {
        this.toolbarRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Toolbar);
    };
    /**
     * renderColorPickerInput method
     *
     * @param {IColorPickerRenderArgs} args - specify the arguments.
     * @returns {void}
     * @hidden

     */ ColorPickerInput.prototype.renderColorPickerInput = function(args) {
        var _this = this;
        this.initializeInstance();
        var suffixID = args.containerType;
        var tbElement = args.container;
        var targetID;
        var options;
        (0, $228f7f224d55f07b$export$eb8062f5486943a9).forEach(function(item) {
            if ((0, $c77ecbfae9b8c035$export$ddfa24987dade61b)(item, args.items) !== -1) switch(item){
                case "fontcolor":
                    targetID = _this.parent.getID() + "_" + suffixID + "_FontColor_Target";
                    var fontNode = _this.parent.createElement("input");
                    fontNode.id = targetID;
                    fontNode.classList.add($afc560df281b588d$export$a58de53b69ab3ae1);
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.cssClass)) {
                        var allClassName = _this.parent.cssClass.split(" ");
                        for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") fontNode.classList.add(allClassName[i]);
                    }
                    document.body.appendChild(fontNode);
                    options = {
                        cssClass: _this.tools[item.toLocaleLowerCase()].icon + " " + $afc560df281b588d$export$d3f61cb93957903e + " " + $afc560df281b588d$export$dca6c13941d1c7e + _this.parent.getCssClass(true),
                        value: _this.tools[item.toLocaleLowerCase()].value,
                        command: _this.tools[item.toLocaleLowerCase()].command,
                        subCommand: _this.tools[item.toLocaleLowerCase()].subCommand,
                        element: (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + suffixID + "_FontColor", tbElement),
                        target: targetID
                    };
                    _this.fontColorPicker = _this.toolbarRenderer.renderColorPicker(options, "fontcolor");
                    _this.fontColorDropDown = _this.toolbarRenderer.renderColorPickerDropDown(options, "fontcolor", _this.fontColorPicker);
                    break;
                case "backgroundcolor":
                    targetID = _this.parent.getID() + "_" + suffixID + "_BackgroundColor_Target";
                    var backNode = _this.parent.createElement("input");
                    backNode.id = targetID;
                    backNode.classList.add($afc560df281b588d$export$a8e816139edb38c7);
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.cssClass)) {
                        var allClassName = _this.parent.cssClass.split(" ");
                        for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") backNode.classList.add(allClassName[i]);
                    }
                    document.body.appendChild(backNode);
                    options = {
                        cssClass: _this.tools[item.toLocaleLowerCase()].icon + " " + $afc560df281b588d$export$d3f61cb93957903e + " " + $afc560df281b588d$export$dca6c13941d1c7e + _this.parent.getCssClass(true),
                        value: _this.tools[item.toLocaleLowerCase()].value,
                        command: _this.tools[item.toLocaleLowerCase()].command,
                        subCommand: _this.tools[item.toLocaleLowerCase()].subCommand,
                        element: (0, $4ZDHT.select)("#" + _this.parent.getID() + "_" + suffixID + "_BackgroundColor", tbElement),
                        target: targetID
                    };
                    _this.backgroundColorPicker = _this.toolbarRenderer.renderColorPicker(options, "backgroundcolor");
                    _this.backgroundColorDropDown = _this.toolbarRenderer.renderColorPickerDropDown(options, "backgroundcolor", _this.backgroundColorPicker, _this.defaultColorPicker);
                    break;
            }
        });
        if (this.parent.inlineMode.enable) this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    ColorPickerInput.prototype.destroy = function() {
        this.removeEventListener();
        this.destroyColorPicker();
        this.defaultColorPicker = null;
        this.fontColorPicker = null;
        this.fontColorDropDown = null;
        this.backgroundColorDropDown = null;
        this.backgroundColorPicker = null;
        this.tools = {};
    };
    /**
     * destroyColorPicker method
     *
     * @returns {void}
     * @hidden

     */ ColorPickerInput.prototype.destroyColorPicker = function() {
        if (this.fontColorPicker && !this.fontColorPicker.isDestroyed) this.fontColorPicker.destroy();
        if (this.backgroundColorPicker && !this.backgroundColorPicker.isDestroyed) this.backgroundColorPicker.destroy();
        if (this.fontColorDropDown && !this.fontColorDropDown.isDestroyed) {
            var innerEle = this.fontColorDropDown.element.querySelector(".e-rte-color-content");
            if (innerEle) (0, $4ZDHT.detach)(innerEle);
            this.fontColorDropDown.destroy();
        }
        if (this.backgroundColorDropDown && !this.backgroundColorDropDown.isDestroyed) {
            var innerEle = this.backgroundColorDropDown.element.querySelector(".e-rte-color-content");
            if (innerEle) {
                this.defaultColorPicker = innerEle.children[0].style.borderBottomColor;
                (0, $4ZDHT.detach)(innerEle);
            }
            this.backgroundColorDropDown.destroy();
        }
    };
    ColorPickerInput.prototype.setRtl = function(args) {
        if (this.fontColorPicker) {
            this.fontColorPicker.setProperties({
                enableRtl: args.enableRtl
            });
            this.fontColorDropDown.setProperties({
                enableRtl: args.enableRtl
            });
        }
        if (this.backgroundColorPicker) {
            this.backgroundColorPicker.setProperties({
                enableRtl: args.enableRtl
            });
            this.backgroundColorDropDown.setProperties({
                enableRtl: args.enableRtl
            });
        }
    };
    ColorPickerInput.prototype.setCssClass = function(e) {
        this.updateCss(this.fontColorPicker, this.fontColorDropDown, e);
        this.updateCss(this.backgroundColorPicker, this.backgroundColorDropDown, e);
    };
    ColorPickerInput.prototype.updateCss = function(colorPickerObj, dropDownObj, e) {
        if (colorPickerObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) {
                colorPickerObj.setProperties({
                    cssClass: (colorPickerObj.cssClass + " " + e.cssClass).trim()
                });
                dropDownObj.setProperties({
                    cssClass: (dropDownObj.cssClass + " " + e.cssClass).trim()
                });
            } else {
                colorPickerObj.setProperties({
                    cssClass: (colorPickerObj.cssClass.replace(e.oldCssClass, "").replace("  ", " ").trim() + " " + e.cssClass).trim()
                });
                dropDownObj.setProperties({
                    cssClass: (dropDownObj.cssClass.replace(e.oldCssClass, "").replace("  ", " ").trim() + " " + e.cssClass).trim()
                });
            }
        }
    };
    ColorPickerInput.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$4598c5c2283d3ecd, this.renderColorPickerInput, this);
        this.parent.on($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$8c46940ff642b0df, this.showColorPicker, this);
    };
    ColorPickerInput.prototype.showColorPicker = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.fontColorPicker) && e.toolbarClick === "fontcolor") this.fontColorDropDown.toggle();
        else if (!(0, $3EnZW.isNullOrUndefined)(this.backgroundColorPicker) && e.toolbarClick === "backgroundcolor") this.backgroundColorDropDown.toggle();
    };
    ColorPickerInput.prototype.onPropertyChanged = function(model) {
        var newProp = model.newProp;
        var element;
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "fontColor":
                    if (this.fontColorPicker) for(var _b = 0, _c = Object.keys(newProp.fontColor); _b < _c.length; _b++){
                        var font = _c[_b];
                        switch(font){
                            case "default":
                                this.fontColorPicker.setProperties({
                                    value: newProp.fontColor.default
                                });
                                element = this.fontColorDropDown.element;
                                var fontBorder = element.querySelector("." + this.tools["fontcolor"].icon);
                                fontBorder.style.borderBottomColor = newProp.fontColor.default;
                                break;
                            case "mode":
                                this.fontColorPicker.setProperties({
                                    mode: newProp.fontColor.mode
                                });
                                break;
                            case "columns":
                                this.fontColorPicker.setProperties({
                                    columns: newProp.fontColor.columns
                                });
                                break;
                            case "colorCode":
                                this.fontColorPicker.setProperties({
                                    presetColors: newProp.fontColor.colorCode
                                });
                                break;
                            case "modeSwitcher":
                                this.fontColorPicker.setProperties({
                                    modeSwitcher: newProp.fontColor.modeSwitcher
                                });
                                break;
                        }
                    }
                    break;
                case "backgroundColor":
                    if (this.backgroundColorPicker) for(var _d = 0, _e = Object.keys(newProp.backgroundColor); _d < _e.length; _d++){
                        var background = _e[_d];
                        switch(background){
                            case "default":
                                this.backgroundColorPicker.setProperties({
                                    value: newProp.backgroundColor.default
                                });
                                element = this.backgroundColorDropDown.element;
                                var backgroundBorder = element.querySelector("." + this.tools["backgroundcolor"].icon);
                                backgroundBorder.style.borderBottomColor = newProp.backgroundColor.default;
                                break;
                            case "mode":
                                this.backgroundColorPicker.setProperties({
                                    mode: newProp.backgroundColor.mode
                                });
                                break;
                            case "columns":
                                this.backgroundColorPicker.setProperties({
                                    columns: newProp.backgroundColor.columns
                                });
                                break;
                            case "colorCode":
                                this.backgroundColorPicker.setProperties({
                                    presetColors: newProp.backgroundColor.colorCode
                                });
                                break;
                            case "modeSwitcher":
                                this.backgroundColorPicker.setProperties({
                                    modeSwitcher: newProp.backgroundColor.modeSwitcher
                                });
                                break;
                        }
                    }
                    break;
            }
        }
    };
    ColorPickerInput.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$4598c5c2283d3ecd, this.renderColorPickerInput);
        this.parent.off($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$8c46940ff642b0df, this.showColorPicker);
    };
    return ColorPickerInput;
}();


/**
 * `Quick toolbar` module is used to handle Quick toolbar actions.
 */ var $5dadc1d67af1956c$export$84902c903b3ee5ae = /** @class */ function() {
    function BaseQuickToolbar(parent, locator) {
        this.parent = parent;
        this.locator = locator;
        this.isRendered = false;
        this.isDestroyed = false;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        this.popupRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Popup);
        this.dropDownButtons = new (0, $7fd080065df28547$export$6a25c66b900b8efc)(this.parent, this.locator);
        this.colorPickerObj = new (0, $7284c217dd61c302$export$75bdaf6ecc1f1e02)(this.parent, this.locator);
    }
    BaseQuickToolbar.prototype.appendPopupContent = function() {
        this.toolbarElement = this.parent.createElement("div", {
            className: $afc560df281b588d$export$1af4006d1f8f8239
        });
        if (this.element.classList.contains($afc560df281b588d$export$76164a13d58bec6)) this.toolbarElement.classList.add($afc560df281b588d$export$a46bb09fc4657cb4);
        this.element.appendChild(this.toolbarElement);
    };
    /**
     * render method
     *
     * @param {IQuickToolbarOptions} args - specifies the arguments
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.render = function(args) {
        var className;
        if (args.popupType === "Image") className = $afc560df281b588d$export$b34e1d1e0c3f7110;
        else if (args.popupType === "Inline") className = $afc560df281b588d$export$757b82a79a74806a;
        else if (args.popupType === "Text") className = $afc560df281b588d$export$76164a13d58bec6;
        else className = "";
        var popupId = (0, $3EnZW.getUniqueID)(args.popupType + "_Quick_Popup");
        this.stringItems = args.toolbarItems;
        this.element = this.parent.createElement("div", {
            id: popupId,
            className: className + " " + $afc560df281b588d$export$d3f61cb93957903e
        });
        this.element.setAttribute("aria-owns", this.parent.getID());
        this.appendPopupContent();
        this.createToolbar(args.toolbarItems, args.mode, args.cssClass);
        this.popupRenderer.renderPopup(this);
        this.addEventListener();
    };
    BaseQuickToolbar.prototype.createToolbar = function(items, mode, cssClass) {
        this.quickTBarObj = new (0, $a8379000104ab123$export$550e9eddeb4f342e)(this.parent, this.locator);
        this.quickTBarObj.render({
            container: "quick",
            target: this.toolbarElement,
            items: items,
            mode: mode,
            cssClass: cssClass
        });
        this.quickTBarObj.toolbarObj.refresh();
    };
    BaseQuickToolbar.prototype.setPosition = function(e) {
        var x;
        var y;
        var imgWrapper = (0, $4ZDHT.closest)(e.target, ".e-img-caption");
        var isAligned = e.target.classList.contains("e-imginline") || e.target.classList.contains("e-imgbreak") ? false : true;
        var target = !(0, $3EnZW.isNullOrUndefined)(imgWrapper) ? imgWrapper : e.target;
        (0, $4ZDHT.addClass)([
            this.toolbarElement
        ], [
            $afc560df281b588d$export$2e33093ebe88b75b
        ]);
        var targetOffsetTop;
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "table")) && !target.classList.contains("e-multi-cells-select") && !target.classList.contains("e-rte-image")) {
            targetOffsetTop = target.offsetTop;
            var parentTable = (0, $4ZDHT.closest)(target, "table");
            while(!(0, $3EnZW.isNullOrUndefined)(parentTable)){
                targetOffsetTop += parentTable.offsetTop;
                parentTable = (0, $4ZDHT.closest)(parentTable.parentElement, "table");
            }
        } else targetOffsetTop = target.classList.contains("e-rte-audio") ? target.parentElement.offsetTop : target.offsetTop;
        var parentOffsetTop = window.pageYOffset + e.parentData.top;
        if (targetOffsetTop - e.editTop > e.popHeight) y = parentOffsetTop + e.tBarElementHeight + (targetOffsetTop - e.editTop) - e.popHeight - 5;
        else if (e.editTop + e.editHeight - (targetOffsetTop + target.offsetHeight) > e.popHeight) y = parentOffsetTop + e.tBarElementHeight + (targetOffsetTop - e.editTop) + target.offsetHeight + 5;
        else y = e.y;
        target = isAligned ? e.target : target;
        var targetOffsetLeft;
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "table")) && !target.classList.contains("e-multi-cells-select") && !target.classList.contains("e-rte-image")) {
            targetOffsetLeft = target.offsetLeft;
            var parentTable = (0, $4ZDHT.closest)(target.parentElement, "th, td");
            while(!(0, $3EnZW.isNullOrUndefined)(parentTable)){
                targetOffsetLeft += parentTable.offsetLeft;
                parentTable = (0, $4ZDHT.closest)(parentTable.parentElement, "table");
            }
        } else targetOffsetLeft = target.classList.contains("e-rte-audio") ? target.parentElement.offsetLeft : target.offsetLeft;
        if (target.offsetWidth > e.popWidth) x = target.offsetWidth / 2 - e.popWidth / 2 + e.parentData.left + targetOffsetLeft;
        else x = e.parentData.left + targetOffsetLeft;
        this.popupObj.position.X = x + e.popWidth > e.parentData.right ? e.parentData.right - e.popWidth : x;
        this.popupObj.position.Y = y >= 0 ? y : e.y + 5;
        this.popupObj.dataBind();
        (0, $4ZDHT.removeClass)([
            this.toolbarElement
        ], [
            $afc560df281b588d$export$2e33093ebe88b75b
        ]);
    };
    BaseQuickToolbar.prototype.checkCollision = function(e, viewPort, type) {
        var x;
        var y;
        var parentTop = e.parentData.top;
        var contentTop = e.windowY + parentTop + e.tBarElementHeight;
        var collision = [];
        if (viewPort === "document") collision = (0, $49u5W.isCollide)(e.popup);
        else collision = (0, $49u5W.isCollide)(e.popup, e.parentElement);
        for(var i = 0; i < collision.length; i++)switch(collision[i]){
            case "top":
                if (viewPort === "document") y = e.windowY;
                else y = window.pageYOffset + parentTop + e.tBarElementHeight;
                break;
            case "bottom":
                var posY = void 0;
                if (viewPort === "document") {
                    if (type === "inline" || type === "text") posY = e.y - e.popHeight - 10;
                    else if (e.windowHeight - (parentTop + e.tBarElementHeight) > e.popHeight) {
                        if (contentTop - e.windowHeight > e.popHeight) posY = contentTop + (e.windowHeight - parentTop) - e.popHeight;
                        else posY = contentTop;
                    } else posY = e.windowY + (parentTop + e.tBarElementHeight);
                } else if (e.target.tagName !== "IMG") posY = e.parentData.bottom + window.pageYOffset - e.popHeight - 10;
                else posY = e.parentData.bottom + window.pageYOffset - e.popHeight - 5;
                y = posY;
                break;
            case "right":
                if (type === "inline" || type === "text") x = window.pageXOffset + (e.windowWidth - (e.popWidth + e.bodyRightSpace + 10));
                else x = e.x - e.popWidth;
                break;
            case "left":
                if (type === "inline" || type === "text") x = 0;
                else x = e.parentData.left;
                break;
        }
        this.popupObj.position.X = x ? x : this.popupObj.position.X;
        this.popupObj.position.Y = y ? y : this.popupObj.position.Y;
        this.popupObj.dataBind();
    };
    /**
     * showPopup method
     *
     * @param {number} x - specifies the x value
     * @param {number} y - specifies the y value
     * @param {Element} target - specifies the element
     * @param {string} type - specifies the type
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.showPopup = function(x, y, target, type) {
        var _this = this;
        var eventArgs = {
            popup: this.popupObj,
            cancel: false,
            targetElement: target,
            positionX: x,
            positionY: y
        };
        this.parent.trigger($947a002e9a697770$export$322c57d724d0f89c, eventArgs, function(beforeQuickToolbarArgs) {
            if (!beforeQuickToolbarArgs.cancel) {
                var editPanelTop = void 0;
                var editPanelHeight = void 0;
                var bodyStyle = window.getComputedStyle(document.body);
                var bodyRight = parseFloat(bodyStyle.marginRight.split("px")[0]) + parseFloat(bodyStyle.paddingRight.split("px")[0]);
                var windowHeight = window.innerHeight;
                var windowWidth = window.innerWidth;
                var parent_1 = _this.parent.element;
                var toolbarAvail = !(0, $3EnZW.isNullOrUndefined)(_this.parent.getToolbar());
                var tbHeight = toolbarAvail && _this.parent.toolbarModule.getToolbarHeight();
                var expTBHeight = toolbarAvail && _this.parent.toolbarModule.getExpandTBarPopHeight();
                var tBarHeight = toolbarAvail ? tbHeight + expTBHeight : 0;
                (0, $4ZDHT.addClass)([
                    _this.element
                ], [
                    $afc560df281b588d$export$e5db7105a59c014a
                ]);
                if ((0, $5q7BP.Browser).isDevice && !(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) (0, $4ZDHT.addClass)([
                    _this.parent.getToolbar()
                ], [
                    $afc560df281b588d$export$e5db7105a59c014a
                ]);
                if (_this.parent.iframeSettings.enable) {
                    var cntEle = _this.contentRenderer.getPanel().contentWindow;
                    editPanelTop = cntEle.pageYOffset;
                    editPanelHeight = cntEle.innerHeight;
                } else {
                    var cntEle = (0, $4ZDHT.closest)(target, "." + $afc560df281b588d$export$603c56dc2061d555);
                    editPanelTop = cntEle ? cntEle.scrollTop : 0;
                    editPanelHeight = cntEle ? cntEle.offsetHeight : 0;
                }
                if (!_this.parent.inlineMode.enable && !(0, $4ZDHT.closest)(target, "table") && type !== "text" && type !== "link" || target.tagName === "IMG") {
                    _this.parent.disableToolbarItem(_this.parent.toolbarSettings.items);
                    _this.parent.enableToolbarItem([
                        "Undo",
                        "Redo"
                    ]);
                } else _this.parent.enableToolbarItem(_this.parent.toolbarSettings.items);
                (0, $4ZDHT.append)([
                    _this.element
                ], document.body);
                if (_this.parent.showTooltip) {
                    _this.tooltip = new (0, $47b4397f26bd41a3$export$28c660c63b792dea)({
                        target: "#" + _this.element.id + " [title]",
                        openDelay: 400,
                        showTipPointer: true,
                        beforeRender: _this.tooltipBeforeRender.bind(_this),
                        windowCollision: true,
                        position: "BottomCenter",
                        cssClass: _this.parent.getCssClass()
                    });
                    _this.tooltip.appendTo(_this.element);
                }
                _this.popupObj.position.X = beforeQuickToolbarArgs.positionX + 20;
                _this.popupObj.position.Y = beforeQuickToolbarArgs.positionY + 20;
                _this.popupObj.dataBind();
                _this.popupObj.element.classList.add("e-popup-open");
                _this.dropDownButtons.renderDropDowns({
                    container: _this.toolbarElement,
                    containerType: "quick",
                    items: _this.stringItems
                });
                _this.colorPickerObj.renderColorPickerInput({
                    container: _this.toolbarElement,
                    containerType: "quick",
                    items: _this.stringItems
                });
                var showPopupData = {
                    x: x,
                    y: y,
                    target: target,
                    editTop: editPanelTop,
                    editHeight: editPanelHeight,
                    popup: _this.popupObj.element,
                    popHeight: _this.popupObj.element.offsetHeight,
                    popWidth: _this.popupObj.element.offsetWidth,
                    parentElement: parent_1,
                    bodyRightSpace: bodyRight,
                    windowY: window.pageYOffset,
                    windowHeight: windowHeight,
                    windowWidth: windowWidth,
                    parentData: parent_1.getBoundingClientRect(),
                    tBarElementHeight: tBarHeight
                };
                if (((0, $4ZDHT.closest)(target, "TABLE") || target.tagName === "IMG" || target.tagName === "AUDIO" || target.tagName === "VIDEO" || target.tagName === "IFRAME" || target.classList && (target.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) || target.classList.contains($afc560df281b588d$export$a13f0f97539de275) || target.classList.contains($afc560df281b588d$export$8dfb598a1fc054c7))) && (x === beforeQuickToolbarArgs.positionX || y === beforeQuickToolbarArgs.positionY)) _this.setPosition(showPopupData);
                if (!_this.parent.inlineMode.enable) _this.checkCollision(showPopupData, "parent", "");
                _this.checkCollision(showPopupData, "document", _this.parent.inlineMode.enable ? "inline" : type === "text" ? "text" : "");
                _this.popupObj.element.classList.remove("e-popup-open");
                (0, $4ZDHT.removeClass)([
                    _this.element
                ], [
                    $afc560df281b588d$export$e5db7105a59c014a
                ]);
                _this.popupObj.show({
                    name: "ZoomIn",
                    duration: (0, $5q7BP.Browser).isIE ? 250 : 400
                }, target);
                if (_this.popupObj && _this.parent.cssClass) {
                    (0, $4ZDHT.removeClass)([
                        _this.popupObj.element
                    ], _this.parent.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    (0, $4ZDHT.addClass)([
                        _this.popupObj.element
                    ], _this.parent.cssClass.replace(/\s+/g, " ").trim().split(" "));
                }
                (0, $4ZDHT.setStyleAttribute)(_this.element, {
                    maxWidth: window.outerWidth + "px"
                });
                (0, $4ZDHT.addClass)([
                    _this.element
                ], [
                    $afc560df281b588d$export$d5575e9771aeb97e
                ]);
                _this.isRendered = true;
            }
        });
    };
    BaseQuickToolbar.prototype.tooltipBeforeRender = function(args) {
        if (args.target.querySelector(".e-active")) {
            args.cancel = true;
            if (!(0, $3EnZW.isNullOrUndefined)(args.target.getAttribute("title"))) this.parent.notify($947a002e9a697770$export$6108d95d641a81fb, {
                target: args.target,
                isTitle: true
            });
        }
    };
    /**
     * hidePopup method
     *
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.hidePopup = function() {
        var isSourceCodeEnabled = !(0, $3EnZW.isNullOrUndefined)(this.parent.rootContainer) && this.parent.rootContainer.classList.contains("e-source-code-enabled");
        if ((0, $5q7BP.Browser).isDevice && !(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) (0, $4ZDHT.removeClass)([
            this.parent.getToolbar()
        ], [
            $afc560df281b588d$export$e5db7105a59c014a
        ]);
        if (!(0, $3EnZW.isNullOrUndefined)(this.element.querySelectorAll("[data-title]"))) {
            var removeHandEle = this.element.querySelectorAll("[data-title]");
            removeHandEle.forEach(function(e) {
                var event = new MouseEvent("mouseout", {
                    bubbles: true,
                    cancelable: true
                });
                e.dispatchEvent(event);
            });
        }
        if (!(0, $3EnZW.isNullOrUndefined)(document.querySelector(".e-tooltip-wrap"))) {
            if (!(0, $3EnZW.isNullOrUndefined)(document.querySelector("#" + this.element.id + " [data-tooltip-id]"))) {
                var tooltipTargetEle = document.querySelector("#" + this.element.id + " [data-tooltip-id]");
                var dataContent = tooltipTargetEle.getAttribute("data-content");
                tooltipTargetEle.removeAttribute("data-content");
                tooltipTargetEle.setAttribute("title", dataContent);
                tooltipTargetEle.removeAttribute("data-tooltip-id");
            }
            this.tooltip.destroy();
        } else if (!(0, $3EnZW.isNullOrUndefined)(this.tooltip)) this.tooltip.destroy();
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getToolbar()) && !this.parent.inlineMode.enable) {
            if (!isSourceCodeEnabled) this.parent.enableToolbarItem(this.parent.toolbarSettings.items);
        }
        this.removeEleFromDOM();
        this.isRendered = false;
    };
    /**
     * @param {string} item - specifies the string value
     * @param {number} index - specifies the index value
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.addQTBarItem = function(item, index) {
        this.quickTBarObj.toolbarObj.addItems(this.quickTBarObj.getItems(item, "toolbar"), index);
    };
    /**
     * @param {number} index - specifies the index value
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.removeQTBarItem = function(index) {
        this.quickTBarObj.toolbarObj.removeItems(index);
    };
    BaseQuickToolbar.prototype.removeEleFromDOM = function() {
        var element = this.popupObj.element;
        if (this.isRendered) {
            this.dropDownButtons.destroyDropDowns();
            this.colorPickerObj.destroyColorPicker();
            (0, $4ZDHT.removeClass)([
                this.element
            ], [
                $afc560df281b588d$export$d5575e9771aeb97e
            ]);
            (0, $4ZDHT.detach)(element);
            var args = this.popupObj;
            this.parent.trigger($947a002e9a697770$export$40fde4e3940a7c90, args);
        }
    };
    BaseQuickToolbar.prototype.updateStatus = function(args) {
        var options = {
            args: args,
            dropDownModule: this.dropDownButtons,
            parent: this.parent,
            tbElements: (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, this.element),
            tbItems: this.quickTBarObj.toolbarObj.items
        };
        (0, $c77ecbfae9b8c035$export$a169408aecd38f56)(options, true, this.parent);
        if (this.parent.quickToolbarSettings.text && this.parent.quickToolbarModule.textQTBar) {
            var options_1 = {
                args: args,
                dropDownModule: this.parent.quickToolbarModule.textQTBar.dropDownButtons,
                parent: this.parent,
                tbElements: (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, this.parent.quickToolbarModule.textQTBar.element),
                tbItems: this.parent.quickToolbarModule.textQTBar.quickTBarObj.toolbarObj.items
            };
            (0, $c77ecbfae9b8c035$export$a169408aecd38f56)(options_1, true, this.parent);
            (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(this.parent.quickToolbarModule.textQTBar.quickTBarObj, this.parent.formatter.editorManager.undoRedoManager.getUndoStatus());
        }
        if (!(0, $4ZDHT.select)("." + $afc560df281b588d$export$97efb1fe9920382d, this.parent.element)) (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(this.parent.getBaseToolbarObject(), this.parent.formatter.editorManager.undoRedoManager.getUndoStatus());
    };
    /**
     * Destroys the Quick toolbar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.tooltip && !this.tooltip.isDestroyed) {
            this.tooltip.destroy();
            this.tooltip = null;
        }
        this.removeEventListener();
        this.quickTBarObj.destroy();
        this.quickTBarObj = null;
        if (this.popupObj && !this.popupObj.isDestroyed) {
            this.removeEleFromDOM();
            this.popupObj.destroy();
        }
        this.colorPickerObj = null;
        this.dropDownButtons = null;
        this.stringItems = null;
        this.dropDownButtons = null;
        this.colorPickerObj = null;
        this.toolbarElement = null;
        this.isDestroyed = true;
    };
    /**
     * addEventListener method
     *
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        if (this.parent.inlineMode.enable || this.parent.quickToolbarSettings.text) this.parent.on($947a002e9a697770$export$209bc394f8eec6dc, this.updateStatus, this);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} e - specifies the model element
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.onPropertyChanged = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.inlineMode)) for(var _i = 0, _a = Object.keys(e.newProp.inlineMode); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "enable":
                    if (e.newProp.inlineMode.enable) this.parent.on($947a002e9a697770$export$209bc394f8eec6dc, this.updateStatus, this);
                    else this.parent.off($947a002e9a697770$export$209bc394f8eec6dc, this.updateStatus);
                    break;
            }
        }
    };
    /**
     * removeEventListener method
     *
     * @returns {void}
     * @hidden

     */ BaseQuickToolbar.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        if (this.parent.inlineMode.enable || this.parent.quickToolbarSettings.text) this.parent.off($947a002e9a697770$export$209bc394f8eec6dc, this.updateStatus);
    };
    return BaseQuickToolbar;
}();



var $2vAqh = parcelRequire("2vAqh");


/**
 * `Popup renderer` module is used to render popup in RichTextEditor.
 *
 * @hidden

 */ var $4df675046e98b9f0$export$85944ebdcf1cb320 = /** @class */ function() {
    /**
     * Constructor for popup renderer module
     *
     * @param {IRichTextEditor} parent - specifies the parent.
     */ function PopupRenderer(parent) {
        this.parent = parent;
    }
    PopupRenderer.prototype.quickToolbarOpen = function() {
        var args = this.popupObj;
        this.parent.trigger($947a002e9a697770$export$17b18cd22953de37, args);
    };
    /**
     * renderPopup method
     *
     * @param {BaseQuickToolbar} args - specifies  the arguments.
     * @returns {void}
     * @hidden

     */ PopupRenderer.prototype.renderPopup = function(args) {
        this.setPanel(args.element);
        this.renderPanel();
        args.popupObj = new (0, $2vAqh.Popup)(args.element, {
            targetType: "relative",
            relateTo: this.parent.element,
            open: this.quickToolbarOpen.bind(this)
        });
        this.popupObj = args.popupObj;
        args.popupObj.hide();
    };
    /**
     * The function is used to add popup class in Quick Toolbar
     *
     * @returns {void}
     * @hidden

     */ PopupRenderer.prototype.renderPanel = function() {
        this.getPanel().classList.add((0, $afc560df281b588d$export$530d3eb0a8cca61c));
    };
    /**
     * Get the popup element of RichTextEditor
     *
     * @returns {Element} - specifies the element
     * @hidden

     */ PopupRenderer.prototype.getPanel = function() {
        return this.popupPanel;
    };
    /**
     * Set the popup element of RichTextEditor
     *
     * @returns {void}
     * @param  {Element} panel - specifies the element
     * @hidden

     */ PopupRenderer.prototype.setPanel = function(panel) {
        this.popupPanel = panel;
    };
    return PopupRenderer;
}();



/**
 * `Quick toolbar` module is used to handle Quick toolbar actions.
 */ var $ef32d60b586a40bb$export$de97f9935dd6a484 = /** @class */ function() {
    function QuickToolbar(parent, locator) {
        this.debounceTimeout = 1000;
        this.parent = parent;
        this.locator = locator;
        this.renderFactory = this.locator.getService("rendererFactory");
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Popup, new (0, $4df675046e98b9f0$export$85944ebdcf1cb320)(this.parent));
        this.addEventListener();
        this.isDestroyed = false;
    }
    QuickToolbar.prototype.formatItems = function(items) {
        var formattedItems = [];
        items.forEach(function(item) {
            if (typeof item === "string") switch(item.toLocaleLowerCase()){
                case "open":
                    formattedItems.push("openLink");
                    break;
                case "edit":
                    formattedItems.push("editLink");
                    break;
                case "unlink":
                    formattedItems.push("removeLink");
                    break;
                default:
                    formattedItems.push(item);
                    break;
            }
            else formattedItems.push(item);
        });
        return formattedItems;
    };
    QuickToolbar.prototype.getQTBarOptions = function(popType, mode, items, type) {
        return {
            popupType: popType,
            toolbarItems: items,
            mode: mode,
            renderType: type,
            cssClass: this.parent.getCssClass()
        };
    };
    /**
     * createQTBar method
     *
     * @param {string} popupType - specifies the string value
     * @param {string} mode - specifies the string value.
     * @param {string} items - specifies the string.
     * @param {RenderType} type - specifies the render type.
     * @returns {BaseQuickToolbar} - specifies the quick toolbar
     * @hidden

     */ QuickToolbar.prototype.createQTBar = function(popupType, mode, items, type) {
        if (items.length < 1) return null;
        var qTBar = new (0, $5dadc1d67af1956c$export$84902c903b3ee5ae)(this.parent, this.locator);
        qTBar.render(this.getQTBarOptions(popupType, mode, this.formatItems(items), type));
        return qTBar;
    };
    QuickToolbar.prototype.initializeQuickToolbars = function() {
        this.parent.quickToolbarModule = this;
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        if (this.parent.inlineMode.enable && this.parent.inlineMode.onSelection && (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) (0, $aqzbR.EventHandler).add(this.contentRenderer.getDocument(), "selectionchange", this.selectionChangeHandler, this);
    };
    // eslint-disable-next-line
    QuickToolbar.prototype.onMouseDown = function(e) {
        this.parent.isBlur = false;
        this.parent.isRTE = true;
    };
    QuickToolbar.prototype.keyUpQT = function(e) {
        if (e.which === 27) this.hideQuickToolbars();
    };
    QuickToolbar.prototype.renderQuickToolbars = function() {
        if (this.linkQTBar || this.imageQTBar || this.audioQTBar || this.videoQTBar || this.textQTBar || this.tableQTBar) return;
        this.linkQTBar = this.createQTBar("Link", "Scrollable", this.parent.quickToolbarSettings.link, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).LinkToolbar);
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).LinkToolbar, this.linkQTBar);
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text) && !this.parent.inlineMode.enable) {
            this.textQTBar = this.createQTBar("Text", "MultiRow", this.parent.quickToolbarSettings.text, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).TextToolbar);
            this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).TextToolbar, this.textQTBar);
        }
        this.imageQTBar = this.createQTBar("Image", "MultiRow", this.parent.quickToolbarSettings.image, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).ImageToolbar);
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).ImageToolbar, this.imageQTBar);
        this.audioQTBar = this.createQTBar("Audio", "MultiRow", this.parent.quickToolbarSettings.audio, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).AudioToolbar);
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).AudioToolbar, this.audioQTBar);
        this.videoQTBar = this.createQTBar("Video", "MultiRow", this.parent.quickToolbarSettings.video, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).VideoToolbar);
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).VideoToolbar, this.videoQTBar);
        this.tableQTBar = this.createQTBar("Table", "MultiRow", this.parent.quickToolbarSettings.table, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).TableToolbar);
        this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).TableToolbar, this.tableQTBar);
        if (this.linkQTBar) {
            (0, $aqzbR.EventHandler).add(this.linkQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.linkQTBar.element, "keyup", this.keyUpQT, this);
        }
        if (this.imageQTBar) {
            (0, $aqzbR.EventHandler).add(this.imageQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.imageQTBar.element, "keyup", this.keyUpQT, this);
        }
        if (this.audioQTBar) {
            (0, $aqzbR.EventHandler).add(this.audioQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.audioQTBar.element, "keyup", this.keyUpQT, this);
        }
        if (this.videoQTBar) {
            (0, $aqzbR.EventHandler).add(this.videoQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.videoQTBar.element, "keyup", this.keyUpQT, this);
        }
        if (this.textQTBar) {
            (0, $aqzbR.EventHandler).add(this.textQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.textQTBar.element, "keyup", this.keyUpQT, this);
        }
        if (this.tableQTBar) {
            (0, $aqzbR.EventHandler).add(this.tableQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.tableQTBar.element, "keyup", this.keyUpQT, this);
        }
    };
    QuickToolbar.prototype.renderInlineQuickToolbar = function() {
        if (this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) {
            (0, $4ZDHT.addClass)([
                this.parent.element
            ], [
                (0, $afc560df281b588d$export$6693fa5cc8580ada)
            ]);
            this.inlineQTBar = this.createQTBar("Inline", "MultiRow", this.parent.toolbarSettings.items, (0, $2eaa618655f536c2$export$ed706b0a66efb05c).InlineToolbar);
            this.renderFactory.addRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).InlineToolbar, this.inlineQTBar);
            (0, $aqzbR.EventHandler).add(this.inlineQTBar.element, "mousedown", this.onMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.inlineQTBar.element, "keyup", this.keyUpQT, this);
        }
    };
    /**
     * Method for showing the inline quick toolbar
     *
     * @param {number} x -specifies the value of x.
     * @param {number} y - specifies the y valu.
     * @param {HTMLElement} target - specifies the target element.
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.showInlineQTBar = function(x, y, target) {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent) || this.parent.readonly || target.tagName.toLowerCase() === "img" || this.inlineQTBar.element.querySelector(".e-rte-color-content")) return;
        this.inlineQTBar.showPopup(x, y, target);
    };
    /**
     * Method for hidding the inline quick toolbar
     *
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.hideInlineQTBar = function() {
        if (this.inlineQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.inlineQTBar.element, "e-popup-close")) this.inlineQTBar.hidePopup();
    };
    /**
     * Method for hidding the quick toolbar
     *
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.hideQuickToolbars = function() {
        if (this.linkQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.linkQTBar.element, "e-popup-close") && document.body.contains(this.linkQTBar.element)) this.linkQTBar.hidePopup();
        if (this.textQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.textQTBar.element, "e-popup-close") && document.body.contains(this.textQTBar.element)) this.textQTBar.hidePopup();
        if (this.imageQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.imageQTBar.element, "e-popup-close") && document.body.contains(this.imageQTBar.element)) this.imageQTBar.hidePopup();
        if (this.audioQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.audioQTBar.element, "e-popup-close") && document.body.contains(this.audioQTBar.element)) this.audioQTBar.hidePopup();
        if (this.videoQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.videoQTBar.element, "e-popup-close") && document.body.contains(this.videoQTBar.element)) this.videoQTBar.hidePopup();
        if (this.tableQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.tableQTBar.element, "e-popup-close") && document.body.contains(this.tableQTBar.element)) this.tableQTBar.hidePopup();
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent) && this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) this.hideInlineQTBar();
    };
    QuickToolbar.prototype.deBounce = function(x, y, target) {
        var _this = this;
        clearTimeout(this.deBouncer);
        this.deBouncer = window.setTimeout(function() {
            _this.showInlineQTBar(x, y, target);
        }, this.debounceTimeout);
    };
    QuickToolbar.prototype.mouseUpHandler = function(e) {
        if (this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) {
            var args = e.args.touches ? e.args.changedTouches[0] : e.args;
            var range = this.parent.getRange();
            var target = e.args.target;
            if ((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("." + (0, $afc560df281b588d$export$757b82a79a74806a), document.body))) {
                if ((0, $c77ecbfae9b8c035$export$80ca177350c4af26)() && e.touchData && e.touchData.prevClientX !== e.touchData.clientX && e.touchData.prevClientY !== e.touchData.clientY) return;
                this.hideInlineQTBar();
                var parentLeft = this.parent.element.getBoundingClientRect().left;
                this.offsetX = this.parent.iframeSettings.enable ? window.pageXOffset + parentLeft + args.clientX : args.pageX;
                this.offsetY = (0, $c77ecbfae9b8c035$export$fd39c00f94741b03)(args, this.parent.element, this.parent.iframeSettings.enable);
                if (target.nodeName === "TEXTAREA") this.showInlineQTBar(this.offsetX, this.offsetY, target);
                else {
                    var closestAnchor = (0, $4ZDHT.closest)(target, "a");
                    target = closestAnchor ? closestAnchor : target;
                    var startNode = this.parent.getRange().startContainer.parentElement;
                    var endNode = this.parent.getRange().endContainer.parentElement;
                    if (((0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(startNode, "A")) || (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(endNode, "A"))) && (!(0, $4ZDHT.closest)(target, "td,th") || !range.collapsed) && (target.tagName !== "IMG" || this.parent.getRange().startOffset !== this.parent.getRange().endOffset)) {
                        if (this.parent.inlineMode.onSelection && range.collapsed) return;
                        this.target = target;
                        this.showInlineQTBar(this.offsetX, this.offsetY, target);
                    }
                }
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.textQTBar) && !(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text) && !this.parent.inlineMode.enable) {
            if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.name) && e.name === "sourceCodeMouseDown") return;
            var args = e.args.touches ? e.args.changedTouches[0] : e.args;
            var target = e.args.target;
            this.hideQuickToolbars();
            var parentLeft = this.parent.element.getBoundingClientRect().left;
            this.offsetX = this.parent.iframeSettings.enable ? this.parent.element.ownerDocument.documentElement.scrollLeft + parentLeft + args.clientX : args.pageX;
            this.offsetY = (0, $c77ecbfae9b8c035$export$fd39c00f94741b03)(args, this.parent.element, this.parent.iframeSettings.enable);
            var range = this.parent.getRange();
            if (range.endContainer.parentElement.tagName === range.startContainer.parentElement.tagName && range.startContainer.parentElement.tagName === "A" && range.endContainer.parentElement.tagName === "A" || target.tagName === "IMG" || target.tagName === "VIDEO" || this.isEmbedVidElem(target) || target.tagName === "AUDIO" || target.childNodes[0] && target.childNodes[0].nodeType === 1 && target.childNodes[0].classList.contains("e-rte-audio") || this.parent.getRange().startOffset === this.parent.getRange().endOffset) return;
            this.target = target;
            this.textQTBar.showPopup(this.offsetX, this.offsetY, target, "text");
        }
    };
    QuickToolbar.prototype.isEmbedVidElem = function(target) {
        if (target && target.nodeType !== 3 && target.nodeName !== "BR" && target.classList && target.classList.contains((0, $afc560df281b588d$export$8dfb598a1fc054c7)) || target && target.nodeName === "IFRAME") return true;
        else return false;
    };
    QuickToolbar.prototype.keyDownHandler = function(e) {
        var preventHide = e.args.altKey;
        if (this.parent.inlineMode.enable && e.args.metaKey && e.args.keyCode === 65) {
            this.showInlineQTBar(this.offsetX, this.offsetY, e.args.target);
            return;
        }
        if (!preventHide) {
            if (this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("." + (0, $afc560df281b588d$export$757b82a79a74806a), document))) this.hideInlineQTBar();
            if (this.textQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.textQTBar.element, "e-popup-close")) this.textQTBar.hidePopup();
        }
    };
    QuickToolbar.prototype.inlineQTBarMouseDownHandler = function() {
        if (this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("." + (0, $afc560df281b588d$export$757b82a79a74806a), document))) this.hideInlineQTBar();
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarSettings.text)) {
            if (this.textQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.textQTBar.element, "e-popup-close") && document.body.contains(this.textQTBar.element)) this.textQTBar.hidePopup();
        }
    };
    QuickToolbar.prototype.keyUpHandler = function(e) {
        var args = e.args;
        if (this.parent.inlineMode.enable && !(0, $5q7BP.Browser).isDevice) {
            if (this.parent.inlineMode.onSelection) {
                if (this.parent.getSelection().length > 0) {
                    if (args.ctrlKey && args.keyCode === 65 || args.shiftKey && (args.keyCode === 33 || args.keyCode === 34 || args.keyCode === 35 || args.keyCode === 36 || args.keyCode === 37 || args.keyCode === 38 || args.keyCode === 39 || args.keyCode === 40)) this.showInlineQTBar(this.offsetX, this.offsetY, args.target);
                }
                return;
            }
            this.deBounce(this.offsetX, this.offsetY, args.target);
        }
        if (this.parent.quickToolbarSettings.text && !(0, $5q7BP.Browser).isDevice) {
            if (args.ctrlKey && args.keyCode === 65 || args.shiftKey && (args.keyCode === 33 || args.keyCode === 34 || args.keyCode === 35 || args.keyCode === 36 || args.keyCode === 37 || args.keyCode === 38 || args.keyCode === 39 || args.keyCode === 40)) this.textQTBar.showPopup(this.offsetX, this.offsetY, args.target, "text");
        }
    };
    QuickToolbar.prototype.selectionChangeHandler = function(e) {
        var _this = this;
        clearTimeout(this.deBouncer);
        this.deBouncer = window.setTimeout(function() {
            _this.onSelectionChange(e);
        }, this.debounceTimeout);
    };
    QuickToolbar.prototype.onSelectionChange = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.select)("." + (0, $afc560df281b588d$export$757b82a79a74806a), document.body))) return;
        var selection = this.contentRenderer.getDocument().getSelection();
        if (!selection.isCollapsed) this.mouseUpHandler({
            args: e
        });
    };
    /**
     * getInlineBaseToolbar method
     *
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.getInlineBaseToolbar = function() {
        return this.inlineQTBar && this.inlineQTBar.quickTBarObj;
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.linkQTBar && !this.linkQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.linkQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.linkQTBar.element, "keyup", this.keyUpQT);
            this.linkQTBar.destroy();
        }
        if (this.textQTBar && !this.textQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.textQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.textQTBar.element, "keyup", this.keyUpQT);
            this.textQTBar.destroy();
        }
        if (this.imageQTBar && !this.imageQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.imageQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.imageQTBar.element, "keyup", this.keyUpQT);
            this.imageQTBar.destroy();
        }
        if (this.audioQTBar && !this.audioQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.audioQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.audioQTBar.element, "keyup", this.keyUpQT);
            this.audioQTBar.destroy();
        }
        if (this.videoQTBar && !this.videoQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.videoQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.videoQTBar.element, "keyup", this.keyUpQT);
            this.videoQTBar.destroy();
        }
        if (this.tableQTBar && !this.tableQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.tableQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.tableQTBar.element, "keyup", this.keyUpQT);
            this.tableQTBar.destroy();
        }
        if (this.inlineQTBar && !this.inlineQTBar.isDestroyed) {
            (0, $aqzbR.EventHandler).remove(this.inlineQTBar.element, "mousedown", this.onMouseDown);
            (0, $aqzbR.EventHandler).remove(this.inlineQTBar.element, "keyup", this.keyUpQT);
            if ((0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) (0, $aqzbR.EventHandler).remove(document, "selectionchange", this.selectionChangeHandler);
            this.inlineQTBar.destroy();
        }
        this.removeEventListener();
        this.isDestroyed = true;
    };
    QuickToolbar.prototype.wireInlineQTBarEvents = function() {
        this.parent.on($947a002e9a697770$export$9ac49ece09f002f8, this.mouseUpHandler, this);
        this.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, this.inlineQTBarMouseDownHandler, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.keyDownHandler, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUpHandler, this);
        this.parent.on($947a002e9a697770$export$20d87a998eb21859, this.mouseUpHandler, this);
        this.parent.on($947a002e9a697770$export$242492f0a40e77d2, this.renderInlineQuickToolbar, this);
    };
    QuickToolbar.prototype.unWireInlineQTBarEvents = function() {
        this.parent.off($947a002e9a697770$export$9ac49ece09f002f8, this.mouseUpHandler);
        this.parent.off($947a002e9a697770$export$ea32a7693b83cfdb, this.inlineQTBarMouseDownHandler);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.keyDownHandler);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUpHandler);
        this.parent.off($947a002e9a697770$export$20d87a998eb21859, this.mouseUpHandler);
        this.parent.off($947a002e9a697770$export$242492f0a40e77d2, this.renderInlineQuickToolbar);
    };
    // eslint-disable-next-line
    QuickToolbar.prototype.toolbarUpdated = function(args) {
        if (this.linkQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.linkQTBar.element, "e-popup-close")) this.linkQTBar.hidePopup();
        if (this.imageQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.imageQTBar.element, "e-popup-close")) this.imageQTBar.hidePopup();
        if (this.audioQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.audioQTBar.element, "e-popup-close")) this.audioQTBar.hidePopup();
        if (this.videoQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.videoQTBar.element, "e-popup-close")) this.videoQTBar.hidePopup();
        if (this.tableQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.tableQTBar.element, "e-popup-close")) this.tableQTBar.hidePopup();
    };
    /**
     * addEventListener
     *
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.initializeQuickToolbars, this);
        this.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, this.renderQuickToolbars, this);
        this.parent.on($947a002e9a697770$export$209bc394f8eec6dc, this.toolbarUpdated, this);
        this.parent.on($947a002e9a697770$export$663103110d94aac9, this.renderQuickToolbars, this);
        this.wireInlineQTBarEvents();
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        if (this.parent.quickToolbarSettings.actionOnScroll === "hide") {
            this.parent.on($947a002e9a697770$export$209876d7b1ac8f3, this.hideQuickToolbars, this);
            this.parent.on($947a002e9a697770$export$55df3e903573f90b, this.hideQuickToolbars, this);
        }
        this.parent.on($947a002e9a697770$export$ceb2354ae09b6ff, this.hideQuickToolbars, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$bba5038aab73375b, this.hideQuickToolbars, this);
    };
    QuickToolbar.prototype.onKeyDown = function(e) {
        var args = e.args;
        if (args.which === 8 || args.which === 46) {
            if (this.imageQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.imageQTBar.element, "e-popup-close")) this.imageQTBar.hidePopup();
            if (this.audioQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.audioQTBar.element, "e-popup-close")) this.audioQTBar.hidePopup();
            if (this.videoQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.videoQTBar.element, "e-popup-close")) this.videoQTBar.hidePopup();
            if (this.tableQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.tableQTBar.element, "e-popup-close")) this.tableQTBar.hidePopup();
            if (this.linkQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.linkQTBar.element, "e-popup-close")) this.linkQTBar.hidePopup();
            if (this.textQTBar && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(this.textQTBar.element, "e-popup-close")) this.textQTBar.hidePopup();
        }
    };
    QuickToolbar.prototype.onIframeMouseDown = function() {
        this.hideQuickToolbars();
        this.hideInlineQTBar();
    };
    QuickToolbar.prototype.updateCss = function(baseQTObj, e) {
        if (baseQTObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass && baseQTObj.quickTBarObj.toolbarObj.cssClass !== e.cssClass)) baseQTObj.quickTBarObj.toolbarObj.setProperties({
                cssClass: (baseQTObj.quickTBarObj.toolbarObj.cssClass + " " + e.cssClass).trim()
            });
            else baseQTObj.quickTBarObj.toolbarObj.setProperties({
                cssClass: (baseQTObj.quickTBarObj.toolbarObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    QuickToolbar.prototype.setCssClass = function(e) {
        var baseQuickToolbarObj = [
            this.inlineQTBar,
            this.imageQTBar,
            this.linkQTBar,
            this.textQTBar,
            this.tableQTBar
        ];
        for(var i = 0; i < baseQuickToolbarObj.length; i++)this.updateCss(baseQuickToolbarObj[i], e);
    };
    QuickToolbar.prototype.setRtl = function(args) {
        if (this.inlineQTBar) this.inlineQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.imageQTBar) this.imageQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.audioQTBar) this.audioQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.videoQTBar) this.videoQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.linkQTBar) this.linkQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
        if (this.textQTBar) this.textQTBar.quickTBarObj.toolbarObj.setProperties({
            enableRtl: args.enableRtl
        });
    };
    /**
     * removeEventListener
     *
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.removeEventListener = function() {
        if (this.deBouncer) {
            clearTimeout(this.deBouncer);
            this.deBouncer = null;
        }
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.initializeQuickToolbars);
        this.parent.off($947a002e9a697770$export$ea32a7693b83cfdb, this.renderQuickToolbars);
        this.parent.off($947a002e9a697770$export$209bc394f8eec6dc, this.toolbarUpdated);
        this.parent.off($947a002e9a697770$export$663103110d94aac9, this.renderQuickToolbars);
        this.unWireInlineQTBarEvents();
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        if (this.parent.quickToolbarSettings.actionOnScroll === "hide") {
            this.parent.off($947a002e9a697770$export$209876d7b1ac8f3, this.hideQuickToolbars);
            this.parent.off($947a002e9a697770$export$55df3e903573f90b, this.hideQuickToolbars);
        }
        this.parent.off($947a002e9a697770$export$ceb2354ae09b6ff, this.hideQuickToolbars);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$9dcaf34b3cdca414, this.setRtl);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$bba5038aab73375b, this.hideQuickToolbars);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} e - specifies the element.
     * @returns {void}
     * @hidden

     */ QuickToolbar.prototype.onPropertyChanged = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.quickToolbarSettings)) for(var _i = 0, _a = Object.keys(e.newProp.quickToolbarSettings); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "actionOnScroll":
                    if (e.newProp.quickToolbarSettings.actionOnScroll === "none") {
                        this.parent.off($947a002e9a697770$export$209876d7b1ac8f3, this.hideQuickToolbars);
                        this.parent.off($947a002e9a697770$export$55df3e903573f90b, this.hideQuickToolbars);
                    } else {
                        this.parent.on($947a002e9a697770$export$209876d7b1ac8f3, this.hideQuickToolbars, this);
                        this.parent.on($947a002e9a697770$export$55df3e903573f90b, this.hideQuickToolbars, this);
                    }
                    break;
            }
        }
        if (e.module !== this.getModuleName()) return;
        if (this.inlineQTBar) {
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], [
                (0, $afc560df281b588d$export$6693fa5cc8580ada)
            ]);
            this.unWireInlineQTBarEvents();
            this.hideInlineQTBar();
        }
        if (this.parent.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) {
            (0, $4ZDHT.addClass)([
                this.parent.element
            ], [
                (0, $afc560df281b588d$export$6693fa5cc8580ada)
            ]);
            this.wireInlineQTBarEvents();
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ QuickToolbar.prototype.getModuleName = function() {
        return "quickToolbar";
    };
    /**
     *
     * @returns {BaseQuickToolbar[]} - specifies the quick toolbar instance.
     * @hidden
     * @private
     */ QuickToolbar.prototype.getQuickToolbarInstance = function() {
        return [
            this.linkQTBar,
            this.imageQTBar,
            this.audioQTBar,
            this.videoQTBar,
            this.tableQTBar,
            this.textQTBar,
            this.inlineQTBar
        ];
    };
    return QuickToolbar;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $hQxLN = parcelRequire("hQxLN");
var $3EnZW = parcelRequire("3EnZW");
var $aqzbR = parcelRequire("aqzbR");
var $e7i2H = parcelRequire("e7i2H");
var $i528u = parcelRequire("i528u");

var $2vAqh = parcelRequire("2vAqh");




parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden

 */ var $1c277ea27e0edf4d$export$160ae30d75f98247 = /** @class */ function() {
    /**
     * Constructor for render module
     *
     * @param {IRichTextEditor} parent - specifies the parent
     * @param {ServiceLocator} locator - specifies the locator.
     * @returns {void}
     */ function Render(parent, locator) {
        this.parent = parent;
        this.locator = locator;
        this.renderer = this.locator.getService("rendererFactory");
        this.addEventListener();
    }
    /**
     * To initialize Rich Text Editor header, content and footer rendering
     *
     * @returns {void}
     * @hidden

     */ Render.prototype.render = function() {
        // eslint-disable-next-line
        var rteObj = this.parent;
        this.contentRenderer = this.renderer.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        this.contentRenderer.renderPanel();
    };
    /**
     * Refresh the entire RichTextEditor.
     *
     * @param {NotifyArgs} e - specifies the arguments.
     * @returns {void}
     */ Render.prototype.refresh = function(e) {
        if (e === void 0) e = {
            requestType: "refresh"
        };
        this.parent.notify(e.requestType + "-begin", e);
    };
    /**
     * Destroy the entire RichTextEditor.
     *
     * @returns {void}
     */ Render.prototype.destroy = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent)) return;
        this.removeEventListener();
        this.locator.destroy();
        this.renderer.destroy();
    };
    Render.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.refresh, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUp, this);
    };
    Render.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.refresh);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUp);
    };
    Render.prototype.keyUp = function(e) {
        if (this.parent.editorMode === "HTML") switch(e.args.which){
            case 46:
            case 8:
                // eslint-disable-next-line
                var childNodes = this.parent.contentModule.getEditPanel().childNodes;
                if (childNodes.length === 0 || childNodes.length === 1 && childNodes[0].childNodes.length === 0 && (childNodes[0].tagName === "BR" || (childNodes[0].tagName === "P" || childNodes[0].tagName === "DIV") && childNodes[0].textContent === "")) {
                    var node = this.parent.contentModule.getEditPanel();
                    if (this.parent.enterKey === "DIV") node.innerHTML = "<div><br/></div>";
                    else if (this.parent.enterKey === "BR") node.innerHTML = "<br/>";
                    else node.innerHTML = "<p><br/></p>";
                    this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), node.childNodes[0], 0);
                }
                break;
        }
    };
    return Render;
}();


parcelRequire("j7YE8");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $4ZDHT = parcelRequire("4ZDHT");




parcelRequire("j7YE8");
var $jmffE = parcelRequire("jmffE");
var $5rsSz = parcelRequire("5rsSz");
var $58ad7cf7be602204$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $58ad7cf7be602204$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $58ad7cf7be602204$var$keyCode = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "control": 17,
    "alt": 18,
    "pause": 19,
    "capslock": 20,
    "space": 32,
    "escape": 27,
    "pageup": 33,
    "pagedown": 34,
    "end": 35,
    "home": 36,
    "leftarrow": 37,
    "uparrow": 38,
    "rightarrow": 39,
    "downarrow": 40,
    "insert": 45,
    "delete": 46,
    "f1": 112,
    "f2": 113,
    "f3": 114,
    "f4": 115,
    "f5": 116,
    "f6": 117,
    "f7": 118,
    "f8": 119,
    "f9": 120,
    "f10": 121,
    "f11": 122,
    "f12": 123,
    "semicolon": 186,
    "plus": 187,
    "comma": 188,
    "minus": 189,
    "dot": 190,
    "forwardslash": 191,
    "graveaccent": 192,
    "openbracket": 219,
    "backslash": 220,
    "closebracket": 221,
    "singlequote": 222,
    "]": 221,
    "[": 219,
    "=": 187,
    "<": 188,
    ">": 190,
    "`": 192
};
/**
 * KeyboardEvents class enables you to bind key action desired key combinations for ex., Ctrl+A, Delete, Alt+Space etc.
 * ```html
 * <div id='testEle'>  </div>;
 * <script>
 *   let node: HTMLElement = document.querySelector('#testEle');
 *   let kbInstance = new KeyboardEvents({
 *       element: node,
 *       keyConfigs:{ selectAll : 'ctrl+a' },
 *       keyAction: function (e:KeyboardEvent, action:string) {
 *           // handler function code
 *       }
 *   });
 * </script>
 * ```
 *
 * @hidden

 */ var $58ad7cf7be602204$export$9bcbcfc970068010 = /** @class */ function(_super) {
    $58ad7cf7be602204$var$__extends(KeyboardEvents, _super);
    /**
     * Initializes the KeyboardEvents
     *
     * @param {HTMLElement} element - specifies the elements.
     * @param {KeyboardEventsModel} options - specify the options
     */ function KeyboardEvents(element, options) {
        var _this = _super.call(this, options, element) || this;
        /**
         * To handle a key press event returns null
         *
         * @param {KeyboardEventArgs} e - specifies the event arguments.
         * @returns {void}
         */ _this.keyPressHandler = function(e) {
            /* eslint-disable */ var isAltKey = e.altKey;
            var isCtrlKey = e.ctrlKey;
            var isShiftKey = e.shiftKey;
            var isMetaKey = e.metaKey;
            /* eslint-enable */ var curkeyCode = e.which;
            var keys = Object.keys(_this.keyConfigs);
            for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
                var key = keys_1[_i];
                var configCollection = _this.keyConfigs["" + key].split(",");
                for(var _a = 0, configCollection_1 = configCollection; _a < configCollection_1.length; _a++){
                    var rconfig = configCollection_1[_a];
                    var rKeyObj = KeyboardEvents_1.getKeyConfigData(rconfig.trim());
                    if (isAltKey === rKeyObj.altKey && (isCtrlKey === rKeyObj.ctrlKey || isMetaKey) && isShiftKey === rKeyObj.shiftKey && curkeyCode === rKeyObj.keyCode) e.action = key;
                }
            }
            if (_this.keyAction) _this.keyAction(e);
        };
        _this.bind();
        return _this;
    }
    KeyboardEvents_1 = KeyboardEvents;
    /**
     * Unwire bound events and destroy the instance.
     *
     * @returns {void}
     */ KeyboardEvents.prototype.destroy = function() {
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    /**
     * Function can be used to specify certain action if a property is changed
     *
     * @param {KeyboardEventsModel} newProp - specifies the keyboard event.
     * @param {KeyboardEventsModel} oldProp - specifies the old property.
     * @returns {void}
     * @private
     */ // eslint-disable-next-line
    KeyboardEvents.prototype.onPropertyChanged = function(newProp, oldProp) {
    // No code are needed
    };
    KeyboardEvents.prototype.bind = function() {
        this.wireEvents();
    };
    /**
     * To get the module name, returns 'keyboard'.
     *
     * @returns {void}
     */ KeyboardEvents.prototype.getModuleName = function() {
        return "keyboard";
    };
    /**
     * Wiring event handlers to events
     *
     * @returns {void}
     */ KeyboardEvents.prototype.wireEvents = function() {
        this.element.addEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * Unwiring event handlers to events
     *
     * @returns {void}
     */ KeyboardEvents.prototype.unwireEvents = function() {
        this.element.removeEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * To get the key configuration data
     *
     * @param {string} config - configuration data
     * @returns {KeyData} - specifies the key data
     */ KeyboardEvents.getKeyConfigData = function(config) {
        if (config in this.configCache) return this.configCache["" + config];
        var keys = config.toLowerCase().split("+");
        var keyData = {
            altKey: keys.indexOf("alt") !== -1 ? true : false,
            ctrlKey: keys.indexOf("ctrl") !== -1 ? true : false,
            shiftKey: keys.indexOf("shift") !== -1 ? true : false,
            keyCode: null
        };
        if (keys[keys.length - 1].length > 1 && !!Number(keys[keys.length - 1])) keyData.keyCode = Number(keys[keys.length - 1]);
        else keyData.keyCode = KeyboardEvents_1.getKeyCode(keys[keys.length - 1]);
        KeyboardEvents_1.configCache["" + config] = keyData;
        return keyData;
    };
    // Return the keycode value as string
    KeyboardEvents.getKeyCode = function(keyVal) {
        return $58ad7cf7be602204$var$keyCode["" + keyVal] || keyVal.toUpperCase().charCodeAt(0);
    };
    var KeyboardEvents_1;
    KeyboardEvents.configCache = {};
    $58ad7cf7be602204$var$__decorate([
        (0, $5rsSz.Property)({})
    ], KeyboardEvents.prototype, "keyConfigs", void 0);
    $58ad7cf7be602204$var$__decorate([
        (0, $5rsSz.Property)("keyup")
    ], KeyboardEvents.prototype, "eventName", void 0);
    $58ad7cf7be602204$var$__decorate([
        (0, $5rsSz.Event)()
    ], KeyboardEvents.prototype, "keyAction", void 0);
    KeyboardEvents = KeyboardEvents_1 = $58ad7cf7be602204$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], KeyboardEvents);
    return KeyboardEvents;
}((0, $jmffE.Base));


/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden

 */ var $d18d9556bd921af3$export$530d090221814d61 = /** @class */ function() {
    /**
     * Constructor for view source module
     *
     * @param {IRichTextEditor} parent - specifies the parent element.
     * @param {ServiceLocator} locator - specifies the locator.
     * @returns {void}
     */ function ViewSource(parent, locator) {
        this.parent = parent;
        var serviceLocator = locator;
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.addEventListener();
    }
    ViewSource.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$a03f62af6e933a3, this.sourceCode, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.onInitialEnd, this);
        this.parent.on($947a002e9a697770$export$328b0edc9fda3a36, this.updateSourceCode, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    ViewSource.prototype.onInitialEnd = function() {
        this.parent.formatter.editorManager.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown, this);
    };
    ViewSource.prototype.removeEventListener = function() {
        this.unWireEvent();
        this.parent.off($947a002e9a697770$export$a03f62af6e933a3, this.sourceCode);
        this.parent.off($947a002e9a697770$export$328b0edc9fda3a36, this.updateSourceCode);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.onInitialEnd);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.formatter.editorManager.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.onKeyDown);
    };
    ViewSource.prototype.getSourceCode = function() {
        return this.parent.createElement("textarea", {
            className: (0, $afc560df281b588d$export$97efb1fe9920382d) + this.parent.getCssClass(true)
        });
    };
    ViewSource.prototype.wireEvent = function(element) {
        this.keyboardModule = new (0, $58ad7cf7be602204$export$9bcbcfc970068010)(element, {
            keyAction: this.previewKeyDown.bind(this),
            keyConfigs: this.parent.formatter.keyConfig,
            eventName: "keydown"
        });
        (0, $aqzbR.EventHandler).add(this.previewElement, "mousedown", this.mouseDownHandler, this);
    };
    ViewSource.prototype.unWireEvent = function() {
        if (this.previewElement) (0, $aqzbR.EventHandler).remove(this.previewElement, "mousedown", this.mouseDownHandler);
        if (this.keyboardModule && !this.keyboardModule.isDestroyed) this.keyboardModule.destroy();
    };
    ViewSource.prototype.wireBaseKeyDown = function() {
        this.parent.keyboardModule = new (0, $58ad7cf7be602204$export$9bcbcfc970068010)(this.contentModule.getEditPanel(), {
            keyAction: this.parent.keyDown.bind(this.parent),
            keyConfigs: this.parent.formatter.keyConfig,
            eventName: "keydown"
        });
    };
    ViewSource.prototype.unWireBaseKeyDown = function() {
        this.parent.keyboardModule.destroy();
    };
    ViewSource.prototype.mouseDownHandler = function(e) {
        this.parent.notify($947a002e9a697770$export$20d87a998eb21859, {
            args: e
        });
    };
    ViewSource.prototype.previewKeyDown = function(event) {
        switch(event.action){
            case "html-source":
                this.updateSourceCode(event);
                event.preventDefault();
                break;
            case "toolbar-focus":
                if (this.parent.toolbarSettings.enable && this.parent.getToolbarElement()) {
                    var firstActiveItem = this.parent.getToolbarElement().querySelector(".e-toolbar-item:not(.e-overlay)[title]");
                    firstActiveItem.firstElementChild.removeAttribute("tabindex");
                    firstActiveItem.firstElementChild.focus();
                }
                break;
        }
    };
    ViewSource.prototype.onKeyDown = function(e) {
        switch(e.event.action){
            case "html-source":
                e.event.preventDefault();
                this.sourceCode(e);
                e.callBack({
                    requestType: "SourceCode",
                    editorMode: "HTML",
                    event: e.event
                });
                break;
        }
    };
    /**
     * sourceCode method
     *
     * @param {ClickEventArgs} args - specifies the click event.
     * @returns {void}
     * @hidden

     */ ViewSource.prototype.sourceCode = function(args) {
        var _this = this;
        this.parent.notify($947a002e9a697770$export$bba5038aab73375b, {});
        this.parent.isBlur = false;
        this.parent.trigger($947a002e9a697770$export$df204737a6131aab, {
            requestType: "SourceCode",
            targetItem: "SourceCode",
            args: args,
            cancel: false
        }, function(actionBeginArgs) {
            if (!actionBeginArgs.cancel) {
                var tbItems = (0, $4ZDHT.selectAll)("." + (0, $afc560df281b588d$export$43195ed9dfb35649), _this.parent.element);
                _this.contentModule = _this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
                var height = _this.parent.inputElement.getBoundingClientRect().height;
                _this.parent.rootContainer.classList.add("e-source-code-enabled");
                _this.parent.notify($947a002e9a697770$export$d928e346d13acf9b, {
                    targetItem: "SourceCode",
                    updateItem: "Preview",
                    baseToolbar: _this.parent.getBaseToolbarObject()
                });
                if ((0, $3EnZW.isNullOrUndefined)(_this.previewElement)) _this.previewElement = _this.getSourceCode();
                _this.parent.updateValueData();
                var rteContent = void 0;
                if ((0, $3EnZW.isNullOrUndefined)(_this.parent.element.querySelector("#" + _this.parent.getID() + "_source-view"))) rteContent = _this.parent.createElement("div", {
                    className: "e-source-content",
                    id: _this.parent.getID() + "_source-view",
                    attrs: {
                        style: "height:" + height + "px"
                    }
                });
                else {
                    rteContent = _this.parent.element.querySelector("#" + _this.parent.getID() + "_source-view");
                    rteContent.style.height = height + "px";
                }
                rteContent.appendChild(_this.previewElement);
                _this.parent.rootContainer.appendChild(rteContent);
                _this.getPanel().value = _this.getTextAreaValue();
                _this.parent.isBlur = false;
                _this.parent.disableToolbarItem(_this.parent.toolbarSettings.items);
                _this.parent.enableToolbarItem("SourceCode");
                if (_this.parent.getToolbar()) (0, $4ZDHT.removeClass)([
                    _this.parent.getToolbar()
                ], [
                    (0, $afc560df281b588d$export$c024b26acaa71d78)
                ]);
                (0, $4ZDHT.removeClass)(tbItems, [
                    (0, $afc560df281b588d$export$79952d4ba2101dd4)
                ]);
                _this.wireEvent(_this.previewElement);
                _this.unWireBaseKeyDown();
                _this.previewElement.focus();
                _this.parent.updateValue();
                _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
                    requestType: "SourceCode",
                    targetItem: "SourceCode",
                    args: args
                });
                _this.parent.invokeChangeEvent();
                if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.saveInterval) && _this.parent.saveInterval > 0 && _this.parent.autoSaveOnIdle) _this.codeViewTimeInterval = setInterval(function() {
                    _this.parent.notify($947a002e9a697770$export$7a1b1fa1df219330, {});
                }, _this.parent.saveInterval);
            }
        });
    };
    /**
     * updateSourceCode method
     *
     * @param {ClickEventArgs} args - specifies the click event.
     * @returns {void}
     * @hidden

     */ ViewSource.prototype.updateSourceCode = function(args) {
        var _this = this;
        this.parent.isBlur = false;
        this.parent.trigger($947a002e9a697770$export$df204737a6131aab, {
            requestType: "Preview",
            targetItem: "Preview",
            args: args,
            cancel: false
        }, function(actionBeginArgs) {
            if (!actionBeginArgs.cancel) {
                _this.parent.rootContainer.classList.remove("e-source-code-enabled");
                var editHTML = _this.getPanel();
                _this.parent.notify($947a002e9a697770$export$d928e346d13acf9b, {
                    targetItem: "Preview",
                    updateItem: "SourceCode",
                    baseToolbar: _this.parent.getBaseToolbarObject()
                });
                var serializeValue = _this.parent.serializeValue(editHTML.value);
                var value = void 0;
                if (serializeValue === null || serializeValue === "") {
                    if (_this.parent.enterKey === "DIV") value = "<div><br/></div>";
                    else if (_this.parent.enterKey === "BR") value = "<br/>";
                    else value = "<p><br/></p>";
                } else value = serializeValue;
                _this.contentModule.getEditPanel().innerHTML = value;
                _this.parent.isBlur = false;
                _this.parent.enableToolbarItem(_this.parent.toolbarSettings.items);
                if (_this.parent.getToolbar()) (0, $4ZDHT.removeClass)([
                    _this.parent.getToolbar()
                ], [
                    (0, $afc560df281b588d$export$c024b26acaa71d78)
                ]);
                _this.unWireEvent();
                _this.wireBaseKeyDown();
                _this.contentModule.getEditPanel().focus();
                _this.parent.updateValue();
                _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
                    requestType: "Preview",
                    targetItem: "Preview",
                    args: args
                });
                _this.parent.formatter.enableUndo(_this.parent);
                _this.parent.addAudioVideoWrapper();
                clearTimeout(_this.codeViewTimeInterval);
                _this.parent.invokeChangeEvent();
                _this.parent.notify($947a002e9a697770$export$5dbeb4561f6544b7, {});
            }
        });
    };
    ViewSource.prototype.getTextAreaValue = function() {
        return this.contentModule.getEditPanel().innerHTML === "<p><br></p>" || this.contentModule.getEditPanel().innerHTML === "<div><br></div>" || this.contentModule.getEditPanel().innerHTML === "<br>" || this.contentModule.getEditPanel().childNodes.length === 1 && this.contentModule.getEditPanel().childNodes[0].tagName === "P" && this.contentModule.getEditPanel().innerHTML.length === 7 || this.contentModule.getEditPanel().childNodes[0].tagName === "DIV" && this.contentModule.getEditPanel().innerHTML.length === 11 ? "" : this.parent.value;
    };
    /**
     * getPanel method
     *
     * @returns {HTMLTextAreaElement} - Specifies the Souce codetext area element.
     * @hidden

     */ ViewSource.prototype.getPanel = function() {
        return this.parent.element && this.parent.element.querySelector(".e-rte-srctextarea");
    };
    /**
     * Destroy the entire RichTextEditor.
     *
     * @returns {void}
     * @hidden

     */ ViewSource.prototype.destroy = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent)) return;
        this.removeEventListener();
    };
    return ViewSource;
}();


/**
 * @hidden

 */ var $2101ab4b6e103e48$export$bdee5ee1ac50b0db = {
    "bold": {
        command: "Style",
        subCommand: "Bold",
        value: "strong"
    },
    "italic": {
        command: "Style",
        subCommand: "Italic",
        value: "em"
    },
    "underline": {
        command: "Style",
        subCommand: "Underline",
        value: "span"
    },
    "strikeThrough": {
        command: "Style",
        subCommand: "StrikeThrough",
        value: "span"
    },
    "insertCode": {
        command: "Formats",
        subCommand: "Pre",
        value: "pre"
    },
    "superscript": {
        command: "Effects",
        subCommand: "SuperScript",
        value: "sup"
    },
    "subscript": {
        command: "Effects",
        subCommand: "SubScript",
        value: "sub"
    },
    "uppercase": {
        command: "Casing",
        subCommand: "UpperCase"
    },
    "lowercase": {
        command: "Casing",
        subCommand: "LowerCase"
    },
    "fontColor": {
        command: "font",
        subCommand: "fontcolor",
        value: "#ff0000"
    },
    "fontName": {
        command: "font",
        subCommand: "fontname",
        value: "Segoe UI"
    },
    "fontSize": {
        command: "font",
        subCommand: "fontsize",
        value: "10pt"
    },
    "backColor": {
        command: "font",
        subCommand: "backgroundcolor",
        value: "#ffff00"
    },
    "justifyCenter": {
        command: "Alignments",
        subCommand: "JustifyCenter"
    },
    "justifyFull": {
        command: "Alignments",
        subCommand: "JustifyFull"
    },
    "justifyLeft": {
        command: "Alignments",
        subCommand: "JustifyLeft"
    },
    "justifyRight": {
        command: "Alignments",
        subCommand: "JustifyRight"
    },
    "undo": {
        command: "Actions",
        subCommand: "Undo"
    },
    "redo": {
        command: "Actions",
        subCommand: "Redo"
    },
    "createLink": {
        command: "Links",
        subCommand: "createLink"
    },
    "editLink": {
        command: "Links",
        subCommand: "createLink"
    },
    "createImage": {
        command: "Images",
        subCommand: "Images"
    },
    "formatBlock": {
        command: "Formats",
        value: "P"
    },
    "heading": {
        command: "Formats",
        value: "H1"
    },
    "indent": {
        command: "Indents",
        subCommand: "Indent"
    },
    "outdent": {
        command: "Indents",
        subCommand: "Outdent"
    },
    "insertHTML": {
        command: "InsertHTML",
        subCommand: "InsertHTML",
        value: ""
    },
    "insertText": {
        command: "InsertText",
        subCommand: "InsertText",
        value: ""
    },
    "insertHorizontalRule": {
        command: "InsertHTML",
        subCommand: "InsertHTML",
        value: "<hr/>"
    },
    "insertImage": {
        command: "Images",
        subCommand: "Image"
    },
    "insertAudio": {
        command: "Audios",
        subCommand: "Audio"
    },
    "insertVideo": {
        command: "Videos",
        subCommand: "Video"
    },
    "editImage": {
        command: "Images",
        subCommand: "Image"
    },
    "insertTable": {
        command: "Table",
        subCommand: "CreateTable"
    },
    "insertBrOnReturn": {
        command: "InsertHTML",
        subCommand: "InsertHTML",
        value: "<br/>"
    },
    "insertOrderedList": {
        command: "Lists",
        value: "OL"
    },
    "insertUnorderedList": {
        command: "Lists",
        value: "UL"
    },
    "insertParagraph": {
        command: "Formats",
        value: "P"
    },
    "removeFormat": {
        command: "Clear",
        subCommand: "ClearFormat"
    },
    "copyFormatPainter": {
        command: "FormatPainter",
        value: "format-copy"
    },
    "applyFormatPainter": {
        command: "FormatPainter",
        value: "format-paste"
    },
    "escapeFormatPainter": {
        command: "FormatPainter",
        value: "escape"
    },
    "InlineCode": {
        command: "Style",
        subCommand: "inlinecode",
        value: "inlinecode"
    }
};


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * ServiceLocator
 *
 * @hidden

 */ var $3541fddf96aaed2a$export$6cd6e3ed1512e78f = /** @class */ function() {
    function ServiceLocator() {
        this.services = {};
    }
    /* eslint-disable */ /**
     * register method
     *
     * @param {string} name - specifies the name.
     * @param {T} type - specifies the type.
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ ServiceLocator.prototype.register = function(name, type) {
        if ((0, $3EnZW.isNullOrUndefined)(this.services["" + name])) this.services["" + name] = type;
    };
    /**
     * getService method
     *
     * @param {string} name - specifies the name.
     * @returns {void}
     * @hidden

     */ ServiceLocator.prototype.getService = function(name) {
        if ((0, $3EnZW.isNullOrUndefined)(this.services["" + name])) // eslint-disable-next-line
        throw "The service " + name + " is not registered";
        return this.services["" + name];
    };
    ServiceLocator.prototype.destroy = function() {
        this.services = {};
    };
    return ServiceLocator;
}();


parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * RendererFactory
 *
 * @hidden

 */ var $f4829b8a9892cfab$export$35d194b5f3387064 = /** @class */ function() {
    function RendererFactory() {
        this.rendererMap = {};
    }
    /**
     * addRenderer method
     *
     * @param {RenderType} name - specifies the render type
     * @param {IRenderer} type - specifies the renderer.
     * @returns {void}
     * @hidden

     */ RendererFactory.prototype.addRenderer = function(name, type) {
        var rName = (0, $3EnZW.getEnumValue)((0, $2eaa618655f536c2$export$ed706b0a66efb05c), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.rendererMap["" + rName])) this.rendererMap["" + rName] = type;
    };
    /**
     * getRenderer method
     *
     * @param {RenderType} name - specifies the render type
     * @returns {void}
     * @hidden

     */ RendererFactory.prototype.getRenderer = function(name) {
        var rName = (0, $3EnZW.getEnumValue)((0, $2eaa618655f536c2$export$ed706b0a66efb05c), name);
        if ((0, $3EnZW.isNullOrUndefined)(this.rendererMap["" + rName])) // eslint-disable-next-line
        throw "The renderer " + rName + " is not found";
        else return this.rendererMap["" + rName];
    };
    RendererFactory.prototype.destroy = function() {
        this.rendererMap = {};
    };
    return RendererFactory;
}();




parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");
/**
 * `ExecCommandCallBack` module is used to run the editor manager command
 */ var $13c0c2954f6df2de$export$4876194f410226b3 = /** @class */ function() {
    function ExecCommandCallBack(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    ExecCommandCallBack.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$4e0a4553c5a3311d, this.commandCallBack, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
    };
    ExecCommandCallBack.prototype.commandCallBack = function(args) {
        var formatPainterCopy = !(0, $3EnZW.isNullOrUndefined)(args.requestType) && args.requestType === "FormatPainter" && args.action === "format-copy";
        if (!(0, $3EnZW.isNullOrUndefined)(args) && !(0, $3EnZW.isNullOrUndefined)(args.requestType) && args.requestType !== "Undo" && args.requestType !== "Redo" && !formatPainterCopy) this.parent.formatter.saveData();
        this.parent.notify($947a002e9a697770$export$6a017cfaa3b33c68, {
            args: args
        });
        this.parent.notify($947a002e9a697770$export$85b9a36db797e02b, {});
    };
    ExecCommandCallBack.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$4e0a4553c5a3311d, this.commandCallBack);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
    };
    return ExecCommandCallBack;
}();



parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");



var $7a5ef0030307835c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7a5ef0030307835c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the toolbar settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$b468e96770a3e7db = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(ToolbarSettings, _super);
    function ToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ToolbarSettings.prototype, "enable", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ToolbarSettings.prototype, "enableFloating", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand)
    ], ToolbarSettings.prototype, "type", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$964474d73666b47f))
    ], ToolbarSettings.prototype, "items", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)({})
    ], ToolbarSettings.prototype, "itemConfigs", void 0);
    return ToolbarSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the importWord settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$da45e41e8d641ff1 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(ImportWord, _super);
    function ImportWord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImportWord.prototype, "serviceUrl", void 0);
    return ImportWord;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the export word of the RichTextEditor.
 */ var $7a5ef0030307835c$export$d12fc001dcc5abdb = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(ExportWord, _super);
    function ExportWord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ExportWord.prototype, "serviceUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Sample.docx")
    ], ExportWord.prototype, "fileName", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ExportWord.prototype, "stylesheet", void 0);
    return ExportWord;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the export settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$f0061bc52b1e55c1 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(ExportPdf, _super);
    function ExportPdf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ExportPdf.prototype, "serviceUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Sample.pdf")
    ], ExportPdf.prototype, "fileName", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ExportPdf.prototype, "stylesheet", void 0);
    return ExportPdf;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the image settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$40286e2b86ce5e93 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(ImageSettings, _super);
    function ImageSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            ".jpeg",
            ".jpg",
            ".png"
        ])
    ], ImageSettings.prototype, "allowedTypes", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("inline")
    ], ImageSettings.prototype, "display", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Blob")
    ], ImageSettings.prototype, "saveFormat", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], ImageSettings.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], ImageSettings.prototype, "height", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImageSettings.prototype, "saveUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImageSettings.prototype, "path", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], ImageSettings.prototype, "resize", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImageSettings.prototype, "removeUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ImageSettings.prototype, "minWidth", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImageSettings.prototype, "maxWidth", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], ImageSettings.prototype, "minHeight", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], ImageSettings.prototype, "maxHeight", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], ImageSettings.prototype, "resizeByPercent", void 0);
    return ImageSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the audio settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$75b44b566abc4e9c = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(AudioSettings, _super);
    function AudioSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            ".wav",
            ".mp3",
            ".m4a",
            ".wma"
        ])
    ], AudioSettings.prototype, "allowedTypes", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Inline")
    ], AudioSettings.prototype, "layoutOption", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Blob")
    ], AudioSettings.prototype, "saveFormat", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AudioSettings.prototype, "saveUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AudioSettings.prototype, "removeUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], AudioSettings.prototype, "path", void 0);
    return AudioSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the video settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$40214e6b2a12030d = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(VideoSettings, _super);
    function VideoSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            ".mp4",
            ".mov",
            ".wmv",
            ".avi"
        ])
    ], VideoSettings.prototype, "allowedTypes", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Inline")
    ], VideoSettings.prototype, "layoutOption", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Blob")
    ], VideoSettings.prototype, "saveFormat", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], VideoSettings.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], VideoSettings.prototype, "height", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VideoSettings.prototype, "saveUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VideoSettings.prototype, "path", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], VideoSettings.prototype, "resize", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VideoSettings.prototype, "removeUrl", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], VideoSettings.prototype, "minWidth", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VideoSettings.prototype, "maxWidth", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], VideoSettings.prototype, "minHeight", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], VideoSettings.prototype, "maxHeight", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], VideoSettings.prototype, "resizeByPercent", void 0);
    return VideoSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the file manager settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$87d854adb2c15ba4 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(FileManagerSettings, _super);
    function FileManagerSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Event)()
    ], FileManagerSettings.prototype, "beforeSend", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({
            getImageUrl: null,
            url: null,
            uploadUrl: null
        }, (0, $89f25b044ddeaaea$export$c7d0cd64e9070819))
    ], FileManagerSettings.prototype, "ajaxSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManagerSettings.prototype, "allowDragAndDrop", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({
            visible: true,
            file: [
                "Open",
                "|",
                "Cut",
                "Copy",
                "|",
                "Delete",
                "Rename",
                "|",
                "Details"
            ],
            folder: [
                "Open",
                "|",
                "Cut",
                "Copy",
                "Paste",
                "|",
                "Delete",
                "Rename",
                "|",
                "Details"
            ],
            layout: [
                "SortBy",
                "View",
                "Refresh",
                "|",
                "Paste",
                "|",
                "NewFolder",
                "Upload",
                "|",
                "Details",
                "|",
                "SelectAll"
            ]
        }, (0, $4532973e3b134128$export$87795476079a01f9))
    ], FileManagerSettings.prototype, "contextMenuSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("")
    ], FileManagerSettings.prototype, "cssClass", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $b165f47ecab2e2f8$export$2414f677b69712c))
    ], FileManagerSettings.prototype, "detailsViewSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManagerSettings.prototype, "enable", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({
            maxWidth: "650px",
            minWidth: "240px",
            visible: true
        }, (0, $d1b6780e16f65095$export$246cb6a888617168))
    ], FileManagerSettings.prototype, "navigationPaneSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("/")
    ], FileManagerSettings.prototype, "path", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FileManagerSettings.prototype, "rootAliasName", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $fdd3737878e30161$export$352475af1e1a6201))
    ], FileManagerSettings.prototype, "searchSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManagerSettings.prototype, "showFileExtension", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FileManagerSettings.prototype, "showHiddenItems", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], FileManagerSettings.prototype, "showThumbnail", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Ascending")
    ], FileManagerSettings.prototype, "sortOrder", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({
            visible: true,
            items: [
                "NewFolder",
                "Upload",
                "Cut",
                "Copy",
                "Paste",
                "Delete",
                "Download",
                "Rename",
                "SortBy",
                "Refresh",
                "Selection",
                "View",
                "Details"
            ]
        }, (0, $dc7b44f9b460d0c8$export$b468e96770a3e7db))
    ], FileManagerSettings.prototype, "toolbarSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Complex)({
            autoUpload: true,
            minFileSize: 0,
            maxFileSize: 30000000,
            allowedExtensions: "",
            autoClose: false
        }, (0, $5aa4792b5d1e0993$export$a2087ef30e892b25))
    ], FileManagerSettings.prototype, "uploadSettings", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("LargeIcons")
    ], FileManagerSettings.prototype, "view", void 0);
    return FileManagerSettings;
}((0, $3fcxu.ChildProperty));
var $7a5ef0030307835c$export$114fa93274be7e85 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(TableSettings, _super);
    function TableSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], TableSettings.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$e54eddff3c69b4c9))
    ], TableSettings.prototype, "styles", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], TableSettings.prototype, "resize", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], TableSettings.prototype, "minWidth", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], TableSettings.prototype, "maxWidth", void 0);
    return TableSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the quick toolbar settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$49efec50857bfbcf = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(QuickToolbarSettings, _super);
    function QuickToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], QuickToolbarSettings.prototype, "enable", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], QuickToolbarSettings.prototype, "showOnRightClick", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("hide")
    ], QuickToolbarSettings.prototype, "actionOnScroll", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "Open",
            "Edit",
            "UnLink"
        ])
    ], QuickToolbarSettings.prototype, "link", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "Replace",
            "Align",
            "Caption",
            "Remove",
            "-",
            "InsertLink",
            "OpenImageLink",
            "EditImageLink",
            "RemoveImageLink",
            "Display",
            "AltText",
            "Dimension"
        ])
    ], QuickToolbarSettings.prototype, "image", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "AudioReplace",
            "AudioRemove",
            "AudioLayoutOption"
        ])
    ], QuickToolbarSettings.prototype, "audio", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "VideoReplace",
            "VideoAlign",
            "VideoRemove",
            "VideoLayoutOption",
            "VideoDimension"
        ])
    ], QuickToolbarSettings.prototype, "video", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], QuickToolbarSettings.prototype, "text", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "TableHeader",
            "TableRows",
            "TableColumns",
            "BackgroundColor",
            "-",
            "TableRemove",
            "Alignments",
            "TableCellVerticalAlign",
            "Styles"
        ])
    ], QuickToolbarSettings.prototype, "table", void 0);
    return QuickToolbarSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configure the format painter settings of the Rich Text Editor.
 */ var $7a5ef0030307835c$export$83bd2b55a538f10c = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(FormatPainterSettings, _super);
    function FormatPainterSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("b; em; font; sub; sup; kbd; i; s; u; code; strong; span; p; div; h1; h2; h3; h4; h5; h6; blockquote; ol; ul; li; pre;")
    ], FormatPainterSettings.prototype, "allowedFormats", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FormatPainterSettings.prototype, "deniedFormats", void 0);
    return FormatPainterSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Specifies the emoji picker options in Rich Text Editor with the following properties.
 */ var $7a5ef0030307835c$export$f38a1fa0f2038152 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(EmojiSettings, _super);
    function EmojiSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$afb1f184b9ed8947))
    ], EmojiSettings.prototype, "iconsSet", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], EmojiSettings.prototype, "showSearchBox", void 0);
    return EmojiSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the Paste Cleanup settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$f209dbc49e40bd87 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(PasteCleanupSettings, _super);
    function PasteCleanupSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PasteCleanupSettings.prototype, "prompt", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PasteCleanupSettings.prototype, "deniedAttrs", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)([
            "background",
            "background-color",
            "border",
            "border-bottom",
            "border-left",
            "border-radius",
            "border-right",
            "border-style",
            "border-top",
            "border-width",
            "clear",
            "color",
            "cursor",
            "direction",
            "display",
            "float",
            "font",
            "font-family",
            "font-size",
            "font-weight",
            "font-style",
            "height",
            "left",
            "line-height",
            "list-style-type",
            "margin",
            "margin-top",
            "margin-left",
            "margin-right",
            "margin-bottom",
            "max-height",
            "max-width",
            "min-height",
            "min-width",
            "overflow",
            "overflow-x",
            "overflow-y",
            "padding",
            "padding-bottom",
            "padding-left",
            "padding-right",
            "padding-top",
            "position",
            "right",
            "table-layout",
            "text-align",
            "text-decoration",
            "text-transform",
            "text-indent",
            "top",
            "vertical-align",
            "visibility",
            "white-space",
            "width"
        ])
    ], PasteCleanupSettings.prototype, "allowedStyleProps", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], PasteCleanupSettings.prototype, "deniedTags", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], PasteCleanupSettings.prototype, "keepFormat", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], PasteCleanupSettings.prototype, "plainText", void 0);
    return PasteCleanupSettings;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the font family settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$cd0608c167c7849e = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(FontFamily, _super);
    function FontFamily() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FontFamily.prototype, "default", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("72px")
    ], FontFamily.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$a5975749f0374264))
    ], FontFamily.prototype, "items", void 0);
    return FontFamily;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the font size settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$80f2abd03de5ca5a = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(FontSize, _super);
    function FontSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], FontSize.prototype, "default", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("60px")
    ], FontSize.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$85e3c3ca0c6fb93))
    ], FontSize.prototype, "items", void 0);
    return FontSize;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the format settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$93514d28bd18d75a = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(Format, _super);
    function Format() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Format.prototype, "default", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("65px")
    ], Format.prototype, "width", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$62d86b02caf22d22))
    ], Format.prototype, "types", void 0);
    return Format;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the font Color settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$df33c55a31a69b45 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(FontColor, _super);
    function FontColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("#ff0000")
    ], FontColor.prototype, "default", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Palette")
    ], FontColor.prototype, "mode", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], FontColor.prototype, "columns", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$6cd2abafd8582497))
    ], FontColor.prototype, "colorCode", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], FontColor.prototype, "modeSwitcher", void 0);
    return FontColor;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the background Color settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$a5eaedcf95d1edc1 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(BackgroundColor, _super);
    function BackgroundColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("#ffff00")
    ], BackgroundColor.prototype, "default", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)("Palette")
    ], BackgroundColor.prototype, "mode", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(10)
    ], BackgroundColor.prototype, "columns", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$8c5a050822fd698c))
    ], BackgroundColor.prototype, "colorCode", void 0);
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], BackgroundColor.prototype, "modeSwitcher", void 0);
    return BackgroundColor;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the numberFormatList settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$9bf833e1445ffdb4 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(NumberFormatList, _super);
    function NumberFormatList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$28e1c0f2ef643da3))
    ], NumberFormatList.prototype, "types", void 0);
    return NumberFormatList;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the bulletFormatList settings of the RichTextEditor.
 */ var $7a5ef0030307835c$export$5f8691b1a1529e19 = /** @class */ function(_super) {
    $7a5ef0030307835c$var$__extends(BulletFormatList, _super);
    function BulletFormatList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $7a5ef0030307835c$var$__decorate([
        (0, $5rsSz.Property)((0, $228f7f224d55f07b$export$27d4548ab8fb9ed))
    ], BulletFormatList.prototype, "types", void 0);
    return BulletFormatList;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $a82ba10855884ca2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a82ba10855884ca2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Objects used for configuring the iframe resources properties.
 */ var $a82ba10855884ca2$export$e9a269813a6315a4 = /** @class */ function(_super) {
    $a82ba10855884ca2$var$__extends(Resources, _super);
    function Resources() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Resources.prototype, "styles", void 0);
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Resources.prototype, "scripts", void 0);
    return Resources;
}((0, $3fcxu.ChildProperty));
/**
 * Configures the iframe settings of the RTE.
 */ var $a82ba10855884ca2$export$18de83c1c630651b = /** @class */ function(_super) {
    $a82ba10855884ca2$var$__extends(IFrameSettings, _super);
    function IFrameSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], IFrameSettings.prototype, "enable", void 0);
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], IFrameSettings.prototype, "attributes", void 0);
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Complex)({}, $a82ba10855884ca2$export$e9a269813a6315a4)
    ], IFrameSettings.prototype, "resources", void 0);
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)([])
    ], IFrameSettings.prototype, "metaTags", void 0);
    $a82ba10855884ca2$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], IFrameSettings.prototype, "sandbox", void 0);
    return IFrameSettings;
}((0, $3fcxu.ChildProperty));


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");
var $2abafb58e1f41a72$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2abafb58e1f41a72$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the inlineMode property of the RTE.
 */ var $2abafb58e1f41a72$export$db37d2e974887d16 = /** @class */ function(_super) {
    $2abafb58e1f41a72$var$__extends(InlineMode, _super);
    function InlineMode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $2abafb58e1f41a72$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], InlineMode.prototype, "enable", void 0);
    $2abafb58e1f41a72$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], InlineMode.prototype, "onSelection", void 0);
    return InlineMode;
}((0, $3fcxu.ChildProperty));



/**
 * @param {string} htmlAttributes - specifies the string value
 * @param {IRichTextEditor} rte - specifies the rte value
 * @param {boolean} isFrame - specifies the boolean value
 * @param {boolean} initial - specifies the boolean value
 * @returns {void}
 * @hidden
 */ function $d344968bffc81d2f$export$74da2cba014bdc09(htmlAttributes, rte, isFrame, initial) {
    var target;
    if (isFrame) {
        var iFrame = rte.contentModule.getDocument();
        target = iFrame.querySelector("body");
    } else target = rte.element;
    if (Object.keys(htmlAttributes).length) for(var _i = 0, _a = Object.keys(htmlAttributes); _i < _a.length; _i++){
        var htmlAttr = _a[_i];
        if (htmlAttr === "class") target.classList.add(htmlAttributes["" + htmlAttr]);
        else if (htmlAttr === "disabled" && htmlAttributes["" + htmlAttr] === "disabled") {
            rte.enabled = false;
            rte.setEnable();
        } else if (htmlAttr === "readonly" && htmlAttributes["" + htmlAttr] === "readonly") {
            rte.readonly = true;
            rte.setReadOnly(initial);
        } else if (htmlAttr === "style") target.setAttribute("style", htmlAttributes["" + htmlAttr]);
        else if (htmlAttr === "tabindex") rte.inputElement.setAttribute("tabindex", htmlAttributes["" + htmlAttr]);
        else if (htmlAttr === "placeholder") {
            rte.placeholder = htmlAttributes["" + htmlAttr];
            rte.setPlaceHolder();
        } else {
            var validateAttr = [
                "name",
                "required"
            ];
            if (validateAttr.indexOf(htmlAttr) > -1) rte.valueContainer.setAttribute(htmlAttr, htmlAttributes["" + htmlAttr]);
            else target.setAttribute(htmlAttr, htmlAttributes["" + htmlAttr]);
        }
    }
}


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $3EnZW = parcelRequire("3EnZW");

var $2vAqh = parcelRequire("2vAqh");


/**
 * `FullScreen` module is used to maximize and minimize screen
 */ var $44b581d77a360fdd$export$f885b95b3f0be76d = /** @class */ function() {
    function FullScreen(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * showFullScreen method
     *
     * @param {MouseEvent} event - specifies the mouse event
     * @returns {void}
     * @hidden

     */ FullScreen.prototype.showFullScreen = function(event) {
        var _this = this;
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== "Markdown" && !(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule)) this.parent.quickToolbarModule.hideQuickToolbars();
        if (this.parent.showTooltip && !(0, $3EnZW.isNullOrUndefined)(document.querySelector(".e-tooltip-wrap"))) this.parent.notify($947a002e9a697770$export$121c0465ebbf863b, {
            args: event
        });
        this.scrollableParent = (0, $2vAqh.getScrollableParent)(this.parent.element);
        if (!this.parent.element.classList.contains($afc560df281b588d$export$f43b8d11ae23b9a)) {
            var evenArgs = {
                cancel: false,
                requestType: "Maximize",
                targetItem: "Maximize",
                args: event
            };
            this.parent.trigger($947a002e9a697770$export$df204737a6131aab, evenArgs, function(beginEventArgs) {
                if (!beginEventArgs.cancel) {
                    if (_this.parent.toolbarSettings.enableFloating && !_this.parent.inlineMode.enable && _this.parent.toolbarSettings.enable) {
                        _this.parent.getToolbarElement().style.width = "100%";
                        _this.parent.getToolbarElement().style.top = "0px";
                    }
                    _this.parent.element.classList.add($afc560df281b588d$export$f43b8d11ae23b9a);
                    _this.toggleParentOverflow(true);
                    if (_this.parent.toolbarModule) {
                        if (!_this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) _this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                        if ((0, $5q7BP.Browser).isDevice) _this.parent.toolbarModule.removeFixedTBarClass();
                        _this.parent.toolbarModule.updateItem({
                            targetItem: "Maximize",
                            updateItem: "Minimize",
                            baseToolbar: _this.parent.getBaseToolbarObject()
                        });
                    }
                    _this.parent.refreshUI();
                    _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
                        requestType: "Maximize",
                        targetItem: "Maximize",
                        args: event
                    });
                }
            });
        }
    };
    /**
     * hideFullScreen method
     *
     * @param {MouseEvent} event - specifies the mouse event
     * @returns {void}
     * @hidden

     */ FullScreen.prototype.hideFullScreen = function(event) {
        var _this = this;
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== "Markdown" && !(0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule)) this.parent.quickToolbarModule.hideQuickToolbars();
        if (this.parent.showTooltip && !(0, $3EnZW.isNullOrUndefined)(document.querySelector(".e-tooltip-wrap"))) this.parent.notify($947a002e9a697770$export$121c0465ebbf863b, {
            args: event
        });
        if (this.parent.element.classList.contains($afc560df281b588d$export$f43b8d11ae23b9a)) {
            var evenArgs = {
                cancel: false,
                requestType: "Minimize",
                targetItem: "Minimize",
                args: event
            };
            this.parent.trigger($947a002e9a697770$export$df204737a6131aab, evenArgs, function(beginEventArgs) {
                if (!beginEventArgs.cancel) {
                    _this.parent.element.classList.remove($afc560df281b588d$export$f43b8d11ae23b9a);
                    var elem = document.querySelectorAll(".e-rte-overflow");
                    for(var i = 0; i < elem.length; i++)(0, $4ZDHT.removeClass)([
                        elem[i]
                    ], [
                        "e-rte-overflow"
                    ]);
                    if (_this.parent.toolbarModule) {
                        if (!_this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) _this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                        _this.parent.toolbarModule.updateItem({
                            targetItem: "Minimize",
                            updateItem: "Maximize",
                            baseToolbar: _this.parent.getBaseToolbarObject()
                        });
                        if ((0, $5q7BP.Browser).isDevice && _this.parent.inlineMode.enable) _this.parent.toolbarModule.addFixedTBarClass();
                    }
                    _this.parent.refreshUI();
                    _this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
                        requestType: "Minimize",
                        targetItem: "Minimize",
                        args: event
                    });
                }
            });
        }
    };
    // eslint-disable-next-line
    FullScreen.prototype.toggleParentOverflow = function(isAdd) {
        if ((0, $3EnZW.isNullOrUndefined)(this.scrollableParent)) return;
        for(var i = 0; i < this.scrollableParent.length; i++)if (this.scrollableParent[i].nodeName === "#document") {
            var elem = document.querySelector("body");
            (0, $4ZDHT.addClass)([
                elem
            ], [
                "e-rte-overflow"
            ]);
        } else {
            var elem = this.scrollableParent[i];
            (0, $4ZDHT.addClass)([
                elem
            ], [
                "e-rte-overflow"
            ]);
        }
    };
    FullScreen.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        switch(originalEvent.action){
            case "full-screen":
                this.showFullScreen(event.args);
                originalEvent.preventDefault();
                break;
            case "escape":
                this.hideFullScreen(event.args);
                originalEvent.preventDefault();
                break;
        }
    };
    FullScreen.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    FullScreen.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
    };
    /**
     * destroy method
     *
     * @returns {void}
     * @hidden

     */ FullScreen.prototype.destroy = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent)) return;
        if (this.parent.element.classList.contains($afc560df281b588d$export$f43b8d11ae23b9a)) this.toggleParentOverflow(false);
        var elem = document.querySelectorAll(".e-rte-overflow");
        for(var i = 0; i < elem.length; i++)(0, $4ZDHT.removeClass)([
            elem[i]
        ], [
            "e-rte-overflow"
        ]);
        this.removeEventListener();
    };
    return FullScreen;
}();


parcelRequire("j7YE8");
var $5q7BP = parcelRequire("5q7BP");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

/**
 * `EnterKey` module is used to handle enter key press actions.
 */ var $71bfa6b0134e8557$export$cbf2176918894801 = /** @class */ function() {
    function EnterKeyAction(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    EnterKeyAction.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$606c1792086c85f2, this.enterHandler, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    EnterKeyAction.prototype.destroy = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.parent)) return;
        this.removeEventListener();
    };
    EnterKeyAction.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$606c1792086c85f2, this.enterHandler);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
    };
    EnterKeyAction.prototype.getRangeNode = function() {
        this.range = this.parent.getRange();
        this.startNode = this.range.startContainer.nodeName === "#text" ? this.range.startContainer.parentElement : this.range.startContainer;
        this.endNode = this.range.endContainer.nodeName === "#text" ? this.range.endContainer.parentElement : this.range.endContainer;
    };
    EnterKeyAction.prototype.enterHandler = function(e) {
        var _this = this;
        this.getRangeNode();
        var isTableEnter = true;
        this.formatTags = [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote"
        ];
        var tableImagCursor = this.processedTableImageCursor();
        if (tableImagCursor.start || tableImagCursor.end) {
            if (tableImagCursor.startName === "TABLE" || tableImagCursor.endName === "TABLE") {
                this.handleCursorAtTableSide(e, tableImagCursor.start, tableImagCursor.end);
                return;
            }
        }
        if (tableImagCursor.start || tableImagCursor.end || this.range.startContainer.nodeName === "IMG") {
            if (this.parent.enterKey === "BR" && (tableImagCursor.startName === "IMG" || tableImagCursor.endName === "IMG" || this.range.startContainer.nodeName === "IMG")) {
                this.handleEnterKeyAtImageSide(e, tableImagCursor.start, tableImagCursor.end);
                return;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.startNode.closest("TABLE")) && !(0, $3EnZW.isNullOrUndefined)(this.endNode.closest("TABLE"))) {
            isTableEnter = false;
            var curElement = this.startNode;
            var blockElement = curElement;
            while(!this.parent.formatter.editorManager.domNode.isBlockNode(curElement)){
                curElement = curElement.parentElement;
                blockElement = curElement;
            }
            isTableEnter = blockElement.tagName === "TH" || blockElement.tagName === "TD" || blockElement.tagName === "TBODY" ? false : true;
        }
        var eventArgs = e.args;
        if (eventArgs.which === 13 && !eventArgs.ctrlKey && (!(0, $5q7BP.Browser).isDevice ? eventArgs.code === "Enter" || eventArgs.code === "NumpadEnter" : eventArgs.key === "Enter")) {
            if ((0, $3EnZW.isNullOrUndefined)(this.startNode.closest("LI, UL, OL")) && (0, $3EnZW.isNullOrUndefined)(this.endNode.closest("LI, UL, OL")) && (0, $3EnZW.isNullOrUndefined)(this.startNode.closest(".e-img-inner")) && isTableEnter && (0, $3EnZW.isNullOrUndefined)(this.startNode.closest("PRE")) && (0, $3EnZW.isNullOrUndefined)(this.endNode.closest("PRE")) && (0, $3EnZW.isNullOrUndefined)(this.startNode.closest("BLOCKQUOTE")) && (0, $3EnZW.isNullOrUndefined)(this.endNode.closest("BLOCKQUOTE"))) {
                var shiftKey_1 = e.args.shiftKey;
                var actionBeginArgs = {
                    cancel: false,
                    name: $947a002e9a697770$export$df204737a6131aab,
                    requestType: shiftKey_1 ? "ShiftEnterAction" : "EnterAction",
                    originalEvent: e.args
                };
                this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
                    if (!actionBeginArgs.cancel) {
                        if (_this.parent.formatter.getUndoRedoStack().length === 0) _this.parent.formatter.saveData();
                        if (!(_this.range.startOffset === _this.range.endOffset && _this.range.startContainer === _this.range.endContainer)) {
                            if (!(_this.range.startContainer.nodeName === "SPAN" && (_this.range.startContainer.classList.contains("e-video-wrap") || _this.range.startContainer.classList.contains("e-audio-wrap")))) _this.range.deleteContents();
                            if (_this.range.startContainer.nodeName === "#text" && _this.range.startContainer.textContent.length === 0 && _this.range.startContainer.parentElement !== _this.parent.inputElement) {
                                if (_this.parent.enterKey === "BR") _this.range.startContainer.parentElement.innerHTML = "&#8203;";
                                else _this.range.startContainer.parentElement.innerHTML = "<br>";
                            } else if (_this.range.startContainer === _this.parent.inputElement && _this.range.startContainer.innerHTML === "") {
                                _this.range.startContainer.innerHTML = "<br>";
                                var focusElem = _this.range.startContainer.childNodes[_this.range.startOffset];
                                _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), focusElem, 0);
                            } else if (_this.parent.inputElement === _this.range.startContainer) {
                                var focusElem = _this.range.startContainer.childNodes[_this.range.startOffset];
                                if (focusElem.nodeName === "#text" && focusElem.textContent.length === 0) _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), focusElem, focusElem.textContent.length === 0 ? 0 : focusElem.previousSibling.textContent.length);
                                else {
                                    _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), focusElem, focusElem.textContent.length >= 0 ? 0 : 1);
                                    if (focusElem.previousSibling.textContent.length === 0) {
                                        (0, $4ZDHT.detach)(focusElem.previousSibling);
                                        if (!shiftKey_1) {
                                            var currentFocusElem = !(0, $3EnZW.isNullOrUndefined)(focusElem.lastChild) ? focusElem.lastChild : focusElem;
                                            while(!(0, $3EnZW.isNullOrUndefined)(currentFocusElem) && currentFocusElem.nodeName !== "#text" && currentFocusElem.nodeName !== "BR")currentFocusElem = currentFocusElem.lastChild;
                                            if (currentFocusElem.nodeName !== "BR" && currentFocusElem.parentElement.textContent.length === 0 && currentFocusElem.parentElement.innerHTML.length === 0 && currentFocusElem.parentElement.nodeName !== "BR") currentFocusElem.parentElement.appendChild(_this.parent.createElement("BR"));
                                            _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), currentFocusElem.nodeName === "BR" ? currentFocusElem : currentFocusElem.parentElement, currentFocusElem.parentElement.textContent.length >= 0 || currentFocusElem.nodeName === "BR" ? 0 : 1);
                                        }
                                    } else if (focusElem.textContent.length === 0) {
                                        var currentFocusElem = focusElem.previousSibling.nodeName === "#text" ? focusElem.previousSibling : focusElem.previousSibling.lastChild;
                                        while(!(0, $3EnZW.isNullOrUndefined)(currentFocusElem) && currentFocusElem.nodeName !== "#text")currentFocusElem = currentFocusElem.lastChild;
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), currentFocusElem, currentFocusElem.textContent.length);
                                        (0, $4ZDHT.detach)(focusElem);
                                    } else if (_this.parent.enterKey !== "BR" && focusElem.previousSibling.textContent.length !== 0 && focusElem.textContent.length !== 0) {
                                        e.args.preventDefault();
                                        return;
                                    }
                                }
                                _this.getRangeNode();
                            }
                        }
                        if (_this.range.startContainer === _this.range.endContainer && _this.range.startOffset === _this.range.endOffset && _this.range.startContainer === _this.parent.inputElement) {
                            if (!(_this.parent.inputElement.childNodes.length === 1 && _this.parent.inputElement.childNodes[0].nodeName === "TABLE")) {
                                if ((0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.childNodes[_this.range.startOffset])) {
                                    var currentLastElem = _this.range.startContainer.childNodes[_this.range.startOffset - 1];
                                    while(currentLastElem.lastChild !== null && currentLastElem.nodeName !== "#text")currentLastElem = currentLastElem.lastChild;
                                    _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), currentLastElem, currentLastElem.nodeName === "BR" ? 0 : currentLastElem.textContent.length);
                                } else _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), _this.range.startContainer.childNodes[_this.range.startOffset], 0);
                            }
                            _this.getRangeNode();
                        }
                        if (_this.parent.enterKey === "P" && !shiftKey_1 || _this.parent.enterKey === "DIV" && !shiftKey_1 || _this.parent.shiftEnterKey === "P" && shiftKey_1 || _this.parent.shiftEnterKey === "DIV" && shiftKey_1) {
                            if (_this.range.startOffset === 1 && _this.parent.inputElement.childNodes.length === 1 && _this.parent.inputElement.childNodes[0].nodeName === "TABLE" || _this.parent.enterKey === "BR" && shiftKey_1) {
                                var newElem = _this.createInsertElement(shiftKey_1);
                                newElem.appendChild(_this.parent.createElement("BR"));
                                _this.parent.inputElement.appendChild(newElem);
                                _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), newElem, 0);
                            } else {
                                var nearBlockNode = void 0;
                                if (isTableEnter && _this.parent.formatter.editorManager.domNode.isBlockNode(_this.startNode)) {
                                    if (_this.range.startContainer.nodeName === "#text" && !(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.previousSibling) && _this.range.startContainer.previousSibling.nodeName === "HR") nearBlockNode = _this.range.startContainer.nextSibling;
                                    else nearBlockNode = _this.startNode;
                                } else nearBlockNode = _this.parent.formatter.editorManager.domNode.blockParentNode(_this.startNode);
                                var isMediaNode = false; // To check the image audio and video node cases
                                var isFocusedFirst = false;
                                if (_this.range.startOffset !== 0 && _this.range.endOffset !== 0 && _this.range.startContainer === _this.range.endContainer && !(!(0, $3EnZW.isNullOrUndefined)(nearBlockNode.childNodes[0]) && (nearBlockNode.childNodes[0].nodeName === "IMG" || nearBlockNode.querySelectorAll("img, audio, video").length > 0))) {
                                    var startNodeText = _this.range.startContainer.textContent;
                                    var splitFirstText = startNodeText.substring(0, _this.range.startOffset);
                                    // eslint-disable-next-line max-len
                                    if (splitFirstText.charCodeAt(_this.range.startOffset - 1) !== 160 && splitFirstText.trim().length === 0) isFocusedFirst = true;
                                } else if (_this.range.startOffset === 0 && _this.range.endOffset === 0) isFocusedFirst = true;
                                _this.removeBRElement(nearBlockNode);
                                var fireFoxEnterAtMiddle = (0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && _this.range.startOffset === 0 && _this.range.startContainer === _this.range.endContainer && _this.range.startContainer.nodeName === "#text" && !_this.parent.formatter.editorManager.domNode.isBlockNode(_this.range.startContainer.previousSibling) && _this.range.startContainer.parentElement === _this.range.startContainer.previousSibling.parentElement;
                                var preventZeroWithSpace = _this.range.startContainer.nodeName === "#text" && _this.range.startContainer.textContent.includes("\u200B") && _this.range.startContainer.textContent.trim() === "\u200B" || _this.range.startContainer.nodeName === "#text" && !(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.textContent[_this.range.startOffset]) && _this.range.startContainer.textContent[_this.range.startOffset].includes("\u200B") && _this.range.startContainer.textContent[_this.range.startOffset] === "\u200B" && _this.parent.inputElement.textContent[0] !== "\u200B";
                                // eslint-disable-next-line max-len
                                if (!preventZeroWithSpace && !fireFoxEnterAtMiddle && (_this.range.startOffset === 0 && _this.range.endOffset === 0 || isFocusedFirst) && !(!(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.previousSibling) && (_this.range.startContainer.previousSibling.nodeName === "IMG" || _this.range.startContainer.previousSibling.nodeName === "BR"))) {
                                    var isNearBlockLengthZero = void 0;
                                    var newElem = void 0;
                                    if (!(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.childNodes) && (_this.range.startContainer.textContent.length === 0 || _this.range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.querySelector(".e-video-clickelem")) && _this.range.startContainer.querySelector(".e-video-clickelem").textContent.length === 0) && (_this.range.startContainer.querySelectorAll("img, audio, video").length > 0 || !(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.querySelector(".e-video-clickelem")) || _this.range.startContainer.nodeName === "IMG" || _this.range.startContainer.nodeName === "TABLE")) {
                                        newElem = _this.createInsertElement(shiftKey_1);
                                        isMediaNode = true;
                                        isNearBlockLengthZero = false;
                                    } else if (nearBlockNode.textContent.trim().length !== 0 || !(0, $3EnZW.isNullOrUndefined)(nearBlockNode.childNodes[0]) && nearBlockNode.childNodes[0].nodeName === "IMG" || nearBlockNode.textContent.trim() === "" && nearBlockNode.querySelectorAll("img, audio, video").length > 0) {
                                        if (_this.range.startOffset === _this.range.endOffset && _this.range.startOffset !== 0) newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, false).cloneNode(true);
                                        else {
                                            newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, true).cloneNode(true);
                                            isMediaNode = true;
                                        }
                                        isNearBlockLengthZero = false;
                                    } else {
                                        newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, true).cloneNode(true);
                                        isNearBlockLengthZero = true;
                                    }
                                    var insertElem = void 0;
                                    if (_this.formatTags.indexOf(newElem.nodeName.toLocaleLowerCase()) < 0) insertElem = _this.createInsertElement(shiftKey_1);
                                    else insertElem = _this.parent.createElement(newElem.nodeName);
                                    while(newElem.firstChild)insertElem.appendChild(newElem.firstChild);
                                    nearBlockNode.parentElement.insertBefore(insertElem, nearBlockNode);
                                    if (!isNearBlockLengthZero) {
                                        var currentFocusElem = insertElem;
                                        var finalFocusElem = void 0;
                                        if (_this.range.startOffset === _this.range.endOffset && _this.range.startOffset !== 0) while(!(0, $3EnZW.isNullOrUndefined)(currentFocusElem) && currentFocusElem.nodeName !== "#text" && currentFocusElem.nodeName !== "BR"){
                                            finalFocusElem = currentFocusElem;
                                            currentFocusElem = currentFocusElem.lastChild;
                                        }
                                        else finalFocusElem = currentFocusElem;
                                        finalFocusElem.innerHTML = "<br>";
                                        if (!isMediaNode) (0, $4ZDHT.detach)(nearBlockNode);
                                    }
                                    _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), insertElem.nextElementSibling, 0);
                                } else if (nearBlockNode.textContent.length === 0 && !(!(0, $3EnZW.isNullOrUndefined)(nearBlockNode.childNodes[0]) && nearBlockNode.childNodes[0].nodeName === "IMG" || nearBlockNode.querySelectorAll("video").length > 0 || nearBlockNode.querySelectorAll("audio").length > 0 || nearBlockNode.querySelectorAll("img").length > 0)) {
                                    if (!(0, $3EnZW.isNullOrUndefined)(nearBlockNode.children[0]) && nearBlockNode.children[0].tagName !== "BR") {
                                        var newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, false).cloneNode(true);
                                        _this.parent.formatter.editorManager.domNode.insertAfter(newElem, nearBlockNode);
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), newElem, newElem.textContent.length >= 0 ? 0 : 1);
                                    } else {
                                        var insertElem = _this.createInsertElement(shiftKey_1);
                                        insertElem.innerHTML = "<br>";
                                        _this.parent.formatter.editorManager.domNode.insertAfter(insertElem, nearBlockNode);
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), insertElem, 0);
                                    }
                                } else if (_this.range.startContainer === _this.range.endContainer && _this.range.startContainer.nodeName === "SPAN" && (_this.range.startContainer.classList.contains("e-video-wrap") || _this.range.startContainer.classList.contains("e-audio-wrap"))) {
                                    if (nearBlockNode.textContent.trim().length > 0) {
                                        var newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, true);
                                        var audioVideoElem = !(0, $3EnZW.isNullOrUndefined)(newElem.previousSibling.querySelector(".e-video-wrap")) ? newElem.previousSibling.querySelector(".e-video-wrap") : newElem.previousSibling.querySelector(".e-audio-wrap");
                                        var isBRInserted = false;
                                        var lastNode = audioVideoElem.previousSibling;
                                        while(!(0, $3EnZW.isNullOrUndefined)(lastNode) && lastNode.nodeName !== "#text")lastNode = lastNode.lastChild;
                                        if ((0, $3EnZW.isNullOrUndefined)(lastNode)) {
                                            var brElm = _this.parent.createElement("br");
                                            audioVideoElem.parentElement.appendChild(brElm);
                                            isBRInserted = true;
                                        }
                                        if (isBRInserted) _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), audioVideoElem.parentElement, 0);
                                        else _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), lastNode, lastNode.textContent.length);
                                        (0, $4ZDHT.detach)(audioVideoElem);
                                    } else {
                                        var newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, true);
                                        var focusElem = newElem.previousSibling;
                                        while(!(0, $3EnZW.isNullOrUndefined)(focusElem.firstChild))(0, $4ZDHT.detach)(focusElem.firstChild);
                                        var brElm = _this.parent.createElement("br");
                                        focusElem.appendChild(brElm);
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), focusElem, 0);
                                    }
                                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.audioModule)) _this.parent.audioModule.hideAudioQuickToolbar();
                                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.videoModule)) _this.parent.videoModule.hideVideoQuickToolbar();
                                } else {
                                    var newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, nearBlockNode, true);
                                    if (!(0, $3EnZW.isNullOrUndefined)(newElem.childNodes[0]) && newElem.childNodes[0].nodeName === "#text" && newElem.childNodes[0].textContent.length === 0) (0, $4ZDHT.detach)(newElem.childNodes[0]);
                                    if (newElem.textContent.trim().length === 0 || newElem.childNodes[0].textContent.trim().includes("\u200B") && newElem.childNodes[0].textContent.trim() === "\u200B") {
                                        var brElm = _this.parent.createElement("br");
                                        if (_this.startNode.nodeName === "A") {
                                            var startParentElem = _this.startNode.parentElement;
                                            _this.startNode.parentElement.insertBefore(brElm, _this.startNode);
                                            (0, $4ZDHT.detach)(_this.startNode);
                                            _this.startNode = startParentElem;
                                        } else if (_this.startNode.nodeName !== "BR") _this.startNode.appendChild(brElm);
                                        if (newElem.childNodes[0].textContent === "\n") (0, $4ZDHT.detach)(newElem.childNodes[0]);
                                        if (newElem.childNodes[0].textContent.trim().includes("\u200B") && newElem.childNodes[0].textContent.trim() === "\u200B") (0, $4ZDHT.detach)(newElem.childNodes[0]);
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), _this.startNode, 0);
                                    }
                                    if ((_this.parent.enterKey === "P" || _this.parent.enterKey === "DIV") && !shiftKey_1 || (_this.parent.shiftEnterKey === "DIV" || _this.parent.shiftEnterKey === "P") && shiftKey_1) {
                                        var isHeadingTag = _this.formatTags.indexOf(newElem.nodeName.toLocaleLowerCase());
                                        if (isHeadingTag < 0 || isHeadingTag >= 0 && newElem.textContent.trim().length === 0) {
                                            var insertElm = _this.createInsertElement(shiftKey_1);
                                            while(newElem.firstChild)insertElm.appendChild(newElem.firstChild);
                                            _this.parent.formatter.editorManager.domNode.insertAfter(insertElm, newElem);
                                            (0, $4ZDHT.detach)(newElem);
                                            _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), _this.parent.formatter.editorManager.domNode.isBlockNode(_this.startNode) ? insertElm : _this.startNode, 0);
                                        }
                                    }
                                }
                            }
                            e.args.preventDefault();
                        }
                        if (_this.parent.enterKey === "BR" && !shiftKey_1 || _this.parent.shiftEnterKey === "BR" && shiftKey_1) {
                            var currentParent = void 0;
                            if (!_this.parent.formatter.editorManager.domNode.isBlockNode(_this.startNode)) {
                                var currentNode = _this.startNode;
                                var previousNode = currentNode;
                                while(!_this.parent.formatter.editorManager.domNode.isBlockNode(currentNode)){
                                    previousNode = currentNode;
                                    currentNode = currentNode.parentElement;
                                }
                                currentParent = currentNode === _this.parent.inputElement ? previousNode : currentNode;
                            } else currentParent = _this.startNode;
                            var currentParentStyle = window.getComputedStyle(currentParent);
                            _this.removeBRElement(currentParent);
                            var isEmptyBrInserted = false;
                            var currentParentLastChild = currentParent.lastChild;
                            while(!(0, $3EnZW.isNullOrUndefined)(currentParentLastChild) && !(currentParentLastChild.nodeName === "#text" || currentParentLastChild.nodeName === "BR" || currentParentLastChild.nodeName === "IMG"))currentParentLastChild = currentParentLastChild.lastChild;
                            var isLastNodeLength = _this.range.startContainer === currentParentLastChild ? _this.range.startContainer.textContent.length : currentParent.textContent.length;
                            var isImageElement = _this.range.startContainer.nodeName === "IMG" || _this.range.startContainer.childNodes.length > 0 && _this.range.startContainer.childNodes[_this.range.startOffset].nodeName === "IMG";
                            if (currentParent !== _this.parent.inputElement && _this.parent.formatter.editorManager.domNode.isBlockNode(currentParent) && _this.range.startOffset === _this.range.endOffset && (_this.range.startOffset === isLastNodeLength || currentParent.textContent.trim().length === 0 && isImageElement)) {
                                var focusBRElem = _this.parent.createElement("br");
                                if (_this.range.startOffset === 0 && _this.range.startContainer.nodeName === "TABLE") _this.range.startContainer.parentElement.insertBefore(focusBRElem, _this.range.startContainer);
                                else {
                                    if (currentParentLastChild.nodeName === "BR" && currentParent.textContent.length === 0) _this.parent.formatter.editorManager.domNode.insertAfter(focusBRElem, currentParentLastChild);
                                    else if (_this.range.startOffset === 0 && _this.range.endOffset === 0 && isImageElement) {
                                        var imageElement = _this.range.startContainer.nodeName === "IMG" ? _this.range.startContainer : _this.range.startContainer.childNodes[_this.range.startOffset];
                                        currentParent.insertBefore(focusBRElem, imageElement);
                                        focusBRElem = imageElement;
                                    } else {
                                        var lineBreakBRElem = _this.parent.createElement("br");
                                        var anchorElement = !(0, $3EnZW.isNullOrUndefined)(_this.range.startContainer.parentElement) && _this.range.startContainer.parentElement.nodeName === "A" && _this.range.startContainer.parentElement.textContent.length === _this.range.startOffset ? _this.range.startContainer.parentElement : _this.range.startContainer;
                                        _this.parent.formatter.editorManager.domNode.insertAfter(focusBRElem, anchorElement);
                                        _this.parent.formatter.editorManager.domNode.insertAfter(lineBreakBRElem, anchorElement);
                                        var brSibling = anchorElement.nextElementSibling;
                                        var brNextSibling = !(0, $3EnZW.isNullOrUndefined)(brSibling) ? brSibling.nextElementSibling : null;
                                        if (!(0, $3EnZW.isNullOrUndefined)(brSibling) && !(0, $3EnZW.isNullOrUndefined)(brNextSibling) && !(0, $3EnZW.isNullOrUndefined)(brNextSibling.nextElementSibling) && brSibling.nodeName === "BR" && brNextSibling.nodeName === "BR" && brNextSibling.nextElementSibling.nodeName === "BR") brNextSibling.nextElementSibling.remove();
                                    }
                                }
                                _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), focusBRElem, 0);
                            } else if (!(0, $3EnZW.isNullOrUndefined)(currentParent) && currentParent !== _this.parent.inputElement && currentParent.nodeName !== "BR") {
                                if (currentParent.textContent.trim().length === 0 || currentParent.textContent.trim().length === 1 && currentParent.textContent.charCodeAt(0) === 8203) {
                                    var newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, currentParent, true).cloneNode(true);
                                    _this.parent.formatter.editorManager.domNode.insertAfter(newElem, currentParent);
                                    var outerBRElem = _this.parent.createElement("br");
                                    newElem.parentElement.insertBefore(outerBRElem, newElem);
                                    _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), newElem, 0);
                                } else {
                                    var newElem = void 0;
                                    var outerBRElem = _this.parent.createElement("br");
                                    if (_this.range.startOffset === 0 && _this.range.endOffset === 0 && !(0, $3EnZW.isNullOrUndefined)(currentParent.previousSibling) && currentParent.previousSibling.nodeName === "BR" && currentParent.nodeName !== "P" && currentParent.nodeName !== "DIV") {
                                        newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, currentParent, false).cloneNode(true);
                                        _this.parent.formatter.editorManager.domNode.insertAfter(outerBRElem, currentParent);
                                        _this.insertFocusContent();
                                        var currentFocusElem = outerBRElem.nextSibling;
                                        while(!(0, $3EnZW.isNullOrUndefined)(currentFocusElem) && currentFocusElem.nodeName !== "#text")currentFocusElem = currentFocusElem.lastChild;
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), currentFocusElem, 0);
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        isEmptyBrInserted = true;
                                    } else if (currentParent !== _this.parent.inputElement && (currentParentStyle.display === "inline" || currentParentStyle.display === "inline-block")) {
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        newElem = _this.parent.formatter.editorManager.nodeCutter.SplitNode(_this.range, currentParent, true).cloneNode(true);
                                        currentParent.parentElement.insertBefore(outerBRElem, currentParent);
                                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), currentParent, 0);
                                        _this.insertFocusContent();
                                    } else _this.insertBRElement();
                                }
                            } else _this.insertBRElement();
                            e.args.preventDefault();
                        }
                        _this.triggerActionComplete(e, shiftKey_1);
                        _this.parent.inputElement.dispatchEvent(new Event("input"));
                    }
                });
            }
        }
    };
    EnterKeyAction.prototype.removeBRElement = function(currentElement) {
        if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && this.range.endOffset === currentElement.textContent.length && (currentElement.textContent.length !== 0 || currentElement.querySelectorAll("BR").length > 1) && !(0, $3EnZW.isNullOrUndefined)(currentElement.lastChild) && currentElement.lastChild.nodeName === "BR") (0, $4ZDHT.detach)(currentElement.lastChild);
    };
    EnterKeyAction.prototype.insertBRElement = function() {
        var isEmptyBrInserted = false;
        var isFocusTextNode = true;
        if (this.range.endContainer.textContent.length === 0 && this.range.startContainer.nodeName === "BR") isFocusTextNode = false;
        var brElm = this.parent.createElement("br");
        var findAnchorLastChild = this.startNode;
        while(findAnchorLastChild.lastChild)findAnchorLastChild = findAnchorLastChild.lastChild;
        var findAnchorElement = this.startNode.nodeName === "A" && this.endNode.nodeName === "A" && !(0, $3EnZW.isNullOrUndefined)(this.range.startContainer.parentElement) && this.range.startOffset === this.range.endOffset && this.range.startContainer.textContent.trim().length === findAnchorLastChild.textContent.trim().length;
        if (this.startNode.nodeName === "BR" && this.endNode.nodeName === "BR" && this.range.startOffset === 0 && this.range.startOffset === this.range.endOffset) {
            this.parent.formatter.editorManager.domNode.insertAfter(brElm, this.startNode);
            isEmptyBrInserted = true;
        } else {
            if (this.startNode === this.parent.inputElement && !(0, $3EnZW.isNullOrUndefined)(this.range.startContainer.previousSibling) && this.range.startContainer.previousSibling.nodeName === "BR" && this.range.startContainer.textContent.length === 0) isEmptyBrInserted = true;
            if (findAnchorElement) this.parent.formatter.editorManager.domNode.insertAfter(brElm, this.startNode);
            else this.range.insertNode(brElm);
        }
        if (isEmptyBrInserted || !(0, $3EnZW.isNullOrUndefined)(brElm.nextElementSibling) && brElm.nextElementSibling.tagName === "BR" || !(0, $3EnZW.isNullOrUndefined)(brElm.nextSibling) && (brElm.nextSibling.textContent.length > 0 || brElm.nextSibling.nodeName === "#text" && brElm.nextSibling.textContent.trim().length === 0 && !(0, $3EnZW.isNullOrUndefined)(brElm.nextSibling.nextSibling) && brElm.nextSibling.nextSibling.textContent.trim().length > 0)) {
            this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), !(0, $3EnZW.isNullOrUndefined)(brElm.nextSibling) && isFocusTextNode ? brElm.nextSibling : brElm, 0);
            isEmptyBrInserted = false;
        } else {
            var brElements = this.parent.createElement("br");
            if (findAnchorElement) this.parent.formatter.editorManager.domNode.insertAfter(brElements, this.startNode);
            else this.range.insertNode(brElements);
            this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), brElm, 0);
        }
    };
    EnterKeyAction.prototype.insertFocusContent = function() {
        if (this.range.startContainer.textContent.length === 0) {
            if (this.range.startContainer.nodeName === "#text") this.range.startContainer.parentElement.innerHTML = "&#8203;";
            else this.range.startContainer.innerHTML = "&#8203;";
        }
    };
    EnterKeyAction.prototype.createInsertElement = function(shiftKey) {
        var insertElem;
        if (this.parent.enterKey === "DIV" && !shiftKey || this.parent.shiftEnterKey === "DIV" && shiftKey) insertElem = this.parent.createElement("div");
        else if (this.parent.enterKey === "P" && !shiftKey || this.parent.shiftEnterKey === "P" && shiftKey) insertElem = this.parent.createElement("p");
        var previousBlockNode = this.parent.formatter.editorManager.domNode.blockNodes()[0].previousSibling;
        var nextBlockNode = this.parent.formatter.editorManager.domNode.blockNodes()[0].nextSibling;
        if (!(0, $3EnZW.isNullOrUndefined)(previousBlockNode) && previousBlockNode.nodeName !== "#text" && previousBlockNode.hasAttribute("style") && previousBlockNode.nodeName !== "TABLE") insertElem.setAttribute("style", previousBlockNode.getAttribute("style"));
        if ((0, $3EnZW.isNullOrUndefined)(previousBlockNode) && !(0, $3EnZW.isNullOrUndefined)(nextBlockNode) && nextBlockNode.nodeName !== "#text" && nextBlockNode.hasAttribute("style") && nextBlockNode.nodeName !== "TABLE") insertElem.setAttribute("style", nextBlockNode.getAttribute("style"));
        return insertElem;
    };
    EnterKeyAction.prototype.triggerActionComplete = function(e, shiftKey) {
        this.parent.trigger($947a002e9a697770$export$830631a3cb598490, {
            requestType: shiftKey ? "ShiftEnterAction" : "EnterAction",
            args: e.args
        });
    };
    EnterKeyAction.prototype.handleCursorAtTableSide = function(e, isStart, isEnd) {
        var _this = this;
        if (this.parent.enterKey !== "BR") {
            var shiftKey_2 = e.args.shiftKey;
            var actionBeginArgs = {
                cancel: false,
                name: $947a002e9a697770$export$df204737a6131aab,
                requestType: shiftKey_2 ? "ShiftEnterAction" : "EnterAction",
                originalEvent: e.args
            };
            this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
                if (!actionBeginArgs.cancel) {
                    var newElement = _this.parent.createElement(_this.parent.enterKey);
                    newElement.innerHTML = "<br>";
                    var tableElement = void 0;
                    if (isStart) {
                        tableElement = _this.range.startContainer.childNodes[_this.range.startOffset];
                        tableElement.parentElement.insertBefore(newElement, tableElement);
                    }
                    if (isEnd) {
                        tableElement = _this.range.startContainer.childNodes[_this.range.startOffset - 1];
                        if (!(0, $3EnZW.isNullOrUndefined)(tableElement.nextSibling)) tableElement.parentElement.insertBefore(newElement, tableElement.nextSibling);
                        else if ((0, $3EnZW.isNullOrUndefined)(tableElement.nextSibling)) tableElement.parentElement.appendChild(newElement);
                    }
                    _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), newElement, 0);
                    e.args.preventDefault();
                    _this.triggerActionComplete(e, shiftKey_2);
                }
            });
        }
    };
    EnterKeyAction.prototype.handleEnterKeyAtImageSide = function(e, isStart, isEnd) {
        var _this = this;
        var actionBeginArgs = {
            cancel: false,
            name: $947a002e9a697770$export$df204737a6131aab,
            requestType: e.args.shiftKey ? "ShiftEnterAction" : "EnterAction",
            originalEvent: e.args
        };
        var directRange = false;
        if (this.range.startContainer.nodeName === "IMG" && this.range.startOffset === 0) directRange = true;
        this.parent.trigger($947a002e9a697770$export$df204737a6131aab, actionBeginArgs, function(actionBeginArgs) {
            if (!actionBeginArgs.cancel) {
                if (_this.parent.enterKey === "BR") {
                    var newElement = _this.parent.createElement("BR");
                    var imageElement = void 0;
                    if (directRange) {
                        imageElement = _this.range.startContainer;
                        imageElement.parentElement.insertBefore(newElement, imageElement);
                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), imageElement, 0);
                    }
                    if (isStart) {
                        imageElement = _this.range.startContainer.childNodes[_this.range.startOffset];
                        imageElement.parentElement.insertBefore(newElement, imageElement);
                        _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), imageElement, 0);
                    }
                    if (isEnd) {
                        imageElement = _this.range.startContainer.childNodes[_this.range.startOffset - 1];
                        if (!(0, $3EnZW.isNullOrUndefined)(imageElement.nextSibling)) {
                            imageElement.parentElement.insertBefore(newElement, imageElement.nextSibling);
                            _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), newElement.nextSibling, 0);
                        } else if ((0, $3EnZW.isNullOrUndefined)(imageElement.nextSibling)) {
                            imageElement.parentElement.appendChild(newElement);
                            var brElement = _this.parent.createElement("BR");
                            imageElement.parentElement.appendChild(brElement);
                            _this.parent.formatter.editorManager.nodeSelection.setCursorPoint(_this.parent.contentModule.getDocument(), brElement, 0);
                        }
                    }
                    e.args.preventDefault();
                    _this.triggerActionComplete(e, e.args.shiftKey);
                }
            }
        });
    };
    EnterKeyAction.prototype.isTableOrImageStart = function() {
        var customHandlerElements = [
            "IMG",
            "TABLE"
        ];
        var startContainer = this.range.startContainer;
        var startOffset = this.range.startOffset;
        var isCursorAtStart = this.range.collapsed && startContainer.nodeType === 1 && startContainer.isContentEditable && startContainer.childNodes[startOffset] && customHandlerElements.indexOf(startContainer.childNodes[startOffset].nodeName) > -1;
        if (isCursorAtStart) return {
            start: isCursorAtStart,
            startNodeName: startContainer.childNodes[startOffset].nodeName
        };
        else return {
            start: false,
            startNodeName: ""
        };
    };
    EnterKeyAction.prototype.isTableOrImageEnd = function() {
        var customHandlerElements = [
            "IMG",
            "TABLE"
        ];
        var startContainer = this.range.startContainer;
        var startOffset = this.range.startOffset;
        var isCursorAtEnd = this.range.collapsed && startContainer.nodeType === 1 && startContainer.isContentEditable && startContainer.childNodes[startOffset - 1] && customHandlerElements.indexOf(startContainer.childNodes[startOffset - 1].nodeName) > -1;
        if (isCursorAtEnd) return {
            end: isCursorAtEnd,
            endNodeName: startContainer.childNodes[startOffset - 1].nodeName
        };
        else return {
            end: false,
            endNodeName: ""
        };
    };
    EnterKeyAction.prototype.processedTableImageCursor = function() {
        var _a = this.isTableOrImageStart(), start = _a.start, startNodeName = _a.startNodeName;
        var _b = this.isTableOrImageEnd(), end = _b.end, endNodeName = _b.endNodeName;
        return {
            start: start,
            startName: startNodeName,
            end: end,
            endName: endNodeName
        };
    };
    return EnterKeyAction;
}();





parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $3EnZW = parcelRequire("3EnZW");

/**
 * Dialog Renderer
 */ var $3b7a703992ffcdd8$export$e25f482e9985501c = /** @class */ function() {
    function DialogRenderer(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    DialogRenderer.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
        this.parent.on($947a002e9a697770$export$4895f32c534ef936, this.documentClickClosedBy, this);
    };
    DialogRenderer.prototype.removeEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
        this.parent.off($947a002e9a697770$export$4895f32c534ef936, this.documentClickClosedBy);
    };
    /**
     * dialog render method
     *
     * @param {DialogModel} e - specifies the dialog model.
     * @returns {void}
     * @hidden

     */ DialogRenderer.prototype.render = function(e) {
        var dlgObj;
        e.beforeOpen = this.beforeOpen.bind(this);
        e.open = this.open.bind(this);
        e.position = {
            X: "center",
            Y: e.target !== "string" && e.target.nodeName === "BODY" && !(0, $3EnZW.isNullOrUndefined)(e.position) ? e.position.Y : this.getDialogPosition()
        };
        if ((0, $3EnZW.isNullOrUndefined)(e.close)) e.close = this.close.bind(this);
        e.beforeClose = this.beforeClose.bind(this);
        // eslint-disable-next-line
        dlgObj = new (0, $397c948d4a376450$export$3ddf2d174ce01153)(e);
        dlgObj.isStringTemplate = true;
        return dlgObj;
    };
    DialogRenderer.prototype.beforeOpen = function(args) {
        if (args.element.classList.contains("e-dialog")) {
            var formEle = (0, $4ZDHT.closest)(args.target, "form");
            if (!(0, $3EnZW.isNullOrUndefined)(formEle)) {
                this.dialogEle = args.element;
                this.dialogEle.addEventListener("keydown", this.handleEnterKeyDown);
            }
        }
        this.parent.trigger($947a002e9a697770$export$9d4d8791559c7809, args, this.beforeOpenCallback.bind(this, args));
    };
    DialogRenderer.prototype.handleEnterKeyDown = function(args) {
        if (args.key === "Enter") args.preventDefault();
    };
    DialogRenderer.prototype.beforeOpenCallback = function(args) {
        if (args.cancel) this.parent.notify($947a002e9a697770$export$7b0b04da5bd57800, null);
    };
    DialogRenderer.prototype.open = function(args) {
        this.parent.trigger($947a002e9a697770$export$a85fefe9f9398bfb, args);
    };
    DialogRenderer.prototype.documentClickClosedBy = function(args) {
        this.outsideClickClosedBy = args.closedBy;
    };
    DialogRenderer.prototype.beforeClose = function(args) {
        if (this.dialogEle) this.dialogEle.removeEventListener("keydown", this.handleEnterKeyDown);
        args.closedBy = this.outsideClickClosedBy === "outside click" ? this.outsideClickClosedBy : args.closedBy;
        this.parent.trigger($947a002e9a697770$export$ff4b54f54b38aea1, args, function(closeArgs) {
            if (!closeArgs.cancel) {
                if (closeArgs.container.classList.contains("e-popup-close")) closeArgs.cancel = true;
            }
        });
        this.outsideClickClosedBy = "";
    };
    DialogRenderer.prototype.getDialogPosition = function() {
        var distanceFromVisibleTop = this.parent.element.getBoundingClientRect().top;
        if (distanceFromVisibleTop < 0) {
            var topHeight = 0;
            var parentElement = this.parent.element;
            while(parentElement.nodeName !== "BODY"){
                var top_1 = parentElement.getBoundingClientRect().top;
                if (top_1 > 0) topHeight = top_1;
                parentElement = parentElement.parentElement;
            }
            distanceFromVisibleTop = Math.abs(distanceFromVisibleTop) + topHeight;
            return distanceFromVisibleTop.toString();
        } else return "top";
    };
    /**
     * dialog close method
     *
     * @param {Object} args - specifies the arguments.
     * @returns {void}
     * @hidden

     */ DialogRenderer.prototype.close = function(args) {
        this.parent.trigger($947a002e9a697770$export$910a35e3fa4f9af, args);
    };
    return DialogRenderer;
}();


parcelRequire("j7YE8");
var $3fcxu = parcelRequire("3fcxu");
var $5rsSz = parcelRequire("5rsSz");

var $bd764ca55277e1f8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bd764ca55277e1f8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Configures the slash menu settings of the RichTextEditor.
 */ var $bd764ca55277e1f8$export$2eff5ca7ec2411e = /** @class */ function(_super) {
    $bd764ca55277e1f8$var$__extends(SlashMenuSettings, _super);
    function SlashMenuSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    $bd764ca55277e1f8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], SlashMenuSettings.prototype, "enable", void 0);
    $bd764ca55277e1f8$var$__decorate([
        (0, $5rsSz.Property)([
            "Paragraph",
            "Heading 1",
            "Heading 2",
            "Heading 3",
            "Heading 4",
            "OrderedList",
            "UnorderedList",
            "CodeBlock",
            "Blockquote"
        ])
    ], SlashMenuSettings.prototype, "items", void 0);
    $bd764ca55277e1f8$var$__decorate([
        (0, $5rsSz.Property)("300px")
    ], SlashMenuSettings.prototype, "popupWidth", void 0);
    $bd764ca55277e1f8$var$__decorate([
        (0, $5rsSz.Property)("320px")
    ], SlashMenuSettings.prototype, "popupHeight", void 0);
    return SlashMenuSettings;
}((0, $3fcxu.ChildProperty));
var $bd764ca55277e1f8$export$730056d8a6c8b5e6 = [
    {
        command: "Paragraph",
        subCommand: "p",
        type: "Basic Block",
        iconCss: "e-rte-paragraph"
    },
    {
        command: "Heading 1",
        subCommand: "h1",
        type: "Basic Block",
        iconCss: "e-rte-h1"
    },
    {
        command: "Heading 2",
        subCommand: "h2",
        type: "Basic Block",
        iconCss: "e-rte-h2"
    },
    {
        command: "Heading 3",
        subCommand: "h3",
        type: "Basic Block",
        iconCss: "e-rte-h3"
    },
    {
        command: "Heading 4",
        subCommand: "h4",
        type: "Basic Block",
        iconCss: "e-rte-h4"
    },
    {
        command: "OrderedList",
        subCommand: "insertOrderedList",
        type: "Basic Block",
        iconCss: "e-list-ordered e-icons"
    },
    {
        command: "UnorderedList",
        subCommand: "insertUnorderedList",
        type: "Basic Block",
        iconCss: "e-list-unordered e-icons"
    },
    {
        command: "Blockquote",
        subCommand: "blockquote",
        type: "Basic Block",
        iconCss: "e-blockquote e-icons"
    },
    {
        command: "CodeBlock",
        subCommand: "pre",
        type: "Basic Block",
        iconCss: "e-code-view e-icons"
    }
];
var $bd764ca55277e1f8$export$b26e7d98f8aebb9f = [
    {
        command: "Image",
        subCommand: (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertImage,
        type: "Media",
        module: "Image",
        iconCss: "e-icons e-image"
    },
    {
        command: "Audio",
        subCommand: (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertAudio,
        type: "Media",
        module: "Audio",
        iconCss: "e-icons e-audio"
    },
    {
        command: "Video",
        subCommand: (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertVideo,
        type: "Media",
        module: "Video",
        iconCss: "e-icons e-video"
    },
    {
        command: "Link",
        subCommand: (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertLink,
        type: "Inline",
        module: "Link",
        iconCss: "e-icons e-link"
    },
    {
        command: "Table",
        subCommand: (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertTable,
        type: "Basic Block",
        module: "Table",
        iconCss: "e-icons e-table"
    },
    {
        command: "Emojipicker",
        subCommand: null,
        type: "Inline",
        module: "EmojiPicker",
        iconCss: "e-icons e-emoji"
    }
];



var $95445997b68090e8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $95445997b68090e8$var$__assign = undefined && undefined.__assign || function() {
    $95445997b68090e8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95445997b68090e8$var$__assign.apply(this, arguments);
};
var $95445997b68090e8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Represents the Rich Text Editor component.
 * ```html
 * <textarea id="rte"></textarea>
 * <script>
 *  var rteObj = new RichTextEditor();
 *  rteObj.appendTo("#rte");
 * </script>
 * ```
 */ var $95445997b68090e8$export$a4ff4468fa943a6c = /** @class */ function(_super) {
    $95445997b68090e8$var$__extends(RichTextEditor, _super);
    function RichTextEditor(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.needsID = true;
        _this.isCopyAll = false;
        return _this;
    }
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} - specifies the declaration.
     * @hidden

     */ RichTextEditor.prototype.requiredModules = function() {
        var modules = [];
        if (this.toolbarSettings.enable) {
            modules.push({
                member: "toolbar",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "link",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "table",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "image",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "audio",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "video",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            if (this.quickToolbarSettings.enable) modules.push({
                member: "quickToolbar",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
        }
        if (this.editorMode === "HTML" && this.slashMenuSettings.enable) modules.push({
            member: "slashMenu",
            args: [
                this,
                this.serviceLocator
            ]
        });
        if (this.showCharCount) modules.push({
            member: "count",
            args: [
                this,
                this.serviceLocator
            ]
        });
        if (this.editorMode === "Markdown") modules.push({
            member: "markdownEditor",
            args: [
                this,
                this.serviceLocator
            ]
        });
        if (this.editorMode === "HTML") {
            modules.push({
                member: "htmlEditor",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "pasteCleanup",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "importExport",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
            modules.push({
                member: "formatPainter",
                args: [
                    this
                ]
            });
            modules.push({
                member: "emojiPicker",
                args: [
                    this,
                    this.serviceLocator
                ]
            });
        }
        if (this.fileManagerSettings.enable) modules.push({
            member: "fileManager",
            args: [
                this,
                this.serviceLocator
            ]
        });
        if (this.enableResize) modules.push({
            member: "resize",
            args: [
                this
            ]
        });
        return modules;
    };
    RichTextEditor.prototype.updateEnable = function() {
        if (this.enabled) {
            (0, $4ZDHT.removeClass)([
                this.element
            ], $afc560df281b588d$export$a0040262df92c03);
            this.element.setAttribute("aria-disabled", "false");
            if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes.tabindex)) this.inputElement.setAttribute("tabindex", this.htmlAttributes.tabindex);
            else this.inputElement.setAttribute("tabindex", "0");
        } else {
            if (this.getToolbar()) {
                (0, $4ZDHT.removeClass)(this.getToolbar().querySelectorAll("." + $afc560df281b588d$export$79952d4ba2101dd4), $afc560df281b588d$export$79952d4ba2101dd4);
                (0, $4ZDHT.removeClass)([
                    this.getToolbar().parentElement
                ], [
                    $afc560df281b588d$export$b46c3eca2c4f8c25
                ]);
            }
            (0, $4ZDHT.addClass)([
                this.element
            ], $afc560df281b588d$export$a0040262df92c03);
            this.element.tabIndex = -1;
            this.element.setAttribute("aria-disabled", "true");
            this.inputElement.setAttribute("tabindex", "-1");
        }
    };
    /**
     * setEnable method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.setEnable = function() {
        this.updateEnable();
        // eslint-disable-next-line
        this.enabled ? this.eventInitializer() : this.unWireEvents();
    };
    RichTextEditor.prototype.initializeValue = function() {
        this.isFocusOut = false;
        this.isRTE = false;
        this.isBlur = true;
        this.defaultResetValue = null;
        this.isResizeInitialized = false;
    };
    /**
     * For internal use only - Initialize the event handler;
     *
     * @returns {void}
     * @hidden
     * @private
     */ RichTextEditor.prototype.preRender = function() {
        this.initializeValue();
        this.clickPoints = {
            clientX: 0,
            clientY: 0
        };
        this.initialValue = this.value;
        this.serviceLocator = new (0, $3541fddf96aaed2a$export$6cd6e3ed1512e78f);
        this.initializeServices();
        this.setContainer();
        this.persistData();
        (0, $4ZDHT.setStyleAttribute)(this.element, {
            "width": (0, $3EnZW.formatUnit)(this.width)
        });
        (0, $4ZDHT.attributes)(this.element, {
            role: "application",
            "aria-label": "Rich Text Editor"
        });
        this.beforeRenderClassValue = this.element.getAttribute("class");
    };
    RichTextEditor.prototype.persistData = function() {
        if (this.enablePersistence && this.originalElement.tagName === "TEXTAREA") {
            this.element.id = this.originalElement.id + "_wrapper";
            var data = window.localStorage.getItem(this.getModuleName() + this.element.id);
            if (!((0, $3EnZW.isNullOrUndefined)(data) || data === "")) this.setProperties(JSON.parse(data), true);
        }
    };
    RichTextEditor.prototype.setContainer = function() {
        this.originalElement = this.element.cloneNode(true);
        if (this.value === null || this.valueTemplate !== null) this.setValue();
        if (this.element.hasAttribute("tabindex")) {
            this.htmlAttributes = {
                "tabindex": this.element.getAttribute("tabindex")
            };
            this.element.removeAttribute("tabindex");
        }
        this.element.innerHTML = "";
        var invalidAttr = [
            "class",
            "style",
            "id",
            "ejs-for"
        ];
        var htmlAttr = {};
        for(var a = 0; a < this.element.attributes.length; a++)if (invalidAttr.indexOf(this.element.attributes[a].name) === -1 && !/^data-val/.test(this.element.attributes[a].name)) htmlAttr[this.element.attributes[a].name] = this.element.getAttribute(this.element.attributes[a].name);
        (0, $3EnZW.extend)(htmlAttr, this.htmlAttributes, htmlAttr);
        this.setProperties({
            htmlAttributes: htmlAttr
        }, true);
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes.id)) this.element.id = this.htmlAttributes.id;
        this.internalID = this.element.id;
        if (this.element.tagName === "TEXTAREA") {
            var rteOuterWrapper = this.createElement("div", {
                className: this.element.getAttribute("class")
            });
            this.element.innerHTML = "";
            this.element.parentElement.insertBefore(rteOuterWrapper, this.element);
            this.valueContainer = this.element;
            (0, $4ZDHT.removeClass)([
                this.valueContainer
            ], this.element.getAttribute("class").split(" "));
            this.element = rteOuterWrapper;
        } else this.valueContainer = this.createElement("textarea", {
            id: this.getID() + "-value",
            attrs: {
                "aria-labelledby": this.getID()
            }
        });
        this.valueContainer.name = this.getID();
        (0, $4ZDHT.addClass)([
            this.valueContainer
        ], $afc560df281b588d$export$c7f23d620ab4e862);
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) {
            var currentClassList = this.cssClass.split(" ");
            for(var i = 0; i < currentClassList.length; i++)(0, $4ZDHT.addClass)([
                this.valueContainer
            ], currentClassList[i]);
        }
        this.rootContainer = this.createElement("div", {
            className: $afc560df281b588d$export$b8cca86ae4c54cb3,
            attrs: {
                "role": "presentation"
            }
        });
        this.element.appendChild(this.rootContainer);
        this.rootContainer.appendChild(this.valueContainer);
    };
    /**
     * getPersistData method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getPersistData = function() {
        return this.addOnPersist([
            "value"
        ]);
    };
    /**
     * Focuses the Rich Text Editor component
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.focusIn = function() {
        if (this.enabled) {
            this.inputElement.focus();
            this.focusHandler({});
        }
    };
    /**
     * Blurs the Rich Text Editor component
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.focusOut = function() {
        if (this.enabled) {
            this.inputElement.blur();
            this.blurHandler({});
        }
    };
    /**
     * Selects all the content in RichTextEditor
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.selectAll = function() {
        this.notify($947a002e9a697770$export$90aca4adda6ff0f5, {});
    };
    /**
     * Selects a content range or an element
     *
     * @param {Range} range - Specify the range which you want to select within the content.
     * The method used to select a particular sentence or word or entire document.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.selectRange = function(range) {
        this.notify($947a002e9a697770$export$86be68e1224a0620, {
            range: range
        });
    };
    /**
     * Retrieves the HTML markup content from currently selected content of RichTextEditor.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.getSelection = function() {
        var str = "";
        this.notify($947a002e9a697770$export$76d3c88e0e217d4e, {
            callBack: function(txt) {
                str = txt;
            }
        });
        return str;
    };
    /**
     * Shows the emoji picker
     *
     * @param {number} x - specifies the number value.
     * @param {number} y - specifies the number value.
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.showEmojiPicker = function(x, y) {
        if (this.readonly) return;
        this.notify($947a002e9a697770$export$4d7e4d3283b3fc57, {
            x: x,
            y: y
        });
    };
    /**
     * Executes the commands
     *
     * @returns {void}
     * @param {CommandName} commandName - Specifies the name of the command to be executed.
     * @param {string | HTMLElement | ILinkCommandsArgs | IImageCommandsArgs} value - Specifies the value that you want to execute.
     * @param {ExecuteCommandOption} option - specifies the command option
     * @public
     */ RichTextEditor.prototype.executeCommand = function(commandName, value, option) {
        value = this.htmlPurifier(commandName, value);
        var internalValue;
        if (this.editorMode === "HTML") {
            var range = this.getRange();
            if (this.iframeSettings.enable) this.formatter.editorManager.nodeSelection.Clear(this.element.ownerDocument);
            var toFocus = this.iframeSettings.enable && range.startContainer === this.inputElement ? true : !this.inputElement.contains(range.startContainer);
            if (toFocus) this.focusIn();
        }
        var tool = (0, $2101ab4b6e103e48$export$bdee5ee1ac50b0db)["" + commandName];
        if (option && option.undo) {
            if (option.undo && this.formatter.getUndoRedoStack().length === 0) this.formatter.saveData();
        }
        if (this.maxLength !== -1 && !(0, $3EnZW.isNullOrUndefined)(tool.command)) {
            var currentInsertContentLength = 0;
            if (tool.command === "Links") currentInsertContentLength = value.text.length === 0 ? value.url.length : value.text.length;
            if (tool.command === "Images" || tool.command === "Table" || tool.command === "Files") currentInsertContentLength = 1;
            if (tool.command === "InsertHTML") {
                if (!(0, $3EnZW.isNullOrUndefined)(value)) {
                    var tempElem = this.createElement("div");
                    tempElem.innerHTML = value;
                    currentInsertContentLength = tempElem.textContent.length;
                } else if (!(0, $3EnZW.isNullOrUndefined)(tool.value) && (tool.value === "<hr/>" || tool.value === "<br/>")) currentInsertContentLength = 1;
            }
            if (tool.command === "InsertText") currentInsertContentLength = value.length;
            var currentLength = this.getText().trim().replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "").length;
            var selectionLength = this.getSelection().length;
            var totalLength = currentLength - selectionLength + currentInsertContentLength;
            if (!(this.maxLength === -1 || totalLength <= this.maxLength)) return;
        }
        internalValue = value;
        if (tool.command === "FormatPainter") {
            if (!(0, $3EnZW.isNullOrUndefined)(value)) this.formatPainterSettings = value;
            internalValue = {
                formatPainterAction: tool.value
            };
        }
        this.formatter.editorManager.execCommand(tool.command, tool.subCommand ? tool.subCommand : internalValue ? internalValue : tool.value, null, null, internalValue ? internalValue : tool.value, internalValue ? internalValue : tool.value === "UL" || tool.value === "OL" ? null : tool.value, null, this.enterKey);
        if (option && option.undo) {
            this.formatter.saveData();
            this.formatter.enableUndo(this);
        }
        this.setPlaceHolder();
        this.notify($947a002e9a697770$export$a2ef9682a059097c, {});
    };
    RichTextEditor.prototype.htmlPurifier = function(command, value) {
        if (this.editorMode === "HTML") switch(command){
            case "insertHTML":
                if (this.enableHtmlSanitizer) {
                    if (typeof value === "string") value = this.htmlEditorModule.sanitizeHelper(value);
                    else value = this.htmlEditorModule.sanitizeHelper(value.outerHTML);
                }
                break;
            case "insertTable":
                if ((0, $3EnZW.isNullOrUndefined)(value.width)) value.width = {
                    minWidth: this.tableSettings.minWidth,
                    maxWidth: this.tableSettings.maxWidth,
                    width: this.tableSettings.width
                };
                break;
            case "insertImage":
                var temp = this.createElement("img", {
                    attrs: {
                        src: value.url
                    }
                });
                var imageValue = temp.outerHTML;
                if (this.enableHtmlSanitizer) imageValue = this.htmlEditorModule.sanitizeHelper(temp.outerHTML);
                var url = imageValue !== "" && this.createElement("div", {
                    innerHTML: imageValue
                }).firstElementChild.getAttribute("src") || null;
                url = !(0, $3EnZW.isNullOrUndefined)(url) ? url : "";
                value.url = url;
                if ((0, $3EnZW.isNullOrUndefined)(value.width)) value.width = {
                    minWidth: this.insertImageSettings.minWidth,
                    maxWidth: this.insertImageSettings.maxWidth,
                    width: this.insertImageSettings.width
                };
                if ((0, $3EnZW.isNullOrUndefined)(value.height)) value.height = {
                    minHeight: this.insertImageSettings.minHeight,
                    maxHeight: this.insertImageSettings.maxHeight,
                    height: this.insertImageSettings.height
                };
                break;
            case "insertAudio":
                var wrapTemp = this.createElement("audio", {
                    attrs: {
                        controls: ""
                    }
                });
                var temp = this.createElement("source", {
                    attrs: {
                        src: value.url,
                        type: value.url && value.url.split(".").length > 0 ? "audio/" + value.url.split(".")[value.url.split(".").length - 1] : ""
                    }
                });
                wrapTemp.appendChild(temp);
                var audioValue = wrapTemp.outerHTML;
                if (this.enableHtmlSanitizer) audioValue = this.htmlEditorModule.sanitizeHelper(wrapTemp.outerHTML);
                var url = audioValue !== "" && this.createElement("div", {
                    innerHTML: audioValue
                }).firstElementChild.firstElementChild.getAttribute("src") || null;
                url = !(0, $3EnZW.isNullOrUndefined)(url) ? url : "";
                value.url = url;
                break;
            case "insertVideo":
                var wrapTemp = this.createElement("video", {
                    attrs: {
                        controls: ""
                    }
                });
                var temp = this.createElement("source", {
                    attrs: {
                        src: value.url,
                        type: value.url && value.url.split(".").length > 0 ? "video/" + value.url.split(".")[value.url.split(".").length - 1] : ""
                    }
                });
                wrapTemp.appendChild(temp);
                var audioValue = wrapTemp.outerHTML;
                if (this.enableHtmlSanitizer) audioValue = this.htmlEditorModule.sanitizeHelper(temp.outerHTML);
                var url = audioValue !== "" && this.createElement("div", {
                    innerHTML: audioValue
                }).firstElementChild.getAttribute("src") || null;
                url = !(0, $3EnZW.isNullOrUndefined)(url) ? url : "";
                value.url = url;
                if ((0, $3EnZW.isNullOrUndefined)(value.width)) value.width = {
                    minWidth: this.insertVideoSettings.minWidth,
                    maxWidth: this.insertVideoSettings.maxWidth,
                    width: this.insertVideoSettings.width
                };
                if ((0, $3EnZW.isNullOrUndefined)(value.height)) value.height = {
                    minHeight: this.insertVideoSettings.minHeight,
                    maxHeight: this.insertVideoSettings.maxHeight,
                    height: this.insertVideoSettings.height
                };
                break;
            case "createLink":
                var tempNode = this.createElement("a", {
                    attrs: {
                        href: value.url
                    }
                });
                var linkValue = tempNode.outerHTML;
                if (this.enableHtmlSanitizer) linkValue = this.htmlEditorModule.sanitizeHelper(tempNode.outerHTML);
                var href = linkValue !== "" && this.createElement("div", {
                    innerHTML: linkValue
                }).firstElementChild.getAttribute("href") || null;
                href = !(0, $3EnZW.isNullOrUndefined)(href) ? href : "";
                value.url = href;
                break;
        }
        return value;
    };
    RichTextEditor.prototype.encode = function(value) {
        var divNode = this.createElement("div");
        divNode.innerText = value.trim();
        // eslint-disable-next-line
        return divNode.innerHTML.replace(/<br\s*[\/]?>/gi, "\n");
    };
    /**
     * For internal use only - To Initialize the component rendering.
     *
     * @returns {void}
     * @private

     */ RichTextEditor.prototype.render = function() {
        if (this.value && !this.valueTemplate) this.setProperties({
            value: this.serializeValue(this.value)
        }, true);
        this.value = !(this.editorMode === "Markdown") && !(0, $3EnZW.isNullOrUndefined)(this.value) ? this.addAnchorAriaLabel(this.value) : this.value;
        this.renderModule = new (0, $1c277ea27e0edf4d$export$160ae30d75f98247)(this, this.serviceLocator);
        this.sourceCodeModule = new (0, $d18d9556bd921af3$export$530d090221814d61)(this, this.serviceLocator);
        this.notify($947a002e9a697770$export$b70fe0c8c3456154, {});
        this.trigger($947a002e9a697770$export$11e63f7b0f3d9900);
        this.RTERender();
        // eslint-disable-next-line
        var execCommandCallBack = new (0, $13c0c2954f6df2de$export$4876194f410226b3)(this);
        this.notify($947a002e9a697770$export$5d4840440f592fca, {});
        if (this.enableXhtml) this.setProperties({
            value: this.getXhtml()
        }, true);
        if (this.toolbarSettings.enable && (this.toolbarSettings.type === "Expand" || this.toolbarSettings.type === "MultiRow" || this.toolbarSettings.type === "Scrollable") && !(0, $3EnZW.isNullOrUndefined)(this.getToolbar()) && this.toolbarSettings.items.indexOf("Undo") > -1 && this.toolbarSettings.items.indexOf("Redo") > -1) this.disableToolbarItem([
            "Undo",
            "Redo"
        ]);
        if (this.value !== null) this.valueContainer.defaultValue = this.value;
        // eslint-disable-next-line
        this.enabled && !this.readonly ? this.eventInitializer() : this.unWireEvents();
        this.notify($947a002e9a697770$export$3195fd95fc6395d5, {
            cssClass: this.getCssClass()
        });
        this.addAudioVideoWrapper();
        this.notify($947a002e9a697770$export$5dbeb4561f6544b7, {});
        this.autoResize();
        this.renderComplete();
    };
    /**
     * addAudioVideoWrapper method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.addAudioVideoWrapper = function() {
        var _this = this;
        var insertElem;
        var audioElm = this.element.querySelectorAll("audio");
        for(var i = 0; i < audioElm.length; i++){
            if (!audioElm[i].classList.contains("e-rte-audio")) {
                audioElm[i].classList.add("e-rte-audio");
                audioElm[i].classList.add($afc560df281b588d$export$aa04ae99872a701a);
            }
            // eslint-disable-next-line max-len
            if (!audioElm[i].parentElement.classList.contains($afc560df281b588d$export$a13f0f97539de275) && !audioElm[i].parentElement.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9)) {
                var audioWrapElem = this.createElement("span", {
                    className: $afc560df281b588d$export$89572e2cf0e0f6e9
                });
                audioWrapElem.setAttribute("style", "width:300px; margin:0 auto;");
                audioWrapElem.contentEditable = "false";
                var audioInnerWrapElem = this.createElement("span", {
                    className: $afc560df281b588d$export$a13f0f97539de275
                });
                audioWrapElem.appendChild(audioInnerWrapElem);
                audioElm[i].parentNode.insertBefore(audioWrapElem, audioElm[i].nextSibling);
                audioInnerWrapElem.appendChild(audioElm[i]);
                if (audioWrapElem.nextElementSibling === null) {
                    insertElem = this.createElement("br");
                    audioWrapElem.parentNode.insertBefore(insertElem, audioWrapElem.nextSibling);
                }
            }
        }
        var videoElm = this.element.querySelectorAll("video");
        for(var i = 0; i < videoElm.length; i++){
            if (!videoElm[i].classList.contains("e-rte-video")) {
                videoElm[i].classList.add("e-rte-video");
                videoElm[i].classList.add($afc560df281b588d$export$3137cd114e7b0358);
            }
            // eslint-disable-next-line max-len
            if (!videoElm[i].parentElement.classList.contains($afc560df281b588d$export$a13f0f97539de275) && !videoElm[i].parentElement.classList.contains($afc560df281b588d$export$fea5ac7fbfdd17f0)) {
                var videoWrapElem = this.createElement("span", {
                    className: $afc560df281b588d$export$fea5ac7fbfdd17f0
                });
                videoWrapElem.contentEditable = "false";
                videoElm[i].parentNode.insertBefore(videoWrapElem, videoElm[i].nextSibling);
                videoWrapElem.appendChild(videoElm[i]);
                if (videoWrapElem.nextElementSibling === null) {
                    insertElem = this.createElement("br");
                    videoWrapElem.parentNode.insertBefore(insertElem, videoWrapElem.nextSibling);
                }
            }
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1) {
                // eslint-disable-next-line
                videoElm[i].addEventListener("play", function(args) {
                    _this.notify($947a002e9a697770$export$ea32a7693b83cfdb, {
                        args: args
                    });
                    _this.notify("editAreaClick", {
                        args: args
                    });
                });
                // eslint-disable-next-line
                videoElm[i].addEventListener("pause", function(args) {
                    _this.notify($947a002e9a697770$export$ea32a7693b83cfdb, {
                        args: args
                    });
                    _this.notify("editAreaClick", {
                        args: args
                    });
                });
            }
        }
    };
    /**
     * For internal use only - Initialize the event handler
     *
     * @returns {void}
     * @private

     * @hidden
     */ RichTextEditor.prototype.eventInitializer = function() {
        this.wireEvents();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RichTextEditor.prototype.cleanList = function(e) {
        var range = this.getRange();
        var currentStartContainer = range.startContainer;
        var currentEndContainer = range.endContainer;
        var currentStartOffset = range.startOffset;
        var isSameContainer = currentStartContainer === currentEndContainer ? true : false;
        // eslint-disable-next-line
        var currentEndOffset = currentEndContainer.textContent.length;
        var endNode = range.endContainer.nodeName === "#text" ? range.endContainer.parentElement : range.endContainer;
        var closestLI = (0, $4ZDHT.closest)(endNode, "LI");
        var isDetached = false;
        var currentRangeEndOffset = range.endOffset;
        if (currentEndContainer.nodeType === Node.TEXT_NODE) {
            if (currentEndContainer.textContent.charAt(currentRangeEndOffset - 1) === "\uFEFF") currentRangeEndOffset--;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(closestLI) && endNode.textContent.trim().length === currentRangeEndOffset && !range.collapsed && (0, $3EnZW.isNullOrUndefined)(endNode.nextElementSibling)) {
            for(var i = 0; i < closestLI.childNodes.length; i++)if (closestLI.childNodes[i].nodeName === "#text" && closestLI.childNodes[i].textContent.trim().length === 0) {
                (0, $4ZDHT.detach)(closestLI.childNodes[i]);
                isDetached = true;
                i--;
            }
            var currentLastElem = closestLI;
            while(currentLastElem.lastChild !== null && currentLastElem.nodeName !== "#text")currentLastElem = currentLastElem.lastChild;
            if (isDetached) {
                var currentLast = currentLastElem.nodeName === "BR" && !(0, $3EnZW.isNullOrUndefined)(currentLastElem.previousSibling) ? currentLastElem.previousSibling : currentLastElem;
                this.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), isSameContainer ? currentLast : currentStartContainer, currentLast, currentStartOffset, currentLast.nodeName === "BR" ? 0 : currentLast.textContent.length);
            }
        }
    };
    /**
     * For internal use only - keydown the event handler;
     *
     * @param {KeyboardEvent} e - specifies the event.
     * @returns {void}
     * @private

     * @hidden
     */ RichTextEditor.prototype.keyDown = function(e) {
        if (this.inputElement.classList.contains("e-mention")) {
            var mentionPopup = this.inputElement.ownerDocument.getElementById(this.inputElement.id + "_popup");
            var slashMenuPopup = this.inputElement.ownerDocument.getElementById(this.inputElement.id + "_slash_menu_popup");
            var mentionKeys = (0, $9dc0015271a44eb1$export$edf0c42e7cc84b69);
            var isMentionKeys = mentionKeys.indexOf(e.key) !== -1;
            var isMentionPopupOpen = mentionPopup && mentionPopup.classList.contains("e-popup-open");
            var isSlashMenuPopupOpen = slashMenuPopup && slashMenuPopup.classList.contains("e-popup-open");
            if (isMentionKeys && (isMentionPopupOpen || isSlashMenuPopupOpen)) return;
        }
        this.notify($947a002e9a697770$export$d081dc64f99d208b, {
            member: "keydown",
            args: e
        });
        this.restrict(e);
        if (this.editorMode === "HTML") this.cleanList(e);
        if (this.editorMode === "HTML" && (e.which === 8 && e.code === "Backspace" || e.which === 46 && e.code === "Delete")) {
            var range = this.getRange();
            var startNode = range.startContainer.nodeName === "#text" ? range.startContainer.parentElement : range.startContainer;
            if ((0, $4ZDHT.closest)(startNode, "pre") && e.which === 8 && range.startContainer.textContent.charCodeAt(range.startOffset - 1) === 8203 || e.which === 46 && range.startContainer.textContent.charCodeAt(range.startOffset) === 8203) {
                var regEx = new RegExp("\u200B", "g");
                var pointer = e.which === 8 ? range.startOffset - 1 : range.startOffset;
                range.startContainer.textContent = range.startContainer.textContent.replace(regEx, "");
                this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), range.startContainer, pointer);
            } else if (e.code === "Backspace" && e.which === 8 && range.startContainer.textContent.charCodeAt(0) === 8203 && range.collapsed) {
                var parentEle = range.startContainer.parentElement;
                var index = void 0;
                var i = void 0;
                for(i = 0; i < parentEle.childNodes.length; i++)if (parentEle.childNodes[i] === range.startContainer) index = i;
                var bool = true;
                var removeNodeArray = [];
                for(i = index; i >= 0; i--)// eslint-disable-next-line max-len
                if (parentEle.childNodes[i].nodeType === 3 && parentEle.childNodes[i].textContent.charCodeAt(0) === 8203 && bool) removeNodeArray.push(i);
                else bool = false;
                if (removeNodeArray.length > 0) for(i = removeNodeArray.length - 1; i > 0; i--)parentEle.childNodes[removeNodeArray[i]].textContent = "";
                this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), range.startContainer, range.startOffset);
            }
        }
        var notFormatPainterCopy = (0, $3EnZW.isNullOrUndefined)(e.action) ? true : e.action !== "format-copy" ? true : false;
        if (this.formatter.getUndoRedoStack().length === 0 && notFormatPainterCopy && !(e.altKey || e.shiftKey || e.altKey && e.shiftKey && e.which === 67)) this.formatter.saveData();
        var preventingMention = false;
        if (this.editorMode === "HTML") {
            var range = this.getRange();
            preventingMention = !(0, $3EnZW.isNullOrUndefined)(range.startContainer) && range.startContainer === range.endContainer && range.endContainer.childNodes.length > 1 && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset - 1]) && range.startContainer.childNodes[range.startOffset - 1].nodeName === "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset - 1].previousSibling) && range.startContainer.childNodes[range.startOffset - 1].textContent.charCodeAt(0) === 32 && range.startContainer.childNodes[range.startOffset - 1].previousSibling.classList.contains("e-mention-chip");
        }
        var keyboardEventAction = [
            "insert-link",
            "format-copy",
            "format-paste",
            "insert-image",
            "insert-table",
            "insert-audio",
            "insert-video"
        ];
        if (keyboardEventAction.indexOf(e.action) === -1 && (!e.target || !(e.target.classList.contains("e-mention") && !(0, $3EnZW.isNullOrUndefined)(document.querySelector("#" + e.target.id + "_popup.e-popup-open")) && e.code === "Tab")) && (e.action && e.action !== "paste" && e.action !== "space" || e.which === 9 || e.code === "Backspace" && e.which === 8) && !preventingMention) {
            var FormatPainterEscapeAction = false;
            if (!(0, $3EnZW.isNullOrUndefined)(this.formatPainterModule)) FormatPainterEscapeAction = this.formatPainterModule.previousAction === "escape";
            if (!FormatPainterEscapeAction) {
                if (this.editorMode === "HTML" && (e.action === "increase-fontsize" || e.action === "decrease-fontsize")) this.notify($947a002e9a697770$export$6f23f8d8c684bbf3, {
                    member: "onHandleFontsizeChange",
                    args: e
                });
                else this.formatter.process(this, null, e);
            }
            switch(e.action){
                case "toolbar-focus":
                    if (this.toolbarSettings.enable && this.getToolbarElement()) {
                        var firstActiveItem = this.getToolbarElement().querySelector(".e-toolbar-item:not(.e-overlay)[title]");
                        var quickToolbarElem = this.getRenderedQuickToolbarElem();
                        if (quickToolbarElem) firstActiveItem = quickToolbarElem.querySelector(".e-toolbar-item:not(.e-overlay)[title]");
                        if (firstActiveItem) {
                            var firstChild = firstActiveItem.firstElementChild;
                            firstChild.removeAttribute("tabindex");
                            firstChild.focus();
                        }
                    }
                    break;
                case "escape":
                    this.contentModule.getEditPanel().focus();
                    break;
            }
        }
        this.notify($947a002e9a697770$export$a4836fff3a9f5351, {
            member: "afterKeyDown",
            args: e
        });
        this.autoResize();
        if (!(0, $3EnZW.isNullOrUndefined)(this.placeholder)) this.setPlaceHolder();
        if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.code) && (e.code === "Backspace" || e.code === "Delete")) {
            var range = this.contentModule.getDocument().getSelection().getRangeAt(0);
            var div = document.createElement("div");
            div.appendChild(range.cloneContents());
            var selectedHTML = div.innerHTML;
            if (selectedHTML === this.inputElement.innerHTML) this.isCopyAll = true;
        }
    };
    RichTextEditor.prototype.keyUp = function(e) {
        if (this.editorMode === "HTML") {
            var range = this.getRange();
            if (!(0, $3EnZW.isNullOrUndefined)(e) && !(0, $3EnZW.isNullOrUndefined)(e.code) && (e.code === "Backspace" || e.code === "Delete")) {
                // To prevent the reformatting the content removed browser behavior.
                var currentRange = this.getRange();
                var selection = this.iframeSettings.enable ? this.contentModule.getPanel().ownerDocument.getSelection() : this.contentModule.getDocument().getSelection();
                if (this.isCopyAll) {
                    this.inputElement.innerHTML = this.enterKey !== "BR" ? "<" + this.enterKey + "><br></" + this.enterKey + ">" : "<br>";
                    this.isCopyAll = false;
                }
                if (selection.rangeCount > 0 && this.contentModule.getDocument().activeElement.tagName !== "INPUT" && this.inputElement.contains(this.contentModule.getDocument().activeElement) && range.startContainer.innerHTML === "<br>" && range.startContainer.textContent === "") {
                    selection.removeAllRanges();
                    selection.addRange(currentRange);
                }
            }
            if ((0, $5q7BP.Browser).userAgent.indexOf("Firefox") !== -1 && range.startContainer.nodeName === "#text" && range.startContainer.parentElement === this.inputElement && this.enterKey !== "BR") {
                var range_1 = this.getRange();
                var tempElem = this.createElement(this.enterKey);
                range_1.startContainer.parentElement.insertBefore(tempElem, range_1.startContainer);
                tempElem.appendChild(range_1.startContainer);
                this.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), tempElem.childNodes[0], tempElem.childNodes[0], tempElem.childNodes[0].textContent.length, tempElem.childNodes[0].textContent.length);
            }
        }
        this.notify($947a002e9a697770$export$2bfa26ed2a709c52, {
            member: "keyup",
            args: e
        });
        this.notify($947a002e9a697770$export$9e83668a3bc32ff2, {
            member: "tableModulekeyUp",
            args: e
        });
        if (e.code === "KeyX" && e.which === 88 && e.keyCode === 88 && e.ctrlKey && (this.inputElement.innerHTML === "" || this.inputElement.innerHTML === "<br>")) this.inputElement.innerHTML = (0, $c77ecbfae9b8c035$export$4649c1610e50ca8d)((0, $c77ecbfae9b8c035$export$9f15c5f175f17548)(this), this);
        var allowedKeys = e.which === 32 || e.which === 13 || e.which === 8 || e.which === 46;
        var formatPainterCopy = e.key === "C" && e.altKey && e.shiftKey;
        var formatPainterPaste = e.key === "V" && e.altKey && e.shiftKey;
        if (!formatPainterCopy && !formatPainterPaste && (e.key !== "shift" && !e.ctrlKey && e.key && e.key.length === 1 || allowedKeys) || this.editorMode === "Markdown" && (e.key !== "shift" && !e.ctrlKey && e.key && e.key.length === 1 || allowedKeys) || this.autoSaveOnIdle && (0, $5q7BP.Browser).isDevice && !this.inlineMode.enable) this.formatter.onKeyHandler(this, e);
        if (this.inputElement && this.inputElement.textContent.length !== 0 || this.element.querySelectorAll(".e-toolbar-item.e-active").length > 0 || this.formatter.getUndoRedoStack().length > 0) this.notify($947a002e9a697770$export$6a017cfaa3b33c68, {
            args: e
        });
        this.setPlaceHolder();
    };
    /**
     * @param {string} value - specifies the value.
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.serializeValue = function(value) {
        if (this.editorMode === "HTML" && !(0, $3EnZW.isNullOrUndefined)(value)) {
            if (this.enableHtmlEncode) {
                value = this.htmlEditorModule.sanitizeHelper((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(value));
                value = this.encode(value);
            } else {
                value = this.htmlEditorModule.sanitizeHelper(value);
                value = this.enableXhtml ? this.htmlEditorModule.xhtmlValidation.selfEncloseValidation(value) : value;
            }
        }
        return value;
    };
    /**
     * This method will clean up the HTML against cross-site scripting attack and return the HTML as string.
     * It's only applicable to editorMode as `HTML`.
     *
     * @param {string} value - Specifies the value that you want to sanitize.
     * @returns {string} - specifies the the string value
     */ RichTextEditor.prototype.sanitizeHtml = function(value) {
        return this.serializeValue(value);
    };
    /**
     * updateValue method
     *
     * @param {string} value - specifies the string value.
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.updateValue = function(value) {
        if ((0, $3EnZW.isNullOrUndefined)(value)) {
            var inputVal = this.inputElement.innerHTML;
            this.setProperties({
                value: (0, $c77ecbfae9b8c035$export$16ed3812c70f8aa3)(inputVal) ? null : inputVal
            });
        } else this.setProperties({
            value: value
        });
    };
    RichTextEditor.prototype.triggerEditArea = function(e) {
        if (!(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) this.notify($947a002e9a697770$export$faf30c817b12eec0, {
            member: "editAreaClick",
            args: e
        });
        else {
            var touch = e.touches ? e.changedTouches[0] : e;
            if (this.clickPoints.clientX === touch.clientX && this.clickPoints.clientY === touch.clientY) this.notify($947a002e9a697770$export$faf30c817b12eec0, {
                member: "editAreaClick",
                args: e
            });
        }
    };
    RichTextEditor.prototype.notifyMouseUp = function(e) {
        var touch = e.touches ? e.changedTouches[0] : e;
        this.notify($947a002e9a697770$export$9ac49ece09f002f8, {
            member: "mouseUp",
            args: e,
            touchData: {
                prevClientX: this.clickPoints.clientX,
                prevClientY: this.clickPoints.clientY,
                clientX: touch.clientX,
                clientY: touch.clientY
            }
        });
        if (this.inputElement && (this.editorMode === "HTML" && (this.inputElement.textContent.length !== 0 || e.target && !(0, $3EnZW.isNullOrUndefined)(e.target.querySelector("li"))) || this.editorMode === "Markdown" && this.inputElement.value.length !== 0) || e.target && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.target, "table")) || e.target && !(0, $3EnZW.isNullOrUndefined)(e.target.querySelector("img")) || e.target && (e.target.nodeName === "VIDEO" || e.target.querySelectorAll("." + $afc560df281b588d$export$fea5ac7fbfdd17f0).length > 0) || e.target && e.target.nodeName !== "BR" && (e.target.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) || e.target.classList.contains($afc560df281b588d$export$a13f0f97539de275) || e.target.classList.contains($afc560df281b588d$export$8dfb598a1fc054c7))) this.notify($947a002e9a697770$export$6a017cfaa3b33c68, {
            args: e
        });
        this.triggerEditArea(e);
    };
    RichTextEditor.prototype.mouseUp = function(e) {
        if (this.quickToolbarSettings.showOnRightClick && (0, $5q7BP.Browser).isDevice) {
            var target = e.target;
            var closestTable = (0, $4ZDHT.closest)(target, "table");
            if (target && target.nodeName === "A" || target.nodeName === "IMG" || target.nodeName === "TD" || target.nodeName === "TH" || target.nodeName === "TABLE" || closestTable && this.contentModule.getEditPanel().contains(closestTable)) return;
        }
        this.notifyMouseUp(e);
        this.setPlaceHolder();
        this.autoResize();
    };
    /**
     * @param {Function} module - specifies the module function.
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.ensureModuleInjected = function(module) {
        return this.getInjectedModules().indexOf(module) >= 0;
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.onCopy = function() {
        this.contentModule.getDocument().execCommand("copy", false, null);
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.onCut = function() {
        this.contentModule.getDocument().execCommand("cut", false, null);
    };
    /**
     * @param {KeyboardEvent} e - specifies the keyboard event.
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.onPaste = function(e) {
        var _this = this;
        var evenArgs = {
            originalEvent: e,
            cancel: false,
            requestType: "Paste"
        };
        this.trigger($947a002e9a697770$export$df204737a6131aab, evenArgs, function(pasteArgs) {
            var currentLength = _this.getText().replace(/\u200B/g, "").replace(_this.editorMode === "HTML" ? /(\r\n|\n|\r|\t)/gm : "", "").length;
            var selectionLength = _this.getSelection().length;
            var pastedContentLength = (0, $3EnZW.isNullOrUndefined)(e) || (0, $3EnZW.isNullOrUndefined)(e.clipboardData) ? 0 : e.clipboardData.getData("text/plain").replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "").length;
            var totalLength = currentLength - selectionLength + pastedContentLength;
            if (_this.editorMode === "Markdown") {
                var args_1 = {
                    requestType: "Paste",
                    editorMode: _this.editorMode,
                    event: e
                };
                setTimeout(function() {
                    _this.formatter.onSuccess(_this, args_1);
                }, 0);
                if (!(_this.maxLength === -1 || totalLength <= _this.maxLength)) e.preventDefault();
                return;
            }
            if (!pasteArgs.cancel && _this.inputElement.contentEditable === "true" && (_this.maxLength === -1 || totalLength <= _this.maxLength)) {
                var isImageDialogOpen = _this.contentModule.getDocument().querySelector(".e-rte-img-dialog");
                if (!(0, $3EnZW.isNullOrUndefined)(_this.pasteCleanupModule)) {
                    if ((0, $3EnZW.isNullOrUndefined)(isImageDialogOpen)) _this.notify($947a002e9a697770$export$32f783c04cad0a05, {
                        args: e
                    });
                } else {
                    console.warn('[WARNING] :: Module "pasteCleanup" is not available in RichTextEditor component! You either misspelled the module name or forgot to load it.');
                    var args_2 = {
                        requestType: "Paste",
                        editorMode: _this.editorMode,
                        event: e
                    };
                    var value = null;
                    var htmlValue = false;
                    if (e && !(0, $3EnZW.isNullOrUndefined)(e.clipboardData)) {
                        value = e.clipboardData.getData("text/plain");
                        htmlValue = e.clipboardData.getData("text/html").indexOf("MsoNormal") > 0;
                    }
                    var file = e && e.clipboardData && e.clipboardData.items.length > 0 ? e.clipboardData.items[0].getAsFile() : null;
                    if (value !== null) _this.notify($947a002e9a697770$export$9b6706c8686cfc8e, {
                        file: file,
                        args: e,
                        text: value,
                        isWordPaste: htmlValue
                    });
                    setTimeout(function() {
                        _this.formatter.onSuccess(_this, args_2);
                    }, 0);
                }
            } else e.preventDefault();
        });
    };
    /**
     * @param {string} action - specifies the string value.
     * @param {MouseEvent} event - specifies the event.
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.clipboardAction = function(action, event) {
        switch(action.toLowerCase()){
            case "cut":
                this.onCut();
                this.formatter.onSuccess(this, {
                    requestType: "Cut",
                    editorMode: this.editorMode,
                    event: event
                });
                break;
            case "copy":
                this.onCopy();
                this.formatter.onSuccess(this, {
                    requestType: "Copy",
                    editorMode: this.editorMode,
                    event: event
                });
                break;
            case "paste":
                this.onPaste(event);
                break;
        }
    };
    /**
     * Destroys the component (detaches/removes all event handlers, attributes, classes, and empties the component element).
     *
     * @returns {void}
     */ RichTextEditor.prototype.destroy = function() {
        if (this.isDestroyed || !this.isRendered) return;
        this.element.className = this.beforeRenderClassValue;
        this.removeHtmlAttributes();
        this.removeAttributes();
        this.beforeRenderClassValue = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.timeInterval)) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.autoSaveTimeOut)) {
            clearTimeout(this.autoSaveTimeOut);
            this.autoSaveTimeOut = null;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.idleInterval)) {
            clearTimeout(this.idleInterval);
            this.idleInterval = null;
        }
        this.notify($947a002e9a697770$export$b1fb4cac938035f7, {});
        this.destroyDependentModules();
        this.unWireEvents();
        if (this.originalElement.tagName === "TEXTAREA") {
            this.element.parentElement.insertBefore(this.valueContainer, this.element);
            this.valueContainer.id = this.getID();
            this.valueContainer.removeAttribute("name");
            (0, $4ZDHT.detach)(this.element);
            if (this.originalElement.innerHTML.trim() !== "") {
                this.valueContainer.value = this.originalElement.innerHTML.trim();
                this.setProperties({
                    value: !(0, $3EnZW.isNullOrUndefined)(this.initialValue) ? this.initialValue : null
                }, true);
            } else this.valueContainer.value = this.valueContainer.defaultValue;
            this.element = this.valueContainer;
            for(var i = 0; i < this.originalElement.classList.length; i++)(0, $4ZDHT.addClass)([
                this.element
            ], this.originalElement.classList[i]);
            if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) {
                var currentClassList = this.cssClass.split(" ");
                for(var i = 0; i < currentClassList.length; i++)(0, $4ZDHT.addClass)([
                    this.element
                ], currentClassList[i]);
            }
            (0, $4ZDHT.removeClass)([
                this.element
            ], $afc560df281b588d$export$c7f23d620ab4e862);
        } else if (this.originalElement.innerHTML.trim() !== "") {
            this.element.innerHTML = this.originalElement.innerHTML.trim();
            this.setProperties({
                value: !(0, $3EnZW.isNullOrUndefined)(this.initialValue) ? this.initialValue : null
            }, true);
        } else this.element.innerHTML = "";
        var dialogElement = document.querySelector(".e-dialog.e-rte-elements");
        if (dialogElement) (0, $4ZDHT.detach)(dialogElement);
        if (this.placeholder && this.placeHolderWrapper) this.placeHolderWrapper = null;
        if (!(0, $3EnZW.isNullOrUndefined)(this.cssClass)) {
            var allClassName = this.cssClass.split(" ");
            for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") (0, $4ZDHT.removeClass)([
                this.element
            ], allClassName[i]);
        }
        if (this.rootContainer) this.rootContainer = null;
        if (this.valueContainer) this.valueContainer = null;
        if (this.originalElement) this.originalElement = null;
        this.currentTarget = null;
        this.scrollParentElements = [];
        this.isRendered = false;
        _super.prototype.destroy.call(this);
    };
    RichTextEditor.prototype.removeHtmlAttributes = function() {
        if (this.htmlAttributes) {
            var keys = Object.keys(this.htmlAttributes);
            for(var i = 0; i < keys.length && this.element.hasAttribute(keys[i]); i++)this.element.removeAttribute(keys[i]);
        }
    };
    RichTextEditor.prototype.removeAttributes = function() {
        if (!this.enabled) (0, $4ZDHT.removeClass)([
            this.element
        ], $afc560df281b588d$export$a0040262df92c03);
        if (this.enableRtl) (0, $4ZDHT.removeClass)([
            this.element
        ], $afc560df281b588d$export$634124fb33d6a503);
        if (this.readonly) (0, $4ZDHT.removeClass)([
            this.element
        ], $afc560df281b588d$export$f53692bf3792d5c);
        if (this.element.style.width !== "" && this.originalElement.style.width === "") this.element.style.removeProperty("width");
        if (this.element.style.height !== "" && this.originalElement.style.height === "") this.element.style.removeProperty("height");
        this.element.removeAttribute("aria-disabled");
        this.element.removeAttribute("role");
        this.element.removeAttribute("tabindex");
        this.element.removeAttribute("aria-label");
    };
    RichTextEditor.prototype.destroyDependentModules = function() {
        // To handle the non Injectible module destruction.
        this.renderModule.destroy();
        this.formatter.editorManager.destroy();
    };
    /**
     * Returns the HTML or Text inside the RichTextEditor.
     *
     * @returns {Element} - specifies the element.
     */ RichTextEditor.prototype.getContent = function() {
        return this.contentModule.getPanel();
    };
    /**
     * Returns the text content as string.
     *
     * @returns {string} - specifies the string value.
     */ RichTextEditor.prototype.getText = function() {
        return this.contentModule.getText();
    };
    /**
     * Returns the html value of the selected content as string.
     *
     * @returns {string} - specifies the string value.
     */ RichTextEditor.prototype.getSelectedHtml = function() {
        var range;
        var wrapperElm = this.createElement("div");
        var selection = this.contentModule.getDocument().getSelection();
        if (selection.rangeCount > 0) {
            range = selection.getRangeAt(0);
            var selectedHtml = range.cloneContents();
            wrapperElm.appendChild(selectedHtml);
        }
        return wrapperElm.innerHTML;
    };
    /**
     * It shows the inline quick toolbar
     *
     * @returns {void}
     */ RichTextEditor.prototype.showInlineToolbar = function() {
        if (this.inlineMode.enable) {
            var currentRange = this.getRange();
            var targetElm = currentRange.endContainer.nodeName === "#text" ? currentRange.endContainer.parentElement : currentRange.endContainer;
            var x = currentRange.getClientRects()[0].left;
            var y = currentRange.getClientRects()[0].top;
            this.quickToolbarModule.showInlineQTBar(x, y, targetElm);
        }
    };
    /**
     * It hides the inline quick toolbar
     *
     * @returns {void}
     */ RichTextEditor.prototype.hideInlineToolbar = function() {
        this.quickToolbarModule.hideInlineQTBar();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @private

     */ RichTextEditor.prototype.getModuleName = function() {
        return "richtexteditor";
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} newProp - specifies the the property.
     * @param {RichTextEditorModel} oldProp - specifies the old property.
     * @returns {void}
     * @hidden

     */ /* eslint-disable */ RichTextEditor.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "enterKey":
                case "value":
                    var nVal = void 0;
                    if (prop === "enterKey") {
                        if (this.value === null || this.value === "<div><br></div>" || this.value === "<p><br></p>" || this.value === "<br>") nVal = null;
                        else nVal = this.value;
                    } else nVal = newProp[prop];
                    nVal = this.serializeValue(nVal);
                    var val = this.editorMode === "HTML" ? (0, $c77ecbfae9b8c035$export$4649c1610e50ca8d)(nVal, this) : nVal;
                    if (!(0, $3EnZW.isNullOrUndefined)(nVal) && nVal !== "" || prop === "enterKey") this.setProperties({
                        value: this.enableHtmlEncode ? this.encode((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(val)) : val
                    }, true);
                    this.updatePanelValue();
                    if (this.inputElement) this.notify($947a002e9a697770$export$5dbeb4561f6544b7, {});
                    this.setPlaceHolder();
                    this.notify($947a002e9a697770$export$76028e63d5b7a5cc, {
                        module: "XhtmlValidation",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    if (this.enableXhtml) this.setProperties({
                        value: this.getXhtml()
                    }, true);
                    if (this.showCharCount) this.countModule.refresh();
                    this.addAudioVideoWrapper();
                    break;
                case "valueTemplate":
                    this.setValue(true);
                    if (this.showCharCount) this.countModule.refresh();
                    break;
                case "width":
                    this.setWidth(newProp[prop]);
                    if (this.toolbarSettings.enable && !this.inlineMode.enable) {
                        this.toolbarModule.refreshToolbarOverflow();
                        this.resizeHandler();
                    }
                    break;
                case "height":
                    this.setHeight(newProp[prop]);
                    this.autoResize();
                    break;
                case "readonly":
                    this.setReadOnly(false);
                    break;
                case "cssClass":
                    this.element.classList.remove(oldProp[prop]);
                    this.setCssClass(newProp[prop]);
                    this.notify($947a002e9a697770$export$3195fd95fc6395d5, {
                        cssClass: newProp[prop],
                        oldCssClass: oldProp[prop]
                    });
                    break;
                case "enabled":
                    this.setEnable();
                    break;
                case "enableRtl":
                    this.updateRTL();
                    break;
                case "placeholder":
                    this.placeholder = newProp[prop];
                    this.setPlaceHolder();
                    break;
                case "htmlAttributes":
                    (0, $d344968bffc81d2f$export$74da2cba014bdc09)(this.htmlAttributes, this, false, false);
                    break;
                case "iframeSettings":
                    var frameSetting = oldProp[prop];
                    if (frameSetting.resources) {
                        var iframe = this.contentModule.getDocument();
                        var header = iframe.querySelector("head");
                        var files = void 0;
                        if (frameSetting.resources.scripts) {
                            files = header.querySelectorAll("." + $afc560df281b588d$export$fa864e52883d32eb);
                            this.removeSheets(files);
                        }
                        if (frameSetting.resources.styles) {
                            files = header.querySelectorAll("." + $afc560df281b588d$export$29177b1f49d99421);
                            this.removeSheets(files);
                        }
                    }
                    this.setIframeSettings();
                    break;
                case "locale":
                    _super.prototype.refresh.call(this);
                    break;
                case "inlineMode":
                    this.notify($947a002e9a697770$export$80cded91831c5507, {
                        module: "quickToolbar",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "toolbarSettings":
                    this.notify($947a002e9a697770$export$80cded91831c5507, {
                        module: "toolbar",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "maxLength":
                    if (this.showCharCount) this.countModule.refresh();
                    break;
                case "showCharCount":
                    if (newProp[prop] && this.countModule) this.countModule.renderCount();
                    else if (newProp[prop] === false && this.countModule) this.countModule.destroy();
                    break;
                case "enableHtmlEncode":
                    this.updateValueData();
                    this.updatePanelValue();
                    this.setPlaceHolder();
                    if (this.showCharCount) this.countModule.refresh();
                    break;
                case "undoRedoSteps":
                case "undoRedoTimer":
                    this.formatter.editorManager.observer.notify($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, {
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "enableXhtml":
                    this.notify($947a002e9a697770$export$76028e63d5b7a5cc, {
                        module: "XhtmlValidation",
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "quickToolbarSettings":
                    newProp.quickToolbarSettings.showOnRightClick ? this.wireContextEvent() : this.unWireContextEvent();
                    this.notify($947a002e9a697770$export$80cded91831c5507, {
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
                case "formatPainterSettings":
                    this.formatter.editorManager.observer.notify($ee11fb99ae4d2c3e$export$bcb6f3aa635029d9, {
                        module: "formatPainter",
                        newProp: newProp
                    });
                    break;
                default:
                    this.notify($947a002e9a697770$export$80cded91831c5507, {
                        newProp: newProp,
                        oldProp: oldProp
                    });
                    break;
            }
            this.autoResize();
        }
    };
    /* eslint-enable */ /**
     * @hidden
     * @returns {void}

     */ RichTextEditor.prototype.updateValueData = function() {
        if (this.enableHtmlEncode) this.setProperties({
            value: this.encode((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(this.inputElement.innerHTML))
        }, true);
        else this.setProperties({
            value: /<[a-z][\s\S]*>/i.test(this.inputElement.innerHTML) ? this.inputElement.innerHTML : (0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(this.inputElement.innerHTML)
        });
    };
    RichTextEditor.prototype.removeSheets = function(srcList) {
        var i;
        for(i = 0; i < srcList.length; i++)(0, $4ZDHT.detach)(srcList[i]);
    };
    RichTextEditor.prototype.updatePanelValue = function() {
        var value = this.editorMode === "HTML" ? this.listOrderCorrection(this.value) : this.value;
        value = this.enableHtmlEncode && this.value ? (0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(value) : value;
        var getTextArea = this.element.querySelector("." + $afc560df281b588d$export$97efb1fe9920382d);
        if (value) {
            if (!(0, $3EnZW.isNullOrUndefined)(getTextArea) && this.rootContainer.classList.contains("e-source-code-enabled")) getTextArea.value = this.value;
            if (this.valueContainer) this.valueContainer.value = this.enableHtmlEncode ? this.value : value;
            if (this.editorMode === "HTML" && this.inputElement && this.inputElement.innerHTML.trim() !== value.trim()) this.inputElement.innerHTML = value;
            else if (this.editorMode === "Markdown" && this.inputElement && this.inputElement.value.trim() !== value.trim()) this.inputElement.value = value;
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(getTextArea) && this.rootContainer.classList.contains("e-source-code-enabled")) getTextArea.value = "";
            if (this.editorMode === "HTML") {
                if (this.enterKey === "DIV") this.inputElement.innerHTML = "<div><br/></div>";
                else if (this.enterKey === "BR") this.inputElement.innerHTML = "<br/>";
                else this.inputElement.innerHTML = "<p><br/></p>";
            } else this.inputElement.value = "";
            if (this.valueContainer) this.valueContainer.value = "";
        }
        if (this.showCharCount) this.countModule.refresh();
    };
    RichTextEditor.prototype.listOrderCorrection = function(value) {
        var valueElementWrapper = this.createElement("div");
        valueElementWrapper.innerHTML = value;
        var listElements = valueElementWrapper.querySelectorAll("UL, OL");
        for(var i = 0; i < listElements.length; i++)if (!(0, $3EnZW.isNullOrUndefined)(listElements[i]) && !(0, $3EnZW.isNullOrUndefined)(listElements[i].parentElement) && !(0, $3EnZW.isNullOrUndefined)(listElements[i].previousElementSibling) && (listElements[i].parentElement.nodeName === "UL" || listElements[i].parentElement.nodeName === "OL")) listElements[i].previousElementSibling.appendChild(listElements[i]);
        return valueElementWrapper.innerHTML;
    };
    RichTextEditor.prototype.setHeight = function(height) {
        if (height !== "auto") this.element.style.height = (0, $3EnZW.formatUnit)(height);
        else this.element.style.height = "auto";
        if (this.toolbarSettings.type === "Expand" && (typeof this.height === "string" && this.height.indexOf("px") > -1 || typeof this.height === "number")) this.element.classList.add($afc560df281b588d$export$1e22aeee795e25a7);
        else this.element.classList.remove($afc560df281b588d$export$1e22aeee795e25a7);
    };
    /**
     * setPlaceHolder method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.setPlaceHolder = function() {
        if (this.inputElement && this.placeholder && this.iframeSettings.enable !== true) {
            if (this.editorMode !== "Markdown") {
                if (!this.placeHolderWrapper) {
                    this.placeHolderWrapper = this.createElement("span", {
                        className: "rte-placeholder e-rte-placeholder " + this.getCssClass()
                    });
                    if (this.fontSize.default) this.placeHolderWrapper.style.fontSize = this.fontSize.default;
                    if (this.inputElement) this.inputElement.parentElement.insertBefore(this.placeHolderWrapper, this.inputElement);
                }
                this.placeHolderWrapper.innerHTML = this.placeholder;
                if (this.inputElement.textContent.length === 0 && this.inputElement.childNodes.length < 2 && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.firstChild) && (this.inputElement.firstChild.nodeName === "BR" || (this.inputElement.firstChild.nodeName === "P" || this.inputElement.firstChild.nodeName === "DIV") && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.firstChild.firstChild) && this.inputElement.firstChild.firstChild.nodeName === "BR")) this.placeHolderWrapper.classList.add("enabled");
                else this.placeHolderWrapper.classList.remove("enabled");
            } else this.inputElement.setAttribute("placeholder", this.placeholder);
        }
        if (this.placeholder && this.iframeSettings.enable && this.inputElement) {
            if (this.inputElement.textContent.length === 0 && this.inputElement.childNodes.length < 2 && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.firstChild) && (this.inputElement.firstChild.nodeName === "BR" || (this.inputElement.firstChild.nodeName === "P" || this.inputElement.firstChild.nodeName === "DIV") && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.firstChild.firstChild) && this.inputElement.firstChild.firstChild.nodeName === "BR")) {
                (0, $4ZDHT.addClass)([
                    this.inputElement
                ], "e-rte-placeholder");
                this.inputElement.setAttribute("placeholder", this.placeholder);
            } else (0, $4ZDHT.removeClass)([
                this.inputElement
            ], "e-rte-placeholder");
        }
    };
    RichTextEditor.prototype.setWidth = function(width) {
        if (width !== "auto") (0, $4ZDHT.setStyleAttribute)(this.element, {
            "width": (0, $3EnZW.formatUnit)(this.width)
        });
        else this.element.style.width = "auto";
    };
    RichTextEditor.prototype.setCssClass = function(cssClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(cssClass)) {
            var allClassName = cssClass.split(" ");
            for(var i = 0; i < allClassName.length; i++)if (allClassName[i].trim() !== "") this.element.classList.add(allClassName[i]);
        }
    };
    RichTextEditor.prototype.updateRTL = function() {
        this.notify($947a002e9a697770$export$9dcaf34b3cdca414, {
            enableRtl: this.enableRtl
        });
        if (this.enableRtl) {
            this.element.classList.add($afc560df281b588d$export$634124fb33d6a503);
            this.inputElement.classList.add($afc560df281b588d$export$634124fb33d6a503);
        } else {
            this.element.classList.remove($afc560df281b588d$export$634124fb33d6a503);
            this.inputElement.classList.remove($afc560df281b588d$export$634124fb33d6a503);
        }
    };
    RichTextEditor.prototype.updateReadOnly = function() {
        this.notify($947a002e9a697770$export$ff4edde773b9bda2, {
            editPanel: this.inputElement,
            mode: this.readonly
        });
    };
    /**
     * setReadOnly method
     *
     * @param {boolean} initial - specifies the boolean value
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.setReadOnly = function(initial) {
        this.updateReadOnly();
        if (!initial) {
            if (this.readonly && this.enabled) {
                this.unbindEvents();
                this.unWireEvents();
            } else if (this.enabled) this.wireEvents();
        }
    };
    /**
     * By default, prints all the pages of the RichTextEditor.
     *
     * @returns {void}
     */ RichTextEditor.prototype.print = function() {
        var _this = this;
        var printWind;
        var printArgs = {
            element: this.inputElement,
            requestType: "print",
            cancel: false
        };
        this.trigger($947a002e9a697770$export$df204737a6131aab, printArgs, function(printingArgs) {
            printWind = window.open("", "print", "height=" + window.outerHeight + ",width=" + window.outerWidth);
            if ((0, $5q7BP.Browser).info.name === "msie") printWind.resizeTo(screen.availWidth, screen.availHeight);
            printWind = (0, $3EnZW.print)(_this.inputElement, printWind);
            if (!printingArgs.cancel) {
                var actionArgs = {
                    requestType: "print"
                };
                _this.trigger($947a002e9a697770$export$830631a3cb598490, actionArgs);
            }
        });
    };
    /**
     * Refresh the view of the editor.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.refreshUI = function() {
        this.renderModule.refresh();
    };
    /**
     * Shows the Rich Text Editor component in full-screen mode.
     *
     * @returns {void}
     */ RichTextEditor.prototype.showFullScreen = function() {
        this.fullScreenModule.showFullScreen();
    };
    /**
     * Enables the give toolbar items in the Rich Text Editor component.
     *
     * @returns {void}
     * @param {string | string[]} items - Specifies the single or collection of items
     * @param {boolean} muteToolbarUpdate enable/disables the toolbar item status in RichTextEditor.
     * that you want to be enable in Rich Text Editor’s Toolbar.
     *
     * @public
     */ RichTextEditor.prototype.enableToolbarItem = function(items, muteToolbarUpdate) {
        this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(), items, true, muteToolbarUpdate);
    };
    /**
     * Disables the given toolbar items in the Rich Text Editor component.
     *
     * @returns {void}
     * @param {string | string[]} items - Specifies the single or collection of items
     * @param {boolean} muteToolbarUpdate enable/disables the toolbar item status in RichTextEditor.
     * that you want to be disable in Rich Text Editor’s Toolbar.
     *
     * @public
     */ RichTextEditor.prototype.disableToolbarItem = function(items, muteToolbarUpdate) {
        this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(), items, false, muteToolbarUpdate);
    };
    /**
     * Removes the give toolbar items from the Rich Text Editor component.
     *
     * @returns {void}
     * @param {string | string[]} items - Specifies the single or collection of items
     * that you want to be remove from Rich Text Editor’s Toolbar.
     *
     * @public
     */ RichTextEditor.prototype.removeToolbarItem = function(items) {
        this.toolbarModule.removeTBarItems(items);
    };
    /**
     * Get the selected range from the RichTextEditor's content.
     *
     * @returns {void}
     * @public

     */ RichTextEditor.prototype.getRange = function() {
        return this.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
    };
    RichTextEditor.prototype.initializeServices = function() {
        this.serviceLocator.register("rendererFactory", new (0, $f4829b8a9892cfab$export$35d194b5f3387064));
        this.serviceLocator.register("rteLocale", this.localeObj = new (0, $e7i2H.L10n)(this.getModuleName(), (0, $ecad6f2eecfabe7c$export$d7f512c98c859244), this.locale));
        this.serviceLocator.register("dialogRenderObject", new (0, $3b7a703992ffcdd8$export$e25f482e9985501c)(this));
    };
    RichTextEditor.prototype.RTERender = function() {
        var rendererFactory = this.serviceLocator.getService("rendererFactory");
        this.contentModule = rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        this.fullScreenModule = new (0, $44b581d77a360fdd$export$f885b95b3f0be76d)(this);
        this.enterKeyModule = new (0, $71bfa6b0134e8557$export$cbf2176918894801)(this);
        this.renderModule.render();
        this.inputElement = this.contentModule.getEditPanel();
        this.setHeight(this.height);
        (0, $d344968bffc81d2f$export$74da2cba014bdc09)(this.htmlAttributes, this, false, true);
        if (this.iframeSettings) this.setIframeSettings();
        this.setCssClass(this.cssClass);
        this.updateEnable();
        this.setPlaceHolder();
        this.updateRTL();
        this.updateReadOnly();
        this.updatePanelValue();
        if (this.enableHtmlEncode && !(0, $3EnZW.isNullOrUndefined)(this.value)) this.setProperties({
            value: this.encode((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(this.value))
        });
    };
    RichTextEditor.prototype.setIframeSettings = function() {
        if (this.iframeSettings.resources) {
            var styleSrc = this.iframeSettings.resources.styles;
            var scriptSrc = this.iframeSettings.resources.scripts;
            if (!(0, $3EnZW.isNullOrUndefined)(this.iframeSettings.resources.scripts) && this.iframeSettings.resources.scripts.length > 0) this.InjectSheet(true, scriptSrc);
            if (!(0, $3EnZW.isNullOrUndefined)(this.iframeSettings.resources.styles) && this.iframeSettings.resources.styles.length > 0) this.InjectSheet(false, styleSrc);
        }
        if (this.iframeSettings.attributes) (0, $d344968bffc81d2f$export$74da2cba014bdc09)(this.iframeSettings.attributes, this, true, false);
    };
    RichTextEditor.prototype.InjectSheet = function(scriptSheet, srcList) {
        try {
            if (srcList && srcList.length > 0) {
                var iFrame = this.contentModule.getDocument();
                var target = iFrame.querySelector("head");
                for(var i = 0; i < srcList.length; i++)if (scriptSheet) {
                    var scriptEle = this.createScriptElement();
                    scriptEle.src = srcList[i];
                    target.appendChild(scriptEle);
                } else {
                    var styleEle = this.createStyleElement();
                    styleEle.href = srcList[i];
                    target.appendChild(styleEle);
                }
            }
        } catch (e) {
            return;
        }
    };
    RichTextEditor.prototype.createScriptElement = function() {
        var scriptEle = this.createElement("script", {
            className: $afc560df281b588d$export$fa864e52883d32eb
        });
        scriptEle.type = "text/javascript";
        return scriptEle;
    };
    RichTextEditor.prototype.createStyleElement = function() {
        var styleEle = this.createElement("link", {
            className: $afc560df281b588d$export$29177b1f49d99421
        });
        styleEle.rel = "stylesheet";
        return styleEle;
    };
    RichTextEditor.prototype.setValue = function(isPropertyChange) {
        var _this = this;
        if (this.valueTemplate) {
            var regEx = new RegExp(/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i);
            if (typeof this.valueTemplate === "string" && regEx.test(this.valueTemplate)) this.setProperties({
                value: this.valueTemplate
            });
            else {
                var compiledTemplate = (0, $c2qqN.compile)(this.valueTemplate)("", this, "valueTemplate");
                // eslint-disable-next-line
                if (typeof this.valueTemplate !== "string" && this.isReact) {
                    this.displayTempElem = this.createElement("div");
                    for(var i = 0; i < compiledTemplate.length; i++){
                        var item = compiledTemplate[i];
                        (0, $4ZDHT.append)([
                            item
                        ], this.displayTempElem);
                    }
                    this.renderTemplates(function() {
                        _this.inputElement.innerHTML = _this.displayTempElem.childNodes[0].innerHTML;
                        _this.setProperties({
                            value: _this.inputElement.innerHTML.trim()
                        });
                    });
                } else {
                    var appendElem = this.element;
                    if (isPropertyChange) {
                        this.inputElement.innerHTML = "";
                        appendElem = this.inputElement;
                    }
                    for(var i = 0; i < compiledTemplate.length; i++){
                        var item = compiledTemplate[i];
                        (0, $4ZDHT.append)([
                            item
                        ], appendElem);
                    }
                    this.setProperties({
                        value: appendElem.innerHTML.trim()
                    });
                    this.renderReactTemplates();
                }
            }
        } else {
            // eslint-disable-next-line
            var innerHtml = !(0, $3EnZW.isNullOrUndefined)(this.element.innerHTML) && this.element.innerHTML.replace(/<(\/?|\!?)(!--!--)>/g, "").trim();
            if (innerHtml !== "") {
                if (this.element.tagName === "TEXTAREA") this.setProperties({
                    value: (0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(innerHtml)
                });
                else this.setProperties({
                    value: innerHtml
                });
            }
        }
    };
    // eslint-disable-next-line
    RichTextEditor.prototype.renderTemplates = function(callBack) {
        this.renderReactTemplates(callBack);
    };
    RichTextEditor.prototype.updateResizeFlag = function() {
        this.isResizeInitialized = true;
    };
    /**
     * Image max width calculation method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getInsertImgMaxWidth = function() {
        var maxWidth = this.insertImageSettings.maxWidth;
        // eslint-disable-next-line
        var imgPadding = 12;
        var imgResizeBorder = 2;
        var editEle = this.contentModule.getEditPanel();
        if (this.editorMode === "HTML" && !(0, $3EnZW.isNullOrUndefined)(this.formatter.editorManager.nodeSelection) && !(0, $3EnZW.isNullOrUndefined)(this.formatter.editorManager.nodeSelection.range)) {
            var currentRange = this.formatter.editorManager.nodeSelection.range;
            if (currentRange.startContainer.nodeType !== 3 && currentRange.startContainer.closest && !(0, $3EnZW.isNullOrUndefined)(currentRange.startContainer.closest("TD"))) editEle = currentRange.startContainer;
        }
        var eleStyle = window.getComputedStyle(editEle);
        var editEleMaxWidth = editEle.offsetWidth - (imgPadding + imgResizeBorder + parseFloat(eleStyle.paddingLeft.split("px")[0]) + parseFloat(eleStyle.paddingRight.split("px")[0]) + parseFloat(eleStyle.marginLeft.split("px")[0]) + parseFloat(eleStyle.marginRight.split("px")[0]));
        return (0, $3EnZW.isNullOrUndefined)(maxWidth) ? editEleMaxWidth : maxWidth;
    };
    /**
     * Video max width calculation method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getInsertVidMaxWidth = function() {
        var maxWidth = this.insertVideoSettings.maxWidth;
        // eslint-disable-next-line
        var vidPadding = 12;
        var vidResizeBorder = 2;
        var editEle = this.contentModule.getEditPanel();
        var eleStyle = window.getComputedStyle(editEle);
        var editEleMaxWidth = editEle.offsetWidth - (vidPadding + vidResizeBorder + parseFloat(eleStyle.paddingLeft.split("px")[0]) + parseFloat(eleStyle.paddingRight.split("px")[0]) + parseFloat(eleStyle.marginLeft.split("px")[0]) + parseFloat(eleStyle.marginRight.split("px")[0]));
        return (0, $3EnZW.isNullOrUndefined)(maxWidth) ? editEleMaxWidth : maxWidth;
    };
    /**
     * Retrieves the HTML from RichTextEditor.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.getHtml = function() {
        var htmlValue = this.removeResizeElement(this.contentModule.getEditPanel().innerHTML);
        return this.enableXhtml && (htmlValue === "<p><br></p>" || htmlValue === "<div><br></div>" || htmlValue === "<br>") ? null : this.serializeValue(htmlValue);
    };
    /**
     * Retrieves the Rich Text Editor's XHTML validated HTML content when `enableXhtml` property is enabled.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.getXhtml = function() {
        var currentValue = this.removeResizeElement(this.value);
        if (!(0, $3EnZW.isNullOrUndefined)(currentValue) && this.enableXhtml) currentValue = this.htmlEditorModule.xhtmlValidation.selfEncloseValidation(currentValue);
        return currentValue;
    };
    /**
     * Shows the source HTML/MD markup.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.showSourceCode = function() {
        if (this.readonly) return;
        this.notify($947a002e9a697770$export$a03f62af6e933a3, {});
    };
    /**
     * Returns the maximum number of characters in the Rich Text Editor.
     *
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.getCharCount = function() {
        var htmlText = this.editorMode === "Markdown" ? this.inputElement.value.trim() : this.inputElement.textContent.trim();
        var htmlLength;
        if (this.editorMode !== "Markdown" && htmlText.indexOf("\u200B") !== -1) htmlLength = htmlText.replace(/\u200B/g, "").length;
        else htmlLength = htmlText.length;
        return htmlLength;
    };
    /**
     * Show the dialog in the Rich Text Editor.
     *
     * @param {DialogType} type - specifies the dialog type.
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.showDialog = function(type) {
        if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertLink) this.notify($947a002e9a697770$export$133203a753e0e8c5, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertImage) this.notify($947a002e9a697770$export$5617ef57439be2b, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertAudio) this.notify($947a002e9a697770$export$86f139d5d20038ff, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertVideo) this.notify($947a002e9a697770$export$747747cd285e0bb9, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertTable) this.notify($947a002e9a697770$export$815a79e2a317fc9, {});
    };
    /**
     * Close the dialog in the Rich Text Editor.
     *
     * @param {DialogType} type - specifies the dialog type.
     * @returns {void}
     * @public
     */ RichTextEditor.prototype.closeDialog = function(type) {
        if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertLink) this.notify($947a002e9a697770$export$1183608103c7fad2, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertImage) this.notify($947a002e9a697770$export$5884d34c82a0825a, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertAudio) this.notify($947a002e9a697770$export$68bf2f47fab9348f, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertVideo) this.notify($947a002e9a697770$export$2b859288d6d27b84, {});
        else if (type === (0, $2eaa618655f536c2$export$290cb7291ee58b61).InsertTable) this.notify($947a002e9a697770$export$4301237dfe1688e2, {});
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getBaseToolbarObject = function() {
        var tbObj;
        if (this.inlineMode.enable && (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)())) tbObj = this.quickToolbarModule && this.quickToolbarModule.getInlineBaseToolbar();
        else tbObj = this.toolbarModule && this.toolbarModule.getBaseToolbar();
        return tbObj;
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getToolbar = function() {
        return this.toolbarModule ? this.toolbarModule.getToolbarElement() : null;
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.getToolbarElement = function() {
        return this.toolbarModule && this.toolbarModule.getToolbarElement();
    };
    /**
     * @returns {void}
     * getID method
     *
     * @hidden

     */ RichTextEditor.prototype.getID = function() {
        return this.internalID;
    };
    /**
     * Returns the CSS class.
     *
     * @param {boolean} [isSpace] - Specifies whether to include a space before the CSS class.
     * @returns {string} The CSS class.
     * @hidden

     */ RichTextEditor.prototype.getCssClass = function(isSpace) {
        return (0, $3EnZW.isNullOrUndefined)(this.cssClass) ? "" : isSpace ? " " + this.cssClass : this.cssClass;
    };
    RichTextEditor.prototype.mouseDownHandler = function(e) {
        var touch = e.touches ? e.changedTouches[0] : e;
        (0, $4ZDHT.addClass)([
            this.element
        ], [
            $afc560df281b588d$export$f6dd9c0812bc4312
        ]);
        this.preventDefaultResize(e);
        this.notify($947a002e9a697770$export$ea32a7693b83cfdb, {
            args: e
        });
        this.formatter.editorManager.observer.notify($947a002e9a697770$export$ea32a7693b83cfdb, {
            args: e
        });
        this.clickPoints = {
            clientX: touch.clientX,
            clientY: touch.clientY
        };
    };
    RichTextEditor.prototype.preventImgResize = function(e) {
        if (e.target.nodeName.toLocaleLowerCase() === "img") e.preventDefault();
    };
    /**
     * preventDefaultResize method
     *
     * @param {FocusEvent} e - specifies the event.
     * @returns {void}
     * @hidden

     */ // eslint-disable-next-line
    RichTextEditor.prototype.preventDefaultResize = function(e) {
        if ((0, $5q7BP.Browser).info.name === "msie") this.contentModule.getEditPanel().addEventListener("mscontrolselect", this.preventImgResize);
        else if ((0, $5q7BP.Browser).info.name === "mozilla") {
            this.contentModule.getDocument().execCommand("enableObjectResizing", false, "false");
            this.contentModule.getDocument().execCommand("enableInlineTableEditing", false, "false");
        }
    };
    // eslint-disable-next-line
    RichTextEditor.prototype.defaultResize = function(e) {
        if ((0, $5q7BP.Browser).info.name === "msie") this.contentModule.getEditPanel().removeEventListener("mscontrolselect", this.preventImgResize);
        else if ((0, $5q7BP.Browser).info.name === "mozilla") {
            this.contentModule.getDocument().execCommand("enableObjectResizing", true, "true");
            this.contentModule.getDocument().execCommand("enableInlineTableEditing", true, "true");
        }
    };
    RichTextEditor.prototype.resizeHandler = function() {
        if (!document.body.contains(this.element)) {
            document.defaultView.removeEventListener("resize", this.resizeHandler, true);
            this.onResizeHandler = null;
            return;
        }
        if (this.toolbarSettings.enable && !this.inlineMode.enable) this.toolbarModule.refreshToolbarOverflow();
        this.notify($947a002e9a697770$export$bad6189f4d27c01f, null);
        this.autoResize();
    };
    RichTextEditor.prototype.scrollHandler = function(e) {
        if (this.element) this.notify($947a002e9a697770$export$209876d7b1ac8f3, {
            args: e
        });
    };
    RichTextEditor.prototype.contentScrollHandler = function(e) {
        this.notify($947a002e9a697770$export$55df3e903573f90b, {
            args: e
        });
    };
    RichTextEditor.prototype.focusHandler = function(e) {
        if (!this.isRTE || this.isFocusOut) {
            this.isRTE = this.isFocusOut ? false : true;
            this.isFocusOut = false;
            (0, $4ZDHT.addClass)([
                this.element
            ], [
                $afc560df281b588d$export$f6dd9c0812bc4312
            ]);
            if (this.editorMode === "HTML") this.cloneValue = this.inputElement.innerHTML === "<p><br></p>" || this.inputElement.innerHTML === "<div><br></div>" || this.inputElement.innerHTML === "<br>" ? null : this.enableHtmlEncode ? this.encode((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(this.inputElement.innerHTML)) : this.inputElement.innerHTML;
            else this.cloneValue = this.inputElement.value === "" ? null : this.inputElement.value;
            var active = document.activeElement;
            if (active === this.element || active === this.getToolbarElement() || active === this.contentModule.getEditPanel() || this.iframeSettings.enable && active === this.contentModule.getPanel() && e.target && !e.target.classList.contains("e-img-inner") && e.target && e.target.parentElement && !e.target.parentElement.classList.contains("e-img-wrap") || (0, $4ZDHT.closest)(active, ".e-rte-toolbar") === this.getToolbarElement()) {
                this.contentModule.getEditPanel().focus();
                if (!(0, $3EnZW.isNullOrUndefined)(this.getToolbarElement())) {
                    this.getToolbarElement().setAttribute("tabindex", "-1");
                    var items = this.getToolbarElement().querySelectorAll('[tabindex="0"]');
                    for(var i = 0; i < items.length; i++)items[i].setAttribute("tabindex", "-1");
                }
            }
            this.preventDefaultResize(e);
            this.trigger("focus", {
                event: e,
                isInteracted: Object.keys(e).length === 0 ? false : true
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.saveInterval) && this.saveInterval > 0 && !this.autoSaveOnIdle && (0, $3EnZW.isNullOrUndefined)(this.timeInterval)) this.timeInterval = setInterval(this.updateValueOnIdle.bind(this), this.saveInterval);
            (0, $aqzbR.EventHandler).add(document, "mousedown", this.onDocumentClick, this);
        }
        if (!this.readonly) {
            var currentFocus = this.getCurrentFocus(e);
            if (currentFocus === "editArea" || currentFocus === "textArea" || currentFocus === "sourceCode") this.resetToolbarTabIndex();
        }
    };
    RichTextEditor.prototype.getUpdatedValue = function() {
        var value;
        var getTextArea = this.element.querySelector("." + $afc560df281b588d$export$97efb1fe9920382d);
        if (this.editorMode === "HTML") {
            value = this.inputElement.innerHTML === "<p><br></p>" || this.inputElement.innerHTML === "<div><br></div>" || this.inputElement.innerHTML === "<br>" ? null : this.enableHtmlEncode ? this.encode((0, $c77ecbfae9b8c035$export$2f872c0f2117be69)(this.removeResizeElement(this.inputElement.innerHTML))) : this.inputElement.innerHTML;
            if (!(0, $3EnZW.isNullOrUndefined)(getTextArea) && this.rootContainer.classList.contains("e-source-code-enabled")) value = getTextArea.value;
        } else value = this.inputElement.value === "" ? null : this.inputElement.value;
        if (value != null && !this.enableHtmlEncode) value = this.removeResizeElement(value);
        return value;
    };
    RichTextEditor.prototype.updateValueOnIdle = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.tableModule) && !(0, $3EnZW.isNullOrUndefined)(this.inputElement.querySelector(".e-table-box.e-rbox-select"))) return;
        this.setProperties({
            value: this.getUpdatedValue()
        }, true);
        this.valueContainer.value = this.value;
        this.isValueChangeBlurhandler = false;
        this.invokeChangeEvent();
    };
    RichTextEditor.prototype.updateIntervalValue = function() {
        clearTimeout(this.idleInterval);
        this.idleInterval = setTimeout(this.updateValueOnIdle.bind(this), 0);
    };
    RichTextEditor.prototype.cleanupResizeElements = function(args) {
        var value = this.removeResizeElement(args.value);
        args.callBack(value);
    };
    RichTextEditor.prototype.addAnchorAriaLabel = function(value) {
        var valueElementWrapper = document.createElement("div");
        valueElementWrapper.innerHTML = value;
        var item = valueElementWrapper.querySelectorAll("a");
        if (item.length > 0) {
            for(var i = 0; i < item.length; i++)if (item[i].hasAttribute("target") && item[i].getAttribute("target") === "_blank") item[i].setAttribute("aria-label", this.serviceLocator.getService("rteLocale").getConstant("linkAriaLabel"));
        }
        return valueElementWrapper.innerHTML;
    };
    RichTextEditor.prototype.removeResizeElement = function(value) {
        var valueElementWrapper = document.createElement("div");
        if (this.editorMode === "HTML") {
            valueElementWrapper.innerHTML = value;
            var item = valueElementWrapper.querySelectorAll(".e-column-resize, .e-row-resize, .e-table-box, .e-table-rhelper, .e-img-resize");
            if (item.length > 0) for(var i = 0; i < item.length; i++)(0, $4ZDHT.detach)(item[i]);
            this.removeSelectionClassStates(valueElementWrapper);
        } else valueElementWrapper.textContent = value;
        return this.editorMode === "Markdown" ? valueElementWrapper.innerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&") : valueElementWrapper.innerHTML;
    };
    RichTextEditor.prototype.updateStatus = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.html) || !(0, $3EnZW.isNullOrUndefined)(e.markdown)) {
            var status_1 = this.formatter.editorManager.undoRedoManager.getUndoStatus();
            var eventArgs = {
                undo: status_1.undo,
                redo: status_1.redo,
                html: e.html,
                markdown: e.markdown
            };
            this.trigger($947a002e9a697770$export$2e0e26484d7e9fc5, eventArgs);
        }
    };
    RichTextEditor.prototype.onDocumentClick = function(e) {
        var target = e.target;
        var rteElement = (0, $4ZDHT.closest)(target, "." + $afc560df281b588d$export$1961a0ca09d720a9);
        if (!this.element.contains(e.target) && document !== e.target && rteElement !== this.element && !(0, $4ZDHT.closest)(target, '[aria-owns="' + this.getID() + '"]')) {
            this.isBlur = true;
            this.isRTE = false;
        }
        this.notify($947a002e9a697770$export$49aaf87a462f3eb3, {
            args: e
        });
        var hideQuickToolbarChecker = this.quickToolbarModule && !this.inlineMode.enable && (0, $3EnZW.isNullOrUndefined)(this.quickToolbarModule.inlineQTBar);
        if (hideQuickToolbarChecker && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, ".e-toolbar-wrapper")) || hideQuickToolbarChecker && (!(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, ".e-rte-table-resize")) || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, ".e-table-box")))) this.quickToolbarModule.hideQuickToolbars();
        if ((0, $5q7BP.Browser).info.name !== "msie" && e.detail > 3) e.preventDefault();
    };
    RichTextEditor.prototype.blurHandler = function(e) {
        var trg = e.relatedTarget;
        if (trg) {
            var rteElement = (0, $4ZDHT.closest)(trg, "." + $afc560df281b588d$export$1961a0ca09d720a9);
            if (!rteElement && this.iframeSettings.enable) {
                var iframeElement = this.element.querySelector("#" + this.getID() + "_rte-view");
                if (iframeElement && iframeElement.contentWindow.document.body.contains(trg)) rteElement = (0, $4ZDHT.closest)(iframeElement, "." + $afc560df281b588d$export$1961a0ca09d720a9);
            }
            if (rteElement && rteElement === this.element) {
                this.isBlur = false;
                if (trg === this.getToolbarElement()) trg.setAttribute("tabindex", "-1");
            } else if ((0, $4ZDHT.closest)(trg, '[aria-owns="' + this.getID() + '"]') || (0, $4ZDHT.closest)(trg, "." + $afc560df281b588d$export$d3f61cb93957903e)) this.isBlur = false;
            else {
                this.isBlur = true;
                trg = null;
            }
        }
        if (this.isBlur && (0, $3EnZW.isNullOrUndefined)(trg)) {
            (0, $4ZDHT.removeClass)([
                this.element
            ], [
                $afc560df281b588d$export$f6dd9c0812bc4312
            ]);
            this.removeSelectionClassStates(this.inputElement);
            this.notify($947a002e9a697770$export$ceb2354ae09b6ff, {});
            var value = this.getUpdatedValue();
            this.setProperties({
                value: value
            });
            this.valueContainer.value = this.value;
            this.notify($947a002e9a697770$export$6a017cfaa3b33c68, {
                args: e,
                documentNode: document
            });
            this.isValueChangeBlurhandler = true;
            this.invokeChangeEvent();
            this.isFocusOut = true;
            this.isBlur = false;
            (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.valueContainer, "focusout");
            this.defaultResize(e);
            this.trigger("blur", {
                event: e,
                isInteracted: Object.keys(e).length === 0 ? false : true
            });
            if (!(0, $3EnZW.isNullOrUndefined)(this.timeInterval)) {
                clearInterval(this.timeInterval);
                this.timeInterval = null;
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.placeHolderWrapper) && this.element.querySelector("[title = Preview]")) this.placeHolderWrapper.style.display = "none";
            (0, $aqzbR.EventHandler).remove(document, "mousedown", this.onDocumentClick);
        } else this.isRTE = true;
        if (!this.readonly && this.getCurrentFocus(e) === "outside") this.resetToolbarTabIndex();
    };
    /**
     * invokeChangeEvent method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.contentChanged = function() {
        if (this.autoSaveOnIdle) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.saveInterval)) {
                clearTimeout(this.autoSaveTimeOut);
                this.autoSaveTimeOut = setTimeout(this.updateIntervalValue.bind(this), this.saveInterval);
            }
        }
    };
    /**
     * invokeChangeEvent method
     *
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.invokeChangeEvent = function() {
        var currentValue;
        if (this.enableXhtml) currentValue = this.getXhtml();
        else currentValue = this.value;
        var eventArgs = {
            value: currentValue,
            isInteracted: this.isValueChangeBlurhandler
        };
        if (this.value !== this.cloneValue) {
            this.trigger("change", eventArgs);
            this.cloneValue = this.value;
        }
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.wireScrollElementsEvents = function() {
        this.scrollParentElements = (0, $2vAqh.getScrollableParent)(this.element);
        for(var _i = 0, _a = this.scrollParentElements; _i < _a.length; _i++){
            var element = _a[_i];
            (0, $aqzbR.EventHandler).add(element, "scroll", this.scrollHandler, this);
        }
        if (!this.iframeSettings.enable) // Add the scroll event handler from the inputElement
        (0, $aqzbR.EventHandler).add(this.inputElement, "scroll", this.contentScrollHandler, this);
    };
    RichTextEditor.prototype.wireContextEvent = function() {
        if (this.quickToolbarSettings.showOnRightClick) {
            (0, $aqzbR.EventHandler).add(this.inputElement, "contextmenu", this.contextHandler, this);
            if ((0, $5q7BP.Browser).isDevice) this.touchModule = new (0, $i528u.Touch)(this.inputElement, {
                tapHold: this.touchHandler.bind(this),
                tapHoldThreshold: 500
            });
        }
    };
    RichTextEditor.prototype.unWireContextEvent = function() {
        (0, $aqzbR.EventHandler).remove(this.inputElement, "contextmenu", this.contextHandler);
        if ((0, $5q7BP.Browser).isDevice && this.touchModule) this.touchModule.destroy();
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.unWireScrollElementsEvents = function() {
        this.scrollParentElements = (0, $2vAqh.getScrollableParent)(this.element);
        for(var _i = 0, _a = this.scrollParentElements; _i < _a.length; _i++){
            var element = _a[_i];
            (0, $aqzbR.EventHandler).remove(element, "scroll", this.scrollHandler);
        }
        if (!this.iframeSettings.enable) // Remove the scroll event handler from the inputElement
        (0, $aqzbR.EventHandler).remove(this.inputElement, "scroll", this.contentScrollHandler);
    };
    RichTextEditor.prototype.touchHandler = function(e) {
        this.notifyMouseUp(e.originalEvent);
        this.triggerEditArea(e.originalEvent);
    };
    RichTextEditor.prototype.contextHandler = function(e) {
        var closestElem = (0, $4ZDHT.closest)(e.target, "a, table, img, video, audio");
        if (!closestElem && e.target && e.target.classList && (e.target.classList.contains($afc560df281b588d$export$89572e2cf0e0f6e9) || e.target.classList.contains($afc560df281b588d$export$a13f0f97539de275))) closestElem = e.target.querySelector("audio");
        if (this.inlineMode.onSelection === false || !(0, $3EnZW.isNullOrUndefined)(closestElem) && this.inputElement.contains(closestElem) && (closestElem.tagName === "IMG" || closestElem.tagName === "TABLE" || closestElem.tagName === "A" || closestElem.tagName.toLowerCase() === "video" || closestElem.tagName.toLowerCase() === "audio")) e.preventDefault();
    };
    RichTextEditor.prototype.resetHandler = function() {
        var defaultValue = this.valueContainer.defaultValue.trim();
        this.setProperties({
            value: defaultValue === "" ? null : defaultValue
        });
    };
    /**
     * @returns {void}
     * @hidden

     */ RichTextEditor.prototype.autoResize = function() {
        if (!this.element || !this.originalElement || !this.valueContainer) return;
        if (this.height === "auto") {
            if (this.editorMode === "Markdown") this.setAutoHeight(this.inputElement);
            else if (this.iframeSettings.enable) {
                var iframeElement = this.element.querySelector("#" + this.getID() + "_rte-view");
                if (iframeElement) this.setAutoHeight(iframeElement);
            }
        } else {
            if (this.editorMode === "Markdown") {
                var textArea = this.inputElement;
                var otherElemHeight = this.enableResize || this.showCharCount ? 20 : 0;
                // Three added because of border top of the e-rte-container, bottom of the toolbar wrapper and then bottom of the e-rte-container.
                if (textArea) textArea.style.height = this.element.clientHeight - (this.toolbarModule.getToolbarHeight() + otherElemHeight + 3) + "px";
            } else if (this.iframeSettings.enable) {
                var iframe = this.element.querySelector("#" + this.getID() + "_rte-view");
                var otherElemHeight = this.enableResize || this.showCharCount ? 20 : 0;
                // Three added because of border top of the e-rte-container, bottom of the toolbar wrapper and then bottom of the e-rte-container.
                if (iframe) iframe.style.height = this.element.clientHeight - (this.toolbarModule.getToolbarHeight() + otherElemHeight + 3) + "px";
            }
        }
    };
    RichTextEditor.prototype.setAutoHeight = function(element) {
        if (!(0, $3EnZW.isNullOrUndefined)(element)) {
            if (element.nodeName === "TEXTAREA") {
                element.style.height = "auto";
                element.style.height = this.inputElement.scrollHeight + 16 + "px";
                element.style.overflow = "hidden";
            } else if (element.nodeName === "IFRAME") element.style.height = this.inputElement.parentElement.offsetHeight + "px";
        }
    };
    RichTextEditor.prototype.wireEvents = function() {
        this.onBlurHandler = this.blurHandler.bind(this);
        this.onFocusHandler = this.focusHandler.bind(this);
        this.onResizeHandler = this.resizeHandler.bind(this);
        this.element.addEventListener("focusin", this.onFocusHandler, true);
        this.element.addEventListener("focusout", this.onBlurHandler, true);
        this.on($947a002e9a697770$export$a2ef9682a059097c, this.contentChanged, this);
        this.on($947a002e9a697770$export$89dafc2f17510148, this.updateResizeFlag, this);
        this.on($947a002e9a697770$export$4755fca075b63809, this.updateStatus, this);
        this.on($947a002e9a697770$export$9da6da25c8aa3ca9, this.cleanupResizeElements, this);
        this.on($947a002e9a697770$export$7a1b1fa1df219330, this.updateValueOnIdle, this);
        this.on($947a002e9a697770$export$c1294d1049dd22e8, this.autoResize, this);
        if (this.iframeSettings.enable) {
            this.onLoadHandler = this.iframeEditableElemLoad.bind(this);
            this.contentModule.getEditPanel().addEventListener("load", this.onLoadHandler, true);
        }
        if (this.readonly && this.enabled) return;
        this.bindEvents();
    };
    RichTextEditor.prototype.restrict = function(e) {
        if (this.maxLength >= 0) {
            var element = this.editorMode === "Markdown" ? this.contentModule.getText() : this.getText().replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\u200B/g, "");
            if (!element) return;
            var array = [
                8,
                16,
                17,
                37,
                38,
                39,
                40,
                46,
                65
            ];
            var arrayKey = void 0;
            for(var i = 0; i <= array.length - 1; i++)if (e.which === array[i]) {
                if (e.ctrlKey && e.which === 65) return;
                else if (e.which !== 65) {
                    arrayKey = array[i];
                    return;
                }
            }
            if (element.length >= this.maxLength && this.maxLength !== -1 && e.which !== arrayKey) e.preventDefault();
        }
    };
    RichTextEditor.prototype.bindEvents = function() {
        this.keyboardModule = new (0, $58ad7cf7be602204$export$9bcbcfc970068010)(this.inputElement, {
            keyAction: this.keyDown.bind(this),
            keyConfigs: $95445997b68090e8$var$__assign({}, this.formatter.keyConfig, this.keyConfig),
            eventName: "keydown"
        });
        var formElement = (0, $4ZDHT.closest)(this.valueContainer, "form");
        if (formElement) (0, $aqzbR.EventHandler).add(formElement, "reset", this.resetHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.keyUp, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "paste", this.onPaste, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "content-changed", this.contentChanged, this);
        this.mouseDownDebListener = (0, $3EnZW.debounce)(this.mouseUp, 30);
        (0, $aqzbR.EventHandler).add(this.inputElement, (0, $5q7BP.Browser).touchEndEvent, this.mouseDownDebListener, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownHandler, this);
        (0, $aqzbR.EventHandler).add(this.inputElement, "input", this.inputHandler, this);
        this.wireContextEvent();
        this.formatter.editorManager.observer.on($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.editorKeyDown, this);
        this.element.ownerDocument.defaultView.addEventListener("resize", this.onResizeHandler, true);
        if (this.iframeSettings.enable) {
            (0, $aqzbR.EventHandler).add(this.inputElement, "focusin", this.focusHandler, this);
            (0, $aqzbR.EventHandler).add(this.inputElement, "focusout", this.blurHandler, this);
            (0, $aqzbR.EventHandler).add(this.inputElement.ownerDocument, "scroll", this.contentScrollHandler, this);
            (0, $aqzbR.EventHandler).add(this.inputElement.ownerDocument, (0, $5q7BP.Browser).touchStartEvent, this.onIframeMouseDown, this);
            (0, $aqzbR.EventHandler).add(this.contentModule.getPanel(), "load", this.iframeLoadHandler, this);
        }
        this.wireScrollElementsEvents();
    };
    RichTextEditor.prototype.onIframeMouseDown = function(e) {
        this.isBlur = false;
        this.currentTarget = e.target;
        this.notify($947a002e9a697770$export$b23f8993ab731614, e);
    };
    RichTextEditor.prototype.inputHandler = function() {
        this.autoResize();
    };
    RichTextEditor.prototype.editorKeyDown = function(e) {
        switch(e.event.action){
            case "copy":
                this.onCopy();
                break;
            case "cut":
                this.onCut();
                break;
            case "tab":
                if (this.iframeSettings.enable) this.isBlur = true;
                break;
        }
        if (e.callBack && (e.event.action === "copy" || e.event.action === "cut" || e.event.action === "delete")) e.callBack({
            requestType: e.event.action,
            editorMode: "HTML",
            event: e.event
        });
    };
    RichTextEditor.prototype.unWireEvents = function() {
        this.element.removeEventListener("focusin", this.onFocusHandler, true);
        this.onFocusHandler = null;
        this.element.removeEventListener("focusout", this.onBlurHandler, true);
        this.onBlurHandler = null;
        this.off($947a002e9a697770$export$a2ef9682a059097c, this.contentChanged);
        this.off($947a002e9a697770$export$89dafc2f17510148, this.updateResizeFlag);
        this.off($947a002e9a697770$export$4755fca075b63809, this.updateStatus);
        this.off($947a002e9a697770$export$9da6da25c8aa3ca9, this.cleanupResizeElements);
        this.off($947a002e9a697770$export$7a1b1fa1df219330, this.updateValueOnIdle);
        this.off($947a002e9a697770$export$c1294d1049dd22e8, this.autoResize);
        if (this.iframeSettings.enable) {
            this.contentModule.getEditPanel().removeEventListener("load", this.onLoadHandler, true);
            this.onLoadHandler = null;
        }
        if (this.readonly && this.enabled) return;
        this.unbindEvents();
    };
    RichTextEditor.prototype.unbindEvents = function() {
        if (this.keyboardModule && !this.keyboardModule.isDestroyed) {
            this.keyboardModule.destroy();
            this.keyboardModule = null;
        }
        var formElement = (0, $4ZDHT.closest)(this.valueContainer, "form");
        if (formElement) (0, $aqzbR.EventHandler).remove(formElement, "reset", this.resetHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.keyUp);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "paste", this.onPaste);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "content-changed", this.contentChanged);
        (0, $aqzbR.EventHandler).remove(this.inputElement, (0, $5q7BP.Browser).touchEndEvent, this.mouseDownDebListener);
        this.mouseDownDebListener = null;
        (0, $aqzbR.EventHandler).remove(this.inputElement, (0, $5q7BP.Browser).touchStartEvent, this.mouseDownHandler);
        (0, $aqzbR.EventHandler).remove(this.inputElement, "input", this.inputHandler);
        (0, $aqzbR.EventHandler).remove(document, "mousedown", this.onDocumentClick);
        this.unWireContextEvent();
        if (this.formatter) this.formatter.editorManager.observer.off($ee11fb99ae4d2c3e$export$76852bc82d3e273b, this.editorKeyDown);
        this.element.ownerDocument.defaultView.removeEventListener("resize", this.onResizeHandler, true);
        this.onResizeHandler = null;
        if (this.iframeSettings.enable) {
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focusin", this.focusHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement, "focusout", this.blurHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement.ownerDocument, "scroll", this.contentScrollHandler);
            (0, $aqzbR.EventHandler).remove(this.inputElement.ownerDocument, (0, $5q7BP.Browser).touchStartEvent, this.onIframeMouseDown);
            (0, $aqzbR.EventHandler).remove(this.contentModule.getPanel(), "load", this.iframeLoadHandler);
        }
        this.unWireScrollElementsEvents();
    };
    /**
     *
     * @param {FocusEvent} e - The focus event.
     * @returns {string} Returns the current focus either `editArea` or `toolbar` or `textArea` or `sourceCode` or `outside` of the RichTextEditor.
     * @hidden
     */ RichTextEditor.prototype.getCurrentFocus = function(e) {
        if (e.target === this.inputElement && document.activeElement === this.inputElement) return "editArea";
        else if (e.target === this.getToolbarElement() || !(0, $3EnZW.isNullOrUndefined)(e.relatedTarget) && (0, $4ZDHT.closest)(e.relatedTarget, ".e-rte-toolbar") === this.getToolbarElement()) return "toolbar";
        else if (e.target === this.valueContainer && document.activeElement === this.valueContainer) return "textArea";
        else if (!(0, $3EnZW.isNullOrUndefined)(e.target) && e.target.classList.contains($afc560df281b588d$export$97efb1fe9920382d) && document.activeElement === e.target) return "sourceCode";
        return "outside";
    };
    /**
     * @returns {void}
     * @hidden
     */ RichTextEditor.prototype.resetToolbarTabIndex = function() {
        if (this.getToolbarElement()) {
            var toolbarItem = this.getToolbarElement().querySelectorAll("input,select,button,a,[tabindex]");
            for(var i = 0; i < toolbarItem.length; i++)if (!toolbarItem[i].classList.contains("e-rte-dropdown-btn") && !toolbarItem[i].classList.contains("e-insert-table-btn") && (!toolbarItem[i].hasAttribute("tabindex") || toolbarItem[i].getAttribute("tabindex") !== "-1")) toolbarItem[i].setAttribute("tabindex", "-1");
        }
    };
    RichTextEditor.prototype.removeSelectionClassStates = function(element) {
        var classNames = [
            $afc560df281b588d$export$cab1e7d690401761,
            $afc560df281b588d$export$e959d74fe932d9e5,
            $afc560df281b588d$export$4a8550b2cafbc9fc,
            $afc560df281b588d$export$fb3f256521ea2317,
            $afc560df281b588d$export$2dd5c5a90215b6c1,
            $afc560df281b588d$export$6ca4282c3a1d5fa5
        ];
        for(var i = 0; i < classNames.length; i++){
            var item = element.querySelectorAll("." + classNames[i]);
            (0, $4ZDHT.removeClass)(item, classNames[i]);
            if (item.length === 0) continue;
            for(var j = 0; j < item.length; j++){
                if (item[j].classList.length === 0) item[j].removeAttribute("class");
                if (item[j].nodeName === "IMG" && item[j].style.outline !== "") item[j].style.outline = "";
            }
        }
    };
    RichTextEditor.prototype.getRenderedQuickToolbarElem = function() {
        var quickToolbars = this.quickToolbarModule.getQuickToolbarInstance();
        for(var i = 0; i < quickToolbars.length; i++){
            if (quickToolbars[i] && quickToolbars[i].isRendered) return quickToolbars[i].element;
        }
        return null;
    };
    RichTextEditor.prototype.iframeLoadHandler = function() {
        this.autoResize();
    };
    RichTextEditor.prototype.iframeEditableElemLoad = function() {
        this.autoResize();
    };
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$b468e96770a3e7db))
    ], RichTextEditor.prototype, "toolbarSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({
            enable: false,
            items: [
                "Paragraph",
                "Heading 1",
                "Heading 2",
                "Heading 3",
                "Heading 4",
                "OrderedList",
                "UnorderedList",
                "CodeBlock",
                "Blockquote"
            ],
            popupWidth: "300px",
            popupHeight: "320px"
        }, (0, $bd764ca55277e1f8$export$2eff5ca7ec2411e))
    ], RichTextEditor.prototype, "slashMenuSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$49efec50857bfbcf))
    ], RichTextEditor.prototype, "quickToolbarSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$f209dbc49e40bd87))
    ], RichTextEditor.prototype, "pasteCleanupSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$83bd2b55a538f10c))
    ], RichTextEditor.prototype, "formatPainterSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$f38a1fa0f2038152))
    ], RichTextEditor.prototype, "emojiPickerSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $a82ba10855884ca2$export$18de83c1c630651b))
    ], RichTextEditor.prototype, "iframeSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$40286e2b86ce5e93))
    ], RichTextEditor.prototype, "insertImageSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$da45e41e8d641ff1))
    ], RichTextEditor.prototype, "importWord", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$d12fc001dcc5abdb))
    ], RichTextEditor.prototype, "exportWord", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$f0061bc52b1e55c1))
    ], RichTextEditor.prototype, "exportPdf", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$75b44b566abc4e9c))
    ], RichTextEditor.prototype, "insertAudioSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$40214e6b2a12030d))
    ], RichTextEditor.prototype, "insertVideoSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$114fa93274be7e85))
    ], RichTextEditor.prototype, "tableSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], RichTextEditor.prototype, "floatingToolbarOffset", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $2abafb58e1f41a72$export$db37d2e974887d16))
    ], RichTextEditor.prototype, "inlineMode", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$87d854adb2c15ba4))
    ], RichTextEditor.prototype, "fileManagerSettings", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)("100%")
    ], RichTextEditor.prototype, "width", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enablePersistence", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], RichTextEditor.prototype, "showTooltip", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enableResize", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)({})
    ], RichTextEditor.prototype, "htmlAttributes", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "placeholder", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "autoSaveOnIdle", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "readonly", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], RichTextEditor.prototype, "enabled", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], RichTextEditor.prototype, "enableHtmlSanitizer", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enableHtmlEncode", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enableXhtml", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], RichTextEditor.prototype, "height", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "cssClass", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "value", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)("P")
    ], RichTextEditor.prototype, "enterKey", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)("BR")
    ], RichTextEditor.prototype, "shiftEnterKey", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(30)
    ], RichTextEditor.prototype, "undoRedoSteps", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(300)
    ], RichTextEditor.prototype, "undoRedoTimer", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)("HTML")
    ], RichTextEditor.prototype, "editorMode", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "keyConfig", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "showCharCount", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enableTabKey", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], RichTextEditor.prototype, "enableAutoUrl", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(-1)
    ], RichTextEditor.prototype, "maxLength", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$93514d28bd18d75a))
    ], RichTextEditor.prototype, "format", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$9bf833e1445ffdb4))
    ], RichTextEditor.prototype, "numberFormatList", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$5f8691b1a1529e19))
    ], RichTextEditor.prototype, "bulletFormatList", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$cd0608c167c7849e))
    ], RichTextEditor.prototype, "fontFamily", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$80f2abd03de5ca5a))
    ], RichTextEditor.prototype, "fontSize", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$df33c55a31a69b45))
    ], RichTextEditor.prototype, "fontColor", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Complex)({}, (0, $7a5ef0030307835c$export$a5eaedcf95d1edc1))
    ], RichTextEditor.prototype, "backgroundColor", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "valueTemplate", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(10000)
    ], RichTextEditor.prototype, "saveInterval", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "actionBegin", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "actionComplete", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeDialogOpen", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "dialogOpen", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeDialogClose", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "dialogClose", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeQuickToolbarOpen", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "quickToolbarOpen", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "quickToolbarClose", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "toolbarStatusUpdate", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "updatedToolbarStatus", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "imageSelected", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeImageUpload", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "imageUploading", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "imageUploadSuccess", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "imageUploadFailed", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "imageRemoving", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "afterImageDelete", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "fileSelected", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeFileUpload", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "fileUploading", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "fileUploadSuccess", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "fileUploadFailed", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "fileRemoving", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "afterMediaDelete", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "created", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "destroyed", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeSanitizeHtml", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "blur", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "toolbarClick", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "focus", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "change", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "resizing", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "resizeStart", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "resizeStop", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforePasteCleanup", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "afterPasteCleanup", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "beforeImageDrop", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], RichTextEditor.prototype, "formatter", void 0);
    $95445997b68090e8$var$__decorate([
        (0, $5rsSz.Event)()
    ], RichTextEditor.prototype, "slashMenuItemSelect", void 0);
    RichTextEditor = $95445997b68090e8$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], RichTextEditor);
    return RichTextEditor;
}((0, $hQxLN.Component));

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");

var $2vAqh = parcelRequire("2vAqh");







/**
 * `Table` module is used to handle table actions.
 */ var $c0d8684036271cdd$export$54ec01a60f47d33d = /** @class */ function() {
    function Table(parent, serviceLocator) {
        this.ensureInsideTableList = true;
        this.pageX = null;
        this.pageY = null;
        this.moveEle = null;
        this.currentColumnResize = "";
        this.resizeEndTime = 0;
        this.isTableMoveActive = false;
        this.isResizeBind = true;
        this.parent = parent;
        this.rteID = parent.element.id;
        this.l10n = serviceLocator.getService("rteLocale");
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.addEventListener();
        this.isDestroyed = false;
    }
    Table.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$33bbb3ec7652e187, this.renderDlgContent, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$446aef6294af7f8b, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$815a79e2a317fc9, this.showDialog, this);
        this.parent.on($947a002e9a697770$export$4301237dfe1688e2, this.closeDialog, this);
        this.parent.on($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler, this);
        this.parent.on($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj, this);
        this.parent.on($947a002e9a697770$export$fc73c017dfcf29c9, this.onToolbarAction, this);
        this.parent.on($947a002e9a697770$export$55eface7583121e7, this.dropdownSelect, this);
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.keyDown, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUp, this);
        this.parent.on($947a002e9a697770$export$9ac49ece09f002f8, this.selectionTable, this);
        this.parent.on($947a002e9a697770$export$9e83668a3bc32ff2, this.tableModulekeyUp, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$a4836fff3a9f5351, this.afterKeyDown, this);
    };
    Table.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$33bbb3ec7652e187, this.renderDlgContent);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.afterRender);
        this.parent.off($947a002e9a697770$export$446aef6294af7f8b, this.afterRender);
        this.parent.off($947a002e9a697770$export$49aaf87a462f3eb3, this.docClick);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$815a79e2a317fc9, this.showDialog);
        this.parent.off($947a002e9a697770$export$4301237dfe1688e2, this.closeDialog);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler);
        this.parent.off($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj);
        this.parent.off($947a002e9a697770$export$fc73c017dfcf29c9, this.onToolbarAction);
        this.parent.off($947a002e9a697770$export$55eface7583121e7, this.dropdownSelect);
        this.parent.off($947a002e9a697770$export$ea32a7693b83cfdb, this.cellSelect);
        this.parent.off($947a002e9a697770$export$417c038e951e7489, this.setBGColor);
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.keyDown);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.keyUp);
        this.parent.off($947a002e9a697770$export$9ac49ece09f002f8, this.selectionTable);
        this.parent.off($947a002e9a697770$export$9e83668a3bc32ff2, this.tableModulekeyUp);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$a4836fff3a9f5351, this.afterKeyDown);
        if (!(0, $5q7BP.Browser).isDevice && this.parent.tableSettings.resize) {
            (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), "mouseover", this.resizeHelper);
            (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
        }
    };
    Table.prototype.updateCss = function(currentObj, e) {
        if (currentObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) currentObj.setProperties({
                cssClass: (currentObj.cssClass + " " + e.cssClass).trim()
            });
            else currentObj.setProperties({
                cssClass: (currentObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    Table.prototype.setCssClass = function(e) {
        if (this.popupObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) (0, $4ZDHT.addClass)([
                this.popupObj.element
            ], e.cssClass);
            else {
                (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                    this.popupObj.element
                ], e.oldCssClass);
                (0, $4ZDHT.addClass)([
                    this.popupObj.element
                ], e.cssClass);
            }
        }
        this.updateCss(this.createTableButton, e);
        this.updateCss(this.editdlgObj, e);
        var numericTextBoxObj = [
            this.columnTextBox,
            this.rowTextBox,
            this.tableWidthNum,
            this.tableCellPadding,
            this.tableCellSpacing
        ];
        for(var i = 0; i < numericTextBoxObj.length; i++)this.updateCss(numericTextBoxObj[i], e);
    };
    Table.prototype.selectionTable = function(e) {
        var target = e.args.target;
        if ((0, $5q7BP.Browser).info.name === "mozilla" && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "table")) && (0, $4ZDHT.closest)(target, "table").tagName === "TABLE") this.parent.contentModule.getEditPanel().setAttribute("contenteditable", "true");
    };
    Table.prototype.afterRender = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.contentModule)) {
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            this.parent.on($947a002e9a697770$export$417c038e951e7489, this.setBGColor, this);
            this.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, this.cellSelect, this);
            if (this.parent.tableSettings.resize) (0, $aqzbR.EventHandler).add(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart, this);
            if (!(0, $5q7BP.Browser).isDevice && this.parent.tableSettings.resize) (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), "mouseover", this.resizeHelper, this);
        }
    };
    Table.prototype.dropdownSelect = function(e) {
        var item = e.item;
        if (!document.body.contains(document.body.querySelector(".e-rte-quick-toolbar")) || item.command !== "Table") return;
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var args = {
            args: e,
            selection: this.parent.formatter.editorManager.nodeSelection.save(range, this.contentModule.getDocument()),
            selectParent: this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range)
        };
        switch(item.subCommand){
            case "InsertRowBefore":
            case "InsertRowAfter":
                this.addRow(args.selection, e);
                break;
            case "InsertColumnLeft":
            case "InsertColumnRight":
                this.addColumn(args.selection, e);
                break;
            case "DeleteColumn":
            case "DeleteRow":
                this.removeRowColumn(args.selection, e);
                break;
            case "AlignTop":
            case "AlignMiddle":
            case "AlignBottom":
                this.verticalAlign(args, e);
                break;
            case "Dashed":
            case "Alternate":
            case "Custom":
                this.tableStyles(args, item.subCommand);
                break;
            case "Merge":
            case "VerticalSplit":
            case "HorizontalSplit":
                this.UpdateCells(args.selection, e);
                break;
        }
    };
    Table.prototype.UpdateCells = function(selectCell, e) {
        this.parent.formatter.process(this.parent, e, e, {
            selection: selectCell,
            subCommand: e.item.subCommand
        });
        this.hideTableQuickToolbar();
    };
    Table.prototype.keyUp = function(e) {
        var target = e.args.target;
        if (e.args.key.toLocaleLowerCase() === "escape" && target && target.classList && this.popupObj && !(0, $4ZDHT.closest)(target, "[id='" + this.popupObj.element.id + "'" + "]") && this.popupObj) {
            var createTableToolbarBtn = this.popupObj.relateTo;
            if (createTableToolbarBtn.nodeName !== "BUTTON") {
                createTableToolbarBtn = createTableToolbarBtn.querySelector("span.e-create-table");
                createTableToolbarBtn = createTableToolbarBtn.parentElement;
            }
            this.popupObj.hide();
            if (createTableToolbarBtn) createTableToolbarBtn.focus();
        }
    };
    Table.prototype.keyDown = function(e) {
        var event = e.args;
        // eslint-disable-next-line
        var proxy = this;
        switch(event.action){
            case "escape":
                break;
            case "insert-table":
                this.openDialog(true, e);
                event.preventDefault();
                break;
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && this.contentModule && event.code !== "KeyK") {
            var selection = void 0;
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            var ele = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range)[0];
            ele = ele && ele.tagName !== "TD" && ele.tagName !== "TH" ? ele.parentElement : ele;
            if (event.keyCode === 8 || event.keyCode === 46 || event.ctrlKey && event.keyCode === 88) {
                if (ele && ele.tagName === "TBODY") {
                    if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && this.contentModule) selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.contentModule.getDocument());
                    event.preventDefault();
                    proxy.removeTable(selection, event, true);
                } else if (ele && ele.querySelectorAll("table").length > 0) {
                    this.removeResizeElement();
                    this.hideTableQuickToolbar();
                }
            }
            if (ele && ele.tagName !== "TD" && ele.tagName !== "TH") {
                var closestTd = (0, $4ZDHT.closest)(ele, "td");
                ele = !(0, $3EnZW.isNullOrUndefined)(closestTd) && this.parent.inputElement.contains(closestTd) ? closestTd : ele;
            }
            if (ele && (ele.tagName === "TD" || ele.tagName === "TH")) {
                var selectedEndCell = this.contentModule.getEditPanel().querySelectorAll(".e-cell-select-end");
                if (((0, $3EnZW.isNullOrUndefined)(this.activeCell) || this.activeCell !== ele) && !(0, $3EnZW.isNullOrUndefined)(selectedEndCell) && selectedEndCell.length === 0) this.activeCell = ele;
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && this.contentModule) selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.contentModule.getDocument());
                if (!event.shiftKey || event.shiftKey && event.keyCode === 9) switch(event.keyCode){
                    case 9:
                    case 37:
                    case 39:
                        this.removeCellSelectClasses();
                        proxy.tabSelection(event, selection, ele);
                        break;
                    case 40:
                    case 38:
                        this.removeCellSelectClasses();
                        proxy.tableArrowNavigation(event, selection, ele);
                        break;
                }
            }
        }
        if (event.shiftKey && (event.keyCode === 39 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 40)) {
            this.keyDownEventInstance = event;
            (0, $aqzbR.EventHandler).add(this.parent.contentModule.getDocument(), "selectionchange", this.tableCellsKeyboardSelection, this);
        }
        if (event.ctrlKey && event.key === "a") this.handleSelectAll();
        if ((event.code === "Delete" && event.which === 46 || event.code === "Backspace" && event.which === 8) && this.parent.editorMode === "HTML") {
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            if (range.startContainer.nodeType === Node.ELEMENT_NODE && range.startContainer.nodeName === "DIV" && range.startContainer.classList.contains("e-table-fake-selection")) {
                this.deleteTable();
                event.preventDefault();
            } else {
                var table = event.code === "Delete" && event.which === 46 ? this.getAdjacentTableElement(range, true) : this.getAdjacentTableElement(range, false);
                if (table) {
                    this.updateTableSelection(table);
                    event.preventDefault();
                }
            }
        } else {
            var isShiftEnter = event.shiftKey && event.key === "Enter";
            var isActionKey = $afc560df281b588d$export$860510861cf23e40.indexOf(event.key) !== -1;
            if (isShiftEnter || isActionKey || event.key && event.key.length === 1) {
                var table = this.parent.contentModule.getEditPanel().querySelector("table.e-cell-select");
                if (table) {
                    if (event.keyCode === 39 || event.keyCode === 37) this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), table, 0);
                    else {
                        var firstTd = table.querySelector("tr").cells[0];
                        this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), firstTd, firstTd, 0, 0);
                    }
                }
                this.removeTableSelection();
            }
        }
    };
    Table.prototype.tableCellsKeyboardSelection = function(e) {
        (0, $aqzbR.EventHandler).remove(this.parent.contentModule.getDocument(), "selectionchange", this.tableCellsKeyboardSelection);
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var event = this.keyDownEventInstance;
        var isMultiSelect = !(0, $3EnZW.isNullOrUndefined)(range) && !(0, $3EnZW.isNullOrUndefined)(range.commonAncestorContainer) && range.commonAncestorContainer.nodeType === Node.ELEMENT_NODE && (range.commonAncestorContainer.tagName === "TR" || range.commonAncestorContainer.tagName === "TBODY") && !(0, $3EnZW.isNullOrUndefined)(this.activeCell);
        var selectedEndCell = this.contentModule.getEditPanel().querySelectorAll(".e-cell-select-end");
        if (!(0, $3EnZW.isNullOrUndefined)(selectedEndCell) && selectedEndCell.length > 0) {
            this.parent.formatter.editorManager.nodeSelection.Clear(this.parent.contentModule.getDocument());
            this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.parent.contentModule.getDocument(), selectedEndCell[0], selectedEndCell[0], 0, 0);
            this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(), selectedEndCell[0], 0);
        }
        if (isMultiSelect || !(0, $3EnZW.isNullOrUndefined)(selectedEndCell) && selectedEndCell.length > 0) {
            var cells = this.getCorrespondingColumns();
            var cell = !(0, $3EnZW.isNullOrUndefined)(selectedEndCell) && selectedEndCell.length > 0 ? selectedEndCell[0] : this.activeCell;
            var activeIndexes = this.getCorrespondingIndex(cell, cells);
            var activeCellRowIndex = activeIndexes[0];
            var activeCellColIndex = activeIndexes[1];
            var target = void 0;
            if (event.keyCode === 39) {
                if (activeCellColIndex < cells[0].length - 1) target = cells[activeCellRowIndex][activeCellColIndex + 1];
                else if (activeCellRowIndex < cells.length - 1) {
                    target = cells[activeCellRowIndex + 1][activeCellColIndex];
                    if (selectedEndCell.length === 0 && activeCellRowIndex < cells.length - 1) this.activeCell = cells[activeCellRowIndex][0];
                } else this.resetTableSelection();
            } else if (event.keyCode === 37) {
                if (0 < activeCellColIndex) target = cells[activeCellRowIndex][activeCellColIndex - 1];
                else if (0 < activeCellRowIndex) {
                    target = cells[activeCellRowIndex - 1][activeCellColIndex];
                    if (selectedEndCell.length === 0 && 0 < activeCellRowIndex) this.activeCell = cells[activeCellRowIndex][cells[activeCellRowIndex].length - 1];
                } else this.resetTableSelection();
            } else if (event.keyCode === 38) {
                if (0 < activeCellRowIndex) target = cells[activeCellRowIndex - 1][activeCellColIndex];
                else this.resetTableSelection();
            } else if (event.keyCode === 40) {
                if (activeCellRowIndex < cells.length - 1) target = cells[activeCellRowIndex + 1][activeCellColIndex];
                else this.resetTableSelection();
            }
            if (target) this.parent.formatter.editorManager.observer.notify("TABLE_MOVE", {
                event: {
                    target: target
                },
                selectNode: [
                    this.activeCell
                ]
            });
        }
        if (selectedEndCell.length > 0) {
            event.preventDefault();
            e.preventDefault();
        }
    };
    Table.prototype.resetTableSelection = function() {
        var selectedEndCell = this.contentModule.getEditPanel().querySelectorAll(".e-cell-select-end");
        if (!(0, $3EnZW.isNullOrUndefined)(selectedEndCell) && selectedEndCell.length > 0) this.parent.formatter.editorManager.nodeSelection.setSelectionNode(this.parent.contentModule.getDocument(), this.curTable);
        this.activeCell = null;
        this.removeCellSelectClasses();
        this.removeTableSelection();
    };
    Table.prototype.getCorrespondingColumns = function() {
        var elementArray = [];
        var colspan = 0;
        var allRows = this.curTable.rows;
        for(var i = 0; i <= allRows.length - 1; i++){
            var ele = allRows[i];
            var index = 0;
            for(var j = 0; j <= ele.children.length - 1; j++){
                var colEle = ele.children[j];
                for(var ele_1 = colEle, colspan_1 = parseInt(ele_1.getAttribute("colspan"), 10) || 1, rowSpan = parseInt(ele_1.getAttribute("rowspan"), 10) || 1, rowIndex = i; rowIndex < i + rowSpan; rowIndex++)for(var colIndex = index; colIndex < index + colspan_1; colIndex++){
                    if (!elementArray[rowIndex]) elementArray[rowIndex] = [];
                    if (elementArray[rowIndex][colIndex]) index++;
                    else elementArray[rowIndex][colIndex] = colEle;
                }
                index += colspan;
            }
        }
        return elementArray;
    };
    Table.prototype.getCorrespondingIndex = function(cell, allCells) {
        for(var i = 0; i < allCells.length; i++)for(var j = 0; j < allCells[i].length; j++){
            if (allCells[i][j] === cell) return [
                i,
                j
            ];
        }
        return [];
    };
    Table.prototype.getAdjacentTableElement = function(range, isdelKey) {
        if (!range.collapsed || !isdelKey && this.quickToolObj && this.quickToolObj.tableQTBar && document.body.contains(this.quickToolObj.tableQTBar.element)) return null;
        var nodeCollection = this.getNodeCollection(range);
        var startContainer = range.collapsed && this.parent.contentModule.getEditPanel() === range.startContainer && nodeCollection && nodeCollection.length > 0 && nodeCollection[0] ? nodeCollection[0] : range.startContainer;
        var adjacentElement = this.getSelectedTableEle(nodeCollection);
        var isBrEle = this.getBrElement(range, nodeCollection);
        if (startContainer && startContainer.nodeType === Node.ELEMENT_NODE) {
            if (startContainer.tagName === "IMG" || startContainer.querySelector("img") || startContainer.tagName === "AUDIO" || startContainer.querySelector("audio") || startContainer.tagName === "VIDEO" || startContainer.querySelector("video") || startContainer.querySelector(".e-video-clickelem")) {
                var compareRange = this.contentModule.getDocument().createRange();
                compareRange.collapse(true);
                compareRange.selectNodeContents(startContainer);
                var nodeIndex = this.parent.formatter.editorManager.nodeSelection.getIndex(startContainer);
                if (isdelKey && compareRange.startOffset >= range.startOffset || !isdelKey && (startContainer.tagName !== "IMG" && compareRange.startOffset !== range.startOffset || startContainer.tagName === "IMG" && nodeIndex !== range.startOffset)) return null;
            }
        }
        if (startContainer && startContainer.nodeType === Node.TEXT_NODE) {
            if (isdelKey) {
                if (range.endOffset !== range.endContainer.textContent.length) {
                    if (range.endOffset !== range.endContainer.textContent.trim().length) return null;
                }
            } else if (range.startOffset !== 0) return null;
        }
        if (startContainer && startContainer.nodeType === Node.ELEMENT_NODE && startContainer.tagName === "TABLE") adjacentElement = startContainer;
        if (adjacentElement) {
            var currentEleIndex = this.parent.formatter.editorManager.nodeSelection.getIndex(adjacentElement);
            if (!(range.startOffset === currentEleIndex && isdelKey || range.startOffset !== currentEleIndex && !isdelKey)) adjacentElement = null;
        }
        if (!adjacentElement && startContainer) adjacentElement = this.getAdjacentElementFromDom(startContainer, isBrEle, isdelKey);
        if (adjacentElement && adjacentElement.nodeType === Node.ELEMENT_NODE && adjacentElement.tagName === "TABLE") {
            this.setSelection(adjacentElement, isBrEle);
            return adjacentElement;
        }
        return null;
    };
    Table.prototype.getAdjacentElementFromDom = function(startContainer, isBrEle, isdelKey) {
        var adjacentElement;
        var parentElement = isBrEle ? isBrEle : startContainer.parentNode;
        var currentElement = startContainer;
        while(parentElement && !adjacentElement && parentElement.parentNode){
            var childNodes = Array.from(parentElement.childNodes);
            var startContainerIndex = childNodes.indexOf(currentElement);
            if (startContainerIndex !== -1 && (isdelKey && startContainerIndex < childNodes.length - 1 || !isdelKey && startContainerIndex > 0)) adjacentElement = childNodes[isdelKey ? startContainerIndex + 1 : startContainerIndex - 1];
            else {
                adjacentElement = isdelKey ? parentElement.nextSibling : parentElement.previousSibling;
                currentElement = parentElement;
            }
            if (!isBrEle && startContainer.nodeType === Node.TEXT_NODE && adjacentElement && adjacentElement.tagName && adjacentElement.tagName.toUpperCase() === "BR") {
                isBrEle = currentElement = parentElement = adjacentElement;
                adjacentElement = null;
            }
            if (!isBrEle && adjacentElement && !(adjacentElement.nodeType === Node.ELEMENT_NODE && adjacentElement.tagName === "TABLE") && !(0, $3EnZW.isNullOrUndefined)(adjacentElement.textContent) && !adjacentElement.textContent.trim()) {
                currentElement = parentElement = adjacentElement.parentNode;
                adjacentElement = null;
            }
            if (adjacentElement && adjacentElement.tagName && [
                "UL",
                "OL",
                "LI"
            ].indexOf(adjacentElement.tagName.toUpperCase()) !== -1) {
                adjacentElement = this.getAdjacentElementFromList(adjacentElement, isdelKey);
                if (!adjacentElement) return null;
            }
            if (parentElement && parentElement.tagName && parentElement.tagName.toUpperCase() === "LI" && !isdelKey) adjacentElement = parentElement;
            parentElement = parentElement.parentNode;
        }
        return adjacentElement;
    };
    Table.prototype.getAdjacentElementFromList = function(adjacentElement, isdelKey) {
        while(adjacentElement){
            if (adjacentElement.tagName && [
                "UL",
                "OL",
                "LI"
            ].indexOf(adjacentElement.tagName.toUpperCase()) === -1) {
                if (!(adjacentElement.nodeType === Node.ELEMENT_NODE && adjacentElement.tagName === "TABLE")) adjacentElement = isdelKey ? adjacentElement.firstChild : adjacentElement.lastChild;
                break;
            }
            adjacentElement = isdelKey ? adjacentElement.firstChild : adjacentElement.lastChild;
        }
        return adjacentElement;
    };
    Table.prototype.getNodeCollection = function(range) {
        var nodes = [];
        if (range.collapsed && this.parent.contentModule.getEditPanel() === range.startContainer && range.startContainer.childNodes.length > 0) {
            var index = Math.max(0, Math.min(range.startContainer.childNodes.length - 1, range.endOffset - 1));
            nodes.push(range.startContainer.childNodes[index]);
        } else nodes = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
        return nodes;
    };
    Table.prototype.getSelectedTableEle = function(nodeCollection) {
        if (nodeCollection && nodeCollection.length > 0) for(var _i = 0, _a = Array.from(nodeCollection); _i < _a.length; _i++){
            var element = _a[_i];
            if (element && element.tagName === "TABLE") return element;
        }
        return null;
    };
    Table.prototype.getBrElement = function(range, nodeCollection) {
        if (range.endContainer.tagName === "BR") return range.endContainer;
        if (nodeCollection.length === 1 && nodeCollection[0] && nodeCollection[0].tagName === "BR") return nodeCollection[0];
        return null;
    };
    Table.prototype.setSelection = function(nextElement, isBrEle) {
        if (!nextElement.classList.contains("e-cell-select")) {
            this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
            if (isBrEle) {
                if (isBrEle.parentNode && isBrEle.parentNode.childNodes.length === 1 && isBrEle.parentNode.firstChild.nodeName === "BR") (0, $4ZDHT.detach)(isBrEle.parentNode);
                else (0, $4ZDHT.detach)(isBrEle);
            }
            var fakeSelectionEle = this.parent.createElement("div", {
                className: "e-table-fake-selection"
            });
            fakeSelectionEle.setAttribute("contenteditable", "false");
            this.contentModule.getEditPanel().appendChild(fakeSelectionEle);
            this.parent.formatter.editorManager.nodeSelection.setSelectionNode(this.contentModule.getDocument(), fakeSelectionEle);
        }
    };
    Table.prototype.removeAllFakeSelectionEles = function() {
        var fakeSelectionEles = this.parent.contentModule.getEditPanel().querySelectorAll(".e-table-fake-selection");
        if (fakeSelectionEles && fakeSelectionEles.length > 0) fakeSelectionEles.forEach(function(element) {
            (0, $4ZDHT.detach)(element);
        });
    };
    Table.prototype.deleteTable = function() {
        var table = this.parent.contentModule.getEditPanel().querySelector("table.e-cell-select");
        this.removeResizeElement();
        if (table) {
            var brElement = document.createElement("br");
            var containerEle = brElement;
            if (this.parent.enterKey === "DIV") {
                containerEle = document.createElement("div");
                containerEle.appendChild(brElement);
            } else if (this.parent.enterKey === "P") {
                containerEle = document.createElement("p");
                containerEle.appendChild(brElement);
            }
            table.parentNode.replaceChild(containerEle, table);
            this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), containerEle, containerEle, 0, 0);
            this.removeTableSelection();
        }
    };
    Table.prototype.removeTableSelection = function() {
        var table = this.parent.contentModule.getEditPanel().querySelector("table.e-cell-select");
        if (table) (0, $259257662ca103fc$export$7e42d760c0740ccc)([
            table
        ], $afc560df281b588d$export$e959d74fe932d9e5);
        this.removeAllFakeSelectionEles();
    };
    Table.prototype.updateTableSelection = function(table) {
        (0, $4ZDHT.addClass)([
            table
        ], "e-cell-select");
    };
    Table.prototype.handleSelectAll = function() {
        this.cancelResizeAction();
        var selectedCells = this.parent.inputElement.querySelectorAll("." + $afc560df281b588d$export$e959d74fe932d9e5);
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(selectedCells, $afc560df281b588d$export$e959d74fe932d9e5);
        this.removeTableSelection();
    };
    Table.prototype.tableModulekeyUp = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && this.contentModule) {
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            var ele = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range)[0];
            ele = ele && ele.tagName !== "TD" && ele.tagName !== "TH" ? ele.parentElement : ele;
            if (ele && ele.tagName !== "TD" && ele.tagName !== "TH") {
                var closestTd = (0, $4ZDHT.closest)(ele, "td");
                ele = !(0, $3EnZW.isNullOrUndefined)(closestTd) && this.parent.inputElement.contains(closestTd) ? closestTd : ele;
            }
            var eventArgs = e.args;
            if (this.previousTableElement !== ele && !(0, $3EnZW.isNullOrUndefined)(this.previousTableElement) && !eventArgs.shiftKey && (eventArgs.keyCode === 39 || eventArgs.keyCode === 37 || eventArgs.keyCode === 38 || eventArgs.keyCode === 40)) {
                (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                    this.previousTableElement
                ], $afc560df281b588d$export$e959d74fe932d9e5);
                this.removeTableSelection();
            }
        }
    };
    Table.prototype.openDialog = function(isInternal, e) {
        if (!isInternal) this.parent.contentModule.getEditPanel().focus();
        if (this.parent.editorMode === "HTML") {
            var docElement = this.parent.contentModule.getDocument();
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(docElement);
            var selection = this.parent.formatter.editorManager.nodeSelection.save(range, docElement);
            var args = {
                originalEvent: e ? e.args : {
                    action: "insert-table"
                },
                item: {
                    command: "Table",
                    subCommand: "CreateTable"
                },
                name: !isInternal ? "showDialog" : null
            };
            this.insertTableDialog({
                self: this,
                args: args,
                selection: selection
            });
        }
    };
    Table.prototype.showDialog = function() {
        this.openDialog(false);
        this.setCssClass({
            cssClass: this.parent.getCssClass()
        });
    };
    Table.prototype.closeDialog = function() {
        if (this.editdlgObj) this.editdlgObj.hide({
            returnValue: true
        });
    };
    Table.prototype.onToolbarAction = function(args) {
        var item = args.args.item;
        switch(item.subCommand){
            case "TableHeader":
                this.tableHeader(args.selection, args.args);
                break;
            case "TableRemove":
                this.removeTable(args.selection, args.args);
                break;
            case "TableEditProperties":
                this.editTable(args);
                break;
        }
    };
    Table.prototype.verticalAlign = function(args, e) {
        var tdEle = (0, $4ZDHT.closest)(args.selectParent[0], "th") || (0, $4ZDHT.closest)(args.selectParent[0], "td");
        if (tdEle) this.parent.formatter.process(this.parent, e, e, {
            tableCell: tdEle,
            subCommand: e.item.subCommand
        });
    };
    Table.prototype.tableStyles = function(args, command) {
        var table = (0, $4ZDHT.closest)(args.selectParent[0], "table");
        if (command === "Dashed") {
            /* eslint-disable */ this.parent.element.classList.contains($afc560df281b588d$export$f93d07ccbf22a6e) ? (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                this.parent.element
            ], $afc560df281b588d$export$f93d07ccbf22a6e) : this.parent.element.classList.add($afc560df281b588d$export$f93d07ccbf22a6e);
            table.classList.contains($afc560df281b588d$export$f93d07ccbf22a6e) ? (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                this.parent.element
            ], $afc560df281b588d$export$f93d07ccbf22a6e) : table.classList.add($afc560df281b588d$export$f93d07ccbf22a6e);
        }
        if (command === "Alternate") {
            this.parent.element.classList.contains($afc560df281b588d$export$a5705c5793875560) ? (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                this.parent.element
            ], $afc560df281b588d$export$a5705c5793875560) : this.parent.element.classList.add($afc560df281b588d$export$a5705c5793875560);
            table.classList.contains($afc560df281b588d$export$a5705c5793875560) ? (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                table
            ], $afc560df281b588d$export$a5705c5793875560) : table.classList.add($afc560df281b588d$export$a5705c5793875560);
        /* eslint-enable */ }
        if (args.args && args.args.item.cssClass) {
            var classList = args.args.item.cssClass.split(" ");
            for(var i = 0; i < classList.length; i++)if (table.classList.contains(classList[i])) (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                table
            ], classList[i]);
            else table.classList.add(classList[i]);
        }
        this.parent.formatter.saveData();
        this.hideTableQuickToolbar();
        this.parent.formatter.editorManager.nodeSelection.restore();
    };
    Table.prototype.insideList = function(range) {
        var blockNodes = this.parent.formatter.editorManager.domNode.blockNodes();
        var nodes = [];
        for(var i = 0; i < blockNodes.length; i++){
            if (blockNodes[i].parentNode.tagName === "LI") nodes.push(blockNodes[i].parentNode);
            else if (blockNodes[i].tagName === "LI" && blockNodes[i].childNodes[0].tagName !== "P" && blockNodes[i].childNodes[0].tagName !== "OL" && blockNodes[i].childNodes[0].tagName !== "UL") nodes.push(blockNodes[i]);
        }
        if (nodes.length > 1 || nodes.length && range.startOffset === 0 && range.endOffset === 0) {
            this.ensureInsideTableList = true;
            return true;
        } else {
            this.ensureInsideTableList = false;
            return false;
        }
    };
    Table.prototype.removeEmptyTextNodes = function(element) {
        var children = element.childNodes;
        for(var i = children.length - 1; i >= 0; i--){
            var node = children[i];
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() === "") element.removeChild(node);
        }
    };
    Table.prototype.tabSelection = function(event, selection, ele) {
        var allHeadBodyTRElements = ele.closest("table").querySelectorAll("thead, tbody, tr");
        for(var i = 0; i < allHeadBodyTRElements.length; i++)this.removeEmptyTextNodes(allHeadBodyTRElements[i]);
        this.previousTableElement = ele;
        var insideList = this.insideList(selection.range);
        if ((event.keyCode === 37 || event.keyCode === 39) && selection.range.startContainer.nodeType === 3 || insideList) return;
        event.preventDefault();
        (0, $259257662ca103fc$export$7e42d760c0740ccc)([
            ele
        ], $afc560df281b588d$export$e959d74fe932d9e5);
        this.removeTableSelection();
        if (!event.shiftKey && event.keyCode !== 37) {
            var nextElement = !(0, $3EnZW.isNullOrUndefined)(ele.nextSibling) ? ele.nextSibling : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "tr").nextSibling) ? (0, $4ZDHT.closest)(ele, "tr").nextSibling.childNodes[0] : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "table").nextSibling) ? (0, $4ZDHT.closest)(ele, "table").nextSibling.nodeName.toLowerCase() === "td" ? (0, $4ZDHT.closest)(ele, "table").nextSibling : ele : ele;
            if (ele === nextElement && ele.nodeName === "TH") nextElement = (0, $4ZDHT.closest)(ele, "table").rows[1].cells[0];
            if (event.keyCode === 39 && ele === nextElement) nextElement = (0, $4ZDHT.closest)(ele, "table").nextSibling;
            if (nextElement) // eslint-disable-next-line
            nextElement.textContent.trim() !== "" && (0, $4ZDHT.closest)(nextElement, "td") ? selection.setSelectionNode(this.contentModule.getDocument(), nextElement) : selection.setSelectionText(this.contentModule.getDocument(), nextElement, nextElement, 0, 0);
            if (ele === nextElement && event.keyCode !== 39 && nextElement) {
                ele.classList.add($afc560df281b588d$export$e959d74fe932d9e5);
                this.addRow(selection, event, true);
                (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                    ele
                ], $afc560df281b588d$export$e959d74fe932d9e5);
                this.removeTableSelection();
                nextElement = nextElement.parentElement.nextSibling ? nextElement.parentElement.nextSibling.firstChild : nextElement.parentElement.firstChild;
                // eslint-disable-next-line
                nextElement.textContent.trim() !== "" && (0, $4ZDHT.closest)(nextElement, "td") ? selection.setSelectionNode(this.contentModule.getDocument(), nextElement) : selection.setSelectionText(this.contentModule.getDocument(), nextElement, nextElement, 0, 0);
            }
        } else {
            var prevElement = !(0, $3EnZW.isNullOrUndefined)(ele.previousSibling) ? ele.previousSibling : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "tr").previousSibling) ? (0, $4ZDHT.closest)(ele, "tr").previousSibling.childNodes[(0, $4ZDHT.closest)(ele, "tr").previousSibling.childNodes.length - 1] : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "table").previousSibling) ? (0, $4ZDHT.closest)(ele, "table").previousSibling.nodeName.toLowerCase() === "td" ? (0, $4ZDHT.closest)(ele, "table").previousSibling : ele : ele;
            if (ele === prevElement && ele.cellIndex === 0 && (0, $4ZDHT.closest)(ele, "table").tHead) {
                var clsTble = (0, $4ZDHT.closest)(ele, "table");
                prevElement = clsTble.rows[0].cells[clsTble.rows[0].cells.length - 1];
            }
            if (event.keyCode === 37 && ele === prevElement) prevElement = (0, $4ZDHT.closest)(ele, "table").previousSibling;
            if (prevElement) // eslint-disable-next-line
            prevElement.textContent.trim() !== "" && (0, $4ZDHT.closest)(prevElement, "td") ? selection.setSelectionNode(this.contentModule.getDocument(), prevElement) : selection.setSelectionText(this.contentModule.getDocument(), prevElement, prevElement, 0, 0);
        }
    };
    Table.prototype.tableArrowNavigation = function(event, selection, ele) {
        var selText = selection.range.startContainer;
        if (event.keyCode === 40 && selText.nodeType === 3 && (selText.nextSibling && selText.nextSibling.nodeName === "BR" || selText.parentNode && selText.parentNode.nodeName !== "TD") || event.keyCode === 38 && selText.nodeType === 3 && (selText.previousSibling && selText.previousSibling.nodeName === "BR" || selText.parentNode && selText.parentNode.nodeName !== "TD")) return;
        event.preventDefault();
        (0, $259257662ca103fc$export$7e42d760c0740ccc)([
            ele
        ], $afc560df281b588d$export$e959d74fe932d9e5);
        this.removeTableSelection();
        if (event.keyCode === 40) ele = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "tr").nextElementSibling) ? (0, $4ZDHT.closest)(ele, "tr").nextElementSibling.children[ele.cellIndex] : (0, $4ZDHT.closest)(ele, "table").tHead && ele.nodeName === "TH" ? (0, $4ZDHT.closest)(ele, "table").rows[1].cells[ele.cellIndex] : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "table").nextSibling) ? (0, $4ZDHT.closest)(ele, "table").nextSibling : ele;
        else ele = !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "tr").previousElementSibling) ? (0, $4ZDHT.closest)(ele, "tr").previousElementSibling.children[ele.cellIndex] : (0, $4ZDHT.closest)(ele, "table").tHead && ele.nodeName !== "TH" ? (0, $4ZDHT.closest)(ele, "table").tHead.rows[0].cells[ele.cellIndex] : !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(ele, "table").previousSibling) ? (0, $4ZDHT.closest)(ele, "table").previousSibling : ele;
        if (ele) selection.setSelectionText(this.contentModule.getDocument(), ele, ele, 0, 0);
    };
    Table.prototype.setBGColor = function(args) {
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
        // eslint-disable-next-line
        var selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.contentModule.getDocument());
        // eslint-disable-next-line
        var selectedCells = this.curTable.querySelectorAll(".e-cell-select");
        for(var i = 0; i < selectedCells.length; i++)selectedCells[i].style.backgroundColor = args.item.value;
        this.parent.formatter.saveData();
        this.hideTableQuickToolbar();
    };
    Table.prototype.hideTableQuickToolbar = function() {
        if (this.quickToolObj && this.quickToolObj.tableQTBar && document.body.contains(this.quickToolObj.tableQTBar.element)) this.quickToolObj.tableQTBar.hidePopup();
    };
    Table.prototype.tableHeader = function(selection, e) {
        this.parent.formatter.process(this.parent, e, e.originalEvent, {
            selection: selection,
            subCommand: e.item.subCommand
        });
    };
    Table.prototype.getAnchorNode = function(element) {
        var selectParent = (0, $4ZDHT.closest)(element, "a");
        return selectParent ? selectParent : element;
    };
    Table.prototype.editAreaClickHandler = function(e) {
        if (this.parent.readonly || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.args.target, ".e-img-caption"))) return;
        var args = e.args;
        var showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (args.which === 2 || showOnRightClick && args.which === 1 || !showOnRightClick && args.which === 3) return;
        if (this.parent.editorMode === "HTML" && this.parent.quickToolbarModule && this.parent.quickToolbarModule.tableQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
            var target = args.target;
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var isPopupOpen = this.quickToolObj.tableQTBar.element.classList.contains("e-rte-pop");
            if (isPopupOpen) return;
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
            var closestTable = (0, $4ZDHT.closest)(target, "table");
            var startNode = this.parent.getRange().startContainer.parentElement;
            var endNode = this.parent.getRange().endContainer.parentElement;
            var isAnchorEle = this.getAnchorNode(target);
            var currentTime = new Date().getTime();
            if (target && target.nodeName !== "A" && isAnchorEle.nodeName !== "A" && target.nodeName !== "IMG" && target.nodeName !== "VIDEO" && !target.classList.contains($afc560df281b588d$export$a13f0f97539de275) && target.nodeName !== "AUDIO" && startNode === endNode && (target.nodeName === "TD" || target.nodeName === "TH" || target.nodeName === "TABLE" || closestTable && this.parent.contentModule.getEditPanel().contains(closestTable)) && !(range.startContainer.nodeType === 3 && !range.collapsed) && currentTime - this.resizeEndTime > 100) {
                var range_1 = this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.save(range_1, this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                var pageX = void 0;
                var pageY = void 0;
                if ((0, $5q7BP.Browser).isDevice && e.args.touches) {
                    pageX = this.parent.iframeSettings.enable ? window.pageXOffset + this.parent.element.getBoundingClientRect().left + e.args.changedTouches[0].clientX : e.args.changedTouches[0].pageX;
                    pageY = this.parent.iframeSettings.enable ? window.pageYOffset + this.parent.element.getBoundingClientRect().top + (!this.parent.inlineMode.enable ? this.parent.toolbarModule.getToolbarHeight() : 0) + e.args.changedTouches[0].clientY : e.args.changedTouches[0].pageY;
                } else {
                    pageX = this.parent.iframeSettings.enable ? window.pageXOffset + this.parent.element.getBoundingClientRect().left + args.clientX : args.pageX;
                    pageY = this.parent.iframeSettings.enable ? window.pageYOffset + this.parent.element.getBoundingClientRect().top + this.parent.toolbarModule.getToolbarHeight() + args.clientY : args.pageY;
                }
                this.quickToolObj.tableQTBar.showPopup(pageX, pageY, target);
                this.parent.formatter.editorManager.nodeSelection.restore();
            } else this.hideTableQuickToolbar();
        }
    };
    Table.prototype.tableCellSelect = function(e) {
        var target = e.target;
        var row = Array.prototype.slice.call(target.parentElement.parentElement.children).indexOf(target.parentElement);
        var col = Array.prototype.slice.call(target.parentElement.children).indexOf(target);
        var list = this.dlgDiv.querySelectorAll(".e-rte-tablecell");
        Array.prototype.forEach.call(list, function(item) {
            var parentIndex = Array.prototype.slice.call(item.parentElement.parentElement.children).indexOf(item.parentElement);
            var cellIndex = Array.prototype.slice.call(item.parentElement.children).indexOf(item);
            (0, $259257662ca103fc$export$7e42d760c0740ccc)([
                item
            ], "e-active");
            if (parentIndex <= row && cellIndex <= col) (0, $4ZDHT.addClass)([
                item
            ], "e-active");
        });
        this.tblHeader.innerHTML = col + 1 + "x" + (row + 1);
    };
    Table.prototype.tableMouseUp = function() {
        this.unwireTableSelectionEvents();
        this.isTableMoveActive = false;
    };
    Table.prototype.tableMouseLeave = function() {
        this.unwireTableSelectionEvents();
        this.isTableMoveActive = false;
        this.resetTableSelection();
    };
    // eslint-disable-next-line
    Table.prototype.tableCellLeave = function(e) {
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.dlgDiv.querySelectorAll(".e-rte-tablecell"), "e-active");
        (0, $4ZDHT.addClass)([
            this.dlgDiv.querySelector(".e-rte-tablecell")
        ], "e-active");
        this.tblHeader.innerHTML = "1x1";
    };
    Table.prototype.tableCellClick = function(e) {
        var target = e.target;
        var row = Array.prototype.slice.call(target.parentElement.parentElement.children).indexOf(target.parentElement) + 1;
        var col = Array.prototype.slice.call(target.parentElement.children).indexOf(target) + 1;
        this.self.tableInsert(row, col, e, this);
    };
    Table.prototype.tableInsert = function(row, col, e, selectionObj) {
        var proxy = selectionObj.self ? selectionObj.self : this;
        var startContainer = selectionObj.selection.range.startContainer;
        if (startContainer.nodeName === "P" && startContainer.textContent.trim() === "" && !(startContainer.childNodes.length > 0)) startContainer.innerHTML = "<br />";
        var parentNode = startContainer.parentNode;
        if (proxy.parent.editorMode === "HTML" && (proxy.parent.iframeSettings.enable && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(parentNode.ownerDocument.querySelector("body"), "e-lib") || // eslint-disable-next-line
        !proxy.parent.iframeSettings.enable && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(parentNode, "[id='" + proxy.contentModule.getPanel().id + "'" + "]")))) {
            proxy.contentModule.getEditPanel().focus();
            var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.contentModule.getDocument());
            selectionObj.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.contentModule.getDocument());
        }
        var value = {
            rows: row,
            columns: col,
            width: {
                minWidth: proxy.parent.tableSettings.minWidth,
                maxWidth: proxy.parent.tableSettings.maxWidth,
                width: proxy.parent.tableSettings.width
            },
            selection: selectionObj.selection
        };
        if (proxy.popupObj) {
            var rows = Array.prototype.slice.call(e.target.parentElement.parentElement.children);
            for(var i = 0; i < rows.length; i++){
                (0, $aqzbR.EventHandler).remove(rows[i], "mouseleave", this.tableCellLeave);
                var cells = Array.prototype.slice.call(rows[i].children);
                for(var j = 0; j < cells.length; j++){
                    (0, $aqzbR.EventHandler).remove(cells[j], "mousemove", this.tableCellSelect);
                    (0, $aqzbR.EventHandler).remove(cells[j], "mouseup", this.tableCellClick);
                }
            }
            proxy.popupObj.hide();
        }
        if (proxy.editdlgObj) proxy.editdlgObj.hide();
        var x = window.scrollX;
        var y = window.scrollY;
        proxy.parent.formatter.process(proxy.parent, selectionObj.args, selectionObj.args.originalEvent, value);
        proxy.contentModule.getEditPanel().focus();
        window.scrollTo(x, y);
        proxy.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, proxy.cellSelect, proxy);
        var selection = proxy.parent.formatter.editorManager.nodeSelection.get(proxy.contentModule.getDocument());
        if (!(0, $3EnZW.isNullOrUndefined)(selection) && !(0, $3EnZW.isNullOrUndefined)(selection.anchorNode) && selection.anchorNode.nodeType === Node.ELEMENT_NODE && (selection.anchorNode.tagName === "TD" || selection.anchorNode.tagName === "TH")) {
            proxy.curTable = (0, $4ZDHT.closest)(selection.anchorNode, "table");
            proxy.activeCell = selection.anchorNode;
        }
    };
    Table.prototype.cellSelect = function(e) {
        var target = e.args.target;
        var tdNode = (0, $4ZDHT.closest)(target, "td,th");
        target = target.nodeName !== "TD" && tdNode && this.parent.contentModule.getEditPanel().contains(tdNode) ? tdNode : target;
        if (!(0, $3EnZW.isNullOrUndefined)(this.activeCell) && e.args.shiftKey && !(0, $3EnZW.isNullOrUndefined)(target) && !(0, $3EnZW.isNullOrUndefined)(target.tagName) && (target.tagName === "TD" || target.tagName === "TH") && this.activeCell !== target) {
            this.parent.formatter.editorManager.observer.notify("TABLE_MOVE", {
                event: e.args,
                selectNode: [
                    this.activeCell
                ]
            });
            e.args.preventDefault();
            return;
        }
        if (!(this.parent.quickToolbarSettings.showOnRightClick && e.args.which === 3 && target.classList.contains($afc560df281b588d$export$e959d74fe932d9e5))) {
            if (this.isTableMoveActive) {
                this.unwireTableSelectionEvents();
                this.isTableMoveActive = false;
            }
            this.activeCell = null;
            this.removeCellSelectClasses();
            this.removeTableSelection();
        }
        if (target && (target.tagName === "TD" || target.tagName === "TH")) {
            (0, $4ZDHT.addClass)([
                target
            ], $afc560df281b588d$export$e959d74fe932d9e5);
            this.activeCell = target;
            this.curTable = this.curTable ? this.curTable : (0, $4ZDHT.closest)(target, "table");
            this.wireTableSelectionEvents();
            this.isTableMoveActive = true;
            this.removeResizeElement();
            if (this.helper && this.contentModule.getEditPanel().contains(this.helper)) (0, $4ZDHT.detach)(this.helper);
        }
        if ((0, $5q7BP.Browser).info.name === "mozilla" && !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(target, "table")) && (0, $4ZDHT.closest)(target, "table").tagName === "TABLE") this.parent.contentModule.getEditPanel().setAttribute("contenteditable", "false");
    };
    Table.prototype.wireTableSelectionEvents = function() {
        (0, $aqzbR.EventHandler).add(this.curTable, "mousemove", this.tableMove, this);
        (0, $aqzbR.EventHandler).add(this.curTable, "mouseup", this.tableMouseUp, this);
        (0, $aqzbR.EventHandler).add(this.curTable, "mouseleave", this.tableMouseLeave, this);
    };
    Table.prototype.unwireTableSelectionEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.curTable, "mousemove", this.tableMove);
        (0, $aqzbR.EventHandler).remove(this.curTable, "mouseup", this.tableMouseUp);
        (0, $aqzbR.EventHandler).remove(this.curTable, "mouseleave", this.tableMouseLeave);
    };
    Table.prototype.removeCellSelectClasses = function() {
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.contentModule.getEditPanel().querySelectorAll("table td, table th"), $afc560df281b588d$export$fb3f256521ea2317);
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.contentModule.getEditPanel().querySelectorAll("table td, table th"), $afc560df281b588d$export$4a8550b2cafbc9fc);
        (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.contentModule.getEditPanel().querySelectorAll("table td, table th"), $afc560df281b588d$export$e959d74fe932d9e5);
    };
    Table.prototype.tableMove = function(event) {
        this.parent.formatter.editorManager.observer.notify("TABLE_MOVE", {
            event: event,
            selectNode: [
                this.activeCell
            ]
        });
    };
    Table.prototype.resizeHelper = function(e) {
        if (this.parent.readonly) return;
        if (this.isTableMoveActive) return;
        if (e && e.buttons && e.buttons > 0) return;
        var target = e.target || e.targetTouches[0].target;
        var closestTable = (0, $4ZDHT.closest)(target, "table.e-rte-table, table.e-rte-paste-table");
        var isResizing = this.parent.contentModule.getEditPanel().querySelectorAll(".e-table-box.e-rbox-select, .e-table-rhelper.e-column-helper, .e-table-rhelper.e-row-helper").length > 0;
        if (!isResizing && !(0, $3EnZW.isNullOrUndefined)(this.curTable) && !(0, $3EnZW.isNullOrUndefined)(closestTable) && closestTable !== this.curTable && this.parent.contentModule.getEditPanel().contains(closestTable)) {
            this.removeResizeElement();
            this.removeHelper(e);
            this.cancelResizeAction();
        }
        if (!isResizing && (target.nodeName === "TABLE" || target.nodeName === "TD" || target.nodeName === "TH")) {
            this.curTable = closestTable && this.parent.contentModule.getEditPanel().contains(closestTable) && (target.nodeName === "TD" || target.nodeName === "TH") ? closestTable : target;
            this.removeResizeElement();
            this.tableResizeEleCreation(this.curTable, e);
        }
    };
    Table.prototype.tableResizeEleCreation = function(table, e) {
        this.parent.preventDefaultResize(e);
        var columns = this.calMaxCol(this.curTable);
        var rows = [];
        for(var i = 0; i < table.rows.length; i++){
            for(var j = 0; j < table.rows[i].cells.length; j++)if (!table.rows[i].cells[j].hasAttribute("rowspan")) {
                rows.push(Array.prototype.slice.call(table.rows[i].cells, 0, table.rows[i].cells.length)[j]);
                break;
            }
        }
        var height = parseInt(getComputedStyle(table).height, 10);
        var width = parseInt(getComputedStyle(table).width, 10);
        var pos = this.calcPos(table);
        for(var i = 0; columns.length >= i; i++){
            var colReEle = this.parent.createElement("span", {
                attrs: {
                    "data-col": i.toString(),
                    "unselectable": "on",
                    "contenteditable": "false"
                }
            });
            colReEle.classList.add($afc560df281b588d$export$55d7db1e6ef8e042, $afc560df281b588d$export$97001d3d2f729a40);
            if (columns.length === i) colReEle.style.cssText = "height: " + height + "px; width: 4px; top: " + pos.top + "px; left:" + ((columns[i - 1].classList.contains("e-multi-cells-select") ? 0 : pos.left) + this.calcPos(columns[i - 1]).left + columns[i - 1].offsetWidth - 2) + "px;";
            else colReEle.style.cssText = "height: " + height + "px; width: 4px; top: " + pos.top + "px; left:" + ((columns[i].classList.contains("e-multi-cells-select") ? 0 : pos.left) + this.calcPos(columns[i]).left - 2) + "px;";
            this.contentModule.getEditPanel().appendChild(colReEle);
        }
        for(var i = 0; rows.length > i; i++){
            var rowReEle = this.parent.createElement("span", {
                attrs: {
                    "data-row": i.toString(),
                    "unselectable": "on",
                    "contenteditable": "false"
                }
            });
            rowReEle.classList.add($afc560df281b588d$export$55d7db1e6ef8e042, $afc560df281b588d$export$f3e568bf9fb0b3e0);
            var rowPosLeft = !(0, $3EnZW.isNullOrUndefined)(table.getAttribute("cellspacing")) || table.getAttribute("cellspacing") !== "" ? 0 : this.calcPos(rows[i]).left;
            rowReEle.style.cssText = "width: " + width + "px; height: 4px; top: " + (this.calcPos(rows[i]).top + (rows[i].classList.contains("e-multi-cells-select") ? 0 : pos.top) + rows[i].offsetHeight - 2) + "px; left:" + (rowPosLeft + pos.left) + "px;";
            this.contentModule.getEditPanel().appendChild(rowReEle);
        }
        var tableReBox = this.parent.createElement("span", {
            className: $afc560df281b588d$export$d56486b0aa3bd575 + this.parent.getCssClass(true),
            attrs: {
                "data-col": columns.length.toString(),
                "unselectable": "on",
                "contenteditable": "false"
            }
        });
        tableReBox.style.cssText = "top: " + (pos.top + height - 4) + "px; left:" + (pos.left + width - 4) + "px;";
        if ((0, $5q7BP.Browser).isDevice) tableReBox.classList.add("e-rmob");
        this.contentModule.getEditPanel().appendChild(tableReBox);
    };
    Table.prototype.removeResizeElement = function() {
        var item = this.parent.contentModule.getEditPanel().querySelectorAll(".e-column-resize, .e-row-resize, .e-table-box");
        if (item.length > 0) for(var i = 0; i < item.length; i++)(0, $4ZDHT.detach)(item[i]);
    };
    Table.prototype.calcPos = function(elem) {
        var parentOffset = {
            top: 0,
            left: 0
        };
        var offset = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var offsetParent = elem.offsetParent || doc.documentElement;
        var isNestedTable = false;
        while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && offsetParent.style.position === "static")offsetParent = offsetParent.parentNode;
        if (offsetParent.nodeName === "TD" && elem.nodeName === "TABLE") {
            offsetParent = (0, $4ZDHT.closest)(offsetParent, ".e-rte-content");
            isNestedTable = true;
        }
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) parentOffset = offsetParent.getBoundingClientRect();
        if (isNestedTable) {
            isNestedTable = false;
            var topValue = this.parent.inputElement && this.parent.inputElement.scrollTop > 0 ? this.parent.inputElement.scrollTop + offset.top - parentOffset.top : offset.top - parentOffset.top;
            var leftValue = this.parent.inputElement && this.parent.inputElement.scrollLeft > 0 ? this.parent.inputElement.scrollLeft + offset.left - parentOffset.left : offset.left - parentOffset.left;
            return {
                top: topValue,
                left: leftValue
            };
        } else return {
            top: elem.offsetTop,
            left: elem.offsetLeft
        };
    };
    Table.prototype.getPointX = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageX;
        else return e.pageX;
    };
    Table.prototype.getPointY = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageY;
        else return e.pageY;
    };
    Table.prototype.resizeStart = function(e) {
        var _this = this;
        if (this.parent.readonly) return;
        if ((0, $5q7BP.Browser).isDevice) this.resizeHelper(e);
        var target = e.target;
        if (target.classList.contains($afc560df281b588d$export$97001d3d2f729a40) || target.classList.contains($afc560df281b588d$export$f3e568bf9fb0b3e0) || target.classList.contains($afc560df281b588d$export$d56486b0aa3bd575)) {
            this.resetResizeHelper(this.curTable);
            e.preventDefault();
            this.parent.preventDefaultResize(e);
            (0, $259257662ca103fc$export$7e42d760c0740ccc)(this.curTable.querySelectorAll("td,th"), $afc560df281b588d$export$e959d74fe932d9e5);
            this.removeTableSelection();
            this.pageX = this.getPointX(e);
            this.pageY = this.getPointY(e);
            this.resizeBtnInit();
            this.hideTableQuickToolbar();
            if (target.classList.contains($afc560df281b588d$export$97001d3d2f729a40)) {
                this.resizeBtnStat.column = true;
                if (parseInt(target.getAttribute("data-col"), 10) === this.calMaxCol(this.curTable).length) {
                    this.currentColumnResize = "last";
                    this.colIndex = parseInt(target.getAttribute("data-col"), 10) - 1;
                    this.columnEle = this.calMaxCol(this.curTable)[this.colIndex];
                } else {
                    if (parseInt(target.getAttribute("data-col"), 10) === 0) this.currentColumnResize = "first";
                    else {
                        this.currentColumnResize = "middle";
                        var cellColl = this.curTable.rows[0].cells;
                        var cellCount = 0;
                        for(var cell = 0; cell < cellColl.length; cell++)cellCount = cellCount + cellColl[cell].colSpan;
                        var sizes = new Array(cellCount);
                        var colGroupEle = (0, $4ZDHT.createElement)("colgroup");
                        var rowSpanCells = new Map();
                        for(var i = 0; i < this.curTable.rows.length; i++){
                            var currentColIndex = 0;
                            for(var k = 0; k < this.curTable.rows[i].cells.length; k++){
                                for(var l = 1; l < this.curTable.rows[i].cells[k].rowSpan; l++){
                                    var key = "" + (i + l) + currentColIndex;
                                    rowSpanCells.set(key, this.curTable.rows[i].cells[k]);
                                }
                                var cellIndex = this.getCellIndex(rowSpanCells, i, k);
                                if (cellIndex > currentColIndex) currentColIndex = cellIndex;
                                var width = this.curTable.rows[i].cells[k].offsetWidth;
                                if (!sizes[currentColIndex] || width < sizes[currentColIndex]) sizes[currentColIndex] = width;
                                currentColIndex += 1 + this.curTable.rows[i].cells[k].colSpan - 1;
                            }
                        }
                        for(var size = 0; size < sizes.length; size++){
                            var cell = (0, $4ZDHT.createElement)("col");
                            cell.appendChild((0, $4ZDHT.createElement)("br"));
                            cell.style.width = this.convertPixelToPercentage(sizes[size], parseInt(getComputedStyle(this.curTable).width, 10)) + "%";
                            colGroupEle.appendChild(cell);
                        }
                        this.curTable.insertBefore(colGroupEle, this.curTable.firstChild);
                        for(var i = 0; i < this.curTable.rows.length; i++)for(var k = 0; k < this.curTable.rows[i].cells.length; k++)this.curTable.rows[i].cells[k].style.width = "";
                    }
                    this.colIndex = parseInt(target.getAttribute("data-col"), 10);
                    this.columnEle = this.calMaxCol(this.curTable)[this.colIndex];
                }
                this.moveEle = e.target;
                this.appendHelper();
            }
            if (target.classList.contains($afc560df281b588d$export$f3e568bf9fb0b3e0)) {
                this.rowEle = this.curTable.rows[parseInt(target.getAttribute("data-row"), 10)];
                this.resizeBtnStat.row = true;
                this.appendHelper();
            }
            if (target.classList.contains($afc560df281b588d$export$d56486b0aa3bd575)) this.resizeBtnStat.tableBox = true;
            if ((0, $5q7BP.Browser).isDevice && this.helper && !this.helper.classList.contains("e-reicon")) {
                this.helper.classList.add("e-reicon");
                (0, $aqzbR.EventHandler).add(document, (0, $5q7BP.Browser).touchStartEvent, this.removeHelper, this);
                (0, $aqzbR.EventHandler).add(this.helper, (0, $5q7BP.Browser).touchStartEvent, this.resizeStart, this);
            } else {
                var args = {
                    event: e,
                    requestType: "Table"
                };
                this.parent.trigger($947a002e9a697770$export$6aff6a45c0c4e7c4, args, function(resizeStartArgs) {
                    if (resizeStartArgs.cancel) _this.cancelResizeAction();
                });
            }
            if (this.isResizeBind) {
                (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing, this);
                (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd, this);
                this.isResizeBind = false;
            }
        }
    };
    Table.prototype.getCellIndex = function(rowSpanCells, rowIndex, colIndex) {
        var cellKey = "" + rowIndex + colIndex;
        var spannedCell = rowSpanCells.get(cellKey);
        if (spannedCell) return this.getCellIndex(rowSpanCells, rowIndex, colIndex + spannedCell.colSpan);
        else return colIndex;
    };
    Table.prototype.removeHelper = function(e) {
        var cls = e.target.classList;
        if (!cls.contains("e-reicon") && this.helper) {
            (0, $aqzbR.EventHandler).remove(document, (0, $5q7BP.Browser).touchStartEvent, this.removeHelper);
            (0, $aqzbR.EventHandler).remove(this.helper, (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
            if (this.helper && this.contentModule.getEditPanel().contains(this.helper)) (0, $4ZDHT.detach)(this.helper);
            this.pageX = null;
            this.helper = null;
        }
    };
    Table.prototype.appendHelper = function() {
        this.helper = this.parent.createElement("div", {
            className: "e-table-rhelper" + this.parent.getCssClass(true)
        });
        if ((0, $5q7BP.Browser).isDevice) this.helper.classList.add("e-reicon");
        this.contentModule.getEditPanel().appendChild(this.helper);
        this.setHelperHeight();
    };
    Table.prototype.setHelperHeight = function() {
        var pos = this.calcPos(this.curTable);
        if (this.resizeBtnStat.column) {
            this.helper.classList.add("e-column-helper");
            this.helper.style.cssText = "height: " + getComputedStyle(this.curTable).height + "; top: " + pos.top + "px; left:" + (pos.left + this.calcPos(this.columnEle).left + (this.currentColumnResize === "last" ? this.columnEle.offsetWidth : 0) - 1) + "px;";
        } else {
            this.helper.classList.add("e-row-helper");
            this.helper.style.cssText = "width: " + getComputedStyle(this.curTable).width + "; top: " + (this.calcPos(this.rowEle).top + pos.top + this.rowEle.offsetHeight - 1) + "px; left:" + (this.calcPos(this.rowEle).left + pos.left) + "px;";
        }
    };
    Table.prototype.updateHelper = function() {
        var pos = this.calcPos(this.curTable);
        if (this.resizeBtnStat.column) {
            var left = pos.left + this.calcPos(this.columnEle).left + (this.currentColumnResize === "last" ? this.columnEle.offsetWidth : 0) - 1;
            this.helper.style.left = left + "px";
            this.helper.style.height = this.curTable.offsetHeight + "px";
        } else {
            var top_1 = this.calcPos(this.rowEle).top + pos.top + this.rowEle.offsetHeight - 1;
            this.helper.style.top = top_1 + "px";
        }
    };
    Table.prototype.calMaxCol = function(curTable) {
        var cellColl = curTable.rows[0].cells;
        var cellCount = 0;
        for(var cell = 0; cell < cellColl.length; cell++)cellCount = cellCount + cellColl[cell].colSpan;
        var cells = new Array(cellCount);
        var rowSpanCells = new Map();
        for(var i = 0; i < curTable.rows.length; i++){
            var currentColIndex = 0;
            for(var k = 0; k < curTable.rows[i].cells.length; k++){
                for(var l = 1; l < curTable.rows[i].cells[k].rowSpan; l++){
                    var key = "" + (i + l) + currentColIndex;
                    rowSpanCells.set(key, curTable.rows[i].cells[k]);
                }
                var cellIndex = this.getCellIndex(rowSpanCells, i, k);
                if (cellIndex > currentColIndex) currentColIndex = cellIndex;
                var width = curTable.rows[i].cells[k].offsetWidth;
                if (!cells[currentColIndex] || width < cells[currentColIndex].offsetWidth) cells[currentColIndex] = curTable.rows[i].cells[k];
                currentColIndex += 1 + curTable.rows[i].cells[k].colSpan - 1;
            }
        }
        return cells;
    };
    Table.prototype.resizing = function(e) {
        var _this = this;
        var pageX = this.getPointX(e);
        var pageY = this.getPointY(e);
        var mouseX = this.parent.enableRtl ? -(pageX - this.pageX) : pageX - this.pageX;
        var mouseY = this.parent.enableRtl ? -(pageY - this.pageY) : pageY - this.pageY;
        this.pageX = pageX;
        this.pageY = pageY;
        var maxiumWidth;
        var currentTdElement = this.curTable.closest("td");
        var args = {
            event: e,
            requestType: "table"
        };
        this.parent.trigger($947a002e9a697770$export$45b39e67d4ce4921, args, function(resizingArgs) {
            if (resizingArgs.cancel) _this.cancelResizeAction();
            else {
                var tableReBox = _this.contentModule.getEditPanel().querySelector(".e-table-box");
                var tableWidth = parseInt(getComputedStyle(_this.curTable).width, 10);
                var tableHeight = parseInt(getComputedStyle(_this.curTable).height, 10);
                var paddingSize = +getComputedStyle(_this.contentModule.getEditPanel()).paddingRight.match(/\d/g).join("");
                var rteWidth = _this.contentModule.getEditPanel().offsetWidth - (_this.contentModule.getEditPanel().offsetWidth - _this.contentModule.getEditPanel().clientWidth) - paddingSize * 2;
                var widthCompare = void 0;
                if (!(0, $3EnZW.isNullOrUndefined)(_this.curTable.parentElement.closest("table")) && !(0, $3EnZW.isNullOrUndefined)(_this.curTable.closest("td")) && _this.contentModule.getEditPanel().contains(_this.curTable.closest("td"))) {
                    var currentTd = _this.curTable.closest("td");
                    var currentTDPad = +getComputedStyle(currentTd).paddingRight.match(/\d/g).join("");
                    // Padding of the current table with the parent element multiply with 2.
                    widthCompare = currentTd.offsetWidth - (currentTd.offsetWidth - currentTd.clientWidth) - currentTDPad * 2;
                } else widthCompare = rteWidth;
                if (_this.resizeBtnStat.column) {
                    if (_this.curTable.closest("li")) widthCompare = _this.curTable.closest("li").offsetWidth;
                    var colGroup = _this.curTable.querySelectorAll("colgroup > col");
                    var currentTableWidth = void 0;
                    if (_this.curTable.style.width !== "" && _this.curTable.style.width.includes("%")) currentTableWidth = parseFloat(_this.curTable.style.width.split("%")[0]);
                    else currentTableWidth = _this.getCurrentTableWidth(_this.curTable.offsetWidth, _this.parent.inputElement.offsetWidth);
                    var currentCol = _this.calMaxCol(_this.curTable)[_this.colIndex];
                    var currentColResizableWidth = _this.getCurrentColWidth(currentCol, tableWidth);
                    if (_this.currentColumnResize === "first") {
                        mouseX = mouseX - 0.75; //This was done for to make the gripper and the table first/last column will be close.
                        _this.removeResizeElement();
                        if (currentTdElement) {
                            maxiumWidth = _this.curTable.getBoundingClientRect().right - _this.calcPos(currentTdElement).left;
                            _this.curTable.style.maxWidth = maxiumWidth + "px";
                        }
                        // Below the value '100' is the 100% width of the parent element.
                        if ((mouseX !== 0 && 5 < currentColResizableWidth || mouseX < 0) && currentTableWidth <= 100 && _this.convertPixelToPercentage(tableWidth - mouseX, widthCompare) <= 100) {
                            var firstColumnsCell = _this.findFirstLastColCells(_this.curTable, true);
                            _this.curTable.style.width = _this.convertPixelToPercentage(tableWidth - mouseX, widthCompare) > 100 ? "100%" : _this.convertPixelToPercentage(tableWidth - mouseX, widthCompare) + "%";
                            var differenceWidth = currentTableWidth - _this.convertPixelToPercentage(tableWidth - mouseX, widthCompare);
                            var preMarginLeft = 0;
                            var widthType = _this.curTable.style.width.indexOf("%") > -1;
                            if (!widthType && _this.curTable.offsetWidth > _this.contentModule.getEditPanel().offsetWidth) {
                                _this.curTable.style.width = rteWidth + "px";
                                return;
                            }
                            if (widthType && parseFloat(_this.curTable.style.width.split("%")[0]) > 100) {
                                _this.curTable.style.width = "100%";
                                return;
                            }
                            if (!(0, $3EnZW.isNullOrUndefined)(_this.curTable.style.marginLeft) && _this.curTable.style.marginLeft !== "") {
                                var regex = /[-+]?\d*\.\d+|\d+/;
                                var value = _this.curTable.style.marginLeft.match(regex);
                                if (!(0, $3EnZW.isNullOrUndefined)(value)) preMarginLeft = parseFloat(value[0]);
                            }
                            var currentMarginLeft = preMarginLeft + differenceWidth;
                            if (currentMarginLeft && currentMarginLeft > 100) {
                                var width = parseFloat(_this.curTable.style.width);
                                currentMarginLeft = 100 - width;
                            }
                            // For table pasted from word, Margin left can be anything so we are avoiding the below process.
                            if (!_this.curTable.classList.contains("e-rte-paste-table") && currentMarginLeft && currentMarginLeft < 1) {
                                _this.curTable.style.marginLeft = null;
                                _this.curTable.style.width = "100%";
                                return;
                            }
                            _this.curTable.style.marginLeft = "calc(" + (_this.curTable.style.width === "100%" ? 0 : currentMarginLeft) + "%)";
                            for(var i = 0; i < firstColumnsCell.length; i++){
                                var currentColumnCellWidth = _this.getCurrentColWidth(firstColumnsCell[i], tableWidth);
                                firstColumnsCell[i].style.width = currentColumnCellWidth - differenceWidth + "%";
                            }
                        }
                    } else if (_this.currentColumnResize === "last") {
                        mouseX = mouseX + 0.75; //This was done for to make the gripper and the table first/last column will be close.
                        _this.removeResizeElement();
                        if (currentTdElement) {
                            maxiumWidth = currentTdElement.getBoundingClientRect().right - _this.curTable.getBoundingClientRect().left;
                            _this.curTable.style.maxWidth = maxiumWidth + "px";
                        }
                        // Below the value '100' is the 100% width of the parent element.
                        if ((mouseX !== 0 && 5 < currentColResizableWidth || mouseX > 0) && currentTableWidth <= 100 && _this.convertPixelToPercentage(tableWidth + mouseX, widthCompare) <= 100) {
                            var lastColumnsCell = _this.findFirstLastColCells(_this.curTable, false);
                            _this.curTable.style.width = _this.convertPixelToPercentage(tableWidth + mouseX, widthCompare) > 100 ? "100%" : _this.convertPixelToPercentage(tableWidth + mouseX, widthCompare) + "%";
                            var differenceWidth = currentTableWidth - _this.convertPixelToPercentage(tableWidth + mouseX, widthCompare);
                            for(var i = 0; i < lastColumnsCell.length; i++){
                                var currentColumnCellWidth = _this.getCurrentColWidth(lastColumnsCell[i], tableWidth);
                                lastColumnsCell[i].style.width = currentColumnCellWidth - differenceWidth + "%";
                            }
                        }
                    } else {
                        var actualwid = colGroup[_this.colIndex].offsetWidth - mouseX;
                        // eslint-disable-next-line
                        var totalwid = colGroup[_this.colIndex].offsetWidth + colGroup[_this.colIndex - 1].offsetWidth;
                        if (totalwid - actualwid > 20 && actualwid > 20) {
                            var leftColumnWidth = totalwid - actualwid;
                            var rightColWidth = actualwid;
                            colGroup[_this.colIndex - 1].style.width = _this.convertPixelToPercentage(leftColumnWidth, tableWidth) + "%";
                            colGroup[_this.colIndex].style.width = _this.convertPixelToPercentage(rightColWidth, tableWidth) + "%";
                        }
                    }
                    _this.updateHelper();
                } else if (_this.resizeBtnStat.row) {
                    _this.parent.preventDefaultResize(e);
                    var tableTrElementPixel = [];
                    var currentTableTrElement = _this.curTable.querySelectorAll("tr");
                    for(var i = 0; i < currentTableTrElement.length; i++)if (_this.rowEle !== currentTableTrElement[i]) tableTrElementPixel[i] = parseFloat(currentTableTrElement[i].clientHeight.toString());
                    _this.curTable.style.height = parseFloat(_this.curTable.clientHeight.toString()) + (mouseY > 0 ? 0 : mouseY) + "px";
                    for(var i = 0; i < currentTableTrElement.length; i++)if (_this.rowEle === currentTableTrElement[i]) currentTableTrElement[i].style.height = parseFloat(currentTableTrElement[i].clientHeight.toString()) + mouseY + "px";
                    else currentTableTrElement[i].style.height = tableTrElementPixel[i] + "px";
                    if (!(0, $3EnZW.isNullOrUndefined)(tableReBox)) tableReBox.style.cssText = "top: " + (_this.calcPos(_this.curTable).top + tableHeight - 4) + "px; left:" + (_this.calcPos(_this.curTable).left + tableWidth - 4) + "px;";
                    _this.updateHelper();
                } else if (_this.resizeBtnStat.tableBox) {
                    if (currentTdElement) {
                        var tableBoxPosition = _this.curTable.getBoundingClientRect().left - currentTdElement.getBoundingClientRect().left;
                        maxiumWidth = Math.abs(tableBoxPosition - currentTdElement.getBoundingClientRect().width) - 5;
                        _this.curTable.style.maxWidth = maxiumWidth + "px";
                    }
                    _this.curTable.style.height = tableHeight + mouseY + "px";
                    if (!(0, $3EnZW.isNullOrUndefined)(tableReBox)) {
                        tableReBox.classList.add("e-rbox-select");
                        tableReBox.style.cssText = "top: " + (_this.calcPos(_this.curTable).top + tableHeight - 4) + "px; left:" + (_this.calcPos(_this.curTable).left + tableWidth - 4) + "px;";
                    }
                    if (_this.curTable.closest("li")) widthCompare = _this.curTable.closest("li").offsetWidth;
                    var widthType = _this.curTable.style.width.indexOf("%") > -1;
                    if (widthType && parseFloat(_this.curTable.style.width.split("%")[0]) > 100) {
                        _this.curTable.style.width = "100%";
                        return;
                    }
                    if (!widthType && _this.curTable.offsetWidth > _this.contentModule.getEditPanel().offsetWidth) {
                        _this.curTable.style.width = rteWidth + "px";
                        return;
                    }
                    _this.curTable.style.width = widthType ? _this.convertPixelToPercentage(tableWidth + mouseX, widthCompare) + "%" : tableWidth + mouseX + "px";
                }
            }
        });
    };
    Table.prototype.getCurrentColWidth = function(col, tableWidth) {
        var currentColWidth = 0;
        if (col.style.width !== "" && col.style.width.includes("%")) currentColWidth = parseFloat(col.style.width.split("%")[0]);
        else currentColWidth = this.convertPixelToPercentage(col.offsetWidth, tableWidth);
        return currentColWidth;
    };
    Table.prototype.getCurrentTableWidth = function(tableWidth, parentWidth) {
        var currentTableWidth = 0;
        currentTableWidth = tableWidth / parentWidth * 100;
        return currentTableWidth;
    };
    Table.prototype.findFirstLastColCells = function(table, isFirst) {
        var resultColumns = [];
        var rows = table.rows;
        var rowSpanCellIndexs = [];
        var _loop_1 = function(i) {
            var cellIndex = isFirst ? 0 : rows[i].cells.length - 1;
            var column = rows[i].cells[cellIndex];
            for(var rowSpan = 1; rowSpan < column.rowSpan; rowSpan++){
                var key = i + rowSpan + "-" + cellIndex;
                rowSpanCellIndexs.push(key);
            }
            var spannedCellKey = i + "-" + cellIndex;
            if (rowSpanCellIndexs.length === 0 || isFirst && rowSpanCellIndexs.indexOf(spannedCellKey) === -1 || !isFirst && rowSpanCellIndexs.indexOf(spannedCellKey) === -1 && rowSpanCellIndexs.every(function(key) {
                return key.split("-")[0] !== i.toString();
            })) resultColumns.push(column);
        };
        for(var i = 0; i < rows.length; i++)_loop_1(i);
        return resultColumns;
    };
    Table.prototype.convertPixelToPercentage = function(value, offsetValue) {
        return value / offsetValue * 100;
    };
    Table.prototype.cancelResizeAction = function() {
        this.isResizeBind = true;
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        this.removeResizeElement();
    };
    Table.prototype.resizeEnd = function(e) {
        this.resizeBtnInit();
        this.isResizeBind = true;
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        if (this.contentModule.getEditPanel().querySelector(".e-table-box") && this.contentModule.getEditPanel().contains(this.contentModule.getEditPanel().querySelector(".e-table-box"))) this.removeResizeElement();
        if (this.helper && this.contentModule.getEditPanel().contains(this.helper)) {
            (0, $4ZDHT.detach)(this.helper);
            this.helper = null;
        }
        this.resetResizeHelper(this.curTable);
        this.pageX = null;
        this.pageY = null;
        this.moveEle = null;
        var currentTableTrElement = this.curTable.querySelectorAll("tr");
        var tableTrPercentage = [];
        for(var i = 0; i < currentTableTrElement.length; i++){
            var percentage = parseFloat(currentTableTrElement[i].clientHeight.toString()) / parseFloat(this.curTable.clientHeight.toString()) * 100;
            tableTrPercentage[i] = percentage;
        }
        for(var i = 0; i < currentTableTrElement.length; i++)if (currentTableTrElement[i].parentElement.nodeName === "THEAD") {
            currentTableTrElement[i].parentElement.style.height = tableTrPercentage[i] + "%";
            currentTableTrElement[i].style.height = tableTrPercentage[i] + "%";
        } else currentTableTrElement[i].style.height = tableTrPercentage[i] + "%";
        var args = {
            event: e,
            requestType: "table"
        };
        this.parent.trigger($947a002e9a697770$export$8c4d3b559babc6db, args);
        this.parent.formatter.saveData();
        this.resizeEndTime = new Date().getTime();
    };
    Table.prototype.resetResizeHelper = function(curTable) {
        var colHelper = this.parent.element.querySelectorAll(".e-table-rhelper.e-column-helper");
        Array.from(colHelper).forEach(function(element) {
            if (element.parentNode) element.parentNode.removeChild(element);
        });
        var rowHelper = this.parent.element.querySelectorAll(".e-table-rhelper.e-row-helper");
        Array.from(rowHelper).forEach(function(element) {
            if (element.parentNode) element.parentNode.removeChild(element);
        });
        if (!curTable.style.width) curTable.style.width = curTable.offsetWidth + "px";
        var colGroup = curTable.querySelector("colgroup");
        if (colGroup) {
            for(var i = 0; i < curTable.rows.length; i++)for(var k = 0; k < curTable.rows[i].cells.length; k++){
                var width = this.convertPixelToPercentage(curTable.rows[i].cells[k].offsetWidth, parseInt(getComputedStyle(curTable).width, 10)) + "%";
                curTable.rows[i].cells[k].style.width = width;
            }
            curTable.removeChild(colGroup);
        }
    };
    Table.prototype.resizeBtnInit = function() {
        return this.resizeBtnStat = {
            column: false,
            row: false,
            tableBox: false
        };
    };
    Table.prototype.addRow = function(selectCell, e, tabkey) {
        var cmd;
        if (tabkey) cmd = {
            item: {
                command: "Table",
                subCommand: "InsertRowAfter"
            }
        };
        var value = {
            selection: selectCell,
            subCommand: tabkey ? cmd.item.subCommand : e.item.subCommand
        };
        this.parent.formatter.process(this.parent, tabkey ? cmd : e, e, value);
    };
    Table.prototype.addColumn = function(selectCell, e) {
        this.parent.formatter.process(this.parent, e, e, {
            selection: selectCell,
            width: this.parent.tableSettings.width,
            subCommand: e.item.subCommand
        });
    };
    Table.prototype.removeRowColumn = function(selectCell, e) {
        this.parent.formatter.process(this.parent, e, e, {
            selection: selectCell,
            subCommand: e.item.subCommand
        });
        this.hideTableQuickToolbar();
    };
    Table.prototype.removeTable = function(selection, args, delKey) {
        var cmd;
        if (delKey) cmd = {
            item: {
                command: "Table",
                subCommand: "TableRemove"
            }
        };
        var value = {
            selection: selection,
            subCommand: delKey ? cmd.item.subCommand : args.item.subCommand
        };
        this.parent.formatter.process(this.parent, delKey ? cmd : args, args.originalEvent, value);
        this.contentModule.getEditPanel().focus();
        if (this.parent.inputElement.innerHTML === null || this.parent.inputElement.innerHTML === "") {
            if (this.parent.enterKey === "DIV") this.contentModule.getEditPanel().innerHTML = "<div><br/></div>";
            else if (this.parent.enterKey === "BR") this.contentModule.getEditPanel().innerHTML = "<br/>";
            else this.contentModule.getEditPanel().innerHTML = "<p><br/></p>";
        }
        this.removeResizeElement();
        this.hideTableQuickToolbar();
    };
    Table.prototype.renderDlgContent = function(args) {
        var _this = this;
        var argsTarget = args.args.originalEvent.target;
        if ((0, $5q7BP.Browser).isDevice || this.parent.inlineMode.enable || !(0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(argsTarget, ".e-rte-text-popup"))) {
            this.insertTableDialog(args);
            return;
        }
        if (this.popupObj) {
            this.popupObj.hide();
            return;
        }
        this.hideTableQuickToolbar();
        var header = "1X1";
        var insertbtn = this.l10n.getConstant("inserttablebtn");
        this.dlgDiv = this.parent.createElement("div", {
            className: "e-rte-table-popup" + this.parent.getCssClass(true),
            id: this.rteID + "_table"
        });
        this.tblHeader = this.parent.createElement("div", {
            className: "e-rte-popup-header" + this.parent.getCssClass(true)
        });
        this.tblHeader.innerHTML = header;
        this.dlgDiv.appendChild(this.tblHeader);
        var tableDiv = this.parent.createElement("div", {
            className: "e-rte-table-span" + this.parent.getCssClass(true)
        });
        this.drawTable(tableDiv, args);
        this.dlgDiv.appendChild(tableDiv);
        this.dlgDiv.appendChild(this.parent.createElement("span", {
            className: "e-span-border" + this.parent.getCssClass(true)
        }));
        var btnEle = this.parent.createElement("button", {
            className: "e-insert-table-btn" + this.parent.getCssClass(true),
            id: this.rteID + "_insertTable",
            attrs: {
                type: "button",
                tabindex: "0"
            }
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.getToolbarElement().querySelector(".e-expended-nav"))) this.parent.getToolbarElement().querySelector(".e-expended-nav").setAttribute("tabindex", "1");
        this.dlgDiv.appendChild(btnEle);
        this.createTableButton = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            iconCss: "e-icons e-create-table",
            content: insertbtn,
            cssClass: "e-flat" + this.parent.getCssClass(true),
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale
        });
        this.createTableButton.isStringTemplate = true;
        this.createTableButton.appendTo(btnEle);
        (0, $aqzbR.EventHandler).add(btnEle, "click", this.insertTableDialog, {
            self: this,
            args: args.args,
            selection: args.selection
        });
        this.parent.getToolbar().parentElement.appendChild(this.dlgDiv);
        var target = args.args.originalEvent.target;
        target = target.classList.contains("e-toolbar-item") ? target.firstChild : target.parentElement;
        this.popupObj = new (0, $2vAqh.Popup)(this.dlgDiv, {
            targetType: "relative",
            relateTo: target,
            collision: {
                X: "fit",
                Y: "none"
            },
            offsetY: 8,
            viewPortElement: this.parent.element,
            position: {
                X: "left",
                Y: "bottom"
            },
            enableRtl: this.parent.enableRtl,
            zIndex: 10001,
            // eslint-disable-next-line
            close: function(event) {
                (0, $aqzbR.EventHandler).remove(btnEle, "click", _this.insertTableDialog);
                (0, $4ZDHT.detach)(btnEle);
                if (_this.createTableButton && !_this.createTableButton.isDestroyed) {
                    _this.createTableButton.destroy();
                    _this.createTableButton.element = null;
                    _this.createTableButton = null;
                }
                _this.parent.isBlur = false;
                _this.popupObj.destroy();
                (0, $4ZDHT.detach)(_this.popupObj.element);
                _this.popupObj = null;
            }
        });
        (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], "e-popup-open");
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.cssClass)) (0, $4ZDHT.addClass)([
            this.popupObj.element
        ], this.parent.getCssClass());
        btnEle.focus();
        this.popupObj.refreshPosition(target);
    };
    Table.prototype.onIframeMouseDown = function() {
        if (this.popupObj) this.popupObj.hide();
        if (this.parent.inlineMode.enable && this.editdlgObj) this.editdlgObj.hide();
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent) && !(0, $3EnZW.isNullOrUndefined)(this.parent.contentModule) && !(0, $3EnZW.isNullOrUndefined)(this.parent.contentModule.getEditPanel())) this.removeResizeElement();
    };
    Table.prototype.docClick = function(e) {
        var target = e.args.target;
        // eslint-disable-next-line
        if (target && target.classList && (this.popupObj && !(0, $4ZDHT.closest)(target, "[id='" + this.popupObj.element.id + "'" + "]") || this.editdlgObj && !(0, $4ZDHT.closest)(target, "#" + this.editdlgObj.element.id)) && !target.classList.contains("e-create-table") && target.offsetParent && !target.offsetParent.classList.contains("e-rte-backgroundcolor-dropdown")) {
            if (this.popupObj) this.popupObj.hide();
            if (this.editdlgObj) {
                this.parent.notify($947a002e9a697770$export$4895f32c534ef936, {
                    closedBy: "outside click"
                });
                this.editdlgObj.hide();
            }
            this.parent.isBlur = true;
            (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
        }
        var closestEle = (0, $4ZDHT.closest)(target, "td");
        var isExist = closestEle && this.parent.contentModule.getEditPanel().contains(closestEle) ? true : false;
        if (target && target.tagName !== "TD" && target.tagName !== "TH" && !isExist && (0, $4ZDHT.closest)(target, ".e-rte-quick-popup") === null && target.offsetParent && !target.offsetParent.classList.contains("e-quick-dropdown") && !target.offsetParent.classList.contains("e-rte-backgroundcolor-dropdown") && !(0, $4ZDHT.closest)(target, ".e-rte-dropdown-popup") && !(0, $4ZDHT.closest)(target, ".e-rte-elements")) {
            var isToolbarClick = target && target.closest(".e-toolbar") ? true : false;
            if (!isToolbarClick) this.removeCellSelectClasses();
            this.removeTableSelection();
            if (!(0, $5q7BP.Browser).isIE) this.hideTableQuickToolbar();
        }
        if (target && target.classList && !target.classList.contains($afc560df281b588d$export$97001d3d2f729a40) && !target.classList.contains($afc560df281b588d$export$f3e568bf9fb0b3e0) && !target.classList.contains($afc560df281b588d$export$d56486b0aa3bd575)) this.removeResizeElement();
    };
    Table.prototype.drawTable = function(tableDiv, args) {
        var rowDiv;
        var tableCell;
        for(var row = 0; row < 3; row++){
            rowDiv = this.parent.createElement("div", {
                className: "e-rte-table-row" + this.parent.getCssClass(true),
                attrs: {
                    "data-column": "" + row
                }
            });
            (0, $aqzbR.EventHandler).add(rowDiv, "mouseleave", this.tableCellLeave, this);
            for(var col = 0; col < 10; col++){
                tableCell = this.parent.createElement("div", {
                    className: "e-rte-tablecell e-default" + this.parent.getCssClass(true),
                    attrs: {
                        "data-cell": "" + col
                    }
                });
                rowDiv.appendChild(tableCell);
                tableCell.style.display = "inline-block";
                if (col === 0 && row === 0) (0, $4ZDHT.addClass)([
                    tableCell
                ], "e-active");
                (0, $aqzbR.EventHandler).add(tableCell, "mousemove", this.tableCellSelect, this);
                (0, $aqzbR.EventHandler).add(tableCell, "mouseup", this.tableCellClick, {
                    self: this,
                    args: args.args,
                    selection: args.selection
                });
            }
            tableDiv.appendChild(rowDiv);
        }
    };
    Table.prototype.editTable = function(args) {
        var _this = this;
        this.createDialog(args);
        var editContent = this.tableDlgContent(args);
        var update = this.l10n.getConstant("dialogUpdate");
        var cancel = this.l10n.getConstant("dialogCancel");
        var editHeader = this.l10n.getConstant("tableEditHeader");
        this.editdlgObj.setProperties({
            height: "initial",
            width: "290px",
            content: editContent,
            header: editHeader,
            buttons: [
                {
                    click: this.applyProperties.bind(this, args),
                    buttonModel: {
                        content: update,
                        cssClass: "e-flat e-size-update" + this.parent.getCssClass(true),
                        isPrimary: true
                    }
                },
                {
                    click: function(e) {
                        _this.cancelDialog(e);
                    },
                    buttonModel: {
                        cssClass: "e-flat e-cancel" + this.parent.getCssClass(true),
                        content: cancel
                    }
                }
            ],
            cssClass: this.editdlgObj.cssClass + " e-rte-edit-table-prop-dialog"
        });
        this.editdlgObj.element.style.maxHeight = "none";
        this.editdlgObj.content.querySelector("input").focus();
        this.hideTableQuickToolbar();
    };
    Table.prototype.insertTableDialog = function(args) {
        var proxy = this.self ? this.self : this;
        if (proxy.popupObj) proxy.popupObj.hide();
        proxy.createDialog(args);
        var dlgContent = proxy.tableCellDlgContent();
        var insert = proxy.l10n.getConstant("dialogInsert");
        var cancel = proxy.l10n.getConstant("dialogCancel");
        if ((0, $3EnZW.isNullOrUndefined)(proxy.editdlgObj)) return;
        proxy.editdlgObj.setProperties({
            height: "initial",
            width: "290px",
            content: dlgContent,
            buttons: [
                {
                    click: proxy.customTable.bind(this, args),
                    buttonModel: {
                        content: insert,
                        cssClass: "e-flat e-insert-table " + proxy.parent.cssClass,
                        isPrimary: true
                    }
                },
                {
                    click: function(e) {
                        proxy.cancelDialog(e);
                    },
                    buttonModel: {
                        cssClass: "e-flat e-cancel " + proxy.parent.cssClass,
                        content: cancel
                    }
                }
            ]
        });
        if (!(0, $3EnZW.isNullOrUndefined)(proxy.parent.cssClass)) proxy.editdlgObj.setProperties({
            cssClass: proxy.parent.cssClass
        });
        proxy.editdlgObj.element.style.maxHeight = "none";
        proxy.editdlgObj.content.querySelector("input").focus();
    };
    Table.prototype.tableCellDlgContent = function() {
        var tableColumn = this.l10n.getConstant("columns");
        var tableRow = this.l10n.getConstant("rows");
        var tableWrap = this.parent.createElement("div", {
            className: "e-cell-wrap" + this.parent.getCssClass(true)
        });
        var content = '<div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" ' + ' data-role ="none" id="tableColumn" class="e-table-column' + this.parent.getCssClass(true) + '"/></div>' + '<div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" data-role ="none" id="tableRow" class="e-table-row' + this.parent.getCssClass(true) + '" /></div>';
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        tableWrap.appendChild(contentElem);
        this.columnTextBox = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            format: "n0",
            min: 1,
            value: 3,
            placeholder: tableColumn,
            floatLabelType: "Auto",
            max: 50,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            cssClass: this.parent.getCssClass()
        });
        this.columnTextBox.isStringTemplate = true;
        this.columnTextBox.appendTo(tableWrap.querySelector("#tableColumn"));
        this.rowTextBox = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            format: "n0",
            min: 1,
            value: 3,
            placeholder: tableRow,
            floatLabelType: "Auto",
            max: 1000,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            cssClass: this.parent.getCssClass()
        });
        this.rowTextBox.isStringTemplate = true;
        this.rowTextBox.appendTo(tableWrap.querySelector("#tableRow"));
        return tableWrap;
    };
    Table.prototype.clearDialogObj = function() {
        if (this.editdlgObj) {
            this.editdlgObj.destroy();
            (0, $4ZDHT.detach)(this.editdlgObj.element);
            this.editdlgObj = null;
        }
    };
    // eslint-disable-next-line
    Table.prototype.createDialog = function(args) {
        var _this = this;
        if (this.editdlgObj) {
            this.editdlgObj.hide({
                returnValue: true
            });
            return;
        }
        var tableDialog = this.parent.createElement("div", {
            className: "e-rte-edit-table" + this.parent.getCssClass(true),
            id: this.rteID + "_tabledialog"
        });
        this.parent.rootContainer.appendChild(tableDialog);
        var insert = this.l10n.getConstant("dialogInsert");
        var cancel = this.l10n.getConstant("dialogCancel");
        var header = this.l10n.getConstant("tabledialogHeader");
        var dialogModel = {
            header: header,
            cssClass: $afc560df281b588d$export$d3f61cb93957903e + this.parent.getCssClass(true),
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true,
            closeOnEscape: true,
            width: (0, $5q7BP.Browser).isDevice ? "290px" : "340px",
            height: "initial",
            position: {
                X: "center",
                Y: (0, $5q7BP.Browser).isDevice ? "center" : "top"
            },
            isModal: (0, $5q7BP.Browser).isDevice,
            buttons: [
                {
                    buttonModel: {
                        content: insert,
                        cssClass: "e-flat e-insert-table" + this.parent.getCssClass(true),
                        isPrimary: true
                    }
                },
                {
                    click: function(e) {
                        _this.cancelDialog(e);
                    },
                    buttonModel: {
                        cssClass: "e-flat e-cancel" + this.parent.getCssClass(true),
                        content: cancel
                    }
                }
            ],
            target: (0, $5q7BP.Browser).isDevice ? document.body : this.parent.element,
            animationSettings: {
                effect: "None"
            },
            close: function(event) {
                _this.parent.isBlur = false;
                _this.editdlgObj.destroy();
                (0, $4ZDHT.detach)(_this.editdlgObj.element);
                _this.dialogRenderObj.close(event);
                _this.editdlgObj = null;
            }
        };
        this.editdlgObj = this.dialogRenderObj.render(dialogModel);
        this.editdlgObj.appendTo(tableDialog);
        if (this.quickToolObj && this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) this.quickToolObj.inlineQTBar.hidePopup();
        if (this.quickToolObj && this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) this.quickToolObj.textQTBar.hidePopup();
    };
    Table.prototype.customTable = function(args, e) {
        var proxy = this.self ? this.self : this;
        if (proxy && proxy.rowTextBox && proxy.rowTextBox.value && proxy.columnTextBox && proxy.columnTextBox.value) {
            var argument = (0, $5q7BP.Browser).isDevice || !(0, $3EnZW.isNullOrUndefined)(args.args) && !(0, $3EnZW.isNullOrUndefined)(args.args.originalEvent) && args.args.originalEvent.action === "insert-table" || proxy.parent.inlineMode.enable || !(0, $3EnZW.isNullOrUndefined)(proxy.parent.quickToolbarSettings.text) && !(args instanceof PointerEvent) ? args : this;
            proxy.tableInsert(proxy.rowTextBox.value, proxy.columnTextBox.value, e, argument);
        }
    };
    // eslint-disable-next-line
    Table.prototype.cancelDialog = function(e) {
        this.parent.isBlur = false;
        this.editdlgObj.hide({
            returnValue: true
        });
    };
    // eslint-disable-next-line
    Table.prototype.applyProperties = function(args, e) {
        var dialogEle = this.editdlgObj.element;
        var table = (0, $4ZDHT.closest)(args.selectNode[0], "table");
        table.style.width = dialogEle.querySelector(".e-table-width") ? dialogEle.querySelector(".e-table-width").value + "px" : table.style.width;
        if (dialogEle.querySelector(".e-cell-padding") && dialogEle.querySelector(".e-cell-padding").value !== "") {
            var tdElm = table.querySelectorAll("td");
            for(var i = 0; i < tdElm.length; i++){
                var padVal = "";
                if (tdElm[i].style.padding === "") padVal = tdElm[i].getAttribute("style") + " padding:" + dialogEle.querySelector(".e-cell-padding").value + "px;";
                else {
                    tdElm[i].style.padding = dialogEle.querySelector(".e-cell-padding").value + "px";
                    padVal = tdElm[i].getAttribute("style");
                }
                tdElm[i].setAttribute("style", padVal);
            }
        }
        table.cellSpacing = dialogEle.querySelector(".e-cell-spacing") ? dialogEle.querySelector(".e-cell-spacing").value : table.cellSpacing;
        if (!(0, $3EnZW.isNullOrUndefined)(table.cellSpacing) && table.cellSpacing !== "0") (0, $4ZDHT.addClass)([
            table
        ], $afc560df281b588d$export$b3b0ed3df2845e37);
        else (0, $259257662ca103fc$export$7e42d760c0740ccc)([
            table
        ], $afc560df281b588d$export$b3b0ed3df2845e37);
        this.parent.formatter.saveData();
        this.editdlgObj.hide({
            returnValue: true
        });
    };
    Table.prototype.tableDlgContent = function(e) {
        var selectNode = e.selectParent[0];
        var tableWidth = this.l10n.getConstant("tableWidth");
        var cellPadding = this.l10n.getConstant("cellpadding");
        var cellSpacing = this.l10n.getConstant("cellspacing");
        var tableWrap = this.parent.createElement("div", {
            className: "e-table-sizewrap" + this.parent.getCssClass(true)
        });
        var widthVal = (0, $4ZDHT.closest)(selectNode, "table").getClientRects()[0].width;
        var padVal = (0, $4ZDHT.closest)(selectNode, "td").style.padding;
        var brdSpcVal = (0, $4ZDHT.closest)(selectNode, "table").getAttribute("cellspacing");
        var content = '<div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" data-role ="none" id="tableWidth" class="e-table-width' + this.parent.getCssClass(true) + '" ' + " /></div>" + '<div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" data-role ="none" id="cellPadding" class="e-cell-padding' + this.parent.getCssClass(true) + '" />' + ' </div><div class="e-rte-field' + this.parent.getCssClass(true) + '"><input type="text" data-role ="none" id="cellSpacing" class="e-cell-spacing' + this.parent.getCssClass(true) + '" /></div>';
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        tableWrap.appendChild(contentElem);
        this.tableWidthNum = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            format: "n0",
            min: 0,
            value: widthVal,
            placeholder: tableWidth,
            floatLabelType: "Auto",
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale
        });
        this.tableWidthNum.isStringTemplate = true;
        this.tableWidthNum.appendTo(tableWrap.querySelector("#tableWidth"));
        this.tableCellPadding = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            format: "n0",
            min: 0,
            // eslint-disable-next-line
            value: padVal !== "" ? parseInt(padVal, null) : 0,
            placeholder: cellPadding,
            floatLabelType: "Auto",
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale
        });
        this.tableCellPadding.isStringTemplate = true;
        this.tableCellPadding.appendTo(tableWrap.querySelector("#cellPadding"));
        this.tableCellSpacing = new (0, $75082a70d3498091$export$d910e4596d16bb81)({
            format: "n0",
            min: 0,
            // eslint-disable-next-line
            value: brdSpcVal !== "" && !(0, $3EnZW.isNullOrUndefined)(brdSpcVal) ? parseInt(brdSpcVal, null) : 0,
            placeholder: cellSpacing,
            floatLabelType: "Auto",
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale
        });
        this.tableCellSpacing.isStringTemplate = true;
        this.tableCellSpacing.appendTo(tableWrap.querySelector("#cellSpacing"));
        return tableWrap;
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ Table.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (this.resizeIconPositionTime) {
            clearTimeout(this.resizeIconPositionTime);
            this.resizeIconPositionTime = null;
        }
        this.removeEventListener();
        (0, $aqzbR.EventHandler).remove(this.parent.contentModule.getDocument(), "selectionchange", this.tableCellsKeyboardSelection);
        if (this.curTable) (0, $aqzbR.EventHandler).remove(this.curTable, "mouseleave", this.tableMouseLeave);
        if (this.tableCellSpacing && !this.tableCellSpacing.isDestroyed) {
            this.tableCellSpacing.destroy();
            this.tableCellSpacing = null;
        }
        if (this.tableCellPadding && !this.tableCellPadding.isDestroyed) {
            this.tableCellPadding.destroy();
            this.tableCellPadding = null;
        }
        if (this.tableWidthNum && !this.tableWidthNum.isDestroyed) {
            this.tableWidthNum.destroy();
            this.tableWidthNum = null;
        }
        if (this.rowTextBox && !this.rowTextBox.isDestroyed) {
            this.rowTextBox.destroy();
            this.rowTextBox = null;
        }
        if (this.columnTextBox && !this.columnTextBox.isDestroyed) {
            this.columnTextBox.destroy();
            this.columnTextBox = null;
        }
        if (this.createTableButton && !this.createTableButton.isDestroyed) {
            this.createTableButton.destroy();
            this.createTableButton = null;
        }
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     */ Table.prototype.getModuleName = function() {
        return "table";
    };
    Table.prototype.afterKeyDown = function() {
        var _this = this;
        if (this.curTable) this.resizeIconPositionTime = setTimeout(function() {
            _this.updateResizeIconPosition();
        }, 1);
    };
    Table.prototype.updateResizeIconPosition = function() {
        var tableReBox = this.parent.contentModule.getEditPanel().querySelector(".e-table-box");
        if (!(0, $3EnZW.isNullOrUndefined)(tableReBox)) {
            var tablePosition = this.calcPos(this.curTable);
            tableReBox.style.cssText = "top: " + (tablePosition.top + parseInt(getComputedStyle(this.curTable).height, 10) - 4) + "px; left:" + (tablePosition.left + parseInt(getComputedStyle(this.curTable).width, 10) - 4) + "px;";
        }
    };
    return Table;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $dyv7X = parcelRequire("dyv7X");







parcelRequire("j7YE8");
var $3EnZW = parcelRequire("3EnZW");

/**
 * `ToolbarAction` module is used to toolbar click action
 */ var $d2db5b36b87bd9bf$export$79d646a7038cf516 = /** @class */ function() {
    function ToolbarAction(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    ToolbarAction.prototype.addEventListener = function() {
        this.parent.on($947a002e9a697770$export$56b876c24dda3084, this.toolbarClick, this);
        this.parent.on($947a002e9a697770$export$55eface7583121e7, this.dropDownSelect, this);
        this.parent.on($947a002e9a697770$export$be0ed384f2f95da8, this.renderSelection, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener, this);
    };
    ToolbarAction.prototype.toolbarClick = function(args) {
        if ((0, $3EnZW.isNullOrUndefined)(args.item)) return;
        if (!(0, $3EnZW.isNullOrUndefined)(args.item.controlParent)) {
            // eslint-disable-next-line
            var activeEle = args.item.controlParent.activeEle;
            if (activeEle) activeEle.tabIndex = -1;
        }
        if (args.item.command === "NumberFormatList" || args.item.command === "BulletFormatList") {
            if (args.originalEvent.target.classList.contains("e-order-list") || args.originalEvent.target.classList.contains("e-unorder-list")) {
                args.item.command = "Lists";
                args.item.subCommand = args.item.subCommand === "NumberFormatList" ? "OL" : "UL";
            }
        }
        if (args.item.command === "Lists") {
            if (args.originalEvent.target.classList.contains("e-caret") && (args.originalEvent.target.parentElement.classList.contains("e-rte-bulletformatlist-dropdown") || args.originalEvent.target.parentElement.classList.contains("e-rte-numberformatlist-dropdown"))) return;
        }
        this.parent.notify($947a002e9a697770$export$d3e2e39ad7d15e6d, args);
        this.parent.notify($947a002e9a697770$export$2a6b3606af0895e8, args);
    };
    ToolbarAction.prototype.dropDownSelect = function(e) {
        this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
        if (!(document.body.contains(document.body.querySelector(".e-rte-quick-toolbar")) && e.item && (e.item.command === "Images" || e.item.command === "Audios" || e.item.command === "Videos" || e.item.command === "VideoLayoutOption" || e.item.command === "Display" || e.item.command === "Table"))) {
            var value = e.item.controlParent && this.parent.quickToolbarModule && this.parent.quickToolbarModule.tableQTBar && this.parent.quickToolbarModule.tableQTBar.element.contains(e.item.controlParent.element) ? "Table" : null;
            if (e.item.command === "Lists") {
                var listItem = {
                    listStyle: e.item.value,
                    listImage: e.item.listImage,
                    type: e.item.subCommand
                };
                this.parent.formatter.process(this.parent, e, e.originalEvent, listItem);
            } else this.parent.formatter.process(this.parent, e, e.originalEvent, value);
        }
        this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
    };
    ToolbarAction.prototype.renderSelection = function(args) {
        this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
        this.parent.formatter.process(this.parent, args, args.originalEvent, null);
        this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, {});
    };
    ToolbarAction.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$56b876c24dda3084, this.toolbarClick);
        this.parent.off($947a002e9a697770$export$55eface7583121e7, this.dropDownSelect);
        this.parent.off($947a002e9a697770$export$be0ed384f2f95da8, this.renderSelection);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.removeEventListener);
    };
    return ToolbarAction;
}();



/**
 * `Toolbar` module is used to handle Toolbar actions.
 */ var $d346826d2cbb602c$export$4c260019440d418f = /** @class */ function() {
    function Toolbar(parent, serviceLocator) {
        this.tools = {};
        this.parent = parent;
        this.isDestroyed = false;
        this.isToolbar = false;
        this.locator = serviceLocator;
        this.isTransformChild = false;
        this.renderFactory = this.locator.getService("rendererFactory");
        $228f7f224d55f07b$export$52b58d6351f526e0(this.parent);
        (0, $c77ecbfae9b8c035$export$e2abd0ade91628fe)(this.parent);
        this.baseToolbar = new (0, $a8379000104ab123$export$550e9eddeb4f342e)(this.parent, this.locator);
        this.addEventListener();
        if (this.parent.toolbarSettings && Object.keys(this.parent.toolbarSettings.itemConfigs).length > 0) (0, $3EnZW.extend)(this.tools, $228f7f224d55f07b$export$904054328df186b, (0, $c77ecbfae9b8c035$export$422955f13ff9f307)(this.parent.toolbarSettings.itemConfigs), true);
        else this.tools = $228f7f224d55f07b$export$904054328df186b;
    }
    Toolbar.prototype.initializeInstance = function() {
        this.contentRenderer = this.renderFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        this.editableElement = this.contentRenderer.getEditPanel();
        this.editPanel = this.contentRenderer.getPanel();
    };
    Toolbar.prototype.toolbarBindEvent = function() {
        if (!this.parent.inlineMode.enable) this.keyBoardModule = new (0, $dyv7X.KeyboardEvents)(this.getToolbarElement(), {
            keyAction: this.toolBarKeyDown.bind(this),
            keyConfigs: this.parent.formatter.keyConfig,
            eventName: "keydown"
        });
    };
    Toolbar.prototype.toolBarKeyDown = function(e) {
        switch(e.action){
            case "escape":
                this.parent.contentModule.getEditPanel().focus();
                break;
            case "enter":
                if (!(0, $3EnZW.isNullOrUndefined)(e.target) && (e.target.classList.contains("e-rte-fontcolor-dropdown") || e.target.classList.contains("e-rte-backgroundcolor-dropdown"))) this.parent.notify($947a002e9a697770$export$8c46940ff642b0df, {
                    toolbarClick: e.target.classList.contains("e-rte-fontcolor-dropdown") ? "fontcolor" : "backgroundcolor"
                });
        }
    };
    Toolbar.prototype.createToolbarElement = function() {
        this.tbElement = this.parent.createElement("div", {
            id: this.parent.getID() + "_toolbar"
        });
        if (!(0, $5q7BP.Browser).isDevice && this.parent.inlineMode.enable && (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) return;
        else if (!this.parent.inlineMode.enable) {
            this.tbWrapper = this.parent.createElement("div", {
                id: this.parent.getID() + "_toolbar_wrapper",
                innerHTML: this.tbElement.outerHTML,
                className: $afc560df281b588d$export$8b3fa306a1b76ad1
            });
            this.tbElement = this.tbWrapper.firstElementChild;
            this.parent.rootContainer.insertBefore(this.tbWrapper, this.editPanel);
        } else this.parent.rootContainer.insertBefore(this.tbElement, this.editPanel);
    };
    Toolbar.prototype.getToolbarMode = function() {
        var tbMode;
        switch(this.parent.toolbarSettings.type){
            case (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand:
                tbMode = "Extended";
                break;
            case (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Scrollable:
                tbMode = "Scrollable";
                break;
            default:
                tbMode = "MultiRow";
        }
        if ((0, $c77ecbfae9b8c035$export$80ca177350c4af26)() && this.parent.toolbarSettings.type === (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand) tbMode = (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Scrollable;
        return tbMode;
    };
    Toolbar.prototype.checkToolbarResponsive = function(ele) {
        if (!(0, $5q7BP.Browser).isDevice || (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) return false;
        var tBarMode;
        if (this.parent.toolbarSettings.type === (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand) tBarMode = (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).MultiRow;
        else tBarMode = this.parent.toolbarSettings.type;
        this.baseToolbar.render({
            container: this.parent.inlineMode.enable ? "quick" : "toolbar",
            items: this.parent.toolbarSettings.items,
            mode: tBarMode,
            target: ele,
            cssClass: this.parent.getCssClass()
        });
        if (this.parent.toolbarSettings.type === (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand) {
            (0, $4ZDHT.addClass)([
                ele
            ], [
                "e-rte-tb-mobile"
            ]);
            if (this.parent.inlineMode.enable) this.addFixedTBarClass();
            else (0, $4ZDHT.addClass)([
                ele
            ], [
                $afc560df281b588d$export$9f76c1757d135a93
            ]);
        }
        this.wireEvents();
        this.dropDownModule.renderDropDowns({
            container: ele,
            containerType: this.parent.inlineMode.enable ? "quick" : "toolbar",
            items: this.parent.toolbarSettings.items
        });
        this.renderColorPicker({
            container: this.tbElement,
            containerType: this.parent.inlineMode.enable ? "quick" : "toolbar",
            items: this.parent.toolbarSettings.items
        });
        return true;
    };
    Toolbar.prototype.checkIsTransformChild = function() {
        this.isTransformChild = false;
        var transformElements = (0, $4ZDHT.selectAll)('[style*="transform"]', document);
        for(var i = 0; i < transformElements.length; i++)// eslint-disable-next-line max-len
        if (!(0, $3EnZW.isNullOrUndefined)(transformElements[i].contains) && transformElements[i].contains(this.parent.element)) {
            this.isTransformChild = true;
            break;
        }
    };
    Toolbar.prototype.toggleFloatClass = function() {
        var floatOffset = this.parent.floatingToolbarOffset;
        if (this.parent.toolbarSettings.enableFloating) {
            (0, $4ZDHT.addClass)([
                this.tbElement.parentElement
            ], [
                $afc560df281b588d$export$b46c3eca2c4f8c25
            ]);
            (0, $4ZDHT.setStyleAttribute)(this.tbElement.parentElement, {
                top: floatOffset + "px"
            });
        } else {
            (0, $4ZDHT.removeClass)([
                this.tbElement.parentElement
            ], [
                $afc560df281b588d$export$b46c3eca2c4f8c25
            ]);
            (0, $4ZDHT.setStyleAttribute)(this.tbElement.parentElement, {
                top: ""
            });
        }
    };
    Toolbar.prototype.renderToolbar = function() {
        this.initializeInstance();
        this.createToolbarElement();
        if (this.checkToolbarResponsive(this.tbElement)) return;
        if (this.parent.inlineMode.enable) this.parent.notify($947a002e9a697770$export$242492f0a40e77d2, {});
        else {
            this.baseToolbar.render({
                container: "toolbar",
                items: this.parent.toolbarSettings.items,
                mode: this.getToolbarMode(),
                target: this.tbElement,
                cssClass: this.parent.getCssClass()
            });
            if (!this.parent.inlineMode.enable) {
                if (this.parent.toolbarSettings.enableFloating) {
                    this.checkIsTransformChild();
                    this.toggleFloatClass();
                }
                (0, $4ZDHT.addClass)([
                    this.parent.element
                ], [
                    $afc560df281b588d$export$beeb26fe5b494f20
                ]);
                if (this.parent.toolbarSettings.type === (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand) (0, $4ZDHT.addClass)([
                    this.parent.element
                ], [
                    $afc560df281b588d$export$cb3f7a6ad383a6c6
                ]);
            }
        }
        this.wireEvents();
        if (this.parent.inlineMode.enable && !(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) this.addFixedTBarClass();
        if (!this.parent.inlineMode.enable) {
            this.dropDownModule.renderDropDowns({
                container: this.tbElement,
                containerType: "toolbar",
                items: this.parent.toolbarSettings.items
            });
            this.renderColorPicker({
                container: this.tbElement,
                containerType: "toolbar",
                items: this.parent.toolbarSettings.items
            });
            this.refreshToolbarOverflow();
        }
        if (this.parent.rootContainer && this.parent.rootContainer.classList.contains("e-source-code-enabled")) {
            this.parent.notify($947a002e9a697770$export$d928e346d13acf9b, {
                targetItem: "SourceCode",
                updateItem: "Preview",
                baseToolbar: this.parent.getBaseToolbarObject()
            });
            this.parent.disableToolbarItem(this.parent.toolbarSettings.items);
        }
    };
    /**
     * addFixedTBarClass method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.addFixedTBarClass = function() {
        (0, $4ZDHT.addClass)([
            this.tbElement
        ], [
            $afc560df281b588d$export$fd53f820baeb149a
        ]);
    };
    /**
     * removeFixedTBarClass method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.removeFixedTBarClass = function() {
        (0, $4ZDHT.removeClass)([
            this.tbElement
        ], [
            $afc560df281b588d$export$fd53f820baeb149a
        ]);
    };
    Toolbar.prototype.showFixedTBar = function() {
        (0, $4ZDHT.addClass)([
            this.tbElement
        ], [
            $afc560df281b588d$export$e9b981d6ef5e24ab
        ]);
        if ((0, $5q7BP.Browser).isIos) (0, $4ZDHT.addClass)([
            this.tbElement
        ], [
            $afc560df281b588d$export$22126b7681996770
        ]);
    };
    Toolbar.prototype.hideFixedTBar = function() {
        // eslint-disable-next-line
        !this.isToolbar ? (0, $4ZDHT.removeClass)([
            this.tbElement
        ], [
            $afc560df281b588d$export$e9b981d6ef5e24ab,
            $afc560df281b588d$export$22126b7681996770
        ]) : this.isToolbar = false;
    };
    /**
     * updateItem method
     *
     * @param {IUpdateItemsModel} args - specifies the arguments.
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.updateItem = function(args) {
        var item = this.tools[args.updateItem.toLocaleLowerCase()];
        if ((0, $c77ecbfae9b8c035$export$3c8120d2b233073c)(args.updateItem.toLocaleLowerCase(), this.locator) !== "Code View" && (0, $c77ecbfae9b8c035$export$3c8120d2b233073c)(args.updateItem.toLocaleLowerCase(), this.locator) !== "Preview" || this.parent.locale !== "en-US") item.tooltip = (0, $c77ecbfae9b8c035$export$3c8120d2b233073c)(args.updateItem.toLocaleLowerCase(), this.locator);
        var trgItem = this.tools[args.targetItem.toLocaleLowerCase()];
        var index = (0, $c77ecbfae9b8c035$export$e3859ff097a28f2c)((0, $c77ecbfae9b8c035$export$2716f3327981be5)(trgItem.subCommand), args.baseToolbar.toolbarObj.items)[0];
        if (!(0, $3EnZW.isNullOrUndefined)(index)) {
            var prefixId = this.parent.inlineMode.enable ? "_quick_" : "_toolbar_";
            args.baseToolbar.toolbarObj.items[index].id = this.parent.getID() + prefixId + item.id;
            args.baseToolbar.toolbarObj.items[index].prefixIcon = item.icon;
            args.baseToolbar.toolbarObj.items[index].tooltipText = item.tooltip;
            args.baseToolbar.toolbarObj.items[index].subCommand = item.subCommand;
            args.baseToolbar.toolbarObj.dataBind();
            args.baseToolbar.toolbarObj.refreshOverflow();
        } else this.addTBarItem(args, 0);
    };
    Toolbar.prototype.updateToolbarStatus = function(args) {
        if (!this.tbElement || this.parent.inlineMode.enable && ((0, $c77ecbfae9b8c035$export$80ca177350c4af26)() || !(0, $5q7BP.Browser).isDevice)) return;
        var options = {
            args: args,
            dropDownModule: this.dropDownModule,
            parent: this.parent,
            tbElements: (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, this.tbElement),
            tbItems: this.baseToolbar.toolbarObj.items
        };
        (0, $c77ecbfae9b8c035$export$a169408aecd38f56)(options, this.parent.inlineMode.enable ? true : false, this.parent);
    };
    Toolbar.prototype.fullScreen = function(e) {
        this.parent.fullScreenModule.showFullScreen(e);
    };
    Toolbar.prototype.hideScreen = function(e) {
        this.parent.fullScreenModule.hideFullScreen(e);
    };
    /**
     * getBaseToolbar method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.getBaseToolbar = function() {
        return this.baseToolbar;
    };
    /**
     * addTBarItem method
     *
     * @param {IUpdateItemsModel} args - specifies the arguments.
     * @param {number} index - specifies the index value.
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.addTBarItem = function(args, index) {
        args.baseToolbar.toolbarObj.addItems([
            args.baseToolbar.getObject(args.updateItem, "toolbar")
        ], index);
    };
    /**
     * enableTBarItems method
     *
     * @param {BaseToolbar} baseToolbar - specifies the toolbar.
     * @param {string} items - specifies the string value.
     * @param {boolean} isEnable - specifies the boolean value.
     * @param {boolean} muteToolbarUpdate - specifies the toolbar.
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.enableTBarItems = function(baseToolbar, items, isEnable, muteToolbarUpdate) {
        var trgItems = (0, $c77ecbfae9b8c035$export$e3859ff097a28f2c)((0, $c77ecbfae9b8c035$export$2716f3327981be5)(items), baseToolbar.toolbarObj.items);
        this.tbItems = (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, baseToolbar.toolbarObj.element);
        for(var i = 0; i < trgItems.length; i++){
            var item = this.tbItems[trgItems[i]];
            if (item) baseToolbar.toolbarObj.enableItems(item, isEnable);
        }
        if (!(0, $4ZDHT.select)("." + $afc560df281b588d$export$97efb1fe9920382d, this.parent.element) && !muteToolbarUpdate) (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(baseToolbar, this.parent.formatter.editorManager.undoRedoManager.getUndoStatus());
    };
    /**
     * removeTBarItems method
     *
     * @param {string} items - specifies the string value.
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.removeTBarItems = function(items) {
        if ((0, $3EnZW.isNullOrUndefined)(this.baseToolbar.toolbarObj)) this.baseToolbar = this.parent.getBaseToolbarObject();
        var trgItems = (0, $c77ecbfae9b8c035$export$e3859ff097a28f2c)((0, $c77ecbfae9b8c035$export$2716f3327981be5)(items), this.baseToolbar.toolbarObj.items);
        this.tbItems = this.parent.inlineMode.enable ? (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, this.baseToolbar.toolbarObj.element) : (0, $4ZDHT.selectAll)("." + $afc560df281b588d$export$43195ed9dfb35649, this.parent.element);
        for(var i = 0; i < trgItems.length; i++)this.baseToolbar.toolbarObj.removeItems(this.tbItems[trgItems[i]]);
    };
    /**
     * getExpandTBarPopHeight method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.getExpandTBarPopHeight = function() {
        var popHeight = 0;
        if (this.parent.toolbarSettings.type === (0, $2eaa618655f536c2$export$a5d11b3163e4b1a5).Expand && this.tbElement.classList.contains("e-extended-toolbar")) {
            var expandPopup = (0, $4ZDHT.select)(".e-toolbar-extended", this.tbElement);
            if (expandPopup && this.tbElement.classList.contains("e-expand-open") || expandPopup && expandPopup.classList.contains("e-popup-open")) {
                (0, $4ZDHT.addClass)([
                    expandPopup
                ], [
                    $afc560df281b588d$export$1e3d54316c24cb7e
                ]);
                popHeight = popHeight + expandPopup.offsetHeight;
                (0, $4ZDHT.removeClass)([
                    expandPopup
                ], [
                    $afc560df281b588d$export$1e3d54316c24cb7e
                ]);
            } else (0, $4ZDHT.removeClass)([
                this.tbElement
            ], [
                $afc560df281b588d$export$c024b26acaa71d78
            ]);
        }
        return popHeight;
    };
    /**
     * getToolbarHeight method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.getToolbarHeight = function() {
        return this.tbElement.offsetHeight;
    };
    /**
     * getToolbarElement method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.getToolbarElement = function() {
        return this.parent && this.parent.element ? (0, $4ZDHT.select)("." + $afc560df281b588d$export$c944507d642a4701, this.parent.element) : null;
    };
    /**
     * refreshToolbarOverflow method
     *
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.refreshToolbarOverflow = function() {
        this.parent.element.classList.remove($afc560df281b588d$export$634124fb33d6a503);
        this.baseToolbar.toolbarObj.refreshOverflow();
        if (this.parent.enableRtl) this.parent.element.classList.add($afc560df281b588d$export$634124fb33d6a503);
    };
    Toolbar.prototype.isToolbarDestroyed = function() {
        return this.baseToolbar && this.baseToolbar.toolbarObj && this.baseToolbar.toolbarObj.isDestroyed ? true : false;
    };
    Toolbar.prototype.destroyToolbar = function() {
        if (!this.isToolbarDestroyed()) {
            this.parent.unWireScrollElementsEvents();
            this.unWireEvents();
            this.dropDownModule.destroy();
            if (this.parent.emojiPickerModule && !this.parent.emojiPickerModule.isPopupDestroyed) this.parent.emojiPickerModule.childDestroy();
            this.dropDownModule = null;
            this.colorPickerModule.destroy();
            this.colorPickerModule = null;
            if (this.keyBoardModule) {
                this.keyBoardModule.destroy();
                this.keyBoardModule = null;
            }
            this.baseToolbar.destroy();
            this.removeEventListener();
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], [
                $afc560df281b588d$export$beeb26fe5b494f20
            ]);
            (0, $4ZDHT.removeClass)([
                this.parent.element
            ], [
                $afc560df281b588d$export$cb3f7a6ad383a6c6
            ]);
            var tbWrapper = (0, $4ZDHT.select)("." + $afc560df281b588d$export$8b3fa306a1b76ad1, this.parent.element);
            var tbElement = (0, $4ZDHT.select)("." + $afc560df281b588d$export$c944507d642a4701, this.parent.element);
            if (!(0, $3EnZW.isNullOrUndefined)(tbWrapper)) (0, $4ZDHT.detach)(tbWrapper);
            if (!(0, $3EnZW.isNullOrUndefined)(tbElement)) (0, $4ZDHT.detach)(tbElement);
        }
    };
    /**
     * Destroys the ToolBar.
     *
     * @function destroy
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.destroy = function() {
        if (this.isDestroyed) return;
        if (!this.isToolbarDestroyed()) this.destroyToolbar();
        this.toolbarObj = null;
        this.editPanel = null;
        this.isToolbar = null;
        this.editableElement = null;
        this.tbItems = null;
        this.baseToolbar = null;
        this.tbElement = null;
        this.tbWrapper = null;
        this.isTransformChild = null;
        this.contentRenderer = null;
        this.dropDownModule = null;
        this.colorPickerModule = null;
        this.toolbarActionModule = null;
        this.tools = null;
        this.locator = null;
        this.renderFactory = null;
        this.isDestroyed = true;
    };
    Toolbar.prototype.mouseDownHandler = function() {
        if ((0, $5q7BP.Browser).isDevice && this.parent.inlineMode.enable && !(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) this.showFixedTBar();
    };
    Toolbar.prototype.focusChangeHandler = function() {
        if ((0, $5q7BP.Browser).isDevice && this.parent.inlineMode.enable && !(0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) {
            this.isToolbar = false;
            this.hideFixedTBar();
        }
    };
    Toolbar.prototype.dropDownBeforeOpenHandler = function() {
        this.isToolbar = true;
    };
    // eslint-disable-next-line
    Toolbar.prototype.tbFocusHandler = function(e) {
        var activeElm = document.activeElement;
        var isToolbaractive = (0, $4ZDHT.closest)(activeElm, ".e-rte-toolbar");
        if (activeElm === this.parent.getToolbarElement() || isToolbaractive === this.parent.getToolbarElement()) {
            var toolbarItem = this.parent.getToolbarElement().querySelectorAll(".e-expended-nav");
            for(var i = 0; i < toolbarItem.length; i++)if ((0, $3EnZW.isNullOrUndefined)(this.parent.getToolbarElement().querySelector(".e-insert-table-btn"))) toolbarItem[i].setAttribute("tabindex", "0");
            else toolbarItem[i].setAttribute("tabindex", "1");
        }
    };
    Toolbar.prototype.wireEvents = function() {
        if (this.parent.inlineMode.enable && (0, $c77ecbfae9b8c035$export$80ca177350c4af26)()) return;
        (0, $aqzbR.EventHandler).add(this.tbElement, "focusin", this.tbFocusHandler, this);
    };
    Toolbar.prototype.unWireEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.tbElement, "focusin", this.tbFocusHandler);
    };
    Toolbar.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.dropDownModule = new (0, $7fd080065df28547$export$6a25c66b900b8efc)(this.parent, this.locator);
        this.toolbarActionModule = new (0, $d2db5b36b87bd9bf$export$79d646a7038cf516)(this.parent);
        this.colorPickerModule = new (0, $7284c217dd61c302$export$75bdaf6ecc1f1e02)(this.parent, this.locator);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.renderToolbar, this);
        this.parent.on($947a002e9a697770$export$c909ec3b151c9e0e, this.toolbarBindEvent, this);
        this.parent.on($947a002e9a697770$export$209bc394f8eec6dc, this.updateToolbarStatus, this);
        this.parent.on($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged, this);
        this.parent.on($947a002e9a697770$export$8502058ba5fe50a0, this.onRefresh, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
        this.parent.on($947a002e9a697770$export$6b5a35c4a823eab1, this.fullScreen, this);
        this.parent.on($947a002e9a697770$export$7f96353fc4f89f6b, this.hideScreen, this);
        this.parent.on($947a002e9a697770$export$d928e346d13acf9b, this.updateItem, this);
        this.parent.on($947a002e9a697770$export$3582505bf03a41c5, this.dropDownBeforeOpenHandler, this);
        this.parent.on($947a002e9a697770$export$ceb2354ae09b6ff, this.focusChangeHandler, this);
        this.parent.on($947a002e9a697770$export$ea32a7693b83cfdb, this.mouseDownHandler, this);
        this.parent.on($947a002e9a697770$export$20d87a998eb21859, this.mouseDownHandler, this);
        this.parent.on($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass, this);
    };
    Toolbar.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.renderToolbar);
        this.parent.off($947a002e9a697770$export$c909ec3b151c9e0e, this.toolbarBindEvent);
        this.parent.off($947a002e9a697770$export$209bc394f8eec6dc, this.updateToolbarStatus);
        this.parent.off($947a002e9a697770$export$80cded91831c5507, this.onPropertyChanged);
        this.parent.off($947a002e9a697770$export$8502058ba5fe50a0, this.onRefresh);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        this.parent.off($947a002e9a697770$export$6b5a35c4a823eab1, this.parent.fullScreenModule.showFullScreen);
        this.parent.off($947a002e9a697770$export$7f96353fc4f89f6b, this.parent.fullScreenModule.hideFullScreen);
        this.parent.off($947a002e9a697770$export$d928e346d13acf9b, this.updateItem);
        this.parent.off($947a002e9a697770$export$3582505bf03a41c5, this.dropDownBeforeOpenHandler);
        this.parent.off($947a002e9a697770$export$ceb2354ae09b6ff, this.focusChangeHandler);
        this.parent.off($947a002e9a697770$export$ea32a7693b83cfdb, this.mouseDownHandler);
        this.parent.off($947a002e9a697770$export$20d87a998eb21859, this.mouseDownHandler);
        this.parent.off($947a002e9a697770$export$3195fd95fc6395d5, this.setCssClass);
    };
    // eslint-disable-next-line @typescript-eslint/tslint/config
    Toolbar.prototype.setCssClass = function(e) {
        if (this.toolbarObj && e.cssClass) {
            if ((0, $3EnZW.isNullOrUndefined)(e.oldCssClass)) this.toolbarObj.setProperties({
                cssClass: (this.toolbarObj.cssClass + " " + e.cssClass).trim()
            });
            else this.toolbarObj.setProperties({
                cssClass: (this.toolbarObj.cssClass.replace(e.oldCssClass, "").trim() + " " + e.cssClass).trim()
            });
        }
    };
    Toolbar.prototype.onRefresh = function() {
        if (!this.parent.inlineMode.enable) this.refreshToolbarOverflow();
        this.parent.autoResize();
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} e - specifies the string value
     * @returns {void}
     * @hidden

     */ Toolbar.prototype.onPropertyChanged = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.inlineMode)) for(var _i = 0, _a = Object.keys(e.newProp.inlineMode); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "enable":
                    this.refreshToolbar();
                    break;
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.toolbarSettings)) {
            if (!(0, $3EnZW.isNullOrUndefined)(e.newProp.toolbarSettings.enableFloating)) this.toggleFloatClass();
        }
        if (e.module !== this.getModuleName()) return;
        this.refreshToolbar();
    };
    Toolbar.prototype.refreshToolbar = function() {
        if ((0, $3EnZW.isNullOrUndefined)(this.baseToolbar.toolbarObj)) this.baseToolbar = this.parent.getBaseToolbarObject();
        var tbWrapper = (0, $4ZDHT.select)("." + $afc560df281b588d$export$8b3fa306a1b76ad1, this.parent.element);
        var tbElement = (0, $4ZDHT.select)("." + $afc560df281b588d$export$c944507d642a4701, this.parent.element);
        if (tbElement || tbWrapper) this.destroyToolbar();
        if (this.parent.toolbarSettings.enable) {
            if (this.baseToolbar && this.baseToolbar.toolbarObj && !this.baseToolbar.toolbarObj.isDestroyed) this.baseToolbar.destroy();
            this.baseToolbar = new (0, $a8379000104ab123$export$550e9eddeb4f342e)(this.parent, this.locator);
            this.addEventListener();
            this.renderToolbar();
            this.parent.wireScrollElementsEvents();
            if (!(0, $4ZDHT.select)("." + $afc560df281b588d$export$97efb1fe9920382d, this.parent.element) && !this.parent.inlineMode.enable) (0, $c77ecbfae9b8c035$export$c584fa307b6d1ee0)(this.baseToolbar, this.parent.formatter.editorManager.undoRedoManager.getUndoStatus());
            this.parent.notify($947a002e9a697770$export$446aef6294af7f8b, {});
        }
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ Toolbar.prototype.getModuleName = function() {
        return "toolbar";
    };
    Toolbar.prototype.renderColorPicker = function(args) {
        this.colorPickerModule.renderColorPickerInput(args);
    };
    return Toolbar;
}();

parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $cfGuF = parcelRequire("cfGuF");
var $5q7BP = parcelRequire("5q7BP");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");







var $aa3fd79c644fe28d$export$ae01dedf5c052bb = /** @class */ function() {
    function Video(parent, serviceLocator) {
        this.isVideoUploaded = false;
        this.isAllowedTypes = true;
        this.pageX = null;
        this.pageY = null;
        this.mouseX = null;
        this.deletedVid = [];
        this.isResizeBind = true;
        this.parent = parent;
        this.rteID = parent.element.id;
        this.i10n = serviceLocator.getService("rteLocale");
        this.rendererFactory = serviceLocator.getService("rendererFactory");
        this.dialogRenderObj = serviceLocator.getService("dialogRenderObject");
        this.addEventListener();
        this.isDestroyed = false;
        this.docClick = this.onDocumentClick.bind(this);
    }
    Video.prototype.addEventListener = function() {
        if (this.parent.isDestroyed) return;
        this.parent.on($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown, this);
        this.parent.on($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp, this);
        this.parent.on($947a002e9a697770$export$73a289ac38fc1ec, this.insertingVideo, this);
        this.parent.on($947a002e9a697770$export$5d4840440f592fca, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$446aef6294af7f8b, this.afterRender, this);
        this.parent.on($947a002e9a697770$export$bad6189f4d27c01f, this.onWindowResize, this);
        this.parent.on($947a002e9a697770$export$747747cd285e0bb9, this.showDialog, this);
        this.parent.on($947a002e9a697770$export$2b859288d6d27b84, this.closeDialog, this);
        this.parent.on($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect, this);
        this.parent.on($947a002e9a697770$export$9aa8e6dd9bc07056, this.deleteVideo, this);
        this.parent.on($947a002e9a697770$export$5f8f11a2ec9ad852, this.onToolbarAction, this);
        this.parent.on($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler, this);
        this.parent.on($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown, this);
        this.parent.on($947a002e9a697770$export$383e1e0225d28d1e, this.videoSize, this);
        this.parent.on($947a002e9a697770$export$ac0f8621e12395a0, this.showVideoQuickToolbar, this);
        this.parent.on($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj, this);
        this.parent.on($947a002e9a697770$export$b1fb4cac938035f7, this.destroy, this);
    };
    Video.prototype.removeEventListener = function() {
        this.parent.off($947a002e9a697770$export$d081dc64f99d208b, this.onKeyDown);
        this.parent.off($947a002e9a697770$export$2bfa26ed2a709c52, this.onKeyUp);
        this.parent.off($947a002e9a697770$export$73a289ac38fc1ec, this.insertingVideo);
        this.parent.off($947a002e9a697770$export$bad6189f4d27c01f, this.onWindowResize);
        this.parent.off($947a002e9a697770$export$5d4840440f592fca, this.afterRender);
        this.parent.off($947a002e9a697770$export$446aef6294af7f8b, this.afterRender);
        this.parent.off($947a002e9a697770$export$747747cd285e0bb9, this.showDialog);
        this.parent.off($947a002e9a697770$export$2b859288d6d27b84, this.closeDialog);
        this.parent.off($947a002e9a697770$export$55eface7583121e7, this.alignmentSelect);
        this.parent.off($947a002e9a697770$export$9aa8e6dd9bc07056, this.deleteVideo);
        this.parent.off($947a002e9a697770$export$5f8f11a2ec9ad852, this.onToolbarAction);
        this.parent.off($947a002e9a697770$export$faf30c817b12eec0, this.editAreaClickHandler);
        this.parent.off($947a002e9a697770$export$b23f8993ab731614, this.onIframeMouseDown);
        this.parent.off($947a002e9a697770$export$383e1e0225d28d1e, this.videoSize);
        this.parent.off($947a002e9a697770$export$ac0f8621e12395a0, this.showVideoQuickToolbar);
        this.parent.off($947a002e9a697770$export$7b0b04da5bd57800, this.clearDialogObj);
        this.parent.off($947a002e9a697770$export$b1fb4cac938035f7, this.destroy);
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule)) {
            (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.videoClick);
            this.parent.formatter.editorManager.observer.off($947a002e9a697770$export$b2d123672bfdbe32, this.undoStack);
            if (this.parent.insertVideoSettings.resize) {
                (0, $aqzbR.EventHandler).remove(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart);
                this.parent.element.ownerDocument.removeEventListener("mousedown", this.docClick);
                this.docClick = null;
                (0, $aqzbR.EventHandler).remove(this.contentModule.getEditPanel(), "cut", this.onCutHandler);
                (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
            }
        }
    };
    Video.prototype.afterRender = function() {
        this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
        (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchEndEvent, this.videoClick, this);
        if (this.parent.insertVideoSettings.resize) {
            (0, $aqzbR.EventHandler).add(this.parent.contentModule.getEditPanel(), (0, $5q7BP.Browser).touchStartEvent, this.resizeStart, this);
            this.parent.element.ownerDocument.addEventListener("mousedown", this.docClick);
            (0, $aqzbR.EventHandler).add(this.contentModule.getEditPanel(), "cut", this.onCutHandler, this);
        }
    };
    Video.prototype.clearDialogObj = function() {
        if (this.uploadObj && !this.uploadObj.isDestroyed) {
            this.uploadObj.destroy();
            (0, $4ZDHT.detach)(this.uploadObj.element);
            this.uploadObj = null;
        }
        if (this.webUrlBtn && !this.webUrlBtn.isDestroyed) {
            this.webUrlBtn.destroy();
            (0, $4ZDHT.detach)(this.webUrlBtn.element);
            this.webUrlBtn = null;
        }
        if (this.embedUrlBtn && !this.embedUrlBtn.isDestroyed) {
            this.embedUrlBtn.destroy();
            (0, $4ZDHT.detach)(this.embedUrlBtn.element);
            this.embedUrlBtn = null;
        }
        if (this.widthNum && !this.widthNum.isDestroyed) {
            this.widthNum.destroy();
            (0, $4ZDHT.detach)(this.widthNum.element);
            this.widthNum = null;
        }
        if (this.heightNum && !this.heightNum.isDestroyed) {
            this.heightNum.destroy();
            (0, $4ZDHT.detach)(this.heightNum.element);
            this.heightNum = null;
        }
        if (this.button && !this.button.isDestroyed) {
            this.button.destroy();
            (0, $4ZDHT.detach)(this.button.element);
            this.heightNum = null;
        }
        if (this.dialogObj && this.dialogObj.element) {
            this.dialogObj.destroy();
            (0, $4ZDHT.detach)(this.dialogObj.element);
            this.dialogObj = null;
        }
    };
    // eslint-disable-next-line
    Video.prototype.onKeyUp = function(event) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.deletedVid) && this.deletedVid.length > 0) for(var i = 0; i < this.deletedVid.length; i++){
            var args = {
                element: this.deletedVid[i],
                src: this.deletedVid[i].tagName !== "IFRAME" ? this.deletedVid[i].querySelector("source").getAttribute("src") : this.deletedVid[i].src
            };
            this.parent.trigger($947a002e9a697770$export$bd12237ad996f402, args);
        }
    };
    Video.prototype.undoStack = function(args) {
        if ((args.subCommand.toLowerCase() === "undo" || args.subCommand.toLowerCase() === "redo") && this.parent.editorMode === "HTML") for(var i = 0; i < this.parent.formatter.getUndoRedoStack().length; i++){
            var temp = this.parent.createElement("div");
            var contentElem = this.parent.formatter.getUndoRedoStack()[i].text;
            temp.appendChild(contentElem.cloneNode(true));
            var vid = temp.querySelectorAll("video");
            if (temp.querySelector(".e-vid-resize") && vid.length > 0) {
                for(var j = 0; j < vid.length; j++)vid[j].style.outline = "";
                (0, $4ZDHT.detach)(temp.querySelector(".e-vid-resize"));
                var clonedElement = temp.cloneNode(true);
                var fragment = document.createDocumentFragment();
                while(clonedElement.firstChild)fragment.appendChild(clonedElement.firstChild);
                this.parent.formatter.getUndoRedoStack()[i].text = fragment;
            }
        }
    };
    Video.prototype.onIframeMouseDown = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Video.prototype.videoSize = function(e) {
        var _this = this;
        if (e.selectNode[0].nodeName !== "VIDEO" && !this.isEmbedVidElem(e.selectNode[0])) return;
        this.insertVideo(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            var vidSizeHeader = this.i10n.getConstant("videoSizeHeader");
            var linkUpdate = this.i10n.getConstant("dialogUpdate");
            var dialogContent = this.vidsizeInput(e);
            var selectObj_1 = {
                args: e.args,
                selfVideo: this,
                selection: e.selection,
                selectNode: e.selectNode
            };
            this.dialogObj.setProperties({
                width: "290px",
                header: vidSizeHeader,
                content: dialogContent,
                buttons: [
                    {
                        // eslint-disable-next-line
                        click: function(e) {
                            _this.insertSize(selectObj_1);
                        },
                        buttonModel: {
                            content: linkUpdate,
                            cssClass: "e-flat e-update-size",
                            isPrimary: true
                        }
                    }
                ]
            });
            this.dialogObj.element.style.maxHeight = "inherit";
            this.dialogObj.content.querySelector("input").focus();
        }
    };
    Video.prototype.vidsizeInput = function(e) {
        var _this = this;
        var selectNode = e.selectNode[0];
        var vidHeight = this.i10n.getConstant("videoHeight");
        var vidWidth = this.i10n.getConstant("videoWidth");
        var vidSizeWrap = this.parent.createElement("div", {
            className: "e-video-sizewrap"
        });
        var widthVal = (0, $3EnZW.isNullOrUndefined)(this.changedWidthValue) && (selectNode.style.width.toString() === "auto" || selectNode.style.width !== "") ? selectNode.style.width : !(0, $3EnZW.isNullOrUndefined)(this.changedWidthValue) ? this.changedWidthValue : parseInt(selectNode.getClientRects()[0].width.toString(), 10).toString();
        var heightVal = (0, $3EnZW.isNullOrUndefined)(this.changedHeightValue) && (selectNode.style.height.toString() === "auto" || selectNode.style.height !== "") ? selectNode.style.height : !(0, $3EnZW.isNullOrUndefined)(this.changedHeightValue) ? this.changedHeightValue : parseInt(selectNode.getClientRects()[0].height.toString(), 10).toString();
        this.changedWidthValue = null;
        this.changedHeightValue = null;
        var content = '<div class="e-rte-label"><label>' + vidWidth + '</label></div><div class="e-rte-field"><input type="text" id="vidwidth" class="e-vid-width" value=' + widthVal + " /></div>" + '<div class="e-rte-label">' + "<label>" + vidHeight + '</label></div><div class="e-rte-field"> ' + '<input type="text" id="vidheight" class="e-vid-height" value=' + heightVal + " /></div>";
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        vidSizeWrap.appendChild(contentElem);
        this.widthNum = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
            value: (0, $3EnZW.formatUnit)(widthVal),
            enableRtl: this.parent.enableRtl,
            input: function(e) {
                _this.inputWidthValue = (0, $3EnZW.formatUnit)(e.value);
            }
        });
        this.widthNum.createElement = this.parent.createElement;
        this.widthNum.appendTo(vidSizeWrap.querySelector("#vidwidth"));
        this.heightNum = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
            value: (0, $3EnZW.formatUnit)(heightVal),
            enableRtl: this.parent.enableRtl,
            input: function(e) {
                _this.inputHeightValue = (0, $3EnZW.formatUnit)(e.value);
            }
        });
        this.heightNum.createElement = this.parent.createElement;
        this.heightNum.appendTo(vidSizeWrap.querySelector("#vidheight"));
        return vidSizeWrap;
    };
    Video.prototype.insertSize = function(e) {
        e.selection.restore();
        var proxy = e.selfVideo;
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        var dialogEle = proxy.dialogObj.element;
        this.changedWidthValue = this.inputWidthValue;
        this.changedHeightValue = this.inputHeightValue;
        var width = dialogEle.querySelector(".e-vid-width").value;
        var height = dialogEle.parentElement.querySelector(".e-vid-height").value;
        proxy.parent.formatter.process(this.parent, e.args, e.args, {
            width: width,
            height: height,
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
        if (this.vidResizeDiv) {
            e.selectNode[0] = e.selectNode[0].tagName === "VIDEO" || e.selectNode[0].tagName === "IFRAME" ? e.selectNode[0] : e.selectNode[0].querySelector("iframe");
            proxy.vidResizePos(e.selectNode[0], this.vidResizeDiv);
        }
        proxy.dialogObj.hide({
            returnValue: true
        });
    };
    Video.prototype.resizeEnd = function(e) {
        this.resizeBtnInit();
        this.videoEle.parentElement.style.cursor = "auto";
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.removeClass)([
            e.target.parentElement
        ], "e-mob-span");
        var args = {
            event: e,
            requestType: "videos"
        };
        this.parent.trigger($947a002e9a697770$export$8c4d3b559babc6db, args);
        /* eslint-disable */ var pageX = this.getPointX(e);
        var pageY = this.parent.iframeSettings.enable ? window.pageYOffset + this.parent.element.getBoundingClientRect().top + e.clientY : e.pageY;
        /* eslint-enable */ this.parent.formatter.editorManager.observer.on($947a002e9a697770$export$b2d123672bfdbe32, this.undoStack, this);
        this.parent.formatter.saveData();
    };
    Video.prototype.resizeStart = function(e, ele) {
        var _this = this;
        if (this.parent.readonly) return;
        var target = ele ? ele : !this.isEmbedVidElem(e.target) ? e.target : e.target.querySelector("iframe");
        this.prevSelectedVidEle = this.videoEle;
        if (target.tagName === "VIDEO" || target.tagName === "IFRAME") {
            this.parent.preventDefaultResize(e);
            var videoElem = target;
            if (this.vidResizeDiv && this.contentModule.getEditPanel().contains(this.vidResizeDiv)) (0, $4ZDHT.detach)(this.vidResizeDiv);
            this.videoResize(videoElem);
        }
        if (target.classList.contains("e-rte-videoboxmark")) {
            if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
            this.pageX = this.getPointX(e);
            this.pageY = this.getPointY(e);
            e.preventDefault();
            e.stopImmediatePropagation();
            this.resizeBtnInit();
            if (this.quickToolObj) this.quickToolObj.videoQTBar.hidePopup();
            if (target.classList.contains("e-rte-topLeft")) this.resizeBtnStat.topLeft = true;
            if (target.classList.contains("e-rte-topRight")) this.resizeBtnStat.topRight = true;
            if (target.classList.contains("e-rte-botLeft")) this.resizeBtnStat.botLeft = true;
            if (target.classList.contains("e-rte-botRight")) this.resizeBtnStat.botRight = true;
            if ((0, $5q7BP.Browser).isDevice && this.contentModule.getEditPanel().contains(this.vidResizeDiv) && !this.vidResizeDiv.classList.contains("e-mob-span")) (0, $4ZDHT.addClass)([
                this.vidResizeDiv
            ], "e-mob-span");
            else {
                var args = {
                    event: e,
                    requestType: "videos"
                };
                this.parent.trigger($947a002e9a697770$export$6aff6a45c0c4e7c4, args, function(resizeStartArgs) {
                    if (resizeStartArgs.cancel) _this.cancelResizeAction();
                });
            }
            if (this.isResizeBind) {
                (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing, this);
                (0, $aqzbR.EventHandler).add(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd, this);
                this.isResizeBind = false;
            }
        }
    };
    Video.prototype.videoClick = function(e) {
        if ((0, $5q7BP.Browser).isDevice) {
            if (e.target.tagName === "VIDEO" || this.isEmbedVidElem(e.target)) {
                this.contentModule.getEditPanel().setAttribute("contenteditable", "false");
                e.target.focus();
            } else if (!this.parent.readonly) this.contentModule.getEditPanel().setAttribute("contenteditable", "true");
        }
        if (e.target.tagName === "VIDEO" || this.isEmbedVidElem(e.target)) e.preventDefault();
    };
    Video.prototype.onCutHandler = function() {
        if (this.vidResizeDiv && this.contentModule.getEditPanel().contains(this.vidResizeDiv)) this.cancelResizeAction();
    };
    Video.prototype.videoResize = function(e) {
        this.resizeBtnInit();
        this.videoEle = e;
        (0, $4ZDHT.addClass)([
            this.videoEle
        ], "e-resize");
        this.vidResizeDiv = this.parent.createElement("span", {
            className: "e-vid-resize",
            id: this.rteID + "_vidResize"
        });
        this.vidResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-videoboxmark e-rte-topLeft",
            styles: "cursor: nwse-resize"
        }));
        this.vidResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-videoboxmark e-rte-topRight",
            styles: "cursor: nesw-resize"
        }));
        this.vidResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-videoboxmark e-rte-botLeft",
            styles: "cursor: nesw-resize"
        }));
        this.vidResizeDiv.appendChild(this.parent.createElement("span", {
            className: "e-rte-videoboxmark e-rte-botRight",
            styles: "cursor: nwse-resize"
        }));
        if ((0, $5q7BP.Browser).isDevice) (0, $4ZDHT.addClass)([
            this.vidResizeDiv
        ], "e-mob-rte");
        e.style.outline = "2px solid #4a90e2";
        this.vidResizePos(e, this.vidResizeDiv);
        this.resizeVidDupPos(e);
        this.contentModule.getEditPanel().appendChild(this.vidResizeDiv);
    };
    Video.prototype.getPointX = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageX;
        else return e.pageX;
    };
    Video.prototype.getPointY = function(e) {
        if (e.touches && e.touches.length) return e.touches[0].pageY;
        else return e.pageY;
    };
    Video.prototype.vidResizePos = function(e, vidResizeDiv) {
        if ((0, $3EnZW.isNullOrUndefined)(vidResizeDiv)) return;
        var pos = this.calcPos(e);
        var top = pos.top;
        var left = pos.left;
        var vidWid = e.width !== 0 && e.width !== "auto" && e.width !== "NaN" ? e.width : e.getBoundingClientRect().width;
        var vidHgt = e.height !== 0 && e.height !== "auto" && e.height !== "NaN" ? e.height : e.getBoundingClientRect().height;
        var borWid = (0, $5q7BP.Browser).isDevice ? 4 * parseInt(e.style.outline.slice(-3), 10) + 2 : 2 * parseInt(e.style.outline.slice(-3), 10) + 2; //span border width + video outline width
        var devWid = (0, $5q7BP.Browser).isDevice ? 0 : 2; // span border width
        vidResizeDiv.querySelector(".e-rte-botLeft").style.left = left - borWid + "px";
        vidResizeDiv.querySelector(".e-rte-botLeft").style.top = parseInt(vidHgt.toString(), 10) - borWid + top + "px";
        vidResizeDiv.querySelector(".e-rte-botRight").style.left = parseInt(vidWid.toString(), 10) - (borWid - devWid) + left + "px";
        vidResizeDiv.querySelector(".e-rte-botRight").style.top = parseInt(vidHgt.toString(), 10) - borWid + top + "px";
        vidResizeDiv.querySelector(".e-rte-topRight").style.left = parseInt(vidWid.toString(), 10) - (borWid - devWid) + left + "px";
        vidResizeDiv.querySelector(".e-rte-topRight").style.top = top - borWid + "px";
        vidResizeDiv.querySelector(".e-rte-topLeft").style.left = left - borWid + "px";
        vidResizeDiv.querySelector(".e-rte-topLeft").style.top = top - borWid + "px";
    };
    Video.prototype.calcPos = function(elem) {
        var ignoreOffset = [
            "TD",
            "TH",
            "TABLE",
            "A"
        ];
        var parentOffset = {
            top: 0,
            left: 0
        };
        var elementOffset;
        var doc = elem.ownerDocument;
        var offsetParent = (elem.offsetParent && (elem.offsetParent.classList.contains("e-video-clickelem") || ignoreOffset.indexOf(elem.offsetParent.tagName) > -1) ? (0, $4ZDHT.closest)(elem, "#" + this.parent.getID() + "_rte-edit-view") : elem.offsetParent) || doc.documentElement;
        while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && offsetParent.style.position === "static")offsetParent = offsetParent.parentNode;
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) parentOffset = offsetParent.getBoundingClientRect();
        if (elem && elem.nodeType === 1 && elem.tagName === "IFRAME") {
            elementOffset = elem.getBoundingClientRect();
            return {
                top: elementOffset.top - parentOffset.top,
                left: elementOffset.left - parentOffset.left
            };
        } else return {
            top: elem.offsetTop,
            left: elem.offsetLeft
        };
    };
    Video.prototype.setAspectRatio = function(vid, expectedX, expectedY, e) {
        var vidEleStyle = getComputedStyle(vid);
        if ((0, $3EnZW.isNullOrUndefined)(vidEleStyle)) return;
        var regExp = RegExp;
        var width = vidEleStyle.width !== "" ? vidEleStyle.width.match(new regExp("^\\d+(\\.\\d*)?%$", "g")) ? parseFloat(vidEleStyle.width) : parseInt(vidEleStyle.width, 10) : vid.style.width !== "" ? vid.style.width : vid.width;
        var height = vidEleStyle.height !== "" ? parseInt(vidEleStyle.height, 10) : vid.style.height !== "" ? vid.style.height : vid.height;
        width = width.toString().match(new regExp("\\b\\d+(\\.\\d*)?(%|$)\\b", "g")) ? parseFloat(width.toString()) : parseInt(width.toString(), 10);
        height = height.toString().match(new regExp("\\b\\d+(\\.\\d*)?(%|$)\\b", "g")) ? parseFloat(height.toString()) : parseInt(height.toString(), 10);
        /* eslint-enable */ if (width > height) {
            vid.style.minWidth = this.parent.insertVideoSettings.minWidth === 0 ? "200px" : (0, $3EnZW.formatUnit)(this.parent.insertVideoSettings.minWidth);
            vid.style.minHeight = this.parent.insertVideoSettings.minHeight === 0 ? "90px" : (0, $3EnZW.formatUnit)(this.parent.insertVideoSettings.minHeight);
            if (this.parent.insertVideoSettings.resizeByPercent) this.updateVidEleWidth(vid, width, height, expectedX, expectedY);
            else if (vid.style.width === "" && vid.style.height !== "" || vidEleStyle.width === "" && vidEleStyle.height !== "") vid.style.height = expectedY + "px";
            else if (vid.style.width !== "" && vid.style.height === "" || vidEleStyle.width !== "" && vidEleStyle.height === "") {
                var currentWidth = width / height * expectedY + width / height < this.parent.inputElement.getBoundingClientRect().right - 32 ? width / height * expectedY + width / height : this.parent.inputElement.getBoundingClientRect().right - 32;
                vid.style.width = currentWidth.toString() + "px";
            } else if (vid.style.width !== "" || vidEleStyle.width !== "") {
                var currentWidth = width / height * expectedY < this.parent.inputElement.getBoundingClientRect().right - 32 ? width / height * expectedY : this.parent.inputElement.getBoundingClientRect().right - 32;
                vid.style.width = currentWidth + "px";
                vid.style.height = expectedY + "px";
            } else vid.setAttribute("width", parseInt((width / height * expectedY + width / height).toString(), 10).toString());
        } else if (height > width) {
            if (this.parent.insertVideoSettings.resizeByPercent) this.updateVidEleWidth(vid, width, height, expectedX, expectedY);
            else if (vidEleStyle.width !== "" || vid.style.width !== "") {
                vid.style.width = expectedX + "px";
                vid.style.height = height / width * expectedX + "px";
            } else vid.setAttribute("width", this.resizeBtnStat.botRight ? (this.getPointX(e.event) - vid.getBoundingClientRect().left).toString() : expectedX.toString());
        } else if (this.parent.insertVideoSettings.resizeByPercent) {
            vid.style.width = this.pixToPerc(expectedX, vid.previousElementSibling || vid.parentElement) + "%";
            vid.style.height = null;
            vid.removeAttribute("height");
        } else {
            vid.style.width = expectedX + "px";
            vid.style.height = expectedX + "px";
        }
    };
    Video.prototype.updateVidEleWidth = function(vid, width, height, expectedX, expectedY) {
        if (parseInt("" + vid.getBoundingClientRect().width + "", 10) !== 0 && parseInt("" + width + "", 10) !== 0) {
            var original = vid.offsetWidth + this.mouseX;
            var finalWidthByPerc = original / vid.offsetWidth * (parseFloat(vid.style.width).toString() === "NaN" ? vid.offsetWidth / parseFloat(getComputedStyle(this.parent.element).width) * 100 : parseFloat(vid.style.width));
            vid.style.width = (finalWidthByPerc > 3 ? finalWidthByPerc : 3) + "%";
        } else if (width > height) vid.style.width = this.pixToPerc(width / height * expectedY, vid.previousElementSibling || vid.parentElement) + "%";
        else vid.style.width = this.pixToPerc(expectedX / height * expectedY, vid.previousElementSibling || vid.parentElement) + "%";
        vid.style.height = null;
        vid.removeAttribute("height");
    };
    Video.prototype.pixToPerc = function(expected, parentEle) {
        return expected / parseFloat(getComputedStyle(parentEle).width) * 100;
    };
    Video.prototype.vidDupMouseMove = function(width, height, e) {
        var _this = this;
        var args = {
            event: e,
            requestType: "videos"
        };
        this.parent.trigger($947a002e9a697770$export$45b39e67d4ce4921, args, function(resizingArgs) {
            if (resizingArgs.cancel) _this.cancelResizeAction();
            else {
                if (parseInt(_this.parent.insertVideoSettings.minWidth, 10) >= parseInt(width, 10) || parseInt(_this.parent.getInsertVidMaxWidth(), 10) <= parseInt(width, 10) && (0, $3EnZW.isNullOrUndefined)(_this.videoEle.style.width)) return;
                if (!_this.parent.insertVideoSettings.resizeByPercent && (parseInt(_this.parent.insertVideoSettings.minHeight, 10) >= parseInt(height, 10) || parseInt(_this.parent.insertVideoSettings.maxHeight, 10) <= parseInt(height, 10))) return;
                _this.videoEle.parentElement.style.cursor = "pointer";
                _this.setAspectRatio(_this.videoEle, parseInt(width, 10), parseInt(height, 10), args);
                _this.resizeVidDupPos(_this.videoEle);
                _this.vidResizePos(_this.videoEle, _this.vidResizeDiv);
            }
        });
    };
    Video.prototype.resizing = function(e) {
        if (this.videoEle.offsetWidth >= this.parent.getInsertVidMaxWidth()) this.videoEle.style.maxHeight = this.videoEle.offsetHeight + "px";
        var pageX = this.getPointX(e);
        var pageY = this.getPointY(e);
        var mouseX = this.resizeBtnStat.botLeft || this.resizeBtnStat.topLeft ? -(pageX - this.pageX) : pageX - this.pageX;
        var mouseY = this.resizeBtnStat.topLeft || this.resizeBtnStat.topRight ? -(pageY - this.pageY) : pageY - this.pageY;
        var width = parseInt(this.vidDupPos.width, 10) + mouseX;
        var height = parseInt(this.vidDupPos.height, 10) + mouseY;
        this.pageX = pageX;
        this.pageY = pageY;
        this.mouseX = mouseX;
        if (this.resizeBtnStat.botRight) this.vidDupMouseMove(width + "px", height + "px", e);
        else if (this.resizeBtnStat.botLeft) this.vidDupMouseMove(width + "px", height + "px", e);
        else if (this.resizeBtnStat.topRight) this.vidDupMouseMove(width + "px", height + "px", e);
        else if (this.resizeBtnStat.topLeft) this.vidDupMouseMove(width + "px", height + "px", e);
    };
    Video.prototype.cancelResizeAction = function() {
        this.isResizeBind = true;
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        if (this.videoEle && this.vidResizeDiv && this.contentModule.getEditPanel().contains(this.vidResizeDiv)) {
            (0, $4ZDHT.detach)(this.vidResizeDiv);
            this.videoEle.style.outline = "";
            this.vidResizeDiv = null;
            this.pageX = null;
            this.pageY = null;
        }
    };
    Video.prototype.resizeVidDupPos = function(e) {
        this.vidDupPos = {
            width: e.style.width !== "" && this.parent.insertVideoSettings && !this.parent.insertVideoSettings.resizeByPercent ? this.videoEle.style.width : e.width !== "auto" && e.width !== 0 && e.width !== "NaN" ? e.width + "px" : parseInt(getComputedStyle(e).width, 10) + "px",
            height: e.style.height !== "" ? this.videoEle.style.height : e.height !== "auto" && e.height !== 0 && e.height !== "NaN" ? e.height + "px" : parseInt(getComputedStyle(e).height, 10) + "px"
        };
    };
    Video.prototype.resizeBtnInit = function() {
        return this.resizeBtnStat = {
            botLeft: false,
            botRight: false,
            topRight: false,
            topLeft: false
        };
    };
    Video.prototype.onToolbarAction = function(args) {
        if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$ae80d5dbf349b0b4, {});
        var item = args.args.item;
        switch(item.subCommand){
            case "VideoReplace":
                this.parent.notify($947a002e9a697770$export$73a289ac38fc1ec, args);
                break;
            case "VideoRemove":
                this.parent.notify($947a002e9a697770$export$9aa8e6dd9bc07056, args);
                break;
            case "VideoDimension":
                this.parent.notify($947a002e9a697770$export$383e1e0225d28d1e, args);
        }
    };
    Video.prototype.onKeyDown = function(event) {
        var originalEvent = event.args;
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        this.deletedVid = [];
        var isCursor;
        var keyCodeValues = [
            27,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            44,
            45,
            9,
            16,
            17,
            18,
            19,
            20,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            91,
            92,
            93,
            144,
            145,
            182,
            183
        ];
        if (this.parent.editorMode === "HTML") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            isCursor = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
        }
        if (!isCursor && this.parent.editorMode === "HTML" && keyCodeValues.indexOf(originalEvent.which) < 0) {
            var nodes = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            for(var i = 0; i < nodes.length; i++)if (nodes[i].nodeName === "VIDEO" || nodes[i].nodeName === "IFRAME") this.deletedVid.push(nodes[i]);
        }
        if (this.parent.editorMode === "HTML" && (originalEvent.which === 8 && originalEvent.code === "Backspace" || originalEvent.which === 46 && originalEvent.code === "Delete")) {
            var isCursor_1 = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (originalEvent.which === 8 && originalEvent.code === "Backspace" && isCursor_1) this.checkVideoBack(range);
            else if (originalEvent.which === 46 && originalEvent.code === "Delete" && isCursor_1) this.checkVideoDel(range);
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection) && originalEvent.code !== "KeyK") {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            if (!originalEvent.ctrlKey && originalEvent.key && (originalEvent.key.length === 1 || originalEvent.action === "enter") && (!(0, $3EnZW.isNullOrUndefined)(selectParentEle[0]) && selectParentEle[0].tagName === "VIDEO" || this.isEmbedVidElem(selectParentEle[0])) && selectParentEle[0].parentElement) {
                var prev = selectParentEle[0].parentElement.childNodes[0];
                if (this.contentModule.getEditPanel().querySelector(".e-vid-resize")) this.removeResizeEle();
                this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), prev, prev, prev.textContent.length, prev.textContent.length);
                (0, $4ZDHT.removeClass)([
                    selectParentEle[0]
                ], $afc560df281b588d$export$2dd5c5a90215b6c1);
                this.quickToolObj.videoQTBar.hidePopup();
            }
        }
        if (originalEvent.ctrlKey && (originalEvent.keyCode === 89 || originalEvent.keyCode === 90)) this.undoStack({
            subCommand: originalEvent.keyCode === 90 ? "undo" : "redo"
        });
        if (originalEvent.keyCode === 8 || originalEvent.keyCode === 46) {
            if (selectNodeEle && (selectNodeEle[0].nodeName === "VIDEO" || this.isEmbedVidElem(selectNodeEle[0])) && selectNodeEle.length < 1) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                originalEvent.preventDefault();
                var event_1 = {
                    selectNode: selectNodeEle,
                    selection: save,
                    selectParent: selectParentEle,
                    args: {
                        item: {
                            command: "Videos",
                            subCommand: "VideoRemove"
                        },
                        originalEvent: originalEvent
                    }
                };
                this.deleteVideo(event_1, originalEvent.keyCode);
            }
            if (this.parent.contentModule.getEditPanel().querySelector(".e-vid-resize")) this.removeResizeEle();
        }
        if (originalEvent.code === "Backspace") originalEvent.action = "backspace";
        switch(originalEvent.action){
            case "escape":
                if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) this.dialogObj.close();
                break;
            case "backspace":
            case "delete":
                for(var i = 0; i < this.deletedVid.length; i++){
                    var src = this.deletedVid[i].src;
                    this.videoRemovePost(src);
                }
                if (this.parent.editorMode !== "Markdown") {
                    if (range.startContainer.nodeType === 3) {
                        if (originalEvent.code === "Backspace") {
                            if (range.startContainer.previousElementSibling && range.startOffset === 0 && range.startContainer.previousElementSibling.classList.contains($afc560df281b588d$export$fea5ac7fbfdd17f0)) (0, $4ZDHT.detach)(range.startContainer.previousElementSibling);
                        } else if (range.startContainer.nextElementSibling && range.endContainer.textContent.length === range.endOffset && range.startContainer.nextElementSibling.classList.contains($afc560df281b588d$export$fea5ac7fbfdd17f0)) (0, $4ZDHT.detach)(range.startContainer.nextElementSibling);
                    } else if (range.startContainer.nodeType === 1 && range.startContainer.classList && range.startContainer.classList.contains($afc560df281b588d$export$fea5ac7fbfdd17f0)) (0, $4ZDHT.detach)(range.startContainer);
                }
                break;
            case "insert-video":
                if (!(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                this.openDialog(true, originalEvent, save, selectNodeEle, selectParentEle);
                originalEvent.preventDefault();
                break;
        }
        if (originalEvent.ctrlKey && originalEvent.key === "a") this.handleSelectAll();
    };
    Video.prototype.handleSelectAll = function() {
        this.cancelResizeAction();
        var videoFocusNodes = this.parent.inputElement.querySelectorAll("." + $afc560df281b588d$export$2dd5c5a90215b6c1);
        (0, $4ZDHT.removeClass)(videoFocusNodes, $afc560df281b588d$export$2dd5c5a90215b6c1);
    };
    Video.prototype.openDialog = function(isInternal, event, selection, ele, parentEle) {
        var range;
        var save;
        var selectNodeEle;
        var selectParentEle;
        if (!isInternal && !(0, $3EnZW.isNullOrUndefined)(this.parent.formatter.editorManager.nodeSelection)) {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = selection;
            selectNodeEle = ele;
            selectParentEle = parentEle;
        }
        if (this.parent.editorMode === "HTML") this.insertVideo({
            args: {
                item: {
                    command: "Videos",
                    subCommand: "Video"
                },
                originalEvent: event,
                name: !isInternal ? "showDialog" : null
            },
            selectNode: selectNodeEle,
            selection: save,
            selectParent: selectParentEle
        });
    };
    Video.prototype.showDialog = function() {
        this.openDialog(false);
    };
    Video.prototype.closeDialog = function() {
        if (this.dialogObj) this.dialogObj.hide({
            returnValue: true
        });
    };
    Video.prototype.checkVideoBack = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === 0 && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.previousSibling) && (range.startContainer.previousSibling.nodeName === "VIDEO" || this.isEmbedVidElem(range.startContainer.previousSibling))) this.deletedVid.push(range.startContainer.previousSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset - 1]) && (range.startContainer.childNodes[range.startOffset - 1].nodeName === "VIDEO" || this.isEmbedVidElem(range.startContainer.childNodes[range.startOffset - 1]))) this.deletedVid.push(range.startContainer.childNodes[range.startOffset - 1]);
    };
    Video.prototype.checkVideoDel = function(range) {
        if (range.startContainer.nodeName === "#text" && range.startOffset === range.startContainer.textContent.length && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.nextSibling) && (range.startContainer.nextSibling.nodeName === "VIDEO" || this.isEmbedVidElem(range.startContainer.nextSibling))) this.deletedVid.push(range.startContainer.nextSibling);
        else if (range.startContainer.nodeName !== "#text" && !(0, $3EnZW.isNullOrUndefined)(range.startContainer.childNodes[range.startOffset]) && (range.startContainer.childNodes[range.startOffset].nodeName === "VIDEO" || this.isEmbedVidElem(range.startContainer.childNodes[range.startOffset]))) this.deletedVid.push(range.startContainer.childNodes[range.startOffset]);
    };
    Video.prototype.alignmentSelect = function(e) {
        var item = e.item;
        if (!document.body.contains(document.body.querySelector(".e-rte-quick-toolbar")) || item.command !== "Videos") return;
        var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        var selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
        selectNodeEle = selectNodeEle[0].nodeName === "VIDEO" ? selectNodeEle : [
            this.videoEle
        ];
        var args = {
            args: e,
            selectNode: selectNodeEle
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        switch(item.subCommand){
            case "JustifyLeft":
            case "JustifyCenter":
            case "JustifyRight":
                this.alignVideo(args, item.subCommand);
                break;
            case "Inline":
                this.inline(args);
                break;
            case "Break":
                this.break(args);
                break;
        }
        if (this.quickToolObj && document.body.contains(this.quickToolObj.videoQTBar.element)) {
            this.quickToolObj.videoQTBar.hidePopup();
            (0, $4ZDHT.removeClass)([
                selectNodeEle[0]
            ], $afc560df281b588d$export$2dd5c5a90215b6c1);
        }
        this.cancelResizeAction();
    };
    Video.prototype.deleteVideo = function(e, keyCode) {
        if (e.selectNode[0].nodeName !== "VIDEO" && !this.isEmbedVidElem(e.selectNode[0])) return;
        if (this.isEmbedVidElem(e.selectNode[0])) e.selectNode[0] = e.selectNode[0].classList.contains($afc560df281b588d$export$8dfb598a1fc054c7) ? e.selectNode[0] : e.selectNode[0].parentElement;
        var args = {
            element: !this.isEmbedVidElem(e.selectNode[0]) ? e.selectNode[0].querySelector("iframe") : e.selectNode[0],
            src: !this.isEmbedVidElem(e.selectNode[0]) ? e.selectNode[0].querySelector("source").getAttribute("src") : e.selectNode[0].querySelector("iframe").getAttribute("src")
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) this.parent.formatter.saveData();
        e.selection.restore();
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
        this.videoRemovePost(args.src);
        if (this.quickToolObj && document.body.contains(this.quickToolObj.videoQTBar.element)) this.quickToolObj.videoQTBar.hidePopup();
        this.cancelResizeAction();
        if ((0, $3EnZW.isNullOrUndefined)(keyCode)) this.parent.trigger($947a002e9a697770$export$bd12237ad996f402, args);
    };
    Video.prototype.videoRemovePost = function(src) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var absoluteUrl = "";
        if ((0, $3EnZW.isNullOrUndefined)(this.parent.insertVideoSettings.removeUrl) || this.parent.insertVideoSettings.removeUrl === "") return;
        if (src.indexOf("http://") > -1 || src.indexOf("https://") > -1) absoluteUrl = src;
        else absoluteUrl = new URL(src, document.baseURI).href;
        // eslint-disable-next-line no-useless-escape
        this.removingVideoName = absoluteUrl.replace(/^.*[\\\/]/, "");
        var xhr = new XMLHttpRequest();
        // eslint-disable-next-line @typescript-eslint/tslint/config
        xhr.addEventListener("readystatechange", function() {
            if (this.readyState === 4 && this.status === 200) proxy.triggerPost(this.response);
        });
        xhr.open("GET", absoluteUrl);
        xhr.responseType = "blob";
        xhr.send();
    };
    Video.prototype.triggerPost = function(response) {
        var removeUrl = this.parent.insertVideoSettings.removeUrl;
        if ((0, $3EnZW.isNullOrUndefined)(removeUrl) || removeUrl === "") return;
        var file = new File([
            response
        ], this.removingVideoName);
        var ajax = new (0, $cfGuF.Ajax)(removeUrl, "POST", true, null);
        var formData = new FormData();
        formData.append("UploadFiles", file);
        ajax.send(formData);
    };
    Video.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if ((0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel())) return;
        if (target.nodeName === "VIDEO" || this.isEmbedVidElem(target)) this.videoEle = !this.isEmbedVidElem(target) ? target : target.querySelector("iframe");
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj) && (// eslint-disable-next-line
        !(0, $4ZDHT.closest)(target, "[id='" + this.dialogObj.element.id + "'" + "]") && this.parent.toolbarSettings.enable && this.parent.getToolbarElement() && !this.parent.getToolbarElement().contains(e.target) || this.parent.getToolbarElement() && this.parent.getToolbarElement().contains(e.target) && !(0, $4ZDHT.closest)(target, "#" + this.parent.getID() + "_toolbar_Video") && !target.querySelector("#" + this.parent.getID() + "_toolbar_Video"))) {
            /* eslint-disable */ if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) ;
            else {
                this.parent.notify($947a002e9a697770$export$4895f32c534ef936, {
                    closedBy: "outside click"
                });
                this.dialogObj.hide({
                    returnValue: true
                });
                this.parent.isBlur = true;
                (0, $c77ecbfae9b8c035$export$716a11175c03fb4e)(this.parent.element, "focusout");
            }
        /* eslint-enable */ }
        // if (((e.target as HTMLElement).tagName !== 'VIDEO' || !this.isEmbedVidElem(e.target as HTMLElement)) && this.vidResizeDiv && !(this.quickToolObj &&
        //     this.quickToolObj.videoQTBar && this.quickToolObj.videoQTBar.element.contains(e.target as HTMLElement)) &&
        //     this.contentModule.getEditPanel().contains(this.vidResizeDiv)) {
        //     this.cancelResizeAction();
        // }
        if (this.contentModule.getEditPanel().querySelector(".e-vid-resize")) {
            if (target.tagName !== "VIDEO" && !this.isEmbedVidElem(target)) this.removeResizeEle();
            if (target.tagName !== "VIDEO" && !this.isEmbedVidElem(target) && !(0, $3EnZW.isNullOrUndefined)(this.videoEle)) this.videoEle.style.outline = "";
            else if (!(0, $3EnZW.isNullOrUndefined)(this.prevSelectedVidEle) && this.prevSelectedVidEle !== (target.tagName === "IFRAME" || target.tagName === "VIDEO" ? target : target.querySelector("iframe"))) this.prevSelectedVidEle.style.outline = "";
        }
        if (this.parent.inlineMode.enable && target && this.dialogObj && !(0, $4ZDHT.closest)(target, "#" + this.dialogObj.element.id)) this.dialogObj.hide();
    };
    Video.prototype.removeResizeEle = function() {
        this.isResizeBind = true;
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchMoveEvent, this.resizing);
        (0, $aqzbR.EventHandler).remove(this.contentModule.getDocument(), (0, $5q7BP.Browser).touchEndEvent, this.resizeEnd);
        (0, $4ZDHT.detach)(this.contentModule.getEditPanel().querySelector(".e-vid-resize"));
    };
    Video.prototype.onWindowResize = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule) && !(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector(".e-vid-resize"))) this.cancelResizeAction();
    };
    Video.prototype.break = function(e) {
        if (e.selectNode[0].nodeName !== "VIDEO" && !this.isEmbedVidElem(e.selectNode[0])) return;
        var subCommand = e.args.item ? e.args.item.subCommand : "Break";
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Video.prototype.inline = function(e) {
        if (e.selectNode[0].nodeName !== "VIDEO" && !this.isEmbedVidElem(e.selectNode[0])) return;
        var subCommand = e.args.item ? e.args.item.subCommand : "Inline";
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Video.prototype.alignVideo = function(e, type) {
        var subCommand = e.args.item ? e.args.item.subCommand : type;
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, {
            selectNode: e.selectNode,
            subCommand: subCommand
        });
    };
    Video.prototype.editAreaClickHandler = function(e) {
        if (this.parent.readonly) {
            this.hideVideoQuickToolbar();
            return;
        }
        var args = e.args;
        var showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (args.which === 2 || showOnRightClick && args.which === 1 || !showOnRightClick && args.which === 3) {
            if (showOnRightClick && args.which === 1 && !(0, $3EnZW.isNullOrUndefined)(args.target) && (args.target.tagName === "VIDEO" || this.isEmbedVidElem(args.target))) {
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), args.target);
            }
            return;
        }
        if (this.parent.editorMode === "HTML" && this.parent.quickToolbarModule && this.parent.quickToolbarModule.videoQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
            var target = args.target;
            this.contentModule = this.rendererFactory.getRenderer((0, $2eaa618655f536c2$export$ed706b0a66efb05c).Content);
            var isPopupOpen = this.quickToolObj.videoQTBar.element.classList.contains("e-rte-pop");
            if ((target.nodeName === "VIDEO" || this.isEmbedVidElem(target)) && this.parent.quickToolbarModule) {
                if (isPopupOpen) return;
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
                if ((0, $259257662ca103fc$export$80ca177350c4af26)()) this.parent.notify($947a002e9a697770$export$dd9b49d5e9b25abd, e);
                (0, $4ZDHT.addClass)([
                    !this.isEmbedVidElem(target) ? target : target.querySelector("iframe")
                ], $afc560df281b588d$export$2dd5c5a90215b6c1);
                this.showVideoQuickToolbar({
                    args: args,
                    type: "Videos",
                    elements: [
                        args.target
                    ]
                });
            } else this.hideVideoQuickToolbar();
        }
    };
    Video.prototype.showVideoQuickToolbar = function(e) {
        var _this = this;
        if (e.type !== "Videos" || !(0, $3EnZW.isNullOrUndefined)(e.args) && e.args.detail === 2 || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule) || (0, $3EnZW.isNullOrUndefined)(this.parent.quickToolbarModule.videoQTBar) || (0, $3EnZW.isNullOrUndefined)(e.args)) return;
        this.quickToolObj = this.parent.quickToolbarModule;
        var args = e.args;
        var target = e.elements;
        [].forEach.call(e.elements, function(element, index) {
            if (index === 0) target = element;
        });
        if (target.tagName === "VIDEO" || this.isEmbedVidElem(target)) (0, $4ZDHT.addClass)([
            !this.isEmbedVidElem(target) || target.tagName === "IFRAME" ? target : target.querySelector("iframe")
        ], [
            $afc560df281b588d$export$2dd5c5a90215b6c1
        ]);
        var pageY = this.parent.iframeSettings.enable ? window.pageYOffset + this.parent.element.getBoundingClientRect().top + args.clientY : args.pageY;
        if (this.parent.quickToolbarModule.videoQTBar) {
            if (e.isNotify) this.showPopupTime = setTimeout(function() {
                _this.parent.formatter.editorManager.nodeSelection.Clear(_this.contentModule.getDocument());
                _this.parent.formatter.editorManager.nodeSelection.setSelectionContents(_this.contentModule.getDocument(), target);
                _this.quickToolObj.videoQTBar.showPopup(args.pageX - 50, pageY + target.getBoundingClientRect().height / 2 - target.offsetTop, target);
            }, 400);
            else this.quickToolObj.videoQTBar.showPopup(args.pageX - 50, pageY + target.getBoundingClientRect().height / 2 - target.offsetTop, target);
        }
    };
    Video.prototype.hideVideoQuickToolbar = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector("." + $afc560df281b588d$export$2dd5c5a90215b6c1))) {
            (0, $4ZDHT.removeClass)([
                this.contentModule.getEditPanel().querySelector("." + $afc560df281b588d$export$2dd5c5a90215b6c1)
            ], $afc560df281b588d$export$2dd5c5a90215b6c1);
            if (!(0, $3EnZW.isNullOrUndefined)(this.videoEle)) this.videoEle.style.outline = "";
            if (!(0, $3EnZW.isNullOrUndefined)(this.contentModule.getEditPanel().querySelector(".e-vid-resize"))) (0, $4ZDHT.detach)(this.contentModule.getEditPanel().querySelector(".e-vid-resize"));
            if (this.quickToolObj && this.quickToolObj.videoQTBar && document.body.contains(this.quickToolObj.videoQTBar.element)) this.quickToolObj.videoQTBar.hidePopup();
        }
    };
    Video.prototype.isEmbedVidElem = function(target) {
        if (target && target.nodeType !== 3 && target.nodeName !== "BR" && target.classList && target.classList.contains($afc560df281b588d$export$8dfb598a1fc054c7) || target && target.nodeName === "IFRAME") return true;
        else return false;
    };
    Video.prototype.insertingVideo = function(e) {
        this.insertVideo(e);
        if (!(0, $3EnZW.isNullOrUndefined)(this.dialogObj)) {
            this.dialogObj.element.style.maxHeight = "inherit";
            var dialogContent = this.dialogObj.element.querySelector(".e-video-content");
            if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertVideoSettings.path) || this.parent.editorMode === "HTML") document.getElementById(this.rteID + "_insertVideo").focus();
            else dialogContent.querySelector(".e-video-url").focus();
        }
    };
    Video.prototype.insertVideo = function(e) {
        var _this = this;
        if (this.dialogObj) {
            this.dialogObj.hide({
                returnValue: true
            });
            return;
        }
        var videoDialog = this.parent.createElement("div", {
            className: "e-rte-video-dialog",
            id: this.rteID + "_video"
        });
        this.parent.rootContainer.appendChild(videoDialog);
        var videoInsert = this.i10n.getConstant("dialogInsert");
        var videolinkCancel = this.i10n.getConstant("dialogCancel");
        var videoHeader = this.i10n.getConstant("videoHeader");
        var selection = e.selection;
        var selectObj = {
            selfVideo: this,
            selection: e.selection,
            args: e.args,
            selectParent: e.selectParent
        };
        var dialogModel = {
            header: videoHeader,
            cssClass: $afc560df281b588d$export$d3f61cb93957903e,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true,
            closeOnEscape: true,
            width: (0, $5q7BP.Browser).isDevice ? "290px" : "340px",
            isModal: (0, $5q7BP.Browser).isDevice,
            buttons: [
                {
                    click: this.insertVideoUrl.bind(selectObj),
                    buttonModel: {
                        content: videoInsert,
                        cssClass: "e-flat e-insertVideo",
                        isPrimary: true,
                        disabled: true
                    }
                },
                {
                    click: function(e) {
                        _this.cancelDialog(e);
                    },
                    buttonModel: {
                        cssClass: "e-flat e-cancel",
                        content: videolinkCancel
                    }
                }
            ],
            target: (0, $5q7BP.Browser).isDevice ? document.body : this.parent.element,
            animationSettings: {
                effect: "None"
            },
            close: function(event) {
                if (_this.isVideoUploaded) {
                    if (_this.dialogObj.element.querySelector(".e-file-abort-btn")) _this.dialogObj.element.querySelector(".e-file-abort-btn").click();
                    else _this.uploadObj.remove();
                }
                _this.parent.isBlur = false;
                if (event && !(0, $3EnZW.isNullOrUndefined)(event.event) && event.event.returnValue) {
                    if (_this.parent.editorMode === "HTML") selection.restore();
                }
                _this.clearDialogObj();
                _this.dialogRenderObj.close(event);
            }
        };
        var dialogContent = this.parent.createElement("div", {
            className: "e-video-content"
        });
        if (!(0, $3EnZW.isNullOrUndefined)(this.parent.insertVideoSettings.path) || this.parent.editorMode === "HTML") dialogContent.appendChild(this.videoUpload(e));
        var linkHeader = this.parent.createElement("div", {
            className: "e-videoheader"
        });
        var embedLinkHeader = this.parent.createElement("div", {
            className: "e-embed-videoheader"
        });
        var linkHeaderText = this.i10n.getConstant("videoLinkHeader");
        var embedLinkHeaderText = this.i10n.getConstant("embedVideoLinkHeader");
        if (this.parent.editorMode === "HTML") {
            linkHeader.innerHTML = linkHeaderText;
            embedLinkHeader.innerHTML = embedLinkHeaderText;
        }
        dialogContent.appendChild(this.urlPopup(e));
        if (e.selectNode && e.selectNode[0].nodeType === 1 && (e.selectNode[0].tagName === "VIDEO" || this.isEmbedVidElem(e.selectNode[0]))) {
            dialogModel.header = this.parent.localeObj.getConstant("editVideoHeader");
            dialogModel.content = dialogContent;
        } else dialogModel.content = dialogContent;
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(videoDialog);
        if (e.selectNode && e.selectNode[0].nodeType === 1 && (e.selectNode[0].tagName === "VIDEO" || this.isEmbedVidElem(e.selectNode[0])) && e.name === "insertVideo") this.dialogObj.element.querySelector(".e-insertVideo").textContent = this.parent.localeObj.getConstant("dialogUpdate");
        videoDialog.style.maxHeight = "inherit";
        if (this.quickToolObj) {
            if (this.quickToolObj.videoQTBar && document.body.contains(this.quickToolObj.videoQTBar.element)) {
                this.quickToolObj.videoQTBar.hidePopup();
                if (!(0, $3EnZW.isNullOrUndefined)(e.selectParent)) (0, $4ZDHT.removeClass)([
                    e.selectParent[0]
                ], $afc560df281b588d$export$2dd5c5a90215b6c1);
            }
            if (this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) this.quickToolObj.inlineQTBar.hidePopup();
            if (this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) this.quickToolObj.textQTBar.hidePopup();
        }
    };
    Video.prototype.urlPopup = function(e) {
        var _this = this;
        var videoUrl = this.parent.createElement("div", {
            className: "e-video-url-wrap"
        });
        var urlContent = this.parent.createElement("div", {
            id: "urlcontent"
        });
        var placeUrl = this.i10n.getConstant("videoUrl");
        var content = '<input id="embedURL" type="radio"><input id="webURL" type="radio" >';
        var contentElem = (0, $c77ecbfae9b8c035$export$ffae2e31416920bc)(content);
        videoUrl.appendChild(contentElem);
        videoUrl.appendChild(urlContent);
        this.embedInputUrl = this.parent.createElement("textarea", {
            className: "e-input e-embed-video-url",
            attrs: {
                placeholder: this.i10n.getConstant("pasteEmbeddedCodeHere"),
                type: "text",
                tabindex: "-1",
                "aria-label": this.i10n.getConstant("embedVideoLinkHeader")
            }
        });
        this.embedInputUrl.addEventListener("keyup", function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.embedInputUrl)) {
                if (_this.embedInputUrl.value.length === 0) _this.dialogObj.getButtons(0).element.disabled = true;
                else _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
            }
        });
        this.inputUrl = this.parent.createElement("input", {
            className: "e-input e-video-url",
            attrs: {
                placeholder: placeUrl,
                spellcheck: "false"
            }
        });
        this.inputUrl.addEventListener("input", function() {
            if (!(0, $3EnZW.isNullOrUndefined)(_this.inputUrl)) {
                if (_this.inputUrl.value.length === 0) _this.dialogObj.getButtons(0).element.disabled = true;
                else _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
            }
        });
        if (e.selectNode && e.selectNode[0] && (e.selectNode[0].nodeName === "VIDEO" || this.isEmbedVidElem(e.selectNode[0]))) {
            if (e.selectNode[0].nodeName === "VIDEO") {
                var regex = new RegExp(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi);
                var sourceElement = e.selectNode[0].querySelector("source");
                this.inputUrl.value = sourceElement && sourceElement.src && sourceElement.src.match(regex) ? sourceElement.src : "";
            } else this.embedInputUrl.value = e.selectNode[0].nodeName === "IFRAME" ? e.selectNode[0].outerHTML : e.selectNode[0].querySelector("iframe").outerHTML;
        }
        var isWebUrl = this.inputUrl.value ? true : false;
        this.embedUrlBtn = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.i10n.getConstant("embeddedCode"),
            checked: !isWebUrl,
            name: "URL",
            created: function() {
                if (!isWebUrl) urlContent.appendChild(_this.embedInputUrl);
            },
            change: function() {
                urlContent.innerHTML = "";
                urlContent.appendChild(_this.embedInputUrl);
            }
        });
        this.embedUrlBtn.appendTo(videoUrl.querySelector("#embedURL"));
        this.webUrlBtn = new (0, $8828e72750329966$export$f4422ae58352e179)({
            label: this.i10n.getConstant("webUrl"),
            checked: isWebUrl,
            name: "URL",
            created: function() {
                if (isWebUrl) urlContent.appendChild(_this.inputUrl);
            },
            change: function() {
                urlContent.innerHTML = "";
                urlContent.appendChild(_this.inputUrl);
            }
        });
        this.webUrlBtn.appendTo(videoUrl.querySelector("#webURL"));
        return videoUrl;
    };
    Video.prototype.videoUpload = function(e) {
        var _this = this;
        var save;
        var selectParent;
        // eslint-disable-next-line
        var proxy = this;
        var iframe = proxy.parent.iframeSettings.enable;
        if (proxy.parent.editorMode === "HTML" && (!iframe && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(e.selection.range.startContainer.parentNode, "[id='" + this.parent.contentModule.getPanel().id + "'" + "]")) || iframe && !(0, $c77ecbfae9b8c035$export$4ea3d958472af68f)(e.selection.range.startContainer.parentNode.ownerDocument.querySelector("body"), "e-lib"))) {
            this.contentModule.getEditPanel().focus();
            var range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        } else {
            save = e.selection;
            selectParent = e.selectParent;
        }
        var uploadParentEle = this.parent.createElement("div", {
            className: "e-vid-uploadwrap e-droparea"
        });
        var deviceVideoUpMsg = this.i10n.getConstant("videoDeviceUploadMessage");
        var videoUpMsg = this.i10n.getConstant("videoUploadMessage");
        var span = this.parent.createElement("span", {
            className: "e-droptext"
        });
        var spanMsg = this.parent.createElement("span", {
            className: "e-rte-upload-text",
            innerHTML: (0, $5q7BP.Browser).isDevice ? deviceVideoUpMsg : videoUpMsg
        });
        span.appendChild(spanMsg);
        var btnEle = this.parent.createElement("button", {
            className: "e-browsebtn",
            id: this.rteID + "_insertVideo",
            attrs: {
                autofocus: "true",
                type: "button"
            }
        });
        span.appendChild(btnEle);
        uploadParentEle.appendChild(span);
        var browserMsg = this.i10n.getConstant("browse");
        this.button = new (0, $933f7ed08601bef4$export$353f5b6fc5456de1)({
            content: browserMsg,
            enableRtl: this.parent.enableRtl
        });
        this.button.isStringTemplate = true;
        this.button.createElement = this.parent.createElement;
        this.button.appendTo(btnEle);
        var btnClick = (0, $5q7BP.Browser).isDevice ? span : btnEle;
        (0, $aqzbR.EventHandler).add(btnClick, "click", this.fileSelect, this);
        var uploadEle = this.parent.createElement("input", {
            id: this.rteID + "_upload",
            attrs: {
                type: "File",
                name: "UploadFiles"
            }
        });
        uploadParentEle.appendChild(uploadEle);
        var fileName;
        var selectArgs;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var filesData;
        this.uploadObj = new (0, $f606c23990200287$export$b4ba47569ccac746)({
            asyncSettings: {
                saveUrl: this.parent.insertVideoSettings.saveUrl,
                removeUrl: this.parent.insertVideoSettings.removeUrl
            },
            dropArea: span,
            multiple: false,
            enableRtl: this.parent.enableRtl,
            allowedExtensions: this.parent.insertVideoSettings.allowedTypes.toString(),
            selected: function(e) {
                proxy.isVideoUploaded = true;
                selectArgs = e;
                filesData = e.filesData;
                _this.parent.trigger($947a002e9a697770$export$cd4c780a3205848c, selectArgs, function(selectArgs) {
                    if (!selectArgs.cancel) {
                        _this.checkExtension(selectArgs.filesData[0]);
                        fileName = selectArgs.filesData[0].name;
                        if (_this.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)(_this.parent.insertVideoSettings.path)) {
                            var reader_1 = new FileReader();
                            // eslint-disable-next-line
                            reader_1.addEventListener("load", function(e) {
                                var url = _this.parent.insertVideoSettings.saveFormat === "Base64" ? reader_1.result : URL.createObjectURL((0, $c77ecbfae9b8c035$export$cf4191ff74926367)(reader_1.result));
                                proxy.uploadUrl = {
                                    url: url,
                                    selection: save,
                                    fileName: fileName,
                                    selectParent: selectParent
                                };
                                proxy.inputUrl.setAttribute("disabled", "true");
                                proxy.embedInputUrl.setAttribute("disabled", "true");
                                if ((0, $3EnZW.isNullOrUndefined)(proxy.parent.insertVideoSettings.saveUrl) && _this.isAllowedTypes && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj)) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                            });
                            reader_1.readAsDataURL(selectArgs.filesData[0].rawFile);
                        }
                    }
                });
            },
            beforeUpload: function(args) {
                _this.parent.trigger($947a002e9a697770$export$cc40225aa9b0a067, args);
            },
            uploading: function(e) {
                if (!_this.parent.isServerRendered) _this.parent.trigger($947a002e9a697770$export$ea51d7451bf2a8d8, e);
            },
            success: function(e) {
                _this.parent.trigger($947a002e9a697770$export$765cb3120ada5f48, e, function(e) {
                    if (!(0, $3EnZW.isNullOrUndefined)(_this.parent.insertVideoSettings.path)) {
                        var url = _this.parent.insertVideoSettings.path + e.file.name;
                        // eslint-disable-next-line
                        var value = {
                            url: url,
                            selection: save
                        };
                        proxy.uploadUrl = {
                            url: url,
                            selection: save,
                            fileName: fileName,
                            selectParent: selectParent,
                            width: {
                                width: proxy.parent.insertVideoSettings.width,
                                minWidth: proxy.parent.insertVideoSettings.minWidth,
                                maxWidth: proxy.parent.getInsertImgMaxWidth()
                            },
                            height: {
                                height: proxy.parent.insertVideoSettings.height,
                                minHeight: proxy.parent.insertVideoSettings.minHeight,
                                maxHeight: proxy.parent.insertVideoSettings.maxHeight
                            }
                        };
                        //proxy.inputUrl.setAttribute('disabled', 'true');
                        proxy.embedInputUrl.setAttribute("disabled", "true");
                    }
                    if (e.operation === "upload" && !(0, $3EnZW.isNullOrUndefined)(_this.dialogObj)) _this.dialogObj.getButtons(0).element.removeAttribute("disabled");
                });
            },
            failure: function(e) {
                _this.parent.trigger($947a002e9a697770$export$f32e611c2450ce56, e);
            },
            removing: function() {
                // eslint-disable-next-line
                _this.parent.trigger($947a002e9a697770$export$af6060fcb094c173, e, function(e) {
                    proxy.isVideoUploaded = false;
                    _this.dialogObj.getButtons(0).element.disabled = true;
                    if (proxy.inputUrl.getAttribute("disabled")) proxy.inputUrl.removeAttribute("disabled");
                    if (proxy.embedInputUrl.getAttribute("disabled")) proxy.embedInputUrl.removeAttribute("disabled");
                    if (proxy.uploadUrl) proxy.uploadUrl.url = "";
                });
            }
        });
        this.uploadObj.isStringTemplate = true;
        this.uploadObj.createElement = this.parent.createElement;
        this.uploadObj.appendTo(uploadEle);
        return uploadParentEle;
    };
    Video.prototype.checkExtension = function(e) {
        if (this.uploadObj.allowedExtensions) {
            if (this.uploadObj.allowedExtensions.toLocaleLowerCase().indexOf(("." + e.type).toLocaleLowerCase()) === -1) {
                this.dialogObj.getButtons(0).element.setAttribute("disabled", "disabled");
                this.isAllowedTypes = false;
            } else this.isAllowedTypes = true;
        }
    };
    Video.prototype.fileSelect = function() {
        this.dialogObj.element.getElementsByClassName("e-file-select-wrap")[0].querySelector("button").click();
        return false;
    };
    // eslint-disable-next-line
    Video.prototype.cancelDialog = function(e) {
        this.parent.isBlur = false;
        this.dialogObj.hide({
            returnValue: true
        });
        if (this.isVideoUploaded) this.uploadObj.removing();
    };
    // eslint-disable-next-line
    Video.prototype.insertVideoUrl = function(e) {
        var proxy = this.selfVideo;
        //let audioSelectParent: Node = proxy.uploadUrl.selectParent[0];
        proxy.isVideoUploaded = false;
        var url = proxy.inputUrl.value;
        var embedUrl = proxy.embedInputUrl.value;
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) proxy.parent.formatter.saveData();
        if (!(0, $3EnZW.isNullOrUndefined)(proxy.uploadUrl) && proxy.uploadUrl.url !== "") {
            proxy.uploadUrl.cssClass = proxy.parent.insertVideoSettings.layoutOption === "Inline" ? $afc560df281b588d$export$3137cd114e7b0358 : $afc560df281b588d$export$871b6a3cec24584d;
            proxy.uploadUrl.width = {
                width: proxy.parent.insertVideoSettings.width,
                minWidth: proxy.parent.insertVideoSettings.minWidth,
                maxWidth: proxy.parent.getInsertImgMaxWidth()
            };
            proxy.uploadUrl.height = {
                height: proxy.parent.insertVideoSettings.height,
                minHeight: proxy.parent.insertVideoSettings.minHeight,
                maxHeight: proxy.parent.insertVideoSettings.maxHeight
            };
            proxy.dialogObj.hide({
                returnValue: false
            });
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, proxy.uploadUrl);
            proxy.uploadUrl.url = "";
        } else if (proxy.parent.editorMode === "HTML" && (url !== "" || embedUrl !== "")) {
            if (proxy.parent.editorMode === "HTML" && (0, $3EnZW.isNullOrUndefined)((0, $4ZDHT.closest)(// eslint-disable-next-line
            this.selection.range.startContainer.parentNode, "[id='" + proxy.contentModule.getPanel().id + "'" + "]"))) {
                proxy.contentModule.getEditPanel().focus();
                var range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.contentModule.getDocument());
                this.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.contentModule.getDocument());
                this.selectParent = proxy.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            }
            var webUrlBtn = document.getElementById("webURL");
            var name_1 = webUrlBtn.checked ? url.split("/")[url.split("/").length - 1] : embedUrl;
            var value = {
                cssClass: proxy.parent.insertVideoSettings.layoutOption === "Inline" ? $afc560df281b588d$export$3137cd114e7b0358 : $afc560df281b588d$export$871b6a3cec24584d,
                url: url,
                selection: this.selection,
                fileName: name_1,
                isEmbedUrl: !webUrlBtn.checked,
                selectParent: this.selectParent,
                width: {
                    width: proxy.parent.insertVideoSettings.width,
                    minWidth: proxy.parent.insertVideoSettings.minWidth,
                    maxWidth: proxy.parent.getInsertImgMaxWidth()
                },
                height: {
                    height: proxy.parent.insertVideoSettings.height,
                    minHeight: proxy.parent.insertVideoSettings.minHeight,
                    maxHeight: proxy.parent.insertVideoSettings.maxHeight
                }
            };
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, value);
            proxy.dialogObj.hide({
                returnValue: false
            });
        }
    };
    /* eslint-disable */ /**
     * Destroys the ToolBar.
     *
     * @method destroy
     * @returns {void}
     * @hidden

     */ /* eslint-enable */ Video.prototype.destroy = function() {
        if (this.isDestroyed) return;
        this.prevSelectedVidEle = undefined;
        this.removeEventListener();
        if (this.showPopupTime) {
            clearTimeout(this.showPopupTime);
            this.showPopupTime = null;
        }
        this.clearDialogObj();
        this.isDestroyed = true;
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */ Video.prototype.getModuleName = function() {
        return "video";
    };
    return Video;
}();



/**
 * The `RTE` module is used configure the properties of RTE type editor.
 */ var $30f18bd0dc90d086$export$e30f3e57961fb302 = /** @class */ function() {
    function Rte(parent) {
        this.compObj = undefined;
        (0, $95445997b68090e8$export$a4ff4468fa943a6c).Inject((0, $f33d01d1f6cb2ad3$export$23bffbc1d2dae0de), (0, $6786024aab39709d$export$18a9461578883ec4), (0, $d346826d2cbb602c$export$4c260019440d418f), (0, $d24ea15df6d7af38$export$a6c7ac8248d6e38a), (0, $49a6f5fde11efa2c$export$3e431a229df88919), (0, $ef32d60b586a40bb$export$de97f9935dd6a484), (0, $c0d8684036271cdd$export$54ec01a60f47d33d), (0, $4f645c5c20d097dd$export$a5245c9b2355d1f8), (0, $30bc71f720415a27$export$a1226420f67c68f9), (0, $a7928f640563b10d$export$6335145236247192), (0, $4c68d77f91fb8b84$export$153755f98d9861de), (0, $aa3fd79c644fe28d$export$ae01dedf5c052bb), (0, $7c797bf333ef7f08$export$f60085f983ca5dd5), (0, $c0eb54371c63e3e0$export$5c31959b0a6b6e24));
        this.parent = parent;
        this.parent.rteModule = this;
        this.base = new (0, $f9046be79aeff00b$export$ef88aa0d34c34520)(this.parent, this);
    }
    Rte.prototype.render = function(e) {
        this.compObj = new (0, $95445997b68090e8$export$a4ff4468fa943a6c)(this.parent.model);
        this.compObj.appendTo(e.target);
    };
    Rte.prototype.focus = function() {
        this.compObj.focusIn();
    };
    Rte.prototype.updateValue = function(e) {
        if (this.compObj && e.type === "RTE") {
            this.parent.setProperties({
                value: this.getRteValue()
            }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    };
    Rte.prototype.getRteValue = function() {
        var rteVal;
        if (this.compObj.editorMode === "Markdown") {
            rteVal = this.compObj.contentModule.getEditPanel().value;
            return rteVal === "" ? "" : rteVal;
        } else {
            rteVal = this.compObj.contentModule.getEditPanel().innerHTML;
            return rteVal === "<p><br></p>" || rteVal === "&lt;p&gt;&lt;br&gt;&lt;/p&gt;" || rteVal === "" ? "" : rteVal;
        }
    };
    Rte.prototype.refresh = function() {
        this.compObj.refresh();
    };
    /**
     * Destroys the rte module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */ Rte.prototype.destroy = function() {
        this.base.destroy();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */ Rte.prototype.getModuleName = function() {
        return "rte";
    };
    return Rte;
}();




const $937adc5561795ee6$export$972441c45418dcb4 = (checkbox)=>{
    const { value: id } = checkbox;
    if (id) {
        checkbox.checked = !!(0, $e68843d575be3a15$export$d193da8733a2af56)(id).value;
        checkbox.addEventListener("change", async ()=>{
            if (checkbox.checked) {
                const date = new Date();
                date.setHours(0, 0, 0);
                await (0, $e68843d575be3a15$export$18f2ef1f3de9bc1c)(id, date);
            } else await (0, $e68843d575be3a15$export$18f2ef1f3de9bc1c)(id, null);
        });
    }
};







const $6d378a20e241a461$export$2ea4d0d34fe561d5 = (json)=>{
    const jsonDateReviver = (key, value)=>{
        const date = new Date(value);
        return !Number.isNaN(date.valueOf()) && date.toISOString() === value ? date : value;
    };
    return JSON.parse(json, jsonDateReviver);
};
const $6d378a20e241a461$export$378e6a16d60321b1 = (element)=>{
    // Listen for keydown as change event fires after dependent events
    element.addEventListener("keydown", (e)=>{
        if (e.key !== "Escape" && e.key !== "Tab") $6d378a20e241a461$export$d8a7b8f475ec0161(element)();
    });
};
const $6d378a20e241a461$export$d8a7b8f475ec0161 = (element)=>()=>{
        const form = element.closest("form");
        if (form) form.dataset.dirty = "true";
    };


const $45badea74a08f73b$export$b7e3ae3d7c15e42e = (props, element)=>{
    const p = {
        ...props
    };
    const messageDivId = `${element.id}-msg`;
    const input = document.createElement(p.type === "RTE" ? "textarea" : "input");
    input.name = p.field;
    if (p.type !== "RTE") (0, $6d378a20e241a461$export$378e6a16d60321b1)(input);
    input.dataset.msgContainerid = messageDivId;
    input.autocomplete = "off";
    element.appendChild(input);
    const messageDiv = document.createElement("div");
    messageDiv.id = messageDivId;
    element.appendChild(messageDiv);
    return input;
};




const $8d258c1e3ba1d8a4$var$DEFAULT_DATE_PICKER_WIDTH = 130;
const $8d258c1e3ba1d8a4$export$9d5c97e1c9024cca = (p, e)=>{
    const datePicker = new (0, $d5f6934cad42758d$export$5109c6dd95d8fb00)({
        ...$8d258c1e3ba1d8a4$export$6b901f18b507bf5b(p),
        change: (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)
    });
    datePicker.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, datePicker);
    (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
};
const $8d258c1e3ba1d8a4$export$6b901f18b507bf5b = (p)=>{
    const allowManualEntry = p.allowManualEntry ?? true;
    let popup;
    return {
        ...(0, $0529b7a83755f1dd$export$b5d8dae9ecb8541e)(p),
        // @ts-expect-error we use null rather than undefined to represent no value in DB
        value: p.value ? (0, $fb0301734e2a6838$export$bf96ab0fd446bad3)(p.value) : null,
        min: p.minDate ? (0, $fb0301734e2a6838$export$bf96ab0fd446bad3)(p.minDate) : undefined,
        max: p.maxDate ? (0, $fb0301734e2a6838$export$bf96ab0fd446bad3)(p.maxDate) : undefined,
        allowEdit: allowManualEntry,
        format: p.format ?? (0, $d47525176c3f6cd7$export$4e4cb19dd88cd821),
        placeholder: p.placeholder ?? (0, $d47525176c3f6cd7$export$3ae94a2503e890a1)(p.defaultValue),
        showTodayButton: !(p.minDate || p.maxDate),
        showClearButton: false,
        ...!p.fullwidth ? {
            width: $8d258c1e3ba1d8a4$var$DEFAULT_DATE_PICKER_WIDTH
        } : {},
        openOnFocus: !allowManualEntry,
        open: (e)=>{
            popup = e.popup;
            $8d258c1e3ba1d8a4$var$formatDatePickerPopupTitle(p, popup);
        },
        navigated: ()=>{
            $8d258c1e3ba1d8a4$var$formatDatePickerPopupTitle(p, popup);
        }
    };
};
const $8d258c1e3ba1d8a4$var$formatDatePickerPopupTitle = (p, popup)=>{
    if (popup) {
        const popupTitle = popup.element.firstElementChild?.firstElementChild?.firstElementChild;
        if (p.type === "Date" && popupTitle && p.minDate && (0, $fb0301734e2a6838$export$aa5154ebe0440ad5)((0, $fb0301734e2a6838$export$bf96ab0fd446bad3)(p.minDate), (0, $e56e694ede576bd9$export$f5cf78abc0513307)) && p.maxDate && (0, $fb0301734e2a6838$export$aa5154ebe0440ad5)((0, $fb0301734e2a6838$export$bf96ab0fd446bad3)(p.maxDate), (0, $e56e694ede576bd9$export$7ebe3995293fd6a4))) popupTitle.innerHTML = popupTitle.innerHTML.replace("2000", "");
    }
};










const $68cd912ea6a5a7c3$export$3e34c5ada111bce = (p, e)=>{
    const dropDownList = new (0, $e5d35cabace4110f$export$85ff158bc62a78c8)({
        ...$68cd912ea6a5a7c3$export$7cf68568721e1f19(p),
        change: (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)
    });
    dropDownList.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, dropDownList);
    (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
};
const $68cd912ea6a5a7c3$export$7cf68568721e1f19 = (p)=>({
        ...(0, $0529b7a83755f1dd$export$b5d8dae9ecb8541e)(p),
        dataSource: p.lookup ? new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
            url: (0, $55576f0fdfdeec43$export$8fa1eaeb4700701e)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.list({
                model: p.lookup
            }), {
                includeEmpty: !p.validation?.required ? "true" : "false"
            }),
            adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
        }) : p.options,
        fields: {
            value: "value",
            text: "text"
        },
        allowFiltering: p.allowFiltering,
        filterType: p.allowFiltering ? "Contains" : undefined,
        placeholder: p.placeholder ?? (p.defaultValue ? p.options?.find((option)=>option.value === p.defaultValue)?.text : undefined),
        showClearButton: false
    });













const $68048d08ba2e35cc$export$d1e31d4a170a6a4e = (p, e)=>{
    const dropDownList = new (0, $717505a12e9203b8$export$1e7dfd31545b5809)({
        ...$68048d08ba2e35cc$export$17a616b3b26edb00(p),
        change: (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)
    });
    dropDownList.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, dropDownList);
    (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
};
const $68048d08ba2e35cc$export$17a616b3b26edb00 = (p)=>({
        ...(0, $68cd912ea6a5a7c3$export$7cf68568721e1f19)(p),
        value: p.value === null ? [] : p.value,
        mode: "Box"
    });









(0, $95445997b68090e8$export$a4ff4468fa943a6c).Inject((0, $30bc71f720415a27$export$a1226420f67c68f9));
const $18d604c9eaaa99a2$export$9226a37e1b4df5e7 = (p, e)=>{
    const richTextEditor = new (0, $95445997b68090e8$export$a4ff4468fa943a6c)({
        ...$18d604c9eaaa99a2$export$168dff6fa397d98a(p),
        change: (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)
    });
    richTextEditor.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    const contentElement = richTextEditor.getContent();
    (0, $6d378a20e241a461$export$378e6a16d60321b1)(contentElement);
    // Listen for keydown as change event fires after dependent events
    contentElement.addEventListener("keydown", (event)=>{
        if (event.key !== "Escape" && event.key !== "Tab") (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)();
    });
    (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, richTextEditor);
    (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
};
const $18d604c9eaaa99a2$export$168dff6fa397d98a = (p)=>({
        ...(0, $0529b7a83755f1dd$export$b5d8dae9ecb8541e)(p),
        format: undefined,
        toolbarSettings: {
            items: !p.readOnly ? [
                "Bold",
                "Italic",
                "Underline",
                "FontColor",
                "ClearFormat",
                "OrderedList",
                "UnorderedList",
                "CreateLink",
                ...p.allowImages ? [
                    "Image"
                ] : []
            ] : []
        },
        editorMode: "HTML",
        enterKey: "DIV",
        pasteCleanupSettings: {
            plainText: true,
            allowedStyleProps: []
        },
        fontColor: {
            default: "#000000"
        },
        ...p.allowImages ? {
            insertImageSettings: {
                path: `${(0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.uploads.get(false)}/`,
                saveUrl: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.uploads.put()
            },
            imageUploading: (args)=>{
                if (args.fileData.size > (0, $e56e694ede576bd9$export$9516f9e0a56cdf20) * 1024) {
                    args.cancel = true;
                    alert(`File exceeds maximum size of ${(0, $e56e694ede576bd9$export$9516f9e0a56cdf20)}KB`);
                }
            },
            imageUploadSuccess: (args)=>{
                // https://ej2.syncfusion.com/documentation/rich-text-editor/how-to/rename-images-in-server
                if (args.e.currentTarget.getResponseHeader("name") != null) {
                    args.file.name = args.e.currentTarget.getResponseHeader("name");
                    const filename = document.querySelectorAll(".e-file-name")[0];
                    filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, "");
                    filename.title = args.file.name;
                }
            }
        } : {}
    });








const $9787288893744190$export$4d67165041e9dc91 = (p, e)=>{
    const textBox = new (0, $6d46db6d177db8e2$export$10e6f4f66014ee2d)({
        ...$9787288893744190$export$fbe2ab99b159d1cf(p),
        change: (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e)
    });
    textBox.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, textBox);
    (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
};
const $9787288893744190$export$fbe2ab99b159d1cf = (p, o)=>{
    const resetHeight = (args)=>{
        args.event.currentTarget.style.height = "100px";
    };
    const growHeight = (args)=>{
        resetHeight(args);
        args.event.currentTarget.style.height = args.event.currentTarget.scrollHeight + "px";
    };
    return {
        ...(0, $0529b7a83755f1dd$export$b5d8dae9ecb8541e)(p),
        placeholder: p.placeholder ?? p.defaultValue,
        showClearButton: false,
        autocomplete: "off",
        ...p.multiline ? {
            multiline: true,
            focus: growHeight,
            input: growHeight,
            ...o?.resetHeightOnBlur ? {
                blur: resetHeight
            } : {}
        } : {}
    };
};
const $9787288893744190$export$11600eed372b9a3a = (p)=>({
        beginEdit: ()=>{
            setTimeout(()=>{
                const input = (0, $e68843d575be3a15$export$d193da8733a2af56)(p.id).element.querySelector(".e-input");
                input.focus();
                if (p.multiline) {
                    // Move cursor to start if textarea to avoid jumping to end (e.g. notes)
                    input.setSelectionRange(0, 0);
                    input.scrollTop = 0;
                }
            }, 1);
        },
        submitClick: ()=>{
            const value = (0, $e68843d575be3a15$export$d193da8733a2af56)(p.id).value;
            if (typeof value === "string") (0, $e68843d575be3a15$export$d193da8733a2af56)(p.id).value = value.trim() || "";
        },
        actionBegin: (args)=>{
            const value = args.data.value;
            if (typeof value === "string") args.data.value = value.trim() || "";
        }
    });



const $fa0cc4e6b2b8ed8b$export$8915d73a47b3dd5f = async (p, e)=>{
    if (p.type !== "Switch") {
        const cm = $fa0cc4e6b2b8ed8b$var$createControlModel(p);
        const editor = new (0, $6c3b84be4fdf3a18$export$9c6622dfc8cb539f)({
            locale: cm.locale,
            mode: "Inline",
            name: p.field,
            primaryKey: p.modelId,
            type: p.type === "Integer" || p.type === "Float" ? "Text" : p.type,
            value: cm.value,
            model: cm,
            emptyText: p.emptyText ?? "Not set",
            validationRules: p.validation ? {
                [p.field]: p.validation
            } : undefined,
            disabled: p.readOnly,
            actionOnBlur: "Cancel",
            url: p.url ?? (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.editable({
                model: p.modelName
            }),
            adaptor: "UrlAdaptor",
            actionSuccess: (args)=>{
                e.setAttribute("data-empty", (0, $23645516f0d2c47e$export$813e94b17b81f345)(args.value) || (0, $23645516f0d2c47e$export$b57b2a4fc103e949)(args.value) ? "true" : "false");
            },
            ...$fa0cc4e6b2b8ed8b$var$createEditorModel(p)
        });
        (0, $e68843d575be3a15$export$56a40825678f1b4b)(p.id, editor);
        if ((0, $23645516f0d2c47e$export$813e94b17b81f345)(cm.value) || (0, $23645516f0d2c47e$export$b57b2a4fc103e949)(cm.value)) e.setAttribute("data-empty", "true");
        e.setAttribute("data-underline", "false");
        editor.appendTo(e);
        const editableValue = e.getElementsByClassName("e-editable-value")[0];
        if (typeof cm.value === "string" || typeof cm.value === "number") {
            if (p.lookup) {
                const url = `${(0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.lookup.item({
                    model: p.lookup,
                    value: cm.value
                })}?includeArchived=true`;
                const res = await (0, $0690cfee00fb4cf1$export$1bb358554aac31c1)(url);
                const item = await res.json();
                editableValue.innerHTML = item.text;
            } else if (p.options) {
                const text = Object.values(p.options).find((option)=>option.value === cm.value)?.text;
                if (text) editableValue.innerHTML = text;
            }
        }
        if (p.urlTemplate || p.obscured || p.copyable || p.validation?.email) {
            const span = document.createElement("span");
            if (p.urlTemplate) span.appendChild($fa0cc4e6b2b8ed8b$var$createIconButton({
                onClick: ()=>{
                    const url = p.urlTemplate.replaceAll("${value}", editor.value.toString());
                    if (url.startsWith("http")) window.open(url);
                    else {
                        const offcanvas = new URLSearchParams(location.search).get("offcanvas") === "true";
                        location.href = offcanvas ? (0, $55576f0fdfdeec43$export$d40de045aa35670f)(url) : url;
                    }
                },
                className: "fa-solid fa-arrow-up-right-from-square"
            }));
            if (p.obscured) span.appendChild($fa0cc4e6b2b8ed8b$var$createIconButton({
                onClick: ()=>{
                    e.setAttribute("data-obscured", e.dataset.obscured === "true" ? "false" : "true");
                },
                className: "fa-solid fa-eye"
            }));
            if (p.copyable) span.appendChild($fa0cc4e6b2b8ed8b$var$createIconButton({
                onClick: ()=>{
                    navigator.clipboard.writeText(editableValue.textContent ?? "");
                },
                className: "fa-solid fa-paste"
            }));
            if (p.validation?.email) span.appendChild($fa0cc4e6b2b8ed8b$var$createIconButton({
                url: `mailto:${cm.value}`,
                className: "fa-solid fa-envelope"
            }));
            e.after(span);
        }
    }
};
const $fa0cc4e6b2b8ed8b$var$createControlModel = (p)=>{
    const { type: type } = p;
    if (type === "Text" || type === "Float" || type === "Integer") return (0, $9787288893744190$export$fbe2ab99b159d1cf)(p);
    else if (type === "Date") return (0, $8d258c1e3ba1d8a4$export$6b901f18b507bf5b)(p);
    else if (type === "DropDownList") return (0, $68cd912ea6a5a7c3$export$7cf68568721e1f19)(p);
    else if (type === "MultiSelect") return (0, $68048d08ba2e35cc$export$17a616b3b26edb00)(p);
    else if (type === "RTE") return (0, $18d604c9eaaa99a2$export$168dff6fa397d98a)(p);
    throw new Error("Invalid type");
};
const $fa0cc4e6b2b8ed8b$var$createEditorModel = (p)=>{
    if (p.type === "Text") return (0, $9787288893744190$export$11600eed372b9a3a)(p);
};
const $fa0cc4e6b2b8ed8b$var$createIconButton = (params)=>{
    const { url: url, newWindow: newWindow, onClick: onClick, className: className } = params;
    const a = document.createElement("a");
    a.href = url ?? "#";
    a.className = "mx-1";
    if (newWindow) a.target = "_blank";
    if (onClick) a.addEventListener("click", (event)=>{
        event.preventDefault();
        onClick();
    });
    const i = document.createElement("i");
    i.className = className;
    a.appendChild(i);
    return a;
};





parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $hQxLN = parcelRequire("hQxLN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");
var $kj1BR = parcelRequire("kj1BR");

var $9c502fb32bcb4eb5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9c502fb32bcb4eb5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c502fb32bcb4eb5$var$DISABLED = "e-switch-disabled";
var $9c502fb32bcb4eb5$var$RIPPLE = "e-ripple-container";
var $9c502fb32bcb4eb5$var$RIPPLE_CHECK = "e-ripple-check";
var $9c502fb32bcb4eb5$var$RTL = "e-rtl";
var $9c502fb32bcb4eb5$var$WRAPPER = "e-switch-wrapper";
var $9c502fb32bcb4eb5$var$ACTIVE = "e-switch-active";
var $9c502fb32bcb4eb5$var$ATTRIBUTES = [
    "title",
    "class",
    "style",
    "disabled",
    "readonly",
    "name",
    "value",
    "aria-label",
    "id",
    "role",
    "tabindex"
];
/**
 * The Switch is a graphical user interface element that allows you to toggle between checked and unchecked states.
 * ```html
 * <input type="checkbox" id="switch"/>
 * <script>
 * var switchObj = new Switch({});
 * switchObj.appendTo("#switch");
 * </script>
 * ```
 */ var $9c502fb32bcb4eb5$export$b5d5cf8927ab7262 = /** @class */ function(_super) {
    $9c502fb32bcb4eb5$var$__extends(Switch, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     *
     * @param {SwitchModel} options switch model
     * @param {string | HTMLInputElement} element target element
     *
     */ function Switch(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        _this.isDrag = false;
        _this.isWireEvents = false;
        return _this;
    }
    Switch.prototype.changeState = function(state) {
        var rippleSpan = null;
        var wrapper = this.getWrapper();
        var bar = wrapper.querySelector(".e-switch-inner");
        var handle = wrapper.querySelector(".e-switch-handle");
        if (0, $kj1BR.isRippleEnabled) rippleSpan = wrapper.getElementsByClassName($9c502fb32bcb4eb5$var$RIPPLE)[0];
        if (state) {
            (0, $4ZDHT.addClass)([
                bar,
                handle
            ], $9c502fb32bcb4eb5$var$ACTIVE);
            this.element.checked = true;
            this.checked = true;
            if (rippleSpan) (0, $4ZDHT.addClass)([
                rippleSpan
            ], [
                $9c502fb32bcb4eb5$var$RIPPLE_CHECK
            ]);
        } else {
            (0, $4ZDHT.removeClass)([
                bar,
                handle
            ], $9c502fb32bcb4eb5$var$ACTIVE);
            this.element.checked = false;
            this.checked = false;
            if (rippleSpan) (0, $4ZDHT.removeClass)([
                rippleSpan
            ], [
                $9c502fb32bcb4eb5$var$RIPPLE_CHECK
            ]);
        }
    };
    Switch.prototype.clickHandler = function(evt) {
        this.isDrag = false;
        this.focusOutHandler();
        this.changeState(!this.checked);
        this.element.focus();
        var changeEventArgs = {
            checked: this.element.checked,
            event: evt
        };
        this.trigger("change", changeEventArgs);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isAngular && evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    /**
     * Destroys the Switch widget.
     *
     * @returns {void}
     */ Switch.prototype.destroy = function() {
        var _this = this;
        _super.prototype.destroy.call(this);
        if (!this.disabled) this.unWireEvents();
        (0, $6a51972c93f30c96$export$b1fb4cac938035f7)(this, this.getWrapper(), this.tagName);
        if (this.refreshing) {
            [
                "e-control",
                "e-switch",
                "e-lib"
            ].forEach(function(key) {
                _this.element.classList.add(key);
            });
            (0, $3EnZW.setValue)("ej2_instances", [
                this
            ], this.element);
        }
    };
    Switch.prototype.focusHandler = function() {
        this.isFocused = true;
    };
    Switch.prototype.focusOutHandler = function() {
        this.getWrapper().classList.remove("e-focus");
    };
    /**
     * Gets the module name.
     *
     * @private
     * @returns {string} - Module Name
     */ Switch.prototype.getModuleName = function() {
        return "switch";
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist data
     */ Switch.prototype.getPersistData = function() {
        return this.addOnPersist([
            "checked"
        ]);
    };
    Switch.prototype.getWrapper = function() {
        if (this.element.parentElement) return this.element.parentElement;
        else return null;
    };
    Switch.prototype.initialize = function() {
        this.element.setAttribute("role", "switch");
        if ((0, $3EnZW.isNullOrUndefined)(this.initialSwitchCheckedValue)) this.initialSwitchCheckedValue = this.checked;
        if (this.name) this.element.setAttribute("name", this.name);
        if (this.value) this.element.setAttribute("value", this.value);
        if (this.checked) this.changeState(true);
        if (this.disabled) this.setDisabled();
        if (this.onLabel || this.offLabel) this.setLabel(this.onLabel, this.offLabel);
    };
    Switch.prototype.initWrapper = function() {
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains($9c502fb32bcb4eb5$var$WRAPPER)) {
            wrapper = this.createElement("div", {
                className: $9c502fb32bcb4eb5$var$WRAPPER
            });
            this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var switchInner = this.createElement("span", {
            className: "e-switch-inner"
        });
        var onLabel = this.createElement("span", {
            className: "e-switch-on"
        });
        var offLabel = this.createElement("span", {
            className: "e-switch-off"
        });
        var handle = this.createElement("span", {
            className: "e-switch-handle"
        });
        wrapper.appendChild(this.element);
        (0, $6a51972c93f30c96$export$4692e7592464f3a2)(this, wrapper);
        switchInner.appendChild(onLabel);
        switchInner.appendChild(offLabel);
        wrapper.appendChild(switchInner);
        wrapper.appendChild(handle);
        if (0, $kj1BR.isRippleEnabled) {
            var rippleSpan = this.createElement("span", {
                className: $9c502fb32bcb4eb5$var$RIPPLE
            });
            handle.appendChild(rippleSpan);
            (0, $kj1BR.rippleEffect)(rippleSpan, {
                duration: 400,
                isCenterRipple: true
            });
        }
        wrapper.classList.add("e-wrapper");
        if (this.enableRtl) wrapper.classList.add($9c502fb32bcb4eb5$var$RTL);
        if (this.cssClass) (0, $4ZDHT.addClass)([
            wrapper
        ], this.cssClass.replace(/\s+/g, " ").trim().split(" "));
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {SwitchModel} newProp - Specifies New Properties
     * @param {SwitchModel} oldProp - Specifies Old Properties
     * @returns {void}
     */ Switch.prototype.onPropertyChanged = function(newProp, oldProp) {
        var wrapper = this.getWrapper();
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "checked":
                    this.changeState(newProp.checked);
                    break;
                case "disabled":
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.unWireEvents();
                        this.isWireEvents = false;
                    } else {
                        this.element.disabled = false;
                        wrapper.classList.remove($9c502fb32bcb4eb5$var$DISABLED);
                        wrapper.setAttribute("aria-disabled", "false");
                        if (!this.isWireEvents) {
                            this.wireEvents();
                            this.isWireEvents = true;
                        }
                    }
                    break;
                case "value":
                    this.element.setAttribute("value", newProp.value);
                    break;
                case "name":
                    this.element.setAttribute("name", newProp.name);
                    break;
                case "onLabel":
                case "offLabel":
                    this.setLabel(newProp.onLabel, newProp.offLabel);
                    break;
                case "enableRtl":
                    if (newProp.enableRtl) wrapper.classList.add($9c502fb32bcb4eb5$var$RTL);
                    else wrapper.classList.remove($9c502fb32bcb4eb5$var$RTL);
                    break;
                case "cssClass":
                    if (oldProp.cssClass) (0, $4ZDHT.removeClass)([
                        wrapper
                    ], oldProp.cssClass.split(" "));
                    if (newProp.cssClass) (0, $4ZDHT.addClass)([
                        wrapper
                    ], newProp.cssClass.replace(/\s+/g, " ").trim().split(" "));
                    break;
                case "htmlAttributes":
                    this.updateHtmlAttribute();
                    break;
            }
        }
    };
    /**
     * Initialize Angular, React and Unique ID support.
     *
     * @private
     * @returns {void}
     */ Switch.prototype.preRender = function() {
        var element = this.element;
        this.formElement = (0, $4ZDHT.closest)(this.element, "form");
        this.tagName = this.element.tagName;
        (0, $6a51972c93f30c96$export$a555f843fc00d55a)(this, "EJS-SWITCH", $9c502fb32bcb4eb5$var$WRAPPER, element, this.getModuleName());
    };
    /**
     * Initialize control rendering.
     *
     * @private
     * @returns {void}
     */ Switch.prototype.render = function() {
        this.initWrapper();
        this.initialize();
        if (!this.disabled) this.wireEvents();
        this.renderComplete();
        this.updateHtmlAttribute();
    };
    Switch.prototype.rippleHandler = function(e) {
        var rippleSpan = this.getWrapper().getElementsByClassName($9c502fb32bcb4eb5$var$RIPPLE)[0];
        (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        if (e.type === "mousedown" && e.currentTarget.classList.contains("e-switch-wrapper") && e.which === 1) {
            this.isDrag = true;
            this.isFocused = false;
        }
    };
    Switch.prototype.mouseLeaveHandler = function(e) {
        var rippleSpan = this.element.parentElement.getElementsByClassName($9c502fb32bcb4eb5$var$RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll(".e-ripple-element");
            for(var i = rippleElem.length - 1; i > 0; i--)rippleSpan.removeChild(rippleSpan.childNodes[i]);
            (0, $6a51972c93f30c96$export$e68f3fbf27cf73b)(e, rippleSpan);
        }
    };
    Switch.prototype.rippleTouchHandler = function(eventType) {
        var rippleSpan = this.getWrapper().getElementsByClassName($9c502fb32bcb4eb5$var$RIPPLE)[0];
        if (rippleSpan) {
            var event_1 = document.createEvent("MouseEvents");
            event_1.initEvent(eventType, false, true);
            rippleSpan.dispatchEvent(event_1);
        }
    };
    Switch.prototype.setDisabled = function() {
        var wrapper = this.getWrapper();
        this.element.disabled = true;
        wrapper.classList.add($9c502fb32bcb4eb5$var$DISABLED);
        wrapper.setAttribute("aria-disabled", "true");
    };
    Switch.prototype.setLabel = function(onText, offText) {
        var wrapper = this.getWrapper();
        if (onText) wrapper.querySelector(".e-switch-on").textContent = onText;
        if (offText) wrapper.querySelector(".e-switch-off").textContent = offText;
    };
    Switch.prototype.updateHtmlAttribute = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.htmlAttributes)) for(var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++){
            var key = _a[_i];
            var wrapper = this.getWrapper();
            if ($9c502fb32bcb4eb5$var$ATTRIBUTES.indexOf(key) > -1) {
                if (key === "class") (0, $4ZDHT.addClass)([
                    wrapper
                ], this.htmlAttributes["" + key].split(" "));
                else if (key === "title") wrapper.setAttribute(key, this.htmlAttributes["" + key]);
                else if (key === "style") wrapper.setAttribute(key, this.htmlAttributes["" + key]);
                else if (key === "disabled") {
                    if (this.htmlAttributes["" + key] === "true") this.setDisabled();
                    this.element.setAttribute(key, this.htmlAttributes["" + key]);
                } else this.element.setAttribute(key, this.htmlAttributes["" + key]);
            } else wrapper.setAttribute(key, this.htmlAttributes["" + key]);
        }
    };
    Switch.prototype.switchFocusHandler = function() {
        if (this.isFocused) this.getWrapper().classList.add("e-focus");
    };
    Switch.prototype.switchMouseUp = function(e) {
        var aTouchY = 0;
        var yDiff = 0;
        var aTouchX = 0;
        var xDiff = 0;
        var target = e.target;
        if (e.type === "touchmove") {
            e.preventDefault();
            aTouchX = e.changedTouches[0].clientX;
            aTouchY = e.changedTouches[0].clientY;
            xDiff = this.bTouchX - aTouchX;
            yDiff = this.bTouchY - aTouchY;
            if (Math.abs(xDiff) < Math.abs(yDiff)) {
                this.isDrag = false;
                this.rippleTouchHandler("mouseup");
            } else this.isDrag = true;
        }
        if (e.type === "touchstart") {
            this.bTouchX = e.changedTouches[0].clientX;
            this.bTouchY = e.changedTouches[0].clientY;
            this.isDrag = true;
            this.rippleTouchHandler("mousedown");
        }
        if (this.isDrag) {
            if (e.type === "mouseup" && target.className.indexOf("e-switch") < 0 || e.type === "touchend") {
                xDiff = this.bTouchX - e.changedTouches[0].clientX;
                yDiff = this.bTouchY - e.changedTouches[0].clientY;
                if (Math.abs(xDiff) >= Math.abs(yDiff)) {
                    this.clickHandler(e);
                    this.rippleTouchHandler("mouseup");
                    e.preventDefault();
                }
            }
        }
    };
    Switch.prototype.formResetHandler = function() {
        this.checked = this.initialSwitchCheckedValue;
        this.element.checked = this.initialSwitchCheckedValue;
    };
    /**
     * Toggle the Switch component state into checked/unchecked.
     *
     * @returns {void}
     */ Switch.prototype.toggle = function() {
        this.clickHandler();
    };
    Switch.prototype.wireEvents = function() {
        var wrapper = this.getWrapper();
        this.delegateMouseUpHandler = this.switchMouseUp.bind(this);
        this.delegateKeyUpHandler = this.switchFocusHandler.bind(this);
        (0, $aqzbR.EventHandler).add(wrapper, "click", this.clickHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focus", this.focusHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "focusout", this.focusOutHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "mouseup", this.delegateMouseUpHandler, this);
        (0, $aqzbR.EventHandler).add(this.element, "keyup", this.delegateKeyUpHandler, this);
        (0, $aqzbR.EventHandler).add(wrapper, "mousedown mouseup", this.rippleHandler, this);
        (0, $aqzbR.EventHandler).add(wrapper, "mouseleave", this.mouseLeaveHandler, this);
        (0, $aqzbR.EventHandler).add(wrapper, "touchstart touchmove touchend", this.switchMouseUp, this);
        if (this.formElement) (0, $aqzbR.EventHandler).add(this.formElement, "reset", this.formResetHandler, this);
    };
    Switch.prototype.unWireEvents = function() {
        var wrapper = this.getWrapper();
        (0, $aqzbR.EventHandler).remove(wrapper, "click", this.clickHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focus", this.focusHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "focusout", this.focusOutHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "mouseup", this.delegateMouseUpHandler);
        (0, $aqzbR.EventHandler).remove(this.element, "keyup", this.delegateKeyUpHandler);
        (0, $aqzbR.EventHandler).remove(wrapper, "mousedown mouseup", this.rippleHandler);
        (0, $aqzbR.EventHandler).remove(wrapper, "mouseleave", this.mouseLeaveHandler);
        (0, $aqzbR.EventHandler).remove(wrapper, "touchstart touchmove touchend", this.switchMouseUp);
        if (this.formElement) (0, $aqzbR.EventHandler).remove(this.formElement, "reset", this.formResetHandler);
    };
    /**
     * Click the switch element
     * its native method
     *
     * @public
     * @returns {void}
     */ Switch.prototype.click = function() {
        this.element.click();
    };
    /**
     * Sets the focus to Switch
     * its native method
     *
     * @public
     */ Switch.prototype.focusIn = function() {
        this.element.focus();
    };
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Event)()
    ], Switch.prototype, "change", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Event)()
    ], Switch.prototype, "created", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Switch.prototype, "checked", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Switch.prototype, "cssClass", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Switch.prototype, "disabled", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Switch.prototype, "name", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Switch.prototype, "onLabel", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Switch.prototype, "offLabel", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)("")
    ], Switch.prototype, "value", void 0);
    $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.Property)({})
    ], Switch.prototype, "htmlAttributes", void 0);
    Switch = $9c502fb32bcb4eb5$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Switch);
    return Switch;
}((0, $hQxLN.Component));







const $55a561918ac7c3be$export$7a06b6416c4a7551 = (p, e)=>{
    const swtch = new (0, $9c502fb32bcb4eb5$export$b5d5cf8927ab7262)({
        checked: (0, $e68843d575be3a15$export$c6a3502e38927635)(p, p.value),
        disabled: p.readOnly
    });
    if (!p.modelId || p.editMode === "Form") {
        swtch.change = (0, $6d378a20e241a461$export$d8a7b8f475ec0161)(e);
        (0, $e68843d575be3a15$export$82af9bc734d9e5bb)(p.id, swtch);
        (0, $e68843d575be3a15$export$c470fcda89530fcd)(p, e);
        swtch.appendTo((0, $45badea74a08f73b$export$b7e3ae3d7c15e42e)(p, e));
    } else {
        swtch.change = async (args)=>{
            const body = {
                params: {
                    name: p.field,
                    primaryKey: p.modelId,
                    value: (0, $e68843d575be3a15$export$c6a3502e38927635)(p, args.checked)
                }
            };
            await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.editable({
                model: p.modelName
            }), body);
        };
        swtch.appendTo(e);
    }
};





(0, $6c3b84be4fdf3a18$export$9c6622dfc8cb539f).Inject((0, $8eb1bb0c25d9a770$export$1e7dfd31545b5809), (0, $30f18bd0dc90d086$export$e30f3e57961fb302));
(0, $95445997b68090e8$export$a4ff4468fa943a6c).Inject((0, $d346826d2cbb602c$export$4c260019440d418f), (0, $f33d01d1f6cb2ad3$export$23bffbc1d2dae0de), (0, $d24ea15df6d7af38$export$a6c7ac8248d6e38a), (0, $49a6f5fde11efa2c$export$3e431a229df88919));
document.addEventListener("DOMContentLoaded", ()=>{
    $7f09102b7f496242$var$initEditables();
    $7f09102b7f496242$var$focusFirstInput();
    (0, $e625b333c39c8463$export$635e15bbd66f01ea)("editablesReady");
});
const $7f09102b7f496242$var$initEditables = ()=>{
    for (const e of document.querySelectorAll(".editable"))$7f09102b7f496242$var$initEditable(e);
};
const $7f09102b7f496242$var$initEditable = (e)=>{
    const p = (0, $6d378a20e241a461$export$2ea4d0d34fe561d5)(e.dataset.props);
    (0, $e68843d575be3a15$export$938ca3893886de06)(p.id, p);
    (0, $e68843d575be3a15$export$829cd59ad97f6102)(p.id, p.field);
    $7f09102b7f496242$var$initControl(p, e);
    $7f09102b7f496242$var$initDataAttributes(p, e);
    $7f09102b7f496242$var$initTooltip(p, e);
};
const $7f09102b7f496242$var$initControl = (p, e)=>{
    if (p.type === "Switch") (0, $55a561918ac7c3be$export$7a06b6416c4a7551)(p, e);
    else if (!p.modelId || p.editMode === "Form") {
        if (p.type === "Text" || p.type === "Float" || p.type === "Integer") (0, $9787288893744190$export$4d67165041e9dc91)(p, e);
        else if (p.type === "Date") (0, $8d258c1e3ba1d8a4$export$9d5c97e1c9024cca)(p, e);
        else if (p.type === "DropDownList") (0, $68cd912ea6a5a7c3$export$3e34c5ada111bce)(p, e);
        else if (p.type === "MultiSelect") (0, $68048d08ba2e35cc$export$d1e31d4a170a6a4e)(p, e);
        else if (p.type === "RTE") (0, $18d604c9eaaa99a2$export$9226a37e1b4df5e7)(p, e);
    } else (0, $fa0cc4e6b2b8ed8b$export$8915d73a47b3dd5f)(p, e);
};
const $7f09102b7f496242$var$initDataAttributes = (p, e)=>{
    e.setAttribute("data-model", p.modelName);
    e.setAttribute("data-field", p.field);
    if (!p.modelId) e.setAttribute("data-new", "true");
    if (p.readOnly) e.setAttribute("data-read-only", "true");
    if (!(p.allowManualEntry ?? true)) e.setAttribute("data-manual-entry", "false");
    if (p.fullwidth) e.setAttribute("data-fullwidth", "true");
    if (p.multiline) e.setAttribute("data-multiline", "true");
    if (p.obscured) e.setAttribute("data-obscured", "true");
};
const $7f09102b7f496242$var$initTooltip = (p, e)=>{
    if (p.tooltip) new (0, $91ca15859685b28b$export$28c660c63b792dea)(e.closest(".editable-wrapper"), {
        title: p.tooltip,
        placement: "right"
    });
};
const $7f09102b7f496242$var$focusFirstInput = ()=>{
    const firstInput = document.querySelector(".editable[data-new] input");
    if (firstInput) firstInput.focus();
    for (const element of document.querySelectorAll(".editable-date-check-box"))(0, $937adc5561795ee6$export$972441c45418dcb4)(element);
};










document.addEventListener("DOMContentLoaded", ()=>{
    document.getElementById("search-button")?.addEventListener("click", ()=>document.getElementById("search")?.focus());
    const search = new (0, $1b6f3188acd1d256$export$6b41f50dc0c59fb3)({
        dataSource: new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
            url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).data.search(),
            adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
        }),
        fields: {
            groupBy: "type",
            value: "name"
        },
        groupTemplate: '<div class="search-result-group">${window.formatters.formatSearchResultType(type)}</div>',
        itemTemplate: '<div class="search-result-item">${window.formatters.formatSearchResultName(name)}</div>',
        allowCustom: false,
        // autofill: true,
        showClearButton: true,
        suggestionCount: 100,
        placeholder: "Search clients and tasks",
        width: 600,
        popupHeight: 600,
        change: ()=>{
            const result = search.getDataByValue(search.value);
            let url;
            if (result.type === "company") url = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).companies.edit({
                id: result.id
            });
            else if (result.type === "individual") url = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).individuals.edit({
                id: result.id
            });
            else if (result.type === "task") url = (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).tasks.edit({
                id: result.id
            });
            if (url) (0, $82c899c22fad1693$export$bf853798236fc2fa)({
                url: url,
                onHide: (0, $2fb2c27c9772a1c5$export$2b7261532f749c9)
            });
            search.clear();
        }
    });
    search.appendTo("#search");
});
const $3f1dfac78426f6b7$export$6ca9a25c0486d5ad = (type)=>{
    if (type === "company") return "Companies";
    else if (type === "individual") return "Individuals";
    else if (type === "task") return "Tasks";
    return "";
};
const $3f1dfac78426f6b7$export$7217b584de818271 = (name)=>name.split("|").map((part)=>part.trim()).filter((part)=>part).map((part)=>`<span>${part}</span>`).join("");


const $ac9ef379b81bdf88$var$wrap = (formatter)=>{
    return (value)=>{
        try {
            return formatter(value);
        } catch (e) {
            console.error(e);
            return "";
        }
    };
};
window.formatters = {
    dueDateClass: $ac9ef379b81bdf88$var$wrap((0, $2ca9fcd86dc38755$export$5277d48d12c46899)),
    formatClassName: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$91884aa883243770)),
    formatDayMonth: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$c4e890008b690b8d)),
    formatDayLongMonth: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$9edae1c37cf7adb6)),
    formatDayMonthYear: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$6fc082e5cc44c8b5)),
    formatDate: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$3ae94a2503e890a1)),
    formatTime: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$3203edd9e5edd663)),
    formatDayMonthYearTime: $ac9ef379b81bdf88$var$wrap((0, $d47525176c3f6cd7$export$d05cda19ddf5275d)),
    formatSearchResultName: $ac9ef379b81bdf88$var$wrap((0, $3f1dfac78426f6b7$export$7217b584de818271)),
    formatSearchResultType: $ac9ef379b81bdf88$var$wrap((0, $3f1dfac78426f6b7$export$6ca9a25c0486d5ad)),
    formatCompanyType: $ac9ef379b81bdf88$var$wrap((value)=>(0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$97fd21cceb1e64f3), value)),
    formatTaskStatus: $ac9ef379b81bdf88$var$wrap((value)=>(0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$61db76a97f26b7e1), value)),
    formatSmartTaskType: $ac9ef379b81bdf88$var$wrap((value)=>(0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$565e37f6a005bc8), value)),
    formatUpdateOnCompletion: $ac9ef379b81bdf88$var$wrap((value)=>(0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$a2d5e26d840f3aaf), value)),
    formatPriority: $ac9ef379b81bdf88$var$wrap((value)=>(0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$300334f671c43555), value))
};









(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="payrollFrequency"]')
    ].map((editableElement)=>editableElement).forEach((editableElement)=>{
        const form = editableElement.closest("form");
        const dropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editableElement.id);
        const editor = (0, $e68843d575be3a15$export$d193da8733a2af56)(editableElement.id);
        const control = dropDownList ?? editor;
        if (control) {
            const refresh = (payrollFrequency, options)=>{
                const { save: save } = options ?? {};
                const selected = control.value === payrollFrequency;
                const dayTr = form.querySelector(`tr[data-payroll-frequency="${payrollFrequency}"]`);
                dayTr.classList.toggle("d-none", !selected);
                const dayEditable = dayTr.querySelector('.editable[data-field="payrollDay"]');
                if (dayEditable) {
                    const dayEditableProps = (0, $e68843d575be3a15$export$75fe5f91d452f94b)(dayEditable.id);
                    const dayDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(dayEditable.id);
                    const dayEditor = (0, $e68843d575be3a15$export$d193da8733a2af56)(dayEditable.id);
                    const disabled = !selected || !!dayEditableProps?.readOnly;
                    if (dayDropDownList) dayDropDownList.enabled = !disabled;
                    else if (dayEditor) {
                        dayEditor.disabled = disabled;
                        if (selected && save) (0, $e68843d575be3a15$export$18f2ef1f3de9bc1c)(dayEditable.id, null);
                    }
                }
            };
            refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Weekly);
            refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Fortnightly);
            refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Monthly);
            refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Quarterly);
            if (dropDownList) dropDownList.addEventListener("change", ()=>{
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Weekly);
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Fortnightly);
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Monthly);
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Quarterly);
            });
            else if (editor) editor.addEventListener("actionSuccess", ()=>{
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Weekly, {
                    save: true
                });
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Fortnightly, {
                    save: true
                });
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Monthly, {
                    save: true
                });
                refresh((0, $19ee14db620c232e$export$dea1348d86434c4a).Quarterly, {
                    save: true
                });
            });
        }
    });
});


parcelRequire("j7YE8");
var $4ZDHT = parcelRequire("4ZDHT");
var $kj1BR = parcelRequire("kj1BR");
var $5q7BP = parcelRequire("5q7BP");
var $c2qqN = parcelRequire("c2qqN");
var $5rsSz = parcelRequire("5rsSz");
var $aqzbR = parcelRequire("aqzbR");
var $3EnZW = parcelRequire("3EnZW");



var $49u5W = parcelRequire("49u5W");
var $2vAqh = parcelRequire("2vAqh");

var $3b677bffd4c0e837$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3b677bffd4c0e837$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * The Mention component is used to list someone or something based on user input in textarea, input,
 * or any other editable element from which the user can select.
 */ var $3b677bffd4c0e837$export$e891316fea657d90 = /** @class */ function(_super) {
    $3b677bffd4c0e837$var$__extends(Mention, _super);
    /**
     * * Constructor for creating the widget
     *
     * @param {MentionModel} options - Specifies the MentionComponent model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */ function Mention(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * When property value changes happened, then onPropertyChanged method will execute the respective changes in this component.
     *
     * @param {MentionModel} newProp - Returns the dynamic property value of the component.
     * @param {MentionModel} oldProp - Returns the previous property value of the component.
     * @private
     * @returns {void}
     */ Mention.prototype.onPropertyChanged = function(newProp, oldProp) {
        for(var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++){
            var prop = _a[_i];
            switch(prop){
                case "minLength":
                    this.minLength = newProp.minLength;
                    break;
                case "suffixText":
                    this.suffixText = newProp.suffixText;
                    break;
                case "allowSpaces":
                    this.allowSpaces = newProp.allowSpaces;
                    break;
                case "mentionChar":
                    this.mentionChar = newProp.mentionChar;
                    break;
                case "showMentionChar":
                    this.showMentionChar = newProp.showMentionChar;
                    break;
                case "cssClass":
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
            }
        }
    };
    Mention.prototype.updateCssClass = function(newClass, oldClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass)) oldClass = oldClass.replace(/\s+/g, " ").trim();
        if (!(0, $3EnZW.isNullOrUndefined)(newClass)) newClass = newClass.replace(/\s+/g, " ").trim();
        this.setCssClass(newClass, [
            this.inputElement
        ], oldClass);
        if (this.popupObj) this.setCssClass(newClass, [
            this.popupObj.element
        ], oldClass);
    };
    Mention.prototype.setCssClass = function(cssClass, elements, oldClass) {
        if (!(0, $3EnZW.isNullOrUndefined)(oldClass) && oldClass !== "") (0, $4ZDHT.removeClass)(elements, oldClass.split(" "));
        if (!(0, $3EnZW.isNullOrUndefined)(cssClass) && cssClass !== "") (0, $4ZDHT.addClass)(elements, cssClass.split(" "));
    };
    Mention.prototype.initializeData = function() {
        this.isSelected = false;
        this.isFiltered = false;
        this.beforePopupOpen = false;
        this.initRemoteRender = false;
        this.isListResetted = false;
        this.isPopupOpen = false;
        this.isCollided = false;
        this.lineBreak = false;
        this.isRTE = false;
        this.keyEventName = "mousedown";
    };
    /**
     * Execute before render the list items
     *
     * @private
     * @returns {void}
     */ Mention.prototype.preRender = function() {
        this.initializeData();
        _super.prototype.preRender.call(this);
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */ Mention.prototype.render = function() {
        var isSelector = typeof this.target === "string";
        this.inputElement = !(0, $3EnZW.isNullOrUndefined)(this.target) ? this.checkAndUpdateInternalComponent(isSelector ? document.querySelector(this.target) : this.target) : this.element;
        if (this.isContentEditable(this.inputElement)) {
            this.inputElement.setAttribute("contenteditable", "true");
            (0, $4ZDHT.addClass)([
                this.inputElement
            ], [
                "e-mention"
            ]);
            if ((0, $3EnZW.isNullOrUndefined)(this.target)) (0, $4ZDHT.addClass)([
                this.inputElement
            ], [
                "e-editable-element"
            ]);
        }
        this.inputElement.setAttribute("role", "textbox");
        this.inputElement.setAttribute("aria-label", "mention");
        this.queryString = this.elementValue();
        this.wireEvent();
    };
    Mention.prototype.wireEvent = function() {
        (0, $aqzbR.EventHandler).add(this.inputElement, "keyup", this.onKeyUp, this);
        this.bindCommonEvent();
    };
    Mention.prototype.unWireEvent = function() {
        (0, $aqzbR.EventHandler).remove(this.inputElement, "keyup", this.onKeyUp);
        this.unBindCommonEvent();
    };
    Mention.prototype.bindCommonEvent = function() {
        if (!(0, $5q7BP.Browser).isDevice) this.inputElement.addEventListener("keydown", this.keyDownHandler.bind(this), !this.isRTE);
    };
    /**
     * Hides the spinner loader.
     *
     * @private
     * @returns {void}
     */ Mention.prototype.hideSpinner = function() {
        this.hideWaitingSpinner();
    };
    Mention.prototype.hideWaitingSpinner = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) (0, $d4834c37f505aa74$export$95fec50f68454318)(this.spinnerElement);
        if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerTemplate) && !(0, $3EnZW.isNullOrUndefined)(this.spinnerTemplateElement)) (0, $4ZDHT.detach)(this.spinnerTemplateElement);
    };
    Mention.prototype.checkAndUpdateInternalComponent = function(targetElement) {
        if (!this.isVue && targetElement.classList.contains("e-richtexteditor")) return targetElement.querySelector(".e-content");
        if (this.isVue && targetElement.nodeName === "TEXTAREA" && targetElement.classList.contains("e-rte-hidden")) {
            var parentElement = targetElement.parentElement;
            if (parentElement && parentElement.classList.contains("e-richtexteditor")) return parentElement.querySelector(".e-content");
        }
        if (targetElement && targetElement.parentElement && targetElement.parentElement.classList.contains("e-rte-content")) {
            this.isRTE = true;
            this.keyEventName = "click";
        }
        return targetElement;
    };
    /**
     * Shows the spinner loader.
     *
     * @returns {void}
     */ Mention.prototype.showWaitingSpinner = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj)) {
            if ((0, $3EnZW.isNullOrUndefined)(this.spinnerTemplate) && (0, $3EnZW.isNullOrUndefined)(this.spinnerElement)) {
                this.spinnerElement = this.popupObj.element;
                (0, $d4834c37f505aa74$export$2342b8d835c798ac)({
                    target: this.spinnerElement,
                    width: (0, $5q7BP.Browser).isDevice ? "16px" : "14px"
                }, this.createElement);
                (0, $d4834c37f505aa74$export$2a7a135fa1ec651f)(this.spinnerElement);
            }
            if (!(0, $3EnZW.isNullOrUndefined)(this.spinnerTemplate)) this.setSpinnerTemplate();
        }
    };
    Mention.prototype.keyDownHandler = function(e) {
        var isKeyAction = true;
        switch(e.keyCode){
            case 38:
                e.action = e.altKey ? "hide" : "up";
                break;
            case 40:
                e.action = e.altKey ? "open" : "down";
                break;
            case 33:
                e.action = "pageUp";
                break;
            case 34:
                e.action = "pageDown";
                break;
            case 36:
                e.action = "home";
                break;
            case 35:
                e.action = "end";
                break;
            case 9:
                e.action = e.shiftKey ? "close" : "tab";
                break;
            case 27:
                e.action = "escape";
                break;
            case 32:
                e.action = "space";
                break;
            case 13:
                e.action = "enter";
                break;
            default:
                isKeyAction = false;
                break;
        }
        if (isKeyAction) this.keyActionHandler(e);
    };
    Mention.prototype.keyActionHandler = function(e) {
        var isNavigation = e.action === "down" || e.action === "up" || e.action === "pageUp" || e.action === "pageDown" || e.action === "home" || e.action === "end";
        var isTabAction = e.action === "tab" || e.action === "close";
        if (this.list === undefined && !this.isRequested && !isTabAction && e.action !== "escape" && e.action !== "space" && this.mentionChar.charCodeAt(0) === this.getLastLetter(this.getTextRange()).charCodeAt(0)) this.renderList();
        if ((0, $3EnZW.isNullOrUndefined)(this.list) || !(0, $3EnZW.isNullOrUndefined)(this.liCollections) && isNavigation && this.liCollections.length === 0 || this.isRequested) return;
        if (e.action === "escape") e.preventDefault();
        this.isSelected = e.action === "escape" ? false : this.isSelected;
        switch(e.action){
            case "down":
            case "up":
                this.isUpDownKey = true;
                this.updateUpDownAction(e);
                break;
            case "tab":
                if (this.isPopupOpen) {
                    e.preventDefault();
                    var li = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                    if (li) this.setSelection(li, e);
                    if (this.isPopupOpen) this.hidePopup(e);
                }
                break;
            case "enter":
                if (this.isPopupOpen) {
                    e.preventDefault();
                    if (this.popupObj && this.popupObj.element.contains(this.selectedLI)) this.updateSelectedItem(this.selectedLI, e, false, true);
                }
                break;
            case "escape":
                if (this.isPopupOpen) this.hidePopup(e);
                break;
        }
    };
    Mention.prototype.updateUpDownAction = function(e) {
        if (this.fields.disabled && this.list && this.list.querySelectorAll(".e-list-item:not(.e-disabled)").length === 0) return;
        var focusEle = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (this.isSelectFocusItem(focusEle)) this.setSelection(focusEle, e);
        else if (!(0, $3EnZW.isNullOrUndefined)(this.liCollections)) {
            var li = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
            if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                var value = this.getFormattedValue(li.getAttribute("data-value"));
                this.activeIndex = this.getIndexByValue(value);
            }
            var index = e.action === "down" ? this.activeIndex + 1 : this.activeIndex - 1;
            var startIndex = 0;
            startIndex = e.action === "down" && (0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? 0 : this.liCollections.length - 1;
            index = index < 0 ? this.liCollections.length - 1 : index === this.liCollections.length ? 0 : index;
            var nextItem = (0, $3EnZW.isNullOrUndefined)(this.activeIndex) ? this.liCollections[startIndex] : this.liCollections[index];
            if (!(0, $3EnZW.isNullOrUndefined)(nextItem)) this.setSelection(nextItem, e);
        }
        var itemIndex;
        for(var index = 0; index < this.liCollections.length; index++)if (this.liCollections[index].classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus) || this.liCollections[index].classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected)) {
            itemIndex = index;
            break;
        }
        if (itemIndex != null && this.isDisabledElement(this.liCollections[itemIndex])) this.updateUpDownAction(e);
        if (this.isPopupOpen) e.preventDefault();
    };
    Mention.prototype.isSelectFocusItem = function(element) {
        return !(0, $3EnZW.isNullOrUndefined)(element);
    };
    Mention.prototype.unBindCommonEvent = function() {
        if (!(0, $5q7BP.Browser).isDevice) this.inputElement.removeEventListener("keydown", this.keyDownHandler.bind(this), !this.isRTE);
    };
    Mention.prototype.onKeyUp = function(e) {
        var rangetextContent;
        if (this.isUpDownKey && this.isPopupOpen && e.keyCode === 229) {
            this.isUpDownKey = false;
            return;
        }
        this.isTyped = e.code !== "Enter" && e.code !== "Space" && e.code !== "ArrowDown" && e.code !== "ArrowUp" ? true : false;
        var isRteImage = document.activeElement.parentElement && document.activeElement.parentElement.querySelector(".e-rte-image") ? true : false;
        if (document.activeElement !== this.inputElement && !isRteImage) this.inputElement.focus();
        if (this.isContentEditable(this.inputElement)) {
            this.range = this.getCurrentRange();
            rangetextContent = this.range.startContainer.textContent.split("");
        }
        var currentRange = this.getTextRange();
        var lastWordRange = this.getLastLetter(currentRange);
        var lastTwoLetters = this.mentionChar.toString() + this.mentionChar.toString();
        // eslint-disable-next-line security/detect-non-literal-regexp
        var Regex = new RegExp(this.mentionChar.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g");
        var charRegex = new RegExp("[a-zA-Z]", "g");
        if (e.key === "Shift" || e.keyCode === 37 || e.keyCode === 39) return;
        if (this.beforePopupOpen && this.isPopupOpen && lastWordRange === lastTwoLetters) {
            this.hidePopup();
            return;
        }
        if (!currentRange || !lastWordRange || e.code === "Enter" || e.keyCode === 27 || lastWordRange.match(Regex) && lastWordRange.match(Regex).length > 1 || this.isContentEditable(this.inputElement) && this.range.startContainer && this.range.startContainer.previousElementSibling && this.range.startContainer.previousElementSibling.tagName !== "BR" && this.range.startContainer.textContent.split("").length > 0 && (rangetextContent.length === 1 || rangetextContent[rangetextContent.length - 2].indexOf("") === -1 || this.range.startContainer.nodeType === 1)) {
            if (this.isPopupOpen && this.allowSpaces && currentRange && currentRange.trim() !== "" && charRegex.test(currentRange) && currentRange.indexOf(this.mentionChar) !== -1 && !this.isMatchedText() && currentRange.length > 1 && currentRange.replace(/\u00A0/g, " ").charAt(currentRange.length - 2) !== " " && this.list && this.list.querySelectorAll("ul").length > 0 && e.code !== "Enter") {
                this.queryString = currentRange.substring(currentRange.lastIndexOf(this.mentionChar) + 1).replace("\xa0", " ");
                this.searchLists(e);
            } else if (this.isPopupOpen && (!this.allowSpaces || !lastWordRange) && e.code !== "ArrowDown" && e.code !== "ArrowUp") {
                this.hidePopup();
                this.lineBreak = true;
            }
            return;
        }
        if (lastWordRange.includes(this.mentionChar)) this.queryString = lastWordRange.replace(this.mentionChar, "");
        if (this.mentionChar.charCodeAt(0) === lastWordRange.charCodeAt(0) && this.queryString !== "" && e.keyCode !== 38 && e.keyCode !== 40 && !this.lineBreak) {
            this.searchLists(e);
            if (!this.isPopupOpen && this.queryString.length >= this.minLength) {
                if (!this.isContentEditable(this.inputElement)) this.showPopup();
                else if (this.isContentEditable(this.inputElement) && this.range && this.range.startContainer !== this.inputElement && e.keyCode !== 9) this.showPopup();
            }
        } else if (lastWordRange.indexOf(this.mentionChar) === 0 && !this.isPopupOpen && e.keyCode !== 8 && (!this.popupObj || (0, $3EnZW.isNullOrUndefined)(this.target) && !document.body.contains(this.popupObj.element) || !(0, $3EnZW.isNullOrUndefined)(this.target) && document.body.contains(this.popupObj.element))) {
            if (this.initRemoteRender && this.list && this.list.classList.contains("e-nodata")) this.searchLists(e);
            this.resetList(this.dataSource, this.fields);
            if ((0, $3EnZW.isNullOrUndefined)(this.list)) this.initValue();
            if (!this.isPopupOpen && e.keyCode !== 38 && e.keyCode !== 40 && this.queryString.length >= this.minLength) {
                this.didPopupOpenByTypingInitialChar = true;
                this.showPopup();
                if (this.initRemoteRender && this.list.querySelectorAll("li").length === 0) this.showWaitingSpinner();
                this.lineBreak = false;
            }
        } else if (this.allowSpaces && this.queryString !== "" && currentRange && currentRange.trim() !== "" && currentRange.replace("\xa0", " ").lastIndexOf(" ") < currentRange.length - 1 && e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 8 && (this.mentionChar.charCodeAt(0) === lastWordRange.charCodeAt(0) || this.liCollections && this.liCollections.length > 0)) {
            this.queryString = currentRange.substring(currentRange.lastIndexOf(this.mentionChar) + 1).replace("\xa0", " ");
            this.searchLists(e);
        } else if (this.queryString === "" && this.isPopupOpen && e.keyCode !== 38 && e.keyCode !== 40 && this.mentionChar.charCodeAt(0) === lastWordRange.charCodeAt(0)) {
            this.searchLists(e);
            if (!this.isListResetted) this.resetList(this.dataSource, this.fields);
        }
        this.isListResetted = false;
    };
    Mention.prototype.isMatchedText = function() {
        var isMatched = false;
        for(var i = 0; i < (this.liCollections && this.liCollections.length); i++)if (this.getTextRange() && this.getTextRange().substring(this.getTextRange().lastIndexOf(this.mentionChar) + 1).replace("\xa0", " ").trim() === this.liCollections[i].getAttribute("data-value").toLowerCase()) isMatched = true;
        return isMatched;
    };
    Mention.prototype.getCurrentRange = function() {
        this.range = this.inputElement.ownerDocument.getSelection().getRangeAt(0);
        return this.range;
    };
    Mention.prototype.searchLists = function(e) {
        var _this = this;
        this.isDataFetched = false;
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) {
            _super.prototype.render.call(this);
            this.unWireListEvents();
            this.wireListEvents();
        }
        if (e.type !== "mousedown" && (e.keyCode === 40 || e.keyCode === 38)) {
            this.queryString = this.queryString === "" ? null : this.queryString;
            this.beforePopupOpen = true;
            this.resetList(this.dataSource, this.fields);
            return;
        }
        this.isSelected = false;
        this.activeIndex = null;
        var eventArgs = {
            preventDefaultAction: false,
            text: this.queryString,
            updateData: function(dataSource, query, fields) {
                if (eventArgs.cancel) return;
                _this.isFiltered = true;
                _this.filterAction(dataSource, query, fields);
            },
            cancel: false
        };
        this.trigger("filtering", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel && !_this.isFiltered && !eventArgs.preventDefaultAction) _this.filterAction(_this.dataSource, null, _this.fields);
        });
    };
    Mention.prototype.filterAction = function(dataSource, query, fields) {
        this.beforePopupOpen = true;
        if (this.queryString.length >= this.minLength) {
            this.resetList(dataSource, fields, query);
            this.isListResetted = true;
        } else {
            if (this.isPopupOpen) this.hidePopup();
            this.beforePopupOpen = false;
        }
        this.setDataIndex();
        this.renderReactTemplates();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mention.prototype.onActionComplete = function(ulElement, list, e, isUpdated) {
        _super.prototype.onActionComplete.call(this, ulElement, list, e);
        if (this.isActive) {
            if (!(0, $3EnZW.isNullOrUndefined)(ulElement)) {
                (0, $4ZDHT.attributes)(ulElement, {
                    "id": this.inputElement.id + "_options",
                    "role": "listbox",
                    "aria-hidden": "false"
                });
                var isRTESlashMenuPopup = this.isRTE && this.cssClass && this.cssClass.indexOf("e-slash-menu") > -1;
                if (isRTESlashMenuPopup) ulElement.id = this.inputElement.id + "_slash_menu_options";
            }
            var focusItem = this.fields.disabled ? ulElement.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li + ":not(.e-disabled)") : ulElement.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
            if (focusItem) {
                focusItem.classList.add((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                this.selectedLI = focusItem;
                var value = this.getFormattedValue(focusItem.getAttribute("data-value"));
                this.selectEventCallback(focusItem, this.getDataByValue(value), value, true);
            }
            if (this.beforePopupOpen && this.isPopupOpen) {
                if (!(0, $3EnZW.isNullOrUndefined)(this.popupObj.element)) this.popupObj.element.remove();
                this.renderPopup();
            }
        }
    };
    Mention.prototype.setDataIndex = function() {
        for(var i = 0; this.liCollections && i < this.liCollections.length; i++)this.liCollections[i].setAttribute("data-index", i.toString());
    };
    Mention.prototype.listOption = function(dataSource, fieldsSettings) {
        var _this = this;
        var fields = _super.prototype.listOption.call(this, dataSource, fieldsSettings);
        if ((0, $3EnZW.isNullOrUndefined)(fields.itemCreated)) fields.itemCreated = function(e) {
            if (_this.highlight) {
                if (_this.inputElement.tagName === _this.getNgDirective() && _this.itemTemplate) setTimeout(function() {
                    (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this.queryString, _this.ignoreCase, _this.filterType);
                }, 0);
                else (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this.queryString, _this.ignoreCase, _this.filterType);
            }
        };
        else {
            var itemCreated_1 = fields.itemCreated;
            fields.itemCreated = function(e) {
                if (_this.highlight) (0, $faaab5eef2504967$export$9183789c55011a91)(e.item, _this.queryString, _this.ignoreCase, _this.filterType);
                itemCreated_1.apply(_this, [
                    e
                ]);
            };
        }
        return fields;
    };
    Mention.prototype.elementValue = function() {
        if (!this.isContentEditable(this.inputElement)) return this.inputElement.value.replace(this.mentionChar, "");
        else return this.inputElement.textContent.replace(this.mentionChar, "");
    };
    Mention.prototype.getQuery = function(query) {
        var filterQuery = query ? query.clone() : this.query ? this.query.clone() : new (0, $56262f229d1cff45$export$62297b13309008b2)();
        var filterType = this.queryString === "" && !(0, $3EnZW.isNullOrUndefined)(this.elementValue()) ? "equal" : this.filterType;
        var queryString = this.queryString === "" && !(0, $3EnZW.isNullOrUndefined)(this.elementValue()) ? this.elementValue() : this.queryString;
        if (this.isFiltered) return filterQuery;
        if (this.queryString !== null && this.queryString !== "") {
            var dataType = this.typeOfData(this.dataSource).typeof;
            if (!(this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) && dataType === "string" || dataType === "number") filterQuery.where("", filterType, queryString, this.ignoreCase, this.ignoreAccent);
            else {
                var mapping = !(0, $3EnZW.isNullOrUndefined)(this.fields.text) ? this.fields.text : "";
                filterQuery.where(mapping, filterType, queryString, this.ignoreCase, this.ignoreAccent);
            }
        }
        if (!(0, $3EnZW.isNullOrUndefined)(this.suggestionCount)) {
            // Since defualt value of suggestioncount is 25, checked the condition
            if (this.suggestionCount !== 25) {
                for(var queryElements = 0; queryElements < filterQuery.queries.length; queryElements++)if (filterQuery.queries[queryElements].fn === "onTake") filterQuery.queries.splice(queryElements, 1);
            }
            filterQuery.take(this.suggestionCount);
        }
        return filterQuery;
    };
    Mention.prototype.renderHightSearch = function() {
        if (this.highlight) for(var i = 0; i < this.liCollections.length; i++){
            var isHighlight = this.ulElement.querySelector(".e-active");
            if (!isHighlight) {
                (0, $faaab5eef2504967$export$97545a2550156b83)(this.liCollections[i]);
                (0, $faaab5eef2504967$export$9183789c55011a91)(this.liCollections[i], this.queryString, this.ignoreCase, this.filterType);
            }
        }
    };
    Mention.prototype.getTextRange = function() {
        var text;
        if (!this.isContentEditable(this.inputElement)) {
            var component = this.inputElement;
            if (!(0, $3EnZW.isNullOrUndefined)(component)) {
                var startPos = component.selectionStart;
                if (component.value && startPos >= 0) text = component.value.substring(0, startPos);
            }
        } else if (this.range) {
            var selectedElem = this.range.startContainer;
            if (!(0, $3EnZW.isNullOrUndefined)(selectedElem)) {
                var workingNodeContent = selectedElem.textContent;
                var selectStartOffset = this.range.startOffset;
                if (workingNodeContent && selectStartOffset >= 0) text = workingNodeContent.substring(0, selectStartOffset);
            }
        }
        return text;
    };
    Mention.prototype.getLastLetter = function(text) {
        if ((0, $3EnZW.isNullOrUndefined)(text)) return "";
        var textValue = text.indexOf("\u200B") > -1 ? text.replace(/\u200B/g, "").replace(/\u00A0/g, " ") : text.replace(/\u00A0/g, " ");
        var words = textValue.split(/\s+/);
        var wordCnt = words.length - 1;
        return words[wordCnt].trim();
    };
    Mention.prototype.isContentEditable = function(element) {
        return element && element.nodeName !== "INPUT" && element.nodeName !== "TEXTAREA";
    };
    /**
     * Opens the popup that displays the list of items.
     *
     * @returns {void}
     */ Mention.prototype.showPopup = function() {
        this.beforePopupOpen = true;
        if (document.activeElement !== this.inputElement) this.inputElement.focus();
        this.queryString = this.didPopupOpenByTypingInitialChar ? this.queryString : "";
        this.didPopupOpenByTypingInitialChar = false;
        if (this.isContentEditable(this.inputElement)) this.range = this.getCurrentRange();
        if (!this.isTyped) this.resetList(this.dataSource, this.fields);
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) this.initValue();
        this.renderPopup();
        (0, $4ZDHT.attributes)(this.inputElement, {
            "aria-activedescendant": this.selectedElementID
        });
        if (this.selectedElementID == null) this.inputElement.removeAttribute("aria-activedescendant");
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */ /**
     * Hides the popup if it is in an open state.
     *
     * @returns {void}
     */ Mention.prototype.hidePopup = function(e) {
        this.removeSelection();
        this.closePopup(0, e);
    };
    Mention.prototype.closePopup = function(delay, e) {
        var _this = this;
        if (!(this.popupObj && document.body.contains(this.popupObj.element) && this.beforePopupOpen)) return;
        (0, $aqzbR.EventHandler).remove(document, "mousedown", this.onDocumentClick);
        this.inputElement.removeAttribute("aria-owns");
        this.inputElement.removeAttribute("aria-activedescendant");
        this.beforePopupOpen = false;
        var animModel = {
            name: "FadeOut",
            duration: 100,
            delay: delay ? delay : 0
        };
        var popupInstance = this.popupObj;
        var eventArgs = {
            popup: popupInstance,
            cancel: false,
            animation: animModel,
            event: e || null
        };
        this.trigger("closed", eventArgs, function(eventArgs) {
            if (!eventArgs.cancel && _this.popupObj) {
                if (_this.isPopupOpen) _this.popupObj.hide(new (0, $kj1BR.Animation)(eventArgs.animation));
                else _this.destroyPopup();
            }
        });
    };
    Mention.prototype.renderPopup = function() {
        var _this = this;
        var args = {
            cancel: false
        };
        this.trigger("beforeOpen", args, function(args) {
            if (!args.cancel) {
                var popupEle_1;
                if ((0, $3EnZW.isNullOrUndefined)(_this.target)) popupEle_1 = _this.createElement("div", {
                    id: _this.inputElement.id + "_popup",
                    className: "e-mention e-popup " + (_this.cssClass != null ? _this.cssClass : "")
                });
                else {
                    popupEle_1 = _this.element;
                    if (_this.cssClass != null) (0, $4ZDHT.addClass)([
                        popupEle_1
                    ], _this.cssClass.split(" "));
                }
                var isRTESlashMenuPopup = _this.isRTE && _this.cssClass && _this.cssClass.indexOf("e-slash-menu") > -1;
                if (isRTESlashMenuPopup) popupEle_1.id = _this.inputElement.id + "_slash_menu_popup";
                else if (!(0, $3EnZW.isNullOrUndefined)(_this.target)) popupEle_1.id = _this.inputElement.id + "_popup";
                _this.listHeight = (0, $3EnZW.formatUnit)(_this.popupHeight);
                if (!(0, $3EnZW.isNullOrUndefined)(_this.list.querySelector("li")) && !_this.initRemoteRender) {
                    var li = _this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
                    if (!(0, $3EnZW.isNullOrUndefined)(li)) {
                        _this.selectedLI = li;
                        var value = _this.getFormattedValue(li.getAttribute("data-value"));
                        _this.selectEventCallback(li, _this.getDataByValue(value), value, true);
                    }
                }
                (0, $4ZDHT.append)([
                    _this.list
                ], popupEle_1);
                if (_this.inputElement.parentElement) {
                    var rteRootElement = _this.inputElement.parentElement.closest(".e-richtexteditor");
                    if (rteRootElement && popupEle_1.firstElementChild && popupEle_1.firstElementChild.childElementCount > 0) {
                        popupEle_1.firstElementChild.setAttribute("aria-owns", rteRootElement.id);
                        (0, $4ZDHT.addClass)([
                            popupEle_1
                        ], "e-rte-elements");
                    }
                }
                if (!_this.popupObj || !document.body.contains(_this.popupObj.element) || !document.contains(popupEle_1) && (0, $3EnZW.isNullOrUndefined)(_this.target)) document.body.appendChild(popupEle_1);
                var coordinates_1;
                popupEle_1.style.visibility = "hidden";
                _this.setHeight(popupEle_1);
                var offsetValue = 0;
                var left = 0;
                _this.initializePopup(popupEle_1, offsetValue, left);
                _this.checkCollision(popupEle_1);
                popupEle_1.style.visibility = "visible";
                var popupLeft_1 = popupEle_1.parentElement.offsetWidth - popupEle_1.offsetWidth;
                var popupHeight_1 = popupEle_1.offsetHeight;
                (0, $4ZDHT.addClass)([
                    popupEle_1
                ], [
                    "e-mention",
                    "e-popup",
                    "e-popup-close"
                ]);
                if (!(0, $3EnZW.isNullOrUndefined)(_this.list)) {
                    _this.unWireListEvents();
                    _this.wireListEvents();
                }
                _this.selectedElementID = _this.selectedLI ? _this.selectedLI.id : null;
                (0, $4ZDHT.attributes)(_this.inputElement, {
                    "aria-owns": _this.inputElement.id + "_options",
                    "aria-activedescendant": _this.selectedElementID
                });
                if (_this.selectedElementID == null) _this.inputElement.removeAttribute("aria-activedescendant");
                var animModel = {
                    name: "FadeIn",
                    duration: 100
                };
                _this.beforePopupOpen = true;
                var popupInstance = _this.popupObj;
                var eventArgs = {
                    popup: popupInstance,
                    cancel: false,
                    animation: animModel
                };
                _this.trigger("opened", eventArgs, function(eventArgs) {
                    if (!eventArgs.cancel) {
                        _this.renderReactTemplates();
                        if (_this.popupObj) _this.popupObj.show(new (0, $kj1BR.Animation)(eventArgs.animation), _this.zIndex === 1000 ? _this.inputElement : null);
                        if ((0, $3EnZW.isNullOrUndefined)(_this.getTriggerCharPosition())) return;
                        coordinates_1 = _this.getCoordinates(_this.inputElement, _this.getTriggerCharPosition());
                        if (!_this.isCollided) popupEle_1.style.cssText = "top: ".concat(coordinates_1.top.toString(), "px;\n left: ").concat(coordinates_1.left.toString(), "px;\nposition: absolute;\n display: block;");
                        else {
                            if (_this.collision.length > 0 && _this.collision.indexOf("right") > -1 && _this.collision.indexOf("bottom") === -1) popupEle_1.style.cssText = "top: ".concat(coordinates_1.top.toString(), "px;\n left: ").concat(popupLeft_1.toString(), "px;\nposition: absolute;\n display: block;");
                            else if (_this.collision && _this.collision.length > 0 && _this.collision.indexOf("bottom") > -1 && _this.collision.indexOf("right") === -1) {
                                popupEle_1.style.left = (0, $3EnZW.formatUnit)(coordinates_1.left);
                                popupEle_1.style.top = (0, $3EnZW.formatUnit)(coordinates_1.top - parseInt(popupHeight_1.toString(), 10));
                            } else if (_this.collision && _this.collision.length > 0 && _this.collision.indexOf("bottom") > -1 && _this.collision.indexOf("right") > -1) {
                                popupEle_1.style.left = (0, $3EnZW.formatUnit)(popupLeft_1);
                                popupEle_1.style.top = (0, $3EnZW.formatUnit)(coordinates_1.top - parseInt(popupHeight_1.toString(), 10));
                            } else {
                                popupEle_1.style.left = (0, $3EnZW.formatUnit)(coordinates_1.left);
                                popupEle_1.style.top = (0, $3EnZW.formatUnit)(coordinates_1.top - parseInt(_this.popupHeight.toString(), 10));
                            }
                            _this.isCollided = false;
                            _this.collision = [];
                        }
                        popupEle_1.style.width = _this.popupWidth !== "100%" && !(0, $3EnZW.isNullOrUndefined)(_this.popupWidth) ? (0, $3EnZW.formatUnit)(_this.popupWidth) : "auto";
                        _this.setHeight(popupEle_1);
                        popupEle_1.style.zIndex = _this.zIndex === 1000 ? (0, $2vAqh.getZindexPartial)(popupEle_1).toString() : _this.zIndex.toString();
                    } else {
                        _this.beforePopupOpen = false;
                        _this.destroyPopup();
                    }
                });
            } else _this.beforePopupOpen = false;
        });
    };
    Mention.prototype.setHeight = function(popupEle) {
        if (this.popupHeight !== "auto" && this.list) {
            this.list.style.maxHeight = (parseInt(this.listHeight, 10) - 2).toString() + "px"; // due to box-sizing property
            popupEle.style.maxHeight = (0, $3EnZW.formatUnit)(this.popupHeight);
        } else popupEle.style.height = "auto";
    };
    Mention.prototype.checkCollision = function(popupEle) {
        if (!(0, $5q7BP.Browser).isDevice || (0, $5q7BP.Browser).isDevice && !(this.getModuleName() === "mention")) {
            var coordinates = this.getCoordinates(this.inputElement, this.getTriggerCharPosition());
            this.collision = (0, $49u5W.isCollide)(popupEle, null, coordinates.left, coordinates.top);
            if (this.collision.length > 0) {
                popupEle.style.marginTop = -parseInt(getComputedStyle(popupEle).marginTop, 10) + "px";
                this.isCollided = true;
            }
            this.popupObj.resolveCollision();
        }
    };
    Mention.prototype.getTriggerCharPosition = function() {
        var mostRecentTriggerCharPos;
        var currentRange = this.getTextRange();
        if (currentRange !== undefined && currentRange !== null) {
            mostRecentTriggerCharPos = 0;
            var idx = currentRange.lastIndexOf(this.mentionChar);
            if (idx >= mostRecentTriggerCharPos) mostRecentTriggerCharPos = idx;
        }
        return mostRecentTriggerCharPos ? mostRecentTriggerCharPos : 0;
    };
    Mention.prototype.initializePopup = function(element, offsetValue, left) {
        var _this = this;
        this.popupObj = new (0, $2vAqh.Popup)(element, {
            width: this.setWidth(),
            targetType: "relative",
            relateTo: this.inputElement,
            collision: {
                X: "flip",
                Y: "flip"
            },
            offsetY: offsetValue,
            enableRtl: this.enableRtl,
            offsetX: left,
            position: {
                X: "left",
                Y: "bottom"
            },
            actionOnScroll: "hide",
            zIndex: this.zIndex,
            close: function() {
                _this.destroyPopup();
            },
            open: function() {
                (0, $aqzbR.EventHandler).add(document, "mousedown", _this.onDocumentClick, _this);
                _this.isPopupOpen = true;
                _this.setDataIndex();
            }
        });
    };
    Mention.prototype.setWidth = function() {
        var width = (0, $3EnZW.formatUnit)(this.popupWidth);
        if (width.indexOf("%") > -1) {
            var inputWidth = this.inputElement.offsetWidth * parseFloat(width) / 100;
            width = inputWidth.toString() + "px";
        }
        return width;
    };
    Mention.prototype.destroyPopup = function() {
        this.isPopupOpen = false;
        this.popupObj.destroy();
        if ((0, $3EnZW.isNullOrUndefined)(this.target)) (0, $4ZDHT.detach)(this.popupObj.element);
        else {
            this.popupObj.element.innerHTML = "";
            this.popupObj.element.removeAttribute("style");
            this.popupObj.element.removeAttribute("aria-disabled");
        }
        if (this.list.classList.contains("e-nodata")) this.list = null;
    };
    Mention.prototype.onDocumentClick = function(e) {
        var target = e.target;
        if (!(!(0, $3EnZW.isNullOrUndefined)(this.popupObj) && (0, $4ZDHT.closest)(target, "#" + this.popupObj.element.id))) this.hidePopup(e);
    };
    Mention.prototype.getCoordinates = function(element, position) {
        var properties = [
            "direction",
            "boxSizing",
            "width",
            "height",
            "overflowX",
            "overflowY",
            "borderTopWidth",
            "borderRightWidth",
            "borderBottomWidth",
            "borderLeftWidth",
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
            "fontStyle",
            "fontVariant",
            "fontWeight",
            "fontStretch",
            "fontSize",
            "fontSizeAdjust",
            "lineHeight",
            "fontFamily",
            "textAlign",
            "textTransform",
            "textIndent",
            "textDecoration",
            "letterSpacing",
            "wordSpacing"
        ];
        var div;
        var span;
        var range;
        var globalRange;
        var coordinates;
        var computed;
        var rect;
        if (!this.isContentEditable(this.inputElement)) {
            div = this.createElement("div", {
                className: "e-form-mirror-div"
            });
            document.body.appendChild(div);
            computed = getComputedStyle(element);
            div.style.position = "absolute";
            div.style.visibility = "hidden";
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            properties.forEach(function(prop) {
                // eslint-disable-next-line security/detect-object-injection
                div.style[prop] = computed[prop];
            });
            div.textContent = element.value.substring(0, position);
            if (this.inputElement.nodeName === "INPUT") div.textContent = div.textContent.replace(/\s/g, "\xa0");
            span = this.createElement("span");
            span.textContent = element.value.substring(position) || ".";
            div.appendChild(span);
            rect = element.getBoundingClientRect();
        } else {
            var selectedNodePosition = this.getTriggerCharPosition();
            globalRange = this.range;
            range = document.createRange();
            if (this.getTextRange() && this.getTextRange().lastIndexOf(this.mentionChar) !== -1) {
                range.setStart(globalRange.startContainer, selectedNodePosition);
                range.setEnd(globalRange.startContainer, selectedNodePosition);
            } else {
                range.setStart(globalRange.startContainer, globalRange.startOffset);
                range.setEnd(globalRange.startContainer, globalRange.endOffset);
            }
            this.isTyped = false;
            range.collapse(false);
            rect = range.getBoundingClientRect().top === 0 ? range.startContainer.getClientRects()[0] : range.getBoundingClientRect();
        }
        var rectTop = rect.top;
        var rectLeft = rect.left;
        var iframes = document.querySelectorAll("iframe");
        if (iframes.length > 0) for(var i = 0; i < iframes.length; i++){
            // eslint-disable-next-line security/detect-object-injection
            var iframe = iframes[i];
            if (iframe.contentDocument && iframe.contentDocument.contains(element)) {
                var iframeRect = iframe.getBoundingClientRect();
                rectTop += iframeRect.top;
                rectLeft += iframeRect.left;
            }
        }
        var doc = document.documentElement;
        var windowLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        var windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        var width = 0;
        if (!(0, $3EnZW.isNullOrUndefined)(range) && range.getBoundingClientRect().top === 0) for(var i = 0; i < this.range.startContainer.childNodes.length; i++){
            if (this.range.startContainer.childNodes[i].nodeType !== Node.TEXT_NODE && this.range.startContainer.childNodes[i].textContent.trim() !== "") width += this.range.startContainer.childNodes[i].getClientRects()[0].width;
            else if (this.range.startContainer.childNodes[i].textContent !== "") {
                var span_1 = document.createElement("span");
                span_1.innerHTML = this.range.startContainer.childNodes[i].nodeValue;
                document.body.appendChild(span_1);
                var textNodeWidth = span_1.offsetWidth;
                document.body.removeChild(span_1);
                width += textNodeWidth;
            }
        }
        if (!this.isContentEditable(this.inputElement)) {
            coordinates = {
                top: rectTop + windowTop + span.offsetTop + parseInt(computed.borderTopWidth, 10) + parseInt(computed.fontSize, 10) + 3 - element.scrollTop - (this.isCollided ? 10 : 0),
                left: rectLeft + windowLeft + span.offsetLeft + parseInt(computed.borderLeftWidth, 10)
            };
            document.body.removeChild(div);
        } else if (this.collision && this.collision.length > 0 && this.collision.indexOf("right") > -1 && this.collision.indexOf("bottom") === -1) coordinates = {
            top: rectTop + windowTop + parseInt(getComputedStyle(this.inputElement).fontSize, 10),
            left: rectLeft + windowLeft + width
        };
        else coordinates = {
            top: rectTop + windowTop + parseInt(getComputedStyle(this.inputElement).fontSize, 10) - (this.isCollided ? 10 : 0),
            left: rectLeft + windowLeft + width
        };
        return coordinates;
    };
    Mention.prototype.initValue = function() {
        this.isDataFetched = false;
        this.renderList();
        if (this.dataSource instanceof (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)) this.initRemoteRender = true;
        else this.updateValues();
    };
    Mention.prototype.updateValues = function() {
        var li = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (!(0, $3EnZW.isNullOrUndefined)(li)) this.setSelection(li, null);
    };
    Mention.prototype.renderList = function() {
        _super.prototype.render.call(this);
        this.unWireListEvents();
        this.wireListEvents();
    };
    /**
     * Event binding for list
     *
     * @returns {void}
     */ Mention.prototype.wireListEvents = function() {
        (0, $aqzbR.EventHandler).add(this.list, this.keyEventName, this.onMouseClick, this);
        (0, $aqzbR.EventHandler).add(this.list, "mouseover", this.onMouseOver, this);
        (0, $aqzbR.EventHandler).add(this.list, "mouseout", this.onMouseLeave, this);
    };
    /**
     * Event un binding for list items.
     *
     * @returns {void}
     */ Mention.prototype.unWireListEvents = function() {
        (0, $aqzbR.EventHandler).remove(this.list, this.keyEventName, this.onMouseClick);
        (0, $aqzbR.EventHandler).remove(this.list, "mouseover", this.onMouseOver);
        (0, $aqzbR.EventHandler).remove(this.list, "mouseout", this.onMouseLeave);
    };
    Mention.prototype.onMouseClick = function(e) {
        var target = e.target;
        var li = (0, $4ZDHT.closest)(target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        if (!this.isValidLI(li) || this.isDisabledElement(li)) return;
        this.isSelected = true;
        this.setSelection(li, e);
        var delay = 100;
        this.closePopup(delay, e);
        this.inputElement.focus();
        if (!this.isRTE) e.preventDefault();
    };
    Mention.prototype.updateSelectedItem = function(li, e, preventSelect, isSelection) {
        var _this = this;
        this.removeSelection();
        li.classList.add((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
        this.removeHover();
        var value = this.getFormattedValue(li.getAttribute("data-value"));
        var selectedData = this.getDataByValue(value);
        if (!preventSelect && !(0, $3EnZW.isNullOrUndefined)(e) && !(e.action === "down" || e.action === "up")) {
            var items = this.detachChanges(selectedData);
            this.isSelected = true;
            var eventArgs = {
                e: e,
                item: li,
                itemData: items,
                isInteracted: e ? true : false,
                cancel: false
            };
            this.trigger("select", eventArgs, function(eventArgs) {
                if (eventArgs.cancel) {
                    li.classList.remove((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                    _this.isSelected = false;
                    _this.isSelectCancel = true;
                } else {
                    _this.selectEventCallback(li, selectedData, value);
                    if (isSelection) _this.setSelectOptions(li, e);
                }
            });
        } else {
            this.selectEventCallback(li, selectedData, value);
            if (isSelection) this.setSelectOptions(li, e);
        }
    };
    Mention.prototype.setSelection = function(li, e) {
        if (this.isValidLI(li) && (!li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected) || this.isPopupOpen && this.isSelected && li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected))) this.updateSelectedItem(li, e, false, true);
        else this.setSelectOptions(li, e);
    };
    Mention.prototype.setSelectOptions = function(li, e) {
        if (this.list) this.removeHover();
        this.previousSelectedLI = !(0, $3EnZW.isNullOrUndefined)(this.selectedLI) ? this.selectedLI : null;
        this.selectedLI = li;
        if (this.isPopupOpen && !(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) this.setScrollPosition(e);
        if (e && (e.keyCode === 38 || e.keyCode === 40)) return;
        if ((0, $3EnZW.isNullOrUndefined)(e) || this.setValue(e)) return;
    };
    Mention.prototype.setScrollPosition = function(e) {
        if (!(0, $3EnZW.isNullOrUndefined)(e)) switch(e.action){
            case "pageDown":
            case "down":
            case "end":
                this.scrollBottom();
                break;
            default:
                this.scrollTop();
                break;
        }
        else this.scrollBottom(true);
    };
    Mention.prototype.scrollBottom = function(isInitial) {
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) {
            var currentOffset = this.list.offsetHeight;
            var nextBottom = this.selectedLI.offsetTop + this.selectedLI.offsetHeight - this.list.scrollTop;
            var nextOffset = this.list.scrollTop + nextBottom - currentOffset;
            nextOffset = isInitial ? nextOffset + parseInt(getComputedStyle(this.list).paddingTop, 10) * 2 : nextOffset;
            var boxRange = this.selectedLI.offsetTop + this.selectedLI.offsetHeight - this.list.scrollTop;
            if (this.activeIndex === 0) this.list.scrollTop = 0;
            else if (nextBottom > currentOffset || !(boxRange > 0 && this.list.offsetHeight > boxRange)) this.list.scrollTop = nextOffset;
        }
    };
    Mention.prototype.scrollTop = function() {
        if (!(0, $3EnZW.isNullOrUndefined)(this.selectedLI)) {
            var nextOffset = this.selectedLI.offsetTop - this.list.scrollTop;
            nextOffset = this.fields.groupBy && nextOffset;
            var boxRange = this.selectedLI.offsetTop + this.selectedLI.offsetHeight - this.list.scrollTop;
            if (this.activeIndex === 0) this.list.scrollTop = 0;
            else if (nextOffset < 0) this.list.scrollTop = this.list.scrollTop + nextOffset;
            else if (!(boxRange > 0 && this.list.offsetHeight > boxRange)) this.list.scrollTop = this.selectedLI.offsetTop;
        }
    };
    Mention.prototype.selectEventCallback = function(li, selectedData, value, selectLi) {
        this.previousItemData = !(0, $3EnZW.isNullOrUndefined)(this.itemData) ? this.itemData : null;
        this.item = li;
        this.itemData = selectedData;
        var focusedItem = this.list.querySelector("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (focusedItem) (0, $4ZDHT.removeClass)([
            focusedItem
        ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).focus);
        if (selectLi) (0, $4ZDHT.addClass)([
            li
        ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
        li.setAttribute("aria-selected", "true");
        this.activeIndex = this.getIndexByValue(value);
    };
    Mention.prototype.detachChanges = function(value) {
        var items;
        if (typeof value === "string" || typeof value === "boolean" || typeof value === "number") items = Object.defineProperties({}, {
            value: {
                value: value,
                enumerable: true
            },
            text: {
                value: value,
                enumerable: true
            }
        });
        else items = value;
        return items;
    };
    Mention.prototype.setValue = function(e) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) {
            if (!(0, $3EnZW.isNullOrUndefined)(this.displayTemplate)) this.setDisplayTemplate();
            this.updateMentionValue(e);
            return true;
        } else {
            if (!(0, $3EnZW.isNullOrUndefined)(this.displayTemplate)) this.setDisplayTemplate(e);
            else this.updateMentionValue(e);
            return true;
        }
    };
    Mention.prototype.updateMentionValue = function(e) {
        var dataItem = this.getItemData();
        var textSuffix = typeof this.suffixText === "string" ? this.suffixText : "";
        var value;
        var endPos;
        var range;
        var globalRange;
        var selection = this.inputElement.ownerDocument.getSelection();
        var startPos = this.getTriggerCharPosition();
        if (this.isSelectCancel) {
            this.isSelectCancel = false;
            return;
        }
        if (dataItem.text !== null) value = this.mentionVal(dataItem.text);
        if (!this.isContentEditable(this.inputElement)) {
            var myField = this.inputElement;
            var currentTriggerSnippet = this.getTextRange().substring(startPos + this.mentionChar.length, this.getTextRange().length);
            value += textSuffix;
            endPos = startPos + this.mentionChar.length;
            endPos += currentTriggerSnippet.length;
            myField.value = myField.value.substring(0, startPos) + value + myField.value.substring(endPos, myField.value.length);
            myField.selectionStart = startPos + value.length;
            myField.selectionEnd = startPos + value.length;
            if (this.isPopupOpen) this.hidePopup();
            this.onChangeEvent(e);
        } else {
            endPos = this.getTriggerCharPosition() + this.mentionChar.length;
            if (this.range && this.range.startContainer.textContent.trim() !== this.mentionChar) endPos = this.range.endOffset;
            globalRange = this.range;
            range = document.createRange();
            if (this.getTextRange() && this.getTextRange().lastIndexOf(this.mentionChar) !== -1 || this.getTextRange() && this.getTextRange().trim() === this.mentionChar) {
                range.setStart(globalRange.startContainer, startPos);
                range.setEnd(globalRange.startContainer, endPos);
            } else if (globalRange.commonAncestorContainer.textContent.trim() !== "" && !(0, $3EnZW.isNullOrUndefined)(globalRange.commonAncestorContainer.textContent.trim()) && this.getTextRange() && this.getTextRange().lastIndexOf(this.mentionChar) !== -1) {
                range.setStart(globalRange.startContainer, globalRange.startOffset - 1);
                range.setEnd(globalRange.startContainer, globalRange.endOffset - 1);
            } else {
                range.setStart(globalRange.startContainer, globalRange.startOffset);
                range.setEnd(globalRange.startContainer, globalRange.endOffset);
            }
            this.isTyped = false;
            range.deleteContents();
            range.startContainer.parentElement.normalize();
            var element = this.createElement("div");
            element.innerHTML = value;
            var frag = document.createDocumentFragment();
            var node = void 0;
            var lastNode = void 0;
            // eslint-disable-next-line no-cond-assign
            while(node = element.firstChild)lastNode = frag.appendChild(node);
            range.insertNode(frag);
            if (lastNode) {
                range = range.cloneRange();
                if (this.isRTE) {
                    range.setStart(lastNode, 0);
                    range.setEnd(lastNode, lastNode.textContent.length);
                } else range.setStartAfter(lastNode);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            if (this.isPopupOpen) this.hidePopup();
            //New event to update the RichTextEditor value, when a mention item is selected using mouse click action.
            if (!(0, $3EnZW.isNullOrUndefined)(e.pointerType) && e.pointerType === "mouse") {
                var event_1 = new CustomEvent("content-changed", {
                    detail: {
                        click: true
                    }
                });
                this.inputElement.dispatchEvent(event_1);
            }
            this.onChangeEvent(e);
        }
    };
    Mention.prototype.mentionVal = function(value) {
        var showChar = this.showMentionChar ? this.mentionChar : "";
        if (!(0, $3EnZW.isNullOrUndefined)(this.displayTemplate) && !(0, $3EnZW.isNullOrUndefined)(this.displayTempElement)) value = this.displayTempElement.innerHTML;
        if (this.isContentEditable(this.inputElement)) {
            if ((0, $5q7BP.Browser).isAndroid) return '<span contenteditable="true" class="e-mention-chip">' + showChar + value + "</span>".concat(typeof this.suffixText === "string" ? this.suffixText : "&#8203;");
            else return '<span contenteditable="false" class="e-mention-chip">' + showChar + value + "</span>".concat(typeof this.suffixText === "string" ? this.suffixText : "&#8203;");
        } else return showChar + value;
    };
    Mention.prototype.setDisplayTemplate = function(e) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) {
            this.clearTemplate([
                "displayTemplate"
            ]);
            if (this.displayTempElement) {
                (0, $4ZDHT.detach)(this.displayTempElement);
                this.displayTempElement = null;
            }
        }
        if (!this.displayTempElement) this.displayTempElement = this.createElement("div");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) this.displayTempElement.innerHTML = "";
        var compiledString = (0, $c2qqN.compile)(this.displayTemplate);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var displayCompTemp = compiledString(this.itemData, this, "displayTemplate", this.displayTemplateId, this.isStringTemplate, null, this.displayTempElement);
        if (displayCompTemp && displayCompTemp.length > 0) (0, $4ZDHT.append)(displayCompTemp, this.displayTempElement);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) this.renderTemplates();
        else this.renderTemplates(function() {
            _this.updateMentionValue(e);
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Mention.prototype.renderTemplates = function(callBack) {
        this.renderReactTemplates(callBack);
    };
    Mention.prototype.setSpinnerTemplate = function() {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) {
            this.clearTemplate([
                "spinnerTemplate"
            ]);
            if (this.spinnerTemplateElement) {
                (0, $4ZDHT.detach)(this.spinnerTemplateElement);
                this.spinnerTemplateElement = null;
            }
        }
        if (!this.spinnerTemplateElement) this.spinnerTemplateElement = this.createElement("div");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) this.spinnerTemplateElement.innerHTML = "";
        var compiledString = (0, $c2qqN.compile)(this.spinnerTemplate);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var spinnerCompTemp = compiledString(null, this, "spinnerTemplate", this.spinnerTemplateId, this.isStringTemplate, null, this.spinnerTemplateElement);
        if (spinnerCompTemp && spinnerCompTemp.length > 0) for(var i = 0; i < spinnerCompTemp.length; i++)this.spinnerTemplateElement.appendChild(spinnerCompTemp[i]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!this.isReact) {
            this.renderTemplates();
            this.popupObj.element.appendChild(this.spinnerTemplateElement);
        } else this.renderTemplates(function() {
            _this.popupObj.element.appendChild(_this.spinnerTemplateElement);
        });
    };
    Mention.prototype.onChangeEvent = function(eve) {
        this.isSelected = false;
        var items = this.detachMentionChanges(this.itemData);
        var preItems;
        if (typeof this.previousItemData === "string" || typeof this.previousItemData === "boolean" || typeof this.previousItemData === "number") preItems = Object.defineProperties({}, {
            value: {
                value: this.previousItemData,
                enumerable: true
            },
            text: {
                value: this.previousItemData,
                enumerable: true
            }
        });
        else preItems = this.previousItemData;
        var eventArgs = {
            e: eve,
            item: this.item,
            itemData: items,
            previousItem: this.previousSelectedLI,
            previousItemData: preItems,
            isInteracted: eve ? true : false,
            value: this.item.innerHTML,
            element: this.inputElement
        };
        this.trigger("change", eventArgs);
    };
    Mention.prototype.detachMentionChanges = function(value) {
        var items;
        if (typeof value === "string" || typeof value === "boolean" || typeof value === "number") items = Object.defineProperties({}, {
            value: {
                value: value,
                enumerable: true
            },
            text: {
                value: value,
                enumerable: true
            }
        });
        else items = value;
        return items;
    };
    Mention.prototype.getItemData = function() {
        var fields = this.fields;
        var dataItem = null;
        dataItem = this.itemData;
        var dataValue;
        var dataText;
        if (!(0, $3EnZW.isNullOrUndefined)(dataItem)) {
            dataValue = (0, $3EnZW.getValue)(fields.value, dataItem);
            dataText = (0, $3EnZW.getValue)(fields.text, dataItem);
        }
        var value = !(0, $3EnZW.isNullOrUndefined)(dataItem) && !(0, $3EnZW.isUndefined)(dataValue) ? dataValue : dataItem;
        var text = !(0, $3EnZW.isNullOrUndefined)(dataItem) && !(0, $3EnZW.isUndefined)(dataValue) ? dataText : dataItem;
        return {
            value: value,
            text: text
        };
    };
    Mention.prototype.removeSelection = function() {
        if (this.list) {
            var selectedItems = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
            if (selectedItems.length) {
                (0, $4ZDHT.removeClass)(selectedItems, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).selected);
                selectedItems[0].removeAttribute("aria-selected");
            }
        }
    };
    Mention.prototype.onMouseOver = function(e) {
        var currentLi = (0, $4ZDHT.closest)(e.target, "." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).li);
        this.setHover(currentLi);
    };
    Mention.prototype.setHover = function(li) {
        if (this.isValidLI(li) && !li.classList.contains((0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover)) {
            this.removeHover();
            (0, $4ZDHT.addClass)([
                li
            ], (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        }
    };
    Mention.prototype.removeHover = function() {
        if (this.list) {
            var hoveredItem = this.list.querySelectorAll("." + (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
            if (hoveredItem && hoveredItem.length) (0, $4ZDHT.removeClass)(hoveredItem, (0, $8333a85b68b3ebf8$export$caaa541e4c87fe5d).hover);
        }
    };
    Mention.prototype.isValidLI = function(li) {
        return li && li.hasAttribute("role") && li.getAttribute("role") === "option";
    };
    Mention.prototype.onMouseLeave = function() {
        this.removeHover();
    };
    /**
     * Search the entered text and show it in the suggestion list if available.
     *
     * @returns {void}
     */ Mention.prototype.search = function(text, positionX, positionY) {
        if (this.isContentEditable(this.inputElement)) this.range = this.getCurrentRange();
        var currentRange = this.getTextRange();
        var lastWordRange = this.getLastLetter(currentRange);
        if (this.ignoreCase && (text === lastWordRange || text === lastWordRange.toLowerCase()) || !this.ignoreCase && text === lastWordRange) this.resetList(this.dataSource, this.fields);
        else {
            if (this.isPopupOpen) this.hidePopup();
            return;
        }
        if ((0, $3EnZW.isNullOrUndefined)(this.list)) {
            this.renderList();
            this.renderPopup();
        } else this.showPopup();
        this.popupObj.element.style.left = (0, $3EnZW.formatUnit)(positionX);
        this.popupObj.element.style.top = (0, $3EnZW.formatUnit)(positionY);
    };
    /**
     * Method to disable specific item in the popup.
     *
     * @param {string | number | object | HTMLLIElement} item - Specifies the item to be disabled.
     * @returns {void}

     */ Mention.prototype.disableItem = function(item) {
        if (this.fields.disabled) {
            if (!this.list) this.renderList();
            var itemIndex = -1;
            if (this.liCollections && this.liCollections.length > 0 && this.listData && this.fields.disabled) {
                if (typeof item === "string") itemIndex = this.getIndexByValue(item);
                else if (typeof item === "object") {
                    if (item instanceof HTMLLIElement) {
                        for(var index = 0; index < this.liCollections.length; index++)if (this.liCollections[index] === item) {
                            itemIndex = this.getIndexByValue(item.getAttribute("data-value"));
                            break;
                        }
                    } else {
                        var value = JSON.parse(JSON.stringify(item))[this.fields.value];
                        for(var index = 0; index < this.listData.length; index++)if (JSON.parse(JSON.stringify(this.listData[index]))[this.fields.value] === value) {
                            itemIndex = this.getIndexByValue(value);
                            break;
                        }
                    }
                } else itemIndex = item;
                var isValidIndex = itemIndex < this.liCollections.length && itemIndex > -1;
                if (isValidIndex && !JSON.parse(JSON.stringify(this.listData[itemIndex]))[this.fields.disabled]) {
                    var li = this.liCollections[itemIndex];
                    if (li) {
                        this.disableListItem(li);
                        var parsedData = JSON.parse(JSON.stringify(this.listData[itemIndex]));
                        parsedData[this.fields.disabled] = true;
                        this.listData[itemIndex] = parsedData;
                        this.dataSource = this.listData;
                    }
                }
            }
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */ Mention.prototype.destroy = function() {
        this.hidePopup();
        this.unWireEvent();
        if (this.list) this.unWireListEvents();
        if (this.inputElement && !this.inputElement.classList.contains("e-" + this.getModuleName())) return;
        this.previousSelectedLI = null;
        this.item = null;
        this.selectedLI = null;
        this.popupObj = null;
        _super.prototype.destroy.call(this);
    };
    Mention.prototype.getLocaleName = function() {
        return "mention";
    };
    Mention.prototype.getNgDirective = function() {
        return "EJS-MENTION";
    };
    /**
     * Return the module name of this component.
     *
     * @private
     * @returns {string} Return the module name of this component.
     */ Mention.prototype.getModuleName = function() {
        return "mention";
    };
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "cssClass", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("@")
    ], Mention.prototype, "mentionChar", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Mention.prototype, "showMentionChar", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Mention.prototype, "allowSpaces", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "suffixText", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(25)
    ], Mention.prototype, "suggestionCount", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(0)
    ], Mention.prototype, "minLength", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("None")
    ], Mention.prototype, "sortOrder", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(true)
    ], Mention.prototype, "ignoreCase", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(false)
    ], Mention.prototype, "highlight", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)()
    ], Mention.prototype, "locale", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("auto")
    ], Mention.prototype, "popupWidth", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("300px")
    ], Mention.prototype, "popupHeight", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "displayTemplate", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "itemTemplate", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("No records found")
    ], Mention.prototype, "noRecordsTemplate", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "spinnerTemplate", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)()
    ], Mention.prototype, "target", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)([])
    ], Mention.prototype, "dataSource", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)(null)
    ], Mention.prototype, "query", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Property)("Contains")
    ], Mention.prototype, "filterType", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Complex)({
            text: null,
            value: null,
            iconCss: null,
            groupBy: null
        }, (0, $8333a85b68b3ebf8$export$47acbd07e937cc3e))
    ], Mention.prototype, "fields", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "actionBegin", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "actionComplete", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "actionFailure", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "change", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "beforeOpen", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "opened", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "closed", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "select", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "filtering", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "created", void 0);
    $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.Event)()
    ], Mention.prototype, "destroyed", void 0);
    Mention = $3b677bffd4c0e837$var$__decorate([
        (0, $5rsSz.NotifyPropertyChanges)
    ], Mention);
    return Mention;
}((0, $8333a85b68b3ebf8$export$7dc99c6c1af7b42));




const $7e886d471b63e7e3$export$bba4a8b863f1eade = {
    Account: "Account",
    User: "User",
    Company: "CompanyView",
    Individual: "IndividualView",
    Service: "Service",
    Task: "Task"
};
const $7e886d471b63e7e3$export$9375978e33483629 = {
    DayMonthYear: "dd/MM/yy",
    Day: "d",
    DayOrdinal: "do",
    DayName: "EEEE",
    DayNameShort: "EEE",
    Month: "M",
    MonthName: "MMMM",
    MonthNameShort: "MMM",
    Year: "yyyy"
};
const $7e886d471b63e7e3$var$PlaceholderDateFormatType = "DayMonthYear";
const $7e886d471b63e7e3$export$d82b96e89413748e = [
    "{{",
    "}}"
];
const $7e886d471b63e7e3$export$8b2dcad0de2eb123 = new RegExp(`(${$7e886d471b63e7e3$export$d82b96e89413748e[0]}(${Object.keys($7e886d471b63e7e3$export$bba4a8b863f1eade).join("|")})\\.([^}]+)${$7e886d471b63e7e3$export$d82b96e89413748e[1]})`, "g");
const $7e886d471b63e7e3$export$c7446825a059cd3 = new RegExp(`<span[^>]*>${$7e886d471b63e7e3$export$8b2dcad0de2eb123.source}</span>`, "g");
const $7e886d471b63e7e3$var$prefix = (prefix, placeholders)=>{
    return placeholders.map((placeholder)=>({
            ...placeholder,
            name: `${prefix}.${placeholder.name}`
        }));
};
const $7e886d471b63e7e3$var$datePlaceholders = (base)=>[
        ...Object.keys($7e886d471b63e7e3$export$9375978e33483629).map((dateFormatType)=>({
                name: [
                    base.name,
                    ...dateFormatType !== $7e886d471b63e7e3$var$PlaceholderDateFormatType ? [
                        dateFormatType
                    ] : []
                ].join("."),
                column: base.column,
                dateFormat: $7e886d471b63e7e3$export$9375978e33483629[dateFormatType]
            }))
    ];
const $7e886d471b63e7e3$var$AccountPlaceholders = $7e886d471b63e7e3$var$prefix("Account", [
    {
        name: "Name",
        column: "name"
    },
    {
        name: "FromName",
        column: "emailFromName"
    },
    {
        name: "FromEmail",
        column: "emailFromEmail"
    }
]);
const $7e886d471b63e7e3$var$UserPlaceholders = $7e886d471b63e7e3$var$prefix("User", [
    {
        name: "FirstName",
        column: "firstName"
    },
    {
        name: "LastName",
        column: "lastName"
    },
    {
        name: "FullName",
        column: "name"
    },
    {
        name: "Email",
        column: "email"
    }
]);
const $7e886d471b63e7e3$var$CompanyPlaceholders = $7e886d471b63e7e3$var$prefix("Company", [
    {
        name: "Name",
        column: "name"
    },
    {
        name: "Type",
        column: "companyType"
    },
    {
        name: "RegistrationNumber",
        column: "registrationNumber"
    },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "IncorporationDate",
        column: "incorporationDate"
    }),
    // { name: 'YearEnd', column: 'yearEndDate' } ...datePlaceholders<>(),
    {
        name: "AuthenticationCode",
        column: "companiesHouseAuthenticationCode"
    },
    {
        name: "UTR",
        column: "utr"
    },
    {
        name: "Reference",
        column: "internalReference"
    },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "EngagementSigned",
        column: "engagementSignedDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "AMLLastChecked",
        column: "amlLastCheckedDate"
    }),
    // { name: 'AddressLine1', column: 'postalAddressLine_1' },
    // { name: 'AddressLine2', column: 'postalAddressLine_2' },
    // { name: 'AddressTown', column: 'postalAddressTown' },
    // { name: 'AddressCounty', column: 'postalAddressCounty' },
    // { name: 'AddressPostcode', column: 'postalAddressPostcode' },
    {
        name: "PrimaryContactFirstName",
        column: "principalContactFirstName"
    },
    {
        name: "PrimaryContactLastName",
        column: "principalContactLastName"
    },
    {
        name: "PrimaryContactEmail",
        column: "principalContactEmail"
    },
    {
        name: "PrimaryContactPhone",
        column: "contactTelephoneNumber"
    },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "AccountsLastMadeUpTo",
        column: "accountsLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "AccountsPeriodEnd",
        column: "accountsPeriodEndDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "AccountsDue",
        column: "accountsDueDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "ConfirmationStatementLastMadeUpTo",
        column: "confirmationStatementLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "ConfirmationStatementNextMadeUpTo",
        column: "confirmationStatementNextMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "ConfirmationStatementDue",
        column: "confirmationStatementDueDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxReturnLastMadeUpTo",
        column: "taxReturnLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxPeriodEnd",
        column: "taxPeriodEndDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxReturnDue",
        column: "taxReturnDueDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxPaymentLastMadeUpTo",
        column: "taxPaymentLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxPaymentDue",
        column: "taxPaymentDueDate"
    }),
    {
        name: "VATNumber",
        column: "vatHmrcRegistrationNumber"
    },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "VATRegistrationDate",
        column: "vatRegistrationDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "VATDeregistrationDate",
        column: "vatDeregistrationDate"
    }),
    // { name: 'VATQuarters', column: 'vatQuarters' },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "VATLastMadeUpTo",
        column: "vatLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "VATPeriodEnd",
        column: "vatPeriodEndDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "VATReturnDue",
        column: "vatReturnDueDate"
    }),
    {
        name: "PAYEReference",
        column: "payeReference"
    },
    {
        name: "PAYEAccountsOfficeReference",
        column: "payeAccountsOfficeReferenceNumber"
    },
    // { name: 'PayrollFrequency', column: 'payrollFrequency' },
    // { name: 'PayrollDay', column: 'payrollDay' },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "PayrollLastMadeUpTo",
        column: "payrollLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "PayrollDue",
        column: "payrollDueDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "PayrollPaymentDue",
        column: "payrollPaymentDueDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "CISLastMadeUpTo",
        column: "cisLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "CISPeriodEnd",
        column: "cisPeriodEndDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "CISReturnDue",
        column: "cisReturnDueDate"
    }),
    // { name: 'BookkeepingFrequency', column: 'bookkeepingFrequency' },
    // { name: 'BookkeepingDay', column: 'bookkeepingDay' },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "BookkeepingLastMadeUpTo",
        column: "bookkeepingLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "BookkeepingDue",
        column: "bookkeepingDueDate"
    })
]);
const $7e886d471b63e7e3$var$IndividualPlaceholders = $7e886d471b63e7e3$var$prefix("Individual", [
    {
        name: "FirstName",
        column: "givenName"
    },
    {
        name: "LastName",
        column: "surname"
    },
    {
        name: "FullName",
        column: "name"
    },
    {
        name: "UTR",
        column: "utr"
    },
    {
        name: "NI Number",
        column: "nationalInsuranceNumber"
    },
    {
        name: "Phone",
        column: "contactTelephoneNumber"
    },
    {
        name: "Email",
        column: "emailAddress"
    },
    // { name: 'Address', column: 'address' },
    // { name: 'Postcode', column: 'postcode' },
    // { name: 'Reference', column: 'internalReference' },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "EngagementSigned",
        column: "engagementSignedDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "AMLLastChecked",
        column: "amlLastCheckedDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxReturnLastMadeUpTo",
        column: "taxReturnLastMadeUpToDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxPeriodEnd",
        column: "taxReturnPeriodEndDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "TaxReturnDue",
        column: "taxReturnDueDate"
    })
]);
const $7e886d471b63e7e3$var$ServicePlaceholders = $7e886d471b63e7e3$var$prefix("Service", [
    {
        name: "Name",
        column: "name"
    }
]);
const $7e886d471b63e7e3$var$TaskPlaceholders = $7e886d471b63e7e3$var$prefix("Task", [
    {
        name: "Name",
        column: "task"
    },
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "Due",
        column: "deadlineDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "PlannedStart",
        column: "plannedStartDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "PlannedCompletion",
        column: "plannedCompletionDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "Started",
        column: "startedDate"
    }),
    ...$7e886d471b63e7e3$var$datePlaceholders({
        name: "Completed",
        column: "completedDate"
    })
]);
const $7e886d471b63e7e3$var$Placeholders = [
    ...$7e886d471b63e7e3$var$AccountPlaceholders,
    ...$7e886d471b63e7e3$var$UserPlaceholders,
    ...$7e886d471b63e7e3$var$CompanyPlaceholders,
    ...$7e886d471b63e7e3$var$IndividualPlaceholders,
    ...$7e886d471b63e7e3$var$ServicePlaceholders,
    ...$7e886d471b63e7e3$var$TaskPlaceholders
];
const $7e886d471b63e7e3$export$5d506100e1bc0b87 = $7e886d471b63e7e3$var$Placeholders.map((placeholder)=>({
        [placeholder.name]: placeholder
    })).reduce((0, $81088ee9a0e19312$export$4950aa0f605343fb));
const $7e886d471b63e7e3$export$cd5b765605c743ed = (prefixes, clientType)=>{
    return $7e886d471b63e7e3$var$Placeholders.filter((placeholder)=>prefixes.some((prefix)=>placeholder.name.startsWith(`${prefix}.`)) && (clientType === undefined || clientType === (0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Company && !placeholder.name.startsWith("Individual.") || clientType === (0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Individual && !placeholder.name.startsWith("Company.")));
};
const $7e886d471b63e7e3$export$65355a49b9c55d11 = (content)=>content ? content.replaceAll($7e886d471b63e7e3$export$8b2dcad0de2eb123, '<span contenteditable="false" class="e-mention-chip">$1</span>') : content;
const $7e886d471b63e7e3$export$1e373cac552fad58 = (content)=>content ? content.replaceAll($7e886d471b63e7e3$export$c7446825a059cd3, "$1") : content;




(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll(".placeholder-popup")
    ].map((element)=>element).forEach(function(element) {
        const { editableId: editableId, prefixes: prefixes } = JSON.parse(element.dataset.props);
        const form = element.closest("form");
        const clientTypeEditable = form.querySelector('.editable[data-field="clientType"]');
        const clientTypeDropDownList = clientTypeEditable ? (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(clientTypeEditable.id) : undefined;
        const editor = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editableId);
        const target = editor.element.getElementsByClassName("e-content")[0];
        const mention = new (0, $3b677bffd4c0e837$export$e891316fea657d90)({
            dataSource: (0, $7e886d471b63e7e3$export$cd5b765605c743ed)(prefixes),
            fields: {
                text: "name"
            },
            target: target,
            mentionChar: (0, $7e886d471b63e7e3$export$d82b96e89413748e)[0][0],
            suggestionCount: 1000,
            popupWidth: "400px",
            popupHeight: "300px",
            highlight: true,
            noRecordsTemplate: "No matching placeholders",
            displayTemplate: `${(0, $7e886d471b63e7e3$export$d82b96e89413748e)[0]}\${name}${(0, $7e886d471b63e7e3$export$d82b96e89413748e)[1]}`
        });
        const refresh = ()=>{
            const clientType = clientTypeDropDownList?.value ?? undefined;
            mention.dataSource = (0, $7e886d471b63e7e3$export$cd5b765605c743ed)(prefixes, clientType);
        };
        mention.appendTo(element);
        refresh();
        if (clientTypeEditable) {
            const clientTypeDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(clientTypeEditable.id);
            clientTypeDropDownList.addEventListener("change", refresh);
        }
        // Don't add line break when selecting placeholder by pressing enter
        editor.actionBegin = (args)=>{
            if (args.requestType === "EnterAction" && mention.element.classList.contains("e-popup-open")) args.cancel = true;
        };
    });
});



window.addEventListener("resize", (0, $cdd05a6aa3de24f9$exports.debounce)(()=>$1fd94efd914cfa3a$var$resize()));
document.addEventListener("DOMContentLoaded", ()=>$1fd94efd914cfa3a$var$resize());
const $1fd94efd914cfa3a$var$resize = ()=>{
    const navbar = document.getElementById("navbar");
    const subNavbar = document.getElementById("subNavbar");
    if (navbar) document.body.style.paddingTop = `${navbar.clientHeight + (subNavbar?.clientHeight ?? 0)}px`;
    const offcanvasIframe = document.querySelector("#offcanvas iframe");
    if (offcanvasIframe) offcanvasIframe.style.height = `${window.innerHeight}px`;
};





(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="scheduleFrequency"]')
    ].map((editableElement)=>editableElement).forEach((editableElement)=>{
        const form = editableElement.closest("form");
        const dropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editableElement.id);
        const editor = (0, $e68843d575be3a15$export$d193da8733a2af56)(editableElement.id);
        const control = dropDownList ?? editor;
        if (control) {
            const refresh = (scheduleFrequency, options)=>{
                const { isDefault: isDefault, save: save } = options ?? {};
                const selected = control.value === scheduleFrequency || control.value === null && isDefault;
                const dayDiv = form.querySelector(`div[data-schedule-frequency="${scheduleFrequency}"]`);
                dayDiv.classList.toggle("d-none", !selected);
                const dayEditable = dayDiv.querySelector('.editable[data-field="scheduleDay"]');
                if (dayEditable) {
                    const dayEditableProps = (0, $e68843d575be3a15$export$75fe5f91d452f94b)(dayEditable.id);
                    const dayDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(dayEditable.id);
                    const dayEditor = (0, $e68843d575be3a15$export$d193da8733a2af56)(dayEditable.id);
                    const disabled = !selected || !!dayEditableProps?.readOnly;
                    if (dayDropDownList) dayDropDownList.enabled = !disabled;
                    else if (dayEditor) {
                        dayEditor.disabled = disabled;
                        if (selected && save) (0, $e68843d575be3a15$export$18f2ef1f3de9bc1c)(dayEditable.id, null);
                    }
                }
            };
            refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Days, {
                isDefault: true
            });
            refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Weeks);
            refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Months);
            refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Years);
            if (dropDownList) dropDownList.addEventListener("change", ()=>{
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Days, {
                    isDefault: true
                });
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Weeks);
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Months);
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Years);
            });
            else if (editor) editor.addEventListener("actionSuccess", ()=>{
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Days, {
                    save: true,
                    isDefault: true
                });
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Weeks, {
                    save: true
                });
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Months, {
                    save: true
                });
                refresh((0, $fae5a78d0cec85ca$export$1427b738abd061e2).Years, {
                    save: true
                });
            });
        }
    });
});








const $d439f4d132d8675f$var$selectors = (...fields)=>fields.map((field)=>`.editable[data-model="RecurringTask"][data-field="${field}"]`).join(", ");
const $d439f4d132d8675f$var$separator = '<i class="fa-solid fa-arrow-right me-3"></i>';
(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll($d439f4d132d8675f$var$selectors("scheduleInterval", "scheduleFrequency", "scheduleDay", "startFromDate", "continueUntilDate", "startDateOffset_interval", "startDateOffset_type", "startDateOffset_direction", "completionDateOffset_interval", "completionDateOffset_type", "completionDateOffset_direction", "deadlineDateOffset_interval", "deadlineDateOffset_type", "deadlineDateOffset_direction", "smartTaskType"))
    ].map((editableElement)=>editableElement).forEach((editableElement)=>{
        const control = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editableElement.id);
        if (control) {
            const form = editableElement.closest("form");
            control.addEventListener("change", async ()=>{
                await $d439f4d132d8675f$var$preview(form);
            });
        }
    });
    [
        ...document.querySelectorAll($d439f4d132d8675f$var$selectors("scheduleFrequency", "smartTaskType"))
    ].map((editableElement)=>editableElement).forEach((editableElement)=>{
        const form = editableElement.closest("form");
        $d439f4d132d8675f$var$preview(form);
    });
});
const $d439f4d132d8675f$var$preview = async (form)=>{
    const data = (0, $e68843d575be3a15$export$9643fd7297feaaf5)(form);
    if (data.smartTaskType || data.scheduleInterval && data.scheduleFrequency && data.startFromDate) {
        const route = data.smartTaskType ? (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).smartTasks.preview() : (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).recurringTasks.preview();
        const res = await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(route, data);
        if (res.ok) {
            const { dueDate: dueDate, startDate: startDate, completionDate: completionDate, deadlineDate: deadlineDate } = await res.json();
            const dueDatePreviewSpan = form.querySelector('span[data-role="dueDatePreview');
            const startDatePreviewSpan = form.querySelector('span[data-role="startDatePreview');
            const completionDatePreviewSpan = form.querySelector('span[data-role="completionDatePreview');
            const deadlineDatePreviewSpan = form.querySelector('span[data-role="deadlineDatePreview');
            dueDatePreviewSpan.innerHTML = dueDate ? `Example ${data.smartTaskType ? (0, $d47525176c3f6cd7$export$afe72249c42899d9)((0, $19ee14db620c232e$export$565e37f6a005bc8), data.smartTaskType) : "due"} date: ${(0, $d47525176c3f6cd7$export$8d572d60a0595891)(dueDate)}` : "";
            startDatePreviewSpan.innerHTML = startDate ? $d439f4d132d8675f$var$separator + (0, $d47525176c3f6cd7$export$8d572d60a0595891)(startDate) : "";
            completionDatePreviewSpan.innerHTML = completionDate ? $d439f4d132d8675f$var$separator + (0, $d47525176c3f6cd7$export$8d572d60a0595891)(completionDate) : "";
            deadlineDatePreviewSpan.innerHTML = deadlineDate ? $d439f4d132d8675f$var$separator + (0, $d47525176c3f6cd7$export$8d572d60a0595891)(deadlineDate) : "";
        }
    }
};






(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="smartTaskType"]')
    ].map((editable)=>editable).forEach((editable)=>{
        const form = editable.closest("form");
        const smartTaskTypeDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editable.id);
        const refresh = (...smartTaskTypes)=>{
            const selected = smartTaskTypes.includes(smartTaskTypeDropDownList.value);
            [
                ...form.querySelectorAll(`[data-smart-task-types="${smartTaskTypes.join(",")}"]`)
            ].map((childContainer)=>childContainer).forEach((childContainer)=>{
                childContainer.classList.toggle("d-none", !selected);
                const childEditable = childContainer.querySelector(".editable");
                if (childEditable) (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(childEditable.id).enabled = selected;
            });
        };
        if (smartTaskTypeDropDownList) {
            refresh((0, $19ee14db620c232e$export$565e37f6a005bc8).BookkeepingDue);
            refresh((0, $19ee14db620c232e$export$565e37f6a005bc8).PayrollDue);
            smartTaskTypeDropDownList.addEventListener("change", ()=>{
                refresh((0, $19ee14db620c232e$export$565e37f6a005bc8).BookkeepingDue);
                refresh((0, $19ee14db620c232e$export$565e37f6a005bc8).PayrollDue);
            });
        }
    });
});






let $e8973fe165519c9e$var$dragSource;
let $e8973fe165519c9e$var$dragTarget;
let $e8973fe165519c9e$var$dragTimeout;
const $e8973fe165519c9e$var$update = async (table)=>{
    const ajax = table.dataset.ajax === "true";
    const form = table.closest("form");
    if (form) {
        if (ajax) {
            const taskId = table.dataset.taskId;
            const recurring = table.dataset.recurring === "true";
            const url = recurring ? (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).recurringTasks.subTasks({
                id: taskId
            }) : (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).tasks.subTasks({
                id: taskId
            });
            const data = [
                ...table.querySelectorAll("tr.sub-task")
            ].map((tr, order)=>{
                const titleDiv = tr.querySelector('div[data-name="title"]');
                const completedCheckBox = tr.querySelector('input[type="checkbox"]');
                return {
                    task: titleDiv?.dataset.value ?? null,
                    order: order,
                    ...completedCheckBox ? {
                        completed: completedCheckBox.checked,
                        completedDate: completedCheckBox.dataset.completedDate
                    } : {}
                };
            });
            await (0, $0690cfee00fb4cf1$export$484f3009c2ee32ad)(url, data);
        } else form.dataset.dirty = "true";
    }
};
document.addEventListener("DOMContentLoaded", ()=>{
    [
        ...document.querySelectorAll("table.sub-tasks tr")
    ].map((tr)=>tr).forEach((tr)=>{
        if (tr.classList.contains("sub-task")) $e8973fe165519c9e$var$initSubTaskRow(tr);
        else if (tr.classList.contains("sub-task-new")) {
            const table = tr.closest("table");
            const recurring = table.dataset.recurring === "true";
            const ajax = table.dataset.ajax === "true";
            const titleTextBox = tr.querySelector('input[type="text"]');
            const addButton = tr.querySelector("a.add");
            const addSubTask = async ()=>{
                const title = titleTextBox?.value.trim();
                if (title) {
                    titleTextBox.value = "";
                    let newTr = document.createElement("tr");
                    tr.parentNode.insertBefore(newTr, tr);
                    newTr.outerHTML = $e8973fe165519c9e$var$subTaskRowTemplate({
                        title: title,
                        recurring: recurring,
                        ajax: ajax
                    });
                    newTr = tr.previousElementSibling;
                    $e8973fe165519c9e$var$initSubTaskRow(newTr);
                    await $e8973fe165519c9e$var$update(table);
                }
            };
            titleTextBox.addEventListener("keyup", async (e)=>{
                addButton.classList.toggle("active", !!titleTextBox.value.trim());
                if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();
                    await addSubTask();
                }
            });
            addButton.addEventListener("click", async (e)=>{
                e.preventDefault();
                e.stopPropagation();
                await addSubTask();
            });
        }
    });
});
const $e8973fe165519c9e$var$initSubTaskRow = (tr)=>{
    const table = tr.closest("table");
    const titleInput = tr.querySelector('input[name="subTaskTitles[]"');
    const titleDiv = tr.querySelector('div[data-name="title"]');
    const completedCheckBox = tr.querySelector('input[type="checkbox"]');
    const completedDateTd = tr.querySelector("td.completed-date");
    const deleteButton = tr.querySelector("a.delete");
    if (titleInput) titleInput.addEventListener("keyup", async ()=>{
        await $e8973fe165519c9e$var$update(table);
    });
    else if (titleDiv) {
        titleDiv.setAttribute("data-underline", "false");
        const titleEditor = new (0, $6c3b84be4fdf3a18$export$9c6622dfc8cb539f)({
            mode: "Inline",
            name: titleDiv.dataset.name,
            value: titleDiv.dataset.value,
            actionOnBlur: "Cancel",
            model: {
                autocomplete: "off",
                showClearButton: false
            },
            validationRules: {
                title: {
                    required: true
                }
            },
            submitClick: async ()=>{
                titleDiv.dataset.value = titleEditor.value.toString();
                await $e8973fe165519c9e$var$update(table);
            }
        });
        titleEditor.appendTo(titleDiv);
    }
    if (completedCheckBox) completedCheckBox.addEventListener("change", async ()=>{
        const completed = completedCheckBox.checked;
        if (completed) {
            if (completedDateTd) completedDateTd.innerHTML = (0, $d47525176c3f6cd7$export$3ae94a2503e890a1)(new Date());
        } else {
            delete completedCheckBox.dataset.completedDate;
            if (completedDateTd) completedDateTd.innerHTML = "";
        }
        tr.classList.toggle("completed", completed);
        await $e8973fe165519c9e$var$update(table);
    });
    if (deleteButton) deleteButton.addEventListener("click", async (e)=>{
        e.preventDefault();
        tr.remove();
        await $e8973fe165519c9e$var$update(table);
    });
    tr.addEventListener("dragstart", async (e)=>{
        if (e.dataTransfer) {
            e.dataTransfer.dropEffect = "move";
            e.dataTransfer.effectAllowed = "move";
        }
        $e8973fe165519c9e$var$dragSource = e.currentTarget;
    });
    tr.addEventListener("dragover", async (e)=>{
        e.preventDefault();
        if ($e8973fe165519c9e$var$dragSource && !$e8973fe165519c9e$var$dragTimeout) {
            const target = e.currentTarget;
            if (target !== $e8973fe165519c9e$var$dragSource) {
                $e8973fe165519c9e$var$dragTarget = target;
                $e8973fe165519c9e$var$dragSource.style.opacity = "0";
                $e8973fe165519c9e$var$dragTimeout = setTimeout(()=>{
                    if ($e8973fe165519c9e$var$dragSource && $e8973fe165519c9e$var$dragTarget) {
                        const rows = [
                            ...$e8973fe165519c9e$var$dragTarget.parentElement.children
                        ];
                        if (rows.indexOf($e8973fe165519c9e$var$dragTarget) > rows.indexOf($e8973fe165519c9e$var$dragSource)) $e8973fe165519c9e$var$dragTarget.after($e8973fe165519c9e$var$dragSource);
                        else $e8973fe165519c9e$var$dragTarget.before($e8973fe165519c9e$var$dragSource);
                    }
                    $e8973fe165519c9e$var$dragTimeout = undefined;
                }, 100);
            }
        }
    });
    tr.addEventListener("drop", async (e)=>{
        e.preventDefault();
        if ($e8973fe165519c9e$var$dragSource && $e8973fe165519c9e$var$dragTarget) {
            $e8973fe165519c9e$var$dragSource.style.opacity = "1";
            await $e8973fe165519c9e$var$update(table);
        }
    });
};
const $e8973fe165519c9e$var$subTaskRowTemplate = (params)=>{
    const { title: title, recurring: recurring, ajax: ajax } = params;
    return ajax ? `
      <tr class="sub-task" draggable="true">
        <td>
          <span class="reorder">
            <i class="fa-solid fa-grip-dots-vertical"></i>
          </span>
        </td>
        ${!recurring ? `
        <th>
          <input type="checkbox" class="form-check-input" />
        </th>` : ""}
        <td class="w-100">
          <div data-name="title" data-value="${title.replaceAll('"', "&quot;")}" data-fullwidth="true"></div>
        </td>
        ${!recurring ? `
        <td class="completed-date"></td>` : ""}
        <td>
          <a href="#" class="delete">
            <i class="fa-solid fa-fa-trash"></i>
          </a>
        </td>
      </tr>` : `
      <tr class="sub-task" draggable="true">
        <td>
          <span class="reorder">
            <i class="fa-solid fa-grip-dots-vertical"></i>
          </span>
        </td>
        ${!recurring ? `
        <th>
          <input name="subTaskCompleteds[]" type="checkbox" class="form-check-input" />
        </th>` : ""}
        <td class="w-100">
          <input name="subTaskTitles[]" type="text" value="${title.replaceAll('"', "&quot;")}"></div>
        </td>
        ${!recurring ? `
        <td class="completed-date"></td>` : ""}
        <td>
          <a href="#" class="delete">
            <i class="fa-solid fa-fa-trash"></i>
          </a>
        </td>
      </tr>`;
};







(0, $e625b333c39c8463$export$63174c828edd6ff8)("editablesReady", ()=>{
    [
        ...document.querySelectorAll('.editable[data-field="clientType"]')
    ].map((editable)=>editable).forEach((editable)=>{
        const form = editable.closest("form");
        const modelName = form.modelName.value;
        if (modelName === "Task" || modelName === "RecurringTask") {
            const clientTypeDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(editable.id);
            const refresh = (clientType)=>{
                const selected = clientTypeDropDownList.value === clientType;
                // Task / Recurring Task
                [
                    ...form.querySelectorAll(`[data-client-type="${clientType}"]`)
                ].map((childContainer)=>childContainer).forEach((childContainer)=>{
                    childContainer.classList.toggle("d-none", !selected);
                    const childEditable = childContainer.querySelector(".editable");
                    if (childEditable) {
                        const childDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(childEditable.id);
                        childDropDownList.enabled = selected;
                    }
                });
                // Smart Task
                const smartTaskTypeInput = form.querySelector(`[name="smartTaskType"]`);
                if (smartTaskTypeInput) {
                    const smartTaskTypeEditable = smartTaskTypeInput.closest(".editable");
                    const smartTaskTypeDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(smartTaskTypeEditable.id);
                    if (selected) smartTaskTypeDropDownList.dataSource = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                        url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).smartTasks.options.types({
                            clientType: clientType
                        }),
                        adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
                    });
                }
                const updateOnCompletionInput = form.querySelector(`[name="updateOnCompletion"]`);
                if (updateOnCompletionInput) {
                    const updateOnCompletionEditable = updateOnCompletionInput.closest(".editable");
                    const updateOnCompletionDropDownList = (0, $e68843d575be3a15$export$caf8f8b20e380f6e)(updateOnCompletionEditable.id);
                    if (selected) updateOnCompletionDropDownList.dataSource = new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                        url: (0, $bc9d09886380ca07$export$66b32f6f30eb4b4).smartTasks.options.updateFields({
                            clientType: clientType
                        }),
                        adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
                    });
                }
            };
            if (clientTypeDropDownList) {
                refresh((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Company);
                refresh((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Individual);
                clientTypeDropDownList.addEventListener("change", ()=>{
                    refresh((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Company);
                    refresh((0, $19ee14db620c232e$export$4cd8cc03ec8c034a).Individual);
                });
            }
        }
    });
});






document.addEventListener("DOMContentLoaded", ()=>{
    [
        ...document.querySelectorAll(".template-picker")
    ].map((element)=>element).forEach((element)=>{
        const { templateId: templateId, taskId: taskId } = element.dataset;
        const input = element.querySelector("input");
        const form = input?.form;
        if (input && form) {
            const templatePicker = new (0, $7ca2c62dd20a2561$export$72b9695b8216309a)({
                dataSource: new (0, $a4fc1b4c34afe464$export$fedddcd2788076dd)({
                    url: (0, $55576f0fdfdeec43$export$8fa1eaeb4700701e)((0, $bc9d09886380ca07$export$66b32f6f30eb4b4).templates.search(), {
                        taskId: taskId
                    }),
                    adaptor: new (0, $e1170102ff02b3b7$export$b011aea473980a2d)()
                }),
                fields: {
                    value: "id",
                    text: "name",
                    groupBy: "serviceName"
                },
                placeholder: "Search templates",
                groupTemplate: "${if(serviceName)}${serviceName}${else}Other${/if}",
                value: templateId,
                allowCustom: false,
                allowFiltering: true,
                change: ()=>form.submit()
            });
            templatePicker.appendTo(input);
        }
    });
});



document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(element) {
        new (0, $91ca15859685b28b$export$28c660c63b792dea)(element);
    });
});


const $ed9535366a273cc1$var$STORAGE_KEY = "containerWiderView";
const $ed9535366a273cc1$var$LABEL_WIDE = "Wide";
const $ed9535366a273cc1$var$LABEL_NARROW = "Compact";
const $ed9535366a273cc1$var$ICON_CLASSES = {
    on: "fa-toggle-on",
    off: "fa-toggle-off"
};
document.addEventListener("DOMContentLoaded", function() {
    const btn = document.getElementById("toggle-width-btn");
    if (!btn) return;
    const containers = document.querySelectorAll("#content");
    containers.forEach((container)=>container.classList.add("no-transition"));
    const container = btn.closest(".width-switch-container");
    const label = container ? container.querySelector(".label") : undefined;
    const icon = btn.querySelector("i");
    const saved = localStorage.getItem($ed9535366a273cc1$var$STORAGE_KEY);
    const isWiderView = saved !== "false";
    btn.setAttribute("data-toggled", isWiderView.toString());
    containers.forEach((container)=>{
        container.classList.toggle("wider-view", isWiderView);
    });
    if (icon) {
        icon.classList.remove(isWiderView ? $ed9535366a273cc1$var$ICON_CLASSES.off : $ed9535366a273cc1$var$ICON_CLASSES.on);
        icon.classList.add(isWiderView ? $ed9535366a273cc1$var$ICON_CLASSES.on : $ed9535366a273cc1$var$ICON_CLASSES.off);
    }
    if (label) label.textContent = isWiderView ? $ed9535366a273cc1$var$LABEL_WIDE : $ed9535366a273cc1$var$LABEL_NARROW;
    btn.addEventListener("click", function() {
        const current = btn.getAttribute("data-toggled") === "true";
        const newState = !current;
        btn.setAttribute("data-toggled", newState.toString());
        containers.forEach((container)=>container.classList.remove("no-transition"));
        containers.forEach((container)=>{
            container.classList.toggle("wider-view", newState);
        });
        if (icon) {
            icon.classList.remove(newState ? $ed9535366a273cc1$var$ICON_CLASSES.off : $ed9535366a273cc1$var$ICON_CLASSES.on);
            icon.classList.add(newState ? $ed9535366a273cc1$var$ICON_CLASSES.on : $ed9535366a273cc1$var$ICON_CLASSES.off);
        }
        if (label) label.textContent = newState ? $ed9535366a273cc1$var$LABEL_WIDE : $ed9535366a273cc1$var$LABEL_NARROW;
        localStorage.setItem($ed9535366a273cc1$var$STORAGE_KEY, newState ? "true" : "false");
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $054ea8408f8aeb09$export$674c05fa57e365a9)();
    const { hash: hash } = window.location;
    if (hash) {
        const link = document.getElementById(hash.substring(1));
        if (link?.href) link.click();
    }
});
const $3c45b2e6954fa354$var$w = window;
$3c45b2e6954fa354$var$w.prefillBeacon = (data)=>{
    $3c45b2e6954fa354$var$w.Beacon("prefill", data);
    $3c45b2e6954fa354$var$w.Beacon("open");
    $3c45b2e6954fa354$var$w.Beacon("navigate", "/ask/message/");
};

})();
//# sourceMappingURL=app.js.map
